var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value2) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value2 }) : obj[key] = value2;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp(a2, prop, b2[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b2) => __defProps(a2, __getOwnPropDescs(b2));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { openBlock, createElementBlock, createElementVNode, createTextVNode, Fragment, Comment as Comment$2, isVNode, defineComponent, inject, getCurrentInstance, watch, onBeforeUnmount, ref, readonly, computed, onMounted, onBeforeMount, reactive, provide, withDirectives, toRef, h as h$1, Teleport, nextTick, renderSlot, onActivated, onDeactivated, mergeProps, watchEffect, Transition, TransitionGroup, vShow, cloneVNode, Text as Text$1, onUnmounted, onBeforeUpdate, onUpdated, normalizeStyle, markRaw, useSlots, createBlock, unref, withCtx, createCommentVNode, normalizeProps, guardReactiveProps, createVNode, toDisplayString, renderList, normalizeClass, resolveDynamicComponent, createSlots, vModelText, pushScopeId, popScopeId } from "vue";
function render$46(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v4m0 4h.01M10.615 3.892L2.39 18.098c-.456.788-.684 1.182-.65 1.506a1 1 0 00.406.705c.263.191.718.191 1.629.191h16.45c.91 0 1.365 0 1.628-.191a1 1 0 00.407-.705c.034-.324-.195-.718-.65-1.506L13.383 3.892c-.454-.785-.681-1.178-.978-1.31a1 1 0 00-.813 0c-.296.132-.523.525-.978 1.31z"
    })
  ]);
}
function render$45(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19 12H5m0 0l7 7m-7-7l7-7"
    })
  ]);
}
function render$44(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 12l3 3 6-6m5.5 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    })
  ]);
}
function render$43(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M20 6L9 17l-5-5"
    })
  ]);
}
function render$42(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 9l6 6 6-6"
    })
  ]);
}
function render$41(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 18l6-6-6-6"
    })
  ]);
}
function render$40(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 13a1 1 0 100-2 1 1 0 000 2zM12 6a1 1 0 100-2 1 1 0 000 2zM12 20a1 1 0 100-2 1 1 0 000 2z"
    })
  ]);
}
function render$3$(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 12h12M3 6h18M9 18h6"
    })
  ]);
}
function render$3_(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 16v-4m0-4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    })
  ]);
}
function render$3Z(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 5v14m-7-7h14"
    })
  ]);
}
function render$3Y(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 21l-3.5-3.5m2.5-6a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0z"
    })
  ]);
}
function render$3X(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21 21l-4.35-4.35M19 11a8 8 0 11-16 0 8 8 0 0116 0z"
    })
  ]);
}
function render$3W(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8 16l4-4m0 0l4 4m-4-4v9m8-4.257A5.5 5.5 0 0016.5 7a.62.62 0 01-.534-.302 7.5 7.5 0 10-11.78 9.096"
    })
  ]);
}
function render$3V(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17 7L7 17M7 7l10 10"
    })
  ]);
}
let onceCbs = [];
const paramsMap = new WeakMap();
function flushOnceCallbacks() {
  onceCbs.forEach((cb2) => cb2(...paramsMap.get(cb2)));
  onceCbs = [];
}
function beforeNextFrameOnce(cb2, ...params) {
  paramsMap.set(cb2, params);
  if (onceCbs.includes(cb2))
    return;
  onceCbs.push(cb2) === 1 && requestAnimationFrame(flushOnceCallbacks);
}
function happensIn(e25, dataSetPropName) {
  let { target } = e25;
  while (target) {
    if (target.dataset) {
      if (target.dataset[dataSetPropName] !== void 0)
        return true;
    }
    target = target.parentElement;
  }
  return false;
}
function getPreciseEventTarget(event) {
  return event.composedPath()[0] || null;
}
function depx(value2) {
  if (typeof value2 === "string") {
    if (value2.endsWith("px")) {
      return Number(value2.slice(0, value2.length - 2));
    }
    return Number(value2);
  }
  return value2;
}
function pxfy(value2) {
  if (value2 === void 0 || value2 === null)
    return void 0;
  if (typeof value2 === "number")
    return `${value2}px`;
  if (value2.endsWith("px"))
    return value2;
  return `${value2}px`;
}
function getMargin(value2, position) {
  const parts = value2.trim().split(/\s+/g);
  const margin = {
    top: parts[0]
  };
  switch (parts.length) {
    case 1:
      margin.right = parts[0];
      margin.bottom = parts[0];
      margin.left = parts[0];
      break;
    case 2:
      margin.right = parts[1];
      margin.left = parts[1];
      margin.bottom = parts[0];
      break;
    case 3:
      margin.right = parts[1];
      margin.bottom = parts[2];
      margin.left = parts[1];
      break;
    case 4:
      margin.right = parts[1];
      margin.bottom = parts[2];
      margin.left = parts[3];
      break;
    default:
      throw new Error("[seemly/getMargin]:" + value2 + " is not a valid value.");
  }
  if (position === void 0)
    return margin;
  return margin[position];
}
function getGap(value2, orient) {
  const [rowGap, colGap] = value2.split(" ");
  if (!orient)
    return {
      row: rowGap,
      col: colGap || rowGap
    };
  return orient === "row" ? rowGap : colGap;
}
var colors = {
  black: "#000",
  silver: "#C0C0C0",
  gray: "#808080",
  white: "#FFF",
  maroon: "#800000",
  red: "#F00",
  purple: "#800080",
  fuchsia: "#F0F",
  green: "#008000",
  lime: "#0F0",
  olive: "#808000",
  yellow: "#FF0",
  navy: "#000080",
  blue: "#00F",
  teal: "#008080",
  aqua: "#0FF",
  transparent: "#0000"
};
function hsl2hsv(h2, s2, l2) {
  s2 /= 100;
  l2 /= 100;
  const v2 = s2 * Math.min(l2, 1 - l2) + l2;
  return [h2, v2 ? (2 - 2 * l2 / v2) * 100 : 0, v2 * 100];
}
function hsv2hsl(h2, s2, v2) {
  s2 /= 100;
  v2 /= 100;
  const l2 = v2 - v2 * s2 / 2;
  const m2 = Math.min(l2, 1 - l2);
  return [h2, m2 ? (v2 - l2) / m2 * 100 : 0, l2 * 100];
}
function hsv2rgb(h2, s2, v2) {
  s2 /= 100;
  v2 /= 100;
  let f2 = (n2, k2 = (n2 + h2 / 60) % 6) => v2 - v2 * s2 * Math.max(Math.min(k2, 4 - k2, 1), 0);
  return [f2(5) * 255, f2(3) * 255, f2(1) * 255];
}
function rgb2hsv(r2, g2, b2) {
  r2 /= 255;
  g2 /= 255;
  b2 /= 255;
  let v2 = Math.max(r2, g2, b2), c2 = v2 - Math.min(r2, g2, b2);
  let h2 = c2 && (v2 == r2 ? (g2 - b2) / c2 : v2 == g2 ? 2 + (b2 - r2) / c2 : 4 + (r2 - g2) / c2);
  return [60 * (h2 < 0 ? h2 + 6 : h2), v2 && c2 / v2 * 100, v2 * 100];
}
function rgb2hsl(r2, g2, b2) {
  r2 /= 255;
  g2 /= 255;
  b2 /= 255;
  let v2 = Math.max(r2, g2, b2), c2 = v2 - Math.min(r2, g2, b2), f2 = 1 - Math.abs(v2 + v2 - c2 - 1);
  let h2 = c2 && (v2 == r2 ? (g2 - b2) / c2 : v2 == g2 ? 2 + (b2 - r2) / c2 : 4 + (r2 - g2) / c2);
  return [60 * (h2 < 0 ? h2 + 6 : h2), f2 ? c2 / f2 * 100 : 0, (v2 + v2 - c2) * 50];
}
function hsl2rgb(h2, s2, l2) {
  s2 /= 100;
  l2 /= 100;
  let a2 = s2 * Math.min(l2, 1 - l2);
  let f2 = (n2, k2 = (n2 + h2 / 30) % 12) => l2 - a2 * Math.max(Math.min(k2 - 3, 9 - k2, 1), -1);
  return [f2(0) * 255, f2(8) * 255, f2(4) * 255];
}
const prefix$1 = "^\\s*";
const suffix = "\\s*$";
const percent$1 = "\\s*((\\.\\d+)|(\\d+(\\.\\d*)?))%\\s*";
const float = "\\s*((\\.\\d+)|(\\d+(\\.\\d*)?))\\s*";
const hex = "([0-9A-Fa-f])";
const dhex = "([0-9A-Fa-f]{2})";
const hslRegex = new RegExp(`${prefix$1}hsl\\s*\\(${float},${percent$1},${percent$1}\\)${suffix}`);
const hsvRegex = new RegExp(`${prefix$1}hsv\\s*\\(${float},${percent$1},${percent$1}\\)${suffix}`);
const hslaRegex = new RegExp(`${prefix$1}hsla\\s*\\(${float},${percent$1},${percent$1},${float}\\)${suffix}`);
const hsvaRegex = new RegExp(`${prefix$1}hsva\\s*\\(${float},${percent$1},${percent$1},${float}\\)${suffix}`);
const rgbRegex = new RegExp(`${prefix$1}rgb\\s*\\(${float},${float},${float}\\)${suffix}`);
const rgbaRegex = new RegExp(`${prefix$1}rgba\\s*\\(${float},${float},${float},${float}\\)${suffix}`);
const sHexRegex = new RegExp(`${prefix$1}#${hex}${hex}${hex}${suffix}`);
const hexRegex = new RegExp(`${prefix$1}#${dhex}${dhex}${dhex}${suffix}`);
const sHexaRegex = new RegExp(`${prefix$1}#${hex}${hex}${hex}${hex}${suffix}`);
const hexaRegex = new RegExp(`${prefix$1}#${dhex}${dhex}${dhex}${dhex}${suffix}`);
function parseHex(value2) {
  return parseInt(value2, 16);
}
function hsla(color) {
  try {
    let i2;
    if (i2 = hslaRegex.exec(color)) {
      return [
        roundDeg(i2[1]),
        roundPercent(i2[5]),
        roundPercent(i2[9]),
        roundAlpha(i2[13])
      ];
    } else if (i2 = hslRegex.exec(color)) {
      return [roundDeg(i2[1]), roundPercent(i2[5]), roundPercent(i2[9]), 1];
    }
    throw new Error(`[seemly/hsla]: Invalid color value ${color}.`);
  } catch (e25) {
    throw e25;
  }
}
function hsva(color) {
  try {
    let i2;
    if (i2 = hsvaRegex.exec(color)) {
      return [
        roundDeg(i2[1]),
        roundPercent(i2[5]),
        roundPercent(i2[9]),
        roundAlpha(i2[13])
      ];
    } else if (i2 = hsvRegex.exec(color)) {
      return [roundDeg(i2[1]), roundPercent(i2[5]), roundPercent(i2[9]), 1];
    }
    throw new Error(`[seemly/hsva]: Invalid color value ${color}.`);
  } catch (e25) {
    throw e25;
  }
}
function rgba(color) {
  try {
    let i2;
    if (i2 = hexRegex.exec(color)) {
      return [parseHex(i2[1]), parseHex(i2[2]), parseHex(i2[3]), 1];
    } else if (i2 = rgbRegex.exec(color)) {
      return [roundChannel(i2[1]), roundChannel(i2[5]), roundChannel(i2[9]), 1];
    } else if (i2 = rgbaRegex.exec(color)) {
      return [
        roundChannel(i2[1]),
        roundChannel(i2[5]),
        roundChannel(i2[9]),
        roundAlpha(i2[13])
      ];
    } else if (i2 = sHexRegex.exec(color)) {
      return [
        parseHex(i2[1] + i2[1]),
        parseHex(i2[2] + i2[2]),
        parseHex(i2[3] + i2[3]),
        1
      ];
    } else if (i2 = hexaRegex.exec(color)) {
      return [
        parseHex(i2[1]),
        parseHex(i2[2]),
        parseHex(i2[3]),
        roundAlpha(parseHex(i2[4]) / 255)
      ];
    } else if (i2 = sHexaRegex.exec(color)) {
      return [
        parseHex(i2[1] + i2[1]),
        parseHex(i2[2] + i2[2]),
        parseHex(i2[3] + i2[3]),
        roundAlpha(parseHex(i2[4] + i2[4]) / 255)
      ];
    } else if (color in colors) {
      return rgba(colors[color]);
    }
    throw new Error(`[seemly/rgba]: Invalid color value ${color}.`);
  } catch (e25) {
    throw e25;
  }
}
function normalizeAlpha$1(alphaValue) {
  return alphaValue > 1 ? 1 : alphaValue < 0 ? 0 : alphaValue;
}
function stringifyRgb(r2, g2, b2) {
  return `rgb(${roundChannel(r2)}, ${roundChannel(g2)}, ${roundChannel(b2)})`;
}
function stringifyRgba(r2, g2, b2, a2) {
  return `rgba(${roundChannel(r2)}, ${roundChannel(g2)}, ${roundChannel(b2)}, ${normalizeAlpha$1(a2)})`;
}
function compositeChannel(v1, a1, v2, a2, a3) {
  return roundChannel((v1 * a1 * (1 - a2) + v2 * a2) / a3);
}
function composite(background, overlay2) {
  if (!Array.isArray(background))
    background = rgba(background);
  if (!Array.isArray(overlay2))
    overlay2 = rgba(overlay2);
  const a1 = background[3];
  const a2 = overlay2[3];
  const alpha = roundAlpha(a1 + a2 - a1 * a2);
  return stringifyRgba(compositeChannel(background[0], a1, overlay2[0], a2, alpha), compositeChannel(background[1], a1, overlay2[1], a2, alpha), compositeChannel(background[2], a1, overlay2[2], a2, alpha), alpha);
}
function changeColor(base2, options) {
  const [r2, g2, b2, a2 = 1] = Array.isArray(base2) ? base2 : rgba(base2);
  if (options.alpha) {
    return stringifyRgba(r2, g2, b2, options.alpha);
  }
  return stringifyRgba(r2, g2, b2, a2);
}
function scaleColor(base2, options) {
  const [r2, g2, b2, a2 = 1] = Array.isArray(base2) ? base2 : rgba(base2);
  const { lightness = 1, alpha = 1 } = options;
  return toRgbaString([r2 * lightness, g2 * lightness, b2 * lightness, a2 * alpha]);
}
function roundAlpha(value2) {
  const v2 = Math.round(Number(value2) * 100) / 100;
  if (v2 > 1)
    return 1;
  if (v2 < 0)
    return 0;
  return v2;
}
function roundDeg(value2) {
  const v2 = Math.round(Number(value2));
  if (v2 >= 360)
    return 0;
  if (v2 < 0)
    return 0;
  return v2;
}
function roundChannel(value2) {
  const v2 = Math.round(Number(value2));
  if (v2 > 255)
    return 255;
  if (v2 < 0)
    return 0;
  return v2;
}
function roundPercent(value2) {
  const v2 = Math.round(Number(value2));
  if (v2 > 100)
    return 100;
  if (v2 < 0)
    return 0;
  return v2;
}
function toRgbString(base2) {
  const [r2, g2, b2] = Array.isArray(base2) ? base2 : rgba(base2);
  return stringifyRgb(r2, g2, b2);
}
function toRgbaString(base2) {
  const [r2, g2, b2] = base2;
  if (3 in base2) {
    return `rgba(${roundChannel(r2)}, ${roundChannel(g2)}, ${roundChannel(b2)}, ${roundAlpha(base2[3])})`;
  }
  return `rgba(${roundChannel(r2)}, ${roundChannel(g2)}, ${roundChannel(b2)}, 1)`;
}
function toHsvString(base2) {
  return `hsv(${roundDeg(base2[0])}, ${roundPercent(base2[1])}%, ${roundPercent(base2[2])}%)`;
}
function toHsvaString(base2) {
  const [h2, s2, v2] = base2;
  if (3 in base2) {
    return `hsva(${roundDeg(h2)}, ${roundPercent(s2)}%, ${roundPercent(v2)}%, ${roundAlpha(base2[3])})`;
  }
  return `hsva(${roundDeg(h2)}, ${roundPercent(s2)}%, ${roundPercent(v2)}%, 1)`;
}
function toHslString(base2) {
  return `hsl(${roundDeg(base2[0])}, ${roundPercent(base2[1])}%, ${roundPercent(base2[2])}%)`;
}
function toHslaString(base2) {
  const [h2, s2, l2] = base2;
  if (3 in base2) {
    return `hsla(${roundDeg(h2)}, ${roundPercent(s2)}%, ${roundPercent(l2)}%, ${roundAlpha(base2[3])})`;
  }
  return `hsla(${roundDeg(h2)}, ${roundPercent(s2)}%, ${roundPercent(l2)}%, 1)`;
}
function toHexaString(base2) {
  if (typeof base2 === "string") {
    let i2;
    if (i2 = hexRegex.exec(base2)) {
      return `${i2[0]}FF`;
    } else if (i2 = hexaRegex.exec(base2)) {
      return i2[0];
    } else if (i2 = sHexRegex.exec(base2)) {
      return `#${i2[1]}${i2[1]}${i2[2]}${i2[2]}${i2[3]}${i2[3]}FF`;
    } else if (i2 = sHexaRegex.exec(base2)) {
      return `#${i2[1]}${i2[1]}${i2[2]}${i2[2]}${i2[3]}${i2[3]}${i2[4]}${i2[4]}`;
    }
    throw new Error(`[seemly/toHexString]: Invalid hex value ${base2}.`);
  }
  const hex3 = `#${base2.slice(0, 3).map((unit) => roundChannel(unit).toString(16).toUpperCase().padStart(2, "0")).join("")}`;
  const a2 = base2.length === 3 ? "FF" : roundChannel(base2[3] * 255).toString(16).padStart(2, "0").toUpperCase();
  return hex3 + a2;
}
function toHexString(base2) {
  if (typeof base2 === "string") {
    let i2;
    if (i2 = hexRegex.exec(base2)) {
      return i2[0];
    } else if (i2 = hexaRegex.exec(base2)) {
      return i2[0].slice(0, 7);
    } else if (i2 = sHexRegex.exec(base2) || sHexaRegex.exec(base2)) {
      return `#${i2[1]}${i2[1]}${i2[2]}${i2[2]}${i2[3]}${i2[3]}`;
    }
    throw new Error(`[seemly/toHexString]: Invalid hex value ${base2}.`);
  }
  return `#${base2.slice(0, 3).map((unit) => roundChannel(unit).toString(16).toUpperCase().padStart(2, "0")).join("")}`;
}
function createId(length2 = 8) {
  return Math.random().toString(16).slice(2, 2 + length2);
}
function repeat(count, v2) {
  const ret = [];
  for (let i2 = 0; i2 < count; ++i2) {
    ret.push(v2);
  }
  return ret;
}
function indexMap(count, createValue) {
  const ret = [];
  if (!createValue) {
    for (let i2 = 0; i2 < count; ++i2) {
      ret.push(i2);
    }
    return ret;
  }
  for (let i2 = 0; i2 < count; ++i2) {
    ret.push(createValue(i2));
  }
  return ret;
}
function getSlot$1(instance, slotName = "default", fallback = []) {
  const slots = instance.$slots;
  const slot = slots[slotName];
  if (slot === void 0)
    return fallback;
  return slot();
}
function keep(object4, keys2 = [], rest) {
  const keepedObject = {};
  keys2.forEach((key) => {
    keepedObject[key] = object4[key];
  });
  return Object.assign(keepedObject, rest);
}
function omit(object4, keys2 = [], rest) {
  const omitedObject = {};
  const originalKeys = Object.getOwnPropertyNames(object4);
  originalKeys.forEach((originalKey) => {
    if (!keys2.includes(originalKey)) {
      omitedObject[originalKey] = object4[originalKey];
    }
  });
  return Object.assign(omitedObject, rest);
}
function flatten$4(vNodes, filterCommentNode = true, result2 = []) {
  vNodes.forEach((vNode) => {
    if (vNode === null)
      return;
    if (typeof vNode !== "object") {
      if (typeof vNode === "string" || typeof vNode === "number") {
        result2.push(createTextVNode(String(vNode)));
      }
      return;
    }
    if (Array.isArray(vNode)) {
      flatten$4(vNode, filterCommentNode, result2);
      return;
    }
    if (vNode.type === Fragment) {
      if (vNode.children === null)
        return;
      if (Array.isArray(vNode.children)) {
        flatten$4(vNode.children, filterCommentNode, result2);
      }
    } else if (vNode.type !== Comment$2) {
      result2.push(vNode);
    }
  });
  return result2;
}
function call(funcs, ...args) {
  if (Array.isArray(funcs)) {
    funcs.forEach((func) => call(func, ...args));
  } else
    return funcs(...args);
}
function keysOf(obj) {
  return Object.keys(obj);
}
const render$3U = (r2, ...args) => {
  if (typeof r2 === "function") {
    return r2(...args);
  } else if (typeof r2 === "string") {
    return createTextVNode(r2);
  } else if (typeof r2 === "number") {
    return createTextVNode(String(r2));
  } else {
    return null;
  }
};
function warn$2(location, message) {
  console.error(`[naive/${location}]: ${message}`);
}
function throwError(location, message) {
  throw new Error(`[naive/${location}]: ${message}`);
}
function smallerSize(size2) {
  switch (size2) {
    case "tiny":
      return "mini";
    case "small":
      return "tiny";
    case "medium":
      return "small";
    case "large":
      return "medium";
    case "huge":
      return "large";
  }
  throw Error(`${size2} has no smaller size.`);
}
function getTitleAttribute(value2) {
  switch (typeof value2) {
    case "string":
      return value2 || void 0;
    case "number":
      return String(value2);
    default:
      return void 0;
  }
}
function getFirstSlotVNode(slots, slotName = "default", props = void 0) {
  const slot = slots[slotName];
  if (!slot) {
    warn$2("getFirstSlotVNode", `slot[${slotName}] is empty`);
    return null;
  }
  const slotContent = flatten$4(slot(props));
  if (slotContent.length === 1) {
    return slotContent[0];
  } else {
    warn$2("getFirstSlotVNode", `slot[${slotName}] should have exactly one child`);
    return null;
  }
}
function createRefSetter(ref2) {
  return (inst) => {
    if (inst) {
      ref2.value = inst.$el;
    } else {
      ref2.value = null;
    }
  };
}
function createInjectionKey(key) {
  return key;
}
function ensureValidVNode(vnodes) {
  return vnodes.some((child) => {
    if (!isVNode(child)) {
      return true;
    }
    if (child.type === Comment$2) {
      return false;
    }
    if (child.type === Fragment && !ensureValidVNode(child.children)) {
      return false;
    }
    return true;
  }) ? vnodes : null;
}
function resolveSlot(slot, fallback) {
  return slot && ensureValidVNode(slot()) || fallback();
}
function resolveSlotWithProps(slot, props, fallback) {
  return slot && ensureValidVNode(slot(props)) || fallback(props);
}
function resolveWrappedSlot(slot, wrapper) {
  const children = slot && ensureValidVNode(slot());
  return wrapper(children || null);
}
function resolveWrappedSlotWithProps(slot, props, wrapper) {
  const children = slot && ensureValidVNode(slot(props));
  return wrapper(children || null);
}
function isSlotEmpty(slot) {
  return !(slot && ensureValidVNode(slot()));
}
function mergeEventHandlers(handlers2) {
  const filteredHandlers = handlers2.filter((handler) => handler !== void 0);
  if (filteredHandlers.length === 0)
    return void 0;
  if (filteredHandlers.length === 1)
    return filteredHandlers[0];
  return (e25) => {
    handlers2.forEach((handler) => {
      if (handler) {
        handler(e25);
      }
    });
  };
}
const Wrapper = defineComponent({
  render() {
    var _a2, _b2;
    return (_b2 = (_a2 = this.$slots).default) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
  }
});
const pureNumberRegex = /^(\d|\.)+$/;
const numberRegex = /(\d|\.)+/;
function formatLength(length2, { c: c2 = 1, offset = 0, attachPx = true } = {}) {
  if (typeof length2 === "number") {
    const result2 = (length2 + offset) * c2;
    if (result2 === 0)
      return "0";
    return `${result2}px`;
  } else if (typeof length2 === "string") {
    if (pureNumberRegex.test(length2)) {
      const result2 = (Number(length2) + offset) * c2;
      if (attachPx) {
        if (result2 === 0)
          return "0";
        return `${result2}px`;
      } else {
        return `${result2}`;
      }
    } else {
      const result2 = numberRegex.exec(length2);
      if (!result2)
        return length2;
      return length2.replace(numberRegex, String((Number(result2[0]) + offset) * c2));
    }
  }
  return length2;
}
function color2Class(color) {
  return color.replace(/#|\(|\)|,|\s/g, "_");
}
function ampCount(selector2) {
  let cnt = 0;
  for (let i2 = 0; i2 < selector2.length; ++i2) {
    if (selector2[i2] === "&")
      ++cnt;
  }
  return cnt;
}
const separatorRegex = /\s*,(?![^(]*\))\s*/g;
const extraSpaceRegex = /\s+/g;
function resolveSelectorWithAmp(amp, selector2) {
  const nextAmp = [];
  selector2.split(separatorRegex).forEach((partialSelector) => {
    let round = ampCount(partialSelector);
    if (!round) {
      amp.forEach((partialAmp) => {
        nextAmp.push((partialAmp && partialAmp + " ") + partialSelector);
      });
      return;
    } else if (round === 1) {
      amp.forEach((partialAmp) => {
        nextAmp.push(partialSelector.replace("&", partialAmp));
      });
      return;
    }
    let partialNextAmp = [
      partialSelector
    ];
    while (round--) {
      const nextPartialNextAmp = [];
      partialNextAmp.forEach((selectorItr) => {
        amp.forEach((partialAmp) => {
          nextPartialNextAmp.push(selectorItr.replace("&", partialAmp));
        });
      });
      partialNextAmp = nextPartialNextAmp;
    }
    partialNextAmp.forEach((part) => nextAmp.push(part));
  });
  return nextAmp;
}
function resolveSelector(amp, selector2) {
  const nextAmp = [];
  selector2.split(separatorRegex).forEach((partialSelector) => {
    amp.forEach((partialAmp) => {
      nextAmp.push((partialAmp && partialAmp + " ") + partialSelector);
    });
  });
  return nextAmp;
}
function parseSelectorPath(selectorPaths) {
  let amp = [""];
  selectorPaths.forEach((selector2) => {
    selector2 = selector2 && selector2.trim();
    if (!selector2) {
      return;
    }
    if (selector2.includes("&")) {
      amp = resolveSelectorWithAmp(amp, selector2);
    } else {
      amp = resolveSelector(amp, selector2);
    }
  });
  return amp.join(", ").replace(extraSpaceRegex, " ");
}
function removeElement(el2) {
  if (!el2)
    return;
  const parentElement = el2.parentElement;
  if (parentElement)
    parentElement.removeChild(el2);
}
function queryElement(id2) {
  return document.head.querySelector(`style[cssr-id="${id2}"]`);
}
function createElement(id2) {
  const el2 = document.createElement("style");
  el2.setAttribute("cssr-id", id2);
  return el2;
}
function isMediaOrSupports(selector2) {
  if (!selector2)
    return false;
  return /^\s*@(s|m)/.test(selector2);
}
const kebabRegex = /[A-Z]/g;
function kebabCase$2(pattern4) {
  return pattern4.replace(kebabRegex, (match2) => "-" + match2.toLowerCase());
}
function unwrapProperty(prop, indent = "  ") {
  if (typeof prop === "object" && prop !== null) {
    return " {\n" + Object.entries(prop).map((v2) => {
      return indent + `  ${kebabCase$2(v2[0])}: ${v2[1]};`;
    }).join("\n") + "\n" + indent + "}";
  }
  return `: ${prop};`;
}
function unwrapProperties(props, instance, params) {
  if (typeof props === "function") {
    return props({
      context: instance.context,
      props: params
    });
  }
  return props;
}
function createStyle(selector2, props, instance, params) {
  if (!props)
    return "";
  const unwrappedProps = unwrapProperties(props, instance, params);
  if (!unwrappedProps)
    return "";
  if (typeof unwrappedProps === "string") {
    return `${selector2} {
${unwrappedProps}
}`;
  }
  const propertyNames = Object.keys(unwrappedProps);
  if (propertyNames.length === 0) {
    if (instance.config.keepEmptyBlock)
      return selector2 + " {\n}";
    return "";
  }
  const statements = selector2 ? [
    selector2 + " {"
  ] : [];
  propertyNames.forEach((propertyName2) => {
    const property2 = unwrappedProps[propertyName2];
    if (propertyName2 === "raw") {
      statements.push("\n" + property2 + "\n");
      return;
    }
    propertyName2 = kebabCase$2(propertyName2);
    if (property2 !== null && property2 !== void 0) {
      statements.push(`  ${propertyName2}${unwrapProperty(property2)}`);
    }
  });
  if (selector2) {
    statements.push("}");
  }
  return statements.join("\n");
}
function loopCNodeListWithCallback(children, options, callback) {
  if (!children)
    return;
  children.forEach((child) => {
    if (Array.isArray(child)) {
      loopCNodeListWithCallback(child, options, callback);
    } else if (typeof child === "function") {
      const grandChildren = child(options);
      if (Array.isArray(grandChildren)) {
        loopCNodeListWithCallback(grandChildren, options, callback);
      } else if (grandChildren) {
        callback(grandChildren);
      }
    } else if (child) {
      callback(child);
    }
  });
}
function traverseCNode(node2, selectorPaths, styles2, instance, params, styleSheet) {
  const $2 = node2.$;
  let blockSelector = "";
  if (!$2 || typeof $2 === "string") {
    if (isMediaOrSupports($2)) {
      blockSelector = $2;
    } else {
      selectorPaths.push($2);
    }
  } else if (typeof $2 === "function") {
    const selector3 = $2({
      context: instance.context,
      props: params
    });
    if (isMediaOrSupports(selector3)) {
      blockSelector = selector3;
    } else {
      selectorPaths.push(selector3);
    }
  } else {
    if ($2.before)
      $2.before(instance.context);
    if (!$2.$ || typeof $2.$ === "string") {
      if (isMediaOrSupports($2.$)) {
        blockSelector = $2.$;
      } else {
        selectorPaths.push($2.$);
      }
    } else if ($2.$) {
      const selector3 = $2.$({
        context: instance.context,
        props: params
      });
      if (isMediaOrSupports(selector3)) {
        blockSelector = selector3;
      } else {
        selectorPaths.push(selector3);
      }
    }
  }
  const selector2 = parseSelectorPath(selectorPaths);
  const style2 = createStyle(selector2, node2.props, instance, params);
  if (blockSelector) {
    styles2.push(`${blockSelector} {`);
    if (styleSheet && style2) {
      styleSheet.insertRule(`${blockSelector} {
${style2}
}
`);
    }
  } else {
    if (styleSheet && style2) {
      styleSheet.insertRule(style2);
    }
    if (!styleSheet && style2.length)
      styles2.push(style2);
  }
  if (node2.children) {
    loopCNodeListWithCallback(node2.children, {
      context: instance.context,
      props: params
    }, (childNode) => {
      if (typeof childNode === "string") {
        const style3 = createStyle(selector2, { raw: childNode }, instance, params);
        if (styleSheet) {
          styleSheet.insertRule(style3);
        } else {
          styles2.push(style3);
        }
      } else {
        traverseCNode(childNode, selectorPaths, styles2, instance, params, styleSheet);
      }
    });
  }
  selectorPaths.pop();
  if (blockSelector) {
    styles2.push("}");
  }
  if ($2 && $2.after)
    $2.after(instance.context);
}
function render$3T(node2, instance, props, insertRule = false) {
  const styles2 = [];
  traverseCNode(node2, [], styles2, instance, props, insertRule ? node2.instance.__styleSheet : void 0);
  if (insertRule)
    return "";
  return styles2.join("\n\n");
}
function murmur2(str) {
  var h2 = 0;
  var k2, i2 = 0, len2 = str.length;
  for (; len2 >= 4; ++i2, len2 -= 4) {
    k2 = str.charCodeAt(i2) & 255 | (str.charCodeAt(++i2) & 255) << 8 | (str.charCodeAt(++i2) & 255) << 16 | (str.charCodeAt(++i2) & 255) << 24;
    k2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= k2 >>> 24;
    h2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len2) {
    case 3:
      h2 ^= (str.charCodeAt(i2 + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i2 + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i2) & 255;
      h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
if (typeof window !== "undefined") {
  window.__cssrContext = {};
}
function unmount(intance, node2, id2) {
  const { els } = node2;
  if (id2 === void 0) {
    els.forEach(removeElement);
    node2.els = [];
  } else {
    const target = queryElement(id2);
    if (target && els.includes(target)) {
      removeElement(target);
      node2.els = els.filter((el2) => el2 !== target);
    }
  }
}
function addElementToList(els, target) {
  els.push(target);
}
function mount(instance, node2, id2, props, head, silent, force, anchorMetaName, ssrAdapter2) {
  if (silent && !ssrAdapter2) {
    if (id2 === void 0) {
      console.error("[css-render/mount]: `id` is required in `silent` mode.");
      return;
    }
    const cssrContext = window.__cssrContext;
    if (!cssrContext[id2]) {
      cssrContext[id2] = true;
      render$3T(node2, instance, props, silent);
    }
    return;
  }
  let style2;
  if (id2 === void 0) {
    style2 = node2.render(props);
    id2 = murmur2(style2);
  }
  if (ssrAdapter2) {
    ssrAdapter2.adapter(id2, style2 !== null && style2 !== void 0 ? style2 : node2.render(props));
    return;
  }
  const queriedTarget = queryElement(id2);
  if (queriedTarget !== null && !force) {
    return queriedTarget;
  }
  const target = queriedTarget !== null && queriedTarget !== void 0 ? queriedTarget : createElement(id2);
  if (style2 === void 0)
    style2 = node2.render(props);
  target.textContent = style2;
  if (queriedTarget !== null)
    return queriedTarget;
  if (anchorMetaName) {
    const anchorMetaEl = document.head.querySelector(`meta[name="${anchorMetaName}"]`);
    if (anchorMetaEl) {
      document.head.insertBefore(target, anchorMetaEl);
      addElementToList(node2.els, target);
      return target;
    }
  }
  if (head) {
    document.head.insertBefore(target, document.head.querySelector("style, link"));
  } else {
    document.head.appendChild(target);
  }
  addElementToList(node2.els, target);
  return target;
}
function wrappedRender(props) {
  return render$3T(this, this.instance, props);
}
function wrappedMount(options = {}) {
  const { id: id2, ssr, props, head = false, silent = false, force = false, anchorMetaName } = options;
  const targetElement = mount(this.instance, this, id2, props, head, silent, force, anchorMetaName, ssr);
  return targetElement;
}
function wrappedUnmount(options = {}) {
  const { id: id2 } = options;
  unmount(this.instance, this, id2);
}
const createCNode = function(instance, $2, props, children) {
  return {
    instance,
    $: $2,
    props,
    children,
    els: [],
    render: wrappedRender,
    mount: wrappedMount,
    unmount: wrappedUnmount
  };
};
const c$3 = function(instance, $2, props, children) {
  if (Array.isArray($2)) {
    return createCNode(instance, { $: null }, null, $2);
  } else if (Array.isArray(props)) {
    return createCNode(instance, $2, null, props);
  } else if (Array.isArray(children)) {
    return createCNode(instance, $2, props, children);
  } else {
    return createCNode(instance, $2, props, null);
  }
};
function CssRender(config2 = {}) {
  let styleSheet = null;
  const cssr2 = {
    c: (...args) => c$3(cssr2, ...args),
    use: (plugin2, ...args) => plugin2.install(cssr2, ...args),
    find: queryElement,
    context: {},
    config: config2,
    get __styleSheet() {
      if (!styleSheet) {
        const style2 = document.createElement("style");
        document.head.appendChild(style2);
        styleSheet = document.styleSheets[document.styleSheets.length - 1];
        return styleSheet;
      }
      return styleSheet;
    }
  };
  return cssr2;
}
function exists(id2, ssr) {
  if (id2 === void 0)
    return false;
  if (ssr) {
    const { context: { ids } } = ssr;
    return ids.has(id2);
  }
  return queryElement(id2) !== null;
}
function plugin$1(options) {
  let _bPrefix = ".";
  let _ePrefix = "__";
  let _mPrefix = "--";
  let c2;
  if (options) {
    let t2 = options.blockPrefix;
    if (t2) {
      _bPrefix = t2;
    }
    t2 = options.elementPrefix;
    if (t2) {
      _ePrefix = t2;
    }
    t2 = options.modifierPrefix;
    if (t2) {
      _mPrefix = t2;
    }
  }
  const _plugin2 = {
    install(instance) {
      c2 = instance.c;
      const ctx2 = instance.context;
      ctx2.bem = {};
      ctx2.bem.b = null;
      ctx2.bem.els = null;
    }
  };
  function b2(arg) {
    let memorizedB;
    let memorizedE;
    return {
      before(ctx2) {
        memorizedB = ctx2.bem.b;
        memorizedE = ctx2.bem.els;
        ctx2.bem.els = null;
      },
      after(ctx2) {
        ctx2.bem.b = memorizedB;
        ctx2.bem.els = memorizedE;
      },
      $({ context, props }) {
        arg = typeof arg === "string" ? arg : arg({ context, props });
        context.bem.b = arg;
        return `${(props === null || props === void 0 ? void 0 : props.bPrefix) || _bPrefix}${context.bem.b}`;
      }
    };
  }
  function e25(arg) {
    let memorizedE;
    return {
      before(ctx2) {
        memorizedE = ctx2.bem.els;
      },
      after(ctx2) {
        ctx2.bem.els = memorizedE;
      },
      $({ context, props }) {
        arg = typeof arg === "string" ? arg : arg({ context, props });
        context.bem.els = arg.split(",").map((v2) => v2.trim());
        return context.bem.els.map((el2) => `${(props === null || props === void 0 ? void 0 : props.bPrefix) || _bPrefix}${context.bem.b}${_ePrefix}${el2}`).join(", ");
      }
    };
  }
  function m2(arg) {
    return {
      $({ context, props }) {
        arg = typeof arg === "string" ? arg : arg({ context, props });
        const modifiers2 = arg.split(",").map((v2) => v2.trim());
        function elementToSelector(el2) {
          return modifiers2.map((modifier) => `&${(props === null || props === void 0 ? void 0 : props.bPrefix) || _bPrefix}${context.bem.b}${el2 !== void 0 ? `${_ePrefix}${el2}` : ""}${_mPrefix}${modifier}`).join(", ");
        }
        const els = context.bem.els;
        if (els !== null) {
          return elementToSelector(els[0]);
        } else {
          return elementToSelector();
        }
      }
    };
  }
  function notM(arg) {
    return {
      $({ context, props }) {
        arg = typeof arg === "string" ? arg : arg({ context, props });
        const els = context.bem.els;
        return `&:not(${(props === null || props === void 0 ? void 0 : props.bPrefix) || _bPrefix}${context.bem.b}${els !== null && els.length > 0 ? `${_ePrefix}${els[0]}` : ""}${_mPrefix}${arg})`;
      }
    };
  }
  const cB2 = (...args) => c2(b2(args[0]), args[1], args[2]);
  const cE2 = (...args) => c2(e25(args[0]), args[1], args[2]);
  const cM2 = (...args) => c2(m2(args[0]), args[1], args[2]);
  const cNotM2 = (...args) => c2(notM(args[0]), args[1], args[2]);
  Object.assign(_plugin2, {
    cB: cB2,
    cE: cE2,
    cM: cM2,
    cNotM: cNotM2
  });
  return _plugin2;
}
function createKey(prefix2, suffix2) {
  return prefix2 + (suffix2 === "default" ? "" : suffix2.replace(/^[a-z]/, (startChar) => startChar.toUpperCase()));
}
createKey("abc", "def");
const namespace = "n";
const prefix = `.${namespace}-`;
const elementPrefix = "__";
const modifierPrefix = "--";
const cssr = CssRender();
const plugin = plugin$1({
  blockPrefix: prefix,
  elementPrefix,
  modifierPrefix
});
cssr.use(plugin);
const { c: c$2, find: find$2 } = cssr;
const { cB: cB$1, cE: cE$1, cM, cNotM } = plugin;
function insideModal(style2) {
  return c$2(({ props: { bPrefix } }) => `${bPrefix || prefix}modal, ${bPrefix || prefix}drawer`, [style2]);
}
function insidePopover(style2) {
  return c$2(({ props: { bPrefix } }) => `${bPrefix || prefix}popover`, [style2]);
}
function asModal(style2) {
  return c$2(({ props: { bPrefix } }) => `&${bPrefix || prefix}modal`, style2);
}
const cCB = (...args) => {
  return c$2(">", [cB$1(...args)]);
};
let _isJsdom;
function isJsdom() {
  if (_isJsdom === void 0) {
    _isJsdom = navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom");
  }
  return _isJsdom;
}
const isBrowser$2 = typeof document !== "undefined" && typeof window !== "undefined";
const eventSet = new WeakSet();
function markEventEffectPerformed(event) {
  eventSet.add(event);
}
function eventEffectNotPerformed(event) {
  return !eventSet.has(event);
}
function useInjectionInstanceCollection(injectionName, collectionKey, registerKeyRef) {
  var _a2;
  const injection = inject(injectionName, null);
  if (injection === null)
    return;
  const vm2 = (_a2 = getCurrentInstance()) === null || _a2 === void 0 ? void 0 : _a2.proxy;
  watch(registerKeyRef, registerInstance);
  registerInstance(registerKeyRef.value);
  onBeforeUnmount(() => {
    registerInstance(void 0, registerKeyRef.value);
  });
  function registerInstance(key, oldKey) {
    const collection = injection[collectionKey];
    if (oldKey !== void 0)
      removeInstance(collection, oldKey);
    if (key !== void 0)
      addInstance(collection, key);
  }
  function removeInstance(collection, key) {
    if (!collection[key])
      collection[key] = [];
    collection[key].splice(collection[key].findIndex((instance) => instance === vm2), 1);
  }
  function addInstance(collection, key) {
    if (!collection[key])
      collection[key] = [];
    if (!~collection[key].findIndex((instance) => instance === vm2)) {
      collection[key].push(vm2);
    }
  }
}
function useDeferredTrue(valueRef, delay, shouldDelayRef) {
  if (!delay)
    return valueRef;
  const delayedRef = ref(valueRef.value);
  let timerId = null;
  watch(valueRef, (value2) => {
    if (timerId !== null)
      window.clearTimeout(timerId);
    if (value2 === true) {
      if (shouldDelayRef && !shouldDelayRef.value) {
        delayedRef.value = true;
      } else {
        timerId = window.setTimeout(() => {
          delayedRef.value = true;
        }, delay);
      }
    } else {
      delayedRef.value = false;
    }
  });
  return delayedRef;
}
function useFalseUntilTruthy(originalRef) {
  const currentRef = ref(!!originalRef.value);
  if (currentRef.value)
    return readonly(currentRef);
  const stop = watch(originalRef, (value2) => {
    if (value2) {
      currentRef.value = true;
      stop();
    }
  });
  return readonly(currentRef);
}
function useMemo(getterOrOptions) {
  const computedValueRef = computed(getterOrOptions);
  const valueRef = ref(computedValueRef.value);
  watch(computedValueRef, (value2) => {
    valueRef.value = value2;
  });
  if (typeof getterOrOptions === "function") {
    return valueRef;
  } else {
    return {
      __v_isRef: true,
      get value() {
        return valueRef.value;
      },
      set value(v2) {
        getterOrOptions.set(v2);
      }
    };
  }
}
function hasInstance() {
  return getCurrentInstance() !== null;
}
const isBrowser$1 = typeof window !== "undefined";
let fontsReady;
let isFontReady;
const init = () => {
  var _a2, _b2;
  fontsReady = isBrowser$1 ? (_b2 = (_a2 = document) === null || _a2 === void 0 ? void 0 : _a2.fonts) === null || _b2 === void 0 ? void 0 : _b2.ready : void 0;
  isFontReady = false;
  if (fontsReady !== void 0) {
    void fontsReady.then(() => {
      isFontReady = true;
    });
  } else {
    isFontReady = true;
  }
};
init();
function onFontsReady(cb2) {
  if (isFontReady)
    return;
  let deactivated = false;
  onMounted(() => {
    if (!isFontReady) {
      fontsReady === null || fontsReady === void 0 ? void 0 : fontsReady.then(() => {
        if (deactivated)
          return;
        cb2();
      });
    }
  });
  onBeforeUnmount(() => {
    deactivated = true;
  });
}
function getEventTarget(e25) {
  const path = e25.composedPath();
  return path[0];
}
const traps = {
  mousemoveoutside: new WeakMap(),
  clickoutside: new WeakMap()
};
function createTrapHandler(name2, el2, originalHandler) {
  if (name2 === "mousemoveoutside") {
    const moveHandler = (e25) => {
      if (el2.contains(getEventTarget(e25)))
        return;
      originalHandler(e25);
    };
    return {
      mousemove: moveHandler,
      touchstart: moveHandler
    };
  } else if (name2 === "clickoutside") {
    let mouseDownOutside = false;
    const downHandler = (e25) => {
      mouseDownOutside = !el2.contains(getEventTarget(e25));
    };
    const upHanlder = (e25) => {
      if (!mouseDownOutside)
        return;
      if (el2.contains(getEventTarget(e25)))
        return;
      originalHandler(e25);
    };
    return {
      mousedown: downHandler,
      mouseup: upHanlder,
      touchstart: downHandler,
      touchend: upHanlder
    };
  }
  console.error(`[evtd/create-trap-handler]: name \`${name2}\` is invalid. This could be a bug of evtd.`);
  return {};
}
function ensureTrapHandlers(name2, el2, handler) {
  const handlers2 = traps[name2];
  let elHandlers = handlers2.get(el2);
  if (elHandlers === void 0) {
    handlers2.set(el2, elHandlers = new WeakMap());
  }
  let trapHandler = elHandlers.get(handler);
  if (trapHandler === void 0) {
    elHandlers.set(handler, trapHandler = createTrapHandler(name2, el2, handler));
  }
  return trapHandler;
}
function trapOn(name2, el2, handler, options) {
  if (name2 === "mousemoveoutside" || name2 === "clickoutside") {
    const trapHandlers = ensureTrapHandlers(name2, el2, handler);
    Object.keys(trapHandlers).forEach((key) => {
      on$1(key, document, trapHandlers[key], options);
    });
    return true;
  }
  return false;
}
function trapOff(name2, el2, handler, options) {
  if (name2 === "mousemoveoutside" || name2 === "clickoutside") {
    const trapHandlers = ensureTrapHandlers(name2, el2, handler);
    Object.keys(trapHandlers).forEach((key) => {
      off(key, document, trapHandlers[key], options);
    });
    return true;
  }
  return false;
}
function createDelegate() {
  if (typeof window === "undefined") {
    return {
      on: () => {
      },
      off: () => {
      }
    };
  }
  const propagationStopped = new WeakMap();
  const immediatePropagationStopped = new WeakMap();
  function trackPropagation() {
    propagationStopped.set(this, true);
  }
  function trackImmediate() {
    propagationStopped.set(this, true);
    immediatePropagationStopped.set(this, true);
  }
  function spy(event, propName, fn2) {
    const source = event[propName];
    event[propName] = function() {
      fn2.apply(event, arguments);
      return source.apply(event, arguments);
    };
    return event;
  }
  function unspy(event, propName) {
    event[propName] = Event.prototype[propName];
  }
  const currentTargets = new WeakMap();
  const currentTargetDescriptor = Object.getOwnPropertyDescriptor(Event.prototype, "currentTarget");
  function getCurrentTarget() {
    var _a2;
    return (_a2 = currentTargets.get(this)) !== null && _a2 !== void 0 ? _a2 : null;
  }
  function defineCurrentTarget(event, getter) {
    if (currentTargetDescriptor === void 0)
      return;
    Object.defineProperty(event, "currentTarget", {
      configurable: true,
      enumerable: true,
      get: getter !== null && getter !== void 0 ? getter : currentTargetDescriptor.get
    });
  }
  const phaseToTypeToElToHandlers = {
    bubble: {},
    capture: {}
  };
  const typeToWindowEventHandlers = {};
  function createUnifiedHandler() {
    const delegeteHandler = function(e25) {
      const { type: type4, eventPhase, bubbles } = e25;
      const target = getEventTarget(e25);
      if (eventPhase === 2)
        return;
      const phase = eventPhase === 1 ? "capture" : "bubble";
      let cursor = target;
      const path = [];
      while (true) {
        if (cursor === null)
          cursor = window;
        path.push(cursor);
        if (cursor === window) {
          break;
        }
        cursor = cursor.parentNode || null;
      }
      const captureElToHandlers = phaseToTypeToElToHandlers.capture[type4];
      const bubbleElToHandlers = phaseToTypeToElToHandlers.bubble[type4];
      spy(e25, "stopPropagation", trackPropagation);
      spy(e25, "stopImmediatePropagation", trackImmediate);
      defineCurrentTarget(e25, getCurrentTarget);
      if (phase === "capture") {
        if (captureElToHandlers === void 0)
          return;
        for (let i2 = path.length - 1; i2 >= 0; --i2) {
          if (propagationStopped.has(e25))
            break;
          const target2 = path[i2];
          const handlers2 = captureElToHandlers.get(target2);
          if (handlers2 !== void 0) {
            currentTargets.set(e25, target2);
            for (const handler of handlers2) {
              if (immediatePropagationStopped.has(e25))
                break;
              handler(e25);
            }
          }
          if (i2 === 0 && !bubbles && bubbleElToHandlers !== void 0) {
            const bubbleHandlers = bubbleElToHandlers.get(target2);
            if (bubbleHandlers !== void 0) {
              for (const handler of bubbleHandlers) {
                if (immediatePropagationStopped.has(e25))
                  break;
                handler(e25);
              }
            }
          }
        }
      } else if (phase === "bubble") {
        if (bubbleElToHandlers === void 0)
          return;
        for (let i2 = 0; i2 < path.length; ++i2) {
          if (propagationStopped.has(e25))
            break;
          const target2 = path[i2];
          const handlers2 = bubbleElToHandlers.get(target2);
          if (handlers2 !== void 0) {
            currentTargets.set(e25, target2);
            for (const handler of handlers2) {
              if (immediatePropagationStopped.has(e25))
                break;
              handler(e25);
            }
          }
        }
      }
      unspy(e25, "stopPropagation");
      unspy(e25, "stopImmediatePropagation");
      defineCurrentTarget(e25);
    };
    delegeteHandler.displayName = "evtdUnifiedHandler";
    return delegeteHandler;
  }
  function createUnifiedWindowEventHandler() {
    const delegateHandler = function(e25) {
      const { type: type4, eventPhase } = e25;
      if (eventPhase !== 2)
        return;
      const handlers2 = typeToWindowEventHandlers[type4];
      if (handlers2 === void 0)
        return;
      handlers2.forEach((handler) => handler(e25));
    };
    delegateHandler.displayName = "evtdUnifiedWindowEventHandler";
    return delegateHandler;
  }
  const unifiedHandler = createUnifiedHandler();
  const unfiendWindowEventHandler = createUnifiedWindowEventHandler();
  function ensureElToHandlers(phase, type4) {
    const phaseHandlers = phaseToTypeToElToHandlers[phase];
    if (phaseHandlers[type4] === void 0) {
      phaseHandlers[type4] = new Map();
      window.addEventListener(type4, unifiedHandler, phase === "capture");
    }
    return phaseHandlers[type4];
  }
  function ensureWindowEventHandlers(type4) {
    const windowEventHandlers = typeToWindowEventHandlers[type4];
    if (windowEventHandlers === void 0) {
      typeToWindowEventHandlers[type4] = new Set();
      window.addEventListener(type4, unfiendWindowEventHandler);
    }
    return typeToWindowEventHandlers[type4];
  }
  function ensureHandlers(elToHandlers, el2) {
    let elHandlers = elToHandlers.get(el2);
    if (elHandlers === void 0) {
      elToHandlers.set(el2, elHandlers = new Set());
    }
    return elHandlers;
  }
  function handlerExist(el2, phase, type4, handler) {
    const elToHandlers = phaseToTypeToElToHandlers[phase][type4];
    if (elToHandlers !== void 0) {
      const handlers2 = elToHandlers.get(el2);
      if (handlers2 !== void 0) {
        if (handlers2.has(handler))
          return true;
      }
    }
    return false;
  }
  function windowEventHandlerExist(type4, handler) {
    const handlers2 = typeToWindowEventHandlers[type4];
    if (handlers2 !== void 0) {
      if (handlers2.has(handler)) {
        return true;
      }
    }
    return false;
  }
  function on2(type4, el2, handler, options) {
    let mergedHandler;
    if (typeof options === "object" && options.once === true) {
      mergedHandler = (e25) => {
        off2(type4, el2, mergedHandler, options);
        handler(e25);
      };
    } else {
      mergedHandler = handler;
    }
    const trapped = trapOn(type4, el2, mergedHandler, options);
    if (trapped)
      return;
    const phase = options === true || typeof options === "object" && options.capture === true ? "capture" : "bubble";
    const elToHandlers = ensureElToHandlers(phase, type4);
    const handlers2 = ensureHandlers(elToHandlers, el2);
    if (!handlers2.has(mergedHandler))
      handlers2.add(mergedHandler);
    if (el2 === window) {
      const windowEventHandlers = ensureWindowEventHandlers(type4);
      if (!windowEventHandlers.has(mergedHandler)) {
        windowEventHandlers.add(mergedHandler);
      }
    }
  }
  function off2(type4, el2, handler, options) {
    const trapped = trapOff(type4, el2, handler, options);
    if (trapped)
      return;
    const capture = options === true || typeof options === "object" && options.capture === true;
    const phase = capture ? "capture" : "bubble";
    const elToHandlers = ensureElToHandlers(phase, type4);
    const handlers2 = ensureHandlers(elToHandlers, el2);
    if (el2 === window) {
      const mirrorPhase = capture ? "bubble" : "capture";
      if (!handlerExist(el2, mirrorPhase, type4, handler) && windowEventHandlerExist(type4, handler)) {
        const windowEventHandlers = typeToWindowEventHandlers[type4];
        windowEventHandlers.delete(handler);
        if (windowEventHandlers.size === 0) {
          window.removeEventListener(type4, unfiendWindowEventHandler);
          typeToWindowEventHandlers[type4] = void 0;
        }
      }
    }
    if (handlers2.has(handler))
      handlers2.delete(handler);
    if (handlers2.size === 0) {
      elToHandlers.delete(el2);
    }
    if (elToHandlers.size === 0) {
      window.removeEventListener(type4, unifiedHandler, phase === "capture");
      phaseToTypeToElToHandlers[phase][type4] = void 0;
    }
  }
  return {
    on: on2,
    off: off2
  };
}
const { on: on$1, off } = createDelegate();
const mousePositionRef = ref(null);
function clickHandler(e25) {
  if (e25.clientX > 0 || e25.clientY > 0) {
    mousePositionRef.value = {
      x: e25.clientX,
      y: e25.clientY
    };
  } else {
    const { target } = e25;
    if (target instanceof Element) {
      const { left, top: top2, width, height } = target.getBoundingClientRect();
      if (left > 0 || top2 > 0) {
        mousePositionRef.value = {
          x: left + width / 2,
          y: top2 + height / 2
        };
      } else {
        mousePositionRef.value = { x: 0, y: 0 };
      }
    } else {
      mousePositionRef.value = null;
    }
  }
}
let usedCount$1 = 0;
let managable$1 = true;
function useClickPosition() {
  if (!isBrowser$1)
    return readonly(ref(null));
  if (usedCount$1 === 0)
    on$1("click", document, clickHandler, true);
  const setup2 = () => {
    usedCount$1 += 1;
  };
  if (managable$1 && (managable$1 = hasInstance())) {
    onBeforeMount(setup2);
    onBeforeUnmount(() => {
      usedCount$1 -= 1;
      if (usedCount$1 === 0)
        off("click", document, clickHandler, true);
    });
  } else {
    setup2();
  }
  return readonly(mousePositionRef);
}
const clickedTimeRef = ref(void 0);
let usedCount = 0;
function handleClick() {
  clickedTimeRef.value = Date.now();
}
let managable = true;
function useClicked(timeout) {
  if (!isBrowser$1)
    return readonly(ref(false));
  const clickedRef = ref(false);
  let timerId = null;
  function clearTimer() {
    if (timerId !== null)
      window.clearTimeout(timerId);
  }
  function clickedHandler() {
    clearTimer();
    clickedRef.value = true;
    timerId = window.setTimeout(() => {
      clickedRef.value = false;
    }, timeout);
  }
  if (usedCount === 0) {
    on$1("click", window, handleClick, true);
  }
  const setup2 = () => {
    usedCount += 1;
    on$1("click", window, clickedHandler, true);
  };
  if (managable && (managable = hasInstance())) {
    onBeforeMount(setup2);
    onBeforeUnmount(() => {
      usedCount -= 1;
      if (usedCount === 0) {
        off("click", window, handleClick, true);
      }
      off("click", window, clickedHandler, true);
      clearTimer();
    });
  } else {
    setup2();
  }
  return readonly(clickedRef);
}
function useMergedState(controlledStateRef, uncontrolledStateRef) {
  watch(controlledStateRef, (value2) => {
    if (value2 !== void 0) {
      uncontrolledStateRef.value = value2;
    }
  });
  return computed(() => {
    if (controlledStateRef.value === void 0) {
      return uncontrolledStateRef.value;
    }
    return controlledStateRef.value;
  });
}
function isMounted() {
  const isMounted2 = ref(false);
  onMounted(() => {
    isMounted2.value = true;
  });
  return readonly(isMounted2);
}
function useCompitable(reactive2, keys2) {
  return computed(() => {
    for (const key of keys2) {
      if (reactive2[key] !== void 0)
        return reactive2[key];
    }
    return reactive2[keys2[keys2.length - 1]];
  });
}
const isIos = (typeof window === "undefined" ? false : /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) && !window.MSStream;
function useIsIos() {
  return isIos;
}
function useKeyboard(options = {}, enabledRef) {
  const state = reactive({
    ctrl: false,
    command: false,
    win: false,
    shift: false,
    tab: false
  });
  const { keydown, keyup } = options;
  const keydownHandler = (e25) => {
    switch (e25.key) {
      case "Control":
        state.ctrl = true;
        break;
      case "Meta":
        state.command = true;
        state.win = true;
        break;
      case "Shift":
        state.shift = true;
        break;
      case "Tab":
        state.tab = true;
        break;
    }
    if (keydown !== void 0) {
      Object.keys(keydown).forEach((key) => {
        if (key !== e25.key)
          return;
        const handler = keydown[key];
        if (typeof handler === "function") {
          handler(e25);
        } else {
          const { stop = false, prevent = false } = handler;
          if (stop)
            e25.stopPropagation();
          if (prevent)
            e25.preventDefault();
          handler.handler(e25);
        }
      });
    }
  };
  const keyupHandler = (e25) => {
    switch (e25.key) {
      case "Control":
        state.ctrl = false;
        break;
      case "Meta":
        state.command = false;
        state.win = false;
        break;
      case "Shift":
        state.shift = false;
        break;
      case "Tab":
        state.tab = false;
        break;
    }
    if (keyup !== void 0) {
      Object.keys(keyup).forEach((key) => {
        if (key !== e25.key)
          return;
        const handler = keyup[key];
        if (typeof handler === "function") {
          handler(e25);
        } else {
          const { stop = false, prevent = false } = handler;
          if (stop)
            e25.stopPropagation();
          if (prevent)
            e25.preventDefault();
          handler.handler(e25);
        }
      });
    }
  };
  const setup2 = () => {
    if (enabledRef === void 0 || enabledRef.value) {
      on$1("keydown", document, keydownHandler);
      on$1("keyup", document, keyupHandler);
    }
    if (enabledRef !== void 0) {
      watch(enabledRef, (value2) => {
        if (value2) {
          on$1("keydown", document, keydownHandler);
          on$1("keyup", document, keyupHandler);
        } else {
          off("keydown", document, keydownHandler);
          off("keyup", document, keyupHandler);
        }
      });
    }
  };
  if (hasInstance()) {
    onBeforeMount(setup2);
    onBeforeUnmount(() => {
      if (enabledRef === void 0 || enabledRef.value) {
        off("keydown", document, keydownHandler);
        off("keyup", document, keyupHandler);
      }
    });
  } else {
    setup2();
  }
  return readonly(state);
}
const internalSelectionMenuInjectionKey = createInjectionKey("n-internal-select-menu");
const internalSelectionMenuBodyInjectionKey = createInjectionKey("n-internal-select-menu-body");
const modalBodyInjectionKey = createInjectionKey("n-modal-body");
const modalInjectionKey = createInjectionKey("n-modal");
const drawerBodyInjectionKey = createInjectionKey("n-drawer-body");
const drawerInjectionKey = createInjectionKey("n-drawer");
const popoverBodyInjectionKey = createInjectionKey("n-popover-body");
const teleportDisabled = "__disabled__";
function useAdjustedTo(props) {
  const modal = inject(modalBodyInjectionKey, null);
  const drawer = inject(drawerBodyInjectionKey, null);
  const popover = inject(popoverBodyInjectionKey, null);
  const selectMenu = inject(internalSelectionMenuBodyInjectionKey, null);
  const fullscreenElementRef = ref();
  if (typeof document !== "undefined") {
    fullscreenElementRef.value = document.fullscreenElement;
    const handleFullscreenChange = () => {
      fullscreenElementRef.value = document.fullscreenElement;
    };
    onMounted(() => {
      on$1("fullscreenchange", document, handleFullscreenChange);
    });
    onBeforeUnmount(() => {
      off("fullscreenchange", document, handleFullscreenChange);
    });
  }
  return useMemo(() => {
    var _a2;
    const { to: to2 } = props;
    if (to2 !== void 0) {
      if (to2 === false)
        return teleportDisabled;
      if (to2 === true)
        return fullscreenElementRef.value || "body";
      return to2;
    }
    if (modal === null || modal === void 0 ? void 0 : modal.value) {
      return (_a2 = modal.value.$el) !== null && _a2 !== void 0 ? _a2 : modal.value;
    }
    if (drawer === null || drawer === void 0 ? void 0 : drawer.value)
      return drawer.value;
    if (popover === null || popover === void 0 ? void 0 : popover.value)
      return popover.value;
    if (selectMenu === null || selectMenu === void 0 ? void 0 : selectMenu.value)
      return selectMenu.value;
    return to2 !== null && to2 !== void 0 ? to2 : fullscreenElementRef.value || "body";
  });
}
useAdjustedTo.tdkey = teleportDisabled;
useAdjustedTo.propTo = {
  type: [String, Object, Boolean],
  default: void 0
};
let houdiniRegistered = false;
function useHoudini() {
  if (!isBrowser$2)
    return;
  if (!window.CSS)
    return;
  if (!houdiniRegistered) {
    houdiniRegistered = true;
    if ("registerProperty" in (window === null || window === void 0 ? void 0 : window.CSS)) {
      try {
        ;
        CSS.registerProperty({
          name: "--n-color-start",
          syntax: "<color>",
          inherits: false,
          initialValue: "#0000"
        });
        CSS.registerProperty({
          name: "--n-color-end",
          syntax: "<color>",
          inherits: false,
          initialValue: "#0000"
        });
      } catch (e25) {
      }
    }
  }
}
function getSlot(scope2, slots, slotName = "default") {
  const slot = slots[slotName];
  if (slot === void 0) {
    throw new Error(`[vueuc/${scope2}]: slot[${slotName}] is empty.`);
  }
  return slot();
}
function flatten$3(vNodes, filterCommentNode = true, result2 = []) {
  vNodes.forEach((vNode) => {
    if (vNode === null)
      return;
    if (typeof vNode !== "object") {
      if (typeof vNode === "string" || typeof vNode === "number") {
        result2.push(createTextVNode(String(vNode)));
      }
      return;
    }
    if (Array.isArray(vNode)) {
      flatten$3(vNode, filterCommentNode, result2);
      return;
    }
    if (vNode.type === Fragment) {
      if (vNode.children === null)
        return;
      if (Array.isArray(vNode.children)) {
        flatten$3(vNode.children, filterCommentNode, result2);
      }
    } else if (vNode.type !== Comment$2) {
      result2.push(vNode);
    }
  });
  return result2;
}
function getFirstVNode(scope2, slots, slotName = "default") {
  const slot = slots[slotName];
  if (slot === void 0) {
    throw new Error(`[vueuc/${scope2}]: slot[${slotName}] is empty.`);
  }
  const content2 = flatten$3(slot());
  if (content2.length === 1) {
    return content2[0];
  } else {
    throw new Error(`[vueuc/${scope2}]: slot[${slotName}] should have exactly one child.`);
  }
}
let viewMeasurer = null;
function ensureViewBoundingRect() {
  if (viewMeasurer === null) {
    viewMeasurer = document.getElementById("v-binder-view-measurer");
    if (viewMeasurer === null) {
      viewMeasurer = document.createElement("div");
      viewMeasurer.id = "v-binder-view-measurer";
      const { style: style2 } = viewMeasurer;
      style2.position = "fixed";
      style2.left = "0";
      style2.right = "0";
      style2.top = "0";
      style2.bottom = "0";
      style2.pointerEvents = "none";
      style2.visibility = "hidden";
      document.body.appendChild(viewMeasurer);
    }
  }
  return viewMeasurer.getBoundingClientRect();
}
function getPointRect(x2, y2) {
  const viewRect = ensureViewBoundingRect();
  return {
    top: y2,
    left: x2,
    height: 0,
    width: 0,
    right: viewRect.width - x2,
    bottom: viewRect.height - y2
  };
}
function getRect(el2) {
  const elRect = el2.getBoundingClientRect();
  const viewRect = ensureViewBoundingRect();
  return {
    left: elRect.left - viewRect.left,
    top: elRect.top - viewRect.top,
    bottom: viewRect.height + viewRect.top - elRect.bottom,
    right: viewRect.width + viewRect.left - elRect.right,
    width: elRect.width,
    height: elRect.height
  };
}
function getParentNode(node2) {
  if (node2.nodeType === 9) {
    return null;
  }
  return node2.parentNode;
}
function getScrollParent(node2) {
  if (node2 === null)
    return null;
  const parentNode = getParentNode(node2);
  if (parentNode === null) {
    return null;
  }
  if (parentNode.nodeType === 9) {
    return document;
  }
  if (parentNode.nodeType === 1) {
    const { overflow, overflowX, overflowY } = getComputedStyle(parentNode);
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
      return parentNode;
    }
  }
  return getScrollParent(parentNode);
}
const Binder = defineComponent({
  name: "Binder",
  props: {
    syncTargetWithParent: Boolean,
    syncTarget: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    var _a2;
    provide("VBinder", (_a2 = getCurrentInstance()) === null || _a2 === void 0 ? void 0 : _a2.proxy);
    const VBinder2 = inject("VBinder", null);
    const targetRef = ref(null);
    const setTargetRef = (el2) => {
      targetRef.value = el2;
      if (VBinder2 && props.syncTargetWithParent) {
        VBinder2.setTargetRef(el2);
      }
    };
    let scrollableNodes = [];
    const ensureScrollListener = () => {
      let cursor = targetRef.value;
      while (true) {
        cursor = getScrollParent(cursor);
        if (cursor === null)
          break;
        scrollableNodes.push(cursor);
      }
      for (const el2 of scrollableNodes) {
        on$1("scroll", el2, onScroll, true);
      }
    };
    const removeScrollListeners = () => {
      for (const el2 of scrollableNodes) {
        off("scroll", el2, onScroll, true);
      }
      scrollableNodes = [];
    };
    const followerScrollListeners = new Set();
    const addScrollListener = (listener) => {
      if (followerScrollListeners.size === 0) {
        ensureScrollListener();
      }
      if (!followerScrollListeners.has(listener)) {
        followerScrollListeners.add(listener);
      }
    };
    const removeScrollListener = (listener) => {
      if (followerScrollListeners.has(listener)) {
        followerScrollListeners.delete(listener);
      }
      if (followerScrollListeners.size === 0) {
        removeScrollListeners();
      }
    };
    const onScroll = () => {
      beforeNextFrameOnce(onScrollRaf);
    };
    const onScrollRaf = () => {
      followerScrollListeners.forEach((listener) => listener());
    };
    const followerResizeListeners = new Set();
    const addResizeListener = (listener) => {
      if (followerResizeListeners.size === 0) {
        on$1("resize", window, onResize);
      }
      if (!followerResizeListeners.has(listener)) {
        followerResizeListeners.add(listener);
      }
    };
    const removeResizeListener = (listener) => {
      if (followerResizeListeners.has(listener)) {
        followerResizeListeners.delete(listener);
      }
      if (followerResizeListeners.size === 0) {
        off("resize", window, onResize);
      }
    };
    const onResize = () => {
      followerResizeListeners.forEach((listener) => listener());
    };
    onBeforeUnmount(() => {
      off("resize", window, onResize);
      removeScrollListeners();
    });
    return {
      targetRef,
      setTargetRef,
      addScrollListener,
      removeScrollListener,
      addResizeListener,
      removeResizeListener
    };
  },
  render() {
    return getSlot("binder", this.$slots);
  }
});
var VBinder = Binder;
var VTarget = defineComponent({
  name: "Target",
  setup() {
    const { setTargetRef, syncTarget } = inject("VBinder");
    const setTargetDirective = {
      mounted: setTargetRef,
      updated: setTargetRef
    };
    return {
      syncTarget,
      setTargetDirective
    };
  },
  render() {
    const { syncTarget, setTargetDirective } = this;
    if (syncTarget) {
      return withDirectives(getFirstVNode("follower", this.$slots), [
        [setTargetDirective]
      ]);
    }
    return getFirstVNode("follower", this.$slots);
  }
});
const ctxKey$1 = "@@mmoContext";
const mousemoveoutside = {
  mounted(el2, { value: value2 }) {
    el2[ctxKey$1] = {
      handler: void 0
    };
    if (typeof value2 === "function") {
      el2[ctxKey$1].handler = value2;
      on$1("mousemoveoutside", el2, value2);
    }
  },
  updated(el2, { value: value2 }) {
    const ctx2 = el2[ctxKey$1];
    if (typeof value2 === "function") {
      if (ctx2.handler) {
        if (ctx2.handler !== value2) {
          off("mousemoveoutside", el2, ctx2.handler);
          ctx2.handler = value2;
          on$1("mousemoveoutside", el2, value2);
        }
      } else {
        el2[ctxKey$1].handler = value2;
        on$1("mousemoveoutside", el2, value2);
      }
    } else {
      if (ctx2.handler) {
        off("mousemoveoutside", el2, ctx2.handler);
        ctx2.handler = void 0;
      }
    }
  },
  unmounted(el2) {
    const { handler } = el2[ctxKey$1];
    if (handler) {
      off("mousemoveoutside", el2, handler);
    }
    el2[ctxKey$1].handler = void 0;
  }
};
var mousemoveoutside$1 = mousemoveoutside;
const ctxKey = "@@coContext";
const clickoutside = {
  mounted(el2, { value: value2, modifiers: modifiers2 }) {
    el2[ctxKey] = {
      handler: void 0
    };
    if (typeof value2 === "function") {
      el2[ctxKey].handler = value2;
      on$1("clickoutside", el2, value2, {
        capture: modifiers2.capture
      });
    }
  },
  updated(el2, { value: value2, modifiers: modifiers2 }) {
    const ctx2 = el2[ctxKey];
    if (typeof value2 === "function") {
      if (ctx2.handler) {
        if (ctx2.handler !== value2) {
          off("clickoutside", el2, ctx2.handler, {
            capture: modifiers2.capture
          });
          ctx2.handler = value2;
          on$1("clickoutside", el2, value2, {
            capture: modifiers2.capture
          });
        }
      } else {
        el2[ctxKey].handler = value2;
        on$1("clickoutside", el2, value2, {
          capture: modifiers2.capture
        });
      }
    } else {
      if (ctx2.handler) {
        off("clickoutside", el2, ctx2.handler, {
          capture: modifiers2.capture
        });
        ctx2.handler = void 0;
      }
    }
  },
  unmounted(el2, { modifiers: modifiers2 }) {
    const { handler } = el2[ctxKey];
    if (handler) {
      off("clickoutside", el2, handler, {
        capture: modifiers2.capture
      });
    }
    el2[ctxKey].handler = void 0;
  }
};
var clickoutside$1 = clickoutside;
function warn$1(location, message) {
  console.error(`[vdirs/${location}]: ${message}`);
}
class ZIndexManager {
  constructor() {
    this.elementZIndex = new Map();
    this.nextZIndex = 2e3;
  }
  get elementCount() {
    return this.elementZIndex.size;
  }
  ensureZIndex(el2, zIndex) {
    const { elementZIndex } = this;
    if (zIndex !== void 0) {
      el2.style.zIndex = `${zIndex}`;
      elementZIndex.delete(el2);
      return;
    }
    const { nextZIndex } = this;
    if (elementZIndex.has(el2)) {
      const currentZIndex = elementZIndex.get(el2);
      if (currentZIndex + 1 === this.nextZIndex)
        return;
    }
    el2.style.zIndex = `${nextZIndex}`;
    elementZIndex.set(el2, nextZIndex);
    this.nextZIndex = nextZIndex + 1;
    this.squashState();
  }
  unregister(el2, zIndex) {
    const { elementZIndex } = this;
    if (elementZIndex.has(el2)) {
      elementZIndex.delete(el2);
    } else if (zIndex === void 0) {
      warn$1("z-index-manager/unregister-element", "Element not found when unregistering.");
    }
    this.squashState();
  }
  squashState() {
    const { elementCount } = this;
    if (!elementCount) {
      this.nextZIndex = 2e3;
    }
    if (this.nextZIndex - elementCount > 2500)
      this.rearrange();
  }
  rearrange() {
    const elementZIndexPair = Array.from(this.elementZIndex.entries());
    elementZIndexPair.sort((pair1, pair2) => {
      return pair1[1] - pair2[1];
    });
    this.nextZIndex = 2e3;
    elementZIndexPair.forEach((pair2) => {
      const el2 = pair2[0];
      const zIndex = this.nextZIndex++;
      if (`${zIndex}` !== el2.style.zIndex)
        el2.style.zIndex = `${zIndex}`;
    });
  }
}
var zIndexManager = new ZIndexManager();
const ctx = "@@ziContext";
const zindexable = {
  mounted(el2, bindings) {
    const { value: value2 = {} } = bindings;
    const { zIndex, enabled } = value2;
    el2[ctx] = {
      enabled: !!enabled,
      initialized: false
    };
    if (enabled) {
      zIndexManager.ensureZIndex(el2, zIndex);
      el2[ctx].initialized = true;
    }
  },
  updated(el2, bindings) {
    const { value: value2 = {} } = bindings;
    const { zIndex, enabled } = value2;
    const cachedEnabled = el2[ctx].enabled;
    if (enabled && !cachedEnabled) {
      zIndexManager.ensureZIndex(el2, zIndex);
      el2[ctx].initialized = true;
    }
    el2[ctx].enabled = !!enabled;
  },
  unmounted(el2, bindings) {
    if (!el2[ctx].initialized)
      return;
    const { value: value2 = {} } = bindings;
    const { zIndex } = value2;
    zIndexManager.unregister(el2, zIndex);
  }
};
var zindexable$1 = zindexable;
const ssrContextKey = Symbol("@css-render/vue3-ssr");
function createStyleString(id2, style2) {
  return `<style cssr-id="${id2}">
${style2}
</style>`;
}
function ssrAdapter(id2, style2) {
  const ssrContext = inject(ssrContextKey, null);
  if (ssrContext === null) {
    console.error("[css-render/vue3-ssr]: no ssr context found.");
    return;
  }
  const { styles: styles2, ids } = ssrContext;
  if (ids.has(id2))
    return;
  if (styles2 !== null) {
    ids.add(id2);
    styles2.push(createStyleString(id2, style2));
  }
}
const isBrowser = typeof document !== "undefined";
function useSsrAdapter() {
  if (isBrowser)
    return void 0;
  const context = inject(ssrContextKey, null);
  if (context === null)
    return void 0;
  return {
    adapter: ssrAdapter,
    context
  };
}
function warn(location, message) {
  console.error(`[vueuc/${location}]: ${message}`);
}
const { c: c$1 } = CssRender();
const cssrAnchorMetaName$1 = "vueuc-style";
function lowBit(n2) {
  return n2 & -n2;
}
class FinweckTree {
  constructor(l2, min) {
    this.l = l2;
    this.min = min;
    const ft2 = new Array(l2 + 1);
    for (let i2 = 0; i2 < l2 + 1; ++i2) {
      ft2[i2] = 0;
    }
    this.ft = ft2;
  }
  add(i2, n2) {
    if (n2 === 0)
      return;
    const { l: l2, ft: ft2 } = this;
    i2 += 1;
    while (i2 <= l2) {
      ft2[i2] += n2;
      i2 += lowBit(i2);
    }
  }
  get(i2) {
    return this.sum(i2 + 1) - this.sum(i2);
  }
  sum(i2) {
    if (i2 === void 0)
      i2 = this.l;
    if (i2 <= 0)
      return 0;
    const { ft: ft2, min, l: l2 } = this;
    if (i2 > l2)
      throw new Error("[FinweckTree.sum]: `i` is larger than length.");
    let ret = i2 * min;
    while (i2 > 0) {
      ret += ft2[i2];
      i2 -= lowBit(i2);
    }
    return ret;
  }
  getBound(threshold) {
    let l2 = 0;
    let r2 = this.l;
    while (r2 > l2) {
      const m2 = Math.floor((l2 + r2) / 2);
      const sumM = this.sum(m2);
      if (sumM > threshold) {
        r2 = m2;
        continue;
      } else if (sumM < threshold) {
        if (l2 === m2) {
          if (this.sum(l2 + 1) <= threshold)
            return l2 + 1;
          return m2;
        }
        l2 = m2;
      } else {
        return m2;
      }
    }
    return l2;
  }
}
function resolveTo(selector2) {
  if (typeof selector2 === "string") {
    return document.querySelector(selector2);
  }
  return selector2();
}
var LazyTeleport = defineComponent({
  name: "LazyTeleport",
  props: {
    to: {
      type: [String, Object],
      default: void 0
    },
    disabled: Boolean,
    show: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    return {
      showTeleport: useFalseUntilTruthy(toRef(props, "show")),
      mergedTo: computed(() => {
        const { to: to2 } = props;
        return to2 !== null && to2 !== void 0 ? to2 : "body";
      })
    };
  },
  render() {
    return this.showTeleport ? this.disabled ? getSlot("lazy-teleport", this.$slots) : h$1(Teleport, {
      disabled: this.disabled,
      to: this.mergedTo
    }, getSlot("lazy-teleport", this.$slots)) : null;
  }
});
const oppositionPositions = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
};
const oppositeAligns = {
  start: "end",
  center: "center",
  end: "start"
};
const propToCompare = {
  top: "height",
  bottom: "height",
  left: "width",
  right: "width"
};
const transformOrigins = {
  "bottom-start": "top left",
  bottom: "top center",
  "bottom-end": "top right",
  "top-start": "bottom left",
  top: "bottom center",
  "top-end": "bottom right",
  "right-start": "top left",
  right: "center left",
  "right-end": "bottom left",
  "left-start": "top right",
  left: "center right",
  "left-end": "bottom right"
};
const overlapTransformOrigin = {
  "bottom-start": "bottom left",
  bottom: "bottom center",
  "bottom-end": "bottom right",
  "top-start": "top left",
  top: "top center",
  "top-end": "top right",
  "right-start": "top right",
  right: "center right",
  "right-end": "bottom right",
  "left-start": "top left",
  left: "center left",
  "left-end": "bottom left"
};
const oppositeAlignCssPositionProps = {
  "bottom-start": "right",
  "bottom-end": "left",
  "top-start": "right",
  "top-end": "left",
  "right-start": "bottom",
  "right-end": "top",
  "left-start": "bottom",
  "left-end": "top"
};
const keepOffsetDirection = {
  top: true,
  bottom: false,
  left: true,
  right: false
};
const cssPositionToOppositeAlign = {
  top: "end",
  bottom: "start",
  left: "end",
  right: "start"
};
function getPlacementAndOffsetOfFollower(placement, targetRect, followerRect, shift2, flip, overlap) {
  if (!flip || overlap) {
    return { placement, top: 0, left: 0 };
  }
  const [position, align] = placement.split("-");
  let properAlign = align !== null && align !== void 0 ? align : "center";
  let properOffset = {
    top: 0,
    left: 0
  };
  const deriveOffset = (oppositeAlignCssSizeProp, alignCssPositionProp, offsetVertically2) => {
    let left = 0;
    let top2 = 0;
    const diff = followerRect[oppositeAlignCssSizeProp] - targetRect[alignCssPositionProp] - targetRect[oppositeAlignCssSizeProp];
    if (diff > 0 && shift2) {
      if (offsetVertically2) {
        top2 = keepOffsetDirection[alignCssPositionProp] ? diff : -diff;
      } else {
        left = keepOffsetDirection[alignCssPositionProp] ? diff : -diff;
      }
    }
    return {
      left,
      top: top2
    };
  };
  const offsetVertically = position === "left" || position === "right";
  if (properAlign !== "center") {
    const oppositeAlignCssPositionProp = oppositeAlignCssPositionProps[placement];
    const currentAlignCssPositionProp = oppositionPositions[oppositeAlignCssPositionProp];
    const oppositeAlignCssSizeProp = propToCompare[oppositeAlignCssPositionProp];
    if (followerRect[oppositeAlignCssSizeProp] > targetRect[oppositeAlignCssSizeProp]) {
      if (targetRect[oppositeAlignCssPositionProp] + targetRect[oppositeAlignCssSizeProp] < followerRect[oppositeAlignCssSizeProp]) {
        const followerOverTargetSize = (followerRect[oppositeAlignCssSizeProp] - targetRect[oppositeAlignCssSizeProp]) / 2;
        if (targetRect[oppositeAlignCssPositionProp] < followerOverTargetSize || targetRect[currentAlignCssPositionProp] < followerOverTargetSize) {
          if (targetRect[oppositeAlignCssPositionProp] < targetRect[currentAlignCssPositionProp]) {
            properAlign = oppositeAligns[align];
            properOffset = deriveOffset(oppositeAlignCssSizeProp, currentAlignCssPositionProp, offsetVertically);
          } else {
            properOffset = deriveOffset(oppositeAlignCssSizeProp, oppositeAlignCssPositionProp, offsetVertically);
          }
        } else {
          properAlign = "center";
        }
      }
    } else if (followerRect[oppositeAlignCssSizeProp] < targetRect[oppositeAlignCssSizeProp]) {
      if (targetRect[currentAlignCssPositionProp] < 0 && targetRect[oppositeAlignCssPositionProp] > targetRect[currentAlignCssPositionProp]) {
        properAlign = oppositeAligns[align];
      }
    }
  } else {
    const possibleAlternativeAlignCssPositionProp1 = position === "bottom" || position === "top" ? "left" : "top";
    const possibleAlternativeAlignCssPositionProp2 = oppositionPositions[possibleAlternativeAlignCssPositionProp1];
    const alternativeAlignCssSizeProp = propToCompare[possibleAlternativeAlignCssPositionProp1];
    const followerOverTargetSize = (followerRect[alternativeAlignCssSizeProp] - targetRect[alternativeAlignCssSizeProp]) / 2;
    if (targetRect[possibleAlternativeAlignCssPositionProp1] < followerOverTargetSize || targetRect[possibleAlternativeAlignCssPositionProp2] < followerOverTargetSize) {
      if (targetRect[possibleAlternativeAlignCssPositionProp1] > targetRect[possibleAlternativeAlignCssPositionProp2]) {
        properAlign = cssPositionToOppositeAlign[possibleAlternativeAlignCssPositionProp1];
        properOffset = deriveOffset(alternativeAlignCssSizeProp, possibleAlternativeAlignCssPositionProp1, offsetVertically);
      } else {
        properAlign = cssPositionToOppositeAlign[possibleAlternativeAlignCssPositionProp2];
        properOffset = deriveOffset(alternativeAlignCssSizeProp, possibleAlternativeAlignCssPositionProp2, offsetVertically);
      }
    }
  }
  let properPosition = position;
  if (targetRect[position] < followerRect[propToCompare[position]] && targetRect[position] < targetRect[oppositionPositions[position]]) {
    properPosition = oppositionPositions[position];
  }
  return {
    placement: properAlign !== "center" ? `${properPosition}-${properAlign}` : properPosition,
    left: properOffset.left,
    top: properOffset.top
  };
}
function getProperTransformOrigin(placement, overlap) {
  if (overlap)
    return overlapTransformOrigin[placement];
  return transformOrigins[placement];
}
function getOffset(placement, offsetRect, targetRect, offsetTopToStandardPlacement, offsetLeftToStandardPlacement, overlap) {
  if (overlap) {
    switch (placement) {
      case "bottom-start":
        return {
          top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height)}px`,
          left: `${Math.round(targetRect.left - offsetRect.left)}px`,
          transform: "translateY(-100%)"
        };
      case "bottom-end":
        return {
          top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height)}px`,
          left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width)}px`,
          transform: "translateX(-100%) translateY(-100%)"
        };
      case "top-start":
        return {
          top: `${Math.round(targetRect.top - offsetRect.top)}px`,
          left: `${Math.round(targetRect.left - offsetRect.left)}px`,
          transform: ""
        };
      case "top-end":
        return {
          top: `${Math.round(targetRect.top - offsetRect.top)}px`,
          left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width)}px`,
          transform: "translateX(-100%)"
        };
      case "right-start":
        return {
          top: `${Math.round(targetRect.top - offsetRect.top)}px`,
          left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width)}px`,
          transform: "translateX(-100%)"
        };
      case "right-end":
        return {
          top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height)}px`,
          left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width)}px`,
          transform: "translateX(-100%) translateY(-100%)"
        };
      case "left-start":
        return {
          top: `${Math.round(targetRect.top - offsetRect.top)}px`,
          left: `${Math.round(targetRect.left - offsetRect.left)}px`,
          transform: ""
        };
      case "left-end":
        return {
          top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height)}px`,
          left: `${Math.round(targetRect.left - offsetRect.left)}px`,
          transform: "translateY(-100%)"
        };
      case "top":
        return {
          top: `${Math.round(targetRect.top - offsetRect.top)}px`,
          left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width / 2)}px`,
          transform: "translateX(-50%)"
        };
      case "right":
        return {
          top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height / 2)}px`,
          left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width)}px`,
          transform: "translateX(-100%) translateY(-50%)"
        };
      case "left":
        return {
          top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height / 2)}px`,
          left: `${Math.round(targetRect.left - offsetRect.left)}px`,
          transform: "translateY(-50%)"
        };
      case "bottom":
      default:
        return {
          top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height)}px`,
          left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width / 2)}px`,
          transform: "translateX(-50%) translateY(-100%)"
        };
    }
  }
  switch (placement) {
    case "bottom-start":
      return {
        top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height + offsetTopToStandardPlacement)}px`,
        left: `${Math.round(targetRect.left - offsetRect.left + offsetLeftToStandardPlacement)}px`,
        transform: ""
      };
    case "bottom-end":
      return {
        top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height + offsetTopToStandardPlacement)}px`,
        left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width + offsetLeftToStandardPlacement)}px`,
        transform: "translateX(-100%)"
      };
    case "top-start":
      return {
        top: `${Math.round(targetRect.top - offsetRect.top + offsetTopToStandardPlacement)}px`,
        left: `${Math.round(targetRect.left - offsetRect.left + offsetLeftToStandardPlacement)}px`,
        transform: "translateY(-100%)"
      };
    case "top-end":
      return {
        top: `${Math.round(targetRect.top - offsetRect.top + offsetTopToStandardPlacement)}px`,
        left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width + offsetLeftToStandardPlacement)}px`,
        transform: "translateX(-100%) translateY(-100%)"
      };
    case "right-start":
      return {
        top: `${Math.round(targetRect.top - offsetRect.top + offsetTopToStandardPlacement)}px`,
        left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width + offsetLeftToStandardPlacement)}px`,
        transform: ""
      };
    case "right-end":
      return {
        top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height + offsetTopToStandardPlacement)}px`,
        left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width + offsetLeftToStandardPlacement)}px`,
        transform: "translateY(-100%)"
      };
    case "left-start":
      return {
        top: `${Math.round(targetRect.top - offsetRect.top + offsetTopToStandardPlacement)}px`,
        left: `${Math.round(targetRect.left - offsetRect.left + offsetLeftToStandardPlacement)}px`,
        transform: "translateX(-100%)"
      };
    case "left-end":
      return {
        top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height + offsetTopToStandardPlacement)}px`,
        left: `${Math.round(targetRect.left - offsetRect.left + offsetLeftToStandardPlacement)}px`,
        transform: "translateX(-100%) translateY(-100%)"
      };
    case "top":
      return {
        top: `${Math.round(targetRect.top - offsetRect.top + offsetTopToStandardPlacement)}px`,
        left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width / 2 + offsetLeftToStandardPlacement)}px`,
        transform: "translateY(-100%) translateX(-50%)"
      };
    case "right":
      return {
        top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height / 2 + offsetTopToStandardPlacement)}px`,
        left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width + offsetLeftToStandardPlacement)}px`,
        transform: "translateY(-50%)"
      };
    case "left":
      return {
        top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height / 2 + offsetTopToStandardPlacement)}px`,
        left: `${Math.round(targetRect.left - offsetRect.left + offsetLeftToStandardPlacement)}px`,
        transform: "translateY(-50%) translateX(-100%)"
      };
    case "bottom":
    default:
      return {
        top: `${Math.round(targetRect.top - offsetRect.top + targetRect.height + offsetTopToStandardPlacement)}px`,
        left: `${Math.round(targetRect.left - offsetRect.left + targetRect.width / 2 + offsetLeftToStandardPlacement)}px`,
        transform: "translateX(-50%)"
      };
  }
}
const style$W = c$1([
  c$1(".v-binder-follower-container", {
    position: "absolute",
    left: "0",
    right: "0",
    top: "0",
    height: "0",
    pointerEvents: "none",
    zIndex: "auto"
  }),
  c$1(".v-binder-follower-content", {
    position: "absolute",
    zIndex: "auto"
  }, [
    c$1("> *", {
      pointerEvents: "all"
    })
  ])
]);
var VFollower = defineComponent({
  name: "Follower",
  inheritAttrs: false,
  props: {
    show: Boolean,
    enabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: "bottom"
    },
    syncTrigger: {
      type: Array,
      default: ["resize", "scroll"]
    },
    to: [String, Object],
    flip: {
      type: Boolean,
      default: true
    },
    internalShift: Boolean,
    x: Number,
    y: Number,
    width: String,
    minWidth: String,
    containerClass: String,
    teleportDisabled: Boolean,
    zindexable: {
      type: Boolean,
      default: true
    },
    zIndex: Number,
    overlap: Boolean
  },
  setup(props) {
    const VBinder2 = inject("VBinder");
    const mergedEnabledRef = useMemo(() => {
      return props.enabled !== void 0 ? props.enabled : props.show;
    });
    const followerRef = ref(null);
    const offsetContainerRef = ref(null);
    const ensureListeners = () => {
      const { syncTrigger } = props;
      if (syncTrigger.includes("scroll")) {
        VBinder2.addScrollListener(syncPosition);
      }
      if (syncTrigger.includes("resize")) {
        VBinder2.addResizeListener(syncPosition);
      }
    };
    const removeListeners = () => {
      VBinder2.removeScrollListener(syncPosition);
      VBinder2.removeResizeListener(syncPosition);
    };
    onMounted(() => {
      if (mergedEnabledRef.value) {
        syncPosition();
        ensureListeners();
      }
    });
    const ssrAdapter2 = useSsrAdapter();
    style$W.mount({
      id: "vueuc/binder",
      head: true,
      anchorMetaName: cssrAnchorMetaName$1,
      ssr: ssrAdapter2
    });
    onBeforeUnmount(() => {
      removeListeners();
    });
    onFontsReady(() => {
      if (mergedEnabledRef.value) {
        syncPosition();
      }
    });
    const syncPosition = () => {
      if (!mergedEnabledRef.value) {
        return;
      }
      const follower = followerRef.value;
      if (follower === null)
        return;
      const target = VBinder2.targetRef;
      const { x: x2, y: y2, overlap } = props;
      const targetRect = x2 !== void 0 && y2 !== void 0 ? getPointRect(x2, y2) : getRect(target);
      follower.style.setProperty("--v-target-width", `${Math.round(targetRect.width)}px`);
      follower.style.setProperty("--v-target-height", `${Math.round(targetRect.height)}px`);
      const { width, minWidth, placement, internalShift, flip } = props;
      follower.setAttribute("v-placement", placement);
      if (overlap) {
        follower.setAttribute("v-overlap", "");
      } else {
        follower.removeAttribute("v-overlap");
      }
      const { style: style2 } = follower;
      if (width === "target") {
        style2.width = `${targetRect.width}px`;
      } else if (width !== void 0) {
        style2.width = width;
      } else {
        style2.width = "";
      }
      if (minWidth === "target") {
        style2.minWidth = `${targetRect.width}px`;
      } else if (minWidth !== void 0) {
        style2.minWidth = minWidth;
      } else {
        style2.minWidth = "";
      }
      const followerRect = getRect(follower);
      const offsetContainerRect = getRect(offsetContainerRef.value);
      const { left: offsetLeftToStandardPlacement, top: offsetTopToStandardPlacement, placement: properPlacement } = getPlacementAndOffsetOfFollower(placement, targetRect, followerRect, internalShift, flip, overlap);
      const properTransformOrigin = getProperTransformOrigin(properPlacement, overlap);
      const { left, top: top2, transform } = getOffset(properPlacement, offsetContainerRect, targetRect, offsetTopToStandardPlacement, offsetLeftToStandardPlacement, overlap);
      follower.setAttribute("v-placement", properPlacement);
      follower.style.setProperty("--v-offset-left", `${Math.round(offsetLeftToStandardPlacement)}px`);
      follower.style.setProperty("--v-offset-top", `${Math.round(offsetTopToStandardPlacement)}px`);
      follower.style.transform = `translateX(${left}) translateY(${top2}) ${transform}`;
      follower.style.setProperty("--v-transform-origin", properTransformOrigin);
      follower.style.transformOrigin = properTransformOrigin;
    };
    watch(mergedEnabledRef, (value2) => {
      if (value2) {
        ensureListeners();
        syncOnNextTick();
      } else {
        removeListeners();
      }
    });
    const syncOnNextTick = () => {
      nextTick().then(syncPosition).catch((e25) => console.error(e25));
    };
    [
      "placement",
      "x",
      "y",
      "internalShift",
      "flip",
      "width",
      "overlap",
      "minWidth"
    ].forEach((prop) => {
      watch(toRef(props, prop), syncPosition);
    });
    ["teleportDisabled"].forEach((prop) => {
      watch(toRef(props, prop), syncOnNextTick);
    });
    watch(toRef(props, "syncTrigger"), (value2) => {
      if (!value2.includes("resize")) {
        VBinder2.removeResizeListener(syncPosition);
      } else {
        VBinder2.addResizeListener(syncPosition);
      }
      if (!value2.includes("scroll")) {
        VBinder2.removeScrollListener(syncPosition);
      } else {
        VBinder2.addScrollListener(syncPosition);
      }
    });
    const isMountedRef = isMounted();
    const mergedToRef = useMemo(() => {
      const { to: to2 } = props;
      if (to2 !== void 0)
        return to2;
      if (isMountedRef.value) {
        return void 0;
      }
      return void 0;
    });
    return {
      VBinder: VBinder2,
      mergedEnabled: mergedEnabledRef,
      offsetContainerRef,
      followerRef,
      mergedTo: mergedToRef,
      syncPosition
    };
  },
  render() {
    return h$1(LazyTeleport, {
      show: this.show,
      to: this.mergedTo,
      disabled: this.teleportDisabled
    }, {
      default: () => {
        var _a2, _b2;
        const vNode = h$1("div", {
          class: ["v-binder-follower-container", this.containerClass],
          ref: "offsetContainerRef"
        }, [
          h$1("div", {
            class: "v-binder-follower-content",
            ref: "followerRef"
          }, (_b2 = (_a2 = this.$slots).default) === null || _b2 === void 0 ? void 0 : _b2.call(_a2))
        ]);
        if (this.zindexable) {
          return withDirectives(vNode, [
            [
              zindexable$1,
              {
                enabled: this.mergedEnabled,
                zIndex: this.zIndex
              }
            ]
          ]);
        }
        return vNode;
      }
    });
  }
});
var resizeObservers = [];
var hasActiveObservations = function() {
  return resizeObservers.some(function(ro2) {
    return ro2.activeTargets.length > 0;
  });
};
var hasSkippedObservations = function() {
  return resizeObservers.some(function(ro2) {
    return ro2.skippedTargets.length > 0;
  });
};
var msg = "ResizeObserver loop completed with undelivered notifications.";
var deliverResizeLoopError = function() {
  var event;
  if (typeof ErrorEvent === "function") {
    event = new ErrorEvent("error", {
      message: msg
    });
  } else {
    event = document.createEvent("Event");
    event.initEvent("error", false, false);
    event.message = msg;
  }
  window.dispatchEvent(event);
};
var ResizeObserverBoxOptions;
(function(ResizeObserverBoxOptions2) {
  ResizeObserverBoxOptions2["BORDER_BOX"] = "border-box";
  ResizeObserverBoxOptions2["CONTENT_BOX"] = "content-box";
  ResizeObserverBoxOptions2["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));
var freeze = function(obj) {
  return Object.freeze(obj);
};
var ResizeObserverSize = function() {
  function ResizeObserverSize2(inlineSize, blockSize) {
    this.inlineSize = inlineSize;
    this.blockSize = blockSize;
    freeze(this);
  }
  return ResizeObserverSize2;
}();
var DOMRectReadOnly = function() {
  function DOMRectReadOnly2(x2, y2, width, height) {
    this.x = x2;
    this.y = y2;
    this.width = width;
    this.height = height;
    this.top = this.y;
    this.left = this.x;
    this.bottom = this.top + this.height;
    this.right = this.left + this.width;
    return freeze(this);
  }
  DOMRectReadOnly2.prototype.toJSON = function() {
    var _a2 = this, x2 = _a2.x, y2 = _a2.y, top2 = _a2.top, right = _a2.right, bottom = _a2.bottom, left = _a2.left, width = _a2.width, height = _a2.height;
    return { x: x2, y: y2, top: top2, right, bottom, left, width, height };
  };
  DOMRectReadOnly2.fromRect = function(rectangle) {
    return new DOMRectReadOnly2(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
  };
  return DOMRectReadOnly2;
}();
var isSVG = function(target) {
  return target instanceof SVGElement && "getBBox" in target;
};
var isHidden = function(target) {
  if (isSVG(target)) {
    var _a2 = target.getBBox(), width = _a2.width, height = _a2.height;
    return !width && !height;
  }
  var _b2 = target, offsetWidth = _b2.offsetWidth, offsetHeight = _b2.offsetHeight;
  return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isElement = function(obj) {
  var _a2;
  if (obj instanceof Element) {
    return true;
  }
  var scope2 = (_a2 = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a2 === void 0 ? void 0 : _a2.defaultView;
  return !!(scope2 && obj instanceof scope2.Element);
};
var isReplacedElement = function(target) {
  switch (target.tagName) {
    case "INPUT":
      if (target.type !== "image") {
        break;
      }
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return true;
  }
  return false;
};
var global$1 = typeof window !== "undefined" ? window : {};
var cache$1 = new WeakMap();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE$1 = /msie|trident/i.test(global$1.navigator && global$1.navigator.userAgent);
var parseDimension = function(pixel) {
  return parseFloat(pixel || "0");
};
var size = function(inlineSize, blockSize, switchSizes) {
  if (inlineSize === void 0) {
    inlineSize = 0;
  }
  if (blockSize === void 0) {
    blockSize = 0;
  }
  if (switchSizes === void 0) {
    switchSizes = false;
  }
  return new ResizeObserverSize((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var zeroBoxes = freeze({
  devicePixelContentBoxSize: size(),
  borderBoxSize: size(),
  contentBoxSize: size(),
  contentRect: new DOMRectReadOnly(0, 0, 0, 0)
});
var calculateBoxSizes = function(target, forceRecalculation) {
  if (forceRecalculation === void 0) {
    forceRecalculation = false;
  }
  if (cache$1.has(target) && !forceRecalculation) {
    return cache$1.get(target);
  }
  if (isHidden(target)) {
    cache$1.set(target, zeroBoxes);
    return zeroBoxes;
  }
  var cs = getComputedStyle(target);
  var svg2 = isSVG(target) && target.ownerSVGElement && target.getBBox();
  var removePadding = !IE$1 && cs.boxSizing === "border-box";
  var switchSizes = verticalRegexp.test(cs.writingMode || "");
  var canScrollVertically = !svg2 && scrollRegexp.test(cs.overflowY || "");
  var canScrollHorizontally = !svg2 && scrollRegexp.test(cs.overflowX || "");
  var paddingTop = svg2 ? 0 : parseDimension(cs.paddingTop);
  var paddingRight = svg2 ? 0 : parseDimension(cs.paddingRight);
  var paddingBottom = svg2 ? 0 : parseDimension(cs.paddingBottom);
  var paddingLeft = svg2 ? 0 : parseDimension(cs.paddingLeft);
  var borderTop = svg2 ? 0 : parseDimension(cs.borderTopWidth);
  var borderRight = svg2 ? 0 : parseDimension(cs.borderRightWidth);
  var borderBottom = svg2 ? 0 : parseDimension(cs.borderBottomWidth);
  var borderLeft = svg2 ? 0 : parseDimension(cs.borderLeftWidth);
  var horizontalPadding = paddingLeft + paddingRight;
  var verticalPadding = paddingTop + paddingBottom;
  var horizontalBorderArea = borderLeft + borderRight;
  var verticalBorderArea = borderTop + borderBottom;
  var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
  var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
  var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
  var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
  var contentWidth = svg2 ? svg2.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
  var contentHeight = svg2 ? svg2.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
  var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
  var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
  var boxes = freeze({
    devicePixelContentBoxSize: size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
    borderBoxSize: size(borderBoxWidth, borderBoxHeight, switchSizes),
    contentBoxSize: size(contentWidth, contentHeight, switchSizes),
    contentRect: new DOMRectReadOnly(paddingLeft, paddingTop, contentWidth, contentHeight)
  });
  cache$1.set(target, boxes);
  return boxes;
};
var calculateBoxSize = function(target, observedBox, forceRecalculation) {
  var _a2 = calculateBoxSizes(target, forceRecalculation), borderBoxSize = _a2.borderBoxSize, contentBoxSize = _a2.contentBoxSize, devicePixelContentBoxSize = _a2.devicePixelContentBoxSize;
  switch (observedBox) {
    case ResizeObserverBoxOptions.DEVICE_PIXEL_CONTENT_BOX:
      return devicePixelContentBoxSize;
    case ResizeObserverBoxOptions.BORDER_BOX:
      return borderBoxSize;
    default:
      return contentBoxSize;
  }
};
var ResizeObserverEntry = function() {
  function ResizeObserverEntry2(target) {
    var boxes = calculateBoxSizes(target);
    this.target = target;
    this.contentRect = boxes.contentRect;
    this.borderBoxSize = freeze([boxes.borderBoxSize]);
    this.contentBoxSize = freeze([boxes.contentBoxSize]);
    this.devicePixelContentBoxSize = freeze([boxes.devicePixelContentBoxSize]);
  }
  return ResizeObserverEntry2;
}();
var calculateDepthForNode = function(node2) {
  if (isHidden(node2)) {
    return Infinity;
  }
  var depth = 0;
  var parent = node2.parentNode;
  while (parent) {
    depth += 1;
    parent = parent.parentNode;
  }
  return depth;
};
var broadcastActiveObservations = function() {
  var shallowestDepth = Infinity;
  var callbacks2 = [];
  resizeObservers.forEach(function processObserver(ro2) {
    if (ro2.activeTargets.length === 0) {
      return;
    }
    var entries = [];
    ro2.activeTargets.forEach(function processTarget(ot2) {
      var entry = new ResizeObserverEntry(ot2.target);
      var targetDepth = calculateDepthForNode(ot2.target);
      entries.push(entry);
      ot2.lastReportedSize = calculateBoxSize(ot2.target, ot2.observedBox);
      if (targetDepth < shallowestDepth) {
        shallowestDepth = targetDepth;
      }
    });
    callbacks2.push(function resizeObserverCallback() {
      ro2.callback.call(ro2.observer, entries, ro2.observer);
    });
    ro2.activeTargets.splice(0, ro2.activeTargets.length);
  });
  for (var _i2 = 0, callbacks_1 = callbacks2; _i2 < callbacks_1.length; _i2++) {
    var callback = callbacks_1[_i2];
    callback();
  }
  return shallowestDepth;
};
var gatherActiveObservationsAtDepth = function(depth) {
  resizeObservers.forEach(function processObserver(ro2) {
    ro2.activeTargets.splice(0, ro2.activeTargets.length);
    ro2.skippedTargets.splice(0, ro2.skippedTargets.length);
    ro2.observationTargets.forEach(function processTarget(ot2) {
      if (ot2.isActive()) {
        if (calculateDepthForNode(ot2.target) > depth) {
          ro2.activeTargets.push(ot2);
        } else {
          ro2.skippedTargets.push(ot2);
        }
      }
    });
  });
};
var process$1 = function() {
  var depth = 0;
  gatherActiveObservationsAtDepth(depth);
  while (hasActiveObservations()) {
    depth = broadcastActiveObservations();
    gatherActiveObservationsAtDepth(depth);
  }
  if (hasSkippedObservations()) {
    deliverResizeLoopError();
  }
  return depth > 0;
};
var trigger;
var callbacks = [];
var notify = function() {
  return callbacks.splice(0).forEach(function(cb2) {
    return cb2();
  });
};
var queueMicroTask = function(callback) {
  if (!trigger) {
    var toggle_1 = 0;
    var el_1 = document.createTextNode("");
    var config2 = { characterData: true };
    new MutationObserver(function() {
      return notify();
    }).observe(el_1, config2);
    trigger = function() {
      el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
    };
  }
  callbacks.push(callback);
  trigger();
};
var queueResizeObserver = function(cb2) {
  queueMicroTask(function ResizeObserver2() {
    requestAnimationFrame(cb2);
  });
};
var watching = 0;
var isWatching = function() {
  return !!watching;
};
var CATCH_PERIOD = 250;
var observerConfig = { attributes: true, characterData: true, childList: true, subtree: true };
var events = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
];
var time$2 = function(timeout) {
  if (timeout === void 0) {
    timeout = 0;
  }
  return Date.now() + timeout;
};
var scheduled = false;
var Scheduler = function() {
  function Scheduler2() {
    var _this = this;
    this.stopped = true;
    this.listener = function() {
      return _this.schedule();
    };
  }
  Scheduler2.prototype.run = function(timeout) {
    var _this = this;
    if (timeout === void 0) {
      timeout = CATCH_PERIOD;
    }
    if (scheduled) {
      return;
    }
    scheduled = true;
    var until = time$2(timeout);
    queueResizeObserver(function() {
      var elementsHaveResized = false;
      try {
        elementsHaveResized = process$1();
      } finally {
        scheduled = false;
        timeout = until - time$2();
        if (!isWatching()) {
          return;
        }
        if (elementsHaveResized) {
          _this.run(1e3);
        } else if (timeout > 0) {
          _this.run(timeout);
        } else {
          _this.start();
        }
      }
    });
  };
  Scheduler2.prototype.schedule = function() {
    this.stop();
    this.run();
  };
  Scheduler2.prototype.observe = function() {
    var _this = this;
    var cb2 = function() {
      return _this.observer && _this.observer.observe(document.body, observerConfig);
    };
    document.body ? cb2() : global$1.addEventListener("DOMContentLoaded", cb2);
  };
  Scheduler2.prototype.start = function() {
    var _this = this;
    if (this.stopped) {
      this.stopped = false;
      this.observer = new MutationObserver(this.listener);
      this.observe();
      events.forEach(function(name2) {
        return global$1.addEventListener(name2, _this.listener, true);
      });
    }
  };
  Scheduler2.prototype.stop = function() {
    var _this = this;
    if (!this.stopped) {
      this.observer && this.observer.disconnect();
      events.forEach(function(name2) {
        return global$1.removeEventListener(name2, _this.listener, true);
      });
      this.stopped = true;
    }
  };
  return Scheduler2;
}();
var scheduler = new Scheduler();
var updateCount = function(n2) {
  !watching && n2 > 0 && scheduler.start();
  watching += n2;
  !watching && scheduler.stop();
};
var skipNotifyOnElement = function(target) {
  return !isSVG(target) && !isReplacedElement(target) && getComputedStyle(target).display === "inline";
};
var ResizeObservation = function() {
  function ResizeObservation2(target, observedBox) {
    this.target = target;
    this.observedBox = observedBox || ResizeObserverBoxOptions.CONTENT_BOX;
    this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  ResizeObservation2.prototype.isActive = function() {
    var size2 = calculateBoxSize(this.target, this.observedBox, true);
    if (skipNotifyOnElement(this.target)) {
      this.lastReportedSize = size2;
    }
    if (this.lastReportedSize.inlineSize !== size2.inlineSize || this.lastReportedSize.blockSize !== size2.blockSize) {
      return true;
    }
    return false;
  };
  return ResizeObservation2;
}();
var ResizeObserverDetail = function() {
  function ResizeObserverDetail2(resizeObserver, callback) {
    this.activeTargets = [];
    this.skippedTargets = [];
    this.observationTargets = [];
    this.observer = resizeObserver;
    this.callback = callback;
  }
  return ResizeObserverDetail2;
}();
var observerMap = new WeakMap();
var getObservationIndex = function(observationTargets, target) {
  for (var i2 = 0; i2 < observationTargets.length; i2 += 1) {
    if (observationTargets[i2].target === target) {
      return i2;
    }
  }
  return -1;
};
var ResizeObserverController = function() {
  function ResizeObserverController2() {
  }
  ResizeObserverController2.connect = function(resizeObserver, callback) {
    var detail = new ResizeObserverDetail(resizeObserver, callback);
    observerMap.set(resizeObserver, detail);
  };
  ResizeObserverController2.observe = function(resizeObserver, target, options) {
    var detail = observerMap.get(resizeObserver);
    var firstObservation = detail.observationTargets.length === 0;
    if (getObservationIndex(detail.observationTargets, target) < 0) {
      firstObservation && resizeObservers.push(detail);
      detail.observationTargets.push(new ResizeObservation(target, options && options.box));
      updateCount(1);
      scheduler.schedule();
    }
  };
  ResizeObserverController2.unobserve = function(resizeObserver, target) {
    var detail = observerMap.get(resizeObserver);
    var index2 = getObservationIndex(detail.observationTargets, target);
    var lastObservation = detail.observationTargets.length === 1;
    if (index2 >= 0) {
      lastObservation && resizeObservers.splice(resizeObservers.indexOf(detail), 1);
      detail.observationTargets.splice(index2, 1);
      updateCount(-1);
    }
  };
  ResizeObserverController2.disconnect = function(resizeObserver) {
    var _this = this;
    var detail = observerMap.get(resizeObserver);
    detail.observationTargets.slice().forEach(function(ot2) {
      return _this.unobserve(resizeObserver, ot2.target);
    });
    detail.activeTargets.splice(0, detail.activeTargets.length);
  };
  return ResizeObserverController2;
}();
var ResizeObserver$1 = function() {
  function ResizeObserver2(callback) {
    if (arguments.length === 0) {
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    }
    if (typeof callback !== "function") {
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    }
    ResizeObserverController.connect(this, callback);
  }
  ResizeObserver2.prototype.observe = function(target, options) {
    if (arguments.length === 0) {
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    }
    if (!isElement(target)) {
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    }
    ResizeObserverController.observe(this, target, options);
  };
  ResizeObserver2.prototype.unobserve = function(target) {
    if (arguments.length === 0) {
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    }
    if (!isElement(target)) {
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    }
    ResizeObserverController.unobserve(this, target);
  };
  ResizeObserver2.prototype.disconnect = function() {
    ResizeObserverController.disconnect(this);
  };
  ResizeObserver2.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  };
  return ResizeObserver2;
}();
class ResizeObserverDelegate {
  constructor() {
    this.handleResize = this.handleResize.bind(this);
    this.observer = new (typeof window !== "undefined" && window.ResizeObserver || ResizeObserver$1)(this.handleResize);
    this.elHandlersMap = new Map();
  }
  handleResize(entries) {
    for (const entry of entries) {
      const handler = this.elHandlersMap.get(entry.target);
      if (handler !== void 0) {
        handler(entry);
      }
    }
  }
  registerHandler(el2, handler) {
    this.elHandlersMap.set(el2, handler);
    this.observer.observe(el2);
  }
  unregisterHandler(el2) {
    if (!this.elHandlersMap.has(el2)) {
      return;
    }
    this.elHandlersMap.delete(el2);
    this.observer.unobserve(el2);
  }
}
var resizeObserverManager = new ResizeObserverDelegate();
var VResizeObserver = defineComponent({
  name: "ResizeObserver",
  props: {
    onResize: Function
  },
  setup(props) {
    let registered = false;
    const proxy = getCurrentInstance().proxy;
    function handleResize(entry) {
      const { onResize } = props;
      if (onResize !== void 0)
        onResize(entry);
    }
    onMounted(() => {
      const el2 = proxy.$el;
      if (el2 === void 0) {
        warn("resize-observer", "$el does not exist.");
        return;
      }
      if (el2.nextElementSibling !== el2.nextSibling) {
        if (el2.nodeType === 3 && el2.nodeValue !== "") {
          warn("resize-observer", "$el can not be observed (it may be a text node).");
          return;
        }
      }
      if (el2.nextElementSibling !== null) {
        resizeObserverManager.registerHandler(el2.nextElementSibling, handleResize);
        registered = true;
      }
    });
    onBeforeUnmount(() => {
      if (registered) {
        resizeObserverManager.unregisterHandler(proxy.$el.nextElementSibling);
      }
    });
  },
  render() {
    return renderSlot(this.$slots, "default");
  }
});
let maybeTouch;
function ensureMaybeTouch() {
  if (maybeTouch === void 0) {
    if ("matchMedia" in window) {
      maybeTouch = window.matchMedia("(pointer:coarse)").matches;
    } else {
      maybeTouch = false;
    }
  }
  return maybeTouch;
}
let wheelScale;
function ensureWheelScale() {
  if (wheelScale === void 0) {
    wheelScale = "chrome" in window ? window.devicePixelRatio : 1;
  }
  return wheelScale;
}
const styles$1 = c$1(".v-vl", {
  maxHeight: "inherit",
  height: "100%",
  overflow: "auto",
  minWidth: "1px"
}, [
  c$1("&:not(.v-vl--show-scrollbar)", {
    scrollbarWidth: "none"
  }, [
    c$1("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", {
      width: 0,
      height: 0,
      display: "none"
    })
  ])
]);
var VirtualList = defineComponent({
  name: "VirtualList",
  inheritAttrs: false,
  props: {
    showScrollbar: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default: () => []
    },
    itemSize: {
      type: Number,
      required: true
    },
    itemResizable: Boolean,
    itemsStyle: [String, Object],
    visibleItemsTag: {
      type: [String, Object],
      default: "div"
    },
    visibleItemsProps: Object,
    ignoreItemResize: Boolean,
    onScroll: Function,
    onWheel: Function,
    onResize: Function,
    defaultScrollKey: [Number, String],
    defaultScrollIndex: Number,
    keyField: {
      type: String,
      default: "key"
    },
    paddingTop: {
      type: [Number, String],
      default: 0
    },
    paddingBottom: {
      type: [Number, String],
      default: 0
    }
  },
  setup(props) {
    const ssrAdapter2 = useSsrAdapter();
    styles$1.mount({
      id: "vueuc/virtual-list",
      head: true,
      anchorMetaName: cssrAnchorMetaName$1,
      ssr: ssrAdapter2
    });
    onMounted(() => {
      const { defaultScrollIndex, defaultScrollKey } = props;
      if (defaultScrollIndex !== void 0 && defaultScrollIndex !== null) {
        scrollTo({ index: defaultScrollIndex });
      } else if (defaultScrollKey !== void 0 && defaultScrollKey !== null) {
        scrollTo({ key: defaultScrollKey });
      }
    });
    let isDeactivated = false;
    let activateStateInitialized = false;
    onActivated(() => {
      isDeactivated = false;
      if (!activateStateInitialized) {
        activateStateInitialized = true;
        return;
      }
      scrollTo({ top: scrollTopRef.value, left: scrollLeft });
    });
    onDeactivated(() => {
      isDeactivated = true;
      if (!activateStateInitialized) {
        activateStateInitialized = true;
      }
    });
    const keyIndexMapRef = computed(() => {
      const map2 = new Map();
      const { keyField } = props;
      props.items.forEach((item, index2) => {
        map2.set(item[keyField], index2);
      });
      return map2;
    });
    const listElRef = ref(null);
    const listHeightRef = ref(void 0);
    const keyToHeightOffset = new Map();
    const finweckTreeRef = computed(() => {
      const { items, itemSize, keyField } = props;
      const ft2 = new FinweckTree(items.length, itemSize);
      items.forEach((item, index2) => {
        const key = item[keyField];
        const heightOffset = keyToHeightOffset.get(key);
        if (heightOffset !== void 0) {
          ft2.add(index2, heightOffset);
        }
      });
      return ft2;
    });
    const finweckTreeUpdateTrigger = ref(0);
    let scrollLeft = 0;
    const scrollTopRef = ref(0);
    const startIndexRef = useMemo(() => {
      return Math.max(finweckTreeRef.value.getBound(scrollTopRef.value - depx(props.paddingTop)) - 1, 0);
    });
    const viewportItemsRef = computed(() => {
      const { value: listHeight } = listHeightRef;
      if (listHeight === void 0)
        return [];
      const { items, itemSize } = props;
      const startIndex = startIndexRef.value;
      const endIndex = Math.min(startIndex + Math.ceil(listHeight / itemSize + 1), items.length - 1);
      const viewportItems = [];
      for (let i2 = startIndex; i2 <= endIndex; ++i2) {
        viewportItems.push(items[i2]);
      }
      return viewportItems;
    });
    const scrollTo = (options, y2) => {
      if (typeof options === "number") {
        scrollToPosition(options, y2, "auto");
        return;
      }
      const { left, top: top2, index: index2, key, position, behavior, debounce: debounce2 = true } = options;
      if (left !== void 0 || top2 !== void 0) {
        scrollToPosition(left, top2, behavior);
      } else if (index2 !== void 0) {
        scrollToIndex(index2, behavior, debounce2);
      } else if (key !== void 0) {
        const toIndex = keyIndexMapRef.value.get(key);
        if (toIndex !== void 0)
          scrollToIndex(toIndex, behavior, debounce2);
      } else if (position === "bottom") {
        scrollToPosition(0, Number.MAX_SAFE_INTEGER, behavior);
      } else if (position === "top") {
        scrollToPosition(0, 0, behavior);
      }
    };
    let anchorIndex;
    let anchorTimerId = null;
    function scrollToIndex(index2, behavior, debounce2) {
      const { value: ft2 } = finweckTreeRef;
      const targetTop = ft2.sum(index2) + depx(props.paddingTop);
      if (!debounce2) {
        listElRef.value.scrollTo({
          left: 0,
          top: targetTop,
          behavior
        });
      } else {
        anchorIndex = index2;
        if (anchorTimerId !== null) {
          window.clearTimeout(anchorTimerId);
        }
        anchorTimerId = window.setTimeout(() => {
          anchorIndex = void 0;
          anchorTimerId = null;
        }, 16);
        const { scrollTop, offsetHeight } = listElRef.value;
        if (targetTop > scrollTop) {
          const itemSize = ft2.get(index2);
          if (targetTop + itemSize <= scrollTop + offsetHeight)
            ;
          else {
            listElRef.value.scrollTo({
              left: 0,
              top: targetTop + itemSize - offsetHeight,
              behavior
            });
          }
        } else {
          listElRef.value.scrollTo({
            left: 0,
            top: targetTop,
            behavior
          });
        }
      }
    }
    function scrollToPosition(left, top2, behavior) {
      listElRef.value.scrollTo({
        left,
        top: top2,
        behavior
      });
    }
    function handleItemResize(key, entry) {
      var _a2, _b2, _c2;
      if (isDeactivated)
        return;
      if (props.ignoreItemResize)
        return;
      if (isHideByVShow(entry.target))
        return;
      const { value: ft2 } = finweckTreeRef;
      const index2 = keyIndexMapRef.value.get(key);
      const previousHeight = ft2.get(index2);
      const height = (_c2 = (_b2 = (_a2 = entry.borderBoxSize) === null || _a2 === void 0 ? void 0 : _a2[0]) === null || _b2 === void 0 ? void 0 : _b2.blockSize) !== null && _c2 !== void 0 ? _c2 : entry.contentRect.height;
      if (height === previousHeight)
        return;
      const offset = height - props.itemSize;
      if (offset === 0) {
        keyToHeightOffset.delete(key);
      } else {
        keyToHeightOffset.set(key, height - props.itemSize);
      }
      const delta = height - previousHeight;
      if (delta === 0)
        return;
      ft2.add(index2, delta);
      const listEl = listElRef.value;
      if (listEl != null) {
        if (anchorIndex === void 0) {
          const previousHeightSum = ft2.sum(index2);
          if (listEl.scrollTop > previousHeightSum) {
            listEl.scrollBy(0, delta);
          }
        } else {
          if (index2 < anchorIndex) {
            listEl.scrollBy(0, delta);
          } else if (index2 === anchorIndex) {
            const previousHeightSum = ft2.sum(index2);
            if (height + previousHeightSum > listEl.scrollTop + listEl.offsetHeight) {
              listEl.scrollBy(0, delta);
            }
          }
        }
        syncViewport();
      }
      finweckTreeUpdateTrigger.value++;
    }
    const mayUseWheel = !ensureMaybeTouch();
    let wheelCatched = false;
    function handleListScroll(e25) {
      var _a2;
      (_a2 = props.onScroll) === null || _a2 === void 0 ? void 0 : _a2.call(props, e25);
      if (!mayUseWheel || !wheelCatched) {
        syncViewport();
      }
    }
    function handleListWheel(e25) {
      var _a2;
      (_a2 = props.onWheel) === null || _a2 === void 0 ? void 0 : _a2.call(props, e25);
      if (mayUseWheel) {
        const listEl = listElRef.value;
        if (listEl != null) {
          if (e25.deltaX === 0) {
            if (listEl.scrollTop === 0 && e25.deltaY <= 0) {
              return;
            }
            if (listEl.scrollTop + listEl.offsetHeight >= listEl.scrollHeight && e25.deltaY >= 0) {
              return;
            }
          }
          e25.preventDefault();
          listEl.scrollTop += e25.deltaY / ensureWheelScale();
          listEl.scrollLeft += e25.deltaX / ensureWheelScale();
          syncViewport();
          wheelCatched = true;
          beforeNextFrameOnce(() => {
            wheelCatched = false;
          });
        }
      }
    }
    function handleListResize(entry) {
      if (isDeactivated)
        return;
      if (isHideByVShow(entry.target))
        return;
      if (entry.contentRect.height === listHeightRef.value)
        return;
      listHeightRef.value = entry.contentRect.height;
      const { onResize } = props;
      if (onResize !== void 0)
        onResize(entry);
    }
    function syncViewport() {
      const { value: listEl } = listElRef;
      if (listEl == null)
        return;
      scrollTopRef.value = listEl.scrollTop;
      scrollLeft = listEl.scrollLeft;
    }
    function isHideByVShow(el2) {
      let cursor = el2;
      while (cursor !== null) {
        if (cursor.style.display === "none")
          return true;
        cursor = cursor.parentElement;
      }
      return false;
    }
    return {
      listHeight: listHeightRef,
      listStyle: {
        overflow: "auto"
      },
      keyToIndex: keyIndexMapRef,
      itemsStyle: computed(() => {
        const { itemResizable } = props;
        const height = pxfy(finweckTreeRef.value.sum());
        finweckTreeUpdateTrigger.value;
        return [
          props.itemsStyle,
          {
            boxSizing: "content-box",
            height: itemResizable ? "" : height,
            minHeight: itemResizable ? height : "",
            paddingTop: pxfy(props.paddingTop),
            paddingBottom: pxfy(props.paddingBottom)
          }
        ];
      }),
      visibleItemsStyle: computed(() => {
        finweckTreeUpdateTrigger.value;
        return {
          transform: `translateY(${pxfy(finweckTreeRef.value.sum(startIndexRef.value))})`
        };
      }),
      viewportItems: viewportItemsRef,
      listElRef,
      itemsElRef: ref(null),
      scrollTo,
      handleListResize,
      handleListScroll,
      handleListWheel,
      handleItemResize
    };
  },
  render() {
    const { itemResizable, keyField, keyToIndex, visibleItemsTag } = this;
    return h$1(VResizeObserver, {
      onResize: this.handleListResize
    }, {
      default: () => {
        var _a2, _b2;
        return h$1("div", mergeProps(this.$attrs, {
          class: ["v-vl", this.showScrollbar && "v-vl--show-scrollbar"],
          onScroll: this.handleListScroll,
          onWheel: this.handleListWheel,
          ref: "listElRef"
        }), [
          this.items.length !== 0 ? h$1("div", {
            ref: "itemsElRef",
            class: "v-vl-items",
            style: this.itemsStyle
          }, [
            h$1(visibleItemsTag, Object.assign({
              class: "v-vl-visible-items",
              style: this.visibleItemsStyle
            }, this.visibleItemsProps), {
              default: () => this.viewportItems.map((item) => {
                const key = item[keyField];
                const index2 = keyToIndex.get(key);
                const itemVNode = this.$slots.default({
                  item,
                  index: index2
                })[0];
                if (itemResizable) {
                  return h$1(VResizeObserver, {
                    key,
                    onResize: (entry) => this.handleItemResize(key, entry)
                  }, {
                    default: () => itemVNode
                  });
                }
                itemVNode.key = key;
                return itemVNode;
              })
            })
          ]) : (_b2 = (_a2 = this.$slots).empty) === null || _b2 === void 0 ? void 0 : _b2.call(_a2)
        ]);
      }
    });
  }
});
const styles = c$1(".v-x-scroll", {
  overflow: "auto",
  scrollbarWidth: "none"
}, [
  c$1("&::-webkit-scrollbar", {
    width: 0,
    height: 0
  })
]);
var VXScroll = defineComponent({
  name: "XScroll",
  props: {
    disabled: Boolean,
    onScroll: Function
  },
  setup() {
    const selfRef = ref(null);
    function handleWheel(e25) {
      const preventYWheel = e25.currentTarget.offsetWidth < e25.currentTarget.scrollWidth;
      if (!preventYWheel || e25.deltaY === 0)
        return;
      e25.currentTarget.scrollLeft += e25.deltaY + e25.deltaX;
      e25.preventDefault();
    }
    const ssrAdapter2 = useSsrAdapter();
    styles.mount({
      id: "vueuc/x-scroll",
      head: true,
      anchorMetaName: cssrAnchorMetaName$1,
      ssr: ssrAdapter2
    });
    const exposedMethods = {
      scrollTo(...args) {
        var _a2;
        (_a2 = selfRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollTo(...args);
      }
    };
    return Object.assign({
      selfRef,
      handleWheel
    }, exposedMethods);
  },
  render() {
    return h$1("div", {
      ref: "selfRef",
      onScroll: this.onScroll,
      onWheel: this.disabled ? void 0 : this.handleWheel,
      class: "v-x-scroll"
    }, this.$slots);
  }
});
const hiddenAttr = "v-hidden";
const style$V = c$1("[v-hidden]", {
  display: "none!important"
});
var VOverflow = defineComponent({
  name: "Overflow",
  props: {
    getCounter: Function,
    getTail: Function,
    updateCounter: Function,
    onUpdateOverflow: Function
  },
  setup(props, { slots }) {
    const selfRef = ref(null);
    const counterRef = ref(null);
    function deriveCounter() {
      const { value: self2 } = selfRef;
      const { getCounter, getTail } = props;
      let counter;
      if (getCounter !== void 0)
        counter = getCounter();
      else {
        counter = counterRef.value;
      }
      if (!self2 || !counter)
        return;
      if (counter.hasAttribute(hiddenAttr)) {
        counter.removeAttribute(hiddenAttr);
      }
      const { children } = self2;
      const containerWidth = self2.offsetWidth;
      const childWidths = [];
      const tail = slots.tail ? getTail === null || getTail === void 0 ? void 0 : getTail() : null;
      let childWidthSum = tail ? tail.offsetWidth : 0;
      let overflow = false;
      const len2 = self2.children.length - (slots.tail ? 1 : 0);
      for (let i2 = 0; i2 < len2 - 1; ++i2) {
        if (i2 < 0)
          continue;
        const child = children[i2];
        if (overflow) {
          if (!child.hasAttribute(hiddenAttr)) {
            child.setAttribute(hiddenAttr, "");
          }
          continue;
        } else if (child.hasAttribute(hiddenAttr)) {
          child.removeAttribute(hiddenAttr);
        }
        const childWidth = child.offsetWidth;
        childWidthSum += childWidth;
        childWidths[i2] = childWidth;
        if (childWidthSum > containerWidth) {
          const { updateCounter } = props;
          for (let j2 = i2; j2 >= 0; --j2) {
            const restCount = len2 - 1 - j2;
            if (updateCounter !== void 0) {
              updateCounter(restCount);
            } else {
              counter.textContent = `${restCount}`;
            }
            const counterWidth = counter.offsetWidth;
            childWidthSum -= childWidths[j2];
            if (childWidthSum + counterWidth <= containerWidth || j2 === 0) {
              overflow = true;
              i2 = j2 - 1;
              if (tail) {
                if (i2 === -1) {
                  tail.style.maxWidth = `${containerWidth - counterWidth}px`;
                  tail.style.boxSizing = "border-box";
                } else {
                  tail.style.maxWidth = "";
                }
              }
              break;
            }
          }
        }
      }
      const { onUpdateOverflow } = props;
      if (!overflow) {
        if (onUpdateOverflow !== void 0) {
          onUpdateOverflow(false);
        }
        counter.setAttribute(hiddenAttr, "");
      } else {
        if (onUpdateOverflow !== void 0) {
          onUpdateOverflow(true);
        }
      }
    }
    const ssrAdapter2 = useSsrAdapter();
    style$V.mount({
      id: "vueuc/overflow",
      head: true,
      anchorMetaName: cssrAnchorMetaName$1,
      ssr: ssrAdapter2
    });
    onMounted(deriveCounter);
    return {
      selfRef,
      counterRef,
      sync: deriveCounter
    };
  },
  render() {
    const { $slots } = this;
    nextTick(this.sync);
    return h$1("div", {
      class: "v-overflow",
      ref: "selfRef"
    }, [
      renderSlot($slots, "default"),
      $slots.counter ? $slots.counter() : h$1("span", {
        style: {
          display: "inline-block"
        },
        ref: "counterRef"
      }),
      $slots.tail ? $slots.tail() : null
    ]);
  }
});
function isHTMLElement(node2) {
  return node2 instanceof HTMLElement;
}
function focusFirstDescendant(node2) {
  for (let i2 = 0; i2 < node2.childNodes.length; i2++) {
    const child = node2.childNodes[i2];
    if (isHTMLElement(child)) {
      if (attemptFocus(child) || focusFirstDescendant(child)) {
        return true;
      }
    }
  }
  return false;
}
function focusLastDescendant(element) {
  for (let i2 = element.childNodes.length - 1; i2 >= 0; i2--) {
    const child = element.childNodes[i2];
    if (isHTMLElement(child)) {
      if (attemptFocus(child) || focusLastDescendant(child)) {
        return true;
      }
    }
  }
  return false;
}
function attemptFocus(element) {
  if (!isFocusable(element)) {
    return false;
  }
  try {
    element.focus({ preventScroll: true });
  } catch (e25) {
  }
  return document.activeElement === element;
}
function isFocusable(element) {
  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute("tabIndex") !== null) {
    return true;
  }
  if (element.getAttribute("disabled")) {
    return false;
  }
  switch (element.nodeName) {
    case "A":
      return !!element.href && element.rel !== "ignore";
    case "INPUT":
      return element.type !== "hidden" && element.type !== "file";
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return true;
    default:
      return false;
  }
}
let stack = [];
const FocusTrap = defineComponent({
  name: "FocusTrap",
  props: {
    disabled: Boolean,
    active: Boolean,
    autoFocus: {
      type: Boolean,
      default: true
    },
    onEsc: Function,
    initialFocusTo: String,
    finalFocusTo: String,
    returnFocusOnDeactivated: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const id2 = createId();
    const focusableStartRef = ref(null);
    const focusableEndRef = ref(null);
    let activated = false;
    let ignoreInternalFocusChange = false;
    const lastFocusedElement = typeof document === "undefined" ? null : document.activeElement;
    function isCurrentActive() {
      const currentActiveId = stack[stack.length - 1];
      return currentActiveId === id2;
    }
    function handleDocumentKeydown(e25) {
      var _a2;
      if (e25.code === "Escape") {
        if (isCurrentActive()) {
          (_a2 = props.onEsc) === null || _a2 === void 0 ? void 0 : _a2.call(props, e25);
        }
      }
    }
    onMounted(() => {
      watch(() => props.active, (value2) => {
        if (value2) {
          activate();
          on$1("keydown", document, handleDocumentKeydown);
        } else {
          off("keydown", document, handleDocumentKeydown);
          if (activated) {
            deactivate();
          }
        }
      }, {
        immediate: true
      });
    });
    onBeforeUnmount(() => {
      off("keydown", document, handleDocumentKeydown);
      if (activated)
        deactivate();
    });
    function handleDocumentFocus(e25) {
      if (ignoreInternalFocusChange)
        return;
      if (isCurrentActive()) {
        const mainEl = getMainEl();
        if (mainEl === null)
          return;
        if (mainEl.contains(getPreciseEventTarget(e25)))
          return;
        resetFocusTo("first");
      }
    }
    function getMainEl() {
      const focusableStartEl = focusableStartRef.value;
      if (focusableStartEl === null)
        return null;
      let mainEl = focusableStartEl;
      while (true) {
        mainEl = mainEl.nextSibling;
        if (mainEl === null)
          break;
        if (mainEl instanceof Element && mainEl.tagName === "DIV") {
          break;
        }
      }
      return mainEl;
    }
    function activate() {
      var _a2;
      if (props.disabled)
        return;
      stack.push(id2);
      if (props.autoFocus) {
        const { initialFocusTo } = props;
        if (initialFocusTo === void 0) {
          resetFocusTo("first");
        } else {
          (_a2 = resolveTo(initialFocusTo)) === null || _a2 === void 0 ? void 0 : _a2.focus({ preventScroll: true });
        }
      }
      activated = true;
      document.addEventListener("focus", handleDocumentFocus, true);
    }
    function deactivate() {
      var _a2;
      if (props.disabled)
        return;
      document.removeEventListener("focus", handleDocumentFocus, true);
      stack = stack.filter((idInStack) => idInStack !== id2);
      if (isCurrentActive())
        return;
      const { finalFocusTo } = props;
      if (finalFocusTo !== void 0) {
        (_a2 = resolveTo(finalFocusTo)) === null || _a2 === void 0 ? void 0 : _a2.focus({ preventScroll: true });
      } else if (props.returnFocusOnDeactivated) {
        if (lastFocusedElement instanceof HTMLElement) {
          ignoreInternalFocusChange = true;
          lastFocusedElement.focus({ preventScroll: true });
          ignoreInternalFocusChange = false;
        }
      }
    }
    function resetFocusTo(target) {
      if (!isCurrentActive())
        return;
      if (props.active) {
        const focusableStartEl = focusableStartRef.value;
        const focusableEndEl = focusableEndRef.value;
        if (focusableStartEl !== null && focusableEndEl !== null) {
          const mainEl = getMainEl();
          if (mainEl == null || mainEl === focusableEndEl) {
            ignoreInternalFocusChange = true;
            focusableStartEl.focus({ preventScroll: true });
            ignoreInternalFocusChange = false;
            return;
          }
          ignoreInternalFocusChange = true;
          const focused = target === "first" ? focusFirstDescendant(mainEl) : focusLastDescendant(mainEl);
          ignoreInternalFocusChange = false;
          if (!focused) {
            ignoreInternalFocusChange = true;
            focusableStartEl.focus({ preventScroll: true });
            ignoreInternalFocusChange = false;
          }
        }
      }
    }
    function handleStartFocus(e25) {
      if (ignoreInternalFocusChange)
        return;
      const mainEl = getMainEl();
      if (mainEl === null)
        return;
      if (e25.relatedTarget !== null && mainEl.contains(e25.relatedTarget)) {
        resetFocusTo("last");
      } else {
        resetFocusTo("first");
      }
    }
    function handleEndFocus(e25) {
      if (ignoreInternalFocusChange)
        return;
      if (e25.relatedTarget !== null && e25.relatedTarget === focusableStartRef.value) {
        resetFocusTo("last");
      } else {
        resetFocusTo("first");
      }
    }
    return {
      focusableStartRef,
      focusableEndRef,
      focusableStyle: "position: absolute; height: 0; width: 0;",
      handleStartFocus,
      handleEndFocus
    };
  },
  render() {
    const { default: defaultSlot } = this.$slots;
    if (defaultSlot === void 0)
      return null;
    if (this.disabled)
      return defaultSlot();
    const { active, focusableStyle } = this;
    return h$1(Fragment, null, [
      h$1("div", {
        "aria-hidden": "true",
        tabindex: active ? "0" : "-1",
        ref: "focusableStartRef",
        style: focusableStyle,
        onFocus: this.handleStartFocus
      }),
      defaultSlot(),
      h$1("div", {
        "aria-hidden": "true",
        style: focusableStyle,
        ref: "focusableEndRef",
        tabindex: active ? "0" : "-1",
        onFocus: this.handleEndFocus
      })
    ]);
  }
});
function useOnResize(elRef, onResize) {
  if (onResize) {
    onMounted(() => {
      const { value: el2 } = elRef;
      if (el2) {
        resizeObserverManager.registerHandler(el2, onResize);
      }
    });
    onBeforeUnmount(() => {
      const { value: el2 } = elRef;
      if (el2) {
        resizeObserverManager.unregisterHandler(el2);
      }
    });
  }
}
let lockCount = 0;
let originalMarginRight = "";
let originalOverflow = "";
let originalOverflowX = "";
let originalOverflowY = "";
const lockHtmlScrollRightCompensationRef = ref("0px");
function useLockHtmlScroll(lockRef) {
  if (typeof document === "undefined")
    return;
  const el2 = document.documentElement;
  let watchStopHandle;
  let activated = false;
  const unlock = () => {
    el2.style.marginRight = originalMarginRight;
    el2.style.overflow = originalOverflow;
    el2.style.overflowX = originalOverflowX;
    el2.style.overflowY = originalOverflowY;
    lockHtmlScrollRightCompensationRef.value = "0px";
  };
  onMounted(() => {
    watchStopHandle = watch(lockRef, (value2) => {
      if (value2) {
        if (!lockCount) {
          const scrollbarWidth = window.innerWidth - el2.offsetWidth;
          if (scrollbarWidth > 0) {
            originalMarginRight = el2.style.marginRight;
            el2.style.marginRight = `${scrollbarWidth}px`;
            lockHtmlScrollRightCompensationRef.value = `${scrollbarWidth}px`;
          }
          originalOverflow = el2.style.overflow;
          originalOverflowX = el2.style.overflowX;
          originalOverflowY = el2.style.overflowY;
          el2.style.overflow = "hidden";
          el2.style.overflowX = "hidden";
          el2.style.overflowY = "hidden";
        }
        activated = true;
        lockCount++;
      } else {
        lockCount--;
        if (!lockCount) {
          unlock();
        }
        activated = false;
      }
    }, {
      immediate: true
    });
  });
  onBeforeUnmount(() => {
    watchStopHandle === null || watchStopHandle === void 0 ? void 0 : watchStopHandle();
    if (activated) {
      lockCount--;
      if (!lockCount) {
        unlock();
      }
      activated = false;
    }
  });
}
const isComposingRef = ref(false);
const compositionStartHandler = () => {
  isComposingRef.value = true;
};
const compositionEndHandler = () => {
  isComposingRef.value = false;
};
let mountedCount = 0;
const useIsComposing = () => {
  if (isBrowser$2) {
    onBeforeMount(() => {
      if (!mountedCount) {
        window.addEventListener("compositionstart", compositionStartHandler);
        window.addEventListener("compositionend", compositionEndHandler);
      }
      mountedCount++;
    });
    onBeforeUnmount(() => {
      if (mountedCount <= 1) {
        window.removeEventListener("compositionstart", compositionStartHandler);
        window.removeEventListener("compositionend", compositionEndHandler);
        mountedCount = 0;
      } else {
        mountedCount--;
      }
    });
  }
  return isComposingRef;
};
function useReactivated(callback) {
  const isDeactivatedRef = { isDeactivated: false };
  let activateStateInitialized = false;
  onActivated(() => {
    isDeactivatedRef.isDeactivated = false;
    if (!activateStateInitialized) {
      activateStateInitialized = true;
      return;
    }
    callback();
  });
  onDeactivated(() => {
    isDeactivatedRef.isDeactivated = true;
    if (!activateStateInitialized) {
      activateStateInitialized = true;
    }
  });
  return isDeactivatedRef;
}
const formItemInjectionKey = createInjectionKey("n-form-item");
function useFormItem(props, { defaultSize = "medium", mergedSize, mergedDisabled } = {}) {
  const NFormItem2 = inject(formItemInjectionKey, null);
  provide(formItemInjectionKey, null);
  const mergedSizeRef = computed(mergedSize ? () => mergedSize(NFormItem2) : () => {
    const { size: size2 } = props;
    if (size2)
      return size2;
    if (NFormItem2) {
      const { mergedSize: mergedSize2 } = NFormItem2;
      if (mergedSize2.value !== void 0) {
        return mergedSize2.value;
      }
    }
    return defaultSize;
  });
  const mergedDisabledRef = computed(mergedDisabled ? () => mergedDisabled(NFormItem2) : () => {
    const { disabled } = props;
    if (disabled !== void 0) {
      return disabled;
    }
    if (NFormItem2) {
      return NFormItem2.disabled.value;
    }
    return false;
  });
  const mergedStatusRef = computed(() => {
    const { status } = props;
    if (status)
      return status;
    return NFormItem2 === null || NFormItem2 === void 0 ? void 0 : NFormItem2.mergedValidationStatus.value;
  });
  onBeforeUnmount(() => {
    if (NFormItem2) {
      NFormItem2.restoreValidation();
    }
  });
  return {
    mergedSizeRef,
    mergedDisabledRef,
    mergedStatusRef,
    nTriggerFormBlur() {
      if (NFormItem2) {
        NFormItem2.handleContentBlur();
      }
    },
    nTriggerFormChange() {
      if (NFormItem2) {
        NFormItem2.handleContentChange();
      }
    },
    nTriggerFormFocus() {
      if (NFormItem2) {
        NFormItem2.handleContentFocus();
      }
    },
    nTriggerFormInput() {
      if (NFormItem2) {
        NFormItem2.handleContentInput();
      }
    }
  };
}
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal$1 = freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal$1 || freeSelf || Function("return this")();
var root$1 = root;
var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;
var objectProto$e = Object.prototype;
var hasOwnProperty$f = objectProto$e.hasOwnProperty;
var nativeObjectToString$1 = objectProto$e.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag(value2) {
  var isOwn = hasOwnProperty$f.call(value2, symToStringTag$1), tag = value2[symToStringTag$1];
  try {
    value2[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e25) {
  }
  var result2 = nativeObjectToString$1.call(value2);
  if (unmasked) {
    if (isOwn) {
      value2[symToStringTag$1] = tag;
    } else {
      delete value2[symToStringTag$1];
    }
  }
  return result2;
}
var objectProto$d = Object.prototype;
var nativeObjectToString = objectProto$d.toString;
function objectToString(value2) {
  return nativeObjectToString.call(value2);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag(value2) {
  if (value2 == null) {
    return value2 === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value2) ? getRawTag(value2) : objectToString(value2);
}
function isObjectLike(value2) {
  return value2 != null && typeof value2 == "object";
}
var symbolTag$1 = "[object Symbol]";
function isSymbol(value2) {
  return typeof value2 == "symbol" || isObjectLike(value2) && baseGetTag(value2) == symbolTag$1;
}
function arrayMap(array4, iteratee) {
  var index2 = -1, length2 = array4 == null ? 0 : array4.length, result2 = Array(length2);
  while (++index2 < length2) {
    result2[index2] = iteratee(array4[index2], index2, array4);
  }
  return result2;
}
var isArray = Array.isArray;
var isArray$1 = isArray;
var INFINITY$2 = 1 / 0;
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString(value2) {
  if (typeof value2 == "string") {
    return value2;
  }
  if (isArray$1(value2)) {
    return arrayMap(value2, baseToString) + "";
  }
  if (isSymbol(value2)) {
    return symbolToString ? symbolToString.call(value2) : "";
  }
  var result2 = value2 + "";
  return result2 == "0" && 1 / value2 == -INFINITY$2 ? "-0" : result2;
}
var reWhitespace = /\s/;
function trimmedEndIndex(string3) {
  var index2 = string3.length;
  while (index2-- && reWhitespace.test(string3.charAt(index2))) {
  }
  return index2;
}
var reTrimStart = /^\s+/;
function baseTrim(string3) {
  return string3 ? string3.slice(0, trimmedEndIndex(string3) + 1).replace(reTrimStart, "") : string3;
}
function isObject$1(value2) {
  var type4 = typeof value2;
  return value2 != null && (type4 == "object" || type4 == "function");
}
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value2) {
  if (typeof value2 == "number") {
    return value2;
  }
  if (isSymbol(value2)) {
    return NAN;
  }
  if (isObject$1(value2)) {
    var other = typeof value2.valueOf == "function" ? value2.valueOf() : value2;
    value2 = isObject$1(other) ? other + "" : other;
  }
  if (typeof value2 != "string") {
    return value2 === 0 ? value2 : +value2;
  }
  value2 = baseTrim(value2);
  var isBinary = reIsBinary.test(value2);
  return isBinary || reIsOctal.test(value2) ? freeParseInt(value2.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value2) ? NAN : +value2;
}
function identity(value2) {
  return value2;
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction(value2) {
  if (!isObject$1(value2)) {
    return false;
  }
  var tag = baseGetTag(value2);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root$1["__core-js_shared__"];
var coreJsData$1 = coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e25) {
    }
    try {
      return func + "";
    } catch (e25) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$c = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$e = objectProto$c.hasOwnProperty;
var reIsNative = RegExp("^" + funcToString$1.call(hasOwnProperty$e).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function baseIsNative(value2) {
  if (!isObject$1(value2) || isMasked(value2)) {
    return false;
  }
  var pattern4 = isFunction(value2) ? reIsNative : reIsHostCtor;
  return pattern4.test(toSource(value2));
}
function getValue$1(object4, key) {
  return object4 == null ? void 0 : object4[key];
}
function getNative(object4, key) {
  var value2 = getValue$1(object4, key);
  return baseIsNative(value2) ? value2 : void 0;
}
var WeakMap$1 = getNative(root$1, "WeakMap");
var WeakMap$2 = WeakMap$1;
var objectCreate = Object.create;
var baseCreate = function() {
  function object4() {
  }
  return function(proto) {
    if (!isObject$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object4.prototype = proto;
    var result2 = new object4();
    object4.prototype = void 0;
    return result2;
  };
}();
var baseCreate$1 = baseCreate;
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
function copyArray(source, array4) {
  var index2 = -1, length2 = source.length;
  array4 || (array4 = Array(length2));
  while (++index2 < length2) {
    array4[index2] = source[index2];
  }
  return array4;
}
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
function constant(value2) {
  return function() {
    return value2;
  };
}
var defineProperty = function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e25) {
  }
}();
var defineProperty$1 = defineProperty;
var baseSetToString = !defineProperty$1 ? identity : function(func, string3) {
  return defineProperty$1(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string3),
    "writable": true
  });
};
var baseSetToString$1 = baseSetToString;
var setToString = shortOut(baseSetToString$1);
var setToString$1 = setToString;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value2, length2) {
  var type4 = typeof value2;
  length2 = length2 == null ? MAX_SAFE_INTEGER$1 : length2;
  return !!length2 && (type4 == "number" || type4 != "symbol" && reIsUint.test(value2)) && (value2 > -1 && value2 % 1 == 0 && value2 < length2);
}
function baseAssignValue(object4, key, value2) {
  if (key == "__proto__" && defineProperty$1) {
    defineProperty$1(object4, key, {
      "configurable": true,
      "enumerable": true,
      "value": value2,
      "writable": true
    });
  } else {
    object4[key] = value2;
  }
}
function eq(value2, other) {
  return value2 === other || value2 !== value2 && other !== other;
}
var objectProto$b = Object.prototype;
var hasOwnProperty$d = objectProto$b.hasOwnProperty;
function assignValue(object4, key, value2) {
  var objValue = object4[key];
  if (!(hasOwnProperty$d.call(object4, key) && eq(objValue, value2)) || value2 === void 0 && !(key in object4)) {
    baseAssignValue(object4, key, value2);
  }
}
function copyObject(source, props, object4, customizer) {
  var isNew = !object4;
  object4 || (object4 = {});
  var index2 = -1, length2 = props.length;
  while (++index2 < length2) {
    var key = props[index2];
    var newValue = customizer ? customizer(object4[key], source[key], key, object4, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object4, key, newValue);
    } else {
      assignValue(object4, key, newValue);
    }
  }
  return object4;
}
var nativeMax$1 = Math.max;
function overRest(func, start, transform) {
  start = nativeMax$1(start === void 0 ? func.length - 1 : start, 0);
  return function() {
    var args = arguments, index2 = -1, length2 = nativeMax$1(args.length - start, 0), array4 = Array(length2);
    while (++index2 < length2) {
      array4[index2] = args[start + index2];
    }
    index2 = -1;
    var otherArgs = Array(start + 1);
    while (++index2 < start) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start] = transform(array4);
    return apply(func, this, otherArgs);
  };
}
function baseRest(func, start) {
  return setToString$1(overRest(func, start, identity), func + "");
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value2) {
  return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER;
}
function isArrayLike(value2) {
  return value2 != null && isLength(value2.length) && !isFunction(value2);
}
function isIterateeCall(value2, index2, object4) {
  if (!isObject$1(object4)) {
    return false;
  }
  var type4 = typeof index2;
  if (type4 == "number" ? isArrayLike(object4) && isIndex(index2, object4.length) : type4 == "string" && index2 in object4) {
    return eq(object4[index2], value2);
  }
  return false;
}
function createAssigner(assigner) {
  return baseRest(function(object4, sources) {
    var index2 = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : void 0, guard = length2 > 2 ? sources[2] : void 0;
    customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : void 0;
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length2 < 3 ? void 0 : customizer;
      length2 = 1;
    }
    object4 = Object(object4);
    while (++index2 < length2) {
      var source = sources[index2];
      if (source) {
        assigner(object4, source, index2, customizer);
      }
    }
    return object4;
  });
}
var objectProto$a = Object.prototype;
function isPrototype(value2) {
  var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$a;
  return value2 === proto;
}
function baseTimes(n2, iteratee) {
  var index2 = -1, result2 = Array(n2);
  while (++index2 < n2) {
    result2[index2] = iteratee(index2);
  }
  return result2;
}
var argsTag$2 = "[object Arguments]";
function baseIsArguments(value2) {
  return isObjectLike(value2) && baseGetTag(value2) == argsTag$2;
}
var objectProto$9 = Object.prototype;
var hasOwnProperty$c = objectProto$9.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;
var isArguments = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value2) {
  return isObjectLike(value2) && hasOwnProperty$c.call(value2, "callee") && !propertyIsEnumerable$1.call(value2, "callee");
};
var isArguments$1 = isArguments;
function stubFalse() {
  return false;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$2 = moduleExports$2 ? root$1.Buffer : void 0;
var nativeIsBuffer = Buffer$2 ? Buffer$2.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$3 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray(value2) {
  return isObjectLike(value2) && isLength(value2.length) && !!typedArrayTags[baseGetTag(value2)];
}
function baseUnary(func) {
  return function(value2) {
    return func(value2);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal$1.process;
var nodeUtil = function() {
  try {
    var types2 = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    if (types2) {
      return types2;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e25) {
  }
}();
var nodeUtil$1 = nodeUtil;
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;
var objectProto$8 = Object.prototype;
var hasOwnProperty$b = objectProto$8.hasOwnProperty;
function arrayLikeKeys(value2, inherited) {
  var isArr = isArray$1(value2), isArg = !isArr && isArguments$1(value2), isBuff = !isArr && !isArg && isBuffer$1(value2), isType2 = !isArr && !isArg && !isBuff && isTypedArray$1(value2), skipIndexes = isArr || isArg || isBuff || isType2, result2 = skipIndexes ? baseTimes(value2.length, String) : [], length2 = result2.length;
  for (var key in value2) {
    if ((inherited || hasOwnProperty$b.call(value2, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType2 && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length2)))) {
      result2.push(key);
    }
  }
  return result2;
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;
var objectProto$7 = Object.prototype;
var hasOwnProperty$a = objectProto$7.hasOwnProperty;
function baseKeys(object4) {
  if (!isPrototype(object4)) {
    return nativeKeys$1(object4);
  }
  var result2 = [];
  for (var key in Object(object4)) {
    if (hasOwnProperty$a.call(object4, key) && key != "constructor") {
      result2.push(key);
    }
  }
  return result2;
}
function keys$1(object4) {
  return isArrayLike(object4) ? arrayLikeKeys(object4) : baseKeys(object4);
}
function nativeKeysIn(object4) {
  var result2 = [];
  if (object4 != null) {
    for (var key in Object(object4)) {
      result2.push(key);
    }
  }
  return result2;
}
var objectProto$6 = Object.prototype;
var hasOwnProperty$9 = objectProto$6.hasOwnProperty;
function baseKeysIn(object4) {
  if (!isObject$1(object4)) {
    return nativeKeysIn(object4);
  }
  var isProto = isPrototype(object4), result2 = [];
  for (var key in object4) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$9.call(object4, key)))) {
      result2.push(key);
    }
  }
  return result2;
}
function keysIn(object4) {
  return isArrayLike(object4) ? arrayLikeKeys(object4, true) : baseKeysIn(object4);
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(value2, object4) {
  if (isArray$1(value2)) {
    return false;
  }
  var type4 = typeof value2;
  if (type4 == "number" || type4 == "symbol" || type4 == "boolean" || value2 == null || isSymbol(value2)) {
    return true;
  }
  return reIsPlainProp.test(value2) || !reIsDeepProp.test(value2) || object4 != null && value2 in Object(object4);
}
var nativeCreate = getNative(Object, "create");
var nativeCreate$1 = nativeCreate;
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}
function hashDelete(key) {
  var result2 = this.has(key) && delete this.__data__[key];
  this.size -= result2 ? 1 : 0;
  return result2;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$5 = Object.prototype;
var hasOwnProperty$8 = objectProto$5.hasOwnProperty;
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate$1) {
    var result2 = data[key];
    return result2 === HASH_UNDEFINED$2 ? void 0 : result2;
  }
  return hasOwnProperty$8.call(data, key) ? data[key] : void 0;
}
var objectProto$4 = Object.prototype;
var hasOwnProperty$7 = objectProto$4.hasOwnProperty;
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$7.call(data, key);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key, value2) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value2 === void 0 ? HASH_UNDEFINED$1 : value2;
  return this;
}
function Hash$2(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$2.prototype.clear = hashClear;
Hash$2.prototype["delete"] = hashDelete;
Hash$2.prototype.get = hashGet;
Hash$2.prototype.has = hashHas;
Hash$2.prototype.set = hashSet;
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function assocIndexOf(array4, key) {
  var length2 = array4.length;
  while (length2--) {
    if (eq(array4[length2][0], key)) {
      return length2;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index2, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  return index2 < 0 ? void 0 : data[index2][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value2) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    ++this.size;
    data.push([key, value2]);
  } else {
    data[index2][1] = value2;
  }
  return this;
}
function ListCache(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
var Map$1 = getNative(root$1, "Map");
var Map$2 = Map$1;
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash$2(),
    "map": new (Map$2 || ListCache)(),
    "string": new Hash$2()
  };
}
function isKeyable(value2) {
  var type4 = typeof value2;
  return type4 == "string" || type4 == "number" || type4 == "symbol" || type4 == "boolean" ? value2 !== "__proto__" : value2 === null;
}
function getMapData(map2, key) {
  var data = map2.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function mapCacheDelete(key) {
  var result2 = getMapData(this, key)["delete"](key);
  this.size -= result2 ? 1 : 0;
  return result2;
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value2) {
  var data = getMapData(this, key), size2 = data.size;
  data.set(key, value2);
  this.size += data.size == size2 ? 0 : 1;
  return this;
}
function MapCache(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var FUNC_ERROR_TEXT$2 = "Expected a function";
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key)) {
      return cache2.get(key);
    }
    var result2 = func.apply(this, args);
    memoized.cache = cache2.set(key, result2) || cache2;
    return result2;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result2 = memoize(func, function(key) {
    if (cache2.size === MAX_MEMOIZE_SIZE) {
      cache2.clear();
    }
    return key;
  });
  var cache2 = result2.cache;
  return result2;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped(function(string3) {
  var result2 = [];
  if (string3.charCodeAt(0) === 46) {
    result2.push("");
  }
  string3.replace(rePropName, function(match2, number4, quote, subString) {
    result2.push(quote ? subString.replace(reEscapeChar, "$1") : number4 || match2);
  });
  return result2;
});
var stringToPath$1 = stringToPath;
function toString(value2) {
  return value2 == null ? "" : baseToString(value2);
}
function castPath(value2, object4) {
  if (isArray$1(value2)) {
    return value2;
  }
  return isKey(value2, object4) ? [value2] : stringToPath$1(toString(value2));
}
var INFINITY$1 = 1 / 0;
function toKey(value2) {
  if (typeof value2 == "string" || isSymbol(value2)) {
    return value2;
  }
  var result2 = value2 + "";
  return result2 == "0" && 1 / value2 == -INFINITY$1 ? "-0" : result2;
}
function baseGet(object4, path) {
  path = castPath(path, object4);
  var index2 = 0, length2 = path.length;
  while (object4 != null && index2 < length2) {
    object4 = object4[toKey(path[index2++])];
  }
  return index2 && index2 == length2 ? object4 : void 0;
}
function get(object4, path, defaultValue) {
  var result2 = object4 == null ? void 0 : baseGet(object4, path);
  return result2 === void 0 ? defaultValue : result2;
}
function arrayPush(array4, values2) {
  var index2 = -1, length2 = values2.length, offset = array4.length;
  while (++index2 < length2) {
    array4[offset + index2] = values2[index2];
  }
  return array4;
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;
var objectTag$2 = "[object Object]";
var funcProto = Function.prototype, objectProto$3 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$6 = objectProto$3.hasOwnProperty;
var objectCtorString = funcToString.call(Object);
function isPlainObject(value2) {
  if (!isObjectLike(value2) || baseGetTag(value2) != objectTag$2) {
    return false;
  }
  var proto = getPrototype$1(value2);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$6.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
function baseSlice(array4, start, end) {
  var index2 = -1, length2 = array4.length;
  if (start < 0) {
    start = -start > length2 ? 0 : length2 + start;
  }
  end = end > length2 ? length2 : end;
  if (end < 0) {
    end += length2;
  }
  length2 = start > end ? 0 : end - start >>> 0;
  start >>>= 0;
  var result2 = Array(length2);
  while (++index2 < length2) {
    result2[index2] = array4[index2 + start];
  }
  return result2;
}
function castSlice(array4, start, end) {
  var length2 = array4.length;
  end = end === void 0 ? length2 : end;
  return !start && end >= length2 ? array4 : baseSlice(array4, start, end);
}
var rsAstralRange$2 = "\\ud800-\\udfff", rsComboMarksRange$3 = "\\u0300-\\u036f", reComboHalfMarksRange$3 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$3 = "\\u20d0-\\u20ff", rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3, rsVarRange$2 = "\\ufe0e\\ufe0f";
var rsZWJ$2 = "\\u200d";
var reHasUnicode = RegExp("[" + rsZWJ$2 + rsAstralRange$2 + rsComboRange$3 + rsVarRange$2 + "]");
function hasUnicode(string3) {
  return reHasUnicode.test(string3);
}
function asciiToArray(string3) {
  return string3.split("");
}
var rsAstralRange$1 = "\\ud800-\\udfff", rsComboMarksRange$2 = "\\u0300-\\u036f", reComboHalfMarksRange$2 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$2 = "\\u20d0-\\u20ff", rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2, rsVarRange$1 = "\\ufe0e\\ufe0f";
var rsAstral = "[" + rsAstralRange$1 + "]", rsCombo$2 = "[" + rsComboRange$2 + "]", rsFitz$1 = "\\ud83c[\\udffb-\\udfff]", rsModifier$1 = "(?:" + rsCombo$2 + "|" + rsFitz$1 + ")", rsNonAstral$1 = "[^" + rsAstralRange$1 + "]", rsRegional$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsZWJ$1 = "\\u200d";
var reOptMod$1 = rsModifier$1 + "?", rsOptVar$1 = "[" + rsVarRange$1 + "]?", rsOptJoin$1 = "(?:" + rsZWJ$1 + "(?:" + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join("|") + ")" + rsOptVar$1 + reOptMod$1 + ")*", rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1, rsSymbol = "(?:" + [rsNonAstral$1 + rsCombo$2 + "?", rsCombo$2, rsRegional$1, rsSurrPair$1, rsAstral].join("|") + ")";
var reUnicode = RegExp(rsFitz$1 + "(?=" + rsFitz$1 + ")|" + rsSymbol + rsSeq$1, "g");
function unicodeToArray(string3) {
  return string3.match(reUnicode) || [];
}
function stringToArray(string3) {
  return hasUnicode(string3) ? unicodeToArray(string3) : asciiToArray(string3);
}
function createCaseFirst(methodName) {
  return function(string3) {
    string3 = toString(string3);
    var strSymbols = hasUnicode(string3) ? stringToArray(string3) : void 0;
    var chr = strSymbols ? strSymbols[0] : string3.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string3.slice(1);
    return chr[methodName]() + trailing;
  };
}
var upperFirst = createCaseFirst("toUpperCase");
var upperFirst$1 = upperFirst;
function capitalize(string3) {
  return upperFirst$1(toString(string3).toLowerCase());
}
function arrayReduce(array4, iteratee, accumulator, initAccum) {
  var index2 = -1, length2 = array4 == null ? 0 : array4.length;
  if (initAccum && length2) {
    accumulator = array4[++index2];
  }
  while (++index2 < length2) {
    accumulator = iteratee(accumulator, array4[index2], index2, array4);
  }
  return accumulator;
}
function basePropertyOf(object4) {
  return function(key) {
    return object4 == null ? void 0 : object4[key];
  };
}
var deburredLetters = {
  "\xC0": "A",
  "\xC1": "A",
  "\xC2": "A",
  "\xC3": "A",
  "\xC4": "A",
  "\xC5": "A",
  "\xE0": "a",
  "\xE1": "a",
  "\xE2": "a",
  "\xE3": "a",
  "\xE4": "a",
  "\xE5": "a",
  "\xC7": "C",
  "\xE7": "c",
  "\xD0": "D",
  "\xF0": "d",
  "\xC8": "E",
  "\xC9": "E",
  "\xCA": "E",
  "\xCB": "E",
  "\xE8": "e",
  "\xE9": "e",
  "\xEA": "e",
  "\xEB": "e",
  "\xCC": "I",
  "\xCD": "I",
  "\xCE": "I",
  "\xCF": "I",
  "\xEC": "i",
  "\xED": "i",
  "\xEE": "i",
  "\xEF": "i",
  "\xD1": "N",
  "\xF1": "n",
  "\xD2": "O",
  "\xD3": "O",
  "\xD4": "O",
  "\xD5": "O",
  "\xD6": "O",
  "\xD8": "O",
  "\xF2": "o",
  "\xF3": "o",
  "\xF4": "o",
  "\xF5": "o",
  "\xF6": "o",
  "\xF8": "o",
  "\xD9": "U",
  "\xDA": "U",
  "\xDB": "U",
  "\xDC": "U",
  "\xF9": "u",
  "\xFA": "u",
  "\xFB": "u",
  "\xFC": "u",
  "\xDD": "Y",
  "\xFD": "y",
  "\xFF": "y",
  "\xC6": "Ae",
  "\xE6": "ae",
  "\xDE": "Th",
  "\xFE": "th",
  "\xDF": "ss",
  "\u0100": "A",
  "\u0102": "A",
  "\u0104": "A",
  "\u0101": "a",
  "\u0103": "a",
  "\u0105": "a",
  "\u0106": "C",
  "\u0108": "C",
  "\u010A": "C",
  "\u010C": "C",
  "\u0107": "c",
  "\u0109": "c",
  "\u010B": "c",
  "\u010D": "c",
  "\u010E": "D",
  "\u0110": "D",
  "\u010F": "d",
  "\u0111": "d",
  "\u0112": "E",
  "\u0114": "E",
  "\u0116": "E",
  "\u0118": "E",
  "\u011A": "E",
  "\u0113": "e",
  "\u0115": "e",
  "\u0117": "e",
  "\u0119": "e",
  "\u011B": "e",
  "\u011C": "G",
  "\u011E": "G",
  "\u0120": "G",
  "\u0122": "G",
  "\u011D": "g",
  "\u011F": "g",
  "\u0121": "g",
  "\u0123": "g",
  "\u0124": "H",
  "\u0126": "H",
  "\u0125": "h",
  "\u0127": "h",
  "\u0128": "I",
  "\u012A": "I",
  "\u012C": "I",
  "\u012E": "I",
  "\u0130": "I",
  "\u0129": "i",
  "\u012B": "i",
  "\u012D": "i",
  "\u012F": "i",
  "\u0131": "i",
  "\u0134": "J",
  "\u0135": "j",
  "\u0136": "K",
  "\u0137": "k",
  "\u0138": "k",
  "\u0139": "L",
  "\u013B": "L",
  "\u013D": "L",
  "\u013F": "L",
  "\u0141": "L",
  "\u013A": "l",
  "\u013C": "l",
  "\u013E": "l",
  "\u0140": "l",
  "\u0142": "l",
  "\u0143": "N",
  "\u0145": "N",
  "\u0147": "N",
  "\u014A": "N",
  "\u0144": "n",
  "\u0146": "n",
  "\u0148": "n",
  "\u014B": "n",
  "\u014C": "O",
  "\u014E": "O",
  "\u0150": "O",
  "\u014D": "o",
  "\u014F": "o",
  "\u0151": "o",
  "\u0154": "R",
  "\u0156": "R",
  "\u0158": "R",
  "\u0155": "r",
  "\u0157": "r",
  "\u0159": "r",
  "\u015A": "S",
  "\u015C": "S",
  "\u015E": "S",
  "\u0160": "S",
  "\u015B": "s",
  "\u015D": "s",
  "\u015F": "s",
  "\u0161": "s",
  "\u0162": "T",
  "\u0164": "T",
  "\u0166": "T",
  "\u0163": "t",
  "\u0165": "t",
  "\u0167": "t",
  "\u0168": "U",
  "\u016A": "U",
  "\u016C": "U",
  "\u016E": "U",
  "\u0170": "U",
  "\u0172": "U",
  "\u0169": "u",
  "\u016B": "u",
  "\u016D": "u",
  "\u016F": "u",
  "\u0171": "u",
  "\u0173": "u",
  "\u0174": "W",
  "\u0175": "w",
  "\u0176": "Y",
  "\u0177": "y",
  "\u0178": "Y",
  "\u0179": "Z",
  "\u017B": "Z",
  "\u017D": "Z",
  "\u017A": "z",
  "\u017C": "z",
  "\u017E": "z",
  "\u0132": "IJ",
  "\u0133": "ij",
  "\u0152": "Oe",
  "\u0153": "oe",
  "\u0149": "'n",
  "\u017F": "s"
};
var deburrLetter = basePropertyOf(deburredLetters);
var deburrLetter$1 = deburrLetter;
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
var rsComboMarksRange$1 = "\\u0300-\\u036f", reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$1 = "\\u20d0-\\u20ff", rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
var rsCombo$1 = "[" + rsComboRange$1 + "]";
var reComboMark = RegExp(rsCombo$1, "g");
function deburr(string3) {
  string3 = toString(string3);
  return string3 && string3.replace(reLatin, deburrLetter$1).replace(reComboMark, "");
}
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function asciiWords(string3) {
  return string3.match(reAsciiWord) || [];
}
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function hasUnicodeWord(string3) {
  return reHasUnicodeWord.test(string3);
}
var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
var rsApos$1 = "['\u2019]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos$1 + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos$1 + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq;
var reUnicodeWord = RegExp([
  rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
  rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
  rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
  rsUpper + "+" + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join("|"), "g");
function unicodeWords(string3) {
  return string3.match(reUnicodeWord) || [];
}
function words(string3, pattern4, guard) {
  string3 = toString(string3);
  pattern4 = guard ? void 0 : pattern4;
  if (pattern4 === void 0) {
    return hasUnicodeWord(string3) ? unicodeWords(string3) : asciiWords(string3);
  }
  return string3.match(pattern4) || [];
}
var rsApos = "['\u2019]";
var reApos = RegExp(rsApos, "g");
function createCompounder(callback) {
  return function(string3) {
    return arrayReduce(words(deburr(string3).replace(reApos, "")), callback, "");
  };
}
var camelCase = createCompounder(function(result2, word, index2) {
  word = word.toLowerCase();
  return result2 + (index2 ? capitalize(word) : word);
});
var camelCase$1 = camelCase;
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key) {
  var data = this.__data__, result2 = data["delete"](key);
  this.size = data.size;
  return result2;
}
function stackGet(key) {
  return this.__data__.get(key);
}
function stackHas(key) {
  return this.__data__.has(key);
}
var LARGE_ARRAY_SIZE = 200;
function stackSet(key, value2) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value2]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value2);
  this.size = data.size;
  return this;
}
function Stack$1(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack$1.prototype.clear = stackClear;
Stack$1.prototype["delete"] = stackDelete;
Stack$1.prototype.get = stackGet;
Stack$1.prototype.has = stackHas;
Stack$1.prototype.set = stackSet;
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer$1 = moduleExports ? root$1.Buffer : void 0, allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : void 0;
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length2 = buffer.length, result2 = allocUnsafe ? allocUnsafe(length2) : new buffer.constructor(length2);
  buffer.copy(result2);
  return result2;
}
function arrayFilter(array4, predicate) {
  var index2 = -1, length2 = array4 == null ? 0 : array4.length, resIndex = 0, result2 = [];
  while (++index2 < length2) {
    var value2 = array4[index2];
    if (predicate(value2, index2, array4)) {
      result2[resIndex++] = value2;
    }
  }
  return result2;
}
function stubArray() {
  return [];
}
var objectProto$2 = Object.prototype;
var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols ? stubArray : function(object4) {
  if (object4 == null) {
    return [];
  }
  object4 = Object(object4);
  return arrayFilter(nativeGetSymbols(object4), function(symbol) {
    return propertyIsEnumerable.call(object4, symbol);
  });
};
var getSymbols$1 = getSymbols;
function baseGetAllKeys(object4, keysFunc, symbolsFunc) {
  var result2 = keysFunc(object4);
  return isArray$1(object4) ? result2 : arrayPush(result2, symbolsFunc(object4));
}
function getAllKeys(object4) {
  return baseGetAllKeys(object4, keys$1, getSymbols$1);
}
var DataView$1 = getNative(root$1, "DataView");
var DataView$2 = DataView$1;
var Promise$1 = getNative(root$1, "Promise");
var Promise$2 = Promise$1;
var Set$1 = getNative(root$1, "Set");
var Set$2 = Set$1;
var mapTag$1 = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag$1 = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag$1 = "[object DataView]";
var dataViewCtorString = toSource(DataView$2), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$2), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$2);
var getTag = baseGetTag;
if (DataView$2 && getTag(new DataView$2(new ArrayBuffer(1))) != dataViewTag$1 || Map$2 && getTag(new Map$2()) != mapTag$1 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$1 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag) {
  getTag = function(value2) {
    var result2 = baseGetTag(value2), Ctor = result2 == objectTag$1 ? value2.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$1;
        case mapCtorString:
          return mapTag$1;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$1;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result2;
  };
}
var getTag$1 = getTag;
var Uint8Array$1 = root$1.Uint8Array;
var Uint8Array$2 = Uint8Array$1;
function cloneArrayBuffer(arrayBuffer) {
  var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result2).set(new Uint8Array$2(arrayBuffer));
  return result2;
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
function initCloneObject(object4) {
  return typeof object4.constructor == "function" && !isPrototype(object4) ? baseCreate$1(getPrototype$1(object4)) : {};
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value2) {
  this.__data__.set(value2, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value2) {
  return this.__data__.has(value2);
}
function SetCache(values2) {
  var index2 = -1, length2 = values2 == null ? 0 : values2.length;
  this.__data__ = new MapCache();
  while (++index2 < length2) {
    this.add(values2[index2]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array4, predicate) {
  var index2 = -1, length2 = array4 == null ? 0 : array4.length;
  while (++index2 < length2) {
    if (predicate(array4[index2], index2, array4)) {
      return true;
    }
  }
  return false;
}
function cacheHas(cache2, key) {
  return cache2.has(key);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(array4, other, bitmask, customizer, equalFunc, stack2) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array4.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack2.get(array4);
  var othStacked = stack2.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array4;
  }
  var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack2.set(array4, other);
  stack2.set(other, array4);
  while (++index2 < arrLength) {
    var arrValue = array4[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array4, stack2) : customizer(arrValue, othValue, index2, array4, other, stack2);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result2 = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack2))) {
          return seen.push(othIndex);
        }
      })) {
        result2 = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack2))) {
      result2 = false;
      break;
    }
  }
  stack2["delete"](array4);
  stack2["delete"](other);
  return result2;
}
function mapToArray(map2) {
  var index2 = -1, result2 = Array(map2.size);
  map2.forEach(function(value2, key) {
    result2[++index2] = [key, value2];
  });
  return result2;
}
function setToArray(set2) {
  var index2 = -1, result2 = Array(set2.size);
  set2.forEach(function(value2) {
    result2[++index2] = value2;
  });
  return result2;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(object4, other, tag, bitmask, customizer, equalFunc, stack2) {
  switch (tag) {
    case dataViewTag:
      if (object4.byteLength != other.byteLength || object4.byteOffset != other.byteOffset) {
        return false;
      }
      object4 = object4.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object4.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object4), new Uint8Array$2(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+object4, +other);
    case errorTag:
      return object4.name == other.name && object4.message == other.message;
    case regexpTag:
    case stringTag:
      return object4 == other + "";
    case mapTag:
      var convert2 = mapToArray;
    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert2 || (convert2 = setToArray);
      if (object4.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack2.get(object4);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack2.set(object4, other);
      var result2 = equalArrays(convert2(object4), convert2(other), bitmask, customizer, equalFunc, stack2);
      stack2["delete"](object4);
      return result2;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object4) == symbolValueOf.call(other);
      }
  }
  return false;
}
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$5 = objectProto$1.hasOwnProperty;
function equalObjects(object4, other, bitmask, customizer, equalFunc, stack2) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object4), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$5.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack2.get(object4);
  var othStacked = stack2.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object4;
  }
  var result2 = true;
  stack2.set(object4, other);
  stack2.set(other, object4);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object4[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object4, stack2) : customizer(objValue, othValue, key, object4, other, stack2);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack2) : compared)) {
      result2 = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result2 && !skipCtor) {
    var objCtor = object4.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object4 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result2 = false;
    }
  }
  stack2["delete"](object4);
  stack2["delete"](other);
  return result2;
}
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto = Object.prototype;
var hasOwnProperty$4 = objectProto.hasOwnProperty;
function baseIsEqualDeep(object4, other, bitmask, customizer, equalFunc, stack2) {
  var objIsArr = isArray$1(object4), othIsArr = isArray$1(other), objTag = objIsArr ? arrayTag : getTag$1(object4), othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object4)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack2 || (stack2 = new Stack$1());
    return objIsArr || isTypedArray$1(object4) ? equalArrays(object4, other, bitmask, customizer, equalFunc, stack2) : equalByTag(object4, other, objTag, bitmask, customizer, equalFunc, stack2);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$4.call(object4, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$4.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object4.value() : object4, othUnwrapped = othIsWrapped ? other.value() : other;
      stack2 || (stack2 = new Stack$1());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack2);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack2 || (stack2 = new Stack$1());
  return equalObjects(object4, other, bitmask, customizer, equalFunc, stack2);
}
function baseIsEqual(value2, other, bitmask, customizer, stack2) {
  if (value2 === other) {
    return true;
  }
  if (value2 == null || other == null || !isObjectLike(value2) && !isObjectLike(other)) {
    return value2 !== value2 && other !== other;
  }
  return baseIsEqualDeep(value2, other, bitmask, customizer, baseIsEqual, stack2);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(object4, source, matchData, customizer) {
  var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
  if (object4 == null) {
    return !length2;
  }
  object4 = Object(object4);
  while (index2--) {
    var data = matchData[index2];
    if (noCustomizer && data[2] ? data[1] !== object4[data[0]] : !(data[0] in object4)) {
      return false;
    }
  }
  while (++index2 < length2) {
    data = matchData[index2];
    var key = data[0], objValue = object4[key], srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === void 0 && !(key in object4)) {
        return false;
      }
    } else {
      var stack2 = new Stack$1();
      if (customizer) {
        var result2 = customizer(objValue, srcValue, key, object4, source, stack2);
      }
      if (!(result2 === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack2) : result2)) {
        return false;
      }
    }
  }
  return true;
}
function isStrictComparable(value2) {
  return value2 === value2 && !isObject$1(value2);
}
function getMatchData(object4) {
  var result2 = keys$1(object4), length2 = result2.length;
  while (length2--) {
    var key = result2[length2], value2 = object4[key];
    result2[length2] = [key, value2, isStrictComparable(value2)];
  }
  return result2;
}
function matchesStrictComparable(key, srcValue) {
  return function(object4) {
    if (object4 == null) {
      return false;
    }
    return object4[key] === srcValue && (srcValue !== void 0 || key in Object(object4));
  };
}
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object4) {
    return object4 === source || baseIsMatch(object4, source, matchData);
  };
}
function baseHasIn(object4, key) {
  return object4 != null && key in Object(object4);
}
function hasPath(object4, path, hasFunc) {
  path = castPath(path, object4);
  var index2 = -1, length2 = path.length, result2 = false;
  while (++index2 < length2) {
    var key = toKey(path[index2]);
    if (!(result2 = object4 != null && hasFunc(object4, key))) {
      break;
    }
    object4 = object4[key];
  }
  if (result2 || ++index2 != length2) {
    return result2;
  }
  length2 = object4 == null ? 0 : object4.length;
  return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray$1(object4) || isArguments$1(object4));
}
function hasIn(object4, path) {
  return object4 != null && hasPath(object4, path, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object4) {
    var objValue = get(object4, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object4, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(key) {
  return function(object4) {
    return object4 == null ? void 0 : object4[key];
  };
}
function basePropertyDeep(path) {
  return function(object4) {
    return baseGet(object4, path);
  };
}
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
function baseIteratee(value2) {
  if (typeof value2 == "function") {
    return value2;
  }
  if (value2 == null) {
    return identity;
  }
  if (typeof value2 == "object") {
    return isArray$1(value2) ? baseMatchesProperty(value2[0], value2[1]) : baseMatches(value2);
  }
  return property$1(value2);
}
function createBaseFor(fromRight) {
  return function(object4, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object4), props = keysFunc(object4), length2 = props.length;
    while (length2--) {
      var key = props[fromRight ? length2 : ++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object4;
  };
}
var baseFor = createBaseFor();
var baseFor$1 = baseFor;
function baseForOwn(object4, iteratee) {
  return object4 && baseFor$1(object4, iteratee, keys$1);
}
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object(collection);
    while (fromRight ? index2-- : ++index2 < length2) {
      if (iteratee(iterable[index2], index2, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var baseEach = createBaseEach(baseForOwn);
var baseEach$1 = baseEach;
var now = function() {
  return root$1.Date.now();
};
var now$1 = now;
var FUNC_ERROR_TEXT$1 = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result2 = func.apply(thisArg, args);
    return result2;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result2;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now$1();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result2;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result2 : trailingEdge(now$1());
  }
  function debounced() {
    var time2 = now$1(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result2;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
function assignMergeValue(object4, key, value2) {
  if (value2 !== void 0 && !eq(object4[key], value2) || value2 === void 0 && !(key in object4)) {
    baseAssignValue(object4, key, value2);
  }
}
function isArrayLikeObject(value2) {
  return isObjectLike(value2) && isArrayLike(value2);
}
function safeGet(object4, key) {
  if (key === "constructor" && typeof object4[key] === "function") {
    return;
  }
  if (key == "__proto__") {
    return;
  }
  return object4[key];
}
function toPlainObject$1(value2) {
  return copyObject(value2, keysIn(value2));
}
function baseMergeDeep(object4, source, key, srcIndex, mergeFunc, customizer, stack2) {
  var objValue = safeGet(object4, key), srcValue = safeGet(source, key), stacked = stack2.get(srcValue);
  if (stacked) {
    assignMergeValue(object4, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + "", object4, source, stack2) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray$1(srcValue), isBuff = !isArr && isBuffer$1(srcValue), isTyped = !isArr && !isBuff && isTypedArray$1(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$1(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject(srcValue) || isArguments$1(srcValue)) {
      newValue = objValue;
      if (isArguments$1(objValue)) {
        newValue = toPlainObject$1(objValue);
      } else if (!isObject$1(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack2.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack2);
    stack2["delete"](srcValue);
  }
  assignMergeValue(object4, key, newValue);
}
function baseMerge(object4, source, srcIndex, customizer, stack2) {
  if (object4 === source) {
    return;
  }
  baseFor$1(source, function(srcValue, key) {
    stack2 || (stack2 = new Stack$1());
    if (isObject$1(srcValue)) {
      baseMergeDeep(object4, source, key, srcIndex, baseMerge, customizer, stack2);
    } else {
      var newValue = customizer ? customizer(safeGet(object4, key), srcValue, key + "", object4, source, stack2) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object4, key, newValue);
    }
  }, keysIn);
}
function baseMap(collection, iteratee) {
  var index2 = -1, result2 = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach$1(collection, function(value2, key, collection2) {
    result2[++index2] = iteratee(value2, key, collection2);
  });
  return result2;
}
function map(collection, iteratee) {
  var func = isArray$1(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee));
}
var kebabCase = createCompounder(function(result2, word, index2) {
  return result2 + (index2 ? "-" : "") + word.toLowerCase();
});
var kebabCase$1 = kebabCase;
var merge$1 = createAssigner(function(object4, source, srcIndex) {
  baseMerge(object4, source, srcIndex);
});
var merge$2 = merge$1;
var FUNC_ERROR_TEXT = "Expected a function";
function throttle(func, wait, options) {
  var leading = true, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject$1(options)) {
    leading = "leading" in options ? !!options.leading : leading;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    "leading": leading,
    "maxWait": wait,
    "trailing": trailing
  });
}
var commonVariables$e = {
  fontFamily: 'v-sans, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  fontFamilyMono: "v-mono, SFMono-Regular, Menlo, Consolas, Courier, monospace",
  fontWeight: "400",
  fontWeightStrong: "500",
  cubicBezierEaseInOut: "cubic-bezier(.4, 0, .2, 1)",
  cubicBezierEaseOut: "cubic-bezier(0, 0, .2, 1)",
  cubicBezierEaseIn: "cubic-bezier(.4, 0, 1, 1)",
  borderRadius: "3px",
  borderRadiusSmall: "2px",
  fontSize: "14px",
  fontSizeMini: "12px",
  fontSizeTiny: "12px",
  fontSizeSmall: "14px",
  fontSizeMedium: "14px",
  fontSizeLarge: "15px",
  fontSizeHuge: "16px",
  lineHeight: "1.6",
  heightMini: "16px",
  heightTiny: "22px",
  heightSmall: "28px",
  heightMedium: "34px",
  heightLarge: "40px",
  heightHuge: "46px"
};
const {
  fontSize,
  fontFamily,
  lineHeight
} = commonVariables$e;
var globalStyle = c$2("body", `
 margin: 0;
 font-size: ${fontSize};
 font-family: ${fontFamily};
 line-height: ${lineHeight};
 -webkit-text-size-adjust: 100%;
 -webkit-tap-highlight-color: transparent;
`, [c$2("input", `
 font-family: inherit;
 font-size: inherit;
 `)]);
const configProviderInjectionKey = createInjectionKey("n-config-provider");
const cssrAnchorMetaName = "naive-ui-style";
function createTheme(theme2) {
  return theme2;
}
function useTheme(resolveId, mountId, style2, defaultTheme2, props, clsPrefixRef) {
  const ssrAdapter2 = useSsrAdapter();
  const NConfigProvider2 = inject(configProviderInjectionKey, null);
  if (style2) {
    const mountStyle = () => {
      const clsPrefix = clsPrefixRef === null || clsPrefixRef === void 0 ? void 0 : clsPrefixRef.value;
      style2.mount({
        id: clsPrefix === void 0 ? mountId : clsPrefix + mountId,
        head: true,
        props: {
          bPrefix: clsPrefix ? `.${clsPrefix}-` : void 0
        },
        anchorMetaName: cssrAnchorMetaName,
        ssr: ssrAdapter2
      });
      if (!(NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.preflightStyleDisabled)) {
        globalStyle.mount({
          id: "n-global",
          head: true,
          anchorMetaName: cssrAnchorMetaName,
          ssr: ssrAdapter2
        });
      }
    };
    if (ssrAdapter2) {
      mountStyle();
    } else {
      onBeforeMount(mountStyle);
    }
  }
  const mergedThemeRef = computed(() => {
    var _a2;
    const { theme: { common: selfCommon, self: self2, peers = {} } = {}, themeOverrides: selfOverrides = {}, builtinThemeOverrides: builtinOverrides = {} } = props;
    const { common: selfCommonOverrides, peers: peersOverrides } = selfOverrides;
    const { common: globalCommon = void 0, [resolveId]: { common: globalSelfCommon = void 0, self: globalSelf = void 0, peers: globalPeers = {} } = {} } = (NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedThemeRef.value) || {};
    const { common: globalCommonOverrides = void 0, [resolveId]: globalSelfOverrides = {} } = (NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedThemeOverridesRef.value) || {};
    const { common: globalSelfCommonOverrides, peers: globalPeersOverrides = {} } = globalSelfOverrides;
    const mergedCommon = merge$2({}, selfCommon || globalSelfCommon || globalCommon || defaultTheme2.common, globalCommonOverrides, globalSelfCommonOverrides, selfCommonOverrides);
    const mergedSelf = merge$2((_a2 = self2 || globalSelf || defaultTheme2.self) === null || _a2 === void 0 ? void 0 : _a2(mergedCommon), builtinOverrides, globalSelfOverrides, selfOverrides);
    return {
      common: mergedCommon,
      self: mergedSelf,
      peers: merge$2({}, defaultTheme2.peers, globalPeers, peers),
      peerOverrides: merge$2({}, builtinOverrides.peers, globalPeersOverrides, peersOverrides)
    };
  });
  return mergedThemeRef;
}
useTheme.props = {
  theme: Object,
  themeOverrides: Object,
  builtinThemeOverrides: Object
};
const defaultClsPrefix = "n";
function useConfig(props = {}, options = {
  defaultBordered: true
}) {
  const NConfigProvider2 = inject(configProviderInjectionKey, null);
  return {
    inlineThemeDisabled: NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.inlineThemeDisabled,
    mergedRtlRef: NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedRtlRef,
    mergedComponentPropsRef: NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedComponentPropsRef,
    mergedBreakpointsRef: NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedBreakpointsRef,
    mergedBorderedRef: computed(() => {
      var _a2, _b2;
      const { bordered } = props;
      if (bordered !== void 0)
        return bordered;
      return (_b2 = (_a2 = NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedBorderedRef.value) !== null && _a2 !== void 0 ? _a2 : options.defaultBordered) !== null && _b2 !== void 0 ? _b2 : true;
    }),
    mergedClsPrefixRef: computed(() => {
      const clsPrefix = NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedClsPrefixRef.value;
      return clsPrefix || defaultClsPrefix;
    }),
    namespaceRef: computed(() => NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedNamespaceRef.value)
  };
}
const enUS$3 = {
  name: "en-US",
  global: {
    undo: "Undo",
    redo: "Redo",
    confirm: "Confirm",
    clear: "Clear"
  },
  Popconfirm: {
    positiveText: "Confirm",
    negativeText: "Cancel"
  },
  Cascader: {
    placeholder: "Please Select",
    loading: "Loading",
    loadingRequiredMessage: (label) => `Please load all ${label}'s descendants before checking it.`
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Clear",
    now: "Now",
    confirm: "Confirm",
    selectTime: "Select Time",
    selectDate: "Select Date",
    datePlaceholder: "Select Date",
    datetimePlaceholder: "Select Date and Time",
    monthPlaceholder: "Select Month",
    yearPlaceholder: "Select Year",
    quarterPlaceholder: "Select Quarter",
    startDatePlaceholder: "Start Date",
    endDatePlaceholder: "End Date",
    startDatetimePlaceholder: "Start Date and Time",
    endDatetimePlaceholder: "End Date and Time",
    startMonthPlaceholder: "Start Month",
    endMonthPlaceholder: "End Month",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "Today"
  },
  DataTable: {
    checkTableAll: "Select all in the table",
    uncheckTableAll: "Unselect all in the table",
    confirm: "Confirm",
    clear: "Clear"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Target"
  },
  Transfer: {
    selectAll: "Select all",
    unselectAll: "Unselect all",
    clearAll: "Clear",
    total: (num) => `Total ${num} items`,
    selected: (num) => `${num} items selected`
  },
  Empty: {
    description: "No Data"
  },
  Select: {
    placeholder: "Please Select"
  },
  TimePicker: {
    placeholder: "Select Time",
    positiveText: "OK",
    negativeText: "Cancel",
    now: "Now"
  },
  Pagination: {
    goto: "Goto",
    selectionSuffix: "page"
  },
  DynamicTags: {
    add: "Add"
  },
  Log: {
    loading: "Loading"
  },
  Input: {
    placeholder: "Please Input"
  },
  InputNumber: {
    placeholder: "Please Input"
  },
  DynamicInput: {
    create: "Create"
  },
  ThemeEditor: {
    title: "Theme Editor",
    clearAllVars: "Clear All Variables",
    clearSearch: "Clear Search",
    filterCompName: "Filter Component Name",
    filterVarName: "Filter Variable Name",
    import: "Import",
    export: "Export",
    restore: "Reset to Default"
  },
  Image: {
    tipPrevious: "Previous picture (\u2190)",
    tipNext: "Next picture (\u2192)",
    tipCounterclockwise: "Counterclockwise",
    tipClockwise: "Clockwise",
    tipZoomOut: "Zoom out",
    tipZoomIn: "Zoom in",
    tipClose: "Close (Esc)",
    tipOriginalSize: "Zoom to original size"
  }
};
var enUS$4 = enUS$3;
function buildFormatLongFn$1(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
function requiredArgs$1(required4, args) {
  if (args.length < required4) {
    throw new TypeError(required4 + " argument" + (required4 > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function toDate$2(argument) {
  requiredArgs$1(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
function toInteger$2(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number4 = Number(dirtyNumber);
  if (isNaN(number4)) {
    return number4;
  }
  return number4 < 0 ? Math.ceil(number4) : Math.floor(number4);
}
var defaultOptions$2 = {};
function getDefaultOptions$1() {
  return defaultOptions$2;
}
function startOfUTCWeek$1(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(1, arguments);
  var defaultOptions2 = getDefaultOptions$1();
  var weekStartsOn = toInteger$2((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date4 = toDate$2(dirtyDate);
  var day = date4.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date4.setUTCDate(date4.getUTCDate() - diff);
  date4.setUTCHours(0, 0, 0, 0);
  return date4;
}
function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
  requiredArgs$1(2, arguments);
  var dateLeftStartOfWeek = startOfUTCWeek$1(dirtyDateLeft, options);
  var dateRightStartOfWeek = startOfUTCWeek$1(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}
function buildLocalizeFn$1(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
function buildMatchFn$1(args) {
  return function(string3) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string3.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern4) {
      return pattern4.test(matchedString);
    }) : findKey(parsePatterns, function(pattern4) {
      return pattern4.test(matchedString);
    });
    var value2;
    value2 = args.valueCallback ? args.valueCallback(key) : key;
    value2 = options.valueCallback ? options.valueCallback(value2) : value2;
    var rest = string3.slice(matchedString.length);
    return {
      value: value2,
      rest
    };
  };
}
function findKey(object4, predicate) {
  for (var key in object4) {
    if (object4.hasOwnProperty(key) && predicate(object4[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array4, predicate) {
  for (var key = 0; key < array4.length; key++) {
    if (predicate(array4[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn$1(args) {
  return function(string3) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string3.match(args.matchPattern);
    if (!matchResult)
      return null;
    var matchedString = matchResult[0];
    var parseResult = string3.match(args.parsePattern);
    if (!parseResult)
      return null;
    var value2 = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value2 = options.valueCallback ? options.valueCallback(value2) : value2;
    var rest = string3.slice(matchedString.length);
    return {
      value: value2,
      rest
    };
  };
}
var formatDistanceLocale$b = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance$n = function(token, count, options) {
  var result2;
  var tokenValue = formatDistanceLocale$b[token];
  if (typeof tokenValue === "string") {
    result2 = tokenValue;
  } else if (count === 1) {
    result2 = tokenValue.one;
  } else {
    result2 = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result2;
    } else {
      return result2 + " ago";
    }
  }
  return result2;
};
var formatDistance$o = formatDistance$n;
var dateFormats$c = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats$c = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats$c = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong$p = {
  date: buildFormatLongFn$1({
    formats: dateFormats$c,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$c,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$c,
    defaultWidth: "full"
  })
};
var formatLong$q = formatLong$p;
var formatRelativeLocale$b = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative$n = function(token, _date, _baseDate, _options) {
  return formatRelativeLocale$b[token];
};
var formatRelative$o = formatRelative$n;
var eraValues$b = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues$b = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues$b = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues$b = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues$b = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues$7 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber$b = function(dirtyNumber, _options) {
  var number4 = Number(dirtyNumber);
  var rem100 = number4 % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number4 + "st";
      case 2:
        return number4 + "nd";
      case 3:
        return number4 + "rd";
    }
  }
  return number4 + "th";
};
var localize$n = {
  ordinalNumber: ordinalNumber$b,
  era: buildLocalizeFn$1({
    values: eraValues$b,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$b,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues$b,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$b,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$b,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$7,
    defaultFormattingWidth: "wide"
  })
};
var localize$o = localize$n;
var matchOrdinalNumberPattern$b = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$b = /\d+/i;
var matchEraPatterns$b = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns$b = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$b = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns$b = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$b = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns$b = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$b = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns$b = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$b = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$b = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$n = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$b,
    parsePattern: parseOrdinalNumberPattern$b,
    valueCallback: function(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$b,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$b,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$b,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$b,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$b,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$b,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$b,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$b,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$b,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$b,
    defaultParseWidth: "any"
  })
};
var match$o = match$n;
var locale$c = {
  code: "en-US",
  formatDistance: formatDistance$o,
  formatLong: formatLong$q,
  formatRelative: formatRelative$o,
  localize: localize$o,
  match: match$o,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var enUS$2 = locale$c;
const dateEnUs = {
  name: "en-US",
  locale: enUS$2
};
var dateEnUS = dateEnUs;
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var date4 = toDate$2(dirtyDate);
  var amount = toInteger$2(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    return date4;
  }
  date4.setDate(date4.getDate() + amount);
  return date4;
}
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var date4 = toDate$2(dirtyDate);
  var amount = toInteger$2(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    return date4;
  }
  var dayOfMonth = date4.getDate();
  var endOfDesiredMonth = new Date(date4.getTime());
  endOfDesiredMonth.setMonth(date4.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date4.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date4;
  }
}
function addMilliseconds$1(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var timestamp = toDate$2(dirtyDate).getTime();
  var amount = toInteger$2(dirtyAmount);
  return new Date(timestamp + amount);
}
function getTimezoneOffsetInMilliseconds$2(date4) {
  var utcDate = new Date(Date.UTC(date4.getFullYear(), date4.getMonth(), date4.getDate(), date4.getHours(), date4.getMinutes(), date4.getSeconds(), date4.getMilliseconds()));
  utcDate.setUTCFullYear(date4.getFullYear());
  return date4.getTime() - utcDate.getTime();
}
function startOfDay(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  date4.setHours(0, 0, 0, 0);
  return date4;
}
function addQuarters(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var amount = toInteger$2(dirtyAmount);
  var months = amount * 3;
  return addMonths(dirtyDate, months);
}
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var amount = toInteger$2(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
var millisecondsInMinute = 6e4;
var millisecondsInHour = 36e5;
var millisecondsInSecond = 1e3;
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
function isDate$1(value2) {
  requiredArgs$1(1, arguments);
  return value2 instanceof Date || typeof value2 === "object" && Object.prototype.toString.call(value2) === "[object Date]";
}
function isValid$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  if (!isDate$1(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date4 = toDate$2(dirtyDate);
  return !isNaN(Number(date4));
}
function getQuarter(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var quarter = Math.floor(date4.getMonth() / 3) + 1;
  return quarter;
}
function startOfMinute(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  date4.setSeconds(0, 0);
  return date4;
}
function startOfQuarter(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var currentMonth = date4.getMonth();
  var month = currentMonth - currentMonth % 3;
  date4.setMonth(month, 1);
  date4.setHours(0, 0, 0, 0);
  return date4;
}
function startOfMonth(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  date4.setDate(1);
  date4.setHours(0, 0, 0, 0);
  return date4;
}
function startOfYear(dirtyDate) {
  requiredArgs$1(1, arguments);
  var cleanDate = toDate$2(dirtyDate);
  var date4 = new Date(0);
  date4.setFullYear(cleanDate.getFullYear(), 0, 1);
  date4.setHours(0, 0, 0, 0);
  return date4;
}
function subMilliseconds$1(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var amount = toInteger$2(dirtyAmount);
  return addMilliseconds$1(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var timestamp = date4.getTime();
  date4.setUTCMonth(0, 1);
  date4.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date4.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var weekStartsOn = 1;
  var date4 = toDate$2(dirtyDate);
  var day = date4.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date4.setUTCDate(date4.getUTCDate() - diff);
  date4.setUTCHours(0, 0, 0, 0);
  return date4;
}
function getUTCISOWeekYear$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var year = date4.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek$1(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek$1(fourthOfJanuaryOfThisYear);
  if (date4.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date4.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var year = getUTCISOWeekYear$1(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date4 = startOfUTCISOWeek$1(fourthOfJanuary);
  return date4;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCISOWeek$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var diff = startOfUTCISOWeek$1(date4).getTime() - startOfUTCISOWeekYear$1(date4).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function getUTCWeekYear$1(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var year = date4.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions$1();
  var firstWeekContainsDate = toInteger$2((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek$1(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek$1(firstWeekOfThisYear, options);
  if (date4.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date4.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear$1(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(1, arguments);
  var defaultOptions2 = getDefaultOptions$1();
  var firstWeekContainsDate = toInteger$2((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear$1(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date4 = startOfUTCWeek$1(firstWeek, options);
  return date4;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCWeek$1(dirtyDate, options) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var diff = startOfUTCWeek$1(date4, options).getTime() - startOfUTCWeekYear$1(date4, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function addLeadingZeros$2(number4, targetLength) {
  var sign = number4 < 0 ? "-" : "";
  var output = Math.abs(number4).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign + output;
}
var formatters$5 = {
  y: function(date4, token) {
    var signedYear = date4.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros$2(token === "yy" ? year % 100 : year, token.length);
  },
  M: function(date4, token) {
    var month = date4.getUTCMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros$2(month + 1, 2);
  },
  d: function(date4, token) {
    return addLeadingZeros$2(date4.getUTCDate(), token.length);
  },
  a: function(date4, token) {
    var dayPeriodEnumValue = date4.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  h: function(date4, token) {
    return addLeadingZeros$2(date4.getUTCHours() % 12 || 12, token.length);
  },
  H: function(date4, token) {
    return addLeadingZeros$2(date4.getUTCHours(), token.length);
  },
  m: function(date4, token) {
    return addLeadingZeros$2(date4.getUTCMinutes(), token.length);
  },
  s: function(date4, token) {
    return addLeadingZeros$2(date4.getUTCSeconds(), token.length);
  },
  S: function(date4, token) {
    var numberOfDigits = token.length;
    var milliseconds = date4.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros$2(fractionalSeconds, token.length);
  }
};
var formatters$6 = formatters$5;
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters$3 = {
  G: function(date4, token, localize2) {
    var era = date4.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  y: function(date4, token, localize2) {
    if (token === "yo") {
      var signedYear = date4.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$6.y(date4, token);
  },
  Y: function(date4, token, localize2, options) {
    var signedWeekYear = getUTCWeekYear$1(date4, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros$2(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros$2(weekYear, token.length);
  },
  R: function(date4, token) {
    var isoWeekYear = getUTCISOWeekYear$1(date4);
    return addLeadingZeros$2(isoWeekYear, token.length);
  },
  u: function(date4, token) {
    var year = date4.getUTCFullYear();
    return addLeadingZeros$2(year, token.length);
  },
  Q: function(date4, token, localize2) {
    var quarter = Math.ceil((date4.getUTCMonth() + 1) / 3);
    switch (token) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros$2(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  q: function(date4, token, localize2) {
    var quarter = Math.ceil((date4.getUTCMonth() + 1) / 3);
    switch (token) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros$2(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  M: function(date4, token, localize2) {
    var month = date4.getUTCMonth();
    switch (token) {
      case "M":
      case "MM":
        return formatters$6.M(date4, token);
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  L: function(date4, token, localize2) {
    var month = date4.getUTCMonth();
    switch (token) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros$2(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  w: function(date4, token, localize2, options) {
    var week = getUTCWeek$1(date4, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros$2(week, token.length);
  },
  I: function(date4, token, localize2) {
    var isoWeek = getUTCISOWeek$1(date4);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros$2(isoWeek, token.length);
  },
  d: function(date4, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date4.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$6.d(date4, token);
  },
  D: function(date4, token, localize2) {
    var dayOfYear = getUTCDayOfYear$1(date4);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros$2(dayOfYear, token.length);
  },
  E: function(date4, token, localize2) {
    var dayOfWeek = date4.getUTCDay();
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  e: function(date4, token, localize2, options) {
    var dayOfWeek = date4.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros$2(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  c: function(date4, token, localize2, options) {
    var dayOfWeek = date4.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros$2(localDayOfWeek, token.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  i: function(date4, token, localize2) {
    var dayOfWeek = date4.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros$2(isoDayOfWeek, token.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  a: function(date4, token, localize2) {
    var hours = date4.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  b: function(date4, token, localize2) {
    var hours = date4.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  B: function(date4, token, localize2) {
    var hours = date4.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  h: function(date4, token, localize2) {
    if (token === "ho") {
      var hours = date4.getUTCHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$6.h(date4, token);
  },
  H: function(date4, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date4.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$6.H(date4, token);
  },
  K: function(date4, token, localize2) {
    var hours = date4.getUTCHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros$2(hours, token.length);
  },
  k: function(date4, token, localize2) {
    var hours = date4.getUTCHours();
    if (hours === 0)
      hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros$2(hours, token.length);
  },
  m: function(date4, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date4.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$6.m(date4, token);
  },
  s: function(date4, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date4.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$6.s(date4, token);
  },
  S: function(date4, token) {
    return formatters$6.S(date4, token);
  },
  X: function(date4, token, _localize, options) {
    var originalDate = options._originalDate || date4;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes$1(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone$1(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone$1(timezoneOffset, ":");
    }
  },
  x: function(date4, token, _localize, options) {
    var originalDate = options._originalDate || date4;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes$1(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone$1(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone$1(timezoneOffset, ":");
    }
  },
  O: function(date4, token, _localize, options) {
    var originalDate = options._originalDate || date4;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort$1(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone$1(timezoneOffset, ":");
    }
  },
  z: function(date4, token, _localize, options) {
    var originalDate = options._originalDate || date4;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort$1(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone$1(timezoneOffset, ":");
    }
  },
  t: function(date4, token, _localize, options) {
    var originalDate = options._originalDate || date4;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros$2(timestamp, token.length);
  },
  T: function(date4, token, _localize, options) {
    var originalDate = options._originalDate || date4;
    var timestamp = originalDate.getTime();
    return addLeadingZeros$2(timestamp, token.length);
  }
};
function formatTimezoneShort$1(offset, dirtyDelimiter) {
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || "";
  return sign + String(hours) + delimiter + addLeadingZeros$2(minutes, 2);
}
function formatTimezoneWithOptionalMinutes$1(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros$2(Math.abs(offset) / 60, 2);
  }
  return formatTimezone$1(offset, dirtyDelimiter);
}
function formatTimezone$1(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros$2(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros$2(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$4 = formatters$3;
var dateLongFormatter = function(pattern4, formatLong2) {
  switch (pattern4) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
};
var timeLongFormatter = function(pattern4, formatLong2) {
  switch (pattern4) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
};
var dateTimeLongFormatter = function(pattern4, formatLong2) {
  var matchResult = pattern4.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern4, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
var longFormatters$1 = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$2 = longFormatters$1;
var protectedDayOfYearTokens$1 = ["D", "DD"];
var protectedWeekYearTokens$1 = ["YY", "YYYY"];
function isProtectedDayOfYearToken$1(token) {
  return protectedDayOfYearTokens$1.indexOf(token) !== -1;
}
function isProtectedWeekYearToken$1(token) {
  return protectedWeekYearTokens$1.indexOf(token) !== -1;
}
function throwProtectedError$1(token, format2, input) {
  if (token === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format$4(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs$1(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions$1();
  var locale2 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : enUS$2;
  var firstWeekContainsDate = toInteger$2((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger$2((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale2.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale2.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate$2(dirtyDate);
  if (!isValid$1(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds$2(originalDate);
  var utcDate = subMilliseconds$1(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2,
    _originalDate: originalDate
  };
  var result2 = formatStr.match(longFormattingTokensRegExp$1).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters$2[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$1).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }
    var formatter = formatters$4[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken$1(substring)) {
        throwProtectedError$1(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken$1(substring)) {
        throwProtectedError$1(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale2.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result2;
}
function cleanEscapedString$1(input) {
  var matched = input.match(escapedStringRegExp$1);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp$1, "'");
}
function assign$1(target, object4) {
  if (target == null) {
    throw new TypeError("assign requires that input parameter not be null or undefined");
  }
  for (var property2 in object4) {
    if (Object.prototype.hasOwnProperty.call(object4, property2)) {
      target[property2] = object4[property2];
    }
  }
  return target;
}
function getDate(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var dayOfMonth = date4.getDate();
  return dayOfMonth;
}
function getDay(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var day = date4.getDay();
  return day;
}
function getDaysInMonth(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var year = date4.getFullYear();
  var monthIndex = date4.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
function getHours(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var hours = date4.getHours();
  return hours;
}
function getMinutes(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var minutes = date4.getMinutes();
  return minutes;
}
function getMonth(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var month = date4.getMonth();
  return month;
}
function getSeconds(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var seconds = date4.getSeconds();
  return seconds;
}
function getTime(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  var timestamp = date4.getTime();
  return timestamp;
}
function getYear(dirtyDate) {
  requiredArgs$1(1, arguments);
  return toDate$2(dirtyDate).getFullYear();
}
function _defineProperty$A(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
var TIMEZONE_UNIT_PRIORITY = 10;
class Setter {
  constructor() {
    _defineProperty$A(this, "priority", void 0);
    _defineProperty$A(this, "subPriority", 0);
  }
  validate(_utcDate, _options) {
    return true;
  }
}
class ValueSetter extends Setter {
  constructor(value2, validateValue, setValue, priority, subPriority) {
    super();
    this.value = value2;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }
  validate(utcDate, options) {
    return this.validateValue(utcDate, this.value, options);
  }
  set(utcDate, flags, options) {
    return this.setValue(utcDate, flags, this.value, options);
  }
}
class DateToSystemTimezoneSetter extends Setter {
  constructor() {
    super(...arguments);
    _defineProperty$A(this, "priority", TIMEZONE_UNIT_PRIORITY);
    _defineProperty$A(this, "subPriority", -1);
  }
  set(date4, flags) {
    if (flags.timestampIsSet) {
      return date4;
    }
    var convertedDate = new Date(0);
    convertedDate.setFullYear(date4.getUTCFullYear(), date4.getUTCMonth(), date4.getUTCDate());
    convertedDate.setHours(date4.getUTCHours(), date4.getUTCMinutes(), date4.getUTCSeconds(), date4.getUTCMilliseconds());
    return convertedDate;
  }
}
function _defineProperty$z(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class Parser$1 {
  constructor() {
    _defineProperty$z(this, "incompatibleTokens", void 0);
    _defineProperty$z(this, "priority", void 0);
    _defineProperty$z(this, "subPriority", void 0);
  }
  run(dateString, token, match2, options) {
    var result2 = this.parse(dateString, token, match2, options);
    if (!result2) {
      return null;
    }
    return {
      setter: new ValueSetter(result2.value, this.validate, this.set, this.priority, this.subPriority),
      rest: result2.rest
    };
  }
  validate(_utcDate, _value, _options) {
    return true;
  }
}
function _defineProperty$y(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class EraParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$y(this, "priority", 140);
    _defineProperty$y(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "G":
      case "GG":
      case "GGG":
        return match2.era(dateString, {
          width: "abbreviated"
        }) || match2.era(dateString, {
          width: "narrow"
        });
      case "GGGGG":
        return match2.era(dateString, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return match2.era(dateString, {
          width: "wide"
        }) || match2.era(dateString, {
          width: "abbreviated"
        }) || match2.era(dateString, {
          width: "narrow"
        });
    }
  }
  set(date4, flags, value2) {
    flags.era = value2;
    date4.setUTCFullYear(value2, 0, 1);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  date: /^(3[0-1]|[0-2]?\d)/,
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  week: /^(5[0-3]|[0-4]?\d)/,
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  hour11h: /^(1[0-1]|0?\d)/,
  hour12h: /^(1[0-2]|0?\d)/,
  minute: /^[0-5]?\d/,
  second: /^[0-5]?\d/,
  singleDigit: /^\d/,
  twoDigits: /^\d{1,2}/,
  threeDigits: /^\d{1,3}/,
  fourDigits: /^\d{1,4}/,
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  twoDigitsSigned: /^-?\d{1,2}/,
  threeDigitsSigned: /^-?\d{1,3}/,
  fourDigitsSigned: /^-?\d{1,4}/
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern4, dateString) {
  var matchResult = dateString.match(pattern4);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern4, dateString) {
  var matchResult = dateString.match(pattern4);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign = matchResult[1] === "+" ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n2 + "}"), dateString);
  }
}
function parseNDigitsSigned(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n2 + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result2;
  if (absCurrentYear <= 50) {
    result2 = twoDigitYear || 100;
  } else {
    var rangeEnd2 = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd2 / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd2 % 100;
    result2 = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result2 : 1 - result2;
}
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function _defineProperty$x(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class YearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$x(this, "priority", 130);
    _defineProperty$x(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token, match2) {
    var valueCallback = function(year) {
      return {
        year,
        isTwoDigitYear: token === "yy"
      };
    };
    switch (token) {
      case "y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "yo":
        return mapValue(match2.ordinalNumber(dateString, {
          unit: "year"
        }), valueCallback);
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }
  validate(_date, value2) {
    return value2.isTwoDigitYear || value2.year > 0;
  }
  set(date4, flags, value2) {
    var currentYear = date4.getUTCFullYear();
    if (value2.isTwoDigitYear) {
      var normalizedTwoDigitYear = normalizeTwoDigitYear(value2.year, currentYear);
      date4.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
      date4.setUTCHours(0, 0, 0, 0);
      return date4;
    }
    var year = !("era" in flags) || flags.era === 1 ? value2.year : 1 - value2.year;
    date4.setUTCFullYear(year, 0, 1);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
function _defineProperty$w(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class LocalWeekYearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$w(this, "priority", 130);
    _defineProperty$w(this, "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]);
  }
  parse(dateString, token, match2) {
    var valueCallback = function(year) {
      return {
        year,
        isTwoDigitYear: token === "YY"
      };
    };
    switch (token) {
      case "Y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "Yo":
        return mapValue(match2.ordinalNumber(dateString, {
          unit: "year"
        }), valueCallback);
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }
  validate(_date, value2) {
    return value2.isTwoDigitYear || value2.year > 0;
  }
  set(date4, flags, value2, options) {
    var currentYear = getUTCWeekYear$1(date4, options);
    if (value2.isTwoDigitYear) {
      var normalizedTwoDigitYear = normalizeTwoDigitYear(value2.year, currentYear);
      date4.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
      date4.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek$1(date4, options);
    }
    var year = !("era" in flags) || flags.era === 1 ? value2.year : 1 - value2.year;
    date4.setUTCFullYear(year, 0, options.firstWeekContainsDate);
    date4.setUTCHours(0, 0, 0, 0);
    return startOfUTCWeek$1(date4, options);
  }
}
function _defineProperty$v(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class ISOWeekYearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$v(this, "priority", 130);
    _defineProperty$v(this, "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
  }
  parse(dateString, token) {
    if (token === "R") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token.length, dateString);
  }
  set(_date, _flags, value2) {
    var firstWeekOfYear = new Date(0);
    firstWeekOfYear.setUTCFullYear(value2, 0, 4);
    firstWeekOfYear.setUTCHours(0, 0, 0, 0);
    return startOfUTCISOWeek$1(firstWeekOfYear);
  }
}
function _defineProperty$u(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class ExtendedYearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$u(this, "priority", 130);
    _defineProperty$u(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token) {
    if (token === "u") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token.length, dateString);
  }
  set(date4, _flags, value2) {
    date4.setUTCFullYear(value2, 0, 1);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
function _defineProperty$t(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class QuarterParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$t(this, "priority", 120);
    _defineProperty$t(this, "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "Q":
      case "QQ":
        return parseNDigits(token.length, dateString);
      case "Qo":
        return match2.ordinalNumber(dateString, {
          unit: "quarter"
        });
      case "QQQ":
        return match2.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return match2.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return match2.quarter(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(_date, value2) {
    return value2 >= 1 && value2 <= 4;
  }
  set(date4, _flags, value2) {
    date4.setUTCMonth((value2 - 1) * 3, 1);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
function _defineProperty$s(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class StandAloneQuarterParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$s(this, "priority", 120);
    _defineProperty$s(this, "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "q":
      case "qq":
        return parseNDigits(token.length, dateString);
      case "qo":
        return match2.ordinalNumber(dateString, {
          unit: "quarter"
        });
      case "qqq":
        return match2.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return match2.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return match2.quarter(dateString, {
          width: "wide",
          context: "standalone"
        }) || match2.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(_date, value2) {
    return value2 >= 1 && value2 <= 4;
  }
  set(date4, _flags, value2) {
    date4.setUTCMonth((value2 - 1) * 3, 1);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
function _defineProperty$r(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class MonthParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$r(this, "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]);
    _defineProperty$r(this, "priority", 110);
  }
  parse(dateString, token, match2) {
    var valueCallback = function(value2) {
      return value2 - 1;
    };
    switch (token) {
      case "M":
        return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
      case "MM":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      case "Mo":
        return mapValue(match2.ordinalNumber(dateString, {
          unit: "month"
        }), valueCallback);
      case "MMM":
        return match2.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.month(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMMM":
        return match2.month(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return match2.month(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.month(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(_date, value2) {
    return value2 >= 0 && value2 <= 11;
  }
  set(date4, _flags, value2) {
    date4.setUTCMonth(value2, 1);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
function _defineProperty$q(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class StandAloneMonthParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$q(this, "priority", 110);
    _defineProperty$q(this, "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token, match2) {
    var valueCallback = function(value2) {
      return value2 - 1;
    };
    switch (token) {
      case "L":
        return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
      case "LL":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      case "Lo":
        return mapValue(match2.ordinalNumber(dateString, {
          unit: "month"
        }), valueCallback);
      case "LLL":
        return match2.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.month(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLLL":
        return match2.month(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return match2.month(dateString, {
          width: "wide",
          context: "standalone"
        }) || match2.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.month(dateString, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(_date, value2) {
    return value2 >= 0 && value2 <= 11;
  }
  set(date4, _flags, value2) {
    date4.setUTCMonth(value2, 1);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs$1(2, arguments);
  var date4 = toDate$2(dirtyDate);
  var week = toInteger$2(dirtyWeek);
  var diff = getUTCWeek$1(date4, options) - week;
  date4.setUTCDate(date4.getUTCDate() - diff * 7);
  return date4;
}
function _defineProperty$p(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class LocalWeekParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$p(this, "priority", 100);
    _defineProperty$p(this, "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "w":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "wo":
        return match2.ordinalNumber(dateString, {
          unit: "week"
        });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value2) {
    return value2 >= 1 && value2 <= 53;
  }
  set(date4, _flags, value2, options) {
    return startOfUTCWeek$1(setUTCWeek(date4, value2, options), options);
  }
}
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs$1(2, arguments);
  var date4 = toDate$2(dirtyDate);
  var isoWeek = toInteger$2(dirtyISOWeek);
  var diff = getUTCISOWeek$1(date4) - isoWeek;
  date4.setUTCDate(date4.getUTCDate() - diff * 7);
  return date4;
}
function _defineProperty$o(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class ISOWeekParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$o(this, "priority", 100);
    _defineProperty$o(this, "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "I":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "Io":
        return match2.ordinalNumber(dateString, {
          unit: "week"
        });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value2) {
    return value2 >= 1 && value2 <= 53;
  }
  set(date4, _flags, value2) {
    return startOfUTCISOWeek$1(setUTCISOWeek(date4, value2));
  }
}
function _defineProperty$n(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
var DAYS_IN_MONTH$1 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR$1 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
class DateParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$n(this, "priority", 90);
    _defineProperty$n(this, "subPriority", 1);
    _defineProperty$n(this, "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "d":
        return parseNumericPattern(numericPatterns.date, dateString);
      case "do":
        return match2.ordinalNumber(dateString, {
          unit: "date"
        });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(date4, value2) {
    var year = date4.getUTCFullYear();
    var isLeapYear = isLeapYearIndex$1(year);
    var month = date4.getUTCMonth();
    if (isLeapYear) {
      return value2 >= 1 && value2 <= DAYS_IN_MONTH_LEAP_YEAR$1[month];
    } else {
      return value2 >= 1 && value2 <= DAYS_IN_MONTH$1[month];
    }
  }
  set(date4, _flags, value2) {
    date4.setUTCDate(value2);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
function _defineProperty$m(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class DayOfYearParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$m(this, "priority", 90);
    _defineProperty$m(this, "subpriority", 1);
    _defineProperty$m(this, "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "D":
      case "DD":
        return parseNumericPattern(numericPatterns.dayOfYear, dateString);
      case "Do":
        return match2.ordinalNumber(dateString, {
          unit: "date"
        });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(date4, value2) {
    var year = date4.getUTCFullYear();
    var isLeapYear = isLeapYearIndex$1(year);
    if (isLeapYear) {
      return value2 >= 1 && value2 <= 366;
    } else {
      return value2 >= 1 && value2 <= 365;
    }
  }
  set(date4, _flags, value2) {
    date4.setUTCMonth(0, value2);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(2, arguments);
  var defaultOptions2 = getDefaultOptions$1();
  var weekStartsOn = toInteger$2((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date4 = toDate$2(dirtyDate);
  var day = toInteger$2(dirtyDay);
  var currentDay = date4.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date4.setUTCDate(date4.getUTCDate() + diff);
  return date4;
}
function _defineProperty$l(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class DayParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$l(this, "priority", 90);
    _defineProperty$l(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "E":
      case "EE":
      case "EEE":
        return match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEE":
        return match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return match2.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEE":
      default:
        return match2.day(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(_date, value2) {
    return value2 >= 0 && value2 <= 6;
  }
  set(date4, _flags, value2, options) {
    date4 = setUTCDay(date4, value2, options);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
function _defineProperty$k(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class LocalDayParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$k(this, "priority", 90);
    _defineProperty$k(this, "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]);
  }
  parse(dateString, token, match2, options) {
    var valueCallback = function(value2) {
      var wholeWeekDays = Math.floor((value2 - 1) / 7) * 7;
      return (value2 + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token) {
      case "e":
      case "ee":
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      case "eo":
        return mapValue(match2.ordinalNumber(dateString, {
          unit: "day"
        }), valueCallback);
      case "eee":
        return match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeee":
        return match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return match2.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "eeee":
      default:
        return match2.day(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(_date, value2) {
    return value2 >= 0 && value2 <= 6;
  }
  set(date4, _flags, value2, options) {
    date4 = setUTCDay(date4, value2, options);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
function _defineProperty$j(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class StandAloneLocalDayParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$j(this, "priority", 90);
    _defineProperty$j(this, "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]);
  }
  parse(dateString, token, match2, options) {
    var valueCallback = function(value2) {
      var wholeWeekDays = Math.floor((value2 - 1) / 7) * 7;
      return (value2 + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token) {
      case "c":
      case "cc":
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      case "co":
        return mapValue(match2.ordinalNumber(dateString, {
          unit: "day"
        }), valueCallback);
      case "ccc":
        return match2.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.day(dateString, {
          width: "short",
          context: "standalone"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "ccccc":
        return match2.day(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return match2.day(dateString, {
          width: "short",
          context: "standalone"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "standalone"
        });
      case "cccc":
      default:
        return match2.day(dateString, {
          width: "wide",
          context: "standalone"
        }) || match2.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.day(dateString, {
          width: "short",
          context: "standalone"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(_date, value2) {
    return value2 >= 0 && value2 <= 6;
  }
  set(date4, _flags, value2, options) {
    date4 = setUTCDay(date4, value2, options);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs$1(2, arguments);
  var day = toInteger$2(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date4 = toDate$2(dirtyDate);
  var currentDay = date4.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date4.setUTCDate(date4.getUTCDate() + diff);
  return date4;
}
function _defineProperty$i(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class ISODayParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$i(this, "priority", 90);
    _defineProperty$i(this, "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]);
  }
  parse(dateString, token, match2) {
    var valueCallback = function(value2) {
      if (value2 === 0) {
        return 7;
      }
      return value2;
    };
    switch (token) {
      case "i":
      case "ii":
        return parseNDigits(token.length, dateString);
      case "io":
        return match2.ordinalNumber(dateString, {
          unit: "day"
        });
      case "iii":
        return mapValue(match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
      case "iiiii":
        return mapValue(match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
      case "iiiiii":
        return mapValue(match2.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
      case "iiii":
      default:
        return mapValue(match2.day(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "short",
          context: "formatting"
        }) || match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        }), valueCallback);
    }
  }
  validate(_date, value2) {
    return value2 >= 1 && value2 <= 7;
  }
  set(date4, _flags, value2) {
    date4 = setUTCISODay(date4, value2);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
}
function _defineProperty$h(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class AMPMParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$h(this, "priority", 80);
    _defineProperty$h(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "a":
      case "aa":
      case "aaa":
        return match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return match2.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date4, _flags, value2) {
    date4.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
    return date4;
  }
}
function _defineProperty$g(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class AMPMMidnightParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$g(this, "priority", 80);
    _defineProperty$g(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "b":
      case "bb":
      case "bbb":
        return match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return match2.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date4, _flags, value2) {
    date4.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
    return date4;
  }
}
function _defineProperty$f(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class DayPeriodParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$f(this, "priority", 80);
    _defineProperty$f(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return match2.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date4, _flags, value2) {
    date4.setUTCHours(dayPeriodEnumToHours(value2), 0, 0, 0);
    return date4;
  }
}
function _defineProperty$e(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class Hour1to12Parser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$e(this, "priority", 70);
    _defineProperty$e(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "h":
        return parseNumericPattern(numericPatterns.hour12h, dateString);
      case "ho":
        return match2.ordinalNumber(dateString, {
          unit: "hour"
        });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value2) {
    return value2 >= 1 && value2 <= 12;
  }
  set(date4, _flags, value2) {
    var isPM = date4.getUTCHours() >= 12;
    if (isPM && value2 < 12) {
      date4.setUTCHours(value2 + 12, 0, 0, 0);
    } else if (!isPM && value2 === 12) {
      date4.setUTCHours(0, 0, 0, 0);
    } else {
      date4.setUTCHours(value2, 0, 0, 0);
    }
    return date4;
  }
}
function _defineProperty$d(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class Hour0to23Parser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$d(this, "priority", 70);
    _defineProperty$d(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "H":
        return parseNumericPattern(numericPatterns.hour23h, dateString);
      case "Ho":
        return match2.ordinalNumber(dateString, {
          unit: "hour"
        });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value2) {
    return value2 >= 0 && value2 <= 23;
  }
  set(date4, _flags, value2) {
    date4.setUTCHours(value2, 0, 0, 0);
    return date4;
  }
}
function _defineProperty$c(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class Hour0To11Parser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$c(this, "priority", 70);
    _defineProperty$c(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "K":
        return parseNumericPattern(numericPatterns.hour11h, dateString);
      case "Ko":
        return match2.ordinalNumber(dateString, {
          unit: "hour"
        });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value2) {
    return value2 >= 0 && value2 <= 11;
  }
  set(date4, _flags, value2) {
    var isPM = date4.getUTCHours() >= 12;
    if (isPM && value2 < 12) {
      date4.setUTCHours(value2 + 12, 0, 0, 0);
    } else {
      date4.setUTCHours(value2, 0, 0, 0);
    }
    return date4;
  }
}
function _defineProperty$b(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class Hour1To24Parser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$b(this, "priority", 70);
    _defineProperty$b(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "k":
        return parseNumericPattern(numericPatterns.hour24h, dateString);
      case "ko":
        return match2.ordinalNumber(dateString, {
          unit: "hour"
        });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value2) {
    return value2 >= 1 && value2 <= 24;
  }
  set(date4, _flags, value2) {
    var hours = value2 <= 24 ? value2 % 24 : value2;
    date4.setUTCHours(hours, 0, 0, 0);
    return date4;
  }
}
function _defineProperty$a(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class MinuteParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$a(this, "priority", 60);
    _defineProperty$a(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "m":
        return parseNumericPattern(numericPatterns.minute, dateString);
      case "mo":
        return match2.ordinalNumber(dateString, {
          unit: "minute"
        });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value2) {
    return value2 >= 0 && value2 <= 59;
  }
  set(date4, _flags, value2) {
    date4.setUTCMinutes(value2, 0, 0);
    return date4;
  }
}
function _defineProperty$9(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class SecondParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$9(this, "priority", 50);
    _defineProperty$9(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "s":
        return parseNumericPattern(numericPatterns.second, dateString);
      case "so":
        return match2.ordinalNumber(dateString, {
          unit: "second"
        });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value2) {
    return value2 >= 0 && value2 <= 59;
  }
  set(date4, _flags, value2) {
    date4.setUTCSeconds(value2, 0);
    return date4;
  }
}
function _defineProperty$8(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class FractionOfSecondParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$8(this, "priority", 30);
    _defineProperty$8(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token) {
    var valueCallback = function(value2) {
      return Math.floor(value2 * Math.pow(10, -token.length + 3));
    };
    return mapValue(parseNDigits(token.length, dateString), valueCallback);
  }
  set(date4, _flags, value2) {
    date4.setUTCMilliseconds(value2);
    return date4;
  }
}
function _defineProperty$7(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class ISOTimezoneWithZParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$7(this, "priority", 10);
    _defineProperty$7(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(dateString, token) {
    switch (token) {
      case "X":
        return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
      case "XX":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "XXXX":
        return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
      case "XXXXX":
        return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
      case "XXX":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date4, flags, value2) {
    if (flags.timestampIsSet) {
      return date4;
    }
    return new Date(date4.getTime() - value2);
  }
}
function _defineProperty$6(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class ISOTimezoneParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$6(this, "priority", 10);
    _defineProperty$6(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(dateString, token) {
    switch (token) {
      case "x":
        return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
      case "xx":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "xxxx":
        return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
      case "xxxxx":
        return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
      case "xxx":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date4, flags, value2) {
    if (flags.timestampIsSet) {
      return date4;
    }
    return new Date(date4.getTime() - value2);
  }
}
function _defineProperty$5(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class TimestampSecondsParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$5(this, "priority", 40);
    _defineProperty$5(this, "incompatibleTokens", "*");
  }
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(_date, _flags, value2) {
    return [new Date(value2 * 1e3), {
      timestampIsSet: true
    }];
  }
}
function _defineProperty$4(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
class TimestampMillisecondsParser extends Parser$1 {
  constructor() {
    super(...arguments);
    _defineProperty$4(this, "priority", 20);
    _defineProperty$4(this, "incompatibleTokens", "*");
  }
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(_date, _flags, value2) {
    return [new Date(value2), {
      timestampIsSet: true
    }];
  }
}
var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse$J(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs$1(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions2 = getDefaultOptions$1();
  var locale2 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : enUS$2;
  if (!locale2.match) {
    throw new RangeError("locale must contain match property");
  }
  var firstWeekContainsDate = toInteger$2((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger$2((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (formatString === "") {
    if (dateString === "") {
      return toDate$2(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2
  };
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters$2) {
      var longFormatter = longFormatters$2[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp);
  var usedTokens = [];
  var _loop = function(_token) {
    if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken$1(_token)) {
      throwProtectedError$1(_token, formatString, dirtyDateString);
    }
    if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken$1(_token)) {
      throwProtectedError$1(_token, formatString, dirtyDateString);
    }
    var firstCharacter = _token[0];
    var parser2 = parsers[firstCharacter];
    if (parser2) {
      var incompatibleTokens = parser2.incompatibleTokens;
      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = usedTokens.find(function(usedToken) {
          return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
        });
        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(_token, "` at the same time"));
        }
      } else if (parser2.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError("The format string mustn't contain `".concat(_token, "` and any other token at the same time"));
      }
      usedTokens.push({
        token: firstCharacter,
        fullToken: _token
      });
      var parseResult = parser2.run(dateString, _token, locale2.match, subFnOptions);
      if (!parseResult) {
        token = _token;
        return {
          v: new Date(NaN)
        };
      }
      setters.push(parseResult.setter);
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
      }
      if (_token === "''") {
        _token = "'";
      } else if (firstCharacter === "'") {
        _token = cleanEscapedString(_token);
      }
      if (dateString.indexOf(_token) === 0) {
        dateString = dateString.slice(_token.length);
      } else {
        token = _token;
        return {
          v: new Date(NaN)
        };
      }
    }
    token = _token;
  };
  for (var token of tokens) {
    var _ret = _loop(token);
    if (typeof _ret === "object")
      return _ret.v;
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function(setter2) {
    return setter2.priority;
  }).sort(function(a2, b2) {
    return b2 - a2;
  }).filter(function(priority, index2, array4) {
    return array4.indexOf(priority) === index2;
  }).map(function(priority) {
    return setters.filter(function(setter2) {
      return setter2.priority === priority;
    }).sort(function(a2, b2) {
      return b2.subPriority - a2.subPriority;
    });
  }).map(function(setterArray) {
    return setterArray[0];
  });
  var date4 = toDate$2(dirtyReferenceDate);
  if (isNaN(date4.getTime())) {
    return new Date(NaN);
  }
  var utcDate = subMilliseconds$1(date4, getTimezoneOffsetInMilliseconds$2(date4));
  var flags = {};
  for (var setter of uniquePrioritySetters) {
    if (!setter.validate(utcDate, subFnOptions)) {
      return new Date(NaN);
    }
    var result2 = setter.set(utcDate, flags, subFnOptions);
    if (Array.isArray(result2)) {
      utcDate = result2[0];
      assign$1(flags, result2[1]);
    } else {
      utcDate = result2;
    }
  }
  return utcDate;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function startOfHour(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  date4.setMinutes(0, 0, 0);
  return date4;
}
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var dateLeft = toDate$2(dirtyDateLeft);
  var dateRight = toDate$2(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}
function startOfSecond(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date4 = toDate$2(dirtyDate);
  date4.setMilliseconds(0);
  return date4;
}
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var dateLeft = toDate$2(dirtyDateLeft);
  var dateRight = toDate$2(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}
function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs$1(2, arguments);
  var date4 = toDate$2(dirtyDate);
  var month = toInteger$2(dirtyMonth);
  var year = date4.getFullYear();
  var day = date4.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  date4.setMonth(month, Math.min(day, daysInMonth));
  return date4;
}
function set(dirtyDate, values2) {
  requiredArgs$1(2, arguments);
  if (typeof values2 !== "object" || values2 === null) {
    throw new RangeError("values parameter must be an object");
  }
  var date4 = toDate$2(dirtyDate);
  if (isNaN(date4.getTime())) {
    return new Date(NaN);
  }
  if (values2.year != null) {
    date4.setFullYear(values2.year);
  }
  if (values2.month != null) {
    date4 = setMonth(date4, values2.month);
  }
  if (values2.date != null) {
    date4.setDate(toInteger$2(values2.date));
  }
  if (values2.hours != null) {
    date4.setHours(toInteger$2(values2.hours));
  }
  if (values2.minutes != null) {
    date4.setMinutes(toInteger$2(values2.minutes));
  }
  if (values2.seconds != null) {
    date4.setSeconds(toInteger$2(values2.seconds));
  }
  if (values2.milliseconds != null) {
    date4.setMilliseconds(toInteger$2(values2.milliseconds));
  }
  return date4;
}
function setHours(dirtyDate, dirtyHours) {
  requiredArgs$1(2, arguments);
  var date4 = toDate$2(dirtyDate);
  var hours = toInteger$2(dirtyHours);
  date4.setHours(hours);
  return date4;
}
function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs$1(2, arguments);
  var date4 = toDate$2(dirtyDate);
  var minutes = toInteger$2(dirtyMinutes);
  date4.setMinutes(minutes);
  return date4;
}
function setQuarter(dirtyDate, dirtyQuarter) {
  requiredArgs$1(2, arguments);
  var date4 = toDate$2(dirtyDate);
  var quarter = toInteger$2(dirtyQuarter);
  var oldQuarter = Math.floor(date4.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return setMonth(date4, date4.getMonth() + diff * 3);
}
function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs$1(2, arguments);
  var date4 = toDate$2(dirtyDate);
  var seconds = toInteger$2(dirtySeconds);
  date4.setSeconds(seconds);
  return date4;
}
function setYear(dirtyDate, dirtyYear) {
  requiredArgs$1(2, arguments);
  var date4 = toDate$2(dirtyDate);
  var year = toInteger$2(dirtyYear);
  if (isNaN(date4.getTime())) {
    return new Date(NaN);
  }
  date4.setFullYear(year);
  return date4;
}
var formatDistanceLocale$a = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
};
var formatDistance$l = function(token, count, options) {
  var result2;
  var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale$a[token].withPreposition : formatDistanceLocale$a[token].standalone;
  if (typeof tokenValue === "string") {
    result2 = tokenValue;
  } else if (count === 1) {
    result2 = tokenValue.one;
  } else {
    result2 = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result2;
    } else {
      return "vor " + result2;
    }
  }
  return result2;
};
var formatDistance$m = formatDistance$l;
var dateFormats$b = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y"
};
var timeFormats$b = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats$b = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong$n = {
  date: buildFormatLongFn$1({
    formats: dateFormats$b,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$b,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$b,
    defaultWidth: "full"
  })
};
var formatLong$o = formatLong$n;
var formatRelativeLocale$a = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
};
var formatRelative$l = function(token, _date, _baseDate, _options) {
  return formatRelativeLocale$a[token];
};
var formatRelative$m = formatRelative$l;
var eraValues$a = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
};
var quarterValues$a = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
};
var monthValues$a = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "M\xE4r", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
};
var formattingMonthValues$1 = {
  narrow: monthValues$a.narrow,
  abbreviated: ["Jan.", "Feb.", "M\xE4rz", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: monthValues$a.wide
};
var dayValues$a = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
};
var dayPeriodValues$a = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
};
var formattingDayPeriodValues$6 = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
};
var ordinalNumber$a = function(dirtyNumber) {
  var number4 = Number(dirtyNumber);
  return number4 + ".";
};
var localize$l = {
  ordinalNumber: ordinalNumber$a,
  era: buildLocalizeFn$1({
    values: eraValues$a,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$a,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues$a,
    formattingValues: formattingMonthValues$1,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$a,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$a,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$6,
    defaultFormattingWidth: "wide"
  })
};
var localize$m = localize$l;
var matchOrdinalNumberPattern$a = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern$a = /\d+/i;
var matchEraPatterns$a = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var parseEraPatterns$a = {
  any: [/^v/i, /^n/i]
};
var matchQuarterPatterns$a = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns$a = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$a = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns$a = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$a = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var parseDayPatterns$a = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$a = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var parseDayPeriodPatterns$a = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    evening: /abends/i,
    night: /nachts/i
  }
};
var match$l = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$a,
    parsePattern: parseOrdinalNumberPattern$a,
    valueCallback: function(value2) {
      return parseInt(value2);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$a,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$a,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$a,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$a,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$a,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$a,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$a,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$a,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$a,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$a,
    defaultParseWidth: "any"
  })
};
var match$m = match$l;
var locale$b = {
  code: "de",
  formatDistance: formatDistance$m,
  formatLong: formatLong$o,
  formatRelative: formatRelative$m,
  localize: localize$m,
  match: match$m,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var de$2 = locale$b;
var formatDistanceLocale$9 = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder"
  },
  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "et halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter"
  },
  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer"
  },
  xHours: {
    one: "en time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dager"
  },
  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker"
  },
  xWeeks: {
    one: "en uke",
    other: "{{count}} uker"
  },
  aboutXMonths: {
    one: "omtrent en m\xE5ned",
    other: "omtrent {{count}} m\xE5neder"
  },
  xMonths: {
    one: "en m\xE5ned",
    other: "{{count}} m\xE5neder"
  },
  aboutXYears: {
    one: "omtrent ett \xE5r",
    other: "omtrent {{count}} \xE5r"
  },
  xYears: {
    one: "ett \xE5r",
    other: "{{count}} \xE5r"
  },
  overXYears: {
    one: "over ett \xE5r",
    other: "over {{count}} \xE5r"
  },
  almostXYears: {
    one: "nesten ett \xE5r",
    other: "nesten {{count}} \xE5r"
  }
};
var formatDistance$j = function(token, count, options) {
  var result2;
  var tokenValue = formatDistanceLocale$9[token];
  if (typeof tokenValue === "string") {
    result2 = tokenValue;
  } else if (count === 1) {
    result2 = tokenValue.one;
  } else {
    result2 = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "om " + result2;
    } else {
      return result2 + " siden";
    }
  }
  return result2;
};
var formatDistance$k = formatDistance$j;
var dateFormats$a = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
};
var timeFormats$a = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats$a = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong$l = {
  date: buildFormatLongFn$1({
    formats: dateFormats$a,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$a,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$a,
    defaultWidth: "full"
  })
};
var formatLong$m = formatLong$l;
var formatRelativeLocale$9 = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i g\xE5r kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
};
var formatRelative$j = function(token, _date, _baseDate, _options) {
  return formatRelativeLocale$9[token];
};
var formatRelative$k = formatRelative$j;
var eraValues$9 = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["f\xF8r Kristus", "etter Kristus"]
};
var quarterValues$9 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
};
var monthValues$9 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
  wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
};
var dayValues$9 = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["s\xF8", "ma", "ti", "on", "to", "fr", "l\xF8"],
  abbreviated: ["s\xF8n", "man", "tir", "ons", "tor", "fre", "l\xF8r"],
  wide: ["s\xF8ndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "l\xF8rdag"]
};
var dayPeriodValues$9 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morg.",
    afternoon: "p\xE5 etterm.",
    evening: "p\xE5 kvelden",
    night: "p\xE5 natten"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morg.",
    afternoon: "p\xE5 etterm.",
    evening: "p\xE5 kvelden",
    night: "p\xE5 natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morgenen",
    afternoon: "p\xE5 ettermiddagen",
    evening: "p\xE5 kvelden",
    night: "p\xE5 natten"
  }
};
var ordinalNumber$9 = function(dirtyNumber, _options) {
  var number4 = Number(dirtyNumber);
  return number4 + ".";
};
var localize$j = {
  ordinalNumber: ordinalNumber$9,
  era: buildLocalizeFn$1({
    values: eraValues$9,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$9,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues$9,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$9,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$9,
    defaultWidth: "wide"
  })
};
var localize$k = localize$j;
var matchOrdinalNumberPattern$9 = /^(\d+)\.?/i;
var parseOrdinalNumberPattern$9 = /\d+/i;
var matchEraPatterns$9 = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var parseEraPatterns$9 = {
  any: [/^f/i, /^e/i]
};
var matchQuarterPatterns$9 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns$9 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$9 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var parseMonthPatterns$9 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$9 = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var parseDayPatterns$9 = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
var matchDayPeriodPatterns$9 = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var parseDayPeriodPatterns$9 = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
};
var match$j = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$9,
    parsePattern: parseOrdinalNumberPattern$9,
    valueCallback: function(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$9,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$9,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$9,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$9,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$9,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$9,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$9,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$9,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$9,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$9,
    defaultParseWidth: "any"
  })
};
var match$k = match$j;
var locale$a = {
  code: "nb",
  formatDistance: formatDistance$k,
  formatLong: formatLong$m,
  formatRelative: formatRelative$k,
  localize: localize$k,
  match: match$k,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var nb$1 = locale$a;
var formatDistanceLocale$8 = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
};
var formatDistance$h = function(token, count, options) {
  var result2;
  var tokenValue = formatDistanceLocale$8[token];
  if (typeof tokenValue === "string") {
    result2 = tokenValue;
  } else if (count === 1) {
    result2 = tokenValue.one;
  } else {
    result2 = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "over " + result2;
    } else {
      return result2 + " geleden";
    }
  }
  return result2;
};
var formatDistance$i = formatDistance$h;
var dateFormats$9 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
};
var timeFormats$9 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats$9 = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong$j = {
  date: buildFormatLongFn$1({
    formats: dateFormats$9,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$9,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$9,
    defaultWidth: "full"
  })
};
var formatLong$k = formatLong$j;
var formatRelativeLocale$8 = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
};
var formatRelative$h = function(token, _date, _baseDate, _options) {
  return formatRelativeLocale$8[token];
};
var formatRelative$i = formatRelative$h;
var eraValues$8 = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
};
var quarterValues$8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
};
var monthValues$8 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
};
var dayValues$8 = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
};
var dayPeriodValues$8 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
};
var ordinalNumber$8 = function(dirtyNumber, _options) {
  var number4 = Number(dirtyNumber);
  return number4 + "e";
};
var localize$h = {
  ordinalNumber: ordinalNumber$8,
  era: buildLocalizeFn$1({
    values: eraValues$8,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$8,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues$8,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$8,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$8,
    defaultWidth: "wide"
  })
};
var localize$i = localize$h;
var matchOrdinalNumberPattern$8 = /^(\d+)e?/i;
var parseOrdinalNumberPattern$8 = /\d+/i;
var matchEraPatterns$8 = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
};
var parseEraPatterns$8 = {
  any: [/^v/, /^n/]
};
var matchQuarterPatterns$8 = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
};
var parseQuarterPatterns$8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$8 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns$8 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
};
var matchDayPatterns$8 = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns$8 = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
};
var matchDayPeriodPatterns$8 = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns$8 = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
};
var match$h = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$8,
    parsePattern: parseOrdinalNumberPattern$8,
    valueCallback: function(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$8,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$8,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$8,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$8,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$8,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$8,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$8,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$8,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$8,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$8,
    defaultParseWidth: "any"
  })
};
var match$i = match$h;
var locale$9 = {
  code: "nl",
  formatDistance: formatDistance$i,
  formatLong: formatLong$k,
  formatRelative: formatRelative$i,
  localize: localize$i,
  match: match$i,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var nl$2 = locale$9;
var formatDistanceLocale$7 = {
  lessThanXSeconds: {
    one: "moins d\u2019une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d\u2019une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d\u2019un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu\u2019un an",
    other: "presque {{count}} ans"
  }
};
var formatDistance$f = function(token, count, options) {
  var result2;
  var form = formatDistanceLocale$7[token];
  if (typeof form === "string") {
    result2 = form;
  } else if (count === 1) {
    result2 = form.one;
  } else {
    result2 = form.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "dans " + result2;
    } else {
      return "il y a " + result2;
    }
  }
  return result2;
};
var formatDistance$g = formatDistance$f;
var dateFormats$8 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
};
var timeFormats$8 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats$8 = {
  full: "{{date}} '\xE0' {{time}}",
  long: "{{date}} '\xE0' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong$h = {
  date: buildFormatLongFn$1({
    formats: dateFormats$8,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$8,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$8,
    defaultWidth: "full"
  })
};
var formatLong$i = formatLong$h;
var formatRelativeLocale$7 = {
  lastWeek: "eeee 'dernier \xE0' p",
  yesterday: "'hier \xE0' p",
  today: "'aujourd\u2019hui \xE0' p",
  tomorrow: "'demain \xE0' p'",
  nextWeek: "eeee 'prochain \xE0' p",
  other: "P"
};
var formatRelative$f = function(token, _date, _baseDate, _options) {
  return formatRelativeLocale$7[token];
};
var formatRelative$g = formatRelative$f;
var eraValues$7 = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant J\xE9sus-Christ", "apr\xE8s J\xE9sus-Christ"]
};
var quarterValues$7 = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2\xE8me trim.", "3\xE8me trim.", "4\xE8me trim."],
  wide: ["1er trimestre", "2\xE8me trimestre", "3\xE8me trimestre", "4\xE8me trimestre"]
};
var monthValues$7 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "f\xE9vr.", "mars", "avr.", "mai", "juin", "juil.", "ao\xFBt", "sept.", "oct.", "nov.", "d\xE9c."],
  wide: ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "d\xE9cembre"]
};
var dayValues$7 = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
};
var dayPeriodValues$7 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "apr\xE8s-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l\u2019apr\xE8s-midi",
    evening: "du soir",
    night: "du matin"
  }
};
var ordinalNumber$7 = function(dirtyNumber, options) {
  var number4 = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  if (number4 === 0)
    return "0";
  var feminineUnits = ["year", "week", "hour", "minute", "second"];
  var suffix2;
  if (number4 === 1) {
    suffix2 = unit && feminineUnits.includes(unit) ? "\xE8re" : "er";
  } else {
    suffix2 = "\xE8me";
  }
  return number4 + suffix2;
};
var localize$f = {
  ordinalNumber: ordinalNumber$7,
  era: buildLocalizeFn$1({
    values: eraValues$7,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$7,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues$7,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$7,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$7,
    defaultWidth: "wide"
  })
};
var localize$g = localize$f;
var matchOrdinalNumberPattern$7 = /^(\d+)(ième|ère|ème|er|e)?/i;
var parseOrdinalNumberPattern$7 = /\d+/i;
var matchEraPatterns$7 = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var parseEraPatterns$7 = {
  any: [/^av/i, /^ap/i]
};
var matchQuarterPatterns$7 = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
};
var parseQuarterPatterns$7 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$7 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var parseMonthPatterns$7 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$7 = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var parseDayPatterns$7 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
};
var matchDayPeriodPatterns$7 = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var parseDayPeriodPatterns$7 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
};
var match$f = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$7,
    parsePattern: parseOrdinalNumberPattern$7,
    valueCallback: function(value2) {
      return parseInt(value2);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$7,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$7,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$7,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$7,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$7,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$7,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$7,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$7,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$7,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$7,
    defaultParseWidth: "any"
  })
};
var match$g = match$f;
var locale$8 = {
  code: "fr",
  formatDistance: formatDistance$g,
  formatLong: formatLong$i,
  formatRelative: formatRelative$g,
  localize: localize$g,
  match: match$g,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var fr$1 = locale$8;
var formatDistanceLocale$6 = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 d\xEDa",
    other: "{{count}} d\xEDas"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 a\xF1o",
    other: "alrededor de {{count}} a\xF1os"
  },
  xYears: {
    one: "1 a\xF1o",
    other: "{{count}} a\xF1os"
  },
  overXYears: {
    one: "m\xE1s de 1 a\xF1o",
    other: "m\xE1s de {{count}} a\xF1os"
  },
  almostXYears: {
    one: "casi 1 a\xF1o",
    other: "casi {{count}} a\xF1os"
  }
};
var formatDistance$d = function(token, count, options) {
  var result2;
  var tokenValue = formatDistanceLocale$6[token];
  if (typeof tokenValue === "string") {
    result2 = tokenValue;
  } else if (count === 1) {
    result2 = tokenValue.one;
  } else {
    result2 = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "en " + result2;
    } else {
      return "hace " + result2;
    }
  }
  return result2;
};
var formatDistance$e = formatDistance$d;
var dateFormats$7 = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
};
var timeFormats$7 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats$7 = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong$f = {
  date: buildFormatLongFn$1({
    formats: dateFormats$7,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$7,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$7,
    defaultWidth: "full"
  })
};
var formatLong$g = formatLong$f;
var formatRelativeLocale$6 = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'ma\xF1ana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
};
var formatRelativeLocalePlural = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'ma\xF1ana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
};
var formatRelative$d = function(token, date4, _baseDate, _options) {
  if (date4.getUTCHours() !== 1) {
    return formatRelativeLocalePlural[token];
  } else {
    return formatRelativeLocale$6[token];
  }
};
var formatRelative$e = formatRelative$d;
var eraValues$6 = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "despu\xE9s de cristo"]
};
var quarterValues$6 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
};
var monthValues$6 = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
};
var dayValues$6 = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "s\xE1"],
  abbreviated: ["dom", "lun", "mar", "mi\xE9", "jue", "vie", "s\xE1b"],
  wide: ["domingo", "lunes", "martes", "mi\xE9rcoles", "jueves", "viernes", "s\xE1bado"]
};
var dayPeriodValues$6 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "ma\xF1ana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "ma\xF1ana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "ma\xF1ana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
};
var formattingDayPeriodValues$5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la ma\xF1ana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la ma\xF1ana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la ma\xF1ana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
};
var ordinalNumber$6 = function(dirtyNumber, _options) {
  var number4 = Number(dirtyNumber);
  return number4 + "\xBA";
};
var localize$d = {
  ordinalNumber: ordinalNumber$6,
  era: buildLocalizeFn$1({
    values: eraValues$6,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$6,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues$6,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$6,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$6,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$5,
    defaultFormattingWidth: "wide"
  })
};
var localize$e = localize$d;
var matchOrdinalNumberPattern$6 = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern$6 = /\d+/i;
var matchEraPatterns$6 = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var parseEraPatterns$6 = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
};
var matchQuarterPatterns$6 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns$6 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$6 = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var parseMonthPatterns$6 = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
};
var matchDayPatterns$6 = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var parseDayPatterns$6 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
};
var matchDayPeriodPatterns$6 = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var parseDayPeriodPatterns$6 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
};
var match$d = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$6,
    parsePattern: parseOrdinalNumberPattern$6,
    valueCallback: function(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$6,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$6,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$6,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$6,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$6,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$6,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$6,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$6,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$6,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$6,
    defaultParseWidth: "any"
  })
};
var match$e = match$d;
var locale$7 = {
  code: "es",
  formatDistance: formatDistance$e,
  formatLong: formatLong$g,
  formatRelative: formatRelative$e,
  localize: localize$e,
  match: match$e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var es$2 = locale$7;
var formatDistanceLocale$5 = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "pi\xF9 di un anno",
    other: "pi\xF9 di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
};
var formatDistance$b = function(token, count, options) {
  var result2;
  var tokenValue = formatDistanceLocale$5[token];
  if (typeof tokenValue === "string") {
    result2 = tokenValue;
  } else if (count === 1) {
    result2 = tokenValue.one;
  } else {
    result2 = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "tra " + result2;
    } else {
      return result2 + " fa";
    }
  }
  return result2;
};
var formatDistance$c = formatDistance$b;
var dateFormats$6 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
};
var timeFormats$6 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats$6 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong$d = {
  date: buildFormatLongFn$1({
    formats: dateFormats$6,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$6,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$6,
    defaultWidth: "full"
  })
};
var formatLong$e = formatLong$d;
var weekdays = ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"];
function lastWeek(day) {
  switch (day) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + weekdays[day] + " scorso alle' p";
  }
}
function thisWeek(day) {
  return "'" + weekdays[day] + " alle' p";
}
function nextWeek(day) {
  switch (day) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + weekdays[day] + " prossimo alle' p";
  }
}
var formatRelativeLocale$5 = {
  lastWeek: function(date4, baseDate, options) {
    var day = date4.getUTCDay();
    if (isSameUTCWeek(date4, baseDate, options)) {
      return thisWeek(day);
    } else {
      return lastWeek(day);
    }
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function(date4, baseDate, options) {
    var day = date4.getUTCDay();
    if (isSameUTCWeek(date4, baseDate, options)) {
      return thisWeek(day);
    } else {
      return nextWeek(day);
    }
  },
  other: "P"
};
var formatRelative$b = function(token, date4, baseDate, options) {
  var format2 = formatRelativeLocale$5[token];
  if (typeof format2 === "function") {
    return format2(date4, baseDate, options);
  }
  return format2;
};
var formatRelative$c = formatRelative$b;
var eraValues$5 = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
};
var quarterValues$5 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
};
var monthValues$5 = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
  wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
};
var dayValues$5 = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"]
};
var dayPeriodValues$5 = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
};
var formattingDayPeriodValues$4 = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
};
var ordinalNumber$5 = function(dirtyNumber, _options) {
  var number4 = Number(dirtyNumber);
  return String(number4);
};
var localize$b = {
  ordinalNumber: ordinalNumber$5,
  era: buildLocalizeFn$1({
    values: eraValues$5,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$5,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues$5,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$5,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$5,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$4,
    defaultFormattingWidth: "wide"
  })
};
var localize$c = localize$b;
var matchOrdinalNumberPattern$5 = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern$5 = /\d+/i;
var matchEraPatterns$5 = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var parseEraPatterns$5 = {
  any: [/^a/i, /^(d|e)/i]
};
var matchQuarterPatterns$5 = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns$5 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$5 = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var parseMonthPatterns$5 = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$5 = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var parseDayPatterns$5 = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
};
var matchDayPeriodPatterns$5 = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var parseDayPeriodPatterns$5 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
};
var match$b = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$5,
    parsePattern: parseOrdinalNumberPattern$5,
    valueCallback: function(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$5,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$5,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$5,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$5,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$5,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$5,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$5,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$5,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$5,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$5,
    defaultParseWidth: "any"
  })
};
var match$c = match$b;
var locale$6 = {
  code: "it",
  formatDistance: formatDistance$c,
  formatLong: formatLong$e,
  formatRelative: formatRelative$c,
  localize: localize$c,
  match: match$c,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var it$2 = locale$6;
var formatDistanceLocale$4 = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 m\xEAs",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 m\xEAs",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
};
var formatDistance$9 = function(token, count, options) {
  var result2;
  var tokenValue = formatDistanceLocale$4[token];
  if (typeof tokenValue === "string") {
    result2 = tokenValue;
  } else if (count === 1) {
    result2 = tokenValue.one;
  } else {
    result2 = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "em " + result2;
    } else {
      return "h\xE1 " + result2;
    }
  }
  return result2;
};
var formatDistance$a = formatDistance$9;
var dateFormats$5 = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
};
var timeFormats$5 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats$5 = {
  full: "{{date}} '\xE0s' {{time}}",
  long: "{{date}} '\xE0s' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong$b = {
  date: buildFormatLongFn$1({
    formats: dateFormats$5,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$5,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$5,
    defaultWidth: "full"
  })
};
var formatLong$c = formatLong$b;
var formatRelativeLocale$4 = {
  lastWeek: function(date4) {
    var weekday = date4.getUTCDay();
    var last = weekday === 0 || weekday === 6 ? "\xFAltimo" : "\xFAltima";
    return "'" + last + "' eeee '\xE0s' p";
  },
  yesterday: "'ontem \xE0s' p",
  today: "'hoje \xE0s' p",
  tomorrow: "'amanh\xE3 \xE0s' p",
  nextWeek: "eeee '\xE0s' p",
  other: "P"
};
var formatRelative$9 = function(token, date4, _baseDate, _options) {
  var format2 = formatRelativeLocale$4[token];
  if (typeof format2 === "function") {
    return format2(date4);
  }
  return format2;
};
var formatRelative$a = formatRelative$9;
var eraValues$4 = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
};
var quarterValues$4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
};
var monthValues$4 = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
};
var dayValues$4 = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: ["domingo", "segunda", "ter\xE7a", "quarta", "quinta", "sexta", "s\xE1bado"],
  wide: ["domingo", "segunda-feira", "ter\xE7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\xE1bado"]
};
var dayPeriodValues$4 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
};
var formattingDayPeriodValues$3 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
};
var ordinalNumber$4 = function(dirtyNumber, options) {
  var number4 = Number(dirtyNumber);
  if ((options === null || options === void 0 ? void 0 : options.unit) === "week") {
    return number4 + "\xAA";
  }
  return number4 + "\xBA";
};
var localize$9 = {
  ordinalNumber: ordinalNumber$4,
  era: buildLocalizeFn$1({
    values: eraValues$4,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$4,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues$4,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$4,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$4,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$3,
    defaultFormattingWidth: "wide"
  })
};
var localize$a = localize$9;
var matchOrdinalNumberPattern$4 = /^(\d+)[ºªo]?/i;
var parseOrdinalNumberPattern$4 = /\d+/i;
var matchEraPatterns$4 = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
};
var parseEraPatterns$4 = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
};
var matchQuarterPatterns$4 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns$4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$4 = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns$4 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
};
var matchDayPatterns$4 = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var parseDayPatterns$4 = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
};
var matchDayPeriodPatterns$4 = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var parseDayPeriodPatterns$4 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
};
var match$9 = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$4,
    parsePattern: parseOrdinalNumberPattern$4,
    valueCallback: function(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$4,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$4,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$4,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$4,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$4,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$4,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$4,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$4,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$4,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$4,
    defaultParseWidth: "any"
  })
};
var match$a = match$9;
var locale$5 = {
  code: "pt-BR",
  formatDistance: formatDistance$a,
  formatLong: formatLong$c,
  formatRelative: formatRelative$a,
  localize: localize$a,
  match: match$a,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var ptBR$1 = locale$5;
function useLocale(ns2) {
  const { mergedLocaleRef, mergedDateLocaleRef } = inject(configProviderInjectionKey, null) || {};
  const localeRef = computed(() => {
    var _a2, _b2;
    return (_b2 = (_a2 = mergedLocaleRef === null || mergedLocaleRef === void 0 ? void 0 : mergedLocaleRef.value) === null || _a2 === void 0 ? void 0 : _a2[ns2]) !== null && _b2 !== void 0 ? _b2 : enUS$4[ns2];
  });
  const dateLocaleRef = computed(() => {
    var _a2;
    return (_a2 = mergedDateLocaleRef === null || mergedDateLocaleRef === void 0 ? void 0 : mergedDateLocaleRef.value) !== null && _a2 !== void 0 ? _a2 : dateEnUS;
  });
  return {
    dateLocaleRef,
    localeRef
  };
}
function useStyle(mountId, style2, clsPrefixRef) {
  if (!style2) {
    return;
  }
  const ssrAdapter2 = useSsrAdapter();
  const NConfigProvider2 = inject(configProviderInjectionKey, null);
  const mountStyle = () => {
    const clsPrefix = clsPrefixRef === null || clsPrefixRef === void 0 ? void 0 : clsPrefixRef.value;
    style2.mount({
      id: clsPrefix === void 0 ? mountId : clsPrefix + mountId,
      head: true,
      anchorMetaName: cssrAnchorMetaName,
      props: {
        bPrefix: clsPrefix ? `.${clsPrefix}-` : void 0
      },
      ssr: ssrAdapter2
    });
    if (!(NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.preflightStyleDisabled)) {
      globalStyle.mount({
        id: "n-global",
        head: true,
        anchorMetaName: cssrAnchorMetaName,
        ssr: ssrAdapter2
      });
    }
  };
  if (ssrAdapter2) {
    mountStyle();
  } else {
    onBeforeMount(mountStyle);
  }
}
function useThemeClass(componentName, hashRef, cssVarsRef, props) {
  var _a2;
  if (!cssVarsRef)
    throwError("useThemeClass", "cssVarsRef is not passed");
  const mergedThemeHashRef = (_a2 = inject(configProviderInjectionKey, null)) === null || _a2 === void 0 ? void 0 : _a2.mergedThemeHashRef;
  const themeClassRef = ref("");
  const ssrAdapter2 = useSsrAdapter();
  let renderCallback;
  const hashClassPrefix = `__${componentName}`;
  const mountStyle = () => {
    let finalThemeHash = hashClassPrefix;
    const hashValue = hashRef ? hashRef.value : void 0;
    const themeHash = mergedThemeHashRef === null || mergedThemeHashRef === void 0 ? void 0 : mergedThemeHashRef.value;
    if (themeHash)
      finalThemeHash += "-" + themeHash;
    if (hashValue)
      finalThemeHash += "-" + hashValue;
    const { themeOverrides: themeOverrides2, builtinThemeOverrides } = props;
    if (themeOverrides2) {
      finalThemeHash += "-" + murmur2(JSON.stringify(themeOverrides2));
    }
    if (builtinThemeOverrides) {
      finalThemeHash += "-" + murmur2(JSON.stringify(builtinThemeOverrides));
    }
    themeClassRef.value = finalThemeHash;
    renderCallback = () => {
      const cssVars = cssVarsRef.value;
      let style2 = "";
      for (const key in cssVars) {
        style2 += `${key}: ${cssVars[key]};`;
      }
      c$2(`.${finalThemeHash}`, style2).mount({
        id: finalThemeHash,
        ssr: ssrAdapter2
      });
      renderCallback = void 0;
    };
  };
  watchEffect(() => {
    mountStyle();
  });
  return {
    themeClass: themeClassRef,
    onRender: () => {
      renderCallback === null || renderCallback === void 0 ? void 0 : renderCallback();
    }
  };
}
function useRtl(mountId, rtlStateRef, clsPrefixRef) {
  if (!rtlStateRef)
    return void 0;
  const ssrAdapter2 = useSsrAdapter();
  const componentRtlStateRef = computed(() => {
    const { value: rtlState } = rtlStateRef;
    if (!rtlState) {
      return void 0;
    }
    const componentRtlState = rtlState[mountId];
    if (!componentRtlState) {
      return void 0;
    }
    return componentRtlState;
  });
  const mountStyle = () => {
    watchEffect(() => {
      const { value: clsPrefix } = clsPrefixRef;
      const id2 = `${clsPrefix}${mountId}Rtl`;
      if (exists(id2, ssrAdapter2))
        return;
      const { value: componentRtlState } = componentRtlStateRef;
      if (!componentRtlState)
        return;
      componentRtlState.style.mount({
        id: id2,
        head: true,
        anchorMetaName: cssrAnchorMetaName,
        props: {
          bPrefix: clsPrefix ? `.${clsPrefix}-` : void 0
        },
        ssr: ssrAdapter2
      });
    });
  };
  if (ssrAdapter2) {
    mountStyle();
  } else {
    onBeforeMount(mountStyle);
  }
  return componentRtlStateRef;
}
var AddIcon = defineComponent({
  name: "Add",
  render() {
    return h$1("svg", { width: "512", height: "512", viewBox: "0 0 512 512", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M256 112V400M400 256H112", stroke: "currentColor", "stroke-width": "32", "stroke-linecap": "round", "stroke-linejoin": "round" }));
  }
});
var ArrowDownIcon = defineComponent({
  name: "ArrowDown",
  render() {
    return h$1("svg", { viewBox: "0 0 28 28", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, h$1("g", { "fill-rule": "nonzero" }, h$1("path", { d: "M23.7916,15.2664 C24.0788,14.9679 24.0696,14.4931 23.7711,14.206 C23.4726,13.9188 22.9978,13.928 22.7106,14.2265 L14.7511,22.5007 L14.7511,3.74792 C14.7511,3.33371 14.4153,2.99792 14.0011,2.99792 C13.5869,2.99792 13.2511,3.33371 13.2511,3.74793 L13.2511,22.4998 L5.29259,14.2265 C5.00543,13.928 4.53064,13.9188 4.23213,14.206 C3.93361,14.4931 3.9244,14.9679 4.21157,15.2664 L13.2809,24.6944 C13.6743,25.1034 14.3289,25.1034 14.7223,24.6944 L23.7916,15.2664 Z" }))));
  }
});
function replaceable(name2, icon) {
  return defineComponent({
    name: upperFirst$1(name2),
    setup() {
      var _a2;
      const mergedIconsRef = (_a2 = inject(configProviderInjectionKey, null)) === null || _a2 === void 0 ? void 0 : _a2.mergedIconsRef;
      return () => {
        var _a3;
        const iconOverride = (_a3 = mergedIconsRef === null || mergedIconsRef === void 0 ? void 0 : mergedIconsRef.value) === null || _a3 === void 0 ? void 0 : _a3[name2];
        return iconOverride ? iconOverride() : icon;
      };
    }
  });
}
var AttachIcon = replaceable("attach", h$1("svg", { viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, h$1("g", { fill: "currentColor", "fill-rule": "nonzero" }, h$1("path", { d: "M3.25735931,8.70710678 L7.85355339,4.1109127 C8.82986412,3.13460197 10.4127766,3.13460197 11.3890873,4.1109127 C12.365398,5.08722343 12.365398,6.67013588 11.3890873,7.64644661 L6.08578644,12.9497475 C5.69526215,13.3402718 5.06209717,13.3402718 4.67157288,12.9497475 C4.28104858,12.5592232 4.28104858,11.9260582 4.67157288,11.5355339 L9.97487373,6.23223305 C10.1701359,6.0369709 10.1701359,5.72038841 9.97487373,5.52512627 C9.77961159,5.32986412 9.4630291,5.32986412 9.26776695,5.52512627 L3.96446609,10.8284271 C3.18341751,11.6094757 3.18341751,12.8758057 3.96446609,13.6568542 C4.74551468,14.4379028 6.01184464,14.4379028 6.79289322,13.6568542 L12.0961941,8.35355339 C13.4630291,6.98671837 13.4630291,4.77064094 12.0961941,3.40380592 C10.7293591,2.0369709 8.51328163,2.0369709 7.14644661,3.40380592 L2.55025253,8 C2.35499039,8.19526215 2.35499039,8.51184464 2.55025253,8.70710678 C2.74551468,8.90236893 3.06209717,8.90236893 3.25735931,8.70710678 Z" })))));
var BackwardIcon = defineComponent({
  name: "Backward",
  render() {
    return h$1("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M12.2674 15.793C11.9675 16.0787 11.4927 16.0672 11.2071 15.7673L6.20572 10.5168C5.9298 10.2271 5.9298 9.7719 6.20572 9.48223L11.2071 4.23177C11.4927 3.93184 11.9675 3.92031 12.2674 4.206C12.5673 4.49169 12.5789 4.96642 12.2932 5.26634L7.78458 9.99952L12.2932 14.7327C12.5789 15.0326 12.5673 15.5074 12.2674 15.793Z", fill: "currentColor" }));
  }
});
var DateIcon = replaceable("date", h$1("svg", { width: "28px", height: "28px", viewBox: "0 0 28 28", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, h$1("g", { "fill-rule": "nonzero" }, h$1("path", { d: "M21.75,3 C23.5449254,3 25,4.45507456 25,6.25 L25,21.75 C25,23.5449254 23.5449254,25 21.75,25 L6.25,25 C4.45507456,25 3,23.5449254 3,21.75 L3,6.25 C3,4.45507456 4.45507456,3 6.25,3 L21.75,3 Z M23.5,9.503 L4.5,9.503 L4.5,21.75 C4.5,22.7164983 5.28350169,23.5 6.25,23.5 L21.75,23.5 C22.7164983,23.5 23.5,22.7164983 23.5,21.75 L23.5,9.503 Z M21.75,4.5 L6.25,4.5 C5.28350169,4.5 4.5,5.28350169 4.5,6.25 L4.5,8.003 L23.5,8.003 L23.5,6.25 C23.5,5.28350169 22.7164983,4.5 21.75,4.5 Z" })))));
var FinishedIcon = defineComponent({
  name: "Checkmark",
  render() {
    return h$1("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, h$1("g", { fill: "none" }, h$1("path", { d: "M14.046 3.486a.75.75 0 0 1-.032 1.06l-7.93 7.474a.85.85 0 0 1-1.188-.022l-2.68-2.72a.75.75 0 1 1 1.068-1.053l2.234 2.267l7.468-7.038a.75.75 0 0 1 1.06.032z", fill: "currentColor" })));
  }
});
var ChevronLeftIcon = defineComponent({
  name: "ChevronLeft",
  render() {
    return h$1("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M10.3536 3.14645C10.5488 3.34171 10.5488 3.65829 10.3536 3.85355L6.20711 8L10.3536 12.1464C10.5488 12.3417 10.5488 12.6583 10.3536 12.8536C10.1583 13.0488 9.84171 13.0488 9.64645 12.8536L5.14645 8.35355C4.95118 8.15829 4.95118 7.84171 5.14645 7.64645L9.64645 3.14645C9.84171 2.95118 10.1583 2.95118 10.3536 3.14645Z", fill: "currentColor" }));
  }
});
var ChevronRightIcon = defineComponent({
  name: "ChevronRight",
  render() {
    return h$1("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M5.64645 3.14645C5.45118 3.34171 5.45118 3.65829 5.64645 3.85355L9.79289 8L5.64645 12.1464C5.45118 12.3417 5.45118 12.6583 5.64645 12.8536C5.84171 13.0488 6.15829 13.0488 6.35355 12.8536L10.8536 8.35355C11.0488 8.15829 11.0488 7.84171 10.8536 7.64645L6.35355 3.14645C6.15829 2.95118 5.84171 2.95118 5.64645 3.14645Z", fill: "currentColor" }));
  }
});
var ErrorIcon$1 = replaceable("close", h$1("svg", { viewBox: "0 0 12 12", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": true }, h$1("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, h$1("g", { fill: "currentColor", "fill-rule": "nonzero" }, h$1("path", { d: "M2.08859116,2.2156945 L2.14644661,2.14644661 C2.32001296,1.97288026 2.58943736,1.95359511 2.7843055,2.08859116 L2.85355339,2.14644661 L6,5.293 L9.14644661,2.14644661 C9.34170876,1.95118446 9.65829124,1.95118446 9.85355339,2.14644661 C10.0488155,2.34170876 10.0488155,2.65829124 9.85355339,2.85355339 L6.707,6 L9.85355339,9.14644661 C10.0271197,9.32001296 10.0464049,9.58943736 9.91140884,9.7843055 L9.85355339,9.85355339 C9.67998704,10.0271197 9.41056264,10.0464049 9.2156945,9.91140884 L9.14644661,9.85355339 L6,6.707 L2.85355339,9.85355339 C2.65829124,10.0488155 2.34170876,10.0488155 2.14644661,9.85355339 C1.95118446,9.65829124 1.95118446,9.34170876 2.14644661,9.14644661 L5.293,6 L2.14644661,2.85355339 C1.97288026,2.67998704 1.95359511,2.41056264 2.08859116,2.2156945 L2.14644661,2.14644661 L2.08859116,2.2156945 Z" })))));
var EyeIcon = defineComponent({
  name: "Eye",
  render() {
    return h$1("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, h$1("path", { d: "M255.66 112c-77.94 0-157.89 45.11-220.83 135.33a16 16 0 0 0-.27 17.77C82.92 340.8 161.8 400 255.66 400c92.84 0 173.34-59.38 221.79-135.25a16.14 16.14 0 0 0 0-17.47C428.89 172.28 347.8 112 255.66 112z", fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "32" }), h$1("circle", { cx: "256", cy: "256", r: "80", fill: "none", stroke: "currentColor", "stroke-miterlimit": "10", "stroke-width": "32" }));
  }
});
var EyeOffIcon = defineComponent({
  name: "EyeOff",
  render() {
    return h$1("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, h$1("path", { d: "M432 448a15.92 15.92 0 0 1-11.31-4.69l-352-352a16 16 0 0 1 22.62-22.62l352 352A16 16 0 0 1 432 448z", fill: "currentColor" }), h$1("path", { d: "M255.66 384c-41.49 0-81.5-12.28-118.92-36.5c-34.07-22-64.74-53.51-88.7-91v-.08c19.94-28.57 41.78-52.73 65.24-72.21a2 2 0 0 0 .14-2.94L93.5 161.38a2 2 0 0 0-2.71-.12c-24.92 21-48.05 46.76-69.08 76.92a31.92 31.92 0 0 0-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416a239.13 239.13 0 0 0 75.8-12.58a2 2 0 0 0 .77-3.31l-21.58-21.58a4 4 0 0 0-3.83-1a204.8 204.8 0 0 1-51.16 6.47z", fill: "currentColor" }), h$1("path", { d: "M490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96a227.34 227.34 0 0 0-74.89 12.83a2 2 0 0 0-.75 3.31l21.55 21.55a4 4 0 0 0 3.88 1a192.82 192.82 0 0 1 50.21-6.69c40.69 0 80.58 12.43 118.55 37c34.71 22.4 65.74 53.88 89.76 91a.13.13 0 0 1 0 .16a310.72 310.72 0 0 1-64.12 72.73a2 2 0 0 0-.15 2.95l19.9 19.89a2 2 0 0 0 2.7.13a343.49 343.49 0 0 0 68.64-78.48a32.2 32.2 0 0 0-.1-34.78z", fill: "currentColor" }), h$1("path", { d: "M256 160a95.88 95.88 0 0 0-21.37 2.4a2 2 0 0 0-1 3.38l112.59 112.56a2 2 0 0 0 3.38-1A96 96 0 0 0 256 160z", fill: "currentColor" }), h$1("path", { d: "M165.78 233.66a2 2 0 0 0-3.38 1a96 96 0 0 0 115 115a2 2 0 0 0 1-3.38z", fill: "currentColor" }));
  }
});
var TrashIcon = replaceable("trash", h$1("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, h$1("path", { d: "M432,144,403.33,419.74A32,32,0,0,1,371.55,448H140.46a32,32,0,0,1-31.78-28.26L80,144", style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;" }), h$1("rect", { x: "32", y: "64", width: "448", height: "80", rx: "16", ry: "16", style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;" }), h$1("line", { x1: "312", y1: "240", x2: "200", y2: "352", style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;" }), h$1("line", { x1: "312", y1: "352", x2: "200", y2: "240", style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;" })));
var DownloadIcon = replaceable("download", h$1("svg", { viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, h$1("g", { fill: "currentColor", "fill-rule": "nonzero" }, h$1("path", { d: "M3.5,13 L12.5,13 C12.7761424,13 13,13.2238576 13,13.5 C13,13.7454599 12.8231248,13.9496084 12.5898756,13.9919443 L12.5,14 L3.5,14 C3.22385763,14 3,13.7761424 3,13.5 C3,13.2545401 3.17687516,13.0503916 3.41012437,13.0080557 L3.5,13 L12.5,13 L3.5,13 Z M7.91012437,1.00805567 L8,1 C8.24545989,1 8.44960837,1.17687516 8.49194433,1.41012437 L8.5,1.5 L8.5,10.292 L11.1819805,7.6109127 C11.3555469,7.43734635 11.6249713,7.4180612 11.8198394,7.55305725 L11.8890873,7.6109127 C12.0626536,7.78447906 12.0819388,8.05390346 11.9469427,8.2487716 L11.8890873,8.31801948 L8.35355339,11.8535534 C8.17998704,12.0271197 7.91056264,12.0464049 7.7156945,11.9114088 L7.64644661,11.8535534 L4.1109127,8.31801948 C3.91565056,8.12275734 3.91565056,7.80617485 4.1109127,7.6109127 C4.28447906,7.43734635 4.55390346,7.4180612 4.7487716,7.55305725 L4.81801948,7.6109127 L7.5,10.292 L7.5,1.5 C7.5,1.25454011 7.67687516,1.05039163 7.91012437,1.00805567 L8,1 L7.91012437,1.00805567 Z" })))));
var EmptyIcon = defineComponent({
  name: "Empty",
  render() {
    return h$1("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M26 7.5C26 11.0899 23.0899 14 19.5 14C15.9101 14 13 11.0899 13 7.5C13 3.91015 15.9101 1 19.5 1C23.0899 1 26 3.91015 26 7.5ZM16.8536 4.14645C16.6583 3.95118 16.3417 3.95118 16.1464 4.14645C15.9512 4.34171 15.9512 4.65829 16.1464 4.85355L18.7929 7.5L16.1464 10.1464C15.9512 10.3417 15.9512 10.6583 16.1464 10.8536C16.3417 11.0488 16.6583 11.0488 16.8536 10.8536L19.5 8.20711L22.1464 10.8536C22.3417 11.0488 22.6583 11.0488 22.8536 10.8536C23.0488 10.6583 23.0488 10.3417 22.8536 10.1464L20.2071 7.5L22.8536 4.85355C23.0488 4.65829 23.0488 4.34171 22.8536 4.14645C22.6583 3.95118 22.3417 3.95118 22.1464 4.14645L19.5 6.79289L16.8536 4.14645Z", fill: "currentColor" }), h$1("path", { d: "M25 22.75V12.5991C24.5572 13.0765 24.053 13.4961 23.5 13.8454V16H17.5L17.3982 16.0068C17.0322 16.0565 16.75 16.3703 16.75 16.75C16.75 18.2688 15.5188 19.5 14 19.5C12.4812 19.5 11.25 18.2688 11.25 16.75L11.2432 16.6482C11.1935 16.2822 10.8797 16 10.5 16H4.5V7.25C4.5 6.2835 5.2835 5.5 6.25 5.5H12.2696C12.4146 4.97463 12.6153 4.47237 12.865 4H6.25C4.45507 4 3 5.45507 3 7.25V22.75C3 24.5449 4.45507 26 6.25 26H21.75C23.5449 26 25 24.5449 25 22.75ZM4.5 22.75V17.5H9.81597L9.85751 17.7041C10.2905 19.5919 11.9808 21 14 21L14.215 20.9947C16.2095 20.8953 17.842 19.4209 18.184 17.5H23.5V22.75C23.5 23.7165 22.7165 24.5 21.75 24.5H6.25C5.2835 24.5 4.5 23.7165 4.5 22.75Z", fill: "currentColor" }));
  }
});
var ErrorIcon = replaceable("error", h$1("svg", { viewBox: "0 0 48 48", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, h$1("g", { "fill-rule": "nonzero" }, h$1("path", { d: "M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M17.8838835,16.1161165 L17.7823881,16.0249942 C17.3266086,15.6583353 16.6733914,15.6583353 16.2176119,16.0249942 L16.1161165,16.1161165 L16.0249942,16.2176119 C15.6583353,16.6733914 15.6583353,17.3266086 16.0249942,17.7823881 L16.1161165,17.8838835 L22.233,24 L16.1161165,30.1161165 L16.0249942,30.2176119 C15.6583353,30.6733914 15.6583353,31.3266086 16.0249942,31.7823881 L16.1161165,31.8838835 L16.2176119,31.9750058 C16.6733914,32.3416647 17.3266086,32.3416647 17.7823881,31.9750058 L17.8838835,31.8838835 L24,25.767 L30.1161165,31.8838835 L30.2176119,31.9750058 C30.6733914,32.3416647 31.3266086,32.3416647 31.7823881,31.9750058 L31.8838835,31.8838835 L31.9750058,31.7823881 C32.3416647,31.3266086 32.3416647,30.6733914 31.9750058,30.2176119 L31.8838835,30.1161165 L25.767,24 L31.8838835,17.8838835 L31.9750058,17.7823881 C32.3416647,17.3266086 32.3416647,16.6733914 31.9750058,16.2176119 L31.8838835,16.1161165 L31.7823881,16.0249942 C31.3266086,15.6583353 30.6733914,15.6583353 30.2176119,16.0249942 L30.1161165,16.1161165 L24,22.233 L17.8838835,16.1161165 L17.7823881,16.0249942 L17.8838835,16.1161165 Z" })))));
var FastBackwardIcon = defineComponent({
  name: "FastBackward",
  render() {
    return h$1("svg", { viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, h$1("g", { fill: "currentColor", "fill-rule": "nonzero" }, h$1("path", { d: "M8.73171,16.7949 C9.03264,17.0795 9.50733,17.0663 9.79196,16.7654 C10.0766,16.4644 10.0634,15.9897 9.76243,15.7051 L4.52339,10.75 L17.2471,10.75 C17.6613,10.75 17.9971,10.4142 17.9971,10 C17.9971,9.58579 17.6613,9.25 17.2471,9.25 L4.52112,9.25 L9.76243,4.29275 C10.0634,4.00812 10.0766,3.53343 9.79196,3.2325 C9.50733,2.93156 9.03264,2.91834 8.73171,3.20297 L2.31449,9.27241 C2.14819,9.4297 2.04819,9.62981 2.01448,9.8386 C2.00308,9.89058 1.99707,9.94459 1.99707,10 C1.99707,10.0576 2.00356,10.1137 2.01585,10.1675 C2.05084,10.3733 2.15039,10.5702 2.31449,10.7254 L8.73171,16.7949 Z" }))));
  }
});
var FastForwardIcon = defineComponent({
  name: "FastForward",
  render() {
    return h$1("svg", { viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, h$1("g", { fill: "currentColor", "fill-rule": "nonzero" }, h$1("path", { d: "M11.2654,3.20511 C10.9644,2.92049 10.4897,2.93371 10.2051,3.23464 C9.92049,3.53558 9.93371,4.01027 10.2346,4.29489 L15.4737,9.25 L2.75,9.25 C2.33579,9.25 2,9.58579 2,10.0000012 C2,10.4142 2.33579,10.75 2.75,10.75 L15.476,10.75 L10.2346,15.7073 C9.93371,15.9919 9.92049,16.4666 10.2051,16.7675 C10.4897,17.0684 10.9644,17.0817 11.2654,16.797 L17.6826,10.7276 C17.8489,10.5703 17.9489,10.3702 17.9826,10.1614 C17.994,10.1094 18,10.0554 18,10.0000012 C18,9.94241 17.9935,9.88633 17.9812,9.83246 C17.9462,9.62667 17.8467,9.42976 17.6826,9.27455 L11.2654,3.20511 Z" }))));
  }
});
var FilterIcon = defineComponent({
  name: "Filter",
  render() {
    return h$1("svg", { viewBox: "0 0 28 28", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, h$1("g", { "fill-rule": "nonzero" }, h$1("path", { d: "M17,19 C17.5522847,19 18,19.4477153 18,20 C18,20.5522847 17.5522847,21 17,21 L11,21 C10.4477153,21 10,20.5522847 10,20 C10,19.4477153 10.4477153,19 11,19 L17,19 Z M21,13 C21.5522847,13 22,13.4477153 22,14 C22,14.5522847 21.5522847,15 21,15 L7,15 C6.44771525,15 6,14.5522847 6,14 C6,13.4477153 6.44771525,13 7,13 L21,13 Z M24,7 C24.5522847,7 25,7.44771525 25,8 C25,8.55228475 24.5522847,9 24,9 L4,9 C3.44771525,9 3,8.55228475 3,8 C3,7.44771525 3.44771525,7 4,7 L24,7 Z" }))));
  }
});
var ForwardIcon = defineComponent({
  name: "Forward",
  render() {
    return h$1("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M7.73271 4.20694C8.03263 3.92125 8.50737 3.93279 8.79306 4.23271L13.7944 9.48318C14.0703 9.77285 14.0703 10.2281 13.7944 10.5178L8.79306 15.7682C8.50737 16.0681 8.03263 16.0797 7.73271 15.794C7.43279 15.5083 7.42125 15.0336 7.70694 14.7336L12.2155 10.0005L7.70694 5.26729C7.42125 4.96737 7.43279 4.49264 7.73271 4.20694Z", fill: "currentColor" }));
  }
});
var InfoIcon = replaceable("info", h$1("svg", { viewBox: "0 0 28 28", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, h$1("g", { "fill-rule": "nonzero" }, h$1("path", { d: "M14,2 C20.6274,2 26,7.37258 26,14 C26,20.6274 20.6274,26 14,26 C7.37258,26 2,20.6274 2,14 C2,7.37258 7.37258,2 14,2 Z M14,11 C13.4477,11 13,11.4477 13,12 L13,12 L13,20 C13,20.5523 13.4477,21 14,21 C14.5523,21 15,20.5523 15,20 L15,20 L15,12 C15,11.4477 14.5523,11 14,11 Z M14,6.75 C13.3096,6.75 12.75,7.30964 12.75,8 C12.75,8.69036 13.3096,9.25 14,9.25 C14.6904,9.25 15.25,8.69036 15.25,8 C15.25,7.30964 14.6904,6.75 14,6.75 Z" })))));
var MoreIcon = defineComponent({
  name: "More",
  render() {
    return h$1("svg", { viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, h$1("g", { fill: "currentColor", "fill-rule": "nonzero" }, h$1("path", { d: "M4,7 C4.55228,7 5,7.44772 5,8 C5,8.55229 4.55228,9 4,9 C3.44772,9 3,8.55229 3,8 C3,7.44772 3.44772,7 4,7 Z M8,7 C8.55229,7 9,7.44772 9,8 C9,8.55229 8.55229,9 8,9 C7.44772,9 7,8.55229 7,8 C7,7.44772 7.44772,7 8,7 Z M12,7 C12.5523,7 13,7.44772 13,8 C13,8.55229 12.5523,9 12,9 C11.4477,9 11,8.55229 11,8 C11,7.44772 11.4477,7 12,7 Z" }))));
  }
});
var RemoveIcon = defineComponent({
  name: "Remove",
  render() {
    return h$1("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, h$1("line", { x1: "400", y1: "256", x2: "112", y2: "256", style: "\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 32px;\n      " }));
  }
});
var SuccessIcon = replaceable("success", h$1("svg", { viewBox: "0 0 48 48", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, h$1("g", { "fill-rule": "nonzero" }, h$1("path", { d: "M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M32.6338835,17.6161165 C32.1782718,17.1605048 31.4584514,17.1301307 30.9676119,17.5249942 L30.8661165,17.6161165 L20.75,27.732233 L17.1338835,24.1161165 C16.6457281,23.6279612 15.8542719,23.6279612 15.3661165,24.1161165 C14.9105048,24.5717282 14.8801307,25.2915486 15.2749942,25.7823881 L15.3661165,25.8838835 L19.8661165,30.3838835 C20.3217282,30.8394952 21.0415486,30.8698693 21.5323881,30.4750058 L21.6338835,30.3838835 L32.6338835,19.3838835 C33.1220388,18.8957281 33.1220388,18.1042719 32.6338835,17.6161165 Z" })))));
var TimeIcon = replaceable("time", h$1("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, h$1("path", { d: "M256,64C150,64,64,150,64,256s86,192,192,192,192-86,192-192S362,64,256,64Z", style: "\n        fill: none;\n        stroke: currentColor;\n        stroke-miterlimit: 10;\n        stroke-width: 32px;\n      " }), h$1("polyline", { points: "256 128 256 272 352 272", style: "\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 32px;\n      " })));
var WarningIcon = replaceable("warning", h$1("svg", { viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", "fill-rule": "evenodd" }, h$1("g", { "fill-rule": "nonzero" }, h$1("path", { d: "M12,2 C17.523,2 22,6.478 22,12 C22,17.522 17.523,22 12,22 C6.477,22 2,17.522 2,12 C2,6.478 6.477,2 12,2 Z M12.0018002,15.0037242 C11.450254,15.0037242 11.0031376,15.4508407 11.0031376,16.0023869 C11.0031376,16.553933 11.450254,17.0010495 12.0018002,17.0010495 C12.5533463,17.0010495 13.0004628,16.553933 13.0004628,16.0023869 C13.0004628,15.4508407 12.5533463,15.0037242 12.0018002,15.0037242 Z M11.99964,7 C11.4868042,7.00018474 11.0642719,7.38637706 11.0066858,7.8837365 L11,8.00036004 L11.0018003,13.0012393 L11.00857,13.117858 C11.0665141,13.6151758 11.4893244,14.0010638 12.0021602,14.0008793 C12.514996,14.0006946 12.9375283,13.6145023 12.9951144,13.1171428 L13.0018002,13.0005193 L13,7.99964009 L12.9932303,7.8830214 C12.9352861,7.38570354 12.5124758,6.99981552 11.99964,7 Z" })))));
var CancelIcon = replaceable("cancel", h$1("svg", { viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, h$1("g", { fill: "currentColor", "fill-rule": "nonzero" }, h$1("path", { d: "M2.58859116,2.7156945 L2.64644661,2.64644661 C2.82001296,2.47288026 3.08943736,2.45359511 3.2843055,2.58859116 L3.35355339,2.64644661 L8,7.293 L12.6464466,2.64644661 C12.8417088,2.45118446 13.1582912,2.45118446 13.3535534,2.64644661 C13.5488155,2.84170876 13.5488155,3.15829124 13.3535534,3.35355339 L8.707,8 L13.3535534,12.6464466 C13.5271197,12.820013 13.5464049,13.0894374 13.4114088,13.2843055 L13.3535534,13.3535534 C13.179987,13.5271197 12.9105626,13.5464049 12.7156945,13.4114088 L12.6464466,13.3535534 L8,8.707 L3.35355339,13.3535534 C3.15829124,13.5488155 2.84170876,13.5488155 2.64644661,13.3535534 C2.45118446,13.1582912 2.45118446,12.8417088 2.64644661,12.6464466 L7.293,8 L2.64644661,3.35355339 C2.47288026,3.17998704 2.45359511,2.91056264 2.58859116,2.7156945 L2.64644661,2.64644661 L2.58859116,2.7156945 Z" })))));
var ChevronDownIcon = defineComponent({
  name: "ChevronDown",
  render() {
    return h$1("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M3.14645 5.64645C3.34171 5.45118 3.65829 5.45118 3.85355 5.64645L8 9.79289L12.1464 5.64645C12.3417 5.45118 12.6583 5.45118 12.8536 5.64645C13.0488 5.84171 13.0488 6.15829 12.8536 6.35355L8.35355 10.8536C8.15829 11.0488 7.84171 11.0488 7.64645 10.8536L3.14645 6.35355C2.95118 6.15829 2.95118 5.84171 3.14645 5.64645Z", fill: "currentColor" }));
  }
});
var ClearIcon = replaceable("clear", h$1("svg", { viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, h$1("g", { fill: "currentColor", "fill-rule": "nonzero" }, h$1("path", { d: "M8,2 C11.3137085,2 14,4.6862915 14,8 C14,11.3137085 11.3137085,14 8,14 C4.6862915,14 2,11.3137085 2,8 C2,4.6862915 4.6862915,2 8,2 Z M6.5343055,5.83859116 C6.33943736,5.70359511 6.07001296,5.72288026 5.89644661,5.89644661 L5.89644661,5.89644661 L5.83859116,5.9656945 C5.70359511,6.16056264 5.72288026,6.42998704 5.89644661,6.60355339 L5.89644661,6.60355339 L7.293,8 L5.89644661,9.39644661 L5.83859116,9.4656945 C5.70359511,9.66056264 5.72288026,9.92998704 5.89644661,10.1035534 L5.89644661,10.1035534 L5.9656945,10.1614088 C6.16056264,10.2964049 6.42998704,10.2771197 6.60355339,10.1035534 L6.60355339,10.1035534 L8,8.707 L9.39644661,10.1035534 L9.4656945,10.1614088 C9.66056264,10.2964049 9.92998704,10.2771197 10.1035534,10.1035534 L10.1035534,10.1035534 L10.1614088,10.0343055 C10.2964049,9.83943736 10.2771197,9.57001296 10.1035534,9.39644661 L10.1035534,9.39644661 L8.707,8 L10.1035534,6.60355339 L10.1614088,6.5343055 C10.2964049,6.33943736 10.2771197,6.07001296 10.1035534,5.89644661 L10.1035534,5.89644661 L10.0343055,5.83859116 C9.83943736,5.70359511 9.57001296,5.72288026 9.39644661,5.89644661 L9.39644661,5.89644661 L8,7.293 L6.60355339,5.89644661 Z" })))));
var ChevronDownFilledIcon = defineComponent({
  name: "ChevronDownFilled",
  render() {
    return h$1("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M3.20041 5.73966C3.48226 5.43613 3.95681 5.41856 4.26034 5.70041L8 9.22652L11.7397 5.70041C12.0432 5.41856 12.5177 5.43613 12.7996 5.73966C13.0815 6.0432 13.0639 6.51775 12.7603 6.7996L8.51034 10.7996C8.22258 11.0668 7.77743 11.0668 7.48967 10.7996L3.23966 6.7996C2.93613 6.51775 2.91856 6.0432 3.20041 5.73966Z", fill: "currentColor" }));
  }
});
var ToIcon = replaceable("to", h$1("svg", { viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, h$1("g", { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" }, h$1("g", { fill: "currentColor", "fill-rule": "nonzero" }, h$1("path", { d: "M11.2654,3.20511 C10.9644,2.92049 10.4897,2.93371 10.2051,3.23464 C9.92049,3.53558 9.93371,4.01027 10.2346,4.29489 L15.4737,9.25 L2.75,9.25 C2.33579,9.25 2,9.58579 2,10.0000012 C2,10.4142 2.33579,10.75 2.75,10.75 L15.476,10.75 L10.2346,15.7073 C9.93371,15.9919 9.92049,16.4666 10.2051,16.7675 C10.4897,17.0684 10.9644,17.0817 11.2654,16.797 L17.6826,10.7276 C17.8489,10.5703 17.9489,10.3702 17.9826,10.1614 C17.994,10.1094 18,10.0554 18,10.0000012 C18,9.94241 17.9935,9.88633 17.9812,9.83246 C17.9462,9.62667 17.8467,9.42976 17.6826,9.27455 L11.2654,3.20511 Z" })))));
var RetryIcon = replaceable("retry", h$1("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" }, h$1("path", { d: "M320,146s24.36-12-64-12A160,160,0,1,0,416,294", style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 32px;" }), h$1("polyline", { points: "256 58 336 138 256 218", style: "fill: none; stroke: currentcolor; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32px;" })));
var RotateClockwiseIcon = replaceable("rotateClockwise", h$1("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 12.7916 15.3658 15.2026 13 16.3265V14.5C13 14.2239 12.7761 14 12.5 14C12.2239 14 12 14.2239 12 14.5V17.5C12 17.7761 12.2239 18 12.5 18H15.5C15.7761 18 16 17.7761 16 17.5C16 17.2239 15.7761 17 15.5 17H13.8758C16.3346 15.6357 18 13.0128 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 10.2761 2.22386 10.5 2.5 10.5C2.77614 10.5 3 10.2761 3 10Z", fill: "currentColor" }), h$1("path", { d: "M10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12ZM10 11C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10C11 10.5523 10.5523 11 10 11Z", fill: "currentColor" })));
var RotateCounterclockwiseIcon = replaceable("rotateClockwise", h$1("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 12.7916 4.63419 15.2026 7 16.3265V14.5C7 14.2239 7.22386 14 7.5 14C7.77614 14 8 14.2239 8 14.5V17.5C8 17.7761 7.77614 18 7.5 18H4.5C4.22386 18 4 17.7761 4 17.5C4 17.2239 4.22386 17 4.5 17H6.12422C3.66539 15.6357 2 13.0128 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 10.2761 17.7761 10.5 17.5 10.5C17.2239 10.5 17 10.2761 17 10Z", fill: "currentColor" }), h$1("path", { d: "M10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10C12 11.1046 11.1046 12 10 12ZM10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11Z", fill: "currentColor" })));
var ZoomInIcon = replaceable("zoomIn", h$1("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M11.5 8.5C11.5 8.22386 11.2761 8 11 8H9V6C9 5.72386 8.77614 5.5 8.5 5.5C8.22386 5.5 8 5.72386 8 6V8H6C5.72386 8 5.5 8.22386 5.5 8.5C5.5 8.77614 5.72386 9 6 9H8V11C8 11.2761 8.22386 11.5 8.5 11.5C8.77614 11.5 9 11.2761 9 11V9H11C11.2761 9 11.5 8.77614 11.5 8.5Z", fill: "currentColor" }), h$1("path", { d: "M8.5 3C11.5376 3 14 5.46243 14 8.5C14 9.83879 13.5217 11.0659 12.7266 12.0196L16.8536 16.1464C17.0488 16.3417 17.0488 16.6583 16.8536 16.8536C16.68 17.0271 16.4106 17.0464 16.2157 16.9114L16.1464 16.8536L12.0196 12.7266C11.0659 13.5217 9.83879 14 8.5 14C5.46243 14 3 11.5376 3 8.5C3 5.46243 5.46243 3 8.5 3ZM8.5 4C6.01472 4 4 6.01472 4 8.5C4 10.9853 6.01472 13 8.5 13C10.9853 13 13 10.9853 13 8.5C13 6.01472 10.9853 4 8.5 4Z", fill: "currentColor" })));
var ZoomOutIcon = replaceable("zoomOut", h$1("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M11 8C11.2761 8 11.5 8.22386 11.5 8.5C11.5 8.77614 11.2761 9 11 9H6C5.72386 9 5.5 8.77614 5.5 8.5C5.5 8.22386 5.72386 8 6 8H11Z", fill: "currentColor" }), h$1("path", { d: "M14 8.5C14 5.46243 11.5376 3 8.5 3C5.46243 3 3 5.46243 3 8.5C3 11.5376 5.46243 14 8.5 14C9.83879 14 11.0659 13.5217 12.0196 12.7266L16.1464 16.8536L16.2157 16.9114C16.4106 17.0464 16.68 17.0271 16.8536 16.8536C17.0488 16.6583 17.0488 16.3417 16.8536 16.1464L12.7266 12.0196C13.5217 11.0659 14 9.83879 14 8.5ZM4 8.5C4 6.01472 6.01472 4 8.5 4C10.9853 4 13 6.01472 13 8.5C13 10.9853 10.9853 13 8.5 13C6.01472 13 4 10.9853 4 8.5Z", fill: "currentColor" })));
var ResizeSmallIcon = defineComponent({
  name: "ResizeSmall",
  render() {
    return h$1("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, h$1("g", { fill: "none" }, h$1("path", { d: "M5.5 4A1.5 1.5 0 0 0 4 5.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 5.5 3h1a.5.5 0 0 1 0 1h-1zM16 5.5A1.5 1.5 0 0 0 14.5 4h-1a.5.5 0 0 1 0-1h1A2.5 2.5 0 0 1 17 5.5v1a.5.5 0 0 1-1 0v-1zm0 9a1.5 1.5 0 0 1-1.5 1.5h-1a.5.5 0 0 0 0 1h1a2.5 2.5 0 0 0 2.5-2.5v-1a.5.5 0 0 0-1 0v1zm-12 0A1.5 1.5 0 0 0 5.5 16h1.25a.5.5 0 0 1 0 1H5.5A2.5 2.5 0 0 1 3 14.5v-1.25a.5.5 0 0 1 1 0v1.25zM8.5 7A1.5 1.5 0 0 0 7 8.5v3A1.5 1.5 0 0 0 8.5 13h3a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 11.5 7h-3zM8 8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3z", fill: "currentColor" })));
  }
});
var NIconSwitchTransition = defineComponent({
  name: "BaseIconSwitchTransition",
  setup(_2, { slots }) {
    const isMountedRef = isMounted();
    return () => h$1(Transition, { name: "icon-switch-transition", appear: isMountedRef.value }, slots);
  }
});
var NFadeInExpandTransition = defineComponent({
  name: "FadeInExpandTransition",
  props: {
    appear: Boolean,
    group: Boolean,
    mode: String,
    onLeave: Function,
    onAfterLeave: Function,
    onAfterEnter: Function,
    width: Boolean,
    reverse: Boolean
  },
  setup(props, { slots }) {
    function handleBeforeLeave(el2) {
      if (props.width) {
        el2.style.maxWidth = `${el2.offsetWidth}px`;
      } else {
        el2.style.maxHeight = `${el2.offsetHeight}px`;
      }
      void el2.offsetWidth;
    }
    function handleLeave(el2) {
      if (props.width) {
        el2.style.maxWidth = "0";
      } else {
        el2.style.maxHeight = "0";
      }
      void el2.offsetWidth;
      const { onLeave } = props;
      if (onLeave)
        onLeave();
    }
    function handleAfterLeave(el2) {
      if (props.width) {
        el2.style.maxWidth = "";
      } else {
        el2.style.maxHeight = "";
      }
      const { onAfterLeave } = props;
      if (onAfterLeave)
        onAfterLeave();
    }
    function handleEnter(el2) {
      el2.style.transition = "none";
      if (props.width) {
        const memorizedWidth = el2.offsetWidth;
        el2.style.maxWidth = "0";
        void el2.offsetWidth;
        el2.style.transition = "";
        el2.style.maxWidth = `${memorizedWidth}px`;
      } else {
        if (props.reverse) {
          el2.style.maxHeight = `${el2.offsetHeight}px`;
          void el2.offsetHeight;
          el2.style.transition = "";
          el2.style.maxHeight = "0";
        } else {
          const memorizedHeight = el2.offsetHeight;
          el2.style.maxHeight = "0";
          void el2.offsetWidth;
          el2.style.transition = "";
          el2.style.maxHeight = `${memorizedHeight}px`;
        }
      }
      void el2.offsetWidth;
    }
    function handleAfterEnter(el2) {
      var _a2;
      if (props.width) {
        el2.style.maxWidth = "";
      } else {
        if (!props.reverse) {
          el2.style.maxHeight = "";
        }
      }
      (_a2 = props.onAfterEnter) === null || _a2 === void 0 ? void 0 : _a2.call(props);
    }
    return () => {
      const { group, width, appear, mode } = props;
      const type4 = group ? TransitionGroup : Transition;
      const resolvedProps = {
        name: width ? "fade-in-width-expand-transition" : "fade-in-height-expand-transition",
        appear,
        onEnter: handleEnter,
        onAfterEnter: handleAfterEnter,
        onBeforeLeave: handleBeforeLeave,
        onLeave: handleLeave,
        onAfterLeave: handleAfterLeave
      };
      if (!group) {
        resolvedProps.mode = mode;
      }
      return h$1(type4, resolvedProps, slots);
    };
  }
});
var style$U = cB$1("base-icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
 transform: translateZ(0);
`, [c$2("svg", `
 height: 1em;
 width: 1em;
 `)]);
var NBaseIcon = defineComponent({
  name: "BaseIcon",
  props: {
    role: String,
    ariaLabel: String,
    ariaDisabled: {
      type: Boolean,
      default: void 0
    },
    ariaHidden: {
      type: Boolean,
      default: void 0
    },
    clsPrefix: {
      type: String,
      required: true
    },
    onClick: Function,
    onMousedown: Function,
    onMouseup: Function
  },
  setup(props) {
    useStyle("-base-icon", style$U, toRef(props, "clsPrefix"));
  },
  render() {
    return h$1("i", { class: `${this.clsPrefix}-base-icon`, onClick: this.onClick, onMousedown: this.onMousedown, onMouseup: this.onMouseup, role: this.role, "aria-label": this.ariaLabel, "aria-hidden": this.ariaHidden, "aria-disabled": this.ariaDisabled }, this.$slots);
  }
});
var style$T = cB$1("base-close", `
 display: flex;
 align-items: center;
 justify-content: center;
 cursor: pointer;
 background-color: transparent;
 color: var(--n-close-icon-color);
 border-radius: var(--n-close-border-radius);
 height: var(--n-close-size);
 width: var(--n-close-size);
 font-size: var(--n-close-icon-size);
 outline: none;
 border: none;
 position: relative;
 padding: 0;
`, [cM("absolute", `
 height: var(--n-close-icon-size);
 width: var(--n-close-icon-size);
 `), c$2("&::before", `
 content: "";
 position: absolute;
 width: var(--n-close-size);
 height: var(--n-close-size);
 left: 50%;
 top: 50%;
 transform: translateY(-50%) translateX(-50%);
 transition: inherit;
 border-radius: inherit;
 `), cNotM("disabled", [c$2("&:hover", `
 color: var(--n-close-icon-color-hover);
 `), c$2("&:hover::before", `
 background-color: var(--n-close-color-hover);
 `), c$2("&:focus::before", `
 background-color: var(--n-close-color-hover);
 `), c$2("&:active", `
 color: var(--n-close-icon-color-pressed);
 `), c$2("&:active::before", `
 background-color: var(--n-close-color-pressed);
 `)]), cM("disabled", `
 cursor: not-allowed;
 color: var(--n-close-icon-color-disabled);
 background-color: transparent;
 `), cM("round", [c$2("&::before", `
 border-radius: 50%;
 `)])]);
var NBaseClose = defineComponent({
  name: "BaseClose",
  props: {
    isButtonTag: {
      type: Boolean,
      default: true
    },
    clsPrefix: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    focusable: {
      type: Boolean,
      default: true
    },
    round: Boolean,
    onClick: Function,
    absolute: Boolean
  },
  setup(props) {
    useStyle("-base-close", style$T, toRef(props, "clsPrefix"));
    return () => {
      const { clsPrefix, disabled, absolute, round, isButtonTag } = props;
      const Tag2 = isButtonTag ? "button" : "div";
      return h$1(Tag2, { type: isButtonTag ? "button" : void 0, tabindex: disabled || !props.focusable ? -1 : 0, "aria-disabled": disabled, "aria-label": "close", role: isButtonTag ? void 0 : "button", disabled, class: [
        `${clsPrefix}-base-close`,
        absolute && `${clsPrefix}-base-close--absolute`,
        disabled && `${clsPrefix}-base-close--disabled`,
        round && `${clsPrefix}-base-close--round`
      ], onMousedown: (e25) => {
        if (!props.focusable) {
          e25.preventDefault();
        }
      }, onClick: props.onClick }, h$1(NBaseIcon, { clsPrefix }, {
        default: () => h$1(ErrorIcon$1, null)
      }));
    };
  }
});
var FocusDetector = defineComponent({
  props: {
    onFocus: Function,
    onBlur: Function
  },
  setup(props) {
    return () => h$1("div", { style: "width: 0; height: 0", tabindex: 0, onFocus: props.onFocus, onBlur: props.onBlur });
  }
});
const {
  cubicBezierEaseInOut: cubicBezierEaseInOut$4
} = commonVariables$e;
function iconSwitchTransition({
  originalTransform = "",
  left = 0,
  top: top2 = 0,
  transition = `all .3s ${cubicBezierEaseInOut$4} !important`
} = {}) {
  return [c$2("&.icon-switch-transition-enter-from, &.icon-switch-transition-leave-to", {
    transform: originalTransform + " scale(0.75)",
    left,
    top: top2,
    opacity: 0
  }), c$2("&.icon-switch-transition-enter-to, &.icon-switch-transition-leave-from", {
    transform: `scale(1) ${originalTransform}`,
    left,
    top: top2,
    opacity: 1
  }), c$2("&.icon-switch-transition-enter-active, &.icon-switch-transition-leave-active", {
    transformOrigin: "center",
    position: "absolute",
    left,
    top: top2,
    transition
  })];
}
var style$S = c$2([c$2("@keyframes loading-container-rotate", `
 to {
 -webkit-transform: rotate(360deg);
 transform: rotate(360deg);
 }
 `), c$2("@keyframes loading-layer-rotate", `
 12.5% {
 -webkit-transform: rotate(135deg);
 transform: rotate(135deg);
 }
 25% {
 -webkit-transform: rotate(270deg);
 transform: rotate(270deg);
 }
 37.5% {
 -webkit-transform: rotate(405deg);
 transform: rotate(405deg);
 }
 50% {
 -webkit-transform: rotate(540deg);
 transform: rotate(540deg);
 }
 62.5% {
 -webkit-transform: rotate(675deg);
 transform: rotate(675deg);
 }
 75% {
 -webkit-transform: rotate(810deg);
 transform: rotate(810deg);
 }
 87.5% {
 -webkit-transform: rotate(945deg);
 transform: rotate(945deg);
 }
 100% {
 -webkit-transform: rotate(1080deg);
 transform: rotate(1080deg);
 } 
 `), c$2("@keyframes loading-left-spin", `
 from {
 -webkit-transform: rotate(265deg);
 transform: rotate(265deg);
 }
 50% {
 -webkit-transform: rotate(130deg);
 transform: rotate(130deg);
 }
 to {
 -webkit-transform: rotate(265deg);
 transform: rotate(265deg);
 }
 `), c$2("@keyframes loading-right-spin", `
 from {
 -webkit-transform: rotate(-265deg);
 transform: rotate(-265deg);
 }
 50% {
 -webkit-transform: rotate(-130deg);
 transform: rotate(-130deg);
 }
 to {
 -webkit-transform: rotate(-265deg);
 transform: rotate(-265deg);
 }
 `), cB$1("base-loading", `
 position: relative;
 line-height: 0;
 width: 1em;
 height: 1em;
 `, [cE$1("transition-wrapper", `
 position: absolute;
 width: 100%;
 height: 100%;
 `, [iconSwitchTransition()]), cE$1("container", `
 display: inline-flex;
 position: relative;
 direction: ltr;
 line-height: 0;
 animation: loading-container-rotate 1568.2352941176ms linear infinite;
 font-size: 0;
 letter-spacing: 0;
 white-space: nowrap;
 opacity: 1;
 width: 100%;
 height: 100%;
 `, [cE$1("svg", `
 stroke: var(--n-text-color);
 fill: transparent;
 position: absolute;
 height: 100%;
 overflow: hidden;
 `), cE$1("container-layer", `
 position: absolute;
 width: 100%;
 height: 100%;
 animation: loading-layer-rotate 5332ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
 `, [cE$1("container-layer-left", `
 display: inline-flex;
 position: relative;
 width: 50%;
 height: 100%;
 overflow: hidden;
 `, [cE$1("svg", `
 animation: loading-left-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
 width: 200%;
 `)]), cE$1("container-layer-patch", `
 position: absolute;
 top: 0;
 left: 47.5%;
 box-sizing: border-box;
 width: 5%;
 height: 100%;
 overflow: hidden;
 `, [cE$1("svg", `
 left: -900%;
 width: 2000%;
 transform: rotate(180deg);
 `)]), cE$1("container-layer-right", `
 display: inline-flex;
 position: relative;
 width: 50%;
 height: 100%;
 overflow: hidden;
 `, [cE$1("svg", `
 animation: loading-right-spin 1333ms cubic-bezier(0.4, 0, 0.2, 1) infinite both;
 left: -100%;
 width: 200%;
 `)])])]), cE$1("placeholder", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [iconSwitchTransition({
  left: "50%",
  top: "50%",
  originalTransform: "translateX(-50%) translateY(-50%)"
})])])]);
const exposedLoadingProps = {
  strokeWidth: {
    type: Number,
    default: 28
  },
  stroke: {
    type: String,
    default: void 0
  }
};
var NBaseLoading = defineComponent({
  name: "BaseLoading",
  props: Object.assign({ clsPrefix: {
    type: String,
    required: true
  }, show: {
    type: Boolean,
    default: true
  }, scale: {
    type: Number,
    default: 1
  }, radius: {
    type: Number,
    default: 100
  } }, exposedLoadingProps),
  setup(props) {
    useStyle("-base-loading", style$S, toRef(props, "clsPrefix"));
  },
  render() {
    const { clsPrefix, radius, strokeWidth, stroke, scale } = this;
    const scaledRadius = radius / scale;
    return h$1("div", { class: `${clsPrefix}-base-loading`, role: "img", "aria-label": "loading" }, h$1(NIconSwitchTransition, null, {
      default: () => this.show ? h$1("div", { key: "icon", class: `${clsPrefix}-base-loading__transition-wrapper` }, h$1("div", { class: `${clsPrefix}-base-loading__container` }, h$1("div", { class: `${clsPrefix}-base-loading__container-layer` }, h$1("div", { class: `${clsPrefix}-base-loading__container-layer-left` }, h$1("svg", { class: `${clsPrefix}-base-loading__svg`, viewBox: `0 0 ${2 * scaledRadius} ${2 * scaledRadius}`, xmlns: "http://www.w3.org/2000/svg", style: { color: stroke } }, h$1("circle", { fill: "none", stroke: "currentColor", "stroke-width": strokeWidth, "stroke-linecap": "round", cx: scaledRadius, cy: scaledRadius, r: radius - strokeWidth / 2, "stroke-dasharray": 4.91 * radius, "stroke-dashoffset": 2.46 * radius }))), h$1("div", { class: `${clsPrefix}-base-loading__container-layer-patch` }, h$1("svg", { class: `${clsPrefix}-base-loading__svg`, viewBox: `0 0 ${2 * scaledRadius} ${2 * scaledRadius}`, xmlns: "http://www.w3.org/2000/svg", style: { color: stroke } }, h$1("circle", { fill: "none", stroke: "currentColor", "stroke-width": strokeWidth, "stroke-linecap": "round", cx: scaledRadius, cy: scaledRadius, r: radius - strokeWidth / 2, "stroke-dasharray": 4.91 * radius, "stroke-dashoffset": 2.46 * radius }))), h$1("div", { class: `${clsPrefix}-base-loading__container-layer-right` }, h$1("svg", { class: `${clsPrefix}-base-loading__svg`, viewBox: `0 0 ${2 * scaledRadius} ${2 * scaledRadius}`, xmlns: "http://www.w3.org/2000/svg", style: { color: stroke } }, h$1("circle", { fill: "none", stroke: "currentColor", "stroke-width": strokeWidth, "stroke-linecap": "round", cx: scaledRadius, cy: scaledRadius, r: radius - strokeWidth / 2, "stroke-dasharray": 4.91 * radius, "stroke-dashoffset": 2.46 * radius })))))) : h$1("div", { key: "placeholder", class: `${clsPrefix}-base-loading__placeholder` }, this.$slots)
    }));
  }
});
function toArray(arg) {
  if (Array.isArray(arg))
    return arg;
  return [arg];
}
const TRAVERSE_COMMAND = {
  STOP: "STOP"
};
function traverseWithCb(treeNode, callback) {
  const command2 = callback(treeNode);
  if (treeNode.children !== void 0 && command2 !== TRAVERSE_COMMAND.STOP) {
    treeNode.children.forEach((childNode) => traverseWithCb(childNode, callback));
  }
}
function getNonLeafKeys(treeNodes, options = {}) {
  const { preserveGroup = false } = options;
  const keys2 = [];
  const cb2 = preserveGroup ? (node2) => {
    if (!node2.isLeaf) {
      keys2.push(node2.key);
      traverse(node2.children);
    }
  } : (node2) => {
    if (!node2.isLeaf) {
      if (!node2.isGroup)
        keys2.push(node2.key);
      traverse(node2.children);
    }
  };
  function traverse(nodes) {
    nodes.forEach(cb2);
  }
  traverse(treeNodes);
  return keys2;
}
function isLeaf(rawNode, getChildren2) {
  const { isLeaf: isLeaf2 } = rawNode;
  if (isLeaf2 !== void 0)
    return isLeaf2;
  else if (!getChildren2(rawNode))
    return true;
  return false;
}
function defaultGetChildren(node2) {
  return node2.children;
}
function defaultGetKey(node2) {
  return node2.key;
}
function isIgnored() {
  return false;
}
function isShallowLoaded(rawNode, getChildren2) {
  const { isLeaf: isLeaf2 } = rawNode;
  if (isLeaf2 === false && !Array.isArray(getChildren2(rawNode)))
    return false;
  return true;
}
function isDisabled(rawNode) {
  return rawNode.disabled === true;
}
function isExpilicitlyNotLoaded(rawNode, getChildren2) {
  return rawNode.isLeaf === false && !Array.isArray(getChildren2(rawNode));
}
function unwrapCheckedKeys(result2) {
  var _a2;
  if (result2 === void 0 || result2 === null)
    return [];
  if (Array.isArray(result2))
    return result2;
  return (_a2 = result2.checkedKeys) !== null && _a2 !== void 0 ? _a2 : [];
}
function unwrapIndeterminateKeys(result2) {
  var _a2;
  if (result2 === void 0 || result2 === null || Array.isArray(result2)) {
    return [];
  }
  return (_a2 = result2.indeterminateKeys) !== null && _a2 !== void 0 ? _a2 : [];
}
function merge(originalKeys, keysToAdd) {
  const set2 = new Set(originalKeys);
  keysToAdd.forEach((key) => {
    if (!set2.has(key)) {
      set2.add(key);
    }
  });
  return Array.from(set2);
}
function minus$1(originalKeys, keysToRemove) {
  const set2 = new Set(originalKeys);
  keysToRemove.forEach((key) => {
    if (set2.has(key)) {
      set2.delete(key);
    }
  });
  return Array.from(set2);
}
function isGroup(rawNode) {
  return (rawNode === null || rawNode === void 0 ? void 0 : rawNode.type) === "group";
}
function createIndexGetter(treeNodes) {
  const map2 = new Map();
  treeNodes.forEach((treeNode, i2) => {
    map2.set(treeNode.key, i2);
  });
  return (key) => {
    var _a2;
    return (_a2 = map2.get(key)) !== null && _a2 !== void 0 ? _a2 : null;
  };
}
class SubtreeNotLoadedError extends Error {
  constructor() {
    super();
    this.message = "SubtreeNotLoadedError: checking a subtree whose required nodes are not fully loaded.";
  }
}
function getExtendedCheckedKeySetAfterCheck(checkKeys, currentCheckedKeys, treeMate, allowNotLoaded) {
  return getExtendedCheckedKeySet(currentCheckedKeys.concat(checkKeys), treeMate, allowNotLoaded, false);
}
function getAvailableAscendantNodeSet(uncheckedKeys, treeMate) {
  const visitedKeys = new Set();
  uncheckedKeys.forEach((uncheckedKey) => {
    const uncheckedTreeNode = treeMate.treeNodeMap.get(uncheckedKey);
    if (uncheckedTreeNode !== void 0) {
      let nodeCursor = uncheckedTreeNode.parent;
      while (nodeCursor !== null) {
        if (nodeCursor.disabled)
          break;
        if (visitedKeys.has(nodeCursor.key))
          break;
        else {
          visitedKeys.add(nodeCursor.key);
        }
        nodeCursor = nodeCursor.parent;
      }
    }
  });
  return visitedKeys;
}
function getExtendedCheckedKeySetAfterUncheck(uncheckedKeys, currentCheckedKeys, treeMate, allowNotLoaded) {
  const extendedCheckedKeySet = getExtendedCheckedKeySet(currentCheckedKeys, treeMate, allowNotLoaded, false);
  const extendedKeySetToUncheck = getExtendedCheckedKeySet(uncheckedKeys, treeMate, allowNotLoaded, true);
  const ascendantKeySet = getAvailableAscendantNodeSet(uncheckedKeys, treeMate);
  const keysToRemove = [];
  extendedCheckedKeySet.forEach((key) => {
    if (extendedKeySetToUncheck.has(key) || ascendantKeySet.has(key)) {
      keysToRemove.push(key);
    }
  });
  keysToRemove.forEach((key) => extendedCheckedKeySet.delete(key));
  return extendedCheckedKeySet;
}
function getCheckedKeys(options, treeMate) {
  const { checkedKeys, keysToCheck, keysToUncheck, indeterminateKeys, cascade, leafOnly, checkStrategy, allowNotLoaded } = options;
  if (!cascade) {
    if (keysToCheck !== void 0) {
      return {
        checkedKeys: merge(checkedKeys, keysToCheck),
        indeterminateKeys: Array.from(indeterminateKeys)
      };
    } else if (keysToUncheck !== void 0) {
      return {
        checkedKeys: minus$1(checkedKeys, keysToUncheck),
        indeterminateKeys: Array.from(indeterminateKeys)
      };
    } else {
      return {
        checkedKeys: Array.from(checkedKeys),
        indeterminateKeys: Array.from(indeterminateKeys)
      };
    }
  }
  const { levelTreeNodeMap } = treeMate;
  let extendedCheckedKeySet;
  if (keysToUncheck !== void 0) {
    extendedCheckedKeySet = getExtendedCheckedKeySetAfterUncheck(keysToUncheck, checkedKeys, treeMate, allowNotLoaded);
  } else if (keysToCheck !== void 0) {
    extendedCheckedKeySet = getExtendedCheckedKeySetAfterCheck(keysToCheck, checkedKeys, treeMate, allowNotLoaded);
  } else {
    extendedCheckedKeySet = getExtendedCheckedKeySet(checkedKeys, treeMate, allowNotLoaded, false);
  }
  const checkStrategyIsParent = checkStrategy === "parent";
  const checkStrategyIsChild = checkStrategy === "child" || leafOnly;
  const syntheticCheckedKeySet = extendedCheckedKeySet;
  const syntheticIndeterminateKeySet = new Set();
  const maxLevel = Math.max.apply(null, Array.from(levelTreeNodeMap.keys()));
  for (let level = maxLevel; level >= 0; level -= 1) {
    const levelIsZero = level === 0;
    const levelTreeNodes = levelTreeNodeMap.get(level);
    for (const levelTreeNode of levelTreeNodes) {
      if (levelTreeNode.isLeaf)
        continue;
      const { key: levelTreeNodeKey, shallowLoaded } = levelTreeNode;
      if (checkStrategyIsChild && shallowLoaded) {
        levelTreeNode.children.forEach((v2) => {
          if (!v2.disabled && !v2.isLeaf && v2.shallowLoaded && syntheticCheckedKeySet.has(v2.key)) {
            syntheticCheckedKeySet.delete(v2.key);
          }
        });
      }
      if (levelTreeNode.disabled || !shallowLoaded) {
        continue;
      }
      let fullyChecked = true;
      let partialChecked = false;
      let allDisabled = true;
      for (const childNode of levelTreeNode.children) {
        const childKey = childNode.key;
        if (childNode.disabled)
          continue;
        if (allDisabled)
          allDisabled = false;
        if (syntheticCheckedKeySet.has(childKey)) {
          partialChecked = true;
        } else if (syntheticIndeterminateKeySet.has(childKey)) {
          partialChecked = true;
          fullyChecked = false;
          break;
        } else {
          fullyChecked = false;
          if (partialChecked) {
            break;
          }
        }
      }
      if (fullyChecked && !allDisabled) {
        if (checkStrategyIsParent) {
          levelTreeNode.children.forEach((v2) => {
            if (!v2.disabled && syntheticCheckedKeySet.has(v2.key)) {
              syntheticCheckedKeySet.delete(v2.key);
            }
          });
        }
        syntheticCheckedKeySet.add(levelTreeNodeKey);
      } else if (partialChecked) {
        syntheticIndeterminateKeySet.add(levelTreeNodeKey);
      }
      if (levelIsZero && checkStrategyIsChild && syntheticCheckedKeySet.has(levelTreeNodeKey)) {
        syntheticCheckedKeySet.delete(levelTreeNodeKey);
      }
    }
  }
  return {
    checkedKeys: Array.from(syntheticCheckedKeySet),
    indeterminateKeys: Array.from(syntheticIndeterminateKeySet)
  };
}
function getExtendedCheckedKeySet(checkedKeys, treeMate, allowNotLoaded, isUnchecking) {
  const { treeNodeMap, getChildren: getChildren2 } = treeMate;
  const visitedKeySet = new Set();
  const extendedKeySet = new Set(checkedKeys);
  checkedKeys.forEach((checkedKey) => {
    const checkedTreeNode = treeNodeMap.get(checkedKey);
    if (checkedTreeNode !== void 0) {
      traverseWithCb(checkedTreeNode, (treeNode) => {
        if (treeNode.disabled) {
          return TRAVERSE_COMMAND.STOP;
        }
        const { key } = treeNode;
        if (visitedKeySet.has(key))
          return;
        visitedKeySet.add(key);
        extendedKeySet.add(key);
        if (isExpilicitlyNotLoaded(treeNode.rawNode, getChildren2)) {
          if (isUnchecking) {
            return TRAVERSE_COMMAND.STOP;
          } else if (!allowNotLoaded) {
            throw new SubtreeNotLoadedError();
          }
        }
      });
    }
  });
  return extendedKeySet;
}
function getPath(key, { includeGroup = false, includeSelf = true }, treeMate) {
  var _a2;
  const treeNodeMap = treeMate.treeNodeMap;
  let treeNode = key === null || key === void 0 ? null : (_a2 = treeNodeMap.get(key)) !== null && _a2 !== void 0 ? _a2 : null;
  const mergedPath = {
    keyPath: [],
    treeNodePath: [],
    treeNode
  };
  if (treeNode === null || treeNode === void 0 ? void 0 : treeNode.ignored) {
    mergedPath.treeNode = null;
    return mergedPath;
  }
  while (treeNode) {
    if (!treeNode.ignored && (includeGroup || !treeNode.isGroup)) {
      mergedPath.treeNodePath.push(treeNode);
    }
    treeNode = treeNode.parent;
  }
  mergedPath.treeNodePath.reverse();
  if (!includeSelf)
    mergedPath.treeNodePath.pop();
  mergedPath.keyPath = mergedPath.treeNodePath.map((treeNode2) => treeNode2.key);
  return mergedPath;
}
function getFirstAvailableNode(nodes) {
  if (nodes.length === 0)
    return null;
  const node2 = nodes[0];
  if (node2.isGroup || node2.ignored || node2.disabled) {
    return node2.getNext();
  }
  return node2;
}
function rawGetNext(node2, loop) {
  const sibs = node2.siblings;
  const l2 = sibs.length;
  const { index: index2 } = node2;
  if (loop) {
    return sibs[(index2 + 1) % l2];
  } else {
    if (index2 === sibs.length - 1)
      return null;
    return sibs[index2 + 1];
  }
}
function move(fromNode, dir, { loop = false, includeDisabled = false } = {}) {
  const iterate = dir === "prev" ? rawGetPrev : rawGetNext;
  const getChildOptions = {
    reverse: dir === "prev"
  };
  let meet = false;
  let endNode = null;
  function traverse(node2) {
    if (node2 === null)
      return;
    if (node2 === fromNode) {
      if (!meet) {
        meet = true;
      } else if (!fromNode.disabled && !fromNode.isGroup) {
        endNode = fromNode;
        return;
      }
    } else {
      if ((!node2.disabled || includeDisabled) && !node2.ignored && !node2.isGroup) {
        endNode = node2;
        return;
      }
    }
    if (node2.isGroup) {
      const child = getChild(node2, getChildOptions);
      if (child !== null) {
        endNode = child;
      } else {
        traverse(iterate(node2, loop));
      }
    } else {
      const nextNode = iterate(node2, false);
      if (nextNode !== null) {
        traverse(nextNode);
      } else {
        const parent = rawGetParent(node2);
        if (parent === null || parent === void 0 ? void 0 : parent.isGroup) {
          traverse(iterate(parent, loop));
        } else if (loop) {
          traverse(iterate(node2, true));
        }
      }
    }
  }
  traverse(fromNode);
  return endNode;
}
function rawGetPrev(node2, loop) {
  const sibs = node2.siblings;
  const l2 = sibs.length;
  const { index: index2 } = node2;
  if (loop) {
    return sibs[(index2 - 1 + l2) % l2];
  } else {
    if (index2 === 0)
      return null;
    return sibs[index2 - 1];
  }
}
function rawGetParent(node2) {
  return node2.parent;
}
function getChild(node2, options = {}) {
  const { reverse = false } = options;
  const { children } = node2;
  if (children) {
    const { length: length2 } = children;
    const start = reverse ? length2 - 1 : 0;
    const end = reverse ? -1 : length2;
    const delta = reverse ? -1 : 1;
    for (let i2 = start; i2 !== end; i2 += delta) {
      const child = children[i2];
      if (!child.disabled && !child.ignored) {
        if (child.isGroup) {
          const childInGroup = getChild(child, options);
          if (childInGroup !== null)
            return childInGroup;
        } else {
          return child;
        }
      }
    }
  }
  return null;
}
const moveMethods = {
  getChild() {
    if (this.ignored)
      return null;
    return getChild(this);
  },
  getParent() {
    const { parent } = this;
    if (parent === null || parent === void 0 ? void 0 : parent.isGroup) {
      return parent.getParent();
    }
    return parent;
  },
  getNext(options = {}) {
    return move(this, "next", options);
  },
  getPrev(options = {}) {
    return move(this, "prev", options);
  }
};
function flatten$2(treeNodes, expandedKeys) {
  const expandedKeySet = expandedKeys ? new Set(expandedKeys) : void 0;
  const flattenedNodes = [];
  function traverse(treeNodes2) {
    treeNodes2.forEach((treeNode) => {
      flattenedNodes.push(treeNode);
      if (treeNode.isLeaf || !treeNode.children || treeNode.ignored)
        return;
      if (treeNode.isGroup) {
        traverse(treeNode.children);
      } else if (expandedKeySet === void 0 || expandedKeySet.has(treeNode.key)) {
        traverse(treeNode.children);
      }
    });
  }
  traverse(treeNodes);
  return flattenedNodes;
}
function contains$1(parent, child) {
  const parentKey = parent.key;
  while (child) {
    if (child.key === parentKey)
      return true;
    child = child.parent;
  }
  return false;
}
function createTreeNodes(rawNodes, treeNodeMap, levelTreeNodeMap, nodeProto, getChildren2, parent = null, level = 0) {
  const treeNodes = [];
  rawNodes.forEach((rawNode, index2) => {
    var _a2;
    const treeNode = Object.create(nodeProto);
    treeNode.rawNode = rawNode;
    treeNode.siblings = treeNodes;
    treeNode.level = level;
    treeNode.index = index2;
    treeNode.isFirstChild = index2 === 0;
    treeNode.isLastChild = index2 + 1 === rawNodes.length;
    treeNode.parent = parent;
    if (!treeNode.ignored) {
      const rawChildren = getChildren2(rawNode);
      if (Array.isArray(rawChildren)) {
        treeNode.children = createTreeNodes(rawChildren, treeNodeMap, levelTreeNodeMap, nodeProto, getChildren2, treeNode, level + 1);
      }
    }
    treeNodes.push(treeNode);
    treeNodeMap.set(treeNode.key, treeNode);
    if (!levelTreeNodeMap.has(level))
      levelTreeNodeMap.set(level, []);
    (_a2 = levelTreeNodeMap.get(level)) === null || _a2 === void 0 ? void 0 : _a2.push(treeNode);
  });
  return treeNodes;
}
function createTreeMate(rawNodes, options = {}) {
  var _a2;
  const treeNodeMap = new Map();
  const levelTreeNodeMap = new Map();
  const { getDisabled = isDisabled, getIgnored: getIgnored2 = isIgnored, getIsGroup: getIsGroup2 = isGroup, getKey = defaultGetKey } = options;
  const _getChildren = (_a2 = options.getChildren) !== null && _a2 !== void 0 ? _a2 : defaultGetChildren;
  const getChildren2 = options.ignoreEmptyChildren ? (node2) => {
    const children = _getChildren(node2);
    if (Array.isArray(children)) {
      if (!children.length)
        return null;
      return children;
    }
    return children;
  } : _getChildren;
  const nodeProto = Object.assign({
    get key() {
      return getKey(this.rawNode);
    },
    get disabled() {
      return getDisabled(this.rawNode);
    },
    get isGroup() {
      return getIsGroup2(this.rawNode);
    },
    get isLeaf() {
      return isLeaf(this.rawNode, getChildren2);
    },
    get shallowLoaded() {
      return isShallowLoaded(this.rawNode, getChildren2);
    },
    get ignored() {
      return getIgnored2(this.rawNode);
    },
    contains(node2) {
      return contains$1(this, node2);
    }
  }, moveMethods);
  const treeNodes = createTreeNodes(rawNodes, treeNodeMap, levelTreeNodeMap, nodeProto, getChildren2);
  function getNode2(key) {
    if (key === null || key === void 0)
      return null;
    const tmNode = treeNodeMap.get(key);
    if (tmNode && !tmNode.isGroup && !tmNode.ignored) {
      return tmNode;
    }
    return null;
  }
  function _getNode(key) {
    if (key === null || key === void 0)
      return null;
    const tmNode = treeNodeMap.get(key);
    if (tmNode && !tmNode.ignored) {
      return tmNode;
    }
    return null;
  }
  function getPrev(key, options2) {
    const node2 = _getNode(key);
    if (!node2)
      return null;
    return node2.getPrev(options2);
  }
  function getNext(key, options2) {
    const node2 = _getNode(key);
    if (!node2)
      return null;
    return node2.getNext(options2);
  }
  function getParent(key) {
    const node2 = _getNode(key);
    if (!node2)
      return null;
    return node2.getParent();
  }
  function getChild2(key) {
    const node2 = _getNode(key);
    if (!node2)
      return null;
    return node2.getChild();
  }
  const treemate = {
    treeNodes,
    treeNodeMap,
    levelTreeNodeMap,
    maxLevel: Math.max(...levelTreeNodeMap.keys()),
    getChildren: getChildren2,
    getFlattenedNodes(expandedKeys) {
      return flatten$2(treeNodes, expandedKeys);
    },
    getNode: getNode2,
    getPrev,
    getNext,
    getParent,
    getChild: getChild2,
    getFirstAvailableNode() {
      return getFirstAvailableNode(treeNodes);
    },
    getPath(key, options2 = {}) {
      return getPath(key, options2, treemate);
    },
    getCheckedKeys(checkedKeys, options2 = {}) {
      const { cascade = true, leafOnly = false, checkStrategy = "all", allowNotLoaded = false } = options2;
      return getCheckedKeys({
        checkedKeys: unwrapCheckedKeys(checkedKeys),
        indeterminateKeys: unwrapIndeterminateKeys(checkedKeys),
        cascade,
        leafOnly,
        checkStrategy,
        allowNotLoaded
      }, treemate);
    },
    check(keysToCheck, checkedKeys, options2 = {}) {
      const { cascade = true, leafOnly = false, checkStrategy = "all", allowNotLoaded = false } = options2;
      return getCheckedKeys({
        checkedKeys: unwrapCheckedKeys(checkedKeys),
        indeterminateKeys: unwrapIndeterminateKeys(checkedKeys),
        keysToCheck: keysToCheck === void 0 || keysToCheck === null ? [] : toArray(keysToCheck),
        cascade,
        leafOnly,
        checkStrategy,
        allowNotLoaded
      }, treemate);
    },
    uncheck(keysToUncheck, checkedKeys, options2 = {}) {
      const { cascade = true, leafOnly = false, checkStrategy = "all", allowNotLoaded = false } = options2;
      return getCheckedKeys({
        checkedKeys: unwrapCheckedKeys(checkedKeys),
        indeterminateKeys: unwrapIndeterminateKeys(checkedKeys),
        keysToUncheck: keysToUncheck === null || keysToUncheck === void 0 ? [] : toArray(keysToUncheck),
        cascade,
        leafOnly,
        checkStrategy,
        allowNotLoaded
      }, treemate);
    },
    getNonLeafKeys(options2 = {}) {
      return getNonLeafKeys(treeNodes, options2);
    }
  };
  return treemate;
}
const base$1 = {
  neutralBase: "#FFF",
  neutralInvertBase: "#000",
  neutralTextBase: "#000",
  neutralPopover: "#fff",
  neutralCard: "#fff",
  neutralModal: "#fff",
  neutralBody: "#fff",
  alpha1: "0.82",
  alpha2: "0.72",
  alpha3: "0.38",
  alpha4: "0.24",
  alpha5: "0.18",
  alphaClose: "0.6",
  alphaDisabled: "0.5",
  alphaDisabledInput: "0.02",
  alphaPending: "0.05",
  alphaTablePending: "0.02",
  alphaPressed: "0.07",
  alphaAvatar: "0.2",
  alphaRail: "0.14",
  alphaProgressRail: ".08",
  alphaBorder: "0.12",
  alphaDivider: "0.06",
  alphaInput: "0",
  alphaAction: "0.02",
  alphaTab: "0.04",
  alphaScrollbar: "0.25",
  alphaScrollbarHover: "0.4",
  alphaCode: "0.05",
  alphaTag: "0.02",
  primaryHover: "#36ad6a",
  primaryDefault: "#18a058",
  primaryActive: "#0c7a43",
  primarySuppl: "#36ad6a",
  infoHover: "#4098fc",
  infoDefault: "#2080f0",
  infoActive: "#1060c9",
  infoSuppl: "#4098fc",
  errorHover: "#de576d",
  errorDefault: "#d03050",
  errorActive: "#ab1f3f",
  errorSuppl: "#de576d",
  warningHover: "#fcb040",
  warningDefault: "#f0a020",
  warningActive: "#c97c10",
  warningSuppl: "#fcb040",
  successHover: "#36ad6a",
  successDefault: "#18a058",
  successActive: "#0c7a43",
  successSuppl: "#36ad6a"
};
const baseBackgroundRgb = rgba(base$1.neutralBase);
const baseInvertBackgroundRgb = rgba(base$1.neutralInvertBase);
const overlayPrefix = "rgba(" + baseInvertBackgroundRgb.slice(0, 3).join(", ") + ", ";
function overlay(alpha) {
  return overlayPrefix + String(alpha) + ")";
}
function neutral(alpha) {
  const overlayRgba = Array.from(baseInvertBackgroundRgb);
  overlayRgba[3] = Number(alpha);
  return composite(baseBackgroundRgb, overlayRgba);
}
const derived = Object.assign(Object.assign({ name: "common" }, commonVariables$e), {
  baseColor: base$1.neutralBase,
  primaryColor: base$1.primaryDefault,
  primaryColorHover: base$1.primaryHover,
  primaryColorPressed: base$1.primaryActive,
  primaryColorSuppl: base$1.primarySuppl,
  infoColor: base$1.infoDefault,
  infoColorHover: base$1.infoHover,
  infoColorPressed: base$1.infoActive,
  infoColorSuppl: base$1.infoSuppl,
  successColor: base$1.successDefault,
  successColorHover: base$1.successHover,
  successColorPressed: base$1.successActive,
  successColorSuppl: base$1.successSuppl,
  warningColor: base$1.warningDefault,
  warningColorHover: base$1.warningHover,
  warningColorPressed: base$1.warningActive,
  warningColorSuppl: base$1.warningSuppl,
  errorColor: base$1.errorDefault,
  errorColorHover: base$1.errorHover,
  errorColorPressed: base$1.errorActive,
  errorColorSuppl: base$1.errorSuppl,
  textColorBase: base$1.neutralTextBase,
  textColor1: "rgb(31, 34, 37)",
  textColor2: "rgb(51, 54, 57)",
  textColor3: "rgb(118, 124, 130)",
  textColorDisabled: neutral(base$1.alpha4),
  placeholderColor: neutral(base$1.alpha4),
  placeholderColorDisabled: neutral(base$1.alpha5),
  iconColor: neutral(base$1.alpha4),
  iconColorHover: scaleColor(neutral(base$1.alpha4), { lightness: 0.75 }),
  iconColorPressed: scaleColor(neutral(base$1.alpha4), { lightness: 0.9 }),
  iconColorDisabled: neutral(base$1.alpha5),
  opacity1: base$1.alpha1,
  opacity2: base$1.alpha2,
  opacity3: base$1.alpha3,
  opacity4: base$1.alpha4,
  opacity5: base$1.alpha5,
  dividerColor: "rgb(239, 239, 245)",
  borderColor: "rgb(224, 224, 230)",
  closeIconColor: neutral(Number(base$1.alphaClose)),
  closeIconColorHover: neutral(Number(base$1.alphaClose)),
  closeIconColorPressed: neutral(Number(base$1.alphaClose)),
  closeColorHover: "rgba(0, 0, 0, .09)",
  closeColorPressed: "rgba(0, 0, 0, .13)",
  clearColor: neutral(base$1.alpha4),
  clearColorHover: scaleColor(neutral(base$1.alpha4), { lightness: 0.75 }),
  clearColorPressed: scaleColor(neutral(base$1.alpha4), { lightness: 0.9 }),
  scrollbarColor: overlay(base$1.alphaScrollbar),
  scrollbarColorHover: overlay(base$1.alphaScrollbarHover),
  scrollbarWidth: "5px",
  scrollbarHeight: "5px",
  scrollbarBorderRadius: "5px",
  progressRailColor: neutral(base$1.alphaProgressRail),
  railColor: "rgb(219, 219, 223)",
  popoverColor: base$1.neutralPopover,
  tableColor: base$1.neutralCard,
  cardColor: base$1.neutralCard,
  modalColor: base$1.neutralModal,
  bodyColor: base$1.neutralBody,
  tagColor: "#eee",
  avatarColor: neutral(base$1.alphaAvatar),
  invertedColor: "rgb(0, 20, 40)",
  inputColor: neutral(base$1.alphaInput),
  codeColor: "rgb(244, 244, 248)",
  tabColor: "rgb(247, 247, 250)",
  actionColor: "rgb(250, 250, 252)",
  tableHeaderColor: "rgb(250, 250, 252)",
  hoverColor: "rgb(243, 243, 245)",
  tableColorHover: "rgba(0, 0, 100, 0.03)",
  tableColorStriped: "rgba(0, 0, 100, 0.02)",
  pressedColor: "rgb(237, 237, 239)",
  opacityDisabled: base$1.alphaDisabled,
  inputColorDisabled: "rgb(250, 250, 252)",
  buttonColor2: "rgba(46, 51, 56, .05)",
  buttonColor2Hover: "rgba(46, 51, 56, .09)",
  buttonColor2Pressed: "rgba(46, 51, 56, .13)",
  boxShadow1: "0 1px 2px -2px rgba(0, 0, 0, .08), 0 3px 6px 0 rgba(0, 0, 0, .06), 0 5px 12px 4px rgba(0, 0, 0, .04)",
  boxShadow2: "0 3px 6px -4px rgba(0, 0, 0, .12), 0 6px 16px 0 rgba(0, 0, 0, .08), 0 9px 28px 8px rgba(0, 0, 0, .05)",
  boxShadow3: "0 6px 16px -9px rgba(0, 0, 0, .08), 0 9px 28px 0 rgba(0, 0, 0, .05), 0 12px 48px 16px rgba(0, 0, 0, .03)"
});
var commonLight = derived;
var commonVars$9 = {
  iconSizeSmall: "34px",
  iconSizeMedium: "40px",
  iconSizeLarge: "46px",
  iconSizeHuge: "52px"
};
const self$K = (vars) => {
  const { textColorDisabled, iconColor, textColor2, fontSizeSmall, fontSizeMedium, fontSizeLarge, fontSizeHuge } = vars;
  return Object.assign(Object.assign({}, commonVars$9), {
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    fontSizeHuge,
    textColor: textColorDisabled,
    iconColor,
    extraTextColor: textColor2
  });
};
const emptyLight = {
  name: "Empty",
  common: commonLight,
  self: self$K
};
var emptyLight$1 = emptyLight;
var style$R = cB$1("empty", `
 display: flex;
 flex-direction: column;
 align-items: center;
 font-size: var(--n-font-size);
`, [cE$1("icon", `
 width: var(--n-icon-size);
 height: var(--n-icon-size);
 font-size: var(--n-icon-size);
 line-height: var(--n-icon-size);
 color: var(--n-icon-color);
 transition:
 color .3s var(--n-bezier);
 `, [c$2("+", [cE$1("description", `
 margin-top: 8px;
 `)])]), cE$1("description", `
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), cE$1("extra", `
 text-align: center;
 transition: color .3s var(--n-bezier);
 margin-top: 12px;
 color: var(--n-extra-text-color);
 `)]);
const emptyProps = Object.assign(Object.assign({}, useTheme.props), { description: String, showDescription: {
  type: Boolean,
  default: true
}, showIcon: {
  type: Boolean,
  default: true
}, size: {
  type: String,
  default: "medium"
}, renderIcon: Function });
var NEmpty = defineComponent({
  name: "Empty",
  props: emptyProps,
  setup(props) {
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Empty", "-empty", style$R, emptyLight$1, props, mergedClsPrefixRef);
    const { localeRef } = useLocale("Empty");
    const NConfigProvider2 = inject(configProviderInjectionKey, null);
    const mergedDescriptionRef = computed(() => {
      var _a2, _b2, _c2;
      return (_a2 = props.description) !== null && _a2 !== void 0 ? _a2 : (_c2 = (_b2 = NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedComponentPropsRef.value) === null || _b2 === void 0 ? void 0 : _b2.Empty) === null || _c2 === void 0 ? void 0 : _c2.description;
    });
    const mergedRenderIconRef = computed(() => {
      var _a2, _b2;
      return ((_b2 = (_a2 = NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedComponentPropsRef.value) === null || _a2 === void 0 ? void 0 : _a2.Empty) === null || _b2 === void 0 ? void 0 : _b2.renderIcon) || (() => h$1(EmptyIcon, null));
    });
    const cssVarsRef = computed(() => {
      const { size: size2 } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { [createKey("iconSize", size2)]: iconSize, [createKey("fontSize", size2)]: fontSize2, textColor, iconColor, extraTextColor } } = themeRef.value;
      return {
        "--n-icon-size": iconSize,
        "--n-font-size": fontSize2,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-text-color": textColor,
        "--n-icon-color": iconColor,
        "--n-extra-text-color": extraTextColor
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("empty", computed(() => {
      let hash2 = "";
      const { size: size2 } = props;
      hash2 += size2[0];
      return hash2;
    }), cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      mergedRenderIcon: mergedRenderIconRef,
      localizedDescription: computed(() => {
        return mergedDescriptionRef.value || localeRef.value.description;
      }),
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const { $slots, mergedClsPrefix, onRender } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { class: [`${mergedClsPrefix}-empty`, this.themeClass], style: this.cssVars }, this.showIcon ? h$1("div", { class: `${mergedClsPrefix}-empty__icon` }, $slots.icon ? $slots.icon() : h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, { default: this.mergedRenderIcon })) : null, this.showDescription ? h$1("div", { class: `${mergedClsPrefix}-empty__description` }, $slots.default ? $slots.default() : this.localizedDescription) : null, $slots.extra ? h$1("div", { class: `${mergedClsPrefix}-empty__extra` }, $slots.extra()) : null);
  }
});
const self$J = (vars) => {
  const { scrollbarColor, scrollbarColorHover } = vars;
  return {
    color: scrollbarColor,
    colorHover: scrollbarColorHover
  };
};
const scrollbarLight = {
  name: "Scrollbar",
  common: commonLight,
  self: self$J
};
var scrollbarLight$1 = scrollbarLight;
const {
  cubicBezierEaseInOut: cubicBezierEaseInOut$3
} = commonVariables$e;
function fadeInTransition({
  name: name2 = "fade-in",
  enterDuration = "0.2s",
  leaveDuration = "0.2s",
  enterCubicBezier = cubicBezierEaseInOut$3,
  leaveCubicBezier = cubicBezierEaseInOut$3
} = {}) {
  return [c$2(`&.${name2}-transition-enter-active`, {
    transition: `all ${enterDuration} ${enterCubicBezier}!important`
  }), c$2(`&.${name2}-transition-leave-active`, {
    transition: `all ${leaveDuration} ${leaveCubicBezier}!important`
  }), c$2(`&.${name2}-transition-enter-from, &.${name2}-transition-leave-to`, {
    opacity: 0
  }), c$2(`&.${name2}-transition-leave-from, &.${name2}-transition-enter-to`, {
    opacity: 1
  })];
}
var style$Q = cB$1("scrollbar", `
 overflow: hidden;
 position: relative;
 z-index: auto;
 height: 100%;
 width: 100%;
`, [c$2(">", [cB$1("scrollbar-container", `
 width: 100%;
 overflow: scroll;
 height: 100%;
 max-height: inherit;
 scrollbar-width: none;
 `, [c$2("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", `
 width: 0;
 height: 0;
 display: none;
 `), c$2(">", [cB$1("scrollbar-content", `
 box-sizing: border-box;
 min-width: 100%;
 `)])])]), c$2(">, +", [cB$1("scrollbar-rail", `
 position: absolute;
 pointer-events: none;
 user-select: none;
 -webkit-user-select: none;
 `, [cM("horizontal", `
 left: 2px;
 right: 2px;
 bottom: 4px;
 height: var(--n-scrollbar-height);
 `, [c$2(">", [cE$1("scrollbar", `
 height: var(--n-scrollbar-height);
 border-radius: var(--n-scrollbar-border-radius);
 right: 0;
 `)])]), cM("vertical", `
 right: 4px;
 top: 2px;
 bottom: 2px;
 width: var(--n-scrollbar-width);
 `, [c$2(">", [cE$1("scrollbar", `
 width: var(--n-scrollbar-width);
 border-radius: var(--n-scrollbar-border-radius);
 bottom: 0;
 `)])]), cM("disabled", [c$2(">", [cE$1("scrollbar", {
  pointerEvents: "none"
})])]), c$2(">", [cE$1("scrollbar", `
 position: absolute;
 cursor: pointer;
 pointer-events: all;
 background-color: var(--n-scrollbar-color);
 transition: background-color .2s var(--n-scrollbar-bezier);
 `, [fadeInTransition(), c$2("&:hover", {
  backgroundColor: "var(--n-scrollbar-color-hover)"
})])])])])]);
const scrollbarProps = Object.assign(Object.assign({}, useTheme.props), {
  size: {
    type: Number,
    default: 5
  },
  duration: {
    type: Number,
    default: 0
  },
  scrollable: {
    type: Boolean,
    default: true
  },
  xScrollable: Boolean,
  trigger: {
    type: String,
    default: "hover"
  },
  useUnifiedContainer: Boolean,
  triggerDisplayManually: Boolean,
  container: Function,
  content: Function,
  containerClass: String,
  containerStyle: [String, Object],
  contentClass: String,
  contentStyle: [String, Object],
  horizontalRailStyle: [String, Object],
  verticalRailStyle: [String, Object],
  onScroll: Function,
  onWheel: Function,
  onResize: Function,
  internalOnUpdateScrollLeft: Function,
  internalHoistYRail: Boolean
});
const Scrollbar = defineComponent({
  name: "Scrollbar",
  props: scrollbarProps,
  inheritAttrs: false,
  setup(props) {
    const { mergedClsPrefixRef, inlineThemeDisabled, mergedRtlRef } = useConfig(props);
    const rtlEnabledRef = useRtl("Scrollbar", mergedRtlRef, mergedClsPrefixRef);
    const wrapperRef = ref(null);
    const containerRef = ref(null);
    const contentRef = ref(null);
    const yRailRef = ref(null);
    const xRailRef = ref(null);
    const contentHeightRef = ref(null);
    const contentWidthRef = ref(null);
    const containerHeightRef = ref(null);
    const containerWidthRef = ref(null);
    const yRailSizeRef = ref(null);
    const xRailSizeRef = ref(null);
    const containerScrollTopRef = ref(0);
    const containerScrollLeftRef = ref(0);
    const isShowXBarRef = ref(false);
    const isShowYBarRef = ref(false);
    let yBarPressed = false;
    let xBarPressed = false;
    let xBarVanishTimerId;
    let yBarVanishTimerId;
    let memoYTop = 0;
    let memoXLeft = 0;
    let memoMouseX = 0;
    let memoMouseY = 0;
    const isIos2 = useIsIos();
    const yBarSizeRef = computed(() => {
      const { value: containerHeight } = containerHeightRef;
      const { value: contentHeight } = contentHeightRef;
      const { value: yRailSize } = yRailSizeRef;
      if (containerHeight === null || contentHeight === null || yRailSize === null) {
        return 0;
      } else {
        return Math.min(containerHeight, yRailSize * containerHeight / contentHeight + props.size * 1.5);
      }
    });
    const yBarSizePxRef = computed(() => {
      return `${yBarSizeRef.value}px`;
    });
    const xBarSizeRef = computed(() => {
      const { value: containerWidth } = containerWidthRef;
      const { value: contentWidth } = contentWidthRef;
      const { value: xRailSize } = xRailSizeRef;
      if (containerWidth === null || contentWidth === null || xRailSize === null) {
        return 0;
      } else {
        return xRailSize * containerWidth / contentWidth + props.size * 1.5;
      }
    });
    const xBarSizePxRef = computed(() => {
      return `${xBarSizeRef.value}px`;
    });
    const yBarTopRef = computed(() => {
      const { value: containerHeight } = containerHeightRef;
      const { value: containerScrollTop } = containerScrollTopRef;
      const { value: contentHeight } = contentHeightRef;
      const { value: yRailSize } = yRailSizeRef;
      if (containerHeight === null || contentHeight === null || yRailSize === null) {
        return 0;
      } else {
        const heightDiff = contentHeight - containerHeight;
        if (!heightDiff)
          return 0;
        return containerScrollTop / heightDiff * (yRailSize - yBarSizeRef.value);
      }
    });
    const yBarTopPxRef = computed(() => {
      return `${yBarTopRef.value}px`;
    });
    const xBarLeftRef = computed(() => {
      const { value: containerWidth } = containerWidthRef;
      const { value: containerScrollLeft } = containerScrollLeftRef;
      const { value: contentWidth } = contentWidthRef;
      const { value: xRailSize } = xRailSizeRef;
      if (containerWidth === null || contentWidth === null || xRailSize === null) {
        return 0;
      } else {
        const widthDiff = contentWidth - containerWidth;
        if (!widthDiff)
          return 0;
        return containerScrollLeft / widthDiff * (xRailSize - xBarSizeRef.value);
      }
    });
    const xBarLeftPxRef = computed(() => {
      return `${xBarLeftRef.value}px`;
    });
    const needYBarRef = computed(() => {
      const { value: containerHeight } = containerHeightRef;
      const { value: contentHeight } = contentHeightRef;
      return containerHeight !== null && contentHeight !== null && contentHeight > containerHeight;
    });
    const needXBarRef = computed(() => {
      const { value: containerWidth } = containerWidthRef;
      const { value: contentWidth } = contentWidthRef;
      return containerWidth !== null && contentWidth !== null && contentWidth > containerWidth;
    });
    const mergedShowXBarRef = computed(() => {
      const { trigger: trigger2 } = props;
      return trigger2 === "none" || isShowXBarRef.value;
    });
    const mergedShowYBarRef = computed(() => {
      const { trigger: trigger2 } = props;
      return trigger2 === "none" || isShowYBarRef.value;
    });
    const mergedContainerRef = computed(() => {
      const { container } = props;
      if (container)
        return container();
      return containerRef.value;
    });
    const mergedContentRef = computed(() => {
      const { content: content2 } = props;
      if (content2)
        return content2();
      return contentRef.value;
    });
    const activateState = useReactivated(() => {
      if (!props.container) {
        scrollTo({
          top: containerScrollTopRef.value,
          left: containerScrollLeftRef.value
        });
      }
    });
    const handleContentResize = () => {
      if (activateState.isDeactivated)
        return;
      sync();
    };
    const handleContainerResize = (e25) => {
      if (activateState.isDeactivated)
        return;
      const { onResize } = props;
      if (onResize)
        onResize(e25);
      sync();
    };
    const scrollTo = (options, y2) => {
      if (!props.scrollable)
        return;
      if (typeof options === "number") {
        scrollToPosition(y2 !== null && y2 !== void 0 ? y2 : 0, options, 0, false, "auto");
        return;
      }
      const { left, top: top2, index: index2, elSize, position, behavior, el: el2, debounce: debounce2 = true } = options;
      if (left !== void 0 || top2 !== void 0) {
        scrollToPosition(left !== null && left !== void 0 ? left : 0, top2 !== null && top2 !== void 0 ? top2 : 0, 0, false, behavior);
      }
      if (el2 !== void 0) {
        scrollToPosition(0, el2.offsetTop, el2.offsetHeight, debounce2, behavior);
      } else if (index2 !== void 0 && elSize !== void 0) {
        scrollToPosition(0, index2 * elSize, elSize, debounce2, behavior);
      } else if (position === "bottom") {
        scrollToPosition(0, Number.MAX_SAFE_INTEGER, 0, false, behavior);
      } else if (position === "top") {
        scrollToPosition(0, 0, 0, false, behavior);
      }
    };
    const scrollBy = (options, y2) => {
      if (!props.scrollable)
        return;
      const { value: container } = mergedContainerRef;
      if (!container)
        return;
      if (typeof options === "object") {
        container.scrollBy(options);
      } else {
        container.scrollBy(options, y2 || 0);
      }
    };
    function scrollToPosition(left, top2, elSize, debounce2, behavior) {
      const { value: container } = mergedContainerRef;
      if (!container)
        return;
      if (debounce2) {
        const { scrollTop, offsetHeight } = container;
        if (top2 > scrollTop) {
          if (top2 + elSize <= scrollTop + offsetHeight)
            ;
          else {
            container.scrollTo({
              left,
              top: top2 + elSize - offsetHeight,
              behavior
            });
          }
          return;
        }
      }
      container.scrollTo({
        left,
        top: top2,
        behavior
      });
    }
    function handleMouseEnterWrapper() {
      showXBar();
      showYBar();
      sync();
    }
    function handleMouseLeaveWrapper() {
      hideBar();
    }
    function hideBar() {
      hideYBar();
      hideXBar();
    }
    function hideYBar() {
      if (yBarVanishTimerId !== void 0) {
        window.clearTimeout(yBarVanishTimerId);
      }
      yBarVanishTimerId = window.setTimeout(() => {
        isShowYBarRef.value = false;
      }, props.duration);
    }
    function hideXBar() {
      if (xBarVanishTimerId !== void 0) {
        window.clearTimeout(xBarVanishTimerId);
      }
      xBarVanishTimerId = window.setTimeout(() => {
        isShowXBarRef.value = false;
      }, props.duration);
    }
    function showXBar() {
      if (xBarVanishTimerId !== void 0) {
        window.clearTimeout(xBarVanishTimerId);
      }
      isShowXBarRef.value = true;
    }
    function showYBar() {
      if (yBarVanishTimerId !== void 0) {
        window.clearTimeout(yBarVanishTimerId);
      }
      isShowYBarRef.value = true;
    }
    function handleScroll(e25) {
      const { onScroll } = props;
      if (onScroll)
        onScroll(e25);
      syncScrollState();
    }
    function syncScrollState() {
      const { value: container } = mergedContainerRef;
      if (container) {
        containerScrollTopRef.value = container.scrollTop;
        containerScrollLeftRef.value = container.scrollLeft * ((rtlEnabledRef === null || rtlEnabledRef === void 0 ? void 0 : rtlEnabledRef.value) ? -1 : 1);
      }
    }
    function syncPositionState() {
      const { value: content2 } = mergedContentRef;
      if (content2) {
        contentHeightRef.value = content2.offsetHeight;
        contentWidthRef.value = content2.offsetWidth;
      }
      const { value: container } = mergedContainerRef;
      if (container) {
        containerHeightRef.value = container.offsetHeight;
        containerWidthRef.value = container.offsetWidth;
      }
      const { value: xRailEl } = xRailRef;
      const { value: yRailEl } = yRailRef;
      if (xRailEl) {
        xRailSizeRef.value = xRailEl.offsetWidth;
      }
      if (yRailEl) {
        yRailSizeRef.value = yRailEl.offsetHeight;
      }
    }
    function syncUnifiedContainer() {
      const { value: container } = mergedContainerRef;
      if (container) {
        containerScrollTopRef.value = container.scrollTop;
        containerScrollLeftRef.value = container.scrollLeft * ((rtlEnabledRef === null || rtlEnabledRef === void 0 ? void 0 : rtlEnabledRef.value) ? -1 : 1);
        containerHeightRef.value = container.offsetHeight;
        containerWidthRef.value = container.offsetWidth;
        contentHeightRef.value = container.scrollHeight;
        contentWidthRef.value = container.scrollWidth;
      }
      const { value: xRailEl } = xRailRef;
      const { value: yRailEl } = yRailRef;
      if (xRailEl) {
        xRailSizeRef.value = xRailEl.offsetWidth;
      }
      if (yRailEl) {
        yRailSizeRef.value = yRailEl.offsetHeight;
      }
    }
    function sync() {
      if (!props.scrollable)
        return;
      if (props.useUnifiedContainer) {
        syncUnifiedContainer();
      } else {
        syncPositionState();
        syncScrollState();
      }
    }
    function isMouseUpAway(e25) {
      var _a2;
      return !((_a2 = wrapperRef.value) === null || _a2 === void 0 ? void 0 : _a2.contains(getPreciseEventTarget(e25)));
    }
    function handleXScrollMouseDown(e25) {
      e25.preventDefault();
      e25.stopPropagation();
      xBarPressed = true;
      on$1("mousemove", window, handleXScrollMouseMove, true);
      on$1("mouseup", window, handleXScrollMouseUp, true);
      memoXLeft = containerScrollLeftRef.value;
      memoMouseX = (rtlEnabledRef === null || rtlEnabledRef === void 0 ? void 0 : rtlEnabledRef.value) ? window.innerWidth - e25.clientX : e25.clientX;
    }
    function handleXScrollMouseMove(e25) {
      if (!xBarPressed)
        return;
      if (xBarVanishTimerId !== void 0) {
        window.clearTimeout(xBarVanishTimerId);
      }
      if (yBarVanishTimerId !== void 0) {
        window.clearTimeout(yBarVanishTimerId);
      }
      const { value: containerWidth } = containerWidthRef;
      const { value: contentWidth } = contentWidthRef;
      const { value: xBarSize } = xBarSizeRef;
      if (containerWidth === null || contentWidth === null)
        return;
      const dX = (rtlEnabledRef === null || rtlEnabledRef === void 0 ? void 0 : rtlEnabledRef.value) ? window.innerWidth - e25.clientX - memoMouseX : e25.clientX - memoMouseX;
      const dScrollLeft = dX * (contentWidth - containerWidth) / (containerWidth - xBarSize);
      const toScrollLeftUpperBound = contentWidth - containerWidth;
      let toScrollLeft = memoXLeft + dScrollLeft;
      toScrollLeft = Math.min(toScrollLeftUpperBound, toScrollLeft);
      toScrollLeft = Math.max(toScrollLeft, 0);
      const { value: container } = mergedContainerRef;
      if (container) {
        container.scrollLeft = toScrollLeft * ((rtlEnabledRef === null || rtlEnabledRef === void 0 ? void 0 : rtlEnabledRef.value) ? -1 : 1);
        const { internalOnUpdateScrollLeft } = props;
        if (internalOnUpdateScrollLeft)
          internalOnUpdateScrollLeft(toScrollLeft);
      }
    }
    function handleXScrollMouseUp(e25) {
      e25.preventDefault();
      e25.stopPropagation();
      off("mousemove", window, handleXScrollMouseMove, true);
      off("mouseup", window, handleXScrollMouseUp, true);
      xBarPressed = false;
      sync();
      if (isMouseUpAway(e25)) {
        hideBar();
      }
    }
    function handleYScrollMouseDown(e25) {
      e25.preventDefault();
      e25.stopPropagation();
      yBarPressed = true;
      on$1("mousemove", window, handleYScrollMouseMove, true);
      on$1("mouseup", window, handleYScrollMouseUp, true);
      memoYTop = containerScrollTopRef.value;
      memoMouseY = e25.clientY;
    }
    function handleYScrollMouseMove(e25) {
      if (!yBarPressed)
        return;
      if (xBarVanishTimerId !== void 0) {
        window.clearTimeout(xBarVanishTimerId);
      }
      if (yBarVanishTimerId !== void 0) {
        window.clearTimeout(yBarVanishTimerId);
      }
      const { value: containerHeight } = containerHeightRef;
      const { value: contentHeight } = contentHeightRef;
      const { value: yBarSize } = yBarSizeRef;
      if (containerHeight === null || contentHeight === null)
        return;
      const dY = e25.clientY - memoMouseY;
      const dScrollTop = dY * (contentHeight - containerHeight) / (containerHeight - yBarSize);
      const toScrollTopUpperBound = contentHeight - containerHeight;
      let toScrollTop = memoYTop + dScrollTop;
      toScrollTop = Math.min(toScrollTopUpperBound, toScrollTop);
      toScrollTop = Math.max(toScrollTop, 0);
      const { value: container } = mergedContainerRef;
      if (container) {
        container.scrollTop = toScrollTop;
      }
    }
    function handleYScrollMouseUp(e25) {
      e25.preventDefault();
      e25.stopPropagation();
      off("mousemove", window, handleYScrollMouseMove, true);
      off("mouseup", window, handleYScrollMouseUp, true);
      yBarPressed = false;
      sync();
      if (isMouseUpAway(e25)) {
        hideBar();
      }
    }
    watchEffect(() => {
      const { value: needXBar } = needXBarRef;
      const { value: needYBar } = needYBarRef;
      const { value: mergedClsPrefix } = mergedClsPrefixRef;
      const { value: xRailEl } = xRailRef;
      const { value: yRailEl } = yRailRef;
      if (xRailEl) {
        if (!needXBar) {
          xRailEl.classList.add(`${mergedClsPrefix}-scrollbar-rail--disabled`);
        } else {
          xRailEl.classList.remove(`${mergedClsPrefix}-scrollbar-rail--disabled`);
        }
      }
      if (yRailEl) {
        if (!needYBar) {
          yRailEl.classList.add(`${mergedClsPrefix}-scrollbar-rail--disabled`);
        } else {
          yRailEl.classList.remove(`${mergedClsPrefix}-scrollbar-rail--disabled`);
        }
      }
    });
    onMounted(() => {
      if (props.container)
        return;
      sync();
    });
    onBeforeUnmount(() => {
      if (xBarVanishTimerId !== void 0) {
        window.clearTimeout(xBarVanishTimerId);
      }
      if (yBarVanishTimerId !== void 0) {
        window.clearTimeout(yBarVanishTimerId);
      }
      off("mousemove", window, handleYScrollMouseMove, true);
      off("mouseup", window, handleYScrollMouseUp, true);
    });
    const themeRef = useTheme("Scrollbar", "-scrollbar", style$Q, scrollbarLight$1, props, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2, scrollbarBorderRadius, scrollbarHeight, scrollbarWidth }, self: { color, colorHover } } = themeRef.value;
      return {
        "--n-scrollbar-bezier": cubicBezierEaseInOut2,
        "--n-scrollbar-color": color,
        "--n-scrollbar-color-hover": colorHover,
        "--n-scrollbar-border-radius": scrollbarBorderRadius,
        "--n-scrollbar-width": scrollbarWidth,
        "--n-scrollbar-height": scrollbarHeight
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("scrollbar", void 0, cssVarsRef, props) : void 0;
    const exposedMethods = {
      scrollTo,
      scrollBy,
      sync,
      syncUnifiedContainer,
      handleMouseEnterWrapper,
      handleMouseLeaveWrapper
    };
    return Object.assign(Object.assign({}, exposedMethods), {
      mergedClsPrefix: mergedClsPrefixRef,
      rtlEnabled: rtlEnabledRef,
      containerScrollTop: containerScrollTopRef,
      wrapperRef,
      containerRef,
      contentRef,
      yRailRef,
      xRailRef,
      needYBar: needYBarRef,
      needXBar: needXBarRef,
      yBarSizePx: yBarSizePxRef,
      xBarSizePx: xBarSizePxRef,
      yBarTopPx: yBarTopPxRef,
      xBarLeftPx: xBarLeftPxRef,
      isShowXBar: mergedShowXBarRef,
      isShowYBar: mergedShowYBarRef,
      isIos: isIos2,
      handleScroll,
      handleContentResize,
      handleContainerResize,
      handleYScrollMouseDown,
      handleXScrollMouseDown,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    });
  },
  render() {
    var _a2;
    const { $slots, mergedClsPrefix, triggerDisplayManually, rtlEnabled, internalHoistYRail } = this;
    if (!this.scrollable)
      return (_a2 = $slots.default) === null || _a2 === void 0 ? void 0 : _a2.call($slots);
    const triggerIsNone = this.trigger === "none";
    const createYRail = () => {
      return h$1("div", { ref: "yRailRef", class: [
        `${mergedClsPrefix}-scrollbar-rail`,
        `${mergedClsPrefix}-scrollbar-rail--vertical`
      ], "data-scrollbar-rail": true, style: this.verticalRailStyle, "aria-hidden": true }, h$1(triggerIsNone ? Wrapper : Transition, triggerIsNone ? null : { name: "fade-in-transition" }, {
        default: () => this.needYBar && this.isShowYBar && !this.isIos ? h$1("div", { class: `${mergedClsPrefix}-scrollbar-rail__scrollbar`, style: {
          height: this.yBarSizePx,
          top: this.yBarTopPx
        }, onMousedown: this.handleYScrollMouseDown }) : null
      }));
    };
    const createChildren = () => {
      var _a3, _b2;
      (_a3 = this.onRender) === null || _a3 === void 0 ? void 0 : _a3.call(this);
      return h$1("div", mergeProps(this.$attrs, {
        role: "none",
        ref: "wrapperRef",
        class: [
          `${mergedClsPrefix}-scrollbar`,
          this.themeClass,
          rtlEnabled && `${mergedClsPrefix}-scrollbar--rtl`
        ],
        style: this.cssVars,
        onMouseenter: triggerDisplayManually ? void 0 : this.handleMouseEnterWrapper,
        onMouseleave: triggerDisplayManually ? void 0 : this.handleMouseLeaveWrapper
      }), [
        this.container ? (_b2 = $slots.default) === null || _b2 === void 0 ? void 0 : _b2.call($slots) : h$1("div", { role: "none", ref: "containerRef", class: [
          `${mergedClsPrefix}-scrollbar-container`,
          this.containerClass
        ], style: this.containerStyle, onScroll: this.handleScroll, onWheel: this.onWheel }, h$1(VResizeObserver, { onResize: this.handleContentResize }, {
          default: () => h$1("div", { ref: "contentRef", role: "none", style: [
            {
              width: this.xScrollable ? "fit-content" : null
            },
            this.contentStyle
          ], class: [
            `${mergedClsPrefix}-scrollbar-content`,
            this.contentClass
          ] }, $slots)
        })),
        internalHoistYRail ? null : createYRail(),
        this.xScrollable && h$1("div", { ref: "xRailRef", class: [
          `${mergedClsPrefix}-scrollbar-rail`,
          `${mergedClsPrefix}-scrollbar-rail--horizontal`
        ], style: this.horizontalRailStyle, "data-scrollbar-rail": true, "aria-hidden": true }, h$1(triggerIsNone ? Wrapper : Transition, triggerIsNone ? null : { name: "fade-in-transition" }, {
          default: () => this.needXBar && this.isShowXBar && !this.isIos ? h$1("div", { class: `${mergedClsPrefix}-scrollbar-rail__scrollbar`, style: {
            width: this.xBarSizePx,
            right: rtlEnabled ? this.xBarLeftPx : void 0,
            left: rtlEnabled ? void 0 : this.xBarLeftPx
          }, onMousedown: this.handleXScrollMouseDown }) : null
        }))
      ]);
    };
    const scrollbarNode = this.container ? createChildren() : h$1(VResizeObserver, { onResize: this.handleContainerResize }, {
      default: createChildren
    });
    if (internalHoistYRail) {
      return h$1(Fragment, null, scrollbarNode, createYRail());
    } else {
      return scrollbarNode;
    }
  }
});
var NScrollbar = Scrollbar;
const XScrollbar = Scrollbar;
var commonVariables$d = {
  height: "calc(var(--n-option-height) * 7.6)",
  paddingSmall: "4px 0",
  paddingMedium: "4px 0",
  paddingLarge: "4px 0",
  paddingHuge: "4px 0",
  optionPaddingSmall: "0 12px",
  optionPaddingMedium: "0 12px",
  optionPaddingLarge: "0 12px",
  optionPaddingHuge: "0 12px",
  loadingSize: "18px"
};
const self$I = (vars) => {
  const { borderRadius, popoverColor, textColor3, dividerColor, textColor2, primaryColorPressed, textColorDisabled, primaryColor, opacityDisabled, hoverColor, fontSizeSmall, fontSizeMedium, fontSizeLarge, fontSizeHuge, heightSmall, heightMedium, heightLarge, heightHuge } = vars;
  return Object.assign(Object.assign({}, commonVariables$d), { optionFontSizeSmall: fontSizeSmall, optionFontSizeMedium: fontSizeMedium, optionFontSizeLarge: fontSizeLarge, optionFontSizeHuge: fontSizeHuge, optionHeightSmall: heightSmall, optionHeightMedium: heightMedium, optionHeightLarge: heightLarge, optionHeightHuge: heightHuge, borderRadius, color: popoverColor, groupHeaderTextColor: textColor3, actionDividerColor: dividerColor, optionTextColor: textColor2, optionTextColorPressed: primaryColorPressed, optionTextColorDisabled: textColorDisabled, optionTextColorActive: primaryColor, optionOpacityDisabled: opacityDisabled, optionCheckColor: primaryColor, optionColorPending: hoverColor, optionColorActive: "rgba(0, 0, 0, 0)", optionColorActivePending: hoverColor, actionTextColor: textColor2, loadingColor: primaryColor });
};
const internalSelectMenuLight = createTheme({
  name: "InternalSelectMenu",
  common: commonLight,
  peers: {
    Scrollbar: scrollbarLight$1,
    Empty: emptyLight$1
  },
  self: self$I
});
var internalSelectMenuLight$1 = internalSelectMenuLight;
function renderCheckMark(show, clsPrefix) {
  return h$1(Transition, { name: "fade-in-scale-up-transition" }, {
    default: () => show ? h$1(NBaseIcon, { clsPrefix, class: `${clsPrefix}-base-select-option__check` }, {
      default: () => h$1(FinishedIcon)
    }) : null
  });
}
var NSelectOption = defineComponent({
  name: "NBaseSelectOption",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    tmNode: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const {
      valueRef,
      pendingTmNodeRef,
      multipleRef,
      valueSetRef,
      renderLabelRef,
      renderOptionRef,
      labelFieldRef,
      valueFieldRef,
      showCheckmarkRef,
      nodePropsRef,
      handleOptionClick,
      handleOptionMouseEnter
    } = inject(internalSelectionMenuInjectionKey);
    const isPendingRef = useMemo(() => {
      const { value: pendingTmNode } = pendingTmNodeRef;
      if (!pendingTmNode)
        return false;
      return props.tmNode.key === pendingTmNode.key;
    });
    function handleClick2(e25) {
      const { tmNode } = props;
      if (tmNode.disabled)
        return;
      handleOptionClick(e25, tmNode);
    }
    function handleMouseEnter(e25) {
      const { tmNode } = props;
      if (tmNode.disabled)
        return;
      handleOptionMouseEnter(e25, tmNode);
    }
    function handleMouseMove(e25) {
      const { tmNode } = props;
      const { value: isPending } = isPendingRef;
      if (tmNode.disabled || isPending)
        return;
      handleOptionMouseEnter(e25, tmNode);
    }
    return {
      multiple: multipleRef,
      isGrouped: useMemo(() => {
        const { tmNode } = props;
        const { parent } = tmNode;
        return parent && parent.rawNode.type === "group";
      }),
      showCheckmark: showCheckmarkRef,
      nodeProps: nodePropsRef,
      isPending: isPendingRef,
      isSelected: useMemo(() => {
        const { value: value2 } = valueRef;
        const { value: multiple } = multipleRef;
        if (value2 === null)
          return false;
        const optionValue = props.tmNode.rawNode[valueFieldRef.value];
        if (multiple) {
          const { value: valueSet } = valueSetRef;
          return valueSet.has(optionValue);
        } else {
          return value2 === optionValue;
        }
      }),
      labelField: labelFieldRef,
      renderLabel: renderLabelRef,
      renderOption: renderOptionRef,
      handleMouseMove,
      handleMouseEnter,
      handleClick: handleClick2
    };
  },
  render() {
    const { clsPrefix, tmNode: { rawNode }, isSelected, isPending, isGrouped, showCheckmark, nodeProps, renderOption, renderLabel, handleClick: handleClick2, handleMouseEnter, handleMouseMove } = this;
    const checkmark = renderCheckMark(isSelected, clsPrefix);
    const children = renderLabel ? [renderLabel(rawNode, isSelected), showCheckmark && checkmark] : [
      render$3U(rawNode[this.labelField], rawNode, isSelected),
      showCheckmark && checkmark
    ];
    const attrs = nodeProps === null || nodeProps === void 0 ? void 0 : nodeProps(rawNode);
    const node2 = h$1("div", Object.assign({}, attrs, { class: [
      `${clsPrefix}-base-select-option`,
      rawNode.class,
      attrs === null || attrs === void 0 ? void 0 : attrs.class,
      {
        [`${clsPrefix}-base-select-option--disabled`]: rawNode.disabled,
        [`${clsPrefix}-base-select-option--selected`]: isSelected,
        [`${clsPrefix}-base-select-option--grouped`]: isGrouped,
        [`${clsPrefix}-base-select-option--pending`]: isPending,
        [`${clsPrefix}-base-select-option--show-checkmark`]: showCheckmark
      }
    ], style: [(attrs === null || attrs === void 0 ? void 0 : attrs.style) || "", rawNode.style || ""], onClick: mergeEventHandlers([handleClick2, attrs === null || attrs === void 0 ? void 0 : attrs.onClick]), onMouseenter: mergeEventHandlers([
      handleMouseEnter,
      attrs === null || attrs === void 0 ? void 0 : attrs.onMouseenter
    ]), onMousemove: mergeEventHandlers([handleMouseMove, attrs === null || attrs === void 0 ? void 0 : attrs.onMousemove]) }), h$1("div", { class: `${clsPrefix}-base-select-option__content` }, children));
    return rawNode.render ? rawNode.render({ node: node2, option: rawNode, selected: isSelected }) : renderOption ? renderOption({ node: node2, option: rawNode, selected: isSelected }) : node2;
  }
});
var NSelectGroupHeader = defineComponent({
  name: "NBaseSelectGroupHeader",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    tmNode: {
      type: Object,
      required: true
    }
  },
  setup() {
    const {
      renderLabelRef,
      renderOptionRef,
      labelFieldRef,
      nodePropsRef
    } = inject(internalSelectionMenuInjectionKey);
    return {
      labelField: labelFieldRef,
      nodeProps: nodePropsRef,
      renderLabel: renderLabelRef,
      renderOption: renderOptionRef
    };
  },
  render() {
    const { clsPrefix, renderLabel, renderOption, nodeProps, tmNode: { rawNode } } = this;
    const attrs = nodeProps === null || nodeProps === void 0 ? void 0 : nodeProps(rawNode);
    const children = renderLabel ? renderLabel(rawNode, false) : render$3U(rawNode[this.labelField], rawNode, false);
    const node2 = h$1("div", Object.assign({}, attrs, { class: [`${clsPrefix}-base-select-group-header`, attrs === null || attrs === void 0 ? void 0 : attrs.class] }), children);
    return rawNode.render ? rawNode.render({ node: node2, option: rawNode }) : renderOption ? renderOption({ node: node2, option: rawNode, selected: false }) : node2;
  }
});
const {
  cubicBezierEaseIn: cubicBezierEaseIn$5,
  cubicBezierEaseOut: cubicBezierEaseOut$6
} = commonVariables$e;
function fadeInScaleUpTransition({
  transformOrigin = "inherit",
  duration = ".2s",
  enterScale = ".9",
  originalTransform = "",
  originalTransition = ""
} = {}) {
  return [c$2("&.fade-in-scale-up-transition-leave-active", {
    transformOrigin,
    transition: `opacity ${duration} ${cubicBezierEaseIn$5}, transform ${duration} ${cubicBezierEaseIn$5} ${originalTransition && "," + originalTransition}`
  }), c$2("&.fade-in-scale-up-transition-enter-active", {
    transformOrigin,
    transition: `opacity ${duration} ${cubicBezierEaseOut$6}, transform ${duration} ${cubicBezierEaseOut$6} ${originalTransition && "," + originalTransition}`
  }), c$2("&.fade-in-scale-up-transition-enter-from, &.fade-in-scale-up-transition-leave-to", {
    opacity: 0,
    transform: `${originalTransform} scale(${enterScale})`
  }), c$2("&.fade-in-scale-up-transition-leave-from, &.fade-in-scale-up-transition-enter-to", {
    opacity: 1,
    transform: `${originalTransform} scale(1)`
  })];
}
var style$P = cB$1("base-select-menu", `
 line-height: 1.5;
 outline: none;
 z-index: 0;
 position: relative;
 border-radius: var(--n-border-radius);
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 background-color: var(--n-color);
`, [cB$1("scrollbar", `
 max-height: var(--n-height);
 `), cB$1("virtual-list", `
 max-height: var(--n-height);
 `), cB$1("base-select-option", `
 min-height: var(--n-option-height);
 font-size: var(--n-option-font-size);
 display: flex;
 align-items: center;
 `, [cE$1("content", `
 z-index: 1;
 white-space: nowrap;
 text-overflow: ellipsis;
 overflow: hidden;
 `)]), cB$1("base-select-group-header", `
 min-height: var(--n-option-height);
 font-size: .93em;
 display: flex;
 align-items: center;
 `), cB$1("base-select-menu-option-wrapper", `
 position: relative;
 width: 100%;
 `), cE$1("loading, empty", `
 display: flex;
 padding: 12px 32px;
 flex: 1;
 justify-content: center;
 `), cE$1("loading", `
 color: var(--n-loading-color);
 font-size: var(--n-loading-size);
 `), cE$1("action", `
 padding: 8px var(--n-option-padding-left);
 font-size: var(--n-option-font-size);
 transition: 
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 border-top: 1px solid var(--n-action-divider-color);
 color: var(--n-action-text-color);
 `), cB$1("base-select-group-header", `
 position: relative;
 cursor: default;
 padding: var(--n-option-padding);
 color: var(--n-group-header-text-color);
 `), cB$1("base-select-option", `
 cursor: pointer;
 position: relative;
 padding: var(--n-option-padding);
 transition:
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 box-sizing: border-box;
 color: var(--n-option-text-color);
 opacity: 1;
 `, [cM("show-checkmark", `
 padding-right: calc(var(--n-option-padding-right) + 20px);
 `), c$2("&::before", `
 content: "";
 position: absolute;
 left: 4px;
 right: 4px;
 top: 0;
 bottom: 0;
 border-radius: var(--n-border-radius);
 transition: background-color .3s var(--n-bezier);
 `), c$2("&:active", `
 color: var(--n-option-text-color-pressed);
 `), cM("grouped", `
 padding-left: calc(var(--n-option-padding-left) * 1.5);
 `), cM("pending", [c$2("&::before", `
 background-color: var(--n-option-color-pending);
 `)]), cM("selected", `
 color: var(--n-option-text-color-active);
 `, [c$2("&::before", `
 background-color: var(--n-option-color-active);
 `), cM("pending", [c$2("&::before", `
 background-color: var(--n-option-color-active-pending);
 `)])]), cM("disabled", `
 cursor: not-allowed;
 `, [cNotM("selected", `
 color: var(--n-option-text-color-disabled);
 `), cM("selected", `
 opacity: var(--n-option-opacity-disabled);
 `)]), cE$1("check", `
 font-size: 16px;
 position: absolute;
 right: calc(var(--n-option-padding-right) - 4px);
 top: calc(50% - 7px);
 color: var(--n-option-check-color);
 transition: color .3s var(--n-bezier);
 `, [fadeInScaleUpTransition({
  enterScale: "0.5"
})])])]);
var NInternalSelectMenu = defineComponent({
  name: "InternalSelectMenu",
  props: Object.assign(Object.assign({}, useTheme.props), {
    clsPrefix: {
      type: String,
      required: true
    },
    scrollable: {
      type: Boolean,
      default: true
    },
    treeMate: {
      type: Object,
      required: true
    },
    multiple: Boolean,
    size: {
      type: String,
      default: "medium"
    },
    value: {
      type: [String, Number, Array],
      default: null
    },
    autoPending: Boolean,
    virtualScroll: {
      type: Boolean,
      default: true
    },
    show: {
      type: Boolean,
      default: true
    },
    labelField: {
      type: String,
      default: "label"
    },
    valueField: {
      type: String,
      default: "value"
    },
    loading: Boolean,
    focusable: Boolean,
    renderLabel: Function,
    renderOption: Function,
    nodeProps: Function,
    showCheckmark: { type: Boolean, default: true },
    onMousedown: Function,
    onScroll: Function,
    onFocus: Function,
    onBlur: Function,
    onKeyup: Function,
    onKeydown: Function,
    onTabOut: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onResize: Function,
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: true
    },
    inlineThemeDisabled: Boolean,
    onToggle: Function
  }),
  setup(props) {
    const themeRef = useTheme("InternalSelectMenu", "-internal-select-menu", style$P, internalSelectMenuLight$1, props, toRef(props, "clsPrefix"));
    const selfRef = ref(null);
    const virtualListRef = ref(null);
    const scrollbarRef = ref(null);
    const flattenedNodesRef = computed(() => props.treeMate.getFlattenedNodes());
    const fIndexGetterRef = computed(() => createIndexGetter(flattenedNodesRef.value));
    const pendingNodeRef = ref(null);
    function initPendingNode() {
      const { treeMate } = props;
      let defaultPendingNode = null;
      const { value: value2 } = props;
      if (value2 === null) {
        defaultPendingNode = treeMate.getFirstAvailableNode();
      } else {
        if (props.multiple) {
          defaultPendingNode = treeMate.getNode((value2 || [])[(value2 || []).length - 1]);
        } else {
          defaultPendingNode = treeMate.getNode(value2);
        }
        if (!defaultPendingNode || defaultPendingNode.disabled) {
          defaultPendingNode = treeMate.getFirstAvailableNode();
        }
      }
      if (defaultPendingNode) {
        setPendingTmNode(defaultPendingNode);
      } else {
        setPendingTmNode(null);
      }
    }
    function clearPendingNodeIfInvalid() {
      const { value: pendingNode } = pendingNodeRef;
      if (pendingNode && !props.treeMate.getNode(pendingNode.key)) {
        pendingNodeRef.value = null;
      }
    }
    let initPendingNodeWatchStopHandle;
    watch(() => props.show, (show) => {
      if (show) {
        initPendingNodeWatchStopHandle = watch(() => props.treeMate, () => {
          if (props.resetMenuOnOptionsChange) {
            if (props.autoPending) {
              initPendingNode();
            } else {
              clearPendingNodeIfInvalid();
            }
            void nextTick(scrollToPendingNode);
          } else {
            clearPendingNodeIfInvalid();
          }
        }, {
          immediate: true
        });
      } else {
        initPendingNodeWatchStopHandle === null || initPendingNodeWatchStopHandle === void 0 ? void 0 : initPendingNodeWatchStopHandle();
      }
    }, {
      immediate: true
    });
    onBeforeUnmount(() => {
      initPendingNodeWatchStopHandle === null || initPendingNodeWatchStopHandle === void 0 ? void 0 : initPendingNodeWatchStopHandle();
    });
    const itemSizeRef = computed(() => {
      return depx(themeRef.value.self[createKey("optionHeight", props.size)]);
    });
    const paddingRef = computed(() => {
      return getMargin(themeRef.value.self[createKey("padding", props.size)]);
    });
    const valueSetRef = computed(() => {
      if (props.multiple && Array.isArray(props.value)) {
        return new Set(props.value);
      }
      return new Set();
    });
    const emptyRef = computed(() => {
      const tmNodes = flattenedNodesRef.value;
      return tmNodes && tmNodes.length === 0;
    });
    function doToggle(tmNode) {
      const { onToggle } = props;
      if (onToggle)
        onToggle(tmNode);
    }
    function doScroll(e25) {
      const { onScroll } = props;
      if (onScroll)
        onScroll(e25);
    }
    function handleVirtualListScroll(e25) {
      var _a2;
      (_a2 = scrollbarRef.value) === null || _a2 === void 0 ? void 0 : _a2.sync();
      doScroll(e25);
    }
    function handleVirtualListResize() {
      var _a2;
      (_a2 = scrollbarRef.value) === null || _a2 === void 0 ? void 0 : _a2.sync();
    }
    function getPendingTmNode() {
      const { value: pendingTmNode } = pendingNodeRef;
      if (pendingTmNode)
        return pendingTmNode;
      return null;
    }
    function handleOptionMouseEnter(e25, tmNode) {
      if (tmNode.disabled)
        return;
      setPendingTmNode(tmNode, false);
    }
    function handleOptionClick(e25, tmNode) {
      if (tmNode.disabled)
        return;
      doToggle(tmNode);
    }
    function handleKeyUp(e25) {
      var _a2;
      if (happensIn(e25, "action"))
        return;
      (_a2 = props.onKeyup) === null || _a2 === void 0 ? void 0 : _a2.call(props, e25);
    }
    function handleKeyDown(e25) {
      var _a2;
      if (happensIn(e25, "action"))
        return;
      (_a2 = props.onKeydown) === null || _a2 === void 0 ? void 0 : _a2.call(props, e25);
    }
    function handleMouseDown(e25) {
      var _a2;
      (_a2 = props.onMousedown) === null || _a2 === void 0 ? void 0 : _a2.call(props, e25);
      if (props.focusable)
        return;
      e25.preventDefault();
    }
    function next() {
      const { value: pendingTmNode } = pendingNodeRef;
      if (pendingTmNode) {
        setPendingTmNode(pendingTmNode.getNext({ loop: true }), true);
      }
    }
    function prev() {
      const { value: pendingTmNode } = pendingNodeRef;
      if (pendingTmNode) {
        setPendingTmNode(pendingTmNode.getPrev({ loop: true }), true);
      }
    }
    function setPendingTmNode(tmNode, doScroll2 = false) {
      pendingNodeRef.value = tmNode;
      if (doScroll2)
        scrollToPendingNode();
    }
    function scrollToPendingNode() {
      var _a2, _b2;
      const tmNode = pendingNodeRef.value;
      if (!tmNode)
        return;
      const fIndex = fIndexGetterRef.value(tmNode.key);
      if (fIndex === null)
        return;
      if (props.virtualScroll) {
        (_a2 = virtualListRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollTo({ index: fIndex });
      } else {
        (_b2 = scrollbarRef.value) === null || _b2 === void 0 ? void 0 : _b2.scrollTo({
          index: fIndex,
          elSize: itemSizeRef.value
        });
      }
    }
    function handleFocusin(e25) {
      var _a2, _b2;
      if ((_a2 = selfRef.value) === null || _a2 === void 0 ? void 0 : _a2.contains(e25.target)) {
        (_b2 = props.onFocus) === null || _b2 === void 0 ? void 0 : _b2.call(props, e25);
      }
    }
    function handleFocusout(e25) {
      var _a2, _b2;
      if (!((_a2 = selfRef.value) === null || _a2 === void 0 ? void 0 : _a2.contains(e25.relatedTarget))) {
        (_b2 = props.onBlur) === null || _b2 === void 0 ? void 0 : _b2.call(props, e25);
      }
    }
    provide(internalSelectionMenuInjectionKey, {
      handleOptionMouseEnter,
      handleOptionClick,
      valueSetRef,
      pendingTmNodeRef: pendingNodeRef,
      nodePropsRef: toRef(props, "nodeProps"),
      showCheckmarkRef: toRef(props, "showCheckmark"),
      multipleRef: toRef(props, "multiple"),
      valueRef: toRef(props, "value"),
      renderLabelRef: toRef(props, "renderLabel"),
      renderOptionRef: toRef(props, "renderOption"),
      labelFieldRef: toRef(props, "labelField"),
      valueFieldRef: toRef(props, "valueField")
    });
    provide(internalSelectionMenuBodyInjectionKey, selfRef);
    onMounted(() => {
      const { value: value2 } = scrollbarRef;
      if (value2)
        value2.sync();
    });
    const cssVarsRef = computed(() => {
      const { size: size2 } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { height, borderRadius, color, groupHeaderTextColor, actionDividerColor, optionTextColorPressed, optionTextColor, optionTextColorDisabled, optionTextColorActive, optionOpacityDisabled, optionCheckColor, actionTextColor, optionColorPending, optionColorActive, loadingColor, loadingSize, optionColorActivePending, [createKey("optionFontSize", size2)]: fontSize2, [createKey("optionHeight", size2)]: optionHeight, [createKey("optionPadding", size2)]: optionPadding } } = themeRef.value;
      return {
        "--n-height": height,
        "--n-action-divider-color": actionDividerColor,
        "--n-action-text-color": actionTextColor,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-border-radius": borderRadius,
        "--n-color": color,
        "--n-option-font-size": fontSize2,
        "--n-group-header-text-color": groupHeaderTextColor,
        "--n-option-check-color": optionCheckColor,
        "--n-option-color-pending": optionColorPending,
        "--n-option-color-active": optionColorActive,
        "--n-option-color-active-pending": optionColorActivePending,
        "--n-option-height": optionHeight,
        "--n-option-opacity-disabled": optionOpacityDisabled,
        "--n-option-text-color": optionTextColor,
        "--n-option-text-color-active": optionTextColorActive,
        "--n-option-text-color-disabled": optionTextColorDisabled,
        "--n-option-text-color-pressed": optionTextColorPressed,
        "--n-option-padding": optionPadding,
        "--n-option-padding-left": getMargin(optionPadding, "left"),
        "--n-option-padding-right": getMargin(optionPadding, "right"),
        "--n-loading-color": loadingColor,
        "--n-loading-size": loadingSize
      };
    });
    const { inlineThemeDisabled } = props;
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("internal-select-menu", computed(() => props.size[0]), cssVarsRef, props) : void 0;
    const exposedProps = {
      selfRef,
      next,
      prev,
      getPendingTmNode
    };
    useOnResize(selfRef, props.onResize);
    return Object.assign({
      mergedTheme: themeRef,
      virtualListRef,
      scrollbarRef,
      itemSize: itemSizeRef,
      padding: paddingRef,
      flattenedNodes: flattenedNodesRef,
      empty: emptyRef,
      virtualListContainer() {
        const { value: value2 } = virtualListRef;
        return value2 === null || value2 === void 0 ? void 0 : value2.listElRef;
      },
      virtualListContent() {
        const { value: value2 } = virtualListRef;
        return value2 === null || value2 === void 0 ? void 0 : value2.itemsElRef;
      },
      doScroll,
      handleFocusin,
      handleFocusout,
      handleKeyUp,
      handleKeyDown,
      handleMouseDown,
      handleVirtualListResize,
      handleVirtualListScroll,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    }, exposedProps);
  },
  render() {
    const { $slots, virtualScroll, clsPrefix, mergedTheme, themeClass, onRender } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { ref: "selfRef", tabindex: this.focusable ? 0 : -1, class: [
      `${clsPrefix}-base-select-menu`,
      themeClass,
      this.multiple && `${clsPrefix}-base-select-menu--multiple`
    ], style: this.cssVars, onFocusin: this.handleFocusin, onFocusout: this.handleFocusout, onKeyup: this.handleKeyUp, onKeydown: this.handleKeyDown, onMousedown: this.handleMouseDown, onMouseenter: this.onMouseenter, onMouseleave: this.onMouseleave }, this.loading ? h$1("div", { class: `${clsPrefix}-base-select-menu__loading` }, h$1(NBaseLoading, { clsPrefix, strokeWidth: 20 })) : !this.empty ? h$1(NScrollbar, { ref: "scrollbarRef", theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar, scrollable: this.scrollable, container: virtualScroll ? this.virtualListContainer : void 0, content: virtualScroll ? this.virtualListContent : void 0, onScroll: virtualScroll ? void 0 : this.doScroll }, {
      default: () => {
        return virtualScroll ? h$1(VirtualList, { ref: "virtualListRef", class: `${clsPrefix}-virtual-list`, items: this.flattenedNodes, itemSize: this.itemSize, showScrollbar: false, paddingTop: this.padding.top, paddingBottom: this.padding.bottom, onResize: this.handleVirtualListResize, onScroll: this.handleVirtualListScroll, itemResizable: true }, {
          default: ({ item: tmNode }) => {
            return tmNode.isGroup ? h$1(NSelectGroupHeader, { key: tmNode.key, clsPrefix, tmNode }) : tmNode.ignored ? null : h$1(NSelectOption, { clsPrefix, key: tmNode.key, tmNode });
          }
        }) : h$1("div", { class: `${clsPrefix}-base-select-menu-option-wrapper`, style: {
          paddingTop: this.padding.top,
          paddingBottom: this.padding.bottom
        } }, this.flattenedNodes.map((tmNode) => tmNode.isGroup ? h$1(NSelectGroupHeader, { key: tmNode.key, clsPrefix, tmNode }) : h$1(NSelectOption, { clsPrefix, key: tmNode.key, tmNode })));
      }
    }) : h$1("div", { class: `${clsPrefix}-base-select-menu__empty`, "data-empty": true }, resolveSlot($slots.empty, () => [
      h$1(NEmpty, { theme: mergedTheme.peers.Empty, themeOverrides: mergedTheme.peerOverrides.Empty })
    ])), resolveWrappedSlot($slots.action, (children) => children && [
      h$1("div", { class: `${clsPrefix}-base-select-menu__action`, "data-action": true, key: "action" }, children),
      h$1(FocusDetector, { onFocus: this.onTabOut, key: "focus-detector" })
    ]));
  }
});
var style$O = cB$1("base-wave", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
`);
var NBaseWave = defineComponent({
  name: "BaseWave",
  props: {
    clsPrefix: {
      type: String,
      required: true
    }
  },
  setup(props) {
    useStyle("-base-wave", style$O, toRef(props, "clsPrefix"));
    const selfRef = ref(null);
    const activeRef = ref(false);
    let animationTimerId = null;
    onBeforeUnmount(() => {
      if (animationTimerId !== null) {
        window.clearTimeout(animationTimerId);
      }
    });
    return {
      active: activeRef,
      selfRef,
      play() {
        if (animationTimerId !== null) {
          window.clearTimeout(animationTimerId);
          activeRef.value = false;
          animationTimerId = null;
        }
        void nextTick(() => {
          var _a2;
          void ((_a2 = selfRef.value) === null || _a2 === void 0 ? void 0 : _a2.offsetHeight);
          activeRef.value = true;
          animationTimerId = window.setTimeout(() => {
            activeRef.value = false;
            animationTimerId = null;
          }, 1e3);
        });
      }
    };
  },
  render() {
    const { clsPrefix } = this;
    return h$1("div", { ref: "selfRef", "aria-hidden": true, class: [
      `${clsPrefix}-base-wave`,
      this.active && `${clsPrefix}-base-wave--active`
    ] });
  }
});
var commonVariables$c = {
  space: "6px",
  spaceArrow: "10px",
  arrowOffset: "10px",
  arrowOffsetVertical: "10px",
  arrowHeight: "6px",
  padding: "8px 14px"
};
const self$H = (vars) => {
  const { boxShadow2, popoverColor, textColor2, borderRadius, fontSize: fontSize2, dividerColor } = vars;
  return Object.assign(Object.assign({}, commonVariables$c), {
    fontSize: fontSize2,
    borderRadius,
    color: popoverColor,
    dividerColor,
    textColor: textColor2,
    boxShadow: boxShadow2
  });
};
const popoverLight = {
  name: "Popover",
  common: commonLight,
  self: self$H
};
var popoverLight$1 = popoverLight;
const oppositePlacement = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
};
const arrowSize = "var(--n-arrow-height) * 1.414";
var style$N = c$2([cB$1("popover", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 position: relative;
 font-size: var(--n-font-size);
 color: var(--n-text-color);
 box-shadow: var(--n-box-shadow);
 word-break: break-word;
 `, [c$2(">", [cB$1("scrollbar", `
 height: inherit;
 max-height: inherit;
 `)]), cNotM("raw", `
 background-color: var(--n-color);
 border-radius: var(--n-border-radius);
 `, [cNotM("scrollable", [cNotM("show-header-or-footer", "padding: var(--n-padding);")])]), cE$1("header", `
 padding: var(--n-padding);
 border-bottom: 1px solid var(--n-divider-color);
 transition: border-color .3s var(--n-bezier);
 `), cE$1("footer", `
 padding: var(--n-padding);
 border-top: 1px solid var(--n-divider-color);
 transition: border-color .3s var(--n-bezier);
 `), cM("scrollable, show-header-or-footer", [cE$1("content", `
 padding: var(--n-padding);
 `)])]), cB$1("popover-shared", `
 transform-origin: inherit;
 `, [
  cB$1("popover-arrow-wrapper", `
 position: absolute;
 overflow: hidden;
 pointer-events: none;
 `, [cB$1("popover-arrow", `
 transition: background-color .3s var(--n-bezier);
 position: absolute;
 display: block;
 width: calc(${arrowSize});
 height: calc(${arrowSize});
 box-shadow: 0 0 8px 0 rgba(0, 0, 0, .12);
 transform: rotate(45deg);
 background-color: var(--n-color);
 pointer-events: all;
 `)]),
  c$2("&.popover-transition-enter-from, &.popover-transition-leave-to", `
 opacity: 0;
 transform: scale(.85);
 `),
  c$2("&.popover-transition-enter-to, &.popover-transition-leave-from", `
 transform: scale(1);
 opacity: 1;
 `),
  c$2("&.popover-transition-enter-active", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .15s var(--n-bezier-ease-out),
 transform .15s var(--n-bezier-ease-out);
 `),
  c$2("&.popover-transition-leave-active", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .15s var(--n-bezier-ease-in),
 transform .15s var(--n-bezier-ease-in);
 `)
]), placementStyle("top-start", `
 top: calc(${arrowSize} / -2);
 left: calc(${getArrowOffset("top-start")} - var(--v-offset-left));
 `), placementStyle("top", `
 top: calc(${arrowSize} / -2);
 transform: translateX(calc(${arrowSize} / -2)) rotate(45deg);
 left: 50%;
 `), placementStyle("top-end", `
 top: calc(${arrowSize} / -2);
 right: calc(${getArrowOffset("top-end")} + var(--v-offset-left));
 `), placementStyle("bottom-start", `
 bottom: calc(${arrowSize} / -2);
 left: calc(${getArrowOffset("bottom-start")} - var(--v-offset-left));
 `), placementStyle("bottom", `
 bottom: calc(${arrowSize} / -2);
 transform: translateX(calc(${arrowSize} / -2)) rotate(45deg);
 left: 50%;
 `), placementStyle("bottom-end", `
 bottom: calc(${arrowSize} / -2);
 right: calc(${getArrowOffset("bottom-end")} + var(--v-offset-left));
 `), placementStyle("left-start", `
 left: calc(${arrowSize} / -2);
 top: calc(${getArrowOffset("left-start")} - var(--v-offset-top));
 `), placementStyle("left", `
 left: calc(${arrowSize} / -2);
 transform: translateY(calc(${arrowSize} / -2)) rotate(45deg);
 top: 50%;
 `), placementStyle("left-end", `
 left: calc(${arrowSize} / -2);
 bottom: calc(${getArrowOffset("left-end")} + var(--v-offset-top));
 `), placementStyle("right-start", `
 right: calc(${arrowSize} / -2);
 top: calc(${getArrowOffset("right-start")} - var(--v-offset-top));
 `), placementStyle("right", `
 right: calc(${arrowSize} / -2);
 transform: translateY(calc(${arrowSize} / -2)) rotate(45deg);
 top: 50%;
 `), placementStyle("right-end", `
 right: calc(${arrowSize} / -2);
 bottom: calc(${getArrowOffset("right-end")} + var(--v-offset-top));
 `), ...map({
  top: ["right-start", "left-start"],
  right: ["top-end", "bottom-end"],
  bottom: ["right-end", "left-end"],
  left: ["top-start", "bottom-start"]
}, (placements, direction) => {
  const isVertical = ["right", "left"].includes(direction);
  const sizeType = isVertical ? "width" : "height";
  return placements.map((placement) => {
    const isReverse = placement.split("-")[1] === "end";
    const targetSize = `var(--v-target-${sizeType}, 0px)`;
    const centerOffset = `calc((${targetSize} - ${arrowSize}) / 2)`;
    const offset = getArrowOffset(placement);
    return c$2(`[v-placement="${placement}"] >`, [cB$1("popover-shared", [cM("center-arrow", [cB$1("popover-arrow", `${direction}: calc(max(${centerOffset}, ${offset}) ${isReverse ? "+" : "-"} var(--v-offset-${isVertical ? "left" : "top"}));`)])])]);
  });
})]);
function getArrowOffset(placement) {
  return ["top", "bottom"].includes(placement.split("-")[0]) ? "var(--n-arrow-offset)" : "var(--n-arrow-offset-vertical)";
}
function placementStyle(placement, arrowStyleLiteral) {
  const position = placement.split("-")[0];
  const sizeStyle = ["top", "bottom"].includes(position) ? "height: var(--n-space-arrow);" : "width: var(--n-space-arrow);";
  return c$2(`[v-placement="${placement}"] >`, [cB$1("popover-shared", `
 margin-${oppositePlacement[position]}: var(--n-space);
 `, [cM("show-arrow", `
 margin-${oppositePlacement[position]}: var(--n-space-arrow);
 `), cM("overlap", `
 margin: 0;
 `), cCB("popover-arrow-wrapper", `
 right: 0;
 left: 0;
 top: 0;
 bottom: 0;
 ${position}: 100%;
 ${oppositePlacement[position]}: auto;
 ${sizeStyle}
 `, [cB$1("popover-arrow", arrowStyleLiteral)])])]);
}
const popoverBodyProps = Object.assign(Object.assign({}, useTheme.props), {
  to: useAdjustedTo.propTo,
  show: Boolean,
  trigger: String,
  showArrow: Boolean,
  delay: Number,
  duration: Number,
  raw: Boolean,
  arrowPointToCenter: Boolean,
  arrowStyle: [String, Object],
  displayDirective: String,
  x: Number,
  y: Number,
  flip: Boolean,
  overlap: Boolean,
  placement: String,
  width: [Number, String],
  keepAliveOnHover: Boolean,
  scrollable: Boolean,
  contentStyle: [Object, String],
  headerStyle: [Object, String],
  footerStyle: [Object, String],
  internalDeactivateImmediately: Boolean,
  animated: Boolean,
  onClickoutside: Function,
  internalTrapFocus: Boolean,
  internalOnAfterLeave: Function,
  minWidth: Number,
  maxWidth: Number
});
const renderArrow = ({ arrowStyle, clsPrefix }) => {
  return h$1("div", { key: "__popover-arrow__", class: `${clsPrefix}-popover-arrow-wrapper` }, h$1("div", { class: `${clsPrefix}-popover-arrow`, style: arrowStyle }));
};
var NPopoverBody = defineComponent({
  name: "PopoverBody",
  inheritAttrs: false,
  props: popoverBodyProps,
  setup(props, { slots, attrs }) {
    const { namespaceRef, mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Popover", "-popover", style$N, popoverLight$1, props, mergedClsPrefixRef);
    const followerRef = ref(null);
    const NPopover2 = inject("NPopover");
    const bodyRef = ref(null);
    const followerEnabledRef = ref(props.show);
    const displayedRef = ref(false);
    watchEffect(() => {
      const { show } = props;
      if (show && !isJsdom() && !props.internalDeactivateImmediately) {
        displayedRef.value = true;
      }
    });
    const directivesRef = computed(() => {
      const { trigger: trigger2, onClickoutside } = props;
      const directives = [];
      const { positionManuallyRef: { value: positionManually } } = NPopover2;
      if (!positionManually) {
        if (trigger2 === "click" && !onClickoutside) {
          directives.push([
            clickoutside$1,
            handleClickOutside,
            void 0,
            { capture: true }
          ]);
        }
        if (trigger2 === "hover") {
          directives.push([mousemoveoutside$1, handleMouseMoveOutside]);
        }
      }
      if (onClickoutside) {
        directives.push([
          clickoutside$1,
          handleClickOutside,
          void 0,
          { capture: true }
        ]);
      }
      if (props.displayDirective === "show" || props.animated && displayedRef.value) {
        directives.push([vShow, props.show]);
      }
      return directives;
    });
    const styleRef = computed(() => {
      const width = props.width === "trigger" ? void 0 : formatLength(props.width);
      const style2 = [];
      if (width) {
        style2.push({ width });
      }
      const { maxWidth, minWidth } = props;
      if (maxWidth) {
        style2.push({ maxWidth: formatLength(maxWidth) });
      }
      if (minWidth) {
        style2.push({ maxWidth: formatLength(minWidth) });
      }
      if (!inlineThemeDisabled) {
        style2.push(cssVarsRef.value);
      }
      return style2;
    });
    const cssVarsRef = computed(() => {
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2, cubicBezierEaseIn: cubicBezierEaseIn2, cubicBezierEaseOut: cubicBezierEaseOut2 }, self: { space: space2, spaceArrow, padding, fontSize: fontSize2, textColor, dividerColor, color, boxShadow, borderRadius, arrowHeight, arrowOffset, arrowOffsetVertical } } = themeRef.value;
      return {
        "--n-box-shadow": boxShadow,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-bezier-ease-in": cubicBezierEaseIn2,
        "--n-bezier-ease-out": cubicBezierEaseOut2,
        "--n-font-size": fontSize2,
        "--n-text-color": textColor,
        "--n-color": color,
        "--n-divider-color": dividerColor,
        "--n-border-radius": borderRadius,
        "--n-arrow-height": arrowHeight,
        "--n-arrow-offset": arrowOffset,
        "--n-arrow-offset-vertical": arrowOffsetVertical,
        "--n-padding": padding,
        "--n-space": space2,
        "--n-space-arrow": spaceArrow
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("popover", void 0, cssVarsRef, props) : void 0;
    NPopover2.setBodyInstance({
      syncPosition
    });
    onBeforeUnmount(() => {
      NPopover2.setBodyInstance(null);
    });
    watch(toRef(props, "show"), (value2) => {
      if (props.animated)
        return;
      if (value2) {
        followerEnabledRef.value = true;
      } else {
        followerEnabledRef.value = false;
      }
    });
    function syncPosition() {
      var _a2;
      (_a2 = followerRef.value) === null || _a2 === void 0 ? void 0 : _a2.syncPosition();
    }
    function handleMouseEnter(e25) {
      if (props.trigger === "hover" && props.keepAliveOnHover && props.show) {
        NPopover2.handleMouseEnter(e25);
      }
    }
    function handleMouseLeave(e25) {
      if (props.trigger === "hover" && props.keepAliveOnHover) {
        NPopover2.handleMouseLeave(e25);
      }
    }
    function handleMouseMoveOutside(e25) {
      if (props.trigger === "hover" && !getTriggerElement().contains(getPreciseEventTarget(e25))) {
        NPopover2.handleMouseMoveOutside(e25);
      }
    }
    function handleClickOutside(e25) {
      if (props.trigger === "click" && !getTriggerElement().contains(getPreciseEventTarget(e25)) || props.onClickoutside) {
        NPopover2.handleClickOutside(e25);
      }
    }
    function getTriggerElement() {
      return NPopover2.getTriggerElement();
    }
    provide(popoverBodyInjectionKey, bodyRef);
    provide(drawerBodyInjectionKey, null);
    provide(modalBodyInjectionKey, null);
    function renderContentNode() {
      themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender();
      const shouldRenderDom = props.displayDirective === "show" || props.show || props.animated && displayedRef.value;
      if (!shouldRenderDom) {
        return null;
      }
      let contentNode;
      const renderBody = NPopover2.internalRenderBodyRef.value;
      const { value: mergedClsPrefix } = mergedClsPrefixRef;
      if (!renderBody) {
        const { value: extraClass } = NPopover2.extraClassRef;
        const { internalTrapFocus } = props;
        const hasHeaderOrFooter = !isSlotEmpty(slots.header) || !isSlotEmpty(slots.footer);
        const renderContentInnerNode = () => {
          var _a2;
          const body = hasHeaderOrFooter ? h$1(Fragment, null, resolveWrappedSlot(slots.header, (children) => {
            return children ? h$1("div", { class: `${mergedClsPrefix}-popover__header`, style: props.headerStyle }, children) : null;
          }), resolveWrappedSlot(slots.default, (children) => {
            return children ? h$1("div", { class: `${mergedClsPrefix}-popover__content`, style: props.contentStyle }, slots) : null;
          }), resolveWrappedSlot(slots.footer, (children) => {
            return children ? h$1("div", { class: `${mergedClsPrefix}-popover__footer`, style: props.footerStyle }, children) : null;
          })) : props.scrollable ? (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots) : h$1("div", { class: `${mergedClsPrefix}-popover__content`, style: props.contentStyle }, slots);
          const maybeScrollableBody = props.scrollable ? h$1(XScrollbar, { contentClass: hasHeaderOrFooter ? void 0 : `${mergedClsPrefix}-popover__content`, contentStyle: hasHeaderOrFooter ? void 0 : props.contentStyle }, {
            default: () => body
          }) : body;
          const arrow = props.showArrow ? renderArrow({
            arrowStyle: props.arrowStyle,
            clsPrefix: mergedClsPrefix
          }) : null;
          return [maybeScrollableBody, arrow];
        };
        contentNode = h$1("div", mergeProps({
          class: [
            `${mergedClsPrefix}-popover`,
            `${mergedClsPrefix}-popover-shared`,
            themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass.value,
            extraClass.map((v2) => `${mergedClsPrefix}-${v2}`),
            {
              [`${mergedClsPrefix}-popover--scrollable`]: props.scrollable,
              [`${mergedClsPrefix}-popover--show-header-or-footer`]: hasHeaderOrFooter,
              [`${mergedClsPrefix}-popover--raw`]: props.raw,
              [`${mergedClsPrefix}-popover-shared--overlap`]: props.overlap,
              [`${mergedClsPrefix}-popover-shared--show-arrow`]: props.showArrow,
              [`${mergedClsPrefix}-popover-shared--center-arrow`]: props.arrowPointToCenter
            }
          ],
          ref: bodyRef,
          style: styleRef.value,
          onKeydown: NPopover2.handleKeydown,
          onMouseenter: handleMouseEnter,
          onMouseleave: handleMouseLeave
        }, attrs), internalTrapFocus ? h$1(FocusTrap, { active: props.show, autoFocus: true }, { default: renderContentInnerNode }) : renderContentInnerNode());
      } else {
        contentNode = renderBody([
          `${mergedClsPrefix}-popover-shared`,
          themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass.value,
          props.overlap && `${mergedClsPrefix}-popover-shared--overlap`,
          props.showArrow && `${mergedClsPrefix}-popover-shared--show-arrow`,
          props.arrowPointToCenter && `${mergedClsPrefix}-popover-shared--center-arrow`
        ], bodyRef, styleRef.value, handleMouseEnter, handleMouseLeave);
      }
      return withDirectives(contentNode, directivesRef.value);
    }
    return {
      displayed: displayedRef,
      namespace: namespaceRef,
      isMounted: NPopover2.isMountedRef,
      zIndex: NPopover2.zIndexRef,
      followerRef,
      adjustedTo: useAdjustedTo(props),
      followerEnabled: followerEnabledRef,
      renderContentNode
    };
  },
  render() {
    return h$1(VFollower, { ref: "followerRef", zIndex: this.zIndex, show: this.show, enabled: this.followerEnabled, to: this.adjustedTo, x: this.x, y: this.y, flip: this.flip, placement: this.placement, containerClass: this.namespace, overlap: this.overlap, width: this.width === "trigger" ? "target" : void 0, teleportDisabled: this.adjustedTo === useAdjustedTo.tdkey }, {
      default: () => {
        return this.animated ? h$1(Transition, {
          name: "popover-transition",
          appear: this.isMounted,
          onEnter: () => {
            this.followerEnabled = true;
          },
          onAfterLeave: () => {
            var _a2;
            (_a2 = this.internalOnAfterLeave) === null || _a2 === void 0 ? void 0 : _a2.call(this);
            this.followerEnabled = false;
            this.displayed = false;
          }
        }, {
          default: this.renderContentNode
        }) : this.renderContentNode();
      }
    });
  }
});
const bodyPropKeys = Object.keys(popoverBodyProps);
const triggerEventMap = {
  focus: ["onFocus", "onBlur"],
  click: ["onClick"],
  hover: ["onMouseenter", "onMouseleave"],
  manual: [],
  nested: ["onFocus", "onBlur", "onMouseenter", "onMouseleave", "onClick"]
};
function appendEvents(vNode, trigger2, events2) {
  triggerEventMap[trigger2].forEach((eventName) => {
    if (!vNode.props)
      vNode.props = {};
    else {
      vNode.props = Object.assign({}, vNode.props);
    }
    const originalHandler = vNode.props[eventName];
    const handler = events2[eventName];
    if (!originalHandler)
      vNode.props[eventName] = handler;
    else {
      vNode.props[eventName] = (...args) => {
        originalHandler(...args);
        handler(...args);
      };
    }
  });
}
const popoverBaseProps = {
  show: {
    type: Boolean,
    default: void 0
  },
  defaultShow: Boolean,
  showArrow: {
    type: Boolean,
    default: true
  },
  trigger: {
    type: String,
    default: "hover"
  },
  delay: {
    type: Number,
    default: 100
  },
  duration: {
    type: Number,
    default: 100
  },
  raw: Boolean,
  placement: {
    type: String,
    default: "top"
  },
  x: Number,
  y: Number,
  arrowPointToCenter: Boolean,
  disabled: Boolean,
  getDisabled: Function,
  displayDirective: {
    type: String,
    default: "if"
  },
  arrowStyle: [String, Object],
  flip: {
    type: Boolean,
    default: true
  },
  animated: {
    type: Boolean,
    default: true
  },
  width: {
    type: [Number, String],
    default: void 0
  },
  overlap: Boolean,
  keepAliveOnHover: {
    type: Boolean,
    default: true
  },
  zIndex: Number,
  to: useAdjustedTo.propTo,
  scrollable: Boolean,
  contentStyle: [Object, String],
  headerStyle: [Object, String],
  footerStyle: [Object, String],
  onClickoutside: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  internalDeactivateImmediately: Boolean,
  internalSyncTargetWithParent: Boolean,
  internalInheritedEventHandlers: {
    type: Array,
    default: () => []
  },
  internalTrapFocus: Boolean,
  internalExtraClass: {
    type: Array,
    default: () => []
  },
  onShow: [Function, Array],
  onHide: [Function, Array],
  arrow: {
    type: Boolean,
    default: void 0
  },
  minWidth: Number,
  maxWidth: Number
};
const popoverProps = Object.assign(Object.assign(Object.assign({}, useTheme.props), popoverBaseProps), { internalOnAfterLeave: Function, internalRenderBody: Function });
var NPopover = defineComponent({
  name: "Popover",
  inheritAttrs: false,
  props: popoverProps,
  __popover__: true,
  setup(props) {
    const isMountedRef = isMounted();
    const binderInstRef = ref(null);
    const controlledShowRef = computed(() => props.show);
    const uncontrolledShowRef = ref(props.defaultShow);
    const mergedShowWithoutDisabledRef = useMergedState(controlledShowRef, uncontrolledShowRef);
    const mergedShowConsideringDisabledPropRef = useMemo(() => {
      if (props.disabled)
        return false;
      return mergedShowWithoutDisabledRef.value;
    });
    const getMergedDisabled = () => {
      if (props.disabled)
        return true;
      const { getDisabled } = props;
      if (getDisabled === null || getDisabled === void 0 ? void 0 : getDisabled())
        return true;
      return false;
    };
    const getMergedShow = () => {
      if (getMergedDisabled())
        return false;
      return mergedShowWithoutDisabledRef.value;
    };
    const compatibleShowArrowRef = useCompitable(props, ["arrow", "showArrow"]);
    const mergedShowArrowRef = computed(() => {
      if (props.overlap)
        return false;
      return compatibleShowArrowRef.value;
    });
    let bodyInstance = null;
    const showTimerIdRef = ref(null);
    const hideTimerIdRef = ref(null);
    const positionManuallyRef = useMemo(() => {
      return props.x !== void 0 && props.y !== void 0;
    });
    function doUpdateShow(value2) {
      const { "onUpdate:show": _onUpdateShow, onUpdateShow, onShow, onHide } = props;
      uncontrolledShowRef.value = value2;
      if (_onUpdateShow) {
        call(_onUpdateShow, value2);
      }
      if (onUpdateShow) {
        call(onUpdateShow, value2);
      }
      if (value2 && onShow) {
        call(onShow, true);
      }
      if (value2 && onHide) {
        call(onHide, false);
      }
    }
    function syncPosition() {
      if (bodyInstance) {
        bodyInstance.syncPosition();
      }
    }
    function clearShowTimer() {
      const { value: showTimerId } = showTimerIdRef;
      if (showTimerId) {
        window.clearTimeout(showTimerId);
        showTimerIdRef.value = null;
      }
    }
    function clearHideTimer() {
      const { value: hideTimerId } = hideTimerIdRef;
      if (hideTimerId) {
        window.clearTimeout(hideTimerId);
        hideTimerIdRef.value = null;
      }
    }
    function handleFocus() {
      const mergedDisabled = getMergedDisabled();
      if (props.trigger === "focus" && !mergedDisabled) {
        if (getMergedShow())
          return;
        doUpdateShow(true);
      }
    }
    function handleBlur() {
      const mergedDisabled = getMergedDisabled();
      if (props.trigger === "focus" && !mergedDisabled) {
        if (!getMergedShow())
          return;
        doUpdateShow(false);
      }
    }
    function handleMouseEnter() {
      const mergedDisabled = getMergedDisabled();
      if (props.trigger === "hover" && !mergedDisabled) {
        clearHideTimer();
        if (showTimerIdRef.value !== null)
          return;
        if (getMergedShow())
          return;
        const delayCallback = () => {
          doUpdateShow(true);
          showTimerIdRef.value = null;
        };
        const { delay } = props;
        if (delay === 0) {
          delayCallback();
        } else {
          showTimerIdRef.value = window.setTimeout(delayCallback, delay);
        }
      }
    }
    function handleMouseLeave() {
      const mergedDisabled = getMergedDisabled();
      if (props.trigger === "hover" && !mergedDisabled) {
        clearShowTimer();
        if (hideTimerIdRef.value !== null)
          return;
        if (!getMergedShow())
          return;
        const delayedCallback = () => {
          doUpdateShow(false);
          hideTimerIdRef.value = null;
        };
        const { duration } = props;
        if (duration === 0) {
          delayedCallback();
        } else {
          hideTimerIdRef.value = window.setTimeout(delayedCallback, duration);
        }
      }
    }
    function handleMouseMoveOutside() {
      handleMouseLeave();
    }
    function handleClickOutside(e25) {
      var _a2;
      if (!getMergedShow())
        return;
      if (props.trigger === "click") {
        clearShowTimer();
        clearHideTimer();
        doUpdateShow(false);
      }
      (_a2 = props.onClickoutside) === null || _a2 === void 0 ? void 0 : _a2.call(props, e25);
    }
    function handleClick2() {
      if (props.trigger === "click" && !getMergedDisabled()) {
        clearShowTimer();
        clearHideTimer();
        const nextShow = !getMergedShow();
        doUpdateShow(nextShow);
      }
    }
    function handleKeydown(e25) {
      if (!props.internalTrapFocus)
        return;
      if (e25.key === "Escape") {
        clearShowTimer();
        clearHideTimer();
        doUpdateShow(false);
      }
    }
    function setShow(value2) {
      uncontrolledShowRef.value = value2;
    }
    function getTriggerElement() {
      var _a2;
      return (_a2 = binderInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.targetRef;
    }
    function setBodyInstance(value2) {
      bodyInstance = value2;
    }
    provide("NPopover", {
      getTriggerElement,
      handleKeydown,
      handleMouseEnter,
      handleMouseLeave,
      handleClickOutside,
      handleMouseMoveOutside,
      setBodyInstance,
      positionManuallyRef,
      isMountedRef,
      zIndexRef: toRef(props, "zIndex"),
      extraClassRef: toRef(props, "internalExtraClass"),
      internalRenderBodyRef: toRef(props, "internalRenderBody")
    });
    watchEffect(() => {
      if (mergedShowWithoutDisabledRef.value && getMergedDisabled()) {
        doUpdateShow(false);
      }
    });
    return {
      binderInstRef,
      positionManually: positionManuallyRef,
      mergedShowConsideringDisabledProp: mergedShowConsideringDisabledPropRef,
      uncontrolledShow: uncontrolledShowRef,
      mergedShowArrow: mergedShowArrowRef,
      getMergedShow,
      setShow,
      handleClick: handleClick2,
      handleMouseEnter,
      handleMouseLeave,
      handleFocus,
      handleBlur,
      syncPosition
    };
  },
  render() {
    var _a2;
    const { positionManually, $slots: slots } = this;
    let triggerVNode;
    let popoverInside = false;
    if (!positionManually) {
      if (slots.activator) {
        triggerVNode = getFirstSlotVNode(slots, "activator");
      } else {
        triggerVNode = getFirstSlotVNode(slots, "trigger");
      }
      if (triggerVNode) {
        triggerVNode = cloneVNode(triggerVNode);
        triggerVNode = triggerVNode.type === Text$1 ? h$1("span", [triggerVNode]) : triggerVNode;
        const handlers2 = {
          onClick: this.handleClick,
          onMouseenter: this.handleMouseEnter,
          onMouseleave: this.handleMouseLeave,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        };
        if ((_a2 = triggerVNode.type) === null || _a2 === void 0 ? void 0 : _a2.__popover__) {
          popoverInside = true;
          if (!triggerVNode.props) {
            triggerVNode.props = {
              internalSyncTargetWithParent: true,
              internalInheritedEventHandlers: []
            };
          }
          triggerVNode.props.internalSyncTargetWithParent = true;
          if (!triggerVNode.props.internalInheritedEventHandlers) {
            triggerVNode.props.internalInheritedEventHandlers = [handlers2];
          } else {
            triggerVNode.props.internalInheritedEventHandlers = [
              handlers2,
              ...triggerVNode.props.internalInheritedEventHandlers
            ];
          }
        } else {
          const { internalInheritedEventHandlers } = this;
          const ascendantAndCurrentHandlers = [
            handlers2,
            ...internalInheritedEventHandlers
          ];
          const mergedHandlers = {
            onBlur: (e25) => {
              ascendantAndCurrentHandlers.forEach((_handlers) => {
                _handlers.onBlur(e25);
              });
            },
            onFocus: (e25) => {
              ascendantAndCurrentHandlers.forEach((_handlers) => {
                _handlers.onFocus(e25);
              });
            },
            onClick: (e25) => {
              ascendantAndCurrentHandlers.forEach((_handlers) => {
                _handlers.onClick(e25);
              });
            },
            onMouseenter: (e25) => {
              ascendantAndCurrentHandlers.forEach((_handlers) => {
                _handlers.onMouseenter(e25);
              });
            },
            onMouseleave: (e25) => {
              ascendantAndCurrentHandlers.forEach((_handlers) => {
                _handlers.onMouseleave(e25);
              });
            }
          };
          appendEvents(triggerVNode, internalInheritedEventHandlers ? "nested" : positionManually ? "manual" : this.trigger, mergedHandlers);
        }
      }
    }
    return h$1(VBinder, { ref: "binderInstRef", syncTarget: !popoverInside, syncTargetWithParent: this.internalSyncTargetWithParent }, {
      default: () => {
        void this.mergedShowConsideringDisabledProp;
        const mergedShow = this.getMergedShow();
        return [
          this.internalTrapFocus && mergedShow ? withDirectives(h$1("div", { style: { position: "fixed", inset: 0 } }), [
            [
              zindexable$1,
              {
                enabled: mergedShow,
                zIndex: this.zIndex
              }
            ]
          ]) : null,
          positionManually ? null : h$1(VTarget, null, {
            default: () => triggerVNode
          }),
          h$1(NPopoverBody, keep(this.$props, bodyPropKeys, Object.assign(Object.assign({}, this.$attrs), { showArrow: this.mergedShowArrow, show: mergedShow })), {
            default: () => {
              var _a3, _b2;
              return (_b2 = (_a3 = this.$slots).default) === null || _b2 === void 0 ? void 0 : _b2.call(_a3);
            },
            header: () => {
              var _a3, _b2;
              return (_b2 = (_a3 = this.$slots).header) === null || _b2 === void 0 ? void 0 : _b2.call(_a3);
            },
            footer: () => {
              var _a3, _b2;
              return (_b2 = (_a3 = this.$slots).footer) === null || _b2 === void 0 ? void 0 : _b2.call(_a3);
            }
          })
        ];
      }
    });
  }
});
var commonVariables$b = {
  closeIconSizeTiny: "12px",
  closeIconSizeSmall: "12px",
  closeIconSizeMedium: "14px",
  closeIconSizeLarge: "14px",
  closeSizeTiny: "16px",
  closeSizeSmall: "16px",
  closeSizeMedium: "18px",
  closeSizeLarge: "18px",
  padding: "0 7px",
  closeMargin: "0 0 0 4px",
  closeMarginRtl: "0 4px 0 0"
};
const self$G = (vars) => {
  const { textColor2, primaryColorHover, primaryColorPressed, primaryColor, infoColor, successColor, warningColor, errorColor, baseColor, borderColor, opacityDisabled, tagColor, closeIconColor, closeIconColorHover, closeIconColorPressed, borderRadiusSmall: borderRadius, fontSizeMini, fontSizeTiny, fontSizeSmall, fontSizeMedium, heightMini, heightTiny, heightSmall, heightMedium, closeColorHover, closeColorPressed, buttonColor2Hover, buttonColor2Pressed, fontWeightStrong } = vars;
  return Object.assign(Object.assign({}, commonVariables$b), {
    closeBorderRadius: borderRadius,
    heightTiny: heightMini,
    heightSmall: heightTiny,
    heightMedium: heightSmall,
    heightLarge: heightMedium,
    borderRadius,
    opacityDisabled,
    fontSizeTiny: fontSizeMini,
    fontSizeSmall: fontSizeTiny,
    fontSizeMedium: fontSizeSmall,
    fontSizeLarge: fontSizeMedium,
    fontWeightStrong,
    textColorCheckable: textColor2,
    textColorHoverCheckable: textColor2,
    textColorPressedCheckable: textColor2,
    textColorChecked: baseColor,
    colorCheckable: "#0000",
    colorHoverCheckable: buttonColor2Hover,
    colorPressedCheckable: buttonColor2Pressed,
    colorChecked: primaryColor,
    colorCheckedHover: primaryColorHover,
    colorCheckedPressed: primaryColorPressed,
    border: `1px solid ${borderColor}`,
    textColor: textColor2,
    color: tagColor,
    colorBordered: "rgb(250, 250, 252)",
    closeIconColor,
    closeIconColorHover,
    closeIconColorPressed,
    closeColorHover,
    closeColorPressed,
    borderPrimary: `1px solid ${changeColor(primaryColor, { alpha: 0.3 })}`,
    textColorPrimary: primaryColor,
    colorPrimary: changeColor(primaryColor, { alpha: 0.12 }),
    colorBorderedPrimary: changeColor(primaryColor, { alpha: 0.1 }),
    closeIconColorPrimary: primaryColor,
    closeIconColorHoverPrimary: primaryColor,
    closeIconColorPressedPrimary: primaryColor,
    closeColorHoverPrimary: changeColor(primaryColor, { alpha: 0.12 }),
    closeColorPressedPrimary: changeColor(primaryColor, { alpha: 0.18 }),
    borderInfo: `1px solid ${changeColor(infoColor, { alpha: 0.3 })}`,
    textColorInfo: infoColor,
    colorInfo: changeColor(infoColor, { alpha: 0.12 }),
    colorBorderedInfo: changeColor(infoColor, { alpha: 0.1 }),
    closeIconColorInfo: infoColor,
    closeIconColorHoverInfo: infoColor,
    closeIconColorPressedInfo: infoColor,
    closeColorHoverInfo: changeColor(infoColor, { alpha: 0.12 }),
    closeColorPressedInfo: changeColor(infoColor, { alpha: 0.18 }),
    borderSuccess: `1px solid ${changeColor(successColor, { alpha: 0.3 })}`,
    textColorSuccess: successColor,
    colorSuccess: changeColor(successColor, { alpha: 0.12 }),
    colorBorderedSuccess: changeColor(successColor, { alpha: 0.1 }),
    closeIconColorSuccess: successColor,
    closeIconColorHoverSuccess: successColor,
    closeIconColorPressedSuccess: successColor,
    closeColorHoverSuccess: changeColor(successColor, { alpha: 0.12 }),
    closeColorPressedSuccess: changeColor(successColor, { alpha: 0.18 }),
    borderWarning: `1px solid ${changeColor(warningColor, { alpha: 0.35 })}`,
    textColorWarning: warningColor,
    colorWarning: changeColor(warningColor, { alpha: 0.15 }),
    colorBorderedWarning: changeColor(warningColor, { alpha: 0.12 }),
    closeIconColorWarning: warningColor,
    closeIconColorHoverWarning: warningColor,
    closeIconColorPressedWarning: warningColor,
    closeColorHoverWarning: changeColor(warningColor, { alpha: 0.12 }),
    closeColorPressedWarning: changeColor(warningColor, { alpha: 0.18 }),
    borderError: `1px solid ${changeColor(errorColor, { alpha: 0.23 })}`,
    textColorError: errorColor,
    colorError: changeColor(errorColor, { alpha: 0.1 }),
    colorBorderedError: changeColor(errorColor, { alpha: 0.08 }),
    closeIconColorError: errorColor,
    closeIconColorHoverError: errorColor,
    closeIconColorPressedError: errorColor,
    closeColorHoverError: changeColor(errorColor, { alpha: 0.12 }),
    closeColorPressedError: changeColor(errorColor, { alpha: 0.18 })
  });
};
const tagLight = {
  name: "Tag",
  common: commonLight,
  self: self$G
};
var tagLight$1 = tagLight;
var commonProps = {
  color: Object,
  type: {
    type: String,
    default: "default"
  },
  round: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  closable: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  }
};
var style$M = cB$1("tag", `
 white-space: nowrap;
 position: relative;
 box-sizing: border-box;
 cursor: default;
 display: inline-flex;
 align-items: center;
 flex-wrap: nowrap;
 padding: var(--n-padding);
 border-radius: var(--n-border-radius);
 color: var(--n-text-color);
 background-color: var(--n-color);
 transition: 
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 line-height: 1;
 height: var(--n-height);
 font-size: var(--n-font-size);
`, [cM("strong", `
 font-weight: var(--n-font-weight-strong);
 `), cE$1("border", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 border: var(--n-border);
 transition: border-color .3s var(--n-bezier);
 `), cE$1("icon", `
 display: flex;
 margin: 0 4px 0 0;
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 font-size: var(--n-avatar-size-override);
 `), cE$1("avatar", `
 display: flex;
 margin: 0 6px 0 0;
 `), cE$1("close", `
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `), cM("round", `
 padding: 0 calc(var(--n-height) / 3);
 border-radius: calc(var(--n-height) / 2);
 `, [cE$1("icon", `
 margin: 0 4px 0 calc((var(--n-height) - 8px) / -2);
 `), cE$1("avatar", `
 margin: 0 6px 0 calc((var(--n-height) - 8px) / -2);
 `), cM("closable", `
 padding: 0 calc(var(--n-height) / 4) 0 calc(var(--n-height) / 3);
 `)]), cM("icon, avatar", [cM("round", `
 padding: 0 calc(var(--n-height) / 3) 0 calc(var(--n-height) / 2);
 `)]), cM("disabled", `
 cursor: not-allowed !important;
 opacity: var(--n-opacity-disabled);
 `), cM("checkable", `
 cursor: pointer;
 box-shadow: none;
 color: var(--n-text-color-checkable);
 background-color: var(--n-color-checkable);
 `, [cNotM("disabled", [c$2("&:hover", "background-color: var(--n-color-hover-checkable);", [cNotM("checked", "color: var(--n-text-color-hover-checkable);")]), c$2("&:active", "background-color: var(--n-color-pressed-checkable);", [cNotM("checked", "color: var(--n-text-color-pressed-checkable);")])]), cM("checked", `
 color: var(--n-text-color-checked);
 background-color: var(--n-color-checked);
 `, [cNotM("disabled", [c$2("&:hover", "background-color: var(--n-color-checked-hover);"), c$2("&:active", "background-color: var(--n-color-checked-pressed);")])])])]);
const tagProps = Object.assign(Object.assign(Object.assign({}, useTheme.props), commonProps), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  checked: Boolean,
  checkable: Boolean,
  strong: Boolean,
  triggerClickOnClose: Boolean,
  onClose: [Array, Function],
  onMouseenter: Function,
  onMouseleave: Function,
  "onUpdate:checked": Function,
  onUpdateChecked: Function,
  internalCloseFocusable: {
    type: Boolean,
    default: true
  },
  internalCloseIsButtonTag: {
    type: Boolean,
    default: true
  },
  onCheckedChange: Function
});
const tagInjectionKey = createInjectionKey("n-tag");
var NTag = defineComponent({
  name: "Tag",
  props: tagProps,
  setup(props) {
    const contentRef = ref(null);
    const { mergedBorderedRef, mergedClsPrefixRef, inlineThemeDisabled, mergedRtlRef } = useConfig(props);
    const themeRef = useTheme("Tag", "-tag", style$M, tagLight$1, props, mergedClsPrefixRef);
    provide(tagInjectionKey, {
      roundRef: toRef(props, "round")
    });
    function handleClick2(e25) {
      if (!props.disabled) {
        if (props.checkable) {
          const { checked, onCheckedChange, onUpdateChecked, "onUpdate:checked": _onUpdateChecked } = props;
          if (onUpdateChecked)
            onUpdateChecked(!checked);
          if (_onUpdateChecked)
            _onUpdateChecked(!checked);
          if (onCheckedChange)
            onCheckedChange(!checked);
        }
      }
    }
    function handleCloseClick(e25) {
      if (!props.triggerClickOnClose) {
        e25.stopPropagation();
      }
      if (!props.disabled) {
        const { onClose } = props;
        if (onClose)
          call(onClose, e25);
      }
    }
    const tagPublicMethods = {
      setTextContent(textContent) {
        const { value: value2 } = contentRef;
        if (value2)
          value2.textContent = textContent;
      }
    };
    const rtlEnabledRef = useRtl("Tag", mergedRtlRef, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { type: type4, size: size2, color: { color, textColor } = {} } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { padding, closeMargin, closeMarginRtl, borderRadius, opacityDisabled, textColorCheckable, textColorHoverCheckable, textColorPressedCheckable, textColorChecked, colorCheckable, colorHoverCheckable, colorPressedCheckable, colorChecked, colorCheckedHover, colorCheckedPressed, closeBorderRadius, fontWeightStrong, [createKey("colorBordered", type4)]: colorBordered, [createKey("closeSize", size2)]: closeSize, [createKey("closeIconSize", size2)]: closeIconSize, [createKey("fontSize", size2)]: fontSize2, [createKey("height", size2)]: height, [createKey("color", type4)]: typedColor, [createKey("textColor", type4)]: typeTextColor, [createKey("border", type4)]: border, [createKey("closeIconColor", type4)]: closeIconColor, [createKey("closeIconColorHover", type4)]: closeIconColorHover, [createKey("closeIconColorPressed", type4)]: closeIconColorPressed, [createKey("closeColorHover", type4)]: closeColorHover, [createKey("closeColorPressed", type4)]: closeColorPressed } } = themeRef.value;
      return {
        "--n-font-weight-strong": fontWeightStrong,
        "--n-avatar-size-override": `calc(${height} - 8px)`,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-border-radius": borderRadius,
        "--n-border": border,
        "--n-close-icon-size": closeIconSize,
        "--n-close-color-pressed": closeColorPressed,
        "--n-close-color-hover": closeColorHover,
        "--n-close-border-radius": closeBorderRadius,
        "--n-close-icon-color": closeIconColor,
        "--n-close-icon-color-hover": closeIconColorHover,
        "--n-close-icon-color-pressed": closeIconColorPressed,
        "--n-close-icon-color-disabled": closeIconColor,
        "--n-close-margin": closeMargin,
        "--n-close-margin-rtl": closeMarginRtl,
        "--n-close-size": closeSize,
        "--n-color": color || (mergedBorderedRef.value ? colorBordered : typedColor),
        "--n-color-checkable": colorCheckable,
        "--n-color-checked": colorChecked,
        "--n-color-checked-hover": colorCheckedHover,
        "--n-color-checked-pressed": colorCheckedPressed,
        "--n-color-hover-checkable": colorHoverCheckable,
        "--n-color-pressed-checkable": colorPressedCheckable,
        "--n-font-size": fontSize2,
        "--n-height": height,
        "--n-opacity-disabled": opacityDisabled,
        "--n-padding": padding,
        "--n-text-color": textColor || typeTextColor,
        "--n-text-color-checkable": textColorCheckable,
        "--n-text-color-checked": textColorChecked,
        "--n-text-color-hover-checkable": textColorHoverCheckable,
        "--n-text-color-pressed-checkable": textColorPressedCheckable
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("tag", computed(() => {
      let hash2 = "";
      const { type: type4, size: size2, color: { color, textColor } = {} } = props;
      hash2 += type4[0];
      hash2 += size2[0];
      if (color) {
        hash2 += `a${color2Class(color)}`;
      }
      if (textColor) {
        hash2 += `b${color2Class(textColor)}`;
      }
      if (mergedBorderedRef.value) {
        hash2 += "c";
      }
      return hash2;
    }), cssVarsRef, props) : void 0;
    return Object.assign(Object.assign({}, tagPublicMethods), {
      rtlEnabled: rtlEnabledRef,
      mergedClsPrefix: mergedClsPrefixRef,
      contentRef,
      mergedBordered: mergedBorderedRef,
      handleClick: handleClick2,
      handleCloseClick,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    });
  },
  render() {
    var _a2, _b2;
    const { mergedClsPrefix, rtlEnabled, closable, color: { borderColor } = {}, round, onRender, $slots } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    const avatarNode = resolveWrappedSlot($slots.avatar, (children) => children && h$1("div", { class: `${mergedClsPrefix}-tag__avatar` }, children));
    const iconNode = resolveWrappedSlot($slots.icon, (children) => children && h$1("div", { class: `${mergedClsPrefix}-tag__icon` }, children));
    return h$1("div", { class: [
      `${mergedClsPrefix}-tag`,
      this.themeClass,
      {
        [`${mergedClsPrefix}-tag--rtl`]: rtlEnabled,
        [`${mergedClsPrefix}-tag--strong`]: this.strong,
        [`${mergedClsPrefix}-tag--disabled`]: this.disabled,
        [`${mergedClsPrefix}-tag--checkable`]: this.checkable,
        [`${mergedClsPrefix}-tag--checked`]: this.checkable && this.checked,
        [`${mergedClsPrefix}-tag--round`]: round,
        [`${mergedClsPrefix}-tag--avatar`]: avatarNode,
        [`${mergedClsPrefix}-tag--icon`]: iconNode,
        [`${mergedClsPrefix}-tag--closable`]: closable
      }
    ], style: this.cssVars, onClick: this.handleClick, onMouseenter: this.onMouseenter, onMouseleave: this.onMouseleave }, iconNode || avatarNode, h$1("span", { class: `${mergedClsPrefix}-tag__content`, ref: "contentRef" }, (_b2 = (_a2 = this.$slots).default) === null || _b2 === void 0 ? void 0 : _b2.call(_a2)), !this.checkable && closable ? h$1(NBaseClose, { clsPrefix: mergedClsPrefix, class: `${mergedClsPrefix}-tag__close`, disabled: this.disabled, onClick: this.handleCloseClick, focusable: this.internalCloseFocusable, round, isButtonTag: this.internalCloseIsButtonTag, absolute: true }) : null, !this.checkable && this.mergedBordered ? h$1("div", { class: `${mergedClsPrefix}-tag__border`, style: { borderColor } }) : null);
  }
});
var style$L = cB$1("base-clear", `
 flex-shrink: 0;
 height: 1em;
 width: 1em;
 position: relative;
`, [c$2(">", [cE$1("clear", `
 font-size: var(--n-clear-size);
 height: 1em;
 width: 1em;
 cursor: pointer;
 color: var(--n-clear-color);
 transition: color .3s var(--n-bezier);
 display: flex;
 `, [c$2("&:hover", `
 color: var(--n-clear-color-hover)!important;
 `), c$2("&:active", `
 color: var(--n-clear-color-pressed)!important;
 `)]), cE$1("placeholder", `
 display: flex;
 `), cE$1("clear, placeholder", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [iconSwitchTransition({
  originalTransform: "translateX(-50%) translateY(-50%)",
  left: "50%",
  top: "50%"
})])])]);
var NBaseClear = defineComponent({
  name: "BaseClear",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    show: Boolean,
    onClear: Function
  },
  setup(props) {
    useStyle("-base-clear", style$L, toRef(props, "clsPrefix"));
    return {
      handleMouseDown(e25) {
        e25.preventDefault();
      }
    };
  },
  render() {
    const { clsPrefix } = this;
    return h$1("div", { class: `${clsPrefix}-base-clear` }, h$1(NIconSwitchTransition, null, {
      default: () => {
        var _a2, _b2;
        return this.show ? h$1("div", { key: "dismiss", class: `${clsPrefix}-base-clear__clear`, onClick: this.onClear, onMousedown: this.handleMouseDown, "data-clear": true }, resolveSlot(this.$slots.icon, () => [
          h$1(NBaseIcon, { clsPrefix }, {
            default: () => h$1(ClearIcon, null)
          })
        ])) : h$1("div", { key: "icon", class: `${clsPrefix}-base-clear__placeholder` }, (_b2 = (_a2 = this.$slots).placeholder) === null || _b2 === void 0 ? void 0 : _b2.call(_a2));
      }
    }));
  }
});
var NBaseSuffix = defineComponent({
  name: "InternalSelectionSuffix",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    showArrow: {
      type: Boolean,
      default: void 0
    },
    showClear: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    onClear: Function
  },
  setup(props, { slots }) {
    return () => {
      const { clsPrefix } = props;
      return h$1(NBaseLoading, { clsPrefix, class: `${clsPrefix}-base-suffix`, strokeWidth: 24, scale: 0.85, show: props.loading }, {
        default: () => props.showArrow ? h$1(NBaseClear, { clsPrefix, show: props.showClear, onClear: props.onClear }, {
          placeholder: () => h$1(NBaseIcon, { clsPrefix, class: `${clsPrefix}-base-suffix__arrow` }, {
            default: () => resolveSlot(slots.default, () => [
              h$1(ChevronDownIcon, null)
            ])
          })
        }) : null
      });
    };
  }
});
var commonVars$8 = {
  paddingSingle: "0 26px 0 12px",
  paddingMultiple: "3px 26px 0 12px",
  clearSize: "16px",
  arrowSize: "16px"
};
const self$F = (vars) => {
  const { borderRadius, textColor2, textColorDisabled, inputColor, inputColorDisabled, primaryColor, primaryColorHover, warningColor, warningColorHover, errorColor, errorColorHover, borderColor, iconColor, iconColorDisabled, clearColor, clearColorHover, clearColorPressed, placeholderColor, placeholderColorDisabled, fontSizeTiny, fontSizeSmall, fontSizeMedium, fontSizeLarge, heightTiny, heightSmall, heightMedium, heightLarge } = vars;
  return Object.assign(Object.assign({}, commonVars$8), {
    fontSizeTiny,
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    heightTiny,
    heightSmall,
    heightMedium,
    heightLarge,
    borderRadius,
    textColor: textColor2,
    textColorDisabled,
    placeholderColor,
    placeholderColorDisabled,
    color: inputColor,
    colorDisabled: inputColorDisabled,
    colorActive: inputColor,
    border: `1px solid ${borderColor}`,
    borderHover: `1px solid ${primaryColorHover}`,
    borderActive: `1px solid ${primaryColor}`,
    borderFocus: `1px solid ${primaryColorHover}`,
    boxShadowHover: "none",
    boxShadowActive: `0 0 0 2px ${changeColor(primaryColor, {
      alpha: 0.2
    })}`,
    boxShadowFocus: `0 0 0 2px ${changeColor(primaryColor, {
      alpha: 0.2
    })}`,
    caretColor: primaryColor,
    arrowColor: iconColor,
    arrowColorDisabled: iconColorDisabled,
    loadingColor: primaryColor,
    borderWarning: `1px solid ${warningColor}`,
    borderHoverWarning: `1px solid ${warningColorHover}`,
    borderActiveWarning: `1px solid ${warningColor}`,
    borderFocusWarning: `1px solid ${warningColorHover}`,
    boxShadowHoverWarning: "none",
    boxShadowActiveWarning: `0 0 0 2px ${changeColor(warningColor, {
      alpha: 0.2
    })}`,
    boxShadowFocusWarning: `0 0 0 2px ${changeColor(warningColor, {
      alpha: 0.2
    })}`,
    colorActiveWarning: inputColor,
    caretColorWarning: warningColor,
    borderError: `1px solid ${errorColor}`,
    borderHoverError: `1px solid ${errorColorHover}`,
    borderActiveError: `1px solid ${errorColor}`,
    borderFocusError: `1px solid ${errorColorHover}`,
    boxShadowHoverError: "none",
    boxShadowActiveError: `0 0 0 2px ${changeColor(errorColor, {
      alpha: 0.2
    })}`,
    boxShadowFocusError: `0 0 0 2px ${changeColor(errorColor, {
      alpha: 0.2
    })}`,
    colorActiveError: inputColor,
    caretColorError: errorColor,
    clearColor,
    clearColorHover,
    clearColorPressed
  });
};
const internalSelectionLight = createTheme({
  name: "InternalSelection",
  common: commonLight,
  peers: {
    Popover: popoverLight$1
  },
  self: self$F
});
var internalSelectionLight$1 = internalSelectionLight;
var style$K = c$2([cB$1("base-selection", `
 position: relative;
 z-index: auto;
 box-shadow: none;
 width: 100%;
 max-width: 100%;
 display: inline-block;
 vertical-align: bottom;
 border-radius: var(--n-border-radius);
 min-height: var(--n-height);
 line-height: 1.5;
 font-size: var(--n-font-size);
 `, [cB$1("base-loading", `
 color: var(--n-loading-color);
 `), cB$1("base-selection-tags", "min-height: var(--n-height);"), cE$1("border, state-border", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border: var(--n-border);
 border-radius: inherit;
 transition:
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `), cE$1("state-border", `
 z-index: 1;
 border-color: #0000;
 `), cB$1("base-suffix", `
 cursor: pointer;
 position: absolute;
 top: 50%;
 transform: translateY(-50%);
 right: 10px;
 `, [cE$1("arrow", `
 font-size: var(--n-arrow-size);
 color: var(--n-arrow-color);
 transition: color .3s var(--n-bezier);
 `)]), cB$1("base-selection-overlay", `
 display: flex;
 align-items: center;
 white-space: nowrap;
 pointer-events: none;
 position: absolute;
 top: 0;
 right: 0;
 bottom: 0;
 left: 0;
 padding: var(--n-padding-single);
 transition: color .3s var(--n-bezier);
 `, [cE$1("wrapper", `
 flex-basis: 0;
 flex-grow: 1;
 overflow: hidden;
 text-overflow: ellipsis;
 `)]), cB$1("base-selection-placeholder", `
 color: var(--n-placeholder-color);
 `, [cE$1("inner", `
 max-width: 100%;
 overflow: hidden;
 `)]), cB$1("base-selection-tags", `
 cursor: pointer;
 outline: none;
 box-sizing: border-box;
 position: relative;
 z-index: auto;
 display: flex;
 padding: var(--n-padding-multiple);
 flex-wrap: wrap;
 align-items: center;
 width: 100%;
 vertical-align: bottom;
 background-color: var(--n-color);
 border-radius: inherit;
 transition:
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `), cB$1("base-selection-label", `
 height: var(--n-height);
 display: inline-flex;
 width: 100%;
 vertical-align: bottom;
 cursor: pointer;
 outline: none;
 z-index: auto;
 box-sizing: border-box;
 position: relative;
 transition:
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 border-radius: inherit;
 background-color: var(--n-color);
 align-items: center;
 `, [cB$1("base-selection-input", `
 font-size: inherit;
 line-height: inherit;
 outline: none;
 cursor: pointer;
 box-sizing: border-box;
 border:none;
 width: 100%;
 padding: var(--n-padding-single);
 background-color: #0000;
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 caret-color: var(--n-caret-color);
 `, [cE$1("content", `
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap; 
 `)]), cE$1("render-label", `
 color: var(--n-text-color);
 `)]), cNotM("disabled", [c$2("&:hover", [cE$1("state-border", `
 box-shadow: var(--n-box-shadow-hover);
 border: var(--n-border-hover);
 `)]), cM("focus", [cE$1("state-border", `
 box-shadow: var(--n-box-shadow-focus);
 border: var(--n-border-focus);
 `)]), cM("active", [cE$1("state-border", `
 box-shadow: var(--n-box-shadow-active);
 border: var(--n-border-active);
 `), cB$1("base-selection-label", "background-color: var(--n-color-active);"), cB$1("base-selection-tags", "background-color: var(--n-color-active);")])]), cM("disabled", "cursor: not-allowed;", [cE$1("arrow", `
 color: var(--n-arrow-color-disabled);
 `), cB$1("base-selection-label", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `, [cB$1("base-selection-input", `
 cursor: not-allowed;
 color: var(--n-text-color-disabled);
 `), cE$1("render-label", `
 color: var(--n-text-color-disabled);
 `)]), cB$1("base-selection-tags", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `), cB$1("base-selection-placeholder", `
 cursor: not-allowed;
 color: var(--n-placeholder-color-disabled);
 `)]), cB$1("base-selection-input-tag", `
 height: calc(var(--n-height) - 6px);
 line-height: calc(var(--n-height) - 6px);
 outline: none;
 display: none;
 position: relative;
 margin-bottom: 3px;
 max-width: 100%;
 vertical-align: bottom;
 `, [cE$1("input", `
 font-size: inherit;
 font-family: inherit;
 min-width: 1px;
 padding: 0;
 background-color: #0000;
 outline: none;
 border: none;
 max-width: 100%;
 overflow: hidden;
 width: 1em;
 line-height: inherit;
 cursor: pointer;
 color: var(--n-text-color);
 caret-color: var(--n-caret-color);
 `), cE$1("mirror", `
 position: absolute;
 left: 0;
 top: 0;
 white-space: pre;
 visibility: hidden;
 user-select: none;
 -webkit-user-select: none;
 opacity: 0;
 `)]), ["warning", "error"].map((status) => cM(`${status}-status`, [cE$1("state-border", `border: var(--n-border-${status});`), cNotM("disabled", [c$2("&:hover", [cE$1("state-border", `
 box-shadow: var(--n-box-shadow-hover-${status});
 border: var(--n-border-hover-${status});
 `)]), cM("active", [cE$1("state-border", `
 box-shadow: var(--n-box-shadow-active-${status});
 border: var(--n-border-active-${status});
 `), cB$1("base-selection-label", `background-color: var(--n-color-active-${status});`), cB$1("base-selection-tags", `background-color: var(--n-color-active-${status});`)]), cM("focus", [cE$1("state-border", `
 box-shadow: var(--n-box-shadow-focus-${status});
 border: var(--n-border-focus-${status});
 `)])])]))]), cB$1("base-selection-popover", `
 margin-bottom: -3px;
 display: flex;
 flex-wrap: wrap;
 margin-right: -8px;
 `), cB$1("base-selection-tag-wrapper", `
 max-width: 100%;
 display: inline-flex;
 padding: 0 7px 3px 0;
 `, [c$2("&:last-child", "padding-right: 0;"), cB$1("tag", `
 font-size: 14px;
 max-width: 100%;
 `, [cE$1("content", `
 line-height: 1.25;
 text-overflow: ellipsis;
 overflow: hidden;
 `)])])]);
var NInternalSelection = defineComponent({
  name: "InternalSelection",
  props: Object.assign(Object.assign({}, useTheme.props), { clsPrefix: {
    type: String,
    required: true
  }, bordered: {
    type: Boolean,
    default: void 0
  }, active: Boolean, pattern: {
    type: String,
    default: ""
  }, placeholder: String, selectedOption: {
    type: Object,
    default: null
  }, selectedOptions: {
    type: Array,
    default: null
  }, labelField: { type: String, default: "label" }, valueField: {
    type: String,
    default: "value"
  }, multiple: Boolean, filterable: Boolean, clearable: Boolean, disabled: Boolean, size: {
    type: String,
    default: "medium"
  }, loading: Boolean, autofocus: Boolean, showArrow: {
    type: Boolean,
    default: true
  }, inputProps: Object, focused: Boolean, renderTag: Function, onKeydown: Function, onClick: Function, onBlur: Function, onFocus: Function, onDeleteOption: Function, maxTagCount: [String, Number], onClear: Function, onPatternInput: Function, onPatternFocus: Function, onPatternBlur: Function, renderLabel: Function, status: String, inlineThemeDisabled: Boolean, ignoreComposition: { type: Boolean, default: true }, onResize: Function }),
  setup(props) {
    const patternInputMirrorRef = ref(null);
    const patternInputRef = ref(null);
    const selfRef = ref(null);
    const multipleElRef = ref(null);
    const singleElRef = ref(null);
    const patternInputWrapperRef = ref(null);
    const counterRef = ref(null);
    const counterWrapperRef = ref(null);
    const overflowRef = ref(null);
    const inputTagElRef = ref(null);
    const showTagsPopoverRef = ref(false);
    const patternInputFocusedRef = ref(false);
    const hoverRef = ref(false);
    const themeRef = useTheme("InternalSelection", "-internal-selection", style$K, internalSelectionLight$1, props, toRef(props, "clsPrefix"));
    const mergedClearableRef = computed(() => {
      return props.clearable && !props.disabled && (hoverRef.value || props.active);
    });
    const filterablePlaceholderRef = computed(() => {
      return props.selectedOption ? props.renderTag ? props.renderTag({
        option: props.selectedOption,
        handleClose: () => {
        }
      }) : props.renderLabel ? props.renderLabel(props.selectedOption, true) : render$3U(props.selectedOption[props.labelField], props.selectedOption, true) : props.placeholder;
    });
    const labelRef = computed(() => {
      const option = props.selectedOption;
      if (!option)
        return void 0;
      return option[props.labelField];
    });
    const selectedRef = computed(() => {
      if (props.multiple) {
        return !!(Array.isArray(props.selectedOptions) && props.selectedOptions.length);
      } else {
        return props.selectedOption !== null;
      }
    });
    function syncMirrorWidth() {
      var _a2;
      const { value: patternInputMirrorEl } = patternInputMirrorRef;
      if (patternInputMirrorEl) {
        const { value: patternInputEl } = patternInputRef;
        if (patternInputEl) {
          patternInputEl.style.width = `${patternInputMirrorEl.offsetWidth}px`;
          if (props.maxTagCount !== "responsive") {
            (_a2 = overflowRef.value) === null || _a2 === void 0 ? void 0 : _a2.sync();
          }
        }
      }
    }
    function hideInputTag() {
      const { value: inputTagEl } = inputTagElRef;
      if (inputTagEl)
        inputTagEl.style.display = "none";
    }
    function showInputTag() {
      const { value: inputTagEl } = inputTagElRef;
      if (inputTagEl)
        inputTagEl.style.display = "inline-block";
    }
    watch(toRef(props, "active"), (value2) => {
      if (!value2)
        hideInputTag();
    });
    watch(toRef(props, "pattern"), () => {
      if (props.multiple) {
        void nextTick(syncMirrorWidth);
      }
    });
    function doFocus(e25) {
      const { onFocus } = props;
      if (onFocus)
        onFocus(e25);
    }
    function doBlur(e25) {
      const { onBlur } = props;
      if (onBlur)
        onBlur(e25);
    }
    function doDeleteOption(value2) {
      const { onDeleteOption } = props;
      if (onDeleteOption)
        onDeleteOption(value2);
    }
    function doClear(e25) {
      const { onClear } = props;
      if (onClear)
        onClear(e25);
    }
    function doPatternInput(value2) {
      const { onPatternInput } = props;
      if (onPatternInput)
        onPatternInput(value2);
    }
    function handleFocusin(e25) {
      var _a2;
      if (!e25.relatedTarget || !((_a2 = selfRef.value) === null || _a2 === void 0 ? void 0 : _a2.contains(e25.relatedTarget))) {
        doFocus(e25);
      }
    }
    function handleFocusout(e25) {
      var _a2;
      if ((_a2 = selfRef.value) === null || _a2 === void 0 ? void 0 : _a2.contains(e25.relatedTarget))
        return;
      doBlur(e25);
    }
    function handleClear(e25) {
      doClear(e25);
    }
    function handleMouseEnter() {
      hoverRef.value = true;
    }
    function handleMouseLeave() {
      hoverRef.value = false;
    }
    function handleMouseDown(e25) {
      if (!props.active || !props.filterable)
        return;
      if (e25.target === patternInputRef.value)
        return;
      e25.preventDefault();
    }
    function handleDeleteOption(option) {
      doDeleteOption(option);
    }
    function handlePatternKeyDown(e25) {
      if (e25.key === "Backspace" && !isComposingRef2.value) {
        if (!props.pattern.length) {
          const { selectedOptions } = props;
          if (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) {
            handleDeleteOption(selectedOptions[selectedOptions.length - 1]);
          }
        }
      }
    }
    const isComposingRef2 = ref(false);
    let cachedInputEvent = null;
    function handlePatternInputInput(e25) {
      const { value: patternInputMirrorEl } = patternInputMirrorRef;
      if (patternInputMirrorEl) {
        const inputText = e25.target.value;
        patternInputMirrorEl.textContent = inputText;
        syncMirrorWidth();
      }
      if (props.ignoreComposition) {
        if (!isComposingRef2.value) {
          doPatternInput(e25);
        } else {
          cachedInputEvent = e25;
        }
      } else {
        doPatternInput(e25);
      }
    }
    function handleCompositionStart() {
      isComposingRef2.value = true;
    }
    function handleCompositionEnd() {
      isComposingRef2.value = false;
      if (props.ignoreComposition) {
        doPatternInput(cachedInputEvent);
      }
      cachedInputEvent = null;
    }
    function handlePatternInputFocus(e25) {
      var _a2;
      patternInputFocusedRef.value = true;
      (_a2 = props.onPatternFocus) === null || _a2 === void 0 ? void 0 : _a2.call(props, e25);
    }
    function handlePatternInputBlur(e25) {
      var _a2;
      patternInputFocusedRef.value = false;
      (_a2 = props.onPatternBlur) === null || _a2 === void 0 ? void 0 : _a2.call(props, e25);
    }
    function blur() {
      var _a2, _b2;
      if (props.filterable) {
        patternInputFocusedRef.value = false;
        (_a2 = patternInputWrapperRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
        (_b2 = patternInputRef.value) === null || _b2 === void 0 ? void 0 : _b2.blur();
      } else if (props.multiple) {
        const { value: multipleEl } = multipleElRef;
        multipleEl === null || multipleEl === void 0 ? void 0 : multipleEl.blur();
      } else {
        const { value: singleEl } = singleElRef;
        singleEl === null || singleEl === void 0 ? void 0 : singleEl.blur();
      }
    }
    function focus() {
      var _a2, _b2, _c2;
      if (props.filterable) {
        patternInputFocusedRef.value = false;
        (_a2 = patternInputWrapperRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      } else if (props.multiple) {
        (_b2 = multipleElRef.value) === null || _b2 === void 0 ? void 0 : _b2.focus();
      } else {
        (_c2 = singleElRef.value) === null || _c2 === void 0 ? void 0 : _c2.focus();
      }
    }
    function focusInput() {
      const { value: patternInputEl } = patternInputRef;
      if (patternInputEl) {
        showInputTag();
        patternInputEl.focus();
      }
    }
    function blurInput() {
      const { value: patternInputEl } = patternInputRef;
      if (patternInputEl) {
        patternInputEl.blur();
      }
    }
    function updateCounter(count) {
      const { value: value2 } = counterRef;
      if (value2) {
        value2.setTextContent(`+${count}`);
      }
    }
    function getCounter() {
      const { value: value2 } = counterWrapperRef;
      return value2;
    }
    function getTail() {
      return patternInputRef.value;
    }
    let enterTimerId = null;
    function clearEnterTimer() {
      if (enterTimerId !== null)
        window.clearTimeout(enterTimerId);
    }
    function handleMouseEnterCounter() {
      if (props.disabled || props.active)
        return;
      clearEnterTimer();
      enterTimerId = window.setTimeout(() => {
        if (selectedRef.value) {
          showTagsPopoverRef.value = true;
        }
      }, 100);
    }
    function handleMouseLeaveCounter() {
      clearEnterTimer();
    }
    function onPopoverUpdateShow(show) {
      if (!show) {
        clearEnterTimer();
        showTagsPopoverRef.value = false;
      }
    }
    watch(selectedRef, (value2) => {
      if (!value2) {
        showTagsPopoverRef.value = false;
      }
    });
    onMounted(() => {
      watchEffect(() => {
        const patternInputWrapperEl = patternInputWrapperRef.value;
        if (!patternInputWrapperEl)
          return;
        patternInputWrapperEl.tabIndex = props.disabled || patternInputFocusedRef.value ? -1 : 0;
      });
    });
    useOnResize(selfRef, props.onResize);
    const { inlineThemeDisabled } = props;
    const cssVarsRef = computed(() => {
      const { size: size2 } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: {
        borderRadius,
        color,
        placeholderColor,
        textColor,
        paddingSingle,
        paddingMultiple,
        caretColor,
        colorDisabled,
        textColorDisabled,
        placeholderColorDisabled,
        colorActive,
        boxShadowFocus,
        boxShadowActive,
        boxShadowHover,
        border,
        borderFocus,
        borderHover,
        borderActive,
        arrowColor,
        arrowColorDisabled,
        loadingColor,
        colorActiveWarning,
        boxShadowFocusWarning,
        boxShadowActiveWarning,
        boxShadowHoverWarning,
        borderWarning,
        borderFocusWarning,
        borderHoverWarning,
        borderActiveWarning,
        colorActiveError,
        boxShadowFocusError,
        boxShadowActiveError,
        boxShadowHoverError,
        borderError,
        borderFocusError,
        borderHoverError,
        borderActiveError,
        clearColor,
        clearColorHover,
        clearColorPressed,
        clearSize,
        arrowSize: arrowSize2,
        [createKey("height", size2)]: height,
        [createKey("fontSize", size2)]: fontSize2
      } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-border": border,
        "--n-border-active": borderActive,
        "--n-border-focus": borderFocus,
        "--n-border-hover": borderHover,
        "--n-border-radius": borderRadius,
        "--n-box-shadow-active": boxShadowActive,
        "--n-box-shadow-focus": boxShadowFocus,
        "--n-box-shadow-hover": boxShadowHover,
        "--n-caret-color": caretColor,
        "--n-color": color,
        "--n-color-active": colorActive,
        "--n-color-disabled": colorDisabled,
        "--n-font-size": fontSize2,
        "--n-height": height,
        "--n-padding-single": paddingSingle,
        "--n-padding-multiple": paddingMultiple,
        "--n-placeholder-color": placeholderColor,
        "--n-placeholder-color-disabled": placeholderColorDisabled,
        "--n-text-color": textColor,
        "--n-text-color-disabled": textColorDisabled,
        "--n-arrow-color": arrowColor,
        "--n-arrow-color-disabled": arrowColorDisabled,
        "--n-loading-color": loadingColor,
        "--n-color-active-warning": colorActiveWarning,
        "--n-box-shadow-focus-warning": boxShadowFocusWarning,
        "--n-box-shadow-active-warning": boxShadowActiveWarning,
        "--n-box-shadow-hover-warning": boxShadowHoverWarning,
        "--n-border-warning": borderWarning,
        "--n-border-focus-warning": borderFocusWarning,
        "--n-border-hover-warning": borderHoverWarning,
        "--n-border-active-warning": borderActiveWarning,
        "--n-color-active-error": colorActiveError,
        "--n-box-shadow-focus-error": boxShadowFocusError,
        "--n-box-shadow-active-error": boxShadowActiveError,
        "--n-box-shadow-hover-error": boxShadowHoverError,
        "--n-border-error": borderError,
        "--n-border-focus-error": borderFocusError,
        "--n-border-hover-error": borderHoverError,
        "--n-border-active-error": borderActiveError,
        "--n-clear-size": clearSize,
        "--n-clear-color": clearColor,
        "--n-clear-color-hover": clearColorHover,
        "--n-clear-color-pressed": clearColorPressed,
        "--n-arrow-size": arrowSize2
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("internal-selection", computed(() => {
      return props.size[0];
    }), cssVarsRef, props) : void 0;
    return {
      mergedTheme: themeRef,
      mergedClearable: mergedClearableRef,
      patternInputFocused: patternInputFocusedRef,
      filterablePlaceholder: filterablePlaceholderRef,
      label: labelRef,
      selected: selectedRef,
      showTagsPanel: showTagsPopoverRef,
      isComposing: isComposingRef2,
      counterRef,
      counterWrapperRef,
      patternInputMirrorRef,
      patternInputRef,
      selfRef,
      multipleElRef,
      singleElRef,
      patternInputWrapperRef,
      overflowRef,
      inputTagElRef,
      handleMouseDown,
      handleFocusin,
      handleClear,
      handleMouseEnter,
      handleMouseLeave,
      handleDeleteOption,
      handlePatternKeyDown,
      handlePatternInputInput,
      handlePatternInputBlur,
      handlePatternInputFocus,
      handleMouseEnterCounter,
      handleMouseLeaveCounter,
      handleFocusout,
      handleCompositionEnd,
      handleCompositionStart,
      onPopoverUpdateShow,
      focus,
      focusInput,
      blur,
      blurInput,
      updateCounter,
      getCounter,
      getTail,
      renderLabel: props.renderLabel,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const { status, multiple, size: size2, disabled, filterable, maxTagCount, bordered, clsPrefix, onRender, renderTag, renderLabel } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    const maxTagCountResponsive = maxTagCount === "responsive";
    const maxTagCountNumeric = typeof maxTagCount === "number";
    const useMaxTagCount = maxTagCountResponsive || maxTagCountNumeric;
    const suffix2 = h$1(Wrapper, null, {
      default: () => h$1(NBaseSuffix, { clsPrefix, loading: this.loading, showArrow: this.showArrow, showClear: this.mergedClearable && this.selected, onClear: this.handleClear }, {
        default: () => {
          var _a2, _b2;
          return (_b2 = (_a2 = this.$slots).arrow) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
        }
      })
    });
    let body;
    if (multiple) {
      const { labelField } = this;
      const createTag = (option) => h$1("div", { class: `${clsPrefix}-base-selection-tag-wrapper`, key: option.value }, renderTag ? renderTag({
        option,
        handleClose: () => {
          this.handleDeleteOption(option);
        }
      }) : h$1(NTag, { size: size2, closable: !option.disabled, disabled, onClose: () => {
        this.handleDeleteOption(option);
      }, internalCloseIsButtonTag: false, internalCloseFocusable: false }, {
        default: () => renderLabel ? renderLabel(option, true) : render$3U(option[labelField], option, true)
      }));
      const createOriginalTagNodes = () => (maxTagCountNumeric ? this.selectedOptions.slice(0, maxTagCount) : this.selectedOptions).map(createTag);
      const input = filterable ? h$1("div", { class: `${clsPrefix}-base-selection-input-tag`, ref: "inputTagElRef", key: "__input-tag__" }, h$1("input", Object.assign({}, this.inputProps, { ref: "patternInputRef", tabindex: -1, disabled, value: this.pattern, autofocus: this.autofocus, class: `${clsPrefix}-base-selection-input-tag__input`, onBlur: this.handlePatternInputBlur, onFocus: this.handlePatternInputFocus, onKeydown: this.handlePatternKeyDown, onInput: this.handlePatternInputInput, onCompositionstart: this.handleCompositionStart, onCompositionend: this.handleCompositionEnd })), h$1("span", { ref: "patternInputMirrorRef", class: `${clsPrefix}-base-selection-input-tag__mirror` }, this.pattern)) : null;
      const renderCounter = maxTagCountResponsive ? () => h$1("div", { class: `${clsPrefix}-base-selection-tag-wrapper`, ref: "counterWrapperRef" }, h$1(NTag, { size: size2, ref: "counterRef", onMouseenter: this.handleMouseEnterCounter, onMouseleave: this.handleMouseLeaveCounter, disabled })) : void 0;
      let counter;
      if (maxTagCountNumeric) {
        const rest = this.selectedOptions.length - maxTagCount;
        if (rest > 0) {
          counter = h$1("div", { class: `${clsPrefix}-base-selection-tag-wrapper`, key: "__counter__" }, h$1(NTag, { size: size2, ref: "counterRef", onMouseenter: this.handleMouseEnterCounter, disabled }, {
            default: () => `+${rest}`
          }));
        }
      }
      const tags2 = maxTagCountResponsive ? filterable ? h$1(VOverflow, { ref: "overflowRef", updateCounter: this.updateCounter, getCounter: this.getCounter, getTail: this.getTail, style: {
        width: "100%",
        display: "flex",
        overflow: "hidden"
      } }, {
        default: createOriginalTagNodes,
        counter: renderCounter,
        tail: () => input
      }) : h$1(VOverflow, { ref: "overflowRef", updateCounter: this.updateCounter, getCounter: this.getCounter, style: {
        width: "100%",
        display: "flex",
        overflow: "hidden"
      } }, {
        default: createOriginalTagNodes,
        counter: renderCounter
      }) : maxTagCountNumeric ? createOriginalTagNodes().concat(counter) : createOriginalTagNodes();
      const renderPopover = useMaxTagCount ? () => h$1("div", { class: `${clsPrefix}-base-selection-popover` }, maxTagCountResponsive ? createOriginalTagNodes() : this.selectedOptions.map(createTag)) : void 0;
      const popoverProps2 = useMaxTagCount ? {
        show: this.showTagsPanel,
        trigger: "hover",
        overlap: true,
        placement: "top",
        width: "trigger",
        onUpdateShow: this.onPopoverUpdateShow,
        theme: this.mergedTheme.peers.Popover,
        themeOverrides: this.mergedTheme.peerOverrides.Popover
      } : null;
      const showPlaceholder = this.selected ? false : this.active ? !this.pattern && !this.isComposing : true;
      const placeholder = showPlaceholder ? h$1("div", { class: `${clsPrefix}-base-selection-placeholder ${clsPrefix}-base-selection-overlay` }, h$1("div", { class: `${clsPrefix}-base-selection-placeholder__inner` }, this.placeholder)) : null;
      const popoverTrigger = filterable ? h$1("div", { ref: "patternInputWrapperRef", class: `${clsPrefix}-base-selection-tags` }, tags2, maxTagCountResponsive ? null : input, suffix2) : h$1("div", { ref: "multipleElRef", class: `${clsPrefix}-base-selection-tags`, tabindex: disabled ? void 0 : 0 }, tags2, suffix2);
      body = h$1(Fragment, null, useMaxTagCount ? h$1(NPopover, Object.assign({}, popoverProps2, { scrollable: true, style: "max-height: calc(var(--v-target-height) * 6.6);" }), {
        trigger: () => popoverTrigger,
        default: renderPopover
      }) : popoverTrigger, placeholder);
    } else {
      if (filterable) {
        const hasInput = this.pattern || this.isComposing;
        const showPlaceholder = this.active ? !hasInput : !this.selected;
        const showSelectedLabel = this.active ? false : this.selected;
        body = h$1("div", { ref: "patternInputWrapperRef", class: `${clsPrefix}-base-selection-label` }, h$1("input", Object.assign({}, this.inputProps, { ref: "patternInputRef", class: `${clsPrefix}-base-selection-input`, value: this.active ? this.pattern : "", placeholder: "", readonly: disabled, disabled, tabindex: -1, autofocus: this.autofocus, onFocus: this.handlePatternInputFocus, onBlur: this.handlePatternInputBlur, onInput: this.handlePatternInputInput, onCompositionstart: this.handleCompositionStart, onCompositionend: this.handleCompositionEnd })), showSelectedLabel ? h$1("div", { class: `${clsPrefix}-base-selection-label__render-label ${clsPrefix}-base-selection-overlay`, key: "input" }, h$1("div", { class: `${clsPrefix}-base-selection-overlay__wrapper` }, renderTag ? renderTag({
          option: this.selectedOption,
          handleClose: () => {
          }
        }) : renderLabel ? renderLabel(this.selectedOption, true) : render$3U(this.label, this.selectedOption, true))) : null, showPlaceholder ? h$1("div", { class: `${clsPrefix}-base-selection-placeholder ${clsPrefix}-base-selection-overlay`, key: "placeholder" }, h$1("div", { class: `${clsPrefix}-base-selection-overlay__wrapper` }, this.filterablePlaceholder)) : null, suffix2);
      } else {
        body = h$1("div", { ref: "singleElRef", class: `${clsPrefix}-base-selection-label`, tabindex: this.disabled ? void 0 : 0 }, this.label !== void 0 ? h$1("div", { class: `${clsPrefix}-base-selection-input`, title: getTitleAttribute(this.label), key: "input" }, h$1("div", { class: `${clsPrefix}-base-selection-input__content` }, renderTag ? renderTag({
          option: this.selectedOption,
          handleClose: () => {
          }
        }) : renderLabel ? renderLabel(this.selectedOption, true) : render$3U(this.label, this.selectedOption, true))) : h$1("div", { class: `${clsPrefix}-base-selection-placeholder ${clsPrefix}-base-selection-overlay`, key: "placeholder" }, h$1("div", { class: `${clsPrefix}-base-selection-placeholder__inner` }, this.placeholder)), suffix2);
      }
    }
    return h$1("div", { ref: "selfRef", class: [
      `${clsPrefix}-base-selection`,
      this.themeClass,
      status && `${clsPrefix}-base-selection--${status}-status`,
      {
        [`${clsPrefix}-base-selection--active`]: this.active,
        [`${clsPrefix}-base-selection--selected`]: this.selected || this.active && this.pattern,
        [`${clsPrefix}-base-selection--disabled`]: this.disabled,
        [`${clsPrefix}-base-selection--multiple`]: this.multiple,
        [`${clsPrefix}-base-selection--focus`]: this.focused
      }
    ], style: this.cssVars, onClick: this.onClick, onMouseenter: this.handleMouseEnter, onMouseleave: this.handleMouseLeave, onKeydown: this.onKeydown, onFocusin: this.handleFocusin, onFocusout: this.handleFocusout, onMousedown: this.handleMouseDown }, body, bordered ? h$1("div", { class: `${clsPrefix}-base-selection__border` }) : null, bordered ? h$1("div", { class: `${clsPrefix}-base-selection__state-border` }) : null);
  }
});
var SlotMachineNumber = defineComponent({
  name: "SlotMachineNumber",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    },
    oldOriginalNumber: {
      type: Number,
      default: void 0
    },
    newOriginalNumber: {
      type: Number,
      default: void 0
    }
  },
  setup(props) {
    const numberRef = ref(null);
    const oldNumberRef = ref(props.value);
    const newNumberRef = ref(props.value);
    const scrollAnimationDirectionRef = ref("up");
    const activeRef = ref(false);
    const newNumberScrollAnimationClassRef = computed(() => {
      return activeRef.value ? `${props.clsPrefix}-base-slot-machine-current-number--${scrollAnimationDirectionRef.value}-scroll` : null;
    });
    const oldNumberScrollAnimationClassRef = computed(() => {
      return activeRef.value ? `${props.clsPrefix}-base-slot-machine-old-number--${scrollAnimationDirectionRef.value}-scroll` : null;
    });
    watch(toRef(props, "value"), (value2, oldValue) => {
      oldNumberRef.value = oldValue;
      newNumberRef.value = value2;
      void nextTick(scroll);
    });
    function scroll() {
      const newOriginalNumber = props.newOriginalNumber;
      const oldOriginalNumber = props.oldOriginalNumber;
      if (oldOriginalNumber === void 0 || newOriginalNumber === void 0) {
        return;
      }
      if (newOriginalNumber > oldOriginalNumber) {
        scrollByDir("up");
      } else if (oldOriginalNumber > newOriginalNumber) {
        scrollByDir("down");
      }
    }
    function scrollByDir(dir) {
      scrollAnimationDirectionRef.value = dir;
      activeRef.value = false;
      void nextTick(() => {
        var _a2;
        void ((_a2 = numberRef.value) === null || _a2 === void 0 ? void 0 : _a2.offsetWidth);
        activeRef.value = true;
      });
    }
    return () => {
      const { clsPrefix } = props;
      return h$1("span", { ref: numberRef, class: `${clsPrefix}-base-slot-machine-number` }, oldNumberRef.value !== null ? h$1("span", { class: [
        `${clsPrefix}-base-slot-machine-old-number ${clsPrefix}-base-slot-machine-old-number--top`,
        oldNumberScrollAnimationClassRef.value
      ] }, oldNumberRef.value) : null, h$1("span", { class: [
        `${clsPrefix}-base-slot-machine-current-number`,
        newNumberScrollAnimationClassRef.value
      ] }, h$1("span", { ref: "numberWrapper", class: [
        `${clsPrefix}-base-slot-machine-current-number__inner`,
        typeof props.value !== "number" && `${clsPrefix}-base-slot-machine-current-number__inner--not-number`
      ] }, newNumberRef.value)), oldNumberRef.value !== null ? h$1("span", { class: [
        `${clsPrefix}-base-slot-machine-old-number ${clsPrefix}-base-slot-machine-old-number--bottom`,
        oldNumberScrollAnimationClassRef.value
      ] }, oldNumberRef.value) : null);
    };
  }
});
const {
  cubicBezierEaseInOut: cubicBezierEaseInOut$2
} = commonVariables$e;
function fadeInWidthExpandTransition({
  duration = ".2s",
  delay = ".1s"
} = {}) {
  return [c$2("&.fade-in-width-expand-transition-leave-from, &.fade-in-width-expand-transition-enter-to", {
    opacity: 1
  }), c$2("&.fade-in-width-expand-transition-leave-to, &.fade-in-width-expand-transition-enter-from", `
 opacity: 0!important;
 margin-left: 0!important;
 margin-right: 0!important;
 `), c$2("&.fade-in-width-expand-transition-leave-active", `
 overflow: hidden;
 transition:
 opacity ${duration} ${cubicBezierEaseInOut$2},
 max-width ${duration} ${cubicBezierEaseInOut$2} ${delay},
 margin-left ${duration} ${cubicBezierEaseInOut$2} ${delay},
 margin-right ${duration} ${cubicBezierEaseInOut$2} ${delay};
 `), c$2("&.fade-in-width-expand-transition-enter-active", `
 overflow: hidden;
 transition:
 opacity ${duration} ${cubicBezierEaseInOut$2} ${delay},
 max-width ${duration} ${cubicBezierEaseInOut$2},
 margin-left ${duration} ${cubicBezierEaseInOut$2},
 margin-right ${duration} ${cubicBezierEaseInOut$2};
 `)];
}
const {
  cubicBezierEaseOut: cubicBezierEaseOut$5
} = commonVariables$e;
function fadeUpWidthExpandTransition({
  duration = ".2s"
} = {}) {
  return [c$2("&.fade-up-width-expand-transition-leave-active", {
    transition: `
 opacity ${duration} ${cubicBezierEaseOut$5},
 max-width ${duration} ${cubicBezierEaseOut$5},
 transform ${duration} ${cubicBezierEaseOut$5}
 `
  }), c$2("&.fade-up-width-expand-transition-enter-active", {
    transition: `
 opacity ${duration} ${cubicBezierEaseOut$5},
 max-width ${duration} ${cubicBezierEaseOut$5},
 transform ${duration} ${cubicBezierEaseOut$5}
 `
  }), c$2("&.fade-up-width-expand-transition-enter-to", {
    opacity: 1,
    transform: "translateX(0) translateY(0)"
  }), c$2("&.fade-up-width-expand-transition-enter-from", {
    maxWidth: "0 !important",
    opacity: 0,
    transform: "translateY(60%)"
  }), c$2("&.fade-up-width-expand-transition-leave-from", {
    opacity: 1,
    transform: "translateY(0)"
  }), c$2("&.fade-up-width-expand-transition-leave-to", {
    maxWidth: "0 !important",
    opacity: 0,
    transform: "translateY(60%)"
  })];
}
var style$J = c$2([c$2("@keyframes n-base-slot-machine-fade-up-in", `
 from {
 transform: translateY(60%);
 opacity: 0;
 }
 to {
 transform: translateY(0);
 opacity: 1;
 }
 `), c$2("@keyframes n-base-slot-machine-fade-down-in", `
 from {
 transform: translateY(-60%);
 opacity: 0;
 }
 to {
 transform: translateY(0);
 opacity: 1;
 }
 `), c$2("@keyframes n-base-slot-machine-fade-up-out", `
 from {
 transform: translateY(0%);
 opacity: 1;
 }
 to {
 transform: translateY(-60%);
 opacity: 0;
 }
 `), c$2("@keyframes n-base-slot-machine-fade-down-out", `
 from {
 transform: translateY(0%);
 opacity: 1;
 }
 to {
 transform: translateY(60%);
 opacity: 0;
 }
 `), cB$1("base-slot-machine", `
 overflow: hidden;
 white-space: nowrap;
 display: inline-block;
 height: 18px;
 line-height: 18px;
 `, [cB$1("base-slot-machine-number", `
 display: inline-block;
 position: relative;
 height: 18px;
 width: .6em;
 max-width: .6em;
 `, [
  fadeUpWidthExpandTransition({
    duration: ".2s"
  }),
  fadeInWidthExpandTransition({
    duration: ".2s",
    delay: "0s"
  }),
  cB$1("base-slot-machine-old-number", `
 display: inline-block;
 opacity: 0;
 position: absolute;
 left: 0;
 right: 0;
 `, [cM("top", {
    transform: "translateY(-100%)"
  }), cM("bottom", {
    transform: "translateY(100%)"
  }), cM("down-scroll", {
    animation: "n-base-slot-machine-fade-down-out .2s cubic-bezier(0, 0, .2, 1)",
    animationIterationCount: 1
  }), cM("up-scroll", {
    animation: "n-base-slot-machine-fade-up-out .2s cubic-bezier(0, 0, .2, 1)",
    animationIterationCount: 1
  })]),
  cB$1("base-slot-machine-current-number", `
 display: inline-block;
 position: absolute;
 left: 0;
 top: 0;
 bottom: 0;
 right: 0;
 opacity: 1;
 transform: translateY(0);
 width: .6em;
 `, [cM("down-scroll", {
    animation: "n-base-slot-machine-fade-down-in .2s cubic-bezier(0, 0, .2, 1)",
    animationIterationCount: 1
  }), cM("up-scroll", {
    animation: "n-base-slot-machine-fade-up-in .2s cubic-bezier(0, 0, .2, 1)",
    animationIterationCount: 1
  }), cE$1("inner", `
 display: inline-block;
 position: absolute;
 right: 0;
 top: 0;
 width: .6em;
 `, [cM("not-number", `
 right: unset;
 left: 0;
 `)])])
])])]);
var NBaseSlotMachine = defineComponent({
  name: "BaseSlotMachine",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: Number,
      default: void 0
    },
    appeared: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    useStyle("-base-slot-machine", style$J, toRef(props, "clsPrefix"));
    const oldValueRef = ref();
    const newValueRef = ref();
    const numbersRef = computed(() => {
      if (typeof props.value === "string")
        return [];
      if (props.value < 1)
        return [0];
      const numbers = [];
      let value2 = props.value;
      if (props.max !== void 0) {
        value2 = Math.min(props.max, value2);
      }
      while (value2 >= 1) {
        numbers.push(value2 % 10);
        value2 /= 10;
        value2 = Math.floor(value2);
      }
      numbers.reverse();
      return numbers;
    });
    watch(toRef(props, "value"), (value2, oldValue) => {
      if (typeof value2 === "string") {
        newValueRef.value = void 0;
        oldValueRef.value = void 0;
      } else {
        if (typeof oldValue === "string") {
          newValueRef.value = value2;
          oldValueRef.value = void 0;
        } else {
          newValueRef.value = value2;
          oldValueRef.value = oldValue;
        }
      }
    });
    return () => {
      const { value: value2, clsPrefix } = props;
      return typeof value2 === "number" ? h$1("span", { class: `${clsPrefix}-base-slot-machine` }, h$1(TransitionGroup, { name: "fade-up-width-expand-transition", tag: "span" }, {
        default: () => numbersRef.value.map((number4, i2) => h$1(SlotMachineNumber, { clsPrefix, key: numbersRef.value.length - i2 - 1, oldOriginalNumber: oldValueRef.value, newOriginalNumber: newValueRef.value, value: number4 }))
      }), h$1(NFadeInExpandTransition, { key: "+", width: true }, {
        default: () => props.max !== void 0 && props.max < value2 ? h$1(SlotMachineNumber, { clsPrefix, value: "+" }) : null
      })) : h$1("span", { class: `${clsPrefix}-base-slot-machine` }, value2);
    };
  }
});
var commonVars$7 = {
  iconMargin: "11px 8px 0 12px",
  iconMarginRtl: "11px 12px 0 8px",
  iconSize: "24px",
  closeIconSize: "16px",
  closeSize: "20px",
  closeMargin: "13px 14px 0 0",
  closeMarginRtl: "13px 0 0 14px",
  padding: "13px"
};
const self$E = (vars) => {
  const { lineHeight: lineHeight2, borderRadius, fontWeightStrong, baseColor, dividerColor, actionColor, textColor1, textColor2, closeColorHover, closeColorPressed, closeIconColor, closeIconColorHover, closeIconColorPressed, infoColor, successColor, warningColor, errorColor, fontSize: fontSize2 } = vars;
  return Object.assign(Object.assign({}, commonVars$7), {
    fontSize: fontSize2,
    lineHeight: lineHeight2,
    titleFontWeight: fontWeightStrong,
    borderRadius,
    border: `1px solid ${dividerColor}`,
    color: actionColor,
    titleTextColor: textColor1,
    iconColor: textColor2,
    contentTextColor: textColor2,
    closeBorderRadius: borderRadius,
    closeColorHover,
    closeColorPressed,
    closeIconColor,
    closeIconColorHover,
    closeIconColorPressed,
    borderInfo: `1px solid ${composite(baseColor, changeColor(infoColor, { alpha: 0.25 }))}`,
    colorInfo: composite(baseColor, changeColor(infoColor, { alpha: 0.08 })),
    titleTextColorInfo: textColor1,
    iconColorInfo: infoColor,
    contentTextColorInfo: textColor2,
    closeColorHoverInfo: closeColorHover,
    closeColorPressedInfo: closeColorPressed,
    closeIconColorInfo: closeIconColor,
    closeIconColorHoverInfo: closeIconColorHover,
    closeIconColorPressedInfo: closeIconColorPressed,
    borderSuccess: `1px solid ${composite(baseColor, changeColor(successColor, { alpha: 0.25 }))}`,
    colorSuccess: composite(baseColor, changeColor(successColor, { alpha: 0.08 })),
    titleTextColorSuccess: textColor1,
    iconColorSuccess: successColor,
    contentTextColorSuccess: textColor2,
    closeColorHoverSuccess: closeColorHover,
    closeColorPressedSuccess: closeColorPressed,
    closeIconColorSuccess: closeIconColor,
    closeIconColorHoverSuccess: closeIconColorHover,
    closeIconColorPressedSuccess: closeIconColorPressed,
    borderWarning: `1px solid ${composite(baseColor, changeColor(warningColor, { alpha: 0.33 }))}`,
    colorWarning: composite(baseColor, changeColor(warningColor, { alpha: 0.08 })),
    titleTextColorWarning: textColor1,
    iconColorWarning: warningColor,
    contentTextColorWarning: textColor2,
    closeColorHoverWarning: closeColorHover,
    closeColorPressedWarning: closeColorPressed,
    closeIconColorWarning: closeIconColor,
    closeIconColorHoverWarning: closeIconColorHover,
    closeIconColorPressedWarning: closeIconColorPressed,
    borderError: `1px solid ${composite(baseColor, changeColor(errorColor, { alpha: 0.25 }))}`,
    colorError: composite(baseColor, changeColor(errorColor, { alpha: 0.08 })),
    titleTextColorError: textColor1,
    iconColorError: errorColor,
    contentTextColorError: textColor2,
    closeColorHoverError: closeColorHover,
    closeColorPressedError: closeColorPressed,
    closeIconColorError: closeIconColor,
    closeIconColorHoverError: closeIconColorHover,
    closeIconColorPressedError: closeIconColorPressed
  });
};
const alertLight = {
  name: "Alert",
  common: commonLight,
  self: self$E
};
var alertLight$1 = alertLight;
const {
  cubicBezierEaseInOut: cubicBezierEaseInOut$1,
  cubicBezierEaseOut: cubicBezierEaseOut$4,
  cubicBezierEaseIn: cubicBezierEaseIn$4
} = commonVariables$e;
function fadeInHeightExpandTransition({
  overflow = "hidden",
  duration = ".3s",
  originalTransition = "",
  leavingDelay = "0s",
  foldPadding = false,
  enterToProps = void 0,
  leaveToProps = void 0,
  reverse = false
} = {}) {
  const enterClass = reverse ? "leave" : "enter";
  const leaveClass = reverse ? "enter" : "leave";
  return [c$2(`&.fade-in-height-expand-transition-${leaveClass}-from,
 &.fade-in-height-expand-transition-${enterClass}-to`, Object.assign(Object.assign({}, enterToProps), {
    opacity: 1
  })), c$2(`&.fade-in-height-expand-transition-${leaveClass}-to,
 &.fade-in-height-expand-transition-${enterClass}-from`, Object.assign(Object.assign({}, leaveToProps), {
    opacity: 0,
    marginTop: "0 !important",
    marginBottom: "0 !important",
    paddingTop: foldPadding ? "0 !important" : void 0,
    paddingBottom: foldPadding ? "0 !important" : void 0
  })), c$2(`&.fade-in-height-expand-transition-${leaveClass}-active`, `
 overflow: ${overflow};
 transition:
 max-height ${duration} ${cubicBezierEaseInOut$1} ${leavingDelay},
 opacity ${duration} ${cubicBezierEaseOut$4} ${leavingDelay},
 margin-top ${duration} ${cubicBezierEaseInOut$1} ${leavingDelay},
 margin-bottom ${duration} ${cubicBezierEaseInOut$1} ${leavingDelay},
 padding-top ${duration} ${cubicBezierEaseInOut$1} ${leavingDelay},
 padding-bottom ${duration} ${cubicBezierEaseInOut$1} ${leavingDelay}
 ${originalTransition ? "," + originalTransition : ""}
 `), c$2(`&.fade-in-height-expand-transition-${enterClass}-active`, `
 overflow: ${overflow};
 transition:
 max-height ${duration} ${cubicBezierEaseInOut$1},
 opacity ${duration} ${cubicBezierEaseIn$4},
 margin-top ${duration} ${cubicBezierEaseInOut$1},
 margin-bottom ${duration} ${cubicBezierEaseInOut$1},
 padding-top ${duration} ${cubicBezierEaseInOut$1},
 padding-bottom ${duration} ${cubicBezierEaseInOut$1}
 ${originalTransition ? "," + originalTransition : ""}
 `)];
}
var style$I = cB$1("alert", `
 line-height: var(--n-line-height);
 border-radius: var(--n-border-radius);
 position: relative;
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-color);
 text-align: start;
 word-break: break-word;
`, [cE$1("border", `
 border-radius: inherit;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 transition: border-color .3s var(--n-bezier);
 border: var(--n-border);
 pointer-events: none;
 `), cM("closable", [cB$1("alert-body", [cE$1("title", `
 padding-right: 24px;
 `)])]), cE$1("icon", {
  color: "var(--n-icon-color)"
}), cB$1("alert-body", {
  padding: "var(--n-padding)"
}, [cE$1("title", {
  color: "var(--n-title-text-color)"
}), cE$1("content", {
  color: "var(--n-content-text-color)"
})]), fadeInHeightExpandTransition({
  originalTransition: "transform .3s var(--n-bezier)",
  enterToProps: {
    transform: "scale(1)"
  },
  leaveToProps: {
    transform: "scale(0.9)"
  }
}), cE$1("icon", `
 position: absolute;
 left: 0;
 top: 0;
 align-items: center;
 justify-content: center;
 display: flex;
 width: var(--n-icon-size);
 height: var(--n-icon-size);
 font-size: var(--n-icon-size);
 margin: var(--n-icon-margin);
 `), cE$1("close", `
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 position: absolute;
 right: 0;
 top: 0;
 margin: var(--n-close-margin);
 `), cM("show-icon", [cB$1("alert-body", {
  paddingLeft: "calc(var(--n-icon-margin-left) + var(--n-icon-size) + var(--n-icon-margin-right))"
})]), cB$1("alert-body", `
 border-radius: var(--n-border-radius);
 transition: border-color .3s var(--n-bezier);
 `, [cE$1("title", `
 transition: color .3s var(--n-bezier);
 font-size: 16px;
 line-height: 19px;
 font-weight: var(--n-title-font-weight);
 `, [c$2("& +", [cE$1("content", {
  marginTop: "9px"
})])]), cE$1("content", {
  transition: "color .3s var(--n-bezier)",
  fontSize: "var(--n-font-size)"
})]), cE$1("icon", {
  transition: "color .3s var(--n-bezier)"
})]);
const alertProps = Object.assign(Object.assign({}, useTheme.props), {
  title: String,
  showIcon: {
    type: Boolean,
    default: true
  },
  type: {
    type: String,
    default: "default"
  },
  bordered: {
    type: Boolean,
    default: true
  },
  closable: Boolean,
  onClose: Function,
  onAfterLeave: Function,
  onAfterHide: Function
});
var NAlert = defineComponent({
  name: "Alert",
  inheritAttrs: false,
  props: alertProps,
  setup(props) {
    const { mergedClsPrefixRef, mergedBorderedRef, inlineThemeDisabled, mergedRtlRef } = useConfig(props);
    const themeRef = useTheme("Alert", "-alert", style$I, alertLight$1, props, mergedClsPrefixRef);
    const rtlEnabledRef = useRtl("Alert", mergedRtlRef, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: self2 } = themeRef.value;
      const { fontSize: fontSize2, borderRadius, titleFontWeight, lineHeight: lineHeight2, iconSize, iconMargin, iconMarginRtl, closeIconSize, closeBorderRadius, closeSize, closeMargin, closeMarginRtl, padding } = self2;
      const { type: type4 } = props;
      const { left, right } = getMargin(iconMargin);
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-color": self2[createKey("color", type4)],
        "--n-close-icon-size": closeIconSize,
        "--n-close-border-radius": closeBorderRadius,
        "--n-close-color-hover": self2[createKey("closeColorHover", type4)],
        "--n-close-color-pressed": self2[createKey("closeColorPressed", type4)],
        "--n-close-icon-color": self2[createKey("closeIconColor", type4)],
        "--n-close-icon-color-hover": self2[createKey("closeIconColorHover", type4)],
        "--n-close-icon-color-pressed": self2[createKey("closeIconColorPressed", type4)],
        "--n-icon-color": self2[createKey("iconColor", type4)],
        "--n-border": self2[createKey("border", type4)],
        "--n-title-text-color": self2[createKey("titleTextColor", type4)],
        "--n-content-text-color": self2[createKey("contentTextColor", type4)],
        "--n-line-height": lineHeight2,
        "--n-border-radius": borderRadius,
        "--n-font-size": fontSize2,
        "--n-title-font-weight": titleFontWeight,
        "--n-icon-size": iconSize,
        "--n-icon-margin": iconMargin,
        "--n-icon-margin-rtl": iconMarginRtl,
        "--n-close-size": closeSize,
        "--n-close-margin": closeMargin,
        "--n-close-margin-rtl": closeMarginRtl,
        "--n-padding": padding,
        "--n-icon-margin-left": left,
        "--n-icon-margin-right": right
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("alert", computed(() => {
      return props.type[0];
    }), cssVarsRef, props) : void 0;
    const visibleRef = ref(true);
    const doAfterLeave = () => {
      const {
        onAfterLeave,
        onAfterHide
      } = props;
      if (onAfterLeave)
        onAfterLeave();
      if (onAfterHide)
        onAfterHide();
    };
    const handleCloseClick = () => {
      var _a2;
      void Promise.resolve((_a2 = props.onClose) === null || _a2 === void 0 ? void 0 : _a2.call(props)).then((result2) => {
        if (result2 === false)
          return;
        visibleRef.value = false;
      });
    };
    const handleAfterLeave = () => {
      doAfterLeave();
    };
    return {
      rtlEnabled: rtlEnabledRef,
      mergedClsPrefix: mergedClsPrefixRef,
      mergedBordered: mergedBorderedRef,
      visible: visibleRef,
      handleCloseClick,
      handleAfterLeave,
      mergedTheme: themeRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    var _a2;
    (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
    return h$1(NFadeInExpandTransition, { onAfterLeave: this.handleAfterLeave }, {
      default: () => {
        const { mergedClsPrefix, $slots } = this;
        const attrs = {
          class: [
            `${mergedClsPrefix}-alert`,
            this.themeClass,
            this.closable && `${mergedClsPrefix}-alert--closable`,
            this.showIcon && `${mergedClsPrefix}-alert--show-icon`,
            this.rtlEnabled && `${mergedClsPrefix}-alert--rtl`
          ],
          style: this.cssVars,
          role: "alert"
        };
        return this.visible ? h$1("div", Object.assign({}, mergeProps(this.$attrs, attrs)), this.closable && h$1(NBaseClose, { clsPrefix: mergedClsPrefix, class: `${mergedClsPrefix}-alert__close`, onClick: this.handleCloseClick }), this.bordered && h$1("div", { class: `${mergedClsPrefix}-alert__border` }), this.showIcon && h$1("div", { class: `${mergedClsPrefix}-alert__icon`, "aria-hidden": "true" }, resolveSlot($slots.icon, () => [
          h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, {
            default: () => {
              switch (this.type) {
                case "success":
                  return h$1(SuccessIcon, null);
                case "info":
                  return h$1(InfoIcon, null);
                case "warning":
                  return h$1(WarningIcon, null);
                case "error":
                  return h$1(ErrorIcon, null);
                default:
                  return null;
              }
            }
          })
        ])), h$1("div", { class: [
          `${mergedClsPrefix}-alert-body`,
          this.mergedBordered && `${mergedClsPrefix}-alert-body--bordered`
        ] }, resolveWrappedSlot($slots.header, (children) => {
          const mergedChildren = children || this.title;
          return mergedChildren ? h$1("div", { class: `${mergedClsPrefix}-alert-body__title` }, mergedChildren) : null;
        }), $slots.default && h$1("div", { class: `${mergedClsPrefix}-alert-body__content` }, $slots))) : null;
      }
    });
  }
});
function getIsGroup(option) {
  return option.type === "group";
}
function getIgnored(option) {
  return option.type === "ignored";
}
function patternMatched(pattern4, value2) {
  try {
    return !!(1 + value2.toString().toLowerCase().indexOf(pattern4.trim().toLowerCase()));
  } catch (err) {
    return false;
  }
}
function createTmOptions(valueField, childrenField) {
  const options = {
    getIsGroup,
    getIgnored,
    getKey(option) {
      if (getIsGroup(option)) {
        return option.name || option.key || "key-required";
      }
      return option[valueField];
    },
    getChildren(option) {
      return option[childrenField];
    }
  };
  return options;
}
function filterOptions(originalOpts, filter, pattern4, childrenField) {
  if (!filter)
    return originalOpts;
  function traverse(options) {
    if (!Array.isArray(options))
      return [];
    const filteredOptions = [];
    for (const option of options) {
      if (getIsGroup(option)) {
        const children = traverse(option[childrenField]);
        if (children.length) {
          filteredOptions.push(Object.assign({}, option, {
            [childrenField]: children
          }));
        }
      } else if (getIgnored(option)) {
        continue;
      } else if (filter(pattern4, option)) {
        filteredOptions.push(option);
      }
    }
    return filteredOptions;
  }
  return traverse(originalOpts);
}
function createValOptMap(options, valueField, childrenField) {
  const valOptMap = new Map();
  options.forEach((option) => {
    if (getIsGroup(option)) {
      option[childrenField].forEach((selectGroupOption) => {
        valOptMap.set(selectGroupOption[valueField], selectGroupOption);
      });
    } else {
      valOptMap.set(option[valueField], option);
    }
  });
  return valOptMap;
}
const isChrome = isBrowser$2 && "chrome" in window;
isBrowser$2 && navigator.userAgent.includes("Firefox");
const isSafari = isBrowser$2 && navigator.userAgent.includes("Safari") && !isChrome;
var commonVariables$a = {
  paddingTiny: "0 8px",
  paddingSmall: "0 10px",
  paddingMedium: "0 12px",
  paddingLarge: "0 14px",
  clearSize: "16px"
};
const self$D = (vars) => {
  const { textColor2, textColor3, textColorDisabled, primaryColor, primaryColorHover, inputColor, inputColorDisabled, borderColor, warningColor, warningColorHover, errorColor, errorColorHover, borderRadius, lineHeight: lineHeight2, fontSizeTiny, fontSizeSmall, fontSizeMedium, fontSizeLarge, heightTiny, heightSmall, heightMedium, heightLarge, actionColor, clearColor, clearColorHover, clearColorPressed, placeholderColor, placeholderColorDisabled, iconColor, iconColorDisabled, iconColorHover, iconColorPressed } = vars;
  return Object.assign(Object.assign({}, commonVariables$a), {
    countTextColorDisabled: textColorDisabled,
    countTextColor: textColor3,
    heightTiny,
    heightSmall,
    heightMedium,
    heightLarge,
    fontSizeTiny,
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    lineHeight: lineHeight2,
    lineHeightTextarea: lineHeight2,
    borderRadius,
    iconSize: "16px",
    groupLabelColor: actionColor,
    groupLabelTextColor: textColor2,
    textColor: textColor2,
    textColorDisabled,
    textDecorationColor: textColor2,
    caretColor: primaryColor,
    placeholderColor,
    placeholderColorDisabled,
    color: inputColor,
    colorDisabled: inputColorDisabled,
    colorFocus: inputColor,
    groupLabelBorder: `1px solid ${borderColor}`,
    border: `1px solid ${borderColor}`,
    borderHover: `1px solid ${primaryColorHover}`,
    borderDisabled: `1px solid ${borderColor}`,
    borderFocus: `1px solid ${primaryColorHover}`,
    boxShadowFocus: `0 0 0 2px ${changeColor(primaryColor, { alpha: 0.2 })}`,
    loadingColor: primaryColor,
    loadingColorWarning: warningColor,
    borderWarning: `1px solid ${warningColor}`,
    borderHoverWarning: `1px solid ${warningColorHover}`,
    colorFocusWarning: inputColor,
    borderFocusWarning: `1px solid ${warningColorHover}`,
    boxShadowFocusWarning: `0 0 0 2px ${changeColor(warningColor, {
      alpha: 0.2
    })}`,
    caretColorWarning: warningColor,
    loadingColorError: errorColor,
    borderError: `1px solid ${errorColor}`,
    borderHoverError: `1px solid ${errorColorHover}`,
    colorFocusError: inputColor,
    borderFocusError: `1px solid ${errorColorHover}`,
    boxShadowFocusError: `0 0 0 2px ${changeColor(errorColor, {
      alpha: 0.2
    })}`,
    caretColorError: errorColor,
    clearColor,
    clearColorHover,
    clearColorPressed,
    iconColor,
    iconColorDisabled,
    iconColorHover,
    iconColorPressed,
    suffixTextColor: textColor2
  });
};
const inputLight = {
  name: "Input",
  common: commonLight,
  self: self$D
};
var inputLight$1 = inputLight;
const inputInjectionKey = createInjectionKey("n-input");
function len(s2) {
  let count = 0;
  for (const _2 of s2) {
    count++;
  }
  return count;
}
function isEmptyInputValue(value2) {
  return value2 === "" || value2 == null;
}
function useCursor(inputElRef) {
  const selectionRef = ref(null);
  function recordCursor() {
    const { value: input } = inputElRef;
    if (!(input === null || input === void 0 ? void 0 : input.focus)) {
      reset();
      return;
    }
    const { selectionStart, selectionEnd, value: value2 } = input;
    if (selectionStart == null || selectionEnd == null) {
      reset();
      return;
    }
    selectionRef.value = {
      start: selectionStart,
      end: selectionEnd,
      beforeText: value2.slice(0, selectionStart),
      afterText: value2.slice(selectionEnd)
    };
  }
  function restoreCursor() {
    var _a2;
    const { value: selection } = selectionRef;
    const { value: inputEl } = inputElRef;
    if (!selection || !inputEl) {
      return;
    }
    const { value: value2 } = inputEl;
    const { start, beforeText, afterText } = selection;
    let startPos = value2.length;
    if (value2.endsWith(afterText)) {
      startPos = value2.length - afterText.length;
    } else if (value2.startsWith(beforeText)) {
      startPos = beforeText.length;
    } else {
      const beforeLastChar = beforeText[start - 1];
      const newIndex = value2.indexOf(beforeLastChar, start - 1);
      if (newIndex !== -1) {
        startPos = newIndex + 1;
      }
    }
    (_a2 = inputEl.setSelectionRange) === null || _a2 === void 0 ? void 0 : _a2.call(inputEl, startPos, startPos);
  }
  function reset() {
    selectionRef.value = null;
  }
  watch(inputElRef, reset);
  return {
    recordCursor,
    restoreCursor
  };
}
var WordCount = defineComponent({
  name: "InputWordCount",
  setup(_2, { slots }) {
    const { mergedValueRef, maxlengthRef, mergedClsPrefixRef, countGraphemesRef } = inject(inputInjectionKey);
    const wordCountRef = computed(() => {
      const { value: mergedValue } = mergedValueRef;
      if (mergedValue === null || Array.isArray(mergedValue))
        return 0;
      return (countGraphemesRef.value || len)(mergedValue);
    });
    return () => {
      const { value: maxlength } = maxlengthRef;
      const { value: mergedValue } = mergedValueRef;
      return h$1("span", { class: `${mergedClsPrefixRef.value}-input-word-count` }, resolveSlotWithProps(slots.default, {
        value: mergedValue === null || Array.isArray(mergedValue) ? "" : mergedValue
      }, () => [
        maxlength === void 0 ? wordCountRef.value : `${wordCountRef.value} / ${maxlength}`
      ]));
    };
  }
});
var style$H = cB$1("input", `
 max-width: 100%;
 cursor: text;
 line-height: 1.5;
 z-index: auto;
 outline: none;
 box-sizing: border-box;
 position: relative;
 display: inline-flex;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 transition: background-color .3s var(--n-bezier);
 font-size: var(--n-font-size);
 --n-padding-vertical: calc((var(--n-height) - 1.5 * var(--n-font-size)) / 2);
`, [
  cE$1("input, textarea", `
 overflow: hidden;
 flex-grow: 1;
 position: relative;
 `),
  cE$1("input-el, textarea-el, input-mirror, textarea-mirror, separator, placeholder", `
 box-sizing: border-box;
 font-size: inherit;
 line-height: 1.5;
 font-family: inherit;
 border: none;
 outline: none;
 background-color: #0000;
 text-align: inherit;
 transition:
 -webkit-text-fill-color .3s var(--n-bezier),
 caret-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier);
 `),
  cE$1("input-el, textarea-el", `
 -webkit-appearance: none;
 scrollbar-width: none;
 width: 100%;
 min-width: 0;
 text-decoration-color: var(--n-text-decoration-color);
 color: var(--n-text-color);
 caret-color: var(--n-caret-color);
 background-color: transparent;
 `, [c$2("&::-webkit-scrollbar, &::-webkit-scrollbar-track-piece, &::-webkit-scrollbar-thumb", `
 width: 0;
 height: 0;
 display: none;
 `), c$2("&::placeholder", `
 color: #0000;
 -webkit-text-fill-color: transparent !important;
 `), c$2("&:-webkit-autofill ~", [cE$1("placeholder", "display: none;")])]),
  cM("round", [cNotM("textarea", "border-radius: calc(var(--n-height) / 2);")]),
  cE$1("placeholder", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 overflow: hidden;
 color: var(--n-placeholder-color);
 `, [c$2("span", `
 width: 100%;
 display: inline-block;
 `)]),
  cM("textarea", [cE$1("placeholder", "overflow: visible;")]),
  cNotM("autosize", "width: 100%;"),
  cM("autosize", [cE$1("textarea-el, input-el", `
 position: absolute;
 top: 0;
 left: 0;
 height: 100%;
 `)]),
  cB$1("input-wrapper", `
 overflow: hidden;
 display: inline-flex;
 flex-grow: 1;
 position: relative;
 padding-left: var(--n-padding-left);
 padding-right: var(--n-padding-right);
 `),
  cE$1("input-mirror", `
 padding: 0;
 height: var(--n-height);
 line-height: var(--n-height);
 overflow: hidden;
 visibility: hidden;
 position: static;
 white-space: pre;
 pointer-events: none;
 `),
  cE$1("input-el", `
 padding: 0;
 height: var(--n-height);
 line-height: var(--n-height);
 `, [c$2("+", [cE$1("placeholder", `
 display: flex;
 align-items: center; 
 `)])]),
  cNotM("textarea", [cE$1("placeholder", "white-space: nowrap;")]),
  cE$1("eye", `
 display: flex;
 align-items: center;
 justify-content: center;
 transition: color .3s var(--n-bezier);
 `),
  cM("textarea", "width: 100%;", [cB$1("input-word-count", `
 position: absolute;
 right: var(--n-padding-right);
 bottom: var(--n-padding-vertical);
 `), cM("resizable", [cB$1("input-wrapper", `
 resize: vertical;
 min-height: var(--n-height);
 `)]), cE$1("textarea-el, textarea-mirror, placeholder", `
 height: 100%;
 padding-left: 0;
 padding-right: 0;
 padding-top: var(--n-padding-vertical);
 padding-bottom: var(--n-padding-vertical);
 word-break: break-word;
 display: inline-block;
 vertical-align: bottom;
 box-sizing: border-box;
 line-height: var(--n-line-height-textarea);
 margin: 0;
 resize: none;
 white-space: pre-wrap;
 `), cE$1("textarea-mirror", `
 width: 100%;
 pointer-events: none;
 overflow: hidden;
 visibility: hidden;
 position: static;
 white-space: pre-wrap;
 overflow-wrap: break-word;
 `)]),
  cM("pair", [cE$1("input-el, placeholder", "text-align: center;"), cE$1("separator", `
 display: flex;
 align-items: center;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 white-space: nowrap;
 `, [cB$1("icon", `
 color: var(--n-icon-color);
 `), cB$1("base-icon", `
 color: var(--n-icon-color);
 `)])]),
  cM("disabled", `
 cursor: not-allowed;
 background-color: var(--n-color-disabled);
 `, [cE$1("border", "border: var(--n-border-disabled);"), cE$1("input-el, textarea-el", `
 cursor: not-allowed;
 color: var(--n-text-color-disabled);
 text-decoration-color: var(--n-text-color-disabled);
 `), cE$1("placeholder", "color: var(--n-placeholder-color-disabled);"), cE$1("separator", "color: var(--n-text-color-disabled);", [cB$1("icon", `
 color: var(--n-icon-color-disabled);
 `), cB$1("base-icon", `
 color: var(--n-icon-color-disabled);
 `)]), cB$1("input-word-count", `
 color: var(--n-count-text-color-disabled);
 `), cE$1("suffix, prefix", "color: var(--n-text-color-disabled);", [cB$1("icon", `
 color: var(--n-icon-color-disabled);
 `), cB$1("internal-icon", `
 color: var(--n-icon-color-disabled);
 `)])]),
  cNotM("disabled", [cE$1("eye", `
 color: var(--n-icon-color);
 cursor: pointer;
 `, [c$2("&:hover", `
 color: var(--n-icon-color-hover);
 `), c$2("&:active", `
 color: var(--n-icon-color-pressed);
 `)]), c$2("&:hover", [cE$1("state-border", "border: var(--n-border-hover);")]), cM("focus", "background-color: var(--n-color-focus);", [cE$1("state-border", `
 border: var(--n-border-focus);
 box-shadow: var(--n-box-shadow-focus);
 `)])]),
  cE$1("border, state-border", `
 box-sizing: border-box;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border-radius: inherit;
 border: var(--n-border);
 transition:
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `),
  cE$1("state-border", `
 border-color: #0000;
 z-index: 1;
 `),
  cE$1("prefix", "margin-right: 4px;"),
  cE$1("suffix", `
 margin-left: 4px;
 `),
  cE$1("suffix, prefix", `
 transition: color .3s var(--n-bezier);
 flex-wrap: nowrap;
 flex-shrink: 0;
 line-height: var(--n-height);
 white-space: nowrap;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 color: var(--n-suffix-text-color);
 `, [cB$1("base-loading", `
 font-size: var(--n-icon-size);
 margin: 0 2px;
 color: var(--n-loading-color);
 `), cB$1("base-clear", `
 font-size: var(--n-icon-size);
 `, [cE$1("placeholder", [cB$1("base-icon", `
 transition: color .3s var(--n-bezier);
 color: var(--n-icon-color);
 font-size: var(--n-icon-size);
 `)])]), c$2(">", [cB$1("icon", `
 transition: color .3s var(--n-bezier);
 color: var(--n-icon-color);
 font-size: var(--n-icon-size);
 `)]), cB$1("base-icon", `
 font-size: var(--n-icon-size);
 `)]),
  cB$1("input-word-count", `
 pointer-events: none;
 line-height: 1.5;
 font-size: .85em;
 color: var(--n-count-text-color);
 transition: color .3s var(--n-bezier);
 margin-left: 4px;
 font-variant: tabular-nums;
 `),
  ["warning", "error"].map((status) => cM(`${status}-status`, [cNotM("disabled", [cB$1("base-loading", `
 color: var(--n-loading-color-${status})
 `), cE$1("input-el, textarea-el", `
 caret-color: var(--n-caret-color-${status});
 `), cE$1("state-border", `
 border: var(--n-border-${status});
 `), c$2("&:hover", [cE$1("state-border", `
 border: var(--n-border-hover-${status});
 `)]), c$2("&:focus", `
 background-color: var(--n-color-focus-${status});
 `, [cE$1("state-border", `
 box-shadow: var(--n-box-shadow-focus-${status});
 border: var(--n-border-focus-${status});
 `)]), cM("focus", `
 background-color: var(--n-color-focus-${status});
 `, [cE$1("state-border", `
 box-shadow: var(--n-box-shadow-focus-${status});
 border: var(--n-border-focus-${status});
 `)])])]))
]);
const safariStyle = cB$1("input", [cM("disabled", [cE$1("input-el, textarea-el", `
 -webkit-text-fill-color: var(--n-text-color-disabled);
 `)])]);
const inputProps = Object.assign(Object.assign({}, useTheme.props), {
  bordered: {
    type: Boolean,
    default: void 0
  },
  type: {
    type: String,
    default: "text"
  },
  placeholder: [Array, String],
  defaultValue: {
    type: [String, Array],
    default: null
  },
  value: [String, Array],
  disabled: {
    type: Boolean,
    default: void 0
  },
  size: String,
  rows: {
    type: [Number, String],
    default: 3
  },
  round: Boolean,
  minlength: [String, Number],
  maxlength: [String, Number],
  clearable: Boolean,
  autosize: {
    type: [Boolean, Object],
    default: false
  },
  pair: Boolean,
  separator: String,
  readonly: {
    type: [String, Boolean],
    default: false
  },
  passivelyActivated: Boolean,
  showPasswordOn: String,
  stateful: {
    type: Boolean,
    default: true
  },
  autofocus: Boolean,
  inputProps: Object,
  resizable: {
    type: Boolean,
    default: true
  },
  showCount: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  allowInput: Function,
  renderCount: Function,
  onMousedown: Function,
  onKeydown: Function,
  onKeyup: Function,
  onInput: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClick: [Function, Array],
  onChange: [Function, Array],
  onClear: [Function, Array],
  countGraphemes: Function,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  textDecoration: [String, Array],
  attrSize: {
    type: Number,
    default: 20
  },
  onInputBlur: [Function, Array],
  onInputFocus: [Function, Array],
  onDeactivate: [Function, Array],
  onActivate: [Function, Array],
  onWrapperFocus: [Function, Array],
  onWrapperBlur: [Function, Array],
  internalDeactivateOnEnter: Boolean,
  internalForceFocus: Boolean,
  internalLoadingBeforeSuffix: Boolean,
  showPasswordToggle: Boolean
});
var NInput = defineComponent({
  name: "Input",
  props: inputProps,
  setup(props) {
    const { mergedClsPrefixRef, mergedBorderedRef, inlineThemeDisabled, mergedRtlRef } = useConfig(props);
    const themeRef = useTheme("Input", "-input", style$H, inputLight$1, props, mergedClsPrefixRef);
    if (isSafari) {
      useStyle("-input-safari", safariStyle, mergedClsPrefixRef);
    }
    const wrapperElRef = ref(null);
    const textareaElRef = ref(null);
    const textareaMirrorElRef = ref(null);
    const inputMirrorElRef = ref(null);
    const inputElRef = ref(null);
    const inputEl2Ref = ref(null);
    const currentFocusedInputRef = ref(null);
    const focusedInputCursorControl = useCursor(currentFocusedInputRef);
    const textareaScrollbarInstRef = ref(null);
    const { localeRef } = useLocale("Input");
    const uncontrolledValueRef = ref(props.defaultValue);
    const controlledValueRef = toRef(props, "value");
    const mergedValueRef = useMergedState(controlledValueRef, uncontrolledValueRef);
    const formItem = useFormItem(props);
    const { mergedSizeRef, mergedDisabledRef, mergedStatusRef } = formItem;
    const focusedRef = ref(false);
    const hoverRef = ref(false);
    const isComposingRef2 = ref(false);
    const activatedRef = ref(false);
    let syncSource = null;
    const mergedPlaceholderRef = computed(() => {
      const { placeholder, pair: pair2 } = props;
      if (pair2) {
        if (Array.isArray(placeholder)) {
          return placeholder;
        } else if (placeholder === void 0) {
          return ["", ""];
        }
        return [placeholder, placeholder];
      } else if (placeholder === void 0) {
        return [localeRef.value.placeholder];
      } else {
        return [placeholder];
      }
    });
    const showPlaceholder1Ref = computed(() => {
      const { value: isComposing } = isComposingRef2;
      const { value: mergedValue } = mergedValueRef;
      const { value: mergedPlaceholder } = mergedPlaceholderRef;
      return !isComposing && (isEmptyInputValue(mergedValue) || Array.isArray(mergedValue) && isEmptyInputValue(mergedValue[0])) && mergedPlaceholder[0];
    });
    const showPlaceholder2Ref = computed(() => {
      const { value: isComposing } = isComposingRef2;
      const { value: mergedValue } = mergedValueRef;
      const { value: mergedPlaceholder } = mergedPlaceholderRef;
      return !isComposing && mergedPlaceholder[1] && (isEmptyInputValue(mergedValue) || Array.isArray(mergedValue) && isEmptyInputValue(mergedValue[1]));
    });
    const mergedFocusRef = useMemo(() => {
      return props.internalForceFocus || focusedRef.value;
    });
    const showClearButton = useMemo(() => {
      if (mergedDisabledRef.value || props.readonly || !props.clearable || !mergedFocusRef.value && !hoverRef.value) {
        return false;
      }
      const { value: mergedValue } = mergedValueRef;
      const { value: mergedFocus } = mergedFocusRef;
      if (props.pair) {
        return !!(Array.isArray(mergedValue) && (mergedValue[0] || mergedValue[1])) && (hoverRef.value || mergedFocus);
      } else {
        return !!mergedValue && (hoverRef.value || mergedFocus);
      }
    });
    const mergedShowPasswordOnRef = computed(() => {
      const { showPasswordOn } = props;
      if (showPasswordOn) {
        return showPasswordOn;
      }
      if (props.showPasswordToggle)
        return "click";
      return void 0;
    });
    const passwordVisibleRef = ref(false);
    const textDecorationStyleRef = computed(() => {
      const { textDecoration } = props;
      if (!textDecoration)
        return ["", ""];
      if (Array.isArray(textDecoration)) {
        return textDecoration.map((v2) => ({
          textDecoration: v2
        }));
      }
      return [
        {
          textDecoration
        }
      ];
    });
    const textAreaScrollContainerWidthRef = ref(void 0);
    const updateTextAreaStyle = () => {
      var _a2, _b2;
      if (props.type === "textarea") {
        const { autosize } = props;
        if (autosize) {
          textAreaScrollContainerWidthRef.value = (_b2 = (_a2 = textareaScrollbarInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.$el) === null || _b2 === void 0 ? void 0 : _b2.offsetWidth;
        }
        if (!textareaElRef.value)
          return;
        if (typeof autosize === "boolean")
          return;
        const { paddingTop: stylePaddingTop, paddingBottom: stylePaddingBottom, lineHeight: styleLineHeight } = window.getComputedStyle(textareaElRef.value);
        const paddingTop = Number(stylePaddingTop.slice(0, -2));
        const paddingBottom = Number(stylePaddingBottom.slice(0, -2));
        const lineHeight2 = Number(styleLineHeight.slice(0, -2));
        const { value: textareaMirrorEl } = textareaMirrorElRef;
        if (!textareaMirrorEl)
          return;
        if (autosize.minRows) {
          const minRows = Math.max(autosize.minRows, 1);
          const styleMinHeight = `${paddingTop + paddingBottom + lineHeight2 * minRows}px`;
          textareaMirrorEl.style.minHeight = styleMinHeight;
        }
        if (autosize.maxRows) {
          const styleMaxHeight = `${paddingTop + paddingBottom + lineHeight2 * autosize.maxRows}px`;
          textareaMirrorEl.style.maxHeight = styleMaxHeight;
        }
      }
    };
    const maxlengthRef = computed(() => {
      const { maxlength } = props;
      return maxlength === void 0 ? void 0 : Number(maxlength);
    });
    onMounted(() => {
      const { value: value2 } = mergedValueRef;
      if (!Array.isArray(value2)) {
        syncMirror(value2);
      }
    });
    const vm2 = getCurrentInstance().proxy;
    function doUpdateValue(value2) {
      const { onUpdateValue, "onUpdate:value": _onUpdateValue, onInput } = props;
      const { nTriggerFormInput } = formItem;
      if (onUpdateValue)
        call(onUpdateValue, value2);
      if (_onUpdateValue)
        call(_onUpdateValue, value2);
      if (onInput)
        call(onInput, value2);
      uncontrolledValueRef.value = value2;
      nTriggerFormInput();
    }
    function doChange(value2) {
      const { onChange } = props;
      const { nTriggerFormChange } = formItem;
      if (onChange)
        call(onChange, value2);
      uncontrolledValueRef.value = value2;
      nTriggerFormChange();
    }
    function doBlur(e25) {
      const { onBlur } = props;
      const { nTriggerFormBlur } = formItem;
      if (onBlur)
        call(onBlur, e25);
      nTriggerFormBlur();
    }
    function doFocus(e25) {
      const { onFocus } = props;
      const { nTriggerFormFocus } = formItem;
      if (onFocus)
        call(onFocus, e25);
      nTriggerFormFocus();
    }
    function doClear(e25) {
      const { onClear } = props;
      if (onClear)
        call(onClear, e25);
    }
    function doUpdateValueBlur(e25) {
      const { onInputBlur } = props;
      if (onInputBlur)
        call(onInputBlur, e25);
    }
    function doUpdateValueFocus(e25) {
      const { onInputFocus } = props;
      if (onInputFocus)
        call(onInputFocus, e25);
    }
    function doDeactivate() {
      const { onDeactivate } = props;
      if (onDeactivate)
        call(onDeactivate);
    }
    function doActivate() {
      const { onActivate } = props;
      if (onActivate)
        call(onActivate);
    }
    function doClick(e25) {
      const { onClick } = props;
      if (onClick)
        call(onClick, e25);
    }
    function doWrapperFocus(e25) {
      const { onWrapperFocus } = props;
      if (onWrapperFocus)
        call(onWrapperFocus, e25);
    }
    function doWrapperBlur(e25) {
      const { onWrapperBlur } = props;
      if (onWrapperBlur)
        call(onWrapperBlur, e25);
    }
    function handleCompositionStart() {
      isComposingRef2.value = true;
    }
    function handleCompositionEnd(e25) {
      isComposingRef2.value = false;
      if (e25.target === inputEl2Ref.value) {
        handleInput(e25, 1);
      } else {
        handleInput(e25, 0);
      }
    }
    function handleInput(e25, index2 = 0, event = "input") {
      const targetValue = e25.target.value;
      syncMirror(targetValue);
      if (e25 instanceof InputEvent && !e25.isComposing) {
        isComposingRef2.value = false;
      }
      if (props.type === "textarea") {
        const { value: textareaScrollbarInst } = textareaScrollbarInstRef;
        if (textareaScrollbarInst) {
          textareaScrollbarInst.syncUnifiedContainer();
        }
      }
      syncSource = targetValue;
      if (isComposingRef2.value)
        return;
      focusedInputCursorControl.recordCursor();
      const isIncomingValueValid = allowInput(targetValue);
      if (isIncomingValueValid) {
        if (!props.pair) {
          event === "input" ? doUpdateValue(targetValue) : doChange(targetValue);
        } else {
          let { value: value2 } = mergedValueRef;
          if (!Array.isArray(value2)) {
            value2 = ["", ""];
          } else {
            value2 = [value2[0], value2[1]];
          }
          value2[index2] = targetValue;
          event === "input" ? doUpdateValue(value2) : doChange(value2);
        }
      }
      vm2.$forceUpdate();
      if (!isIncomingValueValid) {
        void nextTick(focusedInputCursorControl.restoreCursor);
      }
    }
    function allowInput(value2) {
      const { countGraphemes, maxlength, minlength } = props;
      if (countGraphemes) {
        let graphemesCount;
        if (maxlength !== void 0) {
          if (graphemesCount === void 0) {
            graphemesCount = countGraphemes(value2);
          }
          if (graphemesCount > Number(maxlength))
            return false;
        }
        if (minlength !== void 0) {
          if (graphemesCount === void 0) {
            graphemesCount = countGraphemes(value2);
          }
          if (graphemesCount < Number(maxlength))
            return false;
        }
      }
      const { allowInput: allowInput2 } = props;
      if (typeof allowInput2 === "function") {
        return allowInput2(value2);
      }
      return true;
    }
    function handleInputBlur(e25) {
      doUpdateValueBlur(e25);
      if (e25.relatedTarget === wrapperElRef.value) {
        doDeactivate();
      }
      if (!(e25.relatedTarget !== null && (e25.relatedTarget === inputElRef.value || e25.relatedTarget === inputEl2Ref.value || e25.relatedTarget === textareaElRef.value))) {
        activatedRef.value = false;
      }
      dealWithEvent(e25, "blur");
      currentFocusedInputRef.value = null;
    }
    function handleInputFocus(e25, index2) {
      doUpdateValueFocus(e25);
      focusedRef.value = true;
      activatedRef.value = true;
      doActivate();
      dealWithEvent(e25, "focus");
      if (index2 === 0) {
        currentFocusedInputRef.value = inputElRef.value;
      } else if (index2 === 1) {
        currentFocusedInputRef.value = inputEl2Ref.value;
      } else if (index2 === 2) {
        currentFocusedInputRef.value = textareaElRef.value;
      }
    }
    function handleWrapperBlur(e25) {
      if (props.passivelyActivated) {
        doWrapperBlur(e25);
        dealWithEvent(e25, "blur");
      }
    }
    function handleWrapperFocus(e25) {
      if (props.passivelyActivated) {
        focusedRef.value = true;
        doWrapperFocus(e25);
        dealWithEvent(e25, "focus");
      }
    }
    function dealWithEvent(e25, type4) {
      if (e25.relatedTarget !== null && (e25.relatedTarget === inputElRef.value || e25.relatedTarget === inputEl2Ref.value || e25.relatedTarget === textareaElRef.value || e25.relatedTarget === wrapperElRef.value))
        ;
      else {
        if (type4 === "focus") {
          doFocus(e25);
          focusedRef.value = true;
        } else if (type4 === "blur") {
          doBlur(e25);
          focusedRef.value = false;
        }
      }
    }
    function handleChange(e25, index2) {
      handleInput(e25, index2, "change");
    }
    function handleClick2(e25) {
      doClick(e25);
    }
    function handleClear(e25) {
      doClear(e25);
      if (props.pair) {
        doUpdateValue(["", ""]);
        doChange(["", ""]);
      } else {
        doUpdateValue("");
        doChange("");
      }
    }
    function handleMouseDown(e25) {
      const { onMousedown } = props;
      if (onMousedown)
        onMousedown(e25);
      const { tagName } = e25.target;
      if (tagName !== "INPUT" && tagName !== "TEXTAREA") {
        if (props.resizable) {
          const { value: wrapperEl } = wrapperElRef;
          if (wrapperEl) {
            const { left, top: top2, width, height } = wrapperEl.getBoundingClientRect();
            const resizeHandleSize = 14;
            if (left + width - resizeHandleSize < e25.clientX && e25.clientX < left + width && top2 + height - resizeHandleSize < e25.clientY && e25.clientY < top2 + height) {
              return;
            }
          }
        }
        e25.preventDefault();
        if (!focusedRef.value) {
          focus();
        }
      }
    }
    function handleMouseEnter() {
      var _a2;
      hoverRef.value = true;
      if (props.type === "textarea") {
        (_a2 = textareaScrollbarInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.handleMouseEnterWrapper();
      }
    }
    function handleMouseLeave() {
      var _a2;
      hoverRef.value = false;
      if (props.type === "textarea") {
        (_a2 = textareaScrollbarInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.handleMouseLeaveWrapper();
      }
    }
    function handlePasswordToggleClick() {
      if (mergedDisabledRef.value)
        return;
      if (mergedShowPasswordOnRef.value !== "click")
        return;
      passwordVisibleRef.value = !passwordVisibleRef.value;
    }
    function handlePasswordToggleMousedown(e25) {
      if (mergedDisabledRef.value)
        return;
      e25.preventDefault();
      const preventDefaultOnce = (e26) => {
        e26.preventDefault();
        off("mouseup", document, preventDefaultOnce);
      };
      on$1("mouseup", document, preventDefaultOnce);
      if (mergedShowPasswordOnRef.value !== "mousedown")
        return;
      passwordVisibleRef.value = true;
      const hidePassword = () => {
        passwordVisibleRef.value = false;
        off("mouseup", document, hidePassword);
      };
      on$1("mouseup", document, hidePassword);
    }
    function handleWrapperKeydown(e25) {
      var _a2;
      (_a2 = props.onKeydown) === null || _a2 === void 0 ? void 0 : _a2.call(props, e25);
      switch (e25.key) {
        case "Escape":
          handleWrapperKeydownEsc();
          break;
        case "Enter":
          handleWrapperKeydownEnter(e25);
          break;
      }
    }
    function handleWrapperKeydownEnter(e25) {
      var _a2, _b2;
      if (props.passivelyActivated) {
        const { value: focused } = activatedRef;
        if (focused) {
          if (props.internalDeactivateOnEnter) {
            handleWrapperKeydownEsc();
          }
          return;
        }
        e25.preventDefault();
        if (props.type === "textarea") {
          (_a2 = textareaElRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
        } else {
          (_b2 = inputElRef.value) === null || _b2 === void 0 ? void 0 : _b2.focus();
        }
      }
    }
    function handleWrapperKeydownEsc() {
      if (props.passivelyActivated) {
        activatedRef.value = false;
        void nextTick(() => {
          var _a2;
          (_a2 = wrapperElRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
        });
      }
    }
    function focus() {
      var _a2, _b2, _c2;
      if (mergedDisabledRef.value)
        return;
      if (props.passivelyActivated) {
        (_a2 = wrapperElRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      } else {
        (_b2 = textareaElRef.value) === null || _b2 === void 0 ? void 0 : _b2.focus();
        (_c2 = inputElRef.value) === null || _c2 === void 0 ? void 0 : _c2.focus();
      }
    }
    function blur() {
      var _a2;
      if ((_a2 = wrapperElRef.value) === null || _a2 === void 0 ? void 0 : _a2.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    }
    function select() {
      var _a2, _b2;
      (_a2 = textareaElRef.value) === null || _a2 === void 0 ? void 0 : _a2.select();
      (_b2 = inputElRef.value) === null || _b2 === void 0 ? void 0 : _b2.select();
    }
    function activate() {
      if (mergedDisabledRef.value)
        return;
      if (textareaElRef.value)
        textareaElRef.value.focus();
      else if (inputElRef.value)
        inputElRef.value.focus();
    }
    function deactivate() {
      const { value: wrapperEl } = wrapperElRef;
      if ((wrapperEl === null || wrapperEl === void 0 ? void 0 : wrapperEl.contains(document.activeElement)) && wrapperEl !== document.activeElement) {
        handleWrapperKeydownEsc();
      }
    }
    function scrollTo(options) {
      if (props.type === "textarea") {
        const { value: textareaEl } = textareaElRef;
        textareaEl === null || textareaEl === void 0 ? void 0 : textareaEl.scrollTo(options);
      } else {
        const { value: inputEl } = inputElRef;
        inputEl === null || inputEl === void 0 ? void 0 : inputEl.scrollTo(options);
      }
    }
    function syncMirror(value2) {
      const { type: type4, pair: pair2, autosize } = props;
      if (!pair2 && autosize) {
        if (type4 === "textarea") {
          const { value: textareaMirrorEl } = textareaMirrorElRef;
          if (textareaMirrorEl) {
            textareaMirrorEl.textContent = (value2 !== null && value2 !== void 0 ? value2 : "") + "\r\n";
          }
        } else {
          const { value: inputMirrorEl } = inputMirrorElRef;
          if (inputMirrorEl) {
            if (value2) {
              inputMirrorEl.textContent = value2;
            } else {
              inputMirrorEl.innerHTML = "&nbsp;";
            }
          }
        }
      }
    }
    function handleTextAreaMirrorResize() {
      updateTextAreaStyle();
    }
    const placeholderStyleRef = ref({
      top: "0"
    });
    function handleTextAreaScroll(e25) {
      var _a2;
      const { scrollTop } = e25.target;
      placeholderStyleRef.value.top = `${-scrollTop}px`;
      (_a2 = textareaScrollbarInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.syncUnifiedContainer();
    }
    let stopWatchMergedValue1 = null;
    watchEffect(() => {
      const { autosize, type: type4 } = props;
      if (autosize && type4 === "textarea") {
        stopWatchMergedValue1 = watch(mergedValueRef, (value2) => {
          if (!Array.isArray(value2) && value2 !== syncSource) {
            syncMirror(value2);
          }
        });
      } else {
        stopWatchMergedValue1 === null || stopWatchMergedValue1 === void 0 ? void 0 : stopWatchMergedValue1();
      }
    });
    let stopWatchMergedValue2 = null;
    watchEffect(() => {
      if (props.type === "textarea") {
        stopWatchMergedValue2 = watch(mergedValueRef, (value2) => {
          var _a2;
          if (!Array.isArray(value2) && value2 !== syncSource) {
            (_a2 = textareaScrollbarInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.syncUnifiedContainer();
          }
        });
      } else {
        stopWatchMergedValue2 === null || stopWatchMergedValue2 === void 0 ? void 0 : stopWatchMergedValue2();
      }
    });
    provide(inputInjectionKey, {
      mergedValueRef,
      maxlengthRef,
      mergedClsPrefixRef,
      countGraphemesRef: toRef(props, "countGraphemes")
    });
    const exposedProps = {
      wrapperElRef,
      inputElRef,
      textareaElRef,
      isCompositing: isComposingRef2,
      focus,
      blur,
      select,
      deactivate,
      activate,
      scrollTo
    };
    const rtlEnabledRef = useRtl("Input", mergedRtlRef, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { value: size2 } = mergedSizeRef;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { color, borderRadius, textColor, caretColor, caretColorError, caretColorWarning, textDecorationColor, border, borderDisabled, borderHover, borderFocus, placeholderColor, placeholderColorDisabled, lineHeightTextarea, colorDisabled, colorFocus, textColorDisabled, boxShadowFocus, iconSize, colorFocusWarning, boxShadowFocusWarning, borderWarning, borderFocusWarning, borderHoverWarning, colorFocusError, boxShadowFocusError, borderError, borderFocusError, borderHoverError, clearSize, clearColor, clearColorHover, clearColorPressed, iconColor, iconColorDisabled, suffixTextColor, countTextColor, countTextColorDisabled, iconColorHover, iconColorPressed, loadingColor, loadingColorError, loadingColorWarning, [createKey("padding", size2)]: padding, [createKey("fontSize", size2)]: fontSize2, [createKey("height", size2)]: height } } = themeRef.value;
      const { left: paddingLeft, right: paddingRight } = getMargin(padding);
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-count-text-color": countTextColor,
        "--n-count-text-color-disabled": countTextColorDisabled,
        "--n-color": color,
        "--n-font-size": fontSize2,
        "--n-border-radius": borderRadius,
        "--n-height": height,
        "--n-padding-left": paddingLeft,
        "--n-padding-right": paddingRight,
        "--n-text-color": textColor,
        "--n-caret-color": caretColor,
        "--n-text-decoration-color": textDecorationColor,
        "--n-border": border,
        "--n-border-disabled": borderDisabled,
        "--n-border-hover": borderHover,
        "--n-border-focus": borderFocus,
        "--n-placeholder-color": placeholderColor,
        "--n-placeholder-color-disabled": placeholderColorDisabled,
        "--n-icon-size": iconSize,
        "--n-line-height-textarea": lineHeightTextarea,
        "--n-color-disabled": colorDisabled,
        "--n-color-focus": colorFocus,
        "--n-text-color-disabled": textColorDisabled,
        "--n-box-shadow-focus": boxShadowFocus,
        "--n-loading-color": loadingColor,
        "--n-caret-color-warning": caretColorWarning,
        "--n-color-focus-warning": colorFocusWarning,
        "--n-box-shadow-focus-warning": boxShadowFocusWarning,
        "--n-border-warning": borderWarning,
        "--n-border-focus-warning": borderFocusWarning,
        "--n-border-hover-warning": borderHoverWarning,
        "--n-loading-color-warning": loadingColorWarning,
        "--n-caret-color-error": caretColorError,
        "--n-color-focus-error": colorFocusError,
        "--n-box-shadow-focus-error": boxShadowFocusError,
        "--n-border-error": borderError,
        "--n-border-focus-error": borderFocusError,
        "--n-border-hover-error": borderHoverError,
        "--n-loading-color-error": loadingColorError,
        "--n-clear-color": clearColor,
        "--n-clear-size": clearSize,
        "--n-clear-color-hover": clearColorHover,
        "--n-clear-color-pressed": clearColorPressed,
        "--n-icon-color": iconColor,
        "--n-icon-color-hover": iconColorHover,
        "--n-icon-color-pressed": iconColorPressed,
        "--n-icon-color-disabled": iconColorDisabled,
        "--n-suffix-text-color": suffixTextColor
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("input", computed(() => {
      const { value: size2 } = mergedSizeRef;
      return size2[0];
    }), cssVarsRef, props) : void 0;
    return Object.assign(Object.assign({}, exposedProps), {
      wrapperElRef,
      inputElRef,
      inputMirrorElRef,
      inputEl2Ref,
      textareaElRef,
      textareaMirrorElRef,
      textareaScrollbarInstRef,
      rtlEnabled: rtlEnabledRef,
      uncontrolledValue: uncontrolledValueRef,
      mergedValue: mergedValueRef,
      passwordVisible: passwordVisibleRef,
      mergedPlaceholder: mergedPlaceholderRef,
      showPlaceholder1: showPlaceholder1Ref,
      showPlaceholder2: showPlaceholder2Ref,
      mergedFocus: mergedFocusRef,
      isComposing: isComposingRef2,
      activated: activatedRef,
      showClearButton,
      mergedSize: mergedSizeRef,
      mergedDisabled: mergedDisabledRef,
      textDecorationStyle: textDecorationStyleRef,
      mergedClsPrefix: mergedClsPrefixRef,
      mergedBordered: mergedBorderedRef,
      mergedShowPasswordOn: mergedShowPasswordOnRef,
      placeholderStyle: placeholderStyleRef,
      mergedStatus: mergedStatusRef,
      textAreaScrollContainerWidth: textAreaScrollContainerWidthRef,
      handleTextAreaScroll,
      handleCompositionStart,
      handleCompositionEnd,
      handleInput,
      handleInputBlur,
      handleInputFocus,
      handleWrapperBlur,
      handleWrapperFocus,
      handleMouseEnter,
      handleMouseLeave,
      handleMouseDown,
      handleChange,
      handleClick: handleClick2,
      handleClear,
      handlePasswordToggleClick,
      handlePasswordToggleMousedown,
      handleWrapperKeydown,
      handleTextAreaMirrorResize,
      getTextareaScrollContainer: () => {
        return textareaElRef.value;
      },
      mergedTheme: themeRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    });
  },
  render() {
    var _a2, _b2;
    const { mergedClsPrefix, mergedStatus, themeClass, type: type4, countGraphemes, onRender } = this;
    const $slots = this.$slots;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { ref: "wrapperElRef", class: [
      `${mergedClsPrefix}-input`,
      themeClass,
      mergedStatus && `${mergedClsPrefix}-input--${mergedStatus}-status`,
      {
        [`${mergedClsPrefix}-input--rtl`]: this.rtlEnabled,
        [`${mergedClsPrefix}-input--disabled`]: this.mergedDisabled,
        [`${mergedClsPrefix}-input--textarea`]: type4 === "textarea",
        [`${mergedClsPrefix}-input--resizable`]: this.resizable && !this.autosize,
        [`${mergedClsPrefix}-input--autosize`]: this.autosize,
        [`${mergedClsPrefix}-input--round`]: this.round && !(type4 === "textarea"),
        [`${mergedClsPrefix}-input--pair`]: this.pair,
        [`${mergedClsPrefix}-input--focus`]: this.mergedFocus,
        [`${mergedClsPrefix}-input--stateful`]: this.stateful
      }
    ], style: this.cssVars, tabindex: !this.mergedDisabled && this.passivelyActivated && !this.activated ? 0 : void 0, onFocus: this.handleWrapperFocus, onBlur: this.handleWrapperBlur, onClick: this.handleClick, onMousedown: this.handleMouseDown, onMouseenter: this.handleMouseEnter, onMouseleave: this.handleMouseLeave, onCompositionstart: this.handleCompositionStart, onCompositionend: this.handleCompositionEnd, onKeyup: this.onKeyup, onKeydown: this.handleWrapperKeydown }, h$1("div", { class: `${mergedClsPrefix}-input-wrapper` }, resolveWrappedSlot($slots.prefix, (children) => children && h$1("div", { class: `${mergedClsPrefix}-input__prefix` }, children)), type4 === "textarea" ? h$1(NScrollbar, { ref: "textareaScrollbarInstRef", class: `${mergedClsPrefix}-input__textarea`, container: this.getTextareaScrollContainer, triggerDisplayManually: true, useUnifiedContainer: true, internalHoistYRail: true }, {
      default: () => {
        var _a3, _b3;
        const { textAreaScrollContainerWidth } = this;
        const scrollContainerWidthStyle = {
          width: this.autosize && textAreaScrollContainerWidth && `${textAreaScrollContainerWidth}px`
        };
        return h$1(Fragment, null, h$1("textarea", Object.assign({}, this.inputProps, { ref: "textareaElRef", class: [
          `${mergedClsPrefix}-input__textarea-el`,
          (_a3 = this.inputProps) === null || _a3 === void 0 ? void 0 : _a3.class
        ], autofocus: this.autofocus, rows: Number(this.rows), placeholder: this.placeholder, value: this.mergedValue, disabled: this.mergedDisabled, maxlength: countGraphemes ? void 0 : this.maxlength, minlength: countGraphemes ? void 0 : this.minlength, readonly: this.readonly, tabindex: this.passivelyActivated && !this.activated ? -1 : void 0, style: [
          this.textDecorationStyle[0],
          (_b3 = this.inputProps) === null || _b3 === void 0 ? void 0 : _b3.style,
          scrollContainerWidthStyle
        ], onBlur: this.handleInputBlur, onFocus: (e25) => {
          this.handleInputFocus(e25, 2);
        }, onInput: this.handleInput, onChange: this.handleChange, onScroll: this.handleTextAreaScroll })), this.showPlaceholder1 ? h$1("div", { class: `${mergedClsPrefix}-input__placeholder`, style: [
          this.placeholderStyle,
          scrollContainerWidthStyle
        ], key: "placeholder" }, this.mergedPlaceholder[0]) : null, this.autosize ? h$1(VResizeObserver, { onResize: this.handleTextAreaMirrorResize }, {
          default: () => h$1("div", { ref: "textareaMirrorElRef", class: `${mergedClsPrefix}-input__textarea-mirror`, key: "mirror" })
        }) : null);
      }
    }) : h$1("div", { class: `${mergedClsPrefix}-input__input` }, h$1("input", Object.assign({ type: type4 === "password" && this.mergedShowPasswordOn && this.passwordVisible ? "text" : type4 }, this.inputProps, { ref: "inputElRef", class: [
      `${mergedClsPrefix}-input__input-el`,
      (_a2 = this.inputProps) === null || _a2 === void 0 ? void 0 : _a2.class
    ], style: [
      this.textDecorationStyle[0],
      (_b2 = this.inputProps) === null || _b2 === void 0 ? void 0 : _b2.style
    ], tabindex: this.passivelyActivated && !this.activated ? -1 : void 0, placeholder: this.mergedPlaceholder[0], disabled: this.mergedDisabled, maxlength: countGraphemes ? void 0 : this.maxlength, minlength: countGraphemes ? void 0 : this.minlength, value: Array.isArray(this.mergedValue) ? this.mergedValue[0] : this.mergedValue, readonly: this.readonly, autofocus: this.autofocus, size: this.attrSize, onBlur: this.handleInputBlur, onFocus: (e25) => {
      this.handleInputFocus(e25, 0);
    }, onInput: (e25) => {
      this.handleInput(e25, 0);
    }, onChange: (e25) => {
      this.handleChange(e25, 0);
    } })), this.showPlaceholder1 ? h$1("div", { class: `${mergedClsPrefix}-input__placeholder` }, h$1("span", null, this.mergedPlaceholder[0])) : null, this.autosize ? h$1("div", { class: `${mergedClsPrefix}-input__input-mirror`, key: "mirror", ref: "inputMirrorElRef" }, "\xA0") : null), !this.pair && resolveWrappedSlot($slots.suffix, (children) => {
      return children || this.clearable || this.showCount || this.mergedShowPasswordOn || this.loading !== void 0 ? h$1("div", { class: `${mergedClsPrefix}-input__suffix` }, [
        resolveWrappedSlot($slots["clear-icon-placeholder"], (children2) => {
          return (this.clearable || children2) && h$1(NBaseClear, { clsPrefix: mergedClsPrefix, show: this.showClearButton, onClear: this.handleClear }, {
            placeholder: () => children2,
            icon: () => {
              var _a3, _b3;
              return (_b3 = (_a3 = this.$slots)["clear-icon"]) === null || _b3 === void 0 ? void 0 : _b3.call(_a3);
            }
          });
        }),
        !this.internalLoadingBeforeSuffix ? children : null,
        this.loading !== void 0 ? h$1(NBaseSuffix, { clsPrefix: mergedClsPrefix, loading: this.loading, showArrow: false, showClear: false, style: this.cssVars }) : null,
        this.internalLoadingBeforeSuffix ? children : null,
        this.showCount && this.type !== "textarea" ? h$1(WordCount, null, {
          default: (props) => {
            var _a3;
            return (_a3 = $slots.count) === null || _a3 === void 0 ? void 0 : _a3.call($slots, props);
          }
        }) : null,
        this.mergedShowPasswordOn && this.type === "password" ? h$1("div", { class: `${mergedClsPrefix}-input__eye`, onMousedown: this.handlePasswordToggleMousedown, onClick: this.handlePasswordToggleClick }, this.passwordVisible ? resolveSlot($slots["password-visible-icon"], () => [
          h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, { default: () => h$1(EyeIcon, null) })
        ]) : resolveSlot($slots["password-invisible-icon"], () => [
          h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, { default: () => h$1(EyeOffIcon, null) })
        ])) : null
      ]) : null;
    })), this.pair ? h$1("span", { class: `${mergedClsPrefix}-input__separator` }, resolveSlot($slots.separator, () => [this.separator])) : null, this.pair ? h$1("div", { class: `${mergedClsPrefix}-input-wrapper` }, h$1("div", { class: `${mergedClsPrefix}-input__input` }, h$1("input", { ref: "inputEl2Ref", type: this.type, class: `${mergedClsPrefix}-input__input-el`, tabindex: this.passivelyActivated && !this.activated ? -1 : void 0, placeholder: this.mergedPlaceholder[1], disabled: this.mergedDisabled, maxlength: countGraphemes ? void 0 : this.maxlength, minlength: countGraphemes ? void 0 : this.minlength, value: Array.isArray(this.mergedValue) ? this.mergedValue[1] : void 0, readonly: this.readonly, style: this.textDecorationStyle[1], onBlur: this.handleInputBlur, onFocus: (e25) => {
      this.handleInputFocus(e25, 1);
    }, onInput: (e25) => {
      this.handleInput(e25, 1);
    }, onChange: (e25) => {
      this.handleChange(e25, 1);
    } }), this.showPlaceholder2 ? h$1("div", { class: `${mergedClsPrefix}-input__placeholder` }, h$1("span", null, this.mergedPlaceholder[1])) : null), resolveWrappedSlot($slots.suffix, (children) => {
      return (this.clearable || children) && h$1("div", { class: `${mergedClsPrefix}-input__suffix` }, [
        this.clearable && h$1(NBaseClear, { clsPrefix: mergedClsPrefix, show: this.showClearButton, onClear: this.handleClear }, {
          icon: () => {
            var _a3;
            return (_a3 = $slots["clear-icon"]) === null || _a3 === void 0 ? void 0 : _a3.call($slots);
          },
          placeholder: () => {
            var _a3;
            return (_a3 = $slots["clear-icon-placeholder"]) === null || _a3 === void 0 ? void 0 : _a3.call($slots);
          }
        }),
        children
      ]);
    })) : null, this.mergedBordered ? h$1("div", { class: `${mergedClsPrefix}-input__border` }) : null, this.mergedBordered ? h$1("div", { class: `${mergedClsPrefix}-input__state-border` }) : null, this.showCount && type4 === "textarea" ? h$1(WordCount, null, {
      default: (props) => {
        var _a3;
        const { renderCount } = this;
        if (renderCount) {
          return renderCount(props);
        }
        return (_a3 = $slots.count) === null || _a3 === void 0 ? void 0 : _a3.call($slots, props);
      }
    }) : null);
  }
});
var style$G = cB$1("input-group", `
 display: inline-flex;
 width: 100%;
 flex-wrap: nowrap;
 vertical-align: bottom;
`, [c$2(">", [cB$1("input", [c$2("&:not(:last-child)", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), c$2("&:not(:first-child)", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 margin-left: -1px!important;
 `)]), cB$1("button", [c$2("&:not(:last-child)", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `, [cE$1("state-border, border", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `)]), c$2("&:not(:first-child)", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `, [cE$1("state-border, border", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `)])]), c$2("*", [c$2("&:not(:last-child)", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `, [c$2(">", [cB$1("input", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), cB$1("base-selection", [cB$1("base-selection-label", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), cB$1("base-selection-tags", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `), cE$1("box-shadow, border, state-border", `
 border-top-right-radius: 0!important;
 border-bottom-right-radius: 0!important;
 `)])])]), c$2("&:not(:first-child)", `
 margin-left: -1px!important;
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `, [c$2(">", [cB$1("input", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `), cB$1("base-selection", [cB$1("base-selection-label", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `), cB$1("base-selection-tags", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `), cE$1("box-shadow, border, state-border", `
 border-top-left-radius: 0!important;
 border-bottom-left-radius: 0!important;
 `)])])])])])]);
const inputGroupProps = {};
var NInputGroup = defineComponent({
  name: "InputGroup",
  props: inputGroupProps,
  setup(props) {
    const { mergedClsPrefixRef } = useConfig(props);
    useStyle("-input-group", style$G, mergedClsPrefixRef);
    return {
      mergedClsPrefix: mergedClsPrefixRef
    };
  },
  render() {
    const { mergedClsPrefix } = this;
    return h$1("div", { class: `${mergedClsPrefix}-input-group` }, this.$slots);
  }
});
var style$F = cB$1("input-group-label", `
 position: relative;
 user-select: none;
 -webkit-user-select: none;
 box-sizing: border-box;
 padding: 0 12px;
 display: inline-block;
 border-radius: var(--n-border-radius);
 background-color: var(--n-group-label-color);
 color: var(--n-group-label-text-color);
 font-size: var(--n-font-size);
 line-height: var(--n-height);
 height: var(--n-height);
 flex-shrink: 0;
 white-space: nowrap;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
`, [cE$1("border", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 border: var(--n-group-label-border);
 transition: border-color .3s var(--n-bezier);
 `)]);
const inputGroupLabelProps = Object.assign(Object.assign({}, useTheme.props), { size: {
  type: String,
  default: "medium"
}, bordered: {
  type: Boolean,
  default: void 0
} });
var NInputGroupLabel = defineComponent({
  name: "InputGroupLabel",
  props: inputGroupLabelProps,
  setup(props) {
    const { mergedBorderedRef, mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Input", "-input-group-label", style$F, inputLight$1, props, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { size: size2 } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { groupLabelColor, borderRadius, groupLabelTextColor, lineHeight: lineHeight2, groupLabelBorder, [createKey("fontSize", size2)]: fontSize2, [createKey("height", size2)]: height } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-group-label-color": groupLabelColor,
        "--n-group-label-border": groupLabelBorder,
        "--n-border-radius": borderRadius,
        "--n-group-label-text-color": groupLabelTextColor,
        "--n-font-size": fontSize2,
        "--n-line-height": lineHeight2,
        "--n-height": height
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("input-group-label", computed(() => props.size[0]), cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      mergedBordered: mergedBorderedRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    var _a2, _b2, _c2;
    const { mergedClsPrefix } = this;
    (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
    return h$1("div", { class: [`${mergedClsPrefix}-input-group-label`, this.themeClass], style: this.cssVars }, (_c2 = (_b2 = this.$slots).default) === null || _c2 === void 0 ? void 0 : _c2.call(_b2), this.mergedBordered ? h$1("div", { class: `${mergedClsPrefix}-input-group-label__border` }) : null);
  }
});
const isImageSupportNativeLazy = isBrowser$2 && "loading" in document.createElement("img");
const resolveOptionsAndHash = (options = {}) => {
  var _a2;
  const { root: root2 = null } = options;
  return {
    hash: `${options.rootMargin || "0px 0px 0px 0px"}-${Array.isArray(options.threshold) ? options.threshold.join(",") : (_a2 = options.threshold) !== null && _a2 !== void 0 ? _a2 : "0"}`,
    options: Object.assign(Object.assign({}, options), { root: (typeof root2 === "string" ? document.querySelector(root2) : root2) || document.documentElement })
  };
};
const observers = new WeakMap();
const unobserveHandleMap = new WeakMap();
const shouldStartLoadingRefMap = new WeakMap();
const observeIntersection = (el2, options, shouldStartLoadingRef) => {
  if (!el2)
    return () => {
    };
  const resolvedOptionsAndHash = resolveOptionsAndHash(options);
  const { root: root2 } = resolvedOptionsAndHash.options;
  let rootObservers;
  const _rootObservers = observers.get(root2);
  if (_rootObservers) {
    rootObservers = _rootObservers;
  } else {
    rootObservers = new Map();
    observers.set(root2, rootObservers);
  }
  let observer;
  let observerAndObservedElements;
  if (rootObservers.has(resolvedOptionsAndHash.hash)) {
    observerAndObservedElements = rootObservers.get(resolvedOptionsAndHash.hash);
    if (!observerAndObservedElements[1].has(el2)) {
      observer = observerAndObservedElements[0];
      observerAndObservedElements[1].add(el2);
      observer.observe(el2);
    }
  } else {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const _unobserve = unobserveHandleMap.get(entry.target);
          const _shouldStartLoadingRef = shouldStartLoadingRefMap.get(entry.target);
          if (_unobserve)
            _unobserve();
          if (_shouldStartLoadingRef) {
            _shouldStartLoadingRef.value = true;
          }
        }
      });
    }, resolvedOptionsAndHash.options);
    observer.observe(el2);
    observerAndObservedElements = [observer, new Set([el2])];
    rootObservers.set(resolvedOptionsAndHash.hash, observerAndObservedElements);
  }
  let unobservered = false;
  const unobserve = () => {
    if (unobservered)
      return;
    unobserveHandleMap.delete(el2);
    shouldStartLoadingRefMap.delete(el2);
    unobservered = true;
    if (observerAndObservedElements[1].has(el2)) {
      observerAndObservedElements[0].unobserve(el2);
      observerAndObservedElements[1].delete(el2);
    }
    if (observerAndObservedElements[1].size <= 0) {
      rootObservers.delete(resolvedOptionsAndHash.hash);
    }
    if (!rootObservers.size) {
      observers.delete(root2);
    }
  };
  unobserveHandleMap.set(el2, unobserve);
  shouldStartLoadingRefMap.set(el2, shouldStartLoadingRef);
  return unobserve;
};
const self$C = (vars) => {
  const { borderRadius, avatarColor, cardColor, fontSize: fontSize2, heightTiny, heightSmall, heightMedium, heightLarge, heightHuge, modalColor, popoverColor } = vars;
  return {
    borderRadius,
    fontSize: fontSize2,
    border: `2px solid ${cardColor}`,
    heightTiny,
    heightSmall,
    heightMedium,
    heightLarge,
    heightHuge,
    color: composite(cardColor, avatarColor),
    colorModal: composite(modalColor, avatarColor),
    colorPopover: composite(popoverColor, avatarColor)
  };
};
const avatarLight = {
  name: "Avatar",
  common: commonLight,
  self: self$C
};
var avatarLight$1 = avatarLight;
const avatarGroupInjectionKey = createInjectionKey("n-avatar-group");
var style$E = cB$1("avatar", `
 width: var(--n-merged-size);
 height: var(--n-merged-size);
 color: #FFF;
 font-size: var(--n-font-size);
 display: inline-flex;
 position: relative;
 overflow: hidden;
 text-align: center;
 border: var(--n-border);
 border-radius: var(--n-border-radius);
 --n-merged-color: var(--n-color);
 background-color: var(--n-merged-color);
 transition:
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
`, [insideModal(c$2("&", "--n-merged-color: var(--n-color-modal);")), insidePopover(c$2("&", "--n-merged-color: var(--n-color-popover);")), c$2("img", `
 width: 100%;
 height: 100%;
 `), cE$1("text", `
 white-space: nowrap;
 display: inline-block;
 position: absolute;
 left: 50%;
 top: 50%;
 `), cB$1("icon", `
 vertical-align: bottom;
 font-size: calc(var(--n-merged-size) - 6px);
 `), cE$1("text", "line-height: 1.25")]);
const avatarProps = Object.assign(Object.assign({}, useTheme.props), {
  size: [String, Number],
  src: String,
  circle: {
    type: Boolean,
    default: void 0
  },
  objectFit: String,
  round: {
    type: Boolean,
    default: void 0
  },
  bordered: {
    type: Boolean,
    default: void 0
  },
  onError: Function,
  fallbackSrc: String,
  intersectionObserverOptions: Object,
  lazy: Boolean,
  onLoad: Function,
  renderPlaceholder: Function,
  renderFallback: Function,
  imgProps: Object,
  color: String
});
var NAvatar = defineComponent({
  name: "Avatar",
  props: avatarProps,
  setup(props) {
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const hasLoadErrorRef = ref(false);
    let memoedTextHtml = null;
    const textRef = ref(null);
    const selfRef = ref(null);
    const fitTextTransform = () => {
      const { value: textEl } = textRef;
      if (textEl) {
        if (memoedTextHtml === null || memoedTextHtml !== textEl.innerHTML) {
          memoedTextHtml = textEl.innerHTML;
          const { value: selfEl } = selfRef;
          if (selfEl) {
            const { offsetWidth: elWidth, offsetHeight: elHeight } = selfEl;
            const { offsetWidth: textWidth, offsetHeight: textHeight } = textEl;
            const radix = 0.9;
            const ratio = Math.min(elWidth / textWidth * radix, elHeight / textHeight * radix, 1);
            textEl.style.transform = `translateX(-50%) translateY(-50%) scale(${ratio})`;
          }
        }
      }
    };
    const NAvatarGroup2 = inject(avatarGroupInjectionKey, null);
    const mergedSizeRef = computed(() => {
      const { size: size2 } = props;
      if (size2)
        return size2;
      const { size: avatarGroupSize } = NAvatarGroup2 || {};
      if (avatarGroupSize)
        return avatarGroupSize;
      return "medium";
    });
    const themeRef = useTheme("Avatar", "-avatar", style$E, avatarLight$1, props, mergedClsPrefixRef);
    const TagInjection = inject(tagInjectionKey, null);
    const mergedRoundRef = computed(() => {
      if (NAvatarGroup2)
        return true;
      const { round, circle } = props;
      if (round !== void 0 || circle !== void 0)
        return round || circle;
      if (TagInjection) {
        return TagInjection.roundRef.value;
      }
      return false;
    });
    const mergedBorderedRef = computed(() => {
      if (NAvatarGroup2)
        return true;
      return props.bordered || false;
    });
    const handleError = (e25) => {
      var _a2;
      if (!shouldStartLoadingRef.value)
        return;
      hasLoadErrorRef.value = true;
      const { onError, imgProps } = props;
      (_a2 = imgProps === null || imgProps === void 0 ? void 0 : imgProps.onError) === null || _a2 === void 0 ? void 0 : _a2.call(imgProps, e25);
      if (onError) {
        onError(e25);
      }
    };
    watch(() => props.src, () => hasLoadErrorRef.value = false);
    const cssVarsRef = computed(() => {
      const size2 = mergedSizeRef.value;
      const round = mergedRoundRef.value;
      const bordered = mergedBorderedRef.value;
      const { color: propColor } = props;
      const { self: { borderRadius, fontSize: fontSize2, color, border, colorModal, colorPopover }, common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 } } = themeRef.value;
      let height;
      if (typeof size2 === "number") {
        height = `${size2}px`;
      } else {
        height = themeRef.value.self[createKey("height", size2)];
      }
      return {
        "--n-font-size": fontSize2,
        "--n-border": bordered ? border : "none",
        "--n-border-radius": round ? "50%" : borderRadius,
        "--n-color": propColor || color,
        "--n-color-modal": propColor || colorModal,
        "--n-color-popover": propColor || colorPopover,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-merged-size": `var(--n-avatar-size-override, ${height})`
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("avatar", computed(() => {
      const size2 = mergedSizeRef.value;
      const round = mergedRoundRef.value;
      const bordered = mergedBorderedRef.value;
      const { color } = props;
      let hash2 = "";
      if (size2) {
        if (typeof size2 === "number") {
          hash2 += `a${size2}`;
        } else {
          hash2 += size2[0];
        }
      }
      if (round) {
        hash2 += "b";
      }
      if (bordered) {
        hash2 += "c";
      }
      if (color) {
        hash2 += color2Class(color);
      }
      return hash2;
    }), cssVarsRef, props) : void 0;
    const shouldStartLoadingRef = ref(!props.lazy);
    onMounted(() => {
      if (isImageSupportNativeLazy) {
        return;
      }
      let unobserve;
      const stopWatchHandle = watchEffect(() => {
        unobserve === null || unobserve === void 0 ? void 0 : unobserve();
        unobserve = void 0;
        if (props.lazy) {
          unobserve = observeIntersection(selfRef.value, props.intersectionObserverOptions, shouldStartLoadingRef);
        }
      });
      onBeforeUnmount(() => {
        stopWatchHandle();
        unobserve === null || unobserve === void 0 ? void 0 : unobserve();
      });
    });
    const loadedRef = ref(!props.lazy);
    return {
      textRef,
      selfRef,
      mergedRoundRef,
      mergedClsPrefix: mergedClsPrefixRef,
      fitTextTransform,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender,
      hasLoadError: hasLoadErrorRef,
      handleError,
      shouldStartLoading: shouldStartLoadingRef,
      loaded: loadedRef,
      mergedOnLoad: (e25) => {
        var _a2;
        const { onLoad, imgProps } = props;
        onLoad === null || onLoad === void 0 ? void 0 : onLoad(e25);
        (_a2 = imgProps === null || imgProps === void 0 ? void 0 : imgProps.onLoad) === null || _a2 === void 0 ? void 0 : _a2.call(imgProps, e25);
        loadedRef.value = true;
      }
    };
  },
  render() {
    var _a2, _b2;
    const { $slots, src, mergedClsPrefix, lazy, onRender, mergedOnLoad, shouldStartLoading, loaded, hasLoadError } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    let img;
    const placeholderNode = !loaded && !hasLoadError && (this.renderPlaceholder ? this.renderPlaceholder() : (_b2 = (_a2 = this.$slots).placeholder) === null || _b2 === void 0 ? void 0 : _b2.call(_a2));
    if (this.hasLoadError) {
      img = this.renderFallback ? this.renderFallback() : resolveSlot($slots.fallback, () => [
        h$1("img", { src: this.fallbackSrc, style: { objectFit: this.objectFit } })
      ]);
    } else {
      img = resolveWrappedSlot($slots.default, (children) => {
        if (children) {
          return h$1(VResizeObserver, { onResize: this.fitTextTransform }, {
            default: () => h$1("span", { ref: "textRef", class: `${mergedClsPrefix}-avatar__text` }, children)
          });
        } else if (src) {
          const { imgProps } = this;
          return h$1("img", Object.assign(Object.assign({}, imgProps), { loading: isImageSupportNativeLazy && !this.intersectionObserverOptions && lazy ? "lazy" : "eager", src: isImageSupportNativeLazy ? src : shouldStartLoading || loaded ? src : void 0, onLoad: mergedOnLoad, "data-image-src": src, onError: this.handleError, style: [
            imgProps === null || imgProps === void 0 ? void 0 : imgProps.style,
            { objectFit: this.objectFit },
            placeholderNode ? {
              height: "0",
              width: "0",
              visibility: "hidden",
              position: "absolute"
            } : ""
          ] }));
        }
      });
    }
    return h$1("span", { ref: "selfRef", class: [`${mergedClsPrefix}-avatar`, this.themeClass], style: this.cssVars }, img, lazy && placeholderNode);
  }
});
var style$D = cB$1("avatar-group", `
 flex-wrap: nowrap;
 display: inline-flex;
 position: relative;
`, [cNotM("vertical", {
  flexDirection: "row"
}, [cB$1("avatar", [c$2("&:not(:first-child)", `
 margin-left: var(--n-gap);
 `)])]), cM("vertical", {
  flexDirection: "column"
}, [cB$1("avatar", [c$2("&:not(:first-child)", `
 margin-top: var(--n-gap);
 `)])])]);
const self$B = () => {
  return {
    gap: "-12px"
  };
};
const avatarGroupLight = createTheme({
  name: "AvatarGroup",
  common: commonLight,
  peers: {
    Avatar: avatarLight$1
  },
  self: self$B
});
var avatarGroupLight$1 = avatarGroupLight;
const avatarGroupProps = Object.assign(Object.assign({}, useTheme.props), { max: Number, maxStyle: [Object, String], options: {
  type: Array,
  default: () => []
}, vertical: Boolean, size: [String, Number] });
var NAvatarGroup = defineComponent({
  name: "AvatarGroup",
  props: avatarGroupProps,
  setup(props) {
    const { mergedClsPrefixRef, mergedRtlRef } = useConfig(props);
    const mergedThemeRef = useTheme("AvatarGroup", "-avatar-group", style$D, avatarGroupLight$1, props, mergedClsPrefixRef);
    provide(avatarGroupInjectionKey, props);
    const rtlEnabledRef = useRtl("AvatarGroup", mergedRtlRef, mergedClsPrefixRef);
    const restOptionsRef = computed(() => {
      const { max } = props;
      if (max === void 0)
        return void 0;
      const { options } = props;
      if (options.length > max)
        return options.slice(max - 1, options.length);
      return [];
    });
    const displayedOptionsRef = computed(() => {
      const { options, max } = props;
      if (max === void 0)
        return options;
      if (options.length > max)
        return options.slice(0, max - 1);
      if (options.length === max)
        return options.slice(0, max);
      return options;
    });
    return {
      mergedTheme: mergedThemeRef,
      rtlEnabled: rtlEnabledRef,
      mergedClsPrefix: mergedClsPrefixRef,
      restOptions: restOptionsRef,
      displayedOptions: displayedOptionsRef,
      cssVars: computed(() => {
        return {
          "--n-gap": mergedThemeRef.value.self.gap
        };
      })
    };
  },
  render() {
    const { mergedClsPrefix, displayedOptions, restOptions, mergedTheme, $slots } = this;
    return h$1("div", { class: [
      `${mergedClsPrefix}-avatar-group`,
      this.rtlEnabled && `${mergedClsPrefix}-avatar-group--rtl`,
      this.vertical && `${mergedClsPrefix}-avatar-group--vertical`
    ], style: this.cssVars, role: "group" }, displayedOptions.map((option) => {
      return $slots.avatar ? $slots.avatar({ option }) : h$1(NAvatar, { src: option.src, theme: mergedTheme.peers.Avatar, themeOverrides: mergedTheme.peerOverrides.Avatar });
    }), restOptions !== void 0 && restOptions.length > 0 && ($slots.rest ? $slots.rest({ options: restOptions, rest: restOptions.length }) : h$1(NAvatar, { style: this.maxStyle, theme: mergedTheme.peers.Avatar, themeOverrides: mergedTheme.peerOverrides.Avatar }, {
      default: () => `+${restOptions.length}`
    })));
  }
});
const self$A = (vars) => {
  const { errorColor, infoColor, successColor, warningColor, fontFamily: fontFamily2 } = vars;
  return {
    color: errorColor,
    colorInfo: infoColor,
    colorSuccess: successColor,
    colorError: errorColor,
    colorWarning: warningColor,
    fontSize: "12px",
    fontFamily: fontFamily2
  };
};
const badgeLight = {
  name: "Badge",
  common: commonLight,
  self: self$A
};
var badgeLight$1 = badgeLight;
var style$C = c$2([c$2("@keyframes badge-wave-spread", {
  from: {
    boxShadow: "0 0 0.5px 0px var(--n-ripple-color)",
    opacity: 0.6
  },
  to: {
    boxShadow: "0 0 0.5px 4.5px var(--n-ripple-color)",
    opacity: 0
  }
}), cB$1("badge", `
 display: inline-flex;
 position: relative;
 vertical-align: middle;
 color: var(--n-color);
 font-family: var(--n-font-family);
 `, [cM("as-is", [cB$1("badge-sup", {
  position: "static",
  transform: "translateX(0)"
}, [fadeInScaleUpTransition({
  transformOrigin: "left bottom",
  originalTransform: "translateX(0)"
})])]), cM("dot", [cB$1("badge-sup", `
 height: 8px;
 width: 8px;
 padding: 0;
 min-width: 8px;
 left: 100%;
 bottom: calc(100% - 4px);
 `, [c$2("::before", "border-radius: 4px;")])]), cB$1("badge-sup", `
 background: var(--n-color);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 color: #FFF;
 position: absolute;
 height: 18px;
 line-height: 18px;
 border-radius: 9px;
 padding: 0 6px;
 text-align: center;
 font-size: var(--n-font-size);
 transform: translateX(-50%);
 left: 100%;
 bottom: calc(100% - 9px);
 font-variant-numeric: tabular-nums;
 z-index: 1;
 display: flex;
 align-items: center;
 `, [fadeInScaleUpTransition({
  transformOrigin: "left bottom",
  originalTransform: "translateX(-50%)"
}), cB$1("base-wave", {
  zIndex: 1,
  animationDuration: "2s",
  animationIterationCount: "infinite",
  animationDelay: "1s",
  animationTimingFunction: "var(--n-ripple-bezier)",
  animationName: "badge-wave-spread"
}), c$2("&::before", `
 opacity: 0;
 transform: scale(1);
 border-radius: 9px;
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)])])]);
const badgeProps = Object.assign(Object.assign({}, useTheme.props), { value: [String, Number], max: Number, dot: Boolean, type: {
  type: String,
  default: "default"
}, show: {
  type: Boolean,
  default: true
}, showZero: Boolean, processing: Boolean, color: String, offset: Array });
var NBadge = defineComponent({
  name: "Badge",
  props: badgeProps,
  setup(props, { slots }) {
    const { mergedClsPrefixRef, inlineThemeDisabled, mergedRtlRef } = useConfig(props);
    const themeRef = useTheme("Badge", "-badge", style$C, badgeLight$1, props, mergedClsPrefixRef);
    const appearedRef = ref(false);
    const handleAfterEnter = () => {
      appearedRef.value = true;
    };
    const handleAfterLeave = () => {
      appearedRef.value = false;
    };
    const showBadgeRef = computed(() => {
      return props.show && (props.dot || props.value !== void 0 && !(!props.showZero && Number(props.value) <= 0) || !isSlotEmpty(slots.value));
    });
    onMounted(() => {
      if (showBadgeRef.value)
        appearedRef.value = true;
    });
    const rtlEnabledRef = useRtl("Badge", mergedRtlRef, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { type: type4, color: propColor } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2, cubicBezierEaseOut: cubicBezierEaseOut2 }, self: { [createKey("color", type4)]: color, fontFamily: fontFamily2, fontSize: fontSize2 } } = themeRef.value;
      return {
        "--n-font-size": fontSize2,
        "--n-font-family": fontFamily2,
        "--n-color": propColor || color,
        "--n-ripple-color": propColor || color,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-ripple-bezier": cubicBezierEaseOut2
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("badge", computed(() => {
      let hash2 = "";
      const { type: type4, color } = props;
      if (type4) {
        hash2 += type4[0];
      }
      if (color) {
        hash2 += color2Class(color);
      }
      return hash2;
    }), cssVarsRef, props) : void 0;
    const offsetStyleRef = computed(() => {
      const { offset } = props;
      if (!offset)
        return void 0;
      const [x2, y2] = offset;
      const reslovedOffsetX = typeof x2 === "number" ? `${x2}px` : x2;
      const reslovedOffsetY = typeof y2 === "number" ? `${y2}px` : y2;
      return {
        transform: `translate(calc(${(rtlEnabledRef === null || rtlEnabledRef === void 0 ? void 0 : rtlEnabledRef.value) ? "50%" : "-50%"} + ${reslovedOffsetX}), ${reslovedOffsetY})`
      };
    });
    return {
      rtlEnabled: rtlEnabledRef,
      mergedClsPrefix: mergedClsPrefixRef,
      appeared: appearedRef,
      showBadge: showBadgeRef,
      handleAfterEnter,
      handleAfterLeave,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender,
      offsetStyle: offsetStyleRef
    };
  },
  render() {
    var _a2;
    const { mergedClsPrefix, onRender, themeClass, $slots } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    const children = (_a2 = $slots.default) === null || _a2 === void 0 ? void 0 : _a2.call($slots);
    return h$1("div", { class: [
      `${mergedClsPrefix}-badge`,
      this.rtlEnabled && `${mergedClsPrefix}-badge--rtl`,
      themeClass,
      {
        [`${mergedClsPrefix}-badge--dot`]: this.dot,
        [`${mergedClsPrefix}-badge--as-is`]: !children
      }
    ], style: this.cssVars }, children, h$1(Transition, { name: "fade-in-scale-up-transition", onAfterEnter: this.handleAfterEnter, onAfterLeave: this.handleAfterLeave }, {
      default: () => this.showBadge ? h$1("sup", { class: `${mergedClsPrefix}-badge-sup`, title: getTitleAttribute(this.value), style: this.offsetStyle }, resolveSlot($slots.value, () => [
        !this.dot ? h$1(NBaseSlotMachine, { clsPrefix: mergedClsPrefix, appeared: this.appeared, max: this.max, value: this.value }) : null
      ]), this.processing ? h$1(NBaseWave, { clsPrefix: mergedClsPrefix }) : null) : null
    }));
  }
});
var commonVariables$9 = {
  fontWeightActive: "400"
};
const self$z = (vars) => {
  const { fontSize: fontSize2, textColor3, textColor2, borderRadius, buttonColor2Hover, buttonColor2Pressed } = vars;
  return Object.assign(Object.assign({}, commonVariables$9), { fontSize: fontSize2, itemLineHeight: "1.25", itemTextColor: textColor3, itemTextColorHover: textColor2, itemTextColorPressed: textColor2, itemTextColorActive: textColor2, itemBorderRadius: borderRadius, itemColorHover: buttonColor2Hover, itemColorPressed: buttonColor2Pressed, separatorColor: textColor3 });
};
const breadcrumbLight = {
  name: "Breadcrumb",
  common: commonLight,
  self: self$z
};
var breadcrumbLight$1 = breadcrumbLight;
var style$B = cB$1("breadcrumb", `
 white-space: nowrap;
 cursor: default;
 line-height: var(--n-item-line-height);
`, [c$2("ul", `
 list-style: none;
 padding: 0;
 margin: 0;
 `), c$2("a", `
 color: inherit;
 text-decoration: inherit;
 `), cB$1("breadcrumb-item", `
 font-size: var(--n-font-size);
 transition: color .3s var(--n-bezier);
 display: inline-flex;
 align-items: center;
 `, [cB$1("icon", `
 font-size: 18px;
 vertical-align: -.2em;
 transition: color .3s var(--n-bezier);
 color: var(--n-item-text-color);
 `), c$2("&:not(:last-child)", [cM("clickable", [cE$1("link", `
 cursor: pointer;
 `, [c$2("&:hover", `
 background-color: var(--n-item-color-hover);
 `), c$2("&:active", `
 background-color: var(--n-item-color-pressed); 
 `)])])]), cE$1("link", `
 padding: 4px;
 border-radius: var(--n-item-border-radius);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 color: var(--n-item-text-color);
 position: relative;
 `, [c$2("&:hover", `
 color: var(--n-item-text-color-hover);
 `, [cB$1("icon", `
 color: var(--n-item-text-color-hover);
 `)]), c$2("&:active", `
 color: var(--n-item-text-color-pressed);
 `, [cB$1("icon", `
 color: var(--n-item-text-color-pressed);
 `)])]), cE$1("separator", `
 margin: 0 8px;
 color: var(--n-separator-color);
 transition: color .3s var(--n-bezier);
 user-select: none;
 -webkit-user-select: none;
 `), c$2("&:last-child", [cE$1("link", `
 font-weight: var(--n-font-weight-active);
 cursor: unset;
 color: var(--n-item-text-color-active);
 `, [cB$1("icon", `
 color: var(--n-item-text-color-active);
 `)]), cE$1("separator", `
 display: none;
 `)])])]);
const breadcrumbInjectionKey = createInjectionKey("n-breadcrumb");
const breadcrumbProps = Object.assign(Object.assign({}, useTheme.props), { separator: {
  type: String,
  default: "/"
} });
var NBreadcrumb = defineComponent({
  name: "Breadcrumb",
  props: breadcrumbProps,
  setup(props) {
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Breadcrumb", "-breadcrumb", style$B, breadcrumbLight$1, props, mergedClsPrefixRef);
    provide(breadcrumbInjectionKey, {
      separatorRef: toRef(props, "separator"),
      mergedClsPrefixRef
    });
    const cssVarsRef = computed(() => {
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { separatorColor, itemTextColor, itemTextColorHover, itemTextColorPressed, itemTextColorActive, fontSize: fontSize2, fontWeightActive, itemBorderRadius, itemColorHover, itemColorPressed, itemLineHeight } } = themeRef.value;
      return {
        "--n-font-size": fontSize2,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-item-text-color": itemTextColor,
        "--n-item-text-color-hover": itemTextColorHover,
        "--n-item-text-color-pressed": itemTextColorPressed,
        "--n-item-text-color-active": itemTextColorActive,
        "--n-separator-color": separatorColor,
        "--n-item-color-hover": itemColorHover,
        "--n-item-color-pressed": itemColorPressed,
        "--n-item-border-radius": itemBorderRadius,
        "--n-font-weight-active": fontWeightActive,
        "--n-item-line-height": itemLineHeight
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("breadcrumb", void 0, cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    var _a2;
    (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
    return h$1("nav", { class: [`${this.mergedClsPrefix}-breadcrumb`, this.themeClass], style: this.cssVars, "aria-label": "Breadcrumb" }, h$1("ul", null, this.$slots));
  }
});
const useBrowserLocation = (customWindow = isBrowser$2 ? window : null) => {
  const getWindowLocation = () => {
    const { hash: hash2, host, hostname, href, origin, pathname, port, protocol, search } = (customWindow === null || customWindow === void 0 ? void 0 : customWindow.location) || {};
    return {
      hash: hash2,
      host,
      hostname,
      href,
      origin,
      pathname,
      port,
      protocol,
      search
    };
  };
  const updateLocation = () => {
    locationState.value = getWindowLocation();
  };
  const locationState = ref(getWindowLocation());
  onMounted(() => {
    if (customWindow) {
      customWindow.addEventListener("popstate", updateLocation);
      customWindow.addEventListener("hashchange", updateLocation);
    }
  });
  onUnmounted(() => {
    if (customWindow) {
      customWindow.removeEventListener("popstate", updateLocation);
      customWindow.removeEventListener("hashchange", updateLocation);
    }
  });
  return locationState;
};
const breadcrumbItemProps = {
  separator: String,
  href: String,
  clickable: {
    type: Boolean,
    default: true
  },
  onClick: Function
};
var NBreadcrumbItem = defineComponent({
  name: "BreadcrumbItem",
  props: breadcrumbItemProps,
  setup(props, { slots }) {
    const NBreadcrumb2 = inject(breadcrumbInjectionKey, null);
    if (!NBreadcrumb2) {
      return () => null;
    }
    const { separatorRef, mergedClsPrefixRef } = NBreadcrumb2;
    const browserLocationRef = useBrowserLocation();
    const htmlTagRef = computed(() => props.href ? "a" : "span");
    const ariaCurrentRef = computed(() => browserLocationRef.value.href === props.href ? "location" : null);
    return () => {
      const { value: mergedClsPrefix } = mergedClsPrefixRef;
      return h$1("li", { class: [
        `${mergedClsPrefix}-breadcrumb-item`,
        props.clickable && `${mergedClsPrefix}-breadcrumb-item--clickable`
      ] }, h$1(htmlTagRef.value, {
        class: `${mergedClsPrefix}-breadcrumb-item__link`,
        "aria-current": ariaCurrentRef.value,
        href: props.href,
        onClick: props.onClick
      }, slots), h$1("span", { class: `${mergedClsPrefix}-breadcrumb-item__separator`, "aria-hidden": "true" }, resolveSlot(slots.separator, () => {
        var _a2;
        return [
          (_a2 = props.separator) !== null && _a2 !== void 0 ? _a2 : separatorRef.value
        ];
      })));
    };
  }
});
function createHoverColor(rgb) {
  return composite(rgb, [255, 255, 255, 0.16]);
}
function createPressedColor(rgb) {
  return composite(rgb, [0, 0, 0, 0.12]);
}
const buttonGroupInjectionKey = createInjectionKey("n-button-group");
var commonVariables$8 = {
  paddingTiny: "0 6px",
  paddingSmall: "0 10px",
  paddingMedium: "0 14px",
  paddingLarge: "0 18px",
  paddingRoundTiny: "0 10px",
  paddingRoundSmall: "0 14px",
  paddingRoundMedium: "0 18px",
  paddingRoundLarge: "0 22px",
  iconMarginTiny: "6px",
  iconMarginSmall: "6px",
  iconMarginMedium: "6px",
  iconMarginLarge: "6px",
  iconSizeTiny: "14px",
  iconSizeSmall: "18px",
  iconSizeMedium: "18px",
  iconSizeLarge: "20px",
  rippleDuration: ".6s"
};
const self$y = (vars) => {
  const { heightTiny, heightSmall, heightMedium, heightLarge, borderRadius, fontSizeTiny, fontSizeSmall, fontSizeMedium, fontSizeLarge, opacityDisabled, textColor2, textColor3, primaryColorHover, primaryColorPressed, borderColor, primaryColor, baseColor, infoColor, infoColorHover, infoColorPressed, successColor, successColorHover, successColorPressed, warningColor, warningColorHover, warningColorPressed, errorColor, errorColorHover, errorColorPressed, fontWeight, buttonColor2, buttonColor2Hover, buttonColor2Pressed, fontWeightStrong } = vars;
  return Object.assign(Object.assign({}, commonVariables$8), {
    heightTiny,
    heightSmall,
    heightMedium,
    heightLarge,
    borderRadiusTiny: borderRadius,
    borderRadiusSmall: borderRadius,
    borderRadiusMedium: borderRadius,
    borderRadiusLarge: borderRadius,
    fontSizeTiny,
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    opacityDisabled,
    colorOpacitySecondary: "0.16",
    colorOpacitySecondaryHover: "0.22",
    colorOpacitySecondaryPressed: "0.28",
    colorSecondary: buttonColor2,
    colorSecondaryHover: buttonColor2Hover,
    colorSecondaryPressed: buttonColor2Pressed,
    colorTertiary: buttonColor2,
    colorTertiaryHover: buttonColor2Hover,
    colorTertiaryPressed: buttonColor2Pressed,
    colorQuaternary: "#0000",
    colorQuaternaryHover: buttonColor2Hover,
    colorQuaternaryPressed: buttonColor2Pressed,
    color: "#0000",
    colorHover: "#0000",
    colorPressed: "#0000",
    colorFocus: "#0000",
    colorDisabled: "#0000",
    textColor: textColor2,
    textColorTertiary: textColor3,
    textColorHover: primaryColorHover,
    textColorPressed: primaryColorPressed,
    textColorFocus: primaryColorHover,
    textColorDisabled: textColor2,
    textColorText: textColor2,
    textColorTextHover: primaryColorHover,
    textColorTextPressed: primaryColorPressed,
    textColorTextFocus: primaryColorHover,
    textColorTextDisabled: textColor2,
    textColorGhost: textColor2,
    textColorGhostHover: primaryColorHover,
    textColorGhostPressed: primaryColorPressed,
    textColorGhostFocus: primaryColorHover,
    textColorGhostDisabled: textColor2,
    border: `1px solid ${borderColor}`,
    borderHover: `1px solid ${primaryColorHover}`,
    borderPressed: `1px solid ${primaryColorPressed}`,
    borderFocus: `1px solid ${primaryColorHover}`,
    borderDisabled: `1px solid ${borderColor}`,
    rippleColor: primaryColor,
    colorPrimary: primaryColor,
    colorHoverPrimary: primaryColorHover,
    colorPressedPrimary: primaryColorPressed,
    colorFocusPrimary: primaryColorHover,
    colorDisabledPrimary: primaryColor,
    textColorPrimary: baseColor,
    textColorHoverPrimary: baseColor,
    textColorPressedPrimary: baseColor,
    textColorFocusPrimary: baseColor,
    textColorDisabledPrimary: baseColor,
    textColorTextPrimary: primaryColor,
    textColorTextHoverPrimary: primaryColorHover,
    textColorTextPressedPrimary: primaryColorPressed,
    textColorTextFocusPrimary: primaryColorHover,
    textColorTextDisabledPrimary: textColor2,
    textColorGhostPrimary: primaryColor,
    textColorGhostHoverPrimary: primaryColorHover,
    textColorGhostPressedPrimary: primaryColorPressed,
    textColorGhostFocusPrimary: primaryColorHover,
    textColorGhostDisabledPrimary: primaryColor,
    borderPrimary: `1px solid ${primaryColor}`,
    borderHoverPrimary: `1px solid ${primaryColorHover}`,
    borderPressedPrimary: `1px solid ${primaryColorPressed}`,
    borderFocusPrimary: `1px solid ${primaryColorHover}`,
    borderDisabledPrimary: `1px solid ${primaryColor}`,
    rippleColorPrimary: primaryColor,
    colorInfo: infoColor,
    colorHoverInfo: infoColorHover,
    colorPressedInfo: infoColorPressed,
    colorFocusInfo: infoColorHover,
    colorDisabledInfo: infoColor,
    textColorInfo: baseColor,
    textColorHoverInfo: baseColor,
    textColorPressedInfo: baseColor,
    textColorFocusInfo: baseColor,
    textColorDisabledInfo: baseColor,
    textColorTextInfo: infoColor,
    textColorTextHoverInfo: infoColorHover,
    textColorTextPressedInfo: infoColorPressed,
    textColorTextFocusInfo: infoColorHover,
    textColorTextDisabledInfo: textColor2,
    textColorGhostInfo: infoColor,
    textColorGhostHoverInfo: infoColorHover,
    textColorGhostPressedInfo: infoColorPressed,
    textColorGhostFocusInfo: infoColorHover,
    textColorGhostDisabledInfo: infoColor,
    borderInfo: `1px solid ${infoColor}`,
    borderHoverInfo: `1px solid ${infoColorHover}`,
    borderPressedInfo: `1px solid ${infoColorPressed}`,
    borderFocusInfo: `1px solid ${infoColorHover}`,
    borderDisabledInfo: `1px solid ${infoColor}`,
    rippleColorInfo: infoColor,
    colorSuccess: successColor,
    colorHoverSuccess: successColorHover,
    colorPressedSuccess: successColorPressed,
    colorFocusSuccess: successColorHover,
    colorDisabledSuccess: successColor,
    textColorSuccess: baseColor,
    textColorHoverSuccess: baseColor,
    textColorPressedSuccess: baseColor,
    textColorFocusSuccess: baseColor,
    textColorDisabledSuccess: baseColor,
    textColorTextSuccess: successColor,
    textColorTextHoverSuccess: successColorHover,
    textColorTextPressedSuccess: successColorPressed,
    textColorTextFocusSuccess: successColorHover,
    textColorTextDisabledSuccess: textColor2,
    textColorGhostSuccess: successColor,
    textColorGhostHoverSuccess: successColorHover,
    textColorGhostPressedSuccess: successColorPressed,
    textColorGhostFocusSuccess: successColorHover,
    textColorGhostDisabledSuccess: successColor,
    borderSuccess: `1px solid ${successColor}`,
    borderHoverSuccess: `1px solid ${successColorHover}`,
    borderPressedSuccess: `1px solid ${successColorPressed}`,
    borderFocusSuccess: `1px solid ${successColorHover}`,
    borderDisabledSuccess: `1px solid ${successColor}`,
    rippleColorSuccess: successColor,
    colorWarning: warningColor,
    colorHoverWarning: warningColorHover,
    colorPressedWarning: warningColorPressed,
    colorFocusWarning: warningColorHover,
    colorDisabledWarning: warningColor,
    textColorWarning: baseColor,
    textColorHoverWarning: baseColor,
    textColorPressedWarning: baseColor,
    textColorFocusWarning: baseColor,
    textColorDisabledWarning: baseColor,
    textColorTextWarning: warningColor,
    textColorTextHoverWarning: warningColorHover,
    textColorTextPressedWarning: warningColorPressed,
    textColorTextFocusWarning: warningColorHover,
    textColorTextDisabledWarning: textColor2,
    textColorGhostWarning: warningColor,
    textColorGhostHoverWarning: warningColorHover,
    textColorGhostPressedWarning: warningColorPressed,
    textColorGhostFocusWarning: warningColorHover,
    textColorGhostDisabledWarning: warningColor,
    borderWarning: `1px solid ${warningColor}`,
    borderHoverWarning: `1px solid ${warningColorHover}`,
    borderPressedWarning: `1px solid ${warningColorPressed}`,
    borderFocusWarning: `1px solid ${warningColorHover}`,
    borderDisabledWarning: `1px solid ${warningColor}`,
    rippleColorWarning: warningColor,
    colorError: errorColor,
    colorHoverError: errorColorHover,
    colorPressedError: errorColorPressed,
    colorFocusError: errorColorHover,
    colorDisabledError: errorColor,
    textColorError: baseColor,
    textColorHoverError: baseColor,
    textColorPressedError: baseColor,
    textColorFocusError: baseColor,
    textColorDisabledError: baseColor,
    textColorTextError: errorColor,
    textColorTextHoverError: errorColorHover,
    textColorTextPressedError: errorColorPressed,
    textColorTextFocusError: errorColorHover,
    textColorTextDisabledError: textColor2,
    textColorGhostError: errorColor,
    textColorGhostHoverError: errorColorHover,
    textColorGhostPressedError: errorColorPressed,
    textColorGhostFocusError: errorColorHover,
    textColorGhostDisabledError: errorColor,
    borderError: `1px solid ${errorColor}`,
    borderHoverError: `1px solid ${errorColorHover}`,
    borderPressedError: `1px solid ${errorColorPressed}`,
    borderFocusError: `1px solid ${errorColorHover}`,
    borderDisabledError: `1px solid ${errorColor}`,
    rippleColorError: errorColor,
    waveOpacity: "0.6",
    fontWeight,
    fontWeightStrong
  });
};
const buttonLight = {
  name: "Button",
  common: commonLight,
  self: self$y
};
var buttonLight$1 = buttonLight;
var style$A = c$2([cB$1("button", `
 margin: 0;
 font-weight: var(--n-font-weight);
 line-height: 1;
 font-family: inherit;
 padding: var(--n-padding);
 height: var(--n-height);
 font-size: var(--n-font-size);
 border-radius: var(--n-border-radius);
 color: var(--n-text-color);
 background-color: var(--n-color);
 width: var(--n-width);
 white-space: nowrap;
 outline: none;
 position: relative;
 z-index: auto;
 border: none;
 display: inline-flex;
 flex-wrap: nowrap;
 flex-shrink: 0;
 align-items: center;
 justify-content: center;
 user-select: none;
 -webkit-user-select: none;
 text-align: center;
 cursor: pointer;
 text-decoration: none;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [cM("color", [cE$1("border", {
  borderColor: "var(--n-border-color)"
}), cM("disabled", [cE$1("border", {
  borderColor: "var(--n-border-color-disabled)"
})]), cNotM("disabled", [c$2("&:focus", [cE$1("state-border", {
  borderColor: "var(--n-border-color-focus)"
})]), c$2("&:hover", [cE$1("state-border", {
  borderColor: "var(--n-border-color-hover)"
})]), c$2("&:active", [cE$1("state-border", {
  borderColor: "var(--n-border-color-pressed)"
})]), cM("pressed", [cE$1("state-border", {
  borderColor: "var(--n-border-color-pressed)"
})])])]), cM("disabled", {
  backgroundColor: "var(--n-color-disabled)",
  color: "var(--n-text-color-disabled)"
}, [cE$1("border", {
  border: "var(--n-border-disabled)"
})]), cNotM("disabled", [c$2("&:focus", {
  backgroundColor: "var(--n-color-focus)",
  color: "var(--n-text-color-focus)"
}, [cE$1("state-border", {
  border: "var(--n-border-focus)"
})]), c$2("&:hover", {
  backgroundColor: "var(--n-color-hover)",
  color: "var(--n-text-color-hover)"
}, [cE$1("state-border", {
  border: "var(--n-border-hover)"
})]), c$2("&:active", {
  backgroundColor: "var(--n-color-pressed)",
  color: "var(--n-text-color-pressed)"
}, [cE$1("state-border", {
  border: "var(--n-border-pressed)"
})]), cM("pressed", {
  backgroundColor: "var(--n-color-pressed)",
  color: "var(--n-text-color-pressed)"
}, [cE$1("state-border", {
  border: "var(--n-border-pressed)"
})])]), cM("loading", "cursor: wait;"), cB$1("base-wave", `
 pointer-events: none;
 top: 0;
 right: 0;
 bottom: 0;
 left: 0;
 animation-iteration-count: 1;
 animation-duration: var(--n-ripple-duration);
 animation-timing-function: var(--n-bezier-ease-out), var(--n-bezier-ease-out);
 `, [cM("active", {
  zIndex: 1,
  animationName: "button-wave-spread, button-wave-opacity"
})]), isBrowser$2 && "MozBoxSizing" in document.createElement("div").style ? c$2("&::moz-focus-inner", {
  border: 0
}) : null, cE$1("border, state-border", `
 position: absolute;
 left: 0;
 top: 0;
 right: 0;
 bottom: 0;
 border-radius: inherit;
 transition: border-color .3s var(--n-bezier);
 pointer-events: none;
 `), cE$1("border", {
  border: "var(--n-border)"
}), cE$1("state-border", {
  border: "var(--n-border)",
  borderColor: "#0000",
  zIndex: 1
}), cE$1("icon", `
 margin: var(--n-icon-margin);
 margin-left: 0;
 height: var(--n-icon-size);
 width: var(--n-icon-size);
 max-width: var(--n-icon-size);
 font-size: var(--n-icon-size);
 position: relative;
 flex-shrink: 0;
 `, [cB$1("icon-slot", `
 height: var(--n-icon-size);
 width: var(--n-icon-size);
 position: absolute;
 left: 0;
 top: 50%;
 transform: translateY(-50%);
 display: flex;
 align-items: center;
 justify-content: center;
 `, [iconSwitchTransition({
  top: "50%",
  originalTransform: "translateY(-50%)"
})]), fadeInWidthExpandTransition()]), cE$1("content", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 min-width: 0;
 `, [c$2("~", [cE$1("icon", {
  margin: "var(--n-icon-margin)",
  marginRight: 0
})])]), cM("block", `
 display: flex;
 width: 100%;
 `), cM("dashed", [cE$1("border, state-border", {
  borderStyle: "dashed !important"
})]), cM("disabled", {
  cursor: "not-allowed",
  opacity: "var(--n-opacity-disabled)"
})]), c$2("@keyframes button-wave-spread", {
  from: {
    boxShadow: "0 0 0.5px 0 var(--n-ripple-color)"
  },
  to: {
    boxShadow: "0 0 0.5px 4.5px var(--n-ripple-color)"
  }
}), c$2("@keyframes button-wave-opacity", {
  from: {
    opacity: "var(--n-wave-opacity)"
  },
  to: {
    opacity: 0
  }
})]);
const buttonProps = Object.assign(Object.assign({}, useTheme.props), { color: String, textColor: String, text: Boolean, block: Boolean, loading: Boolean, disabled: Boolean, circle: Boolean, size: String, ghost: Boolean, round: Boolean, secondary: Boolean, tertiary: Boolean, quaternary: Boolean, strong: Boolean, focusable: {
  type: Boolean,
  default: true
}, keyboard: {
  type: Boolean,
  default: true
}, tag: {
  type: String,
  default: "button"
}, type: {
  type: String,
  default: "default"
}, dashed: Boolean, renderIcon: Function, iconPlacement: {
  type: String,
  default: "left"
}, attrType: {
  type: String,
  default: "button"
}, bordered: {
  type: Boolean,
  default: true
}, onClick: [Function, Array], nativeFocusBehavior: {
  type: Boolean,
  default: !isSafari
} });
const Button = defineComponent({
  name: "Button",
  props: buttonProps,
  setup(props) {
    const selfElRef = ref(null);
    const waveElRef = ref(null);
    const enterPressedRef = ref(false);
    const showBorderRef = useMemo(() => {
      return !props.quaternary && !props.tertiary && !props.secondary && !props.text && (!props.color || props.ghost || props.dashed) && props.bordered;
    });
    const NButtonGroup2 = inject(buttonGroupInjectionKey, {});
    const { mergedSizeRef } = useFormItem({}, {
      defaultSize: "medium",
      mergedSize: (NFormItem2) => {
        const { size: size2 } = props;
        if (size2)
          return size2;
        const { size: buttonGroupSize } = NButtonGroup2;
        if (buttonGroupSize)
          return buttonGroupSize;
        const { mergedSize: formItemSize2 } = NFormItem2 || {};
        if (formItemSize2) {
          return formItemSize2.value;
        }
        return "medium";
      }
    });
    const mergedFocusableRef = computed(() => {
      return props.focusable && !props.disabled;
    });
    const handleMousedown = (e25) => {
      var _a2;
      if (!mergedFocusableRef.value) {
        e25.preventDefault();
      }
      if (props.nativeFocusBehavior) {
        return;
      }
      e25.preventDefault();
      if (props.disabled) {
        return;
      }
      if (mergedFocusableRef.value) {
        (_a2 = selfElRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus({ preventScroll: true });
      }
    };
    const handleClick2 = (e25) => {
      var _a2;
      if (!props.disabled && !props.loading) {
        const { onClick } = props;
        if (onClick)
          call(onClick, e25);
        if (!props.text) {
          (_a2 = waveElRef.value) === null || _a2 === void 0 ? void 0 : _a2.play();
        }
      }
    };
    const handleKeyup = (e25) => {
      switch (e25.key) {
        case "Enter":
          if (!props.keyboard) {
            return;
          }
          enterPressedRef.value = false;
      }
    };
    const handleKeydown = (e25) => {
      switch (e25.key) {
        case "Enter":
          if (!props.keyboard || props.loading) {
            e25.preventDefault();
            return;
          }
          enterPressedRef.value = true;
      }
    };
    const handleBlur = () => {
      enterPressedRef.value = false;
    };
    const { inlineThemeDisabled, mergedClsPrefixRef, mergedRtlRef } = useConfig(props);
    const themeRef = useTheme("Button", "-button", style$A, buttonLight$1, props, mergedClsPrefixRef);
    const rtlEnabledRef = useRtl("Button", mergedRtlRef, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const theme2 = themeRef.value;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2, cubicBezierEaseOut: cubicBezierEaseOut2 }, self: self2 } = theme2;
      const { rippleDuration, opacityDisabled, fontWeight, fontWeightStrong } = self2;
      const size2 = mergedSizeRef.value;
      const { dashed, type: type4, ghost, text, color, round, circle, textColor, secondary, tertiary, quaternary, strong } = props;
      const fontProps = {
        "font-weight": strong ? fontWeightStrong : fontWeight
      };
      let colorProps = {
        "--n-color": "initial",
        "--n-color-hover": "initial",
        "--n-color-pressed": "initial",
        "--n-color-focus": "initial",
        "--n-color-disabled": "initial",
        "--n-ripple-color": "initial",
        "--n-text-color": "initial",
        "--n-text-color-hover": "initial",
        "--n-text-color-pressed": "initial",
        "--n-text-color-focus": "initial",
        "--n-text-color-disabled": "initial"
      };
      const typeIsTertiary = type4 === "tertiary";
      const typeIsDefault = type4 === "default";
      const mergedType = typeIsTertiary ? "default" : type4;
      if (text) {
        const propTextColor = textColor || color;
        const mergedTextColor = propTextColor || self2[createKey("textColorText", mergedType)];
        colorProps = {
          "--n-color": "#0000",
          "--n-color-hover": "#0000",
          "--n-color-pressed": "#0000",
          "--n-color-focus": "#0000",
          "--n-color-disabled": "#0000",
          "--n-ripple-color": "#0000",
          "--n-text-color": mergedTextColor,
          "--n-text-color-hover": propTextColor ? createHoverColor(propTextColor) : self2[createKey("textColorTextHover", mergedType)],
          "--n-text-color-pressed": propTextColor ? createPressedColor(propTextColor) : self2[createKey("textColorTextPressed", mergedType)],
          "--n-text-color-focus": propTextColor ? createHoverColor(propTextColor) : self2[createKey("textColorTextHover", mergedType)],
          "--n-text-color-disabled": propTextColor || self2[createKey("textColorTextDisabled", mergedType)]
        };
      } else if (ghost || dashed) {
        const mergedTextColor = textColor || color;
        colorProps = {
          "--n-color": "#0000",
          "--n-color-hover": "#0000",
          "--n-color-pressed": "#0000",
          "--n-color-focus": "#0000",
          "--n-color-disabled": "#0000",
          "--n-ripple-color": color || self2[createKey("rippleColor", mergedType)],
          "--n-text-color": mergedTextColor || self2[createKey("textColorGhost", mergedType)],
          "--n-text-color-hover": mergedTextColor ? createHoverColor(mergedTextColor) : self2[createKey("textColorGhostHover", mergedType)],
          "--n-text-color-pressed": mergedTextColor ? createPressedColor(mergedTextColor) : self2[createKey("textColorGhostPressed", mergedType)],
          "--n-text-color-focus": mergedTextColor ? createHoverColor(mergedTextColor) : self2[createKey("textColorGhostHover", mergedType)],
          "--n-text-color-disabled": mergedTextColor || self2[createKey("textColorGhostDisabled", mergedType)]
        };
      } else if (secondary) {
        const typeTextColor = typeIsDefault ? self2.textColor : typeIsTertiary ? self2.textColorTertiary : self2[createKey("color", mergedType)];
        const mergedTextColor = color || typeTextColor;
        const isColoredType = type4 !== "default" && type4 !== "tertiary";
        colorProps = {
          "--n-color": isColoredType ? changeColor(mergedTextColor, {
            alpha: Number(self2.colorOpacitySecondary)
          }) : self2.colorSecondary,
          "--n-color-hover": isColoredType ? changeColor(mergedTextColor, {
            alpha: Number(self2.colorOpacitySecondaryHover)
          }) : self2.colorSecondaryHover,
          "--n-color-pressed": isColoredType ? changeColor(mergedTextColor, {
            alpha: Number(self2.colorOpacitySecondaryPressed)
          }) : self2.colorSecondaryPressed,
          "--n-color-focus": isColoredType ? changeColor(mergedTextColor, {
            alpha: Number(self2.colorOpacitySecondaryHover)
          }) : self2.colorSecondaryHover,
          "--n-color-disabled": self2.colorSecondary,
          "--n-ripple-color": "#0000",
          "--n-text-color": mergedTextColor,
          "--n-text-color-hover": mergedTextColor,
          "--n-text-color-pressed": mergedTextColor,
          "--n-text-color-focus": mergedTextColor,
          "--n-text-color-disabled": mergedTextColor
        };
      } else if (tertiary || quaternary) {
        const typeColor = typeIsDefault ? self2.textColor : typeIsTertiary ? self2.textColorTertiary : self2[createKey("color", mergedType)];
        const mergedColor = color || typeColor;
        if (tertiary) {
          colorProps["--n-color"] = self2.colorTertiary;
          colorProps["--n-color-hover"] = self2.colorTertiaryHover;
          colorProps["--n-color-pressed"] = self2.colorTertiaryPressed;
          colorProps["--n-color-focus"] = self2.colorSecondaryHover;
          colorProps["--n-color-disabled"] = self2.colorTertiary;
        } else {
          colorProps["--n-color"] = self2.colorQuaternary;
          colorProps["--n-color-hover"] = self2.colorQuaternaryHover;
          colorProps["--n-color-pressed"] = self2.colorQuaternaryPressed;
          colorProps["--n-color-focus"] = self2.colorQuaternaryHover;
          colorProps["--n-color-disabled"] = self2.colorQuaternary;
        }
        colorProps["--n-ripple-color"] = "#0000";
        colorProps["--n-text-color"] = mergedColor;
        colorProps["--n-text-color-hover"] = mergedColor;
        colorProps["--n-text-color-pressed"] = mergedColor;
        colorProps["--n-text-color-focus"] = mergedColor;
        colorProps["--n-text-color-disabled"] = mergedColor;
      } else {
        colorProps = {
          "--n-color": color || self2[createKey("color", mergedType)],
          "--n-color-hover": color ? createHoverColor(color) : self2[createKey("colorHover", mergedType)],
          "--n-color-pressed": color ? createPressedColor(color) : self2[createKey("colorPressed", mergedType)],
          "--n-color-focus": color ? createHoverColor(color) : self2[createKey("colorFocus", mergedType)],
          "--n-color-disabled": color || self2[createKey("colorDisabled", mergedType)],
          "--n-ripple-color": color || self2[createKey("rippleColor", mergedType)],
          "--n-text-color": textColor || (color ? self2.textColorPrimary : typeIsTertiary ? self2.textColorTertiary : self2[createKey("textColor", mergedType)]),
          "--n-text-color-hover": textColor || (color ? self2.textColorHoverPrimary : self2[createKey("textColorHover", mergedType)]),
          "--n-text-color-pressed": textColor || (color ? self2.textColorPressedPrimary : self2[createKey("textColorPressed", mergedType)]),
          "--n-text-color-focus": textColor || (color ? self2.textColorFocusPrimary : self2[createKey("textColorFocus", mergedType)]),
          "--n-text-color-disabled": textColor || (color ? self2.textColorDisabledPrimary : self2[createKey("textColorDisabled", mergedType)])
        };
      }
      let borderProps = {
        "--n-border": "initial",
        "--n-border-hover": "initial",
        "--n-border-pressed": "initial",
        "--n-border-focus": "initial",
        "--n-border-disabled": "initial"
      };
      if (text) {
        borderProps = {
          "--n-border": "none",
          "--n-border-hover": "none",
          "--n-border-pressed": "none",
          "--n-border-focus": "none",
          "--n-border-disabled": "none"
        };
      } else {
        borderProps = {
          "--n-border": self2[createKey("border", mergedType)],
          "--n-border-hover": self2[createKey("borderHover", mergedType)],
          "--n-border-pressed": self2[createKey("borderPressed", mergedType)],
          "--n-border-focus": self2[createKey("borderFocus", mergedType)],
          "--n-border-disabled": self2[createKey("borderDisabled", mergedType)]
        };
      }
      const { [createKey("height", size2)]: height, [createKey("fontSize", size2)]: fontSize2, [createKey("padding", size2)]: padding, [createKey("paddingRound", size2)]: paddingRound, [createKey("iconSize", size2)]: iconSize, [createKey("borderRadius", size2)]: borderRadius, [createKey("iconMargin", size2)]: iconMargin, waveOpacity } = self2;
      const sizeProps = {
        "--n-width": circle && !text ? height : "initial",
        "--n-height": text ? "initial" : height,
        "--n-font-size": fontSize2,
        "--n-padding": circle ? "initial" : text ? "initial" : round ? paddingRound : padding,
        "--n-icon-size": iconSize,
        "--n-icon-margin": iconMargin,
        "--n-border-radius": text ? "initial" : circle || round ? height : borderRadius
      };
      return Object.assign(Object.assign(Object.assign(Object.assign({ "--n-bezier": cubicBezierEaseInOut2, "--n-bezier-ease-out": cubicBezierEaseOut2, "--n-ripple-duration": rippleDuration, "--n-opacity-disabled": opacityDisabled, "--n-wave-opacity": waveOpacity }, fontProps), colorProps), borderProps), sizeProps);
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("button", computed(() => {
      let hash2 = "";
      const { dashed, type: type4, ghost, text, color, round, circle, textColor, secondary, tertiary, quaternary, strong } = props;
      if (dashed)
        hash2 += "a";
      if (ghost)
        hash2 += "b";
      if (text)
        hash2 += "c";
      if (round)
        hash2 += "d";
      if (circle)
        hash2 += "e";
      if (secondary)
        hash2 += "f";
      if (tertiary)
        hash2 += "g";
      if (quaternary)
        hash2 += "h";
      if (strong)
        hash2 += "i";
      if (color)
        hash2 += "j" + color2Class(color);
      if (textColor)
        hash2 += "k" + color2Class(textColor);
      const { value: size2 } = mergedSizeRef;
      hash2 += "l" + size2[0];
      hash2 += "m" + type4[0];
      return hash2;
    }), cssVarsRef, props) : void 0;
    return {
      selfElRef,
      waveElRef,
      mergedClsPrefix: mergedClsPrefixRef,
      mergedFocusable: mergedFocusableRef,
      mergedSize: mergedSizeRef,
      showBorder: showBorderRef,
      enterPressed: enterPressedRef,
      rtlEnabled: rtlEnabledRef,
      handleMousedown,
      handleKeydown,
      handleBlur,
      handleKeyup,
      handleClick: handleClick2,
      customColorCssVars: computed(() => {
        const { color } = props;
        if (!color)
          return null;
        const hoverColor = createHoverColor(color);
        return {
          "--n-border-color": color,
          "--n-border-color-hover": hoverColor,
          "--n-border-color-pressed": createPressedColor(color),
          "--n-border-color-focus": hoverColor,
          "--n-border-color-disabled": color
        };
      }),
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const { mergedClsPrefix, tag: Component, onRender } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    const children = resolveWrappedSlot(this.$slots.default, (children2) => children2 && h$1("span", { class: `${mergedClsPrefix}-button__content` }, children2));
    return h$1(Component, { ref: "selfElRef", class: [
      this.themeClass,
      `${mergedClsPrefix}-button`,
      `${mergedClsPrefix}-button--${this.type}-type`,
      `${mergedClsPrefix}-button--${this.mergedSize}-type`,
      this.rtlEnabled && `${mergedClsPrefix}-button--rtl`,
      this.disabled && `${mergedClsPrefix}-button--disabled`,
      this.block && `${mergedClsPrefix}-button--block`,
      this.enterPressed && `${mergedClsPrefix}-button--pressed`,
      !this.text && this.dashed && `${mergedClsPrefix}-button--dashed`,
      this.color && `${mergedClsPrefix}-button--color`,
      this.secondary && `${mergedClsPrefix}-button--secondary`,
      this.loading && `${mergedClsPrefix}-button--loading`,
      this.ghost && `${mergedClsPrefix}-button--ghost`
    ], tabindex: this.mergedFocusable ? 0 : -1, type: this.attrType, style: this.cssVars, disabled: this.disabled, onClick: this.handleClick, onBlur: this.handleBlur, onMousedown: this.handleMousedown, onKeyup: this.handleKeyup, onKeydown: this.handleKeydown }, this.iconPlacement === "right" && children, h$1(NFadeInExpandTransition, { width: true }, {
      default: () => resolveWrappedSlot(this.$slots.icon, (children2) => (this.loading || this.renderIcon || children2) && h$1("span", { class: `${mergedClsPrefix}-button__icon`, style: {
        margin: isSlotEmpty(this.$slots.default) ? "0" : ""
      } }, h$1(NIconSwitchTransition, null, {
        default: () => this.loading ? h$1(NBaseLoading, { clsPrefix: mergedClsPrefix, key: "loading", class: `${mergedClsPrefix}-icon-slot`, strokeWidth: 20 }) : h$1("div", { key: "icon", class: `${mergedClsPrefix}-icon-slot`, role: "none" }, this.renderIcon ? this.renderIcon() : children2)
      })))
    }), this.iconPlacement === "left" && children, !this.text ? h$1(NBaseWave, { ref: "waveElRef", clsPrefix: mergedClsPrefix }) : null, this.showBorder ? h$1("div", { "aria-hidden": true, class: `${mergedClsPrefix}-button__border`, style: this.customColorCssVars }) : null, this.showBorder ? h$1("div", { "aria-hidden": true, class: `${mergedClsPrefix}-button__state-border`, style: this.customColorCssVars }) : null);
  }
});
var NButton = Button;
const XButton = Button;
const zero$1 = "0!important";
const n1 = "-1px!important";
function createLeftBorderStyle(type4) {
  return cM(type4 + "-type", [c$2("& +", [cB$1("button", {}, [cM(type4 + "-type", [cE$1("border", {
    borderLeftWidth: zero$1
  }), cE$1("state-border", {
    left: n1
  })])])])]);
}
function createTopBorderStyle(type4) {
  return cM(type4 + "-type", [c$2("& +", [cB$1("button", [cM(type4 + "-type", [cE$1("border", {
    borderTopWidth: zero$1
  }), cE$1("state-border", {
    top: n1
  })])])])]);
}
var style$z = cB$1("button-group", `
 flex-wrap: nowrap;
 display: inline-flex;
 position: relative;
`, [cNotM("vertical", {
  flexDirection: "row"
}, [cNotM("rtl", [cB$1("button", [c$2("&:first-child:not(:last-child)", `
 margin-right: ${zero$1};
 border-top-right-radius: ${zero$1};
 border-bottom-right-radius: ${zero$1};
 `), c$2("&:last-child:not(:first-child)", `
 margin-left: ${zero$1};
 border-top-left-radius: ${zero$1};
 border-bottom-left-radius: ${zero$1};
 `), c$2("&:not(:first-child):not(:last-child)", `
 margin-left: ${zero$1};
 margin-right: ${zero$1};
 border-radius: ${zero$1};
 `), createLeftBorderStyle("default"), cM("ghost", [createLeftBorderStyle("primary"), createLeftBorderStyle("info"), createLeftBorderStyle("success"), createLeftBorderStyle("warning"), createLeftBorderStyle("error")])])])]), cM("vertical", {
  flexDirection: "column"
}, [cB$1("button", [c$2("&:first-child:not(:last-child)", `
 margin-bottom: ${zero$1};
 margin-left: ${zero$1};
 margin-right: ${zero$1};
 border-bottom-left-radius: ${zero$1};
 border-bottom-right-radius: ${zero$1};
 `), c$2("&:last-child:not(:first-child)", `
 margin-top: ${zero$1};
 margin-left: ${zero$1};
 margin-right: ${zero$1};
 border-top-left-radius: ${zero$1};
 border-top-right-radius: ${zero$1};
 `), c$2("&:not(:first-child):not(:last-child)", `
 margin: ${zero$1};
 border-radius: ${zero$1};
 `), createTopBorderStyle("default"), cM("ghost", [createTopBorderStyle("primary"), createTopBorderStyle("info"), createTopBorderStyle("success"), createTopBorderStyle("warning"), createTopBorderStyle("error")])])])]);
const buttonGroupProps = {
  size: {
    type: String,
    default: void 0
  },
  vertical: Boolean
};
var NButtonGroup = defineComponent({
  name: "ButtonGroup",
  props: buttonGroupProps,
  setup(props) {
    const { mergedClsPrefixRef, mergedRtlRef } = useConfig(props);
    useStyle("-button-group", style$z, mergedClsPrefixRef);
    provide(buttonGroupInjectionKey, props);
    const rtlEnabledRef = useRtl("ButtonGroup", mergedRtlRef, mergedClsPrefixRef);
    return {
      rtlEnabled: rtlEnabledRef,
      mergedClsPrefix: mergedClsPrefixRef
    };
  },
  render() {
    const { mergedClsPrefix } = this;
    return h$1("div", { class: [
      `${mergedClsPrefix}-button-group`,
      this.rtlEnabled && `${mergedClsPrefix}-button-group--rtl`,
      this.vertical && `${mergedClsPrefix}-button-group--vertical`
    ], role: "group" }, this.$slots);
  }
});
const START_YEAR = 1901;
const MONTH_ITEM_HEIGHT = 40;
const matcherMap = {
  date: isSameDay,
  month: isSameMonth,
  year: isSameYear,
  quarter: isSameQuarter
};
function matchDate(sourceTime, patternTime, type4) {
  const matcher = matcherMap[type4];
  if (Array.isArray(sourceTime)) {
    return sourceTime.some((time2) => matcher(time2, patternTime));
  } else {
    return matcher(sourceTime, patternTime);
  }
}
function dateItem(time2, monthTs, valueTs, currentTs) {
  let inSpan = false;
  let startOfSpan = false;
  let endOfSpan = false;
  if (Array.isArray(valueTs)) {
    if (valueTs[0] < time2 && time2 < valueTs[1]) {
      inSpan = true;
    }
    if (matchDate(valueTs[0], time2, "date"))
      startOfSpan = true;
    if (matchDate(valueTs[1], time2, "date"))
      endOfSpan = true;
  }
  const selected = valueTs !== null && (Array.isArray(valueTs) ? matchDate(valueTs[0], time2, "date") || matchDate(valueTs[1], time2, "date") : matchDate(valueTs, time2, "date"));
  return {
    type: "date",
    dateObject: {
      date: getDate(time2),
      month: getMonth(time2),
      year: getYear(time2)
    },
    inCurrentMonth: isSameMonth(time2, monthTs),
    isCurrentDate: matchDate(currentTs, time2, "date"),
    inSpan,
    startOfSpan,
    endOfSpan,
    selected,
    ts: getTime(time2)
  };
}
function monthItem(monthTs, valueTs, currentTs) {
  return {
    type: "month",
    dateObject: {
      month: getMonth(monthTs),
      year: getYear(monthTs)
    },
    isCurrent: isSameMonth(currentTs, monthTs),
    selected: valueTs !== null && matchDate(valueTs, monthTs, "month"),
    ts: getTime(monthTs)
  };
}
function yearItem(yearTs, valueTs, currentTs) {
  return {
    type: "year",
    dateObject: {
      year: getYear(yearTs)
    },
    isCurrent: isSameYear(currentTs, yearTs),
    selected: valueTs !== null && matchDate(valueTs, yearTs, "year"),
    ts: getTime(yearTs)
  };
}
function quarterItem(quarterTs, valueTs, currentTs) {
  return {
    type: "quarter",
    dateObject: {
      quarter: getQuarter(quarterTs),
      year: getYear(quarterTs)
    },
    isCurrent: isSameQuarter(currentTs, quarterTs),
    selected: valueTs !== null && matchDate(valueTs, quarterTs, "quarter"),
    ts: getTime(quarterTs)
  };
}
function dateArray(monthTs, valueTs, currentTs, startDay, strip = false) {
  const displayMonth = getMonth(monthTs);
  let displayMonthIterator = getTime(startOfMonth(monthTs));
  let lastMonthIterator = getTime(addDays(displayMonthIterator, -1));
  const calendarDays = [];
  let protectLastMonthDateIsShownFlag = !strip;
  while (getDay(lastMonthIterator) !== startDay || protectLastMonthDateIsShownFlag) {
    calendarDays.unshift(dateItem(lastMonthIterator, monthTs, valueTs, currentTs));
    lastMonthIterator = getTime(addDays(lastMonthIterator, -1));
    protectLastMonthDateIsShownFlag = false;
  }
  while (getMonth(displayMonthIterator) === displayMonth) {
    calendarDays.push(dateItem(displayMonthIterator, monthTs, valueTs, currentTs));
    displayMonthIterator = getTime(addDays(displayMonthIterator, 1));
  }
  const endIndex = strip ? calendarDays.length <= 28 ? 28 : calendarDays.length <= 35 ? 35 : 42 : 42;
  while (calendarDays.length < endIndex) {
    calendarDays.push(dateItem(displayMonthIterator, monthTs, valueTs, currentTs));
    displayMonthIterator = getTime(addDays(displayMonthIterator, 1));
  }
  return calendarDays;
}
function monthArray(yearAnchorTs, valueTs, currentTs) {
  const calendarMonths = [];
  const yearStart = startOfYear(yearAnchorTs);
  for (let i2 = 0; i2 < 12; i2++) {
    calendarMonths.push(monthItem(getTime(addMonths(yearStart, i2)), valueTs, currentTs));
  }
  return calendarMonths;
}
function quarterArray(yearAnchorTs, valueTs, currentTs) {
  const calendarQuarters = [];
  const yearStart = startOfYear(yearAnchorTs);
  for (let i2 = 0; i2 < 4; i2++) {
    calendarQuarters.push(quarterItem(getTime(addQuarters(yearStart, i2)), valueTs, currentTs));
  }
  return calendarQuarters;
}
function yearArray(valueTs, currentTs) {
  const calendarYears = [];
  const time1900 = new Date(START_YEAR, 0, 1);
  for (let i2 = 0; i2 < 200; i2++) {
    calendarYears.push(yearItem(getTime(addYears(time1900, i2)), valueTs, currentTs));
  }
  return calendarYears;
}
function strictParse(string3, pattern4, backup, option) {
  const result2 = parse$J(string3, pattern4, backup, option);
  if (!isValid$1(result2))
    return result2;
  else if (format$4(result2, pattern4, option) === string3)
    return result2;
  else
    return new Date(NaN);
}
function getDefaultTime(timeValue) {
  if (timeValue === void 0) {
    return void 0;
  }
  if (typeof timeValue === "number") {
    return timeValue;
  }
  const [hour, minute, second] = timeValue.split(":");
  return {
    hours: Number(hour),
    minutes: Number(minute),
    seconds: Number(second)
  };
}
function pluckValueFromRange(value2, type4) {
  return Array.isArray(value2) ? value2[type4 === "start" ? 0 : 1] : null;
}
const self$x = (vars) => {
  const { fontSize: fontSize2, boxShadow2, popoverColor, textColor2, borderRadius, borderColor, heightSmall, heightMedium, heightLarge, fontSizeSmall, fontSizeMedium, fontSizeLarge, dividerColor } = vars;
  return {
    panelFontSize: fontSize2,
    boxShadow: boxShadow2,
    color: popoverColor,
    textColor: textColor2,
    borderRadius,
    border: `1px solid ${borderColor}`,
    heightSmall,
    heightMedium,
    heightLarge,
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    dividerColor
  };
};
const colorPickerLight = createTheme({
  name: "ColorPicker",
  common: commonLight,
  peers: {
    Input: inputLight$1,
    Button: buttonLight$1
  },
  self: self$x
});
var colorPickerLight$1 = colorPickerLight;
function deriveDefaultValue(modes, showAlpha) {
  const mode = modes[0];
  switch (mode) {
    case "hex":
      return showAlpha ? "#000000FF" : "#000000";
    case "rgb":
      return showAlpha ? "rgba(0, 0, 0, 1)" : "rgb(0, 0, 0)";
    case "hsl":
      return showAlpha ? "hsla(0, 0%, 0%, 1)" : "hsl(0, 0%, 0%)";
    case "hsv":
      return showAlpha ? "hsva(0, 0%, 0%, 1)" : "hsv(0, 0%, 0%)";
  }
  return "#000000";
}
function getModeFromValue(color) {
  if (color === null)
    return null;
  if (/^ *#/.test(color))
    return "hex";
  if (color.includes("rgb"))
    return "rgb";
  if (color.includes("hsl"))
    return "hsl";
  if (color.includes("hsv"))
    return "hsv";
  return null;
}
function normalizeHue(hue) {
  hue = Math.round(hue);
  return hue >= 360 ? 359 : hue < 0 ? 0 : hue;
}
function normalizeAlpha(alpha) {
  alpha = Math.round(alpha * 100) / 100;
  return alpha > 1 ? 1 : alpha < 0 ? 0 : alpha;
}
const convert = {
  rgb: {
    hex(value2) {
      return toHexaString(rgba(value2));
    },
    hsl(value2) {
      const [r2, g2, b2, a2] = rgba(value2);
      return toHslaString([...rgb2hsl(r2, g2, b2), a2]);
    },
    hsv(value2) {
      const [r2, g2, b2, a2] = rgba(value2);
      return toHsvaString([...rgb2hsv(r2, g2, b2), a2]);
    }
  },
  hex: {
    rgb(value2) {
      return toRgbaString(rgba(value2));
    },
    hsl(value2) {
      const [r2, g2, b2, a2] = rgba(value2);
      return toHslaString([...rgb2hsl(r2, g2, b2), a2]);
    },
    hsv(value2) {
      const [r2, g2, b2, a2] = rgba(value2);
      return toHsvaString([...rgb2hsv(r2, g2, b2), a2]);
    }
  },
  hsl: {
    hex(value2) {
      const [h2, s2, l2, a2] = hsla(value2);
      return toHexaString([...hsl2rgb(h2, s2, l2), a2]);
    },
    rgb(value2) {
      const [h2, s2, l2, a2] = hsla(value2);
      return toRgbaString([...hsl2rgb(h2, s2, l2), a2]);
    },
    hsv(value2) {
      const [h2, s2, l2, a2] = hsla(value2);
      return toHsvaString([...hsl2hsv(h2, s2, l2), a2]);
    }
  },
  hsv: {
    hex(value2) {
      const [h2, s2, v2, a2] = hsva(value2);
      return toHexaString([...hsv2rgb(h2, s2, v2), a2]);
    },
    rgb(value2) {
      const [h2, s2, v2, a2] = hsva(value2);
      return toRgbaString([...hsv2rgb(h2, s2, v2), a2]);
    },
    hsl(value2) {
      const [h2, s2, v2, a2] = hsva(value2);
      return toHslaString([...hsv2hsl(h2, s2, v2), a2]);
    }
  }
};
function convertColor(value2, mode, originalMode) {
  originalMode = originalMode || getModeFromValue(value2);
  if (!originalMode)
    return null;
  if (originalMode === mode)
    return value2;
  const conversions = convert[originalMode];
  return conversions[mode](value2);
}
const HANDLE_SIZE$2 = "12px";
const HANDLE_SIZE_NUM$1 = 12;
const RADIUS$2 = "6px";
const RADIUS_NUM = 6;
const GRADIENT = "linear-gradient(90deg,red,#ff0 16.66%,#0f0 33.33%,#0ff 50%,#00f 66.66%,#f0f 83.33%,red)";
var HueSlider = defineComponent({
  name: "HueSlider",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    hue: {
      type: Number,
      required: true
    },
    onUpdateHue: {
      type: Function,
      required: true
    },
    onComplete: Function
  },
  setup(props) {
    const railRef = ref(null);
    function handleMouseDown(e25) {
      if (!railRef.value)
        return;
      on$1("mousemove", document, handleMouseMove);
      on$1("mouseup", document, handleMouseUp);
      handleMouseMove(e25);
    }
    function handleMouseMove(e25) {
      const { value: railEl } = railRef;
      if (!railEl)
        return;
      const { width, left } = railEl.getBoundingClientRect();
      const newHue = normalizeHue((e25.clientX - left - RADIUS_NUM) / (width - HANDLE_SIZE_NUM$1) * 360);
      props.onUpdateHue(newHue);
    }
    function handleMouseUp() {
      var _a2;
      off("mousemove", document, handleMouseMove);
      off("mouseup", document, handleMouseUp);
      (_a2 = props.onComplete) === null || _a2 === void 0 ? void 0 : _a2.call(props);
    }
    return {
      railRef,
      handleMouseDown
    };
  },
  render() {
    const { clsPrefix } = this;
    return h$1("div", { class: `${clsPrefix}-color-picker-slider`, style: {
      height: HANDLE_SIZE$2,
      borderRadius: RADIUS$2
    } }, h$1("div", { ref: "railRef", style: {
      boxShadow: "inset 0 0 2px 0 rgba(0, 0, 0, .24)",
      boxSizing: "border-box",
      backgroundImage: GRADIENT,
      height: HANDLE_SIZE$2,
      borderRadius: RADIUS$2,
      position: "relative"
    }, onMousedown: this.handleMouseDown }, h$1("div", { style: {
      position: "absolute",
      left: RADIUS$2,
      right: RADIUS$2,
      top: 0,
      bottom: 0
    } }, h$1("div", { class: `${clsPrefix}-color-picker-handle`, style: {
      left: `calc((${this.hue}%) / 359 * 100 - ${RADIUS$2})`,
      borderRadius: RADIUS$2,
      width: HANDLE_SIZE$2,
      height: HANDLE_SIZE$2
    } }, h$1("div", { class: `${clsPrefix}-color-picker-handle__fill`, style: {
      backgroundColor: `hsl(${this.hue}, 100%, 50%)`,
      borderRadius: RADIUS$2,
      width: HANDLE_SIZE$2,
      height: HANDLE_SIZE$2
    } })))));
  }
});
const HANDLE_SIZE$1 = "12px";
const HANDLE_SIZE_NUM = 12;
const RADIUS$1 = "6px";
var AlphaSlider = defineComponent({
  name: "AlphaSlider",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    rgba: {
      type: Array,
      default: null
    },
    alpha: {
      type: Number,
      default: 0
    },
    onUpdateAlpha: {
      type: Function,
      required: true
    },
    onComplete: Function
  },
  setup(props) {
    const railRef = ref(null);
    function handleMouseDown(e25) {
      if (!railRef.value || !props.rgba)
        return;
      on$1("mousemove", document, handleMouseMove);
      on$1("mouseup", document, handleMouseUp);
      handleMouseMove(e25);
    }
    function handleMouseMove(e25) {
      const { value: railEl } = railRef;
      if (!railEl)
        return;
      const { width, left } = railEl.getBoundingClientRect();
      const newAlpha = (e25.clientX - left) / (width - HANDLE_SIZE_NUM);
      props.onUpdateAlpha(normalizeAlpha(newAlpha));
    }
    function handleMouseUp() {
      var _a2;
      off("mousemove", document, handleMouseMove);
      off("mouseup", document, handleMouseUp);
      (_a2 = props.onComplete) === null || _a2 === void 0 ? void 0 : _a2.call(props);
    }
    return {
      railRef,
      railBackgroundImage: computed(() => {
        const { rgba: rgba2 } = props;
        if (!rgba2)
          return "";
        return `linear-gradient(to right, rgba(${rgba2[0]}, ${rgba2[1]}, ${rgba2[2]}, 0) 0%, rgba(${rgba2[0]}, ${rgba2[1]}, ${rgba2[2]}, 1) 100%)`;
      }),
      handleMouseDown
    };
  },
  render() {
    const { clsPrefix } = this;
    return h$1("div", { class: `${clsPrefix}-color-picker-slider`, ref: "railRef", style: {
      height: HANDLE_SIZE$1,
      borderRadius: RADIUS$1
    }, onMousedown: this.handleMouseDown }, h$1("div", { style: {
      borderRadius: RADIUS$1,
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      overflow: "hidden"
    } }, h$1("div", { class: `${clsPrefix}-color-picker-checkboard` }), h$1("div", { class: `${clsPrefix}-color-picker-slider__image`, style: {
      backgroundImage: this.railBackgroundImage
    } })), this.rgba && h$1("div", { style: {
      position: "absolute",
      left: RADIUS$1,
      right: RADIUS$1,
      top: 0,
      bottom: 0
    } }, h$1("div", { class: `${clsPrefix}-color-picker-handle`, style: {
      left: `calc(${this.alpha * 100}% - ${RADIUS$1})`,
      borderRadius: RADIUS$1,
      width: HANDLE_SIZE$1,
      height: HANDLE_SIZE$1
    } }, h$1("div", { class: `${clsPrefix}-color-picker-handle__fill`, style: {
      backgroundColor: toRgbaString(this.rgba),
      borderRadius: RADIUS$1,
      width: HANDLE_SIZE$1,
      height: HANDLE_SIZE$1
    } }))));
  }
});
const HANDLE_SIZE = "12px";
const RADIUS = "6px";
var Pallete = defineComponent({
  name: "Pallete",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    rgba: {
      type: Array,
      default: null
    },
    displayedHue: {
      type: Number,
      required: true
    },
    displayedSv: {
      type: Array,
      required: true
    },
    onUpdateSV: {
      type: Function,
      required: true
    },
    onComplete: Function
  },
  setup(props) {
    const palleteRef = ref(null);
    function handleMouseDown(e25) {
      if (!palleteRef.value)
        return;
      on$1("mousemove", document, handleMouseMove);
      on$1("mouseup", document, handleMouseUp);
      handleMouseMove(e25);
    }
    function handleMouseMove(e25) {
      const { value: palleteEl } = palleteRef;
      if (!palleteEl)
        return;
      const { width, height, left, bottom } = palleteEl.getBoundingClientRect();
      const newV = (bottom - e25.clientY) / height;
      const newS = (e25.clientX - left) / width;
      const normalizedNewS = 100 * (newS > 1 ? 1 : newS < 0 ? 0 : newS);
      const normalizedNewV = 100 * (newV > 1 ? 1 : newV < 0 ? 0 : newV);
      props.onUpdateSV(normalizedNewS, normalizedNewV);
    }
    function handleMouseUp() {
      var _a2;
      off("mousemove", document, handleMouseMove);
      off("mouseup", document, handleMouseUp);
      (_a2 = props.onComplete) === null || _a2 === void 0 ? void 0 : _a2.call(props);
    }
    return {
      palleteRef,
      handleColor: computed(() => {
        const { rgba: rgba2 } = props;
        if (!rgba2)
          return "";
        return `rgb(${rgba2[0]}, ${rgba2[1]}, ${rgba2[2]})`;
      }),
      handleMouseDown
    };
  },
  render() {
    const { clsPrefix } = this;
    return h$1("div", { class: `${clsPrefix}-color-picker-pallete`, onMousedown: this.handleMouseDown, ref: "palleteRef" }, h$1("div", { class: `${clsPrefix}-color-picker-pallete__layer`, style: {
      backgroundImage: `linear-gradient(90deg, white, hsl(${this.displayedHue}, 100%, 50%))`
    } }), h$1("div", { class: `${clsPrefix}-color-picker-pallete__layer ${clsPrefix}-color-picker-pallete__layer--shadowed`, style: {
      backgroundImage: "linear-gradient(180deg, rgba(0, 0, 0, 0%), rgba(0, 0, 0, 100%))"
    } }), this.rgba && h$1("div", { class: `${clsPrefix}-color-picker-handle`, style: {
      width: HANDLE_SIZE,
      height: HANDLE_SIZE,
      borderRadius: RADIUS,
      left: `calc(${this.displayedSv[0]}% - ${RADIUS})`,
      bottom: `calc(${this.displayedSv[1]}% - ${RADIUS})`
    } }, h$1("div", { class: `${clsPrefix}-color-picker-handle__fill`, style: {
      backgroundColor: this.handleColor,
      borderRadius: RADIUS,
      width: HANDLE_SIZE,
      height: HANDLE_SIZE
    } })));
  }
});
const colorPickerInjectionKey = createInjectionKey("n-color-picker");
function normalizeRgbUnit(value2) {
  if (/^\d{1,3}\.?\d*$/.test(value2.trim())) {
    return Math.max(0, Math.min(parseInt(value2), 255));
  }
  return false;
}
function normalizeHueUnit(value2) {
  if (/^\d{1,3}\.?\d*$/.test(value2.trim())) {
    return Math.max(0, Math.min(parseInt(value2), 360));
  }
  return false;
}
function normalizeSlvUnit(value2) {
  if (/^\d{1,3}\.?\d*$/.test(value2.trim())) {
    return Math.max(0, Math.min(parseInt(value2), 100));
  }
  return false;
}
function normalizeHexaUnit(value2) {
  const trimmedValue = value2.trim();
  if (/^#[0-9a-fA-F]+$/.test(trimmedValue)) {
    return [4, 5, 7, 9].includes(trimmedValue.length);
  }
  return false;
}
function normalizeAlphaUnit(value2) {
  if (/^\d{1,3}\.?\d*%$/.test(value2.trim())) {
    return Math.max(0, Math.min(parseInt(value2) / 100, 100));
  }
  return false;
}
const inputThemeOverrides = {
  paddingSmall: "0 4px"
};
var ColorInputUnit = defineComponent({
  name: "ColorInputUnit",
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      default: null
    },
    showAlpha: Boolean,
    onUpdateValue: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const inputValueRef = ref("");
    const { themeRef } = inject(colorPickerInjectionKey, null);
    watchEffect(() => {
      inputValueRef.value = getInputString();
    });
    function getInputString() {
      const { value: value2 } = props;
      if (value2 === null)
        return "";
      const { label } = props;
      if (label === "HEX") {
        return value2;
      }
      if (label === "A") {
        return `${Math.floor(value2 * 100)}%`;
      }
      return String(Math.floor(value2));
    }
    function handleInputUpdateValue(value2) {
      inputValueRef.value = value2;
    }
    function handleInputChange(value2) {
      let unit;
      let valid;
      switch (props.label) {
        case "HEX":
          valid = normalizeHexaUnit(value2);
          if (valid) {
            props.onUpdateValue(value2);
          }
          inputValueRef.value = getInputString();
          break;
        case "H":
          unit = normalizeHueUnit(value2);
          if (unit === false) {
            inputValueRef.value = getInputString();
          } else {
            props.onUpdateValue(unit);
          }
          break;
        case "S":
        case "L":
        case "V":
          unit = normalizeSlvUnit(value2);
          if (unit === false) {
            inputValueRef.value = getInputString();
          } else {
            props.onUpdateValue(unit);
          }
          break;
        case "A":
          unit = normalizeAlphaUnit(value2);
          if (unit === false) {
            inputValueRef.value = getInputString();
          } else {
            props.onUpdateValue(unit);
          }
          break;
        case "R":
        case "G":
        case "B":
          unit = normalizeRgbUnit(value2);
          if (unit === false) {
            inputValueRef.value = getInputString();
          } else {
            props.onUpdateValue(unit);
          }
          break;
      }
    }
    return {
      mergedTheme: themeRef,
      inputValue: inputValueRef,
      handleInputChange,
      handleInputUpdateValue
    };
  },
  render() {
    const { mergedTheme } = this;
    return h$1(NInput, {
      size: "small",
      placeholder: this.label,
      theme: mergedTheme.peers.Input,
      themeOverrides: mergedTheme.peerOverrides.Input,
      builtinThemeOverrides: inputThemeOverrides,
      value: this.inputValue,
      onUpdateValue: this.handleInputUpdateValue,
      onChange: this.handleInputChange,
      style: this.label === "A" ? "flex-grow: 1.25;" : ""
    });
  }
});
var ColorInput = defineComponent({
  name: "ColorInput",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    modes: {
      type: Array,
      required: true
    },
    showAlpha: {
      type: Boolean,
      required: true
    },
    value: {
      type: String,
      default: null
    },
    valueArr: {
      type: Array,
      default: null
    },
    onUpdateValue: {
      type: Function,
      required: true
    },
    onUpdateMode: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    return {
      handleUnitUpdateValue(index2, value2) {
        const { showAlpha } = props;
        if (props.mode === "hex") {
          props.onUpdateValue((showAlpha ? toHexaString : toHexString)(value2));
          return;
        }
        let nextValueArr;
        if (props.valueArr === null) {
          nextValueArr = [0, 0, 0, 0];
        } else {
          nextValueArr = Array.from(props.valueArr);
        }
        switch (props.mode) {
          case "hsv":
            nextValueArr[index2] = value2;
            props.onUpdateValue((showAlpha ? toHsvaString : toHsvString)(nextValueArr));
            break;
          case "rgb":
            nextValueArr[index2] = value2;
            props.onUpdateValue((showAlpha ? toRgbaString : toRgbString)(nextValueArr));
            break;
          case "hsl":
            nextValueArr[index2] = value2;
            props.onUpdateValue((showAlpha ? toHslaString : toHslString)(nextValueArr));
            break;
        }
      }
    };
  },
  render() {
    const { clsPrefix, modes } = this;
    return h$1("div", { class: `${clsPrefix}-color-picker-input` }, h$1("div", { class: `${clsPrefix}-color-picker-input__mode`, onClick: this.onUpdateMode, style: {
      cursor: modes.length === 1 ? "" : "pointer"
    } }, this.mode.toUpperCase() + (this.showAlpha ? "A" : "")), h$1(NInputGroup, null, {
      default: () => {
        const { mode, valueArr, showAlpha } = this;
        if (mode === "hex") {
          let hexValue = null;
          try {
            hexValue = valueArr === null ? null : (showAlpha ? toHexaString : toHexString)(valueArr);
          } catch (_a2) {
          }
          return h$1(ColorInputUnit, { label: "HEX", showAlpha, value: hexValue, onUpdateValue: (unitValue) => {
            this.handleUnitUpdateValue(0, unitValue);
          } });
        }
        return (mode + (showAlpha ? "a" : "")).split("").map((v2, i2) => h$1(ColorInputUnit, { label: v2.toUpperCase(), value: valueArr === null ? null : valueArr[i2], onUpdateValue: (unitValue) => {
          this.handleUnitUpdateValue(i2, unitValue);
        } }));
      }
    }));
  }
});
var ColorPickerTrigger = defineComponent({
  name: "ColorPickerTrigger",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: null
    },
    hsla: {
      type: Array,
      default: null
    },
    disabled: Boolean,
    onClick: Function
  },
  setup(props) {
    const { colorPickerSlots, renderLabelRef } = inject(colorPickerInjectionKey, null);
    return () => {
      const { hsla: hsla2, value: value2, clsPrefix, onClick, disabled } = props;
      const renderLabel = colorPickerSlots.label || renderLabelRef.value;
      return h$1("div", { class: [
        `${clsPrefix}-color-picker-trigger`,
        disabled && `${clsPrefix}-color-picker-trigger--disabled`
      ], onClick: disabled ? void 0 : onClick }, h$1("div", { class: `${clsPrefix}-color-picker-trigger__fill` }, h$1("div", { class: `${clsPrefix}-color-picker-checkboard` }), h$1("div", { style: {
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        backgroundColor: hsla2 ? toHslaString(hsla2) : ""
      } }), value2 && hsla2 ? h$1("div", { class: `${clsPrefix}-color-picker-trigger__value`, style: {
        color: hsla2[2] > 50 || hsla2[3] < 0.5 ? "black" : "white"
      } }, renderLabel ? renderLabel(value2) : value2) : null));
    };
  }
});
function normalizeColor(color, mode) {
  if (mode === "hsv") {
    const [h2, s2, v2, a2] = hsva(color);
    return toRgbaString([...hsv2rgb(h2, s2, v2), a2]);
  }
  return color;
}
function getHexFromName(color) {
  const ctx2 = document.createElement("canvas").getContext("2d");
  ctx2.fillStyle = color;
  return ctx2.fillStyle;
}
var ColorPickerSwatches = defineComponent({
  name: "ColorPickerSwatches",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    swatches: {
      type: Array,
      required: true
    },
    onUpdateColor: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const parsedSwatchesRef = computed(() => props.swatches.map((value2) => {
      const mode = getModeFromValue(value2);
      return {
        value: value2,
        mode,
        legalValue: normalizeColor(value2, mode)
      };
    }));
    function normalizeOutput(parsed) {
      const { mode: modeProp } = props;
      let { value: value2, mode: swatchColorMode } = parsed;
      if (!swatchColorMode) {
        swatchColorMode = "hex";
        if (/^[a-zA-Z]+$/.test(value2)) {
          value2 = getHexFromName(value2);
        } else {
          warn$2("color-picker", `color ${value2} in swatches is invalid.`);
          value2 = "#000000";
        }
      }
      if (swatchColorMode === modeProp)
        return value2;
      return convertColor(value2, modeProp, swatchColorMode);
    }
    function handleSwatchSelect(parsed) {
      props.onUpdateColor(normalizeOutput(parsed));
    }
    function handleSwatchKeyDown(e25, parsed) {
      if (e25.key === "Enter")
        handleSwatchSelect(parsed);
    }
    return {
      parsedSwatchesRef,
      handleSwatchSelect,
      handleSwatchKeyDown
    };
  },
  render() {
    const { clsPrefix } = this;
    return h$1("div", { class: `${clsPrefix}-color-picker-swatches` }, this.parsedSwatchesRef.map((swatch) => h$1("div", { class: `${clsPrefix}-color-picker-swatch`, tabindex: 0, onClick: () => {
      this.handleSwatchSelect(swatch);
    }, onKeydown: (e25) => {
      this.handleSwatchKeyDown(e25, swatch);
    } }, h$1("div", { class: `${clsPrefix}-color-picker-swatch__fill`, style: { background: swatch.legalValue } }))));
  }
});
var ColorPreview = defineComponent({
  name: "ColorPreview",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    mode: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: null,
      validator: (value2) => {
        const mode = getModeFromValue(value2);
        return Boolean(!value2 || mode && mode !== "hsv");
      }
    },
    onUpdateColor: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    function handleChange(e25) {
      var _a2;
      const value2 = e25.target.value;
      (_a2 = props.onUpdateColor) === null || _a2 === void 0 ? void 0 : _a2.call(props, convertColor(value2.toUpperCase(), props.mode, "hex"));
      e25.stopPropagation();
    }
    return {
      handleChange
    };
  },
  render() {
    const { clsPrefix } = this;
    return h$1("div", { class: `${clsPrefix}-color-picker-preview__preview` }, h$1("span", { class: `${clsPrefix}-color-picker-preview__fill`, style: {
      background: this.color || "#000000"
    } }), h$1("input", { class: `${clsPrefix}-color-picker-preview__input`, type: "color", value: this.color, onChange: this.handleChange }));
  }
});
var style$y = c$2([cB$1("color-picker", `
 display: inline-block;
 box-sizing: border-box;
 height: var(--n-height);
 font-size: var(--n-font-size);
 width: 100%;
 position: relative;
 `), cB$1("color-picker-panel", `
 margin: 4px 0;
 width: 240px;
 font-size: var(--n-panel-font-size);
 color: var(--n-text-color);
 background-color: var(--n-color);
 transition:
 box-shadow .3s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 box-shadow: var(--n-box-shadow);
 `, [fadeInScaleUpTransition(), cB$1("input", `
 text-align: center;
 `)]), cB$1("color-picker-checkboard", `
 background: white; 
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [c$2("&::after", `
 background-image: linear-gradient(45deg, #DDD 25%, #0000 25%), linear-gradient(-45deg, #DDD 25%, #0000 25%), linear-gradient(45deg, #0000 75%, #DDD 75%), linear-gradient(-45deg, #0000 75%, #DDD 75%);
 background-size: 12px 12px;
 background-position: 0 0, 0 6px, 6px -6px, -6px 0px;
 background-repeat: repeat;
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)]), cB$1("color-picker-slider", `
 margin-bottom: 8px;
 position: relative;
 box-sizing: border-box;
 `, [cE$1("image", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `), c$2("&::after", `
 content: "";
 position: absolute;
 border-radius: inherit;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, .24);
 pointer-events: none;
 `)]), cB$1("color-picker-handle", `
 z-index: 1;
 box-shadow: 0 0 2px 0 rgba(0, 0, 0, .45);
 position: absolute;
 background-color: white;
 overflow: hidden;
 `, [cE$1("fill", `
 box-sizing: border-box;
 border: 2px solid white;
 `)]), cB$1("color-picker-pallete", `
 height: 180px;
 position: relative;
 margin-bottom: 8px;
 cursor: crosshair;
 `, [cE$1("layer", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [cM("shadowed", `
 box-shadow: inset 0 0 2px 0 rgba(0, 0, 0, .24);
 `)])]), cB$1("color-picker-preview", `
 display: flex;
 `, [cE$1("sliders", `
 flex: 1 0 auto;
 `), cE$1("preview", `
 position: relative;
 height: 30px;
 width: 30px;
 margin: 0 0 8px 6px;
 border-radius: 50%;
 box-shadow: rgba(0, 0, 0, .15) 0px 0px 0px 1px inset;
 overflow: hidden;
 `), cE$1("fill", `
 display: block;
 width: 30px;
 height: 30px;
 `), cE$1("input", `
 position: absolute;
 top: 0;
 left: 0;
 width: 30px;
 height: 30px;
 opacity: 0;
 z-index: 1;
 `)]), cB$1("color-picker-input", `
 display: flex;
 align-items: center;
 `, [cB$1("input", `
 flex-grow: 1;
 flex-basis: 0;
 `), cE$1("mode", `
 width: 72px;
 text-align: center;
 `)]), cB$1("color-picker-control", `
 padding: 12px;
 `), cB$1("color-picker-action", `
 display: flex;
 margin-top: -4px;
 border-top: 1px solid var(--n-divider-color);
 padding: 8px 12px;
 justify-content: flex-end;
 `, [cB$1("button", "margin-left: 8px;")]), cB$1("color-picker-trigger", `
 border: var(--n-border);
 height: 100%;
 box-sizing: border-box;
 border-radius: var(--n-border-radius);
 transition: border-color .3s var(--n-bezier);
 cursor: pointer;
 `, [cE$1("value", `
 white-space: nowrap;
 position: relative;
 `), cE$1("fill", `
 border-radius: var(--n-border-radius);
 position: absolute;
 display: flex;
 align-items: center;
 justify-content: center;
 left: 4px;
 right: 4px;
 top: 4px;
 bottom: 4px;
 `), cM("disabled", "cursor: not-allowed"), cB$1("color-picker-checkboard", `
 border-radius: var(--n-border-radius);
 `, [c$2("&::after", `
 --n-block-size: calc((var(--n-height) - 8px) / 3);
 background-size: calc(var(--n-block-size) * 2) calc(var(--n-block-size) * 2);
 background-position: 0 0, 0 var(--n-block-size), var(--n-block-size) calc(-1 * var(--n-block-size)), calc(-1 * var(--n-block-size)) 0px; 
 `)])]), cB$1("color-picker-swatches", `
 display: grid;
 grid-gap: 8px;
 flex-wrap: wrap;
 position: relative;
 grid-template-columns: repeat(auto-fill, 18px);
 margin-top: 10px;
 `, [cB$1("color-picker-swatch", `
 width: 18px;
 height: 18px;
 background-image: linear-gradient(45deg, #DDD 25%, #0000 25%), linear-gradient(-45deg, #DDD 25%, #0000 25%), linear-gradient(45deg, #0000 75%, #DDD 75%), linear-gradient(-45deg, #0000 75%, #DDD 75%);
 background-size: 8px 8px;
 background-position: 0px 0, 0px 4px, 4px -4px, -4px 0px;
 background-repeat: repeat;
 `, [cE$1("fill", `
 position: relative;
 width: 100%;
 height: 100%;
 border-radius: 3px;
 box-shadow: rgba(0, 0, 0, .15) 0px 0px 0px 1px inset;
 cursor: pointer;
 `), c$2("&:focus", `
 outline: none;
 `, [cE$1("fill", [c$2("&::after", `
 position: absolute;
 top: 0;
 right: 0;
 bottom: 0;
 left: 0;
 background: inherit;
 filter: blur(2px);
 content: "";
 `)])])])])]);
const colorPickerProps = Object.assign(Object.assign({}, useTheme.props), { value: String, show: {
  type: Boolean,
  default: void 0
}, defaultShow: Boolean, defaultValue: String, modes: {
  type: Array,
  default: () => ["rgb", "hex", "hsl"]
}, placement: {
  type: String,
  default: "bottom-start"
}, to: useAdjustedTo.propTo, showAlpha: {
  type: Boolean,
  default: true
}, showPreview: Boolean, swatches: Array, disabled: {
  type: Boolean,
  default: void 0
}, actions: {
  type: Array,
  default: null
}, internalActions: Array, size: String, renderLabel: Function, onComplete: Function, onConfirm: Function, "onUpdate:show": [Function, Array], onUpdateShow: [Function, Array], "onUpdate:value": [Function, Array], onUpdateValue: [Function, Array] });
var NColorPicker = defineComponent({
  name: "ColorPicker",
  props: colorPickerProps,
  setup(props, { slots }) {
    const selfRef = ref(null);
    let upcomingValue = null;
    const formItem = useFormItem(props);
    const { mergedSizeRef, mergedDisabledRef } = formItem;
    const { localeRef } = useLocale("global");
    const { mergedClsPrefixRef, namespaceRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("ColorPicker", "-color-picker", style$y, colorPickerLight$1, props, mergedClsPrefixRef);
    provide(colorPickerInjectionKey, {
      themeRef,
      renderLabelRef: toRef(props, "renderLabel"),
      colorPickerSlots: slots
    });
    const uncontrolledShowRef = ref(props.defaultShow);
    const mergedShowRef = useMergedState(toRef(props, "show"), uncontrolledShowRef);
    function doUpdateShow(value2) {
      const { onUpdateShow, "onUpdate:show": _onUpdateShow } = props;
      if (onUpdateShow)
        call(onUpdateShow, value2);
      if (_onUpdateShow)
        call(_onUpdateShow, value2);
      uncontrolledShowRef.value = value2;
    }
    const { defaultValue } = props;
    const uncontrolledValueRef = ref(defaultValue === void 0 ? deriveDefaultValue(props.modes, props.showAlpha) : defaultValue);
    const mergedValueRef = useMergedState(toRef(props, "value"), uncontrolledValueRef);
    const undoStackRef = ref([mergedValueRef.value]);
    const valueIndexRef = ref(0);
    const valueModeRef = computed(() => getModeFromValue(mergedValueRef.value));
    const { modes } = props;
    const displayedModeRef = ref(getModeFromValue(mergedValueRef.value) || modes[0] || "rgb");
    function handleUpdateDisplayedMode() {
      const { modes: modes2 } = props;
      const { value: displayedMode } = displayedModeRef;
      const currentModeIndex = modes2.findIndex((mode) => mode === displayedMode);
      if (~currentModeIndex) {
        displayedModeRef.value = modes2[(currentModeIndex + 1) % modes2.length];
      } else {
        displayedModeRef.value = "rgb";
      }
    }
    let _h2, s2, l2, v2, r2, g2, b2, a2;
    const hsvaRef = computed(() => {
      const { value: mergedValue } = mergedValueRef;
      if (!mergedValue)
        return null;
      switch (valueModeRef.value) {
        case "hsv":
          return hsva(mergedValue);
        case "hsl":
          [_h2, s2, l2, a2] = hsla(mergedValue);
          return [...hsl2hsv(_h2, s2, l2), a2];
        case "rgb":
        case "hex":
          [r2, g2, b2, a2] = rgba(mergedValue);
          return [...rgb2hsv(r2, g2, b2), a2];
      }
    });
    const rgbaRef = computed(() => {
      const { value: mergedValue } = mergedValueRef;
      if (!mergedValue)
        return null;
      switch (valueModeRef.value) {
        case "rgb":
        case "hex":
          return rgba(mergedValue);
        case "hsv":
          [_h2, s2, v2, a2] = hsva(mergedValue);
          return [...hsv2rgb(_h2, s2, v2), a2];
        case "hsl":
          [_h2, s2, l2, a2] = hsla(mergedValue);
          return [...hsl2rgb(_h2, s2, l2), a2];
      }
    });
    const hslaRef = computed(() => {
      const { value: mergedValue } = mergedValueRef;
      if (!mergedValue)
        return null;
      switch (valueModeRef.value) {
        case "hsl":
          return hsla(mergedValue);
        case "hsv":
          [_h2, s2, v2, a2] = hsva(mergedValue);
          return [...hsv2hsl(_h2, s2, v2), a2];
        case "rgb":
        case "hex":
          [r2, g2, b2, a2] = rgba(mergedValue);
          return [...rgb2hsl(r2, g2, b2), a2];
      }
    });
    const mergedValueArrRef = computed(() => {
      switch (displayedModeRef.value) {
        case "rgb":
        case "hex":
          return rgbaRef.value;
        case "hsv":
          return hsvaRef.value;
        case "hsl":
          return hslaRef.value;
      }
    });
    const displayedHueRef = ref(0);
    const displayedAlphaRef = ref(1);
    const displayedSvRef = ref([0, 0]);
    function handleUpdateSv(s3, v3) {
      const { value: hsvaArr } = hsvaRef;
      const hue = displayedHueRef.value;
      const alpha = hsvaArr ? hsvaArr[3] : 1;
      displayedSvRef.value = [s3, v3];
      const { showAlpha } = props;
      switch (displayedModeRef.value) {
        case "hsv":
          doUpdateValue((showAlpha ? toHsvaString : toHsvString)([hue, s3, v3, alpha]), "cursor");
          break;
        case "hsl":
          doUpdateValue((showAlpha ? toHslaString : toHslString)([
            ...hsv2hsl(hue, s3, v3),
            alpha
          ]), "cursor");
          break;
        case "rgb":
          doUpdateValue((showAlpha ? toRgbaString : toRgbString)([
            ...hsv2rgb(hue, s3, v3),
            alpha
          ]), "cursor");
          break;
        case "hex":
          doUpdateValue((showAlpha ? toHexaString : toHexString)([
            ...hsv2rgb(hue, s3, v3),
            alpha
          ]), "cursor");
          break;
      }
    }
    function handleUpdateHue(hue) {
      displayedHueRef.value = hue;
      const { value: hsvaArr } = hsvaRef;
      if (!hsvaArr) {
        return;
      }
      const [, s3, v3, a3] = hsvaArr;
      const { showAlpha } = props;
      switch (displayedModeRef.value) {
        case "hsv":
          doUpdateValue((showAlpha ? toHsvaString : toHsvString)([hue, s3, v3, a3]), "cursor");
          break;
        case "rgb":
          doUpdateValue((showAlpha ? toRgbaString : toRgbString)([
            ...hsv2rgb(hue, s3, v3),
            a3
          ]), "cursor");
          break;
        case "hex":
          doUpdateValue((showAlpha ? toHexaString : toHexString)([
            ...hsv2rgb(hue, s3, v3),
            a3
          ]), "cursor");
          break;
        case "hsl":
          doUpdateValue((showAlpha ? toHslaString : toHslString)([
            ...hsv2hsl(hue, s3, v3),
            a3
          ]), "cursor");
          break;
      }
    }
    function handleUpdateAlpha(alpha) {
      switch (displayedModeRef.value) {
        case "hsv":
          [_h2, s2, v2] = hsvaRef.value;
          doUpdateValue(toHsvaString([_h2, s2, v2, alpha]), "cursor");
          break;
        case "rgb":
          [r2, g2, b2] = rgbaRef.value;
          doUpdateValue(toRgbaString([r2, g2, b2, alpha]), "cursor");
          break;
        case "hex":
          [r2, g2, b2] = rgbaRef.value;
          doUpdateValue(toHexaString([r2, g2, b2, alpha]), "cursor");
          break;
        case "hsl":
          [_h2, s2, l2] = hslaRef.value;
          doUpdateValue(toHslaString([_h2, s2, l2, alpha]), "cursor");
          break;
      }
      displayedAlphaRef.value = alpha;
    }
    function doUpdateValue(value2, updateSource) {
      if (updateSource === "cursor") {
        upcomingValue = value2;
      } else {
        upcomingValue = null;
      }
      const { nTriggerFormChange, nTriggerFormInput } = formItem;
      const { onUpdateValue, "onUpdate:value": _onUpdateValue } = props;
      if (onUpdateValue)
        call(onUpdateValue, value2);
      if (_onUpdateValue)
        call(_onUpdateValue, value2);
      nTriggerFormChange();
      nTriggerFormInput();
      uncontrolledValueRef.value = value2;
    }
    function handleInputUpdateValue(value2) {
      doUpdateValue(value2, "input");
      void nextTick(handleComplete);
    }
    function handleComplete(pushStack = true) {
      const { value: value2 } = mergedValueRef;
      if (value2) {
        const { nTriggerFormChange, nTriggerFormInput } = formItem;
        const { onComplete } = props;
        if (onComplete) {
          onComplete(value2);
        }
        const { value: undoStack } = undoStackRef;
        const { value: valueIndex } = valueIndexRef;
        if (pushStack) {
          undoStack.splice(valueIndex + 1, undoStack.length, value2);
          valueIndexRef.value = valueIndex + 1;
        }
        nTriggerFormChange();
        nTriggerFormInput();
      }
    }
    function undo2() {
      const { value: valueIndex } = valueIndexRef;
      if (valueIndex - 1 < 0)
        return;
      doUpdateValue(undoStackRef.value[valueIndex - 1], "input");
      handleComplete(false);
      valueIndexRef.value = valueIndex - 1;
    }
    function redo2() {
      const { value: valueIndex } = valueIndexRef;
      if (valueIndex < 0 || valueIndex + 1 >= undoStackRef.value.length)
        return;
      doUpdateValue(undoStackRef.value[valueIndex + 1], "input");
      handleComplete(false);
      valueIndexRef.value = valueIndex + 1;
    }
    function handleClear() {
      doUpdateValue(null, "input");
      doUpdateShow(false);
    }
    function handleConfirm() {
      const { value: value2 } = mergedValueRef;
      const { onConfirm } = props;
      if (onConfirm) {
        onConfirm(value2);
      }
      doUpdateShow(false);
    }
    const undoableRef = computed(() => valueIndexRef.value >= 1);
    const redoableRef = computed(() => {
      const { value: undoStack } = undoStackRef;
      return undoStack.length > 1 && valueIndexRef.value < undoStack.length - 1;
    });
    watch(mergedShowRef, (value2) => {
      if (!value2) {
        undoStackRef.value = [mergedValueRef.value];
        valueIndexRef.value = 0;
      }
    });
    watchEffect(() => {
      if (upcomingValue && upcomingValue === mergedValueRef.value)
        ;
      else {
        const { value: value2 } = hsvaRef;
        if (value2) {
          displayedHueRef.value = value2[0];
          displayedAlphaRef.value = value2[3];
          displayedSvRef.value = [value2[1], value2[2]];
        }
      }
      upcomingValue = null;
    });
    const cssVarsRef = computed(() => {
      const { value: mergedSize } = mergedSizeRef;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { textColor, color, panelFontSize, boxShadow, border, borderRadius, dividerColor, [createKey("height", mergedSize)]: height, [createKey("fontSize", mergedSize)]: fontSize2 } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-text-color": textColor,
        "--n-color": color,
        "--n-panel-font-size": panelFontSize,
        "--n-font-size": fontSize2,
        "--n-box-shadow": boxShadow,
        "--n-border": border,
        "--n-border-radius": borderRadius,
        "--n-height": height,
        "--n-divider-color": dividerColor
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("color-picker", computed(() => {
      return mergedSizeRef.value[0];
    }), cssVarsRef, props) : void 0;
    function renderPanel() {
      var _a2;
      const { value: rgba2 } = rgbaRef;
      const { value: displayedHue } = displayedHueRef;
      const { internalActions, modes: modes2, actions } = props;
      const { value: mergedTheme } = themeRef;
      const { value: mergedClsPrefix } = mergedClsPrefixRef;
      return h$1("div", { class: [
        `${mergedClsPrefix}-color-picker-panel`,
        themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass.value
      ], onDragstart: (e25) => {
        e25.preventDefault();
      }, style: inlineThemeDisabled ? void 0 : cssVarsRef.value }, h$1("div", { class: `${mergedClsPrefix}-color-picker-control` }, h$1(Pallete, { clsPrefix: mergedClsPrefix, rgba: rgba2, displayedHue, displayedSv: displayedSvRef.value, onUpdateSV: handleUpdateSv, onComplete: handleComplete }), h$1("div", { class: `${mergedClsPrefix}-color-picker-preview` }, h$1("div", { class: `${mergedClsPrefix}-color-picker-preview__sliders` }, h$1(HueSlider, { clsPrefix: mergedClsPrefix, hue: displayedHue, onUpdateHue: handleUpdateHue, onComplete: handleComplete }), props.showAlpha ? h$1(AlphaSlider, { clsPrefix: mergedClsPrefix, rgba: rgba2, alpha: displayedAlphaRef.value, onUpdateAlpha: handleUpdateAlpha, onComplete: handleComplete }) : null), props.showPreview ? h$1(ColorPreview, { clsPrefix: mergedClsPrefix, mode: displayedModeRef.value, color: rgbaRef.value && toHexString(rgbaRef.value), onUpdateColor: (color) => {
        doUpdateValue(color, "input");
      } }) : null), h$1(ColorInput, { clsPrefix: mergedClsPrefix, showAlpha: props.showAlpha, mode: displayedModeRef.value, modes: modes2, onUpdateMode: handleUpdateDisplayedMode, value: mergedValueRef.value, valueArr: mergedValueArrRef.value, onUpdateValue: handleInputUpdateValue }), ((_a2 = props.swatches) === null || _a2 === void 0 ? void 0 : _a2.length) && h$1(ColorPickerSwatches, { clsPrefix: mergedClsPrefix, mode: displayedModeRef.value, swatches: props.swatches, onUpdateColor: (color) => {
        doUpdateValue(color, "input");
      } })), (actions === null || actions === void 0 ? void 0 : actions.length) ? h$1("div", { class: `${mergedClsPrefix}-color-picker-action` }, actions.includes("confirm") && h$1(NButton, { size: "small", onClick: handleConfirm, theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button }, { default: () => localeRef.value.confirm }), actions.includes("clear") && h$1(NButton, { size: "small", onClick: handleClear, disabled: !mergedValueRef.value, theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button }, { default: () => localeRef.value.clear })) : null, slots.action ? h$1("div", { class: `${mergedClsPrefix}-color-picker-action` }, { default: slots.action }) : internalActions ? h$1("div", { class: `${mergedClsPrefix}-color-picker-action` }, internalActions.includes("undo") && h$1(NButton, { size: "small", onClick: undo2, disabled: !undoableRef.value, theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button }, { default: () => localeRef.value.undo }), internalActions.includes("redo") && h$1(NButton, { size: "small", onClick: redo2, disabled: !redoableRef.value, theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button }, { default: () => localeRef.value.redo })) : null);
    }
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      namespace: namespaceRef,
      selfRef,
      hsla: hslaRef,
      rgba: rgbaRef,
      mergedShow: mergedShowRef,
      mergedDisabled: mergedDisabledRef,
      isMounted: isMounted(),
      adjustedTo: useAdjustedTo(props),
      mergedValue: mergedValueRef,
      handleTriggerClick() {
        doUpdateShow(true);
      },
      handleClickOutside(e25) {
        var _a2;
        if ((_a2 = selfRef.value) === null || _a2 === void 0 ? void 0 : _a2.contains(getPreciseEventTarget(e25))) {
          return;
        }
        doUpdateShow(false);
      },
      renderPanel,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const { $slots, mergedClsPrefix, onRender } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { class: [this.themeClass, `${mergedClsPrefix}-color-picker`], ref: "selfRef", style: this.cssVars }, h$1(VBinder, null, {
      default: () => [
        h$1(VTarget, null, {
          default: () => h$1(ColorPickerTrigger, { clsPrefix: mergedClsPrefix, value: this.mergedValue, hsla: this.hsla, disabled: this.mergedDisabled, onClick: this.handleTriggerClick }, {
            label: $slots.label
          })
        }),
        h$1(VFollower, { placement: this.placement, show: this.mergedShow, containerClass: this.namespace, teleportDisabled: this.adjustedTo === useAdjustedTo.tdkey, to: this.adjustedTo }, {
          default: () => h$1(Transition, { name: "fade-in-scale-up-transition", appear: this.isMounted }, {
            default: () => this.mergedShow ? withDirectives(this.renderPanel(), [
              [
                clickoutside$1,
                this.handleClickOutside,
                void 0,
                { capture: true }
              ]
            ]) : null
          })
        })
      ]
    }));
  }
});
var commonVariables$7 = {
  paddingSmall: "12px 16px 12px",
  paddingMedium: "19px 24px 20px",
  paddingLarge: "23px 32px 24px",
  paddingHuge: "27px 40px 28px",
  titleFontSizeSmall: "16px",
  titleFontSizeMedium: "18px",
  titleFontSizeLarge: "18px",
  titleFontSizeHuge: "18px",
  closeIconSize: "18px",
  closeSize: "22px"
};
const self$w = (vars) => {
  const { primaryColor, borderRadius, lineHeight: lineHeight2, fontSize: fontSize2, cardColor, textColor2, textColor1, dividerColor, fontWeightStrong, closeIconColor, closeIconColorHover, closeIconColorPressed, closeColorHover, closeColorPressed, modalColor, boxShadow1, popoverColor, actionColor } = vars;
  return Object.assign(Object.assign({}, commonVariables$7), {
    lineHeight: lineHeight2,
    color: cardColor,
    colorModal: modalColor,
    colorPopover: popoverColor,
    colorTarget: primaryColor,
    colorEmbedded: actionColor,
    colorEmbeddedModal: actionColor,
    colorEmbeddedPopover: actionColor,
    textColor: textColor2,
    titleTextColor: textColor1,
    borderColor: dividerColor,
    actionColor,
    titleFontWeight: fontWeightStrong,
    closeColorHover,
    closeColorPressed,
    closeBorderRadius: borderRadius,
    closeIconColor,
    closeIconColorHover,
    closeIconColorPressed,
    fontSizeSmall: fontSize2,
    fontSizeMedium: fontSize2,
    fontSizeLarge: fontSize2,
    fontSizeHuge: fontSize2,
    boxShadow: boxShadow1,
    borderRadius
  });
};
const cardLight = {
  name: "Card",
  common: commonLight,
  self: self$w
};
var cardLight$1 = cardLight;
var style$x = c$2([cB$1("card", `
 font-size: var(--n-font-size);
 line-height: var(--n-line-height);
 display: flex;
 flex-direction: column;
 width: 100%;
 box-sizing: border-box;
 position: relative;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 color: var(--n-text-color);
 word-break: break-word;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [asModal({
  background: "var(--n-color-modal)"
}), cM("hoverable", [c$2("&:hover", "box-shadow: var(--n-box-shadow);")]), cM("content-segmented", [c$2(">", [cE$1("content", {
  paddingTop: "var(--n-padding-bottom)"
})])]), cM("content-soft-segmented", [c$2(">", [cE$1("content", `
 margin: 0 var(--n-padding-left);
 padding: var(--n-padding-bottom) 0;
 `)])]), cM("footer-segmented", [c$2(">", [cE$1("footer", {
  paddingTop: "var(--n-padding-bottom)"
})])]), cM("footer-soft-segmented", [c$2(">", [cE$1("footer", `
 padding: var(--n-padding-bottom) 0;
 margin: 0 var(--n-padding-left);
 `)])]), c$2(">", [cB$1("card-header", `
 box-sizing: border-box;
 display: flex;
 align-items: center;
 font-size: var(--n-title-font-size);
 padding:
 var(--n-padding-top)
 var(--n-padding-left)
 var(--n-padding-bottom)
 var(--n-padding-left);
 `, [cE$1("main", `
 font-weight: var(--n-title-font-weight);
 transition: color .3s var(--n-bezier);
 flex: 1;
 min-width: 0;
 color: var(--n-title-text-color);
 `), cE$1("extra", `
 display: flex;
 align-items: center;
 font-size: var(--n-font-size);
 font-weight: 400;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), cE$1("close", `
 margin: 0 0 0 8px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), cE$1("action", `
 box-sizing: border-box;
 transition:
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 background-clip: padding-box;
 background-color: var(--n-action-color);
 `), cE$1("content", "flex: 1; min-width: 0;"), cE$1("content, footer", `
 box-sizing: border-box;
 padding: 0 var(--n-padding-left) var(--n-padding-bottom) var(--n-padding-left);
 font-size: var(--n-font-size);
 `, [c$2("&:first-child", {
  paddingTop: "var(--n-padding-bottom)"
})]), cE$1("action", `
 background-color: var(--n-action-color);
 padding: var(--n-padding-bottom) var(--n-padding-left);
 border-bottom-left-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 `)]), cB$1("card-cover", `
 overflow: hidden;
 width: 100%;
 border-radius: var(--n-border-radius) var(--n-border-radius) 0 0;
 `, [c$2("img", `
 display: block;
 width: 100%;
 `)]), cM("bordered", `
 border: 1px solid var(--n-border-color);
 `, [c$2("&:target", "border-color: var(--n-color-target);")]), cM("action-segmented", [c$2(">", [cE$1("action", [c$2("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), cM("content-segmented, content-soft-segmented", [c$2(">", [cE$1("content", {
  transition: "border-color 0.3s var(--n-bezier)"
}, [c$2("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), cM("footer-segmented, footer-soft-segmented", [c$2(">", [cE$1("footer", {
  transition: "border-color 0.3s var(--n-bezier)"
}, [c$2("&:not(:first-child)", {
  borderTop: "1px solid var(--n-border-color)"
})])])]), cM("embedded", `
 background-color: var(--n-color-embedded);
 `)]), insideModal(cB$1("card", `
 background: var(--n-color-modal);
 `, [cM("embedded", `
 background-color: var(--n-color-embedded-modal);
 `)])), insidePopover(cB$1("card", `
 background: var(--n-color-popover);
 `, [cM("embedded", `
 background-color: var(--n-color-embedded-popover);
 `)]))]);
const cardBaseProps = {
  title: String,
  contentStyle: [Object, String],
  headerStyle: [Object, String],
  headerExtraStyle: [Object, String],
  footerStyle: [Object, String],
  embedded: Boolean,
  segmented: {
    type: [Boolean, Object],
    default: false
  },
  size: {
    type: String,
    default: "medium"
  },
  bordered: {
    type: Boolean,
    default: true
  },
  closable: Boolean,
  hoverable: Boolean,
  role: String,
  onClose: [Function, Array],
  tag: {
    type: String,
    default: "div"
  }
};
const cardBasePropKeys = keysOf(cardBaseProps);
const cardProps = Object.assign(Object.assign({}, useTheme.props), cardBaseProps);
var NCard = defineComponent({
  name: "Card",
  props: cardProps,
  setup(props) {
    const handleCloseClick = () => {
      const { onClose } = props;
      if (onClose)
        call(onClose);
    };
    const { inlineThemeDisabled, mergedClsPrefixRef, mergedRtlRef } = useConfig(props);
    const themeRef = useTheme("Card", "-card", style$x, cardLight$1, props, mergedClsPrefixRef);
    const rtlEnabledRef = useRtl("Card", mergedRtlRef, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { size: size2 } = props;
      const { self: { color, colorModal, colorTarget, textColor, titleTextColor, titleFontWeight, borderColor, actionColor, borderRadius, lineHeight: lineHeight2, closeIconColor, closeIconColorHover, closeIconColorPressed, closeColorHover, closeColorPressed, closeBorderRadius, closeIconSize, closeSize, boxShadow, colorPopover, colorEmbedded, colorEmbeddedModal, colorEmbeddedPopover, [createKey("padding", size2)]: padding, [createKey("fontSize", size2)]: fontSize2, [createKey("titleFontSize", size2)]: titleFontSize }, common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 } } = themeRef.value;
      const { top: paddingTop, left: paddingLeft, bottom: paddingBottom } = getMargin(padding);
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-border-radius": borderRadius,
        "--n-color": color,
        "--n-color-modal": colorModal,
        "--n-color-popover": colorPopover,
        "--n-color-embedded": colorEmbedded,
        "--n-color-embedded-modal": colorEmbeddedModal,
        "--n-color-embedded-popover": colorEmbeddedPopover,
        "--n-color-target": colorTarget,
        "--n-text-color": textColor,
        "--n-line-height": lineHeight2,
        "--n-action-color": actionColor,
        "--n-title-text-color": titleTextColor,
        "--n-title-font-weight": titleFontWeight,
        "--n-close-icon-color": closeIconColor,
        "--n-close-icon-color-hover": closeIconColorHover,
        "--n-close-icon-color-pressed": closeIconColorPressed,
        "--n-close-color-hover": closeColorHover,
        "--n-close-color-pressed": closeColorPressed,
        "--n-border-color": borderColor,
        "--n-box-shadow": boxShadow,
        "--n-padding-top": paddingTop,
        "--n-padding-bottom": paddingBottom,
        "--n-padding-left": paddingLeft,
        "--n-font-size": fontSize2,
        "--n-title-font-size": titleFontSize,
        "--n-close-size": closeSize,
        "--n-close-icon-size": closeIconSize,
        "--n-close-border-radius": closeBorderRadius
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("card", computed(() => {
      return props.size[0];
    }), cssVarsRef, props) : void 0;
    return {
      rtlEnabled: rtlEnabledRef,
      mergedClsPrefix: mergedClsPrefixRef,
      mergedTheme: themeRef,
      handleCloseClick,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const { segmented, bordered, hoverable, mergedClsPrefix, rtlEnabled, onRender, embedded, tag: Component, $slots } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1(Component, { class: [
      `${mergedClsPrefix}-card`,
      this.themeClass,
      embedded && `${mergedClsPrefix}-card--embedded`,
      {
        [`${mergedClsPrefix}-card--rtl`]: rtlEnabled,
        [`${mergedClsPrefix}-card--content${typeof segmented !== "boolean" && segmented.content === "soft" ? "-soft" : ""}-segmented`]: segmented === true || segmented !== false && segmented.content,
        [`${mergedClsPrefix}-card--footer${typeof segmented !== "boolean" && segmented.footer === "soft" ? "-soft" : ""}-segmented`]: segmented === true || segmented !== false && segmented.footer,
        [`${mergedClsPrefix}-card--action-segmented`]: segmented === true || segmented !== false && segmented.action,
        [`${mergedClsPrefix}-card--bordered`]: bordered,
        [`${mergedClsPrefix}-card--hoverable`]: hoverable
      }
    ], style: this.cssVars, role: this.role }, resolveWrappedSlot($slots.cover, (children) => children && h$1("div", { class: `${mergedClsPrefix}-card-cover`, role: "none" }, children)), resolveWrappedSlot($slots.header, (children) => {
      return children || this.title || this.closable ? h$1("div", { class: `${mergedClsPrefix}-card-header`, style: this.headerStyle }, h$1("div", { class: `${mergedClsPrefix}-card-header__main`, role: "heading" }, children || this.title), resolveWrappedSlot($slots["header-extra"], (children2) => children2 && h$1("div", { class: `${mergedClsPrefix}-card-header__extra`, style: this.headerExtraStyle }, children2)), this.closable ? h$1(NBaseClose, { clsPrefix: mergedClsPrefix, class: `${mergedClsPrefix}-card-header__close`, onClick: this.handleCloseClick, absolute: true }) : null) : null;
    }), resolveWrappedSlot($slots.default, (children) => children && h$1("div", { class: `${mergedClsPrefix}-card__content`, style: this.contentStyle, role: "none" }, children)), resolveWrappedSlot($slots.footer, (children) => children && [
      h$1("div", { class: `${mergedClsPrefix}-card__footer`, style: this.footerStyle, role: "none" }, children)
    ]), resolveWrappedSlot($slots.action, (children) => children && h$1("div", { class: `${mergedClsPrefix}-card__action`, role: "none" }, children)));
  }
});
const self$v = (vars) => {
  return {
    dotSize: "8px",
    dotColor: "rgba(255, 255, 255, .3)",
    dotColorActive: "rgba(255, 255, 255, 1)",
    dotColorFocus: "rgba(255, 255, 255, .5)",
    dotLineWidth: "16px",
    dotLineWidthActive: "24px",
    arrowColor: "#eee"
  };
};
const carouselLight = {
  name: "Carousel",
  common: commonLight,
  self: self$v
};
var carouselLight$1 = carouselLight;
function addDuplicateSlides(slides) {
  const { length: length2 } = slides;
  if (length2 > 1) {
    slides.push(duplicateSlide(slides[0], 0, "append"));
    slides.unshift(duplicateSlide(slides[length2 - 1], length2 - 1, "prepend"));
    return slides;
  }
  return slides;
}
function duplicateSlide(child, index2, position) {
  return cloneVNode(child, {
    key: `carousel-item-duplicate-${index2}-${position}`
  });
}
function getDisplayIndex(current, length2, duplicatedable) {
  return !duplicatedable ? current : current === 0 ? length2 - 3 : current === length2 - 1 ? 0 : current - 1;
}
function getRealIndex(current, duplicatedable) {
  return !duplicatedable ? current : current + 1;
}
function getPrevIndex(current, length2, duplicatedable) {
  if (current < 0)
    return null;
  return current === 0 ? duplicatedable ? length2 - 1 : null : current - 1;
}
function getNextIndex(current, length2, duplicatedable) {
  if (current > length2 - 1)
    return null;
  return current === length2 - 1 ? duplicatedable ? 0 : null : current + 1;
}
function getDisplayTotalView(total, duplicatedable) {
  return duplicatedable && total > 3 ? total - 2 : total;
}
function isTouchEvent$1(e25) {
  return window.TouchEvent && e25 instanceof window.TouchEvent;
}
function calculateSize(element, innerOnly) {
  let { offsetWidth: width, offsetHeight: height } = element;
  if (innerOnly) {
    const style2 = getComputedStyle(element);
    width = width - parseFloat(style2.getPropertyValue("padding-left")) - parseFloat(style2.getPropertyValue("padding-right"));
    height = height - parseFloat(style2.getPropertyValue("padding-top")) - parseFloat(style2.getPropertyValue("padding-bottom"));
  }
  return { width, height };
}
function clampValue(value2, min, max) {
  return value2 < min ? min : value2 > max ? max : value2;
}
function resolveSpeed(value2) {
  if (value2 === void 0)
    return 0;
  if (typeof value2 === "number")
    return value2;
  const timeRE = /^((\d+)?\.?\d+?)(ms|s)?$/;
  const match2 = value2.match(timeRE);
  if (match2) {
    const [, number4, , unit = "ms"] = match2;
    return Number(number4) * (unit === "ms" ? 1 : 1e3);
  }
  return 0;
}
const carouselMethodsInjectionKey = createInjectionKey("n-carousel-methods");
const provideCarouselContext = (contextValue) => {
  provide(carouselMethodsInjectionKey, contextValue);
};
const useCarouselContext = (location = "unknown", component = "component") => {
  const CarouselContext = inject(carouselMethodsInjectionKey);
  if (!CarouselContext) {
    throwError(location, `\`${component}\` must be placed inside \`n-carousel\`.`);
  }
  return CarouselContext;
};
const carouselDotsProps = {
  total: {
    type: Number,
    default: 0
  },
  currentIndex: {
    type: Number,
    default: 0
  },
  dotType: {
    type: String,
    default: "dot"
  },
  trigger: {
    type: String,
    default: "click"
  },
  keyboard: Boolean
};
var NCarouselDots = defineComponent({
  name: "CarouselDots",
  props: carouselDotsProps,
  setup(props) {
    const { mergedClsPrefixRef } = useConfig(props);
    const dotElsRef = ref([]);
    const NCarousel2 = useCarouselContext();
    function handleKeydown(e25, current) {
      switch (e25.key) {
        case "Enter":
        case " ":
          e25.preventDefault();
          NCarousel2.to(current);
          return;
      }
      if (props.keyboard) {
        handleKeyboard(e25);
      }
    }
    function handleMouseenter(current) {
      if (props.trigger === "hover") {
        NCarousel2.to(current);
      }
    }
    function handleClick2(current) {
      if (props.trigger === "click") {
        NCarousel2.to(current);
      }
    }
    function handleKeyboard(e25) {
      var _a2;
      if (e25.shiftKey || e25.altKey || e25.ctrlKey || e25.metaKey) {
        return;
      }
      const nodeName = (_a2 = document.activeElement) === null || _a2 === void 0 ? void 0 : _a2.nodeName.toLowerCase();
      if (nodeName === "input" || nodeName === "textarea") {
        return;
      }
      const { code: keycode } = e25;
      const isVerticalNext = keycode === "PageUp" || keycode === "ArrowUp";
      const isVerticalPrev = keycode === "PageDown" || keycode === "ArrowDown";
      const isHorizontalNext = keycode === "PageUp" || keycode === "ArrowRight";
      const isHorizontalPrev = keycode === "PageDown" || keycode === "ArrowLeft";
      const vertical = NCarousel2.isVertical();
      const wantToNext = vertical ? isVerticalNext : isHorizontalNext;
      const wantToPrev = vertical ? isVerticalPrev : isHorizontalPrev;
      if (!wantToNext && !wantToPrev) {
        return;
      }
      e25.preventDefault();
      if (wantToNext && !NCarousel2.isNextDisabled()) {
        NCarousel2.next();
        focusDot(NCarousel2.currentIndexRef.value);
      } else if (wantToPrev && !NCarousel2.isPrevDisabled()) {
        NCarousel2.prev();
        focusDot(NCarousel2.currentIndexRef.value);
      }
    }
    function focusDot(index2) {
      var _a2;
      (_a2 = dotElsRef.value[index2]) === null || _a2 === void 0 ? void 0 : _a2.focus();
    }
    onBeforeUpdate(() => dotElsRef.value.length = 0);
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      dotEls: dotElsRef,
      handleKeydown,
      handleMouseenter,
      handleClick: handleClick2
    };
  },
  render() {
    const { mergedClsPrefix, dotEls } = this;
    return h$1("div", { class: [
      `${mergedClsPrefix}-carousel__dots`,
      `${mergedClsPrefix}-carousel__dots--${this.dotType}`
    ], role: "tablist" }, indexMap(this.total, (i2) => {
      const selected = i2 === this.currentIndex;
      return h$1("div", { "aria-selected": selected, ref: (el2) => dotEls.push(el2), role: "button", tabindex: "0", class: [
        `${mergedClsPrefix}-carousel__dot`,
        selected && `${mergedClsPrefix}-carousel__dot--active`
      ], key: i2, onClick: () => {
        this.handleClick(i2);
      }, onMouseenter: () => {
        this.handleMouseenter(i2);
      }, onKeydown: (e25) => {
        this.handleKeydown(e25, i2);
      } });
    }));
  }
});
const backwardIcon = h$1("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, h$1("g", { fill: "none" }, h$1("path", { d: "M10.26 3.2a.75.75 0 0 1 .04 1.06L6.773 8l3.527 3.74a.75.75 0 1 1-1.1 1.02l-4-4.25a.75.75 0 0 1 0-1.02l4-4.25a.75.75 0 0 1 1.06-.04z", fill: "currentColor" })));
const forwardIcon = h$1("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" }, h$1("g", { fill: "none" }, h$1("path", { d: "M5.74 3.2a.75.75 0 0 0-.04 1.06L9.227 8L5.7 11.74a.75.75 0 1 0 1.1 1.02l4-4.25a.75.75 0 0 0 0-1.02l-4-4.25a.75.75 0 0 0-1.06-.04z", fill: "currentColor" })));
var NCarouselArrow = defineComponent({
  name: "CarouselArrow",
  setup(props) {
    const { mergedClsPrefixRef } = useConfig(props);
    const { isVertical, isPrevDisabled, isNextDisabled, prev, next } = useCarouselContext();
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      isVertical,
      isPrevDisabled,
      isNextDisabled,
      prev,
      next
    };
  },
  render() {
    const { mergedClsPrefix } = this;
    return h$1("div", { class: `${mergedClsPrefix}-carousel__arrow-group` }, h$1("div", { class: [
      `${mergedClsPrefix}-carousel__arrow`,
      this.isPrevDisabled() && `${mergedClsPrefix}-carousel__arrow--disabled`
    ], role: "button", onClick: this.prev }, backwardIcon), h$1("div", { class: [
      `${mergedClsPrefix}-carousel__arrow`,
      this.isNextDisabled() && `${mergedClsPrefix}-carousel__arrow--disabled`
    ], role: "button", onClick: this.next }, forwardIcon));
  }
});
const CarouselItemName = "CarouselItem";
const isCarouselItem = (child) => {
  var _a2;
  return ((_a2 = child.type) === null || _a2 === void 0 ? void 0 : _a2.name) === CarouselItemName;
};
var NCarouselItem = defineComponent({
  name: CarouselItemName,
  setup(props) {
    const { mergedClsPrefixRef } = useConfig(props);
    const NCarousel2 = useCarouselContext(camelCase$1(CarouselItemName), `n-${camelCase$1(CarouselItemName)}`);
    const selfElRef = ref();
    const indexRef = computed(() => {
      const { value: selfEl } = selfElRef;
      return selfEl ? NCarousel2.getSlideIndex(selfEl) : -1;
    });
    const isPrevRef = computed(() => NCarousel2.isPrev(indexRef.value));
    const isNextRef = computed(() => NCarousel2.isNext(indexRef.value));
    const isActiveRef = computed(() => NCarousel2.isActive(indexRef.value));
    const styleRef = computed(() => NCarousel2.getSlideStyle(indexRef.value));
    onMounted(() => {
      NCarousel2.addSlide(selfElRef.value);
    });
    onBeforeUnmount(() => {
      NCarousel2.removeSlide(selfElRef.value);
    });
    function handleClick2(event) {
      const { value: index2 } = indexRef;
      if (index2 !== void 0) {
        NCarousel2 === null || NCarousel2 === void 0 ? void 0 : NCarousel2.onCarouselItemClick(index2, event);
      }
    }
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      selfElRef,
      isPrev: isPrevRef,
      isNext: isNextRef,
      isActive: isActiveRef,
      index: indexRef,
      style: styleRef,
      handleClick: handleClick2
    };
  },
  render() {
    var _a2;
    const { $slots: slots, mergedClsPrefix, isPrev, isNext, isActive, index: index2, style: style2 } = this;
    const className = [
      `${mergedClsPrefix}-carousel__slide`,
      {
        [`${mergedClsPrefix}-carousel__slide--current`]: isActive,
        [`${mergedClsPrefix}-carousel__slide--prev`]: isPrev,
        [`${mergedClsPrefix}-carousel__slide--next`]: isNext
      }
    ];
    return h$1("div", {
      ref: "selfElRef",
      class: className,
      role: "option",
      tabindex: "-1",
      "data-index": index2,
      "aria-hidden": !isActive,
      style: style2,
      onClickCapture: this.handleClick
    }, (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots, {
      isPrev,
      isNext,
      isActive,
      index: index2
    }));
  }
});
var style$w = cB$1("carousel", `
 position: relative;
 width: 100%;
 height: 100%;
 touch-action: pan-y;
 overflow: hidden;
`, [cE$1("slides", `
 display: flex;
 width: 100%;
 height: 100%;
 transition-timing-function: var(--n-bezier);
 transition-property: transform;
 `, [cE$1("slide", `
 flex-shrink: 0;
 position: relative;
 width: 100%;
 height: 100%;
 outline: none;
 overflow: hidden;
 `, [c$2("> img", `
 display: block;
 `)])]), cE$1("dots", `
 position: absolute;
 display: flex;
 flex-wrap: nowrap;
 `, [cM("dot", [cE$1("dot", `
 height: var(--n-dot-size);
 width: var(--n-dot-size);
 background-color: var(--n-dot-color);
 border-radius: 50%;
 cursor: pointer;
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [c$2("&:focus", `
 background-color: var(--n-dot-color-focus);
 `), cM("active", `
 background-color: var(--n-dot-color-active);
 `)])]), cM("line", [cE$1("dot", `
 border-radius: 9999px;
 width: var(--n-dot-line-width);
 height: 4px;
 background-color: var(--n-dot-color);
 cursor: pointer;
 transition:
 width .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [c$2("&:focus", `
 background-color: var(--n-dot-color-focus);
 `), cM("active", `
 width: var(--n-dot-line-width-active);
 background-color: var(--n-dot-color-active);
 `)])])]), cE$1("arrow", `
 transition: background-color .3s var(--n-bezier);
 cursor: pointer;
 height: 28px;
 width: 28px;
 display: flex;
 align-items: center;
 justify-content: center;
 background-color: rgba(255, 255, 255, .2);
 color: var(--n-arrow-color);
 border-radius: 8px;
 user-select: none;
 -webkit-user-select: none;
 font-size: 18px;
 `, [c$2("svg", `
 height: 1em;
 width: 1em;
 `), c$2("&:hover", `
 background-color: rgba(255, 255, 255, .3);
 `)]), cM("vertical", `
 touch-action: pan-x;
 `, [cE$1("slides", `
 flex-direction: column;
 `), cM("fade", [cE$1("slide", `
 top: 50%;
 left: unset;
 transform: translateY(-50%);
 `)]), cM("card", [cE$1("slide", `
 top: 50%;
 left: unset;
 transform: translateY(-50%) translateZ(-400px);
 `, [cM("current", `
 transform: translateY(-50%) translateZ(0);
 `), cM("prev", `
 transform: translateY(-100%) translateZ(-200px);
 `), cM("next", `
 transform: translateY(0%) translateZ(-200px);
 `)])])]), cM("usercontrol", [cE$1("slides", [c$2(">", [c$2("div", `
 position: absolute;
 top: 50%;
 left: 50%;
 width: 100%;
 height: 100%;
 transform: translate(-50%, -50%);
 `)])])]), cM("left", [cE$1("dots", `
 transform: translateY(-50%);
 top: 50%;
 left: 12px;
 flex-direction: column;
 `, [cM("line", [cE$1("dot", `
 width: 4px;
 height: var(--n-dot-line-width);
 margin: 4px 0;
 transition:
 height .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [cM("active", `
 height: var(--n-dot-line-width-active);
 `)])])]), cE$1("dot", `
 margin: 4px 0;
 `)]), cE$1("arrow-group", `
 position: absolute;
 display: flex;
 flex-wrap: nowrap;
 `), cM("vertical", [cE$1("arrow", `
 transform: rotate(90deg);
 `)]), cM("show-arrow", [cM("bottom", [cE$1("dots", `
 transform: translateX(0);
 bottom: 18px;
 left: 18px;
 `)]), cM("top", [cE$1("dots", `
 transform: translateX(0);
 top: 18px;
 left: 18px;
 `)]), cM("left", [cE$1("dots", `
 transform: translateX(0);
 top: 18px;
 left: 18px;
 `)]), cM("right", [cE$1("dots", `
 transform: translateX(0);
 top: 18px;
 right: 18px;
 `)])]), cM("left", [cE$1("arrow-group", `
 bottom: 12px;
 left: 12px;
 flex-direction: column;
 `, [c$2("> *:first-child", `
 margin-bottom: 12px;
 `)])]), cM("right", [cE$1("dots", `
 transform: translateY(-50%);
 top: 50%;
 right: 12px;
 flex-direction: column;
 `, [cM("line", [cE$1("dot", `
 width: 4px;
 height: var(--n-dot-line-width);
 margin: 4px 0;
 transition:
 height .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 `, [cM("active", `
 height: var(--n-dot-line-width-active);
 `)])])]), cE$1("dot", `
 margin: 4px 0;
 `), cE$1("arrow-group", `
 bottom: 12px;
 right: 12px;
 flex-direction: column;
 `, [c$2("> *:first-child", `
 margin-bottom: 12px;
 `)])]), cM("top", [cE$1("dots", `
 transform: translateX(-50%);
 top: 12px;
 left: 50%;
 `, [cM("line", [cE$1("dot", `
 margin: 0 4px;
 `)])]), cE$1("dot", `
 margin: 0 4px;
 `), cE$1("arrow-group", `
 top: 12px;
 right: 12px;
 `, [c$2("> *:first-child", `
 margin-right: 12px;
 `)])]), cM("bottom", [cE$1("dots", `
 transform: translateX(-50%);
 bottom: 12px;
 left: 50%;
 `, [cM("line", [cE$1("dot", `
 margin: 0 4px;
 `)])]), cE$1("dot", `
 margin: 0 4px;
 `), cE$1("arrow-group", `
 bottom: 12px;
 right: 12px;
 `, [c$2("> *:first-child", `
 margin-right: 12px;
 `)])]), cM("fade", [cE$1("slide", `
 position: absolute;
 opacity: 0;
 transition-property: opacity;
 pointer-events: none;
 `, [cM("current", `
 opacity: 1;
 pointer-events: auto;
 `)])]), cM("card", [cE$1("slides", `
 perspective: 1000px;
 `), cE$1("slide", `
 position: absolute;
 left: 50%;
 opacity: 0;
 transform: translateX(-50%) translateZ(-400px);
 transition-property: opacity, transform;
 `, [cM("current", `
 opacity: 1;
 transform: translateX(-50%) translateZ(0);
 z-index: 1;
 `), cM("prev", `
 opacity: 0.4;
 transform: translateX(-100%) translateZ(-200px);
 `), cM("next", `
 opacity: 0.4;
 transform: translateX(0%) translateZ(-200px);
 `)])])]);
const transitionProperties = [
  "transitionDuration",
  "transitionTimingFunction"
];
const carouselProps = Object.assign(Object.assign({}, useTheme.props), { defaultIndex: {
  type: Number,
  default: 0
}, currentIndex: Number, showArrow: Boolean, dotType: {
  type: String,
  default: "dot"
}, dotPlacement: {
  type: String,
  default: "bottom"
}, slidesPerView: {
  type: [Number, String],
  default: 1
}, spaceBetween: {
  type: Number,
  default: 0
}, centeredSlides: Boolean, direction: {
  type: String,
  default: "horizontal"
}, autoplay: Boolean, interval: {
  type: Number,
  default: 5e3
}, loop: {
  type: Boolean,
  default: true
}, effect: {
  type: String,
  default: "slide"
}, showDots: {
  type: Boolean,
  default: true
}, trigger: {
  type: String,
  default: "click"
}, transitionStyle: {
  type: Object,
  default: () => ({
    transitionDuration: "300ms"
  })
}, transitionProps: Object, draggable: Boolean, prevSlideStyle: [Object, String], nextSlideStyle: [Object, String], touchable: {
  type: Boolean,
  default: true
}, mousewheel: Boolean, keyboard: Boolean, "onUpdate:currentIndex": Function, onUpdateCurrentIndex: Function });
let globalDragging = false;
var NCarousel = defineComponent({
  name: "Carousel",
  props: carouselProps,
  setup(props) {
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const selfElRef = ref(null);
    const slidesElRef = ref(null);
    const slideElsRef = ref([]);
    const slideVNodesRef = { value: [] };
    const verticalRef = computed(() => props.direction === "vertical");
    const sizeAxisRef = computed(() => verticalRef.value ? "height" : "width");
    const spaceAxisRef = computed(() => verticalRef.value ? "bottom" : "right");
    const sequenceLayoutRef = computed(() => props.effect === "slide");
    const duplicatedableRef = computed(() => props.loop && props.slidesPerView === 1 && sequenceLayoutRef.value);
    const userWantsControlRef = computed(() => props.effect === "custom");
    const displaySlidesPerViewRef = computed(() => !sequenceLayoutRef.value || props.centeredSlides ? 1 : props.slidesPerView);
    const realSlidesPerViewRef = computed(() => userWantsControlRef.value ? 1 : props.slidesPerView);
    const autoSlideSizeRef = computed(() => displaySlidesPerViewRef.value === "auto" || props.slidesPerView === "auto" && props.centeredSlides);
    const perViewSizeRef = ref({ width: 0, height: 0 });
    const slideSizesRef = computed(() => {
      const { value: slidesEls } = slideElsRef;
      if (!slidesEls.length)
        return [];
      const { value: autoSlideSize } = autoSlideSizeRef;
      if (autoSlideSize) {
        return slidesEls.map((slide) => calculateSize(slide));
      }
      const { value: slidesPerView } = realSlidesPerViewRef;
      const { value: perViewSize } = perViewSizeRef;
      const { value: axis } = sizeAxisRef;
      let axisSize = perViewSize[axis];
      if (slidesPerView !== "auto") {
        const { spaceBetween } = props;
        const remaining = axisSize - (slidesPerView - 1) * spaceBetween;
        const percentage2 = 1 / Math.max(1, slidesPerView);
        axisSize = remaining * percentage2;
      }
      const slideSize = Object.assign(Object.assign({}, perViewSize), { [axis]: axisSize });
      return slidesEls.map(() => slideSize);
    });
    const slideTranlatesRef = computed(() => {
      const { value: slideSizes } = slideSizesRef;
      if (!slideSizes.length)
        return [];
      const { centeredSlides, spaceBetween } = props;
      const { value: axis } = sizeAxisRef;
      const { [axis]: perViewSize } = perViewSizeRef.value;
      let previousTranslate2 = 0;
      return slideSizes.map(({ [axis]: slideSize }) => {
        let translate = previousTranslate2;
        if (centeredSlides) {
          translate += (slideSize - perViewSize) / 2;
        }
        previousTranslate2 += slideSize + spaceBetween;
        return translate;
      });
    });
    const isMountedRef = ref(false);
    const transitionStyleRef = computed(() => {
      const { transitionStyle } = props;
      return transitionStyle ? keep(transitionStyle, transitionProperties) : {};
    });
    const speedRef = computed(() => userWantsControlRef.value ? 0 : resolveSpeed(transitionStyleRef.value.transitionDuration));
    const slideStylesRef = computed(() => {
      const { value: slidesEls } = slideElsRef;
      if (!slidesEls.length)
        return [];
      const useComputedSize = !(autoSlideSizeRef.value || realSlidesPerViewRef.value === 1);
      const getSlideSize = (index2) => {
        if (useComputedSize) {
          const { value: axis } = sizeAxisRef;
          return {
            [axis]: `${slideSizesRef.value[index2][axis]}px`
          };
        }
      };
      if (userWantsControlRef.value) {
        return slidesEls.map((_2, i2) => getSlideSize(i2));
      }
      const { effect, spaceBetween } = props;
      const { value: spaceAxis } = spaceAxisRef;
      return slidesEls.reduce((styles2, _2, i2) => {
        const style2 = Object.assign(Object.assign({}, getSlideSize(i2)), { [`margin-${spaceAxis}`]: `${spaceBetween}px` });
        styles2.push(style2);
        if (isMountedRef.value && (effect === "fade" || effect === "card")) {
          Object.assign(style2, transitionStyleRef.value);
        }
        return styles2;
      }, []);
    });
    const totalViewRef = computed(() => {
      const { value: slidesPerView } = displaySlidesPerViewRef;
      const { length: totalSlides } = slideElsRef.value;
      if (slidesPerView !== "auto") {
        return Math.max(totalSlides - slidesPerView, 0) + 1;
      } else {
        const { value: slideSizes } = slideSizesRef;
        const { length: length2 } = slideSizes;
        if (!length2)
          return totalSlides;
        const { value: translates } = slideTranlatesRef;
        const { value: axis } = sizeAxisRef;
        const perViewSize = perViewSizeRef.value[axis];
        let lastViewSize = slideSizes[slideSizes.length - 1][axis];
        let i2 = length2;
        while (i2 > 1 && lastViewSize < perViewSize) {
          i2--;
          lastViewSize += translates[i2] - translates[i2 - 1];
        }
        return clampValue(i2 + 1, 1, length2);
      }
    });
    const displayTotalViewRef = computed(() => getDisplayTotalView(totalViewRef.value, duplicatedableRef.value));
    const defaultRealIndex = getRealIndex(props.defaultIndex, duplicatedableRef.value);
    const uncontrolledDisplayIndexRef = ref(getDisplayIndex(defaultRealIndex, totalViewRef.value, duplicatedableRef.value));
    const mergedDisplayIndexRef = useMergedState(toRef(props, "currentIndex"), uncontrolledDisplayIndexRef);
    const realIndexRef = computed(() => getRealIndex(mergedDisplayIndexRef.value, duplicatedableRef.value));
    function toRealIndex(index2) {
      var _a2, _b2;
      index2 = clampValue(index2, 0, totalViewRef.value - 1);
      const displayIndex = getDisplayIndex(index2, totalViewRef.value, duplicatedableRef.value);
      const { value: lastDisplayIndex } = mergedDisplayIndexRef;
      if (displayIndex !== mergedDisplayIndexRef.value) {
        uncontrolledDisplayIndexRef.value = displayIndex;
        (_a2 = props["onUpdate:currentIndex"]) === null || _a2 === void 0 ? void 0 : _a2.call(props, displayIndex, lastDisplayIndex);
        (_b2 = props.onUpdateCurrentIndex) === null || _b2 === void 0 ? void 0 : _b2.call(props, displayIndex, lastDisplayIndex);
      }
    }
    function getRealPrevIndex(index2 = realIndexRef.value) {
      return getPrevIndex(index2, totalViewRef.value, props.loop);
    }
    function getRealNextIndex(index2 = realIndexRef.value) {
      return getNextIndex(index2, totalViewRef.value, props.loop);
    }
    function isRealPrev(slideOrIndex) {
      const index2 = getSlideIndex(slideOrIndex);
      return index2 !== null && getRealPrevIndex() === index2;
    }
    function isRealNext(slideOrIndex) {
      const index2 = getSlideIndex(slideOrIndex);
      return index2 !== null && getRealNextIndex() === index2;
    }
    function isRealActive(slideOrIndex) {
      return realIndexRef.value === getSlideIndex(slideOrIndex);
    }
    function isDisplayActive(index2) {
      return mergedDisplayIndexRef.value === index2;
    }
    function isPrevDisabled() {
      return getRealPrevIndex() === null;
    }
    function isNextDisabled() {
      return getRealNextIndex() === null;
    }
    function to2(index2) {
      const realIndex = clampValue(getRealIndex(index2, duplicatedableRef.value), 0, totalViewRef.value);
      if (index2 !== mergedDisplayIndexRef.value || realIndex !== realIndexRef.value) {
        toRealIndex(realIndex);
      }
    }
    function prev() {
      const prevIndex = getRealPrevIndex();
      if (prevIndex !== null)
        toRealIndex(prevIndex);
    }
    function next() {
      const nextIndex = getRealNextIndex();
      if (nextIndex !== null)
        toRealIndex(nextIndex);
    }
    function prevIfSlideTransitionEnd() {
      if (!inTransition || !duplicatedableRef.value)
        prev();
    }
    function nextIfSlideTransitionEnd() {
      if (!inTransition || !duplicatedableRef.value)
        next();
    }
    let inTransition = false;
    let previousTranslate = 0;
    const translateStyleRef = ref({});
    function updateTranslate(translate, speed = 0) {
      translateStyleRef.value = Object.assign({}, transitionStyleRef.value, {
        transform: verticalRef.value ? `translateY(${-translate}px)` : `translateX(${-translate}px)`,
        transitionDuration: `${speed}ms`
      });
    }
    function fixTranslate(speed = 0) {
      if (sequenceLayoutRef.value) {
        translateTo(realIndexRef.value, speed);
      } else if (previousTranslate !== 0) {
        if (!inTransition && speed > 0) {
          inTransition = true;
        }
        updateTranslate(previousTranslate = 0, speed);
      }
    }
    function translateTo(index2, speed) {
      const translate = getTranslate(index2);
      if (translate !== previousTranslate && speed > 0) {
        inTransition = true;
      }
      previousTranslate = getTranslate(realIndexRef.value);
      updateTranslate(translate, speed);
    }
    function getTranslate(index2) {
      let translate;
      if (index2 >= totalViewRef.value - 1) {
        translate = getLastViewTranslate();
      } else {
        translate = slideTranlatesRef.value[index2] || 0;
      }
      return translate;
    }
    function getLastViewTranslate() {
      if (displaySlidesPerViewRef.value === "auto") {
        const { value: axis } = sizeAxisRef;
        const { [axis]: perViewSize } = perViewSizeRef.value;
        const { value: translates } = slideTranlatesRef;
        const lastTranslate = translates[translates.length - 1];
        let overallSize;
        if (lastTranslate === void 0) {
          overallSize = perViewSize;
        } else {
          const { value: slideSizes } = slideSizesRef;
          overallSize = lastTranslate + slideSizes[slideSizes.length - 1][axis];
        }
        return overallSize - perViewSize;
      } else {
        const { value: translates } = slideTranlatesRef;
        return translates[totalViewRef.value - 1] || 0;
      }
    }
    const carouselContext = {
      currentIndexRef: mergedDisplayIndexRef,
      to: to2,
      prev: prevIfSlideTransitionEnd,
      next: nextIfSlideTransitionEnd,
      isVertical: () => verticalRef.value,
      isHorizontal: () => !verticalRef.value,
      isPrev: isRealPrev,
      isNext: isRealNext,
      isActive: isRealActive,
      isPrevDisabled,
      isNextDisabled,
      getSlideIndex,
      getSlideStyle,
      addSlide,
      removeSlide,
      onCarouselItemClick
    };
    provideCarouselContext(carouselContext);
    function addSlide(slide) {
      if (!slide)
        return;
      slideElsRef.value.push(slide);
    }
    function removeSlide(slide) {
      if (!slide)
        return;
      const index2 = getSlideIndex(slide);
      if (index2 !== -1) {
        slideElsRef.value.splice(index2, 1);
      }
    }
    function getSlideIndex(slideOrIndex) {
      return typeof slideOrIndex === "number" ? slideOrIndex : slideOrIndex ? slideElsRef.value.indexOf(slideOrIndex) : -1;
    }
    function getSlideStyle(slide) {
      const index2 = getSlideIndex(slide);
      if (index2 !== -1) {
        const styles2 = [slideStylesRef.value[index2]];
        const isPrev = carouselContext.isPrev(index2);
        const isNext = carouselContext.isNext(index2);
        if (isPrev) {
          styles2.push(props.prevSlideStyle || "");
        }
        if (isNext) {
          styles2.push(props.nextSlideStyle || "");
        }
        return normalizeStyle(styles2);
      }
    }
    function onCarouselItemClick(index2, event) {
      let allowClick = !inTransition && !dragging && !isEffectiveDrag;
      if (props.effect === "card" && allowClick && !isRealActive(index2)) {
        to2(index2);
        allowClick = false;
      }
      if (!allowClick) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
    let autoplayTimer = null;
    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }
    function resetAutoplay() {
      stopAutoplay();
      const disabled = !props.autoplay || displayTotalViewRef.value < 2;
      if (!disabled) {
        autoplayTimer = window.setInterval(next, props.interval);
      }
    }
    let dragStartX = 0;
    let dragStartY = 0;
    let dragOffset = 0;
    let dragStartTime = 0;
    let dragging = false;
    let isEffectiveDrag = false;
    function handleTouchstart(event) {
      var _a2;
      if (globalDragging)
        return;
      if (!((_a2 = slidesElRef.value) === null || _a2 === void 0 ? void 0 : _a2.contains(getPreciseEventTarget(event)))) {
        return;
      }
      globalDragging = true;
      dragging = true;
      isEffectiveDrag = false;
      dragStartTime = Date.now();
      stopAutoplay();
      if (event.type !== "touchstart" && !event.target.isContentEditable) {
        event.preventDefault();
      }
      const touchEvent = isTouchEvent$1(event) ? event.touches[0] : event;
      if (verticalRef.value) {
        dragStartY = touchEvent.clientY;
      } else {
        dragStartX = touchEvent.clientX;
      }
      if (props.touchable) {
        on$1("touchmove", document, handleTouchmove, { passive: true });
        on$1("touchend", document, handleTouchend);
        on$1("touchcancel", document, handleTouchend);
      }
      if (props.draggable) {
        on$1("mousemove", document, handleTouchmove);
        on$1("mouseup", document, handleTouchend);
      }
    }
    function handleTouchmove(event) {
      const { value: vertical } = verticalRef;
      const { value: axis } = sizeAxisRef;
      const touchEvent = isTouchEvent$1(event) ? event.touches[0] : event;
      const offset = vertical ? touchEvent.clientY - dragStartY : touchEvent.clientX - dragStartX;
      const perViewSize = perViewSizeRef.value[axis];
      dragOffset = clampValue(offset, -perViewSize, perViewSize);
      if (event.cancelable) {
        event.preventDefault();
      }
      if (sequenceLayoutRef.value) {
        updateTranslate(previousTranslate - dragOffset, 0);
      }
    }
    function handleTouchend() {
      const { value: realIndex } = realIndexRef;
      let currentIndex = realIndex;
      if (!inTransition && dragOffset !== 0 && sequenceLayoutRef.value) {
        const currentTranslate = previousTranslate - dragOffset;
        const translates = [
          ...slideTranlatesRef.value.slice(0, totalViewRef.value - 1),
          getLastViewTranslate()
        ];
        let prevOffset = null;
        for (let i2 = 0; i2 < translates.length; i2++) {
          const offset = Math.abs(translates[i2] - currentTranslate);
          if (prevOffset !== null && prevOffset < offset) {
            break;
          }
          prevOffset = offset;
          currentIndex = i2;
        }
      }
      if (currentIndex === realIndex) {
        const timeElapsed = Date.now() - dragStartTime;
        const { value: axis } = sizeAxisRef;
        const perViewSize = perViewSizeRef.value[axis];
        if (dragOffset > perViewSize / 2 || dragOffset / timeElapsed > 0.4) {
          currentIndex = getRealPrevIndex(realIndex);
        } else if (dragOffset < -perViewSize / 2 || dragOffset / timeElapsed < -0.4) {
          currentIndex = getRealNextIndex(realIndex);
        }
      }
      if (currentIndex !== null && currentIndex !== realIndex) {
        isEffectiveDrag = true;
        toRealIndex(currentIndex);
        void nextTick(() => {
          if (!duplicatedableRef.value || uncontrolledDisplayIndexRef.value !== mergedDisplayIndexRef.value) {
            fixTranslate(speedRef.value);
          }
        });
      } else {
        fixTranslate(speedRef.value);
      }
      resetDragStatus();
      resetAutoplay();
    }
    function resetDragStatus() {
      if (dragging) {
        globalDragging = false;
      }
      dragging = false;
      dragStartX = 0;
      dragStartY = 0;
      dragOffset = 0;
      dragStartTime = 0;
      off("touchmove", document, handleTouchmove);
      off("touchend", document, handleTouchend);
      off("touchcancel", document, handleTouchend);
      off("mousemove", document, handleTouchmove);
      off("mouseup", document, handleTouchend);
    }
    function handleTransitionEnd() {
      if (sequenceLayoutRef.value && inTransition) {
        const { value: realIndex } = realIndexRef;
        translateTo(realIndex, 0);
      } else {
        resetAutoplay();
      }
      if (sequenceLayoutRef.value) {
        translateStyleRef.value.transitionDuration = "0ms";
      }
      inTransition = false;
    }
    function handleMousewheel(event) {
      event.preventDefault();
      if (inTransition)
        return;
      let { deltaX, deltaY } = event;
      if (event.shiftKey && !deltaX) {
        deltaX = deltaY;
      }
      const prevMultiplier = -1;
      const nextMultiplier = 1;
      const m2 = (deltaX || deltaY) > 0 ? nextMultiplier : prevMultiplier;
      let rx2 = 0;
      let ry2 = 0;
      if (verticalRef.value) {
        ry2 = m2;
      } else {
        rx2 = m2;
      }
      const responseStep = 10;
      if (ry2 * deltaY >= responseStep || rx2 * deltaX >= responseStep) {
        if (m2 === nextMultiplier && !isNextDisabled()) {
          next();
        } else if (m2 === prevMultiplier && !isPrevDisabled()) {
          prev();
        }
      }
    }
    function handleResize() {
      perViewSizeRef.value = calculateSize(selfElRef.value, true);
      resetAutoplay();
    }
    function handleSlideResize() {
      var _a2, _b2;
      if (autoSlideSizeRef.value) {
        (_b2 = (_a2 = slideSizesRef.effect).scheduler) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
        slideSizesRef.effect.run();
      }
    }
    function handleMouseenter() {
      if (props.autoplay) {
        stopAutoplay();
      }
    }
    function handleMouseleave() {
      if (props.autoplay) {
        resetAutoplay();
      }
    }
    onMounted(() => {
      watchEffect(resetAutoplay);
      requestAnimationFrame(() => isMountedRef.value = true);
    });
    onBeforeUnmount(() => {
      resetDragStatus();
      stopAutoplay();
    });
    onUpdated(() => {
      const { value: slidesEls } = slideElsRef;
      const { value: slideVNodes } = slideVNodesRef;
      const indexMap2 = new Map();
      const getDisplayIndex2 = (el2) => indexMap2.has(el2) ? indexMap2.get(el2) : -1;
      let isChanged = false;
      for (let i2 = 0; i2 < slidesEls.length; i2++) {
        const index2 = slideVNodes.findIndex((v2) => v2.el === slidesEls[i2]);
        if (index2 !== i2) {
          isChanged = true;
        }
        indexMap2.set(slidesEls[i2], index2);
      }
      if (isChanged) {
        slidesEls.sort((a2, b2) => getDisplayIndex2(a2) - getDisplayIndex2(b2));
      }
    });
    watch(realIndexRef, (realIndex, lastRealIndex) => {
      if (realIndex === lastRealIndex)
        return;
      resetAutoplay();
      if (sequenceLayoutRef.value) {
        if (duplicatedableRef.value && displayTotalViewRef.value > 2) {
          const { value: length2 } = totalViewRef;
          if (realIndex === length2 - 2 && lastRealIndex === 1) {
            realIndex = 0;
          } else if (realIndex === 1 && lastRealIndex === length2 - 2) {
            realIndex = length2 - 1;
          }
        }
        translateTo(realIndex, speedRef.value);
      } else {
        fixTranslate();
      }
    }, { immediate: true });
    watch([duplicatedableRef, displaySlidesPerViewRef], () => void nextTick(() => {
      toRealIndex(realIndexRef.value);
    }));
    watch(slideTranlatesRef, () => {
      sequenceLayoutRef.value && fixTranslate();
    }, {
      deep: true
    });
    watch(sequenceLayoutRef, (value2) => {
      if (!value2) {
        inTransition = false;
        updateTranslate(previousTranslate = 0);
      } else {
        fixTranslate();
      }
    });
    const slidesControlListenersRef = computed(() => {
      return {
        onTouchstartPassive: props.touchable ? handleTouchstart : void 0,
        onMousedown: props.draggable ? handleTouchstart : void 0,
        onWheel: props.mousewheel ? handleMousewheel : void 0
      };
    });
    const arrowSlotPropsRef = computed(() => Object.assign(Object.assign({}, keep(carouselContext, [
      "to",
      "prev",
      "next",
      "isPrevDisabled",
      "isNextDisabled"
    ])), { total: displayTotalViewRef.value, currentIndex: mergedDisplayIndexRef.value }));
    const dotSlotPropsRef = computed(() => ({
      total: displayTotalViewRef.value,
      currentIndex: mergedDisplayIndexRef.value,
      to: carouselContext.to
    }));
    const caroulseExposedMethod = {
      getCurrentIndex: () => mergedDisplayIndexRef.value,
      to: to2,
      prev,
      next
    };
    const themeRef = useTheme("Carousel", "-carousel", style$w, carouselLight$1, props, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { dotSize, dotColor, dotColorActive, dotColorFocus, dotLineWidth, dotLineWidthActive, arrowColor } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-dot-color": dotColor,
        "--n-dot-color-focus": dotColorFocus,
        "--n-dot-color-active": dotColorActive,
        "--n-dot-size": dotSize,
        "--n-dot-line-width": dotLineWidth,
        "--n-dot-line-width-active": dotLineWidthActive,
        "--n-arrow-color": arrowColor
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("carousel", void 0, cssVarsRef, props) : void 0;
    return Object.assign(Object.assign({
      mergedClsPrefix: mergedClsPrefixRef,
      selfElRef,
      slidesElRef,
      slideVNodes: slideVNodesRef,
      duplicatedable: duplicatedableRef,
      userWantsControl: userWantsControlRef,
      autoSlideSize: autoSlideSizeRef,
      displayIndex: mergedDisplayIndexRef,
      realIndex: realIndexRef,
      slideStyles: slideStylesRef,
      translateStyle: translateStyleRef,
      slidesControlListeners: slidesControlListenersRef,
      handleTransitionEnd,
      handleResize,
      handleSlideResize,
      handleMouseenter,
      handleMouseleave,
      isActive: isDisplayActive,
      arrowSlotProps: arrowSlotPropsRef,
      dotSlotProps: dotSlotPropsRef
    }, caroulseExposedMethod), { cssVars: inlineThemeDisabled ? void 0 : cssVarsRef, themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass, onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender });
  },
  render() {
    var _a2;
    const { mergedClsPrefix, showArrow, userWantsControl, slideStyles, dotType, dotPlacement, slidesControlListeners, transitionProps = {}, arrowSlotProps, dotSlotProps, $slots: { default: defaultSlot, dots: dotsSlot, arrow: arrowSlot } } = this;
    const children = defaultSlot && flatten$4(defaultSlot()) || [];
    let slides = filterCarouselItem(children);
    if (!slides.length) {
      slides = children.map((ch2) => h$1(NCarouselItem, null, {
        default: () => cloneVNode(ch2)
      }));
    }
    if (this.duplicatedable) {
      slides = addDuplicateSlides(slides);
    }
    this.slideVNodes.value = slides;
    if (this.autoSlideSize) {
      slides = slides.map((slide) => h$1(VResizeObserver, { onResize: this.handleSlideResize }, {
        default: () => slide
      }));
    }
    (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
    return h$1("div", Object.assign({ ref: "selfElRef", class: [
      this.themeClass,
      `${mergedClsPrefix}-carousel`,
      this.direction === "vertical" && `${mergedClsPrefix}-carousel--vertical`,
      this.showArrow && `${mergedClsPrefix}-carousel--show-arrow`,
      `${mergedClsPrefix}-carousel--${dotPlacement}`,
      `${mergedClsPrefix}-carousel--${this.direction}`,
      `${mergedClsPrefix}-carousel--${this.effect}`,
      userWantsControl && `${mergedClsPrefix}-carousel--usercontrol`
    ], style: this.cssVars }, slidesControlListeners, { onMouseenter: this.handleMouseenter, onMouseleave: this.handleMouseleave }), h$1(VResizeObserver, { onResize: this.handleResize }, {
      default: () => h$1("div", { ref: "slidesElRef", class: `${mergedClsPrefix}-carousel__slides`, role: "listbox", style: this.translateStyle, onTransitionend: this.handleTransitionEnd }, userWantsControl ? slides.map((slide, i2) => h$1("div", { style: slideStyles[i2], key: i2 }, withDirectives(h$1(Transition, Object.assign({}, transitionProps), {
        default: () => slide
      }), [[vShow, this.isActive(i2)]]))) : slides)
    }), this.showDots && dotSlotProps.total > 1 && resolveSlotWithProps(dotsSlot, dotSlotProps, () => [
      h$1(NCarouselDots, { key: dotType + dotPlacement, total: dotSlotProps.total, currentIndex: dotSlotProps.currentIndex, dotType, trigger: this.trigger, keyboard: this.keyboard })
    ]), showArrow && resolveSlotWithProps(arrowSlot, arrowSlotProps, () => [
      h$1(NCarouselArrow, null)
    ]));
  }
});
function filterCarouselItem(vnodes) {
  return vnodes.reduce((carouselItems, vnode) => {
    if (isCarouselItem(vnode)) {
      carouselItems.push(vnode);
    }
    return carouselItems;
  }, []);
}
var commonVariables$6 = {
  sizeSmall: "14px",
  sizeMedium: "16px",
  sizeLarge: "18px",
  labelPadding: "0 8px",
  labelFontWeight: "400"
};
const self$u = (vars) => {
  const { baseColor, inputColorDisabled, cardColor, modalColor, popoverColor, textColorDisabled, borderColor, primaryColor, textColor2, fontSizeSmall, fontSizeMedium, fontSizeLarge, borderRadiusSmall, lineHeight: lineHeight2 } = vars;
  return Object.assign(Object.assign({}, commonVariables$6), {
    labelLineHeight: lineHeight2,
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    borderRadius: borderRadiusSmall,
    color: baseColor,
    colorChecked: primaryColor,
    colorDisabled: inputColorDisabled,
    colorDisabledChecked: inputColorDisabled,
    colorTableHeader: cardColor,
    colorTableHeaderModal: modalColor,
    colorTableHeaderPopover: popoverColor,
    checkMarkColor: baseColor,
    checkMarkColorDisabled: textColorDisabled,
    checkMarkColorDisabledChecked: textColorDisabled,
    border: `1px solid ${borderColor}`,
    borderDisabled: `1px solid ${borderColor}`,
    borderDisabledChecked: `1px solid ${borderColor}`,
    borderChecked: `1px solid ${primaryColor}`,
    borderFocus: `1px solid ${primaryColor}`,
    boxShadowFocus: `0 0 0 2px ${changeColor(primaryColor, { alpha: 0.3 })}`,
    textColor: textColor2,
    textColorDisabled
  });
};
const checkboxLight = {
  name: "Checkbox",
  common: commonLight,
  self: self$u
};
var checkboxLight$1 = checkboxLight;
var CheckMark = h$1("svg", { viewBox: "0 0 64 64", class: "check-icon" }, h$1("path", { d: "M50.42,16.76L22.34,39.45l-8.1-11.46c-1.12-1.58-3.3-1.96-4.88-0.84c-1.58,1.12-1.95,3.3-0.84,4.88l10.26,14.51  c0.56,0.79,1.42,1.31,2.38,1.45c0.16,0.02,0.32,0.03,0.48,0.03c0.8,0,1.57-0.27,2.2-0.78l30.99-25.03c1.5-1.21,1.74-3.42,0.52-4.92  C54.13,15.78,51.93,15.55,50.42,16.76z" }));
var LineMark = h$1("svg", { viewBox: "0 0 100 100", class: "line-icon" }, h$1("path", { d: "M80.2,55.5H21.4c-2.8,0-5.1-2.5-5.1-5.5l0,0c0-3,2.3-5.5,5.1-5.5h58.7c2.8,0,5.1,2.5,5.1,5.5l0,0C85.2,53.1,82.9,55.5,80.2,55.5z" }));
const checkboxGroupInjectionKey = createInjectionKey("n-checkbox-group");
const checkboxGroupProps = {
  min: Number,
  max: Number,
  size: String,
  value: Array,
  defaultValue: {
    type: Array,
    default: null
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onChange: [Function, Array]
};
var NCheckboxGroup = defineComponent({
  name: "CheckboxGroup",
  props: checkboxGroupProps,
  setup(props) {
    const { mergedClsPrefixRef } = useConfig(props);
    const formItem = useFormItem(props);
    const { mergedSizeRef, mergedDisabledRef } = formItem;
    const uncontrolledValueRef = ref(props.defaultValue);
    const controlledValueRef = computed(() => props.value);
    const mergedValueRef = useMergedState(controlledValueRef, uncontrolledValueRef);
    const checkedCount = computed(() => {
      var _a2;
      return ((_a2 = mergedValueRef.value) === null || _a2 === void 0 ? void 0 : _a2.length) || 0;
    });
    const valueSetRef = computed(() => {
      if (Array.isArray(mergedValueRef.value)) {
        return new Set(mergedValueRef.value);
      }
      return new Set();
    });
    function toggleCheckbox(checked, checkboxValue) {
      const { nTriggerFormInput, nTriggerFormChange } = formItem;
      const { onChange, "onUpdate:value": _onUpdateValue, onUpdateValue } = props;
      if (Array.isArray(mergedValueRef.value)) {
        const groupValue = Array.from(mergedValueRef.value);
        const index2 = groupValue.findIndex((value2) => value2 === checkboxValue);
        if (checked) {
          if (!~index2) {
            groupValue.push(checkboxValue);
            if (onUpdateValue) {
              call(onUpdateValue, groupValue, {
                actionType: "check",
                value: checkboxValue
              });
            }
            if (_onUpdateValue) {
              call(_onUpdateValue, groupValue, {
                actionType: "check",
                value: checkboxValue
              });
            }
            nTriggerFormInput();
            nTriggerFormChange();
            uncontrolledValueRef.value = groupValue;
            if (onChange)
              call(onChange, groupValue);
          }
        } else {
          if (~index2) {
            groupValue.splice(index2, 1);
            if (onUpdateValue) {
              call(onUpdateValue, groupValue, {
                actionType: "uncheck",
                value: checkboxValue
              });
            }
            if (_onUpdateValue) {
              call(_onUpdateValue, groupValue, {
                actionType: "uncheck",
                value: checkboxValue
              });
            }
            if (onChange)
              call(onChange, groupValue);
            uncontrolledValueRef.value = groupValue;
            nTriggerFormInput();
            nTriggerFormChange();
          }
        }
      } else {
        if (checked) {
          if (onUpdateValue) {
            call(onUpdateValue, [checkboxValue], {
              actionType: "check",
              value: checkboxValue
            });
          }
          if (_onUpdateValue) {
            call(_onUpdateValue, [checkboxValue], {
              actionType: "check",
              value: checkboxValue
            });
          }
          if (onChange)
            call(onChange, [checkboxValue]);
          uncontrolledValueRef.value = [checkboxValue];
          nTriggerFormInput();
          nTriggerFormChange();
        } else {
          if (onUpdateValue) {
            call(onUpdateValue, [], {
              actionType: "uncheck",
              value: checkboxValue
            });
          }
          if (_onUpdateValue) {
            call(_onUpdateValue, [], {
              actionType: "uncheck",
              value: checkboxValue
            });
          }
          if (onChange)
            call(onChange, []);
          uncontrolledValueRef.value = [];
          nTriggerFormInput();
          nTriggerFormChange();
        }
      }
    }
    provide(checkboxGroupInjectionKey, {
      checkedCountRef: checkedCount,
      maxRef: toRef(props, "max"),
      minRef: toRef(props, "min"),
      valueSetRef,
      disabledRef: mergedDisabledRef,
      mergedSizeRef,
      toggleCheckbox
    });
    return {
      mergedClsPrefix: mergedClsPrefixRef
    };
  },
  render() {
    return h$1("div", { class: `${this.mergedClsPrefix}-checkbox-group`, role: "group" }, this.$slots);
  }
});
var style$v = c$2([
  cB$1("checkbox", `
 line-height: var(--n-label-line-height);
 font-size: var(--n-font-size);
 outline: none;
 cursor: pointer;
 display: inline-flex;
 flex-wrap: nowrap;
 align-items: flex-start;
 word-break: break-word;
 --n-merged-color-table: var(--n-color-table);
 `, [c$2("&:hover", [cB$1("checkbox-box", [cE$1("border", {
    border: "var(--n-border-checked)"
  })])]), c$2("&:focus:not(:active)", [cB$1("checkbox-box", [cE$1("border", `
 border: var(--n-border-focus);
 box-shadow: var(--n-box-shadow-focus);
 `)])]), cM("inside-table", [cB$1("checkbox-box", `
 background-color: var(--n-merged-color-table);
 `)]), cM("checked", [cB$1("checkbox-box", `
 background-color: var(--n-color-checked);
 `, [cB$1("checkbox-icon", [
    c$2(".check-icon", `
 opacity: 1;
 transform: scale(1);
 `)
  ])])]), cM("indeterminate", [cB$1("checkbox-box", [cB$1("checkbox-icon", [c$2(".check-icon", `
 opacity: 0;
 transform: scale(.5);
 `), c$2(".line-icon", `
 opacity: 1;
 transform: scale(1);
 `)])])]), cM("checked, indeterminate", [c$2("&:focus:not(:active)", [cB$1("checkbox-box", [cE$1("border", `
 border: var(--n-border-checked);
 box-shadow: var(--n-box-shadow-focus);
 `)])]), cB$1("checkbox-box", `
 background-color: var(--n-color-checked);
 border-left: 0;
 border-top: 0;
 `, [cE$1("border", {
    border: "var(--n-border-checked)"
  })])]), cM("disabled", {
    cursor: "not-allowed"
  }, [cM("checked", [cB$1("checkbox-box", `
 background-color: var(--n-color-disabled-checked);
 `, [cE$1("border", {
    border: "var(--n-border-disabled-checked)"
  }), cB$1("checkbox-icon", [c$2(".check-icon, .line-icon", {
    fill: "var(--n-check-mark-color-disabled-checked)"
  })])])]), cB$1("checkbox-box", `
 background-color: var(--n-color-disabled);
 `, [cE$1("border", {
    border: "var(--n-border-disabled)"
  }), cB$1("checkbox-icon", [c$2(".check-icon, .line-icon", {
    fill: "var(--n-check-mark-color-disabled)"
  })])]), cE$1("label", {
    color: "var(--n-text-color-disabled)"
  })]), cB$1("checkbox-box-wrapper", `
 position: relative;
 width: var(--n-size);
 flex-shrink: 0;
 flex-grow: 0;
 user-select: none;
 -webkit-user-select: none;
 `), cB$1("checkbox-box", `
 position: absolute;
 left: 0;
 top: 50%;
 transform: translateY(-50%);
 height: var(--n-size);
 width: var(--n-size);
 display: inline-block;
 box-sizing: border-box;
 border-radius: var(--n-border-radius);
 background-color: var(--n-color);
 transition: background-color 0.3s var(--n-bezier);
 `, [cE$1("border", `
 transition:
 border-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 border-radius: inherit;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border: var(--n-border);
 `), cB$1("checkbox-icon", `
 display: flex;
 align-items: center;
 justify-content: center;
 position: absolute;
 left: 1px;
 right: 1px;
 top: 1px;
 bottom: 1px;
 `, [c$2(".check-icon, .line-icon", `
 width: 100%;
 fill: var(--n-check-mark-color);
 opacity: 0;
 transform: scale(0.5);
 transform-origin: center;
 transition:
 fill 0.3s var(--n-bezier),
 transform 0.3s var(--n-bezier),
 opacity 0.3s var(--n-bezier),
 border-color 0.3s var(--n-bezier);
 `), iconSwitchTransition({
    left: "1px",
    top: "1px"
  })])]), cE$1("label", `
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 user-select: none;
 -webkit-user-select: none;
 padding: var(--n-label-padding);
 font-weight: var(--n-label-font-weight);
 `, [c$2("&:empty", {
    display: "none"
  })])]),
  insideModal(cB$1("checkbox", `
 --n-merged-color-table: var(--n-color-table-modal);
 `)),
  insidePopover(cB$1("checkbox", `
 --n-merged-color-table: var(--n-color-table-popover);
 `))
]);
const checkboxProps = Object.assign(Object.assign({}, useTheme.props), {
  size: String,
  checked: {
    type: [Boolean, String, Number],
    default: void 0
  },
  defaultChecked: {
    type: [Boolean, String, Number],
    default: false
  },
  value: [String, Number],
  disabled: {
    type: Boolean,
    default: void 0
  },
  indeterminate: Boolean,
  label: String,
  focusable: {
    type: Boolean,
    default: true
  },
  checkedValue: {
    type: [Boolean, String, Number],
    default: true
  },
  uncheckedValue: {
    type: [Boolean, String, Number],
    default: false
  },
  "onUpdate:checked": [Function, Array],
  onUpdateChecked: [Function, Array],
  privateInsideTable: Boolean,
  onChange: [Function, Array]
});
var NCheckbox = defineComponent({
  name: "Checkbox",
  props: checkboxProps,
  setup(props) {
    const selfRef = ref(null);
    const { mergedClsPrefixRef, inlineThemeDisabled, mergedRtlRef } = useConfig(props);
    const formItem = useFormItem(props, {
      mergedSize(NFormItem2) {
        const { size: size2 } = props;
        if (size2 !== void 0)
          return size2;
        if (NCheckboxGroup2) {
          const { value: mergedSize } = NCheckboxGroup2.mergedSizeRef;
          if (mergedSize !== void 0) {
            return mergedSize;
          }
        }
        if (NFormItem2) {
          const { mergedSize } = NFormItem2;
          if (mergedSize !== void 0)
            return mergedSize.value;
        }
        return "medium";
      },
      mergedDisabled(NFormItem2) {
        const { disabled } = props;
        if (disabled !== void 0)
          return disabled;
        if (NCheckboxGroup2) {
          if (NCheckboxGroup2.disabledRef.value)
            return true;
          const { maxRef: { value: max }, checkedCountRef } = NCheckboxGroup2;
          if (max !== void 0 && checkedCountRef.value >= max && !renderedCheckedRef.value) {
            return true;
          }
          const { minRef: { value: min } } = NCheckboxGroup2;
          if (min !== void 0 && checkedCountRef.value <= min && renderedCheckedRef.value) {
            return true;
          }
        }
        if (NFormItem2) {
          return NFormItem2.disabled.value;
        }
        return false;
      }
    });
    const { mergedDisabledRef, mergedSizeRef } = formItem;
    const NCheckboxGroup2 = inject(checkboxGroupInjectionKey, null);
    const uncontrolledCheckedRef = ref(props.defaultChecked);
    const controlledCheckedRef = toRef(props, "checked");
    const mergedCheckedRef = useMergedState(controlledCheckedRef, uncontrolledCheckedRef);
    const renderedCheckedRef = useMemo(() => {
      if (NCheckboxGroup2) {
        const groupValueSet = NCheckboxGroup2.valueSetRef.value;
        if (groupValueSet && props.value !== void 0) {
          return groupValueSet.has(props.value);
        }
        return false;
      } else {
        return mergedCheckedRef.value === props.checkedValue;
      }
    });
    const themeRef = useTheme("Checkbox", "-checkbox", style$v, checkboxLight$1, props, mergedClsPrefixRef);
    function toggle(e25) {
      if (NCheckboxGroup2 && props.value !== void 0) {
        NCheckboxGroup2.toggleCheckbox(!renderedCheckedRef.value, props.value);
      } else {
        const { onChange, "onUpdate:checked": _onUpdateCheck, onUpdateChecked } = props;
        const { nTriggerFormInput, nTriggerFormChange } = formItem;
        const nextChecked = renderedCheckedRef.value ? props.uncheckedValue : props.checkedValue;
        if (_onUpdateCheck) {
          call(_onUpdateCheck, nextChecked, e25);
        }
        if (onUpdateChecked) {
          call(onUpdateChecked, nextChecked, e25);
        }
        if (onChange)
          call(onChange, nextChecked, e25);
        nTriggerFormInput();
        nTriggerFormChange();
        uncontrolledCheckedRef.value = nextChecked;
      }
    }
    function handleClick2(e25) {
      if (!mergedDisabledRef.value) {
        toggle(e25);
      }
    }
    function handleKeyUp(e25) {
      if (mergedDisabledRef.value)
        return;
      switch (e25.key) {
        case " ":
        case "Enter":
          toggle(e25);
      }
    }
    function handleKeyDown(e25) {
      switch (e25.key) {
        case " ":
          e25.preventDefault();
      }
    }
    const exposedMethods = {
      focus: () => {
        var _a2;
        (_a2 = selfRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      blur: () => {
        var _a2;
        (_a2 = selfRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
      }
    };
    const rtlEnabledRef = useRtl("Checkbox", mergedRtlRef, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { value: mergedSize } = mergedSizeRef;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { borderRadius, color, colorChecked, colorDisabled, colorTableHeader, colorTableHeaderModal, colorTableHeaderPopover, checkMarkColor, checkMarkColorDisabled, border, borderFocus, borderDisabled, borderChecked, boxShadowFocus, textColor, textColorDisabled, checkMarkColorDisabledChecked, colorDisabledChecked, borderDisabledChecked, labelPadding, labelLineHeight, labelFontWeight, [createKey("fontSize", mergedSize)]: fontSize2, [createKey("size", mergedSize)]: size2 } } = themeRef.value;
      return {
        "--n-label-line-height": labelLineHeight,
        "--n-label-font-weight": labelFontWeight,
        "--n-size": size2,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-border-radius": borderRadius,
        "--n-border": border,
        "--n-border-checked": borderChecked,
        "--n-border-focus": borderFocus,
        "--n-border-disabled": borderDisabled,
        "--n-border-disabled-checked": borderDisabledChecked,
        "--n-box-shadow-focus": boxShadowFocus,
        "--n-color": color,
        "--n-color-checked": colorChecked,
        "--n-color-table": colorTableHeader,
        "--n-color-table-modal": colorTableHeaderModal,
        "--n-color-table-popover": colorTableHeaderPopover,
        "--n-color-disabled": colorDisabled,
        "--n-color-disabled-checked": colorDisabledChecked,
        "--n-text-color": textColor,
        "--n-text-color-disabled": textColorDisabled,
        "--n-check-mark-color": checkMarkColor,
        "--n-check-mark-color-disabled": checkMarkColorDisabled,
        "--n-check-mark-color-disabled-checked": checkMarkColorDisabledChecked,
        "--n-font-size": fontSize2,
        "--n-label-padding": labelPadding
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("checkbox", computed(() => mergedSizeRef.value[0]), cssVarsRef, props) : void 0;
    return Object.assign(formItem, exposedMethods, {
      rtlEnabled: rtlEnabledRef,
      selfRef,
      mergedClsPrefix: mergedClsPrefixRef,
      mergedDisabled: mergedDisabledRef,
      renderedChecked: renderedCheckedRef,
      mergedTheme: themeRef,
      labelId: createId(),
      handleClick: handleClick2,
      handleKeyUp,
      handleKeyDown,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    });
  },
  render() {
    var _a2;
    const { $slots, renderedChecked, mergedDisabled, indeterminate, privateInsideTable, cssVars, labelId, label, mergedClsPrefix, focusable, handleKeyUp, handleKeyDown, handleClick: handleClick2 } = this;
    (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
    return h$1("div", { ref: "selfRef", class: [
      `${mergedClsPrefix}-checkbox`,
      this.themeClass,
      this.rtlEnabled && `${mergedClsPrefix}-checkbox--rtl`,
      renderedChecked && `${mergedClsPrefix}-checkbox--checked`,
      mergedDisabled && `${mergedClsPrefix}-checkbox--disabled`,
      indeterminate && `${mergedClsPrefix}-checkbox--indeterminate`,
      privateInsideTable && `${mergedClsPrefix}-checkbox--inside-table`
    ], tabindex: mergedDisabled || !focusable ? void 0 : 0, role: "checkbox", "aria-checked": indeterminate ? "mixed" : renderedChecked, "aria-labelledby": labelId, style: cssVars, onKeyup: handleKeyUp, onKeydown: handleKeyDown, onClick: handleClick2, onMousedown: () => {
      on$1("selectstart", window, (e25) => {
        e25.preventDefault();
      }, {
        once: true
      });
    } }, h$1("div", { class: `${mergedClsPrefix}-checkbox-box-wrapper` }, "\xA0", h$1("div", { class: `${mergedClsPrefix}-checkbox-box` }, h$1(NIconSwitchTransition, null, {
      default: () => this.indeterminate ? h$1("div", { key: "indeterminate", class: `${mergedClsPrefix}-checkbox-icon` }, LineMark) : h$1("div", { key: "check", class: `${mergedClsPrefix}-checkbox-icon` }, CheckMark)
    }), h$1("div", { class: `${mergedClsPrefix}-checkbox-box__border` }))), label !== null || $slots.default ? h$1("span", { class: `${mergedClsPrefix}-checkbox__label`, id: labelId }, $slots.default ? $slots.default() : label) : null);
  }
});
const self$t = (vars) => {
  const { fontWeight, textColor1, textColor2, textColorDisabled, dividerColor, fontSize: fontSize2 } = vars;
  return {
    titleFontSize: fontSize2,
    titleFontWeight: fontWeight,
    dividerColor,
    titleTextColor: textColor1,
    titleTextColorDisabled: textColorDisabled,
    fontSize: fontSize2,
    textColor: textColor2,
    arrowColor: textColor2,
    arrowColorDisabled: textColorDisabled,
    itemMargin: "16px 0 0 0",
    titlePadding: "16px 0 0 0"
  };
};
const collapseLight = {
  name: "Collapse",
  common: commonLight,
  self: self$t
};
var collapseLight$1 = collapseLight;
var style$u = cB$1("collapse", "width: 100%;", [cB$1("collapse-item", `
 font-size: var(--n-font-size);
 color: var(--n-text-color);
 transition:
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 margin: var(--n-item-margin);
 `, [cM("disabled", [cE$1("header", "cursor: not-allowed;", [cE$1("header-main", `
 color: var(--n-title-text-color-disabled);
 `), cB$1("collapse-item-arrow", `
 color: var(--n-arrow-color-disabled);
 `)])]), cB$1("collapse-item", "margin-left: 32px;"), c$2("&:first-child", "margin-top: 0;"), c$2("&:first-child >", [cE$1("header", "padding-top: 0;")]), cM("left-arrow-placement", [cE$1("header", [cB$1("collapse-item-arrow", "margin-right: 4px;")])]), cM("right-arrow-placement", [cE$1("header", [cB$1("collapse-item-arrow", "margin-left: 4px;")])]), cE$1("content-wrapper", [cE$1("content-inner", "padding-top: 16px;"), fadeInHeightExpandTransition({
  duration: "0.15s"
})]), cM("active", [cE$1("header", [cM("active", [cB$1("collapse-item-arrow", "transform: rotate(90deg);")])])]), c$2("&:not(:first-child)", "border-top: 1px solid var(--n-divider-color);"), cE$1("header", `
 font-size: var(--n-title-font-size);
 display: flex;
 flex-wrap: nowrap;
 align-items: center;
 transition: color .3s var(--n-bezier);
 position: relative;
 padding: var(--n-title-padding);
 color: var(--n-title-text-color);
 cursor: pointer;
 `, [cE$1("header-main", `
 display: flex;
 flex-wrap: nowrap;
 align-items: center;
 font-weight: var(--n-title-font-weight);
 transition: color .3s var(--n-bezier);
 flex: 1;
 color: var(--n-title-text-color);
 `), cE$1("header-extra", `
 display: flex;
 align-items: center;
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 `), cB$1("collapse-item-arrow", `
 display: flex;
 transition:
 transform .15s var(--n-bezier),
 color .3s var(--n-bezier);
 font-size: 18px;
 color: var(--n-arrow-color);
 `)])])]);
const collapseProps = Object.assign(Object.assign({}, useTheme.props), {
  defaultExpandedNames: {
    type: [Array, String],
    default: null
  },
  expandedNames: [Array, String],
  arrowPlacement: {
    type: String,
    default: "left"
  },
  accordion: {
    type: Boolean,
    default: false
  },
  displayDirective: {
    type: String,
    default: "if"
  },
  onItemHeaderClick: [Function, Array],
  "onUpdate:expandedNames": [Function, Array],
  onUpdateExpandedNames: [Function, Array],
  onExpandedNamesChange: {
    type: [Function, Array],
    validator: () => {
      return true;
    },
    default: void 0
  }
});
const collapseInjectionKey = createInjectionKey("n-collapse");
var NCollapse = defineComponent({
  name: "Collapse",
  props: collapseProps,
  setup(props, { slots }) {
    const { mergedClsPrefixRef, inlineThemeDisabled, mergedRtlRef } = useConfig(props);
    const uncontrolledExpandedNamesRef = ref(props.defaultExpandedNames);
    const controlledExpandedNamesRef = computed(() => props.expandedNames);
    const mergedExpandedNamesRef = useMergedState(controlledExpandedNamesRef, uncontrolledExpandedNamesRef);
    const themeRef = useTheme("Collapse", "-collapse", style$u, collapseLight$1, props, mergedClsPrefixRef);
    function doUpdateExpandedNames(names) {
      const { "onUpdate:expandedNames": _onUpdateExpandedNames, onUpdateExpandedNames, onExpandedNamesChange } = props;
      if (onUpdateExpandedNames) {
        call(onUpdateExpandedNames, names);
      }
      if (_onUpdateExpandedNames) {
        call(_onUpdateExpandedNames, names);
      }
      if (onExpandedNamesChange) {
        call(onExpandedNamesChange, names);
      }
      uncontrolledExpandedNamesRef.value = names;
    }
    function doItemHeaderClick(info) {
      const { onItemHeaderClick } = props;
      if (onItemHeaderClick) {
        call(onItemHeaderClick, info);
      }
    }
    function toggleItem(collapse, name2, event) {
      const { accordion } = props;
      const { value: expandedNames } = mergedExpandedNamesRef;
      if (accordion) {
        if (collapse) {
          doUpdateExpandedNames([name2]);
          doItemHeaderClick({ name: name2, expanded: true, event });
        } else {
          doUpdateExpandedNames([]);
          doItemHeaderClick({ name: name2, expanded: false, event });
        }
      } else {
        if (!Array.isArray(expandedNames)) {
          doUpdateExpandedNames([name2]);
          doItemHeaderClick({ name: name2, expanded: true, event });
        } else {
          const activeNames = expandedNames.slice();
          const index2 = activeNames.findIndex((activeName) => name2 === activeName);
          if (~index2) {
            activeNames.splice(index2, 1);
            doUpdateExpandedNames(activeNames);
            doItemHeaderClick({ name: name2, expanded: false, event });
          } else {
            activeNames.push(name2);
            doUpdateExpandedNames(activeNames);
            doItemHeaderClick({ name: name2, expanded: true, event });
          }
        }
      }
    }
    provide(collapseInjectionKey, {
      props,
      mergedClsPrefixRef,
      expandedNamesRef: mergedExpandedNamesRef,
      slots,
      toggleItem
    });
    const rtlEnabledRef = useRtl("Collapse", mergedRtlRef, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { titleFontWeight, dividerColor, titlePadding, titleTextColor, titleTextColorDisabled, textColor, arrowColor, fontSize: fontSize2, titleFontSize, arrowColorDisabled, itemMargin } } = themeRef.value;
      return {
        "--n-font-size": fontSize2,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-text-color": textColor,
        "--n-divider-color": dividerColor,
        "--n-title-padding": titlePadding,
        "--n-title-font-size": titleFontSize,
        "--n-title-text-color": titleTextColor,
        "--n-title-text-color-disabled": titleTextColorDisabled,
        "--n-title-font-weight": titleFontWeight,
        "--n-arrow-color": arrowColor,
        "--n-arrow-color-disabled": arrowColorDisabled,
        "--n-item-margin": itemMargin
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("collapse", void 0, cssVarsRef, props) : void 0;
    return {
      rtlEnabled: rtlEnabledRef,
      mergedTheme: themeRef,
      mergedClsPrefix: mergedClsPrefixRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    var _a2;
    (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
    return h$1("div", { class: [
      `${this.mergedClsPrefix}-collapse`,
      this.rtlEnabled && `${this.mergedClsPrefix}-collapse--rtl`,
      this.themeClass
    ], style: this.cssVars }, this.$slots);
  }
});
var NCollapseItemContent = defineComponent({
  name: "CollapseItemContent",
  props: {
    displayDirective: {
      type: String,
      required: true
    },
    show: Boolean,
    clsPrefix: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const onceTrueRef = useFalseUntilTruthy(toRef(props, "show"));
    return {
      onceTrue: onceTrueRef
    };
  },
  render() {
    return h$1(NFadeInExpandTransition, null, {
      default: () => {
        const { show, displayDirective, onceTrue, clsPrefix } = this;
        const useVShow = displayDirective === "show" && onceTrue;
        const contentNode = h$1("div", { class: `${clsPrefix}-collapse-item__content-wrapper` }, h$1("div", { class: `${clsPrefix}-collapse-item__content-inner` }, this.$slots));
        return useVShow ? withDirectives(contentNode, [[vShow, show]]) : show ? contentNode : null;
      }
    });
  }
});
const collapseItemProps = {
  title: String,
  name: [String, Number],
  disabled: Boolean,
  displayDirective: String
};
var NCollapseItem = defineComponent({
  name: "CollapseItem",
  props: collapseItemProps,
  setup(props) {
    const { mergedRtlRef } = useConfig(props);
    const randomName = createId();
    const mergedNameRef = useMemo(() => {
      var _a2;
      return (_a2 = props.name) !== null && _a2 !== void 0 ? _a2 : randomName;
    });
    const NCollapse2 = inject(collapseInjectionKey);
    if (!NCollapse2) {
      throwError("collapse-item", "`n-collapse-item` must be placed inside `n-collapse`.");
    }
    const { expandedNamesRef, props: collapseProps2, mergedClsPrefixRef, slots: collapseSlots } = NCollapse2;
    const collapsedRef = computed(() => {
      const { value: expandedNames } = expandedNamesRef;
      if (Array.isArray(expandedNames)) {
        const { value: name2 } = mergedNameRef;
        return !~expandedNames.findIndex((expandedName) => expandedName === name2);
      } else if (expandedNames) {
        const { value: name2 } = mergedNameRef;
        return name2 !== expandedNames;
      }
      return true;
    });
    const rtlEnabledRef = useRtl("Collapse", mergedRtlRef, mergedClsPrefixRef);
    return {
      rtlEnabled: rtlEnabledRef,
      collapseSlots,
      randomName,
      mergedClsPrefix: mergedClsPrefixRef,
      collapsed: collapsedRef,
      mergedDisplayDirective: computed(() => {
        const { displayDirective } = props;
        if (displayDirective) {
          return displayDirective;
        } else {
          return collapseProps2.displayDirective;
        }
      }),
      arrowPlacement: computed(() => {
        return collapseProps2.arrowPlacement;
      }),
      handleClick(e25) {
        if (NCollapse2 && !props.disabled) {
          NCollapse2.toggleItem(collapsedRef.value, mergedNameRef.value, e25);
        }
      }
    };
  },
  render() {
    const { collapseSlots, $slots, arrowPlacement, collapsed, mergedDisplayDirective, mergedClsPrefix, disabled } = this;
    const headerNode = resolveSlotWithProps($slots.header, { collapsed }, () => [this.title]);
    const headerExtraSlot = $slots["header-extra"] || collapseSlots["header-extra"];
    const arrowSlot = $slots.arrow || collapseSlots.arrow;
    return h$1("div", { class: [
      `${mergedClsPrefix}-collapse-item`,
      `${mergedClsPrefix}-collapse-item--${arrowPlacement}-arrow-placement`,
      disabled && `${mergedClsPrefix}-collapse-item--disabled`,
      !collapsed && `${mergedClsPrefix}-collapse-item--active`
    ] }, h$1("div", { class: [
      `${mergedClsPrefix}-collapse-item__header`,
      !collapsed && `${mergedClsPrefix}-collapse-item__header--active`
    ] }, h$1("div", { class: `${mergedClsPrefix}-collapse-item__header-main`, onClick: this.handleClick }, arrowPlacement === "right" && headerNode, h$1("div", { class: `${mergedClsPrefix}-collapse-item-arrow`, key: this.rtlEnabled ? 0 : 1 }, resolveSlotWithProps(arrowSlot, { collapsed }, () => {
      var _a2;
      return [
        h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, {
          default: (_a2 = collapseSlots.expandIcon) !== null && _a2 !== void 0 ? _a2 : () => this.rtlEnabled ? h$1(ChevronLeftIcon, null) : h$1(ChevronRightIcon, null)
        })
      ];
    })), arrowPlacement === "left" && headerNode), resolveWrappedSlotWithProps(headerExtraSlot, { collapsed }, (children) => h$1("div", { class: `${mergedClsPrefix}-collapse-item__header-extra`, onClick: this.handleClick }, children))), h$1(NCollapseItemContent, { clsPrefix: mergedClsPrefix, displayDirective: mergedDisplayDirective, show: !collapsed }, $slots));
  }
});
const configProviderProps = {
  abstract: Boolean,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clsPrefix: String,
  locale: Object,
  dateLocale: Object,
  namespace: String,
  rtl: Array,
  tag: {
    type: String,
    default: "div"
  },
  hljs: Object,
  katex: Object,
  theme: Object,
  themeOverrides: Object,
  componentOptions: Object,
  icons: Object,
  breakpoints: Object,
  preflightStyleDisabled: Boolean,
  inlineThemeDisabled: {
    type: Boolean,
    default: void 0
  },
  as: {
    type: String,
    validator: () => {
      warn$2("config-provider", "`as` is deprecated, please use `tag` instead.");
      return true;
    },
    default: void 0
  }
};
var NConfigProvider = defineComponent({
  name: "ConfigProvider",
  alias: ["App"],
  props: configProviderProps,
  setup(props) {
    const NConfigProvider2 = inject(configProviderInjectionKey, null);
    const mergedThemeRef = computed(() => {
      const { theme: theme2 } = props;
      if (theme2 === null)
        return void 0;
      const inheritedTheme = NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedThemeRef.value;
      return theme2 === void 0 ? inheritedTheme : inheritedTheme === void 0 ? theme2 : Object.assign({}, inheritedTheme, theme2);
    });
    const mergedThemeOverridesRef = computed(() => {
      const { themeOverrides: themeOverrides2 } = props;
      if (themeOverrides2 === null)
        return void 0;
      if (themeOverrides2 === void 0) {
        return NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedThemeOverridesRef.value;
      } else {
        const inheritedThemeOverrides = NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedThemeOverridesRef.value;
        if (inheritedThemeOverrides === void 0) {
          return themeOverrides2;
        } else {
          return merge$2({}, inheritedThemeOverrides, themeOverrides2);
        }
      }
    });
    const mergedNamespaceRef = useMemo(() => {
      const { namespace: namespace2 } = props;
      return namespace2 === void 0 ? NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedNamespaceRef.value : namespace2;
    });
    const mergedBorderedRef = useMemo(() => {
      const { bordered } = props;
      return bordered === void 0 ? NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedBorderedRef.value : bordered;
    });
    const mergedIconsRef = computed(() => {
      const { icons } = props;
      return icons === void 0 ? NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedIconsRef.value : icons;
    });
    const mergedComponentPropsRef = computed(() => {
      const { componentOptions } = props;
      if (componentOptions !== void 0)
        return componentOptions;
      return NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedComponentPropsRef.value;
    });
    const mergedClsPrefixRef = computed(() => {
      const { clsPrefix } = props;
      if (clsPrefix !== void 0)
        return clsPrefix;
      return NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedClsPrefixRef.value;
    });
    const mergedRtlRef = computed(() => {
      var _a2;
      const { rtl } = props;
      if (rtl === void 0) {
        return NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedRtlRef.value;
      }
      const rtlEnabledState = {};
      for (const rtlInfo of rtl) {
        rtlEnabledState[rtlInfo.name] = markRaw(rtlInfo);
        (_a2 = rtlInfo.peers) === null || _a2 === void 0 ? void 0 : _a2.forEach((peerRtlInfo) => {
          if (!(peerRtlInfo.name in rtlEnabledState)) {
            rtlEnabledState[peerRtlInfo.name] = markRaw(peerRtlInfo);
          }
        });
      }
      return rtlEnabledState;
    });
    const mergedBreakpointsRef = computed(() => {
      return props.breakpoints || (NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedBreakpointsRef.value);
    });
    const inlineThemeDisabled = props.inlineThemeDisabled || (NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.inlineThemeDisabled);
    const preflightStyleDisabled = props.preflightStyleDisabled || (NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.preflightStyleDisabled);
    const mergedThemeHashRef = computed(() => {
      const { value: theme2 } = mergedThemeRef;
      const { value: mergedThemeOverrides } = mergedThemeOverridesRef;
      const hasThemeOverrides = mergedThemeOverrides && Object.keys(mergedThemeOverrides).length !== 0;
      const themeName = theme2 === null || theme2 === void 0 ? void 0 : theme2.name;
      if (themeName) {
        if (hasThemeOverrides) {
          return `${themeName}-${murmur2(JSON.stringify(mergedThemeOverridesRef.value))}`;
        }
        return themeName;
      } else {
        if (hasThemeOverrides) {
          return murmur2(JSON.stringify(mergedThemeOverridesRef.value));
        }
        return "";
      }
    });
    provide(configProviderInjectionKey, {
      mergedThemeHashRef,
      mergedBreakpointsRef,
      mergedRtlRef,
      mergedIconsRef,
      mergedComponentPropsRef,
      mergedBorderedRef,
      mergedNamespaceRef,
      mergedClsPrefixRef,
      mergedLocaleRef: computed(() => {
        const { locale: locale2 } = props;
        if (locale2 === null)
          return void 0;
        return locale2 === void 0 ? NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedLocaleRef.value : locale2;
      }),
      mergedDateLocaleRef: computed(() => {
        const { dateLocale } = props;
        if (dateLocale === null)
          return void 0;
        return dateLocale === void 0 ? NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedDateLocaleRef.value : dateLocale;
      }),
      mergedHljsRef: computed(() => {
        const { hljs } = props;
        return hljs === void 0 ? NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedHljsRef.value : hljs;
      }),
      mergedKatexRef: computed(() => {
        const { katex } = props;
        return katex === void 0 ? NConfigProvider2 === null || NConfigProvider2 === void 0 ? void 0 : NConfigProvider2.mergedKatexRef.value : katex;
      }),
      mergedThemeRef,
      mergedThemeOverridesRef,
      inlineThemeDisabled: inlineThemeDisabled || false,
      preflightStyleDisabled: preflightStyleDisabled || false
    });
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      mergedBordered: mergedBorderedRef,
      mergedNamespace: mergedNamespaceRef,
      mergedTheme: mergedThemeRef,
      mergedThemeOverrides: mergedThemeOverridesRef
    };
  },
  render() {
    var _a2, _b2, _c2, _d2;
    return !this.abstract ? h$1(this.as || this.tag, {
      class: `${this.mergedClsPrefix || defaultClsPrefix}-config-provider`
    }, (_b2 = (_a2 = this.$slots).default) === null || _b2 === void 0 ? void 0 : _b2.call(_a2)) : (_d2 = (_c2 = this.$slots).default) === null || _d2 === void 0 ? void 0 : _d2.call(_c2);
  }
});
function self$s(vars) {
  const { boxShadow2 } = vars;
  return {
    menuBoxShadow: boxShadow2
  };
}
const popselectLight = createTheme({
  name: "Popselect",
  common: commonLight,
  peers: {
    Popover: popoverLight$1,
    InternalSelectMenu: internalSelectMenuLight$1
  },
  self: self$s
});
var popselectLight$1 = popselectLight;
const popselectInjectionKey = createInjectionKey("n-popselect");
var style$t = cB$1("popselect-menu", `
 box-shadow: var(--n-menu-box-shadow);
`);
const panelProps = {
  multiple: Boolean,
  value: {
    type: [String, Number, Array],
    default: null
  },
  cancelable: Boolean,
  options: {
    type: Array,
    default: () => []
  },
  size: {
    type: String,
    default: "medium"
  },
  scrollable: Boolean,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onMouseenter: Function,
  onMouseleave: Function,
  renderLabel: Function,
  showCheckmark: {
    type: Boolean,
    default: void 0
  },
  nodeProps: Function,
  virtualScroll: Boolean,
  onChange: [Function, Array]
};
const panelPropKeys = keysOf(panelProps);
var NPopselectPanel = defineComponent({
  name: "PopselectPanel",
  props: panelProps,
  setup(props) {
    const NPopselect2 = inject(popselectInjectionKey);
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Popselect", "-pop-select", style$t, popselectLight$1, NPopselect2.props, mergedClsPrefixRef);
    const treeMateRef = computed(() => {
      return createTreeMate(props.options, createTmOptions("value", "children"));
    });
    function doUpdateValue(value2, option) {
      const { onUpdateValue, "onUpdate:value": _onUpdateValue, onChange } = props;
      if (onUpdateValue)
        call(onUpdateValue, value2, option);
      if (_onUpdateValue) {
        call(_onUpdateValue, value2, option);
      }
      if (onChange)
        call(onChange, value2, option);
    }
    function handleToggle(tmNode) {
      toggle(tmNode.key);
    }
    function handleMenuMousedown(e25) {
      if (!happensIn(e25, "action"))
        e25.preventDefault();
    }
    function toggle(value2) {
      const { value: { getNode: getNode2 } } = treeMateRef;
      if (props.multiple) {
        if (Array.isArray(props.value)) {
          const newValue = [];
          const newOptions = [];
          let shouldAddValue = true;
          props.value.forEach((v2) => {
            if (v2 === value2) {
              shouldAddValue = false;
              return;
            }
            const tmNode = getNode2(v2);
            if (tmNode) {
              newValue.push(tmNode.key);
              newOptions.push(tmNode.rawNode);
            }
          });
          if (shouldAddValue) {
            newValue.push(value2);
            newOptions.push(getNode2(value2).rawNode);
          }
          doUpdateValue(newValue, newOptions);
        } else {
          const tmNode = getNode2(value2);
          if (tmNode) {
            doUpdateValue([value2], [tmNode.rawNode]);
          }
        }
      } else {
        if (props.value === value2 && props.cancelable) {
          doUpdateValue(null, null);
        } else {
          const tmNode = getNode2(value2);
          if (tmNode) {
            doUpdateValue(value2, tmNode.rawNode);
          }
          const { "onUpdate:show": _onUpdateShow, onUpdateShow } = NPopselect2.props;
          if (_onUpdateShow)
            call(_onUpdateShow, false);
          if (onUpdateShow)
            call(onUpdateShow, false);
          NPopselect2.setShow(false);
        }
      }
      void nextTick(() => {
        NPopselect2.syncPosition();
      });
    }
    watch(toRef(props, "options"), () => {
      void nextTick(() => {
        NPopselect2.syncPosition();
      });
    });
    const cssVarsRef = computed(() => {
      const { self: { menuBoxShadow } } = themeRef.value;
      return {
        "--n-menu-box-shadow": menuBoxShadow
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("select", void 0, cssVarsRef, NPopselect2.props) : void 0;
    return {
      mergedTheme: NPopselect2.mergedThemeRef,
      mergedClsPrefix: mergedClsPrefixRef,
      treeMate: treeMateRef,
      handleToggle,
      handleMenuMousedown,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    var _a2;
    (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
    return h$1(NInternalSelectMenu, { clsPrefix: this.mergedClsPrefix, focusable: true, nodeProps: this.nodeProps, class: [`${this.mergedClsPrefix}-popselect-menu`, this.themeClass], style: this.cssVars, theme: this.mergedTheme.peers.InternalSelectMenu, themeOverrides: this.mergedTheme.peerOverrides.InternalSelectMenu, multiple: this.multiple, treeMate: this.treeMate, size: this.size, value: this.value, virtualScroll: this.virtualScroll, scrollable: this.scrollable, renderLabel: this.renderLabel, onToggle: this.handleToggle, onMouseenter: this.onMouseenter, onMouseleave: this.onMouseenter, onMousedown: this.handleMenuMousedown, showCheckmark: this.showCheckmark }, {
      action: () => {
        var _a3, _b2;
        return ((_b2 = (_a3 = this.$slots).action) === null || _b2 === void 0 ? void 0 : _b2.call(_a3)) || [];
      },
      empty: () => {
        var _a3, _b2;
        return ((_b2 = (_a3 = this.$slots).empty) === null || _b2 === void 0 ? void 0 : _b2.call(_a3)) || [];
      }
    });
  }
});
const popselectProps = Object.assign(Object.assign(Object.assign(Object.assign({}, useTheme.props), omit(popoverBaseProps, ["showArrow", "arrow"])), { placement: Object.assign(Object.assign({}, popoverBaseProps.placement), { default: "bottom" }), trigger: {
  type: String,
  default: "hover"
} }), panelProps);
var NPopselect = defineComponent({
  name: "Popselect",
  props: popselectProps,
  inheritAttrs: false,
  __popover__: true,
  setup(props) {
    const { mergedClsPrefixRef } = useConfig(props);
    const themeRef = useTheme("Popselect", "-popselect", void 0, popselectLight$1, props, mergedClsPrefixRef);
    const popoverInstRef = ref(null);
    function syncPosition() {
      var _a2;
      (_a2 = popoverInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.syncPosition();
    }
    function setShow(value2) {
      var _a2;
      (_a2 = popoverInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.setShow(value2);
    }
    provide(popselectInjectionKey, {
      props,
      mergedThemeRef: themeRef,
      syncPosition,
      setShow
    });
    const exposedMethods = {
      syncPosition,
      setShow
    };
    return Object.assign(Object.assign({}, exposedMethods), { popoverInstRef, mergedTheme: themeRef });
  },
  render() {
    const { mergedTheme } = this;
    const popoverProps2 = {
      theme: mergedTheme.peers.Popover,
      themeOverrides: mergedTheme.peerOverrides.Popover,
      builtinThemeOverrides: {
        padding: "0"
      },
      ref: "popoverInstRef",
      internalRenderBody: (className, ref2, style2, onMouseenter, onMouseleave) => {
        const { $attrs } = this;
        return h$1(NPopselectPanel, Object.assign({}, $attrs, { class: [$attrs.class, className], style: [$attrs.style, style2] }, keep(this.$props, panelPropKeys), { ref: createRefSetter(ref2), onMouseenter: mergeEventHandlers([
          onMouseenter,
          $attrs.onMouseenter
        ]), onMouseleave: mergeEventHandlers([
          onMouseleave,
          $attrs.onMouseleave
        ]) }), {
          action: () => {
            var _a2, _b2;
            return (_b2 = (_a2 = this.$slots).action) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
          },
          empty: () => {
            var _a2, _b2;
            return (_b2 = (_a2 = this.$slots).empty) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
          }
        });
      }
    };
    return h$1(NPopover, Object.assign({}, omit(this.$props, panelPropKeys), popoverProps2, { internalDeactivateImmediately: true }), {
      trigger: () => {
        var _a2, _b2;
        return (_b2 = (_a2 = this.$slots).default) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
      }
    });
  }
});
function self$r(vars) {
  const { boxShadow2 } = vars;
  return {
    menuBoxShadow: boxShadow2
  };
}
const selectLight = createTheme({
  name: "Select",
  common: commonLight,
  peers: {
    InternalSelection: internalSelectionLight$1,
    InternalSelectMenu: internalSelectMenuLight$1
  },
  self: self$r
});
var selectLight$1 = selectLight;
var style$s = c$2([cB$1("select", `
 z-index: auto;
 outline: none;
 width: 100%;
 position: relative;
 `), cB$1("select-menu", `
 margin: 4px 0;
 box-shadow: var(--n-menu-box-shadow);
 `, [fadeInScaleUpTransition({
  originalTransition: "background-color .3s var(--n-bezier), box-shadow .3s var(--n-bezier)"
})])]);
const selectProps = Object.assign(Object.assign({}, useTheme.props), {
  to: useAdjustedTo.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clearable: Boolean,
  clearFilterAfterSelect: {
    type: Boolean,
    default: true
  },
  options: {
    type: Array,
    default: () => []
  },
  defaultValue: {
    type: [String, Number, Array],
    default: null
  },
  keyboard: {
    type: Boolean,
    default: true
  },
  value: [String, Number, Array],
  placeholder: String,
  menuProps: Object,
  multiple: Boolean,
  size: String,
  filterable: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  },
  remote: Boolean,
  loading: Boolean,
  filter: Function,
  placement: {
    type: String,
    default: "bottom-start"
  },
  widthMode: {
    type: String,
    default: "trigger"
  },
  tag: Boolean,
  onCreate: Function,
  fallbackOption: {
    type: [Function, Boolean],
    default: void 0
  },
  show: {
    type: Boolean,
    default: void 0
  },
  showArrow: {
    type: Boolean,
    default: true
  },
  maxTagCount: [Number, String],
  consistentMenuWidth: {
    type: Boolean,
    default: true
  },
  virtualScroll: {
    type: Boolean,
    default: true
  },
  labelField: {
    type: String,
    default: "label"
  },
  valueField: {
    type: String,
    default: "value"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  renderLabel: Function,
  renderOption: Function,
  renderTag: Function,
  "onUpdate:value": [Function, Array],
  inputProps: Object,
  nodeProps: Function,
  ignoreComposition: { type: Boolean, default: true },
  showOnFocus: Boolean,
  onUpdateValue: [Function, Array],
  onBlur: [Function, Array],
  onClear: [Function, Array],
  onFocus: [Function, Array],
  onScroll: [Function, Array],
  onSearch: [Function, Array],
  onUpdateShow: [Function, Array],
  "onUpdate:show": [Function, Array],
  displayDirective: {
    type: String,
    default: "show"
  },
  resetMenuOnOptionsChange: {
    type: Boolean,
    default: true
  },
  status: String,
  showCheckmark: {
    type: Boolean,
    default: true
  },
  onChange: [Function, Array],
  items: Array
});
var NSelect = defineComponent({
  name: "Select",
  props: selectProps,
  setup(props) {
    const { mergedClsPrefixRef, mergedBorderedRef, namespaceRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Select", "-select", style$s, selectLight$1, props, mergedClsPrefixRef);
    const uncontrolledValueRef = ref(props.defaultValue);
    const controlledValueRef = toRef(props, "value");
    const mergedValueRef = useMergedState(controlledValueRef, uncontrolledValueRef);
    const focusedRef = ref(false);
    const patternRef = ref("");
    const treeMateRef = computed(() => {
      const { valueField, childrenField } = props;
      const options = createTmOptions(valueField, childrenField);
      return createTreeMate(filteredOptionsRef.value, options);
    });
    const valOptMapRef = computed(() => createValOptMap(localOptionsRef.value, props.valueField, props.childrenField));
    const uncontrolledShowRef = ref(false);
    const mergedShowRef = useMergedState(toRef(props, "show"), uncontrolledShowRef);
    const triggerRef = ref(null);
    const followerRef = ref(null);
    const menuRef = ref(null);
    const { localeRef } = useLocale("Select");
    const localizedPlaceholderRef = computed(() => {
      var _a2;
      return (_a2 = props.placeholder) !== null && _a2 !== void 0 ? _a2 : localeRef.value.placeholder;
    });
    const compitableOptionsRef = useCompitable(props, ["items", "options"]);
    const emptyArray = [];
    const createdOptionsRef = ref([]);
    const beingCreatedOptionsRef = ref([]);
    const memoValOptMapRef = ref(new Map());
    const wrappedFallbackOptionRef = computed(() => {
      const { fallbackOption } = props;
      if (fallbackOption === void 0) {
        const { labelField, valueField } = props;
        return (value2) => ({
          [labelField]: String(value2),
          [valueField]: value2
        });
      }
      if (fallbackOption === false)
        return false;
      return (value2) => {
        return Object.assign(fallbackOption(value2), {
          value: value2
        });
      };
    });
    const localOptionsRef = computed(() => {
      return beingCreatedOptionsRef.value.concat(createdOptionsRef.value).concat(compitableOptionsRef.value);
    });
    const resolvedFilterRef = computed(() => {
      const { filter } = props;
      if (filter)
        return filter;
      const { labelField, valueField } = props;
      return (pattern4, option) => {
        if (!option)
          return false;
        const label = option[labelField];
        if (typeof label === "string") {
          return patternMatched(pattern4, label);
        }
        const value2 = option[valueField];
        if (typeof value2 === "string") {
          return patternMatched(pattern4, value2);
        }
        if (typeof value2 === "number") {
          return patternMatched(pattern4, String(value2));
        }
        return false;
      };
    });
    const filteredOptionsRef = computed(() => {
      if (props.remote) {
        return compitableOptionsRef.value;
      } else {
        const { value: localOptions } = localOptionsRef;
        const { value: pattern4 } = patternRef;
        if (!pattern4.length || !props.filterable) {
          return localOptions;
        } else {
          return filterOptions(localOptions, resolvedFilterRef.value, pattern4, props.childrenField);
        }
      }
    });
    function getMergedOptions(values2) {
      const remote = props.remote;
      const { value: memoValOptMap } = memoValOptMapRef;
      const { value: valOptMap } = valOptMapRef;
      const { value: wrappedFallbackOption } = wrappedFallbackOptionRef;
      const options = [];
      values2.forEach((value2) => {
        if (valOptMap.has(value2)) {
          options.push(valOptMap.get(value2));
        } else if (remote && memoValOptMap.has(value2)) {
          options.push(memoValOptMap.get(value2));
        } else if (wrappedFallbackOption) {
          const option = wrappedFallbackOption(value2);
          if (option) {
            options.push(option);
          }
        }
      });
      return options;
    }
    const selectedOptionsRef = computed(() => {
      if (props.multiple) {
        const { value: values2 } = mergedValueRef;
        if (!Array.isArray(values2))
          return [];
        return getMergedOptions(values2);
      }
      return null;
    });
    const selectedOptionRef = computed(() => {
      const { value: mergedValue } = mergedValueRef;
      if (!props.multiple && !Array.isArray(mergedValue)) {
        if (mergedValue === null)
          return null;
        return getMergedOptions([mergedValue])[0] || null;
      }
      return null;
    });
    const formItem = useFormItem(props);
    const { mergedSizeRef, mergedDisabledRef, mergedStatusRef } = formItem;
    function doUpdateValue(value2, option) {
      const { onChange, "onUpdate:value": _onUpdateValue, onUpdateValue } = props;
      const { nTriggerFormChange, nTriggerFormInput } = formItem;
      if (onChange)
        call(onChange, value2, option);
      if (onUpdateValue)
        call(onUpdateValue, value2, option);
      if (_onUpdateValue) {
        call(_onUpdateValue, value2, option);
      }
      uncontrolledValueRef.value = value2;
      nTriggerFormChange();
      nTriggerFormInput();
    }
    function doBlur(e25) {
      const { onBlur } = props;
      const { nTriggerFormBlur } = formItem;
      if (onBlur)
        call(onBlur, e25);
      nTriggerFormBlur();
    }
    function doClear() {
      const { onClear } = props;
      if (onClear)
        call(onClear);
    }
    function doFocus(e25) {
      const { onFocus, showOnFocus } = props;
      const { nTriggerFormFocus } = formItem;
      if (onFocus)
        call(onFocus, e25);
      nTriggerFormFocus();
      if (showOnFocus) {
        openMenu();
      }
    }
    function doSearch(value2) {
      const { onSearch } = props;
      if (onSearch)
        call(onSearch, value2);
    }
    function doScroll(e25) {
      const { onScroll } = props;
      if (onScroll)
        call(onScroll, e25);
    }
    function updateMemorizedOptions() {
      var _a2;
      const { remote, multiple } = props;
      if (remote) {
        const { value: memoValOptMap } = memoValOptMapRef;
        if (multiple) {
          const { valueField } = props;
          (_a2 = selectedOptionsRef.value) === null || _a2 === void 0 ? void 0 : _a2.forEach((option) => {
            memoValOptMap.set(option[valueField], option);
          });
        } else {
          const option = selectedOptionRef.value;
          if (option) {
            memoValOptMap.set(option[props.valueField], option);
          }
        }
      }
    }
    function doUpdateShow(value2) {
      const { onUpdateShow, "onUpdate:show": _onUpdateShow } = props;
      if (onUpdateShow)
        call(onUpdateShow, value2);
      if (_onUpdateShow)
        call(_onUpdateShow, value2);
      uncontrolledShowRef.value = value2;
    }
    function openMenu() {
      if (!mergedDisabledRef.value) {
        doUpdateShow(true);
        uncontrolledShowRef.value = true;
        if (props.filterable) {
          focusSelectionInput();
        }
      }
    }
    function closeMenu() {
      doUpdateShow(false);
    }
    function handleMenuAfterLeave() {
      patternRef.value = "";
      beingCreatedOptionsRef.value = emptyArray;
    }
    const activeWithoutMenuOpenRef = ref(false);
    function onTriggerInputFocus() {
      if (props.filterable) {
        activeWithoutMenuOpenRef.value = true;
      }
    }
    function onTriggerInputBlur() {
      if (props.filterable) {
        activeWithoutMenuOpenRef.value = false;
        if (!mergedShowRef.value) {
          handleMenuAfterLeave();
        }
      }
    }
    function handleTriggerClick() {
      if (mergedDisabledRef.value)
        return;
      if (!mergedShowRef.value) {
        openMenu();
      } else {
        if (!props.filterable) {
          closeMenu();
        } else {
          focusSelectionInput();
        }
      }
    }
    function handleTriggerBlur(e25) {
      var _a2, _b2;
      if ((_b2 = (_a2 = menuRef.value) === null || _a2 === void 0 ? void 0 : _a2.selfRef) === null || _b2 === void 0 ? void 0 : _b2.contains(e25.relatedTarget)) {
        return;
      }
      focusedRef.value = false;
      doBlur(e25);
      closeMenu();
    }
    function handleTriggerFocus(e25) {
      doFocus(e25);
      focusedRef.value = true;
    }
    function handleMenuFocus(e25) {
      focusedRef.value = true;
    }
    function handleMenuBlur(e25) {
      var _a2;
      if ((_a2 = triggerRef.value) === null || _a2 === void 0 ? void 0 : _a2.$el.contains(e25.relatedTarget))
        return;
      focusedRef.value = false;
      doBlur(e25);
      closeMenu();
    }
    function handleMenuTabOut() {
      var _a2;
      (_a2 = triggerRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      closeMenu();
    }
    function handleMenuClickOutside(e25) {
      var _a2;
      if (mergedShowRef.value) {
        if (!((_a2 = triggerRef.value) === null || _a2 === void 0 ? void 0 : _a2.$el.contains(getPreciseEventTarget(e25)))) {
          closeMenu();
        }
      }
    }
    function createClearedMultipleSelectValue(value2) {
      if (!Array.isArray(value2))
        return [];
      if (wrappedFallbackOptionRef.value) {
        return Array.from(value2);
      } else {
        const { remote } = props;
        const { value: valOptMap } = valOptMapRef;
        if (remote) {
          const { value: memoValOptMap } = memoValOptMapRef;
          return value2.filter((v2) => valOptMap.has(v2) || memoValOptMap.has(v2));
        } else {
          return value2.filter((v2) => valOptMap.has(v2));
        }
      }
    }
    function handleToggleByTmNode(tmNode) {
      handleToggleByOption(tmNode.rawNode);
    }
    function handleToggleByOption(option) {
      if (mergedDisabledRef.value)
        return;
      const { tag, remote, clearFilterAfterSelect, valueField } = props;
      if (tag && !remote) {
        const { value: beingCreatedOptions } = beingCreatedOptionsRef;
        const beingCreatedOption = beingCreatedOptions[0] || null;
        if (beingCreatedOption) {
          const createdOptions = createdOptionsRef.value;
          if (!createdOptions.length) {
            createdOptionsRef.value = [beingCreatedOption];
          } else {
            createdOptions.push(beingCreatedOption);
          }
          beingCreatedOptionsRef.value = emptyArray;
        }
      }
      if (remote) {
        memoValOptMapRef.value.set(option[valueField], option);
      }
      if (props.multiple) {
        const changedValue = createClearedMultipleSelectValue(mergedValueRef.value);
        const index2 = changedValue.findIndex((value2) => value2 === option[valueField]);
        if (~index2) {
          changedValue.splice(index2, 1);
          if (tag && !remote) {
            const createdOptionIndex = getCreatedOptionIndex(option[valueField]);
            if (~createdOptionIndex) {
              createdOptionsRef.value.splice(createdOptionIndex, 1);
              if (clearFilterAfterSelect)
                patternRef.value = "";
            }
          }
        } else {
          changedValue.push(option[valueField]);
          if (clearFilterAfterSelect)
            patternRef.value = "";
        }
        doUpdateValue(changedValue, getMergedOptions(changedValue));
      } else {
        if (tag && !remote) {
          const createdOptionIndex = getCreatedOptionIndex(option[valueField]);
          if (~createdOptionIndex) {
            createdOptionsRef.value = [
              createdOptionsRef.value[createdOptionIndex]
            ];
          } else {
            createdOptionsRef.value = emptyArray;
          }
        }
        focusSelection();
        closeMenu();
        doUpdateValue(option[valueField], option);
      }
    }
    function getCreatedOptionIndex(optionValue) {
      const createdOptions = createdOptionsRef.value;
      return createdOptions.findIndex((createdOption) => createdOption[props.valueField] === optionValue);
    }
    function handlePatternInput(e25) {
      if (!mergedShowRef.value) {
        openMenu();
      }
      const { value: value2 } = e25.target;
      patternRef.value = value2;
      const { tag, remote } = props;
      doSearch(value2);
      if (tag && !remote) {
        if (!value2) {
          beingCreatedOptionsRef.value = emptyArray;
          return;
        }
        const { onCreate } = props;
        const optionBeingCreated = onCreate ? onCreate(value2) : { [props.labelField]: value2, [props.valueField]: value2 };
        const { valueField } = props;
        if (compitableOptionsRef.value.some((option) => option[valueField] === optionBeingCreated[valueField]) || createdOptionsRef.value.some((option) => option[valueField] === optionBeingCreated[valueField])) {
          beingCreatedOptionsRef.value = emptyArray;
        } else {
          beingCreatedOptionsRef.value = [optionBeingCreated];
        }
      }
    }
    function handleClear(e25) {
      e25.stopPropagation();
      const { multiple } = props;
      if (!multiple && props.filterable) {
        closeMenu();
      }
      doClear();
      if (multiple) {
        doUpdateValue([], []);
      } else {
        doUpdateValue(null, null);
      }
    }
    function handleMenuMousedown(e25) {
      if (!happensIn(e25, "action") && !happensIn(e25, "empty"))
        e25.preventDefault();
    }
    function handleMenuScroll(e25) {
      doScroll(e25);
    }
    function handleKeydown(e25) {
      var _a2, _b2, _c2, _d2, _e2;
      if (!props.keyboard) {
        e25.preventDefault();
        return;
      }
      switch (e25.key) {
        case " ":
          if (props.filterable)
            break;
          else {
            e25.preventDefault();
          }
        case "Enter":
          if (!((_a2 = triggerRef.value) === null || _a2 === void 0 ? void 0 : _a2.isComposing)) {
            if (mergedShowRef.value) {
              const pendingTmNode = (_b2 = menuRef.value) === null || _b2 === void 0 ? void 0 : _b2.getPendingTmNode();
              if (pendingTmNode) {
                handleToggleByTmNode(pendingTmNode);
              } else if (!props.filterable) {
                closeMenu();
                focusSelection();
              }
            } else {
              openMenu();
              if (props.tag && activeWithoutMenuOpenRef.value) {
                const beingCreatedOption = beingCreatedOptionsRef.value[0];
                if (beingCreatedOption) {
                  const optionValue = beingCreatedOption[props.valueField];
                  const { value: mergedValue } = mergedValueRef;
                  if (props.multiple) {
                    if (Array.isArray(mergedValue) && mergedValue.some((value2) => value2 === optionValue))
                      ;
                    else {
                      handleToggleByOption(beingCreatedOption);
                    }
                  } else {
                    handleToggleByOption(beingCreatedOption);
                  }
                }
              }
            }
          }
          e25.preventDefault();
          break;
        case "ArrowUp":
          e25.preventDefault();
          if (props.loading)
            return;
          if (mergedShowRef.value) {
            (_c2 = menuRef.value) === null || _c2 === void 0 ? void 0 : _c2.prev();
          }
          break;
        case "ArrowDown":
          e25.preventDefault();
          if (props.loading)
            return;
          if (mergedShowRef.value) {
            (_d2 = menuRef.value) === null || _d2 === void 0 ? void 0 : _d2.next();
          } else {
            openMenu();
          }
          break;
        case "Escape":
          if (mergedShowRef.value) {
            markEventEffectPerformed(e25);
            closeMenu();
          }
          (_e2 = triggerRef.value) === null || _e2 === void 0 ? void 0 : _e2.focus();
          break;
      }
    }
    function focusSelection() {
      var _a2;
      (_a2 = triggerRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
    }
    function focusSelectionInput() {
      var _a2;
      (_a2 = triggerRef.value) === null || _a2 === void 0 ? void 0 : _a2.focusInput();
    }
    function handleTriggerOrMenuResize() {
      var _a2;
      if (!mergedShowRef.value)
        return;
      (_a2 = followerRef.value) === null || _a2 === void 0 ? void 0 : _a2.syncPosition();
    }
    updateMemorizedOptions();
    watch(toRef(props, "options"), updateMemorizedOptions);
    const exposedMethods = {
      focus: () => {
        var _a2;
        (_a2 = triggerRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      blur: () => {
        var _a2;
        (_a2 = triggerRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
      }
    };
    const cssVarsRef = computed(() => {
      const { self: { menuBoxShadow } } = themeRef.value;
      return {
        "--n-menu-box-shadow": menuBoxShadow
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("select", void 0, cssVarsRef, props) : void 0;
    return Object.assign(Object.assign({}, exposedMethods), {
      mergedStatus: mergedStatusRef,
      mergedClsPrefix: mergedClsPrefixRef,
      mergedBordered: mergedBorderedRef,
      namespace: namespaceRef,
      treeMate: treeMateRef,
      isMounted: isMounted(),
      triggerRef,
      menuRef,
      pattern: patternRef,
      uncontrolledShow: uncontrolledShowRef,
      mergedShow: mergedShowRef,
      adjustedTo: useAdjustedTo(props),
      uncontrolledValue: uncontrolledValueRef,
      mergedValue: mergedValueRef,
      followerRef,
      localizedPlaceholder: localizedPlaceholderRef,
      selectedOption: selectedOptionRef,
      selectedOptions: selectedOptionsRef,
      mergedSize: mergedSizeRef,
      mergedDisabled: mergedDisabledRef,
      focused: focusedRef,
      activeWithoutMenuOpen: activeWithoutMenuOpenRef,
      inlineThemeDisabled,
      onTriggerInputFocus,
      onTriggerInputBlur,
      handleTriggerOrMenuResize,
      handleMenuFocus,
      handleMenuBlur,
      handleMenuTabOut,
      handleTriggerClick,
      handleToggle: handleToggleByTmNode,
      handleDeleteOption: handleToggleByOption,
      handlePatternInput,
      handleClear,
      handleTriggerBlur,
      handleTriggerFocus,
      handleKeydown,
      handleMenuAfterLeave,
      handleMenuClickOutside,
      handleMenuScroll,
      handleMenuKeydown: handleKeydown,
      handleMenuMousedown,
      mergedTheme: themeRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    });
  },
  render() {
    return h$1("div", { class: `${this.mergedClsPrefix}-select` }, h$1(VBinder, null, {
      default: () => [
        h$1(VTarget, null, {
          default: () => h$1(NInternalSelection, { ref: "triggerRef", inlineThemeDisabled: this.inlineThemeDisabled, status: this.mergedStatus, inputProps: this.inputProps, clsPrefix: this.mergedClsPrefix, showArrow: this.showArrow, maxTagCount: this.maxTagCount, bordered: this.mergedBordered, active: this.activeWithoutMenuOpen || this.mergedShow, pattern: this.pattern, placeholder: this.localizedPlaceholder, selectedOption: this.selectedOption, selectedOptions: this.selectedOptions, multiple: this.multiple, renderTag: this.renderTag, renderLabel: this.renderLabel, filterable: this.filterable, clearable: this.clearable, disabled: this.mergedDisabled, size: this.mergedSize, theme: this.mergedTheme.peers.InternalSelection, labelField: this.labelField, valueField: this.valueField, themeOverrides: this.mergedTheme.peerOverrides.InternalSelection, loading: this.loading, focused: this.focused, onClick: this.handleTriggerClick, onDeleteOption: this.handleDeleteOption, onPatternInput: this.handlePatternInput, onClear: this.handleClear, onBlur: this.handleTriggerBlur, onFocus: this.handleTriggerFocus, onKeydown: this.handleKeydown, onPatternBlur: this.onTriggerInputBlur, onPatternFocus: this.onTriggerInputFocus, onResize: this.handleTriggerOrMenuResize, ignoreComposition: this.ignoreComposition }, {
            arrow: () => {
              var _a2, _b2;
              return [(_b2 = (_a2 = this.$slots).arrow) === null || _b2 === void 0 ? void 0 : _b2.call(_a2)];
            }
          })
        }),
        h$1(VFollower, { ref: "followerRef", show: this.mergedShow, to: this.adjustedTo, teleportDisabled: this.adjustedTo === useAdjustedTo.tdkey, containerClass: this.namespace, width: this.consistentMenuWidth ? "target" : void 0, minWidth: "target", placement: this.placement }, {
          default: () => h$1(Transition, { name: "fade-in-scale-up-transition", appear: this.isMounted, onAfterLeave: this.handleMenuAfterLeave }, {
            default: () => {
              var _a2, _b2, _c2;
              if (!(this.mergedShow || this.displayDirective === "show")) {
                return null;
              }
              (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
              return withDirectives(h$1(NInternalSelectMenu, Object.assign({}, this.menuProps, { ref: "menuRef", onResize: this.handleTriggerOrMenuResize, inlineThemeDisabled: this.inlineThemeDisabled, virtualScroll: this.consistentMenuWidth && this.virtualScroll, class: [
                `${this.mergedClsPrefix}-select-menu`,
                this.themeClass,
                (_b2 = this.menuProps) === null || _b2 === void 0 ? void 0 : _b2.class
              ], clsPrefix: this.mergedClsPrefix, focusable: true, labelField: this.labelField, valueField: this.valueField, autoPending: true, nodeProps: this.nodeProps, theme: this.mergedTheme.peers.InternalSelectMenu, themeOverrides: this.mergedTheme.peerOverrides.InternalSelectMenu, treeMate: this.treeMate, multiple: this.multiple, size: "medium", renderOption: this.renderOption, renderLabel: this.renderLabel, value: this.mergedValue, style: [(_c2 = this.menuProps) === null || _c2 === void 0 ? void 0 : _c2.style, this.cssVars], onToggle: this.handleToggle, onScroll: this.handleMenuScroll, onFocus: this.handleMenuFocus, onBlur: this.handleMenuBlur, onKeydown: this.handleMenuKeydown, onTabOut: this.handleMenuTabOut, onMousedown: this.handleMenuMousedown, show: this.mergedShow, showCheckmark: this.showCheckmark, resetMenuOnOptionsChange: this.resetMenuOnOptionsChange }), {
                empty: () => {
                  var _a3, _b3;
                  return [(_b3 = (_a3 = this.$slots).empty) === null || _b3 === void 0 ? void 0 : _b3.call(_a3)];
                },
                action: () => {
                  var _a3, _b3;
                  return [(_b3 = (_a3 = this.$slots).action) === null || _b3 === void 0 ? void 0 : _b3.call(_a3)];
                }
              }), this.displayDirective === "show" ? [
                [vShow, this.mergedShow],
                [
                  clickoutside$1,
                  this.handleMenuClickOutside,
                  void 0,
                  { capture: true }
                ]
              ] : [
                [
                  clickoutside$1,
                  this.handleMenuClickOutside,
                  void 0,
                  { capture: true }
                ]
              ]);
            }
          })
        })
      ]
    }));
  }
});
var commonVariables$5 = {
  itemPaddingSmall: "0 4px",
  itemMarginSmall: "0 0 0 8px",
  itemMarginSmallRtl: "0 8px 0 0",
  itemPaddingMedium: "0 4px",
  itemMarginMedium: "0 0 0 8px",
  itemMarginMediumRtl: "0 8px 0 0",
  itemPaddingLarge: "0 4px",
  itemMarginLarge: "0 0 0 8px",
  itemMarginLargeRtl: "0 8px 0 0",
  buttonIconSizeSmall: "14px",
  buttonIconSizeMedium: "16px",
  buttonIconSizeLarge: "18px",
  inputWidthSmall: "60px",
  selectWidthSmall: "unset",
  inputMarginSmall: "0 0 0 8px",
  inputMarginSmallRtl: "0 8px 0 0",
  selectMarginSmall: "0 0 0 8px",
  prefixMarginSmall: "0 8px 0 0",
  suffixMarginSmall: "0 0 0 8px",
  inputWidthMedium: "60px",
  selectWidthMedium: "unset",
  inputMarginMedium: "0 0 0 8px",
  inputMarginMediumRtl: "0 8px 0 0",
  selectMarginMedium: "0 0 0 8px",
  prefixMarginMedium: "0 8px 0 0",
  suffixMarginMedium: "0 0 0 8px",
  inputWidthLarge: "60px",
  selectWidthLarge: "unset",
  inputMarginLarge: "0 0 0 8px",
  inputMarginLargeRtl: "0 8px 0 0",
  selectMarginLarge: "0 0 0 8px",
  prefixMarginLarge: "0 8px 0 0",
  suffixMarginLarge: "0 0 0 8px"
};
const self$q = (vars) => {
  const {
    textColor2,
    primaryColor,
    primaryColorHover,
    primaryColorPressed,
    inputColorDisabled,
    textColorDisabled,
    borderColor,
    borderRadius,
    fontSizeTiny,
    fontSizeSmall,
    fontSizeMedium,
    heightTiny,
    heightSmall,
    heightMedium
  } = vars;
  return Object.assign(Object.assign({}, commonVariables$5), { buttonColor: "#0000", buttonColorHover: "#0000", buttonColorPressed: "#0000", buttonBorder: `1px solid ${borderColor}`, buttonBorderHover: `1px solid ${borderColor}`, buttonBorderPressed: `1px solid ${borderColor}`, buttonIconColor: textColor2, buttonIconColorHover: textColor2, buttonIconColorPressed: textColor2, itemTextColor: textColor2, itemTextColorHover: primaryColorHover, itemTextColorPressed: primaryColorPressed, itemTextColorActive: primaryColor, itemTextColorDisabled: textColorDisabled, itemColor: "#0000", itemColorHover: "#0000", itemColorPressed: "#0000", itemColorActive: "#0000", itemColorActiveHover: "#0000", itemColorDisabled: inputColorDisabled, itemBorder: "1px solid #0000", itemBorderHover: "1px solid #0000", itemBorderPressed: "1px solid #0000", itemBorderActive: `1px solid ${primaryColor}`, itemBorderDisabled: `1px solid ${borderColor}`, itemBorderRadius: borderRadius, itemSizeSmall: heightTiny, itemSizeMedium: heightSmall, itemSizeLarge: heightMedium, itemFontSizeSmall: fontSizeTiny, itemFontSizeMedium: fontSizeSmall, itemFontSizeLarge: fontSizeMedium, jumperFontSizeSmall: fontSizeTiny, jumperFontSizeMedium: fontSizeSmall, jumperFontSizeLarge: fontSizeMedium, jumperTextColor: textColor2, jumperTextColorDisabled: textColorDisabled });
};
const paginationLight = createTheme({
  name: "Pagination",
  common: commonLight,
  peers: {
    Select: selectLight$1,
    Input: inputLight$1,
    Popselect: popselectLight$1
  },
  self: self$q
});
var paginationLight$1 = paginationLight;
function createPageItemsInfo(currentPage, pageCount, pageSlot) {
  let hasFastBackward = false;
  let hasFastForward = false;
  let fastBackwardTo = 1;
  let fastForwardTo = pageCount;
  if (pageCount === 1) {
    return {
      hasFastBackward: false,
      hasFastForward: false,
      fastForwardTo,
      fastBackwardTo,
      items: [
        {
          type: "page",
          label: 1,
          active: currentPage === 1,
          mayBeFastBackward: false,
          mayBeFastForward: false
        }
      ]
    };
  }
  if (pageCount === 2) {
    return {
      hasFastBackward: false,
      hasFastForward: false,
      fastForwardTo,
      fastBackwardTo,
      items: [
        {
          type: "page",
          label: 1,
          active: currentPage === 1,
          mayBeFastBackward: false,
          mayBeFastForward: false
        },
        {
          type: "page",
          label: 2,
          active: currentPage === 2,
          mayBeFastBackward: true,
          mayBeFastForward: false
        }
      ]
    };
  }
  const firstPage = 1;
  const lastPage = pageCount;
  let middleStart = currentPage;
  let middleEnd = currentPage;
  const middleDelta = (pageSlot - 5) / 2;
  middleEnd += Math.ceil(middleDelta);
  middleEnd = Math.min(Math.max(middleEnd, firstPage + pageSlot - 3), lastPage - 2);
  middleStart -= Math.floor(middleDelta);
  middleStart = Math.max(Math.min(middleStart, lastPage - pageSlot + 3), firstPage + 2);
  let leftSplit = false;
  let rightSplit = false;
  if (middleStart > firstPage + 2)
    leftSplit = true;
  if (middleEnd < lastPage - 2)
    rightSplit = true;
  const items = [];
  items.push({
    type: "page",
    label: 1,
    active: currentPage === 1,
    mayBeFastBackward: false,
    mayBeFastForward: false
  });
  if (leftSplit) {
    hasFastBackward = true;
    fastBackwardTo = middleStart - 1;
    items.push({
      type: "fast-backward",
      active: false,
      label: void 0,
      options: createRange(firstPage + 1, middleStart - 1)
    });
  } else if (lastPage >= firstPage + 1) {
    items.push({
      type: "page",
      label: firstPage + 1,
      mayBeFastBackward: true,
      mayBeFastForward: false,
      active: currentPage === firstPage + 1
    });
  }
  for (let i2 = middleStart; i2 <= middleEnd; ++i2) {
    items.push({
      type: "page",
      label: i2,
      mayBeFastBackward: false,
      mayBeFastForward: false,
      active: currentPage === i2
    });
  }
  if (rightSplit) {
    hasFastForward = true;
    fastForwardTo = middleEnd + 1;
    items.push({
      type: "fast-forward",
      active: false,
      label: void 0,
      options: createRange(middleEnd + 1, lastPage - 1)
    });
  } else if (middleEnd === lastPage - 2 && items[items.length - 1].label !== lastPage - 1) {
    items.push({
      type: "page",
      mayBeFastForward: true,
      mayBeFastBackward: false,
      label: lastPage - 1,
      active: currentPage === lastPage - 1
    });
  }
  if (items[items.length - 1].label !== lastPage) {
    items.push({
      type: "page",
      mayBeFastForward: false,
      mayBeFastBackward: false,
      label: lastPage,
      active: currentPage === lastPage
    });
  }
  return {
    hasFastBackward,
    hasFastForward,
    fastBackwardTo,
    fastForwardTo,
    items
  };
}
function createRange(from, to2) {
  const range3 = [];
  for (let i2 = from; i2 <= to2; ++i2) {
    range3.push({
      label: `${i2}`,
      value: i2
    });
  }
  return range3;
}
const hoverStyleProps = `
 background: var(--n-item-color-hover);
 color: var(--n-item-text-color-hover);
 border: var(--n-item-border-hover);
`;
const hoverStyleChildren$1 = [cM("button", `
 background: var(--n-button-color-hover);
 border: var(--n-button-border-hover);
 color: var(--n-button-icon-color-hover);
 `)];
var style$r = cB$1("pagination", `
 display: flex;
 vertical-align: middle;
 font-size: var(--n-item-font-size);
 flex-wrap: nowrap;
`, [cB$1("pagination-prefix", `
 display: flex;
 align-items: center;
 margin: var(--n-prefix-margin);
 `), cB$1("pagination-suffix", `
 display: flex;
 align-items: center;
 margin: var(--n-suffix-margin);
 `), c$2("> *:not(:first-child)", `
 margin: var(--n-item-margin);
 `), cB$1("select", `
 width: var(--n-select-width);
 `), c$2("&.transition-disabled", [cB$1("pagination-item", "transition: none!important;")]), cB$1("pagination-quick-jumper", `
 white-space: nowrap;
 display: flex;
 color: var(--n-jumper-text-color);
 transition: color .3s var(--n-bezier);
 align-items: center;
 font-size: var(--n-jumper-font-size);
 `, [cB$1("input", `
 margin: var(--n-input-margin);
 width: var(--n-input-width);
 `)]), cB$1("pagination-item", `
 position: relative;
 cursor: pointer;
 user-select: none;
 -webkit-user-select: none;
 display: flex;
 align-items: center;
 justify-content: center;
 box-sizing: border-box;
 min-width: var(--n-item-size);
 height: var(--n-item-size);
 padding: var(--n-item-padding);
 background-color: var(--n-item-color);
 color: var(--n-item-text-color);
 border-radius: var(--n-item-border-radius);
 border: var(--n-item-border);
 fill: var(--n-button-icon-color);
 transition:
 color .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 fill .3s var(--n-bezier);
 `, [cM("button", `
 background: var(--n-button-color);
 color: var(--n-button-icon-color);
 border: var(--n-button-border);
 padding: 0;
 `, [cB$1("base-icon", `
 font-size: var(--n-button-icon-size);
 `)]), cNotM("disabled", [cM("hover", hoverStyleProps, hoverStyleChildren$1), c$2("&:hover", hoverStyleProps, hoverStyleChildren$1), c$2("&:active", `
 background: var(--n-item-color-pressed);
 color: var(--n-item-text-color-pressed);
 border: var(--n-item-border-pressed);
 `, [cM("button", `
 background: var(--n-button-color-pressed);
 border: var(--n-button-border-pressed);
 color: var(--n-button-icon-color-pressed);
 `)]), cM("active", `
 background: var(--n-item-color-active);
 color: var(--n-item-text-color-active);
 border: var(--n-item-border-active);
 `, [c$2("&:hover", `
 background: var(--n-item-color-active-hover);
 `)])]), cM("disabled", `
 cursor: not-allowed;
 color: var(--n-item-text-color-disabled);
 `, [cM("active, button", `
 background-color: var(--n-item-color-disabled);
 border: var(--n-item-border-disabled);
 `)])]), cM("disabled", `
 cursor: not-allowed;
 `, [cB$1("pagination-quick-jumper", `
 color: var(--n-jumper-text-color-disabled);
 `)]), cM("simple", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 `, [cB$1("pagination-quick-jumper", [cB$1("input", `
 margin: 0;
 `)])])]);
const paginationProps = Object.assign(Object.assign({}, useTheme.props), {
  simple: Boolean,
  page: Number,
  defaultPage: {
    type: Number,
    default: 1
  },
  itemCount: Number,
  pageCount: Number,
  defaultPageCount: {
    type: Number,
    default: 1
  },
  showSizePicker: Boolean,
  pageSize: Number,
  defaultPageSize: Number,
  pageSizes: {
    type: Array,
    default() {
      return [10];
    }
  },
  showQuickJumper: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  disabled: Boolean,
  pageSlot: {
    type: Number,
    default: 9
  },
  selectProps: Object,
  prev: Function,
  next: Function,
  goto: Function,
  prefix: Function,
  suffix: Function,
  label: Function,
  displayOrder: {
    type: Array,
    default: ["pages", "size-picker", "quick-jumper"]
  },
  to: useAdjustedTo.propTo,
  "onUpdate:page": [Function, Array],
  onUpdatePage: [Function, Array],
  "onUpdate:pageSize": [Function, Array],
  onUpdatePageSize: [Function, Array],
  onPageSizeChange: [Function, Array],
  onChange: [Function, Array]
});
var NPagination = defineComponent({
  name: "Pagination",
  props: paginationProps,
  setup(props) {
    const { mergedComponentPropsRef, mergedClsPrefixRef, inlineThemeDisabled, mergedRtlRef } = useConfig(props);
    const themeRef = useTheme("Pagination", "-pagination", style$r, paginationLight$1, props, mergedClsPrefixRef);
    const { localeRef } = useLocale("Pagination");
    const selfRef = ref(null);
    const uncontrolledPageRef = ref(props.defaultPage);
    const getDefaultPageSize = () => {
      const { defaultPageSize } = props;
      if (defaultPageSize !== void 0)
        return defaultPageSize;
      const pageSizeOption = props.pageSizes[0];
      if (typeof pageSizeOption === "number")
        return pageSizeOption;
      return pageSizeOption.value || 10;
    };
    const uncontrolledPageSizeRef = ref(getDefaultPageSize());
    const mergedPageRef = useMergedState(toRef(props, "page"), uncontrolledPageRef);
    const mergedPageSizeRef = useMergedState(toRef(props, "pageSize"), uncontrolledPageSizeRef);
    const mergedPageCountRef = computed(() => {
      const { itemCount } = props;
      if (itemCount !== void 0) {
        return Math.max(1, Math.ceil(itemCount / mergedPageSizeRef.value));
      }
      const { pageCount } = props;
      if (pageCount !== void 0)
        return Math.max(pageCount, 1);
      return 1;
    });
    const jumperValueRef = ref("");
    watchEffect(() => {
      void props.simple;
      jumperValueRef.value = String(mergedPageRef.value);
    });
    const fastForwardActiveRef = ref(false);
    const fastBackwardActiveRef = ref(false);
    const showFastForwardMenuRef = ref(false);
    const showFastBackwardMenuRef = ref(false);
    const handleFastForwardMouseenter = () => {
      if (props.disabled)
        return;
      fastForwardActiveRef.value = true;
      disableTransitionOneTick();
    };
    const handleFastForwardMouseleave = () => {
      if (props.disabled)
        return;
      fastForwardActiveRef.value = false;
      disableTransitionOneTick();
    };
    const handleFastBackwardMouseenter = () => {
      fastBackwardActiveRef.value = true;
      disableTransitionOneTick();
    };
    const handleFastBackwardMouseleave = () => {
      fastBackwardActiveRef.value = false;
      disableTransitionOneTick();
    };
    const handleMenuSelect = (value2) => {
      doUpdatePage(value2);
    };
    const pageItemsInfo = computed(() => createPageItemsInfo(mergedPageRef.value, mergedPageCountRef.value, props.pageSlot));
    watchEffect(() => {
      if (!pageItemsInfo.value.hasFastBackward) {
        fastBackwardActiveRef.value = false;
        showFastBackwardMenuRef.value = false;
      } else if (!pageItemsInfo.value.hasFastForward) {
        fastForwardActiveRef.value = false;
        showFastForwardMenuRef.value = false;
      }
    });
    const pageSizeOptionsRef = computed(() => {
      const suffix2 = localeRef.value.selectionSuffix;
      return props.pageSizes.map((size2) => {
        if (typeof size2 === "number") {
          return {
            label: `${size2} / ${suffix2}`,
            value: size2
          };
        } else {
          return size2;
        }
      });
    });
    const inputSizeRef = computed(() => {
      var _a2, _b2;
      return ((_b2 = (_a2 = mergedComponentPropsRef === null || mergedComponentPropsRef === void 0 ? void 0 : mergedComponentPropsRef.value) === null || _a2 === void 0 ? void 0 : _a2.Pagination) === null || _b2 === void 0 ? void 0 : _b2.inputSize) || smallerSize(props.size);
    });
    const selectSizeRef = computed(() => {
      var _a2, _b2;
      return ((_b2 = (_a2 = mergedComponentPropsRef === null || mergedComponentPropsRef === void 0 ? void 0 : mergedComponentPropsRef.value) === null || _a2 === void 0 ? void 0 : _a2.Pagination) === null || _b2 === void 0 ? void 0 : _b2.selectSize) || smallerSize(props.size);
    });
    const startIndexRef = computed(() => {
      return (mergedPageRef.value - 1) * mergedPageSizeRef.value;
    });
    const endIndexRef = computed(() => {
      const endIndex = mergedPageRef.value * mergedPageSizeRef.value - 1;
      const { itemCount } = props;
      if (itemCount !== void 0) {
        return endIndex > itemCount - 1 ? itemCount - 1 : endIndex;
      }
      return endIndex;
    });
    const mergedItemCountRef = computed(() => {
      const { itemCount } = props;
      if (itemCount !== void 0)
        return itemCount;
      return (props.pageCount || 1) * mergedPageSizeRef.value;
    });
    const rtlEnabledRef = useRtl("Pagination", mergedRtlRef, mergedClsPrefixRef);
    const disableTransitionOneTick = () => {
      void nextTick(() => {
        var _a2;
        const { value: selfEl } = selfRef;
        if (!selfEl)
          return;
        selfEl.classList.add("transition-disabled");
        void ((_a2 = selfRef.value) === null || _a2 === void 0 ? void 0 : _a2.offsetWidth);
        selfEl.classList.remove("transition-disabled");
      });
    };
    function doUpdatePage(page2) {
      if (page2 === mergedPageRef.value)
        return;
      const { "onUpdate:page": _onUpdatePage, onUpdatePage, onChange, simple } = props;
      if (_onUpdatePage)
        call(_onUpdatePage, page2);
      if (onUpdatePage)
        call(onUpdatePage, page2);
      if (onChange)
        call(onChange, page2);
      uncontrolledPageRef.value = page2;
      if (simple) {
        jumperValueRef.value = String(page2);
      }
    }
    function doUpdatePageSize(pageSize) {
      if (pageSize === mergedPageSizeRef.value)
        return;
      const { "onUpdate:pageSize": _onUpdatePageSize, onUpdatePageSize, onPageSizeChange } = props;
      if (_onUpdatePageSize)
        call(_onUpdatePageSize, pageSize);
      if (onUpdatePageSize)
        call(onUpdatePageSize, pageSize);
      if (onPageSizeChange)
        call(onPageSizeChange, pageSize);
      uncontrolledPageSizeRef.value = pageSize;
      if (mergedPageCountRef.value < mergedPageRef.value) {
        doUpdatePage(mergedPageCountRef.value);
      }
    }
    function forward() {
      if (props.disabled)
        return;
      const page2 = Math.min(mergedPageRef.value + 1, mergedPageCountRef.value);
      doUpdatePage(page2);
    }
    function backward() {
      if (props.disabled)
        return;
      const page2 = Math.max(mergedPageRef.value - 1, 1);
      doUpdatePage(page2);
    }
    function fastForward() {
      if (props.disabled)
        return;
      const page2 = Math.min(pageItemsInfo.value.fastForwardTo, mergedPageCountRef.value);
      doUpdatePage(page2);
    }
    function fastBackward() {
      if (props.disabled)
        return;
      const page2 = Math.max(pageItemsInfo.value.fastBackwardTo, 1);
      doUpdatePage(page2);
    }
    function handleSizePickerChange(value2) {
      doUpdatePageSize(value2);
    }
    function doQuickJump() {
      const page2 = parseInt(jumperValueRef.value);
      if (Number.isNaN(page2))
        return;
      doUpdatePage(Math.max(1, Math.min(page2, mergedPageCountRef.value)));
      if (!props.simple) {
        jumperValueRef.value = "";
      }
    }
    function handleQuickJumperChange() {
      doQuickJump();
    }
    function handlePageItemClick(pageItem) {
      if (props.disabled)
        return;
      switch (pageItem.type) {
        case "page":
          doUpdatePage(pageItem.label);
          break;
        case "fast-backward":
          fastBackward();
          break;
        case "fast-forward":
          fastForward();
          break;
      }
    }
    function handleJumperInput(value2) {
      jumperValueRef.value = value2.replace(/\D+/g, "");
    }
    watchEffect(() => {
      void mergedPageRef.value;
      void mergedPageSizeRef.value;
      disableTransitionOneTick();
    });
    const cssVarsRef = computed(() => {
      const { size: size2 } = props;
      const { self: { buttonBorder, buttonBorderHover, buttonBorderPressed, buttonIconColor, buttonIconColorHover, buttonIconColorPressed, itemTextColor, itemTextColorHover, itemTextColorPressed, itemTextColorActive, itemTextColorDisabled, itemColor, itemColorHover, itemColorPressed, itemColorActive, itemColorActiveHover, itemColorDisabled, itemBorder, itemBorderHover, itemBorderPressed, itemBorderActive, itemBorderDisabled, itemBorderRadius, jumperTextColor, jumperTextColorDisabled, buttonColor, buttonColorHover, buttonColorPressed, [createKey("itemPadding", size2)]: itemPadding, [createKey("itemMargin", size2)]: itemMargin, [createKey("inputWidth", size2)]: inputWidth, [createKey("selectWidth", size2)]: selectWidth, [createKey("inputMargin", size2)]: inputMargin, [createKey("selectMargin", size2)]: selectMargin, [createKey("jumperFontSize", size2)]: jumperFontSize, [createKey("prefixMargin", size2)]: prefixMargin, [createKey("suffixMargin", size2)]: suffixMargin, [createKey("itemSize", size2)]: itemSize, [createKey("buttonIconSize", size2)]: buttonIconSize, [createKey("itemFontSize", size2)]: itemFontSize, [`${createKey("itemMargin", size2)}Rtl`]: itemMarginRtl, [`${createKey("inputMargin", size2)}Rtl`]: inputMarginRtl }, common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 } } = themeRef.value;
      return {
        "--n-prefix-margin": prefixMargin,
        "--n-suffix-margin": suffixMargin,
        "--n-item-font-size": itemFontSize,
        "--n-select-width": selectWidth,
        "--n-select-margin": selectMargin,
        "--n-input-width": inputWidth,
        "--n-input-margin": inputMargin,
        "--n-input-margin-rtl": inputMarginRtl,
        "--n-item-size": itemSize,
        "--n-item-text-color": itemTextColor,
        "--n-item-text-color-disabled": itemTextColorDisabled,
        "--n-item-text-color-hover": itemTextColorHover,
        "--n-item-text-color-active": itemTextColorActive,
        "--n-item-text-color-pressed": itemTextColorPressed,
        "--n-item-color": itemColor,
        "--n-item-color-hover": itemColorHover,
        "--n-item-color-disabled": itemColorDisabled,
        "--n-item-color-active": itemColorActive,
        "--n-item-color-active-hover": itemColorActiveHover,
        "--n-item-color-pressed": itemColorPressed,
        "--n-item-border": itemBorder,
        "--n-item-border-hover": itemBorderHover,
        "--n-item-border-disabled": itemBorderDisabled,
        "--n-item-border-active": itemBorderActive,
        "--n-item-border-pressed": itemBorderPressed,
        "--n-item-padding": itemPadding,
        "--n-item-border-radius": itemBorderRadius,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-jumper-font-size": jumperFontSize,
        "--n-jumper-text-color": jumperTextColor,
        "--n-jumper-text-color-disabled": jumperTextColorDisabled,
        "--n-item-margin": itemMargin,
        "--n-item-margin-rtl": itemMarginRtl,
        "--n-button-icon-size": buttonIconSize,
        "--n-button-icon-color": buttonIconColor,
        "--n-button-icon-color-hover": buttonIconColorHover,
        "--n-button-icon-color-pressed": buttonIconColorPressed,
        "--n-button-color-hover": buttonColorHover,
        "--n-button-color": buttonColor,
        "--n-button-color-pressed": buttonColorPressed,
        "--n-button-border": buttonBorder,
        "--n-button-border-hover": buttonBorderHover,
        "--n-button-border-pressed": buttonBorderPressed
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("pagination", computed(() => {
      let hash2 = "";
      const { size: size2 } = props;
      hash2 += size2[0];
      return hash2;
    }), cssVarsRef, props) : void 0;
    return {
      rtlEnabled: rtlEnabledRef,
      mergedClsPrefix: mergedClsPrefixRef,
      locale: localeRef,
      selfRef,
      mergedPage: mergedPageRef,
      pageItems: computed(() => {
        return pageItemsInfo.value.items;
      }),
      mergedItemCount: mergedItemCountRef,
      jumperValue: jumperValueRef,
      pageSizeOptions: pageSizeOptionsRef,
      mergedPageSize: mergedPageSizeRef,
      inputSize: inputSizeRef,
      selectSize: selectSizeRef,
      mergedTheme: themeRef,
      mergedPageCount: mergedPageCountRef,
      startIndex: startIndexRef,
      endIndex: endIndexRef,
      showFastForwardMenu: showFastForwardMenuRef,
      showFastBackwardMenu: showFastBackwardMenuRef,
      fastForwardActive: fastForwardActiveRef,
      fastBackwardActive: fastBackwardActiveRef,
      handleMenuSelect,
      handleFastForwardMouseenter,
      handleFastForwardMouseleave,
      handleFastBackwardMouseenter,
      handleFastBackwardMouseleave,
      handleJumperInput,
      handleBackwardClick: backward,
      handleForwardClick: forward,
      handlePageItemClick,
      handleSizePickerChange,
      handleQuickJumperChange,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const { $slots, mergedClsPrefix, disabled, cssVars, mergedPage, mergedPageCount, pageItems, showSizePicker, showQuickJumper, mergedTheme, locale: locale2, inputSize, selectSize, mergedPageSize, pageSizeOptions, jumperValue, simple, prev, next, prefix: prefix2, suffix: suffix2, label, goto, handleJumperInput, handleSizePickerChange, handleBackwardClick, handlePageItemClick, handleForwardClick, handleQuickJumperChange, onRender } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    const renderPrefix = $slots.prefix || prefix2;
    const renderSuffix = $slots.suffix || suffix2;
    const renderPrev = prev || $slots.prev;
    const renderNext = next || $slots.next;
    const renderLabel = label || $slots.label;
    return h$1("div", { ref: "selfRef", class: [
      `${mergedClsPrefix}-pagination`,
      this.themeClass,
      this.rtlEnabled && `${mergedClsPrefix}-pagination--rtl`,
      disabled && `${mergedClsPrefix}-pagination--disabled`,
      simple && `${mergedClsPrefix}-pagination--simple`
    ], style: cssVars }, renderPrefix ? h$1("div", { class: `${mergedClsPrefix}-pagination-prefix` }, renderPrefix({
      page: mergedPage,
      pageSize: mergedPageSize,
      pageCount: mergedPageCount,
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      itemCount: this.mergedItemCount
    })) : null, this.displayOrder.map((part) => {
      switch (part) {
        case "pages":
          return h$1(Fragment, null, h$1("div", { class: [
            `${mergedClsPrefix}-pagination-item`,
            !renderPrev && `${mergedClsPrefix}-pagination-item--button`,
            (mergedPage <= 1 || mergedPage > mergedPageCount || disabled) && `${mergedClsPrefix}-pagination-item--disabled`
          ], onClick: handleBackwardClick }, renderPrev ? renderPrev({
            page: mergedPage,
            pageSize: mergedPageSize,
            pageCount: mergedPageCount,
            startIndex: this.startIndex,
            endIndex: this.endIndex,
            itemCount: this.mergedItemCount
          }) : h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, {
            default: () => this.rtlEnabled ? h$1(ForwardIcon, null) : h$1(BackwardIcon, null)
          })), simple ? h$1(Fragment, null, h$1("div", { class: `${mergedClsPrefix}-pagination-quick-jumper` }, h$1(NInput, { value: jumperValue, onUpdateValue: handleJumperInput, size: inputSize, placeholder: "", disabled, theme: mergedTheme.peers.Input, themeOverrides: mergedTheme.peerOverrides.Input, onChange: handleQuickJumperChange })), "\xA0/ ", mergedPageCount) : pageItems.map((pageItem, index2) => {
            let contentNode;
            let onMouseenter;
            let onMouseleave;
            const { type: type4 } = pageItem;
            switch (type4) {
              case "page":
                const pageNode = pageItem.label;
                if (renderLabel) {
                  contentNode = renderLabel({
                    type: "page",
                    node: pageNode,
                    active: pageItem.active
                  });
                } else {
                  contentNode = pageNode;
                }
                break;
              case "fast-forward":
                const fastForwardNode = this.fastForwardActive ? h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, {
                  default: () => this.rtlEnabled ? h$1(FastBackwardIcon, null) : h$1(FastForwardIcon, null)
                }) : h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, { default: () => h$1(MoreIcon, null) });
                if (renderLabel) {
                  contentNode = renderLabel({
                    type: "fast-forward",
                    node: fastForwardNode,
                    active: this.fastForwardActive || this.showFastForwardMenu
                  });
                } else {
                  contentNode = fastForwardNode;
                }
                onMouseenter = this.handleFastForwardMouseenter;
                onMouseleave = this.handleFastForwardMouseleave;
                break;
              case "fast-backward":
                const fastBackwardNode = this.fastBackwardActive ? h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, {
                  default: () => this.rtlEnabled ? h$1(FastForwardIcon, null) : h$1(FastBackwardIcon, null)
                }) : h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, { default: () => h$1(MoreIcon, null) });
                if (renderLabel) {
                  contentNode = renderLabel({
                    type: "fast-backward",
                    node: fastBackwardNode,
                    active: this.fastBackwardActive || this.showFastBackwardMenu
                  });
                } else {
                  contentNode = fastBackwardNode;
                }
                onMouseenter = this.handleFastBackwardMouseenter;
                onMouseleave = this.handleFastBackwardMouseleave;
                break;
            }
            const itemNode = h$1("div", { key: index2, class: [
              `${mergedClsPrefix}-pagination-item`,
              pageItem.active && `${mergedClsPrefix}-pagination-item--active`,
              type4 !== "page" && (type4 === "fast-backward" && this.showFastBackwardMenu || type4 === "fast-forward" && this.showFastForwardMenu) && `${mergedClsPrefix}-pagination-item--hover`,
              disabled && `${mergedClsPrefix}-pagination-item--disabled`,
              type4 === "page" && `${mergedClsPrefix}-pagination-item--clickable`
            ], onClick: () => {
              handlePageItemClick(pageItem);
            }, onMouseenter, onMouseleave }, contentNode);
            if (type4 === "page" && !pageItem.mayBeFastBackward && !pageItem.mayBeFastForward) {
              return itemNode;
            } else {
              const key = pageItem.type === "page" ? pageItem.mayBeFastBackward ? "fast-backward" : "fast-forward" : pageItem.type;
              return h$1(NPopselect, { to: this.to, key, disabled, trigger: "hover", virtualScroll: true, style: { width: "60px" }, theme: mergedTheme.peers.Popselect, themeOverrides: mergedTheme.peerOverrides.Popselect, builtinThemeOverrides: {
                peers: {
                  InternalSelectMenu: {
                    height: "calc(var(--n-option-height) * 4.6)"
                  }
                }
              }, nodeProps: () => ({
                style: {
                  justifyContent: "center"
                }
              }), show: type4 === "page" ? false : type4 === "fast-backward" ? this.showFastBackwardMenu : this.showFastForwardMenu, onUpdateShow: (value2) => {
                if (type4 === "page")
                  return;
                if (value2) {
                  if (type4 === "fast-backward") {
                    this.showFastBackwardMenu = value2;
                  } else {
                    this.showFastForwardMenu = value2;
                  }
                } else {
                  this.showFastBackwardMenu = false;
                  this.showFastForwardMenu = false;
                }
              }, options: pageItem.type !== "page" ? pageItem.options : [], onUpdateValue: this.handleMenuSelect, scrollable: true, showCheckmark: false }, { default: () => itemNode });
            }
          }), h$1("div", { class: [
            `${mergedClsPrefix}-pagination-item`,
            !renderNext && `${mergedClsPrefix}-pagination-item--button`,
            {
              [`${mergedClsPrefix}-pagination-item--disabled`]: mergedPage < 1 || mergedPage >= mergedPageCount || disabled
            }
          ], onClick: handleForwardClick }, renderNext ? renderNext({
            page: mergedPage,
            pageSize: mergedPageSize,
            pageCount: mergedPageCount,
            itemCount: this.mergedItemCount,
            startIndex: this.startIndex,
            endIndex: this.endIndex
          }) : h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, {
            default: () => this.rtlEnabled ? h$1(BackwardIcon, null) : h$1(ForwardIcon, null)
          })));
        case "size-picker": {
          return !simple && showSizePicker ? h$1(NSelect, Object.assign({ consistentMenuWidth: false, placeholder: "", showCheckmark: false, to: this.to }, this.selectProps, { size: selectSize, options: pageSizeOptions, value: mergedPageSize, disabled, theme: mergedTheme.peers.Select, themeOverrides: mergedTheme.peerOverrides.Select, onUpdateValue: handleSizePickerChange })) : null;
        }
        case "quick-jumper":
          return !simple && showQuickJumper ? h$1("div", { class: `${mergedClsPrefix}-pagination-quick-jumper` }, goto ? goto() : resolveSlot(this.$slots.goto, () => [locale2.goto]), h$1(NInput, { value: jumperValue, onUpdateValue: handleJumperInput, size: inputSize, placeholder: "", disabled, theme: mergedTheme.peers.Input, themeOverrides: mergedTheme.peerOverrides.Input, onChange: handleQuickJumperChange })) : null;
        default:
          return null;
      }
    }), renderSuffix ? h$1("div", { class: `${mergedClsPrefix}-pagination-suffix` }, renderSuffix({
      page: mergedPage,
      pageSize: mergedPageSize,
      pageCount: mergedPageCount,
      startIndex: this.startIndex,
      endIndex: this.endIndex,
      itemCount: this.mergedItemCount
    })) : null);
  }
});
var commonVars$6 = {
  padding: "8px 14px"
};
const self$p = (vars) => {
  const { borderRadius, boxShadow2, baseColor } = vars;
  return Object.assign(Object.assign({}, commonVars$6), { borderRadius, boxShadow: boxShadow2, color: composite(baseColor, "rgba(0, 0, 0, .85)"), textColor: baseColor });
};
const tooltipLight = createTheme({
  name: "Tooltip",
  common: commonLight,
  peers: {
    Popover: popoverLight$1
  },
  self: self$p
});
var tooltipLight$1 = tooltipLight;
const ellipsisLight = createTheme({
  name: "Ellipsis",
  common: commonLight,
  peers: {
    Tooltip: tooltipLight$1
  }
});
var ellipsisLight$1 = ellipsisLight;
var commonVariables$4 = {
  radioSizeSmall: "14px",
  radioSizeMedium: "16px",
  radioSizeLarge: "18px",
  labelPadding: "0 8px",
  labelFontWeight: "400"
};
const self$o = (vars) => {
  const { borderColor, primaryColor, baseColor, textColorDisabled, inputColorDisabled, textColor2, opacityDisabled, borderRadius, fontSizeSmall, fontSizeMedium, fontSizeLarge, heightSmall, heightMedium, heightLarge, lineHeight: lineHeight2 } = vars;
  return Object.assign(Object.assign({}, commonVariables$4), {
    labelLineHeight: lineHeight2,
    buttonHeightSmall: heightSmall,
    buttonHeightMedium: heightMedium,
    buttonHeightLarge: heightLarge,
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    boxShadow: `inset 0 0 0 1px ${borderColor}`,
    boxShadowActive: `inset 0 0 0 1px ${primaryColor}`,
    boxShadowFocus: `inset 0 0 0 1px ${primaryColor}, 0 0 0 2px ${changeColor(primaryColor, { alpha: 0.2 })}`,
    boxShadowHover: `inset 0 0 0 1px ${primaryColor}`,
    boxShadowDisabled: `inset 0 0 0 1px ${borderColor}`,
    color: baseColor,
    colorDisabled: inputColorDisabled,
    colorActive: "#0000",
    textColor: textColor2,
    textColorDisabled,
    dotColorActive: primaryColor,
    dotColorDisabled: borderColor,
    buttonBorderColor: borderColor,
    buttonBorderColorActive: primaryColor,
    buttonBorderColorHover: borderColor,
    buttonColor: baseColor,
    buttonColorActive: baseColor,
    buttonTextColor: textColor2,
    buttonTextColorActive: primaryColor,
    buttonTextColorHover: primaryColor,
    opacityDisabled,
    buttonBoxShadowFocus: `inset 0 0 0 1px ${primaryColor}, 0 0 0 2px ${changeColor(primaryColor, { alpha: 0.3 })}`,
    buttonBoxShadowHover: "inset 0 0 0 1px #0000",
    buttonBoxShadow: "inset 0 0 0 1px #0000",
    buttonBorderRadius: borderRadius
  });
};
const radioLight = {
  name: "Radio",
  common: commonLight,
  self: self$o
};
var radioLight$1 = radioLight;
var commonVariables$3 = {
  padding: "4px 0",
  optionIconSizeSmall: "14px",
  optionIconSizeMedium: "16px",
  optionIconSizeLarge: "16px",
  optionIconSizeHuge: "18px",
  optionSuffixWidthSmall: "14px",
  optionSuffixWidthMedium: "14px",
  optionSuffixWidthLarge: "16px",
  optionSuffixWidthHuge: "16px",
  optionIconSuffixWidthSmall: "32px",
  optionIconSuffixWidthMedium: "32px",
  optionIconSuffixWidthLarge: "36px",
  optionIconSuffixWidthHuge: "36px",
  optionPrefixWidthSmall: "14px",
  optionPrefixWidthMedium: "14px",
  optionPrefixWidthLarge: "16px",
  optionPrefixWidthHuge: "16px",
  optionIconPrefixWidthSmall: "36px",
  optionIconPrefixWidthMedium: "36px",
  optionIconPrefixWidthLarge: "40px",
  optionIconPrefixWidthHuge: "40px"
};
const self$n = (vars) => {
  const { primaryColor, textColor2, dividerColor, hoverColor, popoverColor, invertedColor, borderRadius, fontSizeSmall, fontSizeMedium, fontSizeLarge, fontSizeHuge, heightSmall, heightMedium, heightLarge, heightHuge, textColor3, opacityDisabled } = vars;
  return Object.assign(Object.assign({}, commonVariables$3), {
    optionHeightSmall: heightSmall,
    optionHeightMedium: heightMedium,
    optionHeightLarge: heightLarge,
    optionHeightHuge: heightHuge,
    borderRadius,
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    fontSizeHuge,
    optionTextColor: textColor2,
    optionTextColorHover: textColor2,
    optionTextColorActive: primaryColor,
    optionTextColorChildActive: primaryColor,
    color: popoverColor,
    dividerColor,
    suffixColor: textColor2,
    prefixColor: textColor2,
    optionColorHover: hoverColor,
    optionColorActive: changeColor(primaryColor, { alpha: 0.1 }),
    groupHeaderTextColor: textColor3,
    optionTextColorInverted: "#BBB",
    optionTextColorHoverInverted: "#FFF",
    optionTextColorActiveInverted: "#FFF",
    optionTextColorChildActiveInverted: "#FFF",
    colorInverted: invertedColor,
    dividerColorInverted: "#BBB",
    suffixColorInverted: "#BBB",
    prefixColorInverted: "#BBB",
    optionColorHoverInverted: primaryColor,
    optionColorActiveInverted: primaryColor,
    groupHeaderTextColorInverted: "#AAA",
    optionOpacityDisabled: opacityDisabled
  });
};
const dropdownLight = createTheme({
  name: "Dropdown",
  common: commonLight,
  peers: {
    Popover: popoverLight$1
  },
  self: self$n
});
var dropdownLight$1 = dropdownLight;
var commonVariables$2 = {
  thPaddingSmall: "8px",
  thPaddingMedium: "12px",
  thPaddingLarge: "12px",
  tdPaddingSmall: "8px",
  tdPaddingMedium: "12px",
  tdPaddingLarge: "12px",
  sorterSize: "15px",
  resizableContainerSize: "8px",
  resizableSize: "2px",
  filterSize: "15px",
  paginationMargin: "12px 0 0 0",
  emptyPadding: "48px 0",
  actionPadding: "8px 12px",
  actionButtonMargin: "0 8px 0 0"
};
const self$m = (vars) => {
  const { cardColor, modalColor, popoverColor, textColor2, textColor1, tableHeaderColor, tableColorHover, iconColor, primaryColor, fontWeightStrong, borderRadius, lineHeight: lineHeight2, fontSizeSmall, fontSizeMedium, fontSizeLarge, dividerColor, heightSmall, opacityDisabled, tableColorStriped } = vars;
  return Object.assign(Object.assign({}, commonVariables$2), {
    actionDividerColor: dividerColor,
    lineHeight: lineHeight2,
    borderRadius,
    fontSizeSmall,
    fontSizeMedium,
    fontSizeLarge,
    borderColor: composite(cardColor, dividerColor),
    tdColorHover: composite(cardColor, tableColorHover),
    tdColorStriped: composite(cardColor, tableColorStriped),
    thColor: composite(cardColor, tableHeaderColor),
    thColorHover: composite(composite(cardColor, tableHeaderColor), tableColorHover),
    tdColor: cardColor,
    tdTextColor: textColor2,
    thTextColor: textColor1,
    thFontWeight: fontWeightStrong,
    thButtonColorHover: tableColorHover,
    thIconColor: iconColor,
    thIconColorActive: primaryColor,
    borderColorModal: composite(modalColor, dividerColor),
    tdColorHoverModal: composite(modalColor, tableColorHover),
    tdColorStripedModal: composite(modalColor, tableColorStriped),
    thColorModal: composite(modalColor, tableHeaderColor),
    thColorHoverModal: composite(composite(modalColor, tableHeaderColor), tableColorHover),
    tdColorModal: modalColor,
    borderColorPopover: composite(popoverColor, dividerColor),
    tdColorHoverPopover: composite(popoverColor, tableColorHover),
    tdColorStripedPopover: composite(popoverColor, tableColorStriped),
    thColorPopover: composite(popoverColor, tableHeaderColor),
    thColorHoverPopover: composite(composite(popoverColor, tableHeaderColor), tableColorHover),
    tdColorPopover: popoverColor,
    boxShadowBefore: "inset -12px 0 8px -12px rgba(0, 0, 0, .18)",
    boxShadowAfter: "inset 12px 0 8px -12px rgba(0, 0, 0, .18)",
    loadingColor: primaryColor,
    loadingSize: heightSmall,
    opacityLoading: opacityDisabled
  });
};
const dataTableLight = createTheme({
  name: "DataTable",
  common: commonLight,
  peers: {
    Button: buttonLight$1,
    Checkbox: checkboxLight$1,
    Radio: radioLight$1,
    Pagination: paginationLight$1,
    Scrollbar: scrollbarLight$1,
    Empty: emptyLight$1,
    Popover: popoverLight$1,
    Ellipsis: ellipsisLight$1,
    Dropdown: dropdownLight$1
  },
  self: self$m
});
var dataTableLight$1 = dataTableLight;
const tooltipProps = Object.assign(Object.assign({}, popoverBaseProps), useTheme.props);
var NTooltip = defineComponent({
  name: "Tooltip",
  props: tooltipProps,
  __popover__: true,
  setup(props) {
    const { mergedClsPrefixRef } = useConfig(props);
    const themeRef = useTheme("Tooltip", "-tooltip", void 0, tooltipLight$1, props, mergedClsPrefixRef);
    const popoverRef = ref(null);
    const tooltipExposedMethod = {
      syncPosition() {
        popoverRef.value.syncPosition();
      },
      setShow(show) {
        popoverRef.value.setShow(show);
      }
    };
    return Object.assign(Object.assign({}, tooltipExposedMethod), { popoverRef, mergedTheme: themeRef, popoverThemeOverrides: computed(() => {
      return themeRef.value.self;
    }) });
  },
  render() {
    const { mergedTheme, internalExtraClass } = this;
    return h$1(NPopover, Object.assign(Object.assign({}, this.$props), { theme: mergedTheme.peers.Popover, themeOverrides: mergedTheme.peerOverrides.Popover, builtinThemeOverrides: this.popoverThemeOverrides, internalExtraClass: internalExtraClass.concat("tooltip"), ref: "popoverRef" }), this.$slots);
  }
});
var style$q = cB$1("ellipsis", {
  overflow: "hidden"
}, [cNotM("line-clamp", `
 white-space: nowrap;
 display: inline-block;
 vertical-align: bottom;
 max-width: 100%;
 `), cM("line-clamp", `
 display: -webkit-inline-box;
 -webkit-box-orient: vertical;
 `), cM("cursor-pointer", `
 cursor: pointer;
 `)]);
function createLineClampClass(clsPrefix) {
  return `${clsPrefix}-ellipsis--line-clamp`;
}
function createCursorClass(clsPrefix, cursor) {
  return `${clsPrefix}-ellipsis--cursor-${cursor}`;
}
const ellipsisProps = Object.assign(Object.assign({}, useTheme.props), { expandTrigger: String, lineClamp: [Number, String], tooltip: {
  type: [Boolean, Object],
  default: true
} });
var NEllipsis = defineComponent({
  name: "Ellipsis",
  inheritAttrs: false,
  props: ellipsisProps,
  setup(props, { slots, attrs }) {
    const { mergedClsPrefixRef } = useConfig(props);
    const mergedTheme = useTheme("Ellipsis", "-ellipsis", style$q, ellipsisLight$1, props, mergedClsPrefixRef);
    const triggerRef = ref(null);
    const triggerInnerRef = ref(null);
    const tooltipRef = ref(null);
    const expandedRef = ref(false);
    const ellipsisStyleRef = computed(() => {
      const { lineClamp } = props;
      const { value: expanded } = expandedRef;
      if (lineClamp !== void 0) {
        return {
          textOverflow: "",
          "-webkit-line-clamp": expanded ? "" : lineClamp
        };
      } else {
        return {
          textOverflow: expanded ? "" : "ellipsis",
          "-webkit-line-clamp": ""
        };
      }
    });
    function getTooltipDisabled() {
      let tooltipDisabled = false;
      const { value: expanded } = expandedRef;
      if (expanded)
        return true;
      const { value: trigger2 } = triggerRef;
      if (trigger2) {
        const { lineClamp } = props;
        syncEllipsisStyle(trigger2);
        if (lineClamp !== void 0) {
          tooltipDisabled = trigger2.scrollHeight <= trigger2.offsetHeight;
        } else {
          const { value: triggerInner } = triggerInnerRef;
          if (triggerInner) {
            tooltipDisabled = triggerInner.getBoundingClientRect().width <= trigger2.getBoundingClientRect().width;
          }
        }
        syncCursorStyle(trigger2, tooltipDisabled);
      }
      return tooltipDisabled;
    }
    const handleClickRef = computed(() => {
      return props.expandTrigger === "click" ? () => {
        var _a2;
        const { value: expanded } = expandedRef;
        if (expanded) {
          (_a2 = tooltipRef.value) === null || _a2 === void 0 ? void 0 : _a2.setShow(false);
        }
        expandedRef.value = !expanded;
      } : void 0;
    });
    onDeactivated(() => {
      var _a2;
      if (props.tooltip) {
        (_a2 = tooltipRef.value) === null || _a2 === void 0 ? void 0 : _a2.setShow(false);
      }
    });
    const renderTrigger = () => h$1("span", Object.assign({}, mergeProps(attrs, {
      class: [
        `${mergedClsPrefixRef.value}-ellipsis`,
        props.lineClamp !== void 0 ? createLineClampClass(mergedClsPrefixRef.value) : void 0,
        props.expandTrigger === "click" ? createCursorClass(mergedClsPrefixRef.value, "pointer") : void 0
      ],
      style: ellipsisStyleRef.value
    }), { ref: "triggerRef", onClick: handleClickRef.value, onMouseenter: props.expandTrigger === "click" ? getTooltipDisabled : void 0 }), props.lineClamp ? slots : h$1("span", { ref: "triggerInnerRef" }, slots));
    function syncEllipsisStyle(trigger2) {
      if (!trigger2)
        return;
      const latestStyle = ellipsisStyleRef.value;
      const lineClampClass = createLineClampClass(mergedClsPrefixRef.value);
      if (props.lineClamp !== void 0) {
        syncTriggerClass(trigger2, lineClampClass, "add");
      } else {
        syncTriggerClass(trigger2, lineClampClass, "remove");
      }
      for (const key in latestStyle) {
        if (trigger2.style[key] !== latestStyle[key]) {
          trigger2.style[key] = latestStyle[key];
        }
      }
    }
    function syncCursorStyle(trigger2, tooltipDisabled) {
      const cursorClass = createCursorClass(mergedClsPrefixRef.value, "pointer");
      if (props.expandTrigger === "click" && !tooltipDisabled) {
        syncTriggerClass(trigger2, cursorClass, "add");
      } else {
        syncTriggerClass(trigger2, cursorClass, "remove");
      }
    }
    function syncTriggerClass(trigger2, styleClass, action) {
      if (action === "add") {
        if (!trigger2.classList.contains(styleClass)) {
          trigger2.classList.add(styleClass);
        }
      } else {
        if (trigger2.classList.contains(styleClass)) {
          trigger2.classList.remove(styleClass);
        }
      }
    }
    return {
      mergedTheme,
      triggerRef,
      triggerInnerRef,
      tooltipRef,
      handleClick: handleClickRef,
      renderTrigger,
      getTooltipDisabled
    };
  },
  render() {
    var _a2;
    const { tooltip, renderTrigger, $slots } = this;
    if (tooltip) {
      const { mergedTheme } = this;
      return h$1(NTooltip, Object.assign({ ref: "tooltipRef", placement: "top" }, tooltip, { getDisabled: this.getTooltipDisabled, theme: mergedTheme.peers.Tooltip, themeOverrides: mergedTheme.peerOverrides.Tooltip }), {
        trigger: renderTrigger,
        default: (_a2 = $slots.tooltip) !== null && _a2 !== void 0 ? _a2 : $slots.default
      });
    } else
      return renderTrigger();
  }
});
var RenderSorter = defineComponent({
  name: "DataTableRenderSorter",
  props: {
    render: {
      type: Function,
      required: true
    },
    order: {
      type: [String, Boolean],
      default: false
    }
  },
  render() {
    const { render: render2, order } = this;
    return render2({
      order
    });
  }
});
const dataTableProps = Object.assign(Object.assign({}, useTheme.props), {
  onUnstableColumnResize: Function,
  pagination: {
    type: [Object, Boolean],
    default: false
  },
  paginateSinglePage: {
    type: Boolean,
    default: true
  },
  minHeight: [Number, String],
  maxHeight: [Number, String],
  columns: {
    type: Array,
    default: () => []
  },
  rowClassName: [String, Function],
  rowProps: Function,
  rowKey: Function,
  summary: [Function],
  data: {
    type: Array,
    default: () => []
  },
  loading: Boolean,
  bordered: {
    type: Boolean,
    default: void 0
  },
  bottomBordered: {
    type: Boolean,
    default: void 0
  },
  striped: Boolean,
  scrollX: [Number, String],
  defaultCheckedRowKeys: {
    type: Array,
    default: () => []
  },
  checkedRowKeys: Array,
  singleLine: {
    type: Boolean,
    default: true
  },
  singleColumn: Boolean,
  size: {
    type: String,
    default: "medium"
  },
  remote: Boolean,
  defaultExpandedRowKeys: {
    type: Array,
    default: []
  },
  defaultExpandAll: Boolean,
  expandedRowKeys: Array,
  stickyExpandedRows: Boolean,
  virtualScroll: Boolean,
  tableLayout: {
    type: String,
    default: "auto"
  },
  allowCheckingNotLoaded: Boolean,
  cascade: {
    type: Boolean,
    default: true
  },
  childrenKey: {
    type: String,
    default: "children"
  },
  indent: {
    type: Number,
    default: 16
  },
  flexHeight: Boolean,
  summaryPlacement: {
    type: String,
    default: "bottom"
  },
  paginationBehaviorOnFilter: {
    type: String,
    default: "current"
  },
  scrollbarProps: Object,
  renderCell: Function,
  renderExpandIcon: Function,
  spinProps: { type: Object, default: {} },
  onLoad: Function,
  "onUpdate:page": [Function, Array],
  onUpdatePage: [Function, Array],
  "onUpdate:pageSize": [Function, Array],
  onUpdatePageSize: [Function, Array],
  "onUpdate:sorter": [Function, Array],
  onUpdateSorter: [Function, Array],
  "onUpdate:filters": [Function, Array],
  onUpdateFilters: [Function, Array],
  "onUpdate:checkedRowKeys": [Function, Array],
  onUpdateCheckedRowKeys: [Function, Array],
  "onUpdate:expandedRowKeys": [Function, Array],
  onUpdateExpandedRowKeys: [Function, Array],
  onScroll: Function,
  onPageChange: [Function, Array],
  onPageSizeChange: [Function, Array],
  onSorterChange: [Function, Array],
  onFiltersChange: [Function, Array],
  onCheckedRowKeysChange: [Function, Array]
});
const dataTableInjectionKey = createInjectionKey("n-data-table");
var SortButton = defineComponent({
  name: "SortIcon",
  props: {
    column: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { mergedComponentPropsRef } = useConfig();
    const { mergedSortStateRef, mergedClsPrefixRef } = inject(dataTableInjectionKey);
    const sortStateRef = computed(() => mergedSortStateRef.value.find((state) => state.columnKey === props.column.key));
    const activeRef = computed(() => {
      return sortStateRef.value !== void 0;
    });
    const mergedSortOrderRef = computed(() => {
      const { value: sortState } = sortStateRef;
      if (sortState && activeRef.value) {
        return sortState.order;
      }
      return false;
    });
    const mergedRenderSorterRef = computed(() => {
      var _a2, _b2;
      return ((_b2 = (_a2 = mergedComponentPropsRef === null || mergedComponentPropsRef === void 0 ? void 0 : mergedComponentPropsRef.value) === null || _a2 === void 0 ? void 0 : _a2.DataTable) === null || _b2 === void 0 ? void 0 : _b2.renderSorter) || props.column.renderSorter;
    });
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      active: activeRef,
      mergedSortOrder: mergedSortOrderRef,
      mergedRenderSorter: mergedRenderSorterRef
    };
  },
  render() {
    const { mergedRenderSorter, mergedSortOrder, mergedClsPrefix } = this;
    const { renderSorterIcon } = this.column;
    return mergedRenderSorter ? h$1(RenderSorter, { render: mergedRenderSorter, order: mergedSortOrder }) : h$1("span", { class: [
      `${mergedClsPrefix}-data-table-sorter`,
      mergedSortOrder === "ascend" && `${mergedClsPrefix}-data-table-sorter--asc`,
      mergedSortOrder === "descend" && `${mergedClsPrefix}-data-table-sorter--desc`
    ] }, renderSorterIcon ? renderSorterIcon({ order: mergedSortOrder }) : h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, { default: () => h$1(ArrowDownIcon, null) }));
  }
});
var RenderFilter = defineComponent({
  name: "DataTableRenderFilter",
  props: {
    render: {
      type: Function,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  render() {
    const { render: render2, active, show } = this;
    return render2({
      active,
      show
    });
  }
});
const radioProps = {
  name: String,
  value: {
    type: [String, Number, Boolean],
    default: "on"
  },
  checked: {
    type: Boolean,
    default: void 0
  },
  defaultChecked: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  },
  label: String,
  size: String,
  onUpdateChecked: [Function, Array],
  "onUpdate:checked": [Function, Array],
  checkedValue: {
    type: Boolean,
    default: void 0
  }
};
const radioGroupInjectionKey = createInjectionKey("n-radio-group");
function setup(props) {
  const formItem = useFormItem(props, {
    mergedSize(NFormItem2) {
      const { size: size2 } = props;
      if (size2 !== void 0)
        return size2;
      if (NRadioGroup2) {
        const { mergedSizeRef: { value: mergedSize } } = NRadioGroup2;
        if (mergedSize !== void 0) {
          return mergedSize;
        }
      }
      if (NFormItem2) {
        return NFormItem2.mergedSize.value;
      }
      return "medium";
    },
    mergedDisabled(NFormItem2) {
      if (props.disabled)
        return true;
      if (NRadioGroup2 === null || NRadioGroup2 === void 0 ? void 0 : NRadioGroup2.disabledRef.value)
        return true;
      if (NFormItem2 === null || NFormItem2 === void 0 ? void 0 : NFormItem2.disabled.value)
        return true;
      return false;
    }
  });
  const { mergedSizeRef, mergedDisabledRef } = formItem;
  const inputRef = ref(null);
  const labelRef = ref(null);
  const NRadioGroup2 = inject(radioGroupInjectionKey, null);
  const uncontrolledCheckedRef = ref(props.defaultChecked);
  const controlledCheckedRef = toRef(props, "checked");
  const mergedCheckedRef = useMergedState(controlledCheckedRef, uncontrolledCheckedRef);
  const renderSafeCheckedRef = useMemo(() => {
    if (NRadioGroup2)
      return NRadioGroup2.valueRef.value === props.value;
    return mergedCheckedRef.value;
  });
  const mergedNameRef = useMemo(() => {
    const { name: name2 } = props;
    if (name2 !== void 0)
      return name2;
    if (NRadioGroup2)
      return NRadioGroup2.nameRef.value;
  });
  const focusRef = ref(false);
  function doUpdateChecked() {
    if (NRadioGroup2) {
      const { doUpdateValue } = NRadioGroup2;
      const { value: value2 } = props;
      call(doUpdateValue, value2);
    } else {
      const { onUpdateChecked, "onUpdate:checked": _onUpdateChecked } = props;
      const { nTriggerFormInput, nTriggerFormChange } = formItem;
      if (onUpdateChecked)
        call(onUpdateChecked, true);
      if (_onUpdateChecked)
        call(_onUpdateChecked, true);
      nTriggerFormInput();
      nTriggerFormChange();
      uncontrolledCheckedRef.value = true;
    }
  }
  function toggle() {
    if (mergedDisabledRef.value)
      return;
    if (!renderSafeCheckedRef.value) {
      doUpdateChecked();
    }
  }
  function handleRadioInputChange() {
    toggle();
  }
  function handleRadioInputBlur() {
    focusRef.value = false;
  }
  function handleRadioInputFocus() {
    focusRef.value = true;
  }
  return {
    mergedClsPrefix: NRadioGroup2 ? NRadioGroup2.mergedClsPrefixRef : useConfig(props).mergedClsPrefixRef,
    inputRef,
    labelRef,
    mergedName: mergedNameRef,
    mergedDisabled: mergedDisabledRef,
    uncontrolledChecked: uncontrolledCheckedRef,
    renderSafeChecked: renderSafeCheckedRef,
    focus: focusRef,
    mergedSize: mergedSizeRef,
    handleRadioInputChange,
    handleRadioInputBlur,
    handleRadioInputFocus
  };
}
var style$p = cB$1("radio", `
 line-height: var(--n-label-line-height);
 outline: none;
 position: relative;
 user-select: none;
 -webkit-user-select: none;
 display: inline-flex;
 align-items: flex-start;
 flex-wrap: nowrap;
 font-size: var(--n-font-size);
 word-break: break-word;
`, [cM("checked", [cE$1("dot", `
 background-color: var(--n-color-active);
 `)]), cE$1("dot-wrapper", `
 position: relative;
 flex-shrink: 0;
 flex-grow: 0;
 width: var(--n-radio-size);
 `), cB$1("radio-input", `
 position: absolute;
 border: 0;
 border-radius: inherit;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 opacity: 0;
 z-index: 1;
 cursor: pointer;
 `), cE$1("dot", `
 position: absolute;
 top: 50%;
 left: 0;
 transform: translateY(-50%);
 height: var(--n-radio-size);
 width: var(--n-radio-size);
 background: var(--n-color);
 box-shadow: var(--n-box-shadow);
 border-radius: 50%;
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 `, [c$2("&::before", `
 content: "";
 opacity: 0;
 position: absolute;
 left: 4px;
 top: 4px;
 height: calc(100% - 8px);
 width: calc(100% - 8px);
 border-radius: 50%;
 transform: scale(.8);
 background: var(--n-dot-color-active);
 transition: 
 opacity .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 transform .3s var(--n-bezier);
 `), cM("checked", {
  boxShadow: "var(--n-box-shadow-active)"
}, [c$2("&::before", `
 opacity: 1;
 transform: scale(1);
 `)])]), cE$1("label", `
 color: var(--n-text-color);
 padding: var(--n-label-padding);
 font-weight: var(--n-label-font-weight);
 display: inline-block;
 transition: color .3s var(--n-bezier);
 `), cNotM("disabled", `
 cursor: pointer;
 `, [c$2("&:hover", [cE$1("dot", {
  boxShadow: "var(--n-box-shadow-hover)"
})]), cM("focus", [c$2("&:not(:active)", [cE$1("dot", {
  boxShadow: "var(--n-box-shadow-focus)"
})])])]), cM("disabled", `
 cursor: not-allowed;
 `, [cE$1("dot", {
  boxShadow: "var(--n-box-shadow-disabled)",
  backgroundColor: "var(--n-color-disabled)"
}, [c$2("&::before", {
  backgroundColor: "var(--n-dot-color-disabled)"
}), cM("checked", `
 opacity: 1;
 `)]), cE$1("label", {
  color: "var(--n-text-color-disabled)"
}), cB$1("radio-input", `
 cursor: not-allowed;
 `)])]);
var NRadio = defineComponent({
  name: "Radio",
  props: Object.assign(Object.assign({}, useTheme.props), radioProps),
  setup(props) {
    const radio = setup(props);
    const themeRef = useTheme("Radio", "-radio", style$p, radioLight$1, props, radio.mergedClsPrefix);
    const cssVarsRef = computed(() => {
      const { mergedSize: { value: size2 } } = radio;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { boxShadow, boxShadowActive, boxShadowDisabled, boxShadowFocus, boxShadowHover, color, colorDisabled, colorActive, textColor, textColorDisabled, dotColorActive, dotColorDisabled, labelPadding, labelLineHeight, labelFontWeight, [createKey("fontSize", size2)]: fontSize2, [createKey("radioSize", size2)]: radioSize } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-label-line-height": labelLineHeight,
        "--n-label-font-weight": labelFontWeight,
        "--n-box-shadow": boxShadow,
        "--n-box-shadow-active": boxShadowActive,
        "--n-box-shadow-disabled": boxShadowDisabled,
        "--n-box-shadow-focus": boxShadowFocus,
        "--n-box-shadow-hover": boxShadowHover,
        "--n-color": color,
        "--n-color-active": colorActive,
        "--n-color-disabled": colorDisabled,
        "--n-dot-color-active": dotColorActive,
        "--n-dot-color-disabled": dotColorDisabled,
        "--n-font-size": fontSize2,
        "--n-radio-size": radioSize,
        "--n-text-color": textColor,
        "--n-text-color-disabled": textColorDisabled,
        "--n-label-padding": labelPadding
      };
    });
    const { inlineThemeDisabled, mergedClsPrefixRef, mergedRtlRef } = useConfig(props);
    const rtlEnabledRef = useRtl("Radio", mergedRtlRef, mergedClsPrefixRef);
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("radio", computed(() => radio.mergedSize.value[0]), cssVarsRef, props) : void 0;
    return Object.assign(radio, {
      rtlEnabled: rtlEnabledRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    });
  },
  render() {
    const { $slots, mergedClsPrefix, onRender, label } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("label", { class: [
      `${mergedClsPrefix}-radio`,
      this.themeClass,
      {
        [`${mergedClsPrefix}-radio--rtl`]: this.rtlEnabled,
        [`${mergedClsPrefix}-radio--disabled`]: this.mergedDisabled,
        [`${mergedClsPrefix}-radio--checked`]: this.renderSafeChecked,
        [`${mergedClsPrefix}-radio--focus`]: this.focus
      }
    ], style: this.cssVars }, h$1("input", { ref: "inputRef", type: "radio", class: `${mergedClsPrefix}-radio-input`, value: this.value, name: this.mergedName, checked: this.renderSafeChecked, disabled: this.mergedDisabled, onChange: this.handleRadioInputChange, onFocus: this.handleRadioInputFocus, onBlur: this.handleRadioInputBlur }), h$1("div", { class: `${mergedClsPrefix}-radio__dot-wrapper` }, "\xA0", h$1("div", { class: [
      `${mergedClsPrefix}-radio__dot`,
      this.renderSafeChecked && `${mergedClsPrefix}-radio__dot--checked`
    ] })), resolveWrappedSlot($slots.default, (children) => {
      if (!children && !label)
        return null;
      return h$1("div", { ref: "labelRef", class: `${mergedClsPrefix}-radio__label` }, children || label);
    }));
  }
});
var style$o = cB$1("radio-group", `
 display: inline-block;
 font-size: var(--n-font-size);
`, [cE$1("splitor", `
 display: inline-block;
 vertical-align: bottom;
 width: 1px;
 transition:
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 background: var(--n-button-border-color);
 `, [cM("checked", {
  backgroundColor: "var(--n-button-border-color-active)"
}), cM("disabled", {
  opacity: "var(--n-opacity-disabled)"
})]), cM("button-group", `
 white-space: nowrap;
 height: var(--n-height);
 line-height: var(--n-height);
 `, [cB$1("radio-button", {
  height: "var(--n-height)",
  lineHeight: "var(--n-height)"
}), cE$1("splitor", {
  height: "var(--n-height)"
})]), cB$1("radio-button", `
 vertical-align: bottom;
 outline: none;
 position: relative;
 user-select: none;
 -webkit-user-select: none;
 display: inline-block;
 box-sizing: border-box;
 padding-left: 14px;
 padding-right: 14px;
 white-space: nowrap;
 transition:
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 color: var(--n-button-text-color);
 border-top: 1px solid var(--n-button-border-color);
 border-bottom: 1px solid var(--n-button-border-color);
 `, [cB$1("radio-input", `
 pointer-events: none;
 position: absolute;
 border: 0;
 border-radius: inherit;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 opacity: 0;
 z-index: 1;
 `), cE$1("state-border", `
 z-index: 1;
 pointer-events: none;
 position: absolute;
 box-shadow: var(--n-button-box-shadow);
 transition: box-shadow .3s var(--n-bezier);
 left: -1px;
 bottom: -1px;
 right: -1px;
 top: -1px;
 `), c$2("&:first-child", `
 border-top-left-radius: var(--n-button-border-radius);
 border-bottom-left-radius: var(--n-button-border-radius);
 border-left: 1px solid var(--n-button-border-color);
 `, [cE$1("state-border", `
 border-top-left-radius: var(--n-button-border-radius);
 border-bottom-left-radius: var(--n-button-border-radius);
 `)]), c$2("&:last-child", `
 border-top-right-radius: var(--n-button-border-radius);
 border-bottom-right-radius: var(--n-button-border-radius);
 border-right: 1px solid var(--n-button-border-color);
 `, [cE$1("state-border", `
 border-top-right-radius: var(--n-button-border-radius);
 border-bottom-right-radius: var(--n-button-border-radius);
 `)]), cNotM("disabled", `
 cursor: pointer;
 `, [c$2("&:hover", [cE$1("state-border", `
 transition: box-shadow .3s var(--n-bezier);
 box-shadow: var(--n-button-box-shadow-hover);
 `), cNotM("checked", {
  color: "var(--n-button-text-color-hover)"
})]), cM("focus", [c$2("&:not(:active)", [cE$1("state-border", {
  boxShadow: "var(--n-button-box-shadow-focus)"
})])])]), cM("checked", `
 background: var(--n-button-color-active);
 color: var(--n-button-text-color-active);
 border-color: var(--n-button-border-color-active);
 `), cM("disabled", `
 cursor: not-allowed;
 opacity: var(--n-opacity-disabled);
 `)])]);
function mapSlot(defaultSlot, value2, clsPrefix) {
  var _a2;
  const children = [];
  let isButtonGroup = false;
  for (let i2 = 0; i2 < defaultSlot.length; ++i2) {
    const wrappedInstance = defaultSlot[i2];
    const name2 = (_a2 = wrappedInstance.type) === null || _a2 === void 0 ? void 0 : _a2.name;
    if (name2 === "RadioButton") {
      isButtonGroup = true;
    }
    const instanceProps = wrappedInstance.props;
    if (name2 !== "RadioButton") {
      children.push(wrappedInstance);
      continue;
    }
    if (i2 === 0) {
      children.push(wrappedInstance);
    } else {
      const lastInstanceProps = children[children.length - 1].props;
      const lastInstanceChecked = value2 === lastInstanceProps.value;
      const lastInstanceDisabled = lastInstanceProps.disabled;
      const currentInstanceChecked = value2 === instanceProps.value;
      const currentInstanceDisabled = instanceProps.disabled;
      const lastInstancePriority = (lastInstanceChecked ? 2 : 0) + (!lastInstanceDisabled ? 1 : 0);
      const currentInstancePriority = (currentInstanceChecked ? 2 : 0) + (!currentInstanceDisabled ? 1 : 0);
      const lastInstanceClass = {
        [`${clsPrefix}-radio-group__splitor--disabled`]: lastInstanceDisabled,
        [`${clsPrefix}-radio-group__splitor--checked`]: lastInstanceChecked
      };
      const currentInstanceClass = {
        [`${clsPrefix}-radio-group__splitor--disabled`]: currentInstanceDisabled,
        [`${clsPrefix}-radio-group__splitor--checked`]: currentInstanceChecked
      };
      const splitorClass = lastInstancePriority < currentInstancePriority ? currentInstanceClass : lastInstanceClass;
      children.push(h$1("div", { class: [`${clsPrefix}-radio-group__splitor`, splitorClass] }), wrappedInstance);
    }
  }
  return {
    children,
    isButtonGroup
  };
}
const radioGroupProps = Object.assign(Object.assign({}, useTheme.props), { name: String, value: [String, Number, Boolean], defaultValue: {
  type: [String, Number, Boolean],
  default: null
}, size: String, disabled: {
  type: Boolean,
  default: void 0
}, "onUpdate:value": [Function, Array], onUpdateValue: [Function, Array] });
var NRadioGroup = defineComponent({
  name: "RadioGroup",
  props: radioGroupProps,
  setup(props) {
    const selfElRef = ref(null);
    const { mergedSizeRef, mergedDisabledRef, nTriggerFormChange, nTriggerFormInput, nTriggerFormBlur, nTriggerFormFocus } = useFormItem(props);
    const { mergedClsPrefixRef, inlineThemeDisabled, mergedRtlRef } = useConfig(props);
    const themeRef = useTheme("Radio", "-radio-group", style$o, radioLight$1, props, mergedClsPrefixRef);
    const uncontrolledValueRef = ref(props.defaultValue);
    const controlledValueRef = toRef(props, "value");
    const mergedValueRef = useMergedState(controlledValueRef, uncontrolledValueRef);
    function doUpdateValue(value2) {
      const { onUpdateValue, "onUpdate:value": _onUpdateValue } = props;
      if (onUpdateValue) {
        call(onUpdateValue, value2);
      }
      if (_onUpdateValue) {
        call(_onUpdateValue, value2);
      }
      uncontrolledValueRef.value = value2;
      nTriggerFormChange();
      nTriggerFormInput();
    }
    function handleFocusin(e25) {
      const { value: selfEl } = selfElRef;
      if (!selfEl)
        return;
      if (selfEl.contains(e25.relatedTarget))
        return;
      nTriggerFormFocus();
    }
    function handleFocusout(e25) {
      const { value: selfEl } = selfElRef;
      if (!selfEl)
        return;
      if (selfEl.contains(e25.relatedTarget))
        return;
      nTriggerFormBlur();
    }
    provide(radioGroupInjectionKey, {
      mergedClsPrefixRef,
      nameRef: toRef(props, "name"),
      valueRef: mergedValueRef,
      disabledRef: mergedDisabledRef,
      mergedSizeRef,
      doUpdateValue
    });
    const rtlEnabledRef = useRtl("Radio", mergedRtlRef, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { value: size2 } = mergedSizeRef;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { buttonBorderColor, buttonBorderColorActive, buttonBorderRadius, buttonBoxShadow, buttonBoxShadowFocus, buttonBoxShadowHover, buttonColorActive, buttonTextColor, buttonTextColorActive, buttonTextColorHover, opacityDisabled, [createKey("buttonHeight", size2)]: height, [createKey("fontSize", size2)]: fontSize2 } } = themeRef.value;
      return {
        "--n-font-size": fontSize2,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-button-border-color": buttonBorderColor,
        "--n-button-border-color-active": buttonBorderColorActive,
        "--n-button-border-radius": buttonBorderRadius,
        "--n-button-box-shadow": buttonBoxShadow,
        "--n-button-box-shadow-focus": buttonBoxShadowFocus,
        "--n-button-box-shadow-hover": buttonBoxShadowHover,
        "--n-button-color-active": buttonColorActive,
        "--n-button-text-color": buttonTextColor,
        "--n-button-text-color-hover": buttonTextColorHover,
        "--n-button-text-color-active": buttonTextColorActive,
        "--n-height": height,
        "--n-opacity-disabled": opacityDisabled
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("radio-group", computed(() => mergedSizeRef.value[0]), cssVarsRef, props) : void 0;
    return {
      selfElRef,
      rtlEnabled: rtlEnabledRef,
      mergedClsPrefix: mergedClsPrefixRef,
      mergedValue: mergedValueRef,
      handleFocusout,
      handleFocusin,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    var _a2;
    const { mergedValue, mergedClsPrefix, handleFocusin, handleFocusout } = this;
    const { children, isButtonGroup } = mapSlot(flatten$4(getSlot$1(this)), mergedValue, mergedClsPrefix);
    (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
    return h$1("div", { onFocusin: handleFocusin, onFocusout: handleFocusout, ref: "selfElRef", class: [
      `${mergedClsPrefix}-radio-group`,
      this.rtlEnabled && `${mergedClsPrefix}-radio-group--rtl`,
      this.themeClass,
      isButtonGroup && `${mergedClsPrefix}-radio-group--button-group`
    ], style: this.cssVars }, children);
  }
});
var NRadioButton = defineComponent({
  name: "RadioButton",
  props: radioProps,
  setup,
  render() {
    const { mergedClsPrefix } = this;
    return h$1("label", { class: [
      `${mergedClsPrefix}-radio-button`,
      this.mergedDisabled && `${mergedClsPrefix}-radio-button--disabled`,
      this.renderSafeChecked && `${mergedClsPrefix}-radio-button--checked`,
      this.focus && [`${mergedClsPrefix}-radio-button--focus`]
    ] }, h$1("input", { ref: "inputRef", type: "radio", class: `${mergedClsPrefix}-radio-input`, value: this.value, name: this.mergedName, checked: this.renderSafeChecked, disabled: this.mergedDisabled, onChange: this.handleRadioInputChange, onFocus: this.handleRadioInputFocus, onBlur: this.handleRadioInputBlur }), h$1("div", { class: `${mergedClsPrefix}-radio-button__state-border` }), resolveWrappedSlot(this.$slots.default, (children) => {
      if (!children && !this.label)
        return null;
      return h$1("div", { ref: "labelRef", class: `${mergedClsPrefix}-radio__label` }, children || this.label);
    }));
  }
});
const SELECTION_COL_WIDTH = 40;
const EXPAND_COL_WIDTH = 40;
function getNumberColWidth(col) {
  if (col.type === "selection") {
    return col.width === void 0 ? SELECTION_COL_WIDTH : depx(col.width);
  }
  if (col.type === "expand") {
    return col.width === void 0 ? EXPAND_COL_WIDTH : depx(col.width);
  }
  if ("children" in col)
    return void 0;
  if (typeof col.width === "string") {
    return depx(col.width);
  }
  return col.width;
}
function getStringColWidth(col) {
  var _a2, _b2;
  if (col.type === "selection") {
    return formatLength((_a2 = col.width) !== null && _a2 !== void 0 ? _a2 : SELECTION_COL_WIDTH);
  }
  if (col.type === "expand") {
    return formatLength((_b2 = col.width) !== null && _b2 !== void 0 ? _b2 : EXPAND_COL_WIDTH);
  }
  if ("children" in col) {
    return void 0;
  }
  return formatLength(col.width);
}
function getColKey(col) {
  if (col.type === "selection")
    return "__n_selection__";
  if (col.type === "expand")
    return "__n_expand__";
  return col.key;
}
function createShallowClonedObject(object4) {
  if (!object4)
    return object4;
  if (typeof object4 === "object") {
    return Object.assign({}, object4);
  }
  return object4;
}
function getFlagOfOrder(order) {
  if (order === "ascend")
    return 1;
  else if (order === "descend")
    return -1;
  return 0;
}
function clampValueFollowCSSRules(value2, min, max) {
  if (max !== void 0) {
    value2 = Math.min(value2, typeof max === "number" ? max : parseFloat(max));
  }
  if (min !== void 0) {
    value2 = Math.max(value2, typeof min === "number" ? min : parseFloat(min));
  }
  return value2;
}
function createCustomWidthStyle(column, resizedWidth) {
  if (resizedWidth !== void 0) {
    return {
      width: resizedWidth,
      minWidth: resizedWidth,
      maxWidth: resizedWidth
    };
  }
  const width = getStringColWidth(column);
  const { minWidth, maxWidth } = column;
  return {
    width,
    minWidth: formatLength(minWidth) || width,
    maxWidth: formatLength(maxWidth)
  };
}
function createRowClassName(row, index2, rowClassName) {
  if (typeof rowClassName === "function")
    return rowClassName(row, index2);
  return rowClassName || "";
}
function shouldUseArrayInSingleMode(column) {
  return column.filterOptionValues !== void 0 || column.filterOptionValue === void 0 && column.defaultFilterOptionValues !== void 0;
}
function isColumnSortable(column) {
  if ("children" in column)
    return false;
  return !!column.sorter;
}
function isColumnResizable(column) {
  if ("children" in column && !!column.children.length)
    return false;
  return !!column.resizable;
}
function isColumnFilterable(column) {
  if ("children" in column)
    return false;
  return !!column.filter && (!!column.filterOptions || !!column.renderFilterMenu);
}
function getNextOrderOf(order) {
  if (!order)
    return "descend";
  else if (order === "descend")
    return "ascend";
  return false;
}
function createNextSorter(column, currentSortState) {
  if (column.sorter === void 0)
    return null;
  if (currentSortState === null || currentSortState.columnKey !== column.key) {
    return {
      columnKey: column.key,
      sorter: column.sorter,
      order: getNextOrderOf(false)
    };
  } else {
    return Object.assign(Object.assign({}, currentSortState), { order: getNextOrderOf(currentSortState.order) });
  }
}
function isColumnSorting(column, mergedSortState) {
  return mergedSortState.find((state) => state.columnKey === column.key && state.order) !== void 0;
}
var NDataTableFilterMenu = defineComponent({
  name: "DataTableFilterMenu",
  props: {
    column: {
      type: Object,
      required: true
    },
    radioGroupName: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      required: true
    },
    value: {
      type: [Array, String, Number],
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    onConfirm: {
      type: Function,
      required: true
    },
    onClear: {
      type: Function,
      required: true
    },
    onChange: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const {
      mergedClsPrefixRef,
      mergedThemeRef,
      localeRef
    } = inject(dataTableInjectionKey);
    const temporalValueRef = ref(props.value);
    const checkboxGroupValueRef = computed(() => {
      const { value: temporalValue } = temporalValueRef;
      if (!Array.isArray(temporalValue))
        return null;
      return temporalValue;
    });
    const radioGroupValueRef = computed(() => {
      const { value: temporalValue } = temporalValueRef;
      if (shouldUseArrayInSingleMode(props.column)) {
        return Array.isArray(temporalValue) && temporalValue.length && temporalValue[0] || null;
      }
      if (!Array.isArray(temporalValue))
        return temporalValue;
      return null;
    });
    function doChange(value2) {
      props.onChange(value2);
    }
    function handleChange(value2) {
      if (props.multiple && Array.isArray(value2)) {
        temporalValueRef.value = value2;
      } else if (shouldUseArrayInSingleMode(props.column) && !Array.isArray(value2)) {
        temporalValueRef.value = [value2];
      } else {
        temporalValueRef.value = value2;
      }
    }
    function handleConfirmClick() {
      doChange(temporalValueRef.value);
      props.onConfirm();
    }
    function handleClearClick() {
      if (props.multiple || shouldUseArrayInSingleMode(props.column)) {
        doChange([]);
      } else {
        doChange(null);
      }
      props.onClear();
    }
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      mergedTheme: mergedThemeRef,
      locale: localeRef,
      checkboxGroupValue: checkboxGroupValueRef,
      radioGroupValue: radioGroupValueRef,
      handleChange,
      handleConfirmClick,
      handleClearClick
    };
  },
  render() {
    const { mergedTheme, locale: locale2, mergedClsPrefix } = this;
    return h$1("div", { class: `${mergedClsPrefix}-data-table-filter-menu` }, h$1(NScrollbar, null, {
      default: () => {
        const { checkboxGroupValue, handleChange } = this;
        return this.multiple ? h$1(NCheckboxGroup, { value: checkboxGroupValue, class: `${mergedClsPrefix}-data-table-filter-menu__group`, onUpdateValue: handleChange }, {
          default: () => this.options.map((option) => {
            return h$1(NCheckbox, { key: option.value, theme: mergedTheme.peers.Checkbox, themeOverrides: mergedTheme.peerOverrides.Checkbox, value: option.value }, { default: () => option.label });
          })
        }) : h$1(NRadioGroup, { name: this.radioGroupName, class: `${mergedClsPrefix}-data-table-filter-menu__group`, value: this.radioGroupValue, onUpdateValue: this.handleChange }, {
          default: () => this.options.map((option) => h$1(NRadio, { key: option.value, value: option.value, theme: mergedTheme.peers.Radio, themeOverrides: mergedTheme.peerOverrides.Radio }, { default: () => option.label }))
        });
      }
    }), h$1("div", { class: `${mergedClsPrefix}-data-table-filter-menu__action` }, h$1(NButton, { size: "tiny", theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, onClick: this.handleClearClick }, { default: () => locale2.clear }), h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, type: "primary", size: "tiny", onClick: this.handleConfirmClick }, { default: () => locale2.confirm })));
  }
});
function createFilterState(currentFilterState, columnKey, mergedFilterValue) {
  const nextFilterState = Object.assign({}, currentFilterState);
  nextFilterState[columnKey] = mergedFilterValue;
  return nextFilterState;
}
var FilterButton = defineComponent({
  name: "DataTableFilterButton",
  props: {
    column: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const { mergedComponentPropsRef } = useConfig();
    const {
      mergedThemeRef,
      mergedClsPrefixRef,
      mergedFilterStateRef,
      filterMenuCssVarsRef,
      paginationBehaviorOnFilterRef,
      doUpdatePage,
      doUpdateFilters
    } = inject(dataTableInjectionKey);
    const showPopoverRef = ref(false);
    const filterStateRef = mergedFilterStateRef;
    const filterMultipleRef = computed(() => {
      return props.column.filterMultiple !== false;
    });
    const mergedFilterValueRef = computed(() => {
      const filterValue = filterStateRef.value[props.column.key];
      if (filterValue === void 0) {
        const { value: multiple } = filterMultipleRef;
        if (multiple)
          return [];
        else
          return null;
      }
      return filterValue;
    });
    const activeRef = computed(() => {
      const { value: filterValue } = mergedFilterValueRef;
      if (Array.isArray(filterValue)) {
        return filterValue.length > 0;
      }
      return filterValue !== null;
    });
    const mergedRenderFilterRef = computed(() => {
      var _a2, _b2;
      return ((_b2 = (_a2 = mergedComponentPropsRef === null || mergedComponentPropsRef === void 0 ? void 0 : mergedComponentPropsRef.value) === null || _a2 === void 0 ? void 0 : _a2.DataTable) === null || _b2 === void 0 ? void 0 : _b2.renderFilter) || props.column.renderFilter;
    });
    function handleFilterChange(mergedFilterValue) {
      const nextFilterState = createFilterState(filterStateRef.value, props.column.key, mergedFilterValue);
      doUpdateFilters(nextFilterState, props.column);
      if (paginationBehaviorOnFilterRef.value === "first") {
        doUpdatePage(1);
      }
    }
    function handleFilterMenuCancel() {
      showPopoverRef.value = false;
    }
    function handleFilterMenuConfirm() {
      showPopoverRef.value = false;
    }
    return {
      mergedTheme: mergedThemeRef,
      mergedClsPrefix: mergedClsPrefixRef,
      active: activeRef,
      showPopover: showPopoverRef,
      mergedRenderFilter: mergedRenderFilterRef,
      filterMultiple: filterMultipleRef,
      mergedFilterValue: mergedFilterValueRef,
      filterMenuCssVars: filterMenuCssVarsRef,
      handleFilterChange,
      handleFilterMenuConfirm,
      handleFilterMenuCancel
    };
  },
  render() {
    const { mergedTheme, mergedClsPrefix, handleFilterMenuCancel } = this;
    return h$1(NPopover, { show: this.showPopover, onUpdateShow: (v2) => this.showPopover = v2, trigger: "click", theme: mergedTheme.peers.Popover, themeOverrides: mergedTheme.peerOverrides.Popover, placement: "bottom", style: { padding: 0 } }, {
      trigger: () => {
        const { mergedRenderFilter } = this;
        if (mergedRenderFilter) {
          return h$1(RenderFilter, { "data-data-table-filter": true, render: mergedRenderFilter, active: this.active, show: this.showPopover });
        }
        const { renderFilterIcon } = this.column;
        return h$1("div", { "data-data-table-filter": true, class: [
          `${mergedClsPrefix}-data-table-filter`,
          {
            [`${mergedClsPrefix}-data-table-filter--active`]: this.active,
            [`${mergedClsPrefix}-data-table-filter--show`]: this.showPopover
          }
        ] }, renderFilterIcon ? renderFilterIcon({
          active: this.active,
          show: this.showPopover
        }) : h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, { default: () => h$1(FilterIcon, null) }));
      },
      default: () => {
        const { renderFilterMenu } = this.column;
        return renderFilterMenu ? renderFilterMenu({ hide: handleFilterMenuCancel }) : h$1(NDataTableFilterMenu, { style: this.filterMenuCssVars, radioGroupName: String(this.column.key), multiple: this.filterMultiple, value: this.mergedFilterValue, options: this.options, column: this.column, onChange: this.handleFilterChange, onClear: this.handleFilterMenuCancel, onConfirm: this.handleFilterMenuConfirm });
      }
    });
  }
});
var ResizeButton = defineComponent({
  name: "ColumnResizeButton",
  props: {
    onResizeStart: Function,
    onResize: Function,
    onResizeEnd: Function
  },
  setup(props) {
    const { mergedClsPrefixRef } = inject(dataTableInjectionKey);
    const activeRef = ref(false);
    let startX = 0;
    function getMouseX(e25) {
      return e25.clientX;
    }
    function handleMousedown(e25) {
      var _a2;
      const alreadyStarted = activeRef.value;
      startX = getMouseX(e25);
      activeRef.value = true;
      if (!alreadyStarted) {
        on$1("mousemove", window, handleMousemove);
        on$1("mouseup", window, handleMouseup);
        (_a2 = props.onResizeStart) === null || _a2 === void 0 ? void 0 : _a2.call(props);
      }
    }
    function handleMousemove(e25) {
      var _a2;
      (_a2 = props.onResize) === null || _a2 === void 0 ? void 0 : _a2.call(props, getMouseX(e25) - startX);
    }
    function handleMouseup() {
      var _a2;
      activeRef.value = false;
      (_a2 = props.onResizeEnd) === null || _a2 === void 0 ? void 0 : _a2.call(props);
      off("mousemove", window, handleMousemove);
      off("mouseup", window, handleMouseup);
    }
    onBeforeUnmount(() => {
      off("mousemove", window, handleMousemove);
      off("mouseup", window, handleMouseup);
    });
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      active: activeRef,
      handleMousedown
    };
  },
  render() {
    const { mergedClsPrefix } = this;
    return h$1("span", { "data-data-table-resizable": true, class: [
      `${mergedClsPrefix}-data-table-resize-button`,
      this.active && `${mergedClsPrefix}-data-table-resize-button--active`
    ], onMousedown: this.handleMousedown });
  }
});
var NDropdownDivider = defineComponent({
  name: "DropdownDivider",
  props: {
    clsPrefix: {
      type: String,
      required: true
    }
  },
  render() {
    return h$1("div", { class: `${this.clsPrefix}-dropdown-divider` });
  }
});
const self$l = (vars) => {
  const { textColorBase, opacity1, opacity2, opacity3, opacity4, opacity5 } = vars;
  return {
    color: textColorBase,
    opacity1Depth: opacity1,
    opacity2Depth: opacity2,
    opacity3Depth: opacity3,
    opacity4Depth: opacity4,
    opacity5Depth: opacity5
  };
};
const iconLight = {
  name: "Icon",
  common: commonLight,
  self: self$l
};
var iconLight$1 = iconLight;
var style$n = cB$1("icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
 transform: translateZ(0);
`, [cM("color-transition", {
  transition: "color .3s var(--n-bezier)"
}), cM("depth", {
  color: "var(--n-color)"
}, [c$2("svg", {
  opacity: "var(--n-opacity)",
  transition: "opacity .3s var(--n-bezier)"
})]), c$2("svg", {
  height: "1em",
  width: "1em"
})]);
const iconProps = Object.assign(Object.assign({}, useTheme.props), { depth: [String, Number], size: [Number, String], color: String, component: Object });
const NIcon = defineComponent({
  _n_icon__: true,
  name: "Icon",
  inheritAttrs: false,
  props: iconProps,
  setup(props) {
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Icon", "-icon", style$n, iconLight$1, props, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { depth } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: self2 } = themeRef.value;
      if (depth !== void 0) {
        const { color, [`opacity${depth}Depth`]: opacity } = self2;
        return {
          "--n-bezier": cubicBezierEaseInOut2,
          "--n-color": color,
          "--n-opacity": opacity
        };
      }
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-color": "",
        "--n-opacity": ""
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("icon", computed(() => `${props.depth || "d"}`), cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      mergedStyle: computed(() => {
        const { size: size2, color } = props;
        return {
          fontSize: formatLength(size2),
          color
        };
      }),
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    var _a2;
    const { $parent, depth, mergedClsPrefix, component, onRender, themeClass } = this;
    if ((_a2 = $parent === null || $parent === void 0 ? void 0 : $parent.$options) === null || _a2 === void 0 ? void 0 : _a2._n_icon__) {
      warn$2("icon", "don't wrap `n-icon` inside `n-icon`");
    }
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("i", mergeProps(this.$attrs, {
      role: "img",
      class: [
        `${mergedClsPrefix}-icon`,
        themeClass,
        {
          [`${mergedClsPrefix}-icon--depth`]: depth,
          [`${mergedClsPrefix}-icon--color-transition`]: depth !== void 0
        }
      ],
      style: [this.cssVars, this.mergedStyle]
    }), component ? h$1(component) : this.$slots);
  }
});
const dropdownMenuInjectionKey = createInjectionKey("n-dropdown-menu");
const dropdownInjectionKey = createInjectionKey("n-dropdown");
const dropdownOptionInjectionKey = createInjectionKey("n-dropdown-option");
function isSubmenuNode(rawNode, childrenField) {
  return rawNode.type === "submenu" || rawNode.type === void 0 && rawNode[childrenField] !== void 0;
}
function isGroupNode(rawNode) {
  return rawNode.type === "group";
}
function isDividerNode$1(rawNode) {
  return rawNode.type === "divider";
}
function isRenderNode(rawNode) {
  return rawNode.type === "render";
}
var NDropdownOption = defineComponent({
  name: "DropdownOption",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    tmNode: {
      type: Object,
      required: true
    },
    parentKey: {
      type: [String, Number],
      default: null
    },
    placement: {
      type: String,
      default: "right-start"
    },
    props: Object,
    scrollable: Boolean
  },
  setup(props) {
    const NDropdown2 = inject(dropdownInjectionKey);
    const { hoverKeyRef, keyboardKeyRef, lastToggledSubmenuKeyRef, pendingKeyPathRef, activeKeyPathRef, animatedRef, mergedShowRef, renderLabelRef, renderIconRef, labelFieldRef, childrenFieldRef, renderOptionRef, nodePropsRef, menuPropsRef } = NDropdown2;
    const NDropdownOption2 = inject(dropdownOptionInjectionKey, null);
    const NDropdownMenu2 = inject(dropdownMenuInjectionKey);
    const NPopoverBody2 = inject(popoverBodyInjectionKey);
    const rawNodeRef = computed(() => props.tmNode.rawNode);
    const hasSubmenuRef = computed(() => {
      const { value: childrenField } = childrenFieldRef;
      return isSubmenuNode(props.tmNode.rawNode, childrenField);
    });
    const mergedDisabledRef = computed(() => {
      const { disabled } = props.tmNode;
      return disabled;
    });
    const showSubmenuRef = computed(() => {
      if (!hasSubmenuRef.value)
        return false;
      const { key, disabled } = props.tmNode;
      if (disabled)
        return false;
      const { value: hoverKey } = hoverKeyRef;
      const { value: keyboardKey } = keyboardKeyRef;
      const { value: lastToggledSubmenuKey } = lastToggledSubmenuKeyRef;
      const { value: pendingKeyPath } = pendingKeyPathRef;
      if (hoverKey !== null)
        return pendingKeyPath.includes(key);
      if (keyboardKey !== null) {
        return pendingKeyPath.includes(key) && pendingKeyPath[pendingKeyPath.length - 1] !== key;
      }
      if (lastToggledSubmenuKey !== null)
        return pendingKeyPath.includes(key);
      return false;
    });
    const shouldDelayRef = computed(() => {
      return keyboardKeyRef.value === null && !animatedRef.value;
    });
    const deferredShowSubmenuRef = useDeferredTrue(showSubmenuRef, 300, shouldDelayRef);
    const parentEnteringSubmenuRef = computed(() => {
      return !!(NDropdownOption2 === null || NDropdownOption2 === void 0 ? void 0 : NDropdownOption2.enteringSubmenuRef.value);
    });
    const enteringSubmenuRef = ref(false);
    provide(dropdownOptionInjectionKey, {
      enteringSubmenuRef
    });
    function handleSubmenuBeforeEnter() {
      enteringSubmenuRef.value = true;
    }
    function handleSubmenuAfterEnter() {
      enteringSubmenuRef.value = false;
    }
    function handleMouseEnter() {
      const { parentKey, tmNode } = props;
      if (tmNode.disabled)
        return;
      if (!mergedShowRef.value)
        return;
      lastToggledSubmenuKeyRef.value = parentKey;
      keyboardKeyRef.value = null;
      hoverKeyRef.value = tmNode.key;
    }
    function handleMouseMove() {
      const { tmNode } = props;
      if (tmNode.disabled)
        return;
      if (!mergedShowRef.value)
        return;
      if (hoverKeyRef.value === tmNode.key)
        return;
      handleMouseEnter();
    }
    function handleMouseLeave(e25) {
      if (props.tmNode.disabled)
        return;
      if (!mergedShowRef.value)
        return;
      const { relatedTarget } = e25;
      if (relatedTarget && !happensIn({ target: relatedTarget }, "dropdownOption") && !happensIn({ target: relatedTarget }, "scrollbarRail")) {
        hoverKeyRef.value = null;
      }
    }
    function handleClick2() {
      const { value: hasSubmenu } = hasSubmenuRef;
      const { tmNode } = props;
      if (!mergedShowRef.value)
        return;
      if (!hasSubmenu && !tmNode.disabled) {
        NDropdown2.doSelect(tmNode.key, tmNode.rawNode);
        NDropdown2.doUpdateShow(false);
      }
    }
    return {
      labelField: labelFieldRef,
      renderLabel: renderLabelRef,
      renderIcon: renderIconRef,
      siblingHasIcon: NDropdownMenu2.showIconRef,
      siblingHasSubmenu: NDropdownMenu2.hasSubmenuRef,
      menuProps: menuPropsRef,
      popoverBody: NPopoverBody2,
      animated: animatedRef,
      mergedShowSubmenu: computed(() => {
        return deferredShowSubmenuRef.value && !parentEnteringSubmenuRef.value;
      }),
      rawNode: rawNodeRef,
      hasSubmenu: hasSubmenuRef,
      pending: useMemo(() => {
        const { value: pendingKeyPath } = pendingKeyPathRef;
        const { key } = props.tmNode;
        return pendingKeyPath.includes(key);
      }),
      childActive: useMemo(() => {
        const { value: activeKeyPath } = activeKeyPathRef;
        const { key } = props.tmNode;
        const index2 = activeKeyPath.findIndex((k2) => key === k2);
        if (index2 === -1)
          return false;
        return index2 < activeKeyPath.length - 1;
      }),
      active: useMemo(() => {
        const { value: activeKeyPath } = activeKeyPathRef;
        const { key } = props.tmNode;
        const index2 = activeKeyPath.findIndex((k2) => key === k2);
        if (index2 === -1)
          return false;
        return index2 === activeKeyPath.length - 1;
      }),
      mergedDisabled: mergedDisabledRef,
      renderOption: renderOptionRef,
      nodeProps: nodePropsRef,
      handleClick: handleClick2,
      handleMouseMove,
      handleMouseEnter,
      handleMouseLeave,
      handleSubmenuBeforeEnter,
      handleSubmenuAfterEnter
    };
  },
  render() {
    var _a2, _b2;
    const { animated, rawNode, mergedShowSubmenu, clsPrefix, siblingHasIcon, siblingHasSubmenu, renderLabel, renderIcon: renderIcon2, renderOption, nodeProps, props, scrollable } = this;
    let submenuVNode = null;
    if (mergedShowSubmenu) {
      const submenuNodeProps = (_a2 = this.menuProps) === null || _a2 === void 0 ? void 0 : _a2.call(this, rawNode, rawNode.children);
      submenuVNode = h$1(NDropdownMenu, Object.assign({}, submenuNodeProps, { clsPrefix, scrollable: this.scrollable, tmNodes: this.tmNode.children, parentKey: this.tmNode.key }));
    }
    const builtinProps = {
      class: [
        `${clsPrefix}-dropdown-option-body`,
        this.pending && `${clsPrefix}-dropdown-option-body--pending`,
        this.active && `${clsPrefix}-dropdown-option-body--active`,
        this.childActive && `${clsPrefix}-dropdown-option-body--child-active`,
        this.mergedDisabled && `${clsPrefix}-dropdown-option-body--disabled`
      ],
      onMousemove: this.handleMouseMove,
      onMouseenter: this.handleMouseEnter,
      onMouseleave: this.handleMouseLeave,
      onClick: this.handleClick
    };
    const optionNodeProps = nodeProps === null || nodeProps === void 0 ? void 0 : nodeProps(rawNode);
    const node2 = h$1("div", Object.assign({ class: [`${clsPrefix}-dropdown-option`, optionNodeProps === null || optionNodeProps === void 0 ? void 0 : optionNodeProps.class], "data-dropdown-option": true }, optionNodeProps), h$1("div", mergeProps(builtinProps, props), [
      h$1("div", { class: [
        `${clsPrefix}-dropdown-option-body__prefix`,
        siblingHasIcon && `${clsPrefix}-dropdown-option-body__prefix--show-icon`
      ] }, [renderIcon2 ? renderIcon2(rawNode) : render$3U(rawNode.icon)]),
      h$1("div", { "data-dropdown-option": true, class: `${clsPrefix}-dropdown-option-body__label` }, renderLabel ? renderLabel(rawNode) : render$3U((_b2 = rawNode[this.labelField]) !== null && _b2 !== void 0 ? _b2 : rawNode.title)),
      h$1("div", { "data-dropdown-option": true, class: [
        `${clsPrefix}-dropdown-option-body__suffix`,
        siblingHasSubmenu && `${clsPrefix}-dropdown-option-body__suffix--has-submenu`
      ] }, this.hasSubmenu ? h$1(NIcon, null, {
        default: () => h$1(ChevronRightIcon, null)
      }) : null)
    ]), this.hasSubmenu ? h$1(VBinder, null, {
      default: () => [
        h$1(VTarget, null, {
          default: () => h$1("div", { class: `${clsPrefix}-dropdown-offset-container` }, h$1(VFollower, { show: this.mergedShowSubmenu, placement: this.placement, to: scrollable ? this.popoverBody || void 0 : void 0, teleportDisabled: !scrollable }, {
            default: () => {
              return h$1("div", { class: `${clsPrefix}-dropdown-menu-wrapper` }, animated ? h$1(Transition, { onBeforeEnter: this.handleSubmenuBeforeEnter, onAfterEnter: this.handleSubmenuAfterEnter, name: "fade-in-scale-up-transition", appear: true }, {
                default: () => submenuVNode
              }) : submenuVNode);
            }
          }))
        })
      ]
    }) : null);
    if (renderOption) {
      return renderOption({ node: node2, option: rawNode });
    }
    return node2;
  }
});
var NDropdownGroupHeader = defineComponent({
  name: "DropdownGroupHeader",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    tmNode: {
      type: Object,
      required: true
    }
  },
  setup() {
    const {
      showIconRef,
      hasSubmenuRef
    } = inject(dropdownMenuInjectionKey);
    const { renderLabelRef, labelFieldRef, nodePropsRef, renderOptionRef } = inject(dropdownInjectionKey);
    return {
      labelField: labelFieldRef,
      showIcon: showIconRef,
      hasSubmenu: hasSubmenuRef,
      renderLabel: renderLabelRef,
      nodeProps: nodePropsRef,
      renderOption: renderOptionRef
    };
  },
  render() {
    var _a2;
    const { clsPrefix, hasSubmenu, showIcon, nodeProps, renderLabel, renderOption } = this;
    const { rawNode } = this.tmNode;
    const node2 = h$1("div", Object.assign({ class: `${clsPrefix}-dropdown-option` }, nodeProps === null || nodeProps === void 0 ? void 0 : nodeProps(rawNode)), h$1("div", { class: `${clsPrefix}-dropdown-option-body ${clsPrefix}-dropdown-option-body--group` }, h$1("div", { "data-dropdown-option": true, class: [
      `${clsPrefix}-dropdown-option-body__prefix`,
      showIcon && `${clsPrefix}-dropdown-option-body__prefix--show-icon`
    ] }, render$3U(rawNode.icon)), h$1("div", { class: `${clsPrefix}-dropdown-option-body__label`, "data-dropdown-option": true }, renderLabel ? renderLabel(rawNode) : render$3U((_a2 = rawNode.title) !== null && _a2 !== void 0 ? _a2 : rawNode[this.labelField])), h$1("div", { class: [
      `${clsPrefix}-dropdown-option-body__suffix`,
      hasSubmenu && `${clsPrefix}-dropdown-option-body__suffix--has-submenu`
    ], "data-dropdown-option": true })));
    if (renderOption) {
      return renderOption({ node: node2, option: rawNode });
    }
    return node2;
  }
});
var NDropdownGroup = defineComponent({
  name: "NDropdownGroup",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    tmNode: {
      type: Object,
      required: true
    },
    parentKey: {
      type: [String, Number],
      default: null
    }
  },
  render() {
    const { tmNode, parentKey, clsPrefix } = this;
    const { children } = tmNode;
    return h$1(Fragment, null, h$1(NDropdownGroupHeader, { clsPrefix, tmNode, key: tmNode.key }), children === null || children === void 0 ? void 0 : children.map((child) => {
      const { rawNode } = child;
      if (rawNode.show === false)
        return null;
      if (isDividerNode$1(rawNode)) {
        return h$1(NDropdownDivider, {
          clsPrefix,
          key: child.key
        });
      }
      if (child.isGroup) {
        warn$2("dropdown", "`group` node is not allowed to be put in `group` node.");
        return null;
      }
      return h$1(NDropdownOption, { clsPrefix, tmNode: child, parentKey, key: child.key });
    }));
  }
});
var NDropdownRenderOption = defineComponent({
  name: "DropdownRenderOption",
  props: {
    tmNode: {
      type: Object,
      required: true
    }
  },
  render() {
    const { rawNode: { render: render2, props } } = this.tmNode;
    return h$1("div", props, [render2 === null || render2 === void 0 ? void 0 : render2()]);
  }
});
var NDropdownMenu = defineComponent({
  name: "DropdownMenu",
  props: {
    scrollable: Boolean,
    showArrow: Boolean,
    arrowStyle: [String, Object],
    clsPrefix: {
      type: String,
      required: true
    },
    tmNodes: {
      type: Array,
      default: () => []
    },
    parentKey: {
      type: [String, Number],
      default: null
    }
  },
  setup(props) {
    const { renderIconRef, childrenFieldRef } = inject(dropdownInjectionKey);
    provide(dropdownMenuInjectionKey, {
      showIconRef: computed(() => {
        const renderIcon2 = renderIconRef.value;
        return props.tmNodes.some((tmNode) => {
          var _a2;
          if (tmNode.isGroup) {
            return (_a2 = tmNode.children) === null || _a2 === void 0 ? void 0 : _a2.some(({ rawNode: rawChild }) => renderIcon2 ? renderIcon2(rawChild) : rawChild.icon);
          }
          const { rawNode } = tmNode;
          return renderIcon2 ? renderIcon2(rawNode) : rawNode.icon;
        });
      }),
      hasSubmenuRef: computed(() => {
        const { value: childrenField } = childrenFieldRef;
        return props.tmNodes.some((tmNode) => {
          var _a2;
          if (tmNode.isGroup) {
            return (_a2 = tmNode.children) === null || _a2 === void 0 ? void 0 : _a2.some(({ rawNode: rawChild }) => isSubmenuNode(rawChild, childrenField));
          }
          const { rawNode } = tmNode;
          return isSubmenuNode(rawNode, childrenField);
        });
      })
    });
    const bodyRef = ref(null);
    provide(modalBodyInjectionKey, null);
    provide(drawerBodyInjectionKey, null);
    provide(popoverBodyInjectionKey, bodyRef);
    return {
      bodyRef
    };
  },
  render() {
    const { parentKey, clsPrefix, scrollable } = this;
    const menuOptionsNode = this.tmNodes.map((tmNode) => {
      const { rawNode } = tmNode;
      if (rawNode.show === false)
        return null;
      if (isRenderNode(rawNode)) {
        return h$1(NDropdownRenderOption, { tmNode, key: tmNode.key });
      }
      if (isDividerNode$1(rawNode)) {
        return h$1(NDropdownDivider, { clsPrefix, key: tmNode.key });
      }
      if (isGroupNode(rawNode)) {
        return h$1(NDropdownGroup, { clsPrefix, tmNode, parentKey, key: tmNode.key });
      }
      return h$1(NDropdownOption, { clsPrefix, tmNode, parentKey, key: tmNode.key, props: rawNode.props, scrollable });
    });
    return h$1("div", { class: [
      `${clsPrefix}-dropdown-menu`,
      scrollable && `${clsPrefix}-dropdown-menu--scrollable`
    ], ref: "bodyRef" }, scrollable ? h$1(XScrollbar, { contentClass: `${clsPrefix}-dropdown-menu__content` }, {
      default: () => menuOptionsNode
    }) : menuOptionsNode, this.showArrow ? renderArrow({
      clsPrefix,
      arrowStyle: this.arrowStyle
    }) : null);
  }
});
var style$m = cB$1("dropdown-menu", `
 transform-origin: var(--v-transform-origin);
 background-color: var(--n-color);
 border-radius: var(--n-border-radius);
 box-shadow: var(--n-box-shadow);
 position: relative;
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
`, [fadeInScaleUpTransition(), cB$1("dropdown-option", `
 position: relative;
 `, [c$2("a", `
 text-decoration: none;
 color: inherit;
 outline: none;
 `, [c$2("&::before", `
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)]), cB$1("dropdown-option-body", `
 display: flex;
 cursor: pointer;
 position: relative;
 height: var(--n-option-height);
 line-height: var(--n-option-height);
 font-size: var(--n-font-size);
 color: var(--n-option-text-color);
 transition: color .3s var(--n-bezier);
 `, [c$2("&::before", `
 content: "";
 position: absolute;
 top: 0;
 bottom: 0;
 left: 4px;
 right: 4px;
 transition: background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 `), cNotM("disabled", [cM("pending", `
 color: var(--n-option-text-color-hover);
 `, [cE$1("prefix, suffix", `
 color: var(--n-option-text-color-hover);
 `), c$2("&::before", "background-color: var(--n-option-color-hover);")]), cM("active", `
 color: var(--n-option-text-color-active);
 `, [cE$1("prefix, suffix", `
 color: var(--n-option-text-color-active);
 `), c$2("&::before", "background-color: var(--n-option-color-active);")]), cM("child-active", `
 color: var(--n-option-text-color-child-active);
 `, [cE$1("prefix, suffix", `
 color: var(--n-option-text-color-child-active);
 `)])]), cM("disabled", `
 cursor: not-allowed;
 opacity: var(--n-option-opacity-disabled);
 `), cM("group", `
 font-size: calc(var(--n-font-size) - 1px);
 color: var(--n-group-header-text-color);
 `, [cE$1("prefix", `
 width: calc(var(--n-option-prefix-width) / 2);
 `, [cM("show-icon", `
 width: calc(var(--n-option-icon-prefix-width) / 2);
 `)])]), cE$1("prefix", `
 width: var(--n-option-prefix-width);
 display: flex;
 justify-content: center;
 align-items: center;
 color: var(--n-prefix-color);
 transition: color .3s var(--n-bezier);
 z-index: 1;
 `, [cM("show-icon", `
 width: var(--n-option-icon-prefix-width);
 `), cB$1("icon", `
 font-size: var(--n-option-icon-size);
 `)]), cE$1("label", `
 white-space: nowrap;
 flex: 1;
 z-index: 1;
 `), cE$1("suffix", `
 box-sizing: border-box;
 flex-grow: 0;
 flex-shrink: 0;
 display: flex;
 justify-content: flex-end;
 align-items: center;
 min-width: var(--n-option-suffix-width);
 padding: 0 8px;
 transition: color .3s var(--n-bezier);
 color: var(--n-suffix-color);
 z-index: 1;
 `, [cM("has-submenu", `
 width: var(--n-option-icon-suffix-width);
 `), cB$1("icon", `
 font-size: var(--n-option-icon-size);
 `)]), cB$1("dropdown-menu", "pointer-events: all;")]), cB$1("dropdown-offset-container", `
 pointer-events: none;
 position: absolute;
 left: 0;
 right: 0;
 top: -4px;
 bottom: -4px;
 `)]), cB$1("dropdown-divider", `
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-divider-color);
 height: 1px;
 margin: 4px 0;
 `), cB$1("dropdown-menu-wrapper", `
 transform-origin: var(--v-transform-origin);
 width: fit-content;
 `), c$2(">", [cB$1("scrollbar", `
 height: inherit;
 max-height: inherit;
 `)]), cNotM("scrollable", `
 padding: var(--n-padding);
 `), cM("scrollable", [cE$1("content", `
 padding: var(--n-padding);
 `)])]);
const dropdownBaseProps = {
  animated: {
    type: Boolean,
    default: true
  },
  keyboard: {
    type: Boolean,
    default: true
  },
  size: {
    type: String,
    default: "medium"
  },
  inverted: Boolean,
  placement: {
    type: String,
    default: "bottom"
  },
  onSelect: [Function, Array],
  options: {
    type: Array,
    default: () => []
  },
  menuProps: Function,
  showArrow: Boolean,
  renderLabel: Function,
  renderIcon: Function,
  renderOption: Function,
  nodeProps: Function,
  labelField: {
    type: String,
    default: "label"
  },
  keyField: {
    type: String,
    default: "key"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  value: [String, Number]
};
const popoverPropKeys = Object.keys(popoverBaseProps);
const dropdownProps = Object.assign(Object.assign(Object.assign({}, popoverBaseProps), dropdownBaseProps), useTheme.props);
var NDropdown = defineComponent({
  name: "Dropdown",
  inheritAttrs: false,
  props: dropdownProps,
  setup(props) {
    const uncontrolledShowRef = ref(false);
    const mergedShowRef = useMergedState(toRef(props, "show"), uncontrolledShowRef);
    const treemateRef = computed(() => {
      const { keyField, childrenField } = props;
      return createTreeMate(props.options, {
        getKey(node2) {
          return node2[keyField];
        },
        getDisabled(node2) {
          return node2.disabled === true;
        },
        getIgnored(node2) {
          return node2.type === "divider" || node2.type === "render";
        },
        getChildren(node2) {
          return node2[childrenField];
        }
      });
    });
    const tmNodesRef = computed(() => {
      return treemateRef.value.treeNodes;
    });
    const hoverKeyRef = ref(null);
    const keyboardKeyRef = ref(null);
    const lastToggledSubmenuKeyRef = ref(null);
    const pendingKeyRef = computed(() => {
      var _a2, _b2, _c2;
      return (_c2 = (_b2 = (_a2 = hoverKeyRef.value) !== null && _a2 !== void 0 ? _a2 : keyboardKeyRef.value) !== null && _b2 !== void 0 ? _b2 : lastToggledSubmenuKeyRef.value) !== null && _c2 !== void 0 ? _c2 : null;
    });
    const pendingKeyPathRef = computed(() => treemateRef.value.getPath(pendingKeyRef.value).keyPath);
    const activeKeyPathRef = computed(() => treemateRef.value.getPath(props.value).keyPath);
    const keyboardEnabledRef = useMemo(() => {
      return props.keyboard && mergedShowRef.value;
    });
    useKeyboard({
      keydown: {
        ArrowUp: {
          prevent: true,
          handler: handleKeydownUp
        },
        ArrowRight: {
          prevent: true,
          handler: handleKeydownRight
        },
        ArrowDown: {
          prevent: true,
          handler: handleKeydownDown
        },
        ArrowLeft: {
          prevent: true,
          handler: handleKeydownLeft
        },
        Enter: {
          prevent: true,
          handler: handleKeydownEnter
        },
        Escape: handleKeydownEsc
      }
    }, keyboardEnabledRef);
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Dropdown", "-dropdown", style$m, dropdownLight$1, props, mergedClsPrefixRef);
    provide(dropdownInjectionKey, {
      labelFieldRef: toRef(props, "labelField"),
      childrenFieldRef: toRef(props, "childrenField"),
      renderLabelRef: toRef(props, "renderLabel"),
      renderIconRef: toRef(props, "renderIcon"),
      hoverKeyRef,
      keyboardKeyRef,
      lastToggledSubmenuKeyRef,
      pendingKeyPathRef,
      activeKeyPathRef,
      animatedRef: toRef(props, "animated"),
      mergedShowRef,
      nodePropsRef: toRef(props, "nodeProps"),
      renderOptionRef: toRef(props, "renderOption"),
      menuPropsRef: toRef(props, "menuProps"),
      doSelect,
      doUpdateShow
    });
    watch(mergedShowRef, (value2) => {
      if (!props.animated && !value2) {
        clearPendingState();
      }
    });
    function doSelect(key, node2) {
      const { onSelect } = props;
      if (onSelect)
        call(onSelect, key, node2);
    }
    function doUpdateShow(value2) {
      const { "onUpdate:show": _onUpdateShow, onUpdateShow } = props;
      if (_onUpdateShow)
        call(_onUpdateShow, value2);
      if (onUpdateShow)
        call(onUpdateShow, value2);
      uncontrolledShowRef.value = value2;
    }
    function clearPendingState() {
      hoverKeyRef.value = null;
      keyboardKeyRef.value = null;
      lastToggledSubmenuKeyRef.value = null;
    }
    function handleKeydownEsc() {
      doUpdateShow(false);
    }
    function handleKeydownLeft() {
      handleKeydown("left");
    }
    function handleKeydownRight() {
      handleKeydown("right");
    }
    function handleKeydownUp() {
      handleKeydown("up");
    }
    function handleKeydownDown() {
      handleKeydown("down");
    }
    function handleKeydownEnter() {
      const pendingNode = getPendingNode();
      if ((pendingNode === null || pendingNode === void 0 ? void 0 : pendingNode.isLeaf) && mergedShowRef.value) {
        doSelect(pendingNode.key, pendingNode.rawNode);
        doUpdateShow(false);
      }
    }
    function getPendingNode() {
      var _a2;
      const { value: treeMate } = treemateRef;
      const { value: pendingKey } = pendingKeyRef;
      if (!treeMate || pendingKey === null)
        return null;
      return (_a2 = treeMate.getNode(pendingKey)) !== null && _a2 !== void 0 ? _a2 : null;
    }
    function handleKeydown(direction) {
      const { value: pendingKey } = pendingKeyRef;
      const { value: { getFirstAvailableNode: getFirstAvailableNode2 } } = treemateRef;
      let nextKeyboardKey = null;
      if (pendingKey === null) {
        const firstNode = getFirstAvailableNode2();
        if (firstNode !== null) {
          nextKeyboardKey = firstNode.key;
        }
      } else {
        const currentNode = getPendingNode();
        if (currentNode) {
          let nextNode;
          switch (direction) {
            case "down":
              nextNode = currentNode.getNext();
              break;
            case "up":
              nextNode = currentNode.getPrev();
              break;
            case "right":
              nextNode = currentNode.getChild();
              break;
            case "left":
              nextNode = currentNode.getParent();
              break;
          }
          if (nextNode)
            nextKeyboardKey = nextNode.key;
        }
      }
      if (nextKeyboardKey !== null) {
        hoverKeyRef.value = null;
        keyboardKeyRef.value = nextKeyboardKey;
      }
    }
    const cssVarsRef = computed(() => {
      const { size: size2, inverted } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: self2 } = themeRef.value;
      const { padding, dividerColor, borderRadius, optionOpacityDisabled, [createKey("optionIconSuffixWidth", size2)]: optionIconSuffixWidth, [createKey("optionSuffixWidth", size2)]: optionSuffixWidth, [createKey("optionIconPrefixWidth", size2)]: optionIconPrefixWidth, [createKey("optionPrefixWidth", size2)]: optionPrefixWidth, [createKey("fontSize", size2)]: fontSize2, [createKey("optionHeight", size2)]: optionHeight, [createKey("optionIconSize", size2)]: optionIconSize } = self2;
      const vars = {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-font-size": fontSize2,
        "--n-padding": padding,
        "--n-border-radius": borderRadius,
        "--n-option-height": optionHeight,
        "--n-option-prefix-width": optionPrefixWidth,
        "--n-option-icon-prefix-width": optionIconPrefixWidth,
        "--n-option-suffix-width": optionSuffixWidth,
        "--n-option-icon-suffix-width": optionIconSuffixWidth,
        "--n-option-icon-size": optionIconSize,
        "--n-divider-color": dividerColor,
        "--n-option-opacity-disabled": optionOpacityDisabled
      };
      if (inverted) {
        vars["--n-color"] = self2.colorInverted;
        vars["--n-option-color-hover"] = self2.optionColorHoverInverted;
        vars["--n-option-color-active"] = self2.optionColorActiveInverted;
        vars["--n-option-text-color"] = self2.optionTextColorInverted;
        vars["--n-option-text-color-hover"] = self2.optionTextColorHoverInverted;
        vars["--n-option-text-color-active"] = self2.optionTextColorActiveInverted;
        vars["--n-option-text-color-child-active"] = self2.optionTextColorChildActiveInverted;
        vars["--n-prefix-color"] = self2.prefixColorInverted;
        vars["--n-suffix-color"] = self2.suffixColorInverted;
        vars["--n-group-header-text-color"] = self2.groupHeaderTextColorInverted;
      } else {
        vars["--n-color"] = self2.color;
        vars["--n-option-color-hover"] = self2.optionColorHover;
        vars["--n-option-color-active"] = self2.optionColorActive;
        vars["--n-option-text-color"] = self2.optionTextColor;
        vars["--n-option-text-color-hover"] = self2.optionTextColorHover;
        vars["--n-option-text-color-active"] = self2.optionTextColorActive;
        vars["--n-option-text-color-child-active"] = self2.optionTextColorChildActive;
        vars["--n-prefix-color"] = self2.prefixColor;
        vars["--n-suffix-color"] = self2.suffixColor;
        vars["--n-group-header-text-color"] = self2.groupHeaderTextColor;
      }
      return vars;
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("dropdown", computed(() => `${props.size[0]}${props.inverted ? "i" : ""}`), cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      mergedTheme: themeRef,
      tmNodes: tmNodesRef,
      mergedShow: mergedShowRef,
      handleAfterLeave: () => {
        if (!props.animated)
          return;
        clearPendingState();
      },
      doUpdateShow,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const renderPopoverBody = (className, ref2, style2, onMouseenter, onMouseleave) => {
      var _a2;
      const { mergedClsPrefix, menuProps: menuProps2 } = this;
      (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
      const menuNodeProps = (menuProps2 === null || menuProps2 === void 0 ? void 0 : menuProps2(void 0, this.tmNodes.map((v2) => v2.rawNode))) || {};
      const dropdownProps2 = {
        ref: createRefSetter(ref2),
        class: [className, `${mergedClsPrefix}-dropdown`, this.themeClass],
        clsPrefix: mergedClsPrefix,
        tmNodes: this.tmNodes,
        style: [style2, this.cssVars],
        showArrow: this.showArrow,
        arrowStyle: this.arrowStyle,
        scrollable: this.scrollable,
        onMouseenter,
        onMouseleave
      };
      return h$1(NDropdownMenu, mergeProps(this.$attrs, dropdownProps2, menuNodeProps));
    };
    const { mergedTheme } = this;
    const popoverProps2 = {
      show: this.mergedShow,
      theme: mergedTheme.peers.Popover,
      themeOverrides: mergedTheme.peerOverrides.Popover,
      internalOnAfterLeave: this.handleAfterLeave,
      internalRenderBody: renderPopoverBody,
      onUpdateShow: this.doUpdateShow,
      "onUpdate:show": void 0
    };
    return h$1(NPopover, Object.assign({}, keep(this.$props, popoverPropKeys), popoverProps2), {
      trigger: () => {
        var _a2, _b2;
        return (_b2 = (_a2 = this.$slots).default) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
      }
    });
  }
});
const allKey = "_n_all__";
const noneKey = "_n_none__";
function createSelectHandler(options, rawPaginatedDataRef, doCheckAll, doUncheckAll) {
  if (!options)
    return () => {
    };
  return (key) => {
    for (const option of options) {
      switch (key) {
        case allKey:
          doCheckAll(true);
          return;
        case noneKey:
          doUncheckAll(true);
          return;
        default:
          if (typeof option === "object" && option.key === key) {
            option.onSelect(rawPaginatedDataRef.value);
            return;
          }
      }
    }
  };
}
function createDropdownOptions(options, localeRef) {
  if (!options)
    return [];
  return options.map((option) => {
    switch (option) {
      case "all":
        return {
          label: localeRef.checkTableAll,
          key: allKey
        };
      case "none":
        return {
          label: localeRef.uncheckTableAll,
          key: noneKey
        };
      default:
        return option;
    }
  });
}
var SelectionMenu = defineComponent({
  name: "DataTableSelectionMenu",
  props: {
    clsPrefix: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const {
      props: dataTableProps2,
      localeRef,
      checkOptionsRef,
      rawPaginatedDataRef,
      doCheckAll,
      doUncheckAll
    } = inject(dataTableInjectionKey);
    const handleSelectRef = computed(() => createSelectHandler(checkOptionsRef.value, rawPaginatedDataRef, doCheckAll, doUncheckAll));
    const optionsRef = computed(() => createDropdownOptions(checkOptionsRef.value, localeRef.value));
    return () => {
      var _a2, _b2, _c2, _d2;
      const { clsPrefix } = props;
      return h$1(NDropdown, { theme: (_b2 = (_a2 = dataTableProps2.theme) === null || _a2 === void 0 ? void 0 : _a2.peers) === null || _b2 === void 0 ? void 0 : _b2.Dropdown, themeOverrides: (_d2 = (_c2 = dataTableProps2.themeOverrides) === null || _c2 === void 0 ? void 0 : _c2.peers) === null || _d2 === void 0 ? void 0 : _d2.Dropdown, options: optionsRef.value, onSelect: handleSelectRef.value }, {
        default: () => h$1(NBaseIcon, { clsPrefix, class: `${clsPrefix}-data-table-check-extra` }, {
          default: () => h$1(ChevronDownIcon, null)
        })
      });
    };
  }
});
function renderTitle(column) {
  return typeof column.title === "function" ? column.title(column) : column.title;
}
var TableHeader = defineComponent({
  name: "DataTableHeader",
  props: {
    discrete: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const {
      mergedClsPrefixRef,
      scrollXRef,
      fixedColumnLeftMapRef,
      fixedColumnRightMapRef,
      mergedCurrentPageRef,
      allRowsCheckedRef,
      someRowsCheckedRef,
      rowsRef,
      colsRef,
      mergedThemeRef,
      checkOptionsRef,
      mergedSortStateRef,
      componentId,
      scrollPartRef,
      mergedTableLayoutRef,
      headerCheckboxDisabledRef,
      onUnstableColumnResize,
      doUpdateResizableWidth,
      handleTableHeaderScroll,
      deriveNextSorter,
      doUncheckAll,
      doCheckAll
    } = inject(dataTableInjectionKey);
    const cellElsRef = ref({});
    function getCellActualWidth(key) {
      const element = cellElsRef.value[key];
      return element === null || element === void 0 ? void 0 : element.getBoundingClientRect().width;
    }
    function handleCheckboxUpdateChecked() {
      if (allRowsCheckedRef.value) {
        doUncheckAll();
      } else {
        doCheckAll();
      }
    }
    function handleColHeaderClick(e25, column) {
      if (happensIn(e25, "dataTableFilter") || happensIn(e25, "dataTableResizable")) {
        return;
      }
      if (!isColumnSortable(column))
        return;
      const activeSorter = mergedSortStateRef.value.find((state) => state.columnKey === column.key) || null;
      const nextSorter = createNextSorter(column, activeSorter);
      deriveNextSorter(nextSorter);
    }
    function handleMouseenter() {
      scrollPartRef.value = "head";
    }
    function handleMouseleave() {
      scrollPartRef.value = "body";
    }
    const resizeStartWidthMap = new Map();
    function handleColumnResizeStart(column) {
      resizeStartWidthMap.set(column.key, getCellActualWidth(column.key));
    }
    function handleColumnResize(column, displacementX) {
      const startWidth = resizeStartWidthMap.get(column.key);
      if (startWidth === void 0) {
        return;
      }
      const widthAfterResize = startWidth + displacementX;
      const limitWidth = clampValueFollowCSSRules(widthAfterResize, column.minWidth, column.maxWidth);
      onUnstableColumnResize(widthAfterResize, limitWidth, column, getCellActualWidth);
      doUpdateResizableWidth(column, limitWidth);
    }
    return {
      cellElsRef,
      componentId,
      mergedSortState: mergedSortStateRef,
      mergedClsPrefix: mergedClsPrefixRef,
      scrollX: scrollXRef,
      fixedColumnLeftMap: fixedColumnLeftMapRef,
      fixedColumnRightMap: fixedColumnRightMapRef,
      currentPage: mergedCurrentPageRef,
      allRowsChecked: allRowsCheckedRef,
      someRowsChecked: someRowsCheckedRef,
      rows: rowsRef,
      cols: colsRef,
      mergedTheme: mergedThemeRef,
      checkOptions: checkOptionsRef,
      mergedTableLayout: mergedTableLayoutRef,
      headerCheckboxDisabled: headerCheckboxDisabledRef,
      handleMouseenter,
      handleMouseleave,
      handleCheckboxUpdateChecked,
      handleColHeaderClick,
      handleTableHeaderScroll,
      handleColumnResizeStart,
      handleColumnResize
    };
  },
  render() {
    const { cellElsRef, mergedClsPrefix, fixedColumnLeftMap, fixedColumnRightMap, currentPage, allRowsChecked, someRowsChecked, rows, cols, mergedTheme, checkOptions, componentId, discrete, mergedTableLayout, headerCheckboxDisabled, mergedSortState, handleColHeaderClick, handleCheckboxUpdateChecked, handleColumnResizeStart, handleColumnResize } = this;
    const theadVNode = h$1("thead", { class: `${mergedClsPrefix}-data-table-thead`, "data-n-id": componentId }, rows.map((row) => {
      return h$1("tr", { class: `${mergedClsPrefix}-data-table-tr` }, row.map(({ column, colSpan, rowSpan, isLast }) => {
        var _a2, _b2;
        const key = getColKey(column);
        const { ellipsis } = column;
        const createColumnVNode = () => {
          if (column.type === "selection") {
            return column.multiple !== false ? h$1(Fragment, null, h$1(NCheckbox, { key: currentPage, privateInsideTable: true, checked: allRowsChecked, indeterminate: someRowsChecked, disabled: headerCheckboxDisabled, onUpdateChecked: handleCheckboxUpdateChecked }), checkOptions ? h$1(SelectionMenu, { clsPrefix: mergedClsPrefix }) : null) : null;
          }
          return h$1(Fragment, null, h$1("div", { class: `${mergedClsPrefix}-data-table-th__title-wrapper` }, h$1("div", { class: `${mergedClsPrefix}-data-table-th__title` }, ellipsis === true || ellipsis && !ellipsis.tooltip ? h$1("div", { class: `${mergedClsPrefix}-data-table-th__ellipsis` }, renderTitle(column)) : ellipsis && typeof ellipsis === "object" ? h$1(NEllipsis, Object.assign({}, ellipsis, { theme: mergedTheme.peers.Ellipsis, themeOverrides: mergedTheme.peerOverrides.Ellipsis }), {
            default: () => renderTitle(column)
          }) : renderTitle(column)), isColumnSortable(column) ? h$1(SortButton, { column }) : null), isColumnFilterable(column) ? h$1(FilterButton, { column, options: column.filterOptions }) : null, isColumnResizable(column) ? h$1(ResizeButton, { onResizeStart: () => {
            handleColumnResizeStart(column);
          }, onResize: (displacementX) => {
            handleColumnResize(column, displacementX);
          } }) : null);
        };
        const leftFixed = key in fixedColumnLeftMap;
        const rightFixed = key in fixedColumnRightMap;
        return h$1("th", { ref: (el2) => cellElsRef[key] = el2, key, style: {
          textAlign: column.titleAlign || column.align,
          left: pxfy((_a2 = fixedColumnLeftMap[key]) === null || _a2 === void 0 ? void 0 : _a2.start),
          right: pxfy((_b2 = fixedColumnRightMap[key]) === null || _b2 === void 0 ? void 0 : _b2.start)
        }, colspan: colSpan, rowspan: rowSpan, "data-col-key": key, class: [
          `${mergedClsPrefix}-data-table-th`,
          (leftFixed || rightFixed) && `${mergedClsPrefix}-data-table-th--fixed-${leftFixed ? "left" : "right"}`,
          {
            [`${mergedClsPrefix}-data-table-th--hover`]: isColumnSorting(column, mergedSortState),
            [`${mergedClsPrefix}-data-table-th--filterable`]: isColumnFilterable(column),
            [`${mergedClsPrefix}-data-table-th--sortable`]: isColumnSortable(column),
            [`${mergedClsPrefix}-data-table-th--selection`]: column.type === "selection",
            [`${mergedClsPrefix}-data-table-th--last`]: isLast
          },
          column.className
        ], onClick: column.type !== "selection" && column.type !== "expand" && !("children" in column) ? (e25) => {
          handleColHeaderClick(e25, column);
        } : void 0 }, createColumnVNode());
      }));
    }));
    if (!discrete) {
      return theadVNode;
    }
    const { handleTableHeaderScroll, handleMouseenter, handleMouseleave, scrollX } = this;
    return h$1("div", { class: `${mergedClsPrefix}-data-table-base-table-header`, onScroll: handleTableHeaderScroll, onMouseenter: handleMouseenter, onMouseleave: handleMouseleave }, h$1("table", { ref: "body", class: `${mergedClsPrefix}-data-table-table`, style: {
      minWidth: formatLength(scrollX),
      tableLayout: mergedTableLayout
    } }, h$1("colgroup", null, cols.map((col) => h$1("col", { key: col.key, style: col.style }))), theadVNode));
  }
});
var Cell = defineComponent({
  name: "DataTableCell",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    row: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    column: {
      type: Object,
      required: true
    },
    isSummary: Boolean,
    mergedTheme: {
      type: Object,
      required: true
    },
    renderCell: Function
  },
  render() {
    const { isSummary, column, row, renderCell } = this;
    let cell;
    const { render: render2, key, ellipsis } = column;
    if (render2 && !isSummary) {
      cell = render2(row, this.index);
    } else {
      if (isSummary) {
        cell = row[key].value;
      } else {
        cell = renderCell ? renderCell(get(row, key), row, column) : get(row, key);
      }
    }
    if (ellipsis) {
      if (typeof ellipsis === "object") {
        const { mergedTheme } = this;
        return h$1(NEllipsis, Object.assign({}, ellipsis, { theme: mergedTheme.peers.Ellipsis, themeOverrides: mergedTheme.peerOverrides.Ellipsis }), { default: () => cell });
      } else {
        return h$1("span", { class: `${this.clsPrefix}-data-table-td__ellipsis` }, cell);
      }
    }
    return cell;
  }
});
var ExpandTrigger = defineComponent({
  name: "DataTableExpandTrigger",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    expanded: Boolean,
    loading: Boolean,
    onClick: {
      type: Function,
      required: true
    },
    renderExpandIcon: {
      type: Function
    }
  },
  render() {
    const { clsPrefix } = this;
    return h$1("div", { class: [
      `${clsPrefix}-data-table-expand-trigger`,
      this.expanded && `${clsPrefix}-data-table-expand-trigger--expanded`
    ], onClick: this.onClick }, h$1(NIconSwitchTransition, null, {
      default: () => {
        return this.loading ? h$1(NBaseLoading, { key: "loading", clsPrefix: this.clsPrefix, radius: 85, strokeWidth: 15, scale: 0.88 }) : this.renderExpandIcon ? this.renderExpandIcon({
          expanded: this.expanded
        }) : h$1(NBaseIcon, { clsPrefix, key: "base-icon" }, {
          default: () => h$1(ChevronRightIcon, null)
        });
      }
    }));
  }
});
var RenderSafeCheckbox = defineComponent({
  name: "DataTableBodyCheckbox",
  props: {
    rowKey: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    onUpdateChecked: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const {
      mergedCheckedRowKeySetRef,
      mergedInderminateRowKeySetRef
    } = inject(dataTableInjectionKey);
    return () => {
      const { rowKey } = props;
      return h$1(NCheckbox, { privateInsideTable: true, disabled: props.disabled, indeterminate: mergedInderminateRowKeySetRef.value.has(rowKey), checked: mergedCheckedRowKeySetRef.value.has(rowKey), onUpdateChecked: props.onUpdateChecked });
    };
  }
});
var RenderSafeRadio = defineComponent({
  name: "DataTableBodyRadio",
  props: {
    rowKey: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    onUpdateChecked: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const {
      mergedCheckedRowKeySetRef,
      componentId
    } = inject(dataTableInjectionKey);
    return () => {
      const { rowKey } = props;
      return h$1(NRadio, { name: componentId, disabled: props.disabled, checked: mergedCheckedRowKeySetRef.value.has(rowKey), onUpdateChecked: props.onUpdateChecked });
    };
  }
});
function flatten$1(rowInfos, expandedRowKeys) {
  const fRows = [];
  function traverse(rs2, rootIndex) {
    rs2.forEach((r2) => {
      if (r2.children && expandedRowKeys.has(r2.key)) {
        fRows.push({
          tmNode: r2,
          striped: false,
          key: r2.key,
          index: rootIndex
        });
        traverse(r2.children, rootIndex);
      } else {
        fRows.push({
          key: r2.key,
          tmNode: r2,
          striped: false,
          index: rootIndex
        });
      }
    });
  }
  rowInfos.forEach((rowInfo) => {
    fRows.push(rowInfo);
    const { children } = rowInfo.tmNode;
    if (children && expandedRowKeys.has(rowInfo.key)) {
      traverse(children, rowInfo.index);
    }
  });
  return fRows;
}
const VirtualListItemWrapper = defineComponent({
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    cols: {
      type: Array,
      required: true
    },
    onMouseenter: Function,
    onMouseleave: Function
  },
  render() {
    const { clsPrefix, id: id2, cols, onMouseenter, onMouseleave } = this;
    return h$1("table", { style: { tableLayout: "fixed" }, class: `${clsPrefix}-data-table-table`, onMouseenter, onMouseleave }, h$1("colgroup", null, cols.map((col) => h$1("col", { key: col.key, style: col.style }))), h$1("tbody", { "data-n-id": id2, class: `${clsPrefix}-data-table-tbody` }, this.$slots));
  }
});
var TableBody = defineComponent({
  name: "DataTableBody",
  props: {
    onResize: Function,
    showHeader: Boolean,
    flexHeight: Boolean,
    bodyStyle: Object
  },
  setup(props) {
    const {
      slots: dataTableSlots,
      bodyWidthRef,
      mergedExpandedRowKeysRef,
      mergedClsPrefixRef,
      mergedThemeRef,
      scrollXRef,
      colsRef,
      paginatedDataRef,
      rawPaginatedDataRef,
      fixedColumnLeftMapRef,
      fixedColumnRightMapRef,
      mergedCurrentPageRef,
      rowClassNameRef,
      leftActiveFixedColKeyRef,
      leftActiveFixedChildrenColKeysRef,
      rightActiveFixedColKeyRef,
      rightActiveFixedChildrenColKeysRef,
      renderExpandRef,
      hoverKeyRef,
      summaryRef,
      mergedSortStateRef,
      virtualScrollRef,
      componentId,
      scrollPartRef,
      mergedTableLayoutRef,
      childTriggerColIndexRef,
      indentRef,
      rowPropsRef,
      maxHeightRef,
      stripedRef,
      loadingRef,
      onLoadRef,
      loadingKeySetRef,
      expandableRef,
      stickyExpandedRowsRef,
      renderExpandIconRef,
      summaryPlacementRef,
      treeMateRef,
      scrollbarPropsRef,
      setHeaderScrollLeft,
      doUpdateExpandedRowKeys,
      handleTableBodyScroll,
      doCheck,
      doUncheck,
      renderCell
    } = inject(dataTableInjectionKey);
    const scrollbarInstRef = ref(null);
    const virtualListRef = ref(null);
    const emptyElRef = ref(null);
    const emptyRef = useMemo(() => paginatedDataRef.value.length === 0);
    const shouldDisplaySomeTablePartRef = useMemo(() => props.showHeader || !emptyRef.value);
    const bodyShowHeaderOnlyRef = useMemo(() => {
      return props.showHeader || emptyRef.value;
    });
    let lastSelectedKey = "";
    const mergedExpandedRowKeySetRef = computed(() => {
      return new Set(mergedExpandedRowKeysRef.value);
    });
    function getRowInfo(key) {
      var _a2;
      return (_a2 = treeMateRef.value.getNode(key)) === null || _a2 === void 0 ? void 0 : _a2.rawNode;
    }
    function handleCheckboxUpdateChecked(tmNode, checked, shiftKey) {
      const rowInfo = getRowInfo(tmNode.key);
      if (!rowInfo) {
        warn$2("data-table", `fail to get row data with key ${tmNode.key}`);
        return;
      }
      if (shiftKey) {
        const lastIndex = paginatedDataRef.value.findIndex((item) => item.key === lastSelectedKey);
        if (lastIndex !== -1) {
          const currentIndex = paginatedDataRef.value.findIndex((item) => item.key === tmNode.key);
          const start = Math.min(lastIndex, currentIndex);
          const end = Math.max(lastIndex, currentIndex);
          const rowKeysToCheck = [];
          paginatedDataRef.value.slice(start, end + 1).forEach((r2) => {
            if (!r2.disabled) {
              rowKeysToCheck.push(r2.key);
            }
          });
          if (checked) {
            doCheck(rowKeysToCheck, false, rowInfo);
          } else {
            doUncheck(rowKeysToCheck, rowInfo);
          }
          lastSelectedKey = tmNode.key;
          return;
        }
      }
      if (checked) {
        doCheck(tmNode.key, false, rowInfo);
      } else {
        doUncheck(tmNode.key, rowInfo);
      }
      lastSelectedKey = tmNode.key;
    }
    function handleRadioUpdateChecked(tmNode) {
      const rowInfo = getRowInfo(tmNode.key);
      if (!rowInfo) {
        warn$2("data-table", `fail to get row data with key ${tmNode.key}`);
        return;
      }
      doCheck(tmNode.key, true, rowInfo);
    }
    function getScrollContainer() {
      if (!shouldDisplaySomeTablePartRef.value) {
        const { value: emptyEl } = emptyElRef;
        if (emptyEl) {
          return emptyEl;
        } else {
          return null;
        }
      }
      if (virtualScrollRef.value) {
        return virtualListContainer();
      }
      const { value: value2 } = scrollbarInstRef;
      if (value2)
        return value2.containerRef;
      return null;
    }
    function handleUpdateExpanded(key, tmNode) {
      var _a2;
      if (loadingKeySetRef.value.has(key))
        return;
      const { value: mergedExpandedRowKeys } = mergedExpandedRowKeysRef;
      const index2 = mergedExpandedRowKeys.indexOf(key);
      const nextExpandedKeys = Array.from(mergedExpandedRowKeys);
      if (~index2) {
        nextExpandedKeys.splice(index2, 1);
        doUpdateExpandedRowKeys(nextExpandedKeys);
      } else {
        if (tmNode && !tmNode.isLeaf && !tmNode.shallowLoaded) {
          loadingKeySetRef.value.add(key);
          void ((_a2 = onLoadRef.value) === null || _a2 === void 0 ? void 0 : _a2.call(onLoadRef, tmNode.rawNode).then(() => {
            const { value: futureMergedExpandedRowKeys } = mergedExpandedRowKeysRef;
            const futureNextExpandedKeys = Array.from(futureMergedExpandedRowKeys);
            const index3 = futureNextExpandedKeys.indexOf(key);
            if (!~index3) {
              futureNextExpandedKeys.push(key);
            }
            doUpdateExpandedRowKeys(futureNextExpandedKeys);
          }).finally(() => {
            loadingKeySetRef.value.delete(key);
          }));
        } else {
          nextExpandedKeys.push(key);
          doUpdateExpandedRowKeys(nextExpandedKeys);
        }
      }
    }
    function handleMouseleaveTable() {
      hoverKeyRef.value = null;
    }
    function handleMouseenterTable() {
      scrollPartRef.value = "body";
    }
    function virtualListContainer() {
      const { value: value2 } = virtualListRef;
      return value2 === null || value2 === void 0 ? void 0 : value2.listElRef;
    }
    function virtualListContent() {
      const { value: value2 } = virtualListRef;
      return value2 === null || value2 === void 0 ? void 0 : value2.itemsElRef;
    }
    function handleVirtualListScroll(e25) {
      var _a2;
      handleTableBodyScroll(e25);
      (_a2 = scrollbarInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.sync();
    }
    function handleVirtualListResize(e25) {
      var _a2;
      const { onResize } = props;
      if (onResize)
        onResize(e25);
      (_a2 = scrollbarInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.sync();
    }
    const exposedMethods = {
      getScrollContainer,
      scrollTo(arg0, arg1) {
        var _a2, _b2;
        if (virtualScrollRef.value) {
          (_a2 = virtualListRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollTo(arg0, arg1);
        } else {
          (_b2 = scrollbarInstRef.value) === null || _b2 === void 0 ? void 0 : _b2.scrollTo(arg0, arg1);
        }
      }
    };
    const style2 = c$2([
      ({ props: cProps }) => {
        const createActiveLeftFixedStyle = (leftActiveFixedColKey) => {
          if (leftActiveFixedColKey === null)
            return null;
          return c$2(`[data-n-id="${cProps.componentId}"] [data-col-key="${leftActiveFixedColKey}"]::after`, { boxShadow: "var(--n-box-shadow-after)" });
        };
        const createActiveRightFixedStyle = (rightActiveFixedColKey) => {
          if (rightActiveFixedColKey === null)
            return null;
          return c$2(`[data-n-id="${cProps.componentId}"] [data-col-key="${rightActiveFixedColKey}"]::before`, { boxShadow: "var(--n-box-shadow-before)" });
        };
        return c$2([
          createActiveLeftFixedStyle(cProps.leftActiveFixedColKey),
          createActiveRightFixedStyle(cProps.rightActiveFixedColKey),
          cProps.leftActiveFixedChildrenColKeys.map((leftActiveFixedColKey) => createActiveLeftFixedStyle(leftActiveFixedColKey)),
          cProps.rightActiveFixedChildrenColKeys.map((rightActiveFixedColKey) => createActiveRightFixedStyle(rightActiveFixedColKey))
        ]);
      }
    ]);
    let fixedStyleMounted = false;
    watchEffect(() => {
      const { value: leftActiveFixedColKey } = leftActiveFixedColKeyRef;
      const { value: leftActiveFixedChildrenColKeys } = leftActiveFixedChildrenColKeysRef;
      const { value: rightActiveFixedColKey } = rightActiveFixedColKeyRef;
      const { value: rightActiveFixedChildrenColKeys } = rightActiveFixedChildrenColKeysRef;
      if (!fixedStyleMounted && leftActiveFixedColKey === null && rightActiveFixedColKey === null) {
        return;
      }
      const cProps = {
        leftActiveFixedColKey,
        leftActiveFixedChildrenColKeys,
        rightActiveFixedColKey,
        rightActiveFixedChildrenColKeys,
        componentId
      };
      style2.mount({
        id: `n-${componentId}`,
        force: true,
        props: cProps,
        anchorMetaName: cssrAnchorMetaName
      });
      fixedStyleMounted = true;
    });
    onUnmounted(() => {
      style2.unmount({
        id: `n-${componentId}`
      });
    });
    return Object.assign({
      bodyWidth: bodyWidthRef,
      summaryPlacement: summaryPlacementRef,
      dataTableSlots,
      componentId,
      scrollbarInstRef,
      virtualListRef,
      emptyElRef,
      summary: summaryRef,
      mergedClsPrefix: mergedClsPrefixRef,
      mergedTheme: mergedThemeRef,
      scrollX: scrollXRef,
      cols: colsRef,
      loading: loadingRef,
      bodyShowHeaderOnly: bodyShowHeaderOnlyRef,
      shouldDisplaySomeTablePart: shouldDisplaySomeTablePartRef,
      empty: emptyRef,
      paginatedDataAndInfo: computed(() => {
        const { value: striped } = stripedRef;
        let hasChildren = false;
        const data = paginatedDataRef.value.map(striped ? (tmNode, index2) => {
          if (!tmNode.isLeaf)
            hasChildren = true;
          return {
            tmNode,
            key: tmNode.key,
            striped: index2 % 2 === 1,
            index: index2
          };
        } : (tmNode, index2) => {
          if (!tmNode.isLeaf)
            hasChildren = true;
          return {
            tmNode,
            key: tmNode.key,
            striped: false,
            index: index2
          };
        });
        return {
          data,
          hasChildren
        };
      }),
      rawPaginatedData: rawPaginatedDataRef,
      fixedColumnLeftMap: fixedColumnLeftMapRef,
      fixedColumnRightMap: fixedColumnRightMapRef,
      currentPage: mergedCurrentPageRef,
      rowClassName: rowClassNameRef,
      renderExpand: renderExpandRef,
      mergedExpandedRowKeySet: mergedExpandedRowKeySetRef,
      hoverKey: hoverKeyRef,
      mergedSortState: mergedSortStateRef,
      virtualScroll: virtualScrollRef,
      mergedTableLayout: mergedTableLayoutRef,
      childTriggerColIndex: childTriggerColIndexRef,
      indent: indentRef,
      rowProps: rowPropsRef,
      maxHeight: maxHeightRef,
      loadingKeySet: loadingKeySetRef,
      expandable: expandableRef,
      stickyExpandedRows: stickyExpandedRowsRef,
      renderExpandIcon: renderExpandIconRef,
      scrollbarProps: scrollbarPropsRef,
      setHeaderScrollLeft,
      handleMouseenterTable,
      handleVirtualListScroll,
      handleVirtualListResize,
      handleMouseleaveTable,
      virtualListContainer,
      virtualListContent,
      handleTableBodyScroll,
      handleCheckboxUpdateChecked,
      handleRadioUpdateChecked,
      handleUpdateExpanded,
      renderCell
    }, exposedMethods);
  },
  render() {
    const { mergedTheme, scrollX, mergedClsPrefix, virtualScroll, maxHeight, mergedTableLayout, flexHeight, loadingKeySet, onResize, setHeaderScrollLeft } = this;
    const scrollable = scrollX !== void 0 || maxHeight !== void 0 || flexHeight;
    const isBasicAutoLayout = !scrollable && mergedTableLayout === "auto";
    const xScrollable = scrollX !== void 0 || isBasicAutoLayout;
    const contentStyle = {
      minWidth: formatLength(scrollX) || "100%"
    };
    if (scrollX)
      contentStyle.width = "100%";
    const tableNode = h$1(NScrollbar, Object.assign({}, this.scrollbarProps, { ref: "scrollbarInstRef", scrollable: scrollable || isBasicAutoLayout, class: `${mergedClsPrefix}-data-table-base-table-body`, style: this.bodyStyle, theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar, contentStyle, container: virtualScroll ? this.virtualListContainer : void 0, content: virtualScroll ? this.virtualListContent : void 0, horizontalRailStyle: { zIndex: 3 }, verticalRailStyle: { zIndex: 3 }, xScrollable, onScroll: virtualScroll ? void 0 : this.handleTableBodyScroll, internalOnUpdateScrollLeft: setHeaderScrollLeft, onResize }), {
      default: () => {
        const cordToPass = {};
        const cordKey = {};
        const { cols, paginatedDataAndInfo, mergedTheme: mergedTheme2, fixedColumnLeftMap, fixedColumnRightMap, currentPage, rowClassName, mergedSortState, mergedExpandedRowKeySet, stickyExpandedRows, componentId, childTriggerColIndex, expandable, rowProps, handleMouseenterTable, handleMouseleaveTable, renderExpand, summary, handleCheckboxUpdateChecked, handleRadioUpdateChecked, handleUpdateExpanded } = this;
        const { length: colCount } = cols;
        let mergedData;
        const { data: paginatedData, hasChildren } = paginatedDataAndInfo;
        const mergedPaginationData = hasChildren ? flatten$1(paginatedData, mergedExpandedRowKeySet) : paginatedData;
        if (summary) {
          const summaryRows = summary(this.rawPaginatedData);
          if (Array.isArray(summaryRows)) {
            const summaryRowData = summaryRows.map((row, i2) => ({
              isSummaryRow: true,
              key: `__n_summary__${i2}`,
              tmNode: {
                rawNode: row,
                disabled: true
              },
              index: -1
            }));
            mergedData = this.summaryPlacement === "top" ? [...summaryRowData, ...mergedPaginationData] : [...mergedPaginationData, ...summaryRowData];
          } else {
            const summaryRowData = {
              isSummaryRow: true,
              key: "__n_summary__",
              tmNode: {
                rawNode: summaryRows,
                disabled: true
              },
              index: -1
            };
            mergedData = this.summaryPlacement === "top" ? [summaryRowData, ...mergedPaginationData] : [...mergedPaginationData, summaryRowData];
          }
        } else {
          mergedData = mergedPaginationData;
        }
        const indentStyle = hasChildren ? { width: pxfy(this.indent) } : void 0;
        const displayedData = [];
        mergedData.forEach((rowInfo) => {
          if (renderExpand && mergedExpandedRowKeySet.has(rowInfo.key) && (!expandable || expandable(rowInfo.tmNode.rawNode))) {
            displayedData.push(rowInfo, {
              isExpandedRow: true,
              key: `${rowInfo.key}-expand`,
              tmNode: rowInfo.tmNode,
              index: rowInfo.index
            });
          } else {
            displayedData.push(rowInfo);
          }
        });
        const { length: rowCount } = displayedData;
        const rowIndexToKey = {};
        paginatedData.forEach(({ tmNode }, rowIndex) => {
          rowIndexToKey[rowIndex] = tmNode.key;
        });
        const bodyWidth = stickyExpandedRows ? this.bodyWidth : null;
        const bodyWidthPx = bodyWidth === null ? void 0 : `${bodyWidth}px`;
        const renderRow = (rowInfo, displayedRowIndex, isVirtual) => {
          const { index: actualRowIndex } = rowInfo;
          if ("isExpandedRow" in rowInfo) {
            const { tmNode: { key, rawNode } } = rowInfo;
            return h$1("tr", { class: `${mergedClsPrefix}-data-table-tr`, key: `${key}__expand` }, h$1("td", { class: [
              `${mergedClsPrefix}-data-table-td`,
              `${mergedClsPrefix}-data-table-td--last-col`,
              displayedRowIndex + 1 === rowCount && `${mergedClsPrefix}-data-table-td--last-row`
            ], colspan: colCount }, stickyExpandedRows ? h$1("div", { class: `${mergedClsPrefix}-data-table-expand`, style: {
              width: bodyWidthPx
            } }, renderExpand(rawNode, actualRowIndex)) : renderExpand(rawNode, actualRowIndex)));
          }
          const isSummary = "isSummaryRow" in rowInfo;
          const striped = !isSummary && rowInfo.striped;
          const { tmNode, key: rowKey } = rowInfo;
          const { rawNode: rowData } = tmNode;
          const expanded = mergedExpandedRowKeySet.has(rowKey);
          const props = rowProps ? rowProps(rowData, actualRowIndex) : void 0;
          const mergedRowClassName = typeof rowClassName === "string" ? rowClassName : createRowClassName(rowData, actualRowIndex, rowClassName);
          const row = h$1("tr", Object.assign({ onMouseenter: () => {
            this.hoverKey = rowKey;
          }, key: rowKey, class: [
            `${mergedClsPrefix}-data-table-tr`,
            isSummary && `${mergedClsPrefix}-data-table-tr--summary`,
            striped && `${mergedClsPrefix}-data-table-tr--striped`,
            mergedRowClassName
          ] }, props), cols.map((col, colIndex) => {
            var _a2, _b2, _c2, _d2, _e2;
            if (displayedRowIndex in cordToPass) {
              const cordOfRowToPass = cordToPass[displayedRowIndex];
              const indexInCordOfRowToPass = cordOfRowToPass.indexOf(colIndex);
              if (~indexInCordOfRowToPass) {
                cordOfRowToPass.splice(indexInCordOfRowToPass, 1);
                return null;
              }
            }
            const { column } = col;
            const colKey = getColKey(col);
            const { rowSpan, colSpan } = column;
            const mergedColSpan = isSummary ? ((_a2 = rowInfo.tmNode.rawNode[colKey]) === null || _a2 === void 0 ? void 0 : _a2.colSpan) || 1 : colSpan ? colSpan(rowData, actualRowIndex) : 1;
            const mergedRowSpan = isSummary ? ((_b2 = rowInfo.tmNode.rawNode[colKey]) === null || _b2 === void 0 ? void 0 : _b2.rowSpan) || 1 : rowSpan ? rowSpan(rowData, actualRowIndex) : 1;
            const isLastCol = colIndex + mergedColSpan === colCount;
            const isLastRow = displayedRowIndex + mergedRowSpan === rowCount;
            const isCrossRowTd = mergedRowSpan > 1;
            if (isCrossRowTd) {
              cordKey[displayedRowIndex] = {
                [colIndex]: []
              };
            }
            if (mergedColSpan > 1 || isCrossRowTd) {
              for (let i2 = displayedRowIndex; i2 < displayedRowIndex + mergedRowSpan; ++i2) {
                if (isCrossRowTd) {
                  cordKey[displayedRowIndex][colIndex].push(rowIndexToKey[i2]);
                }
                for (let j2 = colIndex; j2 < colIndex + mergedColSpan; ++j2) {
                  if (i2 === displayedRowIndex && j2 === colIndex) {
                    continue;
                  }
                  if (!(i2 in cordToPass)) {
                    cordToPass[i2] = [j2];
                  } else {
                    cordToPass[i2].push(j2);
                  }
                }
              }
            }
            const hoverKey = isCrossRowTd ? this.hoverKey : null;
            const { cellProps } = column;
            const resolvedCellProps = cellProps === null || cellProps === void 0 ? void 0 : cellProps(rowData, actualRowIndex);
            return h$1("td", Object.assign({}, resolvedCellProps, { key: colKey, style: [
              {
                textAlign: column.align || void 0,
                left: pxfy((_c2 = fixedColumnLeftMap[colKey]) === null || _c2 === void 0 ? void 0 : _c2.start),
                right: pxfy((_d2 = fixedColumnRightMap[colKey]) === null || _d2 === void 0 ? void 0 : _d2.start)
              },
              (resolvedCellProps === null || resolvedCellProps === void 0 ? void 0 : resolvedCellProps.style) || ""
            ], colspan: mergedColSpan, rowspan: isVirtual ? void 0 : mergedRowSpan, "data-col-key": colKey, class: [
              `${mergedClsPrefix}-data-table-td`,
              column.className,
              resolvedCellProps === null || resolvedCellProps === void 0 ? void 0 : resolvedCellProps.class,
              isSummary && `${mergedClsPrefix}-data-table-td--summary`,
              (hoverKey !== null && cordKey[displayedRowIndex][colIndex].includes(hoverKey) || isColumnSorting(column, mergedSortState)) && `${mergedClsPrefix}-data-table-td--hover`,
              column.fixed && `${mergedClsPrefix}-data-table-td--fixed-${column.fixed}`,
              column.align && `${mergedClsPrefix}-data-table-td--${column.align}-align`,
              column.type === "selection" && `${mergedClsPrefix}-data-table-td--selection`,
              column.type === "expand" && `${mergedClsPrefix}-data-table-td--expand`,
              isLastCol && `${mergedClsPrefix}-data-table-td--last-col`,
              isLastRow && `${mergedClsPrefix}-data-table-td--last-row`
            ] }), hasChildren && colIndex === childTriggerColIndex ? [
              repeat(isSummary ? 0 : rowInfo.tmNode.level, h$1("div", { class: `${mergedClsPrefix}-data-table-indent`, style: indentStyle })),
              isSummary || rowInfo.tmNode.isLeaf ? h$1("div", { class: `${mergedClsPrefix}-data-table-expand-placeholder` }) : h$1(ExpandTrigger, { class: `${mergedClsPrefix}-data-table-expand-trigger`, clsPrefix: mergedClsPrefix, expanded, renderExpandIcon: this.renderExpandIcon, loading: loadingKeySet.has(rowInfo.key), onClick: () => {
                handleUpdateExpanded(rowKey, rowInfo.tmNode);
              } })
            ] : null, column.type === "selection" ? !isSummary ? column.multiple === false ? h$1(RenderSafeRadio, { key: currentPage, rowKey, disabled: rowInfo.tmNode.disabled, onUpdateChecked: () => {
              handleRadioUpdateChecked(rowInfo.tmNode);
            } }) : h$1(RenderSafeCheckbox, { key: currentPage, rowKey, disabled: rowInfo.tmNode.disabled, onUpdateChecked: (checked, e25) => {
              handleCheckboxUpdateChecked(rowInfo.tmNode, checked, e25.shiftKey);
            } }) : null : column.type === "expand" ? !isSummary ? !column.expandable || ((_e2 = column.expandable) === null || _e2 === void 0 ? void 0 : _e2.call(column, rowData)) ? h$1(ExpandTrigger, { clsPrefix: mergedClsPrefix, expanded, renderExpandIcon: this.renderExpandIcon, onClick: () => {
              handleUpdateExpanded(rowKey, null);
            } }) : null : null : h$1(Cell, { clsPrefix: mergedClsPrefix, index: actualRowIndex, row: rowData, column, isSummary, mergedTheme: mergedTheme2, renderCell: this.renderCell }));
          }));
          return row;
        };
        if (!virtualScroll) {
          return h$1("table", { class: `${mergedClsPrefix}-data-table-table`, onMouseleave: handleMouseleaveTable, onMouseenter: handleMouseenterTable, style: {
            tableLayout: this.mergedTableLayout
          } }, h$1("colgroup", null, cols.map((col) => h$1("col", { key: col.key, style: col.style }))), this.showHeader ? h$1(TableHeader, { discrete: false }) : null, !this.empty ? h$1("tbody", { "data-n-id": componentId, class: `${mergedClsPrefix}-data-table-tbody` }, displayedData.map((rowInfo, displayedRowIndex) => {
            return renderRow(rowInfo, displayedRowIndex, false);
          })) : null);
        } else {
          return h$1(VirtualList, { ref: "virtualListRef", items: displayedData, itemSize: 28, visibleItemsTag: VirtualListItemWrapper, visibleItemsProps: {
            clsPrefix: mergedClsPrefix,
            id: componentId,
            cols,
            onMouseenter: handleMouseenterTable,
            onMouseleave: handleMouseleaveTable
          }, showScrollbar: false, onResize: this.handleVirtualListResize, onScroll: this.handleVirtualListScroll, itemsStyle: contentStyle, itemResizable: true }, {
            default: ({ item, index: index2 }) => renderRow(item, index2, true)
          });
        }
      }
    });
    if (this.empty) {
      const createEmptyNode = () => h$1("div", { class: [
        `${mergedClsPrefix}-data-table-empty`,
        this.loading && `${mergedClsPrefix}-data-table-empty--hide`
      ], style: this.bodyStyle, ref: "emptyElRef" }, resolveSlot(this.dataTableSlots.empty, () => [
        h$1(NEmpty, { theme: this.mergedTheme.peers.Empty, themeOverrides: this.mergedTheme.peerOverrides.Empty })
      ]));
      if (this.shouldDisplaySomeTablePart) {
        return h$1(Fragment, null, tableNode, createEmptyNode());
      } else {
        return h$1(VResizeObserver, { onResize: this.onResize }, { default: createEmptyNode });
      }
    }
    return tableNode;
  }
});
var MainTable = defineComponent({
  setup() {
    const {
      mergedClsPrefixRef,
      rightFixedColumnsRef,
      leftFixedColumnsRef,
      bodyWidthRef,
      maxHeightRef,
      minHeightRef,
      flexHeightRef,
      syncScrollState
    } = inject(dataTableInjectionKey);
    const headerInstRef = ref(null);
    const bodyInstRef = ref(null);
    const selfElRef = ref(null);
    const fixedStateInitializedRef = ref(!(leftFixedColumnsRef.value.length || rightFixedColumnsRef.value.length));
    const bodyStyleRef = computed(() => {
      return {
        maxHeight: formatLength(maxHeightRef.value),
        minHeight: formatLength(minHeightRef.value)
      };
    });
    function handleBodyResize(entry) {
      bodyWidthRef.value = entry.contentRect.width;
      syncScrollState();
      if (!fixedStateInitializedRef.value) {
        fixedStateInitializedRef.value = true;
      }
    }
    function getHeaderElement() {
      const { value: value2 } = headerInstRef;
      if (value2) {
        return value2.$el;
      }
      return null;
    }
    function getBodyElement() {
      const { value: value2 } = bodyInstRef;
      if (value2) {
        return value2.getScrollContainer();
      }
      return null;
    }
    const exposedMethods = {
      getBodyElement,
      getHeaderElement,
      scrollTo(arg0, arg1) {
        var _a2;
        (_a2 = bodyInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollTo(arg0, arg1);
      }
    };
    watchEffect(() => {
      const { value: selfEl } = selfElRef;
      if (!selfEl)
        return;
      const transitionDisabledClass = `${mergedClsPrefixRef.value}-data-table-base-table--transition-disabled`;
      if (fixedStateInitializedRef.value) {
        setTimeout(() => {
          selfEl.classList.remove(transitionDisabledClass);
        }, 0);
      } else {
        selfEl.classList.add(transitionDisabledClass);
      }
    });
    return Object.assign({
      maxHeight: maxHeightRef,
      mergedClsPrefix: mergedClsPrefixRef,
      selfElRef,
      headerInstRef,
      bodyInstRef,
      bodyStyle: bodyStyleRef,
      flexHeight: flexHeightRef,
      handleBodyResize
    }, exposedMethods);
  },
  render() {
    const { mergedClsPrefix, maxHeight, flexHeight } = this;
    const headerInBody = maxHeight === void 0 && !flexHeight;
    return h$1("div", { class: `${mergedClsPrefix}-data-table-base-table`, ref: "selfElRef" }, headerInBody ? null : h$1(TableHeader, { ref: "headerInstRef" }), h$1(TableBody, { ref: "bodyInstRef", bodyStyle: this.bodyStyle, showHeader: headerInBody, flexHeight, onResize: this.handleBodyResize }));
  }
});
function useCheck(props, data) {
  const { paginatedDataRef, treeMateRef, selectionColumnRef } = data;
  const uncontrolledCheckedRowKeysRef = ref(props.defaultCheckedRowKeys);
  const mergedCheckState = computed(() => {
    var _a2;
    const { checkedRowKeys } = props;
    const sourceKeys = checkedRowKeys === void 0 ? uncontrolledCheckedRowKeysRef.value : checkedRowKeys;
    if (((_a2 = selectionColumnRef.value) === null || _a2 === void 0 ? void 0 : _a2.multiple) === false) {
      return {
        checkedKeys: sourceKeys.slice(0, 1),
        indeterminateKeys: []
      };
    }
    return treeMateRef.value.getCheckedKeys(sourceKeys, {
      cascade: props.cascade,
      allowNotLoaded: props.allowCheckingNotLoaded
    });
  });
  const mergedCheckedRowKeysRef = computed(() => mergedCheckState.value.checkedKeys);
  const mergedInderminateRowKeysRef = computed(() => mergedCheckState.value.indeterminateKeys);
  const mergedCheckedRowKeySetRef = computed(() => {
    return new Set(mergedCheckedRowKeysRef.value);
  });
  const mergedInderminateRowKeySetRef = computed(() => {
    return new Set(mergedInderminateRowKeysRef.value);
  });
  const countOfCurrentPageCheckedRowsRef = computed(() => {
    const { value: mergedCheckedRowKeySet } = mergedCheckedRowKeySetRef;
    return paginatedDataRef.value.reduce((total, tmNode) => {
      const { key, disabled } = tmNode;
      return total + (!disabled && mergedCheckedRowKeySet.has(key) ? 1 : 0);
    }, 0);
  });
  const countOfCurrentPageDisabledRowsRef = computed(() => {
    return paginatedDataRef.value.filter((item) => item.disabled).length;
  });
  const someRowsCheckedRef = computed(() => {
    const { length: length2 } = paginatedDataRef.value;
    const { value: mergedInderminateRowKeySet } = mergedInderminateRowKeySetRef;
    return countOfCurrentPageCheckedRowsRef.value > 0 && countOfCurrentPageCheckedRowsRef.value < length2 - countOfCurrentPageDisabledRowsRef.value || paginatedDataRef.value.some((rowData) => mergedInderminateRowKeySet.has(rowData.key));
  });
  const allRowsCheckedRef = computed(() => {
    const { length: length2 } = paginatedDataRef.value;
    return countOfCurrentPageCheckedRowsRef.value !== 0 && countOfCurrentPageCheckedRowsRef.value === length2 - countOfCurrentPageDisabledRowsRef.value;
  });
  const headerCheckboxDisabledRef = computed(() => {
    return paginatedDataRef.value.length === 0;
  });
  function doUpdateCheckedRowKeys(keys2, row, action) {
    const { "onUpdate:checkedRowKeys": _onUpdateCheckedRowKeys, onUpdateCheckedRowKeys, onCheckedRowKeysChange } = props;
    const rows = [];
    const { value: { getNode: getNode2 } } = treeMateRef;
    keys2.forEach((key) => {
      var _a2;
      const row2 = (_a2 = getNode2(key)) === null || _a2 === void 0 ? void 0 : _a2.rawNode;
      rows.push(row2);
    });
    if (_onUpdateCheckedRowKeys) {
      call(_onUpdateCheckedRowKeys, keys2, rows, { row, action });
    }
    if (onUpdateCheckedRowKeys) {
      call(onUpdateCheckedRowKeys, keys2, rows, { row, action });
    }
    if (onCheckedRowKeysChange) {
      call(onCheckedRowKeysChange, keys2, rows, { row, action });
    }
    uncontrolledCheckedRowKeysRef.value = keys2;
  }
  function doCheck(rowKey, single = false, rowInfo) {
    if (props.loading)
      return;
    if (single) {
      doUpdateCheckedRowKeys(Array.isArray(rowKey) ? rowKey.slice(0, 1) : [rowKey], rowInfo, "check");
      return;
    }
    doUpdateCheckedRowKeys(treeMateRef.value.check(rowKey, mergedCheckedRowKeysRef.value, {
      cascade: props.cascade,
      allowNotLoaded: props.allowCheckingNotLoaded
    }).checkedKeys, rowInfo, "check");
  }
  function doUncheck(rowKey, rowInfo) {
    if (props.loading)
      return;
    doUpdateCheckedRowKeys(treeMateRef.value.uncheck(rowKey, mergedCheckedRowKeysRef.value, {
      cascade: props.cascade,
      allowNotLoaded: props.allowCheckingNotLoaded
    }).checkedKeys, rowInfo, "uncheck");
  }
  function doCheckAll(checkWholeTable = false) {
    const { value: column } = selectionColumnRef;
    if (!column || props.loading)
      return;
    const rowKeysToCheck = [];
    (checkWholeTable ? treeMateRef.value.treeNodes : paginatedDataRef.value).forEach((tmNode) => {
      if (!tmNode.disabled) {
        rowKeysToCheck.push(tmNode.key);
      }
    });
    doUpdateCheckedRowKeys(treeMateRef.value.check(rowKeysToCheck, mergedCheckedRowKeysRef.value, {
      cascade: true,
      allowNotLoaded: props.allowCheckingNotLoaded
    }).checkedKeys, void 0, "checkAll");
  }
  function doUncheckAll(checkWholeTable = false) {
    const { value: column } = selectionColumnRef;
    if (!column || props.loading)
      return;
    const rowKeysToUncheck = [];
    (checkWholeTable ? treeMateRef.value.treeNodes : paginatedDataRef.value).forEach((tmNode) => {
      if (!tmNode.disabled) {
        rowKeysToUncheck.push(tmNode.key);
      }
    });
    doUpdateCheckedRowKeys(treeMateRef.value.uncheck(rowKeysToUncheck, mergedCheckedRowKeysRef.value, {
      cascade: true,
      allowNotLoaded: props.allowCheckingNotLoaded
    }).checkedKeys, void 0, "uncheckAll");
  }
  return {
    mergedCheckedRowKeySetRef,
    mergedCheckedRowKeysRef,
    mergedInderminateRowKeySetRef,
    someRowsCheckedRef,
    allRowsCheckedRef,
    headerCheckboxDisabledRef,
    doUpdateCheckedRowKeys,
    doCheckAll,
    doUncheckAll,
    doCheck,
    doUncheck
  };
}
function getMultiplePriority(sorter) {
  if (typeof sorter === "object" && typeof sorter.multiple === "number") {
    return sorter.multiple;
  }
  return false;
}
function getSortFunction(sorter, columnKey) {
  if (columnKey && (sorter === void 0 || sorter === "default" || typeof sorter === "object" && sorter.compare === "default")) {
    return getDefaultSorterFn(columnKey);
  }
  if (typeof sorter === "function") {
    return sorter;
  }
  if (sorter && typeof sorter === "object" && sorter.compare && sorter.compare !== "default") {
    return sorter.compare;
  }
  return false;
}
function getDefaultSorterFn(columnKey) {
  return (row1, row2) => {
    const value1 = row1[columnKey];
    const value2 = row2[columnKey];
    if (typeof value1 === "number" && typeof value2 === "number") {
      return value1 - value2;
    } else if (typeof value1 === "string" && typeof value2 === "string") {
      return value1.localeCompare(value2);
    }
    return 0;
  };
}
function useSorter(props, { dataRelatedColsRef, filteredDataRef }) {
  const defaultSortState = [];
  dataRelatedColsRef.value.forEach((column) => {
    var _a2;
    if (column.sorter !== void 0) {
      updateSortStatesByNewSortState(defaultSortState, {
        columnKey: column.key,
        sorter: column.sorter,
        order: (_a2 = column.defaultSortOrder) !== null && _a2 !== void 0 ? _a2 : false
      });
    }
  });
  const uncontrolledSortStateRef = ref(defaultSortState);
  const mergedSortStateRef = computed(() => {
    const columnsWithControlledSortOrder = dataRelatedColsRef.value.filter((column) => column.type !== "selection" && column.sorter !== void 0 && (column.sortOrder === "ascend" || column.sortOrder === "descend" || column.sortOrder === false));
    const columnToSort = columnsWithControlledSortOrder.filter((col) => col.sortOrder !== false);
    if (columnToSort.length) {
      return columnToSort.map((column) => {
        return {
          columnKey: column.key,
          order: column.sortOrder,
          sorter: column.sorter
        };
      });
    }
    if (columnsWithControlledSortOrder.length)
      return [];
    const { value: uncontrolledSortState } = uncontrolledSortStateRef;
    if (Array.isArray(uncontrolledSortState)) {
      return uncontrolledSortState;
    } else if (uncontrolledSortState) {
      return [uncontrolledSortState];
    } else {
      return [];
    }
  });
  const sortedDataRef = computed(() => {
    const activeSorters = mergedSortStateRef.value.slice().sort((a2, b2) => {
      const item1Priority = getMultiplePriority(a2.sorter) || 0;
      const item2Priority = getMultiplePriority(b2.sorter) || 0;
      return item2Priority - item1Priority;
    });
    if (activeSorters.length) {
      const filteredData = filteredDataRef.value.slice();
      return filteredData.sort((tmNode1, tmNode2) => {
        let compareResult = 0;
        activeSorters.some((sorterState) => {
          const { columnKey, sorter, order } = sorterState;
          const compareFn = getSortFunction(sorter, columnKey);
          if (compareFn && order) {
            compareResult = compareFn(tmNode1.rawNode, tmNode2.rawNode);
            if (compareResult !== 0) {
              compareResult = compareResult * getFlagOfOrder(order);
              return true;
            }
          }
          return false;
        });
        return compareResult;
      });
    }
    return filteredDataRef.value;
  });
  function getUpdatedSorterState(sortState) {
    let currentSortState = mergedSortStateRef.value.slice();
    if (sortState && getMultiplePriority(sortState.sorter) !== false) {
      currentSortState = currentSortState.filter((sortState2) => getMultiplePriority(sortState2.sorter) !== false);
      updateSortStatesByNewSortState(currentSortState, sortState);
      return currentSortState;
    } else if (sortState) {
      return sortState;
    }
    return null;
  }
  function deriveNextSorter(sortState) {
    const nextSorterState = getUpdatedSorterState(sortState);
    doUpdateSorter(nextSorterState);
  }
  function doUpdateSorter(sortState) {
    const { "onUpdate:sorter": _onUpdateSorter, onUpdateSorter, onSorterChange } = props;
    if (_onUpdateSorter) {
      call(_onUpdateSorter, sortState);
    }
    if (onUpdateSorter) {
      call(onUpdateSorter, sortState);
    }
    if (onSorterChange) {
      call(onSorterChange, sortState);
    }
    uncontrolledSortStateRef.value = sortState;
  }
  function sort(columnKey, order = "ascend") {
    if (!columnKey) {
      clearSorter();
    } else {
      const columnToSort = dataRelatedColsRef.value.find((column) => column.type !== "selection" && column.type !== "expand" && column.key === columnKey);
      if (!(columnToSort === null || columnToSort === void 0 ? void 0 : columnToSort.sorter))
        return;
      const sorter = columnToSort.sorter;
      deriveNextSorter({
        columnKey,
        sorter,
        order
      });
    }
  }
  function clearSorter() {
    doUpdateSorter(null);
  }
  function updateSortStatesByNewSortState(sortStates, sortState) {
    const index2 = sortStates.findIndex((state) => (sortState === null || sortState === void 0 ? void 0 : sortState.columnKey) && state.columnKey === sortState.columnKey);
    if (index2 !== void 0 && index2 >= 0) {
      sortStates[index2] = sortState;
    } else {
      sortStates.push(sortState);
    }
  }
  return {
    clearSorter,
    sort,
    sortedDataRef,
    mergedSortStateRef,
    deriveNextSorter
  };
}
function useTableData(props, { dataRelatedColsRef }) {
  const selectionColumnRef = computed(() => {
    const getSelectionColumn = (cols) => {
      for (let i2 = 0; i2 < cols.length; ++i2) {
        const col = cols[i2];
        if ("children" in col) {
          return getSelectionColumn(col.children);
        } else if (col.type === "selection") {
          return col;
        }
      }
      return null;
    };
    return getSelectionColumn(props.columns);
  });
  const treeMateRef = computed(() => {
    const { childrenKey } = props;
    return createTreeMate(props.data, {
      ignoreEmptyChildren: true,
      getKey: props.rowKey,
      getChildren: (rowData) => rowData[childrenKey],
      getDisabled: (rowData) => {
        var _a2, _b2;
        if ((_b2 = (_a2 = selectionColumnRef.value) === null || _a2 === void 0 ? void 0 : _a2.disabled) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, rowData)) {
          return true;
        }
        return false;
      }
    });
  });
  const childTriggerColIndexRef = useMemo(() => {
    const { columns } = props;
    const { length: length2 } = columns;
    let firstContentfulColIndex = null;
    for (let i2 = 0; i2 < length2; ++i2) {
      const col = columns[i2];
      if (!col.type && firstContentfulColIndex === null) {
        firstContentfulColIndex = i2;
      }
      if ("tree" in col && col.tree) {
        return i2;
      }
    }
    return firstContentfulColIndex || 0;
  });
  const uncontrolledFilterStateRef = ref({});
  const uncontrolledCurrentPageRef = ref(1);
  const uncontrolledPageSizeRef = ref(10);
  const mergedFilterStateRef = computed(() => {
    const columnsWithControlledFilter = dataRelatedColsRef.value.filter((column) => {
      return column.filterOptionValues !== void 0 || column.filterOptionValue !== void 0;
    });
    const controlledFilterState = {};
    columnsWithControlledFilter.forEach((column) => {
      var _a2;
      if (column.type === "selection" || column.type === "expand")
        return;
      if (column.filterOptionValues === void 0) {
        controlledFilterState[column.key] = (_a2 = column.filterOptionValue) !== null && _a2 !== void 0 ? _a2 : null;
      } else {
        controlledFilterState[column.key] = column.filterOptionValues;
      }
    });
    const activeFilters = Object.assign(createShallowClonedObject(uncontrolledFilterStateRef.value), controlledFilterState);
    return activeFilters;
  });
  const filteredDataRef = computed(() => {
    const mergedFilterState = mergedFilterStateRef.value;
    const { columns } = props;
    function createDefaultFilter(columnKey) {
      return (filterOptionValue, row) => !!~String(row[columnKey]).indexOf(String(filterOptionValue));
    }
    const { value: { treeNodes: data } } = treeMateRef;
    const columnEntries = [];
    columns.forEach((column) => {
      if (column.type === "selection" || column.type === "expand" || "children" in column) {
        return;
      }
      columnEntries.push([column.key, column]);
    });
    return data ? data.filter((tmNode) => {
      const { rawNode: row } = tmNode;
      for (const [columnKey, column] of columnEntries) {
        let activeFilterOptionValues = mergedFilterState[columnKey];
        if (activeFilterOptionValues == null)
          continue;
        if (!Array.isArray(activeFilterOptionValues)) {
          activeFilterOptionValues = [activeFilterOptionValues];
        }
        if (!activeFilterOptionValues.length)
          continue;
        const filter2 = column.filter === "default" ? createDefaultFilter(columnKey) : column.filter;
        if (column && typeof filter2 === "function") {
          if (column.filterMode === "and") {
            if (activeFilterOptionValues.some((filterOptionValue) => !filter2(filterOptionValue, row))) {
              return false;
            }
          } else {
            if (activeFilterOptionValues.some((filterOptionValue) => filter2(filterOptionValue, row))) {
              continue;
            } else {
              return false;
            }
          }
        }
      }
      return true;
    }) : [];
  });
  const { sortedDataRef, deriveNextSorter, mergedSortStateRef, sort, clearSorter } = useSorter(props, {
    dataRelatedColsRef,
    filteredDataRef
  });
  dataRelatedColsRef.value.forEach((column) => {
    var _a2;
    if (column.filter) {
      const defaultFilterOptionValues = column.defaultFilterOptionValues;
      if (column.filterMultiple) {
        uncontrolledFilterStateRef.value[column.key] = defaultFilterOptionValues || [];
      } else if (defaultFilterOptionValues !== void 0) {
        uncontrolledFilterStateRef.value[column.key] = defaultFilterOptionValues === null ? [] : defaultFilterOptionValues;
      } else {
        uncontrolledFilterStateRef.value[column.key] = (_a2 = column.defaultFilterOptionValue) !== null && _a2 !== void 0 ? _a2 : null;
      }
    }
  });
  const controlledCurrentPageRef = computed(() => {
    const { pagination } = props;
    if (pagination === false)
      return void 0;
    return pagination.page;
  });
  const controlledPageSizeRef = computed(() => {
    const { pagination } = props;
    if (pagination === false)
      return void 0;
    return pagination.pageSize;
  });
  const _mergedCurrentPageRef = useMergedState(controlledCurrentPageRef, uncontrolledCurrentPageRef);
  const mergedPageSizeRef = useMergedState(controlledPageSizeRef, uncontrolledPageSizeRef);
  const boundedMergedCurrentPageRef = useMemo(() => {
    const page3 = _mergedCurrentPageRef.value;
    return props.remote ? page3 : Math.max(1, Math.min(Math.ceil(filteredDataRef.value.length / mergedPageSizeRef.value), page3));
  });
  const mergedPageCountRef = computed(() => {
    const { pagination } = props;
    if (pagination) {
      const { pageCount } = pagination;
      if (pageCount !== void 0)
        return pageCount;
    }
    return void 0;
  });
  const paginatedDataRef = computed(() => {
    if (props.remote)
      return treeMateRef.value.treeNodes;
    if (!props.pagination)
      return sortedDataRef.value;
    const pageSize = mergedPageSizeRef.value;
    const startIndex = (boundedMergedCurrentPageRef.value - 1) * pageSize;
    return sortedDataRef.value.slice(startIndex, startIndex + pageSize);
  });
  const rawPaginatedDataRef = computed(() => {
    return paginatedDataRef.value.map((tmNode) => tmNode.rawNode);
  });
  function mergedOnUpdatePage(page3) {
    const { pagination } = props;
    if (pagination) {
      const { onChange, "onUpdate:page": _onUpdatePage, onUpdatePage } = pagination;
      if (onChange)
        call(onChange, page3);
      if (onUpdatePage)
        call(onUpdatePage, page3);
      if (_onUpdatePage)
        call(_onUpdatePage, page3);
      doUpdatePage(page3);
    }
  }
  function mergedOnUpdatePageSize(pageSize) {
    const { pagination } = props;
    if (pagination) {
      const { onPageSizeChange, "onUpdate:pageSize": _onUpdatePageSize, onUpdatePageSize } = pagination;
      if (onPageSizeChange)
        call(onPageSizeChange, pageSize);
      if (onUpdatePageSize)
        call(onUpdatePageSize, pageSize);
      if (_onUpdatePageSize)
        call(_onUpdatePageSize, pageSize);
      doUpdatePageSize(pageSize);
    }
  }
  const mergedItemCountRef = computed(() => {
    if (props.remote) {
      const { pagination } = props;
      if (pagination) {
        const { itemCount } = pagination;
        if (itemCount !== void 0)
          return itemCount;
      }
      return void 0;
    }
    return filteredDataRef.value.length;
  });
  const mergedPaginationRef = computed(() => {
    return Object.assign(Object.assign({}, props.pagination), {
      onChange: void 0,
      onUpdatePage: void 0,
      onUpdatePageSize: void 0,
      onPageSizeChange: void 0,
      "onUpdate:page": mergedOnUpdatePage,
      "onUpdate:pageSize": mergedOnUpdatePageSize,
      page: boundedMergedCurrentPageRef.value,
      pageSize: mergedPageSizeRef.value,
      pageCount: mergedItemCountRef.value === void 0 ? mergedPageCountRef.value : void 0,
      itemCount: mergedItemCountRef.value
    });
  });
  function doUpdatePage(page3) {
    const { "onUpdate:page": _onUpdatePage, onPageChange, onUpdatePage } = props;
    if (onUpdatePage)
      call(onUpdatePage, page3);
    if (_onUpdatePage)
      call(_onUpdatePage, page3);
    if (onPageChange)
      call(onPageChange, page3);
    uncontrolledCurrentPageRef.value = page3;
  }
  function doUpdatePageSize(pageSize) {
    const { "onUpdate:pageSize": _onUpdatePageSize, onPageSizeChange, onUpdatePageSize } = props;
    if (onPageSizeChange)
      call(onPageSizeChange, pageSize);
    if (onUpdatePageSize)
      call(onUpdatePageSize, pageSize);
    if (_onUpdatePageSize)
      call(_onUpdatePageSize, pageSize);
    uncontrolledPageSizeRef.value = pageSize;
  }
  function doUpdateFilters(filters2, sourceColumn) {
    const { onUpdateFilters, "onUpdate:filters": _onUpdateFilters, onFiltersChange } = props;
    if (onUpdateFilters)
      call(onUpdateFilters, filters2, sourceColumn);
    if (_onUpdateFilters)
      call(_onUpdateFilters, filters2, sourceColumn);
    if (onFiltersChange)
      call(onFiltersChange, filters2, sourceColumn);
    uncontrolledFilterStateRef.value = filters2;
  }
  function onUnstableColumnResize(resizedWidth, limitedWidth, column, getColumnWidth) {
    var _a2;
    (_a2 = props.onUnstableColumnResize) === null || _a2 === void 0 ? void 0 : _a2.call(props, resizedWidth, limitedWidth, column, getColumnWidth);
  }
  function page2(page3) {
    doUpdatePage(page3);
  }
  function clearFilter() {
    clearFilters();
  }
  function clearFilters() {
    filters({});
  }
  function filters(filters2) {
    filter(filters2);
  }
  function filter(filters2) {
    if (!filters2) {
      uncontrolledFilterStateRef.value = {};
    } else if (filters2) {
      uncontrolledFilterStateRef.value = createShallowClonedObject(filters2);
    } else
      ;
  }
  return {
    treeMateRef,
    mergedCurrentPageRef: boundedMergedCurrentPageRef,
    mergedPaginationRef,
    paginatedDataRef,
    rawPaginatedDataRef,
    mergedFilterStateRef,
    mergedSortStateRef,
    hoverKeyRef: ref(null),
    selectionColumnRef,
    childTriggerColIndexRef,
    doUpdateFilters,
    deriveNextSorter,
    doUpdatePageSize,
    doUpdatePage,
    onUnstableColumnResize,
    filter,
    filters,
    clearFilter,
    clearFilters,
    clearSorter,
    page: page2,
    sort
  };
}
function useScroll(props, { mainTableInstRef, mergedCurrentPageRef, bodyWidthRef, scrollPartRef }) {
  let scrollLeft = 0;
  const leftActiveFixedColKeyRef = ref(null);
  const leftActiveFixedChildrenColKeysRef = ref([]);
  const rightActiveFixedColKeyRef = ref(null);
  const rightActiveFixedChildrenColKeysRef = ref([]);
  const styleScrollXRef = computed(() => {
    return formatLength(props.scrollX);
  });
  const leftFixedColumnsRef = computed(() => {
    return props.columns.filter((column) => column.fixed === "left");
  });
  const rightFixedColumnsRef = computed(() => {
    return props.columns.filter((column) => column.fixed === "right");
  });
  const fixedColumnLeftMapRef = computed(() => {
    const columns = {};
    let left = 0;
    function traverse(cols) {
      cols.forEach((col) => {
        const positionInfo = { start: left, end: 0 };
        columns[getColKey(col)] = positionInfo;
        if ("children" in col) {
          traverse(col.children);
          positionInfo.end = left;
        } else {
          left += getNumberColWidth(col) || 0;
          positionInfo.end = left;
        }
      });
    }
    traverse(leftFixedColumnsRef.value);
    return columns;
  });
  const fixedColumnRightMapRef = computed(() => {
    const columns = {};
    let right = 0;
    function traverse(cols) {
      for (let i2 = cols.length - 1; i2 >= 0; --i2) {
        const col = cols[i2];
        const positionInfo = { start: right, end: 0 };
        columns[getColKey(col)] = positionInfo;
        if ("children" in col) {
          traverse(col.children);
          positionInfo.end = right;
        } else {
          right += getNumberColWidth(col) || 0;
          positionInfo.end = right;
        }
      }
    }
    traverse(rightFixedColumnsRef.value);
    return columns;
  });
  function deriveActiveLeftFixedColumn() {
    var _a2, _b2;
    const { value: leftFixedColumns } = leftFixedColumnsRef;
    let leftWidth = 0;
    const { value: fixedColumnLeftMap } = fixedColumnLeftMapRef;
    let leftActiveFixedColKey = null;
    for (let i2 = 0; i2 < leftFixedColumns.length; ++i2) {
      const key = getColKey(leftFixedColumns[i2]);
      if (scrollLeft > (((_a2 = fixedColumnLeftMap[key]) === null || _a2 === void 0 ? void 0 : _a2.start) || 0) - leftWidth) {
        leftActiveFixedColKey = key;
        leftWidth = ((_b2 = fixedColumnLeftMap[key]) === null || _b2 === void 0 ? void 0 : _b2.end) || 0;
      } else {
        break;
      }
    }
    leftActiveFixedColKeyRef.value = leftActiveFixedColKey;
  }
  function deriveActiveLeftFixedChildrenColumns() {
    leftActiveFixedChildrenColKeysRef.value = [];
    let activeLeftFixedColumn = props.columns.find((col) => getColKey(col) === leftActiveFixedColKeyRef.value);
    while (activeLeftFixedColumn && "children" in activeLeftFixedColumn) {
      const length2 = activeLeftFixedColumn.children.length;
      if (length2 === 0)
        break;
      const nextActiveLeftFixedColumn = activeLeftFixedColumn.children[length2 - 1];
      leftActiveFixedChildrenColKeysRef.value.push(getColKey(nextActiveLeftFixedColumn));
      activeLeftFixedColumn = nextActiveLeftFixedColumn;
    }
  }
  function deriveActiveRightFixedColumn() {
    var _a2, _b2;
    const { value: rightFixedColumns } = rightFixedColumnsRef;
    const scrollWidth = Number(props.scrollX);
    const { value: tableWidth } = bodyWidthRef;
    if (tableWidth === null)
      return;
    let rightWidth = 0;
    let rightActiveFixedColKey = null;
    const { value: fixedColumnRightMap } = fixedColumnRightMapRef;
    for (let i2 = rightFixedColumns.length - 1; i2 >= 0; --i2) {
      const key = getColKey(rightFixedColumns[i2]);
      if (Math.round(scrollLeft + (((_a2 = fixedColumnRightMap[key]) === null || _a2 === void 0 ? void 0 : _a2.start) || 0) + tableWidth - rightWidth) < scrollWidth) {
        rightActiveFixedColKey = key;
        rightWidth = ((_b2 = fixedColumnRightMap[key]) === null || _b2 === void 0 ? void 0 : _b2.end) || 0;
      } else {
        break;
      }
    }
    rightActiveFixedColKeyRef.value = rightActiveFixedColKey;
  }
  function deriveActiveRightFixedChildrenColumns() {
    rightActiveFixedChildrenColKeysRef.value = [];
    let activeRightFixedColumn = props.columns.find((col) => getColKey(col) === rightActiveFixedColKeyRef.value);
    while (activeRightFixedColumn && "children" in activeRightFixedColumn && activeRightFixedColumn.children.length) {
      const nextActiveRightFixedColumn = activeRightFixedColumn.children[0];
      rightActiveFixedChildrenColKeysRef.value.push(getColKey(nextActiveRightFixedColumn));
      activeRightFixedColumn = nextActiveRightFixedColumn;
    }
  }
  function getScrollElements() {
    const header = mainTableInstRef.value ? mainTableInstRef.value.getHeaderElement() : null;
    const body = mainTableInstRef.value ? mainTableInstRef.value.getBodyElement() : null;
    return {
      header,
      body
    };
  }
  function scrollMainTableBodyToTop() {
    const { body } = getScrollElements();
    if (body) {
      body.scrollTop = 0;
    }
  }
  function handleTableHeaderScroll() {
    if (scrollPartRef.value === "head") {
      beforeNextFrameOnce(syncScrollState);
    }
  }
  function handleTableBodyScroll(e25) {
    var _a2;
    (_a2 = props.onScroll) === null || _a2 === void 0 ? void 0 : _a2.call(props, e25);
    if (scrollPartRef.value === "body") {
      beforeNextFrameOnce(syncScrollState);
    }
  }
  function syncScrollState() {
    const { header, body } = getScrollElements();
    if (!body)
      return;
    const { value: tableWidth } = bodyWidthRef;
    if (tableWidth === null)
      return;
    const { value: scrollPart } = scrollPartRef;
    if (props.maxHeight || props.flexHeight) {
      if (!header)
        return;
      if (scrollPart === "head") {
        scrollLeft = header.scrollLeft;
        body.scrollLeft = scrollLeft;
      } else {
        scrollLeft = body.scrollLeft;
        header.scrollLeft = scrollLeft;
      }
    } else {
      scrollLeft = body.scrollLeft;
    }
    deriveActiveLeftFixedColumn();
    deriveActiveLeftFixedChildrenColumns();
    deriveActiveRightFixedColumn();
    deriveActiveRightFixedChildrenColumns();
  }
  function setHeaderScrollLeft(left) {
    const { header } = getScrollElements();
    if (!header)
      return;
    header.scrollLeft = left;
    syncScrollState();
  }
  watch(mergedCurrentPageRef, () => {
    scrollMainTableBodyToTop();
  });
  return {
    styleScrollXRef,
    fixedColumnLeftMapRef,
    fixedColumnRightMapRef,
    leftFixedColumnsRef,
    rightFixedColumnsRef,
    leftActiveFixedColKeyRef,
    leftActiveFixedChildrenColKeysRef,
    rightActiveFixedColKeyRef,
    rightActiveFixedChildrenColKeysRef,
    syncScrollState,
    handleTableBodyScroll,
    handleTableHeaderScroll,
    setHeaderScrollLeft
  };
}
function useResizable() {
  const resizableWidthsRef = ref({});
  function getResizableWidth(key) {
    return resizableWidthsRef.value[key];
  }
  function doUpdateResizableWidth(column, width) {
    if (isColumnResizable(column) && "key" in column) {
      resizableWidthsRef.value[column.key] = width;
    }
  }
  function clearResizableWidth() {
    resizableWidthsRef.value = {};
  }
  return {
    getResizableWidth,
    doUpdateResizableWidth,
    clearResizableWidth
  };
}
function getRowsAndCols(columns, getResizableWidth) {
  const rows = [];
  const cols = [];
  const dataRelatedCols = [];
  const rowItemMap = new WeakMap();
  let maxDepth = -1;
  let totalRowSpan = 0;
  let hasEllipsis = false;
  function ensureMaxDepth(columns2, currentDepth) {
    if (currentDepth > maxDepth) {
      rows[currentDepth] = [];
      maxDepth = currentDepth;
    }
    for (const column of columns2) {
      if ("children" in column) {
        ensureMaxDepth(column.children, currentDepth + 1);
      } else {
        const key = "key" in column ? column.key : void 0;
        cols.push({
          key: getColKey(column),
          style: createCustomWidthStyle(column, key !== void 0 ? formatLength(getResizableWidth(key)) : void 0),
          column
        });
        totalRowSpan += 1;
        if (!hasEllipsis) {
          hasEllipsis = !!column.ellipsis;
        }
        dataRelatedCols.push(column);
      }
    }
  }
  ensureMaxDepth(columns, 0);
  let currentLeafIndex = 0;
  function ensureColLayout(columns2, currentDepth) {
    let hideUntilIndex = 0;
    columns2.forEach((column, index2) => {
      var _a2;
      if ("children" in column) {
        const cachedCurrentLeafIndex = currentLeafIndex;
        const rowItem = {
          column,
          colSpan: 0,
          rowSpan: 1,
          isLast: false
        };
        ensureColLayout(column.children, currentDepth + 1);
        column.children.forEach((childColumn) => {
          var _a3, _b2;
          rowItem.colSpan += (_b2 = (_a3 = rowItemMap.get(childColumn)) === null || _a3 === void 0 ? void 0 : _a3.colSpan) !== null && _b2 !== void 0 ? _b2 : 0;
        });
        if (cachedCurrentLeafIndex + rowItem.colSpan === totalRowSpan) {
          rowItem.isLast = true;
        }
        rowItemMap.set(column, rowItem);
        rows[currentDepth].push(rowItem);
      } else {
        if (currentLeafIndex < hideUntilIndex) {
          currentLeafIndex += 1;
          return;
        }
        let colSpan = 1;
        if ("titleColSpan" in column) {
          colSpan = (_a2 = column.titleColSpan) !== null && _a2 !== void 0 ? _a2 : 1;
        }
        if (colSpan > 1) {
          hideUntilIndex = currentLeafIndex + colSpan;
        }
        const isLast = currentLeafIndex + colSpan === totalRowSpan;
        const rowItem = {
          column,
          colSpan,
          rowSpan: maxDepth - currentDepth + 1,
          isLast
        };
        rowItemMap.set(column, rowItem);
        rows[currentDepth].push(rowItem);
        currentLeafIndex += 1;
      }
    });
  }
  ensureColLayout(columns, 0);
  return {
    hasEllipsis,
    rows,
    cols,
    dataRelatedCols
  };
}
function useGroupHeader(props, getResizableWidth) {
  const rowsAndCols = computed(() => getRowsAndCols(props.columns, getResizableWidth));
  return {
    rowsRef: computed(() => rowsAndCols.value.rows),
    colsRef: computed(() => rowsAndCols.value.cols),
    hasEllipsisRef: computed(() => rowsAndCols.value.hasEllipsis),
    dataRelatedColsRef: computed(() => rowsAndCols.value.dataRelatedCols)
  };
}
function useExpand(props, treeMateRef) {
  const renderExpandRef = useMemo(() => {
    for (const col of props.columns) {
      if (col.type === "expand") {
        return col.renderExpand;
      }
    }
  });
  const expandableRef = useMemo(() => {
    let expandable;
    for (const col of props.columns) {
      if (col.type === "expand") {
        expandable = col.expandable;
        break;
      }
    }
    return expandable;
  });
  const uncontrolledExpandedRowKeysRef = ref(props.defaultExpandAll ? (renderExpandRef === null || renderExpandRef === void 0 ? void 0 : renderExpandRef.value) ? (() => {
    const expandedKeys = [];
    treeMateRef.value.treeNodes.forEach((tmNode) => {
      var _a2;
      if ((_a2 = expandableRef.value) === null || _a2 === void 0 ? void 0 : _a2.call(expandableRef, tmNode.rawNode)) {
        expandedKeys.push(tmNode.key);
      }
    });
    return expandedKeys;
  })() : treeMateRef.value.getNonLeafKeys() : props.defaultExpandedRowKeys);
  const controlledExpandedRowKeysRef = toRef(props, "expandedRowKeys");
  const stickyExpandedRowsRef = toRef(props, "stickyExpandedRows");
  const mergedExpandedRowKeysRef = useMergedState(controlledExpandedRowKeysRef, uncontrolledExpandedRowKeysRef);
  function doUpdateExpandedRowKeys(expandedKeys) {
    const { onUpdateExpandedRowKeys, "onUpdate:expandedRowKeys": _onUpdateExpandedRowKeys } = props;
    if (onUpdateExpandedRowKeys) {
      call(onUpdateExpandedRowKeys, expandedKeys);
    }
    if (_onUpdateExpandedRowKeys) {
      call(_onUpdateExpandedRowKeys, expandedKeys);
    }
    uncontrolledExpandedRowKeysRef.value = expandedKeys;
  }
  return {
    stickyExpandedRowsRef,
    mergedExpandedRowKeysRef,
    renderExpandRef,
    expandableRef,
    doUpdateExpandedRowKeys
  };
}
const fixedColumnStyle = createFixedColumnStyle();
var style$l = c$2([cB$1("data-table", `
 width: 100%;
 font-size: var(--n-font-size);
 display: flex;
 flex-direction: column;
 position: relative;
 --n-merged-th-color: var(--n-th-color);
 --n-merged-td-color: var(--n-td-color);
 --n-merged-border-color: var(--n-border-color);
 --n-merged-th-color-hover: var(--n-th-color-hover);
 --n-merged-td-color-hover: var(--n-td-color-hover);
 --n-merged-td-color-striped: var(--n-td-color-striped);
 `, [cB$1("data-table-wrapper", `
 flex-grow: 1;
 display: flex;
 flex-direction: column;
 `), cM("flex-height", [c$2(">", [cB$1("data-table-wrapper", [c$2(">", [cB$1("data-table-base-table", `
 display: flex;
 flex-direction: column;
 flex-grow: 1;
 `, [c$2(">", [cB$1("data-table-base-table-body", "flex-basis: 0;", [
  c$2("&:last-child", "flex-grow: 1;")
])])])])])])]), c$2(">", [cB$1("data-table-loading-wrapper", `
 color: var(--n-loading-color);
 font-size: var(--n-loading-size);
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 justify-content: center;
 `, [fadeInScaleUpTransition({
  originalTransform: "translateX(-50%) translateY(-50%)"
})])]), cB$1("data-table-expand-placeholder", `
 margin-right: 8px;
 display: inline-block;
 width: 16px;
 height: 1px;
 `), cB$1("data-table-indent", `
 display: inline-block;
 height: 1px;
 `), cB$1("data-table-expand-trigger", `
 display: inline-flex;
 margin-right: 8px;
 cursor: pointer;
 font-size: 16px;
 vertical-align: -0.2em;
 position: relative;
 width: 16px;
 height: 16px;
 color: var(--n-td-text-color);
 transition: color .3s var(--n-bezier);
 `, [cM("expanded", [cB$1("icon", "transform: rotate(90deg);", [iconSwitchTransition({
  originalTransform: "rotate(90deg)"
})]), cB$1("base-icon", "transform: rotate(90deg);", [iconSwitchTransition({
  originalTransform: "rotate(90deg)"
})])]), cB$1("base-loading", `
 color: var(--n-loading-color);
 transition: color .3s var(--n-bezier);
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [iconSwitchTransition()]), cB$1("icon", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [iconSwitchTransition()]), cB$1("base-icon", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [iconSwitchTransition()])]), cB$1("data-table-thead", `
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-merged-th-color);
 `), cB$1("data-table-tr", `
 box-sizing: border-box;
 background-clip: padding-box;
 transition: background-color .3s var(--n-bezier);
 `, [cB$1("data-table-expand", `
 position: sticky;
 left: 0;
 overflow: hidden;
 margin: calc(var(--n-th-padding) * -1);
 padding: var(--n-th-padding);
 box-sizing: border-box;
 `), cM("striped", "background-color: var(--n-merged-td-color-striped);", [cB$1("data-table-td", "background-color: var(--n-merged-td-color-striped);")]), cNotM("summary", [c$2("&:hover", "background-color: var(--n-merged-td-color-hover);", [c$2(">", [cB$1("data-table-td", "background-color: var(--n-merged-td-color-hover);")])])])]), cB$1("data-table-th", `
 padding: var(--n-th-padding);
 position: relative;
 text-align: start;
 box-sizing: border-box;
 background-color: var(--n-merged-th-color);
 border-color: var(--n-merged-border-color);
 border-bottom: 1px solid var(--n-merged-border-color);
 color: var(--n-th-text-color);
 transition:
 border-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 font-weight: var(--n-th-font-weight);
 `, [cM("filterable", `
 padding-right: 36px;
 `, [cM("sortable", `
 padding-right: calc(var(--n-th-padding) + 36px);
 `)]), fixedColumnStyle, cM("selection", `
 padding: 0;
 text-align: center;
 line-height: 0;
 z-index: 3;
 `), cE$1("title-wrapper", `
 display: flex;
 align-items: center;
 flex-wrap: nowrap;
 max-width: 100%;
 `, [cE$1("title", `
 flex: 1;
 min-width: 0;
 `)]), cE$1("ellipsis", `
 display: inline-block;
 vertical-align: bottom;
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap;
 max-width: 100%;
 `), cM("hover", `
 background-color: var(--n-merged-th-color-hover);
 `), cM("sortable", `
 cursor: pointer;
 `, [cE$1("ellipsis", `
 max-width: calc(100% - 18px);
 `), c$2("&:hover", `
 background-color: var(--n-merged-th-color-hover);
 `)]), cB$1("data-table-sorter", `
 height: var(--n-sorter-size);
 width: var(--n-sorter-size);
 margin-left: 4px;
 position: relative;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 vertical-align: -0.2em;
 color: var(--n-th-icon-color);
 transition: color .3s var(--n-bezier);
 `, [cB$1("base-icon", "transition: transform .3s var(--n-bezier)"), cM("desc", [cB$1("base-icon", `
 transform: rotate(0deg);
 `)]), cM("asc", [cB$1("base-icon", `
 transform: rotate(-180deg);
 `)]), cM("asc, desc", `
 color: var(--n-th-icon-color-active);
 `)]), cB$1("data-table-resize-button", `
 width: var(--n-resizable-container-size);
 position: absolute;
 top: 0;
 right: calc(var(--n-resizable-container-size) / 2);
 bottom: 0;
 cursor: col-resize;
 user-select: none;
 `, [c$2("&::after", `
 width: var(--n-resizable-size);
 height: 50%;
 position: absolute;
 top: 50%;
 left: calc(var(--n-resizable-container-size) / 2);
 bottom: 0;
 background-color: var(--n-merged-border-color);
 transform: translateY(-50%);
 transition: background-color .3s var(--n-bezier);
 z-index: 1;
 content: '';
 `), cM("active", [c$2("&::after", ` 
 background-color: var(--n-th-icon-color-active);
 `)]), c$2("&:hover::after", `
 background-color: var(--n-th-icon-color-active);
 `)]), cB$1("data-table-filter", `
 position: absolute;
 z-index: auto;
 right: 0;
 width: 36px;
 top: 0;
 bottom: 0;
 cursor: pointer;
 display: flex;
 justify-content: center;
 align-items: center;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 font-size: var(--n-filter-size);
 color: var(--n-th-icon-color);
 `, [c$2("&:hover", `
 background-color: var(--n-th-button-color-hover);
 `), cM("show", `
 background-color: var(--n-th-button-color-hover);
 `), cM("active", `
 background-color: var(--n-th-button-color-hover);
 color: var(--n-th-icon-color-active);
 `)])]), cB$1("data-table-td", `
 padding: var(--n-td-padding);
 text-align: start;
 box-sizing: border-box;
 border: none;
 background-color: var(--n-merged-td-color);
 color: var(--n-td-text-color);
 border-bottom: 1px solid var(--n-merged-border-color);
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `, [cM("expand", [cB$1("data-table-expand-trigger", `
 margin-right: 0;
 `)]), cM("last-row", `
 border-bottom: 0 solid var(--n-merged-border-color);
 `, [
  c$2("&::after", `
 bottom: 0 !important;
 `),
  c$2("&::before", `
 bottom: 0 !important;
 `)
]), cM("summary", `
 background-color: var(--n-merged-th-color);
 `), cM("hover", `
 background-color: var(--n-merged-td-color-hover);
 `), cE$1("ellipsis", `
 display: inline-block;
 text-overflow: ellipsis;
 overflow: hidden;
 white-space: nowrap;
 max-width: 100%;
 vertical-align: bottom;
 `), cM("selection, expand", `
 text-align: center;
 padding: 0;
 line-height: 0;
 `), fixedColumnStyle]), cB$1("data-table-empty", `
 box-sizing: border-box;
 padding: var(--n-empty-padding);
 flex-grow: 1;
 flex-shrink: 0;
 opacity: 1;
 display: flex;
 align-items: center;
 justify-content: center;
 transition: opacity .3s var(--n-bezier);
 `, [cM("hide", `
 opacity: 0;
 `)]), cE$1("pagination", `
 margin: var(--n-pagination-margin);
 display: flex;
 justify-content: flex-end;
 `), cB$1("data-table-wrapper", `
 position: relative;
 opacity: 1;
 transition: opacity .3s var(--n-bezier), border-color .3s var(--n-bezier);
 border-top-left-radius: var(--n-border-radius);
 border-top-right-radius: var(--n-border-radius);
 line-height: var(--n-line-height);
 `), cM("loading", [cB$1("data-table-wrapper", `
 opacity: var(--n-opacity-loading);
 pointer-events: none;
 `)]), cM("single-column", [cB$1("data-table-td", `
 border-bottom: 0 solid var(--n-merged-border-color);
 `, [c$2("&::after, &::before", `
 bottom: 0 !important;
 `)])]), cNotM("single-line", [cB$1("data-table-th", `
 border-right: 1px solid var(--n-merged-border-color);
 `, [cM("last", `
 border-right: 0 solid var(--n-merged-border-color);
 `)]), cB$1("data-table-td", `
 border-right: 1px solid var(--n-merged-border-color);
 `, [cM("last-col", `
 border-right: 0 solid var(--n-merged-border-color);
 `)])]), cM("bordered", [cB$1("data-table-wrapper", `
 border: 1px solid var(--n-merged-border-color);
 border-bottom-left-radius: var(--n-border-radius);
 border-bottom-right-radius: var(--n-border-radius);
 overflow: hidden;
 `)]), cB$1("data-table-base-table", [cM("transition-disabled", [cB$1("data-table-th", [c$2("&::after, &::before", "transition: none;")]), cB$1("data-table-td", [c$2("&::after, &::before", "transition: none;")])])]), cM("bottom-bordered", [cB$1("data-table-td", [cM("last-row", `
 border-bottom: 1px solid var(--n-merged-border-color);
 `)])]), cB$1("data-table-table", `
 font-variant-numeric: tabular-nums;
 width: 100%;
 word-break: break-word;
 transition: background-color .3s var(--n-bezier);
 border-collapse: separate;
 border-spacing: 0;
 background-color: var(--n-merged-td-color);
 `), cB$1("data-table-base-table-header", `
 border-top-left-radius: calc(var(--n-border-radius) - 1px);
 border-top-right-radius: calc(var(--n-border-radius) - 1px);
 z-index: 3;
 overflow: scroll;
 flex-shrink: 0;
 transition: border-color .3s var(--n-bezier);
 scrollbar-width: none;
 `, [c$2("&::-webkit-scrollbar", `
 width: 0;
 height: 0;
 `)]), cB$1("data-table-check-extra", `
 transition: color .3s var(--n-bezier);
 color: var(--n-th-icon-color);
 position: absolute;
 font-size: 14px;
 right: -4px;
 top: 50%;
 transform: translateY(-50%);
 z-index: 1;
 `)]), cB$1("data-table-filter-menu", [cB$1("scrollbar", `
 max-height: 240px;
 `), cE$1("group", `
 display: flex;
 flex-direction: column;
 padding: 12px 12px 0 12px;
 `, [cB$1("checkbox", `
 margin-bottom: 12px;
 margin-right: 0;
 `), cB$1("radio", `
 margin-bottom: 12px;
 margin-right: 0;
 `)]), cE$1("action", `
 padding: var(--n-action-padding);
 display: flex;
 flex-wrap: nowrap;
 justify-content: space-evenly;
 border-top: 1px solid var(--n-action-divider-color);
 `, [cB$1("button", [c$2("&:not(:last-child)", `
 margin: var(--n-action-button-margin);
 `), c$2("&:last-child", `
 margin-right: 0;
 `)])]), cB$1("divider", `
 margin: 0 !important;
 `)]), insideModal(cB$1("data-table", `
 --n-merged-th-color: var(--n-th-color-modal);
 --n-merged-td-color: var(--n-td-color-modal);
 --n-merged-border-color: var(--n-border-color-modal);
 --n-merged-th-color-hover: var(--n-th-color-hover-modal);
 --n-merged-td-color-hover: var(--n-td-color-hover-modal);
 --n-merged-td-color-striped: var(--n-td-color-striped-modal);
 `)), insidePopover(cB$1("data-table", `
 --n-merged-th-color: var(--n-th-color-popover);
 --n-merged-td-color: var(--n-td-color-popover);
 --n-merged-border-color: var(--n-border-color-popover);
 --n-merged-th-color-hover: var(--n-th-color-hover-popover);
 --n-merged-td-color-hover: var(--n-td-color-hover-popover);
 --n-merged-td-color-striped: var(--n-td-color-striped-popover);
 `))]);
function createFixedColumnStyle() {
  return [cM("fixed-left", `
 left: 0;
 position: sticky;
 z-index: 2;
 `, [c$2("&::after", `
 pointer-events: none;
 content: "";
 width: 36px;
 display: inline-block;
 position: absolute;
 top: 0;
 bottom: -1px;
 transition: box-shadow .2s var(--n-bezier);
 right: -36px;
 `)]), cM("fixed-right", `
 right: 0;
 position: sticky;
 z-index: 1;
 `, [c$2("&::before", `
 pointer-events: none;
 content: "";
 width: 36px;
 display: inline-block;
 position: absolute;
 top: 0;
 bottom: -1px;
 transition: box-shadow .2s var(--n-bezier);
 left: -36px;
 `)])];
}
var NDataTable = defineComponent({
  name: "DataTable",
  alias: ["AdvancedTable"],
  props: dataTableProps,
  setup(props, { slots }) {
    const { mergedBorderedRef, mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const mergedBottomBorderedRef = computed(() => {
      const { bottomBordered } = props;
      if (mergedBorderedRef.value)
        return false;
      if (bottomBordered !== void 0)
        return bottomBordered;
      return true;
    });
    const themeRef = useTheme("DataTable", "-data-table", style$l, dataTableLight$1, props, mergedClsPrefixRef);
    const bodyWidthRef = ref(null);
    const scrollPartRef = ref("body");
    onDeactivated(() => {
      scrollPartRef.value = "body";
    });
    const mainTableInstRef = ref(null);
    const { getResizableWidth, clearResizableWidth, doUpdateResizableWidth } = useResizable();
    const { rowsRef, colsRef, dataRelatedColsRef, hasEllipsisRef } = useGroupHeader(props, getResizableWidth);
    const { treeMateRef, mergedCurrentPageRef, paginatedDataRef, rawPaginatedDataRef, selectionColumnRef, hoverKeyRef, mergedPaginationRef, mergedFilterStateRef, mergedSortStateRef, childTriggerColIndexRef, doUpdatePage, doUpdateFilters, onUnstableColumnResize, deriveNextSorter, filter, filters, clearFilter, clearFilters, clearSorter, page: page2, sort } = useTableData(props, { dataRelatedColsRef });
    const { doCheckAll, doUncheckAll, doCheck, doUncheck, headerCheckboxDisabledRef, someRowsCheckedRef, allRowsCheckedRef, mergedCheckedRowKeySetRef, mergedInderminateRowKeySetRef } = useCheck(props, {
      selectionColumnRef,
      treeMateRef,
      paginatedDataRef
    });
    const { stickyExpandedRowsRef, mergedExpandedRowKeysRef, renderExpandRef, expandableRef, doUpdateExpandedRowKeys } = useExpand(props, treeMateRef);
    const { handleTableBodyScroll, handleTableHeaderScroll, syncScrollState, setHeaderScrollLeft, leftActiveFixedColKeyRef, leftActiveFixedChildrenColKeysRef, rightActiveFixedColKeyRef, rightActiveFixedChildrenColKeysRef, leftFixedColumnsRef, rightFixedColumnsRef, fixedColumnLeftMapRef, fixedColumnRightMapRef } = useScroll(props, {
      scrollPartRef,
      bodyWidthRef,
      mainTableInstRef,
      mergedCurrentPageRef
    });
    const { localeRef } = useLocale("DataTable");
    const mergedTableLayoutRef = computed(() => {
      if (props.virtualScroll || props.flexHeight || props.maxHeight !== void 0 || hasEllipsisRef.value) {
        return "fixed";
      }
      return props.tableLayout;
    });
    provide(dataTableInjectionKey, {
      props,
      treeMateRef,
      renderExpandIconRef: toRef(props, "renderExpandIcon"),
      loadingKeySetRef: ref(new Set()),
      slots,
      indentRef: toRef(props, "indent"),
      childTriggerColIndexRef,
      bodyWidthRef,
      componentId: createId(),
      hoverKeyRef,
      mergedClsPrefixRef,
      mergedThemeRef: themeRef,
      scrollXRef: computed(() => props.scrollX),
      rowsRef,
      colsRef,
      paginatedDataRef,
      leftActiveFixedColKeyRef,
      leftActiveFixedChildrenColKeysRef,
      rightActiveFixedColKeyRef,
      rightActiveFixedChildrenColKeysRef,
      leftFixedColumnsRef,
      rightFixedColumnsRef,
      fixedColumnLeftMapRef,
      fixedColumnRightMapRef,
      mergedCurrentPageRef,
      someRowsCheckedRef,
      allRowsCheckedRef,
      mergedSortStateRef,
      mergedFilterStateRef,
      loadingRef: toRef(props, "loading"),
      rowClassNameRef: toRef(props, "rowClassName"),
      mergedCheckedRowKeySetRef,
      mergedExpandedRowKeysRef,
      mergedInderminateRowKeySetRef,
      localeRef,
      scrollPartRef,
      expandableRef,
      stickyExpandedRowsRef,
      rowKeyRef: toRef(props, "rowKey"),
      renderExpandRef,
      summaryRef: toRef(props, "summary"),
      virtualScrollRef: toRef(props, "virtualScroll"),
      rowPropsRef: toRef(props, "rowProps"),
      stripedRef: toRef(props, "striped"),
      checkOptionsRef: computed(() => {
        const { value: selectionColumn } = selectionColumnRef;
        return selectionColumn === null || selectionColumn === void 0 ? void 0 : selectionColumn.options;
      }),
      rawPaginatedDataRef,
      filterMenuCssVarsRef: computed(() => {
        const { self: { actionDividerColor, actionPadding, actionButtonMargin } } = themeRef.value;
        return {
          "--n-action-padding": actionPadding,
          "--n-action-button-margin": actionButtonMargin,
          "--n-action-divider-color": actionDividerColor
        };
      }),
      onLoadRef: toRef(props, "onLoad"),
      mergedTableLayoutRef,
      maxHeightRef: toRef(props, "maxHeight"),
      minHeightRef: toRef(props, "minHeight"),
      flexHeightRef: toRef(props, "flexHeight"),
      headerCheckboxDisabledRef,
      paginationBehaviorOnFilterRef: toRef(props, "paginationBehaviorOnFilter"),
      summaryPlacementRef: toRef(props, "summaryPlacement"),
      scrollbarPropsRef: toRef(props, "scrollbarProps"),
      syncScrollState,
      doUpdatePage,
      doUpdateFilters,
      getResizableWidth,
      onUnstableColumnResize,
      clearResizableWidth,
      doUpdateResizableWidth,
      deriveNextSorter,
      doCheck,
      doUncheck,
      doCheckAll,
      doUncheckAll,
      doUpdateExpandedRowKeys,
      handleTableHeaderScroll,
      handleTableBodyScroll,
      setHeaderScrollLeft,
      renderCell: toRef(props, "renderCell")
    });
    const exposedMethods = {
      filter,
      filters,
      clearFilters,
      clearSorter,
      page: page2,
      sort,
      clearFilter,
      scrollTo: (arg0, arg1) => {
        var _a2;
        (_a2 = mainTableInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.scrollTo(arg0, arg1);
      }
    };
    const cssVarsRef = computed(() => {
      const { size: size2 } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { borderColor, tdColorHover, thColor, thColorHover, tdColor, tdTextColor, thTextColor, thFontWeight, thButtonColorHover, thIconColor, thIconColorActive, filterSize, borderRadius, lineHeight: lineHeight2, tdColorModal, thColorModal, borderColorModal, thColorHoverModal, tdColorHoverModal, borderColorPopover, thColorPopover, tdColorPopover, tdColorHoverPopover, thColorHoverPopover, paginationMargin, emptyPadding, boxShadowAfter, boxShadowBefore, sorterSize, resizableContainerSize, resizableSize, loadingColor, loadingSize, opacityLoading, tdColorStriped, tdColorStripedModal, tdColorStripedPopover, [createKey("fontSize", size2)]: fontSize2, [createKey("thPadding", size2)]: thPadding, [createKey("tdPadding", size2)]: tdPadding } } = themeRef.value;
      return {
        "--n-font-size": fontSize2,
        "--n-th-padding": thPadding,
        "--n-td-padding": tdPadding,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-border-radius": borderRadius,
        "--n-line-height": lineHeight2,
        "--n-border-color": borderColor,
        "--n-border-color-modal": borderColorModal,
        "--n-border-color-popover": borderColorPopover,
        "--n-th-color": thColor,
        "--n-th-color-hover": thColorHover,
        "--n-th-color-modal": thColorModal,
        "--n-th-color-hover-modal": thColorHoverModal,
        "--n-th-color-popover": thColorPopover,
        "--n-th-color-hover-popover": thColorHoverPopover,
        "--n-td-color": tdColor,
        "--n-td-color-hover": tdColorHover,
        "--n-td-color-modal": tdColorModal,
        "--n-td-color-hover-modal": tdColorHoverModal,
        "--n-td-color-popover": tdColorPopover,
        "--n-td-color-hover-popover": tdColorHoverPopover,
        "--n-th-text-color": thTextColor,
        "--n-td-text-color": tdTextColor,
        "--n-th-font-weight": thFontWeight,
        "--n-th-button-color-hover": thButtonColorHover,
        "--n-th-icon-color": thIconColor,
        "--n-th-icon-color-active": thIconColorActive,
        "--n-filter-size": filterSize,
        "--n-pagination-margin": paginationMargin,
        "--n-empty-padding": emptyPadding,
        "--n-box-shadow-before": boxShadowBefore,
        "--n-box-shadow-after": boxShadowAfter,
        "--n-sorter-size": sorterSize,
        "--n-resizable-container-size": resizableContainerSize,
        "--n-resizable-size": resizableSize,
        "--n-loading-size": loadingSize,
        "--n-loading-color": loadingColor,
        "--n-opacity-loading": opacityLoading,
        "--n-td-color-striped": tdColorStriped,
        "--n-td-color-striped-modal": tdColorStripedModal,
        "--n-td-color-striped-popover": tdColorStripedPopover
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("data-table", computed(() => props.size[0]), cssVarsRef, props) : void 0;
    const mergedShowPaginationRef = computed(() => {
      if (!props.pagination)
        return false;
      if (props.paginateSinglePage)
        return true;
      const mergedPagination = mergedPaginationRef.value;
      const { pageCount } = mergedPagination;
      if (pageCount !== void 0)
        return pageCount > 1;
      return mergedPagination.itemCount && mergedPagination.pageSize && mergedPagination.itemCount > mergedPagination.pageSize;
    });
    return Object.assign({ mainTableInstRef, mergedClsPrefix: mergedClsPrefixRef, mergedTheme: themeRef, paginatedData: paginatedDataRef, mergedBordered: mergedBorderedRef, mergedBottomBordered: mergedBottomBorderedRef, mergedPagination: mergedPaginationRef, mergedShowPagination: mergedShowPaginationRef, cssVars: inlineThemeDisabled ? void 0 : cssVarsRef, themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass, onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender }, exposedMethods);
  },
  render() {
    const { mergedClsPrefix, themeClass, onRender, $slots, spinProps: spinProps2 } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { class: [
      `${mergedClsPrefix}-data-table`,
      themeClass,
      {
        [`${mergedClsPrefix}-data-table--bordered`]: this.mergedBordered,
        [`${mergedClsPrefix}-data-table--bottom-bordered`]: this.mergedBottomBordered,
        [`${mergedClsPrefix}-data-table--single-line`]: this.singleLine,
        [`${mergedClsPrefix}-data-table--single-column`]: this.singleColumn,
        [`${mergedClsPrefix}-data-table--loading`]: this.loading,
        [`${mergedClsPrefix}-data-table--flex-height`]: this.flexHeight
      }
    ], style: this.cssVars }, h$1("div", { class: `${mergedClsPrefix}-data-table-wrapper` }, h$1(MainTable, { ref: "mainTableInstRef" })), this.mergedShowPagination ? h$1("div", { class: `${mergedClsPrefix}-data-table__pagination` }, h$1(NPagination, Object.assign({ theme: this.mergedTheme.peers.Pagination, themeOverrides: this.mergedTheme.peerOverrides.Pagination, disabled: this.loading }, this.mergedPagination))) : null, h$1(Transition, { name: "fade-in-scale-up-transition" }, {
      default: () => {
        return this.loading ? h$1("div", { class: `${mergedClsPrefix}-data-table-loading-wrapper` }, resolveSlot($slots.loading, () => [
          h$1(NBaseLoading, Object.assign({ clsPrefix: mergedClsPrefix, strokeWidth: 20 }, spinProps2))
        ])) : null;
      }
    }));
  }
});
var commonVars$5 = {
  itemFontSize: "12px",
  itemHeight: "36px",
  itemWidth: "52px",
  panelActionPadding: "8px 0"
};
const self$k = (vars) => {
  const { popoverColor, textColor2, primaryColor, hoverColor, dividerColor, opacityDisabled, boxShadow2, borderRadius, iconColor, iconColorDisabled } = vars;
  return Object.assign(Object.assign({}, commonVars$5), {
    panelColor: popoverColor,
    panelBoxShadow: boxShadow2,
    panelDividerColor: dividerColor,
    itemTextColor: textColor2,
    itemTextColorActive: primaryColor,
    itemColorHover: hoverColor,
    itemOpacityDisabled: opacityDisabled,
    itemBorderRadius: borderRadius,
    borderRadius,
    iconColor,
    iconColorDisabled
  });
};
const timePickerLight = createTheme({
  name: "TimePicker",
  common: commonLight,
  peers: {
    Scrollbar: scrollbarLight$1,
    Button: buttonLight$1,
    Input: inputLight$1
  },
  self: self$k
});
var timePickerLight$1 = timePickerLight;
var commonVars$4 = {
  itemSize: "24px",
  itemCellWidth: "38px",
  itemCellHeight: "32px",
  scrollItemWidth: "80px",
  scrollItemHeight: "40px",
  panelExtraFooterPadding: "8px 12px",
  panelActionPadding: "8px 12px",
  calendarTitlePadding: "0",
  calendarTitleHeight: "28px",
  arrowSize: "14px",
  panelHeaderPadding: "8px 12px",
  calendarDaysHeight: "32px",
  calendarTitleGridTempateColumns: "28px 28px 1fr 28px 28px",
  calendarLeftPaddingDate: "6px 12px 4px 12px",
  calendarLeftPaddingDatetime: "4px 12px",
  calendarLeftPaddingDaterange: "6px 12px 4px 12px",
  calendarLeftPaddingDatetimerange: "4px 12px",
  calendarLeftPaddingMonth: "0",
  calendarLeftPaddingYear: "0",
  calendarLeftPaddingQuarter: "0",
  calendarLeftPaddingMonthrange: "0",
  calendarLeftPaddingQuarterrange: "0",
  calendarLeftPaddingYearrange: "0",
  calendarRightPaddingDate: "6px 12px 4px 12px",
  calendarRightPaddingDatetime: "4px 12px",
  calendarRightPaddingDaterange: "6px 12px 4px 12px",
  calendarRightPaddingDatetimerange: "4px 12px",
  calendarRightPaddingMonth: "0",
  calendarRightPaddingYear: "0",
  calendarRightPaddingQuarter: "0",
  calendarRightPaddingMonthrange: "0",
  calendarRightPaddingQuarterrange: "0",
  calendarRightPaddingYearrange: "0"
};
const self$j = (vars) => {
  const { hoverColor, fontSize: fontSize2, textColor2, textColorDisabled, popoverColor, primaryColor, borderRadiusSmall, iconColor, iconColorDisabled, textColor1, dividerColor, boxShadow2, borderRadius, fontWeightStrong } = vars;
  return Object.assign(Object.assign({}, commonVars$4), {
    itemFontSize: fontSize2,
    calendarDaysFontSize: fontSize2,
    calendarTitleFontSize: fontSize2,
    itemTextColor: textColor2,
    itemTextColorDisabled: textColorDisabled,
    itemTextColorActive: popoverColor,
    itemTextColorCurrent: primaryColor,
    itemColorIncluded: changeColor(primaryColor, { alpha: 0.1 }),
    itemColorHover: hoverColor,
    itemColorDisabled: hoverColor,
    itemColorActive: primaryColor,
    itemBorderRadius: borderRadiusSmall,
    panelColor: popoverColor,
    panelTextColor: textColor2,
    arrowColor: iconColor,
    calendarTitleTextColor: textColor1,
    calendarTitleColorHover: hoverColor,
    calendarDaysTextColor: textColor2,
    panelHeaderDividerColor: dividerColor,
    calendarDaysDividerColor: dividerColor,
    calendarDividerColor: dividerColor,
    panelActionDividerColor: dividerColor,
    panelBoxShadow: boxShadow2,
    panelBorderRadius: borderRadius,
    calendarTitleFontWeight: fontWeightStrong,
    scrollItemBorderRadius: borderRadius,
    iconColor,
    iconColorDisabled
  });
};
const datePickerLight = createTheme({
  name: "DatePicker",
  common: commonLight,
  peers: {
    Input: inputLight$1,
    Button: buttonLight$1,
    TimePicker: timePickerLight$1,
    Scrollbar: scrollbarLight$1
  },
  self: self$j
});
var datePickerLight$1 = datePickerLight;
function uniCalendarValidation(props, mergedValueRef) {
  const timePickerValidatorRef = computed(() => {
    const { isTimeDisabled } = props;
    const { value: value2 } = mergedValueRef;
    if (value2 === null || Array.isArray(value2))
      return void 0;
    return isTimeDisabled === null || isTimeDisabled === void 0 ? void 0 : isTimeDisabled(value2);
  });
  const isHourDisabledRef = computed(() => {
    var _a2;
    return (_a2 = timePickerValidatorRef.value) === null || _a2 === void 0 ? void 0 : _a2.isHourDisabled;
  });
  const isMinuteDisabledRef = computed(() => {
    var _a2;
    return (_a2 = timePickerValidatorRef.value) === null || _a2 === void 0 ? void 0 : _a2.isMinuteDisabled;
  });
  const isSecondDisabledRef = computed(() => {
    var _a2;
    return (_a2 = timePickerValidatorRef.value) === null || _a2 === void 0 ? void 0 : _a2.isSecondDisabled;
  });
  const isDateInvalidRef = computed(() => {
    const { type: type4, isDateDisabled } = props;
    const { value: value2 } = mergedValueRef;
    if (value2 === null || Array.isArray(value2) || !["date", "datetime"].includes(type4) || !isDateDisabled) {
      return false;
    }
    return isDateDisabled(value2);
  });
  const isTimeInvalidRef = computed(() => {
    const { type: type4 } = props;
    const { value: value2 } = mergedValueRef;
    if (value2 === null || !(type4 !== "datetime") || Array.isArray(value2)) {
      return false;
    }
    const time2 = new Date(value2);
    const hour = time2.getHours();
    const minute = time2.getMinutes();
    const second = time2.getMinutes();
    return (isHourDisabledRef.value ? isHourDisabledRef.value(hour) : false) || (isMinuteDisabledRef.value ? isMinuteDisabledRef.value(minute, hour) : false) || (isSecondDisabledRef.value ? isSecondDisabledRef.value(second, minute, hour) : false);
  });
  const isDateTimeInvalidRef = computed(() => {
    return isDateInvalidRef.value || isTimeInvalidRef.value;
  });
  const isValueInvalidRef = computed(() => {
    const { type: type4 } = props;
    if (type4 === "date")
      return isDateInvalidRef.value;
    if (type4 === "datetime")
      return isDateTimeInvalidRef.value;
    return false;
  });
  return {
    isValueInvalidRef,
    isDateInvalidRef,
    isTimeInvalidRef,
    isDateTimeInvalidRef,
    isHourDisabledRef,
    isMinuteDisabledRef,
    isSecondDisabledRef
  };
}
function dualCalendarValidation(props, mergedValueRef) {
  const timePickerValidatorRef = computed(() => {
    const { isTimeDisabled } = props;
    const { value: value2 } = mergedValueRef;
    if (!Array.isArray(value2) || !isTimeDisabled) {
      return [void 0, void 0];
    }
    return [
      isTimeDisabled === null || isTimeDisabled === void 0 ? void 0 : isTimeDisabled(value2[0], "start", value2),
      isTimeDisabled === null || isTimeDisabled === void 0 ? void 0 : isTimeDisabled(value2[1], "end", value2)
    ];
  });
  const timeValidator = {
    isStartHourDisabledRef: computed(() => {
      var _a2;
      return (_a2 = timePickerValidatorRef.value[0]) === null || _a2 === void 0 ? void 0 : _a2.isHourDisabled;
    }),
    isEndHourDisabledRef: computed(() => {
      var _a2;
      return (_a2 = timePickerValidatorRef.value[1]) === null || _a2 === void 0 ? void 0 : _a2.isHourDisabled;
    }),
    isStartMinuteDisabledRef: computed(() => {
      var _a2;
      return (_a2 = timePickerValidatorRef.value[0]) === null || _a2 === void 0 ? void 0 : _a2.isMinuteDisabled;
    }),
    isEndMinuteDisabledRef: computed(() => {
      var _a2;
      return (_a2 = timePickerValidatorRef.value[1]) === null || _a2 === void 0 ? void 0 : _a2.isMinuteDisabled;
    }),
    isStartSecondDisabledRef: computed(() => {
      var _a2;
      return (_a2 = timePickerValidatorRef.value[0]) === null || _a2 === void 0 ? void 0 : _a2.isSecondDisabled;
    }),
    isEndSecondDisabledRef: computed(() => {
      var _a2;
      return (_a2 = timePickerValidatorRef.value[1]) === null || _a2 === void 0 ? void 0 : _a2.isSecondDisabled;
    })
  };
  const isStartDateInvalidRef = computed(() => {
    const { type: type4, isDateDisabled } = props;
    const { value: value2 } = mergedValueRef;
    if (value2 === null || !Array.isArray(value2) || !["daterange", "datetimerange"].includes(type4) || !isDateDisabled) {
      return false;
    }
    return isDateDisabled(value2[0], "start", value2);
  });
  const isEndDateInvalidRef = computed(() => {
    const { type: type4, isDateDisabled } = props;
    const { value: value2 } = mergedValueRef;
    if (value2 === null || !Array.isArray(value2) || !["daterange", "datetimerange"].includes(type4) || !isDateDisabled) {
      return false;
    }
    return isDateDisabled(value2[1], "end", value2);
  });
  const isStartTimeInvalidRef = computed(() => {
    const { type: type4 } = props;
    const { value: value2 } = mergedValueRef;
    if (value2 === null || !Array.isArray(value2) || type4 !== "datetimerange") {
      return false;
    }
    const startHours = getHours(value2[0]);
    const startMinutes = getMinutes(value2[0]);
    const startSeconds = getSeconds(value2[0]);
    const { isStartHourDisabledRef, isStartMinuteDisabledRef, isStartSecondDisabledRef } = timeValidator;
    const startTimeInvalid = (isStartHourDisabledRef.value ? isStartHourDisabledRef.value(startHours) : false) || (isStartMinuteDisabledRef.value ? isStartMinuteDisabledRef.value(startMinutes, startHours) : false) || (isStartSecondDisabledRef.value ? isStartSecondDisabledRef.value(startSeconds, startMinutes, startHours) : false);
    return startTimeInvalid;
  });
  const isEndTimeInvalidRef = computed(() => {
    const { type: type4 } = props;
    const { value: value2 } = mergedValueRef;
    if (value2 === null || !Array.isArray(value2) || type4 !== "datetimerange") {
      return false;
    }
    const endHours = getHours(value2[1]);
    const endMinutes = getMinutes(value2[1]);
    const endSeconds = getSeconds(value2[1]);
    const { isEndHourDisabledRef, isEndMinuteDisabledRef, isEndSecondDisabledRef } = timeValidator;
    const endTimeInvalid = (isEndHourDisabledRef.value ? isEndHourDisabledRef.value(endHours) : false) || (isEndMinuteDisabledRef.value ? isEndMinuteDisabledRef.value(endMinutes, endHours) : false) || (isEndSecondDisabledRef.value ? isEndSecondDisabledRef.value(endSeconds, endMinutes, endHours) : false);
    return endTimeInvalid;
  });
  const isStartValueInvalidRef = computed(() => {
    return isStartDateInvalidRef.value || isStartTimeInvalidRef.value;
  });
  const isEndValueInvalidRef = computed(() => {
    return isEndDateInvalidRef.value || isEndTimeInvalidRef.value;
  });
  const isRangeInvalidRef = computed(() => {
    return isStartValueInvalidRef.value || isEndValueInvalidRef.value;
  });
  return Object.assign(Object.assign({}, timeValidator), {
    isStartDateInvalidRef,
    isEndDateInvalidRef,
    isStartTimeInvalidRef,
    isEndTimeInvalidRef,
    isStartValueInvalidRef,
    isEndValueInvalidRef,
    isRangeInvalidRef
  });
}
const datePickerInjectionKey = createInjectionKey("n-date-picker");
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var cloneObject$1 = { exports: {} };
var assign = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = assign2;
  function assign2(target, object4) {
    if (target == null) {
      throw new TypeError("assign requires that input parameter not be null or undefined");
    }
    for (var property2 in object4) {
      if (Object.prototype.hasOwnProperty.call(object4, property2)) {
        target[property2] = object4[property2];
      }
    }
    return target;
  }
  module2.exports = exports2.default;
})(assign, assign.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = cloneObject2;
  var _index = _interopRequireDefault(assign.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function cloneObject2(object4) {
    return (0, _index.default)({}, object4);
  }
  module2.exports = exports2.default;
})(cloneObject$1, cloneObject$1.exports);
var cloneObject = /* @__PURE__ */ getDefaultExportFromCjs(cloneObject$1.exports);
var format$3 = { exports: {} };
var isValid = { exports: {} };
var isDate = { exports: {} };
var requiredArgs = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = requiredArgs2;
  function requiredArgs2(required4, args) {
    if (args.length < required4) {
      throw new TypeError(required4 + " argument" + (required4 > 1 ? "s" : "") + " required, but only " + args.length + " present");
    }
  }
  module2.exports = exports2.default;
})(requiredArgs, requiredArgs.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = isDate2;
  var _index = _interopRequireDefault(requiredArgs.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function isDate2(value2) {
    (0, _index.default)(1, arguments);
    return value2 instanceof Date || typeof value2 === "object" && Object.prototype.toString.call(value2) === "[object Date]";
  }
  module2.exports = exports2.default;
})(isDate, isDate.exports);
var toDate$1 = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = toDate2;
  var _index = _interopRequireDefault(requiredArgs.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function toDate2(argument) {
    (0, _index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
      return new Date(argument.getTime());
    } else if (typeof argument === "number" || argStr === "[object Number]") {
      return new Date(argument);
    } else {
      if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
        console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
        console.warn(new Error().stack);
      }
      return new Date(NaN);
    }
  }
  module2.exports = exports2.default;
})(toDate$1, toDate$1.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = isValid2;
  var _index = _interopRequireDefault(isDate.exports);
  var _index2 = _interopRequireDefault(toDate$1.exports);
  var _index3 = _interopRequireDefault(requiredArgs.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function isValid2(dirtyDate) {
    (0, _index3.default)(1, arguments);
    if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== "number") {
      return false;
    }
    var date4 = (0, _index2.default)(dirtyDate);
    return !isNaN(Number(date4));
  }
  module2.exports = exports2.default;
})(isValid, isValid.exports);
var subMilliseconds = { exports: {} };
var addMilliseconds = { exports: {} };
var toInteger$1 = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = toInteger2;
  function toInteger2(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
      return NaN;
    }
    var number4 = Number(dirtyNumber);
    if (isNaN(number4)) {
      return number4;
    }
    return number4 < 0 ? Math.ceil(number4) : Math.floor(number4);
  }
  module2.exports = exports2.default;
})(toInteger$1, toInteger$1.exports);
var toInteger = /* @__PURE__ */ getDefaultExportFromCjs(toInteger$1.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = addMilliseconds2;
  var _index = _interopRequireDefault(toInteger$1.exports);
  var _index2 = _interopRequireDefault(toDate$1.exports);
  var _index3 = _interopRequireDefault(requiredArgs.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function addMilliseconds2(dirtyDate, dirtyAmount) {
    (0, _index3.default)(2, arguments);
    var timestamp = (0, _index2.default)(dirtyDate).getTime();
    var amount = (0, _index.default)(dirtyAmount);
    return new Date(timestamp + amount);
  }
  module2.exports = exports2.default;
})(addMilliseconds, addMilliseconds.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = subMilliseconds2;
  var _index = _interopRequireDefault(addMilliseconds.exports);
  var _index2 = _interopRequireDefault(requiredArgs.exports);
  var _index3 = _interopRequireDefault(toInteger$1.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function subMilliseconds2(dirtyDate, dirtyAmount) {
    (0, _index2.default)(2, arguments);
    var amount = (0, _index3.default)(dirtyAmount);
    return (0, _index.default)(dirtyDate, -amount);
  }
  module2.exports = exports2.default;
})(subMilliseconds, subMilliseconds.exports);
var formatters$2 = { exports: {} };
var getUTCDayOfYear = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = getUTCDayOfYear2;
  var _index = _interopRequireDefault(toDate$1.exports);
  var _index2 = _interopRequireDefault(requiredArgs.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var MILLISECONDS_IN_DAY2 = 864e5;
  function getUTCDayOfYear2(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date4 = (0, _index.default)(dirtyDate);
    var timestamp = date4.getTime();
    date4.setUTCMonth(0, 1);
    date4.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date4.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY2) + 1;
  }
  module2.exports = exports2.default;
})(getUTCDayOfYear, getUTCDayOfYear.exports);
var getUTCISOWeek = { exports: {} };
var startOfUTCISOWeek = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = startOfUTCISOWeek2;
  var _index = _interopRequireDefault(toDate$1.exports);
  var _index2 = _interopRequireDefault(requiredArgs.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function startOfUTCISOWeek2(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date4 = (0, _index.default)(dirtyDate);
    var day = date4.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date4.setUTCDate(date4.getUTCDate() - diff);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
  module2.exports = exports2.default;
})(startOfUTCISOWeek, startOfUTCISOWeek.exports);
var startOfUTCISOWeekYear = { exports: {} };
var getUTCISOWeekYear = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = getUTCISOWeekYear2;
  var _index = _interopRequireDefault(toDate$1.exports);
  var _index2 = _interopRequireDefault(requiredArgs.exports);
  var _index3 = _interopRequireDefault(startOfUTCISOWeek.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function getUTCISOWeekYear2(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date4 = (0, _index.default)(dirtyDate);
    var year = date4.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
    if (date4.getTime() >= startOfNextYear.getTime()) {
      return year + 1;
    } else if (date4.getTime() >= startOfThisYear.getTime()) {
      return year;
    } else {
      return year - 1;
    }
  }
  module2.exports = exports2.default;
})(getUTCISOWeekYear, getUTCISOWeekYear.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = startOfUTCISOWeekYear2;
  var _index = _interopRequireDefault(getUTCISOWeekYear.exports);
  var _index2 = _interopRequireDefault(startOfUTCISOWeek.exports);
  var _index3 = _interopRequireDefault(requiredArgs.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function startOfUTCISOWeekYear2(dirtyDate) {
    (0, _index3.default)(1, arguments);
    var year = (0, _index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date4 = (0, _index2.default)(fourthOfJanuary);
    return date4;
  }
  module2.exports = exports2.default;
})(startOfUTCISOWeekYear, startOfUTCISOWeekYear.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = getUTCISOWeek2;
  var _index = _interopRequireDefault(toDate$1.exports);
  var _index2 = _interopRequireDefault(startOfUTCISOWeek.exports);
  var _index3 = _interopRequireDefault(startOfUTCISOWeekYear.exports);
  var _index4 = _interopRequireDefault(requiredArgs.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var MILLISECONDS_IN_WEEK2 = 6048e5;
  function getUTCISOWeek2(dirtyDate) {
    (0, _index4.default)(1, arguments);
    var date4 = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date4).getTime() - (0, _index3.default)(date4).getTime();
    return Math.round(diff / MILLISECONDS_IN_WEEK2) + 1;
  }
  module2.exports = exports2.default;
})(getUTCISOWeek, getUTCISOWeek.exports);
var getUTCWeek = { exports: {} };
var startOfUTCWeek = { exports: {} };
var defaultOptions$1 = {};
Object.defineProperty(defaultOptions$1, "__esModule", {
  value: true
});
defaultOptions$1.getDefaultOptions = getDefaultOptions;
defaultOptions$1.setDefaultOptions = setDefaultOptions;
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = startOfUTCWeek2;
  var _index = _interopRequireDefault(toDate$1.exports);
  var _index2 = _interopRequireDefault(requiredArgs.exports);
  var _index3 = _interopRequireDefault(toInteger$1.exports);
  var _index4 = defaultOptions$1;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function startOfUTCWeek2(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var defaultOptions2 = (0, _index4.getDefaultOptions)();
    var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    }
    var date4 = (0, _index.default)(dirtyDate);
    var day = date4.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date4.setUTCDate(date4.getUTCDate() - diff);
    date4.setUTCHours(0, 0, 0, 0);
    return date4;
  }
  module2.exports = exports2.default;
})(startOfUTCWeek, startOfUTCWeek.exports);
var startOfUTCWeekYear = { exports: {} };
var getUTCWeekYear = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = getUTCWeekYear2;
  var _index = _interopRequireDefault(toDate$1.exports);
  var _index2 = _interopRequireDefault(requiredArgs.exports);
  var _index3 = _interopRequireDefault(startOfUTCWeek.exports);
  var _index4 = _interopRequireDefault(toInteger$1.exports);
  var _index5 = defaultOptions$1;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function getUTCWeekYear2(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var date4 = (0, _index.default)(dirtyDate);
    var year = date4.getUTCFullYear();
    var defaultOptions2 = (0, _index5.getDefaultOptions)();
    var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    }
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
    if (date4.getTime() >= startOfNextYear.getTime()) {
      return year + 1;
    } else if (date4.getTime() >= startOfThisYear.getTime()) {
      return year;
    } else {
      return year - 1;
    }
  }
  module2.exports = exports2.default;
})(getUTCWeekYear, getUTCWeekYear.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = startOfUTCWeekYear2;
  var _index = _interopRequireDefault(getUTCWeekYear.exports);
  var _index2 = _interopRequireDefault(requiredArgs.exports);
  var _index3 = _interopRequireDefault(startOfUTCWeek.exports);
  var _index4 = _interopRequireDefault(toInteger$1.exports);
  var _index5 = defaultOptions$1;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function startOfUTCWeekYear2(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var defaultOptions2 = (0, _index5.getDefaultOptions)();
    var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _index.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date4 = (0, _index3.default)(firstWeek, options);
    return date4;
  }
  module2.exports = exports2.default;
})(startOfUTCWeekYear, startOfUTCWeekYear.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = getUTCWeek2;
  var _index = _interopRequireDefault(toDate$1.exports);
  var _index2 = _interopRequireDefault(startOfUTCWeek.exports);
  var _index3 = _interopRequireDefault(startOfUTCWeekYear.exports);
  var _index4 = _interopRequireDefault(requiredArgs.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var MILLISECONDS_IN_WEEK2 = 6048e5;
  function getUTCWeek2(dirtyDate, options) {
    (0, _index4.default)(1, arguments);
    var date4 = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date4, options).getTime() - (0, _index3.default)(date4, options).getTime();
    return Math.round(diff / MILLISECONDS_IN_WEEK2) + 1;
  }
  module2.exports = exports2.default;
})(getUTCWeek, getUTCWeek.exports);
var addLeadingZeros$1 = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = addLeadingZeros2;
  function addLeadingZeros2(number4, targetLength) {
    var sign = number4 < 0 ? "-" : "";
    var output = Math.abs(number4).toString();
    while (output.length < targetLength) {
      output = "0" + output;
    }
    return sign + output;
  }
  module2.exports = exports2.default;
})(addLeadingZeros$1, addLeadingZeros$1.exports);
var lightFormatters = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = void 0;
  var _index = _interopRequireDefault(addLeadingZeros$1.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var formatters2 = {
    y: function(date4, token) {
      var signedYear = date4.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return (0, _index.default)(token === "yy" ? year % 100 : year, token.length);
    },
    M: function(date4, token) {
      var month = date4.getUTCMonth();
      return token === "M" ? String(month + 1) : (0, _index.default)(month + 1, 2);
    },
    d: function(date4, token) {
      return (0, _index.default)(date4.getUTCDate(), token.length);
    },
    a: function(date4, token) {
      var dayPeriodEnumValue = date4.getUTCHours() / 12 >= 1 ? "pm" : "am";
      switch (token) {
        case "a":
        case "aa":
          return dayPeriodEnumValue.toUpperCase();
        case "aaa":
          return dayPeriodEnumValue;
        case "aaaaa":
          return dayPeriodEnumValue[0];
        case "aaaa":
        default:
          return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
      }
    },
    h: function(date4, token) {
      return (0, _index.default)(date4.getUTCHours() % 12 || 12, token.length);
    },
    H: function(date4, token) {
      return (0, _index.default)(date4.getUTCHours(), token.length);
    },
    m: function(date4, token) {
      return (0, _index.default)(date4.getUTCMinutes(), token.length);
    },
    s: function(date4, token) {
      return (0, _index.default)(date4.getUTCSeconds(), token.length);
    },
    S: function(date4, token) {
      var numberOfDigits = token.length;
      var milliseconds = date4.getUTCMilliseconds();
      var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
      return (0, _index.default)(fractionalSeconds, token.length);
    }
  };
  var _default = formatters2;
  exports2.default = _default;
  module2.exports = exports2.default;
})(lightFormatters, lightFormatters.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = void 0;
  var _index = _interopRequireDefault(getUTCDayOfYear.exports);
  var _index2 = _interopRequireDefault(getUTCISOWeek.exports);
  var _index3 = _interopRequireDefault(getUTCISOWeekYear.exports);
  var _index4 = _interopRequireDefault(getUTCWeek.exports);
  var _index5 = _interopRequireDefault(getUTCWeekYear.exports);
  var _index6 = _interopRequireDefault(addLeadingZeros$1.exports);
  var _index7 = _interopRequireDefault(lightFormatters.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var dayPeriodEnum2 = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  };
  var formatters2 = {
    G: function(date4, token, localize2) {
      var era = date4.getUTCFullYear() > 0 ? 1 : 0;
      switch (token) {
        case "G":
        case "GG":
        case "GGG":
          return localize2.era(era, {
            width: "abbreviated"
          });
        case "GGGGG":
          return localize2.era(era, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return localize2.era(era, {
            width: "wide"
          });
      }
    },
    y: function(date4, token, localize2) {
      if (token === "yo") {
        var signedYear = date4.getUTCFullYear();
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return localize2.ordinalNumber(year, {
          unit: "year"
        });
      }
      return _index7.default.y(date4, token);
    },
    Y: function(date4, token, localize2, options) {
      var signedWeekYear = (0, _index5.default)(date4, options);
      var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
      if (token === "YY") {
        var twoDigitYear = weekYear % 100;
        return (0, _index6.default)(twoDigitYear, 2);
      }
      if (token === "Yo") {
        return localize2.ordinalNumber(weekYear, {
          unit: "year"
        });
      }
      return (0, _index6.default)(weekYear, token.length);
    },
    R: function(date4, token) {
      var isoWeekYear = (0, _index3.default)(date4);
      return (0, _index6.default)(isoWeekYear, token.length);
    },
    u: function(date4, token) {
      var year = date4.getUTCFullYear();
      return (0, _index6.default)(year, token.length);
    },
    Q: function(date4, token, localize2) {
      var quarter = Math.ceil((date4.getUTCMonth() + 1) / 3);
      switch (token) {
        case "Q":
          return String(quarter);
        case "QQ":
          return (0, _index6.default)(quarter, 2);
        case "Qo":
          return localize2.ordinalNumber(quarter, {
            unit: "quarter"
          });
        case "QQQ":
          return localize2.quarter(quarter, {
            width: "abbreviated",
            context: "formatting"
          });
        case "QQQQQ":
          return localize2.quarter(quarter, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return localize2.quarter(quarter, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    q: function(date4, token, localize2) {
      var quarter = Math.ceil((date4.getUTCMonth() + 1) / 3);
      switch (token) {
        case "q":
          return String(quarter);
        case "qq":
          return (0, _index6.default)(quarter, 2);
        case "qo":
          return localize2.ordinalNumber(quarter, {
            unit: "quarter"
          });
        case "qqq":
          return localize2.quarter(quarter, {
            width: "abbreviated",
            context: "standalone"
          });
        case "qqqqq":
          return localize2.quarter(quarter, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return localize2.quarter(quarter, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    M: function(date4, token, localize2) {
      var month = date4.getUTCMonth();
      switch (token) {
        case "M":
        case "MM":
          return _index7.default.M(date4, token);
        case "Mo":
          return localize2.ordinalNumber(month + 1, {
            unit: "month"
          });
        case "MMM":
          return localize2.month(month, {
            width: "abbreviated",
            context: "formatting"
          });
        case "MMMMM":
          return localize2.month(month, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return localize2.month(month, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    L: function(date4, token, localize2) {
      var month = date4.getUTCMonth();
      switch (token) {
        case "L":
          return String(month + 1);
        case "LL":
          return (0, _index6.default)(month + 1, 2);
        case "Lo":
          return localize2.ordinalNumber(month + 1, {
            unit: "month"
          });
        case "LLL":
          return localize2.month(month, {
            width: "abbreviated",
            context: "standalone"
          });
        case "LLLLL":
          return localize2.month(month, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return localize2.month(month, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    w: function(date4, token, localize2, options) {
      var week = (0, _index4.default)(date4, options);
      if (token === "wo") {
        return localize2.ordinalNumber(week, {
          unit: "week"
        });
      }
      return (0, _index6.default)(week, token.length);
    },
    I: function(date4, token, localize2) {
      var isoWeek = (0, _index2.default)(date4);
      if (token === "Io") {
        return localize2.ordinalNumber(isoWeek, {
          unit: "week"
        });
      }
      return (0, _index6.default)(isoWeek, token.length);
    },
    d: function(date4, token, localize2) {
      if (token === "do") {
        return localize2.ordinalNumber(date4.getUTCDate(), {
          unit: "date"
        });
      }
      return _index7.default.d(date4, token);
    },
    D: function(date4, token, localize2) {
      var dayOfYear = (0, _index.default)(date4);
      if (token === "Do") {
        return localize2.ordinalNumber(dayOfYear, {
          unit: "dayOfYear"
        });
      }
      return (0, _index6.default)(dayOfYear, token.length);
    },
    E: function(date4, token, localize2) {
      var dayOfWeek = date4.getUTCDay();
      switch (token) {
        case "E":
        case "EE":
        case "EEE":
          return localize2.day(dayOfWeek, {
            width: "abbreviated",
            context: "formatting"
          });
        case "EEEEE":
          return localize2.day(dayOfWeek, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return localize2.day(dayOfWeek, {
            width: "short",
            context: "formatting"
          });
        case "EEEE":
        default:
          return localize2.day(dayOfWeek, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    e: function(date4, token, localize2, options) {
      var dayOfWeek = date4.getUTCDay();
      var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
      switch (token) {
        case "e":
          return String(localDayOfWeek);
        case "ee":
          return (0, _index6.default)(localDayOfWeek, 2);
        case "eo":
          return localize2.ordinalNumber(localDayOfWeek, {
            unit: "day"
          });
        case "eee":
          return localize2.day(dayOfWeek, {
            width: "abbreviated",
            context: "formatting"
          });
        case "eeeee":
          return localize2.day(dayOfWeek, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return localize2.day(dayOfWeek, {
            width: "short",
            context: "formatting"
          });
        case "eeee":
        default:
          return localize2.day(dayOfWeek, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    c: function(date4, token, localize2, options) {
      var dayOfWeek = date4.getUTCDay();
      var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
      switch (token) {
        case "c":
          return String(localDayOfWeek);
        case "cc":
          return (0, _index6.default)(localDayOfWeek, token.length);
        case "co":
          return localize2.ordinalNumber(localDayOfWeek, {
            unit: "day"
          });
        case "ccc":
          return localize2.day(dayOfWeek, {
            width: "abbreviated",
            context: "standalone"
          });
        case "ccccc":
          return localize2.day(dayOfWeek, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return localize2.day(dayOfWeek, {
            width: "short",
            context: "standalone"
          });
        case "cccc":
        default:
          return localize2.day(dayOfWeek, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    i: function(date4, token, localize2) {
      var dayOfWeek = date4.getUTCDay();
      var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
      switch (token) {
        case "i":
          return String(isoDayOfWeek);
        case "ii":
          return (0, _index6.default)(isoDayOfWeek, token.length);
        case "io":
          return localize2.ordinalNumber(isoDayOfWeek, {
            unit: "day"
          });
        case "iii":
          return localize2.day(dayOfWeek, {
            width: "abbreviated",
            context: "formatting"
          });
        case "iiiii":
          return localize2.day(dayOfWeek, {
            width: "narrow",
            context: "formatting"
          });
        case "iiiiii":
          return localize2.day(dayOfWeek, {
            width: "short",
            context: "formatting"
          });
        case "iiii":
        default:
          return localize2.day(dayOfWeek, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    a: function(date4, token, localize2) {
      var hours = date4.getUTCHours();
      var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
      switch (token) {
        case "a":
        case "aa":
          return localize2.dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return localize2.dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return localize2.dayPeriod(dayPeriodEnumValue, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return localize2.dayPeriod(dayPeriodEnumValue, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    b: function(date4, token, localize2) {
      var hours = date4.getUTCHours();
      var dayPeriodEnumValue;
      if (hours === 12) {
        dayPeriodEnumValue = dayPeriodEnum2.noon;
      } else if (hours === 0) {
        dayPeriodEnumValue = dayPeriodEnum2.midnight;
      } else {
        dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
      }
      switch (token) {
        case "b":
        case "bb":
          return localize2.dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return localize2.dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return localize2.dayPeriod(dayPeriodEnumValue, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return localize2.dayPeriod(dayPeriodEnumValue, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    B: function(date4, token, localize2) {
      var hours = date4.getUTCHours();
      var dayPeriodEnumValue;
      if (hours >= 17) {
        dayPeriodEnumValue = dayPeriodEnum2.evening;
      } else if (hours >= 12) {
        dayPeriodEnumValue = dayPeriodEnum2.afternoon;
      } else if (hours >= 4) {
        dayPeriodEnumValue = dayPeriodEnum2.morning;
      } else {
        dayPeriodEnumValue = dayPeriodEnum2.night;
      }
      switch (token) {
        case "B":
        case "BB":
        case "BBB":
          return localize2.dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return localize2.dayPeriod(dayPeriodEnumValue, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return localize2.dayPeriod(dayPeriodEnumValue, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    h: function(date4, token, localize2) {
      if (token === "ho") {
        var hours = date4.getUTCHours() % 12;
        if (hours === 0)
          hours = 12;
        return localize2.ordinalNumber(hours, {
          unit: "hour"
        });
      }
      return _index7.default.h(date4, token);
    },
    H: function(date4, token, localize2) {
      if (token === "Ho") {
        return localize2.ordinalNumber(date4.getUTCHours(), {
          unit: "hour"
        });
      }
      return _index7.default.H(date4, token);
    },
    K: function(date4, token, localize2) {
      var hours = date4.getUTCHours() % 12;
      if (token === "Ko") {
        return localize2.ordinalNumber(hours, {
          unit: "hour"
        });
      }
      return (0, _index6.default)(hours, token.length);
    },
    k: function(date4, token, localize2) {
      var hours = date4.getUTCHours();
      if (hours === 0)
        hours = 24;
      if (token === "ko") {
        return localize2.ordinalNumber(hours, {
          unit: "hour"
        });
      }
      return (0, _index6.default)(hours, token.length);
    },
    m: function(date4, token, localize2) {
      if (token === "mo") {
        return localize2.ordinalNumber(date4.getUTCMinutes(), {
          unit: "minute"
        });
      }
      return _index7.default.m(date4, token);
    },
    s: function(date4, token, localize2) {
      if (token === "so") {
        return localize2.ordinalNumber(date4.getUTCSeconds(), {
          unit: "second"
        });
      }
      return _index7.default.s(date4, token);
    },
    S: function(date4, token) {
      return _index7.default.S(date4, token);
    },
    X: function(date4, token, _localize, options) {
      var originalDate = options._originalDate || date4;
      var timezoneOffset = originalDate.getTimezoneOffset();
      if (timezoneOffset === 0) {
        return "Z";
      }
      switch (token) {
        case "X":
          return formatTimezoneWithOptionalMinutes2(timezoneOffset);
        case "XXXX":
        case "XX":
          return formatTimezone2(timezoneOffset);
        case "XXXXX":
        case "XXX":
        default:
          return formatTimezone2(timezoneOffset, ":");
      }
    },
    x: function(date4, token, _localize, options) {
      var originalDate = options._originalDate || date4;
      var timezoneOffset = originalDate.getTimezoneOffset();
      switch (token) {
        case "x":
          return formatTimezoneWithOptionalMinutes2(timezoneOffset);
        case "xxxx":
        case "xx":
          return formatTimezone2(timezoneOffset);
        case "xxxxx":
        case "xxx":
        default:
          return formatTimezone2(timezoneOffset, ":");
      }
    },
    O: function(date4, token, _localize, options) {
      var originalDate = options._originalDate || date4;
      var timezoneOffset = originalDate.getTimezoneOffset();
      switch (token) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + formatTimezoneShort2(timezoneOffset, ":");
        case "OOOO":
        default:
          return "GMT" + formatTimezone2(timezoneOffset, ":");
      }
    },
    z: function(date4, token, _localize, options) {
      var originalDate = options._originalDate || date4;
      var timezoneOffset = originalDate.getTimezoneOffset();
      switch (token) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + formatTimezoneShort2(timezoneOffset, ":");
        case "zzzz":
        default:
          return "GMT" + formatTimezone2(timezoneOffset, ":");
      }
    },
    t: function(date4, token, _localize, options) {
      var originalDate = options._originalDate || date4;
      var timestamp = Math.floor(originalDate.getTime() / 1e3);
      return (0, _index6.default)(timestamp, token.length);
    },
    T: function(date4, token, _localize, options) {
      var originalDate = options._originalDate || date4;
      var timestamp = originalDate.getTime();
      return (0, _index6.default)(timestamp, token.length);
    }
  };
  function formatTimezoneShort2(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) {
      return sign + String(hours);
    }
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
  }
  function formatTimezoneWithOptionalMinutes2(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
      var sign = offset > 0 ? "-" : "+";
      return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone2(offset, dirtyDelimiter);
  }
  function formatTimezone2(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _index6.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
  }
  var _default = formatters2;
  exports2.default = _default;
  module2.exports = exports2.default;
})(formatters$2, formatters$2.exports);
var longFormatters = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = void 0;
  var dateLongFormatter2 = function(pattern4, formatLong2) {
    switch (pattern4) {
      case "P":
        return formatLong2.date({
          width: "short"
        });
      case "PP":
        return formatLong2.date({
          width: "medium"
        });
      case "PPP":
        return formatLong2.date({
          width: "long"
        });
      case "PPPP":
      default:
        return formatLong2.date({
          width: "full"
        });
    }
  };
  var timeLongFormatter2 = function(pattern4, formatLong2) {
    switch (pattern4) {
      case "p":
        return formatLong2.time({
          width: "short"
        });
      case "pp":
        return formatLong2.time({
          width: "medium"
        });
      case "ppp":
        return formatLong2.time({
          width: "long"
        });
      case "pppp":
      default:
        return formatLong2.time({
          width: "full"
        });
    }
  };
  var dateTimeLongFormatter2 = function(pattern4, formatLong2) {
    var matchResult = pattern4.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) {
      return dateLongFormatter2(pattern4, formatLong2);
    }
    var dateTimeFormat;
    switch (datePattern) {
      case "P":
        dateTimeFormat = formatLong2.dateTime({
          width: "short"
        });
        break;
      case "PP":
        dateTimeFormat = formatLong2.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        dateTimeFormat = formatLong2.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        dateTimeFormat = formatLong2.dateTime({
          width: "full"
        });
        break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter2(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter2(timePattern, formatLong2));
  };
  var longFormatters2 = {
    p: timeLongFormatter2,
    P: dateTimeLongFormatter2
  };
  var _default = longFormatters2;
  exports2.default = _default;
  module2.exports = exports2.default;
})(longFormatters, longFormatters.exports);
var getTimezoneOffsetInMilliseconds$1 = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = getTimezoneOffsetInMilliseconds2;
  function getTimezoneOffsetInMilliseconds2(date4) {
    var utcDate = new Date(Date.UTC(date4.getFullYear(), date4.getMonth(), date4.getDate(), date4.getHours(), date4.getMinutes(), date4.getSeconds(), date4.getMilliseconds()));
    utcDate.setUTCFullYear(date4.getFullYear());
    return date4.getTime() - utcDate.getTime();
  }
  module2.exports = exports2.default;
})(getTimezoneOffsetInMilliseconds$1, getTimezoneOffsetInMilliseconds$1.exports);
var getTimezoneOffsetInMilliseconds = /* @__PURE__ */ getDefaultExportFromCjs(getTimezoneOffsetInMilliseconds$1.exports);
var protectedTokens = {};
Object.defineProperty(protectedTokens, "__esModule", {
  value: true
});
protectedTokens.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
protectedTokens.isProtectedWeekYearToken = isProtectedWeekYearToken;
protectedTokens.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format2, input) {
  if (token === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var defaultLocale = { exports: {} };
var enUS$1 = { exports: {} };
var formatDistance$8 = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = void 0;
  var formatDistanceLocale2 = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  };
  var formatDistance2 = function(token, count, options) {
    var result2;
    var tokenValue = formatDistanceLocale2[token];
    if (typeof tokenValue === "string") {
      result2 = tokenValue;
    } else if (count === 1) {
      result2 = tokenValue.one;
    } else {
      result2 = tokenValue.other.replace("{{count}}", count.toString());
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return "in " + result2;
      } else {
        return result2 + " ago";
      }
    }
    return result2;
  };
  var _default = formatDistance2;
  exports2.default = _default;
  module2.exports = exports2.default;
})(formatDistance$8, formatDistance$8.exports);
var formatLong$a = { exports: {} };
var buildFormatLongFn = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = buildFormatLongFn2;
  function buildFormatLongFn2(args) {
    return function() {
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var width = options.width ? String(options.width) : args.defaultWidth;
      var format2 = args.formats[width] || args.formats[args.defaultWidth];
      return format2;
    };
  }
  module2.exports = exports2.default;
})(buildFormatLongFn, buildFormatLongFn.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = void 0;
  var _index = _interopRequireDefault(buildFormatLongFn.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var dateFormats2 = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  };
  var timeFormats2 = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  };
  var dateTimeFormats2 = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  };
  var formatLong2 = {
    date: (0, _index.default)({
      formats: dateFormats2,
      defaultWidth: "full"
    }),
    time: (0, _index.default)({
      formats: timeFormats2,
      defaultWidth: "full"
    }),
    dateTime: (0, _index.default)({
      formats: dateTimeFormats2,
      defaultWidth: "full"
    })
  };
  var _default = formatLong2;
  exports2.default = _default;
  module2.exports = exports2.default;
})(formatLong$a, formatLong$a.exports);
var formatRelative$8 = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = void 0;
  var formatRelativeLocale2 = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  };
  var formatRelative2 = function(token, _date, _baseDate, _options) {
    return formatRelativeLocale2[token];
  };
  var _default = formatRelative2;
  exports2.default = _default;
  module2.exports = exports2.default;
})(formatRelative$8, formatRelative$8.exports);
var localize$8 = { exports: {} };
var buildLocalizeFn = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = buildLocalizeFn2;
  function buildLocalizeFn2(args) {
    return function(dirtyIndex, options) {
      var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
      var valuesArray;
      if (context === "formatting" && args.formattingValues) {
        var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
        var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
        valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
      } else {
        var _defaultWidth = args.defaultWidth;
        var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
        valuesArray = args.values[_width] || args.values[_defaultWidth];
      }
      var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
      return valuesArray[index2];
    };
  }
  module2.exports = exports2.default;
})(buildLocalizeFn, buildLocalizeFn.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = void 0;
  var _index = _interopRequireDefault(buildLocalizeFn.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var eraValues2 = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  };
  var quarterValues2 = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  };
  var monthValues2 = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  };
  var dayValues2 = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
  };
  var dayPeriodValues2 = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  };
  var formattingDayPeriodValues2 = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  };
  var ordinalNumber2 = function(dirtyNumber, _options) {
    var number4 = Number(dirtyNumber);
    var rem100 = number4 % 100;
    if (rem100 > 20 || rem100 < 10) {
      switch (rem100 % 10) {
        case 1:
          return number4 + "st";
        case 2:
          return number4 + "nd";
        case 3:
          return number4 + "rd";
      }
    }
    return number4 + "th";
  };
  var localize2 = {
    ordinalNumber: ordinalNumber2,
    era: (0, _index.default)({
      values: eraValues2,
      defaultWidth: "wide"
    }),
    quarter: (0, _index.default)({
      values: quarterValues2,
      defaultWidth: "wide",
      argumentCallback: function(quarter) {
        return quarter - 1;
      }
    }),
    month: (0, _index.default)({
      values: monthValues2,
      defaultWidth: "wide"
    }),
    day: (0, _index.default)({
      values: dayValues2,
      defaultWidth: "wide"
    }),
    dayPeriod: (0, _index.default)({
      values: dayPeriodValues2,
      defaultWidth: "wide",
      formattingValues: formattingDayPeriodValues2,
      defaultFormattingWidth: "wide"
    })
  };
  var _default = localize2;
  exports2.default = _default;
  module2.exports = exports2.default;
})(localize$8, localize$8.exports);
var match$8 = { exports: {} };
var buildMatchFn = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = buildMatchFn2;
  function buildMatchFn2(args) {
    return function(string3) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var width = options.width;
      var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
      var matchResult = string3.match(matchPattern);
      if (!matchResult) {
        return null;
      }
      var matchedString = matchResult[0];
      var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
      var key = Array.isArray(parsePatterns) ? findIndex2(parsePatterns, function(pattern4) {
        return pattern4.test(matchedString);
      }) : findKey2(parsePatterns, function(pattern4) {
        return pattern4.test(matchedString);
      });
      var value2;
      value2 = args.valueCallback ? args.valueCallback(key) : key;
      value2 = options.valueCallback ? options.valueCallback(value2) : value2;
      var rest = string3.slice(matchedString.length);
      return {
        value: value2,
        rest
      };
    };
  }
  function findKey2(object4, predicate) {
    for (var key in object4) {
      if (object4.hasOwnProperty(key) && predicate(object4[key])) {
        return key;
      }
    }
    return void 0;
  }
  function findIndex2(array4, predicate) {
    for (var key = 0; key < array4.length; key++) {
      if (predicate(array4[key])) {
        return key;
      }
    }
    return void 0;
  }
  module2.exports = exports2.default;
})(buildMatchFn, buildMatchFn.exports);
var buildMatchPatternFn = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = buildMatchPatternFn2;
  function buildMatchPatternFn2(args) {
    return function(string3) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var matchResult = string3.match(args.matchPattern);
      if (!matchResult)
        return null;
      var matchedString = matchResult[0];
      var parseResult = string3.match(args.parsePattern);
      if (!parseResult)
        return null;
      var value2 = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
      value2 = options.valueCallback ? options.valueCallback(value2) : value2;
      var rest = string3.slice(matchedString.length);
      return {
        value: value2,
        rest
      };
    };
  }
  module2.exports = exports2.default;
})(buildMatchPatternFn, buildMatchPatternFn.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = void 0;
  var _index = _interopRequireDefault(buildMatchFn.exports);
  var _index2 = _interopRequireDefault(buildMatchPatternFn.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var matchOrdinalNumberPattern2 = /^(\d+)(th|st|nd|rd)?/i;
  var parseOrdinalNumberPattern2 = /\d+/i;
  var matchEraPatterns2 = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  };
  var parseEraPatterns2 = {
    any: [/^b/i, /^(a|c)/i]
  };
  var matchQuarterPatterns2 = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  };
  var parseQuarterPatterns2 = {
    any: [/1/i, /2/i, /3/i, /4/i]
  };
  var matchMonthPatterns2 = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  };
  var parseMonthPatterns2 = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  };
  var matchDayPatterns2 = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  };
  var parseDayPatterns2 = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  };
  var matchDayPeriodPatterns2 = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  };
  var parseDayPeriodPatterns2 = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  };
  var match2 = {
    ordinalNumber: (0, _index2.default)({
      matchPattern: matchOrdinalNumberPattern2,
      parsePattern: parseOrdinalNumberPattern2,
      valueCallback: function(value2) {
        return parseInt(value2, 10);
      }
    }),
    era: (0, _index.default)({
      matchPatterns: matchEraPatterns2,
      defaultMatchWidth: "wide",
      parsePatterns: parseEraPatterns2,
      defaultParseWidth: "any"
    }),
    quarter: (0, _index.default)({
      matchPatterns: matchQuarterPatterns2,
      defaultMatchWidth: "wide",
      parsePatterns: parseQuarterPatterns2,
      defaultParseWidth: "any",
      valueCallback: function(index2) {
        return index2 + 1;
      }
    }),
    month: (0, _index.default)({
      matchPatterns: matchMonthPatterns2,
      defaultMatchWidth: "wide",
      parsePatterns: parseMonthPatterns2,
      defaultParseWidth: "any"
    }),
    day: (0, _index.default)({
      matchPatterns: matchDayPatterns2,
      defaultMatchWidth: "wide",
      parsePatterns: parseDayPatterns2,
      defaultParseWidth: "any"
    }),
    dayPeriod: (0, _index.default)({
      matchPatterns: matchDayPeriodPatterns2,
      defaultMatchWidth: "any",
      parsePatterns: parseDayPeriodPatterns2,
      defaultParseWidth: "any"
    })
  };
  var _default = match2;
  exports2.default = _default;
  module2.exports = exports2.default;
})(match$8, match$8.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = void 0;
  var _index = _interopRequireDefault(formatDistance$8.exports);
  var _index2 = _interopRequireDefault(formatLong$a.exports);
  var _index3 = _interopRequireDefault(formatRelative$8.exports);
  var _index4 = _interopRequireDefault(localize$8.exports);
  var _index5 = _interopRequireDefault(match$8.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var locale2 = {
    code: "en-US",
    formatDistance: _index.default,
    formatLong: _index2.default,
    formatRelative: _index3.default,
    localize: _index4.default,
    match: _index5.default,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  };
  var _default = locale2;
  exports2.default = _default;
  module2.exports = exports2.default;
})(enUS$1, enUS$1.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = void 0;
  var _index = _interopRequireDefault(enUS$1.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var _default = _index.default;
  exports2.default = _default;
  module2.exports = exports2.default;
})(defaultLocale, defaultLocale.exports);
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = format2;
  var _index = _interopRequireDefault(isValid.exports);
  var _index2 = _interopRequireDefault(subMilliseconds.exports);
  var _index3 = _interopRequireDefault(toDate$1.exports);
  var _index4 = _interopRequireDefault(formatters$2.exports);
  var _index5 = _interopRequireDefault(longFormatters.exports);
  var _index6 = _interopRequireDefault(getTimezoneOffsetInMilliseconds$1.exports);
  var _index7 = protectedTokens;
  var _index8 = _interopRequireDefault(toInteger$1.exports);
  var _index9 = _interopRequireDefault(requiredArgs.exports);
  var _index10 = defaultOptions$1;
  var _index11 = _interopRequireDefault(defaultLocale.exports);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  var formattingTokensRegExp2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
  var longFormattingTokensRegExp2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
  var escapedStringRegExp2 = /^'([^]*?)'?$/;
  var doubleQuoteRegExp2 = /''/g;
  var unescapedLatinCharacterRegExp2 = /[a-zA-Z]/;
  function format2(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _index9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions2 = (0, _index10.getDefaultOptions)();
    var locale2 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
    var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    }
    var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    }
    if (!locale2.localize) {
      throw new RangeError("locale must contain localize property");
    }
    if (!locale2.formatLong) {
      throw new RangeError("locale must contain formatLong property");
    }
    var originalDate = (0, _index3.default)(dirtyDate);
    if (!(0, _index.default)(originalDate)) {
      throw new RangeError("Invalid time value");
    }
    var timezoneOffset = (0, _index6.default)(originalDate);
    var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
    var formatterOptions = {
      firstWeekContainsDate,
      weekStartsOn,
      locale: locale2,
      _originalDate: originalDate
    };
    var result2 = formatStr.match(longFormattingTokensRegExp2).map(function(substring) {
      var firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        var longFormatter = _index5.default[firstCharacter];
        return longFormatter(substring, locale2.formatLong);
      }
      return substring;
    }).join("").match(formattingTokensRegExp2).map(function(substring) {
      if (substring === "''") {
        return "'";
      }
      var firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return cleanEscapedString2(substring);
      }
      var formatter = _index4.default[firstCharacter];
      if (formatter) {
        if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) {
          (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
        }
        if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) {
          (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
        }
        return formatter(utcDate, substring, locale2.localize, formatterOptions);
      }
      if (firstCharacter.match(unescapedLatinCharacterRegExp2)) {
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
      }
      return substring;
    }).join("");
    return result2;
  }
  function cleanEscapedString2(input) {
    var matched = input.match(escapedStringRegExp2);
    if (!matched) {
      return input;
    }
    return matched[1].replace(doubleQuoteRegExp2, "'");
  }
  module2.exports = exports2.default;
})(format$3, format$3.exports);
var dateFnsFormat = /* @__PURE__ */ getDefaultExportFromCjs(format$3.exports);
function tzIntlTimeZoneName(length2, date4, options) {
  var dtf = getDTF(length2, options.timeZone, options.locale);
  return dtf.formatToParts ? partsTimeZone(dtf, date4) : hackyTimeZone(dtf, date4);
}
function partsTimeZone(dtf, date4) {
  var formatted = dtf.formatToParts(date4);
  return formatted[formatted.length - 1].value;
}
function hackyTimeZone(dtf, date4) {
  var formatted = dtf.format(date4).replace(/\u200E/g, "");
  var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
  return tzNameMatch ? tzNameMatch[0].substr(1) : "";
}
function getDTF(length2, timeZone, locale2) {
  if (locale2 && !locale2.code) {
    throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
  }
  return new Intl.DateTimeFormat(locale2 ? [locale2.code, "en-US"] : void 0, {
    timeZone,
    timeZoneName: length2
  });
}
function tzTokenizeDate(date4, timeZone) {
  var dtf = getDateTimeFormat(timeZone);
  return dtf.formatToParts ? partsOffset(dtf, date4) : hackyOffset(dtf, date4);
}
var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function partsOffset(dtf, date4) {
  try {
    var formatted = dtf.formatToParts(date4);
    var filled = [];
    for (var i2 = 0; i2 < formatted.length; i2++) {
      var pos = typeToPos[formatted[i2].type];
      if (pos >= 0) {
        filled[pos] = parseInt(formatted[i2].value, 10);
      }
    }
    return filled;
  } catch (error) {
    if (error instanceof RangeError) {
      return [NaN];
    }
    throw error;
  }
}
function hackyOffset(dtf, date4) {
  var formatted = dtf.format(date4).replace(/\u200E/g, "");
  var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
  return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]];
}
var dtfCache = {};
function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    var testDateFormatted = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(new Date("2014-06-25T04:00:00.123Z"));
    var hourCycleSupported = testDateFormatted === "06/25/2014, 00:00:00" || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
    dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return dtfCache[timeZone];
}
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
  var utcDate = new Date(0);
  utcDate.setUTCFullYear(fullYear, month, day);
  utcDate.setUTCHours(hour, minute, second, millisecond);
  return utcDate;
}
var MILLISECONDS_IN_HOUR$1 = 36e5;
var MILLISECONDS_IN_MINUTE$2 = 6e4;
var patterns$1 = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function tzParseTimezone(timezoneString, date4, isUtcDate) {
  var token;
  var absoluteOffset;
  if (timezoneString === "") {
    return 0;
  }
  token = patterns$1.timezoneZ.exec(timezoneString);
  if (token) {
    return 0;
  }
  var hours;
  token = patterns$1.timezoneHH.exec(timezoneString);
  if (token) {
    hours = parseInt(token[1], 10);
    if (!validateTimezone(hours)) {
      return NaN;
    }
    return -(hours * MILLISECONDS_IN_HOUR$1);
  }
  token = patterns$1.timezoneHHMM.exec(timezoneString);
  if (token) {
    hours = parseInt(token[1], 10);
    var minutes = parseInt(token[2], 10);
    if (!validateTimezone(hours, minutes)) {
      return NaN;
    }
    absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR$1 + minutes * MILLISECONDS_IN_MINUTE$2;
    return hours > 0 ? -absoluteOffset : absoluteOffset;
  }
  if (isValidTimezoneIANAString(timezoneString)) {
    date4 = new Date(date4 || Date.now());
    var utcDate = isUtcDate ? date4 : toUtcDate(date4);
    var offset = calcOffset(utcDate, timezoneString);
    var fixedOffset = isUtcDate ? offset : fixOffset(date4, offset, timezoneString);
    return -fixedOffset;
  }
  return NaN;
}
function toUtcDate(date4) {
  return newDateUTC(date4.getFullYear(), date4.getMonth(), date4.getDate(), date4.getHours(), date4.getMinutes(), date4.getSeconds(), date4.getMilliseconds());
}
function calcOffset(date4, timezoneString) {
  var tokens = tzTokenizeDate(date4, timezoneString);
  var asUTC = newDateUTC(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
  var asTS = date4.getTime();
  var over = asTS % 1e3;
  asTS -= over >= 0 ? over : 1e3 + over;
  return asUTC - asTS;
}
function fixOffset(date4, offset, timezoneString) {
  var localTS = date4.getTime();
  var utcGuess = localTS - offset;
  var o2 = calcOffset(new Date(utcGuess), timezoneString);
  if (offset === o2) {
    return offset;
  }
  utcGuess -= o2 - offset;
  var o3 = calcOffset(new Date(utcGuess), timezoneString);
  if (o2 === o3) {
    return o2;
  }
  return Math.max(o2, o3);
}
function validateTimezone(hours, minutes) {
  return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var validIANATimezoneCache = {};
function isValidTimezoneIANAString(timeZoneString) {
  if (validIANATimezoneCache[timeZoneString])
    return true;
  try {
    new Intl.DateTimeFormat(void 0, { timeZone: timeZoneString });
    validIANATimezoneCache[timeZoneString] = true;
    return true;
  } catch (error) {
    return false;
  }
}
var MILLISECONDS_IN_MINUTE$1 = 60 * 1e3;
var formatters = {
  X: function(date4, token, localize2, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date4);
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  x: function(date4, token, localize2, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date4);
    switch (token) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  O: function(date4, token, localize2, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date4);
    switch (token) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  z: function(date4, token, localize2, options) {
    var originalDate = options._originalDate || date4;
    switch (token) {
      case "z":
      case "zz":
      case "zzz":
        return tzIntlTimeZoneName("short", originalDate, options);
      case "zzzz":
      default:
        return tzIntlTimeZoneName("long", originalDate, options);
    }
  }
};
function getTimeZoneOffset(timeZone, originalDate) {
  var timeZoneOffset = timeZone ? tzParseTimezone(timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE$1 : originalDate.getTimezoneOffset();
  if (Number.isNaN(timeZoneOffset)) {
    throw new RangeError("Invalid time zone specified: " + timeZone);
  }
  return timeZoneOffset;
}
function addLeadingZeros(number4, targetLength) {
  var sign = number4 < 0 ? "-" : "";
  var output = Math.abs(number4).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign + output;
}
function formatTimezone(offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || "";
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(Math.floor(absOffset % 60), 2);
  return sign + hours + delimeter + minutes;
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimeter);
}
function formatTimezoneShort(offset, dirtyDelimeter) {
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimeter = dirtyDelimeter || "";
  return sign + String(hours) + delimeter + addLeadingZeros(minutes, 2);
}
var formatters$1 = formatters;
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var tzPattern$1 = tzPattern;
var MILLISECONDS_IN_HOUR = 36e5;
var MILLISECONDS_IN_MINUTE = 6e4;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    /^([+-]\d{3})$/,
    /^([+-]\d{4})$/
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    /^([+-]\d{5})/,
    /^([+-]\d{6})/
  ],
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  timeZone: tzPattern$1
};
function toDate(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  }
  if (argument === null) {
    return new Date(NaN);
  }
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  }
  if (argument instanceof Date || typeof argument === "object" && Object.prototype.toString.call(argument) === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || Object.prototype.toString.call(argument) === "[object Number]") {
    return new Date(argument);
  } else if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;
  var date4 = parseDate(restDateString, year);
  if (isNaN(date4)) {
    return new Date(NaN);
  }
  if (date4) {
    var timestamp = date4.getTime();
    var time2 = 0;
    var offset;
    if (dateStrings.time) {
      time2 = parseTime(dateStrings.time);
      if (isNaN(time2)) {
        return new Date(NaN);
      }
    }
    if (dateStrings.timeZone || options.timeZone) {
      offset = tzParseTimezone(dateStrings.timeZone || options.timeZone, new Date(timestamp + time2));
      if (isNaN(offset)) {
        return new Date(NaN);
      }
    } else {
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time2));
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time2 + offset));
    }
    return new Date(timestamp + time2 + offset);
  } else {
    return new Date(NaN);
  }
}
function splitDateString(dateString) {
  var dateStrings = {};
  var parts = patterns.dateTimePattern.exec(dateString);
  var timeString;
  if (!parts) {
    parts = patterns.datePattern.exec(dateString);
    if (parts) {
      dateStrings.date = parts[1];
      timeString = parts[2];
    } else {
      dateStrings.date = null;
      timeString = dateString;
    }
  } else {
    dateStrings.date = parts[1];
    timeString = parts[3];
  }
  if (timeString) {
    var token = patterns.timeZone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], "");
      dateStrings.timeZone = token[1].trim();
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];
  var token;
  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    };
  }
  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    };
  }
  return {
    year: null
  };
}
function parseDate(dateString, year) {
  if (year === null) {
    return null;
  }
  var token;
  var date4;
  var month;
  var week;
  if (dateString.length === 0) {
    date4 = new Date(0);
    date4.setUTCFullYear(year);
    return date4;
  }
  token = patterns.MM.exec(dateString);
  if (token) {
    date4 = new Date(0);
    month = parseInt(token[1], 10) - 1;
    if (!validateDate(year, month)) {
      return new Date(NaN);
    }
    date4.setUTCFullYear(year, month);
    return date4;
  }
  token = patterns.DDD.exec(dateString);
  if (token) {
    date4 = new Date(0);
    var dayOfYear = parseInt(token[1], 10);
    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date4.setUTCFullYear(year, 0, dayOfYear);
    return date4;
  }
  token = patterns.MMDD.exec(dateString);
  if (token) {
    date4 = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);
    if (!validateDate(year, month, day)) {
      return new Date(NaN);
    }
    date4.setUTCFullYear(year, month, day);
    return date4;
  }
  token = patterns.Www.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    if (!validateWeekDate(year, week)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week);
  }
  token = patterns.WwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  }
  return null;
}
function parseTime(timeString) {
  var token;
  var hours;
  var minutes;
  token = patterns.HH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(",", "."));
    if (!validateTime(hours)) {
      return NaN;
    }
    return hours % 24 * MILLISECONDS_IN_HOUR;
  }
  token = patterns.HHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(",", "."));
    if (!validateTime(hours, minutes)) {
      return NaN;
    }
    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
  }
  token = patterns.HHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(",", "."));
    if (!validateTime(hours, minutes, seconds)) {
      return NaN;
    }
    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1e3;
  }
  return null;
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date4 = new Date(0);
  date4.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date4.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date4.setUTCDate(date4.getUTCDate() + diff);
  return date4;
}
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date4) {
  if (month < 0 || month > 11) {
    return false;
  }
  if (date4 != null) {
    if (date4 < 1) {
      return false;
    }
    var isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && date4 > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false;
    }
    if (!isLeapYear && date4 > DAYS_IN_MONTH[month]) {
      return false;
    }
  }
  return true;
}
function validateDayOfYearDate(year, dayOfYear) {
  if (dayOfYear < 1) {
    return false;
  }
  var isLeapYear = isLeapYearIndex(year);
  if (isLeapYear && dayOfYear > 366) {
    return false;
  }
  if (!isLeapYear && dayOfYear > 365) {
    return false;
  }
  return true;
}
function validateWeekDate(year, week, day) {
  if (week < 0 || week > 52) {
    return false;
  }
  if (day != null && (day < 0 || day > 6)) {
    return false;
  }
  return true;
}
function validateTime(hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false;
  }
  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false;
  }
  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false;
  }
  return true;
}
var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function format$2(dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var matches = formatStr.match(tzFormattingTokensRegExp);
  if (matches) {
    var date4 = toDate(dirtyDate, options);
    formatStr = matches.reduce(function(result2, token) {
      if (token[0] === "'") {
        return result2;
      }
      var pos = result2.indexOf(token);
      var precededByQuotedSection = result2[pos - 1] === "'";
      var replaced = result2.replace(token, "'" + formatters$1[token[0]](date4, token, null, options) + "'");
      return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
    }, formatStr);
  }
  return dateFnsFormat(dirtyDate, formatStr, options);
}
function utcToZonedTime(dirtyDate, timeZone, options) {
  var date4 = toDate(dirtyDate, options);
  var offsetMilliseconds = tzParseTimezone(timeZone, date4, true);
  var d2 = new Date(date4.getTime() - offsetMilliseconds);
  var resultDate = new Date(0);
  resultDate.setFullYear(d2.getUTCFullYear(), d2.getUTCMonth(), d2.getUTCDate());
  resultDate.setHours(d2.getUTCHours(), d2.getUTCMinutes(), d2.getUTCSeconds(), d2.getUTCMilliseconds());
  return resultDate;
}
function formatInTimeZone(date4, timeZone, formatStr, options) {
  var extendedOptions = cloneObject(options);
  extendedOptions.timeZone = timeZone;
  return format$2(utcToZonedTime(date4, timeZone), formatStr, extendedOptions);
}
const time$1 = {
  amHours: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11"
  ],
  pmHours: [
    "12",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11"
  ],
  hours: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23"
  ],
  minutes: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59"
  ],
  seconds: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59"
  ],
  period: ["AM", "PM"]
};
function getFixValue(value2) {
  return `00${value2}`.slice(-2);
}
function getTimeUnits(defaultValue, stepOrList, isHourWithAmPm) {
  if (Array.isArray(stepOrList)) {
    return (isHourWithAmPm === "am" ? stepOrList.filter((v2) => v2 < 12) : isHourWithAmPm === "pm" ? stepOrList.filter((v2) => v2 >= 12).map((v2) => v2 === 12 ? 12 : v2 - 12) : stepOrList).map((v2) => getFixValue(v2));
  } else if (typeof stepOrList === "number") {
    if (isHourWithAmPm === "am") {
      return defaultValue.filter((hour) => {
        const hourAsNumber = Number(hour);
        return hourAsNumber < 12 && hourAsNumber % stepOrList === 0;
      });
    } else if (isHourWithAmPm === "pm") {
      return defaultValue.filter((hour) => {
        const hourAsNumber = Number(hour);
        return hourAsNumber >= 12 && hourAsNumber % stepOrList === 0;
      }).map((hour) => {
        const hourAsNumber = Number(hour);
        return getFixValue(hourAsNumber === 12 ? 12 : hourAsNumber - 12);
      });
    }
    return defaultValue.filter((hour) => {
      return Number(hour) % stepOrList === 0;
    });
  } else {
    return isHourWithAmPm === "am" ? defaultValue.filter((hour) => Number(hour) < 12) : isHourWithAmPm === "pm" ? defaultValue.map((hour) => Number(hour)).filter((hour) => Number(hour) >= 12).map((v2) => getFixValue(v2 === 12 ? 12 : v2 - 12)) : defaultValue;
  }
}
function isTimeInStep(value2, type4, stepOrList) {
  if (!stepOrList) {
    return true;
  } else if (typeof stepOrList === "number") {
    return value2 % stepOrList === 0;
  } else {
    return stepOrList.includes(value2);
  }
}
function findSimilarTime(value2, type4, stepOrList) {
  const list = getTimeUnits(time$1[type4], stepOrList).map(Number);
  let lowerBound, upperBound;
  for (let i2 = 0; i2 < list.length; ++i2) {
    const v2 = list[i2];
    if (v2 === value2)
      return v2;
    else if (v2 > value2) {
      upperBound = v2;
      break;
    }
    lowerBound = v2;
  }
  if (lowerBound === void 0) {
    if (!upperBound) {
      throwError("time-picker", "Please set 'hours' or 'minutes' or 'seconds' props");
    }
    return upperBound;
  }
  if (upperBound === void 0) {
    return lowerBound;
  }
  return upperBound - value2 > value2 - lowerBound ? lowerBound : upperBound;
}
function getAmPm(value2) {
  return getHours(value2) < 12 ? "am" : "pm";
}
const timePickerInjectionKey = createInjectionKey("n-time-picker");
var PanelCol = defineComponent({
  name: "TimePickerPanelCol",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    activeValue: {
      type: Number,
      default: null
    },
    onItemClick: Function
  },
  render() {
    const { activeValue, onItemClick, clsPrefix } = this;
    return this.data.map((item) => {
      const { label, disabled, value: value2 } = item;
      const active = activeValue === value2;
      return h$1("div", { key: label, "data-active": active ? "" : null, class: [
        `${clsPrefix}-time-picker-col__item`,
        active && `${clsPrefix}-time-picker-col__item--active`,
        disabled && `${clsPrefix}-time-picker-col__item--disabled`
      ], onClick: onItemClick && !disabled ? () => {
        onItemClick(value2);
      } : void 0 }, label);
    });
  }
});
const timePickerPanelProps = {
  actions: {
    type: Array,
    default: () => ["now", "confirm"]
  },
  showHour: {
    type: Boolean,
    default: true
  },
  showMinute: {
    type: Boolean,
    default: true
  },
  showSecond: {
    type: Boolean,
    default: true
  },
  showPeriod: {
    type: Boolean,
    default: true
  },
  isHourInvalid: Boolean,
  isMinuteInvalid: Boolean,
  isSecondInvalid: Boolean,
  isAmPmInvalid: Boolean,
  isValueInvalid: Boolean,
  hourValue: {
    type: Number,
    default: null
  },
  minuteValue: {
    type: Number,
    default: null
  },
  secondValue: {
    type: Number,
    default: null
  },
  amPmValue: {
    type: String,
    default: null
  },
  isHourDisabled: Function,
  isMinuteDisabled: Function,
  isSecondDisabled: Function,
  onHourClick: {
    type: Function,
    required: true
  },
  onMinuteClick: {
    type: Function,
    required: true
  },
  onSecondClick: {
    type: Function,
    required: true
  },
  onAmPmClick: {
    type: Function,
    required: true
  },
  onNowClick: Function,
  nowText: String,
  confirmText: String,
  transitionDisabled: Boolean,
  onConfirmClick: Function,
  onFocusin: Function,
  onFocusout: Function,
  onFocusDetectorFocus: Function,
  onKeydown: Function,
  hours: [Number, Array],
  minutes: [Number, Array],
  seconds: [Number, Array],
  use12Hours: Boolean
};
var Panel = defineComponent({
  name: "TimePickerPanel",
  props: timePickerPanelProps,
  setup(props) {
    const {
      mergedThemeRef,
      mergedClsPrefixRef
    } = inject(timePickerInjectionKey);
    const hoursRef = computed(() => {
      const { isHourDisabled, hours, use12Hours, amPmValue } = props;
      if (!use12Hours) {
        return getTimeUnits(time$1.hours, hours).map((hour) => {
          return {
            label: hour,
            value: Number(hour),
            disabled: isHourDisabled ? isHourDisabled(Number(hour)) : false
          };
        });
      } else {
        const mergedAmPmValue = amPmValue !== null && amPmValue !== void 0 ? amPmValue : getAmPm(Date.now());
        return getTimeUnits(time$1.hours, hours, mergedAmPmValue).map((hour) => {
          const hourAs12FormattedNumber = Number(hour);
          const hourAs24FormattedNumber = mergedAmPmValue === "pm" && hourAs12FormattedNumber !== 12 ? hourAs12FormattedNumber + 12 : hourAs12FormattedNumber;
          return {
            label: hour,
            value: hourAs24FormattedNumber,
            disabled: isHourDisabled ? isHourDisabled(hourAs24FormattedNumber) : false
          };
        });
      }
    });
    const minutesRef = computed(() => {
      const { isMinuteDisabled, minutes } = props;
      return getTimeUnits(time$1.minutes, minutes).map((minute) => {
        return {
          label: minute,
          value: Number(minute),
          disabled: isMinuteDisabled ? isMinuteDisabled(Number(minute), props.hourValue) : false
        };
      });
    });
    const secondsRef = computed(() => {
      const { isSecondDisabled, seconds } = props;
      return getTimeUnits(time$1.seconds, seconds).map((second) => {
        return {
          label: second,
          value: Number(second),
          disabled: isSecondDisabled ? isSecondDisabled(Number(second), props.minuteValue, props.hourValue) : false
        };
      });
    });
    const amPmRef = computed(() => {
      const { isHourDisabled } = props;
      let amDisabled = true;
      let pmDisabled = true;
      for (let i2 = 0; i2 < 12; ++i2) {
        if (!(isHourDisabled === null || isHourDisabled === void 0 ? void 0 : isHourDisabled(i2))) {
          amDisabled = false;
          break;
        }
      }
      for (let i2 = 12; i2 < 24; ++i2) {
        if (!(isHourDisabled === null || isHourDisabled === void 0 ? void 0 : isHourDisabled(i2))) {
          pmDisabled = false;
          break;
        }
      }
      return [
        {
          label: "AM",
          value: "am",
          disabled: amDisabled
        },
        {
          label: "PM",
          value: "pm",
          disabled: pmDisabled
        }
      ];
    });
    return {
      mergedTheme: mergedThemeRef,
      mergedClsPrefix: mergedClsPrefixRef,
      hours: hoursRef,
      minutes: minutesRef,
      seconds: secondsRef,
      amPm: amPmRef,
      hourScrollRef: ref(null),
      minuteScrollRef: ref(null),
      secondScrollRef: ref(null),
      amPmScrollRef: ref(null)
    };
  },
  render() {
    var _a2, _b2, _c2;
    const { mergedClsPrefix, mergedTheme } = this;
    return h$1("div", { tabindex: 0, class: `${mergedClsPrefix}-time-picker-panel`, onFocusin: this.onFocusin, onFocusout: this.onFocusout, onKeydown: this.onKeydown }, h$1("div", { class: `${mergedClsPrefix}-time-picker-cols` }, this.showHour ? h$1("div", { class: [
      `${mergedClsPrefix}-time-picker-col`,
      this.isHourInvalid && `${mergedClsPrefix}-time-picker-col--invalid`,
      this.transitionDisabled && `${mergedClsPrefix}-time-picker-col--transition-disabled`
    ] }, h$1(NScrollbar, { ref: "hourScrollRef", theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar }, {
      default: () => [
        h$1(PanelCol, { clsPrefix: mergedClsPrefix, data: this.hours, activeValue: this.hourValue, onItemClick: this.onHourClick }),
        h$1("div", { class: `${mergedClsPrefix}-time-picker-col__padding` })
      ]
    })) : null, this.showMinute ? h$1("div", { class: [
      `${mergedClsPrefix}-time-picker-col`,
      this.transitionDisabled && `${mergedClsPrefix}-time-picker-col--transition-disabled`,
      this.isMinuteInvalid && `${mergedClsPrefix}-time-picker-col--invalid`
    ] }, h$1(NScrollbar, { ref: "minuteScrollRef", theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar }, {
      default: () => [
        h$1(PanelCol, { clsPrefix: mergedClsPrefix, data: this.minutes, activeValue: this.minuteValue, onItemClick: this.onMinuteClick }),
        h$1("div", { class: `${mergedClsPrefix}-time-picker-col__padding` })
      ]
    })) : null, this.showSecond ? h$1("div", { class: [
      `${mergedClsPrefix}-time-picker-col`,
      this.isSecondInvalid && `${mergedClsPrefix}-time-picker-col--invalid`,
      this.transitionDisabled && `${mergedClsPrefix}-time-picker-col--transition-disabled`
    ] }, h$1(NScrollbar, { ref: "secondScrollRef", theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar }, {
      default: () => [
        h$1(PanelCol, { clsPrefix: mergedClsPrefix, data: this.seconds, activeValue: this.secondValue, onItemClick: this.onSecondClick }),
        h$1("div", { class: `${mergedClsPrefix}-time-picker-col__padding` })
      ]
    })) : null, this.use12Hours ? h$1("div", { class: [
      `${mergedClsPrefix}-time-picker-col`,
      this.isAmPmInvalid && `${mergedClsPrefix}-time-picker-col--invalid`,
      this.transitionDisabled && `${mergedClsPrefix}-time-picker-col--transition-disabled`
    ] }, h$1(NScrollbar, { ref: "amPmScrollRef", theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar }, {
      default: () => [
        h$1(PanelCol, { clsPrefix: mergedClsPrefix, data: this.amPm, activeValue: this.amPmValue, onItemClick: this.onAmPmClick }),
        h$1("div", { class: `${mergedClsPrefix}-time-picker-col__padding` })
      ]
    })) : null), ((_a2 = this.actions) === null || _a2 === void 0 ? void 0 : _a2.length) ? h$1("div", { class: `${mergedClsPrefix}-time-picker-actions` }, ((_b2 = this.actions) === null || _b2 === void 0 ? void 0 : _b2.includes("now")) ? h$1(NButton, { size: "tiny", theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, onClick: this.onNowClick }, { default: () => this.nowText }) : null, ((_c2 = this.actions) === null || _c2 === void 0 ? void 0 : _c2.includes("confirm")) ? h$1(NButton, { size: "tiny", type: "primary", class: `${mergedClsPrefix}-time-picker-actions__confirm`, theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, disabled: this.isValueInvalid, onClick: this.onConfirmClick }, { default: () => this.confirmText }) : null) : null, h$1(FocusDetector, { onFocus: this.onFocusDetectorFocus }));
  }
});
var style$k = c$2([cB$1("time-picker", `
 z-index: auto;
 position: relative;
 `, [cB$1("time-picker-icon", `
 color: var(--n-icon-color-override);
 transition: color .3s var(--n-bezier);
 `), cM("disabled", [cB$1("time-picker-icon", `
 color: var(--n-icon-color-disabled-override);
 `)])]), cB$1("time-picker-panel", `
 transition:
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 outline: none;
 font-size: var(--n-item-font-size);
 border-radius: var(--n-border-radius);
 margin: 4px 0;
 min-width: 104px;
 overflow: hidden;
 background-color: var(--n-panel-color);
 box-shadow: var(--n-panel-box-shadow);
 `, [fadeInScaleUpTransition(), cB$1("time-picker-actions", `
 padding: var(--n-panel-action-padding);
 align-items: center;
 display: flex;
 justify-content: space-evenly;
 `), cB$1("time-picker-cols", `
 height: calc(var(--n-item-height) * 6);
 display: flex;
 position: relative;
 transition: border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-panel-divider-color);
 `), cB$1("time-picker-col", `
 flex-grow: 1;
 min-width: var(--n-item-width);
 height: calc(var(--n-item-height) * 6);
 flex-direction: column;
 transition: box-shadow .3s var(--n-bezier);
 `, [cM("transition-disabled", [cE$1("item", "transition: none;", [c$2("&::before", "transition: none;")])]), cE$1("padding", `
 height: calc(var(--n-item-height) * 5);
 `), c$2("&:first-child", "min-width: calc(var(--n-item-width) + 4px);", [cE$1("item", [c$2("&::before", "left: 4px;")])]), cE$1("item", `
 cursor: pointer;
 height: var(--n-item-height);
 display: flex;
 align-items: center;
 justify-content: center;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier);
 background: #0000;
 text-decoration-color: #0000;
 color: var(--n-item-text-color);
 z-index: 0;
 box-sizing: border-box;
 padding-top: 4px;
 position: relative;
 `, [c$2("&::before", `
 content: "";
 transition: background-color .3s var(--n-bezier);
 z-index: -1;
 position: absolute;
 left: 0;
 right: 4px;
 top: 4px;
 bottom: 0;
 border-radius: var(--n-item-border-radius);
 `), cNotM("disabled", [c$2("&:hover::before", `
 background-color: var(--n-item-color-hover);
 `)]), cM("active", `
 color: var(--n-item-text-color-active);
 `, [c$2("&::before", `
 background-color: var(--n-item-color-hover);
 `)]), cM("disabled", `
 opacity: var(--n-item-opacity-disabled);
 cursor: not-allowed;
 `)]), cM("invalid", [cE$1("item", [cM("active", `
 text-decoration: line-through;
 text-decoration-color: var(--n-item-text-color-active);
 `)])])])])]);
function validateUnits(value2, max) {
  if (value2 === void 0) {
    return true;
  }
  if (Array.isArray(value2)) {
    return value2.every((v2) => v2 >= 0 && v2 <= max);
  } else {
    return value2 >= 0 && value2 <= max;
  }
}
const timePickerProps = Object.assign(Object.assign({}, useTheme.props), {
  to: useAdjustedTo.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  actions: Array,
  defaultValue: {
    type: Number,
    default: null
  },
  defaultFormattedValue: String,
  placeholder: String,
  placement: {
    type: String,
    default: "bottom-start"
  },
  value: Number,
  format: {
    type: String,
    default: "HH:mm:ss"
  },
  valueFormat: String,
  formattedValue: String,
  isHourDisabled: Function,
  size: String,
  isMinuteDisabled: Function,
  isSecondDisabled: Function,
  inputReadonly: Boolean,
  clearable: Boolean,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onUpdateFormattedValue: [Function, Array],
  "onUpdate:formattedValue": [Function, Array],
  onBlur: [Function, Array],
  onConfirm: [Function, Array],
  onClear: Function,
  onFocus: [Function, Array],
  timeZone: String,
  showIcon: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  show: {
    type: Boolean,
    default: void 0
  },
  hours: {
    type: [Number, Array],
    validator: (value2) => validateUnits(value2, 23)
  },
  minutes: {
    type: [Number, Array],
    validator: (value2) => validateUnits(value2, 59)
  },
  seconds: {
    type: [Number, Array],
    validator: (value2) => validateUnits(value2, 59)
  },
  use12Hours: Boolean,
  stateful: {
    type: Boolean,
    default: true
  },
  onChange: [Function, Array]
});
var NTimePicker = defineComponent({
  name: "TimePicker",
  props: timePickerProps,
  setup(props) {
    const { mergedBorderedRef, mergedClsPrefixRef, namespaceRef, inlineThemeDisabled } = useConfig(props);
    const { localeRef, dateLocaleRef } = useLocale("TimePicker");
    const formItem = useFormItem(props);
    const { mergedSizeRef, mergedDisabledRef, mergedStatusRef } = formItem;
    const themeRef = useTheme("TimePicker", "-time-picker", style$k, timePickerLight$1, props, mergedClsPrefixRef);
    const keyboardState = useKeyboard();
    const inputInstRef = ref(null);
    const panelInstRef = ref(null);
    const dateFnsOptionsRef = computed(() => {
      return {
        locale: dateLocaleRef.value.locale
      };
    });
    function getTimestampFromFormattedValue(value2) {
      if (value2 === null)
        return null;
      return strictParse(value2, props.valueFormat || props.format, new Date(), dateFnsOptionsRef.value).getTime();
    }
    const { defaultValue, defaultFormattedValue } = props;
    const uncontrolledValueRef = ref(defaultFormattedValue !== void 0 ? getTimestampFromFormattedValue(defaultFormattedValue) : defaultValue);
    const mergedValueRef = computed(() => {
      const { formattedValue } = props;
      if (formattedValue !== void 0) {
        return getTimestampFromFormattedValue(formattedValue);
      }
      const { value: value2 } = props;
      if (value2 !== void 0) {
        return value2;
      }
      return uncontrolledValueRef.value;
    });
    const mergedFormatRef = computed(() => {
      const { timeZone } = props;
      if (timeZone) {
        return (date4, format2, options) => {
          return formatInTimeZone(date4, timeZone, format2, options);
        };
      } else {
        return (date4, _format, options) => {
          return format$4(date4, _format, options);
        };
      }
    });
    const displayTimeStringRef = ref("");
    watch(() => props.timeZone, () => {
      const mergedValue = mergedValueRef.value;
      displayTimeStringRef.value = mergedValue === null ? "" : mergedFormatRef.value(mergedValue, props.format, dateFnsOptionsRef.value);
    }, {
      immediate: true
    });
    const uncontrolledShowRef = ref(false);
    const controlledShowRef = toRef(props, "show");
    const mergedShowRef = useMergedState(controlledShowRef, uncontrolledShowRef);
    const memorizedValueRef = ref(mergedValueRef.value);
    const transitionDisabledRef = ref(false);
    const localizedNowRef = computed(() => {
      return localeRef.value.now;
    });
    const localizedPlaceholderRef = computed(() => {
      if (props.placeholder !== void 0)
        return props.placeholder;
      return localeRef.value.placeholder;
    });
    const localizedNegativeTextRef = computed(() => {
      return localeRef.value.negativeText;
    });
    const localizedPositiveTextRef = computed(() => {
      return localeRef.value.positiveText;
    });
    const hourInFormatRef = computed(() => {
      return /H|h|K|k/.test(props.format);
    });
    const minuteInFormatRef = computed(() => {
      return props.format.includes("m");
    });
    const secondInFormatRef = computed(() => {
      return props.format.includes("s");
    });
    const isHourInvalidRef = computed(() => {
      const { isHourDisabled } = props;
      if (hourValueRef.value === null)
        return false;
      if (!isTimeInStep(hourValueRef.value, "hours", props.hours))
        return true;
      if (!isHourDisabled)
        return false;
      return isHourDisabled(hourValueRef.value);
    });
    const isMinuteInvalidRef = computed(() => {
      const { value: minuteValue } = minuteValueRef;
      const { value: hourValue } = hourValueRef;
      if (minuteValue === null || hourValue === null)
        return false;
      if (!isTimeInStep(minuteValue, "minutes", props.minutes))
        return true;
      const { isMinuteDisabled } = props;
      if (!isMinuteDisabled)
        return false;
      return isMinuteDisabled(minuteValue, hourValue);
    });
    const isSecondInvalidRef = computed(() => {
      const { value: minuteValue } = minuteValueRef;
      const { value: hourValue } = hourValueRef;
      const { value: secondValue } = secondValueRef;
      if (secondValue === null || minuteValue === null || hourValue === null) {
        return false;
      }
      if (!isTimeInStep(secondValue, "seconds", props.seconds))
        return true;
      const { isSecondDisabled } = props;
      if (!isSecondDisabled)
        return false;
      return isSecondDisabled(secondValue, minuteValue, hourValue);
    });
    const isValueInvalidRef = computed(() => {
      return isHourInvalidRef.value || isMinuteInvalidRef.value || isSecondInvalidRef.value;
    });
    const mergedAttrSizeRef = computed(() => {
      return props.format.length + 4;
    });
    const amPmValueRef = computed(() => {
      const { value: value2 } = mergedValueRef;
      if (value2 === null)
        return null;
      return getHours(value2) < 12 ? "am" : "pm";
    });
    const hourValueRef = computed(() => {
      const { value: value2 } = mergedValueRef;
      if (value2 === null)
        return null;
      return Number(mergedFormatRef.value(value2, "HH", dateFnsOptionsRef.value));
    });
    const minuteValueRef = computed(() => {
      const { value: value2 } = mergedValueRef;
      if (value2 === null)
        return null;
      return Number(mergedFormatRef.value(value2, "mm", dateFnsOptionsRef.value));
    });
    const secondValueRef = computed(() => {
      const { value: value2 } = mergedValueRef;
      if (value2 === null)
        return null;
      return Number(mergedFormatRef.value(value2, "ss", dateFnsOptionsRef.value));
    });
    function doUpdateFormattedValue(value2, timestampValue) {
      const { onUpdateFormattedValue, "onUpdate:formattedValue": _onUpdateFormattedValue } = props;
      if (onUpdateFormattedValue) {
        call(onUpdateFormattedValue, value2, timestampValue);
      }
      if (_onUpdateFormattedValue) {
        call(_onUpdateFormattedValue, value2, timestampValue);
      }
    }
    function createFormattedValue(value2) {
      return value2 === null ? null : mergedFormatRef.value(value2, props.valueFormat || props.format);
    }
    function doUpdateValue(value2) {
      const { onUpdateValue, "onUpdate:value": _onUpdateValue, onChange } = props;
      const { nTriggerFormChange, nTriggerFormInput } = formItem;
      const formattedValue = createFormattedValue(value2);
      if (onUpdateValue) {
        call(onUpdateValue, value2, formattedValue);
      }
      if (_onUpdateValue) {
        call(_onUpdateValue, value2, formattedValue);
      }
      if (onChange)
        call(onChange, value2, formattedValue);
      doUpdateFormattedValue(formattedValue, value2);
      uncontrolledValueRef.value = value2;
      nTriggerFormChange();
      nTriggerFormInput();
    }
    function doFocus(e25) {
      const { onFocus } = props;
      const { nTriggerFormFocus } = formItem;
      if (onFocus)
        call(onFocus, e25);
      nTriggerFormFocus();
    }
    function doBlur(e25) {
      const { onBlur } = props;
      const { nTriggerFormBlur } = formItem;
      if (onBlur)
        call(onBlur, e25);
      nTriggerFormBlur();
    }
    function doConfirm() {
      const { onConfirm } = props;
      if (onConfirm) {
        call(onConfirm, mergedValueRef.value, createFormattedValue(mergedValueRef.value));
      }
    }
    function handleTimeInputClear(e25) {
      var _a2;
      e25.stopPropagation();
      doUpdateValue(null);
      deriveInputValue(null);
      (_a2 = props.onClear) === null || _a2 === void 0 ? void 0 : _a2.call(props);
    }
    function handleFocusDetectorFocus() {
      closePanel({
        returnFocus: true
      });
    }
    function handleInputKeydown(e25) {
      if (e25.key === "Escape" && mergedShowRef.value) {
        markEventEffectPerformed(e25);
      }
    }
    function handleMenuKeydown(e25) {
      var _a2;
      switch (e25.key) {
        case "Escape":
          if (mergedShowRef.value) {
            markEventEffectPerformed(e25);
            closePanel({
              returnFocus: true
            });
          }
          break;
        case "Tab":
          if (keyboardState.shift && e25.target === ((_a2 = panelInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.$el)) {
            e25.preventDefault();
            closePanel({
              returnFocus: true
            });
          }
          break;
      }
    }
    function disableTransitionOneTick() {
      transitionDisabledRef.value = true;
      void nextTick(() => {
        transitionDisabledRef.value = false;
      });
    }
    function handleTriggerClick(e25) {
      if (mergedDisabledRef.value || happensIn(e25, "clear"))
        return;
      if (!mergedShowRef.value) {
        openPanel();
      }
    }
    function handleHourClick(hour) {
      if (typeof hour === "string")
        return;
      if (mergedValueRef.value === null) {
        doUpdateValue(getTime(setHours(startOfHour(new Date()), hour)));
      } else {
        doUpdateValue(getTime(setHours(mergedValueRef.value, hour)));
      }
    }
    function handleMinuteClick(minute) {
      if (typeof minute === "string")
        return;
      if (mergedValueRef.value === null) {
        doUpdateValue(getTime(setMinutes(startOfMinute(new Date()), minute)));
      } else {
        doUpdateValue(getTime(setMinutes(mergedValueRef.value, minute)));
      }
    }
    function handleSecondClick(second) {
      if (typeof second === "string")
        return;
      if (mergedValueRef.value === null) {
        doUpdateValue(getTime(setSeconds(startOfSecond(new Date()), second)));
      } else {
        doUpdateValue(getTime(setSeconds(mergedValueRef.value, second)));
      }
    }
    function handleAmPmClick(amPm) {
      const { value: mergedValue } = mergedValueRef;
      if (mergedValue === null) {
        const now2 = new Date();
        const hours = getHours(now2);
        if (amPm === "pm" && hours < 12) {
          doUpdateValue(getTime(setHours(now2, hours + 12)));
        } else if (amPm === "am" && hours >= 12) {
          doUpdateValue(getTime(setHours(now2, hours - 12)));
        }
        doUpdateValue(getTime(now2));
      } else {
        const hours = getHours(mergedValue);
        if (amPm === "pm" && hours < 12) {
          doUpdateValue(getTime(setHours(mergedValue, hours + 12)));
        } else if (amPm === "am" && hours >= 12) {
          doUpdateValue(getTime(setHours(mergedValue, hours - 12)));
        }
      }
    }
    function deriveInputValue(time2) {
      if (time2 === void 0)
        time2 = mergedValueRef.value;
      if (time2 === null)
        displayTimeStringRef.value = "";
      else {
        displayTimeStringRef.value = mergedFormatRef.value(time2, props.format, dateFnsOptionsRef.value);
      }
    }
    function handleTimeInputFocus(e25) {
      if (isInternalFocusSwitch(e25))
        return;
      doFocus(e25);
    }
    function handleTimeInputBlur(e25) {
      var _a2;
      if (isInternalFocusSwitch(e25))
        return;
      if (mergedShowRef.value) {
        const panelEl = (_a2 = panelInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.$el;
        if (!(panelEl === null || panelEl === void 0 ? void 0 : panelEl.contains(e25.relatedTarget))) {
          deriveInputValue();
          doBlur(e25);
          closePanel({
            returnFocus: false
          });
        }
      } else {
        deriveInputValue();
        doBlur(e25);
      }
    }
    function handleTimeInputActivate() {
      if (mergedDisabledRef.value)
        return;
      if (!mergedShowRef.value) {
        openPanel();
      }
    }
    function handleTimeInputDeactivate() {
      if (mergedDisabledRef.value)
        return;
      deriveInputValue();
      closePanel({
        returnFocus: false
      });
    }
    function scrollTimer() {
      if (!panelInstRef.value)
        return;
      const { hourScrollRef, minuteScrollRef, secondScrollRef, amPmScrollRef } = panelInstRef.value;
      [hourScrollRef, minuteScrollRef, secondScrollRef, amPmScrollRef].forEach((itemScrollRef) => {
        var _a2;
        if (!itemScrollRef)
          return;
        const activeItemEl = (_a2 = itemScrollRef.contentRef) === null || _a2 === void 0 ? void 0 : _a2.querySelector("[data-active]");
        if (activeItemEl) {
          itemScrollRef.scrollTo({
            top: activeItemEl.offsetTop
          });
        }
      });
    }
    function doUpdateShow(value2) {
      uncontrolledShowRef.value = value2;
      const { onUpdateShow, "onUpdate:show": _onUpdateShow } = props;
      if (onUpdateShow)
        call(onUpdateShow, value2);
      if (_onUpdateShow)
        call(_onUpdateShow, value2);
    }
    function isInternalFocusSwitch(e25) {
      var _a2, _b2, _c2;
      return !!(((_b2 = (_a2 = inputInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.wrapperElRef) === null || _b2 === void 0 ? void 0 : _b2.contains(e25.relatedTarget)) || ((_c2 = panelInstRef.value) === null || _c2 === void 0 ? void 0 : _c2.$el.contains(e25.relatedTarget)));
    }
    function openPanel() {
      memorizedValueRef.value = mergedValueRef.value;
      doUpdateShow(true);
      void nextTick(scrollTimer);
    }
    function handleClickOutside(e25) {
      var _a2, _b2;
      if (mergedShowRef.value && !((_b2 = (_a2 = inputInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.wrapperElRef) === null || _b2 === void 0 ? void 0 : _b2.contains(getPreciseEventTarget(e25)))) {
        closePanel({
          returnFocus: false
        });
      }
    }
    function closePanel({ returnFocus }) {
      var _a2;
      if (mergedShowRef.value) {
        doUpdateShow(false);
        if (returnFocus) {
          (_a2 = inputInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
        }
      }
    }
    function handleTimeInputUpdateValue(v2) {
      if (v2 === "") {
        doUpdateValue(null);
        return;
      }
      const time2 = strictParse(v2, props.format, new Date(), dateFnsOptionsRef.value);
      displayTimeStringRef.value = v2;
      if (isValid$1(time2)) {
        const { value: mergedValue } = mergedValueRef;
        if (mergedValue !== null) {
          const newTime = set(mergedValue, {
            hours: getHours(time2),
            minutes: getMinutes(time2),
            seconds: getSeconds(time2)
          });
          doUpdateValue(getTime(newTime));
        } else {
          doUpdateValue(getTime(time2));
        }
      }
    }
    function handleCancelClick() {
      doUpdateValue(memorizedValueRef.value);
      doUpdateShow(false);
    }
    function handleNowClick() {
      const now2 = new Date();
      const getNowTime = {
        hours: getHours,
        minutes: getMinutes,
        seconds: getSeconds
      };
      const [mergeHours, mergeMinutes, mergeSeconds] = ["hours", "minutes", "seconds"].map((i2) => !props[i2] || isTimeInStep(getNowTime[i2](now2), i2, props[i2]) ? getNowTime[i2](now2) : findSimilarTime(getNowTime[i2](now2), i2, props[i2]));
      const newValue = setSeconds(setMinutes(setHours(mergedValueRef.value ? mergedValueRef.value : getTime(now2), mergeHours), mergeMinutes), mergeSeconds);
      doUpdateValue(getTime(newValue));
    }
    function handleConfirmClick() {
      deriveInputValue();
      doConfirm();
      closePanel({
        returnFocus: true
      });
    }
    function handleMenuFocusOut(e25) {
      if (isInternalFocusSwitch(e25))
        return;
      deriveInputValue();
      doBlur(e25);
      closePanel({
        returnFocus: false
      });
    }
    watch(mergedValueRef, (value2) => {
      deriveInputValue(value2);
      disableTransitionOneTick();
      void nextTick(scrollTimer);
    });
    watch(mergedShowRef, () => {
      if (isValueInvalidRef.value) {
        doUpdateValue(memorizedValueRef.value);
      }
    });
    provide(timePickerInjectionKey, {
      mergedThemeRef: themeRef,
      mergedClsPrefixRef
    });
    const exposedMethods = {
      focus: () => {
        var _a2;
        (_a2 = inputInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      blur: () => {
        var _a2;
        (_a2 = inputInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
      }
    };
    const triggerCssVarsRef = computed(() => {
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { iconColor, iconColorDisabled } } = themeRef.value;
      return {
        "--n-icon-color-override": iconColor,
        "--n-icon-color-disabled-override": iconColorDisabled,
        "--n-bezier": cubicBezierEaseInOut2
      };
    });
    const triggerThemeClassHandle = inlineThemeDisabled ? useThemeClass("time-picker-trigger", void 0, triggerCssVarsRef, props) : void 0;
    const cssVarsRef = computed(() => {
      const { self: { panelColor, itemTextColor, itemTextColorActive, itemColorHover, panelDividerColor, panelBoxShadow, itemOpacityDisabled, borderRadius, itemFontSize, itemWidth, itemHeight, panelActionPadding, itemBorderRadius }, common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-border-radius": borderRadius,
        "--n-item-color-hover": itemColorHover,
        "--n-item-font-size": itemFontSize,
        "--n-item-height": itemHeight,
        "--n-item-opacity-disabled": itemOpacityDisabled,
        "--n-item-text-color": itemTextColor,
        "--n-item-text-color-active": itemTextColorActive,
        "--n-item-width": itemWidth,
        "--n-panel-action-padding": panelActionPadding,
        "--n-panel-box-shadow": panelBoxShadow,
        "--n-panel-color": panelColor,
        "--n-panel-divider-color": panelDividerColor,
        "--n-item-border-radius": itemBorderRadius
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("time-picker", void 0, cssVarsRef, props) : void 0;
    return {
      focus: exposedMethods.focus,
      blur: exposedMethods.blur,
      mergedStatus: mergedStatusRef,
      mergedBordered: mergedBorderedRef,
      mergedClsPrefix: mergedClsPrefixRef,
      namespace: namespaceRef,
      uncontrolledValue: uncontrolledValueRef,
      mergedValue: mergedValueRef,
      isMounted: isMounted(),
      inputInstRef,
      panelInstRef,
      adjustedTo: useAdjustedTo(props),
      mergedShow: mergedShowRef,
      localizedNow: localizedNowRef,
      localizedPlaceholder: localizedPlaceholderRef,
      localizedNegativeText: localizedNegativeTextRef,
      localizedPositiveText: localizedPositiveTextRef,
      hourInFormat: hourInFormatRef,
      minuteInFormat: minuteInFormatRef,
      secondInFormat: secondInFormatRef,
      mergedAttrSize: mergedAttrSizeRef,
      displayTimeString: displayTimeStringRef,
      mergedSize: mergedSizeRef,
      mergedDisabled: mergedDisabledRef,
      isValueInvalid: isValueInvalidRef,
      isHourInvalid: isHourInvalidRef,
      isMinuteInvalid: isMinuteInvalidRef,
      isSecondInvalid: isSecondInvalidRef,
      transitionDisabled: transitionDisabledRef,
      hourValue: hourValueRef,
      minuteValue: minuteValueRef,
      secondValue: secondValueRef,
      amPmValue: amPmValueRef,
      handleInputKeydown,
      handleTimeInputFocus,
      handleTimeInputBlur,
      handleNowClick,
      handleConfirmClick,
      handleTimeInputUpdateValue,
      handleMenuFocusOut,
      handleCancelClick,
      handleClickOutside,
      handleTimeInputActivate,
      handleTimeInputDeactivate,
      handleHourClick,
      handleMinuteClick,
      handleSecondClick,
      handleAmPmClick,
      handleTimeInputClear,
      handleFocusDetectorFocus,
      handleMenuKeydown,
      handleTriggerClick,
      mergedTheme: themeRef,
      triggerCssVars: inlineThemeDisabled ? void 0 : triggerCssVarsRef,
      triggerThemeClass: triggerThemeClassHandle === null || triggerThemeClassHandle === void 0 ? void 0 : triggerThemeClassHandle.themeClass,
      triggerOnRender: triggerThemeClassHandle === null || triggerThemeClassHandle === void 0 ? void 0 : triggerThemeClassHandle.onRender,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const { mergedClsPrefix, $slots, triggerOnRender } = this;
    triggerOnRender === null || triggerOnRender === void 0 ? void 0 : triggerOnRender();
    return h$1("div", { class: [`${mergedClsPrefix}-time-picker`, this.triggerThemeClass], style: this.triggerCssVars }, h$1(VBinder, null, {
      default: () => [
        h$1(VTarget, null, {
          default: () => h$1(NInput, { ref: "inputInstRef", status: this.mergedStatus, value: this.displayTimeString, bordered: this.mergedBordered, passivelyActivated: true, attrSize: this.mergedAttrSize, theme: this.mergedTheme.peers.Input, themeOverrides: this.mergedTheme.peerOverrides.Input, stateful: this.stateful, size: this.mergedSize, placeholder: this.localizedPlaceholder, clearable: this.clearable, disabled: this.mergedDisabled, textDecoration: this.isValueInvalid ? "line-through" : void 0, onFocus: this.handleTimeInputFocus, onBlur: this.handleTimeInputBlur, onActivate: this.handleTimeInputActivate, onDeactivate: this.handleTimeInputDeactivate, onUpdateValue: this.handleTimeInputUpdateValue, onClear: this.handleTimeInputClear, internalDeactivateOnEnter: true, internalForceFocus: this.mergedShow, readonly: this.inputReadonly || this.mergedDisabled, onClick: this.handleTriggerClick, onKeydown: this.handleInputKeydown }, this.showIcon ? {
            [this.clearable ? "clear-icon-placeholder" : "suffix"]: () => h$1(NBaseIcon, { clsPrefix: mergedClsPrefix, class: `${mergedClsPrefix}-time-picker-icon` }, {
              default: () => $slots.icon ? $slots.icon() : h$1(TimeIcon, null)
            })
          } : null)
        }),
        h$1(VFollower, { teleportDisabled: this.adjustedTo === useAdjustedTo.tdkey, show: this.mergedShow, to: this.adjustedTo, containerClass: this.namespace, placement: this.placement }, {
          default: () => h$1(Transition, { name: "fade-in-scale-up-transition", appear: this.isMounted }, {
            default: () => {
              var _a2;
              if (this.mergedShow) {
                (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
                return withDirectives(h$1(Panel, { ref: "panelInstRef", actions: this.actions, class: this.themeClass, style: this.cssVars, seconds: this.seconds, minutes: this.minutes, hours: this.hours, transitionDisabled: this.transitionDisabled, hourValue: this.hourValue, showHour: this.hourInFormat, isHourInvalid: this.isHourInvalid, isHourDisabled: this.isHourDisabled, minuteValue: this.minuteValue, showMinute: this.minuteInFormat, isMinuteInvalid: this.isMinuteInvalid, isMinuteDisabled: this.isMinuteDisabled, secondValue: this.secondValue, amPmValue: this.amPmValue, showSecond: this.secondInFormat, isSecondInvalid: this.isSecondInvalid, isSecondDisabled: this.isSecondDisabled, isValueInvalid: this.isValueInvalid, nowText: this.localizedNow, confirmText: this.localizedPositiveText, use12Hours: this.use12Hours, onFocusout: this.handleMenuFocusOut, onKeydown: this.handleMenuKeydown, onHourClick: this.handleHourClick, onMinuteClick: this.handleMinuteClick, onSecondClick: this.handleSecondClick, onAmPmClick: this.handleAmPmClick, onNowClick: this.handleNowClick, onConfirmClick: this.handleConfirmClick, onFocusDetectorFocus: this.handleFocusDetectorFocus }), [
                  [
                    clickoutside$1,
                    this.handleClickOutside,
                    void 0,
                    { capture: true }
                  ]
                ]);
              }
              return null;
            }
          })
        })
      ]
    }));
  }
});
const TIME_FORMAT = "HH:mm:ss";
const usePanelCommonProps = {
  active: Boolean,
  dateFormat: String,
  timeFormat: {
    type: String,
    value: TIME_FORMAT
  },
  value: {
    type: [Array, Number],
    default: null
  },
  shortcuts: Object,
  defaultTime: [Number, String, Array],
  onClear: Function,
  onConfirm: Function,
  onClose: Function,
  onTabOut: Function,
  onUpdateValue: {
    type: Function,
    required: true
  },
  themeClass: String,
  onRender: Function,
  panel: Boolean
};
function usePanelCommon(props) {
  const {
    dateLocaleRef,
    timePickerSizeRef,
    timePickerPropsRef,
    localeRef,
    mergedClsPrefixRef,
    mergedThemeRef
  } = inject(datePickerInjectionKey);
  const dateFnsOptionsRef = computed(() => {
    return {
      locale: dateLocaleRef.value.locale
    };
  });
  const selfRef = ref(null);
  const keyboardState = useKeyboard();
  function doClear() {
    const { onClear } = props;
    if (onClear)
      onClear();
  }
  function doConfirm() {
    const { onConfirm, value: value2 } = props;
    if (onConfirm)
      onConfirm(value2);
  }
  function doUpdateValue(value2, doUpdate) {
    const { onUpdateValue } = props;
    onUpdateValue(value2, doUpdate);
  }
  function doClose(disableUpdateOnClose = false) {
    const { onClose } = props;
    if (onClose)
      onClose(disableUpdateOnClose);
  }
  function doTabOut() {
    const { onTabOut } = props;
    if (onTabOut)
      onTabOut();
  }
  function handleClearClick() {
    doUpdateValue(null, true);
    doClose(true);
    doClear();
  }
  function handleFocusDetectorFocus() {
    doTabOut();
  }
  function disableTransitionOneTick() {
    if (props.active || props.panel) {
      void nextTick(() => {
        const { value: selfEl } = selfRef;
        if (!selfEl)
          return;
        const dateEls = selfEl.querySelectorAll("[data-n-date]");
        dateEls.forEach((el2) => {
          el2.classList.add("transition-disabled");
        });
        void selfEl.offsetWidth;
        dateEls.forEach((el2) => {
          el2.classList.remove("transition-disabled");
        });
      });
    }
  }
  function handlePanelKeyDown(e25) {
    if (e25.key === "Tab" && e25.target === selfRef.value && keyboardState.shift) {
      e25.preventDefault();
      doTabOut();
    }
  }
  function handlePanelFocus(e25) {
    const { value: el2 } = selfRef;
    if (keyboardState.tab && e25.target === el2 && (el2 === null || el2 === void 0 ? void 0 : el2.contains(e25.relatedTarget))) {
      doTabOut();
    }
  }
  let cachedValue = null;
  let cached = false;
  function cachePendingValue() {
    cachedValue = props.value;
    cached = true;
  }
  function clearPendingValue() {
    cached = false;
  }
  function restorePendingValue() {
    if (cached) {
      doUpdateValue(cachedValue, false);
      cached = false;
    }
  }
  function getShortcutValue(shortcut) {
    if (typeof shortcut === "function") {
      return shortcut();
    }
    return shortcut;
  }
  const showMonthYearPanel = ref(false);
  function handleOpenQuickSelectMonthPanel() {
    showMonthYearPanel.value = !showMonthYearPanel.value;
  }
  return {
    mergedTheme: mergedThemeRef,
    mergedClsPrefix: mergedClsPrefixRef,
    dateFnsOptions: dateFnsOptionsRef,
    timePickerSize: timePickerSizeRef,
    timePickerProps: timePickerPropsRef,
    selfRef,
    locale: localeRef,
    doConfirm,
    doClose,
    doUpdateValue,
    doTabOut,
    handleClearClick,
    handleFocusDetectorFocus,
    disableTransitionOneTick,
    handlePanelKeyDown,
    handlePanelFocus,
    cachePendingValue,
    clearPendingValue,
    restorePendingValue,
    getShortcutValue,
    handleShortcutMouseleave: restorePendingValue,
    showMonthYearPanel,
    handleOpenQuickSelectMonthPanel
  };
}
const useCalendarProps = Object.assign(Object.assign({}, usePanelCommonProps), { actions: {
  type: Array,
  default: () => ["now", "clear", "confirm"]
} });
function useCalendar(props, type4) {
  const panelCommon = usePanelCommon(props);
  const {
    isValueInvalidRef,
    isDateDisabledRef,
    isDateInvalidRef,
    isTimeInvalidRef,
    isDateTimeInvalidRef,
    isHourDisabledRef,
    isMinuteDisabledRef,
    isSecondDisabledRef,
    localeRef,
    firstDayOfWeekRef,
    datePickerSlots
  } = inject(datePickerInjectionKey);
  const validation = {
    isValueInvalid: isValueInvalidRef,
    isDateDisabled: isDateDisabledRef,
    isDateInvalid: isDateInvalidRef,
    isTimeInvalid: isTimeInvalidRef,
    isDateTimeInvalid: isDateTimeInvalidRef,
    isHourDisabled: isHourDisabledRef,
    isMinuteDisabled: isMinuteDisabledRef,
    isSecondDisabled: isSecondDisabledRef
  };
  const mergedDateFormatRef = computed(() => props.dateFormat || localeRef.value.dateFormat);
  const dateInputValueRef = ref(props.value === null || Array.isArray(props.value) ? "" : format$4(props.value, mergedDateFormatRef.value));
  const calendarValueRef = ref(props.value === null || Array.isArray(props.value) ? Date.now() : props.value);
  const yearVlRef = ref(null);
  const yearScrollbarRef = ref(null);
  const monthScrollbarRef = ref(null);
  const nowRef = ref(Date.now());
  const dateArrayRef = computed(() => {
    var _a2;
    return dateArray(calendarValueRef.value, props.value, nowRef.value, (_a2 = firstDayOfWeekRef.value) !== null && _a2 !== void 0 ? _a2 : localeRef.value.firstDayOfWeek);
  });
  const monthArrayRef = computed(() => {
    const { value: value2 } = props;
    return monthArray(calendarValueRef.value, Array.isArray(value2) ? null : value2, nowRef.value);
  });
  const yearArrayRef = computed(() => {
    const { value: value2 } = props;
    return yearArray(Array.isArray(value2) ? null : value2, nowRef.value);
  });
  const quarterArrayRef = computed(() => {
    const { value: value2 } = props;
    return quarterArray(calendarValueRef.value, Array.isArray(value2) ? null : value2, nowRef.value);
  });
  const weekdaysRef = computed(() => {
    return dateArrayRef.value.slice(0, 7).map((dateItem2) => {
      const { ts: ts2 } = dateItem2;
      return format$4(ts2, localeRef.value.dayFormat, panelCommon.dateFnsOptions.value);
    });
  });
  const calendarMonthRef = computed(() => {
    return format$4(calendarValueRef.value, localeRef.value.monthFormat, panelCommon.dateFnsOptions.value);
  });
  const calendarYearRef = computed(() => {
    return format$4(calendarValueRef.value, localeRef.value.yearFormat, panelCommon.dateFnsOptions.value);
  });
  watch(calendarValueRef, (value2, oldValue) => {
    if (type4 === "date" || type4 === "datetime") {
      if (!isSameMonth(value2, oldValue)) {
        panelCommon.disableTransitionOneTick();
      }
    }
  });
  watch(computed(() => props.value), (value2) => {
    if (value2 !== null && !Array.isArray(value2)) {
      dateInputValueRef.value = format$4(value2, mergedDateFormatRef.value, panelCommon.dateFnsOptions.value);
      calendarValueRef.value = value2;
    } else {
      dateInputValueRef.value = "";
    }
  });
  function sanitizeValue(value2) {
    if (type4 === "datetime")
      return getTime(startOfSecond(value2));
    if (type4 === "month")
      return getTime(startOfMonth(value2));
    if (type4 === "year")
      return getTime(startOfYear(value2));
    if (type4 === "quarter")
      return getTime(startOfQuarter(value2));
    return getTime(startOfDay(value2));
  }
  function mergedIsDateDisabled(ts2) {
    const { isDateDisabled: { value: isDateDisabled } } = validation;
    if (!isDateDisabled)
      return false;
    return isDateDisabled(ts2);
  }
  function handleDateInput(value2) {
    const date4 = strictParse(value2, mergedDateFormatRef.value, new Date(), panelCommon.dateFnsOptions.value);
    if (isValid$1(date4)) {
      if (props.value === null) {
        panelCommon.doUpdateValue(getTime(sanitizeValue(Date.now())), props.panel);
      } else if (!Array.isArray(props.value)) {
        const newDateTime = set(props.value, {
          year: getYear(date4),
          month: getMonth(date4),
          date: getDate(date4)
        });
        panelCommon.doUpdateValue(getTime(sanitizeValue(getTime(newDateTime))), props.panel);
      }
    } else {
      dateInputValueRef.value = value2;
    }
  }
  function handleDateInputBlur() {
    const date4 = strictParse(dateInputValueRef.value, mergedDateFormatRef.value, new Date(), panelCommon.dateFnsOptions.value);
    if (isValid$1(date4)) {
      if (props.value === null) {
        panelCommon.doUpdateValue(getTime(sanitizeValue(Date.now())), false);
      } else if (!Array.isArray(props.value)) {
        const newDateTime = set(props.value, {
          year: getYear(date4),
          month: getMonth(date4),
          date: getDate(date4)
        });
        panelCommon.doUpdateValue(getTime(sanitizeValue(getTime(newDateTime))), false);
      }
    } else {
      deriveDateInputValue();
    }
  }
  function clearSelectedDateTime() {
    panelCommon.doUpdateValue(null, true);
    dateInputValueRef.value = "";
    panelCommon.doClose(true);
    panelCommon.handleClearClick();
  }
  function handleNowClick() {
    panelCommon.doUpdateValue(getTime(sanitizeValue(Date.now())), true);
    const now2 = Date.now();
    calendarValueRef.value = now2;
    panelCommon.doClose(true);
    if (props.panel && (type4 === "month" || type4 === "quarter" || type4 === "year")) {
      panelCommon.disableTransitionOneTick();
      justifyColumnsScrollState(now2);
    }
  }
  function handleDateClick(dateItem2) {
    if (mergedIsDateDisabled(dateItem2.ts)) {
      return;
    }
    let newValue;
    if (props.value !== null && !Array.isArray(props.value)) {
      newValue = props.value;
    } else {
      newValue = Date.now();
    }
    if (type4 === "datetime" && props.defaultTime !== null && !Array.isArray(props.defaultTime)) {
      const time2 = getDefaultTime(props.defaultTime);
      if (time2) {
        newValue = getTime(set(newValue, time2));
      }
    }
    newValue = getTime(dateItem2.type === "quarter" && dateItem2.dateObject.quarter ? setQuarter(setYear(newValue, dateItem2.dateObject.year), dateItem2.dateObject.quarter) : set(newValue, dateItem2.dateObject));
    panelCommon.doUpdateValue(sanitizeValue(newValue), props.panel || type4 === "date" || type4 === "year");
    switch (type4) {
      case "date":
        panelCommon.doClose();
        break;
      case "year":
        if (props.panel) {
          panelCommon.disableTransitionOneTick();
        }
        panelCommon.doClose();
        break;
      case "month":
        panelCommon.disableTransitionOneTick();
        justifyColumnsScrollState(newValue);
        break;
      case "quarter":
        panelCommon.disableTransitionOneTick();
        justifyColumnsScrollState(newValue);
        break;
    }
  }
  function handleQuickMonthClick(dateItem2, updatePanelValue) {
    let newValue;
    if (props.value !== null && !Array.isArray(props.value)) {
      newValue = props.value;
    } else {
      newValue = Date.now();
    }
    newValue = getTime(dateItem2.type === "month" ? setMonth(newValue, dateItem2.dateObject.month) : setYear(newValue, dateItem2.dateObject.year));
    updatePanelValue(newValue);
    justifyColumnsScrollState(newValue);
  }
  function onUpdateCalendarValue(value2) {
    calendarValueRef.value = value2;
  }
  function deriveDateInputValue(time2) {
    if (props.value === null || Array.isArray(props.value)) {
      dateInputValueRef.value = "";
      return;
    }
    if (time2 === void 0) {
      time2 = props.value;
    }
    dateInputValueRef.value = format$4(time2, mergedDateFormatRef.value, panelCommon.dateFnsOptions.value);
  }
  function handleConfirmClick() {
    if (validation.isDateInvalid.value || validation.isTimeInvalid.value) {
      return;
    }
    panelCommon.doConfirm();
    closeCalendar();
  }
  function closeCalendar() {
    if (props.active) {
      panelCommon.doClose();
    }
  }
  function nextYear() {
    calendarValueRef.value = getTime(addYears(calendarValueRef.value, 1));
  }
  function prevYear() {
    calendarValueRef.value = getTime(addYears(calendarValueRef.value, -1));
  }
  function nextMonth() {
    calendarValueRef.value = getTime(addMonths(calendarValueRef.value, 1));
  }
  function prevMonth() {
    calendarValueRef.value = getTime(addMonths(calendarValueRef.value, -1));
  }
  function virtualListContainer() {
    const { value: value2 } = yearVlRef;
    return value2 === null || value2 === void 0 ? void 0 : value2.listElRef;
  }
  function virtualListContent() {
    const { value: value2 } = yearVlRef;
    return value2 === null || value2 === void 0 ? void 0 : value2.itemsElRef;
  }
  function handleVirtualListScroll(e25) {
    var _a2;
    (_a2 = yearScrollbarRef.value) === null || _a2 === void 0 ? void 0 : _a2.sync();
  }
  function handleTimePickerChange(value2) {
    if (value2 === null)
      return;
    panelCommon.doUpdateValue(value2, props.panel);
  }
  function handleSingleShortcutMouseenter(shortcut) {
    panelCommon.cachePendingValue();
    const shortcutValue = panelCommon.getShortcutValue(shortcut);
    if (typeof shortcutValue !== "number")
      return;
    panelCommon.doUpdateValue(shortcutValue, false);
  }
  function handleSingleShortcutClick(shortcut) {
    const shortcutValue = panelCommon.getShortcutValue(shortcut);
    if (typeof shortcutValue !== "number")
      return;
    panelCommon.doUpdateValue(shortcutValue, props.panel);
    panelCommon.clearPendingValue();
    handleConfirmClick();
  }
  function justifyColumnsScrollState(value2) {
    const { value: mergedValue } = props;
    if (monthScrollbarRef.value) {
      const monthIndex = value2 === void 0 ? mergedValue === null ? getMonth(Date.now()) : getMonth(mergedValue) : getMonth(value2);
      monthScrollbarRef.value.scrollTo({ top: monthIndex * MONTH_ITEM_HEIGHT });
    }
    if (yearVlRef.value) {
      const yearIndex = (value2 === void 0 ? mergedValue === null ? getYear(Date.now()) : getYear(mergedValue) : getYear(value2)) - START_YEAR;
      yearVlRef.value.scrollTo({ top: yearIndex * MONTH_ITEM_HEIGHT });
    }
  }
  const childComponentRefs = {
    monthScrollbarRef,
    yearScrollbarRef,
    yearVlRef
  };
  return Object.assign(Object.assign(Object.assign(Object.assign({
    dateArray: dateArrayRef,
    monthArray: monthArrayRef,
    yearArray: yearArrayRef,
    quarterArray: quarterArrayRef,
    calendarYear: calendarYearRef,
    calendarMonth: calendarMonthRef,
    weekdays: weekdaysRef,
    mergedIsDateDisabled,
    nextYear,
    prevYear,
    nextMonth,
    prevMonth,
    handleNowClick,
    handleConfirmClick,
    handleSingleShortcutMouseenter,
    handleSingleShortcutClick
  }, validation), panelCommon), childComponentRefs), {
    handleDateClick,
    handleDateInputBlur,
    handleDateInput,
    handleTimePickerChange,
    clearSelectedDateTime,
    virtualListContainer,
    virtualListContent,
    handleVirtualListScroll,
    timePickerSize: panelCommon.timePickerSize,
    dateInputValue: dateInputValueRef,
    datePickerSlots,
    handleQuickMonthClick,
    justifyColumnsScrollState,
    calendarValue: calendarValueRef,
    onUpdateCalendarValue
  });
}
var MonthPanel = defineComponent({
  name: "MonthPanel",
  props: Object.assign(Object.assign({}, useCalendarProps), {
    type: {
      type: String,
      required: true
    },
    useAsQuickJump: Boolean
  }),
  setup(props) {
    const useCalendarRef = useCalendar(props, props.type);
    const getRenderContent = (item) => {
      switch (item.type) {
        case "year":
          return item.dateObject.year;
        case "month":
          return item.dateObject.month + 1;
        case "quarter":
          return `Q${item.dateObject.quarter}`;
      }
    };
    const { useAsQuickJump } = props;
    const renderItem = (item, i2, mergedClsPrefix) => {
      const { mergedIsDateDisabled, handleDateClick, handleQuickMonthClick } = useCalendarRef;
      return h$1("div", { "data-n-date": true, key: i2, class: [
        `${mergedClsPrefix}-date-panel-month-calendar__picker-col-item`,
        {
          [`${mergedClsPrefix}-date-panel-month-calendar__picker-col-item--current`]: item.isCurrent,
          [`${mergedClsPrefix}-date-panel-month-calendar__picker-col-item--selected`]: item.selected,
          [`${mergedClsPrefix}-date-panel-month-calendar__picker-col-item--disabled`]: !useAsQuickJump && mergedIsDateDisabled(item.ts)
        }
      ], onClick: () => {
        useAsQuickJump ? handleQuickMonthClick(item, (value2) => {
          props.onUpdateValue(value2, false);
        }) : handleDateClick(item);
      } }, getRenderContent(item));
    };
    onMounted(() => {
      useCalendarRef.justifyColumnsScrollState();
    });
    return Object.assign(Object.assign({}, useCalendarRef), { renderItem });
  },
  render() {
    const { mergedClsPrefix, mergedTheme, shortcuts, actions, renderItem, type: type4, onRender } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { ref: "selfRef", tabindex: 0, class: [
      `${mergedClsPrefix}-date-panel`,
      `${mergedClsPrefix}-date-panel--month`,
      !this.panel && `${mergedClsPrefix}-date-panel--shadow`,
      this.themeClass
    ], onFocus: this.handlePanelFocus, onKeydown: this.handlePanelKeyDown }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month-calendar` }, h$1(NScrollbar, { ref: "yearScrollbarRef", class: `${mergedClsPrefix}-date-panel-month-calendar__picker-col`, theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar, container: this.virtualListContainer, content: this.virtualListContent, horizontalRailStyle: { zIndex: 1 }, verticalRailStyle: { zIndex: 1 } }, {
      default: () => h$1(VirtualList, { ref: "yearVlRef", items: this.yearArray, itemSize: MONTH_ITEM_HEIGHT, showScrollbar: false, keyField: "ts", onScroll: this.handleVirtualListScroll, paddingBottom: 4 }, {
        default: ({ item, index: index2 }) => {
          return renderItem(item, index2, mergedClsPrefix);
        }
      })
    }), type4 === "month" || type4 === "quarter" ? h$1("div", { class: `${mergedClsPrefix}-date-panel-month-calendar__picker-col` }, h$1(NScrollbar, { ref: "monthScrollbarRef", theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar }, {
      default: () => [
        (type4 === "month" ? this.monthArray : this.quarterArray).map((item, i2) => renderItem(item, i2, mergedClsPrefix)),
        h$1("div", { class: `${mergedClsPrefix}-date-panel-${type4}-calendar__padding` })
      ]
    })) : null), this.datePickerSlots.footer ? h$1("div", { class: `${mergedClsPrefix}-date-panel-footer` }, {
      default: this.datePickerSlots.footer
    }) : null, (actions === null || actions === void 0 ? void 0 : actions.length) || shortcuts ? h$1("div", { class: `${mergedClsPrefix}-date-panel-actions` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-actions__prefix` }, shortcuts && Object.keys(shortcuts).map((key) => {
      const shortcut = shortcuts[key];
      return Array.isArray(shortcut) ? null : h$1(XButton, { size: "tiny", onMouseenter: () => {
        this.handleSingleShortcutMouseenter(shortcut);
      }, onClick: () => {
        this.handleSingleShortcutClick(shortcut);
      }, onMouseleave: () => {
        this.handleShortcutMouseleave();
      } }, { default: () => key });
    })), h$1("div", { class: `${mergedClsPrefix}-date-panel-actions__suffix` }, (actions === null || actions === void 0 ? void 0 : actions.includes("clear")) ? h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", onClick: this.handleClearClick }, { default: () => this.locale.clear }) : null, (actions === null || actions === void 0 ? void 0 : actions.includes("now")) ? h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", onClick: this.handleNowClick }, { default: () => this.locale.now }) : null, (actions === null || actions === void 0 ? void 0 : actions.includes("confirm")) ? h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", type: "primary", disabled: this.isDateInvalid, onClick: this.handleConfirmClick }, { default: () => this.locale.confirm }) : null)) : null, h$1(FocusDetector, { onFocus: this.handleFocusDetectorFocus }));
  }
});
var PanelHeader = defineComponent({
  props: {
    mergedClsPrefix: {
      type: String,
      required: true
    },
    value: Number,
    monthBeforeYear: {
      type: Boolean,
      required: true
    },
    calendarMonth: {
      type: String,
      required: true
    },
    calendarYear: {
      type: String,
      required: true
    },
    onUpdateValue: {
      type: Function,
      required: true
    }
  },
  setup() {
    const triggerRef = ref(null);
    const monthPanelRef = ref(null);
    const showRef = ref(false);
    function handleClickOutside(e25) {
      var _a2;
      if (showRef.value && !((_a2 = triggerRef.value) === null || _a2 === void 0 ? void 0 : _a2.contains(getPreciseEventTarget(e25)))) {
        showRef.value = false;
      }
    }
    function handleHeaderClick() {
      showRef.value = !showRef.value;
    }
    return {
      show: showRef,
      triggerRef,
      monthPanelRef,
      handleHeaderClick,
      handleClickOutside
    };
  },
  render() {
    const { handleClickOutside, mergedClsPrefix } = this;
    return h$1("div", { class: `${mergedClsPrefix}-date-panel-month__month-year`, ref: "triggerRef" }, h$1(VBinder, null, {
      default: () => [
        h$1(VTarget, null, {
          default: () => h$1("div", { class: [
            `${mergedClsPrefix}-date-panel-month__text`,
            this.show && `${mergedClsPrefix}-date-panel-month__text--active`
          ], onClick: this.handleHeaderClick }, this.monthBeforeYear ? [this.calendarMonth, " ", this.calendarYear] : [this.calendarYear, " ", this.calendarMonth])
        }),
        h$1(VFollower, { show: this.show, teleportDisabled: true }, {
          default: () => h$1(Transition, { name: "fade-in-scale-up-transition", appear: true }, {
            default: () => this.show ? withDirectives(h$1(MonthPanel, {
              ref: "monthPanelRef",
              onUpdateValue: this.onUpdateValue,
              actions: [],
              type: "month",
              key: "month",
              useAsQuickJump: true,
              value: this.value
            }), [
              [
                clickoutside$1,
                handleClickOutside,
                void 0,
                { capture: true }
              ]
            ]) : null
          })
        })
      ]
    }));
  }
});
var DatetimePanel = defineComponent({
  name: "DateTimePanel",
  props: useCalendarProps,
  setup(props) {
    return useCalendar(props, "datetime");
  },
  render() {
    var _a2, _b2, _c2, _d2;
    const { mergedClsPrefix, mergedTheme, shortcuts, timePickerProps: timePickerProps2, onRender, $slots } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { ref: "selfRef", tabindex: 0, class: [
      `${mergedClsPrefix}-date-panel`,
      `${mergedClsPrefix}-date-panel--datetime`,
      !this.panel && `${mergedClsPrefix}-date-panel--shadow`,
      this.themeClass
    ], onKeydown: this.handlePanelKeyDown, onFocus: this.handlePanelFocus }, h$1("div", { class: `${mergedClsPrefix}-date-panel-header` }, h$1(NInput, { value: this.dateInputValue, theme: mergedTheme.peers.Input, themeOverrides: mergedTheme.peerOverrides.Input, stateful: false, size: this.timePickerSize, class: `${mergedClsPrefix}-date-panel-date-input`, textDecoration: this.isDateInvalid ? "line-through" : "", placeholder: this.locale.selectDate, onBlur: this.handleDateInputBlur, onUpdateValue: this.handleDateInput }), h$1(NTimePicker, Object.assign({ size: this.timePickerSize, placeholder: this.locale.selectTime, format: this.timeFormat }, Array.isArray(timePickerProps2) ? void 0 : timePickerProps2, { showIcon: false, to: false, theme: mergedTheme.peers.TimePicker, themeOverrides: mergedTheme.peerOverrides.TimePicker, value: Array.isArray(this.value) ? null : this.value, isHourDisabled: this.isHourDisabled, isMinuteDisabled: this.isMinuteDisabled, isSecondDisabled: this.isSecondDisabled, onUpdateValue: this.handleTimePickerChange, stateful: false }))), h$1("div", { class: `${mergedClsPrefix}-date-panel-calendar` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month__fast-prev`, onClick: this.prevYear }, resolveSlot($slots["prev-year"], () => [h$1(FastBackwardIcon, null)])), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__prev`, onClick: this.prevMonth }, resolveSlot($slots["prev-month"], () => [h$1(BackwardIcon, null)])), h$1(PanelHeader, { monthBeforeYear: this.locale.monthBeforeYear, value: this.calendarValue, onUpdateValue: this.onUpdateCalendarValue, mergedClsPrefix, calendarMonth: this.calendarMonth, calendarYear: this.calendarYear }), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__next`, onClick: this.nextMonth }, resolveSlot($slots["next-month"], () => [h$1(ForwardIcon, null)])), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__fast-next`, onClick: this.nextYear }, resolveSlot($slots["next-year"], () => [h$1(FastForwardIcon, null)]))), h$1("div", { class: `${mergedClsPrefix}-date-panel-weekdays` }, this.weekdays.map((weekday) => h$1("div", { key: weekday, class: `${mergedClsPrefix}-date-panel-weekdays__day` }, weekday))), h$1("div", { class: `${mergedClsPrefix}-date-panel-dates` }, this.dateArray.map((dateItem2, i2) => h$1("div", { "data-n-date": true, key: i2, class: [
      `${mergedClsPrefix}-date-panel-date`,
      {
        [`${mergedClsPrefix}-date-panel-date--current`]: dateItem2.isCurrentDate,
        [`${mergedClsPrefix}-date-panel-date--selected`]: dateItem2.selected,
        [`${mergedClsPrefix}-date-panel-date--excluded`]: !dateItem2.inCurrentMonth,
        [`${mergedClsPrefix}-date-panel-date--disabled`]: this.mergedIsDateDisabled(dateItem2.ts)
      }
    ], onClick: () => {
      this.handleDateClick(dateItem2);
    } }, h$1("div", { class: `${mergedClsPrefix}-date-panel-date__trigger` }), dateItem2.dateObject.date, dateItem2.isCurrentDate ? h$1("div", { class: `${mergedClsPrefix}-date-panel-date__sup` }) : null)))), this.datePickerSlots.footer ? h$1("div", { class: `${mergedClsPrefix}-date-panel-footer` }, this.datePickerSlots.footer()) : null, ((_a2 = this.actions) === null || _a2 === void 0 ? void 0 : _a2.length) || shortcuts ? h$1("div", { class: `${mergedClsPrefix}-date-panel-actions` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-actions__prefix` }, shortcuts && Object.keys(shortcuts).map((key) => {
      const shortcut = shortcuts[key];
      return Array.isArray(shortcut) ? null : h$1(XButton, { size: "tiny", onMouseenter: () => {
        this.handleSingleShortcutMouseenter(shortcut);
      }, onClick: () => {
        this.handleSingleShortcutClick(shortcut);
      }, onMouseleave: () => {
        this.handleShortcutMouseleave();
      } }, { default: () => key });
    })), h$1("div", { class: `${mergedClsPrefix}-date-panel-actions__suffix` }, ((_b2 = this.actions) === null || _b2 === void 0 ? void 0 : _b2.includes("clear")) ? h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", onClick: this.clearSelectedDateTime }, { default: () => this.locale.clear }) : null, ((_c2 = this.actions) === null || _c2 === void 0 ? void 0 : _c2.includes("now")) ? h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", onClick: this.handleNowClick }, { default: () => this.locale.now }) : null, ((_d2 = this.actions) === null || _d2 === void 0 ? void 0 : _d2.includes("confirm")) ? h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", type: "primary", disabled: this.isDateInvalid, onClick: this.handleConfirmClick }, { default: () => this.locale.confirm }) : null)) : null, h$1(FocusDetector, { onFocus: this.handleFocusDetectorFocus }));
  }
});
const useDualCalendarProps = Object.assign(Object.assign({}, usePanelCommonProps), { defaultCalendarStartTime: Number, defaultCalendarEndTime: Number, bindCalendarMonths: Boolean, actions: {
  type: Array,
  default: () => ["clear", "confirm"]
} });
function useDualCalendar(props, type4) {
  var _a2, _b2;
  const {
    isDateDisabledRef,
    isStartHourDisabledRef,
    isEndHourDisabledRef,
    isStartMinuteDisabledRef,
    isEndMinuteDisabledRef,
    isStartSecondDisabledRef,
    isEndSecondDisabledRef,
    isStartDateInvalidRef,
    isEndDateInvalidRef,
    isStartTimeInvalidRef,
    isEndTimeInvalidRef,
    isStartValueInvalidRef,
    isEndValueInvalidRef,
    isRangeInvalidRef,
    localeRef,
    rangesRef,
    closeOnSelectRef,
    updateValueOnCloseRef,
    firstDayOfWeekRef,
    datePickerSlots
  } = inject(datePickerInjectionKey);
  const validation = {
    isDateDisabled: isDateDisabledRef,
    isStartHourDisabled: isStartHourDisabledRef,
    isEndHourDisabled: isEndHourDisabledRef,
    isStartMinuteDisabled: isStartMinuteDisabledRef,
    isEndMinuteDisabled: isEndMinuteDisabledRef,
    isStartSecondDisabled: isStartSecondDisabledRef,
    isEndSecondDisabled: isEndSecondDisabledRef,
    isStartDateInvalid: isStartDateInvalidRef,
    isEndDateInvalid: isEndDateInvalidRef,
    isStartTimeInvalid: isStartTimeInvalidRef,
    isEndTimeInvalid: isEndTimeInvalidRef,
    isStartValueInvalid: isStartValueInvalidRef,
    isEndValueInvalid: isEndValueInvalidRef,
    isRangeInvalid: isRangeInvalidRef
  };
  const panelCommon = usePanelCommon(props);
  const startDatesElRef = ref(null);
  const endDatesElRef = ref(null);
  const startYearScrollbarRef = ref(null);
  const endYearScrollbarRef = ref(null);
  const startYearVlRef = ref(null);
  const endYearVlRef = ref(null);
  const startMonthScrollbarRef = ref(null);
  const endMonthScrollbarRef = ref(null);
  const { value: value2 } = props;
  const defaultCalendarStartTime = (_a2 = props.defaultCalendarStartTime) !== null && _a2 !== void 0 ? _a2 : Array.isArray(value2) && typeof value2[0] === "number" ? value2[0] : Date.now();
  const startCalendarDateTimeRef = ref(defaultCalendarStartTime);
  const endCalendarDateTimeRef = ref((_b2 = props.defaultCalendarEndTime) !== null && _b2 !== void 0 ? _b2 : Array.isArray(value2) && typeof value2[1] === "number" ? value2[1] : getTime(addMonths(defaultCalendarStartTime, 1)));
  adjustCalendarTimes(true);
  const nowRef = ref(Date.now());
  const isSelectingRef = ref(false);
  const memorizedStartDateTimeRef = ref(0);
  const mergedDateFormatRef = computed(() => props.dateFormat || localeRef.value.dateFormat);
  const startDateInput = ref(Array.isArray(value2) ? format$4(value2[0], mergedDateFormatRef.value, panelCommon.dateFnsOptions.value) : "");
  const endDateInputRef = ref(Array.isArray(value2) ? format$4(value2[1], mergedDateFormatRef.value, panelCommon.dateFnsOptions.value) : "");
  const selectingPhaseRef = computed(() => {
    if (isSelectingRef.value)
      return "end";
    else
      return "start";
  });
  const startDateArrayRef = computed(() => {
    var _a3;
    return dateArray(startCalendarDateTimeRef.value, props.value, nowRef.value, (_a3 = firstDayOfWeekRef.value) !== null && _a3 !== void 0 ? _a3 : localeRef.value.firstDayOfWeek);
  });
  const endDateArrayRef = computed(() => {
    var _a3;
    return dateArray(endCalendarDateTimeRef.value, props.value, nowRef.value, (_a3 = firstDayOfWeekRef.value) !== null && _a3 !== void 0 ? _a3 : localeRef.value.firstDayOfWeek);
  });
  const weekdaysRef = computed(() => {
    return startDateArrayRef.value.slice(0, 7).map((dateItem2) => {
      const { ts: ts2 } = dateItem2;
      return format$4(ts2, localeRef.value.dayFormat, panelCommon.dateFnsOptions.value);
    });
  });
  const startCalendarMonthRef = computed(() => {
    return format$4(startCalendarDateTimeRef.value, localeRef.value.monthFormat, panelCommon.dateFnsOptions.value);
  });
  const endCalendarMonthRef = computed(() => {
    return format$4(endCalendarDateTimeRef.value, localeRef.value.monthFormat, panelCommon.dateFnsOptions.value);
  });
  const startCalendarYearRef = computed(() => {
    return format$4(startCalendarDateTimeRef.value, localeRef.value.yearFormat, panelCommon.dateFnsOptions.value);
  });
  const endCalendarYearRef = computed(() => {
    return format$4(endCalendarDateTimeRef.value, localeRef.value.yearFormat, panelCommon.dateFnsOptions.value);
  });
  const startTimeValueRef = computed(() => {
    const { value: value3 } = props;
    if (Array.isArray(value3))
      return value3[0];
    return null;
  });
  const endTimeValueRef = computed(() => {
    const { value: value3 } = props;
    if (Array.isArray(value3))
      return value3[1];
    return null;
  });
  const shortcutsRef = computed(() => {
    const { shortcuts } = props;
    return shortcuts || rangesRef.value;
  });
  const startYearArrayRef = computed(() => {
    return yearArray(pluckValueFromRange(props.value, "start"), nowRef.value);
  });
  const endYearArrayRef = computed(() => {
    return yearArray(pluckValueFromRange(props.value, "end"), nowRef.value);
  });
  const startQuarterArrayRef = computed(() => {
    const startValue = pluckValueFromRange(props.value, "start");
    return quarterArray(startValue !== null && startValue !== void 0 ? startValue : Date.now(), startValue, nowRef.value);
  });
  const endQuarterArrayRef = computed(() => {
    const endValue = pluckValueFromRange(props.value, "end");
    return quarterArray(endValue !== null && endValue !== void 0 ? endValue : Date.now(), endValue, nowRef.value);
  });
  const startMonthArrayRef = computed(() => {
    const startValue = pluckValueFromRange(props.value, "start");
    return monthArray(startValue !== null && startValue !== void 0 ? startValue : Date.now(), startValue, nowRef.value);
  });
  const endMonthArrayRef = computed(() => {
    const endValue = pluckValueFromRange(props.value, "end");
    return monthArray(endValue !== null && endValue !== void 0 ? endValue : Date.now(), endValue, nowRef.value);
  });
  watch(computed(() => props.value), (value3) => {
    if (value3 !== null && Array.isArray(value3)) {
      const [startMoment, endMoment] = value3;
      startDateInput.value = format$4(startMoment, mergedDateFormatRef.value, panelCommon.dateFnsOptions.value);
      endDateInputRef.value = format$4(endMoment, mergedDateFormatRef.value, panelCommon.dateFnsOptions.value);
      if (!isSelectingRef.value) {
        syncCalendarTimeWithValue(value3);
      }
    } else {
      startDateInput.value = "";
      endDateInputRef.value = "";
    }
  });
  function handleCalendarChange(value3, oldValue) {
    if (type4 === "daterange" || type4 === "datetimerange") {
      if (getYear(value3) !== getYear(oldValue) || getMonth(value3) !== getMonth(oldValue)) {
        panelCommon.disableTransitionOneTick();
      }
    }
  }
  watch(startCalendarDateTimeRef, handleCalendarChange);
  watch(endCalendarDateTimeRef, handleCalendarChange);
  function adjustCalendarTimes(byStartCalendarTime) {
    const startTime = startOfMonth(startCalendarDateTimeRef.value);
    const endTime = startOfMonth(endCalendarDateTimeRef.value);
    if (props.bindCalendarMonths || startTime >= endTime) {
      if (byStartCalendarTime) {
        endCalendarDateTimeRef.value = getTime(addMonths(startTime, 1));
      } else {
        startCalendarDateTimeRef.value = getTime(addMonths(endTime, -1));
      }
    }
  }
  function startCalendarNextYear() {
    startCalendarDateTimeRef.value = getTime(addMonths(startCalendarDateTimeRef.value, 12));
    adjustCalendarTimes(true);
  }
  function startCalendarPrevYear() {
    startCalendarDateTimeRef.value = getTime(addMonths(startCalendarDateTimeRef.value, -12));
    adjustCalendarTimes(true);
  }
  function startCalendarNextMonth() {
    startCalendarDateTimeRef.value = getTime(addMonths(startCalendarDateTimeRef.value, 1));
    adjustCalendarTimes(true);
  }
  function startCalendarPrevMonth() {
    startCalendarDateTimeRef.value = getTime(addMonths(startCalendarDateTimeRef.value, -1));
    adjustCalendarTimes(true);
  }
  function endCalendarNextYear() {
    endCalendarDateTimeRef.value = getTime(addMonths(endCalendarDateTimeRef.value, 12));
    adjustCalendarTimes(false);
  }
  function endCalendarPrevYear() {
    endCalendarDateTimeRef.value = getTime(addMonths(endCalendarDateTimeRef.value, -12));
    adjustCalendarTimes(false);
  }
  function endCalendarNextMonth() {
    endCalendarDateTimeRef.value = getTime(addMonths(endCalendarDateTimeRef.value, 1));
    adjustCalendarTimes(false);
  }
  function endCalendarPrevMonth() {
    endCalendarDateTimeRef.value = getTime(addMonths(endCalendarDateTimeRef.value, -1));
    adjustCalendarTimes(false);
  }
  function onUpdateStartCalendarValue(value3) {
    startCalendarDateTimeRef.value = value3;
    adjustCalendarTimes(true);
  }
  function onUpdateEndCalendarValue(value3) {
    endCalendarDateTimeRef.value = value3;
    adjustCalendarTimes(false);
  }
  function mergedIsDateDisabled(ts2) {
    const isDateDisabled = isDateDisabledRef.value;
    if (!isDateDisabled)
      return false;
    if (!Array.isArray(props.value))
      return isDateDisabled(ts2, "start", null);
    if (selectingPhaseRef.value === "start") {
      return isDateDisabled(ts2, "start", null);
    } else {
      const { value: memorizedStartDateTime } = memorizedStartDateTimeRef;
      if (ts2 < memorizedStartDateTimeRef.value) {
        return isDateDisabled(ts2, "start", [
          memorizedStartDateTime,
          memorizedStartDateTime
        ]);
      } else {
        return isDateDisabled(ts2, "end", [
          memorizedStartDateTime,
          memorizedStartDateTime
        ]);
      }
    }
  }
  function syncCalendarTimeWithValue(value3) {
    if (value3 === null)
      return;
    const [startMoment, endMoment] = value3;
    startCalendarDateTimeRef.value = startMoment;
    if (startOfMonth(endMoment) <= startOfMonth(startMoment)) {
      endCalendarDateTimeRef.value = getTime(startOfMonth(addMonths(startMoment, 1)));
    } else {
      endCalendarDateTimeRef.value = getTime(startOfMonth(endMoment));
    }
  }
  function handleDateClick(dateItem2) {
    if (!isSelectingRef.value) {
      isSelectingRef.value = true;
      memorizedStartDateTimeRef.value = dateItem2.ts;
      changeStartEndTime(dateItem2.ts, dateItem2.ts, "done");
    } else {
      isSelectingRef.value = false;
      const { value: value3 } = props;
      if (props.panel && Array.isArray(value3)) {
        changeStartEndTime(value3[0], value3[1], "done");
      } else {
        if (closeOnSelectRef.value && type4 === "daterange") {
          if (updateValueOnCloseRef.value) {
            closeCalendar();
          } else {
            handleConfirmClick();
          }
        }
      }
    }
  }
  function handleDateMouseEnter(dateItem2) {
    if (isSelectingRef.value) {
      if (mergedIsDateDisabled(dateItem2.ts))
        return;
      if (dateItem2.ts >= memorizedStartDateTimeRef.value) {
        changeStartEndTime(memorizedStartDateTimeRef.value, dateItem2.ts, "wipPreview");
      } else {
        changeStartEndTime(dateItem2.ts, memorizedStartDateTimeRef.value, "wipPreview");
      }
    }
  }
  function handleConfirmClick() {
    if (isRangeInvalidRef.value) {
      return;
    }
    panelCommon.doConfirm();
    closeCalendar();
  }
  function closeCalendar() {
    isSelectingRef.value = false;
    if (props.active) {
      panelCommon.doClose();
    }
  }
  function changeStartDateTime(time2) {
    if (typeof time2 !== "number") {
      time2 = getTime(time2);
    }
    if (props.value === null) {
      panelCommon.doUpdateValue([time2, time2], props.panel);
    } else if (Array.isArray(props.value)) {
      panelCommon.doUpdateValue([time2, Math.max(props.value[1], time2)], props.panel);
    }
  }
  function changeEndDateTime(time2) {
    if (typeof time2 !== "number") {
      time2 = getTime(time2);
    }
    if (props.value === null) {
      panelCommon.doUpdateValue([time2, time2], props.panel);
    } else if (Array.isArray(props.value)) {
      panelCommon.doUpdateValue([Math.min(props.value[0], time2), time2], props.panel);
    }
  }
  function changeStartEndTime(startTime, endTime, source) {
    if (typeof startTime !== "number") {
      startTime = getTime(startTime);
    }
    if (source !== "shortcutPreview") {
      let startDefaultTime;
      let endDefaultTime;
      if (type4 === "datetimerange") {
        const { defaultTime } = props;
        if (Array.isArray(defaultTime)) {
          startDefaultTime = getDefaultTime(defaultTime[0]);
          endDefaultTime = getDefaultTime(defaultTime[1]);
        } else {
          startDefaultTime = getDefaultTime(defaultTime);
          endDefaultTime = startDefaultTime;
        }
      }
      if (startDefaultTime) {
        startTime = getTime(set(startTime, startDefaultTime));
      }
      if (endDefaultTime) {
        endTime = getTime(set(endTime, endDefaultTime));
      }
    }
    panelCommon.doUpdateValue([startTime, endTime], props.panel && source === "done");
  }
  function sanitizeValue(datetime) {
    if (type4 === "datetimerange") {
      return getTime(startOfSecond(datetime));
    } else if (type4 === "monthrange") {
      return getTime(startOfMonth(datetime));
    } else {
      return getTime(startOfDay(datetime));
    }
  }
  function handleStartDateInput(value3) {
    const date4 = strictParse(value3, mergedDateFormatRef.value, new Date(), panelCommon.dateFnsOptions.value);
    if (isValid$1(date4)) {
      if (!props.value) {
        const newValue = set(new Date(), {
          year: getYear(date4),
          month: getMonth(date4),
          date: getDate(date4)
        });
        changeStartDateTime(sanitizeValue(getTime(newValue)));
      } else if (Array.isArray(props.value)) {
        const newValue = set(props.value[0], {
          year: getYear(date4),
          month: getMonth(date4),
          date: getDate(date4)
        });
        changeStartDateTime(sanitizeValue(getTime(newValue)));
      }
    } else {
      startDateInput.value = value3;
    }
  }
  function handleEndDateInput(value3) {
    const date4 = strictParse(value3, mergedDateFormatRef.value, new Date(), panelCommon.dateFnsOptions.value);
    if (isValid$1(date4)) {
      if (props.value === null) {
        const newValue = set(new Date(), {
          year: getYear(date4),
          month: getMonth(date4),
          date: getDate(date4)
        });
        changeEndDateTime(sanitizeValue(getTime(newValue)));
      } else if (Array.isArray(props.value)) {
        const newValue = set(props.value[1], {
          year: getYear(date4),
          month: getMonth(date4),
          date: getDate(date4)
        });
        changeEndDateTime(sanitizeValue(getTime(newValue)));
      }
    } else {
      endDateInputRef.value = value3;
    }
  }
  function handleStartDateInputBlur() {
    const date4 = strictParse(startDateInput.value, mergedDateFormatRef.value, new Date(), panelCommon.dateFnsOptions.value);
    const { value: value3 } = props;
    if (isValid$1(date4)) {
      if (value3 === null) {
        const newValue = set(new Date(), {
          year: getYear(date4),
          month: getMonth(date4),
          date: getDate(date4)
        });
        changeStartDateTime(sanitizeValue(getTime(newValue)));
      } else if (Array.isArray(value3)) {
        const newValue = set(value3[0], {
          year: getYear(date4),
          month: getMonth(date4),
          date: getDate(date4)
        });
        changeStartDateTime(sanitizeValue(getTime(newValue)));
      }
    } else {
      refreshDisplayDateString();
    }
  }
  function handleEndDateInputBlur() {
    const date4 = strictParse(endDateInputRef.value, mergedDateFormatRef.value, new Date(), panelCommon.dateFnsOptions.value);
    const { value: value3 } = props;
    if (isValid$1(date4)) {
      if (value3 === null) {
        const newValue = set(new Date(), {
          year: getYear(date4),
          month: getMonth(date4),
          date: getDate(date4)
        });
        changeEndDateTime(sanitizeValue(getTime(newValue)));
      } else if (Array.isArray(value3)) {
        const newValue = set(value3[1], {
          year: getYear(date4),
          month: getMonth(date4),
          date: getDate(date4)
        });
        changeEndDateTime(sanitizeValue(getTime(newValue)));
      }
    } else {
      refreshDisplayDateString();
    }
  }
  function refreshDisplayDateString(times) {
    const { value: value3 } = props;
    if (value3 === null || !Array.isArray(value3)) {
      startDateInput.value = "";
      endDateInputRef.value = "";
      return;
    }
    if (times === void 0) {
      times = value3;
    }
    startDateInput.value = format$4(times[0], mergedDateFormatRef.value, panelCommon.dateFnsOptions.value);
    endDateInputRef.value = format$4(times[1], mergedDateFormatRef.value, panelCommon.dateFnsOptions.value);
  }
  function handleStartTimePickerChange(value3) {
    if (value3 === null)
      return;
    changeStartDateTime(value3);
  }
  function handleEndTimePickerChange(value3) {
    if (value3 === null)
      return;
    changeEndDateTime(value3);
  }
  function handleRangeShortcutMouseenter(shortcut) {
    panelCommon.cachePendingValue();
    const shortcutValue = panelCommon.getShortcutValue(shortcut);
    if (!Array.isArray(shortcutValue))
      return;
    changeStartEndTime(shortcutValue[0], shortcutValue[1], "shortcutPreview");
  }
  function handleRangeShortcutClick(shortcut) {
    const shortcutValue = panelCommon.getShortcutValue(shortcut);
    if (!Array.isArray(shortcutValue))
      return;
    changeStartEndTime(shortcutValue[0], shortcutValue[1], "done");
    panelCommon.clearPendingValue();
    handleConfirmClick();
  }
  function justifyColumnsScrollState(value3, type5) {
    const mergedValue = value3 === void 0 ? props.value : value3;
    if (value3 === void 0 || type5 === "start") {
      if (startMonthScrollbarRef.value) {
        const monthIndex = !Array.isArray(mergedValue) ? getMonth(Date.now()) : getMonth(mergedValue[0]);
        startMonthScrollbarRef.value.scrollTo({
          debounce: false,
          index: monthIndex,
          elSize: MONTH_ITEM_HEIGHT
        });
      }
      if (startYearVlRef.value) {
        const yearIndex = (!Array.isArray(mergedValue) ? getYear(Date.now()) : getYear(mergedValue[0])) - START_YEAR;
        startYearVlRef.value.scrollTo({ index: yearIndex, debounce: false });
      }
    }
    if (value3 === void 0 || type5 === "end") {
      if (endMonthScrollbarRef.value) {
        const monthIndex = !Array.isArray(mergedValue) ? getMonth(Date.now()) : getMonth(mergedValue[1]);
        endMonthScrollbarRef.value.scrollTo({
          debounce: false,
          index: monthIndex,
          elSize: MONTH_ITEM_HEIGHT
        });
      }
      if (endYearVlRef.value) {
        const yearIndex = (!Array.isArray(mergedValue) ? getYear(Date.now()) : getYear(mergedValue[1])) - START_YEAR;
        endYearVlRef.value.scrollTo({ index: yearIndex, debounce: false });
      }
    }
  }
  function handleColItemClick(dateItem2, clickType) {
    const { value: value3 } = props;
    const noCurrentValue = !Array.isArray(value3);
    const itemTs = dateItem2.type === "year" && type4 !== "yearrange" ? noCurrentValue ? set(dateItem2.ts, {
      month: getMonth(type4 === "quarterrange" ? startOfQuarter(new Date()) : new Date())
    }).valueOf() : set(dateItem2.ts, {
      month: getMonth(type4 === "quarterrange" ? startOfQuarter(value3[clickType === "start" ? 0 : 1]) : value3[clickType === "start" ? 0 : 1])
    }).valueOf() : dateItem2.ts;
    if (noCurrentValue) {
      const partialValue = sanitizeValue(itemTs);
      const nextValue2 = [partialValue, partialValue];
      panelCommon.doUpdateValue(nextValue2, props.panel);
      justifyColumnsScrollState(nextValue2, "start");
      justifyColumnsScrollState(nextValue2, "end");
      panelCommon.disableTransitionOneTick();
      return;
    }
    const nextValue = [value3[0], value3[1]];
    let otherPartsChanged = false;
    if (clickType === "start") {
      nextValue[0] = sanitizeValue(itemTs);
      if (nextValue[0] > nextValue[1]) {
        nextValue[1] = nextValue[0];
        otherPartsChanged = true;
      }
    } else {
      nextValue[1] = sanitizeValue(itemTs);
      if (nextValue[0] > nextValue[1]) {
        nextValue[0] = nextValue[1];
        otherPartsChanged = true;
      }
    }
    panelCommon.doUpdateValue(nextValue, props.panel);
    switch (type4) {
      case "monthrange":
      case "quarterrange":
        panelCommon.disableTransitionOneTick();
        if (otherPartsChanged) {
          justifyColumnsScrollState(nextValue, "start");
          justifyColumnsScrollState(nextValue, "end");
        } else {
          justifyColumnsScrollState(nextValue, clickType);
        }
        break;
      case "yearrange":
        panelCommon.disableTransitionOneTick();
        justifyColumnsScrollState(nextValue, "start");
        justifyColumnsScrollState(nextValue, "end");
    }
  }
  function handleStartYearVlScroll() {
    var _a3;
    (_a3 = startYearScrollbarRef.value) === null || _a3 === void 0 ? void 0 : _a3.sync();
  }
  function handleEndYearVlScroll() {
    var _a3;
    (_a3 = endYearScrollbarRef.value) === null || _a3 === void 0 ? void 0 : _a3.sync();
  }
  function virtualListContainer(type5) {
    var _a3, _b3;
    if (type5 === "start") {
      return (_a3 = startYearVlRef.value) === null || _a3 === void 0 ? void 0 : _a3.listElRef;
    } else {
      return (_b3 = endYearVlRef.value) === null || _b3 === void 0 ? void 0 : _b3.listElRef;
    }
  }
  function virtualListContent(type5) {
    var _a3, _b3;
    if (type5 === "start") {
      return (_a3 = startYearVlRef.value) === null || _a3 === void 0 ? void 0 : _a3.itemsElRef;
    } else {
      return (_b3 = endYearVlRef.value) === null || _b3 === void 0 ? void 0 : _b3.itemsElRef;
    }
  }
  const childComponentRefs = {
    startYearVlRef,
    endYearVlRef,
    startMonthScrollbarRef,
    endMonthScrollbarRef,
    startYearScrollbarRef,
    endYearScrollbarRef
  };
  return Object.assign(Object.assign(Object.assign(Object.assign({
    startDatesElRef,
    endDatesElRef,
    handleDateClick,
    handleColItemClick,
    handleDateMouseEnter,
    handleConfirmClick,
    startCalendarPrevYear,
    startCalendarPrevMonth,
    startCalendarNextYear,
    startCalendarNextMonth,
    endCalendarPrevYear,
    endCalendarPrevMonth,
    endCalendarNextMonth,
    endCalendarNextYear,
    mergedIsDateDisabled,
    changeStartEndTime,
    ranges: rangesRef,
    startCalendarMonth: startCalendarMonthRef,
    startCalendarYear: startCalendarYearRef,
    endCalendarMonth: endCalendarMonthRef,
    endCalendarYear: endCalendarYearRef,
    weekdays: weekdaysRef,
    startDateArray: startDateArrayRef,
    endDateArray: endDateArrayRef,
    startYearArray: startYearArrayRef,
    startMonthArray: startMonthArrayRef,
    startQuarterArray: startQuarterArrayRef,
    endYearArray: endYearArrayRef,
    endMonthArray: endMonthArrayRef,
    endQuarterArray: endQuarterArrayRef,
    isSelecting: isSelectingRef,
    handleRangeShortcutMouseenter,
    handleRangeShortcutClick
  }, panelCommon), validation), childComponentRefs), {
    startDateDisplayString: startDateInput,
    endDateInput: endDateInputRef,
    timePickerSize: panelCommon.timePickerSize,
    startTimeValue: startTimeValueRef,
    endTimeValue: endTimeValueRef,
    datePickerSlots,
    shortcuts: shortcutsRef,
    startCalendarDateTime: startCalendarDateTimeRef,
    endCalendarDateTime: endCalendarDateTimeRef,
    justifyColumnsScrollState,
    handleFocusDetectorFocus: panelCommon.handleFocusDetectorFocus,
    handleStartTimePickerChange,
    handleEndTimePickerChange,
    handleStartDateInput,
    handleStartDateInputBlur,
    handleEndDateInput,
    handleEndDateInputBlur,
    handleStartYearVlScroll,
    handleEndYearVlScroll,
    virtualListContainer,
    virtualListContent,
    onUpdateStartCalendarValue,
    onUpdateEndCalendarValue
  });
}
var DatetimerangePanel = defineComponent({
  name: "DateTimeRangePanel",
  props: useDualCalendarProps,
  setup(props) {
    return useDualCalendar(props, "datetimerange");
  },
  render() {
    var _a2, _b2, _c2;
    const { mergedClsPrefix, mergedTheme, shortcuts, timePickerProps: timePickerProps2, onRender, $slots } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { ref: "selfRef", tabindex: 0, class: [
      `${mergedClsPrefix}-date-panel`,
      `${mergedClsPrefix}-date-panel--datetimerange`,
      !this.panel && `${mergedClsPrefix}-date-panel--shadow`,
      this.themeClass
    ], onKeydown: this.handlePanelKeyDown, onFocus: this.handlePanelFocus }, h$1("div", { class: `${mergedClsPrefix}-date-panel-header` }, h$1(NInput, { value: this.startDateDisplayString, theme: mergedTheme.peers.Input, themeOverrides: mergedTheme.peerOverrides.Input, size: this.timePickerSize, stateful: false, class: `${mergedClsPrefix}-date-panel-date-input`, textDecoration: this.isStartValueInvalid ? "line-through" : "", placeholder: this.locale.selectDate, onBlur: this.handleStartDateInputBlur, onUpdateValue: this.handleStartDateInput }), h$1(NTimePicker, Object.assign({ placeholder: this.locale.selectTime, format: this.timeFormat, size: this.timePickerSize }, Array.isArray(timePickerProps2) ? timePickerProps2[0] : timePickerProps2, { value: this.startTimeValue, to: false, showIcon: false, disabled: this.isSelecting, theme: mergedTheme.peers.TimePicker, themeOverrides: mergedTheme.peerOverrides.TimePicker, stateful: false, isHourDisabled: this.isStartHourDisabled, isMinuteDisabled: this.isStartMinuteDisabled, isSecondDisabled: this.isStartSecondDisabled, onUpdateValue: this.handleStartTimePickerChange })), h$1(NInput, { value: this.endDateInput, theme: mergedTheme.peers.Input, themeOverrides: mergedTheme.peerOverrides.Input, stateful: false, size: this.timePickerSize, class: `${mergedClsPrefix}-date-panel-date-input`, textDecoration: this.isEndValueInvalid ? "line-through" : "", placeholder: this.locale.selectDate, onBlur: this.handleEndDateInputBlur, onUpdateValue: this.handleEndDateInput }), h$1(NTimePicker, Object.assign({ placeholder: this.locale.selectTime, format: this.timeFormat, size: this.timePickerSize }, Array.isArray(timePickerProps2) ? timePickerProps2[1] : timePickerProps2, { disabled: this.isSelecting, showIcon: false, theme: mergedTheme.peers.TimePicker, themeOverrides: mergedTheme.peerOverrides.TimePicker, to: false, stateful: false, value: this.endTimeValue, isHourDisabled: this.isEndHourDisabled, isMinuteDisabled: this.isEndMinuteDisabled, isSecondDisabled: this.isEndSecondDisabled, onUpdateValue: this.handleEndTimePickerChange }))), h$1("div", { ref: "startDatesElRef", class: `${mergedClsPrefix}-date-panel-calendar ${mergedClsPrefix}-date-panel-calendar--start` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month__fast-prev`, onClick: this.startCalendarPrevYear }, resolveSlot($slots["prev-year"], () => [h$1(FastBackwardIcon, null)])), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__prev`, onClick: this.startCalendarPrevMonth }, resolveSlot($slots["prev-month"], () => [h$1(BackwardIcon, null)])), h$1(PanelHeader, { monthBeforeYear: this.locale.monthBeforeYear, value: this.startCalendarDateTime, onUpdateValue: this.onUpdateStartCalendarValue, mergedClsPrefix, calendarMonth: this.startCalendarMonth, calendarYear: this.startCalendarYear }), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__next`, onClick: this.startCalendarNextMonth }, resolveSlot($slots["next-month"], () => [h$1(ForwardIcon, null)])), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__fast-next`, onClick: this.startCalendarNextYear }, resolveSlot($slots["next-year"], () => [h$1(FastForwardIcon, null)]))), h$1("div", { class: `${mergedClsPrefix}-date-panel-weekdays` }, this.weekdays.map((weekday) => h$1("div", { key: weekday, class: `${mergedClsPrefix}-date-panel-weekdays__day` }, weekday))), h$1("div", { class: `${mergedClsPrefix}-date-panel__divider` }), h$1("div", { class: `${mergedClsPrefix}-date-panel-dates` }, this.startDateArray.map((dateItem2, i2) => {
      const disabled = this.mergedIsDateDisabled(dateItem2.ts);
      return h$1("div", { "data-n-date": true, key: i2, class: [
        `${mergedClsPrefix}-date-panel-date`,
        {
          [`${mergedClsPrefix}-date-panel-date--excluded`]: !dateItem2.inCurrentMonth,
          [`${mergedClsPrefix}-date-panel-date--current`]: dateItem2.isCurrentDate,
          [`${mergedClsPrefix}-date-panel-date--selected`]: dateItem2.selected,
          [`${mergedClsPrefix}-date-panel-date--covered`]: dateItem2.inSpan,
          [`${mergedClsPrefix}-date-panel-date--start`]: dateItem2.startOfSpan,
          [`${mergedClsPrefix}-date-panel-date--end`]: dateItem2.endOfSpan,
          [`${mergedClsPrefix}-date-panel-date--disabled`]: disabled
        }
      ], onClick: disabled ? void 0 : () => {
        this.handleDateClick(dateItem2);
      }, onMouseenter: disabled ? void 0 : () => {
        this.handleDateMouseEnter(dateItem2);
      } }, h$1("div", { class: `${mergedClsPrefix}-date-panel-date__trigger` }), dateItem2.dateObject.date, dateItem2.isCurrentDate ? h$1("div", { class: `${mergedClsPrefix}-date-panel-date__sup` }) : null);
    }))), h$1("div", { class: `${mergedClsPrefix}-date-panel__vertical-divider` }), h$1("div", { ref: "endDatesElRef", class: `${mergedClsPrefix}-date-panel-calendar ${mergedClsPrefix}-date-panel-calendar--end` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month__fast-prev`, onClick: this.endCalendarPrevYear }, resolveSlot($slots["prev-year"], () => [h$1(FastBackwardIcon, null)])), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__prev`, onClick: this.endCalendarPrevMonth }, resolveSlot($slots["prev-month"], () => [h$1(BackwardIcon, null)])), h$1(PanelHeader, { monthBeforeYear: this.locale.monthBeforeYear, value: this.endCalendarDateTime, onUpdateValue: this.onUpdateEndCalendarValue, mergedClsPrefix, calendarMonth: this.endCalendarMonth, calendarYear: this.endCalendarYear }), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__next`, onClick: this.endCalendarNextMonth }, resolveSlot($slots["next-month"], () => [h$1(ForwardIcon, null)])), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__fast-next`, onClick: this.endCalendarNextYear }, resolveSlot($slots["next-year"], () => [h$1(FastForwardIcon, null)]))), h$1("div", { class: `${mergedClsPrefix}-date-panel-weekdays` }, this.weekdays.map((weekday) => h$1("div", { key: weekday, class: `${mergedClsPrefix}-date-panel-weekdays__day` }, weekday))), h$1("div", { class: `${mergedClsPrefix}-date-panel__divider` }), h$1("div", { class: `${mergedClsPrefix}-date-panel-dates` }, this.endDateArray.map((dateItem2, i2) => {
      const disabled = this.mergedIsDateDisabled(dateItem2.ts);
      return h$1("div", { "data-n-date": true, key: i2, class: [
        `${mergedClsPrefix}-date-panel-date`,
        {
          [`${mergedClsPrefix}-date-panel-date--excluded`]: !dateItem2.inCurrentMonth,
          [`${mergedClsPrefix}-date-panel-date--current`]: dateItem2.isCurrentDate,
          [`${mergedClsPrefix}-date-panel-date--selected`]: dateItem2.selected,
          [`${mergedClsPrefix}-date-panel-date--covered`]: dateItem2.inSpan,
          [`${mergedClsPrefix}-date-panel-date--start`]: dateItem2.startOfSpan,
          [`${mergedClsPrefix}-date-panel-date--end`]: dateItem2.endOfSpan,
          [`${mergedClsPrefix}-date-panel-date--disabled`]: disabled
        }
      ], onClick: disabled ? void 0 : () => {
        this.handleDateClick(dateItem2);
      }, onMouseenter: disabled ? void 0 : () => {
        this.handleDateMouseEnter(dateItem2);
      } }, h$1("div", { class: `${mergedClsPrefix}-date-panel-date__trigger` }), dateItem2.dateObject.date, dateItem2.isCurrentDate ? h$1("div", { class: `${mergedClsPrefix}-date-panel-date__sup` }) : null);
    }))), this.datePickerSlots.footer ? h$1("div", { class: `${mergedClsPrefix}-date-panel-footer` }, this.datePickerSlots.footer()) : null, ((_a2 = this.actions) === null || _a2 === void 0 ? void 0 : _a2.length) || shortcuts ? h$1("div", { class: `${mergedClsPrefix}-date-panel-actions` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-actions__prefix` }, shortcuts && Object.keys(shortcuts).map((key) => {
      const shortcut = shortcuts[key];
      return Array.isArray(shortcut) || typeof shortcut === "function" ? h$1(XButton, { size: "tiny", onMouseenter: () => {
        this.handleRangeShortcutMouseenter(shortcut);
      }, onClick: () => {
        this.handleRangeShortcutClick(shortcut);
      }, onMouseleave: () => {
        this.handleShortcutMouseleave();
      } }, { default: () => key }) : null;
    })), h$1("div", { class: `${mergedClsPrefix}-date-panel-actions__suffix` }, ((_b2 = this.actions) === null || _b2 === void 0 ? void 0 : _b2.includes("clear")) ? h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", onClick: this.handleClearClick }, { default: () => this.locale.clear }) : null, ((_c2 = this.actions) === null || _c2 === void 0 ? void 0 : _c2.includes("confirm")) ? h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", type: "primary", disabled: this.isRangeInvalid || this.isSelecting, onClick: this.handleConfirmClick }, { default: () => this.locale.confirm }) : null)) : null, h$1(FocusDetector, { onFocus: this.handleFocusDetectorFocus }));
  }
});
var DatePanel = defineComponent({
  name: "DatePanel",
  props: useCalendarProps,
  setup(props) {
    return useCalendar(props, "date");
  },
  render() {
    var _a2, _b2, _c2;
    const { mergedClsPrefix, mergedTheme, shortcuts, onRender, $slots } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { ref: "selfRef", tabindex: 0, class: [
      `${mergedClsPrefix}-date-panel`,
      `${mergedClsPrefix}-date-panel--date`,
      !this.panel && `${mergedClsPrefix}-date-panel--shadow`,
      this.themeClass
    ], onFocus: this.handlePanelFocus, onKeydown: this.handlePanelKeyDown }, h$1("div", { class: `${mergedClsPrefix}-date-panel-calendar` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month__fast-prev`, onClick: this.prevYear }, resolveSlot($slots["prev-year"], () => [h$1(FastBackwardIcon, null)])), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__prev`, onClick: this.prevMonth }, resolveSlot($slots["prev-month"], () => [h$1(BackwardIcon, null)])), h$1(PanelHeader, { monthBeforeYear: this.locale.monthBeforeYear, value: this.calendarValue, onUpdateValue: this.onUpdateCalendarValue, mergedClsPrefix, calendarMonth: this.calendarMonth, calendarYear: this.calendarYear }), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__next`, onClick: this.nextMonth }, resolveSlot($slots["next-month"], () => [h$1(ForwardIcon, null)])), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__fast-next`, onClick: this.nextYear }, resolveSlot($slots["next-year"], () => [h$1(FastForwardIcon, null)]))), h$1("div", { class: `${mergedClsPrefix}-date-panel-weekdays` }, this.weekdays.map((weekday) => h$1("div", { key: weekday, class: `${mergedClsPrefix}-date-panel-weekdays__day` }, weekday))), h$1("div", { class: `${mergedClsPrefix}-date-panel-dates` }, this.dateArray.map((dateItem2, i2) => h$1("div", { "data-n-date": true, key: i2, class: [
      `${mergedClsPrefix}-date-panel-date`,
      {
        [`${mergedClsPrefix}-date-panel-date--current`]: dateItem2.isCurrentDate,
        [`${mergedClsPrefix}-date-panel-date--selected`]: dateItem2.selected,
        [`${mergedClsPrefix}-date-panel-date--excluded`]: !dateItem2.inCurrentMonth,
        [`${mergedClsPrefix}-date-panel-date--disabled`]: this.mergedIsDateDisabled(dateItem2.ts)
      }
    ], onClick: () => {
      this.handleDateClick(dateItem2);
    } }, h$1("div", { class: `${mergedClsPrefix}-date-panel-date__trigger` }), dateItem2.dateObject.date, dateItem2.isCurrentDate ? h$1("div", { class: `${mergedClsPrefix}-date-panel-date__sup` }) : null)))), this.datePickerSlots.footer ? h$1("div", { class: `${mergedClsPrefix}-date-panel-footer` }, this.datePickerSlots.footer()) : null, ((_a2 = this.actions) === null || _a2 === void 0 ? void 0 : _a2.length) || shortcuts ? h$1("div", { class: `${mergedClsPrefix}-date-panel-actions` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-actions__prefix` }, shortcuts && Object.keys(shortcuts).map((key) => {
      const shortcut = shortcuts[key];
      return Array.isArray(shortcut) ? null : h$1(XButton, { size: "tiny", onMouseenter: () => {
        this.handleSingleShortcutMouseenter(shortcut);
      }, onClick: () => {
        this.handleSingleShortcutClick(shortcut);
      }, onMouseleave: () => {
        this.handleShortcutMouseleave();
      } }, { default: () => key });
    })), h$1("div", { class: `${mergedClsPrefix}-date-panel-actions__suffix` }, ((_b2 = this.actions) === null || _b2 === void 0 ? void 0 : _b2.includes("clear")) ? h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", onClick: this.handleClearClick }, { default: () => this.locale.clear }) : null, ((_c2 = this.actions) === null || _c2 === void 0 ? void 0 : _c2.includes("now")) ? h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", onClick: this.handleNowClick }, { default: () => this.locale.now }) : null)) : null, h$1(FocusDetector, { onFocus: this.handleFocusDetectorFocus }));
  }
});
var DaterangePanel = defineComponent({
  name: "DateRangePanel",
  props: useDualCalendarProps,
  setup(props) {
    return useDualCalendar(props, "daterange");
  },
  render() {
    var _a2, _b2, _c2;
    const { mergedClsPrefix, mergedTheme, shortcuts, onRender, $slots } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { ref: "selfRef", tabindex: 0, class: [
      `${mergedClsPrefix}-date-panel`,
      `${mergedClsPrefix}-date-panel--daterange`,
      !this.panel && `${mergedClsPrefix}-date-panel--shadow`,
      this.themeClass
    ], onKeydown: this.handlePanelKeyDown, onFocus: this.handlePanelFocus }, h$1("div", { ref: "startDatesElRef", class: `${mergedClsPrefix}-date-panel-calendar ${mergedClsPrefix}-date-panel-calendar--start` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month__fast-prev`, onClick: this.startCalendarPrevYear }, resolveSlot($slots["prev-year"], () => [h$1(FastBackwardIcon, null)])), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__prev`, onClick: this.startCalendarPrevMonth }, resolveSlot($slots["prev-month"], () => [h$1(BackwardIcon, null)])), h$1(PanelHeader, { monthBeforeYear: this.locale.monthBeforeYear, value: this.startCalendarDateTime, onUpdateValue: this.onUpdateStartCalendarValue, mergedClsPrefix, calendarMonth: this.startCalendarMonth, calendarYear: this.startCalendarYear }), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__next`, onClick: this.startCalendarNextMonth }, resolveSlot($slots["next-month"], () => [h$1(ForwardIcon, null)])), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__fast-next`, onClick: this.startCalendarNextYear }, resolveSlot($slots["next-year"], () => [h$1(FastForwardIcon, null)]))), h$1("div", { class: `${mergedClsPrefix}-date-panel-weekdays` }, this.weekdays.map((weekday) => h$1("div", { key: weekday, class: `${mergedClsPrefix}-date-panel-weekdays__day` }, weekday))), h$1("div", { class: `${mergedClsPrefix}-date-panel__divider` }), h$1("div", { class: `${mergedClsPrefix}-date-panel-dates` }, this.startDateArray.map((dateItem2, i2) => h$1("div", { "data-n-date": true, key: i2, class: [
      `${mergedClsPrefix}-date-panel-date`,
      {
        [`${mergedClsPrefix}-date-panel-date--excluded`]: !dateItem2.inCurrentMonth,
        [`${mergedClsPrefix}-date-panel-date--current`]: dateItem2.isCurrentDate,
        [`${mergedClsPrefix}-date-panel-date--selected`]: dateItem2.selected,
        [`${mergedClsPrefix}-date-panel-date--covered`]: dateItem2.inSpan,
        [`${mergedClsPrefix}-date-panel-date--start`]: dateItem2.startOfSpan,
        [`${mergedClsPrefix}-date-panel-date--end`]: dateItem2.endOfSpan,
        [`${mergedClsPrefix}-date-panel-date--disabled`]: this.mergedIsDateDisabled(dateItem2.ts)
      }
    ], onClick: () => {
      this.handleDateClick(dateItem2);
    }, onMouseenter: () => {
      this.handleDateMouseEnter(dateItem2);
    } }, h$1("div", { class: `${mergedClsPrefix}-date-panel-date__trigger` }), dateItem2.dateObject.date, dateItem2.isCurrentDate ? h$1("div", { class: `${mergedClsPrefix}-date-panel-date__sup` }) : null)))), h$1("div", { class: `${mergedClsPrefix}-date-panel__vertical-divider` }), h$1("div", { ref: "endDatesElRef", class: `${mergedClsPrefix}-date-panel-calendar ${mergedClsPrefix}-date-panel-calendar--end` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month__fast-prev`, onClick: this.endCalendarPrevYear }, resolveSlot($slots["prev-year"], () => [h$1(FastBackwardIcon, null)])), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__prev`, onClick: this.endCalendarPrevMonth }, resolveSlot($slots["prev-month"], () => [h$1(BackwardIcon, null)])), h$1(PanelHeader, { monthBeforeYear: this.locale.monthBeforeYear, value: this.endCalendarDateTime, onUpdateValue: this.onUpdateEndCalendarValue, mergedClsPrefix, calendarMonth: this.endCalendarMonth, calendarYear: this.endCalendarYear }), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__next`, onClick: this.endCalendarNextMonth }, resolveSlot($slots["next-month"], () => [h$1(ForwardIcon, null)])), h$1("div", { class: `${mergedClsPrefix}-date-panel-month__fast-next`, onClick: this.endCalendarNextYear }, resolveSlot($slots["next-year"], () => [h$1(FastForwardIcon, null)]))), h$1("div", { class: `${mergedClsPrefix}-date-panel-weekdays` }, this.weekdays.map((weekday) => h$1("div", { key: weekday, class: `${mergedClsPrefix}-date-panel-weekdays__day` }, weekday))), h$1("div", { class: `${mergedClsPrefix}-date-panel__divider` }), h$1("div", { class: `${mergedClsPrefix}-date-panel-dates` }, this.endDateArray.map((dateItem2, i2) => h$1("div", { "data-n-date": true, key: i2, class: [
      `${mergedClsPrefix}-date-panel-date`,
      {
        [`${mergedClsPrefix}-date-panel-date--excluded`]: !dateItem2.inCurrentMonth,
        [`${mergedClsPrefix}-date-panel-date--current`]: dateItem2.isCurrentDate,
        [`${mergedClsPrefix}-date-panel-date--selected`]: dateItem2.selected,
        [`${mergedClsPrefix}-date-panel-date--covered`]: dateItem2.inSpan,
        [`${mergedClsPrefix}-date-panel-date--start`]: dateItem2.startOfSpan,
        [`${mergedClsPrefix}-date-panel-date--end`]: dateItem2.endOfSpan,
        [`${mergedClsPrefix}-date-panel-date--disabled`]: this.mergedIsDateDisabled(dateItem2.ts)
      }
    ], onClick: () => {
      this.handleDateClick(dateItem2);
    }, onMouseenter: () => {
      this.handleDateMouseEnter(dateItem2);
    } }, h$1("div", { class: `${mergedClsPrefix}-date-panel-date__trigger` }), dateItem2.dateObject.date, dateItem2.isCurrentDate ? h$1("div", { class: `${mergedClsPrefix}-date-panel-date__sup` }) : null)))), this.datePickerSlots.footer ? h$1("div", { class: `${mergedClsPrefix}-date-panel-footer` }, this.datePickerSlots.footer()) : null, ((_a2 = this.actions) === null || _a2 === void 0 ? void 0 : _a2.length) || shortcuts ? h$1("div", { class: `${mergedClsPrefix}-date-panel-actions` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-actions__prefix` }, shortcuts && Object.keys(shortcuts).map((key) => {
      const shortcut = shortcuts[key];
      return Array.isArray(shortcut) || typeof shortcut === "function" ? h$1(XButton, { size: "tiny", onMouseenter: () => {
        this.handleRangeShortcutMouseenter(shortcut);
      }, onClick: () => {
        this.handleRangeShortcutClick(shortcut);
      }, onMouseleave: () => {
        this.handleShortcutMouseleave();
      } }, { default: () => key }) : null;
    })), h$1("div", { class: `${mergedClsPrefix}-date-panel-actions__suffix` }, ((_b2 = this.actions) === null || _b2 === void 0 ? void 0 : _b2.includes("clear")) ? h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", onClick: this.handleClearClick }, { default: () => this.locale.clear }) : null, ((_c2 = this.actions) === null || _c2 === void 0 ? void 0 : _c2.includes("confirm")) ? h$1(NButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", type: "primary", disabled: this.isRangeInvalid || this.isSelecting, onClick: this.handleConfirmClick }, { default: () => this.locale.confirm }) : null)) : null, h$1(FocusDetector, { onFocus: this.handleFocusDetectorFocus }));
  }
});
var MonthRangePanel = defineComponent({
  name: "MonthRangePanel",
  props: Object.assign(Object.assign({}, useDualCalendarProps), { type: {
    type: String,
    required: true
  } }),
  setup(props) {
    const useCalendarRef = useDualCalendar(props, props.type);
    const renderItem = (item, i2, mergedClsPrefix, type4) => {
      const { handleColItemClick } = useCalendarRef;
      const disabled = false;
      return h$1("div", { "data-n-date": true, key: i2, class: [
        `${mergedClsPrefix}-date-panel-month-calendar__picker-col-item`,
        {
          [`${mergedClsPrefix}-date-panel-month-calendar__picker-col-item--current`]: item.isCurrent,
          [`${mergedClsPrefix}-date-panel-month-calendar__picker-col-item--selected`]: item.selected,
          [`${mergedClsPrefix}-date-panel-month-calendar__picker-col-item--disabled`]: disabled
        }
      ], onClick: () => {
        handleColItemClick(item, type4);
      } }, item.type === "month" ? item.dateObject.month + 1 : item.type === "quarter" ? `Q${item.dateObject.quarter}` : item.dateObject.year);
    };
    onMounted(() => {
      useCalendarRef.justifyColumnsScrollState();
    });
    return Object.assign(Object.assign({}, useCalendarRef), { renderItem });
  },
  render() {
    var _a2, _b2, _c2;
    const { mergedClsPrefix, mergedTheme, shortcuts, type: type4, renderItem, onRender } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { ref: "selfRef", tabindex: 0, class: [
      `${mergedClsPrefix}-date-panel`,
      `${mergedClsPrefix}-date-panel--daterange`,
      !this.panel && `${mergedClsPrefix}-date-panel--shadow`,
      this.themeClass
    ], onKeydown: this.handlePanelKeyDown, onFocus: this.handlePanelFocus }, h$1("div", { ref: "startDatesElRef", class: `${mergedClsPrefix}-date-panel-calendar ${mergedClsPrefix}-date-panel-calendar--start` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month-calendar` }, h$1(NScrollbar, { ref: "startYearScrollbarRef", class: `${mergedClsPrefix}-date-panel-month-calendar__picker-col`, theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar, container: () => this.virtualListContainer("start"), content: () => this.virtualListContent("start"), horizontalRailStyle: { zIndex: 1 }, verticalRailStyle: { zIndex: 1 } }, {
      default: () => h$1(VirtualList, { ref: "startYearVlRef", items: this.startYearArray, itemSize: MONTH_ITEM_HEIGHT, showScrollbar: false, keyField: "ts", onScroll: this.handleStartYearVlScroll, paddingBottom: 4 }, {
        default: ({ item, index: index2 }) => {
          return renderItem(item, index2, mergedClsPrefix, "start");
        }
      })
    }), type4 === "monthrange" || type4 === "quarterrange" ? h$1("div", { class: `${mergedClsPrefix}-date-panel-month-calendar__picker-col` }, h$1(NScrollbar, { ref: "startMonthScrollbarRef", theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar }, {
      default: () => [
        (type4 === "monthrange" ? this.startMonthArray : this.startQuarterArray).map((item, i2) => renderItem(item, i2, mergedClsPrefix, "start")),
        type4 === "monthrange" && h$1("div", { class: `${mergedClsPrefix}-date-panel-month-calendar__padding` })
      ]
    })) : null)), h$1("div", { class: `${mergedClsPrefix}-date-panel__vertical-divider` }), h$1("div", { ref: "endDatesElRef", class: `${mergedClsPrefix}-date-panel-calendar ${mergedClsPrefix}-date-panel-calendar--end` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-month-calendar` }, h$1(NScrollbar, { ref: "endYearScrollbarRef", class: `${mergedClsPrefix}-date-panel-month-calendar__picker-col`, theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar, container: () => this.virtualListContainer("end"), content: () => this.virtualListContent("end"), horizontalRailStyle: { zIndex: 1 }, verticalRailStyle: { zIndex: 1 } }, {
      default: () => h$1(VirtualList, { ref: "endYearVlRef", items: this.endYearArray, itemSize: MONTH_ITEM_HEIGHT, showScrollbar: false, keyField: "ts", onScroll: this.handleEndYearVlScroll, paddingBottom: 4 }, {
        default: ({ item, index: index2 }) => {
          return renderItem(item, index2, mergedClsPrefix, "end");
        }
      })
    }), type4 === "monthrange" || type4 === "quarterrange" ? h$1("div", { class: `${mergedClsPrefix}-date-panel-month-calendar__picker-col` }, h$1(NScrollbar, { ref: "endMonthScrollbarRef", theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar }, {
      default: () => [
        (type4 === "monthrange" ? this.endMonthArray : this.endQuarterArray).map((item, i2) => renderItem(item, i2, mergedClsPrefix, "end")),
        type4 === "monthrange" && h$1("div", { class: `${mergedClsPrefix}-date-panel-month-calendar__padding` })
      ]
    })) : null)), this.datePickerSlots.footer ? h$1("div", { class: `${mergedClsPrefix}-date-panel-footer` }, renderSlot(this.datePickerSlots, "footer")) : null, ((_a2 = this.actions) === null || _a2 === void 0 ? void 0 : _a2.length) || shortcuts ? h$1("div", { class: `${mergedClsPrefix}-date-panel-actions` }, h$1("div", { class: `${mergedClsPrefix}-date-panel-actions__prefix` }, shortcuts && Object.keys(shortcuts).map((key) => {
      const shortcut = shortcuts[key];
      return Array.isArray(shortcut) || typeof shortcut === "function" ? h$1(XButton, { size: "tiny", onMouseenter: () => {
        this.handleRangeShortcutMouseenter(shortcut);
      }, onClick: () => {
        this.handleRangeShortcutClick(shortcut);
      }, onMouseleave: () => {
        this.handleShortcutMouseleave();
      } }, { default: () => key }) : null;
    })), h$1("div", { class: `${mergedClsPrefix}-date-panel-actions__suffix` }, ((_b2 = this.actions) === null || _b2 === void 0 ? void 0 : _b2.includes("clear")) ? h$1(XButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", onClick: this.handleClearClick }, { default: () => this.locale.clear }) : null, ((_c2 = this.actions) === null || _c2 === void 0 ? void 0 : _c2.includes("confirm")) ? h$1(XButton, { theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "tiny", type: "primary", disabled: this.isRangeInvalid, onClick: this.handleConfirmClick }, { default: () => this.locale.confirm }) : null)) : null, h$1(FocusDetector, { onFocus: this.handleFocusDetectorFocus }));
  }
});
var style$j = c$2([cB$1("date-picker", `
 position: relative;
 z-index: auto;
 `, [cB$1("date-picker-icon", `
 color: var(--n-icon-color-override);
 transition: color .3s var(--n-bezier);
 `), cB$1("icon", `
 color: var(--n-icon-color-override);
 transition: color .3s var(--n-bezier);
 `), cM("disabled", [cB$1("date-picker-icon", `
 color: var(--n-icon-color-disabled-override);
 `), cB$1("icon", `
 color: var(--n-icon-color-disabled-override);
 `)])]), cB$1("date-panel", `
 width: fit-content;
 outline: none;
 margin: 4px 0;
 display: grid;
 grid-template-columns: 0fr;
 border-radius: var(--n-panel-border-radius);
 background-color: var(--n-panel-color);
 color: var(--n-panel-text-color);
 `, [fadeInScaleUpTransition(), cM("shadow", `
 box-shadow: var(--n-panel-box-shadow);
 `), cB$1("date-panel-calendar", {
  padding: "var(--n-calendar-left-padding)",
  display: "grid",
  gridTemplateColumns: "1fr",
  gridArea: "left-calendar"
}, [cM("end", {
  padding: "var(--n-calendar-right-padding)",
  gridArea: "right-calendar"
})]), cB$1("date-panel-month-calendar", {
  display: "flex",
  gridArea: "left-calendar"
}, [cE$1("picker-col", `
 min-width: var(--n-scroll-item-width);
 height: calc(var(--n-scroll-item-height) * 6);
 user-select: none;
 -webkit-user-select: none;
 `, [c$2("&:first-child", `
 min-width: calc(var(--n-scroll-item-width) + 4px);
 `, [cE$1("picker-col-item", [c$2("&::before", "left: 4px;")])]), cE$1("padding", `
 height: calc(var(--n-scroll-item-height) * 5)
 `)]), cE$1("picker-col-item", `
 z-index: 0;
 cursor: pointer;
 height: var(--n-scroll-item-height);
 box-sizing: border-box;
 padding-top: 4px;
 display: flex;
 align-items: center;
 justify-content: center;
 position: relative;
 transition: 
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 background: #0000;
 color: var(--n-item-text-color);
 `, [c$2("&::before", `
 z-index: -1;
 content: "";
 position: absolute;
 left: 0;
 right: 4px;
 top: 4px;
 bottom: 0;
 border-radius: var(--n-scroll-item-border-radius);
 transition: 
 background-color .3s var(--n-bezier);
 `), cNotM("disabled", [c$2("&:hover::before", `
 background-color: var(--n-item-color-hover);
 `), cM("selected", `
 color: var(--n-item-color-active);
 `, [c$2("&::before", "background-color: var(--n-item-color-hover);")])]), cM("disabled", `
 color: var(--n-item-text-color-disabled);
 cursor: not-allowed;
 `, [cM("selected", [c$2("&::before", `
 background-color: var(--n-item-color-disabled);
 `)])])])]), cM("date", {
  gridTemplateAreas: `
 "left-calendar"
 "footer"
 "action"
 `
}), cM("daterange", {
  gridTemplateAreas: `
 "left-calendar divider right-calendar"
 "footer footer footer"
 "action action action"
 `
}), cM("datetime", {
  gridTemplateAreas: `
 "header"
 "left-calendar"
 "footer"
 "action"
 `
}), cM("datetimerange", {
  gridTemplateAreas: `
 "header header header"
 "left-calendar divider right-calendar"
 "footer footer footer"
 "action action action"
 `
}), cM("month", {
  gridTemplateAreas: `
 "left-calendar"
 "footer"
 "action"
 `
}), cB$1("date-panel-footer", {
  gridArea: "footer"
}), cB$1("date-panel-actions", {
  gridArea: "action"
}), cB$1("date-panel-header", {
  gridArea: "header"
}), cB$1("date-panel-header", `
 box-sizing: border-box;
 width: 100%;
 align-items: center;
 padding: var(--n-panel-header-padding);
 display: flex;
 justify-content: space-between;
 border-bottom: 1px solid var(--n-panel-header-divider-color);
 `, [c$2(">", [c$2("*:not(:last-child)", {
  marginRight: "10px"
}), c$2("*", {
  flex: 1,
  width: 0
}), cB$1("time-picker", {
  zIndex: 1
})])]), cB$1("date-panel-month", `
 box-sizing: border-box;
 display: grid;
 grid-template-columns: var(--n-calendar-title-grid-template-columns);
 align-items: center;
 justify-items: center;
 padding: var(--n-calendar-title-padding);
 height: var(--n-calendar-title-height);
 `, [cE$1("prev, next, fast-prev, fast-next", `
 line-height: 0;
 cursor: pointer;
 width: var(--n-arrow-size);
 height: var(--n-arrow-size);
 color: var(--n-arrow-color);
 `), cE$1("month-year", `
 user-select: none;
 -webkit-user-select: none;
 flex-grow: 1;
 position: relative;
 `, [cE$1("text", `
 font-size: var(--n-calendar-title-font-size);
 line-height: var(--n-calendar-title-font-size);
 font-weight: var(--n-calendar-title-font-weight);
 padding: 6px 8px;
 text-align: center;
 color: var(--n-calendar-title-text-color);
 cursor: pointer;
 transition: background-color .3s var(--n-bezier);
 border-radius: var(--n-panel-border-radius);
 `, [cM("active", `
 background-color: var(--n-calendar-title-color-hover);
 `), c$2("&:hover", `
 background-color: var(--n-calendar-title-color-hover);
 `)])])]), cB$1("date-panel-weekdays", `
 display: grid;
 margin: auto;
 grid-template-columns: repeat(7, var(--n-item-cell-width));
 grid-template-rows: repeat(1, var(--n-item-cell-height));
 align-items: center;
 justify-items: center;
 margin-bottom: 4px;
 border-bottom: 1px solid var(--n-calendar-days-divider-color);
 `, [cE$1("day", `
 user-select: none;
 -webkit-user-select: none;
 line-height: 15px;
 width: var(--n-item-size);
 text-align: center;
 font-size: var(--n-calendar-days-font-size);
 color: var(--n-item-text-color);
 `)]), cB$1("date-panel-dates", `
 margin: auto;
 display: grid;
 grid-template-columns: repeat(7, var(--n-item-cell-width));
 grid-template-rows: repeat(6, var(--n-item-cell-height));
 align-items: center;
 justify-items: center;
 flex-wrap: wrap;
 `, [cB$1("date-panel-date", `
 user-select: none;
 -webkit-user-select: none;
 position: relative;
 width: var(--n-item-size);
 height: var(--n-item-size);
 line-height: var(--n-item-size);
 text-align: center;
 font-size: var(--n-item-font-size);
 border-radius: var(--n-item-border-radius);
 z-index: 0;
 cursor: pointer;
 transition:
 background-color .2s var(--n-bezier),
 color .2s var(--n-bezier);
 `, [cE$1("trigger", `
 position: absolute;
 left: calc(var(--n-item-size) / 2 - var(--n-item-cell-width) / 2);
 top: calc(var(--n-item-size) / 2 - var(--n-item-cell-height) / 2);
 width: var(--n-item-cell-width);
 height: var(--n-item-cell-height);
 `), cNotM("disabled", [cNotM("selected", [c$2("&:hover", {
  backgroundColor: "var(--n-item-color-hover)"
})])]), cM("current", [cE$1("sup", `
 position: absolute;
 top: 2px;
 right: 2px;
 content: "";
 height: 4px;
 width: 4px;
 border-radius: 2px;
 background-color: var(--n-item-color-active);
 transition:
 background-color .2s var(--n-bezier);
 `)]), c$2("&::after", `
 content: "";
 z-index: -1;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 transition: background-color .3s var(--n-bezier);
 `), cM("covered, start, end", [cNotM("excluded", [c$2("&::before", `
 content: "";
 z-index: -2;
 position: absolute;
 left: calc((var(--n-item-size) - var(--n-item-cell-width)) / 2);
 right: calc((var(--n-item-size) - var(--n-item-cell-width)) / 2);
 top: 0;
 bottom: 0;
 background-color: var(--n-item-color-included);
 `), c$2("&:nth-child(7n + 1)::before", {
  borderTopLeftRadius: "var(--n-item-border-radius)",
  borderBottomLeftRadius: "var(--n-item-border-radius)"
}), c$2("&:nth-child(7n + 7)::before", {
  borderTopRightRadius: "var(--n-item-border-radius)",
  borderBottomRightRadius: "var(--n-item-border-radius)"
})])]), cM("selected", {
  color: "var(--n-item-text-color-active)"
}, [c$2("&::after", {
  backgroundColor: "var(--n-item-color-active)"
}), cM("start", [c$2("&::before", {
  left: "50%"
})]), cM("end", [c$2("&::before", {
  right: "50%"
})]), cE$1("sup", {
  backgroundColor: "var(--n-panel-color)"
})]), cM("excluded", {
  color: "var(--n-item-text-color-disabled)"
}, [cM("selected", [c$2("&::after", {
  backgroundColor: "var(--n-item-color-disabled)"
})])]), cM("disabled", {
  cursor: "not-allowed",
  color: "var(--n-item-text-color-disabled)"
}, [cM("covered", [c$2("&::before", {
  backgroundColor: "var(--n-item-color-disabled)"
})]), cM("selected", [c$2("&::before", {
  backgroundColor: "var(--n-item-color-disabled)"
}), c$2("&::after", {
  backgroundColor: "var(--n-item-color-disabled)"
})])])])]), cE$1("vertical-divider", `
 grid-area: divider;
 height: 100%;
 width: 1px;
 background-color: var(--n-calendar-divider-color);
 `), cB$1("date-panel-footer", {
  borderTop: "1px solid var(--n-panel-action-divider-color)",
  padding: "var(--n-panel-extra-footer-padding)"
}), cB$1("date-panel-actions", `
 flex: 1;
 padding: var(--n-panel-action-padding);
 display: flex;
 align-items: center;
 justify-content: space-between;
 border-top: 1px solid var(--n-panel-action-divider-color);
 `, [cE$1("prefix, suffix", `
 display: flex;
 margin-bottom: -8px;
 `), cE$1("suffix", `
 align-self: flex-end;
 `), cE$1("prefix", `
 flex-wrap: wrap;
 `), cB$1("button", `
 margin-bottom: 8px;
 `, [c$2("&:not(:last-child)", `
 margin-right: 8px;
 `)])])]), c$2("[data-n-date].transition-disabled", {
  transition: "none !important"
}, [c$2("&::before, &::after", {
  transition: "none !important"
})])]);
const datePickerProps = Object.assign(Object.assign({}, useTheme.props), {
  to: useAdjustedTo.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  clearable: Boolean,
  updateValueOnClose: Boolean,
  defaultValue: [Number, Array],
  defaultFormattedValue: [String, Array],
  defaultTime: [Number, String, Array],
  disabled: {
    type: Boolean,
    default: void 0
  },
  placement: {
    type: String,
    default: "bottom-start"
  },
  value: [Number, Array],
  formattedValue: [String, Array],
  size: String,
  type: {
    type: String,
    default: "date"
  },
  valueFormat: String,
  separator: String,
  placeholder: String,
  startPlaceholder: String,
  endPlaceholder: String,
  format: String,
  dateFormat: String,
  timeFormat: String,
  actions: Array,
  shortcuts: Object,
  isDateDisabled: Function,
  isTimeDisabled: Function,
  show: {
    type: Boolean,
    default: void 0
  },
  panel: Boolean,
  ranges: Object,
  firstDayOfWeek: Number,
  inputReadonly: Boolean,
  closeOnSelect: Boolean,
  status: String,
  timePickerProps: [Object, Array],
  onClear: Function,
  onConfirm: Function,
  defaultCalendarStartTime: Number,
  defaultCalendarEndTime: Number,
  bindCalendarMonths: Boolean,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  "onUpdate:formattedValue": [Function, Array],
  onUpdateFormattedValue: [Function, Array],
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onChange: [Function, Array]
});
var NDatePicker = defineComponent({
  name: "DatePicker",
  props: datePickerProps,
  setup(props, { slots }) {
    var _a2;
    const { localeRef, dateLocaleRef } = useLocale("DatePicker");
    const formItem = useFormItem(props);
    const { mergedSizeRef, mergedDisabledRef, mergedStatusRef } = formItem;
    const { mergedComponentPropsRef, mergedClsPrefixRef, mergedBorderedRef, namespaceRef, inlineThemeDisabled } = useConfig(props);
    const panelInstRef = ref(null);
    const triggerElRef = ref(null);
    const inputInstRef = ref(null);
    const uncontrolledShowRef = ref(false);
    const controlledShowRef = toRef(props, "show");
    const mergedShowRef = useMergedState(controlledShowRef, uncontrolledShowRef);
    const dateFnsOptionsRef = computed(() => {
      return {
        locale: dateLocaleRef.value.locale
      };
    });
    const mergedFormatRef = computed(() => {
      const { format: format2 } = props;
      if (format2)
        return format2;
      switch (props.type) {
        case "date":
        case "daterange":
          return localeRef.value.dateFormat;
        case "datetime":
        case "datetimerange":
          return localeRef.value.dateTimeFormat;
        case "year":
        case "yearrange":
          return localeRef.value.yearTypeFormat;
        case "month":
        case "monthrange":
          return localeRef.value.monthTypeFormat;
        case "quarter":
        case "quarterrange":
          return localeRef.value.quarterFormat;
      }
    });
    const mergedValueFormatRef = computed(() => {
      var _a3;
      return (_a3 = props.valueFormat) !== null && _a3 !== void 0 ? _a3 : mergedFormatRef.value;
    });
    function getTimestampValue(value2) {
      if (value2 === null)
        return null;
      const { value: mergedValueFormat } = mergedValueFormatRef;
      const { value: dateFnsOptions } = dateFnsOptionsRef;
      if (Array.isArray(value2)) {
        return [
          strictParse(value2[0], mergedValueFormat, new Date(), dateFnsOptions).getTime(),
          strictParse(value2[1], mergedValueFormat, new Date(), dateFnsOptions).getTime()
        ];
      }
      return strictParse(value2, mergedValueFormat, new Date(), dateFnsOptions).getTime();
    }
    const { defaultFormattedValue, defaultValue } = props;
    const uncontrolledValueRef = ref((_a2 = defaultFormattedValue !== void 0 ? getTimestampValue(defaultFormattedValue) : defaultValue) !== null && _a2 !== void 0 ? _a2 : null);
    const controlledValueRef = computed(() => {
      const { formattedValue } = props;
      if (formattedValue !== void 0) {
        return getTimestampValue(formattedValue);
      }
      return props.value;
    });
    const mergedValueRef = useMergedState(controlledValueRef, uncontrolledValueRef);
    const pendingValueRef = ref(null);
    watchEffect(() => {
      pendingValueRef.value = mergedValueRef.value;
    });
    const singleInputValueRef = ref("");
    const rangeStartInputValueRef = ref("");
    const rangeEndInputValueRef = ref("");
    const themeRef = useTheme("DatePicker", "-date-picker", style$j, datePickerLight$1, props, mergedClsPrefixRef);
    const timePickerSizeRef = computed(() => {
      var _a3, _b2;
      return ((_b2 = (_a3 = mergedComponentPropsRef === null || mergedComponentPropsRef === void 0 ? void 0 : mergedComponentPropsRef.value) === null || _a3 === void 0 ? void 0 : _a3.DatePicker) === null || _b2 === void 0 ? void 0 : _b2.timePickerSize) || "small";
    });
    const isRangeRef = computed(() => {
      return [
        "daterange",
        "datetimerange",
        "monthrange",
        "quarterrange",
        "yearrange"
      ].includes(props.type);
    });
    const localizedPlacehoderRef = computed(() => {
      const { placeholder } = props;
      if (placeholder === void 0) {
        const { type: type4 } = props;
        switch (type4) {
          case "date":
            return localeRef.value.datePlaceholder;
          case "datetime":
            return localeRef.value.datetimePlaceholder;
          case "month":
            return localeRef.value.monthPlaceholder;
          case "year":
            return localeRef.value.yearPlaceholder;
          case "quarter":
            return localeRef.value.quarterPlaceholder;
          default:
            return "";
        }
      } else {
        return placeholder;
      }
    });
    const localizedStartPlaceholderRef = computed(() => {
      if (props.startPlaceholder === void 0) {
        if (props.type === "daterange") {
          return localeRef.value.startDatePlaceholder;
        } else if (props.type === "datetimerange") {
          return localeRef.value.startDatetimePlaceholder;
        } else if (props.type === "monthrange") {
          return localeRef.value.startMonthPlaceholder;
        }
        return "";
      } else {
        return props.startPlaceholder;
      }
    });
    const localizedEndPlaceholderRef = computed(() => {
      if (props.endPlaceholder === void 0) {
        if (props.type === "daterange") {
          return localeRef.value.endDatePlaceholder;
        } else if (props.type === "datetimerange") {
          return localeRef.value.endDatetimePlaceholder;
        } else if (props.type === "monthrange") {
          return localeRef.value.endMonthPlaceholder;
        }
        return "";
      } else {
        return props.endPlaceholder;
      }
    });
    const mergedActionsRef = computed(() => {
      const { actions, type: type4, clearable } = props;
      if (actions === null)
        return [];
      if (actions !== void 0)
        return actions;
      const result2 = clearable ? ["clear"] : [];
      switch (type4) {
        case "date": {
          result2.push("now");
          return result2;
        }
        case "datetime": {
          result2.push("now", "confirm");
          return result2;
        }
        case "daterange": {
          result2.push("confirm");
          return result2;
        }
        case "datetimerange": {
          result2.push("confirm");
          return result2;
        }
        case "month": {
          result2.push("now", "confirm");
          return result2;
        }
        case "year": {
          result2.push("now");
          return result2;
        }
        case "quarter": {
          result2.push("now", "confirm");
          return result2;
        }
        case "monthrange":
        case "yearrange":
        case "quarterrange": {
          result2.push("confirm");
          return result2;
        }
        default: {
          warn$2("date-picker", "The type is wrong, n-date-picker's type only supports `date`, `datetime`, `daterange` and `datetimerange`.");
          break;
        }
      }
    });
    function getFormattedValue(value2) {
      if (value2 === null)
        return null;
      if (Array.isArray(value2)) {
        const { value: mergedValueFormat } = mergedValueFormatRef;
        const { value: dateFnsOptions } = dateFnsOptionsRef;
        return [
          format$4(value2[0], mergedValueFormat, dateFnsOptions),
          format$4(value2[1], mergedValueFormat, dateFnsOptionsRef.value)
        ];
      } else {
        return format$4(value2, mergedValueFormatRef.value, dateFnsOptionsRef.value);
      }
    }
    function doUpdatePendingValue(value2) {
      pendingValueRef.value = value2;
    }
    function doUpdateFormattedValue(value2, timestampValue) {
      const { "onUpdate:formattedValue": _onUpdateFormattedValue, onUpdateFormattedValue } = props;
      if (_onUpdateFormattedValue) {
        call(_onUpdateFormattedValue, value2, timestampValue);
      }
      if (onUpdateFormattedValue) {
        call(onUpdateFormattedValue, value2, timestampValue);
      }
    }
    function doUpdateValue(value2, options) {
      const { "onUpdate:value": _onUpdateValue, onUpdateValue, onChange } = props;
      const { nTriggerFormChange, nTriggerFormInput } = formItem;
      const formattedValue = getFormattedValue(value2);
      if (options.doConfirm) {
        doConfirm(value2, formattedValue);
      }
      if (onUpdateValue) {
        call(onUpdateValue, value2, formattedValue);
      }
      if (_onUpdateValue) {
        call(_onUpdateValue, value2, formattedValue);
      }
      if (onChange)
        call(onChange, value2, formattedValue);
      uncontrolledValueRef.value = value2;
      doUpdateFormattedValue(formattedValue, value2);
      nTriggerFormChange();
      nTriggerFormInput();
    }
    function doClear() {
      const { onClear } = props;
      onClear === null || onClear === void 0 ? void 0 : onClear();
    }
    function doConfirm(value2, formattedValue) {
      const { onConfirm } = props;
      if (onConfirm)
        onConfirm(value2, formattedValue);
    }
    function doFocus(e25) {
      const { onFocus } = props;
      const { nTriggerFormFocus } = formItem;
      if (onFocus)
        call(onFocus, e25);
      nTriggerFormFocus();
    }
    function doBlur(e25) {
      const { onBlur } = props;
      const { nTriggerFormBlur } = formItem;
      if (onBlur)
        call(onBlur, e25);
      nTriggerFormBlur();
    }
    function doUpdateShow(show) {
      const { "onUpdate:show": _onUpdateShow, onUpdateShow } = props;
      if (_onUpdateShow)
        call(_onUpdateShow, show);
      if (onUpdateShow)
        call(onUpdateShow, show);
      uncontrolledShowRef.value = show;
    }
    function handleKeydown(e25) {
      if (e25.key === "Escape") {
        if (mergedShowRef.value) {
          markEventEffectPerformed(e25);
          closeCalendar({
            returnFocus: true
          });
        }
      }
    }
    function handleInputKeydown(e25) {
      if (e25.key === "Escape" && mergedShowRef.value) {
        markEventEffectPerformed(e25);
      }
    }
    function handleClear() {
      var _a3;
      doUpdateShow(false);
      (_a3 = inputInstRef.value) === null || _a3 === void 0 ? void 0 : _a3.deactivate();
      doClear();
    }
    function handlePanelClear() {
      var _a3;
      (_a3 = inputInstRef.value) === null || _a3 === void 0 ? void 0 : _a3.deactivate();
      doClear();
    }
    function handlePanelTabOut() {
      closeCalendar({
        returnFocus: true
      });
    }
    function handleClickOutside(e25) {
      var _a3;
      if (mergedShowRef.value && !((_a3 = triggerElRef.value) === null || _a3 === void 0 ? void 0 : _a3.contains(getPreciseEventTarget(e25)))) {
        closeCalendar({
          returnFocus: false
        });
      }
    }
    function handlePanelClose(disableUpdateOnClose) {
      closeCalendar({
        returnFocus: true,
        disableUpdateOnClose
      });
    }
    function handlePanelUpdateValue(value2, doUpdate) {
      if (doUpdate) {
        doUpdateValue(value2, { doConfirm: false });
      } else {
        doUpdatePendingValue(value2);
      }
    }
    function handlePanelConfirm() {
      const pendingValue = pendingValueRef.value;
      doUpdateValue(Array.isArray(pendingValue) ? [pendingValue[0], pendingValue[1]] : pendingValue, { doConfirm: true });
    }
    function deriveInputState() {
      const { value: value2 } = pendingValueRef;
      if (isRangeRef.value) {
        if (Array.isArray(value2) || value2 === null) {
          deriveRangeInputState(value2);
        }
      } else {
        if (!Array.isArray(value2)) {
          deriveSingleInputState(value2);
        }
      }
    }
    function deriveSingleInputState(value2) {
      if (value2 === null) {
        singleInputValueRef.value = "";
      } else {
        singleInputValueRef.value = format$4(value2, mergedFormatRef.value, dateFnsOptionsRef.value);
      }
    }
    function deriveRangeInputState(values2) {
      if (values2 === null) {
        rangeStartInputValueRef.value = "";
        rangeEndInputValueRef.value = "";
      } else {
        const dateFnsOptions = dateFnsOptionsRef.value;
        rangeStartInputValueRef.value = format$4(values2[0], mergedFormatRef.value, dateFnsOptions);
        rangeEndInputValueRef.value = format$4(values2[1], mergedFormatRef.value, dateFnsOptions);
      }
    }
    function handleInputActivate() {
      if (!mergedShowRef.value) {
        openCalendar();
      }
    }
    function handleInputBlur(e25) {
      var _a3;
      if (!((_a3 = panelInstRef.value) === null || _a3 === void 0 ? void 0 : _a3.$el.contains(e25.relatedTarget))) {
        doBlur(e25);
        deriveInputState();
        closeCalendar({
          returnFocus: false
        });
      }
    }
    function handleInputDeactivate() {
      if (mergedDisabledRef.value)
        return;
      deriveInputState();
      closeCalendar({
        returnFocus: false
      });
    }
    function handleSingleUpdateValue(v2) {
      if (v2 === "") {
        doUpdateValue(null, { doConfirm: false });
        pendingValueRef.value = null;
        singleInputValueRef.value = "";
        return;
      }
      const newSelectedDateTime = strictParse(v2, mergedFormatRef.value, new Date(), dateFnsOptionsRef.value);
      if (isValid$1(newSelectedDateTime)) {
        doUpdateValue(getTime(newSelectedDateTime), { doConfirm: false });
        deriveInputState();
      } else {
        singleInputValueRef.value = v2;
      }
    }
    function handleRangeUpdateValue(v2) {
      if (v2[0] === "" && v2[1] === "") {
        doUpdateValue(null, { doConfirm: false });
        pendingValueRef.value = null;
        rangeStartInputValueRef.value = "";
        rangeEndInputValueRef.value = "";
        return;
      }
      const [startTime, endTime] = v2;
      const newStartTime = strictParse(startTime, mergedFormatRef.value, new Date(), dateFnsOptionsRef.value);
      const newEndTime = strictParse(endTime, mergedFormatRef.value, new Date(), dateFnsOptionsRef.value);
      if (isValid$1(newStartTime) && isValid$1(newEndTime)) {
        doUpdateValue([getTime(newStartTime), getTime(newEndTime)], {
          doConfirm: false
        });
        deriveInputState();
      } else {
        [rangeStartInputValueRef.value, rangeEndInputValueRef.value] = v2;
      }
    }
    function handleTriggerClick(e25) {
      if (mergedDisabledRef.value)
        return;
      if (happensIn(e25, "clear"))
        return;
      if (!mergedShowRef.value) {
        openCalendar();
      }
    }
    function handleInputFocus(e25) {
      if (mergedDisabledRef.value)
        return;
      doFocus(e25);
    }
    function openCalendar() {
      if (mergedDisabledRef.value || mergedShowRef.value)
        return;
      doUpdateShow(true);
    }
    function closeCalendar({ returnFocus, disableUpdateOnClose }) {
      var _a3;
      if (mergedShowRef.value) {
        doUpdateShow(false);
        if (props.type !== "date" && props.updateValueOnClose && !disableUpdateOnClose) {
          handlePanelConfirm();
        }
        if (returnFocus) {
          (_a3 = inputInstRef.value) === null || _a3 === void 0 ? void 0 : _a3.focus();
        }
      }
    }
    watch(pendingValueRef, () => {
      deriveInputState();
    });
    deriveInputState();
    watch(mergedShowRef, (value2) => {
      if (!value2) {
        pendingValueRef.value = mergedValueRef.value;
      }
    });
    const uniVaidation = uniCalendarValidation(props, pendingValueRef);
    const dualValidation = dualCalendarValidation(props, pendingValueRef);
    provide(datePickerInjectionKey, Object.assign(Object.assign(Object.assign({
      mergedClsPrefixRef,
      mergedThemeRef: themeRef,
      timePickerSizeRef,
      localeRef,
      dateLocaleRef,
      firstDayOfWeekRef: toRef(props, "firstDayOfWeek"),
      isDateDisabledRef: toRef(props, "isDateDisabled"),
      rangesRef: toRef(props, "ranges"),
      timePickerPropsRef: toRef(props, "timePickerProps"),
      closeOnSelectRef: toRef(props, "closeOnSelect"),
      updateValueOnCloseRef: toRef(props, "updateValueOnClose")
    }, uniVaidation), dualValidation), { datePickerSlots: slots }));
    const exposedMethods = {
      focus: () => {
        var _a3;
        (_a3 = inputInstRef.value) === null || _a3 === void 0 ? void 0 : _a3.focus();
      },
      blur: () => {
        var _a3;
        (_a3 = inputInstRef.value) === null || _a3 === void 0 ? void 0 : _a3.blur();
      }
    };
    const triggerCssVarsRef = computed(() => {
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { iconColor, iconColorDisabled } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-icon-color-override": iconColor,
        "--n-icon-color-disabled-override": iconColorDisabled
      };
    });
    const triggerThemeClassHandle = inlineThemeDisabled ? useThemeClass("date-picker-trigger", void 0, triggerCssVarsRef, props) : void 0;
    const cssVarsRef = computed(() => {
      const { type: type4 } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { calendarTitleFontSize, calendarDaysFontSize, itemFontSize, itemTextColor, itemColorDisabled, itemColorIncluded, itemColorHover, itemColorActive, itemBorderRadius, itemTextColorDisabled, itemTextColorActive, panelColor, panelTextColor, arrowColor, calendarTitleTextColor, panelActionDividerColor, panelHeaderDividerColor, calendarDaysDividerColor, panelBoxShadow, panelBorderRadius, calendarTitleFontWeight, panelExtraFooterPadding, panelActionPadding, itemSize, itemCellWidth, itemCellHeight, scrollItemWidth, scrollItemHeight, calendarTitlePadding, calendarTitleHeight, calendarDaysHeight, calendarDaysTextColor, arrowSize: arrowSize2, panelHeaderPadding, calendarDividerColor, calendarTitleGridTempateColumns, iconColor, iconColorDisabled, scrollItemBorderRadius, calendarTitleColorHover, [createKey("calendarLeftPadding", type4)]: calendarLeftPadding, [createKey("calendarRightPadding", type4)]: calendarRightPadding } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-panel-border-radius": panelBorderRadius,
        "--n-panel-color": panelColor,
        "--n-panel-box-shadow": panelBoxShadow,
        "--n-panel-text-color": panelTextColor,
        "--n-panel-header-padding": panelHeaderPadding,
        "--n-panel-header-divider-color": panelHeaderDividerColor,
        "--n-calendar-left-padding": calendarLeftPadding,
        "--n-calendar-right-padding": calendarRightPadding,
        "--n-calendar-title-color-hover": calendarTitleColorHover,
        "--n-calendar-title-height": calendarTitleHeight,
        "--n-calendar-title-padding": calendarTitlePadding,
        "--n-calendar-title-font-size": calendarTitleFontSize,
        "--n-calendar-title-font-weight": calendarTitleFontWeight,
        "--n-calendar-title-text-color": calendarTitleTextColor,
        "--n-calendar-title-grid-template-columns": calendarTitleGridTempateColumns,
        "--n-calendar-days-height": calendarDaysHeight,
        "--n-calendar-days-divider-color": calendarDaysDividerColor,
        "--n-calendar-days-font-size": calendarDaysFontSize,
        "--n-calendar-days-text-color": calendarDaysTextColor,
        "--n-calendar-divider-color": calendarDividerColor,
        "--n-panel-action-padding": panelActionPadding,
        "--n-panel-extra-footer-padding": panelExtraFooterPadding,
        "--n-panel-action-divider-color": panelActionDividerColor,
        "--n-item-font-size": itemFontSize,
        "--n-item-border-radius": itemBorderRadius,
        "--n-item-size": itemSize,
        "--n-item-cell-width": itemCellWidth,
        "--n-item-cell-height": itemCellHeight,
        "--n-item-text-color": itemTextColor,
        "--n-item-color-included": itemColorIncluded,
        "--n-item-color-disabled": itemColorDisabled,
        "--n-item-color-hover": itemColorHover,
        "--n-item-color-active": itemColorActive,
        "--n-item-text-color-disabled": itemTextColorDisabled,
        "--n-item-text-color-active": itemTextColorActive,
        "--n-scroll-item-width": scrollItemWidth,
        "--n-scroll-item-height": scrollItemHeight,
        "--n-scroll-item-border-radius": scrollItemBorderRadius,
        "--n-arrow-size": arrowSize2,
        "--n-arrow-color": arrowColor,
        "--n-icon-color": iconColor,
        "--n-icon-color-disabled": iconColorDisabled
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("date-picker", computed(() => {
      return props.type;
    }), cssVarsRef, props) : void 0;
    return Object.assign(Object.assign({}, exposedMethods), {
      mergedStatus: mergedStatusRef,
      mergedClsPrefix: mergedClsPrefixRef,
      mergedBordered: mergedBorderedRef,
      namespace: namespaceRef,
      uncontrolledValue: uncontrolledValueRef,
      pendingValue: pendingValueRef,
      panelInstRef,
      triggerElRef,
      inputInstRef,
      isMounted: isMounted(),
      displayTime: singleInputValueRef,
      displayStartTime: rangeStartInputValueRef,
      displayEndTime: rangeEndInputValueRef,
      mergedShow: mergedShowRef,
      adjustedTo: useAdjustedTo(props),
      isRange: isRangeRef,
      localizedStartPlaceholder: localizedStartPlaceholderRef,
      localizedEndPlaceholder: localizedEndPlaceholderRef,
      mergedSize: mergedSizeRef,
      mergedDisabled: mergedDisabledRef,
      localizedPlacehoder: localizedPlacehoderRef,
      isValueInvalid: uniVaidation.isValueInvalidRef,
      isStartValueInvalid: dualValidation.isStartValueInvalidRef,
      isEndValueInvalid: dualValidation.isEndValueInvalidRef,
      handleInputKeydown,
      handleClickOutside,
      handleKeydown,
      handleClear,
      handlePanelClear,
      handleTriggerClick,
      handleInputActivate,
      handleInputDeactivate,
      handleInputFocus,
      handleInputBlur,
      handlePanelTabOut,
      handlePanelClose,
      handleRangeUpdateValue,
      handleSingleUpdateValue,
      handlePanelUpdateValue,
      handlePanelConfirm,
      mergedTheme: themeRef,
      actions: mergedActionsRef,
      triggerCssVars: inlineThemeDisabled ? void 0 : triggerCssVarsRef,
      triggerThemeClass: triggerThemeClassHandle === null || triggerThemeClassHandle === void 0 ? void 0 : triggerThemeClassHandle.themeClass,
      triggerOnRender: triggerThemeClassHandle === null || triggerThemeClassHandle === void 0 ? void 0 : triggerThemeClassHandle.onRender,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    });
  },
  render() {
    const { clearable, triggerOnRender, mergedClsPrefix, $slots } = this;
    const commonPanelProps = {
      onUpdateValue: this.handlePanelUpdateValue,
      onTabOut: this.handlePanelTabOut,
      onClose: this.handlePanelClose,
      onClear: this.handlePanelClear,
      onKeydown: this.handleKeydown,
      onConfirm: this.handlePanelConfirm,
      ref: "panelInstRef",
      value: this.pendingValue,
      active: this.mergedShow,
      actions: this.actions,
      shortcuts: this.shortcuts,
      style: this.cssVars,
      defaultTime: this.defaultTime,
      themeClass: this.themeClass,
      panel: this.panel,
      onRender: this.onRender
    };
    const renderPanel = () => {
      const { type: type4 } = this;
      return type4 === "datetime" ? h$1(DatetimePanel, Object.assign({}, commonPanelProps), $slots) : type4 === "daterange" ? h$1(DaterangePanel, Object.assign({}, commonPanelProps, { defaultCalendarStartTime: this.defaultCalendarStartTime, defaultCalendarEndTime: this.defaultCalendarEndTime, bindCalendarMonths: this.bindCalendarMonths }), $slots) : type4 === "datetimerange" ? h$1(DatetimerangePanel, Object.assign({}, commonPanelProps, { defaultCalendarStartTime: this.defaultCalendarStartTime, defaultCalendarEndTime: this.defaultCalendarEndTime, bindCalendarMonths: this.bindCalendarMonths }), $slots) : type4 === "month" || type4 === "year" || type4 === "quarter" ? h$1(MonthPanel, Object.assign({}, commonPanelProps, { type: type4, key: type4 })) : type4 === "monthrange" || type4 === "yearrange" || type4 === "quarterrange" ? h$1(MonthRangePanel, Object.assign({}, commonPanelProps, { type: type4 })) : h$1(DatePanel, Object.assign({}, commonPanelProps), $slots);
    };
    if (this.panel) {
      return renderPanel();
    }
    triggerOnRender === null || triggerOnRender === void 0 ? void 0 : triggerOnRender();
    const commonInputProps = {
      bordered: this.mergedBordered,
      size: this.mergedSize,
      passivelyActivated: true,
      disabled: this.mergedDisabled,
      readonly: this.inputReadonly || this.mergedDisabled,
      clearable,
      onClear: this.handleClear,
      onClick: this.handleTriggerClick,
      onKeydown: this.handleInputKeydown,
      onActivate: this.handleInputActivate,
      onDeactivate: this.handleInputDeactivate,
      onFocus: this.handleInputFocus,
      onBlur: this.handleInputBlur
    };
    return h$1("div", { ref: "triggerElRef", class: [
      `${mergedClsPrefix}-date-picker`,
      this.mergedDisabled && `${mergedClsPrefix}-date-picker--disabled`,
      this.isRange && `${mergedClsPrefix}-date-picker--range`,
      this.triggerThemeClass
    ], style: this.triggerCssVars, onKeydown: this.handleKeydown }, h$1(VBinder, null, {
      default: () => [
        h$1(VTarget, null, {
          default: () => this.isRange ? h$1(NInput, Object.assign({ ref: "inputInstRef", status: this.mergedStatus, value: [this.displayStartTime, this.displayEndTime], placeholder: [
            this.localizedStartPlaceholder,
            this.localizedEndPlaceholder
          ], textDecoration: [
            this.isStartValueInvalid ? "line-through" : "",
            this.isEndValueInvalid ? "line-through" : ""
          ], pair: true, onUpdateValue: this.handleRangeUpdateValue, theme: this.mergedTheme.peers.Input, themeOverrides: this.mergedTheme.peerOverrides.Input, internalForceFocus: this.mergedShow, internalDeactivateOnEnter: true }, commonInputProps), {
            separator: () => this.separator === void 0 ? resolveSlot($slots.separator, () => [
              h$1(NBaseIcon, { clsPrefix: mergedClsPrefix, class: `${mergedClsPrefix}-date-picker-icon` }, {
                default: () => h$1(ToIcon, null)
              })
            ]) : this.separator,
            [clearable ? "clear-icon-placeholder" : "suffix"]: () => resolveSlot($slots["date-icon"], () => [
              h$1(NBaseIcon, { clsPrefix: mergedClsPrefix, class: `${mergedClsPrefix}-date-picker-icon` }, {
                default: () => h$1(DateIcon, null)
              })
            ])
          }) : h$1(NInput, Object.assign({ ref: "inputInstRef", status: this.mergedStatus, value: this.displayTime, placeholder: this.localizedPlacehoder, textDecoration: this.isValueInvalid && !this.isRange ? "line-through" : "", onUpdateValue: this.handleSingleUpdateValue, theme: this.mergedTheme.peers.Input, themeOverrides: this.mergedTheme.peerOverrides.Input, internalForceFocus: this.mergedShow, internalDeactivateOnEnter: true }, commonInputProps), {
            [clearable ? "clear-icon-placeholder" : "suffix"]: () => h$1(NBaseIcon, { clsPrefix: mergedClsPrefix, class: `${mergedClsPrefix}-date-picker-icon` }, {
              default: () => resolveSlot($slots["date-icon"], () => [
                h$1(DateIcon, null)
              ])
            })
          })
        }),
        h$1(VFollower, { show: this.mergedShow, containerClass: this.namespace, to: this.adjustedTo, teleportDisabled: this.adjustedTo === useAdjustedTo.tdkey, placement: this.placement }, {
          default: () => h$1(Transition, { name: "fade-in-scale-up-transition", appear: this.isMounted }, {
            default: () => {
              if (!this.mergedShow)
                return null;
              return withDirectives(renderPanel(), [
                [
                  clickoutside$1,
                  this.handleClickOutside,
                  void 0,
                  { capture: true }
                ]
              ]);
            }
          })
        })
      ]
    }));
  }
});
var commonVars$3 = {
  titleFontSize: "18px",
  padding: "16px 28px 20px 28px",
  iconSize: "28px",
  actionSpace: "12px",
  contentMargin: "8px 0 16px 0",
  iconMargin: "0 4px 0 0",
  iconMarginIconTop: "4px 0 8px 0",
  closeSize: "22px",
  closeIconSize: "18px",
  closeMargin: "20px 26px 0 0",
  closeMarginIconTop: "10px 16px 0 0"
};
const self$i = (vars) => {
  const { textColor1, textColor2, modalColor, closeIconColor, closeIconColorHover, closeIconColorPressed, closeColorHover, closeColorPressed, infoColor, successColor, warningColor, errorColor, primaryColor, dividerColor, borderRadius, fontWeightStrong, lineHeight: lineHeight2, fontSize: fontSize2 } = vars;
  return Object.assign(Object.assign({}, commonVars$3), {
    fontSize: fontSize2,
    lineHeight: lineHeight2,
    border: `1px solid ${dividerColor}`,
    titleTextColor: textColor1,
    textColor: textColor2,
    color: modalColor,
    closeColorHover,
    closeColorPressed,
    closeIconColor,
    closeIconColorHover,
    closeIconColorPressed,
    closeBorderRadius: borderRadius,
    iconColor: primaryColor,
    iconColorInfo: infoColor,
    iconColorSuccess: successColor,
    iconColorWarning: warningColor,
    iconColorError: errorColor,
    borderRadius,
    titleFontWeight: fontWeightStrong
  });
};
const dialogLight = createTheme({
  name: "Dialog",
  common: commonLight,
  peers: {
    Button: buttonLight$1
  },
  self: self$i
});
var dialogLight$1 = dialogLight;
const dialogProps = {
  icon: Function,
  type: {
    type: String,
    default: "default"
  },
  title: [String, Function],
  closable: {
    type: Boolean,
    default: true
  },
  negativeText: String,
  positiveText: String,
  positiveButtonProps: Object,
  negativeButtonProps: Object,
  content: [String, Function],
  action: Function,
  showIcon: {
    type: Boolean,
    default: true
  },
  loading: Boolean,
  bordered: Boolean,
  iconPlacement: String,
  onPositiveClick: Function,
  onNegativeClick: Function,
  onClose: Function
};
const dialogPropKeys = keysOf(dialogProps);
var style$i = c$2([cB$1("dialog", `
 word-break: break-word;
 line-height: var(--n-line-height);
 position: relative;
 background: var(--n-color);
 color: var(--n-text-color);
 box-sizing: border-box;
 margin: auto;
 border-radius: var(--n-border-radius);
 padding: var(--n-padding);
 transition: 
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `, [cE$1("icon", {
  color: "var(--n-icon-color)"
}), cM("bordered", {
  border: "var(--n-border)"
}), cM("icon-top", [cE$1("close", {
  margin: "var(--n-close-margin)"
}), cE$1("icon", {
  margin: "var(--n-icon-margin)"
}), cE$1("content", {
  textAlign: "center"
}), cE$1("title", {
  justifyContent: "center"
}), cE$1("action", {
  justifyContent: "center"
})]), cM("icon-left", [cE$1("icon", {
  margin: "var(--n-icon-margin)"
}), cM("closable", [cE$1("title", `
 padding-right: calc(var(--n-close-size) + 6px);
 `)])]), cE$1("close", `
 position: absolute;
 right: 0;
 top: 0;
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 z-index: 1;
 `), cE$1("content", `
 font-size: var(--n-font-size);
 margin: var(--n-content-margin);
 position: relative;
 word-break: break-word;
 `, [cM("last", "margin-bottom: 0;")]), cE$1("action", `
 display: flex;
 justify-content: flex-end;
 `, [c$2("> *:not(:last-child)", {
  marginRight: "var(--n-action-space)"
})]), cE$1("icon", {
  fontSize: "var(--n-icon-size)",
  transition: "color .3s var(--n-bezier)"
}), cE$1("title", `
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 font-size: var(--n-title-font-size);
 font-weight: var(--n-title-font-weight);
 color: var(--n-title-text-color);
 `), cB$1("dialog-icon-container", {
  display: "flex",
  justifyContent: "center"
})]), insideModal(cB$1("dialog", `
 width: 446px;
 max-width: calc(100vw - 32px);
 `)), cB$1("dialog", [asModal(`
 width: 446px;
 max-width: calc(100vw - 32px);
 `)])]);
const iconRenderMap$1 = {
  default: () => h$1(InfoIcon, null),
  info: () => h$1(InfoIcon, null),
  success: () => h$1(SuccessIcon, null),
  warning: () => h$1(WarningIcon, null),
  error: () => h$1(ErrorIcon, null)
};
const NDialog = defineComponent({
  name: "Dialog",
  alias: [
    "NimbusConfirmCard",
    "Confirm"
  ],
  props: Object.assign(Object.assign({}, useTheme.props), dialogProps),
  setup(props) {
    const { mergedComponentPropsRef, mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const mergedIconPlacementRef = computed(() => {
      var _a2, _b2;
      const { iconPlacement } = props;
      return iconPlacement || ((_b2 = (_a2 = mergedComponentPropsRef === null || mergedComponentPropsRef === void 0 ? void 0 : mergedComponentPropsRef.value) === null || _a2 === void 0 ? void 0 : _a2.Dialog) === null || _b2 === void 0 ? void 0 : _b2.iconPlacement) || "left";
    });
    function handlePositiveClick(e25) {
      const { onPositiveClick } = props;
      if (onPositiveClick)
        onPositiveClick(e25);
    }
    function handleNegativeClick(e25) {
      const { onNegativeClick } = props;
      if (onNegativeClick)
        onNegativeClick(e25);
    }
    function handleCloseClick() {
      const { onClose } = props;
      if (onClose)
        onClose();
    }
    const themeRef = useTheme("Dialog", "-dialog", style$i, dialogLight$1, props, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { type: type4 } = props;
      const iconPlacement = mergedIconPlacementRef.value;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { fontSize: fontSize2, lineHeight: lineHeight2, border, titleTextColor, textColor, color, closeBorderRadius, closeColorHover, closeColorPressed, closeIconColor, closeIconColorHover, closeIconColorPressed, closeIconSize, borderRadius, titleFontWeight, titleFontSize, padding, iconSize, actionSpace, contentMargin, closeSize, [iconPlacement === "top" ? "iconMarginIconTop" : "iconMargin"]: iconMargin, [iconPlacement === "top" ? "closeMarginIconTop" : "closeMargin"]: closeMargin, [createKey("iconColor", type4)]: iconColor } } = themeRef.value;
      return {
        "--n-font-size": fontSize2,
        "--n-icon-color": iconColor,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-close-margin": closeMargin,
        "--n-icon-margin": iconMargin,
        "--n-icon-size": iconSize,
        "--n-close-size": closeSize,
        "--n-close-icon-size": closeIconSize,
        "--n-close-border-radius": closeBorderRadius,
        "--n-close-color-hover": closeColorHover,
        "--n-close-color-pressed": closeColorPressed,
        "--n-close-icon-color": closeIconColor,
        "--n-close-icon-color-hover": closeIconColorHover,
        "--n-close-icon-color-pressed": closeIconColorPressed,
        "--n-color": color,
        "--n-text-color": textColor,
        "--n-border-radius": borderRadius,
        "--n-padding": padding,
        "--n-line-height": lineHeight2,
        "--n-border": border,
        "--n-content-margin": contentMargin,
        "--n-title-font-size": titleFontSize,
        "--n-title-font-weight": titleFontWeight,
        "--n-title-text-color": titleTextColor,
        "--n-action-space": actionSpace
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("dialog", computed(() => `${props.type[0]}${mergedIconPlacementRef.value[0]}`), cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      mergedIconPlacement: mergedIconPlacementRef,
      mergedTheme: themeRef,
      handlePositiveClick,
      handleNegativeClick,
      handleCloseClick,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    var _a2;
    const { bordered, mergedIconPlacement, cssVars, closable, showIcon, title, content: content2, action, negativeText, positiveText, positiveButtonProps, negativeButtonProps, handlePositiveClick, handleNegativeClick, mergedTheme, loading, type: type4, mergedClsPrefix } = this;
    (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
    const icon = showIcon ? h$1(NBaseIcon, { clsPrefix: mergedClsPrefix, class: `${mergedClsPrefix}-dialog__icon` }, {
      default: () => resolveWrappedSlot(this.$slots.icon, (children) => children || (this.icon ? render$3U(this.icon) : iconRenderMap$1[this.type]()))
    }) : null;
    const actionNode = resolveWrappedSlot(this.$slots.action, (children) => children || positiveText || negativeText || action ? h$1("div", { class: `${mergedClsPrefix}-dialog__action` }, children || (action ? [render$3U(action)] : [
      this.negativeText && h$1(NButton, Object.assign({ theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, ghost: true, size: "small", onClick: handleNegativeClick }, negativeButtonProps), {
        default: () => render$3U(this.negativeText)
      }),
      this.positiveText && h$1(NButton, Object.assign({ theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, size: "small", type: type4 === "default" ? "primary" : type4, disabled: loading, loading, onClick: handlePositiveClick }, positiveButtonProps), {
        default: () => render$3U(this.positiveText)
      })
    ])) : null);
    return h$1("div", { class: [
      `${mergedClsPrefix}-dialog`,
      this.themeClass,
      this.closable && `${mergedClsPrefix}-dialog--closable`,
      `${mergedClsPrefix}-dialog--icon-${mergedIconPlacement}`,
      bordered && `${mergedClsPrefix}-dialog--bordered`
    ], style: cssVars, role: "dialog" }, closable ? h$1(NBaseClose, { clsPrefix: mergedClsPrefix, class: `${mergedClsPrefix}-dialog__close`, onClick: this.handleCloseClick }) : null, showIcon && mergedIconPlacement === "top" ? h$1("div", { class: `${mergedClsPrefix}-dialog-icon-container` }, icon) : null, h$1("div", { class: `${mergedClsPrefix}-dialog__title` }, showIcon && mergedIconPlacement === "left" ? icon : null, resolveSlot(this.$slots.header, () => [render$3U(title)])), h$1("div", { class: [
      `${mergedClsPrefix}-dialog__content`,
      actionNode ? "" : `${mergedClsPrefix}-dialog__content--last`
    ] }, resolveSlot(this.$slots.default, () => [render$3U(content2)])), actionNode);
  }
});
const dialogProviderInjectionKey = createInjectionKey("n-dialog-provider");
const self$h = (vars) => {
  const { modalColor, textColor2, boxShadow3 } = vars;
  return {
    color: modalColor,
    textColor: textColor2,
    boxShadow: boxShadow3
  };
};
const modalLight = createTheme({
  name: "Modal",
  common: commonLight,
  peers: {
    Scrollbar: scrollbarLight$1,
    Dialog: dialogLight$1,
    Card: cardLight$1
  },
  self: self$h
});
var modalLight$1 = modalLight;
const presetProps = Object.assign(Object.assign({}, cardBaseProps), dialogProps);
const presetPropsKeys = keysOf(presetProps);
var NModalBodyWrapper = defineComponent({
  name: "ModalBody",
  inheritAttrs: false,
  props: Object.assign(Object.assign({ show: {
    type: Boolean,
    required: true
  }, preset: String, displayDirective: {
    type: String,
    required: true
  }, trapFocus: {
    type: Boolean,
    default: true
  }, autoFocus: {
    type: Boolean,
    default: true
  }, blockScroll: Boolean }, presetProps), {
    renderMask: Function,
    onClickoutside: Function,
    onBeforeLeave: {
      type: Function,
      required: true
    },
    onAfterLeave: {
      type: Function,
      required: true
    },
    onPositiveClick: {
      type: Function,
      required: true
    },
    onNegativeClick: {
      type: Function,
      required: true
    },
    onClose: {
      type: Function,
      required: true
    },
    onAfterEnter: Function,
    onEsc: Function
  }),
  setup(props) {
    const bodyRef = ref(null);
    const scrollbarRef = ref(null);
    const displayedRef = ref(props.show);
    const transformOriginXRef = ref(null);
    const transformOriginYRef = ref(null);
    watch(toRef(props, "show"), (value2) => {
      if (value2)
        displayedRef.value = true;
    });
    useLockHtmlScroll(computed(() => props.blockScroll && displayedRef.value));
    const NModal2 = inject(modalInjectionKey);
    function styleTransformOrigin() {
      if (NModal2.transformOriginRef.value === "center") {
        return "";
      }
      const { value: transformOriginX } = transformOriginXRef;
      const { value: transformOriginY } = transformOriginYRef;
      if (transformOriginX === null || transformOriginY === null) {
        return "";
      } else if (scrollbarRef.value) {
        const scrollTop = scrollbarRef.value.containerScrollTop;
        return `${transformOriginX}px ${transformOriginY + scrollTop}px`;
      }
      return "";
    }
    function syncTransformOrigin(el2) {
      if (NModal2.transformOriginRef.value === "center") {
        return;
      }
      const mousePosition = NModal2.getMousePosition();
      if (!mousePosition) {
        return;
      }
      if (!scrollbarRef.value)
        return;
      const scrollTop = scrollbarRef.value.containerScrollTop;
      const { offsetLeft, offsetTop } = el2;
      if (mousePosition) {
        const top2 = mousePosition.y;
        const left = mousePosition.x;
        transformOriginXRef.value = -(offsetLeft - left);
        transformOriginYRef.value = -(offsetTop - top2 - scrollTop);
      }
      el2.style.transformOrigin = styleTransformOrigin();
    }
    function handleEnter(el2) {
      void nextTick(() => {
        syncTransformOrigin(el2);
      });
    }
    function handleBeforeLeave(el2) {
      el2.style.transformOrigin = styleTransformOrigin();
      props.onBeforeLeave();
    }
    function handleAfterLeave() {
      displayedRef.value = false;
      transformOriginXRef.value = null;
      transformOriginYRef.value = null;
      props.onAfterLeave();
    }
    function handleCloseClick() {
      const { onClose } = props;
      if (onClose) {
        onClose();
      }
    }
    function handleNegativeClick() {
      props.onNegativeClick();
    }
    function handlePositiveClick() {
      props.onPositiveClick();
    }
    const childNodeRef = ref(null);
    watch(childNodeRef, (node2) => {
      if (node2) {
        void nextTick(() => {
          const el2 = node2.el;
          if (el2 && bodyRef.value !== el2) {
            bodyRef.value = el2;
          }
        });
      }
    });
    provide(modalBodyInjectionKey, bodyRef);
    provide(drawerBodyInjectionKey, null);
    provide(popoverBodyInjectionKey, null);
    return {
      mergedTheme: NModal2.mergedThemeRef,
      appear: NModal2.appearRef,
      isMounted: NModal2.isMountedRef,
      mergedClsPrefix: NModal2.mergedClsPrefixRef,
      bodyRef,
      scrollbarRef,
      displayed: displayedRef,
      childNodeRef,
      handlePositiveClick,
      handleNegativeClick,
      handleCloseClick,
      handleAfterLeave,
      handleBeforeLeave,
      handleEnter
    };
  },
  render() {
    const { $slots, $attrs, handleEnter, handleAfterLeave, handleBeforeLeave, preset, mergedClsPrefix } = this;
    let childNode = null;
    if (!preset) {
      childNode = getFirstSlotVNode($slots);
      if (!childNode) {
        warn$2("modal", "default slot is empty");
        return;
      }
      childNode = cloneVNode(childNode);
      childNode.props = mergeProps({
        class: `${mergedClsPrefix}-modal`
      }, $attrs, childNode.props || {});
    }
    return this.displayDirective === "show" || this.displayed || this.show ? withDirectives(h$1("div", { role: "none", class: `${mergedClsPrefix}-modal-body-wrapper` }, h$1(NScrollbar, { ref: "scrollbarRef", theme: this.mergedTheme.peers.Scrollbar, themeOverrides: this.mergedTheme.peerOverrides.Scrollbar, contentClass: `${mergedClsPrefix}-modal-scroll-content` }, {
      default: () => {
        var _a2;
        return [
          (_a2 = this.renderMask) === null || _a2 === void 0 ? void 0 : _a2.call(this),
          h$1(FocusTrap, { disabled: !this.trapFocus, active: this.show, onEsc: this.onEsc, autoFocus: this.autoFocus }, {
            default: () => {
              var _a3;
              return h$1(Transition, { name: "fade-in-scale-up-transition", appear: (_a3 = this.appear) !== null && _a3 !== void 0 ? _a3 : this.isMounted, onEnter: handleEnter, onAfterEnter: this.onAfterEnter, onAfterLeave: handleAfterLeave, onBeforeLeave: handleBeforeLeave }, {
                default: () => {
                  const dirs = [
                    [vShow, this.show]
                  ];
                  const { onClickoutside } = this;
                  if (onClickoutside) {
                    dirs.push([
                      clickoutside$1,
                      this.onClickoutside,
                      void 0,
                      { capture: true }
                    ]);
                  }
                  return withDirectives(this.preset === "confirm" || this.preset === "dialog" ? h$1(NDialog, Object.assign({}, this.$attrs, { class: [
                    `${mergedClsPrefix}-modal`,
                    this.$attrs.class
                  ], ref: "bodyRef", theme: this.mergedTheme.peers.Dialog, themeOverrides: this.mergedTheme.peerOverrides.Dialog }, keep(this.$props, dialogPropKeys), { "aria-modal": "true" }), $slots) : this.preset === "card" ? h$1(NCard, Object.assign({}, this.$attrs, { ref: "bodyRef", class: [
                    `${mergedClsPrefix}-modal`,
                    this.$attrs.class
                  ], theme: this.mergedTheme.peers.Card, themeOverrides: this.mergedTheme.peerOverrides.Card }, keep(this.$props, cardBasePropKeys), { "aria-modal": "true", role: "dialog" }), $slots) : this.childNodeRef = childNode, dirs);
                }
              });
            }
          })
        ];
      }
    })), [
      [
        vShow,
        this.displayDirective === "if" || this.displayed || this.show
      ]
    ]) : null;
  }
});
var style$h = c$2([cB$1("modal-container", `
 position: fixed;
 left: 0;
 top: 0;
 height: 0;
 width: 0;
 display: flex;
 `), cB$1("modal-mask", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 background-color: rgba(0, 0, 0, .4);
 `, [fadeInTransition({
  enterDuration: ".25s",
  leaveDuration: ".25s",
  enterCubicBezier: "var(--n-bezier-ease-out)",
  leaveCubicBezier: "var(--n-bezier-ease-out)"
})]), cB$1("modal-body-wrapper", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 overflow: visible;
 `, [cB$1("modal-scroll-content", `
 min-height: 100%;
 display: flex;
 position: relative;
 `)]), cB$1("modal", `
 position: relative;
 align-self: center;
 color: var(--n-text-color);
 margin: auto;
 box-shadow: var(--n-box-shadow);
 `, [fadeInScaleUpTransition({
  duration: ".25s",
  enterScale: ".5"
})])]);
const modalProps = Object.assign(Object.assign(Object.assign(Object.assign({}, useTheme.props), { show: Boolean, unstableShowMask: {
  type: Boolean,
  default: true
}, maskClosable: {
  type: Boolean,
  default: true
}, preset: String, to: [String, Object], displayDirective: {
  type: String,
  default: "if"
}, transformOrigin: {
  type: String,
  default: "mouse"
}, zIndex: Number, autoFocus: {
  type: Boolean,
  default: true
}, trapFocus: {
  type: Boolean,
  default: true
}, closeOnEsc: {
  type: Boolean,
  default: true
}, blockScroll: { type: Boolean, default: true } }), presetProps), {
  onEsc: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onAfterEnter: Function,
  onBeforeLeave: Function,
  onAfterLeave: Function,
  onClose: Function,
  onPositiveClick: Function,
  onNegativeClick: Function,
  onMaskClick: Function,
  internalDialog: Boolean,
  internalAppear: {
    type: Boolean,
    default: void 0
  },
  overlayStyle: [String, Object],
  onBeforeHide: Function,
  onAfterHide: Function,
  onHide: Function
});
var NModal = defineComponent({
  name: "Modal",
  inheritAttrs: false,
  props: modalProps,
  setup(props) {
    const containerRef = ref(null);
    const { mergedClsPrefixRef, namespaceRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Modal", "-modal", style$h, modalLight$1, props, mergedClsPrefixRef);
    const clickedRef = useClicked(64);
    const clickedPositionRef = useClickPosition();
    const isMountedRef = isMounted();
    const NDialogProvider = props.internalDialog ? inject(dialogProviderInjectionKey, null) : null;
    const isComposingRef2 = useIsComposing();
    function doUpdateShow(show) {
      const { onUpdateShow, "onUpdate:show": _onUpdateShow, onHide } = props;
      if (onUpdateShow)
        call(onUpdateShow, show);
      if (_onUpdateShow)
        call(_onUpdateShow, show);
      if (onHide && !show)
        onHide(show);
    }
    function handleCloseClick() {
      const { onClose } = props;
      if (onClose) {
        void Promise.resolve(onClose()).then((value2) => {
          if (value2 === false)
            return;
          doUpdateShow(false);
        });
      } else {
        doUpdateShow(false);
      }
    }
    function handlePositiveClick() {
      const { onPositiveClick } = props;
      if (onPositiveClick) {
        void Promise.resolve(onPositiveClick()).then((value2) => {
          if (value2 === false)
            return;
          doUpdateShow(false);
        });
      } else {
        doUpdateShow(false);
      }
    }
    function handleNegativeClick() {
      const { onNegativeClick } = props;
      if (onNegativeClick) {
        void Promise.resolve(onNegativeClick()).then((value2) => {
          if (value2 === false)
            return;
          doUpdateShow(false);
        });
      } else {
        doUpdateShow(false);
      }
    }
    function handleBeforeLeave() {
      const { onBeforeLeave, onBeforeHide } = props;
      if (onBeforeLeave)
        call(onBeforeLeave);
      if (onBeforeHide)
        onBeforeHide();
    }
    function handleAfterLeave() {
      const { onAfterLeave, onAfterHide } = props;
      if (onAfterLeave)
        call(onAfterLeave);
      if (onAfterHide)
        onAfterHide();
    }
    function handleClickoutside(e25) {
      var _a2;
      const { onMaskClick } = props;
      if (onMaskClick) {
        onMaskClick(e25);
      }
      if (props.maskClosable) {
        if ((_a2 = containerRef.value) === null || _a2 === void 0 ? void 0 : _a2.contains(getPreciseEventTarget(e25))) {
          doUpdateShow(false);
        }
      }
    }
    function handleEsc(e25) {
      var _a2;
      (_a2 = props.onEsc) === null || _a2 === void 0 ? void 0 : _a2.call(props);
      if (props.show && props.closeOnEsc && eventEffectNotPerformed(e25)) {
        !isComposingRef2.value && doUpdateShow(false);
      }
    }
    provide(modalInjectionKey, {
      getMousePosition: () => {
        if (NDialogProvider) {
          const { clickedRef: clickedRef2, clickPositionRef } = NDialogProvider;
          if (clickedRef2.value && clickPositionRef.value) {
            return clickPositionRef.value;
          }
        }
        if (clickedRef.value) {
          return clickedPositionRef.value;
        }
        return null;
      },
      mergedClsPrefixRef,
      mergedThemeRef: themeRef,
      isMountedRef,
      appearRef: toRef(props, "internalAppear"),
      transformOriginRef: toRef(props, "transformOrigin")
    });
    const cssVarsRef = computed(() => {
      const { common: { cubicBezierEaseOut: cubicBezierEaseOut2 }, self: { boxShadow, color, textColor } } = themeRef.value;
      return {
        "--n-bezier-ease-out": cubicBezierEaseOut2,
        "--n-box-shadow": boxShadow,
        "--n-color": color,
        "--n-text-color": textColor
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("theme-class", void 0, cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      namespace: namespaceRef,
      isMounted: isMountedRef,
      containerRef,
      presetProps: computed(() => {
        const pickedProps = keep(props, presetPropsKeys);
        return pickedProps;
      }),
      handleEsc,
      handleAfterLeave,
      handleClickoutside,
      handleBeforeLeave,
      doUpdateShow,
      handleNegativeClick,
      handlePositiveClick,
      handleCloseClick,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const { mergedClsPrefix } = this;
    return h$1(LazyTeleport, { to: this.to, show: this.show }, {
      default: () => {
        var _a2;
        (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
        const { unstableShowMask } = this;
        return withDirectives(h$1("div", { role: "none", ref: "containerRef", class: [
          `${mergedClsPrefix}-modal-container`,
          this.themeClass,
          this.namespace
        ], style: this.cssVars }, h$1(NModalBodyWrapper, Object.assign({ style: this.overlayStyle }, this.$attrs, { ref: "bodyWrapper", displayDirective: this.displayDirective, show: this.show, preset: this.preset, autoFocus: this.autoFocus, trapFocus: this.trapFocus, blockScroll: this.blockScroll }, this.presetProps, { onEsc: this.handleEsc, onClose: this.handleCloseClick, onNegativeClick: this.handleNegativeClick, onPositiveClick: this.handlePositiveClick, onBeforeLeave: this.handleBeforeLeave, onAfterEnter: this.onAfterEnter, onAfterLeave: this.handleAfterLeave, onClickoutside: unstableShowMask ? void 0 : this.handleClickoutside, renderMask: unstableShowMask ? () => {
          var _a3;
          return h$1(Transition, { name: "fade-in-transition", key: "mask", appear: (_a3 = this.internalAppear) !== null && _a3 !== void 0 ? _a3 : this.isMounted }, {
            default: () => {
              return this.show ? h$1("div", { "aria-hidden": true, ref: "containerRef", class: `${mergedClsPrefix}-modal-mask`, onClick: this.handleClickoutside }) : null;
            }
          });
        } : void 0 }), this.$slots)), [
          [
            zindexable$1,
            {
              zIndex: this.zIndex,
              enabled: this.show
            }
          ]
        ]);
      }
    });
  }
});
const self$g = (vars) => {
  const { textColor1, dividerColor, fontWeightStrong } = vars;
  return {
    textColor: textColor1,
    color: dividerColor,
    fontWeight: fontWeightStrong
  };
};
const dividerLight = {
  name: "Divider",
  common: commonLight,
  self: self$g
};
var dividerLight$1 = dividerLight;
var style$g = cB$1("divider", `
 position: relative;
 display: flex;
 width: 100%;
 box-sizing: border-box;
 font-size: 16px;
 color: var(--n-text-color);
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
`, [cNotM("vertical", `
 margin-top: 24px;
 margin-bottom: 24px;
 `, [cNotM("no-title", `
 display: flex;
 align-items: center;
 `)]), cE$1("title", `
 display: flex;
 align-items: center;
 margin-left: 12px;
 margin-right: 12px;
 white-space: nowrap;
 font-weight: var(--n-font-weight);
 `), cM("title-position-left", [cE$1("line", [cM("left", {
  width: "28px"
})])]), cM("title-position-right", [cE$1("line", [cM("right", {
  width: "28px"
})])]), cM("dashed", [cE$1("line", `
 background-color: #0000;
 height: 0px;
 width: 100%;
 border-style: dashed;
 border-width: 1px 0 0;
 `)]), cM("vertical", `
 display: inline-block;
 height: 1em;
 margin: 0 8px;
 vertical-align: middle;
 width: 1px;
 `), cE$1("line", `
 border: none;
 transition: background-color .3s var(--n-bezier), border-color .3s var(--n-bezier);
 height: 1px;
 width: 100%;
 margin: 0;
 `), cNotM("dashed", [cE$1("line", {
  backgroundColor: "var(--n-color)"
})]), cM("dashed", [cE$1("line", {
  borderColor: "var(--n-color)"
})]), cM("vertical", {
  backgroundColor: "var(--n-color)"
})]);
const dividerProps = Object.assign(Object.assign({}, useTheme.props), { titlePlacement: {
  type: String,
  default: "center"
}, dashed: Boolean, vertical: Boolean });
var NDivider = defineComponent({
  name: "Divider",
  props: dividerProps,
  setup(props) {
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Divider", "-divider", style$g, dividerLight$1, props, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { color, textColor, fontWeight } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-color": color,
        "--n-text-color": textColor,
        "--n-font-weight": fontWeight
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("divider", void 0, cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    var _a2;
    const { $slots, titlePlacement, vertical, dashed, cssVars, mergedClsPrefix } = this;
    (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
    return h$1("div", { role: "separator", class: [
      `${mergedClsPrefix}-divider`,
      this.themeClass,
      {
        [`${mergedClsPrefix}-divider--vertical`]: vertical,
        [`${mergedClsPrefix}-divider--no-title`]: !$slots.default,
        [`${mergedClsPrefix}-divider--dashed`]: dashed,
        [`${mergedClsPrefix}-divider--title-position-${titlePlacement}`]: $slots.default && titlePlacement
      }
    ], style: cssVars }, !vertical ? h$1("div", { class: `${mergedClsPrefix}-divider__line ${mergedClsPrefix}-divider__line--left` }) : null, !vertical && $slots.default ? h$1(Fragment, null, h$1("div", { class: `${mergedClsPrefix}-divider__title` }, this.$slots), h$1("div", { class: `${mergedClsPrefix}-divider__line ${mergedClsPrefix}-divider__line--right` })) : null);
  }
});
const self$f = (vars) => {
  const { modalColor, textColor1, textColor2, boxShadow3, lineHeight: lineHeight2, fontWeightStrong, dividerColor, closeColorHover, closeColorPressed, closeIconColor, closeIconColorHover, closeIconColorPressed, borderRadius, primaryColorHover } = vars;
  return {
    bodyPadding: "16px 24px",
    headerPadding: "16px 24px",
    footerPadding: "16px 24px",
    color: modalColor,
    textColor: textColor2,
    titleTextColor: textColor1,
    titleFontSize: "18px",
    titleFontWeight: fontWeightStrong,
    boxShadow: boxShadow3,
    lineHeight: lineHeight2,
    headerBorderBottom: `1px solid ${dividerColor}`,
    footerBorderTop: `1px solid ${dividerColor}`,
    closeIconColor,
    closeIconColorHover,
    closeIconColorPressed,
    closeSize: "22px",
    closeIconSize: "18px",
    closeColorHover,
    closeColorPressed,
    closeBorderRadius: borderRadius,
    resizableTriggerColorHover: primaryColorHover
  };
};
const drawerLight = createTheme({
  name: "Drawer",
  common: commonLight,
  peers: {
    Scrollbar: scrollbarLight$1
  },
  self: self$f
});
var drawerLight$1 = drawerLight;
var NDrawerBodyWrapper = defineComponent({
  name: "NDrawerContent",
  inheritAttrs: false,
  props: {
    blockScroll: Boolean,
    show: {
      type: Boolean,
      default: void 0
    },
    displayDirective: {
      type: String,
      required: true
    },
    placement: {
      type: String,
      required: true
    },
    contentStyle: [Object, String],
    nativeScrollbar: {
      type: Boolean,
      required: true
    },
    scrollbarProps: Object,
    trapFocus: {
      type: Boolean,
      default: true
    },
    autoFocus: {
      type: Boolean,
      default: true
    },
    showMask: {
      type: [Boolean, String],
      required: true
    },
    resizable: Boolean,
    onClickoutside: Function,
    onAfterLeave: Function,
    onAfterEnter: Function,
    onEsc: Function
  },
  setup(props) {
    const displayedRef = ref(!!props.show);
    const bodyRef = ref(null);
    const NDrawer2 = inject(drawerInjectionKey);
    let startPosition = 0;
    let memoizedBodyStyleCursor = "";
    let hoverTimerId = null;
    const isHoverOnResizeTriggerRef = ref(false);
    const isDraggingRef = ref(false);
    const isVertical = computed(() => {
      return props.placement === "top" || props.placement === "bottom";
    });
    const { mergedClsPrefixRef, mergedRtlRef } = useConfig(props);
    const rtlEnabledRef = useRtl("Drawer", mergedRtlRef, mergedClsPrefixRef);
    const handleMousedownResizeTrigger = (e25) => {
      isDraggingRef.value = true;
      startPosition = isVertical.value ? e25.clientY : e25.clientX;
      memoizedBodyStyleCursor = document.body.style.cursor;
      document.body.style.cursor = isVertical.value ? "ns-resize" : "ew-resize";
      document.body.addEventListener("mousemove", handleBodyMousemove);
      document.body.addEventListener("mouseleave", handleBodyMouseleave);
      document.body.addEventListener("mouseup", handleBodyMouseup);
    };
    const handleMouseenterResizeTrigger = () => {
      if (hoverTimerId !== null) {
        window.clearTimeout(hoverTimerId);
        hoverTimerId = null;
      }
      if (isDraggingRef.value) {
        isHoverOnResizeTriggerRef.value = true;
      } else {
        hoverTimerId = window.setTimeout(() => {
          isHoverOnResizeTriggerRef.value = true;
        }, 300);
      }
    };
    const handleMouseleaveResizeTrigger = () => {
      if (hoverTimerId !== null) {
        window.clearTimeout(hoverTimerId);
        hoverTimerId = null;
      }
      isHoverOnResizeTriggerRef.value = false;
    };
    const { doUpdateHeight, doUpdateWidth } = NDrawer2;
    const handleBodyMousemove = (e25) => {
      var _a2, _b2;
      if (isDraggingRef.value) {
        if (isVertical.value) {
          let height = ((_a2 = bodyRef.value) === null || _a2 === void 0 ? void 0 : _a2.offsetHeight) || 0;
          const increment = startPosition - e25.clientY;
          height += props.placement === "bottom" ? increment : -increment;
          doUpdateHeight(height);
          startPosition = e25.clientY;
        } else {
          let width = ((_b2 = bodyRef.value) === null || _b2 === void 0 ? void 0 : _b2.offsetWidth) || 0;
          const increment = startPosition - e25.clientX;
          width += props.placement === "right" ? increment : -increment;
          doUpdateWidth(width);
          startPosition = e25.clientX;
        }
      }
    };
    const handleBodyMouseup = () => {
      if (isDraggingRef.value) {
        startPosition = 0;
        isDraggingRef.value = false;
        document.body.style.cursor = memoizedBodyStyleCursor;
        document.body.removeEventListener("mousemove", handleBodyMousemove);
        document.body.removeEventListener("mouseup", handleBodyMouseup);
        document.body.removeEventListener("mouseleave", handleBodyMouseleave);
      }
    };
    const handleBodyMouseleave = handleBodyMouseup;
    watchEffect(() => {
      if (props.show)
        displayedRef.value = true;
    });
    watch(() => props.show, (value2) => {
      if (!value2) {
        handleBodyMouseup();
      }
    });
    onBeforeUnmount(() => {
      handleBodyMouseup();
    });
    const bodyDirectivesRef = computed(() => {
      const { show } = props;
      const directives = [[vShow, show]];
      if (!props.showMask) {
        directives.push([
          clickoutside$1,
          props.onClickoutside,
          void 0,
          { capture: true }
        ]);
      }
      return directives;
    });
    function handleAfterLeave() {
      var _a2;
      displayedRef.value = false;
      (_a2 = props.onAfterLeave) === null || _a2 === void 0 ? void 0 : _a2.call(props);
    }
    useLockHtmlScroll(computed(() => props.blockScroll && displayedRef.value));
    provide(drawerBodyInjectionKey, bodyRef);
    provide(popoverBodyInjectionKey, null);
    provide(modalBodyInjectionKey, null);
    return {
      bodyRef,
      rtlEnabled: rtlEnabledRef,
      mergedClsPrefix: NDrawer2.mergedClsPrefixRef,
      isMounted: NDrawer2.isMountedRef,
      mergedTheme: NDrawer2.mergedThemeRef,
      displayed: displayedRef,
      transitionName: computed(() => {
        return {
          right: "slide-in-from-right-transition",
          left: "slide-in-from-left-transition",
          top: "slide-in-from-top-transition",
          bottom: "slide-in-from-bottom-transition"
        }[props.placement];
      }),
      handleAfterLeave,
      bodyDirectives: bodyDirectivesRef,
      handleMousedownResizeTrigger,
      handleMouseenterResizeTrigger,
      handleMouseleaveResizeTrigger,
      isDragging: isDraggingRef,
      isHoverOnResizeTrigger: isHoverOnResizeTriggerRef
    };
  },
  render() {
    const { $slots, mergedClsPrefix } = this;
    return this.displayDirective === "show" || this.displayed || this.show ? withDirectives(h$1("div", { role: "none" }, h$1(FocusTrap, { disabled: !this.showMask || !this.trapFocus, active: this.show, autoFocus: this.autoFocus, onEsc: this.onEsc }, {
      default: () => h$1(Transition, { name: this.transitionName, appear: this.isMounted, onAfterEnter: this.onAfterEnter, onAfterLeave: this.handleAfterLeave }, {
        default: () => withDirectives(h$1("div", mergeProps(this.$attrs, {
          role: "dialog",
          ref: "bodyRef",
          "aria-modal": "true",
          class: [
            `${mergedClsPrefix}-drawer`,
            this.rtlEnabled && `${mergedClsPrefix}-drawer--rtl`,
            `${mergedClsPrefix}-drawer--${this.placement}-placement`,
            this.isDragging && `${mergedClsPrefix}-drawer--unselectable`,
            this.nativeScrollbar && `${mergedClsPrefix}-drawer--native-scrollbar`
          ]
        }), [
          this.resizable ? h$1("div", { class: [
            `${mergedClsPrefix}-drawer__resize-trigger`,
            (this.isDragging || this.isHoverOnResizeTrigger) && `${mergedClsPrefix}-drawer__resize-trigger--hover`
          ], onMouseenter: this.handleMouseenterResizeTrigger, onMouseleave: this.handleMouseleaveResizeTrigger, onMousedown: this.handleMousedownResizeTrigger }) : null,
          this.nativeScrollbar ? h$1("div", { class: `${mergedClsPrefix}-drawer-content-wrapper`, style: this.contentStyle, role: "none" }, $slots) : h$1(NScrollbar, Object.assign({}, this.scrollbarProps, { contentStyle: this.contentStyle, contentClass: `${mergedClsPrefix}-drawer-content-wrapper`, theme: this.mergedTheme.peers.Scrollbar, themeOverrides: this.mergedTheme.peerOverrides.Scrollbar }), $slots)
        ]), this.bodyDirectives)
      })
    })), [
      [
        vShow,
        this.displayDirective === "if" || this.displayed || this.show
      ]
    ]) : null;
  }
});
const { cubicBezierEaseIn: cubicBezierEaseIn$3, cubicBezierEaseOut: cubicBezierEaseOut$3 } = commonVariables$e;
function slideInFromRightTransition({ duration = "0.3s", leaveDuration = "0.2s", name: name2 = "slide-in-from-right" } = {}) {
  return [
    c$2(`&.${name2}-transition-leave-active`, {
      transition: `transform ${leaveDuration} ${cubicBezierEaseIn$3}`
    }),
    c$2(`&.${name2}-transition-enter-active`, {
      transition: `transform ${duration} ${cubicBezierEaseOut$3}`
    }),
    c$2(`&.${name2}-transition-enter-to`, {
      transform: "translateX(0)"
    }),
    c$2(`&.${name2}-transition-enter-from`, {
      transform: "translateX(100%)"
    }),
    c$2(`&.${name2}-transition-leave-from`, {
      transform: "translateX(0)"
    }),
    c$2(`&.${name2}-transition-leave-to`, {
      transform: "translateX(100%)"
    })
  ];
}
const { cubicBezierEaseIn: cubicBezierEaseIn$2, cubicBezierEaseOut: cubicBezierEaseOut$2 } = commonVariables$e;
function slideInFromLeftTransition({ duration = "0.3s", leaveDuration = "0.2s", name: name2 = "slide-in-from-left" } = {}) {
  return [
    c$2(`&.${name2}-transition-leave-active`, {
      transition: `transform ${leaveDuration} ${cubicBezierEaseIn$2}`
    }),
    c$2(`&.${name2}-transition-enter-active`, {
      transition: `transform ${duration} ${cubicBezierEaseOut$2}`
    }),
    c$2(`&.${name2}-transition-enter-to`, {
      transform: "translateX(0)"
    }),
    c$2(`&.${name2}-transition-enter-from`, {
      transform: "translateX(-100%)"
    }),
    c$2(`&.${name2}-transition-leave-from`, {
      transform: "translateX(0)"
    }),
    c$2(`&.${name2}-transition-leave-to`, {
      transform: "translateX(-100%)"
    })
  ];
}
const { cubicBezierEaseIn: cubicBezierEaseIn$1, cubicBezierEaseOut: cubicBezierEaseOut$1 } = commonVariables$e;
function slideInFromTopTransition({ duration = "0.3s", leaveDuration = "0.2s", name: name2 = "slide-in-from-top" } = {}) {
  return [
    c$2(`&.${name2}-transition-leave-active`, {
      transition: `transform ${leaveDuration} ${cubicBezierEaseIn$1}`
    }),
    c$2(`&.${name2}-transition-enter-active`, {
      transition: `transform ${duration} ${cubicBezierEaseOut$1}`
    }),
    c$2(`&.${name2}-transition-enter-to`, {
      transform: "translateY(0)"
    }),
    c$2(`&.${name2}-transition-enter-from`, {
      transform: "translateY(-100%)"
    }),
    c$2(`&.${name2}-transition-leave-from`, {
      transform: "translateY(0)"
    }),
    c$2(`&.${name2}-transition-leave-to`, {
      transform: "translateY(-100%)"
    })
  ];
}
const { cubicBezierEaseIn, cubicBezierEaseOut } = commonVariables$e;
function slideInFromBottomTransition({ duration = "0.3s", leaveDuration = "0.2s", name: name2 = "slide-in-from-bottom" } = {}) {
  return [
    c$2(`&.${name2}-transition-leave-active`, {
      transition: `transform ${leaveDuration} ${cubicBezierEaseIn}`
    }),
    c$2(`&.${name2}-transition-enter-active`, {
      transition: `transform ${duration} ${cubicBezierEaseOut}`
    }),
    c$2(`&.${name2}-transition-enter-to`, {
      transform: "translateY(0)"
    }),
    c$2(`&.${name2}-transition-enter-from`, {
      transform: "translateY(100%)"
    }),
    c$2(`&.${name2}-transition-leave-from`, {
      transform: "translateY(0)"
    }),
    c$2(`&.${name2}-transition-leave-to`, {
      transform: "translateY(100%)"
    })
  ];
}
var style$f = c$2([cB$1("drawer", `
 word-break: break-word;
 line-height: var(--n-line-height);
 position: absolute;
 pointer-events: all;
 box-shadow: var(--n-box-shadow);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 background-color: var(--n-color);
 color: var(--n-text-color);
 box-sizing: border-box;
 `, [slideInFromRightTransition(), slideInFromLeftTransition(), slideInFromTopTransition(), slideInFromBottomTransition(), cM("unselectable", `
 user-select: none; 
 -webkit-user-select: none;
 `), cM("native-scrollbar", [cB$1("drawer-content-wrapper", `
 overflow: auto;
 height: 100%;
 `)]), cE$1("resize-trigger", `
 position: absolute;
 background-color: #0000;
 transition: background-color .3s var(--n-bezier);
 `, [cM("hover", `
 background-color: var(--n-resize-trigger-color-hover);
 `)]), cB$1("drawer-content-wrapper", `
 box-sizing: border-box;
 `), cB$1("drawer-content", `
 height: 100%;
 display: flex;
 flex-direction: column;
 `, [cM("native-scrollbar", [cB$1("drawer-body-content-wrapper", `
 height: 100%;
 overflow: auto;
 `)]), cB$1("drawer-body", `
 flex: 1 0 0;
 overflow: hidden;
 `), cB$1("drawer-body-content-wrapper", `
 box-sizing: border-box;
 padding: var(--n-body-padding);
 `), cB$1("drawer-header", `
 font-weight: var(--n-title-font-weight);
 line-height: 1;
 font-size: var(--n-title-font-size);
 color: var(--n-title-text-color);
 padding: var(--n-header-padding);
 transition: border .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-divider-color);
 border-bottom: var(--n-header-border-bottom);
 display: flex;
 justify-content: space-between;
 align-items: center;
 `, [cE$1("close", `
 margin-left: 6px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), cB$1("drawer-footer", `
 display: flex;
 justify-content: flex-end;
 border-top: var(--n-footer-border-top);
 transition: border .3s var(--n-bezier);
 padding: var(--n-footer-padding);
 `)]), cM("right-placement", `
 top: 0;
 bottom: 0;
 right: 0;
 `, [cE$1("resize-trigger", `
 width: 3px;
 height: 100%;
 top: 0;
 left: 0;
 transform: translateX(-1.5px);
 cursor: ew-resize;
 `)]), cM("left-placement", `
 top: 0;
 bottom: 0;
 left: 0;
 `, [cE$1("resize-trigger", `
 width: 3px;
 height: 100%;
 top: 0;
 right: 0;
 transform: translateX(1.5px);
 cursor: ew-resize;
 `)]), cM("top-placement", `
 top: 0;
 left: 0;
 right: 0;
 `, [cE$1("resize-trigger", `
 width: 100%;
 height: 3px;
 bottom: 0;
 left: 0;
 transform: translateY(1.5px);
 cursor: ns-resize;
 `)]), cM("bottom-placement", `
 left: 0;
 bottom: 0;
 right: 0;
 `, [cE$1("resize-trigger", `
 width: 100%;
 height: 3px;
 top: 0;
 left: 0;
 transform: translateY(-1.5px);
 cursor: ns-resize;
 `)])]), c$2("body", [c$2(">", [cB$1("drawer-container", {
  position: "fixed"
})])]), cB$1("drawer-container", `
 position: relative;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 pointer-events: none;
 `, [c$2("> *", {
  pointerEvents: "all"
})]), cB$1("drawer-mask", `
 background-color: rgba(0, 0, 0, .3);
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `, [cM("invisible", `
 background-color: rgba(0, 0, 0, 0)
 `), fadeInTransition({
  enterDuration: "0.2s",
  leaveDuration: "0.2s",
  enterCubicBezier: "var(--n-bezier-in)",
  leaveCubicBezier: "var(--n-bezier-out)"
})])]);
const drawerProps = Object.assign(Object.assign({}, useTheme.props), {
  show: Boolean,
  width: [Number, String],
  height: [Number, String],
  placement: {
    type: String,
    default: "right"
  },
  maskClosable: {
    type: Boolean,
    default: true
  },
  showMask: {
    type: [Boolean, String],
    default: true
  },
  to: [String, Object],
  displayDirective: {
    type: String,
    default: "if"
  },
  nativeScrollbar: {
    type: Boolean,
    default: true
  },
  zIndex: Number,
  onMaskClick: Function,
  scrollbarProps: Object,
  contentStyle: [Object, String],
  trapFocus: {
    type: Boolean,
    default: true
  },
  onEsc: Function,
  autoFocus: {
    type: Boolean,
    default: true
  },
  closeOnEsc: {
    type: Boolean,
    default: true
  },
  blockScroll: {
    type: Boolean,
    default: true
  },
  resizable: Boolean,
  defaultWidth: {
    type: [Number, String],
    default: 251
  },
  defaultHeight: {
    type: [Number, String],
    default: 251
  },
  onUpdateWidth: [Function, Array],
  onUpdateHeight: [Function, Array],
  "onUpdate:width": [Function, Array],
  "onUpdate:height": [Function, Array],
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onAfterEnter: Function,
  onAfterLeave: Function,
  drawerStyle: [String, Object],
  drawerClass: String,
  target: null,
  onShow: Function,
  onHide: Function
});
var NDrawer = defineComponent({
  name: "Drawer",
  inheritAttrs: false,
  props: drawerProps,
  setup(props) {
    const { mergedClsPrefixRef, namespaceRef, inlineThemeDisabled } = useConfig(props);
    const isMountedRef = isMounted();
    const themeRef = useTheme("Drawer", "-drawer", style$f, drawerLight$1, props, mergedClsPrefixRef);
    const uncontrolledWidthRef = ref(props.defaultWidth);
    const uncontrolledHeightRef = ref(props.defaultHeight);
    const mergedWidthRef = useMergedState(toRef(props, "width"), uncontrolledWidthRef);
    const mergedHeightRef = useMergedState(toRef(props, "height"), uncontrolledHeightRef);
    const styleWidthRef = computed(() => {
      const { placement } = props;
      if (placement === "top" || placement === "bottom")
        return "";
      return formatLength(mergedWidthRef.value);
    });
    const styleHeightRef = computed(() => {
      const { placement } = props;
      if (placement === "left" || placement === "right")
        return "";
      return formatLength(mergedHeightRef.value);
    });
    const doUpdateWidth = (value2) => {
      const { onUpdateWidth, "onUpdate:width": _onUpdateWidth } = props;
      if (onUpdateWidth)
        call(onUpdateWidth, value2);
      if (_onUpdateWidth)
        call(_onUpdateWidth, value2);
      uncontrolledWidthRef.value = value2;
    };
    const doUpdateHeight = (value2) => {
      const { onUpdateHeight, "onUpdate:width": _onUpdateHeight } = props;
      if (onUpdateHeight)
        call(onUpdateHeight, value2);
      if (_onUpdateHeight)
        call(_onUpdateHeight, value2);
      uncontrolledHeightRef.value = value2;
    };
    const mergedBodyStyleRef = computed(() => {
      return [
        {
          width: styleWidthRef.value,
          height: styleHeightRef.value
        },
        props.drawerStyle || ""
      ];
    });
    function handleMaskClick(e25) {
      const { onMaskClick, maskClosable } = props;
      if (maskClosable) {
        doUpdateShow(false);
      }
      if (onMaskClick)
        onMaskClick(e25);
    }
    const isComposingRef2 = useIsComposing();
    function handleEsc(e25) {
      var _a2;
      (_a2 = props.onEsc) === null || _a2 === void 0 ? void 0 : _a2.call(props);
      if (props.show && props.closeOnEsc && eventEffectNotPerformed(e25)) {
        !isComposingRef2.value && doUpdateShow(false);
      }
    }
    function doUpdateShow(show) {
      const { onHide, onUpdateShow, "onUpdate:show": _onUpdateShow } = props;
      if (onUpdateShow)
        call(onUpdateShow, show);
      if (_onUpdateShow)
        call(_onUpdateShow, show);
      if (onHide && !show)
        call(onHide, show);
    }
    provide(drawerInjectionKey, {
      isMountedRef,
      mergedThemeRef: themeRef,
      mergedClsPrefixRef,
      doUpdateShow,
      doUpdateHeight,
      doUpdateWidth
    });
    const cssVarsRef = computed(() => {
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2, cubicBezierEaseIn: cubicBezierEaseIn2, cubicBezierEaseOut: cubicBezierEaseOut2 }, self: { color, textColor, boxShadow, lineHeight: lineHeight2, headerPadding, footerPadding, bodyPadding, titleFontSize, titleTextColor, titleFontWeight, headerBorderBottom, footerBorderTop, closeIconColor, closeIconColorHover, closeIconColorPressed, closeColorHover, closeColorPressed, closeIconSize, closeSize, closeBorderRadius, resizableTriggerColorHover } } = themeRef.value;
      return {
        "--n-line-height": lineHeight2,
        "--n-color": color,
        "--n-text-color": textColor,
        "--n-box-shadow": boxShadow,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-bezier-out": cubicBezierEaseOut2,
        "--n-bezier-in": cubicBezierEaseIn2,
        "--n-header-padding": headerPadding,
        "--n-body-padding": bodyPadding,
        "--n-footer-padding": footerPadding,
        "--n-title-text-color": titleTextColor,
        "--n-title-font-size": titleFontSize,
        "--n-title-font-weight": titleFontWeight,
        "--n-header-border-bottom": headerBorderBottom,
        "--n-footer-border-top": footerBorderTop,
        "--n-close-icon-color": closeIconColor,
        "--n-close-icon-color-hover": closeIconColorHover,
        "--n-close-icon-color-pressed": closeIconColorPressed,
        "--n-close-size": closeSize,
        "--n-close-color-hover": closeColorHover,
        "--n-close-color-pressed": closeColorPressed,
        "--n-close-icon-size": closeIconSize,
        "--n-close-border-radius": closeBorderRadius,
        "--n-resize-trigger-color-hover": resizableTriggerColorHover
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("drawer", void 0, cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      namespace: namespaceRef,
      mergedBodyStyle: mergedBodyStyleRef,
      handleMaskClick,
      handleEsc,
      mergedTheme: themeRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender,
      isMounted: isMountedRef
    };
  },
  render() {
    const { mergedClsPrefix } = this;
    return h$1(LazyTeleport, { to: this.to, show: this.show }, {
      default: () => {
        var _a2;
        (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
        return withDirectives(h$1("div", { class: [
          `${mergedClsPrefix}-drawer-container`,
          this.namespace,
          this.themeClass
        ], style: this.cssVars, role: "none" }, this.showMask ? h$1(Transition, { name: "fade-in-transition", appear: this.isMounted }, {
          default: () => this.show ? h$1("div", { "aria-hidden": true, class: [
            `${mergedClsPrefix}-drawer-mask`,
            this.showMask === "transparent" && `${mergedClsPrefix}-drawer-mask--invisible`
          ], onClick: this.handleMaskClick }) : null
        }) : null, h$1(NDrawerBodyWrapper, Object.assign({}, this.$attrs, { class: [this.drawerClass, this.$attrs.class], style: [this.mergedBodyStyle, this.$attrs.style], blockScroll: this.blockScroll, contentStyle: this.contentStyle, placement: this.placement, scrollbarProps: this.scrollbarProps, show: this.show, displayDirective: this.displayDirective, nativeScrollbar: this.nativeScrollbar, onAfterEnter: this.onAfterEnter, onAfterLeave: this.onAfterLeave, trapFocus: this.trapFocus, autoFocus: this.autoFocus, resizable: this.resizable, showMask: this.showMask, onEsc: this.handleEsc, onClickoutside: this.handleMaskClick }), this.$slots)), [[zindexable$1, { zIndex: this.zIndex, enabled: this.show }]]);
      }
    });
  }
});
const drawerContentProps = {
  title: {
    type: String
  },
  headerStyle: [Object, String],
  footerStyle: [Object, String],
  bodyStyle: [Object, String],
  bodyContentStyle: [Object, String],
  nativeScrollbar: { type: Boolean, default: true },
  scrollbarProps: Object,
  closable: Boolean
};
var NDrawerContent = defineComponent({
  name: "DrawerContent",
  props: drawerContentProps,
  setup() {
    const NDrawer2 = inject(drawerInjectionKey, null);
    if (!NDrawer2) {
      throwError("drawer-content", "`n-drawer-content` must be placed inside `n-drawer`.");
    }
    const { doUpdateShow } = NDrawer2;
    function handleCloseClick() {
      doUpdateShow(false);
    }
    return {
      handleCloseClick,
      mergedTheme: NDrawer2.mergedThemeRef,
      mergedClsPrefix: NDrawer2.mergedClsPrefixRef
    };
  },
  render() {
    const { title, mergedClsPrefix, nativeScrollbar, mergedTheme, bodyStyle, bodyContentStyle, headerStyle, footerStyle, scrollbarProps: scrollbarProps2, closable, $slots } = this;
    return h$1("div", { role: "none", class: [
      `${mergedClsPrefix}-drawer-content`,
      nativeScrollbar && `${mergedClsPrefix}-drawer-content--native-scrollbar`
    ] }, $slots.header || title || closable ? h$1("div", { class: `${mergedClsPrefix}-drawer-header`, style: headerStyle, role: "none" }, h$1("div", { class: `${mergedClsPrefix}-drawer-header__main`, role: "heading", "aria-level": "1" }, $slots.header !== void 0 ? $slots.header() : title), closable && h$1(NBaseClose, { onClick: this.handleCloseClick, clsPrefix: mergedClsPrefix, class: `${mergedClsPrefix}-drawer-header__close`, absolute: true })) : null, nativeScrollbar ? h$1("div", { class: `${mergedClsPrefix}-drawer-body`, style: bodyStyle, role: "none" }, h$1("div", { class: `${mergedClsPrefix}-drawer-body-content-wrapper`, style: bodyContentStyle, role: "none" }, $slots)) : h$1(NScrollbar, Object.assign({ themeOverrides: mergedTheme.peerOverrides.Scrollbar, theme: mergedTheme.peers.Scrollbar }, scrollbarProps2, { class: `${mergedClsPrefix}-drawer-body`, contentClass: `${mergedClsPrefix}-drawer-body-content-wrapper`, contentStyle: bodyContentStyle }), $slots), $slots.footer ? h$1("div", { class: `${mergedClsPrefix}-drawer-footer`, style: footerStyle, role: "none" }, $slots.footer()) : null);
  }
});
var commonVars$2 = {
  gapSmall: "4px 8px",
  gapMedium: "8px 12px",
  gapLarge: "12px 16px"
};
const self$e = () => {
  return commonVars$2;
};
const spaceLight = {
  name: "Space",
  self: self$e
};
var spaceLight$1 = spaceLight;
let supportFlexGap;
const ensureSupportFlexGap = () => {
  if (!isBrowser$2)
    return true;
  if (supportFlexGap === void 0) {
    const flex2 = document.createElement("div");
    flex2.style.display = "flex";
    flex2.style.flexDirection = "column";
    flex2.style.rowGap = "1px";
    flex2.appendChild(document.createElement("div"));
    flex2.appendChild(document.createElement("div"));
    document.body.appendChild(flex2);
    const isSupported = flex2.scrollHeight === 1;
    document.body.removeChild(flex2);
    return supportFlexGap = isSupported;
  }
  return supportFlexGap;
};
const spaceProps = Object.assign(Object.assign({}, useTheme.props), {
  align: String,
  justify: {
    type: String,
    default: "start"
  },
  inline: Boolean,
  vertical: Boolean,
  size: {
    type: [String, Number, Array],
    default: "medium"
  },
  wrapItem: {
    type: Boolean,
    default: true
  },
  itemStyle: [String, Object],
  wrap: {
    type: Boolean,
    default: true
  },
  internalUseGap: {
    type: Boolean,
    default: void 0
  }
});
var NSpace = defineComponent({
  name: "Space",
  props: spaceProps,
  setup(props) {
    const { mergedClsPrefixRef, mergedRtlRef } = useConfig(props);
    const themeRef = useTheme("Space", "-space", void 0, spaceLight$1, props, mergedClsPrefixRef);
    const rtlEnabledRef = useRtl("Space", mergedRtlRef, mergedClsPrefixRef);
    return {
      useGap: ensureSupportFlexGap(),
      rtlEnabled: rtlEnabledRef,
      mergedClsPrefix: mergedClsPrefixRef,
      margin: computed(() => {
        const { size: size2 } = props;
        if (Array.isArray(size2)) {
          return {
            horizontal: size2[0],
            vertical: size2[1]
          };
        }
        if (typeof size2 === "number") {
          return {
            horizontal: size2,
            vertical: size2
          };
        }
        const { self: { [createKey("gap", size2)]: gap } } = themeRef.value;
        const { row, col } = getGap(gap);
        return {
          horizontal: depx(col),
          vertical: depx(row)
        };
      })
    };
  },
  render() {
    const { vertical, align, inline, justify, itemStyle, margin, wrap, mergedClsPrefix, rtlEnabled, useGap, wrapItem, internalUseGap } = this;
    const children = flatten$4(getSlot$1(this));
    if (!children.length)
      return null;
    const horizontalMargin = `${margin.horizontal}px`;
    const semiHorizontalMargin = `${margin.horizontal / 2}px`;
    const verticalMargin = `${margin.vertical}px`;
    const semiVerticalMargin = `${margin.vertical / 2}px`;
    const lastIndex = children.length - 1;
    const isJustifySpace = justify.startsWith("space-");
    return h$1("div", { role: "none", class: [
      `${mergedClsPrefix}-space`,
      rtlEnabled && `${mergedClsPrefix}-space--rtl`
    ], style: {
      display: inline ? "inline-flex" : "flex",
      flexDirection: vertical ? "column" : "row",
      justifyContent: ["start", "end"].includes(justify) ? "flex-" + justify : justify,
      flexWrap: !wrap || vertical ? "nowrap" : "wrap",
      marginTop: useGap || vertical ? "" : `-${semiVerticalMargin}`,
      marginBottom: useGap || vertical ? "" : `-${semiVerticalMargin}`,
      alignItems: align,
      gap: useGap ? `${margin.vertical}px ${margin.horizontal}px` : ""
    } }, !wrapItem && (useGap || internalUseGap) ? children : children.map((child, index2) => h$1("div", { role: "none", style: [
      itemStyle,
      {
        maxWidth: "100%"
      },
      useGap ? "" : vertical ? {
        marginBottom: index2 !== lastIndex ? verticalMargin : ""
      } : rtlEnabled ? {
        marginLeft: isJustifySpace ? justify === "space-between" && index2 === lastIndex ? "" : semiHorizontalMargin : index2 !== lastIndex ? horizontalMargin : "",
        marginRight: isJustifySpace ? justify === "space-between" && index2 === 0 ? "" : semiHorizontalMargin : "",
        paddingTop: semiVerticalMargin,
        paddingBottom: semiVerticalMargin
      } : {
        marginRight: isJustifySpace ? justify === "space-between" && index2 === lastIndex ? "" : semiHorizontalMargin : index2 !== lastIndex ? horizontalMargin : "",
        marginLeft: isJustifySpace ? justify === "space-between" && index2 === 0 ? "" : semiHorizontalMargin : "",
        paddingTop: semiVerticalMargin,
        paddingBottom: semiVerticalMargin
      }
    ] }, child)));
  }
});
const dynamicTagsLight = createTheme({
  name: "DynamicTags",
  common: commonLight,
  peers: {
    Input: inputLight$1,
    Button: buttonLight$1,
    Tag: tagLight$1,
    Space: spaceLight$1
  },
  self() {
    return {
      inputWidth: "64px"
    };
  }
});
var dynamicTagsLight$1 = dynamicTagsLight;
var style$e = cB$1("dynamic-tags", [cB$1("input", {
  minWidth: "var(--n-input-width)"
})]);
const dynamicTagsProps = Object.assign(Object.assign(Object.assign({}, useTheme.props), commonProps), {
  size: {
    type: String,
    default: "medium"
  },
  closable: {
    type: Boolean,
    default: true
  },
  defaultValue: {
    type: Array,
    default: () => []
  },
  value: Array,
  inputStyle: [String, Object],
  inputProps: Object,
  max: Number,
  tagStyle: [String, Object],
  renderTag: Function,
  onCreate: {
    type: Function,
    default: (label) => label
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onChange: [Function, Array]
});
var NDynamicTags = defineComponent({
  name: "DynamicTags",
  props: dynamicTagsProps,
  setup(props) {
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const { localeRef } = useLocale("DynamicTags");
    const formItem = useFormItem(props);
    const { mergedDisabledRef } = formItem;
    const inputValueRef = ref("");
    const showInputRef = ref(false);
    const inputForceFocusedRef = ref(true);
    const inputInstRef = ref(null);
    const themeRef = useTheme("DynamicTags", "-dynamic-tags", style$e, dynamicTagsLight$1, props, mergedClsPrefixRef);
    const uncontrolledValueRef = ref(props.defaultValue);
    const controlledValueRef = toRef(props, "value");
    const mergedValueRef = useMergedState(controlledValueRef, uncontrolledValueRef);
    const localizedAddRef = computed(() => {
      return localeRef.value.add;
    });
    const inputSizeRef = computed(() => {
      return smallerSize(props.size);
    });
    const triggerDisabledRef = computed(() => {
      return mergedDisabledRef.value || !!props.max && mergedValueRef.value.length >= props.max;
    });
    function doChange(value2) {
      const { onChange, "onUpdate:value": _onUpdateValue, onUpdateValue } = props;
      const { nTriggerFormInput, nTriggerFormChange } = formItem;
      if (onChange)
        call(onChange, value2);
      if (onUpdateValue)
        call(onUpdateValue, value2);
      if (_onUpdateValue)
        call(_onUpdateValue, value2);
      uncontrolledValueRef.value = value2;
      nTriggerFormInput();
      nTriggerFormChange();
    }
    function handleCloseClick(index2) {
      const tags2 = mergedValueRef.value.slice(0);
      tags2.splice(index2, 1);
      doChange(tags2);
    }
    function handleInputKeyUp(e25) {
      switch (e25.key) {
        case "Enter":
          handleInputConfirm();
      }
    }
    function handleInputConfirm(externalValue) {
      const nextValue = externalValue !== null && externalValue !== void 0 ? externalValue : inputValueRef.value;
      if (nextValue) {
        const tags2 = mergedValueRef.value.slice(0);
        tags2.push(props.onCreate(nextValue));
        doChange(tags2);
      }
      showInputRef.value = false;
      inputForceFocusedRef.value = true;
      inputValueRef.value = "";
    }
    function handleInputBlur() {
      handleInputConfirm();
    }
    function handleAddClick() {
      showInputRef.value = true;
      void nextTick(() => {
        var _a2;
        (_a2 = inputInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
        inputForceFocusedRef.value = false;
      });
    }
    const cssVarsRef = computed(() => {
      const { self: { inputWidth } } = themeRef.value;
      return {
        "--n-input-width": inputWidth
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("dynamic-tags", void 0, cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      inputInstRef,
      localizedAdd: localizedAddRef,
      inputSize: inputSizeRef,
      inputValue: inputValueRef,
      showInput: showInputRef,
      inputForceFocused: inputForceFocusedRef,
      mergedValue: mergedValueRef,
      mergedDisabled: mergedDisabledRef,
      triggerDisabled: triggerDisabledRef,
      handleInputKeyUp,
      handleAddClick,
      handleInputBlur,
      handleCloseClick,
      handleInputConfirm,
      mergedTheme: themeRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const { mergedTheme, cssVars, mergedClsPrefix, onRender, renderTag } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1(NSpace, { class: [`${mergedClsPrefix}-dynamic-tags`, this.themeClass], size: "small", style: cssVars, theme: mergedTheme.peers.Space, themeOverrides: mergedTheme.peerOverrides.Space, itemStyle: "display: flex;" }, {
      default: () => {
        const { mergedTheme: mergedTheme2, tagStyle, type: type4, round, size: size2, color, closable, mergedDisabled, showInput, inputValue, inputStyle, inputSize, inputForceFocused, triggerDisabled, handleInputKeyUp, handleInputBlur, handleAddClick, handleCloseClick, handleInputConfirm, $slots } = this;
        return this.mergedValue.map((tag, index2) => renderTag ? renderTag(tag, index2) : h$1(NTag, { key: index2, theme: mergedTheme2.peers.Tag, themeOverrides: mergedTheme2.peerOverrides.Tag, style: tagStyle, type: type4, round, size: size2, color, closable, disabled: mergedDisabled, onClose: () => {
          handleCloseClick(index2);
        } }, {
          default: () => typeof tag === "string" ? tag : tag.label
        })).concat(showInput ? $slots.input ? $slots.input({
          submit: handleInputConfirm,
          deactivate: handleInputBlur
        }) : h$1(NInput, Object.assign({ placeholder: "", size: inputSize, style: inputStyle, autosize: true }, this.inputProps, { ref: "inputInstRef", value: inputValue, onUpdateValue: (v2) => {
          this.inputValue = v2;
        }, theme: mergedTheme2.peers.Input, themeOverrides: mergedTheme2.peerOverrides.Input, onKeyup: handleInputKeyUp, onBlur: handleInputBlur, internalForceFocus: inputForceFocused })) : $slots.trigger ? $slots.trigger({
          activate: handleAddClick,
          disabled: triggerDisabled
        }) : h$1(NButton, { dashed: true, disabled: triggerDisabled, theme: mergedTheme2.peers.Button, themeOverrides: mergedTheme2.peerOverrides.Button, size: inputSize, onClick: handleAddClick }, {
          icon: () => h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, { default: () => h$1(AddIcon, null) })
        }));
      }
    });
  }
});
var commonVariables$1 = {
  feedbackPadding: "4px 0 0 2px",
  feedbackHeightSmall: "24px",
  feedbackHeightMedium: "24px",
  feedbackHeightLarge: "26px",
  feedbackFontSizeSmall: "13px",
  feedbackFontSizeMedium: "14px",
  feedbackFontSizeLarge: "14px",
  labelFontSizeLeftSmall: "14px",
  labelFontSizeLeftMedium: "14px",
  labelFontSizeLeftLarge: "15px",
  labelFontSizeTopSmall: "13px",
  labelFontSizeTopMedium: "14px",
  labelFontSizeTopLarge: "14px",
  labelHeightSmall: "24px",
  labelHeightMedium: "26px",
  labelHeightLarge: "28px",
  labelPaddingVertical: "0 0 6px 2px",
  labelPaddingHorizontal: "0 12px 0 0",
  labelTextAlignVertical: "left",
  labelTextAlignHorizontal: "right",
  labelFontWeight: "400"
};
const self$d = (vars) => {
  const { heightSmall, heightMedium, heightLarge, textColor1, errorColor, warningColor, lineHeight: lineHeight2, textColor3 } = vars;
  return Object.assign(Object.assign({}, commonVariables$1), { blankHeightSmall: heightSmall, blankHeightMedium: heightMedium, blankHeightLarge: heightLarge, lineHeight: lineHeight2, labelTextColor: textColor1, asteriskColor: errorColor, feedbackTextColorError: errorColor, feedbackTextColorWarning: warningColor, feedbackTextColor: textColor3 });
};
const formLight = {
  name: "Form",
  common: commonLight,
  self: self$d
};
var formLight$1 = formLight;
var style$d = cB$1("form", [cM("inline", `
 width: 100%;
 display: inline-flex;
 align-items: flex-start;
 align-content: space-around;
 `, [cB$1("form-item", {
  width: "auto",
  marginRight: "18px"
}, [c$2("&:last-child", {
  marginRight: 0
})])])]);
const formInjectionKey = createInjectionKey("n-form");
const formItemInstsInjectionKey = createInjectionKey("n-form-item-insts");
var __awaiter$4 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value2) {
    return value2 instanceof P2 ? value2 : new P2(function(resolve) {
      resolve(value2);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value2) {
      try {
        step(generator.next(value2));
      } catch (e25) {
        reject(e25);
      }
    }
    function rejected(value2) {
      try {
        step(generator["throw"](value2));
      } catch (e25) {
        reject(e25);
      }
    }
    function step(result2) {
      result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
const formProps = Object.assign(Object.assign({}, useTheme.props), { inline: Boolean, labelWidth: [Number, String], labelAlign: String, labelPlacement: {
  type: String,
  default: "top"
}, model: {
  type: Object,
  default: () => {
  }
}, rules: Object, disabled: Boolean, size: String, showRequireMark: {
  type: Boolean,
  default: void 0
}, requireMarkPlacement: String, showFeedback: {
  type: Boolean,
  default: true
}, onSubmit: {
  type: Function,
  default: (e25) => {
    e25.preventDefault();
  }
}, showLabel: {
  type: Boolean,
  default: void 0
}, validateMessages: Object });
var NForm = defineComponent({
  name: "Form",
  props: formProps,
  setup(props) {
    const { mergedClsPrefixRef } = useConfig(props);
    useTheme("Form", "-form", style$d, formLight$1, props, mergedClsPrefixRef);
    const formItems = {};
    const maxChildLabelWidthRef = ref(void 0);
    const deriveMaxChildLabelWidth = (currentWidth) => {
      const currentMaxChildLabelWidth = maxChildLabelWidthRef.value;
      if (currentMaxChildLabelWidth === void 0 || currentWidth >= currentMaxChildLabelWidth) {
        maxChildLabelWidthRef.value = currentWidth;
      }
    };
    function validate2(validateCallback, shouldRuleBeApplied = () => true) {
      return __awaiter$4(this, void 0, void 0, function* () {
        yield new Promise((resolve, reject) => {
          const formItemValidationPromises = [];
          for (const key of keysOf(formItems)) {
            const formItemInstances = formItems[key];
            for (const formItemInstance of formItemInstances) {
              if (formItemInstance.path) {
                formItemValidationPromises.push(formItemInstance.internalValidate(null, shouldRuleBeApplied));
              }
            }
          }
          void Promise.all(formItemValidationPromises).then((results) => {
            if (results.some((result2) => !result2.valid)) {
              const errors = results.filter((result2) => result2.errors).map((result2) => result2.errors);
              if (validateCallback) {
                validateCallback(errors);
              }
              reject(errors);
            } else {
              if (validateCallback)
                validateCallback();
              resolve();
            }
          });
        });
      });
    }
    function restoreValidation() {
      for (const key of keysOf(formItems)) {
        const formItemInstances = formItems[key];
        for (const formItemInstance of formItemInstances) {
          formItemInstance.restoreValidation();
        }
      }
    }
    provide(formInjectionKey, {
      props,
      maxChildLabelWidthRef,
      deriveMaxChildLabelWidth
    });
    provide(formItemInstsInjectionKey, { formItems });
    const formExposedMethod = {
      validate: validate2,
      restoreValidation
    };
    return Object.assign(formExposedMethod, {
      mergedClsPrefix: mergedClsPrefixRef
    });
  },
  render() {
    const { mergedClsPrefix } = this;
    return h$1("form", { class: [
      `${mergedClsPrefix}-form`,
      this.inline && `${mergedClsPrefix}-form--inline`
    ], onSubmit: this.onSubmit }, this.$slots);
  }
});
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}
function _getPrototypeOf$1(o2) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf$1(o2);
}
function _setPrototypeOf$1(o2, p2) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf$1(o2, p2);
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e25) {
    return false;
  }
}
function _construct$1(Parent, args, Class) {
  if (_isNativeReflectConstruct$1()) {
    _construct$1 = Reflect.construct.bind();
  } else {
    _construct$1 = function _construct2(Parent2, args2, Class2) {
      var a2 = [null];
      a2.push.apply(a2, args2);
      var Constructor = Function.bind.apply(Parent2, a2);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf$1(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct$1.apply(null, arguments);
}
function _isNativeFunction$1(fn2) {
  return Function.toString.call(fn2).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper$1(Class) {
  var _cache = typeof Map === "function" ? new Map() : void 0;
  _wrapNativeSuper$1 = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction$1(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper2);
    }
    function Wrapper2() {
      return _construct$1(Class2, arguments, _getPrototypeOf$1(this).constructor);
    }
    Wrapper2.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper2,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf$1(Wrapper2, Class2);
  };
  return _wrapNativeSuper$1(Class);
}
var formatRegExp = /%[sdj%]/g;
var warning = function warning2() {
};
if (typeof process !== "undefined" && process.env && false) {
  warning = function warning3(type4, errors) {
    if (typeof console !== "undefined" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING === "undefined") {
      if (errors.every(function(e25) {
        return typeof e25 === "string";
      })) {
        console.warn(type4, errors);
      }
    }
  };
}
function convertFieldsError(errors) {
  if (!errors || !errors.length)
    return null;
  var fields = {};
  errors.forEach(function(error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}
function format$1(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var i2 = 0;
  var len2 = args.length;
  if (typeof template === "function") {
    return template.apply(null, args);
  }
  if (typeof template === "string") {
    var str = template.replace(formatRegExp, function(x2) {
      if (x2 === "%%") {
        return "%";
      }
      if (i2 >= len2) {
        return x2;
      }
      switch (x2) {
        case "%s":
          return String(args[i2++]);
        case "%d":
          return Number(args[i2++]);
        case "%j":
          try {
            return JSON.stringify(args[i2++]);
          } catch (_2) {
            return "[Circular]";
          }
          break;
        default:
          return x2;
      }
    });
    return str;
  }
  return template;
}
function isNativeStringType(type4) {
  return type4 === "string" || type4 === "url" || type4 === "hex" || type4 === "email" || type4 === "date" || type4 === "pattern";
}
function isEmptyValue(value2, type4) {
  if (value2 === void 0 || value2 === null) {
    return true;
  }
  if (type4 === "array" && Array.isArray(value2) && !value2.length) {
    return true;
  }
  if (isNativeStringType(type4) && typeof value2 === "string" && !value2) {
    return true;
  }
  return false;
}
function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;
  function count(errors) {
    results.push.apply(results, errors || []);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }
  arr.forEach(function(a2) {
    func(a2, count);
  });
}
function asyncSerialArray(arr, func, callback) {
  var index2 = 0;
  var arrLength = arr.length;
  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index2;
    index2 = index2 + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }
  next([]);
}
function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function(k2) {
    ret.push.apply(ret, objArr[k2] || []);
  });
  return ret;
}
var AsyncValidationError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose(AsyncValidationError2, _Error);
  function AsyncValidationError2(errors, fields) {
    var _this;
    _this = _Error.call(this, "Async Validation Error") || this;
    _this.errors = errors;
    _this.fields = fields;
    return _this;
  }
  return AsyncValidationError2;
}(/* @__PURE__ */ _wrapNativeSuper$1(Error));
function asyncMap(objArr, option, func, callback, source) {
  if (option.first) {
    var _pending = new Promise(function(resolve, reject) {
      var next = function next2(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve(source);
      };
      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next);
    });
    _pending["catch"](function(e25) {
      return e25;
    });
    return _pending;
  }
  var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function(resolve, reject) {
    var next = function next2(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve(source);
      }
    };
    if (!objArrKeys.length) {
      callback(results);
      resolve(source);
    }
    objArrKeys.forEach(function(key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending["catch"](function(e25) {
    return e25;
  });
  return pending;
}
function isErrorObj(obj) {
  return !!(obj && obj.message !== void 0);
}
function getValue(value2, path) {
  var v2 = value2;
  for (var i2 = 0; i2 < path.length; i2++) {
    if (v2 == void 0) {
      return v2;
    }
    v2 = v2[path[i2]];
  }
  return v2;
}
function complementError(rule, source) {
  return function(oe2) {
    var fieldValue;
    if (rule.fullFields) {
      fieldValue = getValue(source, rule.fullFields);
    } else {
      fieldValue = source[oe2.field || rule.fullField];
    }
    if (isErrorObj(oe2)) {
      oe2.field = oe2.field || rule.fullField;
      oe2.fieldValue = fieldValue;
      return oe2;
    }
    return {
      message: typeof oe2 === "function" ? oe2() : oe2,
      fieldValue,
      field: oe2.field || rule.fullField
    };
  };
}
function deepMerge(target, source) {
  if (source) {
    for (var s2 in source) {
      if (source.hasOwnProperty(s2)) {
        var value2 = source[s2];
        if (typeof value2 === "object" && typeof target[s2] === "object") {
          target[s2] = _extends({}, target[s2], value2);
        } else {
          target[s2] = value2;
        }
      }
    }
  }
  return target;
}
var required$1 = function required(rule, value2, source, errors, options, type4) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value2, type4 || rule.type))) {
    errors.push(format$1(options.messages.required, rule.fullField));
  }
};
var whitespace = function whitespace2(rule, value2, source, errors, options) {
  if (/^\s+$/.test(value2) || value2 === "") {
    errors.push(format$1(options.messages.whitespace, rule.fullField));
  }
};
var urlReg;
var getUrlRegex = function() {
  if (urlReg) {
    return urlReg;
  }
  var word = "[a-fA-F\\d:]";
  var b2 = function b3(options) {
    return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : "";
  };
  var v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
  var v6seg = "[a-fA-F\\d]{1,4}";
  var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v4 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v4 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v4 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v4 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v4 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v4 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v4 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim();
  var v46Exact = new RegExp("(?:^" + v4 + "$)|(?:^" + v6 + "$)");
  var v4exact = new RegExp("^" + v4 + "$");
  var v6exact = new RegExp("^" + v6 + "$");
  var ip2 = function ip3(options) {
    return options && options.exact ? v46Exact : new RegExp("(?:" + b2(options) + v4 + b2(options) + ")|(?:" + b2(options) + v6 + b2(options) + ")", "g");
  };
  ip2.v4 = function(options) {
    return options && options.exact ? v4exact : new RegExp("" + b2(options) + v4 + b2(options), "g");
  };
  ip2.v6 = function(options) {
    return options && options.exact ? v6exact : new RegExp("" + b2(options) + v6 + b2(options), "g");
  };
  var protocol = "(?:(?:[a-z]+:)?//)";
  var auth = "(?:\\S+(?::\\S*)?@)?";
  var ipv4 = ip2.v4().source;
  var ipv6 = ip2.v6().source;
  var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
  var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
  var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
  var port = "(?::\\d{2,5})?";
  var path = '(?:[/?#][^\\s"]*)?';
  var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path;
  urlReg = new RegExp("(?:^" + regex + "$)", "i");
  return urlReg;
};
var pattern$2 = {
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types$1 = {
  integer: function integer(value2) {
    return types$1.number(value2) && parseInt(value2, 10) === value2;
  },
  "float": function float2(value2) {
    return types$1.number(value2) && !types$1.integer(value2);
  },
  array: function array(value2) {
    return Array.isArray(value2);
  },
  regexp: function regexp(value2) {
    if (value2 instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value2);
    } catch (e25) {
      return false;
    }
  },
  date: function date(value2) {
    return typeof value2.getTime === "function" && typeof value2.getMonth === "function" && typeof value2.getYear === "function" && !isNaN(value2.getTime());
  },
  number: function number(value2) {
    if (isNaN(value2)) {
      return false;
    }
    return typeof value2 === "number";
  },
  object: function object(value2) {
    return typeof value2 === "object" && !types$1.array(value2);
  },
  method: function method(value2) {
    return typeof value2 === "function";
  },
  email: function email(value2) {
    return typeof value2 === "string" && value2.length <= 320 && !!value2.match(pattern$2.email);
  },
  url: function url(value2) {
    return typeof value2 === "string" && value2.length <= 2048 && !!value2.match(getUrlRegex());
  },
  hex: function hex2(value2) {
    return typeof value2 === "string" && !!value2.match(pattern$2.hex);
  }
};
var type$1 = function type(rule, value2, source, errors, options) {
  if (rule.required && value2 === void 0) {
    required$1(rule, value2, source, errors, options);
    return;
  }
  var custom = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types$1[ruleType](value2)) {
      errors.push(format$1(options.messages.types[ruleType], rule.fullField, rule.type));
    }
  } else if (ruleType && typeof value2 !== rule.type) {
    errors.push(format$1(options.messages.types[ruleType], rule.fullField, rule.type));
  }
};
var range = function range2(rule, value2, source, errors, options) {
  var len2 = typeof rule.len === "number";
  var min = typeof rule.min === "number";
  var max = typeof rule.max === "number";
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value2;
  var key = null;
  var num = typeof value2 === "number";
  var str = typeof value2 === "string";
  var arr = Array.isArray(value2);
  if (num) {
    key = "number";
  } else if (str) {
    key = "string";
  } else if (arr) {
    key = "array";
  }
  if (!key) {
    return false;
  }
  if (arr) {
    val = value2.length;
  }
  if (str) {
    val = value2.replace(spRegexp, "_").length;
  }
  if (len2) {
    if (val !== rule.len) {
      errors.push(format$1(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(format$1(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(format$1(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(format$1(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
};
var ENUM$1 = "enum";
var enumerable$1 = function enumerable(rule, value2, source, errors, options) {
  rule[ENUM$1] = Array.isArray(rule[ENUM$1]) ? rule[ENUM$1] : [];
  if (rule[ENUM$1].indexOf(value2) === -1) {
    errors.push(format$1(options.messages[ENUM$1], rule.fullField, rule[ENUM$1].join(", ")));
  }
};
var pattern$1 = function pattern(rule, value2, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value2)) {
        errors.push(format$1(options.messages.pattern.mismatch, rule.fullField, value2, rule.pattern));
      }
    } else if (typeof rule.pattern === "string") {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value2)) {
        errors.push(format$1(options.messages.pattern.mismatch, rule.fullField, value2, rule.pattern));
      }
    }
  }
};
var rules = {
  required: required$1,
  whitespace,
  type: type$1,
  range,
  "enum": enumerable$1,
  pattern: pattern$1
};
var string$1 = function string(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value2, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options, "string");
    if (!isEmptyValue(value2, "string")) {
      rules.type(rule, value2, source, errors, options);
      rules.range(rule, value2, source, errors, options);
      rules.pattern(rule, value2, source, errors, options);
      if (rule.whitespace === true) {
        rules.whitespace(rule, value2, source, errors, options);
      }
    }
  }
  callback(errors);
};
var method2 = function method3(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value2) && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options);
    if (value2 !== void 0) {
      rules.type(rule, value2, source, errors, options);
    }
  }
  callback(errors);
};
var number$2 = function number2(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (value2 === "") {
      value2 = void 0;
    }
    if (isEmptyValue(value2) && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options);
    if (value2 !== void 0) {
      rules.type(rule, value2, source, errors, options);
      rules.range(rule, value2, source, errors, options);
    }
  }
  callback(errors);
};
var _boolean = function _boolean2(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value2) && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options);
    if (value2 !== void 0) {
      rules.type(rule, value2, source, errors, options);
    }
  }
  callback(errors);
};
var regexp2 = function regexp3(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value2) && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options);
    if (!isEmptyValue(value2)) {
      rules.type(rule, value2, source, errors, options);
    }
  }
  callback(errors);
};
var integer$1 = function integer2(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value2) && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options);
    if (value2 !== void 0) {
      rules.type(rule, value2, source, errors, options);
      rules.range(rule, value2, source, errors, options);
    }
  }
  callback(errors);
};
var floatFn = function floatFn2(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value2) && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options);
    if (value2 !== void 0) {
      rules.type(rule, value2, source, errors, options);
      rules.range(rule, value2, source, errors, options);
    }
  }
  callback(errors);
};
var array2 = function array3(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if ((value2 === void 0 || value2 === null) && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options, "array");
    if (value2 !== void 0 && value2 !== null) {
      rules.type(rule, value2, source, errors, options);
      rules.range(rule, value2, source, errors, options);
    }
  }
  callback(errors);
};
var object2 = function object3(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value2) && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options);
    if (value2 !== void 0) {
      rules.type(rule, value2, source, errors, options);
    }
  }
  callback(errors);
};
var ENUM = "enum";
var enumerable2 = function enumerable3(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value2) && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options);
    if (value2 !== void 0) {
      rules[ENUM](rule, value2, source, errors, options);
    }
  }
  callback(errors);
};
var pattern2 = function pattern3(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value2, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options);
    if (!isEmptyValue(value2, "string")) {
      rules.pattern(rule, value2, source, errors, options);
    }
  }
  callback(errors);
};
var date2 = function date3(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value2, "date") && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options);
    if (!isEmptyValue(value2, "date")) {
      var dateObject;
      if (value2 instanceof Date) {
        dateObject = value2;
      } else {
        dateObject = new Date(value2);
      }
      rules.type(rule, dateObject, source, errors, options);
      if (dateObject) {
        rules.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
};
var required2 = function required3(rule, value2, callback, source, options) {
  var errors = [];
  var type4 = Array.isArray(value2) ? "array" : typeof value2;
  rules.required(rule, value2, source, errors, options, type4);
  callback(errors);
};
var type2 = function type3(rule, value2, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value2, ruleType) && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options, ruleType);
    if (!isEmptyValue(value2, ruleType)) {
      rules.type(rule, value2, source, errors, options);
    }
  }
  callback(errors);
};
var any = function any2(rule, value2, callback, source, options) {
  var errors = [];
  var validate2 = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate2) {
    if (isEmptyValue(value2) && !rule.required) {
      return callback();
    }
    rules.required(rule, value2, source, errors, options);
  }
  callback(errors);
};
var validators = {
  string: string$1,
  method: method2,
  number: number$2,
  "boolean": _boolean,
  regexp: regexp2,
  integer: integer$1,
  "float": floatFn,
  array: array2,
  object: object2,
  "enum": enumerable2,
  pattern: pattern2,
  date: date2,
  url: type2,
  hex: type2,
  email: type2,
  required: required2,
  any
};
function newMessages() {
  return {
    "default": "Validation error on field %s",
    required: "%s is required",
    "enum": "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      "boolean": "%s is not a %s",
      integer: "%s is not an %s",
      "float": "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages = newMessages();
var Schema$1 = /* @__PURE__ */ function() {
  function Schema2(descriptor) {
    this.rules = null;
    this._messages = messages;
    this.define(descriptor);
  }
  var _proto = Schema2.prototype;
  _proto.define = function define(rules2) {
    var _this = this;
    if (!rules2) {
      throw new Error("Cannot configure a schema with no rules");
    }
    if (typeof rules2 !== "object" || Array.isArray(rules2)) {
      throw new Error("Rules must be an object");
    }
    this.rules = {};
    Object.keys(rules2).forEach(function(name2) {
      var item = rules2[name2];
      _this.rules[name2] = Array.isArray(item) ? item : [item];
    });
  };
  _proto.messages = function messages2(_messages) {
    if (_messages) {
      this._messages = deepMerge(newMessages(), _messages);
    }
    return this._messages;
  };
  _proto.validate = function validate2(source_, o2, oc2) {
    var _this2 = this;
    if (o2 === void 0) {
      o2 = {};
    }
    if (oc2 === void 0) {
      oc2 = function oc3() {
      };
    }
    var source = source_;
    var options = o2;
    var callback = oc2;
    if (typeof options === "function") {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback(null, source);
      }
      return Promise.resolve(source);
    }
    function complete(results) {
      var errors = [];
      var fields = {};
      function add2(e25) {
        if (Array.isArray(e25)) {
          var _errors;
          errors = (_errors = errors).concat.apply(_errors, e25);
        } else {
          errors.push(e25);
        }
      }
      for (var i2 = 0; i2 < results.length; i2++) {
        add2(results[i2]);
      }
      if (!errors.length) {
        callback(null, source);
      } else {
        fields = convertFieldsError(errors);
        callback(errors, fields);
      }
    }
    if (options.messages) {
      var messages$1 = this.messages();
      if (messages$1 === messages) {
        messages$1 = newMessages();
      }
      deepMerge(messages$1, options.messages);
      options.messages = messages$1;
    } else {
      options.messages = this.messages();
    }
    var series = {};
    var keys2 = options.keys || Object.keys(this.rules);
    keys2.forEach(function(z2) {
      var arr = _this2.rules[z2];
      var value2 = source[z2];
      arr.forEach(function(r2) {
        var rule = r2;
        if (typeof rule.transform === "function") {
          if (source === source_) {
            source = _extends({}, source);
          }
          value2 = source[z2] = rule.transform(value2);
        }
        if (typeof rule === "function") {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        }
        rule.validator = _this2.getValidationMethod(rule);
        if (!rule.validator) {
          return;
        }
        rule.field = z2;
        rule.fullField = rule.fullField || z2;
        rule.type = _this2.getType(rule);
        series[z2] = series[z2] || [];
        series[z2].push({
          rule,
          value: value2,
          source,
          field: z2
        });
      });
    });
    var errorFields = {};
    return asyncMap(series, options, function(data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === "object" || rule.type === "array") && (typeof rule.fields === "object" || typeof rule.defaultField === "object");
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;
      function addFullField(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + "." + key,
          fullFields: rule.fullFields ? [].concat(rule.fullFields, [key]) : [key]
        });
      }
      function cb2(e25) {
        if (e25 === void 0) {
          e25 = [];
        }
        var errorList = Array.isArray(e25) ? e25 : [e25];
        if (!options.suppressWarning && errorList.length) {
          Schema2.warning("async-validator:", errorList);
        }
        if (errorList.length && rule.message !== void 0) {
          errorList = [].concat(rule.message);
        }
        var filledErrors = errorList.map(complementError(rule, source));
        if (options.first && filledErrors.length) {
          errorFields[rule.field] = 1;
          return doIt(filledErrors);
        }
        if (!deep) {
          doIt(filledErrors);
        } else {
          if (rule.required && !data.value) {
            if (rule.message !== void 0) {
              filledErrors = [].concat(rule.message).map(complementError(rule, source));
            } else if (options.error) {
              filledErrors = [options.error(rule, format$1(options.messages.required, rule.field))];
            }
            return doIt(filledErrors);
          }
          var fieldsSchema = {};
          if (rule.defaultField) {
            Object.keys(data.value).map(function(key) {
              fieldsSchema[key] = rule.defaultField;
            });
          }
          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
          var paredFieldsSchema = {};
          Object.keys(fieldsSchema).forEach(function(field) {
            var fieldSchema = fieldsSchema[field];
            var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [fieldSchema];
            paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
          });
          var schema = new Schema2(paredFieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function(errs) {
            var finalErrors = [];
            if (filledErrors && filledErrors.length) {
              finalErrors.push.apply(finalErrors, filledErrors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }
      var res;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb2, data.source, options);
      } else if (rule.validator) {
        try {
          res = rule.validator(rule, data.value, cb2, data.source, options);
        } catch (error) {
          console.error == null ? void 0 : console.error(error);
          if (!options.suppressValidatorError) {
            setTimeout(function() {
              throw error;
            }, 0);
          }
          cb2(error.message);
        }
        if (res === true) {
          cb2();
        } else if (res === false) {
          cb2(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
        } else if (res instanceof Array) {
          cb2(res);
        } else if (res instanceof Error) {
          cb2(res.message);
        }
      }
      if (res && res.then) {
        res.then(function() {
          return cb2();
        }, function(e25) {
          return cb2(e25);
        });
      }
    }, function(results) {
      complete(results);
    }, source);
  };
  _proto.getType = function getType2(rule) {
    if (rule.type === void 0 && rule.pattern instanceof RegExp) {
      rule.type = "pattern";
    }
    if (typeof rule.validator !== "function" && rule.type && !validators.hasOwnProperty(rule.type)) {
      throw new Error(format$1("Unknown rule type %s", rule.type));
    }
    return rule.type || "string";
  };
  _proto.getValidationMethod = function getValidationMethod(rule) {
    if (typeof rule.validator === "function") {
      return rule.validator;
    }
    var keys2 = Object.keys(rule);
    var messageIndex = keys2.indexOf("message");
    if (messageIndex !== -1) {
      keys2.splice(messageIndex, 1);
    }
    if (keys2.length === 1 && keys2[0] === "required") {
      return validators.required;
    }
    return validators[this.getType(rule)] || void 0;
  };
  return Schema2;
}();
Schema$1.register = function register(type4, validator2) {
  if (typeof validator2 !== "function") {
    throw new Error("Cannot register a validator by type, validator is not a function");
  }
  validators[type4] = validator2;
};
Schema$1.warning = warning;
Schema$1.messages = messages;
Schema$1.validators = validators;
function formItemSize(props) {
  const NForm2 = inject(formInjectionKey, null);
  return {
    mergedSize: computed(() => {
      if (props.size !== void 0)
        return props.size;
      if ((NForm2 === null || NForm2 === void 0 ? void 0 : NForm2.props.size) !== void 0)
        return NForm2.props.size;
      return "medium";
    })
  };
}
function formItemMisc(props) {
  const NForm2 = inject(formInjectionKey, null);
  const mergedLabelPlacementRef = computed(() => {
    const { labelPlacement } = props;
    if (labelPlacement !== void 0)
      return labelPlacement;
    if (NForm2 === null || NForm2 === void 0 ? void 0 : NForm2.props.labelPlacement)
      return NForm2.props.labelPlacement;
    return "top";
  });
  const isAutoLabelWidthRef = computed(() => {
    return mergedLabelPlacementRef.value === "left" && (props.labelWidth === "auto" || (NForm2 === null || NForm2 === void 0 ? void 0 : NForm2.props.labelWidth) === "auto");
  });
  const mergedLabelWidthRef = computed(() => {
    if (mergedLabelPlacementRef.value === "top")
      return;
    const { labelWidth } = props;
    if (labelWidth !== void 0 && labelWidth !== "auto") {
      return formatLength(labelWidth);
    }
    if (isAutoLabelWidthRef.value) {
      const autoComputedWidth = NForm2 === null || NForm2 === void 0 ? void 0 : NForm2.maxChildLabelWidthRef.value;
      if (autoComputedWidth !== void 0) {
        return formatLength(autoComputedWidth);
      } else {
        return void 0;
      }
    }
    if ((NForm2 === null || NForm2 === void 0 ? void 0 : NForm2.props.labelWidth) !== void 0) {
      return formatLength(NForm2.props.labelWidth);
    }
    return void 0;
  });
  const mergedLabelAlignRef = computed(() => {
    const { labelAlign } = props;
    if (labelAlign)
      return labelAlign;
    if (NForm2 === null || NForm2 === void 0 ? void 0 : NForm2.props.labelAlign)
      return NForm2.props.labelAlign;
    return void 0;
  });
  const mergedLabelStyleRef = computed(() => {
    var _a2;
    return [
      (_a2 = props.labelProps) === null || _a2 === void 0 ? void 0 : _a2.style,
      props.labelStyle,
      {
        width: mergedLabelWidthRef.value
      }
    ];
  });
  const mergedShowRequireMarkRef = computed(() => {
    const { showRequireMark } = props;
    if (showRequireMark !== void 0)
      return showRequireMark;
    return NForm2 === null || NForm2 === void 0 ? void 0 : NForm2.props.showRequireMark;
  });
  const mergedRequireMarkPlacementRef = computed(() => {
    const { requireMarkPlacement } = props;
    if (requireMarkPlacement !== void 0)
      return requireMarkPlacement;
    return (NForm2 === null || NForm2 === void 0 ? void 0 : NForm2.props.requireMarkPlacement) || "right";
  });
  const validationErroredRef = ref(false);
  const mergedValidationStatusRef = computed(() => {
    const { validationStatus } = props;
    if (validationStatus !== void 0)
      return validationStatus;
    if (validationErroredRef.value)
      return "error";
    return void 0;
  });
  const mergedShowFeedbackRef = computed(() => {
    const { showFeedback } = props;
    if (showFeedback !== void 0)
      return showFeedback;
    if ((NForm2 === null || NForm2 === void 0 ? void 0 : NForm2.props.showFeedback) !== void 0)
      return NForm2.props.showFeedback;
    return true;
  });
  const mergedShowLabelRef = computed(() => {
    const { showLabel } = props;
    if (showLabel !== void 0)
      return showLabel;
    if ((NForm2 === null || NForm2 === void 0 ? void 0 : NForm2.props.showLabel) !== void 0)
      return NForm2.props.showLabel;
    return true;
  });
  return {
    validationErrored: validationErroredRef,
    mergedLabelStyle: mergedLabelStyleRef,
    mergedLabelPlacement: mergedLabelPlacementRef,
    mergedLabelAlign: mergedLabelAlignRef,
    mergedShowRequireMark: mergedShowRequireMarkRef,
    mergedRequireMarkPlacement: mergedRequireMarkPlacementRef,
    mergedValidationStatus: mergedValidationStatusRef,
    mergedShowFeedback: mergedShowFeedbackRef,
    mergedShowLabel: mergedShowLabelRef,
    isAutoLabelWidth: isAutoLabelWidthRef
  };
}
function formItemRule(props) {
  const NForm2 = inject(formInjectionKey, null);
  const compatibleRulePathRef = computed(() => {
    const { rulePath } = props;
    if (rulePath !== void 0)
      return rulePath;
    const { path } = props;
    if (path !== void 0)
      return path;
    return void 0;
  });
  const mergedRulesRef = computed(() => {
    const rules2 = [];
    const { rule } = props;
    if (rule !== void 0) {
      if (Array.isArray(rule))
        rules2.push(...rule);
      else
        rules2.push(rule);
    }
    if (NForm2) {
      const { rules: formRules } = NForm2.props;
      const { value: rulePath } = compatibleRulePathRef;
      if (formRules !== void 0 && rulePath !== void 0) {
        const formRule = get(formRules, rulePath);
        if (formRule !== void 0) {
          if (Array.isArray(formRule)) {
            rules2.push(...formRule);
          } else {
            rules2.push(formRule);
          }
        }
      }
    }
    return rules2;
  });
  const hasRequiredRuleRef = computed(() => {
    return mergedRulesRef.value.some((rule) => rule.required);
  });
  const mergedRequiredRef = computed(() => {
    return hasRequiredRuleRef.value || props.required;
  });
  return {
    mergedRules: mergedRulesRef,
    mergedRequired: mergedRequiredRef
  };
}
const {
  cubicBezierEaseInOut
} = commonVariables$e;
function fadeDownTransition({
  name: name2 = "fade-down",
  fromOffset = "-4px",
  enterDuration = ".3s",
  leaveDuration = ".3s",
  enterCubicBezier = cubicBezierEaseInOut,
  leaveCubicBezier = cubicBezierEaseInOut
} = {}) {
  return [c$2(`&.${name2}-transition-enter-from, &.${name2}-transition-leave-to`, {
    opacity: 0,
    transform: `translateY(${fromOffset})`
  }), c$2(`&.${name2}-transition-enter-to, &.${name2}-transition-leave-from`, {
    opacity: 1,
    transform: "translateY(0)"
  }), c$2(`&.${name2}-transition-leave-active`, {
    transition: `opacity ${leaveDuration} ${leaveCubicBezier}, transform ${leaveDuration} ${leaveCubicBezier}`
  }), c$2(`&.${name2}-transition-enter-active`, {
    transition: `opacity ${enterDuration} ${enterCubicBezier}, transform ${enterDuration} ${enterCubicBezier}`
  })];
}
var style$c = cB$1("form-item", `
 display: grid;
 line-height: var(--n-line-height);
`, [cB$1("form-item-label", `
 grid-area: label;
 align-items: center;
 line-height: 1.25;
 text-align: var(--n-label-text-align);
 font-size: var(--n-label-font-size);
 min-height: var(--n-label-height);
 padding: var(--n-label-padding);
 color: var(--n-label-text-color);
 transition: color .3s var(--n-bezier);
 box-sizing: border-box;
 font-weight: var(--n-label-font-weight);
 `, [cE$1("asterisk", `
 white-space: nowrap;
 user-select: none;
 -webkit-user-select: none;
 color: var(--n-asterisk-color);
 transition: color .3s var(--n-bezier);
 `), cE$1("asterisk-placeholder", `
 grid-area: mark;
 user-select: none;
 -webkit-user-select: none;
 visibility: hidden; 
 `)]), cB$1("form-item-blank", `
 grid-area: blank;
 min-height: var(--n-blank-height);
 `), cM("auto-label-width", [cB$1("form-item-label", "white-space: nowrap;")]), cM("left-labelled", `
 grid-template-areas:
 "label blank"
 "label feedback";
 grid-template-columns: auto minmax(0, 1fr);
 grid-template-rows: auto 1fr;
 align-items: start;
 `, [cB$1("form-item-label", `
 display: grid;
 grid-template-columns: 1fr auto;
 min-height: var(--n-blank-height);
 height: auto;
 box-sizing: border-box;
 flex-shrink: 0;
 flex-grow: 0;
 `, [cM("reverse-columns-space", `
 grid-template-columns: auto 1fr;
 `), cM("left-mark", `
 grid-template-areas:
 "mark text"
 ". text";
 `), cM("right-mark", `
 grid-template-areas: 
 "text mark"
 "text .";
 `), cM("right-hanging-mark", `
 grid-template-areas: 
 "text mark"
 "text .";
 `), cE$1("text", `
 grid-area: text; 
 `), cE$1("asterisk", `
 grid-area: mark; 
 align-self: end;
 `)])]), cM("top-labelled", `
 grid-template-areas:
 "label"
 "blank"
 "feedback";
 grid-template-rows: minmax(var(--n-label-height), auto) 1fr;
 grid-template-columns: minmax(0, 100%);
 `, [cM("no-label", `
 grid-template-areas:
 "blank"
 "feedback";
 grid-template-rows: 1fr;
 `), cB$1("form-item-label", `
 display: flex;
 align-items: flex-start;
 justify-content: var(--n-label-text-align);
 `)]), cB$1("form-item-blank", `
 box-sizing: border-box;
 display: flex;
 align-items: center;
 position: relative;
 `), cB$1("form-item-feedback-wrapper", `
 grid-area: feedback;
 box-sizing: border-box;
 min-height: var(--n-feedback-height);
 font-size: var(--n-feedback-font-size);
 line-height: 1.25;
 transform-origin: top left;
 `, [c$2("&:not(:empty)", `
 padding: var(--n-feedback-padding);
 `), cB$1("form-item-feedback", {
  transition: "color .3s var(--n-bezier)",
  color: "var(--n-feedback-text-color)"
}, [cM("warning", {
  color: "var(--n-feedback-text-color-warning)"
}), cM("error", {
  color: "var(--n-feedback-text-color-error)"
}), fadeDownTransition({
  fromOffset: "-3px",
  enterDuration: ".3s",
  leaveDuration: ".2s"
})])])]);
var __awaiter$3 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value2) {
    return value2 instanceof P2 ? value2 : new P2(function(resolve) {
      resolve(value2);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value2) {
      try {
        step(generator.next(value2));
      } catch (e25) {
        reject(e25);
      }
    }
    function rejected(value2) {
      try {
        step(generator["throw"](value2));
      } catch (e25) {
        reject(e25);
      }
    }
    function step(result2) {
      result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
const formItemProps = Object.assign(Object.assign({}, useTheme.props), { label: String, labelWidth: [Number, String], labelStyle: [String, Object], labelAlign: String, labelPlacement: String, path: String, first: Boolean, rulePath: String, required: Boolean, showRequireMark: {
  type: Boolean,
  default: void 0
}, requireMarkPlacement: String, showFeedback: {
  type: Boolean,
  default: void 0
}, rule: [Object, Array], size: String, ignorePathChange: Boolean, validationStatus: String, feedback: String, showLabel: {
  type: Boolean,
  default: void 0
}, labelProps: Object });
function wrapValidator(validator2, async) {
  return (...args) => {
    try {
      const validateResult = validator2(...args);
      if (!async && (typeof validateResult === "boolean" || validateResult instanceof Error || Array.isArray(validateResult)) || (validateResult === null || validateResult === void 0 ? void 0 : validateResult.then)) {
        return validateResult;
      } else if (validateResult === void 0) {
        return true;
      } else {
        warn$2("form-item/validate", `You return a ${typeof validateResult} typed value in the validator method, which is not recommended. Please use ` + (async ? "`Promise`" : "`boolean`, `Error` or `Promise`") + " typed value instead.");
        return true;
      }
    } catch (err) {
      warn$2("form-item/validate", "An error is catched in the validation, so the validation won't be done. Your callback in `validate` method of `n-form` or `n-form-item` won't be called in this validation.");
      console.error(err);
      return void 0;
    }
  };
}
var NFormItem = defineComponent({
  name: "FormItem",
  props: formItemProps,
  setup(props) {
    useInjectionInstanceCollection(formItemInstsInjectionKey, "formItems", toRef(props, "path"));
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const NForm2 = inject(formInjectionKey, null);
    const formItemSizeRefs = formItemSize(props);
    const formItemMiscRefs = formItemMisc(props);
    const { validationErrored: validationErroredRef } = formItemMiscRefs;
    const { mergedRequired: mergedRequiredRef, mergedRules: mergedRulesRef } = formItemRule(props);
    const { mergedSize: mergedSizeRef } = formItemSizeRefs;
    const { mergedLabelPlacement: labelPlacementRef, mergedLabelAlign: labelTextAlignRef, mergedRequireMarkPlacement: mergedRequireMarkPlacementRef } = formItemMiscRefs;
    const renderExplainsRef = ref([]);
    const feedbackIdRef = ref(createId());
    const mergedDisabledRef = NForm2 ? toRef(NForm2.props, "disabled") : ref(false);
    const themeRef = useTheme("Form", "-form-item", style$c, formLight$1, props, mergedClsPrefixRef);
    watch(toRef(props, "path"), () => {
      if (props.ignorePathChange)
        return;
      restoreValidation();
    });
    function restoreValidation() {
      renderExplainsRef.value = [];
      validationErroredRef.value = false;
      if (props.feedback) {
        feedbackIdRef.value = createId();
      }
    }
    function handleContentBlur() {
      void internalValidate("blur");
    }
    function handleContentChange() {
      void internalValidate("change");
    }
    function handleContentFocus() {
      void internalValidate("focus");
    }
    function handleContentInput() {
      void internalValidate("input");
    }
    function validate2(options, callback) {
      return __awaiter$3(this, void 0, void 0, function* () {
        let trigger2;
        let validateCallback;
        let shouldRuleBeApplied;
        let asyncValidatorOptions;
        if (typeof options === "string") {
          trigger2 = options;
          validateCallback = callback;
        } else if (options !== null && typeof options === "object") {
          trigger2 = options.trigger;
          validateCallback = options.callback;
          shouldRuleBeApplied = options.shouldRuleBeApplied;
          asyncValidatorOptions = options.options;
        }
        yield new Promise((resolve, reject) => {
          void internalValidate(trigger2, shouldRuleBeApplied, asyncValidatorOptions).then(({ valid, errors }) => {
            if (valid) {
              if (validateCallback) {
                validateCallback();
              }
              resolve();
            } else {
              if (validateCallback) {
                validateCallback(errors);
              }
              reject(errors);
            }
          });
        });
      });
    }
    const internalValidate = (trigger2 = null, shouldRuleBeApplied = () => true, options = {
      suppressWarning: true
    }) => __awaiter$3(this, void 0, void 0, function* () {
      const { path } = props;
      if (!options) {
        options = {};
      } else {
        if (!options.first)
          options.first = props.first;
      }
      const { value: rules2 } = mergedRulesRef;
      const value2 = NForm2 ? get(NForm2.props.model, path || "") : void 0;
      const messageRenderers = {};
      const originalMessageRendersMessage = {};
      const activeRules = (!trigger2 ? rules2 : rules2.filter((rule) => {
        if (Array.isArray(rule.trigger)) {
          return rule.trigger.includes(trigger2);
        } else {
          return rule.trigger === trigger2;
        }
      })).filter(shouldRuleBeApplied).map((rule, i2) => {
        const shallowClonedRule = Object.assign({}, rule);
        if (shallowClonedRule.validator) {
          shallowClonedRule.validator = wrapValidator(shallowClonedRule.validator, false);
        }
        if (shallowClonedRule.asyncValidator) {
          shallowClonedRule.asyncValidator = wrapValidator(shallowClonedRule.asyncValidator, true);
        }
        if (shallowClonedRule.renderMessage) {
          const rendererKey = `__renderMessage__${i2}`;
          originalMessageRendersMessage[rendererKey] = shallowClonedRule.message;
          shallowClonedRule.message = rendererKey;
          messageRenderers[rendererKey] = shallowClonedRule.renderMessage;
        }
        return shallowClonedRule;
      });
      if (!activeRules.length) {
        return {
          valid: true
        };
      }
      const mergedPath = path !== null && path !== void 0 ? path : "__n_no_path__";
      const validator2 = new Schema$1({ [mergedPath]: activeRules });
      const { validateMessages } = (NForm2 === null || NForm2 === void 0 ? void 0 : NForm2.props) || {};
      if (validateMessages) {
        validator2.messages(validateMessages);
      }
      return yield new Promise((resolve) => {
        void validator2.validate({ [mergedPath]: value2 }, options, (errors) => {
          if (errors === null || errors === void 0 ? void 0 : errors.length) {
            renderExplainsRef.value = errors.map((error) => {
              const transformedMessage = (error === null || error === void 0 ? void 0 : error.message) || "";
              return {
                key: transformedMessage,
                render: () => {
                  if (transformedMessage.startsWith("__renderMessage__")) {
                    return messageRenderers[transformedMessage]();
                  }
                  return transformedMessage;
                }
              };
            });
            errors.forEach((error) => {
              var _a2;
              if ((_a2 = error.message) === null || _a2 === void 0 ? void 0 : _a2.startsWith("__renderMessage__")) {
                error.message = originalMessageRendersMessage[error.message];
              }
            });
            validationErroredRef.value = true;
            resolve({
              valid: false,
              errors
            });
          } else {
            restoreValidation();
            resolve({
              valid: true
            });
          }
        });
      });
    });
    provide(formItemInjectionKey, {
      path: toRef(props, "path"),
      disabled: mergedDisabledRef,
      mergedSize: formItemSizeRefs.mergedSize,
      mergedValidationStatus: formItemMiscRefs.mergedValidationStatus,
      restoreValidation,
      handleContentBlur,
      handleContentChange,
      handleContentFocus,
      handleContentInput
    });
    const exposedRef = {
      validate: validate2,
      restoreValidation,
      internalValidate
    };
    const labelElementRef = ref(null);
    onMounted(() => {
      if (!formItemMiscRefs.isAutoLabelWidth.value)
        return;
      const labelElement = labelElementRef.value;
      if (labelElement !== null) {
        const memoizedWhitespace = labelElement.style.whiteSpace;
        labelElement.style.whiteSpace = "nowrap";
        labelElement.style.width = "";
        NForm2 === null || NForm2 === void 0 ? void 0 : NForm2.deriveMaxChildLabelWidth(Number(getComputedStyle(labelElement).width.slice(0, -2)));
        labelElement.style.whiteSpace = memoizedWhitespace;
      }
    });
    const cssVarsRef = computed(() => {
      var _a2;
      const { value: size2 } = mergedSizeRef;
      const { value: labelPlacement } = labelPlacementRef;
      const direction = labelPlacement === "top" ? "vertical" : "horizontal";
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { labelTextColor, asteriskColor, lineHeight: lineHeight2, feedbackTextColor, feedbackTextColorWarning, feedbackTextColorError, feedbackPadding, labelFontWeight, [createKey("labelHeight", size2)]: labelHeight, [createKey("blankHeight", size2)]: blankHeight, [createKey("feedbackFontSize", size2)]: feedbackFontSize, [createKey("feedbackHeight", size2)]: feedbackHeight, [createKey("labelPadding", direction)]: labelPadding, [createKey("labelTextAlign", direction)]: labelTextAlign, [createKey(createKey("labelFontSize", labelPlacement), size2)]: labelFontSize } } = themeRef.value;
      let mergedLabelTextAlign = (_a2 = labelTextAlignRef.value) !== null && _a2 !== void 0 ? _a2 : labelTextAlign;
      if (labelPlacement === "top") {
        mergedLabelTextAlign = mergedLabelTextAlign === "right" ? "flex-end" : "flex-start";
      }
      const cssVars = {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-line-height": lineHeight2,
        "--n-blank-height": blankHeight,
        "--n-label-font-size": labelFontSize,
        "--n-label-text-align": mergedLabelTextAlign,
        "--n-label-height": labelHeight,
        "--n-label-padding": labelPadding,
        "--n-label-font-weight": labelFontWeight,
        "--n-asterisk-color": asteriskColor,
        "--n-label-text-color": labelTextColor,
        "--n-feedback-padding": feedbackPadding,
        "--n-feedback-font-size": feedbackFontSize,
        "--n-feedback-height": feedbackHeight,
        "--n-feedback-text-color": feedbackTextColor,
        "--n-feedback-text-color-warning": feedbackTextColorWarning,
        "--n-feedback-text-color-error": feedbackTextColorError
      };
      return cssVars;
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("form-item", computed(() => {
      var _a2;
      return `${mergedSizeRef.value[0]}${labelPlacementRef.value[0]}${((_a2 = labelTextAlignRef.value) === null || _a2 === void 0 ? void 0 : _a2[0]) || ""}`;
    }), cssVarsRef, props) : void 0;
    const reverseColSpaceRef = computed(() => {
      return labelPlacementRef.value === "left" && mergedRequireMarkPlacementRef.value === "left" && labelTextAlignRef.value === "left";
    });
    return Object.assign(Object.assign(Object.assign(Object.assign({ labelElementRef, mergedClsPrefix: mergedClsPrefixRef, mergedRequired: mergedRequiredRef, feedbackId: feedbackIdRef, renderExplains: renderExplainsRef, reverseColSpace: reverseColSpaceRef }, formItemMiscRefs), formItemSizeRefs), exposedRef), { cssVars: inlineThemeDisabled ? void 0 : cssVarsRef, themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass, onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender });
  },
  render() {
    const { $slots, mergedClsPrefix, mergedShowLabel, mergedShowRequireMark, mergedRequireMarkPlacement, onRender } = this;
    const renderedShowRequireMark = mergedShowRequireMark !== void 0 ? mergedShowRequireMark : this.mergedRequired;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    const renderLabel = () => {
      const labelText = this.$slots.label ? this.$slots.label() : this.label;
      if (!labelText)
        return null;
      const textNode = h$1("span", { class: `${mergedClsPrefix}-form-item-label__text` }, labelText);
      const markNode = renderedShowRequireMark ? h$1("span", { class: `${mergedClsPrefix}-form-item-label__asterisk` }, mergedRequireMarkPlacement !== "left" ? "\xA0*" : "*\xA0") : mergedRequireMarkPlacement === "right-hanging" && h$1("span", { class: `${mergedClsPrefix}-form-item-label__asterisk-placeholder` }, "\xA0*");
      const { labelProps } = this;
      return h$1("label", Object.assign({}, labelProps, { class: [
        labelProps === null || labelProps === void 0 ? void 0 : labelProps.class,
        `${mergedClsPrefix}-form-item-label`,
        `${mergedClsPrefix}-form-item-label--${mergedRequireMarkPlacement}-mark`,
        this.reverseColSpace && `${mergedClsPrefix}-form-item-label--reverse-columns-space`
      ], style: this.mergedLabelStyle, ref: "labelElementRef" }), mergedRequireMarkPlacement === "left" ? [markNode, textNode] : [textNode, markNode]);
    };
    return h$1("div", { class: [
      `${mergedClsPrefix}-form-item`,
      this.themeClass,
      `${mergedClsPrefix}-form-item--${this.mergedSize}-size`,
      `${mergedClsPrefix}-form-item--${this.mergedLabelPlacement}-labelled`,
      this.isAutoLabelWidth && `${mergedClsPrefix}-form-item--auto-label-width`,
      !mergedShowLabel && `${mergedClsPrefix}-form-item--no-label`
    ], style: this.cssVars }, mergedShowLabel && renderLabel(), h$1("div", { class: [
      `${mergedClsPrefix}-form-item-blank`,
      this.mergedValidationStatus && `${mergedClsPrefix}-form-item-blank--${this.mergedValidationStatus}`
    ] }, $slots), this.mergedShowFeedback ? h$1("div", { key: this.feedbackId, class: `${mergedClsPrefix}-form-item-feedback-wrapper` }, h$1(Transition, { name: "fade-down-transition", mode: "out-in" }, {
      default: () => {
        const { mergedValidationStatus } = this;
        return resolveWrappedSlot($slots.feedback, (children) => {
          var _a2;
          const { feedback } = this;
          const feedbackNodes = children || feedback ? h$1("div", { key: "__feedback__", class: `${mergedClsPrefix}-form-item-feedback__line` }, children || feedback) : this.renderExplains.length ? (_a2 = this.renderExplains) === null || _a2 === void 0 ? void 0 : _a2.map(({ key, render: render2 }) => h$1("div", { key, class: `${mergedClsPrefix}-form-item-feedback__line` }, render2())) : null;
          return feedbackNodes ? mergedValidationStatus === "warning" ? h$1("div", { key: "controlled-warning", class: `${mergedClsPrefix}-form-item-feedback ${mergedClsPrefix}-form-item-feedback--warning` }, feedbackNodes) : mergedValidationStatus === "error" ? h$1("div", { key: "controlled-error", class: `${mergedClsPrefix}-form-item-feedback ${mergedClsPrefix}-form-item-feedback--error` }, feedbackNodes) : mergedValidationStatus === "success" ? h$1("div", { key: "controlled-success", class: `${mergedClsPrefix}-form-item-feedback ${mergedClsPrefix}-form-item-feedback--success` }, feedbackNodes) : h$1("div", { key: "controlled-default", class: `${mergedClsPrefix}-form-item-feedback` }, feedbackNodes) : null;
        });
      }
    })) : null);
  }
});
const imagePreviewSharedProps = Object.assign(Object.assign({}, useTheme.props), { showToolbar: { type: Boolean, default: true }, showToolbarTooltip: Boolean });
const imageContextKey = createInjectionKey("n-image");
function self$c() {
  return {
    toolbarIconColor: "rgba(255, 255, 255, .9)",
    toolbarColor: "rgba(0, 0, 0, .35)",
    toolbarBoxShadow: "none",
    toolbarBorderRadius: "24px"
  };
}
const imageLight = createTheme({
  name: "Image",
  common: commonLight,
  peers: {
    Tooltip: tooltipLight$1
  },
  self: self$c
});
var commonVars$1 = {
  closeMargin: "16px 12px",
  closeSize: "20px",
  closeIconSize: "16px",
  width: "365px",
  padding: "16px",
  titleFontSize: "16px",
  metaFontSize: "12px",
  descriptionFontSize: "12px"
};
const self$b = (vars) => {
  const { textColor2, successColor, infoColor, warningColor, errorColor, popoverColor, closeIconColor, closeIconColorHover, closeIconColorPressed, closeColorHover, closeColorPressed, textColor1, textColor3, borderRadius, fontWeightStrong, boxShadow2, lineHeight: lineHeight2, fontSize: fontSize2 } = vars;
  return Object.assign(Object.assign({}, commonVars$1), {
    borderRadius,
    lineHeight: lineHeight2,
    fontSize: fontSize2,
    headerFontWeight: fontWeightStrong,
    iconColor: textColor2,
    iconColorSuccess: successColor,
    iconColorInfo: infoColor,
    iconColorWarning: warningColor,
    iconColorError: errorColor,
    color: popoverColor,
    textColor: textColor2,
    closeIconColor,
    closeIconColorHover,
    closeIconColorPressed,
    closeBorderRadius: borderRadius,
    closeColorHover,
    closeColorPressed,
    headerTextColor: textColor1,
    descriptionTextColor: textColor3,
    actionTextColor: textColor2,
    boxShadow: boxShadow2
  });
};
const notificationLight = createTheme({
  name: "Notification",
  common: commonLight,
  peers: {
    Scrollbar: scrollbarLight$1
  },
  self: self$b
});
var notificationLight$1 = notificationLight;
const self$a = (vars) => {
  const { textColorDisabled } = vars;
  return {
    iconColorDisabled: textColorDisabled
  };
};
const inputNumberLight = createTheme({
  name: "InputNumber",
  common: commonLight,
  peers: {
    Button: buttonLight$1,
    Input: inputLight$1
  },
  self: self$a
});
var inputNumberLight$1 = inputNumberLight;
function createPartialInvertedVars(color, activeItemColor, activeTextColor, groupTextColor) {
  return {
    itemColorHoverInverted: "#0000",
    itemColorActiveInverted: activeItemColor,
    itemColorActiveHoverInverted: activeItemColor,
    itemColorActiveCollapsedInverted: activeItemColor,
    itemTextColorInverted: color,
    itemTextColorHoverInverted: activeTextColor,
    itemTextColorChildActiveInverted: activeTextColor,
    itemTextColorChildActiveHoverInverted: activeTextColor,
    itemTextColorActiveInverted: activeTextColor,
    itemTextColorActiveHoverInverted: activeTextColor,
    itemTextColorHorizontalInverted: color,
    itemTextColorHoverHorizontalInverted: activeTextColor,
    itemTextColorChildActiveHorizontalInverted: activeTextColor,
    itemTextColorChildActiveHoverHorizontalInverted: activeTextColor,
    itemTextColorActiveHorizontalInverted: activeTextColor,
    itemTextColorActiveHoverHorizontalInverted: activeTextColor,
    itemIconColorInverted: color,
    itemIconColorHoverInverted: activeTextColor,
    itemIconColorActiveInverted: activeTextColor,
    itemIconColorActiveHoverInverted: activeTextColor,
    itemIconColorChildActiveInverted: activeTextColor,
    itemIconColorChildActiveHoverInverted: activeTextColor,
    itemIconColorCollapsedInverted: color,
    itemIconColorHorizontalInverted: color,
    itemIconColorHoverHorizontalInverted: activeTextColor,
    itemIconColorActiveHorizontalInverted: activeTextColor,
    itemIconColorActiveHoverHorizontalInverted: activeTextColor,
    itemIconColorChildActiveHorizontalInverted: activeTextColor,
    itemIconColorChildActiveHoverHorizontalInverted: activeTextColor,
    arrowColorInverted: color,
    arrowColorHoverInverted: activeTextColor,
    arrowColorActiveInverted: activeTextColor,
    arrowColorActiveHoverInverted: activeTextColor,
    arrowColorChildActiveInverted: activeTextColor,
    arrowColorChildActiveHoverInverted: activeTextColor,
    groupTextColorInverted: groupTextColor
  };
}
const self$9 = (vars) => {
  const { borderRadius, textColor3, primaryColor, textColor2, textColor1, fontSize: fontSize2, dividerColor, hoverColor, primaryColorHover } = vars;
  return Object.assign({
    borderRadius,
    color: "#0000",
    groupTextColor: textColor3,
    itemColorHover: hoverColor,
    itemColorActive: changeColor(primaryColor, { alpha: 0.1 }),
    itemColorActiveHover: changeColor(primaryColor, { alpha: 0.1 }),
    itemColorActiveCollapsed: changeColor(primaryColor, { alpha: 0.1 }),
    itemTextColor: textColor2,
    itemTextColorHover: textColor2,
    itemTextColorActive: primaryColor,
    itemTextColorActiveHover: primaryColor,
    itemTextColorChildActive: primaryColor,
    itemTextColorChildActiveHover: primaryColor,
    itemTextColorHorizontal: textColor2,
    itemTextColorHoverHorizontal: primaryColorHover,
    itemTextColorActiveHorizontal: primaryColor,
    itemTextColorActiveHoverHorizontal: primaryColor,
    itemTextColorChildActiveHorizontal: primaryColor,
    itemTextColorChildActiveHoverHorizontal: primaryColor,
    itemIconColor: textColor1,
    itemIconColorHover: textColor1,
    itemIconColorActive: primaryColor,
    itemIconColorActiveHover: primaryColor,
    itemIconColorChildActive: primaryColor,
    itemIconColorChildActiveHover: primaryColor,
    itemIconColorCollapsed: textColor1,
    itemIconColorHorizontal: textColor1,
    itemIconColorHoverHorizontal: primaryColorHover,
    itemIconColorActiveHorizontal: primaryColor,
    itemIconColorActiveHoverHorizontal: primaryColor,
    itemIconColorChildActiveHorizontal: primaryColor,
    itemIconColorChildActiveHoverHorizontal: primaryColor,
    itemHeight: "42px",
    arrowColor: textColor2,
    arrowColorHover: textColor2,
    arrowColorActive: primaryColor,
    arrowColorActiveHover: primaryColor,
    arrowColorChildActive: primaryColor,
    arrowColorChildActiveHover: primaryColor,
    colorInverted: "#0000",
    borderColorHorizontal: "#0000",
    fontSize: fontSize2,
    dividerColor
  }, createPartialInvertedVars("#BBB", primaryColor, "#FFF", "#AAA"));
};
const menuLight = createTheme({
  name: "Menu",
  common: commonLight,
  peers: {
    Tooltip: tooltipLight$1,
    Dropdown: dropdownLight$1
  },
  self: self$9
});
var menuLight$1 = menuLight;
const self$8 = (vars) => {
  const { infoColor, successColor, warningColor, errorColor, textColor2, progressRailColor, fontSize: fontSize2, fontWeight } = vars;
  return {
    fontSize: fontSize2,
    fontSizeCircle: "28px",
    fontWeightCircle: fontWeight,
    railColor: progressRailColor,
    railHeight: "8px",
    iconSizeCircle: "36px",
    iconSizeLine: "18px",
    iconColor: infoColor,
    iconColorInfo: infoColor,
    iconColorSuccess: successColor,
    iconColorWarning: warningColor,
    iconColorError: errorColor,
    textColorCircle: textColor2,
    textColorLineInner: "rgb(255, 255, 255)",
    textColorLineOuter: textColor2,
    fillColor: infoColor,
    fillColorInfo: infoColor,
    fillColorSuccess: successColor,
    fillColorWarning: warningColor,
    fillColorError: errorColor,
    lineBgProcessing: "linear-gradient(90deg, rgba(255, 255, 255, .3) 0%, rgba(255, 255, 255, .5) 100%)"
  };
};
const progressLight = {
  name: "Progress",
  common: commonLight,
  self: self$8
};
var progressLight$1 = progressLight;
var sizeVariables$1 = {
  railHeight: "4px",
  railWidthVertical: "4px",
  handleSize: "18px",
  dotHeight: "8px",
  dotWidth: "8px",
  dotBorderRadius: "4px"
};
const self$7 = (vars) => {
  const indicatorColor = "rgba(0, 0, 0, .85)";
  const boxShadow = "0 2px 8px 0 rgba(0, 0, 0, 0.12)";
  const { railColor, primaryColor, baseColor, cardColor, modalColor, popoverColor, borderRadius, fontSize: fontSize2, opacityDisabled } = vars;
  return Object.assign(Object.assign({}, sizeVariables$1), { fontSize: fontSize2, markFontSize: fontSize2, railColor, railColorHover: railColor, fillColor: primaryColor, fillColorHover: primaryColor, opacityDisabled, handleColor: "#FFF", dotColor: cardColor, dotColorModal: modalColor, dotColorPopover: popoverColor, handleBoxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)", handleBoxShadowHover: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)", handleBoxShadowActive: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)", handleBoxShadowFocus: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)", indicatorColor, indicatorBoxShadow: boxShadow, indicatorTextColor: baseColor, indicatorBorderRadius: borderRadius, dotBorder: `2px solid ${railColor}`, dotBorderActive: `2px solid ${primaryColor}`, dotBoxShadow: "" });
};
const sliderLight = {
  name: "Slider",
  common: commonLight,
  self: self$7
};
var sliderLight$1 = sliderLight;
const self$6 = (vars) => {
  const { opacityDisabled, heightTiny, heightSmall, heightMedium, heightLarge, heightHuge, primaryColor, fontSize: fontSize2 } = vars;
  return {
    fontSize: fontSize2,
    textColor: primaryColor,
    sizeTiny: heightTiny,
    sizeSmall: heightSmall,
    sizeMedium: heightMedium,
    sizeLarge: heightLarge,
    sizeHuge: heightHuge,
    color: primaryColor,
    opacitySpinning: opacityDisabled
  };
};
const spinLight = {
  name: "Spin",
  common: commonLight,
  self: self$6
};
var spinLight$1 = spinLight;
var commonVariables = {
  stepHeaderFontSizeSmall: "14px",
  stepHeaderFontSizeMedium: "16px",
  indicatorIndexFontSizeSmall: "14px",
  indicatorIndexFontSizeMedium: "16px",
  indicatorSizeSmall: "22px",
  indicatorSizeMedium: "28px",
  indicatorIconSizeSmall: "14px",
  indicatorIconSizeMedium: "18px"
};
const self$5 = (vars) => {
  const { fontWeightStrong, baseColor, textColorDisabled, primaryColor, errorColor, textColor1, textColor2 } = vars;
  return Object.assign(Object.assign({}, commonVariables), { stepHeaderFontWeight: fontWeightStrong, indicatorTextColorProcess: baseColor, indicatorTextColorWait: textColorDisabled, indicatorTextColorFinish: primaryColor, indicatorTextColorError: errorColor, indicatorBorderColorProcess: primaryColor, indicatorBorderColorWait: textColorDisabled, indicatorBorderColorFinish: primaryColor, indicatorBorderColorError: errorColor, indicatorColorProcess: primaryColor, indicatorColorWait: "#0000", indicatorColorFinish: "#0000", indicatorColorError: "#0000", splitorColorProcess: textColorDisabled, splitorColorWait: textColorDisabled, splitorColorFinish: primaryColor, splitorColorError: textColorDisabled, headerTextColorProcess: textColor1, headerTextColorWait: textColorDisabled, headerTextColorFinish: textColorDisabled, headerTextColorError: errorColor, descriptionTextColorProcess: textColor2, descriptionTextColorWait: textColorDisabled, descriptionTextColorFinish: textColorDisabled, descriptionTextColorError: errorColor });
};
const stepsLight = {
  name: "Steps",
  common: commonLight,
  self: self$5
};
var stepsLight$1 = stepsLight;
var commonVars = {
  buttonHeightSmall: "14px",
  buttonHeightMedium: "18px",
  buttonHeightLarge: "22px",
  buttonWidthSmall: "14px",
  buttonWidthMedium: "18px",
  buttonWidthLarge: "22px",
  buttonWidthPressedSmall: "20px",
  buttonWidthPressedMedium: "24px",
  buttonWidthPressedLarge: "28px",
  railHeightSmall: "18px",
  railHeightMedium: "22px",
  railHeightLarge: "26px",
  railWidthSmall: "32px",
  railWidthMedium: "40px",
  railWidthLarge: "48px"
};
const self$4 = (vars) => {
  const { primaryColor, opacityDisabled, borderRadius, textColor3 } = vars;
  const railOverlayColor = "rgba(0, 0, 0, .14)";
  return Object.assign(Object.assign({}, commonVars), { iconColor: textColor3, textColor: "white", loadingColor: primaryColor, opacityDisabled, railColor: railOverlayColor, railColorActive: primaryColor, buttonBoxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)", buttonColor: "#FFF", railBorderRadiusSmall: borderRadius, railBorderRadiusMedium: borderRadius, railBorderRadiusLarge: borderRadius, buttonBorderRadiusSmall: borderRadius, buttonBorderRadiusMedium: borderRadius, buttonBorderRadiusLarge: borderRadius, boxShadowFocus: `0 0 0 2px ${changeColor(primaryColor, { alpha: 0.2 })}` });
};
const switchLight = {
  name: "Switch",
  common: commonLight,
  self: self$4
};
var switchLight$1 = switchLight;
var sizeVariables = {
  tabFontSizeSmall: "14px",
  tabFontSizeMedium: "14px",
  tabFontSizeLarge: "16px",
  tabGapSmallLine: "36px",
  tabGapMediumLine: "36px",
  tabGapLargeLine: "36px",
  tabGapSmallLineVertical: "8px",
  tabGapMediumLineVertical: "8px",
  tabGapLargeLineVertical: "8px",
  tabPaddingSmallLine: "6px 0",
  tabPaddingMediumLine: "10px 0",
  tabPaddingLargeLine: "14px 0",
  tabPaddingVerticalSmallLine: "6px 12px",
  tabPaddingVerticalMediumLine: "8px 16px",
  tabPaddingVerticalLargeLine: "10px 20px",
  tabGapSmallBar: "36px",
  tabGapMediumBar: "36px",
  tabGapLargeBar: "36px",
  tabGapSmallBarVertical: "8px",
  tabGapMediumBarVertical: "8px",
  tabGapLargeBarVertical: "8px",
  tabPaddingSmallBar: "4px 0",
  tabPaddingMediumBar: "6px 0",
  tabPaddingLargeBar: "10px 0",
  tabPaddingVerticalSmallBar: "6px 12px",
  tabPaddingVerticalMediumBar: "8px 16px",
  tabPaddingVerticalLargeBar: "10px 20px",
  tabGapSmallCard: "4px",
  tabGapMediumCard: "4px",
  tabGapLargeCard: "4px",
  tabGapSmallCardVertical: "4px",
  tabGapMediumCardVertical: "4px",
  tabGapLargeCardVertical: "4px",
  tabPaddingSmallCard: "8px 16px",
  tabPaddingMediumCard: "10px 20px",
  tabPaddingLargeCard: "12px 24px",
  tabPaddingSmallSegment: "4px 0",
  tabPaddingMediumSegment: "6px 0",
  tabPaddingLargeSegment: "8px 0",
  tabPaddingVerticalLargeSegment: "0 8px",
  tabPaddingVerticalSmallCard: "8px 12px",
  tabPaddingVerticalMediumCard: "10px 16px",
  tabPaddingVerticalLargeCard: "12px 20px",
  tabPaddingVerticalSmallSegment: "0 4px",
  tabPaddingVerticalMediumSegment: "0 6px",
  tabGapSmallSegment: "0",
  tabGapMediumSegment: "0",
  tabGapLargeSegment: "0",
  tabGapSmallSegmentVertical: "0",
  tabGapMediumSegmentVertical: "0",
  tabGapLargeSegmentVertical: "0",
  panePaddingSmall: "8px 0 0 0",
  panePaddingMedium: "12px 0 0 0",
  panePaddingLarge: "16px 0 0 0",
  closeSize: "18px",
  closeIconSize: "14px"
};
const self$3 = (vars) => {
  const { textColor2, primaryColor, textColorDisabled, closeIconColor, closeIconColorHover, closeIconColorPressed, closeColorHover, closeColorPressed, tabColor, baseColor, dividerColor, fontWeight, textColor1, borderRadius, fontSize: fontSize2, fontWeightStrong } = vars;
  return Object.assign(Object.assign({}, sizeVariables), {
    colorSegment: tabColor,
    tabFontSizeCard: fontSize2,
    tabTextColorLine: textColor1,
    tabTextColorActiveLine: primaryColor,
    tabTextColorHoverLine: primaryColor,
    tabTextColorDisabledLine: textColorDisabled,
    tabTextColorSegment: textColor1,
    tabTextColorActiveSegment: textColor2,
    tabTextColorHoverSegment: textColor2,
    tabTextColorDisabledSegment: textColorDisabled,
    tabTextColorBar: textColor1,
    tabTextColorActiveBar: primaryColor,
    tabTextColorHoverBar: primaryColor,
    tabTextColorDisabledBar: textColorDisabled,
    tabTextColorCard: textColor1,
    tabTextColorHoverCard: textColor1,
    tabTextColorActiveCard: primaryColor,
    tabTextColorDisabledCard: textColorDisabled,
    barColor: primaryColor,
    closeIconColor,
    closeIconColorHover,
    closeIconColorPressed,
    closeColorHover,
    closeColorPressed,
    closeBorderRadius: borderRadius,
    tabColor,
    tabColorSegment: baseColor,
    tabBorderColor: dividerColor,
    tabFontWeightActive: fontWeight,
    tabFontWeight: fontWeight,
    tabBorderRadius: borderRadius,
    paneTextColor: textColor2,
    fontWeightStrong
  });
};
const tabsLight = {
  name: "Tabs",
  common: commonLight,
  self: self$3
};
var tabsLight$1 = tabsLight;
const self$2 = (vars) => {
  const { iconColor, primaryColor, errorColor, textColor2, successColor, opacityDisabled, actionColor, borderColor, hoverColor, lineHeight: lineHeight2, borderRadius, fontSize: fontSize2 } = vars;
  return {
    fontSize: fontSize2,
    lineHeight: lineHeight2,
    borderRadius,
    draggerColor: actionColor,
    draggerBorder: `1px dashed ${borderColor}`,
    draggerBorderHover: `1px dashed ${primaryColor}`,
    itemColorHover: hoverColor,
    itemColorHoverError: changeColor(errorColor, {
      alpha: 0.06
    }),
    itemTextColor: textColor2,
    itemTextColorError: errorColor,
    itemTextColorSuccess: successColor,
    itemIconColor: iconColor,
    itemDisabledOpacity: opacityDisabled,
    itemBorderImageCardError: `1px solid ${errorColor}`,
    itemBorderImageCard: `1px solid ${borderColor}`
  };
};
const uploadLight = createTheme({
  name: "Upload",
  common: commonLight,
  peers: {
    Button: buttonLight$1,
    Progress: progressLight$1
  },
  self: self$2
});
var uploadLight$1 = uploadLight;
const prevIcon = h$1("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M6 5C5.75454 5 5.55039 5.17688 5.50806 5.41012L5.5 5.5V14.5C5.5 14.7761 5.72386 15 6 15C6.24546 15 6.44961 14.8231 6.49194 14.5899L6.5 14.5V5.5C6.5 5.22386 6.27614 5 6 5ZM13.8536 5.14645C13.68 4.97288 13.4106 4.9536 13.2157 5.08859L13.1464 5.14645L8.64645 9.64645C8.47288 9.82001 8.4536 10.0894 8.58859 10.2843L8.64645 10.3536L13.1464 14.8536C13.3417 15.0488 13.6583 15.0488 13.8536 14.8536C14.0271 14.68 14.0464 14.4106 13.9114 14.2157L13.8536 14.1464L9.70711 10L13.8536 5.85355C14.0488 5.65829 14.0488 5.34171 13.8536 5.14645Z", fill: "currentColor" }));
const nextIcon = h$1("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M13.5 5C13.7455 5 13.9496 5.17688 13.9919 5.41012L14 5.5V14.5C14 14.7761 13.7761 15 13.5 15C13.2545 15 13.0504 14.8231 13.0081 14.5899L13 14.5V5.5C13 5.22386 13.2239 5 13.5 5ZM5.64645 5.14645C5.82001 4.97288 6.08944 4.9536 6.28431 5.08859L6.35355 5.14645L10.8536 9.64645C11.0271 9.82001 11.0464 10.0894 10.9114 10.2843L10.8536 10.3536L6.35355 14.8536C6.15829 15.0488 5.84171 15.0488 5.64645 14.8536C5.47288 14.68 5.4536 14.4106 5.58859 14.2157L5.64645 14.1464L9.79289 10L5.64645 5.85355C5.45118 5.65829 5.45118 5.34171 5.64645 5.14645Z", fill: "currentColor" }));
const closeIcon = h$1("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h$1("path", { d: "M4.089 4.216l.057-.07a.5.5 0 0 1 .638-.057l.07.057L10 9.293l5.146-5.147a.5.5 0 0 1 .638-.057l.07.057a.5.5 0 0 1 .057.638l-.057.07L10.707 10l5.147 5.146a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.638.057l-.07-.057L10 10.707l-5.146 5.147a.5.5 0 0 1-.638.057l-.07-.057a.5.5 0 0 1-.057-.638l.057-.07L9.293 10L4.146 4.854a.5.5 0 0 1-.057-.638l.057-.07l-.057.07z", fill: "currentColor" }));
var style$b = c$2([c$2("body >", [cB$1("image-container", "position: fixed;")]), cB$1("image-preview-container", `
 position: fixed;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 display: flex;
 `), cB$1("image-preview-overlay", `
 z-index: -1;
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 background: rgba(0, 0, 0, .3);
 `, [fadeInTransition()]), cB$1("image-preview-toolbar", `
 z-index: 1;
 position: absolute;
 left: 50%;
 transform: translateX(-50%);
 border-radius: var(--n-toolbar-border-radius);
 height: 48px;
 bottom: 40px;
 padding: 0 12px;
 background: var(--n-toolbar-color);
 box-shadow: var(--n-toolbar-box-shadow);
 color: var(--n-toolbar-icon-color);
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 `, [cB$1("base-icon", `
 padding: 0 8px;
 font-size: 28px;
 cursor: pointer;
 `), fadeInTransition()]), cB$1("image-preview-wrapper", `
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 display: flex;
 pointer-events: none;
 `, [fadeInScaleUpTransition()]), cB$1("image-preview", `
 user-select: none;
 -webkit-user-select: none;
 pointer-events: all;
 margin: auto;
 max-height: calc(100vh - 32px);
 max-width: calc(100vw - 32px);
 transition: transform .3s var(--n-bezier);
 `), cB$1("image", `
 display: inline-flex;
 max-height: 100%;
 max-width: 100%;
 `, [cNotM("preview-disabled", `
 cursor: pointer;
 `), c$2("img", `
 border-radius: inherit;
 `)])]);
const BLEEDING = 32;
var NImagePreview = defineComponent({
  name: "ImagePreview",
  props: Object.assign(Object.assign({}, imagePreviewSharedProps), { onNext: Function, onPrev: Function, clsPrefix: {
    type: String,
    required: true
  } }),
  setup(props) {
    const themeRef = useTheme("Image", "-image", style$b, imageLight, props, toRef(props, "clsPrefix"));
    let thumbnailEl = null;
    const previewRef = ref(null);
    const previewWrapperRef = ref(null);
    const previewSrcRef = ref(void 0);
    const showRef = ref(false);
    const displayedRef = ref(false);
    const { localeRef } = useLocale("Image");
    function syncTransformOrigin() {
      const { value: previewWrapper } = previewWrapperRef;
      if (!thumbnailEl || !previewWrapper)
        return;
      const { style: style2 } = previewWrapper;
      const tbox = thumbnailEl.getBoundingClientRect();
      const tx2 = tbox.left + tbox.width / 2;
      const ty2 = tbox.top + tbox.height / 2;
      style2.transformOrigin = `${tx2}px ${ty2}px`;
    }
    function handleKeydown(e25) {
      var _a2, _b2;
      switch (e25.key) {
        case " ":
          e25.preventDefault();
          break;
        case "ArrowLeft":
          (_a2 = props.onPrev) === null || _a2 === void 0 ? void 0 : _a2.call(props);
          break;
        case "ArrowRight":
          (_b2 = props.onNext) === null || _b2 === void 0 ? void 0 : _b2.call(props);
          break;
        case "Escape":
          toggleShow();
          break;
      }
    }
    watch(showRef, (value2) => {
      if (value2) {
        on$1("keydown", document, handleKeydown);
      } else
        off("keydown", document, handleKeydown);
    });
    onBeforeUnmount(() => {
      off("keydown", document, handleKeydown);
    });
    let startX = 0;
    let startY = 0;
    let offsetX = 0;
    let offsetY = 0;
    let startOffsetX = 0;
    let startOffsetY = 0;
    let mouseDownClientX = 0;
    let mouseDownClientY = 0;
    let dragging = false;
    function handleMouseMove(e25) {
      const { clientX, clientY } = e25;
      offsetX = clientX - startX;
      offsetY = clientY - startY;
      beforeNextFrameOnce(derivePreviewStyle);
    }
    function getMoveStrategy(opts) {
      const { mouseUpClientX, mouseUpClientY, mouseDownClientX: mouseDownClientX2, mouseDownClientY: mouseDownClientY2 } = opts;
      const deltaHorizontal = mouseDownClientX2 - mouseUpClientX;
      const deltaVertical = mouseDownClientY2 - mouseUpClientY;
      const moveVerticalDirection = `vertical${deltaVertical > 0 ? "Top" : "Bottom"}`;
      const moveHorizontalDirection = `horizontal${deltaHorizontal > 0 ? "Left" : "Right"}`;
      return {
        moveVerticalDirection,
        moveHorizontalDirection,
        deltaHorizontal,
        deltaVertical
      };
    }
    function getDerivedOffset(moveStrategy) {
      const { value: preview } = previewRef;
      if (!preview)
        return { offsetX: 0, offsetY: 0 };
      const pbox = preview.getBoundingClientRect();
      const { moveVerticalDirection, moveHorizontalDirection, deltaHorizontal, deltaVertical } = moveStrategy || {};
      let nextOffsetX = 0;
      let nextOffsetY = 0;
      if (pbox.width <= window.innerWidth) {
        nextOffsetX = 0;
      } else if (pbox.left > 0) {
        nextOffsetX = (pbox.width - window.innerWidth) / 2;
      } else if (pbox.right < window.innerWidth) {
        nextOffsetX = -(pbox.width - window.innerWidth) / 2;
      } else if (moveHorizontalDirection === "horizontalRight") {
        nextOffsetX = Math.min((pbox.width - window.innerWidth) / 2, startOffsetX - (deltaHorizontal !== null && deltaHorizontal !== void 0 ? deltaHorizontal : 0));
      } else {
        nextOffsetX = Math.max(-((pbox.width - window.innerWidth) / 2), startOffsetX - (deltaHorizontal !== null && deltaHorizontal !== void 0 ? deltaHorizontal : 0));
      }
      if (pbox.height <= window.innerHeight) {
        nextOffsetY = 0;
      } else if (pbox.top > 0) {
        nextOffsetY = (pbox.height - window.innerHeight) / 2;
      } else if (pbox.bottom < window.innerHeight) {
        nextOffsetY = -(pbox.height - window.innerHeight) / 2;
      } else if (moveVerticalDirection === "verticalBottom") {
        nextOffsetY = Math.min((pbox.height - window.innerHeight) / 2, startOffsetY - (deltaVertical !== null && deltaVertical !== void 0 ? deltaVertical : 0));
      } else {
        nextOffsetY = Math.max(-((pbox.height - window.innerHeight) / 2), startOffsetY - (deltaVertical !== null && deltaVertical !== void 0 ? deltaVertical : 0));
      }
      return {
        offsetX: nextOffsetX,
        offsetY: nextOffsetY
      };
    }
    function handleMouseUp(e25) {
      off("mousemove", document, handleMouseMove);
      off("mouseup", document, handleMouseUp);
      const { clientX: mouseUpClientX, clientY: mouseUpClientY } = e25;
      dragging = false;
      const moveStrategy = getMoveStrategy({
        mouseUpClientX,
        mouseUpClientY,
        mouseDownClientX,
        mouseDownClientY
      });
      const offset = getDerivedOffset(moveStrategy);
      offsetX = offset.offsetX;
      offsetY = offset.offsetY;
      derivePreviewStyle();
    }
    const imageContext = inject(imageContextKey, null);
    function handlePreviewMousedown(e25) {
      var _a2, _b2;
      (_b2 = (_a2 = imageContext === null || imageContext === void 0 ? void 0 : imageContext.previewedImgPropsRef.value) === null || _a2 === void 0 ? void 0 : _a2.onMousedown) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, e25);
      if (e25.button !== 0)
        return;
      const { clientX, clientY } = e25;
      dragging = true;
      startX = clientX - offsetX;
      startY = clientY - offsetY;
      startOffsetX = offsetX;
      startOffsetY = offsetY;
      mouseDownClientX = clientX;
      mouseDownClientY = clientY;
      derivePreviewStyle();
      on$1("mousemove", document, handleMouseMove);
      on$1("mouseup", document, handleMouseUp);
    }
    function handlePreviewDblclick(e25) {
      var _a2, _b2;
      (_b2 = (_a2 = imageContext === null || imageContext === void 0 ? void 0 : imageContext.previewedImgPropsRef.value) === null || _a2 === void 0 ? void 0 : _a2.onDblclick) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, e25);
      const originalImageSizeScale = getOrignalImageSizeScale();
      scale = scale === originalImageSizeScale ? 1 : originalImageSizeScale;
      derivePreviewStyle();
    }
    const scaleRadix = 1.5;
    let scaleExp = 0;
    let scale = 1;
    let rotate = 0;
    function resetScale() {
      scale = 1;
      scaleExp = 0;
    }
    function handleSwitchPrev() {
      var _a2;
      resetScale();
      rotate = 0;
      (_a2 = props.onPrev) === null || _a2 === void 0 ? void 0 : _a2.call(props);
    }
    function handleSwitchNext() {
      var _a2;
      resetScale();
      rotate = 0;
      (_a2 = props.onNext) === null || _a2 === void 0 ? void 0 : _a2.call(props);
    }
    function rotateCounterclockwise() {
      rotate -= 90;
      derivePreviewStyle();
    }
    function rotateClockwise() {
      rotate += 90;
      derivePreviewStyle();
    }
    function getMaxScale() {
      const { value: preview } = previewRef;
      if (!preview)
        return 1;
      const { innerWidth, innerHeight: innerHeight2 } = window;
      const heightMaxScale = Math.max(1, preview.naturalHeight / (innerHeight2 - BLEEDING));
      const widthMaxScale = Math.max(1, preview.naturalWidth / (innerWidth - BLEEDING));
      return Math.max(3, heightMaxScale * 2, widthMaxScale * 2);
    }
    function getOrignalImageSizeScale() {
      const { value: preview } = previewRef;
      if (!preview)
        return 1;
      const { innerWidth, innerHeight: innerHeight2 } = window;
      const heightScale = preview.naturalHeight / (innerHeight2 - BLEEDING);
      const widthScale = preview.naturalWidth / (innerWidth - BLEEDING);
      if (heightScale < 1 && widthScale < 1) {
        return 1;
      }
      return Math.max(heightScale, widthScale);
    }
    function zoomIn() {
      const maxScale = getMaxScale();
      if (scale < maxScale) {
        scaleExp += 1;
        scale = Math.min(maxScale, Math.pow(scaleRadix, scaleExp));
        derivePreviewStyle();
      }
    }
    function zoomOut() {
      if (scale > 0.5) {
        const originalScale = scale;
        scaleExp -= 1;
        scale = Math.max(0.5, Math.pow(scaleRadix, scaleExp));
        const diff = originalScale - scale;
        derivePreviewStyle(false);
        const offset = getDerivedOffset();
        scale += diff;
        derivePreviewStyle(false);
        scale -= diff;
        offsetX = offset.offsetX;
        offsetY = offset.offsetY;
        derivePreviewStyle();
      }
    }
    function derivePreviewStyle(transition = true) {
      var _a2;
      const { value: preview } = previewRef;
      if (!preview)
        return;
      const { style: style2 } = preview;
      const controlledStyle = normalizeStyle((_a2 = imageContext === null || imageContext === void 0 ? void 0 : imageContext.previewedImgPropsRef.value) === null || _a2 === void 0 ? void 0 : _a2.style);
      let controlledStyleString = "";
      if (typeof controlledStyle === "string") {
        controlledStyleString = controlledStyle + ";";
      } else {
        for (const key in controlledStyle) {
          controlledStyleString += `${kebabCase$1(key)}: ${controlledStyle[key]};`;
        }
      }
      const transformStyle = `transform-origin: center; transform: translateX(${offsetX}px) translateY(${offsetY}px) rotate(${rotate}deg) scale(${scale});`;
      if (dragging) {
        style2.cssText = controlledStyleString + "cursor: grabbing; transition: none;" + transformStyle;
      } else {
        style2.cssText = controlledStyleString + "cursor: grab;" + transformStyle + (transition ? "" : "transition: none;");
      }
      if (!transition) {
        void preview.offsetHeight;
      }
    }
    function toggleShow() {
      showRef.value = !showRef.value;
      displayedRef.value = true;
    }
    function resizeToOrignalImageSize() {
      scale = getOrignalImageSizeScale();
      scaleExp = Math.ceil(Math.log(scale) / Math.log(scaleRadix));
      offsetX = 0;
      offsetY = 0;
      derivePreviewStyle();
    }
    const exposedMethods = {
      setPreviewSrc: (src) => {
        previewSrcRef.value = src;
      },
      setThumbnailEl: (el2) => {
        thumbnailEl = el2;
      },
      toggleShow
    };
    function withTooltip(node2, tooltipKey) {
      if (props.showToolbarTooltip) {
        const { value: theme2 } = themeRef;
        return h$1(NTooltip, { to: false, theme: theme2.peers.Tooltip, themeOverrides: theme2.peerOverrides.Tooltip, keepAliveOnHover: false }, {
          default: () => {
            return localeRef.value[tooltipKey];
          },
          trigger: () => node2
        });
      } else {
        return node2;
      }
    }
    const cssVarsRef = computed(() => {
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { toolbarIconColor, toolbarBorderRadius, toolbarBoxShadow, toolbarColor } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-toolbar-icon-color": toolbarIconColor,
        "--n-toolbar-color": toolbarColor,
        "--n-toolbar-border-radius": toolbarBorderRadius,
        "--n-toolbar-box-shadow": toolbarBoxShadow
      };
    });
    const { inlineThemeDisabled } = useConfig();
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("image-preview", void 0, cssVarsRef, props) : void 0;
    return Object.assign({
      previewRef,
      previewWrapperRef,
      previewSrc: previewSrcRef,
      show: showRef,
      appear: isMounted(),
      displayed: displayedRef,
      previewedImgProps: imageContext === null || imageContext === void 0 ? void 0 : imageContext.previewedImgPropsRef,
      handleWheel(e25) {
        e25.preventDefault();
      },
      handlePreviewMousedown,
      handlePreviewDblclick,
      syncTransformOrigin,
      handleAfterLeave: () => {
        resetScale();
        rotate = 0;
        displayedRef.value = false;
      },
      handleDragStart: (e25) => {
        var _a2, _b2;
        (_b2 = (_a2 = imageContext === null || imageContext === void 0 ? void 0 : imageContext.previewedImgPropsRef.value) === null || _a2 === void 0 ? void 0 : _a2.onDragstart) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, e25);
        e25.preventDefault();
      },
      zoomIn,
      zoomOut,
      rotateCounterclockwise,
      rotateClockwise,
      handleSwitchPrev,
      handleSwitchNext,
      withTooltip,
      resizeToOrignalImageSize,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    }, exposedMethods);
  },
  render() {
    var _a2, _b2;
    const { clsPrefix } = this;
    return h$1(Fragment, null, (_b2 = (_a2 = this.$slots).default) === null || _b2 === void 0 ? void 0 : _b2.call(_a2), h$1(LazyTeleport, { show: this.show }, {
      default: () => {
        var _a3;
        if (!(this.show || this.displayed)) {
          return null;
        }
        (_a3 = this.onRender) === null || _a3 === void 0 ? void 0 : _a3.call(this);
        return withDirectives(h$1("div", { class: [
          `${clsPrefix}-image-preview-container`,
          this.themeClass
        ], style: this.cssVars, onWheel: this.handleWheel }, h$1(Transition, { name: "fade-in-transition", appear: this.appear }, {
          default: () => this.show ? h$1("div", { class: `${clsPrefix}-image-preview-overlay`, onClick: this.toggleShow }) : null
        }), this.showToolbar ? h$1(Transition, { name: "fade-in-transition", appear: this.appear }, {
          default: () => {
            if (!this.show)
              return null;
            const { withTooltip } = this;
            return h$1("div", { class: `${clsPrefix}-image-preview-toolbar` }, this.onPrev ? h$1(Fragment, null, withTooltip(h$1(NBaseIcon, { clsPrefix, onClick: this.handleSwitchPrev }, { default: () => prevIcon }), "tipPrevious"), withTooltip(h$1(NBaseIcon, { clsPrefix, onClick: this.handleSwitchNext }, { default: () => nextIcon }), "tipNext")) : null, withTooltip(h$1(NBaseIcon, { clsPrefix, onClick: this.rotateCounterclockwise }, {
              default: () => h$1(RotateCounterclockwiseIcon, null)
            }), "tipCounterclockwise"), withTooltip(h$1(NBaseIcon, { clsPrefix, onClick: this.rotateClockwise }, {
              default: () => h$1(RotateClockwiseIcon, null)
            }), "tipClockwise"), withTooltip(h$1(NBaseIcon, { clsPrefix, onClick: this.resizeToOrignalImageSize }, {
              default: () => {
                return h$1(ResizeSmallIcon, null);
              }
            }), "tipOriginalSize"), withTooltip(h$1(NBaseIcon, { clsPrefix, onClick: this.zoomOut }, { default: () => h$1(ZoomOutIcon, null) }), "tipZoomOut"), withTooltip(h$1(NBaseIcon, { clsPrefix, onClick: this.zoomIn }, { default: () => h$1(ZoomInIcon, null) }), "tipZoomIn"), withTooltip(h$1(NBaseIcon, { clsPrefix, onClick: this.toggleShow }, { default: () => closeIcon }), "tipClose"));
          }
        }) : null, h$1(Transition, {
          name: "fade-in-scale-up-transition",
          onAfterLeave: this.handleAfterLeave,
          appear: this.appear,
          onEnter: this.syncTransformOrigin,
          onBeforeLeave: this.syncTransformOrigin
        }, {
          default: () => {
            const { previewedImgProps = {} } = this;
            return withDirectives(h$1("div", { class: `${clsPrefix}-image-preview-wrapper`, ref: "previewWrapperRef" }, h$1("img", Object.assign({}, previewedImgProps, { draggable: false, onMousedown: this.handlePreviewMousedown, onDblclick: this.handlePreviewDblclick, class: [
              `${clsPrefix}-image-preview`,
              previewedImgProps.class
            ], key: this.previewSrc, src: this.previewSrc, ref: "previewRef", onDragstart: this.handleDragStart }))), [[vShow, this.show]]);
          }
        })), [[zindexable$1, { enabled: this.show }]]);
      }
    }));
  }
});
const imageGroupInjectionKey = createInjectionKey("n-image-group");
const imageGroupProps = imagePreviewSharedProps;
var NImageGroup = defineComponent({
  name: "ImageGroup",
  props: imageGroupProps,
  setup(props) {
    let currentSrc;
    const { mergedClsPrefixRef } = useConfig(props);
    const groupId = `c${createId()}`;
    const vm2 = getCurrentInstance();
    const setPreviewSrc = (src) => {
      var _a2;
      currentSrc = src;
      (_a2 = previewInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.setPreviewSrc(src);
    };
    function go2(step) {
      if (!(vm2 === null || vm2 === void 0 ? void 0 : vm2.proxy))
        return;
      const container = vm2.proxy.$el.parentElement;
      const imgs = container.querySelectorAll(`[data-group-id=${groupId}]:not([data-error=true])`);
      if (!imgs.length)
        return;
      const index2 = Array.from(imgs).findIndex((img) => img.dataset.previewSrc === currentSrc);
      if (~index2) {
        setPreviewSrc(imgs[(index2 + step + imgs.length) % imgs.length].dataset.previewSrc);
      } else {
        setPreviewSrc(imgs[0].dataset.previewSrc);
      }
    }
    provide(imageGroupInjectionKey, {
      mergedClsPrefixRef,
      setPreviewSrc,
      setThumbnailEl: (el2) => {
        var _a2;
        (_a2 = previewInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.setThumbnailEl(el2);
      },
      toggleShow: () => {
        var _a2;
        (_a2 = previewInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.toggleShow();
      },
      groupId
    });
    const previewInstRef = ref(null);
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      previewInstRef,
      next: () => {
        go2(1);
      },
      prev: () => {
        go2(-1);
      }
    };
  },
  render() {
    return h$1(NImagePreview, { theme: this.theme, themeOverrides: this.themeOverrides, clsPrefix: this.mergedClsPrefix, ref: "previewInstRef", onPrev: this.prev, onNext: this.next, showToolbar: this.showToolbar, showToolbarTooltip: this.showToolbarTooltip }, this.$slots);
  }
});
const imageProps = Object.assign({ alt: String, height: [String, Number], imgProps: Object, previewedImgProps: Object, lazy: Boolean, intersectionObserverOptions: Object, objectFit: {
  type: String,
  default: "fill"
}, previewSrc: String, fallbackSrc: String, width: [String, Number], src: String, previewDisabled: Boolean, loadDescription: String, onError: Function, onLoad: Function }, imagePreviewSharedProps);
var NImage = defineComponent({
  name: "Image",
  props: imageProps,
  inheritAttrs: false,
  setup(props) {
    const imageRef = ref(null);
    const showErrorRef = ref(false);
    const previewInstRef = ref(null);
    const imageGroupHandle = inject(imageGroupInjectionKey, null);
    const { mergedClsPrefixRef } = imageGroupHandle || useConfig(props);
    const exposedMethods = {
      click: () => {
        if (props.previewDisabled || showErrorRef.value)
          return;
        const mergedPreviewSrc = props.previewSrc || props.src;
        if (imageGroupHandle) {
          imageGroupHandle.setPreviewSrc(mergedPreviewSrc);
          imageGroupHandle.setThumbnailEl(imageRef.value);
          imageGroupHandle.toggleShow();
          return;
        }
        const { value: previewInst } = previewInstRef;
        if (!previewInst)
          return;
        previewInst.setPreviewSrc(mergedPreviewSrc);
        previewInst.setThumbnailEl(imageRef.value);
        previewInst.toggleShow();
      }
    };
    const shouldStartLoadingRef = ref(!props.lazy);
    onMounted(() => {
      var _a2;
      (_a2 = imageRef.value) === null || _a2 === void 0 ? void 0 : _a2.setAttribute("data-group-id", (imageGroupHandle === null || imageGroupHandle === void 0 ? void 0 : imageGroupHandle.groupId) || "");
    });
    onMounted(() => {
      if (props.lazy && props.intersectionObserverOptions) {
        let unobserve;
        const stopWatchHandle = watchEffect(() => {
          unobserve === null || unobserve === void 0 ? void 0 : unobserve();
          unobserve = void 0;
          unobserve = observeIntersection(imageRef.value, props.intersectionObserverOptions, shouldStartLoadingRef);
        });
        onBeforeUnmount(() => {
          stopWatchHandle();
          unobserve === null || unobserve === void 0 ? void 0 : unobserve();
        });
      }
    });
    watchEffect(() => {
      var _a2;
      void props.src;
      void ((_a2 = props.imgProps) === null || _a2 === void 0 ? void 0 : _a2.src);
      showErrorRef.value = false;
    });
    const loadedRef = ref(false);
    provide(imageContextKey, {
      previewedImgPropsRef: toRef(props, "previewedImgProps")
    });
    return Object.assign({
      mergedClsPrefix: mergedClsPrefixRef,
      groupId: imageGroupHandle === null || imageGroupHandle === void 0 ? void 0 : imageGroupHandle.groupId,
      previewInstRef,
      imageRef,
      showError: showErrorRef,
      shouldStartLoading: shouldStartLoadingRef,
      loaded: loadedRef,
      mergedOnClick: (e25) => {
        var _a2, _b2;
        exposedMethods.click();
        (_b2 = (_a2 = props.imgProps) === null || _a2 === void 0 ? void 0 : _a2.onClick) === null || _b2 === void 0 ? void 0 : _b2.call(_a2, e25);
      },
      mergedOnError: (e25) => {
        if (!shouldStartLoadingRef.value)
          return;
        showErrorRef.value = true;
        const { onError, imgProps: { onError: imgPropsOnError } = {} } = props;
        onError === null || onError === void 0 ? void 0 : onError(e25);
        imgPropsOnError === null || imgPropsOnError === void 0 ? void 0 : imgPropsOnError(e25);
      },
      mergedOnLoad: (e25) => {
        const { onLoad, imgProps: { onLoad: imgPropsOnLoad } = {} } = props;
        onLoad === null || onLoad === void 0 ? void 0 : onLoad(e25);
        imgPropsOnLoad === null || imgPropsOnLoad === void 0 ? void 0 : imgPropsOnLoad(e25);
        loadedRef.value = true;
      }
    }, exposedMethods);
  },
  render() {
    var _a2, _b2;
    const { mergedClsPrefix, imgProps = {}, loaded, $attrs, lazy } = this;
    const placeholderNode = (_b2 = (_a2 = this.$slots).placeholder) === null || _b2 === void 0 ? void 0 : _b2.call(_a2);
    const loadSrc = this.src || imgProps.src;
    const imgNode = h$1("img", Object.assign(Object.assign({}, imgProps), {
      ref: "imageRef",
      width: this.width || imgProps.width,
      height: this.height || imgProps.height,
      src: this.showError ? this.fallbackSrc : lazy && this.intersectionObserverOptions ? this.shouldStartLoading ? loadSrc : void 0 : loadSrc,
      alt: this.alt || imgProps.alt,
      "aria-label": this.alt || imgProps.alt,
      onClick: this.mergedOnClick,
      onError: this.mergedOnError,
      onLoad: this.mergedOnLoad,
      loading: isImageSupportNativeLazy && lazy && !this.intersectionObserverOptions ? "lazy" : "eager",
      style: [
        imgProps.style || "",
        placeholderNode && !loaded ? { height: "0", width: "0", visibility: "hidden" } : "",
        { objectFit: this.objectFit }
      ],
      "data-error": this.showError,
      "data-preview-src": this.previewSrc || this.src
    }));
    return h$1("div", Object.assign({}, $attrs, { role: "none", class: [
      $attrs.class,
      `${mergedClsPrefix}-image`,
      (this.previewDisabled || this.showError) && `${mergedClsPrefix}-image--preview-disabled`
    ] }), this.groupId ? imgNode : h$1(NImagePreview, { theme: this.theme, themeOverrides: this.themeOverrides, clsPrefix: mergedClsPrefix, ref: "previewInstRef", showToolbar: this.showToolbar, showToolbarTooltip: this.showToolbarTooltip }, {
      default: () => imgNode
    }), !loaded && placeholderNode);
  }
});
function parse$I(value2) {
  if (value2 === void 0 || value2 === null || typeof value2 === "string" && value2.trim() === "") {
    return null;
  }
  return Number(value2);
}
function isWipValue(value2) {
  return value2.includes(".") && (/^(-)?\d+.*(\.|0)$/.test(value2) || /^\.\d+$/.test(value2));
}
function validator(value2) {
  if (value2 === void 0 || value2 === null)
    return true;
  if (Number.isNaN(value2))
    return false;
  return true;
}
function format(value2, precision) {
  if (value2 === void 0 || value2 === null)
    return "";
  return precision === void 0 ? String(value2) : value2.toFixed(precision);
}
function parseNumber(number4) {
  if (number4 === null)
    return null;
  if (typeof number4 === "number") {
    return number4;
  } else {
    const parsedNumber = Number(number4);
    if (Number.isNaN(parsedNumber))
      return null;
    else {
      return parsedNumber;
    }
  }
}
var style$a = c$2([cB$1("input-number-suffix", `
 display: inline-block;
 margin-right: 10px;
 `), cB$1("input-number-prefix", `
 display: inline-block;
 margin-left: 10px;
 `)]);
const HOLDING_CHANGE_THRESHOLD = 800;
const HOLDING_CHANGE_INTERVAL = 100;
const inputNumberProps = Object.assign(Object.assign({}, useTheme.props), {
  autofocus: Boolean,
  loading: {
    type: Boolean,
    default: void 0
  },
  placeholder: String,
  defaultValue: {
    type: Number,
    default: null
  },
  value: Number,
  step: {
    type: [Number, String],
    default: 1
  },
  min: [Number, String],
  max: [Number, String],
  size: String,
  disabled: {
    type: Boolean,
    default: void 0
  },
  validator: Function,
  bordered: {
    type: Boolean,
    default: void 0
  },
  showButton: {
    type: Boolean,
    default: true
  },
  buttonPlacement: {
    type: String,
    default: "right"
  },
  readonly: Boolean,
  clearable: Boolean,
  keyboard: {
    type: Object,
    default: {}
  },
  updateValueOnInput: {
    type: Boolean,
    default: true
  },
  parse: Function,
  format: Function,
  precision: Number,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onFocus: [Function, Array],
  onBlur: [Function, Array],
  onClear: [Function, Array],
  onChange: [Function, Array]
});
var NInputNumber = defineComponent({
  name: "InputNumber",
  props: inputNumberProps,
  setup(props) {
    const { mergedBorderedRef, mergedClsPrefixRef, mergedRtlRef } = useConfig(props);
    const themeRef = useTheme("InputNumber", "-input-number", style$a, inputNumberLight$1, props, mergedClsPrefixRef);
    const { localeRef } = useLocale("InputNumber");
    const formItem = useFormItem(props);
    const { mergedSizeRef, mergedDisabledRef, mergedStatusRef } = formItem;
    const inputInstRef = ref(null);
    const minusButtonInstRef = ref(null);
    const addButtonInstRef = ref(null);
    const uncontrolledValueRef = ref(props.defaultValue);
    const controlledValueRef = toRef(props, "value");
    const mergedValueRef = useMergedState(controlledValueRef, uncontrolledValueRef);
    const displayedValueRef = ref("");
    const getPrecision = (value2) => {
      const fraction = String(value2).split(".")[1];
      return fraction ? fraction.length : 0;
    };
    const getMaxPrecision = (currentValue) => {
      const precisions = [props.min, props.max, props.step, currentValue].map((value2) => {
        if (value2 === void 0)
          return 0;
        return getPrecision(value2);
      });
      return Math.max(...precisions);
    };
    const mergedPlaceholderRef = useMemo(() => {
      const { placeholder } = props;
      if (placeholder !== void 0)
        return placeholder;
      return localeRef.value.placeholder;
    });
    const mergedStepRef = useMemo(() => {
      const parsedNumber = parseNumber(props.step);
      if (parsedNumber !== null) {
        return parsedNumber === 0 ? 1 : Math.abs(parsedNumber);
      }
      return 1;
    });
    const mergedMinRef = useMemo(() => {
      const parsedNumber = parseNumber(props.min);
      if (parsedNumber !== null)
        return parsedNumber;
      else
        return null;
    });
    const mergedMaxRef = useMemo(() => {
      const parsedNumber = parseNumber(props.max);
      if (parsedNumber !== null)
        return parsedNumber;
      else
        return null;
    });
    const doUpdateValue = (value2) => {
      const { value: mergedValue } = mergedValueRef;
      if (value2 === mergedValue) {
        deriveDisplayedValueFromValue();
        return;
      }
      const { "onUpdate:value": _onUpdateValue, onUpdateValue, onChange } = props;
      const { nTriggerFormInput, nTriggerFormChange } = formItem;
      if (onChange)
        call(onChange, value2);
      if (onUpdateValue)
        call(onUpdateValue, value2);
      if (_onUpdateValue)
        call(_onUpdateValue, value2);
      uncontrolledValueRef.value = value2;
      nTriggerFormInput();
      nTriggerFormChange();
    };
    const deriveValueFromDisplayedValue = ({ offset, doUpdateIfValid, fixPrecision, isInputing }) => {
      const { value: displayedValue } = displayedValueRef;
      if (isInputing && isWipValue(displayedValue)) {
        return false;
      }
      const parsedValue = (props.parse || parse$I)(displayedValue);
      if (parsedValue === null) {
        if (doUpdateIfValid)
          doUpdateValue(null);
        return null;
      }
      if (validator(parsedValue)) {
        const currentPrecision = getPrecision(parsedValue);
        const { precision } = props;
        if (precision !== void 0 && precision < currentPrecision && !fixPrecision) {
          return false;
        }
        let nextValue = parseFloat((parsedValue + offset).toFixed(precision !== null && precision !== void 0 ? precision : getMaxPrecision(parsedValue)));
        if (validator(nextValue)) {
          const { value: mergedMax } = mergedMaxRef;
          const { value: mergedMin } = mergedMinRef;
          if (mergedMax !== null && nextValue > mergedMax) {
            if (!doUpdateIfValid || isInputing)
              return false;
            nextValue = mergedMax;
          }
          if (mergedMin !== null && nextValue < mergedMin) {
            if (!doUpdateIfValid || isInputing)
              return false;
            nextValue = mergedMin;
          }
          if (props.validator && !props.validator(nextValue))
            return false;
          if (doUpdateIfValid)
            doUpdateValue(nextValue);
          return nextValue;
        }
      }
      return false;
    };
    const deriveDisplayedValueFromValue = () => {
      const { value: mergedValue } = mergedValueRef;
      if (validator(mergedValue)) {
        const { format: formatProp, precision } = props;
        if (formatProp) {
          displayedValueRef.value = formatProp(mergedValue);
        } else {
          if (mergedValue === null || precision === void 0 || getPrecision(mergedValue) > precision) {
            displayedValueRef.value = format(mergedValue, void 0);
          } else {
            displayedValueRef.value = format(mergedValue, precision);
          }
        }
      } else {
        displayedValueRef.value = String(mergedValue);
      }
    };
    deriveDisplayedValueFromValue();
    const displayedValueInvalidRef = useMemo(() => {
      const derivedValue = deriveValueFromDisplayedValue({
        offset: 0,
        doUpdateIfValid: false,
        isInputing: false,
        fixPrecision: false
      });
      return derivedValue === false;
    });
    const minusableRef = useMemo(() => {
      const { value: mergedValue } = mergedValueRef;
      if (props.validator && mergedValue === null) {
        return false;
      }
      const { value: mergedStep } = mergedStepRef;
      const derivedNextValue = deriveValueFromDisplayedValue({
        offset: -mergedStep,
        doUpdateIfValid: false,
        isInputing: false,
        fixPrecision: false
      });
      return derivedNextValue !== false;
    });
    const addableRef = useMemo(() => {
      const { value: mergedValue } = mergedValueRef;
      if (props.validator && mergedValue === null) {
        return false;
      }
      const { value: mergedStep } = mergedStepRef;
      const derivedNextValue = deriveValueFromDisplayedValue({
        offset: +mergedStep,
        doUpdateIfValid: false,
        isInputing: false,
        fixPrecision: false
      });
      return derivedNextValue !== false;
    });
    function doFocus(e25) {
      const { onFocus } = props;
      const { nTriggerFormFocus } = formItem;
      if (onFocus)
        call(onFocus, e25);
      nTriggerFormFocus();
    }
    function doBlur(e25) {
      var _a2, _b2;
      if (e25.target === ((_a2 = inputInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.wrapperElRef)) {
        return;
      }
      const value2 = deriveValueFromDisplayedValue({
        offset: 0,
        doUpdateIfValid: true,
        isInputing: false,
        fixPrecision: true
      });
      if (value2 !== false) {
        const inputElRef = (_b2 = inputInstRef.value) === null || _b2 === void 0 ? void 0 : _b2.inputElRef;
        if (inputElRef) {
          inputElRef.value = String(value2 || "");
        }
        if (mergedValueRef.value === value2) {
          deriveDisplayedValueFromValue();
        }
      } else {
        deriveDisplayedValueFromValue();
      }
      const { onBlur } = props;
      const { nTriggerFormBlur } = formItem;
      if (onBlur)
        call(onBlur, e25);
      nTriggerFormBlur();
      void nextTick(() => {
        deriveDisplayedValueFromValue();
      });
    }
    function doClear(e25) {
      const { onClear } = props;
      if (onClear)
        call(onClear, e25);
    }
    function doAdd() {
      const { value: addable } = addableRef;
      if (!addable) {
        clearAddHoldTimeout();
        return;
      }
      const { value: mergedValue } = mergedValueRef;
      if (mergedValue === null) {
        if (!props.validator) {
          doUpdateValue(createValidValue());
        }
      } else {
        const { value: mergedStep } = mergedStepRef;
        deriveValueFromDisplayedValue({
          offset: mergedStep,
          doUpdateIfValid: true,
          isInputing: false,
          fixPrecision: true
        });
      }
    }
    function doMinus() {
      const { value: minusable } = minusableRef;
      if (!minusable) {
        clearMinusHoldTimeout();
        return;
      }
      const { value: mergedValue } = mergedValueRef;
      if (mergedValue === null) {
        if (!props.validator) {
          doUpdateValue(createValidValue());
        }
      } else {
        const { value: mergedStep } = mergedStepRef;
        deriveValueFromDisplayedValue({
          offset: -mergedStep,
          doUpdateIfValid: true,
          isInputing: false,
          fixPrecision: true
        });
      }
    }
    const handleFocus = doFocus;
    const handleBlur = doBlur;
    function createValidValue() {
      if (props.validator)
        return null;
      const { value: mergedMin } = mergedMinRef;
      const { value: mergedMax } = mergedMaxRef;
      if (mergedMin !== null) {
        return Math.max(0, mergedMin);
      } else if (mergedMax !== null) {
        return Math.min(0, mergedMax);
      } else {
        return 0;
      }
    }
    function handleClear(e25) {
      doClear(e25);
      doUpdateValue(null);
    }
    function handleMouseDown(e25) {
      var _a2, _b2, _c2;
      if ((_a2 = addButtonInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.$el.contains(e25.target)) {
        e25.preventDefault();
      }
      if ((_b2 = minusButtonInstRef.value) === null || _b2 === void 0 ? void 0 : _b2.$el.contains(e25.target)) {
        e25.preventDefault();
      }
      (_c2 = inputInstRef.value) === null || _c2 === void 0 ? void 0 : _c2.activate();
    }
    let minusHoldStateIntervalId = null;
    let addHoldStateIntervalId = null;
    let firstMinusMousedownId = null;
    function clearMinusHoldTimeout() {
      if (firstMinusMousedownId) {
        window.clearTimeout(firstMinusMousedownId);
        firstMinusMousedownId = null;
      }
      if (minusHoldStateIntervalId) {
        window.clearInterval(minusHoldStateIntervalId);
        minusHoldStateIntervalId = null;
      }
    }
    function clearAddHoldTimeout() {
      if (firstAddMousedownId) {
        window.clearTimeout(firstAddMousedownId);
        firstAddMousedownId = null;
      }
      if (addHoldStateIntervalId) {
        window.clearInterval(addHoldStateIntervalId);
        addHoldStateIntervalId = null;
      }
    }
    function handleMinusMousedown() {
      clearMinusHoldTimeout();
      firstMinusMousedownId = window.setTimeout(() => {
        minusHoldStateIntervalId = window.setInterval(() => {
          doMinus();
        }, HOLDING_CHANGE_INTERVAL);
      }, HOLDING_CHANGE_THRESHOLD);
      on$1("mouseup", document, clearMinusHoldTimeout, {
        once: true
      });
    }
    let firstAddMousedownId = null;
    function handleAddMousedown() {
      clearAddHoldTimeout();
      firstAddMousedownId = window.setTimeout(() => {
        addHoldStateIntervalId = window.setInterval(() => {
          doAdd();
        }, HOLDING_CHANGE_INTERVAL);
      }, HOLDING_CHANGE_THRESHOLD);
      on$1("mouseup", document, clearAddHoldTimeout, {
        once: true
      });
    }
    const handleAddClick = () => {
      if (addHoldStateIntervalId)
        return;
      doAdd();
    };
    const handleMinusClick = () => {
      if (minusHoldStateIntervalId)
        return;
      doMinus();
    };
    function handleKeyDown(e25) {
      var _a2, _b2;
      if (e25.key === "Enter") {
        if (e25.target === ((_a2 = inputInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.wrapperElRef)) {
          return;
        }
        const value2 = deriveValueFromDisplayedValue({
          offset: 0,
          doUpdateIfValid: true,
          isInputing: false,
          fixPrecision: true
        });
        if (value2 !== false) {
          (_b2 = inputInstRef.value) === null || _b2 === void 0 ? void 0 : _b2.deactivate();
        }
      } else if (e25.key === "ArrowUp") {
        if (!addableRef.value)
          return;
        if (props.keyboard.ArrowUp === false)
          return;
        e25.preventDefault();
        const value2 = deriveValueFromDisplayedValue({
          offset: 0,
          doUpdateIfValid: true,
          isInputing: false,
          fixPrecision: true
        });
        if (value2 !== false) {
          doAdd();
        }
      } else if (e25.key === "ArrowDown") {
        if (!minusableRef.value)
          return;
        if (props.keyboard.ArrowDown === false)
          return;
        e25.preventDefault();
        const value2 = deriveValueFromDisplayedValue({
          offset: 0,
          doUpdateIfValid: true,
          isInputing: false,
          fixPrecision: true
        });
        if (value2 !== false) {
          doMinus();
        }
      }
    }
    function handleUpdateDisplayedValue(value2) {
      displayedValueRef.value = value2;
      if (props.updateValueOnInput && !props.format && !props.parse && props.precision === void 0) {
        deriveValueFromDisplayedValue({
          offset: 0,
          doUpdateIfValid: true,
          isInputing: true,
          fixPrecision: false
        });
      }
    }
    watch(mergedValueRef, () => {
      deriveDisplayedValueFromValue();
    });
    const exposedMethods = {
      focus: () => {
        var _a2;
        return (_a2 = inputInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
      },
      blur: () => {
        var _a2;
        return (_a2 = inputInstRef.value) === null || _a2 === void 0 ? void 0 : _a2.blur();
      }
    };
    const rtlEnabledRef = useRtl("InputNumber", mergedRtlRef, mergedClsPrefixRef);
    return Object.assign(Object.assign({}, exposedMethods), {
      rtlEnabled: rtlEnabledRef,
      inputInstRef,
      minusButtonInstRef,
      addButtonInstRef,
      mergedClsPrefix: mergedClsPrefixRef,
      mergedBordered: mergedBorderedRef,
      uncontrolledValue: uncontrolledValueRef,
      mergedValue: mergedValueRef,
      mergedPlaceholder: mergedPlaceholderRef,
      displayedValueInvalid: displayedValueInvalidRef,
      mergedSize: mergedSizeRef,
      mergedDisabled: mergedDisabledRef,
      displayedValue: displayedValueRef,
      addable: addableRef,
      minusable: minusableRef,
      mergedStatus: mergedStatusRef,
      handleFocus,
      handleBlur,
      handleClear,
      handleMouseDown,
      handleAddClick,
      handleMinusClick,
      handleAddMousedown,
      handleMinusMousedown,
      handleKeyDown,
      handleUpdateDisplayedValue,
      mergedTheme: themeRef,
      inputThemeOverrides: {
        paddingSmall: "0 8px 0 10px",
        paddingMedium: "0 8px 0 12px",
        paddingLarge: "0 8px 0 14px"
      },
      buttonThemeOverrides: computed(() => {
        const { self: { iconColorDisabled } } = themeRef.value;
        const [r2, g2, b2, a2] = rgba(iconColorDisabled);
        return {
          textColorTextDisabled: `rgb(${r2}, ${g2}, ${b2})`,
          opacityDisabled: `${a2}`
        };
      })
    });
  },
  render() {
    const { mergedClsPrefix, $slots } = this;
    const renderMinusButton = () => {
      return h$1(XButton, { text: true, disabled: !this.minusable || this.mergedDisabled || this.readonly, focusable: false, theme: this.mergedTheme.peers.Button, themeOverrides: this.mergedTheme.peerOverrides.Button, builtinThemeOverrides: this.buttonThemeOverrides, onClick: this.handleMinusClick, onMousedown: this.handleMinusMousedown, ref: "minusButtonInstRef" }, {
        icon: () => resolveSlot($slots["minus-icon"], () => [
          h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, {
            default: () => h$1(RemoveIcon, null)
          })
        ])
      });
    };
    const renderAddButton = () => {
      return h$1(XButton, { text: true, disabled: !this.addable || this.mergedDisabled || this.readonly, focusable: false, theme: this.mergedTheme.peers.Button, themeOverrides: this.mergedTheme.peerOverrides.Button, builtinThemeOverrides: this.buttonThemeOverrides, onClick: this.handleAddClick, onMousedown: this.handleAddMousedown, ref: "addButtonInstRef" }, {
        icon: () => resolveSlot($slots["add-icon"], () => [
          h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, {
            default: () => h$1(AddIcon, null)
          })
        ])
      });
    };
    return h$1("div", { class: [
      `${mergedClsPrefix}-input-number`,
      this.rtlEnabled && `${mergedClsPrefix}-input-number--rtl`
    ] }, h$1(NInput, { ref: "inputInstRef", autofocus: this.autofocus, status: this.mergedStatus, bordered: this.mergedBordered, loading: this.loading, value: this.displayedValue, onUpdateValue: this.handleUpdateDisplayedValue, theme: this.mergedTheme.peers.Input, themeOverrides: this.mergedTheme.peerOverrides.Input, builtinThemeOverrides: this.inputThemeOverrides, size: this.mergedSize, placeholder: this.mergedPlaceholder, disabled: this.mergedDisabled, readonly: this.readonly, textDecoration: this.displayedValueInvalid ? "line-through" : void 0, onFocus: this.handleFocus, onBlur: this.handleBlur, onKeydown: this.handleKeyDown, onMousedown: this.handleMouseDown, onClear: this.handleClear, clearable: this.clearable, internalLoadingBeforeSuffix: true }, {
      prefix: () => {
        var _a2;
        return this.showButton && this.buttonPlacement === "both" ? [
          renderMinusButton(),
          resolveWrappedSlot($slots.prefix, (children) => {
            if (children) {
              return h$1("span", { class: `${mergedClsPrefix}-input-number-prefix` }, children);
            }
            return null;
          })
        ] : (_a2 = $slots.prefix) === null || _a2 === void 0 ? void 0 : _a2.call($slots);
      },
      suffix: () => {
        var _a2;
        return this.showButton ? [
          resolveWrappedSlot($slots.suffix, (children) => {
            if (children) {
              return h$1("span", { class: `${mergedClsPrefix}-input-number-suffix` }, children);
            }
            return null;
          }),
          this.buttonPlacement === "right" ? renderMinusButton() : null,
          renderAddButton()
        ] : (_a2 = $slots.suffix) === null || _a2 === void 0 ? void 0 : _a2.call($slots);
      }
    }));
  }
});
const layoutSiderInjectionKey = createInjectionKey("n-layout-sider");
const menuInjectionKey = createInjectionKey("n-menu");
const submenuInjectionKey = createInjectionKey("n-submenu");
const menuItemGroupInjectionKey = createInjectionKey("n-menu-item-group");
const ICON_MARGIN_RIGHT = 8;
function useMenuChild(props) {
  const NMenu2 = inject(menuInjectionKey);
  const { props: menuProps2, mergedCollapsedRef } = NMenu2;
  const NSubmenu2 = inject(submenuInjectionKey, null);
  const NMenuOptionGroup2 = inject(menuItemGroupInjectionKey, null);
  const horizontalRef = computed(() => {
    return menuProps2.mode === "horizontal";
  });
  const dropdownPlacementRef = computed(() => {
    if (horizontalRef.value) {
      return menuProps2.dropdownPlacement;
    }
    if ("tmNodes" in props)
      return "right-start";
    return "right";
  });
  const maxIconSizeRef = computed(() => {
    var _a2;
    return Math.max((_a2 = menuProps2.collapsedIconSize) !== null && _a2 !== void 0 ? _a2 : menuProps2.iconSize, menuProps2.iconSize);
  });
  const activeIconSizeRef = computed(() => {
    var _a2;
    if (!horizontalRef.value && props.root && mergedCollapsedRef.value) {
      return (_a2 = menuProps2.collapsedIconSize) !== null && _a2 !== void 0 ? _a2 : menuProps2.iconSize;
    } else {
      return menuProps2.iconSize;
    }
  });
  const paddingLeftRef = computed(() => {
    if (horizontalRef.value)
      return void 0;
    const { collapsedWidth, indent, rootIndent } = menuProps2;
    const { root: root2, isGroup: isGroup2 } = props;
    const mergedRootIndent = rootIndent === void 0 ? indent : rootIndent;
    if (root2) {
      if (mergedCollapsedRef.value) {
        return collapsedWidth / 2 - maxIconSizeRef.value / 2;
      }
      return mergedRootIndent;
    }
    if (NMenuOptionGroup2) {
      return indent / 2 + NMenuOptionGroup2.paddingLeftRef.value;
    }
    if (NSubmenu2) {
      return (isGroup2 ? indent / 2 : indent) + NSubmenu2.paddingLeftRef.value;
    }
    return void 0;
  });
  const iconMarginRightRef = computed(() => {
    const { collapsedWidth, indent, rootIndent } = menuProps2;
    const { value: maxIconSize } = maxIconSizeRef;
    const { root: root2 } = props;
    if (horizontalRef.value)
      return ICON_MARGIN_RIGHT;
    if (!root2)
      return ICON_MARGIN_RIGHT;
    if (!mergedCollapsedRef.value)
      return ICON_MARGIN_RIGHT;
    const mergedRootIndent = rootIndent === void 0 ? indent : rootIndent;
    return mergedRootIndent + maxIconSize + ICON_MARGIN_RIGHT - (collapsedWidth + maxIconSize) / 2;
  });
  return {
    dropdownPlacement: dropdownPlacementRef,
    activeIconSize: activeIconSizeRef,
    maxIconSize: maxIconSizeRef,
    paddingLeft: paddingLeftRef,
    iconMarginRight: iconMarginRightRef,
    NMenu: NMenu2,
    NSubmenu: NSubmenu2
  };
}
const useMenuChildProps = {
  internalKey: {
    type: [String, Number],
    required: true
  },
  root: Boolean,
  isGroup: Boolean,
  level: {
    type: Number,
    required: true
  },
  title: [String, Function],
  extra: [String, Function]
};
const menuItemGroupProps = Object.assign(Object.assign({}, useMenuChildProps), { tmNode: {
  type: Object,
  required: true
}, tmNodes: {
  type: Array,
  required: true
} });
const NMenuOptionGroup = defineComponent({
  name: "MenuOptionGroup",
  props: menuItemGroupProps,
  setup(props) {
    provide(submenuInjectionKey, null);
    const MenuChild = useMenuChild(props);
    provide(menuItemGroupInjectionKey, {
      paddingLeftRef: MenuChild.paddingLeft
    });
    const { mergedClsPrefixRef, props: menuProps2 } = inject(menuInjectionKey);
    return function() {
      const { value: mergedClsPrefix } = mergedClsPrefixRef;
      const paddingLeft = MenuChild.paddingLeft.value;
      const { nodeProps } = menuProps2;
      const attrs = nodeProps === null || nodeProps === void 0 ? void 0 : nodeProps(props.tmNode.rawNode);
      return h$1("div", { class: `${mergedClsPrefix}-menu-item-group`, role: "group" }, h$1("div", Object.assign({}, attrs, { class: [`${mergedClsPrefix}-menu-item-group-title`, attrs === null || attrs === void 0 ? void 0 : attrs.class], style: [
        (attrs === null || attrs === void 0 ? void 0 : attrs.style) || "",
        paddingLeft !== void 0 ? `padding-left: ${paddingLeft}px;` : ""
      ] }), render$3U(props.title), props.extra ? h$1(Fragment, null, " ", render$3U(props.extra)) : null), h$1("div", null, props.tmNodes.map((tmNode) => itemRenderer(tmNode, menuProps2))));
    };
  }
});
var NMenuOptionContent = defineComponent({
  name: "MenuOptionContent",
  props: {
    collapsed: Boolean,
    disabled: Boolean,
    title: [String, Function],
    icon: Function,
    extra: [String, Function],
    showArrow: Boolean,
    childActive: Boolean,
    hover: Boolean,
    paddingLeft: Number,
    selected: Boolean,
    maxIconSize: {
      type: Number,
      required: true
    },
    activeIconSize: {
      type: Number,
      required: true
    },
    iconMarginRight: {
      type: Number,
      required: true
    },
    clsPrefix: {
      type: String,
      required: true
    },
    onClick: Function,
    tmNode: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const { props: menuProps2 } = inject(menuInjectionKey);
    return {
      menuProps: menuProps2,
      style: computed(() => {
        const { paddingLeft } = props;
        return { paddingLeft: paddingLeft && `${paddingLeft}px` };
      }),
      iconStyle: computed(() => {
        const { maxIconSize, activeIconSize, iconMarginRight } = props;
        return {
          width: `${maxIconSize}px`,
          height: `${maxIconSize}px`,
          fontSize: `${activeIconSize}px`,
          marginRight: `${iconMarginRight}px`
        };
      })
    };
  },
  render() {
    const { clsPrefix, tmNode, menuProps: { renderIcon: renderIcon2, renderLabel, renderExtra, expandIcon } } = this;
    const icon = renderIcon2 ? renderIcon2(tmNode.rawNode) : render$3U(this.icon);
    return h$1("div", { onClick: (e25) => {
      var _a2;
      (_a2 = this.onClick) === null || _a2 === void 0 ? void 0 : _a2.call(this, e25);
    }, role: "none", class: [
      `${clsPrefix}-menu-item-content`,
      {
        [`${clsPrefix}-menu-item-content--selected`]: this.selected,
        [`${clsPrefix}-menu-item-content--collapsed`]: this.collapsed,
        [`${clsPrefix}-menu-item-content--child-active`]: this.childActive,
        [`${clsPrefix}-menu-item-content--disabled`]: this.disabled,
        [`${clsPrefix}-menu-item-content--hover`]: this.hover
      }
    ], style: this.style }, icon && h$1("div", { class: `${clsPrefix}-menu-item-content__icon`, style: this.iconStyle, role: "none" }, [icon]), h$1("div", { class: `${clsPrefix}-menu-item-content-header`, role: "none" }, renderLabel ? renderLabel(tmNode.rawNode) : render$3U(this.title), this.extra || renderExtra ? h$1("span", { class: `${clsPrefix}-menu-item-content-header__extra` }, " ", renderExtra ? renderExtra(tmNode.rawNode) : render$3U(this.extra)) : null), this.showArrow ? h$1(NBaseIcon, { ariaHidden: true, class: `${clsPrefix}-menu-item-content__arrow`, clsPrefix }, {
      default: () => expandIcon ? expandIcon(tmNode.rawNode) : h$1(ChevronDownFilledIcon, null)
    }) : null);
  }
});
const submenuProps = Object.assign(Object.assign({}, useMenuChildProps), { rawNodes: {
  type: Array,
  default: () => []
}, tmNodes: {
  type: Array,
  default: () => []
}, tmNode: {
  type: Object,
  required: true
}, disabled: {
  type: Boolean,
  default: false
}, icon: Function, onClick: Function });
const NSubmenu = defineComponent({
  name: "Submenu",
  props: submenuProps,
  setup(props) {
    const MenuChild = useMenuChild(props);
    const { NMenu: NMenu2, NSubmenu: NSubmenu2 } = MenuChild;
    const { props: menuProps2, mergedCollapsedRef, mergedThemeRef } = NMenu2;
    const mergedDisabledRef = computed(() => {
      const { disabled } = props;
      if (NSubmenu2 === null || NSubmenu2 === void 0 ? void 0 : NSubmenu2.mergedDisabledRef.value)
        return true;
      if (menuProps2.disabled)
        return true;
      return disabled;
    });
    const dropdownShowRef = ref(false);
    provide(submenuInjectionKey, {
      paddingLeftRef: MenuChild.paddingLeft,
      mergedDisabledRef
    });
    provide(menuItemGroupInjectionKey, null);
    function doClick() {
      const { onClick } = props;
      if (onClick)
        onClick();
    }
    function handleClick2() {
      if (!mergedDisabledRef.value) {
        if (!mergedCollapsedRef.value) {
          NMenu2.toggleExpand(props.internalKey);
        }
        doClick();
      }
    }
    function handlePopoverShowChange(value2) {
      dropdownShowRef.value = value2;
    }
    return {
      menuProps: menuProps2,
      mergedTheme: mergedThemeRef,
      doSelect: NMenu2.doSelect,
      inverted: NMenu2.invertedRef,
      isHorizontal: NMenu2.isHorizontalRef,
      mergedClsPrefix: NMenu2.mergedClsPrefixRef,
      maxIconSize: MenuChild.maxIconSize,
      activeIconSize: MenuChild.activeIconSize,
      iconMarginRight: MenuChild.iconMarginRight,
      dropdownPlacement: MenuChild.dropdownPlacement,
      dropdownShow: dropdownShowRef,
      paddingLeft: MenuChild.paddingLeft,
      mergedDisabled: mergedDisabledRef,
      mergedValue: NMenu2.mergedValueRef,
      childActive: useMemo(() => {
        return NMenu2.activePathRef.value.includes(props.internalKey);
      }),
      collapsed: computed(() => {
        if (menuProps2.mode === "horizontal")
          return false;
        if (mergedCollapsedRef.value) {
          return true;
        }
        return !NMenu2.mergedExpandedKeysRef.value.includes(props.internalKey);
      }),
      dropdownEnabled: computed(() => {
        return !mergedDisabledRef.value && (menuProps2.mode === "horizontal" || mergedCollapsedRef.value);
      }),
      handlePopoverShowChange,
      handleClick: handleClick2
    };
  },
  render() {
    var _a2;
    const { mergedClsPrefix, menuProps: { renderIcon: renderIcon2, renderLabel } } = this;
    const createSubmenuItem = () => {
      const { isHorizontal, paddingLeft, collapsed, mergedDisabled, maxIconSize, activeIconSize, title, childActive, icon, handleClick: handleClick2, menuProps: { nodeProps }, dropdownShow, iconMarginRight, tmNode, mergedClsPrefix: mergedClsPrefix2 } = this;
      const attrs = nodeProps === null || nodeProps === void 0 ? void 0 : nodeProps(tmNode.rawNode);
      return h$1("div", Object.assign({}, attrs, { class: [`${mergedClsPrefix2}-menu-item`, attrs === null || attrs === void 0 ? void 0 : attrs.class], role: "menuitem" }), h$1(NMenuOptionContent, { tmNode, paddingLeft, collapsed, disabled: mergedDisabled, iconMarginRight, maxIconSize, activeIconSize, title, extra: this.extra, showArrow: !isHorizontal, childActive, clsPrefix: mergedClsPrefix2, icon, hover: dropdownShow, onClick: handleClick2 }));
    };
    const createSubmenuChildren = () => {
      return h$1(NFadeInExpandTransition, null, {
        default: () => {
          const { tmNodes, collapsed } = this;
          return !collapsed ? h$1("div", { class: `${mergedClsPrefix}-submenu-children`, role: "menu" }, tmNodes.map((item) => itemRenderer(item, this.menuProps))) : null;
        }
      });
    };
    return this.root ? h$1(NDropdown, Object.assign({ size: "large", trigger: "hover" }, (_a2 = this.menuProps) === null || _a2 === void 0 ? void 0 : _a2.dropdownProps, { themeOverrides: this.mergedTheme.peerOverrides.Dropdown, theme: this.mergedTheme.peers.Dropdown, builtinThemeOverrides: {
      fontSizeLarge: "14px",
      optionIconSizeLarge: "18px"
    }, value: this.mergedValue, disabled: !this.dropdownEnabled, placement: this.dropdownPlacement, keyField: this.menuProps.keyField, labelField: this.menuProps.labelField, childrenField: this.menuProps.childrenField, onUpdateShow: this.handlePopoverShowChange, options: this.rawNodes, onSelect: this.doSelect, inverted: this.inverted, renderIcon: renderIcon2, renderLabel }), {
      default: () => h$1("div", { class: `${mergedClsPrefix}-submenu`, role: "menuitem", "aria-expanded": !this.collapsed }, createSubmenuItem(), this.isHorizontal ? null : createSubmenuChildren())
    }) : h$1("div", { class: `${mergedClsPrefix}-submenu`, role: "menuitem", "aria-expanded": !this.collapsed }, createSubmenuItem(), createSubmenuChildren());
  }
});
const menuItemProps = Object.assign(Object.assign({}, useMenuChildProps), { tmNode: {
  type: Object,
  required: true
}, disabled: Boolean, icon: Function, onClick: Function });
const NMenuOption = defineComponent({
  name: "MenuOption",
  props: menuItemProps,
  setup(props) {
    const MenuChild = useMenuChild(props);
    const { NSubmenu: NSubmenu2, NMenu: NMenu2 } = MenuChild;
    const { props: menuProps2, mergedClsPrefixRef, mergedCollapsedRef } = NMenu2;
    const submenuDisabledRef = NSubmenu2 ? NSubmenu2.mergedDisabledRef : { value: false };
    const mergedDisabledRef = computed(() => {
      return submenuDisabledRef.value || props.disabled;
    });
    function doClick(e25) {
      const { onClick } = props;
      if (onClick)
        onClick(e25);
    }
    function handleClick2(e25) {
      if (!mergedDisabledRef.value) {
        NMenu2.doSelect(props.internalKey, props.tmNode.rawNode);
        doClick(e25);
      }
    }
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      dropdownPlacement: MenuChild.dropdownPlacement,
      paddingLeft: MenuChild.paddingLeft,
      iconMarginRight: MenuChild.iconMarginRight,
      maxIconSize: MenuChild.maxIconSize,
      activeIconSize: MenuChild.activeIconSize,
      mergedTheme: NMenu2.mergedThemeRef,
      menuProps: menuProps2,
      dropdownEnabled: useMemo(() => {
        return props.root && mergedCollapsedRef.value && menuProps2.mode !== "horizontal" && !mergedDisabledRef.value;
      }),
      selected: useMemo(() => {
        if (NMenu2.mergedValueRef.value === props.internalKey)
          return true;
        return false;
      }),
      mergedDisabled: mergedDisabledRef,
      handleClick: handleClick2
    };
  },
  render() {
    const { mergedClsPrefix, mergedTheme, tmNode, menuProps: { renderLabel, nodeProps } } = this;
    const attrs = nodeProps === null || nodeProps === void 0 ? void 0 : nodeProps(tmNode.rawNode);
    return h$1("div", Object.assign({}, attrs, { role: "menuitem", class: [`${mergedClsPrefix}-menu-item`, attrs === null || attrs === void 0 ? void 0 : attrs.class] }), h$1(NTooltip, { theme: mergedTheme.peers.Tooltip, themeOverrides: mergedTheme.peerOverrides.Tooltip, trigger: "hover", placement: this.dropdownPlacement, disabled: !this.dropdownEnabled || this.title === void 0, internalExtraClass: ["menu-tooltip"] }, {
      default: () => renderLabel ? renderLabel(tmNode.rawNode) : render$3U(this.title),
      trigger: () => h$1(NMenuOptionContent, { tmNode, clsPrefix: mergedClsPrefix, paddingLeft: this.paddingLeft, iconMarginRight: this.iconMarginRight, maxIconSize: this.maxIconSize, activeIconSize: this.activeIconSize, selected: this.selected, title: this.title, extra: this.extra, disabled: this.mergedDisabled, icon: this.icon, onClick: this.handleClick })
    }));
  }
});
var NMenuDivider = defineComponent({
  name: "MenuDivider",
  setup() {
    const NMenu2 = inject(menuInjectionKey);
    const { mergedClsPrefixRef, isHorizontalRef } = NMenu2;
    return () => isHorizontalRef.value ? null : h$1("div", { class: `${mergedClsPrefixRef.value}-menu-divider` });
  }
});
const groupPropKeys = keysOf(menuItemGroupProps);
const itemPropKeys = keysOf(menuItemProps);
const submenuPropKeys = keysOf(submenuProps);
function isIgnoredNode(rawNode) {
  return rawNode.type === "divider" || rawNode.type === "render";
}
function isDividerNode(rawNode) {
  return rawNode.type === "divider";
}
function itemRenderer(tmNode, menuProps2) {
  const { rawNode } = tmNode;
  const { show } = rawNode;
  if (show === false) {
    return null;
  }
  if (isIgnoredNode(rawNode)) {
    if (isDividerNode(rawNode)) {
      return h$1(NMenuDivider, Object.assign({ key: tmNode.key }, rawNode.props));
    }
    return null;
  }
  const { labelField } = menuProps2;
  const { key, level, isGroup: isGroup2 } = tmNode;
  const props = Object.assign(Object.assign({}, rawNode), {
    title: rawNode.title || rawNode[labelField],
    extra: rawNode.titleExtra || rawNode.extra,
    key,
    internalKey: key,
    level,
    root: level === 0,
    isGroup: isGroup2
  });
  if (tmNode.children) {
    if (tmNode.isGroup) {
      return h$1(NMenuOptionGroup, keep(props, groupPropKeys, { tmNode, tmNodes: tmNode.children, key }));
    }
    return h$1(NSubmenu, keep(props, submenuPropKeys, {
      key,
      rawNodes: rawNode[menuProps2.childrenField],
      tmNodes: tmNode.children,
      tmNode
    }));
  } else {
    return h$1(NMenuOption, keep(props, itemPropKeys, {
      key,
      tmNode
    }));
  }
}
const hoverStyleChildren = [c$2("&::before", "background-color: var(--n-item-color-hover);"), cE$1("arrow", `
 color: var(--n-arrow-color-hover);
 `), cE$1("icon", `
 color: var(--n-item-icon-color-hover);
 `), cB$1("menu-item-content-header", `
 color: var(--n-item-text-color-hover);
 `, [c$2("a", `
 color: var(--n-item-text-color-hover);
 `), cE$1("extra", `
 color: var(--n-item-text-color-hover);
 `)])];
const horizontalHoverStyleChildren = [cE$1("icon", `
 color: var(--n-item-icon-color-hover-horizontal);
 `), cB$1("menu-item-content-header", `
 color: var(--n-item-text-color-hover-horizontal);
 `, [c$2("a", `
 color: var(--n-item-text-color-hover-horizontal);
 `), cE$1("extra", `
 color: var(--n-item-text-color-hover-horizontal);
 `)])];
var style$9 = c$2([cB$1("menu", `
 background-color: var(--n-color);
 color: var(--n-item-text-color);
 overflow: hidden;
 transition: background-color .3s var(--n-bezier);
 box-sizing: border-box;
 font-size: var(--n-font-size);
 padding-bottom: 6px;
 `, [cM("horizontal", `
 display: inline-flex;
 padding-bottom: 0;
 `, [cB$1("submenu", "margin: 0;"), cB$1("menu-item", "margin: 0;"), cB$1("menu-item-content", `
 padding: 0 20px;
 border-bottom: 2px solid #0000;
 `, [c$2("&::before", "display: none;"), cM("selected", "border-bottom: 2px solid var(--n-border-color-horizontal)")]), cB$1("menu-item-content", [cM("selected", [cE$1("icon", "color: var(--n-item-icon-color-active-horizontal);"), cB$1("menu-item-content-header", `
 color: var(--n-item-text-color-active-horizontal);
 `, [c$2("a", "color: var(--n-item-text-color-active-horizontal);"), cE$1("extra", "color: var(--n-item-text-color-active-horizontal);")])]), cM("child-active", `
 border-bottom: 2px solid var(--n-border-color-horizontal);
 `, [cB$1("menu-item-content-header", `
 color: var(--n-item-text-color-child-active-horizontal);
 `, [c$2("a", `
 color: var(--n-item-text-color-child-active-horizontal);
 `), cE$1("extra", `
 color: var(--n-item-text-color-child-active-horizontal);
 `)]), cE$1("icon", `
 color: var(--n-item-icon-color-child-active-horizontal);
 `)]), cNotM("disabled", [cNotM("selected, child-active", [c$2("&:focus-within", horizontalHoverStyleChildren)]), cM("selected", [hoverStyle(null, [cE$1("icon", "color: var(--n-item-icon-color-active-hover-horizontal);"), cB$1("menu-item-content-header", `
 color: var(--n-item-text-color-active-hover-horizontal);
 `, [c$2("a", "color: var(--n-item-text-color-active-hover-horizontal);"), cE$1("extra", "color: var(--n-item-text-color-active-hover-horizontal);")])])]), cM("child-active", [hoverStyle(null, [cE$1("icon", "color: var(--n-item-icon-color-child-active-hover-horizontal);"), cB$1("menu-item-content-header", `
 color: var(--n-item-text-color-child-active-hover-horizontal);
 `, [c$2("a", "color: var(--n-item-text-color-child-active-hover-horizontal);"), cE$1("extra", "color: var(--n-item-text-color-child-active-hover-horizontal);")])])]), hoverStyle("border-bottom: 2px solid var(--n-border-color-horizontal);", horizontalHoverStyleChildren)]), cB$1("menu-item-content-header", [c$2("a", "color: var(--n-item-text-color-horizontal);")])])]), cM("collapsed", [cB$1("menu-item-content", [cM("selected", [c$2("&::before", `
 background-color: var(--n-item-color-active-collapsed) !important;
 `)]), cB$1("menu-item-content-header", "opacity: 0;"), cE$1("arrow", "opacity: 0;"), cE$1("icon", "color: var(--n-item-icon-color-collapsed);")])]), cB$1("menu-item", `
 height: var(--n-item-height);
 margin-top: 6px;
 position: relative;
 `), cB$1("menu-item-content", `
 box-sizing: border-box;
 line-height: 1.75;
 height: 100%;
 display: grid;
 grid-template-areas: "icon content arrow";
 grid-template-columns: auto 1fr auto;
 align-items: center;
 cursor: pointer;
 position: relative;
 padding-right: 18px;
 transition:
 background-color .3s var(--n-bezier),
 padding-left .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [c$2("> *", "z-index: 1;"), c$2("&::before", `
 z-index: auto;
 content: "";
 background-color: #0000;
 position: absolute;
 left: 8px;
 right: 8px;
 top: 0;
 bottom: 0;
 pointer-events: none;
 border-radius: var(--n-border-radius);
 transition: background-color .3s var(--n-bezier);
 `), cM("disabled", `
 opacity: .45;
 cursor: not-allowed;
 `), cM("collapsed", [cE$1("arrow", "transform: rotate(0);")]), cM("selected", [c$2("&::before", "background-color: var(--n-item-color-active);"), cE$1("arrow", "color: var(--n-arrow-color-active);"), cE$1("icon", "color: var(--n-item-icon-color-active);"), cB$1("menu-item-content-header", `
 color: var(--n-item-text-color-active);
 `, [c$2("a", "color: var(--n-item-text-color-active);"), cE$1("extra", "color: var(--n-item-text-color-active);")])]), cM("child-active", [cB$1("menu-item-content-header", `
 color: var(--n-item-text-color-child-active);
 `, [c$2("a", `
 color: var(--n-item-text-color-child-active);
 `), cE$1("extra", `
 color: var(--n-item-text-color-child-active);
 `)]), cE$1("arrow", `
 color: var(--n-arrow-color-child-active);
 `), cE$1("icon", `
 color: var(--n-item-icon-color-child-active);
 `)]), cNotM("disabled", [cNotM("selected, child-active", [c$2("&:focus-within", hoverStyleChildren)]), cM("selected", [hoverStyle(null, [cE$1("arrow", "color: var(--n-arrow-color-active-hover);"), cE$1("icon", "color: var(--n-item-icon-color-active-hover);"), cB$1("menu-item-content-header", `
 color: var(--n-item-text-color-active-hover);
 `, [c$2("a", "color: var(--n-item-text-color-active-hover);"), cE$1("extra", "color: var(--n-item-text-color-active-hover);")])])]), cM("child-active", [hoverStyle(null, [cE$1("arrow", "color: var(--n-arrow-color-child-active-hover);"), cE$1("icon", "color: var(--n-item-icon-color-child-active-hover);"), cB$1("menu-item-content-header", `
 color: var(--n-item-text-color-child-active-hover);
 `, [c$2("a", "color: var(--n-item-text-color-child-active-hover);"), cE$1("extra", "color: var(--n-item-text-color-child-active-hover);")])])]), cM("selected", [hoverStyle(null, [c$2("&::before", "background-color: var(--n-item-color-active-hover);")])]), hoverStyle(null, hoverStyleChildren)]), cE$1("icon", `
 grid-area: icon;
 color: var(--n-item-icon-color);
 transition:
 color .3s var(--n-bezier),
 font-size .3s var(--n-bezier),
 margin-right .3s var(--n-bezier);
 box-sizing: content-box;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 `), cE$1("arrow", `
 grid-area: arrow;
 font-size: 16px;
 color: var(--n-arrow-color);
 transform: rotate(180deg);
 opacity: 1;
 transition:
 color .3s var(--n-bezier),
 transform 0.2s var(--n-bezier),
 opacity 0.2s var(--n-bezier);
 `), cB$1("menu-item-content-header", `
 grid-area: content;
 transition:
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier);
 opacity: 1;
 white-space: nowrap;
 overflow: hidden;
 text-overflow: ellipsis;
 color: var(--n-item-text-color);
 `, [c$2("a", `
 outline: none;
 text-decoration: none;
 transition: color .3s var(--n-bezier);
 color: var(--n-item-text-color);
 `, [c$2("&::before", `
 content: "";
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 `)]), cE$1("extra", `
 font-size: .93em;
 color: var(--n-group-text-color);
 transition: color .3s var(--n-bezier);
 `)])]), cB$1("submenu", `
 cursor: pointer;
 position: relative;
 margin-top: 6px;
 `, [cB$1("menu-item-content", `
 height: var(--n-item-height);
 `), cB$1("submenu-children", `
 overflow: hidden;
 padding: 0;
 `, [fadeInHeightExpandTransition({
  duration: ".2s"
})])]), cB$1("menu-item-group", [cB$1("menu-item-group-title", `
 margin-top: 6px;
 color: var(--n-group-text-color);
 cursor: default;
 font-size: .93em;
 height: 36px;
 display: flex;
 align-items: center;
 transition:
 padding-left .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)])]), cB$1("menu-tooltip", [c$2("a", `
 color: inherit;
 text-decoration: none;
 `)]), cB$1("menu-divider", `
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-divider-color);
 height: 1px;
 margin: 6px 18px;
 `)]);
function hoverStyle(props, children) {
  return [cM("hover", props, children), c$2("&:hover", props, children)];
}
const menuProps = Object.assign(Object.assign({}, useTheme.props), {
  options: {
    type: Array,
    default: () => []
  },
  collapsed: {
    type: Boolean,
    default: void 0
  },
  collapsedWidth: {
    type: Number,
    default: 48
  },
  iconSize: {
    type: Number,
    default: 20
  },
  collapsedIconSize: {
    type: Number,
    default: 24
  },
  rootIndent: Number,
  indent: {
    type: Number,
    default: 32
  },
  labelField: {
    type: String,
    default: "label"
  },
  keyField: {
    type: String,
    default: "key"
  },
  childrenField: {
    type: String,
    default: "children"
  },
  disabledField: {
    type: String,
    default: "disabled"
  },
  defaultExpandAll: Boolean,
  defaultExpandedKeys: Array,
  expandedKeys: Array,
  value: [String, Number],
  defaultValue: {
    type: [String, Number],
    default: null
  },
  mode: {
    type: String,
    default: "vertical"
  },
  watchProps: {
    type: Array,
    default: void 0
  },
  disabled: Boolean,
  show: {
    type: Boolean,
    default: true
  },
  inverted: Boolean,
  "onUpdate:expandedKeys": [Function, Array],
  onUpdateExpandedKeys: [Function, Array],
  onUpdateValue: [Function, Array],
  "onUpdate:value": [Function, Array],
  expandIcon: Function,
  renderIcon: Function,
  renderLabel: Function,
  renderExtra: Function,
  dropdownProps: Object,
  accordion: Boolean,
  nodeProps: Function,
  items: Array,
  onOpenNamesChange: [Function, Array],
  onSelect: [Function, Array],
  onExpandedNamesChange: [Function, Array],
  expandedNames: Array,
  defaultExpandedNames: Array,
  dropdownPlacement: {
    type: String,
    default: "bottom"
  }
});
var NMenu = defineComponent({
  name: "Menu",
  props: menuProps,
  setup(props) {
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Menu", "-menu", style$9, menuLight$1, props, mergedClsPrefixRef);
    const layoutSider = inject(layoutSiderInjectionKey, null);
    const mergedCollapsedRef = computed(() => {
      var _a2;
      const { collapsed } = props;
      if (collapsed !== void 0)
        return collapsed;
      if (layoutSider) {
        const { collapseModeRef, collapsedRef } = layoutSider;
        if (collapseModeRef.value === "width") {
          return (_a2 = collapsedRef.value) !== null && _a2 !== void 0 ? _a2 : false;
        }
      }
      return false;
    });
    const treeMateRef = computed(() => {
      const { keyField, childrenField, disabledField } = props;
      return createTreeMate(props.items || props.options, {
        getIgnored(node2) {
          return isIgnoredNode(node2);
        },
        getChildren(node2) {
          return node2[childrenField];
        },
        getDisabled(node2) {
          return node2[disabledField];
        },
        getKey(node2) {
          var _a2;
          return (_a2 = node2[keyField]) !== null && _a2 !== void 0 ? _a2 : node2.name;
        }
      });
    });
    const treeKeysLevelOneRef = computed(() => new Set(treeMateRef.value.treeNodes.map((e25) => e25.key)));
    const { watchProps } = props;
    const uncontrolledValueRef = ref(null);
    if (watchProps === null || watchProps === void 0 ? void 0 : watchProps.includes("defaultValue")) {
      watchEffect(() => {
        uncontrolledValueRef.value = props.defaultValue;
      });
    } else {
      uncontrolledValueRef.value = props.defaultValue;
    }
    const controlledValueRef = toRef(props, "value");
    const mergedValueRef = useMergedState(controlledValueRef, uncontrolledValueRef);
    const uncontrolledExpandedKeysRef = ref([]);
    const initUncontrolledExpandedKeys = () => {
      uncontrolledExpandedKeysRef.value = props.defaultExpandAll ? treeMateRef.value.getNonLeafKeys() : props.defaultExpandedNames || props.defaultExpandedKeys || treeMateRef.value.getPath(mergedValueRef.value, {
        includeSelf: false
      }).keyPath;
    };
    if (watchProps === null || watchProps === void 0 ? void 0 : watchProps.includes("defaultExpandedKeys")) {
      watchEffect(initUncontrolledExpandedKeys);
    } else {
      initUncontrolledExpandedKeys();
    }
    const controlledExpandedKeysRef = useCompitable(props, [
      "expandedNames",
      "expandedKeys"
    ]);
    const mergedExpandedKeysRef = useMergedState(controlledExpandedKeysRef, uncontrolledExpandedKeysRef);
    const tmNodesRef = computed(() => treeMateRef.value.treeNodes);
    const activePathRef = computed(() => {
      return treeMateRef.value.getPath(mergedValueRef.value).keyPath;
    });
    provide(menuInjectionKey, {
      props,
      mergedCollapsedRef,
      mergedThemeRef: themeRef,
      mergedValueRef,
      mergedExpandedKeysRef,
      activePathRef,
      mergedClsPrefixRef,
      isHorizontalRef: computed(() => props.mode === "horizontal"),
      invertedRef: toRef(props, "inverted"),
      doSelect,
      toggleExpand
    });
    function doSelect(value2, item) {
      const { "onUpdate:value": _onUpdateValue, onUpdateValue, onSelect } = props;
      if (onUpdateValue) {
        call(onUpdateValue, value2, item);
      }
      if (_onUpdateValue) {
        call(_onUpdateValue, value2, item);
      }
      if (onSelect) {
        call(onSelect, value2, item);
      }
      uncontrolledValueRef.value = value2;
    }
    function doUpdateExpandedKeys(value2) {
      const { "onUpdate:expandedKeys": _onUpdateExpandedKeys, onUpdateExpandedKeys, onExpandedNamesChange, onOpenNamesChange } = props;
      if (_onUpdateExpandedKeys) {
        call(_onUpdateExpandedKeys, value2);
      }
      if (onUpdateExpandedKeys) {
        call(onUpdateExpandedKeys, value2);
      }
      if (onExpandedNamesChange) {
        call(onExpandedNamesChange, value2);
      }
      if (onOpenNamesChange) {
        call(onOpenNamesChange, value2);
      }
      uncontrolledExpandedKeysRef.value = value2;
    }
    function toggleExpand(key) {
      const currentExpandedKeys = Array.from(mergedExpandedKeysRef.value);
      const index2 = currentExpandedKeys.findIndex((expanededKey) => expanededKey === key);
      if (~index2) {
        currentExpandedKeys.splice(index2, 1);
      } else {
        if (props.accordion) {
          if (treeKeysLevelOneRef.value.has(key)) {
            const closeKeyIndex = currentExpandedKeys.findIndex((e25) => treeKeysLevelOneRef.value.has(e25));
            if (closeKeyIndex > -1) {
              currentExpandedKeys.splice(closeKeyIndex, 1);
            }
          }
        }
        currentExpandedKeys.push(key);
      }
      doUpdateExpandedKeys(currentExpandedKeys);
    }
    const showOption = (key) => {
      const selectedKeyPath = treeMateRef.value.getPath(key !== null && key !== void 0 ? key : mergedValueRef.value, {
        includeSelf: false
      }).keyPath;
      if (!selectedKeyPath.length)
        return;
      const currentExpandedKeys = Array.from(mergedExpandedKeysRef.value);
      const nextExpandedKeys = new Set([
        ...currentExpandedKeys,
        ...selectedKeyPath
      ]);
      if (props.accordion) {
        treeKeysLevelOneRef.value.forEach((firstLevelKey) => {
          if (nextExpandedKeys.has(firstLevelKey) && !selectedKeyPath.includes(firstLevelKey)) {
            nextExpandedKeys.delete(firstLevelKey);
          }
        });
      }
      doUpdateExpandedKeys(Array.from(nextExpandedKeys));
    };
    const cssVarsRef = computed(() => {
      const { inverted } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: self2 } = themeRef.value;
      const { borderRadius, borderColorHorizontal, fontSize: fontSize2, itemHeight, dividerColor } = self2;
      const vars = {
        "--n-divider-color": dividerColor,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-font-size": fontSize2,
        "--n-border-color-horizontal": borderColorHorizontal,
        "--n-border-radius": borderRadius,
        "--n-item-height": itemHeight
      };
      if (inverted) {
        vars["--n-group-text-color"] = self2.groupTextColorInverted;
        vars["--n-color"] = self2.colorInverted;
        vars["--n-item-text-color"] = self2.itemTextColorInverted;
        vars["--n-item-text-color-hover"] = self2.itemTextColorHoverInverted;
        vars["--n-item-text-color-active"] = self2.itemTextColorActiveInverted;
        vars["--n-item-text-color-child-active"] = self2.itemTextColorChildActiveInverted;
        vars["--n-item-text-color-child-active-hover"] = self2.itemTextColorChildActiveInverted;
        vars["--n-item-text-color-active-hover"] = self2.itemTextColorActiveHoverInverted;
        vars["--n-item-icon-color"] = self2.itemIconColorInverted;
        vars["--n-item-icon-color-hover"] = self2.itemIconColorHoverInverted;
        vars["--n-item-icon-color-active"] = self2.itemIconColorActiveInverted;
        vars["--n-item-icon-color-active-hover"] = self2.itemIconColorActiveHoverInverted;
        vars["--n-item-icon-color-child-active"] = self2.itemIconColorChildActiveInverted;
        vars["--n-item-icon-color-child-active-hover"] = self2.itemIconColorChildActiveHoverInverted;
        vars["--n-item-icon-color-collapsed"] = self2.itemIconColorCollapsedInverted;
        vars["--n-item-text-color-horizontal"] = self2.itemTextColorHorizontalInverted;
        vars["--n-item-text-color-hover-horizontal"] = self2.itemTextColorHoverHorizontalInverted;
        vars["--n-item-text-color-active-horizontal"] = self2.itemTextColorActiveHorizontalInverted;
        vars["--n-item-text-color-child-active-horizontal"] = self2.itemTextColorChildActiveHorizontalInverted;
        vars["--n-item-text-color-child-active-hover-horizontal"] = self2.itemTextColorChildActiveHoverHorizontalInverted;
        vars["--n-item-text-color-active-hover-horizontal"] = self2.itemTextColorActiveHoverHorizontalInverted;
        vars["--n-item-icon-color-horizontal"] = self2.itemIconColorHorizontalInverted;
        vars["--n-item-icon-color-hover-horizontal"] = self2.itemIconColorHoverHorizontalInverted;
        vars["--n-item-icon-color-active-horizontal"] = self2.itemIconColorActiveHorizontalInverted;
        vars["--n-item-icon-color-active-hover-horizontal"] = self2.itemIconColorActiveHoverHorizontalInverted;
        vars["--n-item-icon-color-child-active-horizontal"] = self2.itemIconColorChildActiveHorizontalInverted;
        vars["--n-item-icon-color-child-active-hover-horizontal"] = self2.itemIconColorChildActiveHoverHorizontalInverted;
        vars["--n-arrow-color"] = self2.arrowColorInverted;
        vars["--n-arrow-color-hover"] = self2.arrowColorHoverInverted;
        vars["--n-arrow-color-active"] = self2.arrowColorActiveInverted;
        vars["--n-arrow-color-active-hover"] = self2.arrowColorActiveHoverInverted;
        vars["--n-arrow-color-child-active"] = self2.arrowColorChildActiveInverted;
        vars["--n-arrow-color-child-active-hover"] = self2.arrowColorChildActiveHoverInverted;
        vars["--n-item-color-hover"] = self2.itemColorHoverInverted;
        vars["--n-item-color-active"] = self2.itemColorActiveInverted;
        vars["--n-item-color-active-hover"] = self2.itemColorActiveHoverInverted;
        vars["--n-item-color-active-collapsed"] = self2.itemColorActiveCollapsedInverted;
      } else {
        vars["--n-group-text-color"] = self2.groupTextColor;
        vars["--n-color"] = self2.color;
        vars["--n-item-text-color"] = self2.itemTextColor;
        vars["--n-item-text-color-hover"] = self2.itemTextColorHover;
        vars["--n-item-text-color-active"] = self2.itemTextColorActive;
        vars["--n-item-text-color-child-active"] = self2.itemTextColorChildActive;
        vars["--n-item-text-color-child-active-hover"] = self2.itemTextColorChildActiveHover;
        vars["--n-item-text-color-active-hover"] = self2.itemTextColorActiveHover;
        vars["--n-item-icon-color"] = self2.itemIconColor;
        vars["--n-item-icon-color-hover"] = self2.itemIconColorHover;
        vars["--n-item-icon-color-active"] = self2.itemIconColorActive;
        vars["--n-item-icon-color-active-hover"] = self2.itemIconColorActiveHover;
        vars["--n-item-icon-color-child-active"] = self2.itemIconColorChildActive;
        vars["--n-item-icon-color-child-active-hover"] = self2.itemIconColorChildActiveHover;
        vars["--n-item-icon-color-collapsed"] = self2.itemIconColorCollapsed;
        vars["--n-item-text-color-horizontal"] = self2.itemTextColorHorizontal;
        vars["--n-item-text-color-hover-horizontal"] = self2.itemTextColorHoverHorizontal;
        vars["--n-item-text-color-active-horizontal"] = self2.itemTextColorActiveHorizontal;
        vars["--n-item-text-color-child-active-horizontal"] = self2.itemTextColorChildActiveHorizontal;
        vars["--n-item-text-color-child-active-hover-horizontal"] = self2.itemTextColorChildActiveHoverHorizontal;
        vars["--n-item-text-color-active-hover-horizontal"] = self2.itemTextColorActiveHoverHorizontal;
        vars["--n-item-icon-color-horizontal"] = self2.itemIconColorHorizontal;
        vars["--n-item-icon-color-hover-horizontal"] = self2.itemIconColorHoverHorizontal;
        vars["--n-item-icon-color-active-horizontal"] = self2.itemIconColorActiveHorizontal;
        vars["--n-item-icon-color-active-hover-horizontal"] = self2.itemIconColorActiveHoverHorizontal;
        vars["--n-item-icon-color-child-active-horizontal"] = self2.itemIconColorChildActiveHorizontal;
        vars["--n-item-icon-color-child-active-hover-horizontal"] = self2.itemIconColorChildActiveHoverHorizontal;
        vars["--n-arrow-color"] = self2.arrowColor;
        vars["--n-arrow-color-hover"] = self2.arrowColorHover;
        vars["--n-arrow-color-active"] = self2.arrowColorActive;
        vars["--n-arrow-color-active-hover"] = self2.arrowColorActiveHover;
        vars["--n-arrow-color-child-active"] = self2.arrowColorChildActive;
        vars["--n-arrow-color-child-active-hover"] = self2.arrowColorChildActiveHover;
        vars["--n-item-color-hover"] = self2.itemColorHover;
        vars["--n-item-color-active"] = self2.itemColorActive;
        vars["--n-item-color-active-hover"] = self2.itemColorActiveHover;
        vars["--n-item-color-active-collapsed"] = self2.itemColorActiveCollapsed;
      }
      return vars;
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("menu", computed(() => props.inverted ? "a" : "b"), cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      controlledExpandedKeys: controlledExpandedKeysRef,
      uncontrolledExpanededKeys: uncontrolledExpandedKeysRef,
      mergedExpandedKeys: mergedExpandedKeysRef,
      uncontrolledValue: uncontrolledValueRef,
      mergedValue: mergedValueRef,
      activePath: activePathRef,
      tmNodes: tmNodesRef,
      mergedTheme: themeRef,
      mergedCollapsed: mergedCollapsedRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender,
      showOption
    };
  },
  render() {
    const { mergedClsPrefix, mode, themeClass, onRender } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { role: mode === "horizontal" ? "menubar" : "menu", class: [
      `${mergedClsPrefix}-menu`,
      themeClass,
      `${mergedClsPrefix}-menu--${mode}`,
      this.mergedCollapsed && `${mergedClsPrefix}-menu--collapsed`
    ], style: this.cssVars }, this.tmNodes.map((tmNode) => itemRenderer(tmNode, this.$props)));
  }
});
const notificationProviderInjectionKey = createInjectionKey("n-notification-provider");
const NotificationContainer = defineComponent({
  name: "NotificationContainer",
  props: {
    scrollable: {
      type: Boolean,
      required: true
    },
    placement: {
      type: String,
      required: true
    }
  },
  setup() {
    const { mergedThemeRef, mergedClsPrefixRef, wipTransitionCountRef } = inject(notificationProviderInjectionKey);
    const selfRef = ref(null);
    watchEffect(() => {
      var _a2, _b2;
      if (wipTransitionCountRef.value > 0) {
        (_a2 = selfRef === null || selfRef === void 0 ? void 0 : selfRef.value) === null || _a2 === void 0 ? void 0 : _a2.classList.add("transitioning");
      } else {
        (_b2 = selfRef === null || selfRef === void 0 ? void 0 : selfRef.value) === null || _b2 === void 0 ? void 0 : _b2.classList.remove("transitioning");
      }
    });
    return {
      selfRef,
      mergedTheme: mergedThemeRef,
      mergedClsPrefix: mergedClsPrefixRef,
      transitioning: wipTransitionCountRef
    };
  },
  render() {
    const { $slots, scrollable, mergedClsPrefix, mergedTheme, placement } = this;
    return h$1("div", { ref: "selfRef", class: [
      `${mergedClsPrefix}-notification-container`,
      scrollable && `${mergedClsPrefix}-notification-container--scrollable`,
      `${mergedClsPrefix}-notification-container--${placement}`
    ] }, scrollable ? h$1(NScrollbar, { theme: mergedTheme.peers.Scrollbar, themeOverrides: mergedTheme.peerOverrides.Scrollbar, contentStyle: { overflow: "hidden" } }, $slots) : $slots);
  }
});
const iconRenderMap = {
  info: () => h$1(InfoIcon, null),
  success: () => h$1(SuccessIcon, null),
  warning: () => h$1(WarningIcon, null),
  error: () => h$1(ErrorIcon, null),
  default: () => null
};
const notificationProps = {
  closable: {
    type: Boolean,
    default: true
  },
  type: {
    type: String,
    default: "default"
  },
  avatar: Function,
  title: [String, Function],
  description: [String, Function],
  content: [String, Function],
  meta: [String, Function],
  action: [String, Function],
  onClose: {
    type: Function,
    required: true
  },
  keepAliveOnHover: Boolean,
  onMouseenter: Function,
  onMouseleave: Function
};
const notificationPropKeys = keysOf(notificationProps);
const Notification = defineComponent({
  name: "Notification",
  props: notificationProps,
  setup(props) {
    const {
      mergedClsPrefixRef,
      mergedThemeRef,
      props: providerProps
    } = inject(notificationProviderInjectionKey);
    const { inlineThemeDisabled, mergedRtlRef } = useConfig();
    const rtlEnabledRef = useRtl("Notification", mergedRtlRef, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { type: type4 } = props;
      const { self: { color, textColor, closeIconColor, closeIconColorHover, closeIconColorPressed, headerTextColor, descriptionTextColor, actionTextColor, borderRadius, headerFontWeight, boxShadow, lineHeight: lineHeight2, fontSize: fontSize2, closeMargin, closeSize, width, padding, closeIconSize, closeBorderRadius, closeColorHover, closeColorPressed, titleFontSize, metaFontSize, descriptionFontSize, [createKey("iconColor", type4)]: iconColor }, common: { cubicBezierEaseOut: cubicBezierEaseOut2, cubicBezierEaseIn: cubicBezierEaseIn2, cubicBezierEaseInOut: cubicBezierEaseInOut2 } } = mergedThemeRef.value;
      const { left, right, top: top2, bottom } = getMargin(padding);
      return {
        "--n-color": color,
        "--n-font-size": fontSize2,
        "--n-text-color": textColor,
        "--n-description-text-color": descriptionTextColor,
        "--n-action-text-color": actionTextColor,
        "--n-title-text-color": headerTextColor,
        "--n-title-font-weight": headerFontWeight,
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-bezier-ease-out": cubicBezierEaseOut2,
        "--n-bezier-ease-in": cubicBezierEaseIn2,
        "--n-border-radius": borderRadius,
        "--n-box-shadow": boxShadow,
        "--n-close-border-radius": closeBorderRadius,
        "--n-close-color-hover": closeColorHover,
        "--n-close-color-pressed": closeColorPressed,
        "--n-close-icon-color": closeIconColor,
        "--n-close-icon-color-hover": closeIconColorHover,
        "--n-close-icon-color-pressed": closeIconColorPressed,
        "--n-line-height": lineHeight2,
        "--n-icon-color": iconColor,
        "--n-close-margin": closeMargin,
        "--n-close-size": closeSize,
        "--n-close-icon-size": closeIconSize,
        "--n-width": width,
        "--n-padding-left": left,
        "--n-padding-right": right,
        "--n-padding-top": top2,
        "--n-padding-bottom": bottom,
        "--n-title-font-size": titleFontSize,
        "--n-meta-font-size": metaFontSize,
        "--n-description-font-size": descriptionFontSize
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("notification", computed(() => props.type[0]), cssVarsRef, providerProps) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      showAvatar: computed(() => {
        return props.avatar || props.type !== "default";
      }),
      handleCloseClick() {
        props.onClose();
      },
      rtlEnabled: rtlEnabledRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    var _a2;
    const { mergedClsPrefix } = this;
    (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
    return h$1("div", { class: [`${mergedClsPrefix}-notification-wrapper`, this.themeClass], onMouseenter: this.onMouseenter, onMouseleave: this.onMouseleave, style: this.cssVars }, h$1("div", { class: [
      `${mergedClsPrefix}-notification`,
      this.rtlEnabled && `${mergedClsPrefix}-notification--rtl`,
      this.themeClass,
      {
        [`${mergedClsPrefix}-notification--closable`]: this.closable,
        [`${mergedClsPrefix}-notification--show-avatar`]: this.showAvatar
      }
    ], style: this.cssVars }, this.showAvatar ? h$1("div", { class: `${mergedClsPrefix}-notification__avatar` }, this.avatar ? render$3U(this.avatar) : this.type !== "default" ? h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, { default: () => iconRenderMap[this.type]() }) : null) : null, this.closable ? h$1(NBaseClose, { clsPrefix: mergedClsPrefix, class: `${mergedClsPrefix}-notification__close`, onClick: this.handleCloseClick }) : null, h$1("div", { ref: "bodyRef", class: `${mergedClsPrefix}-notification-main` }, this.title ? h$1("div", { class: `${mergedClsPrefix}-notification-main__header` }, render$3U(this.title)) : null, this.description ? h$1("div", { class: `${mergedClsPrefix}-notification-main__description` }, render$3U(this.description)) : null, this.content ? h$1("pre", { class: `${mergedClsPrefix}-notification-main__content` }, render$3U(this.content)) : null, this.meta || this.action ? h$1("div", { class: `${mergedClsPrefix}-notification-main-footer` }, this.meta ? h$1("div", { class: `${mergedClsPrefix}-notification-main-footer__meta` }, render$3U(this.meta)) : null, this.action ? h$1("div", { class: `${mergedClsPrefix}-notification-main-footer__action` }, render$3U(this.action)) : null) : null)));
  }
});
const notificationEnvOptions = Object.assign(Object.assign({}, notificationProps), {
  duration: Number,
  onClose: Function,
  onLeave: Function,
  onAfterEnter: Function,
  onAfterLeave: Function,
  onHide: Function,
  onAfterShow: Function,
  onAfterHide: Function
});
const NotificationEnvironment = defineComponent({
  name: "NotificationEnvironment",
  props: Object.assign(Object.assign({}, notificationEnvOptions), {
    internalKey: {
      type: String,
      required: true
    },
    onInternalAfterLeave: {
      type: Function,
      required: true
    }
  }),
  setup(props) {
    const {
      wipTransitionCountRef
    } = inject(notificationProviderInjectionKey);
    const showRef = ref(true);
    let timerId = null;
    function hide() {
      showRef.value = false;
      if (timerId) {
        window.clearTimeout(timerId);
      }
    }
    function handleBeforeEnter(el2) {
      wipTransitionCountRef.value++;
      void nextTick(() => {
        el2.style.height = `${el2.offsetHeight}px`;
        el2.style.maxHeight = "0";
        el2.style.transition = "none";
        void el2.offsetHeight;
        el2.style.transition = "";
        el2.style.maxHeight = el2.style.height;
      });
    }
    function handleAfterEnter(el2) {
      wipTransitionCountRef.value--;
      el2.style.height = "";
      el2.style.maxHeight = "";
      const { onAfterEnter, onAfterShow } = props;
      if (onAfterEnter)
        onAfterEnter();
      if (onAfterShow)
        onAfterShow();
    }
    function handleBeforeLeave(el2) {
      wipTransitionCountRef.value++;
      el2.style.maxHeight = `${el2.offsetHeight}px`;
      el2.style.height = `${el2.offsetHeight}px`;
      void el2.offsetHeight;
    }
    function handleLeave(el2) {
      const { onHide } = props;
      if (onHide)
        onHide();
      el2.style.maxHeight = "0";
      void el2.offsetHeight;
    }
    function handleAfterLeave() {
      wipTransitionCountRef.value--;
      const { onAfterLeave, onInternalAfterLeave, onAfterHide, internalKey } = props;
      if (onAfterLeave)
        onAfterLeave();
      onInternalAfterLeave(internalKey);
      if (onAfterHide)
        onAfterHide();
    }
    function setHideTimeout() {
      const { duration } = props;
      if (duration) {
        timerId = window.setTimeout(hide, duration);
      }
    }
    function handleMouseenter(e25) {
      if (e25.currentTarget !== e25.target)
        return;
      if (timerId !== null) {
        window.clearTimeout(timerId);
        timerId = null;
      }
    }
    function handleMouseleave(e25) {
      if (e25.currentTarget !== e25.target)
        return;
      setHideTimeout();
    }
    function handleClose2() {
      const { onClose } = props;
      if (onClose) {
        void Promise.resolve(onClose()).then((feedback) => {
          if (feedback === false)
            return;
          hide();
        });
      } else {
        hide();
      }
    }
    onMounted(() => {
      if (props.duration) {
        timerId = window.setTimeout(hide, props.duration);
      }
    });
    return {
      show: showRef,
      hide,
      handleClose: handleClose2,
      handleAfterLeave,
      handleLeave,
      handleBeforeLeave,
      handleAfterEnter,
      handleBeforeEnter,
      handleMouseenter,
      handleMouseleave
    };
  },
  render() {
    return h$1(Transition, {
      name: "notification-transition",
      appear: true,
      onBeforeEnter: this.handleBeforeEnter,
      onAfterEnter: this.handleAfterEnter,
      onBeforeLeave: this.handleBeforeLeave,
      onLeave: this.handleLeave,
      onAfterLeave: this.handleAfterLeave
    }, {
      default: () => {
        return this.show ? h$1(Notification, Object.assign({}, keep(this.$props, notificationPropKeys), { onClose: this.handleClose, onMouseenter: this.duration && this.keepAliveOnHover ? this.handleMouseenter : void 0, onMouseleave: this.duration && this.keepAliveOnHover ? this.handleMouseleave : void 0 })) : null;
      }
    });
  }
});
var style$8 = c$2([cB$1("notification-container", `
 z-index: 4000;
 position: fixed;
 overflow: visible;
 display: flex;
 flex-direction: column;
 align-items: flex-end;
 `, [c$2(">", [cB$1("scrollbar", `
 width: initial;
 overflow: visible;
 height: -moz-fit-content !important;
 height: fit-content !important;
 max-height: 100vh !important;
 `, [c$2(">", [cB$1("scrollbar-container", `
 height: -moz-fit-content !important;
 height: fit-content !important;
 max-height: 100vh !important;
 `, [cB$1("scrollbar-content", `
 padding-top: 12px;
 padding-bottom: 33px;
 `)])])])]), cM("top, top-right, top-left", `
 top: 12px;
 `, [c$2("&.transitioning >", [cB$1("scrollbar", [c$2(">", [cB$1("scrollbar-container", `
 min-height: 100vh !important;
 `)])])])]), cM("bottom, bottom-right, bottom-left", `
 bottom: 12px;
 `, [c$2(">", [cB$1("scrollbar", [c$2(">", [cB$1("scrollbar-container", [cB$1("scrollbar-content", `
 padding-bottom: 12px;
 `)])])])]), cB$1("notification-wrapper", `
 display: flex;
 align-items: flex-end;
 margin-bottom: 0;
 margin-top: 12px;
 `)]), cM("top, bottom", `
 left: 50%;
 transform: translateX(-50%);
 `, [cB$1("notification-wrapper", [c$2("&.notification-transition-enter-from, &.notification-transition-leave-to", `
 transform: scale(0.85);
 `), c$2("&.notification-transition-leave-from, &.notification-transition-enter-to", `
 transform: scale(1);
 `)])]), cM("top", [cB$1("notification-wrapper", `
 transform-origin: top center;
 `)]), cM("bottom", [cB$1("notification-wrapper", `
 transform-origin: bottom center;
 `)]), cM("top-right, bottom-right", [cB$1("notification", `
 margin-left: 28px;
 margin-right: 16px;
 `)]), cM("top-left, bottom-left", [cB$1("notification", `
 margin-left: 16px;
 margin-right: 28px;
 `)]), cM("top-right", `
 right: 0;
 `, [placementTransformStyle("top-right")]), cM("top-left", `
 left: 0;
 `, [placementTransformStyle("top-left")]), cM("bottom-right", `
 right: 0;
 `, [placementTransformStyle("bottom-right")]), cM("bottom-left", `
 left: 0;
 `, [placementTransformStyle("bottom-left")]), cM("scrollable", [cM("top-right", `
 top: 0;
 `), cM("top-left", `
 top: 0;
 `), cM("bottom-right", `
 bottom: 0;
 `), cM("bottom-left", `
 bottom: 0;
 `)]), cB$1("notification-wrapper", `
 margin-bottom: 12px;
 `, [c$2("&.notification-transition-enter-from, &.notification-transition-leave-to", `
 opacity: 0;
 margin-top: 0 !important;
 margin-bottom: 0 !important;
 `), c$2("&.notification-transition-leave-from, &.notification-transition-enter-to", `
 opacity: 1;
 `), c$2("&.notification-transition-leave-active", `
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 transform .3s var(--n-bezier-ease-in),
 max-height .3s var(--n-bezier),
 margin-top .3s linear,
 margin-bottom .3s linear,
 box-shadow .3s var(--n-bezier);
 `), c$2("&.notification-transition-enter-active", `
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 transform .3s var(--n-bezier-ease-out),
 max-height .3s var(--n-bezier),
 margin-top .3s linear,
 margin-bottom .3s linear,
 box-shadow .3s var(--n-bezier);
 `)]), cB$1("notification", `
 background-color: var(--n-color);
 color: var(--n-text-color);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 font-family: inherit;
 font-size: var(--n-font-size);
 font-weight: 400;
 position: relative;
 display: flex;
 overflow: hidden;
 flex-shrink: 0;
 padding-left: var(--n-padding-left);
 padding-right: var(--n-padding-right);
 width: var(--n-width);
 border-radius: var(--n-border-radius);
 box-shadow: var(--n-box-shadow);
 box-sizing: border-box;
 opacity: 1;
 `, [cE$1("avatar", [cB$1("icon", {
  color: "var(--n-icon-color)"
}), cB$1("base-icon", {
  color: "var(--n-icon-color)"
})]), cM("show-avatar", [cB$1("notification-main", `
 margin-left: 40px;
 width: calc(100% - 40px); 
 `)]), cM("closable", [cB$1("notification-main", [c$2("> *:first-child", {
  paddingRight: "20px"
})]), cE$1("close", `
 position: absolute;
 top: 0;
 right: 0;
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `)]), cE$1("avatar", `
 position: absolute;
 top: var(--n-padding-top);
 left: var(--n-padding-left);
 width: 28px;
 height: 28px;
 font-size: 28px;
 display: flex;
 align-items: center;
 justify-content: center;
 `, [cB$1("icon", "transition: color .3s var(--n-bezier);")]), cB$1("notification-main", `
 padding-top: var(--n-padding-top);
 padding-bottom: var(--n-padding-bottom);
 box-sizing: border-box;
 display: flex;
 flex-direction: column;
 margin-left: 8px;
 width: calc(100% - 8px);
 `, [cB$1("notification-main-footer", `
 display: flex;
 align-items: center;
 justify-content: space-between;
 margin-top: 12px;
 `, [cE$1("meta", `
 font-size: var(--n-meta-font-size);
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-description-text-color);
 `), cE$1("action", `
 cursor: pointer;
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-action-text-color);
 `)]), cE$1("header", `
 font-weight: var(--n-title-font-weight);
 font-size: var(--n-title-font-size);
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-title-text-color);
 `), cE$1("description", `
 margin-top: 8px;
 font-size: var(--n-description-font-size);
 white-space: pre-wrap;
 word-wrap: break-word;
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-description-text-color);
 `), cE$1("content", `
 line-height: var(--n-line-height);
 margin: 12px 0 0 0;
 font-family: inherit;
 white-space: pre-wrap;
 word-wrap: break-word;
 transition: color .3s var(--n-bezier-ease-out);
 color: var(--n-text-color);
 `, [c$2("&:first-child", {
  margin: 0
})])])])])]);
function placementTransformStyle(placement) {
  const direction = placement.split("-")[1];
  const transformXEnter = direction === "left" ? "calc(-100%)" : "calc(100%)";
  const transformXLeave = "0";
  return cB$1("notification-wrapper", [c$2("&.notification-transition-enter-from, &.notification-transition-leave-to", `
 transform: translate(${transformXEnter}, 0);
 `), c$2("&.notification-transition-leave-from, &.notification-transition-enter-to", `
 transform: translate(${transformXLeave}, 0);
 `)]);
}
const notificationApiInjectionKey = createInjectionKey("n-notification-api");
const notificationProviderProps = Object.assign(Object.assign({}, useTheme.props), { containerStyle: [String, Object], to: [String, Object], scrollable: {
  type: Boolean,
  default: true
}, max: Number, placement: {
  type: String,
  default: "top-right"
}, keepAliveOnHover: Boolean });
var NNotificationProvider = defineComponent({
  name: "NotificationProvider",
  props: notificationProviderProps,
  setup(props) {
    const { mergedClsPrefixRef } = useConfig(props);
    const notificationListRef = ref([]);
    const notificationRefs = {};
    const leavingKeySet = new Set();
    function create(options) {
      const key = createId();
      const destroy = () => {
        leavingKeySet.add(key);
        if (notificationRefs[key]) {
          notificationRefs[key].hide();
        }
      };
      const notificationReactive = reactive(Object.assign(Object.assign({}, options), {
        key,
        destroy,
        hide: destroy,
        deactivate: destroy
      }));
      const { max } = props;
      if (max && notificationListRef.value.length - leavingKeySet.size >= max) {
        let someoneMountedRemoved = false;
        let index2 = 0;
        for (const notification of notificationListRef.value) {
          if (!leavingKeySet.has(notification.key)) {
            if (notificationRefs[notification.key]) {
              notification.destroy();
              someoneMountedRemoved = true;
            }
            break;
          }
          index2++;
        }
        if (!someoneMountedRemoved) {
          notificationListRef.value.splice(index2, 1);
        }
      }
      notificationListRef.value.push(notificationReactive);
      return notificationReactive;
    }
    const apis = ["info", "success", "warning", "error"].map((type4) => {
      return (options) => create(Object.assign(Object.assign({}, options), { type: type4 }));
    });
    function handleAfterLeave(key) {
      leavingKeySet.delete(key);
      notificationListRef.value.splice(notificationListRef.value.findIndex((notification) => notification.key === key), 1);
    }
    const themeRef = useTheme("Notification", "-notification", style$8, notificationLight$1, props, mergedClsPrefixRef);
    const api = {
      create,
      info: apis[0],
      success: apis[1],
      warning: apis[2],
      error: apis[3],
      open,
      destroyAll
    };
    const wipTransitionCountRef = ref(0);
    provide(notificationApiInjectionKey, api);
    provide(notificationProviderInjectionKey, {
      props,
      mergedClsPrefixRef,
      mergedThemeRef: themeRef,
      wipTransitionCountRef
    });
    function open(options) {
      return create(options);
    }
    function destroyAll() {
      Object.values(notificationListRef.value).forEach((notification) => {
        notification.hide();
      });
    }
    return Object.assign({
      mergedClsPrefix: mergedClsPrefixRef,
      notificationList: notificationListRef,
      notificationRefs,
      handleAfterLeave
    }, api);
  },
  render() {
    var _a2, _b2, _c2;
    const { placement } = this;
    return h$1(Fragment, null, (_b2 = (_a2 = this.$slots).default) === null || _b2 === void 0 ? void 0 : _b2.call(_a2), this.notificationList.length ? h$1(Teleport, { to: (_c2 = this.to) !== null && _c2 !== void 0 ? _c2 : "body" }, h$1(NotificationContainer, { style: this.containerStyle, scrollable: this.scrollable && placement !== "top" && placement !== "bottom", placement }, {
      default: () => {
        return this.notificationList.map((notification) => {
          return h$1(NotificationEnvironment, Object.assign({ ref: (inst) => {
            const refKey = notification.key;
            if (inst === null) {
              delete this.notificationRefs[refKey];
            } else
              this.notificationRefs[refKey] = inst;
          } }, omit(notification, [
            "destroy",
            "hide",
            "deactivate"
          ]), { internalKey: notification.key, onInternalAfterLeave: this.handleAfterLeave, keepAliveOnHover: notification.keepAliveOnHover === void 0 ? this.keepAliveOnHover : notification.keepAliveOnHover }));
        });
      }
    })) : null);
  }
});
function useNotification() {
  const api = inject(notificationApiInjectionKey, null);
  if (api === null) {
    throwError("use-notification", "No outer `n-notification-provider` found.");
  }
  return api;
}
var style$7 = c$2([cB$1("progress", {
  display: "inline-block"
}, [cB$1("progress-icon", `
 color: var(--n-icon-color);
 transition: color .3s var(--n-bezier);
 `), cM("line", `
 width: 100%;
 display: block;
 `, [cB$1("progress-content", `
 display: flex;
 align-items: center;
 `, [cB$1("progress-graph", {
  flex: 1
})]), cB$1("progress-custom-content", {
  marginLeft: "14px"
}), cB$1("progress-icon", `
 width: 30px;
 padding-left: 14px;
 height: var(--n-icon-size-line);
 line-height: var(--n-icon-size-line);
 font-size: var(--n-icon-size-line);
 `, [cM("as-text", `
 color: var(--n-text-color-line-outer);
 text-align: center;
 width: 40px;
 font-size: var(--n-font-size);
 padding-left: 4px;
 transition: color .3s var(--n-bezier);
 `)])]), cM("circle, dashboard", {
  width: "120px"
}, [cB$1("progress-custom-content", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 display: flex;
 align-items: center;
 justify-content: center;
 `), cB$1("progress-text", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 display: flex;
 align-items: center;
 color: inherit;
 font-size: var(--n-font-size-circle);
 color: var(--n-text-color-circle);
 font-weight: var(--n-font-weight-circle);
 transition: color .3s var(--n-bezier);
 white-space: nowrap;
 `), cB$1("progress-icon", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 display: flex;
 align-items: center;
 color: var(--n-icon-color);
 font-size: var(--n-icon-size-circle);
 `)]), cM("multiple-circle", `
 width: 200px;
 color: inherit;
 `, [cB$1("progress-text", `
 font-weight: var(--n-font-weight-circle);
 color: var(--n-text-color-circle);
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 display: flex;
 align-items: center;
 justify-content: center;
 transition: color .3s var(--n-bezier);
 `)]), cB$1("progress-content", {
  position: "relative"
}), cB$1("progress-graph", {
  position: "relative"
}, [cB$1("progress-graph-circle", [c$2("svg", {
  verticalAlign: "bottom"
}), cB$1("progress-graph-circle-fill", `
 stroke: var(--n-fill-color);
 transition:
 opacity .3s var(--n-bezier),
 stroke .3s var(--n-bezier),
 stroke-dasharray .3s var(--n-bezier);
 `, [cM("empty", {
  opacity: 0
})]), cB$1("progress-graph-circle-rail", `
 transition: stroke .3s var(--n-bezier);
 overflow: hidden;
 stroke: var(--n-rail-color);
 `)]), cB$1("progress-graph-line", [cM("indicator-inside", [cB$1("progress-graph-line-rail", `
 height: 16px;
 line-height: 16px;
 border-radius: 10px;
 `, [cB$1("progress-graph-line-fill", `
 height: inherit;
 border-radius: 10px;
 `), cB$1("progress-graph-line-indicator", `
 background: #0000;
 white-space: nowrap;
 text-align: right;
 margin-left: 14px;
 margin-right: 14px;
 height: inherit;
 font-size: 12px;
 color: var(--n-text-color-line-inner);
 transition: color .3s var(--n-bezier);
 `)])]), cM("indicator-inside-label", `
 height: 16px;
 display: flex;
 align-items: center;
 `, [cB$1("progress-graph-line-rail", `
 flex: 1;
 transition: background-color .3s var(--n-bezier);
 `), cB$1("progress-graph-line-indicator", `
 background: var(--n-fill-color);
 font-size: 12px;
 transform: translateZ(0);
 display: flex;
 vertical-align: middle;
 height: 16px;
 line-height: 16px;
 padding: 0 10px;
 border-radius: 10px;
 position: absolute;
 white-space: nowrap;
 color: var(--n-text-color-line-inner);
 transition:
 right .2s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `)]), cB$1("progress-graph-line-rail", `
 position: relative;
 overflow: hidden;
 height: var(--n-rail-height);
 border-radius: 5px;
 background-color: var(--n-rail-color);
 transition: background-color .3s var(--n-bezier);
 `, [cB$1("progress-graph-line-fill", `
 background: var(--n-fill-color);
 position: relative;
 border-radius: 5px;
 height: inherit;
 width: 100%;
 max-width: 0%;
 transition:
 background-color .3s var(--n-bezier),
 max-width .2s var(--n-bezier);
 `, [cM("processing", [c$2("&::after", `
 content: "";
 background-image: var(--n-line-bg-processing);
 animation: progress-processing-animation 2s var(--n-bezier) infinite;
 `)])])])])])]), c$2("@keyframes progress-processing-animation", `
 0% {
 position: absolute;
 left: 0;
 top: 0;
 bottom: 0;
 right: 100%;
 opacity: 1;
 }
 66% {
 position: absolute;
 left: 0;
 top: 0;
 bottom: 0;
 right: 0;
 opacity: 0;
 }
 100% {
 position: absolute;
 left: 0;
 top: 0;
 bottom: 0;
 right: 0;
 opacity: 0;
 }
 `)]);
const iconMap$1 = {
  success: h$1(SuccessIcon, null),
  error: h$1(ErrorIcon, null),
  warning: h$1(WarningIcon, null),
  info: h$1(InfoIcon, null)
};
var Line$1 = defineComponent({
  name: "ProgressLine",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    percentage: {
      type: Number,
      default: 0
    },
    railColor: String,
    railStyle: [String, Object],
    fillColor: String,
    status: {
      type: String,
      required: true
    },
    indicatorPlacement: {
      type: String,
      required: true
    },
    indicatorTextColor: String,
    unit: {
      type: String,
      default: "%"
    },
    processing: {
      type: Boolean,
      required: true
    },
    showIndicator: {
      type: Boolean,
      required: true
    },
    height: [String, Number],
    railBorderRadius: [String, Number],
    fillBorderRadius: [String, Number]
  },
  setup(props, { slots }) {
    const styleHeightRef = computed(() => {
      return formatLength(props.height);
    });
    const styleRailBorderRadiusRef = computed(() => {
      if (props.railBorderRadius !== void 0) {
        return formatLength(props.railBorderRadius);
      }
      if (props.height !== void 0) {
        return formatLength(props.height, { c: 0.5 });
      }
      return "";
    });
    const styleFillBorderRadiusRef = computed(() => {
      if (props.fillBorderRadius !== void 0) {
        return formatLength(props.fillBorderRadius);
      }
      if (props.railBorderRadius !== void 0) {
        return formatLength(props.railBorderRadius);
      }
      if (props.height !== void 0) {
        return formatLength(props.height, { c: 0.5 });
      }
      return "";
    });
    return () => {
      const { indicatorPlacement, railColor, railStyle, percentage: percentage2, unit, indicatorTextColor, status, showIndicator, fillColor, processing, clsPrefix } = props;
      return h$1("div", { class: `${clsPrefix}-progress-content`, role: "none" }, h$1("div", { class: `${clsPrefix}-progress-graph`, "aria-hidden": true }, h$1("div", { class: [
        `${clsPrefix}-progress-graph-line`,
        {
          [`${clsPrefix}-progress-graph-line--indicator-${indicatorPlacement}`]: true
        }
      ] }, h$1("div", { class: `${clsPrefix}-progress-graph-line-rail`, style: [
        {
          backgroundColor: railColor,
          height: styleHeightRef.value,
          borderRadius: styleRailBorderRadiusRef.value
        },
        railStyle
      ] }, h$1("div", { class: [
        `${clsPrefix}-progress-graph-line-fill`,
        processing && `${clsPrefix}-progress-graph-line-fill--processing`
      ], style: {
        maxWidth: `${props.percentage}%`,
        backgroundColor: fillColor,
        height: styleHeightRef.value,
        lineHeight: styleHeightRef.value,
        borderRadius: styleFillBorderRadiusRef.value
      } }, indicatorPlacement === "inside" ? h$1("div", { class: `${clsPrefix}-progress-graph-line-indicator`, style: {
        color: indicatorTextColor
      } }, percentage2, unit) : null)))), showIndicator && indicatorPlacement === "outside" ? h$1("div", null, slots.default ? h$1("div", { class: `${clsPrefix}-progress-custom-content`, style: {
        color: indicatorTextColor
      }, role: "none" }, slots.default()) : status === "default" ? h$1("div", { role: "none", class: `${clsPrefix}-progress-icon ${clsPrefix}-progress-icon--as-text`, style: {
        color: indicatorTextColor
      } }, percentage2, unit) : h$1("div", { class: `${clsPrefix}-progress-icon`, "aria-hidden": true }, h$1(NBaseIcon, { clsPrefix }, { default: () => iconMap$1[status] }))) : null);
    };
  }
});
const iconMap = {
  success: h$1(SuccessIcon, null),
  error: h$1(ErrorIcon, null),
  warning: h$1(WarningIcon, null),
  info: h$1(InfoIcon, null)
};
var Circle = defineComponent({
  name: "ProgressCircle",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    strokeWidth: {
      type: Number,
      required: true
    },
    fillColor: String,
    railColor: String,
    railStyle: [String, Object],
    percentage: {
      type: Number,
      default: 0
    },
    offsetDegree: {
      type: Number,
      default: 0
    },
    showIndicator: {
      type: Boolean,
      required: true
    },
    indicatorTextColor: String,
    unit: String,
    viewBoxWidth: {
      type: Number,
      required: true
    },
    gapDegree: {
      type: Number,
      required: true
    },
    gapOffsetDegree: {
      type: Number,
      default: 0
    }
  },
  setup(props, { slots }) {
    function getPathStyles(percent2, offsetDegree, strokeColor) {
      const { gapDegree, viewBoxWidth, strokeWidth } = props;
      const radius = 50;
      const beginPositionX = 0;
      const beginPositionY = radius;
      const endPositionX = 0;
      const endPositionY = 2 * radius;
      const centerX = 50 + strokeWidth / 2;
      const pathString = `M ${centerX},${centerX} m ${beginPositionX},${beginPositionY}
      a ${radius},${radius} 0 1 1 ${endPositionX},${-endPositionY}
      a ${radius},${radius} 0 1 1 ${-endPositionX},${endPositionY}`;
      const len2 = Math.PI * 2 * radius;
      const pathStyle = {
        stroke: strokeColor,
        strokeDasharray: `${percent2 / 100 * (len2 - gapDegree)}px ${viewBoxWidth * 8}px`,
        strokeDashoffset: `-${gapDegree / 2}px`,
        transformOrigin: offsetDegree ? "center" : void 0,
        transform: offsetDegree ? `rotate(${offsetDegree}deg)` : void 0
      };
      return {
        pathString,
        pathStyle
      };
    }
    return () => {
      const { fillColor, railColor, strokeWidth, offsetDegree, status, percentage: percentage2, showIndicator, indicatorTextColor, unit, gapOffsetDegree, clsPrefix } = props;
      const { pathString: railPathString, pathStyle: railPathStyle } = getPathStyles(100, 0, railColor);
      const { pathString: fillPathString, pathStyle: fillPathStyle } = getPathStyles(percentage2, offsetDegree, fillColor);
      const viewBoxSize = 100 + strokeWidth;
      return h$1("div", { class: `${clsPrefix}-progress-content`, role: "none" }, h$1("div", { class: `${clsPrefix}-progress-graph`, "aria-hidden": true }, h$1("div", { class: `${clsPrefix}-progress-graph-circle`, style: {
        transform: gapOffsetDegree ? `rotate(${gapOffsetDegree}deg)` : void 0
      } }, h$1("svg", { viewBox: `0 0 ${viewBoxSize} ${viewBoxSize}` }, h$1("g", null, h$1("path", { class: `${clsPrefix}-progress-graph-circle-rail`, d: railPathString, "stroke-width": strokeWidth, "stroke-linecap": "round", fill: "none", style: railPathStyle })), h$1("g", null, h$1("path", { class: [
        `${clsPrefix}-progress-graph-circle-fill`,
        percentage2 === 0 && `${clsPrefix}-progress-graph-circle-fill--empty`
      ], d: fillPathString, "stroke-width": strokeWidth, "stroke-linecap": "round", fill: "none", style: fillPathStyle }))))), showIndicator ? h$1("div", null, slots.default ? h$1("div", { class: `${clsPrefix}-progress-custom-content`, role: "none" }, slots.default()) : status !== "default" ? h$1("div", { class: `${clsPrefix}-progress-icon`, "aria-hidden": true }, h$1(NBaseIcon, { clsPrefix }, {
        default: () => iconMap[status]
      })) : h$1("div", { class: `${clsPrefix}-progress-text`, style: {
        color: indicatorTextColor
      }, role: "none" }, h$1("span", { class: `${clsPrefix}-progress-text__percentage` }, percentage2), h$1("span", { class: `${clsPrefix}-progress-text__unit` }, unit))) : null);
    };
  }
});
function circlePath(r2, sw2, vw2 = 100) {
  return `m ${vw2 / 2} ${vw2 / 2 - r2} a ${r2} ${r2} 0 1 1 0 ${2 * r2} a ${r2} ${r2} 0 1 1 0 -${2 * r2}`;
}
var MultipleCircle = defineComponent({
  name: "ProgressMultipleCircle",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    viewBoxWidth: {
      type: Number,
      required: true
    },
    percentage: {
      type: Array,
      default: [0]
    },
    strokeWidth: {
      type: Number,
      required: true
    },
    circleGap: {
      type: Number,
      required: true
    },
    showIndicator: {
      type: Boolean,
      required: true
    },
    fillColor: {
      type: Array,
      default: () => []
    },
    railColor: {
      type: Array,
      default: () => []
    },
    railStyle: {
      type: Array,
      default: () => []
    }
  },
  setup(props, { slots }) {
    const strokeDasharrayRef = computed(() => {
      const strokeDasharrays = props.percentage.map((v2, i2) => `${Math.PI * v2 / 100 * (props.viewBoxWidth / 2 - props.strokeWidth / 2 * (1 + 2 * i2) - props.circleGap * i2) * 2}, ${props.viewBoxWidth * 8}`);
      return strokeDasharrays;
    });
    return () => {
      const { viewBoxWidth, strokeWidth, circleGap, showIndicator, fillColor, railColor, railStyle, percentage: percentage2, clsPrefix } = props;
      return h$1("div", { class: `${clsPrefix}-progress-content`, role: "none" }, h$1("div", { class: `${clsPrefix}-progress-graph`, "aria-hidden": true }, h$1("div", { class: `${clsPrefix}-progress-graph-circle` }, h$1("svg", { viewBox: `0 0 ${viewBoxWidth} ${viewBoxWidth}` }, percentage2.map((p2, index2) => {
        return h$1("g", { key: index2 }, h$1("path", { class: `${clsPrefix}-progress-graph-circle-rail`, d: circlePath(viewBoxWidth / 2 - strokeWidth / 2 * (1 + 2 * index2) - circleGap * index2, strokeWidth, viewBoxWidth), "stroke-width": strokeWidth, "stroke-linecap": "round", fill: "none", style: [
          {
            strokeDashoffset: 0,
            stroke: railColor[index2]
          },
          railStyle[index2]
        ] }), h$1("path", { class: [
          `${clsPrefix}-progress-graph-circle-fill`,
          p2 === 0 && `${clsPrefix}-progress-graph-circle-fill--empty`
        ], d: circlePath(viewBoxWidth / 2 - strokeWidth / 2 * (1 + 2 * index2) - circleGap * index2, strokeWidth, viewBoxWidth), "stroke-width": strokeWidth, "stroke-linecap": "round", fill: "none", style: {
          strokeDasharray: strokeDasharrayRef.value[index2],
          strokeDashoffset: 0,
          stroke: fillColor[index2]
        } }));
      })))), showIndicator && slots.default ? h$1("div", null, h$1("div", { class: `${clsPrefix}-progress-text` }, slots.default())) : null);
    };
  }
});
const progressProps = Object.assign(Object.assign({}, useTheme.props), { processing: Boolean, type: {
  type: String,
  default: "line"
}, gapDegree: Number, gapOffsetDegree: Number, status: {
  type: String,
  default: "default"
}, railColor: [String, Array], railStyle: [String, Array], color: [String, Array], viewBoxWidth: {
  type: Number,
  default: 100
}, strokeWidth: {
  type: Number,
  default: 7
}, percentage: [Number, Array], unit: {
  type: String,
  default: "%"
}, showIndicator: {
  type: Boolean,
  default: true
}, indicatorPosition: {
  type: String,
  default: "outside"
}, indicatorPlacement: {
  type: String,
  default: "outside"
}, indicatorTextColor: String, circleGap: {
  type: Number,
  default: 1
}, height: Number, borderRadius: [String, Number], fillBorderRadius: [String, Number], offsetDegree: Number });
var NProgress = defineComponent({
  name: "Progress",
  props: progressProps,
  setup(props) {
    const mergedIndicatorPlacementRef = computed(() => {
      return props.indicatorPlacement || props.indicatorPosition;
    });
    const gapDeg = computed(() => {
      if (props.gapDegree || props.gapDegree === 0) {
        return props.gapDegree;
      }
      if (props.type === "dashboard") {
        return 75;
      }
      return void 0;
    });
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Progress", "-progress", style$7, progressLight$1, props, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { status } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { fontSize: fontSize2, fontSizeCircle, railColor, railHeight, iconSizeCircle, iconSizeLine, textColorCircle, textColorLineInner, textColorLineOuter, lineBgProcessing, fontWeightCircle, [createKey("iconColor", status)]: iconColor, [createKey("fillColor", status)]: fillColor } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-fill-color": fillColor,
        "--n-font-size": fontSize2,
        "--n-font-size-circle": fontSizeCircle,
        "--n-font-weight-circle": fontWeightCircle,
        "--n-icon-color": iconColor,
        "--n-icon-size-circle": iconSizeCircle,
        "--n-icon-size-line": iconSizeLine,
        "--n-line-bg-processing": lineBgProcessing,
        "--n-rail-color": railColor,
        "--n-rail-height": railHeight,
        "--n-text-color-circle": textColorCircle,
        "--n-text-color-line-inner": textColorLineInner,
        "--n-text-color-line-outer": textColorLineOuter
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("progress", computed(() => props.status[0]), cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      mergedIndicatorPlacement: mergedIndicatorPlacementRef,
      gapDeg,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const { type: type4, cssVars, indicatorTextColor, showIndicator, status, railColor, railStyle, color, percentage: percentage2, viewBoxWidth, strokeWidth, mergedIndicatorPlacement, unit, borderRadius, fillBorderRadius, height, processing, circleGap, mergedClsPrefix, gapDeg, gapOffsetDegree, themeClass, $slots, onRender } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { class: [
      themeClass,
      `${mergedClsPrefix}-progress`,
      `${mergedClsPrefix}-progress--${type4}`,
      `${mergedClsPrefix}-progress--${status}`
    ], style: cssVars, "aria-valuemax": 100, "aria-valuemin": 0, "aria-valuenow": percentage2, role: type4 === "circle" || type4 === "line" || type4 === "dashboard" ? "progressbar" : "none" }, type4 === "circle" || type4 === "dashboard" ? h$1(Circle, { clsPrefix: mergedClsPrefix, status, showIndicator, indicatorTextColor, railColor, fillColor: color, railStyle, offsetDegree: this.offsetDegree, percentage: percentage2, viewBoxWidth, strokeWidth, gapDegree: gapDeg === void 0 ? type4 === "dashboard" ? 75 : 0 : gapDeg, gapOffsetDegree, unit }, $slots) : type4 === "line" ? h$1(Line$1, { clsPrefix: mergedClsPrefix, status, showIndicator, indicatorTextColor, railColor, fillColor: color, railStyle, percentage: percentage2, processing, indicatorPlacement: mergedIndicatorPlacement, unit, fillBorderRadius, railBorderRadius: borderRadius, height }, $slots) : type4 === "multiple-circle" ? h$1(MultipleCircle, { clsPrefix: mergedClsPrefix, strokeWidth, railColor, fillColor: color, railStyle, viewBoxWidth, percentage: percentage2, showIndicator, circleGap }, $slots) : null);
  }
});
const self$1 = (vars) => {
  const { heightSmall, heightMedium, heightLarge, borderRadius } = vars;
  return {
    color: "#eee",
    colorEnd: "#ddd",
    borderRadius,
    heightSmall,
    heightMedium,
    heightLarge
  };
};
const skeletonLight = {
  name: "Skeleton",
  common: commonLight,
  self: self$1
};
var style$6 = c$2([cB$1("skeleton", `
 height: 1em;
 width: 100%;
 transition: background-color .3s var(--n-bezier);
 transition:
 --n-color-start .3s var(--n-bezier),
 --n-color-end .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 animation: 2s skeleton-loading infinite cubic-bezier(0.36, 0, 0.64, 1);
 background-color: var(--n-color-start);
 `), c$2("@keyframes skeleton-loading", `
 0% {
 background: var(--n-color-start);
 }
 40% {
 background: var(--n-color-end);
 }
 80% {
 background: var(--n-color-start);
 }
 100% {
 background: var(--n-color-start);
 }
 `)]);
const skeletonProps = Object.assign(Object.assign({}, useTheme.props), { text: Boolean, round: Boolean, circle: Boolean, height: [String, Number], width: [String, Number], size: String, repeat: {
  type: Number,
  default: 1
}, animated: {
  type: Boolean,
  default: true
}, sharp: {
  type: Boolean,
  default: true
} });
var NSkeleton = defineComponent({
  name: "Skeleton",
  inheritAttrs: false,
  props: skeletonProps,
  setup(props) {
    useHoudini();
    const { mergedClsPrefixRef } = useConfig(props);
    const themeRef = useTheme("Skeleton", "-skeleton", style$6, skeletonLight, props, mergedClsPrefixRef);
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      style: computed(() => {
        var _a2, _b2;
        const theme2 = themeRef.value;
        const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 } } = theme2;
        const selfThemeVars = theme2.self;
        const { color, colorEnd, borderRadius } = selfThemeVars;
        let sizeHeight;
        const { circle, sharp, round, width, height, size: size2, text, animated } = props;
        if (size2 !== void 0) {
          sizeHeight = selfThemeVars[createKey("height", size2)];
        }
        const mergedWidth = circle ? (_a2 = width !== null && width !== void 0 ? width : height) !== null && _a2 !== void 0 ? _a2 : sizeHeight : width;
        const mergedHeight = (_b2 = circle ? width !== null && width !== void 0 ? width : height : height) !== null && _b2 !== void 0 ? _b2 : sizeHeight;
        return {
          display: text ? "inline-block" : "",
          verticalAlign: text ? "-0.125em" : "",
          borderRadius: circle ? "50%" : round ? "4096px" : sharp ? "" : borderRadius,
          width: typeof mergedWidth === "number" ? pxfy(mergedWidth) : mergedWidth,
          height: typeof mergedHeight === "number" ? pxfy(mergedHeight) : mergedHeight,
          animation: !animated ? "none" : "",
          "--n-bezier": cubicBezierEaseInOut2,
          "--n-color-start": color,
          "--n-color-end": colorEnd
        };
      })
    };
  },
  render() {
    const { repeat: repeat2, style: style2, mergedClsPrefix, $attrs } = this;
    const child = h$1("div", mergeProps({
      class: `${mergedClsPrefix}-skeleton`,
      style: style2
    }, $attrs));
    if (repeat2 > 1) {
      return h$1(Fragment, null, Array.apply(null, { length: repeat2 }).map((_2) => [
        child,
        "\n"
      ]));
    }
    return child;
  }
});
function isTouchEvent(e25) {
  return window.TouchEvent && e25 instanceof window.TouchEvent;
}
function useRefs() {
  const refs = ref(new Map());
  const setRefs = (index2) => (el2) => {
    refs.value.set(index2, el2);
  };
  onBeforeUpdate(() => {
    refs.value.clear();
  });
  return [refs, setRefs];
}
var style$5 = c$2([cB$1("slider", `
 display: block;
 padding: calc((var(--n-handle-size) - var(--n-rail-height)) / 2) 0;
 position: relative;
 z-index: 0;
 width: 100%;
 cursor: pointer;
 user-select: none;
 -webkit-user-select: none;
 `, [cM("reverse", [cB$1("slider-handles", [cB$1("slider-handle-wrapper", `
 transform: translate(50%, -50%);
 `)]), cB$1("slider-dots", [cB$1("slider-dot", `
 transform: translateX(50%, -50%);
 `)]), cM("vertical", [cB$1("slider-handles", [cB$1("slider-handle-wrapper", `
 transform: translate(-50%, -50%);
 `)]), cB$1("slider-marks", [cB$1("slider-mark", `
 transform: translateY(calc(-50% + var(--n-dot-height) / 2));
 `)]), cB$1("slider-dots", [cB$1("slider-dot", `
 transform: translateX(-50%) translateY(0);
 `)])])]), cM("vertical", `
 padding: 0 calc((var(--n-handle-size) - var(--n-rail-height)) / 2);
 width: var(--n-rail-width-vertical);
 height: 100%;
 `, [cB$1("slider-handles", `
 top: calc(var(--n-handle-size) / 2);
 right: 0;
 bottom: calc(var(--n-handle-size) / 2);
 left: 0;
 `, [cB$1("slider-handle-wrapper", `
 top: unset;
 left: 50%;
 transform: translate(-50%, 50%);
 `)]), cB$1("slider-rail", `
 height: 100%;
 `, [cE$1("fill", `
 top: unset;
 right: 0;
 bottom: unset;
 left: 0;
 `)]), cM("with-mark", `
 width: var(--n-rail-width-vertical);
 margin: 0 32px 0 8px;
 `), cB$1("slider-marks", `
 top: calc(var(--n-handle-size) / 2);
 right: unset;
 bottom: calc(var(--n-handle-size) / 2);
 left: 22px;
 font-size: var(--n-mark-font-size);
 `, [cB$1("slider-mark", `
 transform: translateY(50%);
 white-space: nowrap;
 `)]), cB$1("slider-dots", `
 top: calc(var(--n-handle-size) / 2);
 right: unset;
 bottom: calc(var(--n-handle-size) / 2);
 left: 50%;
 `, [cB$1("slider-dot", `
 transform: translateX(-50%) translateY(50%);
 `)])]), cM("disabled", `
 cursor: not-allowed;
 opacity: var(--n-opacity-disabled);
 `, [cB$1("slider-handle", `
 cursor: not-allowed;
 `)]), cM("with-mark", `
 width: 100%;
 margin: 8px 0 32px 0;
 `), c$2("&:hover", [cB$1("slider-rail", {
  backgroundColor: "var(--n-rail-color-hover)"
}, [cE$1("fill", {
  backgroundColor: "var(--n-fill-color-hover)"
})]), cB$1("slider-handle", {
  boxShadow: "var(--n-handle-box-shadow-hover)"
})]), cM("active", [cB$1("slider-rail", {
  backgroundColor: "var(--n-rail-color-hover)"
}, [cE$1("fill", {
  backgroundColor: "var(--n-fill-color-hover)"
})]), cB$1("slider-handle", {
  boxShadow: "var(--n-handle-box-shadow-hover)"
})]), cB$1("slider-marks", `
 position: absolute;
 top: 18px;
 left: calc(var(--n-handle-size) / 2);
 right: calc(var(--n-handle-size) / 2);
 `, [cB$1("slider-mark", `
 position: absolute;
 transform: translateX(-50%);
 white-space: nowrap;
 `)]), cB$1("slider-rail", `
 width: 100%;
 position: relative;
 height: var(--n-rail-height);
 background-color: var(--n-rail-color);
 transition: background-color .3s var(--n-bezier);
 border-radius: calc(var(--n-rail-height) / 2);
 `, [cE$1("fill", `
 position: absolute;
 top: 0;
 bottom: 0;
 border-radius: calc(var(--n-rail-height) / 2);
 transition: background-color .3s var(--n-bezier);
 background-color: var(--n-fill-color);
 `)]), cB$1("slider-handles", `
 position: absolute;
 top: 0;
 right: calc(var(--n-handle-size) / 2);
 bottom: 0;
 left: calc(var(--n-handle-size) / 2);
 `, [cB$1("slider-handle-wrapper", `
 outline: none;
 position: absolute;
 top: 50%;
 transform: translate(-50%, -50%);
 cursor: pointer;
 display: flex;
 `, [cB$1("slider-handle", `
 height: var(--n-handle-size);
 width: var(--n-handle-size);
 border-radius: 50%;
 overflow: hidden;
 transition: box-shadow .2s var(--n-bezier), background-color .3s var(--n-bezier);
 background-color: var(--n-handle-color);
 box-shadow: var(--n-handle-box-shadow);
 `, [c$2("&:hover", `
 box-shadow: var(--n-handle-box-shadow-hover);
 `)]), c$2("&:focus", [cB$1("slider-handle", `
 box-shadow: var(--n-handle-box-shadow-focus);
 `, [c$2("&:hover", `
 box-shadow: var(--n-handle-box-shadow-active);
 `)])])])]), cB$1("slider-dots", `
 position: absolute;
 top: 50%;
 left: calc(var(--n-handle-size) / 2);
 right: calc(var(--n-handle-size) / 2);
 `, [cM("transition-disabled", [cB$1("slider-dot", "transition: none;")]), cB$1("slider-dot", `
 transition:
 border-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 position: absolute;
 transform: translate(-50%, -50%);
 height: var(--n-dot-height);
 width: var(--n-dot-width);
 border-radius: var(--n-dot-border-radius);
 overflow: hidden;
 box-sizing: border-box;
 border: var(--n-dot-border);
 background-color: var(--n-dot-color);
 `, [cM("active", "border: var(--n-dot-border-active);")])])]), cB$1("slider-handle-indicator", `
 font-size: var(--n-font-size);
 padding: 6px 10px;
 border-radius: var(--n-indicator-border-radius);
 color: var(--n-indicator-text-color);
 background-color: var(--n-indicator-color);
 box-shadow: var(--n-indicator-box-shadow);
 `, [fadeInScaleUpTransition()]), cB$1("slider-handle-indicator", `
 font-size: var(--n-font-size);
 padding: 6px 10px;
 border-radius: var(--n-indicator-border-radius);
 color: var(--n-indicator-text-color);
 background-color: var(--n-indicator-color);
 box-shadow: var(--n-indicator-box-shadow);
 `, [cM("top", `
 margin-bottom: 12px;
 `), cM("right", `
 margin-left: 12px;
 `), cM("bottom", `
 margin-top: 12px;
 `), cM("left", `
 margin-right: 12px;
 `), fadeInScaleUpTransition()]), insideModal(cB$1("slider", [cB$1("slider-dot", "background-color: var(--n-dot-color-modal);")])), insidePopover(cB$1("slider", [cB$1("slider-dot", "background-color: var(--n-dot-color-popover);")]))]);
const eventButtonLeft = 0;
const sliderProps = Object.assign(Object.assign({}, useTheme.props), { to: useAdjustedTo.propTo, defaultValue: {
  type: [Number, Array],
  default: 0
}, marks: Object, disabled: {
  type: Boolean,
  default: void 0
}, formatTooltip: Function, keyboard: {
  type: Boolean,
  default: true
}, min: {
  type: Number,
  default: 0
}, max: {
  type: Number,
  default: 100
}, step: {
  type: [Number, String],
  default: 1
}, range: Boolean, value: [Number, Array], placement: String, showTooltip: {
  type: Boolean,
  default: void 0
}, tooltip: {
  type: Boolean,
  default: true
}, vertical: Boolean, reverse: Boolean, "onUpdate:value": [Function, Array], onUpdateValue: [Function, Array] });
var NSlider = defineComponent({
  name: "Slider",
  props: sliderProps,
  setup(props) {
    const { mergedClsPrefixRef, namespaceRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Slider", "-slider", style$5, sliderLight$1, props, mergedClsPrefixRef);
    const handleRailRef = ref(null);
    const [handleRefs, setHandleRefs] = useRefs();
    const [followerRefs, setFollowerRefs] = useRefs();
    const followerEnabledIndexSetRef = ref(new Set());
    const formItem = useFormItem(props);
    const { mergedDisabledRef } = formItem;
    const precisionRef = computed(() => {
      const { step } = props;
      if (Number(step) <= 0 || step === "mark")
        return 0;
      const stepString = step.toString();
      let precision = 0;
      if (stepString.includes(".")) {
        precision = stepString.length - stepString.indexOf(".") - 1;
      }
      return precision;
    });
    const uncontrolledValueRef = ref(props.defaultValue);
    const controlledValueRef = toRef(props, "value");
    const mergedValueRef = useMergedState(controlledValueRef, uncontrolledValueRef);
    const arrifiedValueRef = computed(() => {
      const { value: mergedValue } = mergedValueRef;
      return (props.range ? mergedValue : [mergedValue]).map(clampValue2);
    });
    const handleCountExceeds2Ref = computed(() => arrifiedValueRef.value.length > 2);
    const mergedPlacementRef = computed(() => {
      return props.placement === void 0 ? props.vertical ? "right" : "top" : props.placement;
    });
    const markValuesRef = computed(() => {
      const { marks } = props;
      return marks ? Object.keys(marks).map(parseFloat) : null;
    });
    const activeIndexRef = ref(-1);
    const previousIndexRef = ref(-1);
    const hoverIndexRef = ref(-1);
    const draggingRef = ref(false);
    const dotTransitionDisabledRef = ref(false);
    const styleDirectionRef = computed(() => {
      const { vertical, reverse } = props;
      const left = reverse ? "right" : "left";
      const bottom = reverse ? "top" : "bottom";
      return vertical ? bottom : left;
    });
    const fillStyleRef = computed(() => {
      if (handleCountExceeds2Ref.value)
        return;
      const values2 = arrifiedValueRef.value;
      const start = valueToPercentage(props.range ? Math.min(...values2) : props.min);
      const end = valueToPercentage(props.range ? Math.max(...values2) : values2[0]);
      const { value: styleDirection } = styleDirectionRef;
      return props.vertical ? {
        [styleDirection]: `${start}%`,
        height: `${end - start}%`
      } : {
        [styleDirection]: `${start}%`,
        width: `${end - start}%`
      };
    });
    const markInfosRef = computed(() => {
      const mergedMarks = [];
      const { marks } = props;
      if (marks) {
        const orderValues = arrifiedValueRef.value.slice();
        orderValues.sort((a2, b2) => a2 - b2);
        const { value: styleDirection } = styleDirectionRef;
        const { value: handleCountExceeds2 } = handleCountExceeds2Ref;
        const { range: range3 } = props;
        const isActive = handleCountExceeds2 ? () => false : (num) => range3 ? num >= orderValues[0] && num <= orderValues[orderValues.length - 1] : num <= orderValues[0];
        for (const key of Object.keys(marks)) {
          const num = Number(key);
          mergedMarks.push({
            active: isActive(num),
            label: marks[key],
            style: {
              [styleDirection]: `${valueToPercentage(num)}%`
            }
          });
        }
      }
      return mergedMarks;
    });
    function getHandleStyle(value2, index2) {
      const percentage2 = valueToPercentage(value2);
      const { value: styleDirection } = styleDirectionRef;
      return {
        [styleDirection]: `${percentage2}%`,
        zIndex: index2 === activeIndexRef.value ? 1 : 0
      };
    }
    function isShowTooltip(index2) {
      return props.showTooltip || hoverIndexRef.value === index2 || activeIndexRef.value === index2 && draggingRef.value;
    }
    function shouldKeepTooltipTransition(index2) {
      if (!draggingRef.value)
        return true;
      return !(activeIndexRef.value === index2 && previousIndexRef.value === index2);
    }
    function focusActiveHandle(index2) {
      var _a2;
      if (~index2) {
        activeIndexRef.value = index2;
        (_a2 = handleRefs.value.get(index2)) === null || _a2 === void 0 ? void 0 : _a2.focus();
      }
    }
    function syncPosition() {
      followerRefs.value.forEach((inst, index2) => {
        if (isShowTooltip(index2))
          inst.syncPosition();
      });
    }
    function doUpdateValue(value2) {
      const { "onUpdate:value": _onUpdateValue, onUpdateValue } = props;
      const { nTriggerFormInput, nTriggerFormChange } = formItem;
      if (onUpdateValue)
        call(onUpdateValue, value2);
      if (_onUpdateValue)
        call(_onUpdateValue, value2);
      uncontrolledValueRef.value = value2;
      nTriggerFormInput();
      nTriggerFormChange();
    }
    function dispatchValueUpdate(value2) {
      const { range: range3 } = props;
      if (range3) {
        if (Array.isArray(value2)) {
          const { value: oldValues } = arrifiedValueRef;
          if (value2.join() !== oldValues.join()) {
            doUpdateValue(value2);
          }
        }
      } else if (!Array.isArray(value2)) {
        const oldValue = arrifiedValueRef.value[0];
        if (oldValue !== value2) {
          doUpdateValue(value2);
        }
      }
    }
    function doDispatchValue(value2, index2) {
      if (props.range) {
        const values2 = arrifiedValueRef.value.slice();
        values2.splice(index2, 1, value2);
        dispatchValueUpdate(values2);
      } else {
        dispatchValueUpdate(value2);
      }
    }
    function sanitizeValue(value2, currentValue, stepBuffer) {
      const stepping = stepBuffer !== void 0;
      if (!stepBuffer) {
        stepBuffer = value2 - currentValue > 0 ? 1 : -1;
      }
      const markValues = markValuesRef.value || [];
      const { step } = props;
      if (step === "mark") {
        const closestMark2 = getClosestMark(value2, markValues.concat(currentValue), stepping ? stepBuffer : void 0);
        return closestMark2 ? closestMark2.value : currentValue;
      }
      if (step <= 0)
        return currentValue;
      const { value: precision } = precisionRef;
      let closestMark;
      if (stepping) {
        const currentStep = Number((currentValue / step).toFixed(precision));
        const actualStep = Math.floor(currentStep);
        const leftStep = currentStep > actualStep ? actualStep : actualStep - 1;
        const rightStep = currentStep < actualStep ? actualStep : actualStep + 1;
        closestMark = getClosestMark(currentValue, [
          Number((leftStep * step).toFixed(precision)),
          Number((rightStep * step).toFixed(precision)),
          ...markValues
        ], stepBuffer);
      } else {
        const roundValue = getRoundValue(value2);
        closestMark = getClosestMark(value2, [...markValues, roundValue]);
      }
      return closestMark ? clampValue2(closestMark.value) : currentValue;
    }
    function clampValue2(value2) {
      return Math.min(props.max, Math.max(props.min, value2));
    }
    function valueToPercentage(value2) {
      const { max, min } = props;
      return (value2 - min) / (max - min) * 100;
    }
    function percentageToValue(percentage2) {
      const { max, min } = props;
      return min + (max - min) * percentage2;
    }
    function getRoundValue(value2) {
      const { step, min } = props;
      if (Number(step) <= 0 || step === "mark")
        return value2;
      const newValue = Math.round((value2 - min) / step) * step + min;
      return Number(newValue.toFixed(precisionRef.value));
    }
    function getClosestMark(currentValue, markValues = markValuesRef.value, buffer) {
      if (!(markValues === null || markValues === void 0 ? void 0 : markValues.length))
        return null;
      let closestMark = null;
      let index2 = -1;
      while (++index2 < markValues.length) {
        const diff = markValues[index2] - currentValue;
        const distance = Math.abs(diff);
        if ((buffer === void 0 || diff * buffer > 0) && (closestMark === null || distance < closestMark.distance)) {
          closestMark = {
            index: index2,
            distance,
            value: markValues[index2]
          };
        }
      }
      return closestMark;
    }
    function getPointValue(event) {
      const railEl = handleRailRef.value;
      if (!railEl)
        return;
      const touchEvent = isTouchEvent(event) ? event.touches[0] : event;
      const railRect = railEl.getBoundingClientRect();
      let percentage2;
      if (props.vertical) {
        percentage2 = (railRect.bottom - touchEvent.clientY) / railRect.height;
      } else {
        percentage2 = (touchEvent.clientX - railRect.left) / railRect.width;
      }
      if (props.reverse) {
        percentage2 = 1 - percentage2;
      }
      return percentageToValue(percentage2);
    }
    function handleRailKeyDown(e25) {
      if (mergedDisabledRef.value || !props.keyboard)
        return;
      const { vertical, reverse } = props;
      switch (e25.key) {
        case "ArrowUp":
          e25.preventDefault();
          handleStepValue(vertical && reverse ? -1 : 1);
          break;
        case "ArrowRight":
          e25.preventDefault();
          handleStepValue(!vertical && reverse ? -1 : 1);
          break;
        case "ArrowDown":
          e25.preventDefault();
          handleStepValue(vertical && reverse ? 1 : -1);
          break;
        case "ArrowLeft":
          e25.preventDefault();
          handleStepValue(!vertical && reverse ? 1 : -1);
          break;
      }
    }
    function handleStepValue(ratio) {
      const activeIndex = activeIndexRef.value;
      if (activeIndex === -1)
        return;
      const { step } = props;
      const currentValue = arrifiedValueRef.value[activeIndex];
      const nextValue = Number(step) <= 0 || step === "mark" ? currentValue : currentValue + step * ratio;
      doDispatchValue(sanitizeValue(nextValue, currentValue, ratio > 0 ? 1 : -1), activeIndex);
    }
    function handleRailMouseDown(event) {
      var _a2, _b2;
      if (mergedDisabledRef.value)
        return;
      if (!isTouchEvent(event) && event.button !== eventButtonLeft) {
        return;
      }
      const pointValue = getPointValue(event);
      if (pointValue === void 0)
        return;
      const values2 = arrifiedValueRef.value.slice();
      const activeIndex = props.range ? (_b2 = (_a2 = getClosestMark(pointValue, values2)) === null || _a2 === void 0 ? void 0 : _a2.index) !== null && _b2 !== void 0 ? _b2 : -1 : 0;
      if (activeIndex !== -1) {
        event.preventDefault();
        focusActiveHandle(activeIndex);
        startDragging();
        doDispatchValue(sanitizeValue(pointValue, arrifiedValueRef.value[activeIndex]), activeIndex);
      }
    }
    function startDragging() {
      if (!draggingRef.value) {
        draggingRef.value = true;
        on$1("touchend", document, handleMouseUp);
        on$1("mouseup", document, handleMouseUp);
        on$1("touchmove", document, handleMouseMove);
        on$1("mousemove", document, handleMouseMove);
      }
    }
    function stopDragging() {
      if (draggingRef.value) {
        draggingRef.value = false;
        off("touchend", document, handleMouseUp);
        off("mouseup", document, handleMouseUp);
        off("touchmove", document, handleMouseMove);
        off("mousemove", document, handleMouseMove);
      }
    }
    function handleMouseMove(event) {
      const { value: activeIndex } = activeIndexRef;
      if (!draggingRef.value || activeIndex === -1) {
        stopDragging();
        return;
      }
      const pointValue = getPointValue(event);
      doDispatchValue(sanitizeValue(pointValue, arrifiedValueRef.value[activeIndex]), activeIndex);
    }
    function handleMouseUp() {
      stopDragging();
    }
    function handleHandleFocus(index2) {
      activeIndexRef.value = index2;
      if (!mergedDisabledRef.value) {
        hoverIndexRef.value = index2;
      }
    }
    function handleHandleBlur(index2) {
      if (activeIndexRef.value === index2) {
        activeIndexRef.value = -1;
        stopDragging();
      }
      if (hoverIndexRef.value === index2) {
        hoverIndexRef.value = -1;
      }
    }
    function handleHandleMouseEnter(index2) {
      hoverIndexRef.value = index2;
    }
    function handleHandleMouseLeave(index2) {
      if (hoverIndexRef.value === index2) {
        hoverIndexRef.value = -1;
      }
    }
    watch(activeIndexRef, (_2, previous) => void nextTick(() => previousIndexRef.value = previous));
    watch(mergedValueRef, () => {
      if (props.marks) {
        if (dotTransitionDisabledRef.value)
          return;
        dotTransitionDisabledRef.value = true;
        void nextTick(() => {
          dotTransitionDisabledRef.value = false;
        });
      }
      void nextTick(syncPosition);
    });
    onBeforeUnmount(() => {
      stopDragging();
    });
    const cssVarsRef = computed(() => {
      const { self: { markFontSize, railColor, railColorHover, fillColor, fillColorHover, handleColor, opacityDisabled, dotColor, dotColorModal, handleBoxShadow, handleBoxShadowHover, handleBoxShadowActive, handleBoxShadowFocus, dotBorder, dotBoxShadow, railHeight, railWidthVertical, handleSize, dotHeight, dotWidth, dotBorderRadius, fontSize: fontSize2, dotBorderActive, dotColorPopover }, common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-dot-border": dotBorder,
        "--n-dot-border-active": dotBorderActive,
        "--n-dot-border-radius": dotBorderRadius,
        "--n-dot-box-shadow": dotBoxShadow,
        "--n-dot-color": dotColor,
        "--n-dot-color-modal": dotColorModal,
        "--n-dot-color-popover": dotColorPopover,
        "--n-dot-height": dotHeight,
        "--n-dot-width": dotWidth,
        "--n-fill-color": fillColor,
        "--n-fill-color-hover": fillColorHover,
        "--n-font-size": fontSize2,
        "--n-handle-box-shadow": handleBoxShadow,
        "--n-handle-box-shadow-active": handleBoxShadowActive,
        "--n-handle-box-shadow-focus": handleBoxShadowFocus,
        "--n-handle-box-shadow-hover": handleBoxShadowHover,
        "--n-handle-color": handleColor,
        "--n-handle-size": handleSize,
        "--n-opacity-disabled": opacityDisabled,
        "--n-rail-color": railColor,
        "--n-rail-color-hover": railColorHover,
        "--n-rail-height": railHeight,
        "--n-rail-width-vertical": railWidthVertical,
        "--n-mark-font-size": markFontSize
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("slider", void 0, cssVarsRef, props) : void 0;
    const indicatorCssVarsRef = computed(() => {
      const { self: { fontSize: fontSize2, indicatorColor, indicatorBoxShadow, indicatorTextColor, indicatorBorderRadius } } = themeRef.value;
      return {
        "--n-font-size": fontSize2,
        "--n-indicator-border-radius": indicatorBorderRadius,
        "--n-indicator-box-shadow": indicatorBoxShadow,
        "--n-indicator-color": indicatorColor,
        "--n-indicator-text-color": indicatorTextColor
      };
    });
    const indicatorThemeClassHandle = inlineThemeDisabled ? useThemeClass("slider-indicator", void 0, indicatorCssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      namespace: namespaceRef,
      uncontrolledValue: uncontrolledValueRef,
      mergedValue: mergedValueRef,
      mergedDisabled: mergedDisabledRef,
      mergedPlacement: mergedPlacementRef,
      isMounted: isMounted(),
      adjustedTo: useAdjustedTo(props),
      dotTransitionDisabled: dotTransitionDisabledRef,
      markInfos: markInfosRef,
      isShowTooltip,
      shouldKeepTooltipTransition,
      handleRailRef,
      setHandleRefs,
      setFollowerRefs,
      fillStyle: fillStyleRef,
      getHandleStyle,
      activeIndex: activeIndexRef,
      arrifiedValues: arrifiedValueRef,
      followerEnabledIndexSet: followerEnabledIndexSetRef,
      handleRailMouseDown,
      handleHandleFocus,
      handleHandleBlur,
      handleHandleMouseEnter,
      handleHandleMouseLeave,
      handleRailKeyDown,
      indicatorCssVars: inlineThemeDisabled ? void 0 : indicatorCssVarsRef,
      indicatorThemeClass: indicatorThemeClassHandle === null || indicatorThemeClassHandle === void 0 ? void 0 : indicatorThemeClassHandle.themeClass,
      indicatorOnRender: indicatorThemeClassHandle === null || indicatorThemeClassHandle === void 0 ? void 0 : indicatorThemeClassHandle.onRender,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    var _a2;
    const { mergedClsPrefix, themeClass, formatTooltip } = this;
    (_a2 = this.onRender) === null || _a2 === void 0 ? void 0 : _a2.call(this);
    return h$1("div", { class: [
      `${mergedClsPrefix}-slider`,
      themeClass,
      {
        [`${mergedClsPrefix}-slider--disabled`]: this.mergedDisabled,
        [`${mergedClsPrefix}-slider--active`]: this.activeIndex !== -1,
        [`${mergedClsPrefix}-slider--with-mark`]: this.marks,
        [`${mergedClsPrefix}-slider--vertical`]: this.vertical,
        [`${mergedClsPrefix}-slider--reverse`]: this.reverse
      }
    ], style: this.cssVars, onKeydown: this.handleRailKeyDown, onMousedown: this.handleRailMouseDown, onTouchstart: this.handleRailMouseDown }, h$1("div", { class: `${mergedClsPrefix}-slider-rail` }, h$1("div", { class: `${mergedClsPrefix}-slider-rail__fill`, style: this.fillStyle }), this.marks ? h$1("div", { class: [
      `${mergedClsPrefix}-slider-dots`,
      this.dotTransitionDisabled && `${mergedClsPrefix}-slider-dots--transition-disabled`
    ] }, this.markInfos.map((mark) => h$1("div", { key: mark.label, class: [
      `${mergedClsPrefix}-slider-dot`,
      {
        [`${mergedClsPrefix}-slider-dot--active`]: mark.active
      }
    ], style: mark.style }))) : null, h$1("div", { ref: "handleRailRef", class: `${mergedClsPrefix}-slider-handles` }, this.arrifiedValues.map((value2, index2) => {
      const showTooltip2 = this.isShowTooltip(index2);
      return h$1(VBinder, null, {
        default: () => [
          h$1(VTarget, null, {
            default: () => h$1("div", { ref: this.setHandleRefs(index2), class: `${mergedClsPrefix}-slider-handle-wrapper`, tabindex: this.mergedDisabled ? -1 : 0, style: this.getHandleStyle(value2, index2), onFocus: () => {
              this.handleHandleFocus(index2);
            }, onBlur: () => {
              this.handleHandleBlur(index2);
            }, onMouseenter: () => {
              this.handleHandleMouseEnter(index2);
            }, onMouseleave: () => {
              this.handleHandleMouseLeave(index2);
            } }, resolveSlot(this.$slots.thumb, () => [
              h$1("div", { class: `${mergedClsPrefix}-slider-handle` })
            ]))
          }),
          this.tooltip && h$1(VFollower, { ref: this.setFollowerRefs(index2), show: showTooltip2, to: this.adjustedTo, enabled: this.showTooltip && !this.range || this.followerEnabledIndexSet.has(index2), teleportDisabled: this.adjustedTo === useAdjustedTo.tdkey, placement: this.mergedPlacement, containerClass: this.namespace }, {
            default: () => h$1(Transition, { name: "fade-in-scale-up-transition", appear: this.isMounted, css: this.shouldKeepTooltipTransition(index2), onEnter: () => {
              this.followerEnabledIndexSet.add(index2);
            }, onAfterLeave: () => {
              this.followerEnabledIndexSet.delete(index2);
            } }, {
              default: () => {
                var _a3;
                if (showTooltip2) {
                  (_a3 = this.indicatorOnRender) === null || _a3 === void 0 ? void 0 : _a3.call(this);
                  return h$1("div", { class: [
                    `${mergedClsPrefix}-slider-handle-indicator`,
                    this.indicatorThemeClass,
                    `${mergedClsPrefix}-slider-handle-indicator--${this.mergedPlacement}`
                  ], style: this.indicatorCssVars }, typeof formatTooltip === "function" ? formatTooltip(value2) : value2);
                }
                return null;
              }
            })
          })
        ]
      });
    })), this.marks ? h$1("div", { class: `${mergedClsPrefix}-slider-marks` }, this.markInfos.map((mark) => h$1("div", { key: mark.label, class: `${mergedClsPrefix}-slider-mark`, style: mark.style }, mark.label))) : null));
  }
});
var style$4 = c$2([c$2("@keyframes spin-rotate", `
 from {
 transform: rotate(0);
 }
 to {
 transform: rotate(360deg);
 }
 `), cB$1("spin-container", {
  position: "relative"
}, [cB$1("spin-body", `
 position: absolute;
 top: 50%;
 left: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [fadeInTransition()])]), cB$1("spin-body", `
 display: inline-flex;
 align-items: center;
 justify-content: center;
 flex-direction: column;
 `), cB$1("spin", `
 display: inline-flex;
 height: var(--n-size);
 width: var(--n-size);
 font-size: var(--n-size);
 color: var(--n-color);
 `, [cM("rotate", `
 animation: spin-rotate 2s linear infinite;
 `)]), cB$1("spin-description", `
 display: inline-block;
 font-size: var(--n-font-size);
 color: var(--n-text-color);
 transition: color .3s var(--n-bezier);
 margin-top: 8px;
 `), cB$1("spin-content", `
 opacity: 1;
 transition: opacity .3s var(--n-bezier);
 pointer-events: all;
 `, [cM("spinning", `
 user-select: none;
 -webkit-user-select: none;
 pointer-events: none;
 opacity: var(--n-opacity-spinning);
 `)])]);
const STROKE_WIDTH = {
  small: 20,
  medium: 18,
  large: 16
};
const spinProps = Object.assign(Object.assign({}, useTheme.props), { description: String, stroke: String, size: {
  type: [String, Number],
  default: "medium"
}, show: {
  type: Boolean,
  default: true
}, strokeWidth: Number, rotate: {
  type: Boolean,
  default: true
}, spinning: {
  type: Boolean,
  validator: () => {
    return true;
  },
  default: void 0
} });
var NSpin = defineComponent({
  name: "Spin",
  props: spinProps,
  setup(props) {
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Spin", "-spin", style$4, spinLight$1, props, mergedClsPrefixRef);
    const cssVarsRef = computed(() => {
      const { size: spinSize } = props;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: self2 } = themeRef.value;
      const { opacitySpinning, color, textColor } = self2;
      const size2 = typeof spinSize === "number" ? pxfy(spinSize) : self2[createKey("size", spinSize)];
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-opacity-spinning": opacitySpinning,
        "--n-size": size2,
        "--n-color": color,
        "--n-text-color": textColor
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("spin", computed(() => {
      const { size: size2 } = props;
      return typeof size2 === "number" ? String(size2) : size2[0];
    }), cssVarsRef, props) : void 0;
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      compitableShow: useCompitable(props, ["spinning", "show"]),
      mergedStrokeWidth: computed(() => {
        const { strokeWidth } = props;
        if (strokeWidth !== void 0)
          return strokeWidth;
        const { size: size2 } = props;
        return STROKE_WIDTH[typeof size2 === "number" ? "medium" : size2];
      }),
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    var _a2, _b2;
    const { $slots, mergedClsPrefix, description } = this;
    const rotate = $slots.icon && this.rotate;
    const descriptionNode = (description || $slots.description) && h$1("div", { class: `${mergedClsPrefix}-spin-description` }, description || ((_a2 = $slots.description) === null || _a2 === void 0 ? void 0 : _a2.call($slots)));
    const icon = $slots.icon ? h$1("div", { class: [`${mergedClsPrefix}-spin-body`, this.themeClass] }, h$1("div", { class: [
      `${mergedClsPrefix}-spin`,
      rotate && `${mergedClsPrefix}-spin--rotate`
    ], style: $slots.default ? "" : this.cssVars }, $slots.icon()), descriptionNode) : h$1("div", { class: [`${mergedClsPrefix}-spin-body`, this.themeClass] }, h$1(NBaseLoading, { clsPrefix: mergedClsPrefix, style: $slots.default ? "" : this.cssVars, stroke: this.stroke, "stroke-width": this.mergedStrokeWidth, class: `${mergedClsPrefix}-spin` }), descriptionNode);
    (_b2 = this.onRender) === null || _b2 === void 0 ? void 0 : _b2.call(this);
    return $slots.default ? h$1("div", { class: [`${mergedClsPrefix}-spin-container`, this.themeClass], style: this.cssVars }, h$1("div", { class: [
      `${mergedClsPrefix}-spin-content`,
      this.compitableShow && `${mergedClsPrefix}-spin-content--spinning`
    ] }, $slots), h$1(Transition, { name: "fade-in-transition" }, {
      default: () => this.compitableShow ? icon : null
    })) : icon;
  }
});
var style$3 = cB$1("steps", `
 width: 100%;
 display: flex;
`, [cB$1("step", `
 position: relative;
 display: flex;
 flex: 1;
 `, [cM("disabled", "cursor: not-allowed"), cM("clickable", `
 cursor: pointer;
 `), c$2("&:last-child", [cB$1("step-splitor", "display: none;")])]), cB$1("step-splitor", `
 background-color: var(--n-splitor-color);
 margin-top: calc(var(--n-step-header-font-size) / 2);
 height: 1px;
 flex: 1;
 align-self: flex-start;
 margin-left: 12px;
 margin-right: 12px;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `), cB$1("step-content", "flex: 1;", [cB$1("step-content-header", `
 color: var(--n-header-text-color);
 margin-top: calc(var(--n-indicator-size) / 2 - var(--n-step-header-font-size) / 2);
 line-height: var(--n-step-header-font-size);
 font-size: var(--n-step-header-font-size);
 position: relative;
 display: flex;
 font-weight: var(--n-step-header-font-weight);
 margin-left: 9px;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `, [cE$1("title", `
 white-space: nowrap;
 flex: 0;
 `)]), cE$1("description", `
 color: var(--n-description-text-color);
 margin-top: 12px;
 margin-left: 9px;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `)]), cB$1("step-indicator", `
 background-color: var(--n-indicator-color);
 box-shadow: 0 0 0 1px var(--n-indicator-border-color);
 height: var(--n-indicator-size);
 width: var(--n-indicator-size);
 border-radius: 50%;
 display: flex;
 align-items: center;
 justify-content: center;
 transition:
 background-color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 `, [cB$1("step-indicator-slot", `
 position: relative;
 width: var(--n-indicator-icon-size);
 height: var(--n-indicator-icon-size);
 font-size: var(--n-indicator-icon-size);
 line-height: var(--n-indicator-icon-size);
 `, [cE$1("index", `
 display: inline-block;
 text-align: center;
 position: absolute;
 left: 0;
 top: 0;
 font-size: var(--n-indicator-index-font-size);
 width: var(--n-indicator-icon-size);
 height: var(--n-indicator-icon-size);
 line-height: var(--n-indicator-icon-size);
 color: var(--n-indicator-text-color);
 transition: color .3s var(--n-bezier);
 `, [iconSwitchTransition()]), cB$1("icon", `
 color: var(--n-indicator-text-color);
 transition: color .3s var(--n-bezier);
 `, [iconSwitchTransition()]), cB$1("base-icon", `
 color: var(--n-indicator-text-color);
 transition: color .3s var(--n-bezier);
 `, [iconSwitchTransition()])])]), cM("vertical", "flex-direction: column;", [cNotM("show-description", [c$2(">", [cB$1("step", "padding-bottom: 8px;")])]), c$2(">", [cB$1("step", "margin-bottom: 16px;", [c$2("&:last-child", "margin-bottom: 0;"), c$2(">", [cB$1("step-indicator", [c$2(">", [cB$1("step-splitor", `
 position: absolute;
 bottom: -8px;
 width: 1px;
 margin: 0 !important;
 left: calc(var(--n-indicator-size) / 2);
 height: calc(100% - var(--n-indicator-size));
 `)])]), cB$1("step-content", [cE$1("description", "margin-top: 8px;")])])])])])]);
function stepWithIndex(step, i2) {
  if (typeof step !== "object" || step === null || Array.isArray(step)) {
    return null;
  }
  if (!step.props)
    step.props = {};
  step.props.internalIndex = i2 + 1;
  return step;
}
function stepsWithIndex(steps) {
  return steps.map((step, i2) => stepWithIndex(step, i2));
}
const stepsProps = Object.assign(Object.assign({}, useTheme.props), { current: Number, status: {
  type: String,
  default: "process"
}, size: {
  type: String,
  default: "medium"
}, vertical: Boolean, "onUpdate:current": [Function, Array], onUpdateCurrent: [Function, Array] });
const stepsInjectionKey = createInjectionKey("n-steps");
var NSteps = defineComponent({
  name: "Steps",
  props: stepsProps,
  setup(props, { slots }) {
    const { mergedClsPrefixRef, mergedRtlRef } = useConfig(props);
    const rtlEnabledRef = useRtl("Steps", mergedRtlRef, mergedClsPrefixRef);
    const themeRef = useTheme("Steps", "-steps", style$3, stepsLight$1, props, mergedClsPrefixRef);
    provide(stepsInjectionKey, {
      props,
      mergedThemeRef: themeRef,
      mergedClsPrefixRef,
      stepsSlots: slots
    });
    return {
      mergedClsPrefix: mergedClsPrefixRef,
      rtlEnabled: rtlEnabledRef
    };
  },
  render() {
    const { mergedClsPrefix } = this;
    return h$1("div", { class: [
      `${mergedClsPrefix}-steps`,
      this.rtlEnabled && `${mergedClsPrefix}-steps--rtl`,
      this.vertical && `${mergedClsPrefix}-steps--vertical`
    ] }, stepsWithIndex(flatten$4(getSlot$1(this))));
  }
});
const stepProps = {
  status: String,
  title: String,
  description: String,
  disabled: Boolean,
  internalIndex: {
    type: Number,
    default: 0
  }
};
var NStep = defineComponent({
  name: "Step",
  props: stepProps,
  setup(props) {
    const NSteps2 = inject(stepsInjectionKey, null);
    if (!NSteps2)
      throwError("step", "`n-step` must be placed inside `n-steps`.");
    const { inlineThemeDisabled } = useConfig();
    const { props: stepsProps2, mergedThemeRef, mergedClsPrefixRef, stepsSlots } = NSteps2;
    const verticalRef = computed(() => {
      return stepsProps2.vertical;
    });
    const mergedStatusRef = computed(() => {
      const { status } = props;
      if (status) {
        return status;
      } else {
        const { internalIndex } = props;
        const { current } = stepsProps2;
        if (current === void 0)
          return "process";
        if (internalIndex < current) {
          return "finish";
        } else if (internalIndex === current) {
          return stepsProps2.status || "process";
        } else if (internalIndex > current) {
          return "wait";
        }
      }
      return "process";
    });
    const cssVarsRef = computed(() => {
      const { value: status } = mergedStatusRef;
      const { size: size2 } = stepsProps2;
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { stepHeaderFontWeight, [createKey("stepHeaderFontSize", size2)]: stepHeaderFontSize, [createKey("indicatorIndexFontSize", size2)]: indicatorIndexFontSize, [createKey("indicatorSize", size2)]: indicatorSize, [createKey("indicatorIconSize", size2)]: indicatorIconSize, [createKey("indicatorTextColor", status)]: indicatorTextColor, [createKey("indicatorBorderColor", status)]: indicatorBorderColor, [createKey("headerTextColor", status)]: headerTextColor, [createKey("splitorColor", status)]: splitorColor, [createKey("indicatorColor", status)]: indicatorColor, [createKey("descriptionTextColor", status)]: descriptionTextColor } } = mergedThemeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-description-text-color": descriptionTextColor,
        "--n-header-text-color": headerTextColor,
        "--n-indicator-border-color": indicatorBorderColor,
        "--n-indicator-color": indicatorColor,
        "--n-indicator-icon-size": indicatorIconSize,
        "--n-indicator-index-font-size": indicatorIndexFontSize,
        "--n-indicator-size": indicatorSize,
        "--n-indicator-text-color": indicatorTextColor,
        "--n-splitor-color": splitorColor,
        "--n-step-header-font-size": stepHeaderFontSize,
        "--n-step-header-font-weight": stepHeaderFontWeight
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("step", computed(() => {
      const { value: status } = mergedStatusRef;
      const { size: size2 } = stepsProps2;
      return `${status[0]}${size2[0]}`;
    }), cssVarsRef, stepsProps2) : void 0;
    const handleStepClick = computed(() => {
      if (props.disabled)
        return void 0;
      const { onUpdateCurrent, "onUpdate:current": _onUpdateCurrent } = stepsProps2;
      return onUpdateCurrent || _onUpdateCurrent ? () => {
        if (onUpdateCurrent) {
          call(onUpdateCurrent, props.internalIndex);
        }
        if (_onUpdateCurrent) {
          call(_onUpdateCurrent, props.internalIndex);
        }
      } : void 0;
    });
    return {
      stepsSlots,
      mergedClsPrefix: mergedClsPrefixRef,
      vertical: verticalRef,
      mergedStatus: mergedStatusRef,
      handleStepClick,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const { mergedClsPrefix, onRender, handleStepClick, disabled } = this;
    const descriptionNode = resolveWrappedSlot(this.$slots.default, (children) => {
      const mergedDescription = children || this.description;
      if (mergedDescription) {
        return h$1("div", { class: `${mergedClsPrefix}-step-content__description` }, mergedDescription);
      }
      return null;
    });
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { class: [
      `${mergedClsPrefix}-step`,
      disabled && `${mergedClsPrefix}-step--disabled`,
      !disabled && handleStepClick && `${mergedClsPrefix}-step--clickable`,
      this.themeClass,
      descriptionNode && `${mergedClsPrefix}-step--show-description`,
      `${mergedClsPrefix}-step--${this.mergedStatus}-status`
    ], style: this.cssVars, onClick: handleStepClick }, h$1("div", { class: `${mergedClsPrefix}-step-indicator` }, h$1("div", { class: `${mergedClsPrefix}-step-indicator-slot` }, h$1(NIconSwitchTransition, null, {
      default: () => {
        return resolveWrappedSlot(this.$slots.icon, (icon) => {
          const { mergedStatus, stepsSlots } = this;
          return !(mergedStatus === "finish" || mergedStatus === "error") ? icon || h$1("div", { key: this.internalIndex, class: `${mergedClsPrefix}-step-indicator-slot__index` }, this.internalIndex) : mergedStatus === "finish" ? h$1(NBaseIcon, { clsPrefix: mergedClsPrefix, key: "finish" }, {
            default: () => resolveSlot(stepsSlots["finish-icon"], () => [
              h$1(FinishedIcon, null)
            ])
          }) : mergedStatus === "error" ? h$1(NBaseIcon, { clsPrefix: mergedClsPrefix, key: "error" }, {
            default: () => resolveSlot(stepsSlots["error-icon"], () => [
              h$1(ErrorIcon$1, null)
            ])
          }) : null;
        });
      }
    })), this.vertical ? h$1("div", { class: `${mergedClsPrefix}-step-splitor` }) : null), h$1("div", { class: `${mergedClsPrefix}-step-content` }, h$1("div", { class: `${mergedClsPrefix}-step-content-header` }, h$1("div", { class: `${mergedClsPrefix}-step-content-header__title` }, resolveSlot(this.$slots.title, () => [this.title])), !this.vertical ? h$1("div", { class: `${mergedClsPrefix}-step-splitor` }) : null), descriptionNode));
  }
});
var style$2 = cB$1("switch", `
 height: var(--n-height);
 min-width: var(--n-width);
 vertical-align: middle;
 user-select: none;
 -webkit-user-select: none;
 display: inline-flex;
 outline: none;
 justify-content: center;
 align-items: center;
`, [cE$1("children-placeholder", `
 height: var(--n-rail-height);
 display: flex;
 flex-direction: column;
 overflow: hidden;
 pointer-events: none;
 visibility: hidden;
 `), cE$1("rail-placeholder", `
 display: flex;
 flex-wrap: none;
 `), cE$1("button-placeholder", `
 width: calc(1.75 * var(--n-rail-height));
 height: var(--n-rail-height);
 `), cB$1("base-loading", `
 position: absolute;
 top: 50%;
 left: 50%;
 transform: translateX(-50%) translateY(-50%);
 font-size: calc(var(--n-button-width) - 4px);
 color: var(--n-loading-color);
 transition: color .3s var(--n-bezier);
 `, [iconSwitchTransition({
  left: "50%",
  top: "50%",
  originalTransform: "translateX(-50%) translateY(-50%)"
})]), cE$1("checked, unchecked", `
 transition: color .3s var(--n-bezier);
 color: var(--n-text-color);
 box-sizing: border-box;
 position: absolute;
 white-space: nowrap;
 top: 0;
 bottom: 0;
 display: flex;
 align-items: center;
 line-height: 1;
 `), cE$1("checked", `
 right: 0;
 padding-right: calc(1.25 * var(--n-rail-height) - var(--n-offset));
 `), cE$1("unchecked", `
 left: 0;
 justify-content: flex-end;
 padding-left: calc(1.25 * var(--n-rail-height) - var(--n-offset));
 `), c$2("&:focus", [cE$1("rail", `
 box-shadow: var(--n-box-shadow-focus);
 `)]), cM("round", [cE$1("rail", "border-radius: calc(var(--n-rail-height) / 2);", [cE$1("button", "border-radius: calc(var(--n-button-height) / 2);")])]), cNotM("disabled", [cNotM("icon", [cM("rubber-band", [cM("pressed", [cE$1("rail", [cE$1("button", "max-width: var(--n-button-width-pressed);")])]), cE$1("rail", [c$2("&:active", [cE$1("button", "max-width: var(--n-button-width-pressed);")])]), cM("active", [cM("pressed", [cE$1("rail", [cE$1("button", "left: calc(100% - var(--n-offset) - var(--n-button-width-pressed));")])]), cE$1("rail", [c$2("&:active", [cE$1("button", "left: calc(100% - var(--n-offset) - var(--n-button-width-pressed));")])])])])])]), cM("active", [cE$1("rail", [cE$1("button", "left: calc(100% - var(--n-button-width) - var(--n-offset))")])]), cE$1("rail", `
 overflow: hidden;
 height: var(--n-rail-height);
 min-width: var(--n-rail-width);
 border-radius: var(--n-rail-border-radius);
 cursor: pointer;
 position: relative;
 transition:
 opacity .3s var(--n-bezier),
 background .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 background-color: var(--n-rail-color);
 `, [cE$1("button-icon", `
 color: var(--n-icon-color);
 transition: color .3s var(--n-bezier);
 font-size: calc(var(--n-button-height) - 4px);
 position: absolute;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 display: flex;
 justify-content: center;
 align-items: center;
 line-height: 1;
 `, [iconSwitchTransition()]), cE$1("button", `
 align-items: center; 
 top: var(--n-offset);
 left: var(--n-offset);
 height: var(--n-button-height);
 width: var(--n-button-width-pressed);
 max-width: var(--n-button-width);
 border-radius: var(--n-button-border-radius);
 background-color: var(--n-button-color);
 box-shadow: var(--n-button-box-shadow);
 box-sizing: border-box;
 cursor: inherit;
 content: "";
 position: absolute;
 transition:
 background-color .3s var(--n-bezier),
 left .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 max-width .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier);
 `)]), cM("active", [cE$1("rail", "background-color: var(--n-rail-color-active);")]), cM("loading", [cE$1("rail", `
 cursor: wait;
 `)]), cM("disabled", [cE$1("rail", `
 cursor: not-allowed;
 opacity: .5;
 `)])]);
const switchProps = Object.assign(Object.assign({}, useTheme.props), {
  size: {
    type: String,
    default: "medium"
  },
  value: {
    type: [String, Number, Boolean],
    default: void 0
  },
  loading: Boolean,
  defaultValue: {
    type: [String, Number, Boolean],
    default: false
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  round: {
    type: Boolean,
    default: true
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  checkedValue: {
    type: [String, Number, Boolean],
    default: true
  },
  uncheckedValue: {
    type: [String, Number, Boolean],
    default: false
  },
  railStyle: Function,
  rubberBand: {
    type: Boolean,
    default: true
  },
  onChange: [Function, Array]
});
let supportCssMax;
var NSwitch = defineComponent({
  name: "Switch",
  props: switchProps,
  setup(props) {
    if (supportCssMax === void 0) {
      if (typeof CSS !== "undefined") {
        if (typeof CSS.supports !== "undefined") {
          supportCssMax = CSS.supports("width", "max(1px)");
        } else {
          supportCssMax = false;
        }
      } else {
        supportCssMax = true;
      }
    }
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Switch", "-switch", style$2, switchLight$1, props, mergedClsPrefixRef);
    const formItem = useFormItem(props);
    const { mergedSizeRef, mergedDisabledRef } = formItem;
    const uncontrolledValueRef = ref(props.defaultValue);
    const controlledValueRef = toRef(props, "value");
    const mergedValueRef = useMergedState(controlledValueRef, uncontrolledValueRef);
    const checkedRef = computed(() => {
      return mergedValueRef.value === props.checkedValue;
    });
    const pressedRef = ref(false);
    const focusedRef = ref(false);
    const mergedRailStyleRef = computed(() => {
      const { railStyle } = props;
      if (!railStyle)
        return void 0;
      return railStyle({ focused: focusedRef.value, checked: checkedRef.value });
    });
    function doUpdateValue(value2) {
      const { "onUpdate:value": _onUpdateValue, onChange, onUpdateValue } = props;
      const { nTriggerFormInput, nTriggerFormChange } = formItem;
      if (_onUpdateValue)
        call(_onUpdateValue, value2);
      if (onUpdateValue)
        call(onUpdateValue, value2);
      if (onChange)
        call(onChange, value2);
      uncontrolledValueRef.value = value2;
      nTriggerFormInput();
      nTriggerFormChange();
    }
    function doFocus() {
      const { nTriggerFormFocus } = formItem;
      nTriggerFormFocus();
    }
    function doBlur() {
      const { nTriggerFormBlur } = formItem;
      nTriggerFormBlur();
    }
    function handleClick2() {
      if (props.loading || mergedDisabledRef.value)
        return;
      if (mergedValueRef.value !== props.checkedValue) {
        doUpdateValue(props.checkedValue);
      } else {
        doUpdateValue(props.uncheckedValue);
      }
    }
    function handleFocus() {
      focusedRef.value = true;
      doFocus();
    }
    function handleBlur() {
      focusedRef.value = false;
      doBlur();
      pressedRef.value = false;
    }
    function handleKeyup(e25) {
      if (props.loading || mergedDisabledRef.value)
        return;
      if (e25.key === " ") {
        if (mergedValueRef.value !== props.checkedValue) {
          doUpdateValue(props.checkedValue);
        } else {
          doUpdateValue(props.uncheckedValue);
        }
        pressedRef.value = false;
      }
    }
    function handleKeydown(e25) {
      if (props.loading || mergedDisabledRef.value)
        return;
      if (e25.key === " ") {
        e25.preventDefault();
        pressedRef.value = true;
      }
    }
    const cssVarsRef = computed(() => {
      const { value: size2 } = mergedSizeRef;
      const { self: { opacityDisabled, railColor, railColorActive, buttonBoxShadow, buttonColor, boxShadowFocus, loadingColor, textColor, iconColor, [createKey("buttonHeight", size2)]: buttonHeight, [createKey("buttonWidth", size2)]: buttonWidth, [createKey("buttonWidthPressed", size2)]: buttonWidthPressed, [createKey("railHeight", size2)]: railHeight, [createKey("railWidth", size2)]: railWidth, [createKey("railBorderRadius", size2)]: railBorderRadius, [createKey("buttonBorderRadius", size2)]: buttonBorderRadius }, common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 } } = themeRef.value;
      let offset;
      let height;
      let width;
      if (supportCssMax) {
        offset = `calc((${railHeight} - ${buttonHeight}) / 2)`;
        height = `max(${railHeight}, ${buttonHeight})`;
        width = `max(${railWidth}, calc(${railWidth} + ${buttonHeight} - ${railHeight}))`;
      } else {
        offset = pxfy((depx(railHeight) - depx(buttonHeight)) / 2);
        height = pxfy(Math.max(depx(railHeight), depx(buttonHeight)));
        width = depx(railHeight) > depx(buttonHeight) ? railWidth : pxfy(depx(railWidth) + depx(buttonHeight) - depx(railHeight));
      }
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-button-border-radius": buttonBorderRadius,
        "--n-button-box-shadow": buttonBoxShadow,
        "--n-button-color": buttonColor,
        "--n-button-width": buttonWidth,
        "--n-button-width-pressed": buttonWidthPressed,
        "--n-button-height": buttonHeight,
        "--n-height": height,
        "--n-offset": offset,
        "--n-opacity-disabled": opacityDisabled,
        "--n-rail-border-radius": railBorderRadius,
        "--n-rail-color": railColor,
        "--n-rail-color-active": railColorActive,
        "--n-rail-height": railHeight,
        "--n-rail-width": railWidth,
        "--n-width": width,
        "--n-box-shadow-focus": boxShadowFocus,
        "--n-loading-color": loadingColor,
        "--n-text-color": textColor,
        "--n-icon-color": iconColor
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("switch", computed(() => {
      return mergedSizeRef.value[0];
    }), cssVarsRef, props) : void 0;
    return {
      handleClick: handleClick2,
      handleBlur,
      handleFocus,
      handleKeyup,
      handleKeydown,
      mergedRailStyle: mergedRailStyleRef,
      pressed: pressedRef,
      mergedClsPrefix: mergedClsPrefixRef,
      mergedValue: mergedValueRef,
      checked: checkedRef,
      mergedDisabled: mergedDisabledRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    };
  },
  render() {
    const { mergedClsPrefix, mergedDisabled, checked, mergedRailStyle, onRender, $slots } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    const { checked: checkedSlot, unchecked: uncheckedSlot, icon: iconSlot, "checked-icon": checkedIconSlot, "unchecked-icon": uncheckedIconSlot } = $slots;
    const hasIcon = !(isSlotEmpty(iconSlot) && isSlotEmpty(checkedIconSlot) && isSlotEmpty(uncheckedIconSlot));
    return h$1("div", { role: "switch", "aria-checked": checked, class: [
      `${mergedClsPrefix}-switch`,
      this.themeClass,
      hasIcon && `${mergedClsPrefix}-switch--icon`,
      checked && `${mergedClsPrefix}-switch--active`,
      mergedDisabled && `${mergedClsPrefix}-switch--disabled`,
      this.round && `${mergedClsPrefix}-switch--round`,
      this.loading && `${mergedClsPrefix}-switch--loading`,
      this.pressed && `${mergedClsPrefix}-switch--pressed`,
      this.rubberBand && `${mergedClsPrefix}-switch--rubber-band`
    ], tabindex: !this.mergedDisabled ? 0 : void 0, style: this.cssVars, onClick: this.handleClick, onFocus: this.handleFocus, onBlur: this.handleBlur, onKeyup: this.handleKeyup, onKeydown: this.handleKeydown }, h$1("div", { class: `${mergedClsPrefix}-switch__rail`, "aria-hidden": "true", style: mergedRailStyle }, resolveWrappedSlot(checkedSlot, (checkedSlotChildren) => resolveWrappedSlot(uncheckedSlot, (uncheckedSlotChildren) => {
      if (checkedSlotChildren || uncheckedSlotChildren) {
        return h$1("div", { "aria-hidden": true, class: `${mergedClsPrefix}-switch__children-placeholder` }, h$1("div", { class: `${mergedClsPrefix}-switch__rail-placeholder` }, h$1("div", { class: `${mergedClsPrefix}-switch__button-placeholder` }), checkedSlotChildren), h$1("div", { class: `${mergedClsPrefix}-switch__rail-placeholder` }, h$1("div", { class: `${mergedClsPrefix}-switch__button-placeholder` }), uncheckedSlotChildren));
      }
      return null;
    })), h$1("div", { class: `${mergedClsPrefix}-switch__button` }, resolveWrappedSlot(iconSlot, (icon) => resolveWrappedSlot(checkedIconSlot, (checkedIcon) => resolveWrappedSlot(uncheckedIconSlot, (uncheckedIcon) => {
      return h$1(NIconSwitchTransition, null, {
        default: () => this.loading ? h$1(NBaseLoading, { key: "loading", clsPrefix: mergedClsPrefix, strokeWidth: 20 }) : this.checked && (checkedIcon || icon) ? h$1("div", { class: `${mergedClsPrefix}-switch__button-icon`, key: checkedIcon ? "checked-icon" : "icon" }, checkedIcon || icon) : !this.checked && (uncheckedIcon || icon) ? h$1("div", { class: `${mergedClsPrefix}-switch__button-icon`, key: uncheckedIcon ? "unchecked-icon" : "icon" }, uncheckedIcon || icon) : null
      });
    }))), resolveWrappedSlot(checkedSlot, (children) => children && h$1("div", { key: "checked", class: `${mergedClsPrefix}-switch__checked` }, children)), resolveWrappedSlot(uncheckedSlot, (children) => children && h$1("div", { key: "unchecked", class: `${mergedClsPrefix}-switch__unchecked` }, children)))));
  }
});
const tabsInjectionKey = createInjectionKey("n-tabs");
const tabPaneProps = {
  tab: [String, Number, Object, Function],
  name: {
    type: [String, Number],
    required: true
  },
  disabled: Boolean,
  displayDirective: {
    type: String,
    default: "if"
  },
  closable: {
    type: Boolean,
    default: void 0
  },
  tabProps: Object,
  label: [String, Number, Object, Function]
};
var NTabPane = defineComponent({
  __TAB_PANE__: true,
  name: "TabPane",
  alias: ["TabPanel"],
  props: tabPaneProps,
  setup(props) {
    const NTab2 = inject(tabsInjectionKey, null);
    if (!NTab2) {
      throwError("tab-pane", "`n-tab-pane` must be placed inside `n-tabs`.");
    }
    return {
      style: NTab2.paneStyleRef,
      class: NTab2.paneClassRef,
      mergedClsPrefix: NTab2.mergedClsPrefixRef
    };
  },
  render() {
    return h$1("div", { class: [`${this.mergedClsPrefix}-tab-pane`, this.class], style: this.style }, this.$slots);
  }
});
const tabProps = Object.assign({ internalLeftPadded: Boolean, internalAddable: Boolean, internalCreatedByPane: Boolean }, omit(tabPaneProps, ["displayDirective"]));
var NTab = defineComponent({
  __TAB__: true,
  inheritAttrs: false,
  name: "Tab",
  props: tabProps,
  setup(props) {
    const {
      mergedClsPrefixRef,
      valueRef,
      typeRef,
      closableRef,
      tabStyleRef,
      tabChangeIdRef,
      onBeforeLeaveRef,
      triggerRef,
      handleAdd,
      activateTab,
      handleClose: handleClose2
    } = inject(tabsInjectionKey);
    return {
      trigger: triggerRef,
      mergedClosable: computed(() => {
        if (props.internalAddable)
          return false;
        const { closable } = props;
        if (closable === void 0)
          return closableRef.value;
        return closable;
      }),
      style: tabStyleRef,
      clsPrefix: mergedClsPrefixRef,
      value: valueRef,
      type: typeRef,
      handleClose(e25) {
        e25.stopPropagation();
        if (props.disabled)
          return;
        handleClose2(props.name);
      },
      activateTab() {
        if (props.disabled)
          return;
        if (props.internalAddable) {
          handleAdd();
          return;
        }
        const { name: nameProp } = props;
        const id2 = ++tabChangeIdRef.id;
        if (nameProp !== valueRef.value) {
          const { value: onBeforeLeave } = onBeforeLeaveRef;
          if (!onBeforeLeave) {
            activateTab(nameProp);
          } else {
            void Promise.resolve(onBeforeLeave(props.name, valueRef.value)).then((allowLeave) => {
              if (allowLeave && tabChangeIdRef.id === id2) {
                activateTab(nameProp);
              }
            });
          }
        }
      }
    };
  },
  render() {
    const { internalAddable, clsPrefix, name: name2, disabled, label, tab, value: value2, mergedClosable, style: style2, trigger: trigger2, $slots: { default: defaultSlot } } = this;
    const mergedTab = label !== null && label !== void 0 ? label : tab;
    return h$1("div", { class: `${clsPrefix}-tabs-tab-wrapper` }, this.internalLeftPadded ? h$1("div", { class: `${clsPrefix}-tabs-tab-pad` }) : null, h$1("div", Object.assign({ key: name2, "data-name": name2, "data-disabled": disabled ? true : void 0 }, mergeProps({
      class: [
        `${clsPrefix}-tabs-tab`,
        value2 === name2 && `${clsPrefix}-tabs-tab--active`,
        disabled && `${clsPrefix}-tabs-tab--disabled`,
        mergedClosable && `${clsPrefix}-tabs-tab--closable`,
        internalAddable && `${clsPrefix}-tabs-tab--addable`
      ],
      onClick: trigger2 === "click" ? this.activateTab : void 0,
      onMouseenter: trigger2 === "hover" ? this.activateTab : void 0,
      style: internalAddable ? void 0 : style2
    }, this.internalCreatedByPane ? this.tabProps || {} : this.$attrs)), h$1("span", { class: `${clsPrefix}-tabs-tab__label` }, internalAddable ? h$1(Fragment, null, h$1("div", { class: `${clsPrefix}-tabs-tab__height-placeholder` }, "\xA0"), h$1(NBaseIcon, { clsPrefix }, {
      default: () => h$1(AddIcon, null)
    })) : defaultSlot ? defaultSlot() : typeof mergedTab === "object" ? mergedTab : render$3U(mergedTab !== null && mergedTab !== void 0 ? mergedTab : name2)), mergedClosable && this.type === "card" ? h$1(NBaseClose, { clsPrefix, class: `${clsPrefix}-tabs-tab__close`, onClick: this.handleClose, disabled }) : null));
  }
});
var style$1 = cB$1("tabs", `
 box-sizing: border-box;
 width: 100%;
 display: flex;
 flex-direction: column;
 transition:
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
`, [cM("segment-type", [cB$1("tabs-rail", [c$2("&.transition-disabled", "color: red;", [cB$1("tabs-tab", `
 transition: none;
 `)])])]), cM("top", [cB$1("tab-pane", `
 padding: var(--n-pane-padding-top) var(--n-pane-padding-right) var(--n-pane-padding-bottom) var(--n-pane-padding-left);
 `)]), cM("left", [cB$1("tab-pane", `
 padding: var(--n-pane-padding-right) var(--n-pane-padding-bottom) var(--n-pane-padding-left) var(--n-pane-padding-top);
 `)]), cM("left, right", `
 flex-direction: row;
 `, [cB$1("tabs-bar", `
 width: 2px;
 right: 0;
 transition:
 top .2s var(--n-bezier),
 max-height .2s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `), cB$1("tabs-tab", `
 padding: var(--n-tab-padding-vertical); 
 `)]), cM("right", `
 flex-direction: row-reverse;
 `, [cB$1("tab-pane", `
 padding: var(--n-pane-padding-left) var(--n-pane-padding-top) var(--n-pane-padding-right) var(--n-pane-padding-bottom);
 `), cB$1("tabs-bar", `
 left: 0;
 `)]), cM("bottom", `
 flex-direction: column-reverse;
 justify-content: flex-end;
 `, [cB$1("tab-pane", `
 padding: var(--n-pane-padding-bottom) var(--n-pane-padding-right) var(--n-pane-padding-top) var(--n-pane-padding-left);
 `), cB$1("tabs-bar", `
 top: 0;
 `)]), cB$1("tabs-rail", `
 padding: 3px;
 border-radius: var(--n-tab-border-radius);
 width: 100%;
 background-color: var(--n-color-segment);
 transition: background-color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 `, [cB$1("tabs-tab-wrapper", `
 flex-basis: 0;
 flex-grow: 1;
 display: flex;
 align-items: center;
 justify-content: center;
 `, [cB$1("tabs-tab", `
 overflow: hidden;
 border-radius: var(--n-tab-border-radius);
 width: 100%;
 display: flex;
 align-items: center;
 justify-content: center;
 `, [cM("active", `
 font-weight: var(--n-font-weight-strong);
 color: var(--n-tab-text-color-active);
 background-color: var(--n-tab-color-segment);
 box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .08);
 `), c$2("&:hover", `
 color: var(--n-tab-text-color-hover);
 `)])])]), cM("flex", [cB$1("tabs-nav", {
  width: "100%"
}, [cB$1("tabs-wrapper", {
  width: "100%"
}, [cB$1("tabs-tab", {
  marginRight: 0
})])])]), cB$1("tabs-nav", `
 box-sizing: border-box;
 line-height: 1.5;
 display: flex;
 transition: border-color .3s var(--n-bezier);
 `, [cE$1("prefix, suffix", `
 display: flex;
 align-items: center;
 `), cE$1("prefix", "padding-right: 16px;"), cE$1("suffix", "padding-left: 16px;")]), cM("top, bottom", [cB$1("tabs-nav-scroll-wrapper", [c$2("&::before", `
 top: 0;
 bottom: 0;
 left: 0;
 width: 20px;
 `), c$2("&::after", `
 top: 0;
 bottom: 0;
 right: 0;
 width: 20px;
 `), cM("shadow-start", [c$2("&::before", `
 box-shadow: inset 10px 0 8px -8px rgba(0, 0, 0, .12);
 `)]), cM("shadow-end", [c$2("&::after", `
 box-shadow: inset -10px 0 8px -8px rgba(0, 0, 0, .12);
 `)])])]), cM("left, right", [cB$1("tabs-nav-scroll-wrapper", [c$2("&::before", `
 top: 0;
 left: 0;
 right: 0;
 height: 20px;
 `), c$2("&::after", `
 bottom: 0;
 left: 0;
 right: 0;
 height: 20px;
 `), cM("shadow-start", [c$2("&::before", `
 box-shadow: inset 0 10px 8px -8px rgba(0, 0, 0, .12);
 `)]), cM("shadow-end", [c$2("&::after", `
 box-shadow: inset 0 -10px 8px -8px rgba(0, 0, 0, .12);
 `)])])]), cB$1("tabs-nav-scroll-wrapper", `
 flex: 1;
 position: relative;
 overflow: hidden;
 `, [cB$1("tabs-nav-y-scroll", `
 height: 100%;
 width: 100%;
 overflow-y: auto; 
 scrollbar-width: none;
 `, [c$2("&::-webkit-scrollbar", `
 width: 0;
 height: 0;
 `)]), c$2("&::before, &::after", `
 transition: box-shadow .3s var(--n-bezier);
 pointer-events: none;
 content: "";
 position: absolute;
 z-index: 1;
 `)]), cB$1("tabs-nav-scroll-content", `
 display: flex;
 position: relative;
 min-width: 100%;
 width: fit-content;
 box-sizing: border-box;
 `), cB$1("tabs-wrapper", `
 display: inline-flex;
 flex-wrap: nowrap;
 position: relative;
 `), cB$1("tabs-tab-wrapper", `
 display: flex;
 flex-wrap: nowrap;
 flex-shrink: 0;
 flex-grow: 0;
 `), cB$1("tabs-tab", `
 cursor: pointer;
 white-space: nowrap;
 flex-wrap: nowrap;
 display: inline-flex;
 align-items: center;
 color: var(--n-tab-text-color);
 font-size: var(--n-tab-font-size);
 background-clip: padding-box;
 padding: var(--n-tab-padding);
 transition:
 box-shadow .3s var(--n-bezier),
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 border-color .3s var(--n-bezier);
 `, [cM("disabled", {
  cursor: "not-allowed"
}), cE$1("close", `
 margin-left: 6px;
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `), cE$1("label", `
 display: flex;
 align-items: center;
 `)]), cB$1("tabs-bar", `
 position: absolute;
 bottom: 0;
 height: 2px;
 border-radius: 1px;
 background-color: var(--n-bar-color);
 transition:
 left .2s var(--n-bezier),
 max-width .2s var(--n-bezier),
 background-color .3s var(--n-bezier);
 `, [c$2("&.transition-disabled", `
 transition: none;
 `), cM("disabled", `
 background-color: var(--n-tab-text-color-disabled)
 `)]), cB$1("tabs-pane-wrapper", `
 position: relative;
 overflow: hidden;
 transition: max-height .2s var(--n-bezier);
 `), cB$1("tab-pane", `
 color: var(--n-pane-text-color);
 width: 100%;
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .2s var(--n-bezier);
 left: 0;
 right: 0;
 top: 0;
 `, [c$2("&.next-transition-leave-active, &.prev-transition-leave-active, &.next-transition-enter-active, &.prev-transition-enter-active", `
 transition:
 color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 transform .2s var(--n-bezier),
 opacity .2s var(--n-bezier);
 `), c$2("&.next-transition-leave-active, &.prev-transition-leave-active", `
 position: absolute;
 `), c$2("&.next-transition-enter-from, &.prev-transition-leave-to", `
 transform: translateX(32px);
 opacity: 0;
 `), c$2("&.next-transition-leave-to, &.prev-transition-enter-from", `
 transform: translateX(-32px);
 opacity: 0;
 `), c$2("&.next-transition-leave-from, &.next-transition-enter-to, &.prev-transition-leave-from, &.prev-transition-enter-to", `
 transform: translateX(0);
 opacity: 1;
 `)]), cB$1("tabs-tab-pad", `
 box-sizing: border-box;
 width: var(--n-tab-gap);
 flex-grow: 0;
 flex-shrink: 0;
 `), cM("line-type, bar-type", [cB$1("tabs-tab", `
 font-weight: var(--n-tab-font-weight);
 box-sizing: border-box;
 vertical-align: bottom;
 `, [c$2("&:hover", {
  color: "var(--n-tab-text-color-hover)"
}), cM("active", `
 color: var(--n-tab-text-color-active);
 font-weight: var(--n-tab-font-weight-active);
 `), cM("disabled", {
  color: "var(--n-tab-text-color-disabled)"
})])]), cB$1("tabs-nav", [cM("line-type", [cM("top", [cE$1("prefix, suffix", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `), cB$1("tabs-nav-scroll-content", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `), cB$1("tabs-bar", `
 bottom: -1px;
 `)]), cM("left", [cE$1("prefix, suffix", `
 border-right: 1px solid var(--n-tab-border-color);
 `), cB$1("tabs-nav-scroll-content", `
 border-right: 1px solid var(--n-tab-border-color);
 `), cB$1("tabs-bar", `
 right: -1px;
 `)]), cM("right", [cE$1("prefix, suffix", `
 border-left: 1px solid var(--n-tab-border-color);
 `), cB$1("tabs-nav-scroll-content", `
 border-left: 1px solid var(--n-tab-border-color);
 `), cB$1("tabs-bar", `
 left: -1px;
 `)]), cM("bottom", [cE$1("prefix, suffix", `
 border-top: 1px solid var(--n-tab-border-color);
 `), cB$1("tabs-nav-scroll-content", `
 border-top: 1px solid var(--n-tab-border-color);
 `), cB$1("tabs-bar", `
 top: -1px;
 `)]), cE$1("prefix, suffix", `
 transition: border-color .3s var(--n-bezier);
 `), cB$1("tabs-nav-scroll-content", `
 transition: border-color .3s var(--n-bezier);
 `), cB$1("tabs-bar", `
 border-radius: 0;
 `)]), cM("card-type", [cE$1("prefix, suffix", `
 transition: border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-tab-border-color);
 `), cB$1("tabs-pad", `
 flex-grow: 1;
 transition: border-color .3s var(--n-bezier);
 border-bottom: 1px solid var(--n-tab-border-color);
 `), cB$1("tabs-tab-pad", `
 transition: border-color .3s var(--n-bezier);
 `), cB$1("tabs-tab", `
 font-weight: var(--n-tab-font-weight);
 border: 1px solid var(--n-tab-border-color);
 background-color: var(--n-tab-color);
 box-sizing: border-box;
 position: relative;
 vertical-align: bottom;
 display: flex;
 justify-content: space-between;
 font-size: var(--n-tab-font-size);
 color: var(--n-tab-text-color);
 `, [cM("addable", `
 padding-left: 8px;
 padding-right: 8px;
 font-size: 16px;
 `, [cE$1("height-placeholder", `
 width: 0;
 font-size: var(--n-tab-font-size);
 `), cNotM("disabled", [c$2("&:hover", `
 color: var(--n-tab-text-color-hover);
 `)])]), cM("closable", "padding-right: 8px;"), cM("active", `
 background-color: #0000;
 font-weight: var(--n-tab-font-weight-active);
 color: var(--n-tab-text-color-active);
 `), cM("disabled", "color: var(--n-tab-text-color-disabled);")]), cB$1("tabs-scroll-padding", "border-bottom: 1px solid var(--n-tab-border-color);")]), cM("left, right", [cB$1("tabs-wrapper", `
 flex-direction: column;
 `, [cB$1("tabs-tab-wrapper", `
 flex-direction: column;
 `, [cB$1("tabs-tab-pad", `
 height: var(--n-tab-gap-vertical);
 width: 100%;
 `)])])]), cM("top", [cM("card-type", [cB$1("tabs-tab", `
 border-top-left-radius: var(--n-tab-border-radius);
 border-top-right-radius: var(--n-tab-border-radius);
 `, [cM("active", `
 border-bottom: 1px solid #0000;
 `)]), cB$1("tabs-tab-pad", `
 border-bottom: 1px solid var(--n-tab-border-color);
 `)])]), cM("left", [cM("card-type", [cB$1("tabs-tab", `
 border-top-left-radius: var(--n-tab-border-radius);
 border-bottom-left-radius: var(--n-tab-border-radius);
 `, [cM("active", `
 border-right: 1px solid #0000;
 `)]), cB$1("tabs-tab-pad", `
 border-right: 1px solid var(--n-tab-border-color);
 `)])]), cM("right", [cM("card-type", [cB$1("tabs-tab", `
 border-top-right-radius: var(--n-tab-border-radius);
 border-bottom-right-radius: var(--n-tab-border-radius);
 `, [cM("active", `
 border-left: 1px solid #0000;
 `)]), cB$1("tabs-tab-pad", `
 border-left: 1px solid var(--n-tab-border-color);
 `)])]), cM("bottom", [cM("card-type", [cB$1("tabs-tab", `
 border-bottom-left-radius: var(--n-tab-border-radius);
 border-bottom-right-radius: var(--n-tab-border-radius);
 `, [cM("active", `
 border-top: 1px solid #0000;
 `)]), cB$1("tabs-tab-pad", `
 border-top: 1px solid var(--n-tab-border-color);
 `)])])])]);
const tabsProps = Object.assign(Object.assign({}, useTheme.props), {
  value: [String, Number],
  defaultValue: [String, Number],
  trigger: {
    type: String,
    default: "click"
  },
  type: {
    type: String,
    default: "bar"
  },
  closable: Boolean,
  justifyContent: String,
  size: {
    type: String,
    default: "medium"
  },
  placement: {
    type: String,
    default: "top"
  },
  tabStyle: [String, Object],
  barWidth: Number,
  paneClass: String,
  paneStyle: [String, Object],
  paneWrapperClass: String,
  paneWrapperStyle: [String, Object],
  addable: [Boolean, Object],
  tabsPadding: {
    type: Number,
    default: 0
  },
  animated: Boolean,
  onBeforeLeave: Function,
  onAdd: Function,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onClose: [Function, Array],
  labelSize: String,
  activeName: [String, Number],
  onActiveNameChange: [Function, Array]
});
var NTabs = defineComponent({
  name: "Tabs",
  props: tabsProps,
  setup(props, { slots }) {
    var _a2, _b2, _c2, _d2;
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Tabs", "-tabs", style$1, tabsLight$1, props, mergedClsPrefixRef);
    const tabsElRef = ref(null);
    const barElRef = ref(null);
    const scrollWrapperElRef = ref(null);
    const addTabInstRef = ref(null);
    const xScrollInstRef = ref(null);
    const startReachedRef = ref(true);
    const endReachedRef = ref(true);
    const compitableSizeRef = useCompitable(props, ["labelSize", "size"]);
    const compitableValueRef = useCompitable(props, ["activeName", "value"]);
    const uncontrolledValueRef = ref((_b2 = (_a2 = compitableValueRef.value) !== null && _a2 !== void 0 ? _a2 : props.defaultValue) !== null && _b2 !== void 0 ? _b2 : slots.default ? (_d2 = (_c2 = flatten$4(slots.default())[0]) === null || _c2 === void 0 ? void 0 : _c2.props) === null || _d2 === void 0 ? void 0 : _d2.name : null);
    const mergedValueRef = useMergedState(compitableValueRef, uncontrolledValueRef);
    const tabChangeIdRef = { id: 0 };
    const tabWrapperStyleRef = computed(() => {
      if (!props.justifyContent || props.type === "card")
        return void 0;
      return {
        display: "flex",
        justifyContent: props.justifyContent
      };
    });
    watch(mergedValueRef, () => {
      tabChangeIdRef.id = 0;
      updateCurrentBarStyle();
      updateCurrentScrollPosition();
    });
    function getCurrentEl() {
      var _a3;
      const { value: value2 } = mergedValueRef;
      if (value2 === null)
        return null;
      const tabEl = (_a3 = tabsElRef.value) === null || _a3 === void 0 ? void 0 : _a3.querySelector(`[data-name="${value2}"]`);
      return tabEl;
    }
    function updateBarStyle(tabEl) {
      if (props.type === "card")
        return;
      const { value: barEl } = barElRef;
      if (!barEl)
        return;
      if (tabEl) {
        const disabledClassName = `${mergedClsPrefixRef.value}-tabs-bar--disabled`;
        const { barWidth, placement } = props;
        if (tabEl.dataset.disabled === "true") {
          barEl.classList.add(disabledClassName);
        } else {
          barEl.classList.remove(disabledClassName);
        }
        if (["top", "bottom"].includes(placement)) {
          clearBarStyle(["top", "maxHeight", "height"]);
          if (typeof barWidth === "number" && tabEl.offsetWidth >= barWidth) {
            const offsetDiffLeft = Math.floor((tabEl.offsetWidth - barWidth) / 2) + tabEl.offsetLeft;
            barEl.style.left = `${offsetDiffLeft}px`;
            barEl.style.maxWidth = `${barWidth}px`;
          } else {
            barEl.style.left = `${tabEl.offsetLeft}px`;
            barEl.style.maxWidth = `${tabEl.offsetWidth}px`;
          }
          barEl.style.width = "8192px";
          void barEl.offsetWidth;
        } else {
          clearBarStyle(["left", "maxWidth", "width"]);
          if (typeof barWidth === "number" && tabEl.offsetHeight >= barWidth) {
            const offsetDiffTop = Math.floor((tabEl.offsetHeight - barWidth) / 2) + tabEl.offsetTop;
            barEl.style.top = `${offsetDiffTop}px`;
            barEl.style.maxHeight = `${barWidth}px`;
          } else {
            barEl.style.top = `${tabEl.offsetTop}px`;
            barEl.style.maxHeight = `${tabEl.offsetHeight}px`;
          }
          barEl.style.height = "8192px";
          void barEl.offsetHeight;
        }
      }
    }
    function clearBarStyle(styleProps) {
      const { value: barEl } = barElRef;
      if (!barEl)
        return;
      for (const prop of styleProps) {
        barEl.style[prop] = "";
      }
    }
    function updateCurrentBarStyle() {
      if (props.type === "card")
        return;
      const tabEl = getCurrentEl();
      if (tabEl) {
        updateBarStyle(tabEl);
      }
    }
    function updateCurrentScrollPosition(smooth) {
      var _a3;
      const scrollWrapperEl = (_a3 = xScrollInstRef.value) === null || _a3 === void 0 ? void 0 : _a3.$el;
      if (!scrollWrapperEl)
        return;
      const tabEl = getCurrentEl();
      if (!tabEl)
        return;
      const { scrollLeft: scrollWrapperElScrollLeft, offsetWidth: scrollWrapperElOffsetWidth } = scrollWrapperEl;
      const { offsetLeft: tabElOffsetLeft, offsetWidth: tabElOffsetWidth } = tabEl;
      if (scrollWrapperElScrollLeft > tabElOffsetLeft) {
        scrollWrapperEl.scrollTo({
          top: 0,
          left: tabElOffsetLeft,
          behavior: "smooth"
        });
      } else if (tabElOffsetLeft + tabElOffsetWidth > scrollWrapperElScrollLeft + scrollWrapperElOffsetWidth) {
        scrollWrapperEl.scrollTo({
          top: 0,
          left: tabElOffsetLeft + tabElOffsetWidth - scrollWrapperElOffsetWidth,
          behavior: "smooth"
        });
      }
    }
    const tabsPaneWrapperRef = ref(null);
    let fromHeight = 0;
    let hangingTransition = null;
    function onAnimationBeforeLeave(el2) {
      const tabsPaneWrapperEl = tabsPaneWrapperRef.value;
      if (tabsPaneWrapperEl) {
        fromHeight = el2.getBoundingClientRect().height;
        const fromHeightPx = `${fromHeight}px`;
        const applyFromStyle = () => {
          tabsPaneWrapperEl.style.height = fromHeightPx;
          tabsPaneWrapperEl.style.maxHeight = fromHeightPx;
        };
        if (!hangingTransition) {
          hangingTransition = applyFromStyle;
        } else {
          applyFromStyle();
          hangingTransition();
          hangingTransition = null;
        }
      }
    }
    function onAnimationEnter(el2) {
      const tabsPaneWrapperEl = tabsPaneWrapperRef.value;
      if (tabsPaneWrapperEl) {
        const targetHeight = el2.getBoundingClientRect().height;
        const applyTargetStyle = () => {
          void document.body.offsetHeight;
          tabsPaneWrapperEl.style.maxHeight = `${targetHeight}px`;
          tabsPaneWrapperEl.style.height = `${Math.max(fromHeight, targetHeight)}px`;
        };
        if (!hangingTransition) {
          hangingTransition = applyTargetStyle;
        } else {
          hangingTransition();
          hangingTransition = null;
          applyTargetStyle();
        }
      }
    }
    function onAnimationAfterEnter() {
      const tabsPaneWrapperEl = tabsPaneWrapperRef.value;
      if (tabsPaneWrapperEl) {
        tabsPaneWrapperEl.style.maxHeight = "";
        tabsPaneWrapperEl.style.height = "";
      }
    }
    const renderNameListRef = { value: [] };
    const animationDirectionRef = ref("next");
    function activateTab(panelName) {
      const currentValue = mergedValueRef.value;
      let dir = "next";
      for (const name2 of renderNameListRef.value) {
        if (name2 === currentValue) {
          break;
        }
        if (name2 === panelName) {
          dir = "prev";
          break;
        }
      }
      animationDirectionRef.value = dir;
      doUpdateValue(panelName);
    }
    function doUpdateValue(panelName) {
      const { onActiveNameChange, onUpdateValue, "onUpdate:value": _onUpdateValue } = props;
      if (onActiveNameChange) {
        call(onActiveNameChange, panelName);
      }
      if (onUpdateValue)
        call(onUpdateValue, panelName);
      if (_onUpdateValue)
        call(_onUpdateValue, panelName);
      uncontrolledValueRef.value = panelName;
    }
    function handleClose2(panelName) {
      const { onClose } = props;
      if (onClose)
        call(onClose, panelName);
    }
    function updateBarPositionInstantly() {
      const { value: barEl } = barElRef;
      if (!barEl)
        return;
      const disableTransitionClassName = "transition-disabled";
      barEl.classList.add(disableTransitionClassName);
      updateCurrentBarStyle();
      barEl.classList.remove(disableTransitionClassName);
    }
    let memorizedWidth = 0;
    function _handleNavResize(entry) {
      var _b3;
      if (entry.contentRect.width === 0 && entry.contentRect.height === 0) {
        return;
      }
      if (memorizedWidth === entry.contentRect.width) {
        return;
      }
      memorizedWidth = entry.contentRect.width;
      const { type: type4 } = props;
      if (type4 === "line" || type4 === "bar") {
        {
          updateBarPositionInstantly();
        }
      }
      if (type4 !== "segment") {
        deriveScrollShadow((_b3 = xScrollInstRef.value) === null || _b3 === void 0 ? void 0 : _b3.$el);
      }
    }
    const handleNavResize = throttle(_handleNavResize, 64);
    watch([() => props.justifyContent, () => props.size], () => {
      void nextTick(() => {
        const { type: type4 } = props;
        if (type4 === "line" || type4 === "bar") {
          updateBarPositionInstantly();
        }
      });
    });
    const addTabFixedRef = ref(false);
    function _handleTabsResize(entry) {
      var _a3;
      const { target, contentRect: { width } } = entry;
      const containerWidth = target.parentElement.offsetWidth;
      if (!addTabFixedRef.value) {
        if (containerWidth < width) {
          addTabFixedRef.value = true;
        }
      } else {
        const { value: addTabInst } = addTabInstRef;
        if (!addTabInst)
          return;
        if (containerWidth - width > addTabInst.$el.offsetWidth) {
          addTabFixedRef.value = false;
        }
      }
      deriveScrollShadow((_a3 = xScrollInstRef.value) === null || _a3 === void 0 ? void 0 : _a3.$el);
    }
    const handleTabsResize = throttle(_handleTabsResize, 64);
    function handleAdd() {
      const { onAdd } = props;
      if (onAdd)
        onAdd();
      void nextTick(() => {
        const currentEl = getCurrentEl();
        const { value: xScrollInst } = xScrollInstRef;
        if (!currentEl || !xScrollInst)
          return;
        xScrollInst.scrollTo({
          left: currentEl.offsetLeft,
          top: 0,
          behavior: "smooth"
        });
      });
    }
    function deriveScrollShadow(el2) {
      if (!el2)
        return;
      const { placement } = props;
      if (placement === "top" || placement === "bottom") {
        const { scrollLeft, scrollWidth, offsetWidth } = el2;
        startReachedRef.value = scrollLeft <= 0;
        endReachedRef.value = scrollLeft + offsetWidth >= scrollWidth;
      } else {
        const { scrollTop, scrollHeight, offsetHeight } = el2;
        startReachedRef.value = scrollTop <= 0;
        endReachedRef.value = scrollTop + offsetHeight >= scrollHeight;
      }
    }
    const handleScroll = throttle((e25) => {
      deriveScrollShadow(e25.target);
    }, 64);
    provide(tabsInjectionKey, {
      triggerRef: toRef(props, "trigger"),
      tabStyleRef: toRef(props, "tabStyle"),
      paneClassRef: toRef(props, "paneClass"),
      paneStyleRef: toRef(props, "paneStyle"),
      mergedClsPrefixRef,
      typeRef: toRef(props, "type"),
      closableRef: toRef(props, "closable"),
      valueRef: mergedValueRef,
      tabChangeIdRef,
      onBeforeLeaveRef: toRef(props, "onBeforeLeave"),
      activateTab,
      handleClose: handleClose2,
      handleAdd
    });
    onFontsReady(() => {
      updateCurrentBarStyle();
      updateCurrentScrollPosition();
    });
    watchEffect(() => {
      const { value: el2 } = scrollWrapperElRef;
      if (!el2)
        return;
      const { value: clsPrefix } = mergedClsPrefixRef;
      const shadowStartClass = `${clsPrefix}-tabs-nav-scroll-wrapper--shadow-start`;
      const shadowEndClass = `${clsPrefix}-tabs-nav-scroll-wrapper--shadow-end`;
      if (startReachedRef.value) {
        el2.classList.remove(shadowStartClass);
      } else {
        el2.classList.add(shadowStartClass);
      }
      if (endReachedRef.value) {
        el2.classList.remove(shadowEndClass);
      } else {
        el2.classList.add(shadowEndClass);
      }
    });
    const tabsRailElRef = ref(null);
    watch(mergedValueRef, () => {
      if (props.type === "segment") {
        const tabsRailEl = tabsRailElRef.value;
        if (tabsRailEl) {
          void nextTick(() => {
            tabsRailEl.classList.add("transition-disabled");
            void tabsRailEl.offsetWidth;
            tabsRailEl.classList.remove("transition-disabled");
          });
        }
      }
    });
    const exposedMethods = {
      syncBarPosition: () => {
        updateCurrentBarStyle();
      }
    };
    const cssVarsRef = computed(() => {
      const { value: size2 } = compitableSizeRef;
      const { type: type4 } = props;
      const typeSuffix = {
        card: "Card",
        bar: "Bar",
        line: "Line",
        segment: "Segment"
      }[type4];
      const sizeType = `${size2}${typeSuffix}`;
      const { self: { barColor, closeIconColor, closeIconColorHover, closeIconColorPressed, tabColor, tabBorderColor, paneTextColor, tabFontWeight, tabBorderRadius, tabFontWeightActive, colorSegment, fontWeightStrong, tabColorSegment, closeSize, closeIconSize, closeColorHover, closeColorPressed, closeBorderRadius, [createKey("panePadding", size2)]: panePadding, [createKey("tabPadding", sizeType)]: tabPadding, [createKey("tabPaddingVertical", sizeType)]: tabPaddingVertical, [createKey("tabGap", sizeType)]: tabGap, [createKey("tabGap", `${sizeType}Vertical`)]: tabGapVertical, [createKey("tabTextColor", type4)]: tabTextColor, [createKey("tabTextColorActive", type4)]: tabTextColorActive, [createKey("tabTextColorHover", type4)]: tabTextColorHover, [createKey("tabTextColorDisabled", type4)]: tabTextColorDisabled, [createKey("tabFontSize", size2)]: tabFontSize }, common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-color-segment": colorSegment,
        "--n-bar-color": barColor,
        "--n-tab-font-size": tabFontSize,
        "--n-tab-text-color": tabTextColor,
        "--n-tab-text-color-active": tabTextColorActive,
        "--n-tab-text-color-disabled": tabTextColorDisabled,
        "--n-tab-text-color-hover": tabTextColorHover,
        "--n-pane-text-color": paneTextColor,
        "--n-tab-border-color": tabBorderColor,
        "--n-tab-border-radius": tabBorderRadius,
        "--n-close-size": closeSize,
        "--n-close-icon-size": closeIconSize,
        "--n-close-color-hover": closeColorHover,
        "--n-close-color-pressed": closeColorPressed,
        "--n-close-border-radius": closeBorderRadius,
        "--n-close-icon-color": closeIconColor,
        "--n-close-icon-color-hover": closeIconColorHover,
        "--n-close-icon-color-pressed": closeIconColorPressed,
        "--n-tab-color": tabColor,
        "--n-tab-font-weight": tabFontWeight,
        "--n-tab-font-weight-active": tabFontWeightActive,
        "--n-tab-padding": tabPadding,
        "--n-tab-padding-vertical": tabPaddingVertical,
        "--n-tab-gap": tabGap,
        "--n-tab-gap-vertical": tabGapVertical,
        "--n-pane-padding-left": getMargin(panePadding, "left"),
        "--n-pane-padding-right": getMargin(panePadding, "right"),
        "--n-pane-padding-top": getMargin(panePadding, "top"),
        "--n-pane-padding-bottom": getMargin(panePadding, "bottom"),
        "--n-font-weight-strong": fontWeightStrong,
        "--n-tab-color-segment": tabColorSegment
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("tabs", computed(() => {
      return `${compitableSizeRef.value[0]}${props.type[0]}`;
    }), cssVarsRef, props) : void 0;
    return Object.assign({
      mergedClsPrefix: mergedClsPrefixRef,
      mergedValue: mergedValueRef,
      renderedNames: new Set(),
      tabsRailElRef,
      tabsPaneWrapperRef,
      tabsElRef,
      barElRef,
      addTabInstRef,
      xScrollInstRef,
      scrollWrapperElRef,
      addTabFixed: addTabFixedRef,
      tabWrapperStyle: tabWrapperStyleRef,
      handleNavResize,
      mergedSize: compitableSizeRef,
      handleScroll,
      handleTabsResize,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      animationDirection: animationDirectionRef,
      renderNameListRef,
      onAnimationBeforeLeave,
      onAnimationEnter,
      onAnimationAfterEnter,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender
    }, exposedMethods);
  },
  render() {
    const { mergedClsPrefix, type: type4, placement, addTabFixed, addable, mergedSize, renderNameListRef, onRender, paneWrapperClass, paneWrapperStyle, $slots: { default: defaultSlot, prefix: prefixSlot, suffix: suffixSlot } } = this;
    onRender === null || onRender === void 0 ? void 0 : onRender();
    const tabPaneChildren = defaultSlot ? flatten$4(defaultSlot()).filter((v2) => {
      return v2.type.__TAB_PANE__ === true;
    }) : [];
    const tabChildren = defaultSlot ? flatten$4(defaultSlot()).filter((v2) => {
      return v2.type.__TAB__ === true;
    }) : [];
    const showPane = !tabChildren.length;
    const isCard = type4 === "card";
    const isSegment = type4 === "segment";
    const mergedJustifyContent = !isCard && !isSegment && this.justifyContent;
    renderNameListRef.value = [];
    const scrollContent = () => {
      const tabs = h$1("div", { style: this.tabWrapperStyle, class: [`${mergedClsPrefix}-tabs-wrapper`] }, mergedJustifyContent ? null : h$1("div", { class: `${mergedClsPrefix}-tabs-scroll-padding`, style: { width: `${this.tabsPadding}px` } }), showPane ? tabPaneChildren.map((tabPaneVNode, index2) => {
        renderNameListRef.value.push(tabPaneVNode.props.name);
        return justifyTabDynamicProps(h$1(NTab, Object.assign({}, tabPaneVNode.props, { internalCreatedByPane: true, internalLeftPadded: index2 !== 0 && (!mergedJustifyContent || mergedJustifyContent === "center" || mergedJustifyContent === "start" || mergedJustifyContent === "end") }), tabPaneVNode.children ? {
          default: tabPaneVNode.children.tab
        } : void 0));
      }) : tabChildren.map((tabVNode, index2) => {
        renderNameListRef.value.push(tabVNode.props.name);
        if (index2 !== 0 && !mergedJustifyContent) {
          return justifyTabDynamicProps(createLeftPaddedTabVNode(tabVNode));
        } else {
          return justifyTabDynamicProps(tabVNode);
        }
      }), !addTabFixed && addable && isCard ? createAddTag(addable, (showPane ? tabPaneChildren.length : tabChildren.length) !== 0) : null, mergedJustifyContent ? null : h$1("div", { class: `${mergedClsPrefix}-tabs-scroll-padding`, style: { width: `${this.tabsPadding}px` } }));
      return h$1("div", { ref: "tabsElRef", class: `${mergedClsPrefix}-tabs-nav-scroll-content` }, isCard && addable ? h$1(VResizeObserver, { onResize: this.handleTabsResize }, {
        default: () => tabs
      }) : tabs, isCard ? h$1("div", { class: `${mergedClsPrefix}-tabs-pad` }) : null, isCard ? null : h$1("div", { ref: "barElRef", class: `${mergedClsPrefix}-tabs-bar` }));
    };
    const resolvedPlacement = isSegment ? "top" : placement;
    return h$1("div", { class: [
      `${mergedClsPrefix}-tabs`,
      this.themeClass,
      `${mergedClsPrefix}-tabs--${type4}-type`,
      `${mergedClsPrefix}-tabs--${mergedSize}-size`,
      mergedJustifyContent && `${mergedClsPrefix}-tabs--flex`,
      `${mergedClsPrefix}-tabs--${resolvedPlacement}`
    ], style: this.cssVars }, h$1("div", { class: [
      `${mergedClsPrefix}-tabs-nav--${type4}-type`,
      `${mergedClsPrefix}-tabs-nav--${resolvedPlacement}`,
      `${mergedClsPrefix}-tabs-nav`
    ] }, resolveWrappedSlot(prefixSlot, (children) => children && h$1("div", { class: `${mergedClsPrefix}-tabs-nav__prefix` }, children)), isSegment ? h$1("div", { class: `${mergedClsPrefix}-tabs-rail`, ref: "tabsRailElRef" }, showPane ? tabPaneChildren.map((tabPaneVNode, index2) => {
      renderNameListRef.value.push(tabPaneVNode.props.name);
      return h$1(NTab, Object.assign({}, tabPaneVNode.props, { internalCreatedByPane: true, internalLeftPadded: index2 !== 0 }), tabPaneVNode.children ? {
        default: tabPaneVNode.children.tab
      } : void 0);
    }) : tabChildren.map((tabVNode, index2) => {
      renderNameListRef.value.push(tabVNode.props.name);
      if (index2 === 0) {
        return tabVNode;
      } else {
        return createLeftPaddedTabVNode(tabVNode);
      }
    })) : h$1(VResizeObserver, { onResize: this.handleNavResize }, {
      default: () => h$1("div", { class: `${mergedClsPrefix}-tabs-nav-scroll-wrapper`, ref: "scrollWrapperElRef" }, ["top", "bottom"].includes(resolvedPlacement) ? h$1(VXScroll, { ref: "xScrollInstRef", onScroll: this.handleScroll }, {
        default: scrollContent
      }) : h$1("div", { class: `${mergedClsPrefix}-tabs-nav-y-scroll`, onScroll: this.handleScroll }, scrollContent()))
    }), addTabFixed && addable && isCard ? createAddTag(addable, true) : null, resolveWrappedSlot(suffixSlot, (children) => children && h$1("div", { class: `${mergedClsPrefix}-tabs-nav__suffix` }, children))), showPane && (this.animated && (resolvedPlacement === "top" || resolvedPlacement === "bottom") ? h$1("div", { ref: "tabsPaneWrapperRef", style: paneWrapperStyle, class: [`${mergedClsPrefix}-tabs-pane-wrapper`, paneWrapperClass] }, filterMapTabPanes(tabPaneChildren, this.mergedValue, this.renderedNames, this.onAnimationBeforeLeave, this.onAnimationEnter, this.onAnimationAfterEnter, this.animationDirection)) : filterMapTabPanes(tabPaneChildren, this.mergedValue, this.renderedNames)));
  }
});
function filterMapTabPanes(tabPaneVNodes, value2, renderedNames, onBeforeLeave, onEnter, onAfterEnter, animationDirection) {
  const children = [];
  tabPaneVNodes.forEach((vNode) => {
    const { name: name2, displayDirective, "display-directive": _displayDirective } = vNode.props;
    const matchDisplayDirective = (directive) => displayDirective === directive || _displayDirective === directive;
    const show = value2 === name2;
    if (vNode.key !== void 0) {
      vNode.key = name2;
    }
    if (show || matchDisplayDirective("show") || matchDisplayDirective("show:lazy") && renderedNames.has(name2)) {
      if (!renderedNames.has(name2)) {
        renderedNames.add(name2);
      }
      const useVShow = !matchDisplayDirective("if");
      children.push(useVShow ? withDirectives(vNode, [[vShow, show]]) : vNode);
    }
  });
  if (!animationDirection) {
    return children;
  }
  return h$1(TransitionGroup, { name: `${animationDirection}-transition`, onBeforeLeave, onEnter, onAfterEnter }, { default: () => children });
}
function createAddTag(addable, internalLeftPadded) {
  return h$1(NTab, { ref: "addTabInstRef", key: "__addable", name: "__addable", internalCreatedByPane: true, internalAddable: true, internalLeftPadded, disabled: typeof addable === "object" && addable.disabled });
}
function createLeftPaddedTabVNode(tabVNode) {
  const modifiedVNode = cloneVNode(tabVNode);
  if (modifiedVNode.props) {
    modifiedVNode.props.internalLeftPadded = true;
  } else {
    modifiedVNode.props = {
      internalLeftPadded: true
    };
  }
  return modifiedVNode;
}
function justifyTabDynamicProps(tabVNode) {
  if (Array.isArray(tabVNode.dynamicProps)) {
    if (!tabVNode.dynamicProps.includes("internalLeftPadded")) {
      tabVNode.dynamicProps.push("internalLeftPadded");
    }
  } else {
    tabVNode.dynamicProps = ["internalLeftPadded"];
  }
  return tabVNode;
}
const uploadInjectionKey = createInjectionKey("n-upload");
const uploadDraggerKey = "__UPLOAD_DRAGGER__";
var NUploadDragger = defineComponent({
  name: "UploadDragger",
  [uploadDraggerKey]: true,
  setup(_2, { slots }) {
    const NUpload2 = inject(uploadInjectionKey, null);
    if (!NUpload2) {
      throwError("upload-dragger", "`n-upload-dragger` must be placed inside `n-upload`.");
    }
    return () => {
      const { mergedClsPrefixRef: { value: mergedClsPrefix }, mergedDisabledRef: { value: mergedDisabled }, maxReachedRef: { value: maxReached } } = NUpload2;
      return h$1("div", { class: [
        `${mergedClsPrefix}-upload-dragger`,
        (mergedDisabled || maxReached) && `${mergedClsPrefix}-upload-dragger--disabled`
      ] }, slots);
    };
  }
});
var __awaiter$2 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value2) {
    return value2 instanceof P2 ? value2 : new P2(function(resolve) {
      resolve(value2);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value2) {
      try {
        step(generator.next(value2));
      } catch (e25) {
        reject(e25);
      }
    }
    function rejected(value2) {
      try {
        step(generator["throw"](value2));
      } catch (e25) {
        reject(e25);
      }
    }
    function step(result2) {
      result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
const isImageFileType = (type4) => type4.includes("image/");
const getExtname = (url2 = "") => {
  const temp = url2.split("/");
  const filename = temp[temp.length - 1];
  const filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [""])[0];
};
const imageExtensionRegex = /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i;
const isImageFile = (file) => {
  if (file.type) {
    return isImageFileType(file.type);
  }
  const fileNameExtension = getExtname(file.name || "");
  if (imageExtensionRegex.test(fileNameExtension)) {
    return true;
  }
  const url2 = file.thumbnailUrl || file.url || "";
  const urlExtension = getExtname(url2);
  if (/^data:image\//.test(url2) || imageExtensionRegex.test(urlExtension)) {
    return true;
  }
  return false;
};
function createImageDataUrl(file) {
  return __awaiter$2(this, void 0, void 0, function* () {
    return yield new Promise((resolve) => {
      if (!file.type || !isImageFileType(file.type)) {
        resolve("");
        return;
      }
      resolve(window.URL.createObjectURL(file));
    });
  });
}
const environmentSupportFile = isBrowser$2 && window.FileReader && window.File;
function isFileSystemDirectoryEntry(item) {
  return item.isDirectory;
}
function isFileSystemFileEntry(item) {
  return item.isFile;
}
function getFilesFromEntries(entries, directory) {
  return __awaiter$2(this, void 0, void 0, function* () {
    const fileAndEntries = [];
    let _resolve;
    let requestCallbackCount = 0;
    function lock() {
      requestCallbackCount++;
    }
    function unlock() {
      requestCallbackCount--;
      if (!requestCallbackCount) {
        _resolve(fileAndEntries);
      }
    }
    function _getFilesFromEntries(entries2) {
      entries2.forEach((entry) => {
        if (!entry)
          return;
        lock();
        if (directory && isFileSystemDirectoryEntry(entry)) {
          const directoryReader = entry.createReader();
          lock();
          directoryReader.readEntries((entries3) => {
            _getFilesFromEntries(entries3);
            unlock();
          }, () => {
            unlock();
          });
        } else if (isFileSystemFileEntry(entry)) {
          lock();
          entry.file((file) => {
            fileAndEntries.push({ file, entry, source: "dnd" });
            unlock();
          }, () => {
            unlock();
          });
        }
        unlock();
      });
    }
    yield new Promise((resolve) => {
      _resolve = resolve;
      _getFilesFromEntries(entries);
    });
    return fileAndEntries;
  });
}
function createSettledFileInfo(fileInfo) {
  const { id: id2, name: name2, percentage: percentage2, status, url: url2, file, thumbnailUrl, type: type4, fullPath, batchId } = fileInfo;
  return {
    id: id2,
    name: name2,
    percentage: percentage2 !== null && percentage2 !== void 0 ? percentage2 : null,
    status,
    url: url2 !== null && url2 !== void 0 ? url2 : null,
    file: file !== null && file !== void 0 ? file : null,
    thumbnailUrl: thumbnailUrl !== null && thumbnailUrl !== void 0 ? thumbnailUrl : null,
    type: type4 !== null && type4 !== void 0 ? type4 : null,
    fullPath: fullPath !== null && fullPath !== void 0 ? fullPath : null,
    batchId: batchId !== null && batchId !== void 0 ? batchId : null
  };
}
function matchType(name2, mimeType, accept) {
  name2 = name2.toLowerCase();
  mimeType = mimeType.toLocaleLowerCase();
  accept = accept.toLocaleLowerCase();
  const acceptAtoms = accept.split(",").map((acceptAtom) => acceptAtom.trim()).filter(Boolean);
  return acceptAtoms.some((acceptAtom) => {
    if (acceptAtom.startsWith(".")) {
      if (name2.endsWith(acceptAtom))
        return true;
    } else if (acceptAtom.includes("/")) {
      const [type4, subtype] = mimeType.split("/");
      const [acceptType, acceptSubtype] = acceptAtom.split("/");
      if (acceptType === "*" || type4 && acceptType && acceptType === type4) {
        if (acceptSubtype === "*" || subtype && acceptSubtype && acceptSubtype === subtype) {
          return true;
        }
      }
    } else {
      return true;
    }
    return false;
  });
}
const download = (url2, name2) => {
  if (!url2)
    return;
  const a2 = document.createElement("a");
  a2.href = url2;
  if (name2 !== void 0) {
    a2.download = name2;
  }
  document.body.appendChild(a2);
  a2.click();
  document.body.removeChild(a2);
};
var NUploadTrigger = defineComponent({
  name: "UploadTrigger",
  props: {
    abstract: Boolean
  },
  setup(props, { slots }) {
    const NUpload2 = inject(uploadInjectionKey, null);
    if (!NUpload2) {
      throwError("upload-trigger", "`n-upload-trigger` must be placed inside `n-upload`.");
    }
    const { mergedClsPrefixRef, mergedDisabledRef, maxReachedRef, listTypeRef, dragOverRef, openOpenFileDialog, draggerInsideRef, handleFileAddition, mergedDirectoryDndRef, triggerStyleRef } = NUpload2;
    const isImageCardTypeRef = computed(() => listTypeRef.value === "image-card");
    function handleTriggerClick() {
      if (mergedDisabledRef.value || maxReachedRef.value)
        return;
      openOpenFileDialog();
    }
    function handleTriggerDragOver(e25) {
      e25.preventDefault();
      dragOverRef.value = true;
    }
    function handleTriggerDragEnter(e25) {
      e25.preventDefault();
      dragOverRef.value = true;
    }
    function handleTriggerDragLeave(e25) {
      e25.preventDefault();
      dragOverRef.value = false;
    }
    function handleTriggerDrop(e25) {
      var _a2;
      e25.preventDefault();
      if (!draggerInsideRef.value || mergedDisabledRef.value || maxReachedRef.value) {
        dragOverRef.value = false;
        return;
      }
      const dataTransferItems = (_a2 = e25.dataTransfer) === null || _a2 === void 0 ? void 0 : _a2.items;
      if (dataTransferItems === null || dataTransferItems === void 0 ? void 0 : dataTransferItems.length) {
        void getFilesFromEntries(Array.from(dataTransferItems).map((item) => item.webkitGetAsEntry()), mergedDirectoryDndRef.value).then((files) => {
          handleFileAddition(files);
        }).finally(() => {
          dragOverRef.value = false;
        });
      } else {
        dragOverRef.value = false;
      }
    }
    return () => {
      var _a2;
      const { value: mergedClsPrefix } = mergedClsPrefixRef;
      return props.abstract ? (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots, {
        handleClick: handleTriggerClick,
        handleDrop: handleTriggerDrop,
        handleDragOver: handleTriggerDragOver,
        handleDragEnter: handleTriggerDragEnter,
        handleDragLeave: handleTriggerDragLeave
      }) : h$1("div", { class: [
        `${mergedClsPrefix}-upload-trigger`,
        (mergedDisabledRef.value || maxReachedRef.value) && `${mergedClsPrefix}-upload-trigger--disabled`,
        isImageCardTypeRef.value && `${mergedClsPrefix}-upload-trigger--image-card`
      ], style: triggerStyleRef.value, onClick: handleTriggerClick, onDrop: handleTriggerDrop, onDragover: handleTriggerDragOver, onDragenter: handleTriggerDragEnter, onDragleave: handleTriggerDragLeave }, isImageCardTypeRef.value ? h$1(NUploadDragger, null, {
        default: () => resolveSlot(slots.default, () => [
          h$1(NBaseIcon, { clsPrefix: mergedClsPrefix }, { default: () => h$1(AddIcon, null) })
        ])
      }) : slots);
    };
  }
});
var NUploadProgress = defineComponent({
  name: "UploadProgress",
  props: {
    show: Boolean,
    percentage: {
      type: Number,
      required: true
    },
    status: {
      type: String,
      required: true
    }
  },
  setup() {
    const NUpload2 = inject(uploadInjectionKey);
    return {
      mergedTheme: NUpload2.mergedThemeRef
    };
  },
  render() {
    return h$1(NFadeInExpandTransition, null, {
      default: () => this.show ? h$1(NProgress, { type: "line", showIndicator: false, percentage: this.percentage, status: this.status, height: 2, theme: this.mergedTheme.peers.Progress, themeOverrides: this.mergedTheme.peerOverrides.Progress }) : null
    });
  }
});
const imageIcon = h$1("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, h$1("g", { fill: "none" }, h$1("path", { d: "M21.75 3A3.25 3.25 0 0 1 25 6.25v15.5A3.25 3.25 0 0 1 21.75 25H6.25A3.25 3.25 0 0 1 3 21.75V6.25A3.25 3.25 0 0 1 6.25 3h15.5zm.583 20.4l-7.807-7.68a.75.75 0 0 0-.968-.07l-.084.07l-7.808 7.68c.183.065.38.1.584.1h15.5c.204 0 .4-.035.583-.1l-7.807-7.68l7.807 7.68zM21.75 4.5H6.25A1.75 1.75 0 0 0 4.5 6.25v15.5c0 .208.036.408.103.593l7.82-7.692a2.25 2.25 0 0 1 3.026-.117l.129.117l7.82 7.692c.066-.185.102-.385.102-.593V6.25a1.75 1.75 0 0 0-1.75-1.75zm-3.25 3a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5zm0 1.5a1 1 0 1 0 0 2a1 1 0 0 0 0-2z", fill: "currentColor" })));
const documentIcon = h$1("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28" }, h$1("g", { fill: "none" }, h$1("path", { d: "M6.4 2A2.4 2.4 0 0 0 4 4.4v19.2A2.4 2.4 0 0 0 6.4 26h15.2a2.4 2.4 0 0 0 2.4-2.4V11.578c0-.729-.29-1.428-.805-1.944l-6.931-6.931A2.4 2.4 0 0 0 14.567 2H6.4zm-.9 2.4a.9.9 0 0 1 .9-.9H14V10a2 2 0 0 0 2 2h6.5v11.6a.9.9 0 0 1-.9.9H6.4a.9.9 0 0 1-.9-.9V4.4zm16.44 6.1H16a.5.5 0 0 1-.5-.5V4.06l6.44 6.44z", fill: "currentColor" })));
var __awaiter$1 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value2) {
    return value2 instanceof P2 ? value2 : new P2(function(resolve) {
      resolve(value2);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value2) {
      try {
        step(generator.next(value2));
      } catch (e25) {
        reject(e25);
      }
    }
    function rejected(value2) {
      try {
        step(generator["throw"](value2));
      } catch (e25) {
        reject(e25);
      }
    }
    function step(result2) {
      result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
const buttonThemeOverrides = {
  paddingMedium: "0 3px",
  heightMedium: "24px",
  iconSizeMedium: "18px"
};
var NUploadFile = defineComponent({
  name: "UploadFile",
  props: {
    clsPrefix: {
      type: String,
      required: true
    },
    file: {
      type: Object,
      required: true
    },
    listType: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const NUpload2 = inject(uploadInjectionKey);
    const imageRef = ref(null);
    const thumbnailUrlRef = ref("");
    const progressStatusRef = computed(() => {
      const { file } = props;
      if (file.status === "finished")
        return "success";
      if (file.status === "error")
        return "error";
      return "info";
    });
    const buttonTypeRef = computed(() => {
      const { file } = props;
      if (file.status === "error")
        return "error";
      return void 0;
    });
    const showProgressRef = computed(() => {
      const { file } = props;
      return file.status === "uploading";
    });
    const showCancelButtonRef = computed(() => {
      if (!NUpload2.showCancelButtonRef.value)
        return false;
      const { file } = props;
      return ["uploading", "pending", "error"].includes(file.status);
    });
    const showRemoveButtonRef = computed(() => {
      if (!NUpload2.showRemoveButtonRef.value)
        return false;
      const { file } = props;
      return ["finished"].includes(file.status);
    });
    const showDownloadButtonRef = computed(() => {
      if (!NUpload2.showDownloadButtonRef.value)
        return false;
      const { file } = props;
      return ["finished"].includes(file.status);
    });
    const showRetryButtonRef = computed(() => {
      if (!NUpload2.showRetryButtonRef.value)
        return false;
      const { file } = props;
      return ["error"].includes(file.status);
    });
    const mergedThumbnailUrlRef = useMemo(() => {
      return thumbnailUrlRef.value || props.file.thumbnailUrl || props.file.url;
    });
    const showPreviewButtonRef = computed(() => {
      if (!NUpload2.showPreviewButtonRef.value)
        return false;
      const { file: { status }, listType } = props;
      return ["finished"].includes(status) && mergedThumbnailUrlRef.value && listType === "image-card";
    });
    function handleRetryClick() {
      NUpload2.submit(props.file.id);
    }
    function handleRemoveOrCancelClick(e25) {
      e25.preventDefault();
      const { file } = props;
      if (["finished", "pending", "error"].includes(file.status)) {
        handleRemove(file);
      } else if (["uploading"].includes(file.status)) {
        handleAbort(file);
      } else {
        warn$2("upload", "The button clicked type is unknown.");
      }
    }
    function handleDownloadClick(e25) {
      e25.preventDefault();
      handleDownload(props.file);
    }
    function handleRemove(file) {
      const { xhrMap, doChange, onRemoveRef: { value: onRemove }, mergedFileListRef: { value: mergedFileList } } = NUpload2;
      void Promise.resolve(onRemove ? onRemove({
        file: Object.assign({}, file),
        fileList: mergedFileList
      }) : true).then((result2) => {
        if (result2 === false)
          return;
        const fileAfterChange = Object.assign({}, file, {
          status: "removed"
        });
        xhrMap.delete(file.id);
        doChange(fileAfterChange, void 0, {
          remove: true
        });
      });
    }
    function handleDownload(file) {
      const { onDownloadRef: { value: onDownload } } = NUpload2;
      void Promise.resolve(onDownload ? onDownload(Object.assign({}, file)) : true).then((res) => {
        if (res !== false) {
          download(file.url, file.name);
        }
      });
    }
    function handleAbort(file) {
      const { xhrMap } = NUpload2;
      const xhr = xhrMap.get(file.id);
      xhr === null || xhr === void 0 ? void 0 : xhr.abort();
      handleRemove(Object.assign({}, file));
    }
    function handlePreviewClick() {
      const { onPreviewRef: { value: onPreview } } = NUpload2;
      if (onPreview) {
        onPreview(props.file);
      } else if (props.listType === "image-card") {
        const { value: value2 } = imageRef;
        if (!value2)
          return;
        value2.click();
      }
    }
    const deriveFileThumbnailUrl = () => __awaiter$1(this, void 0, void 0, function* () {
      const { listType } = props;
      if (listType !== "image" && listType !== "image-card") {
        return;
      }
      if (NUpload2.shouldUseThumbnailUrlRef.value(props.file)) {
        thumbnailUrlRef.value = yield NUpload2.getFileThumbnailUrlResolver(props.file);
      }
    });
    watchEffect(() => {
      void deriveFileThumbnailUrl();
    });
    return {
      mergedTheme: NUpload2.mergedThemeRef,
      progressStatus: progressStatusRef,
      buttonType: buttonTypeRef,
      showProgress: showProgressRef,
      disabled: NUpload2.mergedDisabledRef,
      showCancelButton: showCancelButtonRef,
      showRemoveButton: showRemoveButtonRef,
      showDownloadButton: showDownloadButtonRef,
      showRetryButton: showRetryButtonRef,
      showPreviewButton: showPreviewButtonRef,
      mergedThumbnailUrl: mergedThumbnailUrlRef,
      shouldUseThumbnailUrl: NUpload2.shouldUseThumbnailUrlRef,
      renderIcon: NUpload2.renderIconRef,
      imageRef,
      handleRemoveOrCancelClick,
      handleDownloadClick,
      handleRetryClick,
      handlePreviewClick
    };
  },
  render() {
    const { clsPrefix, mergedTheme, listType, file, renderIcon: renderIcon2 } = this;
    let icon;
    const isImageType = listType === "image";
    const isImageCardType = listType === "image-card";
    if (isImageType || isImageCardType) {
      icon = !this.shouldUseThumbnailUrl(file) || !this.mergedThumbnailUrl ? h$1("span", { class: `${clsPrefix}-upload-file-info__thumbnail` }, renderIcon2 ? renderIcon2(file) : isImageFile(file) ? h$1(NBaseIcon, { clsPrefix }, { default: () => imageIcon }) : h$1(NBaseIcon, { clsPrefix }, { default: () => documentIcon })) : h$1("a", { rel: "noopener noreferer", target: "_blank", href: file.url || void 0, class: `${clsPrefix}-upload-file-info__thumbnail`, onClick: this.handlePreviewClick }, listType === "image-card" ? h$1(NImage, { src: this.mergedThumbnailUrl || void 0, previewSrc: file.url || void 0, alt: file.name, ref: "imageRef" }) : h$1("img", { src: this.mergedThumbnailUrl || void 0, alt: file.name }));
    } else {
      icon = h$1("span", { class: `${clsPrefix}-upload-file-info__thumbnail` }, renderIcon2 ? renderIcon2(file) : h$1(NBaseIcon, { clsPrefix }, { default: () => h$1(AttachIcon, null) }));
    }
    const progress = h$1(NUploadProgress, { show: this.showProgress, percentage: file.percentage || 0, status: this.progressStatus });
    const showName = listType === "text" || listType === "image";
    return h$1("div", { class: [
      `${clsPrefix}-upload-file`,
      `${clsPrefix}-upload-file--${this.progressStatus}-status`,
      file.url && file.status !== "error" && listType !== "image-card" && `${clsPrefix}-upload-file--with-url`,
      `${clsPrefix}-upload-file--${listType}-type`
    ] }, h$1("div", { class: `${clsPrefix}-upload-file-info` }, icon, h$1("div", { class: `${clsPrefix}-upload-file-info__name` }, showName && (file.url && file.status !== "error" ? h$1("a", { rel: "noopener noreferer", target: "_blank", href: file.url || void 0, onClick: this.handlePreviewClick }, file.name) : h$1("span", { onClick: this.handlePreviewClick }, file.name)), isImageType && progress), h$1("div", { class: [
      `${clsPrefix}-upload-file-info__action`,
      `${clsPrefix}-upload-file-info__action--${listType}-type`
    ] }, this.showPreviewButton ? h$1(NButton, { key: "preview", quaternary: true, type: this.buttonType, onClick: this.handlePreviewClick, theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, builtinThemeOverrides: buttonThemeOverrides }, {
      icon: () => h$1(NBaseIcon, { clsPrefix }, { default: () => h$1(EyeIcon, null) })
    }) : null, (this.showRemoveButton || this.showCancelButton) && !this.disabled && h$1(NButton, { key: "cancelOrTrash", theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, quaternary: true, builtinThemeOverrides: buttonThemeOverrides, type: this.buttonType, onClick: this.handleRemoveOrCancelClick }, {
      icon: () => h$1(NIconSwitchTransition, null, {
        default: () => this.showRemoveButton ? h$1(NBaseIcon, { clsPrefix, key: "trash" }, { default: () => h$1(TrashIcon, null) }) : h$1(NBaseIcon, { clsPrefix, key: "cancel" }, { default: () => h$1(CancelIcon, null) })
      })
    }), this.showRetryButton && !this.disabled && h$1(NButton, { key: "retry", quaternary: true, type: this.buttonType, onClick: this.handleRetryClick, theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, builtinThemeOverrides: buttonThemeOverrides }, {
      icon: () => h$1(NBaseIcon, { clsPrefix }, { default: () => h$1(RetryIcon, null) })
    }), this.showDownloadButton ? h$1(NButton, { key: "download", quaternary: true, type: this.buttonType, onClick: this.handleDownloadClick, theme: mergedTheme.peers.Button, themeOverrides: mergedTheme.peerOverrides.Button, builtinThemeOverrides: buttonThemeOverrides }, {
      icon: () => h$1(NBaseIcon, { clsPrefix }, { default: () => h$1(DownloadIcon, null) })
    }) : null)), !isImageType && progress);
  }
});
var NUploadFileList = defineComponent({
  name: "UploadFileList",
  setup(_2, { slots }) {
    const NUpload2 = inject(uploadInjectionKey, null);
    if (!NUpload2) {
      throwError("upload-file-list", "`n-upload-file-list` must be placed inside `n-upload`.");
    }
    const { abstractRef, mergedClsPrefixRef, listTypeRef, mergedFileListRef, fileListStyleRef, cssVarsRef, themeClassRef, maxReachedRef, showTriggerRef, imageGroupPropsRef } = NUpload2;
    const isImageCardTypeRef = computed(() => listTypeRef.value === "image-card");
    const renderFileList = () => mergedFileListRef.value.map((file) => h$1(NUploadFile, { clsPrefix: mergedClsPrefixRef.value, key: file.id, file, listType: listTypeRef.value }));
    const renderUploadFileList = () => isImageCardTypeRef.value ? h$1(NImageGroup, Object.assign({}, imageGroupPropsRef.value), { default: renderFileList }) : h$1(NFadeInExpandTransition, { group: true }, {
      default: renderFileList
    });
    return () => {
      const { value: mergedClsPrefix } = mergedClsPrefixRef;
      const { value: abstract } = abstractRef;
      return h$1("div", { class: [
        `${mergedClsPrefix}-upload-file-list`,
        isImageCardTypeRef.value && `${mergedClsPrefix}-upload-file-list--grid`,
        abstract ? themeClassRef === null || themeClassRef === void 0 ? void 0 : themeClassRef.value : void 0
      ], style: [
        abstract && cssVarsRef ? cssVarsRef.value : "",
        fileListStyleRef.value
      ] }, renderUploadFileList(), showTriggerRef.value && !maxReachedRef.value && isImageCardTypeRef.value && h$1(NUploadTrigger, null, slots));
    };
  }
});
var style = c$2([cB$1("upload", "width: 100%;", [cM("dragger-inside", [cB$1("upload-trigger", `
 display: block;
 `)]), cM("drag-over", [cB$1("upload-dragger", `
 border: var(--n-dragger-border-hover);
 `)])]), cB$1("upload-dragger", `
 cursor: pointer;
 box-sizing: border-box;
 width: 100%;
 text-align: center;
 border-radius: var(--n-border-radius);
 padding: 24px;
 opacity: 1;
 transition:
 opacity .3s var(--n-bezier),
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier);
 background-color: var(--n-dragger-color);
 border: var(--n-dragger-border);
 `, [c$2("&:hover", `
 border: var(--n-dragger-border-hover);
 `), cM("disabled", `
 cursor: not-allowed;
 `)]), cB$1("upload-trigger", `
 display: inline-block;
 box-sizing: border-box;
 opacity: 1;
 transition: opacity .3s var(--n-bezier);
 `, [c$2("+", [cB$1("upload-file-list", "margin-top: 8px;")]), cM("disabled", `
 opacity: var(--n-item-disabled-opacity);
 cursor: not-allowed;
 `), cM("image-card", `
 width: 96px;
 height: 96px;
 `, [cB$1("base-icon", `
 font-size: 24px;
 `), cB$1("upload-dragger", `
 padding: 0;
 height: 100%;
 width: 100%;
 display: flex;
 align-items: center;
 justify-content: center;
 `)])]), cB$1("upload-file-list", `
 line-height: var(--n-line-height);
 opacity: 1;
 transition: opacity .3s var(--n-bezier);
 `, [c$2("a, img", "outline: none;"), cM("disabled", `
 opacity: var(--n-item-disabled-opacity);
 cursor: not-allowed;
 `, [cB$1("upload-file", "cursor: not-allowed;")]), cM("grid", `
 display: grid;
 grid-template-columns: repeat(auto-fill, 96px);
 grid-gap: 8px;
 margin-top: 0;
 `), cB$1("upload-file", `
 display: block;
 box-sizing: border-box;
 cursor: default;
 padding: 0px 12px 0 6px;
 transition: background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 `, [fadeInHeightExpandTransition(), cB$1("progress", [fadeInHeightExpandTransition({
  foldPadding: true
})]), c$2("&:hover", `
 background-color: var(--n-item-color-hover);
 `, [cB$1("upload-file-info", [cE$1("action", `
 opacity: 1;
 `)])]), cM("image-type", `
 border-radius: var(--n-border-radius);
 text-decoration: underline;
 text-decoration-color: #0000;
 `, [cB$1("upload-file-info", `
 padding-top: 0px;
 padding-bottom: 0px;
 width: 100%;
 height: 100%;
 display: flex;
 justify-content: space-between;
 align-items: center;
 padding: 6px 0;
 `, [cB$1("progress", `
 padding: 2px 0;
 margin-bottom: 0;
 `), cE$1("name", `
 padding: 0 8px;
 `), cE$1("thumbnail", `
 width: 32px;
 height: 32px;
 font-size: 28px;
 display: flex;
 justify-content: center;
 align-items: center;
 `, [c$2("img", `
 width: 100%;
 `)])])]), cM("text-type", [cB$1("progress", `
 box-sizing: border-box;
 padding-bottom: 6px;
 margin-bottom: 6px;
 `)]), cM("image-card-type", `
 position: relative;
 width: 96px;
 height: 96px;
 border: var(--n-item-border-image-card);
 border-radius: var(--n-border-radius);
 padding: 0;
 display: flex;
 align-items: center;
 justify-content: center;
 transition: border-color .3s var(--n-bezier), background-color .3s var(--n-bezier);
 border-radius: var(--n-border-radius);
 overflow: hidden;
 `, [cB$1("progress", `
 position: absolute;
 left: 8px;
 bottom: 8px;
 right: 8px;
 width: unset;
 `), cB$1("upload-file-info", `
 padding: 0;
 width: 100%;
 height: 100%;
 `, [cE$1("thumbnail", `
 width: 100%;
 height: 100%;
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 font-size: 36px;
 `, [c$2("img", `
 width: 100%;
 `)])]), c$2("&::before", `
 position: absolute;
 z-index: 1;
 left: 0;
 right: 0;
 top: 0;
 bottom: 0;
 border-radius: inherit;
 opacity: 0;
 transition: opacity .2s var(--n-bezier);
 content: "";
 `), c$2("&:hover", [c$2("&::before", "opacity: 1;"), cB$1("upload-file-info", [cE$1("thumbnail", "opacity: .12;")])])]), cM("error-status", [c$2("&:hover", `
 background-color: var(--n-item-color-hover-error);
 `), cB$1("upload-file-info", [cE$1("name", "color: var(--n-item-text-color-error);"), cE$1("thumbnail", "color: var(--n-item-text-color-error);")]), cM("image-card-type", `
 border: var(--n-item-border-image-card-error);
 `)]), cM("with-url", `
 cursor: pointer;
 `, [cB$1("upload-file-info", [cE$1("name", `
 color: var(--n-item-text-color-success);
 text-decoration-color: var(--n-item-text-color-success);
 `, [c$2("a", `
 text-decoration: underline;
 `)])])]), cB$1("upload-file-info", `
 position: relative;
 padding-top: 6px;
 padding-bottom: 6px;
 display: flex;
 flex-wrap: nowrap;
 `, [cE$1("thumbnail", `
 font-size: 18px;
 opacity: 1;
 transition: opacity .2s var(--n-bezier);
 color: var(--n-item-icon-color);
 `, [cB$1("base-icon", `
 margin-right: 2px;
 vertical-align: middle;
 transition: color .3s var(--n-bezier);
 `)]), cE$1("action", `
 padding-top: inherit;
 padding-bottom: inherit;
 position: absolute;
 right: 0;
 top: 0;
 bottom: 0;
 width: 80px;
 display: flex;
 align-items: center;
 transition: opacity .2s var(--n-bezier);
 justify-content: flex-end;
 opacity: 0;
 `, [cB$1("button", [c$2("&:not(:last-child)", {
  marginRight: "4px"
}), cB$1("base-icon", [c$2("svg", [iconSwitchTransition()])])]), cM("image-type", `
 position: relative;
 max-width: 80px;
 width: auto;
 `), cM("image-card-type", `
 z-index: 2;
 position: absolute;
 width: 100%;
 height: 100%;
 left: 0;
 right: 0;
 bottom: 0;
 top: 0;
 display: flex;
 justify-content: center;
 align-items: center;
 `)]), cE$1("name", `
 color: var(--n-item-text-color);
 flex: 1;
 display: flex;
 justify-content: center;
 text-overflow: ellipsis;
 overflow: hidden;
 flex-direction: column;
 text-decoration-color: #0000;
 font-size: var(--n-font-size);
 transition:
 color .3s var(--n-bezier),
 text-decoration-color .3s var(--n-bezier); 
 `, [c$2("a", `
 color: inherit;
 text-decoration: underline;
 `)])])])]), cB$1("upload-file-input", `
 display: block;
 width: 0;
 height: 0;
 opacity: 0;
 `)]);
var __awaiter = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value2) {
    return value2 instanceof P2 ? value2 : new P2(function(resolve) {
      resolve(value2);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value2) {
      try {
        step(generator.next(value2));
      } catch (e25) {
        reject(e25);
      }
    }
    function rejected(value2) {
      try {
        step(generator["throw"](value2));
      } catch (e25) {
        reject(e25);
      }
    }
    function step(result2) {
      result2.done ? resolve(result2.value) : adopt(result2.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
function createXhrHandlers(inst, file, xhr) {
  const { doChange, xhrMap } = inst;
  let percentage2 = 0;
  function handleXHRError(e25) {
    var _a2;
    let fileAfterChange = Object.assign({}, file, {
      status: "error",
      percentage: percentage2
    });
    xhrMap.delete(file.id);
    fileAfterChange = createSettledFileInfo(((_a2 = inst.onError) === null || _a2 === void 0 ? void 0 : _a2.call(inst, { file: fileAfterChange, event: e25 })) || fileAfterChange);
    doChange(fileAfterChange, e25);
  }
  function handleXHRLoad(e25) {
    var _a2;
    if (inst.isErrorState) {
      if (inst.isErrorState(xhr)) {
        handleXHRError(e25);
        return;
      }
    } else {
      if (xhr.status < 200 || xhr.status >= 300) {
        handleXHRError(e25);
        return;
      }
    }
    let fileAfterChange = Object.assign({}, file, {
      status: "finished",
      percentage: percentage2
    });
    xhrMap.delete(file.id);
    fileAfterChange = createSettledFileInfo(((_a2 = inst.onFinish) === null || _a2 === void 0 ? void 0 : _a2.call(inst, { file: fileAfterChange, event: e25 })) || fileAfterChange);
    doChange(fileAfterChange, e25);
  }
  return {
    handleXHRLoad,
    handleXHRError,
    handleXHRAbort(e25) {
      const fileAfterChange = Object.assign({}, file, {
        status: "removed",
        file: null,
        percentage: percentage2
      });
      xhrMap.delete(file.id);
      doChange(fileAfterChange, e25);
    },
    handleXHRProgress(e25) {
      const fileAfterChange = Object.assign({}, file, {
        status: "uploading"
      });
      if (e25.lengthComputable) {
        const progress = Math.ceil(e25.loaded / e25.total * 100);
        fileAfterChange.percentage = progress;
        percentage2 = progress;
      }
      doChange(fileAfterChange, e25);
    }
  };
}
function customSubmitImpl(options) {
  const { inst, file, data, headers, withCredentials, action, customRequest } = options;
  const { doChange } = options.inst;
  let percentage2 = 0;
  customRequest({
    file,
    data,
    headers,
    withCredentials,
    action,
    onProgress(event) {
      const fileAfterChange = Object.assign({}, file, {
        status: "uploading"
      });
      const progress = event.percent;
      fileAfterChange.percentage = progress;
      percentage2 = progress;
      doChange(fileAfterChange);
    },
    onFinish() {
      var _a2;
      let fileAfterChange = Object.assign({}, file, {
        status: "finished",
        percentage: percentage2
      });
      fileAfterChange = createSettledFileInfo(((_a2 = inst.onFinish) === null || _a2 === void 0 ? void 0 : _a2.call(inst, { file: fileAfterChange })) || fileAfterChange);
      doChange(fileAfterChange);
    },
    onError() {
      var _a2;
      let fileAfterChange = Object.assign({}, file, {
        status: "error",
        percentage: percentage2
      });
      fileAfterChange = createSettledFileInfo(((_a2 = inst.onError) === null || _a2 === void 0 ? void 0 : _a2.call(inst, { file: fileAfterChange })) || fileAfterChange);
      doChange(fileAfterChange);
    }
  });
}
function registerHandler(inst, file, request) {
  const handlers2 = createXhrHandlers(inst, file, request);
  request.onabort = handlers2.handleXHRAbort;
  request.onerror = handlers2.handleXHRError;
  request.onload = handlers2.handleXHRLoad;
  if (request.upload) {
    request.upload.onprogress = handlers2.handleXHRProgress;
  }
}
function unwrapFunctionValue(data, file) {
  if (typeof data === "function") {
    return data({ file });
  }
  if (data)
    return data;
  return {};
}
function setHeaders(request, headers, file) {
  const headersObject = unwrapFunctionValue(headers, file);
  if (!headersObject)
    return;
  Object.keys(headersObject).forEach((key) => {
    request.setRequestHeader(key, headersObject[key]);
  });
}
function appendData(formData, data, file) {
  const dataObject = unwrapFunctionValue(data, file);
  if (!dataObject)
    return;
  Object.keys(dataObject).forEach((key) => {
    formData.append(key, dataObject[key]);
  });
}
function submitImpl(inst, fieldName, file, { method: method4, action, withCredentials, responseType, headers, data }) {
  const request = new XMLHttpRequest();
  request.responseType = responseType;
  inst.xhrMap.set(file.id, request);
  request.withCredentials = withCredentials;
  const formData = new FormData();
  appendData(formData, data, file);
  formData.append(fieldName, file.file);
  registerHandler(inst, file, request);
  if (action !== void 0) {
    request.open(method4.toUpperCase(), action);
    setHeaders(request, headers, file);
    request.send(formData);
    const fileAfterChange = Object.assign({}, file, {
      status: "uploading"
    });
    inst.doChange(fileAfterChange);
  }
}
const uploadProps = Object.assign(Object.assign({}, useTheme.props), {
  name: {
    type: String,
    default: "file"
  },
  accept: String,
  action: String,
  customRequest: Function,
  directory: Boolean,
  directoryDnd: { type: Boolean, default: void 0 },
  method: {
    type: String,
    default: "POST"
  },
  multiple: Boolean,
  showFileList: {
    type: Boolean,
    default: true
  },
  data: [Object, Function],
  headers: [Object, Function],
  withCredentials: Boolean,
  responseType: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  onChange: Function,
  onRemove: Function,
  onFinish: Function,
  onError: Function,
  onBeforeUpload: Function,
  isErrorState: Function,
  onDownload: Function,
  defaultUpload: {
    type: Boolean,
    default: true
  },
  fileList: Array,
  "onUpdate:fileList": [Function, Array],
  onUpdateFileList: [Function, Array],
  fileListStyle: [String, Object],
  defaultFileList: {
    type: Array,
    default: () => []
  },
  showCancelButton: {
    type: Boolean,
    default: true
  },
  showRemoveButton: {
    type: Boolean,
    default: true
  },
  showDownloadButton: Boolean,
  showRetryButton: {
    type: Boolean,
    default: true
  },
  showPreviewButton: {
    type: Boolean,
    default: true
  },
  listType: {
    type: String,
    default: "text"
  },
  onPreview: Function,
  shouldUseThumbnailUrl: {
    type: Function,
    default: (file) => {
      if (!environmentSupportFile)
        return false;
      return isImageFile(file);
    }
  },
  createThumbnailUrl: Function,
  abstract: Boolean,
  max: Number,
  showTrigger: {
    type: Boolean,
    default: true
  },
  imageGroupProps: Object,
  inputProps: Object,
  triggerStyle: [String, Object],
  renderIcon: Object
});
var NUpload = defineComponent({
  name: "Upload",
  props: uploadProps,
  setup(props) {
    if (props.abstract && props.listType === "image-card") {
      throwError("upload", "when the list-type is image-card, abstract is not supported.");
    }
    const { mergedClsPrefixRef, inlineThemeDisabled } = useConfig(props);
    const themeRef = useTheme("Upload", "-upload", style, uploadLight$1, props, mergedClsPrefixRef);
    const formItem = useFormItem(props);
    const maxReachedRef = computed(() => {
      const { max } = props;
      if (max !== void 0) {
        return mergedFileListRef.value.length >= max;
      }
      return false;
    });
    const uncontrolledFileListRef = ref(props.defaultFileList);
    const controlledFileListRef = toRef(props, "fileList");
    const inputElRef = ref(null);
    const draggerInsideRef = {
      value: false
    };
    const dragOverRef = ref(false);
    const xhrMap = new Map();
    const _mergedFileListRef = useMergedState(controlledFileListRef, uncontrolledFileListRef);
    const mergedFileListRef = computed(() => _mergedFileListRef.value.map(createSettledFileInfo));
    function openOpenFileDialog() {
      var _a2;
      (_a2 = inputElRef.value) === null || _a2 === void 0 ? void 0 : _a2.click();
    }
    function handleFileInputChange(e25) {
      const target = e25.target;
      handleFileAddition(target.files ? Array.from(target.files).map((file) => ({
        file,
        entry: null,
        source: "input"
      })) : null, e25);
      target.value = "";
    }
    function doUpdateFileList(files) {
      const { "onUpdate:fileList": _onUpdateFileList, onUpdateFileList } = props;
      if (_onUpdateFileList)
        call(_onUpdateFileList, files);
      if (onUpdateFileList)
        call(onUpdateFileList, files);
      uncontrolledFileListRef.value = files;
    }
    const mergedMultipleRef = computed(() => props.multiple || props.directory);
    function handleFileAddition(fileAndEntries, e25) {
      if (!fileAndEntries || fileAndEntries.length === 0)
        return;
      const { onBeforeUpload } = props;
      fileAndEntries = mergedMultipleRef.value ? fileAndEntries : [fileAndEntries[0]];
      const { max, accept } = props;
      fileAndEntries = fileAndEntries.filter(({ file, source }) => {
        if (source === "dnd" && (accept === null || accept === void 0 ? void 0 : accept.trim())) {
          return matchType(file.name, file.type, accept);
        } else {
          return true;
        }
      });
      if (max) {
        fileAndEntries = fileAndEntries.slice(0, max - mergedFileListRef.value.length);
      }
      const batchId = createId();
      void Promise.all(fileAndEntries.map(({ file, entry }) => __awaiter(this, void 0, void 0, function* () {
        var _a2;
        const fileInfo = {
          id: createId(),
          batchId,
          name: file.name,
          status: "pending",
          percentage: 0,
          file,
          url: null,
          type: file.type,
          thumbnailUrl: null,
          fullPath: (_a2 = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a2 !== void 0 ? _a2 : `/${file.webkitRelativePath || file.name}`
        };
        if (!onBeforeUpload || (yield onBeforeUpload({
          file: fileInfo,
          fileList: mergedFileListRef.value
        })) !== false) {
          return fileInfo;
        }
        return null;
      }))).then((fileInfos) => __awaiter(this, void 0, void 0, function* () {
        let nextTickChain = Promise.resolve();
        fileInfos.forEach((fileInfo) => {
          nextTickChain = nextTickChain.then(nextTick).then(() => {
            fileInfo && doChange(fileInfo, e25, {
              append: true
            });
          });
        });
        yield nextTickChain;
      })).then(() => {
        if (props.defaultUpload) {
          submit();
        }
      });
    }
    function submit(fileId) {
      const { method: method4, action, withCredentials, headers, data, name: fieldName } = props;
      const filesToUpload = fileId !== void 0 ? mergedFileListRef.value.filter((file) => file.id === fileId) : mergedFileListRef.value;
      const shouldReupload = fileId !== void 0;
      filesToUpload.forEach((file) => {
        const { status } = file;
        if (status === "pending" || status === "error" && shouldReupload) {
          if (props.customRequest) {
            customSubmitImpl({
              inst: {
                doChange,
                xhrMap,
                onFinish: props.onFinish,
                onError: props.onError
              },
              file,
              action,
              withCredentials,
              headers,
              data,
              customRequest: props.customRequest
            });
          } else {
            submitImpl({
              doChange,
              xhrMap,
              onFinish: props.onFinish,
              onError: props.onError,
              isErrorState: props.isErrorState
            }, fieldName, file, {
              method: method4,
              action,
              withCredentials,
              responseType: props.responseType,
              headers,
              data
            });
          }
        }
      });
    }
    const doChange = (fileAfterChange, event, options = {
      append: false,
      remove: false
    }) => {
      const { append, remove: remove2 } = options;
      const fileListAfterChange = Array.from(mergedFileListRef.value);
      const fileIndex = fileListAfterChange.findIndex((file) => file.id === fileAfterChange.id);
      if (append || remove2 || ~fileIndex) {
        if (append) {
          fileListAfterChange.push(fileAfterChange);
        } else if (remove2) {
          fileListAfterChange.splice(fileIndex, 1);
        } else {
          fileListAfterChange.splice(fileIndex, 1, fileAfterChange);
        }
        const { onChange } = props;
        if (onChange) {
          onChange({
            file: fileAfterChange,
            fileList: fileListAfterChange,
            event
          });
        }
        doUpdateFileList(fileListAfterChange);
      }
    };
    function getFileThumbnailUrlResolver(file) {
      var _a2;
      if (file.thumbnailUrl)
        return file.thumbnailUrl;
      const { createThumbnailUrl } = props;
      if (createThumbnailUrl) {
        return (_a2 = createThumbnailUrl(file.file, file)) !== null && _a2 !== void 0 ? _a2 : file.url || "";
      }
      if (file.url) {
        return file.url;
      } else if (file.file) {
        return createImageDataUrl(file.file);
      }
      return "";
    }
    const cssVarsRef = computed(() => {
      const { common: { cubicBezierEaseInOut: cubicBezierEaseInOut2 }, self: { draggerColor, draggerBorder, draggerBorderHover, itemColorHover, itemColorHoverError, itemTextColorError, itemTextColorSuccess, itemTextColor, itemIconColor, itemDisabledOpacity, lineHeight: lineHeight2, borderRadius, fontSize: fontSize2, itemBorderImageCardError, itemBorderImageCard } } = themeRef.value;
      return {
        "--n-bezier": cubicBezierEaseInOut2,
        "--n-border-radius": borderRadius,
        "--n-dragger-border": draggerBorder,
        "--n-dragger-border-hover": draggerBorderHover,
        "--n-dragger-color": draggerColor,
        "--n-font-size": fontSize2,
        "--n-item-color-hover": itemColorHover,
        "--n-item-color-hover-error": itemColorHoverError,
        "--n-item-disabled-opacity": itemDisabledOpacity,
        "--n-item-icon-color": itemIconColor,
        "--n-item-text-color": itemTextColor,
        "--n-item-text-color-error": itemTextColorError,
        "--n-item-text-color-success": itemTextColorSuccess,
        "--n-line-height": lineHeight2,
        "--n-item-border-image-card-error": itemBorderImageCardError,
        "--n-item-border-image-card": itemBorderImageCard
      };
    });
    const themeClassHandle = inlineThemeDisabled ? useThemeClass("upload", void 0, cssVarsRef, props) : void 0;
    provide(uploadInjectionKey, {
      mergedClsPrefixRef,
      mergedThemeRef: themeRef,
      showCancelButtonRef: toRef(props, "showCancelButton"),
      showDownloadButtonRef: toRef(props, "showDownloadButton"),
      showRemoveButtonRef: toRef(props, "showRemoveButton"),
      showRetryButtonRef: toRef(props, "showRetryButton"),
      onRemoveRef: toRef(props, "onRemove"),
      onDownloadRef: toRef(props, "onDownload"),
      mergedFileListRef,
      triggerStyleRef: toRef(props, "triggerStyle"),
      shouldUseThumbnailUrlRef: toRef(props, "shouldUseThumbnailUrl"),
      renderIconRef: toRef(props, "renderIcon"),
      xhrMap,
      submit,
      doChange,
      showPreviewButtonRef: toRef(props, "showPreviewButton"),
      onPreviewRef: toRef(props, "onPreview"),
      getFileThumbnailUrlResolver,
      listTypeRef: toRef(props, "listType"),
      dragOverRef,
      openOpenFileDialog,
      draggerInsideRef,
      handleFileAddition,
      mergedDisabledRef: formItem.mergedDisabledRef,
      maxReachedRef,
      fileListStyleRef: toRef(props, "fileListStyle"),
      abstractRef: toRef(props, "abstract"),
      acceptRef: toRef(props, "accept"),
      cssVarsRef: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClassRef: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender,
      showTriggerRef: toRef(props, "showTrigger"),
      imageGroupPropsRef: toRef(props, "imageGroupProps"),
      mergedDirectoryDndRef: computed(() => {
        var _a2;
        return (_a2 = props.directoryDnd) !== null && _a2 !== void 0 ? _a2 : props.directory;
      })
    });
    const exposedMethods = {
      clear: () => {
        uncontrolledFileListRef.value = [];
      },
      submit,
      openOpenFileDialog
    };
    return Object.assign({
      mergedClsPrefix: mergedClsPrefixRef,
      draggerInsideRef,
      inputElRef,
      mergedTheme: themeRef,
      dragOver: dragOverRef,
      mergedMultiple: mergedMultipleRef,
      cssVars: inlineThemeDisabled ? void 0 : cssVarsRef,
      themeClass: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.themeClass,
      onRender: themeClassHandle === null || themeClassHandle === void 0 ? void 0 : themeClassHandle.onRender,
      handleFileInputChange
    }, exposedMethods);
  },
  render() {
    var _a2, _b2;
    const { draggerInsideRef, mergedClsPrefix, $slots, directory, onRender } = this;
    if ($slots.default && !this.abstract) {
      const firstChild = $slots.default()[0];
      if ((_a2 = firstChild === null || firstChild === void 0 ? void 0 : firstChild.type) === null || _a2 === void 0 ? void 0 : _a2[uploadDraggerKey]) {
        draggerInsideRef.value = true;
      }
    }
    const inputNode = h$1("input", Object.assign({}, this.inputProps, {
      ref: "inputElRef",
      type: "file",
      class: `${mergedClsPrefix}-upload-file-input`,
      accept: this.accept,
      multiple: this.mergedMultiple,
      onChange: this.handleFileInputChange,
      webkitdirectory: directory || void 0,
      directory: directory || void 0
    }));
    if (this.abstract) {
      return h$1(Fragment, null, (_b2 = $slots.default) === null || _b2 === void 0 ? void 0 : _b2.call($slots), h$1(Teleport, { to: "body" }, inputNode));
    }
    onRender === null || onRender === void 0 ? void 0 : onRender();
    return h$1("div", { class: [
      `${mergedClsPrefix}-upload`,
      draggerInsideRef.value && `${mergedClsPrefix}-upload--dragger-inside`,
      this.dragOver && `${mergedClsPrefix}-upload--drag-over`,
      this.themeClass
    ], style: this.cssVars }, inputNode, this.showTrigger && this.listType !== "image-card" && h$1(NUploadTrigger, null, $slots), this.showFileList && h$1(NUploadFileList, null, $slots));
  }
});
function moveElInArrayByIndex({
  array: array4,
  oldIndex,
  newIndex
}) {
  const newArray = [...array4];
  if (newIndex >= newArray.length) {
    let k2 = newIndex - newArray.length + 1;
    while (k2--) {
      newArray.push(void 0);
    }
  }
  newArray.splice(newIndex, 0, newArray.splice(oldIndex, 1)[0]);
  return newArray;
}
const __default__$18 = defineComponent({
  name: "UIButton"
});
const _sfc_main$1l = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$18), {
  props: {
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "default"
    },
    size: {
      type: String,
      default: "medium"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    ghost: {
      type: Boolean,
      default: false
    },
    quaternary: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: void 0
    }
  },
  emits: ["click"],
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NButton), mergeProps({
        id: __props.id,
        text: __props.text,
        class: [
          __props.quaternary ? "quaternary" : null,
          __props.circle || __props.text ? "icon-only" : null,
          __props.active ? "hl-active-btn" : null,
          __props.text ? "hl-text-btn" : null
        ],
        type: __props.type,
        size: __props.size
      }, _ctx.$attrs, {
        disabled: __props.disabled,
        loading: __props.loading,
        onClick: _cache[0] || (_cache[0] = (e25) => _ctx.$emit("click", e25)),
        quaternary: __props.quaternary,
        circle: __props.circle
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default"),
          unref(slots).icon ? renderSlot(_ctx.$slots, "icon", { key: 0 }) : createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["id", "text", "class", "type", "size", "disabled", "loading", "quaternary", "circle"]);
    };
  }
}));
_sfc_main$1l.install = (Vue) => {
  Vue.component(_sfc_main$1l.name, _sfc_main$1l);
};
const __default__$17 = defineComponent({
  name: "UIButtonGroup",
  inheritAttrs: false
});
const _sfc_main$1k = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$17), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NButtonGroup), normalizeProps(guardReactiveProps(_ctx.$attrs)), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16);
    };
  }
}));
_sfc_main$1k.install = (Vue) => {
  Vue.component(_sfc_main$1k.name, _sfc_main$1k);
};
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(module2, exports2) {
  (function() {
    var undefined$1;
    var VERSION = "4.17.21";
    var LARGE_ARRAY_SIZE2 = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT2 = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE2 = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG2 = 1, COMPARE_UNORDERED_FLAG2 = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT2 = 800, HOT_SPAN2 = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY2 = 1 / 0, MAX_SAFE_INTEGER2 = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN2 = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag2 = "[object Arguments]", arrayTag2 = "[object Array]", asyncTag2 = "[object AsyncFunction]", boolTag2 = "[object Boolean]", dateTag2 = "[object Date]", domExcTag = "[object DOMException]", errorTag2 = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag2 = "[object Map]", numberTag2 = "[object Number]", nullTag2 = "[object Null]", objectTag2 = "[object Object]", promiseTag2 = "[object Promise]", proxyTag2 = "[object Proxy]", regexpTag2 = "[object RegExp]", setTag2 = "[object Set]", stringTag2 = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag2 = "[object Undefined]", weakMapTag2 = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag2 = "[object ArrayBuffer]", dataViewTag2 = "[object DataView]", float32Tag2 = "[object Float32Array]", float64Tag2 = "[object Float64Array]", int8Tag2 = "[object Int8Array]", int16Tag2 = "[object Int16Array]", int32Tag2 = "[object Int32Array]", uint8Tag2 = "[object Uint8Array]", uint8ClampedTag2 = "[object Uint8ClampedArray]", uint16Tag2 = "[object Uint16Array]", uint32Tag2 = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp2 = /^\w*$/, rePropName2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar2.source);
    var reTrimStart2 = /^\s+/;
    var reWhitespace2 = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord2 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar2 = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex2 = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary2 = /^0b[01]+$/i;
    var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
    var reIsOctal2 = /^0o[0-7]+$/i;
    var reIsUint2 = /^(?:0|[1-9]\d*)$/;
    var reLatin2 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange2 = "\\ud800-\\udfff", rsComboMarksRange2 = "\\u0300-\\u036f", reComboHalfMarksRange2 = "\\ufe20-\\ufe2f", rsComboSymbolsRange2 = "\\u20d0-\\u20ff", rsComboRange2 = rsComboMarksRange2 + reComboHalfMarksRange2 + rsComboSymbolsRange2, rsDingbatRange2 = "\\u2700-\\u27bf", rsLowerRange2 = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange2 = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange2 = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange2 = "\\u2000-\\u206f", rsSpaceRange2 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange2 = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange2 = "\\ufe0e\\ufe0f", rsBreakRange2 = rsMathOpRange2 + rsNonCharRange2 + rsPunctuationRange2 + rsSpaceRange2;
    var rsApos2 = "['\u2019]", rsAstral2 = "[" + rsAstralRange2 + "]", rsBreak2 = "[" + rsBreakRange2 + "]", rsCombo2 = "[" + rsComboRange2 + "]", rsDigits2 = "\\d+", rsDingbat2 = "[" + rsDingbatRange2 + "]", rsLower2 = "[" + rsLowerRange2 + "]", rsMisc2 = "[^" + rsAstralRange2 + rsBreakRange2 + rsDigits2 + rsDingbatRange2 + rsLowerRange2 + rsUpperRange2 + "]", rsFitz2 = "\\ud83c[\\udffb-\\udfff]", rsModifier2 = "(?:" + rsCombo2 + "|" + rsFitz2 + ")", rsNonAstral2 = "[^" + rsAstralRange2 + "]", rsRegional2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper2 = "[" + rsUpperRange2 + "]", rsZWJ2 = "\\u200d";
    var rsMiscLower2 = "(?:" + rsLower2 + "|" + rsMisc2 + ")", rsMiscUpper2 = "(?:" + rsUpper2 + "|" + rsMisc2 + ")", rsOptContrLower2 = "(?:" + rsApos2 + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper2 = "(?:" + rsApos2 + "(?:D|LL|M|RE|S|T|VE))?", reOptMod2 = rsModifier2 + "?", rsOptVar2 = "[" + rsVarRange2 + "]?", rsOptJoin2 = "(?:" + rsZWJ2 + "(?:" + [rsNonAstral2, rsRegional2, rsSurrPair2].join("|") + ")" + rsOptVar2 + reOptMod2 + ")*", rsOrdLower2 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper2 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq2 = rsOptVar2 + reOptMod2 + rsOptJoin2, rsEmoji2 = "(?:" + [rsDingbat2, rsRegional2, rsSurrPair2].join("|") + ")" + rsSeq2, rsSymbol2 = "(?:" + [rsNonAstral2 + rsCombo2 + "?", rsCombo2, rsRegional2, rsSurrPair2, rsAstral2].join("|") + ")";
    var reApos2 = RegExp(rsApos2, "g");
    var reComboMark2 = RegExp(rsCombo2, "g");
    var reUnicode2 = RegExp(rsFitz2 + "(?=" + rsFitz2 + ")|" + rsSymbol2 + rsSeq2, "g");
    var reUnicodeWord2 = RegExp([
      rsUpper2 + "?" + rsLower2 + "+" + rsOptContrLower2 + "(?=" + [rsBreak2, rsUpper2, "$"].join("|") + ")",
      rsMiscUpper2 + "+" + rsOptContrUpper2 + "(?=" + [rsBreak2, rsUpper2 + rsMiscLower2, "$"].join("|") + ")",
      rsUpper2 + "?" + rsMiscLower2 + "+" + rsOptContrLower2,
      rsUpper2 + "+" + rsOptContrUpper2,
      rsOrdUpper2,
      rsOrdLower2,
      rsDigits2,
      rsEmoji2
    ].join("|"), "g");
    var reHasUnicode2 = RegExp("[" + rsZWJ2 + rsAstralRange2 + rsComboRange2 + rsVarRange2 + "]");
    var reHasUnicodeWord2 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags2 = {};
    typedArrayTags2[float32Tag2] = typedArrayTags2[float64Tag2] = typedArrayTags2[int8Tag2] = typedArrayTags2[int16Tag2] = typedArrayTags2[int32Tag2] = typedArrayTags2[uint8Tag2] = typedArrayTags2[uint8ClampedTag2] = typedArrayTags2[uint16Tag2] = typedArrayTags2[uint32Tag2] = true;
    typedArrayTags2[argsTag2] = typedArrayTags2[arrayTag2] = typedArrayTags2[arrayBufferTag2] = typedArrayTags2[boolTag2] = typedArrayTags2[dataViewTag2] = typedArrayTags2[dateTag2] = typedArrayTags2[errorTag2] = typedArrayTags2[funcTag2] = typedArrayTags2[mapTag2] = typedArrayTags2[numberTag2] = typedArrayTags2[objectTag2] = typedArrayTags2[regexpTag2] = typedArrayTags2[setTag2] = typedArrayTags2[stringTag2] = typedArrayTags2[weakMapTag2] = false;
    var cloneableTags = {};
    cloneableTags[argsTag2] = cloneableTags[arrayTag2] = cloneableTags[arrayBufferTag2] = cloneableTags[dataViewTag2] = cloneableTags[boolTag2] = cloneableTags[dateTag2] = cloneableTags[float32Tag2] = cloneableTags[float64Tag2] = cloneableTags[int8Tag2] = cloneableTags[int16Tag2] = cloneableTags[int32Tag2] = cloneableTags[mapTag2] = cloneableTags[numberTag2] = cloneableTags[objectTag2] = cloneableTags[regexpTag2] = cloneableTags[setTag2] = cloneableTags[stringTag2] = cloneableTags[symbolTag2] = cloneableTags[uint8Tag2] = cloneableTags[uint8ClampedTag2] = cloneableTags[uint16Tag2] = cloneableTags[uint32Tag2] = true;
    cloneableTags[errorTag2] = cloneableTags[funcTag2] = cloneableTags[weakMapTag2] = false;
    var deburredLetters2 = {
      "\xC0": "A",
      "\xC1": "A",
      "\xC2": "A",
      "\xC3": "A",
      "\xC4": "A",
      "\xC5": "A",
      "\xE0": "a",
      "\xE1": "a",
      "\xE2": "a",
      "\xE3": "a",
      "\xE4": "a",
      "\xE5": "a",
      "\xC7": "C",
      "\xE7": "c",
      "\xD0": "D",
      "\xF0": "d",
      "\xC8": "E",
      "\xC9": "E",
      "\xCA": "E",
      "\xCB": "E",
      "\xE8": "e",
      "\xE9": "e",
      "\xEA": "e",
      "\xEB": "e",
      "\xCC": "I",
      "\xCD": "I",
      "\xCE": "I",
      "\xCF": "I",
      "\xEC": "i",
      "\xED": "i",
      "\xEE": "i",
      "\xEF": "i",
      "\xD1": "N",
      "\xF1": "n",
      "\xD2": "O",
      "\xD3": "O",
      "\xD4": "O",
      "\xD5": "O",
      "\xD6": "O",
      "\xD8": "O",
      "\xF2": "o",
      "\xF3": "o",
      "\xF4": "o",
      "\xF5": "o",
      "\xF6": "o",
      "\xF8": "o",
      "\xD9": "U",
      "\xDA": "U",
      "\xDB": "U",
      "\xDC": "U",
      "\xF9": "u",
      "\xFA": "u",
      "\xFB": "u",
      "\xFC": "u",
      "\xDD": "Y",
      "\xFD": "y",
      "\xFF": "y",
      "\xC6": "Ae",
      "\xE6": "ae",
      "\xDE": "Th",
      "\xFE": "th",
      "\xDF": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010A": "C",
      "\u010C": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010B": "c",
      "\u010D": "c",
      "\u010E": "D",
      "\u0110": "D",
      "\u010F": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011A": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011B": "e",
      "\u011C": "G",
      "\u011E": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011D": "g",
      "\u011F": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012A": "I",
      "\u012C": "I",
      "\u012E": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012B": "i",
      "\u012D": "i",
      "\u012F": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013B": "L",
      "\u013D": "L",
      "\u013F": "L",
      "\u0141": "L",
      "\u013A": "l",
      "\u013C": "l",
      "\u013E": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014A": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014B": "n",
      "\u014C": "O",
      "\u014E": "O",
      "\u0150": "O",
      "\u014D": "o",
      "\u014F": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015A": "S",
      "\u015C": "S",
      "\u015E": "S",
      "\u0160": "S",
      "\u015B": "s",
      "\u015D": "s",
      "\u015F": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016A": "U",
      "\u016C": "U",
      "\u016E": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016B": "u",
      "\u016D": "u",
      "\u016F": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017B": "Z",
      "\u017D": "Z",
      "\u017A": "z",
      "\u017C": "z",
      "\u017E": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017F": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt2 = parseInt;
    var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
    var freeExports2 = exports2 && !exports2.nodeType && exports2;
    var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
    var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
    var freeProcess2 = moduleExports2 && freeGlobal2.process;
    var nodeUtil2 = function() {
      try {
        var types2 = freeModule2 && freeModule2.require && freeModule2.require("util").types;
        if (types2) {
          return types2;
        }
        return freeProcess2 && freeProcess2.binding && freeProcess2.binding("util");
      } catch (e25) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil2 && nodeUtil2.isArrayBuffer, nodeIsDate = nodeUtil2 && nodeUtil2.isDate, nodeIsMap = nodeUtil2 && nodeUtil2.isMap, nodeIsRegExp = nodeUtil2 && nodeUtil2.isRegExp, nodeIsSet = nodeUtil2 && nodeUtil2.isSet, nodeIsTypedArray2 = nodeUtil2 && nodeUtil2.isTypedArray;
    function apply2(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array4, setter, iteratee, accumulator) {
      var index2 = -1, length2 = array4 == null ? 0 : array4.length;
      while (++index2 < length2) {
        var value2 = array4[index2];
        setter(accumulator, value2, iteratee(value2), array4);
      }
      return accumulator;
    }
    function arrayEach(array4, iteratee) {
      var index2 = -1, length2 = array4 == null ? 0 : array4.length;
      while (++index2 < length2) {
        if (iteratee(array4[index2], index2, array4) === false) {
          break;
        }
      }
      return array4;
    }
    function arrayEachRight(array4, iteratee) {
      var length2 = array4 == null ? 0 : array4.length;
      while (length2--) {
        if (iteratee(array4[length2], length2, array4) === false) {
          break;
        }
      }
      return array4;
    }
    function arrayEvery(array4, predicate) {
      var index2 = -1, length2 = array4 == null ? 0 : array4.length;
      while (++index2 < length2) {
        if (!predicate(array4[index2], index2, array4)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter2(array4, predicate) {
      var index2 = -1, length2 = array4 == null ? 0 : array4.length, resIndex = 0, result2 = [];
      while (++index2 < length2) {
        var value2 = array4[index2];
        if (predicate(value2, index2, array4)) {
          result2[resIndex++] = value2;
        }
      }
      return result2;
    }
    function arrayIncludes(array4, value2) {
      var length2 = array4 == null ? 0 : array4.length;
      return !!length2 && baseIndexOf(array4, value2, 0) > -1;
    }
    function arrayIncludesWith(array4, value2, comparator) {
      var index2 = -1, length2 = array4 == null ? 0 : array4.length;
      while (++index2 < length2) {
        if (comparator(value2, array4[index2])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap2(array4, iteratee) {
      var index2 = -1, length2 = array4 == null ? 0 : array4.length, result2 = Array(length2);
      while (++index2 < length2) {
        result2[index2] = iteratee(array4[index2], index2, array4);
      }
      return result2;
    }
    function arrayPush2(array4, values2) {
      var index2 = -1, length2 = values2.length, offset = array4.length;
      while (++index2 < length2) {
        array4[offset + index2] = values2[index2];
      }
      return array4;
    }
    function arrayReduce2(array4, iteratee, accumulator, initAccum) {
      var index2 = -1, length2 = array4 == null ? 0 : array4.length;
      if (initAccum && length2) {
        accumulator = array4[++index2];
      }
      while (++index2 < length2) {
        accumulator = iteratee(accumulator, array4[index2], index2, array4);
      }
      return accumulator;
    }
    function arrayReduceRight(array4, iteratee, accumulator, initAccum) {
      var length2 = array4 == null ? 0 : array4.length;
      if (initAccum && length2) {
        accumulator = array4[--length2];
      }
      while (length2--) {
        accumulator = iteratee(accumulator, array4[length2], length2, array4);
      }
      return accumulator;
    }
    function arraySome2(array4, predicate) {
      var index2 = -1, length2 = array4 == null ? 0 : array4.length;
      while (++index2 < length2) {
        if (predicate(array4[index2], index2, array4)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty2("length");
    function asciiToArray2(string3) {
      return string3.split("");
    }
    function asciiWords2(string3) {
      return string3.match(reAsciiWord2) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result2;
      eachFunc(collection, function(value2, key, collection2) {
        if (predicate(value2, key, collection2)) {
          result2 = key;
          return false;
        }
      });
      return result2;
    }
    function baseFindIndex(array4, predicate, fromIndex, fromRight) {
      var length2 = array4.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length2) {
        if (predicate(array4[index2], index2, array4)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIndexOf(array4, value2, fromIndex) {
      return value2 === value2 ? strictIndexOf(array4, value2, fromIndex) : baseFindIndex(array4, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array4, value2, fromIndex, comparator) {
      var index2 = fromIndex - 1, length2 = array4.length;
      while (++index2 < length2) {
        if (comparator(array4[index2], value2)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIsNaN(value2) {
      return value2 !== value2;
    }
    function baseMean(array4, iteratee) {
      var length2 = array4 == null ? 0 : array4.length;
      return length2 ? baseSum(array4, iteratee) / length2 : NAN2;
    }
    function baseProperty2(key) {
      return function(object4) {
        return object4 == null ? undefined$1 : object4[key];
      };
    }
    function basePropertyOf2(object4) {
      return function(key) {
        return object4 == null ? undefined$1 : object4[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value2, index2, collection2) {
        accumulator = initAccum ? (initAccum = false, value2) : iteratee(accumulator, value2, index2, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array4, comparer) {
      var length2 = array4.length;
      array4.sort(comparer);
      while (length2--) {
        array4[length2] = array4[length2].value;
      }
      return array4;
    }
    function baseSum(array4, iteratee) {
      var result2, index2 = -1, length2 = array4.length;
      while (++index2 < length2) {
        var current = iteratee(array4[index2]);
        if (current !== undefined$1) {
          result2 = result2 === undefined$1 ? current : result2 + current;
        }
      }
      return result2;
    }
    function baseTimes2(n2, iteratee) {
      var index2 = -1, result2 = Array(n2);
      while (++index2 < n2) {
        result2[index2] = iteratee(index2);
      }
      return result2;
    }
    function baseToPairs(object4, props) {
      return arrayMap2(props, function(key) {
        return [key, object4[key]];
      });
    }
    function baseTrim2(string3) {
      return string3 ? string3.slice(0, trimmedEndIndex2(string3) + 1).replace(reTrimStart2, "") : string3;
    }
    function baseUnary2(func) {
      return function(value2) {
        return func(value2);
      };
    }
    function baseValues(object4, props) {
      return arrayMap2(props, function(key) {
        return object4[key];
      });
    }
    function cacheHas2(cache2, key) {
      return cache2.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index2 = -1, length2 = strSymbols.length;
      while (++index2 < length2 && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index2 = strSymbols.length;
      while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function countHolders(array4, placeholder) {
      var length2 = array4.length, result2 = 0;
      while (length2--) {
        if (array4[length2] === placeholder) {
          ++result2;
        }
      }
      return result2;
    }
    var deburrLetter2 = basePropertyOf2(deburredLetters2);
    var escapeHtmlChar = basePropertyOf2(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue2(object4, key) {
      return object4 == null ? undefined$1 : object4[key];
    }
    function hasUnicode2(string3) {
      return reHasUnicode2.test(string3);
    }
    function hasUnicodeWord2(string3) {
      return reHasUnicodeWord2.test(string3);
    }
    function iteratorToArray(iterator) {
      var data, result2 = [];
      while (!(data = iterator.next()).done) {
        result2.push(data.value);
      }
      return result2;
    }
    function mapToArray2(map2) {
      var index2 = -1, result2 = Array(map2.size);
      map2.forEach(function(value2, key) {
        result2[++index2] = [key, value2];
      });
      return result2;
    }
    function overArg2(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array4, placeholder) {
      var index2 = -1, length2 = array4.length, resIndex = 0, result2 = [];
      while (++index2 < length2) {
        var value2 = array4[index2];
        if (value2 === placeholder || value2 === PLACEHOLDER) {
          array4[index2] = PLACEHOLDER;
          result2[resIndex++] = index2;
        }
      }
      return result2;
    }
    function setToArray2(set2) {
      var index2 = -1, result2 = Array(set2.size);
      set2.forEach(function(value2) {
        result2[++index2] = value2;
      });
      return result2;
    }
    function setToPairs(set2) {
      var index2 = -1, result2 = Array(set2.size);
      set2.forEach(function(value2) {
        result2[++index2] = [value2, value2];
      });
      return result2;
    }
    function strictIndexOf(array4, value2, fromIndex) {
      var index2 = fromIndex - 1, length2 = array4.length;
      while (++index2 < length2) {
        if (array4[index2] === value2) {
          return index2;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array4, value2, fromIndex) {
      var index2 = fromIndex + 1;
      while (index2--) {
        if (array4[index2] === value2) {
          return index2;
        }
      }
      return index2;
    }
    function stringSize(string3) {
      return hasUnicode2(string3) ? unicodeSize(string3) : asciiSize(string3);
    }
    function stringToArray2(string3) {
      return hasUnicode2(string3) ? unicodeToArray2(string3) : asciiToArray2(string3);
    }
    function trimmedEndIndex2(string3) {
      var index2 = string3.length;
      while (index2-- && reWhitespace2.test(string3.charAt(index2))) {
      }
      return index2;
    }
    var unescapeHtmlChar = basePropertyOf2(htmlUnescapes);
    function unicodeSize(string3) {
      var result2 = reUnicode2.lastIndex = 0;
      while (reUnicode2.test(string3)) {
        ++result2;
      }
      return result2;
    }
    function unicodeToArray2(string3) {
      return string3.match(reUnicode2) || [];
    }
    function unicodeWords2(string3) {
      return string3.match(reUnicodeWord2) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root2 : _2.defaults(root2.Object(), context, _2.pick(root2, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto2 = Array2.prototype, funcProto2 = Function2.prototype, objectProto2 = Object2.prototype;
      var coreJsData2 = context["__core-js_shared__"];
      var funcToString2 = funcProto2.toString;
      var hasOwnProperty2 = objectProto2.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey2 = function() {
        var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString2 = objectProto2.toString;
      var objectCtorString2 = funcToString2.call(Object2);
      var oldDash = root2._;
      var reIsNative2 = RegExp2("^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      var Buffer2 = moduleExports2 ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe2 = Buffer2 ? Buffer2.allocUnsafe : undefined$1, getPrototype2 = overArg2(Object2.getPrototypeOf, Object2), objectCreate2 = Object2.create, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag2 = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty2 = function() {
        try {
          var func = getNative2(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e25) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root2.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root2.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root2.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols2 = Object2.getOwnPropertySymbols, nativeIsBuffer2 = Buffer2 ? Buffer2.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto2.join, nativeKeys2 = overArg2(Object2.keys, Object2), nativeMax2 = Math2.max, nativeMin2 = Math2.min, nativeNow2 = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto2.reverse;
      var DataView2 = getNative2(context, "DataView"), Map2 = getNative2(context, "Map"), Promise2 = getNative2(context, "Promise"), Set2 = getNative2(context, "Set"), WeakMap2 = getNative2(context, "WeakMap"), nativeCreate2 = getNative2(Object2, "create");
      var metaMap = WeakMap2 && new WeakMap2();
      var realNames = {};
      var dataViewCtorString2 = toSource2(DataView2), mapCtorString2 = toSource2(Map2), promiseCtorString2 = toSource2(Promise2), setCtorString2 = toSource2(Set2), weakMapCtorString2 = toSource2(WeakMap2);
      var symbolProto2 = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf2 = symbolProto2 ? symbolProto2.valueOf : undefined$1, symbolToString2 = symbolProto2 ? symbolProto2.toString : undefined$1;
      function lodash2(value2) {
        if (isObjectLike2(value2) && !isArray2(value2) && !(value2 instanceof LazyWrapper)) {
          if (value2 instanceof LodashWrapper) {
            return value2;
          }
          if (hasOwnProperty2.call(value2, "__wrapped__")) {
            return wrapperClone(value2);
          }
        }
        return new LodashWrapper(value2);
      }
      var baseCreate2 = function() {
        function object4() {
        }
        return function(proto) {
          if (!isObject3(proto)) {
            return {};
          }
          if (objectCreate2) {
            return objectCreate2(proto);
          }
          object4.prototype = proto;
          var result3 = new object4();
          object4.prototype = undefined$1;
          return result3;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value2, chainAll) {
        this.__wrapped__ = value2;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        "escape": reEscape,
        "evaluate": reEvaluate,
        "interpolate": reInterpolate,
        "variable": "",
        "imports": {
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate2(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value2) {
        this.__wrapped__ = value2;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result3 = new LazyWrapper(this.__wrapped__);
        result3.__actions__ = copyArray2(this.__actions__);
        result3.__dir__ = this.__dir__;
        result3.__filtered__ = this.__filtered__;
        result3.__iteratees__ = copyArray2(this.__iteratees__);
        result3.__takeCount__ = this.__takeCount__;
        result3.__views__ = copyArray2(this.__views__);
        return result3;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result3 = new LazyWrapper(this);
          result3.__dir__ = -1;
          result3.__filtered__ = true;
        } else {
          result3 = this.clone();
          result3.__dir__ *= -1;
        }
        return result3;
      }
      function lazyValue() {
        var array4 = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array4), isRight = dir < 0, arrLength = isArr ? array4.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length2 = end - start, index2 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin2(length2, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length2 && takeCount == length2) {
          return baseWrapperValue(array4, this.__actions__);
        }
        var result3 = [];
        outer:
          while (length2-- && resIndex < takeCount) {
            index2 += dir;
            var iterIndex = -1, value2 = array4[index2];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex], iteratee2 = data.iteratee, type4 = data.type, computed2 = iteratee2(value2);
              if (type4 == LAZY_MAP_FLAG) {
                value2 = computed2;
              } else if (!computed2) {
                if (type4 == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result3[resIndex++] = value2;
          }
        return result3;
      }
      LazyWrapper.prototype = baseCreate2(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash2(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear2() {
        this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
        this.size = 0;
      }
      function hashDelete2(key) {
        var result3 = this.has(key) && delete this.__data__[key];
        this.size -= result3 ? 1 : 0;
        return result3;
      }
      function hashGet2(key) {
        var data = this.__data__;
        if (nativeCreate2) {
          var result3 = data[key];
          return result3 === HASH_UNDEFINED2 ? undefined$1 : result3;
        }
        return hasOwnProperty2.call(data, key) ? data[key] : undefined$1;
      }
      function hashHas2(key) {
        var data = this.__data__;
        return nativeCreate2 ? data[key] !== undefined$1 : hasOwnProperty2.call(data, key);
      }
      function hashSet2(key, value2) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate2 && value2 === undefined$1 ? HASH_UNDEFINED2 : value2;
        return this;
      }
      Hash2.prototype.clear = hashClear2;
      Hash2.prototype["delete"] = hashDelete2;
      Hash2.prototype.get = hashGet2;
      Hash2.prototype.has = hashHas2;
      Hash2.prototype.set = hashSet2;
      function ListCache2(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear2() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete2(key) {
        var data = this.__data__, index2 = assocIndexOf2(data, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index2 == lastIndex) {
          data.pop();
        } else {
          splice2.call(data, index2, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet2(key) {
        var data = this.__data__, index2 = assocIndexOf2(data, key);
        return index2 < 0 ? undefined$1 : data[index2][1];
      }
      function listCacheHas2(key) {
        return assocIndexOf2(this.__data__, key) > -1;
      }
      function listCacheSet2(key, value2) {
        var data = this.__data__, index2 = assocIndexOf2(data, key);
        if (index2 < 0) {
          ++this.size;
          data.push([key, value2]);
        } else {
          data[index2][1] = value2;
        }
        return this;
      }
      ListCache2.prototype.clear = listCacheClear2;
      ListCache2.prototype["delete"] = listCacheDelete2;
      ListCache2.prototype.get = listCacheGet2;
      ListCache2.prototype.has = listCacheHas2;
      ListCache2.prototype.set = listCacheSet2;
      function MapCache2(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear2() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash2(),
          "map": new (Map2 || ListCache2)(),
          "string": new Hash2()
        };
      }
      function mapCacheDelete2(key) {
        var result3 = getMapData2(this, key)["delete"](key);
        this.size -= result3 ? 1 : 0;
        return result3;
      }
      function mapCacheGet2(key) {
        return getMapData2(this, key).get(key);
      }
      function mapCacheHas2(key) {
        return getMapData2(this, key).has(key);
      }
      function mapCacheSet2(key, value2) {
        var data = getMapData2(this, key), size3 = data.size;
        data.set(key, value2);
        this.size += data.size == size3 ? 0 : 1;
        return this;
      }
      MapCache2.prototype.clear = mapCacheClear2;
      MapCache2.prototype["delete"] = mapCacheDelete2;
      MapCache2.prototype.get = mapCacheGet2;
      MapCache2.prototype.has = mapCacheHas2;
      MapCache2.prototype.set = mapCacheSet2;
      function SetCache2(values3) {
        var index2 = -1, length2 = values3 == null ? 0 : values3.length;
        this.__data__ = new MapCache2();
        while (++index2 < length2) {
          this.add(values3[index2]);
        }
      }
      function setCacheAdd2(value2) {
        this.__data__.set(value2, HASH_UNDEFINED2);
        return this;
      }
      function setCacheHas2(value2) {
        return this.__data__.has(value2);
      }
      SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
      SetCache2.prototype.has = setCacheHas2;
      function Stack2(entries) {
        var data = this.__data__ = new ListCache2(entries);
        this.size = data.size;
      }
      function stackClear2() {
        this.__data__ = new ListCache2();
        this.size = 0;
      }
      function stackDelete2(key) {
        var data = this.__data__, result3 = data["delete"](key);
        this.size = data.size;
        return result3;
      }
      function stackGet2(key) {
        return this.__data__.get(key);
      }
      function stackHas2(key) {
        return this.__data__.has(key);
      }
      function stackSet2(key, value2) {
        var data = this.__data__;
        if (data instanceof ListCache2) {
          var pairs = data.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE2 - 1) {
            pairs.push([key, value2]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache2(pairs);
        }
        data.set(key, value2);
        this.size = data.size;
        return this;
      }
      Stack2.prototype.clear = stackClear2;
      Stack2.prototype["delete"] = stackDelete2;
      Stack2.prototype.get = stackGet2;
      Stack2.prototype.has = stackHas2;
      Stack2.prototype.set = stackSet2;
      function arrayLikeKeys2(value2, inherited) {
        var isArr = isArray2(value2), isArg = !isArr && isArguments2(value2), isBuff = !isArr && !isArg && isBuffer2(value2), isType2 = !isArr && !isArg && !isBuff && isTypedArray2(value2), skipIndexes = isArr || isArg || isBuff || isType2, result3 = skipIndexes ? baseTimes2(value2.length, String2) : [], length2 = result3.length;
        for (var key in value2) {
          if ((inherited || hasOwnProperty2.call(value2, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType2 && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex2(key, length2)))) {
            result3.push(key);
          }
        }
        return result3;
      }
      function arraySample(array4) {
        var length2 = array4.length;
        return length2 ? array4[baseRandom(0, length2 - 1)] : undefined$1;
      }
      function arraySampleSize(array4, n2) {
        return shuffleSelf(copyArray2(array4), baseClamp(n2, 0, array4.length));
      }
      function arrayShuffle(array4) {
        return shuffleSelf(copyArray2(array4));
      }
      function assignMergeValue2(object4, key, value2) {
        if (value2 !== undefined$1 && !eq2(object4[key], value2) || value2 === undefined$1 && !(key in object4)) {
          baseAssignValue2(object4, key, value2);
        }
      }
      function assignValue2(object4, key, value2) {
        var objValue = object4[key];
        if (!(hasOwnProperty2.call(object4, key) && eq2(objValue, value2)) || value2 === undefined$1 && !(key in object4)) {
          baseAssignValue2(object4, key, value2);
        }
      }
      function assocIndexOf2(array4, key) {
        var length2 = array4.length;
        while (length2--) {
          if (eq2(array4[length2][0], key)) {
            return length2;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach2(collection, function(value2, key, collection2) {
          setter(accumulator, value2, iteratee2(value2), collection2);
        });
        return accumulator;
      }
      function baseAssign(object4, source) {
        return object4 && copyObject2(source, keys2(source), object4);
      }
      function baseAssignIn(object4, source) {
        return object4 && copyObject2(source, keysIn2(source), object4);
      }
      function baseAssignValue2(object4, key, value2) {
        if (key == "__proto__" && defineProperty2) {
          defineProperty2(object4, key, {
            "configurable": true,
            "enumerable": true,
            "value": value2,
            "writable": true
          });
        } else {
          object4[key] = value2;
        }
      }
      function baseAt(object4, paths) {
        var index2 = -1, length2 = paths.length, result3 = Array2(length2), skip = object4 == null;
        while (++index2 < length2) {
          result3[index2] = skip ? undefined$1 : get2(object4, paths[index2]);
        }
        return result3;
      }
      function baseClamp(number4, lower, upper) {
        if (number4 === number4) {
          if (upper !== undefined$1) {
            number4 = number4 <= upper ? number4 : upper;
          }
          if (lower !== undefined$1) {
            number4 = number4 >= lower ? number4 : lower;
          }
        }
        return number4;
      }
      function baseClone(value2, bitmask, customizer, key, object4, stack2) {
        var result3, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result3 = object4 ? customizer(value2, key, object4, stack2) : customizer(value2);
        }
        if (result3 !== undefined$1) {
          return result3;
        }
        if (!isObject3(value2)) {
          return value2;
        }
        var isArr = isArray2(value2);
        if (isArr) {
          result3 = initCloneArray(value2);
          if (!isDeep) {
            return copyArray2(value2, result3);
          }
        } else {
          var tag = getTag2(value2), isFunc = tag == funcTag2 || tag == genTag2;
          if (isBuffer2(value2)) {
            return cloneBuffer2(value2, isDeep);
          }
          if (tag == objectTag2 || tag == argsTag2 || isFunc && !object4) {
            result3 = isFlat || isFunc ? {} : initCloneObject2(value2);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value2, baseAssignIn(result3, value2)) : copySymbols(value2, baseAssign(result3, value2));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object4 ? value2 : {};
            }
            result3 = initCloneByTag(value2, tag, isDeep);
          }
        }
        stack2 || (stack2 = new Stack2());
        var stacked = stack2.get(value2);
        if (stacked) {
          return stacked;
        }
        stack2.set(value2, result3);
        if (isSet(value2)) {
          value2.forEach(function(subValue) {
            result3.add(baseClone(subValue, bitmask, customizer, subValue, value2, stack2));
          });
        } else if (isMap(value2)) {
          value2.forEach(function(subValue, key2) {
            result3.set(key2, baseClone(subValue, bitmask, customizer, key2, value2, stack2));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys2 : isFlat ? keysIn2 : keys2;
        var props = isArr ? undefined$1 : keysFunc(value2);
        arrayEach(props || value2, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value2[key2];
          }
          assignValue2(result3, key2, baseClone(subValue, bitmask, customizer, key2, value2, stack2));
        });
        return result3;
      }
      function baseConforms(source) {
        var props = keys2(source);
        return function(object4) {
          return baseConformsTo(object4, source, props);
        };
      }
      function baseConformsTo(object4, source, props) {
        var length2 = props.length;
        if (object4 == null) {
          return !length2;
        }
        object4 = Object2(object4);
        while (length2--) {
          var key = props[length2], predicate = source[key], value2 = object4[key];
          if (value2 === undefined$1 && !(key in object4) || !predicate(value2)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array4, values3, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, isCommon = true, length2 = array4.length, result3 = [], valuesLength = values3.length;
        if (!length2) {
          return result3;
        }
        if (iteratee2) {
          values3 = arrayMap2(values3, baseUnary2(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values3.length >= LARGE_ARRAY_SIZE2) {
          includes2 = cacheHas2;
          isCommon = false;
          values3 = new SetCache2(values3);
        }
        outer:
          while (++index2 < length2) {
            var value2 = array4[index2], computed2 = iteratee2 == null ? value2 : iteratee2(value2);
            value2 = comparator || value2 !== 0 ? value2 : 0;
            if (isCommon && computed2 === computed2) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values3[valuesIndex] === computed2) {
                  continue outer;
                }
              }
              result3.push(value2);
            } else if (!includes2(values3, computed2, comparator)) {
              result3.push(value2);
            }
          }
        return result3;
      }
      var baseEach2 = createBaseEach2(baseForOwn2);
      var baseEachRight = createBaseEach2(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result3 = true;
        baseEach2(collection, function(value2, index2, collection2) {
          result3 = !!predicate(value2, index2, collection2);
          return result3;
        });
        return result3;
      }
      function baseExtremum(array4, iteratee2, comparator) {
        var index2 = -1, length2 = array4.length;
        while (++index2 < length2) {
          var value2 = array4[index2], current = iteratee2(value2);
          if (current != null && (computed2 === undefined$1 ? current === current && !isSymbol2(current) : comparator(current, computed2))) {
            var computed2 = current, result3 = value2;
          }
        }
        return result3;
      }
      function baseFill(array4, value2, start, end) {
        var length2 = array4.length;
        start = toInteger2(start);
        if (start < 0) {
          start = -start > length2 ? 0 : length2 + start;
        }
        end = end === undefined$1 || end > length2 ? length2 : toInteger2(end);
        if (end < 0) {
          end += length2;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array4[start++] = value2;
        }
        return array4;
      }
      function baseFilter(collection, predicate) {
        var result3 = [];
        baseEach2(collection, function(value2, index2, collection2) {
          if (predicate(value2, index2, collection2)) {
            result3.push(value2);
          }
        });
        return result3;
      }
      function baseFlatten(array4, depth, predicate, isStrict, result3) {
        var index2 = -1, length2 = array4.length;
        predicate || (predicate = isFlattenable);
        result3 || (result3 = []);
        while (++index2 < length2) {
          var value2 = array4[index2];
          if (depth > 0 && predicate(value2)) {
            if (depth > 1) {
              baseFlatten(value2, depth - 1, predicate, isStrict, result3);
            } else {
              arrayPush2(result3, value2);
            }
          } else if (!isStrict) {
            result3[result3.length] = value2;
          }
        }
        return result3;
      }
      var baseFor2 = createBaseFor2();
      var baseForRight = createBaseFor2(true);
      function baseForOwn2(object4, iteratee2) {
        return object4 && baseFor2(object4, iteratee2, keys2);
      }
      function baseForOwnRight(object4, iteratee2) {
        return object4 && baseForRight(object4, iteratee2, keys2);
      }
      function baseFunctions(object4, props) {
        return arrayFilter2(props, function(key) {
          return isFunction2(object4[key]);
        });
      }
      function baseGet2(object4, path) {
        path = castPath2(path, object4);
        var index2 = 0, length2 = path.length;
        while (object4 != null && index2 < length2) {
          object4 = object4[toKey2(path[index2++])];
        }
        return index2 && index2 == length2 ? object4 : undefined$1;
      }
      function baseGetAllKeys2(object4, keysFunc, symbolsFunc) {
        var result3 = keysFunc(object4);
        return isArray2(object4) ? result3 : arrayPush2(result3, symbolsFunc(object4));
      }
      function baseGetTag2(value2) {
        if (value2 == null) {
          return value2 === undefined$1 ? undefinedTag2 : nullTag2;
        }
        return symToStringTag2 && symToStringTag2 in Object2(value2) ? getRawTag2(value2) : objectToString2(value2);
      }
      function baseGt(value2, other) {
        return value2 > other;
      }
      function baseHas(object4, key) {
        return object4 != null && hasOwnProperty2.call(object4, key);
      }
      function baseHasIn2(object4, key) {
        return object4 != null && key in Object2(object4);
      }
      function baseInRange(number4, start, end) {
        return number4 >= nativeMin2(start, end) && number4 < nativeMax2(start, end);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length2 = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result3 = [];
        while (othIndex--) {
          var array4 = arrays[othIndex];
          if (othIndex && iteratee2) {
            array4 = arrayMap2(array4, baseUnary2(iteratee2));
          }
          maxLength = nativeMin2(array4.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length2 >= 120 && array4.length >= 120) ? new SetCache2(othIndex && array4) : undefined$1;
        }
        array4 = arrays[0];
        var index2 = -1, seen = caches[0];
        outer:
          while (++index2 < length2 && result3.length < maxLength) {
            var value2 = array4[index2], computed2 = iteratee2 ? iteratee2(value2) : value2;
            value2 = comparator || value2 !== 0 ? value2 : 0;
            if (!(seen ? cacheHas2(seen, computed2) : includes2(result3, computed2, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache2 = caches[othIndex];
                if (!(cache2 ? cacheHas2(cache2, computed2) : includes2(arrays[othIndex], computed2, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed2);
              }
              result3.push(value2);
            }
          }
        return result3;
      }
      function baseInverter(object4, setter, iteratee2, accumulator) {
        baseForOwn2(object4, function(value2, key, object5) {
          setter(accumulator, iteratee2(value2), key, object5);
        });
        return accumulator;
      }
      function baseInvoke(object4, path, args) {
        path = castPath2(path, object4);
        object4 = parent(object4, path);
        var func = object4 == null ? object4 : object4[toKey2(last(path))];
        return func == null ? undefined$1 : apply2(func, object4, args);
      }
      function baseIsArguments2(value2) {
        return isObjectLike2(value2) && baseGetTag2(value2) == argsTag2;
      }
      function baseIsArrayBuffer(value2) {
        return isObjectLike2(value2) && baseGetTag2(value2) == arrayBufferTag2;
      }
      function baseIsDate(value2) {
        return isObjectLike2(value2) && baseGetTag2(value2) == dateTag2;
      }
      function baseIsEqual2(value2, other, bitmask, customizer, stack2) {
        if (value2 === other) {
          return true;
        }
        if (value2 == null || other == null || !isObjectLike2(value2) && !isObjectLike2(other)) {
          return value2 !== value2 && other !== other;
        }
        return baseIsEqualDeep2(value2, other, bitmask, customizer, baseIsEqual2, stack2);
      }
      function baseIsEqualDeep2(object4, other, bitmask, customizer, equalFunc, stack2) {
        var objIsArr = isArray2(object4), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag2 : getTag2(object4), othTag = othIsArr ? arrayTag2 : getTag2(other);
        objTag = objTag == argsTag2 ? objectTag2 : objTag;
        othTag = othTag == argsTag2 ? objectTag2 : othTag;
        var objIsObj = objTag == objectTag2, othIsObj = othTag == objectTag2, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer2(object4)) {
          if (!isBuffer2(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack2 || (stack2 = new Stack2());
          return objIsArr || isTypedArray2(object4) ? equalArrays2(object4, other, bitmask, customizer, equalFunc, stack2) : equalByTag2(object4, other, objTag, bitmask, customizer, equalFunc, stack2);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG2)) {
          var objIsWrapped = objIsObj && hasOwnProperty2.call(object4, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object4.value() : object4, othUnwrapped = othIsWrapped ? other.value() : other;
            stack2 || (stack2 = new Stack2());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack2);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack2 || (stack2 = new Stack2());
        return equalObjects2(object4, other, bitmask, customizer, equalFunc, stack2);
      }
      function baseIsMap(value2) {
        return isObjectLike2(value2) && getTag2(value2) == mapTag2;
      }
      function baseIsMatch2(object4, source, matchData, customizer) {
        var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
        if (object4 == null) {
          return !length2;
        }
        object4 = Object2(object4);
        while (index2--) {
          var data = matchData[index2];
          if (noCustomizer && data[2] ? data[1] !== object4[data[0]] : !(data[0] in object4)) {
            return false;
          }
        }
        while (++index2 < length2) {
          data = matchData[index2];
          var key = data[0], objValue = object4[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object4)) {
              return false;
            }
          } else {
            var stack2 = new Stack2();
            if (customizer) {
              var result3 = customizer(objValue, srcValue, key, object4, source, stack2);
            }
            if (!(result3 === undefined$1 ? baseIsEqual2(srcValue, objValue, COMPARE_PARTIAL_FLAG2 | COMPARE_UNORDERED_FLAG2, customizer, stack2) : result3)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative2(value2) {
        if (!isObject3(value2) || isMasked2(value2)) {
          return false;
        }
        var pattern4 = isFunction2(value2) ? reIsNative2 : reIsHostCtor2;
        return pattern4.test(toSource2(value2));
      }
      function baseIsRegExp(value2) {
        return isObjectLike2(value2) && baseGetTag2(value2) == regexpTag2;
      }
      function baseIsSet(value2) {
        return isObjectLike2(value2) && getTag2(value2) == setTag2;
      }
      function baseIsTypedArray2(value2) {
        return isObjectLike2(value2) && isLength2(value2.length) && !!typedArrayTags2[baseGetTag2(value2)];
      }
      function baseIteratee2(value2) {
        if (typeof value2 == "function") {
          return value2;
        }
        if (value2 == null) {
          return identity2;
        }
        if (typeof value2 == "object") {
          return isArray2(value2) ? baseMatchesProperty2(value2[0], value2[1]) : baseMatches2(value2);
        }
        return property2(value2);
      }
      function baseKeys2(object4) {
        if (!isPrototype2(object4)) {
          return nativeKeys2(object4);
        }
        var result3 = [];
        for (var key in Object2(object4)) {
          if (hasOwnProperty2.call(object4, key) && key != "constructor") {
            result3.push(key);
          }
        }
        return result3;
      }
      function baseKeysIn2(object4) {
        if (!isObject3(object4)) {
          return nativeKeysIn2(object4);
        }
        var isProto = isPrototype2(object4), result3 = [];
        for (var key in object4) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object4, key)))) {
            result3.push(key);
          }
        }
        return result3;
      }
      function baseLt(value2, other) {
        return value2 < other;
      }
      function baseMap2(collection, iteratee2) {
        var index2 = -1, result3 = isArrayLike2(collection) ? Array2(collection.length) : [];
        baseEach2(collection, function(value2, key, collection2) {
          result3[++index2] = iteratee2(value2, key, collection2);
        });
        return result3;
      }
      function baseMatches2(source) {
        var matchData = getMatchData2(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable2(matchData[0][0], matchData[0][1]);
        }
        return function(object4) {
          return object4 === source || baseIsMatch2(object4, source, matchData);
        };
      }
      function baseMatchesProperty2(path, srcValue) {
        if (isKey2(path) && isStrictComparable2(srcValue)) {
          return matchesStrictComparable2(toKey2(path), srcValue);
        }
        return function(object4) {
          var objValue = get2(object4, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn2(object4, path) : baseIsEqual2(srcValue, objValue, COMPARE_PARTIAL_FLAG2 | COMPARE_UNORDERED_FLAG2);
        };
      }
      function baseMerge2(object4, source, srcIndex, customizer, stack2) {
        if (object4 === source) {
          return;
        }
        baseFor2(source, function(srcValue, key) {
          stack2 || (stack2 = new Stack2());
          if (isObject3(srcValue)) {
            baseMergeDeep2(object4, source, key, srcIndex, baseMerge2, customizer, stack2);
          } else {
            var newValue = customizer ? customizer(safeGet2(object4, key), srcValue, key + "", object4, source, stack2) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue2(object4, key, newValue);
          }
        }, keysIn2);
      }
      function baseMergeDeep2(object4, source, key, srcIndex, mergeFunc, customizer, stack2) {
        var objValue = safeGet2(object4, key), srcValue = safeGet2(source, key), stacked = stack2.get(srcValue);
        if (stacked) {
          assignMergeValue2(object4, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object4, source, stack2) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer2(srcValue), isTyped = !isArr && !isBuff && isTypedArray2(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray2(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject2(objValue)) {
              newValue = copyArray2(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer2(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray2(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject2(srcValue) || isArguments2(srcValue)) {
            newValue = objValue;
            if (isArguments2(objValue)) {
              newValue = toPlainObject2(objValue);
            } else if (!isObject3(objValue) || isFunction2(objValue)) {
              newValue = initCloneObject2(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack2.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack2);
          stack2["delete"](srcValue);
        }
        assignMergeValue2(object4, key, newValue);
      }
      function baseNth(array4, n2) {
        var length2 = array4.length;
        if (!length2) {
          return;
        }
        n2 += n2 < 0 ? length2 : 0;
        return isIndex2(n2, length2) ? array4[n2] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap2(iteratees, function(iteratee2) {
            if (isArray2(iteratee2)) {
              return function(value2) {
                return baseGet2(value2, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity2];
        }
        var index2 = -1;
        iteratees = arrayMap2(iteratees, baseUnary2(getIteratee()));
        var result3 = baseMap2(collection, function(value2, key, collection2) {
          var criteria = arrayMap2(iteratees, function(iteratee2) {
            return iteratee2(value2);
          });
          return { "criteria": criteria, "index": ++index2, "value": value2 };
        });
        return baseSortBy(result3, function(object4, other) {
          return compareMultiple(object4, other, orders);
        });
      }
      function basePick(object4, paths) {
        return basePickBy(object4, paths, function(value2, path) {
          return hasIn2(object4, path);
        });
      }
      function basePickBy(object4, paths, predicate) {
        var index2 = -1, length2 = paths.length, result3 = {};
        while (++index2 < length2) {
          var path = paths[index2], value2 = baseGet2(object4, path);
          if (predicate(value2, path)) {
            baseSet(result3, castPath2(path, object4), value2);
          }
        }
        return result3;
      }
      function basePropertyDeep2(path) {
        return function(object4) {
          return baseGet2(object4, path);
        };
      }
      function basePullAll(array4, values3, iteratee2, comparator) {
        var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length2 = values3.length, seen = array4;
        if (array4 === values3) {
          values3 = copyArray2(values3);
        }
        if (iteratee2) {
          seen = arrayMap2(array4, baseUnary2(iteratee2));
        }
        while (++index2 < length2) {
          var fromIndex = 0, value2 = values3[index2], computed2 = iteratee2 ? iteratee2(value2) : value2;
          while ((fromIndex = indexOf2(seen, computed2, fromIndex, comparator)) > -1) {
            if (seen !== array4) {
              splice2.call(seen, fromIndex, 1);
            }
            splice2.call(array4, fromIndex, 1);
          }
        }
        return array4;
      }
      function basePullAt(array4, indexes) {
        var length2 = array4 ? indexes.length : 0, lastIndex = length2 - 1;
        while (length2--) {
          var index2 = indexes[length2];
          if (length2 == lastIndex || index2 !== previous) {
            var previous = index2;
            if (isIndex2(index2)) {
              splice2.call(array4, index2, 1);
            } else {
              baseUnset(array4, index2);
            }
          }
        }
        return array4;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start, end, step, fromRight) {
        var index2 = -1, length2 = nativeMax2(nativeCeil((end - start) / (step || 1)), 0), result3 = Array2(length2);
        while (length2--) {
          result3[fromRight ? length2 : ++index2] = start;
          start += step;
        }
        return result3;
      }
      function baseRepeat(string3, n2) {
        var result3 = "";
        if (!string3 || n2 < 1 || n2 > MAX_SAFE_INTEGER2) {
          return result3;
        }
        do {
          if (n2 % 2) {
            result3 += string3;
          }
          n2 = nativeFloor(n2 / 2);
          if (n2) {
            string3 += string3;
          }
        } while (n2);
        return result3;
      }
      function baseRest2(func, start) {
        return setToString2(overRest2(func, start, identity2), func + "");
      }
      function baseSample(collection) {
        return arraySample(values2(collection));
      }
      function baseSampleSize(collection, n2) {
        var array4 = values2(collection);
        return shuffleSelf(array4, baseClamp(n2, 0, array4.length));
      }
      function baseSet(object4, path, value2, customizer) {
        if (!isObject3(object4)) {
          return object4;
        }
        path = castPath2(path, object4);
        var index2 = -1, length2 = path.length, lastIndex = length2 - 1, nested = object4;
        while (nested != null && ++index2 < length2) {
          var key = toKey2(path[index2]), newValue = value2;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object4;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject3(objValue) ? objValue : isIndex2(path[index2 + 1]) ? [] : {};
            }
          }
          assignValue2(nested, key, newValue);
          nested = nested[key];
        }
        return object4;
      }
      var baseSetData = !metaMap ? identity2 : function(func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString2 = !defineProperty2 ? identity2 : function(func, string3) {
        return defineProperty2(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant2(string3),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values2(collection));
      }
      function baseSlice2(array4, start, end) {
        var index2 = -1, length2 = array4.length;
        if (start < 0) {
          start = -start > length2 ? 0 : length2 + start;
        }
        end = end > length2 ? length2 : end;
        if (end < 0) {
          end += length2;
        }
        length2 = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result3 = Array2(length2);
        while (++index2 < length2) {
          result3[index2] = array4[index2 + start];
        }
        return result3;
      }
      function baseSome(collection, predicate) {
        var result3;
        baseEach2(collection, function(value2, index2, collection2) {
          result3 = predicate(value2, index2, collection2);
          return !result3;
        });
        return !!result3;
      }
      function baseSortedIndex(array4, value2, retHighest) {
        var low = 0, high = array4 == null ? low : array4.length;
        if (typeof value2 == "number" && value2 === value2 && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed2 = array4[mid];
            if (computed2 !== null && !isSymbol2(computed2) && (retHighest ? computed2 <= value2 : computed2 < value2)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array4, value2, identity2, retHighest);
      }
      function baseSortedIndexBy(array4, value2, iteratee2, retHighest) {
        var low = 0, high = array4 == null ? 0 : array4.length;
        if (high === 0) {
          return 0;
        }
        value2 = iteratee2(value2);
        var valIsNaN = value2 !== value2, valIsNull = value2 === null, valIsSymbol = isSymbol2(value2), valIsUndefined = value2 === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed2 = iteratee2(array4[mid]), othIsDefined = computed2 !== undefined$1, othIsNull = computed2 === null, othIsReflexive = computed2 === computed2, othIsSymbol = isSymbol2(computed2);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed2 <= value2 : computed2 < value2;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin2(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array4, iteratee2) {
        var index2 = -1, length2 = array4.length, resIndex = 0, result3 = [];
        while (++index2 < length2) {
          var value2 = array4[index2], computed2 = iteratee2 ? iteratee2(value2) : value2;
          if (!index2 || !eq2(computed2, seen)) {
            var seen = computed2;
            result3[resIndex++] = value2 === 0 ? 0 : value2;
          }
        }
        return result3;
      }
      function baseToNumber(value2) {
        if (typeof value2 == "number") {
          return value2;
        }
        if (isSymbol2(value2)) {
          return NAN2;
        }
        return +value2;
      }
      function baseToString2(value2) {
        if (typeof value2 == "string") {
          return value2;
        }
        if (isArray2(value2)) {
          return arrayMap2(value2, baseToString2) + "";
        }
        if (isSymbol2(value2)) {
          return symbolToString2 ? symbolToString2.call(value2) : "";
        }
        var result3 = value2 + "";
        return result3 == "0" && 1 / value2 == -INFINITY2 ? "-0" : result3;
      }
      function baseUniq(array4, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, length2 = array4.length, isCommon = true, result3 = [], seen = result3;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length2 >= LARGE_ARRAY_SIZE2) {
          var set3 = iteratee2 ? null : createSet(array4);
          if (set3) {
            return setToArray2(set3);
          }
          isCommon = false;
          includes2 = cacheHas2;
          seen = new SetCache2();
        } else {
          seen = iteratee2 ? [] : result3;
        }
        outer:
          while (++index2 < length2) {
            var value2 = array4[index2], computed2 = iteratee2 ? iteratee2(value2) : value2;
            value2 = comparator || value2 !== 0 ? value2 : 0;
            if (isCommon && computed2 === computed2) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed2) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed2);
              }
              result3.push(value2);
            } else if (!includes2(seen, computed2, comparator)) {
              if (seen !== result3) {
                seen.push(computed2);
              }
              result3.push(value2);
            }
          }
        return result3;
      }
      function baseUnset(object4, path) {
        path = castPath2(path, object4);
        object4 = parent(object4, path);
        return object4 == null || delete object4[toKey2(last(path))];
      }
      function baseUpdate(object4, path, updater, customizer) {
        return baseSet(object4, path, updater(baseGet2(object4, path)), customizer);
      }
      function baseWhile(array4, predicate, isDrop, fromRight) {
        var length2 = array4.length, index2 = fromRight ? length2 : -1;
        while ((fromRight ? index2-- : ++index2 < length2) && predicate(array4[index2], index2, array4)) {
        }
        return isDrop ? baseSlice2(array4, fromRight ? 0 : index2, fromRight ? index2 + 1 : length2) : baseSlice2(array4, fromRight ? index2 + 1 : 0, fromRight ? length2 : index2);
      }
      function baseWrapperValue(value2, actions) {
        var result3 = value2;
        if (result3 instanceof LazyWrapper) {
          result3 = result3.value();
        }
        return arrayReduce2(actions, function(result4, action) {
          return action.func.apply(action.thisArg, arrayPush2([result4], action.args));
        }, result3);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length2 = arrays.length;
        if (length2 < 2) {
          return length2 ? baseUniq(arrays[0]) : [];
        }
        var index2 = -1, result3 = Array2(length2);
        while (++index2 < length2) {
          var array4 = arrays[index2], othIndex = -1;
          while (++othIndex < length2) {
            if (othIndex != index2) {
              result3[index2] = baseDifference(result3[index2] || array4, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result3, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values3, assignFunc) {
        var index2 = -1, length2 = props.length, valsLength = values3.length, result3 = {};
        while (++index2 < length2) {
          var value2 = index2 < valsLength ? values3[index2] : undefined$1;
          assignFunc(result3, props[index2], value2);
        }
        return result3;
      }
      function castArrayLikeObject(value2) {
        return isArrayLikeObject2(value2) ? value2 : [];
      }
      function castFunction(value2) {
        return typeof value2 == "function" ? value2 : identity2;
      }
      function castPath2(value2, object4) {
        if (isArray2(value2)) {
          return value2;
        }
        return isKey2(value2, object4) ? [value2] : stringToPath2(toString2(value2));
      }
      var castRest = baseRest2;
      function castSlice2(array4, start, end) {
        var length2 = array4.length;
        end = end === undefined$1 ? length2 : end;
        return !start && end >= length2 ? array4 : baseSlice2(array4, start, end);
      }
      var clearTimeout2 = ctxClearTimeout || function(id2) {
        return root2.clearTimeout(id2);
      };
      function cloneBuffer2(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length2 = buffer.length, result3 = allocUnsafe2 ? allocUnsafe2(length2) : new buffer.constructor(length2);
        buffer.copy(result3);
        return result3;
      }
      function cloneArrayBuffer2(arrayBuffer) {
        var result3 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result3).set(new Uint8Array2(arrayBuffer));
        return result3;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer2(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp4) {
        var result3 = new regexp4.constructor(regexp4.source, reFlags.exec(regexp4));
        result3.lastIndex = regexp4.lastIndex;
        return result3;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf2 ? Object2(symbolValueOf2.call(symbol)) : {};
      }
      function cloneTypedArray2(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer2(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value2, other) {
        if (value2 !== other) {
          var valIsDefined = value2 !== undefined$1, valIsNull = value2 === null, valIsReflexive = value2 === value2, valIsSymbol = isSymbol2(value2);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol2(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value2 > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value2 < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object4, other, orders) {
        var index2 = -1, objCriteria = object4.criteria, othCriteria = other.criteria, length2 = objCriteria.length, ordersLength = orders.length;
        while (++index2 < length2) {
          var result3 = compareAscending(objCriteria[index2], othCriteria[index2]);
          if (result3) {
            if (index2 >= ordersLength) {
              return result3;
            }
            var order = orders[index2];
            return result3 * (order == "desc" ? -1 : 1);
          }
        }
        return object4.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result3 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result3[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result3[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result3[leftIndex++] = args[argsIndex++];
        }
        return result3;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result3 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result3[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result3[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result3[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result3;
      }
      function copyArray2(source, array4) {
        var index2 = -1, length2 = source.length;
        array4 || (array4 = Array2(length2));
        while (++index2 < length2) {
          array4[index2] = source[index2];
        }
        return array4;
      }
      function copyObject2(source, props, object4, customizer) {
        var isNew = !object4;
        object4 || (object4 = {});
        var index2 = -1, length2 = props.length;
        while (++index2 < length2) {
          var key = props[index2];
          var newValue = customizer ? customizer(object4[key], source[key], key, object4, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue2(object4, key, newValue);
          } else {
            assignValue2(object4, key, newValue);
          }
        }
        return object4;
      }
      function copySymbols(source, object4) {
        return copyObject2(source, getSymbols2(source), object4);
      }
      function copySymbolsIn(source, object4) {
        return copyObject2(source, getSymbolsIn(source), object4);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner2(assigner) {
        return baseRest2(function(object4, sources) {
          var index2 = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : undefined$1, guard = length2 > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : undefined$1;
          if (guard && isIterateeCall2(sources[0], sources[1], guard)) {
            customizer = length2 < 3 ? undefined$1 : customizer;
            length2 = 1;
          }
          object4 = Object2(object4);
          while (++index2 < length2) {
            var source = sources[index2];
            if (source) {
              assigner(object4, source, index2, customizer);
            }
          }
          return object4;
        });
      }
      function createBaseEach2(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike2(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object2(collection);
          while (fromRight ? index2-- : ++index2 < length2) {
            if (iteratee2(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor2(fromRight) {
        return function(object4, iteratee2, keysFunc) {
          var index2 = -1, iterable = Object2(object4), props = keysFunc(object4), length2 = props.length;
          while (length2--) {
            var key = props[fromRight ? length2 : ++index2];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object4;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn2 = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          return fn2.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst2(methodName) {
        return function(string3) {
          string3 = toString2(string3);
          var strSymbols = hasUnicode2(string3) ? stringToArray2(string3) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string3.charAt(0);
          var trailing = strSymbols ? castSlice2(strSymbols, 1).join("") : string3.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder2(callback) {
        return function(string3) {
          return arrayReduce2(words2(deburr2(string3).replace(reApos2, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate2(Ctor.prototype), result3 = Ctor.apply(thisBinding, args);
          return isObject3(result3) ? result3 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length2 = arguments.length, args = Array2(length2), index2 = length2, placeholder = getHolder(wrapper);
          while (index2--) {
            args[index2] = arguments[index2];
          }
          var holders = length2 < 3 && args[0] !== placeholder && args[length2 - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length2 -= holders.length;
          if (length2 < arity) {
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined$1, args, holders, undefined$1, undefined$1, arity - length2);
          }
          var fn2 = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          return apply2(fn2, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike2(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys2(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length2 = funcs.length, index2 = length2, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index2--) {
            var func = funcs[index2];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT2);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index2 = wrapper ? index2 : length2;
          while (++index2 < length2) {
            func = funcs[index2];
            var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value2 = args[0];
            if (wrapper && args.length == 1 && isArray2(value2)) {
              return wrapper.plant(value2).value();
            }
            var index3 = 0, result3 = length2 ? funcs[index3].apply(this, args) : value2;
            while (++index3 < length2) {
              result3 = funcs[index3].call(this, result3);
            }
            return result3;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length2 = arguments.length, args = Array2(length2), index2 = length2;
          while (index2--) {
            args[index2] = arguments[index2];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length2 -= holdersCount;
          if (isCurried && length2 < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary2, arity - length2);
          }
          var thisBinding = isBind ? thisArg : this, fn2 = isBindKey ? thisBinding[func] : func;
          length2 = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length2 > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length2) {
            args.length = ary2;
          }
          if (this && this !== root2 && this instanceof wrapper) {
            fn2 = Ctor || createCtor(fn2);
          }
          return fn2.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object4, iteratee2) {
          return baseInverter(object4, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator2, defaultValue) {
        return function(value2, other) {
          var result3;
          if (value2 === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value2 !== undefined$1) {
            result3 = value2;
          }
          if (other !== undefined$1) {
            if (result3 === undefined$1) {
              return other;
            }
            if (typeof value2 == "string" || typeof other == "string") {
              value2 = baseToString2(value2);
              other = baseToString2(other);
            } else {
              value2 = baseToNumber(value2);
              other = baseToNumber(other);
            }
            result3 = operator2(value2, other);
          }
          return result3;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap2(iteratees, baseUnary2(getIteratee()));
          return baseRest2(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply2(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length2, chars) {
        chars = chars === undefined$1 ? " " : baseToString2(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length2) : chars;
        }
        var result3 = baseRepeat(chars, nativeCeil(length2 / stringSize(chars)));
        return hasUnicode2(chars) ? castSlice2(stringToArray2(result3), 0, length2).join("") : result3.slice(0, length2);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn2 = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply2(fn2, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange2(fromRight) {
        return function(start, end, step) {
          if (step && typeof step != "number" && isIterateeCall2(start, end, step)) {
            end = step = undefined$1;
          }
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator2) {
        return function(value2, other) {
          if (!(typeof value2 == "string" && typeof other == "string")) {
            value2 = toNumber2(value2);
            other = toNumber2(other);
          }
          return operator2(value2, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result3 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result3, newData);
        }
        result3.placeholder = placeholder;
        return setWrapToString(result3, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number4, precision) {
          number4 = toNumber2(number4);
          precision = precision == null ? 0 : nativeMin2(toInteger2(precision), 292);
          if (precision && nativeIsFinite(number4)) {
            var pair2 = (toString2(number4) + "e").split("e"), value2 = func(pair2[0] + "e" + (+pair2[1] + precision));
            pair2 = (toString2(value2) + "e").split("e");
            return +(pair2[0] + "e" + (+pair2[1] - precision));
          }
          return func(number4);
        };
      }
      var createSet = !(Set2 && 1 / setToArray2(new Set2([, -0]))[1] == INFINITY2) ? noop2 : function(values3) {
        return new Set2(values3);
      };
      function createToPairs(keysFunc) {
        return function(object4) {
          var tag = getTag2(object4);
          if (tag == mapTag2) {
            return mapToArray2(object4);
          }
          if (tag == setTag2) {
            return setToPairs(object4);
          }
          return baseToPairs(object4, keysFunc(object4));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        var length2 = partials ? partials.length : 0;
        if (!length2) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax2(toInteger2(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger2(arity);
        length2 -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax2(newData[9] - length2, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result3 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result3 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result3 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result3 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result3, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object4) {
        if (objValue === undefined$1 || eq2(objValue, objectProto2[key]) && !hasOwnProperty2.call(object4, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object4, source, stack2) {
        if (isObject3(objValue) && isObject3(srcValue)) {
          stack2.set(srcValue, objValue);
          baseMerge2(objValue, srcValue, undefined$1, customDefaultsMerge, stack2);
          stack2["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value2) {
        return isPlainObject2(value2) ? undefined$1 : value2;
      }
      function equalArrays2(array4, other, bitmask, customizer, equalFunc, stack2) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, arrLength = array4.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack2.get(array4);
        var othStacked = stack2.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array4;
        }
        var index2 = -1, result3 = true, seen = bitmask & COMPARE_UNORDERED_FLAG2 ? new SetCache2() : undefined$1;
        stack2.set(array4, other);
        stack2.set(other, array4);
        while (++index2 < arrLength) {
          var arrValue = array4[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array4, stack2) : customizer(arrValue, othValue, index2, array4, other, stack2);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result3 = false;
            break;
          }
          if (seen) {
            if (!arraySome2(other, function(othValue2, othIndex) {
              if (!cacheHas2(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack2))) {
                return seen.push(othIndex);
              }
            })) {
              result3 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack2))) {
            result3 = false;
            break;
          }
        }
        stack2["delete"](array4);
        stack2["delete"](other);
        return result3;
      }
      function equalByTag2(object4, other, tag, bitmask, customizer, equalFunc, stack2) {
        switch (tag) {
          case dataViewTag2:
            if (object4.byteLength != other.byteLength || object4.byteOffset != other.byteOffset) {
              return false;
            }
            object4 = object4.buffer;
            other = other.buffer;
          case arrayBufferTag2:
            if (object4.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object4), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag2:
          case dateTag2:
          case numberTag2:
            return eq2(+object4, +other);
          case errorTag2:
            return object4.name == other.name && object4.message == other.message;
          case regexpTag2:
          case stringTag2:
            return object4 == other + "";
          case mapTag2:
            var convert2 = mapToArray2;
          case setTag2:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
            convert2 || (convert2 = setToArray2);
            if (object4.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack2.get(object4);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG2;
            stack2.set(object4, other);
            var result3 = equalArrays2(convert2(object4), convert2(other), bitmask, customizer, equalFunc, stack2);
            stack2["delete"](object4);
            return result3;
          case symbolTag2:
            if (symbolValueOf2) {
              return symbolValueOf2.call(object4) == symbolValueOf2.call(other);
            }
        }
        return false;
      }
      function equalObjects2(object4, other, bitmask, customizer, equalFunc, stack2) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, objProps = getAllKeys2(object4), objLength = objProps.length, othProps = getAllKeys2(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack2.get(object4);
        var othStacked = stack2.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object4;
        }
        var result3 = true;
        stack2.set(object4, other);
        stack2.set(other, object4);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object4[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object4, stack2) : customizer(objValue, othValue, key, object4, other, stack2);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack2) : compared)) {
            result3 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result3 && !skipCtor) {
          var objCtor = object4.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object4 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result3 = false;
          }
        }
        stack2["delete"](object4);
        stack2["delete"](other);
        return result3;
      }
      function flatRest(func) {
        return setToString2(overRest2(func, undefined$1, flatten2), func + "");
      }
      function getAllKeys2(object4) {
        return baseGetAllKeys2(object4, keys2, getSymbols2);
      }
      function getAllKeysIn(object4) {
        return baseGetAllKeys2(object4, keysIn2, getSymbolsIn);
      }
      var getData = !metaMap ? noop2 : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result3 = func.name + "", array4 = realNames[result3], length2 = hasOwnProperty2.call(realNames, result3) ? array4.length : 0;
        while (length2--) {
          var data = array4[length2], otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result3;
      }
      function getHolder(func) {
        var object4 = hasOwnProperty2.call(lodash2, "placeholder") ? lodash2 : func;
        return object4.placeholder;
      }
      function getIteratee() {
        var result3 = lodash2.iteratee || iteratee;
        result3 = result3 === iteratee ? baseIteratee2 : result3;
        return arguments.length ? result3(arguments[0], arguments[1]) : result3;
      }
      function getMapData2(map3, key) {
        var data = map3.__data__;
        return isKeyable2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      function getMatchData2(object4) {
        var result3 = keys2(object4), length2 = result3.length;
        while (length2--) {
          var key = result3[length2], value2 = object4[key];
          result3[length2] = [key, value2, isStrictComparable2(value2)];
        }
        return result3;
      }
      function getNative2(object4, key) {
        var value2 = getValue2(object4, key);
        return baseIsNative2(value2) ? value2 : undefined$1;
      }
      function getRawTag2(value2) {
        var isOwn = hasOwnProperty2.call(value2, symToStringTag2), tag = value2[symToStringTag2];
        try {
          value2[symToStringTag2] = undefined$1;
          var unmasked = true;
        } catch (e25) {
        }
        var result3 = nativeObjectToString2.call(value2);
        if (unmasked) {
          if (isOwn) {
            value2[symToStringTag2] = tag;
          } else {
            delete value2[symToStringTag2];
          }
        }
        return result3;
      }
      var getSymbols2 = !nativeGetSymbols2 ? stubArray2 : function(object4) {
        if (object4 == null) {
          return [];
        }
        object4 = Object2(object4);
        return arrayFilter2(nativeGetSymbols2(object4), function(symbol) {
          return propertyIsEnumerable2.call(object4, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols2 ? stubArray2 : function(object4) {
        var result3 = [];
        while (object4) {
          arrayPush2(result3, getSymbols2(object4));
          object4 = getPrototype2(object4);
        }
        return result3;
      };
      var getTag2 = baseGetTag2;
      if (DataView2 && getTag2(new DataView2(new ArrayBuffer(1))) != dataViewTag2 || Map2 && getTag2(new Map2()) != mapTag2 || Promise2 && getTag2(Promise2.resolve()) != promiseTag2 || Set2 && getTag2(new Set2()) != setTag2 || WeakMap2 && getTag2(new WeakMap2()) != weakMapTag2) {
        getTag2 = function(value2) {
          var result3 = baseGetTag2(value2), Ctor = result3 == objectTag2 ? value2.constructor : undefined$1, ctorString = Ctor ? toSource2(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString2:
                return dataViewTag2;
              case mapCtorString2:
                return mapTag2;
              case promiseCtorString2:
                return promiseTag2;
              case setCtorString2:
                return setTag2;
              case weakMapCtorString2:
                return weakMapTag2;
            }
          }
          return result3;
        };
      }
      function getView(start, end, transforms) {
        var index2 = -1, length2 = transforms.length;
        while (++index2 < length2) {
          var data = transforms[index2], size3 = data.size;
          switch (data.type) {
            case "drop":
              start += size3;
              break;
            case "dropRight":
              end -= size3;
              break;
            case "take":
              end = nativeMin2(end, start + size3);
              break;
            case "takeRight":
              start = nativeMax2(start, end - size3);
              break;
          }
        }
        return { "start": start, "end": end };
      }
      function getWrapDetails(source) {
        var match2 = source.match(reWrapDetails);
        return match2 ? match2[1].split(reSplitDetails) : [];
      }
      function hasPath2(object4, path, hasFunc) {
        path = castPath2(path, object4);
        var index2 = -1, length2 = path.length, result3 = false;
        while (++index2 < length2) {
          var key = toKey2(path[index2]);
          if (!(result3 = object4 != null && hasFunc(object4, key))) {
            break;
          }
          object4 = object4[key];
        }
        if (result3 || ++index2 != length2) {
          return result3;
        }
        length2 = object4 == null ? 0 : object4.length;
        return !!length2 && isLength2(length2) && isIndex2(key, length2) && (isArray2(object4) || isArguments2(object4));
      }
      function initCloneArray(array4) {
        var length2 = array4.length, result3 = new array4.constructor(length2);
        if (length2 && typeof array4[0] == "string" && hasOwnProperty2.call(array4, "index")) {
          result3.index = array4.index;
          result3.input = array4.input;
        }
        return result3;
      }
      function initCloneObject2(object4) {
        return typeof object4.constructor == "function" && !isPrototype2(object4) ? baseCreate2(getPrototype2(object4)) : {};
      }
      function initCloneByTag(object4, tag, isDeep) {
        var Ctor = object4.constructor;
        switch (tag) {
          case arrayBufferTag2:
            return cloneArrayBuffer2(object4);
          case boolTag2:
          case dateTag2:
            return new Ctor(+object4);
          case dataViewTag2:
            return cloneDataView(object4, isDeep);
          case float32Tag2:
          case float64Tag2:
          case int8Tag2:
          case int16Tag2:
          case int32Tag2:
          case uint8Tag2:
          case uint8ClampedTag2:
          case uint16Tag2:
          case uint32Tag2:
            return cloneTypedArray2(object4, isDeep);
          case mapTag2:
            return new Ctor();
          case numberTag2:
          case stringTag2:
            return new Ctor(object4);
          case regexpTag2:
            return cloneRegExp(object4);
          case setTag2:
            return new Ctor();
          case symbolTag2:
            return cloneSymbol(object4);
        }
      }
      function insertWrapDetails(source, details) {
        var length2 = details.length;
        if (!length2) {
          return source;
        }
        var lastIndex = length2 - 1;
        details[lastIndex] = (length2 > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length2 > 2 ? ", " : " ");
        return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value2) {
        return isArray2(value2) || isArguments2(value2) || !!(spreadableSymbol && value2 && value2[spreadableSymbol]);
      }
      function isIndex2(value2, length2) {
        var type4 = typeof value2;
        length2 = length2 == null ? MAX_SAFE_INTEGER2 : length2;
        return !!length2 && (type4 == "number" || type4 != "symbol" && reIsUint2.test(value2)) && (value2 > -1 && value2 % 1 == 0 && value2 < length2);
      }
      function isIterateeCall2(value2, index2, object4) {
        if (!isObject3(object4)) {
          return false;
        }
        var type4 = typeof index2;
        if (type4 == "number" ? isArrayLike2(object4) && isIndex2(index2, object4.length) : type4 == "string" && index2 in object4) {
          return eq2(object4[index2], value2);
        }
        return false;
      }
      function isKey2(value2, object4) {
        if (isArray2(value2)) {
          return false;
        }
        var type4 = typeof value2;
        if (type4 == "number" || type4 == "symbol" || type4 == "boolean" || value2 == null || isSymbol2(value2)) {
          return true;
        }
        return reIsPlainProp2.test(value2) || !reIsDeepProp2.test(value2) || object4 != null && value2 in Object2(object4);
      }
      function isKeyable2(value2) {
        var type4 = typeof value2;
        return type4 == "string" || type4 == "number" || type4 == "symbol" || type4 == "boolean" ? value2 !== "__proto__" : value2 === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked2(func) {
        return !!maskSrcKey2 && maskSrcKey2 in func;
      }
      var isMaskable = coreJsData2 ? isFunction2 : stubFalse2;
      function isPrototype2(value2) {
        var Ctor = value2 && value2.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
        return value2 === proto;
      }
      function isStrictComparable2(value2) {
        return value2 === value2 && !isObject3(value2);
      }
      function matchesStrictComparable2(key, srcValue) {
        return function(object4) {
          if (object4 == null) {
            return false;
          }
          return object4[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object4));
        };
      }
      function memoizeCapped2(func) {
        var result3 = memoize2(func, function(key) {
          if (cache2.size === MAX_MEMOIZE_SIZE2) {
            cache2.clear();
          }
          return key;
        });
        var cache2 = result3.cache;
        return result3;
      }
      function mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value2 = source[3];
        if (value2) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value2, source[4]) : value2;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        value2 = source[5];
        if (value2) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value2, source[6]) : value2;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        value2 = source[7];
        if (value2) {
          data[7] = value2;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin2(data[8], source[8]);
        }
        if (data[9] == null) {
          data[9] = source[9];
        }
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn2(object4) {
        var result3 = [];
        if (object4 != null) {
          for (var key in Object2(object4)) {
            result3.push(key);
          }
        }
        return result3;
      }
      function objectToString2(value2) {
        return nativeObjectToString2.call(value2);
      }
      function overRest2(func, start, transform2) {
        start = nativeMax2(start === undefined$1 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments, index2 = -1, length2 = nativeMax2(args.length - start, 0), array4 = Array2(length2);
          while (++index2 < length2) {
            array4[index2] = args[start + index2];
          }
          index2 = -1;
          var otherArgs = Array2(start + 1);
          while (++index2 < start) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start] = transform2(array4);
          return apply2(func, this, otherArgs);
        };
      }
      function parent(object4, path) {
        return path.length < 2 ? object4 : baseGet2(object4, baseSlice2(path, 0, -1));
      }
      function reorder(array4, indexes) {
        var arrLength = array4.length, length2 = nativeMin2(indexes.length, arrLength), oldArray = copyArray2(array4);
        while (length2--) {
          var index2 = indexes[length2];
          array4[length2] = isIndex2(index2, arrLength) ? oldArray[index2] : undefined$1;
        }
        return array4;
      }
      function safeGet2(object4, key) {
        if (key === "constructor" && typeof object4[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object4[key];
      }
      var setData = shortOut2(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root2.setTimeout(func, wait);
      };
      var setToString2 = shortOut2(baseSetToString2);
      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + "";
        return setToString2(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut2(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow2(), remaining = HOT_SPAN2 - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT2) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array4, size3) {
        var index2 = -1, length2 = array4.length, lastIndex = length2 - 1;
        size3 = size3 === undefined$1 ? length2 : size3;
        while (++index2 < size3) {
          var rand = baseRandom(index2, lastIndex), value2 = array4[rand];
          array4[rand] = array4[index2];
          array4[index2] = value2;
        }
        array4.length = size3;
        return array4;
      }
      var stringToPath2 = memoizeCapped2(function(string3) {
        var result3 = [];
        if (string3.charCodeAt(0) === 46) {
          result3.push("");
        }
        string3.replace(rePropName2, function(match2, number4, quote, subString) {
          result3.push(quote ? subString.replace(reEscapeChar2, "$1") : number4 || match2);
        });
        return result3;
      });
      function toKey2(value2) {
        if (typeof value2 == "string" || isSymbol2(value2)) {
          return value2;
        }
        var result3 = value2 + "";
        return result3 == "0" && 1 / value2 == -INFINITY2 ? "-0" : result3;
      }
      function toSource2(func) {
        if (func != null) {
          try {
            return funcToString2.call(func);
          } catch (e25) {
          }
          try {
            return func + "";
          } catch (e25) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair2) {
          var value2 = "_." + pair2[0];
          if (bitmask & pair2[1] && !arrayIncludes(details, value2)) {
            details.push(value2);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result3 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result3.__actions__ = copyArray2(wrapper.__actions__);
        result3.__index__ = wrapper.__index__;
        result3.__values__ = wrapper.__values__;
        return result3;
      }
      function chunk(array4, size3, guard) {
        if (guard ? isIterateeCall2(array4, size3, guard) : size3 === undefined$1) {
          size3 = 1;
        } else {
          size3 = nativeMax2(toInteger2(size3), 0);
        }
        var length2 = array4 == null ? 0 : array4.length;
        if (!length2 || size3 < 1) {
          return [];
        }
        var index2 = 0, resIndex = 0, result3 = Array2(nativeCeil(length2 / size3));
        while (index2 < length2) {
          result3[resIndex++] = baseSlice2(array4, index2, index2 += size3);
        }
        return result3;
      }
      function compact(array4) {
        var index2 = -1, length2 = array4 == null ? 0 : array4.length, resIndex = 0, result3 = [];
        while (++index2 < length2) {
          var value2 = array4[index2];
          if (value2) {
            result3[resIndex++] = value2;
          }
        }
        return result3;
      }
      function concat() {
        var length2 = arguments.length;
        if (!length2) {
          return [];
        }
        var args = Array2(length2 - 1), array4 = arguments[0], index2 = length2;
        while (index2--) {
          args[index2 - 1] = arguments[index2];
        }
        return arrayPush2(isArray2(array4) ? copyArray2(array4) : [array4], baseFlatten(args, 1));
      }
      var difference = baseRest2(function(array4, values3) {
        return isArrayLikeObject2(array4) ? baseDifference(array4, baseFlatten(values3, 1, isArrayLikeObject2, true)) : [];
      });
      var differenceBy = baseRest2(function(array4, values3) {
        var iteratee2 = last(values3);
        if (isArrayLikeObject2(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject2(array4) ? baseDifference(array4, baseFlatten(values3, 1, isArrayLikeObject2, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest2(function(array4, values3) {
        var comparator = last(values3);
        if (isArrayLikeObject2(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject2(array4) ? baseDifference(array4, baseFlatten(values3, 1, isArrayLikeObject2, true), undefined$1, comparator) : [];
      });
      function drop(array4, n2, guard) {
        var length2 = array4 == null ? 0 : array4.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger2(n2);
        return baseSlice2(array4, n2 < 0 ? 0 : n2, length2);
      }
      function dropRight(array4, n2, guard) {
        var length2 = array4 == null ? 0 : array4.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger2(n2);
        n2 = length2 - n2;
        return baseSlice2(array4, 0, n2 < 0 ? 0 : n2);
      }
      function dropRightWhile(array4, predicate) {
        return array4 && array4.length ? baseWhile(array4, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array4, predicate) {
        return array4 && array4.length ? baseWhile(array4, getIteratee(predicate, 3), true) : [];
      }
      function fill(array4, value2, start, end) {
        var length2 = array4 == null ? 0 : array4.length;
        if (!length2) {
          return [];
        }
        if (start && typeof start != "number" && isIterateeCall2(array4, value2, start)) {
          start = 0;
          end = length2;
        }
        return baseFill(array4, value2, start, end);
      }
      function findIndex2(array4, predicate, fromIndex) {
        var length2 = array4 == null ? 0 : array4.length;
        if (!length2) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax2(length2 + index2, 0);
        }
        return baseFindIndex(array4, getIteratee(predicate, 3), index2);
      }
      function findLastIndex(array4, predicate, fromIndex) {
        var length2 = array4 == null ? 0 : array4.length;
        if (!length2) {
          return -1;
        }
        var index2 = length2 - 1;
        if (fromIndex !== undefined$1) {
          index2 = toInteger2(fromIndex);
          index2 = fromIndex < 0 ? nativeMax2(length2 + index2, 0) : nativeMin2(index2, length2 - 1);
        }
        return baseFindIndex(array4, getIteratee(predicate, 3), index2, true);
      }
      function flatten2(array4) {
        var length2 = array4 == null ? 0 : array4.length;
        return length2 ? baseFlatten(array4, 1) : [];
      }
      function flattenDeep(array4) {
        var length2 = array4 == null ? 0 : array4.length;
        return length2 ? baseFlatten(array4, INFINITY2) : [];
      }
      function flattenDepth(array4, depth) {
        var length2 = array4 == null ? 0 : array4.length;
        if (!length2) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger2(depth);
        return baseFlatten(array4, depth);
      }
      function fromPairs(pairs) {
        var index2 = -1, length2 = pairs == null ? 0 : pairs.length, result3 = {};
        while (++index2 < length2) {
          var pair2 = pairs[index2];
          result3[pair2[0]] = pair2[1];
        }
        return result3;
      }
      function head(array4) {
        return array4 && array4.length ? array4[0] : undefined$1;
      }
      function indexOf(array4, value2, fromIndex) {
        var length2 = array4 == null ? 0 : array4.length;
        if (!length2) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger2(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax2(length2 + index2, 0);
        }
        return baseIndexOf(array4, value2, index2);
      }
      function initial(array4) {
        var length2 = array4 == null ? 0 : array4.length;
        return length2 ? baseSlice2(array4, 0, -1) : [];
      }
      var intersection = baseRest2(function(arrays) {
        var mapped = arrayMap2(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest2(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap2(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest2(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap2(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join(array4, separator) {
        return array4 == null ? "" : nativeJoin.call(array4, separator);
      }
      function last(array4) {
        var length2 = array4 == null ? 0 : array4.length;
        return length2 ? array4[length2 - 1] : undefined$1;
      }
      function lastIndexOf(array4, value2, fromIndex) {
        var length2 = array4 == null ? 0 : array4.length;
        if (!length2) {
          return -1;
        }
        var index2 = length2;
        if (fromIndex !== undefined$1) {
          index2 = toInteger2(fromIndex);
          index2 = index2 < 0 ? nativeMax2(length2 + index2, 0) : nativeMin2(index2, length2 - 1);
        }
        return value2 === value2 ? strictLastIndexOf(array4, value2, index2) : baseFindIndex(array4, baseIsNaN, index2, true);
      }
      function nth2(array4, n2) {
        return array4 && array4.length ? baseNth(array4, toInteger2(n2)) : undefined$1;
      }
      var pull = baseRest2(pullAll);
      function pullAll(array4, values3) {
        return array4 && array4.length && values3 && values3.length ? basePullAll(array4, values3) : array4;
      }
      function pullAllBy(array4, values3, iteratee2) {
        return array4 && array4.length && values3 && values3.length ? basePullAll(array4, values3, getIteratee(iteratee2, 2)) : array4;
      }
      function pullAllWith(array4, values3, comparator) {
        return array4 && array4.length && values3 && values3.length ? basePullAll(array4, values3, undefined$1, comparator) : array4;
      }
      var pullAt = flatRest(function(array4, indexes) {
        var length2 = array4 == null ? 0 : array4.length, result3 = baseAt(array4, indexes);
        basePullAt(array4, arrayMap2(indexes, function(index2) {
          return isIndex2(index2, length2) ? +index2 : index2;
        }).sort(compareAscending));
        return result3;
      });
      function remove2(array4, predicate) {
        var result3 = [];
        if (!(array4 && array4.length)) {
          return result3;
        }
        var index2 = -1, indexes = [], length2 = array4.length;
        predicate = getIteratee(predicate, 3);
        while (++index2 < length2) {
          var value2 = array4[index2];
          if (predicate(value2, index2, array4)) {
            result3.push(value2);
            indexes.push(index2);
          }
        }
        basePullAt(array4, indexes);
        return result3;
      }
      function reverse(array4) {
        return array4 == null ? array4 : nativeReverse.call(array4);
      }
      function slice(array4, start, end) {
        var length2 = array4 == null ? 0 : array4.length;
        if (!length2) {
          return [];
        }
        if (end && typeof end != "number" && isIterateeCall2(array4, start, end)) {
          start = 0;
          end = length2;
        } else {
          start = start == null ? 0 : toInteger2(start);
          end = end === undefined$1 ? length2 : toInteger2(end);
        }
        return baseSlice2(array4, start, end);
      }
      function sortedIndex(array4, value2) {
        return baseSortedIndex(array4, value2);
      }
      function sortedIndexBy(array4, value2, iteratee2) {
        return baseSortedIndexBy(array4, value2, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array4, value2) {
        var length2 = array4 == null ? 0 : array4.length;
        if (length2) {
          var index2 = baseSortedIndex(array4, value2);
          if (index2 < length2 && eq2(array4[index2], value2)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedLastIndex(array4, value2) {
        return baseSortedIndex(array4, value2, true);
      }
      function sortedLastIndexBy(array4, value2, iteratee2) {
        return baseSortedIndexBy(array4, value2, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array4, value2) {
        var length2 = array4 == null ? 0 : array4.length;
        if (length2) {
          var index2 = baseSortedIndex(array4, value2, true) - 1;
          if (eq2(array4[index2], value2)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedUniq(array4) {
        return array4 && array4.length ? baseSortedUniq(array4) : [];
      }
      function sortedUniqBy(array4, iteratee2) {
        return array4 && array4.length ? baseSortedUniq(array4, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array4) {
        var length2 = array4 == null ? 0 : array4.length;
        return length2 ? baseSlice2(array4, 1, length2) : [];
      }
      function take(array4, n2, guard) {
        if (!(array4 && array4.length)) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger2(n2);
        return baseSlice2(array4, 0, n2 < 0 ? 0 : n2);
      }
      function takeRight(array4, n2, guard) {
        var length2 = array4 == null ? 0 : array4.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger2(n2);
        n2 = length2 - n2;
        return baseSlice2(array4, n2 < 0 ? 0 : n2, length2);
      }
      function takeRightWhile(array4, predicate) {
        return array4 && array4.length ? baseWhile(array4, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array4, predicate) {
        return array4 && array4.length ? baseWhile(array4, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest2(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject2, true));
      });
      var unionBy = baseRest2(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject2(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject2, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest2(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject2, true), undefined$1, comparator);
      });
      function uniq(array4) {
        return array4 && array4.length ? baseUniq(array4) : [];
      }
      function uniqBy(array4, iteratee2) {
        return array4 && array4.length ? baseUniq(array4, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array4, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array4 && array4.length ? baseUniq(array4, undefined$1, comparator) : [];
      }
      function unzip(array4) {
        if (!(array4 && array4.length)) {
          return [];
        }
        var length2 = 0;
        array4 = arrayFilter2(array4, function(group) {
          if (isArrayLikeObject2(group)) {
            length2 = nativeMax2(group.length, length2);
            return true;
          }
        });
        return baseTimes2(length2, function(index2) {
          return arrayMap2(array4, baseProperty2(index2));
        });
      }
      function unzipWith(array4, iteratee2) {
        if (!(array4 && array4.length)) {
          return [];
        }
        var result3 = unzip(array4);
        if (iteratee2 == null) {
          return result3;
        }
        return arrayMap2(result3, function(group) {
          return apply2(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest2(function(array4, values3) {
        return isArrayLikeObject2(array4) ? baseDifference(array4, values3) : [];
      });
      var xor = baseRest2(function(arrays) {
        return baseXor(arrayFilter2(arrays, isArrayLikeObject2));
      });
      var xorBy = baseRest2(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject2(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter2(arrays, isArrayLikeObject2), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest2(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter2(arrays, isArrayLikeObject2), undefined$1, comparator);
      });
      var zip = baseRest2(unzip);
      function zipObject(props, values3) {
        return baseZipObject(props || [], values3 || [], assignValue2);
      }
      function zipObjectDeep(props, values3) {
        return baseZipObject(props || [], values3 || [], baseSet);
      }
      var zipWith = baseRest2(function(arrays) {
        var length2 = arrays.length, iteratee2 = length2 > 1 ? arrays[length2 - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value2) {
        var result3 = lodash2(value2);
        result3.__chain__ = true;
        return result3;
      }
      function tap(value2, interceptor) {
        interceptor(value2);
        return value2;
      }
      function thru(value2, interceptor) {
        return interceptor(value2);
      }
      var wrapperAt = flatRest(function(paths) {
        var length2 = paths.length, start = length2 ? paths[0] : 0, value2 = this.__wrapped__, interceptor = function(object4) {
          return baseAt(object4, paths);
        };
        if (length2 > 1 || this.__actions__.length || !(value2 instanceof LazyWrapper) || !isIndex2(start)) {
          return this.thru(interceptor);
        }
        value2 = value2.slice(start, +start + (length2 ? 1 : 0));
        value2.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value2, this.__chain__).thru(function(array4) {
          if (length2 && !array4.length) {
            array4.push(undefined$1);
          }
          return array4;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray2(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value2 = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value2 };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value2) {
        var result3, parent2 = this;
        while (parent2 instanceof baseLodash) {
          var clone2 = wrapperClone(parent2);
          clone2.__index__ = 0;
          clone2.__values__ = undefined$1;
          if (result3) {
            previous.__wrapped__ = clone2;
          } else {
            result3 = clone2;
          }
          var previous = clone2;
          parent2 = parent2.__wrapped__;
        }
        previous.__wrapped__ = value2;
        return result3;
      }
      function wrapperReverse() {
        var value2 = this.__wrapped__;
        if (value2 instanceof LazyWrapper) {
          var wrapped = value2;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result3, value2, key) {
        if (hasOwnProperty2.call(result3, key)) {
          ++result3[key];
        } else {
          baseAssignValue2(result3, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray2(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall2(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter2 : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find2 = createFind(findIndex2);
      var findLast2 = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten(map2(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map2(collection, iteratee2), INFINITY2);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger2(depth);
        return baseFlatten(map2(collection, iteratee2), depth);
      }
      function forEach(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEach : baseEach2;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result3, value2, key) {
        if (hasOwnProperty2.call(result3, key)) {
          result3[key].push(value2);
        } else {
          baseAssignValue2(result3, key, [value2]);
        }
      });
      function includes(collection, value2, fromIndex, guard) {
        collection = isArrayLike2(collection) ? collection : values2(collection);
        fromIndex = fromIndex && !guard ? toInteger2(fromIndex) : 0;
        var length2 = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax2(length2 + fromIndex, 0);
        }
        return isString(collection) ? fromIndex <= length2 && collection.indexOf(value2, fromIndex) > -1 : !!length2 && baseIndexOf(collection, value2, fromIndex) > -1;
      }
      var invokeMap = baseRest2(function(collection, path, args) {
        var index2 = -1, isFunc = typeof path == "function", result3 = isArrayLike2(collection) ? Array2(collection.length) : [];
        baseEach2(collection, function(value2) {
          result3[++index2] = isFunc ? apply2(path, value2, args) : baseInvoke(value2, path, args);
        });
        return result3;
      });
      var keyBy = createAggregator(function(result3, value2, key) {
        baseAssignValue2(result3, key, value2);
      });
      function map2(collection, iteratee2) {
        var func = isArray2(collection) ? arrayMap2 : baseMap2;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray2(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray2(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function(result3, value2, key) {
        result3[key ? 0 : 1].push(value2);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduce2 : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach2);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter2 : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray2(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n2, guard) {
        if (guard ? isIterateeCall2(collection, n2, guard) : n2 === undefined$1) {
          n2 = 1;
        } else {
          n2 = toInteger2(n2);
        }
        var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n2);
      }
      function shuffle(collection) {
        var func = isArray2(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size2(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike2(collection)) {
          return isString(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag2(collection);
        if (tag == mapTag2 || tag == setTag2) {
          return collection.size;
        }
        return baseKeys2(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray2(collection) ? arraySome2 : baseSome;
        if (guard && isIterateeCall2(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest2(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length2 = iteratees.length;
        if (length2 > 1 && isIterateeCall2(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length2 > 2 && isIterateeCall2(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now2 = ctxNow || function() {
        return root2.Date.now();
      };
      function after(n2, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        n2 = toInteger2(n2);
        return function() {
          if (--n2 < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n2, guard) {
        n2 = guard ? undefined$1 : n2;
        n2 = func && n2 == null ? func.length : n2;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n2);
      }
      function before(n2, func) {
        var result3;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        n2 = toInteger2(n2);
        return function() {
          if (--n2 > 0) {
            result3 = func.apply(this, arguments);
          }
          if (n2 <= 1) {
            func = undefined$1;
          }
          return result3;
        };
      }
      var bind = baseRest2(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest2(function(object4, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object4, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result3 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result3.placeholder = curry.placeholder;
        return result3;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result3 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result3.placeholder = curryRight.placeholder;
        return result3;
      }
      function debounce2(func, wait, options) {
        var lastArgs, lastThis, maxWait, result3, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        wait = toNumber2(wait) || 0;
        if (isObject3(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax2(toNumber2(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time2) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time2;
          result3 = func.apply(thisArg, args);
          return result3;
        }
        function leadingEdge(time2) {
          lastInvokeTime = time2;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time2) : result3;
        }
        function remainingWait(time2) {
          var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin2(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time2) {
          var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time2 = now2();
          if (shouldInvoke(time2)) {
            return trailingEdge(time2);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time2));
        }
        function trailingEdge(time2) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time2);
          }
          lastArgs = lastThis = undefined$1;
          return result3;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result3 : trailingEdge(now2());
        }
        function debounced() {
          var time2 = now2(), isInvoking = shouldInvoke(time2);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time2;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result3;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest2(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest2(function(func, wait, args) {
        return baseDelay(func, toNumber2(wait) || 0, args);
      });
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize2(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
          if (cache2.has(key)) {
            return cache2.get(key);
          }
          var result3 = func.apply(this, args);
          memoized.cache = cache2.set(key, result3) || cache2;
          return result3;
        };
        memoized.cache = new (memoize2.Cache || MapCache2)();
        return memoized;
      }
      memoize2.Cache = MapCache2;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap2(transforms[0], baseUnary2(getIteratee())) : arrayMap2(baseFlatten(transforms, 1), baseUnary2(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest2(function(args) {
          var index2 = -1, length2 = nativeMin2(args.length, funcsLength);
          while (++index2 < length2) {
            args[index2] = transforms[index2].call(this, args[index2]);
          }
          return apply2(func, this, args);
        });
      });
      var partial = baseRest2(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest2(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        start = start === undefined$1 ? start : toInteger2(start);
        return baseRest2(func, start);
      }
      function spread(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        start = start == null ? 0 : nativeMax2(toInteger2(start), 0);
        return baseRest2(function(args) {
          var array4 = args[start], otherArgs = castSlice2(args, 0, start);
          if (array4) {
            arrayPush2(otherArgs, array4);
          }
          return apply2(func, this, otherArgs);
        });
      }
      function throttle2(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        if (isObject3(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce2(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value2, wrapper) {
        return partial(castFunction(wrapper), value2);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value2 = arguments[0];
        return isArray2(value2) ? value2 : [value2];
      }
      function clone(value2) {
        return baseClone(value2, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value2, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value2, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value2) {
        return baseClone(value2, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value2, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value2, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object4, source) {
        return source == null || baseConformsTo(object4, source, keys2(source));
      }
      function eq2(value2, other) {
        return value2 === other || value2 !== value2 && other !== other;
      }
      var gt2 = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value2, other) {
        return value2 >= other;
      });
      var isArguments2 = baseIsArguments2(function() {
        return arguments;
      }()) ? baseIsArguments2 : function(value2) {
        return isObjectLike2(value2) && hasOwnProperty2.call(value2, "callee") && !propertyIsEnumerable2.call(value2, "callee");
      };
      var isArray2 = Array2.isArray;
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary2(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike2(value2) {
        return value2 != null && isLength2(value2.length) && !isFunction2(value2);
      }
      function isArrayLikeObject2(value2) {
        return isObjectLike2(value2) && isArrayLike2(value2);
      }
      function isBoolean(value2) {
        return value2 === true || value2 === false || isObjectLike2(value2) && baseGetTag2(value2) == boolTag2;
      }
      var isBuffer2 = nativeIsBuffer2 || stubFalse2;
      var isDate2 = nodeIsDate ? baseUnary2(nodeIsDate) : baseIsDate;
      function isElement2(value2) {
        return isObjectLike2(value2) && value2.nodeType === 1 && !isPlainObject2(value2);
      }
      function isEmpty(value2) {
        if (value2 == null) {
          return true;
        }
        if (isArrayLike2(value2) && (isArray2(value2) || typeof value2 == "string" || typeof value2.splice == "function" || isBuffer2(value2) || isTypedArray2(value2) || isArguments2(value2))) {
          return !value2.length;
        }
        var tag = getTag2(value2);
        if (tag == mapTag2 || tag == setTag2) {
          return !value2.size;
        }
        if (isPrototype2(value2)) {
          return !baseKeys2(value2).length;
        }
        for (var key in value2) {
          if (hasOwnProperty2.call(value2, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual(value2, other) {
        return baseIsEqual2(value2, other);
      }
      function isEqualWith(value2, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result3 = customizer ? customizer(value2, other) : undefined$1;
        return result3 === undefined$1 ? baseIsEqual2(value2, other, undefined$1, customizer) : !!result3;
      }
      function isError(value2) {
        if (!isObjectLike2(value2)) {
          return false;
        }
        var tag = baseGetTag2(value2);
        return tag == errorTag2 || tag == domExcTag || typeof value2.message == "string" && typeof value2.name == "string" && !isPlainObject2(value2);
      }
      function isFinite2(value2) {
        return typeof value2 == "number" && nativeIsFinite(value2);
      }
      function isFunction2(value2) {
        if (!isObject3(value2)) {
          return false;
        }
        var tag = baseGetTag2(value2);
        return tag == funcTag2 || tag == genTag2 || tag == asyncTag2 || tag == proxyTag2;
      }
      function isInteger(value2) {
        return typeof value2 == "number" && value2 == toInteger2(value2);
      }
      function isLength2(value2) {
        return typeof value2 == "number" && value2 > -1 && value2 % 1 == 0 && value2 <= MAX_SAFE_INTEGER2;
      }
      function isObject3(value2) {
        var type4 = typeof value2;
        return value2 != null && (type4 == "object" || type4 == "function");
      }
      function isObjectLike2(value2) {
        return value2 != null && typeof value2 == "object";
      }
      var isMap = nodeIsMap ? baseUnary2(nodeIsMap) : baseIsMap;
      function isMatch(object4, source) {
        return object4 === source || baseIsMatch2(object4, source, getMatchData2(source));
      }
      function isMatchWith(object4, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch2(object4, source, getMatchData2(source), customizer);
      }
      function isNaN2(value2) {
        return isNumber(value2) && value2 != +value2;
      }
      function isNative(value2) {
        if (isMaskable(value2)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative2(value2);
      }
      function isNull(value2) {
        return value2 === null;
      }
      function isNil(value2) {
        return value2 == null;
      }
      function isNumber(value2) {
        return typeof value2 == "number" || isObjectLike2(value2) && baseGetTag2(value2) == numberTag2;
      }
      function isPlainObject2(value2) {
        if (!isObjectLike2(value2) || baseGetTag2(value2) != objectTag2) {
          return false;
        }
        var proto = getPrototype2(value2);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString2.call(Ctor) == objectCtorString2;
      }
      var isRegExp = nodeIsRegExp ? baseUnary2(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value2) {
        return isInteger(value2) && value2 >= -MAX_SAFE_INTEGER2 && value2 <= MAX_SAFE_INTEGER2;
      }
      var isSet = nodeIsSet ? baseUnary2(nodeIsSet) : baseIsSet;
      function isString(value2) {
        return typeof value2 == "string" || !isArray2(value2) && isObjectLike2(value2) && baseGetTag2(value2) == stringTag2;
      }
      function isSymbol2(value2) {
        return typeof value2 == "symbol" || isObjectLike2(value2) && baseGetTag2(value2) == symbolTag2;
      }
      var isTypedArray2 = nodeIsTypedArray2 ? baseUnary2(nodeIsTypedArray2) : baseIsTypedArray2;
      function isUndefined(value2) {
        return value2 === undefined$1;
      }
      function isWeakMap(value2) {
        return isObjectLike2(value2) && getTag2(value2) == weakMapTag2;
      }
      function isWeakSet(value2) {
        return isObjectLike2(value2) && baseGetTag2(value2) == weakSetTag;
      }
      var lt2 = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value2, other) {
        return value2 <= other;
      });
      function toArray2(value2) {
        if (!value2) {
          return [];
        }
        if (isArrayLike2(value2)) {
          return isString(value2) ? stringToArray2(value2) : copyArray2(value2);
        }
        if (symIterator && value2[symIterator]) {
          return iteratorToArray(value2[symIterator]());
        }
        var tag = getTag2(value2), func = tag == mapTag2 ? mapToArray2 : tag == setTag2 ? setToArray2 : values2;
        return func(value2);
      }
      function toFinite(value2) {
        if (!value2) {
          return value2 === 0 ? value2 : 0;
        }
        value2 = toNumber2(value2);
        if (value2 === INFINITY2 || value2 === -INFINITY2) {
          var sign = value2 < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value2 === value2 ? value2 : 0;
      }
      function toInteger2(value2) {
        var result3 = toFinite(value2), remainder = result3 % 1;
        return result3 === result3 ? remainder ? result3 - remainder : result3 : 0;
      }
      function toLength(value2) {
        return value2 ? baseClamp(toInteger2(value2), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber2(value2) {
        if (typeof value2 == "number") {
          return value2;
        }
        if (isSymbol2(value2)) {
          return NAN2;
        }
        if (isObject3(value2)) {
          var other = typeof value2.valueOf == "function" ? value2.valueOf() : value2;
          value2 = isObject3(other) ? other + "" : other;
        }
        if (typeof value2 != "string") {
          return value2 === 0 ? value2 : +value2;
        }
        value2 = baseTrim2(value2);
        var isBinary = reIsBinary2.test(value2);
        return isBinary || reIsOctal2.test(value2) ? freeParseInt2(value2.slice(2), isBinary ? 2 : 8) : reIsBadHex2.test(value2) ? NAN2 : +value2;
      }
      function toPlainObject2(value2) {
        return copyObject2(value2, keysIn2(value2));
      }
      function toSafeInteger(value2) {
        return value2 ? baseClamp(toInteger2(value2), -MAX_SAFE_INTEGER2, MAX_SAFE_INTEGER2) : value2 === 0 ? value2 : 0;
      }
      function toString2(value2) {
        return value2 == null ? "" : baseToString2(value2);
      }
      var assign2 = createAssigner2(function(object4, source) {
        if (isPrototype2(source) || isArrayLike2(source)) {
          copyObject2(source, keys2(source), object4);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty2.call(source, key)) {
            assignValue2(object4, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner2(function(object4, source) {
        copyObject2(source, keysIn2(source), object4);
      });
      var assignInWith = createAssigner2(function(object4, source, srcIndex, customizer) {
        copyObject2(source, keysIn2(source), object4, customizer);
      });
      var assignWith = createAssigner2(function(object4, source, srcIndex, customizer) {
        copyObject2(source, keys2(source), object4, customizer);
      });
      var at2 = flatRest(baseAt);
      function create(prototype, properties2) {
        var result3 = baseCreate2(prototype);
        return properties2 == null ? result3 : baseAssign(result3, properties2);
      }
      var defaults2 = baseRest2(function(object4, sources) {
        object4 = Object2(object4);
        var index2 = -1;
        var length2 = sources.length;
        var guard = length2 > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall2(sources[0], sources[1], guard)) {
          length2 = 1;
        }
        while (++index2 < length2) {
          var source = sources[index2];
          var props = keysIn2(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value2 = object4[key];
            if (value2 === undefined$1 || eq2(value2, objectProto2[key]) && !hasOwnProperty2.call(object4, key)) {
              object4[key] = source[key];
            }
          }
        }
        return object4;
      });
      var defaultsDeep = baseRest2(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply2(mergeWith, undefined$1, args);
      });
      function findKey2(object4, predicate) {
        return baseFindKey(object4, getIteratee(predicate, 3), baseForOwn2);
      }
      function findLastKey(object4, predicate) {
        return baseFindKey(object4, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object4, iteratee2) {
        return object4 == null ? object4 : baseFor2(object4, getIteratee(iteratee2, 3), keysIn2);
      }
      function forInRight(object4, iteratee2) {
        return object4 == null ? object4 : baseForRight(object4, getIteratee(iteratee2, 3), keysIn2);
      }
      function forOwn(object4, iteratee2) {
        return object4 && baseForOwn2(object4, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object4, iteratee2) {
        return object4 && baseForOwnRight(object4, getIteratee(iteratee2, 3));
      }
      function functions(object4) {
        return object4 == null ? [] : baseFunctions(object4, keys2(object4));
      }
      function functionsIn(object4) {
        return object4 == null ? [] : baseFunctions(object4, keysIn2(object4));
      }
      function get2(object4, path, defaultValue) {
        var result3 = object4 == null ? undefined$1 : baseGet2(object4, path);
        return result3 === undefined$1 ? defaultValue : result3;
      }
      function has2(object4, path) {
        return object4 != null && hasPath2(object4, path, baseHas);
      }
      function hasIn2(object4, path) {
        return object4 != null && hasPath2(object4, path, baseHasIn2);
      }
      var invert = createInverter(function(result3, value2, key) {
        if (value2 != null && typeof value2.toString != "function") {
          value2 = nativeObjectToString2.call(value2);
        }
        result3[value2] = key;
      }, constant2(identity2));
      var invertBy = createInverter(function(result3, value2, key) {
        if (value2 != null && typeof value2.toString != "function") {
          value2 = nativeObjectToString2.call(value2);
        }
        if (hasOwnProperty2.call(result3, value2)) {
          result3[value2].push(key);
        } else {
          result3[value2] = [key];
        }
      }, getIteratee);
      var invoke = baseRest2(baseInvoke);
      function keys2(object4) {
        return isArrayLike2(object4) ? arrayLikeKeys2(object4) : baseKeys2(object4);
      }
      function keysIn2(object4) {
        return isArrayLike2(object4) ? arrayLikeKeys2(object4, true) : baseKeysIn2(object4);
      }
      function mapKeys(object4, iteratee2) {
        var result3 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn2(object4, function(value2, key, object5) {
          baseAssignValue2(result3, iteratee2(value2, key, object5), value2);
        });
        return result3;
      }
      function mapValues(object4, iteratee2) {
        var result3 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn2(object4, function(value2, key, object5) {
          baseAssignValue2(result3, key, iteratee2(value2, key, object5));
        });
        return result3;
      }
      var merge2 = createAssigner2(function(object4, source, srcIndex) {
        baseMerge2(object4, source, srcIndex);
      });
      var mergeWith = createAssigner2(function(object4, source, srcIndex, customizer) {
        baseMerge2(object4, source, srcIndex, customizer);
      });
      var omit2 = flatRest(function(object4, paths) {
        var result3 = {};
        if (object4 == null) {
          return result3;
        }
        var isDeep = false;
        paths = arrayMap2(paths, function(path) {
          path = castPath2(path, object4);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject2(object4, getAllKeysIn(object4), result3);
        if (isDeep) {
          result3 = baseClone(result3, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length2 = paths.length;
        while (length2--) {
          baseUnset(result3, paths[length2]);
        }
        return result3;
      });
      function omitBy(object4, predicate) {
        return pickBy(object4, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function(object4, paths) {
        return object4 == null ? {} : basePick(object4, paths);
      });
      function pickBy(object4, predicate) {
        if (object4 == null) {
          return {};
        }
        var props = arrayMap2(getAllKeysIn(object4), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object4, props, function(value2, path) {
          return predicate(value2, path[0]);
        });
      }
      function result2(object4, path, defaultValue) {
        path = castPath2(path, object4);
        var index2 = -1, length2 = path.length;
        if (!length2) {
          length2 = 1;
          object4 = undefined$1;
        }
        while (++index2 < length2) {
          var value2 = object4 == null ? undefined$1 : object4[toKey2(path[index2])];
          if (value2 === undefined$1) {
            index2 = length2;
            value2 = defaultValue;
          }
          object4 = isFunction2(value2) ? value2.call(object4) : value2;
        }
        return object4;
      }
      function set2(object4, path, value2) {
        return object4 == null ? object4 : baseSet(object4, path, value2);
      }
      function setWith(object4, path, value2, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object4 == null ? object4 : baseSet(object4, path, value2, customizer);
      }
      var toPairs = createToPairs(keys2);
      var toPairsIn = createToPairs(keysIn2);
      function transform(object4, iteratee2, accumulator) {
        var isArr = isArray2(object4), isArrLike = isArr || isBuffer2(object4) || isTypedArray2(object4);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object4 && object4.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject3(object4)) {
            accumulator = isFunction2(Ctor) ? baseCreate2(getPrototype2(object4)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn2)(object4, function(value2, index2, object5) {
          return iteratee2(accumulator, value2, index2, object5);
        });
        return accumulator;
      }
      function unset(object4, path) {
        return object4 == null ? true : baseUnset(object4, path);
      }
      function update(object4, path, updater) {
        return object4 == null ? object4 : baseUpdate(object4, path, castFunction(updater));
      }
      function updateWith(object4, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object4 == null ? object4 : baseUpdate(object4, path, castFunction(updater), customizer);
      }
      function values2(object4) {
        return object4 == null ? [] : baseValues(object4, keys2(object4));
      }
      function valuesIn(object4) {
        return object4 == null ? [] : baseValues(object4, keysIn2(object4));
      }
      function clamp(number4, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber2(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber2(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber2(number4), lower, upper);
      }
      function inRange(number4, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number4 = toNumber2(number4);
        return baseInRange(number4, start, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall2(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin2(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase2 = createCompounder2(function(result3, word, index2) {
        word = word.toLowerCase();
        return result3 + (index2 ? capitalize2(word) : word);
      });
      function capitalize2(string3) {
        return upperFirst2(toString2(string3).toLowerCase());
      }
      function deburr2(string3) {
        string3 = toString2(string3);
        return string3 && string3.replace(reLatin2, deburrLetter2).replace(reComboMark2, "");
      }
      function endsWith(string3, target, position) {
        string3 = toString2(string3);
        target = baseToString2(target);
        var length2 = string3.length;
        position = position === undefined$1 ? length2 : baseClamp(toInteger2(position), 0, length2);
        var end = position;
        position -= target.length;
        return position >= 0 && string3.slice(position, end) == target;
      }
      function escape2(string3) {
        string3 = toString2(string3);
        return string3 && reHasUnescapedHtml.test(string3) ? string3.replace(reUnescapedHtml, escapeHtmlChar) : string3;
      }
      function escapeRegExp(string3) {
        string3 = toString2(string3);
        return string3 && reHasRegExpChar.test(string3) ? string3.replace(reRegExpChar2, "\\$&") : string3;
      }
      var kebabCase2 = createCompounder2(function(result3, word, index2) {
        return result3 + (index2 ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder2(function(result3, word, index2) {
        return result3 + (index2 ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst2("toLowerCase");
      function pad(string3, length2, chars) {
        string3 = toString2(string3);
        length2 = toInteger2(length2);
        var strLength = length2 ? stringSize(string3) : 0;
        if (!length2 || strLength >= length2) {
          return string3;
        }
        var mid = (length2 - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string3 + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string3, length2, chars) {
        string3 = toString2(string3);
        length2 = toInteger2(length2);
        var strLength = length2 ? stringSize(string3) : 0;
        return length2 && strLength < length2 ? string3 + createPadding(length2 - strLength, chars) : string3;
      }
      function padStart(string3, length2, chars) {
        string3 = toString2(string3);
        length2 = toInteger2(length2);
        var strLength = length2 ? stringSize(string3) : 0;
        return length2 && strLength < length2 ? createPadding(length2 - strLength, chars) + string3 : string3;
      }
      function parseInt2(string3, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString2(string3).replace(reTrimStart2, ""), radix || 0);
      }
      function repeat2(string3, n2, guard) {
        if (guard ? isIterateeCall2(string3, n2, guard) : n2 === undefined$1) {
          n2 = 1;
        } else {
          n2 = toInteger2(n2);
        }
        return baseRepeat(toString2(string3), n2);
      }
      function replace() {
        var args = arguments, string3 = toString2(args[0]);
        return args.length < 3 ? string3 : string3.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder2(function(result3, word, index2) {
        return result3 + (index2 ? "_" : "") + word.toLowerCase();
      });
      function split(string3, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall2(string3, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string3 = toString2(string3);
        if (string3 && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
          separator = baseToString2(separator);
          if (!separator && hasUnicode2(string3)) {
            return castSlice2(stringToArray2(string3), 0, limit);
          }
        }
        return string3.split(separator, limit);
      }
      var startCase = createCompounder2(function(result3, word, index2) {
        return result3 + (index2 ? " " : "") + upperFirst2(word);
      });
      function startsWith2(string3, target, position) {
        string3 = toString2(string3);
        position = position == null ? 0 : baseClamp(toInteger2(position), 0, string3.length);
        target = baseToString2(target);
        return string3.slice(position, position + target.length) == target;
      }
      function template(string3, options, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall2(string3, options, guard)) {
          options = undefined$1;
        }
        string3 = toString2(string3);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys2(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
        var reDelimiters = RegExp2((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
        var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string3.replace(reDelimiters, function(match2, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string3.slice(index2, offset).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index2 = offset + match2.length;
          return match2;
        });
        source += "';\n";
        var variable2 = hasOwnProperty2.call(options, "variable") && options.variable;
        if (!variable2) {
          source = "with (obj) {\n" + source + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable2)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source = "function(" + (variable2 || "obj") + ") {\n" + (variable2 ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
        var result3 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
        });
        result3.source = source;
        if (isError(result3)) {
          throw result3;
        }
        return result3;
      }
      function toLower(value2) {
        return toString2(value2).toLowerCase();
      }
      function toUpper(value2) {
        return toString2(value2).toUpperCase();
      }
      function trim(string3, chars, guard) {
        string3 = toString2(string3);
        if (string3 && (guard || chars === undefined$1)) {
          return baseTrim2(string3);
        }
        if (!string3 || !(chars = baseToString2(chars))) {
          return string3;
        }
        var strSymbols = stringToArray2(string3), chrSymbols = stringToArray2(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice2(strSymbols, start, end).join("");
      }
      function trimEnd(string3, chars, guard) {
        string3 = toString2(string3);
        if (string3 && (guard || chars === undefined$1)) {
          return string3.slice(0, trimmedEndIndex2(string3) + 1);
        }
        if (!string3 || !(chars = baseToString2(chars))) {
          return string3;
        }
        var strSymbols = stringToArray2(string3), end = charsEndIndex(strSymbols, stringToArray2(chars)) + 1;
        return castSlice2(strSymbols, 0, end).join("");
      }
      function trimStart(string3, chars, guard) {
        string3 = toString2(string3);
        if (string3 && (guard || chars === undefined$1)) {
          return string3.replace(reTrimStart2, "");
        }
        if (!string3 || !(chars = baseToString2(chars))) {
          return string3;
        }
        var strSymbols = stringToArray2(string3), start = charsStartIndex(strSymbols, stringToArray2(chars));
        return castSlice2(strSymbols, start).join("");
      }
      function truncate(string3, options) {
        var length2 = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject3(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length2 = "length" in options ? toInteger2(options.length) : length2;
          omission = "omission" in options ? baseToString2(options.omission) : omission;
        }
        string3 = toString2(string3);
        var strLength = string3.length;
        if (hasUnicode2(string3)) {
          var strSymbols = stringToArray2(string3);
          strLength = strSymbols.length;
        }
        if (length2 >= strLength) {
          return string3;
        }
        var end = length2 - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result3 = strSymbols ? castSlice2(strSymbols, 0, end).join("") : string3.slice(0, end);
        if (separator === undefined$1) {
          return result3 + omission;
        }
        if (strSymbols) {
          end += result3.length - end;
        }
        if (isRegExp(separator)) {
          if (string3.slice(end).search(separator)) {
            var match2, substring = result3;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString2(reFlags.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match2 = separator.exec(substring)) {
              var newEnd = match2.index;
            }
            result3 = result3.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string3.indexOf(baseToString2(separator), end) != end) {
          var index2 = result3.lastIndexOf(separator);
          if (index2 > -1) {
            result3 = result3.slice(0, index2);
          }
        }
        return result3 + omission;
      }
      function unescape2(string3) {
        string3 = toString2(string3);
        return string3 && reHasEscapedHtml.test(string3) ? string3.replace(reEscapedHtml, unescapeHtmlChar) : string3;
      }
      var upperCase = createCompounder2(function(result3, word, index2) {
        return result3 + (index2 ? " " : "") + word.toUpperCase();
      });
      var upperFirst2 = createCaseFirst2("toUpperCase");
      function words2(string3, pattern4, guard) {
        string3 = toString2(string3);
        pattern4 = guard ? undefined$1 : pattern4;
        if (pattern4 === undefined$1) {
          return hasUnicodeWord2(string3) ? unicodeWords2(string3) : asciiWords2(string3);
        }
        return string3.match(pattern4) || [];
      }
      var attempt = baseRest2(function(func, args) {
        try {
          return apply2(func, undefined$1, args);
        } catch (e25) {
          return isError(e25) ? e25 : new Error2(e25);
        }
      });
      var bindAll = flatRest(function(object4, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey2(key);
          baseAssignValue2(object4, key, bind(object4[key], object4));
        });
        return object4;
      });
      function cond(pairs) {
        var length2 = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length2 ? [] : arrayMap2(pairs, function(pair2) {
          if (typeof pair2[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          return [toIteratee(pair2[0]), pair2[1]];
        });
        return baseRest2(function(args) {
          var index2 = -1;
          while (++index2 < length2) {
            var pair2 = pairs[index2];
            if (apply2(pair2[0], this, args)) {
              return apply2(pair2[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }
      function constant2(value2) {
        return function() {
          return value2;
        };
      }
      function defaultTo(value2, defaultValue) {
        return value2 == null || value2 !== value2 ? defaultValue : value2;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity2(value2) {
        return value2;
      }
      function iteratee(func) {
        return baseIteratee2(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches(source) {
        return baseMatches2(baseClone(source, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty2(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method4 = baseRest2(function(path, args) {
        return function(object4) {
          return baseInvoke(object4, path, args);
        };
      });
      var methodOf = baseRest2(function(object4, args) {
        return function(path) {
          return baseInvoke(object4, path, args);
        };
      });
      function mixin(object4, source, options) {
        var props = keys2(source), methodNames = baseFunctions(source, props);
        if (options == null && !(isObject3(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object4;
          object4 = this;
          methodNames = baseFunctions(source, keys2(source));
        }
        var chain2 = !(isObject3(options) && "chain" in options) || !!options.chain, isFunc = isFunction2(object4);
        arrayEach(methodNames, function(methodName) {
          var func = source[methodName];
          object4[methodName] = func;
          if (isFunc) {
            object4.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result3 = object4(this.__wrapped__), actions = result3.__actions__ = copyArray2(this.__actions__);
                actions.push({ "func": func, "args": arguments, "thisArg": object4 });
                result3.__chain__ = chainAll;
                return result3;
              }
              return func.apply(object4, arrayPush2([this.value()], arguments));
            };
          }
        });
        return object4;
      }
      function noConflict() {
        if (root2._ === this) {
          root2._ = oldDash;
        }
        return this;
      }
      function noop2() {
      }
      function nthArg(n2) {
        n2 = toInteger2(n2);
        return baseRest2(function(args) {
          return baseNth(args, n2);
        });
      }
      var over = createOver(arrayMap2);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome2);
      function property2(path) {
        return isKey2(path) ? baseProperty2(toKey2(path)) : basePropertyDeep2(path);
      }
      function propertyOf(object4) {
        return function(path) {
          return object4 == null ? undefined$1 : baseGet2(object4, path);
        };
      }
      var range3 = createRange2();
      var rangeRight = createRange2(true);
      function stubArray2() {
        return [];
      }
      function stubFalse2() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n2, iteratee2) {
        n2 = toInteger2(n2);
        if (n2 < 1 || n2 > MAX_SAFE_INTEGER2) {
          return [];
        }
        var index2 = MAX_ARRAY_LENGTH, length2 = nativeMin2(n2, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n2 -= MAX_ARRAY_LENGTH;
        var result3 = baseTimes2(length2, iteratee2);
        while (++index2 < n2) {
          iteratee2(index2);
        }
        return result3;
      }
      function toPath(value2) {
        if (isArray2(value2)) {
          return arrayMap2(value2, toKey2);
        }
        return isSymbol2(value2) ? [value2] : copyArray2(stringToPath2(toString2(value2)));
      }
      function uniqueId(prefix2) {
        var id2 = ++idCounter;
        return toString2(prefix2) + id2;
      }
      var add2 = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max(array4) {
        return array4 && array4.length ? baseExtremum(array4, identity2, baseGt) : undefined$1;
      }
      function maxBy(array4, iteratee2) {
        return array4 && array4.length ? baseExtremum(array4, getIteratee(iteratee2, 2), baseGt) : undefined$1;
      }
      function mean(array4) {
        return baseMean(array4, identity2);
      }
      function meanBy(array4, iteratee2) {
        return baseMean(array4, getIteratee(iteratee2, 2));
      }
      function min(array4) {
        return array4 && array4.length ? baseExtremum(array4, identity2, baseLt) : undefined$1;
      }
      function minBy(array4, iteratee2) {
        return array4 && array4.length ? baseExtremum(array4, getIteratee(iteratee2, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round = createRound("round");
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array4) {
        return array4 && array4.length ? baseSum(array4, identity2) : 0;
      }
      function sumBy(array4, iteratee2) {
        return array4 && array4.length ? baseSum(array4, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign2;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at2;
      lodash2.before = before;
      lodash2.bind = bind;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant2;
      lodash2.countBy = countBy;
      lodash2.create = create;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce2;
      lodash2.defaults = defaults2;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten2;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip;
      lodash2.flow = flow;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys2;
      lodash2.keysIn = keysIn2;
      lodash2.map = map2;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues;
      lodash2.matches = matches;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize2;
      lodash2.merge = merge2;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method4;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit2;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick;
      lodash2.pickBy = pickBy;
      lodash2.property = property2;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range3;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove2;
      lodash2.rest = rest;
      lodash2.reverse = reverse;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set2;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split;
      lodash2.spread = spread;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle2;
      lodash2.thru = thru;
      lodash2.toArray = toArray2;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject2;
      lodash2.transform = transform;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update;
      lodash2.updateWith = updateWith;
      lodash2.values = values2;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words2;
      lodash2.wrap = wrap;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add2;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase2;
      lodash2.capitalize = capitalize2;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp;
      lodash2.clone = clone;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr2;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith;
      lodash2.eq = eq2;
      lodash2.escape = escape2;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find2;
      lodash2.findIndex = findIndex2;
      lodash2.findKey = findKey2;
      lodash2.findLast = findLast2;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get2;
      lodash2.gt = gt2;
      lodash2.gte = gte;
      lodash2.has = has2;
      lodash2.hasIn = hasIn2;
      lodash2.head = head;
      lodash2.identity = identity2;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments2;
      lodash2.isArray = isArray2;
      lodash2.isArrayBuffer = isArrayBuffer;
      lodash2.isArrayLike = isArrayLike2;
      lodash2.isArrayLikeObject = isArrayLikeObject2;
      lodash2.isBoolean = isBoolean;
      lodash2.isBuffer = isBuffer2;
      lodash2.isDate = isDate2;
      lodash2.isElement = isElement2;
      lodash2.isEmpty = isEmpty;
      lodash2.isEqual = isEqual;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError;
      lodash2.isFinite = isFinite2;
      lodash2.isFunction = isFunction2;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength2;
      lodash2.isMap = isMap;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil;
      lodash2.isNull = isNull;
      lodash2.isNumber = isNumber;
      lodash2.isObject = isObject3;
      lodash2.isObjectLike = isObjectLike2;
      lodash2.isPlainObject = isPlainObject2;
      lodash2.isRegExp = isRegExp;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet;
      lodash2.isString = isString;
      lodash2.isSymbol = isSymbol2;
      lodash2.isTypedArray = isTypedArray2;
      lodash2.isUndefined = isUndefined;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join;
      lodash2.kebabCase = kebabCase2;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt2;
      lodash2.lte = lte;
      lodash2.max = max;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray2;
      lodash2.stubFalse = stubFalse2;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth2;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop2;
      lodash2.now = now2;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat2;
      lodash2.replace = replace;
      lodash2.result = result2;
      lodash2.round = round;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size2;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith2;
      lodash2.subtract = subtract;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger2;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber2;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString2;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape2;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst2;
      lodash2.each = forEach;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source = {};
        baseForOwn2(lodash2, function(func, methodName) {
          if (!hasOwnProperty2.call(lodash2.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), { "chain": false });
      lodash2.VERSION = VERSION;
      arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach(["drop", "take"], function(methodName, index2) {
        LazyWrapper.prototype[methodName] = function(n2) {
          n2 = n2 === undefined$1 ? 1 : nativeMax2(toInteger2(n2), 0);
          var result3 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
          if (result3.__filtered__) {
            result3.__takeCount__ = nativeMin2(n2, result3.__takeCount__);
          } else {
            result3.__views__.push({
              "size": nativeMin2(n2, MAX_ARRAY_LENGTH),
              "type": methodName + (result3.__dir__ < 0 ? "Right" : "")
            });
          }
          return result3;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n2) {
          return this.reverse()[methodName](n2).reverse();
        };
      });
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
        var type4 = index2 + 1, isFilter = type4 == LAZY_FILTER_FLAG || type4 == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result3 = this.clone();
          result3.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type4
          });
          result3.__filtered__ = result3.__filtered__ || isFilter;
          return result3;
        };
      });
      arrayEach(["head", "last"], function(methodName, index2) {
        var takeName = "take" + (index2 ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(["initial", "tail"], function(methodName, index2) {
        var dropName = "drop" + (index2 ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity2);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest2(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value2) {
          return baseInvoke(value2, path, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start, end) {
        start = toInteger2(start);
        var result3 = this;
        if (result3.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result3);
        }
        if (start < 0) {
          result3 = result3.takeRight(-start);
        } else if (start) {
          result3 = result3.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger2(end);
          result3 = end < 0 ? result3.dropRight(-end) : result3.take(end - start);
        }
        return result3;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn2(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value2 = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value2 instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value2);
          var interceptor = function(value3) {
            var result4 = lodashFunc.apply(lodash2, arrayPush2([value3], args));
            return isTaker && chainAll ? result4[0] : result4;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value2 = onlyLazy ? value2 : new LazyWrapper(this);
            var result3 = func.apply(value2, args);
            result3.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result3, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result3 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result3.value()[0] : result3.value() : result3;
        };
      });
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto2[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value2 = this.value();
            return func.apply(isArray2(value2) ? value2 : [], args);
          }
          return this[chainName](function(value3) {
            return func.apply(isArray2(value3) ? value3 : [], args);
          });
        };
      });
      baseForOwn2(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty2.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _2 = runInContext();
    if (freeModule2) {
      (freeModule2.exports = _2)._ = _2;
      freeExports2._ = _2;
    } else {
      root2._ = _2;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
const getColorFromString = (str) => {
  let hash2 = 0;
  if (str.length == 0)
    return hash2.toString();
  for (let i2 = 0; i2 < str.length; i2++) {
    hash2 = str.charCodeAt(i2) + ((hash2 << 5) - hash2);
    hash2 = hash2 & hash2;
  }
  const shortened = Math.abs(hash2) % 360;
  return "hsl(" + shortened + ",35%, 60%)";
};
const getInitials = (fullName = "") => {
  if (fullName === null || !fullName.trim()) {
    return fullName;
  }
  const names = (fullName != null ? fullName : "").toLocaleUpperCase().split(" ").filter((name2) => name2.trim());
  if (names.length > 1) {
    return names.splice(0, 2).reduce((acc, each) => acc + each[0], "");
  }
  return names[0].slice(0, 2);
};
const getDefaultProps = (styles2 = {}) => ({
  round: true,
  size: 24,
  style: styles2
});
const renderAvatar = (option) => {
  if (option.imageUrl) {
    return h$1(NAvatar, __spreadValues({
      src: option.imageUrl
    }, getDefaultProps()));
  } else {
    return h$1(NAvatar, getDefaultProps({
      backgroundColor: getColorFromString(option.label),
      fontSize: "10px"
    }), {
      default: () => getInitials(option.label)
    });
  }
};
const commonStyles$1 = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  marginLeft: "8px"
};
const renderLabelAsAvatar = (option) => {
  return h$1("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, [
    renderAvatar(option),
    h$1("div", {
      style: commonStyles$1
    }, [
      h$1("p", { style: { margin: 0 } }, [option.label]),
      h$1("span", {
        style: {
          color: "var(--gray-500)"
        }
      }, {
        default: () => option == null ? void 0 : option.description
      })
    ])
  ]);
};
const renderGroupLabel = (option) => {
  return h$1("div", {}, [h$1("span", {}, [option.label])]);
};
const _hoisted_1$v = { class: "flex items-center space-x-1" };
const _hoisted_2$n = {
  key: 0,
  class: "flex items-center"
};
const __default__$16 = defineComponent({
  name: "UITag",
  inheritAttrs: false
});
const _sfc_main$1j = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$16), {
  props: {
    type: {
      type: String,
      default: "default"
    },
    closable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium"
    },
    round: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NTag), mergeProps({
        class: [`hl-${__props.type}`]
      }, _ctx.$attrs, {
        type: __props.type,
        closable: __props.closable,
        size: __props.size,
        round: __props.round
      }), {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$v, [
            unref(slots).icon ? (openBlock(), createElementBlock("div", _hoisted_2$n, [
              renderSlot(_ctx.$slots, "icon")
            ])) : createCommentVNode("", true),
            createElementVNode("div", null, [
              renderSlot(_ctx.$slots, "default")
            ])
          ])
        ]),
        _: 3
      }, 16, ["class", "type", "closable", "size", "round"]);
    };
  }
}));
_sfc_main$1j.install = (Vue) => {
  Vue.component(_sfc_main$1j.name, _sfc_main$1j);
};
const commonStyles = {
  display: "flex",
  alignItems: "center",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "24px"
};
const renderSingleSelectedAsAvatar = ({ option }) => {
  return h$1("div", {
    style: commonStyles
  }, [
    renderAvatar(option),
    h$1("p", { style: { marginLeft: "8px" } }, { default: () => option.label })
  ]);
};
const renderMultipleSelectedAsAvatar = ({
  option,
  handleClose: handleClose2
}) => {
  return h$1(_sfc_main$1j, {
    style: {
      padding: "0 6px 0 4px"
    },
    round: true,
    closable: true,
    onClose: (e25) => {
      e25.stopPropagation();
      handleClose2();
    }
  }, {
    default: () => h$1("div", {
      style: commonStyles
    }, [
      renderAvatar(option),
      h$1("p", { style: { marginLeft: "8px" } }, { default: () => option.label })
    ])
  });
};
const __default__$15 = defineComponent({
  name: "UISelect",
  inheritAttrs: false
});
const _sfc_main$1i = defineComponent(__spreadProps(__spreadValues({}, __default__$15), {
  props: {
    id: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    },
    multiple: {
      type: Boolean,
      default: void 0
    },
    filterable: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: void 0
    },
    clearable: {
      type: Boolean,
      default: false
    },
    remote: {
      type: Boolean,
      default: void 0
    },
    tag: {
      type: Boolean,
      default: void 0
    },
    type: {
      type: String,
      default: "default"
    },
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "large"
    },
    maxTagCount: {
      type: Number,
      default: void 0
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String
    },
    value: {
      type: [String, Array]
    }
  },
  emits: ["search", "update:value", "scroll"],
  setup(__props) {
    const props = __props;
    const renderAvatarLabel = (option, selected) => {
      var _a2;
      const labelType = (_a2 = option.type) != null ? _a2 : props.type;
      switch (labelType) {
        case "avatar":
        default: {
          return renderLabelAsAvatar(option);
        }
        case "group": {
          return renderGroupLabel(option);
        }
      }
    };
    const selectedValueRenderer = computed(() => {
      switch (props.type) {
        case "avatar": {
          if (props.multiple) {
            return renderMultipleSelectedAsAvatar;
          }
          return renderSingleSelectedAsAvatar;
        }
        case "default":
        default: {
          return void 0;
        }
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NSelect), mergeProps({
        "reset-menu-on-options-change": __props.resetMenuOnOptionsChange,
        onScroll: _cache[0] || (_cache[0] = (e25) => _ctx.$emit("scroll", e25)),
        "render-label": __props.type === "avatar" ? renderAvatarLabel : void 0,
        "render-tag": unref(selectedValueRenderer),
        id: __props.id
      }, _ctx.$attrs, {
        placeholder: __props.placeholder,
        options: __props.options,
        disabled: __props.disabled,
        value: __props.value,
        class: "hl-select",
        filterable: __props.filterable,
        show: __props.show,
        multiple: __props.multiple,
        loading: __props.loading,
        clearable: __props.clearable,
        remote: __props.remote,
        tag: __props.tag,
        onSearch: _cache[1] || (_cache[1] = (value2) => _ctx.$emit("search", value2)),
        "onUpdate:value": _cache[2] || (_cache[2] = (value2, option) => _ctx.$emit("update:value", value2, option)),
        "max-tag-count": __props.maxTagCount,
        size: __props.size
      }), {
        action: withCtx(() => [
          renderSlot(_ctx.$slots, "action")
        ]),
        arrow: withCtx(() => [
          renderSlot(_ctx.$slots, "arrow")
        ]),
        empty: withCtx(() => [
          renderSlot(_ctx.$slots, "empty")
        ]),
        _: 3
      }, 16, ["reset-menu-on-options-change", "render-label", "render-tag", "id", "placeholder", "options", "disabled", "value", "filterable", "show", "multiple", "loading", "clearable", "remote", "tag", "max-tag-count", "size"]);
    };
  }
}));
_sfc_main$1i.install = (Vue) => {
  Vue.component(_sfc_main$1i.name, _sfc_main$1i);
};
var DisplaySmMedium_vue_vue_type_style_index_0_lang = "";
const __default__$14 = defineComponent({
  name: "UIDisplaySmMedium",
  inheritAttrs: false
});
const _sfc_main$1h = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$14), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "hl-display-sm-medium" }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
var TextLgMedium_vue_vue_type_style_index_0_lang = "";
const __default__$13 = defineComponent({
  name: "UITextLgMedium",
  inheritAttrs: false
});
const _sfc_main$1g = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$13), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "hl-text-lg-medium" }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
var TextSmNormal_vue_vue_type_style_index_0_lang = "";
const __default__$12 = defineComponent({
  name: "UITextSmNormal",
  inheritAttrs: false
});
const _sfc_main$1f = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$12), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "hl-text-sm-normal" }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
var TextSmMedium_vue_vue_type_style_index_0_lang = "";
const __default__$11 = defineComponent({
  name: "UITextSmNormal",
  inheritAttrs: false
});
const _sfc_main$1e = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$11), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "hl-text-sm-medium" }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
var TextXsMedium_vue_vue_type_style_index_0_lang = "";
const __default__$10 = defineComponent({
  name: "UITextXsMedium",
  inheritAttrs: false
});
const _sfc_main$1d = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$10), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "hl-text-xs-medium" }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
var TextXsRegular_vue_vue_type_style_index_0_lang = "";
const __default__$$ = defineComponent({
  name: "UITextXsRegular",
  inheritAttrs: false
});
const _sfc_main$1c = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$$), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "hl-text-xs-regular" }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
var TextMdMedium_vue_vue_type_style_index_0_lang = "";
const __default__$_ = defineComponent({
  name: "UITextMdMedium",
  inheritAttrs: false
});
const _sfc_main$1b = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$_), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "hl-text-md-medium" }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
var TextMdNormal_vue_vue_type_style_index_0_lang = "";
const __default__$Z = defineComponent({
  name: "UITextMdNormal",
  inheritAttrs: false
});
const _sfc_main$1a = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$Z), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "hl-text-md-normal" }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
var DisplaySmSemibold_vue_vue_type_style_index_0_lang = "";
const __default__$Y = defineComponent({
  name: "UIDisplaySmSemibold",
  inheritAttrs: false
});
const _sfc_main$19 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$Y), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "hl-display-sm-semibold" }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
var TextSmRegular_vue_vue_type_style_index_0_lang = "";
const __default__$X = defineComponent({
  name: "UITextSmRegular",
  inheritAttrs: false
});
const _sfc_main$18 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$X), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "hl-text-sm-regular" }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
_sfc_main$1h.install = (Vue) => {
  Vue.component(_sfc_main$1h.name, _sfc_main$1h);
  Vue.component(_sfc_main$1g.name, _sfc_main$1g);
  Vue.component(_sfc_main$1f.name, _sfc_main$1f);
  Vue.component(_sfc_main$1e.name, _sfc_main$1e);
  Vue.component(_sfc_main$1d.name, _sfc_main$1d);
  Vue.component(_sfc_main$1b.name, _sfc_main$1b);
  Vue.component(_sfc_main$1a.name, _sfc_main$1a);
  Vue.component(_sfc_main$19.name, _sfc_main$19);
  Vue.component(_sfc_main$18.name, _sfc_main$18);
  Vue.component(_sfc_main$1c.name, _sfc_main$1c);
};
const _hoisted_1$u = { class: "mr-1" };
const _hoisted_2$m = { class: "flex items-center justify-between w-60 filter-heading" };
const _hoisted_3$k = { class: "flex items-center text-primary-600 space-x-2 actions" };
defineComponent({
  name: "UIFilter"
});
const _sfc_main$17 = /* @__PURE__ */ defineComponent({
  __name: "FilterDropdown",
  props: {
    collapseItems: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: true
    }
  },
  emits: ["update:filter"],
  setup(__props, { emit }) {
    const props = __props;
    const filterUpdates = ref();
    const filters = ref([]);
    const popoverRef = ref();
    const selectedFilter = ref({});
    const filterCount = ref(0);
    watch(() => props.options, (value2) => {
      filters.value = value2;
    }, {
      immediate: true
    });
    function generateOptions(collapseItem) {
      const items = filters.value.find((x2) => collapseItem.key === x2.key);
      if (items)
        return (items == null ? void 0 : items.options) || [];
      return [];
    }
    function selectedOption(collapseItem) {
      const items = filters.value.find((x2) => collapseItem.key === x2.key);
      if (items)
        return (items == null ? void 0 : items.value) || "";
      return [];
    }
    function onOptionSelect(value2, collapseItem) {
      const clonedOptions = lodash.exports.cloneDeep(filters.value);
      clonedOptions.forEach((x2) => {
        if (x2.key === collapseItem.key)
          x2.value = value2;
        return x2;
      });
      filters.value = clonedOptions;
      filterUpdates.value = lodash.exports.cloneDeep(clonedOptions).map((x2) => {
        delete x2.options;
        return x2;
      });
      selectedFilter.value[collapseItem.key] = value2;
    }
    function clearAll() {
      filters.value = props.options;
      filterUpdates.value = {};
      selectedFilter.value = {};
      calculateCountsAndEmit();
      closePopup();
    }
    function calculateCountsAndEmit() {
      filterCount.value = 0;
      for (const key in selectedFilter.value) {
        const val = selectedFilter.value[key];
        const initialValue = props.options.find((x2) => x2.key === key);
        if (initialValue.key === key && initialValue.value !== val) {
          filterCount.value += 1;
        }
      }
      emit("update:filter", {
        filters: filterUpdates.value,
        options: filters.value
      });
    }
    function ApplyAll() {
      calculateCountsAndEmit();
      closePopup();
    }
    function closePopup() {
      popoverRef.value.handleClick();
    }
    const locales = inject("customLocale");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NPopover), {
        trigger: "click",
        "show-arrow": false,
        ref_key: "popoverRef",
        ref: popoverRef,
        placement: "bottom"
      }, {
        trigger: withCtx(() => [
          createVNode(unref(_sfc_main$1l), {
            size: "large",
            class: "hl-table-filter-btn",
            id: ""
          }, {
            default: withCtx(() => {
              var _a2;
              return [
                createVNode(unref(render$3$), { class: "w-5 h-5 mr-1" }),
                createElementVNode("span", _hoisted_1$u, toDisplayString((_a2 = unref(locales).DataTable.filters) != null ? _a2 : "Filters"), 1),
                createVNode(unref(NBadge), {
                  class: "badge",
                  value: filterCount.value,
                  color: "#F2F4F7"
                }, null, 8, ["value"])
              ];
            }),
            _: 1
          })
        ]),
        header: withCtx(() => [
          createElementVNode("div", _hoisted_2$m, [
            createVNode(unref(_sfc_main$1e), { class: "title text-gray-900" }, {
              default: withCtx(() => {
                var _a2;
                return [
                  createTextVNode(toDisplayString((_a2 = unref(locales).DataTable.filters) != null ? _a2 : "Filters"), 1)
                ];
              }),
              _: 1
            }),
            createElementVNode("div", _hoisted_3$k, [
              createVNode(unref(_sfc_main$1l), {
                text: "",
                onClick: clearAll,
                id: `hl-table-${__props.id}-filter-clear`
              }, {
                default: withCtx(() => {
                  var _a2;
                  return [
                    createTextVNode(toDisplayString((_a2 = unref(locales).DataTable.clear) != null ? _a2 : "Clear"), 1)
                  ];
                }),
                _: 1
              }, 8, ["id"]),
              createVNode(unref(_sfc_main$1l), {
                text: "",
                onClick: ApplyAll,
                id: `hl-table-${__props.id}-filter-apply`
              }, {
                default: withCtx(() => {
                  var _a2;
                  return [
                    createTextVNode(toDisplayString((_a2 = unref(locales).DataTable.apply) != null ? _a2 : "Apply"), 1)
                  ];
                }),
                _: 1
              }, 8, ["id"])
            ])
          ])
        ]),
        default: withCtx(() => [
          createVNode(unref(NCollapse), null, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(__props.collapseItems, (item) => {
                return openBlock(), createBlock(unref(NCollapseItem), {
                  title: item.label,
                  name: item.key,
                  key: item.key
                }, {
                  default: withCtx(() => [
                    createVNode(unref(_sfc_main$1i), {
                      options: generateOptions(item),
                      value: selectedOption(item),
                      id: __props.id,
                      "onUpdate:value": (val) => onOptionSelect(val, item)
                    }, null, 8, ["options", "value", "id", "onUpdate:value"])
                  ]),
                  _: 2
                }, 1032, ["title", "name"]);
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512);
    };
  }
});
_sfc_main$17.install = (Vue) => {
  Vue.component(_sfc_main$17.name, _sfc_main$17);
};
const __default__$W = defineComponent({
  name: "UIInput"
});
const _sfc_main$16 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$W), {
  props: {
    id: {
      type: String,
      required: true
    },
    modelValue: {
      type: [String, Array],
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: { type: String, default: void 0 },
    readonly: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 3
    },
    maxlength: Number,
    minlength: Number,
    loading: {
      type: Boolean
    },
    autosize: {
      type: [Boolean, Object]
    },
    clearable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "large"
    },
    showCount: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["update:modelValue", "onBlur", "onChange"],
  setup(__props, { emit }) {
    function emitValueUpdate(value2) {
      emit("update:modelValue", value2);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NInput), mergeProps(_ctx.$attrs, {
        id: __props.id,
        clearable: __props.clearable,
        disabled: __props.disabled,
        loading: __props.loading,
        maxlength: __props.maxlength,
        minlength: __props.minlength,
        placeholder: __props.placeholder,
        readonly: __props.readonly,
        rows: __props.rows,
        "show-count": __props.showCount,
        size: __props.size,
        type: __props.type,
        value: __props.modelValue,
        autosize: __props.autosize,
        "onUpdate:value": emitValueUpdate,
        onOnBlur: _cache[0] || (_cache[0] = (val) => _ctx.$emit("onBlur", val)),
        onOnChange: _cache[1] || (_cache[1] = (val) => _ctx.$emit("onChange", val)),
        class: "hl-input-text font-sans"
      }), {
        prefix: withCtx(() => [
          renderSlot(_ctx.$slots, "prefix")
        ]),
        suffix: withCtx(() => [
          renderSlot(_ctx.$slots, "suffix")
        ]),
        _: 3
      }, 16, ["id", "clearable", "disabled", "loading", "maxlength", "minlength", "placeholder", "readonly", "rows", "show-count", "size", "type", "value", "autosize"]);
    };
  }
}));
const __default__$V = defineComponent({
  name: "UIInputGroup",
  inheritAttrs: false
});
const _sfc_main$15 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$V), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NInputGroup), null, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      });
    };
  }
}));
const __default__$U = defineComponent({
  name: "UIInputGroupLabel",
  inheritAttrs: false
});
const _sfc_main$14 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$U), {
  props: {
    size: {
      type: String,
      default: "large"
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NInputGroupLabel), mergeProps(_ctx.$attrs, { size: __props.size }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["size"]);
    };
  }
}));
_sfc_main$16.install = (Vue) => {
  Vue.component(_sfc_main$16.name, _sfc_main$16);
  Vue.component(_sfc_main$15.name, _sfc_main$15);
  Vue.component(_sfc_main$14.name, _sfc_main$14);
};
var Pagination_vue_vue_type_style_index_0_lang = "";
const __default__$T = defineComponent({
  name: "UIPagination",
  inheritAttrs: false
});
const _sfc_main$13 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$T), {
  props: {
    pageCount: {
      type: Number,
      default: 10
    },
    page: {
      type: Number
    },
    id: {
      type: String,
      required: true
    },
    pageSize: {
      type: Number,
      default: void 0
    },
    pageSlot: {
      type: Number,
      default: 9
    },
    showSizePicker: {
      type: Boolean,
      default: false
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40]
    }
  },
  emits: ["update:page", "update:page-size"],
  setup(__props, { emit }) {
    const locales = inject("customLocale");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NPagination), {
        "page-size": __props.pageSize,
        "page-sizes": __props.pageSizes,
        "show-size-picker": __props.showSizePicker,
        "page-count": __props.pageCount,
        page: __props.page,
        "page-slot": __props.pageSlot,
        "onUpdate:page": _cache[0] || (_cache[0] = (val) => emit("update:page", val)),
        "onUpdate:pageSize": _cache[1] || (_cache[1] = (val) => emit("update:page-size", val))
      }, {
        prev: withCtx(() => [
          createVNode(unref(_sfc_main$1l), {
            id: `${__props.id}-previous`,
            size: "small"
          }, {
            default: withCtx(() => {
              var _a2;
              return [
                createTextVNode(toDisplayString((_a2 = unref(locales).Pagination.previous) != null ? _a2 : "Previous"), 1)
              ];
            }),
            _: 1
          }, 8, ["id"])
        ]),
        next: withCtx(() => [
          createVNode(unref(_sfc_main$1l), {
            id: `${__props.id}-next`,
            size: "small"
          }, {
            default: withCtx(() => {
              var _a2;
              return [
                createTextVNode(toDisplayString((_a2 = unref(locales).Pagination.next) != null ? _a2 : "Next"), 1)
              ];
            }),
            _: 1
          }, 8, ["id"])
        ]),
        _: 1
      }, 8, ["page-size", "page-sizes", "show-size-picker", "page-count", "page", "page-slot"]);
    };
  }
}));
_sfc_main$13.install = (Vue) => {
  Vue.component(_sfc_main$13.name, _sfc_main$13);
};
var draggable_bundle = { exports: {} };
(function(module2, exports2) {
  (function webpackUniversalModuleDefinition(root2, factory) {
    module2.exports = factory();
  })(window, function() {
    return function(modules) {
      var installedModules = {};
      function __webpack_require__(moduleId) {
        if (installedModules[moduleId]) {
          return installedModules[moduleId].exports;
        }
        var module3 = installedModules[moduleId] = {
          i: moduleId,
          l: false,
          exports: {}
        };
        modules[moduleId].call(module3.exports, module3, module3.exports, __webpack_require__);
        module3.l = true;
        return module3.exports;
      }
      __webpack_require__.m = modules;
      __webpack_require__.c = installedModules;
      __webpack_require__.d = function(exports3, name2, getter) {
        if (!__webpack_require__.o(exports3, name2)) {
          Object.defineProperty(exports3, name2, { enumerable: true, get: getter });
        }
      };
      __webpack_require__.r = function(exports3) {
        if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
          Object.defineProperty(exports3, Symbol.toStringTag, { value: "Module" });
        }
        Object.defineProperty(exports3, "__esModule", { value: true });
      };
      __webpack_require__.t = function(value2, mode) {
        if (mode & 1)
          value2 = __webpack_require__(value2);
        if (mode & 8)
          return value2;
        if (mode & 4 && typeof value2 === "object" && value2 && value2.__esModule)
          return value2;
        var ns2 = Object.create(null);
        __webpack_require__.r(ns2);
        Object.defineProperty(ns2, "default", { enumerable: true, value: value2 });
        if (mode & 2 && typeof value2 != "string")
          for (var key in value2)
            __webpack_require__.d(ns2, key, function(key2) {
              return value2[key2];
            }.bind(null, key));
        return ns2;
      };
      __webpack_require__.n = function(module3) {
        var getter = module3 && module3.__esModule ? function getDefault() {
          return module3["default"];
        } : function getModuleExports() {
          return module3;
        };
        __webpack_require__.d(getter, "a", getter);
        return getter;
      };
      __webpack_require__.o = function(object4, property2) {
        return Object.prototype.hasOwnProperty.call(object4, property2);
      };
      __webpack_require__.p = "";
      return __webpack_require__(__webpack_require__.s = 66);
    }([
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _AbstractEvent = __webpack_require__(64);
        var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _AbstractEvent2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _AbstractPlugin = __webpack_require__(60);
        var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _AbstractPlugin2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _closest = __webpack_require__(51);
        Object.defineProperty(exports3, "closest", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_closest).default;
          }
        });
        var _requestNextAnimationFrame = __webpack_require__(49);
        Object.defineProperty(exports3, "requestNextAnimationFrame", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_requestNextAnimationFrame).default;
          }
        });
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _SensorEvent = __webpack_require__(44);
        Object.keys(_SensorEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _SensorEvent[key];
            }
          });
        });
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _Sensor = __webpack_require__(47);
        var _Sensor2 = _interopRequireDefault(_Sensor);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _Sensor2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _DragEvent = __webpack_require__(14);
        Object.keys(_DragEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _DragEvent[key];
            }
          });
        });
        var _DraggableEvent = __webpack_require__(13);
        Object.keys(_DraggableEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _DraggableEvent[key];
            }
          });
        });
        var _Plugins = __webpack_require__(12);
        Object.keys(_Plugins).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _Plugins[key];
            }
          });
        });
        var _Sensors = __webpack_require__(6);
        Object.keys(_Sensors).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _Sensors[key];
            }
          });
        });
        var _Draggable = __webpack_require__(37);
        var _Draggable2 = _interopRequireDefault(_Draggable);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _Draggable2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _Sensor = __webpack_require__(4);
        Object.defineProperty(exports3, "Sensor", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_Sensor).default;
          }
        });
        var _MouseSensor = __webpack_require__(46);
        Object.defineProperty(exports3, "MouseSensor", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_MouseSensor).default;
          }
        });
        var _TouchSensor = __webpack_require__(43);
        Object.defineProperty(exports3, "TouchSensor", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_TouchSensor).default;
          }
        });
        var _DragSensor = __webpack_require__(41);
        Object.defineProperty(exports3, "DragSensor", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_DragSensor).default;
          }
        });
        var _ForceTouchSensor = __webpack_require__(39);
        Object.defineProperty(exports3, "ForceTouchSensor", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_ForceTouchSensor).default;
          }
        });
        var _SensorEvent = __webpack_require__(3);
        Object.keys(_SensorEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _SensorEvent[key];
            }
          });
        });
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _SnappableEvent = __webpack_require__(18);
        Object.keys(_SnappableEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _SnappableEvent[key];
            }
          });
        });
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _CollidableEvent = __webpack_require__(23);
        Object.keys(_CollidableEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _CollidableEvent[key];
            }
          });
        });
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _SortableEvent = __webpack_require__(27);
        Object.keys(_SortableEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _SortableEvent[key];
            }
          });
        });
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _SwappableEvent = __webpack_require__(30);
        Object.keys(_SwappableEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _SwappableEvent[key];
            }
          });
        });
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _DroppableEvent = __webpack_require__(33);
        Object.keys(_DroppableEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _DroppableEvent[key];
            }
          });
        });
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _Announcement = __webpack_require__(62);
        Object.defineProperty(exports3, "Announcement", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_Announcement).default;
          }
        });
        Object.defineProperty(exports3, "defaultAnnouncementOptions", {
          enumerable: true,
          get: function() {
            return _Announcement.defaultOptions;
          }
        });
        var _Focusable = __webpack_require__(59);
        Object.defineProperty(exports3, "Focusable", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_Focusable).default;
          }
        });
        var _Mirror = __webpack_require__(57);
        Object.defineProperty(exports3, "Mirror", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_Mirror).default;
          }
        });
        Object.defineProperty(exports3, "defaultMirrorOptions", {
          enumerable: true,
          get: function() {
            return _Mirror.defaultOptions;
          }
        });
        var _Scrollable = __webpack_require__(53);
        Object.defineProperty(exports3, "Scrollable", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_Scrollable).default;
          }
        });
        Object.defineProperty(exports3, "defaultScrollableOptions", {
          enumerable: true,
          get: function() {
            return _Scrollable.defaultOptions;
          }
        });
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _DraggableEvent = __webpack_require__(63);
        Object.keys(_DraggableEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _DraggableEvent[key];
            }
          });
        });
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _DragEvent = __webpack_require__(65);
        Object.keys(_DragEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _DragEvent[key];
            }
          });
        });
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.defaultOptions = void 0;
        var _extends2 = Object.assign || function(target) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            var source = arguments[i2];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _AbstractPlugin = __webpack_require__(1);
        var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onSortableSorted = Symbol("onSortableSorted");
        const defaultOptions2 = exports3.defaultOptions = {
          duration: 150,
          easingFunction: "ease-in-out",
          horizontal: false
        };
        class SwapAnimation extends _AbstractPlugin2.default {
          constructor(draggable) {
            super(draggable);
            this.options = _extends2({}, defaultOptions2, this.getOptions());
            this.lastAnimationFrame = null;
            this[onSortableSorted] = this[onSortableSorted].bind(this);
          }
          attach() {
            this.draggable.on("sortable:sorted", this[onSortableSorted]);
          }
          detach() {
            this.draggable.off("sortable:sorted", this[onSortableSorted]);
          }
          getOptions() {
            return this.draggable.options.swapAnimation || {};
          }
          [onSortableSorted]({ oldIndex, newIndex, dragEvent }) {
            const { source, over } = dragEvent;
            cancelAnimationFrame(this.lastAnimationFrame);
            this.lastAnimationFrame = requestAnimationFrame(() => {
              if (oldIndex >= newIndex) {
                animate(source, over, this.options);
              } else {
                animate(over, source, this.options);
              }
            });
          }
        }
        exports3.default = SwapAnimation;
        function animate(from, to2, { duration, easingFunction, horizontal }) {
          for (const element of [from, to2]) {
            element.style.pointerEvents = "none";
          }
          if (horizontal) {
            const width = from.offsetWidth;
            from.style.transform = `translate3d(${width}px, 0, 0)`;
            to2.style.transform = `translate3d(-${width}px, 0, 0)`;
          } else {
            const height = from.offsetHeight;
            from.style.transform = `translate3d(0, ${height}px, 0)`;
            to2.style.transform = `translate3d(0, -${height}px, 0)`;
          }
          requestAnimationFrame(() => {
            for (const element of [from, to2]) {
              element.addEventListener("transitionend", resetElementOnTransitionEnd);
              element.style.transition = `transform ${duration}ms ${easingFunction}`;
              element.style.transform = "";
            }
          });
        }
        function resetElementOnTransitionEnd(event) {
          event.target.style.transition = "";
          event.target.style.pointerEvents = "";
          event.target.removeEventListener("transitionend", resetElementOnTransitionEnd);
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.defaultOptions = void 0;
        var _SwapAnimation = __webpack_require__(15);
        var _SwapAnimation2 = _interopRequireDefault(_SwapAnimation);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _SwapAnimation2.default;
        exports3.defaultOptions = _SwapAnimation.defaultOptions;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _AbstractPlugin = __webpack_require__(1);
        var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);
        var _SnappableEvent = __webpack_require__(7);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onDragStart = Symbol("onDragStart");
        const onDragStop = Symbol("onDragStop");
        const onDragOver = Symbol("onDragOver");
        const onDragOut = Symbol("onDragOut");
        const onMirrorCreated = Symbol("onMirrorCreated");
        const onMirrorDestroy = Symbol("onMirrorDestroy");
        class Snappable extends _AbstractPlugin2.default {
          constructor(draggable) {
            super(draggable);
            this.firstSource = null;
            this.mirror = null;
            this[onDragStart] = this[onDragStart].bind(this);
            this[onDragStop] = this[onDragStop].bind(this);
            this[onDragOver] = this[onDragOver].bind(this);
            this[onDragOut] = this[onDragOut].bind(this);
            this[onMirrorCreated] = this[onMirrorCreated].bind(this);
            this[onMirrorDestroy] = this[onMirrorDestroy].bind(this);
          }
          attach() {
            this.draggable.on("drag:start", this[onDragStart]).on("drag:stop", this[onDragStop]).on("drag:over", this[onDragOver]).on("drag:out", this[onDragOut]).on("droppable:over", this[onDragOver]).on("droppable:out", this[onDragOut]).on("mirror:created", this[onMirrorCreated]).on("mirror:destroy", this[onMirrorDestroy]);
          }
          detach() {
            this.draggable.off("drag:start", this[onDragStart]).off("drag:stop", this[onDragStop]).off("drag:over", this[onDragOver]).off("drag:out", this[onDragOut]).off("droppable:over", this[onDragOver]).off("droppable:out", this[onDragOut]).off("mirror:created", this[onMirrorCreated]).off("mirror:destroy", this[onMirrorDestroy]);
          }
          [onDragStart](event) {
            if (event.canceled()) {
              return;
            }
            this.firstSource = event.source;
          }
          [onDragStop]() {
            this.firstSource = null;
          }
          [onDragOver](event) {
            if (event.canceled()) {
              return;
            }
            const source = event.source || event.dragEvent.source;
            if (source === this.firstSource) {
              this.firstSource = null;
              return;
            }
            const snapInEvent = new _SnappableEvent.SnapInEvent({
              dragEvent: event,
              snappable: event.over || event.droppable
            });
            this.draggable.trigger(snapInEvent);
            if (snapInEvent.canceled()) {
              return;
            }
            if (this.mirror) {
              this.mirror.style.display = "none";
            }
            source.classList.remove(this.draggable.getClassNameFor("source:dragging"));
            source.classList.add(this.draggable.getClassNameFor("source:placed"));
            setTimeout(() => {
              source.classList.remove(this.draggable.getClassNameFor("source:placed"));
            }, this.draggable.options.placedTimeout);
          }
          [onDragOut](event) {
            if (event.canceled()) {
              return;
            }
            const source = event.source || event.dragEvent.source;
            const snapOutEvent = new _SnappableEvent.SnapOutEvent({
              dragEvent: event,
              snappable: event.over || event.droppable
            });
            this.draggable.trigger(snapOutEvent);
            if (snapOutEvent.canceled()) {
              return;
            }
            if (this.mirror) {
              this.mirror.style.display = "";
            }
            source.classList.add(this.draggable.getClassNameFor("source:dragging"));
          }
          [onMirrorCreated]({ mirror }) {
            this.mirror = mirror;
          }
          [onMirrorDestroy]() {
            this.mirror = null;
          }
        }
        exports3.default = Snappable;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.SnapOutEvent = exports3.SnapInEvent = exports3.SnapEvent = void 0;
        var _AbstractEvent = __webpack_require__(0);
        var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        class SnapEvent extends _AbstractEvent2.default {
          get dragEvent() {
            return this.data.dragEvent;
          }
          get snappable() {
            return this.data.snappable;
          }
        }
        exports3.SnapEvent = SnapEvent;
        SnapEvent.type = "snap";
        class SnapInEvent extends SnapEvent {
        }
        exports3.SnapInEvent = SnapInEvent;
        SnapInEvent.type = "snap:in";
        SnapInEvent.cancelable = true;
        class SnapOutEvent extends SnapEvent {
        }
        exports3.SnapOutEvent = SnapOutEvent;
        SnapOutEvent.type = "snap:out";
        SnapOutEvent.cancelable = true;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _SnappableEvent = __webpack_require__(7);
        Object.keys(_SnappableEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _SnappableEvent[key];
            }
          });
        });
        var _Snappable = __webpack_require__(17);
        var _Snappable2 = _interopRequireDefault(_Snappable);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _Snappable2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.defaultOptions = void 0;
        var _extends2 = Object.assign || function(target) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            var source = arguments[i2];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _AbstractPlugin = __webpack_require__(1);
        var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);
        var _utils = __webpack_require__(2);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onMirrorCreated = Symbol("onMirrorCreated");
        const onMirrorDestroy = Symbol("onMirrorDestroy");
        const onDragOver = Symbol("onDragOver");
        const resize = Symbol("resize");
        const defaultOptions2 = exports3.defaultOptions = {};
        class ResizeMirror extends _AbstractPlugin2.default {
          constructor(draggable) {
            super(draggable);
            this.options = _extends2({}, defaultOptions2, this.getOptions());
            this.lastWidth = 0;
            this.lastHeight = 0;
            this.mirror = null;
            this[onMirrorCreated] = this[onMirrorCreated].bind(this);
            this[onMirrorDestroy] = this[onMirrorDestroy].bind(this);
            this[onDragOver] = this[onDragOver].bind(this);
          }
          attach() {
            this.draggable.on("mirror:created", this[onMirrorCreated]).on("drag:over", this[onDragOver]).on("drag:over:container", this[onDragOver]);
          }
          detach() {
            this.draggable.off("mirror:created", this[onMirrorCreated]).off("mirror:destroy", this[onMirrorDestroy]).off("drag:over", this[onDragOver]).off("drag:over:container", this[onDragOver]);
          }
          getOptions() {
            return this.draggable.options.resizeMirror || {};
          }
          [onMirrorCreated]({ mirror }) {
            this.mirror = mirror;
          }
          [onMirrorDestroy]() {
            this.mirror = null;
          }
          [onDragOver](dragEvent) {
            this[resize](dragEvent);
          }
          [resize]({ overContainer, over }) {
            requestAnimationFrame(() => {
              if (this.mirror.parentNode !== overContainer) {
                overContainer.appendChild(this.mirror);
              }
              const overElement = over || this.draggable.getDraggableElementsForContainer(overContainer)[0];
              if (!overElement) {
                return;
              }
              (0, _utils.requestNextAnimationFrame)(() => {
                const overRect = overElement.getBoundingClientRect();
                if (this.lastHeight === overRect.height && this.lastWidth === overRect.width) {
                  return;
                }
                this.mirror.style.width = `${overRect.width}px`;
                this.mirror.style.height = `${overRect.height}px`;
                this.lastWidth = overRect.width;
                this.lastHeight = overRect.height;
              });
            });
          }
        }
        exports3.default = ResizeMirror;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.defaultOptions = void 0;
        var _ResizeMirror = __webpack_require__(20);
        var _ResizeMirror2 = _interopRequireDefault(_ResizeMirror);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _ResizeMirror2.default;
        exports3.defaultOptions = _ResizeMirror.defaultOptions;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _AbstractPlugin = __webpack_require__(1);
        var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);
        var _utils = __webpack_require__(2);
        var _CollidableEvent = __webpack_require__(8);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onDragMove = Symbol("onDragMove");
        const onDragStop = Symbol("onDragStop");
        const onRequestAnimationFrame = Symbol("onRequestAnimationFrame");
        class Collidable extends _AbstractPlugin2.default {
          constructor(draggable) {
            super(draggable);
            this.currentlyCollidingElement = null;
            this.lastCollidingElement = null;
            this.currentAnimationFrame = null;
            this[onDragMove] = this[onDragMove].bind(this);
            this[onDragStop] = this[onDragStop].bind(this);
            this[onRequestAnimationFrame] = this[onRequestAnimationFrame].bind(this);
          }
          attach() {
            this.draggable.on("drag:move", this[onDragMove]).on("drag:stop", this[onDragStop]);
          }
          detach() {
            this.draggable.off("drag:move", this[onDragMove]).off("drag:stop", this[onDragStop]);
          }
          getCollidables() {
            const collidables = this.draggable.options.collidables;
            if (typeof collidables === "string") {
              return Array.prototype.slice.call(document.querySelectorAll(collidables));
            } else if (collidables instanceof NodeList || collidables instanceof Array) {
              return Array.prototype.slice.call(collidables);
            } else if (collidables instanceof HTMLElement) {
              return [collidables];
            } else if (typeof collidables === "function") {
              return collidables();
            } else {
              return [];
            }
          }
          [onDragMove](event) {
            const target = event.sensorEvent.target;
            this.currentAnimationFrame = requestAnimationFrame(this[onRequestAnimationFrame](target));
            if (this.currentlyCollidingElement) {
              event.cancel();
            }
            const collidableInEvent = new _CollidableEvent.CollidableInEvent({
              dragEvent: event,
              collidingElement: this.currentlyCollidingElement
            });
            const collidableOutEvent = new _CollidableEvent.CollidableOutEvent({
              dragEvent: event,
              collidingElement: this.lastCollidingElement
            });
            const enteringCollidable = Boolean(this.currentlyCollidingElement && this.lastCollidingElement !== this.currentlyCollidingElement);
            const leavingCollidable = Boolean(!this.currentlyCollidingElement && this.lastCollidingElement);
            if (enteringCollidable) {
              if (this.lastCollidingElement) {
                this.draggable.trigger(collidableOutEvent);
              }
              this.draggable.trigger(collidableInEvent);
            } else if (leavingCollidable) {
              this.draggable.trigger(collidableOutEvent);
            }
            this.lastCollidingElement = this.currentlyCollidingElement;
          }
          [onDragStop](event) {
            const lastCollidingElement = this.currentlyCollidingElement || this.lastCollidingElement;
            const collidableOutEvent = new _CollidableEvent.CollidableOutEvent({
              dragEvent: event,
              collidingElement: lastCollidingElement
            });
            if (lastCollidingElement) {
              this.draggable.trigger(collidableOutEvent);
            }
            this.lastCollidingElement = null;
            this.currentlyCollidingElement = null;
          }
          [onRequestAnimationFrame](target) {
            return () => {
              const collidables = this.getCollidables();
              this.currentlyCollidingElement = (0, _utils.closest)(target, (element) => collidables.includes(element));
            };
          }
        }
        exports3.default = Collidable;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.CollidableOutEvent = exports3.CollidableInEvent = exports3.CollidableEvent = void 0;
        var _AbstractEvent = __webpack_require__(0);
        var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        class CollidableEvent extends _AbstractEvent2.default {
          get dragEvent() {
            return this.data.dragEvent;
          }
        }
        exports3.CollidableEvent = CollidableEvent;
        CollidableEvent.type = "collidable";
        class CollidableInEvent extends CollidableEvent {
          get collidingElement() {
            return this.data.collidingElement;
          }
        }
        exports3.CollidableInEvent = CollidableInEvent;
        CollidableInEvent.type = "collidable:in";
        class CollidableOutEvent extends CollidableEvent {
          get collidingElement() {
            return this.data.collidingElement;
          }
        }
        exports3.CollidableOutEvent = CollidableOutEvent;
        CollidableOutEvent.type = "collidable:out";
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _CollidableEvent = __webpack_require__(8);
        Object.keys(_CollidableEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _CollidableEvent[key];
            }
          });
        });
        var _Collidable = __webpack_require__(22);
        var _Collidable2 = _interopRequireDefault(_Collidable);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _Collidable2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _Collidable = __webpack_require__(24);
        Object.defineProperty(exports3, "Collidable", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_Collidable).default;
          }
        });
        var _ResizeMirror = __webpack_require__(21);
        Object.defineProperty(exports3, "ResizeMirror", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_ResizeMirror).default;
          }
        });
        Object.defineProperty(exports3, "defaultResizeMirrorOptions", {
          enumerable: true,
          get: function() {
            return _ResizeMirror.defaultOptions;
          }
        });
        var _Snappable = __webpack_require__(19);
        Object.defineProperty(exports3, "Snappable", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_Snappable).default;
          }
        });
        var _SwapAnimation = __webpack_require__(16);
        Object.defineProperty(exports3, "SwapAnimation", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_SwapAnimation).default;
          }
        });
        Object.defineProperty(exports3, "defaultSwapAnimationOptions", {
          enumerable: true,
          get: function() {
            return _SwapAnimation.defaultOptions;
          }
        });
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _extends2 = Object.assign || function(target) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            var source = arguments[i2];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _Draggable = __webpack_require__(5);
        var _Draggable2 = _interopRequireDefault(_Draggable);
        var _SortableEvent = __webpack_require__(9);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onDragStart = Symbol("onDragStart");
        const onDragOverContainer = Symbol("onDragOverContainer");
        const onDragOver = Symbol("onDragOver");
        const onDragStop = Symbol("onDragStop");
        function onSortableSortedDefaultAnnouncement({ dragEvent }) {
          const sourceText = dragEvent.source.textContent.trim() || dragEvent.source.id || "sortable element";
          if (dragEvent.over) {
            const overText = dragEvent.over.textContent.trim() || dragEvent.over.id || "sortable element";
            const isFollowing = dragEvent.source.compareDocumentPosition(dragEvent.over) & Node.DOCUMENT_POSITION_FOLLOWING;
            if (isFollowing) {
              return `Placed ${sourceText} after ${overText}`;
            } else {
              return `Placed ${sourceText} before ${overText}`;
            }
          } else {
            return `Placed ${sourceText} into a different container`;
          }
        }
        const defaultAnnouncements = {
          "sortable:sorted": onSortableSortedDefaultAnnouncement
        };
        class Sortable extends _Draggable2.default {
          constructor(containers = [], options = {}) {
            super(containers, _extends2({}, options, {
              announcements: _extends2({}, defaultAnnouncements, options.announcements || {})
            }));
            this.startIndex = null;
            this.startContainer = null;
            this[onDragStart] = this[onDragStart].bind(this);
            this[onDragOverContainer] = this[onDragOverContainer].bind(this);
            this[onDragOver] = this[onDragOver].bind(this);
            this[onDragStop] = this[onDragStop].bind(this);
            this.on("drag:start", this[onDragStart]).on("drag:over:container", this[onDragOverContainer]).on("drag:over", this[onDragOver]).on("drag:stop", this[onDragStop]);
          }
          destroy() {
            super.destroy();
            this.off("drag:start", this[onDragStart]).off("drag:over:container", this[onDragOverContainer]).off("drag:over", this[onDragOver]).off("drag:stop", this[onDragStop]);
          }
          index(element) {
            return this.getDraggableElementsForContainer(element.parentNode).indexOf(element);
          }
          [onDragStart](event) {
            this.startContainer = event.source.parentNode;
            this.startIndex = this.index(event.source);
            const sortableStartEvent = new _SortableEvent.SortableStartEvent({
              dragEvent: event,
              startIndex: this.startIndex,
              startContainer: this.startContainer
            });
            this.trigger(sortableStartEvent);
            if (sortableStartEvent.canceled()) {
              event.cancel();
            }
          }
          [onDragOverContainer](event) {
            if (event.canceled()) {
              return;
            }
            const { source, over, overContainer } = event;
            const oldIndex = this.index(source);
            const sortableSortEvent = new _SortableEvent.SortableSortEvent({
              dragEvent: event,
              currentIndex: oldIndex,
              source,
              over
            });
            this.trigger(sortableSortEvent);
            if (sortableSortEvent.canceled()) {
              return;
            }
            const children = this.getDraggableElementsForContainer(overContainer);
            const moves = move2({ source, over, overContainer, children });
            if (!moves) {
              return;
            }
            const { oldContainer, newContainer } = moves;
            const newIndex = this.index(event.source);
            const sortableSortedEvent = new _SortableEvent.SortableSortedEvent({
              dragEvent: event,
              oldIndex,
              newIndex,
              oldContainer,
              newContainer
            });
            this.trigger(sortableSortedEvent);
          }
          [onDragOver](event) {
            if (event.over === event.originalSource || event.over === event.source) {
              return;
            }
            const { source, over, overContainer } = event;
            const oldIndex = this.index(source);
            const sortableSortEvent = new _SortableEvent.SortableSortEvent({
              dragEvent: event,
              currentIndex: oldIndex,
              source,
              over
            });
            this.trigger(sortableSortEvent);
            if (sortableSortEvent.canceled()) {
              return;
            }
            const children = this.getDraggableElementsForContainer(overContainer);
            const moves = move2({ source, over, overContainer, children });
            if (!moves) {
              return;
            }
            const { oldContainer, newContainer } = moves;
            const newIndex = this.index(source);
            const sortableSortedEvent = new _SortableEvent.SortableSortedEvent({
              dragEvent: event,
              oldIndex,
              newIndex,
              oldContainer,
              newContainer
            });
            this.trigger(sortableSortedEvent);
          }
          [onDragStop](event) {
            const sortableStopEvent = new _SortableEvent.SortableStopEvent({
              dragEvent: event,
              oldIndex: this.startIndex,
              newIndex: this.index(event.source),
              oldContainer: this.startContainer,
              newContainer: event.source.parentNode
            });
            this.trigger(sortableStopEvent);
            this.startIndex = null;
            this.startContainer = null;
          }
        }
        exports3.default = Sortable;
        function index2(element) {
          return Array.prototype.indexOf.call(element.parentNode.children, element);
        }
        function move2({ source, over, overContainer, children }) {
          const emptyOverContainer = !children.length;
          const differentContainer = source.parentNode !== overContainer;
          const sameContainer = over && !differentContainer;
          if (emptyOverContainer) {
            return moveInsideEmptyContainer(source, overContainer);
          } else if (sameContainer) {
            return moveWithinContainer(source, over);
          } else if (differentContainer) {
            return moveOutsideContainer(source, over, overContainer);
          } else {
            return null;
          }
        }
        function moveInsideEmptyContainer(source, overContainer) {
          const oldContainer = source.parentNode;
          overContainer.appendChild(source);
          return { oldContainer, newContainer: overContainer };
        }
        function moveWithinContainer(source, over) {
          const oldIndex = index2(source);
          const newIndex = index2(over);
          if (oldIndex < newIndex) {
            source.parentNode.insertBefore(source, over.nextElementSibling);
          } else {
            source.parentNode.insertBefore(source, over);
          }
          return { oldContainer: source.parentNode, newContainer: source.parentNode };
        }
        function moveOutsideContainer(source, over, overContainer) {
          const oldContainer = source.parentNode;
          if (over) {
            over.parentNode.insertBefore(source, over);
          } else {
            overContainer.appendChild(source);
          }
          return { oldContainer, newContainer: source.parentNode };
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.SortableStopEvent = exports3.SortableSortedEvent = exports3.SortableSortEvent = exports3.SortableStartEvent = exports3.SortableEvent = void 0;
        var _AbstractEvent = __webpack_require__(0);
        var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        class SortableEvent extends _AbstractEvent2.default {
          get dragEvent() {
            return this.data.dragEvent;
          }
        }
        exports3.SortableEvent = SortableEvent;
        SortableEvent.type = "sortable";
        class SortableStartEvent extends SortableEvent {
          get startIndex() {
            return this.data.startIndex;
          }
          get startContainer() {
            return this.data.startContainer;
          }
        }
        exports3.SortableStartEvent = SortableStartEvent;
        SortableStartEvent.type = "sortable:start";
        SortableStartEvent.cancelable = true;
        class SortableSortEvent extends SortableEvent {
          get currentIndex() {
            return this.data.currentIndex;
          }
          get over() {
            return this.data.oldIndex;
          }
          get overContainer() {
            return this.data.newIndex;
          }
        }
        exports3.SortableSortEvent = SortableSortEvent;
        SortableSortEvent.type = "sortable:sort";
        SortableSortEvent.cancelable = true;
        class SortableSortedEvent extends SortableEvent {
          get oldIndex() {
            return this.data.oldIndex;
          }
          get newIndex() {
            return this.data.newIndex;
          }
          get oldContainer() {
            return this.data.oldContainer;
          }
          get newContainer() {
            return this.data.newContainer;
          }
        }
        exports3.SortableSortedEvent = SortableSortedEvent;
        SortableSortedEvent.type = "sortable:sorted";
        class SortableStopEvent extends SortableEvent {
          get oldIndex() {
            return this.data.oldIndex;
          }
          get newIndex() {
            return this.data.newIndex;
          }
          get oldContainer() {
            return this.data.oldContainer;
          }
          get newContainer() {
            return this.data.newContainer;
          }
        }
        exports3.SortableStopEvent = SortableStopEvent;
        SortableStopEvent.type = "sortable:stop";
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _SortableEvent = __webpack_require__(9);
        Object.keys(_SortableEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _SortableEvent[key];
            }
          });
        });
        var _Sortable = __webpack_require__(26);
        var _Sortable2 = _interopRequireDefault(_Sortable);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _Sortable2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _extends2 = Object.assign || function(target) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            var source = arguments[i2];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _Draggable = __webpack_require__(5);
        var _Draggable2 = _interopRequireDefault(_Draggable);
        var _SwappableEvent = __webpack_require__(10);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onDragStart = Symbol("onDragStart");
        const onDragOver = Symbol("onDragOver");
        const onDragStop = Symbol("onDragStop");
        function onSwappableSwappedDefaultAnnouncement({ dragEvent, swappedElement }) {
          const sourceText = dragEvent.source.textContent.trim() || dragEvent.source.id || "swappable element";
          const overText = swappedElement.textContent.trim() || swappedElement.id || "swappable element";
          return `Swapped ${sourceText} with ${overText}`;
        }
        const defaultAnnouncements = {
          "swappabled:swapped": onSwappableSwappedDefaultAnnouncement
        };
        class Swappable extends _Draggable2.default {
          constructor(containers = [], options = {}) {
            super(containers, _extends2({}, options, {
              announcements: _extends2({}, defaultAnnouncements, options.announcements || {})
            }));
            this.lastOver = null;
            this[onDragStart] = this[onDragStart].bind(this);
            this[onDragOver] = this[onDragOver].bind(this);
            this[onDragStop] = this[onDragStop].bind(this);
            this.on("drag:start", this[onDragStart]).on("drag:over", this[onDragOver]).on("drag:stop", this[onDragStop]);
          }
          destroy() {
            super.destroy();
            this.off("drag:start", this._onDragStart).off("drag:over", this._onDragOver).off("drag:stop", this._onDragStop);
          }
          [onDragStart](event) {
            const swappableStartEvent = new _SwappableEvent.SwappableStartEvent({
              dragEvent: event
            });
            this.trigger(swappableStartEvent);
            if (swappableStartEvent.canceled()) {
              event.cancel();
            }
          }
          [onDragOver](event) {
            if (event.over === event.originalSource || event.over === event.source || event.canceled()) {
              return;
            }
            const swappableSwapEvent = new _SwappableEvent.SwappableSwapEvent({
              dragEvent: event,
              over: event.over,
              overContainer: event.overContainer
            });
            this.trigger(swappableSwapEvent);
            if (swappableSwapEvent.canceled()) {
              return;
            }
            if (this.lastOver && this.lastOver !== event.over) {
              swap(this.lastOver, event.source);
            }
            if (this.lastOver === event.over) {
              this.lastOver = null;
            } else {
              this.lastOver = event.over;
            }
            swap(event.source, event.over);
            const swappableSwappedEvent = new _SwappableEvent.SwappableSwappedEvent({
              dragEvent: event,
              swappedElement: event.over
            });
            this.trigger(swappableSwappedEvent);
          }
          [onDragStop](event) {
            const swappableStopEvent = new _SwappableEvent.SwappableStopEvent({
              dragEvent: event
            });
            this.trigger(swappableStopEvent);
            this.lastOver = null;
          }
        }
        exports3.default = Swappable;
        function withTempElement(callback) {
          const tmpElement = document.createElement("div");
          callback(tmpElement);
          tmpElement.parentNode.removeChild(tmpElement);
        }
        function swap(source, over) {
          const overParent = over.parentNode;
          const sourceParent = source.parentNode;
          withTempElement((tmpElement) => {
            sourceParent.insertBefore(tmpElement, source);
            overParent.insertBefore(source, over);
            sourceParent.insertBefore(over, tmpElement);
          });
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.SwappableStopEvent = exports3.SwappableSwappedEvent = exports3.SwappableSwapEvent = exports3.SwappableStartEvent = exports3.SwappableEvent = void 0;
        var _AbstractEvent = __webpack_require__(0);
        var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        class SwappableEvent extends _AbstractEvent2.default {
          get dragEvent() {
            return this.data.dragEvent;
          }
        }
        exports3.SwappableEvent = SwappableEvent;
        SwappableEvent.type = "swappable";
        class SwappableStartEvent extends SwappableEvent {
        }
        exports3.SwappableStartEvent = SwappableStartEvent;
        SwappableStartEvent.type = "swappable:start";
        SwappableStartEvent.cancelable = true;
        class SwappableSwapEvent extends SwappableEvent {
          get over() {
            return this.data.over;
          }
          get overContainer() {
            return this.data.overContainer;
          }
        }
        exports3.SwappableSwapEvent = SwappableSwapEvent;
        SwappableSwapEvent.type = "swappable:swap";
        SwappableSwapEvent.cancelable = true;
        class SwappableSwappedEvent extends SwappableEvent {
          get swappedElement() {
            return this.data.swappedElement;
          }
        }
        exports3.SwappableSwappedEvent = SwappableSwappedEvent;
        SwappableSwappedEvent.type = "swappable:swapped";
        class SwappableStopEvent extends SwappableEvent {
        }
        exports3.SwappableStopEvent = SwappableStopEvent;
        SwappableStopEvent.type = "swappable:stop";
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _SwappableEvent = __webpack_require__(10);
        Object.keys(_SwappableEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _SwappableEvent[key];
            }
          });
        });
        var _Swappable = __webpack_require__(29);
        var _Swappable2 = _interopRequireDefault(_Swappable);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _Swappable2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _extends2 = Object.assign || function(target) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            var source = arguments[i2];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _utils = __webpack_require__(2);
        var _Draggable = __webpack_require__(5);
        var _Draggable2 = _interopRequireDefault(_Draggable);
        var _DroppableEvent = __webpack_require__(11);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onDragStart = Symbol("onDragStart");
        const onDragMove = Symbol("onDragMove");
        const onDragStop = Symbol("onDragStop");
        const dropInDropzone = Symbol("dropInDropZone");
        const returnToOriginalDropzone = Symbol("returnToOriginalDropzone");
        const closestDropzone = Symbol("closestDropzone");
        const getDropzones = Symbol("getDropzones");
        function onDroppableDroppedDefaultAnnouncement({ dragEvent, dropzone }) {
          const sourceText = dragEvent.source.textContent.trim() || dragEvent.source.id || "draggable element";
          const dropzoneText = dropzone.textContent.trim() || dropzone.id || "droppable element";
          return `Dropped ${sourceText} into ${dropzoneText}`;
        }
        function onDroppableReturnedDefaultAnnouncement({ dragEvent, dropzone }) {
          const sourceText = dragEvent.source.textContent.trim() || dragEvent.source.id || "draggable element";
          const dropzoneText = dropzone.textContent.trim() || dropzone.id || "droppable element";
          return `Returned ${sourceText} from ${dropzoneText}`;
        }
        const defaultAnnouncements = {
          "droppable:dropped": onDroppableDroppedDefaultAnnouncement,
          "droppable:returned": onDroppableReturnedDefaultAnnouncement
        };
        const defaultClasses = {
          "droppable:active": "draggable-dropzone--active",
          "droppable:occupied": "draggable-dropzone--occupied"
        };
        const defaultOptions2 = {
          dropzone: ".draggable-droppable"
        };
        class Droppable extends _Draggable2.default {
          constructor(containers = [], options = {}) {
            super(containers, _extends2({}, defaultOptions2, options, {
              classes: _extends2({}, defaultClasses, options.classes || {}),
              announcements: _extends2({}, defaultAnnouncements, options.announcements || {})
            }));
            this.dropzones = null;
            this.lastDropzone = null;
            this.initialDropzone = null;
            this[onDragStart] = this[onDragStart].bind(this);
            this[onDragMove] = this[onDragMove].bind(this);
            this[onDragStop] = this[onDragStop].bind(this);
            this.on("drag:start", this[onDragStart]).on("drag:move", this[onDragMove]).on("drag:stop", this[onDragStop]);
          }
          destroy() {
            super.destroy();
            this.off("drag:start", this[onDragStart]).off("drag:move", this[onDragMove]).off("drag:stop", this[onDragStop]);
          }
          [onDragStart](event) {
            if (event.canceled()) {
              return;
            }
            this.dropzones = [...this[getDropzones]()];
            const dropzone = (0, _utils.closest)(event.sensorEvent.target, this.options.dropzone);
            if (!dropzone) {
              event.cancel();
              return;
            }
            const droppableStartEvent = new _DroppableEvent.DroppableStartEvent({
              dragEvent: event,
              dropzone
            });
            this.trigger(droppableStartEvent);
            if (droppableStartEvent.canceled()) {
              event.cancel();
              return;
            }
            this.initialDropzone = dropzone;
            for (const dropzoneElement of this.dropzones) {
              if (dropzoneElement.classList.contains(this.getClassNameFor("droppable:occupied"))) {
                continue;
              }
              dropzoneElement.classList.add(this.getClassNameFor("droppable:active"));
            }
          }
          [onDragMove](event) {
            if (event.canceled()) {
              return;
            }
            const dropzone = this[closestDropzone](event.sensorEvent.target);
            const overEmptyDropzone = dropzone && !dropzone.classList.contains(this.getClassNameFor("droppable:occupied"));
            if (overEmptyDropzone && this[dropInDropzone](event, dropzone)) {
              this.lastDropzone = dropzone;
            } else if ((!dropzone || dropzone === this.initialDropzone) && this.lastDropzone) {
              this[returnToOriginalDropzone](event);
              this.lastDropzone = null;
            }
          }
          [onDragStop](event) {
            const droppableStopEvent = new _DroppableEvent.DroppableStopEvent({
              dragEvent: event,
              dropzone: this.lastDropzone || this.initialDropzone
            });
            this.trigger(droppableStopEvent);
            const occupiedClass = this.getClassNameFor("droppable:occupied");
            for (const dropzone of this.dropzones) {
              dropzone.classList.remove(this.getClassNameFor("droppable:active"));
            }
            if (this.lastDropzone && this.lastDropzone !== this.initialDropzone) {
              this.initialDropzone.classList.remove(occupiedClass);
            }
            this.dropzones = null;
            this.lastDropzone = null;
            this.initialDropzone = null;
          }
          [dropInDropzone](event, dropzone) {
            const droppableDroppedEvent = new _DroppableEvent.DroppableDroppedEvent({
              dragEvent: event,
              dropzone
            });
            this.trigger(droppableDroppedEvent);
            if (droppableDroppedEvent.canceled()) {
              return false;
            }
            const occupiedClass = this.getClassNameFor("droppable:occupied");
            if (this.lastDropzone) {
              this.lastDropzone.classList.remove(occupiedClass);
            }
            dropzone.appendChild(event.source);
            dropzone.classList.add(occupiedClass);
            return true;
          }
          [returnToOriginalDropzone](event) {
            const droppableReturnedEvent = new _DroppableEvent.DroppableReturnedEvent({
              dragEvent: event,
              dropzone: this.lastDropzone
            });
            this.trigger(droppableReturnedEvent);
            if (droppableReturnedEvent.canceled()) {
              return;
            }
            this.initialDropzone.appendChild(event.source);
            this.lastDropzone.classList.remove(this.getClassNameFor("droppable:occupied"));
          }
          [closestDropzone](target) {
            if (!this.dropzones) {
              return null;
            }
            return (0, _utils.closest)(target, this.dropzones);
          }
          [getDropzones]() {
            const dropzone = this.options.dropzone;
            if (typeof dropzone === "string") {
              return document.querySelectorAll(dropzone);
            } else if (dropzone instanceof NodeList || dropzone instanceof Array) {
              return dropzone;
            } else if (typeof dropzone === "function") {
              return dropzone();
            } else {
              return [];
            }
          }
        }
        exports3.default = Droppable;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.DroppableStopEvent = exports3.DroppableReturnedEvent = exports3.DroppableDroppedEvent = exports3.DroppableStartEvent = exports3.DroppableEvent = void 0;
        var _AbstractEvent = __webpack_require__(0);
        var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        class DroppableEvent extends _AbstractEvent2.default {
          get dragEvent() {
            return this.data.dragEvent;
          }
        }
        exports3.DroppableEvent = DroppableEvent;
        DroppableEvent.type = "droppable";
        class DroppableStartEvent extends DroppableEvent {
          get dropzone() {
            return this.data.dropzone;
          }
        }
        exports3.DroppableStartEvent = DroppableStartEvent;
        DroppableStartEvent.type = "droppable:start";
        DroppableStartEvent.cancelable = true;
        class DroppableDroppedEvent extends DroppableEvent {
          get dropzone() {
            return this.data.dropzone;
          }
        }
        exports3.DroppableDroppedEvent = DroppableDroppedEvent;
        DroppableDroppedEvent.type = "droppable:dropped";
        DroppableDroppedEvent.cancelable = true;
        class DroppableReturnedEvent extends DroppableEvent {
          get dropzone() {
            return this.data.dropzone;
          }
        }
        exports3.DroppableReturnedEvent = DroppableReturnedEvent;
        DroppableReturnedEvent.type = "droppable:returned";
        DroppableReturnedEvent.cancelable = true;
        class DroppableStopEvent extends DroppableEvent {
          get dropzone() {
            return this.data.dropzone;
          }
        }
        exports3.DroppableStopEvent = DroppableStopEvent;
        DroppableStopEvent.type = "droppable:stop";
        DroppableStopEvent.cancelable = true;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _DroppableEvent = __webpack_require__(11);
        Object.keys(_DroppableEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _DroppableEvent[key];
            }
          });
        });
        var _Droppable = __webpack_require__(32);
        var _Droppable2 = _interopRequireDefault(_Droppable);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _Droppable2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        class Emitter {
          constructor() {
            this.callbacks = {};
          }
          on(type4, ...callbacks2) {
            if (!this.callbacks[type4]) {
              this.callbacks[type4] = [];
            }
            this.callbacks[type4].push(...callbacks2);
            return this;
          }
          off(type4, callback) {
            if (!this.callbacks[type4]) {
              return null;
            }
            const copy = this.callbacks[type4].slice(0);
            for (let i2 = 0; i2 < copy.length; i2++) {
              if (callback === copy[i2]) {
                this.callbacks[type4].splice(i2, 1);
              }
            }
            return this;
          }
          trigger(event) {
            if (!this.callbacks[event.type]) {
              return null;
            }
            const callbacks2 = [...this.callbacks[event.type]];
            const caughtErrors = [];
            for (let i2 = callbacks2.length - 1; i2 >= 0; i2--) {
              const callback = callbacks2[i2];
              try {
                callback(event);
              } catch (error) {
                caughtErrors.push(error);
              }
            }
            if (caughtErrors.length) {
              console.error(`Draggable caught errors while triggering '${event.type}'`, caughtErrors);
            }
            return this;
          }
        }
        exports3.default = Emitter;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _Emitter = __webpack_require__(35);
        var _Emitter2 = _interopRequireDefault(_Emitter);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _Emitter2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.defaultOptions = void 0;
        var _extends2 = Object.assign || function(target) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            var source = arguments[i2];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _utils = __webpack_require__(2);
        var _Plugins = __webpack_require__(12);
        var _Emitter = __webpack_require__(36);
        var _Emitter2 = _interopRequireDefault(_Emitter);
        var _Sensors = __webpack_require__(6);
        var _DraggableEvent = __webpack_require__(13);
        var _DragEvent = __webpack_require__(14);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onDragStart = Symbol("onDragStart");
        const onDragMove = Symbol("onDragMove");
        const onDragStop = Symbol("onDragStop");
        const onDragPressure = Symbol("onDragPressure");
        const defaultAnnouncements = {
          "drag:start": (event) => `Picked up ${event.source.textContent.trim() || event.source.id || "draggable element"}`,
          "drag:stop": (event) => `Released ${event.source.textContent.trim() || event.source.id || "draggable element"}`
        };
        const defaultClasses = {
          "container:dragging": "draggable-container--is-dragging",
          "source:dragging": "draggable-source--is-dragging",
          "source:placed": "draggable-source--placed",
          "container:placed": "draggable-container--placed",
          "body:dragging": "draggable--is-dragging",
          "draggable:over": "draggable--over",
          "container:over": "draggable-container--over",
          "source:original": "draggable--original",
          mirror: "draggable-mirror"
        };
        const defaultOptions2 = exports3.defaultOptions = {
          draggable: ".draggable-source",
          handle: null,
          delay: 100,
          placedTimeout: 800,
          plugins: [],
          sensors: []
        };
        class Draggable {
          constructor(containers = [document.body], options = {}) {
            if (containers instanceof NodeList || containers instanceof Array) {
              this.containers = [...containers];
            } else if (containers instanceof HTMLElement) {
              this.containers = [containers];
            } else {
              throw new Error("Draggable containers are expected to be of type `NodeList`, `HTMLElement[]` or `HTMLElement`");
            }
            this.options = _extends2({}, defaultOptions2, options, {
              classes: _extends2({}, defaultClasses, options.classes || {}),
              announcements: _extends2({}, defaultAnnouncements, options.announcements || {})
            });
            this.emitter = new _Emitter2.default();
            this.dragging = false;
            this.plugins = [];
            this.sensors = [];
            this[onDragStart] = this[onDragStart].bind(this);
            this[onDragMove] = this[onDragMove].bind(this);
            this[onDragStop] = this[onDragStop].bind(this);
            this[onDragPressure] = this[onDragPressure].bind(this);
            document.addEventListener("drag:start", this[onDragStart], true);
            document.addEventListener("drag:move", this[onDragMove], true);
            document.addEventListener("drag:stop", this[onDragStop], true);
            document.addEventListener("drag:pressure", this[onDragPressure], true);
            const defaultPlugins = Object.values(Draggable.Plugins).map((Plugin) => Plugin);
            const defaultSensors = [_Sensors.MouseSensor, _Sensors.TouchSensor];
            this.addPlugin(...[...defaultPlugins, ...this.options.plugins]);
            this.addSensor(...[...defaultSensors, ...this.options.sensors]);
            const draggableInitializedEvent = new _DraggableEvent.DraggableInitializedEvent({
              draggable: this
            });
            this.on("mirror:created", ({ mirror }) => this.mirror = mirror);
            this.on("mirror:destroy", () => this.mirror = null);
            this.trigger(draggableInitializedEvent);
          }
          destroy() {
            document.removeEventListener("drag:start", this[onDragStart], true);
            document.removeEventListener("drag:move", this[onDragMove], true);
            document.removeEventListener("drag:stop", this[onDragStop], true);
            document.removeEventListener("drag:pressure", this[onDragPressure], true);
            const draggableDestroyEvent = new _DraggableEvent.DraggableDestroyEvent({
              draggable: this
            });
            this.trigger(draggableDestroyEvent);
            this.removePlugin(...this.plugins.map((plugin2) => plugin2.constructor));
            this.removeSensor(...this.sensors.map((sensor) => sensor.constructor));
          }
          addPlugin(...plugins) {
            const activePlugins = plugins.map((Plugin) => new Plugin(this));
            activePlugins.forEach((plugin2) => plugin2.attach());
            this.plugins = [...this.plugins, ...activePlugins];
            return this;
          }
          removePlugin(...plugins) {
            const removedPlugins = this.plugins.filter((plugin2) => plugins.includes(plugin2.constructor));
            removedPlugins.forEach((plugin2) => plugin2.detach());
            this.plugins = this.plugins.filter((plugin2) => !plugins.includes(plugin2.constructor));
            return this;
          }
          addSensor(...sensors) {
            const activeSensors = sensors.map((Sensor) => new Sensor(this.containers, this.options));
            activeSensors.forEach((sensor) => sensor.attach());
            this.sensors = [...this.sensors, ...activeSensors];
            return this;
          }
          removeSensor(...sensors) {
            const removedSensors = this.sensors.filter((sensor) => sensors.includes(sensor.constructor));
            removedSensors.forEach((sensor) => sensor.detach());
            this.sensors = this.sensors.filter((sensor) => !sensors.includes(sensor.constructor));
            return this;
          }
          addContainer(...containers) {
            this.containers = [...this.containers, ...containers];
            this.sensors.forEach((sensor) => sensor.addContainer(...containers));
            return this;
          }
          removeContainer(...containers) {
            this.containers = this.containers.filter((container) => !containers.includes(container));
            this.sensors.forEach((sensor) => sensor.removeContainer(...containers));
            return this;
          }
          on(type4, ...callbacks2) {
            this.emitter.on(type4, ...callbacks2);
            return this;
          }
          off(type4, callback) {
            this.emitter.off(type4, callback);
            return this;
          }
          trigger(event) {
            this.emitter.trigger(event);
            return this;
          }
          getClassNameFor(name2) {
            return this.options.classes[name2];
          }
          isDragging() {
            return Boolean(this.dragging);
          }
          getDraggableElements() {
            return this.containers.reduce((current, container) => {
              return [...current, ...this.getDraggableElementsForContainer(container)];
            }, []);
          }
          getDraggableElementsForContainer(container) {
            const allDraggableElements = container.querySelectorAll(this.options.draggable);
            return [...allDraggableElements].filter((childElement) => {
              return childElement !== this.originalSource && childElement !== this.mirror;
            });
          }
          [onDragStart](event) {
            const sensorEvent = getSensorEvent(event);
            const { target, container } = sensorEvent;
            if (!this.containers.includes(container)) {
              return;
            }
            if (this.options.handle && target && !(0, _utils.closest)(target, this.options.handle)) {
              sensorEvent.cancel();
              return;
            }
            this.originalSource = (0, _utils.closest)(target, this.options.draggable);
            this.sourceContainer = container;
            if (!this.originalSource) {
              sensorEvent.cancel();
              return;
            }
            if (this.lastPlacedSource && this.lastPlacedContainer) {
              clearTimeout(this.placedTimeoutID);
              this.lastPlacedSource.classList.remove(this.getClassNameFor("source:placed"));
              this.lastPlacedContainer.classList.remove(this.getClassNameFor("container:placed"));
            }
            this.source = this.originalSource.cloneNode(true);
            this.originalSource.parentNode.insertBefore(this.source, this.originalSource);
            this.originalSource.style.display = "none";
            const dragEvent = new _DragEvent.DragStartEvent({
              source: this.source,
              originalSource: this.originalSource,
              sourceContainer: container,
              sensorEvent
            });
            this.trigger(dragEvent);
            this.dragging = !dragEvent.canceled();
            if (dragEvent.canceled()) {
              this.source.parentNode.removeChild(this.source);
              this.originalSource.style.display = null;
              return;
            }
            this.originalSource.classList.add(this.getClassNameFor("source:original"));
            this.source.classList.add(this.getClassNameFor("source:dragging"));
            this.sourceContainer.classList.add(this.getClassNameFor("container:dragging"));
            document.body.classList.add(this.getClassNameFor("body:dragging"));
            applyUserSelect(document.body, "none");
            requestAnimationFrame(() => {
              const oldSensorEvent = getSensorEvent(event);
              const newSensorEvent = oldSensorEvent.clone({ target: this.source });
              this[onDragMove](_extends2({}, event, {
                detail: newSensorEvent
              }));
            });
          }
          [onDragMove](event) {
            if (!this.dragging) {
              return;
            }
            const sensorEvent = getSensorEvent(event);
            const { container } = sensorEvent;
            let target = sensorEvent.target;
            const dragMoveEvent = new _DragEvent.DragMoveEvent({
              source: this.source,
              originalSource: this.originalSource,
              sourceContainer: container,
              sensorEvent
            });
            this.trigger(dragMoveEvent);
            if (dragMoveEvent.canceled()) {
              sensorEvent.cancel();
            }
            target = (0, _utils.closest)(target, this.options.draggable);
            const withinCorrectContainer = (0, _utils.closest)(sensorEvent.target, this.containers);
            const overContainer = sensorEvent.overContainer || withinCorrectContainer;
            const isLeavingContainer = this.currentOverContainer && overContainer !== this.currentOverContainer;
            const isLeavingDraggable = this.currentOver && target !== this.currentOver;
            const isOverContainer = overContainer && this.currentOverContainer !== overContainer;
            const isOverDraggable = withinCorrectContainer && target && this.currentOver !== target;
            if (isLeavingDraggable) {
              const dragOutEvent = new _DragEvent.DragOutEvent({
                source: this.source,
                originalSource: this.originalSource,
                sourceContainer: container,
                sensorEvent,
                over: this.currentOver
              });
              this.currentOver.classList.remove(this.getClassNameFor("draggable:over"));
              this.currentOver = null;
              this.trigger(dragOutEvent);
            }
            if (isLeavingContainer) {
              const dragOutContainerEvent = new _DragEvent.DragOutContainerEvent({
                source: this.source,
                originalSource: this.originalSource,
                sourceContainer: container,
                sensorEvent,
                overContainer: this.currentOverContainer
              });
              this.currentOverContainer.classList.remove(this.getClassNameFor("container:over"));
              this.currentOverContainer = null;
              this.trigger(dragOutContainerEvent);
            }
            if (isOverContainer) {
              overContainer.classList.add(this.getClassNameFor("container:over"));
              const dragOverContainerEvent = new _DragEvent.DragOverContainerEvent({
                source: this.source,
                originalSource: this.originalSource,
                sourceContainer: container,
                sensorEvent,
                overContainer
              });
              this.currentOverContainer = overContainer;
              this.trigger(dragOverContainerEvent);
            }
            if (isOverDraggable) {
              target.classList.add(this.getClassNameFor("draggable:over"));
              const dragOverEvent = new _DragEvent.DragOverEvent({
                source: this.source,
                originalSource: this.originalSource,
                sourceContainer: container,
                sensorEvent,
                overContainer,
                over: target
              });
              this.currentOver = target;
              this.trigger(dragOverEvent);
            }
          }
          [onDragStop](event) {
            if (!this.dragging) {
              return;
            }
            this.dragging = false;
            const dragStopEvent = new _DragEvent.DragStopEvent({
              source: this.source,
              originalSource: this.originalSource,
              sensorEvent: event.sensorEvent,
              sourceContainer: this.sourceContainer
            });
            this.trigger(dragStopEvent);
            this.source.parentNode.insertBefore(this.originalSource, this.source);
            this.source.parentNode.removeChild(this.source);
            this.originalSource.style.display = "";
            this.source.classList.remove(this.getClassNameFor("source:dragging"));
            this.originalSource.classList.remove(this.getClassNameFor("source:original"));
            this.originalSource.classList.add(this.getClassNameFor("source:placed"));
            this.sourceContainer.classList.add(this.getClassNameFor("container:placed"));
            this.sourceContainer.classList.remove(this.getClassNameFor("container:dragging"));
            document.body.classList.remove(this.getClassNameFor("body:dragging"));
            applyUserSelect(document.body, "");
            if (this.currentOver) {
              this.currentOver.classList.remove(this.getClassNameFor("draggable:over"));
            }
            if (this.currentOverContainer) {
              this.currentOverContainer.classList.remove(this.getClassNameFor("container:over"));
            }
            this.lastPlacedSource = this.originalSource;
            this.lastPlacedContainer = this.sourceContainer;
            this.placedTimeoutID = setTimeout(() => {
              if (this.lastPlacedSource) {
                this.lastPlacedSource.classList.remove(this.getClassNameFor("source:placed"));
              }
              if (this.lastPlacedContainer) {
                this.lastPlacedContainer.classList.remove(this.getClassNameFor("container:placed"));
              }
              this.lastPlacedSource = null;
              this.lastPlacedContainer = null;
            }, this.options.placedTimeout);
            this.source = null;
            this.originalSource = null;
            this.currentOverContainer = null;
            this.currentOver = null;
            this.sourceContainer = null;
          }
          [onDragPressure](event) {
            if (!this.dragging) {
              return;
            }
            const sensorEvent = getSensorEvent(event);
            const source = this.source || (0, _utils.closest)(sensorEvent.originalEvent.target, this.options.draggable);
            const dragPressureEvent = new _DragEvent.DragPressureEvent({
              sensorEvent,
              source,
              pressure: sensorEvent.pressure
            });
            this.trigger(dragPressureEvent);
          }
        }
        exports3.default = Draggable;
        Draggable.Plugins = { Announcement: _Plugins.Announcement, Focusable: _Plugins.Focusable, Mirror: _Plugins.Mirror, Scrollable: _Plugins.Scrollable };
        function getSensorEvent(event) {
          return event.detail;
        }
        function applyUserSelect(element, value2) {
          element.style.webkitUserSelect = value2;
          element.style.mozUserSelect = value2;
          element.style.msUserSelect = value2;
          element.style.oUserSelect = value2;
          element.style.userSelect = value2;
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _Sensor = __webpack_require__(4);
        var _Sensor2 = _interopRequireDefault(_Sensor);
        var _SensorEvent = __webpack_require__(3);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onMouseForceWillBegin = Symbol("onMouseForceWillBegin");
        const onMouseForceDown = Symbol("onMouseForceDown");
        const onMouseDown = Symbol("onMouseDown");
        const onMouseForceChange = Symbol("onMouseForceChange");
        const onMouseMove = Symbol("onMouseMove");
        const onMouseUp = Symbol("onMouseUp");
        const onMouseForceGlobalChange = Symbol("onMouseForceGlobalChange");
        class ForceTouchSensor extends _Sensor2.default {
          constructor(containers = [], options = {}) {
            super(containers, options);
            this.mightDrag = false;
            this[onMouseForceWillBegin] = this[onMouseForceWillBegin].bind(this);
            this[onMouseForceDown] = this[onMouseForceDown].bind(this);
            this[onMouseDown] = this[onMouseDown].bind(this);
            this[onMouseForceChange] = this[onMouseForceChange].bind(this);
            this[onMouseMove] = this[onMouseMove].bind(this);
            this[onMouseUp] = this[onMouseUp].bind(this);
          }
          attach() {
            for (const container of this.containers) {
              container.addEventListener("webkitmouseforcewillbegin", this[onMouseForceWillBegin], false);
              container.addEventListener("webkitmouseforcedown", this[onMouseForceDown], false);
              container.addEventListener("mousedown", this[onMouseDown], true);
              container.addEventListener("webkitmouseforcechanged", this[onMouseForceChange], false);
            }
            document.addEventListener("mousemove", this[onMouseMove]);
            document.addEventListener("mouseup", this[onMouseUp]);
          }
          detach() {
            for (const container of this.containers) {
              container.removeEventListener("webkitmouseforcewillbegin", this[onMouseForceWillBegin], false);
              container.removeEventListener("webkitmouseforcedown", this[onMouseForceDown], false);
              container.removeEventListener("mousedown", this[onMouseDown], true);
              container.removeEventListener("webkitmouseforcechanged", this[onMouseForceChange], false);
            }
            document.removeEventListener("mousemove", this[onMouseMove]);
            document.removeEventListener("mouseup", this[onMouseUp]);
          }
          [onMouseForceWillBegin](event) {
            event.preventDefault();
            this.mightDrag = true;
          }
          [onMouseForceDown](event) {
            if (this.dragging) {
              return;
            }
            const target = document.elementFromPoint(event.clientX, event.clientY);
            const container = event.currentTarget;
            const dragStartEvent = new _SensorEvent.DragStartSensorEvent({
              clientX: event.clientX,
              clientY: event.clientY,
              target,
              container,
              originalEvent: event
            });
            this.trigger(container, dragStartEvent);
            this.currentContainer = container;
            this.dragging = !dragStartEvent.canceled();
            this.mightDrag = false;
          }
          [onMouseUp](event) {
            if (!this.dragging) {
              return;
            }
            const dragStopEvent = new _SensorEvent.DragStopSensorEvent({
              clientX: event.clientX,
              clientY: event.clientY,
              target: null,
              container: this.currentContainer,
              originalEvent: event
            });
            this.trigger(this.currentContainer, dragStopEvent);
            this.currentContainer = null;
            this.dragging = false;
            this.mightDrag = false;
          }
          [onMouseDown](event) {
            if (!this.mightDrag) {
              return;
            }
            event.stopPropagation();
            event.stopImmediatePropagation();
            event.preventDefault();
          }
          [onMouseMove](event) {
            if (!this.dragging) {
              return;
            }
            const target = document.elementFromPoint(event.clientX, event.clientY);
            const dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
              clientX: event.clientX,
              clientY: event.clientY,
              target,
              container: this.currentContainer,
              originalEvent: event
            });
            this.trigger(this.currentContainer, dragMoveEvent);
          }
          [onMouseForceChange](event) {
            if (this.dragging) {
              return;
            }
            const target = event.target;
            const container = event.currentTarget;
            const dragPressureEvent = new _SensorEvent.DragPressureSensorEvent({
              pressure: event.webkitForce,
              clientX: event.clientX,
              clientY: event.clientY,
              target,
              container,
              originalEvent: event
            });
            this.trigger(container, dragPressureEvent);
          }
          [onMouseForceGlobalChange](event) {
            if (!this.dragging) {
              return;
            }
            const target = event.target;
            const dragPressureEvent = new _SensorEvent.DragPressureSensorEvent({
              pressure: event.webkitForce,
              clientX: event.clientX,
              clientY: event.clientY,
              target,
              container: this.currentContainer,
              originalEvent: event
            });
            this.trigger(this.currentContainer, dragPressureEvent);
          }
        }
        exports3.default = ForceTouchSensor;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _ForceTouchSensor = __webpack_require__(38);
        var _ForceTouchSensor2 = _interopRequireDefault(_ForceTouchSensor);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _ForceTouchSensor2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _utils = __webpack_require__(2);
        var _Sensor = __webpack_require__(4);
        var _Sensor2 = _interopRequireDefault(_Sensor);
        var _SensorEvent = __webpack_require__(3);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onMouseDown = Symbol("onMouseDown");
        const onMouseUp = Symbol("onMouseUp");
        const onDragStart = Symbol("onDragStart");
        const onDragOver = Symbol("onDragOver");
        const onDragEnd = Symbol("onDragEnd");
        const onDrop = Symbol("onDrop");
        const reset = Symbol("reset");
        class DragSensor extends _Sensor2.default {
          constructor(containers = [], options = {}) {
            super(containers, options);
            this.mouseDownTimeout = null;
            this.draggableElement = null;
            this.nativeDraggableElement = null;
            this[onMouseDown] = this[onMouseDown].bind(this);
            this[onMouseUp] = this[onMouseUp].bind(this);
            this[onDragStart] = this[onDragStart].bind(this);
            this[onDragOver] = this[onDragOver].bind(this);
            this[onDragEnd] = this[onDragEnd].bind(this);
            this[onDrop] = this[onDrop].bind(this);
          }
          attach() {
            document.addEventListener("mousedown", this[onMouseDown], true);
          }
          detach() {
            document.removeEventListener("mousedown", this[onMouseDown], true);
          }
          [onDragStart](event) {
            event.dataTransfer.setData("text", "");
            event.dataTransfer.effectAllowed = this.options.type;
            const target = document.elementFromPoint(event.clientX, event.clientY);
            this.currentContainer = (0, _utils.closest)(event.target, this.containers);
            if (!this.currentContainer) {
              return;
            }
            const dragStartEvent = new _SensorEvent.DragStartSensorEvent({
              clientX: event.clientX,
              clientY: event.clientY,
              target,
              container: this.currentContainer,
              originalEvent: event
            });
            setTimeout(() => {
              this.trigger(this.currentContainer, dragStartEvent);
              if (dragStartEvent.canceled()) {
                this.dragging = false;
              } else {
                this.dragging = true;
              }
            }, 0);
          }
          [onDragOver](event) {
            if (!this.dragging) {
              return;
            }
            const target = document.elementFromPoint(event.clientX, event.clientY);
            const container = this.currentContainer;
            const dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
              clientX: event.clientX,
              clientY: event.clientY,
              target,
              container,
              originalEvent: event
            });
            this.trigger(container, dragMoveEvent);
            if (!dragMoveEvent.canceled()) {
              event.preventDefault();
              event.dataTransfer.dropEffect = this.options.type;
            }
          }
          [onDragEnd](event) {
            if (!this.dragging) {
              return;
            }
            document.removeEventListener("mouseup", this[onMouseUp], true);
            const target = document.elementFromPoint(event.clientX, event.clientY);
            const container = this.currentContainer;
            const dragStopEvent = new _SensorEvent.DragStopSensorEvent({
              clientX: event.clientX,
              clientY: event.clientY,
              target,
              container,
              originalEvent: event
            });
            this.trigger(container, dragStopEvent);
            this.dragging = false;
            this[reset]();
          }
          [onDrop](event) {
            event.preventDefault();
          }
          [onMouseDown](event) {
            if (event.target && (event.target.form || event.target.contenteditable)) {
              return;
            }
            const nativeDraggableElement = (0, _utils.closest)(event.target, (element) => element.draggable);
            if (nativeDraggableElement) {
              nativeDraggableElement.draggable = false;
              this.nativeDraggableElement = nativeDraggableElement;
            }
            document.addEventListener("mouseup", this[onMouseUp], true);
            document.addEventListener("dragstart", this[onDragStart], false);
            document.addEventListener("dragover", this[onDragOver], false);
            document.addEventListener("dragend", this[onDragEnd], false);
            document.addEventListener("drop", this[onDrop], false);
            const target = (0, _utils.closest)(event.target, this.options.draggable);
            if (!target) {
              return;
            }
            this.mouseDownTimeout = setTimeout(() => {
              target.draggable = true;
              this.draggableElement = target;
            }, this.options.delay);
          }
          [onMouseUp]() {
            this[reset]();
          }
          [reset]() {
            clearTimeout(this.mouseDownTimeout);
            document.removeEventListener("mouseup", this[onMouseUp], true);
            document.removeEventListener("dragstart", this[onDragStart], false);
            document.removeEventListener("dragover", this[onDragOver], false);
            document.removeEventListener("dragend", this[onDragEnd], false);
            document.removeEventListener("drop", this[onDrop], false);
            if (this.nativeDraggableElement) {
              this.nativeDraggableElement.draggable = true;
              this.nativeDraggableElement = null;
            }
            if (this.draggableElement) {
              this.draggableElement.draggable = false;
              this.draggableElement = null;
            }
          }
        }
        exports3.default = DragSensor;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _DragSensor = __webpack_require__(40);
        var _DragSensor2 = _interopRequireDefault(_DragSensor);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _DragSensor2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _utils = __webpack_require__(2);
        var _Sensor = __webpack_require__(4);
        var _Sensor2 = _interopRequireDefault(_Sensor);
        var _SensorEvent = __webpack_require__(3);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onTouchStart = Symbol("onTouchStart");
        const onTouchHold = Symbol("onTouchHold");
        const onTouchEnd = Symbol("onTouchEnd");
        const onTouchMove = Symbol("onTouchMove");
        let preventScrolling = false;
        window.addEventListener("touchmove", (event) => {
          if (!preventScrolling) {
            return;
          }
          event.preventDefault();
        }, { passive: false });
        class TouchSensor extends _Sensor2.default {
          constructor(containers = [], options = {}) {
            super(containers, options);
            this.currentScrollableParent = null;
            this.tapTimeout = null;
            this.touchMoved = false;
            this[onTouchStart] = this[onTouchStart].bind(this);
            this[onTouchHold] = this[onTouchHold].bind(this);
            this[onTouchEnd] = this[onTouchEnd].bind(this);
            this[onTouchMove] = this[onTouchMove].bind(this);
          }
          attach() {
            document.addEventListener("touchstart", this[onTouchStart]);
          }
          detach() {
            document.removeEventListener("touchstart", this[onTouchStart]);
          }
          [onTouchStart](event) {
            const container = (0, _utils.closest)(event.target, this.containers);
            if (!container) {
              return;
            }
            document.addEventListener("touchmove", this[onTouchMove]);
            document.addEventListener("touchend", this[onTouchEnd]);
            document.addEventListener("touchcancel", this[onTouchEnd]);
            container.addEventListener("contextmenu", onContextMenu);
            this.currentContainer = container;
            this.tapTimeout = setTimeout(this[onTouchHold](event, container), this.options.delay);
          }
          [onTouchHold](event, container) {
            return () => {
              if (this.touchMoved) {
                return;
              }
              const touch = event.touches[0] || event.changedTouches[0];
              const target = event.target;
              const dragStartEvent = new _SensorEvent.DragStartSensorEvent({
                clientX: touch.pageX,
                clientY: touch.pageY,
                target,
                container,
                originalEvent: event
              });
              this.trigger(container, dragStartEvent);
              this.dragging = !dragStartEvent.canceled();
              preventScrolling = this.dragging;
            };
          }
          [onTouchMove](event) {
            this.touchMoved = true;
            if (!this.dragging) {
              return;
            }
            const touch = event.touches[0] || event.changedTouches[0];
            const target = document.elementFromPoint(touch.pageX - window.scrollX, touch.pageY - window.scrollY);
            const dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
              clientX: touch.pageX,
              clientY: touch.pageY,
              target,
              container: this.currentContainer,
              originalEvent: event
            });
            this.trigger(this.currentContainer, dragMoveEvent);
          }
          [onTouchEnd](event) {
            this.touchMoved = false;
            preventScrolling = false;
            document.removeEventListener("touchend", this[onTouchEnd]);
            document.removeEventListener("touchcancel", this[onTouchEnd]);
            document.removeEventListener("touchmove", this[onTouchMove]);
            if (this.currentContainer) {
              this.currentContainer.removeEventListener("contextmenu", onContextMenu);
            }
            clearTimeout(this.tapTimeout);
            if (!this.dragging) {
              return;
            }
            const touch = event.touches[0] || event.changedTouches[0];
            const target = document.elementFromPoint(touch.pageX - window.scrollX, touch.pageY - window.scrollY);
            event.preventDefault();
            const dragStopEvent = new _SensorEvent.DragStopSensorEvent({
              clientX: touch.pageX,
              clientY: touch.pageY,
              target,
              container: this.currentContainer,
              originalEvent: event
            });
            this.trigger(this.currentContainer, dragStopEvent);
            this.currentContainer = null;
            this.dragging = false;
          }
        }
        exports3.default = TouchSensor;
        function onContextMenu(event) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _TouchSensor = __webpack_require__(42);
        var _TouchSensor2 = _interopRequireDefault(_TouchSensor);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _TouchSensor2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.DragPressureSensorEvent = exports3.DragStopSensorEvent = exports3.DragMoveSensorEvent = exports3.DragStartSensorEvent = exports3.SensorEvent = void 0;
        var _AbstractEvent = __webpack_require__(0);
        var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        class SensorEvent extends _AbstractEvent2.default {
          get originalEvent() {
            return this.data.originalEvent;
          }
          get clientX() {
            return this.data.clientX;
          }
          get clientY() {
            return this.data.clientY;
          }
          get target() {
            return this.data.target;
          }
          get container() {
            return this.data.container;
          }
          get pressure() {
            return this.data.pressure;
          }
        }
        exports3.SensorEvent = SensorEvent;
        class DragStartSensorEvent extends SensorEvent {
        }
        exports3.DragStartSensorEvent = DragStartSensorEvent;
        DragStartSensorEvent.type = "drag:start";
        class DragMoveSensorEvent extends SensorEvent {
        }
        exports3.DragMoveSensorEvent = DragMoveSensorEvent;
        DragMoveSensorEvent.type = "drag:move";
        class DragStopSensorEvent extends SensorEvent {
        }
        exports3.DragStopSensorEvent = DragStopSensorEvent;
        DragStopSensorEvent.type = "drag:stop";
        class DragPressureSensorEvent extends SensorEvent {
        }
        exports3.DragPressureSensorEvent = DragPressureSensorEvent;
        DragPressureSensorEvent.type = "drag:pressure";
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _utils = __webpack_require__(2);
        var _Sensor = __webpack_require__(4);
        var _Sensor2 = _interopRequireDefault(_Sensor);
        var _SensorEvent = __webpack_require__(3);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onContextMenuWhileDragging = Symbol("onContextMenuWhileDragging");
        const onMouseDown = Symbol("onMouseDown");
        const onMouseMove = Symbol("onMouseMove");
        const onMouseUp = Symbol("onMouseUp");
        class MouseSensor extends _Sensor2.default {
          constructor(containers = [], options = {}) {
            super(containers, options);
            this.mouseDown = false;
            this.mouseDownTimeout = null;
            this.openedContextMenu = false;
            this[onContextMenuWhileDragging] = this[onContextMenuWhileDragging].bind(this);
            this[onMouseDown] = this[onMouseDown].bind(this);
            this[onMouseMove] = this[onMouseMove].bind(this);
            this[onMouseUp] = this[onMouseUp].bind(this);
          }
          attach() {
            document.addEventListener("mousedown", this[onMouseDown], true);
          }
          detach() {
            document.removeEventListener("mousedown", this[onMouseDown], true);
          }
          [onMouseDown](event) {
            if (event.button !== 0 || event.ctrlKey || event.metaKey) {
              return;
            }
            document.addEventListener("mouseup", this[onMouseUp]);
            const target = document.elementFromPoint(event.clientX, event.clientY);
            const container = (0, _utils.closest)(target, this.containers);
            if (!container) {
              return;
            }
            document.addEventListener("dragstart", preventNativeDragStart);
            this.mouseDown = true;
            clearTimeout(this.mouseDownTimeout);
            this.mouseDownTimeout = setTimeout(() => {
              if (!this.mouseDown) {
                return;
              }
              const dragStartEvent = new _SensorEvent.DragStartSensorEvent({
                clientX: event.clientX,
                clientY: event.clientY,
                target,
                container,
                originalEvent: event
              });
              this.trigger(container, dragStartEvent);
              this.currentContainer = container;
              this.dragging = !dragStartEvent.canceled();
              if (this.dragging) {
                document.addEventListener("contextmenu", this[onContextMenuWhileDragging]);
                document.addEventListener("mousemove", this[onMouseMove]);
              }
            }, this.options.delay);
          }
          [onMouseMove](event) {
            if (!this.dragging) {
              return;
            }
            const target = document.elementFromPoint(event.clientX, event.clientY);
            const dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
              clientX: event.clientX,
              clientY: event.clientY,
              target,
              container: this.currentContainer,
              originalEvent: event
            });
            this.trigger(this.currentContainer, dragMoveEvent);
          }
          [onMouseUp](event) {
            this.mouseDown = Boolean(this.openedContextMenu);
            if (this.openedContextMenu) {
              this.openedContextMenu = false;
              return;
            }
            document.removeEventListener("mouseup", this[onMouseUp]);
            document.removeEventListener("dragstart", preventNativeDragStart);
            if (!this.dragging) {
              return;
            }
            const target = document.elementFromPoint(event.clientX, event.clientY);
            const dragStopEvent = new _SensorEvent.DragStopSensorEvent({
              clientX: event.clientX,
              clientY: event.clientY,
              target,
              container: this.currentContainer,
              originalEvent: event
            });
            this.trigger(this.currentContainer, dragStopEvent);
            document.removeEventListener("contextmenu", this[onContextMenuWhileDragging]);
            document.removeEventListener("mousemove", this[onMouseMove]);
            this.currentContainer = null;
            this.dragging = false;
          }
          [onContextMenuWhileDragging](event) {
            event.preventDefault();
            this.openedContextMenu = true;
          }
        }
        exports3.default = MouseSensor;
        function preventNativeDragStart(event) {
          event.preventDefault();
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _MouseSensor = __webpack_require__(45);
        var _MouseSensor2 = _interopRequireDefault(_MouseSensor);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _MouseSensor2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _extends2 = Object.assign || function(target) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            var source = arguments[i2];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        class Sensor {
          constructor(containers = [], options = {}) {
            this.containers = [...containers];
            this.options = _extends2({}, options);
            this.dragging = false;
            this.currentContainer = null;
          }
          attach() {
            return this;
          }
          detach() {
            return this;
          }
          addContainer(...containers) {
            this.containers = [...this.containers, ...containers];
          }
          removeContainer(...containers) {
            this.containers = this.containers.filter((container) => !containers.includes(container));
          }
          trigger(element, sensorEvent) {
            const event = document.createEvent("Event");
            event.detail = sensorEvent;
            event.initEvent(sensorEvent.type, true, true);
            element.dispatchEvent(event);
            this.lastEvent = sensorEvent;
            return sensorEvent;
          }
        }
        exports3.default = Sensor;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.default = requestNextAnimationFrame;
        function requestNextAnimationFrame(callback) {
          return requestAnimationFrame(() => {
            requestAnimationFrame(callback);
          });
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _requestNextAnimationFrame = __webpack_require__(48);
        var _requestNextAnimationFrame2 = _interopRequireDefault(_requestNextAnimationFrame);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _requestNextAnimationFrame2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.default = closest;
        const matchFunction = Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
        function closest(element, value2) {
          if (!element) {
            return null;
          }
          const selector2 = value2;
          const callback = value2;
          const nodeList = value2;
          const singleElement = value2;
          const isSelector = Boolean(typeof value2 === "string");
          const isFunction2 = Boolean(typeof value2 === "function");
          const isNodeList = Boolean(value2 instanceof NodeList || value2 instanceof Array);
          const isElement2 = Boolean(value2 instanceof HTMLElement);
          function conditionFn(currentElement) {
            if (!currentElement) {
              return currentElement;
            } else if (isSelector) {
              return matchFunction.call(currentElement, selector2);
            } else if (isNodeList) {
              return [...nodeList].includes(currentElement);
            } else if (isElement2) {
              return singleElement === currentElement;
            } else if (isFunction2) {
              return callback(currentElement);
            } else {
              return null;
            }
          }
          let current = element;
          do {
            current = current.correspondingUseElement || current.correspondingElement || current;
            if (conditionFn(current)) {
              return current;
            }
            current = current.parentNode;
          } while (current && current !== document.body && current !== document);
          return null;
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _closest = __webpack_require__(50);
        var _closest2 = _interopRequireDefault(_closest);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _closest2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.defaultOptions = exports3.scroll = exports3.onDragStop = exports3.onDragMove = exports3.onDragStart = void 0;
        var _extends2 = Object.assign || function(target) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            var source = arguments[i2];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _AbstractPlugin = __webpack_require__(1);
        var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);
        var _utils = __webpack_require__(2);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onDragStart = exports3.onDragStart = Symbol("onDragStart");
        const onDragMove = exports3.onDragMove = Symbol("onDragMove");
        const onDragStop = exports3.onDragStop = Symbol("onDragStop");
        const scroll = exports3.scroll = Symbol("scroll");
        const defaultOptions2 = exports3.defaultOptions = {
          speed: 6,
          sensitivity: 50,
          scrollableElements: []
        };
        class Scrollable extends _AbstractPlugin2.default {
          constructor(draggable) {
            super(draggable);
            this.options = _extends2({}, defaultOptions2, this.getOptions());
            this.currentMousePosition = null;
            this.scrollAnimationFrame = null;
            this.scrollableElement = null;
            this.findScrollableElementFrame = null;
            this[onDragStart] = this[onDragStart].bind(this);
            this[onDragMove] = this[onDragMove].bind(this);
            this[onDragStop] = this[onDragStop].bind(this);
            this[scroll] = this[scroll].bind(this);
          }
          attach() {
            this.draggable.on("drag:start", this[onDragStart]).on("drag:move", this[onDragMove]).on("drag:stop", this[onDragStop]);
          }
          detach() {
            this.draggable.off("drag:start", this[onDragStart]).off("drag:move", this[onDragMove]).off("drag:stop", this[onDragStop]);
          }
          getOptions() {
            return this.draggable.options.scrollable || {};
          }
          getScrollableElement(target) {
            if (this.hasDefinedScrollableElements()) {
              return (0, _utils.closest)(target, this.options.scrollableElements) || document.documentElement;
            } else {
              return closestScrollableElement(target);
            }
          }
          hasDefinedScrollableElements() {
            return Boolean(this.options.scrollableElements.length !== 0);
          }
          [onDragStart](dragEvent) {
            this.findScrollableElementFrame = requestAnimationFrame(() => {
              this.scrollableElement = this.getScrollableElement(dragEvent.source);
            });
          }
          [onDragMove](dragEvent) {
            this.findScrollableElementFrame = requestAnimationFrame(() => {
              this.scrollableElement = this.getScrollableElement(dragEvent.sensorEvent.target);
            });
            if (!this.scrollableElement) {
              return;
            }
            const sensorEvent = dragEvent.sensorEvent;
            const scrollOffset = { x: 0, y: 0 };
            if ("ontouchstart" in window) {
              scrollOffset.y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
              scrollOffset.x = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
            }
            this.currentMousePosition = {
              clientX: sensorEvent.clientX - scrollOffset.x,
              clientY: sensorEvent.clientY - scrollOffset.y
            };
            this.scrollAnimationFrame = requestAnimationFrame(this[scroll]);
          }
          [onDragStop]() {
            cancelAnimationFrame(this.scrollAnimationFrame);
            cancelAnimationFrame(this.findScrollableElementFrame);
            this.scrollableElement = null;
            this.scrollAnimationFrame = null;
            this.findScrollableElementFrame = null;
            this.currentMousePosition = null;
          }
          [scroll]() {
            if (!this.scrollableElement || !this.currentMousePosition) {
              return;
            }
            cancelAnimationFrame(this.scrollAnimationFrame);
            const { speed, sensitivity } = this.options;
            const rect = this.scrollableElement.getBoundingClientRect();
            const bottomCutOff = rect.bottom > window.innerHeight;
            const topCutOff = rect.top < 0;
            const cutOff = topCutOff || bottomCutOff;
            const documentScrollingElement = getDocumentScrollingElement();
            const scrollableElement = this.scrollableElement;
            const clientX = this.currentMousePosition.clientX;
            const clientY = this.currentMousePosition.clientY;
            if (scrollableElement !== document.body && scrollableElement !== document.documentElement && !cutOff) {
              const { offsetHeight, offsetWidth } = scrollableElement;
              if (rect.top + offsetHeight - clientY < sensitivity) {
                scrollableElement.scrollTop += speed;
              } else if (clientY - rect.top < sensitivity) {
                scrollableElement.scrollTop -= speed;
              }
              if (rect.left + offsetWidth - clientX < sensitivity) {
                scrollableElement.scrollLeft += speed;
              } else if (clientX - rect.left < sensitivity) {
                scrollableElement.scrollLeft -= speed;
              }
            } else {
              const { innerHeight: innerHeight2, innerWidth } = window;
              if (clientY < sensitivity) {
                documentScrollingElement.scrollTop -= speed;
              } else if (innerHeight2 - clientY < sensitivity) {
                documentScrollingElement.scrollTop += speed;
              }
              if (clientX < sensitivity) {
                documentScrollingElement.scrollLeft -= speed;
              } else if (innerWidth - clientX < sensitivity) {
                documentScrollingElement.scrollLeft += speed;
              }
            }
            this.scrollAnimationFrame = requestAnimationFrame(this[scroll]);
          }
        }
        exports3.default = Scrollable;
        function hasOverflow(element) {
          const overflowRegex = /(auto|scroll)/;
          const computedStyles = getComputedStyle(element, null);
          const overflow = computedStyles.getPropertyValue("overflow") + computedStyles.getPropertyValue("overflow-y") + computedStyles.getPropertyValue("overflow-x");
          return overflowRegex.test(overflow);
        }
        function isStaticallyPositioned(element) {
          const position = getComputedStyle(element).getPropertyValue("position");
          return position === "static";
        }
        function closestScrollableElement(element) {
          if (!element) {
            return getDocumentScrollingElement();
          }
          const position = getComputedStyle(element).getPropertyValue("position");
          const excludeStaticParents = position === "absolute";
          const scrollableElement = (0, _utils.closest)(element, (parent) => {
            if (excludeStaticParents && isStaticallyPositioned(parent)) {
              return false;
            }
            return hasOverflow(parent);
          });
          if (position === "fixed" || !scrollableElement) {
            return getDocumentScrollingElement();
          } else {
            return scrollableElement;
          }
        }
        function getDocumentScrollingElement() {
          return document.scrollingElement || document.documentElement;
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.defaultOptions = void 0;
        var _Scrollable = __webpack_require__(52);
        var _Scrollable2 = _interopRequireDefault(_Scrollable);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _Scrollable2.default;
        exports3.defaultOptions = _Scrollable.defaultOptions;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.MirrorDestroyEvent = exports3.MirrorMoveEvent = exports3.MirrorAttachedEvent = exports3.MirrorCreatedEvent = exports3.MirrorCreateEvent = exports3.MirrorEvent = void 0;
        var _AbstractEvent = __webpack_require__(0);
        var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        class MirrorEvent extends _AbstractEvent2.default {
          get source() {
            return this.data.source;
          }
          get originalSource() {
            return this.data.originalSource;
          }
          get sourceContainer() {
            return this.data.sourceContainer;
          }
          get sensorEvent() {
            return this.data.sensorEvent;
          }
          get dragEvent() {
            return this.data.dragEvent;
          }
          get originalEvent() {
            if (this.sensorEvent) {
              return this.sensorEvent.originalEvent;
            }
            return null;
          }
        }
        exports3.MirrorEvent = MirrorEvent;
        class MirrorCreateEvent extends MirrorEvent {
        }
        exports3.MirrorCreateEvent = MirrorCreateEvent;
        MirrorCreateEvent.type = "mirror:create";
        class MirrorCreatedEvent extends MirrorEvent {
          get mirror() {
            return this.data.mirror;
          }
        }
        exports3.MirrorCreatedEvent = MirrorCreatedEvent;
        MirrorCreatedEvent.type = "mirror:created";
        class MirrorAttachedEvent extends MirrorEvent {
          get mirror() {
            return this.data.mirror;
          }
        }
        exports3.MirrorAttachedEvent = MirrorAttachedEvent;
        MirrorAttachedEvent.type = "mirror:attached";
        class MirrorMoveEvent extends MirrorEvent {
          get mirror() {
            return this.data.mirror;
          }
        }
        exports3.MirrorMoveEvent = MirrorMoveEvent;
        MirrorMoveEvent.type = "mirror:move";
        MirrorMoveEvent.cancelable = true;
        class MirrorDestroyEvent extends MirrorEvent {
          get mirror() {
            return this.data.mirror;
          }
        }
        exports3.MirrorDestroyEvent = MirrorDestroyEvent;
        MirrorDestroyEvent.type = "mirror:destroy";
        MirrorDestroyEvent.cancelable = true;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _MirrorEvent = __webpack_require__(54);
        Object.keys(_MirrorEvent).forEach(function(key) {
          if (key === "default" || key === "__esModule")
            return;
          Object.defineProperty(exports3, key, {
            enumerable: true,
            get: function() {
              return _MirrorEvent[key];
            }
          });
        });
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.defaultOptions = exports3.getAppendableContainer = exports3.onScroll = exports3.onMirrorMove = exports3.onMirrorCreated = exports3.onDragStop = exports3.onDragMove = exports3.onDragStart = void 0;
        var _extends2 = Object.assign || function(target) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            var source = arguments[i2];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _AbstractPlugin = __webpack_require__(1);
        var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);
        var _MirrorEvent = __webpack_require__(55);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        function _objectWithoutProperties(obj, keys2) {
          var target = {};
          for (var i2 in obj) {
            if (keys2.indexOf(i2) >= 0)
              continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i2))
              continue;
            target[i2] = obj[i2];
          }
          return target;
        }
        const onDragStart = exports3.onDragStart = Symbol("onDragStart");
        const onDragMove = exports3.onDragMove = Symbol("onDragMove");
        const onDragStop = exports3.onDragStop = Symbol("onDragStop");
        const onMirrorCreated = exports3.onMirrorCreated = Symbol("onMirrorCreated");
        const onMirrorMove = exports3.onMirrorMove = Symbol("onMirrorMove");
        const onScroll = exports3.onScroll = Symbol("onScroll");
        const getAppendableContainer = exports3.getAppendableContainer = Symbol("getAppendableContainer");
        const defaultOptions2 = exports3.defaultOptions = {
          constrainDimensions: false,
          xAxis: true,
          yAxis: true,
          cursorOffsetX: null,
          cursorOffsetY: null
        };
        class Mirror extends _AbstractPlugin2.default {
          constructor(draggable) {
            super(draggable);
            this.options = _extends2({}, defaultOptions2, this.getOptions());
            this.scrollOffset = { x: 0, y: 0 };
            this.initialScrollOffset = {
              x: window.scrollX,
              y: window.scrollY
            };
            this[onDragStart] = this[onDragStart].bind(this);
            this[onDragMove] = this[onDragMove].bind(this);
            this[onDragStop] = this[onDragStop].bind(this);
            this[onMirrorCreated] = this[onMirrorCreated].bind(this);
            this[onMirrorMove] = this[onMirrorMove].bind(this);
            this[onScroll] = this[onScroll].bind(this);
          }
          attach() {
            this.draggable.on("drag:start", this[onDragStart]).on("drag:move", this[onDragMove]).on("drag:stop", this[onDragStop]).on("mirror:created", this[onMirrorCreated]).on("mirror:move", this[onMirrorMove]);
          }
          detach() {
            this.draggable.off("drag:start", this[onDragStart]).off("drag:move", this[onDragMove]).off("drag:stop", this[onDragStop]).off("mirror:created", this[onMirrorCreated]).off("mirror:move", this[onMirrorMove]);
          }
          getOptions() {
            return this.draggable.options.mirror || {};
          }
          [onDragStart](dragEvent) {
            if (dragEvent.canceled()) {
              return;
            }
            if ("ontouchstart" in window) {
              document.addEventListener("scroll", this[onScroll], true);
            }
            this.initialScrollOffset = {
              x: window.scrollX,
              y: window.scrollY
            };
            const { source, originalSource, sourceContainer, sensorEvent } = dragEvent;
            const mirrorCreateEvent = new _MirrorEvent.MirrorCreateEvent({
              source,
              originalSource,
              sourceContainer,
              sensorEvent,
              dragEvent
            });
            this.draggable.trigger(mirrorCreateEvent);
            if (isNativeDragEvent(sensorEvent) || mirrorCreateEvent.canceled()) {
              return;
            }
            const appendableContainer = this[getAppendableContainer](source) || sourceContainer;
            this.mirror = source.cloneNode(true);
            const mirrorCreatedEvent = new _MirrorEvent.MirrorCreatedEvent({
              source,
              originalSource,
              sourceContainer,
              sensorEvent,
              dragEvent,
              mirror: this.mirror
            });
            const mirrorAttachedEvent = new _MirrorEvent.MirrorAttachedEvent({
              source,
              originalSource,
              sourceContainer,
              sensorEvent,
              dragEvent,
              mirror: this.mirror
            });
            this.draggable.trigger(mirrorCreatedEvent);
            appendableContainer.appendChild(this.mirror);
            this.draggable.trigger(mirrorAttachedEvent);
          }
          [onDragMove](dragEvent) {
            if (!this.mirror || dragEvent.canceled()) {
              return;
            }
            const { source, originalSource, sourceContainer, sensorEvent } = dragEvent;
            const mirrorMoveEvent = new _MirrorEvent.MirrorMoveEvent({
              source,
              originalSource,
              sourceContainer,
              sensorEvent,
              dragEvent,
              mirror: this.mirror
            });
            this.draggable.trigger(mirrorMoveEvent);
          }
          [onDragStop](dragEvent) {
            if ("ontouchstart" in window) {
              document.removeEventListener("scroll", this[onScroll], true);
            }
            this.initialScrollOffset = { x: 0, y: 0 };
            this.scrollOffset = { x: 0, y: 0 };
            if (!this.mirror) {
              return;
            }
            const { source, sourceContainer, sensorEvent } = dragEvent;
            const mirrorDestroyEvent = new _MirrorEvent.MirrorDestroyEvent({
              source,
              mirror: this.mirror,
              sourceContainer,
              sensorEvent,
              dragEvent
            });
            this.draggable.trigger(mirrorDestroyEvent);
            if (!mirrorDestroyEvent.canceled()) {
              this.mirror.parentNode.removeChild(this.mirror);
            }
          }
          [onScroll]() {
            this.scrollOffset = {
              x: window.scrollX - this.initialScrollOffset.x,
              y: window.scrollY - this.initialScrollOffset.y
            };
          }
          [onMirrorCreated]({ mirror, source, sensorEvent }) {
            const mirrorClass = this.draggable.getClassNameFor("mirror");
            const setState = (_ref) => {
              let { mirrorOffset, initialX, initialY } = _ref, args = _objectWithoutProperties(_ref, ["mirrorOffset", "initialX", "initialY"]);
              this.mirrorOffset = mirrorOffset;
              this.initialX = initialX;
              this.initialY = initialY;
              return _extends2({ mirrorOffset, initialX, initialY }, args);
            };
            const initialState = {
              mirror,
              source,
              sensorEvent,
              mirrorClass,
              scrollOffset: this.scrollOffset,
              options: this.options
            };
            return Promise.resolve(initialState).then(computeMirrorDimensions).then(calculateMirrorOffset).then(resetMirror).then(addMirrorClasses).then(positionMirror({ initial: true })).then(removeMirrorID).then(setState);
          }
          [onMirrorMove](mirrorEvent) {
            if (mirrorEvent.canceled()) {
              return null;
            }
            const initialState = {
              mirror: mirrorEvent.mirror,
              sensorEvent: mirrorEvent.sensorEvent,
              mirrorOffset: this.mirrorOffset,
              options: this.options,
              initialX: this.initialX,
              initialY: this.initialY,
              scrollOffset: this.scrollOffset
            };
            return Promise.resolve(initialState).then(positionMirror({ raf: true }));
          }
          [getAppendableContainer](source) {
            const appendTo = this.options.appendTo;
            if (typeof appendTo === "string") {
              return document.querySelector(appendTo);
            } else if (appendTo instanceof HTMLElement) {
              return appendTo;
            } else if (typeof appendTo === "function") {
              return appendTo(source);
            } else {
              return source.parentNode;
            }
          }
        }
        exports3.default = Mirror;
        function computeMirrorDimensions(_ref2) {
          let { source } = _ref2, args = _objectWithoutProperties(_ref2, ["source"]);
          return withPromise((resolve) => {
            const sourceRect = source.getBoundingClientRect();
            resolve(_extends2({ source, sourceRect }, args));
          });
        }
        function calculateMirrorOffset(_ref3) {
          let { sensorEvent, sourceRect, options } = _ref3, args = _objectWithoutProperties(_ref3, ["sensorEvent", "sourceRect", "options"]);
          return withPromise((resolve) => {
            const top2 = options.cursorOffsetY === null ? sensorEvent.clientY - sourceRect.top : options.cursorOffsetY;
            const left = options.cursorOffsetX === null ? sensorEvent.clientX - sourceRect.left : options.cursorOffsetX;
            const mirrorOffset = { top: top2, left };
            resolve(_extends2({ sensorEvent, sourceRect, mirrorOffset, options }, args));
          });
        }
        function resetMirror(_ref4) {
          let { mirror, source, options } = _ref4, args = _objectWithoutProperties(_ref4, ["mirror", "source", "options"]);
          return withPromise((resolve) => {
            let offsetHeight;
            let offsetWidth;
            if (options.constrainDimensions) {
              const computedSourceStyles = getComputedStyle(source);
              offsetHeight = computedSourceStyles.getPropertyValue("height");
              offsetWidth = computedSourceStyles.getPropertyValue("width");
            }
            mirror.style.position = "fixed";
            mirror.style.pointerEvents = "none";
            mirror.style.top = 0;
            mirror.style.left = 0;
            mirror.style.margin = 0;
            if (options.constrainDimensions) {
              mirror.style.height = offsetHeight;
              mirror.style.width = offsetWidth;
            }
            resolve(_extends2({ mirror, source, options }, args));
          });
        }
        function addMirrorClasses(_ref5) {
          let { mirror, mirrorClass } = _ref5, args = _objectWithoutProperties(_ref5, ["mirror", "mirrorClass"]);
          return withPromise((resolve) => {
            mirror.classList.add(mirrorClass);
            resolve(_extends2({ mirror, mirrorClass }, args));
          });
        }
        function removeMirrorID(_ref6) {
          let { mirror } = _ref6, args = _objectWithoutProperties(_ref6, ["mirror"]);
          return withPromise((resolve) => {
            mirror.removeAttribute("id");
            delete mirror.id;
            resolve(_extends2({ mirror }, args));
          });
        }
        function positionMirror({ withFrame = false, initial = false } = {}) {
          return (_ref7) => {
            let { mirror, sensorEvent, mirrorOffset, initialY, initialX, scrollOffset, options } = _ref7, args = _objectWithoutProperties(_ref7, ["mirror", "sensorEvent", "mirrorOffset", "initialY", "initialX", "scrollOffset", "options"]);
            return withPromise((resolve) => {
              const result2 = _extends2({
                mirror,
                sensorEvent,
                mirrorOffset,
                options
              }, args);
              if (mirrorOffset) {
                const x2 = sensorEvent.clientX - mirrorOffset.left - scrollOffset.x;
                const y2 = sensorEvent.clientY - mirrorOffset.top - scrollOffset.y;
                if (options.xAxis && options.yAxis || initial) {
                  mirror.style.transform = `translate3d(${x2}px, ${y2}px, 0)`;
                } else if (options.xAxis && !options.yAxis) {
                  mirror.style.transform = `translate3d(${x2}px, ${initialY}px, 0)`;
                } else if (options.yAxis && !options.xAxis) {
                  mirror.style.transform = `translate3d(${initialX}px, ${y2}px, 0)`;
                }
                if (initial) {
                  result2.initialX = x2;
                  result2.initialY = y2;
                }
              }
              resolve(result2);
            }, { frame: withFrame });
          };
        }
        function withPromise(callback, { raf = false } = {}) {
          return new Promise((resolve, reject) => {
            if (raf) {
              requestAnimationFrame(() => {
                callback(resolve, reject);
              });
            } else {
              callback(resolve, reject);
            }
          });
        }
        function isNativeDragEvent(sensorEvent) {
          return /^drag/.test(sensorEvent.originalEvent.type);
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.defaultOptions = void 0;
        var _Mirror = __webpack_require__(56);
        var _Mirror2 = _interopRequireDefault(_Mirror);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _Mirror2.default;
        exports3.defaultOptions = _Mirror.defaultOptions;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _extends2 = Object.assign || function(target) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            var source = arguments[i2];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _AbstractPlugin = __webpack_require__(1);
        var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onInitialize = Symbol("onInitialize");
        const onDestroy = Symbol("onDestroy");
        const defaultOptions2 = {};
        class Focusable extends _AbstractPlugin2.default {
          constructor(draggable) {
            super(draggable);
            this.options = _extends2({}, defaultOptions2, this.getOptions());
            this[onInitialize] = this[onInitialize].bind(this);
            this[onDestroy] = this[onDestroy].bind(this);
          }
          attach() {
            this.draggable.on("draggable:initialize", this[onInitialize]).on("draggable:destroy", this[onDestroy]);
          }
          detach() {
            this.draggable.off("draggable:initialize", this[onInitialize]).off("draggable:destroy", this[onDestroy]);
          }
          getOptions() {
            return this.draggable.options.focusable || {};
          }
          getElements() {
            return [...this.draggable.containers, ...this.draggable.getDraggableElements()];
          }
          [onInitialize]() {
            requestAnimationFrame(() => {
              this.getElements().forEach((element) => decorateElement(element));
            });
          }
          [onDestroy]() {
            requestAnimationFrame(() => {
              this.getElements().forEach((element) => stripElement(element));
            });
          }
        }
        exports3.default = Focusable;
        const elementsWithMissingTabIndex = [];
        function decorateElement(element) {
          const hasMissingTabIndex = Boolean(!element.getAttribute("tabindex") && element.tabIndex === -1);
          if (hasMissingTabIndex) {
            elementsWithMissingTabIndex.push(element);
            element.tabIndex = 0;
          }
        }
        function stripElement(element) {
          const tabIndexElementPosition = elementsWithMissingTabIndex.indexOf(element);
          if (tabIndexElementPosition !== -1) {
            element.tabIndex = -1;
            elementsWithMissingTabIndex.splice(tabIndexElementPosition, 1);
          }
        }
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _Focusable = __webpack_require__(58);
        var _Focusable2 = _interopRequireDefault(_Focusable);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _Focusable2.default;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        class AbstractPlugin {
          constructor(draggable) {
            this.draggable = draggable;
          }
          attach() {
            throw new Error("Not Implemented");
          }
          detach() {
            throw new Error("Not Implemented");
          }
        }
        exports3.default = AbstractPlugin;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.defaultOptions = void 0;
        var _extends2 = Object.assign || function(target) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            var source = arguments[i2];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        var _AbstractPlugin = __webpack_require__(1);
        var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        const onInitialize = Symbol("onInitialize");
        const onDestroy = Symbol("onDestroy");
        const announceEvent = Symbol("announceEvent");
        const announceMessage = Symbol("announceMessage");
        const ARIA_RELEVANT = "aria-relevant";
        const ARIA_ATOMIC = "aria-atomic";
        const ARIA_LIVE = "aria-live";
        const ROLE = "role";
        const defaultOptions2 = exports3.defaultOptions = {
          expire: 7e3
        };
        class Announcement extends _AbstractPlugin2.default {
          constructor(draggable) {
            super(draggable);
            this.options = _extends2({}, defaultOptions2, this.getOptions());
            this.originalTriggerMethod = this.draggable.trigger;
            this[onInitialize] = this[onInitialize].bind(this);
            this[onDestroy] = this[onDestroy].bind(this);
          }
          attach() {
            this.draggable.on("draggable:initialize", this[onInitialize]);
          }
          detach() {
            this.draggable.off("draggable:destroy", this[onDestroy]);
          }
          getOptions() {
            return this.draggable.options.announcements || {};
          }
          [announceEvent](event) {
            const message = this.options[event.type];
            if (message && typeof message === "string") {
              this[announceMessage](message);
            }
            if (message && typeof message === "function") {
              this[announceMessage](message(event));
            }
          }
          [announceMessage](message) {
            announce(message, { expire: this.options.expire });
          }
          [onInitialize]() {
            this.draggable.trigger = (event) => {
              try {
                this[announceEvent](event);
              } finally {
                this.originalTriggerMethod.call(this.draggable, event);
              }
            };
          }
          [onDestroy]() {
            this.draggable.trigger = this.originalTriggerMethod;
          }
        }
        exports3.default = Announcement;
        const liveRegion = createRegion();
        function announce(message, { expire }) {
          const element = document.createElement("div");
          element.textContent = message;
          liveRegion.appendChild(element);
          return setTimeout(() => {
            liveRegion.removeChild(element);
          }, expire);
        }
        function createRegion() {
          const element = document.createElement("div");
          element.setAttribute("id", "draggable-live-region");
          element.setAttribute(ARIA_RELEVANT, "additions");
          element.setAttribute(ARIA_ATOMIC, "true");
          element.setAttribute(ARIA_LIVE, "assertive");
          element.setAttribute(ROLE, "log");
          element.style.position = "fixed";
          element.style.width = "1px";
          element.style.height = "1px";
          element.style.top = "-1px";
          element.style.overflow = "hidden";
          return element;
        }
        document.addEventListener("DOMContentLoaded", () => {
          document.body.appendChild(liveRegion);
        });
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.defaultOptions = void 0;
        var _Announcement = __webpack_require__(61);
        var _Announcement2 = _interopRequireDefault(_Announcement);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.default = _Announcement2.default;
        exports3.defaultOptions = _Announcement.defaultOptions;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.DraggableDestroyEvent = exports3.DraggableInitializedEvent = exports3.DraggableEvent = void 0;
        var _AbstractEvent = __webpack_require__(0);
        var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        class DraggableEvent extends _AbstractEvent2.default {
          get draggable() {
            return this.data.draggable;
          }
        }
        exports3.DraggableEvent = DraggableEvent;
        DraggableEvent.type = "draggable";
        class DraggableInitializedEvent extends DraggableEvent {
        }
        exports3.DraggableInitializedEvent = DraggableInitializedEvent;
        DraggableInitializedEvent.type = "draggable:initialize";
        class DraggableDestroyEvent extends DraggableEvent {
        }
        exports3.DraggableDestroyEvent = DraggableDestroyEvent;
        DraggableDestroyEvent.type = "draggable:destroy";
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        var _extends2 = Object.assign || function(target) {
          for (var i2 = 1; i2 < arguments.length; i2++) {
            var source = arguments[i2];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        const canceled = Symbol("canceled");
        class AbstractEvent {
          constructor(data) {
            this[canceled] = false;
            this.data = data;
          }
          get type() {
            return this.constructor.type;
          }
          get cancelable() {
            return this.constructor.cancelable;
          }
          cancel() {
            this[canceled] = true;
          }
          canceled() {
            return Boolean(this[canceled]);
          }
          clone(data) {
            return new this.constructor(_extends2({}, this.data, data));
          }
        }
        exports3.default = AbstractEvent;
        AbstractEvent.type = "event";
        AbstractEvent.cancelable = false;
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.DragStopEvent = exports3.DragPressureEvent = exports3.DragOutContainerEvent = exports3.DragOverContainerEvent = exports3.DragOutEvent = exports3.DragOverEvent = exports3.DragMoveEvent = exports3.DragStartEvent = exports3.DragEvent = void 0;
        var _AbstractEvent = __webpack_require__(0);
        var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        class DragEvent extends _AbstractEvent2.default {
          get source() {
            return this.data.source;
          }
          get originalSource() {
            return this.data.originalSource;
          }
          get mirror() {
            return this.data.mirror;
          }
          get sourceContainer() {
            return this.data.sourceContainer;
          }
          get sensorEvent() {
            return this.data.sensorEvent;
          }
          get originalEvent() {
            if (this.sensorEvent) {
              return this.sensorEvent.originalEvent;
            }
            return null;
          }
        }
        exports3.DragEvent = DragEvent;
        DragEvent.type = "drag";
        class DragStartEvent extends DragEvent {
        }
        exports3.DragStartEvent = DragStartEvent;
        DragStartEvent.type = "drag:start";
        DragStartEvent.cancelable = true;
        class DragMoveEvent extends DragEvent {
        }
        exports3.DragMoveEvent = DragMoveEvent;
        DragMoveEvent.type = "drag:move";
        class DragOverEvent extends DragEvent {
          get overContainer() {
            return this.data.overContainer;
          }
          get over() {
            return this.data.over;
          }
        }
        exports3.DragOverEvent = DragOverEvent;
        DragOverEvent.type = "drag:over";
        DragOverEvent.cancelable = true;
        class DragOutEvent extends DragEvent {
          get overContainer() {
            return this.data.overContainer;
          }
          get over() {
            return this.data.over;
          }
        }
        exports3.DragOutEvent = DragOutEvent;
        DragOutEvent.type = "drag:out";
        class DragOverContainerEvent extends DragEvent {
          get overContainer() {
            return this.data.overContainer;
          }
        }
        exports3.DragOverContainerEvent = DragOverContainerEvent;
        DragOverContainerEvent.type = "drag:over:container";
        class DragOutContainerEvent extends DragEvent {
          get overContainer() {
            return this.data.overContainer;
          }
        }
        exports3.DragOutContainerEvent = DragOutContainerEvent;
        DragOutContainerEvent.type = "drag:out:container";
        class DragPressureEvent extends DragEvent {
          get pressure() {
            return this.data.pressure;
          }
        }
        exports3.DragPressureEvent = DragPressureEvent;
        DragPressureEvent.type = "drag:pressure";
        class DragStopEvent extends DragEvent {
        }
        exports3.DragStopEvent = DragStopEvent;
        DragStopEvent.type = "drag:stop";
      },
      function(module3, exports3, __webpack_require__) {
        Object.defineProperty(exports3, "__esModule", {
          value: true
        });
        exports3.Plugins = exports3.Sensors = exports3.Sortable = exports3.Swappable = exports3.Droppable = exports3.Draggable = exports3.BasePlugin = exports3.BaseEvent = void 0;
        var _Draggable = __webpack_require__(5);
        Object.defineProperty(exports3, "Draggable", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_Draggable).default;
          }
        });
        var _Droppable = __webpack_require__(34);
        Object.defineProperty(exports3, "Droppable", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_Droppable).default;
          }
        });
        var _Swappable = __webpack_require__(31);
        Object.defineProperty(exports3, "Swappable", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_Swappable).default;
          }
        });
        var _Sortable = __webpack_require__(28);
        Object.defineProperty(exports3, "Sortable", {
          enumerable: true,
          get: function() {
            return _interopRequireDefault(_Sortable).default;
          }
        });
        var _AbstractEvent = __webpack_require__(0);
        var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);
        var _AbstractPlugin = __webpack_require__(1);
        var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);
        var _Sensors = __webpack_require__(6);
        var Sensors = _interopRequireWildcard(_Sensors);
        var _Plugins = __webpack_require__(25);
        var Plugins = _interopRequireWildcard(_Plugins);
        function _interopRequireWildcard(obj) {
          if (obj && obj.__esModule) {
            return obj;
          } else {
            var newObj = {};
            if (obj != null) {
              for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key))
                  newObj[key] = obj[key];
              }
            }
            newObj.default = obj;
            return newObj;
          }
        }
        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }
        exports3.BaseEvent = _AbstractEvent2.default;
        exports3.BasePlugin = _AbstractPlugin2.default;
        exports3.Sensors = Sensors;
        exports3.Plugins = Plugins;
      }
    ]);
  });
})(draggable_bundle);
function enableDragSort(dragIconClass) {
  const containers = document.querySelectorAll(".n-data-table-tbody");
  if (containers.length === 0) {
    return false;
  }
  const config2 = {
    draggable: ".n-data-table-tr",
    mirror: {
      appendTo: containers,
      constrainDimensions: true
    },
    delay: 300,
    classes: {
      mirror: "draggable-mirror"
    }
  };
  if (dragIconClass) {
    config2["handle"] = `.${dragIconClass}`;
  }
  return new draggable_bundle.exports.Sortable(containers, config2);
}
var Table_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$t = { class: "ghl-table-custom-header" };
const _hoisted_2$l = { class: "filter-bar--left" };
const _hoisted_3$j = { class: "filter-bar--right" };
const _hoisted_4$d = {
  key: 1,
  class: "hl-breadcrumb"
};
const _hoisted_5$a = { class: "ghl-table-container" };
const _hoisted_6$9 = {
  key: 0,
  class: "ghl-table-footer"
};
const _hoisted_7$5 = { class: "ghl-table-footer-left" };
const _hoisted_8$3 = { class: "ghl-table-footer-right" };
const _hoisted_9$2 = {
  key: 1,
  class: "pagination"
};
const __default__$S = defineComponent({
  name: "UITable",
  inheritAttrs: false
});
const _sfc_main$12 = defineComponent(__spreadProps(__spreadValues({}, __default__$S), {
  props: {
    id: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number
    },
    pageCount: {
      type: Number
    },
    tabs: {
      type: Array,
      default: () => []
    },
    enableTextSearch: {
      type: Boolean,
      default: true
    },
    enableFilter: {
      type: Boolean,
      default: true
    },
    filterCollapseItems: {
      type: Array,
      default: () => []
    },
    filterOptions: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    defaultTab: {
      type: String,
      default: ""
    },
    rowKey: Function,
    checkedRowKeys: Array,
    searchInputPlaceholder: {
      type: String,
      default: void 0
    },
    defaultExpandAll: {
      type: Boolean,
      default: false
    },
    searchText: {
      type: String,
      default: ""
    },
    transparent: {
      type: Boolean,
      default: false
    },
    showSizePicker: {
      type: Boolean,
      default: false
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40]
    },
    pageSize: {
      type: Number,
      default: void 0
    },
    pageSlot: {
      type: Number,
      default: 9
    },
    dragSort: {
      type: Boolean,
      default: false
    },
    dragIconClass: {
      type: String,
      required: false
    },
    scrollX: {
      type: [Number, void 0],
      required: false,
      default: void 0
    },
    scrollbarProps: {
      type: Object,
      required: false,
      default: void 0
    },
    virtualScroll: {
      type: Boolean,
      required: false,
      default: false
    },
    flexHeight: {
      type: Boolean,
      required: false,
      default: false
    },
    maxHeight: {
      type: [Number, String],
      default: void 0
    },
    minHeight: {
      type: Number,
      default: void 0
    },
    tableLayout: {
      type: String,
      default: "auto"
    },
    rowClassName: {
      type: String,
      default: void 0
    },
    rowProps: {
      type: Function,
      default: void 0
    }
  },
  emits: [
    "update:page",
    "update:page-size",
    "update:searchText",
    "update:filter",
    "update:checkedRowKeys",
    "update:sorter",
    "update:defaultTab",
    "update:dragSort"
  ],
  setup(__props, { emit }) {
    const props = __props;
    function updateTab(row) {
      emit("update:defaultTab", row.key);
    }
    function onUpdateSearchText(val) {
      emit("update:searchText", val);
    }
    const slots = useSlots();
    const isSortInitialized = ref(false);
    const updatedData = ref([]);
    const onSortUpdated = (event) => {
      if (props.dragSort) {
        const {
          data: { oldIndex, newIndex }
        } = event;
        const recentOrder = moveElInArrayByIndex({
          array: updatedData.value.length ? updatedData.value : props.data,
          oldIndex,
          newIndex
        });
        emit("update:dragSort", {
          updatedList: recentOrder,
          sorted: updatedData.value.length ? updatedData.value[oldIndex] : props.data[oldIndex],
          oldIndex,
          newIndex
        });
        updatedData.value = recentOrder;
      }
    };
    const initializeDragging = () => {
      if ((props == null ? void 0 : props.dragSort) === true && (props == null ? void 0 : props.data) && !isSortInitialized.value) {
        const sortable = enableDragSort(props == null ? void 0 : props.dragIconClass);
        if (sortable) {
          sortable.on("sortable:stop", onSortUpdated);
          isSortInitialized.value = true;
        } else {
          console.warn(`ghl-ui:: Dragging is not initialized for table - ${props.id}`);
        }
      }
    };
    onMounted(() => {
      initializeDragging();
    });
    onUpdated(() => initializeDragging());
    const showFilterBar = computed(() => {
      return (props == null ? void 0 : props.tabs.length) || (props == null ? void 0 : props.enableTextSearch) || slots["filter-right"] || slots["filter-left"] || slots["filter-left-start"] || slots["filter-left-end"] || slots["filter-right-start"] || slots["filter-right-end"] || (props == null ? void 0 : props.filterCollapseItems.length);
    });
    return (_ctx, _cache) => {
      var _a2, _b2;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["table-container", { "ghl-transparent-heading": __props.transparent }])
      }, [
        createElementVNode("div", _hoisted_1$t, [
          unref(showFilterBar) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(unref(slots).breadcrumb ? "filter-bar-breadcrumb" : "filter-bar")
          }, [
            createElementVNode("div", _hoisted_2$l, [
              renderSlot(_ctx.$slots, "filter-left"),
              !((_a2 = unref(slots)) == null ? void 0 : _a2["filter-left"]) ? renderSlot(_ctx.$slots, "filter-left-start", { key: 0 }) : createCommentVNode("", true),
              __props.tabs.length ? (openBlock(), createBlock(unref(_sfc_main$1k), { key: 1 }, {
                default: withCtx(() => [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(__props.tabs, (row) => {
                    return openBlock(), createBlock(unref(_sfc_main$1l), {
                      size: "large",
                      key: row.key,
                      onClick: ($event) => updateTab(row),
                      id: `hl-table-${__props.id}-filter-tab-${row.key}`,
                      active: __props.defaultTab === row.key
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(row == null ? void 0 : row.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "id", "active"]);
                  }), 128))
                ]),
                _: 1
              })) : createCommentVNode("", true),
              renderSlot(_ctx.$slots, "filter-left-end")
            ]),
            createElementVNode("div", _hoisted_3$j, [
              renderSlot(_ctx.$slots, "filter-right"),
              !((_b2 = unref(slots)) == null ? void 0 : _b2["filter-right"]) ? renderSlot(_ctx.$slots, "filter-right-start", { key: 0 }) : createCommentVNode("", true),
              __props.enableTextSearch ? (openBlock(), createBlock(unref(_sfc_main$16), {
                key: 1,
                class: "filter-search",
                modelValue: __props.searchText,
                "onUpdate:modelValue": onUpdateSearchText,
                clearable: "",
                size: "large",
                placeholder: __props.searchInputPlaceholder,
                id: `hl-table-${__props.id}-filter-text-search`
              }, {
                prefix: withCtx(() => [
                  createVNode(unref(render$3Y), { class: "w-4 h-4" })
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder", "id"])) : createCommentVNode("", true),
              __props.filterCollapseItems.length ? (openBlock(), createBlock(unref(_sfc_main$17), {
                key: 2,
                options: __props.filterOptions,
                collapseItems: __props.filterCollapseItems,
                id: __props.id,
                "onUpdate:filter": _cache[0] || (_cache[0] = (value2) => emit("update:filter", value2))
              }, null, 8, ["options", "collapseItems", "id"])) : createCommentVNode("", true),
              renderSlot(_ctx.$slots, "filter-right-end")
            ])
          ], 2)) : createCommentVNode("", true),
          unref(slots).breadcrumb ? (openBlock(), createElementBlock("div", _hoisted_4$d, [
            renderSlot(_ctx.$slots, "breadcrumb")
          ])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_5$a, [
          createVNode(unref(NDataTable), {
            "default-expand-all": __props.defaultExpandAll,
            "onUpdate:sorter": _cache[1] || (_cache[1] = (val) => _ctx.$emit("update:sorter", val)),
            "checked-row-keys": __props.checkedRowKeys,
            "onUpdate:checkedRowKeys": _cache[2] || (_cache[2] = (val) => _ctx.$emit("update:checkedRowKeys", val)),
            "row-key": __props.rowKey,
            columns: props.columns,
            data: __props.data,
            pagination: false,
            bordered: false,
            loading: __props.loading,
            "scroll-x": __props.scrollX,
            "scrollbar-props": __props.scrollbarProps,
            "virtual-scroll": __props.virtualScroll,
            "flex-height": __props.flexHeight,
            "max-height": __props.maxHeight,
            "min-height": __props.minHeight,
            "table-layout": __props.tableLayout,
            "row-class-name": __props.rowClassName,
            "row-props": __props.rowProps
          }, {
            empty: withCtx(() => [
              renderSlot(_ctx.$slots, "empty")
            ]),
            _: 3
          }, 8, ["default-expand-all", "checked-row-keys", "row-key", "columns", "data", "loading", "scroll-x", "scrollbar-props", "virtual-scroll", "flex-height", "max-height", "min-height", "table-layout", "row-class-name", "row-props"]),
          createElementVNode("div", null, [
            __props.data.length ? (openBlock(), createElementBlock("div", _hoisted_6$9, [
              createElementVNode("div", _hoisted_7$5, [
                unref(slots)["footer-left"] ? renderSlot(_ctx.$slots, "footer-left", { key: 0 }) : createCommentVNode("", true)
              ]),
              createElementVNode("div", _hoisted_8$3, [
                unref(slots).pagination ? renderSlot(_ctx.$slots, "pagination", { key: 0 }) : (openBlock(), createElementBlock("div", _hoisted_9$2, [
                  createVNode(unref(_sfc_main$13), {
                    "show-size-picker": __props.showSizePicker,
                    "page-sizes": __props.pageSizes,
                    "page-size": __props.pageSize,
                    "page-count": __props.pageCount,
                    "onUpdate:page": _cache[3] || (_cache[3] = (val) => _ctx.$emit("update:page", val)),
                    "onUpdate:pageSize": _cache[4] || (_cache[4] = (val) => _ctx.$emit("update:page-size", val)),
                    page: __props.page,
                    id: __props.id,
                    "page-slot": __props.pageSlot
                  }, null, 8, ["show-size-picker", "page-sizes", "page-size", "page-count", "page", "id", "page-slot"])
                ]))
              ])
            ])) : createCommentVNode("", true)
          ])
        ])
      ], 2);
    };
  }
}));
const __default__$R = defineComponent({
  name: "UITooltip",
  inheritAttrs: false
});
const _sfc_main$11 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$R), {
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    placement: {
      type: String,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NTooltip), mergeProps(_ctx.$attrs, {
        trigger: __props.trigger,
        show: __props.show,
        placement: __props.placement,
        "onUpdate:show": _cache[0] || (_cache[0] = (val) => _ctx.$emit("show", val))
      }), {
        trigger: withCtx(() => [
          renderSlot(_ctx.$slots, "trigger")
        ]),
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["trigger", "show", "placement"]);
    };
  }
}));
_sfc_main$11.install = (Vue) => {
  Vue.component(_sfc_main$11.name, _sfc_main$11);
};
const _hoisted_1$s = { class: "flex space-x-1" };
defineComponent({
  name: "UIActionButtons"
});
const _sfc_main$10 = /* @__PURE__ */ defineComponent({
  __name: "ActionButtons",
  props: {
    options: Array,
    id: {
      type: String,
      required: true
    },
    placement: String
  },
  emits: ["click"],
  setup(__props, { emit: emits }) {
    const handleClick2 = (option, e25) => {
      e25.preventDefault();
      emits("click", option);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$s, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (row) => {
          return openBlock(), createBlock(unref(_sfc_main$1l), {
            id: `${__props.id}-action-btn-${row.key}`,
            disabled: row == null ? void 0 : row.disabled,
            key: row.key,
            tooltip: "test",
            onClick: (e25) => handleClick2(row, e25),
            circle: "",
            quaternary: ""
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$11), {
                placement: __props.placement,
                disabled: !row.label
              }, {
                trigger: withCtx(() => [
                  (openBlock(), createBlock(resolveDynamicComponent(row == null ? void 0 : row.icon)))
                ]),
                default: withCtx(() => [
                  createTextVNode(" " + toDisplayString(row.label), 1)
                ]),
                _: 2
              }, 1032, ["placement", "disabled"])
            ]),
            _: 2
          }, 1032, ["id", "disabled", "onClick"]);
        }), 128))
      ]);
    };
  }
});
const __default__$Q = defineComponent({
  name: "UIDropdown",
  inheritAttrs: false
});
const _sfc_main$$ = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$Q), {
  props: {
    trigger: {
      type: String,
      default: "click"
    },
    options: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: "medium"
    },
    placement: {
      type: String,
      default: "top"
    }
  },
  emits: ["select"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NDropdown), {
        id: __props.id,
        trigger: __props.trigger,
        options: __props.options,
        placement: __props.placement,
        size: __props.size,
        onSelect: _cache[0] || (_cache[0] = (val) => _ctx.$emit("select", val))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["id", "trigger", "options", "placement", "size"]);
    };
  }
}));
_sfc_main$$.install = (Vue) => {
  Vue.component(_sfc_main$$.name, _sfc_main$$);
};
defineComponent({
  name: "UIActionDropdown"
});
const _sfc_main$_ = /* @__PURE__ */ defineComponent({
  __name: "ActionDropdown",
  props: __spreadProps(__spreadValues({}, _sfc_main$$.props), {
    id: {
      type: String,
      required: true
    }
  }),
  emits: ["select"],
  setup(__props, { emit }) {
    function handleSelect(val) {
      emit("select", val);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$$), {
        options: _ctx.options,
        onSelect: handleSelect,
        id: `${__props.id}-action-dropdown`,
        "`": ""
      }, {
        default: withCtx(() => [
          createVNode(unref(_sfc_main$1l), {
            quaternary: "",
            circle: "",
            iconOnly: "",
            id: `${__props.id}-action-dropdown-trigger`
          }, {
            default: withCtx(() => [
              createVNode(unref(render$40), { class: "w-5 h-5" })
            ]),
            _: 1
          }, 8, ["id"])
        ]),
        _: 1
      }, 8, ["options", "id"]);
    };
  }
});
_sfc_main$12.install = (Vue) => {
  Vue.component(_sfc_main$12.name, _sfc_main$12);
  Vue.component(_sfc_main$_.name, _sfc_main$_);
  Vue.component(_sfc_main$10.name, _sfc_main$10);
};
const __default__$P = defineComponent({
  name: "UIBreadcrumb",
  inheritAttrs: false
});
const _sfc_main$Z = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$P), {
  props: {
    separator: {
      type: String,
      default: "/"
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NBreadcrumb), { separator: __props.separator }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["separator"]);
    };
  }
}));
const __default__$O = defineComponent({
  name: "UIBreadcrumbItem",
  inheritAttrs: false
});
const _sfc_main$Y = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$O), {
  props: {
    clickable: {
      type: Boolean,
      default: true
    },
    href: {
      type: String,
      default: void 0
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NBreadcrumbItem), {
        clickable: __props.clickable,
        href: __props.href
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["clickable", "href"]);
    };
  }
}));
_sfc_main$Z.install = (Vue) => {
  Vue.component(_sfc_main$Z.name, _sfc_main$Z);
  Vue.component(_sfc_main$Y.name, _sfc_main$Y);
};
const __default__$N = defineComponent({
  name: "UICollapse",
  inheritAttrs: false
});
const _sfc_main$X = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$N), {
  props: {
    arrowPlacement: {
      type: String,
      default: "left"
    },
    defaultExpandedNames: {
      type: [String, Number, Array],
      default: void 0
    }
  },
  emits: ["itemHeaderClick"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NCollapse), {
        "arrow-placement": __props.arrowPlacement,
        "default-expanded-names": __props.defaultExpandedNames,
        onItemHeaderClick: _cache[0] || (_cache[0] = (val) => _ctx.$emit("itemHeaderClick", val))
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["arrow-placement", "default-expanded-names"]);
    };
  }
}));
const __default__$M = defineComponent({
  name: "UICollapseItem",
  inheritAttrs: false
});
const _sfc_main$W = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$M), {
  props: {
    title: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    arrowPlacement: {
      type: String,
      default: "left"
    },
    id: {
      type: String,
      required: true
    }
  },
  emits: ["onItemHeaderClick"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NCollapseItem), {
        id: __props.id,
        title: __props.title,
        name: __props.name,
        onOnItemHeaderClick: _cache[0] || (_cache[0] = (val) => _ctx.$emit("onItemHeaderClick", val))
      }, {
        "header-extra": withCtx(() => [
          renderSlot(_ctx.$slots, "header-extra")
        ]),
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["id", "title", "name"]);
    };
  }
}));
_sfc_main$X.install = (Vue) => {
  Vue.component(_sfc_main$X.name, _sfc_main$X);
  Vue.component(_sfc_main$W.name, _sfc_main$W);
};
const __default__$L = defineComponent({
  name: "UIDrawer",
  inheritAttrs: false
});
const _sfc_main$V = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$L), {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 502
    },
    placement: {
      type: String,
      default: "right"
    },
    id: {
      type: String,
      required: true
    },
    displayDirective: {
      type: String,
      default: "if"
    }
  },
  emits: ["update:show"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NDrawer), mergeProps({ id: __props.id }, _ctx.$attrs, {
        show: __props.show,
        width: __props.width,
        placement: __props.placement,
        "onUpdate:show": _cache[0] || (_cache[0] = (val) => _ctx.$emit("update:show", val)),
        "display-directive": __props.displayDirective
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "show", "width", "placement", "display-directive"]);
    };
  }
}));
const _hoisted_1$r = {
  key: 0,
  class: "hl-icon-container"
};
const _sfc_main$U = /* @__PURE__ */ defineComponent({
  __name: "IconContainer",
  props: {
    type: {
      type: String,
      default: "primary"
    }
  },
  setup(__props) {
    const iconType = {
      success: "icon-success",
      error: "icon-error",
      warning: "icon-warning",
      primary: "icon-primary"
    };
    const slots = useSlots();
    return (_ctx, _cache) => {
      return unref(slots).default() ? (openBlock(), createElementBlock("div", _hoisted_1$r, [
        createElementVNode("div", {
          class: normalizeClass(["icon", iconType[__props.type]])
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2)
      ])) : createCommentVNode("", true);
    };
  }
});
var DrawerContent_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$q = { class: "hl-drawer-header-container" };
const _hoisted_2$k = {
  key: 0,
  class: "hl-drawer-header-icon"
};
const _hoisted_3$i = { class: "hl-drawer-title" };
const _hoisted_4$c = { class: "hl-drawer-description" };
const _hoisted_5$9 = { class: "hl-drawer-actions" };
const _hoisted_6$8 = { class: "hl-drawer-action-left" };
const _hoisted_7$4 = { class: "hl-drawer-action-right" };
const __default__$K = defineComponent({
  name: "UIDrawerContent",
  inheritAttrs: false
});
const _sfc_main$T = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$K), {
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    icon: {
      type: Function,
      default: void 0
    },
    width: {
      type: Number,
      default: 502
    },
    positiveText: {
      type: String,
      default: ""
    },
    negativeText: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["negativeClick", "positiveClick"],
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const canShowFooter = computed(() => {
      return props.positiveText || props.negativeText || (slots == null ? void 0 : slots.actionLeft) || (slots == null ? void 0 : slots.actionRight);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NDrawerContent), mergeProps(_ctx.$attrs, {
        closable: "",
        class: "hl-drawer-content"
      }), createSlots({
        header: withCtx(() => [
          createElementVNode("div", _hoisted_1$q, [
            __props.icon ? (openBlock(), createElementBlock("div", _hoisted_2$k, [
              createVNode(_sfc_main$U, null, {
                default: withCtx(() => [
                  (openBlock(), createBlock(resolveDynamicComponent(__props.icon), { class: "w-5 h-5" }))
                ]),
                _: 1
              })
            ])) : createCommentVNode("", true),
            createElementVNode("div", null, [
              createElementVNode("div", _hoisted_3$i, toDisplayString(__props.title), 1),
              createElementVNode("div", _hoisted_4$c, toDisplayString(__props.description), 1)
            ])
          ])
        ]),
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, [
        unref(canShowFooter) ? {
          name: "footer",
          fn: withCtx(() => {
            var _a2, _b2;
            return [
              createElementVNode("div", _hoisted_5$9, [
                createElementVNode("div", _hoisted_6$8, [
                  ((_a2 = unref(slots)) == null ? void 0 : _a2.actionLeft) ? renderSlot(_ctx.$slots, "actionLeft", { key: 0 }) : createCommentVNode("", true)
                ]),
                createElementVNode("div", _hoisted_7$4, [
                  ((_b2 = unref(slots)) == null ? void 0 : _b2.actionRight) ? renderSlot(_ctx.$slots, "actionRight", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    __props.negativeText ? (openBlock(), createBlock(unref(_sfc_main$1l), {
                      key: 0,
                      id: `${__props.id}-btn-negative-action`,
                      onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("negativeClick"))
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(__props.negativeText), 1)
                      ]),
                      _: 1
                    }, 8, ["id"])) : createCommentVNode("", true),
                    __props.positiveText ? (openBlock(), createBlock(unref(_sfc_main$1l), {
                      key: 1,
                      id: `${__props.id}-btn-positive-action`,
                      loading: __props.loading,
                      disabled: __props.disabled,
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("positiveClick"))
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString(__props.positiveText), 1)
                      ]),
                      _: 1
                    }, 8, ["id", "loading", "disabled"])) : createCommentVNode("", true)
                  ], 64))
                ])
              ])
            ];
          })
        } : void 0
      ]), 1040);
    };
  }
}));
_sfc_main$V.install = (Vue) => {
  Vue.component(_sfc_main$V.name, _sfc_main$V);
  Vue.component(_sfc_main$T.name, _sfc_main$T);
};
const __default__$J = defineComponent({
  name: "UIFormLabelTooltip",
  inheritAttrs: false
});
const _sfc_main$S = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$J), {
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    placement: {
      type: String,
      default: void 0
    },
    icon: {
      type: Function,
      default: render$3_
    },
    iconClass: String
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(_sfc_main$11), {
        placement: __props.placement,
        trigger: __props.trigger
      }, {
        trigger: withCtx(() => [
          (openBlock(), createBlock(resolveDynamicComponent(__props.icon), {
            class: normalizeClass(__props.iconClass ? __props.iconClass : "w-4 h-4 text-gray-500")
          }, null, 8, ["class"]))
        ]),
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["placement", "trigger"]);
    };
  }
}));
const __default__$I = defineComponent({
  name: "UIForm"
});
const _sfc_main$R = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$I), {
  props: {
    rules: {
      type: Object
    },
    inline: {
      type: Boolean,
      default: false
    },
    model: {
      type: [String, Object]
    },
    id: {
      type: String,
      required: true
    }
  },
  setup(__props, { expose }) {
    const formRef = ref();
    function getForm() {
      return formRef.value;
    }
    expose({ getForm });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NForm), mergeProps({ id: __props.id }, _ctx.$attrs, {
        rules: __props.rules,
        model: __props.model,
        inline: __props.inline,
        ref_key: "formRef",
        ref: formRef
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "rules", "model", "inline"]);
    };
  }
}));
const __default__$H = defineComponent({
  name: "UIDivider",
  inheritAttrs: false
});
const _sfc_main$Q = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$H), {
  props: {
    titlePlacement: {
      type: String,
      default: "center"
    },
    dashed: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return unref(slots).default ? (openBlock(), createBlock(unref(NDivider), {
        key: 0,
        "title-placement": __props.titlePlacement,
        dashed: __props.dashed,
        vertical: __props.vertical
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["title-placement", "dashed", "vertical"])) : (openBlock(), createBlock(unref(NDivider), {
        key: 1,
        "title-placement": __props.titlePlacement,
        dashed: __props.dashed,
        vertical: __props.vertical
      }, null, 8, ["title-placement", "dashed", "vertical"]));
    };
  }
}));
_sfc_main$Q.install = (Vue) => {
  Vue.component(_sfc_main$Q.name, _sfc_main$Q);
};
var FormContentHorizontal_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$p = { class: "hl-form-content-hz" };
const _hoisted_2$j = { class: "col-left" };
const _hoisted_3$h = { class: "n-form-custom-label" };
const _hoisted_4$b = {
  key: 0,
  class: "asterisk"
};
const _hoisted_5$8 = { key: 0 };
const _hoisted_6$7 = {
  key: 0,
  class: "extra"
};
const _hoisted_7$3 = { class: "col-right" };
const __default__$G = defineComponent({
  name: "UIFormContentHorizontal",
  inheritAttrs: false
});
const _sfc_main$P = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$G), {
  props: {
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Object,
      default: null
    }
  },
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      var _a2, _b2, _c2, _d2;
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(_sfc_main$Q)),
        createElementVNode("div", _hoisted_1$p, [
          createElementVNode("div", _hoisted_2$j, [
            createElementVNode("div", _hoisted_3$h, [
              createVNode(unref(_sfc_main$1e), { class: "title" }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(__props.label) + " ", 1),
                  __props.required ? (openBlock(), createElementBlock("span", _hoisted_4$b, "\xA0*")) : createCommentVNode("", true)
                ]),
                _: 1
              }),
              __props.tooltip ? (openBlock(), createBlock(_sfc_main$S, {
                key: 0,
                placement: (_a2 = __props.tooltip) == null ? void 0 : _a2.placement,
                trigger: (_b2 = __props.tooltip) == null ? void 0 : _b2.trigger,
                icon: (_c2 = __props.tooltip) == null ? void 0 : _c2.icon,
                iconClass: (_d2 = __props.tooltip) == null ? void 0 : _d2.iconClass
              }, {
                default: withCtx(() => [
                  typeof __props.tooltip.text === "string" ? (openBlock(), createElementBlock("span", _hoisted_5$8, toDisplayString(__props.tooltip.text), 1)) : (openBlock(), createBlock(resolveDynamicComponent(__props.tooltip.text), { key: 1 }))
                ]),
                _: 1
              }, 8, ["placement", "trigger", "icon", "iconClass"])) : createCommentVNode("", true)
            ]),
            createVNode(unref(_sfc_main$18), { class: "description" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.description), 1)
              ]),
              _: 1
            }),
            unref(slots).extra ? (openBlock(), createElementBlock("div", _hoisted_6$7, [
              renderSlot(_ctx.$slots, "extra")
            ])) : createCommentVNode("", true)
          ]),
          createElementVNode("div", _hoisted_7$3, [
            renderSlot(_ctx.$slots, "default")
          ])
        ])
      ], 64);
    };
  }
}));
var FormItem_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$o = { class: "n-form-custom-label" };
const _hoisted_2$i = {
  key: 0,
  class: "asterisk"
};
const _hoisted_3$g = { key: 0 };
const __default__$F = defineComponent({
  name: "UIFormItem",
  inheritAttrs: false
});
const _sfc_main$O = defineComponent(__spreadProps(__spreadValues({}, __default__$F), {
  props: {
    label: {
      type: String
    },
    path: {
      type: String
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    showFeedback: {
      type: Boolean,
      default: true
    },
    rule: {
      type: Object,
      default: void 0
    },
    tooltip: {
      type: Object,
      default: null
    },
    required: Boolean
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NFormItem), mergeProps(_ctx.$attrs, {
        rule: __props.rule,
        label: __props.label,
        path: __props.path,
        "show-label": __props.showLabel,
        "show-feedback": __props.showFeedback,
        class: { "n-form-has-custom-label": __props.tooltip },
        required: __props.required
      }), createSlots({
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, [
        __props.tooltip ? {
          name: "label",
          fn: withCtx(() => {
            var _a2, _b2, _c2, _d2;
            return [
              createElementVNode("div", _hoisted_1$o, [
                createElementVNode("span", null, [
                  createElementVNode("span", null, toDisplayString(__props.label), 1),
                  __props.required ? (openBlock(), createElementBlock("span", _hoisted_2$i, "\xA0*")) : createCommentVNode("", true)
                ]),
                createVNode(_sfc_main$S, {
                  placement: (_a2 = __props.tooltip) == null ? void 0 : _a2.placement,
                  trigger: (_b2 = __props.tooltip) == null ? void 0 : _b2.trigger,
                  icon: (_c2 = __props.tooltip) == null ? void 0 : _c2.icon,
                  iconClass: (_d2 = __props.tooltip) == null ? void 0 : _d2.iconClass
                }, {
                  default: withCtx(() => [
                    typeof __props.tooltip.text === "string" ? (openBlock(), createElementBlock("span", _hoisted_3$g, toDisplayString(__props.tooltip.text), 1)) : (openBlock(), createBlock(resolveDynamicComponent(__props.tooltip.text), { key: 1 }))
                  ]),
                  _: 1
                }, 8, ["placement", "trigger", "icon", "iconClass"])
              ])
            ];
          })
        } : void 0
      ]), 1040, ["rule", "label", "path", "show-label", "show-feedback", "class", "required"]);
    };
  }
}));
_sfc_main$R.install = (Vue) => {
  Vue.component(_sfc_main$R.name, _sfc_main$R);
  Vue.component(_sfc_main$O.name, _sfc_main$O);
  Vue.component(_sfc_main$P.name, _sfc_main$P), Vue.component(_sfc_main$S.name, _sfc_main$S);
};
var Modal_vue_vue_type_style_index_0_lang = "";
const __default__$E = defineComponent({
  name: "UIModal",
  inheritAttrs: false
});
const _sfc_main$N = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$E), {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 544
    },
    zIndex: {
      type: Number,
      default: void 0
    },
    to: {
      type: String,
      default: "body"
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ""
    },
    maskClosable: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:show"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NModal), {
        show: __props.show,
        "onUpdate:show": _cache[0] || (_cache[0] = (val) => _ctx.$emit("update:show", val)),
        "z-index": __props.zIndex,
        "auto-focus": __props.autoFocus,
        to: __props.to,
        "mask-closable": __props.maskClosable
      }, {
        default: withCtx(() => [
          createVNode(unref(NCard), {
            style: normalizeStyle({ width: `${__props.width}px` }),
            bordered: false,
            size: "huge",
            role: "dialog",
            "aria-modal": "true",
            class: normalizeClass(["hl-modal", __props.className])
          }, {
            header: withCtx(() => [
              renderSlot(_ctx.$slots, "header")
            ]),
            footer: withCtx(() => [
              renderSlot(_ctx.$slots, "footer")
            ]),
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["style", "class"])
        ]),
        _: 3
      }, 8, ["show", "z-index", "auto-focus", "to", "mask-closable"]);
    };
  }
}));
const _hoisted_1$n = { class: "hl-modal-heading" };
const _hoisted_2$h = { key: 0 };
const _hoisted_3$f = { key: 1 };
const _hoisted_4$a = {
  key: 0,
  class: "hl-icon-container"
};
const _hoisted_5$7 = { class: "action" };
const _hoisted_6$6 = { class: "title" };
const _hoisted_7$2 = {
  key: 0,
  class: "action"
};
const _hoisted_8$2 = {
  key: 1,
  class: "description"
};
const _sfc_main$M = /* @__PURE__ */ defineComponent({
  __name: "ModalHeader",
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    icon: {
      type: Function,
      default: void 0
    },
    type: {
      type: String,
      default: "primary"
    }
  },
  emits: ["close"],
  setup(__props) {
    const iconType = {
      custom: "icon-custom",
      success: "icon-success",
      error: "icon-error",
      warning: "icon-warning",
      primary: "icon-primary"
    };
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$n, [
        unref(slots).customHeader ? (openBlock(), createElementBlock("div", _hoisted_2$h, [
          renderSlot(_ctx.$slots, "customHeader")
        ])) : (openBlock(), createElementBlock("div", _hoisted_3$f, [
          __props.icon ? (openBlock(), createElementBlock("div", _hoisted_4$a, [
            createElementVNode("div", {
              class: normalizeClass(["icon", iconType[__props.type]])
            }, [
              (openBlock(), createBlock(resolveDynamicComponent(__props.icon)))
            ], 2),
            createElementVNode("div", _hoisted_5$7, [
              createVNode(unref(_sfc_main$1l), {
                circle: "",
                quaternary: "",
                onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("close")),
                id: `${__props.id}-modal-close-btn`
              }, {
                default: withCtx(() => [
                  createVNode(unref(render$3V), { class: "w-5 h-5" })
                ]),
                _: 1
              }, 8, ["id"])
            ])
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_6$6, [
            createTextVNode(toDisplayString(__props.title) + " ", 1),
            !__props.icon ? (openBlock(), createElementBlock("div", _hoisted_7$2, [
              createVNode(unref(_sfc_main$1l), {
                circle: "",
                quaternary: "",
                onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("close")),
                id: `${__props.id}-modal-close-btn`
              }, {
                default: withCtx(() => [
                  createVNode(unref(render$3V), { class: "w-6 h-6" })
                ]),
                _: 1
              }, 8, ["id"])
            ])) : createCommentVNode("", true)
          ]),
          __props.description ? (openBlock(), createElementBlock("div", _hoisted_8$2, toDisplayString(__props.description), 1)) : createCommentVNode("", true)
        ]))
      ]);
    };
  }
});
const _hoisted_1$m = { class: "hl-modal-footer-actions" };
const _hoisted_2$g = { class: "action-left" };
const _hoisted_3$e = { class: "action-right" };
defineComponent({
  name: "UIModalFooter"
});
const _sfc_main$L = /* @__PURE__ */ defineComponent({
  __name: "ModalFooter",
  props: {
    id: {
      type: String,
      required: true
    },
    positiveText: {
      type: String,
      default: ""
    },
    negativeText: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "primary"
    }
  },
  setup(__props) {
    const slots = useSlots();
    const isActionRightSlotEnabled = computed(() => !!slots.actionRight);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$m, [
        createElementVNode("div", _hoisted_2$g, [
          renderSlot(_ctx.$slots, "actionLeft")
        ]),
        createElementVNode("div", _hoisted_3$e, [
          renderSlot(_ctx.$slots, "actionRight"),
          !unref(isActionRightSlotEnabled) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            __props.negativeText ? (openBlock(), createBlock(unref(_sfc_main$1l), {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("negativeClick")),
              id: `${__props.id}-btn-negative-action`
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.negativeText), 1)
              ]),
              _: 1
            }, 8, ["id"])) : createCommentVNode("", true),
            __props.positiveText ? (openBlock(), createBlock(unref(_sfc_main$1l), {
              key: 1,
              loading: __props.loading,
              disabled: __props.disabled,
              type: __props.type,
              id: `${__props.id}-btn-positive-action`,
              onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("positiveClick"))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.positiveText), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled", "type", "id"])) : createCommentVNode("", true)
          ], 64)) : createCommentVNode("", true)
        ])
      ]);
    };
  }
});
var ModalContent_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$l = { class: "hl-modal-content" };
defineComponent({
  name: "UIModalContent"
});
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "ModalContent",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$l, [
        renderSlot(_ctx.$slots, "default")
      ]);
    };
  }
});
_sfc_main$N.install = (Vue) => {
  Vue.component(_sfc_main$N.name, _sfc_main$N);
  Vue.component(_sfc_main$M.name, _sfc_main$M);
  Vue.component(_sfc_main$L.name, _sfc_main$L);
  Vue.component(_sfc_main$K.name, _sfc_main$K);
};
const __default__$D = defineComponent({
  name: "UIRadio",
  inheritAttrs: false
});
const _sfc_main$J = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$D), {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Boolean]
    },
    name: {
      type: String
    },
    label: {
      type: String
    },
    checked: {
      type: Boolean
    },
    id: {
      type: String,
      required: true
    }
  },
  emits: ["change", "checked", "value"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NRadio), mergeProps({
        id: __props.id,
        disabled: __props.disabled,
        label: __props.label,
        value: __props.value,
        name: __props.name
      }, _ctx.$attrs, {
        checked: __props.checked,
        onChange: _cache[0] || (_cache[0] = (value2) => _ctx.$emit("change", value2)),
        onChecked: _cache[1] || (_cache[1] = (value2) => _ctx.$emit("checked", value2)),
        "onUpdate:value": _cache[2] || (_cache[2] = (value2) => _ctx.$emit("value", value2)),
        size: "large"
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "disabled", "label", "value", "name", "checked"]);
    };
  }
}));
const __default__$C = defineComponent({
  name: "UIRadioGroup",
  inheritAttrs: false
});
const _sfc_main$I = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$C), {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Boolean]
    },
    name: {
      type: String
    },
    size: {
      type: String,
      default: "medium"
    },
    defaultValue: {
      type: [String, Number, Boolean, null]
    }
  },
  emits: ["update:value"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NRadioGroup), mergeProps({
        disabled: __props.disabled,
        "default-value": __props.defaultValue,
        value: __props.value,
        name: __props.name
      }, _ctx.$attrs, {
        size: __props.size,
        "onUpdate:value": _cache[0] || (_cache[0] = (value2) => _ctx.$emit("update:value", value2))
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["disabled", "default-value", "value", "name", "size"]);
    };
  }
}));
_sfc_main$J.install = (Vue) => {
  Vue.component(_sfc_main$J.name, _sfc_main$J);
  Vue.component(_sfc_main$I.name, _sfc_main$I);
};
const __default__$B = defineComponent({
  name: "UISteps",
  inheritAttrs: false
});
const _sfc_main$H = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$B), {
  props: {
    current: {
      type: Number
    },
    status: {
      type: String
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NSteps), mergeProps(_ctx.$attrs, {
        current: __props.current,
        status: __props.status,
        vertical: __props.vertical
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["current", "status", "vertical"]);
    };
  }
}));
const __default__$A = defineComponent({
  name: "UIStep",
  inheritAttrs: false
});
const _sfc_main$G = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$A), {
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NStep), mergeProps(_ctx.$attrs, {
        title: __props.title,
        description: __props.description
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["title", "description"]);
    };
  }
}));
_sfc_main$H.install = (Vue) => {
  Vue.component(_sfc_main$H.name, _sfc_main$H);
  Vue.component(_sfc_main$G.name, _sfc_main$G);
};
const __default__$z = defineComponent({
  name: "UITabs",
  inheritAttrs: false
});
const _sfc_main$F = defineComponent(__spreadProps(__spreadValues({}, __default__$z), {
  props: {
    value: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: "line"
    },
    defaultValue: {
      type: String,
      default: void 0
    },
    justifyContent: {
      type: String,
      default: ""
    },
    animated: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:value"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NTabs), {
        value: __props.value,
        "onUpdate:value": _cache[0] || (_cache[0] = (val) => _ctx.$emit("update:value", val)),
        type: __props.type,
        animated: __props.animated,
        "justify-content": __props.justifyContent,
        "default-value": __props.defaultValue
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["value", "type", "animated", "justify-content", "default-value"]);
    };
  }
}));
var UITabPane = defineComponent({
  __TAB_PANE__: true,
  props: {
    name: {
      type: [String, Number]
    },
    tab: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { slots }) {
    return () => h$1(NTabPane, {
      name: props.name,
      tab: props.tab,
      disabled: props.disabled
    }, () => slots == null ? void 0 : slots.default());
  }
});
var UITab = defineComponent({
  __TAB__: true,
  props: {
    name: {
      type: [String, Number]
    },
    key: {
      type: [String, Number]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { slots }) {
    return () => h$1(NTab, {
      name: props.name,
      key: props.key,
      disabled: props.disabled
    }, () => slots.default());
  }
});
_sfc_main$F.install = (Vue) => {
  Vue.component(_sfc_main$F.name, _sfc_main$F);
  Vue.component(UITabPane.name, UITabPane);
  Vue.component(UITab.name, UITab);
};
var Toolbar_vue_vue_type_style_index_0_lang = "";
const __default__$y = defineComponent({
  name: "UIToolbar",
  inheritAttrs: false
});
const _sfc_main$E = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$y), {
  props: {
    theme: {
      type: String,
      default: "dark"
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, {
        class: ["hl-toolbar", __props.theme]
      }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
var ToolbarGroup_vue_vue_type_style_index_0_lang = "";
const __default__$x = defineComponent({
  name: "UIToolbarGroup",
  inheritAttrs: false
});
const _sfc_main$D = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$x), {
  props: {
    borderLeft: Boolean,
    borderRight: Boolean
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, {
        class: ["hl-toolbar-group", { "hl-br": __props.borderRight, "hl-bl": __props.borderLeft }]
      }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
}));
_sfc_main$E.install = (Vue) => {
  Vue.component(_sfc_main$E.name, _sfc_main$E);
  Vue.component(_sfc_main$D.name, _sfc_main$D);
};
var ItemDetails_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$k = { class: "item__content" };
const _sfc_main$C = /* @__PURE__ */ defineComponent({
  __name: "ItemDetails",
  props: {
    item: {
      type: Object,
      required: true
    },
    isActive: Boolean,
    isDisabled: Boolean,
    renderOption: {
      type: Function,
      default: null
    }
  },
  emits: ["onForwardTraverse", "onSelect"],
  setup(__props, { emit }) {
    const props = __props;
    const handleClick2 = () => {
      if (props.isDisabled) {
        return false;
      }
      emit("onSelect", props.item);
    };
    return (_ctx, _cache) => {
      var _a2, _b2, _c2;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["item__item", __props.isDisabled ? "disabled" : ""]),
        onClick: handleClick2
      }, [
        __props.item.render ? (openBlock(), createBlock(resolveDynamicComponent(__props.item.render(__props.item, __props.isActive)), { key: 0 })) : __props.renderOption ? (openBlock(), createBlock(resolveDynamicComponent(__props.renderOption(__props.item, __props.isActive)), { key: 1 })) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
          ((_a2 = __props.item) == null ? void 0 : _a2.imageUrl) ? (openBlock(), createBlock(unref(NAvatar), {
            key: 0,
            size: 32,
            src: (_b2 = __props.item) == null ? void 0 : _b2.imageUrl,
            round: "",
            class: "item__icon"
          }, null, 8, ["src"])) : (openBlock(), createBlock(unref(NAvatar), {
            key: 1,
            src: (_c2 = __props.item) == null ? void 0 : _c2.imageUrl,
            size: 32,
            round: "",
            class: "item__name"
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(unref(getInitials)(__props.item.label)), 1)
            ]),
            _: 1
          }, 8, ["src"])),
          createElementVNode("div", _hoisted_1$k, [
            __props.item.label ? (openBlock(), createBlock(unref(_sfc_main$1e), { key: 0 }, {
              default: withCtx(() => [
                createVNode(unref(NEllipsis), {
                  class: "item__title",
                  tooltip: !__props.item.disabled
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.item.label), 1)
                  ]),
                  _: 1
                }, 8, ["tooltip"])
              ]),
              _: 1
            })) : createCommentVNode("", true),
            __props.item.description ? (openBlock(), createBlock(unref(_sfc_main$1c), { key: 1 }, {
              default: withCtx(() => [
                createVNode(unref(NEllipsis), {
                  class: "item__description",
                  tooltip: false
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.item.description), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ]),
          __props.isActive ? (openBlock(), createBlock(unref(render$43), {
            key: 2,
            class: "item__checked"
          })) : createCommentVNode("", true)
        ], 64))
      ], 2);
    };
  }
});
const __default__$w = defineComponent({
  name: "UIAvatar",
  inheritAttrs: false
});
const _sfc_main$B = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$w), {
  props: {
    size: {
      type: [Number, String],
      default: "medium"
    },
    objectFit: {
      type: String,
      default: "fill"
    },
    round: {
      type: Boolean,
      default: true
    },
    src: {
      type: String
    },
    fallbackSrc: {
      type: String
    },
    style: {
      type: Object
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NAvatar), mergeProps(_ctx.$attrs, {
        style: __props.style,
        src: __props.src,
        "fallback-src": __props.fallbackSrc,
        round: __props.round,
        "object-fit": __props.objectFit,
        size: __props.size
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["style", "src", "fallback-src", "round", "object-fit", "size"]);
    };
  }
}));
var Trigger_vue_vue_type_style_index_0_scoped_true_lang = "";
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _hoisted_1$j = { class: "trigger-multiple__container" };
const _hoisted_2$f = { class: "trigger-multiple__empty" };
const _hoisted_3$d = { class: "trigger-single__container" };
const _hoisted_4$9 = {
  key: 1,
  class: "trigger-single__empty"
};
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  __name: "Trigger",
  props: {
    value: {
      type: Array,
      default: () => []
    },
    max: {
      type: Number,
      default: 5,
      validator(val) {
        return val <= 10;
      }
    },
    disabled: Boolean,
    multiple: Boolean
  },
  emits: ["onRemove"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const handleRemove = (val, e25) => {
      if (val && !props.disabled) {
        e25.stopImmediatePropagation();
        emits("onRemove", val);
      }
    };
    return (_ctx, _cache) => {
      var _a2, _b2;
      return props.multiple ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass(["trigger-multiple", props.disabled && "disabled"])
      }, [
        ((_a2 = props.value) == null ? void 0 : _a2.length) ? (openBlock(), createBlock(unref(NAvatarGroup), {
          key: 0,
          options: props.value,
          max: __props.max,
          class: "trigger-multiple__avatars"
        }, {
          avatar: withCtx(({ option: { name: name2, src, value: value2 } }) => [
            createVNode(_sfc_main$11, null, {
              trigger: withCtx(() => [
                createElementVNode("div", _hoisted_1$j, [
                  src ? (openBlock(), createBlock(_sfc_main$B, {
                    key: 0,
                    src,
                    class: "trigger-multiple__avatar"
                  }, null, 8, ["src"])) : (openBlock(), createBlock(_sfc_main$B, {
                    key: 1,
                    src,
                    class: "trigger-multiple__avatar"
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(unref(getInitials)(name2)), 1)
                    ]),
                    _: 2
                  }, 1032, ["src"])),
                  createVNode(unref(render$3V), {
                    class: "trigger-multiple__close",
                    onClick: (e25) => handleRemove(value2, e25)
                  }, null, 8, ["onClick"])
                ])
              ]),
              default: withCtx(() => [
                createTextVNode(" " + toDisplayString(name2), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["options", "max"])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_2$f, [
          createVNode(unref(render$3Z), { class: "trigger-multiple__empty-icon" })
        ])
      ], 2)) : (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass(["trigger-single", props.disabled && "disabled"])
      }, [
        ((_b2 = props.value) == null ? void 0 : _b2.length) ? (openBlock(), createBlock(_sfc_main$11, { key: 0 }, {
          trigger: withCtx(() => {
            var _a3, _b3, _c2;
            return [
              createElementVNode("div", _hoisted_3$d, [
                ((_a3 = props.value[0]) == null ? void 0 : _a3.src) ? (openBlock(), createBlock(_sfc_main$B, {
                  key: 0,
                  src: (_b3 = props.value[0]) == null ? void 0 : _b3.src,
                  class: "trigger-single__avatar"
                }, null, 8, ["src"])) : (openBlock(), createBlock(_sfc_main$B, {
                  key: 1,
                  src: (_c2 = props.value[0]) == null ? void 0 : _c2.src,
                  class: "trigger-single__avatar"
                }, {
                  default: withCtx(() => {
                    var _a4;
                    return [
                      createTextVNode(toDisplayString(unref(getInitials)((_a4 = props.value[0]) == null ? void 0 : _a4.name)), 1)
                    ];
                  }),
                  _: 1
                }, 8, ["src"])),
                createVNode(unref(render$3V), {
                  class: "trigger-single__close",
                  onClick: _cache[0] || (_cache[0] = (e25) => {
                    var _a4;
                    return handleRemove((_a4 = props.value[0]) == null ? void 0 : _a4.value, e25);
                  })
                })
              ])
            ];
          }),
          default: withCtx(() => {
            var _a3;
            return [
              createTextVNode(" " + toDisplayString((_a3 = props.value[0]) == null ? void 0 : _a3.name), 1)
            ];
          }),
          _: 1
        })) : (openBlock(), createElementBlock("div", _hoisted_4$9, [
          createVNode(unref(render$3Z), { class: "trigger-single__empty-icon" })
        ]))
      ], 2));
    };
  }
});
var Trigger = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["__scopeId", "data-v-9723c69e"]]);
var AdvancedSelect_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$i = { class: "advanced-select__search" };
const _hoisted_2$e = { key: 2 };
const _hoisted_3$c = {
  key: 1,
  class: "no-data"
};
const _hoisted_4$8 = { key: 3 };
const _hoisted_5$6 = {
  key: 1,
  class: "empty-search"
};
const __default__$v = defineComponent({
  name: "UIAdvancedSelect",
  inheritAttrs: false
});
const _sfc_main$z = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$v), {
  props: {
    renderOption: {
      type: Function,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    remote: Boolean,
    disabled: Boolean,
    loading: Boolean,
    searchPlaceholder: {
      type: String,
      required: false,
      default: "Search"
    },
    value: {
      type: [String, Number, Array],
      default: () => void 0
    },
    trigger: {
      type: String,
      default: "click"
    },
    virtualScroll: {
      type: Boolean,
      default: false
    },
    multiple: Boolean
  },
  emits: ["onChange", "onSearch", "onScroll", "onClose", "onChangeSrc"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const currentTree = ref(lodash.exports.uniqBy(props.options, "value"));
    const popper = ref(null);
    const searchString = ref(null);
    const transformSelections = computed(() => {
      if (props.multiple && Array.isArray(props.value)) {
        return props.value;
      }
      return [props.value];
    });
    const selectedValues = computed(() => {
      var _a2;
      if (!props.options || !props.value) {
        return [];
      }
      return (_a2 = props.options.filter((option) => transformSelections.value.includes(option.value))) == null ? void 0 : _a2.map((option) => ({
        name: option.label,
        text: getInitials(option.label),
        src: option == null ? void 0 : option.imageUrl,
        value: option.value
      }));
    });
    const closePopper = () => {
      var _a2;
      emits("onClose");
      (_a2 = popper == null ? void 0 : popper.value) == null ? void 0 : _a2.setShow(false);
    };
    const handleSearch = (value2) => {
      if (props.remote) {
        emits("onSearch", value2);
        return false;
      }
      const trimmedValue = value2 == null ? void 0 : value2.trim();
      if (!trimmedValue || !value2) {
        currentTree.value = props.options;
        return false;
      }
      currentTree.value = props.options.filter((option) => option.label.toLowerCase().includes(value2.toLowerCase()));
      return true;
    };
    const onSelectionChange = (selected) => {
      emits("onChangeSrc", "DROPDOWN");
      if (props.multiple) {
        const currentMultipleValues = props == null ? void 0 : props.value;
        const selectedValue = selected.value;
        if (currentMultipleValues == null ? void 0 : currentMultipleValues.includes(selectedValue)) {
          emits("onChange", lodash.exports.without(currentMultipleValues, selectedValue));
          return true;
        }
        emits("onChange", [...currentMultipleValues != null ? currentMultipleValues : [], selectedValue]);
      } else {
        emits("onChange", selected.value);
        closePopper();
        return true;
      }
    };
    const sortSelectedValuesToTop = (modalShown) => {
      var _a2;
      if (!modalShown) {
        emits("onClose");
        return true;
      }
      if (!props.value) {
        return false;
      }
      let toSort = [];
      let notToSort = [];
      const selectedIds = props.multiple ? props.value : [props.value];
      (_a2 = lodash.exports.uniqBy(props.options, "value")) == null ? void 0 : _a2.forEach((each) => {
        if (selectedIds.includes(each.value)) {
          toSort = [...toSort, each];
        } else {
          notToSort = [...notToSort, each];
        }
      });
      currentTree.value = [...toSort, ...notToSort];
    };
    const handleScroll = (e25) => {
      const clientHeight = e25.target.clientHeight;
      const scrollHeight = e25.target.scrollHeight;
      const scrollTop = e25.target.scrollTop;
      emits("onScroll", { clientHeight, scrollHeight, scrollTop });
    };
    const handleRemove = (value2) => {
      emits("onChangeSrc", "TRIGGER");
      if (props.multiple) {
        emits("onChange", lodash.exports.without(props == null ? void 0 : props.value, value2));
        return true;
      }
      emits("onChange", null);
    };
    watch(() => searchString, lodash.exports.debounce((searchString2) => {
      handleSearch(searchString2.value);
    }, 0), { deep: true });
    watch(() => props.options, (updatedOptions) => {
      currentTree.value = lodash.exports.uniqBy(updatedOptions, "value");
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NPopover), {
        class: "advanced-select override-shadow",
        "show-arrow": false,
        trigger: __props.trigger,
        disabled: __props.disabled,
        ref_key: "popper",
        ref: popper,
        raw: "",
        "onUpdate:show": sortSelectedValuesToTop
      }, {
        trigger: withCtx(() => [
          unref(slots).trigger ? renderSlot(_ctx.$slots, "trigger", {
            key: 0,
            disabled: __props.disabled,
            value: unref(selectedValues)
          }) : (openBlock(), createBlock(Trigger, {
            key: 1,
            value: unref(selectedValues),
            disabled: __props.disabled,
            multiple: __props.multiple,
            onOnRemove: handleRemove
          }, null, 8, ["value", "disabled", "multiple"]))
        ]),
        default: withCtx(() => {
          var _a2, _b2;
          return [
            createElementVNode("div", {
              class: "advanced-select__container",
              onScroll: handleScroll
            }, [
              createElementVNode("div", _hoisted_1$i, [
                createVNode(unref(NInput), {
                  id: "advanced-select-search",
                  value: searchString.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event) => searchString.value = $event),
                  loading: __props.loading,
                  placeholder: __props.searchPlaceholder,
                  size: "large"
                }, {
                  prefix: withCtx(() => [
                    createVNode(unref(render$3X), { class: "icon" })
                  ]),
                  _: 1
                }, 8, ["value", "loading", "placeholder"])
              ]),
              __props.virtualScroll ? (openBlock(), createBlock(unref(VirtualList), {
                key: 0,
                class: "virtual-list",
                items: currentTree.value,
                itemSize: 50
              }, {
                default: withCtx(({ item }) => [
                  createVNode(_sfc_main$C, {
                    item,
                    "is-active": unref(transformSelections).includes(item.value),
                    "is-disabled": item.disabled,
                    onOnSelect: onSelectionChange
                  }, null, 8, ["item", "is-active", "is-disabled"])
                ]),
                _: 1
              }, 8, ["items"])) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(currentTree.value, (item) => {
                return openBlock(), createBlock(_sfc_main$C, {
                  key: item.label.toString(),
                  item,
                  "is-active": unref(transformSelections).includes(item.value),
                  "is-disabled": item.disabled,
                  "render-option": __props.renderOption,
                  onOnSelect: onSelectionChange
                }, null, 8, ["item", "is-active", "is-disabled", "render-option"]);
              }), 128)),
              !searchString.value && !((_a2 = __props.options) == null ? void 0 : _a2.length) ? (openBlock(), createElementBlock("div", _hoisted_2$e, [
                unref(slots).empty ? renderSlot(_ctx.$slots, "empty", { key: 0 }) : (openBlock(), createElementBlock("p", _hoisted_3$c, "No data"))
              ])) : createCommentVNode("", true),
              searchString.value && !((_b2 = currentTree.value) == null ? void 0 : _b2.length) ? (openBlock(), createElementBlock("div", _hoisted_4$8, [
                unref(slots).emptySearch ? renderSlot(_ctx.$slots, "emptySearch", { key: 0 }) : (openBlock(), createElementBlock("p", _hoisted_5$6, "No matching results found"))
              ])) : createCommentVNode("", true)
            ], 32)
          ];
        }),
        _: 3
      }, 8, ["trigger", "disabled"]);
    };
  }
}));
_sfc_main$z.install = (Vue) => {
  Vue.component(_sfc_main$z.name, _sfc_main$z);
};
var Alert_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$h = { class: "body" };
const _hoisted_2$d = {
  key: 2,
  class: "mt-3"
};
const __default__$u = defineComponent({
  name: "UIAlert",
  inheritAttrs: false
});
const _sfc_main$y = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$u), {
  props: {
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "default"
    },
    closable: {
      type: Boolean,
      default: true
    }
  },
  emits: ["close"],
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NAlert), {
        id: __props.id,
        type: __props.type,
        closable: __props.closable,
        class: normalizeClass(["rounded-[12px]", [`hl-${__props.type}`]]),
        onClose: _cache[0] || (_cache[0] = () => _ctx.$emit("close", __props.id))
      }, {
        icon: withCtx(() => [
          __props.type === "warning" ? (openBlock(), createBlock(unref(render$46), {
            key: 0,
            class: "w-5 h-5"
          })) : __props.type === "success" ? (openBlock(), createBlock(unref(render$44), {
            key: 1,
            class: "w-5 h-5"
          })) : (openBlock(), createBlock(unref(render$3_), {
            key: 2,
            class: "w-5 h-5"
          }))
        ]),
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$h, [
            unref(slots).title ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: normalizeClass(unref(slots).content || unref(slots).actions ? "title" : "")
            }, [
              createVNode(unref(_sfc_main$1e), null, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "title", {}, void 0, true)
                ]),
                _: 3
              })
            ], 2)) : createCommentVNode("", true),
            unref(slots).content ? renderSlot(_ctx.$slots, "content", { key: 1 }, void 0, true) : createCommentVNode("", true),
            unref(slots).actions ? (openBlock(), createElementBlock("div", _hoisted_2$d, [
              renderSlot(_ctx.$slots, "actions", {}, void 0, true)
            ])) : createCommentVNode("", true)
          ])
        ]),
        _: 3
      }, 8, ["id", "type", "closable", "class"]);
    };
  }
}));
var UIAlert = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["__scopeId", "data-v-1cd95d1d"]]);
UIAlert.install = (Vue) => {
  Vue.component(UIAlert.name, UIAlert);
};
_sfc_main$B.install = (Vue) => {
  Vue.component(_sfc_main$B.name, _sfc_main$B);
};
const __default__$t = defineComponent({
  name: "UIAvatarGroup",
  inheritAttrs: false
});
const _sfc_main$x = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$t), {
  props: {
    size: {
      type: [String, Number],
      default: "medium"
    },
    vertical: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 5
    },
    id: {
      type: String,
      required: true
    },
    options: {
      type: Array
    },
    defaultClassName: {
      type: String
    },
    restClassName: {
      type: String
    },
    src: {
      type: String
    },
    onClose: Function
  },
  setup(__props) {
    function createDropdownOptions2(options) {
      return options.map((option) => ({
        key: option.name,
        label: option.name
      }));
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NAvatarGroup), {
        options: __props.options,
        max: __props.max,
        vertical: __props.vertical
      }, {
        avatar: withCtx(({ option: { name: name2, src, icon, text, className } }) => [
          createVNode(unref(_sfc_main$11), null, {
            trigger: withCtx(() => [
              src ? (openBlock(), createBlock(resolveDynamicComponent(unref(_sfc_main$B)), {
                key: 0,
                src,
                size: __props.size,
                class: normalizeClass(className || __props.defaultClassName)
              }, null, 8, ["src", "size", "class"])) : icon ? (openBlock(), createBlock(unref(_sfc_main$B), {
                key: 1,
                size: __props.size,
                class: normalizeClass(className || __props.defaultClassName)
              }, {
                default: withCtx(() => [
                  (openBlock(), createBlock(resolveDynamicComponent(icon)))
                ]),
                _: 2
              }, 1032, ["size", "class"])) : (openBlock(), createBlock(resolveDynamicComponent(unref(_sfc_main$B)), {
                key: 2,
                size: __props.size,
                class: normalizeClass(className || __props.defaultClassName)
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(text != null ? text : name2), 1)
                ]),
                _: 2
              }, 1032, ["size", "class"]))
            ]),
            default: withCtx(() => [
              createTextVNode(" " + toDisplayString(name2), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        rest: withCtx(({ options: restOptions, rest }) => [
          createVNode(unref(_sfc_main$$), {
            trigger: "hover",
            options: createDropdownOptions2(restOptions),
            placement: "top",
            id: `${__props.id}-dropdown`
          }, {
            default: withCtx(() => [
              createVNode(unref(_sfc_main$B), {
                id: `${__props.id}-dropdown-trigger`,
                class: normalizeClass(__props.restClassName || __props.defaultClassName),
                size: __props.size
              }, {
                default: withCtx(() => [
                  createTextVNode("+" + toDisplayString(rest), 1)
                ]),
                _: 2
              }, 1032, ["id", "class", "size"])
            ]),
            _: 2
          }, 1032, ["options", "id"])
        ]),
        _: 1
      }, 8, ["options", "max", "vertical"]);
    };
  }
}));
_sfc_main$x.install = (Vue) => {
  Vue.component(_sfc_main$x.name, _sfc_main$x);
};
const __default__$s = defineComponent({
  name: "UIBadge",
  inheritAttrs: false
});
const _sfc_main$w = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$s), {
  props: {
    id: {
      type: String,
      required: true
    },
    color: {
      type: String
    },
    dot: {
      type: Boolean
    },
    max: {
      type: Number
    },
    processing: {
      type: Boolean
    },
    showZero: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "default"
    },
    value: {
      type: [Number, String],
      default: void 0
    },
    offset: {
      type: Array
    }
  },
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NBadge), {
        color: __props.color,
        dot: __props.dot,
        max: __props.max,
        processing: __props.processing,
        "show-zero": __props.showZero,
        show: __props.show,
        type: __props.type,
        value: __props.value,
        offset: __props.offset
      }, createSlots({
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "content")
        ]),
        _: 2
      }, [
        unref(slots).value ? {
          name: "value",
          fn: withCtx(() => [
            renderSlot(_ctx.$slots, "value")
          ])
        } : void 0
      ]), 1032, ["color", "dot", "max", "processing", "show-zero", "show", "type", "value", "offset"]);
    };
  }
}));
_sfc_main$w.install = (Vue) => {
  Vue.component(_sfc_main$w.name, _sfc_main$w);
};
const EOF$1 = 0;
const Ident = 1;
const Function$2 = 2;
const AtKeyword = 3;
const Hash$1 = 4;
const String$2 = 5;
const BadString = 6;
const Url$1 = 7;
const BadUrl = 8;
const Delim = 9;
const Number$2 = 10;
const Percentage$1 = 11;
const Dimension$1 = 12;
const WhiteSpace$1 = 13;
const CDO$1 = 14;
const CDC$1 = 15;
const Colon = 16;
const Semicolon = 17;
const Comma = 18;
const LeftSquareBracket = 19;
const RightSquareBracket = 20;
const LeftParenthesis = 21;
const RightParenthesis = 22;
const LeftCurlyBracket = 23;
const RightCurlyBracket = 24;
const Comment$1 = 25;
const EOF = 0;
function isDigit$1(code) {
  return code >= 48 && code <= 57;
}
function isHexDigit(code) {
  return isDigit$1(code) || code >= 65 && code <= 70 || code >= 97 && code <= 102;
}
function isUppercaseLetter(code) {
  return code >= 65 && code <= 90;
}
function isLowercaseLetter(code) {
  return code >= 97 && code <= 122;
}
function isLetter(code) {
  return isUppercaseLetter(code) || isLowercaseLetter(code);
}
function isNonAscii(code) {
  return code >= 128;
}
function isNameStart(code) {
  return isLetter(code) || isNonAscii(code) || code === 95;
}
function isName(code) {
  return isNameStart(code) || isDigit$1(code) || code === 45;
}
function isNonPrintable(code) {
  return code >= 0 && code <= 8 || code === 11 || code >= 14 && code <= 31 || code === 127;
}
function isNewline(code) {
  return code === 10 || code === 13 || code === 12;
}
function isWhiteSpace(code) {
  return isNewline(code) || code === 32 || code === 9;
}
function isValidEscape(first, second) {
  if (first !== 92) {
    return false;
  }
  if (isNewline(second) || second === EOF) {
    return false;
  }
  return true;
}
function isIdentifierStart(first, second, third) {
  if (first === 45) {
    return isNameStart(second) || second === 45 || isValidEscape(second, third);
  }
  if (isNameStart(first)) {
    return true;
  }
  if (first === 92) {
    return isValidEscape(first, second);
  }
  return false;
}
function isNumberStart(first, second, third) {
  if (first === 43 || first === 45) {
    if (isDigit$1(second)) {
      return 2;
    }
    return second === 46 && isDigit$1(third) ? 3 : 0;
  }
  if (first === 46) {
    return isDigit$1(second) ? 2 : 0;
  }
  if (isDigit$1(first)) {
    return 1;
  }
  return 0;
}
function isBOM(code) {
  if (code === 65279) {
    return 1;
  }
  if (code === 65534) {
    return 1;
  }
  return 0;
}
const CATEGORY = new Array(128);
const EofCategory = 128;
const WhiteSpaceCategory = 130;
const DigitCategory = 131;
const NameStartCategory = 132;
const NonPrintableCategory = 133;
for (let i2 = 0; i2 < CATEGORY.length; i2++) {
  CATEGORY[i2] = isWhiteSpace(i2) && WhiteSpaceCategory || isDigit$1(i2) && DigitCategory || isNameStart(i2) && NameStartCategory || isNonPrintable(i2) && NonPrintableCategory || i2 || EofCategory;
}
function charCodeCategory(code) {
  return code < 128 ? CATEGORY[code] : NameStartCategory;
}
function getCharCode(source, offset) {
  return offset < source.length ? source.charCodeAt(offset) : 0;
}
function getNewlineLength(source, offset, code) {
  if (code === 13 && getCharCode(source, offset + 1) === 10) {
    return 2;
  }
  return 1;
}
function cmpChar(testStr, offset, referenceCode) {
  let code = testStr.charCodeAt(offset);
  if (isUppercaseLetter(code)) {
    code = code | 32;
  }
  return code === referenceCode;
}
function cmpStr(testStr, start, end, referenceStr) {
  if (end - start !== referenceStr.length) {
    return false;
  }
  if (start < 0 || end > testStr.length) {
    return false;
  }
  for (let i2 = start; i2 < end; i2++) {
    const referenceCode = referenceStr.charCodeAt(i2 - start);
    let testCode = testStr.charCodeAt(i2);
    if (isUppercaseLetter(testCode)) {
      testCode = testCode | 32;
    }
    if (testCode !== referenceCode) {
      return false;
    }
  }
  return true;
}
function findWhiteSpaceStart(source, offset) {
  for (; offset >= 0; offset--) {
    if (!isWhiteSpace(source.charCodeAt(offset))) {
      break;
    }
  }
  return offset + 1;
}
function findWhiteSpaceEnd(source, offset) {
  for (; offset < source.length; offset++) {
    if (!isWhiteSpace(source.charCodeAt(offset))) {
      break;
    }
  }
  return offset;
}
function findDecimalNumberEnd(source, offset) {
  for (; offset < source.length; offset++) {
    if (!isDigit$1(source.charCodeAt(offset))) {
      break;
    }
  }
  return offset;
}
function consumeEscaped(source, offset) {
  offset += 2;
  if (isHexDigit(getCharCode(source, offset - 1))) {
    for (const maxOffset2 = Math.min(source.length, offset + 5); offset < maxOffset2; offset++) {
      if (!isHexDigit(getCharCode(source, offset))) {
        break;
      }
    }
    const code = getCharCode(source, offset);
    if (isWhiteSpace(code)) {
      offset += getNewlineLength(source, offset, code);
    }
  }
  return offset;
}
function consumeName(source, offset) {
  for (; offset < source.length; offset++) {
    const code = source.charCodeAt(offset);
    if (isName(code)) {
      continue;
    }
    if (isValidEscape(code, getCharCode(source, offset + 1))) {
      offset = consumeEscaped(source, offset) - 1;
      continue;
    }
    break;
  }
  return offset;
}
function consumeNumber$1(source, offset) {
  let code = source.charCodeAt(offset);
  if (code === 43 || code === 45) {
    code = source.charCodeAt(offset += 1);
  }
  if (isDigit$1(code)) {
    offset = findDecimalNumberEnd(source, offset + 1);
    code = source.charCodeAt(offset);
  }
  if (code === 46 && isDigit$1(source.charCodeAt(offset + 1))) {
    offset += 2;
    offset = findDecimalNumberEnd(source, offset);
  }
  if (cmpChar(source, offset, 101)) {
    let sign = 0;
    code = source.charCodeAt(offset + 1);
    if (code === 45 || code === 43) {
      sign = 1;
      code = source.charCodeAt(offset + 2);
    }
    if (isDigit$1(code)) {
      offset = findDecimalNumberEnd(source, offset + 1 + sign + 1);
    }
  }
  return offset;
}
function consumeBadUrlRemnants(source, offset) {
  for (; offset < source.length; offset++) {
    const code = source.charCodeAt(offset);
    if (code === 41) {
      offset++;
      break;
    }
    if (isValidEscape(code, getCharCode(source, offset + 1))) {
      offset = consumeEscaped(source, offset);
    }
  }
  return offset;
}
function decodeEscaped(escaped) {
  if (escaped.length === 1 && !isHexDigit(escaped.charCodeAt(0))) {
    return escaped[0];
  }
  let code = parseInt(escaped, 16);
  if (code === 0 || code >= 55296 && code <= 57343 || code > 1114111) {
    code = 65533;
  }
  return String.fromCodePoint(code);
}
var tokenNames = [
  "EOF-token",
  "ident-token",
  "function-token",
  "at-keyword-token",
  "hash-token",
  "string-token",
  "bad-string-token",
  "url-token",
  "bad-url-token",
  "delim-token",
  "number-token",
  "percentage-token",
  "dimension-token",
  "whitespace-token",
  "CDO-token",
  "CDC-token",
  "colon-token",
  "semicolon-token",
  "comma-token",
  "[-token",
  "]-token",
  "(-token",
  ")-token",
  "{-token",
  "}-token"
];
const MIN_SIZE = 16 * 1024;
function adoptBuffer(buffer = null, size2) {
  if (buffer === null || buffer.length < size2) {
    return new Uint32Array(Math.max(size2 + 1024, MIN_SIZE));
  }
  return buffer;
}
const N$5 = 10;
const F$3 = 12;
const R$3 = 13;
function computeLinesAndColumns(host) {
  const source = host.source;
  const sourceLength = source.length;
  const startOffset = source.length > 0 ? isBOM(source.charCodeAt(0)) : 0;
  const lines = adoptBuffer(host.lines, sourceLength);
  const columns = adoptBuffer(host.columns, sourceLength);
  let line = host.startLine;
  let column = host.startColumn;
  for (let i2 = startOffset; i2 < sourceLength; i2++) {
    const code = source.charCodeAt(i2);
    lines[i2] = line;
    columns[i2] = column++;
    if (code === N$5 || code === R$3 || code === F$3) {
      if (code === R$3 && i2 + 1 < sourceLength && source.charCodeAt(i2 + 1) === N$5) {
        i2++;
        lines[i2] = line;
        columns[i2] = column;
      }
      line++;
      column = 1;
    }
  }
  lines[sourceLength] = line;
  columns[sourceLength] = column;
  host.lines = lines;
  host.columns = columns;
  host.computed = true;
}
class OffsetToLocation {
  constructor() {
    this.lines = null;
    this.columns = null;
    this.computed = false;
  }
  setSource(source, startOffset = 0, startLine = 1, startColumn = 1) {
    this.source = source;
    this.startOffset = startOffset;
    this.startLine = startLine;
    this.startColumn = startColumn;
    this.computed = false;
  }
  getLocation(offset, filename) {
    if (!this.computed) {
      computeLinesAndColumns(this);
    }
    return {
      source: filename,
      offset: this.startOffset + offset,
      line: this.lines[offset],
      column: this.columns[offset]
    };
  }
  getLocationRange(start, end, filename) {
    if (!this.computed) {
      computeLinesAndColumns(this);
    }
    return {
      source: filename,
      start: {
        offset: this.startOffset + start,
        line: this.lines[start],
        column: this.columns[start]
      },
      end: {
        offset: this.startOffset + end,
        line: this.lines[end],
        column: this.columns[end]
      }
    };
  }
}
const OFFSET_MASK = 16777215;
const TYPE_SHIFT = 24;
const balancePair$1 = new Map([
  [Function$2, RightParenthesis],
  [LeftParenthesis, RightParenthesis],
  [LeftSquareBracket, RightSquareBracket],
  [LeftCurlyBracket, RightCurlyBracket]
]);
class TokenStream {
  constructor(source, tokenize2) {
    this.setSource(source, tokenize2);
  }
  reset() {
    this.eof = false;
    this.tokenIndex = -1;
    this.tokenType = 0;
    this.tokenStart = this.firstCharOffset;
    this.tokenEnd = this.firstCharOffset;
  }
  setSource(source = "", tokenize2 = () => {
  }) {
    source = String(source || "");
    const sourceLength = source.length;
    const offsetAndType = adoptBuffer(this.offsetAndType, source.length + 1);
    const balance = adoptBuffer(this.balance, source.length + 1);
    let tokenCount = 0;
    let balanceCloseType = 0;
    let balanceStart = 0;
    let firstCharOffset = -1;
    this.offsetAndType = null;
    this.balance = null;
    tokenize2(source, (type4, start, end) => {
      switch (type4) {
        default:
          balance[tokenCount] = sourceLength;
          break;
        case balanceCloseType: {
          let balancePrev = balanceStart & OFFSET_MASK;
          balanceStart = balance[balancePrev];
          balanceCloseType = balanceStart >> TYPE_SHIFT;
          balance[tokenCount] = balancePrev;
          balance[balancePrev++] = tokenCount;
          for (; balancePrev < tokenCount; balancePrev++) {
            if (balance[balancePrev] === sourceLength) {
              balance[balancePrev] = tokenCount;
            }
          }
          break;
        }
        case LeftParenthesis:
        case Function$2:
        case LeftSquareBracket:
        case LeftCurlyBracket:
          balance[tokenCount] = balanceStart;
          balanceCloseType = balancePair$1.get(type4);
          balanceStart = balanceCloseType << TYPE_SHIFT | tokenCount;
          break;
      }
      offsetAndType[tokenCount++] = type4 << TYPE_SHIFT | end;
      if (firstCharOffset === -1) {
        firstCharOffset = start;
      }
    });
    offsetAndType[tokenCount] = EOF$1 << TYPE_SHIFT | sourceLength;
    balance[tokenCount] = sourceLength;
    balance[sourceLength] = sourceLength;
    while (balanceStart !== 0) {
      const balancePrev = balanceStart & OFFSET_MASK;
      balanceStart = balance[balancePrev];
      balance[balancePrev] = sourceLength;
    }
    this.source = source;
    this.firstCharOffset = firstCharOffset === -1 ? 0 : firstCharOffset;
    this.tokenCount = tokenCount;
    this.offsetAndType = offsetAndType;
    this.balance = balance;
    this.reset();
    this.next();
  }
  lookupType(offset) {
    offset += this.tokenIndex;
    if (offset < this.tokenCount) {
      return this.offsetAndType[offset] >> TYPE_SHIFT;
    }
    return EOF$1;
  }
  lookupOffset(offset) {
    offset += this.tokenIndex;
    if (offset < this.tokenCount) {
      return this.offsetAndType[offset - 1] & OFFSET_MASK;
    }
    return this.source.length;
  }
  lookupValue(offset, referenceStr) {
    offset += this.tokenIndex;
    if (offset < this.tokenCount) {
      return cmpStr(this.source, this.offsetAndType[offset - 1] & OFFSET_MASK, this.offsetAndType[offset] & OFFSET_MASK, referenceStr);
    }
    return false;
  }
  getTokenStart(tokenIndex) {
    if (tokenIndex === this.tokenIndex) {
      return this.tokenStart;
    }
    if (tokenIndex > 0) {
      return tokenIndex < this.tokenCount ? this.offsetAndType[tokenIndex - 1] & OFFSET_MASK : this.offsetAndType[this.tokenCount] & OFFSET_MASK;
    }
    return this.firstCharOffset;
  }
  substrToCursor(start) {
    return this.source.substring(start, this.tokenStart);
  }
  isBalanceEdge(pos) {
    return this.balance[this.tokenIndex] < pos;
  }
  isDelim(code, offset) {
    if (offset) {
      return this.lookupType(offset) === Delim && this.source.charCodeAt(this.lookupOffset(offset)) === code;
    }
    return this.tokenType === Delim && this.source.charCodeAt(this.tokenStart) === code;
  }
  skip(tokenCount) {
    let next = this.tokenIndex + tokenCount;
    if (next < this.tokenCount) {
      this.tokenIndex = next;
      this.tokenStart = this.offsetAndType[next - 1] & OFFSET_MASK;
      next = this.offsetAndType[next];
      this.tokenType = next >> TYPE_SHIFT;
      this.tokenEnd = next & OFFSET_MASK;
    } else {
      this.tokenIndex = this.tokenCount;
      this.next();
    }
  }
  next() {
    let next = this.tokenIndex + 1;
    if (next < this.tokenCount) {
      this.tokenIndex = next;
      this.tokenStart = this.tokenEnd;
      next = this.offsetAndType[next];
      this.tokenType = next >> TYPE_SHIFT;
      this.tokenEnd = next & OFFSET_MASK;
    } else {
      this.eof = true;
      this.tokenIndex = this.tokenCount;
      this.tokenType = EOF$1;
      this.tokenStart = this.tokenEnd = this.source.length;
    }
  }
  skipSC() {
    while (this.tokenType === WhiteSpace$1 || this.tokenType === Comment$1) {
      this.next();
    }
  }
  skipUntilBalanced(startToken, stopConsume) {
    let cursor = startToken;
    let balanceEnd;
    let offset;
    loop:
      for (; cursor < this.tokenCount; cursor++) {
        balanceEnd = this.balance[cursor];
        if (balanceEnd < startToken) {
          break loop;
        }
        offset = cursor > 0 ? this.offsetAndType[cursor - 1] & OFFSET_MASK : this.firstCharOffset;
        switch (stopConsume(this.source.charCodeAt(offset))) {
          case 1:
            break loop;
          case 2:
            cursor++;
            break loop;
          default:
            if (this.balance[balanceEnd] === cursor) {
              cursor = balanceEnd;
            }
        }
      }
    this.skip(cursor - this.tokenIndex);
  }
  forEachToken(fn2) {
    for (let i2 = 0, offset = this.firstCharOffset; i2 < this.tokenCount; i2++) {
      const start = offset;
      const item = this.offsetAndType[i2];
      const end = item & OFFSET_MASK;
      const type4 = item >> TYPE_SHIFT;
      offset = end;
      fn2(type4, start, end, i2);
    }
  }
  dump() {
    const tokens = new Array(this.tokenCount);
    this.forEachToken((type4, start, end, index2) => {
      tokens[index2] = {
        idx: index2,
        type: tokenNames[type4],
        chunk: this.source.substring(start, end),
        balance: this.balance[index2]
      };
    });
    return tokens;
  }
}
function tokenize$1(source, onToken) {
  function getCharCode2(offset2) {
    return offset2 < sourceLength ? source.charCodeAt(offset2) : 0;
  }
  function consumeNumericToken() {
    offset = consumeNumber$1(source, offset);
    if (isIdentifierStart(getCharCode2(offset), getCharCode2(offset + 1), getCharCode2(offset + 2))) {
      type4 = Dimension$1;
      offset = consumeName(source, offset);
      return;
    }
    if (getCharCode2(offset) === 37) {
      type4 = Percentage$1;
      offset++;
      return;
    }
    type4 = Number$2;
  }
  function consumeIdentLikeToken() {
    const nameStartOffset = offset;
    offset = consumeName(source, offset);
    if (cmpStr(source, nameStartOffset, offset, "url") && getCharCode2(offset) === 40) {
      offset = findWhiteSpaceEnd(source, offset + 1);
      if (getCharCode2(offset) === 34 || getCharCode2(offset) === 39) {
        type4 = Function$2;
        offset = nameStartOffset + 4;
        return;
      }
      consumeUrlToken();
      return;
    }
    if (getCharCode2(offset) === 40) {
      type4 = Function$2;
      offset++;
      return;
    }
    type4 = Ident;
  }
  function consumeStringToken(endingCodePoint) {
    if (!endingCodePoint) {
      endingCodePoint = getCharCode2(offset++);
    }
    type4 = String$2;
    for (; offset < source.length; offset++) {
      const code = source.charCodeAt(offset);
      switch (charCodeCategory(code)) {
        case endingCodePoint:
          offset++;
          return;
        case WhiteSpaceCategory:
          if (isNewline(code)) {
            offset += getNewlineLength(source, offset, code);
            type4 = BadString;
            return;
          }
          break;
        case 92:
          if (offset === source.length - 1) {
            break;
          }
          const nextCode = getCharCode2(offset + 1);
          if (isNewline(nextCode)) {
            offset += getNewlineLength(source, offset + 1, nextCode);
          } else if (isValidEscape(code, nextCode)) {
            offset = consumeEscaped(source, offset) - 1;
          }
          break;
      }
    }
  }
  function consumeUrlToken() {
    type4 = Url$1;
    offset = findWhiteSpaceEnd(source, offset);
    for (; offset < source.length; offset++) {
      const code = source.charCodeAt(offset);
      switch (charCodeCategory(code)) {
        case 41:
          offset++;
          return;
        case WhiteSpaceCategory:
          offset = findWhiteSpaceEnd(source, offset);
          if (getCharCode2(offset) === 41 || offset >= source.length) {
            if (offset < source.length) {
              offset++;
            }
            return;
          }
          offset = consumeBadUrlRemnants(source, offset);
          type4 = BadUrl;
          return;
        case 34:
        case 39:
        case 40:
        case NonPrintableCategory:
          offset = consumeBadUrlRemnants(source, offset);
          type4 = BadUrl;
          return;
        case 92:
          if (isValidEscape(code, getCharCode2(offset + 1))) {
            offset = consumeEscaped(source, offset) - 1;
            break;
          }
          offset = consumeBadUrlRemnants(source, offset);
          type4 = BadUrl;
          return;
      }
    }
  }
  source = String(source || "");
  const sourceLength = source.length;
  let start = isBOM(getCharCode2(0));
  let offset = start;
  let type4;
  while (offset < sourceLength) {
    const code = source.charCodeAt(offset);
    switch (charCodeCategory(code)) {
      case WhiteSpaceCategory:
        type4 = WhiteSpace$1;
        offset = findWhiteSpaceEnd(source, offset + 1);
        break;
      case 34:
        consumeStringToken();
        break;
      case 35:
        if (isName(getCharCode2(offset + 1)) || isValidEscape(getCharCode2(offset + 1), getCharCode2(offset + 2))) {
          type4 = Hash$1;
          offset = consumeName(source, offset + 1);
        } else {
          type4 = Delim;
          offset++;
        }
        break;
      case 39:
        consumeStringToken();
        break;
      case 40:
        type4 = LeftParenthesis;
        offset++;
        break;
      case 41:
        type4 = RightParenthesis;
        offset++;
        break;
      case 43:
        if (isNumberStart(code, getCharCode2(offset + 1), getCharCode2(offset + 2))) {
          consumeNumericToken();
        } else {
          type4 = Delim;
          offset++;
        }
        break;
      case 44:
        type4 = Comma;
        offset++;
        break;
      case 45:
        if (isNumberStart(code, getCharCode2(offset + 1), getCharCode2(offset + 2))) {
          consumeNumericToken();
        } else {
          if (getCharCode2(offset + 1) === 45 && getCharCode2(offset + 2) === 62) {
            type4 = CDC$1;
            offset = offset + 3;
          } else {
            if (isIdentifierStart(code, getCharCode2(offset + 1), getCharCode2(offset + 2))) {
              consumeIdentLikeToken();
            } else {
              type4 = Delim;
              offset++;
            }
          }
        }
        break;
      case 46:
        if (isNumberStart(code, getCharCode2(offset + 1), getCharCode2(offset + 2))) {
          consumeNumericToken();
        } else {
          type4 = Delim;
          offset++;
        }
        break;
      case 47:
        if (getCharCode2(offset + 1) === 42) {
          type4 = Comment$1;
          offset = source.indexOf("*/", offset + 2);
          offset = offset === -1 ? source.length : offset + 2;
        } else {
          type4 = Delim;
          offset++;
        }
        break;
      case 58:
        type4 = Colon;
        offset++;
        break;
      case 59:
        type4 = Semicolon;
        offset++;
        break;
      case 60:
        if (getCharCode2(offset + 1) === 33 && getCharCode2(offset + 2) === 45 && getCharCode2(offset + 3) === 45) {
          type4 = CDO$1;
          offset = offset + 4;
        } else {
          type4 = Delim;
          offset++;
        }
        break;
      case 64:
        if (isIdentifierStart(getCharCode2(offset + 1), getCharCode2(offset + 2), getCharCode2(offset + 3))) {
          type4 = AtKeyword;
          offset = consumeName(source, offset + 1);
        } else {
          type4 = Delim;
          offset++;
        }
        break;
      case 91:
        type4 = LeftSquareBracket;
        offset++;
        break;
      case 92:
        if (isValidEscape(code, getCharCode2(offset + 1))) {
          consumeIdentLikeToken();
        } else {
          type4 = Delim;
          offset++;
        }
        break;
      case 93:
        type4 = RightSquareBracket;
        offset++;
        break;
      case 123:
        type4 = LeftCurlyBracket;
        offset++;
        break;
      case 125:
        type4 = RightCurlyBracket;
        offset++;
        break;
      case DigitCategory:
        consumeNumericToken();
        break;
      case NameStartCategory:
        consumeIdentLikeToken();
        break;
      default:
        type4 = Delim;
        offset++;
    }
    onToken(type4, start, start = offset);
  }
}
let releasedCursors = null;
class List {
  static createItem(data) {
    return {
      prev: null,
      next: null,
      data
    };
  }
  constructor() {
    this.head = null;
    this.tail = null;
    this.cursor = null;
  }
  createItem(data) {
    return List.createItem(data);
  }
  allocateCursor(prev, next) {
    let cursor;
    if (releasedCursors !== null) {
      cursor = releasedCursors;
      releasedCursors = releasedCursors.cursor;
      cursor.prev = prev;
      cursor.next = next;
      cursor.cursor = this.cursor;
    } else {
      cursor = {
        prev,
        next,
        cursor: this.cursor
      };
    }
    this.cursor = cursor;
    return cursor;
  }
  releaseCursor() {
    const { cursor } = this;
    this.cursor = cursor.cursor;
    cursor.prev = null;
    cursor.next = null;
    cursor.cursor = releasedCursors;
    releasedCursors = cursor;
  }
  updateCursors(prevOld, prevNew, nextOld, nextNew) {
    let { cursor } = this;
    while (cursor !== null) {
      if (cursor.prev === prevOld) {
        cursor.prev = prevNew;
      }
      if (cursor.next === nextOld) {
        cursor.next = nextNew;
      }
      cursor = cursor.cursor;
    }
  }
  *[Symbol.iterator]() {
    for (let cursor = this.head; cursor !== null; cursor = cursor.next) {
      yield cursor.data;
    }
  }
  get size() {
    let size2 = 0;
    for (let cursor = this.head; cursor !== null; cursor = cursor.next) {
      size2++;
    }
    return size2;
  }
  get isEmpty() {
    return this.head === null;
  }
  get first() {
    return this.head && this.head.data;
  }
  get last() {
    return this.tail && this.tail.data;
  }
  fromArray(array4) {
    let cursor = null;
    this.head = null;
    for (let data of array4) {
      const item = List.createItem(data);
      if (cursor !== null) {
        cursor.next = item;
      } else {
        this.head = item;
      }
      item.prev = cursor;
      cursor = item;
    }
    this.tail = cursor;
    return this;
  }
  toArray() {
    return [...this];
  }
  toJSON() {
    return [...this];
  }
  forEach(fn2, thisArg = this) {
    const cursor = this.allocateCursor(null, this.head);
    while (cursor.next !== null) {
      const item = cursor.next;
      cursor.next = item.next;
      fn2.call(thisArg, item.data, item, this);
    }
    this.releaseCursor();
  }
  forEachRight(fn2, thisArg = this) {
    const cursor = this.allocateCursor(this.tail, null);
    while (cursor.prev !== null) {
      const item = cursor.prev;
      cursor.prev = item.prev;
      fn2.call(thisArg, item.data, item, this);
    }
    this.releaseCursor();
  }
  reduce(fn2, initialValue, thisArg = this) {
    let cursor = this.allocateCursor(null, this.head);
    let acc = initialValue;
    let item;
    while (cursor.next !== null) {
      item = cursor.next;
      cursor.next = item.next;
      acc = fn2.call(thisArg, acc, item.data, item, this);
    }
    this.releaseCursor();
    return acc;
  }
  reduceRight(fn2, initialValue, thisArg = this) {
    let cursor = this.allocateCursor(this.tail, null);
    let acc = initialValue;
    let item;
    while (cursor.prev !== null) {
      item = cursor.prev;
      cursor.prev = item.prev;
      acc = fn2.call(thisArg, acc, item.data, item, this);
    }
    this.releaseCursor();
    return acc;
  }
  some(fn2, thisArg = this) {
    for (let cursor = this.head; cursor !== null; cursor = cursor.next) {
      if (fn2.call(thisArg, cursor.data, cursor, this)) {
        return true;
      }
    }
    return false;
  }
  map(fn2, thisArg = this) {
    const result2 = new List();
    for (let cursor = this.head; cursor !== null; cursor = cursor.next) {
      result2.appendData(fn2.call(thisArg, cursor.data, cursor, this));
    }
    return result2;
  }
  filter(fn2, thisArg = this) {
    const result2 = new List();
    for (let cursor = this.head; cursor !== null; cursor = cursor.next) {
      if (fn2.call(thisArg, cursor.data, cursor, this)) {
        result2.appendData(cursor.data);
      }
    }
    return result2;
  }
  nextUntil(start, fn2, thisArg = this) {
    if (start === null) {
      return;
    }
    const cursor = this.allocateCursor(null, start);
    while (cursor.next !== null) {
      const item = cursor.next;
      cursor.next = item.next;
      if (fn2.call(thisArg, item.data, item, this)) {
        break;
      }
    }
    this.releaseCursor();
  }
  prevUntil(start, fn2, thisArg = this) {
    if (start === null) {
      return;
    }
    const cursor = this.allocateCursor(start, null);
    while (cursor.prev !== null) {
      const item = cursor.prev;
      cursor.prev = item.prev;
      if (fn2.call(thisArg, item.data, item, this)) {
        break;
      }
    }
    this.releaseCursor();
  }
  clear() {
    this.head = null;
    this.tail = null;
  }
  copy() {
    const result2 = new List();
    for (let data of this) {
      result2.appendData(data);
    }
    return result2;
  }
  prepend(item) {
    this.updateCursors(null, item, this.head, item);
    if (this.head !== null) {
      this.head.prev = item;
      item.next = this.head;
    } else {
      this.tail = item;
    }
    this.head = item;
    return this;
  }
  prependData(data) {
    return this.prepend(List.createItem(data));
  }
  append(item) {
    return this.insert(item);
  }
  appendData(data) {
    return this.insert(List.createItem(data));
  }
  insert(item, before = null) {
    if (before !== null) {
      this.updateCursors(before.prev, item, before, item);
      if (before.prev === null) {
        if (this.head !== before) {
          throw new Error("before doesn't belong to list");
        }
        this.head = item;
        before.prev = item;
        item.next = before;
        this.updateCursors(null, item);
      } else {
        before.prev.next = item;
        item.prev = before.prev;
        before.prev = item;
        item.next = before;
      }
    } else {
      this.updateCursors(this.tail, item, null, item);
      if (this.tail !== null) {
        this.tail.next = item;
        item.prev = this.tail;
      } else {
        this.head = item;
      }
      this.tail = item;
    }
    return this;
  }
  insertData(data, before) {
    return this.insert(List.createItem(data), before);
  }
  remove(item) {
    this.updateCursors(item, item.prev, item, item.next);
    if (item.prev !== null) {
      item.prev.next = item.next;
    } else {
      if (this.head !== item) {
        throw new Error("item doesn't belong to list");
      }
      this.head = item.next;
    }
    if (item.next !== null) {
      item.next.prev = item.prev;
    } else {
      if (this.tail !== item) {
        throw new Error("item doesn't belong to list");
      }
      this.tail = item.prev;
    }
    item.prev = null;
    item.next = null;
    return item;
  }
  push(data) {
    this.insert(List.createItem(data));
  }
  pop() {
    return this.tail !== null ? this.remove(this.tail) : null;
  }
  unshift(data) {
    this.prepend(List.createItem(data));
  }
  shift() {
    return this.head !== null ? this.remove(this.head) : null;
  }
  prependList(list) {
    return this.insertList(list, this.head);
  }
  appendList(list) {
    return this.insertList(list);
  }
  insertList(list, before) {
    if (list.head === null) {
      return this;
    }
    if (before !== void 0 && before !== null) {
      this.updateCursors(before.prev, list.tail, before, list.head);
      if (before.prev !== null) {
        before.prev.next = list.head;
        list.head.prev = before.prev;
      } else {
        this.head = list.head;
      }
      before.prev = list.tail;
      list.tail.next = before;
    } else {
      this.updateCursors(this.tail, list.tail, null, list.head);
      if (this.tail !== null) {
        this.tail.next = list.head;
        list.head.prev = this.tail;
      } else {
        this.head = list.head;
      }
      this.tail = list.tail;
    }
    list.head = null;
    list.tail = null;
    return this;
  }
  replace(oldItem, newItemOrList) {
    if ("head" in newItemOrList) {
      this.insertList(newItemOrList, oldItem);
    } else {
      this.insert(newItemOrList, oldItem);
    }
    this.remove(oldItem);
  }
}
function createCustomError(name2, message) {
  const error = Object.create(SyntaxError.prototype);
  const errorStack = new Error();
  return Object.assign(error, {
    name: name2,
    message,
    get stack() {
      return (errorStack.stack || "").replace(/^(.+\n){1,3}/, `${name2}: ${message}
`);
    }
  });
}
const MAX_LINE_LENGTH = 100;
const OFFSET_CORRECTION = 60;
const TAB_REPLACEMENT = "    ";
function sourceFragment({ source, line, column }, extraLines) {
  function processLines(start, end) {
    return lines.slice(start, end).map((line2, idx) => String(start + idx + 1).padStart(maxNumLength) + " |" + line2).join("\n");
  }
  const lines = source.split(/\r\n?|\n|\f/);
  const startLine = Math.max(1, line - extraLines) - 1;
  const endLine = Math.min(line + extraLines, lines.length + 1);
  const maxNumLength = Math.max(4, String(endLine).length) + 1;
  let cutLeft = 0;
  column += (TAB_REPLACEMENT.length - 1) * (lines[line - 1].substr(0, column - 1).match(/\t/g) || []).length;
  if (column > MAX_LINE_LENGTH) {
    cutLeft = column - OFFSET_CORRECTION + 3;
    column = OFFSET_CORRECTION - 2;
  }
  for (let i2 = startLine; i2 <= endLine; i2++) {
    if (i2 >= 0 && i2 < lines.length) {
      lines[i2] = lines[i2].replace(/\t/g, TAB_REPLACEMENT);
      lines[i2] = (cutLeft > 0 && lines[i2].length > cutLeft ? "\u2026" : "") + lines[i2].substr(cutLeft, MAX_LINE_LENGTH - 2) + (lines[i2].length > cutLeft + MAX_LINE_LENGTH - 1 ? "\u2026" : "");
    }
  }
  return [
    processLines(startLine, line),
    new Array(column + maxNumLength + 2).join("-") + "^",
    processLines(line, endLine)
  ].filter(Boolean).join("\n");
}
function SyntaxError$2(message, source, offset, line, column) {
  const error = Object.assign(createCustomError("SyntaxError", message), {
    source,
    offset,
    line,
    column,
    sourceFragment(extraLines) {
      return sourceFragment({ source, line, column }, isNaN(extraLines) ? 0 : extraLines);
    },
    get formattedMessage() {
      return `Parse error: ${message}
` + sourceFragment({ source, line, column }, 2);
    }
  });
  return error;
}
function readSequence$1(recognizer) {
  const children = this.createList();
  let space2 = false;
  const context = {
    recognizer
  };
  while (!this.eof) {
    switch (this.tokenType) {
      case Comment$1:
        this.next();
        continue;
      case WhiteSpace$1:
        space2 = true;
        this.next();
        continue;
    }
    let child = recognizer.getNode.call(this, context);
    if (child === void 0) {
      break;
    }
    if (space2) {
      if (recognizer.onWhiteSpace) {
        recognizer.onWhiteSpace.call(this, child, children, context);
      }
      space2 = false;
    }
    children.push(child);
  }
  if (space2 && recognizer.onWhiteSpace) {
    recognizer.onWhiteSpace.call(this, null, children, context);
  }
  return children;
}
const NOOP = () => {
};
const EXCLAMATIONMARK$3 = 33;
const NUMBERSIGN$4 = 35;
const SEMICOLON = 59;
const LEFTCURLYBRACKET$1 = 123;
const NULL = 0;
function createParseContext(name2) {
  return function() {
    return this[name2]();
  };
}
function fetchParseValues(dict) {
  const result2 = Object.create(null);
  for (const name2 in dict) {
    const item = dict[name2];
    const fn2 = item.parse || item;
    if (fn2) {
      result2[name2] = fn2;
    }
  }
  return result2;
}
function processConfig(config2) {
  const parseConfig = {
    context: Object.create(null),
    scope: Object.assign(Object.create(null), config2.scope),
    atrule: fetchParseValues(config2.atrule),
    pseudo: fetchParseValues(config2.pseudo),
    node: fetchParseValues(config2.node)
  };
  for (const name2 in config2.parseContext) {
    switch (typeof config2.parseContext[name2]) {
      case "function":
        parseConfig.context[name2] = config2.parseContext[name2];
        break;
      case "string":
        parseConfig.context[name2] = createParseContext(config2.parseContext[name2]);
        break;
    }
  }
  return __spreadValues(__spreadValues({
    config: parseConfig
  }, parseConfig), parseConfig.node);
}
function createParser(config2) {
  let source = "";
  let filename = "<unknown>";
  let needPositions = false;
  let onParseError = NOOP;
  let onParseErrorThrow = false;
  const locationMap = new OffsetToLocation();
  const parser2 = Object.assign(new TokenStream(), processConfig(config2 || {}), {
    parseAtrulePrelude: true,
    parseRulePrelude: true,
    parseValue: true,
    parseCustomProperty: false,
    readSequence: readSequence$1,
    consumeUntilBalanceEnd: () => 0,
    consumeUntilLeftCurlyBracket(code) {
      return code === LEFTCURLYBRACKET$1 ? 1 : 0;
    },
    consumeUntilLeftCurlyBracketOrSemicolon(code) {
      return code === LEFTCURLYBRACKET$1 || code === SEMICOLON ? 1 : 0;
    },
    consumeUntilExclamationMarkOrSemicolon(code) {
      return code === EXCLAMATIONMARK$3 || code === SEMICOLON ? 1 : 0;
    },
    consumeUntilSemicolonIncluded(code) {
      return code === SEMICOLON ? 2 : 0;
    },
    createList() {
      return new List();
    },
    createSingleNodeList(node2) {
      return new List().appendData(node2);
    },
    getFirstListNode(list) {
      return list && list.first;
    },
    getLastListNode(list) {
      return list && list.last;
    },
    parseWithFallback(consumer, fallback) {
      const startToken = this.tokenIndex;
      try {
        return consumer.call(this);
      } catch (e25) {
        if (onParseErrorThrow) {
          throw e25;
        }
        const fallbackNode = fallback.call(this, startToken);
        onParseErrorThrow = true;
        onParseError(e25, fallbackNode);
        onParseErrorThrow = false;
        return fallbackNode;
      }
    },
    lookupNonWSType(offset) {
      let type4;
      do {
        type4 = this.lookupType(offset++);
        if (type4 !== WhiteSpace$1) {
          return type4;
        }
      } while (type4 !== NULL);
      return NULL;
    },
    charCodeAt(offset) {
      return offset >= 0 && offset < source.length ? source.charCodeAt(offset) : 0;
    },
    substring(offsetStart, offsetEnd) {
      return source.substring(offsetStart, offsetEnd);
    },
    substrToCursor(start) {
      return this.source.substring(start, this.tokenStart);
    },
    cmpChar(offset, charCode) {
      return cmpChar(source, offset, charCode);
    },
    cmpStr(offsetStart, offsetEnd, str) {
      return cmpStr(source, offsetStart, offsetEnd, str);
    },
    consume(tokenType2) {
      const start = this.tokenStart;
      this.eat(tokenType2);
      return this.substrToCursor(start);
    },
    consumeFunctionName() {
      const name2 = source.substring(this.tokenStart, this.tokenEnd - 1);
      this.eat(Function$2);
      return name2;
    },
    consumeNumber(type4) {
      const number4 = source.substring(this.tokenStart, consumeNumber$1(source, this.tokenStart));
      this.eat(type4);
      return number4;
    },
    eat(tokenType2) {
      if (this.tokenType !== tokenType2) {
        const tokenName = tokenNames[tokenType2].slice(0, -6).replace(/-/g, " ").replace(/^./, (m2) => m2.toUpperCase());
        let message = `${/[[\](){}]/.test(tokenName) ? `"${tokenName}"` : tokenName} is expected`;
        let offset = this.tokenStart;
        switch (tokenType2) {
          case Ident:
            if (this.tokenType === Function$2 || this.tokenType === Url$1) {
              offset = this.tokenEnd - 1;
              message = "Identifier is expected but function found";
            } else {
              message = "Identifier is expected";
            }
            break;
          case Hash$1:
            if (this.isDelim(NUMBERSIGN$4)) {
              this.next();
              offset++;
              message = "Name is expected";
            }
            break;
          case Percentage$1:
            if (this.tokenType === Number$2) {
              offset = this.tokenEnd;
              message = "Percent sign is expected";
            }
            break;
        }
        this.error(message, offset);
      }
      this.next();
    },
    eatIdent(name2) {
      if (this.tokenType !== Ident || this.lookupValue(0, name2) === false) {
        this.error(`Identifier "${name2}" is expected`);
      }
      this.next();
    },
    eatDelim(code) {
      if (!this.isDelim(code)) {
        this.error(`Delim "${String.fromCharCode(code)}" is expected`);
      }
      this.next();
    },
    getLocation(start, end) {
      if (needPositions) {
        return locationMap.getLocationRange(start, end, filename);
      }
      return null;
    },
    getLocationFromList(list) {
      if (needPositions) {
        const head = this.getFirstListNode(list);
        const tail = this.getLastListNode(list);
        return locationMap.getLocationRange(head !== null ? head.loc.start.offset - locationMap.startOffset : this.tokenStart, tail !== null ? tail.loc.end.offset - locationMap.startOffset : this.tokenStart, filename);
      }
      return null;
    },
    error(message, offset) {
      const location = typeof offset !== "undefined" && offset < source.length ? locationMap.getLocation(offset) : this.eof ? locationMap.getLocation(findWhiteSpaceStart(source, source.length - 1)) : locationMap.getLocation(this.tokenStart);
      throw new SyntaxError$2(message || "Unexpected input", source, location.offset, location.line, location.column);
    }
  });
  const parse2 = function(source_, options) {
    source = source_;
    options = options || {};
    parser2.setSource(source, tokenize$1);
    locationMap.setSource(source, options.offset, options.line, options.column);
    filename = options.filename || "<unknown>";
    needPositions = Boolean(options.positions);
    onParseError = typeof options.onParseError === "function" ? options.onParseError : NOOP;
    onParseErrorThrow = false;
    parser2.parseAtrulePrelude = "parseAtrulePrelude" in options ? Boolean(options.parseAtrulePrelude) : true;
    parser2.parseRulePrelude = "parseRulePrelude" in options ? Boolean(options.parseRulePrelude) : true;
    parser2.parseValue = "parseValue" in options ? Boolean(options.parseValue) : true;
    parser2.parseCustomProperty = "parseCustomProperty" in options ? Boolean(options.parseCustomProperty) : false;
    const { context = "default", onComment } = options;
    if (context in parser2.context === false) {
      throw new Error("Unknown context `" + context + "`");
    }
    if (typeof onComment === "function") {
      parser2.forEachToken((type4, start, end) => {
        if (type4 === Comment$1) {
          const loc = parser2.getLocation(start, end);
          const value2 = cmpStr(source, end - 2, end, "*/") ? source.slice(start + 2, end - 2) : source.slice(start + 2, end);
          onComment(value2, loc);
        }
      });
    }
    const ast = parser2.context[context].call(parser2, options);
    if (!parser2.eof) {
      parser2.error();
    }
    return ast;
  };
  return Object.assign(parse2, {
    SyntaxError: SyntaxError$2,
    config: parser2.config
  });
}
var base64Vlq = {};
var base64$1 = {};
var intToCharMap = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
base64$1.encode = function(number4) {
  if (0 <= number4 && number4 < intToCharMap.length) {
    return intToCharMap[number4];
  }
  throw new TypeError("Must be between 0 and 63: " + number4);
};
base64$1.decode = function(charCode) {
  var bigA = 65;
  var bigZ = 90;
  var littleA = 97;
  var littleZ = 122;
  var zero2 = 48;
  var nine = 57;
  var plus2 = 43;
  var slash2 = 47;
  var littleOffset = 26;
  var numberOffset = 52;
  if (bigA <= charCode && charCode <= bigZ) {
    return charCode - bigA;
  }
  if (littleA <= charCode && charCode <= littleZ) {
    return charCode - littleA + littleOffset;
  }
  if (zero2 <= charCode && charCode <= nine) {
    return charCode - zero2 + numberOffset;
  }
  if (charCode == plus2) {
    return 62;
  }
  if (charCode == slash2) {
    return 63;
  }
  return -1;
};
var base64 = base64$1;
var VLQ_BASE_SHIFT = 5;
var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
var VLQ_BASE_MASK = VLQ_BASE - 1;
var VLQ_CONTINUATION_BIT = VLQ_BASE;
function toVLQSigned(aValue) {
  return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
function fromVLQSigned(aValue) {
  var isNegative = (aValue & 1) === 1;
  var shifted = aValue >> 1;
  return isNegative ? -shifted : shifted;
}
base64Vlq.encode = function base64VLQ_encode(aValue) {
  var encoded = "";
  var digit;
  var vlq = toVLQSigned(aValue);
  do {
    digit = vlq & VLQ_BASE_MASK;
    vlq >>>= VLQ_BASE_SHIFT;
    if (vlq > 0) {
      digit |= VLQ_CONTINUATION_BIT;
    }
    encoded += base64.encode(digit);
  } while (vlq > 0);
  return encoded;
};
base64Vlq.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
  var strLen = aStr.length;
  var result2 = 0;
  var shift2 = 0;
  var continuation, digit;
  do {
    if (aIndex >= strLen) {
      throw new Error("Expected more digits in base 64 VLQ value.");
    }
    digit = base64.decode(aStr.charCodeAt(aIndex++));
    if (digit === -1) {
      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
    }
    continuation = !!(digit & VLQ_CONTINUATION_BIT);
    digit &= VLQ_BASE_MASK;
    result2 = result2 + (digit << shift2);
    shift2 += VLQ_BASE_SHIFT;
  } while (continuation);
  aOutParam.value = fromVLQSigned(result2);
  aOutParam.rest = aIndex;
};
var util$3 = {};
(function(exports2) {
  function getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) {
      return aArgs[aName];
    } else if (arguments.length === 3) {
      return aDefaultValue;
    } else {
      throw new Error('"' + aName + '" is a required argument.');
    }
  }
  exports2.getArg = getArg;
  var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
  var dataUrlRegexp = /^data:.+\,.+$/;
  function urlParse(aUrl) {
    var match2 = aUrl.match(urlRegexp);
    if (!match2) {
      return null;
    }
    return {
      scheme: match2[1],
      auth: match2[2],
      host: match2[3],
      port: match2[4],
      path: match2[5]
    };
  }
  exports2.urlParse = urlParse;
  function urlGenerate(aParsedUrl) {
    var url2 = "";
    if (aParsedUrl.scheme) {
      url2 += aParsedUrl.scheme + ":";
    }
    url2 += "//";
    if (aParsedUrl.auth) {
      url2 += aParsedUrl.auth + "@";
    }
    if (aParsedUrl.host) {
      url2 += aParsedUrl.host;
    }
    if (aParsedUrl.port) {
      url2 += ":" + aParsedUrl.port;
    }
    if (aParsedUrl.path) {
      url2 += aParsedUrl.path;
    }
    return url2;
  }
  exports2.urlGenerate = urlGenerate;
  var MAX_CACHED_INPUTS = 32;
  function lruMemoize(f2) {
    var cache2 = [];
    return function(input) {
      for (var i2 = 0; i2 < cache2.length; i2++) {
        if (cache2[i2].input === input) {
          var temp = cache2[0];
          cache2[0] = cache2[i2];
          cache2[i2] = temp;
          return cache2[0].result;
        }
      }
      var result2 = f2(input);
      cache2.unshift({
        input,
        result: result2
      });
      if (cache2.length > MAX_CACHED_INPUTS) {
        cache2.pop();
      }
      return result2;
    };
  }
  var normalize = lruMemoize(function normalize2(aPath) {
    var path = aPath;
    var url2 = urlParse(aPath);
    if (url2) {
      if (!url2.path) {
        return aPath;
      }
      path = url2.path;
    }
    var isAbsolute = exports2.isAbsolute(path);
    var parts = [];
    var start = 0;
    var i2 = 0;
    while (true) {
      start = i2;
      i2 = path.indexOf("/", start);
      if (i2 === -1) {
        parts.push(path.slice(start));
        break;
      } else {
        parts.push(path.slice(start, i2));
        while (i2 < path.length && path[i2] === "/") {
          i2++;
        }
      }
    }
    for (var part, up2 = 0, i2 = parts.length - 1; i2 >= 0; i2--) {
      part = parts[i2];
      if (part === ".") {
        parts.splice(i2, 1);
      } else if (part === "..") {
        up2++;
      } else if (up2 > 0) {
        if (part === "") {
          parts.splice(i2 + 1, up2);
          up2 = 0;
        } else {
          parts.splice(i2, 2);
          up2--;
        }
      }
    }
    path = parts.join("/");
    if (path === "") {
      path = isAbsolute ? "/" : ".";
    }
    if (url2) {
      url2.path = path;
      return urlGenerate(url2);
    }
    return path;
  });
  exports2.normalize = normalize;
  function join(aRoot, aPath) {
    if (aRoot === "") {
      aRoot = ".";
    }
    if (aPath === "") {
      aPath = ".";
    }
    var aPathUrl = urlParse(aPath);
    var aRootUrl = urlParse(aRoot);
    if (aRootUrl) {
      aRoot = aRootUrl.path || "/";
    }
    if (aPathUrl && !aPathUrl.scheme) {
      if (aRootUrl) {
        aPathUrl.scheme = aRootUrl.scheme;
      }
      return urlGenerate(aPathUrl);
    }
    if (aPathUrl || aPath.match(dataUrlRegexp)) {
      return aPath;
    }
    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
      aRootUrl.host = aPath;
      return urlGenerate(aRootUrl);
    }
    var joined = aPath.charAt(0) === "/" ? aPath : normalize(aRoot.replace(/\/+$/, "") + "/" + aPath);
    if (aRootUrl) {
      aRootUrl.path = joined;
      return urlGenerate(aRootUrl);
    }
    return joined;
  }
  exports2.join = join;
  exports2.isAbsolute = function(aPath) {
    return aPath.charAt(0) === "/" || urlRegexp.test(aPath);
  };
  function relative(aRoot, aPath) {
    if (aRoot === "") {
      aRoot = ".";
    }
    aRoot = aRoot.replace(/\/$/, "");
    var level = 0;
    while (aPath.indexOf(aRoot + "/") !== 0) {
      var index2 = aRoot.lastIndexOf("/");
      if (index2 < 0) {
        return aPath;
      }
      aRoot = aRoot.slice(0, index2);
      if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
        return aPath;
      }
      ++level;
    }
    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
  }
  exports2.relative = relative;
  var supportsNullProto = function() {
    var obj = Object.create(null);
    return !("__proto__" in obj);
  }();
  function identity2(s2) {
    return s2;
  }
  function toSetString(aStr) {
    if (isProtoString(aStr)) {
      return "$" + aStr;
    }
    return aStr;
  }
  exports2.toSetString = supportsNullProto ? identity2 : toSetString;
  function fromSetString(aStr) {
    if (isProtoString(aStr)) {
      return aStr.slice(1);
    }
    return aStr;
  }
  exports2.fromSetString = supportsNullProto ? identity2 : fromSetString;
  function isProtoString(s2) {
    if (!s2) {
      return false;
    }
    var length2 = s2.length;
    if (length2 < 9) {
      return false;
    }
    if (s2.charCodeAt(length2 - 1) !== 95 || s2.charCodeAt(length2 - 2) !== 95 || s2.charCodeAt(length2 - 3) !== 111 || s2.charCodeAt(length2 - 4) !== 116 || s2.charCodeAt(length2 - 5) !== 111 || s2.charCodeAt(length2 - 6) !== 114 || s2.charCodeAt(length2 - 7) !== 112 || s2.charCodeAt(length2 - 8) !== 95 || s2.charCodeAt(length2 - 9) !== 95) {
      return false;
    }
    for (var i2 = length2 - 10; i2 >= 0; i2--) {
      if (s2.charCodeAt(i2) !== 36) {
        return false;
      }
    }
    return true;
  }
  function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) {
      return cmp;
    }
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) {
      return cmp;
    }
    return strcmp(mappingA.name, mappingB.name);
  }
  exports2.compareByOriginalPositions = compareByOriginalPositions;
  function compareByOriginalPositionsNoSource(mappingA, mappingB, onlyCompareOriginal) {
    var cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) {
      return cmp;
    }
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) {
      return cmp;
    }
    return strcmp(mappingA.name, mappingB.name);
  }
  exports2.compareByOriginalPositionsNoSource = compareByOriginalPositionsNoSource;
  function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) {
      return cmp;
    }
    cmp = strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) {
      return cmp;
    }
    return strcmp(mappingA.name, mappingB.name);
  }
  exports2.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
  function compareByGeneratedPositionsDeflatedNoLine(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) {
      return cmp;
    }
    cmp = strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) {
      return cmp;
    }
    return strcmp(mappingA.name, mappingB.name);
  }
  exports2.compareByGeneratedPositionsDeflatedNoLine = compareByGeneratedPositionsDeflatedNoLine;
  function strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) {
      return 0;
    }
    if (aStr1 === null) {
      return 1;
    }
    if (aStr2 === null) {
      return -1;
    }
    if (aStr1 > aStr2) {
      return 1;
    }
    return -1;
  }
  function compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) {
      return cmp;
    }
    cmp = strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) {
      return cmp;
    }
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) {
      return cmp;
    }
    return strcmp(mappingA.name, mappingB.name);
  }
  exports2.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;
  function parseSourceMapInput(str) {
    return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ""));
  }
  exports2.parseSourceMapInput = parseSourceMapInput;
  function computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
    sourceURL = sourceURL || "";
    if (sourceRoot) {
      if (sourceRoot[sourceRoot.length - 1] !== "/" && sourceURL[0] !== "/") {
        sourceRoot += "/";
      }
      sourceURL = sourceRoot + sourceURL;
    }
    if (sourceMapURL) {
      var parsed = urlParse(sourceMapURL);
      if (!parsed) {
        throw new Error("sourceMapURL could not be parsed");
      }
      if (parsed.path) {
        var index2 = parsed.path.lastIndexOf("/");
        if (index2 >= 0) {
          parsed.path = parsed.path.substring(0, index2 + 1);
        }
      }
      sourceURL = join(urlGenerate(parsed), sourceURL);
    }
    return normalize(sourceURL);
  }
  exports2.computeSourceURL = computeSourceURL;
})(util$3);
var arraySet = {};
var util$2 = util$3;
var has = Object.prototype.hasOwnProperty;
var hasNativeMap = typeof Map !== "undefined";
function ArraySet$1() {
  this._array = [];
  this._set = hasNativeMap ? new Map() : Object.create(null);
}
ArraySet$1.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
  var set2 = new ArraySet$1();
  for (var i2 = 0, len2 = aArray.length; i2 < len2; i2++) {
    set2.add(aArray[i2], aAllowDuplicates);
  }
  return set2;
};
ArraySet$1.prototype.size = function ArraySet_size() {
  return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};
ArraySet$1.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
  var sStr = hasNativeMap ? aStr : util$2.toSetString(aStr);
  var isDuplicate = hasNativeMap ? this.has(aStr) : has.call(this._set, sStr);
  var idx = this._array.length;
  if (!isDuplicate || aAllowDuplicates) {
    this._array.push(aStr);
  }
  if (!isDuplicate) {
    if (hasNativeMap) {
      this._set.set(aStr, idx);
    } else {
      this._set[sStr] = idx;
    }
  }
};
ArraySet$1.prototype.has = function ArraySet_has(aStr) {
  if (hasNativeMap) {
    return this._set.has(aStr);
  } else {
    var sStr = util$2.toSetString(aStr);
    return has.call(this._set, sStr);
  }
};
ArraySet$1.prototype.indexOf = function ArraySet_indexOf(aStr) {
  if (hasNativeMap) {
    var idx = this._set.get(aStr);
    if (idx >= 0) {
      return idx;
    }
  } else {
    var sStr = util$2.toSetString(aStr);
    if (has.call(this._set, sStr)) {
      return this._set[sStr];
    }
  }
  throw new Error('"' + aStr + '" is not in the set.');
};
ArraySet$1.prototype.at = function ArraySet_at(aIdx) {
  if (aIdx >= 0 && aIdx < this._array.length) {
    return this._array[aIdx];
  }
  throw new Error("No element indexed by " + aIdx);
};
ArraySet$1.prototype.toArray = function ArraySet_toArray() {
  return this._array.slice();
};
arraySet.ArraySet = ArraySet$1;
var mappingList = {};
var util$1 = util$3;
function generatedPositionAfter(mappingA, mappingB) {
  var lineA = mappingA.generatedLine;
  var lineB = mappingB.generatedLine;
  var columnA = mappingA.generatedColumn;
  var columnB = mappingB.generatedColumn;
  return lineB > lineA || lineB == lineA && columnB >= columnA || util$1.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}
function MappingList$1() {
  this._array = [];
  this._sorted = true;
  this._last = { generatedLine: -1, generatedColumn: 0 };
}
MappingList$1.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
  this._array.forEach(aCallback, aThisArg);
};
MappingList$1.prototype.add = function MappingList_add(aMapping) {
  if (generatedPositionAfter(this._last, aMapping)) {
    this._last = aMapping;
    this._array.push(aMapping);
  } else {
    this._sorted = false;
    this._array.push(aMapping);
  }
};
MappingList$1.prototype.toArray = function MappingList_toArray() {
  if (!this._sorted) {
    this._array.sort(util$1.compareByGeneratedPositionsInflated);
    this._sorted = true;
  }
  return this._array;
};
mappingList.MappingList = MappingList$1;
var base64VLQ = base64Vlq;
var util = util$3;
var ArraySet = arraySet.ArraySet;
var MappingList = mappingList.MappingList;
function SourceMapGenerator(aArgs) {
  if (!aArgs) {
    aArgs = {};
  }
  this._file = util.getArg(aArgs, "file", null);
  this._sourceRoot = util.getArg(aArgs, "sourceRoot", null);
  this._skipValidation = util.getArg(aArgs, "skipValidation", false);
  this._sources = new ArraySet();
  this._names = new ArraySet();
  this._mappings = new MappingList();
  this._sourcesContents = null;
}
SourceMapGenerator.prototype._version = 3;
SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
  var sourceRoot = aSourceMapConsumer.sourceRoot;
  var generator = new SourceMapGenerator({
    file: aSourceMapConsumer.file,
    sourceRoot
  });
  aSourceMapConsumer.eachMapping(function(mapping) {
    var newMapping = {
      generated: {
        line: mapping.generatedLine,
        column: mapping.generatedColumn
      }
    };
    if (mapping.source != null) {
      newMapping.source = mapping.source;
      if (sourceRoot != null) {
        newMapping.source = util.relative(sourceRoot, newMapping.source);
      }
      newMapping.original = {
        line: mapping.originalLine,
        column: mapping.originalColumn
      };
      if (mapping.name != null) {
        newMapping.name = mapping.name;
      }
    }
    generator.addMapping(newMapping);
  });
  aSourceMapConsumer.sources.forEach(function(sourceFile) {
    var sourceRelative = sourceFile;
    if (sourceRoot !== null) {
      sourceRelative = util.relative(sourceRoot, sourceFile);
    }
    if (!generator._sources.has(sourceRelative)) {
      generator._sources.add(sourceRelative);
    }
    var content2 = aSourceMapConsumer.sourceContentFor(sourceFile);
    if (content2 != null) {
      generator.setSourceContent(sourceFile, content2);
    }
  });
  return generator;
};
SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
  var generated = util.getArg(aArgs, "generated");
  var original = util.getArg(aArgs, "original", null);
  var source = util.getArg(aArgs, "source", null);
  var name2 = util.getArg(aArgs, "name", null);
  if (!this._skipValidation) {
    this._validateMapping(generated, original, source, name2);
  }
  if (source != null) {
    source = String(source);
    if (!this._sources.has(source)) {
      this._sources.add(source);
    }
  }
  if (name2 != null) {
    name2 = String(name2);
    if (!this._names.has(name2)) {
      this._names.add(name2);
    }
  }
  this._mappings.add({
    generatedLine: generated.line,
    generatedColumn: generated.column,
    originalLine: original != null && original.line,
    originalColumn: original != null && original.column,
    source,
    name: name2
  });
};
SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
  var source = aSourceFile;
  if (this._sourceRoot != null) {
    source = util.relative(this._sourceRoot, source);
  }
  if (aSourceContent != null) {
    if (!this._sourcesContents) {
      this._sourcesContents = Object.create(null);
    }
    this._sourcesContents[util.toSetString(source)] = aSourceContent;
  } else if (this._sourcesContents) {
    delete this._sourcesContents[util.toSetString(source)];
    if (Object.keys(this._sourcesContents).length === 0) {
      this._sourcesContents = null;
    }
  }
};
SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
  var sourceFile = aSourceFile;
  if (aSourceFile == null) {
    if (aSourceMapConsumer.file == null) {
      throw new Error(`SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map's "file" property. Both were omitted.`);
    }
    sourceFile = aSourceMapConsumer.file;
  }
  var sourceRoot = this._sourceRoot;
  if (sourceRoot != null) {
    sourceFile = util.relative(sourceRoot, sourceFile);
  }
  var newSources = new ArraySet();
  var newNames = new ArraySet();
  this._mappings.unsortedForEach(function(mapping) {
    if (mapping.source === sourceFile && mapping.originalLine != null) {
      var original = aSourceMapConsumer.originalPositionFor({
        line: mapping.originalLine,
        column: mapping.originalColumn
      });
      if (original.source != null) {
        mapping.source = original.source;
        if (aSourceMapPath != null) {
          mapping.source = util.join(aSourceMapPath, mapping.source);
        }
        if (sourceRoot != null) {
          mapping.source = util.relative(sourceRoot, mapping.source);
        }
        mapping.originalLine = original.line;
        mapping.originalColumn = original.column;
        if (original.name != null) {
          mapping.name = original.name;
        }
      }
    }
    var source = mapping.source;
    if (source != null && !newSources.has(source)) {
      newSources.add(source);
    }
    var name2 = mapping.name;
    if (name2 != null && !newNames.has(name2)) {
      newNames.add(name2);
    }
  }, this);
  this._sources = newSources;
  this._names = newNames;
  aSourceMapConsumer.sources.forEach(function(sourceFile2) {
    var content2 = aSourceMapConsumer.sourceContentFor(sourceFile2);
    if (content2 != null) {
      if (aSourceMapPath != null) {
        sourceFile2 = util.join(aSourceMapPath, sourceFile2);
      }
      if (sourceRoot != null) {
        sourceFile2 = util.relative(sourceRoot, sourceFile2);
      }
      this.setSourceContent(sourceFile2, content2);
    }
  }, this);
};
SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
  if (aOriginal && typeof aOriginal.line !== "number" && typeof aOriginal.column !== "number") {
    throw new Error("original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.");
  }
  if (aGenerated && "line" in aGenerated && "column" in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) {
    return;
  } else if (aGenerated && "line" in aGenerated && "column" in aGenerated && aOriginal && "line" in aOriginal && "column" in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) {
    return;
  } else {
    throw new Error("Invalid mapping: " + JSON.stringify({
      generated: aGenerated,
      source: aSource,
      original: aOriginal,
      name: aName
    }));
  }
};
SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
  var previousGeneratedColumn = 0;
  var previousGeneratedLine = 1;
  var previousOriginalColumn = 0;
  var previousOriginalLine = 0;
  var previousName = 0;
  var previousSource = 0;
  var result2 = "";
  var next;
  var mapping;
  var nameIdx;
  var sourceIdx;
  var mappings = this._mappings.toArray();
  for (var i2 = 0, len2 = mappings.length; i2 < len2; i2++) {
    mapping = mappings[i2];
    next = "";
    if (mapping.generatedLine !== previousGeneratedLine) {
      previousGeneratedColumn = 0;
      while (mapping.generatedLine !== previousGeneratedLine) {
        next += ";";
        previousGeneratedLine++;
      }
    } else {
      if (i2 > 0) {
        if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i2 - 1])) {
          continue;
        }
        next += ",";
      }
    }
    next += base64VLQ.encode(mapping.generatedColumn - previousGeneratedColumn);
    previousGeneratedColumn = mapping.generatedColumn;
    if (mapping.source != null) {
      sourceIdx = this._sources.indexOf(mapping.source);
      next += base64VLQ.encode(sourceIdx - previousSource);
      previousSource = sourceIdx;
      next += base64VLQ.encode(mapping.originalLine - 1 - previousOriginalLine);
      previousOriginalLine = mapping.originalLine - 1;
      next += base64VLQ.encode(mapping.originalColumn - previousOriginalColumn);
      previousOriginalColumn = mapping.originalColumn;
      if (mapping.name != null) {
        nameIdx = this._names.indexOf(mapping.name);
        next += base64VLQ.encode(nameIdx - previousName);
        previousName = nameIdx;
      }
    }
    result2 += next;
  }
  return result2;
};
SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
  return aSources.map(function(source) {
    if (!this._sourcesContents) {
      return null;
    }
    if (aSourceRoot != null) {
      source = util.relative(aSourceRoot, source);
    }
    var key = util.toSetString(source);
    return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
  }, this);
};
SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
  var map2 = {
    version: this._version,
    sources: this._sources.toArray(),
    names: this._names.toArray(),
    mappings: this._serializeMappings()
  };
  if (this._file != null) {
    map2.file = this._file;
  }
  if (this._sourceRoot != null) {
    map2.sourceRoot = this._sourceRoot;
  }
  if (this._sourcesContents) {
    map2.sourcesContent = this._generateSourcesContent(map2.sources, map2.sourceRoot);
  }
  return map2;
};
SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
  return JSON.stringify(this.toJSON());
};
var SourceMapGenerator_1 = SourceMapGenerator;
const trackNodes = new Set(["Atrule", "Selector", "Declaration"]);
function generateSourceMap(handlers2) {
  const map2 = new SourceMapGenerator_1();
  const generated = {
    line: 1,
    column: 0
  };
  const original = {
    line: 0,
    column: 0
  };
  const activatedGenerated = {
    line: 1,
    column: 0
  };
  const activatedMapping = {
    generated: activatedGenerated
  };
  let line = 1;
  let column = 0;
  let sourceMappingActive = false;
  const origHandlersNode = handlers2.node;
  handlers2.node = function(node2) {
    if (node2.loc && node2.loc.start && trackNodes.has(node2.type)) {
      const nodeLine = node2.loc.start.line;
      const nodeColumn = node2.loc.start.column - 1;
      if (original.line !== nodeLine || original.column !== nodeColumn) {
        original.line = nodeLine;
        original.column = nodeColumn;
        generated.line = line;
        generated.column = column;
        if (sourceMappingActive) {
          sourceMappingActive = false;
          if (generated.line !== activatedGenerated.line || generated.column !== activatedGenerated.column) {
            map2.addMapping(activatedMapping);
          }
        }
        sourceMappingActive = true;
        map2.addMapping({
          source: node2.loc.source,
          original,
          generated
        });
      }
    }
    origHandlersNode.call(this, node2);
    if (sourceMappingActive && trackNodes.has(node2.type)) {
      activatedGenerated.line = line;
      activatedGenerated.column = column;
    }
  };
  const origHandlersEmit = handlers2.emit;
  handlers2.emit = function(value2, type4, auto) {
    for (let i2 = 0; i2 < value2.length; i2++) {
      if (value2.charCodeAt(i2) === 10) {
        line++;
        column = 0;
      } else {
        column++;
      }
    }
    origHandlersEmit(value2, type4, auto);
  };
  const origHandlersResult = handlers2.result;
  handlers2.result = function() {
    if (sourceMappingActive) {
      map2.addMapping(activatedMapping);
    }
    return {
      css: origHandlersResult(),
      map: map2
    };
  };
  return handlers2;
}
const PLUSSIGN$9 = 43;
const HYPHENMINUS$6 = 45;
const code$1 = (type4, value2) => {
  if (type4 === Delim) {
    type4 = value2;
  }
  if (typeof type4 === "string") {
    const charCode = type4.charCodeAt(0);
    return charCode > 127 ? 32768 : charCode << 8;
  }
  return type4;
};
const specPairs = [
  [Ident, Ident],
  [Ident, Function$2],
  [Ident, Url$1],
  [Ident, BadUrl],
  [Ident, "-"],
  [Ident, Number$2],
  [Ident, Percentage$1],
  [Ident, Dimension$1],
  [Ident, CDC$1],
  [Ident, LeftParenthesis],
  [AtKeyword, Ident],
  [AtKeyword, Function$2],
  [AtKeyword, Url$1],
  [AtKeyword, BadUrl],
  [AtKeyword, "-"],
  [AtKeyword, Number$2],
  [AtKeyword, Percentage$1],
  [AtKeyword, Dimension$1],
  [AtKeyword, CDC$1],
  [Hash$1, Ident],
  [Hash$1, Function$2],
  [Hash$1, Url$1],
  [Hash$1, BadUrl],
  [Hash$1, "-"],
  [Hash$1, Number$2],
  [Hash$1, Percentage$1],
  [Hash$1, Dimension$1],
  [Hash$1, CDC$1],
  [Dimension$1, Ident],
  [Dimension$1, Function$2],
  [Dimension$1, Url$1],
  [Dimension$1, BadUrl],
  [Dimension$1, "-"],
  [Dimension$1, Number$2],
  [Dimension$1, Percentage$1],
  [Dimension$1, Dimension$1],
  [Dimension$1, CDC$1],
  ["#", Ident],
  ["#", Function$2],
  ["#", Url$1],
  ["#", BadUrl],
  ["#", "-"],
  ["#", Number$2],
  ["#", Percentage$1],
  ["#", Dimension$1],
  ["#", CDC$1],
  ["-", Ident],
  ["-", Function$2],
  ["-", Url$1],
  ["-", BadUrl],
  ["-", "-"],
  ["-", Number$2],
  ["-", Percentage$1],
  ["-", Dimension$1],
  ["-", CDC$1],
  [Number$2, Ident],
  [Number$2, Function$2],
  [Number$2, Url$1],
  [Number$2, BadUrl],
  [Number$2, Number$2],
  [Number$2, Percentage$1],
  [Number$2, Dimension$1],
  [Number$2, "%"],
  [Number$2, CDC$1],
  ["@", Ident],
  ["@", Function$2],
  ["@", Url$1],
  ["@", BadUrl],
  ["@", "-"],
  ["@", CDC$1],
  [".", Number$2],
  [".", Percentage$1],
  [".", Dimension$1],
  ["+", Number$2],
  ["+", Percentage$1],
  ["+", Dimension$1],
  ["/", "*"]
];
const safePairs = specPairs.concat([
  [Ident, Hash$1],
  [Dimension$1, Hash$1],
  [Hash$1, Hash$1],
  [AtKeyword, LeftParenthesis],
  [AtKeyword, String$2],
  [AtKeyword, Colon],
  [Percentage$1, Percentage$1],
  [Percentage$1, Dimension$1],
  [Percentage$1, Function$2],
  [Percentage$1, "-"],
  [RightParenthesis, Ident],
  [RightParenthesis, Function$2],
  [RightParenthesis, Percentage$1],
  [RightParenthesis, Dimension$1],
  [RightParenthesis, Hash$1],
  [RightParenthesis, "-"]
]);
function createMap(pairs) {
  const isWhiteSpaceRequired = new Set(pairs.map(([prev, next]) => code$1(prev) << 16 | code$1(next)));
  return function(prevCode, type4, value2) {
    const nextCode = code$1(type4, value2);
    const nextCharCode = value2.charCodeAt(0);
    const emitWs = nextCharCode === HYPHENMINUS$6 && type4 !== Ident && type4 !== Function$2 && type4 !== CDC$1 || nextCharCode === PLUSSIGN$9 ? isWhiteSpaceRequired.has(prevCode << 16 | nextCharCode << 8) : isWhiteSpaceRequired.has(prevCode << 16 | nextCode);
    if (emitWs) {
      this.emit(" ", WhiteSpace$1, true);
    }
    return nextCode;
  };
}
const spec = createMap(specPairs);
const safe = createMap(safePairs);
var tokenBefore = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  spec,
  safe
}, Symbol.toStringTag, { value: "Module" }));
const REVERSESOLIDUS = 92;
function processChildren(node2, delimeter) {
  if (typeof delimeter === "function") {
    let prev = null;
    node2.children.forEach((node3) => {
      if (prev !== null) {
        delimeter.call(this, prev);
      }
      this.node(node3);
      prev = node3;
    });
    return;
  }
  node2.children.forEach(this.node, this);
}
function processChunk(chunk) {
  tokenize$1(chunk, (type4, start, end) => {
    this.token(type4, chunk.slice(start, end));
  });
}
function createGenerator(config2) {
  const types2 = new Map();
  for (let name2 in config2.node) {
    const item = config2.node[name2];
    const fn2 = item.generate || item;
    if (typeof fn2 === "function") {
      types2.set(name2, item.generate || item);
    }
  }
  return function(node2, options) {
    let buffer = "";
    let prevCode = 0;
    let handlers2 = {
      node(node3) {
        if (types2.has(node3.type)) {
          types2.get(node3.type).call(publicApi, node3);
        } else {
          throw new Error("Unknown node type: " + node3.type);
        }
      },
      tokenBefore: safe,
      token(type4, value2) {
        prevCode = this.tokenBefore(prevCode, type4, value2);
        this.emit(value2, type4, false);
        if (type4 === Delim && value2.charCodeAt(0) === REVERSESOLIDUS) {
          this.emit("\n", WhiteSpace$1, true);
        }
      },
      emit(value2) {
        buffer += value2;
      },
      result() {
        return buffer;
      }
    };
    if (options) {
      if (typeof options.decorator === "function") {
        handlers2 = options.decorator(handlers2);
      }
      if (options.sourceMap) {
        handlers2 = generateSourceMap(handlers2);
      }
      if (options.mode in tokenBefore) {
        handlers2.tokenBefore = tokenBefore[options.mode];
      }
    }
    const publicApi = {
      node: (node3) => handlers2.node(node3),
      children: processChildren,
      token: (type4, value2) => handlers2.token(type4, value2),
      tokenize: processChunk
    };
    handlers2.node(node2);
    return handlers2.result();
  };
}
function createConvertor(walk2) {
  return {
    fromPlainObject(ast) {
      walk2(ast, {
        enter(node2) {
          if (node2.children && node2.children instanceof List === false) {
            node2.children = new List().fromArray(node2.children);
          }
        }
      });
      return ast;
    },
    toPlainObject(ast) {
      walk2(ast, {
        leave(node2) {
          if (node2.children && node2.children instanceof List) {
            node2.children = node2.children.toArray();
          }
        }
      });
      return ast;
    }
  };
}
const { hasOwnProperty: hasOwnProperty$3 } = Object.prototype;
const noop$2 = function() {
};
function ensureFunction$1(value2) {
  return typeof value2 === "function" ? value2 : noop$2;
}
function invokeForType(fn2, type4) {
  return function(node2, item, list) {
    if (node2.type === type4) {
      fn2.call(this, node2, item, list);
    }
  };
}
function getWalkersFromStructure(name2, nodeType) {
  const structure2 = nodeType.structure;
  const walkers = [];
  for (const key in structure2) {
    if (hasOwnProperty$3.call(structure2, key) === false) {
      continue;
    }
    let fieldTypes = structure2[key];
    const walker = {
      name: key,
      type: false,
      nullable: false
    };
    if (!Array.isArray(fieldTypes)) {
      fieldTypes = [fieldTypes];
    }
    for (const fieldType of fieldTypes) {
      if (fieldType === null) {
        walker.nullable = true;
      } else if (typeof fieldType === "string") {
        walker.type = "node";
      } else if (Array.isArray(fieldType)) {
        walker.type = "list";
      }
    }
    if (walker.type) {
      walkers.push(walker);
    }
  }
  if (walkers.length) {
    return {
      context: nodeType.walkContext,
      fields: walkers
    };
  }
  return null;
}
function getTypesFromConfig(config2) {
  const types2 = {};
  for (const name2 in config2.node) {
    if (hasOwnProperty$3.call(config2.node, name2)) {
      const nodeType = config2.node[name2];
      if (!nodeType.structure) {
        throw new Error("Missed `structure` field in `" + name2 + "` node type definition");
      }
      types2[name2] = getWalkersFromStructure(name2, nodeType);
    }
  }
  return types2;
}
function createTypeIterator(config2, reverse) {
  const fields = config2.fields.slice();
  const contextName = config2.context;
  const useContext = typeof contextName === "string";
  if (reverse) {
    fields.reverse();
  }
  return function(node2, context, walk2, walkReducer) {
    let prevContextValue;
    if (useContext) {
      prevContextValue = context[contextName];
      context[contextName] = node2;
    }
    for (const field of fields) {
      const ref2 = node2[field.name];
      if (!field.nullable || ref2) {
        if (field.type === "list") {
          const breakWalk = reverse ? ref2.reduceRight(walkReducer, false) : ref2.reduce(walkReducer, false);
          if (breakWalk) {
            return true;
          }
        } else if (walk2(ref2)) {
          return true;
        }
      }
    }
    if (useContext) {
      context[contextName] = prevContextValue;
    }
  };
}
function createFastTraveralMap({
  StyleSheet: StyleSheet2,
  Atrule: Atrule2,
  Rule: Rule2,
  Block: Block2,
  DeclarationList: DeclarationList2
}) {
  return {
    Atrule: {
      StyleSheet: StyleSheet2,
      Atrule: Atrule2,
      Rule: Rule2,
      Block: Block2
    },
    Rule: {
      StyleSheet: StyleSheet2,
      Atrule: Atrule2,
      Rule: Rule2,
      Block: Block2
    },
    Declaration: {
      StyleSheet: StyleSheet2,
      Atrule: Atrule2,
      Rule: Rule2,
      Block: Block2,
      DeclarationList: DeclarationList2
    }
  };
}
function createWalker(config2) {
  const types2 = getTypesFromConfig(config2);
  const iteratorsNatural = {};
  const iteratorsReverse = {};
  const breakWalk = Symbol("break-walk");
  const skipNode = Symbol("skip-node");
  for (const name2 in types2) {
    if (hasOwnProperty$3.call(types2, name2) && types2[name2] !== null) {
      iteratorsNatural[name2] = createTypeIterator(types2[name2], false);
      iteratorsReverse[name2] = createTypeIterator(types2[name2], true);
    }
  }
  const fastTraversalIteratorsNatural = createFastTraveralMap(iteratorsNatural);
  const fastTraversalIteratorsReverse = createFastTraveralMap(iteratorsReverse);
  const walk2 = function(root2, options) {
    function walkNode(node2, item, list) {
      const enterRet = enter.call(context, node2, item, list);
      if (enterRet === breakWalk) {
        return true;
      }
      if (enterRet === skipNode) {
        return false;
      }
      if (iterators.hasOwnProperty(node2.type)) {
        if (iterators[node2.type](node2, context, walkNode, walkReducer)) {
          return true;
        }
      }
      if (leave.call(context, node2, item, list) === breakWalk) {
        return true;
      }
      return false;
    }
    let enter = noop$2;
    let leave = noop$2;
    let iterators = iteratorsNatural;
    let walkReducer = (ret, data, item, list) => ret || walkNode(data, item, list);
    const context = {
      break: breakWalk,
      skip: skipNode,
      root: root2,
      stylesheet: null,
      atrule: null,
      atrulePrelude: null,
      rule: null,
      selector: null,
      block: null,
      declaration: null,
      function: null
    };
    if (typeof options === "function") {
      enter = options;
    } else if (options) {
      enter = ensureFunction$1(options.enter);
      leave = ensureFunction$1(options.leave);
      if (options.reverse) {
        iterators = iteratorsReverse;
      }
      if (options.visit) {
        if (fastTraversalIteratorsNatural.hasOwnProperty(options.visit)) {
          iterators = options.reverse ? fastTraversalIteratorsReverse[options.visit] : fastTraversalIteratorsNatural[options.visit];
        } else if (!types2.hasOwnProperty(options.visit)) {
          throw new Error("Bad value `" + options.visit + "` for `visit` option (should be: " + Object.keys(types2).sort().join(", ") + ")");
        }
        enter = invokeForType(enter, options.visit);
        leave = invokeForType(leave, options.visit);
      }
    }
    if (enter === noop$2 && leave === noop$2) {
      throw new Error("Neither `enter` nor `leave` walker handler is set or both aren't a function");
    }
    walkNode(root2);
  };
  walk2.break = breakWalk;
  walk2.skip = skipNode;
  walk2.find = function(ast, fn2) {
    let found = null;
    walk2(ast, function(node2, item, list) {
      if (fn2.call(this, node2, item, list)) {
        found = node2;
        return breakWalk;
      }
    });
    return found;
  };
  walk2.findLast = function(ast, fn2) {
    let found = null;
    walk2(ast, {
      reverse: true,
      enter(node2, item, list) {
        if (fn2.call(this, node2, item, list)) {
          found = node2;
          return breakWalk;
        }
      }
    });
    return found;
  };
  walk2.findAll = function(ast, fn2) {
    const found = [];
    walk2(ast, function(node2, item, list) {
      if (fn2.call(this, node2, item, list)) {
        found.push(node2);
      }
    });
    return found;
  };
  return walk2;
}
function noop$1(value2) {
  return value2;
}
function generateMultiplier(multiplier) {
  const { min, max, comma } = multiplier;
  if (min === 0 && max === 0) {
    return comma ? "#?" : "*";
  }
  if (min === 0 && max === 1) {
    return "?";
  }
  if (min === 1 && max === 0) {
    return comma ? "#" : "+";
  }
  if (min === 1 && max === 1) {
    return "";
  }
  return (comma ? "#" : "") + (min === max ? "{" + min + "}" : "{" + min + "," + (max !== 0 ? max : "") + "}");
}
function generateTypeOpts(node2) {
  switch (node2.type) {
    case "Range":
      return " [" + (node2.min === null ? "-\u221E" : node2.min) + "," + (node2.max === null ? "\u221E" : node2.max) + "]";
    default:
      throw new Error("Unknown node type `" + node2.type + "`");
  }
}
function generateSequence(node2, decorate, forceBraces, compact) {
  const combinator = node2.combinator === " " || compact ? node2.combinator : " " + node2.combinator + " ";
  const result2 = node2.terms.map((term) => internalGenerate(term, decorate, forceBraces, compact)).join(combinator);
  if (node2.explicit || forceBraces) {
    return (compact || result2[0] === "," ? "[" : "[ ") + result2 + (compact ? "]" : " ]");
  }
  return result2;
}
function internalGenerate(node2, decorate, forceBraces, compact) {
  let result2;
  switch (node2.type) {
    case "Group":
      result2 = generateSequence(node2, decorate, forceBraces, compact) + (node2.disallowEmpty ? "!" : "");
      break;
    case "Multiplier":
      return internalGenerate(node2.term, decorate, forceBraces, compact) + decorate(generateMultiplier(node2), node2);
    case "Type":
      result2 = "<" + node2.name + (node2.opts ? decorate(generateTypeOpts(node2.opts), node2.opts) : "") + ">";
      break;
    case "Property":
      result2 = "<'" + node2.name + "'>";
      break;
    case "Keyword":
      result2 = node2.name;
      break;
    case "AtKeyword":
      result2 = "@" + node2.name;
      break;
    case "Function":
      result2 = node2.name + "(";
      break;
    case "String":
    case "Token":
      result2 = node2.value;
      break;
    case "Comma":
      result2 = ",";
      break;
    default:
      throw new Error("Unknown node type `" + node2.type + "`");
  }
  return decorate(result2, node2);
}
function generate$G(node2, options) {
  let decorate = noop$1;
  let forceBraces = false;
  let compact = false;
  if (typeof options === "function") {
    decorate = options;
  } else if (options) {
    forceBraces = Boolean(options.forceBraces);
    compact = Boolean(options.compact);
    if (typeof options.decorate === "function") {
      decorate = options.decorate;
    }
  }
  return internalGenerate(node2, decorate, forceBraces, compact);
}
const defaultLoc = { offset: 0, line: 1, column: 1 };
function locateMismatch(matchResult, node2) {
  const tokens = matchResult.tokens;
  const longestMatch = matchResult.longestMatch;
  const mismatchNode = longestMatch < tokens.length ? tokens[longestMatch].node || null : null;
  const badNode = mismatchNode !== node2 ? mismatchNode : null;
  let mismatchOffset = 0;
  let mismatchLength = 0;
  let entries = 0;
  let css2 = "";
  let start;
  let end;
  for (let i2 = 0; i2 < tokens.length; i2++) {
    const token = tokens[i2].value;
    if (i2 === longestMatch) {
      mismatchLength = token.length;
      mismatchOffset = css2.length;
    }
    if (badNode !== null && tokens[i2].node === badNode) {
      if (i2 <= longestMatch) {
        entries++;
      } else {
        entries = 0;
      }
    }
    css2 += token;
  }
  if (longestMatch === tokens.length || entries > 1) {
    start = fromLoc(badNode || node2, "end") || buildLoc(defaultLoc, css2);
    end = buildLoc(start);
  } else {
    start = fromLoc(badNode, "start") || buildLoc(fromLoc(node2, "start") || defaultLoc, css2.slice(0, mismatchOffset));
    end = fromLoc(badNode, "end") || buildLoc(start, css2.substr(mismatchOffset, mismatchLength));
  }
  return {
    css: css2,
    mismatchOffset,
    mismatchLength,
    start,
    end
  };
}
function fromLoc(node2, point) {
  const value2 = node2 && node2.loc && node2.loc[point];
  if (value2) {
    return "line" in value2 ? buildLoc(value2) : value2;
  }
  return null;
}
function buildLoc({ offset, line, column }, extra) {
  const loc = {
    offset,
    line,
    column
  };
  if (extra) {
    const lines = extra.split(/\n|\r\n?|\f/);
    loc.offset += extra.length;
    loc.line += lines.length - 1;
    loc.column = lines.length === 1 ? loc.column + extra.length : lines.pop().length + 1;
  }
  return loc;
}
const SyntaxReferenceError = function(type4, referenceName) {
  const error = createCustomError("SyntaxReferenceError", type4 + (referenceName ? " `" + referenceName + "`" : ""));
  error.reference = referenceName;
  return error;
};
const SyntaxMatchError = function(message, syntax2, node2, matchResult) {
  const error = createCustomError("SyntaxMatchError", message);
  const {
    css: css2,
    mismatchOffset,
    mismatchLength,
    start,
    end
  } = locateMismatch(matchResult, node2);
  error.rawMessage = message;
  error.syntax = syntax2 ? generate$G(syntax2) : "<generic>";
  error.css = css2;
  error.mismatchOffset = mismatchOffset;
  error.mismatchLength = mismatchLength;
  error.message = message + "\n  syntax: " + error.syntax + "\n   value: " + (css2 || "<empty string>") + "\n  --------" + new Array(error.mismatchOffset + 1).join("-") + "^";
  Object.assign(error, start);
  error.loc = {
    source: node2 && node2.loc && node2.loc.source || "<unknown>",
    start,
    end
  };
  return error;
};
const keywords$1 = new Map();
const properties$1 = new Map();
const HYPHENMINUS$5 = 45;
const keyword$1 = getKeywordDescriptor;
const property = getPropertyDescriptor;
function isCustomProperty(str, offset) {
  offset = offset || 0;
  return str.length - offset >= 2 && str.charCodeAt(offset) === HYPHENMINUS$5 && str.charCodeAt(offset + 1) === HYPHENMINUS$5;
}
function getVendorPrefix(str, offset) {
  offset = offset || 0;
  if (str.length - offset >= 3) {
    if (str.charCodeAt(offset) === HYPHENMINUS$5 && str.charCodeAt(offset + 1) !== HYPHENMINUS$5) {
      const secondDashIndex = str.indexOf("-", offset + 2);
      if (secondDashIndex !== -1) {
        return str.substring(offset, secondDashIndex + 1);
      }
    }
  }
  return "";
}
function getKeywordDescriptor(keyword2) {
  if (keywords$1.has(keyword2)) {
    return keywords$1.get(keyword2);
  }
  const name2 = keyword2.toLowerCase();
  let descriptor = keywords$1.get(name2);
  if (descriptor === void 0) {
    const custom = isCustomProperty(name2, 0);
    const vendor = !custom ? getVendorPrefix(name2, 0) : "";
    descriptor = Object.freeze({
      basename: name2.substr(vendor.length),
      name: name2,
      prefix: vendor,
      vendor,
      custom
    });
  }
  keywords$1.set(keyword2, descriptor);
  return descriptor;
}
function getPropertyDescriptor(property2) {
  if (properties$1.has(property2)) {
    return properties$1.get(property2);
  }
  let name2 = property2;
  let hack = property2[0];
  if (hack === "/") {
    hack = property2[1] === "/" ? "//" : "/";
  } else if (hack !== "_" && hack !== "*" && hack !== "$" && hack !== "#" && hack !== "+" && hack !== "&") {
    hack = "";
  }
  const custom = isCustomProperty(name2, hack.length);
  if (!custom) {
    name2 = name2.toLowerCase();
    if (properties$1.has(name2)) {
      const descriptor2 = properties$1.get(name2);
      properties$1.set(property2, descriptor2);
      return descriptor2;
    }
  }
  const vendor = !custom ? getVendorPrefix(name2, hack.length) : "";
  const prefix2 = name2.substr(0, hack.length + vendor.length);
  const descriptor = Object.freeze({
    basename: name2.substr(prefix2.length),
    name: name2.substr(hack.length),
    hack,
    vendor,
    prefix: prefix2,
    custom
  });
  properties$1.set(property2, descriptor);
  return descriptor;
}
const cssWideKeywords = [
  "initial",
  "inherit",
  "unset",
  "revert",
  "revert-layer"
];
const PLUSSIGN$8 = 43;
const HYPHENMINUS$4 = 45;
const N$4 = 110;
const DISALLOW_SIGN$1 = true;
const ALLOW_SIGN$1 = false;
function isDelim$1(token, code) {
  return token !== null && token.type === Delim && token.value.charCodeAt(0) === code;
}
function skipSC(token, offset, getNextToken) {
  while (token !== null && (token.type === WhiteSpace$1 || token.type === Comment$1)) {
    token = getNextToken(++offset);
  }
  return offset;
}
function checkInteger$1(token, valueOffset, disallowSign, offset) {
  if (!token) {
    return 0;
  }
  const code = token.value.charCodeAt(valueOffset);
  if (code === PLUSSIGN$8 || code === HYPHENMINUS$4) {
    if (disallowSign) {
      return 0;
    }
    valueOffset++;
  }
  for (; valueOffset < token.value.length; valueOffset++) {
    if (!isDigit$1(token.value.charCodeAt(valueOffset))) {
      return 0;
    }
  }
  return offset + 1;
}
function consumeB$1(token, offset_, getNextToken) {
  let sign = false;
  let offset = skipSC(token, offset_, getNextToken);
  token = getNextToken(offset);
  if (token === null) {
    return offset_;
  }
  if (token.type !== Number$2) {
    if (isDelim$1(token, PLUSSIGN$8) || isDelim$1(token, HYPHENMINUS$4)) {
      sign = true;
      offset = skipSC(getNextToken(++offset), offset, getNextToken);
      token = getNextToken(offset);
      if (token === null || token.type !== Number$2) {
        return 0;
      }
    } else {
      return offset_;
    }
  }
  if (!sign) {
    const code = token.value.charCodeAt(0);
    if (code !== PLUSSIGN$8 && code !== HYPHENMINUS$4) {
      return 0;
    }
  }
  return checkInteger$1(token, sign ? 0 : 1, sign, offset);
}
function anPlusB(token, getNextToken) {
  let offset = 0;
  if (!token) {
    return 0;
  }
  if (token.type === Number$2) {
    return checkInteger$1(token, 0, ALLOW_SIGN$1, offset);
  } else if (token.type === Ident && token.value.charCodeAt(0) === HYPHENMINUS$4) {
    if (!cmpChar(token.value, 1, N$4)) {
      return 0;
    }
    switch (token.value.length) {
      case 2:
        return consumeB$1(getNextToken(++offset), offset, getNextToken);
      case 3:
        if (token.value.charCodeAt(2) !== HYPHENMINUS$4) {
          return 0;
        }
        offset = skipSC(getNextToken(++offset), offset, getNextToken);
        token = getNextToken(offset);
        return checkInteger$1(token, 0, DISALLOW_SIGN$1, offset);
      default:
        if (token.value.charCodeAt(2) !== HYPHENMINUS$4) {
          return 0;
        }
        return checkInteger$1(token, 3, DISALLOW_SIGN$1, offset);
    }
  } else if (token.type === Ident || isDelim$1(token, PLUSSIGN$8) && getNextToken(offset + 1).type === Ident) {
    if (token.type !== Ident) {
      token = getNextToken(++offset);
    }
    if (token === null || !cmpChar(token.value, 0, N$4)) {
      return 0;
    }
    switch (token.value.length) {
      case 1:
        return consumeB$1(getNextToken(++offset), offset, getNextToken);
      case 2:
        if (token.value.charCodeAt(1) !== HYPHENMINUS$4) {
          return 0;
        }
        offset = skipSC(getNextToken(++offset), offset, getNextToken);
        token = getNextToken(offset);
        return checkInteger$1(token, 0, DISALLOW_SIGN$1, offset);
      default:
        if (token.value.charCodeAt(1) !== HYPHENMINUS$4) {
          return 0;
        }
        return checkInteger$1(token, 2, DISALLOW_SIGN$1, offset);
    }
  } else if (token.type === Dimension$1) {
    let code = token.value.charCodeAt(0);
    let sign = code === PLUSSIGN$8 || code === HYPHENMINUS$4 ? 1 : 0;
    let i2 = sign;
    for (; i2 < token.value.length; i2++) {
      if (!isDigit$1(token.value.charCodeAt(i2))) {
        break;
      }
    }
    if (i2 === sign) {
      return 0;
    }
    if (!cmpChar(token.value, i2, N$4)) {
      return 0;
    }
    if (i2 + 1 === token.value.length) {
      return consumeB$1(getNextToken(++offset), offset, getNextToken);
    } else {
      if (token.value.charCodeAt(i2 + 1) !== HYPHENMINUS$4) {
        return 0;
      }
      if (i2 + 2 === token.value.length) {
        offset = skipSC(getNextToken(++offset), offset, getNextToken);
        token = getNextToken(offset);
        return checkInteger$1(token, 0, DISALLOW_SIGN$1, offset);
      } else {
        return checkInteger$1(token, i2 + 2, DISALLOW_SIGN$1, offset);
      }
    }
  }
  return 0;
}
const PLUSSIGN$7 = 43;
const HYPHENMINUS$3 = 45;
const QUESTIONMARK$2 = 63;
const U$2 = 117;
function isDelim(token, code) {
  return token !== null && token.type === Delim && token.value.charCodeAt(0) === code;
}
function startsWith$1(token, code) {
  return token.value.charCodeAt(0) === code;
}
function hexSequence(token, offset, allowDash) {
  let hexlen = 0;
  for (let pos = offset; pos < token.value.length; pos++) {
    const code = token.value.charCodeAt(pos);
    if (code === HYPHENMINUS$3 && allowDash && hexlen !== 0) {
      hexSequence(token, offset + hexlen + 1, false);
      return 6;
    }
    if (!isHexDigit(code)) {
      return 0;
    }
    if (++hexlen > 6) {
      return 0;
    }
  }
  return hexlen;
}
function withQuestionMarkSequence(consumed, length2, getNextToken) {
  if (!consumed) {
    return 0;
  }
  while (isDelim(getNextToken(length2), QUESTIONMARK$2)) {
    if (++consumed > 6) {
      return 0;
    }
    length2++;
  }
  return length2;
}
function urange(token, getNextToken) {
  let length2 = 0;
  if (token === null || token.type !== Ident || !cmpChar(token.value, 0, U$2)) {
    return 0;
  }
  token = getNextToken(++length2);
  if (token === null) {
    return 0;
  }
  if (isDelim(token, PLUSSIGN$7)) {
    token = getNextToken(++length2);
    if (token === null) {
      return 0;
    }
    if (token.type === Ident) {
      return withQuestionMarkSequence(hexSequence(token, 0, true), ++length2, getNextToken);
    }
    if (isDelim(token, QUESTIONMARK$2)) {
      return withQuestionMarkSequence(1, ++length2, getNextToken);
    }
    return 0;
  }
  if (token.type === Number$2) {
    const consumedHexLength = hexSequence(token, 1, true);
    if (consumedHexLength === 0) {
      return 0;
    }
    token = getNextToken(++length2);
    if (token === null) {
      return length2;
    }
    if (token.type === Dimension$1 || token.type === Number$2) {
      if (!startsWith$1(token, HYPHENMINUS$3) || !hexSequence(token, 1, false)) {
        return 0;
      }
      return length2 + 1;
    }
    return withQuestionMarkSequence(consumedHexLength, length2, getNextToken);
  }
  if (token.type === Dimension$1) {
    return withQuestionMarkSequence(hexSequence(token, 1, true), ++length2, getNextToken);
  }
  return 0;
}
const calcFunctionNames = ["calc(", "-moz-calc(", "-webkit-calc("];
const balancePair = new Map([
  [Function$2, RightParenthesis],
  [LeftParenthesis, RightParenthesis],
  [LeftSquareBracket, RightSquareBracket],
  [LeftCurlyBracket, RightCurlyBracket]
]);
function charCodeAt(str, index2) {
  return index2 < str.length ? str.charCodeAt(index2) : 0;
}
function eqStr(actual, expected) {
  return cmpStr(actual, 0, actual.length, expected);
}
function eqStrAny(actual, expected) {
  for (let i2 = 0; i2 < expected.length; i2++) {
    if (eqStr(actual, expected[i2])) {
      return true;
    }
  }
  return false;
}
function isPostfixIeHack(str, offset) {
  if (offset !== str.length - 2) {
    return false;
  }
  return charCodeAt(str, offset) === 92 && isDigit$1(charCodeAt(str, offset + 1));
}
function outOfRange(opts, value2, numEnd) {
  if (opts && opts.type === "Range") {
    const num = Number(numEnd !== void 0 && numEnd !== value2.length ? value2.substr(0, numEnd) : value2);
    if (isNaN(num)) {
      return true;
    }
    if (opts.min !== null && num < opts.min && typeof opts.min !== "string") {
      return true;
    }
    if (opts.max !== null && num > opts.max && typeof opts.max !== "string") {
      return true;
    }
  }
  return false;
}
function consumeFunction(token, getNextToken) {
  let balanceCloseType = 0;
  let balanceStash = [];
  let length2 = 0;
  scan:
    do {
      switch (token.type) {
        case RightCurlyBracket:
        case RightParenthesis:
        case RightSquareBracket:
          if (token.type !== balanceCloseType) {
            break scan;
          }
          balanceCloseType = balanceStash.pop();
          if (balanceStash.length === 0) {
            length2++;
            break scan;
          }
          break;
        case Function$2:
        case LeftParenthesis:
        case LeftSquareBracket:
        case LeftCurlyBracket:
          balanceStash.push(balanceCloseType);
          balanceCloseType = balancePair.get(token.type);
          break;
      }
      length2++;
    } while (token = getNextToken(length2));
  return length2;
}
function calc(next) {
  return function(token, getNextToken, opts) {
    if (token === null) {
      return 0;
    }
    if (token.type === Function$2 && eqStrAny(token.value, calcFunctionNames)) {
      return consumeFunction(token, getNextToken);
    }
    return next(token, getNextToken, opts);
  };
}
function tokenType(expectedTokenType) {
  return function(token) {
    if (token === null || token.type !== expectedTokenType) {
      return 0;
    }
    return 1;
  };
}
function customIdent(token) {
  if (token === null || token.type !== Ident) {
    return 0;
  }
  const name2 = token.value.toLowerCase();
  if (eqStrAny(name2, cssWideKeywords)) {
    return 0;
  }
  if (eqStr(name2, "default")) {
    return 0;
  }
  return 1;
}
function customPropertyName(token) {
  if (token === null || token.type !== Ident) {
    return 0;
  }
  if (charCodeAt(token.value, 0) !== 45 || charCodeAt(token.value, 1) !== 45) {
    return 0;
  }
  return 1;
}
function hexColor(token) {
  if (token === null || token.type !== Hash$1) {
    return 0;
  }
  const length2 = token.value.length;
  if (length2 !== 4 && length2 !== 5 && length2 !== 7 && length2 !== 9) {
    return 0;
  }
  for (let i2 = 1; i2 < length2; i2++) {
    if (!isHexDigit(charCodeAt(token.value, i2))) {
      return 0;
    }
  }
  return 1;
}
function idSelector(token) {
  if (token === null || token.type !== Hash$1) {
    return 0;
  }
  if (!isIdentifierStart(charCodeAt(token.value, 1), charCodeAt(token.value, 2), charCodeAt(token.value, 3))) {
    return 0;
  }
  return 1;
}
function declarationValue(token, getNextToken) {
  if (!token) {
    return 0;
  }
  let balanceCloseType = 0;
  let balanceStash = [];
  let length2 = 0;
  scan:
    do {
      switch (token.type) {
        case BadString:
        case BadUrl:
          break scan;
        case RightCurlyBracket:
        case RightParenthesis:
        case RightSquareBracket:
          if (token.type !== balanceCloseType) {
            break scan;
          }
          balanceCloseType = balanceStash.pop();
          break;
        case Semicolon:
          if (balanceCloseType === 0) {
            break scan;
          }
          break;
        case Delim:
          if (balanceCloseType === 0 && token.value === "!") {
            break scan;
          }
          break;
        case Function$2:
        case LeftParenthesis:
        case LeftSquareBracket:
        case LeftCurlyBracket:
          balanceStash.push(balanceCloseType);
          balanceCloseType = balancePair.get(token.type);
          break;
      }
      length2++;
    } while (token = getNextToken(length2));
  return length2;
}
function anyValue(token, getNextToken) {
  if (!token) {
    return 0;
  }
  let balanceCloseType = 0;
  let balanceStash = [];
  let length2 = 0;
  scan:
    do {
      switch (token.type) {
        case BadString:
        case BadUrl:
          break scan;
        case RightCurlyBracket:
        case RightParenthesis:
        case RightSquareBracket:
          if (token.type !== balanceCloseType) {
            break scan;
          }
          balanceCloseType = balanceStash.pop();
          break;
        case Function$2:
        case LeftParenthesis:
        case LeftSquareBracket:
        case LeftCurlyBracket:
          balanceStash.push(balanceCloseType);
          balanceCloseType = balancePair.get(token.type);
          break;
      }
      length2++;
    } while (token = getNextToken(length2));
  return length2;
}
function dimension(type4) {
  if (type4) {
    type4 = new Set(type4);
  }
  return function(token, getNextToken, opts) {
    if (token === null || token.type !== Dimension$1) {
      return 0;
    }
    const numberEnd = consumeNumber$1(token.value, 0);
    if (type4 !== null) {
      const reverseSolidusOffset = token.value.indexOf("\\", numberEnd);
      const unit = reverseSolidusOffset === -1 || !isPostfixIeHack(token.value, reverseSolidusOffset) ? token.value.substr(numberEnd) : token.value.substring(numberEnd, reverseSolidusOffset);
      if (type4.has(unit.toLowerCase()) === false) {
        return 0;
      }
    }
    if (outOfRange(opts, token.value, numberEnd)) {
      return 0;
    }
    return 1;
  };
}
function percentage(token, getNextToken, opts) {
  if (token === null || token.type !== Percentage$1) {
    return 0;
  }
  if (outOfRange(opts, token.value, token.value.length - 1)) {
    return 0;
  }
  return 1;
}
function zero(next) {
  if (typeof next !== "function") {
    next = function() {
      return 0;
    };
  }
  return function(token, getNextToken, opts) {
    if (token !== null && token.type === Number$2) {
      if (Number(token.value) === 0) {
        return 1;
      }
    }
    return next(token, getNextToken, opts);
  };
}
function number$1(token, getNextToken, opts) {
  if (token === null) {
    return 0;
  }
  const numberEnd = consumeNumber$1(token.value, 0);
  const isNumber = numberEnd === token.value.length;
  if (!isNumber && !isPostfixIeHack(token.value, numberEnd)) {
    return 0;
  }
  if (outOfRange(opts, token.value, numberEnd)) {
    return 0;
  }
  return 1;
}
function integer3(token, getNextToken, opts) {
  if (token === null || token.type !== Number$2) {
    return 0;
  }
  let i2 = charCodeAt(token.value, 0) === 43 || charCodeAt(token.value, 0) === 45 ? 1 : 0;
  for (; i2 < token.value.length; i2++) {
    if (!isDigit$1(charCodeAt(token.value, i2))) {
      return 0;
    }
  }
  if (outOfRange(opts, token.value, i2)) {
    return 0;
  }
  return 1;
}
const tokenTypes = {
  "ident-token": tokenType(Ident),
  "function-token": tokenType(Function$2),
  "at-keyword-token": tokenType(AtKeyword),
  "hash-token": tokenType(Hash$1),
  "string-token": tokenType(String$2),
  "bad-string-token": tokenType(BadString),
  "url-token": tokenType(Url$1),
  "bad-url-token": tokenType(BadUrl),
  "delim-token": tokenType(Delim),
  "number-token": tokenType(Number$2),
  "percentage-token": tokenType(Percentage$1),
  "dimension-token": tokenType(Dimension$1),
  "whitespace-token": tokenType(WhiteSpace$1),
  "CDO-token": tokenType(CDO$1),
  "CDC-token": tokenType(CDC$1),
  "colon-token": tokenType(Colon),
  "semicolon-token": tokenType(Semicolon),
  "comma-token": tokenType(Comma),
  "[-token": tokenType(LeftSquareBracket),
  "]-token": tokenType(RightSquareBracket),
  "(-token": tokenType(LeftParenthesis),
  ")-token": tokenType(RightParenthesis),
  "{-token": tokenType(LeftCurlyBracket),
  "}-token": tokenType(RightCurlyBracket)
};
const productionTypes = {
  "string": tokenType(String$2),
  "ident": tokenType(Ident),
  "percentage": calc(percentage),
  "zero": zero(),
  "number": calc(number$1),
  "integer": calc(integer3),
  "custom-ident": customIdent,
  "custom-property-name": customPropertyName,
  "hex-color": hexColor,
  "id-selector": idSelector,
  "an-plus-b": anPlusB,
  "urange": urange,
  "declaration-value": declarationValue,
  "any-value": anyValue
};
function createDemensionTypes(units2) {
  const {
    angle: angle2,
    decibel: decibel2,
    frequency: frequency2,
    flex: flex2,
    length: length2,
    resolution: resolution2,
    semitones: semitones2,
    time: time2
  } = units2 || {};
  return {
    "dimension": calc(dimension(null)),
    "angle": calc(dimension(angle2)),
    "decibel": calc(dimension(decibel2)),
    "frequency": calc(dimension(frequency2)),
    "flex": calc(dimension(flex2)),
    "length": calc(zero(dimension(length2))),
    "resolution": calc(dimension(resolution2)),
    "semitones": calc(dimension(semitones2)),
    "time": calc(dimension(time2))
  };
}
function createGenericTypes(units2) {
  return __spreadValues(__spreadValues(__spreadValues({}, tokenTypes), productionTypes), createDemensionTypes(units2));
}
const length = [
  "cm",
  "mm",
  "q",
  "in",
  "pt",
  "pc",
  "px",
  "em",
  "rem",
  "ex",
  "rex",
  "cap",
  "rcap",
  "ch",
  "rch",
  "ic",
  "ric",
  "lh",
  "rlh",
  "vw",
  "svw",
  "lvw",
  "dvw",
  "vh",
  "svh",
  "lvh",
  "dvh",
  "vi",
  "svi",
  "lvi",
  "dvi",
  "vb",
  "svb",
  "lvb",
  "dvb",
  "vmin",
  "svmin",
  "lvmin",
  "dvmin",
  "vmax",
  "svmax",
  "lvmax",
  "dvmax",
  "cqw",
  "cqh",
  "cqi",
  "cqb",
  "cqmin",
  "cqmax"
];
const angle = ["deg", "grad", "rad", "turn"];
const time = ["s", "ms"];
const frequency = ["hz", "khz"];
const resolution = ["dpi", "dpcm", "dppx", "x"];
const flex = ["fr"];
const decibel = ["db"];
const semitones = ["st"];
var units = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  length,
  angle,
  time,
  frequency,
  resolution,
  flex,
  decibel,
  semitones
}, Symbol.toStringTag, { value: "Module" }));
function SyntaxError$1(message, input, offset) {
  return Object.assign(createCustomError("SyntaxError", message), {
    input,
    offset,
    rawMessage: message,
    message: message + "\n  " + input + "\n--" + new Array((offset || input.length) + 1).join("-") + "^"
  });
}
const TAB$1 = 9;
const N$3 = 10;
const F$2 = 12;
const R$2 = 13;
const SPACE$3 = 32;
class Tokenizer {
  constructor(str) {
    this.str = str;
    this.pos = 0;
  }
  charCodeAt(pos) {
    return pos < this.str.length ? this.str.charCodeAt(pos) : 0;
  }
  charCode() {
    return this.charCodeAt(this.pos);
  }
  nextCharCode() {
    return this.charCodeAt(this.pos + 1);
  }
  nextNonWsCode(pos) {
    return this.charCodeAt(this.findWsEnd(pos));
  }
  findWsEnd(pos) {
    for (; pos < this.str.length; pos++) {
      const code = this.str.charCodeAt(pos);
      if (code !== R$2 && code !== N$3 && code !== F$2 && code !== SPACE$3 && code !== TAB$1) {
        break;
      }
    }
    return pos;
  }
  substringToPos(end) {
    return this.str.substring(this.pos, this.pos = end);
  }
  eat(code) {
    if (this.charCode() !== code) {
      this.error("Expect `" + String.fromCharCode(code) + "`");
    }
    this.pos++;
  }
  peek() {
    return this.pos < this.str.length ? this.str.charAt(this.pos++) : "";
  }
  error(message) {
    throw new SyntaxError$1(message, this.str, this.pos);
  }
}
const TAB = 9;
const N$2 = 10;
const F$1 = 12;
const R$1 = 13;
const SPACE$2 = 32;
const EXCLAMATIONMARK$2 = 33;
const NUMBERSIGN$3 = 35;
const AMPERSAND$5 = 38;
const APOSTROPHE$2 = 39;
const LEFTPARENTHESIS$2 = 40;
const RIGHTPARENTHESIS$2 = 41;
const ASTERISK$6 = 42;
const PLUSSIGN$6 = 43;
const COMMA = 44;
const HYPERMINUS = 45;
const LESSTHANSIGN = 60;
const GREATERTHANSIGN$2 = 62;
const QUESTIONMARK$1 = 63;
const COMMERCIALAT = 64;
const LEFTSQUAREBRACKET = 91;
const RIGHTSQUAREBRACKET = 93;
const LEFTCURLYBRACKET = 123;
const VERTICALLINE$3 = 124;
const RIGHTCURLYBRACKET = 125;
const INFINITY = 8734;
const NAME_CHAR = new Uint8Array(128).map((_2, idx) => /[a-zA-Z0-9\-]/.test(String.fromCharCode(idx)) ? 1 : 0);
const COMBINATOR_PRECEDENCE = {
  " ": 1,
  "&&": 2,
  "||": 3,
  "|": 4
};
function scanSpaces(tokenizer) {
  return tokenizer.substringToPos(tokenizer.findWsEnd(tokenizer.pos));
}
function scanWord(tokenizer) {
  let end = tokenizer.pos;
  for (; end < tokenizer.str.length; end++) {
    const code = tokenizer.str.charCodeAt(end);
    if (code >= 128 || NAME_CHAR[code] === 0) {
      break;
    }
  }
  if (tokenizer.pos === end) {
    tokenizer.error("Expect a keyword");
  }
  return tokenizer.substringToPos(end);
}
function scanNumber(tokenizer) {
  let end = tokenizer.pos;
  for (; end < tokenizer.str.length; end++) {
    const code = tokenizer.str.charCodeAt(end);
    if (code < 48 || code > 57) {
      break;
    }
  }
  if (tokenizer.pos === end) {
    tokenizer.error("Expect a number");
  }
  return tokenizer.substringToPos(end);
}
function scanString(tokenizer) {
  const end = tokenizer.str.indexOf("'", tokenizer.pos + 1);
  if (end === -1) {
    tokenizer.pos = tokenizer.str.length;
    tokenizer.error("Expect an apostrophe");
  }
  return tokenizer.substringToPos(end + 1);
}
function readMultiplierRange(tokenizer) {
  let min = null;
  let max = null;
  tokenizer.eat(LEFTCURLYBRACKET);
  min = scanNumber(tokenizer);
  if (tokenizer.charCode() === COMMA) {
    tokenizer.pos++;
    if (tokenizer.charCode() !== RIGHTCURLYBRACKET) {
      max = scanNumber(tokenizer);
    }
  } else {
    max = min;
  }
  tokenizer.eat(RIGHTCURLYBRACKET);
  return {
    min: Number(min),
    max: max ? Number(max) : 0
  };
}
function readMultiplier(tokenizer) {
  let range3 = null;
  let comma = false;
  switch (tokenizer.charCode()) {
    case ASTERISK$6:
      tokenizer.pos++;
      range3 = {
        min: 0,
        max: 0
      };
      break;
    case PLUSSIGN$6:
      tokenizer.pos++;
      range3 = {
        min: 1,
        max: 0
      };
      break;
    case QUESTIONMARK$1:
      tokenizer.pos++;
      range3 = {
        min: 0,
        max: 1
      };
      break;
    case NUMBERSIGN$3:
      tokenizer.pos++;
      comma = true;
      if (tokenizer.charCode() === LEFTCURLYBRACKET) {
        range3 = readMultiplierRange(tokenizer);
      } else if (tokenizer.charCode() === QUESTIONMARK$1) {
        tokenizer.pos++;
        range3 = {
          min: 0,
          max: 0
        };
      } else {
        range3 = {
          min: 1,
          max: 0
        };
      }
      break;
    case LEFTCURLYBRACKET:
      range3 = readMultiplierRange(tokenizer);
      break;
    default:
      return null;
  }
  return {
    type: "Multiplier",
    comma,
    min: range3.min,
    max: range3.max,
    term: null
  };
}
function maybeMultiplied(tokenizer, node2) {
  const multiplier = readMultiplier(tokenizer);
  if (multiplier !== null) {
    multiplier.term = node2;
    if (tokenizer.charCode() === NUMBERSIGN$3 && tokenizer.charCodeAt(tokenizer.pos - 1) === PLUSSIGN$6) {
      return maybeMultiplied(tokenizer, multiplier);
    }
    return multiplier;
  }
  return node2;
}
function maybeToken(tokenizer) {
  const ch2 = tokenizer.peek();
  if (ch2 === "") {
    return null;
  }
  return {
    type: "Token",
    value: ch2
  };
}
function readProperty$1(tokenizer) {
  let name2;
  tokenizer.eat(LESSTHANSIGN);
  tokenizer.eat(APOSTROPHE$2);
  name2 = scanWord(tokenizer);
  tokenizer.eat(APOSTROPHE$2);
  tokenizer.eat(GREATERTHANSIGN$2);
  return maybeMultiplied(tokenizer, {
    type: "Property",
    name: name2
  });
}
function readTypeRange(tokenizer) {
  let min = null;
  let max = null;
  let sign = 1;
  tokenizer.eat(LEFTSQUAREBRACKET);
  if (tokenizer.charCode() === HYPERMINUS) {
    tokenizer.peek();
    sign = -1;
  }
  if (sign == -1 && tokenizer.charCode() === INFINITY) {
    tokenizer.peek();
  } else {
    min = sign * Number(scanNumber(tokenizer));
    if (NAME_CHAR[tokenizer.charCode()] !== 0) {
      min += scanWord(tokenizer);
    }
  }
  scanSpaces(tokenizer);
  tokenizer.eat(COMMA);
  scanSpaces(tokenizer);
  if (tokenizer.charCode() === INFINITY) {
    tokenizer.peek();
  } else {
    sign = 1;
    if (tokenizer.charCode() === HYPERMINUS) {
      tokenizer.peek();
      sign = -1;
    }
    max = sign * Number(scanNumber(tokenizer));
    if (NAME_CHAR[tokenizer.charCode()] !== 0) {
      max += scanWord(tokenizer);
    }
  }
  tokenizer.eat(RIGHTSQUAREBRACKET);
  return {
    type: "Range",
    min,
    max
  };
}
function readType(tokenizer) {
  let name2;
  let opts = null;
  tokenizer.eat(LESSTHANSIGN);
  name2 = scanWord(tokenizer);
  if (tokenizer.charCode() === LEFTPARENTHESIS$2 && tokenizer.nextCharCode() === RIGHTPARENTHESIS$2) {
    tokenizer.pos += 2;
    name2 += "()";
  }
  if (tokenizer.charCodeAt(tokenizer.findWsEnd(tokenizer.pos)) === LEFTSQUAREBRACKET) {
    scanSpaces(tokenizer);
    opts = readTypeRange(tokenizer);
  }
  tokenizer.eat(GREATERTHANSIGN$2);
  return maybeMultiplied(tokenizer, {
    type: "Type",
    name: name2,
    opts
  });
}
function readKeywordOrFunction(tokenizer) {
  const name2 = scanWord(tokenizer);
  if (tokenizer.charCode() === LEFTPARENTHESIS$2) {
    tokenizer.pos++;
    return {
      type: "Function",
      name: name2
    };
  }
  return maybeMultiplied(tokenizer, {
    type: "Keyword",
    name: name2
  });
}
function regroupTerms(terms, combinators) {
  function createGroup(terms2, combinator2) {
    return {
      type: "Group",
      terms: terms2,
      combinator: combinator2,
      disallowEmpty: false,
      explicit: false
    };
  }
  let combinator;
  combinators = Object.keys(combinators).sort((a2, b2) => COMBINATOR_PRECEDENCE[a2] - COMBINATOR_PRECEDENCE[b2]);
  while (combinators.length > 0) {
    combinator = combinators.shift();
    let i2 = 0;
    let subgroupStart = 0;
    for (; i2 < terms.length; i2++) {
      const term = terms[i2];
      if (term.type === "Combinator") {
        if (term.value === combinator) {
          if (subgroupStart === -1) {
            subgroupStart = i2 - 1;
          }
          terms.splice(i2, 1);
          i2--;
        } else {
          if (subgroupStart !== -1 && i2 - subgroupStart > 1) {
            terms.splice(subgroupStart, i2 - subgroupStart, createGroup(terms.slice(subgroupStart, i2), combinator));
            i2 = subgroupStart + 1;
          }
          subgroupStart = -1;
        }
      }
    }
    if (subgroupStart !== -1 && combinators.length) {
      terms.splice(subgroupStart, i2 - subgroupStart, createGroup(terms.slice(subgroupStart, i2), combinator));
    }
  }
  return combinator;
}
function readImplicitGroup(tokenizer) {
  const terms = [];
  const combinators = {};
  let token;
  let prevToken = null;
  let prevTokenPos = tokenizer.pos;
  while (token = peek(tokenizer)) {
    if (token.type !== "Spaces") {
      if (token.type === "Combinator") {
        if (prevToken === null || prevToken.type === "Combinator") {
          tokenizer.pos = prevTokenPos;
          tokenizer.error("Unexpected combinator");
        }
        combinators[token.value] = true;
      } else if (prevToken !== null && prevToken.type !== "Combinator") {
        combinators[" "] = true;
        terms.push({
          type: "Combinator",
          value: " "
        });
      }
      terms.push(token);
      prevToken = token;
      prevTokenPos = tokenizer.pos;
    }
  }
  if (prevToken !== null && prevToken.type === "Combinator") {
    tokenizer.pos -= prevTokenPos;
    tokenizer.error("Unexpected combinator");
  }
  return {
    type: "Group",
    terms,
    combinator: regroupTerms(terms, combinators) || " ",
    disallowEmpty: false,
    explicit: false
  };
}
function readGroup(tokenizer) {
  let result2;
  tokenizer.eat(LEFTSQUAREBRACKET);
  result2 = readImplicitGroup(tokenizer);
  tokenizer.eat(RIGHTSQUAREBRACKET);
  result2.explicit = true;
  if (tokenizer.charCode() === EXCLAMATIONMARK$2) {
    tokenizer.pos++;
    result2.disallowEmpty = true;
  }
  return result2;
}
function peek(tokenizer) {
  let code = tokenizer.charCode();
  if (code < 128 && NAME_CHAR[code] === 1) {
    return readKeywordOrFunction(tokenizer);
  }
  switch (code) {
    case RIGHTSQUAREBRACKET:
      break;
    case LEFTSQUAREBRACKET:
      return maybeMultiplied(tokenizer, readGroup(tokenizer));
    case LESSTHANSIGN:
      return tokenizer.nextCharCode() === APOSTROPHE$2 ? readProperty$1(tokenizer) : readType(tokenizer);
    case VERTICALLINE$3:
      return {
        type: "Combinator",
        value: tokenizer.substringToPos(tokenizer.pos + (tokenizer.nextCharCode() === VERTICALLINE$3 ? 2 : 1))
      };
    case AMPERSAND$5:
      tokenizer.pos++;
      tokenizer.eat(AMPERSAND$5);
      return {
        type: "Combinator",
        value: "&&"
      };
    case COMMA:
      tokenizer.pos++;
      return {
        type: "Comma"
      };
    case APOSTROPHE$2:
      return maybeMultiplied(tokenizer, {
        type: "String",
        value: scanString(tokenizer)
      });
    case SPACE$2:
    case TAB:
    case N$2:
    case R$1:
    case F$1:
      return {
        type: "Spaces",
        value: scanSpaces(tokenizer)
      };
    case COMMERCIALAT:
      code = tokenizer.nextCharCode();
      if (code < 128 && NAME_CHAR[code] === 1) {
        tokenizer.pos++;
        return {
          type: "AtKeyword",
          name: scanWord(tokenizer)
        };
      }
      return maybeToken(tokenizer);
    case ASTERISK$6:
    case PLUSSIGN$6:
    case QUESTIONMARK$1:
    case NUMBERSIGN$3:
    case EXCLAMATIONMARK$2:
      break;
    case LEFTCURLYBRACKET:
      code = tokenizer.nextCharCode();
      if (code < 48 || code > 57) {
        return maybeToken(tokenizer);
      }
      break;
    default:
      return maybeToken(tokenizer);
  }
}
function parse$H(source) {
  const tokenizer = new Tokenizer(source);
  const result2 = readImplicitGroup(tokenizer);
  if (tokenizer.pos !== source.length) {
    tokenizer.error("Unexpected input");
  }
  if (result2.terms.length === 1 && result2.terms[0].type === "Group") {
    return result2.terms[0];
  }
  return result2;
}
const noop = function() {
};
function ensureFunction(value2) {
  return typeof value2 === "function" ? value2 : noop;
}
function walk$1(node2, options, context) {
  function walk2(node3) {
    enter.call(context, node3);
    switch (node3.type) {
      case "Group":
        node3.terms.forEach(walk2);
        break;
      case "Multiplier":
        walk2(node3.term);
        break;
      case "Type":
      case "Property":
      case "Keyword":
      case "AtKeyword":
      case "Function":
      case "String":
      case "Token":
      case "Comma":
        break;
      default:
        throw new Error("Unknown type: " + node3.type);
    }
    leave.call(context, node3);
  }
  let enter = noop;
  let leave = noop;
  if (typeof options === "function") {
    enter = options;
  } else if (options) {
    enter = ensureFunction(options.enter);
    leave = ensureFunction(options.leave);
  }
  if (enter === noop && leave === noop) {
    throw new Error("Neither `enter` nor `leave` walker handler is set or both aren't a function");
  }
  walk2(node2);
}
const astToTokens = {
  decorator(handlers2) {
    const tokens = [];
    let curNode = null;
    return __spreadProps(__spreadValues({}, handlers2), {
      node(node2) {
        const tmp = curNode;
        curNode = node2;
        handlers2.node.call(this, node2);
        curNode = tmp;
      },
      emit(value2, type4, auto) {
        tokens.push({
          type: type4,
          value: value2,
          node: auto ? null : curNode
        });
      },
      result() {
        return tokens;
      }
    });
  }
};
function stringToTokens(str) {
  const tokens = [];
  tokenize$1(str, (type4, start, end) => tokens.push({
    type: type4,
    value: str.slice(start, end),
    node: null
  }));
  return tokens;
}
function prepareTokens(value2, syntax2) {
  if (typeof value2 === "string") {
    return stringToTokens(value2);
  }
  return syntax2.generate(value2, astToTokens);
}
const MATCH = { type: "Match" };
const MISMATCH = { type: "Mismatch" };
const DISALLOW_EMPTY = { type: "DisallowEmpty" };
const LEFTPARENTHESIS$1 = 40;
const RIGHTPARENTHESIS$1 = 41;
function createCondition(match2, thenBranch, elseBranch) {
  if (thenBranch === MATCH && elseBranch === MISMATCH) {
    return match2;
  }
  if (match2 === MATCH && thenBranch === MATCH && elseBranch === MATCH) {
    return match2;
  }
  if (match2.type === "If" && match2.else === MISMATCH && thenBranch === MATCH) {
    thenBranch = match2.then;
    match2 = match2.match;
  }
  return {
    type: "If",
    match: match2,
    then: thenBranch,
    else: elseBranch
  };
}
function isFunctionType(name2) {
  return name2.length > 2 && name2.charCodeAt(name2.length - 2) === LEFTPARENTHESIS$1 && name2.charCodeAt(name2.length - 1) === RIGHTPARENTHESIS$1;
}
function isEnumCapatible(term) {
  return term.type === "Keyword" || term.type === "AtKeyword" || term.type === "Function" || term.type === "Type" && isFunctionType(term.name);
}
function buildGroupMatchGraph(combinator, terms, atLeastOneTermMatched) {
  switch (combinator) {
    case " ": {
      let result2 = MATCH;
      for (let i2 = terms.length - 1; i2 >= 0; i2--) {
        const term = terms[i2];
        result2 = createCondition(term, result2, MISMATCH);
      }
      return result2;
    }
    case "|": {
      let result2 = MISMATCH;
      let map2 = null;
      for (let i2 = terms.length - 1; i2 >= 0; i2--) {
        let term = terms[i2];
        if (isEnumCapatible(term)) {
          if (map2 === null && i2 > 0 && isEnumCapatible(terms[i2 - 1])) {
            map2 = Object.create(null);
            result2 = createCondition({
              type: "Enum",
              map: map2
            }, MATCH, result2);
          }
          if (map2 !== null) {
            const key = (isFunctionType(term.name) ? term.name.slice(0, -1) : term.name).toLowerCase();
            if (key in map2 === false) {
              map2[key] = term;
              continue;
            }
          }
        }
        map2 = null;
        result2 = createCondition(term, MATCH, result2);
      }
      return result2;
    }
    case "&&": {
      if (terms.length > 5) {
        return {
          type: "MatchOnce",
          terms,
          all: true
        };
      }
      let result2 = MISMATCH;
      for (let i2 = terms.length - 1; i2 >= 0; i2--) {
        const term = terms[i2];
        let thenClause;
        if (terms.length > 1) {
          thenClause = buildGroupMatchGraph(combinator, terms.filter(function(newGroupTerm) {
            return newGroupTerm !== term;
          }), false);
        } else {
          thenClause = MATCH;
        }
        result2 = createCondition(term, thenClause, result2);
      }
      return result2;
    }
    case "||": {
      if (terms.length > 5) {
        return {
          type: "MatchOnce",
          terms,
          all: false
        };
      }
      let result2 = atLeastOneTermMatched ? MATCH : MISMATCH;
      for (let i2 = terms.length - 1; i2 >= 0; i2--) {
        const term = terms[i2];
        let thenClause;
        if (terms.length > 1) {
          thenClause = buildGroupMatchGraph(combinator, terms.filter(function(newGroupTerm) {
            return newGroupTerm !== term;
          }), true);
        } else {
          thenClause = MATCH;
        }
        result2 = createCondition(term, thenClause, result2);
      }
      return result2;
    }
  }
}
function buildMultiplierMatchGraph(node2) {
  let result2 = MATCH;
  let matchTerm = buildMatchGraphInternal(node2.term);
  if (node2.max === 0) {
    matchTerm = createCondition(matchTerm, DISALLOW_EMPTY, MISMATCH);
    result2 = createCondition(matchTerm, null, MISMATCH);
    result2.then = createCondition(MATCH, MATCH, result2);
    if (node2.comma) {
      result2.then.else = createCondition({ type: "Comma", syntax: node2 }, result2, MISMATCH);
    }
  } else {
    for (let i2 = node2.min || 1; i2 <= node2.max; i2++) {
      if (node2.comma && result2 !== MATCH) {
        result2 = createCondition({ type: "Comma", syntax: node2 }, result2, MISMATCH);
      }
      result2 = createCondition(matchTerm, createCondition(MATCH, MATCH, result2), MISMATCH);
    }
  }
  if (node2.min === 0) {
    result2 = createCondition(MATCH, MATCH, result2);
  } else {
    for (let i2 = 0; i2 < node2.min - 1; i2++) {
      if (node2.comma && result2 !== MATCH) {
        result2 = createCondition({ type: "Comma", syntax: node2 }, result2, MISMATCH);
      }
      result2 = createCondition(matchTerm, result2, MISMATCH);
    }
  }
  return result2;
}
function buildMatchGraphInternal(node2) {
  if (typeof node2 === "function") {
    return {
      type: "Generic",
      fn: node2
    };
  }
  switch (node2.type) {
    case "Group": {
      let result2 = buildGroupMatchGraph(node2.combinator, node2.terms.map(buildMatchGraphInternal), false);
      if (node2.disallowEmpty) {
        result2 = createCondition(result2, DISALLOW_EMPTY, MISMATCH);
      }
      return result2;
    }
    case "Multiplier":
      return buildMultiplierMatchGraph(node2);
    case "Type":
    case "Property":
      return {
        type: node2.type,
        name: node2.name,
        syntax: node2
      };
    case "Keyword":
      return {
        type: node2.type,
        name: node2.name.toLowerCase(),
        syntax: node2
      };
    case "AtKeyword":
      return {
        type: node2.type,
        name: "@" + node2.name.toLowerCase(),
        syntax: node2
      };
    case "Function":
      return {
        type: node2.type,
        name: node2.name.toLowerCase() + "(",
        syntax: node2
      };
    case "String":
      if (node2.value.length === 3) {
        return {
          type: "Token",
          value: node2.value.charAt(1),
          syntax: node2
        };
      }
      return {
        type: node2.type,
        value: node2.value.substr(1, node2.value.length - 2).replace(/\\'/g, "'"),
        syntax: node2
      };
    case "Token":
      return {
        type: node2.type,
        value: node2.value,
        syntax: node2
      };
    case "Comma":
      return {
        type: node2.type,
        syntax: node2
      };
    default:
      throw new Error("Unknown node type:", node2.type);
  }
}
function buildMatchGraph(syntaxTree2, ref2) {
  if (typeof syntaxTree2 === "string") {
    syntaxTree2 = parse$H(syntaxTree2);
  }
  return {
    type: "MatchGraph",
    match: buildMatchGraphInternal(syntaxTree2),
    syntax: ref2 || null,
    source: syntaxTree2
  };
}
const { hasOwnProperty: hasOwnProperty$2 } = Object.prototype;
const STUB = 0;
const TOKEN = 1;
const OPEN_SYNTAX = 2;
const CLOSE_SYNTAX = 3;
const EXIT_REASON_MATCH = "Match";
const EXIT_REASON_MISMATCH = "Mismatch";
const EXIT_REASON_ITERATION_LIMIT = "Maximum iteration number exceeded (please fill an issue on https://github.com/csstree/csstree/issues)";
const ITERATION_LIMIT = 15e3;
function reverseList(list) {
  let prev = null;
  let next = null;
  let item = list;
  while (item !== null) {
    next = item.prev;
    item.prev = prev;
    prev = item;
    item = next;
  }
  return prev;
}
function areStringsEqualCaseInsensitive(testStr, referenceStr) {
  if (testStr.length !== referenceStr.length) {
    return false;
  }
  for (let i2 = 0; i2 < testStr.length; i2++) {
    const referenceCode = referenceStr.charCodeAt(i2);
    let testCode = testStr.charCodeAt(i2);
    if (testCode >= 65 && testCode <= 90) {
      testCode = testCode | 32;
    }
    if (testCode !== referenceCode) {
      return false;
    }
  }
  return true;
}
function isContextEdgeDelim(token) {
  if (token.type !== Delim) {
    return false;
  }
  return token.value !== "?";
}
function isCommaContextStart(token) {
  if (token === null) {
    return true;
  }
  return token.type === Comma || token.type === Function$2 || token.type === LeftParenthesis || token.type === LeftSquareBracket || token.type === LeftCurlyBracket || isContextEdgeDelim(token);
}
function isCommaContextEnd(token) {
  if (token === null) {
    return true;
  }
  return token.type === RightParenthesis || token.type === RightSquareBracket || token.type === RightCurlyBracket || token.type === Delim && token.value === "/";
}
function internalMatch(tokens, state, syntaxes) {
  function moveToNextToken() {
    do {
      tokenIndex++;
      token = tokenIndex < tokens.length ? tokens[tokenIndex] : null;
    } while (token !== null && (token.type === WhiteSpace$1 || token.type === Comment$1));
  }
  function getNextToken(offset) {
    const nextIndex = tokenIndex + offset;
    return nextIndex < tokens.length ? tokens[nextIndex] : null;
  }
  function stateSnapshotFromSyntax(nextState, prev) {
    return {
      nextState,
      matchStack,
      syntaxStack,
      thenStack,
      tokenIndex,
      prev
    };
  }
  function pushThenStack(nextState) {
    thenStack = {
      nextState,
      matchStack,
      syntaxStack,
      prev: thenStack
    };
  }
  function pushElseStack(nextState) {
    elseStack = stateSnapshotFromSyntax(nextState, elseStack);
  }
  function addTokenToMatch() {
    matchStack = {
      type: TOKEN,
      syntax: state.syntax,
      token,
      prev: matchStack
    };
    moveToNextToken();
    syntaxStash = null;
    if (tokenIndex > longestMatch) {
      longestMatch = tokenIndex;
    }
  }
  function openSyntax() {
    syntaxStack = {
      syntax: state.syntax,
      opts: state.syntax.opts || syntaxStack !== null && syntaxStack.opts || null,
      prev: syntaxStack
    };
    matchStack = {
      type: OPEN_SYNTAX,
      syntax: state.syntax,
      token: matchStack.token,
      prev: matchStack
    };
  }
  function closeSyntax() {
    if (matchStack.type === OPEN_SYNTAX) {
      matchStack = matchStack.prev;
    } else {
      matchStack = {
        type: CLOSE_SYNTAX,
        syntax: syntaxStack.syntax,
        token: matchStack.token,
        prev: matchStack
      };
    }
    syntaxStack = syntaxStack.prev;
  }
  let syntaxStack = null;
  let thenStack = null;
  let elseStack = null;
  let syntaxStash = null;
  let iterationCount = 0;
  let exitReason = null;
  let token = null;
  let tokenIndex = -1;
  let longestMatch = 0;
  let matchStack = {
    type: STUB,
    syntax: null,
    token: null,
    prev: null
  };
  moveToNextToken();
  while (exitReason === null && ++iterationCount < ITERATION_LIMIT) {
    switch (state.type) {
      case "Match":
        if (thenStack === null) {
          if (token !== null) {
            if (tokenIndex !== tokens.length - 1 || token.value !== "\\0" && token.value !== "\\9") {
              state = MISMATCH;
              break;
            }
          }
          exitReason = EXIT_REASON_MATCH;
          break;
        }
        state = thenStack.nextState;
        if (state === DISALLOW_EMPTY) {
          if (thenStack.matchStack === matchStack) {
            state = MISMATCH;
            break;
          } else {
            state = MATCH;
          }
        }
        while (thenStack.syntaxStack !== syntaxStack) {
          closeSyntax();
        }
        thenStack = thenStack.prev;
        break;
      case "Mismatch":
        if (syntaxStash !== null && syntaxStash !== false) {
          if (elseStack === null || tokenIndex > elseStack.tokenIndex) {
            elseStack = syntaxStash;
            syntaxStash = false;
          }
        } else if (elseStack === null) {
          exitReason = EXIT_REASON_MISMATCH;
          break;
        }
        state = elseStack.nextState;
        thenStack = elseStack.thenStack;
        syntaxStack = elseStack.syntaxStack;
        matchStack = elseStack.matchStack;
        tokenIndex = elseStack.tokenIndex;
        token = tokenIndex < tokens.length ? tokens[tokenIndex] : null;
        elseStack = elseStack.prev;
        break;
      case "MatchGraph":
        state = state.match;
        break;
      case "If":
        if (state.else !== MISMATCH) {
          pushElseStack(state.else);
        }
        if (state.then !== MATCH) {
          pushThenStack(state.then);
        }
        state = state.match;
        break;
      case "MatchOnce":
        state = {
          type: "MatchOnceBuffer",
          syntax: state,
          index: 0,
          mask: 0
        };
        break;
      case "MatchOnceBuffer": {
        const terms = state.syntax.terms;
        if (state.index === terms.length) {
          if (state.mask === 0 || state.syntax.all) {
            state = MISMATCH;
            break;
          }
          state = MATCH;
          break;
        }
        if (state.mask === (1 << terms.length) - 1) {
          state = MATCH;
          break;
        }
        for (; state.index < terms.length; state.index++) {
          const matchFlag = 1 << state.index;
          if ((state.mask & matchFlag) === 0) {
            pushElseStack(state);
            pushThenStack({
              type: "AddMatchOnce",
              syntax: state.syntax,
              mask: state.mask | matchFlag
            });
            state = terms[state.index++];
            break;
          }
        }
        break;
      }
      case "AddMatchOnce":
        state = {
          type: "MatchOnceBuffer",
          syntax: state.syntax,
          index: 0,
          mask: state.mask
        };
        break;
      case "Enum":
        if (token !== null) {
          let name2 = token.value.toLowerCase();
          if (name2.indexOf("\\") !== -1) {
            name2 = name2.replace(/\\[09].*$/, "");
          }
          if (hasOwnProperty$2.call(state.map, name2)) {
            state = state.map[name2];
            break;
          }
        }
        state = MISMATCH;
        break;
      case "Generic": {
        const opts = syntaxStack !== null ? syntaxStack.opts : null;
        const lastTokenIndex2 = tokenIndex + Math.floor(state.fn(token, getNextToken, opts));
        if (!isNaN(lastTokenIndex2) && lastTokenIndex2 > tokenIndex) {
          while (tokenIndex < lastTokenIndex2) {
            addTokenToMatch();
          }
          state = MATCH;
        } else {
          state = MISMATCH;
        }
        break;
      }
      case "Type":
      case "Property": {
        const syntaxDict = state.type === "Type" ? "types" : "properties";
        const dictSyntax = hasOwnProperty$2.call(syntaxes, syntaxDict) ? syntaxes[syntaxDict][state.name] : null;
        if (!dictSyntax || !dictSyntax.match) {
          throw new Error("Bad syntax reference: " + (state.type === "Type" ? "<" + state.name + ">" : "<'" + state.name + "'>"));
        }
        if (syntaxStash !== false && token !== null && state.type === "Type") {
          const lowPriorityMatching = state.name === "custom-ident" && token.type === Ident || state.name === "length" && token.value === "0";
          if (lowPriorityMatching) {
            if (syntaxStash === null) {
              syntaxStash = stateSnapshotFromSyntax(state, elseStack);
            }
            state = MISMATCH;
            break;
          }
        }
        openSyntax();
        state = dictSyntax.match;
        break;
      }
      case "Keyword": {
        const name2 = state.name;
        if (token !== null) {
          let keywordName = token.value;
          if (keywordName.indexOf("\\") !== -1) {
            keywordName = keywordName.replace(/\\[09].*$/, "");
          }
          if (areStringsEqualCaseInsensitive(keywordName, name2)) {
            addTokenToMatch();
            state = MATCH;
            break;
          }
        }
        state = MISMATCH;
        break;
      }
      case "AtKeyword":
      case "Function":
        if (token !== null && areStringsEqualCaseInsensitive(token.value, state.name)) {
          addTokenToMatch();
          state = MATCH;
          break;
        }
        state = MISMATCH;
        break;
      case "Token":
        if (token !== null && token.value === state.value) {
          addTokenToMatch();
          state = MATCH;
          break;
        }
        state = MISMATCH;
        break;
      case "Comma":
        if (token !== null && token.type === Comma) {
          if (isCommaContextStart(matchStack.token)) {
            state = MISMATCH;
          } else {
            addTokenToMatch();
            state = isCommaContextEnd(token) ? MISMATCH : MATCH;
          }
        } else {
          state = isCommaContextStart(matchStack.token) || isCommaContextEnd(token) ? MATCH : MISMATCH;
        }
        break;
      case "String":
        let string3 = "";
        let lastTokenIndex = tokenIndex;
        for (; lastTokenIndex < tokens.length && string3.length < state.value.length; lastTokenIndex++) {
          string3 += tokens[lastTokenIndex].value;
        }
        if (areStringsEqualCaseInsensitive(string3, state.value)) {
          while (tokenIndex < lastTokenIndex) {
            addTokenToMatch();
          }
          state = MATCH;
        } else {
          state = MISMATCH;
        }
        break;
      default:
        throw new Error("Unknown node type: " + state.type);
    }
  }
  switch (exitReason) {
    case null:
      console.warn("[csstree-match] BREAK after " + ITERATION_LIMIT + " iterations");
      exitReason = EXIT_REASON_ITERATION_LIMIT;
      matchStack = null;
      break;
    case EXIT_REASON_MATCH:
      while (syntaxStack !== null) {
        closeSyntax();
      }
      break;
    default:
      matchStack = null;
  }
  return {
    tokens,
    reason: exitReason,
    iterations: iterationCount,
    match: matchStack,
    longestMatch
  };
}
function matchAsTree(tokens, matchGraph, syntaxes) {
  const matchResult = internalMatch(tokens, matchGraph, syntaxes || {});
  if (matchResult.match === null) {
    return matchResult;
  }
  let item = matchResult.match;
  let host = matchResult.match = {
    syntax: matchGraph.syntax || null,
    match: []
  };
  const hostStack = [host];
  item = reverseList(item).prev;
  while (item !== null) {
    switch (item.type) {
      case OPEN_SYNTAX:
        host.match.push(host = {
          syntax: item.syntax,
          match: []
        });
        hostStack.push(host);
        break;
      case CLOSE_SYNTAX:
        hostStack.pop();
        host = hostStack[hostStack.length - 1];
        break;
      default:
        host.match.push({
          syntax: item.syntax || null,
          token: item.token.value,
          node: item.token.node
        });
    }
    item = item.prev;
  }
  return matchResult;
}
function getTrace(node2) {
  function shouldPutToTrace(syntax2) {
    if (syntax2 === null) {
      return false;
    }
    return syntax2.type === "Type" || syntax2.type === "Property" || syntax2.type === "Keyword";
  }
  function hasMatch(matchNode) {
    if (Array.isArray(matchNode.match)) {
      for (let i2 = 0; i2 < matchNode.match.length; i2++) {
        if (hasMatch(matchNode.match[i2])) {
          if (shouldPutToTrace(matchNode.syntax)) {
            result2.unshift(matchNode.syntax);
          }
          return true;
        }
      }
    } else if (matchNode.node === node2) {
      result2 = shouldPutToTrace(matchNode.syntax) ? [matchNode.syntax] : [];
      return true;
    }
    return false;
  }
  let result2 = null;
  if (this.matched !== null) {
    hasMatch(this.matched);
  }
  return result2;
}
function isType(node2, type4) {
  return testNode(this, node2, (match2) => match2.type === "Type" && match2.name === type4);
}
function isProperty(node2, property2) {
  return testNode(this, node2, (match2) => match2.type === "Property" && match2.name === property2);
}
function isKeyword(node2) {
  return testNode(this, node2, (match2) => match2.type === "Keyword");
}
function testNode(match2, node2, fn2) {
  const trace2 = getTrace.call(match2, node2);
  if (trace2 === null) {
    return false;
  }
  return trace2.some(fn2);
}
var trace = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getTrace,
  isType,
  isProperty,
  isKeyword
}, Symbol.toStringTag, { value: "Module" }));
function getFirstMatchNode(matchNode) {
  if ("node" in matchNode) {
    return matchNode.node;
  }
  return getFirstMatchNode(matchNode.match[0]);
}
function getLastMatchNode(matchNode) {
  if ("node" in matchNode) {
    return matchNode.node;
  }
  return getLastMatchNode(matchNode.match[matchNode.match.length - 1]);
}
function matchFragments(lexer2, ast, match2, type4, name2) {
  function findFragments(matchNode) {
    if (matchNode.syntax !== null && matchNode.syntax.type === type4 && matchNode.syntax.name === name2) {
      const start = getFirstMatchNode(matchNode);
      const end = getLastMatchNode(matchNode);
      lexer2.syntax.walk(ast, function(node2, item, list) {
        if (node2 === start) {
          const nodes = new List();
          do {
            nodes.appendData(item.data);
            if (item.data === end) {
              break;
            }
            item = item.next;
          } while (item !== null);
          fragments.push({
            parent: list,
            nodes
          });
        }
      });
    }
    if (Array.isArray(matchNode.match)) {
      matchNode.match.forEach(findFragments);
    }
  }
  const fragments = [];
  if (match2.matched !== null) {
    findFragments(match2.matched);
  }
  return fragments;
}
const { hasOwnProperty: hasOwnProperty$1 } = Object.prototype;
function isValidNumber$1(value2) {
  return typeof value2 === "number" && isFinite(value2) && Math.floor(value2) === value2 && value2 >= 0;
}
function isValidLocation(loc) {
  return Boolean(loc) && isValidNumber$1(loc.offset) && isValidNumber$1(loc.line) && isValidNumber$1(loc.column);
}
function createNodeStructureChecker(type4, fields) {
  return function checkNode(node2, warn2) {
    if (!node2 || node2.constructor !== Object) {
      return warn2(node2, "Type of node should be an Object");
    }
    for (let key in node2) {
      let valid = true;
      if (hasOwnProperty$1.call(node2, key) === false) {
        continue;
      }
      if (key === "type") {
        if (node2.type !== type4) {
          warn2(node2, "Wrong node type `" + node2.type + "`, expected `" + type4 + "`");
        }
      } else if (key === "loc") {
        if (node2.loc === null) {
          continue;
        } else if (node2.loc && node2.loc.constructor === Object) {
          if (typeof node2.loc.source !== "string") {
            key += ".source";
          } else if (!isValidLocation(node2.loc.start)) {
            key += ".start";
          } else if (!isValidLocation(node2.loc.end)) {
            key += ".end";
          } else {
            continue;
          }
        }
        valid = false;
      } else if (fields.hasOwnProperty(key)) {
        valid = false;
        for (let i2 = 0; !valid && i2 < fields[key].length; i2++) {
          const fieldType = fields[key][i2];
          switch (fieldType) {
            case String:
              valid = typeof node2[key] === "string";
              break;
            case Boolean:
              valid = typeof node2[key] === "boolean";
              break;
            case null:
              valid = node2[key] === null;
              break;
            default:
              if (typeof fieldType === "string") {
                valid = node2[key] && node2[key].type === fieldType;
              } else if (Array.isArray(fieldType)) {
                valid = node2[key] instanceof List;
              }
          }
        }
      } else {
        warn2(node2, "Unknown field `" + key + "` for " + type4 + " node type");
      }
      if (!valid) {
        warn2(node2, "Bad value for `" + type4 + "." + key + "`");
      }
    }
    for (const key in fields) {
      if (hasOwnProperty$1.call(fields, key) && hasOwnProperty$1.call(node2, key) === false) {
        warn2(node2, "Field `" + type4 + "." + key + "` is missed");
      }
    }
  };
}
function processStructure(name2, nodeType) {
  const structure2 = nodeType.structure;
  const fields = {
    type: String,
    loc: true
  };
  const docs = {
    type: '"' + name2 + '"'
  };
  for (const key in structure2) {
    if (hasOwnProperty$1.call(structure2, key) === false) {
      continue;
    }
    const docsTypes = [];
    const fieldTypes = fields[key] = Array.isArray(structure2[key]) ? structure2[key].slice() : [structure2[key]];
    for (let i2 = 0; i2 < fieldTypes.length; i2++) {
      const fieldType = fieldTypes[i2];
      if (fieldType === String || fieldType === Boolean) {
        docsTypes.push(fieldType.name);
      } else if (fieldType === null) {
        docsTypes.push("null");
      } else if (typeof fieldType === "string") {
        docsTypes.push("<" + fieldType + ">");
      } else if (Array.isArray(fieldType)) {
        docsTypes.push("List");
      } else {
        throw new Error("Wrong value `" + fieldType + "` in `" + name2 + "." + key + "` structure definition");
      }
    }
    docs[key] = docsTypes.join(" | ");
  }
  return {
    docs,
    check: createNodeStructureChecker(name2, fields)
  };
}
function getStructureFromConfig(config2) {
  const structure2 = {};
  if (config2.node) {
    for (const name2 in config2.node) {
      if (hasOwnProperty$1.call(config2.node, name2)) {
        const nodeType = config2.node[name2];
        if (nodeType.structure) {
          structure2[name2] = processStructure(name2, nodeType);
        } else {
          throw new Error("Missed `structure` field in `" + name2 + "` node type definition");
        }
      }
    }
  }
  return structure2;
}
const cssWideKeywordsSyntax = buildMatchGraph(cssWideKeywords.join(" | "));
function dumpMapSyntax(map2, compact, syntaxAsAst) {
  const result2 = {};
  for (const name2 in map2) {
    if (map2[name2].syntax) {
      result2[name2] = syntaxAsAst ? map2[name2].syntax : generate$G(map2[name2].syntax, { compact });
    }
  }
  return result2;
}
function dumpAtruleMapSyntax(map2, compact, syntaxAsAst) {
  const result2 = {};
  for (const [name2, atrule2] of Object.entries(map2)) {
    result2[name2] = {
      prelude: atrule2.prelude && (syntaxAsAst ? atrule2.prelude.syntax : generate$G(atrule2.prelude.syntax, { compact })),
      descriptors: atrule2.descriptors && dumpMapSyntax(atrule2.descriptors, compact, syntaxAsAst)
    };
  }
  return result2;
}
function valueHasVar(tokens) {
  for (let i2 = 0; i2 < tokens.length; i2++) {
    if (tokens[i2].value.toLowerCase() === "var(") {
      return true;
    }
  }
  return false;
}
function buildMatchResult(matched, error, iterations) {
  return __spreadValues({
    matched,
    iterations,
    error
  }, trace);
}
function matchSyntax(lexer2, syntax2, value2, useCssWideKeywords) {
  const tokens = prepareTokens(value2, lexer2.syntax);
  let result2;
  if (valueHasVar(tokens)) {
    return buildMatchResult(null, new Error("Matching for a tree with var() is not supported"));
  }
  if (useCssWideKeywords) {
    result2 = matchAsTree(tokens, lexer2.cssWideKeywordsSyntax, lexer2);
  }
  if (!useCssWideKeywords || !result2.match) {
    result2 = matchAsTree(tokens, syntax2.match, lexer2);
    if (!result2.match) {
      return buildMatchResult(null, new SyntaxMatchError(result2.reason, syntax2.syntax, value2, result2), result2.iterations);
    }
  }
  return buildMatchResult(result2.match, null, result2.iterations);
}
class Lexer {
  constructor(config2, syntax2, structure2) {
    this.cssWideKeywordsSyntax = cssWideKeywordsSyntax;
    this.syntax = syntax2;
    this.generic = false;
    this.units = __spreadValues({}, units);
    this.atrules = Object.create(null);
    this.properties = Object.create(null);
    this.types = Object.create(null);
    this.structure = structure2 || getStructureFromConfig(config2);
    if (config2) {
      if (config2.units) {
        for (const group of Object.keys(units)) {
          if (Array.isArray(config2.units[group])) {
            this.units[group] = config2.units[group];
          }
        }
      }
      if (config2.types) {
        for (const name2 in config2.types) {
          this.addType_(name2, config2.types[name2]);
        }
      }
      if (config2.generic) {
        this.generic = true;
        for (const [name2, value2] of Object.entries(createGenericTypes(this.units))) {
          this.addType_(name2, value2);
        }
      }
      if (config2.atrules) {
        for (const name2 in config2.atrules) {
          this.addAtrule_(name2, config2.atrules[name2]);
        }
      }
      if (config2.properties) {
        for (const name2 in config2.properties) {
          this.addProperty_(name2, config2.properties[name2]);
        }
      }
    }
  }
  checkStructure(ast) {
    function collectWarning(node2, message) {
      warns.push({ node: node2, message });
    }
    const structure2 = this.structure;
    const warns = [];
    this.syntax.walk(ast, function(node2) {
      if (structure2.hasOwnProperty(node2.type)) {
        structure2[node2.type].check(node2, collectWarning);
      } else {
        collectWarning(node2, "Unknown node type `" + node2.type + "`");
      }
    });
    return warns.length ? warns : false;
  }
  createDescriptor(syntax2, type4, name2, parent = null) {
    const ref2 = {
      type: type4,
      name: name2
    };
    const descriptor = {
      type: type4,
      name: name2,
      parent,
      serializable: typeof syntax2 === "string" || syntax2 && typeof syntax2.type === "string",
      syntax: null,
      match: null
    };
    if (typeof syntax2 === "function") {
      descriptor.match = buildMatchGraph(syntax2, ref2);
    } else {
      if (typeof syntax2 === "string") {
        Object.defineProperty(descriptor, "syntax", {
          get() {
            Object.defineProperty(descriptor, "syntax", {
              value: parse$H(syntax2)
            });
            return descriptor.syntax;
          }
        });
      } else {
        descriptor.syntax = syntax2;
      }
      Object.defineProperty(descriptor, "match", {
        get() {
          Object.defineProperty(descriptor, "match", {
            value: buildMatchGraph(descriptor.syntax, ref2)
          });
          return descriptor.match;
        }
      });
    }
    return descriptor;
  }
  addAtrule_(name2, syntax2) {
    if (!syntax2) {
      return;
    }
    this.atrules[name2] = {
      type: "Atrule",
      name: name2,
      prelude: syntax2.prelude ? this.createDescriptor(syntax2.prelude, "AtrulePrelude", name2) : null,
      descriptors: syntax2.descriptors ? Object.keys(syntax2.descriptors).reduce((map2, descName) => {
        map2[descName] = this.createDescriptor(syntax2.descriptors[descName], "AtruleDescriptor", descName, name2);
        return map2;
      }, Object.create(null)) : null
    };
  }
  addProperty_(name2, syntax2) {
    if (!syntax2) {
      return;
    }
    this.properties[name2] = this.createDescriptor(syntax2, "Property", name2);
  }
  addType_(name2, syntax2) {
    if (!syntax2) {
      return;
    }
    this.types[name2] = this.createDescriptor(syntax2, "Type", name2);
  }
  checkAtruleName(atruleName) {
    if (!this.getAtrule(atruleName)) {
      return new SyntaxReferenceError("Unknown at-rule", "@" + atruleName);
    }
  }
  checkAtrulePrelude(atruleName, prelude) {
    const error = this.checkAtruleName(atruleName);
    if (error) {
      return error;
    }
    const atrule2 = this.getAtrule(atruleName);
    if (!atrule2.prelude && prelude) {
      return new SyntaxError("At-rule `@" + atruleName + "` should not contain a prelude");
    }
    if (atrule2.prelude && !prelude) {
      if (!matchSyntax(this, atrule2.prelude, "", false).matched) {
        return new SyntaxError("At-rule `@" + atruleName + "` should contain a prelude");
      }
    }
  }
  checkAtruleDescriptorName(atruleName, descriptorName) {
    const error = this.checkAtruleName(atruleName);
    if (error) {
      return error;
    }
    const atrule2 = this.getAtrule(atruleName);
    const descriptor = keyword$1(descriptorName);
    if (!atrule2.descriptors) {
      return new SyntaxError("At-rule `@" + atruleName + "` has no known descriptors");
    }
    if (!atrule2.descriptors[descriptor.name] && !atrule2.descriptors[descriptor.basename]) {
      return new SyntaxReferenceError("Unknown at-rule descriptor", descriptorName);
    }
  }
  checkPropertyName(propertyName2) {
    if (!this.getProperty(propertyName2)) {
      return new SyntaxReferenceError("Unknown property", propertyName2);
    }
  }
  matchAtrulePrelude(atruleName, prelude) {
    const error = this.checkAtrulePrelude(atruleName, prelude);
    if (error) {
      return buildMatchResult(null, error);
    }
    const atrule2 = this.getAtrule(atruleName);
    if (!atrule2.prelude) {
      return buildMatchResult(null, null);
    }
    return matchSyntax(this, atrule2.prelude, prelude || "", false);
  }
  matchAtruleDescriptor(atruleName, descriptorName, value2) {
    const error = this.checkAtruleDescriptorName(atruleName, descriptorName);
    if (error) {
      return buildMatchResult(null, error);
    }
    const atrule2 = this.getAtrule(atruleName);
    const descriptor = keyword$1(descriptorName);
    return matchSyntax(this, atrule2.descriptors[descriptor.name] || atrule2.descriptors[descriptor.basename], value2, false);
  }
  matchDeclaration(node2) {
    if (node2.type !== "Declaration") {
      return buildMatchResult(null, new Error("Not a Declaration node"));
    }
    return this.matchProperty(node2.property, node2.value);
  }
  matchProperty(propertyName2, value2) {
    if (property(propertyName2).custom) {
      return buildMatchResult(null, new Error("Lexer matching doesn't applicable for custom properties"));
    }
    const error = this.checkPropertyName(propertyName2);
    if (error) {
      return buildMatchResult(null, error);
    }
    return matchSyntax(this, this.getProperty(propertyName2), value2, true);
  }
  matchType(typeName2, value2) {
    const typeSyntax = this.getType(typeName2);
    if (!typeSyntax) {
      return buildMatchResult(null, new SyntaxReferenceError("Unknown type", typeName2));
    }
    return matchSyntax(this, typeSyntax, value2, false);
  }
  match(syntax2, value2) {
    if (typeof syntax2 !== "string" && (!syntax2 || !syntax2.type)) {
      return buildMatchResult(null, new SyntaxReferenceError("Bad syntax"));
    }
    if (typeof syntax2 === "string" || !syntax2.match) {
      syntax2 = this.createDescriptor(syntax2, "Type", "anonymous");
    }
    return matchSyntax(this, syntax2, value2, false);
  }
  findValueFragments(propertyName2, value2, type4, name2) {
    return matchFragments(this, value2, this.matchProperty(propertyName2, value2), type4, name2);
  }
  findDeclarationValueFragments(declaration, type4, name2) {
    return matchFragments(this, declaration.value, this.matchDeclaration(declaration), type4, name2);
  }
  findAllFragments(ast, type4, name2) {
    const result2 = [];
    this.syntax.walk(ast, {
      visit: "Declaration",
      enter: (declaration) => {
        result2.push.apply(result2, this.findDeclarationValueFragments(declaration, type4, name2));
      }
    });
    return result2;
  }
  getAtrule(atruleName, fallbackBasename = true) {
    const atrule2 = keyword$1(atruleName);
    const atruleEntry = atrule2.vendor && fallbackBasename ? this.atrules[atrule2.name] || this.atrules[atrule2.basename] : this.atrules[atrule2.name];
    return atruleEntry || null;
  }
  getAtrulePrelude(atruleName, fallbackBasename = true) {
    const atrule2 = this.getAtrule(atruleName, fallbackBasename);
    return atrule2 && atrule2.prelude || null;
  }
  getAtruleDescriptor(atruleName, name2) {
    return this.atrules.hasOwnProperty(atruleName) && this.atrules.declarators ? this.atrules[atruleName].declarators[name2] || null : null;
  }
  getProperty(propertyName2, fallbackBasename = true) {
    const property$12 = property(propertyName2);
    const propertyEntry = property$12.vendor && fallbackBasename ? this.properties[property$12.name] || this.properties[property$12.basename] : this.properties[property$12.name];
    return propertyEntry || null;
  }
  getType(name2) {
    return hasOwnProperty.call(this.types, name2) ? this.types[name2] : null;
  }
  validate() {
    function validate2(syntax2, name2, broken, descriptor) {
      if (broken.has(name2)) {
        return broken.get(name2);
      }
      broken.set(name2, false);
      if (descriptor.syntax !== null) {
        walk$1(descriptor.syntax, function(node2) {
          if (node2.type !== "Type" && node2.type !== "Property") {
            return;
          }
          const map2 = node2.type === "Type" ? syntax2.types : syntax2.properties;
          const brokenMap = node2.type === "Type" ? brokenTypes : brokenProperties;
          if (!hasOwnProperty.call(map2, node2.name) || validate2(syntax2, node2.name, brokenMap, map2[node2.name])) {
            broken.set(name2, true);
          }
        }, this);
      }
    }
    let brokenTypes = new Map();
    let brokenProperties = new Map();
    for (const key in this.types) {
      validate2(this, key, brokenTypes, this.types[key]);
    }
    for (const key in this.properties) {
      validate2(this, key, brokenProperties, this.properties[key]);
    }
    brokenTypes = [...brokenTypes.keys()].filter((name2) => brokenTypes.get(name2));
    brokenProperties = [...brokenProperties.keys()].filter((name2) => brokenProperties.get(name2));
    if (brokenTypes.length || brokenProperties.length) {
      return {
        types: brokenTypes,
        properties: brokenProperties
      };
    }
    return null;
  }
  dump(syntaxAsAst, pretty) {
    return {
      generic: this.generic,
      units: this.units,
      types: dumpMapSyntax(this.types, !pretty, syntaxAsAst),
      properties: dumpMapSyntax(this.properties, !pretty, syntaxAsAst),
      atrules: dumpAtruleMapSyntax(this.atrules, !pretty, syntaxAsAst)
    };
  }
  toString() {
    return JSON.stringify(this.dump());
  }
}
function appendOrSet(a2, b2) {
  if (typeof b2 === "string" && /^\s*\|/.test(b2)) {
    return typeof a2 === "string" ? a2 + b2 : b2.replace(/^\s*\|\s*/, "");
  }
  return b2 || null;
}
function sliceProps(obj, props) {
  const result2 = Object.create(null);
  for (const [key, value2] of Object.entries(obj)) {
    if (value2) {
      result2[key] = {};
      for (const prop of Object.keys(value2)) {
        if (props.includes(prop)) {
          result2[key][prop] = value2[prop];
        }
      }
    }
  }
  return result2;
}
function mix(dest, src) {
  const result2 = __spreadValues({}, dest);
  for (const [prop, value2] of Object.entries(src)) {
    switch (prop) {
      case "generic":
        result2[prop] = Boolean(value2);
        break;
      case "units":
        result2[prop] = __spreadValues({}, dest[prop]);
        for (const [name2, patch] of Object.entries(value2)) {
          result2[prop][name2] = Array.isArray(patch) ? patch : [];
        }
        break;
      case "atrules":
        result2[prop] = __spreadValues({}, dest[prop]);
        for (const [name2, atrule2] of Object.entries(value2)) {
          const exists2 = result2[prop][name2] || {};
          const current = result2[prop][name2] = {
            prelude: exists2.prelude || null,
            descriptors: __spreadValues({}, exists2.descriptors)
          };
          if (!atrule2) {
            continue;
          }
          current.prelude = atrule2.prelude ? appendOrSet(current.prelude, atrule2.prelude) : current.prelude || null;
          for (const [descriptorName, descriptorValue] of Object.entries(atrule2.descriptors || {})) {
            current.descriptors[descriptorName] = descriptorValue ? appendOrSet(current.descriptors[descriptorName], descriptorValue) : null;
          }
          if (!Object.keys(current.descriptors).length) {
            current.descriptors = null;
          }
        }
        break;
      case "types":
      case "properties":
        result2[prop] = __spreadValues({}, dest[prop]);
        for (const [name2, syntax2] of Object.entries(value2)) {
          result2[prop][name2] = appendOrSet(result2[prop][name2], syntax2);
        }
        break;
      case "scope":
        result2[prop] = __spreadValues({}, dest[prop]);
        for (const [name2, props] of Object.entries(value2)) {
          result2[prop][name2] = __spreadValues(__spreadValues({}, result2[prop][name2]), props);
        }
        break;
      case "parseContext":
        result2[prop] = __spreadValues(__spreadValues({}, dest[prop]), value2);
        break;
      case "atrule":
      case "pseudo":
        result2[prop] = __spreadValues(__spreadValues({}, dest[prop]), sliceProps(value2, ["parse"]));
        break;
      case "node":
        result2[prop] = __spreadValues(__spreadValues({}, dest[prop]), sliceProps(value2, ["name", "structure", "parse", "generate", "walkContext"]));
        break;
    }
  }
  return result2;
}
function createSyntax(config2) {
  const parse2 = createParser(config2);
  const walk2 = createWalker(config2);
  const generate2 = createGenerator(config2);
  const { fromPlainObject: fromPlainObject2, toPlainObject: toPlainObject2 } = createConvertor(walk2);
  const syntax2 = {
    lexer: null,
    createLexer: (config3) => new Lexer(config3, syntax2, syntax2.lexer.structure),
    tokenize: tokenize$1,
    parse: parse2,
    generate: generate2,
    walk: walk2,
    find: walk2.find,
    findLast: walk2.findLast,
    findAll: walk2.findAll,
    fromPlainObject: fromPlainObject2,
    toPlainObject: toPlainObject2,
    fork(extension) {
      const base2 = mix({}, config2);
      return createSyntax(typeof extension === "function" ? extension(base2, Object.assign) : mix(base2, extension));
    }
  };
  syntax2.lexer = new Lexer({
    generic: true,
    units: config2.units,
    types: config2.types,
    atrules: config2.atrules,
    properties: config2.properties,
    node: config2.node
  }, syntax2);
  return syntax2;
}
var createSyntax$1 = (config2) => createSyntax(mix({}, config2));
var definitions = {
  "generic": true,
  "units": {
    "angle": [
      "deg",
      "grad",
      "rad",
      "turn"
    ],
    "decibel": [
      "db"
    ],
    "flex": [
      "fr"
    ],
    "frequency": [
      "hz",
      "khz"
    ],
    "length": [
      "cm",
      "mm",
      "q",
      "in",
      "pt",
      "pc",
      "px",
      "em",
      "rem",
      "ex",
      "rex",
      "cap",
      "rcap",
      "ch",
      "rch",
      "ic",
      "ric",
      "lh",
      "rlh",
      "vw",
      "svw",
      "lvw",
      "dvw",
      "vh",
      "svh",
      "lvh",
      "dvh",
      "vi",
      "svi",
      "lvi",
      "dvi",
      "vb",
      "svb",
      "lvb",
      "dvb",
      "vmin",
      "svmin",
      "lvmin",
      "dvmin",
      "vmax",
      "svmax",
      "lvmax",
      "dvmax",
      "cqw",
      "cqh",
      "cqi",
      "cqb",
      "cqmin",
      "cqmax"
    ],
    "resolution": [
      "dpi",
      "dpcm",
      "dppx",
      "x"
    ],
    "semitones": [
      "st"
    ],
    "time": [
      "s",
      "ms"
    ]
  },
  "types": {
    "abs()": "abs( <calc-sum> )",
    "absolute-size": "xx-small|x-small|small|medium|large|x-large|xx-large|xxx-large",
    "acos()": "acos( <calc-sum> )",
    "alpha-value": "<number>|<percentage>",
    "angle-percentage": "<angle>|<percentage>",
    "angular-color-hint": "<angle-percentage>",
    "angular-color-stop": "<color>&&<color-stop-angle>?",
    "angular-color-stop-list": "[<angular-color-stop> [, <angular-color-hint>]?]# , <angular-color-stop>",
    "animateable-feature": "scroll-position|contents|<custom-ident>",
    "asin()": "asin( <calc-sum> )",
    "atan()": "atan( <calc-sum> )",
    "atan2()": "atan2( <calc-sum> , <calc-sum> )",
    "attachment": "scroll|fixed|local",
    "attr()": "attr( <attr-name> <type-or-unit>? [, <attr-fallback>]? )",
    "attr-matcher": "['~'|'|'|'^'|'$'|'*']? '='",
    "attr-modifier": "i|s",
    "attribute-selector": "'[' <wq-name> ']'|'[' <wq-name> <attr-matcher> [<string-token>|<ident-token>] <attr-modifier>? ']'",
    "auto-repeat": "repeat( [auto-fill|auto-fit] , [<line-names>? <fixed-size>]+ <line-names>? )",
    "auto-track-list": "[<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>? <auto-repeat> [<line-names>? [<fixed-size>|<fixed-repeat>]]* <line-names>?",
    "axis": "block|inline|vertical|horizontal",
    "baseline-position": "[first|last]? baseline",
    "basic-shape": "<inset()>|<circle()>|<ellipse()>|<polygon()>|<path()>",
    "bg-image": "none|<image>",
    "bg-layer": "<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
    "bg-position": "[[left|center|right|top|bottom|<length-percentage>]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]|[center|[left|right] <length-percentage>?]&&[center|[top|bottom] <length-percentage>?]]",
    "bg-size": "[<length-percentage>|auto]{1,2}|cover|contain",
    "blur()": "blur( <length> )",
    "blend-mode": "normal|multiply|screen|overlay|darken|lighten|color-dodge|color-burn|hard-light|soft-light|difference|exclusion|hue|saturation|color|luminosity",
    "box": "border-box|padding-box|content-box",
    "brightness()": "brightness( <number-percentage> )",
    "calc()": "calc( <calc-sum> )",
    "calc-sum": "<calc-product> [['+'|'-'] <calc-product>]*",
    "calc-product": "<calc-value> ['*' <calc-value>|'/' <number>]*",
    "calc-value": "<number>|<dimension>|<percentage>|<calc-constant>|( <calc-sum> )",
    "calc-constant": "e|pi|infinity|-infinity|NaN",
    "cf-final-image": "<image>|<color>",
    "cf-mixing-image": "<percentage>?&&<image>",
    "circle()": "circle( [<shape-radius>]? [at <position>]? )",
    "clamp()": "clamp( <calc-sum>#{3} )",
    "class-selector": "'.' <ident-token>",
    "clip-source": "<url>",
    "color": "<rgb()>|<rgba()>|<hsl()>|<hsla()>|<hwb()>|<lab()>|<lch()>|<hex-color>|<named-color>|currentcolor|<deprecated-system-color>",
    "color-stop": "<color-stop-length>|<color-stop-angle>",
    "color-stop-angle": "<angle-percentage>{1,2}",
    "color-stop-length": "<length-percentage>{1,2}",
    "color-stop-list": "[<linear-color-stop> [, <linear-color-hint>]?]# , <linear-color-stop>",
    "combinator": "'>'|'+'|'~'|['||']",
    "common-lig-values": "[common-ligatures|no-common-ligatures]",
    "compat-auto": "searchfield|textarea|push-button|slider-horizontal|checkbox|radio|square-button|menulist|listbox|meter|progress-bar|button",
    "composite-style": "clear|copy|source-over|source-in|source-out|source-atop|destination-over|destination-in|destination-out|destination-atop|xor",
    "compositing-operator": "add|subtract|intersect|exclude",
    "compound-selector": "[<type-selector>? <subclass-selector>* [<pseudo-element-selector> <pseudo-class-selector>*]*]!",
    "compound-selector-list": "<compound-selector>#",
    "complex-selector": "<compound-selector> [<combinator>? <compound-selector>]*",
    "complex-selector-list": "<complex-selector>#",
    "conic-gradient()": "conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
    "contextual-alt-values": "[contextual|no-contextual]",
    "content-distribution": "space-between|space-around|space-evenly|stretch",
    "content-list": "[<string>|contents|<image>|<counter>|<quote>|<target>|<leader()>|<attr()>]+",
    "content-position": "center|start|end|flex-start|flex-end",
    "content-replacement": "<image>",
    "contrast()": "contrast( [<number-percentage>] )",
    "cos()": "cos( <calc-sum> )",
    "counter": "<counter()>|<counters()>",
    "counter()": "counter( <counter-name> , <counter-style>? )",
    "counter-name": "<custom-ident>",
    "counter-style": "<counter-style-name>|symbols( )",
    "counter-style-name": "<custom-ident>",
    "counters()": "counters( <counter-name> , <string> , <counter-style>? )",
    "cross-fade()": "cross-fade( <cf-mixing-image> , <cf-final-image>? )",
    "cubic-bezier-timing-function": "ease|ease-in|ease-out|ease-in-out|cubic-bezier( <number [0,1]> , <number> , <number [0,1]> , <number> )",
    "deprecated-system-color": "ActiveBorder|ActiveCaption|AppWorkspace|Background|ButtonFace|ButtonHighlight|ButtonShadow|ButtonText|CaptionText|GrayText|Highlight|HighlightText|InactiveBorder|InactiveCaption|InactiveCaptionText|InfoBackground|InfoText|Menu|MenuText|Scrollbar|ThreeDDarkShadow|ThreeDFace|ThreeDHighlight|ThreeDLightShadow|ThreeDShadow|Window|WindowFrame|WindowText",
    "discretionary-lig-values": "[discretionary-ligatures|no-discretionary-ligatures]",
    "display-box": "contents|none",
    "display-inside": "flow|flow-root|table|flex|grid|ruby",
    "display-internal": "table-row-group|table-header-group|table-footer-group|table-row|table-cell|table-column-group|table-column|table-caption|ruby-base|ruby-text|ruby-base-container|ruby-text-container",
    "display-legacy": "inline-block|inline-list-item|inline-table|inline-flex|inline-grid",
    "display-listitem": "<display-outside>?&&[flow|flow-root]?&&list-item",
    "display-outside": "block|inline|run-in",
    "drop-shadow()": "drop-shadow( <length>{2,3} <color>? )",
    "east-asian-variant-values": "[jis78|jis83|jis90|jis04|simplified|traditional]",
    "east-asian-width-values": "[full-width|proportional-width]",
    "element()": "element( <custom-ident> , [first|start|last|first-except]? )|element( <id-selector> )",
    "ellipse()": "ellipse( [<shape-radius>{2}]? [at <position>]? )",
    "ending-shape": "circle|ellipse",
    "env()": "env( <custom-ident> , <declaration-value>? )",
    "exp()": "exp( <calc-sum> )",
    "explicit-track-list": "[<line-names>? <track-size>]+ <line-names>?",
    "family-name": "<string>|<custom-ident>+",
    "feature-tag-value": "<string> [<integer>|on|off]?",
    "feature-type": "@stylistic|@historical-forms|@styleset|@character-variant|@swash|@ornaments|@annotation",
    "feature-value-block": "<feature-type> '{' <feature-value-declaration-list> '}'",
    "feature-value-block-list": "<feature-value-block>+",
    "feature-value-declaration": "<custom-ident> : <integer>+ ;",
    "feature-value-declaration-list": "<feature-value-declaration>",
    "feature-value-name": "<custom-ident>",
    "fill-rule": "nonzero|evenodd",
    "filter-function": "<blur()>|<brightness()>|<contrast()>|<drop-shadow()>|<grayscale()>|<hue-rotate()>|<invert()>|<opacity()>|<saturate()>|<sepia()>",
    "filter-function-list": "[<filter-function>|<url>]+",
    "final-bg-layer": "<'background-color'>||<bg-image>||<bg-position> [/ <bg-size>]?||<repeat-style>||<attachment>||<box>||<box>",
    "fixed-breadth": "<length-percentage>",
    "fixed-repeat": "repeat( [<integer [1,\u221E]>] , [<line-names>? <fixed-size>]+ <line-names>? )",
    "fixed-size": "<fixed-breadth>|minmax( <fixed-breadth> , <track-breadth> )|minmax( <inflexible-breadth> , <fixed-breadth> )",
    "font-stretch-absolute": "normal|ultra-condensed|extra-condensed|condensed|semi-condensed|semi-expanded|expanded|extra-expanded|ultra-expanded|<percentage>",
    "font-variant-css21": "[normal|small-caps]",
    "font-weight-absolute": "normal|bold|<number [1,1000]>",
    "frequency-percentage": "<frequency>|<percentage>",
    "general-enclosed": "[<function-token> <any-value> )]|( <ident> <any-value> )",
    "generic-family": "serif|sans-serif|cursive|fantasy|monospace|-apple-system",
    "generic-name": "serif|sans-serif|cursive|fantasy|monospace",
    "geometry-box": "<shape-box>|fill-box|stroke-box|view-box",
    "gradient": "<linear-gradient()>|<repeating-linear-gradient()>|<radial-gradient()>|<repeating-radial-gradient()>|<conic-gradient()>|<repeating-conic-gradient()>|<-legacy-gradient>",
    "grayscale()": "grayscale( <number-percentage> )",
    "grid-line": "auto|<custom-ident>|[<integer>&&<custom-ident>?]|[span&&[<integer>||<custom-ident>]]",
    "historical-lig-values": "[historical-ligatures|no-historical-ligatures]",
    "hsl()": "hsl( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsl( <hue> , <percentage> , <percentage> , <alpha-value>? )",
    "hsla()": "hsla( <hue> <percentage> <percentage> [/ <alpha-value>]? )|hsla( <hue> , <percentage> , <percentage> , <alpha-value>? )",
    "hue": "<number>|<angle>",
    "hue-rotate()": "hue-rotate( <angle> )",
    "hwb()": "hwb( [<hue>|none] [<percentage>|none] [<percentage>|none] [/ [<alpha-value>|none]]? )",
    "hypot()": "hypot( <calc-sum># )",
    "image": "<url>|<image()>|<image-set()>|<element()>|<paint()>|<cross-fade()>|<gradient>",
    "image()": "image( <image-tags>? [<image-src>? , <color>?]! )",
    "image-set()": "image-set( <image-set-option># )",
    "image-set-option": "[<image>|<string>] [<resolution>||type( <string> )]",
    "image-src": "<url>|<string>",
    "image-tags": "ltr|rtl",
    "inflexible-breadth": "<length-percentage>|min-content|max-content|auto",
    "inset()": "inset( <length-percentage>{1,4} [round <'border-radius'>]? )",
    "invert()": "invert( <number-percentage> )",
    "keyframes-name": "<custom-ident>|<string>",
    "keyframe-block": "<keyframe-selector># { <declaration-list> }",
    "keyframe-block-list": "<keyframe-block>+",
    "keyframe-selector": "from|to|<percentage>",
    "lab()": "lab( [<percentage>|<number>|none] [<percentage>|<number>|none] [<percentage>|<number>|none] [/ [<alpha-value>|none]]? )",
    "layer()": "layer( <layer-name> )",
    "layer-name": "<ident> ['.' <ident>]*",
    "lch()": "lch( [<percentage>|<number>|none] [<percentage>|<number>|none] [<hue>|none] [/ [<alpha-value>|none]]? )",
    "leader()": "leader( <leader-type> )",
    "leader-type": "dotted|solid|space|<string>",
    "length-percentage": "<length>|<percentage>",
    "line-names": "'[' <custom-ident>* ']'",
    "line-name-list": "[<line-names>|<name-repeat>]+",
    "line-style": "none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset",
    "line-width": "<length>|thin|medium|thick",
    "linear-color-hint": "<length-percentage>",
    "linear-color-stop": "<color> <color-stop-length>?",
    "linear-gradient()": "linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
    "log()": "log( <calc-sum> , <calc-sum>? )",
    "mask-layer": "<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||<geometry-box>||[<geometry-box>|no-clip]||<compositing-operator>||<masking-mode>",
    "mask-position": "[<length-percentage>|left|center|right] [<length-percentage>|top|center|bottom]?",
    "mask-reference": "none|<image>|<mask-source>",
    "mask-source": "<url>",
    "masking-mode": "alpha|luminance|match-source",
    "matrix()": "matrix( <number>#{6} )",
    "matrix3d()": "matrix3d( <number>#{16} )",
    "max()": "max( <calc-sum># )",
    "media-and": "<media-in-parens> [and <media-in-parens>]+",
    "media-condition": "<media-not>|<media-and>|<media-or>|<media-in-parens>",
    "media-condition-without-or": "<media-not>|<media-and>|<media-in-parens>",
    "media-feature": "( [<mf-plain>|<mf-boolean>|<mf-range>] )",
    "media-in-parens": "( <media-condition> )|<media-feature>|<general-enclosed>",
    "media-not": "not <media-in-parens>",
    "media-or": "<media-in-parens> [or <media-in-parens>]+",
    "media-query": "<media-condition>|[not|only]? <media-type> [and <media-condition-without-or>]?",
    "media-query-list": "<media-query>#",
    "media-type": "<ident>",
    "mf-boolean": "<mf-name>",
    "mf-name": "<ident>",
    "mf-plain": "<mf-name> : <mf-value>",
    "mf-range": "<mf-name> ['<'|'>']? '='? <mf-value>|<mf-value> ['<'|'>']? '='? <mf-name>|<mf-value> '<' '='? <mf-name> '<' '='? <mf-value>|<mf-value> '>' '='? <mf-name> '>' '='? <mf-value>",
    "mf-value": "<number>|<dimension>|<ident>|<ratio>",
    "min()": "min( <calc-sum># )",
    "minmax()": "minmax( [<length-percentage>|min-content|max-content|auto] , [<length-percentage>|<flex>|min-content|max-content|auto] )",
    "mod()": "mod( <calc-sum> , <calc-sum> )",
    "name-repeat": "repeat( [<integer [1,\u221E]>|auto-fill] , <line-names>+ )",
    "named-color": "transparent|aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen|<-non-standard-color>",
    "namespace-prefix": "<ident>",
    "ns-prefix": "[<ident-token>|'*']? '|'",
    "number-percentage": "<number>|<percentage>",
    "numeric-figure-values": "[lining-nums|oldstyle-nums]",
    "numeric-fraction-values": "[diagonal-fractions|stacked-fractions]",
    "numeric-spacing-values": "[proportional-nums|tabular-nums]",
    "nth": "<an-plus-b>|even|odd",
    "opacity()": "opacity( [<number-percentage>] )",
    "overflow-position": "unsafe|safe",
    "outline-radius": "<length>|<percentage>",
    "page-body": "<declaration>? [; <page-body>]?|<page-margin-box> <page-body>",
    "page-margin-box": "<page-margin-box-type> '{' <declaration-list> '}'",
    "page-margin-box-type": "@top-left-corner|@top-left|@top-center|@top-right|@top-right-corner|@bottom-left-corner|@bottom-left|@bottom-center|@bottom-right|@bottom-right-corner|@left-top|@left-middle|@left-bottom|@right-top|@right-middle|@right-bottom",
    "page-selector-list": "[<page-selector>#]?",
    "page-selector": "<pseudo-page>+|<ident> <pseudo-page>*",
    "page-size": "A5|A4|A3|B5|B4|JIS-B5|JIS-B4|letter|legal|ledger",
    "path()": "path( [<fill-rule> ,]? <string> )",
    "paint()": "paint( <ident> , <declaration-value>? )",
    "perspective()": "perspective( [<length [0,\u221E]>|none] )",
    "polygon()": "polygon( <fill-rule>? , [<length-percentage> <length-percentage>]# )",
    "position": "[[left|center|right]||[top|center|bottom]|[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]?|[[left|right] <length-percentage>]&&[[top|bottom] <length-percentage>]]",
    "pow()": "pow( <calc-sum> , <calc-sum> )",
    "pseudo-class-selector": "':' <ident-token>|':' <function-token> <any-value> ')'",
    "pseudo-element-selector": "':' <pseudo-class-selector>",
    "pseudo-page": ": [left|right|first|blank]",
    "quote": "open-quote|close-quote|no-open-quote|no-close-quote",
    "radial-gradient()": "radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
    "ratio": "<number [0,\u221E]> [/ <number [0,\u221E]>]?",
    "relative-selector": "<combinator>? <complex-selector>",
    "relative-selector-list": "<relative-selector>#",
    "relative-size": "larger|smaller",
    "rem()": "rem( <calc-sum> , <calc-sum> )",
    "repeat-style": "repeat-x|repeat-y|[repeat|space|round|no-repeat]{1,2}",
    "repeating-conic-gradient()": "repeating-conic-gradient( [from <angle>]? [at <position>]? , <angular-color-stop-list> )",
    "repeating-linear-gradient()": "repeating-linear-gradient( [<angle>|to <side-or-corner>]? , <color-stop-list> )",
    "repeating-radial-gradient()": "repeating-radial-gradient( [<ending-shape>||<size>]? [at <position>]? , <color-stop-list> )",
    "reversed-counter-name": "reversed( <counter-name> )",
    "rgb()": "rgb( <percentage>{3} [/ <alpha-value>]? )|rgb( <number>{3} [/ <alpha-value>]? )|rgb( <percentage>#{3} , <alpha-value>? )|rgb( <number>#{3} , <alpha-value>? )",
    "rgba()": "rgba( <percentage>{3} [/ <alpha-value>]? )|rgba( <number>{3} [/ <alpha-value>]? )|rgba( <percentage>#{3} , <alpha-value>? )|rgba( <number>#{3} , <alpha-value>? )",
    "rotate()": "rotate( [<angle>|<zero>] )",
    "rotate3d()": "rotate3d( <number> , <number> , <number> , [<angle>|<zero>] )",
    "rotateX()": "rotateX( [<angle>|<zero>] )",
    "rotateY()": "rotateY( [<angle>|<zero>] )",
    "rotateZ()": "rotateZ( [<angle>|<zero>] )",
    "round()": "round( <rounding-strategy>? , <calc-sum> , <calc-sum> )",
    "rounding-strategy": "nearest|up|down|to-zero",
    "saturate()": "saturate( <number-percentage> )",
    "scale()": "scale( [<number>|<percentage>]#{1,2} )",
    "scale3d()": "scale3d( [<number>|<percentage>]#{3} )",
    "scaleX()": "scaleX( [<number>|<percentage>] )",
    "scaleY()": "scaleY( [<number>|<percentage>] )",
    "scaleZ()": "scaleZ( [<number>|<percentage>] )",
    "scroller": "root|nearest",
    "self-position": "center|start|end|self-start|self-end|flex-start|flex-end",
    "shape-radius": "<length-percentage>|closest-side|farthest-side",
    "sign()": "sign( <calc-sum> )",
    "skew()": "skew( [<angle>|<zero>] , [<angle>|<zero>]? )",
    "skewX()": "skewX( [<angle>|<zero>] )",
    "skewY()": "skewY( [<angle>|<zero>] )",
    "sepia()": "sepia( <number-percentage> )",
    "shadow": "inset?&&<length>{2,4}&&<color>?",
    "shadow-t": "[<length>{2,3}&&<color>?]",
    "shape": "rect( <top> , <right> , <bottom> , <left> )|rect( <top> <right> <bottom> <left> )",
    "shape-box": "<box>|margin-box",
    "side-or-corner": "[left|right]||[top|bottom]",
    "sin()": "sin( <calc-sum> )",
    "single-animation": "<time>||<easing-function>||<time>||<single-animation-iteration-count>||<single-animation-direction>||<single-animation-fill-mode>||<single-animation-play-state>||[none|<keyframes-name>]",
    "single-animation-direction": "normal|reverse|alternate|alternate-reverse",
    "single-animation-fill-mode": "none|forwards|backwards|both",
    "single-animation-iteration-count": "infinite|<number>",
    "single-animation-play-state": "running|paused",
    "single-animation-timeline": "auto|none|<timeline-name>|scroll( <axis>? <scroller>? )",
    "single-transition": "[none|<single-transition-property>]||<time>||<easing-function>||<time>",
    "single-transition-property": "all|<custom-ident>",
    "size": "closest-side|farthest-side|closest-corner|farthest-corner|<length>|<length-percentage>{2}",
    "sqrt()": "sqrt( <calc-sum> )",
    "step-position": "jump-start|jump-end|jump-none|jump-both|start|end",
    "step-timing-function": "step-start|step-end|steps( <integer> [, <step-position>]? )",
    "subclass-selector": "<id-selector>|<class-selector>|<attribute-selector>|<pseudo-class-selector>",
    "supports-condition": "not <supports-in-parens>|<supports-in-parens> [and <supports-in-parens>]*|<supports-in-parens> [or <supports-in-parens>]*",
    "supports-in-parens": "( <supports-condition> )|<supports-feature>|<general-enclosed>",
    "supports-feature": "<supports-decl>|<supports-selector-fn>",
    "supports-decl": "( <declaration> )",
    "supports-selector-fn": "selector( <complex-selector> )",
    "symbol": "<string>|<image>|<custom-ident>",
    "tan()": "tan( <calc-sum> )",
    "target": "<target-counter()>|<target-counters()>|<target-text()>",
    "target-counter()": "target-counter( [<string>|<url>] , <custom-ident> , <counter-style>? )",
    "target-counters()": "target-counters( [<string>|<url>] , <custom-ident> , <string> , <counter-style>? )",
    "target-text()": "target-text( [<string>|<url>] , [content|before|after|first-letter]? )",
    "time-percentage": "<time>|<percentage>",
    "timeline-name": "<custom-ident>|<string>",
    "easing-function": "linear|<cubic-bezier-timing-function>|<step-timing-function>",
    "track-breadth": "<length-percentage>|<flex>|min-content|max-content|auto",
    "track-list": "[<line-names>? [<track-size>|<track-repeat>]]+ <line-names>?",
    "track-repeat": "repeat( [<integer [1,\u221E]>] , [<line-names>? <track-size>]+ <line-names>? )",
    "track-size": "<track-breadth>|minmax( <inflexible-breadth> , <track-breadth> )|fit-content( <length-percentage> )",
    "transform-function": "<matrix()>|<translate()>|<translateX()>|<translateY()>|<scale()>|<scaleX()>|<scaleY()>|<rotate()>|<skew()>|<skewX()>|<skewY()>|<matrix3d()>|<translate3d()>|<translateZ()>|<scale3d()>|<scaleZ()>|<rotate3d()>|<rotateX()>|<rotateY()>|<rotateZ()>|<perspective()>",
    "transform-list": "<transform-function>+",
    "translate()": "translate( <length-percentage> , <length-percentage>? )",
    "translate3d()": "translate3d( <length-percentage> , <length-percentage> , <length> )",
    "translateX()": "translateX( <length-percentage> )",
    "translateY()": "translateY( <length-percentage> )",
    "translateZ()": "translateZ( <length> )",
    "type-or-unit": "string|color|url|integer|number|length|angle|time|frequency|cap|ch|em|ex|ic|lh|rlh|rem|vb|vi|vw|vh|vmin|vmax|mm|Q|cm|in|pt|pc|px|deg|grad|rad|turn|ms|s|Hz|kHz|%",
    "type-selector": "<wq-name>|<ns-prefix>? '*'",
    "var()": "var( <custom-property-name> , <declaration-value>? )",
    "viewport-length": "auto|<length-percentage>",
    "visual-box": "content-box|padding-box|border-box",
    "wq-name": "<ns-prefix>? <ident-token>",
    "-legacy-gradient": "<-webkit-gradient()>|<-legacy-linear-gradient>|<-legacy-repeating-linear-gradient>|<-legacy-radial-gradient>|<-legacy-repeating-radial-gradient>",
    "-legacy-linear-gradient": "-moz-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-linear-gradient( <-legacy-linear-gradient-arguments> )",
    "-legacy-repeating-linear-gradient": "-moz-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-webkit-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )|-o-repeating-linear-gradient( <-legacy-linear-gradient-arguments> )",
    "-legacy-linear-gradient-arguments": "[<angle>|<side-or-corner>]? , <color-stop-list>",
    "-legacy-radial-gradient": "-moz-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-radial-gradient( <-legacy-radial-gradient-arguments> )",
    "-legacy-repeating-radial-gradient": "-moz-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-webkit-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )|-o-repeating-radial-gradient( <-legacy-radial-gradient-arguments> )",
    "-legacy-radial-gradient-arguments": "[<position> ,]? [[[<-legacy-radial-gradient-shape>||<-legacy-radial-gradient-size>]|[<length>|<percentage>]{2}] ,]? <color-stop-list>",
    "-legacy-radial-gradient-size": "closest-side|closest-corner|farthest-side|farthest-corner|contain|cover",
    "-legacy-radial-gradient-shape": "circle|ellipse",
    "-non-standard-font": "-apple-system-body|-apple-system-headline|-apple-system-subheadline|-apple-system-caption1|-apple-system-caption2|-apple-system-footnote|-apple-system-short-body|-apple-system-short-headline|-apple-system-short-subheadline|-apple-system-short-caption1|-apple-system-short-footnote|-apple-system-tall-body",
    "-non-standard-color": "-moz-ButtonDefault|-moz-ButtonHoverFace|-moz-ButtonHoverText|-moz-CellHighlight|-moz-CellHighlightText|-moz-Combobox|-moz-ComboboxText|-moz-Dialog|-moz-DialogText|-moz-dragtargetzone|-moz-EvenTreeRow|-moz-Field|-moz-FieldText|-moz-html-CellHighlight|-moz-html-CellHighlightText|-moz-mac-accentdarkestshadow|-moz-mac-accentdarkshadow|-moz-mac-accentface|-moz-mac-accentlightesthighlight|-moz-mac-accentlightshadow|-moz-mac-accentregularhighlight|-moz-mac-accentregularshadow|-moz-mac-chrome-active|-moz-mac-chrome-inactive|-moz-mac-focusring|-moz-mac-menuselect|-moz-mac-menushadow|-moz-mac-menutextselect|-moz-MenuHover|-moz-MenuHoverText|-moz-MenuBarText|-moz-MenuBarHoverText|-moz-nativehyperlinktext|-moz-OddTreeRow|-moz-win-communicationstext|-moz-win-mediatext|-moz-activehyperlinktext|-moz-default-background-color|-moz-default-color|-moz-hyperlinktext|-moz-visitedhyperlinktext|-webkit-activelink|-webkit-focus-ring-color|-webkit-link|-webkit-text",
    "-non-standard-image-rendering": "optimize-contrast|-moz-crisp-edges|-o-crisp-edges|-webkit-optimize-contrast",
    "-non-standard-overflow": "-moz-scrollbars-none|-moz-scrollbars-horizontal|-moz-scrollbars-vertical|-moz-hidden-unscrollable",
    "-non-standard-width": "fill-available|min-intrinsic|intrinsic|-moz-available|-moz-fit-content|-moz-min-content|-moz-max-content|-webkit-min-content|-webkit-max-content",
    "-webkit-gradient()": "-webkit-gradient( <-webkit-gradient-type> , <-webkit-gradient-point> [, <-webkit-gradient-point>|, <-webkit-gradient-radius> , <-webkit-gradient-point>] [, <-webkit-gradient-radius>]? [, <-webkit-gradient-color-stop>]* )",
    "-webkit-gradient-color-stop": "from( <color> )|color-stop( [<number-zero-one>|<percentage>] , <color> )|to( <color> )",
    "-webkit-gradient-point": "[left|center|right|<length-percentage>] [top|center|bottom|<length-percentage>]",
    "-webkit-gradient-radius": "<length>|<percentage>",
    "-webkit-gradient-type": "linear|radial",
    "-webkit-mask-box-repeat": "repeat|stretch|round",
    "-webkit-mask-clip-style": "border|border-box|padding|padding-box|content|content-box|text",
    "-ms-filter-function-list": "<-ms-filter-function>+",
    "-ms-filter-function": "<-ms-filter-function-progid>|<-ms-filter-function-legacy>",
    "-ms-filter-function-progid": "'progid:' [<ident-token> '.']* [<ident-token>|<function-token> <any-value>? )]",
    "-ms-filter-function-legacy": "<ident-token>|<function-token> <any-value>? )",
    "-ms-filter": "<string>",
    "age": "child|young|old",
    "attr-name": "<wq-name>",
    "attr-fallback": "<any-value>",
    "bg-clip": "<box>|border|text",
    "bottom": "<length>|auto",
    "generic-voice": "[<age>? <gender> <integer>?]",
    "gender": "male|female|neutral",
    "left": "<length>|auto",
    "mask-image": "<mask-reference>#",
    "paint": "none|<color>|<url> [none|<color>]?|context-fill|context-stroke",
    "right": "<length>|auto",
    "scroll-timeline-axis": "block|inline|vertical|horizontal",
    "scroll-timeline-name": "none|<custom-ident>",
    "single-animation-composition": "replace|add|accumulate",
    "svg-length": "<percentage>|<length>|<number>",
    "svg-writing-mode": "lr-tb|rl-tb|tb-rl|lr|rl|tb",
    "top": "<length>|auto",
    "x": "<number>",
    "y": "<number>",
    "declaration": "<ident-token> : <declaration-value>? ['!' important]?",
    "declaration-list": "[<declaration>? ';']* <declaration>?",
    "url": "url( <string> <url-modifier>* )|<url-token>",
    "url-modifier": "<ident>|<function-token> <any-value> )",
    "number-zero-one": "<number [0,1]>",
    "number-one-or-greater": "<number [1,\u221E]>",
    "-non-standard-display": "-ms-inline-flexbox|-ms-grid|-ms-inline-grid|-webkit-flex|-webkit-inline-flex|-webkit-box|-webkit-inline-box|-moz-inline-stack|-moz-box|-moz-inline-box"
  },
  "properties": {
    "--*": "<declaration-value>",
    "-ms-accelerator": "false|true",
    "-ms-block-progression": "tb|rl|bt|lr",
    "-ms-content-zoom-chaining": "none|chained",
    "-ms-content-zooming": "none|zoom",
    "-ms-content-zoom-limit": "<'-ms-content-zoom-limit-min'> <'-ms-content-zoom-limit-max'>",
    "-ms-content-zoom-limit-max": "<percentage>",
    "-ms-content-zoom-limit-min": "<percentage>",
    "-ms-content-zoom-snap": "<'-ms-content-zoom-snap-type'>||<'-ms-content-zoom-snap-points'>",
    "-ms-content-zoom-snap-points": "snapInterval( <percentage> , <percentage> )|snapList( <percentage># )",
    "-ms-content-zoom-snap-type": "none|proximity|mandatory",
    "-ms-filter": "<string>",
    "-ms-flow-from": "[none|<custom-ident>]#",
    "-ms-flow-into": "[none|<custom-ident>]#",
    "-ms-grid-columns": "none|<track-list>|<auto-track-list>",
    "-ms-grid-rows": "none|<track-list>|<auto-track-list>",
    "-ms-high-contrast-adjust": "auto|none",
    "-ms-hyphenate-limit-chars": "auto|<integer>{1,3}",
    "-ms-hyphenate-limit-lines": "no-limit|<integer>",
    "-ms-hyphenate-limit-zone": "<percentage>|<length>",
    "-ms-ime-align": "auto|after",
    "-ms-overflow-style": "auto|none|scrollbar|-ms-autohiding-scrollbar",
    "-ms-scrollbar-3dlight-color": "<color>",
    "-ms-scrollbar-arrow-color": "<color>",
    "-ms-scrollbar-base-color": "<color>",
    "-ms-scrollbar-darkshadow-color": "<color>",
    "-ms-scrollbar-face-color": "<color>",
    "-ms-scrollbar-highlight-color": "<color>",
    "-ms-scrollbar-shadow-color": "<color>",
    "-ms-scrollbar-track-color": "<color>",
    "-ms-scroll-chaining": "chained|none",
    "-ms-scroll-limit": "<'-ms-scroll-limit-x-min'> <'-ms-scroll-limit-y-min'> <'-ms-scroll-limit-x-max'> <'-ms-scroll-limit-y-max'>",
    "-ms-scroll-limit-x-max": "auto|<length>",
    "-ms-scroll-limit-x-min": "<length>",
    "-ms-scroll-limit-y-max": "auto|<length>",
    "-ms-scroll-limit-y-min": "<length>",
    "-ms-scroll-rails": "none|railed",
    "-ms-scroll-snap-points-x": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
    "-ms-scroll-snap-points-y": "snapInterval( <length-percentage> , <length-percentage> )|snapList( <length-percentage># )",
    "-ms-scroll-snap-type": "none|proximity|mandatory",
    "-ms-scroll-snap-x": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-x'>",
    "-ms-scroll-snap-y": "<'-ms-scroll-snap-type'> <'-ms-scroll-snap-points-y'>",
    "-ms-scroll-translation": "none|vertical-to-horizontal",
    "-ms-text-autospace": "none|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space",
    "-ms-touch-select": "grippers|none",
    "-ms-user-select": "none|element|text",
    "-ms-wrap-flow": "auto|both|start|end|maximum|clear",
    "-ms-wrap-margin": "<length>",
    "-ms-wrap-through": "wrap|none",
    "-moz-appearance": "none|button|button-arrow-down|button-arrow-next|button-arrow-previous|button-arrow-up|button-bevel|button-focus|caret|checkbox|checkbox-container|checkbox-label|checkmenuitem|dualbutton|groupbox|listbox|listitem|menuarrow|menubar|menucheckbox|menuimage|menuitem|menuitemtext|menulist|menulist-button|menulist-text|menulist-textfield|menupopup|menuradio|menuseparator|meterbar|meterchunk|progressbar|progressbar-vertical|progresschunk|progresschunk-vertical|radio|radio-container|radio-label|radiomenuitem|range|range-thumb|resizer|resizerpanel|scale-horizontal|scalethumbend|scalethumb-horizontal|scalethumbstart|scalethumbtick|scalethumb-vertical|scale-vertical|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|separator|sheet|spinner|spinner-downbutton|spinner-textfield|spinner-upbutton|splitter|statusbar|statusbarpanel|tab|tabpanel|tabpanels|tab-scroll-arrow-back|tab-scroll-arrow-forward|textfield|textfield-multiline|toolbar|toolbarbutton|toolbarbutton-dropdown|toolbargripper|toolbox|tooltip|treeheader|treeheadercell|treeheadersortarrow|treeitem|treeline|treetwisty|treetwistyopen|treeview|-moz-mac-unified-toolbar|-moz-win-borderless-glass|-moz-win-browsertabbar-toolbox|-moz-win-communicationstext|-moz-win-communications-toolbox|-moz-win-exclude-glass|-moz-win-glass|-moz-win-mediatext|-moz-win-media-toolbox|-moz-window-button-box|-moz-window-button-box-maximized|-moz-window-button-close|-moz-window-button-maximize|-moz-window-button-minimize|-moz-window-button-restore|-moz-window-frame-bottom|-moz-window-frame-left|-moz-window-frame-right|-moz-window-titlebar|-moz-window-titlebar-maximized",
    "-moz-binding": "<url>|none",
    "-moz-border-bottom-colors": "<color>+|none",
    "-moz-border-left-colors": "<color>+|none",
    "-moz-border-right-colors": "<color>+|none",
    "-moz-border-top-colors": "<color>+|none",
    "-moz-context-properties": "none|[fill|fill-opacity|stroke|stroke-opacity]#",
    "-moz-float-edge": "border-box|content-box|margin-box|padding-box",
    "-moz-force-broken-image-icon": "0|1",
    "-moz-image-region": "<shape>|auto",
    "-moz-orient": "inline|block|horizontal|vertical",
    "-moz-outline-radius": "<outline-radius>{1,4} [/ <outline-radius>{1,4}]?",
    "-moz-outline-radius-bottomleft": "<outline-radius>",
    "-moz-outline-radius-bottomright": "<outline-radius>",
    "-moz-outline-radius-topleft": "<outline-radius>",
    "-moz-outline-radius-topright": "<outline-radius>",
    "-moz-stack-sizing": "ignore|stretch-to-fit",
    "-moz-text-blink": "none|blink",
    "-moz-user-focus": "ignore|normal|select-after|select-before|select-menu|select-same|select-all|none",
    "-moz-user-input": "auto|none|enabled|disabled",
    "-moz-user-modify": "read-only|read-write|write-only",
    "-moz-window-dragging": "drag|no-drag",
    "-moz-window-shadow": "default|menu|tooltip|sheet|none",
    "-webkit-appearance": "none|button|button-bevel|caps-lock-indicator|caret|checkbox|default-button|inner-spin-button|listbox|listitem|media-controls-background|media-controls-fullscreen-background|media-current-time-display|media-enter-fullscreen-button|media-exit-fullscreen-button|media-fullscreen-button|media-mute-button|media-overlay-play-button|media-play-button|media-seek-back-button|media-seek-forward-button|media-slider|media-sliderthumb|media-time-remaining-display|media-toggle-closed-captions-button|media-volume-slider|media-volume-slider-container|media-volume-sliderthumb|menulist|menulist-button|menulist-text|menulist-textfield|meter|progress-bar|progress-bar-value|push-button|radio|scrollbarbutton-down|scrollbarbutton-left|scrollbarbutton-right|scrollbarbutton-up|scrollbargripper-horizontal|scrollbargripper-vertical|scrollbarthumb-horizontal|scrollbarthumb-vertical|scrollbartrack-horizontal|scrollbartrack-vertical|searchfield|searchfield-cancel-button|searchfield-decoration|searchfield-results-button|searchfield-results-decoration|slider-horizontal|slider-vertical|sliderthumb-horizontal|sliderthumb-vertical|square-button|textarea|textfield|-apple-pay-button",
    "-webkit-border-before": "<'border-width'>||<'border-style'>||<color>",
    "-webkit-border-before-color": "<color>",
    "-webkit-border-before-style": "<'border-style'>",
    "-webkit-border-before-width": "<'border-width'>",
    "-webkit-box-reflect": "[above|below|right|left]? <length>? <image>?",
    "-webkit-line-clamp": "none|<integer>",
    "-webkit-mask": "[<mask-reference>||<position> [/ <bg-size>]?||<repeat-style>||[<box>|border|padding|content|text]||[<box>|border|padding|content]]#",
    "-webkit-mask-attachment": "<attachment>#",
    "-webkit-mask-clip": "[<box>|border|padding|content|text]#",
    "-webkit-mask-composite": "<composite-style>#",
    "-webkit-mask-image": "<mask-reference>#",
    "-webkit-mask-origin": "[<box>|border|padding|content]#",
    "-webkit-mask-position": "<position>#",
    "-webkit-mask-position-x": "[<length-percentage>|left|center|right]#",
    "-webkit-mask-position-y": "[<length-percentage>|top|center|bottom]#",
    "-webkit-mask-repeat": "<repeat-style>#",
    "-webkit-mask-repeat-x": "repeat|no-repeat|space|round",
    "-webkit-mask-repeat-y": "repeat|no-repeat|space|round",
    "-webkit-mask-size": "<bg-size>#",
    "-webkit-overflow-scrolling": "auto|touch",
    "-webkit-tap-highlight-color": "<color>",
    "-webkit-text-fill-color": "<color>",
    "-webkit-text-stroke": "<length>||<color>",
    "-webkit-text-stroke-color": "<color>",
    "-webkit-text-stroke-width": "<length>",
    "-webkit-touch-callout": "default|none",
    "-webkit-user-modify": "read-only|read-write|read-write-plaintext-only",
    "accent-color": "auto|<color>",
    "align-content": "normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>",
    "align-items": "normal|stretch|<baseline-position>|[<overflow-position>? <self-position>]",
    "align-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? <self-position>",
    "align-tracks": "[normal|<baseline-position>|<content-distribution>|<overflow-position>? <content-position>]#",
    "all": "initial|inherit|unset|revert|revert-layer",
    "animation": "<single-animation>#",
    "animation-composition": "<single-animation-composition>#",
    "animation-delay": "<time>#",
    "animation-direction": "<single-animation-direction>#",
    "animation-duration": "<time>#",
    "animation-fill-mode": "<single-animation-fill-mode>#",
    "animation-iteration-count": "<single-animation-iteration-count>#",
    "animation-name": "[none|<keyframes-name>]#",
    "animation-play-state": "<single-animation-play-state>#",
    "animation-timing-function": "<easing-function>#",
    "animation-timeline": "<single-animation-timeline>#",
    "appearance": "none|auto|textfield|menulist-button|<compat-auto>",
    "aspect-ratio": "auto|<ratio>",
    "azimuth": "<angle>|[[left-side|far-left|left|center-left|center|center-right|right|far-right|right-side]||behind]|leftwards|rightwards",
    "backdrop-filter": "none|<filter-function-list>",
    "backface-visibility": "visible|hidden",
    "background": "[<bg-layer> ,]* <final-bg-layer>",
    "background-attachment": "<attachment>#",
    "background-blend-mode": "<blend-mode>#",
    "background-clip": "<bg-clip>#",
    "background-color": "<color>",
    "background-image": "<bg-image>#",
    "background-origin": "<box>#",
    "background-position": "<bg-position>#",
    "background-position-x": "[center|[[left|right|x-start|x-end]? <length-percentage>?]!]#",
    "background-position-y": "[center|[[top|bottom|y-start|y-end]? <length-percentage>?]!]#",
    "background-repeat": "<repeat-style>#",
    "background-size": "<bg-size>#",
    "block-overflow": "clip|ellipsis|<string>",
    "block-size": "<'width'>",
    "border": "<line-width>||<line-style>||<color>",
    "border-block": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-color": "<'border-top-color'>{1,2}",
    "border-block-style": "<'border-top-style'>",
    "border-block-width": "<'border-top-width'>",
    "border-block-end": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-end-color": "<'border-top-color'>",
    "border-block-end-style": "<'border-top-style'>",
    "border-block-end-width": "<'border-top-width'>",
    "border-block-start": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-block-start-color": "<'border-top-color'>",
    "border-block-start-style": "<'border-top-style'>",
    "border-block-start-width": "<'border-top-width'>",
    "border-bottom": "<line-width>||<line-style>||<color>",
    "border-bottom-color": "<'border-top-color'>",
    "border-bottom-left-radius": "<length-percentage>{1,2}",
    "border-bottom-right-radius": "<length-percentage>{1,2}",
    "border-bottom-style": "<line-style>",
    "border-bottom-width": "<line-width>",
    "border-collapse": "collapse|separate",
    "border-color": "<color>{1,4}",
    "border-end-end-radius": "<length-percentage>{1,2}",
    "border-end-start-radius": "<length-percentage>{1,2}",
    "border-image": "<'border-image-source'>||<'border-image-slice'> [/ <'border-image-width'>|/ <'border-image-width'>? / <'border-image-outset'>]?||<'border-image-repeat'>",
    "border-image-outset": "[<length>|<number>]{1,4}",
    "border-image-repeat": "[stretch|repeat|round|space]{1,2}",
    "border-image-slice": "<number-percentage>{1,4}&&fill?",
    "border-image-source": "none|<image>",
    "border-image-width": "[<length-percentage>|<number>|auto]{1,4}",
    "border-inline": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-end": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-color": "<'border-top-color'>{1,2}",
    "border-inline-style": "<'border-top-style'>",
    "border-inline-width": "<'border-top-width'>",
    "border-inline-end-color": "<'border-top-color'>",
    "border-inline-end-style": "<'border-top-style'>",
    "border-inline-end-width": "<'border-top-width'>",
    "border-inline-start": "<'border-top-width'>||<'border-top-style'>||<color>",
    "border-inline-start-color": "<'border-top-color'>",
    "border-inline-start-style": "<'border-top-style'>",
    "border-inline-start-width": "<'border-top-width'>",
    "border-left": "<line-width>||<line-style>||<color>",
    "border-left-color": "<color>",
    "border-left-style": "<line-style>",
    "border-left-width": "<line-width>",
    "border-radius": "<length-percentage>{1,4} [/ <length-percentage>{1,4}]?",
    "border-right": "<line-width>||<line-style>||<color>",
    "border-right-color": "<color>",
    "border-right-style": "<line-style>",
    "border-right-width": "<line-width>",
    "border-spacing": "<length> <length>?",
    "border-start-end-radius": "<length-percentage>{1,2}",
    "border-start-start-radius": "<length-percentage>{1,2}",
    "border-style": "<line-style>{1,4}",
    "border-top": "<line-width>||<line-style>||<color>",
    "border-top-color": "<color>",
    "border-top-left-radius": "<length-percentage>{1,2}",
    "border-top-right-radius": "<length-percentage>{1,2}",
    "border-top-style": "<line-style>",
    "border-top-width": "<line-width>",
    "border-width": "<line-width>{1,4}",
    "bottom": "<length>|<percentage>|auto",
    "box-align": "start|center|end|baseline|stretch",
    "box-decoration-break": "slice|clone",
    "box-direction": "normal|reverse|inherit",
    "box-flex": "<number>",
    "box-flex-group": "<integer>",
    "box-lines": "single|multiple",
    "box-ordinal-group": "<integer>",
    "box-orient": "horizontal|vertical|inline-axis|block-axis|inherit",
    "box-pack": "start|center|end|justify",
    "box-shadow": "none|<shadow>#",
    "box-sizing": "content-box|border-box",
    "break-after": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
    "break-before": "auto|avoid|always|all|avoid-page|page|left|right|recto|verso|avoid-column|column|avoid-region|region",
    "break-inside": "auto|avoid|avoid-page|avoid-column|avoid-region",
    "caption-side": "top|bottom|block-start|block-end|inline-start|inline-end",
    "caret": "<'caret-color'>||<'caret-shape'>",
    "caret-color": "auto|<color>",
    "caret-shape": "auto|bar|block|underscore",
    "clear": "none|left|right|both|inline-start|inline-end",
    "clip": "<shape>|auto",
    "clip-path": "<clip-source>|[<basic-shape>||<geometry-box>]|none",
    "color": "<color>",
    "print-color-adjust": "economy|exact",
    "color-scheme": "normal|[light|dark|<custom-ident>]+&&only?",
    "column-count": "<integer>|auto",
    "column-fill": "auto|balance|balance-all",
    "column-gap": "normal|<length-percentage>",
    "column-rule": "<'column-rule-width'>||<'column-rule-style'>||<'column-rule-color'>",
    "column-rule-color": "<color>",
    "column-rule-style": "<'border-style'>",
    "column-rule-width": "<'border-width'>",
    "column-span": "none|all",
    "column-width": "<length>|auto",
    "columns": "<'column-width'>||<'column-count'>",
    "contain": "none|strict|content|[[size||inline-size]||layout||style||paint]",
    "contain-intrinsic-size": "[none|<length>|auto <length>]{1,2}",
    "contain-intrinsic-block-size": "none|<length>|auto <length>",
    "contain-intrinsic-height": "none|<length>|auto <length>",
    "contain-intrinsic-inline-size": "none|<length>|auto <length>",
    "contain-intrinsic-width": "none|<length>|auto <length>",
    "content": "normal|none|[<content-replacement>|<content-list>] [/ [<string>|<counter>]+]?",
    "content-visibility": "visible|auto|hidden",
    "counter-increment": "[<counter-name> <integer>?]+|none",
    "counter-reset": "[<counter-name> <integer>?|<reversed-counter-name> <integer>?]+|none",
    "counter-set": "[<counter-name> <integer>?]+|none",
    "cursor": "[[<url> [<x> <y>]? ,]* [auto|default|none|context-menu|help|pointer|progress|wait|cell|crosshair|text|vertical-text|alias|copy|move|no-drop|not-allowed|e-resize|n-resize|ne-resize|nw-resize|s-resize|se-resize|sw-resize|w-resize|ew-resize|ns-resize|nesw-resize|nwse-resize|col-resize|row-resize|all-scroll|zoom-in|zoom-out|grab|grabbing|hand|-webkit-grab|-webkit-grabbing|-webkit-zoom-in|-webkit-zoom-out|-moz-grab|-moz-grabbing|-moz-zoom-in|-moz-zoom-out]]",
    "direction": "ltr|rtl",
    "display": "[<display-outside>||<display-inside>]|<display-listitem>|<display-internal>|<display-box>|<display-legacy>|<-non-standard-display>",
    "empty-cells": "show|hide",
    "filter": "none|<filter-function-list>|<-ms-filter-function-list>",
    "flex": "none|[<'flex-grow'> <'flex-shrink'>?||<'flex-basis'>]",
    "flex-basis": "content|<'width'>",
    "flex-direction": "row|row-reverse|column|column-reverse",
    "flex-flow": "<'flex-direction'>||<'flex-wrap'>",
    "flex-grow": "<number>",
    "flex-shrink": "<number>",
    "flex-wrap": "nowrap|wrap|wrap-reverse",
    "float": "left|right|none|inline-start|inline-end",
    "font": "[[<'font-style'>||<font-variant-css21>||<'font-weight'>||<'font-stretch'>]? <'font-size'> [/ <'line-height'>]? <'font-family'>]|caption|icon|menu|message-box|small-caption|status-bar",
    "font-family": "[<family-name>|<generic-family>]#",
    "font-feature-settings": "normal|<feature-tag-value>#",
    "font-kerning": "auto|normal|none",
    "font-language-override": "normal|<string>",
    "font-optical-sizing": "auto|none",
    "font-variation-settings": "normal|[<string> <number>]#",
    "font-size": "<absolute-size>|<relative-size>|<length-percentage>",
    "font-size-adjust": "none|[ex-height|cap-height|ch-width|ic-width|ic-height]? [from-font|<number>]",
    "font-smooth": "auto|never|always|<absolute-size>|<length>",
    "font-stretch": "<font-stretch-absolute>",
    "font-style": "normal|italic|oblique <angle>?",
    "font-synthesis": "none|[weight||style||small-caps]",
    "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
    "font-variant-alternates": "normal|[stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )]",
    "font-variant-caps": "normal|small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps",
    "font-variant-east-asian": "normal|[<east-asian-variant-values>||<east-asian-width-values>||ruby]",
    "font-variant-ligatures": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>]",
    "font-variant-numeric": "normal|[<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero]",
    "font-variant-position": "normal|sub|super",
    "font-weight": "<font-weight-absolute>|bolder|lighter",
    "forced-color-adjust": "auto|none",
    "gap": "<'row-gap'> <'column-gap'>?",
    "grid": "<'grid-template'>|<'grid-template-rows'> / [auto-flow&&dense?] <'grid-auto-columns'>?|[auto-flow&&dense?] <'grid-auto-rows'>? / <'grid-template-columns'>",
    "grid-area": "<grid-line> [/ <grid-line>]{0,3}",
    "grid-auto-columns": "<track-size>+",
    "grid-auto-flow": "[row|column]||dense",
    "grid-auto-rows": "<track-size>+",
    "grid-column": "<grid-line> [/ <grid-line>]?",
    "grid-column-end": "<grid-line>",
    "grid-column-gap": "<length-percentage>",
    "grid-column-start": "<grid-line>",
    "grid-gap": "<'grid-row-gap'> <'grid-column-gap'>?",
    "grid-row": "<grid-line> [/ <grid-line>]?",
    "grid-row-end": "<grid-line>",
    "grid-row-gap": "<length-percentage>",
    "grid-row-start": "<grid-line>",
    "grid-template": "none|[<'grid-template-rows'> / <'grid-template-columns'>]|[<line-names>? <string> <track-size>? <line-names>?]+ [/ <explicit-track-list>]?",
    "grid-template-areas": "none|<string>+",
    "grid-template-columns": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
    "grid-template-rows": "none|<track-list>|<auto-track-list>|subgrid <line-name-list>?",
    "hanging-punctuation": "none|[first||[force-end|allow-end]||last]",
    "height": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
    "hyphenate-character": "auto|<string>",
    "hyphens": "none|manual|auto",
    "image-orientation": "from-image|<angle>|[<angle>? flip]",
    "image-rendering": "auto|crisp-edges|pixelated|optimizeSpeed|optimizeQuality|<-non-standard-image-rendering>",
    "image-resolution": "[from-image||<resolution>]&&snap?",
    "ime-mode": "auto|normal|active|inactive|disabled",
    "initial-letter": "normal|[<number> <integer>?]",
    "initial-letter-align": "[auto|alphabetic|hanging|ideographic]",
    "inline-size": "<'width'>",
    "input-security": "auto|none",
    "inset": "<'top'>{1,4}",
    "inset-block": "<'top'>{1,2}",
    "inset-block-end": "<'top'>",
    "inset-block-start": "<'top'>",
    "inset-inline": "<'top'>{1,2}",
    "inset-inline-end": "<'top'>",
    "inset-inline-start": "<'top'>",
    "isolation": "auto|isolate",
    "justify-content": "normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]",
    "justify-items": "normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]|legacy|legacy&&[left|right|center]",
    "justify-self": "auto|normal|stretch|<baseline-position>|<overflow-position>? [<self-position>|left|right]",
    "justify-tracks": "[normal|<content-distribution>|<overflow-position>? [<content-position>|left|right]]#",
    "left": "<length>|<percentage>|auto",
    "letter-spacing": "normal|<length-percentage>",
    "line-break": "auto|loose|normal|strict|anywhere",
    "line-clamp": "none|<integer>",
    "line-height": "normal|<number>|<length>|<percentage>",
    "line-height-step": "<length>",
    "list-style": "<'list-style-type'>||<'list-style-position'>||<'list-style-image'>",
    "list-style-image": "<image>|none",
    "list-style-position": "inside|outside",
    "list-style-type": "<counter-style>|<string>|none",
    "margin": "[<length>|<percentage>|auto]{1,4}",
    "margin-block": "<'margin-left'>{1,2}",
    "margin-block-end": "<'margin-left'>",
    "margin-block-start": "<'margin-left'>",
    "margin-bottom": "<length>|<percentage>|auto",
    "margin-inline": "<'margin-left'>{1,2}",
    "margin-inline-end": "<'margin-left'>",
    "margin-inline-start": "<'margin-left'>",
    "margin-left": "<length>|<percentage>|auto",
    "margin-right": "<length>|<percentage>|auto",
    "margin-top": "<length>|<percentage>|auto",
    "margin-trim": "none|in-flow|all",
    "mask": "<mask-layer>#",
    "mask-border": "<'mask-border-source'>||<'mask-border-slice'> [/ <'mask-border-width'>? [/ <'mask-border-outset'>]?]?||<'mask-border-repeat'>||<'mask-border-mode'>",
    "mask-border-mode": "luminance|alpha",
    "mask-border-outset": "[<length>|<number>]{1,4}",
    "mask-border-repeat": "[stretch|repeat|round|space]{1,2}",
    "mask-border-slice": "<number-percentage>{1,4} fill?",
    "mask-border-source": "none|<image>",
    "mask-border-width": "[<length-percentage>|<number>|auto]{1,4}",
    "mask-clip": "[<geometry-box>|no-clip]#",
    "mask-composite": "<compositing-operator>#",
    "mask-image": "<mask-reference>#",
    "mask-mode": "<masking-mode>#",
    "mask-origin": "<geometry-box>#",
    "mask-position": "<position>#",
    "mask-repeat": "<repeat-style>#",
    "mask-size": "<bg-size>#",
    "mask-type": "luminance|alpha",
    "masonry-auto-flow": "[pack|next]||[definite-first|ordered]",
    "math-depth": "auto-add|add( <integer> )|<integer>",
    "math-shift": "normal|compact",
    "math-style": "normal|compact",
    "max-block-size": "<'max-width'>",
    "max-height": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
    "max-inline-size": "<'max-width'>",
    "max-lines": "none|<integer>",
    "max-width": "none|<length-percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|<-non-standard-width>",
    "min-block-size": "<'min-width'>",
    "min-height": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )",
    "min-inline-size": "<'min-width'>",
    "min-width": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|<-non-standard-width>",
    "mix-blend-mode": "<blend-mode>|plus-lighter",
    "object-fit": "fill|contain|cover|none|scale-down",
    "object-position": "<position>",
    "offset": "[<'offset-position'>? [<'offset-path'> [<'offset-distance'>||<'offset-rotate'>]?]?]! [/ <'offset-anchor'>]?",
    "offset-anchor": "auto|<position>",
    "offset-distance": "<length-percentage>",
    "offset-path": "none|ray( [<angle>&&<size>&&contain?] )|<path()>|<url>|[<basic-shape>||<geometry-box>]",
    "offset-position": "auto|<position>",
    "offset-rotate": "[auto|reverse]||<angle>",
    "opacity": "<alpha-value>",
    "order": "<integer>",
    "orphans": "<integer>",
    "outline": "[<'outline-color'>||<'outline-style'>||<'outline-width'>]",
    "outline-color": "<color>|invert",
    "outline-offset": "<length>",
    "outline-style": "auto|<'border-style'>",
    "outline-width": "<line-width>",
    "overflow": "[visible|hidden|clip|scroll|auto]{1,2}|<-non-standard-overflow>",
    "overflow-anchor": "auto|none",
    "overflow-block": "visible|hidden|clip|scroll|auto",
    "overflow-clip-box": "padding-box|content-box",
    "overflow-clip-margin": "<visual-box>||<length [0,\u221E]>",
    "overflow-inline": "visible|hidden|clip|scroll|auto",
    "overflow-wrap": "normal|break-word|anywhere",
    "overflow-x": "visible|hidden|clip|scroll|auto",
    "overflow-y": "visible|hidden|clip|scroll|auto",
    "overscroll-behavior": "[contain|none|auto]{1,2}",
    "overscroll-behavior-block": "contain|none|auto",
    "overscroll-behavior-inline": "contain|none|auto",
    "overscroll-behavior-x": "contain|none|auto",
    "overscroll-behavior-y": "contain|none|auto",
    "padding": "[<length>|<percentage>]{1,4}",
    "padding-block": "<'padding-left'>{1,2}",
    "padding-block-end": "<'padding-left'>",
    "padding-block-start": "<'padding-left'>",
    "padding-bottom": "<length>|<percentage>",
    "padding-inline": "<'padding-left'>{1,2}",
    "padding-inline-end": "<'padding-left'>",
    "padding-inline-start": "<'padding-left'>",
    "padding-left": "<length>|<percentage>",
    "padding-right": "<length>|<percentage>",
    "padding-top": "<length>|<percentage>",
    "page-break-after": "auto|always|avoid|left|right|recto|verso",
    "page-break-before": "auto|always|avoid|left|right|recto|verso",
    "page-break-inside": "auto|avoid",
    "paint-order": "normal|[fill||stroke||markers]",
    "perspective": "none|<length>",
    "perspective-origin": "<position>",
    "place-content": "<'align-content'> <'justify-content'>?",
    "place-items": "<'align-items'> <'justify-items'>?",
    "place-self": "<'align-self'> <'justify-self'>?",
    "pointer-events": "auto|none|visiblePainted|visibleFill|visibleStroke|visible|painted|fill|stroke|all|inherit",
    "position": "static|relative|absolute|sticky|fixed|-webkit-sticky",
    "quotes": "none|auto|[<string> <string>]+",
    "resize": "none|both|horizontal|vertical|block|inline",
    "right": "<length>|<percentage>|auto",
    "rotate": "none|<angle>|[x|y|z|<number>{3}]&&<angle>",
    "row-gap": "normal|<length-percentage>",
    "ruby-align": "start|center|space-between|space-around",
    "ruby-merge": "separate|collapse|auto",
    "ruby-position": "[alternate||[over|under]]|inter-character",
    "scale": "none|<number>{1,3}",
    "scrollbar-color": "auto|<color>{2}",
    "scrollbar-gutter": "auto|stable&&both-edges?",
    "scrollbar-width": "auto|thin|none",
    "scroll-behavior": "auto|smooth",
    "scroll-margin": "<length>{1,4}",
    "scroll-margin-block": "<length>{1,2}",
    "scroll-margin-block-start": "<length>",
    "scroll-margin-block-end": "<length>",
    "scroll-margin-bottom": "<length>",
    "scroll-margin-inline": "<length>{1,2}",
    "scroll-margin-inline-start": "<length>",
    "scroll-margin-inline-end": "<length>",
    "scroll-margin-left": "<length>",
    "scroll-margin-right": "<length>",
    "scroll-margin-top": "<length>",
    "scroll-padding": "[auto|<length-percentage>]{1,4}",
    "scroll-padding-block": "[auto|<length-percentage>]{1,2}",
    "scroll-padding-block-start": "auto|<length-percentage>",
    "scroll-padding-block-end": "auto|<length-percentage>",
    "scroll-padding-bottom": "auto|<length-percentage>",
    "scroll-padding-inline": "[auto|<length-percentage>]{1,2}",
    "scroll-padding-inline-start": "auto|<length-percentage>",
    "scroll-padding-inline-end": "auto|<length-percentage>",
    "scroll-padding-left": "auto|<length-percentage>",
    "scroll-padding-right": "auto|<length-percentage>",
    "scroll-padding-top": "auto|<length-percentage>",
    "scroll-snap-align": "[none|start|end|center]{1,2}",
    "scroll-snap-coordinate": "none|<position>#",
    "scroll-snap-destination": "<position>",
    "scroll-snap-points-x": "none|repeat( <length-percentage> )",
    "scroll-snap-points-y": "none|repeat( <length-percentage> )",
    "scroll-snap-stop": "normal|always",
    "scroll-snap-type": "none|[x|y|block|inline|both] [mandatory|proximity]?",
    "scroll-snap-type-x": "none|mandatory|proximity",
    "scroll-snap-type-y": "none|mandatory|proximity",
    "scroll-timeline": "<scroll-timeline-name>||<scroll-timeline-axis>",
    "scroll-timeline-axis": "block|inline|vertical|horizontal",
    "scroll-timeline-name": "none|<custom-ident>",
    "shape-image-threshold": "<alpha-value>",
    "shape-margin": "<length-percentage>",
    "shape-outside": "none|[<shape-box>||<basic-shape>]|<image>",
    "tab-size": "<integer>|<length>",
    "table-layout": "auto|fixed",
    "text-align": "start|end|left|right|center|justify|match-parent",
    "text-align-last": "auto|start|end|left|right|center|justify",
    "text-combine-upright": "none|all|[digits <integer>?]",
    "text-decoration": "<'text-decoration-line'>||<'text-decoration-style'>||<'text-decoration-color'>||<'text-decoration-thickness'>",
    "text-decoration-color": "<color>",
    "text-decoration-line": "none|[underline||overline||line-through||blink]|spelling-error|grammar-error",
    "text-decoration-skip": "none|[objects||[spaces|[leading-spaces||trailing-spaces]]||edges||box-decoration]",
    "text-decoration-skip-ink": "auto|all|none",
    "text-decoration-style": "solid|double|dotted|dashed|wavy",
    "text-decoration-thickness": "auto|from-font|<length>|<percentage>",
    "text-emphasis": "<'text-emphasis-style'>||<'text-emphasis-color'>",
    "text-emphasis-color": "<color>",
    "text-emphasis-position": "[over|under]&&[right|left]",
    "text-emphasis-style": "none|[[filled|open]||[dot|circle|double-circle|triangle|sesame]]|<string>",
    "text-indent": "<length-percentage>&&hanging?&&each-line?",
    "text-justify": "auto|inter-character|inter-word|none",
    "text-orientation": "mixed|upright|sideways",
    "text-overflow": "[clip|ellipsis|<string>]{1,2}",
    "text-rendering": "auto|optimizeSpeed|optimizeLegibility|geometricPrecision",
    "text-shadow": "none|<shadow-t>#",
    "text-size-adjust": "none|auto|<percentage>",
    "text-transform": "none|capitalize|uppercase|lowercase|full-width|full-size-kana",
    "text-underline-offset": "auto|<length>|<percentage>",
    "text-underline-position": "auto|from-font|[under||[left|right]]",
    "top": "<length>|<percentage>|auto",
    "touch-action": "auto|none|[[pan-x|pan-left|pan-right]||[pan-y|pan-up|pan-down]||pinch-zoom]|manipulation",
    "transform": "none|<transform-list>",
    "transform-box": "content-box|border-box|fill-box|stroke-box|view-box",
    "transform-origin": "[<length-percentage>|left|center|right|top|bottom]|[[<length-percentage>|left|center|right]&&[<length-percentage>|top|center|bottom]] <length>?",
    "transform-style": "flat|preserve-3d",
    "transition": "<single-transition>#",
    "transition-delay": "<time>#",
    "transition-duration": "<time>#",
    "transition-property": "none|<single-transition-property>#",
    "transition-timing-function": "<easing-function>#",
    "translate": "none|<length-percentage> [<length-percentage> <length>?]?",
    "unicode-bidi": "normal|embed|isolate|bidi-override|isolate-override|plaintext|-moz-isolate|-moz-isolate-override|-moz-plaintext|-webkit-isolate|-webkit-isolate-override|-webkit-plaintext",
    "user-select": "auto|text|none|contain|all",
    "vertical-align": "baseline|sub|super|text-top|text-bottom|middle|top|bottom|<percentage>|<length>",
    "visibility": "visible|hidden|collapse",
    "white-space": "normal|pre|nowrap|pre-wrap|pre-line|break-spaces",
    "widows": "<integer>",
    "width": "auto|<length>|<percentage>|min-content|max-content|fit-content|fit-content( <length-percentage> )|fill|stretch|intrinsic|-moz-max-content|-webkit-max-content|-moz-fit-content|-webkit-fit-content",
    "will-change": "auto|<animateable-feature>#",
    "word-break": "normal|break-all|keep-all|break-word",
    "word-spacing": "normal|<length>",
    "word-wrap": "normal|break-word",
    "writing-mode": "horizontal-tb|vertical-rl|vertical-lr|sideways-rl|sideways-lr|<svg-writing-mode>",
    "z-index": "auto|<integer>",
    "zoom": "normal|reset|<number>|<percentage>",
    "-moz-background-clip": "padding|border",
    "-moz-border-radius-bottomleft": "<'border-bottom-left-radius'>",
    "-moz-border-radius-bottomright": "<'border-bottom-right-radius'>",
    "-moz-border-radius-topleft": "<'border-top-left-radius'>",
    "-moz-border-radius-topright": "<'border-bottom-right-radius'>",
    "-moz-control-character-visibility": "visible|hidden",
    "-moz-osx-font-smoothing": "auto|grayscale",
    "-moz-user-select": "none|text|all|-moz-none",
    "-ms-flex-align": "start|end|center|baseline|stretch",
    "-ms-flex-item-align": "auto|start|end|center|baseline|stretch",
    "-ms-flex-line-pack": "start|end|center|justify|distribute|stretch",
    "-ms-flex-negative": "<'flex-shrink'>",
    "-ms-flex-pack": "start|end|center|justify|distribute",
    "-ms-flex-order": "<integer>",
    "-ms-flex-positive": "<'flex-grow'>",
    "-ms-flex-preferred-size": "<'flex-basis'>",
    "-ms-interpolation-mode": "nearest-neighbor|bicubic",
    "-ms-grid-column-align": "start|end|center|stretch",
    "-ms-grid-row-align": "start|end|center|stretch",
    "-ms-hyphenate-limit-last": "none|always|column|page|spread",
    "-webkit-background-clip": "[<box>|border|padding|content|text]#",
    "-webkit-column-break-after": "always|auto|avoid",
    "-webkit-column-break-before": "always|auto|avoid",
    "-webkit-column-break-inside": "always|auto|avoid",
    "-webkit-font-smoothing": "auto|none|antialiased|subpixel-antialiased",
    "-webkit-mask-box-image": "[<url>|<gradient>|none] [<length-percentage>{4} <-webkit-mask-box-repeat>{2}]?",
    "-webkit-print-color-adjust": "economy|exact",
    "-webkit-text-security": "none|circle|disc|square",
    "-webkit-user-drag": "none|element|auto",
    "-webkit-user-select": "auto|none|text|all",
    "alignment-baseline": "auto|baseline|before-edge|text-before-edge|middle|central|after-edge|text-after-edge|ideographic|alphabetic|hanging|mathematical",
    "baseline-shift": "baseline|sub|super|<svg-length>",
    "behavior": "<url>+",
    "clip-rule": "nonzero|evenodd",
    "cue": "<'cue-before'> <'cue-after'>?",
    "cue-after": "<url> <decibel>?|none",
    "cue-before": "<url> <decibel>?|none",
    "dominant-baseline": "auto|use-script|no-change|reset-size|ideographic|alphabetic|hanging|mathematical|central|middle|text-after-edge|text-before-edge",
    "fill": "<paint>",
    "fill-opacity": "<number-zero-one>",
    "fill-rule": "nonzero|evenodd",
    "glyph-orientation-horizontal": "<angle>",
    "glyph-orientation-vertical": "<angle>",
    "kerning": "auto|<svg-length>",
    "marker": "none|<url>",
    "marker-end": "none|<url>",
    "marker-mid": "none|<url>",
    "marker-start": "none|<url>",
    "pause": "<'pause-before'> <'pause-after'>?",
    "pause-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "pause-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "rest": "<'rest-before'> <'rest-after'>?",
    "rest-after": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "rest-before": "<time>|none|x-weak|weak|medium|strong|x-strong",
    "shape-rendering": "auto|optimizeSpeed|crispEdges|geometricPrecision",
    "src": "[<url> [format( <string># )]?|local( <family-name> )]#",
    "speak": "auto|none|normal",
    "speak-as": "normal|spell-out||digits||[literal-punctuation|no-punctuation]",
    "stroke": "<paint>",
    "stroke-dasharray": "none|[<svg-length>+]#",
    "stroke-dashoffset": "<svg-length>",
    "stroke-linecap": "butt|round|square",
    "stroke-linejoin": "miter|round|bevel",
    "stroke-miterlimit": "<number-one-or-greater>",
    "stroke-opacity": "<number-zero-one>",
    "stroke-width": "<svg-length>",
    "text-anchor": "start|middle|end",
    "unicode-range": "<urange>#",
    "voice-balance": "<number>|left|center|right|leftwards|rightwards",
    "voice-duration": "auto|<time>",
    "voice-family": "[[<family-name>|<generic-voice>] ,]* [<family-name>|<generic-voice>]|preserve",
    "voice-pitch": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
    "voice-range": "<frequency>&&absolute|[[x-low|low|medium|high|x-high]||[<frequency>|<semitones>|<percentage>]]",
    "voice-rate": "[normal|x-slow|slow|medium|fast|x-fast]||<percentage>",
    "voice-stress": "normal|strong|moderate|none|reduced",
    "voice-volume": "silent|[[x-soft|soft|medium|loud|x-loud]||<decibel>]"
  },
  "atrules": {
    "charset": {
      "prelude": "<string>",
      "descriptors": null
    },
    "counter-style": {
      "prelude": "<counter-style-name>",
      "descriptors": {
        "additive-symbols": "[<integer>&&<symbol>]#",
        "fallback": "<counter-style-name>",
        "negative": "<symbol> <symbol>?",
        "pad": "<integer>&&<symbol>",
        "prefix": "<symbol>",
        "range": "[[<integer>|infinite]{2}]#|auto",
        "speak-as": "auto|bullets|numbers|words|spell-out|<counter-style-name>",
        "suffix": "<symbol>",
        "symbols": "<symbol>+",
        "system": "cyclic|numeric|alphabetic|symbolic|additive|[fixed <integer>?]|[extends <counter-style-name>]"
      }
    },
    "document": {
      "prelude": "[<url>|url-prefix( <string> )|domain( <string> )|media-document( <string> )|regexp( <string> )]#",
      "descriptors": null
    },
    "font-face": {
      "prelude": null,
      "descriptors": {
        "ascent-override": "normal|<percentage>",
        "descent-override": "normal|<percentage>",
        "font-display": "[auto|block|swap|fallback|optional]",
        "font-family": "<family-name>",
        "font-feature-settings": "normal|<feature-tag-value>#",
        "font-variation-settings": "normal|[<string> <number>]#",
        "font-stretch": "<font-stretch-absolute>{1,2}",
        "font-style": "normal|italic|oblique <angle>{0,2}",
        "font-weight": "<font-weight-absolute>{1,2}",
        "font-variant": "normal|none|[<common-lig-values>||<discretionary-lig-values>||<historical-lig-values>||<contextual-alt-values>||stylistic( <feature-value-name> )||historical-forms||styleset( <feature-value-name># )||character-variant( <feature-value-name># )||swash( <feature-value-name> )||ornaments( <feature-value-name> )||annotation( <feature-value-name> )||[small-caps|all-small-caps|petite-caps|all-petite-caps|unicase|titling-caps]||<numeric-figure-values>||<numeric-spacing-values>||<numeric-fraction-values>||ordinal||slashed-zero||<east-asian-variant-values>||<east-asian-width-values>||ruby]",
        "line-gap-override": "normal|<percentage>",
        "size-adjust": "<percentage>",
        "src": "[<url> [format( <string># )]?|local( <family-name> )]#",
        "unicode-range": "<urange>#"
      }
    },
    "font-feature-values": {
      "prelude": "<family-name>#",
      "descriptors": null
    },
    "import": {
      "prelude": "[<string>|<url>] [layer|layer( <layer-name> )]? [supports( [<supports-condition>|<declaration>] )]? <media-query-list>?",
      "descriptors": null
    },
    "keyframes": {
      "prelude": "<keyframes-name>",
      "descriptors": null
    },
    "layer": {
      "prelude": "[<layer-name>#|<layer-name>?]",
      "descriptors": null
    },
    "media": {
      "prelude": "<media-query-list>",
      "descriptors": null
    },
    "namespace": {
      "prelude": "<namespace-prefix>? [<string>|<url>]",
      "descriptors": null
    },
    "page": {
      "prelude": "<page-selector-list>",
      "descriptors": {
        "bleed": "auto|<length>",
        "marks": "none|[crop||cross]",
        "size": "<length>{1,2}|auto|[<page-size>||[portrait|landscape]]"
      }
    },
    "property": {
      "prelude": "<custom-property-name>",
      "descriptors": {
        "syntax": "<string>",
        "inherits": "true|false",
        "initial-value": "<string>"
      }
    },
    "scroll-timeline": {
      "prelude": "<timeline-name>",
      "descriptors": null
    },
    "supports": {
      "prelude": "<supports-condition>",
      "descriptors": null
    },
    "viewport": {
      "prelude": null,
      "descriptors": {
        "height": "<viewport-length>{1,2}",
        "max-height": "<viewport-length>",
        "max-width": "<viewport-length>",
        "max-zoom": "auto|<number>|<percentage>",
        "min-height": "<viewport-length>",
        "min-width": "<viewport-length>",
        "min-zoom": "auto|<number>|<percentage>",
        "orientation": "auto|portrait|landscape",
        "user-zoom": "zoom|fixed",
        "viewport-fit": "auto|contain|cover",
        "width": "<viewport-length>{1,2}",
        "zoom": "auto|<number>|<percentage>"
      }
    },
    "nest": {
      "prelude": "<complex-selector-list>",
      "descriptors": null
    }
  }
};
const PLUSSIGN$5 = 43;
const HYPHENMINUS$2 = 45;
const N$1 = 110;
const DISALLOW_SIGN = true;
const ALLOW_SIGN = false;
function checkInteger(offset, disallowSign) {
  let pos = this.tokenStart + offset;
  const code = this.charCodeAt(pos);
  if (code === PLUSSIGN$5 || code === HYPHENMINUS$2) {
    if (disallowSign) {
      this.error("Number sign is not allowed");
    }
    pos++;
  }
  for (; pos < this.tokenEnd; pos++) {
    if (!isDigit$1(this.charCodeAt(pos))) {
      this.error("Integer is expected", pos);
    }
  }
}
function checkTokenIsInteger(disallowSign) {
  return checkInteger.call(this, 0, disallowSign);
}
function expectCharCode(offset, code) {
  if (!this.cmpChar(this.tokenStart + offset, code)) {
    let msg2 = "";
    switch (code) {
      case N$1:
        msg2 = "N is expected";
        break;
      case HYPHENMINUS$2:
        msg2 = "HyphenMinus is expected";
        break;
    }
    this.error(msg2, this.tokenStart + offset);
  }
}
function consumeB() {
  let offset = 0;
  let sign = 0;
  let type4 = this.tokenType;
  while (type4 === WhiteSpace$1 || type4 === Comment$1) {
    type4 = this.lookupType(++offset);
  }
  if (type4 !== Number$2) {
    if (this.isDelim(PLUSSIGN$5, offset) || this.isDelim(HYPHENMINUS$2, offset)) {
      sign = this.isDelim(PLUSSIGN$5, offset) ? PLUSSIGN$5 : HYPHENMINUS$2;
      do {
        type4 = this.lookupType(++offset);
      } while (type4 === WhiteSpace$1 || type4 === Comment$1);
      if (type4 !== Number$2) {
        this.skip(offset);
        checkTokenIsInteger.call(this, DISALLOW_SIGN);
      }
    } else {
      return null;
    }
  }
  if (offset > 0) {
    this.skip(offset);
  }
  if (sign === 0) {
    type4 = this.charCodeAt(this.tokenStart);
    if (type4 !== PLUSSIGN$5 && type4 !== HYPHENMINUS$2) {
      this.error("Number sign is expected");
    }
  }
  checkTokenIsInteger.call(this, sign !== 0);
  return sign === HYPHENMINUS$2 ? "-" + this.consume(Number$2) : this.consume(Number$2);
}
const name$F = "AnPlusB";
const structure$E = {
  a: [String, null],
  b: [String, null]
};
function parse$G() {
  const start = this.tokenStart;
  let a2 = null;
  let b2 = null;
  if (this.tokenType === Number$2) {
    checkTokenIsInteger.call(this, ALLOW_SIGN);
    b2 = this.consume(Number$2);
  } else if (this.tokenType === Ident && this.cmpChar(this.tokenStart, HYPHENMINUS$2)) {
    a2 = "-1";
    expectCharCode.call(this, 1, N$1);
    switch (this.tokenEnd - this.tokenStart) {
      case 2:
        this.next();
        b2 = consumeB.call(this);
        break;
      case 3:
        expectCharCode.call(this, 2, HYPHENMINUS$2);
        this.next();
        this.skipSC();
        checkTokenIsInteger.call(this, DISALLOW_SIGN);
        b2 = "-" + this.consume(Number$2);
        break;
      default:
        expectCharCode.call(this, 2, HYPHENMINUS$2);
        checkInteger.call(this, 3, DISALLOW_SIGN);
        this.next();
        b2 = this.substrToCursor(start + 2);
    }
  } else if (this.tokenType === Ident || this.isDelim(PLUSSIGN$5) && this.lookupType(1) === Ident) {
    let sign = 0;
    a2 = "1";
    if (this.isDelim(PLUSSIGN$5)) {
      sign = 1;
      this.next();
    }
    expectCharCode.call(this, 0, N$1);
    switch (this.tokenEnd - this.tokenStart) {
      case 1:
        this.next();
        b2 = consumeB.call(this);
        break;
      case 2:
        expectCharCode.call(this, 1, HYPHENMINUS$2);
        this.next();
        this.skipSC();
        checkTokenIsInteger.call(this, DISALLOW_SIGN);
        b2 = "-" + this.consume(Number$2);
        break;
      default:
        expectCharCode.call(this, 1, HYPHENMINUS$2);
        checkInteger.call(this, 2, DISALLOW_SIGN);
        this.next();
        b2 = this.substrToCursor(start + sign + 1);
    }
  } else if (this.tokenType === Dimension$1) {
    const code = this.charCodeAt(this.tokenStart);
    const sign = code === PLUSSIGN$5 || code === HYPHENMINUS$2;
    let i2 = this.tokenStart + sign;
    for (; i2 < this.tokenEnd; i2++) {
      if (!isDigit$1(this.charCodeAt(i2))) {
        break;
      }
    }
    if (i2 === this.tokenStart + sign) {
      this.error("Integer is expected", this.tokenStart + sign);
    }
    expectCharCode.call(this, i2 - this.tokenStart, N$1);
    a2 = this.substring(start, i2);
    if (i2 + 1 === this.tokenEnd) {
      this.next();
      b2 = consumeB.call(this);
    } else {
      expectCharCode.call(this, i2 - this.tokenStart + 1, HYPHENMINUS$2);
      if (i2 + 2 === this.tokenEnd) {
        this.next();
        this.skipSC();
        checkTokenIsInteger.call(this, DISALLOW_SIGN);
        b2 = "-" + this.consume(Number$2);
      } else {
        checkInteger.call(this, i2 - this.tokenStart + 2, DISALLOW_SIGN);
        this.next();
        b2 = this.substrToCursor(i2 + 1);
      }
    }
  } else {
    this.error();
  }
  if (a2 !== null && a2.charCodeAt(0) === PLUSSIGN$5) {
    a2 = a2.substr(1);
  }
  if (b2 !== null && b2.charCodeAt(0) === PLUSSIGN$5) {
    b2 = b2.substr(1);
  }
  return {
    type: "AnPlusB",
    loc: this.getLocation(start, this.tokenStart),
    a: a2,
    b: b2
  };
}
function generate$F(node2) {
  if (node2.a) {
    const a2 = node2.a === "+1" && "n" || node2.a === "1" && "n" || node2.a === "-1" && "-n" || node2.a + "n";
    if (node2.b) {
      const b2 = node2.b[0] === "-" || node2.b[0] === "+" ? node2.b : "+" + node2.b;
      this.tokenize(a2 + b2);
    } else {
      this.tokenize(a2);
    }
  } else {
    this.tokenize(node2.b);
  }
}
var AnPlusB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$F,
  structure: structure$E,
  parse: parse$G,
  generate: generate$F
}, Symbol.toStringTag, { value: "Module" }));
function consumeRaw$5(startToken) {
  return this.Raw(startToken, this.consumeUntilLeftCurlyBracketOrSemicolon, true);
}
function isDeclarationBlockAtrule() {
  for (let offset = 1, type4; type4 = this.lookupType(offset); offset++) {
    if (type4 === RightCurlyBracket) {
      return true;
    }
    if (type4 === LeftCurlyBracket || type4 === AtKeyword) {
      return false;
    }
  }
  return false;
}
const name$E = "Atrule";
const walkContext$9 = "atrule";
const structure$D = {
  name: String,
  prelude: ["AtrulePrelude", "Raw", null],
  block: ["Block", null]
};
function parse$F(isDeclaration = false) {
  const start = this.tokenStart;
  let name2;
  let nameLowerCase;
  let prelude = null;
  let block = null;
  this.eat(AtKeyword);
  name2 = this.substrToCursor(start + 1);
  nameLowerCase = name2.toLowerCase();
  this.skipSC();
  if (this.eof === false && this.tokenType !== LeftCurlyBracket && this.tokenType !== Semicolon) {
    if (this.parseAtrulePrelude) {
      prelude = this.parseWithFallback(this.AtrulePrelude.bind(this, name2, isDeclaration), consumeRaw$5);
    } else {
      prelude = consumeRaw$5.call(this, this.tokenIndex);
    }
    this.skipSC();
  }
  switch (this.tokenType) {
    case Semicolon:
      this.next();
      break;
    case LeftCurlyBracket:
      if (hasOwnProperty.call(this.atrule, nameLowerCase) && typeof this.atrule[nameLowerCase].block === "function") {
        block = this.atrule[nameLowerCase].block.call(this, isDeclaration);
      } else {
        block = this.Block(isDeclarationBlockAtrule.call(this));
      }
      break;
  }
  return {
    type: "Atrule",
    loc: this.getLocation(start, this.tokenStart),
    name: name2,
    prelude,
    block
  };
}
function generate$E(node2) {
  this.token(AtKeyword, "@" + node2.name);
  if (node2.prelude !== null) {
    this.node(node2.prelude);
  }
  if (node2.block) {
    this.node(node2.block);
  } else {
    this.token(Semicolon, ";");
  }
}
var Atrule = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$E,
  walkContext: walkContext$9,
  structure: structure$D,
  parse: parse$F,
  generate: generate$E
}, Symbol.toStringTag, { value: "Module" }));
const name$D = "AtrulePrelude";
const walkContext$8 = "atrulePrelude";
const structure$C = {
  children: [[]]
};
function parse$E(name2) {
  let children = null;
  if (name2 !== null) {
    name2 = name2.toLowerCase();
  }
  this.skipSC();
  if (hasOwnProperty.call(this.atrule, name2) && typeof this.atrule[name2].prelude === "function") {
    children = this.atrule[name2].prelude.call(this);
  } else {
    children = this.readSequence(this.scope.AtrulePrelude);
  }
  this.skipSC();
  if (this.eof !== true && this.tokenType !== LeftCurlyBracket && this.tokenType !== Semicolon) {
    this.error("Semicolon or block is expected");
  }
  return {
    type: "AtrulePrelude",
    loc: this.getLocationFromList(children),
    children
  };
}
function generate$D(node2) {
  this.children(node2);
}
var AtrulePrelude = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$D,
  walkContext: walkContext$8,
  structure: structure$C,
  parse: parse$E,
  generate: generate$D
}, Symbol.toStringTag, { value: "Module" }));
const DOLLARSIGN$1 = 36;
const ASTERISK$5 = 42;
const EQUALSSIGN = 61;
const CIRCUMFLEXACCENT = 94;
const VERTICALLINE$2 = 124;
const TILDE$2 = 126;
function getAttributeName() {
  if (this.eof) {
    this.error("Unexpected end of input");
  }
  const start = this.tokenStart;
  let expectIdent = false;
  if (this.isDelim(ASTERISK$5)) {
    expectIdent = true;
    this.next();
  } else if (!this.isDelim(VERTICALLINE$2)) {
    this.eat(Ident);
  }
  if (this.isDelim(VERTICALLINE$2)) {
    if (this.charCodeAt(this.tokenStart + 1) !== EQUALSSIGN) {
      this.next();
      this.eat(Ident);
    } else if (expectIdent) {
      this.error("Identifier is expected", this.tokenEnd);
    }
  } else if (expectIdent) {
    this.error("Vertical line is expected");
  }
  return {
    type: "Identifier",
    loc: this.getLocation(start, this.tokenStart),
    name: this.substrToCursor(start)
  };
}
function getOperator() {
  const start = this.tokenStart;
  const code = this.charCodeAt(start);
  if (code !== EQUALSSIGN && code !== TILDE$2 && code !== CIRCUMFLEXACCENT && code !== DOLLARSIGN$1 && code !== ASTERISK$5 && code !== VERTICALLINE$2) {
    this.error("Attribute selector (=, ~=, ^=, $=, *=, |=) is expected");
  }
  this.next();
  if (code !== EQUALSSIGN) {
    if (!this.isDelim(EQUALSSIGN)) {
      this.error("Equal sign is expected");
    }
    this.next();
  }
  return this.substrToCursor(start);
}
const name$C = "AttributeSelector";
const structure$B = {
  name: "Identifier",
  matcher: [String, null],
  value: ["String", "Identifier", null],
  flags: [String, null]
};
function parse$D() {
  const start = this.tokenStart;
  let name2;
  let matcher = null;
  let value2 = null;
  let flags = null;
  this.eat(LeftSquareBracket);
  this.skipSC();
  name2 = getAttributeName.call(this);
  this.skipSC();
  if (this.tokenType !== RightSquareBracket) {
    if (this.tokenType !== Ident) {
      matcher = getOperator.call(this);
      this.skipSC();
      value2 = this.tokenType === String$2 ? this.String() : this.Identifier();
      this.skipSC();
    }
    if (this.tokenType === Ident) {
      flags = this.consume(Ident);
      this.skipSC();
    }
  }
  this.eat(RightSquareBracket);
  return {
    type: "AttributeSelector",
    loc: this.getLocation(start, this.tokenStart),
    name: name2,
    matcher,
    value: value2,
    flags
  };
}
function generate$C(node2) {
  this.token(Delim, "[");
  this.node(node2.name);
  if (node2.matcher !== null) {
    this.tokenize(node2.matcher);
    this.node(node2.value);
  }
  if (node2.flags !== null) {
    this.token(Ident, node2.flags);
  }
  this.token(Delim, "]");
}
var AttributeSelector = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$C,
  structure: structure$B,
  parse: parse$D,
  generate: generate$C
}, Symbol.toStringTag, { value: "Module" }));
const AMPERSAND$4 = 38;
function consumeRaw$4(startToken) {
  return this.Raw(startToken, null, true);
}
function consumeRule() {
  return this.parseWithFallback(this.Rule, consumeRaw$4);
}
function consumeRawDeclaration(startToken) {
  return this.Raw(startToken, this.consumeUntilSemicolonIncluded, true);
}
function consumeDeclaration() {
  if (this.tokenType === Semicolon) {
    return consumeRawDeclaration.call(this, this.tokenIndex);
  }
  const node2 = this.parseWithFallback(this.Declaration, consumeRawDeclaration);
  if (this.tokenType === Semicolon) {
    this.next();
  }
  return node2;
}
const name$B = "Block";
const walkContext$7 = "block";
const structure$A = {
  children: [[
    "Atrule",
    "Rule",
    "Declaration"
  ]]
};
function parse$C(isStyleBlock) {
  const consumer = isStyleBlock ? consumeDeclaration : consumeRule;
  const start = this.tokenStart;
  let children = this.createList();
  this.eat(LeftCurlyBracket);
  scan:
    while (!this.eof) {
      switch (this.tokenType) {
        case RightCurlyBracket:
          break scan;
        case WhiteSpace$1:
        case Comment$1:
          this.next();
          break;
        case AtKeyword:
          children.push(this.parseWithFallback(this.Atrule.bind(this, isStyleBlock), consumeRaw$4));
          break;
        default:
          if (isStyleBlock && this.isDelim(AMPERSAND$4)) {
            children.push(consumeRule.call(this));
          } else {
            children.push(consumer.call(this));
          }
      }
    }
  if (!this.eof) {
    this.eat(RightCurlyBracket);
  }
  return {
    type: "Block",
    loc: this.getLocation(start, this.tokenStart),
    children
  };
}
function generate$B(node2) {
  this.token(LeftCurlyBracket, "{");
  this.children(node2, (prev) => {
    if (prev.type === "Declaration") {
      this.token(Semicolon, ";");
    }
  });
  this.token(RightCurlyBracket, "}");
}
var Block = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$B,
  walkContext: walkContext$7,
  structure: structure$A,
  parse: parse$C,
  generate: generate$B
}, Symbol.toStringTag, { value: "Module" }));
const name$A = "Brackets";
const structure$z = {
  children: [[]]
};
function parse$B(readSequence2, recognizer) {
  const start = this.tokenStart;
  let children = null;
  this.eat(LeftSquareBracket);
  children = readSequence2.call(this, recognizer);
  if (!this.eof) {
    this.eat(RightSquareBracket);
  }
  return {
    type: "Brackets",
    loc: this.getLocation(start, this.tokenStart),
    children
  };
}
function generate$A(node2) {
  this.token(Delim, "[");
  this.children(node2);
  this.token(Delim, "]");
}
var Brackets$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$A,
  structure: structure$z,
  parse: parse$B,
  generate: generate$A
}, Symbol.toStringTag, { value: "Module" }));
const name$z = "CDC";
const structure$y = [];
function parse$A() {
  const start = this.tokenStart;
  this.eat(CDC$1);
  return {
    type: "CDC",
    loc: this.getLocation(start, this.tokenStart)
  };
}
function generate$z() {
  this.token(CDC$1, "-->");
}
var CDC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$z,
  structure: structure$y,
  parse: parse$A,
  generate: generate$z
}, Symbol.toStringTag, { value: "Module" }));
const name$y = "CDO";
const structure$x = [];
function parse$z() {
  const start = this.tokenStart;
  this.eat(CDO$1);
  return {
    type: "CDO",
    loc: this.getLocation(start, this.tokenStart)
  };
}
function generate$y() {
  this.token(CDO$1, "<!--");
}
var CDO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$y,
  structure: structure$x,
  parse: parse$z,
  generate: generate$y
}, Symbol.toStringTag, { value: "Module" }));
const FULLSTOP$2 = 46;
const name$x = "ClassSelector";
const structure$w = {
  name: String
};
function parse$y() {
  this.eatDelim(FULLSTOP$2);
  return {
    type: "ClassSelector",
    loc: this.getLocation(this.tokenStart - 1, this.tokenEnd),
    name: this.consume(Ident)
  };
}
function generate$x(node2) {
  this.token(Delim, ".");
  this.token(Ident, node2.name);
}
var ClassSelector = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$x,
  structure: structure$w,
  parse: parse$y,
  generate: generate$x
}, Symbol.toStringTag, { value: "Module" }));
const PLUSSIGN$4 = 43;
const SOLIDUS$5 = 47;
const GREATERTHANSIGN$1 = 62;
const TILDE$1 = 126;
const name$w = "Combinator";
const structure$v = {
  name: String
};
function parse$x() {
  const start = this.tokenStart;
  let name2;
  switch (this.tokenType) {
    case WhiteSpace$1:
      name2 = " ";
      break;
    case Delim:
      switch (this.charCodeAt(this.tokenStart)) {
        case GREATERTHANSIGN$1:
        case PLUSSIGN$4:
        case TILDE$1:
          this.next();
          break;
        case SOLIDUS$5:
          this.next();
          this.eatIdent("deep");
          this.eatDelim(SOLIDUS$5);
          break;
        default:
          this.error("Combinator is expected");
      }
      name2 = this.substrToCursor(start);
      break;
  }
  return {
    type: "Combinator",
    loc: this.getLocation(start, this.tokenStart),
    name: name2
  };
}
function generate$w(node2) {
  this.tokenize(node2.name);
}
var Combinator = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$w,
  structure: structure$v,
  parse: parse$x,
  generate: generate$w
}, Symbol.toStringTag, { value: "Module" }));
const ASTERISK$4 = 42;
const SOLIDUS$4 = 47;
const name$v = "Comment";
const structure$u = {
  value: String
};
function parse$w() {
  const start = this.tokenStart;
  let end = this.tokenEnd;
  this.eat(Comment$1);
  if (end - start + 2 >= 2 && this.charCodeAt(end - 2) === ASTERISK$4 && this.charCodeAt(end - 1) === SOLIDUS$4) {
    end -= 2;
  }
  return {
    type: "Comment",
    loc: this.getLocation(start, this.tokenStart),
    value: this.substring(start + 2, end)
  };
}
function generate$v(node2) {
  this.token(Comment$1, "/*" + node2.value + "*/");
}
var Comment = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$v,
  structure: structure$u,
  parse: parse$w,
  generate: generate$v
}, Symbol.toStringTag, { value: "Module" }));
const EXCLAMATIONMARK$1 = 33;
const NUMBERSIGN$2 = 35;
const DOLLARSIGN = 36;
const AMPERSAND$3 = 38;
const ASTERISK$3 = 42;
const PLUSSIGN$3 = 43;
const SOLIDUS$3 = 47;
function consumeValueRaw(startToken) {
  return this.Raw(startToken, this.consumeUntilExclamationMarkOrSemicolon, true);
}
function consumeCustomPropertyRaw(startToken) {
  return this.Raw(startToken, this.consumeUntilExclamationMarkOrSemicolon, false);
}
function consumeValue() {
  const startValueToken = this.tokenIndex;
  const value2 = this.Value();
  if (value2.type !== "Raw" && this.eof === false && this.tokenType !== Semicolon && this.isDelim(EXCLAMATIONMARK$1) === false && this.isBalanceEdge(startValueToken) === false) {
    this.error();
  }
  return value2;
}
const name$u = "Declaration";
const walkContext$6 = "declaration";
const structure$t = {
  important: [Boolean, String],
  property: String,
  value: ["Value", "Raw"]
};
function parse$v() {
  const start = this.tokenStart;
  const startToken = this.tokenIndex;
  const property2 = readProperty.call(this);
  const customProperty = isCustomProperty(property2);
  const parseValue = customProperty ? this.parseCustomProperty : this.parseValue;
  const consumeRaw2 = customProperty ? consumeCustomPropertyRaw : consumeValueRaw;
  let important = false;
  let value2;
  this.skipSC();
  this.eat(Colon);
  const valueStart = this.tokenIndex;
  if (!customProperty) {
    this.skipSC();
  }
  if (parseValue) {
    value2 = this.parseWithFallback(consumeValue, consumeRaw2);
  } else {
    value2 = consumeRaw2.call(this, this.tokenIndex);
  }
  if (customProperty && value2.type === "Value" && value2.children.isEmpty) {
    for (let offset = valueStart - this.tokenIndex; offset <= 0; offset++) {
      if (this.lookupType(offset) === WhiteSpace$1) {
        value2.children.appendData({
          type: "WhiteSpace",
          loc: null,
          value: " "
        });
        break;
      }
    }
  }
  if (this.isDelim(EXCLAMATIONMARK$1)) {
    important = getImportant.call(this);
    this.skipSC();
  }
  if (this.eof === false && this.tokenType !== Semicolon && this.isBalanceEdge(startToken) === false) {
    this.error();
  }
  return {
    type: "Declaration",
    loc: this.getLocation(start, this.tokenStart),
    important,
    property: property2,
    value: value2
  };
}
function generate$u(node2) {
  this.token(Ident, node2.property);
  this.token(Colon, ":");
  this.node(node2.value);
  if (node2.important) {
    this.token(Delim, "!");
    this.token(Ident, node2.important === true ? "important" : node2.important);
  }
}
function readProperty() {
  const start = this.tokenStart;
  if (this.tokenType === Delim) {
    switch (this.charCodeAt(this.tokenStart)) {
      case ASTERISK$3:
      case DOLLARSIGN:
      case PLUSSIGN$3:
      case NUMBERSIGN$2:
      case AMPERSAND$3:
        this.next();
        break;
      case SOLIDUS$3:
        this.next();
        if (this.isDelim(SOLIDUS$3)) {
          this.next();
        }
        break;
    }
  }
  if (this.tokenType === Hash$1) {
    this.eat(Hash$1);
  } else {
    this.eat(Ident);
  }
  return this.substrToCursor(start);
}
function getImportant() {
  this.eat(Delim);
  this.skipSC();
  const important = this.consume(Ident);
  return important === "important" ? true : important;
}
var Declaration = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$u,
  walkContext: walkContext$6,
  structure: structure$t,
  parse: parse$v,
  generate: generate$u
}, Symbol.toStringTag, { value: "Module" }));
const AMPERSAND$2 = 38;
function consumeRaw$3(startToken) {
  return this.Raw(startToken, this.consumeUntilSemicolonIncluded, true);
}
const name$t = "DeclarationList";
const structure$s = {
  children: [[
    "Declaration",
    "Atrule",
    "Rule"
  ]]
};
function parse$u() {
  const children = this.createList();
  while (!this.eof) {
    switch (this.tokenType) {
      case WhiteSpace$1:
      case Comment$1:
      case Semicolon:
        this.next();
        break;
      case AtKeyword:
        children.push(this.parseWithFallback(this.Atrule.bind(this, true), consumeRaw$3));
        break;
      default:
        if (this.isDelim(AMPERSAND$2)) {
          children.push(this.parseWithFallback(this.Rule, consumeRaw$3));
        } else {
          children.push(this.parseWithFallback(this.Declaration, consumeRaw$3));
        }
    }
  }
  return {
    type: "DeclarationList",
    loc: this.getLocationFromList(children),
    children
  };
}
function generate$t(node2) {
  this.children(node2, (prev) => {
    if (prev.type === "Declaration") {
      this.token(Semicolon, ";");
    }
  });
}
var DeclarationList = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$t,
  structure: structure$s,
  parse: parse$u,
  generate: generate$t
}, Symbol.toStringTag, { value: "Module" }));
const name$s = "Dimension";
const structure$r = {
  value: String,
  unit: String
};
function parse$t() {
  const start = this.tokenStart;
  const value2 = this.consumeNumber(Dimension$1);
  return {
    type: "Dimension",
    loc: this.getLocation(start, this.tokenStart),
    value: value2,
    unit: this.substring(start + value2.length, this.tokenStart)
  };
}
function generate$s(node2) {
  this.token(Dimension$1, node2.value + node2.unit);
}
var Dimension = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$s,
  structure: structure$r,
  parse: parse$t,
  generate: generate$s
}, Symbol.toStringTag, { value: "Module" }));
const name$r = "Function";
const walkContext$5 = "function";
const structure$q = {
  name: String,
  children: [[]]
};
function parse$s(readSequence2, recognizer) {
  const start = this.tokenStart;
  const name2 = this.consumeFunctionName();
  const nameLowerCase = name2.toLowerCase();
  let children;
  children = recognizer.hasOwnProperty(nameLowerCase) ? recognizer[nameLowerCase].call(this, recognizer) : readSequence2.call(this, recognizer);
  if (!this.eof) {
    this.eat(RightParenthesis);
  }
  return {
    type: "Function",
    loc: this.getLocation(start, this.tokenStart),
    name: name2,
    children
  };
}
function generate$r(node2) {
  this.token(Function$2, node2.name + "(");
  this.children(node2);
  this.token(RightParenthesis, ")");
}
var Function$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$r,
  walkContext: walkContext$5,
  structure: structure$q,
  parse: parse$s,
  generate: generate$r
}, Symbol.toStringTag, { value: "Module" }));
const xxx = "XXX";
const name$q = "Hash";
const structure$p = {
  value: String
};
function parse$r() {
  const start = this.tokenStart;
  this.eat(Hash$1);
  return {
    type: "Hash",
    loc: this.getLocation(start, this.tokenStart),
    value: this.substrToCursor(start + 1)
  };
}
function generate$q(node2) {
  this.token(Hash$1, "#" + node2.value);
}
var Hash = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  xxx,
  name: name$q,
  structure: structure$p,
  parse: parse$r,
  generate: generate$q
}, Symbol.toStringTag, { value: "Module" }));
const name$p = "Identifier";
const structure$o = {
  name: String
};
function parse$q() {
  return {
    type: "Identifier",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    name: this.consume(Ident)
  };
}
function generate$p(node2) {
  this.token(Ident, node2.name);
}
var Identifier$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$p,
  structure: structure$o,
  parse: parse$q,
  generate: generate$p
}, Symbol.toStringTag, { value: "Module" }));
const name$o = "IdSelector";
const structure$n = {
  name: String
};
function parse$p() {
  const start = this.tokenStart;
  this.eat(Hash$1);
  return {
    type: "IdSelector",
    loc: this.getLocation(start, this.tokenStart),
    name: this.substrToCursor(start + 1)
  };
}
function generate$o(node2) {
  this.token(Delim, "#" + node2.name);
}
var IdSelector = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$o,
  structure: structure$n,
  parse: parse$p,
  generate: generate$o
}, Symbol.toStringTag, { value: "Module" }));
const name$n = "MediaFeature";
const structure$m = {
  name: String,
  value: ["Identifier", "Number", "Dimension", "Ratio", null]
};
function parse$o() {
  const start = this.tokenStart;
  let name2;
  let value2 = null;
  this.eat(LeftParenthesis);
  this.skipSC();
  name2 = this.consume(Ident);
  this.skipSC();
  if (this.tokenType !== RightParenthesis) {
    this.eat(Colon);
    this.skipSC();
    switch (this.tokenType) {
      case Number$2:
        if (this.lookupNonWSType(1) === Delim) {
          value2 = this.Ratio();
        } else {
          value2 = this.Number();
        }
        break;
      case Dimension$1:
        value2 = this.Dimension();
        break;
      case Ident:
        value2 = this.Identifier();
        break;
      default:
        this.error("Number, dimension, ratio or identifier is expected");
    }
    this.skipSC();
  }
  this.eat(RightParenthesis);
  return {
    type: "MediaFeature",
    loc: this.getLocation(start, this.tokenStart),
    name: name2,
    value: value2
  };
}
function generate$n(node2) {
  this.token(LeftParenthesis, "(");
  this.token(Ident, node2.name);
  if (node2.value !== null) {
    this.token(Colon, ":");
    this.node(node2.value);
  }
  this.token(RightParenthesis, ")");
}
var MediaFeature = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$n,
  structure: structure$m,
  parse: parse$o,
  generate: generate$n
}, Symbol.toStringTag, { value: "Module" }));
const name$m = "MediaQuery";
const structure$l = {
  children: [[
    "Identifier",
    "MediaFeature",
    "WhiteSpace"
  ]]
};
function parse$n() {
  const children = this.createList();
  let child = null;
  this.skipSC();
  scan:
    while (!this.eof) {
      switch (this.tokenType) {
        case Comment$1:
        case WhiteSpace$1:
          this.next();
          continue;
        case Ident:
          child = this.Identifier();
          break;
        case LeftParenthesis:
          child = this.MediaFeature();
          break;
        default:
          break scan;
      }
      children.push(child);
    }
  if (child === null) {
    this.error("Identifier or parenthesis is expected");
  }
  return {
    type: "MediaQuery",
    loc: this.getLocationFromList(children),
    children
  };
}
function generate$m(node2) {
  this.children(node2);
}
var MediaQuery = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$m,
  structure: structure$l,
  parse: parse$n,
  generate: generate$m
}, Symbol.toStringTag, { value: "Module" }));
const name$l = "MediaQueryList";
const structure$k = {
  children: [[
    "MediaQuery"
  ]]
};
function parse$m() {
  const children = this.createList();
  this.skipSC();
  while (!this.eof) {
    children.push(this.MediaQuery());
    if (this.tokenType !== Comma) {
      break;
    }
    this.next();
  }
  return {
    type: "MediaQueryList",
    loc: this.getLocationFromList(children),
    children
  };
}
function generate$l(node2) {
  this.children(node2, () => this.token(Comma, ","));
}
var MediaQueryList = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$l,
  structure: structure$k,
  parse: parse$m,
  generate: generate$l
}, Symbol.toStringTag, { value: "Module" }));
const AMPERSAND$1 = 38;
const name$k = "NestingSelector";
const structure$j = {};
function parse$l() {
  const start = this.tokenStart;
  this.eatDelim(AMPERSAND$1);
  return {
    type: "NestingSelector",
    loc: this.getLocation(start, this.tokenStart)
  };
}
function generate$k() {
  this.token(Delim, "&");
}
var NestingSelector = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$k,
  structure: structure$j,
  parse: parse$l,
  generate: generate$k
}, Symbol.toStringTag, { value: "Module" }));
const name$j = "Nth";
const structure$i = {
  nth: ["AnPlusB", "Identifier"],
  selector: ["SelectorList", null]
};
function parse$k() {
  this.skipSC();
  const start = this.tokenStart;
  let end = start;
  let selector2 = null;
  let nth2;
  if (this.lookupValue(0, "odd") || this.lookupValue(0, "even")) {
    nth2 = this.Identifier();
  } else {
    nth2 = this.AnPlusB();
  }
  end = this.tokenStart;
  this.skipSC();
  if (this.lookupValue(0, "of")) {
    this.next();
    selector2 = this.SelectorList();
    end = this.tokenStart;
  }
  return {
    type: "Nth",
    loc: this.getLocation(start, end),
    nth: nth2,
    selector: selector2
  };
}
function generate$j(node2) {
  this.node(node2.nth);
  if (node2.selector !== null) {
    this.token(Ident, "of");
    this.node(node2.selector);
  }
}
var Nth = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$j,
  structure: structure$i,
  parse: parse$k,
  generate: generate$j
}, Symbol.toStringTag, { value: "Module" }));
const name$i = "Number";
const structure$h = {
  value: String
};
function parse$j() {
  return {
    type: "Number",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: this.consume(Number$2)
  };
}
function generate$i(node2) {
  this.token(Number$2, node2.value);
}
var Number$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$i,
  structure: structure$h,
  parse: parse$j,
  generate: generate$i
}, Symbol.toStringTag, { value: "Module" }));
const name$h = "Operator";
const structure$g = {
  value: String
};
function parse$i() {
  const start = this.tokenStart;
  this.next();
  return {
    type: "Operator",
    loc: this.getLocation(start, this.tokenStart),
    value: this.substrToCursor(start)
  };
}
function generate$h(node2) {
  this.tokenize(node2.value);
}
var Operator = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$h,
  structure: structure$g,
  parse: parse$i,
  generate: generate$h
}, Symbol.toStringTag, { value: "Module" }));
const name$g = "Parentheses";
const structure$f = {
  children: [[]]
};
function parse$h(readSequence2, recognizer) {
  const start = this.tokenStart;
  let children = null;
  this.eat(LeftParenthesis);
  children = readSequence2.call(this, recognizer);
  if (!this.eof) {
    this.eat(RightParenthesis);
  }
  return {
    type: "Parentheses",
    loc: this.getLocation(start, this.tokenStart),
    children
  };
}
function generate$g(node2) {
  this.token(LeftParenthesis, "(");
  this.children(node2);
  this.token(RightParenthesis, ")");
}
var Parentheses = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$g,
  structure: structure$f,
  parse: parse$h,
  generate: generate$g
}, Symbol.toStringTag, { value: "Module" }));
const name$f = "Percentage";
const structure$e = {
  value: String
};
function parse$g() {
  return {
    type: "Percentage",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: this.consumeNumber(Percentage$1)
  };
}
function generate$f(node2) {
  this.token(Percentage$1, node2.value + "%");
}
var Percentage = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$f,
  structure: structure$e,
  parse: parse$g,
  generate: generate$f
}, Symbol.toStringTag, { value: "Module" }));
const name$e = "PseudoClassSelector";
const walkContext$4 = "function";
const structure$d = {
  name: String,
  children: [["Raw"], null]
};
function parse$f() {
  const start = this.tokenStart;
  let children = null;
  let name2;
  let nameLowerCase;
  this.eat(Colon);
  if (this.tokenType === Function$2) {
    name2 = this.consumeFunctionName();
    nameLowerCase = name2.toLowerCase();
    if (hasOwnProperty.call(this.pseudo, nameLowerCase)) {
      this.skipSC();
      children = this.pseudo[nameLowerCase].call(this);
      this.skipSC();
    } else {
      children = this.createList();
      children.push(this.Raw(this.tokenIndex, null, false));
    }
    this.eat(RightParenthesis);
  } else {
    name2 = this.consume(Ident);
  }
  return {
    type: "PseudoClassSelector",
    loc: this.getLocation(start, this.tokenStart),
    name: name2,
    children
  };
}
function generate$e(node2) {
  this.token(Colon, ":");
  if (node2.children === null) {
    this.token(Ident, node2.name);
  } else {
    this.token(Function$2, node2.name + "(");
    this.children(node2);
    this.token(RightParenthesis, ")");
  }
}
var PseudoClassSelector = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$e,
  walkContext: walkContext$4,
  structure: structure$d,
  parse: parse$f,
  generate: generate$e
}, Symbol.toStringTag, { value: "Module" }));
const name$d = "PseudoElementSelector";
const walkContext$3 = "function";
const structure$c = {
  name: String,
  children: [["Raw"], null]
};
function parse$e() {
  const start = this.tokenStart;
  let children = null;
  let name2;
  let nameLowerCase;
  this.eat(Colon);
  this.eat(Colon);
  if (this.tokenType === Function$2) {
    name2 = this.consumeFunctionName();
    nameLowerCase = name2.toLowerCase();
    if (hasOwnProperty.call(this.pseudo, nameLowerCase)) {
      this.skipSC();
      children = this.pseudo[nameLowerCase].call(this);
      this.skipSC();
    } else {
      children = this.createList();
      children.push(this.Raw(this.tokenIndex, null, false));
    }
    this.eat(RightParenthesis);
  } else {
    name2 = this.consume(Ident);
  }
  return {
    type: "PseudoElementSelector",
    loc: this.getLocation(start, this.tokenStart),
    name: name2,
    children
  };
}
function generate$d(node2) {
  this.token(Colon, ":");
  this.token(Colon, ":");
  if (node2.children === null) {
    this.token(Ident, node2.name);
  } else {
    this.token(Function$2, node2.name + "(");
    this.children(node2);
    this.token(RightParenthesis, ")");
  }
}
var PseudoElementSelector = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$d,
  walkContext: walkContext$3,
  structure: structure$c,
  parse: parse$e,
  generate: generate$d
}, Symbol.toStringTag, { value: "Module" }));
const SOLIDUS$2 = 47;
const FULLSTOP$1 = 46;
function consumeNumber() {
  this.skipSC();
  const value2 = this.consume(Number$2);
  for (let i2 = 0; i2 < value2.length; i2++) {
    const code = value2.charCodeAt(i2);
    if (!isDigit$1(code) && code !== FULLSTOP$1) {
      this.error("Unsigned number is expected", this.tokenStart - value2.length + i2);
    }
  }
  if (Number(value2) === 0) {
    this.error("Zero number is not allowed", this.tokenStart - value2.length);
  }
  return value2;
}
const name$c = "Ratio";
const structure$b = {
  left: String,
  right: String
};
function parse$d() {
  const start = this.tokenStart;
  const left = consumeNumber.call(this);
  let right;
  this.skipSC();
  this.eatDelim(SOLIDUS$2);
  right = consumeNumber.call(this);
  return {
    type: "Ratio",
    loc: this.getLocation(start, this.tokenStart),
    left,
    right
  };
}
function generate$c(node2) {
  this.token(Number$2, node2.left);
  this.token(Delim, "/");
  this.token(Number$2, node2.right);
}
var Ratio = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$c,
  structure: structure$b,
  parse: parse$d,
  generate: generate$c
}, Symbol.toStringTag, { value: "Module" }));
function getOffsetExcludeWS() {
  if (this.tokenIndex > 0) {
    if (this.lookupType(-1) === WhiteSpace$1) {
      return this.tokenIndex > 1 ? this.getTokenStart(this.tokenIndex - 1) : this.firstCharOffset;
    }
  }
  return this.tokenStart;
}
const name$b = "Raw";
const structure$a = {
  value: String
};
function parse$c(startToken, consumeUntil, excludeWhiteSpace) {
  const startOffset = this.getTokenStart(startToken);
  let endOffset;
  this.skipUntilBalanced(startToken, consumeUntil || this.consumeUntilBalanceEnd);
  if (excludeWhiteSpace && this.tokenStart > startOffset) {
    endOffset = getOffsetExcludeWS.call(this);
  } else {
    endOffset = this.tokenStart;
  }
  return {
    type: "Raw",
    loc: this.getLocation(startOffset, endOffset),
    value: this.substring(startOffset, endOffset)
  };
}
function generate$b(node2) {
  this.tokenize(node2.value);
}
var Raw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$b,
  structure: structure$a,
  parse: parse$c,
  generate: generate$b
}, Symbol.toStringTag, { value: "Module" }));
function consumeRaw$2(startToken) {
  return this.Raw(startToken, this.consumeUntilLeftCurlyBracket, true);
}
function consumePrelude() {
  const prelude = this.SelectorList();
  if (prelude.type !== "Raw" && this.eof === false && this.tokenType !== LeftCurlyBracket) {
    this.error();
  }
  return prelude;
}
const name$a = "Rule";
const walkContext$2 = "rule";
const structure$9 = {
  prelude: ["SelectorList", "Raw"],
  block: ["Block"]
};
function parse$b() {
  const startToken = this.tokenIndex;
  const startOffset = this.tokenStart;
  let prelude;
  let block;
  if (this.parseRulePrelude) {
    prelude = this.parseWithFallback(consumePrelude, consumeRaw$2);
  } else {
    prelude = consumeRaw$2.call(this, startToken);
  }
  block = this.Block(true);
  return {
    type: "Rule",
    loc: this.getLocation(startOffset, this.tokenStart),
    prelude,
    block
  };
}
function generate$a(node2) {
  this.node(node2.prelude);
  this.node(node2.block);
}
var Rule$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$a,
  walkContext: walkContext$2,
  structure: structure$9,
  parse: parse$b,
  generate: generate$a
}, Symbol.toStringTag, { value: "Module" }));
const name$9 = "Selector";
const structure$8 = {
  children: [[
    "TypeSelector",
    "IdSelector",
    "ClassSelector",
    "AttributeSelector",
    "PseudoClassSelector",
    "PseudoElementSelector",
    "Combinator",
    "WhiteSpace"
  ]]
};
function parse$a() {
  const children = this.readSequence(this.scope.Selector);
  if (this.getFirstListNode(children) === null) {
    this.error("Selector is expected");
  }
  return {
    type: "Selector",
    loc: this.getLocationFromList(children),
    children
  };
}
function generate$9(node2) {
  this.children(node2);
}
var Selector = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$9,
  structure: structure$8,
  parse: parse$a,
  generate: generate$9
}, Symbol.toStringTag, { value: "Module" }));
const name$8 = "SelectorList";
const walkContext$1 = "selector";
const structure$7 = {
  children: [[
    "Selector",
    "Raw"
  ]]
};
function parse$9() {
  const children = this.createList();
  while (!this.eof) {
    children.push(this.Selector());
    if (this.tokenType === Comma) {
      this.next();
      continue;
    }
    break;
  }
  return {
    type: "SelectorList",
    loc: this.getLocationFromList(children),
    children
  };
}
function generate$8(node2) {
  this.children(node2, () => this.token(Comma, ","));
}
var SelectorList = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$8,
  walkContext: walkContext$1,
  structure: structure$7,
  parse: parse$9,
  generate: generate$8
}, Symbol.toStringTag, { value: "Module" }));
const REVERSE_SOLIDUS$1 = 92;
const QUOTATION_MARK$1 = 34;
const APOSTROPHE$1 = 39;
function decode$1(str) {
  const len2 = str.length;
  const firstChar = str.charCodeAt(0);
  const start = firstChar === QUOTATION_MARK$1 || firstChar === APOSTROPHE$1 ? 1 : 0;
  const end = start === 1 && len2 > 1 && str.charCodeAt(len2 - 1) === firstChar ? len2 - 2 : len2 - 1;
  let decoded = "";
  for (let i2 = start; i2 <= end; i2++) {
    let code = str.charCodeAt(i2);
    if (code === REVERSE_SOLIDUS$1) {
      if (i2 === end) {
        if (i2 !== len2 - 1) {
          decoded = str.substr(i2 + 1);
        }
        break;
      }
      code = str.charCodeAt(++i2);
      if (isValidEscape(REVERSE_SOLIDUS$1, code)) {
        const escapeStart = i2 - 1;
        const escapeEnd = consumeEscaped(str, escapeStart);
        i2 = escapeEnd - 1;
        decoded += decodeEscaped(str.substring(escapeStart + 1, escapeEnd));
      } else {
        if (code === 13 && str.charCodeAt(i2 + 1) === 10) {
          i2++;
        }
      }
    } else {
      decoded += str[i2];
    }
  }
  return decoded;
}
function encode$1(str, apostrophe) {
  const quote = apostrophe ? "'" : '"';
  const quoteCode = apostrophe ? APOSTROPHE$1 : QUOTATION_MARK$1;
  let encoded = "";
  let wsBeforeHexIsNeeded = false;
  for (let i2 = 0; i2 < str.length; i2++) {
    const code = str.charCodeAt(i2);
    if (code === 0) {
      encoded += "\uFFFD";
      continue;
    }
    if (code <= 31 || code === 127) {
      encoded += "\\" + code.toString(16);
      wsBeforeHexIsNeeded = true;
      continue;
    }
    if (code === quoteCode || code === REVERSE_SOLIDUS$1) {
      encoded += "\\" + str.charAt(i2);
      wsBeforeHexIsNeeded = false;
    } else {
      if (wsBeforeHexIsNeeded && (isHexDigit(code) || isWhiteSpace(code))) {
        encoded += " ";
      }
      encoded += str.charAt(i2);
      wsBeforeHexIsNeeded = false;
    }
  }
  return quote + encoded + quote;
}
const name$7 = "String";
const structure$6 = {
  value: String
};
function parse$8() {
  return {
    type: "String",
    loc: this.getLocation(this.tokenStart, this.tokenEnd),
    value: decode$1(this.consume(String$2))
  };
}
function generate$7(node2) {
  this.token(String$2, encode$1(node2.value));
}
var String$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$7,
  structure: structure$6,
  parse: parse$8,
  generate: generate$7
}, Symbol.toStringTag, { value: "Module" }));
const EXCLAMATIONMARK = 33;
function consumeRaw$1(startToken) {
  return this.Raw(startToken, null, false);
}
const name$6 = "StyleSheet";
const walkContext = "stylesheet";
const structure$5 = {
  children: [[
    "Comment",
    "CDO",
    "CDC",
    "Atrule",
    "Rule",
    "Raw"
  ]]
};
function parse$7() {
  const start = this.tokenStart;
  const children = this.createList();
  let child;
  while (!this.eof) {
    switch (this.tokenType) {
      case WhiteSpace$1:
        this.next();
        continue;
      case Comment$1:
        if (this.charCodeAt(this.tokenStart + 2) !== EXCLAMATIONMARK) {
          this.next();
          continue;
        }
        child = this.Comment();
        break;
      case CDO$1:
        child = this.CDO();
        break;
      case CDC$1:
        child = this.CDC();
        break;
      case AtKeyword:
        child = this.parseWithFallback(this.Atrule, consumeRaw$1);
        break;
      default:
        child = this.parseWithFallback(this.Rule, consumeRaw$1);
    }
    children.push(child);
  }
  return {
    type: "StyleSheet",
    loc: this.getLocation(start, this.tokenStart),
    children
  };
}
function generate$6(node2) {
  this.children(node2);
}
var StyleSheet = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$6,
  walkContext,
  structure: structure$5,
  parse: parse$7,
  generate: generate$6
}, Symbol.toStringTag, { value: "Module" }));
const ASTERISK$2 = 42;
const VERTICALLINE$1 = 124;
function eatIdentifierOrAsterisk() {
  if (this.tokenType !== Ident && this.isDelim(ASTERISK$2) === false) {
    this.error("Identifier or asterisk is expected");
  }
  this.next();
}
const name$5 = "TypeSelector";
const structure$4 = {
  name: String
};
function parse$6() {
  const start = this.tokenStart;
  if (this.isDelim(VERTICALLINE$1)) {
    this.next();
    eatIdentifierOrAsterisk.call(this);
  } else {
    eatIdentifierOrAsterisk.call(this);
    if (this.isDelim(VERTICALLINE$1)) {
      this.next();
      eatIdentifierOrAsterisk.call(this);
    }
  }
  return {
    type: "TypeSelector",
    loc: this.getLocation(start, this.tokenStart),
    name: this.substrToCursor(start)
  };
}
function generate$5(node2) {
  this.tokenize(node2.name);
}
var TypeSelector = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$5,
  structure: structure$4,
  parse: parse$6,
  generate: generate$5
}, Symbol.toStringTag, { value: "Module" }));
const PLUSSIGN$2 = 43;
const HYPHENMINUS$1 = 45;
const QUESTIONMARK = 63;
function eatHexSequence(offset, allowDash) {
  let len2 = 0;
  for (let pos = this.tokenStart + offset; pos < this.tokenEnd; pos++) {
    const code = this.charCodeAt(pos);
    if (code === HYPHENMINUS$1 && allowDash && len2 !== 0) {
      eatHexSequence.call(this, offset + len2 + 1, false);
      return -1;
    }
    if (!isHexDigit(code)) {
      this.error(allowDash && len2 !== 0 ? "Hyphen minus" + (len2 < 6 ? " or hex digit" : "") + " is expected" : len2 < 6 ? "Hex digit is expected" : "Unexpected input", pos);
    }
    if (++len2 > 6) {
      this.error("Too many hex digits", pos);
    }
  }
  this.next();
  return len2;
}
function eatQuestionMarkSequence(max) {
  let count = 0;
  while (this.isDelim(QUESTIONMARK)) {
    if (++count > max) {
      this.error("Too many question marks");
    }
    this.next();
  }
}
function startsWith(code) {
  if (this.charCodeAt(this.tokenStart) !== code) {
    this.error((code === PLUSSIGN$2 ? "Plus sign" : "Hyphen minus") + " is expected");
  }
}
function scanUnicodeRange() {
  let hexLength = 0;
  switch (this.tokenType) {
    case Number$2:
      hexLength = eatHexSequence.call(this, 1, true);
      if (this.isDelim(QUESTIONMARK)) {
        eatQuestionMarkSequence.call(this, 6 - hexLength);
        break;
      }
      if (this.tokenType === Dimension$1 || this.tokenType === Number$2) {
        startsWith.call(this, HYPHENMINUS$1);
        eatHexSequence.call(this, 1, false);
        break;
      }
      break;
    case Dimension$1:
      hexLength = eatHexSequence.call(this, 1, true);
      if (hexLength > 0) {
        eatQuestionMarkSequence.call(this, 6 - hexLength);
      }
      break;
    default:
      this.eatDelim(PLUSSIGN$2);
      if (this.tokenType === Ident) {
        hexLength = eatHexSequence.call(this, 0, true);
        if (hexLength > 0) {
          eatQuestionMarkSequence.call(this, 6 - hexLength);
        }
        break;
      }
      if (this.isDelim(QUESTIONMARK)) {
        this.next();
        eatQuestionMarkSequence.call(this, 5);
        break;
      }
      this.error("Hex digit or question mark is expected");
  }
}
const name$4 = "UnicodeRange";
const structure$3 = {
  value: String
};
function parse$5() {
  const start = this.tokenStart;
  this.eatIdent("u");
  scanUnicodeRange.call(this);
  return {
    type: "UnicodeRange",
    loc: this.getLocation(start, this.tokenStart),
    value: this.substrToCursor(start)
  };
}
function generate$4(node2) {
  this.tokenize(node2.value);
}
var UnicodeRange = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$4,
  structure: structure$3,
  parse: parse$5,
  generate: generate$4
}, Symbol.toStringTag, { value: "Module" }));
const SPACE$1 = 32;
const REVERSE_SOLIDUS = 92;
const QUOTATION_MARK = 34;
const APOSTROPHE = 39;
const LEFTPARENTHESIS = 40;
const RIGHTPARENTHESIS = 41;
function decode(str) {
  const len2 = str.length;
  let start = 4;
  let end = str.charCodeAt(len2 - 1) === RIGHTPARENTHESIS ? len2 - 2 : len2 - 1;
  let decoded = "";
  while (start < end && isWhiteSpace(str.charCodeAt(start))) {
    start++;
  }
  while (start < end && isWhiteSpace(str.charCodeAt(end))) {
    end--;
  }
  for (let i2 = start; i2 <= end; i2++) {
    let code = str.charCodeAt(i2);
    if (code === REVERSE_SOLIDUS) {
      if (i2 === end) {
        if (i2 !== len2 - 1) {
          decoded = str.substr(i2 + 1);
        }
        break;
      }
      code = str.charCodeAt(++i2);
      if (isValidEscape(REVERSE_SOLIDUS, code)) {
        const escapeStart = i2 - 1;
        const escapeEnd = consumeEscaped(str, escapeStart);
        i2 = escapeEnd - 1;
        decoded += decodeEscaped(str.substring(escapeStart + 1, escapeEnd));
      } else {
        if (code === 13 && str.charCodeAt(i2 + 1) === 10) {
          i2++;
        }
      }
    } else {
      decoded += str[i2];
    }
  }
  return decoded;
}
function encode(str) {
  let encoded = "";
  let wsBeforeHexIsNeeded = false;
  for (let i2 = 0; i2 < str.length; i2++) {
    const code = str.charCodeAt(i2);
    if (code === 0) {
      encoded += "\uFFFD";
      continue;
    }
    if (code <= 31 || code === 127) {
      encoded += "\\" + code.toString(16);
      wsBeforeHexIsNeeded = true;
      continue;
    }
    if (code === SPACE$1 || code === REVERSE_SOLIDUS || code === QUOTATION_MARK || code === APOSTROPHE || code === LEFTPARENTHESIS || code === RIGHTPARENTHESIS) {
      encoded += "\\" + str.charAt(i2);
      wsBeforeHexIsNeeded = false;
    } else {
      if (wsBeforeHexIsNeeded && isHexDigit(code)) {
        encoded += " ";
      }
      encoded += str.charAt(i2);
      wsBeforeHexIsNeeded = false;
    }
  }
  return "url(" + encoded + ")";
}
const name$3 = "Url";
const structure$2 = {
  value: String
};
function parse$4() {
  const start = this.tokenStart;
  let value2;
  switch (this.tokenType) {
    case Url$1:
      value2 = decode(this.consume(Url$1));
      break;
    case Function$2:
      if (!this.cmpStr(this.tokenStart, this.tokenEnd, "url(")) {
        this.error("Function name must be `url`");
      }
      this.eat(Function$2);
      this.skipSC();
      value2 = decode$1(this.consume(String$2));
      this.skipSC();
      if (!this.eof) {
        this.eat(RightParenthesis);
      }
      break;
    default:
      this.error("Url or Function is expected");
  }
  return {
    type: "Url",
    loc: this.getLocation(start, this.tokenStart),
    value: value2
  };
}
function generate$3(node2) {
  this.token(Url$1, encode(node2.value));
}
var Url = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$3,
  structure: structure$2,
  parse: parse$4,
  generate: generate$3
}, Symbol.toStringTag, { value: "Module" }));
const name$2 = "Value";
const structure$1 = {
  children: [[]]
};
function parse$3() {
  const start = this.tokenStart;
  const children = this.readSequence(this.scope.Value);
  return {
    type: "Value",
    loc: this.getLocation(start, this.tokenStart),
    children
  };
}
function generate$2(node2) {
  this.children(node2);
}
var Value = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$2,
  structure: structure$1,
  parse: parse$3,
  generate: generate$2
}, Symbol.toStringTag, { value: "Module" }));
const SPACE = Object.freeze({
  type: "WhiteSpace",
  loc: null,
  value: " "
});
const name$1 = "WhiteSpace";
const structure = {
  value: String
};
function parse$2() {
  this.eat(WhiteSpace$1);
  return SPACE;
}
function generate$1(node2) {
  this.token(WhiteSpace$1, node2.value);
}
var WhiteSpace = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$1,
  structure,
  parse: parse$2,
  generate: generate$1
}, Symbol.toStringTag, { value: "Module" }));
var node$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnPlusB,
  Atrule,
  AtrulePrelude,
  AttributeSelector,
  Block,
  Brackets: Brackets$1,
  CDC,
  CDO,
  ClassSelector,
  Combinator,
  Comment,
  Declaration,
  DeclarationList,
  Dimension,
  Function: Function$1,
  Hash,
  Identifier: Identifier$1,
  IdSelector,
  MediaFeature,
  MediaQuery,
  MediaQueryList,
  NestingSelector,
  Nth,
  Number: Number$1,
  Operator,
  Parentheses,
  Percentage,
  PseudoClassSelector,
  PseudoElementSelector,
  Ratio,
  Raw,
  Rule: Rule$1,
  Selector,
  SelectorList,
  String: String$1,
  StyleSheet,
  TypeSelector,
  UnicodeRange,
  Url,
  Value,
  WhiteSpace
}, Symbol.toStringTag, { value: "Module" }));
var lexerConfig = __spreadProps(__spreadValues({
  generic: true
}, definitions), {
  node: node$1
});
const NUMBERSIGN$1 = 35;
const ASTERISK$1 = 42;
const PLUSSIGN$1 = 43;
const HYPHENMINUS = 45;
const SOLIDUS$1 = 47;
const U$1 = 117;
function defaultRecognizer(context) {
  switch (this.tokenType) {
    case Hash$1:
      return this.Hash();
    case Comma:
      return this.Operator();
    case LeftParenthesis:
      return this.Parentheses(this.readSequence, context.recognizer);
    case LeftSquareBracket:
      return this.Brackets(this.readSequence, context.recognizer);
    case String$2:
      return this.String();
    case Dimension$1:
      return this.Dimension();
    case Percentage$1:
      return this.Percentage();
    case Number$2:
      return this.Number();
    case Function$2:
      return this.cmpStr(this.tokenStart, this.tokenEnd, "url(") ? this.Url() : this.Function(this.readSequence, context.recognizer);
    case Url$1:
      return this.Url();
    case Ident:
      if (this.cmpChar(this.tokenStart, U$1) && this.cmpChar(this.tokenStart + 1, PLUSSIGN$1)) {
        return this.UnicodeRange();
      } else {
        return this.Identifier();
      }
    case Delim: {
      const code = this.charCodeAt(this.tokenStart);
      if (code === SOLIDUS$1 || code === ASTERISK$1 || code === PLUSSIGN$1 || code === HYPHENMINUS) {
        return this.Operator();
      }
      if (code === NUMBERSIGN$1) {
        this.error("Hex or identifier is expected", this.tokenStart + 1);
      }
      break;
    }
  }
}
var atrulePrelude = {
  getNode: defaultRecognizer
};
const NUMBERSIGN = 35;
const AMPERSAND = 38;
const ASTERISK = 42;
const PLUSSIGN = 43;
const SOLIDUS = 47;
const FULLSTOP = 46;
const GREATERTHANSIGN = 62;
const VERTICALLINE = 124;
const TILDE = 126;
function onWhiteSpace(next, children) {
  if (children.last !== null && children.last.type !== "Combinator" && next !== null && next.type !== "Combinator") {
    children.push({
      type: "Combinator",
      loc: null,
      name: " "
    });
  }
}
function getNode() {
  switch (this.tokenType) {
    case LeftSquareBracket:
      return this.AttributeSelector();
    case Hash$1:
      return this.IdSelector();
    case Colon:
      if (this.lookupType(1) === Colon) {
        return this.PseudoElementSelector();
      } else {
        return this.PseudoClassSelector();
      }
    case Ident:
      return this.TypeSelector();
    case Number$2:
    case Percentage$1:
      return this.Percentage();
    case Dimension$1:
      if (this.charCodeAt(this.tokenStart) === FULLSTOP) {
        this.error("Identifier is expected", this.tokenStart + 1);
      }
      break;
    case Delim: {
      const code = this.charCodeAt(this.tokenStart);
      switch (code) {
        case PLUSSIGN:
        case GREATERTHANSIGN:
        case TILDE:
        case SOLIDUS:
          return this.Combinator();
        case FULLSTOP:
          return this.ClassSelector();
        case ASTERISK:
        case VERTICALLINE:
          return this.TypeSelector();
        case NUMBERSIGN:
          return this.IdSelector();
        case AMPERSAND:
          return this.NestingSelector();
      }
      break;
    }
  }
}
var selector$1 = {
  onWhiteSpace,
  getNode
};
function expressionFn() {
  return this.createSingleNodeList(this.Raw(this.tokenIndex, null, false));
}
function varFn() {
  const children = this.createList();
  this.skipSC();
  children.push(this.Identifier());
  this.skipSC();
  if (this.tokenType === Comma) {
    children.push(this.Operator());
    const startIndex = this.tokenIndex;
    const value2 = this.parseCustomProperty ? this.Value(null) : this.Raw(this.tokenIndex, this.consumeUntilExclamationMarkOrSemicolon, false);
    if (value2.type === "Value" && value2.children.isEmpty) {
      for (let offset = startIndex - this.tokenIndex; offset <= 0; offset++) {
        if (this.lookupType(offset) === WhiteSpace$1) {
          value2.children.appendData({
            type: "WhiteSpace",
            loc: null,
            value: " "
          });
          break;
        }
      }
    }
    children.push(value2);
  }
  return children;
}
function isPlusMinusOperator(node2) {
  return node2 !== null && node2.type === "Operator" && (node2.value[node2.value.length - 1] === "-" || node2.value[node2.value.length - 1] === "+");
}
var value = {
  getNode: defaultRecognizer,
  onWhiteSpace(next, children) {
    if (isPlusMinusOperator(next)) {
      next.value = " " + next.value;
    }
    if (isPlusMinusOperator(children.last)) {
      children.last.value += " ";
    }
  },
  "expression": expressionFn,
  "var": varFn
};
var scope = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AtrulePrelude: atrulePrelude,
  Selector: selector$1,
  Value: value
}, Symbol.toStringTag, { value: "Module" }));
var fontFace = {
  parse: {
    prelude: null,
    block() {
      return this.Block(true);
    }
  }
};
var importAtrule = {
  parse: {
    prelude() {
      const children = this.createList();
      this.skipSC();
      switch (this.tokenType) {
        case String$2:
          children.push(this.String());
          break;
        case Url$1:
        case Function$2:
          children.push(this.Url());
          break;
        default:
          this.error("String or url() is expected");
      }
      if (this.lookupNonWSType(0) === Ident || this.lookupNonWSType(0) === LeftParenthesis) {
        children.push(this.MediaQueryList());
      }
      return children;
    },
    block: null
  }
};
var media = {
  parse: {
    prelude() {
      return this.createSingleNodeList(this.MediaQueryList());
    },
    block(isStyleBlock = false) {
      return this.Block(isStyleBlock);
    }
  }
};
var nest = {
  parse: {
    prelude() {
      return this.createSingleNodeList(this.SelectorList());
    },
    block() {
      return this.Block(true);
    }
  }
};
var page = {
  parse: {
    prelude() {
      return this.createSingleNodeList(this.SelectorList());
    },
    block() {
      return this.Block(true);
    }
  }
};
function consumeRaw() {
  return this.createSingleNodeList(this.Raw(this.tokenIndex, null, false));
}
function parentheses() {
  this.skipSC();
  if (this.tokenType === Ident && this.lookupNonWSType(1) === Colon) {
    return this.createSingleNodeList(this.Declaration());
  }
  return readSequence.call(this);
}
function readSequence() {
  const children = this.createList();
  let child;
  this.skipSC();
  scan:
    while (!this.eof) {
      switch (this.tokenType) {
        case Comment$1:
        case WhiteSpace$1:
          this.next();
          continue;
        case Function$2:
          child = this.Function(consumeRaw, this.scope.AtrulePrelude);
          break;
        case Ident:
          child = this.Identifier();
          break;
        case LeftParenthesis:
          child = this.Parentheses(parentheses, this.scope.AtrulePrelude);
          break;
        default:
          break scan;
      }
      children.push(child);
    }
  return children;
}
var supports = {
  parse: {
    prelude() {
      const children = readSequence.call(this);
      if (this.getFirstListNode(children) === null) {
        this.error("Condition is expected");
      }
      return children;
    },
    block(isStyleBlock = false) {
      return this.Block(isStyleBlock);
    }
  }
};
var atrule = {
  "font-face": fontFace,
  "import": importAtrule,
  media,
  nest,
  page,
  supports
};
const selectorList = {
  parse() {
    return this.createSingleNodeList(this.SelectorList());
  }
};
const selector = {
  parse() {
    return this.createSingleNodeList(this.Selector());
  }
};
const identList = {
  parse() {
    return this.createSingleNodeList(this.Identifier());
  }
};
const nth = {
  parse() {
    return this.createSingleNodeList(this.Nth());
  }
};
var pseudo = {
  "dir": identList,
  "has": selectorList,
  "lang": identList,
  "matches": selectorList,
  "is": selectorList,
  "-moz-any": selectorList,
  "-webkit-any": selectorList,
  "where": selectorList,
  "not": selectorList,
  "nth-child": nth,
  "nth-last-child": nth,
  "nth-last-of-type": nth,
  "nth-of-type": nth,
  "slotted": selector,
  "host": selector,
  "host-context": selector
};
var node = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnPlusB: parse$G,
  Atrule: parse$F,
  AtrulePrelude: parse$E,
  AttributeSelector: parse$D,
  Block: parse$C,
  Brackets: parse$B,
  CDC: parse$A,
  CDO: parse$z,
  ClassSelector: parse$y,
  Combinator: parse$x,
  Comment: parse$w,
  Declaration: parse$v,
  DeclarationList: parse$u,
  Dimension: parse$t,
  Function: parse$s,
  Hash: parse$r,
  Identifier: parse$q,
  IdSelector: parse$p,
  MediaFeature: parse$o,
  MediaQuery: parse$n,
  MediaQueryList: parse$m,
  NestingSelector: parse$l,
  Nth: parse$k,
  Number: parse$j,
  Operator: parse$i,
  Parentheses: parse$h,
  Percentage: parse$g,
  PseudoClassSelector: parse$f,
  PseudoElementSelector: parse$e,
  Ratio: parse$d,
  Raw: parse$c,
  Rule: parse$b,
  Selector: parse$a,
  SelectorList: parse$9,
  String: parse$8,
  StyleSheet: parse$7,
  TypeSelector: parse$6,
  UnicodeRange: parse$5,
  Url: parse$4,
  Value: parse$3,
  WhiteSpace: parse$2
}, Symbol.toStringTag, { value: "Module" }));
var parserConfig = {
  parseContext: {
    default: "StyleSheet",
    stylesheet: "StyleSheet",
    atrule: "Atrule",
    atrulePrelude(options) {
      return this.AtrulePrelude(options.atrule ? String(options.atrule) : null);
    },
    mediaQueryList: "MediaQueryList",
    mediaQuery: "MediaQuery",
    rule: "Rule",
    selectorList: "SelectorList",
    selector: "Selector",
    block() {
      return this.Block(true);
    },
    declarationList: "DeclarationList",
    declaration: "Declaration",
    value: "Value"
  },
  scope,
  atrule,
  pseudo,
  node
};
var walkerConfig = {
  node: node$1
};
var syntax$1 = createSyntax$1(__spreadValues(__spreadValues(__spreadValues({}, lexerConfig), parserConfig), walkerConfig));
const {
  tokenize,
  parse: parse$1,
  generate,
  lexer,
  createLexer,
  walk,
  find: find$1,
  findLast,
  findAll,
  toPlainObject,
  fromPlainObject,
  fork
} = syntax$1;
const syntax = lexer;
function isTargetError(error) {
  if (!error) {
    return null;
  }
  if (error.name !== "SyntaxError" && error.name !== "SyntaxMatchError" && error.name !== "SyntaxReferenceError") {
    return null;
  }
  return error;
}
function validateAtrule(node2) {
  const atrule2 = node2.name;
  const errors = [];
  let error;
  if (error = isTargetError(syntax.checkAtruleName(atrule2))) {
    errors.push(Object.assign(error, __spreadValues({
      atrule: atrule2
    }, node2.loc && node2.loc.start)));
    return errors;
  }
  errors.push(...validateAtrulePrelude(atrule2, node2.prelude, node2.prelude && node2.prelude.loc && node2.prelude.loc.start || node2.loc && node2.loc.start));
  if (node2.block && node2.block.children) {
    node2.block.children.forEach((child) => {
      if (child.type === "Declaration") {
        errors.push(...validateAtruleDescriptor(atrule2, child.property, child.value, child.loc && child.loc.start));
      }
    });
  }
  return errors;
}
function validateAtrulePrelude(atrule2, prelude, preludeLoc) {
  const errors = [];
  let error;
  if (error = isTargetError(syntax.checkAtrulePrelude(atrule2, prelude))) {
    errors.push(Object.assign(error, __spreadValues({
      atrule: atrule2
    }, preludeLoc)));
  } else if (error = isTargetError(syntax.matchAtrulePrelude(atrule2, prelude).error)) {
    errors.push(Object.assign(error, __spreadValues({
      atrule: atrule2
    }, error.rawMessage === "Mismatch" && {
      details: error.message,
      message: "Invalid value for `@" + atrule2 + "` prelude"
    })));
  }
  return errors;
}
function validateAtruleDescriptor(atrule2, descriptor, value2, descriptorLoc) {
  const errors = [];
  let error;
  if (error = isTargetError(syntax.checkAtruleDescriptorName(atrule2, descriptor))) {
    errors.push(Object.assign(error, __spreadValues({
      atrule: atrule2,
      descriptor
    }, descriptorLoc)));
  } else {
    if (error = isTargetError(syntax.matchAtruleDescriptor(atrule2, descriptor, value2).error)) {
      errors.push(Object.assign(error, __spreadValues({
        atrule: atrule2,
        descriptor
      }, error.rawMessage === "Mismatch" && {
        details: error.message,
        message: "Invalid value for `" + descriptor + "` descriptor"
      })));
    }
  }
  return errors;
}
function validateDeclaration(property$12, value2, valueLoc) {
  const errors = [];
  let error;
  if (property(property$12).custom) {
    return errors;
  }
  if (error = isTargetError(syntax.checkPropertyName(property$12))) {
    errors.push(Object.assign(error, __spreadValues({
      property: property$12
    }, valueLoc)));
  } else if (error = isTargetError(syntax.matchProperty(property$12, value2).error)) {
    errors.push(Object.assign(error, __spreadValues({
      property: property$12
    }, error.rawMessage === "Mismatch" && {
      details: error.message,
      message: "Invalid value for `" + property$12 + "` property"
    })));
  }
  return errors;
}
function validateRule(node2) {
  const errors = [];
  if (node2.block && node2.block.children) {
    node2.block.children.forEach((child) => {
      if (child.type === "Declaration") {
        errors.push(...validateDeclaration(child.property, child.value, child.loc && child.loc.start));
      }
    });
  }
  return errors;
}
function validate(css2, filename) {
  const errors = [];
  const ast = typeof css2 !== "string" ? css2 : parse$1(css2, {
    filename,
    positions: true,
    parseAtrulePrelude: false,
    parseRulePrelude: false,
    parseValue: false,
    parseCustomProperty: false,
    onParseError(error) {
      errors.push(error);
    }
  });
  walk(ast, {
    visit: "Atrule",
    enter(node2) {
      errors.push(...validateAtrule(node2));
    }
  });
  walk(ast, {
    visit: "Rule",
    enter(node2) {
      errors.push(...validateRule(node2));
    }
  });
  return errors;
}
var ActionTypes;
(function(ActionTypes2) {
  ActionTypes2["setDefault"] = "setDefault";
  ActionTypes2["setCurrentToAll"] = "setCurrentToAll";
  ActionTypes2["setAuto"] = "setAuto";
  ActionTypes2["setAutoToAll"] = "setAutoToAll";
  ActionTypes2["removeCurrent"] = "removeCurrent";
  ActionTypes2["removeAll"] = "removeAll";
})(ActionTypes || (ActionTypes = {}));
const baseOptions = [
  {
    key: ActionTypes.setDefault,
    label: `Set value to 20px`
  },
  {
    key: ActionTypes.setCurrentToAll,
    label: "Set all values to this value"
  },
  {
    key: ActionTypes.setAuto,
    label: "Set value to auto"
  },
  {
    key: ActionTypes.setAutoToAll,
    label: "Set all values to auto"
  },
  {
    key: ActionTypes.removeCurrent,
    label: "Remove current value"
  },
  {
    key: ActionTypes.removeAll,
    label: "Remove all values"
  }
];
var Input_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$g = ["id"];
const _sfc_main$v = /* @__PURE__ */ defineComponent({
  __name: "Input",
  props: {
    id: String,
    value: String,
    spaceType: {
      type: String,
      required: true
    },
    positionType: {
      type: String,
      required: true
    },
    defaultValue: {
      type: String,
      required: true
    },
    showSuggestions: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:value", "update:action"],
  setup(__props, { emit }) {
    const props = __props;
    const attributeValue = ref(props == null ? void 0 : props.value);
    const handleActionClick = (key) => {
      switch (key) {
        case ActionTypes.setAuto:
        case ActionTypes.setAutoToAll: {
          emit("update:action", {
            spaceType: props.spaceType,
            position: props.positionType,
            actionType: key,
            value: "auto"
          });
          break;
        }
        case ActionTypes.setCurrentToAll: {
          emit("update:action", {
            spaceType: props.spaceType,
            position: props.positionType,
            actionType: key,
            value: props.value
          });
          break;
        }
        case ActionTypes.setDefault: {
          emit("update:action", {
            spaceType: props.spaceType,
            position: props.positionType,
            actionType: key,
            value: props.defaultValue
          });
          break;
        }
        case ActionTypes.removeAll:
        case ActionTypes.removeCurrent: {
          emit("update:action", {
            spaceType: props.spaceType,
            position: props.positionType,
            actionType: key,
            value: null
          });
          break;
        }
        default: {
          emit("update:action", {
            spaceType: props.spaceType,
            position: props.positionType,
            actionType: ActionTypes.setAuto,
            value: "auto"
          });
          break;
        }
      }
    };
    const validateCss = (cssString) => {
      const validationErrors = validate(cssString, null);
      if (validationErrors.length) {
        return false;
      }
      return true;
    };
    const handleBlur = (payload) => {
      const input = payload.target.value;
      const cssString = `.some{${props.spaceType}-${props.positionType} : ${input}}`;
      const value2 = validateCss(cssString) ? input : "";
      attributeValue.value = value2;
      emit("update:value", {
        spaceType: props.spaceType,
        position: props.positionType,
        value: value2
      });
    };
    onUpdated(() => {
      attributeValue.value = props.value;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", { id: __props.id }, [
        createVNode(unref(NInputGroup), null, {
          default: withCtx(() => [
            withDirectives(createElementVNode("input", {
              placeholder: "0px",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => attributeValue.value = $event),
              onBlur: handleBlur
            }, null, 544), [
              [vModelText, attributeValue.value]
            ]),
            __props.showSuggestions ? (openBlock(), createBlock(unref(NDropdown), {
              key: 0,
              trigger: "click",
              options: unref(baseOptions),
              onSelect: handleActionClick
            }, {
              default: withCtx(() => [
                createVNode(unref(NButton), {
                  size: "small",
                  quaternary: "",
                  style: { padding: "0px" },
                  text: ""
                }, {
                  icon: withCtx(() => [
                    createVNode(unref(NIcon), {
                      depth: "3",
                      size: "12px"
                    }, {
                      default: withCtx(() => [
                        createVNode(unref(render$42))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["options"])) : createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 8, _hoisted_1$g);
    };
  }
});
var Input = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["__scopeId", "data-v-f69f2b7c"]]);
var Spacing_vue_vue_type_style_index_0_scoped_true_lang = "";
const _withScopeId = (n2) => (pushScopeId("data-v-e22ddb48"), n2 = n2(), popScopeId(), n2);
const _hoisted_1$f = { class: "ghl-spacing margin" };
const _hoisted_2$c = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "ghl-spacing__title" }, "Margin", -1));
const _hoisted_3$b = { class: "ghl-spacing__children" };
const _hoisted_4$7 = { class: "ghl-spacing padding" };
const _hoisted_5$5 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "ghl-spacing__title" }, "padding", -1));
const _hoisted_6$5 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("div", { class: "padding--children empty" }, null, -1));
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "Spacing",
  props: {
    margin: {
      type: Object,
      default: () => ({
        top: null,
        bottom: null,
        left: null,
        right: null
      })
    },
    marginPositions: {
      type: Array,
      default: ["top", "bottom", "right", "left"]
    },
    padding: {
      type: Object,
      default: () => ({
        top: null,
        bottom: null,
        left: null,
        right: null
      })
    },
    paddingPositions: {
      type: Array,
      default: ["top", "bottom", "right", "left"]
    },
    showSuggestions: {
      type: Boolean,
      default: true
    }
  },
  emits: ["update:value"],
  setup(__props, { emit }) {
    const props = __props;
    const spacings = ref({ margin: props.margin, padding: props.padding });
    watch(() => props.margin, (newMarginValues) => {
      spacings.value.margin = newMarginValues;
    });
    watch(() => props.padding, (newPaddingValues) => {
      spacings.value.padding = newPaddingValues;
    });
    const handleChange = ({
      spaceType,
      position,
      value: value2
    }) => {
      spacings.value[spaceType][position] = value2;
      emit("update:value", {
        changed: { [spaceType]: { [position]: value2 } },
        value: spacings.value
      });
    };
    const handleActionClick = ({
      actionType,
      spaceType,
      position,
      value: value2
    }) => {
      switch (actionType) {
        case ActionTypes.setAuto:
        case ActionTypes.setDefault:
        case ActionTypes.removeCurrent:
        default: {
          spacings.value[spaceType][position] = value2;
          emit("update:value", {
            changed: { [spaceType]: { [position]: value2 } },
            value: spacings.value
          });
          break;
        }
        case ActionTypes.setCurrentToAll:
        case ActionTypes.setAutoToAll:
        case ActionTypes.removeAll: {
          const positions = Object.keys(spacings.value[spaceType]);
          positions.forEach((position2) => {
            spacings.value[spaceType][position2] = value2;
          });
          emit("update:value", {
            changed: spacings.value,
            value: spacings.value
          });
          break;
        }
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$f, [
        _hoisted_2$c,
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.marginPositions, (marginPosition) => {
          return openBlock(), createElementBlock("div", {
            class: normalizeClass(["ghl-spacing__input", `margin--${marginPosition}`]),
            key: marginPosition
          }, [
            createVNode(Input, {
              positionType: marginPosition,
              spaceType: "margin",
              "onUpdate:value": handleChange,
              "onUpdate:action": handleActionClick,
              defaultValue: "20px",
              value: spacings.value.margin[marginPosition],
              showSuggestions: __props.showSuggestions
            }, null, 8, ["positionType", "value", "showSuggestions"])
          ], 2);
        }), 128)),
        createElementVNode("div", _hoisted_3$b, [
          createElementVNode("div", _hoisted_4$7, [
            _hoisted_5$5,
            (openBlock(true), createElementBlock(Fragment, null, renderList(__props.paddingPositions, (paddingPosition) => {
              return openBlock(), createElementBlock("div", {
                class: normalizeClass(["ghl-spacing__input", `padding--${paddingPosition}`]),
                key: paddingPosition
              }, [
                createVNode(Input, {
                  positionType: paddingPosition,
                  spaceType: "padding",
                  "onUpdate:value": handleChange,
                  "onUpdate:action": handleActionClick,
                  defaultValue: "20px",
                  value: spacings.value.padding[paddingPosition],
                  showSuggestions: __props.showSuggestions
                }, null, 8, ["positionType", "value", "showSuggestions"])
              ], 2);
            }), 128)),
            _hoisted_6$5
          ])
        ])
      ]);
    };
  }
});
var UIBuilderSpace = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["__scopeId", "data-v-e22ddb48"]]);
UIBuilderSpace.install = (Vue) => {
  Vue.component(UIBuilderSpace.name, UIBuilderSpace);
};
var Card_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$e = {
  key: 0,
  class: "hl-card-header"
};
const _hoisted_2$b = { class: "hl-card-content" };
const _hoisted_3$a = {
  key: 1,
  class: "hl-card-footer"
};
const __default__$r = defineComponent({
  name: "UICard",
  inheritAttrs: false
});
const _sfc_main$t = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$r), {
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, { class: "hl-card" }), [
        unref(slots).header ? (openBlock(), createElementBlock("div", _hoisted_1$e, [
          renderSlot(_ctx.$slots, "header")
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_2$b, [
          renderSlot(_ctx.$slots, "default")
        ]),
        unref(slots).footer ? (openBlock(), createElementBlock("div", _hoisted_3$a, [
          renderSlot(_ctx.$slots, "footer")
        ])) : createCommentVNode("", true)
      ], 16);
    };
  }
}));
_sfc_main$t.install = (Vue) => {
  Vue.component(_sfc_main$t.name, _sfc_main$t);
};
var Carousel_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$d = ["src"];
const __default__$q = defineComponent({
  name: "UICarousel",
  inheritAttrs: false,
  components: { NCarousel, NCarouselItem }
});
const _sfc_main$s = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$q), {
  props: {
    showArrow: Boolean,
    autoPlay: Boolean,
    direction: {
      type: String,
      default: "horizontal"
    },
    dotPlacement: {
      type: String,
      default: "bottom"
    },
    dotType: {
      type: String,
      default: "dot"
    },
    itemsPerView: {
      type: [Number, String],
      default: 1
    },
    spaceBetweenItems: {
      type: Number,
      default: 0
    },
    draggable: Boolean,
    loop: Boolean,
    centeredItems: Boolean,
    mousewheel: Boolean,
    showDots: Boolean,
    interval: {
      type: Number,
      default: 5e3
    },
    effect: {
      type: String,
      default: "slide"
    },
    touchable: {
      type: Boolean,
      default: true
    },
    transitionProps: {
      type: Object,
      default: void 0
    },
    transitionStyle: {
      type: Object,
      default: () => ({
        transitionDuration: "300ms"
      })
    },
    carouselItems: {
      type: Array,
      default: void 0
    },
    classNames: String
  },
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NCarousel), {
        "show-arrow": __props.showArrow,
        autoplay: __props.autoPlay,
        direction: __props.direction,
        "dot-type": __props.dotType,
        "dot-placement": __props.dotPlacement,
        class: normalizeClass(__props.classNames),
        "slides-per-view": __props.itemsPerView,
        "space-between": __props.spaceBetweenItems,
        draggable: __props.draggable,
        loop: __props.loop,
        "centered-slides": __props.centeredItems,
        mousewheel: __props.mousewheel,
        "show-dots": __props.showDots,
        touchable: __props.touchable,
        interval: __props.interval,
        effect: __props.effect,
        "transition-props": __props.transitionProps,
        "transition-style": __props.transitionStyle
      }, createSlots({
        dots: withCtx(({ total, currentIndex, to: to2 }) => [
          renderSlot(_ctx.$slots, "customDots", {
            total,
            currentIndex,
            changeTo: to2
          }, void 0, true)
        ]),
        default: withCtx(() => [
          unref(slots).customRender ? renderSlot(_ctx.$slots, "customRender", { key: 0 }, void 0, true) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(__props.carouselItems, (carouselItem) => {
            return openBlock(), createBlock(unref(NCarouselItem), {
              key: carouselItem.key,
              class: normalizeClass(carouselItem == null ? void 0 : carouselItem.class)
            }, {
              default: withCtx(() => [
                createElementVNode("img", {
                  src: carouselItem.src,
                  class: normalizeClass(`ghl-carousel-image-${carouselItem.key}`)
                }, null, 10, _hoisted_1$d)
              ]),
              _: 2
            }, 1032, ["class"]);
          }), 128))
        ]),
        _: 2
      }, [
        unref(slots).customArrows ? {
          name: "arrow",
          fn: withCtx(({ prev, next }) => [
            renderSlot(_ctx.$slots, "customArrows", {
              prev,
              next
            }, void 0, true)
          ])
        } : void 0
      ]), 1032, ["show-arrow", "autoplay", "direction", "dot-type", "dot-placement", "class", "slides-per-view", "space-between", "draggable", "loop", "centered-slides", "mousewheel", "show-dots", "touchable", "interval", "effect", "transition-props", "transition-style"]);
    };
  }
}));
var UICarousel = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["__scopeId", "data-v-1fb8b5d2"]]);
UICarousel.install = (Vue) => {
  Vue.component(UICarousel.name, UICarousel);
};
const __default__$p = defineComponent({
  name: "UICheckbox",
  inheritAttrs: false
});
const _sfc_main$r = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$p), {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    }
  },
  emits: ["update:checked"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NCheckbox), mergeProps({
        id: __props.id,
        disabled: __props.disabled
      }, _ctx.$attrs, {
        checked: __props.checked,
        size: "large",
        "onUpdate:checked": _cache[0] || (_cache[0] = (value2) => _ctx.$emit("update:checked", value2))
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "disabled", "checked"]);
    };
  }
}));
_sfc_main$r.install = (Vue) => {
  Vue.component(_sfc_main$r.name, _sfc_main$r);
};
const DefaultBufferLength = 1024;
let nextPropID = 0;
class Range$1 {
  constructor(from, to2) {
    this.from = from;
    this.to = to2;
  }
}
class NodeProp {
  constructor(config2 = {}) {
    this.id = nextPropID++;
    this.perNode = !!config2.perNode;
    this.deserialize = config2.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  add(match2) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    if (typeof match2 != "function")
      match2 = NodeType.match(match2);
    return (type4) => {
      let result2 = match2(type4);
      return result2 === void 0 ? null : [this, result2];
    };
  }
}
NodeProp.closedBy = new NodeProp({ deserialize: (str) => str.split(" ") });
NodeProp.openedBy = new NodeProp({ deserialize: (str) => str.split(" ") });
NodeProp.group = new NodeProp({ deserialize: (str) => str.split(" ") });
NodeProp.contextHash = new NodeProp({ perNode: true });
NodeProp.lookAhead = new NodeProp({ perNode: true });
NodeProp.mounted = new NodeProp({ perNode: true });
class MountedTree {
  constructor(tree, overlay2, parser2) {
    this.tree = tree;
    this.overlay = overlay2;
    this.parser = parser2;
  }
}
const noProps = Object.create(null);
class NodeType {
  constructor(name2, props, id2, flags = 0) {
    this.name = name2;
    this.props = props;
    this.id = id2;
    this.flags = flags;
  }
  static define(spec2) {
    let props = spec2.props && spec2.props.length ? Object.create(null) : noProps;
    let flags = (spec2.top ? 1 : 0) | (spec2.skipped ? 2 : 0) | (spec2.error ? 4 : 0) | (spec2.name == null ? 8 : 0);
    let type4 = new NodeType(spec2.name || "", props, spec2.id, flags);
    if (spec2.props)
      for (let src of spec2.props) {
        if (!Array.isArray(src))
          src = src(type4);
        if (src) {
          if (src[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          props[src[0].id] = src[1];
        }
      }
    return type4;
  }
  prop(prop) {
    return this.props[prop.id];
  }
  get isTop() {
    return (this.flags & 1) > 0;
  }
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  get isError() {
    return (this.flags & 4) > 0;
  }
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  is(name2) {
    if (typeof name2 == "string") {
      if (this.name == name2)
        return true;
      let group = this.prop(NodeProp.group);
      return group ? group.indexOf(name2) > -1 : false;
    }
    return this.id == name2;
  }
  static match(map2) {
    let direct = Object.create(null);
    for (let prop in map2)
      for (let name2 of prop.split(" "))
        direct[name2] = map2[prop];
    return (node2) => {
      for (let groups = node2.prop(NodeProp.group), i2 = -1; i2 < (groups ? groups.length : 0); i2++) {
        let found = direct[i2 < 0 ? node2.name : groups[i2]];
        if (found)
          return found;
      }
    };
  }
}
NodeType.none = new NodeType("", Object.create(null), 0, 8);
class NodeSet {
  constructor(types2) {
    this.types = types2;
    for (let i2 = 0; i2 < types2.length; i2++)
      if (types2[i2].id != i2)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  extend(...props) {
    let newTypes = [];
    for (let type4 of this.types) {
      let newProps = null;
      for (let source of props) {
        let add2 = source(type4);
        if (add2) {
          if (!newProps)
            newProps = Object.assign({}, type4.props);
          newProps[add2[0].id] = add2[1];
        }
      }
      newTypes.push(newProps ? new NodeType(type4.name, newProps, type4.id, type4.flags) : type4);
    }
    return new NodeSet(newTypes);
  }
}
const CachedNode = new WeakMap(), CachedInnerNode = new WeakMap();
var IterMode;
(function(IterMode2) {
  IterMode2[IterMode2["ExcludeBuffers"] = 1] = "ExcludeBuffers";
  IterMode2[IterMode2["IncludeAnonymous"] = 2] = "IncludeAnonymous";
  IterMode2[IterMode2["IgnoreMounts"] = 4] = "IgnoreMounts";
  IterMode2[IterMode2["IgnoreOverlays"] = 8] = "IgnoreOverlays";
})(IterMode || (IterMode = {}));
class Tree {
  constructor(type4, children, positions, length2, props) {
    this.type = type4;
    this.children = children;
    this.positions = positions;
    this.length = length2;
    this.props = null;
    if (props && props.length) {
      this.props = Object.create(null);
      for (let [prop, value2] of props)
        this.props[typeof prop == "number" ? prop : prop.id] = value2;
    }
  }
  toString() {
    let mounted = this.prop(NodeProp.mounted);
    if (mounted && !mounted.overlay)
      return mounted.tree.toString();
    let children = "";
    for (let ch2 of this.children) {
      let str = ch2.toString();
      if (str) {
        if (children)
          children += ",";
        children += str;
      }
    }
    return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
  }
  cursor(mode = 0) {
    return new TreeCursor(this.topNode, mode);
  }
  cursorAt(pos, side = 0, mode = 0) {
    let scope2 = CachedNode.get(this) || this.topNode;
    let cursor = new TreeCursor(scope2);
    cursor.moveTo(pos, side);
    CachedNode.set(this, cursor._tree);
    return cursor;
  }
  get topNode() {
    return new TreeNode(this, 0, 0, null);
  }
  resolve(pos, side = 0) {
    let node2 = resolveNode(CachedNode.get(this) || this.topNode, pos, side, false);
    CachedNode.set(this, node2);
    return node2;
  }
  resolveInner(pos, side = 0) {
    let node2 = resolveNode(CachedInnerNode.get(this) || this.topNode, pos, side, true);
    CachedInnerNode.set(this, node2);
    return node2;
  }
  iterate(spec2) {
    let { enter, leave, from = 0, to: to2 = this.length } = spec2;
    let mode = spec2.mode || 0, anon = (mode & IterMode.IncludeAnonymous) > 0;
    for (let c2 = this.cursor(mode | IterMode.IncludeAnonymous); ; ) {
      let entered = false;
      if (c2.from <= to2 && c2.to >= from && (!anon && c2.type.isAnonymous || enter(c2) !== false)) {
        if (c2.firstChild())
          continue;
        entered = true;
      }
      for (; ; ) {
        if (entered && leave && (anon || !c2.type.isAnonymous))
          leave(c2);
        if (c2.nextSibling())
          break;
        if (!c2.parent())
          return;
        entered = true;
      }
    }
  }
  prop(prop) {
    return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : void 0;
  }
  get propValues() {
    let result2 = [];
    if (this.props)
      for (let id2 in this.props)
        result2.push([+id2, this.props[id2]]);
    return result2;
  }
  balance(config2 = {}) {
    return this.children.length <= 8 ? this : balanceRange(NodeType.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length2) => new Tree(this.type, children, positions, length2, this.propValues), config2.makeTree || ((children, positions, length2) => new Tree(NodeType.none, children, positions, length2)));
  }
  static build(data) {
    return buildTree(data);
  }
}
Tree.empty = new Tree(NodeType.none, [], [], 0);
class FlatBufferCursor {
  constructor(buffer, index2) {
    this.buffer = buffer;
    this.index = index2;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new FlatBufferCursor(this.buffer, this.index);
  }
}
class TreeBuffer {
  constructor(buffer, length2, set2) {
    this.buffer = buffer;
    this.length = length2;
    this.set = set2;
  }
  get type() {
    return NodeType.none;
  }
  toString() {
    let result2 = [];
    for (let index2 = 0; index2 < this.buffer.length; ) {
      result2.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2.join(",");
  }
  childString(index2) {
    let id2 = this.buffer[index2], endIndex = this.buffer[index2 + 3];
    let type4 = this.set.types[id2], result2 = type4.name;
    if (/\W/.test(result2) && !type4.isError)
      result2 = JSON.stringify(result2);
    index2 += 4;
    if (endIndex == index2)
      return result2;
    let children = [];
    while (index2 < endIndex) {
      children.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2 + "(" + children.join(",") + ")";
  }
  findChild(startIndex, endIndex, dir, pos, side) {
    let { buffer } = this, pick = -1;
    for (let i2 = startIndex; i2 != endIndex; i2 = buffer[i2 + 3]) {
      if (checkSide(side, pos, buffer[i2 + 1], buffer[i2 + 2])) {
        pick = i2;
        if (dir > 0)
          break;
      }
    }
    return pick;
  }
  slice(startI, endI, from) {
    let b2 = this.buffer;
    let copy = new Uint16Array(endI - startI), len2 = 0;
    for (let i2 = startI, j2 = 0; i2 < endI; ) {
      copy[j2++] = b2[i2++];
      copy[j2++] = b2[i2++] - from;
      let to2 = copy[j2++] = b2[i2++] - from;
      copy[j2++] = b2[i2++] - startI;
      len2 = Math.max(len2, to2);
    }
    return new TreeBuffer(copy, len2, this.set);
  }
}
function checkSide(side, pos, from, to2) {
  switch (side) {
    case -2:
      return from < pos;
    case -1:
      return to2 >= pos && from < pos;
    case 0:
      return from < pos && to2 > pos;
    case 1:
      return from <= pos && to2 > pos;
    case 2:
      return to2 > pos;
    case 4:
      return true;
  }
}
function enterUnfinishedNodesBefore(node2, pos) {
  let scan = node2.childBefore(pos);
  while (scan) {
    let last = scan.lastChild;
    if (!last || last.to != scan.to)
      break;
    if (last.type.isError && last.from == last.to) {
      node2 = scan;
      scan = last.prevSibling;
    } else {
      scan = last;
    }
  }
  return node2;
}
function resolveNode(node2, pos, side, overlays) {
  var _a2;
  while (node2.from == node2.to || (side < 1 ? node2.from >= pos : node2.from > pos) || (side > -1 ? node2.to <= pos : node2.to < pos)) {
    let parent = !overlays && node2 instanceof TreeNode && node2.index < 0 ? null : node2.parent;
    if (!parent)
      return node2;
    node2 = parent;
  }
  let mode = overlays ? 0 : IterMode.IgnoreOverlays;
  if (overlays)
    for (let scan = node2, parent = scan.parent; parent; scan = parent, parent = scan.parent) {
      if (scan instanceof TreeNode && scan.index < 0 && ((_a2 = parent.enter(pos, side, mode)) === null || _a2 === void 0 ? void 0 : _a2.from) != scan.from)
        node2 = parent;
    }
  for (; ; ) {
    let inner = node2.enter(pos, side, mode);
    if (!inner)
      return node2;
    node2 = inner;
  }
}
class TreeNode {
  constructor(_tree, from, index2, _parent) {
    this._tree = _tree;
    this.from = from;
    this.index = index2;
    this._parent = _parent;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(i2, dir, pos, side, mode = 0) {
    for (let parent = this; ; ) {
      for (let { children, positions } = parent._tree, e25 = dir > 0 ? children.length : -1; i2 != e25; i2 += dir) {
        let next = children[i2], start = positions[i2] + parent.from;
        if (!checkSide(side, pos, start, start + next.length))
          continue;
        if (next instanceof TreeBuffer) {
          if (mode & IterMode.ExcludeBuffers)
            continue;
          let index2 = next.findChild(0, next.buffer.length, dir, pos - start, side);
          if (index2 > -1)
            return new BufferNode(new BufferContext(parent, next, i2, start), null, index2);
        } else if (mode & IterMode.IncludeAnonymous || (!next.type.isAnonymous || hasChild(next))) {
          let mounted;
          if (!(mode & IterMode.IgnoreMounts) && next.props && (mounted = next.prop(NodeProp.mounted)) && !mounted.overlay)
            return new TreeNode(mounted.tree, start, i2, parent);
          let inner = new TreeNode(next, start, i2, parent);
          return mode & IterMode.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side);
        }
      }
      if (mode & IterMode.IncludeAnonymous || !parent.type.isAnonymous)
        return null;
      if (parent.index >= 0)
        i2 = parent.index + dir;
      else
        i2 = dir < 0 ? -1 : parent._parent._tree.children.length;
      parent = parent._parent;
      if (!parent)
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(0, 1, 0, 4);
  }
  get lastChild() {
    return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
  }
  childAfter(pos) {
    return this.nextChild(0, 1, pos, 2);
  }
  childBefore(pos) {
    return this.nextChild(this._tree.children.length - 1, -1, pos, -2);
  }
  enter(pos, side, mode = 0) {
    let mounted;
    if (!(mode & IterMode.IgnoreOverlays) && (mounted = this._tree.prop(NodeProp.mounted)) && mounted.overlay) {
      let rPos = pos - this.from;
      for (let { from, to: to2 } of mounted.overlay) {
        if ((side > 0 ? from <= rPos : from < rPos) && (side < 0 ? to2 >= rPos : to2 > rPos))
          return new TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
      }
    }
    return this.nextChild(0, 1, pos, side, mode);
  }
  nextSignificantParent() {
    let val = this;
    while (val.type.isAnonymous && val._parent)
      val = val._parent;
    return val;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
  }
  cursor(mode = 0) {
    return new TreeCursor(this, mode);
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  resolve(pos, side = 0) {
    return resolveNode(this, pos, side, false);
  }
  resolveInner(pos, side = 0) {
    return resolveNode(this, pos, side, true);
  }
  enterUnfinishedNodesBefore(pos) {
    return enterUnfinishedNodesBefore(this, pos);
  }
  getChild(type4, before = null, after = null) {
    let r2 = getChildren(this, type4, before, after);
    return r2.length ? r2[0] : null;
  }
  getChildren(type4, before = null, after = null) {
    return getChildren(this, type4, before, after);
  }
  toString() {
    return this._tree.toString();
  }
  get node() {
    return this;
  }
  matchContext(context) {
    return matchNodeContext(this, context);
  }
}
function getChildren(node2, type4, before, after) {
  let cur2 = node2.cursor(), result2 = [];
  if (!cur2.firstChild())
    return result2;
  if (before != null) {
    while (!cur2.type.is(before))
      if (!cur2.nextSibling())
        return result2;
  }
  for (; ; ) {
    if (after != null && cur2.type.is(after))
      return result2;
    if (cur2.type.is(type4))
      result2.push(cur2.node);
    if (!cur2.nextSibling())
      return after == null ? result2 : [];
  }
}
function matchNodeContext(node2, context, i2 = context.length - 1) {
  for (let p2 = node2.parent; i2 >= 0; p2 = p2.parent) {
    if (!p2)
      return false;
    if (!p2.type.isAnonymous) {
      if (context[i2] && context[i2] != p2.name)
        return false;
      i2--;
    }
  }
  return true;
}
class BufferContext {
  constructor(parent, buffer, index2, start) {
    this.parent = parent;
    this.buffer = buffer;
    this.index = index2;
    this.start = start;
  }
}
class BufferNode {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(context, _parent, index2) {
    this.context = context;
    this._parent = _parent;
    this.index = index2;
    this.type = context.buffer.set.types[context.buffer.buffer[index2]];
  }
  child(dir, pos, side) {
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode(this.context, this, index2);
  }
  get firstChild() {
    return this.child(1, 0, 4);
  }
  get lastChild() {
    return this.child(-1, 0, 4);
  }
  childAfter(pos) {
    return this.child(1, pos, 2);
  }
  childBefore(pos) {
    return this.child(-1, pos, -2);
  }
  enter(pos, side, mode = 0) {
    if (mode & IterMode.ExcludeBuffers)
      return null;
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode(this.context, this, index2);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(dir) {
    return this._parent ? null : this.context.parent.nextChild(this.context.index + dir, dir, 0, 4);
  }
  get nextSibling() {
    let { buffer } = this.context;
    let after = buffer.buffer[this.index + 3];
    if (after < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length))
      return new BufferNode(this.context, this._parent, after);
    return this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer } = this.context;
    let parentStart = this._parent ? this._parent.index + 4 : 0;
    if (this.index == parentStart)
      return this.externalSibling(-1);
    return new BufferNode(this.context, this._parent, buffer.findChild(parentStart, this.index, -1, 0, 4));
  }
  cursor(mode = 0) {
    return new TreeCursor(this, mode);
  }
  get tree() {
    return null;
  }
  toTree() {
    let children = [], positions = [];
    let { buffer } = this.context;
    let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
    if (endI > startI) {
      let from = buffer.buffer[this.index + 1];
      children.push(buffer.slice(startI, endI, from));
      positions.push(0);
    }
    return new Tree(this.type, children, positions, this.to - this.from);
  }
  resolve(pos, side = 0) {
    return resolveNode(this, pos, side, false);
  }
  resolveInner(pos, side = 0) {
    return resolveNode(this, pos, side, true);
  }
  enterUnfinishedNodesBefore(pos) {
    return enterUnfinishedNodesBefore(this, pos);
  }
  toString() {
    return this.context.buffer.childString(this.index);
  }
  getChild(type4, before = null, after = null) {
    let r2 = getChildren(this, type4, before, after);
    return r2.length ? r2[0] : null;
  }
  getChildren(type4, before = null, after = null) {
    return getChildren(this, type4, before, after);
  }
  get node() {
    return this;
  }
  matchContext(context) {
    return matchNodeContext(this, context);
  }
}
class TreeCursor {
  get name() {
    return this.type.name;
  }
  constructor(node2, mode = 0) {
    this.mode = mode;
    this.buffer = null;
    this.stack = [];
    this.index = 0;
    this.bufferNode = null;
    if (node2 instanceof TreeNode) {
      this.yieldNode(node2);
    } else {
      this._tree = node2.context.parent;
      this.buffer = node2.context;
      for (let n2 = node2._parent; n2; n2 = n2._parent)
        this.stack.unshift(n2.index);
      this.bufferNode = node2;
      this.yieldBuf(node2.index);
    }
  }
  yieldNode(node2) {
    if (!node2)
      return false;
    this._tree = node2;
    this.type = node2.type;
    this.from = node2.from;
    this.to = node2.to;
    return true;
  }
  yieldBuf(index2, type4) {
    this.index = index2;
    let { start, buffer } = this.buffer;
    this.type = type4 || buffer.set.types[buffer.buffer[index2]];
    this.from = start + buffer.buffer[index2 + 1];
    this.to = start + buffer.buffer[index2 + 2];
    return true;
  }
  yield(node2) {
    if (!node2)
      return false;
    if (node2 instanceof TreeNode) {
      this.buffer = null;
      return this.yieldNode(node2);
    }
    this.buffer = node2.context;
    return this.yieldBuf(node2.index, node2.type);
  }
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  enterChild(dir, pos, side) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
    let { buffer } = this.buffer;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
    if (index2 < 0)
      return false;
    this.stack.push(this.index);
    return this.yieldBuf(index2);
  }
  firstChild() {
    return this.enterChild(1, 0, 4);
  }
  lastChild() {
    return this.enterChild(-1, 0, 4);
  }
  childAfter(pos) {
    return this.enterChild(1, pos, 2);
  }
  childBefore(pos) {
    return this.enterChild(-1, pos, -2);
  }
  enter(pos, side, mode = this.mode) {
    if (!this.buffer)
      return this.yield(this._tree.enter(pos, side, mode));
    return mode & IterMode.ExcludeBuffers ? false : this.enterChild(1, pos, side);
  }
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & IterMode.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let parent = this.mode & IterMode.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    this.buffer = null;
    return this.yieldNode(parent);
  }
  sibling(dir) {
    if (!this.buffer)
      return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4, this.mode));
    let { buffer } = this.buffer, d2 = this.stack.length - 1;
    if (dir < 0) {
      let parentStart = d2 < 0 ? 0 : this.stack[d2] + 4;
      if (this.index != parentStart)
        return this.yieldBuf(buffer.findChild(parentStart, this.index, -1, 0, 4));
    } else {
      let after = buffer.buffer[this.index + 3];
      if (after < (d2 < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d2] + 3]))
        return this.yieldBuf(after);
    }
    return d2 < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4, this.mode)) : false;
  }
  nextSibling() {
    return this.sibling(1);
  }
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(dir) {
    let index2, parent, { buffer } = this;
    if (buffer) {
      if (dir > 0) {
        if (this.index < buffer.buffer.buffer.length)
          return false;
      } else {
        for (let i2 = 0; i2 < this.index; i2++)
          if (buffer.buffer.buffer[i2 + 3] < this.index)
            return false;
      }
      ({ index: index2, parent } = buffer);
    } else {
      ({ index: index2, _parent: parent } = this._tree);
    }
    for (; parent; { index: index2, _parent: parent } = parent) {
      if (index2 > -1)
        for (let i2 = index2 + dir, e25 = dir < 0 ? -1 : parent._tree.children.length; i2 != e25; i2 += dir) {
          let child = parent._tree.children[i2];
          if (this.mode & IterMode.IncludeAnonymous || child instanceof TreeBuffer || !child.type.isAnonymous || hasChild(child))
            return false;
        }
    }
    return true;
  }
  move(dir, enter) {
    if (enter && this.enterChild(dir, 0, 4))
      return true;
    for (; ; ) {
      if (this.sibling(dir))
        return true;
      if (this.atLastNode(dir) || !this.parent())
        return false;
    }
  }
  next(enter = true) {
    return this.move(1, enter);
  }
  prev(enter = true) {
    return this.move(-1, enter);
  }
  moveTo(pos, side = 0) {
    while (this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))
      if (!this.parent())
        break;
    while (this.enterChild(1, pos, side)) {
    }
    return this;
  }
  get node() {
    if (!this.buffer)
      return this._tree;
    let cache2 = this.bufferNode, result2 = null, depth = 0;
    if (cache2 && cache2.context == this.buffer) {
      scan:
        for (let index2 = this.index, d2 = this.stack.length; d2 >= 0; ) {
          for (let c2 = cache2; c2; c2 = c2._parent)
            if (c2.index == index2) {
              if (index2 == this.index)
                return c2;
              result2 = c2;
              depth = d2 + 1;
              break scan;
            }
          index2 = this.stack[--d2];
        }
    }
    for (let i2 = depth; i2 < this.stack.length; i2++)
      result2 = new BufferNode(this.buffer, result2, this.stack[i2]);
    return this.bufferNode = new BufferNode(this.buffer, result2, this.index);
  }
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  iterate(enter, leave) {
    for (let depth = 0; ; ) {
      let mustLeave = false;
      if (this.type.isAnonymous || enter(this) !== false) {
        if (this.firstChild()) {
          depth++;
          continue;
        }
        if (!this.type.isAnonymous)
          mustLeave = true;
      }
      for (; ; ) {
        if (mustLeave && leave)
          leave(this);
        mustLeave = this.type.isAnonymous;
        if (this.nextSibling())
          break;
        if (!depth)
          return;
        this.parent();
        depth--;
        mustLeave = true;
      }
    }
  }
  matchContext(context) {
    if (!this.buffer)
      return matchNodeContext(this.node, context);
    let { buffer } = this.buffer, { types: types2 } = buffer.set;
    for (let i2 = context.length - 1, d2 = this.stack.length - 1; i2 >= 0; d2--) {
      if (d2 < 0)
        return matchNodeContext(this.node, context, i2);
      let type4 = types2[buffer.buffer[this.stack[d2]]];
      if (!type4.isAnonymous) {
        if (context[i2] && context[i2] != type4.name)
          return false;
        i2--;
      }
    }
    return true;
  }
}
function hasChild(tree) {
  return tree.children.some((ch2) => ch2 instanceof TreeBuffer || !ch2.type.isAnonymous || hasChild(ch2));
}
function buildTree(data) {
  var _a2;
  let { buffer, nodeSet, maxBufferLength = DefaultBufferLength, reused = [], minRepeatType = nodeSet.types.length } = data;
  let cursor = Array.isArray(buffer) ? new FlatBufferCursor(buffer, buffer.length) : buffer;
  let types2 = nodeSet.types;
  let contextHash = 0, lookAhead = 0;
  function takeNode(parentStart, minPos, children2, positions2, inRepeat) {
    let { id: id2, start, end, size: size2 } = cursor;
    let lookAheadAtStart = lookAhead;
    while (size2 < 0) {
      cursor.next();
      if (size2 == -1) {
        let node3 = reused[id2];
        children2.push(node3);
        positions2.push(start - parentStart);
        return;
      } else if (size2 == -3) {
        contextHash = id2;
        return;
      } else if (size2 == -4) {
        lookAhead = id2;
        return;
      } else {
        throw new RangeError(`Unrecognized record size: ${size2}`);
      }
    }
    let type4 = types2[id2], node2, buffer2;
    let startPos = start - parentStart;
    if (end - start <= maxBufferLength && (buffer2 = findBufferSize(cursor.pos - minPos, inRepeat))) {
      let data2 = new Uint16Array(buffer2.size - buffer2.skip);
      let endPos = cursor.pos - buffer2.size, index2 = data2.length;
      while (cursor.pos > endPos)
        index2 = copyToBuffer(buffer2.start, data2, index2);
      node2 = new TreeBuffer(data2, end - buffer2.start, nodeSet);
      startPos = buffer2.start - parentStart;
    } else {
      let endPos = cursor.pos - size2;
      cursor.next();
      let localChildren = [], localPositions = [];
      let localInRepeat = id2 >= minRepeatType ? id2 : -1;
      let lastGroup = 0, lastEnd = end;
      while (cursor.pos > endPos) {
        if (localInRepeat >= 0 && cursor.id == localInRepeat && cursor.size >= 0) {
          if (cursor.end <= lastEnd - maxBufferLength) {
            makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor.end, lastEnd, localInRepeat, lookAheadAtStart);
            lastGroup = localChildren.length;
            lastEnd = cursor.end;
          }
          cursor.next();
        } else {
          takeNode(start, endPos, localChildren, localPositions, localInRepeat);
        }
      }
      if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length)
        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart);
      localChildren.reverse();
      localPositions.reverse();
      if (localInRepeat > -1 && lastGroup > 0) {
        let make = makeBalanced(type4);
        node2 = balanceRange(type4, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
      } else {
        node2 = makeTree(type4, localChildren, localPositions, end - start, lookAheadAtStart - end);
      }
    }
    children2.push(node2);
    positions2.push(startPos);
  }
  function makeBalanced(type4) {
    return (children2, positions2, length3) => {
      let lookAhead2 = 0, lastI = children2.length - 1, last, lookAheadProp;
      if (lastI >= 0 && (last = children2[lastI]) instanceof Tree) {
        if (!lastI && last.type == type4 && last.length == length3)
          return last;
        if (lookAheadProp = last.prop(NodeProp.lookAhead))
          lookAhead2 = positions2[lastI] + last.length + lookAheadProp;
      }
      return makeTree(type4, children2, positions2, length3, lookAhead2);
    };
  }
  function makeRepeatLeaf(children2, positions2, base2, i2, from, to2, type4, lookAhead2) {
    let localChildren = [], localPositions = [];
    while (children2.length > i2) {
      localChildren.push(children2.pop());
      localPositions.push(positions2.pop() + base2 - from);
    }
    children2.push(makeTree(nodeSet.types[type4], localChildren, localPositions, to2 - from, lookAhead2 - to2));
    positions2.push(from - base2);
  }
  function makeTree(type4, children2, positions2, length3, lookAhead2 = 0, props) {
    if (contextHash) {
      let pair2 = [NodeProp.contextHash, contextHash];
      props = props ? [pair2].concat(props) : [pair2];
    }
    if (lookAhead2 > 25) {
      let pair2 = [NodeProp.lookAhead, lookAhead2];
      props = props ? [pair2].concat(props) : [pair2];
    }
    return new Tree(type4, children2, positions2, length3, props);
  }
  function findBufferSize(maxSize, inRepeat) {
    let fork2 = cursor.fork();
    let size2 = 0, start = 0, skip = 0, minStart = fork2.end - maxBufferLength;
    let result2 = { size: 0, start: 0, skip: 0 };
    scan:
      for (let minPos = fork2.pos - maxSize; fork2.pos > minPos; ) {
        let nodeSize2 = fork2.size;
        if (fork2.id == inRepeat && nodeSize2 >= 0) {
          result2.size = size2;
          result2.start = start;
          result2.skip = skip;
          skip += 4;
          size2 += 4;
          fork2.next();
          continue;
        }
        let startPos = fork2.pos - nodeSize2;
        if (nodeSize2 < 0 || startPos < minPos || fork2.start < minStart)
          break;
        let localSkipped = fork2.id >= minRepeatType ? 4 : 0;
        let nodeStart2 = fork2.start;
        fork2.next();
        while (fork2.pos > startPos) {
          if (fork2.size < 0) {
            if (fork2.size == -3)
              localSkipped += 4;
            else
              break scan;
          } else if (fork2.id >= minRepeatType) {
            localSkipped += 4;
          }
          fork2.next();
        }
        start = nodeStart2;
        size2 += nodeSize2;
        skip += localSkipped;
      }
    if (inRepeat < 0 || size2 == maxSize) {
      result2.size = size2;
      result2.start = start;
      result2.skip = skip;
    }
    return result2.size > 4 ? result2 : void 0;
  }
  function copyToBuffer(bufferStart, buffer2, index2) {
    let { id: id2, start, end, size: size2 } = cursor;
    cursor.next();
    if (size2 >= 0 && id2 < minRepeatType) {
      let startIndex = index2;
      if (size2 > 4) {
        let endPos = cursor.pos - (size2 - 4);
        while (cursor.pos > endPos)
          index2 = copyToBuffer(bufferStart, buffer2, index2);
      }
      buffer2[--index2] = startIndex;
      buffer2[--index2] = end - bufferStart;
      buffer2[--index2] = start - bufferStart;
      buffer2[--index2] = id2;
    } else if (size2 == -3) {
      contextHash = id2;
    } else if (size2 == -4) {
      lookAhead = id2;
    }
    return index2;
  }
  let children = [], positions = [];
  while (cursor.pos > 0)
    takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1);
  let length2 = (_a2 = data.length) !== null && _a2 !== void 0 ? _a2 : children.length ? positions[0] + children[0].length : 0;
  return new Tree(types2[data.topID], children.reverse(), positions.reverse(), length2);
}
const nodeSizeCache = new WeakMap();
function nodeSize(balanceType, node2) {
  if (!balanceType.isAnonymous || node2 instanceof TreeBuffer || node2.type != balanceType)
    return 1;
  let size2 = nodeSizeCache.get(node2);
  if (size2 == null) {
    size2 = 1;
    for (let child of node2.children) {
      if (child.type != balanceType || !(child instanceof Tree)) {
        size2 = 1;
        break;
      }
      size2 += nodeSize(balanceType, child);
    }
    nodeSizeCache.set(node2, size2);
  }
  return size2;
}
function balanceRange(balanceType, children, positions, from, to2, start, length2, mkTop, mkTree) {
  let total = 0;
  for (let i2 = from; i2 < to2; i2++)
    total += nodeSize(balanceType, children[i2]);
  let maxChild = Math.ceil(total * 1.5 / 8);
  let localChildren = [], localPositions = [];
  function divide(children2, positions2, from2, to3, offset) {
    for (let i2 = from2; i2 < to3; ) {
      let groupFrom = i2, groupStart = positions2[i2], groupSize = nodeSize(balanceType, children2[i2]);
      i2++;
      for (; i2 < to3; i2++) {
        let nextSize = nodeSize(balanceType, children2[i2]);
        if (groupSize + nextSize >= maxChild)
          break;
        groupSize += nextSize;
      }
      if (i2 == groupFrom + 1) {
        if (groupSize > maxChild) {
          let only = children2[groupFrom];
          divide(only.children, only.positions, 0, only.children.length, positions2[groupFrom] + offset);
          continue;
        }
        localChildren.push(children2[groupFrom]);
      } else {
        let length3 = positions2[i2 - 1] + children2[i2 - 1].length - groupStart;
        localChildren.push(balanceRange(balanceType, children2, positions2, groupFrom, i2, groupStart, length3, null, mkTree));
      }
      localPositions.push(groupStart + offset - start);
    }
  }
  divide(children, positions, from, to2, 0);
  return (mkTop || mkTree)(localChildren, localPositions, length2);
}
class NodeWeakMap {
  constructor() {
    this.map = new WeakMap();
  }
  setBuffer(buffer, index2, value2) {
    let inner = this.map.get(buffer);
    if (!inner)
      this.map.set(buffer, inner = new Map());
    inner.set(index2, value2);
  }
  getBuffer(buffer, index2) {
    let inner = this.map.get(buffer);
    return inner && inner.get(index2);
  }
  set(node2, value2) {
    if (node2 instanceof BufferNode)
      this.setBuffer(node2.context.buffer, node2.index, value2);
    else if (node2 instanceof TreeNode)
      this.map.set(node2.tree, value2);
  }
  get(node2) {
    return node2 instanceof BufferNode ? this.getBuffer(node2.context.buffer, node2.index) : node2 instanceof TreeNode ? this.map.get(node2.tree) : void 0;
  }
  cursorSet(cursor, value2) {
    if (cursor.buffer)
      this.setBuffer(cursor.buffer.buffer, cursor.index, value2);
    else
      this.map.set(cursor.tree, value2);
  }
  cursorGet(cursor) {
    return cursor.buffer ? this.getBuffer(cursor.buffer.buffer, cursor.index) : this.map.get(cursor.tree);
  }
}
class TreeFragment {
  constructor(from, to2, tree, offset, openStart = false, openEnd = false) {
    this.from = from;
    this.to = to2;
    this.tree = tree;
    this.offset = offset;
    this.open = (openStart ? 1 : 0) | (openEnd ? 2 : 0);
  }
  get openStart() {
    return (this.open & 1) > 0;
  }
  get openEnd() {
    return (this.open & 2) > 0;
  }
  static addTree(tree, fragments = [], partial = false) {
    let result2 = [new TreeFragment(0, tree.length, tree, 0, false, partial)];
    for (let f2 of fragments)
      if (f2.to > tree.length)
        result2.push(f2);
    return result2;
  }
  static applyChanges(fragments, changes, minGap = 128) {
    if (!changes.length)
      return fragments;
    let result2 = [];
    let fI2 = 1, nextF = fragments.length ? fragments[0] : null;
    for (let cI2 = 0, pos = 0, off2 = 0; ; cI2++) {
      let nextC = cI2 < changes.length ? changes[cI2] : null;
      let nextPos = nextC ? nextC.fromA : 1e9;
      if (nextPos - pos >= minGap)
        while (nextF && nextF.from < nextPos) {
          let cut = nextF;
          if (pos >= cut.from || nextPos <= cut.to || off2) {
            let fFrom = Math.max(cut.from, pos) - off2, fTo = Math.min(cut.to, nextPos) - off2;
            cut = fFrom >= fTo ? null : new TreeFragment(fFrom, fTo, cut.tree, cut.offset + off2, cI2 > 0, !!nextC);
          }
          if (cut)
            result2.push(cut);
          if (nextF.to > nextPos)
            break;
          nextF = fI2 < fragments.length ? fragments[fI2++] : null;
        }
      if (!nextC)
        break;
      pos = nextC.toA;
      off2 = nextC.toA - nextC.toB;
    }
    return result2;
  }
}
class Parser {
  startParse(input, fragments, ranges) {
    if (typeof input == "string")
      input = new StringInput(input);
    ranges = !ranges ? [new Range$1(0, input.length)] : ranges.length ? ranges.map((r2) => new Range$1(r2.from, r2.to)) : [new Range$1(0, 0)];
    return this.createParse(input, fragments || [], ranges);
  }
  parse(input, fragments, ranges) {
    let parse2 = this.startParse(input, fragments, ranges);
    for (; ; ) {
      let done = parse2.advance();
      if (done)
        return done;
    }
  }
}
class StringInput {
  constructor(string3) {
    this.string = string3;
  }
  get length() {
    return this.string.length;
  }
  chunk(from) {
    return this.string.slice(from);
  }
  get lineChunks() {
    return false;
  }
  read(from, to2) {
    return this.string.slice(from, to2);
  }
}
function parseMixed(nest2) {
  return (parse2, input, fragments, ranges) => new MixedParse(parse2, nest2, input, fragments, ranges);
}
class InnerParse {
  constructor(parser2, parse2, overlay2, target, ranges) {
    this.parser = parser2;
    this.parse = parse2;
    this.overlay = overlay2;
    this.target = target;
    this.ranges = ranges;
    if (!ranges.length || ranges.some((r2) => r2.from >= r2.to))
      throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(ranges));
  }
}
class ActiveOverlay {
  constructor(parser2, predicate, mounts, index2, start, target, prev) {
    this.parser = parser2;
    this.predicate = predicate;
    this.mounts = mounts;
    this.index = index2;
    this.start = start;
    this.target = target;
    this.prev = prev;
    this.depth = 0;
    this.ranges = [];
  }
}
const stoppedInner = new NodeProp({ perNode: true });
class MixedParse {
  constructor(base2, nest2, input, fragments, ranges) {
    this.nest = nest2;
    this.input = input;
    this.fragments = fragments;
    this.ranges = ranges;
    this.inner = [];
    this.innerDone = 0;
    this.baseTree = null;
    this.stoppedAt = null;
    this.baseParse = base2;
  }
  advance() {
    if (this.baseParse) {
      let done2 = this.baseParse.advance();
      if (!done2)
        return null;
      this.baseParse = null;
      this.baseTree = done2;
      this.startInner();
      if (this.stoppedAt != null)
        for (let inner2 of this.inner)
          inner2.parse.stopAt(this.stoppedAt);
    }
    if (this.innerDone == this.inner.length) {
      let result2 = this.baseTree;
      if (this.stoppedAt != null)
        result2 = new Tree(result2.type, result2.children, result2.positions, result2.length, result2.propValues.concat([[stoppedInner, this.stoppedAt]]));
      return result2;
    }
    let inner = this.inner[this.innerDone], done = inner.parse.advance();
    if (done) {
      this.innerDone++;
      let props = Object.assign(Object.create(null), inner.target.props);
      props[NodeProp.mounted.id] = new MountedTree(done, inner.overlay, inner.parser);
      inner.target.props = props;
    }
    return null;
  }
  get parsedPos() {
    if (this.baseParse)
      return 0;
    let pos = this.input.length;
    for (let i2 = this.innerDone; i2 < this.inner.length; i2++) {
      if (this.inner[i2].ranges[0].from < pos)
        pos = Math.min(pos, this.inner[i2].parse.parsedPos);
    }
    return pos;
  }
  stopAt(pos) {
    this.stoppedAt = pos;
    if (this.baseParse)
      this.baseParse.stopAt(pos);
    else
      for (let i2 = this.innerDone; i2 < this.inner.length; i2++)
        this.inner[i2].parse.stopAt(pos);
  }
  startInner() {
    let fragmentCursor = new FragmentCursor$1(this.fragments);
    let overlay2 = null;
    let covered = null;
    let cursor = new TreeCursor(new TreeNode(this.baseTree, this.ranges[0].from, 0, null), IterMode.IncludeAnonymous | IterMode.IgnoreMounts);
    scan:
      for (let nest2, isCovered; this.stoppedAt == null || cursor.from < this.stoppedAt; ) {
        let enter = true, range3;
        if (fragmentCursor.hasNode(cursor)) {
          if (overlay2) {
            let match2 = overlay2.mounts.find((m2) => m2.frag.from <= cursor.from && m2.frag.to >= cursor.to && m2.mount.overlay);
            if (match2)
              for (let r2 of match2.mount.overlay) {
                let from = r2.from + match2.pos, to2 = r2.to + match2.pos;
                if (from >= cursor.from && to2 <= cursor.to && !overlay2.ranges.some((r3) => r3.from < to2 && r3.to > from))
                  overlay2.ranges.push({ from, to: to2 });
              }
          }
          enter = false;
        } else if (covered && (isCovered = checkCover(covered.ranges, cursor.from, cursor.to))) {
          enter = isCovered != 2;
        } else if (!cursor.type.isAnonymous && cursor.from < cursor.to && (nest2 = this.nest(cursor, this.input))) {
          if (!cursor.tree)
            materialize(cursor);
          let oldMounts = fragmentCursor.findMounts(cursor.from, nest2.parser);
          if (typeof nest2.overlay == "function") {
            overlay2 = new ActiveOverlay(nest2.parser, nest2.overlay, oldMounts, this.inner.length, cursor.from, cursor.tree, overlay2);
          } else {
            let ranges = punchRanges(this.ranges, nest2.overlay || [new Range$1(cursor.from, cursor.to)]);
            if (ranges.length)
              this.inner.push(new InnerParse(nest2.parser, nest2.parser.startParse(this.input, enterFragments(oldMounts, ranges), ranges), nest2.overlay ? nest2.overlay.map((r2) => new Range$1(r2.from - cursor.from, r2.to - cursor.from)) : null, cursor.tree, ranges));
            if (!nest2.overlay)
              enter = false;
            else if (ranges.length)
              covered = { ranges, depth: 0, prev: covered };
          }
        } else if (overlay2 && (range3 = overlay2.predicate(cursor))) {
          if (range3 === true)
            range3 = new Range$1(cursor.from, cursor.to);
          if (range3.from < range3.to)
            overlay2.ranges.push(range3);
        }
        if (enter && cursor.firstChild()) {
          if (overlay2)
            overlay2.depth++;
          if (covered)
            covered.depth++;
        } else {
          for (; ; ) {
            if (cursor.nextSibling())
              break;
            if (!cursor.parent())
              break scan;
            if (overlay2 && !--overlay2.depth) {
              let ranges = punchRanges(this.ranges, overlay2.ranges);
              if (ranges.length)
                this.inner.splice(overlay2.index, 0, new InnerParse(overlay2.parser, overlay2.parser.startParse(this.input, enterFragments(overlay2.mounts, ranges), ranges), overlay2.ranges.map((r2) => new Range$1(r2.from - overlay2.start, r2.to - overlay2.start)), overlay2.target, ranges));
              overlay2 = overlay2.prev;
            }
            if (covered && !--covered.depth)
              covered = covered.prev;
          }
        }
      }
  }
}
function checkCover(covered, from, to2) {
  for (let range3 of covered) {
    if (range3.from >= to2)
      break;
    if (range3.to > from)
      return range3.from <= from && range3.to >= to2 ? 2 : 1;
  }
  return 0;
}
function sliceBuf(buf, startI, endI, nodes, positions, off2) {
  if (startI < endI) {
    let from = buf.buffer[startI + 1];
    nodes.push(buf.slice(startI, endI, from));
    positions.push(from - off2);
  }
}
function materialize(cursor) {
  let { node: node2 } = cursor, depth = 0;
  do {
    cursor.parent();
    depth++;
  } while (!cursor.tree);
  let i2 = 0, base2 = cursor.tree, off2 = 0;
  for (; ; i2++) {
    off2 = base2.positions[i2] + cursor.from;
    if (off2 <= node2.from && off2 + base2.children[i2].length >= node2.to)
      break;
  }
  let buf = base2.children[i2], b2 = buf.buffer;
  function split(startI, endI, type4, innerOffset, length2) {
    let i3 = startI;
    while (b2[i3 + 2] + off2 <= node2.from)
      i3 = b2[i3 + 3];
    let children = [], positions = [];
    sliceBuf(buf, startI, i3, children, positions, innerOffset);
    let from = b2[i3 + 1], to2 = b2[i3 + 2];
    let isTarget = from + off2 == node2.from && to2 + off2 == node2.to && b2[i3] == node2.type.id;
    children.push(isTarget ? node2.toTree() : split(i3 + 4, b2[i3 + 3], buf.set.types[b2[i3]], from, to2 - from));
    positions.push(from - innerOffset);
    sliceBuf(buf, b2[i3 + 3], endI, children, positions, innerOffset);
    return new Tree(type4, children, positions, length2);
  }
  base2.children[i2] = split(0, b2.length, NodeType.none, 0, buf.length);
  for (let d2 = 0; d2 <= depth; d2++)
    cursor.childAfter(node2.from);
}
class StructureCursor {
  constructor(root2, offset) {
    this.offset = offset;
    this.done = false;
    this.cursor = root2.cursor(IterMode.IncludeAnonymous | IterMode.IgnoreMounts);
  }
  moveTo(pos) {
    let { cursor } = this, p2 = pos - this.offset;
    while (!this.done && cursor.from < p2) {
      if (cursor.to >= pos && cursor.enter(p2, 1, IterMode.IgnoreOverlays | IterMode.ExcludeBuffers))
        ;
      else if (!cursor.next(false))
        this.done = true;
    }
  }
  hasNode(cursor) {
    this.moveTo(cursor.from);
    if (!this.done && this.cursor.from + this.offset == cursor.from && this.cursor.tree) {
      for (let tree = this.cursor.tree; ; ) {
        if (tree == cursor.tree)
          return true;
        if (tree.children.length && tree.positions[0] == 0 && tree.children[0] instanceof Tree)
          tree = tree.children[0];
        else
          break;
      }
    }
    return false;
  }
}
class FragmentCursor$1 {
  constructor(fragments) {
    var _a2;
    this.fragments = fragments;
    this.curTo = 0;
    this.fragI = 0;
    if (fragments.length) {
      let first = this.curFrag = fragments[0];
      this.curTo = (_a2 = first.tree.prop(stoppedInner)) !== null && _a2 !== void 0 ? _a2 : first.to;
      this.inner = new StructureCursor(first.tree, -first.offset);
    } else {
      this.curFrag = this.inner = null;
    }
  }
  hasNode(node2) {
    while (this.curFrag && node2.from >= this.curTo)
      this.nextFrag();
    return this.curFrag && this.curFrag.from <= node2.from && this.curTo >= node2.to && this.inner.hasNode(node2);
  }
  nextFrag() {
    var _a2;
    this.fragI++;
    if (this.fragI == this.fragments.length) {
      this.curFrag = this.inner = null;
    } else {
      let frag = this.curFrag = this.fragments[this.fragI];
      this.curTo = (_a2 = frag.tree.prop(stoppedInner)) !== null && _a2 !== void 0 ? _a2 : frag.to;
      this.inner = new StructureCursor(frag.tree, -frag.offset);
    }
  }
  findMounts(pos, parser2) {
    var _a2;
    let result2 = [];
    if (this.inner) {
      this.inner.cursor.moveTo(pos, 1);
      for (let pos2 = this.inner.cursor.node; pos2; pos2 = pos2.parent) {
        let mount2 = (_a2 = pos2.tree) === null || _a2 === void 0 ? void 0 : _a2.prop(NodeProp.mounted);
        if (mount2 && mount2.parser == parser2) {
          for (let i2 = this.fragI; i2 < this.fragments.length; i2++) {
            let frag = this.fragments[i2];
            if (frag.from >= pos2.to)
              break;
            if (frag.tree == this.curFrag.tree)
              result2.push({
                frag,
                pos: pos2.from - frag.offset,
                mount: mount2
              });
          }
        }
      }
    }
    return result2;
  }
}
function punchRanges(outer, ranges) {
  let copy = null, current = ranges;
  for (let i2 = 1, j2 = 0; i2 < outer.length; i2++) {
    let gapFrom = outer[i2 - 1].to, gapTo = outer[i2].from;
    for (; j2 < current.length; j2++) {
      let r2 = current[j2];
      if (r2.from >= gapTo)
        break;
      if (r2.to <= gapFrom)
        continue;
      if (!copy)
        current = copy = ranges.slice();
      if (r2.from < gapFrom) {
        copy[j2] = new Range$1(r2.from, gapFrom);
        if (r2.to > gapTo)
          copy.splice(j2 + 1, 0, new Range$1(gapTo, r2.to));
      } else if (r2.to > gapTo) {
        copy[j2--] = new Range$1(gapTo, r2.to);
      } else {
        copy.splice(j2--, 1);
      }
    }
  }
  return current;
}
function findCoverChanges(a2, b2, from, to2) {
  let iA2 = 0, iB2 = 0, inA = false, inB = false, pos = -1e9;
  let result2 = [];
  for (; ; ) {
    let nextA = iA2 == a2.length ? 1e9 : inA ? a2[iA2].to : a2[iA2].from;
    let nextB = iB2 == b2.length ? 1e9 : inB ? b2[iB2].to : b2[iB2].from;
    if (inA != inB) {
      let start = Math.max(pos, from), end = Math.min(nextA, nextB, to2);
      if (start < end)
        result2.push(new Range$1(start, end));
    }
    pos = Math.min(nextA, nextB);
    if (pos == 1e9)
      break;
    if (nextA == pos) {
      if (!inA)
        inA = true;
      else {
        inA = false;
        iA2++;
      }
    }
    if (nextB == pos) {
      if (!inB)
        inB = true;
      else {
        inB = false;
        iB2++;
      }
    }
  }
  return result2;
}
function enterFragments(mounts, ranges) {
  let result2 = [];
  for (let { pos, mount: mount2, frag } of mounts) {
    let startPos = pos + (mount2.overlay ? mount2.overlay[0].from : 0), endPos = startPos + mount2.tree.length;
    let from = Math.max(frag.from, startPos), to2 = Math.min(frag.to, endPos);
    if (mount2.overlay) {
      let overlay2 = mount2.overlay.map((r2) => new Range$1(r2.from + pos, r2.to + pos));
      let changes = findCoverChanges(ranges, overlay2, from, to2);
      for (let i2 = 0, pos2 = from; ; i2++) {
        let last = i2 == changes.length, end = last ? to2 : changes[i2].from;
        if (end > pos2)
          result2.push(new TreeFragment(pos2, end, mount2.tree, -startPos, frag.from >= pos2 || frag.openStart, frag.to <= end || frag.openEnd));
        if (last)
          break;
        pos2 = changes[i2].to;
      }
    } else {
      result2.push(new TreeFragment(from, to2, mount2.tree, -startPos, frag.from >= startPos || frag.openStart, frag.to <= endPos || frag.openEnd));
    }
  }
  return result2;
}
class Stack {
  constructor(p2, stack2, state, reducePos, pos, score2, buffer, bufferBase, curContext, lookAhead = 0, parent) {
    this.p = p2;
    this.stack = stack2;
    this.state = state;
    this.reducePos = reducePos;
    this.pos = pos;
    this.score = score2;
    this.buffer = buffer;
    this.bufferBase = bufferBase;
    this.curContext = curContext;
    this.lookAhead = lookAhead;
    this.parent = parent;
  }
  toString() {
    return `[${this.stack.filter((_2, i2) => i2 % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  static start(p2, state, pos = 0) {
    let cx2 = p2.parser.context;
    return new Stack(p2, [], state, pos, pos, 0, [], 0, cx2 ? new StackContext(cx2, cx2.start) : null, 0, null);
  }
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  pushState(state, start) {
    this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
    this.state = state;
  }
  reduce(action) {
    var _a2;
    let depth = action >> 19, type4 = action & 65535;
    let { parser: parser2 } = this.p;
    let dPrec = parser2.dynamicPrecedence(type4);
    if (dPrec)
      this.score += dPrec;
    if (depth == 0) {
      this.pushState(parser2.getGoto(this.state, type4, true), this.reducePos);
      if (type4 < parser2.minRepeatTerm)
        this.storeNode(type4, this.reducePos, this.reducePos, 4, true);
      this.reduceContext(type4, this.reducePos);
      return;
    }
    let base2 = this.stack.length - (depth - 1) * 3 - (action & 262144 ? 6 : 0);
    let start = base2 ? this.stack[base2 - 2] : this.p.ranges[0].from, size2 = this.reducePos - start;
    if (size2 >= 2e3 && !((_a2 = this.p.parser.nodeSet.types[type4]) === null || _a2 === void 0 ? void 0 : _a2.isAnonymous)) {
      if (start == this.p.lastBigReductionStart) {
        this.p.bigReductionCount++;
        this.p.lastBigReductionSize = size2;
      } else if (this.p.lastBigReductionSize < size2) {
        this.p.bigReductionCount = 1;
        this.p.lastBigReductionStart = start;
        this.p.lastBigReductionSize = size2;
      }
    }
    let bufferBase = base2 ? this.stack[base2 - 1] : 0, count = this.bufferBase + this.buffer.length - bufferBase;
    if (type4 < parser2.minRepeatTerm || action & 131072) {
      let pos = parser2.stateFlag(this.state, 1) ? this.pos : this.reducePos;
      this.storeNode(type4, start, pos, count + 4, true);
    }
    if (action & 262144) {
      this.state = this.stack[base2];
    } else {
      let baseStateID = this.stack[base2 - 3];
      this.state = parser2.getGoto(baseStateID, type4, true);
    }
    while (this.stack.length > base2)
      this.stack.pop();
    this.reduceContext(type4, start);
  }
  storeNode(term, start, end, size2 = 4, isReduce = false) {
    if (term == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let cur2 = this, top2 = this.buffer.length;
      if (top2 == 0 && cur2.parent) {
        top2 = cur2.bufferBase - cur2.parent.bufferBase;
        cur2 = cur2.parent;
      }
      if (top2 > 0 && cur2.buffer[top2 - 4] == 0 && cur2.buffer[top2 - 1] > -1) {
        if (start == end)
          return;
        if (cur2.buffer[top2 - 2] >= start) {
          cur2.buffer[top2 - 2] = end;
          return;
        }
      }
    }
    if (!isReduce || this.pos == end) {
      this.buffer.push(term, start, end, size2);
    } else {
      let index2 = this.buffer.length;
      if (index2 > 0 && this.buffer[index2 - 4] != 0)
        while (index2 > 0 && this.buffer[index2 - 2] > end) {
          this.buffer[index2] = this.buffer[index2 - 4];
          this.buffer[index2 + 1] = this.buffer[index2 - 3];
          this.buffer[index2 + 2] = this.buffer[index2 - 2];
          this.buffer[index2 + 3] = this.buffer[index2 - 1];
          index2 -= 4;
          if (size2 > 4)
            size2 -= 4;
        }
      this.buffer[index2] = term;
      this.buffer[index2 + 1] = start;
      this.buffer[index2 + 2] = end;
      this.buffer[index2 + 3] = size2;
    }
  }
  shift(action, next, nextEnd) {
    let start = this.pos;
    if (action & 131072) {
      this.pushState(action & 65535, this.pos);
    } else if ((action & 262144) == 0) {
      let nextState = action, { parser: parser2 } = this.p;
      if (nextEnd > this.pos || next <= parser2.maxNode) {
        this.pos = nextEnd;
        if (!parser2.stateFlag(nextState, 1))
          this.reducePos = nextEnd;
      }
      this.pushState(nextState, start);
      this.shiftContext(next, start);
      if (next <= parser2.maxNode)
        this.buffer.push(next, start, nextEnd, 4);
    } else {
      this.pos = nextEnd;
      this.shiftContext(next, start);
      if (next <= this.p.parser.maxNode)
        this.buffer.push(next, start, nextEnd, 4);
    }
  }
  apply(action, next, nextEnd) {
    if (action & 65536)
      this.reduce(action);
    else
      this.shift(action, next, nextEnd);
  }
  useNode(value2, next) {
    let index2 = this.p.reused.length - 1;
    if (index2 < 0 || this.p.reused[index2] != value2) {
      this.p.reused.push(value2);
      index2++;
    }
    let start = this.pos;
    this.reducePos = this.pos = start + value2.length;
    this.pushState(next, start);
    this.buffer.push(index2, start, this.reducePos, -1);
    if (this.curContext)
      this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value2, this, this.p.stream.reset(this.pos - value2.length)));
  }
  split() {
    let parent = this;
    let off2 = parent.buffer.length;
    while (off2 > 0 && parent.buffer[off2 - 2] > parent.reducePos)
      off2 -= 4;
    let buffer = parent.buffer.slice(off2), base2 = parent.bufferBase + off2;
    while (parent && base2 == parent.bufferBase)
      parent = parent.parent;
    return new Stack(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base2, this.curContext, this.lookAhead, parent);
  }
  recoverByDelete(next, nextEnd) {
    let isNode = next <= this.p.parser.maxNode;
    if (isNode)
      this.storeNode(next, this.pos, nextEnd, 4);
    this.storeNode(0, this.pos, nextEnd, isNode ? 8 : 4);
    this.pos = this.reducePos = nextEnd;
    this.score -= 190;
  }
  canShift(term) {
    for (let sim = new SimulatedStack(this); ; ) {
      let action = this.p.parser.stateSlot(sim.state, 4) || this.p.parser.hasAction(sim.state, term);
      if (action == 0)
        return false;
      if ((action & 65536) == 0)
        return true;
      sim.reduce(action);
    }
  }
  recoverByInsert(next) {
    if (this.stack.length >= 300)
      return [];
    let nextStates = this.p.parser.nextStates(this.state);
    if (nextStates.length > 4 << 1 || this.stack.length >= 120) {
      let best = [];
      for (let i2 = 0, s2; i2 < nextStates.length; i2 += 2) {
        if ((s2 = nextStates[i2 + 1]) != this.state && this.p.parser.hasAction(s2, next))
          best.push(nextStates[i2], s2);
      }
      if (this.stack.length < 120)
        for (let i2 = 0; best.length < 4 << 1 && i2 < nextStates.length; i2 += 2) {
          let s2 = nextStates[i2 + 1];
          if (!best.some((v2, i3) => i3 & 1 && v2 == s2))
            best.push(nextStates[i2], s2);
        }
      nextStates = best;
    }
    let result2 = [];
    for (let i2 = 0; i2 < nextStates.length && result2.length < 4; i2 += 2) {
      let s2 = nextStates[i2 + 1];
      if (s2 == this.state)
        continue;
      let stack2 = this.split();
      stack2.pushState(s2, this.pos);
      stack2.storeNode(0, stack2.pos, stack2.pos, 4, true);
      stack2.shiftContext(nextStates[i2], this.pos);
      stack2.score -= 200;
      result2.push(stack2);
    }
    return result2;
  }
  forceReduce() {
    let { parser: parser2 } = this.p;
    let reduce = parser2.stateSlot(this.state, 5);
    if ((reduce & 65536) == 0)
      return false;
    if (!parser2.validAction(this.state, reduce)) {
      let depth = reduce >> 19, term = reduce & 65535;
      let target = this.stack.length - depth * 3;
      if (target < 0 || parser2.getGoto(this.stack[target], term, false) < 0) {
        let backup = this.findForcedReduction();
        if (backup == null)
          return false;
        reduce = backup;
      }
      this.storeNode(0, this.pos, this.pos, 4, true);
      this.score -= 100;
    }
    this.reducePos = this.pos;
    this.reduce(reduce);
    return true;
  }
  findForcedReduction() {
    let { parser: parser2 } = this.p, seen = [];
    let explore = (state, depth) => {
      if (seen.includes(state))
        return;
      seen.push(state);
      return parser2.allActions(state, (action) => {
        if (action & (262144 | 131072))
          ;
        else if (action & 65536) {
          let rDepth = (action >> 19) - depth;
          if (rDepth > 1) {
            let term = action & 65535, target = this.stack.length - rDepth * 3;
            if (target >= 0 && parser2.getGoto(this.stack[target], term, false) >= 0)
              return rDepth << 19 | 65536 | term;
          }
        } else {
          let found = explore(action, depth + 1);
          if (found != null)
            return found;
        }
      });
    };
    return explore(this.state, 0);
  }
  forceAll() {
    while (!this.p.parser.stateFlag(this.state, 2)) {
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, true);
        break;
      }
    }
    return this;
  }
  get deadEnd() {
    if (this.stack.length != 3)
      return false;
    let { parser: parser2 } = this.p;
    return parser2.data[parser2.stateSlot(this.state, 1)] == 65535 && !parser2.stateSlot(this.state, 4);
  }
  restart() {
    this.state = this.stack[0];
    this.stack.length = 0;
  }
  sameState(other) {
    if (this.state != other.state || this.stack.length != other.stack.length)
      return false;
    for (let i2 = 0; i2 < this.stack.length; i2 += 3)
      if (this.stack[i2] != other.stack[i2])
        return false;
    return true;
  }
  get parser() {
    return this.p.parser;
  }
  dialectEnabled(dialectID) {
    return this.p.parser.dialect.flags[dialectID];
  }
  shiftContext(term, start) {
    if (this.curContext)
      this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
  }
  reduceContext(term, start) {
    if (this.curContext)
      this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
  }
  emitContext() {
    let last = this.buffer.length - 1;
    if (last < 0 || this.buffer[last] != -3)
      this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  emitLookAhead() {
    let last = this.buffer.length - 1;
    if (last < 0 || this.buffer[last] != -4)
      this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(context) {
    if (context != this.curContext.context) {
      let newCx = new StackContext(this.curContext.tracker, context);
      if (newCx.hash != this.curContext.hash)
        this.emitContext();
      this.curContext = newCx;
    }
  }
  setLookAhead(lookAhead) {
    if (lookAhead > this.lookAhead) {
      this.emitLookAhead();
      this.lookAhead = lookAhead;
    }
  }
  close() {
    if (this.curContext && this.curContext.tracker.strict)
      this.emitContext();
    if (this.lookAhead > 0)
      this.emitLookAhead();
  }
}
class StackContext {
  constructor(tracker, context) {
    this.tracker = tracker;
    this.context = context;
    this.hash = tracker.strict ? tracker.hash(context) : 0;
  }
}
var Recover;
(function(Recover2) {
  Recover2[Recover2["Insert"] = 200] = "Insert";
  Recover2[Recover2["Delete"] = 190] = "Delete";
  Recover2[Recover2["Reduce"] = 100] = "Reduce";
  Recover2[Recover2["MaxNext"] = 4] = "MaxNext";
  Recover2[Recover2["MaxInsertStackDepth"] = 300] = "MaxInsertStackDepth";
  Recover2[Recover2["DampenInsertStackDepth"] = 120] = "DampenInsertStackDepth";
  Recover2[Recover2["MinBigReduction"] = 2e3] = "MinBigReduction";
})(Recover || (Recover = {}));
class SimulatedStack {
  constructor(start) {
    this.start = start;
    this.state = start.state;
    this.stack = start.stack;
    this.base = this.stack.length;
  }
  reduce(action) {
    let term = action & 65535, depth = action >> 19;
    if (depth == 0) {
      if (this.stack == this.start.stack)
        this.stack = this.stack.slice();
      this.stack.push(this.state, 0, 0);
      this.base += 3;
    } else {
      this.base -= (depth - 1) * 3;
    }
    let goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
    this.state = goto;
  }
}
class StackBufferCursor {
  constructor(stack2, pos, index2) {
    this.stack = stack2;
    this.pos = pos;
    this.index = index2;
    this.buffer = stack2.buffer;
    if (this.index == 0)
      this.maybeNext();
  }
  static create(stack2, pos = stack2.bufferBase + stack2.buffer.length) {
    return new StackBufferCursor(stack2, pos, pos - stack2.bufferBase);
  }
  maybeNext() {
    let next = this.stack.parent;
    if (next != null) {
      this.index = this.stack.bufferBase - next.bufferBase;
      this.stack = next;
      this.buffer = next.buffer;
    }
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4;
    this.pos -= 4;
    if (this.index == 0)
      this.maybeNext();
  }
  fork() {
    return new StackBufferCursor(this.stack, this.pos, this.index);
  }
}
function decodeArray(input, Type2 = Uint16Array) {
  if (typeof input != "string")
    return input;
  let array4 = null;
  for (let pos = 0, out = 0; pos < input.length; ) {
    let value2 = 0;
    for (; ; ) {
      let next = input.charCodeAt(pos++), stop = false;
      if (next == 126) {
        value2 = 65535;
        break;
      }
      if (next >= 92)
        next--;
      if (next >= 34)
        next--;
      let digit = next - 32;
      if (digit >= 46) {
        digit -= 46;
        stop = true;
      }
      value2 += digit;
      if (stop)
        break;
      value2 *= 46;
    }
    if (array4)
      array4[out++] = value2;
    else
      array4 = new Type2(value2);
  }
  return array4;
}
class CachedToken {
  constructor() {
    this.start = -1;
    this.value = -1;
    this.end = -1;
    this.extended = -1;
    this.lookAhead = 0;
    this.mask = 0;
    this.context = 0;
  }
}
const nullToken = new CachedToken();
class InputStream {
  constructor(input, ranges) {
    this.input = input;
    this.ranges = ranges;
    this.chunk = "";
    this.chunkOff = 0;
    this.chunk2 = "";
    this.chunk2Pos = 0;
    this.next = -1;
    this.token = nullToken;
    this.rangeIndex = 0;
    this.pos = this.chunkPos = ranges[0].from;
    this.range = ranges[0];
    this.end = ranges[ranges.length - 1].to;
    this.readNext();
  }
  resolveOffset(offset, assoc) {
    let range3 = this.range, index2 = this.rangeIndex;
    let pos = this.pos + offset;
    while (pos < range3.from) {
      if (!index2)
        return null;
      let next = this.ranges[--index2];
      pos -= range3.from - next.to;
      range3 = next;
    }
    while (assoc < 0 ? pos > range3.to : pos >= range3.to) {
      if (index2 == this.ranges.length - 1)
        return null;
      let next = this.ranges[++index2];
      pos += next.from - range3.to;
      range3 = next;
    }
    return pos;
  }
  clipPos(pos) {
    if (pos >= this.range.from && pos < this.range.to)
      return pos;
    for (let range3 of this.ranges)
      if (range3.to > pos)
        return Math.max(pos, range3.from);
    return this.end;
  }
  peek(offset) {
    let idx = this.chunkOff + offset, pos, result2;
    if (idx >= 0 && idx < this.chunk.length) {
      pos = this.pos + offset;
      result2 = this.chunk.charCodeAt(idx);
    } else {
      let resolved = this.resolveOffset(offset, 1);
      if (resolved == null)
        return -1;
      pos = resolved;
      if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) {
        result2 = this.chunk2.charCodeAt(pos - this.chunk2Pos);
      } else {
        let i2 = this.rangeIndex, range3 = this.range;
        while (range3.to <= pos)
          range3 = this.ranges[++i2];
        this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
        if (pos + this.chunk2.length > range3.to)
          this.chunk2 = this.chunk2.slice(0, range3.to - pos);
        result2 = this.chunk2.charCodeAt(0);
      }
    }
    if (pos >= this.token.lookAhead)
      this.token.lookAhead = pos + 1;
    return result2;
  }
  acceptToken(token, endOffset = 0) {
    let end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
    if (end == null || end < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = token;
    this.token.end = end;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk, chunkPos } = this;
      this.chunk = this.chunk2;
      this.chunkPos = this.chunk2Pos;
      this.chunk2 = chunk;
      this.chunk2Pos = chunkPos;
      this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk;
      this.chunk2Pos = this.chunkPos;
      let nextChunk = this.input.chunk(this.pos);
      let end = this.pos + nextChunk.length;
      this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
      this.chunkPos = this.pos;
      this.chunkOff = 0;
    }
  }
  readNext() {
    if (this.chunkOff >= this.chunk.length) {
      this.getChunk();
      if (this.chunkOff == this.chunk.length)
        return this.next = -1;
    }
    return this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  advance(n2 = 1) {
    this.chunkOff += n2;
    while (this.pos + n2 >= this.range.to) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      n2 -= this.range.to - this.pos;
      this.range = this.ranges[++this.rangeIndex];
      this.pos = this.range.from;
    }
    this.pos += n2;
    if (this.pos >= this.token.lookAhead)
      this.token.lookAhead = this.pos + 1;
    return this.readNext();
  }
  setDone() {
    this.pos = this.chunkPos = this.end;
    this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
    this.chunk = "";
    return this.next = -1;
  }
  reset(pos, token) {
    if (token) {
      this.token = token;
      token.start = pos;
      token.lookAhead = pos + 1;
      token.value = token.extended = -1;
    } else {
      this.token = nullToken;
    }
    if (this.pos != pos) {
      this.pos = pos;
      if (pos == this.end) {
        this.setDone();
        return this;
      }
      while (pos < this.range.from)
        this.range = this.ranges[--this.rangeIndex];
      while (pos >= this.range.to)
        this.range = this.ranges[++this.rangeIndex];
      if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) {
        this.chunkOff = pos - this.chunkPos;
      } else {
        this.chunk = "";
        this.chunkOff = 0;
      }
      this.readNext();
    }
    return this;
  }
  read(from, to2) {
    if (from >= this.chunkPos && to2 <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(from - this.chunkPos, to2 - this.chunkPos);
    if (from >= this.chunk2Pos && to2 <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(from - this.chunk2Pos, to2 - this.chunk2Pos);
    if (from >= this.range.from && to2 <= this.range.to)
      return this.input.read(from, to2);
    let result2 = "";
    for (let r2 of this.ranges) {
      if (r2.from >= to2)
        break;
      if (r2.to > from)
        result2 += this.input.read(Math.max(r2.from, from), Math.min(r2.to, to2));
    }
    return result2;
  }
}
class TokenGroup {
  constructor(data, id2) {
    this.data = data;
    this.id = id2;
  }
  token(input, stack2) {
    let { parser: parser2 } = stack2.p;
    readToken(this.data, input, stack2, this.id, parser2.data, parser2.tokenPrecTable);
  }
}
TokenGroup.prototype.contextual = TokenGroup.prototype.fallback = TokenGroup.prototype.extend = false;
class LocalTokenGroup {
  constructor(data, precTable, elseToken) {
    this.precTable = precTable;
    this.elseToken = elseToken;
    this.data = typeof data == "string" ? decodeArray(data) : data;
  }
  token(input, stack2) {
    let start = input.pos, skipped = 0;
    for (; ; ) {
      let atEof = input.next < 0, nextPos = input.resolveOffset(1, 1);
      readToken(this.data, input, stack2, 0, this.data, this.precTable);
      if (input.token.value > -1)
        break;
      if (this.elseToken == null)
        return;
      if (!atEof)
        skipped++;
      if (nextPos == null)
        break;
      input.reset(nextPos, input.token);
    }
    if (skipped) {
      input.reset(start, input.token);
      input.acceptToken(this.elseToken, skipped);
    }
  }
}
LocalTokenGroup.prototype.contextual = TokenGroup.prototype.fallback = TokenGroup.prototype.extend = false;
class ExternalTokenizer {
  constructor(token, options = {}) {
    this.token = token;
    this.contextual = !!options.contextual;
    this.fallback = !!options.fallback;
    this.extend = !!options.extend;
  }
}
function readToken(data, input, stack2, group, precTable, precOffset) {
  let state = 0, groupMask = 1 << group, { dialect } = stack2.p.parser;
  scan:
    for (; ; ) {
      if ((groupMask & data[state]) == 0)
        break;
      let accEnd = data[state + 1];
      for (let i2 = state + 3; i2 < accEnd; i2 += 2)
        if ((data[i2 + 1] & groupMask) > 0) {
          let term = data[i2];
          if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || overrides(term, input.token.value, precTable, precOffset))) {
            input.acceptToken(term);
            break;
          }
        }
      let next = input.next, low = 0, high = data[state + 2];
      if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535 && data[accEnd + high * 3 - 3] == 65535) {
        state = data[accEnd + high * 3 - 1];
        continue scan;
      }
      for (; low < high; ) {
        let mid = low + high >> 1;
        let index2 = accEnd + mid + (mid << 1);
        let from = data[index2], to2 = data[index2 + 1] || 65536;
        if (next < from)
          high = mid;
        else if (next >= to2)
          low = mid + 1;
        else {
          state = data[index2 + 2];
          input.advance();
          continue scan;
        }
      }
      break;
    }
}
function findOffset(data, start, term) {
  for (let i2 = start, next; (next = data[i2]) != 65535; i2++)
    if (next == term)
      return i2 - start;
  return -1;
}
function overrides(token, prev, tableData, tableOffset) {
  let iPrev = findOffset(tableData, tableOffset, prev);
  return iPrev < 0 || findOffset(tableData, tableOffset, token) < iPrev;
}
const verbose = typeof process != "undefined" && process.env && /\bparse\b/.test({}.LOG);
let stackIDs = null;
var Safety;
(function(Safety2) {
  Safety2[Safety2["Margin"] = 25] = "Margin";
})(Safety || (Safety = {}));
function cutAt(tree, pos, side) {
  let cursor = tree.cursor(IterMode.IncludeAnonymous);
  cursor.moveTo(pos);
  for (; ; ) {
    if (!(side < 0 ? cursor.childBefore(pos) : cursor.childAfter(pos)))
      for (; ; ) {
        if ((side < 0 ? cursor.to < pos : cursor.from > pos) && !cursor.type.isError)
          return side < 0 ? Math.max(0, Math.min(cursor.to - 1, pos - 25)) : Math.min(tree.length, Math.max(cursor.from + 1, pos + 25));
        if (side < 0 ? cursor.prevSibling() : cursor.nextSibling())
          break;
        if (!cursor.parent())
          return side < 0 ? 0 : tree.length;
      }
  }
}
class FragmentCursor {
  constructor(fragments, nodeSet) {
    this.fragments = fragments;
    this.nodeSet = nodeSet;
    this.i = 0;
    this.fragment = null;
    this.safeFrom = -1;
    this.safeTo = -1;
    this.trees = [];
    this.start = [];
    this.index = [];
    this.nextFragment();
  }
  nextFragment() {
    let fr2 = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (fr2) {
      this.safeFrom = fr2.openStart ? cutAt(fr2.tree, fr2.from + fr2.offset, 1) - fr2.offset : fr2.from;
      this.safeTo = fr2.openEnd ? cutAt(fr2.tree, fr2.to + fr2.offset, -1) - fr2.offset : fr2.to;
      while (this.trees.length) {
        this.trees.pop();
        this.start.pop();
        this.index.pop();
      }
      this.trees.push(fr2.tree);
      this.start.push(-fr2.offset);
      this.index.push(0);
      this.nextStart = this.safeFrom;
    } else {
      this.nextStart = 1e9;
    }
  }
  nodeAt(pos) {
    if (pos < this.nextStart)
      return null;
    while (this.fragment && this.safeTo <= pos)
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let last = this.trees.length - 1;
      if (last < 0) {
        this.nextFragment();
        return null;
      }
      let top2 = this.trees[last], index2 = this.index[last];
      if (index2 == top2.children.length) {
        this.trees.pop();
        this.start.pop();
        this.index.pop();
        continue;
      }
      let next = top2.children[index2];
      let start = this.start[last] + top2.positions[index2];
      if (start > pos) {
        this.nextStart = start;
        return null;
      }
      if (next instanceof Tree) {
        if (start == pos) {
          if (start < this.safeFrom)
            return null;
          let end = start + next.length;
          if (end <= this.safeTo) {
            let lookAhead = next.prop(NodeProp.lookAhead);
            if (!lookAhead || end + lookAhead < this.fragment.to)
              return next;
          }
        }
        this.index[last]++;
        if (start + next.length >= Math.max(this.safeFrom, pos)) {
          this.trees.push(next);
          this.start.push(start);
          this.index.push(0);
        }
      } else {
        this.index[last]++;
        this.nextStart = start + next.length;
      }
    }
  }
}
class TokenCache {
  constructor(parser2, stream) {
    this.stream = stream;
    this.tokens = [];
    this.mainToken = null;
    this.actions = [];
    this.tokens = parser2.tokenizers.map((_2) => new CachedToken());
  }
  getActions(stack2) {
    let actionIndex = 0;
    let main = null;
    let { parser: parser2 } = stack2.p, { tokenizers } = parser2;
    let mask = parser2.stateSlot(stack2.state, 3);
    let context = stack2.curContext ? stack2.curContext.hash : 0;
    let lookAhead = 0;
    for (let i2 = 0; i2 < tokenizers.length; i2++) {
      if ((1 << i2 & mask) == 0)
        continue;
      let tokenizer = tokenizers[i2], token = this.tokens[i2];
      if (main && !tokenizer.fallback)
        continue;
      if (tokenizer.contextual || token.start != stack2.pos || token.mask != mask || token.context != context) {
        this.updateCachedToken(token, tokenizer, stack2);
        token.mask = mask;
        token.context = context;
      }
      if (token.lookAhead > token.end + 25)
        lookAhead = Math.max(token.lookAhead, lookAhead);
      if (token.value != 0) {
        let startIndex = actionIndex;
        if (token.extended > -1)
          actionIndex = this.addActions(stack2, token.extended, token.end, actionIndex);
        actionIndex = this.addActions(stack2, token.value, token.end, actionIndex);
        if (!tokenizer.extend) {
          main = token;
          if (actionIndex > startIndex)
            break;
        }
      }
    }
    while (this.actions.length > actionIndex)
      this.actions.pop();
    if (lookAhead)
      stack2.setLookAhead(lookAhead);
    if (!main && stack2.pos == this.stream.end) {
      main = new CachedToken();
      main.value = stack2.p.parser.eofTerm;
      main.start = main.end = stack2.pos;
      actionIndex = this.addActions(stack2, main.value, main.end, actionIndex);
    }
    this.mainToken = main;
    return this.actions;
  }
  getMainToken(stack2) {
    if (this.mainToken)
      return this.mainToken;
    let main = new CachedToken(), { pos, p: p2 } = stack2;
    main.start = pos;
    main.end = Math.min(pos + 1, p2.stream.end);
    main.value = pos == p2.stream.end ? p2.parser.eofTerm : 0;
    return main;
  }
  updateCachedToken(token, tokenizer, stack2) {
    let start = this.stream.clipPos(stack2.pos);
    tokenizer.token(this.stream.reset(start, token), stack2);
    if (token.value > -1) {
      let { parser: parser2 } = stack2.p;
      for (let i2 = 0; i2 < parser2.specialized.length; i2++)
        if (parser2.specialized[i2] == token.value) {
          let result2 = parser2.specializers[i2](this.stream.read(token.start, token.end), stack2);
          if (result2 >= 0 && stack2.p.parser.dialect.allows(result2 >> 1)) {
            if ((result2 & 1) == 0)
              token.value = result2 >> 1;
            else
              token.extended = result2 >> 1;
            break;
          }
        }
    } else {
      token.value = 0;
      token.end = this.stream.clipPos(start + 1);
    }
  }
  putAction(action, token, end, index2) {
    for (let i2 = 0; i2 < index2; i2 += 3)
      if (this.actions[i2] == action)
        return index2;
    this.actions[index2++] = action;
    this.actions[index2++] = token;
    this.actions[index2++] = end;
    return index2;
  }
  addActions(stack2, token, end, index2) {
    let { state } = stack2, { parser: parser2 } = stack2.p, { data } = parser2;
    for (let set2 = 0; set2 < 2; set2++) {
      for (let i2 = parser2.stateSlot(state, set2 ? 2 : 1); ; i2 += 3) {
        if (data[i2] == 65535) {
          if (data[i2 + 1] == 1) {
            i2 = pair(data, i2 + 2);
          } else {
            if (index2 == 0 && data[i2 + 1] == 2)
              index2 = this.putAction(pair(data, i2 + 2), token, end, index2);
            break;
          }
        }
        if (data[i2] == token)
          index2 = this.putAction(pair(data, i2 + 1), token, end, index2);
      }
    }
    return index2;
  }
}
var Rec;
(function(Rec2) {
  Rec2[Rec2["Distance"] = 5] = "Distance";
  Rec2[Rec2["MaxRemainingPerStep"] = 3] = "MaxRemainingPerStep";
  Rec2[Rec2["MinBufferLengthPrune"] = 500] = "MinBufferLengthPrune";
  Rec2[Rec2["ForceReduceLimit"] = 10] = "ForceReduceLimit";
  Rec2[Rec2["CutDepth"] = 15e3] = "CutDepth";
  Rec2[Rec2["CutTo"] = 9e3] = "CutTo";
  Rec2[Rec2["MaxLeftAssociativeReductionCount"] = 300] = "MaxLeftAssociativeReductionCount";
  Rec2[Rec2["MaxStackCount"] = 12] = "MaxStackCount";
})(Rec || (Rec = {}));
class Parse {
  constructor(parser2, input, fragments, ranges) {
    this.parser = parser2;
    this.input = input;
    this.ranges = ranges;
    this.recovering = 0;
    this.nextStackID = 9812;
    this.minStackPos = 0;
    this.reused = [];
    this.stoppedAt = null;
    this.lastBigReductionStart = -1;
    this.lastBigReductionSize = 0;
    this.bigReductionCount = 0;
    this.stream = new InputStream(input, ranges);
    this.tokens = new TokenCache(parser2, this.stream);
    this.topTerm = parser2.top[1];
    let { from } = ranges[0];
    this.stacks = [Stack.start(this, parser2.top[0], from)];
    this.fragments = fragments.length && this.stream.end - from > parser2.bufferLength * 4 ? new FragmentCursor(fragments, parser2.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  advance() {
    let stacks = this.stacks, pos = this.minStackPos;
    let newStacks = this.stacks = [];
    let stopped, stoppedTokens;
    if (this.bigReductionCount > 300 && stacks.length == 1) {
      let [s2] = stacks;
      while (s2.forceReduce() && s2.stack.length && s2.stack[s2.stack.length - 2] >= this.lastBigReductionStart) {
      }
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let i2 = 0; i2 < stacks.length; i2++) {
      let stack2 = stacks[i2];
      for (; ; ) {
        this.tokens.mainToken = null;
        if (stack2.pos > pos) {
          newStacks.push(stack2);
        } else if (this.advanceStack(stack2, newStacks, stacks)) {
          continue;
        } else {
          if (!stopped) {
            stopped = [];
            stoppedTokens = [];
          }
          stopped.push(stack2);
          let tok = this.tokens.getMainToken(stack2);
          stoppedTokens.push(tok.value, tok.end);
        }
        break;
      }
    }
    if (!newStacks.length) {
      let finished = stopped && findFinished(stopped);
      if (finished)
        return this.stackToTree(finished);
      if (this.parser.strict) {
        if (verbose && stopped)
          console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
        throw new SyntaxError("No parse at " + pos);
      }
      if (!this.recovering)
        this.recovering = 5;
    }
    if (this.recovering && stopped) {
      let finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
      if (finished)
        return this.stackToTree(finished.forceAll());
    }
    if (this.recovering) {
      let maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3;
      if (newStacks.length > maxRemaining) {
        newStacks.sort((a2, b2) => b2.score - a2.score);
        while (newStacks.length > maxRemaining)
          newStacks.pop();
      }
      if (newStacks.some((s2) => s2.reducePos > pos))
        this.recovering--;
    } else if (newStacks.length > 1) {
      outer:
        for (let i2 = 0; i2 < newStacks.length - 1; i2++) {
          let stack2 = newStacks[i2];
          for (let j2 = i2 + 1; j2 < newStacks.length; j2++) {
            let other = newStacks[j2];
            if (stack2.sameState(other) || stack2.buffer.length > 500 && other.buffer.length > 500) {
              if ((stack2.score - other.score || stack2.buffer.length - other.buffer.length) > 0) {
                newStacks.splice(j2--, 1);
              } else {
                newStacks.splice(i2--, 1);
                continue outer;
              }
            }
          }
        }
      if (newStacks.length > 12)
        newStacks.splice(12, newStacks.length - 12);
    }
    this.minStackPos = newStacks[0].pos;
    for (let i2 = 1; i2 < newStacks.length; i2++)
      if (newStacks[i2].pos < this.minStackPos)
        this.minStackPos = newStacks[i2].pos;
    return null;
  }
  stopAt(pos) {
    if (this.stoppedAt != null && this.stoppedAt < pos)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = pos;
  }
  advanceStack(stack2, stacks, split) {
    let start = stack2.pos, { parser: parser2 } = this;
    let base2 = verbose ? this.stackID(stack2) + " -> " : "";
    if (this.stoppedAt != null && start > this.stoppedAt)
      return stack2.forceReduce() ? stack2 : null;
    if (this.fragments) {
      let strictCx = stack2.curContext && stack2.curContext.tracker.strict, cxHash = strictCx ? stack2.curContext.hash : 0;
      for (let cached = this.fragments.nodeAt(start); cached; ) {
        let match2 = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser2.getGoto(stack2.state, cached.type.id) : -1;
        if (match2 > -1 && cached.length && (!strictCx || (cached.prop(NodeProp.contextHash) || 0) == cxHash)) {
          stack2.useNode(cached, match2);
          if (verbose)
            console.log(base2 + this.stackID(stack2) + ` (via reuse of ${parser2.getName(cached.type.id)})`);
          return true;
        }
        if (!(cached instanceof Tree) || cached.children.length == 0 || cached.positions[0] > 0)
          break;
        let inner = cached.children[0];
        if (inner instanceof Tree && cached.positions[0] == 0)
          cached = inner;
        else
          break;
      }
    }
    let defaultReduce = parser2.stateSlot(stack2.state, 4);
    if (defaultReduce > 0) {
      stack2.reduce(defaultReduce);
      if (verbose)
        console.log(base2 + this.stackID(stack2) + ` (via always-reduce ${parser2.getName(defaultReduce & 65535)})`);
      return true;
    }
    if (stack2.stack.length >= 15e3) {
      while (stack2.stack.length > 9e3 && stack2.forceReduce()) {
      }
    }
    let actions = this.tokens.getActions(stack2);
    for (let i2 = 0; i2 < actions.length; ) {
      let action = actions[i2++], term = actions[i2++], end = actions[i2++];
      let last = i2 == actions.length || !split;
      let localStack = last ? stack2 : stack2.split();
      localStack.apply(action, term, end);
      if (verbose)
        console.log(base2 + this.stackID(localStack) + ` (via ${(action & 65536) == 0 ? "shift" : `reduce of ${parser2.getName(action & 65535)}`} for ${parser2.getName(term)} @ ${start}${localStack == stack2 ? "" : ", split"})`);
      if (last)
        return true;
      else if (localStack.pos > start)
        stacks.push(localStack);
      else
        split.push(localStack);
    }
    return false;
  }
  advanceFully(stack2, newStacks) {
    let pos = stack2.pos;
    for (; ; ) {
      if (!this.advanceStack(stack2, null, null))
        return false;
      if (stack2.pos > pos) {
        pushStackDedup(stack2, newStacks);
        return true;
      }
    }
  }
  runRecovery(stacks, tokens, newStacks) {
    let finished = null, restarted = false;
    for (let i2 = 0; i2 < stacks.length; i2++) {
      let stack2 = stacks[i2], token = tokens[i2 << 1], tokenEnd = tokens[(i2 << 1) + 1];
      let base2 = verbose ? this.stackID(stack2) + " -> " : "";
      if (stack2.deadEnd) {
        if (restarted)
          continue;
        restarted = true;
        stack2.restart();
        if (verbose)
          console.log(base2 + this.stackID(stack2) + " (restarted)");
        let done = this.advanceFully(stack2, newStacks);
        if (done)
          continue;
      }
      let force = stack2.split(), forceBase = base2;
      for (let j2 = 0; force.forceReduce() && j2 < 10; j2++) {
        if (verbose)
          console.log(forceBase + this.stackID(force) + " (via force-reduce)");
        let done = this.advanceFully(force, newStacks);
        if (done)
          break;
        if (verbose)
          forceBase = this.stackID(force) + " -> ";
      }
      for (let insert2 of stack2.recoverByInsert(token)) {
        if (verbose)
          console.log(base2 + this.stackID(insert2) + " (via recover-insert)");
        this.advanceFully(insert2, newStacks);
      }
      if (this.stream.end > stack2.pos) {
        if (tokenEnd == stack2.pos) {
          tokenEnd++;
          token = 0;
        }
        stack2.recoverByDelete(token, tokenEnd);
        if (verbose)
          console.log(base2 + this.stackID(stack2) + ` (via recover-delete ${this.parser.getName(token)})`);
        pushStackDedup(stack2, newStacks);
      } else if (!finished || finished.score < stack2.score) {
        finished = stack2;
      }
    }
    return finished;
  }
  stackToTree(stack2) {
    stack2.close();
    return Tree.build({
      buffer: StackBufferCursor.create(stack2),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: stack2.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(stack2) {
    let id2 = (stackIDs || (stackIDs = new WeakMap())).get(stack2);
    if (!id2)
      stackIDs.set(stack2, id2 = String.fromCodePoint(this.nextStackID++));
    return id2 + stack2;
  }
}
function pushStackDedup(stack2, newStacks) {
  for (let i2 = 0; i2 < newStacks.length; i2++) {
    let other = newStacks[i2];
    if (other.pos == stack2.pos && other.sameState(stack2)) {
      if (newStacks[i2].score < stack2.score)
        newStacks[i2] = stack2;
      return;
    }
  }
  newStacks.push(stack2);
}
class Dialect {
  constructor(source, flags, disabled) {
    this.source = source;
    this.flags = flags;
    this.disabled = disabled;
  }
  allows(term) {
    return !this.disabled || this.disabled[term] == 0;
  }
}
const id$1 = (x2) => x2;
class ContextTracker {
  constructor(spec2) {
    this.start = spec2.start;
    this.shift = spec2.shift || id$1;
    this.reduce = spec2.reduce || id$1;
    this.reuse = spec2.reuse || id$1;
    this.hash = spec2.hash || (() => 0);
    this.strict = spec2.strict !== false;
  }
}
class LRParser extends Parser {
  constructor(spec2) {
    super();
    this.wrappers = [];
    if (spec2.version != 14)
      throw new RangeError(`Parser version (${spec2.version}) doesn't match runtime version (${14})`);
    let nodeNames = spec2.nodeNames.split(" ");
    this.minRepeatTerm = nodeNames.length;
    for (let i2 = 0; i2 < spec2.repeatNodeCount; i2++)
      nodeNames.push("");
    let topTerms = Object.keys(spec2.topRules).map((r2) => spec2.topRules[r2][1]);
    let nodeProps = [];
    for (let i2 = 0; i2 < nodeNames.length; i2++)
      nodeProps.push([]);
    function setProp(nodeID, prop, value2) {
      nodeProps[nodeID].push([prop, prop.deserialize(String(value2))]);
    }
    if (spec2.nodeProps)
      for (let propSpec of spec2.nodeProps) {
        let prop = propSpec[0];
        if (typeof prop == "string")
          prop = NodeProp[prop];
        for (let i2 = 1; i2 < propSpec.length; ) {
          let next = propSpec[i2++];
          if (next >= 0) {
            setProp(next, prop, propSpec[i2++]);
          } else {
            let value2 = propSpec[i2 + -next];
            for (let j2 = -next; j2 > 0; j2--)
              setProp(propSpec[i2++], prop, value2);
            i2++;
          }
        }
      }
    this.nodeSet = new NodeSet(nodeNames.map((name2, i2) => NodeType.define({
      name: i2 >= this.minRepeatTerm ? void 0 : name2,
      id: i2,
      props: nodeProps[i2],
      top: topTerms.indexOf(i2) > -1,
      error: i2 == 0,
      skipped: spec2.skippedNodes && spec2.skippedNodes.indexOf(i2) > -1
    })));
    if (spec2.propSources)
      this.nodeSet = this.nodeSet.extend(...spec2.propSources);
    this.strict = false;
    this.bufferLength = DefaultBufferLength;
    let tokenArray = decodeArray(spec2.tokenData);
    this.context = spec2.context;
    this.specializerSpecs = spec2.specialized || [];
    this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let i2 = 0; i2 < this.specializerSpecs.length; i2++)
      this.specialized[i2] = this.specializerSpecs[i2].term;
    this.specializers = this.specializerSpecs.map(getSpecializer);
    this.states = decodeArray(spec2.states, Uint32Array);
    this.data = decodeArray(spec2.stateData);
    this.goto = decodeArray(spec2.goto);
    this.maxTerm = spec2.maxTerm;
    this.tokenizers = spec2.tokenizers.map((value2) => typeof value2 == "number" ? new TokenGroup(tokenArray, value2) : value2);
    this.topRules = spec2.topRules;
    this.dialects = spec2.dialects || {};
    this.dynamicPrecedences = spec2.dynamicPrecedences || null;
    this.tokenPrecTable = spec2.tokenPrec;
    this.termNames = spec2.termNames || null;
    this.maxNode = this.nodeSet.types.length - 1;
    this.dialect = this.parseDialect();
    this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(input, fragments, ranges) {
    let parse2 = new Parse(this, input, fragments, ranges);
    for (let w2 of this.wrappers)
      parse2 = w2(parse2, input, fragments, ranges);
    return parse2;
  }
  getGoto(state, term, loose = false) {
    let table = this.goto;
    if (term >= table[0])
      return -1;
    for (let pos = table[term + 1]; ; ) {
      let groupTag = table[pos++], last = groupTag & 1;
      let target = table[pos++];
      if (last && loose)
        return target;
      for (let end = pos + (groupTag >> 1); pos < end; pos++)
        if (table[pos] == state)
          return target;
      if (last)
        return -1;
    }
  }
  hasAction(state, terminal) {
    let data = this.data;
    for (let set2 = 0; set2 < 2; set2++) {
      for (let i2 = this.stateSlot(state, set2 ? 2 : 1), next; ; i2 += 3) {
        if ((next = data[i2]) == 65535) {
          if (data[i2 + 1] == 1)
            next = data[i2 = pair(data, i2 + 2)];
          else if (data[i2 + 1] == 2)
            return pair(data, i2 + 2);
          else
            break;
        }
        if (next == terminal || next == 0)
          return pair(data, i2 + 1);
      }
    }
    return 0;
  }
  stateSlot(state, slot) {
    return this.states[state * 6 + slot];
  }
  stateFlag(state, flag) {
    return (this.stateSlot(state, 0) & flag) > 0;
  }
  validAction(state, action) {
    return !!this.allActions(state, (a2) => a2 == action ? true : null);
  }
  allActions(state, action) {
    let deflt = this.stateSlot(state, 4);
    let result2 = deflt ? action(deflt) : void 0;
    for (let i2 = this.stateSlot(state, 1); result2 == null; i2 += 3) {
      if (this.data[i2] == 65535) {
        if (this.data[i2 + 1] == 1)
          i2 = pair(this.data, i2 + 2);
        else
          break;
      }
      result2 = action(pair(this.data, i2 + 1));
    }
    return result2;
  }
  nextStates(state) {
    let result2 = [];
    for (let i2 = this.stateSlot(state, 1); ; i2 += 3) {
      if (this.data[i2] == 65535) {
        if (this.data[i2 + 1] == 1)
          i2 = pair(this.data, i2 + 2);
        else
          break;
      }
      if ((this.data[i2 + 2] & 65536 >> 16) == 0) {
        let value2 = this.data[i2 + 1];
        if (!result2.some((v2, i3) => i3 & 1 && v2 == value2))
          result2.push(this.data[i2], value2);
      }
    }
    return result2;
  }
  configure(config2) {
    let copy = Object.assign(Object.create(LRParser.prototype), this);
    if (config2.props)
      copy.nodeSet = this.nodeSet.extend(...config2.props);
    if (config2.top) {
      let info = this.topRules[config2.top];
      if (!info)
        throw new RangeError(`Invalid top rule name ${config2.top}`);
      copy.top = info;
    }
    if (config2.tokenizers)
      copy.tokenizers = this.tokenizers.map((t2) => {
        let found = config2.tokenizers.find((r2) => r2.from == t2);
        return found ? found.to : t2;
      });
    if (config2.specializers) {
      copy.specializers = this.specializers.slice();
      copy.specializerSpecs = this.specializerSpecs.map((s2, i2) => {
        let found = config2.specializers.find((r2) => r2.from == s2.external);
        if (!found)
          return s2;
        let spec2 = Object.assign(Object.assign({}, s2), { external: found.to });
        copy.specializers[i2] = getSpecializer(spec2);
        return spec2;
      });
    }
    if (config2.contextTracker)
      copy.context = config2.contextTracker;
    if (config2.dialect)
      copy.dialect = this.parseDialect(config2.dialect);
    if (config2.strict != null)
      copy.strict = config2.strict;
    if (config2.wrap)
      copy.wrappers = copy.wrappers.concat(config2.wrap);
    if (config2.bufferLength != null)
      copy.bufferLength = config2.bufferLength;
    return copy;
  }
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  getName(term) {
    return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
  }
  get eofTerm() {
    return this.maxNode + 1;
  }
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  dynamicPrecedence(term) {
    let prec2 = this.dynamicPrecedences;
    return prec2 == null ? 0 : prec2[term] || 0;
  }
  parseDialect(dialect) {
    let values2 = Object.keys(this.dialects), flags = values2.map(() => false);
    if (dialect)
      for (let part of dialect.split(" ")) {
        let id2 = values2.indexOf(part);
        if (id2 >= 0)
          flags[id2] = true;
      }
    let disabled = null;
    for (let i2 = 0; i2 < values2.length; i2++)
      if (!flags[i2]) {
        for (let j2 = this.dialects[values2[i2]], id2; (id2 = this.data[j2++]) != 65535; )
          (disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id2] = 1;
      }
    return new Dialect(dialect, flags, disabled);
  }
  static deserialize(spec2) {
    return new LRParser(spec2);
  }
}
function pair(data, off2) {
  return data[off2] | data[off2 + 1] << 16;
}
function findFinished(stacks) {
  let best = null;
  for (let stack2 of stacks) {
    let stopped = stack2.p.stoppedAt;
    if ((stack2.pos == stack2.p.stream.end || stopped != null && stack2.pos > stopped) && stack2.p.parser.stateFlag(stack2.state, 2) && (!best || best.score < stack2.score))
      best = stack2;
  }
  return best;
}
function getSpecializer(spec2) {
  if (spec2.external) {
    let mask = spec2.extend ? 1 : 0;
    return (value2, stack2) => spec2.external(value2, stack2) << 1 | mask;
  }
  return spec2.get;
}
let nextTagID = 0;
class Tag {
  constructor(set2, base2, modified) {
    this.set = set2;
    this.base = base2;
    this.modified = modified;
    this.id = nextTagID++;
  }
  static define(parent) {
    if (parent === null || parent === void 0 ? void 0 : parent.base)
      throw new Error("Can not derive from a modified tag");
    let tag = new Tag([], null, []);
    tag.set.push(tag);
    if (parent)
      for (let t2 of parent.set)
        tag.set.push(t2);
    return tag;
  }
  static defineModifier() {
    let mod = new Modifier();
    return (tag) => {
      if (tag.modified.indexOf(mod) > -1)
        return tag;
      return Modifier.get(tag.base || tag, tag.modified.concat(mod).sort((a2, b2) => a2.id - b2.id));
    };
  }
}
let nextModifierID = 0;
class Modifier {
  constructor() {
    this.instances = [];
    this.id = nextModifierID++;
  }
  static get(base2, mods) {
    if (!mods.length)
      return base2;
    let exists2 = mods[0].instances.find((t2) => t2.base == base2 && sameArray$1(mods, t2.modified));
    if (exists2)
      return exists2;
    let set2 = [], tag = new Tag(set2, base2, mods);
    for (let m2 of mods)
      m2.instances.push(tag);
    let configs = powerSet(mods);
    for (let parent of base2.set)
      if (!parent.modified.length)
        for (let config2 of configs)
          set2.push(Modifier.get(parent, config2));
    return tag;
  }
}
function sameArray$1(a2, b2) {
  return a2.length == b2.length && a2.every((x2, i2) => x2 == b2[i2]);
}
function powerSet(array4) {
  let sets = [[]];
  for (let i2 = 0; i2 < array4.length; i2++) {
    for (let j2 = 0, e25 = sets.length; j2 < e25; j2++) {
      sets.push(sets[j2].concat(array4[i2]));
    }
  }
  return sets.sort((a2, b2) => b2.length - a2.length);
}
function styleTags(spec2) {
  let byName = Object.create(null);
  for (let prop in spec2) {
    let tags2 = spec2[prop];
    if (!Array.isArray(tags2))
      tags2 = [tags2];
    for (let part of prop.split(" "))
      if (part) {
        let pieces = [], mode = 2, rest = part;
        for (let pos = 0; ; ) {
          if (rest == "..." && pos > 0 && pos + 3 == part.length) {
            mode = 1;
            break;
          }
          let m2 = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest);
          if (!m2)
            throw new RangeError("Invalid path: " + part);
          pieces.push(m2[0] == "*" ? "" : m2[0][0] == '"' ? JSON.parse(m2[0]) : m2[0]);
          pos += m2[0].length;
          if (pos == part.length)
            break;
          let next = part[pos++];
          if (pos == part.length && next == "!") {
            mode = 0;
            break;
          }
          if (next != "/")
            throw new RangeError("Invalid path: " + part);
          rest = part.slice(pos);
        }
        let last = pieces.length - 1, inner = pieces[last];
        if (!inner)
          throw new RangeError("Invalid path: " + part);
        let rule = new Rule(tags2, mode, last > 0 ? pieces.slice(0, last) : null);
        byName[inner] = rule.sort(byName[inner]);
      }
  }
  return ruleNodeProp.add(byName);
}
const ruleNodeProp = new NodeProp();
class Rule {
  constructor(tags2, mode, context, next) {
    this.tags = tags2;
    this.mode = mode;
    this.context = context;
    this.next = next;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(other) {
    if (!other || other.depth < this.depth) {
      this.next = other;
      return this;
    }
    other.next = this.sort(other.next);
    return other;
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
Rule.empty = new Rule([], 2, null);
function tagHighlighter(tags2, options) {
  let map2 = Object.create(null);
  for (let style2 of tags2) {
    if (!Array.isArray(style2.tag))
      map2[style2.tag.id] = style2.class;
    else
      for (let tag of style2.tag)
        map2[tag.id] = style2.class;
  }
  let { scope: scope2, all = null } = options || {};
  return {
    style: (tags3) => {
      let cls = all;
      for (let tag of tags3) {
        for (let sub of tag.set) {
          let tagClass = map2[sub.id];
          if (tagClass) {
            cls = cls ? cls + " " + tagClass : tagClass;
            break;
          }
        }
      }
      return cls;
    },
    scope: scope2
  };
}
function highlightTags(highlighters, tags2) {
  let result2 = null;
  for (let highlighter of highlighters) {
    let value2 = highlighter.style(tags2);
    if (value2)
      result2 = result2 ? result2 + " " + value2 : value2;
  }
  return result2;
}
function highlightTree(tree, highlighter, putStyle, from = 0, to2 = tree.length) {
  let builder = new HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [highlighter], putStyle);
  builder.highlightRange(tree.cursor(), from, to2, "", builder.highlighters);
  builder.flush(to2);
}
class HighlightBuilder {
  constructor(at2, highlighters, span) {
    this.at = at2;
    this.highlighters = highlighters;
    this.span = span;
    this.class = "";
  }
  startSpan(at2, cls) {
    if (cls != this.class) {
      this.flush(at2);
      if (at2 > this.at)
        this.at = at2;
      this.class = cls;
    }
  }
  flush(to2) {
    if (to2 > this.at && this.class)
      this.span(this.at, to2, this.class);
  }
  highlightRange(cursor, from, to2, inheritedClass, highlighters) {
    let { type: type4, from: start, to: end } = cursor;
    if (start >= to2 || end <= from)
      return;
    if (type4.isTop)
      highlighters = this.highlighters.filter((h2) => !h2.scope || h2.scope(type4));
    let cls = inheritedClass;
    let rule = getStyleTags(cursor) || Rule.empty;
    let tagCls = highlightTags(highlighters, rule.tags);
    if (tagCls) {
      if (cls)
        cls += " ";
      cls += tagCls;
      if (rule.mode == 1)
        inheritedClass += (inheritedClass ? " " : "") + tagCls;
    }
    this.startSpan(Math.max(from, start), cls);
    if (rule.opaque)
      return;
    let mounted = cursor.tree && cursor.tree.prop(NodeProp.mounted);
    if (mounted && mounted.overlay) {
      let inner = cursor.node.enter(mounted.overlay[0].from + start, 1);
      let innerHighlighters = this.highlighters.filter((h2) => !h2.scope || h2.scope(mounted.tree.type));
      let hasChild2 = cursor.firstChild();
      for (let i2 = 0, pos = start; ; i2++) {
        let next = i2 < mounted.overlay.length ? mounted.overlay[i2] : null;
        let nextPos = next ? next.from + start : end;
        let rangeFrom = Math.max(from, pos), rangeTo = Math.min(to2, nextPos);
        if (rangeFrom < rangeTo && hasChild2) {
          while (cursor.from < rangeTo) {
            this.highlightRange(cursor, rangeFrom, rangeTo, inheritedClass, highlighters);
            this.startSpan(Math.min(rangeTo, cursor.to), cls);
            if (cursor.to >= nextPos || !cursor.nextSibling())
              break;
          }
        }
        if (!next || nextPos > to2)
          break;
        pos = next.to + start;
        if (pos > from) {
          this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to2, pos), "", innerHighlighters);
          this.startSpan(Math.min(to2, pos), cls);
        }
      }
      if (hasChild2)
        cursor.parent();
    } else if (cursor.firstChild()) {
      if (mounted)
        inheritedClass = "";
      do {
        if (cursor.to <= from)
          continue;
        if (cursor.from >= to2)
          break;
        this.highlightRange(cursor, from, to2, inheritedClass, highlighters);
        this.startSpan(Math.min(to2, cursor.to), cls);
      } while (cursor.nextSibling());
      cursor.parent();
    }
  }
}
function getStyleTags(node2) {
  let rule = node2.type.prop(ruleNodeProp);
  while (rule && rule.context && !node2.matchContext(rule.context))
    rule = rule.next;
  return rule || null;
}
const t$1 = Tag.define;
const comment = t$1(), name = t$1(), typeName = t$1(name), propertyName = t$1(name), literal = t$1(), string2 = t$1(literal), number3 = t$1(literal), content = t$1(), heading = t$1(content), keyword = t$1(), operator = t$1(), punctuation = t$1(), bracket = t$1(punctuation), meta = t$1();
const tags$1 = {
  comment,
  lineComment: t$1(comment),
  blockComment: t$1(comment),
  docComment: t$1(comment),
  name,
  variableName: t$1(name),
  typeName,
  tagName: t$1(typeName),
  propertyName,
  attributeName: t$1(propertyName),
  className: t$1(name),
  labelName: t$1(name),
  namespace: t$1(name),
  macroName: t$1(name),
  literal,
  string: string2,
  docString: t$1(string2),
  character: t$1(string2),
  attributeValue: t$1(string2),
  number: number3,
  integer: t$1(number3),
  float: t$1(number3),
  bool: t$1(literal),
  regexp: t$1(literal),
  escape: t$1(literal),
  color: t$1(literal),
  url: t$1(literal),
  keyword,
  self: t$1(keyword),
  null: t$1(keyword),
  atom: t$1(keyword),
  unit: t$1(keyword),
  modifier: t$1(keyword),
  operatorKeyword: t$1(keyword),
  controlKeyword: t$1(keyword),
  definitionKeyword: t$1(keyword),
  moduleKeyword: t$1(keyword),
  operator,
  derefOperator: t$1(operator),
  arithmeticOperator: t$1(operator),
  logicOperator: t$1(operator),
  bitwiseOperator: t$1(operator),
  compareOperator: t$1(operator),
  updateOperator: t$1(operator),
  definitionOperator: t$1(operator),
  typeOperator: t$1(operator),
  controlOperator: t$1(operator),
  punctuation,
  separator: t$1(punctuation),
  bracket,
  angleBracket: t$1(bracket),
  squareBracket: t$1(bracket),
  paren: t$1(bracket),
  brace: t$1(bracket),
  content,
  heading,
  heading1: t$1(heading),
  heading2: t$1(heading),
  heading3: t$1(heading),
  heading4: t$1(heading),
  heading5: t$1(heading),
  heading6: t$1(heading),
  contentSeparator: t$1(content),
  list: t$1(content),
  quote: t$1(content),
  emphasis: t$1(content),
  strong: t$1(content),
  link: t$1(content),
  monospace: t$1(content),
  strikethrough: t$1(content),
  inserted: t$1(),
  deleted: t$1(),
  changed: t$1(),
  invalid: t$1(),
  meta,
  documentMeta: t$1(meta),
  annotation: t$1(meta),
  processingInstruction: t$1(meta),
  definition: Tag.defineModifier(),
  constant: Tag.defineModifier(),
  function: Tag.defineModifier(),
  standard: Tag.defineModifier(),
  local: Tag.defineModifier(),
  special: Tag.defineModifier()
};
tagHighlighter([
  { tag: tags$1.link, class: "tok-link" },
  { tag: tags$1.heading, class: "tok-heading" },
  { tag: tags$1.emphasis, class: "tok-emphasis" },
  { tag: tags$1.strong, class: "tok-strong" },
  { tag: tags$1.keyword, class: "tok-keyword" },
  { tag: tags$1.atom, class: "tok-atom" },
  { tag: tags$1.bool, class: "tok-bool" },
  { tag: tags$1.url, class: "tok-url" },
  { tag: tags$1.labelName, class: "tok-labelName" },
  { tag: tags$1.inserted, class: "tok-inserted" },
  { tag: tags$1.deleted, class: "tok-deleted" },
  { tag: tags$1.literal, class: "tok-literal" },
  { tag: tags$1.string, class: "tok-string" },
  { tag: tags$1.number, class: "tok-number" },
  { tag: [tags$1.regexp, tags$1.escape, tags$1.special(tags$1.string)], class: "tok-string2" },
  { tag: tags$1.variableName, class: "tok-variableName" },
  { tag: tags$1.local(tags$1.variableName), class: "tok-variableName tok-local" },
  { tag: tags$1.definition(tags$1.variableName), class: "tok-variableName tok-definition" },
  { tag: tags$1.special(tags$1.variableName), class: "tok-variableName2" },
  { tag: tags$1.definition(tags$1.propertyName), class: "tok-propertyName tok-definition" },
  { tag: tags$1.typeName, class: "tok-typeName" },
  { tag: tags$1.namespace, class: "tok-namespace" },
  { tag: tags$1.className, class: "tok-className" },
  { tag: tags$1.macroName, class: "tok-macroName" },
  { tag: tags$1.propertyName, class: "tok-propertyName" },
  { tag: tags$1.operator, class: "tok-operator" },
  { tag: tags$1.comment, class: "tok-comment" },
  { tag: tags$1.meta, class: "tok-meta" },
  { tag: tags$1.invalid, class: "tok-invalid" },
  { tag: tags$1.punctuation, class: "tok-punctuation" }
]);
const scriptText = 54, StartCloseScriptTag = 1, styleText = 55, StartCloseStyleTag = 2, textareaText = 56, StartCloseTextareaTag = 3, EndTag = 4, SelfClosingEndTag = 5, StartTag = 6, StartScriptTag = 7, StartStyleTag = 8, StartTextareaTag = 9, StartSelfClosingTag = 10, StartCloseTag = 11, NoMatchStartCloseTag = 12, MismatchedStartCloseTag = 13, missingCloseTag = 57, IncompleteCloseTag = 14, commentContent$1 = 58, Element$1 = 20, TagName = 22, Attribute = 23, AttributeName = 24, AttributeValue = 26, UnquotedAttributeValue = 27, ScriptText = 28, StyleText = 31, TextareaText = 34, OpenTag = 36, CloseTag = 37, Dialect_noMatch = 0, Dialect_selfClosing = 1;
const selfClosers$1 = {
  area: true,
  base: true,
  br: true,
  col: true,
  command: true,
  embed: true,
  frame: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
  menuitem: true
};
const implicitlyClosed = {
  dd: true,
  li: true,
  optgroup: true,
  option: true,
  p: true,
  rp: true,
  rt: true,
  tbody: true,
  td: true,
  tfoot: true,
  th: true,
  tr: true
};
const closeOnOpen = {
  dd: { dd: true, dt: true },
  dt: { dd: true, dt: true },
  li: { li: true },
  option: { option: true, optgroup: true },
  optgroup: { optgroup: true },
  p: {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    dir: true,
    div: true,
    dl: true,
    fieldset: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    menu: true,
    nav: true,
    ol: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    ul: true
  },
  rp: { rp: true, rt: true },
  rt: { rp: true, rt: true },
  tbody: { tbody: true, tfoot: true },
  td: { td: true, th: true },
  tfoot: { tbody: true },
  th: { td: true, th: true },
  thead: { tbody: true, tfoot: true },
  tr: { tr: true }
};
function nameChar(ch2) {
  return ch2 == 45 || ch2 == 46 || ch2 == 58 || ch2 >= 65 && ch2 <= 90 || ch2 == 95 || ch2 >= 97 && ch2 <= 122 || ch2 >= 161;
}
function isSpace(ch2) {
  return ch2 == 9 || ch2 == 10 || ch2 == 13 || ch2 == 32;
}
let cachedName = null, cachedInput = null, cachedPos = 0;
function tagNameAfter(input, offset) {
  let pos = input.pos + offset;
  if (cachedPos == pos && cachedInput == input)
    return cachedName;
  let next = input.peek(offset);
  while (isSpace(next))
    next = input.peek(++offset);
  let name2 = "";
  for (; ; ) {
    if (!nameChar(next))
      break;
    name2 += String.fromCharCode(next);
    next = input.peek(++offset);
  }
  cachedInput = input;
  cachedPos = pos;
  return cachedName = name2 ? name2.toLowerCase() : next == question || next == bang ? void 0 : null;
}
const lessThan = 60, greaterThan = 62, slash$1 = 47, question = 63, bang = 33, dash$1 = 45;
function ElementContext(name2, parent) {
  this.name = name2;
  this.parent = parent;
  this.hash = parent ? parent.hash : 0;
  for (let i2 = 0; i2 < name2.length; i2++)
    this.hash += (this.hash << 4) + name2.charCodeAt(i2) + (name2.charCodeAt(i2) << 8);
}
const startTagTerms = [StartTag, StartSelfClosingTag, StartScriptTag, StartStyleTag, StartTextareaTag];
const elementContext = new ContextTracker({
  start: null,
  shift(context, term, stack2, input) {
    return startTagTerms.indexOf(term) > -1 ? new ElementContext(tagNameAfter(input, 1) || "", context) : context;
  },
  reduce(context, term) {
    return term == Element$1 && context ? context.parent : context;
  },
  reuse(context, node2, stack2, input) {
    let type4 = node2.type.id;
    return type4 == StartTag || type4 == OpenTag ? new ElementContext(tagNameAfter(input, 1) || "", context) : context;
  },
  hash(context) {
    return context ? context.hash : 0;
  },
  strict: false
});
const tagStart = new ExternalTokenizer((input, stack2) => {
  if (input.next != lessThan) {
    if (input.next < 0 && stack2.context)
      input.acceptToken(missingCloseTag);
    return;
  }
  input.advance();
  let close = input.next == slash$1;
  if (close)
    input.advance();
  let name2 = tagNameAfter(input, 0);
  if (name2 === void 0)
    return;
  if (!name2)
    return input.acceptToken(close ? IncompleteCloseTag : StartTag);
  let parent = stack2.context ? stack2.context.name : null;
  if (close) {
    if (name2 == parent)
      return input.acceptToken(StartCloseTag);
    if (parent && implicitlyClosed[parent])
      return input.acceptToken(missingCloseTag, -2);
    if (stack2.dialectEnabled(Dialect_noMatch))
      return input.acceptToken(NoMatchStartCloseTag);
    for (let cx2 = stack2.context; cx2; cx2 = cx2.parent)
      if (cx2.name == name2)
        return;
    input.acceptToken(MismatchedStartCloseTag);
  } else {
    if (name2 == "script")
      return input.acceptToken(StartScriptTag);
    if (name2 == "style")
      return input.acceptToken(StartStyleTag);
    if (name2 == "textarea")
      return input.acceptToken(StartTextareaTag);
    if (selfClosers$1.hasOwnProperty(name2))
      return input.acceptToken(StartSelfClosingTag);
    if (parent && closeOnOpen[parent] && closeOnOpen[parent][name2])
      input.acceptToken(missingCloseTag, -1);
    else
      input.acceptToken(StartTag);
  }
}, { contextual: true });
const commentContent = new ExternalTokenizer((input) => {
  for (let dashes = 0, i2 = 0; ; i2++) {
    if (input.next < 0) {
      if (i2)
        input.acceptToken(commentContent$1);
      break;
    }
    if (input.next == dash$1) {
      dashes++;
    } else if (input.next == greaterThan && dashes >= 2) {
      if (i2 > 3)
        input.acceptToken(commentContent$1, -2);
      break;
    } else {
      dashes = 0;
    }
    input.advance();
  }
});
function inForeignElement(context) {
  for (; context; context = context.parent)
    if (context.name == "svg" || context.name == "math")
      return true;
  return false;
}
const endTag = new ExternalTokenizer((input, stack2) => {
  if (input.next == slash$1 && input.peek(1) == greaterThan) {
    let selfClosing = stack2.dialectEnabled(Dialect_selfClosing) || inForeignElement(stack2.context);
    input.acceptToken(selfClosing ? SelfClosingEndTag : EndTag, 2);
  } else if (input.next == greaterThan) {
    input.acceptToken(EndTag, 1);
  }
});
function contentTokenizer(tag, textToken, endToken) {
  let lastState = 2 + tag.length;
  return new ExternalTokenizer((input) => {
    for (let state = 0, matchedLen = 0, i2 = 0; ; i2++) {
      if (input.next < 0) {
        if (i2)
          input.acceptToken(textToken);
        break;
      }
      if (state == 0 && input.next == lessThan || state == 1 && input.next == slash$1 || state >= 2 && state < lastState && input.next == tag.charCodeAt(state - 2)) {
        state++;
        matchedLen++;
      } else if ((state == 2 || state == lastState) && isSpace(input.next)) {
        matchedLen++;
      } else if (state == lastState && input.next == greaterThan) {
        if (i2 > matchedLen)
          input.acceptToken(textToken, -matchedLen);
        else
          input.acceptToken(endToken, -(matchedLen - 2));
        break;
      } else if ((input.next == 10 || input.next == 13) && i2) {
        input.acceptToken(textToken, 1);
        break;
      } else {
        state = matchedLen = 0;
      }
      input.advance();
    }
  });
}
const scriptTokens = contentTokenizer("script", scriptText, StartCloseScriptTag);
const styleTokens = contentTokenizer("style", styleText, StartCloseStyleTag);
const textareaTokens = contentTokenizer("textarea", textareaText, StartCloseTextareaTag);
const htmlHighlighting = styleTags({
  "Text RawText": tags$1.content,
  "StartTag StartCloseTag SelfClosingEndTag EndTag": tags$1.angleBracket,
  TagName: tags$1.tagName,
  "MismatchedCloseTag/TagName": [tags$1.tagName, tags$1.invalid],
  AttributeName: tags$1.attributeName,
  "AttributeValue UnquotedAttributeValue": tags$1.attributeValue,
  Is: tags$1.definitionOperator,
  "EntityReference CharacterReference": tags$1.character,
  Comment: tags$1.blockComment,
  ProcessingInst: tags$1.processingInstruction,
  DoctypeDecl: tags$1.documentMeta
});
const parser$3 = LRParser.deserialize({
  version: 14,
  states: ",xOVO!rOOO!WQ#tO'#CqO!]Q#tO'#CzO!bQ#tO'#C}O!gQ#tO'#DQO!lQ#tO'#DSO!qOaO'#CpO!|ObO'#CpO#XOdO'#CpO$eO!rO'#CpOOO`'#Cp'#CpO$lO$fO'#DTO$tQ#tO'#DVO$yQ#tO'#DWOOO`'#Dk'#DkOOO`'#DY'#DYQVO!rOOO%OQ&rO,59]O%WQ&rO,59fO%`Q&rO,59iO%hQ&rO,59lO%sQ&rO,59nOOOa'#D^'#D^O%{OaO'#CxO&WOaO,59[OOOb'#D_'#D_O&`ObO'#C{O&kObO,59[OOOd'#D`'#D`O&sOdO'#DOO'OOdO,59[OOO`'#Da'#DaO'WO!rO,59[O'_Q#tO'#DROOO`,59[,59[OOOp'#Db'#DbO'dO$fO,59oOOO`,59o,59oO'lQ#|O,59qO'qQ#|O,59rOOO`-E7W-E7WO'vQ&rO'#CsOOQW'#DZ'#DZO(UQ&rO1G.wOOOa1G.w1G.wO(^Q&rO1G/QOOOb1G/Q1G/QO(fQ&rO1G/TOOOd1G/T1G/TO(nQ&rO1G/WOOO`1G/W1G/WOOO`1G/Y1G/YO(yQ&rO1G/YOOOa-E7[-E7[O)RQ#tO'#CyOOO`1G.v1G.vOOOb-E7]-E7]O)WQ#tO'#C|OOOd-E7^-E7^O)]Q#tO'#DPOOO`-E7_-E7_O)bQ#|O,59mOOOp-E7`-E7`OOO`1G/Z1G/ZOOO`1G/]1G/]OOO`1G/^1G/^O)gQ,UO,59_OOQW-E7X-E7XOOOa7+$c7+$cOOOb7+$l7+$lOOOd7+$o7+$oOOO`7+$r7+$rOOO`7+$t7+$tO)rQ#|O,59eO)wQ#|O,59hO)|Q#|O,59kOOO`1G/X1G/XO*RO7[O'#CvO*dOMhO'#CvOOQW1G.y1G.yOOO`1G/P1G/POOO`1G/S1G/SOOO`1G/V1G/VOOOO'#D['#D[O*uO7[O,59bOOQW,59b,59bOOOO'#D]'#D]O+WOMhO,59bOOOO-E7Y-E7YOOQW1G.|1G.|OOOO-E7Z-E7Z",
  stateData: "+s~O!^OS~OUSOVPOWQOXROYTO[]O][O^^O`^Oa^Ob^Oc^Ox^O{_O!dZO~OfaO~OfbO~OfcO~OfdO~OfeO~O!WfOPlP!ZlP~O!XiOQoP!ZoP~O!YlORrP!ZrP~OUSOVPOWQOXROYTOZqO[]O][O^^O`^Oa^Ob^Oc^Ox^O!dZO~O!ZrO~P#dO![sO!euO~OfvO~OfwO~OS|OhyO~OS!OOhyO~OS!QOhyO~OS!SOT!TOhyO~OS!TOhyO~O!WfOPlX!ZlX~OP!WO!Z!XO~O!XiOQoX!ZoX~OQ!ZO!Z!XO~O!YlORrX!ZrX~OR!]O!Z!XO~O!Z!XO~P#dOf!_O~O![sO!e!aO~OS!bO~OS!cO~Oi!dOSgXhgXTgX~OS!fOhyO~OS!gOhyO~OS!hOhyO~OS!iOT!jOhyO~OS!jOhyO~Of!kO~Of!lO~Of!mO~OS!nO~Ok!qO!`!oO!b!pO~OS!rO~OS!sO~OS!tO~Oa!uOb!uOc!uO!`!wO!a!uO~Oa!xOb!xOc!xO!b!wO!c!xO~Oa!uOb!uOc!uO!`!{O!a!uO~Oa!xOb!xOc!xO!b!{O!c!xO~OT~bac!dx{!d~",
  goto: "%p!`PPPPPPPPPPPPPPPPPPPP!a!gP!mPP!yP!|#P#S#Y#]#`#f#i#l#r#x!aP!a!aP$O$U$l$r$x%O%U%[%bPPPPPPPP%hX^OX`pXUOX`pezabcde{}!P!R!UR!q!dRhUR!XhXVOX`pRkVR!XkXWOX`pRnWR!XnXXOX`pQrXR!XpXYOX`pQ`ORx`Q{aQ}bQ!PcQ!RdQ!UeZ!e{}!P!R!UQ!v!oR!z!vQ!y!pR!|!yQgUR!VgQjVR!YjQmWR![mQpXR!^pQtZR!`tS_O`ToXp",
  nodeNames: "\u26A0 StartCloseTag StartCloseTag StartCloseTag EndTag SelfClosingEndTag StartTag StartTag StartTag StartTag StartTag StartCloseTag StartCloseTag StartCloseTag IncompleteCloseTag Document Text EntityReference CharacterReference InvalidEntity Element OpenTag TagName Attribute AttributeName Is AttributeValue UnquotedAttributeValue ScriptText CloseTag OpenTag StyleText CloseTag OpenTag TextareaText CloseTag OpenTag CloseTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag CloseTag DoctypeDecl",
  maxTerm: 67,
  context: elementContext,
  nodeProps: [
    ["closedBy", -10, 1, 2, 3, 7, 8, 9, 10, 11, 12, 13, "EndTag", 6, "EndTag SelfClosingEndTag", -4, 21, 30, 33, 36, "CloseTag"],
    ["openedBy", 4, "StartTag StartCloseTag", 5, "StartTag", -4, 29, 32, 35, 37, "OpenTag"],
    ["group", -9, 14, 17, 18, 19, 20, 39, 40, 41, 42, "Entity", 16, "Entity TextContent", -3, 28, 31, 34, "TextContent Entity"]
  ],
  propSources: [htmlHighlighting],
  skippedNodes: [0],
  repeatNodeCount: 9,
  tokenData: "!<p!aR!YOX$qXY,QYZ,QZ[$q[]&X]^,Q^p$qpq,Qqr-_rs3_sv-_vw3}wxHYx}-_}!OH{!O!P-_!P!Q$q!Q![-_![!]Mz!]!^-_!^!_!$S!_!`!;x!`!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4U-_4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!Z$|c`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr$qrs&}sv$qvw+Pwx(tx!^$q!^!_*V!_!a&X!a#S$q#S#T&X#T;'S$q;'S;=`+z<%lO$q!R&bX`P!a`!cpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&Xq'UV`P!cpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}P'pT`POv'kw!^'k!_;'S'k;'S;=`(P<%lO'kP(SP;=`<%l'kp([S!cpOv(Vx;'S(V;'S;=`(h<%lO(Vp(kP;=`<%l(Vq(qP;=`<%l&}a({W`P!a`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t`)jT!a`Or)esv)ew;'S)e;'S;=`)y<%lO)e`)|P;=`<%l)ea*SP;=`<%l(t!Q*^V!a`!cpOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!Q*vP;=`<%l*V!R*|P;=`<%l&XW+UYkWOX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+PW+wP;=`<%l+P!Z+}P;=`<%l$q!a,]``P!a`!cp!^^OX&XXY,QYZ,QZ]&X]^,Q^p&Xpq,Qqr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!_-ljhS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q[/ebhSkWOX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+PS0rXhSqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0mS1bP;=`<%l0m[1hP;=`<%l/^!V1vchS`P!a`!cpOq&Xqr1krs&}sv1kvw0mwx(tx!P1k!P!Q&X!Q!^1k!^!_*V!_!a&X!a#s1k#s$f&X$f;'S1k;'S;=`3R<%l?Ah1k?Ah?BY&X?BY?Mn1k?MnO&X!V3UP;=`<%l1k!_3[P;=`<%l-_!Z3hV!`h`P!cpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}!_4WihSkWc!ROX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst>]tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^/^!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!Z5zbkWOX5uXZ7SZ[5u[^7S^p5uqr5urs7Sst+Ptw5uwx7Sx!]5u!]!^7w!^!a7S!a#S5u#S#T7S#T;'S5u;'S;=`8n<%lO5u!R7VVOp7Sqs7St!]7S!]!^7l!^;'S7S;'S;=`7q<%lO7S!R7qOa!R!R7tP;=`<%l7S!Z8OYkWa!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!Z8qP;=`<%l5u!_8{ihSkWOX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst/^tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^:j!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!_:sbhSkWa!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!V<QchSOp7Sqr;{rs7Sst0mtw;{wx7Sx!P;{!P!Q7S!Q!];{!]!^=]!^!a7S!a#s;{#s$f7S$f;'S;{;'S;=`>P<%l?Ah;{?Ah?BY7S?BY?Mn;{?MnO7S!V=dXhSa!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!V>SP;=`<%l;{!_>YP;=`<%l8t!_>dhhSkWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^/^!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!Z@TakWOX@OXZAYZ[@O[^AY^p@Oqr@OrsAYsw@OwxAYx!]@O!]!^Az!^!aAY!a#S@O#S#TAY#T;'S@O;'S;=`Bq<%lO@O!RA]UOpAYq!]AY!]!^Ao!^;'SAY;'S;=`At<%lOAY!RAtOb!R!RAwP;=`<%lAY!ZBRYkWb!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!ZBtP;=`<%l@O!_COhhSkWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^Dj!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!_DsbhSkWb!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!VFQbhSOpAYqrE{rsAYswE{wxAYx!PE{!P!QAY!Q!]E{!]!^GY!^!aAY!a#sE{#s$fAY$f;'SE{;'S;=`G|<%l?AhE{?Ah?BYAY?BY?MnE{?MnOAY!VGaXhSb!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!VHPP;=`<%lE{!_HVP;=`<%lBw!ZHcW!bx`P!a`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t!aIYlhS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OKQ!O!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!aK_khS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!`&X!`!aMS!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!TM_X`P!a`!cp!eQOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!aNZ!ZhSfQ`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OMz!O!PMz!P!Q$q!Q![Mz![!]Mz!]!^-_!^!_*V!_!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f$}-_$}%OMz%O%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4UMz4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Je-_$Je$JgMz$Jg$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!a!$PP;=`<%lMz!R!$ZY!a`!cpOq*Vqr!$yrs(Vsv*Vwx)ex!a*V!a!b!4t!b;'S*V;'S;=`*s<%lO*V!R!%Q]!a`!cpOr*Vrs(Vsv*Vwx)ex}*V}!O!%y!O!f*V!f!g!']!g#W*V#W#X!0`#X;'S*V;'S;=`*s<%lO*V!R!&QX!a`!cpOr*Vrs(Vsv*Vwx)ex}*V}!O!&m!O;'S*V;'S;=`*s<%lO*V!R!&vV!a`!cp!dPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!'dX!a`!cpOr*Vrs(Vsv*Vwx)ex!q*V!q!r!(P!r;'S*V;'S;=`*s<%lO*V!R!(WX!a`!cpOr*Vrs(Vsv*Vwx)ex!e*V!e!f!(s!f;'S*V;'S;=`*s<%lO*V!R!(zX!a`!cpOr*Vrs(Vsv*Vwx)ex!v*V!v!w!)g!w;'S*V;'S;=`*s<%lO*V!R!)nX!a`!cpOr*Vrs(Vsv*Vwx)ex!{*V!{!|!*Z!|;'S*V;'S;=`*s<%lO*V!R!*bX!a`!cpOr*Vrs(Vsv*Vwx)ex!r*V!r!s!*}!s;'S*V;'S;=`*s<%lO*V!R!+UX!a`!cpOr*Vrs(Vsv*Vwx)ex!g*V!g!h!+q!h;'S*V;'S;=`*s<%lO*V!R!+xY!a`!cpOr!+qrs!,hsv!+qvw!-Swx!.[x!`!+q!`!a!/j!a;'S!+q;'S;=`!0Y<%lO!+qq!,mV!cpOv!,hvx!-Sx!`!,h!`!a!-q!a;'S!,h;'S;=`!.U<%lO!,hP!-VTO!`!-S!`!a!-f!a;'S!-S;'S;=`!-k<%lO!-SP!-kO{PP!-nP;=`<%l!-Sq!-xS!cp{POv(Vx;'S(V;'S;=`(h<%lO(Vq!.XP;=`<%l!,ha!.aX!a`Or!.[rs!-Ssv!.[vw!-Sw!`!.[!`!a!.|!a;'S!.[;'S;=`!/d<%lO!.[a!/TT!a`{POr)esv)ew;'S)e;'S;=`)y<%lO)ea!/gP;=`<%l!.[!R!/sV!a`!cp{POr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!0]P;=`<%l!+q!R!0gX!a`!cpOr*Vrs(Vsv*Vwx)ex#c*V#c#d!1S#d;'S*V;'S;=`*s<%lO*V!R!1ZX!a`!cpOr*Vrs(Vsv*Vwx)ex#V*V#V#W!1v#W;'S*V;'S;=`*s<%lO*V!R!1}X!a`!cpOr*Vrs(Vsv*Vwx)ex#h*V#h#i!2j#i;'S*V;'S;=`*s<%lO*V!R!2qX!a`!cpOr*Vrs(Vsv*Vwx)ex#m*V#m#n!3^#n;'S*V;'S;=`*s<%lO*V!R!3eX!a`!cpOr*Vrs(Vsv*Vwx)ex#d*V#d#e!4Q#e;'S*V;'S;=`*s<%lO*V!R!4XX!a`!cpOr*Vrs(Vsv*Vwx)ex#X*V#X#Y!+q#Y;'S*V;'S;=`*s<%lO*V!R!4{Y!a`!cpOr!4trs!5ksv!4tvw!6Vwx!8]x!a!4t!a!b!:]!b;'S!4t;'S;=`!;r<%lO!4tq!5pV!cpOv!5kvx!6Vx!a!5k!a!b!7W!b;'S!5k;'S;=`!8V<%lO!5kP!6YTO!a!6V!a!b!6i!b;'S!6V;'S;=`!7Q<%lO!6VP!6lTO!`!6V!`!a!6{!a;'S!6V;'S;=`!7Q<%lO!6VP!7QOxPP!7TP;=`<%l!6Vq!7]V!cpOv!5kvx!6Vx!`!5k!`!a!7r!a;'S!5k;'S;=`!8V<%lO!5kq!7yS!cpxPOv(Vx;'S(V;'S;=`(h<%lO(Vq!8YP;=`<%l!5ka!8bX!a`Or!8]rs!6Vsv!8]vw!6Vw!a!8]!a!b!8}!b;'S!8];'S;=`!:V<%lO!8]a!9SX!a`Or!8]rs!6Vsv!8]vw!6Vw!`!8]!`!a!9o!a;'S!8];'S;=`!:V<%lO!8]a!9vT!a`xPOr)esv)ew;'S)e;'S;=`)y<%lO)ea!:YP;=`<%l!8]!R!:dY!a`!cpOr!4trs!5ksv!4tvw!6Vwx!8]x!`!4t!`!a!;S!a;'S!4t;'S;=`!;r<%lO!4t!R!;]V!a`!cpxPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!;uP;=`<%l!4t!V!<TXiS`P!a`!cpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X",
  tokenizers: [scriptTokens, styleTokens, textareaTokens, endTag, tagStart, commentContent, 0, 1, 2, 3, 4, 5],
  topRules: { "Document": [0, 15] },
  dialects: { noMatch: 0, selfClosing: 485 },
  tokenPrec: 487
});
function getAttrs$1(openTag, input) {
  let attrs = Object.create(null);
  for (let att of openTag.getChildren(Attribute)) {
    let name2 = att.getChild(AttributeName), value2 = att.getChild(AttributeValue) || att.getChild(UnquotedAttributeValue);
    if (name2)
      attrs[input.read(name2.from, name2.to)] = !value2 ? "" : value2.type.id == AttributeValue ? input.read(value2.from + 1, value2.to - 1) : input.read(value2.from, value2.to);
  }
  return attrs;
}
function findTagName(openTag, input) {
  let tagNameNode = openTag.getChild(TagName);
  return tagNameNode ? input.read(tagNameNode.from, tagNameNode.to) : " ";
}
function maybeNest(node2, input, tags2) {
  let attrs;
  for (let tag of tags2) {
    if (!tag.attrs || tag.attrs(attrs || (attrs = getAttrs$1(node2.node.parent.firstChild, input))))
      return { parser: tag.parser };
  }
  return null;
}
function configureNesting(tags2 = [], attributes = []) {
  let script = [], style2 = [], textarea = [], other = [];
  for (let tag of tags2) {
    let array4 = tag.tag == "script" ? script : tag.tag == "style" ? style2 : tag.tag == "textarea" ? textarea : other;
    array4.push(tag);
  }
  let attrs = attributes.length ? Object.create(null) : null;
  for (let attr of attributes)
    (attrs[attr.name] || (attrs[attr.name] = [])).push(attr);
  return parseMixed((node2, input) => {
    let id2 = node2.type.id;
    if (id2 == ScriptText)
      return maybeNest(node2, input, script);
    if (id2 == StyleText)
      return maybeNest(node2, input, style2);
    if (id2 == TextareaText)
      return maybeNest(node2, input, textarea);
    if (id2 == Element$1 && other.length) {
      let n2 = node2.node, open = n2.firstChild, tagName = open && findTagName(open, input), attrs2;
      if (tagName)
        for (let tag of other) {
          if (tag.tag == tagName && (!tag.attrs || tag.attrs(attrs2 || (attrs2 = getAttrs$1(n2, input))))) {
            let close = n2.lastChild;
            return { parser: tag.parser, overlay: [{ from: open.to, to: close.type.id == CloseTag ? close.from : n2.to }] };
          }
        }
    }
    if (attrs && id2 == Attribute) {
      let n2 = node2.node, nameNode;
      if (nameNode = n2.firstChild) {
        let matches = attrs[input.read(nameNode.from, nameNode.to)];
        if (matches)
          for (let attr of matches) {
            if (attr.tagName && attr.tagName != findTagName(n2.parent, input))
              continue;
            let value2 = n2.lastChild;
            if (value2.type.id == AttributeValue) {
              let from = value2.from + 1;
              let last = value2.lastChild, to2 = value2.to - (last && last.isError ? 0 : 1);
              if (to2 > from)
                return { parser: attr.parser, overlay: [{ from, to: to2 }] };
            } else if (value2.type.id == UnquotedAttributeValue) {
              return { parser: attr.parser, overlay: [{ from: value2.from, to: value2.to }] };
            }
          }
      }
    }
    return null;
  });
}
const descendantOp = 96, Unit = 1, callee = 97, identifier$2 = 98, VariableName = 2;
const space$1 = [
  9,
  10,
  11,
  12,
  13,
  32,
  133,
  160,
  5760,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8232,
  8233,
  8239,
  8287,
  12288
];
const colon = 58, parenL = 40, underscore = 95, bracketL = 91, dash = 45, period = 46, hash = 35, percent = 37;
function isAlpha(ch2) {
  return ch2 >= 65 && ch2 <= 90 || ch2 >= 97 && ch2 <= 122 || ch2 >= 161;
}
function isDigit(ch2) {
  return ch2 >= 48 && ch2 <= 57;
}
const identifiers = new ExternalTokenizer((input, stack2) => {
  for (let inside2 = false, dashes = 0, i2 = 0; ; i2++) {
    let { next } = input;
    if (isAlpha(next) || next == dash || next == underscore || inside2 && isDigit(next)) {
      if (!inside2 && (next != dash || i2 > 0))
        inside2 = true;
      if (dashes === i2 && next == dash)
        dashes++;
      input.advance();
    } else {
      if (inside2)
        input.acceptToken(next == parenL ? callee : dashes == 2 && stack2.canShift(VariableName) ? VariableName : identifier$2);
      break;
    }
  }
});
const descendant = new ExternalTokenizer((input) => {
  if (space$1.includes(input.peek(-1))) {
    let { next } = input;
    if (isAlpha(next) || next == underscore || next == hash || next == period || next == bracketL || next == colon || next == dash)
      input.acceptToken(descendantOp);
  }
});
const unitToken = new ExternalTokenizer((input) => {
  if (!space$1.includes(input.peek(-1))) {
    let { next } = input;
    if (next == percent) {
      input.advance();
      input.acceptToken(Unit);
    }
    if (isAlpha(next)) {
      do {
        input.advance();
      } while (isAlpha(input.next));
      input.acceptToken(Unit);
    }
  }
});
const cssHighlighting = styleTags({
  "AtKeyword import charset namespace keyframes media supports": tags$1.definitionKeyword,
  "from to selector": tags$1.keyword,
  NamespaceName: tags$1.namespace,
  KeyframeName: tags$1.labelName,
  KeyframeRangeName: tags$1.operatorKeyword,
  TagName: tags$1.tagName,
  ClassName: tags$1.className,
  PseudoClassName: tags$1.constant(tags$1.className),
  IdName: tags$1.labelName,
  "FeatureName PropertyName": tags$1.propertyName,
  AttributeName: tags$1.attributeName,
  NumberLiteral: tags$1.number,
  KeywordQuery: tags$1.keyword,
  UnaryQueryOp: tags$1.operatorKeyword,
  "CallTag ValueName": tags$1.atom,
  VariableName: tags$1.variableName,
  Callee: tags$1.operatorKeyword,
  Unit: tags$1.unit,
  "UniversalSelector NestingSelector": tags$1.definitionOperator,
  MatchOp: tags$1.compareOperator,
  "ChildOp SiblingOp, LogicOp": tags$1.logicOperator,
  BinOp: tags$1.arithmeticOperator,
  Important: tags$1.modifier,
  Comment: tags$1.blockComment,
  ColorLiteral: tags$1.color,
  "ParenthesizedContent StringLiteral": tags$1.string,
  ":": tags$1.punctuation,
  "PseudoOp #": tags$1.derefOperator,
  "; ,": tags$1.separator,
  "( )": tags$1.paren,
  "[ ]": tags$1.squareBracket,
  "{ }": tags$1.brace
});
const spec_callee = { __proto__: null, lang: 32, "nth-child": 32, "nth-last-child": 32, "nth-of-type": 32, "nth-last-of-type": 32, dir: 32, "host-context": 32, url: 60, "url-prefix": 60, domain: 60, regexp: 60, selector: 134 };
const spec_AtKeyword = { __proto__: null, "@import": 114, "@media": 138, "@charset": 142, "@namespace": 146, "@keyframes": 152, "@supports": 164 };
const spec_identifier$1 = { __proto__: null, not: 128, only: 128 };
const parser$2 = LRParser.deserialize({
  version: 14,
  states: "9bQYQ[OOO#_Q[OOP#fOWOOOOQP'#Cd'#CdOOQP'#Cc'#CcO#kQ[O'#CfO$_QXO'#CaO$fQ[O'#ChO$qQ[O'#DPO$vQ[O'#DTOOQP'#Ej'#EjO${QdO'#DeO%gQ[O'#DrO${QdO'#DtO%xQ[O'#DvO&TQ[O'#DyO&]Q[O'#EPO&kQ[O'#EROOQS'#Ei'#EiOOQS'#EU'#EUQYQ[OOO&rQXO'#CdO'gQWO'#DaO'lQWO'#EpO'wQ[O'#EpQOQWOOP(RO#tO'#C_POOO)C@X)C@XOOQP'#Cg'#CgOOQP,59Q,59QO#kQ[O,59QO(^Q[O'#EXO(xQWO,58{O)QQ[O,59SO$qQ[O,59kO$vQ[O,59oO(^Q[O,59sO(^Q[O,59uO(^Q[O,59vO)]Q[O'#D`OOQS,58{,58{OOQP'#Ck'#CkOOQO'#C}'#C}OOQP,59S,59SO)dQWO,59SO)iQWO,59SOOQP'#DR'#DROOQP,59k,59kOOQO'#DV'#DVO)nQ`O,59oOOQS'#Cp'#CpO${QdO'#CqO)vQvO'#CsO+TQtO,5:POOQO'#Cx'#CxO)iQWO'#CwO+iQWO'#CyOOQS'#Em'#EmOOQO'#Dh'#DhO+nQ[O'#DoO+|QWO'#EqO&]Q[O'#DmO,[QWO'#DpOOQO'#Er'#ErO({QWO,5:^O,aQpO,5:`OOQS'#Dx'#DxO,iQWO,5:bO,nQ[O,5:bOOQO'#D{'#D{O,vQWO,5:eO,{QWO,5:kO-TQWO,5:mOOQS-E8S-E8SO${QdO,59{O-]Q[O'#EZO-jQWO,5;[O-jQWO,5;[POOO'#ET'#ETP-uO#tO,58yPOOO,58y,58yOOQP1G.l1G.lO.lQXO,5:sOOQO-E8V-E8VOOQS1G.g1G.gOOQP1G.n1G.nO)dQWO1G.nO)iQWO1G.nOOQP1G/V1G/VO.yQ`O1G/ZO/dQXO1G/_O/zQXO1G/aO0bQXO1G/bO0xQWO,59zO0}Q[O'#DOO1UQdO'#CoOOQP1G/Z1G/ZO${QdO1G/ZO1]QpO,59]OOQS,59_,59_O${QdO,59aO1eQWO1G/kOOQS,59c,59cO1jQ!bO,59eO1rQWO'#DhO1}QWO,5:TO2SQWO,5:ZO&]Q[O,5:VO&]Q[O'#E[O2[QWO,5;]O2gQWO,5:XO(^Q[O,5:[OOQS1G/x1G/xOOQS1G/z1G/zOOQS1G/|1G/|O2xQWO1G/|O2}QdO'#D|OOQS1G0P1G0POOQS1G0V1G0VOOQS1G0X1G0XO3YQtO1G/gOOQO,5:u,5:uO3pQ[O,5:uOOQO-E8X-E8XO3}QWO1G0vPOOO-E8R-E8RPOOO1G.e1G.eOOQP7+$Y7+$YOOQP7+$u7+$uO${QdO7+$uOOQS1G/f1G/fO4YQXO'#EoO4aQWO,59jO4fQtO'#EVO5ZQdO'#ElO5eQWO,59ZO5jQpO7+$uOOQS1G.w1G.wOOQS1G.{1G.{OOQS7+%V7+%VO5rQWO1G/PO${QdO1G/oOOQO1G/u1G/uOOQO1G/q1G/qO5wQWO,5:vOOQO-E8Y-E8YO6VQXO1G/vOOQS7+%h7+%hO6^QYO'#CsOOQO'#EO'#EOO6iQ`O'#D}OOQO'#D}'#D}O6tQWO'#E]O6|QdO,5:hOOQS,5:h,5:hO7XQtO'#EYO${QdO'#EYO8VQdO7+%ROOQO7+%R7+%ROOQO1G0a1G0aO8jQpO<<HaO8rQWO,5;ZOOQP1G/U1G/UOOQS-E8T-E8TO${QdO'#EWO8zQWO,5;WOOQT1G.u1G.uOOQP<<Ha<<HaOOQS7+$k7+$kO9SQdO7+%ZOOQO7+%b7+%bOOQO,5:i,5:iO3QQdO'#E^O6tQWO,5:wOOQS,5:w,5:wOOQS-E8Z-E8ZOOQS1G0S1G0SO9ZQtO,5:tOOQS-E8W-E8WOOQO<<Hm<<HmOOQPAN={AN={O:XQdO,5:rOOQO-E8U-E8UOOQO<<Hu<<HuOOQO,5:x,5:xOOQO-E8[-E8[OOQS1G0c1G0c",
  stateData: ":k~O#WOS#XQQ~OUYOXYO]VO^VOtWOxXO!YaO!ZZO!g[O!i]O!k^O!n_O!t`O#URO#_TO~OQfOUYOXYO]VO^VOtWOxXO!YaO!ZZO!g[O!i]O!k^O!n_O!t`O#UeO#_TO~O#R#dP~P!ZO#XjO~O#UlO~O]qO^qOpoOtrOxsO|tO!PvO#SuO#_nO~O!RwO~P#pO`}O#TzO#UyO~O#U!OO~O#U!QO~OQ!ZOb!TOf!ZOh!ZOn!YO#T!WO#U!SO#b!UO~Ob!]O!b!_O!e!`O#U![O!R#eP~Oh!eOn!YO#U!dO~Oh!gO#U!gO~Ob!]O!b!_O!e!`O#U![O~O!W#eP~P%gO]WX]!UX^WXpWXtWXxWX|WX!PWX!RWX#SWX#_WX~O]!lO~O!W!mO#R#dX!Q#dX~O#R#dX!Q#dX~P!ZO#Y!pO#Z!pO#[!rO~OUYOXYO]VO^VOtWOxXO#URO#_TO~OpoO!RwO~O`!yO#TzO#UyO~O!Q#dP~P!ZOb#QO~Ob#RO~Ov#SOz#TO~OP#VObgXjgX!WgX!bgX!egX#UgXagXQgXfgXhgXngXpgX!VgX#RgX#TgX#bgXvgX!QgX~Ob!]Oj#WO!b!_O!e!`O#U![O!W#eP~Ob#ZO~Ob!]O!b!_O!e!`O#U#[O~Op#`O!`#_O!R#eX!W#eX~Ob#cO~Oj#WO!W#eO~O!W#fO~Oh#gOn!YO~O!R#hO~O!RwO!`#_O~O!RwO!W#kO~O!W!}X#R!}X!Q!}X~P!ZO!W!mO#R#da!Q#da~O#Y!pO#Z!pO#[#rO~O]qO^qOtrOxsO|tO!PvO#SuO#_nO~Op!{a!R!{aa!{a~P.QOv#tOz#uO~O]qO^qOtrOxsO#_nO~Op{i|{i!P{i!R{i#S{ia{i~P/ROp}i|}i!P}i!R}i#S}ia}i~P/ROp!Oi|!Oi!P!Oi!R!Oi#S!Oia!Oi~P/RO!Q#vO~Oa#cP~P(^Oa#`P~P${Oa#}Oj#WO~O!W$PO~Oh$QOo$QO~O]!^Xa![X!`![X~O]$RO~Oa$SO!`#_O~Op#`O!R#ea!W#ea~O!`#_Op!aa!R!aa!W!aaa!aa~O!W$XO~O!Q$`O#U$ZO#b$YO~Oj#WOp$bO!V$dO!W!Ti#R!Ti!Q!Ti~P${O!W!}a#R!}a!Q!}a~P!ZO!W!mO#R#di!Q#di~Oa#cX~P#pOa$hO~Oj#WOQ!yXa!yXb!yXf!yXh!yXn!yXp!yX#T!yX#U!yX#b!yX~Op$jOa#`X~P${Oa$lO~Oj#WOv$mO~Oa$nO~O!`#_Op#Oa!R#Oa!W#Oa~Oa$pO~P.QOP#VOpgX!RgX~O#b$YOp!qX!R!qX~Op$rO!RwO~O!Q$vO#U$ZO#b$YO~Oj#WOQ!|Xb!|Xf!|Xh!|Xn!|Xp!|X!V!|X!W!|X#R!|X#T!|X#U!|X#b!|X!Q!|X~Op$bO!V$yO!W!Tq#R!Tq!Q!Tq~P${Oj#WOv$zO~OpoOa#ca~Op$jOa#`a~Oa$}O~P${Oj#WOQ!|ab!|af!|ah!|an!|ap!|a!V!|a!W!|a#R!|a#T!|a#U!|a#b!|a!Q!|a~Oa!zap!za~P${O#Wo#X#bj!P#b~",
  goto: "-Y#gPPP#hP#kP#t$TP#t$d#tPP$jPPP$p$y$yP%]P$yP$y%w&ZPPP&s&y#tP'PP#tP'VP#tP#t#tPPP']'r(PPP#kPP(W(W(b(WP(WP(W(WP#kP#kP#kP(e#kP(h(k(n(u#kP#kP(z)Q)a)o)u*P*V*a*g*mPPPPPPPPPP*s*|P+i+lP,b,e,k,tRkQ_bOPdhw!m#nkYOPdhotuvw!m#Q#c#nkSOPdhotuvw!m#Q#c#nQmTR!snQ{VR!wqQ!w}Q#Y!XR#s!yq!ZZ]!T!l#R#T#W#l#u#z$R$b$c$j$o${p!ZZ]!T!l#R#T#W#l#u#z$R$b$c$j$o${U$]#h$_$rR$q$[q!XZ]!T!l#R#T#W#l#u#z$R$b$c$j$o${p!ZZ]!T!l#R#T#W#l#u#z$R$b$c$j$o${Q!e^R#g!fQ|VR!xqQ!w|R#s!xQ!PWR!zrQ!RXR!{sQxUQ!vpQ#d!bQ#j!iQ#k!jQ$t$^R%Q$sSgPwQ!ohQ#m!mR$e#nZfPhw!m#na!a[`a!V!]!_#_#`R#]!]R!f^R!h_R#i!hS$^#h$_R%O$rV$[#h$_$rQ!qjR#q!qQdOShPwU!kdh#nR#n!mQ#z#RU$i#z$o${Q$o$RR${$jQ$k#zR$|$kQpUS!up$gR$g#wQ$c#lR$x$cQ!ngS#o!n#pR#p!oQ#a!^R$V#aQ$_#hR$u$_Q$s$^R%P$s_cOPdhw!m#n^UOPdhw!m#nQ!toQ!|tQ!}uQ#OvQ#w#QR$W#cR#{#RQ!VZQ!c]Q#U!TQ#l!l[#y#R#z$R$j$o${Q#|#TQ$O#WS$a#l$cQ$f#uR$w$bR#x#QQiPR#PwQ!b[Q!jaR#X!VU!^[a!VQ!i`Q#^!]Q#b!_Q$T#_R$U#`",
  nodeNames: "\u26A0 Unit VariableName Comment StyleSheet RuleSet UniversalSelector TagSelector TagName NestingSelector ClassSelector ClassName PseudoClassSelector : :: PseudoClassName PseudoClassName ) ( ArgList ValueName ParenthesizedValue ColorLiteral NumberLiteral StringLiteral BinaryExpression BinOp CallExpression Callee CallLiteral CallTag ParenthesizedContent , PseudoClassName ArgList IdSelector # IdName ] AttributeSelector [ AttributeName MatchOp ChildSelector ChildOp DescendantSelector SiblingSelector SiblingOp } { Block Declaration PropertyName Important ; ImportStatement AtKeyword import KeywordQuery FeatureQuery FeatureName BinaryQuery LogicOp UnaryQuery UnaryQueryOp ParenthesizedQuery SelectorQuery selector MediaStatement media CharsetStatement charset NamespaceStatement namespace NamespaceName KeyframesStatement keyframes KeyframeName KeyframeList KeyframeSelector KeyframeRangeName SupportsStatement supports AtRule Styles",
  maxTerm: 114,
  nodeProps: [
    ["openedBy", 17, "(", 48, "{"],
    ["closedBy", 18, ")", 49, "}"]
  ],
  propSources: [cssHighlighting],
  skippedNodes: [0, 3, 85],
  repeatNodeCount: 10,
  tokenData: "J^~R!^OX$}X^%u^p$}pq%uqr)Xrs.Rst/utu6duv$}vw7^wx7oxy9^yz9oz{9t{|:_|}?Q}!O?c!O!P@Q!P!Q@i!Q![Ab![!]B]!]!^CX!^!_$}!_!`Cj!`!aC{!a!b$}!b!cDw!c!}$}!}#OFa#O#P$}#P#QFr#Q#R6d#R#T$}#T#UGT#U#c$}#c#dHf#d#o$}#o#pH{#p#q6d#q#rI^#r#sIo#s#y$}#y#z%u#z$f$}$f$g%u$g#BY$}#BY#BZ%u#BZ$IS$}$IS$I_%u$I_$I|$}$I|$JO%u$JO$JT$}$JT$JU%u$JU$KV$}$KV$KW%u$KW&FU$}&FU&FV%u&FV;'S$};'S;=`JW<%lO$}`%QSOy%^z;'S%^;'S;=`%o<%lO%^`%cSo`Oy%^z;'S%^;'S;=`%o<%lO%^`%rP;=`<%l%^~%zh#W~OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^~'mh#W~o`OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^l)[UOy%^z#]%^#]#^)n#^;'S%^;'S;=`%o<%lO%^l)sUo`Oy%^z#a%^#a#b*V#b;'S%^;'S;=`%o<%lO%^l*[Uo`Oy%^z#d%^#d#e*n#e;'S%^;'S;=`%o<%lO%^l*sUo`Oy%^z#c%^#c#d+V#d;'S%^;'S;=`%o<%lO%^l+[Uo`Oy%^z#f%^#f#g+n#g;'S%^;'S;=`%o<%lO%^l+sUo`Oy%^z#h%^#h#i,V#i;'S%^;'S;=`%o<%lO%^l,[Uo`Oy%^z#T%^#T#U,n#U;'S%^;'S;=`%o<%lO%^l,sUo`Oy%^z#b%^#b#c-V#c;'S%^;'S;=`%o<%lO%^l-[Uo`Oy%^z#h%^#h#i-n#i;'S%^;'S;=`%o<%lO%^l-uS!V[o`Oy%^z;'S%^;'S;=`%o<%lO%^~.UWOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o<%lO.R~.sOh~~.vRO;'S.R;'S;=`/P;=`O.R~/SXOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o;=`<%l.R<%lO.R~/rP;=`<%l.Rn/zYtQOy%^z!Q%^!Q![0j![!c%^!c!i0j!i#T%^#T#Z0j#Z;'S%^;'S;=`%o<%lO%^l0oYo`Oy%^z!Q%^!Q![1_![!c%^!c!i1_!i#T%^#T#Z1_#Z;'S%^;'S;=`%o<%lO%^l1dYo`Oy%^z!Q%^!Q![2S![!c%^!c!i2S!i#T%^#T#Z2S#Z;'S%^;'S;=`%o<%lO%^l2ZYf[o`Oy%^z!Q%^!Q![2y![!c%^!c!i2y!i#T%^#T#Z2y#Z;'S%^;'S;=`%o<%lO%^l3QYf[o`Oy%^z!Q%^!Q![3p![!c%^!c!i3p!i#T%^#T#Z3p#Z;'S%^;'S;=`%o<%lO%^l3uYo`Oy%^z!Q%^!Q![4e![!c%^!c!i4e!i#T%^#T#Z4e#Z;'S%^;'S;=`%o<%lO%^l4lYf[o`Oy%^z!Q%^!Q![5[![!c%^!c!i5[!i#T%^#T#Z5[#Z;'S%^;'S;=`%o<%lO%^l5aYo`Oy%^z!Q%^!Q![6P![!c%^!c!i6P!i#T%^#T#Z6P#Z;'S%^;'S;=`%o<%lO%^l6WSf[o`Oy%^z;'S%^;'S;=`%o<%lO%^d6gUOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^d7QSzSo`Oy%^z;'S%^;'S;=`%o<%lO%^b7cSXQOy%^z;'S%^;'S;=`%o<%lO%^~7rWOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W<%lO7o~8_RO;'S7o;'S;=`8h;=`O7o~8kXOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W;=`<%l7o<%lO7o~9ZP;=`<%l7on9cSb^Oy%^z;'S%^;'S;=`%o<%lO%^~9tOa~n9{UUQjWOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^n:fWjW!PQOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^l;TUo`Oy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^l;nYo`#b[Oy%^z!Q%^!Q![;g![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^l<cYo`Oy%^z{%^{|=R|}%^}!O=R!O!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=WUo`Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=qUo`#b[Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l>[[o`#b[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^n?VSp^Oy%^z;'S%^;'S;=`%o<%lO%^l?hWjWOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^n@VU#_QOy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^~@nTjWOy%^z{@}{;'S%^;'S;=`%o<%lO%^~AUSo`#X~Oy%^z;'S%^;'S;=`%o<%lO%^lAg[#b[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^bBbU]QOy%^z![%^![!]Bt!];'S%^;'S;=`%o<%lO%^bB{S^Qo`Oy%^z;'S%^;'S;=`%o<%lO%^nC^S!W^Oy%^z;'S%^;'S;=`%o<%lO%^dCoSzSOy%^z;'S%^;'S;=`%o<%lO%^bDQU|QOy%^z!`%^!`!aDd!a;'S%^;'S;=`%o<%lO%^bDkS|Qo`Oy%^z;'S%^;'S;=`%o<%lO%^bDzWOy%^z!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^bEk[!YQo`Oy%^z}%^}!OEd!O!Q%^!Q![Ed![!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^bFfSxQOy%^z;'S%^;'S;=`%o<%lO%^lFwSv[Oy%^z;'S%^;'S;=`%o<%lO%^bGWUOy%^z#b%^#b#cGj#c;'S%^;'S;=`%o<%lO%^bGoUo`Oy%^z#W%^#W#XHR#X;'S%^;'S;=`%o<%lO%^bHYS!`Qo`Oy%^z;'S%^;'S;=`%o<%lO%^bHiUOy%^z#f%^#f#gHR#g;'S%^;'S;=`%o<%lO%^fIQS!RUOy%^z;'S%^;'S;=`%o<%lO%^nIcS!Q^Oy%^z;'S%^;'S;=`%o<%lO%^fItU!PQOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^`JZP;=`<%l$}",
  tokenizers: [descendant, unitToken, identifiers, 1, 2, 3, 4, new LocalTokenGroup("m~RRYZ[z{a~~g~aO#Z~~dP!P!Qg~lO#[~~", 28, 102)],
  topRules: { "StyleSheet": [0, 4], "Styles": [1, 84] },
  specialized: [{ term: 97, get: (value2) => spec_callee[value2] || -1 }, { term: 56, get: (value2) => spec_AtKeyword[value2] || -1 }, { term: 98, get: (value2) => spec_identifier$1[value2] || -1 }],
  tokenPrec: 1169
});
class Text {
  lineAt(pos) {
    if (pos < 0 || pos > this.length)
      throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
    return this.lineInner(pos, false, 1, 0);
  }
  line(n2) {
    if (n2 < 1 || n2 > this.lines)
      throw new RangeError(`Invalid line number ${n2} in ${this.lines}-line document`);
    return this.lineInner(n2, true, 1, 0);
  }
  replace(from, to2, text) {
    let parts = [];
    this.decompose(0, from, parts, 2);
    if (text.length)
      text.decompose(0, text.length, parts, 1 | 2);
    this.decompose(to2, this.length, parts, 1);
    return TextNode.from(parts, this.length - (to2 - from) + text.length);
  }
  append(other) {
    return this.replace(this.length, this.length, other);
  }
  slice(from, to2 = this.length) {
    let parts = [];
    this.decompose(from, to2, parts, 0);
    return TextNode.from(parts, to2 - from);
  }
  eq(other) {
    if (other == this)
      return true;
    if (other.length != this.length || other.lines != this.lines)
      return false;
    let start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
    let a2 = new RawTextCursor(this), b2 = new RawTextCursor(other);
    for (let skip = start, pos = start; ; ) {
      a2.next(skip);
      b2.next(skip);
      skip = 0;
      if (a2.lineBreak != b2.lineBreak || a2.done != b2.done || a2.value != b2.value)
        return false;
      pos += a2.value.length;
      if (a2.done || pos >= end)
        return true;
    }
  }
  iter(dir = 1) {
    return new RawTextCursor(this, dir);
  }
  iterRange(from, to2 = this.length) {
    return new PartialTextCursor(this, from, to2);
  }
  iterLines(from, to2) {
    let inner;
    if (from == null) {
      inner = this.iter();
    } else {
      if (to2 == null)
        to2 = this.lines + 1;
      let start = this.line(from).from;
      inner = this.iterRange(start, Math.max(start, to2 == this.lines + 1 ? this.length : to2 <= 1 ? 0 : this.line(to2 - 1).to));
    }
    return new LineCursor(inner);
  }
  toString() {
    return this.sliceString(0);
  }
  toJSON() {
    let lines = [];
    this.flatten(lines);
    return lines;
  }
  constructor() {
  }
  static of(text) {
    if (text.length == 0)
      throw new RangeError("A document must have at least one line");
    if (text.length == 1 && !text[0])
      return Text.empty;
    return text.length <= 32 ? new TextLeaf(text) : TextNode.from(TextLeaf.split(text, []));
  }
}
class TextLeaf extends Text {
  constructor(text, length2 = textLength(text)) {
    super();
    this.text = text;
    this.length = length2;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(target, isLine, line, offset) {
    for (let i2 = 0; ; i2++) {
      let string3 = this.text[i2], end = offset + string3.length;
      if ((isLine ? line : end) >= target)
        return new Line(offset, end, line, string3);
      offset = end + 1;
      line++;
    }
  }
  decompose(from, to2, target, open) {
    let text = from <= 0 && to2 >= this.length ? this : new TextLeaf(sliceText(this.text, from, to2), Math.min(to2, this.length) - Math.max(0, from));
    if (open & 1) {
      let prev = target.pop();
      let joined = appendText(text.text, prev.text.slice(), 0, text.length);
      if (joined.length <= 32) {
        target.push(new TextLeaf(joined, prev.length + text.length));
      } else {
        let mid = joined.length >> 1;
        target.push(new TextLeaf(joined.slice(0, mid)), new TextLeaf(joined.slice(mid)));
      }
    } else {
      target.push(text);
    }
  }
  replace(from, to2, text) {
    if (!(text instanceof TextLeaf))
      return super.replace(from, to2, text);
    let lines = appendText(this.text, appendText(text.text, sliceText(this.text, 0, from)), to2);
    let newLen = this.length + text.length - (to2 - from);
    if (lines.length <= 32)
      return new TextLeaf(lines, newLen);
    return TextNode.from(TextLeaf.split(lines, []), newLen);
  }
  sliceString(from, to2 = this.length, lineSep = "\n") {
    let result2 = "";
    for (let pos = 0, i2 = 0; pos <= to2 && i2 < this.text.length; i2++) {
      let line = this.text[i2], end = pos + line.length;
      if (pos > from && i2)
        result2 += lineSep;
      if (from < end && to2 > pos)
        result2 += line.slice(Math.max(0, from - pos), to2 - pos);
      pos = end + 1;
    }
    return result2;
  }
  flatten(target) {
    for (let line of this.text)
      target.push(line);
  }
  scanIdentical() {
    return 0;
  }
  static split(text, target) {
    let part = [], len2 = -1;
    for (let line of text) {
      part.push(line);
      len2 += line.length + 1;
      if (part.length == 32) {
        target.push(new TextLeaf(part, len2));
        part = [];
        len2 = -1;
      }
    }
    if (len2 > -1)
      target.push(new TextLeaf(part, len2));
    return target;
  }
}
class TextNode extends Text {
  constructor(children, length2) {
    super();
    this.children = children;
    this.length = length2;
    this.lines = 0;
    for (let child of children)
      this.lines += child.lines;
  }
  lineInner(target, isLine, line, offset) {
    for (let i2 = 0; ; i2++) {
      let child = this.children[i2], end = offset + child.length, endLine = line + child.lines - 1;
      if ((isLine ? endLine : end) >= target)
        return child.lineInner(target, isLine, line, offset);
      offset = end + 1;
      line = endLine + 1;
    }
  }
  decompose(from, to2, target, open) {
    for (let i2 = 0, pos = 0; pos <= to2 && i2 < this.children.length; i2++) {
      let child = this.children[i2], end = pos + child.length;
      if (from <= end && to2 >= pos) {
        let childOpen = open & ((pos <= from ? 1 : 0) | (end >= to2 ? 2 : 0));
        if (pos >= from && end <= to2 && !childOpen)
          target.push(child);
        else
          child.decompose(from - pos, to2 - pos, target, childOpen);
      }
      pos = end + 1;
    }
  }
  replace(from, to2, text) {
    if (text.lines < this.lines)
      for (let i2 = 0, pos = 0; i2 < this.children.length; i2++) {
        let child = this.children[i2], end = pos + child.length;
        if (from >= pos && to2 <= end) {
          let updated = child.replace(from - pos, to2 - pos, text);
          let totalLines = this.lines - child.lines + updated.lines;
          if (updated.lines < totalLines >> 5 - 1 && updated.lines > totalLines >> 5 + 1) {
            let copy = this.children.slice();
            copy[i2] = updated;
            return new TextNode(copy, this.length - (to2 - from) + text.length);
          }
          return super.replace(pos, end, updated);
        }
        pos = end + 1;
      }
    return super.replace(from, to2, text);
  }
  sliceString(from, to2 = this.length, lineSep = "\n") {
    let result2 = "";
    for (let i2 = 0, pos = 0; i2 < this.children.length && pos <= to2; i2++) {
      let child = this.children[i2], end = pos + child.length;
      if (pos > from && i2)
        result2 += lineSep;
      if (from < end && to2 > pos)
        result2 += child.sliceString(from - pos, to2 - pos, lineSep);
      pos = end + 1;
    }
    return result2;
  }
  flatten(target) {
    for (let child of this.children)
      child.flatten(target);
  }
  scanIdentical(other, dir) {
    if (!(other instanceof TextNode))
      return 0;
    let length2 = 0;
    let [iA2, iB2, eA2, eB2] = dir > 0 ? [0, 0, this.children.length, other.children.length] : [this.children.length - 1, other.children.length - 1, -1, -1];
    for (; ; iA2 += dir, iB2 += dir) {
      if (iA2 == eA2 || iB2 == eB2)
        return length2;
      let chA = this.children[iA2], chB = other.children[iB2];
      if (chA != chB)
        return length2 + chA.scanIdentical(chB, dir);
      length2 += chA.length + 1;
    }
  }
  static from(children, length2 = children.reduce((l2, ch2) => l2 + ch2.length + 1, -1)) {
    let lines = 0;
    for (let ch2 of children)
      lines += ch2.lines;
    if (lines < 32) {
      let flat = [];
      for (let ch2 of children)
        ch2.flatten(flat);
      return new TextLeaf(flat, length2);
    }
    let chunk = Math.max(32, lines >> 5), maxChunk = chunk << 1, minChunk = chunk >> 1;
    let chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
    function add2(child) {
      let last;
      if (child.lines > maxChunk && child instanceof TextNode) {
        for (let node2 of child.children)
          add2(node2);
      } else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
        flush();
        chunked.push(child);
      } else if (child instanceof TextLeaf && currentLines && (last = currentChunk[currentChunk.length - 1]) instanceof TextLeaf && child.lines + last.lines <= 32) {
        currentLines += child.lines;
        currentLen += child.length + 1;
        currentChunk[currentChunk.length - 1] = new TextLeaf(last.text.concat(child.text), last.length + 1 + child.length);
      } else {
        if (currentLines + child.lines > chunk)
          flush();
        currentLines += child.lines;
        currentLen += child.length + 1;
        currentChunk.push(child);
      }
    }
    function flush() {
      if (currentLines == 0)
        return;
      chunked.push(currentChunk.length == 1 ? currentChunk[0] : TextNode.from(currentChunk, currentLen));
      currentLen = -1;
      currentLines = currentChunk.length = 0;
    }
    for (let child of children)
      add2(child);
    flush();
    return chunked.length == 1 ? chunked[0] : new TextNode(chunked, length2);
  }
}
Text.empty = /* @__PURE__ */ new TextLeaf([""], 0);
function textLength(text) {
  let length2 = -1;
  for (let line of text)
    length2 += line.length + 1;
  return length2;
}
function appendText(text, target, from = 0, to2 = 1e9) {
  for (let pos = 0, i2 = 0, first = true; i2 < text.length && pos <= to2; i2++) {
    let line = text[i2], end = pos + line.length;
    if (end >= from) {
      if (end > to2)
        line = line.slice(0, to2 - pos);
      if (pos < from)
        line = line.slice(from - pos);
      if (first) {
        target[target.length - 1] += line;
        first = false;
      } else
        target.push(line);
    }
    pos = end + 1;
  }
  return target;
}
function sliceText(text, from, to2) {
  return appendText(text, [""], from, to2);
}
class RawTextCursor {
  constructor(text, dir = 1) {
    this.dir = dir;
    this.done = false;
    this.lineBreak = false;
    this.value = "";
    this.nodes = [text];
    this.offsets = [dir > 0 ? 1 : (text instanceof TextLeaf ? text.text.length : text.children.length) << 1];
  }
  nextInner(skip, dir) {
    this.done = this.lineBreak = false;
    for (; ; ) {
      let last = this.nodes.length - 1;
      let top2 = this.nodes[last], offsetValue = this.offsets[last], offset = offsetValue >> 1;
      let size2 = top2 instanceof TextLeaf ? top2.text.length : top2.children.length;
      if (offset == (dir > 0 ? size2 : 0)) {
        if (last == 0) {
          this.done = true;
          this.value = "";
          return this;
        }
        if (dir > 0)
          this.offsets[last - 1]++;
        this.nodes.pop();
        this.offsets.pop();
      } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
        this.offsets[last] += dir;
        if (skip == 0) {
          this.lineBreak = true;
          this.value = "\n";
          return this;
        }
        skip--;
      } else if (top2 instanceof TextLeaf) {
        let next = top2.text[offset + (dir < 0 ? -1 : 0)];
        this.offsets[last] += dir;
        if (next.length > Math.max(0, skip)) {
          this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
          return this;
        }
        skip -= next.length;
      } else {
        let next = top2.children[offset + (dir < 0 ? -1 : 0)];
        if (skip > next.length) {
          skip -= next.length;
          this.offsets[last] += dir;
        } else {
          if (dir < 0)
            this.offsets[last]--;
          this.nodes.push(next);
          this.offsets.push(dir > 0 ? 1 : (next instanceof TextLeaf ? next.text.length : next.children.length) << 1);
        }
      }
    }
  }
  next(skip = 0) {
    if (skip < 0) {
      this.nextInner(-skip, -this.dir);
      skip = this.value.length;
    }
    return this.nextInner(skip, this.dir);
  }
}
class PartialTextCursor {
  constructor(text, start, end) {
    this.value = "";
    this.done = false;
    this.cursor = new RawTextCursor(text, start > end ? -1 : 1);
    this.pos = start > end ? text.length : 0;
    this.from = Math.min(start, end);
    this.to = Math.max(start, end);
  }
  nextInner(skip, dir) {
    if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
      this.value = "";
      this.done = true;
      return this;
    }
    skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
    let limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
    if (skip > limit)
      skip = limit;
    limit -= skip;
    let { value: value2 } = this.cursor.next(skip);
    this.pos += (value2.length + skip) * dir;
    this.value = value2.length <= limit ? value2 : dir < 0 ? value2.slice(value2.length - limit) : value2.slice(0, limit);
    this.done = !this.value;
    return this;
  }
  next(skip = 0) {
    if (skip < 0)
      skip = Math.max(skip, this.from - this.pos);
    else if (skip > 0)
      skip = Math.min(skip, this.to - this.pos);
    return this.nextInner(skip, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class LineCursor {
  constructor(inner) {
    this.inner = inner;
    this.afterBreak = true;
    this.value = "";
    this.done = false;
  }
  next(skip = 0) {
    let { done, lineBreak, value: value2 } = this.inner.next(skip);
    if (done) {
      this.done = true;
      this.value = "";
    } else if (lineBreak) {
      if (this.afterBreak) {
        this.value = "";
      } else {
        this.afterBreak = true;
        this.next();
      }
    } else {
      this.value = value2;
      this.afterBreak = false;
    }
    return this;
  }
  get lineBreak() {
    return false;
  }
}
if (typeof Symbol != "undefined") {
  Text.prototype[Symbol.iterator] = function() {
    return this.iter();
  };
  RawTextCursor.prototype[Symbol.iterator] = PartialTextCursor.prototype[Symbol.iterator] = LineCursor.prototype[Symbol.iterator] = function() {
    return this;
  };
}
class Line {
  constructor(from, to2, number4, text) {
    this.from = from;
    this.to = to2;
    this.number = number4;
    this.text = text;
  }
  get length() {
    return this.to - this.from;
  }
}
let extend = /* @__PURE__ */ "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s2) => s2 ? parseInt(s2, 36) : 1);
for (let i2 = 1; i2 < extend.length; i2++)
  extend[i2] += extend[i2 - 1];
function isExtendingChar(code) {
  for (let i2 = 1; i2 < extend.length; i2 += 2)
    if (extend[i2] > code)
      return extend[i2 - 1] <= code;
  return false;
}
function isRegionalIndicator(code) {
  return code >= 127462 && code <= 127487;
}
const ZWJ = 8205;
function findClusterBreak(str, pos, forward = true, includeExtending = true) {
  return (forward ? nextClusterBreak : prevClusterBreak)(str, pos, includeExtending);
}
function nextClusterBreak(str, pos, includeExtending) {
  if (pos == str.length)
    return pos;
  if (pos && surrogateLow(str.charCodeAt(pos)) && surrogateHigh(str.charCodeAt(pos - 1)))
    pos--;
  let prev = codePointAt(str, pos);
  pos += codePointSize(prev);
  while (pos < str.length) {
    let next = codePointAt(str, pos);
    if (prev == ZWJ || next == ZWJ || includeExtending && isExtendingChar(next)) {
      pos += codePointSize(next);
      prev = next;
    } else if (isRegionalIndicator(next)) {
      let countBefore = 0, i2 = pos - 2;
      while (i2 >= 0 && isRegionalIndicator(codePointAt(str, i2))) {
        countBefore++;
        i2 -= 2;
      }
      if (countBefore % 2 == 0)
        break;
      else
        pos += 2;
    } else {
      break;
    }
  }
  return pos;
}
function prevClusterBreak(str, pos, includeExtending) {
  while (pos > 0) {
    let found = nextClusterBreak(str, pos - 2, includeExtending);
    if (found < pos)
      return found;
    pos--;
  }
  return 0;
}
function surrogateLow(ch2) {
  return ch2 >= 56320 && ch2 < 57344;
}
function surrogateHigh(ch2) {
  return ch2 >= 55296 && ch2 < 56320;
}
function codePointAt(str, pos) {
  let code0 = str.charCodeAt(pos);
  if (!surrogateHigh(code0) || pos + 1 == str.length)
    return code0;
  let code1 = str.charCodeAt(pos + 1);
  if (!surrogateLow(code1))
    return code0;
  return (code0 - 55296 << 10) + (code1 - 56320) + 65536;
}
function fromCodePoint(code) {
  if (code <= 65535)
    return String.fromCharCode(code);
  code -= 65536;
  return String.fromCharCode((code >> 10) + 55296, (code & 1023) + 56320);
}
function codePointSize(code) {
  return code < 65536 ? 1 : 2;
}
const DefaultSplit = /\r\n?|\n/;
var MapMode = /* @__PURE__ */ function(MapMode2) {
  MapMode2[MapMode2["Simple"] = 0] = "Simple";
  MapMode2[MapMode2["TrackDel"] = 1] = "TrackDel";
  MapMode2[MapMode2["TrackBefore"] = 2] = "TrackBefore";
  MapMode2[MapMode2["TrackAfter"] = 3] = "TrackAfter";
  return MapMode2;
}(MapMode || (MapMode = {}));
class ChangeDesc {
  constructor(sections) {
    this.sections = sections;
  }
  get length() {
    let result2 = 0;
    for (let i2 = 0; i2 < this.sections.length; i2 += 2)
      result2 += this.sections[i2];
    return result2;
  }
  get newLength() {
    let result2 = 0;
    for (let i2 = 0; i2 < this.sections.length; i2 += 2) {
      let ins = this.sections[i2 + 1];
      result2 += ins < 0 ? this.sections[i2] : ins;
    }
    return result2;
  }
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  iterGaps(f2) {
    for (let i2 = 0, posA = 0, posB = 0; i2 < this.sections.length; ) {
      let len2 = this.sections[i2++], ins = this.sections[i2++];
      if (ins < 0) {
        f2(posA, posB, len2);
        posB += len2;
      } else {
        posB += ins;
      }
      posA += len2;
    }
  }
  iterChangedRanges(f2, individual = false) {
    iterChanges(this, f2, individual);
  }
  get invertedDesc() {
    let sections = [];
    for (let i2 = 0; i2 < this.sections.length; ) {
      let len2 = this.sections[i2++], ins = this.sections[i2++];
      if (ins < 0)
        sections.push(len2, ins);
      else
        sections.push(ins, len2);
    }
    return new ChangeDesc(sections);
  }
  composeDesc(other) {
    return this.empty ? other : other.empty ? this : composeSets(this, other);
  }
  mapDesc(other, before = false) {
    return other.empty ? this : mapSet(this, other, before);
  }
  mapPos(pos, assoc = -1, mode = MapMode.Simple) {
    let posA = 0, posB = 0;
    for (let i2 = 0; i2 < this.sections.length; ) {
      let len2 = this.sections[i2++], ins = this.sections[i2++], endA = posA + len2;
      if (ins < 0) {
        if (endA > pos)
          return posB + (pos - posA);
        posB += len2;
      } else {
        if (mode != MapMode.Simple && endA >= pos && (mode == MapMode.TrackDel && posA < pos && endA > pos || mode == MapMode.TrackBefore && posA < pos || mode == MapMode.TrackAfter && endA > pos))
          return null;
        if (endA > pos || endA == pos && assoc < 0 && !len2)
          return pos == posA || assoc < 0 ? posB : posB + ins;
        posB += ins;
      }
      posA = endA;
    }
    if (pos > posA)
      throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
    return posB;
  }
  touchesRange(from, to2 = from) {
    for (let i2 = 0, pos = 0; i2 < this.sections.length && pos <= to2; ) {
      let len2 = this.sections[i2++], ins = this.sections[i2++], end = pos + len2;
      if (ins >= 0 && pos <= to2 && end >= from)
        return pos < from && end > to2 ? "cover" : true;
      pos = end;
    }
    return false;
  }
  toString() {
    let result2 = "";
    for (let i2 = 0; i2 < this.sections.length; ) {
      let len2 = this.sections[i2++], ins = this.sections[i2++];
      result2 += (result2 ? " " : "") + len2 + (ins >= 0 ? ":" + ins : "");
    }
    return result2;
  }
  toJSON() {
    return this.sections;
  }
  static fromJSON(json2) {
    if (!Array.isArray(json2) || json2.length % 2 || json2.some((a2) => typeof a2 != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new ChangeDesc(json2);
  }
  static create(sections) {
    return new ChangeDesc(sections);
  }
}
class ChangeSet extends ChangeDesc {
  constructor(sections, inserted) {
    super(sections);
    this.inserted = inserted;
  }
  apply(doc2) {
    if (this.length != doc2.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    iterChanges(this, (fromA, toA, fromB, _toB, text) => doc2 = doc2.replace(fromB, fromB + (toA - fromA), text), false);
    return doc2;
  }
  mapDesc(other, before = false) {
    return mapSet(this, other, before, true);
  }
  invert(doc2) {
    let sections = this.sections.slice(), inserted = [];
    for (let i2 = 0, pos = 0; i2 < sections.length; i2 += 2) {
      let len2 = sections[i2], ins = sections[i2 + 1];
      if (ins >= 0) {
        sections[i2] = ins;
        sections[i2 + 1] = len2;
        let index2 = i2 >> 1;
        while (inserted.length < index2)
          inserted.push(Text.empty);
        inserted.push(len2 ? doc2.slice(pos, pos + len2) : Text.empty);
      }
      pos += len2;
    }
    return new ChangeSet(sections, inserted);
  }
  compose(other) {
    return this.empty ? other : other.empty ? this : composeSets(this, other, true);
  }
  map(other, before = false) {
    return other.empty ? this : mapSet(this, other, before, true);
  }
  iterChanges(f2, individual = false) {
    iterChanges(this, f2, individual);
  }
  get desc() {
    return ChangeDesc.create(this.sections);
  }
  filter(ranges) {
    let resultSections = [], resultInserted = [], filteredSections = [];
    let iter = new SectionIter(this);
    done:
      for (let i2 = 0, pos = 0; ; ) {
        let next = i2 == ranges.length ? 1e9 : ranges[i2++];
        while (pos < next || pos == next && iter.len == 0) {
          if (iter.done)
            break done;
          let len2 = Math.min(iter.len, next - pos);
          addSection(filteredSections, len2, -1);
          let ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
          addSection(resultSections, len2, ins);
          if (ins > 0)
            addInsert(resultInserted, resultSections, iter.text);
          iter.forward(len2);
          pos += len2;
        }
        let end = ranges[i2++];
        while (pos < end) {
          if (iter.done)
            break done;
          let len2 = Math.min(iter.len, end - pos);
          addSection(resultSections, len2, -1);
          addSection(filteredSections, len2, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
          iter.forward(len2);
          pos += len2;
        }
      }
    return {
      changes: new ChangeSet(resultSections, resultInserted),
      filtered: ChangeDesc.create(filteredSections)
    };
  }
  toJSON() {
    let parts = [];
    for (let i2 = 0; i2 < this.sections.length; i2 += 2) {
      let len2 = this.sections[i2], ins = this.sections[i2 + 1];
      if (ins < 0)
        parts.push(len2);
      else if (ins == 0)
        parts.push([len2]);
      else
        parts.push([len2].concat(this.inserted[i2 >> 1].toJSON()));
    }
    return parts;
  }
  static of(changes, length2, lineSep) {
    let sections = [], inserted = [], pos = 0;
    let total = null;
    function flush(force = false) {
      if (!force && !sections.length)
        return;
      if (pos < length2)
        addSection(sections, length2 - pos, -1);
      let set2 = new ChangeSet(sections, inserted);
      total = total ? total.compose(set2.map(total)) : set2;
      sections = [];
      inserted = [];
      pos = 0;
    }
    function process2(spec2) {
      if (Array.isArray(spec2)) {
        for (let sub of spec2)
          process2(sub);
      } else if (spec2 instanceof ChangeSet) {
        if (spec2.length != length2)
          throw new RangeError(`Mismatched change set length (got ${spec2.length}, expected ${length2})`);
        flush();
        total = total ? total.compose(spec2.map(total)) : spec2;
      } else {
        let { from, to: to2 = from, insert: insert2 } = spec2;
        if (from > to2 || from < 0 || to2 > length2)
          throw new RangeError(`Invalid change range ${from} to ${to2} (in doc of length ${length2})`);
        let insText = !insert2 ? Text.empty : typeof insert2 == "string" ? Text.of(insert2.split(lineSep || DefaultSplit)) : insert2;
        let insLen = insText.length;
        if (from == to2 && insLen == 0)
          return;
        if (from < pos)
          flush();
        if (from > pos)
          addSection(sections, from - pos, -1);
        addSection(sections, to2 - from, insLen);
        addInsert(inserted, sections, insText);
        pos = to2;
      }
    }
    process2(changes);
    flush(!total);
    return total;
  }
  static empty(length2) {
    return new ChangeSet(length2 ? [length2, -1] : [], []);
  }
  static fromJSON(json2) {
    if (!Array.isArray(json2))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let sections = [], inserted = [];
    for (let i2 = 0; i2 < json2.length; i2++) {
      let part = json2[i2];
      if (typeof part == "number") {
        sections.push(part, -1);
      } else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e25, i3) => i3 && typeof e25 != "string")) {
        throw new RangeError("Invalid JSON representation of ChangeSet");
      } else if (part.length == 1) {
        sections.push(part[0], 0);
      } else {
        while (inserted.length < i2)
          inserted.push(Text.empty);
        inserted[i2] = Text.of(part.slice(1));
        sections.push(part[0], inserted[i2].length);
      }
    }
    return new ChangeSet(sections, inserted);
  }
  static createSet(sections, inserted) {
    return new ChangeSet(sections, inserted);
  }
}
function addSection(sections, len2, ins, forceJoin = false) {
  if (len2 == 0 && ins <= 0)
    return;
  let last = sections.length - 2;
  if (last >= 0 && ins <= 0 && ins == sections[last + 1])
    sections[last] += len2;
  else if (len2 == 0 && sections[last] == 0)
    sections[last + 1] += ins;
  else if (forceJoin) {
    sections[last] += len2;
    sections[last + 1] += ins;
  } else
    sections.push(len2, ins);
}
function addInsert(values2, sections, value2) {
  if (value2.length == 0)
    return;
  let index2 = sections.length - 2 >> 1;
  if (index2 < values2.length) {
    values2[values2.length - 1] = values2[values2.length - 1].append(value2);
  } else {
    while (values2.length < index2)
      values2.push(Text.empty);
    values2.push(value2);
  }
}
function iterChanges(desc, f2, individual) {
  let inserted = desc.inserted;
  for (let posA = 0, posB = 0, i2 = 0; i2 < desc.sections.length; ) {
    let len2 = desc.sections[i2++], ins = desc.sections[i2++];
    if (ins < 0) {
      posA += len2;
      posB += len2;
    } else {
      let endA = posA, endB = posB, text = Text.empty;
      for (; ; ) {
        endA += len2;
        endB += ins;
        if (ins && inserted)
          text = text.append(inserted[i2 - 2 >> 1]);
        if (individual || i2 == desc.sections.length || desc.sections[i2 + 1] < 0)
          break;
        len2 = desc.sections[i2++];
        ins = desc.sections[i2++];
      }
      f2(posA, endA, posB, endB, text);
      posA = endA;
      posB = endB;
    }
  }
}
function mapSet(setA, setB, before, mkSet = false) {
  let sections = [], insert2 = mkSet ? [] : null;
  let a2 = new SectionIter(setA), b2 = new SectionIter(setB);
  for (let inserted = -1; ; ) {
    if (a2.ins == -1 && b2.ins == -1) {
      let len2 = Math.min(a2.len, b2.len);
      addSection(sections, len2, -1);
      a2.forward(len2);
      b2.forward(len2);
    } else if (b2.ins >= 0 && (a2.ins < 0 || inserted == a2.i || a2.off == 0 && (b2.len < a2.len || b2.len == a2.len && !before))) {
      let len2 = b2.len;
      addSection(sections, b2.ins, -1);
      while (len2) {
        let piece = Math.min(a2.len, len2);
        if (a2.ins >= 0 && inserted < a2.i && a2.len <= piece) {
          addSection(sections, 0, a2.ins);
          if (insert2)
            addInsert(insert2, sections, a2.text);
          inserted = a2.i;
        }
        a2.forward(piece);
        len2 -= piece;
      }
      b2.next();
    } else if (a2.ins >= 0) {
      let len2 = 0, left = a2.len;
      while (left) {
        if (b2.ins == -1) {
          let piece = Math.min(left, b2.len);
          len2 += piece;
          left -= piece;
          b2.forward(piece);
        } else if (b2.ins == 0 && b2.len < left) {
          left -= b2.len;
          b2.next();
        } else {
          break;
        }
      }
      addSection(sections, len2, inserted < a2.i ? a2.ins : 0);
      if (insert2 && inserted < a2.i)
        addInsert(insert2, sections, a2.text);
      inserted = a2.i;
      a2.forward(a2.len - left);
    } else if (a2.done && b2.done) {
      return insert2 ? ChangeSet.createSet(sections, insert2) : ChangeDesc.create(sections);
    } else {
      throw new Error("Mismatched change set lengths");
    }
  }
}
function composeSets(setA, setB, mkSet = false) {
  let sections = [];
  let insert2 = mkSet ? [] : null;
  let a2 = new SectionIter(setA), b2 = new SectionIter(setB);
  for (let open = false; ; ) {
    if (a2.done && b2.done) {
      return insert2 ? ChangeSet.createSet(sections, insert2) : ChangeDesc.create(sections);
    } else if (a2.ins == 0) {
      addSection(sections, a2.len, 0, open);
      a2.next();
    } else if (b2.len == 0 && !b2.done) {
      addSection(sections, 0, b2.ins, open);
      if (insert2)
        addInsert(insert2, sections, b2.text);
      b2.next();
    } else if (a2.done || b2.done) {
      throw new Error("Mismatched change set lengths");
    } else {
      let len2 = Math.min(a2.len2, b2.len), sectionLen = sections.length;
      if (a2.ins == -1) {
        let insB = b2.ins == -1 ? -1 : b2.off ? 0 : b2.ins;
        addSection(sections, len2, insB, open);
        if (insert2 && insB)
          addInsert(insert2, sections, b2.text);
      } else if (b2.ins == -1) {
        addSection(sections, a2.off ? 0 : a2.len, len2, open);
        if (insert2)
          addInsert(insert2, sections, a2.textBit(len2));
      } else {
        addSection(sections, a2.off ? 0 : a2.len, b2.off ? 0 : b2.ins, open);
        if (insert2 && !b2.off)
          addInsert(insert2, sections, b2.text);
      }
      open = (a2.ins > len2 || b2.ins >= 0 && b2.len > len2) && (open || sections.length > sectionLen);
      a2.forward2(len2);
      b2.forward(len2);
    }
  }
}
class SectionIter {
  constructor(set2) {
    this.set = set2;
    this.i = 0;
    this.next();
  }
  next() {
    let { sections } = this.set;
    if (this.i < sections.length) {
      this.len = sections[this.i++];
      this.ins = sections[this.i++];
    } else {
      this.len = 0;
      this.ins = -2;
    }
    this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted } = this.set, index2 = this.i - 2 >> 1;
    return index2 >= inserted.length ? Text.empty : inserted[index2];
  }
  textBit(len2) {
    let { inserted } = this.set, index2 = this.i - 2 >> 1;
    return index2 >= inserted.length && !len2 ? Text.empty : inserted[index2].slice(this.off, len2 == null ? void 0 : this.off + len2);
  }
  forward(len2) {
    if (len2 == this.len)
      this.next();
    else {
      this.len -= len2;
      this.off += len2;
    }
  }
  forward2(len2) {
    if (this.ins == -1)
      this.forward(len2);
    else if (len2 == this.ins)
      this.next();
    else {
      this.ins -= len2;
      this.off += len2;
    }
  }
}
class SelectionRange {
  constructor(from, to2, flags) {
    this.from = from;
    this.to = to2;
    this.flags = flags;
  }
  get anchor() {
    return this.flags & 16 ? this.to : this.from;
  }
  get head() {
    return this.flags & 16 ? this.from : this.to;
  }
  get empty() {
    return this.from == this.to;
  }
  get assoc() {
    return this.flags & 4 ? -1 : this.flags & 8 ? 1 : 0;
  }
  get bidiLevel() {
    let level = this.flags & 3;
    return level == 3 ? null : level;
  }
  get goalColumn() {
    let value2 = this.flags >> 5;
    return value2 == 33554431 ? void 0 : value2;
  }
  map(change, assoc = -1) {
    let from, to2;
    if (this.empty) {
      from = to2 = change.mapPos(this.from, assoc);
    } else {
      from = change.mapPos(this.from, 1);
      to2 = change.mapPos(this.to, -1);
    }
    return from == this.from && to2 == this.to ? this : new SelectionRange(from, to2, this.flags);
  }
  extend(from, to2 = from) {
    if (from <= this.anchor && to2 >= this.anchor)
      return EditorSelection.range(from, to2);
    let head = Math.abs(from - this.anchor) > Math.abs(to2 - this.anchor) ? from : to2;
    return EditorSelection.range(this.anchor, head);
  }
  eq(other) {
    return this.anchor == other.anchor && this.head == other.head;
  }
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  static fromJSON(json2) {
    if (!json2 || typeof json2.anchor != "number" || typeof json2.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return EditorSelection.range(json2.anchor, json2.head);
  }
  static create(from, to2, flags) {
    return new SelectionRange(from, to2, flags);
  }
}
class EditorSelection {
  constructor(ranges, mainIndex) {
    this.ranges = ranges;
    this.mainIndex = mainIndex;
  }
  map(change, assoc = -1) {
    if (change.empty)
      return this;
    return EditorSelection.create(this.ranges.map((r2) => r2.map(change, assoc)), this.mainIndex);
  }
  eq(other) {
    if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex)
      return false;
    for (let i2 = 0; i2 < this.ranges.length; i2++)
      if (!this.ranges[i2].eq(other.ranges[i2]))
        return false;
    return true;
  }
  get main() {
    return this.ranges[this.mainIndex];
  }
  asSingle() {
    return this.ranges.length == 1 ? this : new EditorSelection([this.main], 0);
  }
  addRange(range3, main = true) {
    return EditorSelection.create([range3].concat(this.ranges), main ? 0 : this.mainIndex + 1);
  }
  replaceRange(range3, which = this.mainIndex) {
    let ranges = this.ranges.slice();
    ranges[which] = range3;
    return EditorSelection.create(ranges, this.mainIndex);
  }
  toJSON() {
    return { ranges: this.ranges.map((r2) => r2.toJSON()), main: this.mainIndex };
  }
  static fromJSON(json2) {
    if (!json2 || !Array.isArray(json2.ranges) || typeof json2.main != "number" || json2.main >= json2.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new EditorSelection(json2.ranges.map((r2) => SelectionRange.fromJSON(r2)), json2.main);
  }
  static single(anchor, head = anchor) {
    return new EditorSelection([EditorSelection.range(anchor, head)], 0);
  }
  static create(ranges, mainIndex = 0) {
    if (ranges.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let pos = 0, i2 = 0; i2 < ranges.length; i2++) {
      let range3 = ranges[i2];
      if (range3.empty ? range3.from <= pos : range3.from < pos)
        return EditorSelection.normalized(ranges.slice(), mainIndex);
      pos = range3.to;
    }
    return new EditorSelection(ranges, mainIndex);
  }
  static cursor(pos, assoc = 0, bidiLevel, goalColumn) {
    return SelectionRange.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 4 : 8) | (bidiLevel == null ? 3 : Math.min(2, bidiLevel)) | (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 33554431) << 5);
  }
  static range(anchor, head, goalColumn, bidiLevel) {
    let flags = (goalColumn !== null && goalColumn !== void 0 ? goalColumn : 33554431) << 5 | (bidiLevel == null ? 3 : Math.min(2, bidiLevel));
    return head < anchor ? SelectionRange.create(head, anchor, 16 | 8 | flags) : SelectionRange.create(anchor, head, (head > anchor ? 4 : 0) | flags);
  }
  static normalized(ranges, mainIndex = 0) {
    let main = ranges[mainIndex];
    ranges.sort((a2, b2) => a2.from - b2.from);
    mainIndex = ranges.indexOf(main);
    for (let i2 = 1; i2 < ranges.length; i2++) {
      let range3 = ranges[i2], prev = ranges[i2 - 1];
      if (range3.empty ? range3.from <= prev.to : range3.from < prev.to) {
        let from = prev.from, to2 = Math.max(range3.to, prev.to);
        if (i2 <= mainIndex)
          mainIndex--;
        ranges.splice(--i2, 2, range3.anchor > range3.head ? EditorSelection.range(to2, from) : EditorSelection.range(from, to2));
      }
    }
    return new EditorSelection(ranges, mainIndex);
  }
}
function checkSelection(selection, docLength) {
  for (let range3 of selection.ranges)
    if (range3.to > docLength)
      throw new RangeError("Selection points outside of document");
}
let nextID = 0;
class Facet {
  constructor(combine, compareInput, compare2, isStatic, enables) {
    this.combine = combine;
    this.compareInput = compareInput;
    this.compare = compare2;
    this.isStatic = isStatic;
    this.id = nextID++;
    this.default = combine([]);
    this.extensions = typeof enables == "function" ? enables(this) : enables;
  }
  static define(config2 = {}) {
    return new Facet(config2.combine || ((a2) => a2), config2.compareInput || ((a2, b2) => a2 === b2), config2.compare || (!config2.combine ? sameArray : (a2, b2) => a2 === b2), !!config2.static, config2.enables);
  }
  of(value2) {
    return new FacetProvider([], this, 0, value2);
  }
  compute(deps, get2) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new FacetProvider(deps, this, 1, get2);
  }
  computeN(deps, get2) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new FacetProvider(deps, this, 2, get2);
  }
  from(field, get2) {
    if (!get2)
      get2 = (x2) => x2;
    return this.compute([field], (state) => get2(state.field(field)));
  }
}
function sameArray(a2, b2) {
  return a2 == b2 || a2.length == b2.length && a2.every((e25, i2) => e25 === b2[i2]);
}
class FacetProvider {
  constructor(dependencies, facet, type4, value2) {
    this.dependencies = dependencies;
    this.facet = facet;
    this.type = type4;
    this.value = value2;
    this.id = nextID++;
  }
  dynamicSlot(addresses) {
    var _a2;
    let getter = this.value;
    let compare2 = this.facet.compareInput;
    let id2 = this.id, idx = addresses[id2] >> 1, multi = this.type == 2;
    let depDoc = false, depSel = false, depAddrs = [];
    for (let dep of this.dependencies) {
      if (dep == "doc")
        depDoc = true;
      else if (dep == "selection")
        depSel = true;
      else if ((((_a2 = addresses[dep.id]) !== null && _a2 !== void 0 ? _a2 : 1) & 1) == 0)
        depAddrs.push(addresses[dep.id]);
    }
    return {
      create(state) {
        state.values[idx] = getter(state);
        return 1;
      },
      update(state, tr2) {
        if (depDoc && tr2.docChanged || depSel && (tr2.docChanged || tr2.selection) || ensureAll(state, depAddrs)) {
          let newVal = getter(state);
          if (multi ? !compareArray(newVal, state.values[idx], compare2) : !compare2(newVal, state.values[idx])) {
            state.values[idx] = newVal;
            return 1;
          }
        }
        return 0;
      },
      reconfigure: (state, oldState) => {
        let newVal, oldAddr = oldState.config.address[id2];
        if (oldAddr != null) {
          let oldVal = getAddr(oldState, oldAddr);
          if (this.dependencies.every((dep) => {
            return dep instanceof Facet ? oldState.facet(dep) === state.facet(dep) : dep instanceof StateField ? oldState.field(dep, false) == state.field(dep, false) : true;
          }) || (multi ? compareArray(newVal = getter(state), oldVal, compare2) : compare2(newVal = getter(state), oldVal))) {
            state.values[idx] = oldVal;
            return 0;
          }
        } else {
          newVal = getter(state);
        }
        state.values[idx] = newVal;
        return 1;
      }
    };
  }
}
function compareArray(a2, b2, compare2) {
  if (a2.length != b2.length)
    return false;
  for (let i2 = 0; i2 < a2.length; i2++)
    if (!compare2(a2[i2], b2[i2]))
      return false;
  return true;
}
function ensureAll(state, addrs) {
  let changed = false;
  for (let addr of addrs)
    if (ensureAddr(state, addr) & 1)
      changed = true;
  return changed;
}
function dynamicFacetSlot(addresses, facet, providers) {
  let providerAddrs = providers.map((p2) => addresses[p2.id]);
  let providerTypes = providers.map((p2) => p2.type);
  let dynamic = providerAddrs.filter((p2) => !(p2 & 1));
  let idx = addresses[facet.id] >> 1;
  function get2(state) {
    let values2 = [];
    for (let i2 = 0; i2 < providerAddrs.length; i2++) {
      let value2 = getAddr(state, providerAddrs[i2]);
      if (providerTypes[i2] == 2)
        for (let val of value2)
          values2.push(val);
      else
        values2.push(value2);
    }
    return facet.combine(values2);
  }
  return {
    create(state) {
      for (let addr of providerAddrs)
        ensureAddr(state, addr);
      state.values[idx] = get2(state);
      return 1;
    },
    update(state, tr2) {
      if (!ensureAll(state, dynamic))
        return 0;
      let value2 = get2(state);
      if (facet.compare(value2, state.values[idx]))
        return 0;
      state.values[idx] = value2;
      return 1;
    },
    reconfigure(state, oldState) {
      let depChanged = ensureAll(state, providerAddrs);
      let oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
      if (oldProviders && !depChanged && sameArray(providers, oldProviders)) {
        state.values[idx] = oldValue;
        return 0;
      }
      let value2 = get2(state);
      if (facet.compare(value2, oldValue)) {
        state.values[idx] = oldValue;
        return 0;
      }
      state.values[idx] = value2;
      return 1;
    }
  };
}
const initField = /* @__PURE__ */ Facet.define({ static: true });
class StateField {
  constructor(id2, createF, updateF, compareF, spec2) {
    this.id = id2;
    this.createF = createF;
    this.updateF = updateF;
    this.compareF = compareF;
    this.spec = spec2;
    this.provides = void 0;
  }
  static define(config2) {
    let field = new StateField(nextID++, config2.create, config2.update, config2.compare || ((a2, b2) => a2 === b2), config2);
    if (config2.provide)
      field.provides = config2.provide(field);
    return field;
  }
  create(state) {
    let init2 = state.facet(initField).find((i2) => i2.field == this);
    return ((init2 === null || init2 === void 0 ? void 0 : init2.create) || this.createF)(state);
  }
  slot(addresses) {
    let idx = addresses[this.id] >> 1;
    return {
      create: (state) => {
        state.values[idx] = this.create(state);
        return 1;
      },
      update: (state, tr2) => {
        let oldVal = state.values[idx];
        let value2 = this.updateF(oldVal, tr2);
        if (this.compareF(oldVal, value2))
          return 0;
        state.values[idx] = value2;
        return 1;
      },
      reconfigure: (state, oldState) => {
        if (oldState.config.address[this.id] != null) {
          state.values[idx] = oldState.field(this);
          return 0;
        }
        state.values[idx] = this.create(state);
        return 1;
      }
    };
  }
  init(create) {
    return [this, initField.of({ field: this, create })];
  }
  get extension() {
    return this;
  }
}
const Prec_ = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function prec(value2) {
  return (ext) => new PrecExtension(ext, value2);
}
const Prec = {
  highest: /* @__PURE__ */ prec(Prec_.highest),
  high: /* @__PURE__ */ prec(Prec_.high),
  default: /* @__PURE__ */ prec(Prec_.default),
  low: /* @__PURE__ */ prec(Prec_.low),
  lowest: /* @__PURE__ */ prec(Prec_.lowest)
};
class PrecExtension {
  constructor(inner, prec2) {
    this.inner = inner;
    this.prec = prec2;
  }
}
class Compartment {
  of(ext) {
    return new CompartmentInstance(this, ext);
  }
  reconfigure(content2) {
    return Compartment.reconfigure.of({ compartment: this, extension: content2 });
  }
  get(state) {
    return state.config.compartments.get(this);
  }
}
class CompartmentInstance {
  constructor(compartment, inner) {
    this.compartment = compartment;
    this.inner = inner;
  }
}
class Configuration {
  constructor(base2, compartments, dynamicSlots, address, staticValues, facets) {
    this.base = base2;
    this.compartments = compartments;
    this.dynamicSlots = dynamicSlots;
    this.address = address;
    this.staticValues = staticValues;
    this.facets = facets;
    this.statusTemplate = [];
    while (this.statusTemplate.length < dynamicSlots.length)
      this.statusTemplate.push(0);
  }
  staticFacet(facet) {
    let addr = this.address[facet.id];
    return addr == null ? facet.default : this.staticValues[addr >> 1];
  }
  static resolve(base2, compartments, oldState) {
    let fields = [];
    let facets = Object.create(null);
    let newCompartments = new Map();
    for (let ext of flatten(base2, compartments, newCompartments)) {
      if (ext instanceof StateField)
        fields.push(ext);
      else
        (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
    }
    let address = Object.create(null);
    let staticValues = [];
    let dynamicSlots = [];
    for (let field of fields) {
      address[field.id] = dynamicSlots.length << 1;
      dynamicSlots.push((a2) => field.slot(a2));
    }
    let oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
    for (let id2 in facets) {
      let providers = facets[id2], facet = providers[0].facet;
      let oldProviders = oldFacets && oldFacets[id2] || [];
      if (providers.every((p2) => p2.type == 0)) {
        address[facet.id] = staticValues.length << 1 | 1;
        if (sameArray(oldProviders, providers)) {
          staticValues.push(oldState.facet(facet));
        } else {
          let value2 = facet.combine(providers.map((p2) => p2.value));
          staticValues.push(oldState && facet.compare(value2, oldState.facet(facet)) ? oldState.facet(facet) : value2);
        }
      } else {
        for (let p2 of providers) {
          if (p2.type == 0) {
            address[p2.id] = staticValues.length << 1 | 1;
            staticValues.push(p2.value);
          } else {
            address[p2.id] = dynamicSlots.length << 1;
            dynamicSlots.push((a2) => p2.dynamicSlot(a2));
          }
        }
        address[facet.id] = dynamicSlots.length << 1;
        dynamicSlots.push((a2) => dynamicFacetSlot(a2, facet, providers));
      }
    }
    let dynamic = dynamicSlots.map((f2) => f2(address));
    return new Configuration(base2, newCompartments, dynamic, address, staticValues, facets);
  }
}
function flatten(extension, compartments, newCompartments) {
  let result2 = [[], [], [], [], []];
  let seen = new Map();
  function inner(ext, prec2) {
    let known = seen.get(ext);
    if (known != null) {
      if (known <= prec2)
        return;
      let found = result2[known].indexOf(ext);
      if (found > -1)
        result2[known].splice(found, 1);
      if (ext instanceof CompartmentInstance)
        newCompartments.delete(ext.compartment);
    }
    seen.set(ext, prec2);
    if (Array.isArray(ext)) {
      for (let e25 of ext)
        inner(e25, prec2);
    } else if (ext instanceof CompartmentInstance) {
      if (newCompartments.has(ext.compartment))
        throw new RangeError(`Duplicate use of compartment in extensions`);
      let content2 = compartments.get(ext.compartment) || ext.inner;
      newCompartments.set(ext.compartment, content2);
      inner(content2, prec2);
    } else if (ext instanceof PrecExtension) {
      inner(ext.inner, ext.prec);
    } else if (ext instanceof StateField) {
      result2[prec2].push(ext);
      if (ext.provides)
        inner(ext.provides, prec2);
    } else if (ext instanceof FacetProvider) {
      result2[prec2].push(ext);
      if (ext.facet.extensions)
        inner(ext.facet.extensions, Prec_.default);
    } else {
      let content2 = ext.extension;
      if (!content2)
        throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      inner(content2, prec2);
    }
  }
  inner(extension, Prec_.default);
  return result2.reduce((a2, b2) => a2.concat(b2));
}
function ensureAddr(state, addr) {
  if (addr & 1)
    return 2;
  let idx = addr >> 1;
  let status = state.status[idx];
  if (status == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (status & 2)
    return status;
  state.status[idx] = 4;
  let changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
  return state.status[idx] = 2 | changed;
}
function getAddr(state, addr) {
  return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
const languageData = /* @__PURE__ */ Facet.define();
const allowMultipleSelections = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.some((v2) => v2),
  static: true
});
const lineSeparator = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.length ? values2[0] : void 0,
  static: true
});
const changeFilter = /* @__PURE__ */ Facet.define();
const transactionFilter = /* @__PURE__ */ Facet.define();
const transactionExtender = /* @__PURE__ */ Facet.define();
const readOnly = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.length ? values2[0] : false
});
class Annotation {
  constructor(type4, value2) {
    this.type = type4;
    this.value = value2;
  }
  static define() {
    return new AnnotationType();
  }
}
class AnnotationType {
  of(value2) {
    return new Annotation(this, value2);
  }
}
class StateEffectType {
  constructor(map2) {
    this.map = map2;
  }
  of(value2) {
    return new StateEffect(this, value2);
  }
}
class StateEffect {
  constructor(type4, value2) {
    this.type = type4;
    this.value = value2;
  }
  map(mapping) {
    let mapped = this.type.map(this.value, mapping);
    return mapped === void 0 ? void 0 : mapped == this.value ? this : new StateEffect(this.type, mapped);
  }
  is(type4) {
    return this.type == type4;
  }
  static define(spec2 = {}) {
    return new StateEffectType(spec2.map || ((v2) => v2));
  }
  static mapEffects(effects, mapping) {
    if (!effects.length)
      return effects;
    let result2 = [];
    for (let effect of effects) {
      let mapped = effect.map(mapping);
      if (mapped)
        result2.push(mapped);
    }
    return result2;
  }
}
StateEffect.reconfigure = /* @__PURE__ */ StateEffect.define();
StateEffect.appendConfig = /* @__PURE__ */ StateEffect.define();
class Transaction {
  constructor(startState, changes, selection, effects, annotations, scrollIntoView2) {
    this.startState = startState;
    this.changes = changes;
    this.selection = selection;
    this.effects = effects;
    this.annotations = annotations;
    this.scrollIntoView = scrollIntoView2;
    this._doc = null;
    this._state = null;
    if (selection)
      checkSelection(selection, changes.newLength);
    if (!annotations.some((a2) => a2.type == Transaction.time))
      this.annotations = annotations.concat(Transaction.time.of(Date.now()));
  }
  static create(startState, changes, selection, effects, annotations, scrollIntoView2) {
    return new Transaction(startState, changes, selection, effects, annotations, scrollIntoView2);
  }
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  get state() {
    if (!this._state)
      this.startState.applyTransaction(this);
    return this._state;
  }
  annotation(type4) {
    for (let ann of this.annotations)
      if (ann.type == type4)
        return ann.value;
    return void 0;
  }
  get docChanged() {
    return !this.changes.empty;
  }
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  isUserEvent(event) {
    let e25 = this.annotation(Transaction.userEvent);
    return !!(e25 && (e25 == event || e25.length > event.length && e25.slice(0, event.length) == event && e25[event.length] == "."));
  }
}
Transaction.time = /* @__PURE__ */ Annotation.define();
Transaction.userEvent = /* @__PURE__ */ Annotation.define();
Transaction.addToHistory = /* @__PURE__ */ Annotation.define();
Transaction.remote = /* @__PURE__ */ Annotation.define();
function joinRanges(a2, b2) {
  let result2 = [];
  for (let iA2 = 0, iB2 = 0; ; ) {
    let from, to2;
    if (iA2 < a2.length && (iB2 == b2.length || b2[iB2] >= a2[iA2])) {
      from = a2[iA2++];
      to2 = a2[iA2++];
    } else if (iB2 < b2.length) {
      from = b2[iB2++];
      to2 = b2[iB2++];
    } else
      return result2;
    if (!result2.length || result2[result2.length - 1] < from)
      result2.push(from, to2);
    else if (result2[result2.length - 1] < to2)
      result2[result2.length - 1] = to2;
  }
}
function mergeTransaction(a2, b2, sequential) {
  var _a2;
  let mapForA, mapForB, changes;
  if (sequential) {
    mapForA = b2.changes;
    mapForB = ChangeSet.empty(b2.changes.length);
    changes = a2.changes.compose(b2.changes);
  } else {
    mapForA = b2.changes.map(a2.changes);
    mapForB = a2.changes.mapDesc(b2.changes, true);
    changes = a2.changes.compose(mapForA);
  }
  return {
    changes,
    selection: b2.selection ? b2.selection.map(mapForB) : (_a2 = a2.selection) === null || _a2 === void 0 ? void 0 : _a2.map(mapForA),
    effects: StateEffect.mapEffects(a2.effects, mapForA).concat(StateEffect.mapEffects(b2.effects, mapForB)),
    annotations: a2.annotations.length ? a2.annotations.concat(b2.annotations) : b2.annotations,
    scrollIntoView: a2.scrollIntoView || b2.scrollIntoView
  };
}
function resolveTransactionInner(state, spec2, docSize) {
  let sel = spec2.selection, annotations = asArray$1(spec2.annotations);
  if (spec2.userEvent)
    annotations = annotations.concat(Transaction.userEvent.of(spec2.userEvent));
  return {
    changes: spec2.changes instanceof ChangeSet ? spec2.changes : ChangeSet.of(spec2.changes || [], docSize, state.facet(lineSeparator)),
    selection: sel && (sel instanceof EditorSelection ? sel : EditorSelection.single(sel.anchor, sel.head)),
    effects: asArray$1(spec2.effects),
    annotations,
    scrollIntoView: !!spec2.scrollIntoView
  };
}
function resolveTransaction(state, specs, filter) {
  let s2 = resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
  if (specs.length && specs[0].filter === false)
    filter = false;
  for (let i2 = 1; i2 < specs.length; i2++) {
    if (specs[i2].filter === false)
      filter = false;
    let seq = !!specs[i2].sequential;
    s2 = mergeTransaction(s2, resolveTransactionInner(state, specs[i2], seq ? s2.changes.newLength : state.doc.length), seq);
  }
  let tr2 = Transaction.create(state, s2.changes, s2.selection, s2.effects, s2.annotations, s2.scrollIntoView);
  return extendTransaction(filter ? filterTransaction(tr2) : tr2);
}
function filterTransaction(tr2) {
  let state = tr2.startState;
  let result2 = true;
  for (let filter of state.facet(changeFilter)) {
    let value2 = filter(tr2);
    if (value2 === false) {
      result2 = false;
      break;
    }
    if (Array.isArray(value2))
      result2 = result2 === true ? value2 : joinRanges(result2, value2);
  }
  if (result2 !== true) {
    let changes, back;
    if (result2 === false) {
      back = tr2.changes.invertedDesc;
      changes = ChangeSet.empty(state.doc.length);
    } else {
      let filtered = tr2.changes.filter(result2);
      changes = filtered.changes;
      back = filtered.filtered.mapDesc(filtered.changes).invertedDesc;
    }
    tr2 = Transaction.create(state, changes, tr2.selection && tr2.selection.map(back), StateEffect.mapEffects(tr2.effects, back), tr2.annotations, tr2.scrollIntoView);
  }
  let filters = state.facet(transactionFilter);
  for (let i2 = filters.length - 1; i2 >= 0; i2--) {
    let filtered = filters[i2](tr2);
    if (filtered instanceof Transaction)
      tr2 = filtered;
    else if (Array.isArray(filtered) && filtered.length == 1 && filtered[0] instanceof Transaction)
      tr2 = filtered[0];
    else
      tr2 = resolveTransaction(state, asArray$1(filtered), false);
  }
  return tr2;
}
function extendTransaction(tr2) {
  let state = tr2.startState, extenders = state.facet(transactionExtender), spec2 = tr2;
  for (let i2 = extenders.length - 1; i2 >= 0; i2--) {
    let extension = extenders[i2](tr2);
    if (extension && Object.keys(extension).length)
      spec2 = mergeTransaction(spec2, resolveTransactionInner(state, extension, tr2.changes.newLength), true);
  }
  return spec2 == tr2 ? tr2 : Transaction.create(state, tr2.changes, tr2.selection, spec2.effects, spec2.annotations, spec2.scrollIntoView);
}
const none$2 = [];
function asArray$1(value2) {
  return value2 == null ? none$2 : Array.isArray(value2) ? value2 : [value2];
}
var CharCategory = /* @__PURE__ */ function(CharCategory2) {
  CharCategory2[CharCategory2["Word"] = 0] = "Word";
  CharCategory2[CharCategory2["Space"] = 1] = "Space";
  CharCategory2[CharCategory2["Other"] = 2] = "Other";
  return CharCategory2;
}(CharCategory || (CharCategory = {}));
const nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let wordChar;
try {
  wordChar = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_2) {
}
function hasWordChar(str) {
  if (wordChar)
    return wordChar.test(str);
  for (let i2 = 0; i2 < str.length; i2++) {
    let ch2 = str[i2];
    if (/\w/.test(ch2) || ch2 > "\x80" && (ch2.toUpperCase() != ch2.toLowerCase() || nonASCIISingleCaseWordChar.test(ch2)))
      return true;
  }
  return false;
}
function makeCategorizer(wordChars) {
  return (char) => {
    if (!/\S/.test(char))
      return CharCategory.Space;
    if (hasWordChar(char))
      return CharCategory.Word;
    for (let i2 = 0; i2 < wordChars.length; i2++)
      if (char.indexOf(wordChars[i2]) > -1)
        return CharCategory.Word;
    return CharCategory.Other;
  };
}
class EditorState {
  constructor(config2, doc2, selection, values2, computeSlot, tr2) {
    this.config = config2;
    this.doc = doc2;
    this.selection = selection;
    this.values = values2;
    this.status = config2.statusTemplate.slice();
    this.computeSlot = computeSlot;
    if (tr2)
      tr2._state = this;
    for (let i2 = 0; i2 < this.config.dynamicSlots.length; i2++)
      ensureAddr(this, i2 << 1);
    this.computeSlot = null;
  }
  field(field, require2 = true) {
    let addr = this.config.address[field.id];
    if (addr == null) {
      if (require2)
        throw new RangeError("Field is not present in this state");
      return void 0;
    }
    ensureAddr(this, addr);
    return getAddr(this, addr);
  }
  update(...specs) {
    return resolveTransaction(this, specs, true);
  }
  applyTransaction(tr2) {
    let conf = this.config, { base: base2, compartments } = conf;
    for (let effect of tr2.effects) {
      if (effect.is(Compartment.reconfigure)) {
        if (conf) {
          compartments = new Map();
          conf.compartments.forEach((val, key) => compartments.set(key, val));
          conf = null;
        }
        compartments.set(effect.value.compartment, effect.value.extension);
      } else if (effect.is(StateEffect.reconfigure)) {
        conf = null;
        base2 = effect.value;
      } else if (effect.is(StateEffect.appendConfig)) {
        conf = null;
        base2 = asArray$1(base2).concat(effect.value);
      }
    }
    let startValues;
    if (!conf) {
      conf = Configuration.resolve(base2, compartments, this);
      let intermediateState = new EditorState(conf, this.doc, this.selection, conf.dynamicSlots.map(() => null), (state, slot) => slot.reconfigure(state, this), null);
      startValues = intermediateState.values;
    } else {
      startValues = tr2.startState.values.slice();
    }
    new EditorState(conf, tr2.newDoc, tr2.newSelection, startValues, (state, slot) => slot.update(state, tr2), tr2);
  }
  replaceSelection(text) {
    if (typeof text == "string")
      text = this.toText(text);
    return this.changeByRange((range3) => ({
      changes: { from: range3.from, to: range3.to, insert: text },
      range: EditorSelection.cursor(range3.from + text.length)
    }));
  }
  changeByRange(f2) {
    let sel = this.selection;
    let result1 = f2(sel.ranges[0]);
    let changes = this.changes(result1.changes), ranges = [result1.range];
    let effects = asArray$1(result1.effects);
    for (let i2 = 1; i2 < sel.ranges.length; i2++) {
      let result2 = f2(sel.ranges[i2]);
      let newChanges = this.changes(result2.changes), newMapped = newChanges.map(changes);
      for (let j2 = 0; j2 < i2; j2++)
        ranges[j2] = ranges[j2].map(newMapped);
      let mapBy = changes.mapDesc(newChanges, true);
      ranges.push(result2.range.map(mapBy));
      changes = changes.compose(newMapped);
      effects = StateEffect.mapEffects(effects, newMapped).concat(StateEffect.mapEffects(asArray$1(result2.effects), mapBy));
    }
    return {
      changes,
      selection: EditorSelection.create(ranges, sel.mainIndex),
      effects
    };
  }
  changes(spec2 = []) {
    if (spec2 instanceof ChangeSet)
      return spec2;
    return ChangeSet.of(spec2, this.doc.length, this.facet(EditorState.lineSeparator));
  }
  toText(string3) {
    return Text.of(string3.split(this.facet(EditorState.lineSeparator) || DefaultSplit));
  }
  sliceDoc(from = 0, to2 = this.doc.length) {
    return this.doc.sliceString(from, to2, this.lineBreak);
  }
  facet(facet) {
    let addr = this.config.address[facet.id];
    if (addr == null)
      return facet.default;
    ensureAddr(this, addr);
    return getAddr(this, addr);
  }
  toJSON(fields) {
    let result2 = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (fields)
      for (let prop in fields) {
        let value2 = fields[prop];
        if (value2 instanceof StateField && this.config.address[value2.id] != null)
          result2[prop] = value2.spec.toJSON(this.field(fields[prop]), this);
      }
    return result2;
  }
  static fromJSON(json2, config2 = {}, fields) {
    if (!json2 || typeof json2.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let fieldInit = [];
    if (fields)
      for (let prop in fields) {
        if (Object.prototype.hasOwnProperty.call(json2, prop)) {
          let field = fields[prop], value2 = json2[prop];
          fieldInit.push(field.init((state) => field.spec.fromJSON(value2, state)));
        }
      }
    return EditorState.create({
      doc: json2.doc,
      selection: EditorSelection.fromJSON(json2.selection),
      extensions: config2.extensions ? fieldInit.concat([config2.extensions]) : fieldInit
    });
  }
  static create(config2 = {}) {
    let configuration = Configuration.resolve(config2.extensions || [], new Map());
    let doc2 = config2.doc instanceof Text ? config2.doc : Text.of((config2.doc || "").split(configuration.staticFacet(EditorState.lineSeparator) || DefaultSplit));
    let selection = !config2.selection ? EditorSelection.single(0) : config2.selection instanceof EditorSelection ? config2.selection : EditorSelection.single(config2.selection.anchor, config2.selection.head);
    checkSelection(selection, doc2.length);
    if (!configuration.staticFacet(allowMultipleSelections))
      selection = selection.asSingle();
    return new EditorState(configuration, doc2, selection, configuration.dynamicSlots.map(() => null), (state, slot) => slot.create(state), null);
  }
  get tabSize() {
    return this.facet(EditorState.tabSize);
  }
  get lineBreak() {
    return this.facet(EditorState.lineSeparator) || "\n";
  }
  get readOnly() {
    return this.facet(readOnly);
  }
  phrase(phrase2, ...insert2) {
    for (let map2 of this.facet(EditorState.phrases))
      if (Object.prototype.hasOwnProperty.call(map2, phrase2)) {
        phrase2 = map2[phrase2];
        break;
      }
    if (insert2.length)
      phrase2 = phrase2.replace(/\$(\$|\d*)/g, (m2, i2) => {
        if (i2 == "$")
          return "$";
        let n2 = +(i2 || 1);
        return !n2 || n2 > insert2.length ? m2 : insert2[n2 - 1];
      });
    return phrase2;
  }
  languageDataAt(name2, pos, side = -1) {
    let values2 = [];
    for (let provider of this.facet(languageData)) {
      for (let result2 of provider(this, pos, side)) {
        if (Object.prototype.hasOwnProperty.call(result2, name2))
          values2.push(result2[name2]);
      }
    }
    return values2;
  }
  charCategorizer(at2) {
    return makeCategorizer(this.languageDataAt("wordChars", at2).join(""));
  }
  wordAt(pos) {
    let { text, from, length: length2 } = this.doc.lineAt(pos);
    let cat = this.charCategorizer(pos);
    let start = pos - from, end = pos - from;
    while (start > 0) {
      let prev = findClusterBreak(text, start, false);
      if (cat(text.slice(prev, start)) != CharCategory.Word)
        break;
      start = prev;
    }
    while (end < length2) {
      let next = findClusterBreak(text, end);
      if (cat(text.slice(end, next)) != CharCategory.Word)
        break;
      end = next;
    }
    return start == end ? null : EditorSelection.range(start + from, end + from);
  }
}
EditorState.allowMultipleSelections = allowMultipleSelections;
EditorState.tabSize = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.length ? values2[0] : 4
});
EditorState.lineSeparator = lineSeparator;
EditorState.readOnly = readOnly;
EditorState.phrases = /* @__PURE__ */ Facet.define({
  compare(a2, b2) {
    let kA2 = Object.keys(a2), kB2 = Object.keys(b2);
    return kA2.length == kB2.length && kA2.every((k2) => a2[k2] == b2[k2]);
  }
});
EditorState.languageData = languageData;
EditorState.changeFilter = changeFilter;
EditorState.transactionFilter = transactionFilter;
EditorState.transactionExtender = transactionExtender;
Compartment.reconfigure = /* @__PURE__ */ StateEffect.define();
function combineConfig(configs, defaults2, combine = {}) {
  let result2 = {};
  for (let config2 of configs)
    for (let key of Object.keys(config2)) {
      let value2 = config2[key], current = result2[key];
      if (current === void 0)
        result2[key] = value2;
      else if (current === value2 || value2 === void 0)
        ;
      else if (Object.hasOwnProperty.call(combine, key))
        result2[key] = combine[key](current, value2);
      else
        throw new Error("Config merge conflict for field " + key);
    }
  for (let key in defaults2)
    if (result2[key] === void 0)
      result2[key] = defaults2[key];
  return result2;
}
class RangeValue {
  eq(other) {
    return this == other;
  }
  range(from, to2 = from) {
    return Range.create(from, to2, this);
  }
}
RangeValue.prototype.startSide = RangeValue.prototype.endSide = 0;
RangeValue.prototype.point = false;
RangeValue.prototype.mapMode = MapMode.TrackDel;
class Range {
  constructor(from, to2, value2) {
    this.from = from;
    this.to = to2;
    this.value = value2;
  }
  static create(from, to2, value2) {
    return new Range(from, to2, value2);
  }
}
function cmpRange(a2, b2) {
  return a2.from - b2.from || a2.value.startSide - b2.value.startSide;
}
class Chunk {
  constructor(from, to2, value2, maxPoint) {
    this.from = from;
    this.to = to2;
    this.value = value2;
    this.maxPoint = maxPoint;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  findIndex(pos, side, end, startAt = 0) {
    let arr = end ? this.to : this.from;
    for (let lo2 = startAt, hi2 = arr.length; ; ) {
      if (lo2 == hi2)
        return lo2;
      let mid = lo2 + hi2 >> 1;
      let diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
      if (mid == lo2)
        return diff >= 0 ? lo2 : hi2;
      if (diff >= 0)
        hi2 = mid;
      else
        lo2 = mid + 1;
    }
  }
  between(offset, from, to2, f2) {
    for (let i2 = this.findIndex(from, -1e9, true), e25 = this.findIndex(to2, 1e9, false, i2); i2 < e25; i2++)
      if (f2(this.from[i2] + offset, this.to[i2] + offset, this.value[i2]) === false)
        return false;
  }
  map(offset, changes) {
    let value2 = [], from = [], to2 = [], newPos = -1, maxPoint = -1;
    for (let i2 = 0; i2 < this.value.length; i2++) {
      let val = this.value[i2], curFrom = this.from[i2] + offset, curTo = this.to[i2] + offset, newFrom, newTo;
      if (curFrom == curTo) {
        let mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
        if (mapped == null)
          continue;
        newFrom = newTo = mapped;
        if (val.startSide != val.endSide) {
          newTo = changes.mapPos(curFrom, val.endSide);
          if (newTo < newFrom)
            continue;
        }
      } else {
        newFrom = changes.mapPos(curFrom, val.startSide);
        newTo = changes.mapPos(curTo, val.endSide);
        if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0)
          continue;
      }
      if ((newTo - newFrom || val.endSide - val.startSide) < 0)
        continue;
      if (newPos < 0)
        newPos = newFrom;
      if (val.point)
        maxPoint = Math.max(maxPoint, newTo - newFrom);
      value2.push(val);
      from.push(newFrom - newPos);
      to2.push(newTo - newPos);
    }
    return { mapped: value2.length ? new Chunk(from, to2, value2, maxPoint) : null, pos: newPos };
  }
}
class RangeSet {
  constructor(chunkPos, chunk, nextLayer, maxPoint) {
    this.chunkPos = chunkPos;
    this.chunk = chunk;
    this.nextLayer = nextLayer;
    this.maxPoint = maxPoint;
  }
  static create(chunkPos, chunk, nextLayer, maxPoint) {
    return new RangeSet(chunkPos, chunk, nextLayer, maxPoint);
  }
  get length() {
    let last = this.chunk.length - 1;
    return last < 0 ? 0 : Math.max(this.chunkEnd(last), this.nextLayer.length);
  }
  get size() {
    if (this.isEmpty)
      return 0;
    let size2 = this.nextLayer.size;
    for (let chunk of this.chunk)
      size2 += chunk.value.length;
    return size2;
  }
  chunkEnd(index2) {
    return this.chunkPos[index2] + this.chunk[index2].length;
  }
  update(updateSpec) {
    let { add: add2 = [], sort = false, filterFrom = 0, filterTo = this.length } = updateSpec;
    let filter = updateSpec.filter;
    if (add2.length == 0 && !filter)
      return this;
    if (sort)
      add2 = add2.slice().sort(cmpRange);
    if (this.isEmpty)
      return add2.length ? RangeSet.of(add2) : this;
    let cur2 = new LayerCursor(this, null, -1).goto(0), i2 = 0, spill = [];
    let builder = new RangeSetBuilder();
    while (cur2.value || i2 < add2.length) {
      if (i2 < add2.length && (cur2.from - add2[i2].from || cur2.startSide - add2[i2].value.startSide) >= 0) {
        let range3 = add2[i2++];
        if (!builder.addInner(range3.from, range3.to, range3.value))
          spill.push(range3);
      } else if (cur2.rangeIndex == 1 && cur2.chunkIndex < this.chunk.length && (i2 == add2.length || this.chunkEnd(cur2.chunkIndex) < add2[i2].from) && (!filter || filterFrom > this.chunkEnd(cur2.chunkIndex) || filterTo < this.chunkPos[cur2.chunkIndex]) && builder.addChunk(this.chunkPos[cur2.chunkIndex], this.chunk[cur2.chunkIndex])) {
        cur2.nextChunk();
      } else {
        if (!filter || filterFrom > cur2.to || filterTo < cur2.from || filter(cur2.from, cur2.to, cur2.value)) {
          if (!builder.addInner(cur2.from, cur2.to, cur2.value))
            spill.push(Range.create(cur2.from, cur2.to, cur2.value));
        }
        cur2.next();
      }
    }
    return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? RangeSet.empty : this.nextLayer.update({ add: spill, filter, filterFrom, filterTo }));
  }
  map(changes) {
    if (changes.empty || this.isEmpty)
      return this;
    let chunks = [], chunkPos = [], maxPoint = -1;
    for (let i2 = 0; i2 < this.chunk.length; i2++) {
      let start = this.chunkPos[i2], chunk = this.chunk[i2];
      let touch = changes.touchesRange(start, start + chunk.length);
      if (touch === false) {
        maxPoint = Math.max(maxPoint, chunk.maxPoint);
        chunks.push(chunk);
        chunkPos.push(changes.mapPos(start));
      } else if (touch === true) {
        let { mapped, pos } = chunk.map(start, changes);
        if (mapped) {
          maxPoint = Math.max(maxPoint, mapped.maxPoint);
          chunks.push(mapped);
          chunkPos.push(pos);
        }
      }
    }
    let next = this.nextLayer.map(changes);
    return chunks.length == 0 ? next : new RangeSet(chunkPos, chunks, next || RangeSet.empty, maxPoint);
  }
  between(from, to2, f2) {
    if (this.isEmpty)
      return;
    for (let i2 = 0; i2 < this.chunk.length; i2++) {
      let start = this.chunkPos[i2], chunk = this.chunk[i2];
      if (to2 >= start && from <= start + chunk.length && chunk.between(start, from - start, to2 - start, f2) === false)
        return;
    }
    this.nextLayer.between(from, to2, f2);
  }
  iter(from = 0) {
    return HeapCursor.from([this]).goto(from);
  }
  get isEmpty() {
    return this.nextLayer == this;
  }
  static iter(sets, from = 0) {
    return HeapCursor.from(sets).goto(from);
  }
  static compare(oldSets, newSets, textDiff, comparator, minPointSize = -1) {
    let a2 = oldSets.filter((set2) => set2.maxPoint > 0 || !set2.isEmpty && set2.maxPoint >= minPointSize);
    let b2 = newSets.filter((set2) => set2.maxPoint > 0 || !set2.isEmpty && set2.maxPoint >= minPointSize);
    let sharedChunks = findSharedChunks(a2, b2, textDiff);
    let sideA = new SpanCursor(a2, sharedChunks, minPointSize);
    let sideB = new SpanCursor(b2, sharedChunks, minPointSize);
    textDiff.iterGaps((fromA, fromB, length2) => compare$1(sideA, fromA, sideB, fromB, length2, comparator));
    if (textDiff.empty && textDiff.length == 0)
      compare$1(sideA, 0, sideB, 0, 0, comparator);
  }
  static eq(oldSets, newSets, from = 0, to2) {
    if (to2 == null)
      to2 = 1e9 - 1;
    let a2 = oldSets.filter((set2) => !set2.isEmpty && newSets.indexOf(set2) < 0);
    let b2 = newSets.filter((set2) => !set2.isEmpty && oldSets.indexOf(set2) < 0);
    if (a2.length != b2.length)
      return false;
    if (!a2.length)
      return true;
    let sharedChunks = findSharedChunks(a2, b2);
    let sideA = new SpanCursor(a2, sharedChunks, 0).goto(from), sideB = new SpanCursor(b2, sharedChunks, 0).goto(from);
    for (; ; ) {
      if (sideA.to != sideB.to || !sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !sideA.point.eq(sideB.point)))
        return false;
      if (sideA.to > to2)
        return true;
      sideA.next();
      sideB.next();
    }
  }
  static spans(sets, from, to2, iterator, minPointSize = -1) {
    let cursor = new SpanCursor(sets, null, minPointSize).goto(from), pos = from;
    let openRanges = cursor.openStart;
    for (; ; ) {
      let curTo = Math.min(cursor.to, to2);
      if (cursor.point) {
        let active = cursor.activeForPoint(cursor.to);
        let openCount = cursor.pointFrom < from ? active.length + 1 : Math.min(active.length, openRanges);
        iterator.point(pos, curTo, cursor.point, active, openCount, cursor.pointRank);
        openRanges = Math.min(cursor.openEnd(curTo), active.length);
      } else if (curTo > pos) {
        iterator.span(pos, curTo, cursor.active, openRanges);
        openRanges = cursor.openEnd(curTo);
      }
      if (cursor.to > to2)
        return openRanges + (cursor.point && cursor.to > to2 ? 1 : 0);
      pos = cursor.to;
      cursor.next();
    }
  }
  static of(ranges, sort = false) {
    let build = new RangeSetBuilder();
    for (let range3 of ranges instanceof Range ? [ranges] : sort ? lazySort(ranges) : ranges)
      build.add(range3.from, range3.to, range3.value);
    return build.finish();
  }
}
RangeSet.empty = /* @__PURE__ */ new RangeSet([], [], null, -1);
function lazySort(ranges) {
  if (ranges.length > 1)
    for (let prev = ranges[0], i2 = 1; i2 < ranges.length; i2++) {
      let cur2 = ranges[i2];
      if (cmpRange(prev, cur2) > 0)
        return ranges.slice().sort(cmpRange);
      prev = cur2;
    }
  return ranges;
}
RangeSet.empty.nextLayer = RangeSet.empty;
class RangeSetBuilder {
  finishChunk(newArrays) {
    this.chunks.push(new Chunk(this.from, this.to, this.value, this.maxPoint));
    this.chunkPos.push(this.chunkStart);
    this.chunkStart = -1;
    this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
    this.maxPoint = -1;
    if (newArrays) {
      this.from = [];
      this.to = [];
      this.value = [];
    }
  }
  constructor() {
    this.chunks = [];
    this.chunkPos = [];
    this.chunkStart = -1;
    this.last = null;
    this.lastFrom = -1e9;
    this.lastTo = -1e9;
    this.from = [];
    this.to = [];
    this.value = [];
    this.maxPoint = -1;
    this.setMaxPoint = -1;
    this.nextLayer = null;
  }
  add(from, to2, value2) {
    if (!this.addInner(from, to2, value2))
      (this.nextLayer || (this.nextLayer = new RangeSetBuilder())).add(from, to2, value2);
  }
  addInner(from, to2, value2) {
    let diff = from - this.lastTo || value2.startSide - this.last.endSide;
    if (diff <= 0 && (from - this.lastFrom || value2.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    if (diff < 0)
      return false;
    if (this.from.length == 250)
      this.finishChunk(true);
    if (this.chunkStart < 0)
      this.chunkStart = from;
    this.from.push(from - this.chunkStart);
    this.to.push(to2 - this.chunkStart);
    this.last = value2;
    this.lastFrom = from;
    this.lastTo = to2;
    this.value.push(value2);
    if (value2.point)
      this.maxPoint = Math.max(this.maxPoint, to2 - from);
    return true;
  }
  addChunk(from, chunk) {
    if ((from - this.lastTo || chunk.value[0].startSide - this.last.endSide) < 0)
      return false;
    if (this.from.length)
      this.finishChunk(true);
    this.setMaxPoint = Math.max(this.setMaxPoint, chunk.maxPoint);
    this.chunks.push(chunk);
    this.chunkPos.push(from);
    let last = chunk.value.length - 1;
    this.last = chunk.value[last];
    this.lastFrom = chunk.from[last] + from;
    this.lastTo = chunk.to[last] + from;
    return true;
  }
  finish() {
    return this.finishInner(RangeSet.empty);
  }
  finishInner(next) {
    if (this.from.length)
      this.finishChunk(false);
    if (this.chunks.length == 0)
      return next;
    let result2 = RangeSet.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
    this.from = null;
    return result2;
  }
}
function findSharedChunks(a2, b2, textDiff) {
  let inA = new Map();
  for (let set2 of a2)
    for (let i2 = 0; i2 < set2.chunk.length; i2++)
      if (set2.chunk[i2].maxPoint <= 0)
        inA.set(set2.chunk[i2], set2.chunkPos[i2]);
  let shared = new Set();
  for (let set2 of b2)
    for (let i2 = 0; i2 < set2.chunk.length; i2++) {
      let known = inA.get(set2.chunk[i2]);
      if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set2.chunkPos[i2] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set2.chunk[i2].length)))
        shared.add(set2.chunk[i2]);
    }
  return shared;
}
class LayerCursor {
  constructor(layer2, skip, minPoint, rank = 0) {
    this.layer = layer2;
    this.skip = skip;
    this.minPoint = minPoint;
    this.rank = rank;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(pos, side = -1e9) {
    this.chunkIndex = this.rangeIndex = 0;
    this.gotoInner(pos, side, false);
    return this;
  }
  gotoInner(pos, side, forward) {
    while (this.chunkIndex < this.layer.chunk.length) {
      let next = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint))
        break;
      this.chunkIndex++;
      forward = false;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
      if (!forward || this.rangeIndex < rangeIndex)
        this.setRangeIndex(rangeIndex);
    }
    this.next();
  }
  forward(pos, side) {
    if ((this.to - pos || this.endSide - side) < 0)
      this.gotoInner(pos, side, true);
  }
  next() {
    for (; ; ) {
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9;
        this.value = null;
        break;
      } else {
        let chunkPos = this.layer.chunkPos[this.chunkIndex], chunk = this.layer.chunk[this.chunkIndex];
        let from = chunkPos + chunk.from[this.rangeIndex];
        this.from = from;
        this.to = chunkPos + chunk.to[this.rangeIndex];
        this.value = chunk.value[this.rangeIndex];
        this.setRangeIndex(this.rangeIndex + 1);
        if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
    }
  }
  setRangeIndex(index2) {
    if (index2 == this.layer.chunk[this.chunkIndex].value.length) {
      this.chunkIndex++;
      if (this.skip) {
        while (this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))
          this.chunkIndex++;
      }
      this.rangeIndex = 0;
    } else {
      this.rangeIndex = index2;
    }
  }
  nextChunk() {
    this.chunkIndex++;
    this.rangeIndex = 0;
    this.next();
  }
  compare(other) {
    return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
  }
}
class HeapCursor {
  constructor(heap) {
    this.heap = heap;
  }
  static from(sets, skip = null, minPoint = -1) {
    let heap = [];
    for (let i2 = 0; i2 < sets.length; i2++) {
      for (let cur2 = sets[i2]; !cur2.isEmpty; cur2 = cur2.nextLayer) {
        if (cur2.maxPoint >= minPoint)
          heap.push(new LayerCursor(cur2, skip, minPoint, i2));
      }
    }
    return heap.length == 1 ? heap[0] : new HeapCursor(heap);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(pos, side = -1e9) {
    for (let cur2 of this.heap)
      cur2.goto(pos, side);
    for (let i2 = this.heap.length >> 1; i2 >= 0; i2--)
      heapBubble(this.heap, i2);
    this.next();
    return this;
  }
  forward(pos, side) {
    for (let cur2 of this.heap)
      cur2.forward(pos, side);
    for (let i2 = this.heap.length >> 1; i2 >= 0; i2--)
      heapBubble(this.heap, i2);
    if ((this.to - pos || this.value.endSide - side) < 0)
      this.next();
  }
  next() {
    if (this.heap.length == 0) {
      this.from = this.to = 1e9;
      this.value = null;
      this.rank = -1;
    } else {
      let top2 = this.heap[0];
      this.from = top2.from;
      this.to = top2.to;
      this.value = top2.value;
      this.rank = top2.rank;
      if (top2.value)
        top2.next();
      heapBubble(this.heap, 0);
    }
  }
}
function heapBubble(heap, index2) {
  for (let cur2 = heap[index2]; ; ) {
    let childIndex = (index2 << 1) + 1;
    if (childIndex >= heap.length)
      break;
    let child = heap[childIndex];
    if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
      child = heap[childIndex + 1];
      childIndex++;
    }
    if (cur2.compare(child) < 0)
      break;
    heap[childIndex] = cur2;
    heap[index2] = child;
    index2 = childIndex;
  }
}
class SpanCursor {
  constructor(sets, skip, minPoint) {
    this.minPoint = minPoint;
    this.active = [];
    this.activeTo = [];
    this.activeRank = [];
    this.minActive = -1;
    this.point = null;
    this.pointFrom = 0;
    this.pointRank = 0;
    this.to = -1e9;
    this.endSide = 0;
    this.openStart = -1;
    this.cursor = HeapCursor.from(sets, skip, minPoint);
  }
  goto(pos, side = -1e9) {
    this.cursor.goto(pos, side);
    this.active.length = this.activeTo.length = this.activeRank.length = 0;
    this.minActive = -1;
    this.to = pos;
    this.endSide = side;
    this.openStart = -1;
    this.next();
    return this;
  }
  forward(pos, side) {
    while (this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)
      this.removeActive(this.minActive);
    this.cursor.forward(pos, side);
  }
  removeActive(index2) {
    remove(this.active, index2);
    remove(this.activeTo, index2);
    remove(this.activeRank, index2);
    this.minActive = findMinIndex(this.active, this.activeTo);
  }
  addActive(trackOpen) {
    let i2 = 0, { value: value2, to: to2, rank } = this.cursor;
    while (i2 < this.activeRank.length && this.activeRank[i2] <= rank)
      i2++;
    insert(this.active, i2, value2);
    insert(this.activeTo, i2, to2);
    insert(this.activeRank, i2, rank);
    if (trackOpen)
      insert(trackOpen, i2, this.cursor.from);
    this.minActive = findMinIndex(this.active, this.activeTo);
  }
  next() {
    let from = this.to, wasPoint = this.point;
    this.point = null;
    let trackOpen = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let a2 = this.minActive;
      if (a2 > -1 && (this.activeTo[a2] - this.cursor.from || this.active[a2].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[a2] > from) {
          this.to = this.activeTo[a2];
          this.endSide = this.active[a2].endSide;
          break;
        }
        this.removeActive(a2);
        if (trackOpen)
          remove(trackOpen, a2);
      } else if (!this.cursor.value) {
        this.to = this.endSide = 1e9;
        break;
      } else if (this.cursor.from > from) {
        this.to = this.cursor.from;
        this.endSide = this.cursor.startSide;
        break;
      } else {
        let nextVal = this.cursor.value;
        if (!nextVal.point) {
          this.addActive(trackOpen);
          this.cursor.next();
        } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) {
          this.cursor.next();
        } else {
          this.point = nextVal;
          this.pointFrom = this.cursor.from;
          this.pointRank = this.cursor.rank;
          this.to = this.cursor.to;
          this.endSide = nextVal.endSide;
          this.cursor.next();
          this.forward(this.to, this.endSide);
          break;
        }
      }
    }
    if (trackOpen) {
      this.openStart = 0;
      for (let i2 = trackOpen.length - 1; i2 >= 0 && trackOpen[i2] < from; i2--)
        this.openStart++;
    }
  }
  activeForPoint(to2) {
    if (!this.active.length)
      return this.active;
    let active = [];
    for (let i2 = this.active.length - 1; i2 >= 0; i2--) {
      if (this.activeRank[i2] < this.pointRank)
        break;
      if (this.activeTo[i2] > to2 || this.activeTo[i2] == to2 && this.active[i2].endSide >= this.point.endSide)
        active.push(this.active[i2]);
    }
    return active.reverse();
  }
  openEnd(to2) {
    let open = 0;
    for (let i2 = this.activeTo.length - 1; i2 >= 0 && this.activeTo[i2] > to2; i2--)
      open++;
    return open;
  }
}
function compare$1(a2, startA, b2, startB, length2, comparator) {
  a2.goto(startA);
  b2.goto(startB);
  let endB = startB + length2;
  let pos = startB, dPos = startB - startA;
  for (; ; ) {
    let diff = a2.to + dPos - b2.to || a2.endSide - b2.endSide;
    let end = diff < 0 ? a2.to + dPos : b2.to, clipEnd = Math.min(end, endB);
    if (a2.point || b2.point) {
      if (!(a2.point && b2.point && (a2.point == b2.point || a2.point.eq(b2.point)) && sameValues(a2.activeForPoint(a2.to), b2.activeForPoint(b2.to))))
        comparator.comparePoint(pos, clipEnd, a2.point, b2.point);
    } else {
      if (clipEnd > pos && !sameValues(a2.active, b2.active))
        comparator.compareRange(pos, clipEnd, a2.active, b2.active);
    }
    if (end > endB)
      break;
    pos = end;
    if (diff <= 0)
      a2.next();
    if (diff >= 0)
      b2.next();
  }
}
function sameValues(a2, b2) {
  if (a2.length != b2.length)
    return false;
  for (let i2 = 0; i2 < a2.length; i2++)
    if (a2[i2] != b2[i2] && !a2[i2].eq(b2[i2]))
      return false;
  return true;
}
function remove(array4, index2) {
  for (let i2 = index2, e25 = array4.length - 1; i2 < e25; i2++)
    array4[i2] = array4[i2 + 1];
  array4.pop();
}
function insert(array4, index2, value2) {
  for (let i2 = array4.length - 1; i2 >= index2; i2--)
    array4[i2 + 1] = array4[i2];
  array4[index2] = value2;
}
function findMinIndex(value2, array4) {
  let found = -1, foundPos = 1e9;
  for (let i2 = 0; i2 < array4.length; i2++)
    if ((array4[i2] - foundPos || value2[i2].endSide - value2[found].endSide) < 0) {
      found = i2;
      foundPos = array4[i2];
    }
  return found;
}
function countColumn(string3, tabSize, to2 = string3.length) {
  let n2 = 0;
  for (let i2 = 0; i2 < to2; ) {
    if (string3.charCodeAt(i2) == 9) {
      n2 += tabSize - n2 % tabSize;
      i2++;
    } else {
      n2++;
      i2 = findClusterBreak(string3, i2);
    }
  }
  return n2;
}
function findColumn(string3, col, tabSize, strict) {
  for (let i2 = 0, n2 = 0; ; ) {
    if (n2 >= col)
      return i2;
    if (i2 == string3.length)
      break;
    n2 += string3.charCodeAt(i2) == 9 ? tabSize - n2 % tabSize : 1;
    i2 = findClusterBreak(string3, i2);
  }
  return strict === true ? -1 : string3.length;
}
const C$1 = "\u037C";
const COUNT = typeof Symbol == "undefined" ? "__" + C$1 : Symbol.for(C$1);
const SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet");
const top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class StyleModule {
  constructor(spec2, options) {
    this.rules = [];
    let { finish } = options || {};
    function splitSelector(selector2) {
      return /^@/.test(selector2) ? [selector2] : selector2.split(/,\s*/);
    }
    function render2(selectors, spec3, target, isKeyframes) {
      let local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
      if (isAt && spec3 == null)
        return target.push(selectors[0] + ";");
      for (let prop in spec3) {
        let value2 = spec3[prop];
        if (/&/.test(prop)) {
          render2(prop.split(/,\s*/).map((part) => selectors.map((sel) => part.replace(/&/, sel))).reduce((a2, b2) => a2.concat(b2)), value2, target);
        } else if (value2 && typeof value2 == "object") {
          if (!isAt)
            throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
          render2(splitSelector(prop), value2, local, keyframes);
        } else if (value2 != null) {
          local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l2) => "-" + l2.toLowerCase()) + ": " + value2 + ";");
        }
      }
      if (local.length || keyframes) {
        target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
      }
    }
    for (let prop in spec2)
      render2(splitSelector(prop), spec2[prop], this.rules);
  }
  getRules() {
    return this.rules.join("\n");
  }
  static newName() {
    let id2 = top[COUNT] || 1;
    top[COUNT] = id2 + 1;
    return C$1 + id2.toString(36);
  }
  static mount(root2, modules) {
    (root2[SET] || new StyleSet(root2)).mount(Array.isArray(modules) ? modules : [modules]);
  }
}
let adoptedSet = new Map();
class StyleSet {
  constructor(root2) {
    let doc2 = root2.ownerDocument || root2, win = doc2.defaultView;
    if (!root2.head && root2.adoptedStyleSheets && win.CSSStyleSheet) {
      let adopted = adoptedSet.get(doc2);
      if (adopted) {
        root2.adoptedStyleSheets = [adopted.sheet, ...root2.adoptedStyleSheets];
        return root2[SET] = adopted;
      }
      this.sheet = new win.CSSStyleSheet();
      root2.adoptedStyleSheets = [this.sheet, ...root2.adoptedStyleSheets];
      adoptedSet.set(doc2, this);
    } else {
      this.styleTag = doc2.createElement("style");
      let target = root2.head || root2;
      target.insertBefore(this.styleTag, target.firstChild);
    }
    this.modules = [];
    root2[SET] = this;
  }
  mount(modules) {
    let sheet = this.sheet;
    let pos = 0, j2 = 0;
    for (let i2 = 0; i2 < modules.length; i2++) {
      let mod = modules[i2], index2 = this.modules.indexOf(mod);
      if (index2 < j2 && index2 > -1) {
        this.modules.splice(index2, 1);
        j2--;
        index2 = -1;
      }
      if (index2 == -1) {
        this.modules.splice(j2++, 0, mod);
        if (sheet)
          for (let k2 = 0; k2 < mod.rules.length; k2++)
            sheet.insertRule(mod.rules[k2], pos++);
      } else {
        while (j2 < index2)
          pos += this.modules[j2++].rules.length;
        pos += mod.rules.length;
        j2++;
      }
    }
    if (!sheet) {
      let text = "";
      for (let i2 = 0; i2 < this.modules.length; i2++)
        text += this.modules[i2].getRules() + "\n";
      this.styleTag.textContent = text;
    }
  }
}
var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
};
var shift = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
};
var mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var ie$2 = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var i$1 = 0; i$1 < 10; i$1++)
  base[48 + i$1] = base[96 + i$1] = String(i$1);
for (var i$1 = 1; i$1 <= 24; i$1++)
  base[i$1 + 111] = "F" + i$1;
for (var i$1 = 65; i$1 <= 90; i$1++) {
  base[i$1] = String.fromCharCode(i$1 + 32);
  shift[i$1] = String.fromCharCode(i$1);
}
for (var code in base)
  if (!shift.hasOwnProperty(code))
    shift[code] = base[code];
function keyName(event) {
  var ignoreKey = mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || ie$2 && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
  var name2 = !ignoreKey && event.key || (event.shiftKey ? shift : base)[event.keyCode] || event.key || "Unidentified";
  if (name2 == "Esc")
    name2 = "Escape";
  if (name2 == "Del")
    name2 = "Delete";
  if (name2 == "Left")
    name2 = "ArrowLeft";
  if (name2 == "Up")
    name2 = "ArrowUp";
  if (name2 == "Right")
    name2 = "ArrowRight";
  if (name2 == "Down")
    name2 = "ArrowDown";
  return name2;
}
function getSelection(root2) {
  let target;
  if (root2.nodeType == 11) {
    target = root2.getSelection ? root2 : root2.ownerDocument;
  } else {
    target = root2;
  }
  return target.getSelection();
}
function contains(dom, node2) {
  return node2 ? dom == node2 || dom.contains(node2.nodeType != 1 ? node2.parentNode : node2) : false;
}
function deepActiveElement(doc2) {
  let elt = doc2.activeElement;
  while (elt && elt.shadowRoot)
    elt = elt.shadowRoot.activeElement;
  return elt;
}
function hasSelection(dom, selection) {
  if (!selection.anchorNode)
    return false;
  try {
    return contains(dom, selection.anchorNode);
  } catch (_2) {
    return false;
  }
}
function clientRectsFor(dom) {
  if (dom.nodeType == 3)
    return textRange(dom, 0, dom.nodeValue.length).getClientRects();
  else if (dom.nodeType == 1)
    return dom.getClientRects();
  else
    return [];
}
function isEquivalentPosition(node2, off2, targetNode, targetOff) {
  return targetNode ? scanFor(node2, off2, targetNode, targetOff, -1) || scanFor(node2, off2, targetNode, targetOff, 1) : false;
}
function domIndex(node2) {
  for (var index2 = 0; ; index2++) {
    node2 = node2.previousSibling;
    if (!node2)
      return index2;
  }
}
function scanFor(node2, off2, targetNode, targetOff, dir) {
  for (; ; ) {
    if (node2 == targetNode && off2 == targetOff)
      return true;
    if (off2 == (dir < 0 ? 0 : maxOffset(node2))) {
      if (node2.nodeName == "DIV")
        return false;
      let parent = node2.parentNode;
      if (!parent || parent.nodeType != 1)
        return false;
      off2 = domIndex(node2) + (dir < 0 ? 0 : 1);
      node2 = parent;
    } else if (node2.nodeType == 1) {
      node2 = node2.childNodes[off2 + (dir < 0 ? -1 : 0)];
      if (node2.nodeType == 1 && node2.contentEditable == "false")
        return false;
      off2 = dir < 0 ? maxOffset(node2) : 0;
    } else {
      return false;
    }
  }
}
function maxOffset(node2) {
  return node2.nodeType == 3 ? node2.nodeValue.length : node2.childNodes.length;
}
function flattenRect(rect, left) {
  let x2 = left ? rect.left : rect.right;
  return { left: x2, right: x2, top: rect.top, bottom: rect.bottom };
}
function windowRect(win) {
  return {
    left: 0,
    right: win.innerWidth,
    top: 0,
    bottom: win.innerHeight
  };
}
function scrollRectIntoView(dom, rect, side, x2, y2, xMargin, yMargin, ltr) {
  let doc2 = dom.ownerDocument, win = doc2.defaultView || window;
  for (let cur2 = dom, stop = false; cur2 && !stop; ) {
    if (cur2.nodeType == 1) {
      let bounding, top2 = cur2 == doc2.body;
      if (top2) {
        bounding = windowRect(win);
      } else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(cur2).position))
          stop = true;
        if (cur2.scrollHeight <= cur2.clientHeight && cur2.scrollWidth <= cur2.clientWidth) {
          cur2 = cur2.assignedSlot || cur2.parentNode;
          continue;
        }
        let rect2 = cur2.getBoundingClientRect();
        bounding = {
          left: rect2.left,
          right: rect2.left + cur2.clientWidth,
          top: rect2.top,
          bottom: rect2.top + cur2.clientHeight
        };
      }
      let moveX = 0, moveY = 0;
      if (y2 == "nearest") {
        if (rect.top < bounding.top) {
          moveY = -(bounding.top - rect.top + yMargin);
          if (side > 0 && rect.bottom > bounding.bottom + moveY)
            moveY = rect.bottom - bounding.bottom + moveY + yMargin;
        } else if (rect.bottom > bounding.bottom) {
          moveY = rect.bottom - bounding.bottom + yMargin;
          if (side < 0 && rect.top - moveY < bounding.top)
            moveY = -(bounding.top + moveY - rect.top + yMargin);
        }
      } else {
        let rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
        let targetTop = y2 == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y2 == "start" || y2 == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
        moveY = targetTop - bounding.top;
      }
      if (x2 == "nearest") {
        if (rect.left < bounding.left) {
          moveX = -(bounding.left - rect.left + xMargin);
          if (side > 0 && rect.right > bounding.right + moveX)
            moveX = rect.right - bounding.right + moveX + xMargin;
        } else if (rect.right > bounding.right) {
          moveX = rect.right - bounding.right + xMargin;
          if (side < 0 && rect.left < bounding.left + moveX)
            moveX = -(bounding.left + moveX - rect.left + xMargin);
        }
      } else {
        let targetLeft = x2 == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x2 == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
        moveX = targetLeft - bounding.left;
      }
      if (moveX || moveY) {
        if (top2) {
          win.scrollBy(moveX, moveY);
        } else {
          let movedX = 0, movedY = 0;
          if (moveY) {
            let start = cur2.scrollTop;
            cur2.scrollTop += moveY;
            movedY = cur2.scrollTop - start;
          }
          if (moveX) {
            let start = cur2.scrollLeft;
            cur2.scrollLeft += moveX;
            movedX = cur2.scrollLeft - start;
          }
          rect = {
            left: rect.left - movedX,
            top: rect.top - movedY,
            right: rect.right - movedX,
            bottom: rect.bottom - movedY
          };
          if (movedX && Math.abs(movedX - moveX) < 1)
            x2 = "nearest";
          if (movedY && Math.abs(movedY - moveY) < 1)
            y2 = "nearest";
        }
      }
      if (top2)
        break;
      cur2 = cur2.assignedSlot || cur2.parentNode;
    } else if (cur2.nodeType == 11) {
      cur2 = cur2.host;
    } else {
      break;
    }
  }
}
function scrollableParent(dom) {
  let doc2 = dom.ownerDocument;
  for (let cur2 = dom.parentNode; cur2; ) {
    if (cur2 == doc2.body) {
      break;
    } else if (cur2.nodeType == 1) {
      if (cur2.scrollHeight > cur2.clientHeight || cur2.scrollWidth > cur2.clientWidth)
        return cur2;
      cur2 = cur2.assignedSlot || cur2.parentNode;
    } else if (cur2.nodeType == 11) {
      cur2 = cur2.host;
    } else {
      break;
    }
  }
  return null;
}
class DOMSelectionState {
  constructor() {
    this.anchorNode = null;
    this.anchorOffset = 0;
    this.focusNode = null;
    this.focusOffset = 0;
  }
  eq(domSel) {
    return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
  }
  setRange(range3) {
    let { anchorNode, focusNode } = range3;
    this.set(anchorNode, Math.min(range3.anchorOffset, anchorNode ? maxOffset(anchorNode) : 0), focusNode, Math.min(range3.focusOffset, focusNode ? maxOffset(focusNode) : 0));
  }
  set(anchorNode, anchorOffset, focusNode, focusOffset) {
    this.anchorNode = anchorNode;
    this.anchorOffset = anchorOffset;
    this.focusNode = focusNode;
    this.focusOffset = focusOffset;
  }
}
let preventScrollSupported = null;
function focusPreventScroll(dom) {
  if (dom.setActive)
    return dom.setActive();
  if (preventScrollSupported)
    return dom.focus(preventScrollSupported);
  let stack2 = [];
  for (let cur2 = dom; cur2; cur2 = cur2.parentNode) {
    stack2.push(cur2, cur2.scrollTop, cur2.scrollLeft);
    if (cur2 == cur2.ownerDocument)
      break;
  }
  dom.focus(preventScrollSupported == null ? {
    get preventScroll() {
      preventScrollSupported = { preventScroll: true };
      return true;
    }
  } : void 0);
  if (!preventScrollSupported) {
    preventScrollSupported = false;
    for (let i2 = 0; i2 < stack2.length; ) {
      let elt = stack2[i2++], top2 = stack2[i2++], left = stack2[i2++];
      if (elt.scrollTop != top2)
        elt.scrollTop = top2;
      if (elt.scrollLeft != left)
        elt.scrollLeft = left;
    }
  }
}
let scratchRange;
function textRange(node2, from, to2 = from) {
  let range3 = scratchRange || (scratchRange = document.createRange());
  range3.setEnd(node2, to2);
  range3.setStart(node2, from);
  return range3;
}
function dispatchKey(elt, name2, code) {
  let options = { key: name2, code: name2, keyCode: code, which: code, cancelable: true };
  let down = new KeyboardEvent("keydown", options);
  down.synthetic = true;
  elt.dispatchEvent(down);
  let up2 = new KeyboardEvent("keyup", options);
  up2.synthetic = true;
  elt.dispatchEvent(up2);
  return down.defaultPrevented || up2.defaultPrevented;
}
function getRoot(node2) {
  while (node2) {
    if (node2 && (node2.nodeType == 9 || node2.nodeType == 11 && node2.host))
      return node2;
    node2 = node2.assignedSlot || node2.parentNode;
  }
  return null;
}
function clearAttributes(node2) {
  while (node2.attributes.length)
    node2.removeAttributeNode(node2.attributes[0]);
}
function atElementStart(doc2, selection) {
  let node2 = selection.focusNode, offset = selection.focusOffset;
  if (!node2 || selection.anchorNode != node2 || selection.anchorOffset != offset)
    return false;
  offset = Math.min(offset, maxOffset(node2));
  for (; ; ) {
    if (offset) {
      if (node2.nodeType != 1)
        return false;
      let prev = node2.childNodes[offset - 1];
      if (prev.contentEditable == "false")
        offset--;
      else {
        node2 = prev;
        offset = maxOffset(node2);
      }
    } else if (node2 == doc2) {
      return true;
    } else {
      offset = domIndex(node2);
      node2 = node2.parentNode;
    }
  }
}
function isScrolledToBottom(elt) {
  return elt.scrollTop > Math.max(1, elt.scrollHeight - elt.clientHeight - 4);
}
class DOMPos {
  constructor(node2, offset, precise = true) {
    this.node = node2;
    this.offset = offset;
    this.precise = precise;
  }
  static before(dom, precise) {
    return new DOMPos(dom.parentNode, domIndex(dom), precise);
  }
  static after(dom, precise) {
    return new DOMPos(dom.parentNode, domIndex(dom) + 1, precise);
  }
}
const noChildren = [];
class ContentView {
  constructor() {
    this.parent = null;
    this.dom = null;
    this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(view) {
    let pos = this.posAtStart;
    for (let child of this.children) {
      if (child == view)
        return pos;
      pos += child.length + child.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(view) {
    return this.posBefore(view) + view.length;
  }
  sync(view, track) {
    if (this.flags & 2) {
      let parent = this.dom;
      let prev = null, next;
      for (let child of this.children) {
        if (child.flags & 7) {
          if (!child.dom && (next = prev ? prev.nextSibling : parent.firstChild)) {
            let contentView = ContentView.get(next);
            if (!contentView || !contentView.parent && contentView.canReuseDOM(child))
              child.reuseDOM(next);
          }
          child.sync(view, track);
          child.flags &= ~7;
        }
        next = prev ? prev.nextSibling : parent.firstChild;
        if (track && !track.written && track.node == parent && next != child.dom)
          track.written = true;
        if (child.dom.parentNode == parent) {
          while (next && next != child.dom)
            next = rm$1(next);
        } else {
          parent.insertBefore(child.dom, next);
        }
        prev = child.dom;
      }
      next = prev ? prev.nextSibling : parent.firstChild;
      if (next && track && track.node == parent)
        track.written = true;
      while (next)
        next = rm$1(next);
    } else if (this.flags & 1) {
      for (let child of this.children)
        if (child.flags & 7) {
          child.sync(view, track);
          child.flags &= ~7;
        }
    }
  }
  reuseDOM(_dom) {
  }
  localPosFromDOM(node2, offset) {
    let after;
    if (node2 == this.dom) {
      after = this.dom.childNodes[offset];
    } else {
      let bias = maxOffset(node2) == 0 ? 0 : offset == 0 ? -1 : 1;
      for (; ; ) {
        let parent = node2.parentNode;
        if (parent == this.dom)
          break;
        if (bias == 0 && parent.firstChild != parent.lastChild) {
          if (node2 == parent.firstChild)
            bias = -1;
          else
            bias = 1;
        }
        node2 = parent;
      }
      if (bias < 0)
        after = node2;
      else
        after = node2.nextSibling;
    }
    if (after == this.dom.firstChild)
      return 0;
    while (after && !ContentView.get(after))
      after = after.nextSibling;
    if (!after)
      return this.length;
    for (let i2 = 0, pos = 0; ; i2++) {
      let child = this.children[i2];
      if (child.dom == after)
        return pos;
      pos += child.length + child.breakAfter;
    }
  }
  domBoundsAround(from, to2, offset = 0) {
    let fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
    for (let i2 = 0, pos = offset, prevEnd = offset; i2 < this.children.length; i2++) {
      let child = this.children[i2], end = pos + child.length;
      if (pos < from && end > to2)
        return child.domBoundsAround(from, to2, pos);
      if (end >= from && fromI == -1) {
        fromI = i2;
        fromStart = pos;
      }
      if (pos > to2 && child.dom.parentNode == this.dom) {
        toI = i2;
        toEnd = prevEnd;
        break;
      }
      prevEnd = end;
      pos = end + child.breakAfter;
    }
    return {
      from: fromStart,
      to: toEnd < 0 ? offset + this.length : toEnd,
      startDOM: (fromI ? this.children[fromI - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: toI < this.children.length && toI >= 0 ? this.children[toI].dom : null
    };
  }
  markDirty(andParent = false) {
    this.flags |= 2;
    this.markParentsDirty(andParent);
  }
  markParentsDirty(childList) {
    for (let parent = this.parent; parent; parent = parent.parent) {
      if (childList)
        parent.flags |= 2;
      if (parent.flags & 1)
        return;
      parent.flags |= 1;
      childList = false;
    }
  }
  setParent(parent) {
    if (this.parent != parent) {
      this.parent = parent;
      if (this.flags & 7)
        this.markParentsDirty(true);
    }
  }
  setDOM(dom) {
    if (this.dom)
      this.dom.cmView = null;
    this.dom = dom;
    dom.cmView = this;
  }
  get rootView() {
    for (let v2 = this; ; ) {
      let parent = v2.parent;
      if (!parent)
        return v2;
      v2 = parent;
    }
  }
  replaceChildren(from, to2, children = noChildren) {
    this.markDirty();
    for (let i2 = from; i2 < to2; i2++) {
      let child = this.children[i2];
      if (child.parent == this)
        child.destroy();
    }
    this.children.splice(from, to2 - from, ...children);
    for (let i2 = 0; i2 < children.length; i2++)
      children[i2].setParent(this);
  }
  ignoreMutation(_rec) {
    return false;
  }
  ignoreEvent(_event) {
    return false;
  }
  childCursor(pos = this.length) {
    return new ChildCursor(this.children, pos, this.children.length);
  }
  childPos(pos, bias = 1) {
    return this.childCursor().findPos(pos, bias);
  }
  toString() {
    let name2 = this.constructor.name.replace("View", "");
    return name2 + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (name2 == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(node2) {
    return node2.cmView;
  }
  get isEditable() {
    return true;
  }
  get isWidget() {
    return false;
  }
  get isHidden() {
    return false;
  }
  merge(from, to2, source, hasStart, openStart, openEnd) {
    return false;
  }
  become(other) {
    return false;
  }
  canReuseDOM(other) {
    return other.constructor == this.constructor && !((this.flags | other.flags) & 8);
  }
  getSide() {
    return 0;
  }
  destroy() {
    this.parent = null;
  }
}
ContentView.prototype.breakAfter = 0;
function rm$1(dom) {
  let next = dom.nextSibling;
  dom.parentNode.removeChild(dom);
  return next;
}
class ChildCursor {
  constructor(children, pos, i2) {
    this.children = children;
    this.pos = pos;
    this.i = i2;
    this.off = 0;
  }
  findPos(pos, bias = 1) {
    for (; ; ) {
      if (pos > this.pos || pos == this.pos && (bias > 0 || this.i == 0 || this.children[this.i - 1].breakAfter)) {
        this.off = pos - this.pos;
        return this;
      }
      let next = this.children[--this.i];
      this.pos -= next.length + next.breakAfter;
    }
  }
}
function replaceRange(parent, fromI, fromOff, toI, toOff, insert2, breakAtStart, openStart, openEnd) {
  let { children } = parent;
  let before = children.length ? children[fromI] : null;
  let last = insert2.length ? insert2[insert2.length - 1] : null;
  let breakAtEnd = last ? last.breakAfter : breakAtStart;
  if (fromI == toI && before && !breakAtStart && !breakAtEnd && insert2.length < 2 && before.merge(fromOff, toOff, insert2.length ? last : null, fromOff == 0, openStart, openEnd))
    return;
  if (toI < children.length) {
    let after = children[toI];
    if (after && toOff < after.length) {
      if (fromI == toI) {
        after = after.split(toOff);
        toOff = 0;
      }
      if (!breakAtEnd && last && after.merge(0, toOff, last, true, 0, openEnd)) {
        insert2[insert2.length - 1] = after;
      } else {
        if (toOff)
          after.merge(0, toOff, null, false, 0, openEnd);
        insert2.push(after);
      }
    } else if (after === null || after === void 0 ? void 0 : after.breakAfter) {
      if (last)
        last.breakAfter = 1;
      else
        breakAtStart = 1;
    }
    toI++;
  }
  if (before) {
    before.breakAfter = breakAtStart;
    if (fromOff > 0) {
      if (!breakAtStart && insert2.length && before.merge(fromOff, before.length, insert2[0], false, openStart, 0)) {
        before.breakAfter = insert2.shift().breakAfter;
      } else if (fromOff < before.length || before.children.length && before.children[before.children.length - 1].length == 0) {
        before.merge(fromOff, before.length, null, false, openStart, 0);
      }
      fromI++;
    }
  }
  while (fromI < toI && insert2.length) {
    if (children[toI - 1].become(insert2[insert2.length - 1])) {
      toI--;
      insert2.pop();
      openEnd = insert2.length ? 0 : openStart;
    } else if (children[fromI].become(insert2[0])) {
      fromI++;
      insert2.shift();
      openStart = insert2.length ? 0 : openEnd;
    } else {
      break;
    }
  }
  if (!insert2.length && fromI && toI < children.length && !children[fromI - 1].breakAfter && children[toI].merge(0, 0, children[fromI - 1], false, openStart, openEnd))
    fromI--;
  if (fromI < toI || insert2.length)
    parent.replaceChildren(fromI, toI, insert2);
}
function mergeChildrenInto(parent, from, to2, insert2, openStart, openEnd) {
  let cur2 = parent.childCursor();
  let { i: toI, off: toOff } = cur2.findPos(to2, 1);
  let { i: fromI, off: fromOff } = cur2.findPos(from, -1);
  let dLen = from - to2;
  for (let view of insert2)
    dLen += view.length;
  parent.length += dLen;
  replaceRange(parent, fromI, fromOff, toI, toOff, insert2, 0, openStart, openEnd);
}
const LineBreakPlaceholder = "\uFFFF";
class DOMReader {
  constructor(points, state) {
    this.points = points;
    this.text = "";
    this.lineSeparator = state.facet(EditorState.lineSeparator);
  }
  append(text) {
    this.text += text;
  }
  lineBreak() {
    this.text += LineBreakPlaceholder;
  }
  readRange(start, end) {
    if (!start)
      return this;
    let parent = start.parentNode;
    for (let cur2 = start; ; ) {
      this.findPointBefore(parent, cur2);
      let oldLen = this.text.length;
      this.readNode(cur2);
      let next = cur2.nextSibling;
      if (next == end)
        break;
      let view = ContentView.get(cur2), nextView = ContentView.get(next);
      if (view && nextView ? view.breakAfter : (view ? view.breakAfter : isBlockElement(cur2)) || isBlockElement(next) && (cur2.nodeName != "BR" || cur2.cmIgnore) && this.text.length > oldLen)
        this.lineBreak();
      cur2 = next;
    }
    this.findPointBefore(parent, end);
    return this;
  }
  readTextNode(node2) {
    let text = node2.nodeValue;
    for (let point of this.points)
      if (point.node == node2)
        point.pos = this.text.length + Math.min(point.offset, text.length);
    for (let off2 = 0, re2 = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let nextBreak = -1, breakSize = 1, m2;
      if (this.lineSeparator) {
        nextBreak = text.indexOf(this.lineSeparator, off2);
        breakSize = this.lineSeparator.length;
      } else if (m2 = re2.exec(text)) {
        nextBreak = m2.index;
        breakSize = m2[0].length;
      }
      this.append(text.slice(off2, nextBreak < 0 ? text.length : nextBreak));
      if (nextBreak < 0)
        break;
      this.lineBreak();
      if (breakSize > 1) {
        for (let point of this.points)
          if (point.node == node2 && point.pos > this.text.length)
            point.pos -= breakSize - 1;
      }
      off2 = nextBreak + breakSize;
    }
  }
  readNode(node2) {
    if (node2.cmIgnore)
      return;
    let view = ContentView.get(node2);
    let fromView = view && view.overrideDOMText;
    if (fromView != null) {
      this.findPointInside(node2, fromView.length);
      for (let i2 = fromView.iter(); !i2.next().done; ) {
        if (i2.lineBreak)
          this.lineBreak();
        else
          this.append(i2.value);
      }
    } else if (node2.nodeType == 3) {
      this.readTextNode(node2);
    } else if (node2.nodeName == "BR") {
      if (node2.nextSibling)
        this.lineBreak();
    } else if (node2.nodeType == 1) {
      this.readRange(node2.firstChild, null);
    }
  }
  findPointBefore(node2, next) {
    for (let point of this.points)
      if (point.node == node2 && node2.childNodes[point.offset] == next)
        point.pos = this.text.length;
  }
  findPointInside(node2, maxLen) {
    for (let point of this.points)
      if (node2.nodeType == 3 ? point.node == node2 : node2.contains(point.node))
        point.pos = this.text.length + Math.min(maxLen, point.offset);
  }
}
function isBlockElement(node2) {
  return node2.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node2.nodeName);
}
class DOMPoint {
  constructor(node2, offset) {
    this.node = node2;
    this.offset = offset;
    this.pos = -1;
  }
}
let nav = typeof navigator != "undefined" ? navigator : { userAgent: "", vendor: "", platform: "" };
let doc = typeof document != "undefined" ? document : { documentElement: { style: {} } };
const ie_edge = /* @__PURE__ */ /Edge\/(\d+)/.exec(nav.userAgent);
const ie_upto10 = /* @__PURE__ */ /MSIE \d/.test(nav.userAgent);
const ie_11up = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(nav.userAgent);
const ie$1 = !!(ie_upto10 || ie_11up || ie_edge);
const gecko = !ie$1 && /* @__PURE__ */ /gecko\/(\d+)/i.test(nav.userAgent);
const chrome = !ie$1 && /* @__PURE__ */ /Chrome\/(\d+)/.exec(nav.userAgent);
const webkit = "webkitFontSmoothing" in doc.documentElement.style;
const safari = !ie$1 && /* @__PURE__ */ /Apple Computer/.test(nav.vendor);
const ios = safari && (/* @__PURE__ */ /Mobile\/\w+/.test(nav.userAgent) || nav.maxTouchPoints > 2);
var browser = {
  mac: ios || /* @__PURE__ */ /Mac/.test(nav.platform),
  windows: /* @__PURE__ */ /Win/.test(nav.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(nav.platform),
  ie: ie$1,
  ie_version: ie_upto10 ? doc.documentMode || 6 : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : 0,
  gecko,
  gecko_version: gecko ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(nav.userAgent) || [0, 0])[1] : 0,
  chrome: !!chrome,
  chrome_version: chrome ? +chrome[1] : 0,
  ios,
  android: /* @__PURE__ */ /Android\b/.test(nav.userAgent),
  webkit,
  safari,
  webkit_version: webkit ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0,
  tabSize: doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const MaxJoinLen = 256;
class TextView extends ContentView {
  constructor(text) {
    super();
    this.text = text;
  }
  get length() {
    return this.text.length;
  }
  createDOM(textDOM) {
    this.setDOM(textDOM || document.createTextNode(this.text));
  }
  sync(view, track) {
    if (!this.dom)
      this.createDOM();
    if (this.dom.nodeValue != this.text) {
      if (track && track.node == this.dom)
        track.written = true;
      this.dom.nodeValue = this.text;
    }
  }
  reuseDOM(dom) {
    if (dom.nodeType == 3)
      this.createDOM(dom);
  }
  merge(from, to2, source) {
    if (this.flags & 8 || source && (!(source instanceof TextView) || this.length - (to2 - from) + source.length > MaxJoinLen || source.flags & 8))
      return false;
    this.text = this.text.slice(0, from) + (source ? source.text : "") + this.text.slice(to2);
    this.markDirty();
    return true;
  }
  split(from) {
    let result2 = new TextView(this.text.slice(from));
    this.text = this.text.slice(0, from);
    this.markDirty();
    result2.flags |= this.flags & 8;
    return result2;
  }
  localPosFromDOM(node2, offset) {
    return node2 == this.dom ? offset : offset ? this.text.length : 0;
  }
  domAtPos(pos) {
    return new DOMPos(this.dom, pos);
  }
  domBoundsAround(_from, _to, offset) {
    return { from: offset, to: offset + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(pos, side) {
    return textCoords(this.dom, pos, side);
  }
}
class MarkView extends ContentView {
  constructor(mark, children = [], length2 = 0) {
    super();
    this.mark = mark;
    this.children = children;
    this.length = length2;
    for (let ch2 of children)
      ch2.setParent(this);
  }
  setAttrs(dom) {
    clearAttributes(dom);
    if (this.mark.class)
      dom.className = this.mark.class;
    if (this.mark.attrs)
      for (let name2 in this.mark.attrs)
        dom.setAttribute(name2, this.mark.attrs[name2]);
    return dom;
  }
  canReuseDOM(other) {
    return super.canReuseDOM(other) && !((this.flags | other.flags) & 8);
  }
  reuseDOM(node2) {
    if (node2.nodeName == this.mark.tagName.toUpperCase()) {
      this.setDOM(node2);
      this.flags |= 4 | 2;
    }
  }
  sync(view, track) {
    if (!this.dom)
      this.setDOM(this.setAttrs(document.createElement(this.mark.tagName)));
    else if (this.flags & 4)
      this.setAttrs(this.dom);
    super.sync(view, track);
  }
  merge(from, to2, source, _hasStart, openStart, openEnd) {
    if (source && (!(source instanceof MarkView && source.mark.eq(this.mark)) || from && openStart <= 0 || to2 < this.length && openEnd <= 0))
      return false;
    mergeChildrenInto(this, from, to2, source ? source.children : [], openStart - 1, openEnd - 1);
    this.markDirty();
    return true;
  }
  split(from) {
    let result2 = [], off2 = 0, detachFrom = -1, i2 = 0;
    for (let elt of this.children) {
      let end = off2 + elt.length;
      if (end > from)
        result2.push(off2 < from ? elt.split(from - off2) : elt);
      if (detachFrom < 0 && off2 >= from)
        detachFrom = i2;
      off2 = end;
      i2++;
    }
    let length2 = this.length - from;
    this.length = from;
    if (detachFrom > -1) {
      this.children.length = detachFrom;
      this.markDirty();
    }
    return new MarkView(this.mark, result2, length2);
  }
  domAtPos(pos) {
    return inlineDOMAtPos(this, pos);
  }
  coordsAt(pos, side) {
    return coordsInChildren(this, pos, side);
  }
}
function textCoords(text, pos, side) {
  let length2 = text.nodeValue.length;
  if (pos > length2)
    pos = length2;
  let from = pos, to2 = pos, flatten2 = 0;
  if (pos == 0 && side < 0 || pos == length2 && side >= 0) {
    if (!(browser.chrome || browser.gecko)) {
      if (pos) {
        from--;
        flatten2 = 1;
      } else if (to2 < length2) {
        to2++;
        flatten2 = -1;
      }
    }
  } else {
    if (side < 0)
      from--;
    else if (to2 < length2)
      to2++;
  }
  let rects = textRange(text, from, to2).getClientRects();
  if (!rects.length)
    return null;
  let rect = rects[(flatten2 ? flatten2 < 0 : side >= 0) ? 0 : rects.length - 1];
  if (browser.safari && !flatten2 && rect.width == 0)
    rect = Array.prototype.find.call(rects, (r2) => r2.width) || rect;
  return flatten2 ? flattenRect(rect, flatten2 < 0) : rect || null;
}
class WidgetView extends ContentView {
  constructor(widget, length2, side) {
    super();
    this.widget = widget;
    this.length = length2;
    this.side = side;
    this.prevWidget = null;
  }
  static create(widget, length2, side) {
    return new WidgetView(widget, length2, side);
  }
  split(from) {
    let result2 = WidgetView.create(this.widget, this.length - from, this.side);
    this.length -= from;
    return result2;
  }
  sync(view) {
    if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
      if (this.dom && this.prevWidget)
        this.prevWidget.destroy(this.dom);
      this.prevWidget = null;
      this.setDOM(this.widget.toDOM(view));
      this.dom.contentEditable = "false";
    }
  }
  getSide() {
    return this.side;
  }
  merge(from, to2, source, hasStart, openStart, openEnd) {
    if (source && (!(source instanceof WidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to2 < this.length && openEnd <= 0))
      return false;
    this.length = from + (source ? source.length : 0) + (this.length - to2);
    return true;
  }
  become(other) {
    if (other instanceof WidgetView && other.side == this.side && this.widget.constructor == other.widget.constructor) {
      if (!this.widget.compare(other.widget))
        this.markDirty(true);
      if (this.dom && !this.prevWidget)
        this.prevWidget = this.widget;
      this.widget = other.widget;
      this.length = other.length;
      return true;
    }
    return false;
  }
  ignoreMutation() {
    return true;
  }
  ignoreEvent(event) {
    return this.widget.ignoreEvent(event);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return Text.empty;
    let top2 = this;
    while (top2.parent)
      top2 = top2.parent;
    let { view } = top2, text = view && view.state.doc, start = this.posAtStart;
    return text ? text.slice(start, start + this.length) : Text.empty;
  }
  domAtPos(pos) {
    return (this.length ? pos == 0 : this.side > 0) ? DOMPos.before(this.dom) : DOMPos.after(this.dom, pos == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(pos, side) {
    let custom = this.widget.coordsAt(this.dom, pos, side);
    if (custom)
      return custom;
    let rects = this.dom.getClientRects(), rect = null;
    if (!rects.length)
      return null;
    let fromBack = this.side ? this.side < 0 : pos > 0;
    for (let i2 = fromBack ? rects.length - 1 : 0; ; i2 += fromBack ? -1 : 1) {
      rect = rects[i2];
      if (pos > 0 ? i2 == 0 : i2 == rects.length - 1 || rect.top < rect.bottom)
        break;
    }
    return flattenRect(rect, !fromBack);
  }
  get isEditable() {
    return false;
  }
  get isWidget() {
    return true;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy();
    if (this.dom)
      this.widget.destroy(this.dom);
  }
}
class WidgetBufferView extends ContentView {
  constructor(side) {
    super();
    this.side = side;
  }
  get length() {
    return 0;
  }
  merge() {
    return false;
  }
  become(other) {
    return other instanceof WidgetBufferView && other.side == this.side;
  }
  split() {
    return new WidgetBufferView(this.side);
  }
  sync() {
    if (!this.dom) {
      let dom = document.createElement("img");
      dom.className = "cm-widgetBuffer";
      dom.setAttribute("aria-hidden", "true");
      this.setDOM(dom);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(pos) {
    return this.side > 0 ? DOMPos.before(this.dom) : DOMPos.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(pos) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return Text.empty;
  }
  get isHidden() {
    return true;
  }
}
TextView.prototype.children = WidgetView.prototype.children = WidgetBufferView.prototype.children = noChildren;
function inlineDOMAtPos(parent, pos) {
  let dom = parent.dom, { children } = parent, i2 = 0;
  for (let off2 = 0; i2 < children.length; i2++) {
    let child = children[i2], end = off2 + child.length;
    if (end == off2 && child.getSide() <= 0)
      continue;
    if (pos > off2 && pos < end && child.dom.parentNode == dom)
      return child.domAtPos(pos - off2);
    if (pos <= off2)
      break;
    off2 = end;
  }
  for (let j2 = i2; j2 > 0; j2--) {
    let prev = children[j2 - 1];
    if (prev.dom.parentNode == dom)
      return prev.domAtPos(prev.length);
  }
  for (let j2 = i2; j2 < children.length; j2++) {
    let next = children[j2];
    if (next.dom.parentNode == dom)
      return next.domAtPos(0);
  }
  return new DOMPos(dom, 0);
}
function joinInlineInto(parent, view, open) {
  let last, { children } = parent;
  if (open > 0 && view instanceof MarkView && children.length && (last = children[children.length - 1]) instanceof MarkView && last.mark.eq(view.mark)) {
    joinInlineInto(last, view.children[0], open - 1);
  } else {
    children.push(view);
    view.setParent(parent);
  }
  parent.length += view.length;
}
function coordsInChildren(view, pos, side) {
  let before = null, beforePos = -1, after = null, afterPos = -1;
  function scan(view2, pos2) {
    for (let i2 = 0, off2 = 0; i2 < view2.children.length && off2 <= pos2; i2++) {
      let child = view2.children[i2], end = off2 + child.length;
      if (end >= pos2) {
        if (child.children.length) {
          scan(child, pos2 - off2);
        } else if ((!after || after.isHidden && side > 0) && (end > pos2 || off2 == end && child.getSide() > 0)) {
          after = child;
          afterPos = pos2 - off2;
        } else if (off2 < pos2 || off2 == end && child.getSide() < 0 && !child.isHidden) {
          before = child;
          beforePos = pos2 - off2;
        }
      }
      off2 = end;
    }
  }
  scan(view, pos);
  let target = (side < 0 ? before : after) || before || after;
  if (target)
    return target.coordsAt(Math.max(0, target == before ? beforePos : afterPos), side);
  return fallbackRect(view);
}
function fallbackRect(view) {
  let last = view.dom.lastChild;
  if (!last)
    return view.dom.getBoundingClientRect();
  let rects = clientRectsFor(last);
  return rects[rects.length - 1] || null;
}
function combineAttrs(source, target) {
  for (let name2 in source) {
    if (name2 == "class" && target.class)
      target.class += " " + source.class;
    else if (name2 == "style" && target.style)
      target.style += ";" + source.style;
    else
      target[name2] = source[name2];
  }
  return target;
}
const noAttrs = /* @__PURE__ */ Object.create(null);
function attrsEq(a2, b2, ignore) {
  if (a2 == b2)
    return true;
  if (!a2)
    a2 = noAttrs;
  if (!b2)
    b2 = noAttrs;
  let keysA = Object.keys(a2), keysB = Object.keys(b2);
  if (keysA.length - (ignore && keysA.indexOf(ignore) > -1 ? 1 : 0) != keysB.length - (ignore && keysB.indexOf(ignore) > -1 ? 1 : 0))
    return false;
  for (let key of keysA) {
    if (key != ignore && (keysB.indexOf(key) == -1 || a2[key] !== b2[key]))
      return false;
  }
  return true;
}
function updateAttrs(dom, prev, attrs) {
  let changed = null;
  if (prev) {
    for (let name2 in prev)
      if (!(attrs && name2 in attrs))
        dom.removeAttribute(changed = name2);
  }
  if (attrs) {
    for (let name2 in attrs)
      if (!(prev && prev[name2] == attrs[name2]))
        dom.setAttribute(changed = name2, attrs[name2]);
  }
  return !!changed;
}
function getAttrs(dom) {
  let attrs = Object.create(null);
  for (let i2 = 0; i2 < dom.attributes.length; i2++) {
    let attr = dom.attributes[i2];
    attrs[attr.name] = attr.value;
  }
  return attrs;
}
class WidgetType {
  eq(widget) {
    return false;
  }
  updateDOM(dom, view) {
    return false;
  }
  compare(other) {
    return this == other || this.constructor == other.constructor && this.eq(other);
  }
  get estimatedHeight() {
    return -1;
  }
  get lineBreaks() {
    return 0;
  }
  ignoreEvent(event) {
    return true;
  }
  coordsAt(dom, pos, side) {
    return null;
  }
  get isHidden() {
    return false;
  }
  destroy(dom) {
  }
}
var BlockType = /* @__PURE__ */ function(BlockType2) {
  BlockType2[BlockType2["Text"] = 0] = "Text";
  BlockType2[BlockType2["WidgetBefore"] = 1] = "WidgetBefore";
  BlockType2[BlockType2["WidgetAfter"] = 2] = "WidgetAfter";
  BlockType2[BlockType2["WidgetRange"] = 3] = "WidgetRange";
  return BlockType2;
}(BlockType || (BlockType = {}));
class Decoration extends RangeValue {
  constructor(startSide, endSide, widget, spec2) {
    super();
    this.startSide = startSide;
    this.endSide = endSide;
    this.widget = widget;
    this.spec = spec2;
  }
  get heightRelevant() {
    return false;
  }
  static mark(spec2) {
    return new MarkDecoration(spec2);
  }
  static widget(spec2) {
    let side = Math.max(-1e4, Math.min(1e4, spec2.side || 0)), block = !!spec2.block;
    side += block && !spec2.inlineOrder ? side > 0 ? 3e8 : -4e8 : side > 0 ? 1e8 : -1e8;
    return new PointDecoration(spec2, side, side, block, spec2.widget || null, false);
  }
  static replace(spec2) {
    let block = !!spec2.block, startSide, endSide;
    if (spec2.isBlockGap) {
      startSide = -5e8;
      endSide = 4e8;
    } else {
      let { start, end } = getInclusive(spec2, block);
      startSide = (start ? block ? -3e8 : -1 : 5e8) - 1;
      endSide = (end ? block ? 2e8 : 1 : -6e8) + 1;
    }
    return new PointDecoration(spec2, startSide, endSide, block, spec2.widget || null, true);
  }
  static line(spec2) {
    return new LineDecoration(spec2);
  }
  static set(of2, sort = false) {
    return RangeSet.of(of2, sort);
  }
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : false;
  }
}
Decoration.none = RangeSet.empty;
class MarkDecoration extends Decoration {
  constructor(spec2) {
    let { start, end } = getInclusive(spec2);
    super(start ? -1 : 5e8, end ? 1 : -6e8, null, spec2);
    this.tagName = spec2.tagName || "span";
    this.class = spec2.class || "";
    this.attrs = spec2.attributes || null;
  }
  eq(other) {
    var _a2, _b2;
    return this == other || other instanceof MarkDecoration && this.tagName == other.tagName && (this.class || ((_a2 = this.attrs) === null || _a2 === void 0 ? void 0 : _a2.class)) == (other.class || ((_b2 = other.attrs) === null || _b2 === void 0 ? void 0 : _b2.class)) && attrsEq(this.attrs, other.attrs, "class");
  }
  range(from, to2 = from) {
    if (from >= to2)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(from, to2);
  }
}
MarkDecoration.prototype.point = false;
class LineDecoration extends Decoration {
  constructor(spec2) {
    super(-2e8, -2e8, null, spec2);
  }
  eq(other) {
    return other instanceof LineDecoration && this.spec.class == other.spec.class && attrsEq(this.spec.attributes, other.spec.attributes);
  }
  range(from, to2 = from) {
    if (to2 != from)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(from, to2);
  }
}
LineDecoration.prototype.mapMode = MapMode.TrackBefore;
LineDecoration.prototype.point = true;
class PointDecoration extends Decoration {
  constructor(spec2, startSide, endSide, block, widget, isReplace) {
    super(startSide, endSide, widget, spec2);
    this.block = block;
    this.isReplace = isReplace;
    this.mapMode = !block ? MapMode.TrackDel : startSide <= 0 ? MapMode.TrackBefore : MapMode.TrackAfter;
  }
  get type() {
    return this.startSide < this.endSide ? BlockType.WidgetRange : this.startSide <= 0 ? BlockType.WidgetBefore : BlockType.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(other) {
    return other instanceof PointDecoration && widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
  }
  range(from, to2 = from) {
    if (this.isReplace && (from > to2 || from == to2 && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && to2 != from)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(from, to2);
  }
}
PointDecoration.prototype.point = true;
function getInclusive(spec2, block = false) {
  let { inclusiveStart: start, inclusiveEnd: end } = spec2;
  if (start == null)
    start = spec2.inclusive;
  if (end == null)
    end = spec2.inclusive;
  return { start: start !== null && start !== void 0 ? start : block, end: end !== null && end !== void 0 ? end : block };
}
function widgetsEq(a2, b2) {
  return a2 == b2 || !!(a2 && b2 && a2.compare(b2));
}
function addRange(from, to2, ranges, margin = 0) {
  let last = ranges.length - 1;
  if (last >= 0 && ranges[last] + margin >= from)
    ranges[last] = Math.max(ranges[last], to2);
  else
    ranges.push(from, to2);
}
class LineView extends ContentView {
  constructor() {
    super(...arguments);
    this.children = [];
    this.length = 0;
    this.prevAttrs = void 0;
    this.attrs = null;
    this.breakAfter = 0;
  }
  merge(from, to2, source, hasStart, openStart, openEnd) {
    if (source) {
      if (!(source instanceof LineView))
        return false;
      if (!this.dom)
        source.transferDOM(this);
    }
    if (hasStart)
      this.setDeco(source ? source.attrs : null);
    mergeChildrenInto(this, from, to2, source ? source.children : [], openStart, openEnd);
    return true;
  }
  split(at2) {
    let end = new LineView();
    end.breakAfter = this.breakAfter;
    if (this.length == 0)
      return end;
    let { i: i2, off: off2 } = this.childPos(at2);
    if (off2) {
      end.append(this.children[i2].split(off2), 0);
      this.children[i2].merge(off2, this.children[i2].length, null, false, 0, 0);
      i2++;
    }
    for (let j2 = i2; j2 < this.children.length; j2++)
      end.append(this.children[j2], 0);
    while (i2 > 0 && this.children[i2 - 1].length == 0)
      this.children[--i2].destroy();
    this.children.length = i2;
    this.markDirty();
    this.length = at2;
    return end;
  }
  transferDOM(other) {
    if (!this.dom)
      return;
    this.markDirty();
    other.setDOM(this.dom);
    other.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs;
    this.prevAttrs = void 0;
    this.dom = null;
  }
  setDeco(attrs) {
    if (!attrsEq(this.attrs, attrs)) {
      if (this.dom) {
        this.prevAttrs = this.attrs;
        this.markDirty();
      }
      this.attrs = attrs;
    }
  }
  append(child, openStart) {
    joinInlineInto(this, child, openStart);
  }
  addLineDeco(deco) {
    let attrs = deco.spec.attributes, cls = deco.spec.class;
    if (attrs)
      this.attrs = combineAttrs(attrs, this.attrs || {});
    if (cls)
      this.attrs = combineAttrs({ class: cls }, this.attrs || {});
  }
  domAtPos(pos) {
    return inlineDOMAtPos(this, pos);
  }
  reuseDOM(node2) {
    if (node2.nodeName == "DIV") {
      this.setDOM(node2);
      this.flags |= 4 | 2;
    }
  }
  sync(view, track) {
    var _a2;
    if (!this.dom) {
      this.setDOM(document.createElement("div"));
      this.dom.className = "cm-line";
      this.prevAttrs = this.attrs ? null : void 0;
    } else if (this.flags & 4) {
      clearAttributes(this.dom);
      this.dom.className = "cm-line";
      this.prevAttrs = this.attrs ? null : void 0;
    }
    if (this.prevAttrs !== void 0) {
      updateAttrs(this.dom, this.prevAttrs, this.attrs);
      this.dom.classList.add("cm-line");
      this.prevAttrs = void 0;
    }
    super.sync(view, track);
    let last = this.dom.lastChild;
    while (last && ContentView.get(last) instanceof MarkView)
      last = last.lastChild;
    if (!last || !this.length || last.nodeName != "BR" && ((_a2 = ContentView.get(last)) === null || _a2 === void 0 ? void 0 : _a2.isEditable) == false && (!browser.ios || !this.children.some((ch2) => ch2 instanceof TextView))) {
      let hack = document.createElement("BR");
      hack.cmIgnore = true;
      this.dom.appendChild(hack);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let totalWidth = 0, textHeight;
    for (let child of this.children) {
      if (!(child instanceof TextView) || /[^ -~]/.test(child.text))
        return null;
      let rects = clientRectsFor(child.dom);
      if (rects.length != 1)
        return null;
      totalWidth += rects[0].width;
      textHeight = rects[0].height;
    }
    return !totalWidth ? null : {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: totalWidth / this.length,
      textHeight
    };
  }
  coordsAt(pos, side) {
    let rect = coordsInChildren(this, pos, side);
    if (!this.children.length && rect && this.parent) {
      let { heightOracle } = this.parent.view.viewState, height = rect.bottom - rect.top;
      if (Math.abs(height - heightOracle.lineHeight) < 2 && heightOracle.textHeight < height) {
        let dist2 = (height - heightOracle.textHeight) / 2;
        return { top: rect.top + dist2, bottom: rect.bottom - dist2, left: rect.left, right: rect.left };
      }
    }
    return rect;
  }
  become(_other) {
    return false;
  }
  get type() {
    return BlockType.Text;
  }
  static find(docView, pos) {
    for (let i2 = 0, off2 = 0; i2 < docView.children.length; i2++) {
      let block = docView.children[i2], end = off2 + block.length;
      if (end >= pos) {
        if (block instanceof LineView)
          return block;
        if (end > pos)
          break;
      }
      off2 = end + block.breakAfter;
    }
    return null;
  }
}
class BlockWidgetView extends ContentView {
  constructor(widget, length2, type4) {
    super();
    this.widget = widget;
    this.length = length2;
    this.type = type4;
    this.breakAfter = 0;
    this.prevWidget = null;
  }
  merge(from, to2, source, _takeDeco, openStart, openEnd) {
    if (source && (!(source instanceof BlockWidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to2 < this.length && openEnd <= 0))
      return false;
    this.length = from + (source ? source.length : 0) + (this.length - to2);
    return true;
  }
  domAtPos(pos) {
    return pos == 0 ? DOMPos.before(this.dom) : DOMPos.after(this.dom, pos == this.length);
  }
  split(at2) {
    let len2 = this.length - at2;
    this.length = at2;
    let end = new BlockWidgetView(this.widget, len2, this.type);
    end.breakAfter = this.breakAfter;
    return end;
  }
  get children() {
    return noChildren;
  }
  sync(view) {
    if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
      if (this.dom && this.prevWidget)
        this.prevWidget.destroy(this.dom);
      this.prevWidget = null;
      this.setDOM(this.widget.toDOM(view));
      this.dom.contentEditable = "false";
    }
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : Text.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(other) {
    if (other instanceof BlockWidgetView && other.widget.constructor == this.widget.constructor) {
      if (!other.widget.compare(this.widget))
        this.markDirty(true);
      if (this.dom && !this.prevWidget)
        this.prevWidget = this.widget;
      this.widget = other.widget;
      this.length = other.length;
      this.type = other.type;
      this.breakAfter = other.breakAfter;
      return true;
    }
    return false;
  }
  ignoreMutation() {
    return true;
  }
  ignoreEvent(event) {
    return this.widget.ignoreEvent(event);
  }
  get isEditable() {
    return false;
  }
  get isWidget() {
    return true;
  }
  coordsAt(pos, side) {
    return this.widget.coordsAt(this.dom, pos, side);
  }
  destroy() {
    super.destroy();
    if (this.dom)
      this.widget.destroy(this.dom);
  }
}
class ContentBuilder {
  constructor(doc2, pos, end, disallowBlockEffectsFor) {
    this.doc = doc2;
    this.pos = pos;
    this.end = end;
    this.disallowBlockEffectsFor = disallowBlockEffectsFor;
    this.content = [];
    this.curLine = null;
    this.breakAtStart = 0;
    this.pendingBuffer = 0;
    this.bufferMarks = [];
    this.atCursorPos = true;
    this.openStart = -1;
    this.openEnd = -1;
    this.text = "";
    this.textOff = 0;
    this.cursor = doc2.iter();
    this.skip = pos;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let last = this.content[this.content.length - 1];
    return !last.breakAfter && !(last instanceof BlockWidgetView && last.type == BlockType.WidgetBefore);
  }
  getLine() {
    if (!this.curLine) {
      this.content.push(this.curLine = new LineView());
      this.atCursorPos = true;
    }
    return this.curLine;
  }
  flushBuffer(active = this.bufferMarks) {
    if (this.pendingBuffer) {
      this.curLine.append(wrapMarks(new WidgetBufferView(-1), active), active.length);
      this.pendingBuffer = 0;
    }
  }
  addBlockWidget(view) {
    this.flushBuffer();
    this.curLine = null;
    this.content.push(view);
  }
  finish(openEnd) {
    if (this.pendingBuffer && openEnd <= this.bufferMarks.length)
      this.flushBuffer();
    else
      this.pendingBuffer = 0;
    if (!this.posCovered())
      this.getLine();
  }
  buildText(length2, active, openStart) {
    while (length2 > 0) {
      if (this.textOff == this.text.length) {
        let { value: value2, lineBreak, done } = this.cursor.next(this.skip);
        this.skip = 0;
        if (done)
          throw new Error("Ran out of text content when drawing inline views");
        if (lineBreak) {
          if (!this.posCovered())
            this.getLine();
          if (this.content.length)
            this.content[this.content.length - 1].breakAfter = 1;
          else
            this.breakAtStart = 1;
          this.flushBuffer();
          this.curLine = null;
          this.atCursorPos = true;
          length2--;
          continue;
        } else {
          this.text = value2;
          this.textOff = 0;
        }
      }
      let take = Math.min(this.text.length - this.textOff, length2, 512);
      this.flushBuffer(active.slice(active.length - openStart));
      this.getLine().append(wrapMarks(new TextView(this.text.slice(this.textOff, this.textOff + take)), active), openStart);
      this.atCursorPos = true;
      this.textOff += take;
      length2 -= take;
      openStart = 0;
    }
  }
  span(from, to2, active, openStart) {
    this.buildText(to2 - from, active, openStart);
    this.pos = to2;
    if (this.openStart < 0)
      this.openStart = openStart;
  }
  point(from, to2, deco, active, openStart, index2) {
    if (this.disallowBlockEffectsFor[index2] && deco instanceof PointDecoration) {
      if (deco.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (to2 > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let len2 = to2 - from;
    if (deco instanceof PointDecoration) {
      if (deco.block) {
        let { type: type4 } = deco;
        if (type4 == BlockType.WidgetAfter && !this.posCovered())
          this.getLine();
        this.addBlockWidget(new BlockWidgetView(deco.widget || new NullWidget("div"), len2, type4));
      } else {
        let view = WidgetView.create(deco.widget || new NullWidget("span"), len2, len2 ? 0 : deco.startSide);
        let cursorBefore = this.atCursorPos && !view.isEditable && openStart <= active.length && (from < to2 || deco.startSide > 0);
        let cursorAfter = !view.isEditable && (from < to2 || openStart > active.length || deco.startSide <= 0);
        let line = this.getLine();
        if (this.pendingBuffer == 2 && !cursorBefore && !view.isEditable)
          this.pendingBuffer = 0;
        this.flushBuffer(active);
        if (cursorBefore) {
          line.append(wrapMarks(new WidgetBufferView(1), active), openStart);
          openStart = active.length + Math.max(0, openStart - active.length);
        }
        line.append(wrapMarks(view, active), openStart);
        this.atCursorPos = cursorAfter;
        this.pendingBuffer = !cursorAfter ? 0 : from < to2 || openStart > active.length ? 1 : 2;
        if (this.pendingBuffer)
          this.bufferMarks = active.slice();
      }
    } else if (this.doc.lineAt(this.pos).from == this.pos) {
      this.getLine().addLineDeco(deco);
    }
    if (len2) {
      if (this.textOff + len2 <= this.text.length) {
        this.textOff += len2;
      } else {
        this.skip += len2 - (this.text.length - this.textOff);
        this.text = "";
        this.textOff = 0;
      }
      this.pos = to2;
    }
    if (this.openStart < 0)
      this.openStart = openStart;
  }
  static build(text, from, to2, decorations2, dynamicDecorationMap) {
    let builder = new ContentBuilder(text, from, to2, dynamicDecorationMap);
    builder.openEnd = RangeSet.spans(decorations2, from, to2, builder);
    if (builder.openStart < 0)
      builder.openStart = builder.openEnd;
    builder.finish(builder.openEnd);
    return builder;
  }
}
function wrapMarks(view, active) {
  for (let mark of active)
    view = new MarkView(mark, [view], view.length);
  return view;
}
class NullWidget extends WidgetType {
  constructor(tag) {
    super();
    this.tag = tag;
  }
  eq(other) {
    return other.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(elt) {
    return elt.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return true;
  }
}
const clickAddsSelectionRange = /* @__PURE__ */ Facet.define();
const dragMovesSelection$1 = /* @__PURE__ */ Facet.define();
const mouseSelectionStyle = /* @__PURE__ */ Facet.define();
const exceptionSink = /* @__PURE__ */ Facet.define();
const updateListener = /* @__PURE__ */ Facet.define();
const inputHandler$1 = /* @__PURE__ */ Facet.define();
const focusChangeEffect = /* @__PURE__ */ Facet.define();
const perLineTextDirection = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.some((x2) => x2)
});
const nativeSelectionHidden = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.some((x2) => x2)
});
class ScrollTarget {
  constructor(range3, y2 = "nearest", x2 = "nearest", yMargin = 5, xMargin = 5) {
    this.range = range3;
    this.y = y2;
    this.x = x2;
    this.yMargin = yMargin;
    this.xMargin = xMargin;
  }
  map(changes) {
    return changes.empty ? this : new ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin);
  }
}
const scrollIntoView$1 = /* @__PURE__ */ StateEffect.define({ map: (t2, ch2) => t2.map(ch2) });
function logException(state, exception, context) {
  let handler = state.facet(exceptionSink);
  if (handler.length)
    handler[0](exception);
  else if (window.onerror)
    window.onerror(String(exception), context, void 0, void 0, exception);
  else if (context)
    console.error(context + ":", exception);
  else
    console.error(exception);
}
const editable = /* @__PURE__ */ Facet.define({ combine: (values2) => values2.length ? values2[0] : true });
let nextPluginID = 0;
const viewPlugin = /* @__PURE__ */ Facet.define();
class ViewPlugin {
  constructor(id2, create, domEventHandlers, buildExtensions) {
    this.id = id2;
    this.create = create;
    this.domEventHandlers = domEventHandlers;
    this.extension = buildExtensions(this);
  }
  static define(create, spec2) {
    const { eventHandlers, provide: provide2, decorations: deco } = spec2 || {};
    return new ViewPlugin(nextPluginID++, create, eventHandlers, (plugin2) => {
      let ext = [viewPlugin.of(plugin2)];
      if (deco)
        ext.push(decorations.of((view) => {
          let pluginInst = view.plugin(plugin2);
          return pluginInst ? deco(pluginInst) : Decoration.none;
        }));
      if (provide2)
        ext.push(provide2(plugin2));
      return ext;
    });
  }
  static fromClass(cls, spec2) {
    return ViewPlugin.define((view) => new cls(view), spec2);
  }
}
class PluginInstance {
  constructor(spec2) {
    this.spec = spec2;
    this.mustUpdate = null;
    this.value = null;
  }
  update(view) {
    if (!this.value) {
      if (this.spec) {
        try {
          this.value = this.spec.create(view);
        } catch (e25) {
          logException(view.state, e25, "CodeMirror plugin crashed");
          this.deactivate();
        }
      }
    } else if (this.mustUpdate) {
      let update = this.mustUpdate;
      this.mustUpdate = null;
      if (this.value.update) {
        try {
          this.value.update(update);
        } catch (e25) {
          logException(update.state, e25, "CodeMirror plugin crashed");
          if (this.value.destroy)
            try {
              this.value.destroy();
            } catch (_2) {
            }
          this.deactivate();
        }
      }
    }
    return this;
  }
  destroy(view) {
    var _a2;
    if ((_a2 = this.value) === null || _a2 === void 0 ? void 0 : _a2.destroy) {
      try {
        this.value.destroy();
      } catch (e25) {
        logException(view.state, e25, "CodeMirror plugin crashed");
      }
    }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const editorAttributes = /* @__PURE__ */ Facet.define();
const contentAttributes = /* @__PURE__ */ Facet.define();
const decorations = /* @__PURE__ */ Facet.define();
const atomicRanges = /* @__PURE__ */ Facet.define();
const scrollMargins = /* @__PURE__ */ Facet.define();
function getScrollMargins(view) {
  let left = 0, right = 0, top2 = 0, bottom = 0;
  for (let source of view.state.facet(scrollMargins)) {
    let m2 = source(view);
    if (m2) {
      if (m2.left != null)
        left = Math.max(left, m2.left);
      if (m2.right != null)
        right = Math.max(right, m2.right);
      if (m2.top != null)
        top2 = Math.max(top2, m2.top);
      if (m2.bottom != null)
        bottom = Math.max(bottom, m2.bottom);
    }
  }
  return { left, right, top: top2, bottom };
}
const styleModule = /* @__PURE__ */ Facet.define();
class ChangedRange {
  constructor(fromA, toA, fromB, toB) {
    this.fromA = fromA;
    this.toA = toA;
    this.fromB = fromB;
    this.toB = toB;
  }
  join(other) {
    return new ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
  }
  addToSet(set2) {
    let i2 = set2.length, me2 = this;
    for (; i2 > 0; i2--) {
      let range3 = set2[i2 - 1];
      if (range3.fromA > me2.toA)
        continue;
      if (range3.toA < me2.fromA)
        break;
      me2 = me2.join(range3);
      set2.splice(i2 - 1, 1);
    }
    set2.splice(i2, 0, me2);
    return set2;
  }
  static extendWithRanges(diff, ranges) {
    if (ranges.length == 0)
      return diff;
    let result2 = [];
    for (let dI2 = 0, rI2 = 0, posA = 0, posB = 0; ; dI2++) {
      let next = dI2 == diff.length ? null : diff[dI2], off2 = posA - posB;
      let end = next ? next.fromB : 1e9;
      while (rI2 < ranges.length && ranges[rI2] < end) {
        let from = ranges[rI2], to2 = ranges[rI2 + 1];
        let fromB = Math.max(posB, from), toB = Math.min(end, to2);
        if (fromB <= toB)
          new ChangedRange(fromB + off2, toB + off2, fromB, toB).addToSet(result2);
        if (to2 > end)
          break;
        else
          rI2 += 2;
      }
      if (!next)
        return result2;
      new ChangedRange(next.fromA, next.toA, next.fromB, next.toB).addToSet(result2);
      posA = next.toA;
      posB = next.toB;
    }
  }
}
class ViewUpdate {
  constructor(view, state, transactions) {
    this.view = view;
    this.state = state;
    this.transactions = transactions;
    this.flags = 0;
    this.startState = view.state;
    this.changes = ChangeSet.empty(this.startState.doc.length);
    for (let tr2 of transactions)
      this.changes = this.changes.compose(tr2.changes);
    let changedRanges = [];
    this.changes.iterChangedRanges((fromA, toA, fromB, toB) => changedRanges.push(new ChangedRange(fromA, toA, fromB, toB)));
    this.changedRanges = changedRanges;
  }
  static create(view, state, transactions) {
    return new ViewUpdate(view, state, transactions);
  }
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  get geometryChanged() {
    return this.docChanged || (this.flags & (8 | 2)) > 0;
  }
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  get docChanged() {
    return !this.changes.empty;
  }
  get selectionSet() {
    return this.transactions.some((tr2) => tr2.selection);
  }
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
var Direction = /* @__PURE__ */ function(Direction2) {
  Direction2[Direction2["LTR"] = 0] = "LTR";
  Direction2[Direction2["RTL"] = 1] = "RTL";
  return Direction2;
}(Direction || (Direction = {}));
const LTR = Direction.LTR, RTL = Direction.RTL;
function dec(str) {
  let result2 = [];
  for (let i2 = 0; i2 < str.length; i2++)
    result2.push(1 << +str[i2]);
  return result2;
}
const LowTypes = /* @__PURE__ */ dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
const ArabicTypes = /* @__PURE__ */ dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
const Brackets = /* @__PURE__ */ Object.create(null), BracketStack = [];
for (let p2 of ["()", "[]", "{}"]) {
  let l2 = /* @__PURE__ */ p2.charCodeAt(0), r2 = /* @__PURE__ */ p2.charCodeAt(1);
  Brackets[l2] = r2;
  Brackets[r2] = -l2;
}
function charType(ch2) {
  return ch2 <= 247 ? LowTypes[ch2] : 1424 <= ch2 && ch2 <= 1524 ? 2 : 1536 <= ch2 && ch2 <= 1785 ? ArabicTypes[ch2 - 1536] : 1774 <= ch2 && ch2 <= 2220 ? 4 : 8192 <= ch2 && ch2 <= 8203 ? 256 : 64336 <= ch2 && ch2 <= 65023 ? 4 : ch2 == 8204 ? 256 : 1;
}
const BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class BidiSpan {
  constructor(from, to2, level) {
    this.from = from;
    this.to = to2;
    this.level = level;
  }
  get dir() {
    return this.level % 2 ? RTL : LTR;
  }
  side(end, dir) {
    return this.dir == dir == end ? this.to : this.from;
  }
  static find(order, index2, level, assoc) {
    let maybe = -1;
    for (let i2 = 0; i2 < order.length; i2++) {
      let span = order[i2];
      if (span.from <= index2 && span.to >= index2) {
        if (span.level == level)
          return i2;
        if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index2 : span.to > index2 : order[maybe].level > span.level))
          maybe = i2;
      }
    }
    if (maybe < 0)
      throw new RangeError("Index out of range");
    return maybe;
  }
}
const types = [];
function computeOrder(line, direction) {
  let len2 = line.length, outerType = direction == LTR ? 1 : 2, oppositeType = direction == LTR ? 2 : 1;
  if (!line || outerType == 1 && !BidiRE.test(line))
    return trivialOrder(len2);
  for (let i2 = 0, prev = outerType, prevStrong = outerType; i2 < len2; i2++) {
    let type4 = charType(line.charCodeAt(i2));
    if (type4 == 512)
      type4 = prev;
    else if (type4 == 8 && prevStrong == 4)
      type4 = 16;
    types[i2] = type4 == 4 ? 2 : type4;
    if (type4 & 7)
      prevStrong = type4;
    prev = type4;
  }
  for (let i2 = 0, prev = outerType, prevStrong = outerType; i2 < len2; i2++) {
    let type4 = types[i2];
    if (type4 == 128) {
      if (i2 < len2 - 1 && prev == types[i2 + 1] && prev & 24)
        type4 = types[i2] = prev;
      else
        types[i2] = 256;
    } else if (type4 == 64) {
      let end = i2 + 1;
      while (end < len2 && types[end] == 64)
        end++;
      let replace = i2 && prev == 8 || end < len2 && types[end] == 8 ? prevStrong == 1 ? 1 : 8 : 256;
      for (let j2 = i2; j2 < end; j2++)
        types[j2] = replace;
      i2 = end - 1;
    } else if (type4 == 8 && prevStrong == 1) {
      types[i2] = 1;
    }
    prev = type4;
    if (type4 & 7)
      prevStrong = type4;
  }
  for (let i2 = 0, sI2 = 0, context = 0, ch2, br2, type4; i2 < len2; i2++) {
    if (br2 = Brackets[ch2 = line.charCodeAt(i2)]) {
      if (br2 < 0) {
        for (let sJ = sI2 - 3; sJ >= 0; sJ -= 3) {
          if (BracketStack[sJ + 1] == -br2) {
            let flags = BracketStack[sJ + 2];
            let type5 = flags & 2 ? outerType : !(flags & 4) ? 0 : flags & 1 ? oppositeType : outerType;
            if (type5)
              types[i2] = types[BracketStack[sJ]] = type5;
            sI2 = sJ;
            break;
          }
        }
      } else if (BracketStack.length == 189) {
        break;
      } else {
        BracketStack[sI2++] = i2;
        BracketStack[sI2++] = ch2;
        BracketStack[sI2++] = context;
      }
    } else if ((type4 = types[i2]) == 2 || type4 == 1) {
      let embed = type4 == outerType;
      context = embed ? 0 : 1;
      for (let sJ = sI2 - 3; sJ >= 0; sJ -= 3) {
        let cur2 = BracketStack[sJ + 2];
        if (cur2 & 2)
          break;
        if (embed) {
          BracketStack[sJ + 2] |= 2;
        } else {
          if (cur2 & 4)
            break;
          BracketStack[sJ + 2] |= 4;
        }
      }
    }
  }
  for (let i2 = 0; i2 < len2; i2++) {
    if (types[i2] == 256) {
      let end = i2 + 1;
      while (end < len2 && types[end] == 256)
        end++;
      let beforeL = (i2 ? types[i2 - 1] : outerType) == 1;
      let afterL = (end < len2 ? types[end] : outerType) == 1;
      let replace = beforeL == afterL ? beforeL ? 1 : 2 : outerType;
      for (let j2 = i2; j2 < end; j2++)
        types[j2] = replace;
      i2 = end - 1;
    }
  }
  let order = [];
  if (outerType == 1) {
    for (let i2 = 0; i2 < len2; ) {
      let start = i2, rtl = types[i2++] != 1;
      while (i2 < len2 && rtl == (types[i2] != 1))
        i2++;
      if (rtl) {
        for (let j2 = i2; j2 > start; ) {
          let end = j2, l2 = types[--j2] != 2;
          while (j2 > start && l2 == (types[j2 - 1] != 2))
            j2--;
          order.push(new BidiSpan(j2, end, l2 ? 2 : 1));
        }
      } else {
        order.push(new BidiSpan(start, i2, 0));
      }
    }
  } else {
    for (let i2 = 0; i2 < len2; ) {
      let start = i2, rtl = types[i2++] == 2;
      while (i2 < len2 && rtl == (types[i2] == 2))
        i2++;
      order.push(new BidiSpan(start, i2, rtl ? 1 : 2));
    }
  }
  return order;
}
function trivialOrder(length2) {
  return [new BidiSpan(0, length2, 0)];
}
let movedOver = "";
function moveVisually(line, order, dir, start, forward) {
  var _a2;
  let startIndex = start.head - line.from, spanI = -1;
  if (startIndex == 0) {
    if (!forward || !line.length)
      return null;
    if (order[0].level != dir) {
      startIndex = order[0].side(false, dir);
      spanI = 0;
    }
  } else if (startIndex == line.length) {
    if (forward)
      return null;
    let last = order[order.length - 1];
    if (last.level != dir) {
      startIndex = last.side(true, dir);
      spanI = order.length - 1;
    }
  }
  if (spanI < 0)
    spanI = BidiSpan.find(order, startIndex, (_a2 = start.bidiLevel) !== null && _a2 !== void 0 ? _a2 : -1, start.assoc);
  let span = order[spanI];
  if (startIndex == span.side(forward, dir)) {
    span = order[spanI += forward ? 1 : -1];
    startIndex = span.side(!forward, dir);
  }
  let indexForward = forward == (span.dir == dir);
  let nextIndex = findClusterBreak(line.text, startIndex, indexForward);
  movedOver = line.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
  if (nextIndex != span.side(forward, dir))
    return EditorSelection.cursor(nextIndex + line.from, indexForward ? -1 : 1, span.level);
  let nextSpan = spanI == (forward ? order.length - 1 : 0) ? null : order[spanI + (forward ? 1 : -1)];
  if (!nextSpan && span.level != dir)
    return EditorSelection.cursor(forward ? line.to : line.from, forward ? -1 : 1, dir);
  if (nextSpan && nextSpan.level < span.level)
    return EditorSelection.cursor(nextSpan.side(!forward, dir) + line.from, forward ? 1 : -1, nextSpan.level);
  return EditorSelection.cursor(nextIndex + line.from, forward ? -1 : 1, span.level);
}
class DocView extends ContentView {
  constructor(view) {
    super();
    this.view = view;
    this.decorations = [];
    this.dynamicDecorationMap = [];
    this.hasComposition = null;
    this.markedForComposition = new Set();
    this.minWidth = 0;
    this.minWidthFrom = 0;
    this.minWidthTo = 0;
    this.impreciseAnchor = null;
    this.impreciseHead = null;
    this.forceSelection = false;
    this.lastUpdate = Date.now();
    this.setDOM(view.contentDOM);
    this.children = [new LineView()];
    this.children[0].setParent(this);
    this.updateDeco();
    this.updateInner([new ChangedRange(0, 0, 0, view.state.doc.length)], 0, null);
  }
  get length() {
    return this.view.state.doc.length;
  }
  update(update) {
    let changedRanges = update.changedRanges;
    if (this.minWidth > 0 && changedRanges.length) {
      if (!changedRanges.every(({ fromA, toA }) => toA < this.minWidthFrom || fromA > this.minWidthTo)) {
        this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
      } else {
        this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
        this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
      }
    }
    let composition = this.view.inputState.composing < 0 ? null : findCompositionRange(this.view, update.changes);
    if (this.hasComposition) {
      this.markedForComposition.clear();
      let { from, to: to2 } = this.hasComposition;
      changedRanges = new ChangedRange(from, to2, update.changes.mapPos(from, -1), update.changes.mapPos(to2, 1)).addToSet(changedRanges.slice());
    }
    this.hasComposition = composition ? { from: composition.range.fromB, to: composition.range.toB } : null;
    if ((browser.ie || browser.chrome) && !composition && update && update.state.doc.lines != update.startState.doc.lines)
      this.forceSelection = true;
    let prevDeco = this.decorations, deco = this.updateDeco();
    let decoDiff = findChangedDeco(prevDeco, deco, update.changes);
    changedRanges = ChangedRange.extendWithRanges(changedRanges, decoDiff);
    if (!(this.flags & 7) && changedRanges.length == 0) {
      return false;
    } else {
      this.updateInner(changedRanges, update.startState.doc.length, composition);
      if (update.transactions.length)
        this.lastUpdate = Date.now();
      return true;
    }
  }
  updateInner(changes, oldLength, composition) {
    this.view.viewState.mustMeasureContent = true;
    this.updateChildren(changes, oldLength, composition);
    let { observer } = this.view;
    observer.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight + "px";
      this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let track = browser.chrome || browser.ios ? { node: observer.selectionRange.focusNode, written: false } : void 0;
      this.sync(this.view, track);
      this.flags &= ~7;
      if (track && (track.written || observer.selectionRange.focusNode != track.node))
        this.forceSelection = true;
      this.dom.style.height = "";
    });
    this.markedForComposition.forEach((cView) => cView.flags &= ~8);
    let gaps = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
      for (let child of this.children)
        if (child instanceof BlockWidgetView && child.widget instanceof BlockGapWidget)
          gaps.push(child.dom);
    }
    observer.updateGaps(gaps);
  }
  updateChildren(changes, oldLength, composition) {
    let ranges = composition ? composition.range.addToSet(changes.slice()) : changes;
    let cursor = this.childCursor(oldLength);
    for (let i2 = ranges.length - 1; ; i2--) {
      let next = i2 >= 0 ? ranges[i2] : null;
      if (!next)
        break;
      let { fromA, toA, fromB, toB } = next, content2, breakAtStart, openStart, openEnd;
      if (composition && composition.range.fromB < toB && composition.range.toB > fromB) {
        let before = ContentBuilder.build(this.view.state.doc, fromB, composition.range.fromB, this.decorations, this.dynamicDecorationMap);
        let after = ContentBuilder.build(this.view.state.doc, composition.range.toB, toB, this.decorations, this.dynamicDecorationMap);
        breakAtStart = before.breakAtStart;
        openStart = before.openStart;
        openEnd = after.openEnd;
        let compLine = this.compositionView(composition);
        if (after.breakAtStart) {
          compLine.breakAfter = 1;
        } else if (after.content.length && compLine.merge(compLine.length, compLine.length, after.content[0], false, after.openStart, 0)) {
          compLine.breakAfter = after.content[0].breakAfter;
          after.content.shift();
        }
        if (before.content.length && compLine.merge(0, 0, before.content[before.content.length - 1], true, 0, before.openEnd)) {
          before.content.pop();
        }
        content2 = before.content.concat(compLine).concat(after.content);
      } else {
        ({ content: content2, breakAtStart, openStart, openEnd } = ContentBuilder.build(this.view.state.doc, fromB, toB, this.decorations, this.dynamicDecorationMap));
      }
      let { i: toI, off: toOff } = cursor.findPos(toA, 1);
      let { i: fromI, off: fromOff } = cursor.findPos(fromA, -1);
      replaceRange(this, fromI, fromOff, toI, toOff, content2, breakAtStart, openStart, openEnd);
    }
    if (composition)
      this.fixCompositionDOM(composition);
  }
  compositionView(composition) {
    let cur2 = new TextView(composition.text.nodeValue);
    cur2.flags |= 8;
    for (let { deco } of composition.marks)
      cur2 = new MarkView(deco, [cur2], cur2.length);
    let line = new LineView();
    line.append(cur2, 0);
    return line;
  }
  fixCompositionDOM(composition) {
    let fix = (dom, cView2) => {
      cView2.flags |= 8;
      this.markedForComposition.add(cView2);
      let prev = ContentView.get(dom);
      if (prev != cView2) {
        if (prev)
          prev.dom = null;
        cView2.setDOM(dom);
      }
    };
    let pos = this.childPos(composition.range.fromB, 1);
    let cView = this.children[pos.i];
    fix(composition.line, cView);
    for (let i2 = composition.marks.length - 1; i2 >= -1; i2--) {
      pos = cView.childPos(pos.off, 1);
      cView = cView.children[pos.i];
      fix(i2 >= 0 ? composition.marks[i2].node : composition.text, cView);
    }
  }
  updateSelection(mustRead = false, fromPointer = false) {
    if (mustRead || !this.view.observer.selectionRange.focusNode)
      this.view.observer.readSelectionRange();
    let activeElt = this.view.root.activeElement, focused = activeElt == this.dom;
    let selectionNotFocus = !focused && hasSelection(this.dom, this.view.observer.selectionRange) && !(activeElt && this.dom.contains(activeElt));
    if (!(focused || fromPointer || selectionNotFocus))
      return;
    let force = this.forceSelection;
    this.forceSelection = false;
    let main = this.view.state.selection.main;
    let anchor = this.domAtPos(main.anchor);
    let head = main.empty ? anchor : this.domAtPos(main.head);
    if (browser.gecko && main.empty && !this.hasComposition && betweenUneditable(anchor)) {
      let dummy = document.createTextNode("");
      this.view.observer.ignore(() => anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
      anchor = head = new DOMPos(dummy, 0);
      force = true;
    }
    let domSel = this.view.observer.selectionRange;
    if (force || !domSel.focusNode || !isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) {
      this.view.observer.ignore(() => {
        if (browser.android && browser.chrome && this.dom.contains(domSel.focusNode) && inUneditable(domSel.focusNode, this.dom)) {
          this.dom.blur();
          this.dom.focus({ preventScroll: true });
        }
        let rawSel = getSelection(this.view.root);
        if (!rawSel)
          ;
        else if (main.empty) {
          if (browser.gecko) {
            let nextTo = nextToUneditable(anchor.node, anchor.offset);
            if (nextTo && nextTo != (1 | 2)) {
              let text = nearbyTextNode(anchor.node, anchor.offset, nextTo == 1 ? 1 : -1);
              if (text)
                anchor = new DOMPos(text, nextTo == 1 ? 0 : text.nodeValue.length);
            }
          }
          rawSel.collapse(anchor.node, anchor.offset);
          if (main.bidiLevel != null && domSel.cursorBidiLevel != null)
            domSel.cursorBidiLevel = main.bidiLevel;
        } else if (rawSel.extend) {
          rawSel.collapse(anchor.node, anchor.offset);
          try {
            rawSel.extend(head.node, head.offset);
          } catch (_2) {
          }
        } else {
          let range3 = document.createRange();
          if (main.anchor > main.head)
            [anchor, head] = [head, anchor];
          range3.setEnd(head.node, head.offset);
          range3.setStart(anchor.node, anchor.offset);
          rawSel.removeAllRanges();
          rawSel.addRange(range3);
        }
        if (selectionNotFocus && this.view.root.activeElement == this.dom) {
          this.dom.blur();
          if (activeElt)
            activeElt.focus();
        }
      });
      this.view.observer.setSelectionRange(anchor, head);
    }
    this.impreciseAnchor = anchor.precise ? null : new DOMPos(domSel.anchorNode, domSel.anchorOffset);
    this.impreciseHead = head.precise ? null : new DOMPos(domSel.focusNode, domSel.focusOffset);
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view } = this, cursor = view.state.selection.main;
    let sel = getSelection(view.root);
    let { anchorNode, anchorOffset } = view.observer.selectionRange;
    if (!sel || !cursor.empty || !cursor.assoc || !sel.modify)
      return;
    let line = LineView.find(this, cursor.head);
    if (!line)
      return;
    let lineStart = line.posAtStart;
    if (cursor.head == lineStart || cursor.head == lineStart + line.length)
      return;
    let before = this.coordsAt(cursor.head, -1), after = this.coordsAt(cursor.head, 1);
    if (!before || !after || before.bottom > after.top)
      return;
    let dom = this.domAtPos(cursor.head + cursor.assoc);
    sel.collapse(dom.node, dom.offset);
    sel.modify("move", cursor.assoc < 0 ? "forward" : "backward", "lineboundary");
    view.observer.readSelectionRange();
    let newRange = view.observer.selectionRange;
    if (view.docView.posFromDOM(newRange.anchorNode, newRange.anchorOffset) != cursor.from)
      sel.collapse(anchorNode, anchorOffset);
  }
  nearest(dom) {
    for (let cur2 = dom; cur2; ) {
      let domView = ContentView.get(cur2);
      if (domView && domView.rootView == this)
        return domView;
      cur2 = cur2.parentNode;
    }
    return null;
  }
  posFromDOM(node2, offset) {
    let view = this.nearest(node2);
    if (!view)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return view.localPosFromDOM(node2, offset) + view.posAtStart;
  }
  domAtPos(pos) {
    let { i: i2, off: off2 } = this.childCursor().findPos(pos, -1);
    for (; i2 < this.children.length - 1; ) {
      let child = this.children[i2];
      if (off2 < child.length || child instanceof LineView)
        break;
      i2++;
      off2 = 0;
    }
    return this.children[i2].domAtPos(off2);
  }
  coordsAt(pos, side) {
    for (let off2 = this.length, i2 = this.children.length - 1; ; i2--) {
      let child = this.children[i2], start = off2 - child.breakAfter - child.length;
      if (pos > start || pos == start && child.type != BlockType.WidgetBefore && child.type != BlockType.WidgetAfter && (!i2 || side == 2 || this.children[i2 - 1].breakAfter || this.children[i2 - 1].type == BlockType.WidgetBefore && side > -2))
        return child.coordsAt(pos - start, side);
      off2 = start;
    }
  }
  coordsForChar(pos) {
    let { i: i2, off: off2 } = this.childPos(pos, 1), child = this.children[i2];
    if (!(child instanceof LineView))
      return null;
    while (child.children.length) {
      let { i: i3, off: childOff } = child.childPos(off2, 1);
      for (; ; i3++) {
        if (i3 == child.children.length)
          return null;
        if ((child = child.children[i3]).length)
          break;
      }
      off2 = childOff;
    }
    if (!(child instanceof TextView))
      return null;
    let end = findClusterBreak(child.text, off2);
    if (end == off2)
      return null;
    let rects = textRange(child.dom, off2, end).getClientRects();
    return !rects.length || rects[0].top >= rects[0].bottom ? null : rects[0];
  }
  measureVisibleLineHeights(viewport) {
    let result2 = [], { from, to: to2 } = viewport;
    let contentWidth = this.view.contentDOM.clientWidth;
    let isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
    let widest = -1, ltr = this.view.textDirection == Direction.LTR;
    for (let pos = 0, i2 = 0; i2 < this.children.length; i2++) {
      let child = this.children[i2], end = pos + child.length;
      if (end > to2)
        break;
      if (pos >= from) {
        let childRect = child.dom.getBoundingClientRect();
        result2.push(childRect.height);
        if (isWider) {
          let last = child.dom.lastChild;
          let rects = last ? clientRectsFor(last) : [];
          if (rects.length) {
            let rect = rects[rects.length - 1];
            let width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
            if (width > widest) {
              widest = width;
              this.minWidth = contentWidth;
              this.minWidthFrom = pos;
              this.minWidthTo = end;
            }
          }
        }
      }
      pos = end + child.breakAfter;
    }
    return result2;
  }
  textDirectionAt(pos) {
    let { i: i2 } = this.childPos(pos, 1);
    return getComputedStyle(this.children[i2].dom).direction == "rtl" ? Direction.RTL : Direction.LTR;
  }
  measureTextSize() {
    for (let child of this.children) {
      if (child instanceof LineView) {
        let measure = child.measureTextSize();
        if (measure)
          return measure;
      }
    }
    let dummy = document.createElement("div"), lineHeight2, charWidth, textHeight;
    dummy.className = "cm-line";
    dummy.style.width = "99999px";
    dummy.style.position = "absolute";
    dummy.textContent = "abc def ghi jkl mno pqr stu";
    this.view.observer.ignore(() => {
      this.dom.appendChild(dummy);
      let rect = clientRectsFor(dummy.firstChild)[0];
      lineHeight2 = dummy.getBoundingClientRect().height;
      charWidth = rect ? rect.width / 27 : 7;
      textHeight = rect ? rect.height : lineHeight2;
      dummy.remove();
    });
    return { lineHeight: lineHeight2, charWidth, textHeight };
  }
  childCursor(pos = this.length) {
    let i2 = this.children.length;
    if (i2)
      pos -= this.children[--i2].length;
    return new ChildCursor(this.children, pos, i2);
  }
  computeBlockGapDeco() {
    let deco = [], vs = this.view.viewState;
    for (let pos = 0, i2 = 0; ; i2++) {
      let next = i2 == vs.viewports.length ? null : vs.viewports[i2];
      let end = next ? next.from - 1 : this.length;
      if (end > pos) {
        let height = vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top;
        deco.push(Decoration.replace({
          widget: new BlockGapWidget(height),
          block: true,
          inclusive: true,
          isBlockGap: true
        }).range(pos, end));
      }
      if (!next)
        break;
      pos = next.to + 1;
    }
    return Decoration.set(deco);
  }
  updateDeco() {
    let allDeco = this.view.state.facet(decorations).map((d2, i2) => {
      let dynamic = this.dynamicDecorationMap[i2] = typeof d2 == "function";
      return dynamic ? d2(this.view) : d2;
    });
    for (let i2 = allDeco.length; i2 < allDeco.length + 3; i2++)
      this.dynamicDecorationMap[i2] = false;
    return this.decorations = [
      ...allDeco,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ];
  }
  scrollIntoView(target) {
    let { range: range3 } = target;
    let rect = this.coordsAt(range3.head, range3.empty ? range3.assoc : range3.head > range3.anchor ? -1 : 1), other;
    if (!rect)
      return;
    if (!range3.empty && (other = this.coordsAt(range3.anchor, range3.anchor > range3.head ? -1 : 1)))
      rect = {
        left: Math.min(rect.left, other.left),
        top: Math.min(rect.top, other.top),
        right: Math.max(rect.right, other.right),
        bottom: Math.max(rect.bottom, other.bottom)
      };
    let margins = getScrollMargins(this.view);
    let targetRect = {
      left: rect.left - margins.left,
      top: rect.top - margins.top,
      right: rect.right + margins.right,
      bottom: rect.bottom + margins.bottom
    };
    scrollRectIntoView(this.view.scrollDOM, targetRect, range3.head < range3.anchor ? -1 : 1, target.x, target.y, target.xMargin, target.yMargin, this.view.textDirection == Direction.LTR);
  }
}
function betweenUneditable(pos) {
  return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
class BlockGapWidget extends WidgetType {
  constructor(height) {
    super();
    this.height = height;
  }
  toDOM() {
    let elt = document.createElement("div");
    this.updateDOM(elt);
    return elt;
  }
  eq(other) {
    return other.height == this.height;
  }
  updateDOM(elt) {
    elt.style.height = this.height + "px";
    return true;
  }
  get estimatedHeight() {
    return this.height;
  }
}
function findCompositionNode(view) {
  let sel = view.observer.selectionRange;
  let textNode = sel.focusNode && nearbyTextNode(sel.focusNode, sel.focusOffset, 0);
  if (!textNode)
    return null;
  let cView = ContentView.get(textNode);
  let from, to2;
  if (cView instanceof TextView) {
    from = cView.posAtStart;
    to2 = from + cView.length;
  } else {
    up:
      for (let offset = 0, node2 = textNode; ; ) {
        for (let sibling = node2.previousSibling, cView2; sibling; sibling = sibling.previousSibling) {
          if (cView2 = ContentView.get(sibling)) {
            from = to2 = cView2.posAtEnd + offset;
            break up;
          }
          let reader = new DOMReader([], view.state);
          reader.readNode(sibling);
          if (reader.text.indexOf(LineBreakPlaceholder) > -1)
            return null;
          offset += reader.text.length;
        }
        node2 = node2.parentNode;
        if (!node2)
          return null;
        let parentView = ContentView.get(node2);
        if (parentView) {
          from = to2 = parentView.posAtStart + offset;
          break;
        }
      }
  }
  return { from, to: to2, node: textNode };
}
function findCompositionRange(view, changes) {
  let found = findCompositionNode(view);
  if (!found)
    return null;
  let { from: fromA, to: toA, node: textNode } = found;
  let fromB = changes.mapPos(fromA, -1), toB = changes.mapPos(toA, 1);
  let text = textNode.nodeValue;
  if (/[\n\r]/.test(text))
    return null;
  if (toB - fromB != text.length) {
    let fromB2 = changes.mapPos(fromA, 1), toB2 = changes.mapPos(toA, -1);
    if (toB2 - fromB2 == text.length)
      fromB = fromB2, toB = toB2;
    else if (view.state.doc.sliceString(toB - text.length, toB) == text)
      fromB = toB - text.length;
    else if (view.state.doc.sliceString(fromB, fromB + text.length) == text)
      toB = fromB + text.length;
    else
      return null;
  }
  let { main } = view.state.selection;
  if (view.state.doc.sliceString(fromB, toB) != text || fromB > main.head || toB < main.head)
    return null;
  let marks = [];
  let range3 = new ChangedRange(fromA, toA, fromB, toB);
  for (let parent = textNode.parentNode; ; parent = parent.parentNode) {
    let parentView = ContentView.get(parent);
    if (parentView instanceof MarkView)
      marks.push({ node: parent, deco: parentView.mark });
    else if (parentView instanceof LineView || parent.nodeName == "DIV" && parent.parentNode == view.contentDOM)
      return { range: range3, text: textNode, marks, line: parent };
    else if (parent != view.contentDOM)
      marks.push({ node: parent, deco: new MarkDecoration({
        inclusive: true,
        attributes: getAttrs(parent),
        tagName: parent.tagName.toLowerCase()
      }) });
    else
      return null;
  }
}
function nearbyTextNode(startNode, startOffset, side) {
  if (side <= 0)
    for (let node2 = startNode, offset = startOffset; ; ) {
      if (node2.nodeType == 3)
        return node2;
      if (node2.nodeType == 1 && offset > 0) {
        node2 = node2.childNodes[offset - 1];
        offset = maxOffset(node2);
      } else {
        break;
      }
    }
  if (side >= 0)
    for (let node2 = startNode, offset = startOffset; ; ) {
      if (node2.nodeType == 3)
        return node2;
      if (node2.nodeType == 1 && offset < node2.childNodes.length && side >= 0) {
        node2 = node2.childNodes[offset];
        offset = 0;
      } else {
        break;
      }
    }
  return null;
}
function nextToUneditable(node2, offset) {
  if (node2.nodeType != 1)
    return 0;
  return (offset && node2.childNodes[offset - 1].contentEditable == "false" ? 1 : 0) | (offset < node2.childNodes.length && node2.childNodes[offset].contentEditable == "false" ? 2 : 0);
}
class DecorationComparator$1 {
  constructor() {
    this.changes = [];
  }
  compareRange(from, to2) {
    addRange(from, to2, this.changes);
  }
  comparePoint(from, to2) {
    addRange(from, to2, this.changes);
  }
}
function findChangedDeco(a2, b2, diff) {
  let comp = new DecorationComparator$1();
  RangeSet.compare(a2, b2, diff, comp);
  return comp.changes;
}
function inUneditable(node2, inside2) {
  for (let cur2 = node2; cur2 && cur2 != inside2; cur2 = cur2.assignedSlot || cur2.parentNode) {
    if (cur2.nodeType == 1 && cur2.contentEditable == "false") {
      return true;
    }
  }
  return false;
}
function groupAt(state, pos, bias = 1) {
  let categorize = state.charCategorizer(pos);
  let line = state.doc.lineAt(pos), linePos = pos - line.from;
  if (line.length == 0)
    return EditorSelection.cursor(pos);
  if (linePos == 0)
    bias = 1;
  else if (linePos == line.length)
    bias = -1;
  let from = linePos, to2 = linePos;
  if (bias < 0)
    from = findClusterBreak(line.text, linePos, false);
  else
    to2 = findClusterBreak(line.text, linePos);
  let cat = categorize(line.text.slice(from, to2));
  while (from > 0) {
    let prev = findClusterBreak(line.text, from, false);
    if (categorize(line.text.slice(prev, from)) != cat)
      break;
    from = prev;
  }
  while (to2 < line.length) {
    let next = findClusterBreak(line.text, to2);
    if (categorize(line.text.slice(to2, next)) != cat)
      break;
    to2 = next;
  }
  return EditorSelection.range(from + line.from, to2 + line.from);
}
function getdx(x2, rect) {
  return rect.left > x2 ? rect.left - x2 : Math.max(0, x2 - rect.right);
}
function getdy(y2, rect) {
  return rect.top > y2 ? rect.top - y2 : Math.max(0, y2 - rect.bottom);
}
function yOverlap(a2, b2) {
  return a2.top < b2.bottom - 1 && a2.bottom > b2.top + 1;
}
function upTop(rect, top2) {
  return top2 < rect.top ? { top: top2, left: rect.left, right: rect.right, bottom: rect.bottom } : rect;
}
function upBot(rect, bottom) {
  return bottom > rect.bottom ? { top: rect.top, left: rect.left, right: rect.right, bottom } : rect;
}
function domPosAtCoords(parent, x2, y2) {
  let closest, closestRect, closestX, closestY, closestOverlap = false;
  let above, below, aboveRect, belowRect;
  for (let child = parent.firstChild; child; child = child.nextSibling) {
    let rects = clientRectsFor(child);
    for (let i2 = 0; i2 < rects.length; i2++) {
      let rect = rects[i2];
      if (closestRect && yOverlap(closestRect, rect))
        rect = upTop(upBot(rect, closestRect.bottom), closestRect.top);
      let dx2 = getdx(x2, rect), dy2 = getdy(y2, rect);
      if (dx2 == 0 && dy2 == 0)
        return child.nodeType == 3 ? domPosInText(child, x2, y2) : domPosAtCoords(child, x2, y2);
      if (!closest || closestY > dy2 || closestY == dy2 && closestX > dx2) {
        closest = child;
        closestRect = rect;
        closestX = dx2;
        closestY = dy2;
        let side = dy2 ? y2 < rect.top ? -1 : 1 : dx2 ? x2 < rect.left ? -1 : 1 : 0;
        closestOverlap = !side || (side > 0 ? i2 < rects.length - 1 : i2 > 0);
      }
      if (dx2 == 0) {
        if (y2 > rect.bottom && (!aboveRect || aboveRect.bottom < rect.bottom)) {
          above = child;
          aboveRect = rect;
        } else if (y2 < rect.top && (!belowRect || belowRect.top > rect.top)) {
          below = child;
          belowRect = rect;
        }
      } else if (aboveRect && yOverlap(aboveRect, rect)) {
        aboveRect = upBot(aboveRect, rect.bottom);
      } else if (belowRect && yOverlap(belowRect, rect)) {
        belowRect = upTop(belowRect, rect.top);
      }
    }
  }
  if (aboveRect && aboveRect.bottom >= y2) {
    closest = above;
    closestRect = aboveRect;
  } else if (belowRect && belowRect.top <= y2) {
    closest = below;
    closestRect = belowRect;
  }
  if (!closest)
    return { node: parent, offset: 0 };
  let clipX = Math.max(closestRect.left, Math.min(closestRect.right, x2));
  if (closest.nodeType == 3)
    return domPosInText(closest, clipX, y2);
  if (closestOverlap && closest.contentEditable != "false")
    return domPosAtCoords(closest, clipX, y2);
  let offset = Array.prototype.indexOf.call(parent.childNodes, closest) + (x2 >= (closestRect.left + closestRect.right) / 2 ? 1 : 0);
  return { node: parent, offset };
}
function domPosInText(node2, x2, y2) {
  let len2 = node2.nodeValue.length;
  let closestOffset = -1, closestDY = 1e9, generalSide = 0;
  for (let i2 = 0; i2 < len2; i2++) {
    let rects = textRange(node2, i2, i2 + 1).getClientRects();
    for (let j2 = 0; j2 < rects.length; j2++) {
      let rect = rects[j2];
      if (rect.top == rect.bottom)
        continue;
      if (!generalSide)
        generalSide = x2 - rect.left;
      let dy2 = (rect.top > y2 ? rect.top - y2 : y2 - rect.bottom) - 1;
      if (rect.left - 1 <= x2 && rect.right + 1 >= x2 && dy2 < closestDY) {
        let right = x2 >= (rect.left + rect.right) / 2, after = right;
        if (browser.chrome || browser.gecko) {
          let rectBefore = textRange(node2, i2).getBoundingClientRect();
          if (rectBefore.left == rect.right)
            after = !right;
        }
        if (dy2 <= 0)
          return { node: node2, offset: i2 + (after ? 1 : 0) };
        closestOffset = i2 + (after ? 1 : 0);
        closestDY = dy2;
      }
    }
  }
  return { node: node2, offset: closestOffset > -1 ? closestOffset : generalSide > 0 ? node2.nodeValue.length : 0 };
}
function posAtCoords(view, coords, precise, bias = -1) {
  var _a2, _b2;
  let content2 = view.contentDOM.getBoundingClientRect(), docTop = content2.top + view.viewState.paddingTop;
  let block, { docHeight } = view.viewState;
  let { x: x2, y: y2 } = coords, yOffset = y2 - docTop;
  if (yOffset < 0)
    return 0;
  if (yOffset > docHeight)
    return view.state.doc.length;
  for (let halfLine = view.viewState.heightOracle.textHeight / 2, bounced = false; ; ) {
    block = view.elementAtHeight(yOffset);
    if (block.type == BlockType.Text)
      break;
    for (; ; ) {
      yOffset = bias > 0 ? block.bottom + halfLine : block.top - halfLine;
      if (yOffset >= 0 && yOffset <= docHeight)
        break;
      if (bounced)
        return precise ? null : 0;
      bounced = true;
      bias = -bias;
    }
  }
  y2 = docTop + yOffset;
  let lineStart = block.from;
  if (lineStart < view.viewport.from)
    return view.viewport.from == 0 ? 0 : precise ? null : posAtCoordsImprecise(view, content2, block, x2, y2);
  if (lineStart > view.viewport.to)
    return view.viewport.to == view.state.doc.length ? view.state.doc.length : precise ? null : posAtCoordsImprecise(view, content2, block, x2, y2);
  let doc2 = view.dom.ownerDocument;
  let root2 = view.root.elementFromPoint ? view.root : doc2;
  let element = root2.elementFromPoint(x2, y2);
  if (element && !view.contentDOM.contains(element))
    element = null;
  if (!element) {
    x2 = Math.max(content2.left + 1, Math.min(content2.right - 1, x2));
    element = root2.elementFromPoint(x2, y2);
    if (element && !view.contentDOM.contains(element))
      element = null;
  }
  let node2, offset = -1;
  if (element && ((_a2 = view.docView.nearest(element)) === null || _a2 === void 0 ? void 0 : _a2.isEditable) != false) {
    if (doc2.caretPositionFromPoint) {
      let pos = doc2.caretPositionFromPoint(x2, y2);
      if (pos)
        ({ offsetNode: node2, offset } = pos);
    } else if (doc2.caretRangeFromPoint) {
      let range3 = doc2.caretRangeFromPoint(x2, y2);
      if (range3) {
        ({ startContainer: node2, startOffset: offset } = range3);
        if (!view.contentDOM.contains(node2) || browser.safari && isSuspiciousSafariCaretResult(node2, offset, x2) || browser.chrome && isSuspiciousChromeCaretResult(node2, offset, x2))
          node2 = void 0;
      }
    }
  }
  if (!node2 || !view.docView.dom.contains(node2)) {
    let line = LineView.find(view.docView, lineStart);
    if (!line)
      return yOffset > block.top + block.height / 2 ? block.to : block.from;
    ({ node: node2, offset } = domPosAtCoords(line.dom, x2, y2));
  }
  let nearest = view.docView.nearest(node2);
  if (!nearest)
    return null;
  if (nearest.isWidget && ((_b2 = nearest.dom) === null || _b2 === void 0 ? void 0 : _b2.nodeType) == 1) {
    let rect = nearest.dom.getBoundingClientRect();
    return coords.y < rect.top || coords.y <= rect.bottom && coords.x <= (rect.left + rect.right) / 2 ? nearest.posAtStart : nearest.posAtEnd;
  } else {
    return nearest.localPosFromDOM(node2, offset) + nearest.posAtStart;
  }
}
function posAtCoordsImprecise(view, contentRect, block, x2, y2) {
  let into = Math.round((x2 - contentRect.left) * view.defaultCharacterWidth);
  if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
    let textHeight = view.viewState.heightOracle.textHeight;
    let line = Math.floor((y2 - block.top - (view.defaultLineHeight - textHeight) * 0.5) / textHeight);
    into += line * view.viewState.heightOracle.lineLength;
  }
  let content2 = view.state.sliceDoc(block.from, block.to);
  return block.from + findColumn(content2, into, view.state.tabSize);
}
function isSuspiciousSafariCaretResult(node2, offset, x2) {
  let len2;
  if (node2.nodeType != 3 || offset != (len2 = node2.nodeValue.length))
    return false;
  for (let next = node2.nextSibling; next; next = next.nextSibling)
    if (next.nodeType != 1 || next.nodeName != "BR")
      return false;
  return textRange(node2, len2 - 1, len2).getBoundingClientRect().left > x2;
}
function isSuspiciousChromeCaretResult(node2, offset, x2) {
  if (offset != 0)
    return false;
  for (let cur2 = node2; ; ) {
    let parent = cur2.parentNode;
    if (!parent || parent.nodeType != 1 || parent.firstChild != cur2)
      return false;
    if (parent.classList.contains("cm-line"))
      break;
    cur2 = parent;
  }
  let rect = node2.nodeType == 1 ? node2.getBoundingClientRect() : textRange(node2, 0, Math.max(node2.nodeValue.length, 1)).getBoundingClientRect();
  return x2 - rect.left > 5;
}
function blockAt(view, pos) {
  let line = view.lineBlockAt(pos);
  if (Array.isArray(line.type))
    for (let l2 of line.type) {
      if (l2.to > pos || l2.to == pos && (l2.to == line.to || l2.type == BlockType.Text))
        return l2;
    }
  return line;
}
function moveToLineBoundary(view, start, forward, includeWrap) {
  let line = blockAt(view, start.head);
  let coords = !includeWrap || line.type != BlockType.Text || !(view.lineWrapping || line.widgetLineBreaks) ? null : view.coordsAtPos(start.assoc < 0 && start.head > line.from ? start.head - 1 : start.head);
  if (coords) {
    let editorRect = view.dom.getBoundingClientRect();
    let direction = view.textDirectionAt(line.from);
    let pos = view.posAtCoords({
      x: forward == (direction == Direction.LTR) ? editorRect.right - 1 : editorRect.left + 1,
      y: (coords.top + coords.bottom) / 2
    });
    if (pos != null)
      return EditorSelection.cursor(pos, forward ? -1 : 1);
  }
  return EditorSelection.cursor(forward ? line.to : line.from, forward ? -1 : 1);
}
function moveByChar(view, start, forward, by2) {
  let line = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line);
  let direction = view.textDirectionAt(line.from);
  for (let cur2 = start, check = null; ; ) {
    let next = moveVisually(line, spans, direction, cur2, forward), char = movedOver;
    if (!next) {
      if (line.number == (forward ? view.state.doc.lines : 1))
        return cur2;
      char = "\n";
      line = view.state.doc.line(line.number + (forward ? 1 : -1));
      spans = view.bidiSpans(line);
      next = EditorSelection.cursor(forward ? line.from : line.to);
    }
    if (!check) {
      if (!by2)
        return next;
      check = by2(char);
    } else if (!check(char)) {
      return cur2;
    }
    cur2 = next;
  }
}
function byGroup(view, pos, start) {
  let categorize = view.state.charCategorizer(pos);
  let cat = categorize(start);
  return (next) => {
    let nextCat = categorize(next);
    if (cat == CharCategory.Space)
      cat = nextCat;
    return cat == nextCat;
  };
}
function moveVertically(view, start, forward, distance) {
  let startPos = start.head, dir = forward ? 1 : -1;
  if (startPos == (forward ? view.state.doc.length : 0))
    return EditorSelection.cursor(startPos, start.assoc);
  let goal = start.goalColumn, startY;
  let rect = view.contentDOM.getBoundingClientRect();
  let startCoords = view.coordsAtPos(startPos), docTop = view.documentTop;
  if (startCoords) {
    if (goal == null)
      goal = startCoords.left - rect.left;
    startY = dir < 0 ? startCoords.top : startCoords.bottom;
  } else {
    let line = view.viewState.lineBlockAt(startPos);
    if (goal == null)
      goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line.from));
    startY = (dir < 0 ? line.top : line.bottom) + docTop;
  }
  let resolvedGoal = rect.left + goal;
  let dist2 = distance !== null && distance !== void 0 ? distance : view.viewState.heightOracle.textHeight >> 1;
  for (let extra = 0; ; extra += 10) {
    let curY = startY + (dist2 + extra) * dir;
    let pos = posAtCoords(view, { x: resolvedGoal, y: curY }, false, dir);
    if (curY < rect.top || curY > rect.bottom || (dir < 0 ? pos < startPos : pos > startPos))
      return EditorSelection.cursor(pos, start.assoc, void 0, goal);
  }
}
function skipAtomicRanges(atoms, pos, bias) {
  for (; ; ) {
    let moved = 0;
    for (let set2 of atoms) {
      set2.between(pos - 1, pos + 1, (from, to2, value2) => {
        if (pos > from && pos < to2) {
          let side = moved || bias || (pos - from < to2 - pos ? -1 : 1);
          pos = side < 0 ? from : to2;
          moved = side;
        }
      });
    }
    if (!moved)
      return pos;
  }
}
function skipAtoms(view, oldPos, pos) {
  let newPos = skipAtomicRanges(view.state.facet(atomicRanges).map((f2) => f2(view)), pos.from, oldPos.head > pos.from ? -1 : 1);
  return newPos == pos.from ? pos : EditorSelection.cursor(newPos, newPos < pos.from ? 1 : -1);
}
class InputState {
  constructor(view) {
    this.lastKeyCode = 0;
    this.lastKeyTime = 0;
    this.lastTouchTime = 0;
    this.lastFocusTime = 0;
    this.lastScrollTop = 0;
    this.lastScrollLeft = 0;
    this.chromeScrollHack = -1;
    this.pendingIOSKey = void 0;
    this.lastSelectionOrigin = null;
    this.lastSelectionTime = 0;
    this.lastEscPress = 0;
    this.lastContextMenu = 0;
    this.scrollHandlers = [];
    this.registeredEvents = [];
    this.customHandlers = [];
    this.composing = -1;
    this.compositionFirstChange = null;
    this.compositionEndedAt = 0;
    this.compositionPendingKey = false;
    this.compositionPendingChange = false;
    this.mouseSelection = null;
    let handleEvent = (handler, event) => {
      if (this.ignoreDuringComposition(event))
        return;
      if (event.type == "keydown" && this.keydown(view, event))
        return;
      if (this.mustFlushObserver(event))
        view.observer.forceFlush();
      if (this.runCustomHandlers(event.type, view, event))
        event.preventDefault();
      else
        handler(view, event);
    };
    for (let type4 in handlers) {
      let handler = handlers[type4];
      view.contentDOM.addEventListener(type4, (event) => {
        if (eventBelongsToEditor(view, event))
          handleEvent(handler, event);
      }, handlerOptions[type4]);
      this.registeredEvents.push(type4);
    }
    view.scrollDOM.addEventListener("mousedown", (event) => {
      if (event.target == view.scrollDOM && event.clientY > view.contentDOM.getBoundingClientRect().bottom) {
        handleEvent(handlers.mousedown, event);
        if (!event.defaultPrevented && event.button == 2) {
          let start = view.contentDOM.style.minHeight;
          view.contentDOM.style.minHeight = "100%";
          setTimeout(() => view.contentDOM.style.minHeight = start, 200);
        }
      }
    });
    view.scrollDOM.addEventListener("drop", (event) => {
      if (event.target == view.scrollDOM && event.clientY > view.contentDOM.getBoundingClientRect().bottom)
        handleEvent(handlers.drop, event);
    });
    if (browser.chrome && browser.chrome_version == 102) {
      view.scrollDOM.addEventListener("wheel", () => {
        if (this.chromeScrollHack < 0)
          view.contentDOM.style.pointerEvents = "none";
        else
          window.clearTimeout(this.chromeScrollHack);
        this.chromeScrollHack = setTimeout(() => {
          this.chromeScrollHack = -1;
          view.contentDOM.style.pointerEvents = "";
        }, 100);
      }, { passive: true });
    }
    this.notifiedFocused = view.hasFocus;
    if (browser.safari)
      view.contentDOM.addEventListener("input", () => null);
  }
  setSelectionOrigin(origin) {
    this.lastSelectionOrigin = origin;
    this.lastSelectionTime = Date.now();
  }
  ensureHandlers(view, plugins) {
    var _a2;
    let handlers2;
    this.customHandlers = [];
    for (let plugin2 of plugins)
      if (handlers2 = (_a2 = plugin2.update(view).spec) === null || _a2 === void 0 ? void 0 : _a2.domEventHandlers) {
        this.customHandlers.push({ plugin: plugin2.value, handlers: handlers2 });
        for (let type4 in handlers2)
          if (this.registeredEvents.indexOf(type4) < 0 && type4 != "scroll") {
            this.registeredEvents.push(type4);
            view.contentDOM.addEventListener(type4, (event) => {
              if (!eventBelongsToEditor(view, event))
                return;
              if (this.runCustomHandlers(type4, view, event))
                event.preventDefault();
            });
          }
      }
  }
  runCustomHandlers(type4, view, event) {
    for (let set2 of this.customHandlers) {
      let handler = set2.handlers[type4];
      if (handler) {
        try {
          if (handler.call(set2.plugin, event, view) || event.defaultPrevented)
            return true;
        } catch (e25) {
          logException(view.state, e25);
        }
      }
    }
    return false;
  }
  runScrollHandlers(view, event) {
    this.lastScrollTop = view.scrollDOM.scrollTop;
    this.lastScrollLeft = view.scrollDOM.scrollLeft;
    for (let set2 of this.customHandlers) {
      let handler = set2.handlers.scroll;
      if (handler) {
        try {
          handler.call(set2.plugin, event, view);
        } catch (e25) {
          logException(view.state, e25);
        }
      }
    }
  }
  keydown(view, event) {
    this.lastKeyCode = event.keyCode;
    this.lastKeyTime = Date.now();
    if (event.keyCode == 9 && Date.now() < this.lastEscPress + 2e3)
      return true;
    if (event.keyCode != 27 && modifierCodes.indexOf(event.keyCode) < 0)
      view.inputState.lastEscPress = 0;
    if (browser.android && browser.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
      view.observer.delayAndroidKey(event.key, event.keyCode);
      return true;
    }
    let pending;
    if (browser.ios && !event.synthetic && !event.altKey && !event.metaKey && ((pending = PendingKeys.find((key) => key.keyCode == event.keyCode)) && !event.ctrlKey || EmacsyPendingKeys.indexOf(event.key) > -1 && event.ctrlKey && !event.shiftKey)) {
      this.pendingIOSKey = pending || event;
      setTimeout(() => this.flushIOSKey(view), 250);
      return true;
    }
    return false;
  }
  flushIOSKey(view) {
    let key = this.pendingIOSKey;
    if (!key)
      return false;
    this.pendingIOSKey = void 0;
    return dispatchKey(view.contentDOM, key.key, key.keyCode);
  }
  ignoreDuringComposition(event) {
    if (!/^key/.test(event.type))
      return false;
    if (this.composing > 0)
      return true;
    if (browser.safari && !browser.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) {
      this.compositionPendingKey = false;
      return true;
    }
    return false;
  }
  mustFlushObserver(event) {
    return event.type == "keydown" && event.keyCode != 229;
  }
  startMouseSelection(mouseSelection) {
    if (this.mouseSelection)
      this.mouseSelection.destroy();
    this.mouseSelection = mouseSelection;
  }
  update(update) {
    if (this.mouseSelection)
      this.mouseSelection.update(update);
    if (update.transactions.length)
      this.lastKeyCode = this.lastSelectionTime = 0;
  }
  destroy() {
    if (this.mouseSelection)
      this.mouseSelection.destroy();
  }
}
const PendingKeys = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
];
const EmacsyPendingKeys = "dthko";
const modifierCodes = [16, 17, 18, 20, 91, 92, 224, 225];
const dragScrollMargin = 6;
function dragScrollSpeed(dist2) {
  return Math.max(0, dist2) * 0.7 + 8;
}
function dist(a2, b2) {
  return Math.max(Math.abs(a2.clientX - b2.clientX), Math.abs(a2.clientY - b2.clientY));
}
class MouseSelection {
  constructor(view, startEvent, style2, mustSelect) {
    this.view = view;
    this.startEvent = startEvent;
    this.style = style2;
    this.mustSelect = mustSelect;
    this.scrollSpeed = { x: 0, y: 0 };
    this.scrolling = -1;
    this.lastEvent = startEvent;
    this.scrollParent = scrollableParent(view.contentDOM);
    this.atoms = view.state.facet(atomicRanges).map((f2) => f2(view));
    let doc2 = view.contentDOM.ownerDocument;
    doc2.addEventListener("mousemove", this.move = this.move.bind(this));
    doc2.addEventListener("mouseup", this.up = this.up.bind(this));
    this.extend = startEvent.shiftKey;
    this.multiple = view.state.facet(EditorState.allowMultipleSelections) && addsSelectionRange(view, startEvent);
    this.dragging = isInPrimarySelection(view, startEvent) && getClickType(startEvent) == 1 ? null : false;
  }
  start(event) {
    if (this.dragging === false) {
      event.preventDefault();
      this.select(event);
    }
  }
  move(event) {
    var _a2;
    if (event.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && dist(this.startEvent, event) < 10)
      return;
    this.select(this.lastEvent = event);
    let sx2 = 0, sy2 = 0;
    let rect = ((_a2 = this.scrollParent) === null || _a2 === void 0 ? void 0 : _a2.getBoundingClientRect()) || { left: 0, top: 0, right: this.view.win.innerWidth, bottom: this.view.win.innerHeight };
    let margins = getScrollMargins(this.view);
    if (event.clientX - margins.left <= rect.left + dragScrollMargin)
      sx2 = -dragScrollSpeed(rect.left - event.clientX);
    else if (event.clientX + margins.right >= rect.right - dragScrollMargin)
      sx2 = dragScrollSpeed(event.clientX - rect.right);
    if (event.clientY - margins.top <= rect.top + dragScrollMargin)
      sy2 = -dragScrollSpeed(rect.top - event.clientY);
    else if (event.clientY + margins.bottom >= rect.bottom - dragScrollMargin)
      sy2 = dragScrollSpeed(event.clientY - rect.bottom);
    this.setScrollSpeed(sx2, sy2);
  }
  up(event) {
    if (this.dragging == null)
      this.select(this.lastEvent);
    if (!this.dragging)
      event.preventDefault();
    this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let doc2 = this.view.contentDOM.ownerDocument;
    doc2.removeEventListener("mousemove", this.move);
    doc2.removeEventListener("mouseup", this.up);
    this.view.inputState.mouseSelection = null;
  }
  setScrollSpeed(sx2, sy2) {
    this.scrollSpeed = { x: sx2, y: sy2 };
    if (sx2 || sy2) {
      if (this.scrolling < 0)
        this.scrolling = setInterval(() => this.scroll(), 50);
    } else if (this.scrolling > -1) {
      clearInterval(this.scrolling);
      this.scrolling = -1;
    }
  }
  scroll() {
    if (this.scrollParent) {
      this.scrollParent.scrollLeft += this.scrollSpeed.x;
      this.scrollParent.scrollTop += this.scrollSpeed.y;
    } else {
      this.view.win.scrollBy(this.scrollSpeed.x, this.scrollSpeed.y);
    }
    if (this.dragging === false)
      this.select(this.lastEvent);
  }
  skipAtoms(sel) {
    let ranges = null;
    for (let i2 = 0; i2 < sel.ranges.length; i2++) {
      let range3 = sel.ranges[i2], updated = null;
      if (range3.empty) {
        let pos = skipAtomicRanges(this.atoms, range3.from, 0);
        if (pos != range3.from)
          updated = EditorSelection.cursor(pos, -1);
      } else {
        let from = skipAtomicRanges(this.atoms, range3.from, -1);
        let to2 = skipAtomicRanges(this.atoms, range3.to, 1);
        if (from != range3.from || to2 != range3.to)
          updated = EditorSelection.range(range3.from == range3.anchor ? from : to2, range3.from == range3.head ? from : to2);
      }
      if (updated) {
        if (!ranges)
          ranges = sel.ranges.slice();
        ranges[i2] = updated;
      }
    }
    return ranges ? EditorSelection.create(ranges, sel.mainIndex) : sel;
  }
  select(event) {
    let { view } = this, selection = this.skipAtoms(this.style.get(event, this.extend, this.multiple));
    if (this.mustSelect || !selection.eq(view.state.selection) || selection.main.assoc != view.state.selection.main.assoc && this.dragging === false)
      this.view.dispatch({
        selection,
        userEvent: "select.pointer"
      });
    this.mustSelect = false;
  }
  update(update) {
    if (update.docChanged && this.dragging)
      this.dragging = this.dragging.map(update.changes);
    if (this.style.update(update))
      setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function addsSelectionRange(view, event) {
  let facet = view.state.facet(clickAddsSelectionRange);
  return facet.length ? facet[0](event) : browser.mac ? event.metaKey : event.ctrlKey;
}
function dragMovesSelection(view, event) {
  let facet = view.state.facet(dragMovesSelection$1);
  return facet.length ? facet[0](event) : browser.mac ? !event.altKey : !event.ctrlKey;
}
function isInPrimarySelection(view, event) {
  let { main } = view.state.selection;
  if (main.empty)
    return false;
  let sel = getSelection(view.root);
  if (!sel || sel.rangeCount == 0)
    return true;
  let rects = sel.getRangeAt(0).getClientRects();
  for (let i2 = 0; i2 < rects.length; i2++) {
    let rect = rects[i2];
    if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY)
      return true;
  }
  return false;
}
function eventBelongsToEditor(view, event) {
  if (!event.bubbles)
    return true;
  if (event.defaultPrevented)
    return false;
  for (let node2 = event.target, cView; node2 != view.contentDOM; node2 = node2.parentNode)
    if (!node2 || node2.nodeType == 11 || (cView = ContentView.get(node2)) && cView.ignoreEvent(event))
      return false;
  return true;
}
const handlers = /* @__PURE__ */ Object.create(null);
const handlerOptions = /* @__PURE__ */ Object.create(null);
const brokenClipboardAPI = browser.ie && browser.ie_version < 15 || browser.ios && browser.webkit_version < 604;
function capturePaste(view) {
  let parent = view.dom.parentNode;
  if (!parent)
    return;
  let target = parent.appendChild(document.createElement("textarea"));
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.focus();
  setTimeout(() => {
    view.focus();
    target.remove();
    doPaste(view, target.value);
  }, 50);
}
function doPaste(view, input) {
  let { state } = view, changes, i2 = 1, text = state.toText(input);
  let byLine = text.lines == state.selection.ranges.length;
  let linewise = lastLinewiseCopy != null && state.selection.ranges.every((r2) => r2.empty) && lastLinewiseCopy == text.toString();
  if (linewise) {
    let lastLine = -1;
    changes = state.changeByRange((range3) => {
      let line = state.doc.lineAt(range3.from);
      if (line.from == lastLine)
        return { range: range3 };
      lastLine = line.from;
      let insert2 = state.toText((byLine ? text.line(i2++).text : input) + state.lineBreak);
      return {
        changes: { from: line.from, insert: insert2 },
        range: EditorSelection.cursor(range3.from + insert2.length)
      };
    });
  } else if (byLine) {
    changes = state.changeByRange((range3) => {
      let line = text.line(i2++);
      return {
        changes: { from: range3.from, to: range3.to, insert: line.text },
        range: EditorSelection.cursor(range3.from + line.length)
      };
    });
  } else {
    changes = state.replaceSelection(text);
  }
  view.dispatch(changes, {
    userEvent: "input.paste",
    scrollIntoView: true
  });
}
handlers.keydown = (view, event) => {
  view.inputState.setSelectionOrigin("select");
  if (event.keyCode == 27)
    view.inputState.lastEscPress = Date.now();
};
handlers.touchstart = (view, e25) => {
  view.inputState.lastTouchTime = Date.now();
  view.inputState.setSelectionOrigin("select.pointer");
};
handlers.touchmove = (view) => {
  view.inputState.setSelectionOrigin("select.pointer");
};
handlerOptions.touchstart = handlerOptions.touchmove = { passive: true };
handlers.mousedown = (view, event) => {
  view.observer.flush();
  if (view.inputState.lastTouchTime > Date.now() - 2e3)
    return;
  let style2 = null;
  for (let makeStyle of view.state.facet(mouseSelectionStyle)) {
    style2 = makeStyle(view, event);
    if (style2)
      break;
  }
  if (!style2 && event.button == 0)
    style2 = basicMouseSelection(view, event);
  if (style2) {
    let mustFocus = !view.hasFocus;
    view.inputState.startMouseSelection(new MouseSelection(view, event, style2, mustFocus));
    if (mustFocus)
      view.observer.ignore(() => focusPreventScroll(view.contentDOM));
    if (view.inputState.mouseSelection)
      view.inputState.mouseSelection.start(event);
  }
};
function rangeForClick(view, pos, bias, type4) {
  if (type4 == 1) {
    return EditorSelection.cursor(pos, bias);
  } else if (type4 == 2) {
    return groupAt(view.state, pos, bias);
  } else {
    let visual = LineView.find(view.docView, pos), line = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
    let from = visual ? visual.posAtStart : line.from, to2 = visual ? visual.posAtEnd : line.to;
    if (to2 < view.state.doc.length && to2 == line.to)
      to2++;
    return EditorSelection.range(from, to2);
  }
}
let insideY = (y2, rect) => y2 >= rect.top && y2 <= rect.bottom;
let inside = (x2, y2, rect) => insideY(y2, rect) && x2 >= rect.left && x2 <= rect.right;
function findPositionSide(view, pos, x2, y2) {
  let line = LineView.find(view.docView, pos);
  if (!line)
    return 1;
  let off2 = pos - line.posAtStart;
  if (off2 == 0)
    return 1;
  if (off2 == line.length)
    return -1;
  let before = line.coordsAt(off2, -1);
  if (before && inside(x2, y2, before))
    return -1;
  let after = line.coordsAt(off2, 1);
  if (after && inside(x2, y2, after))
    return 1;
  return before && insideY(y2, before) ? -1 : 1;
}
function queryPos(view, event) {
  let pos = view.posAtCoords({ x: event.clientX, y: event.clientY }, false);
  return { pos, bias: findPositionSide(view, pos, event.clientX, event.clientY) };
}
const BadMouseDetail = browser.ie && browser.ie_version <= 11;
let lastMouseDown = null, lastMouseDownCount = 0, lastMouseDownTime = 0;
function getClickType(event) {
  if (!BadMouseDetail)
    return event.detail;
  let last = lastMouseDown, lastTime = lastMouseDownTime;
  lastMouseDown = event;
  lastMouseDownTime = Date.now();
  return lastMouseDownCount = !last || lastTime > Date.now() - 400 && Math.abs(last.clientX - event.clientX) < 2 && Math.abs(last.clientY - event.clientY) < 2 ? (lastMouseDownCount + 1) % 3 : 1;
}
function basicMouseSelection(view, event) {
  let start = queryPos(view, event), type4 = getClickType(event);
  let startSel = view.state.selection;
  return {
    update(update) {
      if (update.docChanged) {
        start.pos = update.changes.mapPos(start.pos);
        startSel = startSel.map(update.changes);
      }
    },
    get(event2, extend2, multiple) {
      let cur2 = queryPos(view, event2), removed;
      let range3 = rangeForClick(view, cur2.pos, cur2.bias, type4);
      if (start.pos != cur2.pos && !extend2) {
        let startRange = rangeForClick(view, start.pos, start.bias, type4);
        let from = Math.min(startRange.from, range3.from), to2 = Math.max(startRange.to, range3.to);
        range3 = from < range3.from ? EditorSelection.range(from, to2) : EditorSelection.range(to2, from);
      }
      if (extend2)
        return startSel.replaceRange(startSel.main.extend(range3.from, range3.to));
      else if (multiple && type4 == 1 && startSel.ranges.length > 1 && (removed = removeRangeAround(startSel, cur2.pos)))
        return removed;
      else if (multiple)
        return startSel.addRange(range3);
      else
        return EditorSelection.create([range3]);
    }
  };
}
function removeRangeAround(sel, pos) {
  for (let i2 = 0; i2 < sel.ranges.length; i2++) {
    let { from, to: to2 } = sel.ranges[i2];
    if (from <= pos && to2 >= pos)
      return EditorSelection.create(sel.ranges.slice(0, i2).concat(sel.ranges.slice(i2 + 1)), sel.mainIndex == i2 ? 0 : sel.mainIndex - (sel.mainIndex > i2 ? 1 : 0));
  }
  return null;
}
handlers.dragstart = (view, event) => {
  let { selection: { main } } = view.state;
  let { mouseSelection } = view.inputState;
  if (mouseSelection)
    mouseSelection.dragging = main;
  if (event.dataTransfer) {
    event.dataTransfer.setData("Text", view.state.sliceDoc(main.from, main.to));
    event.dataTransfer.effectAllowed = "copyMove";
  }
};
function dropText(view, event, text, direct) {
  if (!text)
    return;
  let dropPos = view.posAtCoords({ x: event.clientX, y: event.clientY }, false);
  event.preventDefault();
  let { mouseSelection } = view.inputState;
  let del = direct && mouseSelection && mouseSelection.dragging && dragMovesSelection(view, event) ? { from: mouseSelection.dragging.from, to: mouseSelection.dragging.to } : null;
  let ins = { from: dropPos, insert: text };
  let changes = view.state.changes(del ? [del, ins] : ins);
  view.focus();
  view.dispatch({
    changes,
    selection: { anchor: changes.mapPos(dropPos, -1), head: changes.mapPos(dropPos, 1) },
    userEvent: del ? "move.drop" : "input.drop"
  });
}
handlers.drop = (view, event) => {
  if (!event.dataTransfer)
    return;
  if (view.state.readOnly)
    return event.preventDefault();
  let files = event.dataTransfer.files;
  if (files && files.length) {
    event.preventDefault();
    let text = Array(files.length), read = 0;
    let finishFile = () => {
      if (++read == files.length)
        dropText(view, event, text.filter((s2) => s2 != null).join(view.state.lineBreak), false);
    };
    for (let i2 = 0; i2 < files.length; i2++) {
      let reader = new FileReader();
      reader.onerror = finishFile;
      reader.onload = () => {
        if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result))
          text[i2] = reader.result;
        finishFile();
      };
      reader.readAsText(files[i2]);
    }
  } else {
    dropText(view, event, event.dataTransfer.getData("Text"), true);
  }
};
handlers.paste = (view, event) => {
  if (view.state.readOnly)
    return event.preventDefault();
  view.observer.flush();
  let data = brokenClipboardAPI ? null : event.clipboardData;
  if (data) {
    doPaste(view, data.getData("text/plain") || data.getData("text/uri-text"));
    event.preventDefault();
  } else {
    capturePaste(view);
  }
};
function captureCopy(view, text) {
  let parent = view.dom.parentNode;
  if (!parent)
    return;
  let target = parent.appendChild(document.createElement("textarea"));
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.value = text;
  target.focus();
  target.selectionEnd = text.length;
  target.selectionStart = 0;
  setTimeout(() => {
    target.remove();
    view.focus();
  }, 50);
}
function copiedRange(state) {
  let content2 = [], ranges = [], linewise = false;
  for (let range3 of state.selection.ranges)
    if (!range3.empty) {
      content2.push(state.sliceDoc(range3.from, range3.to));
      ranges.push(range3);
    }
  if (!content2.length) {
    let upto = -1;
    for (let { from } of state.selection.ranges) {
      let line = state.doc.lineAt(from);
      if (line.number > upto) {
        content2.push(line.text);
        ranges.push({ from: line.from, to: Math.min(state.doc.length, line.to + 1) });
      }
      upto = line.number;
    }
    linewise = true;
  }
  return { text: content2.join(state.lineBreak), ranges, linewise };
}
let lastLinewiseCopy = null;
handlers.copy = handlers.cut = (view, event) => {
  let { text, ranges, linewise } = copiedRange(view.state);
  if (!text && !linewise)
    return;
  lastLinewiseCopy = linewise ? text : null;
  let data = brokenClipboardAPI ? null : event.clipboardData;
  if (data) {
    event.preventDefault();
    data.clearData();
    data.setData("text/plain", text);
  } else {
    captureCopy(view, text);
  }
  if (event.type == "cut" && !view.state.readOnly)
    view.dispatch({
      changes: ranges,
      scrollIntoView: true,
      userEvent: "delete.cut"
    });
};
const isFocusChange = /* @__PURE__ */ Annotation.define();
function focusChangeTransaction(state, focus) {
  let effects = [];
  for (let getEffect of state.facet(focusChangeEffect)) {
    let effect = getEffect(state, focus);
    if (effect)
      effects.push(effect);
  }
  return effects ? state.update({ effects, annotations: isFocusChange.of(true) }) : null;
}
function updateForFocusChange(view) {
  setTimeout(() => {
    let focus = view.hasFocus;
    if (focus != view.inputState.notifiedFocused) {
      let tr2 = focusChangeTransaction(view.state, focus);
      if (tr2)
        view.dispatch(tr2);
      else
        view.update([]);
    }
  }, 10);
}
handlers.focus = (view) => {
  view.inputState.lastFocusTime = Date.now();
  if (!view.scrollDOM.scrollTop && (view.inputState.lastScrollTop || view.inputState.lastScrollLeft)) {
    view.scrollDOM.scrollTop = view.inputState.lastScrollTop;
    view.scrollDOM.scrollLeft = view.inputState.lastScrollLeft;
  }
  updateForFocusChange(view);
};
handlers.blur = (view) => {
  view.observer.clearSelectionRange();
  updateForFocusChange(view);
};
handlers.compositionstart = handlers.compositionupdate = (view) => {
  if (view.inputState.compositionFirstChange == null)
    view.inputState.compositionFirstChange = true;
  if (view.inputState.composing < 0) {
    view.inputState.composing = 0;
  }
};
handlers.compositionend = (view) => {
  view.inputState.composing = -1;
  view.inputState.compositionEndedAt = Date.now();
  view.inputState.compositionPendingKey = true;
  view.inputState.compositionPendingChange = view.observer.pendingRecords().length > 0;
  view.inputState.compositionFirstChange = null;
  if (browser.chrome && browser.android) {
    view.observer.flushSoon();
  } else if (view.inputState.compositionPendingChange) {
    Promise.resolve().then(() => view.observer.flush());
  } else {
    setTimeout(() => {
      if (view.inputState.composing < 0 && view.docView.hasComposition)
        view.update([]);
    }, 50);
  }
};
handlers.contextmenu = (view) => {
  view.inputState.lastContextMenu = Date.now();
};
handlers.beforeinput = (view, event) => {
  var _a2;
  let pending;
  if (browser.chrome && browser.android && (pending = PendingKeys.find((key) => key.inputType == event.inputType))) {
    view.observer.delayAndroidKey(pending.key, pending.keyCode);
    if (pending.key == "Backspace" || pending.key == "Delete") {
      let startViewHeight = ((_a2 = window.visualViewport) === null || _a2 === void 0 ? void 0 : _a2.height) || 0;
      setTimeout(() => {
        var _a3;
        if ((((_a3 = window.visualViewport) === null || _a3 === void 0 ? void 0 : _a3.height) || 0) > startViewHeight + 10 && view.hasFocus) {
          view.contentDOM.blur();
          view.focus();
        }
      }, 100);
    }
  }
};
const wrappingWhiteSpace = ["pre-wrap", "normal", "pre-line", "break-spaces"];
class HeightOracle {
  constructor(lineWrapping) {
    this.lineWrapping = lineWrapping;
    this.doc = Text.empty;
    this.heightSamples = {};
    this.lineHeight = 14;
    this.charWidth = 7;
    this.textHeight = 14;
    this.lineLength = 30;
    this.heightChanged = false;
  }
  heightForGap(from, to2) {
    let lines = this.doc.lineAt(to2).number - this.doc.lineAt(from).number + 1;
    if (this.lineWrapping)
      lines += Math.max(0, Math.ceil((to2 - from - lines * this.lineLength * 0.5) / this.lineLength));
    return this.lineHeight * lines;
  }
  heightForLine(length2) {
    if (!this.lineWrapping)
      return this.lineHeight;
    let lines = 1 + Math.max(0, Math.ceil((length2 - this.lineLength) / (this.lineLength - 5)));
    return lines * this.lineHeight;
  }
  setDoc(doc2) {
    this.doc = doc2;
    return this;
  }
  mustRefreshForWrapping(whiteSpace) {
    return wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(lineHeights) {
    let newHeight = false;
    for (let i2 = 0; i2 < lineHeights.length; i2++) {
      let h2 = lineHeights[i2];
      if (h2 < 0) {
        i2++;
      } else if (!this.heightSamples[Math.floor(h2 * 10)]) {
        newHeight = true;
        this.heightSamples[Math.floor(h2 * 10)] = true;
      }
    }
    return newHeight;
  }
  refresh(whiteSpace, lineHeight2, charWidth, textHeight, lineLength, knownHeights) {
    let lineWrapping = wrappingWhiteSpace.indexOf(whiteSpace) > -1;
    let changed = Math.round(lineHeight2) != Math.round(this.lineHeight) || this.lineWrapping != lineWrapping;
    this.lineWrapping = lineWrapping;
    this.lineHeight = lineHeight2;
    this.charWidth = charWidth;
    this.textHeight = textHeight;
    this.lineLength = lineLength;
    if (changed) {
      this.heightSamples = {};
      for (let i2 = 0; i2 < knownHeights.length; i2++) {
        let h2 = knownHeights[i2];
        if (h2 < 0)
          i2++;
        else
          this.heightSamples[Math.floor(h2 * 10)] = true;
      }
    }
    return changed;
  }
}
class MeasuredHeights {
  constructor(from, heights) {
    this.from = from;
    this.heights = heights;
    this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class BlockInfo {
  constructor(from, length2, top2, height, _content) {
    this.from = from;
    this.length = length2;
    this.top = top2;
    this.height = height;
    this._content = _content;
  }
  get type() {
    return typeof this._content == "number" ? BlockType.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  get to() {
    return this.from + this.length;
  }
  get bottom() {
    return this.top + this.height;
  }
  get widget() {
    return this._content instanceof PointDecoration ? this._content.widget : null;
  }
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  join(other) {
    let content2 = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(other._content) ? other._content : [other]);
    return new BlockInfo(this.from, this.length + other.length, this.top, this.height + other.height, content2);
  }
}
var QueryType$1 = /* @__PURE__ */ function(QueryType2) {
  QueryType2[QueryType2["ByPos"] = 0] = "ByPos";
  QueryType2[QueryType2["ByHeight"] = 1] = "ByHeight";
  QueryType2[QueryType2["ByPosNoHeight"] = 2] = "ByPosNoHeight";
  return QueryType2;
}(QueryType$1 || (QueryType$1 = {}));
const Epsilon = 1e-3;
class HeightMap {
  constructor(length2, height, flags = 2) {
    this.length = length2;
    this.height = height;
    this.flags = flags;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(value2) {
    this.flags = (value2 ? 2 : 0) | this.flags & ~2;
  }
  setHeight(oracle, height) {
    if (this.height != height) {
      if (Math.abs(this.height - height) > Epsilon)
        oracle.heightChanged = true;
      this.height = height;
    }
  }
  replace(_from, _to, nodes) {
    return HeightMap.of(nodes);
  }
  decomposeLeft(_to, result2) {
    result2.push(this);
  }
  decomposeRight(_from, result2) {
    result2.push(this);
  }
  applyChanges(decorations2, oldDoc, oracle, changes) {
    let me2 = this, doc2 = oracle.doc;
    for (let i2 = changes.length - 1; i2 >= 0; i2--) {
      let { fromA, toA, fromB, toB } = changes[i2];
      let start = me2.lineAt(fromA, QueryType$1.ByPosNoHeight, oracle.setDoc(oldDoc), 0, 0);
      let end = start.to >= toA ? start : me2.lineAt(toA, QueryType$1.ByPosNoHeight, oracle, 0, 0);
      toB += end.to - toA;
      toA = end.to;
      while (i2 > 0 && start.from <= changes[i2 - 1].toA) {
        fromA = changes[i2 - 1].fromA;
        fromB = changes[i2 - 1].fromB;
        i2--;
        if (fromA < start.from)
          start = me2.lineAt(fromA, QueryType$1.ByPosNoHeight, oracle, 0, 0);
      }
      fromB += start.from - fromA;
      fromA = start.from;
      let nodes = NodeBuilder.build(oracle.setDoc(doc2), decorations2, fromB, toB);
      me2 = me2.replace(fromA, toA, nodes);
    }
    return me2.updateHeight(oracle, 0);
  }
  static empty() {
    return new HeightMapText(0, 0);
  }
  static of(nodes) {
    if (nodes.length == 1)
      return nodes[0];
    let i2 = 0, j2 = nodes.length, before = 0, after = 0;
    for (; ; ) {
      if (i2 == j2) {
        if (before > after * 2) {
          let split = nodes[i2 - 1];
          if (split.break)
            nodes.splice(--i2, 1, split.left, null, split.right);
          else
            nodes.splice(--i2, 1, split.left, split.right);
          j2 += 1 + split.break;
          before -= split.size;
        } else if (after > before * 2) {
          let split = nodes[j2];
          if (split.break)
            nodes.splice(j2, 1, split.left, null, split.right);
          else
            nodes.splice(j2, 1, split.left, split.right);
          j2 += 2 + split.break;
          after -= split.size;
        } else {
          break;
        }
      } else if (before < after) {
        let next = nodes[i2++];
        if (next)
          before += next.size;
      } else {
        let next = nodes[--j2];
        if (next)
          after += next.size;
      }
    }
    let brk = 0;
    if (nodes[i2 - 1] == null) {
      brk = 1;
      i2--;
    } else if (nodes[i2] == null) {
      brk = 1;
      j2++;
    }
    return new HeightMapBranch(HeightMap.of(nodes.slice(0, i2)), brk, HeightMap.of(nodes.slice(j2)));
  }
}
HeightMap.prototype.size = 1;
class HeightMapBlock extends HeightMap {
  constructor(length2, height, deco) {
    super(length2, height);
    this.deco = deco;
  }
  blockAt(_height, _oracle, top2, offset) {
    return new BlockInfo(offset, this.length, top2, this.height, this.deco || 0);
  }
  lineAt(_value, _type, oracle, top2, offset) {
    return this.blockAt(0, oracle, top2, offset);
  }
  forEachLine(from, to2, oracle, top2, offset, f2) {
    if (from <= offset + this.length && to2 >= offset)
      f2(this.blockAt(0, oracle, top2, offset));
  }
  updateHeight(oracle, offset = 0, _force = false, measured) {
    if (measured && measured.from <= offset && measured.more)
      this.setHeight(oracle, measured.heights[measured.index++]);
    this.outdated = false;
    return this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class HeightMapText extends HeightMapBlock {
  constructor(length2, height) {
    super(length2, height, null);
    this.collapsed = 0;
    this.widgetHeight = 0;
    this.breaks = 0;
  }
  blockAt(_height, _oracle, top2, offset) {
    return new BlockInfo(offset, this.length, top2, this.height, this.breaks);
  }
  replace(_from, _to, nodes) {
    let node2 = nodes[0];
    if (nodes.length == 1 && (node2 instanceof HeightMapText || node2 instanceof HeightMapGap && node2.flags & 4) && Math.abs(this.length - node2.length) < 10) {
      if (node2 instanceof HeightMapGap)
        node2 = new HeightMapText(node2.length, this.height);
      else
        node2.height = this.height;
      if (!this.outdated)
        node2.outdated = false;
      return node2;
    } else {
      return HeightMap.of(nodes);
    }
  }
  updateHeight(oracle, offset = 0, force = false, measured) {
    if (measured && measured.from <= offset && measured.more)
      this.setHeight(oracle, measured.heights[measured.index++]);
    else if (force || this.outdated)
      this.setHeight(oracle, Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)) + this.breaks * oracle.lineHeight);
    this.outdated = false;
    return this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class HeightMapGap extends HeightMap {
  constructor(length2) {
    super(length2, 0);
  }
  heightMetrics(oracle, offset) {
    let firstLine = oracle.doc.lineAt(offset).number, lastLine = oracle.doc.lineAt(offset + this.length).number;
    let lines = lastLine - firstLine + 1;
    let perLine, perChar = 0;
    if (oracle.lineWrapping) {
      let totalPerLine = Math.min(this.height, oracle.lineHeight * lines);
      perLine = totalPerLine / lines;
      if (this.length > lines + 1)
        perChar = (this.height - totalPerLine) / (this.length - lines - 1);
    } else {
      perLine = this.height / lines;
    }
    return { firstLine, lastLine, perLine, perChar };
  }
  blockAt(height, oracle, top2, offset) {
    let { firstLine, lastLine, perLine, perChar } = this.heightMetrics(oracle, offset);
    if (oracle.lineWrapping) {
      let guess = offset + Math.round(Math.max(0, Math.min(1, (height - top2) / this.height)) * this.length);
      let line = oracle.doc.lineAt(guess), lineHeight2 = perLine + line.length * perChar;
      let lineTop = Math.max(top2, height - lineHeight2 / 2);
      return new BlockInfo(line.from, line.length, lineTop, lineHeight2, 0);
    } else {
      let line = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top2) / perLine)));
      let { from, length: length2 } = oracle.doc.line(firstLine + line);
      return new BlockInfo(from, length2, top2 + perLine * line, perLine, 0);
    }
  }
  lineAt(value2, type4, oracle, top2, offset) {
    if (type4 == QueryType$1.ByHeight)
      return this.blockAt(value2, oracle, top2, offset);
    if (type4 == QueryType$1.ByPosNoHeight) {
      let { from, to: to2 } = oracle.doc.lineAt(value2);
      return new BlockInfo(from, to2 - from, 0, 0, 0);
    }
    let { firstLine, perLine, perChar } = this.heightMetrics(oracle, offset);
    let line = oracle.doc.lineAt(value2), lineHeight2 = perLine + line.length * perChar;
    let linesAbove = line.number - firstLine;
    let lineTop = top2 + perLine * linesAbove + perChar * (line.from - offset - linesAbove);
    return new BlockInfo(line.from, line.length, Math.max(top2, Math.min(lineTop, top2 + this.height - lineHeight2)), lineHeight2, 0);
  }
  forEachLine(from, to2, oracle, top2, offset, f2) {
    from = Math.max(from, offset);
    to2 = Math.min(to2, offset + this.length);
    let { firstLine, perLine, perChar } = this.heightMetrics(oracle, offset);
    for (let pos = from, lineTop = top2; pos <= to2; ) {
      let line = oracle.doc.lineAt(pos);
      if (pos == from) {
        let linesAbove = line.number - firstLine;
        lineTop += perLine * linesAbove + perChar * (from - offset - linesAbove);
      }
      let lineHeight2 = perLine + perChar * line.length;
      f2(new BlockInfo(line.from, line.length, lineTop, lineHeight2, 0));
      lineTop += lineHeight2;
      pos = line.to + 1;
    }
  }
  replace(from, to2, nodes) {
    let after = this.length - to2;
    if (after > 0) {
      let last = nodes[nodes.length - 1];
      if (last instanceof HeightMapGap)
        nodes[nodes.length - 1] = new HeightMapGap(last.length + after);
      else
        nodes.push(null, new HeightMapGap(after - 1));
    }
    if (from > 0) {
      let first = nodes[0];
      if (first instanceof HeightMapGap)
        nodes[0] = new HeightMapGap(from + first.length);
      else
        nodes.unshift(new HeightMapGap(from - 1), null);
    }
    return HeightMap.of(nodes);
  }
  decomposeLeft(to2, result2) {
    result2.push(new HeightMapGap(to2 - 1), null);
  }
  decomposeRight(from, result2) {
    result2.push(null, new HeightMapGap(this.length - from - 1));
  }
  updateHeight(oracle, offset = 0, force = false, measured) {
    let end = offset + this.length;
    if (measured && measured.from <= offset + this.length && measured.more) {
      let nodes = [], pos = Math.max(offset, measured.from), singleHeight = -1;
      if (measured.from > offset)
        nodes.push(new HeightMapGap(measured.from - offset - 1).updateHeight(oracle, offset));
      while (pos <= end && measured.more) {
        let len2 = oracle.doc.lineAt(pos).length;
        if (nodes.length)
          nodes.push(null);
        let height = measured.heights[measured.index++];
        if (singleHeight == -1)
          singleHeight = height;
        else if (Math.abs(height - singleHeight) >= Epsilon)
          singleHeight = -2;
        let line = new HeightMapText(len2, height);
        line.outdated = false;
        nodes.push(line);
        pos += len2 + 1;
      }
      if (pos <= end)
        nodes.push(null, new HeightMapGap(end - pos).updateHeight(oracle, pos));
      let result2 = HeightMap.of(nodes);
      if (singleHeight < 0 || Math.abs(result2.height - this.height) >= Epsilon || Math.abs(singleHeight - this.heightMetrics(oracle, offset).perLine) >= Epsilon)
        oracle.heightChanged = true;
      return result2;
    } else if (force || this.outdated) {
      this.setHeight(oracle, oracle.heightForGap(offset, offset + this.length));
      this.outdated = false;
    }
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class HeightMapBranch extends HeightMap {
  constructor(left, brk, right) {
    super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 : 0));
    this.left = left;
    this.right = right;
    this.size = left.size + right.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(height, oracle, top2, offset) {
    let mid = top2 + this.left.height;
    return height < mid ? this.left.blockAt(height, oracle, top2, offset) : this.right.blockAt(height, oracle, mid, offset + this.left.length + this.break);
  }
  lineAt(value2, type4, oracle, top2, offset) {
    let rightTop = top2 + this.left.height, rightOffset = offset + this.left.length + this.break;
    let left = type4 == QueryType$1.ByHeight ? value2 < rightTop : value2 < rightOffset;
    let base2 = left ? this.left.lineAt(value2, type4, oracle, top2, offset) : this.right.lineAt(value2, type4, oracle, rightTop, rightOffset);
    if (this.break || (left ? base2.to < rightOffset : base2.from > rightOffset))
      return base2;
    let subQuery = type4 == QueryType$1.ByPosNoHeight ? QueryType$1.ByPosNoHeight : QueryType$1.ByPos;
    if (left)
      return base2.join(this.right.lineAt(rightOffset, subQuery, oracle, rightTop, rightOffset));
    else
      return this.left.lineAt(rightOffset, subQuery, oracle, top2, offset).join(base2);
  }
  forEachLine(from, to2, oracle, top2, offset, f2) {
    let rightTop = top2 + this.left.height, rightOffset = offset + this.left.length + this.break;
    if (this.break) {
      if (from < rightOffset)
        this.left.forEachLine(from, to2, oracle, top2, offset, f2);
      if (to2 >= rightOffset)
        this.right.forEachLine(from, to2, oracle, rightTop, rightOffset, f2);
    } else {
      let mid = this.lineAt(rightOffset, QueryType$1.ByPos, oracle, top2, offset);
      if (from < mid.from)
        this.left.forEachLine(from, mid.from - 1, oracle, top2, offset, f2);
      if (mid.to >= from && mid.from <= to2)
        f2(mid);
      if (to2 > mid.to)
        this.right.forEachLine(mid.to + 1, to2, oracle, rightTop, rightOffset, f2);
    }
  }
  replace(from, to2, nodes) {
    let rightStart = this.left.length + this.break;
    if (to2 < rightStart)
      return this.balanced(this.left.replace(from, to2, nodes), this.right);
    if (from > this.left.length)
      return this.balanced(this.left, this.right.replace(from - rightStart, to2 - rightStart, nodes));
    let result2 = [];
    if (from > 0)
      this.decomposeLeft(from, result2);
    let left = result2.length;
    for (let node2 of nodes)
      result2.push(node2);
    if (from > 0)
      mergeGaps(result2, left - 1);
    if (to2 < this.length) {
      let right = result2.length;
      this.decomposeRight(to2, result2);
      mergeGaps(result2, right);
    }
    return HeightMap.of(result2);
  }
  decomposeLeft(to2, result2) {
    let left = this.left.length;
    if (to2 <= left)
      return this.left.decomposeLeft(to2, result2);
    result2.push(this.left);
    if (this.break) {
      left++;
      if (to2 >= left)
        result2.push(null);
    }
    if (to2 > left)
      this.right.decomposeLeft(to2 - left, result2);
  }
  decomposeRight(from, result2) {
    let left = this.left.length, right = left + this.break;
    if (from >= right)
      return this.right.decomposeRight(from - right, result2);
    if (from < left)
      this.left.decomposeRight(from, result2);
    if (this.break && from < right)
      result2.push(null);
    result2.push(this.right);
  }
  balanced(left, right) {
    if (left.size > 2 * right.size || right.size > 2 * left.size)
      return HeightMap.of(this.break ? [left, null, right] : [left, right]);
    this.left = left;
    this.right = right;
    this.height = left.height + right.height;
    this.outdated = left.outdated || right.outdated;
    this.size = left.size + right.size;
    this.length = left.length + this.break + right.length;
    return this;
  }
  updateHeight(oracle, offset = 0, force = false, measured) {
    let { left, right } = this, rightStart = offset + left.length + this.break, rebalance = null;
    if (measured && measured.from <= offset + left.length && measured.more)
      rebalance = left = left.updateHeight(oracle, offset, force, measured);
    else
      left.updateHeight(oracle, offset, force);
    if (measured && measured.from <= rightStart + right.length && measured.more)
      rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
    else
      right.updateHeight(oracle, rightStart, force);
    if (rebalance)
      return this.balanced(left, right);
    this.height = this.left.height + this.right.height;
    this.outdated = false;
    return this;
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function mergeGaps(nodes, around) {
  let before, after;
  if (nodes[around] == null && (before = nodes[around - 1]) instanceof HeightMapGap && (after = nodes[around + 1]) instanceof HeightMapGap)
    nodes.splice(around - 1, 3, new HeightMapGap(before.length + 1 + after.length));
}
const relevantWidgetHeight = 5;
class NodeBuilder {
  constructor(pos, oracle) {
    this.pos = pos;
    this.oracle = oracle;
    this.nodes = [];
    this.lineStart = -1;
    this.lineEnd = -1;
    this.covering = null;
    this.writtenTo = pos;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(_from, to2) {
    if (this.lineStart > -1) {
      let end = Math.min(to2, this.lineEnd), last = this.nodes[this.nodes.length - 1];
      if (last instanceof HeightMapText)
        last.length += end - this.pos;
      else if (end > this.pos || !this.isCovered)
        this.nodes.push(new HeightMapText(end - this.pos, -1));
      this.writtenTo = end;
      if (to2 > end) {
        this.nodes.push(null);
        this.writtenTo++;
        this.lineStart = -1;
      }
    }
    this.pos = to2;
  }
  point(from, to2, deco) {
    if (from < to2 || deco.heightRelevant) {
      let height = deco.widget ? deco.widget.estimatedHeight : 0;
      let breaks = deco.widget ? deco.widget.lineBreaks : 0;
      if (height < 0)
        height = this.oracle.lineHeight;
      let len2 = to2 - from;
      if (deco.block) {
        this.addBlock(new HeightMapBlock(len2, height, deco));
      } else if (len2 || breaks || height >= relevantWidgetHeight) {
        this.addLineDeco(height, breaks, len2);
      }
    } else if (to2 > from) {
      this.span(from, to2);
    }
    if (this.lineEnd > -1 && this.lineEnd < this.pos)
      this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from, to: to2 } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = from;
    this.lineEnd = to2;
    if (this.writtenTo < from) {
      if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null)
        this.nodes.push(this.blankContent(this.writtenTo, from - 1));
      this.nodes.push(null);
    }
    if (this.pos > from)
      this.nodes.push(new HeightMapText(this.pos - from, -1));
    this.writtenTo = this.pos;
  }
  blankContent(from, to2) {
    let gap = new HeightMapGap(to2 - from);
    if (this.oracle.doc.lineAt(from).to == to2)
      gap.flags |= 4;
    return gap;
  }
  ensureLine() {
    this.enterLine();
    let last = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (last instanceof HeightMapText)
      return last;
    let line = new HeightMapText(0, -1);
    this.nodes.push(line);
    return line;
  }
  addBlock(block) {
    var _a2;
    this.enterLine();
    let type4 = (_a2 = block.deco) === null || _a2 === void 0 ? void 0 : _a2.type;
    if (type4 == BlockType.WidgetAfter && !this.isCovered)
      this.ensureLine();
    this.nodes.push(block);
    this.writtenTo = this.pos = this.pos + block.length;
    if (type4 != BlockType.WidgetBefore)
      this.covering = block;
  }
  addLineDeco(height, breaks, length2) {
    let line = this.ensureLine();
    line.length += length2;
    line.collapsed += length2;
    line.widgetHeight = Math.max(line.widgetHeight, height);
    line.breaks += breaks;
    this.writtenTo = this.pos = this.pos + length2;
  }
  finish(from) {
    let last = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    if (this.lineStart > -1 && !(last instanceof HeightMapText) && !this.isCovered)
      this.nodes.push(new HeightMapText(0, -1));
    else if (this.writtenTo < this.pos || last == null)
      this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let pos = from;
    for (let node2 of this.nodes) {
      if (node2 instanceof HeightMapText)
        node2.updateHeight(this.oracle, pos);
      pos += node2 ? node2.length : 1;
    }
    return this.nodes;
  }
  static build(oracle, decorations2, from, to2) {
    let builder = new NodeBuilder(from, oracle);
    RangeSet.spans(decorations2, from, to2, builder, 0);
    return builder.finish(from);
  }
}
function heightRelevantDecoChanges(a2, b2, diff) {
  let comp = new DecorationComparator();
  RangeSet.compare(a2, b2, diff, comp, 0);
  return comp.changes;
}
class DecorationComparator {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(from, to2, a2, b2) {
    if (from < to2 || a2 && a2.heightRelevant || b2 && b2.heightRelevant)
      addRange(from, to2, this.changes, 5);
  }
}
function visiblePixelRange(dom, paddingTop) {
  let rect = dom.getBoundingClientRect();
  let doc2 = dom.ownerDocument, win = doc2.defaultView || window;
  let left = Math.max(0, rect.left), right = Math.min(win.innerWidth, rect.right);
  let top2 = Math.max(0, rect.top), bottom = Math.min(win.innerHeight, rect.bottom);
  for (let parent = dom.parentNode; parent && parent != doc2.body; ) {
    if (parent.nodeType == 1) {
      let elt = parent;
      let style2 = window.getComputedStyle(elt);
      if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style2.overflow != "visible") {
        let parentRect = elt.getBoundingClientRect();
        left = Math.max(left, parentRect.left);
        right = Math.min(right, parentRect.right);
        top2 = Math.max(top2, parentRect.top);
        bottom = parent == dom.parentNode ? parentRect.bottom : Math.min(bottom, parentRect.bottom);
      }
      parent = style2.position == "absolute" || style2.position == "fixed" ? elt.offsetParent : elt.parentNode;
    } else if (parent.nodeType == 11) {
      parent = parent.host;
    } else {
      break;
    }
  }
  return {
    left: left - rect.left,
    right: Math.max(left, right) - rect.left,
    top: top2 - (rect.top + paddingTop),
    bottom: Math.max(top2, bottom) - (rect.top + paddingTop)
  };
}
function fullPixelRange(dom, paddingTop) {
  let rect = dom.getBoundingClientRect();
  return {
    left: 0,
    right: rect.right - rect.left,
    top: paddingTop,
    bottom: rect.bottom - (rect.top + paddingTop)
  };
}
class LineGap {
  constructor(from, to2, size2) {
    this.from = from;
    this.to = to2;
    this.size = size2;
  }
  static same(a2, b2) {
    if (a2.length != b2.length)
      return false;
    for (let i2 = 0; i2 < a2.length; i2++) {
      let gA2 = a2[i2], gB2 = b2[i2];
      if (gA2.from != gB2.from || gA2.to != gB2.to || gA2.size != gB2.size)
        return false;
    }
    return true;
  }
  draw(wrapping) {
    return Decoration.replace({ widget: new LineGapWidget(this.size, wrapping) }).range(this.from, this.to);
  }
}
class LineGapWidget extends WidgetType {
  constructor(size2, vertical) {
    super();
    this.size = size2;
    this.vertical = vertical;
  }
  eq(other) {
    return other.size == this.size && other.vertical == this.vertical;
  }
  toDOM() {
    let elt = document.createElement("div");
    if (this.vertical) {
      elt.style.height = this.size + "px";
    } else {
      elt.style.width = this.size + "px";
      elt.style.height = "2px";
      elt.style.display = "inline-block";
    }
    return elt;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class ViewState {
  constructor(state) {
    this.state = state;
    this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 };
    this.inView = true;
    this.paddingTop = 0;
    this.paddingBottom = 0;
    this.contentDOMWidth = 0;
    this.contentDOMHeight = 0;
    this.editorHeight = 0;
    this.editorWidth = 0;
    this.scrollTop = 0;
    this.scrolledToBottom = true;
    this.scrollAnchorPos = 0;
    this.scrollAnchorHeight = -1;
    this.scaler = IdScaler;
    this.scrollTarget = null;
    this.printing = false;
    this.mustMeasureContent = true;
    this.defaultTextDirection = Direction.LTR;
    this.visibleRanges = [];
    this.mustEnforceCursorAssoc = false;
    let guessWrapping = state.facet(contentAttributes).some((v2) => typeof v2 != "function" && v2.class == "cm-lineWrapping");
    this.heightOracle = new HeightOracle(guessWrapping);
    this.stateDeco = state.facet(decorations).filter((d2) => typeof d2 != "function");
    this.heightMap = HeightMap.empty().applyChanges(this.stateDeco, Text.empty, this.heightOracle.setDoc(state.doc), [new ChangedRange(0, 0, 0, state.doc.length)]);
    this.viewport = this.getViewport(0, null);
    this.updateViewportLines();
    this.updateForViewport();
    this.lineGaps = this.ensureLineGaps([]);
    this.lineGapDeco = Decoration.set(this.lineGaps.map((gap) => gap.draw(false)));
    this.computeVisibleRanges();
  }
  updateForViewport() {
    let viewports = [this.viewport], { main } = this.state.selection;
    for (let i2 = 0; i2 <= 1; i2++) {
      let pos = i2 ? main.head : main.anchor;
      if (!viewports.some(({ from, to: to2 }) => pos >= from && pos <= to2)) {
        let { from, to: to2 } = this.lineBlockAt(pos);
        viewports.push(new Viewport(from, to2));
      }
    }
    this.viewports = viewports.sort((a2, b2) => a2.from - b2.from);
    this.scaler = this.heightMap.height <= 7e6 ? IdScaler : new BigScaler(this.heightOracle, this.heightMap, this.viewports);
  }
  updateViewportLines() {
    this.viewportLines = [];
    this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (block) => {
      this.viewportLines.push(this.scaler.scale == 1 ? block : scaleBlock(block, this.scaler));
    });
  }
  update(update, scrollTarget = null) {
    this.state = update.state;
    let prevDeco = this.stateDeco;
    this.stateDeco = this.state.facet(decorations).filter((d2) => typeof d2 != "function");
    let contentChanges = update.changedRanges;
    let heightChanges = ChangedRange.extendWithRanges(contentChanges, heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : ChangeSet.empty(this.state.doc.length)));
    let prevHeight = this.heightMap.height;
    let scrollAnchor = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
    if (this.heightMap.height != prevHeight)
      update.flags |= 2;
    if (scrollAnchor) {
      this.scrollAnchorPos = update.changes.mapPos(scrollAnchor.from, -1);
      this.scrollAnchorHeight = scrollAnchor.top;
    } else {
      this.scrollAnchorPos = -1;
      this.scrollAnchorHeight = this.heightMap.height;
    }
    let viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
    if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport))
      viewport = this.getViewport(0, scrollTarget);
    let updateLines = !update.changes.empty || update.flags & 2 || viewport.from != this.viewport.from || viewport.to != this.viewport.to;
    this.viewport = viewport;
    this.updateForViewport();
    if (updateLines)
      this.updateViewportLines();
    if (this.lineGaps.length || this.viewport.to - this.viewport.from > 2e3 << 1)
      this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
    update.flags |= this.computeVisibleRanges();
    if (scrollTarget)
      this.scrollTarget = scrollTarget;
    if (!this.mustEnforceCursorAssoc && update.selectionSet && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc && !update.state.facet(nativeSelectionHidden))
      this.mustEnforceCursorAssoc = true;
  }
  measure(view) {
    let dom = view.contentDOM, style2 = window.getComputedStyle(dom);
    let oracle = this.heightOracle;
    let whiteSpace = style2.whiteSpace;
    this.defaultTextDirection = style2.direction == "rtl" ? Direction.RTL : Direction.LTR;
    let refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace);
    let domRect = dom.getBoundingClientRect();
    let measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != domRect.height;
    this.contentDOMHeight = domRect.height;
    this.mustMeasureContent = false;
    let result2 = 0, bias = 0;
    let paddingTop = parseInt(style2.paddingTop) || 0, paddingBottom = parseInt(style2.paddingBottom) || 0;
    if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
      this.paddingTop = paddingTop;
      this.paddingBottom = paddingBottom;
      result2 |= 8 | 2;
    }
    if (this.editorWidth != view.scrollDOM.clientWidth) {
      if (oracle.lineWrapping)
        measureContent = true;
      this.editorWidth = view.scrollDOM.clientWidth;
      result2 |= 8;
    }
    if (this.scrollTop != view.scrollDOM.scrollTop) {
      this.scrollAnchorHeight = -1;
      this.scrollTop = view.scrollDOM.scrollTop;
    }
    this.scrolledToBottom = isScrolledToBottom(view.scrollDOM);
    let pixelViewport = (this.printing ? fullPixelRange : visiblePixelRange)(dom, this.paddingTop);
    let dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
    this.pixelViewport = pixelViewport;
    let inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (inView != this.inView) {
      this.inView = inView;
      if (inView)
        measureContent = true;
    }
    if (!this.inView && !this.scrollTarget)
      return 0;
    let contentWidth = domRect.width;
    if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
      this.contentDOMWidth = domRect.width;
      this.editorHeight = view.scrollDOM.clientHeight;
      result2 |= 8;
    }
    if (measureContent) {
      let lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
      if (oracle.mustRefreshForHeights(lineHeights))
        refresh = true;
      if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
        let { lineHeight: lineHeight2, charWidth, textHeight } = view.docView.measureTextSize();
        refresh = lineHeight2 > 0 && oracle.refresh(whiteSpace, lineHeight2, charWidth, textHeight, contentWidth / charWidth, lineHeights);
        if (refresh) {
          view.docView.minWidth = 0;
          result2 |= 8;
        }
      }
      if (dTop > 0 && dBottom > 0)
        bias = Math.max(dTop, dBottom);
      else if (dTop < 0 && dBottom < 0)
        bias = Math.min(dTop, dBottom);
      oracle.heightChanged = false;
      for (let vp2 of this.viewports) {
        let heights = vp2.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp2);
        this.heightMap = (refresh ? HeightMap.empty().applyChanges(this.stateDeco, Text.empty, this.heightOracle, [new ChangedRange(0, 0, 0, view.state.doc.length)]) : this.heightMap).updateHeight(oracle, 0, refresh, new MeasuredHeights(vp2.from, heights));
      }
      if (oracle.heightChanged)
        result2 |= 2;
    }
    let viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    if (viewportChange)
      this.viewport = this.getViewport(bias, this.scrollTarget);
    this.updateForViewport();
    if (result2 & 2 || viewportChange)
      this.updateViewportLines();
    if (this.lineGaps.length || this.viewport.to - this.viewport.from > 2e3 << 1)
      this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps, view));
    result2 |= this.computeVisibleRanges();
    if (this.mustEnforceCursorAssoc) {
      this.mustEnforceCursorAssoc = false;
      view.docView.enforceCursorAssoc();
    }
    return result2;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(bias, scrollTarget) {
    let marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1e3 / 2));
    let map2 = this.heightMap, oracle = this.heightOracle;
    let { visibleTop, visibleBottom } = this;
    let viewport = new Viewport(map2.lineAt(visibleTop - marginTop * 1e3, QueryType$1.ByHeight, oracle, 0, 0).from, map2.lineAt(visibleBottom + (1 - marginTop) * 1e3, QueryType$1.ByHeight, oracle, 0, 0).to);
    if (scrollTarget) {
      let { head } = scrollTarget.range;
      if (head < viewport.from || head > viewport.to) {
        let viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
        let block = map2.lineAt(head, QueryType$1.ByPos, oracle, 0, 0), topPos;
        if (scrollTarget.y == "center")
          topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
        else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from)
          topPos = block.top;
        else
          topPos = block.bottom - viewHeight;
        viewport = new Viewport(map2.lineAt(topPos - 1e3 / 2, QueryType$1.ByHeight, oracle, 0, 0).from, map2.lineAt(topPos + viewHeight + 1e3 / 2, QueryType$1.ByHeight, oracle, 0, 0).to);
      }
    }
    return viewport;
  }
  mapViewport(viewport, changes) {
    let from = changes.mapPos(viewport.from, -1), to2 = changes.mapPos(viewport.to, 1);
    return new Viewport(this.heightMap.lineAt(from, QueryType$1.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(to2, QueryType$1.ByPos, this.heightOracle, 0, 0).to);
  }
  viewportIsAppropriate({ from, to: to2 }, bias = 0) {
    if (!this.inView)
      return true;
    let { top: top2 } = this.heightMap.lineAt(from, QueryType$1.ByPos, this.heightOracle, 0, 0);
    let { bottom } = this.heightMap.lineAt(to2, QueryType$1.ByPos, this.heightOracle, 0, 0);
    let { visibleTop, visibleBottom } = this;
    return (from == 0 || top2 <= visibleTop - Math.max(10, Math.min(-bias, 250))) && (to2 == this.state.doc.length || bottom >= visibleBottom + Math.max(10, Math.min(bias, 250))) && (top2 > visibleTop - 2 * 1e3 && bottom < visibleBottom + 2 * 1e3);
  }
  mapLineGaps(gaps, changes) {
    if (!gaps.length || changes.empty)
      return gaps;
    let mapped = [];
    for (let gap of gaps)
      if (!changes.touchesRange(gap.from, gap.to))
        mapped.push(new LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size));
    return mapped;
  }
  ensureLineGaps(current, mayMeasure) {
    let wrapping = this.heightOracle.lineWrapping;
    let margin = wrapping ? 1e4 : 2e3, halfMargin = margin >> 1, doubleMargin = margin << 1;
    if (this.defaultTextDirection != Direction.LTR && !wrapping)
      return [];
    let gaps = [];
    let addGap = (from, to2, line, structure2) => {
      if (to2 - from < halfMargin)
        return;
      let sel = this.state.selection.main, avoid = [sel.from];
      if (!sel.empty)
        avoid.push(sel.to);
      for (let pos of avoid) {
        if (pos > from && pos < to2) {
          addGap(from, pos - 10, line, structure2);
          addGap(pos + 10, to2, line, structure2);
          return;
        }
      }
      let gap = find(current, (gap2) => gap2.from >= line.from && gap2.to <= line.to && Math.abs(gap2.from - from) < halfMargin && Math.abs(gap2.to - to2) < halfMargin && !avoid.some((pos) => gap2.from < pos && gap2.to > pos));
      if (!gap) {
        if (to2 < line.to && mayMeasure && wrapping && mayMeasure.visibleRanges.some((r2) => r2.from <= to2 && r2.to >= to2)) {
          let lineStart = mayMeasure.moveToLineBoundary(EditorSelection.cursor(to2), false, true).head;
          if (lineStart > from)
            to2 = lineStart;
        }
        gap = new LineGap(from, to2, this.gapSize(line, from, to2, structure2));
      }
      gaps.push(gap);
    };
    for (let line of this.viewportLines) {
      if (line.length < doubleMargin)
        continue;
      let structure2 = lineStructure(line.from, line.to, this.stateDeco);
      if (structure2.total < doubleMargin)
        continue;
      let target = this.scrollTarget ? this.scrollTarget.range.head : null;
      let viewFrom, viewTo;
      if (wrapping) {
        let marginHeight = margin / this.heightOracle.lineLength * this.heightOracle.lineHeight;
        let top2, bot;
        if (target != null) {
          let targetFrac = findFraction(structure2, target);
          let spaceFrac = ((this.visibleBottom - this.visibleTop) / 2 + marginHeight) / line.height;
          top2 = targetFrac - spaceFrac;
          bot = targetFrac + spaceFrac;
        } else {
          top2 = (this.visibleTop - line.top - marginHeight) / line.height;
          bot = (this.visibleBottom - line.top + marginHeight) / line.height;
        }
        viewFrom = findPosition(structure2, top2);
        viewTo = findPosition(structure2, bot);
      } else {
        let totalWidth = structure2.total * this.heightOracle.charWidth;
        let marginWidth = margin * this.heightOracle.charWidth;
        let left, right;
        if (target != null) {
          let targetFrac = findFraction(structure2, target);
          let spaceFrac = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + marginWidth) / totalWidth;
          left = targetFrac - spaceFrac;
          right = targetFrac + spaceFrac;
        } else {
          left = (this.pixelViewport.left - marginWidth) / totalWidth;
          right = (this.pixelViewport.right + marginWidth) / totalWidth;
        }
        viewFrom = findPosition(structure2, left);
        viewTo = findPosition(structure2, right);
      }
      if (viewFrom > line.from)
        addGap(line.from, viewFrom, line, structure2);
      if (viewTo < line.to)
        addGap(viewTo, line.to, line, structure2);
    }
    return gaps;
  }
  gapSize(line, from, to2, structure2) {
    let fraction = findFraction(structure2, to2) - findFraction(structure2, from);
    if (this.heightOracle.lineWrapping) {
      return line.height * fraction;
    } else {
      return structure2.total * this.heightOracle.charWidth * fraction;
    }
  }
  updateLineGaps(gaps) {
    if (!LineGap.same(gaps, this.lineGaps)) {
      this.lineGaps = gaps;
      this.lineGapDeco = Decoration.set(gaps.map((gap) => gap.draw(this.heightOracle.lineWrapping)));
    }
  }
  computeVisibleRanges() {
    let deco = this.stateDeco;
    if (this.lineGaps.length)
      deco = deco.concat(this.lineGapDeco);
    let ranges = [];
    RangeSet.spans(deco, this.viewport.from, this.viewport.to, {
      span(from, to2) {
        ranges.push({ from, to: to2 });
      },
      point() {
      }
    }, 20);
    let changed = ranges.length != this.visibleRanges.length || this.visibleRanges.some((r2, i2) => r2.from != ranges[i2].from || r2.to != ranges[i2].to);
    this.visibleRanges = ranges;
    return changed ? 4 : 0;
  }
  lineBlockAt(pos) {
    return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b2) => b2.from <= pos && b2.to >= pos) || scaleBlock(this.heightMap.lineAt(pos, QueryType$1.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(height) {
    return scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), QueryType$1.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(scrollTop) {
    let block = this.lineBlockAtHeight(scrollTop + 8);
    return block.from >= this.viewport.from || this.viewportLines[0].top - scrollTop > 200 ? block : this.viewportLines[0];
  }
  elementAtHeight(height) {
    return scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
class Viewport {
  constructor(from, to2) {
    this.from = from;
    this.to = to2;
  }
}
function lineStructure(from, to2, stateDeco) {
  let ranges = [], pos = from, total = 0;
  RangeSet.spans(stateDeco, from, to2, {
    span() {
    },
    point(from2, to3) {
      if (from2 > pos) {
        ranges.push({ from: pos, to: from2 });
        total += from2 - pos;
      }
      pos = to3;
    }
  }, 20);
  if (pos < to2) {
    ranges.push({ from: pos, to: to2 });
    total += to2 - pos;
  }
  return { total, ranges };
}
function findPosition({ total, ranges }, ratio) {
  if (ratio <= 0)
    return ranges[0].from;
  if (ratio >= 1)
    return ranges[ranges.length - 1].to;
  let dist2 = Math.floor(total * ratio);
  for (let i2 = 0; ; i2++) {
    let { from, to: to2 } = ranges[i2], size2 = to2 - from;
    if (dist2 <= size2)
      return from + dist2;
    dist2 -= size2;
  }
}
function findFraction(structure2, pos) {
  let counted = 0;
  for (let { from, to: to2 } of structure2.ranges) {
    if (pos <= to2) {
      counted += pos - from;
      break;
    }
    counted += to2 - from;
  }
  return counted / structure2.total;
}
function find(array4, f2) {
  for (let val of array4)
    if (f2(val))
      return val;
  return void 0;
}
const IdScaler = {
  toDOM(n2) {
    return n2;
  },
  fromDOM(n2) {
    return n2;
  },
  scale: 1
};
class BigScaler {
  constructor(oracle, heightMap, viewports) {
    let vpHeight = 0, base2 = 0, domBase = 0;
    this.viewports = viewports.map(({ from, to: to2 }) => {
      let top2 = heightMap.lineAt(from, QueryType$1.ByPos, oracle, 0, 0).top;
      let bottom = heightMap.lineAt(to2, QueryType$1.ByPos, oracle, 0, 0).bottom;
      vpHeight += bottom - top2;
      return { from, to: to2, top: top2, bottom, domTop: 0, domBottom: 0 };
    });
    this.scale = (7e6 - vpHeight) / (heightMap.height - vpHeight);
    for (let obj of this.viewports) {
      obj.domTop = domBase + (obj.top - base2) * this.scale;
      domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
      base2 = obj.bottom;
    }
  }
  toDOM(n2) {
    for (let i2 = 0, base2 = 0, domBase = 0; ; i2++) {
      let vp2 = i2 < this.viewports.length ? this.viewports[i2] : null;
      if (!vp2 || n2 < vp2.top)
        return domBase + (n2 - base2) * this.scale;
      if (n2 <= vp2.bottom)
        return vp2.domTop + (n2 - vp2.top);
      base2 = vp2.bottom;
      domBase = vp2.domBottom;
    }
  }
  fromDOM(n2) {
    for (let i2 = 0, base2 = 0, domBase = 0; ; i2++) {
      let vp2 = i2 < this.viewports.length ? this.viewports[i2] : null;
      if (!vp2 || n2 < vp2.domTop)
        return base2 + (n2 - domBase) / this.scale;
      if (n2 <= vp2.domBottom)
        return vp2.top + (n2 - vp2.domTop);
      base2 = vp2.bottom;
      domBase = vp2.domBottom;
    }
  }
}
function scaleBlock(block, scaler) {
  if (scaler.scale == 1)
    return block;
  let bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
  return new BlockInfo(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block._content) ? block._content.map((b2) => scaleBlock(b2, scaler)) : block._content);
}
const theme$1 = /* @__PURE__ */ Facet.define({ combine: (strs) => strs.join(" ") });
const darkTheme = /* @__PURE__ */ Facet.define({ combine: (values2) => values2.indexOf(true) > -1 });
const baseThemeID = /* @__PURE__ */ StyleModule.newName(), baseLightID = /* @__PURE__ */ StyleModule.newName(), baseDarkID = /* @__PURE__ */ StyleModule.newName();
const lightDarkIDs = { "&light": "." + baseLightID, "&dark": "." + baseDarkID };
function buildTheme(main, spec2, scopes) {
  return new StyleModule(spec2, {
    finish(sel) {
      return /&/.test(sel) ? sel.replace(/&\w*/, (m2) => {
        if (m2 == "&")
          return main;
        if (!scopes || !scopes[m2])
          throw new RangeError(`Unsupported selector: ${m2}`);
        return scopes[m2];
      }) : main + " " + sel;
    }
  });
}
const baseTheme$1$2 = /* @__PURE__ */ buildTheme("." + baseThemeID, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    boxSizing: "border-box",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#444"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    insetInlineStart: 0,
    zIndex: 200
  },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    borderRight: "1px solid #ddd"
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top"
  },
  ".cm-highlightSpace:before": {
    content: "attr(data-display)",
    position: "absolute",
    pointerEvents: "none",
    color: "#888"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, lightDarkIDs);
class DOMChange {
  constructor(view, start, end, typeOver) {
    this.typeOver = typeOver;
    this.bounds = null;
    this.text = "";
    let { impreciseHead: iHead, impreciseAnchor: iAnchor } = view.docView;
    if (view.state.readOnly && start > -1) {
      this.newSel = null;
    } else if (start > -1 && (this.bounds = view.docView.domBoundsAround(start, end, 0))) {
      let selPoints = iHead || iAnchor ? [] : selectionPoints(view);
      let reader = new DOMReader(selPoints, view.state);
      reader.readRange(this.bounds.startDOM, this.bounds.endDOM);
      this.text = reader.text;
      this.newSel = selectionFromPoints(selPoints, this.bounds.from);
    } else {
      let domSel = view.observer.selectionRange;
      let head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !contains(view.contentDOM, domSel.focusNode) ? view.state.selection.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
      let anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !contains(view.contentDOM, domSel.anchorNode) ? view.state.selection.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
      this.newSel = EditorSelection.single(anchor, head);
    }
  }
}
function applyDOMChange(view, domChange) {
  let change;
  let { newSel } = domChange, sel = view.state.selection.main;
  let lastKey = view.inputState.lastKeyTime > Date.now() - 100 ? view.inputState.lastKeyCode : -1;
  if (domChange.bounds) {
    let { from, to: to2 } = domChange.bounds;
    let preferredPos = sel.from, preferredSide = null;
    if (lastKey === 8 || browser.android && domChange.text.length < to2 - from) {
      preferredPos = sel.to;
      preferredSide = "end";
    }
    let diff = findDiff(view.state.doc.sliceString(from, to2, LineBreakPlaceholder), domChange.text, preferredPos - from, preferredSide);
    if (diff) {
      if (browser.chrome && lastKey == 13 && diff.toB == diff.from + 2 && domChange.text.slice(diff.from, diff.toB) == LineBreakPlaceholder + LineBreakPlaceholder)
        diff.toB--;
      change = {
        from: from + diff.from,
        to: from + diff.toA,
        insert: Text.of(domChange.text.slice(diff.from, diff.toB).split(LineBreakPlaceholder))
      };
    }
  } else if (newSel && (!view.hasFocus && view.state.facet(editable) || newSel.main.eq(sel))) {
    newSel = null;
  }
  if (!change && !newSel)
    return false;
  if (!change && domChange.typeOver && !sel.empty && newSel && newSel.main.empty) {
    change = { from: sel.from, to: sel.to, insert: view.state.doc.slice(sel.from, sel.to) };
  } else if (change && change.from >= sel.from && change.to <= sel.to && (change.from != sel.from || change.to != sel.to) && sel.to - sel.from - (change.to - change.from) <= 4) {
    change = {
      from: sel.from,
      to: sel.to,
      insert: view.state.doc.slice(sel.from, change.from).append(change.insert).append(view.state.doc.slice(change.to, sel.to))
    };
  } else if ((browser.mac || browser.android) && change && change.from == change.to && change.from == sel.head - 1 && /^\. ?$/.test(change.insert.toString()) && view.contentDOM.getAttribute("autocorrect") == "off") {
    if (newSel && change.insert.length == 2)
      newSel = EditorSelection.single(newSel.main.anchor - 1, newSel.main.head - 1);
    change = { from: sel.from, to: sel.to, insert: Text.of([" "]) };
  } else if (browser.chrome && change && change.from == change.to && change.from == sel.head && change.insert.toString() == "\n " && view.lineWrapping) {
    if (newSel)
      newSel = EditorSelection.single(newSel.main.anchor - 1, newSel.main.head - 1);
    change = { from: sel.from, to: sel.to, insert: Text.of([" "]) };
  }
  if (change) {
    let startState = view.state;
    if (browser.ios && view.inputState.flushIOSKey(view))
      return true;
    if (browser.android && (change.from == sel.from && change.to == sel.to && change.insert.length == 1 && change.insert.lines == 2 && dispatchKey(view.contentDOM, "Enter", 13) || (change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 || lastKey == 8 && change.insert.length < change.to - change.from) && dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && dispatchKey(view.contentDOM, "Delete", 46)))
      return true;
    let text = change.insert.toString();
    if (view.state.facet(inputHandler$1).some((h2) => h2(view, change.from, change.to, text)))
      return true;
    if (view.inputState.composing >= 0)
      view.inputState.composing++;
    let tr2;
    if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
      let before = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
      let after = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
      tr2 = startState.replaceSelection(view.state.toText(before + change.insert.sliceString(0, void 0, view.state.lineBreak) + after));
    } else {
      let changes = startState.changes(change);
      let mainSel = newSel && newSel.main.to <= changes.newLength ? newSel.main : void 0;
      if (startState.selection.ranges.length > 1 && view.inputState.composing >= 0 && change.to <= sel.to && change.to >= sel.to - 10) {
        let replaced = view.state.sliceDoc(change.from, change.to);
        let composition = findCompositionNode(view) || view.state.doc.lineAt(sel.head);
        let offset = sel.to - change.to, size2 = sel.to - sel.from;
        tr2 = startState.changeByRange((range3) => {
          if (range3.from == sel.from && range3.to == sel.to)
            return { changes, range: mainSel || range3.map(changes) };
          let to2 = range3.to - offset, from = to2 - replaced.length;
          if (range3.to - range3.from != size2 || view.state.sliceDoc(from, to2) != replaced || composition && range3.to >= composition.from && range3.from <= composition.to)
            return { range: range3 };
          let rangeChanges = startState.changes({ from, to: to2, insert: change.insert }), selOff = range3.to - sel.to;
          return {
            changes: rangeChanges,
            range: !mainSel ? range3.map(rangeChanges) : EditorSelection.range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
          };
        });
      } else {
        tr2 = {
          changes,
          selection: mainSel && startState.selection.replaceRange(mainSel)
        };
      }
    }
    let userEvent = "input.type";
    if (view.composing || view.inputState.compositionPendingChange && view.inputState.compositionEndedAt > Date.now() - 50) {
      view.inputState.compositionPendingChange = false;
      userEvent += ".compose";
      if (view.inputState.compositionFirstChange) {
        userEvent += ".start";
        view.inputState.compositionFirstChange = false;
      }
    }
    view.dispatch(tr2, { scrollIntoView: true, userEvent });
    return true;
  } else if (newSel && !newSel.main.eq(sel)) {
    let scrollIntoView2 = false, userEvent = "select";
    if (view.inputState.lastSelectionTime > Date.now() - 50) {
      if (view.inputState.lastSelectionOrigin == "select")
        scrollIntoView2 = true;
      userEvent = view.inputState.lastSelectionOrigin;
    }
    view.dispatch({ selection: newSel, scrollIntoView: scrollIntoView2, userEvent });
    return true;
  } else {
    return false;
  }
}
function findDiff(a2, b2, preferredPos, preferredSide) {
  let minLen = Math.min(a2.length, b2.length);
  let from = 0;
  while (from < minLen && a2.charCodeAt(from) == b2.charCodeAt(from))
    from++;
  if (from == minLen && a2.length == b2.length)
    return null;
  let toA = a2.length, toB = b2.length;
  while (toA > 0 && toB > 0 && a2.charCodeAt(toA - 1) == b2.charCodeAt(toB - 1)) {
    toA--;
    toB--;
  }
  if (preferredSide == "end") {
    let adjust = Math.max(0, from - Math.min(toA, toB));
    preferredPos -= toA + adjust - from;
  }
  if (toA < from && a2.length < b2.length) {
    let move2 = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
    from -= move2;
    toB = from + (toB - toA);
    toA = from;
  } else if (toB < from) {
    let move2 = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
    from -= move2;
    toA = from + (toA - toB);
    toB = from;
  }
  return { from, toA, toB };
}
function selectionPoints(view) {
  let result2 = [];
  if (view.root.activeElement != view.contentDOM)
    return result2;
  let { anchorNode, anchorOffset, focusNode, focusOffset } = view.observer.selectionRange;
  if (anchorNode) {
    result2.push(new DOMPoint(anchorNode, anchorOffset));
    if (focusNode != anchorNode || focusOffset != anchorOffset)
      result2.push(new DOMPoint(focusNode, focusOffset));
  }
  return result2;
}
function selectionFromPoints(points, base2) {
  if (points.length == 0)
    return null;
  let anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
  return anchor > -1 && head > -1 ? EditorSelection.single(anchor + base2, head + base2) : null;
}
const observeOptions = {
  childList: true,
  characterData: true,
  subtree: true,
  attributes: true,
  characterDataOldValue: true
};
const useCharData = browser.ie && browser.ie_version <= 11;
class DOMObserver {
  constructor(view) {
    this.view = view;
    this.active = false;
    this.selectionRange = new DOMSelectionState();
    this.selectionChanged = false;
    this.delayedFlush = -1;
    this.resizeTimeout = -1;
    this.queue = [];
    this.delayedAndroidKey = null;
    this.flushingAndroidKey = -1;
    this.lastChange = 0;
    this.scrollTargets = [];
    this.intersection = null;
    this.resizeScroll = null;
    this.resizeContent = null;
    this.intersecting = false;
    this.gapIntersection = null;
    this.gaps = [];
    this.parentCheck = -1;
    this.dom = view.contentDOM;
    this.observer = new MutationObserver((mutations) => {
      for (let mut of mutations)
        this.queue.push(mut);
      if ((browser.ie && browser.ie_version <= 11 || browser.ios && view.composing) && mutations.some((m2) => m2.type == "childList" && m2.removedNodes.length || m2.type == "characterData" && m2.oldValue.length > m2.target.nodeValue.length))
        this.flushSoon();
      else
        this.flush();
    });
    if (useCharData)
      this.onCharData = (event) => {
        this.queue.push({
          target: event.target,
          type: "characterData",
          oldValue: event.prevValue
        });
        this.flushSoon();
      };
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onPrint = this.onPrint.bind(this);
    this.onScroll = this.onScroll.bind(this);
    if (typeof ResizeObserver == "function") {
      this.resizeScroll = new ResizeObserver(() => {
        var _a2;
        if (((_a2 = this.view.docView) === null || _a2 === void 0 ? void 0 : _a2.lastUpdate) < Date.now() - 75)
          this.onResize();
      });
      this.resizeScroll.observe(view.scrollDOM);
      this.resizeContent = new ResizeObserver(() => this.view.requestMeasure());
      this.resizeContent.observe(view.contentDOM);
    }
    this.addWindowListeners(this.win = view.win);
    this.start();
    if (typeof IntersectionObserver == "function") {
      this.intersection = new IntersectionObserver((entries) => {
        if (this.parentCheck < 0)
          this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3);
        if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
          this.intersecting = !this.intersecting;
          if (this.intersecting != this.view.inView)
            this.onScrollChanged(document.createEvent("Event"));
        }
      }, { threshold: [0, 1e-3] });
      this.intersection.observe(this.dom);
      this.gapIntersection = new IntersectionObserver((entries) => {
        if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0)
          this.onScrollChanged(document.createEvent("Event"));
      }, {});
    }
    this.listenForScroll();
    this.readSelectionRange();
  }
  onScrollChanged(e25) {
    this.view.inputState.runScrollHandlers(this.view, e25);
    if (this.intersecting)
      this.view.measure();
  }
  onScroll(e25) {
    if (this.intersecting)
      this.flush(false);
    this.onScrollChanged(e25);
  }
  onResize() {
    if (this.resizeTimeout < 0)
      this.resizeTimeout = setTimeout(() => {
        this.resizeTimeout = -1;
        this.view.requestMeasure();
      }, 50);
  }
  onPrint() {
    this.view.viewState.printing = true;
    this.view.measure();
    setTimeout(() => {
      this.view.viewState.printing = false;
      this.view.requestMeasure();
    }, 500);
  }
  updateGaps(gaps) {
    if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g2, i2) => g2 != gaps[i2]))) {
      this.gapIntersection.disconnect();
      for (let gap of gaps)
        this.gapIntersection.observe(gap);
      this.gaps = gaps;
    }
  }
  onSelectionChange(event) {
    let wasChanged = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view } = this, sel = this.selectionRange;
    if (view.state.facet(editable) ? view.root.activeElement != this.dom : !hasSelection(view.dom, sel))
      return;
    let context = sel.anchorNode && view.docView.nearest(sel.anchorNode);
    if (context && context.ignoreEvent(event)) {
      if (!wasChanged)
        this.selectionChanged = false;
      return;
    }
    if ((browser.ie && browser.ie_version <= 11 || browser.android && browser.chrome) && !view.state.selection.main.empty && sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset))
      this.flushSoon();
    else
      this.flush(false);
  }
  readSelectionRange() {
    let { view } = this;
    let range3 = browser.safari && view.root.nodeType == 11 && deepActiveElement(this.dom.ownerDocument) == this.dom && safariSelectionRangeHack(this.view) || getSelection(view.root);
    if (!range3 || this.selectionRange.eq(range3))
      return false;
    let local = hasSelection(this.dom, range3);
    if (local && !this.selectionChanged && view.inputState.lastFocusTime > Date.now() - 200 && view.inputState.lastTouchTime < Date.now() - 300 && atElementStart(this.dom, range3)) {
      this.view.inputState.lastFocusTime = 0;
      view.docView.updateSelection();
      return false;
    }
    this.selectionRange.setRange(range3);
    if (local)
      this.selectionChanged = true;
    return true;
  }
  setSelectionRange(anchor, head) {
    this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
    this.selectionChanged = false;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let i2 = 0, changed = null;
    for (let dom = this.dom; dom; ) {
      if (dom.nodeType == 1) {
        if (!changed && i2 < this.scrollTargets.length && this.scrollTargets[i2] == dom)
          i2++;
        else if (!changed)
          changed = this.scrollTargets.slice(0, i2);
        if (changed)
          changed.push(dom);
        dom = dom.assignedSlot || dom.parentNode;
      } else if (dom.nodeType == 11) {
        dom = dom.host;
      } else {
        break;
      }
    }
    if (i2 < this.scrollTargets.length && !changed)
      changed = this.scrollTargets.slice(0, i2);
    if (changed) {
      for (let dom of this.scrollTargets)
        dom.removeEventListener("scroll", this.onScroll);
      for (let dom of this.scrollTargets = changed)
        dom.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(f2) {
    if (!this.active)
      return f2();
    try {
      this.stop();
      return f2();
    } finally {
      this.start();
      this.clear();
    }
  }
  start() {
    if (this.active)
      return;
    this.observer.observe(this.dom, observeOptions);
    if (useCharData)
      this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
    this.active = true;
  }
  stop() {
    if (!this.active)
      return;
    this.active = false;
    this.observer.disconnect();
    if (useCharData)
      this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
  }
  clear() {
    this.processRecords();
    this.queue.length = 0;
    this.selectionChanged = false;
  }
  delayAndroidKey(key, keyCode) {
    var _a2;
    if (!this.delayedAndroidKey) {
      let flush = () => {
        let key2 = this.delayedAndroidKey;
        if (key2) {
          this.clearDelayedAndroidKey();
          this.view.inputState.lastKeyCode = key2.keyCode;
          this.view.inputState.lastKeyTime = Date.now();
          let flushed = this.flush();
          if (!flushed && key2.force)
            dispatchKey(this.dom, key2.key, key2.keyCode);
        }
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(flush);
    }
    if (!this.delayedAndroidKey || key == "Enter")
      this.delayedAndroidKey = {
        key,
        keyCode,
        force: this.lastChange < Date.now() - 50 || !!((_a2 = this.delayedAndroidKey) === null || _a2 === void 0 ? void 0 : _a2.force)
      };
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey);
    this.delayedAndroidKey = null;
    this.flushingAndroidKey = -1;
  }
  flushSoon() {
    if (this.delayedFlush < 0)
      this.delayedFlush = this.view.win.requestAnimationFrame(() => {
        this.delayedFlush = -1;
        this.flush();
      });
  }
  forceFlush() {
    if (this.delayedFlush >= 0) {
      this.view.win.cancelAnimationFrame(this.delayedFlush);
      this.delayedFlush = -1;
    }
    this.flush();
  }
  pendingRecords() {
    for (let mut of this.observer.takeRecords())
      this.queue.push(mut);
    return this.queue;
  }
  processRecords() {
    let records = this.pendingRecords();
    if (records.length)
      this.queue = [];
    let from = -1, to2 = -1, typeOver = false;
    for (let record of records) {
      let range3 = this.readMutation(record);
      if (!range3)
        continue;
      if (range3.typeOver)
        typeOver = true;
      if (from == -1) {
        ({ from, to: to2 } = range3);
      } else {
        from = Math.min(range3.from, from);
        to2 = Math.max(range3.to, to2);
      }
    }
    return { from, to: to2, typeOver };
  }
  readChange() {
    let { from, to: to2, typeOver } = this.processRecords();
    let newSel = this.selectionChanged && hasSelection(this.dom, this.selectionRange);
    if (from < 0 && !newSel)
      return null;
    if (from > -1)
      this.lastChange = Date.now();
    this.view.inputState.lastFocusTime = 0;
    this.selectionChanged = false;
    return new DOMChange(this.view, from, to2, typeOver);
  }
  flush(readSelection = true) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return false;
    if (readSelection)
      this.readSelectionRange();
    let domChange = this.readChange();
    if (!domChange)
      return false;
    let startState = this.view.state;
    let handled = applyDOMChange(this.view, domChange);
    if (this.view.state == startState)
      this.view.update([]);
    return handled;
  }
  readMutation(rec) {
    let cView = this.view.docView.nearest(rec.target);
    if (!cView || cView.ignoreMutation(rec))
      return null;
    cView.markDirty(rec.type == "attributes");
    if (rec.type == "attributes")
      cView.flags |= 4;
    if (rec.type == "childList") {
      let childBefore = findChild(cView, rec.previousSibling || rec.target.previousSibling, -1);
      let childAfter = findChild(cView, rec.nextSibling || rec.target.nextSibling, 1);
      return {
        from: childBefore ? cView.posAfter(childBefore) : cView.posAtStart,
        to: childAfter ? cView.posBefore(childAfter) : cView.posAtEnd,
        typeOver: false
      };
    } else if (rec.type == "characterData") {
      return { from: cView.posAtStart, to: cView.posAtEnd, typeOver: rec.target.nodeValue == rec.oldValue };
    } else {
      return null;
    }
  }
  setWindow(win) {
    if (win != this.win) {
      this.removeWindowListeners(this.win);
      this.win = win;
      this.addWindowListeners(this.win);
    }
  }
  addWindowListeners(win) {
    win.addEventListener("resize", this.onResize);
    win.addEventListener("beforeprint", this.onPrint);
    win.addEventListener("scroll", this.onScroll);
    win.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(win) {
    win.removeEventListener("scroll", this.onScroll);
    win.removeEventListener("resize", this.onResize);
    win.removeEventListener("beforeprint", this.onPrint);
    win.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  destroy() {
    var _a2, _b2, _c2, _d2;
    this.stop();
    (_a2 = this.intersection) === null || _a2 === void 0 ? void 0 : _a2.disconnect();
    (_b2 = this.gapIntersection) === null || _b2 === void 0 ? void 0 : _b2.disconnect();
    (_c2 = this.resizeScroll) === null || _c2 === void 0 ? void 0 : _c2.disconnect();
    (_d2 = this.resizeContent) === null || _d2 === void 0 ? void 0 : _d2.disconnect();
    for (let dom of this.scrollTargets)
      dom.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win);
    clearTimeout(this.parentCheck);
    clearTimeout(this.resizeTimeout);
    this.win.cancelAnimationFrame(this.delayedFlush);
    this.win.cancelAnimationFrame(this.flushingAndroidKey);
  }
}
function findChild(cView, dom, dir) {
  while (dom) {
    let curView = ContentView.get(dom);
    if (curView && curView.parent == cView)
      return curView;
    let parent = dom.parentNode;
    dom = parent != cView.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
  }
  return null;
}
function safariSelectionRangeHack(view) {
  let found = null;
  function read(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    found = event.getTargetRanges()[0];
  }
  view.contentDOM.addEventListener("beforeinput", read, true);
  view.dom.ownerDocument.execCommand("indent");
  view.contentDOM.removeEventListener("beforeinput", read, true);
  if (!found)
    return null;
  let anchorNode = found.startContainer, anchorOffset = found.startOffset;
  let focusNode = found.endContainer, focusOffset = found.endOffset;
  let curAnchor = view.docView.domAtPos(view.state.selection.main.anchor);
  if (isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset))
    [anchorNode, anchorOffset, focusNode, focusOffset] = [focusNode, focusOffset, anchorNode, anchorOffset];
  return { anchorNode, anchorOffset, focusNode, focusOffset };
}
class EditorView {
  constructor(config2 = {}) {
    this.plugins = [];
    this.pluginMap = new Map();
    this.editorAttrs = {};
    this.contentAttrs = {};
    this.bidiCache = [];
    this.destroyed = false;
    this.updateState = 2;
    this.measureScheduled = -1;
    this.measureRequests = [];
    this.contentDOM = document.createElement("div");
    this.scrollDOM = document.createElement("div");
    this.scrollDOM.tabIndex = -1;
    this.scrollDOM.className = "cm-scroller";
    this.scrollDOM.appendChild(this.contentDOM);
    this.announceDOM = document.createElement("div");
    this.announceDOM.style.cssText = "position: fixed; top: -10000px";
    this.announceDOM.setAttribute("aria-live", "polite");
    this.dom = document.createElement("div");
    this.dom.appendChild(this.announceDOM);
    this.dom.appendChild(this.scrollDOM);
    this._dispatch = config2.dispatch || ((tr2) => this.update([tr2]));
    this.dispatch = this.dispatch.bind(this);
    this._root = config2.root || getRoot(config2.parent) || document;
    this.viewState = new ViewState(config2.state || EditorState.create(config2));
    this.plugins = this.state.facet(viewPlugin).map((spec2) => new PluginInstance(spec2));
    for (let plugin2 of this.plugins)
      plugin2.update(this);
    this.observer = new DOMObserver(this);
    this.inputState = new InputState(this);
    this.inputState.ensureHandlers(this, this.plugins);
    this.docView = new DocView(this);
    this.mountStyles();
    this.updateAttrs();
    this.updateState = 0;
    this.requestMeasure();
    if (config2.parent)
      config2.parent.appendChild(this.dom);
  }
  get state() {
    return this.viewState.state;
  }
  get viewport() {
    return this.viewState.viewport;
  }
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  get inView() {
    return this.viewState.inView;
  }
  get composing() {
    return this.inputState.composing > 0;
  }
  get compositionStarted() {
    return this.inputState.composing >= 0;
  }
  get root() {
    return this._root;
  }
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  dispatch(...input) {
    let tr2 = input.length == 1 && input[0] instanceof Transaction ? input[0] : this.state.update(...input);
    this._dispatch(tr2, this);
  }
  update(transactions) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let redrawn = false, attrsChanged = false, update;
    let state = this.state;
    for (let tr2 of transactions) {
      if (tr2.startState != state)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      state = tr2.state;
    }
    if (this.destroyed) {
      this.viewState.state = state;
      return;
    }
    let focus = this.hasFocus, focusFlag = 0, dispatchFocus = null;
    if (transactions.some((tr2) => tr2.annotation(isFocusChange))) {
      this.inputState.notifiedFocused = focus;
      focusFlag = 1;
    } else if (focus != this.inputState.notifiedFocused) {
      this.inputState.notifiedFocused = focus;
      dispatchFocus = focusChangeTransaction(state, focus);
      if (!dispatchFocus)
        focusFlag = 1;
    }
    let pendingKey = this.observer.delayedAndroidKey, domChange = null;
    if (pendingKey) {
      this.observer.clearDelayedAndroidKey();
      domChange = this.observer.readChange();
      if (domChange && !this.state.doc.eq(state.doc) || !this.state.selection.eq(state.selection))
        domChange = null;
    } else {
      this.observer.clear();
    }
    if (state.facet(EditorState.phrases) != this.state.facet(EditorState.phrases))
      return this.setState(state);
    update = ViewUpdate.create(this, state, transactions);
    update.flags |= focusFlag;
    let scrollTarget = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let tr2 of transactions) {
        if (scrollTarget)
          scrollTarget = scrollTarget.map(tr2.changes);
        if (tr2.scrollIntoView) {
          let { main } = tr2.state.selection;
          scrollTarget = new ScrollTarget(main.empty ? main : EditorSelection.cursor(main.head, main.head > main.anchor ? -1 : 1));
        }
        for (let e25 of tr2.effects)
          if (e25.is(scrollIntoView$1))
            scrollTarget = e25.value;
      }
      this.viewState.update(update, scrollTarget);
      this.bidiCache = CachedOrder.update(this.bidiCache, update.changes);
      if (!update.empty) {
        this.updatePlugins(update);
        this.inputState.update(update);
      }
      redrawn = this.docView.update(update);
      if (this.state.facet(styleModule) != this.styleModules)
        this.mountStyles();
      attrsChanged = this.updateAttrs();
      this.showAnnouncements(transactions);
      this.docView.updateSelection(redrawn, transactions.some((tr2) => tr2.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (update.startState.facet(theme$1) != update.state.facet(theme$1))
      this.viewState.mustMeasureContent = true;
    if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent)
      this.requestMeasure();
    if (!update.empty)
      for (let listener of this.state.facet(updateListener))
        listener(update);
    if (dispatchFocus || domChange)
      Promise.resolve().then(() => {
        if (dispatchFocus && this.state == dispatchFocus.startState)
          this.dispatch(dispatchFocus);
        if (domChange) {
          if (!applyDOMChange(this, domChange) && pendingKey.force)
            dispatchKey(this.contentDOM, pendingKey.key, pendingKey.keyCode);
        }
      });
  }
  setState(newState) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = newState;
      return;
    }
    this.updateState = 2;
    let hadFocus = this.hasFocus;
    try {
      for (let plugin2 of this.plugins)
        plugin2.destroy(this);
      this.viewState = new ViewState(newState);
      this.plugins = newState.facet(viewPlugin).map((spec2) => new PluginInstance(spec2));
      this.pluginMap.clear();
      for (let plugin2 of this.plugins)
        plugin2.update(this);
      this.docView = new DocView(this);
      this.inputState.ensureHandlers(this, this.plugins);
      this.mountStyles();
      this.updateAttrs();
      this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    if (hadFocus)
      this.focus();
    this.requestMeasure();
  }
  updatePlugins(update) {
    let prevSpecs = update.startState.facet(viewPlugin), specs = update.state.facet(viewPlugin);
    if (prevSpecs != specs) {
      let newPlugins = [];
      for (let spec2 of specs) {
        let found = prevSpecs.indexOf(spec2);
        if (found < 0) {
          newPlugins.push(new PluginInstance(spec2));
        } else {
          let plugin2 = this.plugins[found];
          plugin2.mustUpdate = update;
          newPlugins.push(plugin2);
        }
      }
      for (let plugin2 of this.plugins)
        if (plugin2.mustUpdate != update)
          plugin2.destroy(this);
      this.plugins = newPlugins;
      this.pluginMap.clear();
      this.inputState.ensureHandlers(this, this.plugins);
    } else {
      for (let p2 of this.plugins)
        p2.mustUpdate = update;
    }
    for (let i2 = 0; i2 < this.plugins.length; i2++)
      this.plugins[i2].update(this);
  }
  measure(flush = true) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1)
      this.win.cancelAnimationFrame(this.measureScheduled);
    this.measureScheduled = 0;
    if (flush)
      this.observer.forceFlush();
    let updated = null;
    let sDOM = this.scrollDOM, { scrollTop } = sDOM;
    let { scrollAnchorPos, scrollAnchorHeight } = this.viewState;
    if (scrollTop != this.viewState.scrollTop)
      scrollAnchorHeight = -1;
    this.viewState.scrollAnchorHeight = -1;
    try {
      for (let i2 = 0; ; i2++) {
        if (scrollAnchorHeight < 0) {
          if (isScrolledToBottom(sDOM)) {
            scrollAnchorPos = -1;
            scrollAnchorHeight = this.viewState.heightMap.height;
          } else {
            let block = this.viewState.scrollAnchorAt(scrollTop);
            scrollAnchorPos = block.from;
            scrollAnchorHeight = block.top;
          }
        }
        this.updateState = 1;
        let changed = this.viewState.measure(this);
        if (!changed && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (i2 > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let measuring = [];
        if (!(changed & 4))
          [this.measureRequests, measuring] = [measuring, this.measureRequests];
        let measured = measuring.map((m2) => {
          try {
            return m2.read(this);
          } catch (e25) {
            logException(this.state, e25);
            return BadMeasure;
          }
        });
        let update = ViewUpdate.create(this, this.state, []), redrawn = false;
        update.flags |= changed;
        if (!updated)
          updated = update;
        else
          updated.flags |= changed;
        this.updateState = 2;
        if (!update.empty) {
          this.updatePlugins(update);
          this.inputState.update(update);
          this.updateAttrs();
          redrawn = this.docView.update(update);
        }
        for (let i3 = 0; i3 < measuring.length; i3++)
          if (measured[i3] != BadMeasure) {
            try {
              let m2 = measuring[i3];
              if (m2.write)
                m2.write(measured[i3], this);
            } catch (e25) {
              logException(this.state, e25);
            }
          }
        if (redrawn)
          this.docView.updateSelection(true);
        if (!update.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight) {
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget);
              this.viewState.scrollTarget = null;
              continue;
            } else {
              let newAnchorHeight = scrollAnchorPos < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(scrollAnchorPos).top;
              let diff = newAnchorHeight - scrollAnchorHeight;
              if (diff > 1 || diff < -1) {
                scrollTop = sDOM.scrollTop = scrollTop + diff;
                scrollAnchorHeight = -1;
                continue;
              }
            }
          }
          break;
        }
      }
    } finally {
      this.updateState = 0;
      this.measureScheduled = -1;
    }
    if (updated && !updated.empty)
      for (let listener of this.state.facet(updateListener))
        listener(updated);
  }
  get themeClasses() {
    return baseThemeID + " " + (this.state.facet(darkTheme) ? baseDarkID : baseLightID) + " " + this.state.facet(theme$1);
  }
  updateAttrs() {
    let editorAttrs = attrsFromFacet(this, editorAttributes, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    });
    let contentAttrs = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      translate: "no",
      contenteditable: !this.state.facet(editable) ? "false" : "true",
      class: "cm-content",
      style: `${browser.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    if (this.state.readOnly)
      contentAttrs["aria-readonly"] = "true";
    attrsFromFacet(this, contentAttributes, contentAttrs);
    let changed = this.observer.ignore(() => {
      let changedContent = updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
      let changedEditor = updateAttrs(this.dom, this.editorAttrs, editorAttrs);
      return changedContent || changedEditor;
    });
    this.editorAttrs = editorAttrs;
    this.contentAttrs = contentAttrs;
    return changed;
  }
  showAnnouncements(trs) {
    let first = true;
    for (let tr2 of trs)
      for (let effect of tr2.effects)
        if (effect.is(EditorView.announce)) {
          if (first)
            this.announceDOM.textContent = "";
          first = false;
          let div = this.announceDOM.appendChild(document.createElement("div"));
          div.textContent = effect.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(styleModule);
    StyleModule.mount(this.root, this.styleModules.concat(baseTheme$1$2).reverse());
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    if (this.updateState == 0 && this.measureScheduled > -1)
      this.measure(false);
  }
  requestMeasure(request) {
    if (this.measureScheduled < 0)
      this.measureScheduled = this.win.requestAnimationFrame(() => this.measure());
    if (request) {
      if (this.measureRequests.indexOf(request) > -1)
        return;
      if (request.key != null)
        for (let i2 = 0; i2 < this.measureRequests.length; i2++) {
          if (this.measureRequests[i2].key === request.key) {
            this.measureRequests[i2] = request;
            return;
          }
        }
      this.measureRequests.push(request);
    }
  }
  plugin(plugin2) {
    let known = this.pluginMap.get(plugin2);
    if (known === void 0 || known && known.spec != plugin2)
      this.pluginMap.set(plugin2, known = this.plugins.find((p2) => p2.spec == plugin2) || null);
    return known && known.update(this).value;
  }
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  elementAtHeight(height) {
    this.readMeasured();
    return this.viewState.elementAtHeight(height);
  }
  lineBlockAtHeight(height) {
    this.readMeasured();
    return this.viewState.lineBlockAtHeight(height);
  }
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  lineBlockAt(pos) {
    return this.viewState.lineBlockAt(pos);
  }
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  moveByChar(start, forward, by2) {
    return skipAtoms(this, start, moveByChar(this, start, forward, by2));
  }
  moveByGroup(start, forward) {
    return skipAtoms(this, start, moveByChar(this, start, forward, (initial) => byGroup(this, start.head, initial)));
  }
  moveToLineBoundary(start, forward, includeWrap = true) {
    return moveToLineBoundary(this, start, forward, includeWrap);
  }
  moveVertically(start, forward, distance) {
    return skipAtoms(this, start, moveVertically(this, start, forward, distance));
  }
  domAtPos(pos) {
    return this.docView.domAtPos(pos);
  }
  posAtDOM(node2, offset = 0) {
    return this.docView.posFromDOM(node2, offset);
  }
  posAtCoords(coords, precise = true) {
    this.readMeasured();
    return posAtCoords(this, coords, precise);
  }
  coordsAtPos(pos, side = 1) {
    this.readMeasured();
    let rect = this.docView.coordsAt(pos, side);
    if (!rect || rect.left == rect.right)
      return rect;
    let line = this.state.doc.lineAt(pos), order = this.bidiSpans(line);
    let span = order[BidiSpan.find(order, pos - line.from, -1, side)];
    return flattenRect(rect, span.dir == Direction.LTR == side > 0);
  }
  coordsForChar(pos) {
    this.readMeasured();
    return this.docView.coordsForChar(pos);
  }
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  textDirectionAt(pos) {
    let perLine = this.state.facet(perLineTextDirection);
    if (!perLine || pos < this.viewport.from || pos > this.viewport.to)
      return this.textDirection;
    this.readMeasured();
    return this.docView.textDirectionAt(pos);
  }
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  bidiSpans(line) {
    if (line.length > MaxBidiLine)
      return trivialOrder(line.length);
    let dir = this.textDirectionAt(line.from);
    for (let entry of this.bidiCache)
      if (entry.from == line.from && entry.dir == dir)
        return entry.order;
    let order = computeOrder(line.text, dir);
    this.bidiCache.push(new CachedOrder(line.from, line.to, dir, order));
    return order;
  }
  get hasFocus() {
    var _a2;
    return (this.dom.ownerDocument.hasFocus() || browser.safari && ((_a2 = this.inputState) === null || _a2 === void 0 ? void 0 : _a2.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  focus() {
    this.observer.ignore(() => {
      focusPreventScroll(this.contentDOM);
      this.docView.updateSelection();
    });
  }
  setRoot(root2) {
    if (this._root != root2) {
      this._root = root2;
      this.observer.setWindow((root2.nodeType == 9 ? root2 : root2.ownerDocument).defaultView || window);
      this.mountStyles();
    }
  }
  destroy() {
    for (let plugin2 of this.plugins)
      plugin2.destroy(this);
    this.plugins = [];
    this.inputState.destroy();
    this.dom.remove();
    this.observer.destroy();
    if (this.measureScheduled > -1)
      this.win.cancelAnimationFrame(this.measureScheduled);
    this.destroyed = true;
  }
  static scrollIntoView(pos, options = {}) {
    return scrollIntoView$1.of(new ScrollTarget(typeof pos == "number" ? EditorSelection.cursor(pos) : pos, options.y, options.x, options.yMargin, options.xMargin));
  }
  static domEventHandlers(handlers2) {
    return ViewPlugin.define(() => ({}), { eventHandlers: handlers2 });
  }
  static theme(spec2, options) {
    let prefix2 = StyleModule.newName();
    let result2 = [theme$1.of(prefix2), styleModule.of(buildTheme(`.${prefix2}`, spec2))];
    if (options && options.dark)
      result2.push(darkTheme.of(true));
    return result2;
  }
  static baseTheme(spec2) {
    return Prec.lowest(styleModule.of(buildTheme("." + baseThemeID, spec2, lightDarkIDs)));
  }
  static findFromDOM(dom) {
    var _a2;
    let content2 = dom.querySelector(".cm-content");
    let cView = content2 && ContentView.get(content2) || ContentView.get(dom);
    return ((_a2 = cView === null || cView === void 0 ? void 0 : cView.rootView) === null || _a2 === void 0 ? void 0 : _a2.view) || null;
  }
}
EditorView.styleModule = styleModule;
EditorView.inputHandler = inputHandler$1;
EditorView.focusChangeEffect = focusChangeEffect;
EditorView.perLineTextDirection = perLineTextDirection;
EditorView.exceptionSink = exceptionSink;
EditorView.updateListener = updateListener;
EditorView.editable = editable;
EditorView.mouseSelectionStyle = mouseSelectionStyle;
EditorView.dragMovesSelection = dragMovesSelection$1;
EditorView.clickAddsSelectionRange = clickAddsSelectionRange;
EditorView.decorations = decorations;
EditorView.atomicRanges = atomicRanges;
EditorView.scrollMargins = scrollMargins;
EditorView.darkTheme = darkTheme;
EditorView.contentAttributes = contentAttributes;
EditorView.editorAttributes = editorAttributes;
EditorView.lineWrapping = /* @__PURE__ */ EditorView.contentAttributes.of({ "class": "cm-lineWrapping" });
EditorView.announce = /* @__PURE__ */ StateEffect.define();
const MaxBidiLine = 4096;
const BadMeasure = {};
class CachedOrder {
  constructor(from, to2, dir, order) {
    this.from = from;
    this.to = to2;
    this.dir = dir;
    this.order = order;
  }
  static update(cache2, changes) {
    if (changes.empty)
      return cache2;
    let result2 = [], lastDir = cache2.length ? cache2[cache2.length - 1].dir : Direction.LTR;
    for (let i2 = Math.max(0, cache2.length - 10); i2 < cache2.length; i2++) {
      let entry = cache2[i2];
      if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to))
        result2.push(new CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.order));
    }
    return result2;
  }
}
function attrsFromFacet(view, facet, base2) {
  for (let sources = view.state.facet(facet), i2 = sources.length - 1; i2 >= 0; i2--) {
    let source = sources[i2], value2 = typeof source == "function" ? source(view) : source;
    if (value2)
      combineAttrs(value2, base2);
  }
  return base2;
}
const currentPlatform = browser.mac ? "mac" : browser.windows ? "win" : browser.linux ? "linux" : "key";
function normalizeKeyName(name2, platform) {
  const parts = name2.split(/-(?!$)/);
  let result2 = parts[parts.length - 1];
  if (result2 == "Space")
    result2 = " ";
  let alt, ctrl, shift2, meta2;
  for (let i2 = 0; i2 < parts.length - 1; ++i2) {
    const mod = parts[i2];
    if (/^(cmd|meta|m)$/i.test(mod))
      meta2 = true;
    else if (/^a(lt)?$/i.test(mod))
      alt = true;
    else if (/^(c|ctrl|control)$/i.test(mod))
      ctrl = true;
    else if (/^s(hift)?$/i.test(mod))
      shift2 = true;
    else if (/^mod$/i.test(mod)) {
      if (platform == "mac")
        meta2 = true;
      else
        ctrl = true;
    } else
      throw new Error("Unrecognized modifier name: " + mod);
  }
  if (alt)
    result2 = "Alt-" + result2;
  if (ctrl)
    result2 = "Ctrl-" + result2;
  if (meta2)
    result2 = "Meta-" + result2;
  if (shift2)
    result2 = "Shift-" + result2;
  return result2;
}
function modifiers(name2, event, shift2) {
  if (event.altKey)
    name2 = "Alt-" + name2;
  if (event.ctrlKey)
    name2 = "Ctrl-" + name2;
  if (event.metaKey)
    name2 = "Meta-" + name2;
  if (shift2 !== false && event.shiftKey)
    name2 = "Shift-" + name2;
  return name2;
}
const handleKeyEvents = /* @__PURE__ */ Prec.default(/* @__PURE__ */ EditorView.domEventHandlers({
  keydown(event, view) {
    return runHandlers(getKeymap(view.state), event, view, "editor");
  }
}));
const keymap = /* @__PURE__ */ Facet.define({ enables: handleKeyEvents });
const Keymaps = /* @__PURE__ */ new WeakMap();
function getKeymap(state) {
  let bindings = state.facet(keymap);
  let map2 = Keymaps.get(bindings);
  if (!map2)
    Keymaps.set(bindings, map2 = buildKeymap(bindings.reduce((a2, b2) => a2.concat(b2), [])));
  return map2;
}
function runScopeHandlers(view, event, scope2) {
  return runHandlers(getKeymap(view.state), event, view, scope2);
}
let storedPrefix = null;
const PrefixTimeout = 4e3;
function buildKeymap(bindings, platform = currentPlatform) {
  let bound = Object.create(null);
  let isPrefix = Object.create(null);
  let checkPrefix = (name2, is2) => {
    let current = isPrefix[name2];
    if (current == null)
      isPrefix[name2] = is2;
    else if (current != is2)
      throw new Error("Key binding " + name2 + " is used both as a regular binding and as a multi-stroke prefix");
  };
  let add2 = (scope2, key, command2, preventDefault, stopPropagation) => {
    var _a2, _b2;
    let scopeObj = bound[scope2] || (bound[scope2] = Object.create(null));
    let parts = key.split(/ (?!$)/).map((k2) => normalizeKeyName(k2, platform));
    for (let i2 = 1; i2 < parts.length; i2++) {
      let prefix2 = parts.slice(0, i2).join(" ");
      checkPrefix(prefix2, true);
      if (!scopeObj[prefix2])
        scopeObj[prefix2] = {
          preventDefault: true,
          stopPropagation: false,
          run: [(view) => {
            let ourObj = storedPrefix = { view, prefix: prefix2, scope: scope2 };
            setTimeout(() => {
              if (storedPrefix == ourObj)
                storedPrefix = null;
            }, PrefixTimeout);
            return true;
          }]
        };
    }
    let full = parts.join(" ");
    checkPrefix(full, false);
    let binding = scopeObj[full] || (scopeObj[full] = {
      preventDefault: false,
      stopPropagation: false,
      run: ((_b2 = (_a2 = scopeObj._any) === null || _a2 === void 0 ? void 0 : _a2.run) === null || _b2 === void 0 ? void 0 : _b2.slice()) || []
    });
    if (command2)
      binding.run.push(command2);
    if (preventDefault)
      binding.preventDefault = true;
    if (stopPropagation)
      binding.stopPropagation = true;
  };
  for (let b2 of bindings) {
    let scopes = b2.scope ? b2.scope.split(" ") : ["editor"];
    if (b2.any)
      for (let scope2 of scopes) {
        let scopeObj = bound[scope2] || (bound[scope2] = Object.create(null));
        if (!scopeObj._any)
          scopeObj._any = { preventDefault: false, stopPropagation: false, run: [] };
        for (let key in scopeObj)
          scopeObj[key].run.push(b2.any);
      }
    let name2 = b2[platform] || b2.key;
    if (!name2)
      continue;
    for (let scope2 of scopes) {
      add2(scope2, name2, b2.run, b2.preventDefault, b2.stopPropagation);
      if (b2.shift)
        add2(scope2, "Shift-" + name2, b2.shift, b2.preventDefault, b2.stopPropagation);
    }
  }
  return bound;
}
function runHandlers(map2, event, view, scope2) {
  let name2 = keyName(event);
  let charCode = codePointAt(name2, 0), isChar = codePointSize(charCode) == name2.length && name2 != " ";
  let prefix2 = "", handled = false, prevented = false, stopPropagation = false;
  if (storedPrefix && storedPrefix.view == view && storedPrefix.scope == scope2) {
    prefix2 = storedPrefix.prefix + " ";
    if (modifierCodes.indexOf(event.keyCode) < 0) {
      prevented = true;
      storedPrefix = null;
    }
  }
  let ran = new Set();
  let runFor = (binding) => {
    if (binding) {
      for (let cmd2 of binding.run)
        if (!ran.has(cmd2)) {
          ran.add(cmd2);
          if (cmd2(view, event)) {
            if (binding.stopPropagation)
              stopPropagation = true;
            return true;
          }
        }
      if (binding.preventDefault) {
        if (binding.stopPropagation)
          stopPropagation = true;
        prevented = true;
      }
    }
    return false;
  };
  let scopeObj = map2[scope2], baseName, shiftName;
  if (scopeObj) {
    if (runFor(scopeObj[prefix2 + modifiers(name2, event, !isChar)])) {
      handled = true;
    } else if (isChar && (event.altKey || event.metaKey || event.ctrlKey) && !(browser.windows && event.ctrlKey && event.altKey) && (baseName = base[event.keyCode]) && baseName != name2) {
      if (runFor(scopeObj[prefix2 + modifiers(baseName, event, true)])) {
        handled = true;
      } else if (event.shiftKey && (shiftName = shift[event.keyCode]) != name2 && shiftName != baseName && runFor(scopeObj[prefix2 + modifiers(shiftName, event, false)])) {
        handled = true;
      }
    } else if (isChar && event.shiftKey && runFor(scopeObj[prefix2 + modifiers(name2, event, true)])) {
      handled = true;
    }
    if (!handled && runFor(scopeObj._any))
      handled = true;
  }
  if (prevented)
    handled = true;
  if (handled && stopPropagation)
    event.stopPropagation();
  return handled;
}
class RectangleMarker {
  constructor(className, left, top2, width, height) {
    this.className = className;
    this.left = left;
    this.top = top2;
    this.width = width;
    this.height = height;
  }
  draw() {
    let elt = document.createElement("div");
    elt.className = this.className;
    this.adjust(elt);
    return elt;
  }
  update(elt, prev) {
    if (prev.className != this.className)
      return false;
    this.adjust(elt);
    return true;
  }
  adjust(elt) {
    elt.style.left = this.left + "px";
    elt.style.top = this.top + "px";
    if (this.width != null)
      elt.style.width = this.width + "px";
    elt.style.height = this.height + "px";
  }
  eq(p2) {
    return this.left == p2.left && this.top == p2.top && this.width == p2.width && this.height == p2.height && this.className == p2.className;
  }
  static forRange(view, className, range3) {
    if (range3.empty) {
      let pos = view.coordsAtPos(range3.head, range3.assoc || 1);
      if (!pos)
        return [];
      let base2 = getBase(view);
      return [new RectangleMarker(className, pos.left - base2.left, pos.top - base2.top, null, pos.bottom - pos.top)];
    } else {
      return rectanglesForRange(view, className, range3);
    }
  }
}
function getBase(view) {
  let rect = view.scrollDOM.getBoundingClientRect();
  let left = view.textDirection == Direction.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth;
  return { left: left - view.scrollDOM.scrollLeft, top: rect.top - view.scrollDOM.scrollTop };
}
function wrappedLine(view, pos, inside2) {
  let range3 = EditorSelection.cursor(pos);
  return {
    from: Math.max(inside2.from, view.moveToLineBoundary(range3, false, true).from),
    to: Math.min(inside2.to, view.moveToLineBoundary(range3, true, true).from),
    type: BlockType.Text
  };
}
function rectanglesForRange(view, className, range3) {
  if (range3.to <= view.viewport.from || range3.from >= view.viewport.to)
    return [];
  let from = Math.max(range3.from, view.viewport.from), to2 = Math.min(range3.to, view.viewport.to);
  let ltr = view.textDirection == Direction.LTR;
  let content2 = view.contentDOM, contentRect = content2.getBoundingClientRect(), base2 = getBase(view);
  let lineElt = content2.querySelector(".cm-line"), lineStyle = lineElt && window.getComputedStyle(lineElt);
  let leftSide = contentRect.left + (lineStyle ? parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent)) : 0);
  let rightSide = contentRect.right - (lineStyle ? parseInt(lineStyle.paddingRight) : 0);
  let startBlock = blockAt(view, from), endBlock = blockAt(view, to2);
  let visualStart = startBlock.type == BlockType.Text ? startBlock : null;
  let visualEnd = endBlock.type == BlockType.Text ? endBlock : null;
  if (visualStart && (view.lineWrapping || startBlock.widgetLineBreaks))
    visualStart = wrappedLine(view, from, visualStart);
  if (visualEnd && (view.lineWrapping || endBlock.widgetLineBreaks))
    visualEnd = wrappedLine(view, to2, visualEnd);
  if (visualStart && visualEnd && visualStart.from == visualEnd.from) {
    return pieces(drawForLine(range3.from, range3.to, visualStart));
  } else {
    let top2 = visualStart ? drawForLine(range3.from, null, visualStart) : drawForWidget(startBlock, false);
    let bottom = visualEnd ? drawForLine(null, range3.to, visualEnd) : drawForWidget(endBlock, true);
    let between = [];
    if ((visualStart || startBlock).to < (visualEnd || endBlock).from - (visualStart && visualEnd ? 1 : 0) || startBlock.widgetLineBreaks > 1 && top2.bottom + view.defaultLineHeight / 2 < bottom.top)
      between.push(piece(leftSide, top2.bottom, rightSide, bottom.top));
    else if (top2.bottom < bottom.top && view.elementAtHeight((top2.bottom + bottom.top) / 2).type == BlockType.Text)
      top2.bottom = bottom.top = (top2.bottom + bottom.top) / 2;
    return pieces(top2).concat(between).concat(pieces(bottom));
  }
  function piece(left, top2, right, bottom) {
    return new RectangleMarker(className, left - base2.left, top2 - base2.top - 0.01, right - left, bottom - top2 + 0.01);
  }
  function pieces({ top: top2, bottom, horizontal }) {
    let pieces2 = [];
    for (let i2 = 0; i2 < horizontal.length; i2 += 2)
      pieces2.push(piece(horizontal[i2], top2, horizontal[i2 + 1], bottom));
    return pieces2;
  }
  function drawForLine(from2, to3, line) {
    let top2 = 1e9, bottom = -1e9, horizontal = [];
    function addSpan(from3, fromOpen, to4, toOpen, dir) {
      let fromCoords = view.coordsAtPos(from3, from3 == line.to ? -2 : 2);
      let toCoords = view.coordsAtPos(to4, to4 == line.from ? 2 : -2);
      if (!fromCoords || !toCoords)
        return;
      top2 = Math.min(fromCoords.top, toCoords.top, top2);
      bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
      if (dir == Direction.LTR)
        horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
      else
        horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
    }
    let start = from2 !== null && from2 !== void 0 ? from2 : line.from, end = to3 !== null && to3 !== void 0 ? to3 : line.to;
    for (let r2 of view.visibleRanges)
      if (r2.to > start && r2.from < end) {
        for (let pos = Math.max(r2.from, start), endPos = Math.min(r2.to, end); ; ) {
          let docLine = view.state.doc.lineAt(pos);
          for (let span of view.bidiSpans(docLine)) {
            let spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
            if (spanFrom >= endPos)
              break;
            if (spanTo > pos)
              addSpan(Math.max(spanFrom, pos), from2 == null && spanFrom <= start, Math.min(spanTo, endPos), to3 == null && spanTo >= end, span.dir);
          }
          pos = docLine.to + 1;
          if (pos >= endPos)
            break;
        }
      }
    if (horizontal.length == 0)
      addSpan(start, from2 == null, end, to3 == null, view.textDirection);
    return { top: top2, bottom, horizontal };
  }
  function drawForWidget(block, top2) {
    let y2 = contentRect.top + (top2 ? block.top : block.bottom);
    return { top: y2, bottom: y2, horizontal: [] };
  }
}
function sameMarker(a2, b2) {
  return a2.constructor == b2.constructor && a2.eq(b2);
}
class LayerView {
  constructor(view, layer2) {
    this.view = view;
    this.layer = layer2;
    this.drawn = [];
    this.measureReq = { read: this.measure.bind(this), write: this.draw.bind(this) };
    this.dom = view.scrollDOM.appendChild(document.createElement("div"));
    this.dom.classList.add("cm-layer");
    if (layer2.above)
      this.dom.classList.add("cm-layer-above");
    if (layer2.class)
      this.dom.classList.add(layer2.class);
    this.dom.setAttribute("aria-hidden", "true");
    this.setOrder(view.state);
    view.requestMeasure(this.measureReq);
    if (layer2.mount)
      layer2.mount(this.dom, view);
  }
  update(update) {
    if (update.startState.facet(layerOrder) != update.state.facet(layerOrder))
      this.setOrder(update.state);
    if (this.layer.update(update, this.dom) || update.geometryChanged)
      update.view.requestMeasure(this.measureReq);
  }
  setOrder(state) {
    let pos = 0, order = state.facet(layerOrder);
    while (pos < order.length && order[pos] != this.layer)
      pos++;
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - pos);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  draw(markers) {
    if (markers.length != this.drawn.length || markers.some((p2, i2) => !sameMarker(p2, this.drawn[i2]))) {
      let old = this.dom.firstChild, oldI = 0;
      for (let marker of markers) {
        if (marker.update && old && marker.constructor && this.drawn[oldI].constructor && marker.update(old, this.drawn[oldI])) {
          old = old.nextSibling;
          oldI++;
        } else {
          this.dom.insertBefore(marker.draw(), old);
        }
      }
      while (old) {
        let next = old.nextSibling;
        old.remove();
        old = next;
      }
      this.drawn = markers;
    }
  }
  destroy() {
    if (this.layer.destroy)
      this.layer.destroy(this.dom, this.view);
    this.dom.remove();
  }
}
const layerOrder = /* @__PURE__ */ Facet.define();
function layer(config2) {
  return [
    ViewPlugin.define((v2) => new LayerView(v2, config2)),
    layerOrder.of(config2)
  ];
}
const CanHidePrimary = !browser.ios;
const selectionConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      cursorBlinkRate: 1200,
      drawRangeCursor: true
    }, {
      cursorBlinkRate: (a2, b2) => Math.min(a2, b2),
      drawRangeCursor: (a2, b2) => a2 || b2
    });
  }
});
function drawSelection(config2 = {}) {
  return [
    selectionConfig.of(config2),
    cursorLayer,
    selectionLayer,
    hideNativeSelection,
    nativeSelectionHidden.of(true)
  ];
}
function configChanged(update) {
  return update.startState.facet(selectionConfig) != update.state.facet(selectionConfig);
}
const cursorLayer = /* @__PURE__ */ layer({
  above: true,
  markers(view) {
    let { state } = view, conf = state.facet(selectionConfig);
    let cursors = [];
    for (let r2 of state.selection.ranges) {
      let prim = r2 == state.selection.main;
      if (r2.empty ? !prim || CanHidePrimary : conf.drawRangeCursor) {
        let className = prim ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
        let cursor = r2.empty ? r2 : EditorSelection.cursor(r2.head, r2.head > r2.anchor ? -1 : 1);
        for (let piece of RectangleMarker.forRange(view, className, cursor))
          cursors.push(piece);
      }
    }
    return cursors;
  },
  update(update, dom) {
    if (update.transactions.some((tr2) => tr2.selection))
      dom.style.animationName = dom.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
    let confChange = configChanged(update);
    if (confChange)
      setBlinkRate(update.state, dom);
    return update.docChanged || update.selectionSet || confChange;
  },
  mount(dom, view) {
    setBlinkRate(view.state, dom);
  },
  class: "cm-cursorLayer"
});
function setBlinkRate(state, dom) {
  dom.style.animationDuration = state.facet(selectionConfig).cursorBlinkRate + "ms";
}
const selectionLayer = /* @__PURE__ */ layer({
  above: false,
  markers(view) {
    return view.state.selection.ranges.map((r2) => r2.empty ? [] : RectangleMarker.forRange(view, "cm-selectionBackground", r2)).reduce((a2, b2) => a2.concat(b2));
  },
  update(update, dom) {
    return update.docChanged || update.selectionSet || update.viewportChanged || configChanged(update);
  },
  class: "cm-selectionLayer"
});
const themeSpec = {
  ".cm-line": {
    "& ::selection": { backgroundColor: "transparent !important" },
    "&::selection": { backgroundColor: "transparent !important" }
  }
};
if (CanHidePrimary)
  themeSpec[".cm-line"].caretColor = "transparent !important";
const hideNativeSelection = /* @__PURE__ */ Prec.highest(/* @__PURE__ */ EditorView.theme(themeSpec));
const setDropCursorPos = /* @__PURE__ */ StateEffect.define({
  map(pos, mapping) {
    return pos == null ? null : mapping.mapPos(pos);
  }
});
const dropCursorPos = /* @__PURE__ */ StateField.define({
  create() {
    return null;
  },
  update(pos, tr2) {
    if (pos != null)
      pos = tr2.changes.mapPos(pos);
    return tr2.effects.reduce((pos2, e25) => e25.is(setDropCursorPos) ? e25.value : pos2, pos);
  }
});
const drawDropCursor = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.cursor = null;
    this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(update) {
    var _a2;
    let cursorPos = update.state.field(dropCursorPos);
    if (cursorPos == null) {
      if (this.cursor != null) {
        (_a2 = this.cursor) === null || _a2 === void 0 ? void 0 : _a2.remove();
        this.cursor = null;
      }
    } else {
      if (!this.cursor) {
        this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
        this.cursor.className = "cm-dropCursor";
      }
      if (update.startState.field(dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged)
        this.view.requestMeasure(this.measureReq);
    }
  }
  readPos() {
    let pos = this.view.state.field(dropCursorPos);
    let rect = pos != null && this.view.coordsAtPos(pos);
    if (!rect)
      return null;
    let outer = this.view.scrollDOM.getBoundingClientRect();
    return {
      left: rect.left - outer.left + this.view.scrollDOM.scrollLeft,
      top: rect.top - outer.top + this.view.scrollDOM.scrollTop,
      height: rect.bottom - rect.top
    };
  }
  drawCursor(pos) {
    if (this.cursor) {
      if (pos) {
        this.cursor.style.left = pos.left + "px";
        this.cursor.style.top = pos.top + "px";
        this.cursor.style.height = pos.height + "px";
      } else {
        this.cursor.style.left = "-100000px";
      }
    }
  }
  destroy() {
    if (this.cursor)
      this.cursor.remove();
  }
  setDropPos(pos) {
    if (this.view.state.field(dropCursorPos) != pos)
      this.view.dispatch({ effects: setDropCursorPos.of(pos) });
  }
}, {
  eventHandlers: {
    dragover(event) {
      this.setDropPos(this.view.posAtCoords({ x: event.clientX, y: event.clientY }));
    },
    dragleave(event) {
      if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget))
        this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function dropCursor() {
  return [dropCursorPos, drawDropCursor];
}
function iterMatches(doc2, re2, from, to2, f2) {
  re2.lastIndex = 0;
  for (let cursor = doc2.iterRange(from, to2), pos = from, m2; !cursor.next().done; pos += cursor.value.length) {
    if (!cursor.lineBreak)
      while (m2 = re2.exec(cursor.value))
        f2(pos + m2.index, m2);
  }
}
function matchRanges(view, maxLength) {
  let visible = view.visibleRanges;
  if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to)
    return visible;
  let result2 = [];
  for (let { from, to: to2 } of visible) {
    from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
    to2 = Math.min(view.state.doc.lineAt(to2).to, to2 + maxLength);
    if (result2.length && result2[result2.length - 1].to >= from)
      result2[result2.length - 1].to = to2;
    else
      result2.push({ from, to: to2 });
  }
  return result2;
}
class MatchDecorator {
  constructor(config2) {
    const { regexp: regexp4, decoration, decorate, boundary, maxLength = 1e3 } = config2;
    if (!regexp4.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    this.regexp = regexp4;
    if (decorate) {
      this.addMatch = (match2, view, from, add2) => decorate(add2, from, from + match2[0].length, match2, view);
    } else if (typeof decoration == "function") {
      this.addMatch = (match2, view, from, add2) => {
        let deco = decoration(match2, view, from);
        if (deco)
          add2(from, from + match2[0].length, deco);
      };
    } else if (decoration) {
      this.addMatch = (match2, _view, from, add2) => add2(from, from + match2[0].length, decoration);
    } else {
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    }
    this.boundary = boundary;
    this.maxLength = maxLength;
  }
  createDeco(view) {
    let build = new RangeSetBuilder(), add2 = build.add.bind(build);
    for (let { from, to: to2 } of matchRanges(view, this.maxLength))
      iterMatches(view.state.doc, this.regexp, from, to2, (from2, m2) => this.addMatch(m2, view, from2, add2));
    return build.finish();
  }
  updateDeco(update, deco) {
    let changeFrom = 1e9, changeTo = -1;
    if (update.docChanged)
      update.changes.iterChanges((_f2, _t2, from, to2) => {
        if (to2 > update.view.viewport.from && from < update.view.viewport.to) {
          changeFrom = Math.min(from, changeFrom);
          changeTo = Math.max(to2, changeTo);
        }
      });
    if (update.viewportChanged || changeTo - changeFrom > 1e3)
      return this.createDeco(update.view);
    if (changeTo > -1)
      return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
    return deco;
  }
  updateRange(view, deco, updateFrom, updateTo) {
    for (let r2 of view.visibleRanges) {
      let from = Math.max(r2.from, updateFrom), to2 = Math.min(r2.to, updateTo);
      if (to2 > from) {
        let fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to2 ? view.state.doc.lineAt(to2) : fromLine;
        let start = Math.max(r2.from, fromLine.from), end = Math.min(r2.to, toLine.to);
        if (this.boundary) {
          for (; from > fromLine.from; from--)
            if (this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
              start = from;
              break;
            }
          for (; to2 < toLine.to; to2++)
            if (this.boundary.test(toLine.text[to2 - toLine.from])) {
              end = to2;
              break;
            }
        }
        let ranges = [], m2;
        let add2 = (from2, to3, deco2) => ranges.push(deco2.range(from2, to3));
        if (fromLine == toLine) {
          this.regexp.lastIndex = start - fromLine.from;
          while ((m2 = this.regexp.exec(fromLine.text)) && m2.index < end - fromLine.from)
            this.addMatch(m2, view, m2.index + fromLine.from, add2);
        } else {
          iterMatches(view.state.doc, this.regexp, start, end, (from2, m3) => this.addMatch(m3, view, from2, add2));
        }
        deco = deco.update({ filterFrom: start, filterTo: end, filter: (from2, to3) => from2 < start || to3 > end, add: ranges });
      }
    }
    return deco;
  }
}
const UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
const Specials = /* @__PURE__ */ new RegExp("[\0-\b\n-\x7F-\x9F\xAD\u061C\u200B\u200E\u200F\u2028\u2029\u202D\u202E\u2066\u2067\u2069\uFEFF\uFFF9-\uFFFC]", UnicodeRegexpSupport);
const Names = {
  0: "null",
  7: "bell",
  8: "backspace",
  10: "newline",
  11: "vertical tab",
  13: "carriage return",
  27: "escape",
  8203: "zero width space",
  8204: "zero width non-joiner",
  8205: "zero width joiner",
  8206: "left-to-right mark",
  8207: "right-to-left mark",
  8232: "line separator",
  8237: "left-to-right override",
  8238: "right-to-left override",
  8294: "left-to-right isolate",
  8295: "right-to-left isolate",
  8297: "pop directional isolate",
  8233: "paragraph separator",
  65279: "zero width no-break space",
  65532: "object replacement"
};
let _supportsTabSize = null;
function supportsTabSize() {
  var _a2;
  if (_supportsTabSize == null && typeof document != "undefined" && document.body) {
    let styles2 = document.body.style;
    _supportsTabSize = ((_a2 = styles2.tabSize) !== null && _a2 !== void 0 ? _a2 : styles2.MozTabSize) != null;
  }
  return _supportsTabSize || false;
}
const specialCharConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    let config2 = combineConfig(configs, {
      render: null,
      specialChars: Specials,
      addSpecialChars: null
    });
    if (config2.replaceTabs = !supportsTabSize())
      config2.specialChars = new RegExp("	|" + config2.specialChars.source, UnicodeRegexpSupport);
    if (config2.addSpecialChars)
      config2.specialChars = new RegExp(config2.specialChars.source + "|" + config2.addSpecialChars.source, UnicodeRegexpSupport);
    return config2;
  }
});
function highlightSpecialChars(config2 = {}) {
  return [specialCharConfig.of(config2), specialCharPlugin()];
}
let _plugin = null;
function specialCharPlugin() {
  return _plugin || (_plugin = ViewPlugin.fromClass(class {
    constructor(view) {
      this.view = view;
      this.decorations = Decoration.none;
      this.decorationCache = Object.create(null);
      this.decorator = this.makeDecorator(view.state.facet(specialCharConfig));
      this.decorations = this.decorator.createDeco(view);
    }
    makeDecorator(conf) {
      return new MatchDecorator({
        regexp: conf.specialChars,
        decoration: (m2, view, pos) => {
          let { doc: doc2 } = view.state;
          let code = codePointAt(m2[0], 0);
          if (code == 9) {
            let line = doc2.lineAt(pos);
            let size2 = view.state.tabSize, col = countColumn(line.text, size2, pos - line.from);
            return Decoration.replace({ widget: new TabWidget((size2 - col % size2) * this.view.defaultCharacterWidth) });
          }
          return this.decorationCache[code] || (this.decorationCache[code] = Decoration.replace({ widget: new SpecialCharWidget(conf, code) }));
        },
        boundary: conf.replaceTabs ? void 0 : /[^]/
      });
    }
    update(update) {
      let conf = update.state.facet(specialCharConfig);
      if (update.startState.facet(specialCharConfig) != conf) {
        this.decorator = this.makeDecorator(conf);
        this.decorations = this.decorator.createDeco(update.view);
      } else {
        this.decorations = this.decorator.updateDeco(update, this.decorations);
      }
    }
  }, {
    decorations: (v2) => v2.decorations
  }));
}
const DefaultPlaceholder = "\u2022";
function placeholder$1(code) {
  if (code >= 32)
    return DefaultPlaceholder;
  if (code == 10)
    return "\u2424";
  return String.fromCharCode(9216 + code);
}
class SpecialCharWidget extends WidgetType {
  constructor(options, code) {
    super();
    this.options = options;
    this.code = code;
  }
  eq(other) {
    return other.code == this.code;
  }
  toDOM(view) {
    let ph2 = placeholder$1(this.code);
    let desc = view.state.phrase("Control character") + " " + (Names[this.code] || "0x" + this.code.toString(16));
    let custom = this.options.render && this.options.render(this.code, desc, ph2);
    if (custom)
      return custom;
    let span = document.createElement("span");
    span.textContent = ph2;
    span.title = desc;
    span.setAttribute("aria-label", desc);
    span.className = "cm-specialChar";
    return span;
  }
  ignoreEvent() {
    return false;
  }
}
class TabWidget extends WidgetType {
  constructor(width) {
    super();
    this.width = width;
  }
  eq(other) {
    return other.width == this.width;
  }
  toDOM() {
    let span = document.createElement("span");
    span.textContent = "	";
    span.className = "cm-tab";
    span.style.width = this.width + "px";
    return span;
  }
  ignoreEvent() {
    return false;
  }
}
function highlightActiveLine() {
  return activeLineHighlighter;
}
const lineDeco = /* @__PURE__ */ Decoration.line({ class: "cm-activeLine" });
const activeLineHighlighter = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.decorations = this.getDeco(view);
  }
  update(update) {
    if (update.docChanged || update.selectionSet)
      this.decorations = this.getDeco(update.view);
  }
  getDeco(view) {
    let lastLineStart = -1, deco = [];
    for (let r2 of view.state.selection.ranges) {
      let line = view.lineBlockAt(r2.head);
      if (line.from > lastLineStart) {
        deco.push(lineDeco.range(line.from));
        lastLineStart = line.from;
      }
    }
    return Decoration.set(deco);
  }
}, {
  decorations: (v2) => v2.decorations
});
const MaxOff = 2e3;
function rectangleFor(state, a2, b2) {
  let startLine = Math.min(a2.line, b2.line), endLine = Math.max(a2.line, b2.line);
  let ranges = [];
  if (a2.off > MaxOff || b2.off > MaxOff || a2.col < 0 || b2.col < 0) {
    let startOff = Math.min(a2.off, b2.off), endOff = Math.max(a2.off, b2.off);
    for (let i2 = startLine; i2 <= endLine; i2++) {
      let line = state.doc.line(i2);
      if (line.length <= endOff)
        ranges.push(EditorSelection.range(line.from + startOff, line.to + endOff));
    }
  } else {
    let startCol = Math.min(a2.col, b2.col), endCol = Math.max(a2.col, b2.col);
    for (let i2 = startLine; i2 <= endLine; i2++) {
      let line = state.doc.line(i2);
      let start = findColumn(line.text, startCol, state.tabSize, true);
      if (start < 0) {
        ranges.push(EditorSelection.cursor(line.to));
      } else {
        let end = findColumn(line.text, endCol, state.tabSize);
        ranges.push(EditorSelection.range(line.from + start, line.from + end));
      }
    }
  }
  return ranges;
}
function absoluteColumn(view, x2) {
  let ref2 = view.coordsAtPos(view.viewport.from);
  return ref2 ? Math.round(Math.abs((ref2.left - x2) / view.defaultCharacterWidth)) : -1;
}
function getPos(view, event) {
  let offset = view.posAtCoords({ x: event.clientX, y: event.clientY }, false);
  let line = view.state.doc.lineAt(offset), off2 = offset - line.from;
  let col = off2 > MaxOff ? -1 : off2 == line.length ? absoluteColumn(view, event.clientX) : countColumn(line.text, view.state.tabSize, offset - line.from);
  return { line: line.number, col, off: off2 };
}
function rectangleSelectionStyle(view, event) {
  let start = getPos(view, event), startSel = view.state.selection;
  if (!start)
    return null;
  return {
    update(update) {
      if (update.docChanged) {
        let newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
        let newLine = update.state.doc.lineAt(newStart);
        start = { line: newLine.number, col: start.col, off: Math.min(start.off, newLine.length) };
        startSel = startSel.map(update.changes);
      }
    },
    get(event2, _extend, multiple) {
      let cur2 = getPos(view, event2);
      if (!cur2)
        return startSel;
      let ranges = rectangleFor(view.state, start, cur2);
      if (!ranges.length)
        return startSel;
      if (multiple)
        return EditorSelection.create(ranges.concat(startSel.ranges));
      else
        return EditorSelection.create(ranges);
    }
  };
}
function rectangularSelection(options) {
  let filter = (options === null || options === void 0 ? void 0 : options.eventFilter) || ((e25) => e25.altKey && e25.button == 0);
  return EditorView.mouseSelectionStyle.of((view, event) => filter(event) ? rectangleSelectionStyle(view, event) : null);
}
const keys = {
  Alt: [18, (e25) => !!e25.altKey],
  Control: [17, (e25) => !!e25.ctrlKey],
  Shift: [16, (e25) => !!e25.shiftKey],
  Meta: [91, (e25) => !!e25.metaKey]
};
const showCrosshair = { style: "cursor: crosshair" };
function crosshairCursor(options = {}) {
  let [code, getter] = keys[options.key || "Alt"];
  let plugin2 = ViewPlugin.fromClass(class {
    constructor(view) {
      this.view = view;
      this.isDown = false;
    }
    set(isDown) {
      if (this.isDown != isDown) {
        this.isDown = isDown;
        this.view.update([]);
      }
    }
  }, {
    eventHandlers: {
      keydown(e25) {
        this.set(e25.keyCode == code || getter(e25));
      },
      keyup(e25) {
        if (e25.keyCode == code || !getter(e25))
          this.set(false);
      },
      mousemove(e25) {
        this.set(getter(e25));
      }
    }
  });
  return [
    plugin2,
    EditorView.contentAttributes.of((view) => {
      var _a2;
      return ((_a2 = view.plugin(plugin2)) === null || _a2 === void 0 ? void 0 : _a2.isDown) ? showCrosshair : null;
    })
  ];
}
const Outside = "-10000px";
class TooltipViewManager {
  constructor(view, facet, createTooltipView) {
    this.facet = facet;
    this.createTooltipView = createTooltipView;
    this.input = view.state.facet(facet);
    this.tooltips = this.input.filter((t2) => t2);
    this.tooltipViews = this.tooltips.map(createTooltipView);
  }
  update(update) {
    var _a2;
    let input = update.state.facet(this.facet);
    let tooltips = input.filter((x2) => x2);
    if (input === this.input) {
      for (let t2 of this.tooltipViews)
        if (t2.update)
          t2.update(update);
      return false;
    }
    let tooltipViews = [];
    for (let i2 = 0; i2 < tooltips.length; i2++) {
      let tip = tooltips[i2], known = -1;
      if (!tip)
        continue;
      for (let i3 = 0; i3 < this.tooltips.length; i3++) {
        let other = this.tooltips[i3];
        if (other && other.create == tip.create)
          known = i3;
      }
      if (known < 0) {
        tooltipViews[i2] = this.createTooltipView(tip);
      } else {
        let tooltipView = tooltipViews[i2] = this.tooltipViews[known];
        if (tooltipView.update)
          tooltipView.update(update);
      }
    }
    for (let t2 of this.tooltipViews)
      if (tooltipViews.indexOf(t2) < 0) {
        t2.dom.remove();
        (_a2 = t2.destroy) === null || _a2 === void 0 ? void 0 : _a2.call(t2);
      }
    this.input = input;
    this.tooltips = tooltips;
    this.tooltipViews = tooltipViews;
    return true;
  }
}
function windowSpace(view) {
  let { win } = view;
  return { top: 0, left: 0, bottom: win.innerHeight, right: win.innerWidth };
}
const tooltipConfig = /* @__PURE__ */ Facet.define({
  combine: (values2) => {
    var _a2, _b2, _c2;
    return {
      position: browser.ios ? "absolute" : ((_a2 = values2.find((conf) => conf.position)) === null || _a2 === void 0 ? void 0 : _a2.position) || "fixed",
      parent: ((_b2 = values2.find((conf) => conf.parent)) === null || _b2 === void 0 ? void 0 : _b2.parent) || null,
      tooltipSpace: ((_c2 = values2.find((conf) => conf.tooltipSpace)) === null || _c2 === void 0 ? void 0 : _c2.tooltipSpace) || windowSpace
    };
  }
});
const knownHeight = /* @__PURE__ */ new WeakMap();
const tooltipPlugin = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.inView = true;
    this.lastTransaction = 0;
    this.measureTimeout = -1;
    let config2 = view.state.facet(tooltipConfig);
    this.position = config2.position;
    this.parent = config2.parent;
    this.classes = view.themeClasses;
    this.createContainer();
    this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this };
    this.manager = new TooltipViewManager(view, showTooltip, (t2) => this.createTooltip(t2));
    this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries) => {
      if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1)
        this.measureSoon();
    }, { threshold: [1] }) : null;
    this.observeIntersection();
    view.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
    this.maybeMeasure();
  }
  createContainer() {
    if (this.parent) {
      this.container = document.createElement("div");
      this.container.style.position = "relative";
      this.container.className = this.view.themeClasses;
      this.parent.appendChild(this.container);
    } else {
      this.container = this.view.dom;
    }
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let tooltip of this.manager.tooltipViews)
        this.intersectionObserver.observe(tooltip.dom);
    }
  }
  measureSoon() {
    if (this.measureTimeout < 0)
      this.measureTimeout = setTimeout(() => {
        this.measureTimeout = -1;
        this.maybeMeasure();
      }, 50);
  }
  update(update) {
    if (update.transactions.length)
      this.lastTransaction = Date.now();
    let updated = this.manager.update(update);
    if (updated)
      this.observeIntersection();
    let shouldMeasure = updated || update.geometryChanged;
    let newConfig = update.state.facet(tooltipConfig);
    if (newConfig.position != this.position) {
      this.position = newConfig.position;
      for (let t2 of this.manager.tooltipViews)
        t2.dom.style.position = this.position;
      shouldMeasure = true;
    }
    if (newConfig.parent != this.parent) {
      if (this.parent)
        this.container.remove();
      this.parent = newConfig.parent;
      this.createContainer();
      for (let t2 of this.manager.tooltipViews)
        this.container.appendChild(t2.dom);
      shouldMeasure = true;
    } else if (this.parent && this.view.themeClasses != this.classes) {
      this.classes = this.container.className = this.view.themeClasses;
    }
    if (shouldMeasure)
      this.maybeMeasure();
  }
  createTooltip(tooltip) {
    let tooltipView = tooltip.create(this.view);
    tooltipView.dom.classList.add("cm-tooltip");
    if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let arrow = document.createElement("div");
      arrow.className = "cm-tooltip-arrow";
      tooltipView.dom.appendChild(arrow);
    }
    tooltipView.dom.style.position = this.position;
    tooltipView.dom.style.top = Outside;
    this.container.appendChild(tooltipView.dom);
    if (tooltipView.mount)
      tooltipView.mount(this.view);
    return tooltipView;
  }
  destroy() {
    var _a2, _b2;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let tooltipView of this.manager.tooltipViews) {
      tooltipView.dom.remove();
      (_a2 = tooltipView.destroy) === null || _a2 === void 0 ? void 0 : _a2.call(tooltipView);
    }
    (_b2 = this.intersectionObserver) === null || _b2 === void 0 ? void 0 : _b2.disconnect();
    clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let editor = this.view.dom.getBoundingClientRect();
    return {
      editor,
      parent: this.parent ? this.container.getBoundingClientRect() : editor,
      pos: this.manager.tooltips.map((t2, i2) => {
        let tv2 = this.manager.tooltipViews[i2];
        return tv2.getCoords ? tv2.getCoords(t2.pos) : this.view.coordsAtPos(t2.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom }) => dom.getBoundingClientRect()),
      space: this.view.state.facet(tooltipConfig).tooltipSpace(this.view)
    };
  }
  writeMeasure(measured) {
    var _a2;
    let { editor, space: space2 } = measured;
    let others = [];
    for (let i2 = 0; i2 < this.manager.tooltips.length; i2++) {
      let tooltip = this.manager.tooltips[i2], tView = this.manager.tooltipViews[i2], { dom } = tView;
      let pos = measured.pos[i2], size2 = measured.size[i2];
      if (!pos || pos.bottom <= Math.max(editor.top, space2.top) || pos.top >= Math.min(editor.bottom, space2.bottom) || pos.right < Math.max(editor.left, space2.left) - 0.1 || pos.left > Math.min(editor.right, space2.right) + 0.1) {
        dom.style.top = Outside;
        continue;
      }
      let arrow = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
      let arrowHeight = arrow ? 7 : 0;
      let width = size2.right - size2.left, height = (_a2 = knownHeight.get(tView)) !== null && _a2 !== void 0 ? _a2 : size2.bottom - size2.top;
      let offset = tView.offset || noOffset, ltr = this.view.textDirection == Direction.LTR;
      let left = size2.width > space2.right - space2.left ? ltr ? space2.left : space2.right - size2.width : ltr ? Math.min(pos.left - (arrow ? 14 : 0) + offset.x, space2.right - width) : Math.max(space2.left, pos.left - width + (arrow ? 14 : 0) - offset.x);
      let above = !!tooltip.above;
      if (!tooltip.strictSide && (above ? pos.top - (size2.bottom - size2.top) - offset.y < space2.top : pos.bottom + (size2.bottom - size2.top) + offset.y > space2.bottom) && above == space2.bottom - pos.bottom > pos.top - space2.top)
        above = !above;
      let spaceVert = (above ? pos.top - space2.top : space2.bottom - pos.bottom) - arrowHeight;
      if (spaceVert < height && tView.resize !== false) {
        if (spaceVert < this.view.defaultLineHeight) {
          dom.style.top = Outside;
          continue;
        }
        knownHeight.set(tView, height);
        dom.style.height = (height = spaceVert) + "px";
      } else if (dom.style.height) {
        dom.style.height = "";
      }
      let top2 = above ? pos.top - height - arrowHeight - offset.y : pos.bottom + arrowHeight + offset.y;
      let right = left + width;
      if (tView.overlap !== true) {
        for (let r2 of others)
          if (r2.left < right && r2.right > left && r2.top < top2 + height && r2.bottom > top2)
            top2 = above ? r2.top - height - 2 - arrowHeight : r2.bottom + arrowHeight + 2;
      }
      if (this.position == "absolute") {
        dom.style.top = top2 - measured.parent.top + "px";
        dom.style.left = left - measured.parent.left + "px";
      } else {
        dom.style.top = top2 + "px";
        dom.style.left = left + "px";
      }
      if (arrow)
        arrow.style.left = `${pos.left + (ltr ? offset.x : -offset.x) - (left + 14 - 7)}px`;
      if (tView.overlap !== true)
        others.push({ left, top: top2, right, bottom: top2 + height });
      dom.classList.toggle("cm-tooltip-above", above);
      dom.classList.toggle("cm-tooltip-below", !above);
      if (tView.positioned)
        tView.positioned(measured.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length) {
      if (this.view.inView)
        this.view.requestMeasure(this.measureReq);
      if (this.inView != this.view.inView) {
        this.inView = this.view.inView;
        if (!this.inView)
          for (let tv2 of this.manager.tooltipViews)
            tv2.dom.style.top = Outside;
      }
    }
  }
}, {
  eventHandlers: {
    scroll() {
      this.maybeMeasure();
    }
  }
});
const baseTheme$5 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-tooltip": {
    zIndex: 100,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: `${7}px`,
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: `${7}px solid transparent`,
      borderRight: `${7}px solid transparent`
    },
    ".cm-tooltip-above &": {
      bottom: `-${7}px`,
      "&:before": {
        borderTop: `${7}px solid #bbb`
      },
      "&:after": {
        borderTop: `${7}px solid #f5f5f5`,
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: `-${7}px`,
      "&:before": {
        borderBottom: `${7}px solid #bbb`
      },
      "&:after": {
        borderBottom: `${7}px solid #f5f5f5`,
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
});
const noOffset = { x: 0, y: 0 };
const showTooltip = /* @__PURE__ */ Facet.define({
  enables: [tooltipPlugin, baseTheme$5]
});
const showHoverTooltip = /* @__PURE__ */ Facet.define();
class HoverTooltipHost {
  constructor(view) {
    this.view = view;
    this.mounted = false;
    this.dom = document.createElement("div");
    this.dom.classList.add("cm-tooltip-hover");
    this.manager = new TooltipViewManager(view, showHoverTooltip, (t2) => this.createHostedView(t2));
  }
  static create(view) {
    return new HoverTooltipHost(view);
  }
  createHostedView(tooltip) {
    let hostedView = tooltip.create(this.view);
    hostedView.dom.classList.add("cm-tooltip-section");
    this.dom.appendChild(hostedView.dom);
    if (this.mounted && hostedView.mount)
      hostedView.mount(this.view);
    return hostedView;
  }
  mount(view) {
    for (let hostedView of this.manager.tooltipViews) {
      if (hostedView.mount)
        hostedView.mount(view);
    }
    this.mounted = true;
  }
  positioned(space2) {
    for (let hostedView of this.manager.tooltipViews) {
      if (hostedView.positioned)
        hostedView.positioned(space2);
    }
  }
  update(update) {
    this.manager.update(update);
  }
  destroy() {
    var _a2;
    for (let t2 of this.manager.tooltipViews)
      (_a2 = t2.destroy) === null || _a2 === void 0 ? void 0 : _a2.call(t2);
  }
}
const showHoverTooltipHost = /* @__PURE__ */ showTooltip.compute([showHoverTooltip], (state) => {
  let tooltips = state.facet(showHoverTooltip).filter((t2) => t2);
  if (tooltips.length === 0)
    return null;
  return {
    pos: Math.min(...tooltips.map((t2) => t2.pos)),
    end: Math.max(...tooltips.filter((t2) => t2.end != null).map((t2) => t2.end)),
    create: HoverTooltipHost.create,
    above: tooltips[0].above,
    arrow: tooltips.some((t2) => t2.arrow)
  };
});
class HoverPlugin {
  constructor(view, source, field, setHover, hoverTime) {
    this.view = view;
    this.source = source;
    this.field = field;
    this.setHover = setHover;
    this.hoverTime = hoverTime;
    this.hoverTimeout = -1;
    this.restartTimeout = -1;
    this.pending = null;
    this.lastMove = { x: 0, y: 0, target: view.dom, time: 0 };
    this.checkHover = this.checkHover.bind(this);
    view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
    view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    if (this.pending) {
      this.pending = null;
      clearTimeout(this.restartTimeout);
      this.restartTimeout = setTimeout(() => this.startHover(), 20);
    }
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    this.hoverTimeout = -1;
    if (this.active)
      return;
    let hovered = Date.now() - this.lastMove.time;
    if (hovered < this.hoverTime)
      this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
    else
      this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { lastMove } = this;
    let pos = this.view.contentDOM.contains(lastMove.target) ? this.view.posAtCoords(lastMove) : null;
    if (pos == null)
      return;
    let posCoords = this.view.coordsAtPos(pos);
    if (posCoords == null || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - this.view.defaultCharacterWidth || lastMove.x > posCoords.right + this.view.defaultCharacterWidth)
      return;
    let bidi = this.view.bidiSpans(this.view.state.doc.lineAt(pos)).find((s2) => s2.from <= pos && s2.to >= pos);
    let rtl = bidi && bidi.dir == Direction.RTL ? -1 : 1;
    let open = this.source(this.view, pos, lastMove.x < posCoords.left ? -rtl : rtl);
    if (open === null || open === void 0 ? void 0 : open.then) {
      let pending = this.pending = { pos };
      open.then((result2) => {
        if (this.pending == pending) {
          this.pending = null;
          if (result2)
            this.view.dispatch({ effects: this.setHover.of(result2) });
        }
      }, (e25) => logException(this.view.state, e25, "hover tooltip"));
    } else if (open) {
      this.view.dispatch({ effects: this.setHover.of(open) });
    }
  }
  mousemove(event) {
    var _a2;
    this.lastMove = { x: event.clientX, y: event.clientY, target: event.target, time: Date.now() };
    if (this.hoverTimeout < 0)
      this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
    let tooltip = this.active;
    if (tooltip && !isInTooltip(this.lastMove.target) || this.pending) {
      let { pos } = tooltip || this.pending, end = (_a2 = tooltip === null || tooltip === void 0 ? void 0 : tooltip.end) !== null && _a2 !== void 0 ? _a2 : pos;
      if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !isOverRange(this.view, pos, end, event.clientX, event.clientY, 6)) {
        this.view.dispatch({ effects: this.setHover.of(null) });
        this.pending = null;
      }
    }
  }
  mouseleave(e25) {
    clearTimeout(this.hoverTimeout);
    this.hoverTimeout = -1;
    if (this.active && !isInTooltip(e25.relatedTarget))
      this.view.dispatch({ effects: this.setHover.of(null) });
  }
  destroy() {
    clearTimeout(this.hoverTimeout);
    this.view.dom.removeEventListener("mouseleave", this.mouseleave);
    this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
function isInTooltip(elt) {
  for (let cur2 = elt; cur2; cur2 = cur2.parentNode)
    if (cur2.nodeType == 1 && cur2.classList.contains("cm-tooltip"))
      return true;
  return false;
}
function isOverRange(view, from, to2, x2, y2, margin) {
  let range3 = document.createRange();
  let fromDOM = view.domAtPos(from), toDOM = view.domAtPos(to2);
  range3.setEnd(toDOM.node, toDOM.offset);
  range3.setStart(fromDOM.node, fromDOM.offset);
  let rects = range3.getClientRects();
  range3.detach();
  for (let i2 = 0; i2 < rects.length; i2++) {
    let rect = rects[i2];
    let dist2 = Math.max(rect.top - y2, y2 - rect.bottom, rect.left - x2, x2 - rect.right);
    if (dist2 <= margin)
      return true;
  }
  return false;
}
function hoverTooltip(source, options = {}) {
  let setHover = StateEffect.define();
  let hoverState = StateField.define({
    create() {
      return null;
    },
    update(value2, tr2) {
      if (value2 && (options.hideOnChange && (tr2.docChanged || tr2.selection) || options.hideOn && options.hideOn(tr2, value2)))
        return null;
      if (value2 && tr2.docChanged) {
        let newPos = tr2.changes.mapPos(value2.pos, -1, MapMode.TrackDel);
        if (newPos == null)
          return null;
        let copy = Object.assign(Object.create(null), value2);
        copy.pos = newPos;
        if (value2.end != null)
          copy.end = tr2.changes.mapPos(value2.end);
        value2 = copy;
      }
      for (let effect of tr2.effects) {
        if (effect.is(setHover))
          value2 = effect.value;
        if (effect.is(closeHoverTooltipEffect))
          value2 = null;
      }
      return value2;
    },
    provide: (f2) => showHoverTooltip.from(f2)
  });
  return [
    hoverState,
    ViewPlugin.define((view) => new HoverPlugin(view, source, hoverState, setHover, options.hoverTime || 300)),
    showHoverTooltipHost
  ];
}
function getTooltip(view, tooltip) {
  let plugin2 = view.plugin(tooltipPlugin);
  if (!plugin2)
    return null;
  let found = plugin2.manager.tooltips.indexOf(tooltip);
  return found < 0 ? null : plugin2.manager.tooltipViews[found];
}
const closeHoverTooltipEffect = /* @__PURE__ */ StateEffect.define();
const panelConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    let topContainer, bottomContainer;
    for (let c2 of configs) {
      topContainer = topContainer || c2.topContainer;
      bottomContainer = bottomContainer || c2.bottomContainer;
    }
    return { topContainer, bottomContainer };
  }
});
function getPanel(view, panel) {
  let plugin2 = view.plugin(panelPlugin);
  let index2 = plugin2 ? plugin2.specs.indexOf(panel) : -1;
  return index2 > -1 ? plugin2.panels[index2] : null;
}
const panelPlugin = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.input = view.state.facet(showPanel);
    this.specs = this.input.filter((s2) => s2);
    this.panels = this.specs.map((spec2) => spec2(view));
    let conf = view.state.facet(panelConfig);
    this.top = new PanelGroup(view, true, conf.topContainer);
    this.bottom = new PanelGroup(view, false, conf.bottomContainer);
    this.top.sync(this.panels.filter((p2) => p2.top));
    this.bottom.sync(this.panels.filter((p2) => !p2.top));
    for (let p2 of this.panels) {
      p2.dom.classList.add("cm-panel");
      if (p2.mount)
        p2.mount();
    }
  }
  update(update) {
    let conf = update.state.facet(panelConfig);
    if (this.top.container != conf.topContainer) {
      this.top.sync([]);
      this.top = new PanelGroup(update.view, true, conf.topContainer);
    }
    if (this.bottom.container != conf.bottomContainer) {
      this.bottom.sync([]);
      this.bottom = new PanelGroup(update.view, false, conf.bottomContainer);
    }
    this.top.syncClasses();
    this.bottom.syncClasses();
    let input = update.state.facet(showPanel);
    if (input != this.input) {
      let specs = input.filter((x2) => x2);
      let panels = [], top2 = [], bottom = [], mount2 = [];
      for (let spec2 of specs) {
        let known = this.specs.indexOf(spec2), panel;
        if (known < 0) {
          panel = spec2(update.view);
          mount2.push(panel);
        } else {
          panel = this.panels[known];
          if (panel.update)
            panel.update(update);
        }
        panels.push(panel);
        (panel.top ? top2 : bottom).push(panel);
      }
      this.specs = specs;
      this.panels = panels;
      this.top.sync(top2);
      this.bottom.sync(bottom);
      for (let p2 of mount2) {
        p2.dom.classList.add("cm-panel");
        if (p2.mount)
          p2.mount();
      }
    } else {
      for (let p2 of this.panels)
        if (p2.update)
          p2.update(update);
    }
  }
  destroy() {
    this.top.sync([]);
    this.bottom.sync([]);
  }
}, {
  provide: (plugin2) => EditorView.scrollMargins.of((view) => {
    let value2 = view.plugin(plugin2);
    return value2 && { top: value2.top.scrollMargin(), bottom: value2.bottom.scrollMargin() };
  })
});
class PanelGroup {
  constructor(view, top2, container) {
    this.view = view;
    this.top = top2;
    this.container = container;
    this.dom = void 0;
    this.classes = "";
    this.panels = [];
    this.syncClasses();
  }
  sync(panels) {
    for (let p2 of this.panels)
      if (p2.destroy && panels.indexOf(p2) < 0)
        p2.destroy();
    this.panels = panels;
    this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      if (this.dom) {
        this.dom.remove();
        this.dom = void 0;
      }
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div");
      this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
      this.dom.style[this.top ? "top" : "bottom"] = "0";
      let parent = this.container || this.view.dom;
      parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
    }
    let curDOM = this.dom.firstChild;
    for (let panel of this.panels) {
      if (panel.dom.parentNode == this.dom) {
        while (curDOM != panel.dom)
          curDOM = rm$2(curDOM);
        curDOM = curDOM.nextSibling;
      } else {
        this.dom.insertBefore(panel.dom, curDOM);
      }
    }
    while (curDOM)
      curDOM = rm$2(curDOM);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!this.container || this.classes == this.view.themeClasses)
      return;
    for (let cls of this.classes.split(" "))
      if (cls)
        this.container.classList.remove(cls);
    for (let cls of (this.classes = this.view.themeClasses).split(" "))
      if (cls)
        this.container.classList.add(cls);
  }
}
function rm$2(node2) {
  let next = node2.nextSibling;
  node2.remove();
  return next;
}
const showPanel = /* @__PURE__ */ Facet.define({
  enables: panelPlugin
});
class GutterMarker extends RangeValue {
  compare(other) {
    return this == other || this.constructor == other.constructor && this.eq(other);
  }
  eq(other) {
    return false;
  }
  destroy(dom) {
  }
}
GutterMarker.prototype.elementClass = "";
GutterMarker.prototype.toDOM = void 0;
GutterMarker.prototype.mapMode = MapMode.TrackBefore;
GutterMarker.prototype.startSide = GutterMarker.prototype.endSide = -1;
GutterMarker.prototype.point = true;
const gutterLineClass = /* @__PURE__ */ Facet.define();
const defaults$1 = {
  class: "",
  renderEmptyElements: false,
  elementStyle: "",
  markers: () => RangeSet.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {}
};
const activeGutters = /* @__PURE__ */ Facet.define();
function gutter(config2) {
  return [gutters(), activeGutters.of(Object.assign(Object.assign({}, defaults$1), config2))];
}
const unfixGutters = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.some((x2) => x2)
});
function gutters(config2) {
  let result2 = [
    gutterView
  ];
  if (config2 && config2.fixed === false)
    result2.push(unfixGutters.of(true));
  return result2;
}
const gutterView = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.prevViewport = view.viewport;
    this.dom = document.createElement("div");
    this.dom.className = "cm-gutters";
    this.dom.setAttribute("aria-hidden", "true");
    this.dom.style.minHeight = this.view.contentHeight + "px";
    this.gutters = view.state.facet(activeGutters).map((conf) => new SingleGutterView(view, conf));
    for (let gutter2 of this.gutters)
      this.dom.appendChild(gutter2.dom);
    this.fixed = !view.state.facet(unfixGutters);
    if (this.fixed) {
      this.dom.style.position = "sticky";
    }
    this.syncGutters(false);
    view.scrollDOM.insertBefore(this.dom, view.contentDOM);
  }
  update(update) {
    if (this.updateGutters(update)) {
      let vpA = this.prevViewport, vpB = update.view.viewport;
      let vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
      this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
    }
    if (update.geometryChanged)
      this.dom.style.minHeight = this.view.contentHeight + "px";
    if (this.view.state.facet(unfixGutters) != !this.fixed) {
      this.fixed = !this.fixed;
      this.dom.style.position = this.fixed ? "sticky" : "";
    }
    this.prevViewport = update.view.viewport;
  }
  syncGutters(detach) {
    let after = this.dom.nextSibling;
    if (detach)
      this.dom.remove();
    let lineClasses = RangeSet.iter(this.view.state.facet(gutterLineClass), this.view.viewport.from);
    let classSet = [];
    let contexts = this.gutters.map((gutter2) => new UpdateContext(gutter2, this.view.viewport, -this.view.documentPadding.top));
    for (let line of this.view.viewportLineBlocks) {
      if (classSet.length)
        classSet = [];
      if (Array.isArray(line.type)) {
        let first = true;
        for (let b2 of line.type) {
          if (b2.type == BlockType.Text && first) {
            advanceCursor(lineClasses, classSet, b2.from);
            for (let cx2 of contexts)
              cx2.line(this.view, b2, classSet);
            first = false;
          } else if (b2.widget) {
            for (let cx2 of contexts)
              cx2.widget(this.view, b2);
          }
        }
      } else if (line.type == BlockType.Text) {
        advanceCursor(lineClasses, classSet, line.from);
        for (let cx2 of contexts)
          cx2.line(this.view, line, classSet);
      }
    }
    for (let cx2 of contexts)
      cx2.finish();
    if (detach)
      this.view.scrollDOM.insertBefore(this.dom, after);
  }
  updateGutters(update) {
    let prev = update.startState.facet(activeGutters), cur2 = update.state.facet(activeGutters);
    let change = update.docChanged || update.heightChanged || update.viewportChanged || !RangeSet.eq(update.startState.facet(gutterLineClass), update.state.facet(gutterLineClass), update.view.viewport.from, update.view.viewport.to);
    if (prev == cur2) {
      for (let gutter2 of this.gutters)
        if (gutter2.update(update))
          change = true;
    } else {
      change = true;
      let gutters2 = [];
      for (let conf of cur2) {
        let known = prev.indexOf(conf);
        if (known < 0) {
          gutters2.push(new SingleGutterView(this.view, conf));
        } else {
          this.gutters[known].update(update);
          gutters2.push(this.gutters[known]);
        }
      }
      for (let g2 of this.gutters) {
        g2.dom.remove();
        if (gutters2.indexOf(g2) < 0)
          g2.destroy();
      }
      for (let g2 of gutters2)
        this.dom.appendChild(g2.dom);
      this.gutters = gutters2;
    }
    return change;
  }
  destroy() {
    for (let view of this.gutters)
      view.destroy();
    this.dom.remove();
  }
}, {
  provide: (plugin2) => EditorView.scrollMargins.of((view) => {
    let value2 = view.plugin(plugin2);
    if (!value2 || value2.gutters.length == 0 || !value2.fixed)
      return null;
    return view.textDirection == Direction.LTR ? { left: value2.dom.offsetWidth } : { right: value2.dom.offsetWidth };
  })
});
function asArray(val) {
  return Array.isArray(val) ? val : [val];
}
function advanceCursor(cursor, collect, pos) {
  while (cursor.value && cursor.from <= pos) {
    if (cursor.from == pos)
      collect.push(cursor.value);
    cursor.next();
  }
}
class UpdateContext {
  constructor(gutter2, viewport, height) {
    this.gutter = gutter2;
    this.height = height;
    this.i = 0;
    this.cursor = RangeSet.iter(gutter2.markers, viewport.from);
  }
  addElement(view, block, markers) {
    let { gutter: gutter2 } = this, above = block.top - this.height;
    if (this.i == gutter2.elements.length) {
      let newElt = new GutterElement(view, block.height, above, markers);
      gutter2.elements.push(newElt);
      gutter2.dom.appendChild(newElt.dom);
    } else {
      gutter2.elements[this.i].update(view, block.height, above, markers);
    }
    this.height = block.bottom;
    this.i++;
  }
  line(view, line, extraMarkers) {
    let localMarkers = [];
    advanceCursor(this.cursor, localMarkers, line.from);
    if (extraMarkers.length)
      localMarkers = localMarkers.concat(extraMarkers);
    let forLine = this.gutter.config.lineMarker(view, line, localMarkers);
    if (forLine)
      localMarkers.unshift(forLine);
    let gutter2 = this.gutter;
    if (localMarkers.length == 0 && !gutter2.config.renderEmptyElements)
      return;
    this.addElement(view, line, localMarkers);
  }
  widget(view, block) {
    let marker = this.gutter.config.widgetMarker(view, block.widget, block);
    if (marker)
      this.addElement(view, block, [marker]);
  }
  finish() {
    let gutter2 = this.gutter;
    while (gutter2.elements.length > this.i) {
      let last = gutter2.elements.pop();
      gutter2.dom.removeChild(last.dom);
      last.destroy();
    }
  }
}
class SingleGutterView {
  constructor(view, config2) {
    this.view = view;
    this.config = config2;
    this.elements = [];
    this.spacer = null;
    this.dom = document.createElement("div");
    this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let prop in config2.domEventHandlers) {
      this.dom.addEventListener(prop, (event) => {
        let target = event.target, y2;
        if (target != this.dom && this.dom.contains(target)) {
          while (target.parentNode != this.dom)
            target = target.parentNode;
          let rect = target.getBoundingClientRect();
          y2 = (rect.top + rect.bottom) / 2;
        } else {
          y2 = event.clientY;
        }
        let line = view.lineBlockAtHeight(y2 - view.documentTop);
        if (config2.domEventHandlers[prop](view, line, event))
          event.preventDefault();
      });
    }
    this.markers = asArray(config2.markers(view));
    if (config2.initialSpacer) {
      this.spacer = new GutterElement(view, 0, 0, [config2.initialSpacer(view)]);
      this.dom.appendChild(this.spacer.dom);
      this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
    }
  }
  update(update) {
    let prevMarkers = this.markers;
    this.markers = asArray(this.config.markers(update.view));
    if (this.spacer && this.config.updateSpacer) {
      let updated = this.config.updateSpacer(this.spacer.markers[0], update);
      if (updated != this.spacer.markers[0])
        this.spacer.update(update.view, 0, 0, [updated]);
    }
    let vp2 = update.view.viewport;
    return !RangeSet.eq(this.markers, prevMarkers, vp2.from, vp2.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
  }
  destroy() {
    for (let elt of this.elements)
      elt.destroy();
  }
}
class GutterElement {
  constructor(view, height, above, markers) {
    this.height = -1;
    this.above = 0;
    this.markers = [];
    this.dom = document.createElement("div");
    this.dom.className = "cm-gutterElement";
    this.update(view, height, above, markers);
  }
  update(view, height, above, markers) {
    if (this.height != height)
      this.dom.style.height = (this.height = height) + "px";
    if (this.above != above)
      this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
    if (!sameMarkers(this.markers, markers))
      this.setMarkers(view, markers);
  }
  setMarkers(view, markers) {
    let cls = "cm-gutterElement", domPos = this.dom.firstChild;
    for (let iNew = 0, iOld = 0; ; ) {
      let skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
      if (marker) {
        let c2 = marker.elementClass;
        if (c2)
          cls += " " + c2;
        for (let i2 = iOld; i2 < this.markers.length; i2++)
          if (this.markers[i2].compare(marker)) {
            skipTo = i2;
            matched = true;
            break;
          }
      } else {
        skipTo = this.markers.length;
      }
      while (iOld < skipTo) {
        let next = this.markers[iOld++];
        if (next.toDOM) {
          next.destroy(domPos);
          let after = domPos.nextSibling;
          domPos.remove();
          domPos = after;
        }
      }
      if (!marker)
        break;
      if (marker.toDOM) {
        if (matched)
          domPos = domPos.nextSibling;
        else
          this.dom.insertBefore(marker.toDOM(view), domPos);
      }
      if (matched)
        iOld++;
    }
    this.dom.className = cls;
    this.markers = markers;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function sameMarkers(a2, b2) {
  if (a2.length != b2.length)
    return false;
  for (let i2 = 0; i2 < a2.length; i2++)
    if (!a2[i2].compare(b2[i2]))
      return false;
  return true;
}
const lineNumberMarkers = /* @__PURE__ */ Facet.define();
const lineNumberConfig = /* @__PURE__ */ Facet.define({
  combine(values2) {
    return combineConfig(values2, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(a2, b2) {
        let result2 = Object.assign({}, a2);
        for (let event in b2) {
          let exists2 = result2[event], add2 = b2[event];
          result2[event] = exists2 ? (view, line, event2) => exists2(view, line, event2) || add2(view, line, event2) : add2;
        }
        return result2;
      }
    });
  }
});
class NumberMarker extends GutterMarker {
  constructor(number4) {
    super();
    this.number = number4;
  }
  eq(other) {
    return this.number == other.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function formatNumber$1(view, number4) {
  return view.state.facet(lineNumberConfig).formatNumber(number4, view.state);
}
const lineNumberGutter = /* @__PURE__ */ activeGutters.compute([lineNumberConfig], (state) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: false,
  markers(view) {
    return view.state.facet(lineNumberMarkers);
  },
  lineMarker(view, line, others) {
    if (others.some((m2) => m2.toDOM))
      return null;
    return new NumberMarker(formatNumber$1(view, view.state.doc.lineAt(line.from).number));
  },
  widgetMarker: () => null,
  lineMarkerChange: (update) => update.startState.facet(lineNumberConfig) != update.state.facet(lineNumberConfig),
  initialSpacer(view) {
    return new NumberMarker(formatNumber$1(view, maxLineNumber(view.state.doc.lines)));
  },
  updateSpacer(spacer, update) {
    let max = formatNumber$1(update.view, maxLineNumber(update.view.state.doc.lines));
    return max == spacer.number ? spacer : new NumberMarker(max);
  },
  domEventHandlers: state.facet(lineNumberConfig).domEventHandlers
}));
function lineNumbers(config2 = {}) {
  return [
    lineNumberConfig.of(config2),
    gutters(),
    lineNumberGutter
  ];
}
function maxLineNumber(lines) {
  let last = 9;
  while (last < lines)
    last = last * 10 + 9;
  return last;
}
const activeLineGutterMarker = /* @__PURE__ */ new class extends GutterMarker {
  constructor() {
    super(...arguments);
    this.elementClass = "cm-activeLineGutter";
  }
}();
const activeLineGutterHighlighter = /* @__PURE__ */ gutterLineClass.compute(["selection"], (state) => {
  let marks = [], last = -1;
  for (let range3 of state.selection.ranges) {
    let linePos = state.doc.lineAt(range3.head).from;
    if (linePos > last) {
      last = linePos;
      marks.push(activeLineGutterMarker.range(linePos));
    }
  }
  return RangeSet.of(marks);
});
function highlightActiveLineGutter() {
  return activeLineGutterHighlighter;
}
var _a$1;
const languageDataProp = /* @__PURE__ */ new NodeProp();
function defineLanguageFacet(baseData) {
  return Facet.define({
    combine: baseData ? (values2) => values2.concat(baseData) : void 0
  });
}
const sublanguageProp = /* @__PURE__ */ new NodeProp();
class Language$1 {
  constructor(data, parser2, extraExtensions = [], name2 = "") {
    this.data = data;
    this.name = name2;
    if (!EditorState.prototype.hasOwnProperty("tree"))
      Object.defineProperty(EditorState.prototype, "tree", { get() {
        return syntaxTree(this);
      } });
    this.parser = parser2;
    this.extension = [
      language.of(this),
      EditorState.languageData.of((state, pos, side) => {
        let top2 = topNodeAt(state, pos, side), data2 = top2.type.prop(languageDataProp);
        if (!data2)
          return [];
        let base2 = state.facet(data2), sub = top2.type.prop(sublanguageProp);
        if (sub) {
          let innerNode = top2.resolve(pos - top2.from, side);
          for (let sublang of sub)
            if (sublang.test(innerNode, state)) {
              let data3 = state.facet(sublang.facet);
              return sublang.type == "replace" ? data3 : data3.concat(base2);
            }
        }
        return base2;
      })
    ].concat(extraExtensions);
  }
  isActiveAt(state, pos, side = -1) {
    return topNodeAt(state, pos, side).type.prop(languageDataProp) == this.data;
  }
  findRegions(state) {
    let lang = state.facet(language);
    if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data)
      return [{ from: 0, to: state.doc.length }];
    if (!lang || !lang.allowsNesting)
      return [];
    let result2 = [];
    let explore = (tree, from) => {
      if (tree.prop(languageDataProp) == this.data) {
        result2.push({ from, to: from + tree.length });
        return;
      }
      let mount2 = tree.prop(NodeProp.mounted);
      if (mount2) {
        if (mount2.tree.prop(languageDataProp) == this.data) {
          if (mount2.overlay)
            for (let r2 of mount2.overlay)
              result2.push({ from: r2.from + from, to: r2.to + from });
          else
            result2.push({ from, to: from + tree.length });
          return;
        } else if (mount2.overlay) {
          let size2 = result2.length;
          explore(mount2.tree, mount2.overlay[0].from + from);
          if (result2.length > size2)
            return;
        }
      }
      for (let i2 = 0; i2 < tree.children.length; i2++) {
        let ch2 = tree.children[i2];
        if (ch2 instanceof Tree)
          explore(ch2, tree.positions[i2] + from);
      }
    };
    explore(syntaxTree(state), 0);
    return result2;
  }
  get allowsNesting() {
    return true;
  }
}
Language$1.setState = /* @__PURE__ */ StateEffect.define();
function topNodeAt(state, pos, side) {
  let topLang = state.facet(language), tree = syntaxTree(state).topNode;
  if (!topLang || topLang.allowsNesting) {
    for (let node2 = tree; node2; node2 = node2.enter(pos, side, IterMode.ExcludeBuffers))
      if (node2.type.isTop)
        tree = node2;
  }
  return tree;
}
class LRLanguage extends Language$1 {
  constructor(data, parser2, name2) {
    super(data, parser2, [], name2);
    this.parser = parser2;
  }
  static define(spec2) {
    let data = defineLanguageFacet(spec2.languageData);
    return new LRLanguage(data, spec2.parser.configure({
      props: [languageDataProp.add((type4) => type4.isTop ? data : void 0)]
    }), spec2.name);
  }
  configure(options, name2) {
    return new LRLanguage(this.data, this.parser.configure(options), name2 || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function syntaxTree(state) {
  let field = state.field(Language$1.state, false);
  return field ? field.tree : Tree.empty;
}
class DocInput {
  constructor(doc2) {
    this.doc = doc2;
    this.cursorPos = 0;
    this.string = "";
    this.cursor = doc2.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(pos) {
    this.string = this.cursor.next(pos - this.cursorPos).value;
    this.cursorPos = pos + this.string.length;
    return this.cursorPos - this.string.length;
  }
  chunk(pos) {
    this.syncTo(pos);
    return this.string;
  }
  get lineChunks() {
    return true;
  }
  read(from, to2) {
    let stringStart = this.cursorPos - this.string.length;
    if (from < stringStart || to2 >= this.cursorPos)
      return this.doc.sliceString(from, to2);
    else
      return this.string.slice(from - stringStart, to2 - stringStart);
  }
}
let currentContext = null;
class ParseContext {
  constructor(parser2, state, fragments = [], tree, treeLen, viewport, skipped, scheduleOn) {
    this.parser = parser2;
    this.state = state;
    this.fragments = fragments;
    this.tree = tree;
    this.treeLen = treeLen;
    this.viewport = viewport;
    this.skipped = skipped;
    this.scheduleOn = scheduleOn;
    this.parse = null;
    this.tempSkipped = [];
  }
  static create(parser2, state, viewport) {
    return new ParseContext(parser2, state, [], Tree.empty, 0, viewport, [], null);
  }
  startParse() {
    return this.parser.startParse(new DocInput(this.state.doc), this.fragments);
  }
  work(until, upto) {
    if (upto != null && upto >= this.state.doc.length)
      upto = void 0;
    if (this.tree != Tree.empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
      this.takeTree();
      return true;
    }
    return this.withContext(() => {
      var _a2;
      if (typeof until == "number") {
        let endTime = Date.now() + until;
        until = () => Date.now() > endTime;
      }
      if (!this.parse)
        this.parse = this.startParse();
      if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length)
        this.parse.stopAt(upto);
      for (; ; ) {
        let done = this.parse.advance();
        if (done) {
          this.fragments = this.withoutTempSkipped(TreeFragment.addTree(done, this.fragments, this.parse.stoppedAt != null));
          this.treeLen = (_a2 = this.parse.stoppedAt) !== null && _a2 !== void 0 ? _a2 : this.state.doc.length;
          this.tree = done;
          this.parse = null;
          if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length))
            this.parse = this.startParse();
          else
            return true;
        }
        if (until())
          return false;
      }
    });
  }
  takeTree() {
    let pos, tree;
    if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
      if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos)
        this.parse.stopAt(pos);
      this.withContext(() => {
        while (!(tree = this.parse.advance())) {
        }
      });
      this.treeLen = pos;
      this.tree = tree;
      this.fragments = this.withoutTempSkipped(TreeFragment.addTree(this.tree, this.fragments, true));
      this.parse = null;
    }
  }
  withContext(f2) {
    let prev = currentContext;
    currentContext = this;
    try {
      return f2();
    } finally {
      currentContext = prev;
    }
  }
  withoutTempSkipped(fragments) {
    for (let r2; r2 = this.tempSkipped.pop(); )
      fragments = cutFragments(fragments, r2.from, r2.to);
    return fragments;
  }
  changes(changes, newState) {
    let { fragments, tree, treeLen, viewport, skipped } = this;
    this.takeTree();
    if (!changes.empty) {
      let ranges = [];
      changes.iterChangedRanges((fromA, toA, fromB, toB) => ranges.push({ fromA, toA, fromB, toB }));
      fragments = TreeFragment.applyChanges(fragments, ranges);
      tree = Tree.empty;
      treeLen = 0;
      viewport = { from: changes.mapPos(viewport.from, -1), to: changes.mapPos(viewport.to, 1) };
      if (this.skipped.length) {
        skipped = [];
        for (let r2 of this.skipped) {
          let from = changes.mapPos(r2.from, 1), to2 = changes.mapPos(r2.to, -1);
          if (from < to2)
            skipped.push({ from, to: to2 });
        }
      }
    }
    return new ParseContext(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
  }
  updateViewport(viewport) {
    if (this.viewport.from == viewport.from && this.viewport.to == viewport.to)
      return false;
    this.viewport = viewport;
    let startLen = this.skipped.length;
    for (let i2 = 0; i2 < this.skipped.length; i2++) {
      let { from, to: to2 } = this.skipped[i2];
      if (from < viewport.to && to2 > viewport.from) {
        this.fragments = cutFragments(this.fragments, from, to2);
        this.skipped.splice(i2--, 1);
      }
    }
    if (this.skipped.length >= startLen)
      return false;
    this.reset();
    return true;
  }
  reset() {
    if (this.parse) {
      this.takeTree();
      this.parse = null;
    }
  }
  skipUntilInView(from, to2) {
    this.skipped.push({ from, to: to2 });
  }
  static getSkippingParser(until) {
    return new class extends Parser {
      createParse(input, fragments, ranges) {
        let from = ranges[0].from, to2 = ranges[ranges.length - 1].to;
        let parser2 = {
          parsedPos: from,
          advance() {
            let cx2 = currentContext;
            if (cx2) {
              for (let r2 of ranges)
                cx2.tempSkipped.push(r2);
              if (until)
                cx2.scheduleOn = cx2.scheduleOn ? Promise.all([cx2.scheduleOn, until]) : until;
            }
            this.parsedPos = to2;
            return new Tree(NodeType.none, [], [], to2 - from);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
        return parser2;
      }
    }();
  }
  isDone(upto) {
    upto = Math.min(upto, this.state.doc.length);
    let frags = this.fragments;
    return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
  }
  static get() {
    return currentContext;
  }
}
function cutFragments(fragments, from, to2) {
  return TreeFragment.applyChanges(fragments, [{ fromA: from, toA: to2, fromB: from, toB: to2 }]);
}
class LanguageState {
  constructor(context) {
    this.context = context;
    this.tree = context.tree;
  }
  apply(tr2) {
    if (!tr2.docChanged && this.tree == this.context.tree)
      return this;
    let newCx = this.context.changes(tr2.changes, tr2.state);
    let upto = this.context.treeLen == tr2.startState.doc.length ? void 0 : Math.max(tr2.changes.mapPos(this.context.treeLen), newCx.viewport.to);
    if (!newCx.work(20, upto))
      newCx.takeTree();
    return new LanguageState(newCx);
  }
  static init(state) {
    let vpTo = Math.min(3e3, state.doc.length);
    let parseState = ParseContext.create(state.facet(language).parser, state, { from: 0, to: vpTo });
    if (!parseState.work(20, vpTo))
      parseState.takeTree();
    return new LanguageState(parseState);
  }
}
Language$1.state = /* @__PURE__ */ StateField.define({
  create: LanguageState.init,
  update(value2, tr2) {
    for (let e25 of tr2.effects)
      if (e25.is(Language$1.setState))
        return e25.value;
    if (tr2.startState.facet(language) != tr2.state.facet(language))
      return LanguageState.init(tr2.state);
    return value2.apply(tr2);
  }
});
let requestIdle = (callback) => {
  let timeout = setTimeout(() => callback(), 500);
  return () => clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined")
  requestIdle = (callback) => {
    let idle = -1, timeout = setTimeout(() => {
      idle = requestIdleCallback(callback, { timeout: 500 - 100 });
    }, 100);
    return () => idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
  };
const isInputPending = typeof navigator != "undefined" && ((_a$1 = navigator.scheduling) === null || _a$1 === void 0 ? void 0 : _a$1.isInputPending) ? () => navigator.scheduling.isInputPending() : null;
const parseWorker = /* @__PURE__ */ ViewPlugin.fromClass(class ParseWorker {
  constructor(view) {
    this.view = view;
    this.working = null;
    this.workScheduled = 0;
    this.chunkEnd = -1;
    this.chunkBudget = -1;
    this.work = this.work.bind(this);
    this.scheduleWork();
  }
  update(update) {
    let cx2 = this.view.state.field(Language$1.state).context;
    if (cx2.updateViewport(update.view.viewport) || this.view.viewport.to > cx2.treeLen)
      this.scheduleWork();
    if (update.docChanged) {
      if (this.view.hasFocus)
        this.chunkBudget += 50;
      this.scheduleWork();
    }
    this.checkAsyncSchedule(cx2);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state } = this.view, field = state.field(Language$1.state);
    if (field.tree != field.context.tree || !field.context.isDone(state.doc.length))
      this.working = requestIdle(this.work);
  }
  work(deadline) {
    this.working = null;
    let now2 = Date.now();
    if (this.chunkEnd < now2 && (this.chunkEnd < 0 || this.view.hasFocus)) {
      this.chunkEnd = now2 + 3e4;
      this.chunkBudget = 3e3;
    }
    if (this.chunkBudget <= 0)
      return;
    let { state, viewport: { to: vpTo } } = this.view, field = state.field(Language$1.state);
    if (field.tree == field.context.tree && field.context.isDone(vpTo + 1e5))
      return;
    let endTime = Date.now() + Math.min(this.chunkBudget, 100, deadline && !isInputPending ? Math.max(25, deadline.timeRemaining() - 5) : 1e9);
    let viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1e3;
    let done = field.context.work(() => {
      return isInputPending && isInputPending() || Date.now() > endTime;
    }, vpTo + (viewportFirst ? 0 : 1e5));
    this.chunkBudget -= Date.now() - now2;
    if (done || this.chunkBudget <= 0) {
      field.context.takeTree();
      this.view.dispatch({ effects: Language$1.setState.of(new LanguageState(field.context)) });
    }
    if (this.chunkBudget > 0 && !(done && !viewportFirst))
      this.scheduleWork();
    this.checkAsyncSchedule(field.context);
  }
  checkAsyncSchedule(cx2) {
    if (cx2.scheduleOn) {
      this.workScheduled++;
      cx2.scheduleOn.then(() => this.scheduleWork()).catch((err) => logException(this.view.state, err)).then(() => this.workScheduled--);
      cx2.scheduleOn = null;
    }
  }
  destroy() {
    if (this.working)
      this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
});
const language = /* @__PURE__ */ Facet.define({
  combine(languages) {
    return languages.length ? languages[0] : null;
  },
  enables: (language2) => [
    Language$1.state,
    parseWorker,
    EditorView.contentAttributes.compute([language2], (state) => {
      let lang = state.facet(language2);
      return lang && lang.name ? { "data-language": lang.name } : {};
    })
  ]
});
class LanguageSupport {
  constructor(language2, support = []) {
    this.language = language2;
    this.support = support;
    this.extension = [language2, support];
  }
}
const indentService = /* @__PURE__ */ Facet.define();
const indentUnit = /* @__PURE__ */ Facet.define({
  combine: (values2) => {
    if (!values2.length)
      return "  ";
    let unit = values2[0];
    if (!unit || /\S/.test(unit) || Array.from(unit).some((e25) => e25 != unit[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(values2[0]));
    return unit;
  }
});
function getIndentUnit(state) {
  let unit = state.facet(indentUnit);
  return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
function indentString(state, cols) {
  let result2 = "", ts2 = state.tabSize, ch2 = state.facet(indentUnit)[0];
  if (ch2 == "	") {
    while (cols >= ts2) {
      result2 += "	";
      cols -= ts2;
    }
    ch2 = " ";
  }
  for (let i2 = 0; i2 < cols; i2++)
    result2 += ch2;
  return result2;
}
function getIndentation(context, pos) {
  if (context instanceof EditorState)
    context = new IndentContext(context);
  for (let service of context.state.facet(indentService)) {
    let result2 = service(context, pos);
    if (result2 !== void 0)
      return result2;
  }
  let tree = syntaxTree(context.state);
  return tree ? syntaxIndentation(context, tree, pos) : null;
}
class IndentContext {
  constructor(state, options = {}) {
    this.state = state;
    this.options = options;
    this.unit = getIndentUnit(state);
  }
  lineAt(pos, bias = 1) {
    let line = this.state.doc.lineAt(pos);
    let { simulateBreak, simulateDoubleBreak } = this.options;
    if (simulateBreak != null && simulateBreak >= line.from && simulateBreak <= line.to) {
      if (simulateDoubleBreak && simulateBreak == pos)
        return { text: "", from: pos };
      else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos)
        return { text: line.text.slice(simulateBreak - line.from), from: simulateBreak };
      else
        return { text: line.text.slice(0, simulateBreak - line.from), from: line.from };
    }
    return line;
  }
  textAfterPos(pos, bias = 1) {
    if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak)
      return "";
    let { text, from } = this.lineAt(pos, bias);
    return text.slice(pos - from, Math.min(text.length, pos + 100 - from));
  }
  column(pos, bias = 1) {
    let { text, from } = this.lineAt(pos, bias);
    let result2 = this.countColumn(text, pos - from);
    let override2 = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
    if (override2 > -1)
      result2 += override2 - this.countColumn(text, text.search(/\S|$/));
    return result2;
  }
  countColumn(line, pos = line.length) {
    return countColumn(line, this.state.tabSize, pos);
  }
  lineIndent(pos, bias = 1) {
    let { text, from } = this.lineAt(pos, bias);
    let override2 = this.options.overrideIndentation;
    if (override2) {
      let overriden = override2(from);
      if (overriden > -1)
        return overriden;
    }
    return this.countColumn(text, text.search(/\S|$/));
  }
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const indentNodeProp = /* @__PURE__ */ new NodeProp();
function syntaxIndentation(cx2, ast, pos) {
  return indentFrom(ast.resolveInner(pos).enterUnfinishedNodesBefore(pos), pos, cx2);
}
function ignoreClosed(cx2) {
  return cx2.pos == cx2.options.simulateBreak && cx2.options.simulateDoubleBreak;
}
function indentStrategy(tree) {
  let strategy = tree.type.prop(indentNodeProp);
  if (strategy)
    return strategy;
  let first = tree.firstChild, close;
  if (first && (close = first.type.prop(NodeProp.closedBy))) {
    let last = tree.lastChild, closed = last && close.indexOf(last.name) > -1;
    return (cx2) => delimitedStrategy(cx2, true, 1, void 0, closed && !ignoreClosed(cx2) ? last.from : void 0);
  }
  return tree.parent == null ? topIndent : null;
}
function indentFrom(node2, pos, base2) {
  for (; node2; node2 = node2.parent) {
    let strategy = indentStrategy(node2);
    if (strategy)
      return strategy(TreeIndentContext.create(base2, pos, node2));
  }
  return null;
}
function topIndent() {
  return 0;
}
class TreeIndentContext extends IndentContext {
  constructor(base2, pos, node2) {
    super(base2.state, base2.options);
    this.base = base2;
    this.pos = pos;
    this.node = node2;
  }
  static create(base2, pos, node2) {
    return new TreeIndentContext(base2, pos, node2);
  }
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  baseIndentFor(node2) {
    let line = this.state.doc.lineAt(node2.from);
    for (; ; ) {
      let atBreak = node2.resolve(line.from);
      while (atBreak.parent && atBreak.parent.from == atBreak.from)
        atBreak = atBreak.parent;
      if (isParent(atBreak, node2))
        break;
      line = this.state.doc.lineAt(atBreak.from);
    }
    return this.lineIndent(line.from);
  }
  continue() {
    let parent = this.node.parent;
    return parent ? indentFrom(parent, this.pos, this.base) : 0;
  }
}
function isParent(parent, of2) {
  for (let cur2 = of2; cur2; cur2 = cur2.parent)
    if (parent == cur2)
      return true;
  return false;
}
function bracketedAligned(context) {
  let tree = context.node;
  let openToken = tree.childAfter(tree.from), last = tree.lastChild;
  if (!openToken)
    return null;
  let sim = context.options.simulateBreak;
  let openLine = context.state.doc.lineAt(openToken.from);
  let lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
  for (let pos = openToken.to; ; ) {
    let next = tree.childAfter(pos);
    if (!next || next == last)
      return null;
    if (!next.type.isSkipped)
      return next.from < lineEnd ? openToken : null;
    pos = next.to;
  }
}
function delimitedIndent({ closing: closing2, align = true, units: units2 = 1 }) {
  return (context) => delimitedStrategy(context, align, units2, closing2);
}
function delimitedStrategy(context, align, units2, closing2, closedAt) {
  let after = context.textAfter, space2 = after.match(/^\s*/)[0].length;
  let closed = closing2 && after.slice(space2, space2 + closing2.length) == closing2 || closedAt == context.pos + space2;
  let aligned = align ? bracketedAligned(context) : null;
  if (aligned)
    return closed ? context.column(aligned.from) : context.column(aligned.to);
  return context.baseIndent + (closed ? 0 : context.unit * units2);
}
const flatIndent = (context) => context.baseIndent;
function continuedIndent({ except, units: units2 = 1 } = {}) {
  return (context) => {
    let matchExcept = except && except.test(context.textAfter);
    return context.baseIndent + (matchExcept ? 0 : units2 * context.unit);
  };
}
const DontIndentBeyond = 200;
function indentOnInput() {
  return EditorState.transactionFilter.of((tr2) => {
    if (!tr2.docChanged || !tr2.isUserEvent("input.type") && !tr2.isUserEvent("input.complete"))
      return tr2;
    let rules2 = tr2.startState.languageDataAt("indentOnInput", tr2.startState.selection.main.head);
    if (!rules2.length)
      return tr2;
    let doc2 = tr2.newDoc, { head } = tr2.newSelection.main, line = doc2.lineAt(head);
    if (head > line.from + DontIndentBeyond)
      return tr2;
    let lineStart = doc2.sliceString(line.from, head);
    if (!rules2.some((r2) => r2.test(lineStart)))
      return tr2;
    let { state } = tr2, last = -1, changes = [];
    for (let { head: head2 } of state.selection.ranges) {
      let line2 = state.doc.lineAt(head2);
      if (line2.from == last)
        continue;
      last = line2.from;
      let indent = getIndentation(state, line2.from);
      if (indent == null)
        continue;
      let cur2 = /^\s*/.exec(line2.text)[0];
      let norm = indentString(state, indent);
      if (cur2 != norm)
        changes.push({ from: line2.from, to: line2.from + cur2.length, insert: norm });
    }
    return changes.length ? [tr2, { changes, sequential: true }] : tr2;
  });
}
const foldService = /* @__PURE__ */ Facet.define();
const foldNodeProp = /* @__PURE__ */ new NodeProp();
function foldInside(node2) {
  let first = node2.firstChild, last = node2.lastChild;
  return first && first.to < last.from ? { from: first.to, to: last.type.isError ? node2.to : last.from } : null;
}
function syntaxFolding(state, start, end) {
  let tree = syntaxTree(state);
  if (tree.length < end)
    return null;
  let inner = tree.resolveInner(end, 1);
  let found = null;
  for (let cur2 = inner; cur2; cur2 = cur2.parent) {
    if (cur2.to <= end || cur2.from > end)
      continue;
    if (found && cur2.from < start)
      break;
    let prop = cur2.type.prop(foldNodeProp);
    if (prop && (cur2.to < tree.length - 50 || tree.length == state.doc.length || !isUnfinished(cur2))) {
      let value2 = prop(cur2, state);
      if (value2 && value2.from <= end && value2.from >= start && value2.to > end)
        found = value2;
    }
  }
  return found;
}
function isUnfinished(node2) {
  let ch2 = node2.lastChild;
  return ch2 && ch2.to == node2.to && ch2.type.isError;
}
function foldable(state, lineStart, lineEnd) {
  for (let service of state.facet(foldService)) {
    let result2 = service(state, lineStart, lineEnd);
    if (result2)
      return result2;
  }
  return syntaxFolding(state, lineStart, lineEnd);
}
function mapRange(range3, mapping) {
  let from = mapping.mapPos(range3.from, 1), to2 = mapping.mapPos(range3.to, -1);
  return from >= to2 ? void 0 : { from, to: to2 };
}
const foldEffect = /* @__PURE__ */ StateEffect.define({ map: mapRange });
const unfoldEffect = /* @__PURE__ */ StateEffect.define({ map: mapRange });
function selectedLines(view) {
  let lines = [];
  for (let { head } of view.state.selection.ranges) {
    if (lines.some((l2) => l2.from <= head && l2.to >= head))
      continue;
    lines.push(view.lineBlockAt(head));
  }
  return lines;
}
const foldState = /* @__PURE__ */ StateField.define({
  create() {
    return Decoration.none;
  },
  update(folded, tr2) {
    folded = folded.map(tr2.changes);
    for (let e25 of tr2.effects) {
      if (e25.is(foldEffect) && !foldExists(folded, e25.value.from, e25.value.to))
        folded = folded.update({ add: [foldWidget.range(e25.value.from, e25.value.to)] });
      else if (e25.is(unfoldEffect))
        folded = folded.update({
          filter: (from, to2) => e25.value.from != from || e25.value.to != to2,
          filterFrom: e25.value.from,
          filterTo: e25.value.to
        });
    }
    if (tr2.selection) {
      let onSelection = false, { head } = tr2.selection.main;
      folded.between(head, head, (a2, b2) => {
        if (a2 < head && b2 > head)
          onSelection = true;
      });
      if (onSelection)
        folded = folded.update({
          filterFrom: head,
          filterTo: head,
          filter: (a2, b2) => b2 <= head || a2 >= head
        });
    }
    return folded;
  },
  provide: (f2) => EditorView.decorations.from(f2),
  toJSON(folded, state) {
    let ranges = [];
    folded.between(0, state.doc.length, (from, to2) => {
      ranges.push(from, to2);
    });
    return ranges;
  },
  fromJSON(value2) {
    if (!Array.isArray(value2) || value2.length % 2)
      throw new RangeError("Invalid JSON for fold state");
    let ranges = [];
    for (let i2 = 0; i2 < value2.length; ) {
      let from = value2[i2++], to2 = value2[i2++];
      if (typeof from != "number" || typeof to2 != "number")
        throw new RangeError("Invalid JSON for fold state");
      ranges.push(foldWidget.range(from, to2));
    }
    return Decoration.set(ranges, true);
  }
});
function findFold(state, from, to2) {
  var _a2;
  let found = null;
  (_a2 = state.field(foldState, false)) === null || _a2 === void 0 ? void 0 : _a2.between(from, to2, (from2, to3) => {
    if (!found || found.from > from2)
      found = { from: from2, to: to3 };
  });
  return found;
}
function foldExists(folded, from, to2) {
  let found = false;
  folded.between(from, from, (a2, b2) => {
    if (a2 == from && b2 == to2)
      found = true;
  });
  return found;
}
function maybeEnable(state, other) {
  return state.field(foldState, false) ? other : other.concat(StateEffect.appendConfig.of(codeFolding()));
}
const foldCode = (view) => {
  for (let line of selectedLines(view)) {
    let range3 = foldable(view.state, line.from, line.to);
    if (range3) {
      view.dispatch({ effects: maybeEnable(view.state, [foldEffect.of(range3), announceFold(view, range3)]) });
      return true;
    }
  }
  return false;
};
const unfoldCode = (view) => {
  if (!view.state.field(foldState, false))
    return false;
  let effects = [];
  for (let line of selectedLines(view)) {
    let folded = findFold(view.state, line.from, line.to);
    if (folded)
      effects.push(unfoldEffect.of(folded), announceFold(view, folded, false));
  }
  if (effects.length)
    view.dispatch({ effects });
  return effects.length > 0;
};
function announceFold(view, range3, fold = true) {
  let lineFrom = view.state.doc.lineAt(range3.from).number, lineTo = view.state.doc.lineAt(range3.to).number;
  return EditorView.announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
const foldAll = (view) => {
  let { state } = view, effects = [];
  for (let pos = 0; pos < state.doc.length; ) {
    let line = view.lineBlockAt(pos), range3 = foldable(state, line.from, line.to);
    if (range3)
      effects.push(foldEffect.of(range3));
    pos = (range3 ? view.lineBlockAt(range3.to) : line).to + 1;
  }
  if (effects.length)
    view.dispatch({ effects: maybeEnable(view.state, effects) });
  return !!effects.length;
};
const unfoldAll = (view) => {
  let field = view.state.field(foldState, false);
  if (!field || !field.size)
    return false;
  let effects = [];
  field.between(0, view.state.doc.length, (from, to2) => {
    effects.push(unfoldEffect.of({ from, to: to2 }));
  });
  view.dispatch({ effects });
  return true;
};
const foldKeymap = [
  { key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: foldCode },
  { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: unfoldCode },
  { key: "Ctrl-Alt-[", run: foldAll },
  { key: "Ctrl-Alt-]", run: unfoldAll }
];
const defaultConfig = {
  placeholderDOM: null,
  placeholderText: "\u2026"
};
const foldConfig = /* @__PURE__ */ Facet.define({
  combine(values2) {
    return combineConfig(values2, defaultConfig);
  }
});
function codeFolding(config2) {
  let result2 = [foldState, baseTheme$1$1];
  if (config2)
    result2.push(foldConfig.of(config2));
  return result2;
}
const foldWidget = /* @__PURE__ */ Decoration.replace({ widget: /* @__PURE__ */ new class extends WidgetType {
  toDOM(view) {
    let { state } = view, conf = state.facet(foldConfig);
    let onclick = (event) => {
      let line = view.lineBlockAt(view.posAtDOM(event.target));
      let folded = findFold(view.state, line.from, line.to);
      if (folded)
        view.dispatch({ effects: unfoldEffect.of(folded) });
      event.preventDefault();
    };
    if (conf.placeholderDOM)
      return conf.placeholderDOM(view, onclick);
    let element = document.createElement("span");
    element.textContent = conf.placeholderText;
    element.setAttribute("aria-label", state.phrase("folded code"));
    element.title = state.phrase("unfold");
    element.className = "cm-foldPlaceholder";
    element.onclick = onclick;
    return element;
  }
}() });
const foldGutterDefaults = {
  openText: "\u2304",
  closedText: "\u203A",
  markerDOM: null,
  domEventHandlers: {},
  foldingChanged: () => false
};
class FoldMarker extends GutterMarker {
  constructor(config2, open) {
    super();
    this.config = config2;
    this.open = open;
  }
  eq(other) {
    return this.config == other.config && this.open == other.open;
  }
  toDOM(view) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    let span = document.createElement("span");
    span.textContent = this.open ? this.config.openText : this.config.closedText;
    span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
    return span;
  }
}
function foldGutter(config2 = {}) {
  let fullConfig = Object.assign(Object.assign({}, foldGutterDefaults), config2);
  let canFold = new FoldMarker(fullConfig, true), canUnfold = new FoldMarker(fullConfig, false);
  let markers = ViewPlugin.fromClass(class {
    constructor(view) {
      this.from = view.viewport.from;
      this.markers = this.buildMarkers(view);
    }
    update(update) {
      if (update.docChanged || update.viewportChanged || update.startState.facet(language) != update.state.facet(language) || update.startState.field(foldState, false) != update.state.field(foldState, false) || syntaxTree(update.startState) != syntaxTree(update.state) || fullConfig.foldingChanged(update))
        this.markers = this.buildMarkers(update.view);
    }
    buildMarkers(view) {
      let builder = new RangeSetBuilder();
      for (let line of view.viewportLineBlocks) {
        let mark = findFold(view.state, line.from, line.to) ? canUnfold : foldable(view.state, line.from, line.to) ? canFold : null;
        if (mark)
          builder.add(line.from, line.from, mark);
      }
      return builder.finish();
    }
  });
  let { domEventHandlers } = fullConfig;
  return [
    markers,
    gutter({
      class: "cm-foldGutter",
      markers(view) {
        var _a2;
        return ((_a2 = view.plugin(markers)) === null || _a2 === void 0 ? void 0 : _a2.markers) || RangeSet.empty;
      },
      initialSpacer() {
        return new FoldMarker(fullConfig, false);
      },
      domEventHandlers: Object.assign(Object.assign({}, domEventHandlers), { click: (view, line, event) => {
        if (domEventHandlers.click && domEventHandlers.click(view, line, event))
          return true;
        let folded = findFold(view.state, line.from, line.to);
        if (folded) {
          view.dispatch({ effects: unfoldEffect.of(folded) });
          return true;
        }
        let range3 = foldable(view.state, line.from, line.to);
        if (range3) {
          view.dispatch({ effects: foldEffect.of(range3) });
          return true;
        }
        return false;
      } })
    }),
    codeFolding()
  ];
}
const baseTheme$1$1 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-foldPlaceholder": {
    backgroundColor: "#eee",
    border: "1px solid #ddd",
    color: "#888",
    borderRadius: ".2em",
    margin: "0 1px",
    padding: "0 1px",
    cursor: "pointer"
  },
  ".cm-foldGutter span": {
    padding: "0 1px",
    cursor: "pointer"
  }
});
class HighlightStyle {
  constructor(specs, options) {
    this.specs = specs;
    let modSpec;
    function def(spec2) {
      let cls = StyleModule.newName();
      (modSpec || (modSpec = Object.create(null)))["." + cls] = spec2;
      return cls;
    }
    const all = typeof options.all == "string" ? options.all : options.all ? def(options.all) : void 0;
    const scopeOpt = options.scope;
    this.scope = scopeOpt instanceof Language$1 ? (type4) => type4.prop(languageDataProp) == scopeOpt.data : scopeOpt ? (type4) => type4 == scopeOpt : void 0;
    this.style = tagHighlighter(specs.map((style2) => ({
      tag: style2.tag,
      class: style2.class || def(Object.assign({}, style2, { tag: null }))
    })), {
      all
    }).style;
    this.module = modSpec ? new StyleModule(modSpec) : null;
    this.themeType = options.themeType;
  }
  static define(specs, options) {
    return new HighlightStyle(specs, options || {});
  }
}
const highlighterFacet = /* @__PURE__ */ Facet.define();
const fallbackHighlighter = /* @__PURE__ */ Facet.define({
  combine(values2) {
    return values2.length ? [values2[0]] : null;
  }
});
function getHighlighters(state) {
  let main = state.facet(highlighterFacet);
  return main.length ? main : state.facet(fallbackHighlighter);
}
function syntaxHighlighting(highlighter, options) {
  let ext = [treeHighlighter], themeType;
  if (highlighter instanceof HighlightStyle) {
    if (highlighter.module)
      ext.push(EditorView.styleModule.of(highlighter.module));
    themeType = highlighter.themeType;
  }
  if (options === null || options === void 0 ? void 0 : options.fallback)
    ext.push(fallbackHighlighter.of(highlighter));
  else if (themeType)
    ext.push(highlighterFacet.computeN([EditorView.darkTheme], (state) => {
      return state.facet(EditorView.darkTheme) == (themeType == "dark") ? [highlighter] : [];
    }));
  else
    ext.push(highlighterFacet.of(highlighter));
  return ext;
}
class TreeHighlighter {
  constructor(view) {
    this.markCache = Object.create(null);
    this.tree = syntaxTree(view.state);
    this.decorations = this.buildDeco(view, getHighlighters(view.state));
  }
  update(update) {
    let tree = syntaxTree(update.state), highlighters = getHighlighters(update.state);
    let styleChange = highlighters != getHighlighters(update.startState);
    if (tree.length < update.view.viewport.to && !styleChange && tree.type == this.tree.type) {
      this.decorations = this.decorations.map(update.changes);
    } else if (tree != this.tree || update.viewportChanged || styleChange) {
      this.tree = tree;
      this.decorations = this.buildDeco(update.view, highlighters);
    }
  }
  buildDeco(view, highlighters) {
    if (!highlighters || !this.tree.length)
      return Decoration.none;
    let builder = new RangeSetBuilder();
    for (let { from, to: to2 } of view.visibleRanges) {
      highlightTree(this.tree, highlighters, (from2, to3, style2) => {
        builder.add(from2, to3, this.markCache[style2] || (this.markCache[style2] = Decoration.mark({ class: style2 })));
      }, from, to2);
    }
    return builder.finish();
  }
}
const treeHighlighter = /* @__PURE__ */ Prec.high(/* @__PURE__ */ ViewPlugin.fromClass(TreeHighlighter, {
  decorations: (v2) => v2.decorations
}));
const defaultHighlightStyle = /* @__PURE__ */ HighlightStyle.define([
  {
    tag: tags$1.meta,
    color: "#404740"
  },
  {
    tag: tags$1.link,
    textDecoration: "underline"
  },
  {
    tag: tags$1.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: tags$1.emphasis,
    fontStyle: "italic"
  },
  {
    tag: tags$1.strong,
    fontWeight: "bold"
  },
  {
    tag: tags$1.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: tags$1.keyword,
    color: "#708"
  },
  {
    tag: [tags$1.atom, tags$1.bool, tags$1.url, tags$1.contentSeparator, tags$1.labelName],
    color: "#219"
  },
  {
    tag: [tags$1.literal, tags$1.inserted],
    color: "#164"
  },
  {
    tag: [tags$1.string, tags$1.deleted],
    color: "#a11"
  },
  {
    tag: [tags$1.regexp, tags$1.escape, /* @__PURE__ */ tags$1.special(tags$1.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ tags$1.definition(tags$1.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ tags$1.local(tags$1.variableName),
    color: "#30a"
  },
  {
    tag: [tags$1.typeName, tags$1.namespace],
    color: "#085"
  },
  {
    tag: tags$1.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ tags$1.special(tags$1.variableName), tags$1.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ tags$1.definition(tags$1.propertyName),
    color: "#00c"
  },
  {
    tag: tags$1.comment,
    color: "#940"
  },
  {
    tag: tags$1.invalid,
    color: "#f00"
  }
]);
const baseTheme$4 = /* @__PURE__ */ EditorView.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
});
const DefaultScanDist = 1e4, DefaultBrackets = "()[]{}";
const bracketMatchingConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      afterCursor: true,
      brackets: DefaultBrackets,
      maxScanDistance: DefaultScanDist,
      renderMatch: defaultRenderMatch
    });
  }
});
const matchingMark = /* @__PURE__ */ Decoration.mark({ class: "cm-matchingBracket" }), nonmatchingMark = /* @__PURE__ */ Decoration.mark({ class: "cm-nonmatchingBracket" });
function defaultRenderMatch(match2) {
  let decorations2 = [];
  let mark = match2.matched ? matchingMark : nonmatchingMark;
  decorations2.push(mark.range(match2.start.from, match2.start.to));
  if (match2.end)
    decorations2.push(mark.range(match2.end.from, match2.end.to));
  return decorations2;
}
const bracketMatchingState = /* @__PURE__ */ StateField.define({
  create() {
    return Decoration.none;
  },
  update(deco, tr2) {
    if (!tr2.docChanged && !tr2.selection)
      return deco;
    let decorations2 = [];
    let config2 = tr2.state.facet(bracketMatchingConfig);
    for (let range3 of tr2.state.selection.ranges) {
      if (!range3.empty)
        continue;
      let match2 = matchBrackets(tr2.state, range3.head, -1, config2) || range3.head > 0 && matchBrackets(tr2.state, range3.head - 1, 1, config2) || config2.afterCursor && (matchBrackets(tr2.state, range3.head, 1, config2) || range3.head < tr2.state.doc.length && matchBrackets(tr2.state, range3.head + 1, -1, config2));
      if (match2)
        decorations2 = decorations2.concat(config2.renderMatch(match2, tr2.state));
    }
    return Decoration.set(decorations2, true);
  },
  provide: (f2) => EditorView.decorations.from(f2)
});
const bracketMatchingUnique = [
  bracketMatchingState,
  baseTheme$4
];
function bracketMatching(config2 = {}) {
  return [bracketMatchingConfig.of(config2), bracketMatchingUnique];
}
const bracketMatchingHandle = /* @__PURE__ */ new NodeProp();
function matchingNodes(node2, dir, brackets) {
  let byProp = node2.prop(dir < 0 ? NodeProp.openedBy : NodeProp.closedBy);
  if (byProp)
    return byProp;
  if (node2.name.length == 1) {
    let index2 = brackets.indexOf(node2.name);
    if (index2 > -1 && index2 % 2 == (dir < 0 ? 1 : 0))
      return [brackets[index2 + dir]];
  }
  return null;
}
function findHandle(node2) {
  let hasHandle = node2.type.prop(bracketMatchingHandle);
  return hasHandle ? hasHandle(node2.node) : node2;
}
function matchBrackets(state, pos, dir, config2 = {}) {
  let maxScanDistance = config2.maxScanDistance || DefaultScanDist, brackets = config2.brackets || DefaultBrackets;
  let tree = syntaxTree(state), node2 = tree.resolveInner(pos, dir);
  for (let cur2 = node2; cur2; cur2 = cur2.parent) {
    let matches = matchingNodes(cur2.type, dir, brackets);
    if (matches && cur2.from < cur2.to) {
      let handle = findHandle(cur2);
      if (handle && (dir > 0 ? pos >= handle.from && pos < handle.to : pos > handle.from && pos <= handle.to))
        return matchMarkedBrackets(state, pos, dir, cur2, handle, matches, brackets);
    }
  }
  return matchPlainBrackets(state, pos, dir, tree, node2.type, maxScanDistance, brackets);
}
function matchMarkedBrackets(_state, _pos, dir, token, handle, matching, brackets) {
  let parent = token.parent, firstToken = { from: handle.from, to: handle.to };
  let depth = 0, cursor = parent === null || parent === void 0 ? void 0 : parent.cursor();
  if (cursor && (dir < 0 ? cursor.childBefore(token.from) : cursor.childAfter(token.to)))
    do {
      if (dir < 0 ? cursor.to <= token.from : cursor.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor.type.name) > -1 && cursor.from < cursor.to) {
          let endHandle = findHandle(cursor);
          return { start: firstToken, end: endHandle ? { from: endHandle.from, to: endHandle.to } : void 0, matched: true };
        } else if (matchingNodes(cursor.type, dir, brackets)) {
          depth++;
        } else if (matchingNodes(cursor.type, -dir, brackets)) {
          if (depth == 0) {
            let endHandle = findHandle(cursor);
            return {
              start: firstToken,
              end: endHandle && endHandle.from < endHandle.to ? { from: endHandle.from, to: endHandle.to } : void 0,
              matched: false
            };
          }
          depth--;
        }
      }
    } while (dir < 0 ? cursor.prevSibling() : cursor.nextSibling());
  return { start: firstToken, matched: false };
}
function matchPlainBrackets(state, pos, dir, tree, tokenType2, maxScanDistance, brackets) {
  let startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
  let bracket2 = brackets.indexOf(startCh);
  if (bracket2 < 0 || bracket2 % 2 == 0 != dir > 0)
    return null;
  let startToken = { from: dir < 0 ? pos - 1 : pos, to: dir > 0 ? pos + 1 : pos };
  let iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
  for (let distance = 0; !iter.next().done && distance <= maxScanDistance; ) {
    let text = iter.value;
    if (dir < 0)
      distance += text.length;
    let basePos = pos + distance * dir;
    for (let pos2 = dir > 0 ? 0 : text.length - 1, end = dir > 0 ? text.length : -1; pos2 != end; pos2 += dir) {
      let found = brackets.indexOf(text[pos2]);
      if (found < 0 || tree.resolveInner(basePos + pos2, 1).type != tokenType2)
        continue;
      if (found % 2 == 0 == dir > 0) {
        depth++;
      } else if (depth == 1) {
        return { start: startToken, end: { from: basePos + pos2, to: basePos + pos2 + 1 }, matched: found >> 1 == bracket2 >> 1 };
      } else {
        depth--;
      }
    }
    if (dir > 0)
      distance += text.length;
  }
  return iter.done ? { start: startToken, matched: false } : null;
}
const noTokens = /* @__PURE__ */ Object.create(null);
const typeArray = [NodeType.none];
const warned = [];
const defaultTable = /* @__PURE__ */ Object.create(null);
for (let [legacyName, name2] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  defaultTable[legacyName] = /* @__PURE__ */ createTokenType(noTokens, name2);
function warnForPart(part, msg2) {
  if (warned.indexOf(part) > -1)
    return;
  warned.push(part);
  console.warn(msg2);
}
function createTokenType(extra, tagStr) {
  let tag = null;
  for (let part of tagStr.split(".")) {
    let value2 = extra[part] || tags$1[part];
    if (!value2) {
      warnForPart(part, `Unknown highlighting tag ${part}`);
    } else if (typeof value2 == "function") {
      if (!tag)
        warnForPart(part, `Modifier ${part} used at start of tag`);
      else
        tag = value2(tag);
    } else {
      if (tag)
        warnForPart(part, `Tag ${part} used as modifier`);
      else
        tag = value2;
    }
  }
  if (!tag)
    return 0;
  let name2 = tagStr.replace(/ /g, "_"), type4 = NodeType.define({
    id: typeArray.length,
    name: name2,
    props: [styleTags({ [name2]: tag })]
  });
  typeArray.push(type4);
  return type4.id;
}
let _properties = null;
function properties() {
  if (!_properties && typeof document == "object" && document.body) {
    let { style: style2 } = document.body, names = [], seen = new Set();
    for (let prop in style2)
      if (prop != "cssText" && prop != "cssFloat") {
        if (typeof style2[prop] == "string") {
          if (/[A-Z]/.test(prop))
            prop = prop.replace(/[A-Z]/g, (ch2) => "-" + ch2.toLowerCase());
          if (!seen.has(prop)) {
            names.push(prop);
            seen.add(prop);
          }
        }
      }
    _properties = names.sort().map((name2) => ({ type: "property", label: name2 }));
  }
  return _properties || [];
}
const pseudoClasses = /* @__PURE__ */ [
  "active",
  "after",
  "any-link",
  "autofill",
  "backdrop",
  "before",
  "checked",
  "cue",
  "default",
  "defined",
  "disabled",
  "empty",
  "enabled",
  "file-selector-button",
  "first",
  "first-child",
  "first-letter",
  "first-line",
  "first-of-type",
  "focus",
  "focus-visible",
  "focus-within",
  "fullscreen",
  "has",
  "host",
  "host-context",
  "hover",
  "in-range",
  "indeterminate",
  "invalid",
  "is",
  "lang",
  "last-child",
  "last-of-type",
  "left",
  "link",
  "marker",
  "modal",
  "not",
  "nth-child",
  "nth-last-child",
  "nth-last-of-type",
  "nth-of-type",
  "only-child",
  "only-of-type",
  "optional",
  "out-of-range",
  "part",
  "placeholder",
  "placeholder-shown",
  "read-only",
  "read-write",
  "required",
  "right",
  "root",
  "scope",
  "selection",
  "slotted",
  "target",
  "target-text",
  "valid",
  "visited",
  "where"
].map((name2) => ({ type: "class", label: name2 }));
const values = /* @__PURE__ */ [
  "above",
  "absolute",
  "activeborder",
  "additive",
  "activecaption",
  "after-white-space",
  "ahead",
  "alias",
  "all",
  "all-scroll",
  "alphabetic",
  "alternate",
  "always",
  "antialiased",
  "appworkspace",
  "asterisks",
  "attr",
  "auto",
  "auto-flow",
  "avoid",
  "avoid-column",
  "avoid-page",
  "avoid-region",
  "axis-pan",
  "background",
  "backwards",
  "baseline",
  "below",
  "bidi-override",
  "blink",
  "block",
  "block-axis",
  "bold",
  "bolder",
  "border",
  "border-box",
  "both",
  "bottom",
  "break",
  "break-all",
  "break-word",
  "bullets",
  "button",
  "button-bevel",
  "buttonface",
  "buttonhighlight",
  "buttonshadow",
  "buttontext",
  "calc",
  "capitalize",
  "caps-lock-indicator",
  "caption",
  "captiontext",
  "caret",
  "cell",
  "center",
  "checkbox",
  "circle",
  "cjk-decimal",
  "clear",
  "clip",
  "close-quote",
  "col-resize",
  "collapse",
  "color",
  "color-burn",
  "color-dodge",
  "column",
  "column-reverse",
  "compact",
  "condensed",
  "contain",
  "content",
  "contents",
  "content-box",
  "context-menu",
  "continuous",
  "copy",
  "counter",
  "counters",
  "cover",
  "crop",
  "cross",
  "crosshair",
  "currentcolor",
  "cursive",
  "cyclic",
  "darken",
  "dashed",
  "decimal",
  "decimal-leading-zero",
  "default",
  "default-button",
  "dense",
  "destination-atop",
  "destination-in",
  "destination-out",
  "destination-over",
  "difference",
  "disc",
  "discard",
  "disclosure-closed",
  "disclosure-open",
  "document",
  "dot-dash",
  "dot-dot-dash",
  "dotted",
  "double",
  "down",
  "e-resize",
  "ease",
  "ease-in",
  "ease-in-out",
  "ease-out",
  "element",
  "ellipse",
  "ellipsis",
  "embed",
  "end",
  "ethiopic-abegede-gez",
  "ethiopic-halehame-aa-er",
  "ethiopic-halehame-gez",
  "ew-resize",
  "exclusion",
  "expanded",
  "extends",
  "extra-condensed",
  "extra-expanded",
  "fantasy",
  "fast",
  "fill",
  "fill-box",
  "fixed",
  "flat",
  "flex",
  "flex-end",
  "flex-start",
  "footnotes",
  "forwards",
  "from",
  "geometricPrecision",
  "graytext",
  "grid",
  "groove",
  "hand",
  "hard-light",
  "help",
  "hidden",
  "hide",
  "higher",
  "highlight",
  "highlighttext",
  "horizontal",
  "hsl",
  "hsla",
  "hue",
  "icon",
  "ignore",
  "inactiveborder",
  "inactivecaption",
  "inactivecaptiontext",
  "infinite",
  "infobackground",
  "infotext",
  "inherit",
  "initial",
  "inline",
  "inline-axis",
  "inline-block",
  "inline-flex",
  "inline-grid",
  "inline-table",
  "inset",
  "inside",
  "intrinsic",
  "invert",
  "italic",
  "justify",
  "keep-all",
  "landscape",
  "large",
  "larger",
  "left",
  "level",
  "lighter",
  "lighten",
  "line-through",
  "linear",
  "linear-gradient",
  "lines",
  "list-item",
  "listbox",
  "listitem",
  "local",
  "logical",
  "loud",
  "lower",
  "lower-hexadecimal",
  "lower-latin",
  "lower-norwegian",
  "lowercase",
  "ltr",
  "luminosity",
  "manipulation",
  "match",
  "matrix",
  "matrix3d",
  "medium",
  "menu",
  "menutext",
  "message-box",
  "middle",
  "min-intrinsic",
  "mix",
  "monospace",
  "move",
  "multiple",
  "multiple_mask_images",
  "multiply",
  "n-resize",
  "narrower",
  "ne-resize",
  "nesw-resize",
  "no-close-quote",
  "no-drop",
  "no-open-quote",
  "no-repeat",
  "none",
  "normal",
  "not-allowed",
  "nowrap",
  "ns-resize",
  "numbers",
  "numeric",
  "nw-resize",
  "nwse-resize",
  "oblique",
  "opacity",
  "open-quote",
  "optimizeLegibility",
  "optimizeSpeed",
  "outset",
  "outside",
  "outside-shape",
  "overlay",
  "overline",
  "padding",
  "padding-box",
  "painted",
  "page",
  "paused",
  "perspective",
  "pinch-zoom",
  "plus-darker",
  "plus-lighter",
  "pointer",
  "polygon",
  "portrait",
  "pre",
  "pre-line",
  "pre-wrap",
  "preserve-3d",
  "progress",
  "push-button",
  "radial-gradient",
  "radio",
  "read-only",
  "read-write",
  "read-write-plaintext-only",
  "rectangle",
  "region",
  "relative",
  "repeat",
  "repeating-linear-gradient",
  "repeating-radial-gradient",
  "repeat-x",
  "repeat-y",
  "reset",
  "reverse",
  "rgb",
  "rgba",
  "ridge",
  "right",
  "rotate",
  "rotate3d",
  "rotateX",
  "rotateY",
  "rotateZ",
  "round",
  "row",
  "row-resize",
  "row-reverse",
  "rtl",
  "run-in",
  "running",
  "s-resize",
  "sans-serif",
  "saturation",
  "scale",
  "scale3d",
  "scaleX",
  "scaleY",
  "scaleZ",
  "screen",
  "scroll",
  "scrollbar",
  "scroll-position",
  "se-resize",
  "self-start",
  "self-end",
  "semi-condensed",
  "semi-expanded",
  "separate",
  "serif",
  "show",
  "single",
  "skew",
  "skewX",
  "skewY",
  "skip-white-space",
  "slide",
  "slider-horizontal",
  "slider-vertical",
  "sliderthumb-horizontal",
  "sliderthumb-vertical",
  "slow",
  "small",
  "small-caps",
  "small-caption",
  "smaller",
  "soft-light",
  "solid",
  "source-atop",
  "source-in",
  "source-out",
  "source-over",
  "space",
  "space-around",
  "space-between",
  "space-evenly",
  "spell-out",
  "square",
  "start",
  "static",
  "status-bar",
  "stretch",
  "stroke",
  "stroke-box",
  "sub",
  "subpixel-antialiased",
  "svg_masks",
  "super",
  "sw-resize",
  "symbolic",
  "symbols",
  "system-ui",
  "table",
  "table-caption",
  "table-cell",
  "table-column",
  "table-column-group",
  "table-footer-group",
  "table-header-group",
  "table-row",
  "table-row-group",
  "text",
  "text-bottom",
  "text-top",
  "textarea",
  "textfield",
  "thick",
  "thin",
  "threeddarkshadow",
  "threedface",
  "threedhighlight",
  "threedlightshadow",
  "threedshadow",
  "to",
  "top",
  "transform",
  "translate",
  "translate3d",
  "translateX",
  "translateY",
  "translateZ",
  "transparent",
  "ultra-condensed",
  "ultra-expanded",
  "underline",
  "unidirectional-pan",
  "unset",
  "up",
  "upper-latin",
  "uppercase",
  "url",
  "var",
  "vertical",
  "vertical-text",
  "view-box",
  "visible",
  "visibleFill",
  "visiblePainted",
  "visibleStroke",
  "visual",
  "w-resize",
  "wait",
  "wave",
  "wider",
  "window",
  "windowframe",
  "windowtext",
  "words",
  "wrap",
  "wrap-reverse",
  "x-large",
  "x-small",
  "xor",
  "xx-large",
  "xx-small"
].map((name2) => ({ type: "keyword", label: name2 })).concat(/* @__PURE__ */ [
  "aliceblue",
  "antiquewhite",
  "aqua",
  "aquamarine",
  "azure",
  "beige",
  "bisque",
  "black",
  "blanchedalmond",
  "blue",
  "blueviolet",
  "brown",
  "burlywood",
  "cadetblue",
  "chartreuse",
  "chocolate",
  "coral",
  "cornflowerblue",
  "cornsilk",
  "crimson",
  "cyan",
  "darkblue",
  "darkcyan",
  "darkgoldenrod",
  "darkgray",
  "darkgreen",
  "darkkhaki",
  "darkmagenta",
  "darkolivegreen",
  "darkorange",
  "darkorchid",
  "darkred",
  "darksalmon",
  "darkseagreen",
  "darkslateblue",
  "darkslategray",
  "darkturquoise",
  "darkviolet",
  "deeppink",
  "deepskyblue",
  "dimgray",
  "dodgerblue",
  "firebrick",
  "floralwhite",
  "forestgreen",
  "fuchsia",
  "gainsboro",
  "ghostwhite",
  "gold",
  "goldenrod",
  "gray",
  "grey",
  "green",
  "greenyellow",
  "honeydew",
  "hotpink",
  "indianred",
  "indigo",
  "ivory",
  "khaki",
  "lavender",
  "lavenderblush",
  "lawngreen",
  "lemonchiffon",
  "lightblue",
  "lightcoral",
  "lightcyan",
  "lightgoldenrodyellow",
  "lightgray",
  "lightgreen",
  "lightpink",
  "lightsalmon",
  "lightseagreen",
  "lightskyblue",
  "lightslategray",
  "lightsteelblue",
  "lightyellow",
  "lime",
  "limegreen",
  "linen",
  "magenta",
  "maroon",
  "mediumaquamarine",
  "mediumblue",
  "mediumorchid",
  "mediumpurple",
  "mediumseagreen",
  "mediumslateblue",
  "mediumspringgreen",
  "mediumturquoise",
  "mediumvioletred",
  "midnightblue",
  "mintcream",
  "mistyrose",
  "moccasin",
  "navajowhite",
  "navy",
  "oldlace",
  "olive",
  "olivedrab",
  "orange",
  "orangered",
  "orchid",
  "palegoldenrod",
  "palegreen",
  "paleturquoise",
  "palevioletred",
  "papayawhip",
  "peachpuff",
  "peru",
  "pink",
  "plum",
  "powderblue",
  "purple",
  "rebeccapurple",
  "red",
  "rosybrown",
  "royalblue",
  "saddlebrown",
  "salmon",
  "sandybrown",
  "seagreen",
  "seashell",
  "sienna",
  "silver",
  "skyblue",
  "slateblue",
  "slategray",
  "snow",
  "springgreen",
  "steelblue",
  "tan",
  "teal",
  "thistle",
  "tomato",
  "turquoise",
  "violet",
  "wheat",
  "white",
  "whitesmoke",
  "yellow",
  "yellowgreen"
].map((name2) => ({ type: "constant", label: name2 })));
const tags = /* @__PURE__ */ [
  "a",
  "abbr",
  "address",
  "article",
  "aside",
  "b",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "figcaption",
  "figure",
  "footer",
  "form",
  "header",
  "hgroup",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "meter",
  "nav",
  "ol",
  "output",
  "p",
  "pre",
  "ruby",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "tr",
  "u",
  "ul"
].map((name2) => ({ type: "type", label: name2 }));
const identifier$1 = /^(\w[\w-]*|-\w[\w-]*|)$/, variable = /^-(-[\w-]*)?$/;
function isVarArg(node2, doc2) {
  var _a2;
  if (node2.name == "(" || node2.type.isError)
    node2 = node2.parent || node2;
  if (node2.name != "ArgList")
    return false;
  let callee2 = (_a2 = node2.parent) === null || _a2 === void 0 ? void 0 : _a2.firstChild;
  if ((callee2 === null || callee2 === void 0 ? void 0 : callee2.name) != "Callee")
    return false;
  return doc2.sliceString(callee2.from, callee2.to) == "var";
}
const VariablesByNode = /* @__PURE__ */ new NodeWeakMap();
const declSelector = ["Declaration"];
function astTop(node2) {
  for (let cur2 = node2; ; ) {
    if (cur2.type.isTop)
      return cur2;
    if (!(cur2 = cur2.parent))
      return node2;
  }
}
function variableNames(doc2, node2, isVariable) {
  if (node2.to - node2.from > 4096) {
    let known = VariablesByNode.get(node2);
    if (known)
      return known;
    let result2 = [], seen = new Set(), cursor = node2.cursor(IterMode.IncludeAnonymous);
    if (cursor.firstChild())
      do {
        for (let option of variableNames(doc2, cursor.node, isVariable))
          if (!seen.has(option.label)) {
            seen.add(option.label);
            result2.push(option);
          }
      } while (cursor.nextSibling());
    VariablesByNode.set(node2, result2);
    return result2;
  } else {
    let result2 = [], seen = new Set();
    node2.cursor().iterate((node3) => {
      var _a2;
      if (isVariable(node3) && node3.matchContext(declSelector) && ((_a2 = node3.node.nextSibling) === null || _a2 === void 0 ? void 0 : _a2.name) == ":") {
        let name2 = doc2.sliceString(node3.from, node3.to);
        if (!seen.has(name2)) {
          seen.add(name2);
          result2.push({ label: name2, type: "variable" });
        }
      }
    });
    return result2;
  }
}
const defineCSSCompletionSource = (isVariable) => (context) => {
  let { state, pos } = context, node2 = syntaxTree(state).resolveInner(pos, -1);
  let isDash = node2.type.isError && node2.from == node2.to - 1 && state.doc.sliceString(node2.from, node2.to) == "-";
  if (node2.name == "PropertyName" || (isDash || node2.name == "TagName") && /^(Block|Styles)$/.test(node2.resolve(node2.to).name))
    return { from: node2.from, options: properties(), validFor: identifier$1 };
  if (node2.name == "ValueName")
    return { from: node2.from, options: values, validFor: identifier$1 };
  if (node2.name == "PseudoClassName")
    return { from: node2.from, options: pseudoClasses, validFor: identifier$1 };
  if (isVariable(node2) || (context.explicit || isDash) && isVarArg(node2, state.doc))
    return {
      from: isVariable(node2) || isDash ? node2.from : pos,
      options: variableNames(state.doc, astTop(node2), isVariable),
      validFor: variable
    };
  if (node2.name == "TagName") {
    for (let { parent } = node2; parent; parent = parent.parent)
      if (parent.name == "Block")
        return { from: node2.from, options: properties(), validFor: identifier$1 };
    return { from: node2.from, options: tags, validFor: identifier$1 };
  }
  if (!context.explicit)
    return null;
  let above = node2.resolve(pos), before = above.childBefore(pos);
  if (before && before.name == ":" && above.name == "PseudoClassSelector")
    return { from: pos, options: pseudoClasses, validFor: identifier$1 };
  if (before && before.name == ":" && above.name == "Declaration" || above.name == "ArgList")
    return { from: pos, options: values, validFor: identifier$1 };
  if (above.name == "Block" || above.name == "Styles")
    return { from: pos, options: properties(), validFor: identifier$1 };
  return null;
};
const cssCompletionSource = /* @__PURE__ */ defineCSSCompletionSource((n2) => n2.name == "VariableName");
const cssLanguage = /* @__PURE__ */ LRLanguage.define({
  name: "css",
  parser: /* @__PURE__ */ parser$2.configure({
    props: [
      /* @__PURE__ */ indentNodeProp.add({
        Declaration: /* @__PURE__ */ continuedIndent()
      }),
      /* @__PURE__ */ foldNodeProp.add({
        Block: foldInside
      })
    ]
  }),
  languageData: {
    commentTokens: { block: { open: "/*", close: "*/" } },
    indentOnInput: /^\s*\}$/,
    wordChars: "-"
  }
});
function css() {
  return new LanguageSupport(cssLanguage, cssLanguage.data.of({ autocomplete: cssCompletionSource }));
}
const noSemi = 303, incdec = 1, incdecPrefix = 2, insertSemi = 304, spaces = 306, newline = 307, LineComment = 3, BlockComment = 4;
const space = [
  9,
  10,
  11,
  12,
  13,
  32,
  133,
  160,
  5760,
  8192,
  8193,
  8194,
  8195,
  8196,
  8197,
  8198,
  8199,
  8200,
  8201,
  8202,
  8232,
  8233,
  8239,
  8287,
  12288
];
const braceR = 125, semicolon = 59, slash = 47, star = 42, plus = 43, minus = 45;
const trackNewline = new ContextTracker({
  start: false,
  shift(context, term) {
    return term == LineComment || term == BlockComment || term == spaces ? context : term == newline;
  },
  strict: false
});
const insertSemicolon = new ExternalTokenizer((input, stack2) => {
  let { next } = input;
  if (next == braceR || next == -1 || stack2.context)
    input.acceptToken(insertSemi);
}, { contextual: true, fallback: true });
const noSemicolon = new ExternalTokenizer((input, stack2) => {
  let { next } = input, after;
  if (space.indexOf(next) > -1)
    return;
  if (next == slash && ((after = input.peek(1)) == slash || after == star))
    return;
  if (next != braceR && next != semicolon && next != -1 && !stack2.context)
    input.acceptToken(noSemi);
}, { contextual: true });
const incdecToken = new ExternalTokenizer((input, stack2) => {
  let { next } = input;
  if (next == plus || next == minus) {
    input.advance();
    if (next == input.next) {
      input.advance();
      let mayPostfix = !stack2.context && stack2.canShift(incdec);
      input.acceptToken(mayPostfix ? incdec : incdecPrefix);
    }
  }
}, { contextual: true });
const jsHighlight = styleTags({
  "get set async static": tags$1.modifier,
  "for while do if else switch try catch finally return throw break continue default case": tags$1.controlKeyword,
  "in of await yield void typeof delete instanceof": tags$1.operatorKeyword,
  "let var const function class extends": tags$1.definitionKeyword,
  "import export from": tags$1.moduleKeyword,
  "with debugger as new": tags$1.keyword,
  TemplateString: tags$1.special(tags$1.string),
  super: tags$1.atom,
  BooleanLiteral: tags$1.bool,
  this: tags$1.self,
  null: tags$1.null,
  Star: tags$1.modifier,
  VariableName: tags$1.variableName,
  "CallExpression/VariableName TaggedTemplateExpression/VariableName": tags$1.function(tags$1.variableName),
  VariableDefinition: tags$1.definition(tags$1.variableName),
  Label: tags$1.labelName,
  PropertyName: tags$1.propertyName,
  PrivatePropertyName: tags$1.special(tags$1.propertyName),
  "CallExpression/MemberExpression/PropertyName": tags$1.function(tags$1.propertyName),
  "FunctionDeclaration/VariableDefinition": tags$1.function(tags$1.definition(tags$1.variableName)),
  "ClassDeclaration/VariableDefinition": tags$1.definition(tags$1.className),
  PropertyDefinition: tags$1.definition(tags$1.propertyName),
  PrivatePropertyDefinition: tags$1.definition(tags$1.special(tags$1.propertyName)),
  UpdateOp: tags$1.updateOperator,
  LineComment: tags$1.lineComment,
  BlockComment: tags$1.blockComment,
  Number: tags$1.number,
  String: tags$1.string,
  Escape: tags$1.escape,
  ArithOp: tags$1.arithmeticOperator,
  LogicOp: tags$1.logicOperator,
  BitOp: tags$1.bitwiseOperator,
  CompareOp: tags$1.compareOperator,
  RegExp: tags$1.regexp,
  Equals: tags$1.definitionOperator,
  Arrow: tags$1.function(tags$1.punctuation),
  ": Spread": tags$1.punctuation,
  "( )": tags$1.paren,
  "[ ]": tags$1.squareBracket,
  "{ }": tags$1.brace,
  "InterpolationStart InterpolationEnd": tags$1.special(tags$1.brace),
  ".": tags$1.derefOperator,
  ", ;": tags$1.separator,
  "@": tags$1.meta,
  TypeName: tags$1.typeName,
  TypeDefinition: tags$1.definition(tags$1.typeName),
  "type enum interface implements namespace module declare": tags$1.definitionKeyword,
  "abstract global Privacy readonly override": tags$1.modifier,
  "is keyof unique infer": tags$1.operatorKeyword,
  JSXAttributeValue: tags$1.attributeValue,
  JSXText: tags$1.content,
  "JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": tags$1.angleBracket,
  "JSXIdentifier JSXNameSpacedName": tags$1.tagName,
  "JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": tags$1.attributeName,
  "JSXBuiltin/JSXIdentifier": tags$1.standard(tags$1.tagName)
});
const spec_identifier = { __proto__: null, export: 14, as: 19, from: 27, default: 30, async: 35, function: 36, extends: 46, this: 50, true: 58, false: 58, null: 70, void: 74, typeof: 78, super: 96, new: 130, delete: 146, yield: 155, await: 159, class: 164, public: 221, private: 221, protected: 221, readonly: 223, instanceof: 242, satisfies: 245, in: 246, const: 248, import: 280, keyof: 335, unique: 339, infer: 345, is: 381, abstract: 401, implements: 403, type: 405, let: 408, var: 410, using: 413, interface: 419, enum: 423, namespace: 429, module: 431, declare: 435, global: 439, for: 458, of: 467, while: 470, with: 474, do: 478, if: 482, else: 484, switch: 488, case: 494, try: 500, catch: 504, finally: 508, return: 512, throw: 516, break: 520, continue: 524, debugger: 528 };
const spec_word = { __proto__: null, async: 117, get: 119, set: 121, declare: 181, public: 183, private: 183, protected: 183, static: 185, abstract: 187, override: 189, readonly: 195, accessor: 197, new: 385 };
const spec_LessThan = { __proto__: null, "<": 137 };
const parser$1 = LRParser.deserialize({
  version: 14,
  states: "$6tO`QUOOO%TQUOOO'WQWOOP(eOSOOO*sQ(CjO'#CfO*zOpO'#CgO+YO!bO'#CgO+hO07`O'#DZO-yQUO'#DaO.ZQUO'#DlO%TQUO'#DvO0_QUO'#EOOOQ(CY'#EW'#EWO0xQSO'#ETOOQO'#Ei'#EiOOQO'#Ic'#IcO1QQSO'#GkO1]QSO'#EhO1bQSO'#EhO3dQ(CjO'#JdO6TQ(CjO'#JeO6qQSO'#FWO6vQ#tO'#FoOOQ(CY'#F`'#F`O7RO&jO'#F`O7aQ,UO'#FvO8wQSO'#FuOOQ(CY'#Je'#JeOOQ(CW'#Jd'#JdO8|QSO'#GoOOQQ'#KP'#KPO9XQSO'#IPO9^Q(C[O'#IQOOQQ'#JQ'#JQOOQQ'#IU'#IUQ`QUOOO%TQUO'#DnO9fQUO'#DzO9mQUO'#D|O9SQSO'#GkO9tQ,UO'#ClO:SQSO'#EgO:_QSO'#ErO:dQ,UO'#F_O;RQSO'#GkOOQO'#KQ'#KQO;WQSO'#KQO;fQSO'#GsO;fQSO'#GtO;fQSO'#GvO9SQSO'#GyO<]QSO'#G|O=tQSO'#CbO>UQSO'#HYO>^QSO'#H`O>^QSO'#HbO`QUO'#HdO>^QSO'#HfO>^QSO'#HiO>cQSO'#HoO>hQ(C]O'#HuO%TQUO'#HwO>sQ(C]O'#HyO?OQ(C]O'#H{O9^Q(C[O'#H}O?ZQ(CjO'#CfO@]QWO'#DfQOQSOOO%TQUO'#D|O@sQSO'#EPO9tQ,UO'#EgOAOQSO'#EgOAZQ`O'#F_OOQQ'#Cd'#CdOOQ(CW'#Dk'#DkOOQ(CW'#Jh'#JhO%TQUO'#JhOOQO'#Jl'#JlOOQO'#I`'#I`OBZQWO'#E`OOQ(CW'#E_'#E_OCVQ(C`O'#E`OCaQWO'#ESOOQO'#Jk'#JkOCuQWO'#JlOESQWO'#ESOCaQWO'#E`PEaO?MpO'#C`POOO)CDo)CDoOOOO'#IV'#IVOElOpO,59ROOQ(CY,59R,59ROOOO'#IW'#IWOEzO!bO,59RO%TQUO'#D]OOOO'#IY'#IYOFYO07`O,59uOOQ(CY,59u,59uOFhQUO'#IZOF{QSO'#JfOH}QbO'#JfO+vQUO'#JfOIUQSO,59{OIlQSO'#EiOIyQSO'#JtOJUQSO'#JsOJUQSO'#JsOJ^QSO,5;VOJcQSO'#JrOOQ(CY,5:W,5:WOJjQUO,5:WOLkQ(CjO,5:bOM[QSO,5:jOMuQ(C[O'#JqOM|QSO'#JpO8|QSO'#JpONbQSO'#JpONjQSO,5;UONoQSO'#JpO!!wQbO'#JeOOQ(CY'#Cf'#CfO%TQUO'#EOO!#gQ`O,5:oOOQO'#Jm'#JmOOQO-E<a-E<aO9SQSO,5=VO!#}QSO,5=VO!$SQUO,5;SO!&VQ,UO'#EdO!'jQSO,5;SO!)SQ,UO'#DpO!)ZQUO'#DuO!)eQWO,5;]O!)mQWO,5;]O%TQUO,5;]OOQQ'#FO'#FOOOQQ'#FQ'#FQO%TQUO,5;^O%TQUO,5;^O%TQUO,5;^O%TQUO,5;^O%TQUO,5;^O%TQUO,5;^O%TQUO,5;^O%TQUO,5;^O%TQUO,5;^O%TQUO,5;^O%TQUO,5;^OOQQ'#FU'#FUO!){QUO,5;oOOQ(CY,5;t,5;tOOQ(CY,5;u,5;uO!,OQSO,5;uOOQ(CY,5;v,5;vO%TQUO'#IgO!,WQ(C[O,5<cO!&VQ,UO,5;^O!,uQ,UO,5;^O%TQUO,5;rO!,|Q#tO'#FeO!-yQ#tO'#JxO!-eQ#tO'#JxO!.QQ#tO'#JxOOQO'#Jx'#JxO!.fQ#tO,5;}OOOO,5<Z,5<ZO!.wQUO'#FqOOOO'#If'#IfO7RO&jO,5;zO!/OQ#tO'#FsOOQ(CY,5;z,5;zO!/oQ7[O'#CrOOQ(CY'#Cv'#CvO!0SQSO'#CvO!0XO07`O'#CzO!0uQ,UO,5<`O!0|QSO,5<bO!2cQMhO'#GQO!2pQSO'#GRO!2uQSO'#GRO!2zQMhO'#GVO!3yQWO'#GZO!4lQ7[O'#J_OOQ(CY'#J_'#J_O!4vQSO'#J^O!5UQSO'#J]O!5^QSO'#CqOOQ(CY'#Ct'#CtOOQ(CY'#DO'#DOOOQ(CY'#DQ'#DQO0{QSO'#DSO!'oQ,UO'#FxO!'oQ,UO'#FzO!5fQSO'#F|O!5kQSO'#F}O!2uQSO'#GTO!'oQ,UO'#GYO!5pQSO'#EjO!6_QSO,5<aOOQ(CW'#Co'#CoO!6gQSO'#EkO!7aQWO'#ElOOQ(CW'#Jr'#JrO!7hQ(C[O'#KRO9^Q(C[O,5=ZO`QUO,5>kOOQQ'#JY'#JYOOQQ,5>l,5>lOOQQ-E<S-E<SO!9jQ(CjO,5:YO!<WQ(CjO,5:fO%TQUO,5:fO!>qQ(CjO,5:hOOQO,5@l,5@lO!?bQ,UO,5=VO!?pQ(C[O'#JZO8wQSO'#JZO!@RQ(C[O,59WO!@^QWO,59WO!@fQ,UO,59WO9tQ,UO,59WO!@qQSO,5;SO!@yQSO'#HXO!A[QSO'#KUO%TQUO,5;wO!7[QWO,5;yO!AdQSO,5=rO!AiQSO,5=rO!AnQSO,5=rO9^Q(C[O,5=rO;fQSO,5=bOOQO'#Cr'#CrO!A|QWO,5=_O!BUQ,UO,5=`O!BaQSO,5=bO!BfQ`O,5=eO!BnQSO'#KQO>cQSO'#HOO9SQSO'#HQO!BsQSO'#HQO9tQ,UO'#HSO!BxQSO'#HSOOQQ,5=h,5=hO!B}QSO'#HTO!CVQSO'#ClO!C[QSO,58|O!CfQSO,58|O!EkQUO,58|OOQQ,58|,58|O!E{Q(C[O,58|O%TQUO,58|O!HWQUO'#H[OOQQ'#H]'#H]OOQQ'#H^'#H^O`QUO,5=tO!HnQSO,5=tO`QUO,5=zO`QUO,5=|O!HsQSO,5>OO`QUO,5>QO!HxQSO,5>TO!H}QUO,5>ZOOQQ,5>a,5>aO%TQUO,5>aO9^Q(C[O,5>cOOQQ,5>e,5>eO!MXQSO,5>eOOQQ,5>g,5>gO!MXQSO,5>gOOQQ,5>i,5>iO!M^QWO'#DXO%TQUO'#JhO!M{QWO'#JhO!NjQWO'#DgO!N{QWO'#DgO##^QUO'#DgO##eQSO'#JgO##mQSO,5:QO##rQSO'#EmO#$QQSO'#JuO#$YQSO,5;WO#$_QWO'#DgO#$lQWO'#EROOQ(CY,5:k,5:kO%TQUO,5:kO#$sQSO,5:kO>cQSO,5;RO!@^QWO,5;RO!@fQ,UO,5;RO9tQ,UO,5;RO#${QSO,5@SO#%QQ!LQO,5:oOOQO-E<^-E<^O#&WQ(C`O,5:zOCaQWO,5:nO#&bQWO,5:nOCaQWO,5:zO!@RQ(C[O,5:nOOQ(CW'#Ec'#EcOOQO,5:z,5:zO%TQUO,5:zO#&oQ(C[O,5:zO#&zQ(C[O,5:zO!@^QWO,5:nOOQO,5;Q,5;QO#'YQ(C[O,5:zPOOO'#IT'#ITP#'nO?MpO,58zPOOO,58z,58zOOOO-E<T-E<TOOQ(CY1G.m1G.mOOOO-E<U-E<UO#'yQ`O,59wOOOO-E<W-E<WOOQ(CY1G/a1G/aO#(OQbO,5>uO+vQUO,5>uOOQO,5>{,5>{O#(YQUO'#IZOOQO-E<X-E<XO#(gQSO,5@QO#(oQbO,5@QO#(vQSO,5@_OOQ(CY1G/g1G/gO%TQUO,5@`O#)OQSO'#IaOOQO-E<_-E<_O#(vQSO,5@_OOQ(CW1G0q1G0qOOQ(CY1G/r1G/rOOQ(CY1G0U1G0UO%TQUO,5@]O#)dQ(C[O,5@]O#)uQ(C[O,5@]O#)|QSO,5@[O8|QSO,5@[O#*UQSO,5@[O#*dQSO'#IdO#)|QSO,5@[OOQ(CW1G0p1G0pO!)eQWO,5:qO!)pQWO,5:qOOQO,5:s,5:sO#+UQSO,5:sO#+^Q,UO1G2qO9SQSO1G2qOOQ(CY1G0n1G0nO#+lQ(CjO1G0nO#,qQ(ChO,5;OOOQ(CY'#GP'#GPO#-_Q(CjO'#J_O!$SQUO1G0nO#/gQ,UO'#JiO#/qQSO,5:[O#/vQbO'#JjO%TQUO'#JjO#0QQSO,5:aOOQ(CY'#DX'#DXOOQ(CY1G0w1G0wO%TQUO1G0wOOQ(CY1G1a1G1aO#0VQSO1G0wO#2nQ(CjO1G0xO#2uQ(CjO1G0xO#5`Q(CjO1G0xO#5gQ(CjO1G0xO#7qQ(CjO1G0xO#8XQ(CjO1G0xO#;RQ(CjO1G0xO#;YQ(CjO1G0xO#=sQ(CjO1G0xO#=zQ(CjO1G0xO#?rQ(CjO1G0xO#BrQ$IUO'#CfO#DpQ$IUO1G1ZO#DwQ$IUO'#JeO!,RQSO1G1aO#EXQ(CjO,5?ROOQ(CW-E<e-E<eO#E{Q(CjO1G0xOOQ(CY1G0x1G0xO#HWQ(CjO1G1^O#HzQ#tO,5<RO#ISQ#tO,5<SO#I[Q#tO'#FjO#IsQSO'#FiOOQO'#Jy'#JyOOQO'#Ie'#IeO#IxQ#tO1G1iOOQ(CY1G1i1G1iOOOO1G1t1G1tO#JZQ$IUO'#JdO#JeQSO,5<]O!){QUO,5<]OOOO-E<d-E<dOOQ(CY1G1f1G1fO#JjQWO'#JxOOQ(CY,5<_,5<_O#JrQWO,5<_OOQ(CY,59b,59bO!&VQ,UO'#C|OOOO'#IX'#IXO#JwO07`O,59fOOQ(CY,59f,59fO%TQUO1G1zO!5kQSO'#IiO#KSQ,UO,5<sOOQ(CY,5<p,5<pOOQO'#Gf'#GfO!'oQ,UO,5=POOQO'#Gh'#GhO!'oQ,UO,5=RO!&VQ,UO,5=TOOQO1G1|1G1|O#KZQ`O'#CoO#KnQ`O,5<lO#KuQSO'#J|O9SQSO'#J|O#LTQSO,5<nO!'oQ,UO,5<mO#LYQSO'#GSO#LeQSO,5<mO#LjQ`O'#GPO#LwQ`O'#J}O#MRQSO'#J}O!&VQ,UO'#J}O#MWQSO,5<qO#M]QWO'#G[O!3tQWO'#G[O#MnQSO'#G^O#MsQSO'#G`O!2uQSO'#GcO#MxQ(C[O'#IkO#NTQWO,5<uOOQ(CY,5<u,5<uO#N[QWO'#G[O#NjQWO'#G]O#NrQWO'#G]OOQ(CY,5=U,5=UO!'oQ,UO,5?xO!'oQ,UO,5?xO#NwQSO'#IlO$ SQSO,5?wO$ [QSO,59]O$ {Q,UO,59nOOQ(CY,59n,59nO$!nQ,UO,5<dO$#aQ,UO,5<fO@TQSO,5<hOOQ(CY,5<i,5<iO$#kQSO,5<oO$#pQ,UO,5<tO$$QQSO'#JpO!$SQUO1G1{O$$VQSO1G1{O8|QSO'#JsO8|QSO'#EmO%TQUO'#EmO8|QSO'#InO$$[Q(C[O,5@mOOQQ1G2u1G2uOOQQ1G4V1G4VOOQ(CY1G/t1G/tO!,OQSO1G/tO$&aQ(CjO1G0QOOQQ1G2q1G2qO!&VQ,UO1G2qO%TQUO1G2qO$'QQSO1G2qO$']Q,UO'#EdOOQ(CW,5?u,5?uO$'gQ(C[O,5?uOOQQ1G.r1G.rO!@RQ(C[O1G.rO!@^QWO1G.rO!@fQ,UO1G.rO$'xQSO1G0nO$'}QSO'#CfO$(YQSO'#KVO$(bQSO,5=sO$(gQSO'#KVO$(lQSO'#KVO$(wQSO'#ItO$)VQSO,5@pO$)_QbO1G1cOOQ(CY1G1e1G1eO9SQSO1G3^O@TQSO1G3^O$)fQSO1G3^O$)kQSO1G3^OOQQ1G3^1G3^O!BaQSO1G2|O!&VQ,UO1G2yO$)pQSO1G2yOOQQ1G2z1G2zO!&VQ,UO1G2zO$)uQSO1G2zO$)}QWO'#GxOOQQ1G2|1G2|O!3tQWO'#IpO!BfQ`O1G3POOQQ1G3P1G3POOQQ,5=j,5=jO$*VQ,UO,5=lO9SQSO,5=lO#MsQSO,5=nO8wQSO,5=nO!@^QWO,5=nO!@fQ,UO,5=nO9tQ,UO,5=nO$*eQSO'#KTO$*pQSO,5=oOOQQ1G.h1G.hO$*uQ(C[O1G.hO@TQSO1G.hO$+QQSO1G.hO9^Q(C[O1G.hO$-VQbO,5@rO$-gQSO,5@rO8|QSO,5@rO$-rQUO,5=vO$-yQSO,5=vOOQQ1G3`1G3`O`QUO1G3`OOQQ1G3f1G3fOOQQ1G3h1G3hO>^QSO1G3jO$.OQUO1G3lO$2SQUO'#HkOOQQ1G3o1G3oO$2aQSO'#HqO>cQSO'#HsOOQQ1G3u1G3uO$2iQUO1G3uO9^Q(C[O1G3{OOQQ1G3}1G3}OOQ(CW'#GW'#GWO9^Q(C[O1G4PO9^Q(C[O1G4RO$6pQSO,5@SO!){QUO,5;XO8|QSO,5;XO>cQSO,5:RO!){QUO,5:RO!@^QWO,5:RO$6uQ$IUO,5:ROOQO,5;X,5;XO$7PQWO'#I[O$7gQSO,5@ROOQ(CY1G/l1G/lO$7oQWO'#IbO$7yQSO,5@aOOQ(CW1G0r1G0rO!N{QWO,5:ROOQO'#I_'#I_O$8RQWO,5:mOOQ(CY,5:m,5:mO#$vQSO1G0VOOQ(CY1G0V1G0VO%TQUO1G0VOOQ(CY1G0m1G0mO>cQSO1G0mO!@^QWO1G0mO!@fQ,UO1G0mOOQ(CW1G5n1G5nO!@RQ(C[O1G0YOOQO1G0f1G0fO%TQUO1G0fO$8YQ(C[O1G0fO$8eQ(C[O1G0fO!@^QWO1G0YOCaQWO1G0YO$8sQ(C[O1G0fOOQO1G0Y1G0YO$9XQ(CjO1G0fPOOO-E<R-E<RPOOO1G.f1G.fOOOO1G/c1G/cO$9cQ`O,5<cO$9kQbO1G4aOOQO1G4g1G4gO%TQUO,5>uO$9uQSO1G5lO$9}QSO1G5yO$:VQbO1G5zO8|QSO,5>{O$:aQ(CjO1G5wO%TQUO1G5wO$:qQ(C[O1G5wO$;SQSO1G5vO$;SQSO1G5vO8|QSO1G5vO$;[QSO,5?OO8|QSO,5?OOOQO,5?O,5?OO$;pQSO,5?OO$$QQSO,5?OOOQO-E<b-E<bOOQO1G0]1G0]OOQO1G0_1G0_O!,RQSO1G0_OOQQ7+(]7+(]O!&VQ,UO7+(]O%TQUO7+(]O$<OQSO7+(]O$<ZQ,UO7+(]O$<iQ(CjO,59nO$>qQ(CjO,5<dO$@|Q(CjO,5<fO$CXQ(CjO,5<tOOQ(CY7+&Y7+&YO$EjQ(CjO7+&YO$F^Q,UO'#I]O$FhQSO,5@TOOQ(CY1G/v1G/vO$FpQUO'#I^O$F}QSO,5@UO$GVQbO,5@UOOQ(CY1G/{1G/{O$GaQSO7+&cOOQ(CY7+&c7+&cO$GfQ$IUO,5:bO%TQUO7+&uO$GpQ$IUO,5:YO$G}Q$IUO,5:fO$HXQ$IUO,5:hOOQ(CY7+&{7+&{OOQO1G1m1G1mOOQO1G1n1G1nO$HcQ#tO,5<UO!){QUO,5<TOOQO-E<c-E<cOOQ(CY7+'T7+'TOOOO7+'`7+'`OOOO1G1w1G1wO$HnQSO1G1wOOQ(CY1G1y1G1yO$HsQ`O,59hOOOO-E<V-E<VOOQ(CY1G/Q1G/QO$HzQ(CjO7+'fOOQ(CY,5?T,5?TO$InQ`O,5?TOOQ(CY1G2_1G2_P!&VQ,UO'#IiPOQ(CY-E<g-E<gO$J^Q,UO1G2kO$KPQ,UO1G2mO$KZQ`O1G2oOOQ(CY1G2W1G2WO$KbQSO'#IhO$KpQSO,5@hO$KpQSO,5@hO$KxQSO,5@hO$LTQSO,5@hOOQO1G2Y1G2YO$LcQ,UO1G2XO!'oQ,UO1G2XO$LsQMhO'#IjO$MTQSO,5@iO!&VQ,UO,5@iO$M]Q`O,5@iOOQ(CY1G2]1G2]OOQ(CW,5<v,5<vOOQ(CW,5<w,5<wO$$QQSO,5<wOCQQSO,5<wO!@^QWO,5<vOOQO'#G_'#G_O$MgQSO,5<xOOQ(CW,5<z,5<zO$$QQSO,5<}OOQO,5?V,5?VOOQO-E<i-E<iOOQ(CY1G2a1G2aO!3tQWO,5<vO$MoQSO,5<wO#MnQSO,5<xO!3tQWO,5<wO$MzQ,UO1G5dO$NUQ,UO1G5dOOQO,5?W,5?WOOQO-E<j-E<jOOQO1G.w1G.wO!7[QWO,59pO%TQUO,59pO$NcQSO1G2SO!'oQ,UO1G2ZO$NhQ(CjO7+'gOOQ(CY7+'g7+'gO!$SQUO7+'gO% [QSO,5;XOOQ(CW,5?Y,5?YOOQ(CW-E<l-E<lOOQ(CY7+%`7+%`O% aQ`O'#KOO#$vQSO7+(]O% kQbO7+(]O$<RQSO7+(]O% rQ(ChO'#CfO%!VQ(ChO,5<{O%!wQSO,5<{OOQ(CW1G5a1G5aOOQQ7+$^7+$^O!@RQ(C[O7+$^O!@^QWO7+$^O!$SQUO7+&YO%!|QSO'#IsO%#bQSO,5@qOOQO1G3_1G3_O9SQSO,5@qO%#bQSO,5@qO%#jQSO,5@qOOQO,5?`,5?`OOQO-E<r-E<rOOQ(CY7+&}7+&}O%#oQSO7+(xO9^Q(C[O7+(xO9SQSO7+(xO@TQSO7+(xOOQQ7+(h7+(hO%#tQ(ChO7+(eO!&VQ,UO7+(eO%$OQ`O7+(fOOQQ7+(f7+(fO!&VQ,UO7+(fO%$VQSO'#KSO%$bQSO,5=dOOQO,5?[,5?[OOQO-E<n-E<nOOQQ7+(k7+(kO%%qQWO'#HROOQQ1G3W1G3WO!&VQ,UO1G3WO%TQUO1G3WO%%xQSO1G3WO%&TQ,UO1G3WO9^Q(C[O1G3YO#MsQSO1G3YO8wQSO1G3YO!@^QWO1G3YO!@fQ,UO1G3YO%&cQSO'#IrO%&nQSO,5@oO%&vQWO,5@oOOQ(CW1G3Z1G3ZOOQQ7+$S7+$SO@TQSO7+$SO9^Q(C[O7+$SO%'RQSO7+$SO%TQUO1G6^O%TQUO1G6_O%'WQ(C[O1G6^O%'bQUO1G3bO%'iQSO1G3bO%'nQUO1G3bOOQQ7+(z7+(zO9^Q(C[O7+)UO`QUO7+)WOOQQ'#KY'#KYOOQQ'#Iu'#IuO%'uQUO,5>VOOQQ,5>V,5>VO%TQUO'#HlO%(SQSO'#HnOOQQ,5>],5>]O8|QSO,5>]OOQQ,5>_,5>_OOQQ7+)a7+)aOOQQ7+)g7+)gOOQQ7+)k7+)kOOQQ7+)m7+)mO%(XQWO1G5nO%(mQ$IUO1G0sO%(wQSO1G0sOOQO1G/m1G/mO%)SQ$IUO1G/mO>cQSO1G/mO!){QUO'#DgOOQO,5>v,5>vOOQO-E<Y-E<YOOQO,5>|,5>|OOQO-E<`-E<`O!@^QWO1G/mOOQO-E<]-E<]OOQ(CY1G0X1G0XOOQ(CY7+%q7+%qO#$vQSO7+%qOOQ(CY7+&X7+&XO>cQSO7+&XO!@^QWO7+&XOOQO7+%t7+%tO$9XQ(CjO7+&QOOQO7+&Q7+&QO%TQUO7+&QO%)^Q(C[O7+&QO!@RQ(C[O7+%tO!@^QWO7+%tO%)iQ(C[O7+&QO%)wQ(CjO7++cO%TQUO7++cO%*XQSO7++bO%*XQSO7++bOOQO1G4j1G4jO8|QSO1G4jO%*aQSO1G4jOOQO7+%y7+%yO#$vQSO<<KwO% kQbO<<KwO%*oQSO<<KwOOQQ<<Kw<<KwO!&VQ,UO<<KwO%TQUO<<KwO%*wQSO<<KwO%+SQ(CjO1G2kO%-_Q(CjO1G2mO%/jQ(CjO1G2XO%1{Q,UO,5>wOOQO-E<Z-E<ZO%2VQbO,5>xO%TQUO,5>xOOQO-E<[-E<[O%2aQSO1G5pOOQ(CY<<I}<<I}O%2iQ$IUO1G0nO%4sQ$IUO1G0xO%4zQ$IUO1G0xO%7OQ$IUO1G0xO%7VQ$IUO1G0xO%8zQ$IUO1G0xO%9bQ$IUO1G0xO%;uQ$IUO1G0xO%;|Q$IUO1G0xO%>QQ$IUO1G0xO%>XQ$IUO1G0xO%@PQ$IUO1G0xO%@dQ(CjO<<JaO%AiQ$IUO1G0xO%C_Q$IUO'#J_O%EbQ$IUO1G1^O%EoQ$IUO1G0QO!){QUO'#FlOOQO'#Jz'#JzOOQO1G1p1G1pO%EyQSO1G1oO%FOQ$IUO,5?ROOOO7+'c7+'cOOOO1G/S1G/SOOQ(CY1G4o1G4oO!'oQ,UO7+(ZO%FYQSO,5?SO9SQSO,5?SOOQO-E<f-E<fO%FhQSO1G6SO%FhQSO1G6SO%FpQSO1G6SO%F{Q,UO7+'sO%G]Q`O,5?UO%GgQSO,5?UO!&VQ,UO,5?UOOQO-E<h-E<hO%GlQ`O1G6TO%GvQSO1G6TOOQ(CW1G2c1G2cO$$QQSO1G2cOOQ(CW1G2b1G2bO%HOQSO1G2dO!&VQ,UO1G2dOOQ(CW1G2i1G2iO!@^QWO1G2bOCQQSO1G2cO%HTQSO1G2dO%H]QSO1G2cO!'oQ,UO7++OOOQ(CY1G/[1G/[O%HhQSO1G/[OOQ(CY7+'n7+'nO%HmQ,UO7+'uO%H}Q(CjO<<KROOQ(CY<<KR<<KRO%IqQSO1G0sO!&VQ,UO'#ImO%IvQSO,5@jO!&VQ,UO1G2gOOQQ<<Gx<<GxO!@RQ(C[O<<GxO%JOQ(CjO<<ItOOQ(CY<<It<<ItOOQO,5?_,5?_O%JrQSO,5?_O$(lQSO,5?_OOQO-E<q-E<qO%JwQSO1G6]O%JwQSO1G6]O9SQSO1G6]O@TQSO<<LdOOQQ<<Ld<<LdO%KPQSO<<LdO9^Q(C[O<<LdOOQQ<<LP<<LPO%#tQ(ChO<<LPOOQQ<<LQ<<LQO%$OQ`O<<LQO%KUQWO'#IoO%KaQSO,5@nO!){QUO,5@nOOQQ1G3O1G3OO%KiQUO'#JhOOQO'#Iq'#IqO9^Q(C[O'#IqO%KsQWO,5=mOOQQ,5=m,5=mO%KzQWO'#E`O%L`QSO7+(rO%LeQSO7+(rOOQQ7+(r7+(rO!&VQ,UO7+(rO%TQUO7+(rO%LmQSO7+(rOOQQ7+(t7+(tO9^Q(C[O7+(tO#MsQSO7+(tO8wQSO7+(tO!@^QWO7+(tO%LxQSO,5?^OOQO-E<p-E<pOOQO'#HU'#HUO%MTQSO1G6ZO9^Q(C[O<<GnOOQQ<<Gn<<GnO@TQSO<<GnO%M]QSO7++xO%MbQSO7++yO%TQUO7++xO%TQUO7++yOOQQ7+(|7+(|O%MgQSO7+(|O%MlQUO7+(|O%MsQSO7+(|OOQQ<<Lp<<LpOOQQ<<Lr<<LrOOQQ-E<s-E<sOOQQ1G3q1G3qO%MxQSO,5>WOOQQ,5>Y,5>YO%M}QSO1G3wO8|QSO7+&_O!){QUO7+&_OOQO7+%X7+%XO%NSQ$IUO1G5zO>cQSO7+%XOOQ(CY<<I]<<I]OOQ(CY<<Is<<IsO>cQSO<<IsOOQO<<Il<<IlO$9XQ(CjO<<IlO%TQUO<<IlOOQO<<I`<<I`O!@RQ(C[O<<I`O%N^Q(C[O<<IlO%NiQ(CjO<<N}O%NyQSO<<N|OOQO7+*U7+*UO8|QSO7+*UOOQQANAcANAcO& RQSOANAcO!&VQ,UOANAcO#$vQSOANAcO% kQbOANAcO%TQUOANAcO& ZQ(CjO7+'sO&#lQ(CjO7+'uO&%}QbO1G4dO&&XQ$IUO7+&YO&&fQ$IUO,59nO&(iQ$IUO,5<dO&*lQ$IUO,5<fO&,oQ$IUO,5<tO&.eQ$IUO7+'fO&.rQ$IUO7+'gO&/PQSO,5<WOOQO7+'Z7+'ZO&/UQ,UO<<KuOOQO1G4n1G4nO&/]QSO1G4nO&/hQSO1G4nO&/vQSO7++nO&/vQSO7++nO!&VQ,UO1G4pO&0OQ`O1G4pO&0YQSO7++oOOQ(CW7+'}7+'}O$$QQSO7+(OO&0bQ`O7+(OOOQ(CW7+'|7+'|O$$QQSO7+'}O&0iQSO7+(OO!&VQ,UO7+(OOCQQSO7+'}O&0nQ,UO<<NjOOQ(CY7+$v7+$vO&0xQ`O,5?XOOQO-E<k-E<kO&1SQ(ChO7+(ROOQQAN=dAN=dO9SQSO1G4yOOQO1G4y1G4yO&1dQSO1G4yO&1iQSO7++wO&1iQSO7++wO9^Q(C[OANBOO@TQSOANBOOOQQANBOANBOOOQQANAkANAkOOQQANAlANAlO&1qQSO,5?ZOOQO-E<m-E<mO&1|Q$IUO1G6YO&4^QbO'#CfOOQO,5?],5?]OOQO-E<o-E<oOOQQ1G3X1G3XO%KiQUO,5<xOOQQ<<L^<<L^O!&VQ,UO<<L^O%L`QSO<<L^O&4hQSO<<L^O%TQUO<<L^OOQQ<<L`<<L`O9^Q(C[O<<L`O#MsQSO<<L`O8wQSO<<L`O&4pQWO1G4xO&4{QSO7++uOOQQAN=YAN=YO9^Q(C[OAN=YOOQQ<= d<= dOOQQ<= e<= eO&5TQSO<= dO&5YQSO<= eOOQQ<<Lh<<LhO&5_QSO<<LhO&5dQUO<<LhOOQQ1G3r1G3rO>cQSO7+)cO&5kQSO<<IyO&5vQ$IUO<<IyOOQO<<Hs<<HsOOQ(CYAN?_AN?_OOQOAN?WAN?WO$9XQ(CjOAN?WOOQOAN>zAN>zO%TQUOAN?WOOQO<<Mp<<MpOOQQG26}G26}O!&VQ,UOG26}O#$vQSOG26}O&6QQSOG26}O% kQbOG26}O&6YQ$IUO<<JaO&6gQ$IUO1G2XO&8]Q$IUO1G2kO&:`Q$IUO1G2mO&<cQ$IUO<<KRO&<pQ$IUO<<ItOOQO1G1r1G1rO!'oQ,UOANAaOOQO7+*Y7+*YO&<}QSO7+*YO&=YQSO<= YO&=bQ`O7+*[OOQ(CW<<Kj<<KjO$$QQSO<<KjOOQ(CW<<Ki<<KiO&=lQ`O<<KjO$$QQSO<<KiOOQO7+*e7+*eO9SQSO7+*eO&=sQSO<= cOOQQG27jG27jO9^Q(C[OG27jO!){QUO1G4uO&={QSO7++tO%L`QSOANAxOOQQANAxANAxO!&VQ,UOANAxO&>TQSOANAxOOQQANAzANAzO9^Q(C[OANAzO#MsQSOANAzOOQO'#HV'#HVOOQO7+*d7+*dOOQQG22tG22tOOQQANEOANEOOOQQANEPANEPOOQQANBSANBSO&>]QSOANBSOOQQ<<L}<<L}O!){QUOAN?eOOQOG24rG24rO$9XQ(CjOG24rO#$vQSOLD,iOOQQLD,iLD,iO!&VQ,UOLD,iO&>bQSOLD,iO&>jQ$IUO7+'sO&@`Q$IUO7+'uO&BUQ,UOG26{OOQO<<Mt<<MtOOQ(CWANAUANAUO$$QQSOANAUOOQ(CWANATANATOOQO<<NP<<NPOOQQLD-ULD-UO&BfQ$IUO7+*aOOQQG27dG27dO%L`QSOG27dO!&VQ,UOG27dOOQQG27fG27fO9^Q(C[OG27fOOQQG27nG27nO&BpQ$IUOG25POOQOLD*^LD*^OOQQ!$(!T!$(!TO#$vQSO!$(!TO!&VQ,UO!$(!TO&BzQ(CjOG26{OOQ(CWG26pG26pOOQQLD-OLD-OO%L`QSOLD-OOOQQLD-QLD-QOOQQ!)9Eo!)9EoO#$vQSO!)9EoOOQQ!$(!j!$(!jOOQQ!.K;Z!.K;ZO&E]Q$IUOG26{O!){QUO'#DvO0xQSO'#ETO&GRQbO'#JdO!){QUO'#DnO&GYQUO'#DzO&GaQbO'#CfO&IwQbO'#CfO!){QUO'#D|O&JXQUO,5;SO!){QUO,5;^O!){QUO,5;^O!){QUO,5;^O!){QUO,5;^O!){QUO,5;^O!){QUO,5;^O!){QUO,5;^O!){QUO,5;^O!){QUO,5;^O!){QUO,5;^O!){QUO,5;^O!){QUO'#IgO&L[QSO,5<cO&LdQ,UO,5;^O&MwQ,UO,5;^O!){QUO,5;rO0{QSO'#DSO0{QSO'#DSO!&VQ,UO'#FxO&LdQ,UO'#FxO!&VQ,UO'#FzO&LdQ,UO'#FzO!&VQ,UO'#GYO&LdQ,UO'#GYO!){QUO,5:fO!){QUO,5@`O&JXQUO1G0nO&NOQ$IUO'#CfO!){QUO1G1zO!&VQ,UO,5=PO&LdQ,UO,5=PO!&VQ,UO,5=RO&LdQ,UO,5=RO!&VQ,UO,5<mO&LdQ,UO,5<mO&JXQUO1G1{O!){QUO7+&uO!&VQ,UO1G2XO&LdQ,UO1G2XO!&VQ,UO1G2ZO&LdQ,UO1G2ZO&JXQUO7+'gO&JXQUO7+&YO!&VQ,UOANAaO&LdQ,UOANAaO&NYQSO'#EhO&N_QSO'#EhO&NgQSO'#FWO&NlQSO'#ErO&NqQSO'#JtO&N|QSO'#JrO' XQSO,5;SO' ^Q,UO,5<`O' eQSO'#GRO' jQSO'#GRO' oQSO,5<aO' wQSO,5;SO'!PQ$IUO1G1ZO'!WQSO,5<mO'!]QSO,5<mO'!bQSO,5<oO'!gQSO,5<oO'!lQSO1G1{O'!qQSO1G0nO'!vQ,UO<<KuO'!}Q,UO<<KuO7aQ,UO'#FvO8wQSO'#FuOAOQSO'#EgO!){QUO,5;oO!2uQSO'#GRO!2uQSO'#GRO!2uQSO'#GTO!2uQSO'#GTO!'oQ,UO7+(ZO!'oQ,UO7+(ZO$KZQ`O1G2oO$KZQ`O1G2oO!&VQ,UO,5=TO!&VQ,UO,5=T",
  stateData: "'$W~O'nOS'oOSROS'pRQ~OPYOQYOV!UO^qOayObxOikOkYOlkOmkOskOuYOwYO|WO!QkO!RkO!XXO!ctO!hZO!kYO!lYO!mYO!ouO!qvO!twO!x]O#p!OO$Q{O$UfO%`|O%b!PO%d}O%e}O%f}O%i!QO%k!RO%n!SO%o!SO%q!TO%}!VO&T!WO&V!XO&X!YO&Z!ZO&^![O&d!]O&j!^O&l!_O&n!`O&p!aO&r!bO'uSO'wTO'zUO(SVO(b[O(oiO~OPYOQYOa!iOb!hOikOkYOlkOmkOskOuYOwYO|WO!QkO!RkO!X!dO!ctO!hZO!kYO!lYO!mYO!ouO!q!fO!t!gO$Q!jO$UfO'u!cO'wTO'zUO(SVO(b[O(oiO~O^!uOl!mO|!nO![!wO!]!tO!^!tO!x9qO!|!oO!}!oO#O!vO#P!oO#Q!oO#T!xO#U!xO'v!kO'wTO'zUO(V!lO(b!rO~O'p!yO~OPYXXYX^YXkYXyYXzYX|YX!VYX!eYX!fYX!hYX!lYX#XYX#dcX#gYX#hYX#iYX#jYX#kYX#lYX#mYX#nYX#oYX#qYX#sYX#uYX#vYX#{YX'lYX(SYX(cYX(jYX(kYX~O!a$zX~P(jO[!{O'w!}O'x!{O'y!}O~O[#OO'y!}O'z!}O'{#OO~Oq#QO!O#RO(T#RO(U#TO~OPYOQYOa!iOb!hOikOkYOlkOmkOskOuYOwYO|WO!QkO!RkO!X!dO!ctO!hZO!kYO!lYO!mYO!ouO!q!fO!t!gO$Q!jO$UfO'u9uO'wTO'zUO(SVO(b[O(oiO~O!U#XO!V#UO!S(YP!S(gP~P+vO!W#aO~P`OPYOQYOa!iOb!hOkYOlkOmkOskOuYOwYO|WO!QkO!RkO!X!dO!ctO!hZO!kYO!lYO!mYO!ouO!q!fO!t!gO$Q!jO$UfO'wTO'zUO(SVO(b[O(oiO~Oi#kO!U#gO!x]O#b#jO#c#gO'u9vO!g(dP~P.bO!h#mO'u#lO~O!t#qO!x]O%`#rO~O#d#sO~O!a#tO#d#sO~OP$[OX$cOk$POy#xOz#yO|#zO!V$`O!e$RO!f#vO!h#wO!l$[O#g#}O#h$OO#i$OO#j$OO#k$QO#l$RO#m$RO#n$bO#o$RO#q$SO#s$UO#u$WO#v$XO(SVO(c$YO(j#{O(k#|O~O^(WX'l(WX'j(WX!g(WX!S(WX!X(WX%a(WX!a(WX~P1jO#X$dO#{$dOP(XXX(XXk(XXy(XXz(XX|(XX!V(XX!e(XX!h(XX!l(XX#g(XX#h(XX#i(XX#j(XX#k(XX#l(XX#m(XX#n(XX#o(XX#q(XX#s(XX#u(XX#v(XX(S(XX(c(XX(j(XX(k(XX!X(XX%a(XX~O^(XX!f(XX'l(XX'j(XX!S(XX!g(XXo(XX!a(XX~P4QO#X$dO~O$W$fO$Y$eO$a$kO~O!X$lO$UfO$d$mO$f$oO~Oi%ROk$sOl$rOm$rOs%SOu%TOw%UO|$zO!X${O!c%ZO!h$wO#c%[O$Q%XO$m%VO$o%WO$r%YO'u$qO'wTO'zUO(O%QO(S$tOd(PP~O!h%]O~O|%`O!X%aO'u%_O~O!a%eO~O^%fO'l%fO~O'v!kO~P%TO%f%mO~P%TO!h%]O'u%_O'v!kO(O%QO~Ob%tO!h%]O'u%_O~O#o$RO~Oy%yO!X%vO!h%xO%b%|O'u%_O'v!kO'wTO'zUO](xP~O!t#qO~O%k&OO|(tX!X(tX'u(tX~O'u&PO~O!q&UO#p!OO%b!PO%d}O%e}O%f}O%i!QO%k!RO%n!SO%o!SO~Oa&ZOb&YO!t&WO%`&XO%s&VO~P;kOa&^ObxO!X&]O!q&UO!twO!x]O#p!OO%`|O%d}O%e}O%f}O%i!QO%k!RO%n!SO%o!SO%q!TO~O_&aO#X&dO%b&_O'v!kO~P<pO!h&eO!q&iO~O!h#mO~O!XXO~O^%fO'k&qO'l%fO~O^%fO'k&tO'l%fO~O^%fO'k&vO'l%fO~O'jYX!SYXoYX!gYX&RYX!XYX%aYX!aYX~P(jO!['TO!]&|O!^&|O'v!kO'wTO'zUO~Ol&zO|&yO!U&}O(V&xO!W(ZP!W(iP~P?wOg'WO!X'UO'u%_O~Ob']O!h%]O'u%_O~Oy%yO!h%xO~Ol!mO|!nO!x9qO!|!oO!}!oO#P!oO#Q!oO'v!kO'wTO'zUO(V!lO(b!rO~O!['cO!]'bO!^'bO#O!oO#T'dO#U'dO~PAcO^%fO!a#tO!h%]O'l%fO(O%QO(c'fO~O!l'jO#X'hO~PBqOl!mO|!nO'wTO'zUO(V!lO(b!rO~O!XXOl(`X|(`X![(`X!](`X!^(`X!x(`X!|(`X!}(`X#O(`X#P(`X#Q(`X#T(`X#U(`X'v(`X'w(`X'z(`X(V(`X(b(`X~O!]'bO!^'bO'v!kO~PCaO'q'nO'r'nO's'pO~O[!{O'w'rO'x!{O'y'rO~O[#OO'y'rO'z'rO'{#OO~Oq#QO!O#RO(T#RO(U'vO~O!U'xO!S&}X!S'TX!V&}X!V'TX~P+vO!V'zO!S(YX~OP$[OX$cOk$POy#xOz#yO|#zO!V'zO!e$RO!f#vO!h#wO!l$[O#g#}O#h$OO#i$OO#j$OO#k$QO#l$RO#m$RO#n$bO#o$RO#q$SO#s$UO#u$WO#v$XO(SVO(c$YO(j#{O(k#|O~O!S(YX~PGTO!S(PO~O!S(fX!V(fX!a(fX!g(fX(c(fX~O#X(fX#d#]X!W(fX~PIZO#X(QO!S(hX!V(hX~O!V(RO!S(gX~O!S(UO~O#X$dO~PIZO!W(VO~P`Oy#xOz#yO|#zO!f#vO!h#wO(SVOP!jaX!jak!ja!V!ja!e!ja!l!ja#g!ja#h!ja#i!ja#j!ja#k!ja#l!ja#m!ja#n!ja#o!ja#q!ja#s!ja#u!ja#v!ja(c!ja(j!ja(k!ja~O^!ja'l!ja'j!ja!S!ja!g!jao!ja!X!ja%a!ja!a!ja~PJqO!g(WO~O!a#tO#X(XO(c'fO!V(eX^(eX'l(eX~O!g(eX~PMaO|%`O!X%aO!x]O#b(^O#c(]O'u%_O~O!V(_O!g(dX~O!g(aO~O|%`O!X%aO#c(]O'u%_O~OP(XXX(XXk(XXy(XXz(XX|(XX!V(XX!e(XX!f(XX!h(XX!l(XX#g(XX#h(XX#i(XX#j(XX#k(XX#l(XX#m(XX#n(XX#o(XX#q(XX#s(XX#u(XX#v(XX(S(XX(c(XX(j(XX(k(XX~O!a#tO!g(XX~PN}Oy(bOz(cO!f#vO!h#wO!x!wa|!wa~O!t!wa%`!wa!X!wa#b!wa#c!wa'u!wa~P!#RO!t(gO~OPYOQYOa!iOb!hOikOkYOlkOmkOskOuYOwYO|WO!QkO!RkO!XXO!ctO!hZO!kYO!lYO!mYO!ouO!q!fO!t!gO$Q!jO$UfO'u!cO'wTO'zUO(SVO(b[O(oiO~Oi%ROk$sOl$rOm$rOs%SOu%TOw:ZO|$zO!X${O!c;eO!h$wO#c:aO$Q%XO$m:]O$o:_O$r%YO'u(kO'wTO'zUO(O%QO(S$tO~O#d(mO~Oi%ROk$sOl$rOm$rOs%SOu%TOw%UO|$zO!X${O!c%ZO!h$wO#c%[O$Q%XO$m%VO$o%WO$r%YO'u(kO'wTO'zUO(O%QO(S$tO~Od(]P~P!'oO!U(qO!g(^P~P%TO(V(sO(b[O~O|(uO!h#wO(V(sO(b[O~OP9pOQ9pOa;aOb!hOikOk9pOlkOmkOskOu9pOw9pO|WO!QkO!RkO!X!dO!c9sO!hZO!k9pO!l9pO!m9pO!o9tO!q9wO!t!gO$Q!jO$UfO'u)TO'wTO'zUO(SVO(b[O(o;_O~Oz)WO!h#wO~O!V$`O^$ka'l$ka'j$ka!g$ka!S$ka!X$ka%a$ka!a$ka~O#p)[O~P!&VOy)_O!a)^O!X$XX$T$XX$W$XX$Y$XX$a$XX~O!a)^O!X(lX$T(lX$W(lX$Y(lX$a(lX~Oy)_O~P!-eOy)_O!X(lX$T(lX$W(lX$Y(lX$a(lX~O!X)aO$T)eO$W)`O$Y)`O$a)fO~O!U)iO~P!){O$W$fO$Y$eO$a)mO~Og$sXy$sX|$sX!f$sX(j$sX(k$sX~OdfXd$sXgfX!VfX#XfX~P!/ZOl)oO~Oq)pO(T)qO(U)sO~Og)|Oy)uO|)vO(j)xO(k)zO~Od)tO~P!0dOd)}O~Oi%ROk$sOl$rOm$rOs%SOu%TOw:ZO|$zO!X${O!c;eO!h$wO#c:aO$Q%XO$m:]O$o:_O$r%YO'wTO'zUO(O%QO(S$tO~O!U*RO'u*OO!g(pP~P!1RO#d*TO~O!h*UO~O!U*ZO'u*WO!S(qP~P!1ROk*gO|*_O![*eO!]*^O!^*^O!h*UO#T*fO%W*aO'v!kO(V!lO~O!W*dO~P!3XO!f#vOg(RXy(RX|(RX(j(RX(k(RX!V(RX#X(RX~Od(RX#y(RX~P!4QOg*jO#X*iOd(QX!V(QX~O!V*kOd(PX~O'u&POd(PP~O!h*rO~O'u(kO~Oi*vO|%`O!U#gO!X%aO!x]O#b#jO#c#gO'u%_O!g(dP~O!a#tO#d*wO~O|%`O!U*yO!V(RO!X%aO'u%_O!S(gP~Ol'QO|*{O!U*zO'wTO'zUO(V(sO~O!W(iP~P!6{O!V*|O^(uX'l(uX~OP$[OX$cOk$POy#xOz#yO|#zO!e$RO!f#vO!h#wO!l$[O#g#}O#h$OO#i$OO#j$OO#k$QO#l$RO#m$RO#n$bO#o$RO#q$SO#s$UO#u$WO#v$XO(SVO(c$YO(j#{O(k#|O~O^!ba!V!ba'l!ba'j!ba!S!ba!g!bao!ba!X!ba%a!ba!a!ba~P!7sOy#xOz#yO|#zO!f#vO!h#wO(SVOP!naX!nak!na!V!na!e!na!l!na#g!na#h!na#i!na#j!na#k!na#l!na#m!na#n!na#o!na#q!na#s!na#u!na#v!na(c!na(j!na(k!na~O^!na'l!na'j!na!S!na!g!nao!na!X!na%a!na!a!na~P!:^Oy#xOz#yO|#zO!f#vO!h#wO(SVOP!paX!pak!pa!V!pa!e!pa!l!pa#g!pa#h!pa#i!pa#j!pa#k!pa#l!pa#m!pa#n!pa#o!pa#q!pa#s!pa#u!pa#v!pa(c!pa(j!pa(k!pa~O^!pa'l!pa'j!pa!S!pa!g!pao!pa!X!pa%a!pa!a!pa~P!<wOg+VO!X'UO%a+UO(O%QO~O!a+XO^'}X!X'}X'l'}X!V'}X~O^%fO!XXO'l%fO~O!h%]O(O%QO~O!h%]O'u%_O(O%QO~O!a#tO#d(mO~O%b+eO'u+aO'wTO'zUO!W(yP~O!V+fO](xX~OX+jO~O]+kO~O!X%vO'u%_O'v!kO](xP~O#X+pO(O%QO~Og+sO!X${O(O%QO~O!X+uO~Oy+wO!XXO~O%f%mO~O!t+|O~Ob,RO~O'u#lO!W(wP~Ob%tO~O%b!PO'u&PO~P<pOX,XO],WO~OPYOQYOayObxOikOkYOlkOmkOskOuYOwYO|WO!QkO!RkO!ctO!hZO!kYO!lYO!mYO!ouO!twO!x]O$UfO%`|O'wTO'zUO(SVO(b[O(oiO~O!X!dO!q!fO$Q!jO'u!cO~P!CnO],WO^%fO'l%fO~OPYOQYOa!iOb!hOikOkYOlkOmkOskOuYOwYO|WO!QkO!RkO!X!dO!ctO!hZO!kYO!lYO!mYO!ouO!t!gO$Q!jO$UfO'u!cO'wTO'zUO(SVO(b[O(oiO~O^,^O!qvO#p}O%d}O%e}O%f}O~P!FWO!h&eO~O&T,dO~O!X,fO~O&f,hO&h,iOP&caQ&caV&ca^&caa&cab&cai&cak&cal&cam&cas&cau&caw&ca|&ca!Q&ca!R&ca!X&ca!c&ca!h&ca!k&ca!l&ca!m&ca!o&ca!q&ca!t&ca!x&ca#p&ca$Q&ca$U&ca%`&ca%b&ca%d&ca%e&ca%f&ca%i&ca%k&ca%n&ca%o&ca%q&ca%}&ca&T&ca&V&ca&X&ca&Z&ca&^&ca&d&ca&j&ca&l&ca&n&ca&p&ca&r&ca'j&ca'u&ca'w&ca'z&ca(S&ca(b&ca(o&ca!W&ca&[&ca_&ca&a&ca~O'u,nO~O!V{X!V!_X!W{X!W!_X!a{X!a!_X!h!_X#X{X(O!_X~O!a,sO#X,rO!V#aX!V([X!W#aX!W([X!a([X!h([X(O([X~O!a,uO!h%]O(O%QO!V!ZX!W!ZX~Ol!mO|!nO'wTO'zUO(V!lO~OP9pOQ9pOa;aOb!hOikOk9pOlkOmkOskOu9pOw9pO|WO!QkO!RkO!X!dO!c9sO!hZO!k9pO!l9pO!m9pO!o9tO!q9wO!t!gO$Q!jO$UfO'wTO'zUO(SVO(b[O(o;_O~O'u:fO~P# ^O!V,yO!W(ZX~O!W,{O~O!a,sO#X,rO!V#aX!W#aX~O!V,|O!W(iX~O!W-OO~O!]-PO!^-PO'v!kO~P!N{O!W-SO~P'WOg-VO!X'UO~O!S-[O~Ol!wa![!wa!]!wa!^!wa!|!wa!}!wa#O!wa#P!wa#Q!wa#T!wa#U!wa'v!wa'w!wa'z!wa(V!wa(b!wa~P!#RO!l-aO#X-_O~PBqO!]-cO!^-cO'v!kO~PCaO^%fO#X-_O'l%fO~O^%fO!a#tO#X-_O'l%fO~O^%fO!a#tO!l-aO#X-_O'l%fO(c'fO~O'q'nO'r'nO's-hO~Oo-iO~O!S&}a!V&}a~P!7sO!U-mO!S&}X!V&}X~P%TO!V'zO!S(Ya~O!S(Ya~PGTO!V(RO!S(ga~O|%`O!U-qO!X%aO'u%_O!S'TX!V'TX~O#X-sO!V(ea!g(ea^(ea'l(ea~O!a#tO~P#)dO!V(_O!g(da~O|%`O!X%aO#c-wO'u%_O~Oi-|O|%`O!U-yO!X%aO!x]O#b-{O#c-yO'u%_O!V'WX!g'WX~Oz.QO!h#wO~Og.TO!X'UO%a.SO(O%QO~O^#[i!V#[i'l#[i'j#[i!S#[i!g#[io#[i!X#[i%a#[i!a#[i~P!7sOg;kOy)uO|)vO(j)xO(k)zO~O#d#Wa^#Wa#X#Wa'l#Wa!V#Wa!g#Wa!X#Wa!S#Wa~P#,`O#d(RXP(RXX(RX^(RXk(RXz(RX!e(RX!h(RX!l(RX#g(RX#h(RX#i(RX#j(RX#k(RX#l(RX#m(RX#n(RX#o(RX#q(RX#s(RX#u(RX#v(RX'l(RX(S(RX(c(RX!g(RX!S(RX'j(RXo(RX!X(RX%a(RX!a(RX~P!4QO!V.^Od(]X~P!0dOd.`O~O!V.aO!g(^X~P!7sO!g.dO~O!S.fO~OP$[Oy#xOz#yO|#zO!f#vO!h#wO!l$[O(SVOX#fi^#fik#fi!V#fi!e#fi#h#fi#i#fi#j#fi#k#fi#l#fi#m#fi#n#fi#o#fi#q#fi#s#fi#u#fi#v#fi'l#fi(c#fi(j#fi(k#fi'j#fi!S#fi!g#fio#fi!X#fi%a#fi!a#fi~O#g#fi~P#0[O#g#}O~P#0[OP$[Oy#xOz#yO|#zO!f#vO!h#wO!l$[O#g#}O#h$OO#i$OO#j$OO(SVOX#fi^#fi!V#fi!e#fi#k#fi#l#fi#m#fi#n#fi#o#fi#q#fi#s#fi#u#fi#v#fi'l#fi(c#fi(j#fi(k#fi'j#fi!S#fi!g#fio#fi!X#fi%a#fi!a#fi~Ok#fi~P#2|Ok$PO~P#2|OP$[Ok$POy#xOz#yO|#zO!f#vO!h#wO!l$[O#g#}O#h$OO#i$OO#j$OO#k$QO(SVO^#fi!V#fi#q#fi#s#fi#u#fi#v#fi'l#fi(c#fi(j#fi(k#fi'j#fi!S#fi!g#fio#fi!X#fi%a#fi!a#fi~OX#fi!e#fi#l#fi#m#fi#n#fi#o#fi~P#5nOX$cO!e$RO#l$RO#m$RO#n$bO#o$RO~P#5nOP$[OX$cOk$POy#xOz#yO|#zO!e$RO!f#vO!h#wO!l$[O#g#}O#h$OO#i$OO#j$OO#k$QO#l$RO#m$RO#n$bO#o$RO#q$SO(SVO^#fi!V#fi#s#fi#u#fi#v#fi'l#fi(c#fi(k#fi'j#fi!S#fi!g#fio#fi!X#fi%a#fi!a#fi~O(j#fi~P#8oO(j#{O~P#8oOP$[OX$cOk$POy#xOz#yO|#zO!e$RO!f#vO!h#wO!l$[O#g#}O#h$OO#i$OO#j$OO#k$QO#l$RO#m$RO#n$bO#o$RO#q$SO#s$UO(SVO(j#{O^#fi!V#fi#u#fi#v#fi'l#fi(c#fi'j#fi!S#fi!g#fio#fi!X#fi%a#fi!a#fi~O(k#fi~P#;aO(k#|O~P#;aOP$[OX$cOk$POy#xOz#yO|#zO!e$RO!f#vO!h#wO!l$[O#g#}O#h$OO#i$OO#j$OO#k$QO#l$RO#m$RO#n$bO#o$RO#q$SO#s$UO#u$WO(SVO(j#{O(k#|O~O^#fi!V#fi#v#fi'l#fi(c#fi'j#fi!S#fi!g#fio#fi!X#fi%a#fi!a#fi~P#>ROPYXXYXkYXyYXzYX|YX!eYX!fYX!hYX!lYX#XYX#dcX#gYX#hYX#iYX#jYX#kYX#lYX#mYX#nYX#oYX#qYX#sYX#uYX#vYX#{YX(SYX(cYX(jYX(kYX!VYX!WYX~O#yYX~P#@lOP$[OX:XOk9{Oy#xOz#yO|#zO!e9}O!f#vO!h#wO!l$[O#g9yO#h9zO#i9zO#j9zO#k9|O#l9}O#m9}O#n:WO#o9}O#q:OO#s:QO#u:SO#v:TO(SVO(c$YO(j#{O(k#|O~O#y.hO~P#ByO#X:YO#{:YO#y(XX!W(XX~PN}O^'Za!V'Za'l'Za'j'Za!g'Za!S'Zao'Za!X'Za%a'Za!a'Za~P!7sOP#fiX#fi^#fik#fiz#fi!V#fi!e#fi!f#fi!h#fi!l#fi#g#fi#h#fi#i#fi#j#fi#k#fi#l#fi#m#fi#n#fi#o#fi#q#fi#s#fi#u#fi#v#fi'l#fi(S#fi(c#fi'j#fi!S#fi!g#fio#fi!X#fi%a#fi!a#fi~P#,`O^#zi!V#zi'l#zi'j#zi!S#zi!g#zio#zi!X#zi%a#zi!a#zi~P!7sO$W.mO$Y.mO~O$W.nO$Y.nO~O!a)^O#X.oO!X$^X$T$^X$W$^X$Y$^X$a$^X~O!U.pO~O!X)aO$T.rO$W)`O$Y)`O$a.sO~O!V:UO!W(WX~P#ByO!W.tO~O!a)^O$a(lX~O$a.vO~Oq)pO(T)qO(U.yO~O!S.}O~P!&VO!VcX!acX!gcX!g$sX(ccX~P!/ZO!g/TO~P#,`O!V/UO!a#tO(c'fO!g(pX~O!g/ZO~O!U*RO'u%_O!g(pP~O#d/]O~O!S$sX!V$sX!a$zX~P!/ZO!V/^O!S(qX~P#,`O!a/`O~O!S/bO~Ok/fO!a#tO!h%]O(O%QO(c'fO~O'u/hO~O!a+XO~O^%fO!V/lO'l%fO~O!W/nO~P!3XO!]/oO!^/oO'v!kO(V!lO~O|/qO(V!lO~O#T/rO~O'u&POd'`X!V'`X~O!V*kOd(Pa~Od/wO~Oy/xOz/xO|/yOgva(jva(kva!Vva#Xva~Odva#yva~P$ aOy)uO|)vOg$la(j$la(k$la!V$la#X$la~Od$la#y$la~P$!VOy)uO|)vOg$na(j$na(k$na!V$na#X$na~Od$na#y$na~P$!xO#d/{O~Od$|a!V$|a#X$|a#y$|a~P!0dO!a#tO~O#d0OO~O!V*|O^(ua'l(ua~Oy#xOz#yO|#zO!f#vO!h#wO(SVOP!niX!nik!ni!V!ni!e!ni!l!ni#g!ni#h!ni#i!ni#j!ni#k!ni#l!ni#m!ni#n!ni#o!ni#q!ni#s!ni#u!ni#v!ni(c!ni(j!ni(k!ni~O^!ni'l!ni'j!ni!S!ni!g!nio!ni!X!ni%a!ni!a!ni~P$$gOg.TO!X'UO%a.SO~Oi0YO'u0XO~P!1UO!a+XO^'}a!X'}a'l'}a!V'}a~O#d0`O~OXYX!VcX!WcX~O!V0aO!W(yX~O!W0cO~OX0dO~O'u+aO'wTO'zUO~O!X%vO'u%_O]'hX!V'hX~O!V+fO](xa~O!g0iO~P!7sOX0lO~O]0mO~O#X0pO~Og0sO!X${O~O(V(sO!W(vP~Og0|O!X0yO%a0{O(O%QO~OX1WO!V1UO!W(wX~O!W1XO~O]1ZO^%fO'l%fO~O'u#lO'wTO'zUO~O#X$dO#{$dOP(XXX(XXk(XXy(XXz(XX|(XX!V(XX!e(XX!h(XX!l(XX#g(XX#h(XX#i(XX#j(XX#k(XX#l(XX#m(XX#n(XX#q(XX#s(XX#u(XX#v(XX(S(XX(c(XX(j(XX(k(XX~O#o1^O&R1_O^(XX!f(XX~P$+]O#X$dO#o1^O&R1_O~O^1aO~P%TO^1cO~O&[1fOP&YiQ&YiV&Yi^&Yia&Yib&Yii&Yik&Yil&Yim&Yis&Yiu&Yiw&Yi|&Yi!Q&Yi!R&Yi!X&Yi!c&Yi!h&Yi!k&Yi!l&Yi!m&Yi!o&Yi!q&Yi!t&Yi!x&Yi#p&Yi$Q&Yi$U&Yi%`&Yi%b&Yi%d&Yi%e&Yi%f&Yi%i&Yi%k&Yi%n&Yi%o&Yi%q&Yi%}&Yi&T&Yi&V&Yi&X&Yi&Z&Yi&^&Yi&d&Yi&j&Yi&l&Yi&n&Yi&p&Yi&r&Yi'j&Yi'u&Yi'w&Yi'z&Yi(S&Yi(b&Yi(o&Yi!W&Yi_&Yi&a&Yi~O_1lO!W1jO&a1kO~P`O!XXO!h1nO~O&h,iOP&ciQ&ciV&ci^&cia&cib&cii&cik&cil&cim&cis&ciu&ciw&ci|&ci!Q&ci!R&ci!X&ci!c&ci!h&ci!k&ci!l&ci!m&ci!o&ci!q&ci!t&ci!x&ci#p&ci$Q&ci$U&ci%`&ci%b&ci%d&ci%e&ci%f&ci%i&ci%k&ci%n&ci%o&ci%q&ci%}&ci&T&ci&V&ci&X&ci&Z&ci&^&ci&d&ci&j&ci&l&ci&n&ci&p&ci&r&ci'j&ci'u&ci'w&ci'z&ci(S&ci(b&ci(o&ci!W&ci&[&ci_&ci&a&ci~O!S1tO~O!V!Za!W!Za~P#ByOl!mO|!nO!U1zO(V!lO!V'OX!W'OX~P?wO!V,yO!W(Za~O!V'UX!W'UX~P!6{O!V,|O!W(ia~O!W2RO~P'WO^%fO#X2[O'l%fO~O^%fO!a#tO#X2[O'l%fO~O^%fO!a#tO!l2`O#X2[O'l%fO(c'fO~O^%fO'l%fO~P!7sO!V$`Oo$ka~O!S&}i!V&}i~P!7sO!V'zO!S(Yi~O!V(RO!S(gi~O!S(hi!V(hi~P!7sO!V(ei!g(ei^(ei'l(ei~P!7sO#X2bO!V(ei!g(ei^(ei'l(ei~O!V(_O!g(di~O|%`O!X%aO!x]O#b2gO#c2fO'u%_O~O|%`O!X%aO#c2fO'u%_O~Og2nO!X'UO%a2mO~Og2nO!X'UO%a2mO(O%QO~O#dvaPvaXva^vakva!eva!fva!hva!lva#gva#hva#iva#jva#kva#lva#mva#nva#ova#qva#sva#uva#vva'lva(Sva(cva!gva!Sva'jvaova!Xva%ava!ava~P$ aO#d$laP$laX$la^$lak$laz$la!e$la!f$la!h$la!l$la#g$la#h$la#i$la#j$la#k$la#l$la#m$la#n$la#o$la#q$la#s$la#u$la#v$la'l$la(S$la(c$la!g$la!S$la'j$lao$la!X$la%a$la!a$la~P$!VO#d$naP$naX$na^$nak$naz$na!e$na!f$na!h$na!l$na#g$na#h$na#i$na#j$na#k$na#l$na#m$na#n$na#o$na#q$na#s$na#u$na#v$na'l$na(S$na(c$na!g$na!S$na'j$nao$na!X$na%a$na!a$na~P$!xO#d$|aP$|aX$|a^$|ak$|az$|a!V$|a!e$|a!f$|a!h$|a!l$|a#g$|a#h$|a#i$|a#j$|a#k$|a#l$|a#m$|a#n$|a#o$|a#q$|a#s$|a#u$|a#v$|a'l$|a(S$|a(c$|a!g$|a!S$|a'j$|a#X$|ao$|a!X$|a%a$|a!a$|a~P#,`O^#[q!V#[q'l#[q'j#[q!S#[q!g#[qo#[q!X#[q%a#[q!a#[q~P!7sOd'PX!V'PX~P!'oO!V.^Od(]a~O!U2vO!V'QX!g'QX~P%TO!V.aO!g(^a~O!V.aO!g(^a~P!7sO!S2yO~O#y!ja!W!ja~PJqO#y!ba!V!ba!W!ba~P#ByO#y!na!W!na~P!:^O#y!pa!W!pa~P!<wO!X3]O$UfO$_3^O~O!W3bO~Oo3cO~P#,`O^$hq!V$hq'l$hq'j$hq!S$hq!g$hqo$hq!X$hq%a$hq!a$hq~P!7sO!S3dO~P#,`Oy)uO|)vO(k)zOg%Xi(j%Xi!V%Xi#X%Xi~Od%Xi#y%Xi~P$IuOy)uO|)vOg%Zi(j%Zi(k%Zi!V%Zi#X%Zi~Od%Zi#y%Zi~P$JhO(c$YO~P#,`O!U3gO'u%_O!V'[X!g'[X~O!V/UO!g(pa~O!V/UO!a#tO!g(pa~O!V/UO!a#tO(c'fO!g(pa~Od$ui!V$ui#X$ui#y$ui~P!0dO!U3oO'u*WO!S'^X!V'^X~P!1RO!V/^O!S(qa~O!V/^O!S(qa~P#,`O!a#tO#o3wO~Ok3zO!a#tO(c'fO~Od(Qi!V(Qi~P!0dO#X3}Od(Qi!V(Qi~P!0dO!g4QO~O^$iq!V$iq'l$iq'j$iq!S$iq!g$iqo$iq!X$iq%a$iq!a$iq~P!7sO!S4UO~O!V4VO!X(rX~P#,`O!f#vO~P4QO^$sX!X$sX%UYX'l$sX!V$sX~P!/ZO%U4XO^hXghXyhX|hX!XhX'lhX(jhX(khX!VhX~O%U4XO~O%b4`O'u+aO'wTO'zUO!V'gX!W'gX~O!V0aO!W(ya~OX4dO~O]4eO~O^%fO'l%fO~P#,`O!X${O~P#,`O!V4mO#X4oO!W(vX~O!W4pO~Ol!mO|4qO![!wO!]!tO!^!tO!x9qO!|!oO!}!oO#O!oO#P!oO#Q!oO#T4vO#U!xO'v!kO'wTO'zUO(V!lO(b!rO~O!W4uO~P%$gOg4{O!X0yO%a4zO~Og4{O!X0yO%a4zO(O%QO~O'u#lO!V'fX!W'fX~O!V1UO!W(wa~O'wTO'zUO(V5UO~O]5YO~O#o5]O&R5^O~PMaO!g5_O~P%TO^5aO~O^5aO~P%TO_1lO!W5fO&a1kO~P`O!a5hO~O!a5jO!V([i!W([i!a([i!h([i(O([i~O!V#ai!W#ai~P#ByO#X5kO!V#ai!W#ai~O!V!Zi!W!Zi~P#ByO^%fO#X5tO'l%fO~O^%fO!a#tO#X5tO'l%fO~O!V(eq!g(eq^(eq'l(eq~P!7sO!V(_O!g(dq~O|%`O!X%aO#c5{O'u%_O~O!X'UO%a6OO~Og6RO!X'UO%a6OO~O#d%XiP%XiX%Xi^%Xik%Xiz%Xi!e%Xi!f%Xi!h%Xi!l%Xi#g%Xi#h%Xi#i%Xi#j%Xi#k%Xi#l%Xi#m%Xi#n%Xi#o%Xi#q%Xi#s%Xi#u%Xi#v%Xi'l%Xi(S%Xi(c%Xi!g%Xi!S%Xi'j%Xio%Xi!X%Xi%a%Xi!a%Xi~P$IuO#d%ZiP%ZiX%Zi^%Zik%Ziz%Zi!e%Zi!f%Zi!h%Zi!l%Zi#g%Zi#h%Zi#i%Zi#j%Zi#k%Zi#l%Zi#m%Zi#n%Zi#o%Zi#q%Zi#s%Zi#u%Zi#v%Zi'l%Zi(S%Zi(c%Zi!g%Zi!S%Zi'j%Zio%Zi!X%Zi%a%Zi!a%Zi~P$JhO#d$uiP$uiX$ui^$uik$uiz$ui!V$ui!e$ui!f$ui!h$ui!l$ui#g$ui#h$ui#i$ui#j$ui#k$ui#l$ui#m$ui#n$ui#o$ui#q$ui#s$ui#u$ui#v$ui'l$ui(S$ui(c$ui!g$ui!S$ui'j$ui#X$uio$ui!X$ui%a$ui!a$ui~P#,`Od'Pa!V'Pa~P!0dO!V'Qa!g'Qa~P!7sO!V.aO!g(^i~O#y#[i!V#[i!W#[i~P#ByOP$[Oy#xOz#yO|#zO!f#vO!h#wO!l$[O(SVOX#fik#fi!e#fi#h#fi#i#fi#j#fi#k#fi#l#fi#m#fi#n#fi#o#fi#q#fi#s#fi#u#fi#v#fi#y#fi(c#fi(j#fi(k#fi!V#fi!W#fi~O#g#fi~P%2vO#g9yO~P%2vOP$[Oy#xOz#yO|#zO!f#vO!h#wO!l$[O#g9yO#h9zO#i9zO#j9zO(SVOX#fi!e#fi#k#fi#l#fi#m#fi#n#fi#o#fi#q#fi#s#fi#u#fi#v#fi#y#fi(c#fi(j#fi(k#fi!V#fi!W#fi~Ok#fi~P%5ROk9{O~P%5ROP$[Ok9{Oy#xOz#yO|#zO!f#vO!h#wO!l$[O#g9yO#h9zO#i9zO#j9zO#k9|O(SVO#q#fi#s#fi#u#fi#v#fi#y#fi(c#fi(j#fi(k#fi!V#fi!W#fi~OX#fi!e#fi#l#fi#m#fi#n#fi#o#fi~P%7^OX:XO!e9}O#l9}O#m9}O#n:WO#o9}O~P%7^OP$[OX:XOk9{Oy#xOz#yO|#zO!e9}O!f#vO!h#wO!l$[O#g9yO#h9zO#i9zO#j9zO#k9|O#l9}O#m9}O#n:WO#o9}O#q:OO(SVO#s#fi#u#fi#v#fi#y#fi(c#fi(k#fi!V#fi!W#fi~O(j#fi~P%9xO(j#{O~P%9xOP$[OX:XOk9{Oy#xOz#yO|#zO!e9}O!f#vO!h#wO!l$[O#g9yO#h9zO#i9zO#j9zO#k9|O#l9}O#m9}O#n:WO#o9}O#q:OO#s:QO(SVO(j#{O#u#fi#v#fi#y#fi(c#fi!V#fi!W#fi~O(k#fi~P%<TO(k#|O~P%<TOP$[OX:XOk9{Oy#xOz#yO|#zO!e9}O!f#vO!h#wO!l$[O#g9yO#h9zO#i9zO#j9zO#k9|O#l9}O#m9}O#n:WO#o9}O#q:OO#s:QO#u:SO(SVO(j#{O(k#|O~O#v#fi#y#fi(c#fi!V#fi!W#fi~P%>`O^#wy!V#wy'l#wy'j#wy!S#wy!g#wyo#wy!X#wy%a#wy!a#wy~P!7sOg;lOy)uO|)vO(j)xO(k)zO~OP#fiX#fik#fiz#fi!e#fi!f#fi!h#fi!l#fi#g#fi#h#fi#i#fi#j#fi#k#fi#l#fi#m#fi#n#fi#o#fi#q#fi#s#fi#u#fi#v#fi#y#fi(S#fi(c#fi!V#fi!W#fi~P%AWO!f#vOP(RXX(RXg(RXk(RXy(RXz(RX|(RX!e(RX!h(RX!l(RX#g(RX#h(RX#i(RX#j(RX#k(RX#l(RX#m(RX#n(RX#o(RX#q(RX#s(RX#u(RX#v(RX#y(RX(S(RX(c(RX(j(RX(k(RX!V(RX!W(RX~O#y#zi!V#zi!W#zi~P#ByO#y!ni!W!ni~P$$gO!W6_O~O!V'Za!W'Za~P#ByO!a#tO(c'fO!V'[a!g'[a~O!V/UO!g(pi~O!V/UO!a#tO!g(pi~Od$uq!V$uq#X$uq#y$uq~P!0dO!S'^a!V'^a~P#,`O!a6fO~O!V/^O!S(qi~P#,`O!V/^O!S(qi~O!S6jO~O!a#tO#o6oO~Ok6pO!a#tO(c'fO~O!S6rO~Od$wq!V$wq#X$wq#y$wq~P!0dO^$iy!V$iy'l$iy'j$iy!S$iy!g$iyo$iy!X$iy%a$iy!a$iy~P!7sO!a5jO~O!V4VO!X(ra~O^#[y!V#[y'l#[y'j#[y!S#[y!g#[yo#[y!X#[y%a#[y!a#[y~P!7sOX6wO~O!V0aO!W(yi~O]6}O~O(V(sO!V'cX!W'cX~O!V4mO!W(va~OikO'u7UO~P.bO!W7XO~P%$gOl!mO|7YO'wTO'zUO(V!lO(b!rO~O!X0yO~O!X0yO%a7[O~Og7_O!X0yO%a7[O~OX7dO!V'fa!W'fa~O!V1UO!W(wi~O!g7hO~O!g7iO~O!g7lO~O!g7lO~P%TO^7nO~O!a7oO~O!g7pO~O!V(hi!W(hi~P#ByO^%fO#X7xO'l%fO~O!V(ey!g(ey^(ey'l(ey~P!7sO!V(_O!g(dy~O!X'UO%a7{O~O#d$uqP$uqX$uq^$uqk$uqz$uq!V$uq!e$uq!f$uq!h$uq!l$uq#g$uq#h$uq#i$uq#j$uq#k$uq#l$uq#m$uq#n$uq#o$uq#q$uq#s$uq#u$uq#v$uq'l$uq(S$uq(c$uq!g$uq!S$uq'j$uq#X$uqo$uq!X$uq%a$uq!a$uq~P#,`O#d$wqP$wqX$wq^$wqk$wqz$wq!V$wq!e$wq!f$wq!h$wq!l$wq#g$wq#h$wq#i$wq#j$wq#k$wq#l$wq#m$wq#n$wq#o$wq#q$wq#s$wq#u$wq#v$wq'l$wq(S$wq(c$wq!g$wq!S$wq'j$wq#X$wqo$wq!X$wq%a$wq!a$wq~P#,`O!V'Qi!g'Qi~P!7sO#y#[q!V#[q!W#[q~P#ByOy/xOz/xO|/yOPvaXvagvakva!eva!fva!hva!lva#gva#hva#iva#jva#kva#lva#mva#nva#ova#qva#sva#uva#vva#yva(Sva(cva(jva(kva!Vva!Wva~Oy)uO|)vOP$laX$lag$lak$laz$la!e$la!f$la!h$la!l$la#g$la#h$la#i$la#j$la#k$la#l$la#m$la#n$la#o$la#q$la#s$la#u$la#v$la#y$la(S$la(c$la(j$la(k$la!V$la!W$la~Oy)uO|)vOP$naX$nag$nak$naz$na!e$na!f$na!h$na!l$na#g$na#h$na#i$na#j$na#k$na#l$na#m$na#n$na#o$na#q$na#s$na#u$na#v$na#y$na(S$na(c$na(j$na(k$na!V$na!W$na~OP$|aX$|ak$|az$|a!e$|a!f$|a!h$|a!l$|a#g$|a#h$|a#i$|a#j$|a#k$|a#l$|a#m$|a#n$|a#o$|a#q$|a#s$|a#u$|a#v$|a#y$|a(S$|a(c$|a!V$|a!W$|a~P%AWO#y$hq!V$hq!W$hq~P#ByO#y$iq!V$iq!W$iq~P#ByO!W8VO~O#y8WO~P!0dO!a#tO!V'[i!g'[i~O!a#tO(c'fO!V'[i!g'[i~O!V/UO!g(pq~O!S'^i!V'^i~P#,`O!V/^O!S(qq~O!S8^O~P#,`O!S8^O~Od(Qy!V(Qy~P!0dO!V'aa!X'aa~P#,`O^%Tq!X%Tq'l%Tq!V%Tq~P#,`OX8cO~O!V0aO!W(yq~O#X8gO!V'ca!W'ca~O!V4mO!W(vi~P#ByOPYXXYXkYXyYXzYX|YX!SYX!VYX!eYX!fYX!hYX!lYX#XYX#dcX#gYX#hYX#iYX#jYX#kYX#lYX#mYX#nYX#oYX#qYX#sYX#uYX#vYX#{YX(SYX(cYX(jYX(kYX~O!a%RX#o%RX~P&2WO!X0yO%a8kO~O'wTO'zUO(V8pO~O!V1UO!W(wq~O!g8sO~O!g8tO~O!g8uO~O!g8uO~P%TO#X8xO!V#ay!W#ay~O!V#ay!W#ay~P#ByO!X'UO%a8}O~O#y#wy!V#wy!W#wy~P#ByOP$uiX$uik$uiz$ui!e$ui!f$ui!h$ui!l$ui#g$ui#h$ui#i$ui#j$ui#k$ui#l$ui#m$ui#n$ui#o$ui#q$ui#s$ui#u$ui#v$ui#y$ui(S$ui(c$ui!V$ui!W$ui~P%AWOy)uO|)vO(k)zOP%XiX%Xig%Xik%Xiz%Xi!e%Xi!f%Xi!h%Xi!l%Xi#g%Xi#h%Xi#i%Xi#j%Xi#k%Xi#l%Xi#m%Xi#n%Xi#o%Xi#q%Xi#s%Xi#u%Xi#v%Xi#y%Xi(S%Xi(c%Xi(j%Xi!V%Xi!W%Xi~Oy)uO|)vOP%ZiX%Zig%Zik%Ziz%Zi!e%Zi!f%Zi!h%Zi!l%Zi#g%Zi#h%Zi#i%Zi#j%Zi#k%Zi#l%Zi#m%Zi#n%Zi#o%Zi#q%Zi#s%Zi#u%Zi#v%Zi#y%Zi(S%Zi(c%Zi(j%Zi(k%Zi!V%Zi!W%Zi~O#y$iy!V$iy!W$iy~P#ByO#y#[y!V#[y!W#[y~P#ByO!a#tO!V'[q!g'[q~O!V/UO!g(py~O!S'^q!V'^q~P#,`O!S9UO~P#,`O!V0aO!W(yy~O!V4mO!W(vq~O!X0yO%a9]O~O!g9`O~O!X'UO%a9eO~OP$uqX$uqk$uqz$uq!e$uq!f$uq!h$uq!l$uq#g$uq#h$uq#i$uq#j$uq#k$uq#l$uq#m$uq#n$uq#o$uq#q$uq#s$uq#u$uq#v$uq#y$uq(S$uq(c$uq!V$uq!W$uq~P%AWOP$wqX$wqk$wqz$wq!e$wq!f$wq!h$wq!l$wq#g$wq#h$wq#i$wq#j$wq#k$wq#l$wq#m$wq#n$wq#o$wq#q$wq#s$wq#u$wq#v$wq#y$wq(S$wq(c$wq!V$wq!W$wq~P%AWOd%]!Z!V%]!Z#X%]!Z#y%]!Z~P!0dO!V'cq!W'cq~P#ByO!V#a!Z!W#a!Z~P#ByO#d%]!ZP%]!ZX%]!Z^%]!Zk%]!Zz%]!Z!V%]!Z!e%]!Z!f%]!Z!h%]!Z!l%]!Z#g%]!Z#h%]!Z#i%]!Z#j%]!Z#k%]!Z#l%]!Z#m%]!Z#n%]!Z#o%]!Z#q%]!Z#s%]!Z#u%]!Z#v%]!Z'l%]!Z(S%]!Z(c%]!Z!g%]!Z!S%]!Z'j%]!Z#X%]!Zo%]!Z!X%]!Z%a%]!Z!a%]!Z~P#,`OP%]!ZX%]!Zk%]!Zz%]!Z!e%]!Z!f%]!Z!h%]!Z!l%]!Z#g%]!Z#h%]!Z#i%]!Z#j%]!Z#k%]!Z#l%]!Z#m%]!Z#n%]!Z#o%]!Z#q%]!Z#s%]!Z#u%]!Z#v%]!Z#y%]!Z(S%]!Z(c%]!Z!V%]!Z!W%]!Z~P%AWOo(WX~P1jO'v!kO~P!){O!ScX!VcX#XcX~P&2WOPYXXYXkYXyYXzYX|YX!VYX!VcX!eYX!fYX!hYX!lYX#XYX#XcX#dcX#gYX#hYX#iYX#jYX#kYX#lYX#mYX#nYX#oYX#qYX#sYX#uYX#vYX#{YX(SYX(cYX(jYX(kYX~O!acX!gYX!gcX(ccX~P&GnOP9pOQ9pOa;aOb!hOikOk9pOlkOmkOskOu9pOw9pO|WO!QkO!RkO!XXO!c9sO!hZO!k9pO!l9pO!m9pO!o9tO!q9wO!t!gO$Q!jO$UfO'u)TO'wTO'zUO(SVO(b[O(o;_O~O!V:UO!W$ka~Oi%ROk$sOl$rOm$rOs%SOu%TOw:[O|$zO!X${O!c;fO!h$wO#c:bO$Q%XO$m:^O$o:`O$r%YO'u(kO'wTO'zUO(O%QO(S$tO~O#p)[O~P&LdO!WYX!WcX~P&GnO#d9xO~O!a#tO#d9xO~O#X:YO~O#o9}O~O#X:dO!V(hX!W(hX~O#X:YO!V(fX!W(fX~O#d:eO~Od:gO~P!0dO#d:lO~O#d:mO~O!a#tO#d:nO~O!a#tO#d:eO~O#y:oO~P#ByO#d:pO~O#d:qO~O#d:rO~O#d:sO~O#d:tO~O#d:uO~O#y:vO~P!0dO#y:wO~P!0dO$U~!f!|!}#P#Q#T#b#c#n(o$m$o$r%U%`%a%b%i%k%n%o%q%s~'pR$U(o#h!R'n'v#il#g#jky'o(V'o'u$W$Y$W~",
  goto: "$&a(}PPPP)OP)RP)cP*r.uPPPP5UPP5kP;f>mP?QP?QPPP?QP@rP?QP?QP?QP@vPP@{PAfPF]PPPFaPPPPFaIaPPPIgJbPFaPLoPPPPN}FaPPPFaPFaP!#]FaP!&p!'r!'{P!(n!(r!(nPPPPP!+|!'rPP!,j!-dP!0WFaFa!0]!3f!7z!7z!;oPPP!;vFaPPPPPPPPPPP!?SP!@ePPFa!ArPFaPFaFaFaFaPFa!CUPP!F]P!I`P!Id!In!Ir!IrP!FYP!Iv!IvP!LyP!L}FaFa!MT#!V?QP?QP?Q?QP##a?Q?Q#%]?Q#'l?Q#)b?Q?Q#*O#+|#+|#,Q#,Y#+|#,bP#+|P?Q#,z?Q#.T?Q?Q5UPPP#/aPPP#/y#/yP#/yP#0`#/yPP#0fP#0]P#0]#0x#0]#1d#1j5R)R#1m)RP#1t#1t#1tP)RP)RP)RP)RPP)RP#1z#1}P#1})RP#2RP#2UP)RP)RP)RP)RP)RP)R)RPP#2[#2b#2l#2r#2x#3O#3U#3d#3j#3p#3z#4Q#4[#4k#4q#5b#5t#5z#6Q#6`#6u#8W#8f#8l#8r#8x#9O#9Y#9`#9f#9p#:S#:YPPPPPPPPPP#:`PPPPPPP#;S#>ZP#?j#?q#?yPPPP#DX#F}#Me#Mh#Mk#Nd#Ng#Nj#Nq#NyPP$ P$ T$ {$!z$#O$#dPP$#h$#n$#rP$#u$#y$#|$$r$%Y$%p$%t$%w$%z$&Q$&T$&X$&]R!zRmqOXs!Y#b%e&h&j&k&m,a,f1f1iY!tQ'U-R0y4tQ%kuQ%sxQ%z{Q&`!US&|!d,yQ'[!hS'b!q!wS*^${*cQ+_%tQ+l%|Q,Q&YQ-P'TQ-Z']Q-c'cQ/o*eQ1T,RR:c9t$|dOPWXYZstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$`$d%e%k%x&a&d&h&j&k&m&q&y'W'h'x'z(Q(X(m(q(u)t*w*{,^,a,f-V-_-m-s.a.h/y0O0`0|1^1_1a1c1f1i1k2[2b2v4q4{5]5^5a5t7Y7_7n7xS#o]9q!r)V$Z$l&})i,r,u.p1z3]4o5k8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;bQ*n%UQ+d%vQ,S&]Q,Z&eQ.W:ZQ0V+VQ0Z+XQ0f+eQ1],XQ2j.TQ4_0aQ5S1UQ6Q2nQ6W:[Q6y4`R8O6R&zkOPWXYZstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$Z$`$d$l%e%k%x&a&d&e&h&j&k&m&q&y&}'W'h'x'z(Q(X(m(q(u)i)t*w*{+V,^,a,f,r,u-V-_-m-s.T.a.h.p/y0O0`0|1^1_1a1c1f1i1k1z2[2b2n2v3]4o4q4{5]5^5a5k5t6R7Y7_7n7x8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;bt!mQ!q!t!w!x&|'T'U'b'c'd,y-P-R-c0y4t4v$^$ri#t#v$b$c$w$z%V%W%[)p)v)y){)|*T*Z*i*j+U+X+p+s.S.^/O/]/^/`/{0p0s0{2m3e3o3w3}4V4X4z6O6f6o7[7{8W8k8}9]9e:W:X:]:^:_:`:a:b:h:i:j:k:l:m:p:q:r:s:v:w;_;g;h;k;lQ%}{Q&z!dS'Q%a,|Q+d%vQ/z*rQ0f+eQ0k+kQ1[,WQ1],XQ4_0aQ4h0mQ5V1WQ5W1ZQ6y4`Q6|4eQ7g5YQ8f6}R8q7dpnOXs!U!Y#b%e&_&h&j&k&m,a,f1f1iR,U&a&t^OPXYstuvy!Y!_!f!i!n#Q#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$Z$`$d$l%e%k%x&a&d&e&h&j&k&m&q&y'W'h'z(Q(X(m(q(u)i)t*w*{+V,^,a,f,r,u-V-_-m-s.T.a.h.p/y0O0`0|1^1_1a1c1f1i1k1z2[2b2n2v3]4o4q4{5]5^5a5k5t6R7Y7_7n7x8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;a;b[#ZWZ#U#X&}'x!S%bm#f#g#j%]%`(R(](^(_*y*z*|,],s-q-w-x-y-{1n2f2g5j5{Q%nwQ%rxS%w{%|Q&T!SQ'X!gQ'Z!hQ(f#qS*Q$w*US+^%s%tQ+b%vQ+{&WQ,P&YS-Y'[']Q.V(gQ/Y*RQ0_+_Q0e+eQ0g+fQ0j+jQ1O+|S1S,Q,RQ2W-ZQ3f/UQ4^0aQ4b0dQ4g0lQ5R1TQ6c3gQ6x4`Q6{4dQ8b6wR9W8cv$yi#v%V%W%[)y){*T*i*j.^/]/{3e3}8W;_;g;h!S%px!h!s%r%s%t&{'Z'[']'a'k*]+^+_,v-Y-Z-b/g0_2P2W2_3yQ+W%nQ+q&QQ+t&RQ,O&YQ.U(fQ0}+{U1R,P,Q,RQ2o.VQ4|1OS5Q1S1TQ7c5R#O;c#t$b$c$w$z)p)v)|*Z+U+X+p+s.S/O/^/`0p0s0{2m3o3w4V4X4z6O6f6o7[7{8k8}9]9e:]:_:a:h:j:l:p:r:v;k;lg;d:W:X:^:`:b:i:k:m:q:s:wW%Oi%Q*k;_S&Q!P&_Q&R!QQ&S!RR+o&O$_$}i#t#v$b$c$w$z%V%W%[)p)v)y){)|*T*Z*i*j+U+X+p+s.S.^/O/]/^/`/{0p0s0{2m3e3o3w3}4V4X4z6O6f6o7[7{8W8k8}9]9e:W:X:]:^:_:`:a:b:h:i:j:k:l:m:p:q:r:s:v:w;_;g;h;k;lT)q$t)rV*o%U:Z:[U'Q!d%a,|S(t#x#yQ+i%yS.O(b(cQ0t+uQ4O/xR7R4m&zkOPWXYZstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$Z$`$d$l%e%k%x&a&d&e&h&j&k&m&q&y&}'W'h'x'z(Q(X(m(q(u)i)t*w*{+V,^,a,f,r,u-V-_-m-s.T.a.h.p/y0O0`0|1^1_1a1c1f1i1k1z2[2b2n2v3]4o4q4{5]5^5a5k5t6R7Y7_7n7x8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;b$i$_c#W#c%i%j%l'w'}(i(p(x(y(z({(|(})O)P)Q)R)S)U)X)])g+S+h,w-f-k-p-r.].c.g.i.j.k.z/|1u1x2Y2a2u2z2{2|2}3O3P3Q3R3S3T3U3V3W3Z3[3a4S4[5m5s5x6U6V6[6]7T7r7v8P8T8U8z9Y9a9r;UT#RV#S&{kOPWXYZstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$Z$`$d$l%e%k%x&a&d&e&h&j&k&m&q&y&}'W'h'x'z(Q(X(m(q(u)i)t*w*{+V,^,a,f,r,u-V-_-m-s.T.a.h.p/y0O0`0|1^1_1a1c1f1i1k1z2[2b2n2v3]4o4q4{5]5^5a5k5t6R7Y7_7n7x8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;bQ'O!dR1{,yv!mQ!d!q!t!w!x&|'T'U'b'c'd,y-P-R-c0y4t4vS*]${*cS/g*^*eQ/p*fQ0v+wQ3y/oR3|/rlqOXs!Y#b%e&h&j&k&m,a,f1f1iQ&o!]Q'l!vS(h#s9xQ+[%qQ+y&TQ+z&VQ-W'YQ-e'eS.[(m:eS/}*w:nQ0]+]Q0x+xQ1m,hQ1o,iQ1w,tQ2U-XQ2X-]S4T0O:tQ4Y0^S4]0`:uQ5l1yQ5p2VQ5u2^Q6v4ZQ7s5nQ7t5qQ7w5vR8w7p$d$^c#W#c%j%l'w'}(i(p(x(y(z({(|(})O)P)Q)R)S)U)X)])g+S+h,w-f-k-p-r.].c.g.j.k.z/|1u1x2Y2a2u2z2{2|2}3O3P3Q3R3S3T3U3V3W3Z3[3a4S4[5m5s5x6U6V6[6]7T7r7v8P8T8U8z9Y9a9r;US(e#n'_U*h$|(l3YS+R%i.iQ2k0VQ5}2jQ7}6QR9O8O$d$]c#W#c%j%l'w'}(i(p(x(y(z({(|(})O)P)Q)R)S)U)X)])g+S+h,w-f-k-p-r.].c.g.j.k.z/|1u1x2Y2a2u2z2{2|2}3O3P3Q3R3S3T3U3V3W3Z3[3a4S4[5m5s5x6U6V6[6]7T7r7v8P8T8U8z9Y9a9r;US(d#n'_S(v#y$^S+Q%i.iS.P(c(eQ.l)WQ0S+RR2h.Q&zkOPWXYZstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$Z$`$d$l%e%k%x&a&d&e&h&j&k&m&q&y&}'W'h'x'z(Q(X(m(q(u)i)t*w*{+V,^,a,f,r,u-V-_-m-s.T.a.h.p/y0O0`0|1^1_1a1c1f1i1k1z2[2b2n2v3]4o4q4{5]5^5a5k5t6R7Y7_7n7x8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;bS#o]9qQ&j!WQ&k!XQ&m!ZQ&n![R1e,dQ'V!gQ+T%nQ-U'XS.R(f+WQ2S-TW2l.U.V0U0WQ5o2TU5|2i2k2oS7z5}6PS8|7|7}S9c8{9OQ9k9dR9n9lU!uQ'U-RT4r0y4t!O_OXZ`s!U!Y#b#f%]%e&_&a&h&j&k&m(_,a,f-x1f1i]!oQ!q'U-R0y4tT#o]9q%WzOPWXYZstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$`$d%e%k%x&a&d&e&h&j&k&m&q&y'W'h'x'z(Q(X(m(q(u)t*w*{+V,^,a,f-V-_-m-s.T.a.h/y0O0`0|1^1_1a1c1f1i1k2[2b2n2v4q4{5]5^5a5t6R7Y7_7n7xS(t#x#yS.O(b(c!s:{$Z$l&})i,r,u.p1z3]4o5k8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;bY!sQ'U-R0y4tQ'a!qS'k!t!wS'm!x4vS-b'b'cQ-d'dR2_-cQ'j!sS(Z#e1`S-a'a'mQ/X*QQ/e*]Q2`-dQ3k/YS3t/f/pQ6b3fS6m3z3|Q8Y6cR8a6pQ#ubQ'i!sS(Y#e1`S([#k*vQ*x%^Q+Y%oQ+`%uU-`'a'j'mQ-t(ZQ/W*QQ/d*]Q/j*`Q0[+ZQ1P+}S2]-a-dQ2e-|S3j/X/YS3s/e/pQ3v/iQ3x/kQ5O1QQ5w2`Q6a3fQ6e3kS6i3t3|Q6n3{Q7a5PS8X6b6cQ8]6jQ8_6mQ8n7bQ9S8YQ9T8^Q9V8aQ9_8oQ9g9UQ;O:yQ;Z;SR;[;TV!uQ'U-R%WaOPWXYZstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$`$d%e%k%x&a&d&e&h&j&k&m&q&y'W'h'x'z(Q(X(m(q(u)t*w*{+V,^,a,f-V-_-m-s.T.a.h/y0O0`0|1^1_1a1c1f1i1k2[2b2n2v4q4{5]5^5a5t6R7Y7_7n7xS#uy!i!r:x$Z$l&})i,r,u.p1z3]4o5k8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;bR;O;a%WbOPWXYZstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$`$d%e%k%x&a&d&e&h&j&k&m&q&y'W'h'x'z(Q(X(m(q(u)t*w*{+V,^,a,f-V-_-m-s.T.a.h/y0O0`0|1^1_1a1c1f1i1k2[2b2n2v4q4{5]5^5a5t6R7Y7_7n7xQ%^j!S%ox!h!s%r%s%t&{'Z'[']'a'k*]+^+_,v-Y-Z-b/g0_2P2W2_3yS%uy!iQ+Z%pQ+}&YW1Q,O,P,Q,RU5P1R1S1TS7b5Q5RQ8o7c!r:y$Z$l&})i,r,u.p1z3]4o5k8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;bQ;S;`R;T;a$zeOPXYstuv!Y!_!f!n#Q#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$`$d%e%k%x&a&d&h&j&k&m&q&y'W'h'z(Q(X(m(q(u)t*w*{+V,^,a,f-V-_-m-s.T.a.h/y0O0`0|1^1_1a1c1f1i1k2[2b2n2v4q4{5]5^5a5t6R7Y7_7n7xY#`WZ#U#X'x!S%bm#f#g#j%]%`(R(](^(_*y*z*|,],s-q-w-x-y-{1n2f2g5j5{Q,[&e!p:z$Z$l)i,r,u.p1z3]4o5k8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;bR:}&}S'R!d%aR1},|$|dOPWXYZstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$`$d%e%k%x&a&d&h&j&k&m&q&y'W'h'x'z(Q(X(m(q(u)t*w*{,^,a,f-V-_-m-s.a.h/y0O0`0|1^1_1a1c1f1i1k2[2b2v4q4{5]5^5a5t7Y7_7n7x!r)V$Z$l&})i,r,u.p1z3]4o5k8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;bQ,Z&eQ0V+VQ2j.TQ6Q2nR8O6R!f$Tc#W%i'w'}(i(p)P)Q)R)S)X)]+h-f-k-p-r.].c.z/|2Y2a2u3W4S4[5s5x6U7v8z9r!T:P)U)g,w.i1u1x2z3S3T3U3V3Z3a5m6V6[6]7T7r8P8T8U9Y9a;U!b$Vc#W%i'w'}(i(p)R)S)X)]+h-f-k-p-r.].c.z/|2Y2a2u3W4S4[5s5x6U7v8z9r!P:R)U)g,w.i1u1x2z3U3V3Z3a5m6V6[6]7T7r8P8T8U9Y9a;U!^$Zc#W%i'w'}(i(p)X)]+h-f-k-p-r.].c.z/|2Y2a2u3W4S4[5s5x6U7v8z9rQ3e/Sz;b)U)g,w.i1u1x2z3Z3a5m6V6[6]7T7r8P8T8U9Y9a;UQ;g;iR;h;j&zkOPWXYZstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$Z$`$d$l%e%k%x&a&d&e&h&j&k&m&q&y&}'W'h'x'z(Q(X(m(q(u)i)t*w*{+V,^,a,f,r,u-V-_-m-s.T.a.h.p/y0O0`0|1^1_1a1c1f1i1k1z2[2b2n2v3]4o4q4{5]5^5a5k5t6R7Y7_7n7x8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;bS$mh$nR3^.o'RgOPWXYZhstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$Z$`$d$l$n%e%k%x&a&d&e&h&j&k&m&q&y&}'W'h'x'z(Q(X(m(q(u)i)t*w*{+V,^,a,f,r,u-V-_-m-s.T.a.h.o.p/y0O0`0|1^1_1a1c1f1i1k1z2[2b2n2v3]4o4q4{5]5^5a5k5t6R7Y7_7n7x8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;bT$if$oQ$gfS)`$j)dR)l$oT$hf$oT)b$j)d'RhOPWXYZhstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$Z$`$d$l$n%e%k%x&a&d&e&h&j&k&m&q&y&}'W'h'x'z(Q(X(m(q(u)i)t*w*{+V,^,a,f,r,u-V-_-m-s.T.a.h.o.p/y0O0`0|1^1_1a1c1f1i1k1z2[2b2n2v3]4o4q4{5]5^5a5k5t6R7Y7_7n7x8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;bT$mh$nQ$phR)k$n%WjOPWXYZstuv!Y!_!f!n#Q#U#X#b#m#s#w#z#}$O$P$Q$R$S$T$U$V$W$X$`$d%e%k%x&a&d&e&h&j&k&m&q&y'W'h'x'z(Q(X(m(q(u)t*w*{+V,^,a,f-V-_-m-s.T.a.h/y0O0`0|1^1_1a1c1f1i1k2[2b2n2v4q4{5]5^5a5t6R7Y7_7n7x!s;`$Z$l&})i,r,u.p1z3]4o5k8g8x9p9s9t9w9x9y9z9{9|9}:O:P:Q:R:S:T:U:Y:c:d:e:g:n:o:t:u;b#alOPXZs!Y!_!n#Q#b#m#z$l%e&a&d&e&h&j&k&m&q&y'W(u)i*{+V,^,a,f-V.T.p/y0|1^1_1a1c1f1i1k2n3]4q4{5]5^5a6R7Y7_7nv$|i#v%V%W%[)y){*T*i*j.^/]/{3e3}8W;_;g;h#O(l#t$b$c$w$z)p)v)|*Z+U+X+p+s.S/O/^/`0p0s0{2m3o3w4V4X4z6O6f6o7[7{8k8}9]9e:]:_:a:h:j:l:p:r:v;k;lQ*s%YQ.{)ug3Y:W:X:^:`:b:i:k:m:q:s:wv$xi#v%V%W%[)y){*T*i*j.^/]/{3e3}8W;_;g;hQ*V$yS*`${*cQ*t%ZQ/k*a#O;Q#t$b$c$w$z)p)v)|*Z+U+X+p+s.S/O/^/`0p0s0{2m3o3w4V4X4z6O6f6o7[7{8k8}9]9e:]:_:a:h:j:l:p:r:v;k;lf;R:W:X:^:`:b:i:k:m:q:s:wQ;V;cQ;W;dQ;X;eR;Y;fv$|i#v%V%W%[)y){*T*i*j.^/]/{3e3}8W;_;g;h#O(l#t$b$c$w$z)p)v)|*Z+U+X+p+s.S/O/^/`0p0s0{2m3o3w4V4X4z6O6f6o7[7{8k8}9]9e:]:_:a:h:j:l:p:r:v;k;lg3Y:W:X:^:`:b:i:k:m:q:s:wloOXs!Y#b%e&h&j&k&m,a,f1f1iQ*Y$zQ,o&tQ,p&vR3n/^$^$}i#t#v$b$c$w$z%V%W%[)p)v)y){)|*T*Z*i*j+U+X+p+s.S.^/O/]/^/`/{0p0s0{2m3e3o3w3}4V4X4z6O6f6o7[7{8W8k8}9]9e:W:X:]:^:_:`:a:b:h:i:j:k:l:m:p:q:r:s:v:w;_;g;h;k;lQ+r&RQ0r+tQ4k0qR7Q4lT*b${*cS*b${*cT4s0y4tS/i*_4qT3{/q7YQ+Y%oQ/j*`Q0[+ZQ1P+}Q5O1QQ7a5PQ8n7bR9_8on)y$u(n*u/[/s/t2s3l4R6`6q9R;P;];^!Y:h(j)Z*P*X.Z.w.|/S/a0T0o0q2r3m3q4j4l6S6T6g6k6s6u8[8`9f;i;j]:i3X6Z8Q9P9Q9op){$u(n*u/Q/[/s/t2s3l4R6`6q9R;P;];^![:j(j)Z*P*X.Z.w.|/S/a0T0o0q2p2r3m3q4j4l6S6T6g6k6s6u8[8`9f;i;j_:k3X6Z8Q8R9P9Q9opnOXs!U!Y#b%e&_&h&j&k&m,a,f1f1iQ&[!TR,^&epnOXs!U!Y#b%e&_&h&j&k&m,a,f1f1iR&[!TQ+v&SR0n+oqnOXs!U!Y#b%e&_&h&j&k&m,a,f1f1iQ0z+{S4y0}1OU7Z4w4x4|S8j7]7^S9Z8i8lQ9h9[R9m9iQ&c!UR,V&_R5V1WS%w{%|R0g+fQ&h!VR,a&iR,g&nT1g,f1iR,k&oQ,j&oR1p,kQ'o!yR-g'oQsOQ#bXT%hs#bQ!|TR'q!|Q#PUR's#PQ)r$tR.x)rQ#SVR'u#SQ#VWU'{#V'|-nQ'|#WR-n'}Q,z'OR1|,zQ._(nR2t._Q.b(pS2w.b2xR2x.cQ-R'UR2Q-RY!qQ'U-R0y4tR'`!qS#]W%`U(S#](T-oQ(T#^R-o(OQ,}'RR2O,}r`OXs!U!Y#b%e&_&a&h&j&k&m,a,f1f1iS#fZ%]U#p`#f-xR-x(_Q(`#hQ-u([W-}(`-u2c5yQ2c-vR5y2dQ)d$jR.q)dQ$nhR)j$nQ$acU)Y$a-j:VQ-j9rR:V)gQ/V*QW3h/V3i6d8ZU3i/W/X/YS6d3j3kR8Z6e#o)w$u(j(n)Z*P*X*p*q*u.X.Y.Z.w.|/Q/R/S/[/a/s/t0T0o0q2p2q2r2s3X3l3m3q4R4j4l6S6T6X6Y6Z6`6g6k6q6s6u8Q8R8S8[8`9P9Q9R9f9o;P;];^;i;jQ/_*XU3p/_3r6hQ3r/aR6h3qQ*c${R/m*cQ*l%PR/v*lQ4W0TR6t4WQ*}%cR0R*}Q4n0tS7S4n8hR8h7TQ+x&TR0w+xQ4t0yR7W4tQ1V,SS5T1V7eR7e5VQ0b+bW4a0b4c6z8dQ4c0eQ6z4bR8d6{Q+g%wR0h+gQ1i,fR5e1iWrOXs#bQ&l!YQ+P%eQ,`&hQ,b&jQ,c&kQ,e&mQ1d,aS1g,f1iR5d1fQ%gpQ&p!^Q&s!`Q&u!aQ&w!bQ'g!sQ+O%dQ+[%qQ+n%}Q,U&cQ,m&rW-^'a'i'j'mQ-e'eQ/l*bQ0]+]S1Y,V,YQ1q,lQ1r,oQ1s,pQ2X-]W2Z-`-a-d-fQ4Y0^Q4f0kQ4i0oQ4}1PQ5X1[Q5c1eU5r2Y2]2`Q5u2^Q6v4ZQ7O4hQ7P4jQ7V4sQ7`5OQ7f5WS7u5s5wQ7w5vQ8e6|Q8m7aQ8r7gQ8y7vQ9X8fQ9^8nQ9b8zR9j9_Q%qxQ'Y!hQ'e!sU+]%r%s%tQ,t&{U-X'Z'[']S-]'a'kQ/c*]S0^+^+_Q1y,vS2V-Y-ZQ2^-bQ3u/gQ4Z0_Q5n2PQ5q2WQ5v2_R6l3yS$vi;_R*m%QU%Pi%Q;_R/u*kQ$uiS(j#t+XQ(n#vS)Z$b$cQ*P$wQ*X$zQ*p%VQ*q%WQ*u%[Q.X:]Q.Y:_Q.Z:aQ.w)pS.|)v/OQ/Q)yQ/R){Q/S)|Q/[*TQ/a*ZQ/s*iQ/t*jh0T+U.S0{2m4z6O7[7{8k8}9]9eQ0o+pQ0q+sQ2p:hQ2q:jQ2r:lQ2s.^S3X:W:XQ3l/]Q3m/^Q3q/`Q4R/{Q4j0pQ4l0sQ6S:pQ6T:rQ6X:^Q6Y:`Q6Z:bQ6`3eQ6g3oQ6k3wQ6q3}Q6s4VQ6u4XQ8Q:mQ8R:iQ8S:kQ8[6fQ8`6oQ9P:qQ9Q:sQ9R8WQ9f:vQ9o:wQ;P;_Q;];gQ;^;hQ;i;kR;j;llpOXs!Y#b%e&h&j&k&m,a,f1f1iQ!ePS#dZ#mQ&r!_U'^!n4q7YQ't#QQ(w#zQ)h$lS,Y&a&dQ,_&eQ,l&qQ,q&yQ-T'WQ.e(uQ.u)iQ0P*{Q0W+VQ1b,^Q2T-VQ2k.TQ3`.pQ4P/yQ4x0|Q5Z1^Q5[1_Q5`1aQ5b1cQ5g1kQ5}2nQ6^3]Q7^4{Q7j5]Q7k5^Q7m5aQ7}6RQ8l7_R8v7n#UcOPXZs!Y!_!n#b#m#z%e&a&d&e&h&j&k&m&q&y'W(u*{+V,^,a,f-V.T/y0|1^1_1a1c1f1i1k2n4q4{5]5^5a6R7Y7_7nQ#WWQ#cYQ%itQ%juS%lv!fS'w#U'zQ'}#XQ(i#sQ(p#wQ(x#}Q(y$OQ(z$PQ({$QQ(|$RQ(}$SQ)O$TQ)P$UQ)Q$VQ)R$WQ)S$XQ)U$ZQ)X$`Q)]$dW)g$l)i.p3]Q+S%kQ+h%xS,w&}1zQ-f'hS-k'x-mQ-p(QQ-r(XQ.](mQ.c(qQ.g9pQ.i9sQ.j9tQ.k9wQ.z)tQ/|*wQ1u,rQ1x,uQ2Y-_Q2a-sQ2u.aQ2z9xQ2{9yQ2|9zQ2}9{Q3O9|Q3P9}Q3Q:OQ3R:PQ3S:QQ3T:RQ3U:SQ3V:TQ3W.hQ3Z:YQ3[:cQ3a:UQ4S0OQ4[0`Q5m:dQ5s2[Q5x2bQ6U2vQ6V:eQ6[:gQ6]:nQ7T4oQ7r5kQ7v5tQ8P:oQ8T:tQ8U:uQ8z7xQ9Y8gQ9a8xQ9r#QR;U;bR#YWR'P!dY!sQ'U-R0y4tS&{!d,yQ'a!qS'k!t!wS'm!x4vS,v&|'TS-b'b'cQ-d'dQ2P-PR2_-cR(o#vR(r#wQ!eQT-Q'U-R]!pQ!q'U-R0y4tQ#n]R'_9qT#iZ%]S#hZ%]S%cm,]U([#f#g#jS-v(](^Q-z(_Q0Q*|Q2d-wU2e-x-y-{S5z2f2gR7y5{`#[W#U#X%`'x(R*y-qr#eZm#f#g#j%](](^(_*|-w-x-y-{2f2g5{Q1`,]Q1v,sQ5i1nQ7q5jT:|&}*zT#_W%`S#^W%`S'y#U(RS(O#X*yS,x&}*zT-l'x-qT'S!d%aQ$jfR)n$oT)c$j)dR3_.oT*S$w*UR*[$zQ0U+UQ2i.SQ4w0{Q6P2mQ7]4zQ7|6OQ8i7[Q8{7{Q9[8kQ9d8}Q9i9]R9l9elqOXs!Y#b%e&h&j&k&m,a,f1f1iQ&b!UR,U&_rmOXs!T!U!Y#b%e&_&h&j&k&m,a,f1f1iR,]&eT%dm,]R0u+uR,T&]Q%{{R+m%|R+c%vT&f!V&iT&g!V&iT1h,f1i",
  nodeNames: "\u26A0 ArithOp ArithOp LineComment BlockComment Script ExportDeclaration export Star as VariableName String Escape from ; default FunctionDeclaration async function VariableDefinition > TypeParamList TypeDefinition extends ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation InterpolationStart NullType null VoidType void TypeofType typeof MemberExpression . ?. PropertyName [ TemplateString Escape Interpolation super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewExpression new TypeArgList CompareOp < ) ( ArgList UnaryExpression delete LogicOp BitOp YieldExpression yield AwaitExpression await ParenthesizedExpression ClassExpression class ClassBody MethodDeclaration Decorator @ MemberExpression PrivatePropertyName CallExpression declare Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly accessor Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof satisfies in const CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXStartTag JSXSelfClosingTag JSXIdentifier JSXBuiltin JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast ArrowFunction TypeParamList SequenceExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature PropertyDefinition CallSignature TypePredicate is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var using TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement SingleExpression SingleClassItem",
  maxTerm: 366,
  context: trackNewline,
  nodeProps: [
    ["group", -26, 6, 14, 16, 62, 199, 203, 207, 208, 210, 213, 216, 226, 228, 234, 236, 238, 240, 243, 249, 255, 257, 259, 261, 263, 265, 266, "Statement", -32, 10, 11, 25, 28, 29, 35, 45, 48, 49, 51, 56, 64, 72, 76, 78, 80, 81, 103, 104, 113, 114, 131, 134, 136, 137, 138, 139, 141, 142, 162, 163, 165, "Expression", -23, 24, 26, 30, 34, 36, 38, 166, 168, 170, 171, 173, 174, 175, 177, 178, 179, 181, 182, 183, 193, 195, 197, 198, "Type", -3, 84, 96, 102, "ClassItem"],
    ["openedBy", 31, "InterpolationStart", 50, "[", 54, "{", 69, "(", 143, "JSXStartTag", 155, "JSXStartTag JSXStartCloseTag"],
    ["closedBy", 33, "InterpolationEnd", 44, "]", 55, "}", 70, ")", 144, "JSXSelfCloseEndTag JSXEndTag", 160, "JSXEndTag"]
  ],
  propSources: [jsHighlight],
  skippedNodes: [0, 3, 4, 269],
  repeatNodeCount: 33,
  tokenData: "$>y(CSR!bOX%ZXY+gYZ-yZ[+g[]%Z]^.c^p%Zpq+gqr/mrs3cst:_tu>PuvBavwDxwxGgxyMvyz! Qz{!![{|!%O|}!&]}!O!%O!O!P!'g!P!Q!1w!Q!R#0t!R![#3T![!]#@T!]!^#Aa!^!_#Bk!_!`#GS!`!a#In!a!b#N{!b!c$$z!c!}>P!}#O$&U#O#P$'`#P#Q$,w#Q#R$.R#R#S>P#S#T$/`#T#o$0j#o#p$4z#p#q$5p#q#r$7Q#r#s$8^#s$f%Z$f$g+g$g#BY>P#BY#BZ$9h#BZ$IS>P$IS$I_$9h$I_$I|>P$I|$I}$<s$I}$JO$<s$JO$JT>P$JT$JU$9h$JU$KV>P$KV$KW$9h$KW&FU>P&FU&FV$9h&FV;'S>P;'S;=`BZ<%l?HT>P?HT?HU$9h?HUO>P(n%d_$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&j&hT$d&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c&j&zP;=`<%l&c'|'U]$d&j'{!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!b(SU'{!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!b(iP;=`<%l'}'|(oP;=`<%l&}'[(y]$d&j'xpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rp)wU'xpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)rp*^P;=`<%l)r'[*dP;=`<%l(r#S*nX'xp'{!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g#S+^P;=`<%l*g(n+dP;=`<%l%Z(CS+rq$d&j'xp'{!b'n(;dOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p$f%Z$f$g+g$g#BY%Z#BY#BZ+g#BZ$IS%Z$IS$I_+g$I_$JT%Z$JT$JU+g$JU$KV%Z$KV$KW+g$KW&FU%Z&FU&FV+g&FV;'S%Z;'S;=`+a<%l?HT%Z?HT?HU+g?HUO%Z(CS.ST'y#S$d&j'o(;dO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c(CS.n_$d&j'xp'{!b'o(;dOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#`/x`$d&j!l$Ip'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S1V`#q$Id$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`2X!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S2d_#q$Id$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$2b3l_'w$(n$d&j'{!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k*r4r_$d&j'{!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k)`5vX$d&jOr5qrs6cs!^5q!^!_6y!_#o5q#o#p6y#p;'S5q;'S;=`7h<%lO5q)`6jT$_#t$d&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#t6|TOr6yrs7]s;'S6y;'S;=`7b<%lO6y#t7bO$_#t#t7eP;=`<%l6y)`7kP;=`<%l5q*r7w]$_#t$d&j'{!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}%W8uZ'{!bOY8pYZ6yZr8prs9hsw8pwx6yx#O8p#O#P6y#P;'S8p;'S;=`:R<%lO8p%W9oU$_#t'{!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}%W:UP;=`<%l8p*r:[P;=`<%l4k#%|:hg$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}st%Ztu<Puw%Zwx(rx!^%Z!^!_*g!_!c%Z!c!}<P!}#O%Z#O#P&c#P#R%Z#R#S<P#S#T%Z#T#o<P#o#p*g#p$g%Z$g;'S<P;'S;=`=y<%lO<P#%|<[i$d&j(b!L^'xp'{!bOY%ZYZ&cZr%Zrs&}st%Ztu<Puw%Zwx(rx!Q%Z!Q![<P![!^%Z!^!_*g!_!c%Z!c!}<P!}#O%Z#O#P&c#P#R%Z#R#S<P#S#T%Z#T#o<P#o#p*g#p$g%Z$g;'S<P;'S;=`=y<%lO<P#%|=|P;=`<%l<P(CS>`k$d&j'xp'{!b(V!LY'u&;d$W#tOY%ZYZ&cZr%Zrs&}st%Ztu>Puw%Zwx(rx}%Z}!O@T!O!Q%Z!Q![>P![!^%Z!^!_*g!_!c%Z!c!}>P!}#O%Z#O#P&c#P#R%Z#R#S>P#S#T%Z#T#o>P#o#p*g#p$g%Z$g;'S>P;'S;=`BZ<%lO>P+d@`k$d&j'xp'{!b$W#tOY%ZYZ&cZr%Zrs&}st%Ztu@Tuw%Zwx(rx}%Z}!O@T!O!Q%Z!Q![@T![!^%Z!^!_*g!_!c%Z!c!}@T!}#O%Z#O#P&c#P#R%Z#R#S@T#S#T%Z#T#o@T#o#p*g#p$g%Z$g;'S@T;'S;=`BT<%lO@T+dBWP;=`<%l@T(CSB^P;=`<%l>P%#SBl`$d&j'xp'{!b#i$IdOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Cn!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#SCy_$d&j#{$Id'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%DfETa(k%<v$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sv%ZvwFYwx(rx!^%Z!^!_*g!_!`Cn!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#SFe`$d&j#u$Id'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Cn!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$2bGp_'z$)`$d&j'xpOYHoYZIuZrHorsIuswHowxKVx!^Ho!^!_LX!_#OHo#O#PIu#P#oHo#o#pLX#p;'SHo;'S;=`Mp<%lOHo*QHv_$d&j'xpOYHoYZIuZrHorsIuswHowxKVx!^Ho!^!_LX!_#OHo#O#PIu#P#oHo#o#pLX#p;'SHo;'S;=`Mp<%lOHo)`IzX$d&jOwIuwx6cx!^Iu!^!_Jg!_#oIu#o#pJg#p;'SIu;'S;=`KP<%lOIu#tJjTOwJgwx7]x;'SJg;'S;=`Jy<%lOJg#tJ|P;=`<%lJg)`KSP;=`<%lIu*QK`]$_#t$d&j'xpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r$fL^Z'xpOYLXYZJgZrLXrsJgswLXwxMPx#OLX#O#PJg#P;'SLX;'S;=`Mj<%lOLX$fMWU$_#t'xpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)r$fMmP;=`<%lLX*QMsP;=`<%lHo(*QNR_!h(!b$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z!'l! ]_!gM|$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'+h!!ib$d&j'xp'{!b'v#)d#j$IdOY%ZYZ&cZr%Zrs&}sw%Zwx(rxz%Zz{!#q{!^%Z!^!_*g!_!`Cn!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S!#|`$d&j'xp'{!b#g$IdOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Cn!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&-O!%Z`$d&j'xp'{!bk&%`OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Cn!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&C[!&h_!V&;l$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS!'rc$d&j'xp'{!by'<nOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!(}!P!Q%Z!Q![!+g![!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z!'d!)Wa$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!*]!P!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z!'d!*h_!UMt$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l!+rg$d&j'xp'{!bl$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!+g![!^%Z!^!_*g!_!g%Z!g!h!-Z!h#O%Z#O#P&c#P#R%Z#R#S!+g#S#X%Z#X#Y!-Z#Y#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l!-dg$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx{%Z{|!.{|}%Z}!O!.{!O!Q%Z!Q![!0a![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!0a#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l!/Uc$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!0a![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!0a#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l!0lc$d&j'xp'{!bl$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!0a![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!0a#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS!2Sf$d&j'xp'{!b#h$IdOY!3hYZ&cZr!3hrs!4{sw!3hwx!C}xz!3hz{#$s{!P!3h!P!Q#&Y!Q!^!3h!^!_!Mh!_!`#-x!`!a#/_!a!}!3h!}#O##[#O#P!<w#P#o!3h#o#p!Mh#p;'S!3h;'S;=`#$m<%lO!3h(r!3sb$d&j'xp'{!b!RSOY!3hYZ&cZr!3hrs!4{sw!3hwx!C}x!P!3h!P!Q!Kh!Q!^!3h!^!_!Mh!_!}!3h!}#O##[#O#P!<w#P#o!3h#o#p!Mh#p;'S!3h;'S;=`#$m<%lO!3h(Q!5U`$d&j'{!b!RSOY!4{YZ&cZw!4{wx!6Wx!P!4{!P!Q!=o!Q!^!4{!^!_!?g!_!}!4{!}#O!Bn#O#P!<w#P#o!4{#o#p!?g#p;'S!4{;'S;=`!Cw<%lO!4{&n!6_^$d&j!RSOY!6WYZ&cZ!P!6W!P!Q!7Z!Q!^!6W!^!_!8g!_!}!6W!}#O!;U#O#P!<w#P#o!6W#o#p!8g#p;'S!6W;'S;=`!=i<%lO!6W&n!7ba$d&j!RSO!^&c!_#Z&c#Z#[!7Z#[#]&c#]#^!7Z#^#a&c#a#b!7Z#b#g&c#g#h!7Z#h#i&c#i#j!7Z#j#m&c#m#n!7Z#n#o&c#p;'S&c;'S;=`&w<%lO&cS!8lX!RSOY!8gZ!P!8g!P!Q!9X!Q!}!8g!}#O!9p#O#P!:o#P;'S!8g;'S;=`!;O<%lO!8gS!9^U!RS#Z#[!9X#]#^!9X#a#b!9X#g#h!9X#i#j!9X#m#n!9XS!9sVOY!9pZ#O!9p#O#P!:Y#P#Q!8g#Q;'S!9p;'S;=`!:i<%lO!9pS!:]SOY!9pZ;'S!9p;'S;=`!:i<%lO!9pS!:lP;=`<%l!9pS!:rSOY!8gZ;'S!8g;'S;=`!;O<%lO!8gS!;RP;=`<%l!8g&n!;Z[$d&jOY!;UYZ&cZ!^!;U!^!_!9p!_#O!;U#O#P!<P#P#Q!6W#Q#o!;U#o#p!9p#p;'S!;U;'S;=`!<q<%lO!;U&n!<UX$d&jOY!;UYZ&cZ!^!;U!^!_!9p!_#o!;U#o#p!9p#p;'S!;U;'S;=`!<q<%lO!;U&n!<tP;=`<%l!;U&n!<|X$d&jOY!6WYZ&cZ!^!6W!^!_!8g!_#o!6W#o#p!8g#p;'S!6W;'S;=`!=i<%lO!6W&n!=lP;=`<%l!6W(Q!=xi$d&j'{!b!RSOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#Z&}#Z#[!=o#[#]&}#]#^!=o#^#a&}#a#b!=o#b#g&}#g#h!=o#h#i&}#i#j!=o#j#m&}#m#n!=o#n#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!f!?nZ'{!b!RSOY!?gZw!?gwx!8gx!P!?g!P!Q!@a!Q!}!?g!}#O!Ap#O#P!:o#P;'S!?g;'S;=`!Bh<%lO!?g!f!@hb'{!b!RSOY'}Zw'}x#O'}#P#Z'}#Z#[!@a#[#]'}#]#^!@a#^#a'}#a#b!@a#b#g'}#g#h!@a#h#i'}#i#j!@a#j#m'}#m#n!@a#n;'S'};'S;=`(f<%lO'}!f!AuX'{!bOY!ApZw!Apwx!9px#O!Ap#O#P!:Y#P#Q!?g#Q;'S!Ap;'S;=`!Bb<%lO!Ap!f!BeP;=`<%l!Ap!f!BkP;=`<%l!?g(Q!Bu^$d&j'{!bOY!BnYZ&cZw!Bnwx!;Ux!^!Bn!^!_!Ap!_#O!Bn#O#P!<P#P#Q!4{#Q#o!Bn#o#p!Ap#p;'S!Bn;'S;=`!Cq<%lO!Bn(Q!CtP;=`<%l!Bn(Q!CzP;=`<%l!4{'`!DW`$d&j'xp!RSOY!C}YZ&cZr!C}rs!6Ws!P!C}!P!Q!EY!Q!^!C}!^!_!GQ!_!}!C}!}#O!JX#O#P!<w#P#o!C}#o#p!GQ#p;'S!C};'S;=`!Kb<%lO!C}'`!Eci$d&j'xp!RSOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#Z(r#Z#[!EY#[#](r#]#^!EY#^#a(r#a#b!EY#b#g(r#g#h!EY#h#i(r#i#j!EY#j#m(r#m#n!EY#n#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rt!GXZ'xp!RSOY!GQZr!GQrs!8gs!P!GQ!P!Q!Gz!Q!}!GQ!}#O!IZ#O#P!:o#P;'S!GQ;'S;=`!JR<%lO!GQt!HRb'xp!RSOY)rZr)rs#O)r#P#Z)r#Z#[!Gz#[#])r#]#^!Gz#^#a)r#a#b!Gz#b#g)r#g#h!Gz#h#i)r#i#j!Gz#j#m)r#m#n!Gz#n;'S)r;'S;=`*Z<%lO)rt!I`X'xpOY!IZZr!IZrs!9ps#O!IZ#O#P!:Y#P#Q!GQ#Q;'S!IZ;'S;=`!I{<%lO!IZt!JOP;=`<%l!IZt!JUP;=`<%l!GQ'`!J`^$d&j'xpOY!JXYZ&cZr!JXrs!;Us!^!JX!^!_!IZ!_#O!JX#O#P!<P#P#Q!C}#Q#o!JX#o#p!IZ#p;'S!JX;'S;=`!K[<%lO!JX'`!K_P;=`<%l!JX'`!KeP;=`<%l!C}(r!Ksk$d&j'xp'{!b!RSOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#Z%Z#Z#[!Kh#[#]%Z#]#^!Kh#^#a%Z#a#b!Kh#b#g%Z#g#h!Kh#h#i%Z#i#j!Kh#j#m%Z#m#n!Kh#n#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#W!Mq]'xp'{!b!RSOY!MhZr!Mhrs!?gsw!Mhwx!GQx!P!Mh!P!Q!Nj!Q!}!Mh!}#O#!U#O#P!:o#P;'S!Mh;'S;=`##U<%lO!Mh#W!Nse'xp'{!b!RSOY*gZr*grs'}sw*gwx)rx#O*g#P#Z*g#Z#[!Nj#[#]*g#]#^!Nj#^#a*g#a#b!Nj#b#g*g#g#h!Nj#h#i*g#i#j!Nj#j#m*g#m#n!Nj#n;'S*g;'S;=`+Z<%lO*g#W#!]Z'xp'{!bOY#!UZr#!Urs!Apsw#!Uwx!IZx#O#!U#O#P!:Y#P#Q!Mh#Q;'S#!U;'S;=`##O<%lO#!U#W##RP;=`<%l#!U#W##XP;=`<%l!Mh(r##e`$d&j'xp'{!bOY##[YZ&cZr##[rs!Bnsw##[wx!JXx!^##[!^!_#!U!_#O##[#O#P!<P#P#Q!3h#Q#o##[#o#p#!U#p;'S##[;'S;=`#$g<%lO##[(r#$jP;=`<%l##[(r#$pP;=`<%l!3h(CS#%Qb$d&j'xp'{!b'p(;d!RSOY!3hYZ&cZr!3hrs!4{sw!3hwx!C}x!P!3h!P!Q!Kh!Q!^!3h!^!_!Mh!_!}!3h!}#O##[#O#P!<w#P#o!3h#o#p!Mh#p;'S!3h;'S;=`#$m<%lO!3h(CS#&e_$d&j'xp'{!bR(;dOY#&YYZ&cZr#&Yrs#'dsw#&Ywx#*tx!^#&Y!^!_#,s!_#O#&Y#O#P#(f#P#o#&Y#o#p#,s#p;'S#&Y;'S;=`#-r<%lO#&Y(Bb#'m]$d&j'{!bR(;dOY#'dYZ&cZw#'dwx#(fx!^#'d!^!_#)w!_#O#'d#O#P#(f#P#o#'d#o#p#)w#p;'S#'d;'S;=`#*n<%lO#'d(AO#(mX$d&jR(;dOY#(fYZ&cZ!^#(f!^!_#)Y!_#o#(f#o#p#)Y#p;'S#(f;'S;=`#)q<%lO#(f(;d#)_SR(;dOY#)YZ;'S#)Y;'S;=`#)k<%lO#)Y(;d#)nP;=`<%l#)Y(AO#)tP;=`<%l#(f(<v#*OW'{!bR(;dOY#)wZw#)wwx#)Yx#O#)w#O#P#)Y#P;'S#)w;'S;=`#*h<%lO#)w(<v#*kP;=`<%l#)w(Bb#*qP;=`<%l#'d(Ap#*}]$d&j'xpR(;dOY#*tYZ&cZr#*trs#(fs!^#*t!^!_#+v!_#O#*t#O#P#(f#P#o#*t#o#p#+v#p;'S#*t;'S;=`#,m<%lO#*t(<U#+}W'xpR(;dOY#+vZr#+vrs#)Ys#O#+v#O#P#)Y#P;'S#+v;'S;=`#,g<%lO#+v(<U#,jP;=`<%l#+v(Ap#,pP;=`<%l#*t(=h#,|Y'xp'{!bR(;dOY#,sZr#,srs#)wsw#,swx#+vx#O#,s#O#P#)Y#P;'S#,s;'S;=`#-l<%lO#,s(=h#-oP;=`<%l#,s(CS#-uP;=`<%l#&Y%#W#.Vb$d&j#{$Id'xp'{!b!RSOY!3hYZ&cZr!3hrs!4{sw!3hwx!C}x!P!3h!P!Q!Kh!Q!^!3h!^!_!Mh!_!}!3h!}#O##[#O#P!<w#P#o!3h#o#p!Mh#p;'S!3h;'S;=`#$m<%lO!3h+h#/lb$T#t$d&j'xp'{!b!RSOY!3hYZ&cZr!3hrs!4{sw!3hwx!C}x!P!3h!P!Q!Kh!Q!^!3h!^!_!Mh!_!}!3h!}#O##[#O#P!<w#P#o!3h#o#p!Mh#p;'S!3h;'S;=`#$m<%lO!3h$/l#1Pp$d&j'xp'{!bl$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!+g!P!Q%Z!Q![#3T![!^%Z!^!_*g!_!g%Z!g!h!-Z!h#O%Z#O#P&c#P#R%Z#R#S#3T#S#U%Z#U#V#6_#V#X%Z#X#Y!-Z#Y#b%Z#b#c#5T#c#d#9g#d#l%Z#l#m#<i#m#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#3`k$d&j'xp'{!bl$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!+g!P!Q%Z!Q![#3T![!^%Z!^!_*g!_!g%Z!g!h!-Z!h#O%Z#O#P&c#P#R%Z#R#S#3T#S#X%Z#X#Y!-Z#Y#b%Z#b#c#5T#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#5`_$d&j'xp'{!bl$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#6hd$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#7v!R!S#7v!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#7v#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#8Rf$d&j'xp'{!bl$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#7v!R!S#7v!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#7v#S#b%Z#b#c#5T#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#9pc$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#:{!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#:{#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#;We$d&j'xp'{!bl$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#:{!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#:{#S#b%Z#b#c#5T#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#<rg$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#>Z![!^%Z!^!_*g!_!c%Z!c!i#>Z!i#O%Z#O#P&c#P#R%Z#R#S#>Z#S#T%Z#T#Z#>Z#Z#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z$/l#>fi$d&j'xp'{!bl$'|OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#>Z![!^%Z!^!_*g!_!c%Z!c!i#>Z!i#O%Z#O#P&c#P#R%Z#R#S#>Z#S#T%Z#T#Z#>Z#Z#b%Z#b#c#5T#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%Gh#@b_!a$b$d&j#y%<f'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)[#Al_^l$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS#Bz^(O!*v!e'.r'xp'{!b$U)d(oSOY*gZr*grs'}sw*gwx)rx!P*g!P!Q#Cv!Q!^*g!^!_#Dl!_!`#F^!`#O*g#P;'S*g;'S;=`+Z<%lO*g(n#DPX$f&j'xp'{!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g$Kh#DuZ#k$Id'xp'{!bOY*gZr*grs'}sw*gwx)rx!_*g!_!`#Eh!`#O*g#P;'S*g;'S;=`+Z<%lO*g$Kh#EqX#{$Id'xp'{!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g$Kh#FgX#l$Id'xp'{!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g%Gh#G_a#X%?x$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`!a#Hd!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#W#Ho_#d$Ih$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%Gh#I}adBf#l$Id$a#|$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`#KS!`!a#L^!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S#K__#l$Id$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S#Lia#k$Id$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Cn!`!a#Mn!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S#My`#k$Id$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Cn!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'+h$ Wc(c$Ip$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P$!c!P!^%Z!^!_*g!_!a%Z!a!b$#m!b#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'+`$!n_z'#p$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S$#x`$d&j#v$Id'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Cn!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#&^$%V_!x!Ln$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(@^$&a_|(8n$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(n$'eZ$d&jO!^$(W!^!_$(n!_#i$(W#i#j$(s#j#l$(W#l#m$*f#m#o$(W#o#p$(n#p;'S$(W;'S;=`$,q<%lO$(W(n$(_T[#S$d&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#S$(sO[#S(n$(x[$d&jO!Q&c!Q![$)n![!^&c!_!c&c!c!i$)n!i#T&c#T#Z$)n#Z#o&c#o#p$,U#p;'S&c;'S;=`&w<%lO&c(n$)sZ$d&jO!Q&c!Q![$*f![!^&c!_!c&c!c!i$*f!i#T&c#T#Z$*f#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$*kZ$d&jO!Q&c!Q![$+^![!^&c!_!c&c!c!i$+^!i#T&c#T#Z$+^#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$+cZ$d&jO!Q&c!Q![$(W![!^&c!_!c&c!c!i$(W!i#T&c#T#Z$(W#Z#o&c#p;'S&c;'S;=`&w<%lO&c#S$,XR!Q![$,b!c!i$,b#T#Z$,b#S$,eS!Q![$,b!c!i$,b#T#Z$,b#q#r$(n(n$,tP;=`<%l$(W!2r$-S_!S!+S$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#S$.^`#s$Id$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Cn!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&,v$/k_$d&j'xp'{!b(S&%WOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS$0yk$d&j'xp'{!b(V!LY'u&;d$Y#tOY%ZYZ&cZr%Zrs&}st%Ztu$0juw%Zwx(rx}%Z}!O$2n!O!Q%Z!Q![$0j![!^%Z!^!_*g!_!c%Z!c!}$0j!}#O%Z#O#P&c#P#R%Z#R#S$0j#S#T%Z#T#o$0j#o#p*g#p$g%Z$g;'S$0j;'S;=`$4t<%lO$0j+d$2yk$d&j'xp'{!b$Y#tOY%ZYZ&cZr%Zrs&}st%Ztu$2nuw%Zwx(rx}%Z}!O$2n!O!Q%Z!Q![$2n![!^%Z!^!_*g!_!c%Z!c!}$2n!}#O%Z#O#P&c#P#R%Z#R#S$2n#S#T%Z#T#o$2n#o#p*g#p$g%Z$g;'S$2n;'S;=`$4n<%lO$2n+d$4qP;=`<%l$2n(CS$4wP;=`<%l$0j!5p$5TX!X!3l'xp'{!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g%Df$5{a(j%<v$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Cn!`#O%Z#O#P&c#P#o%Z#o#p*g#p#q$#m#q;'S%Z;'S;=`+a<%lO%Z%#`$7__!W$I`o`$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(r$8i_!mS$d&j'xp'{!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(CS$9y|$d&j'xp'{!b'n(;d(V!LY'u&;d$W#tOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}st%Ztu>Puw%Zwx(rx}%Z}!O@T!O!Q%Z!Q![>P![!^%Z!^!_*g!_!c%Z!c!}>P!}#O%Z#O#P&c#P#R%Z#R#S>P#S#T%Z#T#o>P#o#p*g#p$f%Z$f$g+g$g#BY>P#BY#BZ$9h#BZ$IS>P$IS$I_$9h$I_$JT>P$JT$JU$9h$JU$KV>P$KV$KW$9h$KW&FU>P&FU&FV$9h&FV;'S>P;'S;=`BZ<%l?HT>P?HT?HU$9h?HUO>P(CS$=Uk$d&j'xp'{!b'o(;d(V!LY'u&;d$W#tOY%ZYZ&cZr%Zrs&}st%Ztu>Puw%Zwx(rx}%Z}!O@T!O!Q%Z!Q![>P![!^%Z!^!_*g!_!c%Z!c!}>P!}#O%Z#O#P&c#P#R%Z#R#S>P#S#T%Z#T#o>P#o#p*g#p$g%Z$g;'S>P;'S;=`BZ<%lO>P",
  tokenizers: [noSemicolon, incdecToken, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, insertSemicolon, new LocalTokenGroup("$S~RRtu[#O#Pg#S#T#|~_P#o#pb~gOq~~jVO#i!P#i#j!U#j#l!P#l#m!q#m;'S!P;'S;=`#v<%lO!P~!UO!O~~!XS!Q![!e!c!i!e#T#Z!e#o#p#Z~!hR!Q![!q!c!i!q#T#Z!q~!tR!Q![!}!c!i!}#T#Z!}~#QR!Q![!P!c!i!P#T#Z!P~#^R!Q![#g!c!i#g#T#Z#g~#jS!Q![#g!c!i#g#T#Z#g#q#r!P~#yP;=`<%l!P~$RO(U~~", 141, 327), new LocalTokenGroup("j~RQYZXz{^~^O'r~~aP!P!Qd~iO's~~", 25, 309)],
  topRules: { "Script": [0, 5], "SingleExpression": [1, 267], "SingleClassItem": [2, 268] },
  dialects: { jsx: 12794, ts: 12796 },
  dynamicPrecedences: { "76": 1, "78": 1, "163": 1, "191": 1 },
  specialized: [{ term: 313, get: (value2) => spec_identifier[value2] || -1 }, { term: 329, get: (value2) => spec_word[value2] || -1 }, { term: 67, get: (value2) => spec_LessThan[value2] || -1 }],
  tokenPrec: 12820
});
class CompletionContext {
  constructor(state, pos, explicit) {
    this.state = state;
    this.pos = pos;
    this.explicit = explicit;
    this.abortListeners = [];
  }
  tokenBefore(types2) {
    let token = syntaxTree(this.state).resolveInner(this.pos, -1);
    while (token && types2.indexOf(token.name) < 0)
      token = token.parent;
    return token ? {
      from: token.from,
      to: this.pos,
      text: this.state.sliceDoc(token.from, this.pos),
      type: token.type
    } : null;
  }
  matchBefore(expr) {
    let line = this.state.doc.lineAt(this.pos);
    let start = Math.max(line.from, this.pos - 250);
    let str = line.text.slice(start - line.from, this.pos - line.from);
    let found = str.search(ensureAnchor(expr, false));
    return found < 0 ? null : { from: start + found, to: this.pos, text: str.slice(found) };
  }
  get aborted() {
    return this.abortListeners == null;
  }
  addEventListener(type4, listener) {
    if (type4 == "abort" && this.abortListeners)
      this.abortListeners.push(listener);
  }
}
function toSet(chars) {
  let flat = Object.keys(chars).join("");
  let words2 = /\w/.test(flat);
  if (words2)
    flat = flat.replace(/\w/g, "");
  return `[${words2 ? "\\w" : ""}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function prefixMatch(options) {
  let first = Object.create(null), rest = Object.create(null);
  for (let { label } of options) {
    first[label[0]] = true;
    for (let i2 = 1; i2 < label.length; i2++)
      rest[label[i2]] = true;
  }
  let source = toSet(first) + toSet(rest) + "*$";
  return [new RegExp("^" + source), new RegExp(source)];
}
function completeFromList(list) {
  let options = list.map((o2) => typeof o2 == "string" ? { label: o2 } : o2);
  let [validFor, match2] = options.every((o2) => /^\w+$/.test(o2.label)) ? [/\w*$/, /\w+$/] : prefixMatch(options);
  return (context) => {
    let token = context.matchBefore(match2);
    return token || context.explicit ? { from: token ? token.from : context.pos, options, validFor } : null;
  };
}
function ifNotIn(nodes, source) {
  return (context) => {
    for (let pos = syntaxTree(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent) {
      if (nodes.indexOf(pos.name) > -1)
        return null;
      if (pos.type.isTop)
        break;
    }
    return source(context);
  };
}
class Option {
  constructor(completion, source, match2, score2) {
    this.completion = completion;
    this.source = source;
    this.match = match2;
    this.score = score2;
  }
}
function cur(state) {
  return state.selection.main.from;
}
function ensureAnchor(expr, start) {
  var _a2;
  let { source } = expr;
  let addStart = start && source[0] != "^", addEnd = source[source.length - 1] != "$";
  if (!addStart && !addEnd)
    return expr;
  return new RegExp(`${addStart ? "^" : ""}(?:${source})${addEnd ? "$" : ""}`, (_a2 = expr.flags) !== null && _a2 !== void 0 ? _a2 : expr.ignoreCase ? "i" : "");
}
const pickedCompletion = /* @__PURE__ */ Annotation.define();
function insertCompletionText(state, text, from, to2) {
  let { main } = state.selection, fromOff = from - main.from, toOff = to2 - main.from;
  return Object.assign(Object.assign({}, state.changeByRange((range3) => {
    if (range3 != main && from != to2 && state.sliceDoc(range3.from + fromOff, range3.from + toOff) != state.sliceDoc(from, to2))
      return { range: range3 };
    return {
      changes: { from: range3.from + fromOff, to: to2 == main.from ? range3.to : range3.from + toOff, insert: text },
      range: EditorSelection.cursor(range3.from + fromOff + text.length)
    };
  })), { userEvent: "input.complete" });
}
const SourceCache = /* @__PURE__ */ new WeakMap();
function asSource(source) {
  if (!Array.isArray(source))
    return source;
  let known = SourceCache.get(source);
  if (!known)
    SourceCache.set(source, known = completeFromList(source));
  return known;
}
const startCompletionEffect = /* @__PURE__ */ StateEffect.define();
const closeCompletionEffect = /* @__PURE__ */ StateEffect.define();
class FuzzyMatcher {
  constructor(pattern4) {
    this.pattern = pattern4;
    this.chars = [];
    this.folded = [];
    this.any = [];
    this.precise = [];
    this.byWord = [];
    this.score = 0;
    this.matched = [];
    for (let p2 = 0; p2 < pattern4.length; ) {
      let char = codePointAt(pattern4, p2), size2 = codePointSize(char);
      this.chars.push(char);
      let part = pattern4.slice(p2, p2 + size2), upper = part.toUpperCase();
      this.folded.push(codePointAt(upper == part ? part.toLowerCase() : upper, 0));
      p2 += size2;
    }
    this.astral = pattern4.length != this.chars.length;
  }
  ret(score2, matched) {
    this.score = score2;
    this.matched = matched;
    return true;
  }
  match(word) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (word.length < this.pattern.length)
      return false;
    let { chars, folded, any: any3, precise, byWord } = this;
    if (chars.length == 1) {
      let first = codePointAt(word, 0), firstSize = codePointSize(first);
      let score2 = firstSize == word.length ? 0 : -100;
      if (first == chars[0])
        ;
      else if (first == folded[0])
        score2 += -200;
      else
        return false;
      return this.ret(score2, [0, firstSize]);
    }
    let direct = word.indexOf(this.pattern);
    if (direct == 0)
      return this.ret(word.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let len2 = chars.length, anyTo = 0;
    if (direct < 0) {
      for (let i2 = 0, e25 = Math.min(word.length, 200); i2 < e25 && anyTo < len2; ) {
        let next = codePointAt(word, i2);
        if (next == chars[anyTo] || next == folded[anyTo])
          any3[anyTo++] = i2;
        i2 += codePointSize(next);
      }
      if (anyTo < len2)
        return false;
    }
    let preciseTo = 0;
    let byWordTo = 0, byWordFolded = false;
    let adjacentTo = 0, adjacentStart = -1, adjacentEnd = -1;
    let hasLower = /[a-z]/.test(word), wordAdjacent = true;
    for (let i2 = 0, e25 = Math.min(word.length, 200), prevType = 0; i2 < e25 && byWordTo < len2; ) {
      let next = codePointAt(word, i2);
      if (direct < 0) {
        if (preciseTo < len2 && next == chars[preciseTo])
          precise[preciseTo++] = i2;
        if (adjacentTo < len2) {
          if (next == chars[adjacentTo] || next == folded[adjacentTo]) {
            if (adjacentTo == 0)
              adjacentStart = i2;
            adjacentEnd = i2 + 1;
            adjacentTo++;
          } else {
            adjacentTo = 0;
          }
        }
      }
      let ch2, type4 = next < 255 ? next >= 48 && next <= 57 || next >= 97 && next <= 122 ? 2 : next >= 65 && next <= 90 ? 1 : 0 : (ch2 = fromCodePoint(next)) != ch2.toLowerCase() ? 1 : ch2 != ch2.toUpperCase() ? 2 : 0;
      if (!i2 || type4 == 1 && hasLower || prevType == 0 && type4 != 0) {
        if (chars[byWordTo] == next || folded[byWordTo] == next && (byWordFolded = true))
          byWord[byWordTo++] = i2;
        else if (byWord.length)
          wordAdjacent = false;
      }
      prevType = type4;
      i2 += codePointSize(next);
    }
    if (byWordTo == len2 && byWord[0] == 0 && wordAdjacent)
      return this.result(-100 + (byWordFolded ? -200 : 0), byWord, word);
    if (adjacentTo == len2 && adjacentStart == 0)
      return this.ret(-200 - word.length + (adjacentEnd == word.length ? 0 : -100), [0, adjacentEnd]);
    if (direct > -1)
      return this.ret(-700 - word.length, [direct, direct + this.pattern.length]);
    if (adjacentTo == len2)
      return this.ret(-200 + -700 - word.length, [adjacentStart, adjacentEnd]);
    if (byWordTo == len2)
      return this.result(-100 + (byWordFolded ? -200 : 0) + -700 + (wordAdjacent ? 0 : -1100), byWord, word);
    return chars.length == 2 ? false : this.result((any3[0] ? -700 : 0) + -200 + -1100, any3, word);
  }
  result(score2, positions, word) {
    let result2 = [], i2 = 0;
    for (let pos of positions) {
      let to2 = pos + (this.astral ? codePointSize(codePointAt(word, pos)) : 1);
      if (i2 && result2[i2 - 1] == pos)
        result2[i2 - 1] = to2;
      else {
        result2[i2++] = pos;
        result2[i2++] = to2;
      }
    }
    return this.ret(score2 - word.length, result2);
  }
}
const completionConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      activateOnTyping: true,
      selectOnOpen: true,
      override: null,
      closeOnBlur: true,
      maxRenderedOptions: 100,
      defaultKeymap: true,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: false,
      icons: true,
      addToOptions: [],
      positionInfo: defaultPositionInfo,
      compareCompletions: (a2, b2) => a2.label.localeCompare(b2.label),
      interactionDelay: 75
    }, {
      defaultKeymap: (a2, b2) => a2 && b2,
      closeOnBlur: (a2, b2) => a2 && b2,
      icons: (a2, b2) => a2 && b2,
      tooltipClass: (a2, b2) => (c2) => joinClass(a2(c2), b2(c2)),
      optionClass: (a2, b2) => (c2) => joinClass(a2(c2), b2(c2)),
      addToOptions: (a2, b2) => a2.concat(b2)
    });
  }
});
function joinClass(a2, b2) {
  return a2 ? b2 ? a2 + " " + b2 : a2 : b2;
}
function defaultPositionInfo(view, list, option, info, space2) {
  let rtl = view.textDirection == Direction.RTL, left = rtl, narrow = false;
  let side = "top", offset, maxWidth;
  let spaceLeft = list.left - space2.left, spaceRight = space2.right - list.right;
  let infoWidth = info.right - info.left, infoHeight = info.bottom - info.top;
  if (left && spaceLeft < Math.min(infoWidth, spaceRight))
    left = false;
  else if (!left && spaceRight < Math.min(infoWidth, spaceLeft))
    left = true;
  if (infoWidth <= (left ? spaceLeft : spaceRight)) {
    offset = Math.max(space2.top, Math.min(option.top, space2.bottom - infoHeight)) - list.top;
    maxWidth = Math.min(400, left ? spaceLeft : spaceRight);
  } else {
    narrow = true;
    maxWidth = Math.min(400, (rtl ? list.right : space2.right - list.left) - 30);
    let spaceBelow = space2.bottom - list.bottom;
    if (spaceBelow >= infoHeight || spaceBelow > list.top) {
      offset = option.bottom - list.top;
    } else {
      side = "bottom";
      offset = list.bottom - option.top;
    }
  }
  return {
    style: `${side}: ${offset}px; max-width: ${maxWidth}px`,
    class: "cm-completionInfo-" + (narrow ? rtl ? "left-narrow" : "right-narrow" : left ? "left" : "right")
  };
}
function optionContent(config2) {
  let content2 = config2.addToOptions.slice();
  if (config2.icons)
    content2.push({
      render(completion) {
        let icon = document.createElement("div");
        icon.classList.add("cm-completionIcon");
        if (completion.type)
          icon.classList.add(...completion.type.split(/\s+/g).map((cls) => "cm-completionIcon-" + cls));
        icon.setAttribute("aria-hidden", "true");
        return icon;
      },
      position: 20
    });
  content2.push({
    render(completion, _s2, match2) {
      let labelElt = document.createElement("span");
      labelElt.className = "cm-completionLabel";
      let label = completion.displayLabel || completion.label, off2 = 0;
      for (let j2 = 0; j2 < match2.length; ) {
        let from = match2[j2++], to2 = match2[j2++];
        if (from > off2)
          labelElt.appendChild(document.createTextNode(label.slice(off2, from)));
        let span = labelElt.appendChild(document.createElement("span"));
        span.appendChild(document.createTextNode(label.slice(from, to2)));
        span.className = "cm-completionMatchedText";
        off2 = to2;
      }
      if (off2 < label.length)
        labelElt.appendChild(document.createTextNode(label.slice(off2)));
      return labelElt;
    },
    position: 50
  }, {
    render(completion) {
      if (!completion.detail)
        return null;
      let detailElt = document.createElement("span");
      detailElt.className = "cm-completionDetail";
      detailElt.textContent = completion.detail;
      return detailElt;
    },
    position: 80
  });
  return content2.sort((a2, b2) => a2.position - b2.position).map((a2) => a2.render);
}
function rangeAroundSelected(total, selected, max) {
  if (total <= max)
    return { from: 0, to: total };
  if (selected < 0)
    selected = 0;
  if (selected <= total >> 1) {
    let off3 = Math.floor(selected / max);
    return { from: off3 * max, to: (off3 + 1) * max };
  }
  let off2 = Math.floor((total - selected) / max);
  return { from: total - (off2 + 1) * max, to: total - off2 * max };
}
class CompletionTooltip {
  constructor(view, stateField, applyCompletion2) {
    this.view = view;
    this.stateField = stateField;
    this.applyCompletion = applyCompletion2;
    this.info = null;
    this.infoDestroy = null;
    this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (pos) => this.placeInfo(pos),
      key: this
    };
    this.space = null;
    this.currentClass = "";
    let cState = view.state.field(stateField);
    let { options, selected } = cState.open;
    let config2 = view.state.facet(completionConfig);
    this.optionContent = optionContent(config2);
    this.optionClass = config2.optionClass;
    this.tooltipClass = config2.tooltipClass;
    this.range = rangeAroundSelected(options.length, selected, config2.maxRenderedOptions);
    this.dom = document.createElement("div");
    this.dom.className = "cm-tooltip-autocomplete";
    this.updateTooltipClass(view.state);
    this.dom.addEventListener("mousedown", (e25) => {
      for (let dom = e25.target, match2; dom && dom != this.dom; dom = dom.parentNode) {
        if (dom.nodeName == "LI" && (match2 = /-(\d+)$/.exec(dom.id)) && +match2[1] < options.length) {
          this.applyCompletion(view, options[+match2[1]]);
          e25.preventDefault();
          return;
        }
      }
    });
    this.dom.addEventListener("focusout", (e25) => {
      let state = view.state.field(this.stateField, false);
      if (state && state.tooltip && view.state.facet(completionConfig).closeOnBlur && e25.relatedTarget != view.contentDOM)
        view.dispatch({ effects: closeCompletionEffect.of(null) });
    });
    this.list = this.dom.appendChild(this.createListBox(options, cState.id, this.range));
    this.list.addEventListener("scroll", () => {
      if (this.info)
        this.view.requestMeasure(this.placeInfoReq);
    });
  }
  mount() {
    this.updateSel();
  }
  update(update) {
    var _a2, _b2, _c2;
    let cState = update.state.field(this.stateField);
    let prevState = update.startState.field(this.stateField);
    this.updateTooltipClass(update.state);
    if (cState != prevState) {
      this.updateSel();
      if (((_a2 = cState.open) === null || _a2 === void 0 ? void 0 : _a2.disabled) != ((_b2 = prevState.open) === null || _b2 === void 0 ? void 0 : _b2.disabled))
        this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!((_c2 = cState.open) === null || _c2 === void 0 ? void 0 : _c2.disabled));
    }
  }
  updateTooltipClass(state) {
    let cls = this.tooltipClass(state);
    if (cls != this.currentClass) {
      for (let c2 of this.currentClass.split(" "))
        if (c2)
          this.dom.classList.remove(c2);
      for (let c2 of cls.split(" "))
        if (c2)
          this.dom.classList.add(c2);
      this.currentClass = cls;
    }
  }
  positioned(space2) {
    this.space = space2;
    if (this.info)
      this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let cState = this.view.state.field(this.stateField), open = cState.open;
    if (open.selected > -1 && open.selected < this.range.from || open.selected >= this.range.to) {
      this.range = rangeAroundSelected(open.options.length, open.selected, this.view.state.facet(completionConfig).maxRenderedOptions);
      this.list.remove();
      this.list = this.dom.appendChild(this.createListBox(open.options, cState.id, this.range));
      this.list.addEventListener("scroll", () => {
        if (this.info)
          this.view.requestMeasure(this.placeInfoReq);
      });
    }
    if (this.updateSelectedOption(open.selected)) {
      this.destroyInfo();
      let { completion } = open.options[open.selected];
      let { info } = completion;
      if (!info)
        return;
      let infoResult = typeof info === "string" ? document.createTextNode(info) : info(completion);
      if (!infoResult)
        return;
      if ("then" in infoResult) {
        infoResult.then((obj) => {
          if (obj && this.view.state.field(this.stateField, false) == cState)
            this.addInfoPane(obj, completion);
        }).catch((e25) => logException(this.view.state, e25, "completion info"));
      } else {
        this.addInfoPane(infoResult, completion);
      }
    }
  }
  addInfoPane(content2, completion) {
    this.destroyInfo();
    let wrap = this.info = document.createElement("div");
    wrap.className = "cm-tooltip cm-completionInfo";
    if (content2.nodeType != null) {
      wrap.appendChild(content2);
      this.infoDestroy = null;
    } else {
      let { dom, destroy } = content2;
      wrap.appendChild(dom);
      this.infoDestroy = destroy || null;
    }
    this.dom.appendChild(wrap);
    this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(selected) {
    let set2 = null;
    for (let opt = this.list.firstChild, i2 = this.range.from; opt; opt = opt.nextSibling, i2++) {
      if (opt.nodeName != "LI" || !opt.id) {
        i2--;
      } else if (i2 == selected) {
        if (!opt.hasAttribute("aria-selected")) {
          opt.setAttribute("aria-selected", "true");
          set2 = opt;
        }
      } else {
        if (opt.hasAttribute("aria-selected"))
          opt.removeAttribute("aria-selected");
      }
    }
    if (set2)
      scrollIntoView(this.list, set2);
    return set2;
  }
  measureInfo() {
    let sel = this.dom.querySelector("[aria-selected]");
    if (!sel || !this.info)
      return null;
    let listRect = this.dom.getBoundingClientRect();
    let infoRect = this.info.getBoundingClientRect();
    let selRect = sel.getBoundingClientRect();
    let space2 = this.space;
    if (!space2) {
      let win = this.dom.ownerDocument.defaultView || window;
      space2 = { left: 0, top: 0, right: win.innerWidth, bottom: win.innerHeight };
    }
    if (selRect.top > Math.min(space2.bottom, listRect.bottom) - 10 || selRect.bottom < Math.max(space2.top, listRect.top) + 10)
      return null;
    return this.view.state.facet(completionConfig).positionInfo(this.view, listRect, selRect, infoRect, space2);
  }
  placeInfo(pos) {
    if (this.info) {
      if (pos) {
        if (pos.style)
          this.info.style.cssText = pos.style;
        this.info.className = "cm-tooltip cm-completionInfo " + (pos.class || "");
      } else {
        this.info.style.cssText = "top: -1e6px";
      }
    }
  }
  createListBox(options, id2, range3) {
    const ul2 = document.createElement("ul");
    ul2.id = id2;
    ul2.setAttribute("role", "listbox");
    ul2.setAttribute("aria-expanded", "true");
    ul2.setAttribute("aria-label", this.view.state.phrase("Completions"));
    let curSection = null;
    for (let i2 = range3.from; i2 < range3.to; i2++) {
      let { completion, match: match2 } = options[i2], { section } = completion;
      if (section) {
        let name2 = typeof section == "string" ? section : section.name;
        if (name2 != curSection && (i2 > range3.from || range3.from == 0)) {
          curSection = name2;
          if (typeof section != "string" && section.header) {
            ul2.appendChild(section.header(section));
          } else {
            let header = ul2.appendChild(document.createElement("completion-section"));
            header.textContent = name2;
          }
        }
      }
      const li2 = ul2.appendChild(document.createElement("li"));
      li2.id = id2 + "-" + i2;
      li2.setAttribute("role", "option");
      let cls = this.optionClass(completion);
      if (cls)
        li2.className = cls;
      for (let source of this.optionContent) {
        let node2 = source(completion, this.view.state, match2);
        if (node2)
          li2.appendChild(node2);
      }
    }
    if (range3.from)
      ul2.classList.add("cm-completionListIncompleteTop");
    if (range3.to < options.length)
      ul2.classList.add("cm-completionListIncompleteBottom");
    return ul2;
  }
  destroyInfo() {
    if (this.info) {
      if (this.infoDestroy)
        this.infoDestroy();
      this.info.remove();
      this.info = null;
    }
  }
  destroy() {
    this.destroyInfo();
  }
}
function completionTooltip(stateField, applyCompletion2) {
  return (view) => new CompletionTooltip(view, stateField, applyCompletion2);
}
function scrollIntoView(container, element) {
  let parent = container.getBoundingClientRect();
  let self2 = element.getBoundingClientRect();
  if (self2.top < parent.top)
    container.scrollTop -= parent.top - self2.top;
  else if (self2.bottom > parent.bottom)
    container.scrollTop += self2.bottom - parent.bottom;
}
function score(option) {
  return (option.boost || 0) * 100 + (option.apply ? 10 : 0) + (option.info ? 5 : 0) + (option.type ? 1 : 0);
}
function sortOptions(active, state) {
  let options = [];
  let sections = null;
  let addOption = (option) => {
    options.push(option);
    let { section } = option.completion;
    if (section) {
      if (!sections)
        sections = [];
      let name2 = typeof section == "string" ? section : section.name;
      if (!sections.some((s2) => s2.name == name2))
        sections.push(typeof section == "string" ? { name: name2 } : section);
    }
  };
  for (let a2 of active)
    if (a2.hasResult()) {
      let getMatch = a2.result.getMatch;
      if (a2.result.filter === false) {
        for (let option of a2.result.options) {
          addOption(new Option(option, a2.source, getMatch ? getMatch(option) : [], 1e9 - options.length));
        }
      } else {
        let matcher = new FuzzyMatcher(state.sliceDoc(a2.from, a2.to));
        for (let option of a2.result.options)
          if (matcher.match(option.label)) {
            let matched = !option.displayLabel ? matcher.matched : getMatch ? getMatch(option, matcher.matched) : [];
            addOption(new Option(option, a2.source, matched, matcher.score + (option.boost || 0)));
          }
      }
    }
  if (sections) {
    let sectionOrder = Object.create(null), pos = 0;
    let cmp = (a2, b2) => {
      var _a2, _b2;
      return ((_a2 = a2.rank) !== null && _a2 !== void 0 ? _a2 : 1e9) - ((_b2 = b2.rank) !== null && _b2 !== void 0 ? _b2 : 1e9) || (a2.name < b2.name ? -1 : 1);
    };
    for (let s2 of sections.sort(cmp)) {
      pos -= 1e5;
      sectionOrder[s2.name] = pos;
    }
    for (let option of options) {
      let { section } = option.completion;
      if (section)
        option.score += sectionOrder[typeof section == "string" ? section : section.name];
    }
  }
  let result2 = [], prev = null;
  let compare2 = state.facet(completionConfig).compareCompletions;
  for (let opt of options.sort((a2, b2) => b2.score - a2.score || compare2(a2.completion, b2.completion))) {
    let cur2 = opt.completion;
    if (!prev || prev.label != cur2.label || prev.detail != cur2.detail || prev.type != null && cur2.type != null && prev.type != cur2.type || prev.apply != cur2.apply || prev.boost != cur2.boost)
      result2.push(opt);
    else if (score(opt.completion) > score(prev))
      result2[result2.length - 1] = opt;
    prev = opt.completion;
  }
  return result2;
}
class CompletionDialog {
  constructor(options, attrs, tooltip, timestamp, selected, disabled) {
    this.options = options;
    this.attrs = attrs;
    this.tooltip = tooltip;
    this.timestamp = timestamp;
    this.selected = selected;
    this.disabled = disabled;
  }
  setSelected(selected, id2) {
    return selected == this.selected || selected >= this.options.length ? this : new CompletionDialog(this.options, makeAttrs(id2, selected), this.tooltip, this.timestamp, selected, this.disabled);
  }
  static build(active, state, id2, prev, conf) {
    let options = sortOptions(active, state);
    if (!options.length) {
      return prev && active.some((a2) => a2.state == 1) ? new CompletionDialog(prev.options, prev.attrs, prev.tooltip, prev.timestamp, prev.selected, true) : null;
    }
    let selected = state.facet(completionConfig).selectOnOpen ? 0 : -1;
    if (prev && prev.selected != selected && prev.selected != -1) {
      let selectedValue = prev.options[prev.selected].completion;
      for (let i2 = 0; i2 < options.length; i2++)
        if (options[i2].completion == selectedValue) {
          selected = i2;
          break;
        }
    }
    return new CompletionDialog(options, makeAttrs(id2, selected), {
      pos: active.reduce((a2, b2) => b2.hasResult() ? Math.min(a2, b2.from) : a2, 1e8),
      create: completionTooltip(completionState, applyCompletion),
      above: conf.aboveCursor
    }, prev ? prev.timestamp : Date.now(), selected, false);
  }
  map(changes) {
    return new CompletionDialog(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), { pos: changes.mapPos(this.tooltip.pos) }), this.timestamp, this.selected, this.disabled);
  }
}
class CompletionState {
  constructor(active, id2, open) {
    this.active = active;
    this.id = id2;
    this.open = open;
  }
  static start() {
    return new CompletionState(none$1, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(tr2) {
    let { state } = tr2, conf = state.facet(completionConfig);
    let sources = conf.override || state.languageDataAt("autocomplete", cur(state)).map(asSource);
    let active = sources.map((source) => {
      let value2 = this.active.find((s2) => s2.source == source) || new ActiveSource(source, this.active.some((a2) => a2.state != 0) ? 1 : 0);
      return value2.update(tr2, conf);
    });
    if (active.length == this.active.length && active.every((a2, i2) => a2 == this.active[i2]))
      active = this.active;
    let open = this.open;
    if (open && tr2.docChanged)
      open = open.map(tr2.changes);
    if (tr2.selection || active.some((a2) => a2.hasResult() && tr2.changes.touchesRange(a2.from, a2.to)) || !sameResults(active, this.active))
      open = CompletionDialog.build(active, state, this.id, open, conf);
    else if (open && open.disabled && !active.some((a2) => a2.state == 1))
      open = null;
    if (!open && active.every((a2) => a2.state != 1) && active.some((a2) => a2.hasResult()))
      active = active.map((a2) => a2.hasResult() ? new ActiveSource(a2.source, 0) : a2);
    for (let effect of tr2.effects)
      if (effect.is(setSelectedEffect))
        open = open && open.setSelected(effect.value, this.id);
    return active == this.active && open == this.open ? this : new CompletionState(active, this.id, open);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : baseAttrs;
  }
}
function sameResults(a2, b2) {
  if (a2 == b2)
    return true;
  for (let iA2 = 0, iB2 = 0; ; ) {
    while (iA2 < a2.length && !a2[iA2].hasResult)
      iA2++;
    while (iB2 < b2.length && !b2[iB2].hasResult)
      iB2++;
    let endA = iA2 == a2.length, endB = iB2 == b2.length;
    if (endA || endB)
      return endA == endB;
    if (a2[iA2++].result != b2[iB2++].result)
      return false;
  }
}
const baseAttrs = {
  "aria-autocomplete": "list"
};
function makeAttrs(id2, selected) {
  let result2 = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": id2
  };
  if (selected > -1)
    result2["aria-activedescendant"] = id2 + "-" + selected;
  return result2;
}
const none$1 = [];
function getUserEvent(tr2) {
  return tr2.isUserEvent("input.type") ? "input" : tr2.isUserEvent("delete.backward") ? "delete" : null;
}
class ActiveSource {
  constructor(source, state, explicitPos = -1) {
    this.source = source;
    this.state = state;
    this.explicitPos = explicitPos;
  }
  hasResult() {
    return false;
  }
  update(tr2, conf) {
    let event = getUserEvent(tr2), value2 = this;
    if (event)
      value2 = value2.handleUserEvent(tr2, event, conf);
    else if (tr2.docChanged)
      value2 = value2.handleChange(tr2);
    else if (tr2.selection && value2.state != 0)
      value2 = new ActiveSource(value2.source, 0);
    for (let effect of tr2.effects) {
      if (effect.is(startCompletionEffect))
        value2 = new ActiveSource(value2.source, 1, effect.value ? cur(tr2.state) : -1);
      else if (effect.is(closeCompletionEffect))
        value2 = new ActiveSource(value2.source, 0);
      else if (effect.is(setActiveEffect)) {
        for (let active of effect.value)
          if (active.source == value2.source)
            value2 = active;
      }
    }
    return value2;
  }
  handleUserEvent(tr2, type4, conf) {
    return type4 == "delete" || !conf.activateOnTyping ? this.map(tr2.changes) : new ActiveSource(this.source, 1);
  }
  handleChange(tr2) {
    return tr2.changes.touchesRange(cur(tr2.startState)) ? new ActiveSource(this.source, 0) : this.map(tr2.changes);
  }
  map(changes) {
    return changes.empty || this.explicitPos < 0 ? this : new ActiveSource(this.source, this.state, changes.mapPos(this.explicitPos));
  }
}
class ActiveResult extends ActiveSource {
  constructor(source, explicitPos, result2, from, to2) {
    super(source, 2, explicitPos);
    this.result = result2;
    this.from = from;
    this.to = to2;
  }
  hasResult() {
    return true;
  }
  handleUserEvent(tr2, type4, conf) {
    var _a2;
    let from = tr2.changes.mapPos(this.from), to2 = tr2.changes.mapPos(this.to, 1);
    let pos = cur(tr2.state);
    if ((this.explicitPos < 0 ? pos <= from : pos < this.from) || pos > to2 || type4 == "delete" && cur(tr2.startState) == this.from)
      return new ActiveSource(this.source, type4 == "input" && conf.activateOnTyping ? 1 : 0);
    let explicitPos = this.explicitPos < 0 ? -1 : tr2.changes.mapPos(this.explicitPos), updated;
    if (checkValid(this.result.validFor, tr2.state, from, to2))
      return new ActiveResult(this.source, explicitPos, this.result, from, to2);
    if (this.result.update && (updated = this.result.update(this.result, from, to2, new CompletionContext(tr2.state, pos, explicitPos >= 0))))
      return new ActiveResult(this.source, explicitPos, updated, updated.from, (_a2 = updated.to) !== null && _a2 !== void 0 ? _a2 : cur(tr2.state));
    return new ActiveSource(this.source, 1, explicitPos);
  }
  handleChange(tr2) {
    return tr2.changes.touchesRange(this.from, this.to) ? new ActiveSource(this.source, 0) : this.map(tr2.changes);
  }
  map(mapping) {
    return mapping.empty ? this : new ActiveResult(this.source, this.explicitPos < 0 ? -1 : mapping.mapPos(this.explicitPos), this.result, mapping.mapPos(this.from), mapping.mapPos(this.to, 1));
  }
}
function checkValid(validFor, state, from, to2) {
  if (!validFor)
    return false;
  let text = state.sliceDoc(from, to2);
  return typeof validFor == "function" ? validFor(text, from, to2, state) : ensureAnchor(validFor, true).test(text);
}
const setActiveEffect = /* @__PURE__ */ StateEffect.define({
  map(sources, mapping) {
    return sources.map((s2) => s2.map(mapping));
  }
});
const setSelectedEffect = /* @__PURE__ */ StateEffect.define();
const completionState = /* @__PURE__ */ StateField.define({
  create() {
    return CompletionState.start();
  },
  update(value2, tr2) {
    return value2.update(tr2);
  },
  provide: (f2) => [
    showTooltip.from(f2, (val) => val.tooltip),
    EditorView.contentAttributes.from(f2, (state) => state.attrs)
  ]
});
function applyCompletion(view, option) {
  const apply2 = option.completion.apply || option.completion.label;
  let result2 = view.state.field(completionState).active.find((a2) => a2.source == option.source);
  if (!(result2 instanceof ActiveResult))
    return false;
  if (typeof apply2 == "string")
    view.dispatch(Object.assign(Object.assign({}, insertCompletionText(view.state, apply2, result2.from, result2.to)), { annotations: pickedCompletion.of(option.completion) }));
  else
    apply2(view, option.completion, result2.from, result2.to);
  return true;
}
function moveCompletionSelection(forward, by2 = "option") {
  return (view) => {
    let cState = view.state.field(completionState, false);
    if (!cState || !cState.open || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet(completionConfig).interactionDelay)
      return false;
    let step = 1, tooltip;
    if (by2 == "page" && (tooltip = getTooltip(view, cState.open.tooltip)))
      step = Math.max(2, Math.floor(tooltip.dom.offsetHeight / tooltip.dom.querySelector("li").offsetHeight) - 1);
    let { length: length2 } = cState.open.options;
    let selected = cState.open.selected > -1 ? cState.open.selected + step * (forward ? 1 : -1) : forward ? 0 : length2 - 1;
    if (selected < 0)
      selected = by2 == "page" ? 0 : length2 - 1;
    else if (selected >= length2)
      selected = by2 == "page" ? length2 - 1 : 0;
    view.dispatch({ effects: setSelectedEffect.of(selected) });
    return true;
  };
}
const acceptCompletion = (view) => {
  let cState = view.state.field(completionState, false);
  if (view.state.readOnly || !cState || !cState.open || cState.open.selected < 0 || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet(completionConfig).interactionDelay)
    return false;
  return applyCompletion(view, cState.open.options[cState.open.selected]);
};
const startCompletion = (view) => {
  let cState = view.state.field(completionState, false);
  if (!cState)
    return false;
  view.dispatch({ effects: startCompletionEffect.of(true) });
  return true;
};
const closeCompletion = (view) => {
  let cState = view.state.field(completionState, false);
  if (!cState || !cState.active.some((a2) => a2.state != 0))
    return false;
  view.dispatch({ effects: closeCompletionEffect.of(null) });
  return true;
};
class RunningQuery {
  constructor(active, context) {
    this.active = active;
    this.context = context;
    this.time = Date.now();
    this.updates = [];
    this.done = void 0;
  }
}
const DebounceTime = 50, MaxUpdateCount = 50, MinAbortTime = 1e3;
const completionPlugin = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.debounceUpdate = -1;
    this.running = [];
    this.debounceAccept = -1;
    this.composing = 0;
    for (let active of view.state.field(completionState).active)
      if (active.state == 1)
        this.startQuery(active);
  }
  update(update) {
    let cState = update.state.field(completionState);
    if (!update.selectionSet && !update.docChanged && update.startState.field(completionState) == cState)
      return;
    let doesReset = update.transactions.some((tr2) => {
      return (tr2.selection || tr2.docChanged) && !getUserEvent(tr2);
    });
    for (let i2 = 0; i2 < this.running.length; i2++) {
      let query = this.running[i2];
      if (doesReset || query.updates.length + update.transactions.length > MaxUpdateCount && Date.now() - query.time > MinAbortTime) {
        for (let handler of query.context.abortListeners) {
          try {
            handler();
          } catch (e25) {
            logException(this.view.state, e25);
          }
        }
        query.context.abortListeners = null;
        this.running.splice(i2--, 1);
      } else {
        query.updates.push(...update.transactions);
      }
    }
    if (this.debounceUpdate > -1)
      clearTimeout(this.debounceUpdate);
    this.debounceUpdate = cState.active.some((a2) => a2.state == 1 && !this.running.some((q2) => q2.active.source == a2.source)) ? setTimeout(() => this.startUpdate(), DebounceTime) : -1;
    if (this.composing != 0)
      for (let tr2 of update.transactions) {
        if (getUserEvent(tr2) == "input")
          this.composing = 2;
        else if (this.composing == 2 && tr2.selection)
          this.composing = 3;
      }
  }
  startUpdate() {
    this.debounceUpdate = -1;
    let { state } = this.view, cState = state.field(completionState);
    for (let active of cState.active) {
      if (active.state == 1 && !this.running.some((r2) => r2.active.source == active.source))
        this.startQuery(active);
    }
  }
  startQuery(active) {
    let { state } = this.view, pos = cur(state);
    let context = new CompletionContext(state, pos, active.explicitPos == pos);
    let pending = new RunningQuery(active, context);
    this.running.push(pending);
    Promise.resolve(active.source(context)).then((result2) => {
      if (!pending.context.aborted) {
        pending.done = result2 || null;
        this.scheduleAccept();
      }
    }, (err) => {
      this.view.dispatch({ effects: closeCompletionEffect.of(null) });
      logException(this.view.state, err);
    });
  }
  scheduleAccept() {
    if (this.running.every((q2) => q2.done !== void 0))
      this.accept();
    else if (this.debounceAccept < 0)
      this.debounceAccept = setTimeout(() => this.accept(), DebounceTime);
  }
  accept() {
    var _a2;
    if (this.debounceAccept > -1)
      clearTimeout(this.debounceAccept);
    this.debounceAccept = -1;
    let updated = [];
    let conf = this.view.state.facet(completionConfig);
    for (let i2 = 0; i2 < this.running.length; i2++) {
      let query = this.running[i2];
      if (query.done === void 0)
        continue;
      this.running.splice(i2--, 1);
      if (query.done) {
        let active = new ActiveResult(query.active.source, query.active.explicitPos, query.done, query.done.from, (_a2 = query.done.to) !== null && _a2 !== void 0 ? _a2 : cur(query.updates.length ? query.updates[0].startState : this.view.state));
        for (let tr2 of query.updates)
          active = active.update(tr2, conf);
        if (active.hasResult()) {
          updated.push(active);
          continue;
        }
      }
      let current = this.view.state.field(completionState).active.find((a2) => a2.source == query.active.source);
      if (current && current.state == 1) {
        if (query.done == null) {
          let active = new ActiveSource(query.active.source, 0);
          for (let tr2 of query.updates)
            active = active.update(tr2, conf);
          if (active.state != 1)
            updated.push(active);
        } else {
          this.startQuery(current);
        }
      }
    }
    if (updated.length)
      this.view.dispatch({ effects: setActiveEffect.of(updated) });
  }
}, {
  eventHandlers: {
    blur(event) {
      let state = this.view.state.field(completionState, false);
      if (state && state.tooltip && this.view.state.facet(completionConfig).closeOnBlur) {
        let dialog = state.open && getTooltip(this.view, state.open.tooltip);
        if (!dialog || !dialog.dom.contains(event.relatedTarget))
          this.view.dispatch({ effects: closeCompletionEffect.of(null) });
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      if (this.composing == 3) {
        setTimeout(() => this.view.dispatch({ effects: startCompletionEffect.of(false) }), 20);
      }
      this.composing = 0;
    }
  }
});
const baseTheme$3 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"\xB7\xB7\xB7"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: `${400}px`,
    boxSizing: "border-box"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: `${30}px` },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: `${30}px` },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'\u0192'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'\u25CB'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'\u25CC'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'\u{1D465}'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'\u{1D436}'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'\u{1D461}'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'\u222A'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'\u25A1'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'\u{1F511}\uFE0E'" }
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'\u25A2'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
});
class FieldPos {
  constructor(field, line, from, to2) {
    this.field = field;
    this.line = line;
    this.from = from;
    this.to = to2;
  }
}
class FieldRange {
  constructor(field, from, to2) {
    this.field = field;
    this.from = from;
    this.to = to2;
  }
  map(changes) {
    let from = changes.mapPos(this.from, -1, MapMode.TrackDel);
    let to2 = changes.mapPos(this.to, 1, MapMode.TrackDel);
    return from == null || to2 == null ? null : new FieldRange(this.field, from, to2);
  }
}
class Snippet {
  constructor(lines, fieldPositions) {
    this.lines = lines;
    this.fieldPositions = fieldPositions;
  }
  instantiate(state, pos) {
    let text = [], lineStart = [pos];
    let lineObj = state.doc.lineAt(pos), baseIndent = /^\s*/.exec(lineObj.text)[0];
    for (let line of this.lines) {
      if (text.length) {
        let indent = baseIndent, tabs = /^\t*/.exec(line)[0].length;
        for (let i2 = 0; i2 < tabs; i2++)
          indent += state.facet(indentUnit);
        lineStart.push(pos + indent.length - tabs);
        line = indent + line.slice(tabs);
      }
      text.push(line);
      pos += line.length + 1;
    }
    let ranges = this.fieldPositions.map((pos2) => new FieldRange(pos2.field, lineStart[pos2.line] + pos2.from, lineStart[pos2.line] + pos2.to));
    return { text, ranges };
  }
  static parse(template) {
    let fields = [];
    let lines = [], positions = [], m2;
    for (let line of template.split(/\r\n?|\n/)) {
      while (m2 = /[#$]\{(?:(\d+)(?::([^}]*))?|([^}]*))\}/.exec(line)) {
        let seq = m2[1] ? +m2[1] : null, name2 = m2[2] || m2[3] || "", found = -1;
        for (let i2 = 0; i2 < fields.length; i2++) {
          if (seq != null ? fields[i2].seq == seq : name2 ? fields[i2].name == name2 : false)
            found = i2;
        }
        if (found < 0) {
          let i2 = 0;
          while (i2 < fields.length && (seq == null || fields[i2].seq != null && fields[i2].seq < seq))
            i2++;
          fields.splice(i2, 0, { seq, name: name2 });
          found = i2;
          for (let pos of positions)
            if (pos.field >= found)
              pos.field++;
        }
        positions.push(new FieldPos(found, lines.length, m2.index, m2.index + name2.length));
        line = line.slice(0, m2.index) + name2 + line.slice(m2.index + m2[0].length);
      }
      for (let esc; esc = /\\([{}])/.exec(line); ) {
        line = line.slice(0, esc.index) + esc[1] + line.slice(esc.index + esc[0].length);
        for (let pos of positions)
          if (pos.line == lines.length && pos.from > esc.index) {
            pos.from--;
            pos.to--;
          }
      }
      lines.push(line);
    }
    return new Snippet(lines, positions);
  }
}
let fieldMarker = /* @__PURE__ */ Decoration.widget({ widget: /* @__PURE__ */ new class extends WidgetType {
  toDOM() {
    let span = document.createElement("span");
    span.className = "cm-snippetFieldPosition";
    return span;
  }
  ignoreEvent() {
    return false;
  }
}() });
let fieldRange = /* @__PURE__ */ Decoration.mark({ class: "cm-snippetField" });
class ActiveSnippet {
  constructor(ranges, active) {
    this.ranges = ranges;
    this.active = active;
    this.deco = Decoration.set(ranges.map((r2) => (r2.from == r2.to ? fieldMarker : fieldRange).range(r2.from, r2.to)));
  }
  map(changes) {
    let ranges = [];
    for (let r2 of this.ranges) {
      let mapped = r2.map(changes);
      if (!mapped)
        return null;
      ranges.push(mapped);
    }
    return new ActiveSnippet(ranges, this.active);
  }
  selectionInsideField(sel) {
    return sel.ranges.every((range3) => this.ranges.some((r2) => r2.field == this.active && r2.from <= range3.from && r2.to >= range3.to));
  }
}
const setActive = /* @__PURE__ */ StateEffect.define({
  map(value2, changes) {
    return value2 && value2.map(changes);
  }
});
const moveToField = /* @__PURE__ */ StateEffect.define();
const snippetState = /* @__PURE__ */ StateField.define({
  create() {
    return null;
  },
  update(value2, tr2) {
    for (let effect of tr2.effects) {
      if (effect.is(setActive))
        return effect.value;
      if (effect.is(moveToField) && value2)
        return new ActiveSnippet(value2.ranges, effect.value);
    }
    if (value2 && tr2.docChanged)
      value2 = value2.map(tr2.changes);
    if (value2 && tr2.selection && !value2.selectionInsideField(tr2.selection))
      value2 = null;
    return value2;
  },
  provide: (f2) => EditorView.decorations.from(f2, (val) => val ? val.deco : Decoration.none)
});
function fieldSelection(ranges, field) {
  return EditorSelection.create(ranges.filter((r2) => r2.field == field).map((r2) => EditorSelection.range(r2.from, r2.to)));
}
function snippet(template) {
  let snippet2 = Snippet.parse(template);
  return (editor, completion, from, to2) => {
    let { text, ranges } = snippet2.instantiate(editor.state, from);
    let spec2 = {
      changes: { from, to: to2, insert: Text.of(text) },
      scrollIntoView: true,
      annotations: completion ? pickedCompletion.of(completion) : void 0
    };
    if (ranges.length)
      spec2.selection = fieldSelection(ranges, 0);
    if (ranges.length > 1) {
      let active = new ActiveSnippet(ranges, 0);
      let effects = spec2.effects = [setActive.of(active)];
      if (editor.state.field(snippetState, false) === void 0)
        effects.push(StateEffect.appendConfig.of([snippetState, addSnippetKeymap, snippetPointerHandler, baseTheme$3]));
    }
    editor.dispatch(editor.state.update(spec2));
  };
}
function moveField(dir) {
  return ({ state, dispatch }) => {
    let active = state.field(snippetState, false);
    if (!active || dir < 0 && active.active == 0)
      return false;
    let next = active.active + dir, last = dir > 0 && !active.ranges.some((r2) => r2.field == next + dir);
    dispatch(state.update({
      selection: fieldSelection(active.ranges, next),
      effects: setActive.of(last ? null : new ActiveSnippet(active.ranges, next))
    }));
    return true;
  };
}
const clearSnippet = ({ state, dispatch }) => {
  let active = state.field(snippetState, false);
  if (!active)
    return false;
  dispatch(state.update({ effects: setActive.of(null) }));
  return true;
};
const nextSnippetField = /* @__PURE__ */ moveField(1);
const prevSnippetField = /* @__PURE__ */ moveField(-1);
const defaultSnippetKeymap = [
  { key: "Tab", run: nextSnippetField, shift: prevSnippetField },
  { key: "Escape", run: clearSnippet }
];
const snippetKeymap = /* @__PURE__ */ Facet.define({
  combine(maps) {
    return maps.length ? maps[0] : defaultSnippetKeymap;
  }
});
const addSnippetKeymap = /* @__PURE__ */ Prec.highest(/* @__PURE__ */ keymap.compute([snippetKeymap], (state) => state.facet(snippetKeymap)));
function snippetCompletion(template, completion) {
  return Object.assign(Object.assign({}, completion), { apply: snippet(template) });
}
const snippetPointerHandler = /* @__PURE__ */ EditorView.domEventHandlers({
  mousedown(event, view) {
    let active = view.state.field(snippetState, false), pos;
    if (!active || (pos = view.posAtCoords({ x: event.clientX, y: event.clientY })) == null)
      return false;
    let match2 = active.ranges.find((r2) => r2.from <= pos && r2.to >= pos);
    if (!match2 || match2.field == active.active)
      return false;
    view.dispatch({
      selection: fieldSelection(active.ranges, match2.field),
      effects: setActive.of(active.ranges.some((r2) => r2.field > match2.field) ? new ActiveSnippet(active.ranges, match2.field) : null)
    });
    return true;
  }
});
const defaults = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
};
const closeBracketEffect = /* @__PURE__ */ StateEffect.define({
  map(value2, mapping) {
    let mapped = mapping.mapPos(value2, -1, MapMode.TrackAfter);
    return mapped == null ? void 0 : mapped;
  }
});
const closedBracket = /* @__PURE__ */ new class extends RangeValue {
}();
closedBracket.startSide = 1;
closedBracket.endSide = -1;
const bracketState = /* @__PURE__ */ StateField.define({
  create() {
    return RangeSet.empty;
  },
  update(value2, tr2) {
    if (tr2.selection) {
      let lineStart = tr2.state.doc.lineAt(tr2.selection.main.head).from;
      let prevLineStart = tr2.startState.doc.lineAt(tr2.startState.selection.main.head).from;
      if (lineStart != tr2.changes.mapPos(prevLineStart, -1))
        value2 = RangeSet.empty;
    }
    value2 = value2.map(tr2.changes);
    for (let effect of tr2.effects)
      if (effect.is(closeBracketEffect))
        value2 = value2.update({ add: [closedBracket.range(effect.value, effect.value + 1)] });
    return value2;
  }
});
function closeBrackets() {
  return [inputHandler, bracketState];
}
const definedClosing = "()[]{}<>";
function closing(ch2) {
  for (let i2 = 0; i2 < definedClosing.length; i2 += 2)
    if (definedClosing.charCodeAt(i2) == ch2)
      return definedClosing.charAt(i2 + 1);
  return fromCodePoint(ch2 < 128 ? ch2 : ch2 + 1);
}
function config(state, pos) {
  return state.languageDataAt("closeBrackets", pos)[0] || defaults;
}
const android$1 = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent);
const inputHandler = /* @__PURE__ */ EditorView.inputHandler.of((view, from, to2, insert2) => {
  if ((android$1 ? view.composing : view.compositionStarted) || view.state.readOnly)
    return false;
  let sel = view.state.selection.main;
  if (insert2.length > 2 || insert2.length == 2 && codePointSize(codePointAt(insert2, 0)) == 1 || from != sel.from || to2 != sel.to)
    return false;
  let tr2 = insertBracket(view.state, insert2);
  if (!tr2)
    return false;
  view.dispatch(tr2);
  return true;
});
const deleteBracketPair = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  let conf = config(state, state.selection.main.head);
  let tokens = conf.brackets || defaults.brackets;
  let dont = null, changes = state.changeByRange((range3) => {
    if (range3.empty) {
      let before = prevChar(state.doc, range3.head);
      for (let token of tokens) {
        if (token == before && nextChar(state.doc, range3.head) == closing(codePointAt(token, 0)))
          return {
            changes: { from: range3.head - token.length, to: range3.head + token.length },
            range: EditorSelection.cursor(range3.head - token.length)
          };
      }
    }
    return { range: dont = range3 };
  });
  if (!dont)
    dispatch(state.update(changes, { scrollIntoView: true, userEvent: "delete.backward" }));
  return !dont;
};
const closeBracketsKeymap = [
  { key: "Backspace", run: deleteBracketPair }
];
function insertBracket(state, bracket2) {
  let conf = config(state, state.selection.main.head);
  let tokens = conf.brackets || defaults.brackets;
  for (let tok of tokens) {
    let closed = closing(codePointAt(tok, 0));
    if (bracket2 == tok)
      return closed == tok ? handleSame(state, tok, tokens.indexOf(tok + tok + tok) > -1, conf) : handleOpen(state, tok, closed, conf.before || defaults.before);
    if (bracket2 == closed && closedBracketAt(state, state.selection.main.from))
      return handleClose(state, tok, closed);
  }
  return null;
}
function closedBracketAt(state, pos) {
  let found = false;
  state.field(bracketState).between(0, state.doc.length, (from) => {
    if (from == pos)
      found = true;
  });
  return found;
}
function nextChar(doc2, pos) {
  let next = doc2.sliceString(pos, pos + 2);
  return next.slice(0, codePointSize(codePointAt(next, 0)));
}
function prevChar(doc2, pos) {
  let prev = doc2.sliceString(pos - 2, pos);
  return codePointSize(codePointAt(prev, 0)) == prev.length ? prev : prev.slice(1);
}
function handleOpen(state, open, close, closeBefore) {
  let dont = null, changes = state.changeByRange((range3) => {
    if (!range3.empty)
      return {
        changes: [{ insert: open, from: range3.from }, { insert: close, from: range3.to }],
        effects: closeBracketEffect.of(range3.to + open.length),
        range: EditorSelection.range(range3.anchor + open.length, range3.head + open.length)
      };
    let next = nextChar(state.doc, range3.head);
    if (!next || /\s/.test(next) || closeBefore.indexOf(next) > -1)
      return {
        changes: { insert: open + close, from: range3.head },
        effects: closeBracketEffect.of(range3.head + open.length),
        range: EditorSelection.cursor(range3.head + open.length)
      };
    return { range: dont = range3 };
  });
  return dont ? null : state.update(changes, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}
function handleClose(state, _open, close) {
  let dont = null, changes = state.changeByRange((range3) => {
    if (range3.empty && nextChar(state.doc, range3.head) == close)
      return {
        changes: { from: range3.head, to: range3.head + close.length, insert: close },
        range: EditorSelection.cursor(range3.head + close.length)
      };
    return dont = { range: range3 };
  });
  return dont ? null : state.update(changes, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}
function handleSame(state, token, allowTriple, config2) {
  let stringPrefixes = config2.stringPrefixes || defaults.stringPrefixes;
  let dont = null, changes = state.changeByRange((range3) => {
    if (!range3.empty)
      return {
        changes: [{ insert: token, from: range3.from }, { insert: token, from: range3.to }],
        effects: closeBracketEffect.of(range3.to + token.length),
        range: EditorSelection.range(range3.anchor + token.length, range3.head + token.length)
      };
    let pos = range3.head, next = nextChar(state.doc, pos), start;
    if (next == token) {
      if (nodeStart(state, pos)) {
        return {
          changes: { insert: token + token, from: pos },
          effects: closeBracketEffect.of(pos + token.length),
          range: EditorSelection.cursor(pos + token.length)
        };
      } else if (closedBracketAt(state, pos)) {
        let isTriple = allowTriple && state.sliceDoc(pos, pos + token.length * 3) == token + token + token;
        let content2 = isTriple ? token + token + token : token;
        return {
          changes: { from: pos, to: pos + content2.length, insert: content2 },
          range: EditorSelection.cursor(pos + content2.length)
        };
      }
    } else if (allowTriple && state.sliceDoc(pos - 2 * token.length, pos) == token + token && (start = canStartStringAt(state, pos - 2 * token.length, stringPrefixes)) > -1 && nodeStart(state, start)) {
      return {
        changes: { insert: token + token + token + token, from: pos },
        effects: closeBracketEffect.of(pos + token.length),
        range: EditorSelection.cursor(pos + token.length)
      };
    } else if (state.charCategorizer(pos)(next) != CharCategory.Word) {
      if (canStartStringAt(state, pos, stringPrefixes) > -1 && !probablyInString(state, pos, token, stringPrefixes))
        return {
          changes: { insert: token + token, from: pos },
          effects: closeBracketEffect.of(pos + token.length),
          range: EditorSelection.cursor(pos + token.length)
        };
    }
    return { range: dont = range3 };
  });
  return dont ? null : state.update(changes, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}
function nodeStart(state, pos) {
  let tree = syntaxTree(state).resolveInner(pos + 1);
  return tree.parent && tree.from == pos;
}
function probablyInString(state, pos, quoteToken, prefixes) {
  let node2 = syntaxTree(state).resolveInner(pos, -1);
  let maxPrefix = prefixes.reduce((m2, p2) => Math.max(m2, p2.length), 0);
  for (let i2 = 0; i2 < 5; i2++) {
    let start = state.sliceDoc(node2.from, Math.min(node2.to, node2.from + quoteToken.length + maxPrefix));
    let quotePos = start.indexOf(quoteToken);
    if (!quotePos || quotePos > -1 && prefixes.indexOf(start.slice(0, quotePos)) > -1) {
      let first = node2.firstChild;
      while (first && first.from == node2.from && first.to - first.from > quoteToken.length + quotePos) {
        if (state.sliceDoc(first.to - quoteToken.length, first.to) == quoteToken)
          return false;
        first = first.firstChild;
      }
      return true;
    }
    let parent = node2.to == pos && node2.parent;
    if (!parent)
      break;
    node2 = parent;
  }
  return false;
}
function canStartStringAt(state, pos, prefixes) {
  let charCat = state.charCategorizer(pos);
  if (charCat(state.sliceDoc(pos - 1, pos)) != CharCategory.Word)
    return pos;
  for (let prefix2 of prefixes) {
    let start = pos - prefix2.length;
    if (state.sliceDoc(start, pos) == prefix2 && charCat(state.sliceDoc(start - 1, start)) != CharCategory.Word)
      return start;
  }
  return -1;
}
function autocompletion(config2 = {}) {
  return [
    completionState,
    completionConfig.of(config2),
    completionPlugin,
    completionKeymapExt,
    baseTheme$3
  ];
}
const completionKeymap = [
  { key: "Ctrl-Space", run: startCompletion },
  { key: "Escape", run: closeCompletion },
  { key: "ArrowDown", run: /* @__PURE__ */ moveCompletionSelection(true) },
  { key: "ArrowUp", run: /* @__PURE__ */ moveCompletionSelection(false) },
  { key: "PageDown", run: /* @__PURE__ */ moveCompletionSelection(true, "page") },
  { key: "PageUp", run: /* @__PURE__ */ moveCompletionSelection(false, "page") },
  { key: "Enter", run: acceptCompletion }
];
const completionKeymapExt = /* @__PURE__ */ Prec.highest(/* @__PURE__ */ keymap.computeN([completionConfig], (state) => state.facet(completionConfig).defaultKeymap ? [completionKeymap] : []));
const snippets = [
  /* @__PURE__ */ snippetCompletion("function ${name}(${params}) {\n	${}\n}", {
    label: "function",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ snippetCompletion("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n	${}\n}", {
    label: "for",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ snippetCompletion("for (let ${name} of ${collection}) {\n	${}\n}", {
    label: "for",
    detail: "of loop",
    type: "keyword"
  }),
  /* @__PURE__ */ snippetCompletion("do {\n	${}\n} while (${})", {
    label: "do",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ snippetCompletion("while (${}) {\n	${}\n}", {
    label: "while",
    detail: "loop",
    type: "keyword"
  }),
  /* @__PURE__ */ snippetCompletion("try {\n	${}\n} catch (${error}) {\n	${}\n}", {
    label: "try",
    detail: "/ catch block",
    type: "keyword"
  }),
  /* @__PURE__ */ snippetCompletion("if (${}) {\n	${}\n}", {
    label: "if",
    detail: "block",
    type: "keyword"
  }),
  /* @__PURE__ */ snippetCompletion("if (${}) {\n	${}\n} else {\n	${}\n}", {
    label: "if",
    detail: "/ else block",
    type: "keyword"
  }),
  /* @__PURE__ */ snippetCompletion("class ${name} {\n	constructor(${params}) {\n		${}\n	}\n}", {
    label: "class",
    detail: "definition",
    type: "keyword"
  }),
  /* @__PURE__ */ snippetCompletion('import {${names}} from "${module}"\n${}', {
    label: "import",
    detail: "named",
    type: "keyword"
  }),
  /* @__PURE__ */ snippetCompletion('import ${name} from "${module}"\n${}', {
    label: "import",
    detail: "default",
    type: "keyword"
  })
];
const cache = /* @__PURE__ */ new NodeWeakMap();
const ScopeNodes = /* @__PURE__ */ new Set([
  "Script",
  "Block",
  "FunctionExpression",
  "FunctionDeclaration",
  "ArrowFunction",
  "MethodDeclaration",
  "ForStatement"
]);
function defID(type4) {
  return (node2, def) => {
    let id2 = node2.node.getChild("VariableDefinition");
    if (id2)
      def(id2, type4);
    return true;
  };
}
const functionContext = ["FunctionDeclaration"];
const gatherCompletions = {
  FunctionDeclaration: /* @__PURE__ */ defID("function"),
  ClassDeclaration: /* @__PURE__ */ defID("class"),
  ClassExpression: () => true,
  EnumDeclaration: /* @__PURE__ */ defID("constant"),
  TypeAliasDeclaration: /* @__PURE__ */ defID("type"),
  NamespaceDeclaration: /* @__PURE__ */ defID("namespace"),
  VariableDefinition(node2, def) {
    if (!node2.matchContext(functionContext))
      def(node2, "variable");
  },
  TypeDefinition(node2, def) {
    def(node2, "type");
  },
  __proto__: null
};
function getScope(doc2, node2) {
  let cached = cache.get(node2);
  if (cached)
    return cached;
  let completions = [], top2 = true;
  function def(node3, type4) {
    let name2 = doc2.sliceString(node3.from, node3.to);
    completions.push({ label: name2, type: type4 });
  }
  node2.cursor(IterMode.IncludeAnonymous).iterate((node3) => {
    if (top2) {
      top2 = false;
    } else if (node3.name) {
      let gather = gatherCompletions[node3.name];
      if (gather && gather(node3, def) || ScopeNodes.has(node3.name))
        return false;
    } else if (node3.to - node3.from > 8192) {
      for (let c2 of getScope(doc2, node3.node))
        completions.push(c2);
      return false;
    }
  });
  cache.set(node2, completions);
  return completions;
}
const Identifier = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/;
const dontComplete = [
  "TemplateString",
  "String",
  "RegExp",
  "LineComment",
  "BlockComment",
  "VariableDefinition",
  "TypeDefinition",
  "Label",
  "PropertyDefinition",
  "PropertyName",
  "PrivatePropertyDefinition",
  "PrivatePropertyName",
  ".",
  "?."
];
function localCompletionSource(context) {
  let inner = syntaxTree(context.state).resolveInner(context.pos, -1);
  if (dontComplete.indexOf(inner.name) > -1)
    return null;
  let isWord = inner.name == "VariableName" || inner.to - inner.from < 20 && Identifier.test(context.state.sliceDoc(inner.from, inner.to));
  if (!isWord && !context.explicit)
    return null;
  let options = [];
  for (let pos = inner; pos; pos = pos.parent) {
    if (ScopeNodes.has(pos.name))
      options = options.concat(getScope(context.state.doc, pos));
  }
  return {
    options,
    from: isWord ? inner.from : context.pos,
    validFor: Identifier
  };
}
function pathFor(read, member, name2) {
  var _a2;
  let path = [];
  for (; ; ) {
    let obj = member.firstChild, prop;
    if ((obj === null || obj === void 0 ? void 0 : obj.name) == "VariableName") {
      path.push(read(obj));
      return { path: path.reverse(), name: name2 };
    } else if ((obj === null || obj === void 0 ? void 0 : obj.name) == "MemberExpression" && ((_a2 = prop = obj.lastChild) === null || _a2 === void 0 ? void 0 : _a2.name) == "PropertyName") {
      path.push(read(prop));
      member = obj;
    } else {
      return null;
    }
  }
}
function completionPath(context) {
  let read = (node2) => context.state.doc.sliceString(node2.from, node2.to);
  let inner = syntaxTree(context.state).resolveInner(context.pos, -1);
  if (inner.name == "PropertyName") {
    return pathFor(read, inner.parent, read(inner));
  } else if ((inner.name == "." || inner.name == "?.") && inner.parent.name == "MemberExpression") {
    return pathFor(read, inner.parent, "");
  } else if (dontComplete.indexOf(inner.name) > -1) {
    return null;
  } else if (inner.name == "VariableName" || inner.to - inner.from < 20 && Identifier.test(read(inner))) {
    return { path: [], name: read(inner) };
  } else if (inner.name == "MemberExpression") {
    return pathFor(read, inner, "");
  } else {
    return context.explicit ? { path: [], name: "" } : null;
  }
}
function enumeratePropertyCompletions(obj, top2) {
  let options = [], seen = new Set();
  for (let depth = 0; ; depth++) {
    for (let name2 of (Object.getOwnPropertyNames || Object.keys)(obj)) {
      if (!/^[a-zA-Z_$][\w$]*$/.test(name2) || seen.has(name2))
        continue;
      seen.add(name2);
      let value2;
      try {
        value2 = obj[name2];
      } catch (_2) {
        continue;
      }
      options.push({
        label: name2,
        type: typeof value2 == "function" ? /^[A-Z]/.test(name2) ? "class" : top2 ? "function" : "method" : top2 ? "variable" : "property",
        boost: -depth
      });
    }
    let next = Object.getPrototypeOf(obj);
    if (!next)
      return options;
    obj = next;
  }
}
function scopeCompletionSource(scope2) {
  let cache2 = new Map();
  return (context) => {
    let path = completionPath(context);
    if (!path)
      return null;
    let target = scope2;
    for (let step of path.path) {
      target = target[step];
      if (!target)
        return null;
    }
    let options = cache2.get(target);
    if (!options)
      cache2.set(target, options = enumeratePropertyCompletions(target, !path.path.length));
    return {
      from: context.pos - path.name.length,
      options,
      validFor: Identifier
    };
  };
}
const javascriptLanguage = /* @__PURE__ */ LRLanguage.define({
  name: "javascript",
  parser: /* @__PURE__ */ parser$1.configure({
    props: [
      /* @__PURE__ */ indentNodeProp.add({
        IfStatement: /* @__PURE__ */ continuedIndent({ except: /^\s*({|else\b)/ }),
        TryStatement: /* @__PURE__ */ continuedIndent({ except: /^\s*({|catch\b|finally\b)/ }),
        LabeledStatement: flatIndent,
        SwitchBody: (context) => {
          let after = context.textAfter, closed = /^\s*\}/.test(after), isCase = /^\s*(case|default)\b/.test(after);
          return context.baseIndent + (closed ? 0 : isCase ? 1 : 2) * context.unit;
        },
        Block: /* @__PURE__ */ delimitedIndent({ closing: "}" }),
        ArrowFunction: (cx2) => cx2.baseIndent + cx2.unit,
        "TemplateString BlockComment": () => null,
        "Statement Property": /* @__PURE__ */ continuedIndent({ except: /^{/ }),
        JSXElement(context) {
          let closed = /^\s*<\//.test(context.textAfter);
          return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
        },
        JSXEscape(context) {
          let closed = /\s*\}/.test(context.textAfter);
          return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
        },
        "JSXOpenTag JSXSelfClosingTag"(context) {
          return context.column(context.node.from) + context.unit;
        }
      }),
      /* @__PURE__ */ foldNodeProp.add({
        "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": foldInside,
        BlockComment(tree) {
          return { from: tree.from + 2, to: tree.to - 2 };
        }
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["(", "[", "{", "'", '"', "`"] },
    commentTokens: { line: "//", block: { open: "/*", close: "*/" } },
    indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
    wordChars: "$"
  }
});
const jsxSublanguage = {
  test: (node2) => /^JSX/.test(node2.name),
  facet: /* @__PURE__ */ defineLanguageFacet({ commentTokens: { block: { open: "{/*", close: "*/}" } } })
};
const typescriptLanguage = /* @__PURE__ */ javascriptLanguage.configure({ dialect: "ts" }, "typescript");
const jsxLanguage = /* @__PURE__ */ javascriptLanguage.configure({
  dialect: "jsx",
  props: [/* @__PURE__ */ sublanguageProp.add((n2) => n2.isTop ? [jsxSublanguage] : void 0)]
});
const tsxLanguage = /* @__PURE__ */ javascriptLanguage.configure({
  dialect: "jsx ts",
  props: [/* @__PURE__ */ sublanguageProp.add((n2) => n2.isTop ? [jsxSublanguage] : void 0)]
}, "typescript");
const keywords = /* @__PURE__ */ "break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield".split(" ").map((kw2) => ({ label: kw2, type: "keyword" }));
function javascript(config2 = {}) {
  let lang = config2.jsx ? config2.typescript ? tsxLanguage : jsxLanguage : config2.typescript ? typescriptLanguage : javascriptLanguage;
  return new LanguageSupport(lang, [
    javascriptLanguage.data.of({
      autocomplete: ifNotIn(dontComplete, completeFromList(snippets.concat(keywords)))
    }),
    javascriptLanguage.data.of({
      autocomplete: localCompletionSource
    }),
    config2.jsx ? autoCloseTags$1 : []
  ]);
}
function findOpenTag(node2) {
  for (; ; ) {
    if (node2.name == "JSXOpenTag" || node2.name == "JSXSelfClosingTag" || node2.name == "JSXFragmentTag")
      return node2;
    if (node2.name == "JSXEscape" || !node2.parent)
      return null;
    node2 = node2.parent;
  }
}
function elementName$1(doc2, tree, max = doc2.length) {
  for (let ch2 = tree === null || tree === void 0 ? void 0 : tree.firstChild; ch2; ch2 = ch2.nextSibling) {
    if (ch2.name == "JSXIdentifier" || ch2.name == "JSXBuiltin" || ch2.name == "JSXNamespacedName" || ch2.name == "JSXMemberExpression")
      return doc2.sliceString(ch2.from, Math.min(ch2.to, max));
  }
  return "";
}
function isEndTag(node2) {
  return node2 && (node2.name == "JSXEndTag" || node2.name == "JSXSelfCloseEndTag");
}
const android = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent);
const autoCloseTags$1 = /* @__PURE__ */ EditorView.inputHandler.of((view, from, to2, text) => {
  if ((android ? view.composing : view.compositionStarted) || view.state.readOnly || from != to2 || text != ">" && text != "/" || !javascriptLanguage.isActiveAt(view.state, from, -1))
    return false;
  let { state } = view;
  let changes = state.changeByRange((range3) => {
    var _a2;
    let { head } = range3, around = syntaxTree(state).resolveInner(head, -1), name2;
    if (around.name == "JSXStartTag")
      around = around.parent;
    if (around.name == "JSXAttributeValue" && around.to > head)
      ;
    else if (text == ">" && around.name == "JSXFragmentTag") {
      return { range: EditorSelection.cursor(head + 1), changes: { from: head, insert: `></>` } };
    } else if (text == "/" && around.name == "JSXFragmentTag") {
      let empty2 = around.parent, base2 = empty2 === null || empty2 === void 0 ? void 0 : empty2.parent;
      if (empty2.from == head - 1 && ((_a2 = base2.lastChild) === null || _a2 === void 0 ? void 0 : _a2.name) != "JSXEndTag" && (name2 = elementName$1(state.doc, base2 === null || base2 === void 0 ? void 0 : base2.firstChild, head))) {
        let insert2 = `/${name2}>`;
        return { range: EditorSelection.cursor(head + insert2.length), changes: { from: head, insert: insert2 } };
      }
    } else if (text == ">") {
      let openTag = findOpenTag(around);
      if (openTag && !isEndTag(openTag.lastChild) && state.sliceDoc(head, head + 2) != "</" && (name2 = elementName$1(state.doc, openTag, head)))
        return { range: EditorSelection.cursor(head + 1), changes: { from: head, insert: `></${name2}>` } };
    }
    return { range: range3 };
  });
  if (changes.changes.empty)
    return false;
  view.dispatch(changes, { userEvent: "input.type", scrollIntoView: true });
  return true;
});
function esLint(eslint, config2) {
  if (!config2) {
    config2 = {
      parserOptions: { ecmaVersion: 2019, sourceType: "module" },
      env: { browser: true, node: true, es6: true, es2015: true, es2017: true, es2020: true },
      rules: {}
    };
    eslint.getRules().forEach((desc, name2) => {
      if (desc.meta.docs.recommended)
        config2.rules[name2] = 2;
    });
  }
  return (view) => {
    let { state } = view, found = [];
    for (let { from, to: to2 } of javascriptLanguage.findRegions(state)) {
      let fromLine = state.doc.lineAt(from), offset = { line: fromLine.number - 1, col: from - fromLine.from, pos: from };
      for (let d2 of eslint.verify(state.sliceDoc(from, to2), config2))
        found.push(translateDiagnostic(d2, state.doc, offset));
    }
    return found;
  };
}
function mapPos(line, col, doc2, offset) {
  return doc2.line(line + offset.line).from + col + (line == 1 ? offset.col - 1 : -1);
}
function translateDiagnostic(input, doc2, offset) {
  let start = mapPos(input.line, input.column, doc2, offset);
  let result2 = {
    from: start,
    to: input.endLine != null && input.endColumn != 1 ? mapPos(input.endLine, input.endColumn, doc2, offset) : start,
    message: input.message,
    source: input.ruleId ? "eslint:" + input.ruleId : "eslint",
    severity: input.severity == 1 ? "warning" : "error"
  };
  if (input.fix) {
    let { range: range3, text } = input.fix, from = range3[0] + offset.pos - start, to2 = range3[1] + offset.pos - start;
    result2.actions = [{
      name: "fix",
      apply(view, start2) {
        view.dispatch({ changes: { from: start2 + from, to: start2 + to2, insert: text }, scrollIntoView: true });
      }
    }];
  }
  return result2;
}
const Targets = ["_blank", "_self", "_top", "_parent"];
const Charsets = ["ascii", "utf-8", "utf-16", "latin1", "latin1"];
const Methods = ["get", "post", "put", "delete"];
const Encs = ["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"];
const Bool = ["true", "false"];
const S$1 = {};
const Tags = {
  a: {
    attrs: {
      href: null,
      ping: null,
      type: null,
      media: null,
      target: Targets,
      hreflang: null
    }
  },
  abbr: S$1,
  address: S$1,
  area: {
    attrs: {
      alt: null,
      coords: null,
      href: null,
      target: null,
      ping: null,
      media: null,
      hreflang: null,
      type: null,
      shape: ["default", "rect", "circle", "poly"]
    }
  },
  article: S$1,
  aside: S$1,
  audio: {
    attrs: {
      src: null,
      mediagroup: null,
      crossorigin: ["anonymous", "use-credentials"],
      preload: ["none", "metadata", "auto"],
      autoplay: ["autoplay"],
      loop: ["loop"],
      controls: ["controls"]
    }
  },
  b: S$1,
  base: { attrs: { href: null, target: Targets } },
  bdi: S$1,
  bdo: S$1,
  blockquote: { attrs: { cite: null } },
  body: S$1,
  br: S$1,
  button: {
    attrs: {
      form: null,
      formaction: null,
      name: null,
      value: null,
      autofocus: ["autofocus"],
      disabled: ["autofocus"],
      formenctype: Encs,
      formmethod: Methods,
      formnovalidate: ["novalidate"],
      formtarget: Targets,
      type: ["submit", "reset", "button"]
    }
  },
  canvas: { attrs: { width: null, height: null } },
  caption: S$1,
  center: S$1,
  cite: S$1,
  code: S$1,
  col: { attrs: { span: null } },
  colgroup: { attrs: { span: null } },
  command: {
    attrs: {
      type: ["command", "checkbox", "radio"],
      label: null,
      icon: null,
      radiogroup: null,
      command: null,
      title: null,
      disabled: ["disabled"],
      checked: ["checked"]
    }
  },
  data: { attrs: { value: null } },
  datagrid: { attrs: { disabled: ["disabled"], multiple: ["multiple"] } },
  datalist: { attrs: { data: null } },
  dd: S$1,
  del: { attrs: { cite: null, datetime: null } },
  details: { attrs: { open: ["open"] } },
  dfn: S$1,
  div: S$1,
  dl: S$1,
  dt: S$1,
  em: S$1,
  embed: { attrs: { src: null, type: null, width: null, height: null } },
  eventsource: { attrs: { src: null } },
  fieldset: { attrs: { disabled: ["disabled"], form: null, name: null } },
  figcaption: S$1,
  figure: S$1,
  footer: S$1,
  form: {
    attrs: {
      action: null,
      name: null,
      "accept-charset": Charsets,
      autocomplete: ["on", "off"],
      enctype: Encs,
      method: Methods,
      novalidate: ["novalidate"],
      target: Targets
    }
  },
  h1: S$1,
  h2: S$1,
  h3: S$1,
  h4: S$1,
  h5: S$1,
  h6: S$1,
  head: {
    children: ["title", "base", "link", "style", "meta", "script", "noscript", "command"]
  },
  header: S$1,
  hgroup: S$1,
  hr: S$1,
  html: {
    attrs: { manifest: null }
  },
  i: S$1,
  iframe: {
    attrs: {
      src: null,
      srcdoc: null,
      name: null,
      width: null,
      height: null,
      sandbox: ["allow-top-navigation", "allow-same-origin", "allow-forms", "allow-scripts"],
      seamless: ["seamless"]
    }
  },
  img: {
    attrs: {
      alt: null,
      src: null,
      ismap: null,
      usemap: null,
      width: null,
      height: null,
      crossorigin: ["anonymous", "use-credentials"]
    }
  },
  input: {
    attrs: {
      alt: null,
      dirname: null,
      form: null,
      formaction: null,
      height: null,
      list: null,
      max: null,
      maxlength: null,
      min: null,
      name: null,
      pattern: null,
      placeholder: null,
      size: null,
      src: null,
      step: null,
      value: null,
      width: null,
      accept: ["audio/*", "video/*", "image/*"],
      autocomplete: ["on", "off"],
      autofocus: ["autofocus"],
      checked: ["checked"],
      disabled: ["disabled"],
      formenctype: Encs,
      formmethod: Methods,
      formnovalidate: ["novalidate"],
      formtarget: Targets,
      multiple: ["multiple"],
      readonly: ["readonly"],
      required: ["required"],
      type: [
        "hidden",
        "text",
        "search",
        "tel",
        "url",
        "email",
        "password",
        "datetime",
        "date",
        "month",
        "week",
        "time",
        "datetime-local",
        "number",
        "range",
        "color",
        "checkbox",
        "radio",
        "file",
        "submit",
        "image",
        "reset",
        "button"
      ]
    }
  },
  ins: { attrs: { cite: null, datetime: null } },
  kbd: S$1,
  keygen: {
    attrs: {
      challenge: null,
      form: null,
      name: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      keytype: ["RSA"]
    }
  },
  label: { attrs: { for: null, form: null } },
  legend: S$1,
  li: { attrs: { value: null } },
  link: {
    attrs: {
      href: null,
      type: null,
      hreflang: null,
      media: null,
      sizes: ["all", "16x16", "16x16 32x32", "16x16 32x32 64x64"]
    }
  },
  map: { attrs: { name: null } },
  mark: S$1,
  menu: { attrs: { label: null, type: ["list", "context", "toolbar"] } },
  meta: {
    attrs: {
      content: null,
      charset: Charsets,
      name: ["viewport", "application-name", "author", "description", "generator", "keywords"],
      "http-equiv": ["content-language", "content-type", "default-style", "refresh"]
    }
  },
  meter: { attrs: { value: null, min: null, low: null, high: null, max: null, optimum: null } },
  nav: S$1,
  noscript: S$1,
  object: {
    attrs: {
      data: null,
      type: null,
      name: null,
      usemap: null,
      form: null,
      width: null,
      height: null,
      typemustmatch: ["typemustmatch"]
    }
  },
  ol: {
    attrs: { reversed: ["reversed"], start: null, type: ["1", "a", "A", "i", "I"] },
    children: ["li", "script", "template", "ul", "ol"]
  },
  optgroup: { attrs: { disabled: ["disabled"], label: null } },
  option: { attrs: { disabled: ["disabled"], label: null, selected: ["selected"], value: null } },
  output: { attrs: { for: null, form: null, name: null } },
  p: S$1,
  param: { attrs: { name: null, value: null } },
  pre: S$1,
  progress: { attrs: { value: null, max: null } },
  q: { attrs: { cite: null } },
  rp: S$1,
  rt: S$1,
  ruby: S$1,
  samp: S$1,
  script: {
    attrs: {
      type: ["text/javascript"],
      src: null,
      async: ["async"],
      defer: ["defer"],
      charset: Charsets
    }
  },
  section: S$1,
  select: {
    attrs: {
      form: null,
      name: null,
      size: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      multiple: ["multiple"]
    }
  },
  slot: { attrs: { name: null } },
  small: S$1,
  source: { attrs: { src: null, type: null, media: null } },
  span: S$1,
  strong: S$1,
  style: {
    attrs: {
      type: ["text/css"],
      media: null,
      scoped: null
    }
  },
  sub: S$1,
  summary: S$1,
  sup: S$1,
  table: S$1,
  tbody: S$1,
  td: { attrs: { colspan: null, rowspan: null, headers: null } },
  template: S$1,
  textarea: {
    attrs: {
      dirname: null,
      form: null,
      maxlength: null,
      name: null,
      placeholder: null,
      rows: null,
      cols: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      readonly: ["readonly"],
      required: ["required"],
      wrap: ["soft", "hard"]
    }
  },
  tfoot: S$1,
  th: { attrs: { colspan: null, rowspan: null, headers: null, scope: ["row", "col", "rowgroup", "colgroup"] } },
  thead: S$1,
  time: { attrs: { datetime: null } },
  title: S$1,
  tr: S$1,
  track: {
    attrs: {
      src: null,
      label: null,
      default: null,
      kind: ["subtitles", "captions", "descriptions", "chapters", "metadata"],
      srclang: null
    }
  },
  ul: { children: ["li", "script", "template", "ul", "ol"] },
  var: S$1,
  video: {
    attrs: {
      src: null,
      poster: null,
      width: null,
      height: null,
      crossorigin: ["anonymous", "use-credentials"],
      preload: ["auto", "metadata", "none"],
      autoplay: ["autoplay"],
      mediagroup: ["movie"],
      muted: ["muted"],
      controls: ["controls"]
    }
  },
  wbr: S$1
};
const GlobalAttrs = {
  accesskey: null,
  class: null,
  contenteditable: Bool,
  contextmenu: null,
  dir: ["ltr", "rtl", "auto"],
  draggable: ["true", "false", "auto"],
  dropzone: ["copy", "move", "link", "string:", "file:"],
  hidden: ["hidden"],
  id: null,
  inert: ["inert"],
  itemid: null,
  itemprop: null,
  itemref: null,
  itemscope: ["itemscope"],
  itemtype: null,
  lang: ["ar", "bn", "de", "en-GB", "en-US", "es", "fr", "hi", "id", "ja", "pa", "pt", "ru", "tr", "zh"],
  spellcheck: Bool,
  autocorrect: Bool,
  autocapitalize: Bool,
  style: null,
  tabindex: null,
  title: null,
  translate: ["yes", "no"],
  rel: ["stylesheet", "alternate", "author", "bookmark", "help", "license", "next", "nofollow", "noreferrer", "prefetch", "prev", "search", "tag"],
  role: /* @__PURE__ */ "alert application article banner button cell checkbox complementary contentinfo dialog document feed figure form grid gridcell heading img list listbox listitem main navigation region row rowgroup search switch tab table tabpanel textbox timer".split(" "),
  "aria-activedescendant": null,
  "aria-atomic": Bool,
  "aria-autocomplete": ["inline", "list", "both", "none"],
  "aria-busy": Bool,
  "aria-checked": ["true", "false", "mixed", "undefined"],
  "aria-controls": null,
  "aria-describedby": null,
  "aria-disabled": Bool,
  "aria-dropeffect": null,
  "aria-expanded": ["true", "false", "undefined"],
  "aria-flowto": null,
  "aria-grabbed": ["true", "false", "undefined"],
  "aria-haspopup": Bool,
  "aria-hidden": Bool,
  "aria-invalid": ["true", "false", "grammar", "spelling"],
  "aria-label": null,
  "aria-labelledby": null,
  "aria-level": null,
  "aria-live": ["off", "polite", "assertive"],
  "aria-multiline": Bool,
  "aria-multiselectable": Bool,
  "aria-owns": null,
  "aria-posinset": null,
  "aria-pressed": ["true", "false", "mixed", "undefined"],
  "aria-readonly": Bool,
  "aria-relevant": null,
  "aria-required": Bool,
  "aria-selected": ["true", "false", "undefined"],
  "aria-setsize": null,
  "aria-sort": ["ascending", "descending", "none", "other"],
  "aria-valuemax": null,
  "aria-valuemin": null,
  "aria-valuenow": null,
  "aria-valuetext": null
};
const eventAttributes = /* @__PURE__ */ "beforeunload copy cut dragstart dragover dragleave dragenter dragend drag paste focus blur change click load mousedown mouseenter mouseleave mouseup keydown keyup resize scroll unload".split(" ").map((n2) => "on" + n2);
for (let a2 of eventAttributes)
  GlobalAttrs[a2] = null;
class Schema {
  constructor(extraTags, extraAttrs) {
    this.tags = Object.assign(Object.assign({}, Tags), extraTags);
    this.globalAttrs = Object.assign(Object.assign({}, GlobalAttrs), extraAttrs);
    this.allTags = Object.keys(this.tags);
    this.globalAttrNames = Object.keys(this.globalAttrs);
  }
}
Schema.default = /* @__PURE__ */ new Schema();
function elementName(doc2, tree, max = doc2.length) {
  if (!tree)
    return "";
  let tag = tree.firstChild;
  let name2 = tag && tag.getChild("TagName");
  return name2 ? doc2.sliceString(name2.from, Math.min(name2.to, max)) : "";
}
function findParentElement(tree, skip = false) {
  for (; tree; tree = tree.parent)
    if (tree.name == "Element") {
      if (skip)
        skip = false;
      else
        return tree;
    }
  return null;
}
function allowedChildren(doc2, tree, schema) {
  let parentInfo = schema.tags[elementName(doc2, findParentElement(tree))];
  return (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.children) || schema.allTags;
}
function openTags(doc2, tree) {
  let open = [];
  for (let parent = findParentElement(tree); parent && !parent.type.isTop; parent = findParentElement(parent.parent)) {
    let tagName = elementName(doc2, parent);
    if (tagName && parent.lastChild.name == "CloseTag")
      break;
    if (tagName && open.indexOf(tagName) < 0 && (tree.name == "EndTag" || tree.from >= parent.firstChild.to))
      open.push(tagName);
  }
  return open;
}
const identifier = /^[:\-\.\w\u00b7-\uffff]*$/;
function completeTag(state, schema, tree, from, to2) {
  let end = /\s*>/.test(state.sliceDoc(to2, to2 + 5)) ? "" : ">";
  let parent = findParentElement(tree, true);
  return {
    from,
    to: to2,
    options: allowedChildren(state.doc, parent, schema).map((tagName) => ({ label: tagName, type: "type" })).concat(openTags(state.doc, tree).map((tag, i2) => ({
      label: "/" + tag,
      apply: "/" + tag + end,
      type: "type",
      boost: 99 - i2
    }))),
    validFor: /^\/?[:\-\.\w\u00b7-\uffff]*$/
  };
}
function completeCloseTag(state, tree, from, to2) {
  let end = /\s*>/.test(state.sliceDoc(to2, to2 + 5)) ? "" : ">";
  return {
    from,
    to: to2,
    options: openTags(state.doc, tree).map((tag, i2) => ({ label: tag, apply: tag + end, type: "type", boost: 99 - i2 })),
    validFor: identifier
  };
}
function completeStartTag(state, schema, tree, pos) {
  let options = [], level = 0;
  for (let tagName of allowedChildren(state.doc, tree, schema))
    options.push({ label: "<" + tagName, type: "type" });
  for (let open of openTags(state.doc, tree))
    options.push({ label: "</" + open + ">", type: "type", boost: 99 - level++ });
  return { from: pos, to: pos, options, validFor: /^<\/?[:\-\.\w\u00b7-\uffff]*$/ };
}
function completeAttrName(state, schema, tree, from, to2) {
  let elt = findParentElement(tree), info = elt ? schema.tags[elementName(state.doc, elt)] : null;
  let localAttrs = info && info.attrs ? Object.keys(info.attrs) : [];
  let names = info && info.globalAttrs === false ? localAttrs : localAttrs.length ? localAttrs.concat(schema.globalAttrNames) : schema.globalAttrNames;
  return {
    from,
    to: to2,
    options: names.map((attrName) => ({ label: attrName, type: "property" })),
    validFor: identifier
  };
}
function completeAttrValue(state, schema, tree, from, to2) {
  var _a2;
  let nameNode = (_a2 = tree.parent) === null || _a2 === void 0 ? void 0 : _a2.getChild("AttributeName");
  let options = [], token = void 0;
  if (nameNode) {
    let attrName = state.sliceDoc(nameNode.from, nameNode.to);
    let attrs = schema.globalAttrs[attrName];
    if (!attrs) {
      let elt = findParentElement(tree), info = elt ? schema.tags[elementName(state.doc, elt)] : null;
      attrs = (info === null || info === void 0 ? void 0 : info.attrs) && info.attrs[attrName];
    }
    if (attrs) {
      let base2 = state.sliceDoc(from, to2).toLowerCase(), quoteStart = '"', quoteEnd = '"';
      if (/^['"]/.test(base2)) {
        token = base2[0] == '"' ? /^[^"]*$/ : /^[^']*$/;
        quoteStart = "";
        quoteEnd = state.sliceDoc(to2, to2 + 1) == base2[0] ? "" : base2[0];
        base2 = base2.slice(1);
        from++;
      } else {
        token = /^[^\s<>='"]*$/;
      }
      for (let value2 of attrs)
        options.push({ label: value2, apply: quoteStart + value2 + quoteEnd, type: "constant" });
    }
  }
  return { from, to: to2, options, validFor: token };
}
function htmlCompletionFor(schema, context) {
  let { state, pos } = context, tree = syntaxTree(state).resolveInner(pos, -1), around = tree.resolve(pos);
  for (let scan = pos, before; around == tree && (before = tree.childBefore(scan)); ) {
    let last = before.lastChild;
    if (!last || !last.type.isError || last.from < last.to)
      break;
    around = tree = before;
    scan = last.from;
  }
  if (tree.name == "TagName") {
    return tree.parent && /CloseTag$/.test(tree.parent.name) ? completeCloseTag(state, tree, tree.from, pos) : completeTag(state, schema, tree, tree.from, pos);
  } else if (tree.name == "StartTag") {
    return completeTag(state, schema, tree, pos, pos);
  } else if (tree.name == "StartCloseTag" || tree.name == "IncompleteCloseTag") {
    return completeCloseTag(state, tree, pos, pos);
  } else if (context.explicit && (tree.name == "OpenTag" || tree.name == "SelfClosingTag") || tree.name == "AttributeName") {
    return completeAttrName(state, schema, tree, tree.name == "AttributeName" ? tree.from : pos, pos);
  } else if (tree.name == "Is" || tree.name == "AttributeValue" || tree.name == "UnquotedAttributeValue") {
    return completeAttrValue(state, schema, tree, tree.name == "Is" ? pos : tree.from, pos);
  } else if (context.explicit && (around.name == "Element" || around.name == "Text" || around.name == "Document")) {
    return completeStartTag(state, schema, tree, pos);
  } else {
    return null;
  }
}
function htmlCompletionSource(context) {
  return htmlCompletionFor(Schema.default, context);
}
function htmlCompletionSourceWith(config2) {
  let { extraTags, extraGlobalAttributes: extraAttrs } = config2;
  let schema = extraAttrs || extraTags ? new Schema(extraTags, extraAttrs) : Schema.default;
  return (context) => htmlCompletionFor(schema, context);
}
const defaultNesting = [
  {
    tag: "script",
    attrs: (attrs) => attrs.type == "text/typescript" || attrs.lang == "ts",
    parser: typescriptLanguage.parser
  },
  {
    tag: "script",
    attrs: (attrs) => attrs.type == "text/babel" || attrs.type == "text/jsx",
    parser: jsxLanguage.parser
  },
  {
    tag: "script",
    attrs: (attrs) => attrs.type == "text/typescript-jsx",
    parser: tsxLanguage.parser
  },
  {
    tag: "script",
    attrs(attrs) {
      return !attrs.type || /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i.test(attrs.type);
    },
    parser: javascriptLanguage.parser
  },
  {
    tag: "style",
    attrs(attrs) {
      return (!attrs.lang || attrs.lang == "css") && (!attrs.type || /^(text\/)?(x-)?(stylesheet|css)$/i.test(attrs.type));
    },
    parser: cssLanguage.parser
  }
];
const defaultAttrs = /* @__PURE__ */ [
  {
    name: "style",
    parser: /* @__PURE__ */ cssLanguage.parser.configure({ top: "Styles" })
  }
].concat(/* @__PURE__ */ eventAttributes.map((name2) => ({ name: name2, parser: javascriptLanguage.parser })));
const htmlPlain = /* @__PURE__ */ LRLanguage.define({
  name: "html",
  parser: /* @__PURE__ */ parser$3.configure({
    props: [
      /* @__PURE__ */ indentNodeProp.add({
        Element(context) {
          let after = /^(\s*)(<\/)?/.exec(context.textAfter);
          if (context.node.to <= context.pos + after[0].length)
            return context.continue();
          return context.lineIndent(context.node.from) + (after[2] ? 0 : context.unit);
        },
        "OpenTag CloseTag SelfClosingTag"(context) {
          return context.column(context.node.from) + context.unit;
        },
        Document(context) {
          if (context.pos + /\s*/.exec(context.textAfter)[0].length < context.node.to)
            return context.continue();
          let endElt = null, close;
          for (let cur2 = context.node; ; ) {
            let last = cur2.lastChild;
            if (!last || last.name != "Element" || last.to != cur2.to)
              break;
            endElt = cur2 = last;
          }
          if (endElt && !((close = endElt.lastChild) && (close.name == "CloseTag" || close.name == "SelfClosingTag")))
            return context.lineIndent(endElt.from) + context.unit;
          return null;
        }
      }),
      /* @__PURE__ */ foldNodeProp.add({
        Element(node2) {
          let first = node2.firstChild, last = node2.lastChild;
          if (!first || first.name != "OpenTag")
            return null;
          return { from: first.to, to: last.name == "CloseTag" ? last.from : node2.to };
        }
      }),
      /* @__PURE__ */ bracketMatchingHandle.add({
        "OpenTag CloseTag": (node2) => node2.getChild("TagName")
      })
    ]
  }),
  languageData: {
    commentTokens: { block: { open: "<!--", close: "-->" } },
    indentOnInput: /^\s*<\/\w+\W$/,
    wordChars: "-._"
  }
});
const htmlLanguage = /* @__PURE__ */ htmlPlain.configure({
  wrap: /* @__PURE__ */ configureNesting(defaultNesting, defaultAttrs)
});
function html(config2 = {}) {
  let dialect = "", wrap;
  if (config2.matchClosingTags === false)
    dialect = "noMatch";
  if (config2.selfClosingTags === true)
    dialect = (dialect ? dialect + " " : "") + "selfClosing";
  if (config2.nestedLanguages && config2.nestedLanguages.length || config2.nestedAttributes && config2.nestedAttributes.length)
    wrap = configureNesting((config2.nestedLanguages || []).concat(defaultNesting), (config2.nestedAttributes || []).concat(defaultAttrs));
  let lang = wrap ? htmlPlain.configure({ wrap, dialect }) : dialect ? htmlLanguage.configure({ dialect }) : htmlLanguage;
  return new LanguageSupport(lang, [
    htmlLanguage.data.of({ autocomplete: htmlCompletionSourceWith(config2) }),
    config2.autoCloseTags !== false ? autoCloseTags : [],
    javascript().support,
    css().support
  ]);
}
const selfClosers = /* @__PURE__ */ new Set(/* @__PURE__ */ "area base br col command embed frame hr img input keygen link meta param source track wbr menuitem".split(" "));
const autoCloseTags = /* @__PURE__ */ EditorView.inputHandler.of((view, from, to2, text) => {
  if (view.composing || view.state.readOnly || from != to2 || text != ">" && text != "/" || !htmlLanguage.isActiveAt(view.state, from, -1))
    return false;
  let { state } = view;
  let changes = state.changeByRange((range3) => {
    var _a2, _b2, _c2;
    let { head } = range3, around = syntaxTree(state).resolveInner(head, -1), name2;
    if (around.name == "TagName" || around.name == "StartTag")
      around = around.parent;
    if (text == ">" && around.name == "OpenTag") {
      if (((_b2 = (_a2 = around.parent) === null || _a2 === void 0 ? void 0 : _a2.lastChild) === null || _b2 === void 0 ? void 0 : _b2.name) != "CloseTag" && (name2 = elementName(state.doc, around.parent, head)) && !selfClosers.has(name2)) {
        let hasRightBracket = view.state.doc.sliceString(head, head + 1) === ">";
        let insert2 = `${hasRightBracket ? "" : ">"}</${name2}>`;
        return { range: EditorSelection.cursor(head + 1), changes: { from: head + (hasRightBracket ? 1 : 0), insert: insert2 } };
      }
    } else if (text == "/" && around.name == "OpenTag") {
      let empty2 = around.parent, base2 = empty2 === null || empty2 === void 0 ? void 0 : empty2.parent;
      if (empty2.from == head - 1 && ((_c2 = base2.lastChild) === null || _c2 === void 0 ? void 0 : _c2.name) != "CloseTag" && (name2 = elementName(state.doc, base2, head)) && !selfClosers.has(name2)) {
        let hasRightBracket = view.state.doc.sliceString(head, head + 1) === ">";
        let insert2 = `/${name2}${hasRightBracket ? "" : ">"}`;
        let pos = head + insert2.length + (hasRightBracket ? 1 : 0);
        return { range: EditorSelection.cursor(pos), changes: { from: head, insert: insert2 } };
      }
    }
    return { range: range3 };
  });
  if (changes.changes.empty)
    return false;
  view.dispatch(changes, { userEvent: "input.type", scrollIntoView: true });
  return true;
});
const jsonHighlighting = styleTags({
  String: tags$1.string,
  Number: tags$1.number,
  "True False": tags$1.bool,
  PropertyName: tags$1.propertyName,
  Null: tags$1.null,
  ",": tags$1.separator,
  "[ ]": tags$1.squareBracket,
  "{ }": tags$1.brace
});
const parser = LRParser.deserialize({
  version: 14,
  states: "$bOVQPOOOOQO'#Cb'#CbOnQPO'#CeOvQPO'#CjOOQO'#Cp'#CpQOQPOOOOQO'#Cg'#CgO}QPO'#CfO!SQPO'#CrOOQO,59P,59PO![QPO,59PO!aQPO'#CuOOQO,59U,59UO!iQPO,59UOVQPO,59QOqQPO'#CkO!nQPO,59^OOQO1G.k1G.kOVQPO'#ClO!vQPO,59aOOQO1G.p1G.pOOQO1G.l1G.lOOQO,59V,59VOOQO-E6i-E6iOOQO,59W,59WOOQO-E6j-E6j",
  stateData: "#O~OcOS~OQSORSOSSOTSOWQO]ROePO~OVXOeUO~O[[O~PVOg^O~Oh_OVfX~OVaO~OhbO[iX~O[dO~Oh_OVfa~OhbO[ia~O",
  goto: "!kjPPPPPPkPPkqwPPk{!RPPP!XP!ePP!hXSOR^bQWQRf_TVQ_Q`WRg`QcZRicQTOQZRQe^RhbRYQR]R",
  nodeNames: "\u26A0 JsonText True False Null Number String } { Object Property PropertyName ] [ Array",
  maxTerm: 25,
  nodeProps: [
    ["openedBy", 7, "{", 12, "["],
    ["closedBy", 8, "}", 13, "]"]
  ],
  propSources: [jsonHighlighting],
  skippedNodes: [0],
  repeatNodeCount: 2,
  tokenData: "(|~RaXY!WYZ!W]^!Wpq!Wrs!]|}$u}!O$z!Q!R%T!R![&c![!]&t!}#O&y#P#Q'O#Y#Z'T#b#c'r#h#i(Z#o#p(r#q#r(w~!]Oc~~!`Wpq!]qr!]rs!xs#O!]#O#P!}#P;'S!];'S;=`$o<%lO!]~!}Oe~~#QXrs!]!P!Q!]#O#P!]#U#V!]#Y#Z!]#b#c!]#f#g!]#h#i!]#i#j#m~#pR!Q![#y!c!i#y#T#Z#y~#|R!Q![$V!c!i$V#T#Z$V~$YR!Q![$c!c!i$c#T#Z$c~$fR!Q![!]!c!i!]#T#Z!]~$rP;=`<%l!]~$zOh~~$}Q!Q!R%T!R![&c~%YRT~!O!P%c!g!h%w#X#Y%w~%fP!Q![%i~%nRT~!Q![%i!g!h%w#X#Y%w~%zR{|&T}!O&T!Q![&Z~&WP!Q![&Z~&`PT~!Q![&Z~&hST~!O!P%c!Q![&c!g!h%w#X#Y%w~&yOg~~'OO]~~'TO[~~'WP#T#U'Z~'^P#`#a'a~'dP#g#h'g~'jP#X#Y'm~'rOR~~'uP#i#j'x~'{P#`#a(O~(RP#`#a(U~(ZOS~~(^P#f#g(a~(dP#i#j(g~(jP#X#Y(m~(rOQ~~(wOW~~(|OV~",
  tokenizers: [0],
  topRules: { "JsonText": [0, 1] },
  tokenPrec: 0
});
const jsonParseLinter = () => (view) => {
  try {
    JSON.parse(view.state.doc.toString());
  } catch (e25) {
    if (!(e25 instanceof SyntaxError))
      throw e25;
    const pos = getErrorPosition(e25, view.state.doc);
    return [{
      from: pos,
      message: e25.message,
      severity: "error",
      to: pos
    }];
  }
  return [];
};
function getErrorPosition(error, doc2) {
  let m2;
  if (m2 = error.message.match(/at position (\d+)/))
    return Math.min(+m2[1], doc2.length);
  if (m2 = error.message.match(/at line (\d+) column (\d+)/))
    return Math.min(doc2.line(+m2[1]).from + +m2[2] - 1, doc2.length);
  return 0;
}
const jsonLanguage = /* @__PURE__ */ LRLanguage.define({
  name: "json",
  parser: /* @__PURE__ */ parser.configure({
    props: [
      /* @__PURE__ */ indentNodeProp.add({
        Object: /* @__PURE__ */ continuedIndent({ except: /^\s*\}/ }),
        Array: /* @__PURE__ */ continuedIndent({ except: /^\s*\]/ })
      }),
      /* @__PURE__ */ foldNodeProp.add({
        "Object Array": foldInside
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["[", "{", '"'] },
    indentOnInput: /^\s*[\}\]]$/
  }
});
function json() {
  return new LanguageSupport(jsonLanguage);
}
function crelt() {
  var elt = arguments[0];
  if (typeof elt == "string")
    elt = document.createElement(elt);
  var i2 = 1, next = arguments[1];
  if (next && typeof next == "object" && next.nodeType == null && !Array.isArray(next)) {
    for (var name2 in next)
      if (Object.prototype.hasOwnProperty.call(next, name2)) {
        var value2 = next[name2];
        if (typeof value2 == "string")
          elt.setAttribute(name2, value2);
        else if (value2 != null)
          elt[name2] = value2;
      }
    i2++;
  }
  for (; i2 < arguments.length; i2++)
    add(elt, arguments[i2]);
  return elt;
}
function add(elt, child) {
  if (typeof child == "string") {
    elt.appendChild(document.createTextNode(child));
  } else if (child == null)
    ;
  else if (child.nodeType != null) {
    elt.appendChild(child);
  } else if (Array.isArray(child)) {
    for (var i2 = 0; i2 < child.length; i2++)
      add(elt, child[i2]);
  } else {
    throw new RangeError("Unsupported child node: " + child);
  }
}
class SelectedDiagnostic {
  constructor(from, to2, diagnostic) {
    this.from = from;
    this.to = to2;
    this.diagnostic = diagnostic;
  }
}
class LintState {
  constructor(diagnostics, panel, selected) {
    this.diagnostics = diagnostics;
    this.panel = panel;
    this.selected = selected;
  }
  static init(diagnostics, panel, state) {
    let markedDiagnostics = diagnostics;
    let diagnosticFilter = state.facet(lintConfig).markerFilter;
    if (diagnosticFilter)
      markedDiagnostics = diagnosticFilter(markedDiagnostics);
    let ranges = Decoration.set(markedDiagnostics.map((d2) => {
      return d2.from == d2.to || d2.from == d2.to - 1 && state.doc.lineAt(d2.from).to == d2.from ? Decoration.widget({
        widget: new DiagnosticWidget(d2),
        diagnostic: d2
      }).range(d2.from) : Decoration.mark({
        attributes: { class: "cm-lintRange cm-lintRange-" + d2.severity + (d2.markClass ? " " + d2.markClass : "") },
        diagnostic: d2
      }).range(d2.from, d2.to);
    }), true);
    return new LintState(ranges, panel, findDiagnostic(ranges));
  }
}
function findDiagnostic(diagnostics, diagnostic = null, after = 0) {
  let found = null;
  diagnostics.between(after, 1e9, (from, to2, { spec: spec2 }) => {
    if (diagnostic && spec2.diagnostic != diagnostic)
      return;
    found = new SelectedDiagnostic(from, to2, spec2.diagnostic);
    return false;
  });
  return found;
}
function hideTooltip(tr2, tooltip) {
  let line = tr2.startState.doc.lineAt(tooltip.pos);
  return !!(tr2.effects.some((e25) => e25.is(setDiagnosticsEffect)) || tr2.changes.touchesRange(line.from, line.to));
}
function maybeEnableLint(state, effects) {
  return state.field(lintState, false) ? effects : effects.concat(StateEffect.appendConfig.of(lintExtensions));
}
function setDiagnostics(state, diagnostics) {
  return {
    effects: maybeEnableLint(state, [setDiagnosticsEffect.of(diagnostics)])
  };
}
const setDiagnosticsEffect = /* @__PURE__ */ StateEffect.define();
const togglePanel$1 = /* @__PURE__ */ StateEffect.define();
const movePanelSelection = /* @__PURE__ */ StateEffect.define();
const lintState = /* @__PURE__ */ StateField.define({
  create() {
    return new LintState(Decoration.none, null, null);
  },
  update(value2, tr2) {
    if (tr2.docChanged) {
      let mapped = value2.diagnostics.map(tr2.changes), selected = null;
      if (value2.selected) {
        let selPos = tr2.changes.mapPos(value2.selected.from, 1);
        selected = findDiagnostic(mapped, value2.selected.diagnostic, selPos) || findDiagnostic(mapped, null, selPos);
      }
      value2 = new LintState(mapped, value2.panel, selected);
    }
    for (let effect of tr2.effects) {
      if (effect.is(setDiagnosticsEffect)) {
        value2 = LintState.init(effect.value, value2.panel, tr2.state);
      } else if (effect.is(togglePanel$1)) {
        value2 = new LintState(value2.diagnostics, effect.value ? LintPanel.open : null, value2.selected);
      } else if (effect.is(movePanelSelection)) {
        value2 = new LintState(value2.diagnostics, value2.panel, effect.value);
      }
    }
    return value2;
  },
  provide: (f2) => [
    showPanel.from(f2, (val) => val.panel),
    EditorView.decorations.from(f2, (s2) => s2.diagnostics)
  ]
});
const activeMark = /* @__PURE__ */ Decoration.mark({ class: "cm-lintRange cm-lintRange-active" });
function lintTooltip(view, pos, side) {
  let { diagnostics } = view.state.field(lintState);
  let found = [], stackStart = 2e8, stackEnd = 0;
  diagnostics.between(pos - (side < 0 ? 1 : 0), pos + (side > 0 ? 1 : 0), (from, to2, { spec: spec2 }) => {
    if (pos >= from && pos <= to2 && (from == to2 || (pos > from || side > 0) && (pos < to2 || side < 0))) {
      found.push(spec2.diagnostic);
      stackStart = Math.min(from, stackStart);
      stackEnd = Math.max(to2, stackEnd);
    }
  });
  let diagnosticFilter = view.state.facet(lintConfig).tooltipFilter;
  if (diagnosticFilter)
    found = diagnosticFilter(found);
  if (!found.length)
    return null;
  return {
    pos: stackStart,
    end: stackEnd,
    above: view.state.doc.lineAt(stackStart).to < stackEnd,
    create() {
      return { dom: diagnosticsTooltip(view, found) };
    }
  };
}
function diagnosticsTooltip(view, diagnostics) {
  return crelt("ul", { class: "cm-tooltip-lint" }, diagnostics.map((d2) => renderDiagnostic(view, d2, false)));
}
const openLintPanel = (view) => {
  let field = view.state.field(lintState, false);
  if (!field || !field.panel)
    view.dispatch({ effects: maybeEnableLint(view.state, [togglePanel$1.of(true)]) });
  let panel = getPanel(view, LintPanel.open);
  if (panel)
    panel.dom.querySelector(".cm-panel-lint ul").focus();
  return true;
};
const closeLintPanel = (view) => {
  let field = view.state.field(lintState, false);
  if (!field || !field.panel)
    return false;
  view.dispatch({ effects: togglePanel$1.of(false) });
  return true;
};
const nextDiagnostic = (view) => {
  let field = view.state.field(lintState, false);
  if (!field)
    return false;
  let sel = view.state.selection.main, next = field.diagnostics.iter(sel.to + 1);
  if (!next.value) {
    next = field.diagnostics.iter(0);
    if (!next.value || next.from == sel.from && next.to == sel.to)
      return false;
  }
  view.dispatch({ selection: { anchor: next.from, head: next.to }, scrollIntoView: true });
  return true;
};
const lintKeymap = [
  { key: "Mod-Shift-m", run: openLintPanel, preventDefault: true },
  { key: "F8", run: nextDiagnostic }
];
const lintPlugin = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.timeout = -1;
    this.set = true;
    let { delay } = view.state.facet(lintConfig);
    this.lintTime = Date.now() + delay;
    this.run = this.run.bind(this);
    this.timeout = setTimeout(this.run, delay);
  }
  run() {
    let now2 = Date.now();
    if (now2 < this.lintTime - 10) {
      setTimeout(this.run, this.lintTime - now2);
    } else {
      this.set = false;
      let { state } = this.view, { sources } = state.facet(lintConfig);
      Promise.all(sources.map((source) => Promise.resolve(source(this.view)))).then((annotations) => {
        let all = annotations.reduce((a2, b2) => a2.concat(b2));
        if (this.view.state.doc == state.doc)
          this.view.dispatch(setDiagnostics(this.view.state, all));
      }, (error) => {
        logException(this.view.state, error);
      });
    }
  }
  update(update) {
    let config2 = update.state.facet(lintConfig);
    if (update.docChanged || config2 != update.startState.facet(lintConfig) || config2.needsRefresh && config2.needsRefresh(update)) {
      this.lintTime = Date.now() + config2.delay;
      if (!this.set) {
        this.set = true;
        this.timeout = setTimeout(this.run, config2.delay);
      }
    }
  }
  force() {
    if (this.set) {
      this.lintTime = Date.now();
      this.run();
    }
  }
  destroy() {
    clearTimeout(this.timeout);
  }
});
const lintConfig = /* @__PURE__ */ Facet.define({
  combine(input) {
    return Object.assign({ sources: input.map((i2) => i2.source) }, combineConfig(input.map((i2) => i2.config), {
      delay: 750,
      markerFilter: null,
      tooltipFilter: null,
      needsRefresh: null
    }, {
      needsRefresh: (a2, b2) => !a2 ? b2 : !b2 ? a2 : (u2) => a2(u2) || b2(u2)
    }));
  }
});
function linter(source, config2 = {}) {
  return [
    lintConfig.of({ source, config: config2 }),
    lintPlugin,
    lintExtensions
  ];
}
function assignKeys(actions) {
  let assigned = [];
  if (actions)
    actions:
      for (let { name: name2 } of actions) {
        for (let i2 = 0; i2 < name2.length; i2++) {
          let ch2 = name2[i2];
          if (/[a-zA-Z]/.test(ch2) && !assigned.some((c2) => c2.toLowerCase() == ch2.toLowerCase())) {
            assigned.push(ch2);
            continue actions;
          }
        }
        assigned.push("");
      }
  return assigned;
}
function renderDiagnostic(view, diagnostic, inPanel) {
  var _a2;
  let keys2 = inPanel ? assignKeys(diagnostic.actions) : [];
  return crelt("li", { class: "cm-diagnostic cm-diagnostic-" + diagnostic.severity }, crelt("span", { class: "cm-diagnosticText" }, diagnostic.renderMessage ? diagnostic.renderMessage() : diagnostic.message), (_a2 = diagnostic.actions) === null || _a2 === void 0 ? void 0 : _a2.map((action, i2) => {
    let fired = false, click = (e25) => {
      e25.preventDefault();
      if (fired)
        return;
      fired = true;
      let found = findDiagnostic(view.state.field(lintState).diagnostics, diagnostic);
      if (found)
        action.apply(view, found.from, found.to);
    };
    let { name: name2 } = action, keyIndex = keys2[i2] ? name2.indexOf(keys2[i2]) : -1;
    let nameElt = keyIndex < 0 ? name2 : [
      name2.slice(0, keyIndex),
      crelt("u", name2.slice(keyIndex, keyIndex + 1)),
      name2.slice(keyIndex + 1)
    ];
    return crelt("button", {
      type: "button",
      class: "cm-diagnosticAction",
      onclick: click,
      onmousedown: click,
      "aria-label": ` Action: ${name2}${keyIndex < 0 ? "" : ` (access key "${keys2[i2]})"`}.`
    }, nameElt);
  }), diagnostic.source && crelt("div", { class: "cm-diagnosticSource" }, diagnostic.source));
}
class DiagnosticWidget extends WidgetType {
  constructor(diagnostic) {
    super();
    this.diagnostic = diagnostic;
  }
  eq(other) {
    return other.diagnostic == this.diagnostic;
  }
  toDOM() {
    return crelt("span", { class: "cm-lintPoint cm-lintPoint-" + this.diagnostic.severity });
  }
}
class PanelItem {
  constructor(view, diagnostic) {
    this.diagnostic = diagnostic;
    this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16);
    this.dom = renderDiagnostic(view, diagnostic, true);
    this.dom.id = this.id;
    this.dom.setAttribute("role", "option");
  }
}
class LintPanel {
  constructor(view) {
    this.view = view;
    this.items = [];
    let onkeydown = (event) => {
      if (event.keyCode == 27) {
        closeLintPanel(this.view);
        this.view.focus();
      } else if (event.keyCode == 38 || event.keyCode == 33) {
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      } else if (event.keyCode == 40 || event.keyCode == 34) {
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      } else if (event.keyCode == 36) {
        this.moveSelection(0);
      } else if (event.keyCode == 35) {
        this.moveSelection(this.items.length - 1);
      } else if (event.keyCode == 13) {
        this.view.focus();
      } else if (event.keyCode >= 65 && event.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic } = this.items[this.selectedIndex], keys2 = assignKeys(diagnostic.actions);
        for (let i2 = 0; i2 < keys2.length; i2++)
          if (keys2[i2].toUpperCase().charCodeAt(0) == event.keyCode) {
            let found = findDiagnostic(this.view.state.field(lintState).diagnostics, diagnostic);
            if (found)
              diagnostic.actions[i2].apply(view, found.from, found.to);
          }
      } else {
        return;
      }
      event.preventDefault();
    };
    let onclick = (event) => {
      for (let i2 = 0; i2 < this.items.length; i2++) {
        if (this.items[i2].dom.contains(event.target))
          this.moveSelection(i2);
      }
    };
    this.list = crelt("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown,
      onclick
    });
    this.dom = crelt("div", { class: "cm-panel-lint" }, this.list, crelt("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => closeLintPanel(this.view)
    }, "\xD7"));
    this.update();
  }
  get selectedIndex() {
    let selected = this.view.state.field(lintState).selected;
    if (!selected)
      return -1;
    for (let i2 = 0; i2 < this.items.length; i2++)
      if (this.items[i2].diagnostic == selected.diagnostic)
        return i2;
    return -1;
  }
  update() {
    let { diagnostics, selected } = this.view.state.field(lintState);
    let i2 = 0, needsSync = false, newSelectedItem = null;
    diagnostics.between(0, this.view.state.doc.length, (_start, _end, { spec: spec2 }) => {
      let found = -1, item;
      for (let j2 = i2; j2 < this.items.length; j2++)
        if (this.items[j2].diagnostic == spec2.diagnostic) {
          found = j2;
          break;
        }
      if (found < 0) {
        item = new PanelItem(this.view, spec2.diagnostic);
        this.items.splice(i2, 0, item);
        needsSync = true;
      } else {
        item = this.items[found];
        if (found > i2) {
          this.items.splice(i2, found - i2);
          needsSync = true;
        }
      }
      if (selected && item.diagnostic == selected.diagnostic) {
        if (!item.dom.hasAttribute("aria-selected")) {
          item.dom.setAttribute("aria-selected", "true");
          newSelectedItem = item;
        }
      } else if (item.dom.hasAttribute("aria-selected")) {
        item.dom.removeAttribute("aria-selected");
      }
      i2++;
    });
    while (i2 < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0)) {
      needsSync = true;
      this.items.pop();
    }
    if (this.items.length == 0) {
      this.items.push(new PanelItem(this.view, {
        from: -1,
        to: -1,
        severity: "info",
        message: this.view.state.phrase("No diagnostics")
      }));
      needsSync = true;
    }
    if (newSelectedItem) {
      this.list.setAttribute("aria-activedescendant", newSelectedItem.id);
      this.view.requestMeasure({
        key: this,
        read: () => ({ sel: newSelectedItem.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
        write: ({ sel, panel }) => {
          if (sel.top < panel.top)
            this.list.scrollTop -= panel.top - sel.top;
          else if (sel.bottom > panel.bottom)
            this.list.scrollTop += sel.bottom - panel.bottom;
        }
      });
    } else if (this.selectedIndex < 0) {
      this.list.removeAttribute("aria-activedescendant");
    }
    if (needsSync)
      this.sync();
  }
  sync() {
    let domPos = this.list.firstChild;
    function rm2() {
      let prev = domPos;
      domPos = prev.nextSibling;
      prev.remove();
    }
    for (let item of this.items) {
      if (item.dom.parentNode == this.list) {
        while (domPos != item.dom)
          rm2();
        domPos = item.dom.nextSibling;
      } else {
        this.list.insertBefore(item.dom, domPos);
      }
    }
    while (domPos)
      rm2();
  }
  moveSelection(selectedIndex) {
    if (this.selectedIndex < 0)
      return;
    let field = this.view.state.field(lintState);
    let selection = findDiagnostic(field.diagnostics, this.items[selectedIndex].diagnostic);
    if (!selection)
      return;
    this.view.dispatch({
      selection: { anchor: selection.from, head: selection.to },
      scrollIntoView: true,
      effects: movePanelSelection.of(selection)
    });
  }
  static open(view) {
    return new LintPanel(view);
  }
}
function svg(content2, attrs = `viewBox="0 0 40 40"`) {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${attrs}>${encodeURIComponent(content2)}</svg>')`;
}
function underline(color) {
  return svg(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${color}" fill="none" stroke-width=".7"/>`, `width="6" height="3"`);
}
const baseTheme$2 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ underline("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ underline("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ underline("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ underline("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
});
function severityWeight(sev) {
  return sev == "error" ? 4 : sev == "warning" ? 3 : sev == "info" ? 2 : 1;
}
class LintGutterMarker extends GutterMarker {
  constructor(diagnostics) {
    super();
    this.diagnostics = diagnostics;
    this.severity = diagnostics.reduce((max, d2) => severityWeight(max) < severityWeight(d2.severity) ? d2.severity : max, "hint");
  }
  toDOM(view) {
    let elt = document.createElement("div");
    elt.className = "cm-lint-marker cm-lint-marker-" + this.severity;
    let diagnostics = this.diagnostics;
    let diagnosticsFilter = view.state.facet(lintGutterConfig).tooltipFilter;
    if (diagnosticsFilter)
      diagnostics = diagnosticsFilter(diagnostics);
    if (diagnostics.length)
      elt.onmouseover = () => gutterMarkerMouseOver(view, elt, diagnostics);
    return elt;
  }
}
function trackHoverOn(view, marker) {
  let mousemove = (event) => {
    let rect = marker.getBoundingClientRect();
    if (event.clientX > rect.left - 10 && event.clientX < rect.right + 10 && event.clientY > rect.top - 10 && event.clientY < rect.bottom + 10)
      return;
    for (let target = event.target; target; target = target.parentNode) {
      if (target.nodeType == 1 && target.classList.contains("cm-tooltip-lint"))
        return;
    }
    window.removeEventListener("mousemove", mousemove);
    if (view.state.field(lintGutterTooltip))
      view.dispatch({ effects: setLintGutterTooltip.of(null) });
  };
  window.addEventListener("mousemove", mousemove);
}
function gutterMarkerMouseOver(view, marker, diagnostics) {
  function hovered() {
    let line = view.elementAtHeight(marker.getBoundingClientRect().top + 5 - view.documentTop);
    const linePos = view.coordsAtPos(line.from);
    if (linePos) {
      view.dispatch({ effects: setLintGutterTooltip.of({
        pos: line.from,
        above: false,
        create() {
          return {
            dom: diagnosticsTooltip(view, diagnostics),
            getCoords: () => marker.getBoundingClientRect()
          };
        }
      }) });
    }
    marker.onmouseout = marker.onmousemove = null;
    trackHoverOn(view, marker);
  }
  let { hoverTime } = view.state.facet(lintGutterConfig);
  let hoverTimeout = setTimeout(hovered, hoverTime);
  marker.onmouseout = () => {
    clearTimeout(hoverTimeout);
    marker.onmouseout = marker.onmousemove = null;
  };
  marker.onmousemove = () => {
    clearTimeout(hoverTimeout);
    hoverTimeout = setTimeout(hovered, hoverTime);
  };
}
function markersForDiagnostics(doc2, diagnostics) {
  let byLine = Object.create(null);
  for (let diagnostic of diagnostics) {
    let line = doc2.lineAt(diagnostic.from);
    (byLine[line.from] || (byLine[line.from] = [])).push(diagnostic);
  }
  let markers = [];
  for (let line in byLine) {
    markers.push(new LintGutterMarker(byLine[line]).range(+line));
  }
  return RangeSet.of(markers, true);
}
const lintGutterExtension = /* @__PURE__ */ gutter({
  class: "cm-gutter-lint",
  markers: (view) => view.state.field(lintGutterMarkers)
});
const lintGutterMarkers = /* @__PURE__ */ StateField.define({
  create() {
    return RangeSet.empty;
  },
  update(markers, tr2) {
    markers = markers.map(tr2.changes);
    let diagnosticFilter = tr2.state.facet(lintGutterConfig).markerFilter;
    for (let effect of tr2.effects) {
      if (effect.is(setDiagnosticsEffect)) {
        let diagnostics = effect.value;
        if (diagnosticFilter)
          diagnostics = diagnosticFilter(diagnostics || []);
        markers = markersForDiagnostics(tr2.state.doc, diagnostics.slice(0));
      }
    }
    return markers;
  }
});
const setLintGutterTooltip = /* @__PURE__ */ StateEffect.define();
const lintGutterTooltip = /* @__PURE__ */ StateField.define({
  create() {
    return null;
  },
  update(tooltip, tr2) {
    if (tooltip && tr2.docChanged)
      tooltip = hideTooltip(tr2, tooltip) ? null : Object.assign(Object.assign({}, tooltip), { pos: tr2.changes.mapPos(tooltip.pos) });
    return tr2.effects.reduce((t2, e25) => e25.is(setLintGutterTooltip) ? e25.value : t2, tooltip);
  },
  provide: (field) => showTooltip.from(field)
});
const lintGutterTheme = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-gutter-lint": {
    width: "1.4em",
    "& .cm-gutterElement": {
      padding: ".2em"
    }
  },
  ".cm-lint-marker": {
    width: "1em",
    height: "1em"
  },
  ".cm-lint-marker-info": {
    content: /* @__PURE__ */ svg(`<path fill="#aaf" stroke="#77e" stroke-width="6" stroke-linejoin="round" d="M5 5L35 5L35 35L5 35Z"/>`)
  },
  ".cm-lint-marker-warning": {
    content: /* @__PURE__ */ svg(`<path fill="#fe8" stroke="#fd7" stroke-width="6" stroke-linejoin="round" d="M20 6L37 35L3 35Z"/>`)
  },
  ".cm-lint-marker-error": {
    content: /* @__PURE__ */ svg(`<circle cx="20" cy="20" r="15" fill="#f87" stroke="#f43" stroke-width="6"/>`)
  }
});
const lintExtensions = [
  lintState,
  /* @__PURE__ */ EditorView.decorations.compute([lintState], (state) => {
    let { selected, panel } = state.field(lintState);
    return !selected || !panel || selected.from == selected.to ? Decoration.none : Decoration.set([
      activeMark.range(selected.from, selected.to)
    ]);
  }),
  /* @__PURE__ */ hoverTooltip(lintTooltip, { hideOn: hideTooltip }),
  baseTheme$2
];
const lintGutterConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      hoverTime: 300,
      markerFilter: null,
      tooltipFilter: null
    });
  }
});
function lintGutter(config2 = {}) {
  return [lintGutterConfig.of(config2), lintGutterMarkers, lintGutterExtension, lintGutterTheme, lintGutterTooltip];
}
const toggleComment = (target) => {
  let { state } = target, line = state.doc.lineAt(state.selection.main.from), config2 = getConfig(target.state, line.from);
  return config2.line ? toggleLineComment(target) : config2.block ? toggleBlockCommentByLine(target) : false;
};
function command(f2, option) {
  return ({ state, dispatch }) => {
    if (state.readOnly)
      return false;
    let tr2 = f2(option, state);
    if (!tr2)
      return false;
    dispatch(state.update(tr2));
    return true;
  };
}
const toggleLineComment = /* @__PURE__ */ command(changeLineComment, 0);
const toggleBlockComment = /* @__PURE__ */ command(changeBlockComment, 0);
const toggleBlockCommentByLine = /* @__PURE__ */ command((o2, s2) => changeBlockComment(o2, s2, selectedLineRanges(s2)), 0);
function getConfig(state, pos) {
  let data = state.languageDataAt("commentTokens", pos);
  return data.length ? data[0] : {};
}
const SearchMargin = 50;
function findBlockComment(state, { open, close }, from, to2) {
  let textBefore = state.sliceDoc(from - SearchMargin, from);
  let textAfter = state.sliceDoc(to2, to2 + SearchMargin);
  let spaceBefore = /\s*$/.exec(textBefore)[0].length, spaceAfter = /^\s*/.exec(textAfter)[0].length;
  let beforeOff = textBefore.length - spaceBefore;
  if (textBefore.slice(beforeOff - open.length, beforeOff) == open && textAfter.slice(spaceAfter, spaceAfter + close.length) == close) {
    return {
      open: { pos: from - spaceBefore, margin: spaceBefore && 1 },
      close: { pos: to2 + spaceAfter, margin: spaceAfter && 1 }
    };
  }
  let startText, endText;
  if (to2 - from <= 2 * SearchMargin) {
    startText = endText = state.sliceDoc(from, to2);
  } else {
    startText = state.sliceDoc(from, from + SearchMargin);
    endText = state.sliceDoc(to2 - SearchMargin, to2);
  }
  let startSpace = /^\s*/.exec(startText)[0].length, endSpace = /\s*$/.exec(endText)[0].length;
  let endOff = endText.length - endSpace - close.length;
  if (startText.slice(startSpace, startSpace + open.length) == open && endText.slice(endOff, endOff + close.length) == close) {
    return {
      open: {
        pos: from + startSpace + open.length,
        margin: /\s/.test(startText.charAt(startSpace + open.length)) ? 1 : 0
      },
      close: {
        pos: to2 - endSpace - close.length,
        margin: /\s/.test(endText.charAt(endOff - 1)) ? 1 : 0
      }
    };
  }
  return null;
}
function selectedLineRanges(state) {
  let ranges = [];
  for (let r2 of state.selection.ranges) {
    let fromLine = state.doc.lineAt(r2.from);
    let toLine = r2.to <= fromLine.to ? fromLine : state.doc.lineAt(r2.to);
    let last = ranges.length - 1;
    if (last >= 0 && ranges[last].to > fromLine.from)
      ranges[last].to = toLine.to;
    else
      ranges.push({ from: fromLine.from + /^\s*/.exec(fromLine.text)[0].length, to: toLine.to });
  }
  return ranges;
}
function changeBlockComment(option, state, ranges = state.selection.ranges) {
  let tokens = ranges.map((r2) => getConfig(state, r2.from).block);
  if (!tokens.every((c2) => c2))
    return null;
  let comments = ranges.map((r2, i2) => findBlockComment(state, tokens[i2], r2.from, r2.to));
  if (option != 2 && !comments.every((c2) => c2)) {
    return { changes: state.changes(ranges.map((range3, i2) => {
      if (comments[i2])
        return [];
      return [{ from: range3.from, insert: tokens[i2].open + " " }, { from: range3.to, insert: " " + tokens[i2].close }];
    })) };
  } else if (option != 1 && comments.some((c2) => c2)) {
    let changes = [];
    for (let i2 = 0, comment2; i2 < comments.length; i2++)
      if (comment2 = comments[i2]) {
        let token = tokens[i2], { open, close } = comment2;
        changes.push({ from: open.pos - token.open.length, to: open.pos + open.margin }, { from: close.pos - close.margin, to: close.pos + token.close.length });
      }
    return { changes };
  }
  return null;
}
function changeLineComment(option, state, ranges = state.selection.ranges) {
  let lines = [];
  let prevLine = -1;
  for (let { from, to: to2 } of ranges) {
    let startI = lines.length, minIndent = 1e9;
    let token = getConfig(state, from).line;
    if (!token)
      continue;
    for (let pos = from; pos <= to2; ) {
      let line = state.doc.lineAt(pos);
      if (line.from > prevLine && (from == to2 || to2 > line.from)) {
        prevLine = line.from;
        let indent = /^\s*/.exec(line.text)[0].length;
        let empty2 = indent == line.length;
        let comment2 = line.text.slice(indent, indent + token.length) == token ? indent : -1;
        if (indent < line.text.length && indent < minIndent)
          minIndent = indent;
        lines.push({ line, comment: comment2, token, indent, empty: empty2, single: false });
      }
      pos = line.to + 1;
    }
    if (minIndent < 1e9) {
      for (let i2 = startI; i2 < lines.length; i2++)
        if (lines[i2].indent < lines[i2].line.text.length)
          lines[i2].indent = minIndent;
    }
    if (lines.length == startI + 1)
      lines[startI].single = true;
  }
  if (option != 2 && lines.some((l2) => l2.comment < 0 && (!l2.empty || l2.single))) {
    let changes = [];
    for (let { line, token, indent, empty: empty2, single } of lines)
      if (single || !empty2)
        changes.push({ from: line.from + indent, insert: token + " " });
    let changeSet = state.changes(changes);
    return { changes: changeSet, selection: state.selection.map(changeSet, 1) };
  } else if (option != 1 && lines.some((l2) => l2.comment >= 0)) {
    let changes = [];
    for (let { line, comment: comment2, token } of lines)
      if (comment2 >= 0) {
        let from = line.from + comment2, to2 = from + token.length;
        if (line.text[to2 - line.from] == " ")
          to2++;
        changes.push({ from, to: to2 });
      }
    return { changes };
  }
  return null;
}
const fromHistory = /* @__PURE__ */ Annotation.define();
const isolateHistory = /* @__PURE__ */ Annotation.define();
const invertedEffects = /* @__PURE__ */ Facet.define();
const historyConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      minDepth: 100,
      newGroupDelay: 500,
      joinToEvent: (_t2, isAdjacent2) => isAdjacent2
    }, {
      minDepth: Math.max,
      newGroupDelay: Math.min,
      joinToEvent: (a2, b2) => (tr2, adj) => a2(tr2, adj) || b2(tr2, adj)
    });
  }
});
function changeEnd(changes) {
  let end = 0;
  changes.iterChangedRanges((_2, to2) => end = to2);
  return end;
}
const historyField_ = /* @__PURE__ */ StateField.define({
  create() {
    return HistoryState.empty;
  },
  update(state, tr2) {
    let config2 = tr2.state.facet(historyConfig);
    let fromHist = tr2.annotation(fromHistory);
    if (fromHist) {
      let selection = tr2.docChanged ? EditorSelection.single(changeEnd(tr2.changes)) : void 0;
      let item = HistEvent.fromTransaction(tr2, selection), from = fromHist.side;
      let other = from == 0 ? state.undone : state.done;
      if (item)
        other = updateBranch(other, other.length, config2.minDepth, item);
      else
        other = addSelection(other, tr2.startState.selection);
      return new HistoryState(from == 0 ? fromHist.rest : other, from == 0 ? other : fromHist.rest);
    }
    let isolate = tr2.annotation(isolateHistory);
    if (isolate == "full" || isolate == "before")
      state = state.isolate();
    if (tr2.annotation(Transaction.addToHistory) === false)
      return !tr2.changes.empty ? state.addMapping(tr2.changes.desc) : state;
    let event = HistEvent.fromTransaction(tr2);
    let time2 = tr2.annotation(Transaction.time), userEvent = tr2.annotation(Transaction.userEvent);
    if (event)
      state = state.addChanges(event, time2, userEvent, config2, tr2);
    else if (tr2.selection)
      state = state.addSelection(tr2.startState.selection, time2, userEvent, config2.newGroupDelay);
    if (isolate == "full" || isolate == "after")
      state = state.isolate();
    return state;
  },
  toJSON(value2) {
    return { done: value2.done.map((e25) => e25.toJSON()), undone: value2.undone.map((e25) => e25.toJSON()) };
  },
  fromJSON(json2) {
    return new HistoryState(json2.done.map(HistEvent.fromJSON), json2.undone.map(HistEvent.fromJSON));
  }
});
function history(config2 = {}) {
  return [
    historyField_,
    historyConfig.of(config2),
    EditorView.domEventHandlers({
      beforeinput(e25, view) {
        let command2 = e25.inputType == "historyUndo" ? undo : e25.inputType == "historyRedo" ? redo : null;
        if (!command2)
          return false;
        e25.preventDefault();
        return command2(view);
      }
    })
  ];
}
function cmd(side, selection) {
  return function({ state, dispatch }) {
    if (!selection && state.readOnly)
      return false;
    let historyState = state.field(historyField_, false);
    if (!historyState)
      return false;
    let tr2 = historyState.pop(side, state, selection);
    if (!tr2)
      return false;
    dispatch(tr2);
    return true;
  };
}
const undo = /* @__PURE__ */ cmd(0, false);
const redo = /* @__PURE__ */ cmd(1, false);
const undoSelection = /* @__PURE__ */ cmd(0, true);
const redoSelection = /* @__PURE__ */ cmd(1, true);
class HistEvent {
  constructor(changes, effects, mapped, startSelection, selectionsAfter) {
    this.changes = changes;
    this.effects = effects;
    this.mapped = mapped;
    this.startSelection = startSelection;
    this.selectionsAfter = selectionsAfter;
  }
  setSelAfter(after) {
    return new HistEvent(this.changes, this.effects, this.mapped, this.startSelection, after);
  }
  toJSON() {
    var _a2, _b2, _c2;
    return {
      changes: (_a2 = this.changes) === null || _a2 === void 0 ? void 0 : _a2.toJSON(),
      mapped: (_b2 = this.mapped) === null || _b2 === void 0 ? void 0 : _b2.toJSON(),
      startSelection: (_c2 = this.startSelection) === null || _c2 === void 0 ? void 0 : _c2.toJSON(),
      selectionsAfter: this.selectionsAfter.map((s2) => s2.toJSON())
    };
  }
  static fromJSON(json2) {
    return new HistEvent(json2.changes && ChangeSet.fromJSON(json2.changes), [], json2.mapped && ChangeDesc.fromJSON(json2.mapped), json2.startSelection && EditorSelection.fromJSON(json2.startSelection), json2.selectionsAfter.map(EditorSelection.fromJSON));
  }
  static fromTransaction(tr2, selection) {
    let effects = none;
    for (let invert of tr2.startState.facet(invertedEffects)) {
      let result2 = invert(tr2);
      if (result2.length)
        effects = effects.concat(result2);
    }
    if (!effects.length && tr2.changes.empty)
      return null;
    return new HistEvent(tr2.changes.invert(tr2.startState.doc), effects, void 0, selection || tr2.startState.selection, none);
  }
  static selection(selections) {
    return new HistEvent(void 0, none, void 0, void 0, selections);
  }
}
function updateBranch(branch, to2, maxLen, newEvent) {
  let start = to2 + 1 > maxLen + 20 ? to2 - maxLen - 1 : 0;
  let newBranch = branch.slice(start, to2);
  newBranch.push(newEvent);
  return newBranch;
}
function isAdjacent(a2, b2) {
  let ranges = [], isAdjacent2 = false;
  a2.iterChangedRanges((f2, t2) => ranges.push(f2, t2));
  b2.iterChangedRanges((_f2, _t2, f2, t2) => {
    for (let i2 = 0; i2 < ranges.length; ) {
      let from = ranges[i2++], to2 = ranges[i2++];
      if (t2 >= from && f2 <= to2)
        isAdjacent2 = true;
    }
  });
  return isAdjacent2;
}
function eqSelectionShape(a2, b2) {
  return a2.ranges.length == b2.ranges.length && a2.ranges.filter((r2, i2) => r2.empty != b2.ranges[i2].empty).length === 0;
}
function conc(a2, b2) {
  return !a2.length ? b2 : !b2.length ? a2 : a2.concat(b2);
}
const none = [];
const MaxSelectionsPerEvent = 200;
function addSelection(branch, selection) {
  if (!branch.length) {
    return [HistEvent.selection([selection])];
  } else {
    let lastEvent = branch[branch.length - 1];
    let sels = lastEvent.selectionsAfter.slice(Math.max(0, lastEvent.selectionsAfter.length - MaxSelectionsPerEvent));
    if (sels.length && sels[sels.length - 1].eq(selection))
      return branch;
    sels.push(selection);
    return updateBranch(branch, branch.length - 1, 1e9, lastEvent.setSelAfter(sels));
  }
}
function popSelection(branch) {
  let last = branch[branch.length - 1];
  let newBranch = branch.slice();
  newBranch[branch.length - 1] = last.setSelAfter(last.selectionsAfter.slice(0, last.selectionsAfter.length - 1));
  return newBranch;
}
function addMappingToBranch(branch, mapping) {
  if (!branch.length)
    return branch;
  let length2 = branch.length, selections = none;
  while (length2) {
    let event = mapEvent(branch[length2 - 1], mapping, selections);
    if (event.changes && !event.changes.empty || event.effects.length) {
      let result2 = branch.slice(0, length2);
      result2[length2 - 1] = event;
      return result2;
    } else {
      mapping = event.mapped;
      length2--;
      selections = event.selectionsAfter;
    }
  }
  return selections.length ? [HistEvent.selection(selections)] : none;
}
function mapEvent(event, mapping, extraSelections) {
  let selections = conc(event.selectionsAfter.length ? event.selectionsAfter.map((s2) => s2.map(mapping)) : none, extraSelections);
  if (!event.changes)
    return HistEvent.selection(selections);
  let mappedChanges = event.changes.map(mapping), before = mapping.mapDesc(event.changes, true);
  let fullMapping = event.mapped ? event.mapped.composeDesc(before) : before;
  return new HistEvent(mappedChanges, StateEffect.mapEffects(event.effects, mapping), fullMapping, event.startSelection.map(before), selections);
}
const joinableUserEvent = /^(input\.type|delete)($|\.)/;
class HistoryState {
  constructor(done, undone, prevTime = 0, prevUserEvent = void 0) {
    this.done = done;
    this.undone = undone;
    this.prevTime = prevTime;
    this.prevUserEvent = prevUserEvent;
  }
  isolate() {
    return this.prevTime ? new HistoryState(this.done, this.undone) : this;
  }
  addChanges(event, time2, userEvent, config2, tr2) {
    let done = this.done, lastEvent = done[done.length - 1];
    if (lastEvent && lastEvent.changes && !lastEvent.changes.empty && event.changes && (!userEvent || joinableUserEvent.test(userEvent)) && (!lastEvent.selectionsAfter.length && time2 - this.prevTime < config2.newGroupDelay && config2.joinToEvent(tr2, isAdjacent(lastEvent.changes, event.changes)) || userEvent == "input.type.compose")) {
      done = updateBranch(done, done.length - 1, config2.minDepth, new HistEvent(event.changes.compose(lastEvent.changes), conc(event.effects, lastEvent.effects), lastEvent.mapped, lastEvent.startSelection, none));
    } else {
      done = updateBranch(done, done.length, config2.minDepth, event);
    }
    return new HistoryState(done, none, time2, userEvent);
  }
  addSelection(selection, time2, userEvent, newGroupDelay) {
    let last = this.done.length ? this.done[this.done.length - 1].selectionsAfter : none;
    if (last.length > 0 && time2 - this.prevTime < newGroupDelay && userEvent == this.prevUserEvent && userEvent && /^select($|\.)/.test(userEvent) && eqSelectionShape(last[last.length - 1], selection))
      return this;
    return new HistoryState(addSelection(this.done, selection), this.undone, time2, userEvent);
  }
  addMapping(mapping) {
    return new HistoryState(addMappingToBranch(this.done, mapping), addMappingToBranch(this.undone, mapping), this.prevTime, this.prevUserEvent);
  }
  pop(side, state, selection) {
    let branch = side == 0 ? this.done : this.undone;
    if (branch.length == 0)
      return null;
    let event = branch[branch.length - 1];
    if (selection && event.selectionsAfter.length) {
      return state.update({
        selection: event.selectionsAfter[event.selectionsAfter.length - 1],
        annotations: fromHistory.of({ side, rest: popSelection(branch) }),
        userEvent: side == 0 ? "select.undo" : "select.redo",
        scrollIntoView: true
      });
    } else if (!event.changes) {
      return null;
    } else {
      let rest = branch.length == 1 ? none : branch.slice(0, branch.length - 1);
      if (event.mapped)
        rest = addMappingToBranch(rest, event.mapped);
      return state.update({
        changes: event.changes,
        selection: event.startSelection,
        effects: event.effects,
        annotations: fromHistory.of({ side, rest }),
        filter: false,
        userEvent: side == 0 ? "undo" : "redo",
        scrollIntoView: true
      });
    }
  }
}
HistoryState.empty = /* @__PURE__ */ new HistoryState(none, none);
const historyKeymap = [
  { key: "Mod-z", run: undo, preventDefault: true },
  { key: "Mod-y", mac: "Mod-Shift-z", run: redo, preventDefault: true },
  { linux: "Ctrl-Shift-z", run: redo, preventDefault: true },
  { key: "Mod-u", run: undoSelection, preventDefault: true },
  { key: "Alt-u", mac: "Mod-Shift-u", run: redoSelection, preventDefault: true }
];
function updateSel(sel, by2) {
  return EditorSelection.create(sel.ranges.map(by2), sel.mainIndex);
}
function setSel(state, selection) {
  return state.update({ selection, scrollIntoView: true, userEvent: "select" });
}
function moveSel({ state, dispatch }, how) {
  let selection = updateSel(state.selection, how);
  if (selection.eq(state.selection))
    return false;
  dispatch(setSel(state, selection));
  return true;
}
function rangeEnd(range3, forward) {
  return EditorSelection.cursor(forward ? range3.to : range3.from);
}
function cursorByChar(view, forward) {
  return moveSel(view, (range3) => range3.empty ? view.moveByChar(range3, forward) : rangeEnd(range3, forward));
}
function ltrAtCursor(view) {
  return view.textDirectionAt(view.state.selection.main.head) == Direction.LTR;
}
const cursorCharLeft = (view) => cursorByChar(view, !ltrAtCursor(view));
const cursorCharRight = (view) => cursorByChar(view, ltrAtCursor(view));
function cursorByGroup(view, forward) {
  return moveSel(view, (range3) => range3.empty ? view.moveByGroup(range3, forward) : rangeEnd(range3, forward));
}
const cursorGroupLeft = (view) => cursorByGroup(view, !ltrAtCursor(view));
const cursorGroupRight = (view) => cursorByGroup(view, ltrAtCursor(view));
function interestingNode(state, node2, bracketProp) {
  if (node2.type.prop(bracketProp))
    return true;
  let len2 = node2.to - node2.from;
  return len2 && (len2 > 2 || /[^\s,.;:]/.test(state.sliceDoc(node2.from, node2.to))) || node2.firstChild;
}
function moveBySyntax(state, start, forward) {
  let pos = syntaxTree(state).resolveInner(start.head);
  let bracketProp = forward ? NodeProp.closedBy : NodeProp.openedBy;
  for (let at2 = start.head; ; ) {
    let next = forward ? pos.childAfter(at2) : pos.childBefore(at2);
    if (!next)
      break;
    if (interestingNode(state, next, bracketProp))
      pos = next;
    else
      at2 = forward ? next.to : next.from;
  }
  let bracket2 = pos.type.prop(bracketProp), match2, newPos;
  if (bracket2 && (match2 = forward ? matchBrackets(state, pos.from, 1) : matchBrackets(state, pos.to, -1)) && match2.matched)
    newPos = forward ? match2.end.to : match2.end.from;
  else
    newPos = forward ? pos.to : pos.from;
  return EditorSelection.cursor(newPos, forward ? -1 : 1);
}
const cursorSyntaxLeft = (view) => moveSel(view, (range3) => moveBySyntax(view.state, range3, !ltrAtCursor(view)));
const cursorSyntaxRight = (view) => moveSel(view, (range3) => moveBySyntax(view.state, range3, ltrAtCursor(view)));
function cursorByLine(view, forward) {
  return moveSel(view, (range3) => {
    if (!range3.empty)
      return rangeEnd(range3, forward);
    let moved = view.moveVertically(range3, forward);
    return moved.head != range3.head ? moved : view.moveToLineBoundary(range3, forward);
  });
}
const cursorLineUp = (view) => cursorByLine(view, false);
const cursorLineDown = (view) => cursorByLine(view, true);
function pageInfo(view) {
  let selfScroll = view.scrollDOM.clientHeight < view.scrollDOM.scrollHeight - 2;
  let marginTop = 0, marginBottom = 0, height;
  if (selfScroll) {
    for (let source of view.state.facet(EditorView.scrollMargins)) {
      let margins = source(view);
      if (margins === null || margins === void 0 ? void 0 : margins.top)
        marginTop = Math.max(margins === null || margins === void 0 ? void 0 : margins.top, marginTop);
      if (margins === null || margins === void 0 ? void 0 : margins.bottom)
        marginBottom = Math.max(margins === null || margins === void 0 ? void 0 : margins.bottom, marginBottom);
    }
    height = view.scrollDOM.clientHeight - marginTop - marginBottom;
  } else {
    height = (view.dom.ownerDocument.defaultView || window).innerHeight;
  }
  return {
    marginTop,
    marginBottom,
    selfScroll,
    height: Math.max(view.defaultLineHeight, height - 5)
  };
}
function cursorByPage(view, forward) {
  let page2 = pageInfo(view);
  let { state } = view, selection = updateSel(state.selection, (range3) => {
    return range3.empty ? view.moveVertically(range3, forward, page2.height) : rangeEnd(range3, forward);
  });
  if (selection.eq(state.selection))
    return false;
  let effect;
  if (page2.selfScroll) {
    let startPos = view.coordsAtPos(state.selection.main.head);
    let scrollRect = view.scrollDOM.getBoundingClientRect();
    let scrollTop = scrollRect.top + page2.marginTop, scrollBottom = scrollRect.bottom - page2.marginBottom;
    if (startPos && startPos.top > scrollTop && startPos.bottom < scrollBottom)
      effect = EditorView.scrollIntoView(selection.main.head, { y: "start", yMargin: startPos.top - scrollTop });
  }
  view.dispatch(setSel(state, selection), { effects: effect });
  return true;
}
const cursorPageUp = (view) => cursorByPage(view, false);
const cursorPageDown = (view) => cursorByPage(view, true);
function moveByLineBoundary(view, start, forward) {
  let line = view.lineBlockAt(start.head), moved = view.moveToLineBoundary(start, forward);
  if (moved.head == start.head && moved.head != (forward ? line.to : line.from))
    moved = view.moveToLineBoundary(start, forward, false);
  if (!forward && moved.head == line.from && line.length) {
    let space2 = /^\s*/.exec(view.state.sliceDoc(line.from, Math.min(line.from + 100, line.to)))[0].length;
    if (space2 && start.head != line.from + space2)
      moved = EditorSelection.cursor(line.from + space2);
  }
  return moved;
}
const cursorLineBoundaryForward = (view) => moveSel(view, (range3) => moveByLineBoundary(view, range3, true));
const cursorLineBoundaryBackward = (view) => moveSel(view, (range3) => moveByLineBoundary(view, range3, false));
const cursorLineBoundaryLeft = (view) => moveSel(view, (range3) => moveByLineBoundary(view, range3, !ltrAtCursor(view)));
const cursorLineBoundaryRight = (view) => moveSel(view, (range3) => moveByLineBoundary(view, range3, ltrAtCursor(view)));
const cursorLineStart = (view) => moveSel(view, (range3) => EditorSelection.cursor(view.lineBlockAt(range3.head).from, 1));
const cursorLineEnd = (view) => moveSel(view, (range3) => EditorSelection.cursor(view.lineBlockAt(range3.head).to, -1));
function toMatchingBracket(state, dispatch, extend2) {
  let found = false, selection = updateSel(state.selection, (range3) => {
    let matching = matchBrackets(state, range3.head, -1) || matchBrackets(state, range3.head, 1) || range3.head > 0 && matchBrackets(state, range3.head - 1, 1) || range3.head < state.doc.length && matchBrackets(state, range3.head + 1, -1);
    if (!matching || !matching.end)
      return range3;
    found = true;
    let head = matching.start.from == range3.head ? matching.end.to : matching.end.from;
    return extend2 ? EditorSelection.range(range3.anchor, head) : EditorSelection.cursor(head);
  });
  if (!found)
    return false;
  dispatch(setSel(state, selection));
  return true;
}
const cursorMatchingBracket = ({ state, dispatch }) => toMatchingBracket(state, dispatch, false);
function extendSel(view, how) {
  let selection = updateSel(view.state.selection, (range3) => {
    let head = how(range3);
    return EditorSelection.range(range3.anchor, head.head, head.goalColumn, head.bidiLevel || void 0);
  });
  if (selection.eq(view.state.selection))
    return false;
  view.dispatch(setSel(view.state, selection));
  return true;
}
function selectByChar(view, forward) {
  return extendSel(view, (range3) => view.moveByChar(range3, forward));
}
const selectCharLeft = (view) => selectByChar(view, !ltrAtCursor(view));
const selectCharRight = (view) => selectByChar(view, ltrAtCursor(view));
function selectByGroup(view, forward) {
  return extendSel(view, (range3) => view.moveByGroup(range3, forward));
}
const selectGroupLeft = (view) => selectByGroup(view, !ltrAtCursor(view));
const selectGroupRight = (view) => selectByGroup(view, ltrAtCursor(view));
const selectSyntaxLeft = (view) => extendSel(view, (range3) => moveBySyntax(view.state, range3, !ltrAtCursor(view)));
const selectSyntaxRight = (view) => extendSel(view, (range3) => moveBySyntax(view.state, range3, ltrAtCursor(view)));
function selectByLine(view, forward) {
  return extendSel(view, (range3) => view.moveVertically(range3, forward));
}
const selectLineUp = (view) => selectByLine(view, false);
const selectLineDown = (view) => selectByLine(view, true);
function selectByPage(view, forward) {
  return extendSel(view, (range3) => view.moveVertically(range3, forward, pageInfo(view).height));
}
const selectPageUp = (view) => selectByPage(view, false);
const selectPageDown = (view) => selectByPage(view, true);
const selectLineBoundaryForward = (view) => extendSel(view, (range3) => moveByLineBoundary(view, range3, true));
const selectLineBoundaryBackward = (view) => extendSel(view, (range3) => moveByLineBoundary(view, range3, false));
const selectLineBoundaryLeft = (view) => extendSel(view, (range3) => moveByLineBoundary(view, range3, !ltrAtCursor(view)));
const selectLineBoundaryRight = (view) => extendSel(view, (range3) => moveByLineBoundary(view, range3, ltrAtCursor(view)));
const selectLineStart = (view) => extendSel(view, (range3) => EditorSelection.cursor(view.lineBlockAt(range3.head).from));
const selectLineEnd = (view) => extendSel(view, (range3) => EditorSelection.cursor(view.lineBlockAt(range3.head).to));
const cursorDocStart = ({ state, dispatch }) => {
  dispatch(setSel(state, { anchor: 0 }));
  return true;
};
const cursorDocEnd = ({ state, dispatch }) => {
  dispatch(setSel(state, { anchor: state.doc.length }));
  return true;
};
const selectDocStart = ({ state, dispatch }) => {
  dispatch(setSel(state, { anchor: state.selection.main.anchor, head: 0 }));
  return true;
};
const selectDocEnd = ({ state, dispatch }) => {
  dispatch(setSel(state, { anchor: state.selection.main.anchor, head: state.doc.length }));
  return true;
};
const selectAll = ({ state, dispatch }) => {
  dispatch(state.update({ selection: { anchor: 0, head: state.doc.length }, userEvent: "select" }));
  return true;
};
const selectLine = ({ state, dispatch }) => {
  let ranges = selectedLineBlocks(state).map(({ from, to: to2 }) => EditorSelection.range(from, Math.min(to2 + 1, state.doc.length)));
  dispatch(state.update({ selection: EditorSelection.create(ranges), userEvent: "select" }));
  return true;
};
const selectParentSyntax = ({ state, dispatch }) => {
  let selection = updateSel(state.selection, (range3) => {
    var _a2;
    let context = syntaxTree(state).resolveInner(range3.head, 1);
    while (!(context.from < range3.from && context.to >= range3.to || context.to > range3.to && context.from <= range3.from || !((_a2 = context.parent) === null || _a2 === void 0 ? void 0 : _a2.parent)))
      context = context.parent;
    return EditorSelection.range(context.to, context.from);
  });
  dispatch(setSel(state, selection));
  return true;
};
const simplifySelection = ({ state, dispatch }) => {
  let cur2 = state.selection, selection = null;
  if (cur2.ranges.length > 1)
    selection = EditorSelection.create([cur2.main]);
  else if (!cur2.main.empty)
    selection = EditorSelection.create([EditorSelection.cursor(cur2.main.head)]);
  if (!selection)
    return false;
  dispatch(setSel(state, selection));
  return true;
};
function deleteBy(target, by2) {
  if (target.state.readOnly)
    return false;
  let event = "delete.selection", { state } = target;
  let changes = state.changeByRange((range3) => {
    let { from, to: to2 } = range3;
    if (from == to2) {
      let towards = by2(from);
      if (towards < from) {
        event = "delete.backward";
        towards = skipAtomic(target, towards, false);
      } else if (towards > from) {
        event = "delete.forward";
        towards = skipAtomic(target, towards, true);
      }
      from = Math.min(from, towards);
      to2 = Math.max(to2, towards);
    } else {
      from = skipAtomic(target, from, false);
      to2 = skipAtomic(target, to2, true);
    }
    return from == to2 ? { range: range3 } : { changes: { from, to: to2 }, range: EditorSelection.cursor(from) };
  });
  if (changes.changes.empty)
    return false;
  target.dispatch(state.update(changes, {
    scrollIntoView: true,
    userEvent: event,
    effects: event == "delete.selection" ? EditorView.announce.of(state.phrase("Selection deleted")) : void 0
  }));
  return true;
}
function skipAtomic(target, pos, forward) {
  if (target instanceof EditorView)
    for (let ranges of target.state.facet(EditorView.atomicRanges).map((f2) => f2(target)))
      ranges.between(pos, pos, (from, to2) => {
        if (from < pos && to2 > pos)
          pos = forward ? to2 : from;
      });
  return pos;
}
const deleteByChar = (target, forward) => deleteBy(target, (pos) => {
  let { state } = target, line = state.doc.lineAt(pos), before, targetPos;
  if (!forward && pos > line.from && pos < line.from + 200 && !/[^ \t]/.test(before = line.text.slice(0, pos - line.from))) {
    if (before[before.length - 1] == "	")
      return pos - 1;
    let col = countColumn(before, state.tabSize), drop = col % getIndentUnit(state) || getIndentUnit(state);
    for (let i2 = 0; i2 < drop && before[before.length - 1 - i2] == " "; i2++)
      pos--;
    targetPos = pos;
  } else {
    targetPos = findClusterBreak(line.text, pos - line.from, forward, forward) + line.from;
    if (targetPos == pos && line.number != (forward ? state.doc.lines : 1))
      targetPos += forward ? 1 : -1;
  }
  return targetPos;
});
const deleteCharBackward = (view) => deleteByChar(view, false);
const deleteCharForward = (view) => deleteByChar(view, true);
const deleteByGroup = (target, forward) => deleteBy(target, (start) => {
  let pos = start, { state } = target, line = state.doc.lineAt(pos);
  let categorize = state.charCategorizer(pos);
  for (let cat = null; ; ) {
    if (pos == (forward ? line.to : line.from)) {
      if (pos == start && line.number != (forward ? state.doc.lines : 1))
        pos += forward ? 1 : -1;
      break;
    }
    let next = findClusterBreak(line.text, pos - line.from, forward) + line.from;
    let nextChar2 = line.text.slice(Math.min(pos, next) - line.from, Math.max(pos, next) - line.from);
    let nextCat = categorize(nextChar2);
    if (cat != null && nextCat != cat)
      break;
    if (nextChar2 != " " || pos != start)
      cat = nextCat;
    pos = next;
  }
  return pos;
});
const deleteGroupBackward = (target) => deleteByGroup(target, false);
const deleteGroupForward = (target) => deleteByGroup(target, true);
const deleteToLineEnd = (view) => deleteBy(view, (pos) => {
  let lineEnd = view.lineBlockAt(pos).to;
  return pos < lineEnd ? lineEnd : Math.min(view.state.doc.length, pos + 1);
});
const deleteToLineStart = (view) => deleteBy(view, (pos) => {
  let lineStart = view.lineBlockAt(pos).from;
  return pos > lineStart ? lineStart : Math.max(0, pos - 1);
});
const splitLine = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  let changes = state.changeByRange((range3) => {
    return {
      changes: { from: range3.from, to: range3.to, insert: Text.of(["", ""]) },
      range: EditorSelection.cursor(range3.from)
    };
  });
  dispatch(state.update(changes, { scrollIntoView: true, userEvent: "input" }));
  return true;
};
const transposeChars = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  let changes = state.changeByRange((range3) => {
    if (!range3.empty || range3.from == 0 || range3.from == state.doc.length)
      return { range: range3 };
    let pos = range3.from, line = state.doc.lineAt(pos);
    let from = pos == line.from ? pos - 1 : findClusterBreak(line.text, pos - line.from, false) + line.from;
    let to2 = pos == line.to ? pos + 1 : findClusterBreak(line.text, pos - line.from, true) + line.from;
    return {
      changes: { from, to: to2, insert: state.doc.slice(pos, to2).append(state.doc.slice(from, pos)) },
      range: EditorSelection.cursor(to2)
    };
  });
  if (changes.changes.empty)
    return false;
  dispatch(state.update(changes, { scrollIntoView: true, userEvent: "move.character" }));
  return true;
};
function selectedLineBlocks(state) {
  let blocks = [], upto = -1;
  for (let range3 of state.selection.ranges) {
    let startLine = state.doc.lineAt(range3.from), endLine = state.doc.lineAt(range3.to);
    if (!range3.empty && range3.to == endLine.from)
      endLine = state.doc.lineAt(range3.to - 1);
    if (upto >= startLine.number) {
      let prev = blocks[blocks.length - 1];
      prev.to = endLine.to;
      prev.ranges.push(range3);
    } else {
      blocks.push({ from: startLine.from, to: endLine.to, ranges: [range3] });
    }
    upto = endLine.number + 1;
  }
  return blocks;
}
function moveLine(state, dispatch, forward) {
  if (state.readOnly)
    return false;
  let changes = [], ranges = [];
  for (let block of selectedLineBlocks(state)) {
    if (forward ? block.to == state.doc.length : block.from == 0)
      continue;
    let nextLine = state.doc.lineAt(forward ? block.to + 1 : block.from - 1);
    let size2 = nextLine.length + 1;
    if (forward) {
      changes.push({ from: block.to, to: nextLine.to }, { from: block.from, insert: nextLine.text + state.lineBreak });
      for (let r2 of block.ranges)
        ranges.push(EditorSelection.range(Math.min(state.doc.length, r2.anchor + size2), Math.min(state.doc.length, r2.head + size2)));
    } else {
      changes.push({ from: nextLine.from, to: block.from }, { from: block.to, insert: state.lineBreak + nextLine.text });
      for (let r2 of block.ranges)
        ranges.push(EditorSelection.range(r2.anchor - size2, r2.head - size2));
    }
  }
  if (!changes.length)
    return false;
  dispatch(state.update({
    changes,
    scrollIntoView: true,
    selection: EditorSelection.create(ranges, state.selection.mainIndex),
    userEvent: "move.line"
  }));
  return true;
}
const moveLineUp = ({ state, dispatch }) => moveLine(state, dispatch, false);
const moveLineDown = ({ state, dispatch }) => moveLine(state, dispatch, true);
function copyLine(state, dispatch, forward) {
  if (state.readOnly)
    return false;
  let changes = [];
  for (let block of selectedLineBlocks(state)) {
    if (forward)
      changes.push({ from: block.from, insert: state.doc.slice(block.from, block.to) + state.lineBreak });
    else
      changes.push({ from: block.to, insert: state.lineBreak + state.doc.slice(block.from, block.to) });
  }
  dispatch(state.update({ changes, scrollIntoView: true, userEvent: "input.copyline" }));
  return true;
}
const copyLineUp = ({ state, dispatch }) => copyLine(state, dispatch, false);
const copyLineDown = ({ state, dispatch }) => copyLine(state, dispatch, true);
const deleteLine = (view) => {
  if (view.state.readOnly)
    return false;
  let { state } = view, changes = state.changes(selectedLineBlocks(state).map(({ from, to: to2 }) => {
    if (from > 0)
      from--;
    else if (to2 < state.doc.length)
      to2++;
    return { from, to: to2 };
  }));
  let selection = updateSel(state.selection, (range3) => view.moveVertically(range3, true)).map(changes);
  view.dispatch({ changes, selection, scrollIntoView: true, userEvent: "delete.line" });
  return true;
};
function isBetweenBrackets(state, pos) {
  if (/\(\)|\[\]|\{\}/.test(state.sliceDoc(pos - 1, pos + 1)))
    return { from: pos, to: pos };
  let context = syntaxTree(state).resolveInner(pos);
  let before = context.childBefore(pos), after = context.childAfter(pos), closedBy;
  if (before && after && before.to <= pos && after.from >= pos && (closedBy = before.type.prop(NodeProp.closedBy)) && closedBy.indexOf(after.name) > -1 && state.doc.lineAt(before.to).from == state.doc.lineAt(after.from).from)
    return { from: before.to, to: after.from };
  return null;
}
const insertNewlineAndIndent = /* @__PURE__ */ newlineAndIndent(false);
const insertBlankLine = /* @__PURE__ */ newlineAndIndent(true);
function newlineAndIndent(atEof) {
  return ({ state, dispatch }) => {
    if (state.readOnly)
      return false;
    let changes = state.changeByRange((range3) => {
      let { from, to: to2 } = range3, line = state.doc.lineAt(from);
      let explode = !atEof && from == to2 && isBetweenBrackets(state, from);
      if (atEof)
        from = to2 = (to2 <= line.to ? line : state.doc.lineAt(to2)).to;
      let cx2 = new IndentContext(state, { simulateBreak: from, simulateDoubleBreak: !!explode });
      let indent = getIndentation(cx2, from);
      if (indent == null)
        indent = /^\s*/.exec(state.doc.lineAt(from).text)[0].length;
      while (to2 < line.to && /\s/.test(line.text[to2 - line.from]))
        to2++;
      if (explode)
        ({ from, to: to2 } = explode);
      else if (from > line.from && from < line.from + 100 && !/\S/.test(line.text.slice(0, from)))
        from = line.from;
      let insert2 = ["", indentString(state, indent)];
      if (explode)
        insert2.push(indentString(state, cx2.lineIndent(line.from, -1)));
      return {
        changes: { from, to: to2, insert: Text.of(insert2) },
        range: EditorSelection.cursor(from + 1 + insert2[1].length)
      };
    });
    dispatch(state.update(changes, { scrollIntoView: true, userEvent: "input" }));
    return true;
  };
}
function changeBySelectedLine(state, f2) {
  let atLine = -1;
  return state.changeByRange((range3) => {
    let changes = [];
    for (let pos = range3.from; pos <= range3.to; ) {
      let line = state.doc.lineAt(pos);
      if (line.number > atLine && (range3.empty || range3.to > line.from)) {
        f2(line, changes, range3);
        atLine = line.number;
      }
      pos = line.to + 1;
    }
    let changeSet = state.changes(changes);
    return {
      changes,
      range: EditorSelection.range(changeSet.mapPos(range3.anchor, 1), changeSet.mapPos(range3.head, 1))
    };
  });
}
const indentSelection = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  let updated = Object.create(null);
  let context = new IndentContext(state, { overrideIndentation: (start) => {
    let found = updated[start];
    return found == null ? -1 : found;
  } });
  let changes = changeBySelectedLine(state, (line, changes2, range3) => {
    let indent = getIndentation(context, line.from);
    if (indent == null)
      return;
    if (!/\S/.test(line.text))
      indent = 0;
    let cur2 = /^\s*/.exec(line.text)[0];
    let norm = indentString(state, indent);
    if (cur2 != norm || range3.from < line.from + cur2.length) {
      updated[line.from] = indent;
      changes2.push({ from: line.from, to: line.from + cur2.length, insert: norm });
    }
  });
  if (!changes.changes.empty)
    dispatch(state.update(changes, { userEvent: "indent" }));
  return true;
};
const indentMore = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  dispatch(state.update(changeBySelectedLine(state, (line, changes) => {
    changes.push({ from: line.from, insert: state.facet(indentUnit) });
  }), { userEvent: "input.indent" }));
  return true;
};
const indentLess = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  dispatch(state.update(changeBySelectedLine(state, (line, changes) => {
    let space2 = /^\s*/.exec(line.text)[0];
    if (!space2)
      return;
    let col = countColumn(space2, state.tabSize), keep2 = 0;
    let insert2 = indentString(state, Math.max(0, col - getIndentUnit(state)));
    while (keep2 < space2.length && keep2 < insert2.length && space2.charCodeAt(keep2) == insert2.charCodeAt(keep2))
      keep2++;
    changes.push({ from: line.from + keep2, to: line.from + space2.length, insert: insert2.slice(keep2) });
  }), { userEvent: "delete.dedent" }));
  return true;
};
const emacsStyleKeymap = [
  { key: "Ctrl-b", run: cursorCharLeft, shift: selectCharLeft, preventDefault: true },
  { key: "Ctrl-f", run: cursorCharRight, shift: selectCharRight },
  { key: "Ctrl-p", run: cursorLineUp, shift: selectLineUp },
  { key: "Ctrl-n", run: cursorLineDown, shift: selectLineDown },
  { key: "Ctrl-a", run: cursorLineStart, shift: selectLineStart },
  { key: "Ctrl-e", run: cursorLineEnd, shift: selectLineEnd },
  { key: "Ctrl-d", run: deleteCharForward },
  { key: "Ctrl-h", run: deleteCharBackward },
  { key: "Ctrl-k", run: deleteToLineEnd },
  { key: "Ctrl-Alt-h", run: deleteGroupBackward },
  { key: "Ctrl-o", run: splitLine },
  { key: "Ctrl-t", run: transposeChars },
  { key: "Ctrl-v", run: cursorPageDown }
];
const standardKeymap = /* @__PURE__ */ [
  { key: "ArrowLeft", run: cursorCharLeft, shift: selectCharLeft, preventDefault: true },
  { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: cursorGroupLeft, shift: selectGroupLeft, preventDefault: true },
  { mac: "Cmd-ArrowLeft", run: cursorLineBoundaryLeft, shift: selectLineBoundaryLeft, preventDefault: true },
  { key: "ArrowRight", run: cursorCharRight, shift: selectCharRight, preventDefault: true },
  { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: cursorGroupRight, shift: selectGroupRight, preventDefault: true },
  { mac: "Cmd-ArrowRight", run: cursorLineBoundaryRight, shift: selectLineBoundaryRight, preventDefault: true },
  { key: "ArrowUp", run: cursorLineUp, shift: selectLineUp, preventDefault: true },
  { mac: "Cmd-ArrowUp", run: cursorDocStart, shift: selectDocStart },
  { mac: "Ctrl-ArrowUp", run: cursorPageUp, shift: selectPageUp },
  { key: "ArrowDown", run: cursorLineDown, shift: selectLineDown, preventDefault: true },
  { mac: "Cmd-ArrowDown", run: cursorDocEnd, shift: selectDocEnd },
  { mac: "Ctrl-ArrowDown", run: cursorPageDown, shift: selectPageDown },
  { key: "PageUp", run: cursorPageUp, shift: selectPageUp },
  { key: "PageDown", run: cursorPageDown, shift: selectPageDown },
  { key: "Home", run: cursorLineBoundaryBackward, shift: selectLineBoundaryBackward, preventDefault: true },
  { key: "Mod-Home", run: cursorDocStart, shift: selectDocStart },
  { key: "End", run: cursorLineBoundaryForward, shift: selectLineBoundaryForward, preventDefault: true },
  { key: "Mod-End", run: cursorDocEnd, shift: selectDocEnd },
  { key: "Enter", run: insertNewlineAndIndent },
  { key: "Mod-a", run: selectAll },
  { key: "Backspace", run: deleteCharBackward, shift: deleteCharBackward },
  { key: "Delete", run: deleteCharForward },
  { key: "Mod-Backspace", mac: "Alt-Backspace", run: deleteGroupBackward },
  { key: "Mod-Delete", mac: "Alt-Delete", run: deleteGroupForward },
  { mac: "Mod-Backspace", run: deleteToLineStart },
  { mac: "Mod-Delete", run: deleteToLineEnd }
].concat(/* @__PURE__ */ emacsStyleKeymap.map((b2) => ({ mac: b2.key, run: b2.run, shift: b2.shift })));
const defaultKeymap = /* @__PURE__ */ [
  { key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: cursorSyntaxLeft, shift: selectSyntaxLeft },
  { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: cursorSyntaxRight, shift: selectSyntaxRight },
  { key: "Alt-ArrowUp", run: moveLineUp },
  { key: "Shift-Alt-ArrowUp", run: copyLineUp },
  { key: "Alt-ArrowDown", run: moveLineDown },
  { key: "Shift-Alt-ArrowDown", run: copyLineDown },
  { key: "Escape", run: simplifySelection },
  { key: "Mod-Enter", run: insertBlankLine },
  { key: "Alt-l", mac: "Ctrl-l", run: selectLine },
  { key: "Mod-i", run: selectParentSyntax, preventDefault: true },
  { key: "Mod-[", run: indentLess },
  { key: "Mod-]", run: indentMore },
  { key: "Mod-Alt-\\", run: indentSelection },
  { key: "Shift-Mod-k", run: deleteLine },
  { key: "Shift-Mod-\\", run: cursorMatchingBracket },
  { key: "Mod-/", run: toggleComment },
  { key: "Alt-A", run: toggleBlockComment }
].concat(standardKeymap);
const basicNormalize = typeof String.prototype.normalize == "function" ? (x2) => x2.normalize("NFKD") : (x2) => x2;
class SearchCursor {
  constructor(text, query, from = 0, to2 = text.length, normalize, test) {
    this.test = test;
    this.value = { from: 0, to: 0 };
    this.done = false;
    this.matches = [];
    this.buffer = "";
    this.bufferPos = 0;
    this.iter = text.iterRange(from, to2);
    this.bufferStart = from;
    this.normalize = normalize ? (x2) => normalize(basicNormalize(x2)) : basicNormalize;
    this.query = this.normalize(query);
  }
  peek() {
    if (this.bufferPos == this.buffer.length) {
      this.bufferStart += this.buffer.length;
      this.iter.next();
      if (this.iter.done)
        return -1;
      this.bufferPos = 0;
      this.buffer = this.iter.value;
    }
    return codePointAt(this.buffer, this.bufferPos);
  }
  next() {
    while (this.matches.length)
      this.matches.pop();
    return this.nextOverlapping();
  }
  nextOverlapping() {
    for (; ; ) {
      let next = this.peek();
      if (next < 0) {
        this.done = true;
        return this;
      }
      let str = fromCodePoint(next), start = this.bufferStart + this.bufferPos;
      this.bufferPos += codePointSize(next);
      let norm = this.normalize(str);
      for (let i2 = 0, pos = start; ; i2++) {
        let code = norm.charCodeAt(i2);
        let match2 = this.match(code, pos);
        if (match2) {
          this.value = match2;
          return this;
        }
        if (i2 == norm.length - 1)
          break;
        if (pos == start && i2 < str.length && str.charCodeAt(i2) == code)
          pos++;
      }
    }
  }
  match(code, pos) {
    let match2 = null;
    for (let i2 = 0; i2 < this.matches.length; i2 += 2) {
      let index2 = this.matches[i2], keep2 = false;
      if (this.query.charCodeAt(index2) == code) {
        if (index2 == this.query.length - 1) {
          match2 = { from: this.matches[i2 + 1], to: pos + 1 };
        } else {
          this.matches[i2]++;
          keep2 = true;
        }
      }
      if (!keep2) {
        this.matches.splice(i2, 2);
        i2 -= 2;
      }
    }
    if (this.query.charCodeAt(0) == code) {
      if (this.query.length == 1)
        match2 = { from: pos, to: pos + 1 };
      else
        this.matches.push(1, pos);
    }
    if (match2 && this.test && !this.test(match2.from, match2.to, this.buffer, this.bufferPos))
      match2 = null;
    return match2;
  }
}
if (typeof Symbol != "undefined")
  SearchCursor.prototype[Symbol.iterator] = function() {
    return this;
  };
const empty = { from: -1, to: -1, match: /* @__PURE__ */ /.*/.exec("") };
const baseFlags = "gm" + (/x/.unicode == null ? "" : "u");
class RegExpCursor {
  constructor(text, query, options, from = 0, to2 = text.length) {
    this.text = text;
    this.to = to2;
    this.curLine = "";
    this.done = false;
    this.value = empty;
    if (/\\[sWDnr]|\n|\r|\[\^/.test(query))
      return new MultilineRegExpCursor(text, query, options, from, to2);
    this.re = new RegExp(query, baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
    this.test = options === null || options === void 0 ? void 0 : options.test;
    this.iter = text.iter();
    let startLine = text.lineAt(from);
    this.curLineStart = startLine.from;
    this.matchPos = toCharEnd(text, from);
    this.getLine(this.curLineStart);
  }
  getLine(skip) {
    this.iter.next(skip);
    if (this.iter.lineBreak) {
      this.curLine = "";
    } else {
      this.curLine = this.iter.value;
      if (this.curLineStart + this.curLine.length > this.to)
        this.curLine = this.curLine.slice(0, this.to - this.curLineStart);
      this.iter.next();
    }
  }
  nextLine() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1;
    if (this.curLineStart > this.to)
      this.curLine = "";
    else
      this.getLine(0);
  }
  next() {
    for (let off2 = this.matchPos - this.curLineStart; ; ) {
      this.re.lastIndex = off2;
      let match2 = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (match2) {
        let from = this.curLineStart + match2.index, to2 = from + match2[0].length;
        this.matchPos = toCharEnd(this.text, to2 + (from == to2 ? 1 : 0));
        if (from == this.curLineStart + this.curLine.length)
          this.nextLine();
        if ((from < to2 || from > this.value.to) && (!this.test || this.test(from, to2, match2))) {
          this.value = { from, to: to2, match: match2 };
          return this;
        }
        off2 = this.matchPos - this.curLineStart;
      } else if (this.curLineStart + this.curLine.length < this.to) {
        this.nextLine();
        off2 = 0;
      } else {
        this.done = true;
        return this;
      }
    }
  }
}
const flattened = /* @__PURE__ */ new WeakMap();
class FlattenedDoc {
  constructor(from, text) {
    this.from = from;
    this.text = text;
  }
  get to() {
    return this.from + this.text.length;
  }
  static get(doc2, from, to2) {
    let cached = flattened.get(doc2);
    if (!cached || cached.from >= to2 || cached.to <= from) {
      let flat = new FlattenedDoc(from, doc2.sliceString(from, to2));
      flattened.set(doc2, flat);
      return flat;
    }
    if (cached.from == from && cached.to == to2)
      return cached;
    let { text, from: cachedFrom } = cached;
    if (cachedFrom > from) {
      text = doc2.sliceString(from, cachedFrom) + text;
      cachedFrom = from;
    }
    if (cached.to < to2)
      text += doc2.sliceString(cached.to, to2);
    flattened.set(doc2, new FlattenedDoc(cachedFrom, text));
    return new FlattenedDoc(from, text.slice(from - cachedFrom, to2 - cachedFrom));
  }
}
class MultilineRegExpCursor {
  constructor(text, query, options, from, to2) {
    this.text = text;
    this.to = to2;
    this.done = false;
    this.value = empty;
    this.matchPos = toCharEnd(text, from);
    this.re = new RegExp(query, baseFlags + ((options === null || options === void 0 ? void 0 : options.ignoreCase) ? "i" : ""));
    this.test = options === null || options === void 0 ? void 0 : options.test;
    this.flat = FlattenedDoc.get(text, from, this.chunkEnd(from + 5e3));
  }
  chunkEnd(pos) {
    return pos >= this.to ? this.to : this.text.lineAt(pos).to;
  }
  next() {
    for (; ; ) {
      let off2 = this.re.lastIndex = this.matchPos - this.flat.from;
      let match2 = this.re.exec(this.flat.text);
      if (match2 && !match2[0] && match2.index == off2) {
        this.re.lastIndex = off2 + 1;
        match2 = this.re.exec(this.flat.text);
      }
      if (match2) {
        let from = this.flat.from + match2.index, to2 = from + match2[0].length;
        if ((this.flat.to >= this.to || match2.index + match2[0].length <= this.flat.text.length - 10) && (!this.test || this.test(from, to2, match2))) {
          this.value = { from, to: to2, match: match2 };
          this.matchPos = toCharEnd(this.text, to2 + (from == to2 ? 1 : 0));
          return this;
        }
      }
      if (this.flat.to == this.to) {
        this.done = true;
        return this;
      }
      this.flat = FlattenedDoc.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
    }
  }
}
if (typeof Symbol != "undefined") {
  RegExpCursor.prototype[Symbol.iterator] = MultilineRegExpCursor.prototype[Symbol.iterator] = function() {
    return this;
  };
}
function validRegExp(source) {
  try {
    new RegExp(source, baseFlags);
    return true;
  } catch (_a2) {
    return false;
  }
}
function toCharEnd(text, pos) {
  if (pos >= text.length)
    return pos;
  let line = text.lineAt(pos), next;
  while (pos < line.to && (next = line.text.charCodeAt(pos - line.from)) >= 56320 && next < 57344)
    pos++;
  return pos;
}
function createLineDialog(view) {
  let input = crelt("input", { class: "cm-textfield", name: "line" });
  let dom = crelt("form", {
    class: "cm-gotoLine",
    onkeydown: (event) => {
      if (event.keyCode == 27) {
        event.preventDefault();
        view.dispatch({ effects: dialogEffect.of(false) });
        view.focus();
      } else if (event.keyCode == 13) {
        event.preventDefault();
        go2();
      }
    },
    onsubmit: (event) => {
      event.preventDefault();
      go2();
    }
  }, crelt("label", view.state.phrase("Go to line"), ": ", input), " ", crelt("button", { class: "cm-button", type: "submit" }, view.state.phrase("go")));
  function go2() {
    let match2 = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(input.value);
    if (!match2)
      return;
    let { state } = view, startLine = state.doc.lineAt(state.selection.main.head);
    let [, sign, ln2, cl2, percent2] = match2;
    let col = cl2 ? +cl2.slice(1) : 0;
    let line = ln2 ? +ln2 : startLine.number;
    if (ln2 && percent2) {
      let pc2 = line / 100;
      if (sign)
        pc2 = pc2 * (sign == "-" ? -1 : 1) + startLine.number / state.doc.lines;
      line = Math.round(state.doc.lines * pc2);
    } else if (ln2 && sign) {
      line = line * (sign == "-" ? -1 : 1) + startLine.number;
    }
    let docLine = state.doc.line(Math.max(1, Math.min(state.doc.lines, line)));
    view.dispatch({
      effects: dialogEffect.of(false),
      selection: EditorSelection.cursor(docLine.from + Math.max(0, Math.min(col, docLine.length))),
      scrollIntoView: true
    });
    view.focus();
  }
  return { dom };
}
const dialogEffect = /* @__PURE__ */ StateEffect.define();
const dialogField = /* @__PURE__ */ StateField.define({
  create() {
    return true;
  },
  update(value2, tr2) {
    for (let e25 of tr2.effects)
      if (e25.is(dialogEffect))
        value2 = e25.value;
    return value2;
  },
  provide: (f2) => showPanel.from(f2, (val) => val ? createLineDialog : null)
});
const gotoLine = (view) => {
  let panel = getPanel(view, createLineDialog);
  if (!panel) {
    let effects = [dialogEffect.of(true)];
    if (view.state.field(dialogField, false) == null)
      effects.push(StateEffect.appendConfig.of([dialogField, baseTheme$1]));
    view.dispatch({ effects });
    panel = getPanel(view, createLineDialog);
  }
  if (panel)
    panel.dom.querySelector("input").focus();
  return true;
};
const baseTheme$1 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-panel.cm-gotoLine": {
    padding: "2px 6px 4px",
    "& label": { fontSize: "80%" }
  }
});
const defaultHighlightOptions = {
  highlightWordAroundCursor: false,
  minSelectionLength: 1,
  maxMatches: 100,
  wholeWords: false
};
const highlightConfig = /* @__PURE__ */ Facet.define({
  combine(options) {
    return combineConfig(options, defaultHighlightOptions, {
      highlightWordAroundCursor: (a2, b2) => a2 || b2,
      minSelectionLength: Math.min,
      maxMatches: Math.min
    });
  }
});
function highlightSelectionMatches(options) {
  let ext = [defaultTheme, matchHighlighter];
  if (options)
    ext.push(highlightConfig.of(options));
  return ext;
}
const matchDeco = /* @__PURE__ */ Decoration.mark({ class: "cm-selectionMatch" });
const mainMatchDeco = /* @__PURE__ */ Decoration.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function insideWordBoundaries(check, state, from, to2) {
  return (from == 0 || check(state.sliceDoc(from - 1, from)) != CharCategory.Word) && (to2 == state.doc.length || check(state.sliceDoc(to2, to2 + 1)) != CharCategory.Word);
}
function insideWord(check, state, from, to2) {
  return check(state.sliceDoc(from, from + 1)) == CharCategory.Word && check(state.sliceDoc(to2 - 1, to2)) == CharCategory.Word;
}
const matchHighlighter = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.decorations = this.getDeco(view);
  }
  update(update) {
    if (update.selectionSet || update.docChanged || update.viewportChanged)
      this.decorations = this.getDeco(update.view);
  }
  getDeco(view) {
    let conf = view.state.facet(highlightConfig);
    let { state } = view, sel = state.selection;
    if (sel.ranges.length > 1)
      return Decoration.none;
    let range3 = sel.main, query, check = null;
    if (range3.empty) {
      if (!conf.highlightWordAroundCursor)
        return Decoration.none;
      let word = state.wordAt(range3.head);
      if (!word)
        return Decoration.none;
      check = state.charCategorizer(range3.head);
      query = state.sliceDoc(word.from, word.to);
    } else {
      let len2 = range3.to - range3.from;
      if (len2 < conf.minSelectionLength || len2 > 200)
        return Decoration.none;
      if (conf.wholeWords) {
        query = state.sliceDoc(range3.from, range3.to);
        check = state.charCategorizer(range3.head);
        if (!(insideWordBoundaries(check, state, range3.from, range3.to) && insideWord(check, state, range3.from, range3.to)))
          return Decoration.none;
      } else {
        query = state.sliceDoc(range3.from, range3.to).trim();
        if (!query)
          return Decoration.none;
      }
    }
    let deco = [];
    for (let part of view.visibleRanges) {
      let cursor = new SearchCursor(state.doc, query, part.from, part.to);
      while (!cursor.next().done) {
        let { from, to: to2 } = cursor.value;
        if (!check || insideWordBoundaries(check, state, from, to2)) {
          if (range3.empty && from <= range3.from && to2 >= range3.to)
            deco.push(mainMatchDeco.range(from, to2));
          else if (from >= range3.to || to2 <= range3.from)
            deco.push(matchDeco.range(from, to2));
          if (deco.length > conf.maxMatches)
            return Decoration.none;
        }
      }
    }
    return Decoration.set(deco);
  }
}, {
  decorations: (v2) => v2.decorations
});
const defaultTheme = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-selectionMatch": { backgroundColor: "#99ff7780" },
  ".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
});
const selectWord = ({ state, dispatch }) => {
  let { selection } = state;
  let newSel = EditorSelection.create(selection.ranges.map((range3) => state.wordAt(range3.head) || EditorSelection.cursor(range3.head)), selection.mainIndex);
  if (newSel.eq(selection))
    return false;
  dispatch(state.update({ selection: newSel }));
  return true;
};
function findNextOccurrence(state, query) {
  let { main, ranges } = state.selection;
  let word = state.wordAt(main.head), fullWord = word && word.from == main.from && word.to == main.to;
  for (let cycled = false, cursor = new SearchCursor(state.doc, query, ranges[ranges.length - 1].to); ; ) {
    cursor.next();
    if (cursor.done) {
      if (cycled)
        return null;
      cursor = new SearchCursor(state.doc, query, 0, Math.max(0, ranges[ranges.length - 1].from - 1));
      cycled = true;
    } else {
      if (cycled && ranges.some((r2) => r2.from == cursor.value.from))
        continue;
      if (fullWord) {
        let word2 = state.wordAt(cursor.value.from);
        if (!word2 || word2.from != cursor.value.from || word2.to != cursor.value.to)
          continue;
      }
      return cursor.value;
    }
  }
}
const selectNextOccurrence = ({ state, dispatch }) => {
  let { ranges } = state.selection;
  if (ranges.some((sel) => sel.from === sel.to))
    return selectWord({ state, dispatch });
  let searchedText = state.sliceDoc(ranges[0].from, ranges[0].to);
  if (state.selection.ranges.some((r2) => state.sliceDoc(r2.from, r2.to) != searchedText))
    return false;
  let range3 = findNextOccurrence(state, searchedText);
  if (!range3)
    return false;
  dispatch(state.update({
    selection: state.selection.addRange(EditorSelection.range(range3.from, range3.to), false),
    effects: EditorView.scrollIntoView(range3.to)
  }));
  return true;
};
const searchConfigFacet = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      top: false,
      caseSensitive: false,
      literal: false,
      regexp: false,
      wholeWord: false,
      createPanel: (view) => new SearchPanel(view),
      scrollToMatch: (range3) => EditorView.scrollIntoView(range3)
    });
  }
});
class SearchQuery {
  constructor(config2) {
    this.search = config2.search;
    this.caseSensitive = !!config2.caseSensitive;
    this.literal = !!config2.literal;
    this.regexp = !!config2.regexp;
    this.replace = config2.replace || "";
    this.valid = !!this.search && (!this.regexp || validRegExp(this.search));
    this.unquoted = this.unquote(this.search);
    this.wholeWord = !!config2.wholeWord;
  }
  unquote(text) {
    return this.literal ? text : text.replace(/\\([nrt\\])/g, (_2, ch2) => ch2 == "n" ? "\n" : ch2 == "r" ? "\r" : ch2 == "t" ? "	" : "\\");
  }
  eq(other) {
    return this.search == other.search && this.replace == other.replace && this.caseSensitive == other.caseSensitive && this.regexp == other.regexp && this.wholeWord == other.wholeWord;
  }
  create() {
    return this.regexp ? new RegExpQuery(this) : new StringQuery(this);
  }
  getCursor(state, from = 0, to2) {
    let st2 = state.doc ? state : EditorState.create({ doc: state });
    if (to2 == null)
      to2 = st2.doc.length;
    return this.regexp ? regexpCursor(this, st2, from, to2) : stringCursor(this, st2, from, to2);
  }
}
class QueryType {
  constructor(spec2) {
    this.spec = spec2;
  }
}
function stringCursor(spec2, state, from, to2) {
  return new SearchCursor(state.doc, spec2.unquoted, from, to2, spec2.caseSensitive ? void 0 : (x2) => x2.toLowerCase(), spec2.wholeWord ? stringWordTest(state.doc, state.charCategorizer(state.selection.main.head)) : void 0);
}
function stringWordTest(doc2, categorizer) {
  return (from, to2, buf, bufPos) => {
    if (bufPos > from || bufPos + buf.length < to2) {
      bufPos = Math.max(0, from - 2);
      buf = doc2.sliceString(bufPos, Math.min(doc2.length, to2 + 2));
    }
    return (categorizer(charBefore(buf, from - bufPos)) != CharCategory.Word || categorizer(charAfter(buf, from - bufPos)) != CharCategory.Word) && (categorizer(charAfter(buf, to2 - bufPos)) != CharCategory.Word || categorizer(charBefore(buf, to2 - bufPos)) != CharCategory.Word);
  };
}
class StringQuery extends QueryType {
  constructor(spec2) {
    super(spec2);
  }
  nextMatch(state, curFrom, curTo) {
    let cursor = stringCursor(this.spec, state, curTo, state.doc.length).nextOverlapping();
    if (cursor.done)
      cursor = stringCursor(this.spec, state, 0, curFrom).nextOverlapping();
    return cursor.done ? null : cursor.value;
  }
  prevMatchInRange(state, from, to2) {
    for (let pos = to2; ; ) {
      let start = Math.max(from, pos - 1e4 - this.spec.unquoted.length);
      let cursor = stringCursor(this.spec, state, start, pos), range3 = null;
      while (!cursor.nextOverlapping().done)
        range3 = cursor.value;
      if (range3)
        return range3;
      if (start == from)
        return null;
      pos -= 1e4;
    }
  }
  prevMatch(state, curFrom, curTo) {
    return this.prevMatchInRange(state, 0, curFrom) || this.prevMatchInRange(state, curTo, state.doc.length);
  }
  getReplacement(_result) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(state, limit) {
    let cursor = stringCursor(this.spec, state, 0, state.doc.length), ranges = [];
    while (!cursor.next().done) {
      if (ranges.length >= limit)
        return null;
      ranges.push(cursor.value);
    }
    return ranges;
  }
  highlight(state, from, to2, add2) {
    let cursor = stringCursor(this.spec, state, Math.max(0, from - this.spec.unquoted.length), Math.min(to2 + this.spec.unquoted.length, state.doc.length));
    while (!cursor.next().done)
      add2(cursor.value.from, cursor.value.to);
  }
}
function regexpCursor(spec2, state, from, to2) {
  return new RegExpCursor(state.doc, spec2.search, {
    ignoreCase: !spec2.caseSensitive,
    test: spec2.wholeWord ? regexpWordTest(state.charCategorizer(state.selection.main.head)) : void 0
  }, from, to2);
}
function charBefore(str, index2) {
  return str.slice(findClusterBreak(str, index2, false), index2);
}
function charAfter(str, index2) {
  return str.slice(index2, findClusterBreak(str, index2));
}
function regexpWordTest(categorizer) {
  return (_from, _to, match2) => !match2[0].length || (categorizer(charBefore(match2.input, match2.index)) != CharCategory.Word || categorizer(charAfter(match2.input, match2.index)) != CharCategory.Word) && (categorizer(charAfter(match2.input, match2.index + match2[0].length)) != CharCategory.Word || categorizer(charBefore(match2.input, match2.index + match2[0].length)) != CharCategory.Word);
}
class RegExpQuery extends QueryType {
  nextMatch(state, curFrom, curTo) {
    let cursor = regexpCursor(this.spec, state, curTo, state.doc.length).next();
    if (cursor.done)
      cursor = regexpCursor(this.spec, state, 0, curFrom).next();
    return cursor.done ? null : cursor.value;
  }
  prevMatchInRange(state, from, to2) {
    for (let size2 = 1; ; size2++) {
      let start = Math.max(from, to2 - size2 * 1e4);
      let cursor = regexpCursor(this.spec, state, start, to2), range3 = null;
      while (!cursor.next().done)
        range3 = cursor.value;
      if (range3 && (start == from || range3.from > start + 10))
        return range3;
      if (start == from)
        return null;
    }
  }
  prevMatch(state, curFrom, curTo) {
    return this.prevMatchInRange(state, 0, curFrom) || this.prevMatchInRange(state, curTo, state.doc.length);
  }
  getReplacement(result2) {
    return this.spec.unquote(this.spec.replace.replace(/\$([$&\d+])/g, (m2, i2) => i2 == "$" ? "$" : i2 == "&" ? result2.match[0] : i2 != "0" && +i2 < result2.match.length ? result2.match[i2] : m2));
  }
  matchAll(state, limit) {
    let cursor = regexpCursor(this.spec, state, 0, state.doc.length), ranges = [];
    while (!cursor.next().done) {
      if (ranges.length >= limit)
        return null;
      ranges.push(cursor.value);
    }
    return ranges;
  }
  highlight(state, from, to2, add2) {
    let cursor = regexpCursor(this.spec, state, Math.max(0, from - 250), Math.min(to2 + 250, state.doc.length));
    while (!cursor.next().done)
      add2(cursor.value.from, cursor.value.to);
  }
}
const setSearchQuery = /* @__PURE__ */ StateEffect.define();
const togglePanel = /* @__PURE__ */ StateEffect.define();
const searchState = /* @__PURE__ */ StateField.define({
  create(state) {
    return new SearchState(defaultQuery(state).create(), null);
  },
  update(value2, tr2) {
    for (let effect of tr2.effects) {
      if (effect.is(setSearchQuery))
        value2 = new SearchState(effect.value.create(), value2.panel);
      else if (effect.is(togglePanel))
        value2 = new SearchState(value2.query, effect.value ? createSearchPanel : null);
    }
    return value2;
  },
  provide: (f2) => showPanel.from(f2, (val) => val.panel)
});
class SearchState {
  constructor(query, panel) {
    this.query = query;
    this.panel = panel;
  }
}
const matchMark = /* @__PURE__ */ Decoration.mark({ class: "cm-searchMatch" }), selectedMatchMark = /* @__PURE__ */ Decoration.mark({ class: "cm-searchMatch cm-searchMatch-selected" });
const searchHighlighter = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.decorations = this.highlight(view.state.field(searchState));
  }
  update(update) {
    let state = update.state.field(searchState);
    if (state != update.startState.field(searchState) || update.docChanged || update.selectionSet || update.viewportChanged)
      this.decorations = this.highlight(state);
  }
  highlight({ query, panel }) {
    if (!panel || !query.spec.valid)
      return Decoration.none;
    let { view } = this;
    let builder = new RangeSetBuilder();
    for (let i2 = 0, ranges = view.visibleRanges, l2 = ranges.length; i2 < l2; i2++) {
      let { from, to: to2 } = ranges[i2];
      while (i2 < l2 - 1 && to2 > ranges[i2 + 1].from - 2 * 250)
        to2 = ranges[++i2].to;
      query.highlight(view.state, from, to2, (from2, to3) => {
        let selected = view.state.selection.ranges.some((r2) => r2.from == from2 && r2.to == to3);
        builder.add(from2, to3, selected ? selectedMatchMark : matchMark);
      });
    }
    return builder.finish();
  }
}, {
  decorations: (v2) => v2.decorations
});
function searchCommand(f2) {
  return (view) => {
    let state = view.state.field(searchState, false);
    return state && state.query.spec.valid ? f2(view, state) : openSearchPanel(view);
  };
}
const findNext = /* @__PURE__ */ searchCommand((view, { query }) => {
  let { to: to2 } = view.state.selection.main;
  let next = query.nextMatch(view.state, to2, to2);
  if (!next)
    return false;
  let selection = EditorSelection.single(next.from, next.to);
  let config2 = view.state.facet(searchConfigFacet);
  view.dispatch({
    selection,
    effects: [announceMatch(view, next), config2.scrollToMatch(selection.main, view)],
    userEvent: "select.search"
  });
  selectSearchInput(view);
  return true;
});
const findPrevious = /* @__PURE__ */ searchCommand((view, { query }) => {
  let { state } = view, { from } = state.selection.main;
  let prev = query.prevMatch(state, from, from);
  if (!prev)
    return false;
  let selection = EditorSelection.single(prev.from, prev.to);
  let config2 = view.state.facet(searchConfigFacet);
  view.dispatch({
    selection,
    effects: [announceMatch(view, prev), config2.scrollToMatch(selection.main, view)],
    userEvent: "select.search"
  });
  selectSearchInput(view);
  return true;
});
const selectMatches = /* @__PURE__ */ searchCommand((view, { query }) => {
  let ranges = query.matchAll(view.state, 1e3);
  if (!ranges || !ranges.length)
    return false;
  view.dispatch({
    selection: EditorSelection.create(ranges.map((r2) => EditorSelection.range(r2.from, r2.to))),
    userEvent: "select.search.matches"
  });
  return true;
});
const selectSelectionMatches = ({ state, dispatch }) => {
  let sel = state.selection;
  if (sel.ranges.length > 1 || sel.main.empty)
    return false;
  let { from, to: to2 } = sel.main;
  let ranges = [], main = 0;
  for (let cur2 = new SearchCursor(state.doc, state.sliceDoc(from, to2)); !cur2.next().done; ) {
    if (ranges.length > 1e3)
      return false;
    if (cur2.value.from == from)
      main = ranges.length;
    ranges.push(EditorSelection.range(cur2.value.from, cur2.value.to));
  }
  dispatch(state.update({
    selection: EditorSelection.create(ranges, main),
    userEvent: "select.search.matches"
  }));
  return true;
};
const replaceNext = /* @__PURE__ */ searchCommand((view, { query }) => {
  let { state } = view, { from, to: to2 } = state.selection.main;
  if (state.readOnly)
    return false;
  let next = query.nextMatch(state, from, from);
  if (!next)
    return false;
  let changes = [], selection, replacement;
  let effects = [];
  if (next.from == from && next.to == to2) {
    replacement = state.toText(query.getReplacement(next));
    changes.push({ from: next.from, to: next.to, insert: replacement });
    next = query.nextMatch(state, next.from, next.to);
    effects.push(EditorView.announce.of(state.phrase("replaced match on line $", state.doc.lineAt(from).number) + "."));
  }
  if (next) {
    let off2 = changes.length == 0 || changes[0].from >= next.to ? 0 : next.to - next.from - replacement.length;
    selection = EditorSelection.single(next.from - off2, next.to - off2);
    effects.push(announceMatch(view, next));
    effects.push(state.facet(searchConfigFacet).scrollToMatch(selection.main, view));
  }
  view.dispatch({
    changes,
    selection,
    effects,
    userEvent: "input.replace"
  });
  return true;
});
const replaceAll = /* @__PURE__ */ searchCommand((view, { query }) => {
  if (view.state.readOnly)
    return false;
  let changes = query.matchAll(view.state, 1e9).map((match2) => {
    let { from, to: to2 } = match2;
    return { from, to: to2, insert: query.getReplacement(match2) };
  });
  if (!changes.length)
    return false;
  let announceText = view.state.phrase("replaced $ matches", changes.length) + ".";
  view.dispatch({
    changes,
    effects: EditorView.announce.of(announceText),
    userEvent: "input.replace.all"
  });
  return true;
});
function createSearchPanel(view) {
  return view.state.facet(searchConfigFacet).createPanel(view);
}
function defaultQuery(state, fallback) {
  var _a2, _b2, _c2, _d2, _e2;
  let sel = state.selection.main;
  let selText = sel.empty || sel.to > sel.from + 100 ? "" : state.sliceDoc(sel.from, sel.to);
  if (fallback && !selText)
    return fallback;
  let config2 = state.facet(searchConfigFacet);
  return new SearchQuery({
    search: ((_a2 = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _a2 !== void 0 ? _a2 : config2.literal) ? selText : selText.replace(/\n/g, "\\n"),
    caseSensitive: (_b2 = fallback === null || fallback === void 0 ? void 0 : fallback.caseSensitive) !== null && _b2 !== void 0 ? _b2 : config2.caseSensitive,
    literal: (_c2 = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _c2 !== void 0 ? _c2 : config2.literal,
    regexp: (_d2 = fallback === null || fallback === void 0 ? void 0 : fallback.regexp) !== null && _d2 !== void 0 ? _d2 : config2.regexp,
    wholeWord: (_e2 = fallback === null || fallback === void 0 ? void 0 : fallback.wholeWord) !== null && _e2 !== void 0 ? _e2 : config2.wholeWord
  });
}
function getSearchInput(view) {
  let panel = getPanel(view, createSearchPanel);
  return panel && panel.dom.querySelector("[main-field]");
}
function selectSearchInput(view) {
  let input = getSearchInput(view);
  if (input && input == view.root.activeElement)
    input.select();
}
const openSearchPanel = (view) => {
  let state = view.state.field(searchState, false);
  if (state && state.panel) {
    let searchInput = getSearchInput(view);
    if (searchInput && searchInput != view.root.activeElement) {
      let query = defaultQuery(view.state, state.query.spec);
      if (query.valid)
        view.dispatch({ effects: setSearchQuery.of(query) });
      searchInput.focus();
      searchInput.select();
    }
  } else {
    view.dispatch({ effects: [
      togglePanel.of(true),
      state ? setSearchQuery.of(defaultQuery(view.state, state.query.spec)) : StateEffect.appendConfig.of(searchExtensions)
    ] });
  }
  return true;
};
const closeSearchPanel = (view) => {
  let state = view.state.field(searchState, false);
  if (!state || !state.panel)
    return false;
  let panel = getPanel(view, createSearchPanel);
  if (panel && panel.dom.contains(view.root.activeElement))
    view.focus();
  view.dispatch({ effects: togglePanel.of(false) });
  return true;
};
const searchKeymap = [
  { key: "Mod-f", run: openSearchPanel, scope: "editor search-panel" },
  { key: "F3", run: findNext, shift: findPrevious, scope: "editor search-panel", preventDefault: true },
  { key: "Mod-g", run: findNext, shift: findPrevious, scope: "editor search-panel", preventDefault: true },
  { key: "Escape", run: closeSearchPanel, scope: "editor search-panel" },
  { key: "Mod-Shift-l", run: selectSelectionMatches },
  { key: "Alt-g", run: gotoLine },
  { key: "Mod-d", run: selectNextOccurrence, preventDefault: true }
];
class SearchPanel {
  constructor(view) {
    this.view = view;
    let query = this.query = view.state.field(searchState).query.spec;
    this.commit = this.commit.bind(this);
    this.searchField = crelt("input", {
      value: query.search,
      placeholder: phrase(view, "Find"),
      "aria-label": phrase(view, "Find"),
      class: "cm-textfield",
      name: "search",
      form: "",
      "main-field": "true",
      onchange: this.commit,
      onkeyup: this.commit
    });
    this.replaceField = crelt("input", {
      value: query.replace,
      placeholder: phrase(view, "Replace"),
      "aria-label": phrase(view, "Replace"),
      class: "cm-textfield",
      name: "replace",
      form: "",
      onchange: this.commit,
      onkeyup: this.commit
    });
    this.caseField = crelt("input", {
      type: "checkbox",
      name: "case",
      form: "",
      checked: query.caseSensitive,
      onchange: this.commit
    });
    this.reField = crelt("input", {
      type: "checkbox",
      name: "re",
      form: "",
      checked: query.regexp,
      onchange: this.commit
    });
    this.wordField = crelt("input", {
      type: "checkbox",
      name: "word",
      form: "",
      checked: query.wholeWord,
      onchange: this.commit
    });
    function button(name2, onclick, content2) {
      return crelt("button", { class: "cm-button", name: name2, onclick, type: "button" }, content2);
    }
    this.dom = crelt("div", { onkeydown: (e25) => this.keydown(e25), class: "cm-search" }, [
      this.searchField,
      button("next", () => findNext(view), [phrase(view, "next")]),
      button("prev", () => findPrevious(view), [phrase(view, "previous")]),
      button("select", () => selectMatches(view), [phrase(view, "all")]),
      crelt("label", null, [this.caseField, phrase(view, "match case")]),
      crelt("label", null, [this.reField, phrase(view, "regexp")]),
      crelt("label", null, [this.wordField, phrase(view, "by word")]),
      ...view.state.readOnly ? [] : [
        crelt("br"),
        this.replaceField,
        button("replace", () => replaceNext(view), [phrase(view, "replace")]),
        button("replaceAll", () => replaceAll(view), [phrase(view, "replace all")])
      ],
      crelt("button", {
        name: "close",
        onclick: () => closeSearchPanel(view),
        "aria-label": phrase(view, "close"),
        type: "button"
      }, ["\xD7"])
    ]);
  }
  commit() {
    let query = new SearchQuery({
      search: this.searchField.value,
      caseSensitive: this.caseField.checked,
      regexp: this.reField.checked,
      wholeWord: this.wordField.checked,
      replace: this.replaceField.value
    });
    if (!query.eq(this.query)) {
      this.query = query;
      this.view.dispatch({ effects: setSearchQuery.of(query) });
    }
  }
  keydown(e25) {
    if (runScopeHandlers(this.view, e25, "search-panel")) {
      e25.preventDefault();
    } else if (e25.keyCode == 13 && e25.target == this.searchField) {
      e25.preventDefault();
      (e25.shiftKey ? findPrevious : findNext)(this.view);
    } else if (e25.keyCode == 13 && e25.target == this.replaceField) {
      e25.preventDefault();
      replaceNext(this.view);
    }
  }
  update(update) {
    for (let tr2 of update.transactions)
      for (let effect of tr2.effects) {
        if (effect.is(setSearchQuery) && !effect.value.eq(this.query))
          this.setQuery(effect.value);
      }
  }
  setQuery(query) {
    this.query = query;
    this.searchField.value = query.search;
    this.replaceField.value = query.replace;
    this.caseField.checked = query.caseSensitive;
    this.reField.checked = query.regexp;
    this.wordField.checked = query.wholeWord;
  }
  mount() {
    this.searchField.select();
  }
  get pos() {
    return 80;
  }
  get top() {
    return this.view.state.facet(searchConfigFacet).top;
  }
}
function phrase(view, phrase2) {
  return view.state.phrase(phrase2);
}
const AnnounceMargin = 30;
const Break = /[\s\.,:;?!]/;
function announceMatch(view, { from, to: to2 }) {
  let line = view.state.doc.lineAt(from), lineEnd = view.state.doc.lineAt(to2).to;
  let start = Math.max(line.from, from - AnnounceMargin), end = Math.min(lineEnd, to2 + AnnounceMargin);
  let text = view.state.sliceDoc(start, end);
  if (start != line.from) {
    for (let i2 = 0; i2 < AnnounceMargin; i2++)
      if (!Break.test(text[i2 + 1]) && Break.test(text[i2])) {
        text = text.slice(i2);
        break;
      }
  }
  if (end != lineEnd) {
    for (let i2 = text.length - 1; i2 > text.length - AnnounceMargin; i2--)
      if (!Break.test(text[i2 - 1]) && Break.test(text[i2])) {
        text = text.slice(0, i2);
        break;
      }
  }
  return EditorView.announce.of(`${view.state.phrase("current match")}. ${text} ${view.state.phrase("on line")} ${line.number}.`);
}
const baseTheme = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-panel.cm-search": {
    padding: "2px 6px 4px",
    position: "relative",
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    },
    "& input, & button, & label": {
      margin: ".2em .6em .2em 0"
    },
    "& input[type=checkbox]": {
      marginRight: ".2em"
    },
    "& label": {
      fontSize: "80%",
      whiteSpace: "pre"
    }
  },
  "&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
  "&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
  "&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
  "&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
});
const searchExtensions = [
  searchState,
  /* @__PURE__ */ Prec.lowest(searchHighlighter),
  baseTheme
];
const basicSetup = /* @__PURE__ */ (() => [
  lineNumbers(),
  highlightActiveLineGutter(),
  highlightSpecialChars(),
  history(),
  foldGutter(),
  drawSelection(),
  dropCursor(),
  EditorState.allowMultipleSelections.of(true),
  indentOnInput(),
  syntaxHighlighting(defaultHighlightStyle, { fallback: true }),
  bracketMatching(),
  closeBrackets(),
  autocompletion(),
  rectangularSelection(),
  crosshairCursor(),
  highlightActiveLine(),
  highlightSelectionMatches(),
  keymap.of([
    ...closeBracketsKeymap,
    ...defaultKeymap,
    ...searchKeymap,
    ...historyKeymap,
    ...foldKeymap,
    ...completionKeymap,
    ...lintKeymap
  ])
])();
var e = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function t(e25) {
  return e25 && e25.__esModule && Object.prototype.hasOwnProperty.call(e25, "default") ? e25.default : e25;
}
function r(e25, t2) {
  return e25(t2 = { exports: {} }, t2.exports), t2.exports;
}
function n(e25) {
  return e25 && e25.default || e25;
}
function i(e25) {
  return (i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e26) {
    return typeof e26;
  } : function(e26) {
    return e26 && typeof Symbol == "function" && e26.constructor === Symbol && e26 !== Symbol.prototype ? "symbol" : typeof e26;
  })(e25);
}
function a(e25, t2) {
  if (!(e25 instanceof t2))
    throw new TypeError("Cannot call a class as a function");
}
function o(e25, t2) {
  for (var r2 = 0; r2 < t2.length; r2++) {
    var n2 = t2[r2];
    n2.enumerable = n2.enumerable || false, n2.configurable = true, "value" in n2 && (n2.writable = true), Object.defineProperty(e25, n2.key, n2);
  }
}
function s(e25, t2, r2) {
  return t2 && o(e25.prototype, t2), r2 && o(e25, r2), e25;
}
function u(e25, t2, r2) {
  return t2 in e25 ? Object.defineProperty(e25, t2, { value: r2, enumerable: true, configurable: true, writable: true }) : e25[t2] = r2, e25;
}
function c(e25, t2) {
  var r2 = Object.keys(e25);
  if (Object.getOwnPropertySymbols) {
    var n2 = Object.getOwnPropertySymbols(e25);
    t2 && (n2 = n2.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e25, t3).enumerable;
    })), r2.push.apply(r2, n2);
  }
  return r2;
}
function p(e25) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var r2 = arguments[t2] != null ? arguments[t2] : {};
    t2 % 2 ? c(Object(r2), true).forEach(function(t3) {
      u(e25, t3, r2[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e25, Object.getOwnPropertyDescriptors(r2)) : c(Object(r2)).forEach(function(t3) {
      Object.defineProperty(e25, t3, Object.getOwnPropertyDescriptor(r2, t3));
    });
  }
  return e25;
}
function f(e25, t2) {
  if (typeof t2 != "function" && t2 !== null)
    throw new TypeError("Super expression must either be null or a function");
  e25.prototype = Object.create(t2 && t2.prototype, { constructor: { value: e25, writable: true, configurable: true } }), t2 && d(e25, t2);
}
function h(e25) {
  return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function(e26) {
    return e26.__proto__ || Object.getPrototypeOf(e26);
  })(e25);
}
function d(e25, t2) {
  return (d = Object.setPrototypeOf || function(e26, t3) {
    return e26.__proto__ = t3, e26;
  })(e25, t2);
}
function m(e25, t2, r2) {
  return (m = function() {
    if (typeof Reflect == "undefined" || !Reflect.construct)
      return false;
    if (Reflect.construct.sham)
      return false;
    if (typeof Proxy == "function")
      return true;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), true;
    } catch (e26) {
      return false;
    }
  }() ? Reflect.construct : function(e26, t3, r3) {
    var n2 = [null];
    n2.push.apply(n2, t3);
    var i2 = new (Function.bind.apply(e26, n2))();
    return r3 && d(i2, r3.prototype), i2;
  }).apply(null, arguments);
}
function g(e25) {
  var t2 = typeof Map == "function" ? new Map() : void 0;
  return (g = function(e26) {
    if (e26 === null || (r2 = e26, Function.toString.call(r2).indexOf("[native code]") === -1))
      return e26;
    var r2;
    if (typeof e26 != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (t2 !== void 0) {
      if (t2.has(e26))
        return t2.get(e26);
      t2.set(e26, n2);
    }
    function n2() {
      return m(e26, arguments, h(this).constructor);
    }
    return n2.prototype = Object.create(e26.prototype, { constructor: { value: n2, enumerable: false, writable: true, configurable: true } }), d(n2, e26);
  })(e25);
}
function y(e25) {
  if (e25 === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e25;
}
function v(e25, t2) {
  return !t2 || typeof t2 != "object" && typeof t2 != "function" ? y(e25) : t2;
}
function x(e25, t2, r2) {
  return (x = typeof Reflect != "undefined" && Reflect.get ? Reflect.get : function(e26, t3, r3) {
    var n2 = function(e27, t4) {
      for (; !Object.prototype.hasOwnProperty.call(e27, t4) && (e27 = h(e27)) !== null; )
        ;
      return e27;
    }(e26, t3);
    if (n2) {
      var i2 = Object.getOwnPropertyDescriptor(n2, t3);
      return i2.get ? i2.get.call(r3) : i2.value;
    }
  })(e25, t2, r2 || e25);
}
function b(e25, t2) {
  return C(e25) || function(e26, t3) {
    if (!(Symbol.iterator in Object(e26) || Object.prototype.toString.call(e26) === "[object Arguments]"))
      return;
    var r2 = [], n2 = true, i2 = false, a2 = void 0;
    try {
      for (var o2, s2 = e26[Symbol.iterator](); !(n2 = (o2 = s2.next()).done) && (r2.push(o2.value), !t3 || r2.length !== t3); n2 = true)
        ;
    } catch (e27) {
      i2 = true, a2 = e27;
    } finally {
      try {
        n2 || s2.return == null || s2.return();
      } finally {
        if (i2)
          throw a2;
      }
    }
    return r2;
  }(e25, t2) || k();
}
function E(e25) {
  return function(e26) {
    if (Array.isArray(e26)) {
      for (var t2 = 0, r2 = new Array(e26.length); t2 < e26.length; t2++)
        r2[t2] = e26[t2];
      return r2;
    }
  }(e25) || S(e25) || function() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}
function C(e25) {
  if (Array.isArray(e25))
    return e25;
}
function S(e25) {
  if (Symbol.iterator in Object(e25) || Object.prototype.toString.call(e25) === "[object Arguments]")
    return Array.from(e25);
}
function k() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var D = r(function(e25) {
  var t2 = e25.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
  typeof __g == "number" && (__g = t2);
}), F = {}.hasOwnProperty, A = function(e25, t2) {
  return F.call(e25, t2);
}, w = function(e25) {
  try {
    return !!e25();
  } catch (e26) {
    return true;
  }
}, _ = !w(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), T = r(function(e25) {
  var t2 = e25.exports = { version: "2.6.10" };
  typeof __e == "number" && (__e = t2);
}), P = (T.version, function(e25) {
  return i(e25) === "object" ? e25 !== null : typeof e25 == "function";
}), I = function(e25) {
  if (!P(e25))
    throw TypeError(e25 + " is not an object!");
  return e25;
}, B = D.document, O = P(B) && P(B.createElement), L = function(e25) {
  return O ? B.createElement(e25) : {};
}, N = !_ && !w(function() {
  return Object.defineProperty(L("div"), "a", { get: function() {
    return 7;
  } }).a != 7;
}), j = function(e25, t2) {
  if (!P(e25))
    return e25;
  var r2, n2;
  if (t2 && typeof (r2 = e25.toString) == "function" && !P(n2 = r2.call(e25)))
    return n2;
  if (typeof (r2 = e25.valueOf) == "function" && !P(n2 = r2.call(e25)))
    return n2;
  if (!t2 && typeof (r2 = e25.toString) == "function" && !P(n2 = r2.call(e25)))
    return n2;
  throw TypeError("Can't convert object to primitive value");
}, R = Object.defineProperty, M = { f: _ ? Object.defineProperty : function(e25, t2, r2) {
  if (I(e25), t2 = j(t2, true), I(r2), N)
    try {
      return R(e25, t2, r2);
    } catch (e26) {
    }
  if ("get" in r2 || "set" in r2)
    throw TypeError("Accessors not supported!");
  return "value" in r2 && (e25[t2] = r2.value), e25;
} }, V = function(e25, t2) {
  return { enumerable: !(1 & e25), configurable: !(2 & e25), writable: !(4 & e25), value: t2 };
}, U = _ ? function(e25, t2, r2) {
  return M.f(e25, t2, V(1, r2));
} : function(e25, t2, r2) {
  return e25[t2] = r2, e25;
}, q = 0, W = Math.random(), $ = function(e25) {
  return "Symbol(".concat(e25 === void 0 ? "" : e25, ")_", (++q + W).toString(36));
}, G = r(function(e25) {
  var t2 = D["__core-js_shared__"] || (D["__core-js_shared__"] = {});
  (e25.exports = function(e26, r2) {
    return t2[e26] || (t2[e26] = r2 !== void 0 ? r2 : {});
  })("versions", []).push({ version: T.version, mode: "global", copyright: "\xA9 2019 Denis Pushkarev (zloirock.ru)" });
}), z = G("native-function-to-string", Function.toString), H = r(function(e25) {
  var t2 = $("src"), r2 = ("" + z).split("toString");
  T.inspectSource = function(e26) {
    return z.call(e26);
  }, (e25.exports = function(e26, n2, i2, a2) {
    var o2 = typeof i2 == "function";
    o2 && (A(i2, "name") || U(i2, "name", n2)), e26[n2] !== i2 && (o2 && (A(i2, t2) || U(i2, t2, e26[n2] ? "" + e26[n2] : r2.join(String(n2)))), e26 === D ? e26[n2] = i2 : a2 ? e26[n2] ? e26[n2] = i2 : U(e26, n2, i2) : (delete e26[n2], U(e26, n2, i2)));
  })(Function.prototype, "toString", function() {
    return typeof this == "function" && this[t2] || z.call(this);
  });
}), K = function(e25) {
  if (typeof e25 != "function")
    throw TypeError(e25 + " is not a function!");
  return e25;
}, J = function(e25, t2, r2) {
  if (K(e25), t2 === void 0)
    return e25;
  switch (r2) {
    case 1:
      return function(r3) {
        return e25.call(t2, r3);
      };
    case 2:
      return function(r3, n2) {
        return e25.call(t2, r3, n2);
      };
    case 3:
      return function(r3, n2, i2) {
        return e25.call(t2, r3, n2, i2);
      };
  }
  return function() {
    return e25.apply(t2, arguments);
  };
}, Q = function e2(t2, r2, n2) {
  var i2, a2, o2, s2, u2 = t2 & e2.F, c2 = t2 & e2.G, l2 = t2 & e2.P, p2 = t2 & e2.B, f2 = c2 ? D : t2 & e2.S ? D[r2] || (D[r2] = {}) : (D[r2] || {}).prototype, h2 = c2 ? T : T[r2] || (T[r2] = {}), d2 = h2.prototype || (h2.prototype = {});
  for (i2 in c2 && (n2 = r2), n2)
    o2 = ((a2 = !u2 && f2 && f2[i2] !== void 0) ? f2 : n2)[i2], s2 = p2 && a2 ? J(o2, D) : l2 && typeof o2 == "function" ? J(Function.call, o2) : o2, f2 && H(f2, i2, o2, t2 & e2.U), h2[i2] != o2 && U(h2, i2, s2), l2 && d2[i2] != o2 && (d2[i2] = o2);
};
D.core = T, Q.F = 1, Q.G = 2, Q.S = 4, Q.P = 8, Q.B = 16, Q.W = 32, Q.U = 64, Q.R = 128;
var X = Q, Y = r(function(e25) {
  var t2 = $("meta"), r2 = M.f, n2 = 0, a2 = Object.isExtensible || function() {
    return true;
  }, o2 = !w(function() {
    return a2(Object.preventExtensions({}));
  }), s2 = function(e26) {
    r2(e26, t2, { value: { i: "O" + ++n2, w: {} } });
  }, u2 = e25.exports = { KEY: t2, NEED: false, fastKey: function(e26, r3) {
    if (!P(e26))
      return i(e26) == "symbol" ? e26 : (typeof e26 == "string" ? "S" : "P") + e26;
    if (!A(e26, t2)) {
      if (!a2(e26))
        return "F";
      if (!r3)
        return "E";
      s2(e26);
    }
    return e26[t2].i;
  }, getWeak: function(e26, r3) {
    if (!A(e26, t2)) {
      if (!a2(e26))
        return true;
      if (!r3)
        return false;
      s2(e26);
    }
    return e26[t2].w;
  }, onFreeze: function(e26) {
    return o2 && u2.NEED && a2(e26) && !A(e26, t2) && s2(e26), e26;
  } };
}), Z = (Y.KEY, Y.NEED, Y.fastKey, Y.getWeak, Y.onFreeze, r(function(e25) {
  var t2 = G("wks"), r2 = D.Symbol, n2 = typeof r2 == "function";
  (e25.exports = function(e26) {
    return t2[e26] || (t2[e26] = n2 && r2[e26] || (n2 ? r2 : $)("Symbol." + e26));
  }).store = t2;
})), ee = M.f, te = Z("toStringTag"), re = function(e25, t2, r2) {
  e25 && !A(e25 = r2 ? e25 : e25.prototype, te) && ee(e25, te, { configurable: true, value: t2 });
}, ne = { f: Z }, ie = M.f, ae = function(e25) {
  var t2 = T.Symbol || (T.Symbol = D.Symbol || {});
  e25.charAt(0) == "_" || e25 in t2 || ie(t2, e25, { value: ne.f(e25) });
}, oe = {}.toString, se = function(e25) {
  return oe.call(e25).slice(8, -1);
}, ue = Object("z").propertyIsEnumerable(0) ? Object : function(e25) {
  return se(e25) == "String" ? e25.split("") : Object(e25);
}, ce = function(e25) {
  if (e25 == null)
    throw TypeError("Can't call method on  " + e25);
  return e25;
}, le = function(e25) {
  return ue(ce(e25));
}, pe = Math.ceil, fe = Math.floor, he = function(e25) {
  return isNaN(e25 = +e25) ? 0 : (e25 > 0 ? fe : pe)(e25);
}, de$1 = Math.min, me = function(e25) {
  return e25 > 0 ? de$1(he(e25), 9007199254740991) : 0;
}, ge = Math.max, ye = Math.min, ve = function(e25, t2) {
  return (e25 = he(e25)) < 0 ? ge(e25 + t2, 0) : ye(e25, t2);
}, xe = function(e25) {
  return function(t2, r2, n2) {
    var i2, a2 = le(t2), o2 = me(a2.length), s2 = ve(n2, o2);
    if (e25 && r2 != r2) {
      for (; o2 > s2; )
        if ((i2 = a2[s2++]) != i2)
          return true;
    } else
      for (; o2 > s2; s2++)
        if ((e25 || s2 in a2) && a2[s2] === r2)
          return e25 || s2 || 0;
    return !e25 && -1;
  };
}, be = G("keys"), Ee = function(e25) {
  return be[e25] || (be[e25] = $(e25));
}, Ce = xe(false), Se = Ee("IE_PROTO"), ke = function(e25, t2) {
  var r2, n2 = le(e25), i2 = 0, a2 = [];
  for (r2 in n2)
    r2 != Se && A(n2, r2) && a2.push(r2);
  for (; t2.length > i2; )
    A(n2, r2 = t2[i2++]) && (~Ce(a2, r2) || a2.push(r2));
  return a2;
}, De = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","), Fe = Object.keys || function(e25) {
  return ke(e25, De);
}, Ae = { f: Object.getOwnPropertySymbols }, we = { f: {}.propertyIsEnumerable }, _e = Array.isArray || function(e25) {
  return se(e25) == "Array";
}, Te = function(e25) {
  return Object(ce(e25));
}, Pe = _ ? Object.defineProperties : function(e25, t2) {
  I(e25);
  for (var r2, n2 = Fe(t2), i2 = n2.length, a2 = 0; i2 > a2; )
    M.f(e25, r2 = n2[a2++], t2[r2]);
  return e25;
}, Ie = D.document, Be = Ie && Ie.documentElement, Oe = Ee("IE_PROTO"), Le = function() {
}, Ne = function() {
  var e25, t2 = L("iframe"), r2 = De.length;
  for (t2.style.display = "none", Be.appendChild(t2), t2.src = "javascript:", (e25 = t2.contentWindow.document).open(), e25.write("<script>document.F=Object<\/script>"), e25.close(), Ne = e25.F; r2--; )
    delete Ne.prototype[De[r2]];
  return Ne();
}, je = Object.create || function(e25, t2) {
  var r2;
  return e25 !== null ? (Le.prototype = I(e25), r2 = new Le(), Le.prototype = null, r2[Oe] = e25) : r2 = Ne(), t2 === void 0 ? r2 : Pe(r2, t2);
}, Re = De.concat("length", "prototype"), Me = { f: Object.getOwnPropertyNames || function(e25) {
  return ke(e25, Re);
} }, Ve = Me.f, Ue = {}.toString, qe = (typeof window == "undefined" ? "undefined" : i(window)) == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], We = { f: function(e25) {
  return qe && Ue.call(e25) == "[object Window]" ? function(e26) {
    try {
      return Ve(e26);
    } catch (e27) {
      return qe.slice();
    }
  }(e25) : Ve(le(e25));
} }, $e = Object.getOwnPropertyDescriptor, Ge = { f: _ ? $e : function(e25, t2) {
  if (e25 = le(e25), t2 = j(t2, true), N)
    try {
      return $e(e25, t2);
    } catch (e26) {
    }
  if (A(e25, t2))
    return V(!we.f.call(e25, t2), e25[t2]);
} }, ze = Y.KEY, He = Ge.f, Ke = M.f, Je = We.f, Qe = D.Symbol, Xe = D.JSON, Ye = Xe && Xe.stringify, Ze = Z("_hidden"), et = Z("toPrimitive"), tt = {}.propertyIsEnumerable, rt = G("symbol-registry"), nt = G("symbols"), it$1 = G("op-symbols"), at = Object.prototype, ot = typeof Qe == "function" && !!Ae.f, st = D.QObject, ut = !st || !st.prototype || !st.prototype.findChild, ct = _ && w(function() {
  return je(Ke({}, "a", { get: function() {
    return Ke(this, "a", { value: 7 }).a;
  } })).a != 7;
}) ? function(e25, t2, r2) {
  var n2 = He(at, t2);
  n2 && delete at[t2], Ke(e25, t2, r2), n2 && e25 !== at && Ke(at, t2, n2);
} : Ke, lt = function(e25) {
  var t2 = nt[e25] = je(Qe.prototype);
  return t2._k = e25, t2;
}, pt$1 = ot && i(Qe.iterator) == "symbol" ? function(e25) {
  return i(e25) == "symbol";
} : function(e25) {
  return e25 instanceof Qe;
}, ft = function(e25, t2, r2) {
  return e25 === at && ft(it$1, t2, r2), I(e25), t2 = j(t2, true), I(r2), A(nt, t2) ? (r2.enumerable ? (A(e25, Ze) && e25[Ze][t2] && (e25[Ze][t2] = false), r2 = je(r2, { enumerable: V(0, false) })) : (A(e25, Ze) || Ke(e25, Ze, V(1, {})), e25[Ze][t2] = true), ct(e25, t2, r2)) : Ke(e25, t2, r2);
}, ht = function(e25, t2) {
  I(e25);
  for (var r2, n2 = function(e26) {
    var t3 = Fe(e26), r3 = Ae.f;
    if (r3)
      for (var n3, i3 = r3(e26), a3 = we.f, o2 = 0; i3.length > o2; )
        a3.call(e26, n3 = i3[o2++]) && t3.push(n3);
    return t3;
  }(t2 = le(t2)), i2 = 0, a2 = n2.length; a2 > i2; )
    ft(e25, r2 = n2[i2++], t2[r2]);
  return e25;
}, dt = function(e25) {
  var t2 = tt.call(this, e25 = j(e25, true));
  return !(this === at && A(nt, e25) && !A(it$1, e25)) && (!(t2 || !A(this, e25) || !A(nt, e25) || A(this, Ze) && this[Ze][e25]) || t2);
}, mt = function(e25, t2) {
  if (e25 = le(e25), t2 = j(t2, true), e25 !== at || !A(nt, t2) || A(it$1, t2)) {
    var r2 = He(e25, t2);
    return !r2 || !A(nt, t2) || A(e25, Ze) && e25[Ze][t2] || (r2.enumerable = true), r2;
  }
}, gt = function(e25) {
  for (var t2, r2 = Je(le(e25)), n2 = [], i2 = 0; r2.length > i2; )
    A(nt, t2 = r2[i2++]) || t2 == Ze || t2 == ze || n2.push(t2);
  return n2;
}, yt = function(e25) {
  for (var t2, r2 = e25 === at, n2 = Je(r2 ? it$1 : le(e25)), i2 = [], a2 = 0; n2.length > a2; )
    !A(nt, t2 = n2[a2++]) || r2 && !A(at, t2) || i2.push(nt[t2]);
  return i2;
};
ot || (H((Qe = function() {
  if (this instanceof Qe)
    throw TypeError("Symbol is not a constructor!");
  var e25 = $(arguments.length > 0 ? arguments[0] : void 0), t2 = function t3(r2) {
    this === at && t3.call(it$1, r2), A(this, Ze) && A(this[Ze], e25) && (this[Ze][e25] = false), ct(this, e25, V(1, r2));
  };
  return _ && ut && ct(at, e25, { configurable: true, set: t2 }), lt(e25);
}).prototype, "toString", function() {
  return this._k;
}), Ge.f = mt, M.f = ft, Me.f = We.f = gt, we.f = dt, Ae.f = yt, _ && H(at, "propertyIsEnumerable", dt, true), ne.f = function(e25) {
  return lt(Z(e25));
}), X(X.G + X.W + X.F * !ot, { Symbol: Qe });
for (var vt = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), xt = 0; vt.length > xt; )
  Z(vt[xt++]);
for (var bt = Fe(Z.store), Et = 0; bt.length > Et; )
  ae(bt[Et++]);
X(X.S + X.F * !ot, "Symbol", { for: function(e25) {
  return A(rt, e25 += "") ? rt[e25] : rt[e25] = Qe(e25);
}, keyFor: function(e25) {
  if (!pt$1(e25))
    throw TypeError(e25 + " is not a symbol!");
  for (var t2 in rt)
    if (rt[t2] === e25)
      return t2;
}, useSetter: function() {
  ut = true;
}, useSimple: function() {
  ut = false;
} }), X(X.S + X.F * !ot, "Object", { create: function(e25, t2) {
  return t2 === void 0 ? je(e25) : ht(je(e25), t2);
}, defineProperty: ft, defineProperties: ht, getOwnPropertyDescriptor: mt, getOwnPropertyNames: gt, getOwnPropertySymbols: yt });
var Ct = w(function() {
  Ae.f(1);
});
X(X.S + X.F * Ct, "Object", { getOwnPropertySymbols: function(e25) {
  return Ae.f(Te(e25));
} }), Xe && X(X.S + X.F * (!ot || w(function() {
  var e25 = Qe();
  return Ye([e25]) != "[null]" || Ye({ a: e25 }) != "{}" || Ye(Object(e25)) != "{}";
})), "JSON", { stringify: function(e25) {
  for (var t2, r2, n2 = [e25], i2 = 1; arguments.length > i2; )
    n2.push(arguments[i2++]);
  if (r2 = t2 = n2[1], (P(t2) || e25 !== void 0) && !pt$1(e25))
    return _e(t2) || (t2 = function(e26, t3) {
      if (typeof r2 == "function" && (t3 = r2.call(this, e26, t3)), !pt$1(t3))
        return t3;
    }), n2[1] = t2, Ye.apply(Xe, n2);
} }), Qe.prototype[et] || U(Qe.prototype, et, Qe.prototype.valueOf), re(Qe, "Symbol"), re(Math, "Math", true), re(D.JSON, "JSON", true), X(X.S, "Object", { create: je }), X(X.S + X.F * !_, "Object", { defineProperty: M.f }), X(X.S + X.F * !_, "Object", { defineProperties: Pe });
var St = function(e25, t2) {
  var r2 = (T.Object || {})[e25] || Object[e25], n2 = {};
  n2[e25] = t2(r2), X(X.S + X.F * w(function() {
    r2(1);
  }), "Object", n2);
}, kt = Ge.f;
St("getOwnPropertyDescriptor", function() {
  return function(e25, t2) {
    return kt(le(e25), t2);
  };
});
var Dt = Ee("IE_PROTO"), Ft = Object.prototype, At = Object.getPrototypeOf || function(e25) {
  return e25 = Te(e25), A(e25, Dt) ? e25[Dt] : typeof e25.constructor == "function" && e25 instanceof e25.constructor ? e25.constructor.prototype : e25 instanceof Object ? Ft : null;
};
St("getPrototypeOf", function() {
  return function(e25) {
    return At(Te(e25));
  };
}), St("keys", function() {
  return function(e25) {
    return Fe(Te(e25));
  };
}), St("getOwnPropertyNames", function() {
  return We.f;
});
var wt = Y.onFreeze;
St("freeze", function(e25) {
  return function(t2) {
    return e25 && P(t2) ? e25(wt(t2)) : t2;
  };
});
var _t = Y.onFreeze;
St("seal", function(e25) {
  return function(t2) {
    return e25 && P(t2) ? e25(_t(t2)) : t2;
  };
});
var Tt = Y.onFreeze;
St("preventExtensions", function(e25) {
  return function(t2) {
    return e25 && P(t2) ? e25(Tt(t2)) : t2;
  };
}), St("isFrozen", function(e25) {
  return function(t2) {
    return !P(t2) || !!e25 && e25(t2);
  };
}), St("isSealed", function(e25) {
  return function(t2) {
    return !P(t2) || !!e25 && e25(t2);
  };
}), St("isExtensible", function(e25) {
  return function(t2) {
    return !!P(t2) && (!e25 || e25(t2));
  };
});
var Pt = Object.assign, It = !Pt || w(function() {
  var e25 = {}, t2 = {}, r2 = Symbol(), n2 = "abcdefghijklmnopqrst";
  return e25[r2] = 7, n2.split("").forEach(function(e26) {
    t2[e26] = e26;
  }), Pt({}, e25)[r2] != 7 || Object.keys(Pt({}, t2)).join("") != n2;
}) ? function(e25, t2) {
  for (var r2 = Te(e25), n2 = arguments.length, i2 = 1, a2 = Ae.f, o2 = we.f; n2 > i2; )
    for (var s2, u2 = ue(arguments[i2++]), c2 = a2 ? Fe(u2).concat(a2(u2)) : Fe(u2), l2 = c2.length, p2 = 0; l2 > p2; )
      s2 = c2[p2++], _ && !o2.call(u2, s2) || (r2[s2] = u2[s2]);
  return r2;
} : Pt;
X(X.S + X.F, "Object", { assign: It });
var Bt = Object.is || function(e25, t2) {
  return e25 === t2 ? e25 !== 0 || 1 / e25 == 1 / t2 : e25 != e25 && t2 != t2;
};
X(X.S, "Object", { is: Bt });
var Ot = function(e25, t2) {
  if (I(e25), !P(t2) && t2 !== null)
    throw TypeError(t2 + ": can't set as prototype!");
}, Lt = { set: Object.setPrototypeOf || ("__proto__" in {} ? function(e25, t2, r2) {
  try {
    (r2 = J(Function.call, Ge.f(Object.prototype, "__proto__").set, 2))(e25, []), t2 = !(e25 instanceof Array);
  } catch (e26) {
    t2 = true;
  }
  return function(e26, n2) {
    return Ot(e26, n2), t2 ? e26.__proto__ = n2 : r2(e26, n2), e26;
  };
}({}, false) : void 0), check: Ot };
X(X.S, "Object", { setPrototypeOf: Lt.set });
var Nt = Z("toStringTag"), jt = se(function() {
  return arguments;
}()) == "Arguments", Rt = function(e25) {
  var t2, r2, n2;
  return e25 === void 0 ? "Undefined" : e25 === null ? "Null" : typeof (r2 = function(e26, t3) {
    try {
      return e26[t3];
    } catch (e27) {
    }
  }(t2 = Object(e25), Nt)) == "string" ? r2 : jt ? se(t2) : (n2 = se(t2)) == "Object" && typeof t2.callee == "function" ? "Arguments" : n2;
}, Mt = {};
Mt[Z("toStringTag")] = "z", Mt + "" != "[object z]" && H(Object.prototype, "toString", function() {
  return "[object " + Rt(this) + "]";
}, true);
var Vt = function(e25, t2, r2) {
  var n2 = r2 === void 0;
  switch (t2.length) {
    case 0:
      return n2 ? e25() : e25.call(r2);
    case 1:
      return n2 ? e25(t2[0]) : e25.call(r2, t2[0]);
    case 2:
      return n2 ? e25(t2[0], t2[1]) : e25.call(r2, t2[0], t2[1]);
    case 3:
      return n2 ? e25(t2[0], t2[1], t2[2]) : e25.call(r2, t2[0], t2[1], t2[2]);
    case 4:
      return n2 ? e25(t2[0], t2[1], t2[2], t2[3]) : e25.call(r2, t2[0], t2[1], t2[2], t2[3]);
  }
  return e25.apply(r2, t2);
}, Ut = [].slice, qt = {}, Wt = function(e25, t2, r2) {
  if (!(t2 in qt)) {
    for (var n2 = [], i2 = 0; i2 < t2; i2++)
      n2[i2] = "a[" + i2 + "]";
    qt[t2] = Function("F,a", "return new F(" + n2.join(",") + ")");
  }
  return qt[t2](e25, r2);
}, $t = Function.bind || function(e25) {
  var t2 = K(this), r2 = Ut.call(arguments, 1), n2 = function n3() {
    var i2 = r2.concat(Ut.call(arguments));
    return this instanceof n3 ? Wt(t2, i2.length, i2) : Vt(t2, i2, e25);
  };
  return P(t2.prototype) && (n2.prototype = t2.prototype), n2;
};
X(X.P, "Function", { bind: $t });
var Gt = M.f, zt = Function.prototype, Ht = /^\s*function ([^ (]*)/;
"name" in zt || _ && Gt(zt, "name", { configurable: true, get: function() {
  try {
    return ("" + this).match(Ht)[1];
  } catch (e25) {
    return "";
  }
} });
var Kt = Z("hasInstance"), Jt = Function.prototype;
Kt in Jt || M.f(Jt, Kt, { value: function(e25) {
  if (typeof this != "function" || !P(e25))
    return false;
  if (!P(this.prototype))
    return e25 instanceof this;
  for (; e25 = At(e25); )
    if (this.prototype === e25)
      return true;
  return false;
} });
var Qt = "	\n\v\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF", Xt = "[" + Qt + "]", Yt = RegExp("^" + Xt + Xt + "*"), Zt = RegExp(Xt + Xt + "*$"), er = function(e25, t2, r2) {
  var n2 = {}, i2 = w(function() {
    return !!Qt[e25]() || "\u200B\x85"[e25]() != "\u200B\x85";
  }), a2 = n2[e25] = i2 ? t2(tr) : Qt[e25];
  r2 && (n2[r2] = a2), X(X.P + X.F * i2, "String", n2);
}, tr = er.trim = function(e25, t2) {
  return e25 = String(ce(e25)), 1 & t2 && (e25 = e25.replace(Yt, "")), 2 & t2 && (e25 = e25.replace(Zt, "")), e25;
}, rr = er, nr = D.parseInt, ir = rr.trim, ar = /^[-+]?0[xX]/, or = nr(Qt + "08") !== 8 || nr(Qt + "0x16") !== 22 ? function(e25, t2) {
  var r2 = ir(String(e25), 3);
  return nr(r2, t2 >>> 0 || (ar.test(r2) ? 16 : 10));
} : nr;
X(X.G + X.F * (parseInt != or), { parseInt: or });
var sr = D.parseFloat, ur = rr.trim, cr = 1 / sr(Qt + "-0") != -1 / 0 ? function(e25) {
  var t2 = ur(String(e25), 3), r2 = sr(t2);
  return r2 === 0 && t2.charAt(0) == "-" ? -0 : r2;
} : sr;
X(X.G + X.F * (parseFloat != cr), { parseFloat: cr });
var lr = Lt.set, pr = function(e25, t2, r2) {
  var n2, i2 = t2.constructor;
  return i2 !== r2 && typeof i2 == "function" && (n2 = i2.prototype) !== r2.prototype && P(n2) && lr && lr(e25, n2), e25;
}, fr = Me.f, hr = Ge.f, dr = M.f, mr = rr.trim, gr = D.Number, yr = gr, vr = gr.prototype, xr = se(je(vr)) == "Number", br = "trim" in String.prototype, Er = function(e25) {
  var t2 = j(e25, false);
  if (typeof t2 == "string" && t2.length > 2) {
    var r2, n2, i2, a2 = (t2 = br ? t2.trim() : mr(t2, 3)).charCodeAt(0);
    if (a2 === 43 || a2 === 45) {
      if ((r2 = t2.charCodeAt(2)) === 88 || r2 === 120)
        return NaN;
    } else if (a2 === 48) {
      switch (t2.charCodeAt(1)) {
        case 66:
        case 98:
          n2 = 2, i2 = 49;
          break;
        case 79:
        case 111:
          n2 = 8, i2 = 55;
          break;
        default:
          return +t2;
      }
      for (var o2, s2 = t2.slice(2), u2 = 0, c2 = s2.length; u2 < c2; u2++)
        if ((o2 = s2.charCodeAt(u2)) < 48 || o2 > i2)
          return NaN;
      return parseInt(s2, n2);
    }
  }
  return +t2;
};
if (!gr(" 0o1") || !gr("0b1") || gr("+0x1")) {
  gr = function(e25) {
    var t2 = arguments.length < 1 ? 0 : e25, r2 = this;
    return r2 instanceof gr && (xr ? w(function() {
      vr.valueOf.call(r2);
    }) : se(r2) != "Number") ? pr(new yr(Er(t2)), r2, gr) : Er(t2);
  };
  for (var Cr, Sr = _ ? fr(yr) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), kr = 0; Sr.length > kr; kr++)
    A(yr, Cr = Sr[kr]) && !A(gr, Cr) && dr(gr, Cr, hr(yr, Cr));
  gr.prototype = vr, vr.constructor = gr, H(D, "Number", gr);
}
var Dr = function(e25, t2) {
  if (typeof e25 != "number" && se(e25) != "Number")
    throw TypeError(t2);
  return +e25;
}, Fr = function(e25) {
  var t2 = String(ce(this)), r2 = "", n2 = he(e25);
  if (n2 < 0 || n2 == 1 / 0)
    throw RangeError("Count can't be negative");
  for (; n2 > 0; (n2 >>>= 1) && (t2 += t2))
    1 & n2 && (r2 += t2);
  return r2;
}, Ar = 1 .toFixed, wr = Math.floor, _r = [0, 0, 0, 0, 0, 0], Tr = "Number.toFixed: incorrect invocation!", Pr = function(e25, t2) {
  for (var r2 = -1, n2 = t2; ++r2 < 6; )
    n2 += e25 * _r[r2], _r[r2] = n2 % 1e7, n2 = wr(n2 / 1e7);
}, Ir = function(e25) {
  for (var t2 = 6, r2 = 0; --t2 >= 0; )
    r2 += _r[t2], _r[t2] = wr(r2 / e25), r2 = r2 % e25 * 1e7;
}, Br = function() {
  for (var e25 = 6, t2 = ""; --e25 >= 0; )
    if (t2 !== "" || e25 === 0 || _r[e25] !== 0) {
      var r2 = String(_r[e25]);
      t2 = t2 === "" ? r2 : t2 + Fr.call("0", 7 - r2.length) + r2;
    }
  return t2;
}, Or = function e3(t2, r2, n2) {
  return r2 === 0 ? n2 : r2 % 2 == 1 ? e3(t2, r2 - 1, n2 * t2) : e3(t2 * t2, r2 / 2, n2);
};
X(X.P + X.F * (!!Ar && (8e-5 .toFixed(3) !== "0.000" || 0.9 .toFixed(0) !== "1" || 1.255 .toFixed(2) !== "1.25" || 1000000000000000100 .toFixed(0) !== "1000000000000000128") || !w(function() {
  Ar.call({});
})), "Number", { toFixed: function(e25) {
  var t2, r2, n2, i2, a2 = Dr(this, Tr), o2 = he(e25), s2 = "", u2 = "0";
  if (o2 < 0 || o2 > 20)
    throw RangeError(Tr);
  if (a2 != a2)
    return "NaN";
  if (a2 <= -1e21 || a2 >= 1e21)
    return String(a2);
  if (a2 < 0 && (s2 = "-", a2 = -a2), a2 > 1e-21)
    if (r2 = (t2 = function(e26) {
      for (var t3 = 0, r3 = e26; r3 >= 4096; )
        t3 += 12, r3 /= 4096;
      for (; r3 >= 2; )
        t3 += 1, r3 /= 2;
      return t3;
    }(a2 * Or(2, 69, 1)) - 69) < 0 ? a2 * Or(2, -t2, 1) : a2 / Or(2, t2, 1), r2 *= 4503599627370496, (t2 = 52 - t2) > 0) {
      for (Pr(0, r2), n2 = o2; n2 >= 7; )
        Pr(1e7, 0), n2 -= 7;
      for (Pr(Or(10, n2, 1), 0), n2 = t2 - 1; n2 >= 23; )
        Ir(1 << 23), n2 -= 23;
      Ir(1 << n2), Pr(1, 1), Ir(2), u2 = Br();
    } else
      Pr(0, r2), Pr(1 << -t2, 0), u2 = Br() + Fr.call("0", o2);
  return u2 = o2 > 0 ? s2 + ((i2 = u2.length) <= o2 ? "0." + Fr.call("0", o2 - i2) + u2 : u2.slice(0, i2 - o2) + "." + u2.slice(i2 - o2)) : s2 + u2;
} });
var Lr = 1 .toPrecision;
X(X.P + X.F * (w(function() {
  return Lr.call(1, void 0) !== "1";
}) || !w(function() {
  Lr.call({});
})), "Number", { toPrecision: function(e25) {
  var t2 = Dr(this, "Number#toPrecision: incorrect invocation!");
  return e25 === void 0 ? Lr.call(t2) : Lr.call(t2, e25);
} }), X(X.S, "Number", { EPSILON: Math.pow(2, -52) });
var Nr = D.isFinite;
X(X.S, "Number", { isFinite: function(e25) {
  return typeof e25 == "number" && Nr(e25);
} });
var jr = Math.floor, Rr = function(e25) {
  return !P(e25) && isFinite(e25) && jr(e25) === e25;
};
X(X.S, "Number", { isInteger: Rr }), X(X.S, "Number", { isNaN: function(e25) {
  return e25 != e25;
} });
var Mr = Math.abs;
X(X.S, "Number", { isSafeInteger: function(e25) {
  return Rr(e25) && Mr(e25) <= 9007199254740991;
} }), X(X.S, "Number", { MAX_SAFE_INTEGER: 9007199254740991 }), X(X.S, "Number", { MIN_SAFE_INTEGER: -9007199254740991 }), X(X.S + X.F * (Number.parseFloat != cr), "Number", { parseFloat: cr }), X(X.S + X.F * (Number.parseInt != or), "Number", { parseInt: or });
var Vr = Math.log1p || function(e25) {
  return (e25 = +e25) > -1e-8 && e25 < 1e-8 ? e25 - e25 * e25 / 2 : Math.log(1 + e25);
}, Ur = Math.sqrt, qr = Math.acosh;
X(X.S + X.F * !(qr && Math.floor(qr(Number.MAX_VALUE)) == 710 && qr(1 / 0) == 1 / 0), "Math", { acosh: function(e25) {
  return (e25 = +e25) < 1 ? NaN : e25 > 9490626562425156e-8 ? Math.log(e25) + Math.LN2 : Vr(e25 - 1 + Ur(e25 - 1) * Ur(e25 + 1));
} });
var Wr = Math.asinh;
X(X.S + X.F * !(Wr && 1 / Wr(0) > 0), "Math", { asinh: function e4(t2) {
  return isFinite(t2 = +t2) && t2 != 0 ? t2 < 0 ? -e4(-t2) : Math.log(t2 + Math.sqrt(t2 * t2 + 1)) : t2;
} });
var $r = Math.atanh;
X(X.S + X.F * !($r && 1 / $r(-0) < 0), "Math", { atanh: function(e25) {
  return (e25 = +e25) == 0 ? e25 : Math.log((1 + e25) / (1 - e25)) / 2;
} });
var Gr = Math.sign || function(e25) {
  return (e25 = +e25) == 0 || e25 != e25 ? e25 : e25 < 0 ? -1 : 1;
};
X(X.S, "Math", { cbrt: function(e25) {
  return Gr(e25 = +e25) * Math.pow(Math.abs(e25), 1 / 3);
} }), X(X.S, "Math", { clz32: function(e25) {
  return (e25 >>>= 0) ? 31 - Math.floor(Math.log(e25 + 0.5) * Math.LOG2E) : 32;
} });
var zr = Math.exp;
X(X.S, "Math", { cosh: function(e25) {
  return (zr(e25 = +e25) + zr(-e25)) / 2;
} });
var Hr = Math.expm1, Kr = !Hr || Hr(10) > 22025.465794806718 || Hr(10) < 22025.465794806718 || Hr(-2e-17) != -2e-17 ? function(e25) {
  return (e25 = +e25) == 0 ? e25 : e25 > -1e-6 && e25 < 1e-6 ? e25 + e25 * e25 / 2 : Math.exp(e25) - 1;
} : Hr;
X(X.S + X.F * (Kr != Math.expm1), "Math", { expm1: Kr });
var Jr = Math.pow, Qr = Jr(2, -52), Xr = Jr(2, -23), Yr = Jr(2, 127) * (2 - Xr), Zr = Jr(2, -126), en = Math.fround || function(e25) {
  var t2, r2, n2 = Math.abs(e25), i2 = Gr(e25);
  return n2 < Zr ? i2 * (n2 / Zr / Xr + 1 / Qr - 1 / Qr) * Zr * Xr : (r2 = (t2 = (1 + Xr / Qr) * n2) - (t2 - n2)) > Yr || r2 != r2 ? i2 * (1 / 0) : i2 * r2;
};
X(X.S, "Math", { fround: en });
var tn = Math.abs;
X(X.S, "Math", { hypot: function(e25, t2) {
  for (var r2, n2, i2 = 0, a2 = 0, o2 = arguments.length, s2 = 0; a2 < o2; )
    s2 < (r2 = tn(arguments[a2++])) ? (i2 = i2 * (n2 = s2 / r2) * n2 + 1, s2 = r2) : i2 += r2 > 0 ? (n2 = r2 / s2) * n2 : r2;
  return s2 === 1 / 0 ? 1 / 0 : s2 * Math.sqrt(i2);
} });
var rn = Math.imul;
X(X.S + X.F * w(function() {
  return rn(4294967295, 5) != -5 || rn.length != 2;
}), "Math", { imul: function(e25, t2) {
  var r2 = +e25, n2 = +t2, i2 = 65535 & r2, a2 = 65535 & n2;
  return 0 | i2 * a2 + ((65535 & r2 >>> 16) * a2 + i2 * (65535 & n2 >>> 16) << 16 >>> 0);
} }), X(X.S, "Math", { log10: function(e25) {
  return Math.log(e25) * Math.LOG10E;
} }), X(X.S, "Math", { log1p: Vr }), X(X.S, "Math", { log2: function(e25) {
  return Math.log(e25) / Math.LN2;
} }), X(X.S, "Math", { sign: Gr });
var nn = Math.exp;
X(X.S + X.F * w(function() {
  return !Math.sinh(-2e-17) != -2e-17;
}), "Math", { sinh: function(e25) {
  return Math.abs(e25 = +e25) < 1 ? (Kr(e25) - Kr(-e25)) / 2 : (nn(e25 - 1) - nn(-e25 - 1)) * (Math.E / 2);
} });
var an = Math.exp;
X(X.S, "Math", { tanh: function(e25) {
  var t2 = Kr(e25 = +e25), r2 = Kr(-e25);
  return t2 == 1 / 0 ? 1 : r2 == 1 / 0 ? -1 : (t2 - r2) / (an(e25) + an(-e25));
} }), X(X.S, "Math", { trunc: function(e25) {
  return (e25 > 0 ? Math.floor : Math.ceil)(e25);
} });
var on = String.fromCharCode, sn = String.fromCodePoint;
X(X.S + X.F * (!!sn && sn.length != 1), "String", { fromCodePoint: function(e25) {
  for (var t2, r2 = [], n2 = arguments.length, i2 = 0; n2 > i2; ) {
    if (t2 = +arguments[i2++], ve(t2, 1114111) !== t2)
      throw RangeError(t2 + " is not a valid code point");
    r2.push(t2 < 65536 ? on(t2) : on(55296 + ((t2 -= 65536) >> 10), t2 % 1024 + 56320));
  }
  return r2.join("");
} }), X(X.S, "String", { raw: function(e25) {
  for (var t2 = le(e25.raw), r2 = me(t2.length), n2 = arguments.length, i2 = [], a2 = 0; r2 > a2; )
    i2.push(String(t2[a2++])), a2 < n2 && i2.push(String(arguments[a2]));
  return i2.join("");
} }), rr("trim", function(e25) {
  return function() {
    return e25(this, 3);
  };
});
var un = function(e25) {
  return function(t2, r2) {
    var n2, i2, a2 = String(ce(t2)), o2 = he(r2), s2 = a2.length;
    return o2 < 0 || o2 >= s2 ? e25 ? "" : void 0 : (n2 = a2.charCodeAt(o2)) < 55296 || n2 > 56319 || o2 + 1 === s2 || (i2 = a2.charCodeAt(o2 + 1)) < 56320 || i2 > 57343 ? e25 ? a2.charAt(o2) : n2 : e25 ? a2.slice(o2, o2 + 2) : i2 - 56320 + (n2 - 55296 << 10) + 65536;
  };
}, cn = {}, ln = {};
U(ln, Z("iterator"), function() {
  return this;
});
var pn = function(e25, t2, r2) {
  e25.prototype = je(ln, { next: V(1, r2) }), re(e25, t2 + " Iterator");
}, fn = Z("iterator"), hn = !([].keys && "next" in [].keys()), dn = function() {
  return this;
}, mn = function(e25, t2, r2, n2, i2, a2, o2) {
  pn(r2, t2, n2);
  var s2, u2, c2, l2 = function(e26) {
    if (!hn && e26 in d2)
      return d2[e26];
    switch (e26) {
      case "keys":
      case "values":
        return function() {
          return new r2(this, e26);
        };
    }
    return function() {
      return new r2(this, e26);
    };
  }, p2 = t2 + " Iterator", f2 = i2 == "values", h2 = false, d2 = e25.prototype, m2 = d2[fn] || d2["@@iterator"] || i2 && d2[i2], g2 = m2 || l2(i2), y2 = i2 ? f2 ? l2("entries") : g2 : void 0, v2 = t2 == "Array" && d2.entries || m2;
  if (v2 && (c2 = At(v2.call(new e25()))) !== Object.prototype && c2.next && (re(c2, p2, true), typeof c2[fn] != "function" && U(c2, fn, dn)), f2 && m2 && m2.name !== "values" && (h2 = true, g2 = function() {
    return m2.call(this);
  }), (hn || h2 || !d2[fn]) && U(d2, fn, g2), cn[t2] = g2, cn[p2] = dn, i2)
    if (s2 = { values: f2 ? g2 : l2("values"), keys: a2 ? g2 : l2("keys"), entries: y2 }, o2)
      for (u2 in s2)
        u2 in d2 || H(d2, u2, s2[u2]);
    else
      X(X.P + X.F * (hn || h2), t2, s2);
  return s2;
}, gn = un(true);
mn(String, "String", function(e25) {
  this._t = String(e25), this._i = 0;
}, function() {
  var e25, t2 = this._t, r2 = this._i;
  return r2 >= t2.length ? { value: void 0, done: true } : (e25 = gn(t2, r2), this._i += e25.length, { value: e25, done: false });
});
var yn = un(false);
X(X.P, "String", { codePointAt: function(e25) {
  return yn(this, e25);
} });
var vn = Z("match"), xn = function(e25) {
  var t2;
  return P(e25) && ((t2 = e25[vn]) !== void 0 ? !!t2 : se(e25) == "RegExp");
}, bn = function(e25, t2, r2) {
  if (xn(t2))
    throw TypeError("String#" + r2 + " doesn't accept regex!");
  return String(ce(e25));
}, En = Z("match"), Cn = function(e25) {
  var t2 = /./;
  try {
    "/./"[e25](t2);
  } catch (r2) {
    try {
      return t2[En] = false, !"/./"[e25](t2);
    } catch (e26) {
    }
  }
  return true;
}, Sn = "".endsWith;
X(X.P + X.F * Cn("endsWith"), "String", { endsWith: function(e25) {
  var t2 = bn(this, e25, "endsWith"), r2 = arguments.length > 1 ? arguments[1] : void 0, n2 = me(t2.length), i2 = r2 === void 0 ? n2 : Math.min(me(r2), n2), a2 = String(e25);
  return Sn ? Sn.call(t2, a2, i2) : t2.slice(i2 - a2.length, i2) === a2;
} });
X(X.P + X.F * Cn("includes"), "String", { includes: function(e25) {
  return !!~bn(this, e25, "includes").indexOf(e25, arguments.length > 1 ? arguments[1] : void 0);
} }), X(X.P, "String", { repeat: Fr });
var kn = "".startsWith;
X(X.P + X.F * Cn("startsWith"), "String", { startsWith: function(e25) {
  var t2 = bn(this, e25, "startsWith"), r2 = me(Math.min(arguments.length > 1 ? arguments[1] : void 0, t2.length)), n2 = String(e25);
  return kn ? kn.call(t2, n2, r2) : t2.slice(r2, r2 + n2.length) === n2;
} });
var Dn = /"/g, Fn = function(e25, t2, r2, n2) {
  var i2 = String(ce(e25)), a2 = "<" + t2;
  return r2 !== "" && (a2 += " " + r2 + '="' + String(n2).replace(Dn, "&quot;") + '"'), a2 + ">" + i2 + "</" + t2 + ">";
}, An = function(e25, t2) {
  var r2 = {};
  r2[e25] = t2(Fn), X(X.P + X.F * w(function() {
    var t3 = ""[e25]('"');
    return t3 !== t3.toLowerCase() || t3.split('"').length > 3;
  }), "String", r2);
};
An("anchor", function(e25) {
  return function(t2) {
    return e25(this, "a", "name", t2);
  };
}), An("big", function(e25) {
  return function() {
    return e25(this, "big", "", "");
  };
}), An("blink", function(e25) {
  return function() {
    return e25(this, "blink", "", "");
  };
}), An("bold", function(e25) {
  return function() {
    return e25(this, "b", "", "");
  };
}), An("fixed", function(e25) {
  return function() {
    return e25(this, "tt", "", "");
  };
}), An("fontcolor", function(e25) {
  return function(t2) {
    return e25(this, "font", "color", t2);
  };
}), An("fontsize", function(e25) {
  return function(t2) {
    return e25(this, "font", "size", t2);
  };
}), An("italics", function(e25) {
  return function() {
    return e25(this, "i", "", "");
  };
}), An("link", function(e25) {
  return function(t2) {
    return e25(this, "a", "href", t2);
  };
}), An("small", function(e25) {
  return function() {
    return e25(this, "small", "", "");
  };
}), An("strike", function(e25) {
  return function() {
    return e25(this, "strike", "", "");
  };
}), An("sub", function(e25) {
  return function() {
    return e25(this, "sub", "", "");
  };
}), An("sup", function(e25) {
  return function() {
    return e25(this, "sup", "", "");
  };
}), X(X.S, "Date", { now: function() {
  return new Date().getTime();
} }), X(X.P + X.F * w(function() {
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({ toISOString: function() {
    return 1;
  } }) !== 1;
}), "Date", { toJSON: function(e25) {
  var t2 = Te(this), r2 = j(t2);
  return typeof r2 != "number" || isFinite(r2) ? t2.toISOString() : null;
} });
var wn = Date.prototype.getTime, _n = Date.prototype.toISOString, Tn = function(e25) {
  return e25 > 9 ? e25 : "0" + e25;
}, Pn = w(function() {
  return _n.call(new Date(-5e13 - 1)) != "0385-07-25T07:06:39.999Z";
}) || !w(function() {
  _n.call(new Date(NaN));
}) ? function() {
  if (!isFinite(wn.call(this)))
    throw RangeError("Invalid time value");
  var e25 = this, t2 = e25.getUTCFullYear(), r2 = e25.getUTCMilliseconds(), n2 = t2 < 0 ? "-" : t2 > 9999 ? "+" : "";
  return n2 + ("00000" + Math.abs(t2)).slice(n2 ? -6 : -4) + "-" + Tn(e25.getUTCMonth() + 1) + "-" + Tn(e25.getUTCDate()) + "T" + Tn(e25.getUTCHours()) + ":" + Tn(e25.getUTCMinutes()) + ":" + Tn(e25.getUTCSeconds()) + "." + (r2 > 99 ? r2 : "0" + Tn(r2)) + "Z";
} : _n;
X(X.P + X.F * (Date.prototype.toISOString !== Pn), "Date", { toISOString: Pn });
var In = Date.prototype, Bn = In.toString, On = In.getTime;
new Date(NaN) + "" != "Invalid Date" && H(In, "toString", function() {
  var e25 = On.call(this);
  return e25 == e25 ? Bn.call(this) : "Invalid Date";
});
var Ln = Z("toPrimitive"), Nn = Date.prototype;
Ln in Nn || U(Nn, Ln, function(e25) {
  if (e25 !== "string" && e25 !== "number" && e25 !== "default")
    throw TypeError("Incorrect hint");
  return j(I(this), e25 != "number");
}), X(X.S, "Array", { isArray: _e });
var jn = function(e25, t2, r2, n2) {
  try {
    return n2 ? t2(I(r2)[0], r2[1]) : t2(r2);
  } catch (t3) {
    var i2 = e25.return;
    throw i2 !== void 0 && I(i2.call(e25)), t3;
  }
}, Rn = Z("iterator"), Mn = Array.prototype, Vn = function(e25) {
  return e25 !== void 0 && (cn.Array === e25 || Mn[Rn] === e25);
}, Un = function(e25, t2, r2) {
  t2 in e25 ? M.f(e25, t2, V(0, r2)) : e25[t2] = r2;
}, qn = Z("iterator"), Wn = T.getIteratorMethod = function(e25) {
  if (e25 != null)
    return e25[qn] || e25["@@iterator"] || cn[Rt(e25)];
}, $n = Z("iterator"), Gn = false;
try {
  var zn = [7][$n]();
  zn.return = function() {
    Gn = true;
  }, Array.from(zn, function() {
    throw 2;
  });
} catch (e25) {
}
var Hn = function(e25, t2) {
  if (!t2 && !Gn)
    return false;
  var r2 = false;
  try {
    var n2 = [7], i2 = n2[$n]();
    i2.next = function() {
      return { done: r2 = true };
    }, n2[$n] = function() {
      return i2;
    }, e25(n2);
  } catch (e26) {
  }
  return r2;
};
X(X.S + X.F * !Hn(function(e25) {
  Array.from(e25);
}), "Array", { from: function(e25) {
  var t2, r2, n2, i2, a2 = Te(e25), o2 = typeof this == "function" ? this : Array, s2 = arguments.length, u2 = s2 > 1 ? arguments[1] : void 0, c2 = u2 !== void 0, l2 = 0, p2 = Wn(a2);
  if (c2 && (u2 = J(u2, s2 > 2 ? arguments[2] : void 0, 2)), p2 == null || o2 == Array && Vn(p2))
    for (r2 = new o2(t2 = me(a2.length)); t2 > l2; l2++)
      Un(r2, l2, c2 ? u2(a2[l2], l2) : a2[l2]);
  else
    for (i2 = p2.call(a2), r2 = new o2(); !(n2 = i2.next()).done; l2++)
      Un(r2, l2, c2 ? jn(i2, u2, [n2.value, l2], true) : n2.value);
  return r2.length = l2, r2;
} }), X(X.S + X.F * w(function() {
  function e25() {
  }
  return !(Array.of.call(e25) instanceof e25);
}), "Array", { of: function() {
  for (var e25 = 0, t2 = arguments.length, r2 = new (typeof this == "function" ? this : Array)(t2); t2 > e25; )
    Un(r2, e25, arguments[e25++]);
  return r2.length = t2, r2;
} });
var Kn = function(e25, t2) {
  return !!e25 && w(function() {
    t2 ? e25.call(null, function() {
    }, 1) : e25.call(null);
  });
}, Jn = [].join;
X(X.P + X.F * (ue != Object || !Kn(Jn)), "Array", { join: function(e25) {
  return Jn.call(le(this), e25 === void 0 ? "," : e25);
} });
var Qn = [].slice;
X(X.P + X.F * w(function() {
  Be && Qn.call(Be);
}), "Array", { slice: function(e25, t2) {
  var r2 = me(this.length), n2 = se(this);
  if (t2 = t2 === void 0 ? r2 : t2, n2 == "Array")
    return Qn.call(this, e25, t2);
  for (var i2 = ve(e25, r2), a2 = ve(t2, r2), o2 = me(a2 - i2), s2 = new Array(o2), u2 = 0; u2 < o2; u2++)
    s2[u2] = n2 == "String" ? this.charAt(i2 + u2) : this[i2 + u2];
  return s2;
} });
var Xn = [].sort, Yn = [1, 2, 3];
X(X.P + X.F * (w(function() {
  Yn.sort(void 0);
}) || !w(function() {
  Yn.sort(null);
}) || !Kn(Xn)), "Array", { sort: function(e25) {
  return e25 === void 0 ? Xn.call(Te(this)) : Xn.call(Te(this), K(e25));
} });
var Zn = Z("species"), ei = function(e25, t2) {
  return new (function(e26) {
    var t3;
    return _e(e26) && (typeof (t3 = e26.constructor) != "function" || t3 !== Array && !_e(t3.prototype) || (t3 = void 0), P(t3) && (t3 = t3[Zn]) === null && (t3 = void 0)), t3 === void 0 ? Array : t3;
  }(e25))(t2);
}, ti = function(e25, t2) {
  var r2 = e25 == 1, n2 = e25 == 2, i2 = e25 == 3, a2 = e25 == 4, o2 = e25 == 6, s2 = e25 == 5 || o2, u2 = t2 || ei;
  return function(t3, c2, l2) {
    for (var p2, f2, h2 = Te(t3), d2 = ue(h2), m2 = J(c2, l2, 3), g2 = me(d2.length), y2 = 0, v2 = r2 ? u2(t3, g2) : n2 ? u2(t3, 0) : void 0; g2 > y2; y2++)
      if ((s2 || y2 in d2) && (f2 = m2(p2 = d2[y2], y2, h2), e25)) {
        if (r2)
          v2[y2] = f2;
        else if (f2)
          switch (e25) {
            case 3:
              return true;
            case 5:
              return p2;
            case 6:
              return y2;
            case 2:
              v2.push(p2);
          }
        else if (a2)
          return false;
      }
    return o2 ? -1 : i2 || a2 ? a2 : v2;
  };
}, ri = ti(0), ni = Kn([].forEach, true);
X(X.P + X.F * !ni, "Array", { forEach: function(e25) {
  return ri(this, e25, arguments[1]);
} });
var ii = ti(1);
X(X.P + X.F * !Kn([].map, true), "Array", { map: function(e25) {
  return ii(this, e25, arguments[1]);
} });
var ai = ti(2);
X(X.P + X.F * !Kn([].filter, true), "Array", { filter: function(e25) {
  return ai(this, e25, arguments[1]);
} });
var oi = ti(3);
X(X.P + X.F * !Kn([].some, true), "Array", { some: function(e25) {
  return oi(this, e25, arguments[1]);
} });
var si = ti(4);
X(X.P + X.F * !Kn([].every, true), "Array", { every: function(e25) {
  return si(this, e25, arguments[1]);
} });
var ui = function(e25, t2, r2, n2, i2) {
  K(t2);
  var a2 = Te(e25), o2 = ue(a2), s2 = me(a2.length), u2 = i2 ? s2 - 1 : 0, c2 = i2 ? -1 : 1;
  if (r2 < 2)
    for (; ; ) {
      if (u2 in o2) {
        n2 = o2[u2], u2 += c2;
        break;
      }
      if (u2 += c2, i2 ? u2 < 0 : s2 <= u2)
        throw TypeError("Reduce of empty array with no initial value");
    }
  for (; i2 ? u2 >= 0 : s2 > u2; u2 += c2)
    u2 in o2 && (n2 = t2(n2, o2[u2], u2, a2));
  return n2;
};
X(X.P + X.F * !Kn([].reduce, true), "Array", { reduce: function(e25) {
  return ui(this, e25, arguments.length, arguments[1], false);
} }), X(X.P + X.F * !Kn([].reduceRight, true), "Array", { reduceRight: function(e25) {
  return ui(this, e25, arguments.length, arguments[1], true);
} });
var ci = xe(false), li = [].indexOf, pi = !!li && 1 / [1].indexOf(1, -0) < 0;
X(X.P + X.F * (pi || !Kn(li)), "Array", { indexOf: function(e25) {
  return pi ? li.apply(this, arguments) || 0 : ci(this, e25, arguments[1]);
} });
var fi$2 = [].lastIndexOf, hi = !!fi$2 && 1 / [1].lastIndexOf(1, -0) < 0;
X(X.P + X.F * (hi || !Kn(fi$2)), "Array", { lastIndexOf: function(e25) {
  if (hi)
    return fi$2.apply(this, arguments) || 0;
  var t2 = le(this), r2 = me(t2.length), n2 = r2 - 1;
  for (arguments.length > 1 && (n2 = Math.min(n2, he(arguments[1]))), n2 < 0 && (n2 = r2 + n2); n2 >= 0; n2--)
    if (n2 in t2 && t2[n2] === e25)
      return n2 || 0;
  return -1;
} });
var di = [].copyWithin || function(e25, t2) {
  var r2 = Te(this), n2 = me(r2.length), i2 = ve(e25, n2), a2 = ve(t2, n2), o2 = arguments.length > 2 ? arguments[2] : void 0, s2 = Math.min((o2 === void 0 ? n2 : ve(o2, n2)) - a2, n2 - i2), u2 = 1;
  for (a2 < i2 && i2 < a2 + s2 && (u2 = -1, a2 += s2 - 1, i2 += s2 - 1); s2-- > 0; )
    a2 in r2 ? r2[i2] = r2[a2] : delete r2[i2], i2 += u2, a2 += u2;
  return r2;
}, mi = Z("unscopables"), gi = Array.prototype;
gi[mi] == null && U(gi, mi, {});
var yi = function(e25) {
  gi[mi][e25] = true;
};
X(X.P, "Array", { copyWithin: di }), yi("copyWithin");
var vi = function(e25) {
  for (var t2 = Te(this), r2 = me(t2.length), n2 = arguments.length, i2 = ve(n2 > 1 ? arguments[1] : void 0, r2), a2 = n2 > 2 ? arguments[2] : void 0, o2 = a2 === void 0 ? r2 : ve(a2, r2); o2 > i2; )
    t2[i2++] = e25;
  return t2;
};
X(X.P, "Array", { fill: vi }), yi("fill");
var xi = ti(5), bi = true;
"find" in [] && Array(1).find(function() {
  bi = false;
}), X(X.P + X.F * bi, "Array", { find: function(e25) {
  return xi(this, e25, arguments.length > 1 ? arguments[1] : void 0);
} }), yi("find");
var Ei = ti(6), Ci = true;
"findIndex" in [] && Array(1).findIndex(function() {
  Ci = false;
}), X(X.P + X.F * Ci, "Array", { findIndex: function(e25) {
  return Ei(this, e25, arguments.length > 1 ? arguments[1] : void 0);
} }), yi("findIndex");
var Si = Z("species"), ki = function(e25) {
  var t2 = D[e25];
  _ && t2 && !t2[Si] && M.f(t2, Si, { configurable: true, get: function() {
    return this;
  } });
};
ki("Array");
var Di = function(e25, t2) {
  return { value: t2, done: !!e25 };
}, Fi = mn(Array, "Array", function(e25, t2) {
  this._t = le(e25), this._i = 0, this._k = t2;
}, function() {
  var e25 = this._t, t2 = this._k, r2 = this._i++;
  return !e25 || r2 >= e25.length ? (this._t = void 0, Di(1)) : Di(0, t2 == "keys" ? r2 : t2 == "values" ? e25[r2] : [r2, e25[r2]]);
}, "values");
cn.Arguments = cn.Array, yi("keys"), yi("values"), yi("entries");
var Ai = function() {
  var e25 = I(this), t2 = "";
  return e25.global && (t2 += "g"), e25.ignoreCase && (t2 += "i"), e25.multiline && (t2 += "m"), e25.unicode && (t2 += "u"), e25.sticky && (t2 += "y"), t2;
}, wi = M.f, _i = Me.f, Ti = D.RegExp, Pi = Ti, Ii = Ti.prototype, Bi = /a/g, Oi = /a/g, Li = new Ti(Bi) !== Bi;
if (_ && (!Li || w(function() {
  return Oi[Z("match")] = false, Ti(Bi) != Bi || Ti(Oi) == Oi || Ti(Bi, "i") != "/a/i";
}))) {
  Ti = function(e25, t2) {
    var r2 = this instanceof Ti, n2 = xn(e25), i2 = t2 === void 0;
    return !r2 && n2 && e25.constructor === Ti && i2 ? e25 : pr(Li ? new Pi(n2 && !i2 ? e25.source : e25, t2) : Pi((n2 = e25 instanceof Ti) ? e25.source : e25, n2 && i2 ? Ai.call(e25) : t2), r2 ? this : Ii, Ti);
  };
  for (var Ni = function(e25) {
    e25 in Ti || wi(Ti, e25, { configurable: true, get: function() {
      return Pi[e25];
    }, set: function(t2) {
      Pi[e25] = t2;
    } });
  }, ji = _i(Pi), Ri = 0; ji.length > Ri; )
    Ni(ji[Ri++]);
  Ii.constructor = Ti, Ti.prototype = Ii, H(D, "RegExp", Ti);
}
ki("RegExp");
var Mi = RegExp.prototype.exec, Vi = String.prototype.replace, Ui = Mi, qi = function() {
  var e25 = /a/, t2 = /b*/g;
  return Mi.call(e25, "a"), Mi.call(t2, "a"), e25.lastIndex !== 0 || t2.lastIndex !== 0;
}(), Wi = /()??/.exec("")[1] !== void 0;
(qi || Wi) && (Ui = function(e25) {
  var t2, r2, n2, i2, a2 = this;
  return Wi && (r2 = new RegExp("^" + a2.source + "$(?!\\s)", Ai.call(a2))), qi && (t2 = a2.lastIndex), n2 = Mi.call(a2, e25), qi && n2 && (a2.lastIndex = a2.global ? n2.index + n2[0].length : t2), Wi && n2 && n2.length > 1 && Vi.call(n2[0], r2, function() {
    for (i2 = 1; i2 < arguments.length - 2; i2++)
      arguments[i2] === void 0 && (n2[i2] = void 0);
  }), n2;
});
var $i = Ui;
X({ target: "RegExp", proto: true, forced: $i !== /./.exec }, { exec: $i }), _ && /./g.flags != "g" && M.f(RegExp.prototype, "flags", { configurable: true, get: Ai });
var Gi = /./.toString, zi = function(e25) {
  H(RegExp.prototype, "toString", e25, true);
};
w(function() {
  return Gi.call({ source: "a", flags: "b" }) != "/a/b";
}) ? zi(function() {
  var e25 = I(this);
  return "/".concat(e25.source, "/", "flags" in e25 ? e25.flags : !_ && e25 instanceof RegExp ? Ai.call(e25) : void 0);
}) : Gi.name != "toString" && zi(function() {
  return Gi.call(this);
});
var Hi = un(true), Ki = function(e25, t2, r2) {
  return t2 + (r2 ? Hi(e25, t2).length : 1);
}, Ji = RegExp.prototype.exec, Qi = function(e25, t2) {
  var r2 = e25.exec;
  if (typeof r2 == "function") {
    var n2 = r2.call(e25, t2);
    if (i(n2) !== "object")
      throw new TypeError("RegExp exec method returned something other than an Object or null");
    return n2;
  }
  if (Rt(e25) !== "RegExp")
    throw new TypeError("RegExp#exec called on incompatible receiver");
  return Ji.call(e25, t2);
}, Xi = Z("species"), Yi = !w(function() {
  var e25 = /./;
  return e25.exec = function() {
    var e26 = [];
    return e26.groups = { a: "7" }, e26;
  }, "".replace(e25, "$<a>") !== "7";
}), Zi = function() {
  var e25 = /(?:)/, t2 = e25.exec;
  e25.exec = function() {
    return t2.apply(this, arguments);
  };
  var r2 = "ab".split(e25);
  return r2.length === 2 && r2[0] === "a" && r2[1] === "b";
}(), ea = function(e25, t2, r2) {
  var n2 = Z(e25), i2 = !w(function() {
    var t3 = {};
    return t3[n2] = function() {
      return 7;
    }, ""[e25](t3) != 7;
  }), a2 = i2 ? !w(function() {
    var t3 = false, r3 = /a/;
    return r3.exec = function() {
      return t3 = true, null;
    }, e25 === "split" && (r3.constructor = {}, r3.constructor[Xi] = function() {
      return r3;
    }), r3[n2](""), !t3;
  }) : void 0;
  if (!i2 || !a2 || e25 === "replace" && !Yi || e25 === "split" && !Zi) {
    var o2 = /./[n2], s2 = r2(ce, n2, ""[e25], function(e26, t3, r3, n3, a3) {
      return t3.exec === $i ? i2 && !a3 ? { done: true, value: o2.call(t3, r3, n3) } : { done: true, value: e26.call(r3, t3, n3) } : { done: false };
    }), u2 = s2[0], c2 = s2[1];
    H(String.prototype, e25, u2), U(RegExp.prototype, n2, t2 == 2 ? function(e26, t3) {
      return c2.call(e26, this, t3);
    } : function(e26) {
      return c2.call(e26, this);
    });
  }
};
ea("match", 1, function(e25, t2, r2, n2) {
  return [function(r3) {
    var n3 = e25(this), i2 = r3 == null ? void 0 : r3[t2];
    return i2 !== void 0 ? i2.call(r3, n3) : new RegExp(r3)[t2](String(n3));
  }, function(e26) {
    var t3 = n2(r2, e26, this);
    if (t3.done)
      return t3.value;
    var i2 = I(e26), a2 = String(this);
    if (!i2.global)
      return Qi(i2, a2);
    var o2 = i2.unicode;
    i2.lastIndex = 0;
    for (var s2, u2 = [], c2 = 0; (s2 = Qi(i2, a2)) !== null; ) {
      var l2 = String(s2[0]);
      u2[c2] = l2, l2 === "" && (i2.lastIndex = Ki(a2, me(i2.lastIndex), o2)), c2++;
    }
    return c2 === 0 ? null : u2;
  }];
});
var ta = Math.max, ra = Math.min, na = Math.floor, ia = /\$([$&`']|\d\d?|<[^>]*>)/g, aa = /\$([$&`']|\d\d?)/g;
ea("replace", 2, function(e25, t2, r2, n2) {
  return [function(n3, i3) {
    var a2 = e25(this), o2 = n3 == null ? void 0 : n3[t2];
    return o2 !== void 0 ? o2.call(n3, a2, i3) : r2.call(String(a2), n3, i3);
  }, function(e26, t3) {
    var a2 = n2(r2, e26, this, t3);
    if (a2.done)
      return a2.value;
    var o2 = I(e26), s2 = String(this), u2 = typeof t3 == "function";
    u2 || (t3 = String(t3));
    var c2 = o2.global;
    if (c2) {
      var l2 = o2.unicode;
      o2.lastIndex = 0;
    }
    for (var p2 = []; ; ) {
      var f2 = Qi(o2, s2);
      if (f2 === null)
        break;
      if (p2.push(f2), !c2)
        break;
      String(f2[0]) === "" && (o2.lastIndex = Ki(s2, me(o2.lastIndex), l2));
    }
    for (var h2, d2 = "", m2 = 0, g2 = 0; g2 < p2.length; g2++) {
      f2 = p2[g2];
      for (var y2 = String(f2[0]), v2 = ta(ra(he(f2.index), s2.length), 0), x2 = [], b2 = 1; b2 < f2.length; b2++)
        x2.push((h2 = f2[b2]) === void 0 ? h2 : String(h2));
      var E2 = f2.groups;
      if (u2) {
        var C2 = [y2].concat(x2, v2, s2);
        E2 !== void 0 && C2.push(E2);
        var S2 = String(t3.apply(void 0, C2));
      } else
        S2 = i2(y2, s2, v2, x2, E2, t3);
      v2 >= m2 && (d2 += s2.slice(m2, v2) + S2, m2 = v2 + y2.length);
    }
    return d2 + s2.slice(m2);
  }];
  function i2(e26, t3, n3, i3, a2, o2) {
    var s2 = n3 + e26.length, u2 = i3.length, c2 = aa;
    return a2 !== void 0 && (a2 = Te(a2), c2 = ia), r2.call(o2, c2, function(r3, o3) {
      var c3;
      switch (o3.charAt(0)) {
        case "$":
          return "$";
        case "&":
          return e26;
        case "`":
          return t3.slice(0, n3);
        case "'":
          return t3.slice(s2);
        case "<":
          c3 = a2[o3.slice(1, -1)];
          break;
        default:
          var l2 = +o3;
          if (l2 === 0)
            return r3;
          if (l2 > u2) {
            var p2 = na(l2 / 10);
            return p2 === 0 ? r3 : p2 <= u2 ? i3[p2 - 1] === void 0 ? o3.charAt(1) : i3[p2 - 1] + o3.charAt(1) : r3;
          }
          c3 = i3[l2 - 1];
      }
      return c3 === void 0 ? "" : c3;
    });
  }
}), ea("search", 1, function(e25, t2, r2, n2) {
  return [function(r3) {
    var n3 = e25(this), i2 = r3 == null ? void 0 : r3[t2];
    return i2 !== void 0 ? i2.call(r3, n3) : new RegExp(r3)[t2](String(n3));
  }, function(e26) {
    var t3 = n2(r2, e26, this);
    if (t3.done)
      return t3.value;
    var i2 = I(e26), a2 = String(this), o2 = i2.lastIndex;
    Bt(o2, 0) || (i2.lastIndex = 0);
    var s2 = Qi(i2, a2);
    return Bt(i2.lastIndex, o2) || (i2.lastIndex = o2), s2 === null ? -1 : s2.index;
  }];
});
var oa = Z("species"), sa = function(e25, t2) {
  var r2, n2 = I(e25).constructor;
  return n2 === void 0 || (r2 = I(n2)[oa]) == null ? t2 : K(r2);
}, ua = Math.min, ca = [].push, la = !w(function() {
  RegExp(4294967295, "y");
});
ea("split", 2, function(e25, t2, r2, n2) {
  var i2;
  return i2 = "abbc".split(/(b)*/)[1] == "c" || "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function(e26, t3) {
    var n3 = String(this);
    if (e26 === void 0 && t3 === 0)
      return [];
    if (!xn(e26))
      return r2.call(n3, e26, t3);
    for (var i3, a2, o2, s2 = [], u2 = (e26.ignoreCase ? "i" : "") + (e26.multiline ? "m" : "") + (e26.unicode ? "u" : "") + (e26.sticky ? "y" : ""), c2 = 0, l2 = t3 === void 0 ? 4294967295 : t3 >>> 0, p2 = new RegExp(e26.source, u2 + "g"); (i3 = $i.call(p2, n3)) && !((a2 = p2.lastIndex) > c2 && (s2.push(n3.slice(c2, i3.index)), i3.length > 1 && i3.index < n3.length && ca.apply(s2, i3.slice(1)), o2 = i3[0].length, c2 = a2, s2.length >= l2)); )
      p2.lastIndex === i3.index && p2.lastIndex++;
    return c2 === n3.length ? !o2 && p2.test("") || s2.push("") : s2.push(n3.slice(c2)), s2.length > l2 ? s2.slice(0, l2) : s2;
  } : "0".split(void 0, 0).length ? function(e26, t3) {
    return e26 === void 0 && t3 === 0 ? [] : r2.call(this, e26, t3);
  } : r2, [function(r3, n3) {
    var a2 = e25(this), o2 = r3 == null ? void 0 : r3[t2];
    return o2 !== void 0 ? o2.call(r3, a2, n3) : i2.call(String(a2), r3, n3);
  }, function(e26, t3) {
    var a2 = n2(i2, e26, this, t3, i2 !== r2);
    if (a2.done)
      return a2.value;
    var o2 = I(e26), s2 = String(this), u2 = sa(o2, RegExp), c2 = o2.unicode, l2 = (o2.ignoreCase ? "i" : "") + (o2.multiline ? "m" : "") + (o2.unicode ? "u" : "") + (la ? "y" : "g"), p2 = new u2(la ? o2 : "^(?:" + o2.source + ")", l2), f2 = t3 === void 0 ? 4294967295 : t3 >>> 0;
    if (f2 === 0)
      return [];
    if (s2.length === 0)
      return Qi(p2, s2) === null ? [s2] : [];
    for (var h2 = 0, d2 = 0, m2 = []; d2 < s2.length; ) {
      p2.lastIndex = la ? d2 : 0;
      var g2, y2 = Qi(p2, la ? s2 : s2.slice(d2));
      if (y2 === null || (g2 = ua(me(p2.lastIndex + (la ? 0 : d2)), s2.length)) === h2)
        d2 = Ki(s2, d2, c2);
      else {
        if (m2.push(s2.slice(h2, d2)), m2.length === f2)
          return m2;
        for (var v2 = 1; v2 <= y2.length - 1; v2++)
          if (m2.push(y2[v2]), m2.length === f2)
            return m2;
        d2 = h2 = g2;
      }
    }
    return m2.push(s2.slice(h2)), m2;
  }];
});
var pa, fa, ha, da$2 = function(e25, t2, r2, n2) {
  if (!(e25 instanceof t2) || n2 !== void 0 && n2 in e25)
    throw TypeError(r2 + ": incorrect invocation!");
  return e25;
}, ma = r(function(e25) {
  var t2 = {}, r2 = {}, n2 = e25.exports = function(e26, n3, i2, a2, o2) {
    var s2, u2, c2, l2, p2 = o2 ? function() {
      return e26;
    } : Wn(e26), f2 = J(i2, a2, n3 ? 2 : 1), h2 = 0;
    if (typeof p2 != "function")
      throw TypeError(e26 + " is not iterable!");
    if (Vn(p2)) {
      for (s2 = me(e26.length); s2 > h2; h2++)
        if ((l2 = n3 ? f2(I(u2 = e26[h2])[0], u2[1]) : f2(e26[h2])) === t2 || l2 === r2)
          return l2;
    } else
      for (c2 = p2.call(e26); !(u2 = c2.next()).done; )
        if ((l2 = jn(c2, f2, u2.value, n3)) === t2 || l2 === r2)
          return l2;
  };
  n2.BREAK = t2, n2.RETURN = r2;
}), ga = D.process, ya = D.setImmediate, va = D.clearImmediate, xa = D.MessageChannel, ba = D.Dispatch, Ea = 0, Ca = {}, Sa = function() {
  var e25 = +this;
  if (Ca.hasOwnProperty(e25)) {
    var t2 = Ca[e25];
    delete Ca[e25], t2();
  }
}, ka = function(e25) {
  Sa.call(e25.data);
};
ya && va || (ya = function(e25) {
  for (var t2 = [], r2 = 1; arguments.length > r2; )
    t2.push(arguments[r2++]);
  return Ca[++Ea] = function() {
    Vt(typeof e25 == "function" ? e25 : Function(e25), t2);
  }, pa(Ea), Ea;
}, va = function(e25) {
  delete Ca[e25];
}, se(ga) == "process" ? pa = function(e25) {
  ga.nextTick(J(Sa, e25, 1));
} : ba && ba.now ? pa = function(e25) {
  ba.now(J(Sa, e25, 1));
} : xa ? (ha = (fa = new xa()).port2, fa.port1.onmessage = ka, pa = J(ha.postMessage, ha, 1)) : D.addEventListener && typeof postMessage == "function" && !D.importScripts ? (pa = function(e25) {
  D.postMessage(e25 + "", "*");
}, D.addEventListener("message", ka, false)) : pa = "onreadystatechange" in L("script") ? function(e25) {
  Be.appendChild(L("script")).onreadystatechange = function() {
    Be.removeChild(this), Sa.call(e25);
  };
} : function(e25) {
  setTimeout(J(Sa, e25, 1), 0);
});
var Da = { set: ya, clear: va }, Fa = Da.set, Aa = D.MutationObserver || D.WebKitMutationObserver, wa = D.process, _a = D.Promise, Ta = se(wa) == "process";
function Pa(e25) {
  var t2, r2;
  this.promise = new e25(function(e26, n2) {
    if (t2 !== void 0 || r2 !== void 0)
      throw TypeError("Bad Promise constructor");
    t2 = e26, r2 = n2;
  }), this.resolve = K(t2), this.reject = K(r2);
}
var Ia, Ba, Oa, La, Na = { f: function(e25) {
  return new Pa(e25);
} }, ja = function(e25) {
  try {
    return { e: false, v: e25() };
  } catch (e26) {
    return { e: true, v: e26 };
  }
}, Ra = D.navigator, Ma = Ra && Ra.userAgent || "", Va = function(e25, t2) {
  if (I(e25), P(t2) && t2.constructor === e25)
    return t2;
  var r2 = Na.f(e25);
  return (0, r2.resolve)(t2), r2.promise;
}, Ua = function(e25, t2, r2) {
  for (var n2 in t2)
    H(e25, n2, t2[n2], r2);
  return e25;
}, qa = Da.set, Wa = function() {
  var e25, t2, r2, n2 = function() {
    var n3, i3;
    for (Ta && (n3 = wa.domain) && n3.exit(); e25; ) {
      i3 = e25.fn, e25 = e25.next;
      try {
        i3();
      } catch (n4) {
        throw e25 ? r2() : t2 = void 0, n4;
      }
    }
    t2 = void 0, n3 && n3.enter();
  };
  if (Ta)
    r2 = function() {
      wa.nextTick(n2);
    };
  else if (!Aa || D.navigator && D.navigator.standalone)
    if (_a && _a.resolve) {
      var i2 = _a.resolve(void 0);
      r2 = function() {
        i2.then(n2);
      };
    } else
      r2 = function() {
        Fa.call(D, n2);
      };
  else {
    var a2 = true, o2 = document.createTextNode("");
    new Aa(n2).observe(o2, { characterData: true }), r2 = function() {
      o2.data = a2 = !a2;
    };
  }
  return function(n3) {
    var i3 = { fn: n3, next: void 0 };
    t2 && (t2.next = i3), e25 || (e25 = i3, r2()), t2 = i3;
  };
}(), $a = D.TypeError, Ga = D.process, za = Ga && Ga.versions, Ha = za && za.v8 || "", Ka = D.Promise, Ja = Rt(Ga) == "process", Qa = function() {
}, Xa = Ba = Na.f, Ya = !!function() {
  try {
    var e25 = Ka.resolve(1), t2 = (e25.constructor = {})[Z("species")] = function(e26) {
      e26(Qa, Qa);
    };
    return (Ja || typeof PromiseRejectionEvent == "function") && e25.then(Qa) instanceof t2 && Ha.indexOf("6.6") !== 0 && Ma.indexOf("Chrome/66") === -1;
  } catch (e26) {
  }
}(), Za = function(e25) {
  var t2;
  return !(!P(e25) || typeof (t2 = e25.then) != "function") && t2;
}, eo = function(e25, t2) {
  if (!e25._n) {
    e25._n = true;
    var r2 = e25._c;
    Wa(function() {
      for (var n2 = e25._v, i2 = e25._s == 1, a2 = 0, o2 = function(t3) {
        var r3, a3, o3, s2 = i2 ? t3.ok : t3.fail, u2 = t3.resolve, c2 = t3.reject, l2 = t3.domain;
        try {
          s2 ? (i2 || (e25._h == 2 && no$1(e25), e25._h = 1), s2 === true ? r3 = n2 : (l2 && l2.enter(), r3 = s2(n2), l2 && (l2.exit(), o3 = true)), r3 === t3.promise ? c2($a("Promise-chain cycle")) : (a3 = Za(r3)) ? a3.call(r3, u2, c2) : u2(r3)) : c2(n2);
        } catch (e26) {
          l2 && !o3 && l2.exit(), c2(e26);
        }
      }; r2.length > a2; )
        o2(r2[a2++]);
      e25._c = [], e25._n = false, t2 && !e25._h && to(e25);
    });
  }
}, to = function(e25) {
  qa.call(D, function() {
    var t2, r2, n2, i2 = e25._v, a2 = ro(e25);
    if (a2 && (t2 = ja(function() {
      Ja ? Ga.emit("unhandledRejection", i2, e25) : (r2 = D.onunhandledrejection) ? r2({ promise: e25, reason: i2 }) : (n2 = D.console) && n2.error && n2.error("Unhandled promise rejection", i2);
    }), e25._h = Ja || ro(e25) ? 2 : 1), e25._a = void 0, a2 && t2.e)
      throw t2.v;
  });
}, ro = function(e25) {
  return e25._h !== 1 && (e25._a || e25._c).length === 0;
}, no$1 = function(e25) {
  qa.call(D, function() {
    var t2;
    Ja ? Ga.emit("rejectionHandled", e25) : (t2 = D.onrejectionhandled) && t2({ promise: e25, reason: e25._v });
  });
}, io = function(e25) {
  var t2 = this;
  t2._d || (t2._d = true, (t2 = t2._w || t2)._v = e25, t2._s = 2, t2._a || (t2._a = t2._c.slice()), eo(t2, true));
}, ao = function e5(t2) {
  var r2, n2 = this;
  if (!n2._d) {
    n2._d = true, n2 = n2._w || n2;
    try {
      if (n2 === t2)
        throw $a("Promise can't be resolved itself");
      (r2 = Za(t2)) ? Wa(function() {
        var i2 = { _w: n2, _d: false };
        try {
          r2.call(t2, J(e5, i2, 1), J(io, i2, 1));
        } catch (e25) {
          io.call(i2, e25);
        }
      }) : (n2._v = t2, n2._s = 1, eo(n2, false));
    } catch (e25) {
      io.call({ _w: n2, _d: false }, e25);
    }
  }
};
Ya || (Ka = function(e25) {
  da$2(this, Ka, "Promise", "_h"), K(e25), Ia.call(this);
  try {
    e25(J(ao, this, 1), J(io, this, 1));
  } catch (e26) {
    io.call(this, e26);
  }
}, (Ia = function(e25) {
  this._c = [], this._a = void 0, this._s = 0, this._d = false, this._v = void 0, this._h = 0, this._n = false;
}).prototype = Ua(Ka.prototype, { then: function(e25, t2) {
  var r2 = Xa(sa(this, Ka));
  return r2.ok = typeof e25 != "function" || e25, r2.fail = typeof t2 == "function" && t2, r2.domain = Ja ? Ga.domain : void 0, this._c.push(r2), this._a && this._a.push(r2), this._s && eo(this, false), r2.promise;
}, catch: function(e25) {
  return this.then(void 0, e25);
} }), Oa = function() {
  var e25 = new Ia();
  this.promise = e25, this.resolve = J(ao, e25, 1), this.reject = J(io, e25, 1);
}, Na.f = Xa = function(e25) {
  return e25 === Ka || e25 === La ? new Oa(e25) : Ba(e25);
}), X(X.G + X.W + X.F * !Ya, { Promise: Ka }), re(Ka, "Promise"), ki("Promise"), La = T.Promise, X(X.S + X.F * !Ya, "Promise", { reject: function(e25) {
  var t2 = Xa(this);
  return (0, t2.reject)(e25), t2.promise;
} }), X(X.S + X.F * !Ya, "Promise", { resolve: function(e25) {
  return Va(this, e25);
} }), X(X.S + X.F * !(Ya && Hn(function(e25) {
  Ka.all(e25).catch(Qa);
})), "Promise", { all: function(e25) {
  var t2 = this, r2 = Xa(t2), n2 = r2.resolve, i2 = r2.reject, a2 = ja(function() {
    var r3 = [], a3 = 0, o2 = 1;
    ma(e25, false, function(e26) {
      var s2 = a3++, u2 = false;
      r3.push(void 0), o2++, t2.resolve(e26).then(function(e27) {
        u2 || (u2 = true, r3[s2] = e27, --o2 || n2(r3));
      }, i2);
    }), --o2 || n2(r3);
  });
  return a2.e && i2(a2.v), r2.promise;
}, race: function(e25) {
  var t2 = this, r2 = Xa(t2), n2 = r2.reject, i2 = ja(function() {
    ma(e25, false, function(e26) {
      t2.resolve(e26).then(r2.resolve, n2);
    });
  });
  return i2.e && n2(i2.v), r2.promise;
} });
var oo = function(e25, t2) {
  if (!P(e25) || e25._t !== t2)
    throw TypeError("Incompatible receiver, " + t2 + " required!");
  return e25;
}, so = M.f, uo = Y.fastKey, co = _ ? "_s" : "size", lo = function(e25, t2) {
  var r2, n2 = uo(t2);
  if (n2 !== "F")
    return e25._i[n2];
  for (r2 = e25._f; r2; r2 = r2.n)
    if (r2.k == t2)
      return r2;
}, po = { getConstructor: function(e25, t2, r2, n2) {
  var i2 = e25(function(e26, a2) {
    da$2(e26, i2, t2, "_i"), e26._t = t2, e26._i = je(null), e26._f = void 0, e26._l = void 0, e26[co] = 0, a2 != null && ma(a2, r2, e26[n2], e26);
  });
  return Ua(i2.prototype, { clear: function() {
    for (var e26 = oo(this, t2), r3 = e26._i, n3 = e26._f; n3; n3 = n3.n)
      n3.r = true, n3.p && (n3.p = n3.p.n = void 0), delete r3[n3.i];
    e26._f = e26._l = void 0, e26[co] = 0;
  }, delete: function(e26) {
    var r3 = oo(this, t2), n3 = lo(r3, e26);
    if (n3) {
      var i3 = n3.n, a2 = n3.p;
      delete r3._i[n3.i], n3.r = true, a2 && (a2.n = i3), i3 && (i3.p = a2), r3._f == n3 && (r3._f = i3), r3._l == n3 && (r3._l = a2), r3[co]--;
    }
    return !!n3;
  }, forEach: function(e26) {
    oo(this, t2);
    for (var r3, n3 = J(e26, arguments.length > 1 ? arguments[1] : void 0, 3); r3 = r3 ? r3.n : this._f; )
      for (n3(r3.v, r3.k, this); r3 && r3.r; )
        r3 = r3.p;
  }, has: function(e26) {
    return !!lo(oo(this, t2), e26);
  } }), _ && so(i2.prototype, "size", { get: function() {
    return oo(this, t2)[co];
  } }), i2;
}, def: function(e25, t2, r2) {
  var n2, i2, a2 = lo(e25, t2);
  return a2 ? a2.v = r2 : (e25._l = a2 = { i: i2 = uo(t2, true), k: t2, v: r2, p: n2 = e25._l, n: void 0, r: false }, e25._f || (e25._f = a2), n2 && (n2.n = a2), e25[co]++, i2 !== "F" && (e25._i[i2] = a2)), e25;
}, getEntry: lo, setStrong: function(e25, t2, r2) {
  mn(e25, t2, function(e26, r3) {
    this._t = oo(e26, t2), this._k = r3, this._l = void 0;
  }, function() {
    for (var e26 = this._k, t3 = this._l; t3 && t3.r; )
      t3 = t3.p;
    return this._t && (this._l = t3 = t3 ? t3.n : this._t._f) ? Di(0, e26 == "keys" ? t3.k : e26 == "values" ? t3.v : [t3.k, t3.v]) : (this._t = void 0, Di(1));
  }, r2 ? "entries" : "values", !r2, true), ki(t2);
} }, fo = function(e25, t2, r2, n2, i2, a2) {
  var o2 = D[e25], s2 = o2, u2 = i2 ? "set" : "add", c2 = s2 && s2.prototype, l2 = {}, p2 = function(e26) {
    var t3 = c2[e26];
    H(c2, e26, e26 == "delete" ? function(e27) {
      return !(a2 && !P(e27)) && t3.call(this, e27 === 0 ? 0 : e27);
    } : e26 == "has" ? function(e27) {
      return !(a2 && !P(e27)) && t3.call(this, e27 === 0 ? 0 : e27);
    } : e26 == "get" ? function(e27) {
      return a2 && !P(e27) ? void 0 : t3.call(this, e27 === 0 ? 0 : e27);
    } : e26 == "add" ? function(e27) {
      return t3.call(this, e27 === 0 ? 0 : e27), this;
    } : function(e27, r3) {
      return t3.call(this, e27 === 0 ? 0 : e27, r3), this;
    });
  };
  if (typeof s2 == "function" && (a2 || c2.forEach && !w(function() {
    new s2().entries().next();
  }))) {
    var f2 = new s2(), h2 = f2[u2](a2 ? {} : -0, 1) != f2, d2 = w(function() {
      f2.has(1);
    }), m2 = Hn(function(e26) {
      new s2(e26);
    }), g2 = !a2 && w(function() {
      for (var e26 = new s2(), t3 = 5; t3--; )
        e26[u2](t3, t3);
      return !e26.has(-0);
    });
    m2 || ((s2 = t2(function(t3, r3) {
      da$2(t3, s2, e25);
      var n3 = pr(new o2(), t3, s2);
      return r3 != null && ma(r3, i2, n3[u2], n3), n3;
    })).prototype = c2, c2.constructor = s2), (d2 || g2) && (p2("delete"), p2("has"), i2 && p2("get")), (g2 || h2) && p2(u2), a2 && c2.clear && delete c2.clear;
  } else
    s2 = n2.getConstructor(t2, e25, i2, u2), Ua(s2.prototype, r2), Y.NEED = true;
  return re(s2, e25), l2[e25] = s2, X(X.G + X.W + X.F * (s2 != o2), l2), a2 || n2.setStrong(s2, e25, i2), s2;
}, ho = (fo("Map", function(e25) {
  return function() {
    return e25(this, arguments.length > 0 ? arguments[0] : void 0);
  };
}, { get: function(e25) {
  var t2 = po.getEntry(oo(this, "Map"), e25);
  return t2 && t2.v;
}, set: function(e25, t2) {
  return po.def(oo(this, "Map"), e25 === 0 ? 0 : e25, t2);
} }, po, true), fo("Set", function(e25) {
  return function() {
    return e25(this, arguments.length > 0 ? arguments[0] : void 0);
  };
}, { add: function(e25) {
  return po.def(oo(this, "Set"), e25 = e25 === 0 ? 0 : e25, e25);
} }, po), Y.getWeak), mo = ti(5), go = ti(6), yo = 0, vo = function(e25) {
  return e25._l || (e25._l = new xo());
}, xo = function() {
  this.a = [];
}, bo = function(e25, t2) {
  return mo(e25.a, function(e26) {
    return e26[0] === t2;
  });
};
xo.prototype = { get: function(e25) {
  var t2 = bo(this, e25);
  if (t2)
    return t2[1];
}, has: function(e25) {
  return !!bo(this, e25);
}, set: function(e25, t2) {
  var r2 = bo(this, e25);
  r2 ? r2[1] = t2 : this.a.push([e25, t2]);
}, delete: function(e25) {
  var t2 = go(this.a, function(t3) {
    return t3[0] === e25;
  });
  return ~t2 && this.a.splice(t2, 1), !!~t2;
} };
var Eo = { getConstructor: function(e25, t2, r2, n2) {
  var i2 = e25(function(e26, a2) {
    da$2(e26, i2, t2, "_i"), e26._t = t2, e26._i = yo++, e26._l = void 0, a2 != null && ma(a2, r2, e26[n2], e26);
  });
  return Ua(i2.prototype, { delete: function(e26) {
    if (!P(e26))
      return false;
    var r3 = ho(e26);
    return r3 === true ? vo(oo(this, t2)).delete(e26) : r3 && A(r3, this._i) && delete r3[this._i];
  }, has: function(e26) {
    if (!P(e26))
      return false;
    var r3 = ho(e26);
    return r3 === true ? vo(oo(this, t2)).has(e26) : r3 && A(r3, this._i);
  } }), i2;
}, def: function(e25, t2, r2) {
  var n2 = ho(I(t2), true);
  return n2 === true ? vo(e25).set(t2, r2) : n2[e25._i] = r2, e25;
}, ufstore: vo };
r(function(e25) {
  var t2, r2 = ti(0), n2 = oo, i2 = !D.ActiveXObject && "ActiveXObject" in D, a2 = Y.getWeak, o2 = Object.isExtensible, s2 = Eo.ufstore, u2 = function(e26) {
    return function() {
      return e26(this, arguments.length > 0 ? arguments[0] : void 0);
    };
  }, c2 = { get: function(e26) {
    if (P(e26)) {
      var t3 = a2(e26);
      return t3 === true ? s2(oo(this, "WeakMap")).get(e26) : t3 ? t3[this._i] : void 0;
    }
  }, set: function(e26, t3) {
    return Eo.def(oo(this, "WeakMap"), e26, t3);
  } }, l2 = e25.exports = fo("WeakMap", u2, c2, Eo, true, true);
  n2 && i2 && (t2 = Eo.getConstructor(u2, "WeakMap"), It(t2.prototype, c2), Y.NEED = true, r2(["delete", "has", "get", "set"], function(e26) {
    var r3 = l2.prototype, n3 = r3[e26];
    H(r3, e26, function(r4, i3) {
      if (P(r4) && !o2(r4)) {
        this._f || (this._f = new t2());
        var a3 = this._f[e26](r4, i3);
        return e26 == "set" ? this : a3;
      }
      return n3.call(this, r4, i3);
    });
  }));
});
fo("WeakSet", function(e25) {
  return function() {
    return e25(this, arguments.length > 0 ? arguments[0] : void 0);
  };
}, { add: function(e25) {
  return Eo.def(oo(this, "WeakSet"), e25, true);
} }, Eo, false, true);
for (var Co, So = $("typed_array"), ko = $("view"), Do = !(!D.ArrayBuffer || !D.DataView), Fo = Do, Ao = 0, wo = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); Ao < 9; )
  (Co = D[wo[Ao++]]) ? (U(Co.prototype, So, true), U(Co.prototype, ko, true)) : Fo = false;
var _o = { ABV: Do, CONSTR: Fo, TYPED: So, VIEW: ko }, To = function(e25) {
  if (e25 === void 0)
    return 0;
  var t2 = he(e25), r2 = me(t2);
  if (t2 !== r2)
    throw RangeError("Wrong length!");
  return r2;
}, Po = r(function(e25, t2) {
  var r2 = Me.f, n2 = M.f, i2 = "prototype", a2 = "Wrong index!", o2 = D.ArrayBuffer, s2 = D.DataView, u2 = D.Math, c2 = D.RangeError, l2 = D.Infinity, p2 = o2, f2 = u2.abs, h2 = u2.pow, d2 = u2.floor, m2 = u2.log, g2 = u2.LN2, y2 = _ ? "_b" : "buffer", v2 = _ ? "_l" : "byteLength", x2 = _ ? "_o" : "byteOffset";
  function b2(e26, t3, r3) {
    var n3, i3, a3, o3 = new Array(r3), s3 = 8 * r3 - t3 - 1, u3 = (1 << s3) - 1, c3 = u3 >> 1, p3 = t3 === 23 ? h2(2, -24) - h2(2, -77) : 0, y3 = 0, v3 = e26 < 0 || e26 === 0 && 1 / e26 < 0 ? 1 : 0;
    for ((e26 = f2(e26)) != e26 || e26 === l2 ? (i3 = e26 != e26 ? 1 : 0, n3 = u3) : (n3 = d2(m2(e26) / g2), e26 * (a3 = h2(2, -n3)) < 1 && (n3--, a3 *= 2), (e26 += n3 + c3 >= 1 ? p3 / a3 : p3 * h2(2, 1 - c3)) * a3 >= 2 && (n3++, a3 /= 2), n3 + c3 >= u3 ? (i3 = 0, n3 = u3) : n3 + c3 >= 1 ? (i3 = (e26 * a3 - 1) * h2(2, t3), n3 += c3) : (i3 = e26 * h2(2, c3 - 1) * h2(2, t3), n3 = 0)); t3 >= 8; o3[y3++] = 255 & i3, i3 /= 256, t3 -= 8)
      ;
    for (n3 = n3 << t3 | i3, s3 += t3; s3 > 0; o3[y3++] = 255 & n3, n3 /= 256, s3 -= 8)
      ;
    return o3[--y3] |= 128 * v3, o3;
  }
  function E2(e26, t3, r3) {
    var n3, i3 = 8 * r3 - t3 - 1, a3 = (1 << i3) - 1, o3 = a3 >> 1, s3 = i3 - 7, u3 = r3 - 1, c3 = e26[u3--], p3 = 127 & c3;
    for (c3 >>= 7; s3 > 0; p3 = 256 * p3 + e26[u3], u3--, s3 -= 8)
      ;
    for (n3 = p3 & (1 << -s3) - 1, p3 >>= -s3, s3 += t3; s3 > 0; n3 = 256 * n3 + e26[u3], u3--, s3 -= 8)
      ;
    if (p3 === 0)
      p3 = 1 - o3;
    else {
      if (p3 === a3)
        return n3 ? NaN : c3 ? -l2 : l2;
      n3 += h2(2, t3), p3 -= o3;
    }
    return (c3 ? -1 : 1) * n3 * h2(2, p3 - t3);
  }
  function C2(e26) {
    return e26[3] << 24 | e26[2] << 16 | e26[1] << 8 | e26[0];
  }
  function S2(e26) {
    return [255 & e26];
  }
  function k2(e26) {
    return [255 & e26, e26 >> 8 & 255];
  }
  function F2(e26) {
    return [255 & e26, e26 >> 8 & 255, e26 >> 16 & 255, e26 >> 24 & 255];
  }
  function A2(e26) {
    return b2(e26, 52, 8);
  }
  function T2(e26) {
    return b2(e26, 23, 4);
  }
  function P2(e26, t3, r3) {
    n2(e26[i2], t3, { get: function() {
      return this[r3];
    } });
  }
  function I2(e26, t3, r3, n3) {
    var i3 = To(+r3);
    if (i3 + t3 > e26[v2])
      throw c2(a2);
    var o3 = e26[y2]._b, s3 = i3 + e26[x2], u3 = o3.slice(s3, s3 + t3);
    return n3 ? u3 : u3.reverse();
  }
  function B2(e26, t3, r3, n3, i3, o3) {
    var s3 = To(+r3);
    if (s3 + t3 > e26[v2])
      throw c2(a2);
    for (var u3 = e26[y2]._b, l3 = s3 + e26[x2], p3 = n3(+i3), f3 = 0; f3 < t3; f3++)
      u3[l3 + f3] = p3[o3 ? f3 : t3 - f3 - 1];
  }
  if (_o.ABV) {
    if (!w(function() {
      o2(1);
    }) || !w(function() {
      new o2(-1);
    }) || w(function() {
      return new o2(), new o2(1.5), new o2(NaN), o2.name != "ArrayBuffer";
    })) {
      for (var O2, L2 = (o2 = function(e26) {
        return da$2(this, o2), new p2(To(e26));
      })[i2] = p2[i2], N2 = r2(p2), j2 = 0; N2.length > j2; )
        (O2 = N2[j2++]) in o2 || U(o2, O2, p2[O2]);
      L2.constructor = o2;
    }
    var R2 = new s2(new o2(2)), V2 = s2[i2].setInt8;
    R2.setInt8(0, 2147483648), R2.setInt8(1, 2147483649), !R2.getInt8(0) && R2.getInt8(1) || Ua(s2[i2], { setInt8: function(e26, t3) {
      V2.call(this, e26, t3 << 24 >> 24);
    }, setUint8: function(e26, t3) {
      V2.call(this, e26, t3 << 24 >> 24);
    } }, true);
  } else
    o2 = function(e26) {
      da$2(this, o2, "ArrayBuffer");
      var t3 = To(e26);
      this._b = vi.call(new Array(t3), 0), this[v2] = t3;
    }, s2 = function(e26, t3, r3) {
      da$2(this, s2, "DataView"), da$2(e26, o2, "DataView");
      var n3 = e26[v2], i3 = he(t3);
      if (i3 < 0 || i3 > n3)
        throw c2("Wrong offset!");
      if (i3 + (r3 = r3 === void 0 ? n3 - i3 : me(r3)) > n3)
        throw c2("Wrong length!");
      this[y2] = e26, this[x2] = i3, this[v2] = r3;
    }, _ && (P2(o2, "byteLength", "_l"), P2(s2, "buffer", "_b"), P2(s2, "byteLength", "_l"), P2(s2, "byteOffset", "_o")), Ua(s2[i2], { getInt8: function(e26) {
      return I2(this, 1, e26)[0] << 24 >> 24;
    }, getUint8: function(e26) {
      return I2(this, 1, e26)[0];
    }, getInt16: function(e26) {
      var t3 = I2(this, 2, e26, arguments[1]);
      return (t3[1] << 8 | t3[0]) << 16 >> 16;
    }, getUint16: function(e26) {
      var t3 = I2(this, 2, e26, arguments[1]);
      return t3[1] << 8 | t3[0];
    }, getInt32: function(e26) {
      return C2(I2(this, 4, e26, arguments[1]));
    }, getUint32: function(e26) {
      return C2(I2(this, 4, e26, arguments[1])) >>> 0;
    }, getFloat32: function(e26) {
      return E2(I2(this, 4, e26, arguments[1]), 23, 4);
    }, getFloat64: function(e26) {
      return E2(I2(this, 8, e26, arguments[1]), 52, 8);
    }, setInt8: function(e26, t3) {
      B2(this, 1, e26, S2, t3);
    }, setUint8: function(e26, t3) {
      B2(this, 1, e26, S2, t3);
    }, setInt16: function(e26, t3) {
      B2(this, 2, e26, k2, t3, arguments[2]);
    }, setUint16: function(e26, t3) {
      B2(this, 2, e26, k2, t3, arguments[2]);
    }, setInt32: function(e26, t3) {
      B2(this, 4, e26, F2, t3, arguments[2]);
    }, setUint32: function(e26, t3) {
      B2(this, 4, e26, F2, t3, arguments[2]);
    }, setFloat32: function(e26, t3) {
      B2(this, 4, e26, T2, t3, arguments[2]);
    }, setFloat64: function(e26, t3) {
      B2(this, 8, e26, A2, t3, arguments[2]);
    } });
  re(o2, "ArrayBuffer"), re(s2, "DataView"), U(s2[i2], _o.VIEW, true), t2.ArrayBuffer = o2, t2.DataView = s2;
}), Io = D.ArrayBuffer, Bo = Po.ArrayBuffer, Oo = Po.DataView, Lo = _o.ABV && Io.isView, No = Bo.prototype.slice, jo = _o.VIEW;
X(X.G + X.W + X.F * (Io !== Bo), { ArrayBuffer: Bo }), X(X.S + X.F * !_o.CONSTR, "ArrayBuffer", { isView: function(e25) {
  return Lo && Lo(e25) || P(e25) && jo in e25;
} }), X(X.P + X.U + X.F * w(function() {
  return !new Bo(2).slice(1, void 0).byteLength;
}), "ArrayBuffer", { slice: function(e25, t2) {
  if (No !== void 0 && t2 === void 0)
    return No.call(I(this), e25);
  for (var r2 = I(this).byteLength, n2 = ve(e25, r2), i2 = ve(t2 === void 0 ? r2 : t2, r2), a2 = new (sa(this, Bo))(me(i2 - n2)), o2 = new Oo(this), s2 = new Oo(a2), u2 = 0; n2 < i2; )
    s2.setUint8(u2++, o2.getUint8(n2++));
  return a2;
} }), ki("ArrayBuffer"), X(X.G + X.W + X.F * !_o.ABV, { DataView: Po.DataView });
var Ro = r(function(e25) {
  if (_) {
    var t2 = D, r2 = w, n2 = X, a2 = _o, o2 = Po, s2 = J, u2 = da$2, c2 = V, l2 = U, p2 = Ua, f2 = he, h2 = me, d2 = To, m2 = ve, g2 = j, y2 = A, v2 = Rt, x2 = P, b2 = Te, E2 = Vn, C2 = je, S2 = At, k2 = Me.f, F2 = Wn, T2 = $, I2 = Z, B2 = ti, O2 = xe, L2 = sa, N2 = Fi, R2 = cn, q2 = Hn, W2 = ki, G2 = vi, z2 = di, H2 = M, K2 = Ge, Q2 = H2.f, Y2 = K2.f, ee2 = t2.RangeError, te2 = t2.TypeError, re2 = t2.Uint8Array, ne2 = Array.prototype, ie2 = o2.ArrayBuffer, ae2 = o2.DataView, oe2 = B2(0), se2 = B2(2), ue2 = B2(3), ce2 = B2(4), le2 = B2(5), pe2 = B2(6), fe2 = O2(true), de2 = O2(false), ge2 = N2.values, ye2 = N2.keys, be2 = N2.entries, Ee2 = ne2.lastIndexOf, Ce2 = ne2.reduce, Se2 = ne2.reduceRight, ke2 = ne2.join, De2 = ne2.sort, Fe2 = ne2.slice, Ae2 = ne2.toString, we2 = ne2.toLocaleString, _e2 = I2("iterator"), Pe2 = I2("toStringTag"), Ie2 = T2("typed_constructor"), Be2 = T2("def_constructor"), Oe2 = a2.CONSTR, Le2 = a2.TYPED, Ne2 = a2.VIEW, Re2 = B2(1, function(e26, t3) {
      return $e2(L2(e26, e26[Be2]), t3);
    }), Ve2 = r2(function() {
      return new re2(new Uint16Array([1]).buffer)[0] === 1;
    }), Ue2 = !!re2 && !!re2.prototype.set && r2(function() {
      new re2(1).set({});
    }), qe2 = function(e26, t3) {
      var r3 = f2(e26);
      if (r3 < 0 || r3 % t3)
        throw ee2("Wrong offset!");
      return r3;
    }, We2 = function(e26) {
      if (x2(e26) && Le2 in e26)
        return e26;
      throw te2(e26 + " is not a typed array!");
    }, $e2 = function(e26, t3) {
      if (!(x2(e26) && Ie2 in e26))
        throw te2("It is not a typed array constructor!");
      return new e26(t3);
    }, ze2 = function(e26, t3) {
      return He2(L2(e26, e26[Be2]), t3);
    }, He2 = function(e26, t3) {
      for (var r3 = 0, n3 = t3.length, i2 = $e2(e26, n3); n3 > r3; )
        i2[r3] = t3[r3++];
      return i2;
    }, Ke2 = function(e26, t3, r3) {
      Q2(e26, t3, { get: function() {
        return this._d[r3];
      } });
    }, Je2 = function(e26) {
      var t3, r3, n3, i2, a3, o3, u3 = b2(e26), c3 = arguments.length, l3 = c3 > 1 ? arguments[1] : void 0, p3 = l3 !== void 0, f3 = F2(u3);
      if (f3 != null && !E2(f3)) {
        for (o3 = f3.call(u3), n3 = [], t3 = 0; !(a3 = o3.next()).done; t3++)
          n3.push(a3.value);
        u3 = n3;
      }
      for (p3 && c3 > 2 && (l3 = s2(l3, arguments[2], 2)), t3 = 0, r3 = h2(u3.length), i2 = $e2(this, r3); r3 > t3; t3++)
        i2[t3] = p3 ? l3(u3[t3], t3) : u3[t3];
      return i2;
    }, Qe2 = function() {
      for (var e26 = 0, t3 = arguments.length, r3 = $e2(this, t3); t3 > e26; )
        r3[e26] = arguments[e26++];
      return r3;
    }, Xe2 = !!re2 && r2(function() {
      we2.call(new re2(1));
    }), Ye2 = function() {
      return we2.apply(Xe2 ? Fe2.call(We2(this)) : We2(this), arguments);
    }, Ze2 = { copyWithin: function(e26, t3) {
      return z2.call(We2(this), e26, t3, arguments.length > 2 ? arguments[2] : void 0);
    }, every: function(e26) {
      return ce2(We2(this), e26, arguments.length > 1 ? arguments[1] : void 0);
    }, fill: function(e26) {
      return G2.apply(We2(this), arguments);
    }, filter: function(e26) {
      return ze2(this, se2(We2(this), e26, arguments.length > 1 ? arguments[1] : void 0));
    }, find: function(e26) {
      return le2(We2(this), e26, arguments.length > 1 ? arguments[1] : void 0);
    }, findIndex: function(e26) {
      return pe2(We2(this), e26, arguments.length > 1 ? arguments[1] : void 0);
    }, forEach: function(e26) {
      oe2(We2(this), e26, arguments.length > 1 ? arguments[1] : void 0);
    }, indexOf: function(e26) {
      return de2(We2(this), e26, arguments.length > 1 ? arguments[1] : void 0);
    }, includes: function(e26) {
      return fe2(We2(this), e26, arguments.length > 1 ? arguments[1] : void 0);
    }, join: function(e26) {
      return ke2.apply(We2(this), arguments);
    }, lastIndexOf: function(e26) {
      return Ee2.apply(We2(this), arguments);
    }, map: function(e26) {
      return Re2(We2(this), e26, arguments.length > 1 ? arguments[1] : void 0);
    }, reduce: function(e26) {
      return Ce2.apply(We2(this), arguments);
    }, reduceRight: function(e26) {
      return Se2.apply(We2(this), arguments);
    }, reverse: function() {
      for (var e26, t3 = We2(this).length, r3 = Math.floor(t3 / 2), n3 = 0; n3 < r3; )
        e26 = this[n3], this[n3++] = this[--t3], this[t3] = e26;
      return this;
    }, some: function(e26) {
      return ue2(We2(this), e26, arguments.length > 1 ? arguments[1] : void 0);
    }, sort: function(e26) {
      return De2.call(We2(this), e26);
    }, subarray: function(e26, t3) {
      var r3 = We2(this), n3 = r3.length, i2 = m2(e26, n3);
      return new (L2(r3, r3[Be2]))(r3.buffer, r3.byteOffset + i2 * r3.BYTES_PER_ELEMENT, h2((t3 === void 0 ? n3 : m2(t3, n3)) - i2));
    } }, et2 = function(e26, t3) {
      return ze2(this, Fe2.call(We2(this), e26, t3));
    }, tt2 = function(e26) {
      We2(this);
      var t3 = qe2(arguments[1], 1), r3 = this.length, n3 = b2(e26), i2 = h2(n3.length), a3 = 0;
      if (i2 + t3 > r3)
        throw ee2("Wrong length!");
      for (; a3 < i2; )
        this[t3 + a3] = n3[a3++];
    }, rt2 = { entries: function() {
      return be2.call(We2(this));
    }, keys: function() {
      return ye2.call(We2(this));
    }, values: function() {
      return ge2.call(We2(this));
    } }, nt2 = function(e26, t3) {
      return x2(e26) && e26[Le2] && i(t3) != "symbol" && t3 in e26 && String(+t3) == String(t3);
    }, it2 = function(e26, t3) {
      return nt2(e26, t3 = g2(t3, true)) ? c2(2, e26[t3]) : Y2(e26, t3);
    }, at2 = function(e26, t3, r3) {
      return !(nt2(e26, t3 = g2(t3, true)) && x2(r3) && y2(r3, "value")) || y2(r3, "get") || y2(r3, "set") || r3.configurable || y2(r3, "writable") && !r3.writable || y2(r3, "enumerable") && !r3.enumerable ? Q2(e26, t3, r3) : (e26[t3] = r3.value, e26);
    };
    Oe2 || (K2.f = it2, H2.f = at2), n2(n2.S + n2.F * !Oe2, "Object", { getOwnPropertyDescriptor: it2, defineProperty: at2 }), r2(function() {
      Ae2.call({});
    }) && (Ae2 = we2 = function() {
      return ke2.call(this);
    });
    var ot2 = p2({}, Ze2);
    p2(ot2, rt2), l2(ot2, _e2, rt2.values), p2(ot2, { slice: et2, set: tt2, constructor: function() {
    }, toString: Ae2, toLocaleString: Ye2 }), Ke2(ot2, "buffer", "b"), Ke2(ot2, "byteOffset", "o"), Ke2(ot2, "byteLength", "l"), Ke2(ot2, "length", "e"), Q2(ot2, Pe2, { get: function() {
      return this[Le2];
    } }), e25.exports = function(e26, i2, o3, s3) {
      var c3 = e26 + ((s3 = !!s3) ? "Clamped" : "") + "Array", p3 = "get" + e26, f3 = "set" + e26, m3 = t2[c3], g3 = m3 || {}, y3 = m3 && S2(m3), b3 = !m3 || !a2.ABV, E3 = {}, D2 = m3 && m3.prototype, F3 = function(e27, t3) {
        Q2(e27, t3, { get: function() {
          return function(e28, t4) {
            var r3 = e28._d;
            return r3.v[p3](t4 * i2 + r3.o, Ve2);
          }(this, t3);
        }, set: function(e28) {
          return function(e29, t4, r3) {
            var n3 = e29._d;
            s3 && (r3 = (r3 = Math.round(r3)) < 0 ? 0 : r3 > 255 ? 255 : 255 & r3), n3.v[f3](t4 * i2 + n3.o, r3, Ve2);
          }(this, t3, e28);
        }, enumerable: true });
      };
      b3 ? (m3 = o3(function(e27, t3, r3, n3) {
        u2(e27, m3, c3, "_d");
        var a3, o4, s4, p4, f4 = 0, g4 = 0;
        if (x2(t3)) {
          if (!(t3 instanceof ie2 || (p4 = v2(t3)) == "ArrayBuffer" || p4 == "SharedArrayBuffer"))
            return Le2 in t3 ? He2(m3, t3) : Je2.call(m3, t3);
          a3 = t3, g4 = qe2(r3, i2);
          var y4 = t3.byteLength;
          if (n3 === void 0) {
            if (y4 % i2)
              throw ee2("Wrong length!");
            if ((o4 = y4 - g4) < 0)
              throw ee2("Wrong length!");
          } else if ((o4 = h2(n3) * i2) + g4 > y4)
            throw ee2("Wrong length!");
          s4 = o4 / i2;
        } else
          s4 = d2(t3), a3 = new ie2(o4 = s4 * i2);
        for (l2(e27, "_d", { b: a3, o: g4, l: o4, e: s4, v: new ae2(a3) }); f4 < s4; )
          F3(e27, f4++);
      }), D2 = m3.prototype = C2(ot2), l2(D2, "constructor", m3)) : r2(function() {
        m3(1);
      }) && r2(function() {
        new m3(-1);
      }) && q2(function(e27) {
        new m3(), new m3(null), new m3(1.5), new m3(e27);
      }, true) || (m3 = o3(function(e27, t3, r3, n3) {
        var a3;
        return u2(e27, m3, c3), x2(t3) ? t3 instanceof ie2 || (a3 = v2(t3)) == "ArrayBuffer" || a3 == "SharedArrayBuffer" ? n3 !== void 0 ? new g3(t3, qe2(r3, i2), n3) : r3 !== void 0 ? new g3(t3, qe2(r3, i2)) : new g3(t3) : Le2 in t3 ? He2(m3, t3) : Je2.call(m3, t3) : new g3(d2(t3));
      }), oe2(y3 !== Function.prototype ? k2(g3).concat(k2(y3)) : k2(g3), function(e27) {
        e27 in m3 || l2(m3, e27, g3[e27]);
      }), m3.prototype = D2, D2.constructor = m3);
      var A2 = D2[_e2], w2 = !!A2 && (A2.name == "values" || A2.name == null), _2 = rt2.values;
      l2(m3, Ie2, true), l2(D2, Le2, c3), l2(D2, Ne2, true), l2(D2, Be2, m3), (s3 ? new m3(1)[Pe2] == c3 : Pe2 in D2) || Q2(D2, Pe2, { get: function() {
        return c3;
      } }), E3[c3] = m3, n2(n2.G + n2.W + n2.F * (m3 != g3), E3), n2(n2.S, c3, { BYTES_PER_ELEMENT: i2 }), n2(n2.S + n2.F * r2(function() {
        g3.of.call(m3, 1);
      }), c3, { from: Je2, of: Qe2 }), "BYTES_PER_ELEMENT" in D2 || l2(D2, "BYTES_PER_ELEMENT", i2), n2(n2.P, c3, Ze2), W2(c3), n2(n2.P + n2.F * Ue2, c3, { set: tt2 }), n2(n2.P + n2.F * !w2, c3, rt2), D2.toString != Ae2 && (D2.toString = Ae2), n2(n2.P + n2.F * r2(function() {
        new m3(1).slice();
      }), c3, { slice: et2 }), n2(n2.P + n2.F * (r2(function() {
        return [1, 2].toLocaleString() != new m3([1, 2]).toLocaleString();
      }) || !r2(function() {
        D2.toLocaleString.call([1, 2]);
      })), c3, { toLocaleString: Ye2 }), R2[c3] = w2 ? A2 : _2, w2 || l2(D2, _e2, _2);
    };
  } else
    e25.exports = function() {
    };
});
Ro("Int8", 1, function(e25) {
  return function(t2, r2, n2) {
    return e25(this, t2, r2, n2);
  };
}), Ro("Uint8", 1, function(e25) {
  return function(t2, r2, n2) {
    return e25(this, t2, r2, n2);
  };
}), Ro("Uint8", 1, function(e25) {
  return function(t2, r2, n2) {
    return e25(this, t2, r2, n2);
  };
}, true), Ro("Int16", 2, function(e25) {
  return function(t2, r2, n2) {
    return e25(this, t2, r2, n2);
  };
}), Ro("Uint16", 2, function(e25) {
  return function(t2, r2, n2) {
    return e25(this, t2, r2, n2);
  };
}), Ro("Int32", 4, function(e25) {
  return function(t2, r2, n2) {
    return e25(this, t2, r2, n2);
  };
}), Ro("Uint32", 4, function(e25) {
  return function(t2, r2, n2) {
    return e25(this, t2, r2, n2);
  };
}), Ro("Float32", 4, function(e25) {
  return function(t2, r2, n2) {
    return e25(this, t2, r2, n2);
  };
}), Ro("Float64", 8, function(e25) {
  return function(t2, r2, n2) {
    return e25(this, t2, r2, n2);
  };
});
var Mo = (D.Reflect || {}).apply, Vo = Function.apply;
X(X.S + X.F * !w(function() {
  Mo(function() {
  });
}), "Reflect", { apply: function(e25, t2, r2) {
  var n2 = K(e25), i2 = I(r2);
  return Mo ? Mo(n2, t2, i2) : Vo.call(n2, t2, i2);
} });
var Uo = (D.Reflect || {}).construct, qo = w(function() {
  function e25() {
  }
  return !(Uo(function() {
  }, [], e25) instanceof e25);
}), Wo = !w(function() {
  Uo(function() {
  });
});
X(X.S + X.F * (qo || Wo), "Reflect", { construct: function(e25, t2) {
  K(e25), I(t2);
  var r2 = arguments.length < 3 ? e25 : K(arguments[2]);
  if (Wo && !qo)
    return Uo(e25, t2, r2);
  if (e25 == r2) {
    switch (t2.length) {
      case 0:
        return new e25();
      case 1:
        return new e25(t2[0]);
      case 2:
        return new e25(t2[0], t2[1]);
      case 3:
        return new e25(t2[0], t2[1], t2[2]);
      case 4:
        return new e25(t2[0], t2[1], t2[2], t2[3]);
    }
    var n2 = [null];
    return n2.push.apply(n2, t2), new ($t.apply(e25, n2))();
  }
  var i2 = r2.prototype, a2 = je(P(i2) ? i2 : Object.prototype), o2 = Function.apply.call(e25, a2, t2);
  return P(o2) ? o2 : a2;
} }), X(X.S + X.F * w(function() {
  Reflect.defineProperty(M.f({}, 1, { value: 1 }), 1, { value: 2 });
}), "Reflect", { defineProperty: function(e25, t2, r2) {
  I(e25), t2 = j(t2, true), I(r2);
  try {
    return M.f(e25, t2, r2), true;
  } catch (e26) {
    return false;
  }
} });
var $o = Ge.f;
X(X.S, "Reflect", { deleteProperty: function(e25, t2) {
  var r2 = $o(I(e25), t2);
  return !(r2 && !r2.configurable) && delete e25[t2];
} });
var Go = function(e25) {
  this._t = I(e25), this._i = 0;
  var t2, r2 = this._k = [];
  for (t2 in e25)
    r2.push(t2);
};
pn(Go, "Object", function() {
  var e25, t2 = this._k;
  do {
    if (this._i >= t2.length)
      return { value: void 0, done: true };
  } while (!((e25 = t2[this._i++]) in this._t));
  return { value: e25, done: false };
}), X(X.S, "Reflect", { enumerate: function(e25) {
  return new Go(e25);
} }), X(X.S, "Reflect", { get: function e6(t2, r2) {
  var n2, i2, a2 = arguments.length < 3 ? t2 : arguments[2];
  return I(t2) === a2 ? t2[r2] : (n2 = Ge.f(t2, r2)) ? A(n2, "value") ? n2.value : n2.get !== void 0 ? n2.get.call(a2) : void 0 : P(i2 = At(t2)) ? e6(i2, r2, a2) : void 0;
} }), X(X.S, "Reflect", { getOwnPropertyDescriptor: function(e25, t2) {
  return Ge.f(I(e25), t2);
} }), X(X.S, "Reflect", { getPrototypeOf: function(e25) {
  return At(I(e25));
} }), X(X.S, "Reflect", { has: function(e25, t2) {
  return t2 in e25;
} });
var zo = Object.isExtensible;
X(X.S, "Reflect", { isExtensible: function(e25) {
  return I(e25), !zo || zo(e25);
} });
var Ho = D.Reflect, Ko = Ho && Ho.ownKeys || function(e25) {
  var t2 = Me.f(I(e25)), r2 = Ae.f;
  return r2 ? t2.concat(r2(e25)) : t2;
};
X(X.S, "Reflect", { ownKeys: Ko });
var Jo = Object.preventExtensions;
X(X.S, "Reflect", { preventExtensions: function(e25) {
  I(e25);
  try {
    return Jo && Jo(e25), true;
  } catch (e26) {
    return false;
  }
} }), X(X.S, "Reflect", { set: function e7(t2, r2, n2) {
  var i2, a2, o2 = arguments.length < 4 ? t2 : arguments[3], s2 = Ge.f(I(t2), r2);
  if (!s2) {
    if (P(a2 = At(t2)))
      return e7(a2, r2, n2, o2);
    s2 = V(0);
  }
  if (A(s2, "value")) {
    if (s2.writable === false || !P(o2))
      return false;
    if (i2 = Ge.f(o2, r2)) {
      if (i2.get || i2.set || i2.writable === false)
        return false;
      i2.value = n2, M.f(o2, r2, i2);
    } else
      M.f(o2, r2, V(0, n2));
    return true;
  }
  return s2.set !== void 0 && (s2.set.call(o2, n2), true);
} }), Lt && X(X.S, "Reflect", { setPrototypeOf: function(e25, t2) {
  Lt.check(e25, t2);
  try {
    return Lt.set(e25, t2), true;
  } catch (e26) {
    return false;
  }
} });
var Qo = xe(true);
X(X.P, "Array", { includes: function(e25) {
  return Qo(this, e25, arguments.length > 1 ? arguments[1] : void 0);
} }), yi("includes");
T.Array.includes;
var Xo = Z("isConcatSpreadable");
var Yo = function e8(t2, r2, n2, i2, a2, o2, s2, u2) {
  for (var c2, l2, p2 = a2, f2 = 0, h2 = !!s2 && J(s2, u2, 3); f2 < i2; ) {
    if (f2 in n2) {
      if (c2 = h2 ? h2(n2[f2], f2, r2) : n2[f2], l2 = false, P(c2) && (l2 = (l2 = c2[Xo]) !== void 0 ? !!l2 : _e(c2)), l2 && o2 > 0)
        p2 = e8(t2, r2, c2, me(c2.length), p2, o2 - 1) - 1;
      else {
        if (p2 >= 9007199254740991)
          throw TypeError();
        t2[p2] = c2;
      }
      p2++;
    }
    f2++;
  }
  return p2;
};
X(X.P, "Array", { flatMap: function(e25) {
  var t2, r2, n2 = Te(this);
  return K(e25), t2 = me(n2.length), r2 = ei(n2, 0), Yo(r2, n2, n2, t2, 0, 1, e25, arguments[1]), r2;
} }), yi("flatMap");
T.Array.flatMap;
var Zo = function(e25, t2, r2, n2) {
  var i2 = String(ce(e25)), a2 = i2.length, o2 = r2 === void 0 ? " " : String(r2), s2 = me(t2);
  if (s2 <= a2 || o2 == "")
    return i2;
  var u2 = s2 - a2, c2 = Fr.call(o2, Math.ceil(u2 / o2.length));
  return c2.length > u2 && (c2 = c2.slice(0, u2)), n2 ? c2 + i2 : i2 + c2;
}, es$1 = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(Ma);
X(X.P + X.F * es$1, "String", { padStart: function(e25) {
  return Zo(this, e25, arguments.length > 1 ? arguments[1] : void 0, true);
} });
T.String.padStart;
var ts = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(Ma);
X(X.P + X.F * ts, "String", { padEnd: function(e25) {
  return Zo(this, e25, arguments.length > 1 ? arguments[1] : void 0, false);
} });
T.String.padEnd;
rr("trimLeft", function(e25) {
  return function() {
    return e25(this, 1);
  };
}, "trimStart");
T.String.trimLeft;
rr("trimRight", function(e25) {
  return function() {
    return e25(this, 2);
  };
}, "trimEnd");
T.String.trimRight;
ae("asyncIterator");
ne.f("asyncIterator");
X(X.S, "Object", { getOwnPropertyDescriptors: function(e25) {
  for (var t2, r2, n2 = le(e25), i2 = Ge.f, a2 = Ko(n2), o2 = {}, s2 = 0; a2.length > s2; )
    (r2 = i2(n2, t2 = a2[s2++])) !== void 0 && Un(o2, t2, r2);
  return o2;
} });
T.Object.getOwnPropertyDescriptors;
var rs = we.f, ns = function(e25) {
  return function(t2) {
    for (var r2, n2 = le(t2), i2 = Fe(n2), a2 = i2.length, o2 = 0, s2 = []; a2 > o2; )
      r2 = i2[o2++], _ && !rs.call(n2, r2) || s2.push(e25 ? [r2, n2[r2]] : n2[r2]);
    return s2;
  };
}, is = ns(false);
X(X.S, "Object", { values: function(e25) {
  return is(e25);
} });
T.Object.values;
var as = ns(true);
X(X.S, "Object", { entries: function(e25) {
  return as(e25);
} });
T.Object.entries;
X(X.P + X.R, "Promise", { finally: function(e25) {
  var t2 = sa(this, T.Promise || D.Promise), r2 = typeof e25 == "function";
  return this.then(r2 ? function(r3) {
    return Va(t2, e25()).then(function() {
      return r3;
    });
  } : e25, r2 ? function(r3) {
    return Va(t2, e25()).then(function() {
      throw r3;
    });
  } : e25);
} });
T.Promise.finally;
var os = [].slice, ss = /MSIE .\./.test(Ma), us = function(e25) {
  return function(t2, r2) {
    var n2 = arguments.length > 2, i2 = !!n2 && os.call(arguments, 2);
    return e25(n2 ? function() {
      (typeof t2 == "function" ? t2 : Function(t2)).apply(this, i2);
    } : t2, r2);
  };
};
X(X.G + X.B + X.F * ss, { setTimeout: us(D.setTimeout), setInterval: us(D.setInterval) }), X(X.G + X.B, { setImmediate: Da.set, clearImmediate: Da.clear });
for (var cs = Z("iterator"), ls = Z("toStringTag"), ps = cn.Array, fs = { CSSRuleList: true, CSSStyleDeclaration: false, CSSValueList: false, ClientRectList: false, DOMRectList: false, DOMStringList: false, DOMTokenList: true, DataTransferItemList: false, FileList: false, HTMLAllCollection: false, HTMLCollection: false, HTMLFormElement: false, HTMLSelectElement: false, MediaList: true, MimeTypeArray: false, NamedNodeMap: false, NodeList: true, PaintRequestList: false, Plugin: false, PluginArray: false, SVGLengthList: false, SVGNumberList: false, SVGPathSegList: false, SVGPointList: false, SVGStringList: false, SVGTransformList: false, SourceBufferList: false, StyleSheetList: true, TextTrackCueList: false, TextTrackList: false, TouchList: false }, hs = Fe(fs), ds = 0; ds < hs.length; ds++) {
  var ms, gs = hs[ds], ys = fs[gs], vs = D[gs], xs = vs && vs.prototype;
  if (xs && (xs[cs] || U(xs, cs, ps), xs[ls] || U(xs, ls, gs), cn[gs] = ps, ys))
    for (ms in Fi)
      xs[ms] || H(xs, ms, Fi[ms], true);
}
r(function(e25) {
  var t2 = function(e26) {
    var t3, r2 = Object.prototype, n2 = r2.hasOwnProperty, a2 = typeof Symbol == "function" ? Symbol : {}, o2 = a2.iterator || "@@iterator", s2 = a2.asyncIterator || "@@asyncIterator", u2 = a2.toStringTag || "@@toStringTag";
    function c2(e27, t4, r3, n3) {
      var i2 = t4 && t4.prototype instanceof g2 ? t4 : g2, a3 = Object.create(i2.prototype), o3 = new w2(n3 || []);
      return a3._invoke = function(e28, t5, r4) {
        var n4 = p2;
        return function(i3, a4) {
          if (n4 === h2)
            throw new Error("Generator is already running");
          if (n4 === d2) {
            if (i3 === "throw")
              throw a4;
            return T2();
          }
          for (r4.method = i3, r4.arg = a4; ; ) {
            var o4 = r4.delegate;
            if (o4) {
              var s3 = D2(o4, r4);
              if (s3) {
                if (s3 === m2)
                  continue;
                return s3;
              }
            }
            if (r4.method === "next")
              r4.sent = r4._sent = r4.arg;
            else if (r4.method === "throw") {
              if (n4 === p2)
                throw n4 = d2, r4.arg;
              r4.dispatchException(r4.arg);
            } else
              r4.method === "return" && r4.abrupt("return", r4.arg);
            n4 = h2;
            var u3 = l2(e28, t5, r4);
            if (u3.type === "normal") {
              if (n4 = r4.done ? d2 : f2, u3.arg === m2)
                continue;
              return { value: u3.arg, done: r4.done };
            }
            u3.type === "throw" && (n4 = d2, r4.method = "throw", r4.arg = u3.arg);
          }
        };
      }(e27, r3, o3), a3;
    }
    function l2(e27, t4, r3) {
      try {
        return { type: "normal", arg: e27.call(t4, r3) };
      } catch (e28) {
        return { type: "throw", arg: e28 };
      }
    }
    e26.wrap = c2;
    var p2 = "suspendedStart", f2 = "suspendedYield", h2 = "executing", d2 = "completed", m2 = {};
    function g2() {
    }
    function y2() {
    }
    function v2() {
    }
    var x2 = {};
    x2[o2] = function() {
      return this;
    };
    var b2 = Object.getPrototypeOf, E2 = b2 && b2(b2(_2([])));
    E2 && E2 !== r2 && n2.call(E2, o2) && (x2 = E2);
    var C2 = v2.prototype = g2.prototype = Object.create(x2);
    function S2(e27) {
      ["next", "throw", "return"].forEach(function(t4) {
        e27[t4] = function(e28) {
          return this._invoke(t4, e28);
        };
      });
    }
    function k2(e27) {
      var t4;
      this._invoke = function(r3, a3) {
        function o3() {
          return new Promise(function(t5, o4) {
            !function t6(r4, a4, o5, s3) {
              var u3 = l2(e27[r4], e27, a4);
              if (u3.type !== "throw") {
                var c3 = u3.arg, p3 = c3.value;
                return p3 && i(p3) === "object" && n2.call(p3, "__await") ? Promise.resolve(p3.__await).then(function(e28) {
                  t6("next", e28, o5, s3);
                }, function(e28) {
                  t6("throw", e28, o5, s3);
                }) : Promise.resolve(p3).then(function(e28) {
                  c3.value = e28, o5(c3);
                }, function(e28) {
                  return t6("throw", e28, o5, s3);
                });
              }
              s3(u3.arg);
            }(r3, a3, t5, o4);
          });
        }
        return t4 = t4 ? t4.then(o3, o3) : o3();
      };
    }
    function D2(e27, r3) {
      var n3 = e27.iterator[r3.method];
      if (n3 === t3) {
        if (r3.delegate = null, r3.method === "throw") {
          if (e27.iterator.return && (r3.method = "return", r3.arg = t3, D2(e27, r3), r3.method === "throw"))
            return m2;
          r3.method = "throw", r3.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return m2;
      }
      var i2 = l2(n3, e27.iterator, r3.arg);
      if (i2.type === "throw")
        return r3.method = "throw", r3.arg = i2.arg, r3.delegate = null, m2;
      var a3 = i2.arg;
      return a3 ? a3.done ? (r3[e27.resultName] = a3.value, r3.next = e27.nextLoc, r3.method !== "return" && (r3.method = "next", r3.arg = t3), r3.delegate = null, m2) : a3 : (r3.method = "throw", r3.arg = new TypeError("iterator result is not an object"), r3.delegate = null, m2);
    }
    function F2(e27) {
      var t4 = { tryLoc: e27[0] };
      1 in e27 && (t4.catchLoc = e27[1]), 2 in e27 && (t4.finallyLoc = e27[2], t4.afterLoc = e27[3]), this.tryEntries.push(t4);
    }
    function A2(e27) {
      var t4 = e27.completion || {};
      t4.type = "normal", delete t4.arg, e27.completion = t4;
    }
    function w2(e27) {
      this.tryEntries = [{ tryLoc: "root" }], e27.forEach(F2, this), this.reset(true);
    }
    function _2(e27) {
      if (e27) {
        var r3 = e27[o2];
        if (r3)
          return r3.call(e27);
        if (typeof e27.next == "function")
          return e27;
        if (!isNaN(e27.length)) {
          var i2 = -1, a3 = function r4() {
            for (; ++i2 < e27.length; )
              if (n2.call(e27, i2))
                return r4.value = e27[i2], r4.done = false, r4;
            return r4.value = t3, r4.done = true, r4;
          };
          return a3.next = a3;
        }
      }
      return { next: T2 };
    }
    function T2() {
      return { value: t3, done: true };
    }
    return y2.prototype = C2.constructor = v2, v2.constructor = y2, v2[u2] = y2.displayName = "GeneratorFunction", e26.isGeneratorFunction = function(e27) {
      var t4 = typeof e27 == "function" && e27.constructor;
      return !!t4 && (t4 === y2 || (t4.displayName || t4.name) === "GeneratorFunction");
    }, e26.mark = function(e27) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e27, v2) : (e27.__proto__ = v2, u2 in e27 || (e27[u2] = "GeneratorFunction")), e27.prototype = Object.create(C2), e27;
    }, e26.awrap = function(e27) {
      return { __await: e27 };
    }, S2(k2.prototype), k2.prototype[s2] = function() {
      return this;
    }, e26.AsyncIterator = k2, e26.async = function(t4, r3, n3, i2) {
      var a3 = new k2(c2(t4, r3, n3, i2));
      return e26.isGeneratorFunction(r3) ? a3 : a3.next().then(function(e27) {
        return e27.done ? e27.value : a3.next();
      });
    }, S2(C2), C2[u2] = "Generator", C2[o2] = function() {
      return this;
    }, C2.toString = function() {
      return "[object Generator]";
    }, e26.keys = function(e27) {
      var t4 = [];
      for (var r3 in e27)
        t4.push(r3);
      return t4.reverse(), function r4() {
        for (; t4.length; ) {
          var n3 = t4.pop();
          if (n3 in e27)
            return r4.value = n3, r4.done = false, r4;
        }
        return r4.done = true, r4;
      };
    }, e26.values = _2, w2.prototype = { constructor: w2, reset: function(e27) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t3, this.done = false, this.delegate = null, this.method = "next", this.arg = t3, this.tryEntries.forEach(A2), !e27)
        for (var r3 in this)
          r3.charAt(0) === "t" && n2.call(this, r3) && !isNaN(+r3.slice(1)) && (this[r3] = t3);
    }, stop: function() {
      this.done = true;
      var e27 = this.tryEntries[0].completion;
      if (e27.type === "throw")
        throw e27.arg;
      return this.rval;
    }, dispatchException: function(e27) {
      if (this.done)
        throw e27;
      var r3 = this;
      function i2(n3, i3) {
        return s3.type = "throw", s3.arg = e27, r3.next = n3, i3 && (r3.method = "next", r3.arg = t3), !!i3;
      }
      for (var a3 = this.tryEntries.length - 1; a3 >= 0; --a3) {
        var o3 = this.tryEntries[a3], s3 = o3.completion;
        if (o3.tryLoc === "root")
          return i2("end");
        if (o3.tryLoc <= this.prev) {
          var u3 = n2.call(o3, "catchLoc"), c3 = n2.call(o3, "finallyLoc");
          if (u3 && c3) {
            if (this.prev < o3.catchLoc)
              return i2(o3.catchLoc, true);
            if (this.prev < o3.finallyLoc)
              return i2(o3.finallyLoc);
          } else if (u3) {
            if (this.prev < o3.catchLoc)
              return i2(o3.catchLoc, true);
          } else {
            if (!c3)
              throw new Error("try statement without catch or finally");
            if (this.prev < o3.finallyLoc)
              return i2(o3.finallyLoc);
          }
        }
      }
    }, abrupt: function(e27, t4) {
      for (var r3 = this.tryEntries.length - 1; r3 >= 0; --r3) {
        var i2 = this.tryEntries[r3];
        if (i2.tryLoc <= this.prev && n2.call(i2, "finallyLoc") && this.prev < i2.finallyLoc) {
          var a3 = i2;
          break;
        }
      }
      a3 && (e27 === "break" || e27 === "continue") && a3.tryLoc <= t4 && t4 <= a3.finallyLoc && (a3 = null);
      var o3 = a3 ? a3.completion : {};
      return o3.type = e27, o3.arg = t4, a3 ? (this.method = "next", this.next = a3.finallyLoc, m2) : this.complete(o3);
    }, complete: function(e27, t4) {
      if (e27.type === "throw")
        throw e27.arg;
      return e27.type === "break" || e27.type === "continue" ? this.next = e27.arg : e27.type === "return" ? (this.rval = this.arg = e27.arg, this.method = "return", this.next = "end") : e27.type === "normal" && t4 && (this.next = t4), m2;
    }, finish: function(e27) {
      for (var t4 = this.tryEntries.length - 1; t4 >= 0; --t4) {
        var r3 = this.tryEntries[t4];
        if (r3.finallyLoc === e27)
          return this.complete(r3.completion, r3.afterLoc), A2(r3), m2;
      }
    }, catch: function(e27) {
      for (var t4 = this.tryEntries.length - 1; t4 >= 0; --t4) {
        var r3 = this.tryEntries[t4];
        if (r3.tryLoc === e27) {
          var n3 = r3.completion;
          if (n3.type === "throw") {
            var i2 = n3.arg;
            A2(r3);
          }
          return i2;
        }
      }
      throw new Error("illegal catch attempt");
    }, delegateYield: function(e27, r3, n3) {
      return this.delegate = { iterator: _2(e27), resultName: r3, nextLoc: n3 }, this.method === "next" && (this.arg = t3), m2;
    } }, e26;
  }(e25.exports);
  try {
    regeneratorRuntime = t2;
  } catch (e26) {
    Function("r", "regeneratorRuntime = r")(t2);
  }
});
var bs = r(function(e25) {
  var t2 = e25.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
  typeof __g == "number" && (__g = t2);
}), Es = r(function(e25) {
  var t2 = e25.exports = { version: "2.6.10" };
  typeof __e == "number" && (__e = t2);
}), Cs = (Es.version, function(e25, t2, r2) {
  if (function(e26) {
    if (typeof e26 != "function")
      throw TypeError(e26 + " is not a function!");
  }(e25), t2 === void 0)
    return e25;
  switch (r2) {
    case 1:
      return function(r3) {
        return e25.call(t2, r3);
      };
    case 2:
      return function(r3, n2) {
        return e25.call(t2, r3, n2);
      };
    case 3:
      return function(r3, n2, i2) {
        return e25.call(t2, r3, n2, i2);
      };
  }
  return function() {
    return e25.apply(t2, arguments);
  };
}), Ss = function(e25) {
  return i(e25) === "object" ? e25 !== null : typeof e25 == "function";
}, ks = function(e25) {
  if (!Ss(e25))
    throw TypeError(e25 + " is not an object!");
  return e25;
}, Ds = function(e25) {
  try {
    return !!e25();
  } catch (e26) {
    return true;
  }
}, Fs = !Ds(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), As = bs.document, ws = Ss(As) && Ss(As.createElement), _s = !Fs && !Ds(function() {
  return Object.defineProperty((e25 = "div", ws ? As.createElement(e25) : {}), "a", { get: function() {
    return 7;
  } }).a != 7;
  var e25;
}), Ts = Object.defineProperty, Ps = { f: Fs ? Object.defineProperty : function(e25, t2, r2) {
  if (ks(e25), t2 = function(e26, t3) {
    if (!Ss(e26))
      return e26;
    var r3, n2;
    if (t3 && typeof (r3 = e26.toString) == "function" && !Ss(n2 = r3.call(e26)))
      return n2;
    if (typeof (r3 = e26.valueOf) == "function" && !Ss(n2 = r3.call(e26)))
      return n2;
    if (!t3 && typeof (r3 = e26.toString) == "function" && !Ss(n2 = r3.call(e26)))
      return n2;
    throw TypeError("Can't convert object to primitive value");
  }(t2, true), ks(r2), _s)
    try {
      return Ts(e25, t2, r2);
    } catch (e26) {
    }
  if ("get" in r2 || "set" in r2)
    throw TypeError("Accessors not supported!");
  return "value" in r2 && (e25[t2] = r2.value), e25;
} }, Is = Fs ? function(e25, t2, r2) {
  return Ps.f(e25, t2, function(e26, t3) {
    return { enumerable: !(1 & e26), configurable: !(2 & e26), writable: !(4 & e26), value: t3 };
  }(1, r2));
} : function(e25, t2, r2) {
  return e25[t2] = r2, e25;
}, Bs = {}.hasOwnProperty, Os = function(e25, t2) {
  return Bs.call(e25, t2);
}, Ls = function e9(t2, r2, n2) {
  var i2, a2, o2, s2 = t2 & e9.F, u2 = t2 & e9.G, c2 = t2 & e9.S, l2 = t2 & e9.P, p2 = t2 & e9.B, f2 = t2 & e9.W, h2 = u2 ? Es : Es[r2] || (Es[r2] = {}), d2 = h2.prototype, m2 = u2 ? bs : c2 ? bs[r2] : (bs[r2] || {}).prototype;
  for (i2 in u2 && (n2 = r2), n2)
    (a2 = !s2 && m2 && m2[i2] !== void 0) && Os(h2, i2) || (o2 = a2 ? m2[i2] : n2[i2], h2[i2] = u2 && typeof m2[i2] != "function" ? n2[i2] : p2 && a2 ? Cs(o2, bs) : f2 && m2[i2] == o2 ? function(e25) {
      var t3 = function(t4, r3, n3) {
        if (this instanceof e25) {
          switch (arguments.length) {
            case 0:
              return new e25();
            case 1:
              return new e25(t4);
            case 2:
              return new e25(t4, r3);
          }
          return new e25(t4, r3, n3);
        }
        return e25.apply(this, arguments);
      };
      return t3.prototype = e25.prototype, t3;
    }(o2) : l2 && typeof o2 == "function" ? Cs(Function.call, o2) : o2, l2 && ((h2.virtual || (h2.virtual = {}))[i2] = o2, t2 & e9.R && d2 && !d2[i2] && Is(d2, i2, o2)));
};
Ls.F = 1, Ls.G = 2, Ls.S = 4, Ls.P = 8, Ls.B = 16, Ls.W = 32, Ls.U = 64, Ls.R = 128;
Ls(Ls.G, { global: bs });
var Ns = Es.global;
function js(e25, t2) {
  for (var r2 = 0, n2 = e25.length - 1; n2 >= 0; n2--) {
    var i2 = e25[n2];
    i2 === "." ? e25.splice(n2, 1) : i2 === ".." ? (e25.splice(n2, 1), r2++) : r2 && (e25.splice(n2, 1), r2--);
  }
  if (t2)
    for (; r2--; r2)
      e25.unshift("..");
  return e25;
}
t(r(function(e25) {
  var t2, r2 = (t2 = Ns) && t2.__esModule ? t2 : { default: t2 };
  r2.default._babelPolyfill && typeof console != "undefined" && console.warn && console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended and may have consequences if different versions of the polyfills are applied sequentially. If you do need to load the polyfill more than once, use @babel/polyfill/noConflict instead to bypass the warning."), r2.default._babelPolyfill = true;
}));
var Rs = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, Ms = function(e25) {
  return Rs.exec(e25).slice(1);
};
function Vs() {
  for (var e25 = "", t2 = false, r2 = arguments.length - 1; r2 >= -1 && !t2; r2--) {
    var n2 = r2 >= 0 ? arguments[r2] : "/";
    if (typeof n2 != "string")
      throw new TypeError("Arguments to path.resolve must be strings");
    n2 && (e25 = n2 + "/" + e25, t2 = n2.charAt(0) === "/");
  }
  return (t2 ? "/" : "") + (e25 = js($s(e25.split("/"), function(e26) {
    return !!e26;
  }), !t2).join("/")) || ".";
}
function Us(e25) {
  var t2 = qs(e25), r2 = Gs(e25, -1) === "/";
  return (e25 = js($s(e25.split("/"), function(e26) {
    return !!e26;
  }), !t2).join("/")) || t2 || (e25 = "."), e25 && r2 && (e25 += "/"), (t2 ? "/" : "") + e25;
}
function qs(e25) {
  return e25.charAt(0) === "/";
}
var Ws = { extname: function(e25) {
  return Ms(e25)[3];
}, basename: function(e25, t2) {
  var r2 = Ms(e25)[2];
  return t2 && r2.substr(-1 * t2.length) === t2 && (r2 = r2.substr(0, r2.length - t2.length)), r2;
}, dirname: function(e25) {
  var t2 = Ms(e25), r2 = t2[0], n2 = t2[1];
  return r2 || n2 ? (n2 && (n2 = n2.substr(0, n2.length - 1)), r2 + n2) : ".";
}, sep: "/", delimiter: ":", relative: function(e25, t2) {
  function r2(e26) {
    for (var t3 = 0; t3 < e26.length && e26[t3] === ""; t3++)
      ;
    for (var r3 = e26.length - 1; r3 >= 0 && e26[r3] === ""; r3--)
      ;
    return t3 > r3 ? [] : e26.slice(t3, r3 - t3 + 1);
  }
  e25 = Vs(e25).substr(1), t2 = Vs(t2).substr(1);
  for (var n2 = r2(e25.split("/")), i2 = r2(t2.split("/")), a2 = Math.min(n2.length, i2.length), o2 = a2, s2 = 0; s2 < a2; s2++)
    if (n2[s2] !== i2[s2]) {
      o2 = s2;
      break;
    }
  var u2 = [];
  for (s2 = o2; s2 < n2.length; s2++)
    u2.push("..");
  return (u2 = u2.concat(i2.slice(o2))).join("/");
}, join: function() {
  return Us($s(Array.prototype.slice.call(arguments, 0), function(e25, t2) {
    if (typeof e25 != "string")
      throw new TypeError("Arguments to path.join must be strings");
    return e25;
  }).join("/"));
}, isAbsolute: qs, normalize: Us, resolve: Vs };
function $s(e25, t2) {
  if (e25.filter)
    return e25.filter(t2);
  for (var r2 = [], n2 = 0; n2 < e25.length; n2++)
    t2(e25[n2], n2, e25) && r2.push(e25[n2]);
  return r2;
}
var Gs = "ab".substr(-1) === "b" ? function(e25, t2, r2) {
  return e25.substr(t2, r2);
} : function(e25, t2, r2) {
  return t2 < 0 && (t2 = e25.length + t2), e25.substr(t2, r2);
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function zs(e25) {
  return e25 != null && (!!e25._isBuffer || Hs(e25) || function(e26) {
    return typeof e26.readFloatLE == "function" && typeof e26.slice == "function" && Hs(e26.slice(0, 0));
  }(e25));
}
function Hs(e25) {
  return !!e25.constructor && typeof e25.constructor.isBuffer == "function" && e25.constructor.isBuffer(e25);
}
var Ks = typeof Object.create == "function" ? function(e25, t2) {
  e25.super_ = t2, e25.prototype = Object.create(t2.prototype, { constructor: { value: e25, enumerable: false, writable: true, configurable: true } });
} : function(e25, t2) {
  e25.super_ = t2;
  var r2 = function() {
  };
  r2.prototype = t2.prototype, e25.prototype = new r2(), e25.prototype.constructor = e25;
}, Js = /%[sdj%]/g;
function Qs(e25) {
  if (!cu(e25)) {
    for (var t2 = [], r2 = 0; r2 < arguments.length; r2++)
      t2.push(Zs(arguments[r2]));
    return t2.join(" ");
  }
  r2 = 1;
  for (var n2 = arguments, i2 = n2.length, a2 = String(e25).replace(Js, function(e26) {
    if (e26 === "%%")
      return "%";
    if (r2 >= i2)
      return e26;
    switch (e26) {
      case "%s":
        return String(n2[r2++]);
      case "%d":
        return Number(n2[r2++]);
      case "%j":
        try {
          return JSON.stringify(n2[r2++]);
        } catch (e27) {
          return "[Circular]";
        }
      default:
        return e26;
    }
  }), o2 = n2[r2]; r2 < i2; o2 = n2[++r2])
    su(o2) || !fu(o2) ? a2 += " " + o2 : a2 += " " + Zs(o2);
  return a2;
}
var Xs, Ys = {};
function Zs(e25, t2) {
  var r2 = { seen: [], stylize: tu };
  return arguments.length >= 3 && (r2.depth = arguments[2]), arguments.length >= 4 && (r2.colors = arguments[3]), ou(t2) ? r2.showHidden = t2 : t2 && bu(r2, t2), lu(r2.showHidden) && (r2.showHidden = false), lu(r2.depth) && (r2.depth = 2), lu(r2.colors) && (r2.colors = false), lu(r2.customInspect) && (r2.customInspect = true), r2.colors && (r2.stylize = eu), ru(r2, e25, r2.depth);
}
function eu(e25, t2) {
  var r2 = Zs.styles[t2];
  return r2 ? "[" + Zs.colors[r2][0] + "m" + e25 + "[" + Zs.colors[r2][1] + "m" : e25;
}
function tu(e25, t2) {
  return e25;
}
function ru(e25, t2, r2) {
  if (e25.customInspect && t2 && mu(t2.inspect) && t2.inspect !== Zs && (!t2.constructor || t2.constructor.prototype !== t2)) {
    var n2 = t2.inspect(r2, e25);
    return cu(n2) || (n2 = ru(e25, n2, r2)), n2;
  }
  var i2 = function(e26, t3) {
    if (lu(t3))
      return e26.stylize("undefined", "undefined");
    if (cu(t3)) {
      var r3 = "'" + JSON.stringify(t3).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return e26.stylize(r3, "string");
    }
    if (uu(t3))
      return e26.stylize("" + t3, "number");
    if (ou(t3))
      return e26.stylize("" + t3, "boolean");
    if (su(t3))
      return e26.stylize("null", "null");
  }(e25, t2);
  if (i2)
    return i2;
  var a2 = Object.keys(t2), o2 = function(e26) {
    var t3 = {};
    return e26.forEach(function(e27, r3) {
      t3[e27] = true;
    }), t3;
  }(a2);
  if (e25.showHidden && (a2 = Object.getOwnPropertyNames(t2)), du(t2) && (a2.indexOf("message") >= 0 || a2.indexOf("description") >= 0))
    return nu(t2);
  if (a2.length === 0) {
    if (mu(t2)) {
      var s2 = t2.name ? ": " + t2.name : "";
      return e25.stylize("[Function" + s2 + "]", "special");
    }
    if (pu(t2))
      return e25.stylize(RegExp.prototype.toString.call(t2), "regexp");
    if (hu(t2))
      return e25.stylize(Date.prototype.toString.call(t2), "date");
    if (du(t2))
      return nu(t2);
  }
  var u2, c2 = "", l2 = false, p2 = ["{", "}"];
  (au(t2) && (l2 = true, p2 = ["[", "]"]), mu(t2)) && (c2 = " [Function" + (t2.name ? ": " + t2.name : "") + "]");
  return pu(t2) && (c2 = " " + RegExp.prototype.toString.call(t2)), hu(t2) && (c2 = " " + Date.prototype.toUTCString.call(t2)), du(t2) && (c2 = " " + nu(t2)), a2.length !== 0 || l2 && t2.length != 0 ? r2 < 0 ? pu(t2) ? e25.stylize(RegExp.prototype.toString.call(t2), "regexp") : e25.stylize("[Object]", "special") : (e25.seen.push(t2), u2 = l2 ? function(e26, t3, r3, n3, i3) {
    for (var a3 = [], o3 = 0, s3 = t3.length; o3 < s3; ++o3)
      Eu(t3, String(o3)) ? a3.push(iu(e26, t3, r3, n3, String(o3), true)) : a3.push("");
    return i3.forEach(function(i4) {
      i4.match(/^\d+$/) || a3.push(iu(e26, t3, r3, n3, i4, true));
    }), a3;
  }(e25, t2, r2, o2, a2) : a2.map(function(n3) {
    return iu(e25, t2, r2, o2, n3, l2);
  }), e25.seen.pop(), function(e26, t3, r3) {
    if (e26.reduce(function(e27, t4) {
      return t4.indexOf("\n"), e27 + t4.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0) > 60)
      return r3[0] + (t3 === "" ? "" : t3 + "\n ") + " " + e26.join(",\n  ") + " " + r3[1];
    return r3[0] + t3 + " " + e26.join(", ") + " " + r3[1];
  }(u2, c2, p2)) : p2[0] + c2 + p2[1];
}
function nu(e25) {
  return "[" + Error.prototype.toString.call(e25) + "]";
}
function iu(e25, t2, r2, n2, i2, a2) {
  var o2, s2, u2;
  if ((u2 = Object.getOwnPropertyDescriptor(t2, i2) || { value: t2[i2] }).get ? s2 = u2.set ? e25.stylize("[Getter/Setter]", "special") : e25.stylize("[Getter]", "special") : u2.set && (s2 = e25.stylize("[Setter]", "special")), Eu(n2, i2) || (o2 = "[" + i2 + "]"), s2 || (e25.seen.indexOf(u2.value) < 0 ? (s2 = su(r2) ? ru(e25, u2.value, null) : ru(e25, u2.value, r2 - 1)).indexOf("\n") > -1 && (s2 = a2 ? s2.split("\n").map(function(e26) {
    return "  " + e26;
  }).join("\n").substr(2) : "\n" + s2.split("\n").map(function(e26) {
    return "   " + e26;
  }).join("\n")) : s2 = e25.stylize("[Circular]", "special")), lu(o2)) {
    if (a2 && i2.match(/^\d+$/))
      return s2;
    (o2 = JSON.stringify("" + i2)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o2 = o2.substr(1, o2.length - 2), o2 = e25.stylize(o2, "name")) : (o2 = o2.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o2 = e25.stylize(o2, "string"));
  }
  return o2 + ": " + s2;
}
function au(e25) {
  return Array.isArray(e25);
}
function ou(e25) {
  return typeof e25 == "boolean";
}
function su(e25) {
  return e25 === null;
}
function uu(e25) {
  return typeof e25 == "number";
}
function cu(e25) {
  return typeof e25 == "string";
}
function lu(e25) {
  return e25 === void 0;
}
function pu(e25) {
  return fu(e25) && yu(e25) === "[object RegExp]";
}
function fu(e25) {
  return i(e25) === "object" && e25 !== null;
}
function hu(e25) {
  return fu(e25) && yu(e25) === "[object Date]";
}
function du(e25) {
  return fu(e25) && (yu(e25) === "[object Error]" || e25 instanceof Error);
}
function mu(e25) {
  return typeof e25 == "function";
}
function gu(e25) {
  return e25 === null || typeof e25 == "boolean" || typeof e25 == "number" || typeof e25 == "string" || i(e25) === "symbol" || e25 === void 0;
}
function yu(e25) {
  return Object.prototype.toString.call(e25);
}
function vu(e25) {
  return e25 < 10 ? "0" + e25.toString(10) : e25.toString(10);
}
Zs.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, Zs.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" };
var xu = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function bu(e25, t2) {
  if (!t2 || !fu(t2))
    return e25;
  for (var r2 = Object.keys(t2), n2 = r2.length; n2--; )
    e25[r2[n2]] = t2[r2[n2]];
  return e25;
}
function Eu(e25, t2) {
  return Object.prototype.hasOwnProperty.call(e25, t2);
}
var Cu = { inherits: Ks, _extend: bu, log: function() {
  console.log("%s - %s", function() {
    var e25 = new Date(), t2 = [vu(e25.getHours()), vu(e25.getMinutes()), vu(e25.getSeconds())].join(":");
    return [e25.getDate(), xu[e25.getMonth()], t2].join(" ");
  }(), Qs.apply(null, arguments));
}, isBuffer: function(e25) {
  return Buffer.isBuffer(e25);
}, isPrimitive: gu, isFunction: mu, isError: du, isDate: hu, isObject: fu, isRegExp: pu, isUndefined: lu, isSymbol: function(e25) {
  return i(e25) === "symbol";
}, isString: cu, isNumber: uu, isNullOrUndefined: function(e25) {
  return e25 == null;
}, isNull: su, isBoolean: ou, isArray: au, inspect: Zs, deprecate: function e10(t2, r2) {
  if (lu(global.process))
    return function() {
      return e10(t2, r2).apply(this, arguments);
    };
  var n2 = false;
  return function() {
    return n2 || (console.error(r2), n2 = true), t2.apply(this, arguments);
  };
}, format: Qs, debuglog: function(e25) {
  if (lu(Xs) && (Xs = ""), e25 = e25.toUpperCase(), !Ys[e25])
    if (new RegExp("\\b" + e25 + "\\b", "i").test(Xs)) {
      Ys[e25] = function() {
        var t2 = Qs.apply(null, arguments);
        console.error("%s %d: %s", e25, 0, t2);
      };
    } else
      Ys[e25] = function() {
      };
  return Ys[e25];
} };
function Su(e25, t2) {
  if (e25 === t2)
    return 0;
  for (var r2 = e25.length, n2 = t2.length, i2 = 0, a2 = Math.min(r2, n2); i2 < a2; ++i2)
    if (e25[i2] !== t2[i2]) {
      r2 = e25[i2], n2 = t2[i2];
      break;
    }
  return r2 < n2 ? -1 : n2 < r2 ? 1 : 0;
}
var ku, Du = Object.prototype.hasOwnProperty, Fu = Object.keys || function(e25) {
  var t2 = [];
  for (var r2 in e25)
    Du.call(e25, r2) && t2.push(r2);
  return t2;
}, Au = Array.prototype.slice;
function wu() {
  return ku !== void 0 ? ku : ku = function() {
  }.name === "foo";
}
function _u(e25) {
  return Object.prototype.toString.call(e25);
}
function Tu(e25) {
  return !zs(e25) && (typeof global.ArrayBuffer == "function" && (typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e25) : !!e25 && (e25 instanceof DataView || !!(e25.buffer && e25.buffer instanceof ArrayBuffer))));
}
function Pu(e25, t2) {
  e25 || ju(e25, true, t2, "==", Ru);
}
var Iu = /\s*function\s+([^\(\s]*)\s*/;
function Bu(e25) {
  if (mu(e25)) {
    if (wu())
      return e25.name;
    var t2 = e25.toString().match(Iu);
    return t2 && t2[1];
  }
}
function Ou(e25) {
  this.name = "AssertionError", this.actual = e25.actual, this.expected = e25.expected, this.operator = e25.operator, e25.message ? (this.message = e25.message, this.generatedMessage = false) : (this.message = function(e26) {
    return Lu(Nu(e26.actual), 128) + " " + e26.operator + " " + Lu(Nu(e26.expected), 128);
  }(this), this.generatedMessage = true);
  var t2 = e25.stackStartFunction || ju;
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, t2);
  else {
    var r2 = new Error();
    if (r2.stack) {
      var n2 = r2.stack, i2 = Bu(t2), a2 = n2.indexOf("\n" + i2);
      if (a2 >= 0) {
        var o2 = n2.indexOf("\n", a2 + 1);
        n2 = n2.substring(o2 + 1);
      }
      this.stack = n2;
    }
  }
}
function Lu(e25, t2) {
  return typeof e25 == "string" ? e25.length < t2 ? e25 : e25.slice(0, t2) : e25;
}
function Nu(e25) {
  if (wu() || !mu(e25))
    return Zs(e25);
  var t2 = Bu(e25);
  return "[Function" + (t2 ? ": " + t2 : "") + "]";
}
function ju(e25, t2, r2, n2, i2) {
  throw new Ou({ message: r2, actual: e25, expected: t2, operator: n2, stackStartFunction: i2 });
}
function Ru(e25, t2) {
  e25 || ju(e25, true, t2, "==", Ru);
}
function Mu(e25, t2, r2, n2) {
  if (e25 === t2)
    return true;
  if (zs(e25) && zs(t2))
    return Su(e25, t2) === 0;
  if (hu(e25) && hu(t2))
    return e25.getTime() === t2.getTime();
  if (pu(e25) && pu(t2))
    return e25.source === t2.source && e25.global === t2.global && e25.multiline === t2.multiline && e25.lastIndex === t2.lastIndex && e25.ignoreCase === t2.ignoreCase;
  if (e25 !== null && i(e25) === "object" || t2 !== null && i(t2) === "object") {
    if (Tu(e25) && Tu(t2) && _u(e25) === _u(t2) && !(e25 instanceof Float32Array || e25 instanceof Float64Array))
      return Su(new Uint8Array(e25.buffer), new Uint8Array(t2.buffer)) === 0;
    if (zs(e25) !== zs(t2))
      return false;
    var a2 = (n2 = n2 || { actual: [], expected: [] }).actual.indexOf(e25);
    return a2 !== -1 && a2 === n2.expected.indexOf(t2) || (n2.actual.push(e25), n2.expected.push(t2), function(e26, t3, r3, n3) {
      if (e26 == null || t3 == null)
        return false;
      if (gu(e26) || gu(t3))
        return e26 === t3;
      if (r3 && Object.getPrototypeOf(e26) !== Object.getPrototypeOf(t3))
        return false;
      var i2 = Vu(e26), a3 = Vu(t3);
      if (i2 && !a3 || !i2 && a3)
        return false;
      if (i2)
        return e26 = Au.call(e26), t3 = Au.call(t3), Mu(e26, t3, r3);
      var o2, s2, u2 = Fu(e26), c2 = Fu(t3);
      if (u2.length !== c2.length)
        return false;
      for (u2.sort(), c2.sort(), s2 = u2.length - 1; s2 >= 0; s2--)
        if (u2[s2] !== c2[s2])
          return false;
      for (s2 = u2.length - 1; s2 >= 0; s2--)
        if (o2 = u2[s2], !Mu(e26[o2], t3[o2], r3, n3))
          return false;
      return true;
    }(e25, t2, r2, n2));
  }
  return r2 ? e25 === t2 : e25 == t2;
}
function Vu(e25) {
  return Object.prototype.toString.call(e25) == "[object Arguments]";
}
function Uu(e25, t2) {
  if (!e25 || !t2)
    return false;
  if (Object.prototype.toString.call(t2) == "[object RegExp]")
    return t2.test(e25);
  try {
    if (e25 instanceof t2)
      return true;
  } catch (e26) {
  }
  return !Error.isPrototypeOf(t2) && t2.call({}, e25) === true;
}
function qu(e25, t2, r2, n2) {
  var i2;
  if (typeof t2 != "function")
    throw new TypeError('"block" argument must be a function');
  typeof r2 == "string" && (n2 = r2, r2 = null), i2 = function(e26) {
    var t3;
    try {
      e26();
    } catch (e27) {
      t3 = e27;
    }
    return t3;
  }(t2), n2 = (r2 && r2.name ? " (" + r2.name + ")." : ".") + (n2 ? " " + n2 : "."), e25 && !i2 && ju(i2, r2, "Missing expected exception" + n2);
  var a2 = typeof n2 == "string", o2 = !e25 && i2 && !r2;
  if ((!e25 && du(i2) && a2 && Uu(i2, r2) || o2) && ju(i2, r2, "Got unwanted exception" + n2), e25 && i2 && r2 && !Uu(i2, r2) || !e25 && i2)
    throw i2;
}
Pu.AssertionError = Ou, Ks(Ou, Error), Pu.fail = ju, Pu.ok = Ru, Pu.equal = function e11(t2, r2, n2) {
  t2 != r2 && ju(t2, r2, n2, "==", e11);
}, Pu.notEqual = function e12(t2, r2, n2) {
  t2 == r2 && ju(t2, r2, n2, "!=", e12);
}, Pu.deepEqual = function e13(t2, r2, n2) {
  Mu(t2, r2, false) || ju(t2, r2, n2, "deepEqual", e13);
}, Pu.deepStrictEqual = function e14(t2, r2, n2) {
  Mu(t2, r2, true) || ju(t2, r2, n2, "deepStrictEqual", e14);
}, Pu.notDeepEqual = function e15(t2, r2, n2) {
  Mu(t2, r2, false) && ju(t2, r2, n2, "notDeepEqual", e15);
}, Pu.notDeepStrictEqual = function e16(t2, r2, n2) {
  Mu(t2, r2, true) && ju(t2, r2, n2, "notDeepStrictEqual", e16);
}, Pu.strictEqual = function e17(t2, r2, n2) {
  t2 !== r2 && ju(t2, r2, n2, "===", e17);
}, Pu.notStrictEqual = function e18(t2, r2, n2) {
  t2 === r2 && ju(t2, r2, n2, "!==", e18);
}, Pu.throws = function(e25, t2, r2) {
  qu(true, e25, t2, r2);
}, Pu.doesNotThrow = function(e25, t2, r2) {
  qu(false, e25, t2, r2);
}, Pu.ifError = function(e25) {
  if (e25)
    throw e25;
};
var Wu = "ECMAScript JS AST traversal functions", $u = "https://github.com/estools/estraverse", Gu = "estraverse.js", zu = { node: ">=4.0" }, Hu = [{ name: "Yusuke Suzuki", email: "utatane.tea@gmail.com", web: "http://github.com/Constellation" }], Ku = { type: "git", url: "http://github.com/estools/estraverse.git" }, Ju = { "babel-preset-env": "^1.6.1", "babel-register": "^6.3.13", chai: "^2.1.1", espree: "^1.11.0", gulp: "^3.8.10", "gulp-bump": "^0.2.2", "gulp-filter": "^2.0.0", "gulp-git": "^1.0.1", "gulp-tag-version": "^1.3.0", jshint: "^2.5.6", mocha: "^2.1.0" }, Qu = { test: "npm run-script lint && npm run-script unit-test", lint: "jshint estraverse.js", "unit-test": "mocha --compilers js:babel-register" }, Xu = { name: "estraverse", description: Wu, homepage: $u, main: Gu, version: "4.3.0", engines: zu, maintainers: Hu, repository: Ku, devDependencies: Ju, license: "BSD-2-Clause", scripts: Qu }, Yu = n(Object.freeze({ __proto__: null, name: "estraverse", description: Wu, homepage: $u, main: Gu, version: "4.3.0", engines: zu, maintainers: Hu, repository: Ku, devDependencies: Ju, license: "BSD-2-Clause", scripts: Qu, default: Xu })), Zu = r(function(e25, t2) {
  !function e26(t3) {
    var r2, n2, a2, o2, s2, u2;
    function c2(e27) {
      var t4, r3, n3 = {};
      for (t4 in e27)
        e27.hasOwnProperty(t4) && (i(r3 = e27[t4]) === "object" && r3 !== null ? n3[t4] = c2(r3) : n3[t4] = r3);
      return n3;
    }
    function l2(e27, t4) {
      this.parent = e27, this.key = t4;
    }
    function p2(e27, t4, r3, n3) {
      this.node = e27, this.path = t4, this.wrap = r3, this.ref = n3;
    }
    function f2() {
    }
    function h2(e27) {
      return e27 != null && (i(e27) === "object" && typeof e27.type == "string");
    }
    function d2(e27, t4) {
      return (e27 === r2.ObjectExpression || e27 === r2.ObjectPattern) && t4 === "properties";
    }
    function m2(e27, t4) {
      return new f2().traverse(e27, t4);
    }
    function g2(e27, t4) {
      var r3;
      return r3 = function(e28, t5) {
        var r4, n3, i2, a3;
        for (n3 = e28.length, i2 = 0; n3; )
          t5(e28[a3 = i2 + (r4 = n3 >>> 1)]) ? n3 = r4 : (i2 = a3 + 1, n3 -= r4 + 1);
        return i2;
      }(t4, function(t5) {
        return t5.range[0] > e27.range[0];
      }), e27.extendedRange = [e27.range[0], e27.range[1]], r3 !== t4.length && (e27.extendedRange[1] = t4[r3].range[0]), (r3 -= 1) >= 0 && (e27.extendedRange[0] = t4[r3].range[1]), e27;
    }
    return r2 = { AssignmentExpression: "AssignmentExpression", AssignmentPattern: "AssignmentPattern", ArrayExpression: "ArrayExpression", ArrayPattern: "ArrayPattern", ArrowFunctionExpression: "ArrowFunctionExpression", AwaitExpression: "AwaitExpression", BlockStatement: "BlockStatement", BinaryExpression: "BinaryExpression", BreakStatement: "BreakStatement", CallExpression: "CallExpression", CatchClause: "CatchClause", ClassBody: "ClassBody", ClassDeclaration: "ClassDeclaration", ClassExpression: "ClassExpression", ComprehensionBlock: "ComprehensionBlock", ComprehensionExpression: "ComprehensionExpression", ConditionalExpression: "ConditionalExpression", ContinueStatement: "ContinueStatement", DebuggerStatement: "DebuggerStatement", DirectiveStatement: "DirectiveStatement", DoWhileStatement: "DoWhileStatement", EmptyStatement: "EmptyStatement", ExportAllDeclaration: "ExportAllDeclaration", ExportDefaultDeclaration: "ExportDefaultDeclaration", ExportNamedDeclaration: "ExportNamedDeclaration", ExportSpecifier: "ExportSpecifier", ExpressionStatement: "ExpressionStatement", ForStatement: "ForStatement", ForInStatement: "ForInStatement", ForOfStatement: "ForOfStatement", FunctionDeclaration: "FunctionDeclaration", FunctionExpression: "FunctionExpression", GeneratorExpression: "GeneratorExpression", Identifier: "Identifier", IfStatement: "IfStatement", ImportExpression: "ImportExpression", ImportDeclaration: "ImportDeclaration", ImportDefaultSpecifier: "ImportDefaultSpecifier", ImportNamespaceSpecifier: "ImportNamespaceSpecifier", ImportSpecifier: "ImportSpecifier", Literal: "Literal", LabeledStatement: "LabeledStatement", LogicalExpression: "LogicalExpression", MemberExpression: "MemberExpression", MetaProperty: "MetaProperty", MethodDefinition: "MethodDefinition", ModuleSpecifier: "ModuleSpecifier", NewExpression: "NewExpression", ObjectExpression: "ObjectExpression", ObjectPattern: "ObjectPattern", Program: "Program", Property: "Property", RestElement: "RestElement", ReturnStatement: "ReturnStatement", SequenceExpression: "SequenceExpression", SpreadElement: "SpreadElement", Super: "Super", SwitchStatement: "SwitchStatement", SwitchCase: "SwitchCase", TaggedTemplateExpression: "TaggedTemplateExpression", TemplateElement: "TemplateElement", TemplateLiteral: "TemplateLiteral", ThisExpression: "ThisExpression", ThrowStatement: "ThrowStatement", TryStatement: "TryStatement", UnaryExpression: "UnaryExpression", UpdateExpression: "UpdateExpression", VariableDeclaration: "VariableDeclaration", VariableDeclarator: "VariableDeclarator", WhileStatement: "WhileStatement", WithStatement: "WithStatement", YieldExpression: "YieldExpression" }, a2 = { AssignmentExpression: ["left", "right"], AssignmentPattern: ["left", "right"], ArrayExpression: ["elements"], ArrayPattern: ["elements"], ArrowFunctionExpression: ["params", "body"], AwaitExpression: ["argument"], BlockStatement: ["body"], BinaryExpression: ["left", "right"], BreakStatement: ["label"], CallExpression: ["callee", "arguments"], CatchClause: ["param", "body"], ClassBody: ["body"], ClassDeclaration: ["id", "superClass", "body"], ClassExpression: ["id", "superClass", "body"], ComprehensionBlock: ["left", "right"], ComprehensionExpression: ["blocks", "filter", "body"], ConditionalExpression: ["test", "consequent", "alternate"], ContinueStatement: ["label"], DebuggerStatement: [], DirectiveStatement: [], DoWhileStatement: ["body", "test"], EmptyStatement: [], ExportAllDeclaration: ["source"], ExportDefaultDeclaration: ["declaration"], ExportNamedDeclaration: ["declaration", "specifiers", "source"], ExportSpecifier: ["exported", "local"], ExpressionStatement: ["expression"], ForStatement: ["init", "test", "update", "body"], ForInStatement: ["left", "right", "body"], ForOfStatement: ["left", "right", "body"], FunctionDeclaration: ["id", "params", "body"], FunctionExpression: ["id", "params", "body"], GeneratorExpression: ["blocks", "filter", "body"], Identifier: [], IfStatement: ["test", "consequent", "alternate"], ImportExpression: ["source"], ImportDeclaration: ["specifiers", "source"], ImportDefaultSpecifier: ["local"], ImportNamespaceSpecifier: ["local"], ImportSpecifier: ["imported", "local"], Literal: [], LabeledStatement: ["label", "body"], LogicalExpression: ["left", "right"], MemberExpression: ["object", "property"], MetaProperty: ["meta", "property"], MethodDefinition: ["key", "value"], ModuleSpecifier: [], NewExpression: ["callee", "arguments"], ObjectExpression: ["properties"], ObjectPattern: ["properties"], Program: ["body"], Property: ["key", "value"], RestElement: ["argument"], ReturnStatement: ["argument"], SequenceExpression: ["expressions"], SpreadElement: ["argument"], Super: [], SwitchStatement: ["discriminant", "cases"], SwitchCase: ["test", "consequent"], TaggedTemplateExpression: ["tag", "quasi"], TemplateElement: [], TemplateLiteral: ["quasis", "expressions"], ThisExpression: [], ThrowStatement: ["argument"], TryStatement: ["block", "handler", "finalizer"], UnaryExpression: ["argument"], UpdateExpression: ["argument"], VariableDeclaration: ["declarations"], VariableDeclarator: ["id", "init"], WhileStatement: ["test", "body"], WithStatement: ["object", "body"], YieldExpression: ["argument"] }, n2 = { Break: o2 = {}, Skip: s2 = {}, Remove: u2 = {} }, l2.prototype.replace = function(e27) {
      this.parent[this.key] = e27;
    }, l2.prototype.remove = function() {
      return Array.isArray(this.parent) ? (this.parent.splice(this.key, 1), true) : (this.replace(null), false);
    }, f2.prototype.path = function() {
      var e27, t4, r3, n3, i2;
      function a3(e28, t5) {
        if (Array.isArray(t5))
          for (r3 = 0, n3 = t5.length; r3 < n3; ++r3)
            e28.push(t5[r3]);
        else
          e28.push(t5);
      }
      if (!this.__current.path)
        return null;
      for (i2 = [], e27 = 2, t4 = this.__leavelist.length; e27 < t4; ++e27)
        a3(i2, this.__leavelist[e27].path);
      return a3(i2, this.__current.path), i2;
    }, f2.prototype.type = function() {
      return this.current().type || this.__current.wrap;
    }, f2.prototype.parents = function() {
      var e27, t4, r3;
      for (r3 = [], e27 = 1, t4 = this.__leavelist.length; e27 < t4; ++e27)
        r3.push(this.__leavelist[e27].node);
      return r3;
    }, f2.prototype.current = function() {
      return this.__current.node;
    }, f2.prototype.__execute = function(e27, t4) {
      var r3, n3;
      return n3 = void 0, r3 = this.__current, this.__current = t4, this.__state = null, e27 && (n3 = e27.call(this, t4.node, this.__leavelist[this.__leavelist.length - 1].node)), this.__current = r3, n3;
    }, f2.prototype.notify = function(e27) {
      this.__state = e27;
    }, f2.prototype.skip = function() {
      this.notify(s2);
    }, f2.prototype.break = function() {
      this.notify(o2);
    }, f2.prototype.remove = function() {
      this.notify(u2);
    }, f2.prototype.__initialize = function(e27, t4) {
      this.visitor = t4, this.root = e27, this.__worklist = [], this.__leavelist = [], this.__current = null, this.__state = null, this.__fallback = null, t4.fallback === "iteration" ? this.__fallback = Object.keys : typeof t4.fallback == "function" && (this.__fallback = t4.fallback), this.__keys = a2, t4.keys && (this.__keys = Object.assign(Object.create(this.__keys), t4.keys));
    }, f2.prototype.traverse = function(e27, t4) {
      var r3, n3, i2, a3, u3, c3, l3, f3, m3, g3, y2, v2;
      for (this.__initialize(e27, t4), v2 = {}, r3 = this.__worklist, n3 = this.__leavelist, r3.push(new p2(e27, null, null, null)), n3.push(new p2(null, null, null, null)); r3.length; )
        if ((i2 = r3.pop()) !== v2) {
          if (i2.node) {
            if (c3 = this.__execute(t4.enter, i2), this.__state === o2 || c3 === o2)
              return;
            if (r3.push(v2), n3.push(i2), this.__state === s2 || c3 === s2)
              continue;
            if (u3 = (a3 = i2.node).type || i2.wrap, !(g3 = this.__keys[u3])) {
              if (!this.__fallback)
                throw new Error("Unknown node type " + u3 + ".");
              g3 = this.__fallback(a3);
            }
            for (f3 = g3.length; (f3 -= 1) >= 0; )
              if (y2 = a3[l3 = g3[f3]])
                if (Array.isArray(y2)) {
                  for (m3 = y2.length; (m3 -= 1) >= 0; )
                    if (y2[m3]) {
                      if (d2(u3, g3[f3]))
                        i2 = new p2(y2[m3], [l3, m3], "Property", null);
                      else {
                        if (!h2(y2[m3]))
                          continue;
                        i2 = new p2(y2[m3], [l3, m3], null, null);
                      }
                      r3.push(i2);
                    }
                } else
                  h2(y2) && r3.push(new p2(y2, l3, null, null));
          }
        } else if (i2 = n3.pop(), c3 = this.__execute(t4.leave, i2), this.__state === o2 || c3 === o2)
          return;
    }, f2.prototype.replace = function(e27, t4) {
      var r3, n3, i2, a3, c3, f3, m3, g3, y2, v2, x2, b2, E2;
      function C2(e28) {
        var t5, n4, i3, a4;
        if (e28.ref.remove()) {
          for (n4 = e28.ref.key, a4 = e28.ref.parent, t5 = r3.length; t5--; )
            if ((i3 = r3[t5]).ref && i3.ref.parent === a4) {
              if (i3.ref.key < n4)
                break;
              --i3.ref.key;
            }
        }
      }
      for (this.__initialize(e27, t4), x2 = {}, r3 = this.__worklist, n3 = this.__leavelist, f3 = new p2(e27, null, null, new l2(b2 = { root: e27 }, "root")), r3.push(f3), n3.push(f3); r3.length; )
        if ((f3 = r3.pop()) !== x2) {
          if ((c3 = this.__execute(t4.enter, f3)) !== void 0 && c3 !== o2 && c3 !== s2 && c3 !== u2 && (f3.ref.replace(c3), f3.node = c3), this.__state !== u2 && c3 !== u2 || (C2(f3), f3.node = null), this.__state === o2 || c3 === o2)
            return b2.root;
          if ((i2 = f3.node) && (r3.push(x2), n3.push(f3), this.__state !== s2 && c3 !== s2)) {
            if (a3 = i2.type || f3.wrap, !(y2 = this.__keys[a3])) {
              if (!this.__fallback)
                throw new Error("Unknown node type " + a3 + ".");
              y2 = this.__fallback(i2);
            }
            for (m3 = y2.length; (m3 -= 1) >= 0; )
              if (v2 = i2[E2 = y2[m3]])
                if (Array.isArray(v2)) {
                  for (g3 = v2.length; (g3 -= 1) >= 0; )
                    if (v2[g3]) {
                      if (d2(a3, y2[m3]))
                        f3 = new p2(v2[g3], [E2, g3], "Property", new l2(v2, g3));
                      else {
                        if (!h2(v2[g3]))
                          continue;
                        f3 = new p2(v2[g3], [E2, g3], null, new l2(v2, g3));
                      }
                      r3.push(f3);
                    }
                } else
                  h2(v2) && r3.push(new p2(v2, E2, null, new l2(i2, E2)));
          }
        } else if (f3 = n3.pop(), (c3 = this.__execute(t4.leave, f3)) !== void 0 && c3 !== o2 && c3 !== s2 && c3 !== u2 && f3.ref.replace(c3), this.__state !== u2 && c3 !== u2 || C2(f3), this.__state === o2 || c3 === o2)
          return b2.root;
      return b2.root;
    }, t3.version = Yu.version, t3.Syntax = r2, t3.traverse = m2, t3.replace = function(e27, t4) {
      return new f2().replace(e27, t4);
    }, t3.attachComments = function(e27, t4, r3) {
      var i2, a3, o3, s3, u3 = [];
      if (!e27.range)
        throw new Error("attachComments needs range information");
      if (!r3.length) {
        if (t4.length) {
          for (o3 = 0, a3 = t4.length; o3 < a3; o3 += 1)
            (i2 = c2(t4[o3])).extendedRange = [0, e27.range[0]], u3.push(i2);
          e27.leadingComments = u3;
        }
        return e27;
      }
      for (o3 = 0, a3 = t4.length; o3 < a3; o3 += 1)
        u3.push(g2(c2(t4[o3]), r3));
      return s3 = 0, m2(e27, { enter: function(e28) {
        for (var t5; s3 < u3.length && !((t5 = u3[s3]).extendedRange[1] > e28.range[0]); )
          t5.extendedRange[1] === e28.range[0] ? (e28.leadingComments || (e28.leadingComments = []), e28.leadingComments.push(t5), u3.splice(s3, 1)) : s3 += 1;
        return s3 === u3.length ? n2.Break : u3[s3].extendedRange[0] > e28.range[1] ? n2.Skip : void 0;
      } }), s3 = 0, m2(e27, { leave: function(e28) {
        for (var t5; s3 < u3.length && (t5 = u3[s3], !(e28.range[1] < t5.extendedRange[0])); )
          e28.range[1] === t5.extendedRange[0] ? (e28.trailingComments || (e28.trailingComments = []), e28.trailingComments.push(t5), u3.splice(s3, 1)) : s3 += 1;
        return s3 === u3.length ? n2.Break : u3[s3].extendedRange[0] > e28.range[1] ? n2.Skip : void 0;
      } }), e27;
    }, t3.VisitorKeys = a2, t3.VisitorOption = n2, t3.Controller = f2, t3.cloneEnvironment = function() {
      return e26({});
    }, t3;
  }(t2);
}), ec = function() {
  function e25(t2, r2, n2, i2, o2, s2, u2) {
    a(this, e25), this.identifier = t2, this.from = r2, this.tainted = false, this.resolved = null, this.flag = n2, this.isWrite() && (this.writeExpr = i2, this.partial = s2, this.init = u2), this.__maybeImplicitGlobal = o2;
  }
  return s(e25, [{ key: "isStatic", value: function() {
    return !this.tainted && this.resolved && this.resolved.scope.isStatic();
  } }, { key: "isWrite", value: function() {
    return !!(this.flag & e25.WRITE);
  } }, { key: "isRead", value: function() {
    return !!(this.flag & e25.READ);
  } }, { key: "isReadOnly", value: function() {
    return this.flag === e25.READ;
  } }, { key: "isWriteOnly", value: function() {
    return this.flag === e25.WRITE;
  } }, { key: "isReadWrite", value: function() {
    return this.flag === e25.RW;
  } }]), e25;
}();
ec.READ = 1, ec.WRITE = 2, ec.RW = 3;
var tc = ec, rc = function e19(t2, r2) {
  a(this, e19), this.name = t2, this.identifiers = [], this.references = [], this.defs = [], this.tainted = false, this.stack = true, this.scope = r2;
};
rc.CatchClause = "CatchClause", rc.Parameter = "Parameter", rc.FunctionName = "FunctionName", rc.ClassName = "ClassName", rc.Variable = "Variable", rc.ImportBinding = "ImportBinding", rc.ImplicitGlobalVariable = "ImplicitGlobalVariable";
var nc = rc, ic = function e20(t2, r2, n2, i2, o2, s2) {
  a(this, e20), this.type = t2, this.name = r2, this.node = n2, this.parent = i2, this.index = o2, this.kind = s2;
}, ac = { ParameterDefinition: function(e25) {
  function t2(e26, r2, n2, i2) {
    var o2;
    return a(this, t2), (o2 = v(this, h(t2).call(this, nc.Parameter, e26, r2, null, n2, null))).rest = i2, o2;
  }
  return f(t2, ic), t2;
}(), Definition: ic }, oc = Zu.Syntax, sc = ac.Definition;
function uc(e25) {
  return e25.type === nc.ClassName || e25.type === nc.Variable && e25.parent.kind !== "var";
}
var cc = function() {
  function e25(t2, r2, n2, i2, o2) {
    a(this, e25), this.type = r2, this.set = new Map(), this.taints = new Map(), this.dynamic = this.type === "global" || this.type === "with", this.block = i2, this.through = [], this.variables = [], this.references = [], this.variableScope = this.type === "global" || this.type === "function" || this.type === "module" ? this : n2.variableScope, this.functionExpressionScope = false, this.directCallToEvalScope = false, this.thisFound = false, this.__left = [], this.upper = n2, this.isStrict = function(e26, t3, r3, n3) {
      var i3;
      if (e26.upper && e26.upper.isStrict)
        return true;
      if (r3)
        return true;
      if (e26.type === "class" || e26.type === "module")
        return true;
      if (e26.type === "block" || e26.type === "switch")
        return false;
      if (e26.type === "function") {
        if (t3.type === oc.ArrowFunctionExpression && t3.body.type !== oc.BlockStatement)
          return false;
        if (!(i3 = t3.type === oc.Program ? t3 : t3.body))
          return false;
      } else {
        if (e26.type !== "global")
          return false;
        i3 = t3;
      }
      if (n3)
        for (var a2 = 0, o3 = i3.body.length; a2 < o3; ++a2) {
          var s2 = i3.body[a2];
          if (s2.type !== oc.DirectiveStatement)
            break;
          if (s2.raw === '"use strict"' || s2.raw === "'use strict'")
            return true;
        }
      else
        for (var u2 = 0, c2 = i3.body.length; u2 < c2; ++u2) {
          var l2 = i3.body[u2];
          if (l2.type !== oc.ExpressionStatement)
            break;
          var p2 = l2.expression;
          if (p2.type !== oc.Literal || typeof p2.value != "string")
            break;
          if (p2.raw !== null && p2.raw !== void 0) {
            if (p2.raw === '"use strict"' || p2.raw === "'use strict'")
              return true;
          } else if (p2.value === "use strict")
            return true;
        }
      return false;
    }(this, i2, o2, t2.__useDirective()), this.childScopes = [], this.upper && this.upper.childScopes.push(this), this.__declaredVariables = t2.__declaredVariables, function(e26, t3) {
      e26.scopes.push(t3);
      var r3 = e26.__nodeToScope.get(t3.block);
      r3 ? r3.push(t3) : e26.__nodeToScope.set(t3.block, [t3]);
    }(t2, this);
  }
  return s(e25, [{ key: "__shouldStaticallyClose", value: function(e26) {
    return !this.dynamic || e26.__isOptimistic();
  } }, { key: "__shouldStaticallyCloseForGlobal", value: function(e26) {
    var t2 = e26.identifier.name;
    if (!this.set.has(t2))
      return false;
    var r2 = this.set.get(t2).defs;
    return r2.length > 0 && r2.every(uc);
  } }, { key: "__staticCloseRef", value: function(e26) {
    this.__resolve(e26) || this.__delegateToUpperScope(e26);
  } }, { key: "__dynamicCloseRef", value: function(e26) {
    var t2 = this;
    do {
      t2.through.push(e26), t2 = t2.upper;
    } while (t2);
  } }, { key: "__globalCloseRef", value: function(e26) {
    this.__shouldStaticallyCloseForGlobal(e26) ? this.__staticCloseRef(e26) : this.__dynamicCloseRef(e26);
  } }, { key: "__close", value: function(e26) {
    var t2;
    t2 = this.__shouldStaticallyClose(e26) ? this.__staticCloseRef : this.type !== "global" ? this.__dynamicCloseRef : this.__globalCloseRef;
    for (var r2 = 0, n2 = this.__left.length; r2 < n2; ++r2) {
      var i2 = this.__left[r2];
      t2.call(this, i2);
    }
    return this.__left = null, this.upper;
  } }, { key: "__isValidResolution", value: function(e26, t2) {
    return true;
  } }, { key: "__resolve", value: function(e26) {
    var t2 = e26.identifier.name;
    if (!this.set.has(t2))
      return false;
    var r2 = this.set.get(t2);
    return !!this.__isValidResolution(e26, r2) && (r2.references.push(e26), r2.stack = r2.stack && e26.from.variableScope === this.variableScope, e26.tainted && (r2.tainted = true, this.taints.set(r2.name, true)), e26.resolved = r2, true);
  } }, { key: "__delegateToUpperScope", value: function(e26) {
    this.upper && this.upper.__left.push(e26), this.through.push(e26);
  } }, { key: "__addDeclaredVariablesOfNode", value: function(e26, t2) {
    if (t2 != null) {
      var r2 = this.__declaredVariables.get(t2);
      r2 == null && (r2 = [], this.__declaredVariables.set(t2, r2)), r2.indexOf(e26) === -1 && r2.push(e26);
    }
  } }, { key: "__defineGeneric", value: function(e26, t2, r2, n2, i2) {
    var a2;
    (a2 = t2.get(e26)) || (a2 = new nc(e26, this), t2.set(e26, a2), r2.push(a2)), i2 && (a2.defs.push(i2), this.__addDeclaredVariablesOfNode(a2, i2.node), this.__addDeclaredVariablesOfNode(a2, i2.parent)), n2 && a2.identifiers.push(n2);
  } }, { key: "__define", value: function(e26, t2) {
    e26 && e26.type === oc.Identifier && this.__defineGeneric(e26.name, this.set, this.variables, e26, t2);
  } }, { key: "__referencing", value: function(e26, t2, r2, n2, i2, a2) {
    if (e26 && e26.type === oc.Identifier && e26.name !== "super") {
      var o2 = new tc(e26, this, t2 || tc.READ, r2, n2, !!i2, !!a2);
      this.references.push(o2), this.__left.push(o2);
    }
  } }, { key: "__detectEval", value: function() {
    var e26 = this;
    this.directCallToEvalScope = true;
    do {
      e26.dynamic = true, e26 = e26.upper;
    } while (e26);
  } }, { key: "__detectThis", value: function() {
    this.thisFound = true;
  } }, { key: "__isClosed", value: function() {
    return this.__left === null;
  } }, { key: "resolve", value: function(e26) {
    var t2, r2, n2;
    for (Pu(this.__isClosed(), "Scope should be closed."), Pu(e26.type === oc.Identifier, "Target should be identifier."), r2 = 0, n2 = this.references.length; r2 < n2; ++r2)
      if ((t2 = this.references[r2]).identifier === e26)
        return t2;
    return null;
  } }, { key: "isStatic", value: function() {
    return !this.dynamic;
  } }, { key: "isArgumentsMaterialized", value: function() {
    return true;
  } }, { key: "isThisMaterialized", value: function() {
    return true;
  } }, { key: "isUsedName", value: function(e26) {
    if (this.set.has(e26))
      return true;
    for (var t2 = 0, r2 = this.through.length; t2 < r2; ++t2)
      if (this.through[t2].identifier.name === e26)
        return true;
    return false;
  } }]), e25;
}(), lc = { Scope: cc, GlobalScope: function(e25) {
  function t2(e26, r2) {
    var n2;
    return a(this, t2), (n2 = v(this, h(t2).call(this, e26, "global", null, r2, false))).implicit = { set: new Map(), variables: [], left: [] }, n2;
  }
  return f(t2, cc), s(t2, [{ key: "__close", value: function(e26) {
    for (var r2 = [], n2 = 0, i2 = this.__left.length; n2 < i2; ++n2) {
      var a2 = this.__left[n2];
      a2.__maybeImplicitGlobal && !this.set.has(a2.identifier.name) && r2.push(a2.__maybeImplicitGlobal);
    }
    for (var o2 = 0, s2 = r2.length; o2 < s2; ++o2) {
      var u2 = r2[o2];
      this.__defineImplicit(u2.pattern, new sc(nc.ImplicitGlobalVariable, u2.pattern, u2.node, null, null, null));
    }
    return this.implicit.left = this.__left, x(h(t2.prototype), "__close", this).call(this, e26);
  } }, { key: "__defineImplicit", value: function(e26, t3) {
    e26 && e26.type === oc.Identifier && this.__defineGeneric(e26.name, this.implicit.set, this.implicit.variables, e26, t3);
  } }]), t2;
}(), ModuleScope: function(e25) {
  function t2(e26, r2, n2) {
    return a(this, t2), v(this, h(t2).call(this, e26, "module", r2, n2, false));
  }
  return f(t2, cc), t2;
}(), FunctionExpressionNameScope: function(e25) {
  function t2(e26, r2, n2) {
    var i2;
    return a(this, t2), (i2 = v(this, h(t2).call(this, e26, "function-expression-name", r2, n2, false))).__define(n2.id, new sc(nc.FunctionName, n2.id, n2, null, null, null)), i2.functionExpressionScope = true, i2;
  }
  return f(t2, cc), t2;
}(), CatchScope: function(e25) {
  function t2(e26, r2, n2) {
    return a(this, t2), v(this, h(t2).call(this, e26, "catch", r2, n2, false));
  }
  return f(t2, cc), t2;
}(), WithScope: function(e25) {
  function t2(e26, r2, n2) {
    return a(this, t2), v(this, h(t2).call(this, e26, "with", r2, n2, false));
  }
  return f(t2, cc), s(t2, [{ key: "__close", value: function(e26) {
    if (this.__shouldStaticallyClose(e26))
      return x(h(t2.prototype), "__close", this).call(this, e26);
    for (var r2 = 0, n2 = this.__left.length; r2 < n2; ++r2) {
      var i2 = this.__left[r2];
      i2.tainted = true, this.__delegateToUpperScope(i2);
    }
    return this.__left = null, this.upper;
  } }]), t2;
}(), BlockScope: function(e25) {
  function t2(e26, r2, n2) {
    return a(this, t2), v(this, h(t2).call(this, e26, "block", r2, n2, false));
  }
  return f(t2, cc), t2;
}(), SwitchScope: function(e25) {
  function t2(e26, r2, n2) {
    return a(this, t2), v(this, h(t2).call(this, e26, "switch", r2, n2, false));
  }
  return f(t2, cc), t2;
}(), FunctionScope: function(e25) {
  function t2(e26, r2, n2, i2) {
    var o2;
    return a(this, t2), (o2 = v(this, h(t2).call(this, e26, "function", r2, n2, i2))).block.type !== oc.ArrowFunctionExpression && o2.__defineArguments(), o2;
  }
  return f(t2, cc), s(t2, [{ key: "isArgumentsMaterialized", value: function() {
    if (this.block.type === oc.ArrowFunctionExpression)
      return false;
    if (!this.isStatic())
      return true;
    var e26 = this.set.get("arguments");
    return Pu(e26, "Always have arguments variable."), e26.tainted || e26.references.length !== 0;
  } }, { key: "isThisMaterialized", value: function() {
    return !this.isStatic() || this.thisFound;
  } }, { key: "__defineArguments", value: function() {
    this.__defineGeneric("arguments", this.set, this.variables, null, null), this.taints.set("arguments", true);
  } }, { key: "__isValidResolution", value: function(e26, t3) {
    if (this.block.type === "Program")
      return true;
    var r2 = this.block.body.range[0];
    return !(t3.scope === this && e26.identifier.range[0] < r2 && t3.defs.every(function(e27) {
      return e27.name.range[0] >= r2;
    }));
  } }]), t2;
}(), ForScope: function(e25) {
  function t2(e26, r2, n2) {
    return a(this, t2), v(this, h(t2).call(this, e26, "for", r2, n2, false));
  }
  return f(t2, cc), t2;
}(), ClassScope: function(e25) {
  function t2(e26, r2, n2) {
    return a(this, t2), v(this, h(t2).call(this, e26, "class", r2, n2, false));
  }
  return f(t2, cc), t2;
}() }, pc = lc.GlobalScope, fc = lc.CatchScope, hc = lc.WithScope, dc = lc.ModuleScope, mc = lc.ClassScope, gc = lc.SwitchScope, yc = lc.FunctionScope, vc = lc.ForScope, xc = lc.FunctionExpressionNameScope, bc = lc.BlockScope, Ec = function() {
  function e25(t2) {
    a(this, e25), this.scopes = [], this.globalScope = null, this.__nodeToScope = new WeakMap(), this.__currentScope = null, this.__options = t2, this.__declaredVariables = new WeakMap();
  }
  return s(e25, [{ key: "__useDirective", value: function() {
    return this.__options.directive;
  } }, { key: "__isOptimistic", value: function() {
    return this.__options.optimistic;
  } }, { key: "__ignoreEval", value: function() {
    return this.__options.ignoreEval;
  } }, { key: "__isNodejsScope", value: function() {
    return this.__options.nodejsScope;
  } }, { key: "isModule", value: function() {
    return this.__options.sourceType === "module";
  } }, { key: "isImpliedStrict", value: function() {
    return this.__options.impliedStrict;
  } }, { key: "isStrictModeSupported", value: function() {
    return this.__options.ecmaVersion >= 5;
  } }, { key: "__get", value: function(e26) {
    return this.__nodeToScope.get(e26);
  } }, { key: "getDeclaredVariables", value: function(e26) {
    return this.__declaredVariables.get(e26) || [];
  } }, { key: "acquire", value: function(e26, t2) {
    function r2(e27) {
      return e27.type !== "function" || !e27.functionExpressionScope;
    }
    var n2 = this.__get(e26);
    if (!n2 || n2.length === 0)
      return null;
    if (n2.length === 1)
      return n2[0];
    if (t2)
      for (var i2 = n2.length - 1; i2 >= 0; --i2) {
        var a2 = n2[i2];
        if (r2(a2))
          return a2;
      }
    else
      for (var o2 = 0, s2 = n2.length; o2 < s2; ++o2) {
        var u2 = n2[o2];
        if (r2(u2))
          return u2;
      }
    return null;
  } }, { key: "acquireAll", value: function(e26) {
    return this.__get(e26);
  } }, { key: "release", value: function(e26, t2) {
    var r2 = this.__get(e26);
    if (r2 && r2.length) {
      var n2 = r2[0].upper;
      return n2 ? this.acquire(n2.block, t2) : null;
    }
    return null;
  } }, { key: "attach", value: function() {
  } }, { key: "detach", value: function() {
  } }, { key: "__nestScope", value: function(e26) {
    return e26 instanceof pc && (Pu(this.__currentScope === null), this.globalScope = e26), this.__currentScope = e26, e26;
  } }, { key: "__nestGlobalScope", value: function(e26) {
    return this.__nestScope(new pc(this, e26));
  } }, { key: "__nestBlockScope", value: function(e26) {
    return this.__nestScope(new bc(this, this.__currentScope, e26));
  } }, { key: "__nestFunctionScope", value: function(e26, t2) {
    return this.__nestScope(new yc(this, this.__currentScope, e26, t2));
  } }, { key: "__nestForScope", value: function(e26) {
    return this.__nestScope(new vc(this, this.__currentScope, e26));
  } }, { key: "__nestCatchScope", value: function(e26) {
    return this.__nestScope(new fc(this, this.__currentScope, e26));
  } }, { key: "__nestWithScope", value: function(e26) {
    return this.__nestScope(new hc(this, this.__currentScope, e26));
  } }, { key: "__nestClassScope", value: function(e26) {
    return this.__nestScope(new mc(this, this.__currentScope, e26));
  } }, { key: "__nestSwitchScope", value: function(e26) {
    return this.__nestScope(new gc(this, this.__currentScope, e26));
  } }, { key: "__nestModuleScope", value: function(e26) {
    return this.__nestScope(new dc(this, this.__currentScope, e26));
  } }, { key: "__nestFunctionExpressionNameScope", value: function(e26) {
    return this.__nestScope(new xc(this, this.__currentScope, e26));
  } }, { key: "__isES6", value: function() {
    return this.__options.ecmaVersion >= 6;
  } }]), e25;
}(), Cc = "https://github.com/estools/esrecurse", Sc = { node: ">=4.0" }, kc = [{ name: "Yusuke Suzuki", email: "utatane.tea@gmail.com", web: "https://github.com/Constellation" }], Dc = { type: "git", url: "https://github.com/estools/esrecurse.git" }, Fc = { estraverse: "^4.1.0" }, Ac = { "babel-cli": "^6.24.1", "babel-eslint": "^7.2.3", "babel-preset-es2015": "^6.24.1", "babel-register": "^6.24.1", chai: "^4.0.2", esprima: "^4.0.0", gulp: "^3.9.0", "gulp-bump": "^2.7.0", "gulp-eslint": "^4.0.0", "gulp-filter": "^5.0.0", "gulp-git": "^2.4.1", "gulp-mocha": "^4.3.1", "gulp-tag-version": "^1.2.1", jsdoc: "^3.3.0-alpha10", minimist: "^1.1.0" }, wc = { test: "gulp travis", "unit-test": "gulp test", lint: "gulp lint" }, _c = { presets: ["es2015"] }, Tc = { name: "esrecurse", description: "ECMAScript AST recursive visitor", homepage: Cc, main: "esrecurse.js", version: "4.2.1", engines: Sc, maintainers: kc, repository: Dc, dependencies: Fc, devDependencies: Ac, license: "BSD-2-Clause", scripts: wc, babel: _c }, Pc = n(Object.freeze({ __proto__: null, name: "esrecurse", description: "ECMAScript AST recursive visitor", homepage: Cc, main: "esrecurse.js", version: "4.2.1", engines: Sc, maintainers: kc, repository: Dc, dependencies: Fc, devDependencies: Ac, license: "BSD-2-Clause", scripts: wc, babel: _c, default: Tc })), Ic = r(function(e25, t2) {
  !function() {
    var e26 = Zu;
    function r2(e27) {
      return e27 != null && (i(e27) === "object" && typeof e27.type == "string");
    }
    function n2(t3, r3) {
      return (t3 === e26.Syntax.ObjectExpression || t3 === e26.Syntax.ObjectPattern) && r3 === "properties";
    }
    function a2(t3, r3) {
      r3 = r3 || {}, this.__visitor = t3 || this, this.__childVisitorKeys = r3.childVisitorKeys ? Object.assign({}, e26.VisitorKeys, r3.childVisitorKeys) : e26.VisitorKeys, r3.fallback === "iteration" ? this.__fallback = Object.keys : typeof r3.fallback == "function" && (this.__fallback = r3.fallback);
    }
    a2.prototype.visitChildren = function(t3) {
      var i2, a3, o2, s2, u2, c2, l2;
      if (t3 != null) {
        if (i2 = t3.type || e26.Syntax.Property, !(a3 = this.__childVisitorKeys[i2])) {
          if (!this.__fallback)
            throw new Error("Unknown node type " + i2 + ".");
          a3 = this.__fallback(t3);
        }
        for (o2 = 0, s2 = a3.length; o2 < s2; ++o2)
          if (l2 = t3[a3[o2]])
            if (Array.isArray(l2))
              for (u2 = 0, c2 = l2.length; u2 < c2; ++u2)
                l2[u2] && (r2(l2[u2]) || n2(i2, a3[o2])) && this.visit(l2[u2]);
            else
              r2(l2) && this.visit(l2);
      }
    }, a2.prototype.visit = function(t3) {
      var r3;
      t3 != null && (r3 = t3.type || e26.Syntax.Property, this.__visitor[r3] ? this.__visitor[r3].call(this, t3) : this.visitChildren(t3));
    }, t2.version = Pc.version, t2.Visitor = a2, t2.visit = function(e27, t3, r3) {
      new a2(t3, r3).visit(e27);
    };
  }();
}), Bc = (Ic.version, Ic.Visitor, Ic.visit, Zu.Syntax);
var Oc = function(e25) {
  function t2(e26, r2, n2) {
    var i2;
    return a(this, t2), (i2 = v(this, h(t2).call(this, null, e26))).rootPattern = r2, i2.callback = n2, i2.assignments = [], i2.rightHandNodes = [], i2.restElements = [], i2;
  }
  return f(t2, Ic.Visitor), s(t2, null, [{ key: "isPattern", value: function(e26) {
    var t3 = e26.type;
    return t3 === Bc.Identifier || t3 === Bc.ObjectPattern || t3 === Bc.ArrayPattern || t3 === Bc.SpreadElement || t3 === Bc.RestElement || t3 === Bc.AssignmentPattern;
  } }]), s(t2, [{ key: "Identifier", value: function(e26) {
    var t3, r2 = (t3 = this.restElements)[t3.length - 1] || null;
    this.callback(e26, { topLevel: e26 === this.rootPattern, rest: r2 != null && r2.argument === e26, assignments: this.assignments });
  } }, { key: "Property", value: function(e26) {
    e26.computed && this.rightHandNodes.push(e26.key), this.visit(e26.value);
  } }, { key: "ArrayPattern", value: function(e26) {
    for (var t3 = 0, r2 = e26.elements.length; t3 < r2; ++t3) {
      var n2 = e26.elements[t3];
      this.visit(n2);
    }
  } }, { key: "AssignmentPattern", value: function(e26) {
    this.assignments.push(e26), this.visit(e26.left), this.rightHandNodes.push(e26.right), this.assignments.pop();
  } }, { key: "RestElement", value: function(e26) {
    this.restElements.push(e26), this.visit(e26.argument), this.restElements.pop();
  } }, { key: "MemberExpression", value: function(e26) {
    e26.computed && this.rightHandNodes.push(e26.property), this.rightHandNodes.push(e26.object);
  } }, { key: "SpreadElement", value: function(e26) {
    this.visit(e26.argument);
  } }, { key: "ArrayExpression", value: function(e26) {
    e26.elements.forEach(this.visit, this);
  } }, { key: "AssignmentExpression", value: function(e26) {
    this.assignments.push(e26), this.visit(e26.left), this.rightHandNodes.push(e26.right), this.assignments.pop();
  } }, { key: "CallExpression", value: function(e26) {
    var t3 = this;
    e26.arguments.forEach(function(e27) {
      t3.rightHandNodes.push(e27);
    }), this.visit(e26.callee);
  } }]), t2;
}(), Lc = Zu.Syntax, Nc = ac.ParameterDefinition, jc = ac.Definition;
var Rc = function(e25) {
  function t2(e26, r2) {
    var n2;
    return a(this, t2), (n2 = v(this, h(t2).call(this, null, r2.options))).declaration = e26, n2.referencer = r2, n2;
  }
  return f(t2, Ic.Visitor), s(t2, [{ key: "visitImport", value: function(e26, t3) {
    var r2 = this;
    this.referencer.visitPattern(e26, function(e27) {
      r2.referencer.currentScope().__define(e27, new jc(nc.ImportBinding, e27, t3, r2.declaration, null, null));
    });
  } }, { key: "ImportNamespaceSpecifier", value: function(e26) {
    var t3 = e26.local || e26.id;
    t3 && this.visitImport(t3, e26);
  } }, { key: "ImportDefaultSpecifier", value: function(e26) {
    var t3 = e26.local || e26.id;
    this.visitImport(t3, e26);
  } }, { key: "ImportSpecifier", value: function(e26) {
    var t3 = e26.local || e26.id;
    e26.name ? this.visitImport(e26.name, e26) : this.visitImport(t3, e26);
  } }]), t2;
}(), Mc = function(e25) {
  function t2(e26, r2) {
    var n2;
    return a(this, t2), (n2 = v(this, h(t2).call(this, null, e26))).options = e26, n2.scopeManager = r2, n2.parent = null, n2.isInnerMethodDefinition = false, n2;
  }
  return f(t2, Ic.Visitor), s(t2, [{ key: "currentScope", value: function() {
    return this.scopeManager.__currentScope;
  } }, { key: "close", value: function(e26) {
    for (; this.currentScope() && e26 === this.currentScope().block; )
      this.scopeManager.__currentScope = this.currentScope().__close(this.scopeManager);
  } }, { key: "pushInnerMethodDefinition", value: function(e26) {
    var t3 = this.isInnerMethodDefinition;
    return this.isInnerMethodDefinition = e26, t3;
  } }, { key: "popInnerMethodDefinition", value: function(e26) {
    this.isInnerMethodDefinition = e26;
  } }, { key: "referencingDefaultValue", value: function(e26, t3, r2, n2) {
    var i2 = this.currentScope();
    t3.forEach(function(t4) {
      i2.__referencing(e26, tc.WRITE, t4.right, r2, e26 !== t4.left, n2);
    });
  } }, { key: "visitPattern", value: function(e26, t3, r2) {
    var n2 = t3, i2 = r2;
    typeof t3 == "function" && (i2 = t3, n2 = { processRightHandNodes: false }), function(e27, t4, r3, n3) {
      var i3 = new Oc(e27, t4, n3);
      i3.visit(t4), r3 != null && i3.rightHandNodes.forEach(r3.visit, r3);
    }(this.options, e26, n2.processRightHandNodes ? this : null, i2);
  } }, { key: "visitFunction", value: function(e26) {
    var t3, r2, n2 = this;
    e26.type === Lc.FunctionDeclaration && this.currentScope().__define(e26.id, new jc(nc.FunctionName, e26.id, e26, null, null, null)), e26.type === Lc.FunctionExpression && e26.id && this.scopeManager.__nestFunctionExpressionNameScope(e26), this.scopeManager.__nestFunctionScope(e26, this.isInnerMethodDefinition);
    var i2 = this;
    function a2(r3, n3) {
      i2.currentScope().__define(r3, new Nc(r3, e26, t3, n3.rest)), i2.referencingDefaultValue(r3, n3.assignments, null, true);
    }
    for (t3 = 0, r2 = e26.params.length; t3 < r2; ++t3)
      this.visitPattern(e26.params[t3], { processRightHandNodes: true }, a2);
    e26.rest && this.visitPattern({ type: "RestElement", argument: e26.rest }, function(t4) {
      n2.currentScope().__define(t4, new Nc(t4, e26, e26.params.length, true));
    }), e26.body && (e26.body.type === Lc.BlockStatement ? this.visitChildren(e26.body) : this.visit(e26.body)), this.close(e26);
  } }, { key: "visitClass", value: function(e26) {
    e26.type === Lc.ClassDeclaration && this.currentScope().__define(e26.id, new jc(nc.ClassName, e26.id, e26, null, null, null)), this.visit(e26.superClass), this.scopeManager.__nestClassScope(e26), e26.id && this.currentScope().__define(e26.id, new jc(nc.ClassName, e26.id, e26)), this.visit(e26.body), this.close(e26);
  } }, { key: "visitProperty", value: function(e26) {
    var t3;
    e26.computed && this.visit(e26.key);
    var r2 = e26.type === Lc.MethodDefinition;
    r2 && (t3 = this.pushInnerMethodDefinition(true)), this.visit(e26.value), r2 && this.popInnerMethodDefinition(t3);
  } }, { key: "visitForIn", value: function(e26) {
    var t3 = this;
    e26.left.type === Lc.VariableDeclaration && e26.left.kind !== "var" && this.scopeManager.__nestForScope(e26), e26.left.type === Lc.VariableDeclaration ? (this.visit(e26.left), this.visitPattern(e26.left.declarations[0].id, function(r2) {
      t3.currentScope().__referencing(r2, tc.WRITE, e26.right, null, true, true);
    })) : this.visitPattern(e26.left, { processRightHandNodes: true }, function(r2, n2) {
      var i2 = null;
      t3.currentScope().isStrict || (i2 = { pattern: r2, node: e26 }), t3.referencingDefaultValue(r2, n2.assignments, i2, false), t3.currentScope().__referencing(r2, tc.WRITE, e26.right, i2, true, false);
    }), this.visit(e26.right), this.visit(e26.body), this.close(e26);
  } }, { key: "visitVariableDeclaration", value: function(e26, t3, r2, n2) {
    var i2 = this, a2 = r2.declarations[n2], o2 = a2.init;
    this.visitPattern(a2.id, { processRightHandNodes: true }, function(s2, u2) {
      e26.__define(s2, new jc(t3, s2, a2, r2, n2, r2.kind)), i2.referencingDefaultValue(s2, u2.assignments, null, true), o2 && i2.currentScope().__referencing(s2, tc.WRITE, o2, null, !u2.topLevel, true);
    });
  } }, { key: "AssignmentExpression", value: function(e26) {
    var t3 = this;
    Oc.isPattern(e26.left) ? e26.operator === "=" ? this.visitPattern(e26.left, { processRightHandNodes: true }, function(r2, n2) {
      var i2 = null;
      t3.currentScope().isStrict || (i2 = { pattern: r2, node: e26 }), t3.referencingDefaultValue(r2, n2.assignments, i2, false), t3.currentScope().__referencing(r2, tc.WRITE, e26.right, i2, !n2.topLevel, false);
    }) : this.currentScope().__referencing(e26.left, tc.RW, e26.right) : this.visit(e26.left), this.visit(e26.right);
  } }, { key: "CatchClause", value: function(e26) {
    var t3 = this;
    this.scopeManager.__nestCatchScope(e26), this.visitPattern(e26.param, { processRightHandNodes: true }, function(r2, n2) {
      t3.currentScope().__define(r2, new jc(nc.CatchClause, e26.param, e26, null, null, null)), t3.referencingDefaultValue(r2, n2.assignments, null, true);
    }), this.visit(e26.body), this.close(e26);
  } }, { key: "Program", value: function(e26) {
    this.scopeManager.__nestGlobalScope(e26), this.scopeManager.__isNodejsScope() && (this.currentScope().isStrict = false, this.scopeManager.__nestFunctionScope(e26, false)), this.scopeManager.__isES6() && this.scopeManager.isModule() && this.scopeManager.__nestModuleScope(e26), this.scopeManager.isStrictModeSupported() && this.scopeManager.isImpliedStrict() && (this.currentScope().isStrict = true), this.visitChildren(e26), this.close(e26);
  } }, { key: "Identifier", value: function(e26) {
    this.currentScope().__referencing(e26);
  } }, { key: "UpdateExpression", value: function(e26) {
    Oc.isPattern(e26.argument) ? this.currentScope().__referencing(e26.argument, tc.RW, null) : this.visitChildren(e26);
  } }, { key: "MemberExpression", value: function(e26) {
    this.visit(e26.object), e26.computed && this.visit(e26.property);
  } }, { key: "Property", value: function(e26) {
    this.visitProperty(e26);
  } }, { key: "MethodDefinition", value: function(e26) {
    this.visitProperty(e26);
  } }, { key: "BreakStatement", value: function() {
  } }, { key: "ContinueStatement", value: function() {
  } }, { key: "LabeledStatement", value: function(e26) {
    this.visit(e26.body);
  } }, { key: "ForStatement", value: function(e26) {
    e26.init && e26.init.type === Lc.VariableDeclaration && e26.init.kind !== "var" && this.scopeManager.__nestForScope(e26), this.visitChildren(e26), this.close(e26);
  } }, { key: "ClassExpression", value: function(e26) {
    this.visitClass(e26);
  } }, { key: "ClassDeclaration", value: function(e26) {
    this.visitClass(e26);
  } }, { key: "CallExpression", value: function(e26) {
    this.scopeManager.__ignoreEval() || e26.callee.type !== Lc.Identifier || e26.callee.name !== "eval" || this.currentScope().variableScope.__detectEval(), this.visitChildren(e26);
  } }, { key: "BlockStatement", value: function(e26) {
    this.scopeManager.__isES6() && this.scopeManager.__nestBlockScope(e26), this.visitChildren(e26), this.close(e26);
  } }, { key: "ThisExpression", value: function() {
    this.currentScope().variableScope.__detectThis();
  } }, { key: "WithStatement", value: function(e26) {
    this.visit(e26.object), this.scopeManager.__nestWithScope(e26), this.visit(e26.body), this.close(e26);
  } }, { key: "VariableDeclaration", value: function(e26) {
    for (var t3 = e26.kind === "var" ? this.currentScope().variableScope : this.currentScope(), r2 = 0, n2 = e26.declarations.length; r2 < n2; ++r2) {
      var i2 = e26.declarations[r2];
      this.visitVariableDeclaration(t3, nc.Variable, e26, r2), i2.init && this.visit(i2.init);
    }
  } }, { key: "SwitchStatement", value: function(e26) {
    this.visit(e26.discriminant), this.scopeManager.__isES6() && this.scopeManager.__nestSwitchScope(e26);
    for (var t3 = 0, r2 = e26.cases.length; t3 < r2; ++t3)
      this.visit(e26.cases[t3]);
    this.close(e26);
  } }, { key: "FunctionDeclaration", value: function(e26) {
    this.visitFunction(e26);
  } }, { key: "FunctionExpression", value: function(e26) {
    this.visitFunction(e26);
  } }, { key: "ForOfStatement", value: function(e26) {
    this.visitForIn(e26);
  } }, { key: "ForInStatement", value: function(e26) {
    this.visitForIn(e26);
  } }, { key: "ArrowFunctionExpression", value: function(e26) {
    this.visitFunction(e26);
  } }, { key: "ImportDeclaration", value: function(e26) {
    Pu(this.scopeManager.__isES6() && this.scopeManager.isModule(), "ImportDeclaration should appear when the mode is ES6 and in the module context."), new Rc(e26, this).visit(e26);
  } }, { key: "visitExportDeclaration", value: function(e26) {
    e26.source || (e26.declaration ? this.visit(e26.declaration) : this.visitChildren(e26));
  } }, { key: "ExportDeclaration", value: function(e26) {
    this.visitExportDeclaration(e26);
  } }, { key: "ExportNamedDeclaration", value: function(e26) {
    this.visitExportDeclaration(e26);
  } }, { key: "ExportSpecifier", value: function(e26) {
    var t3 = e26.id || e26.local;
    this.visit(t3);
  } }, { key: "MetaProperty", value: function() {
  } }]), t2;
}(), Vc = "http://github.com/eslint/eslint-scope", Uc = { node: ">=8.0.0" }, qc = { url: "https://github.com/eslint/eslint-scope/issues" }, Wc = { test: "node Makefile.js test", lint: "node Makefile.js lint", "generate-release": "eslint-generate-release", "generate-alpharelease": "eslint-generate-prerelease alpha", "generate-betarelease": "eslint-generate-prerelease beta", "generate-rcrelease": "eslint-generate-prerelease rc", "publish-release": "eslint-publish-release" }, $c = ["LICENSE", "README.md", "lib"], Gc = { esrecurse: "^4.1.0", estraverse: "^4.1.1" }, zc = { "@typescript-eslint/parser": "^1.11.0", chai: "^4.2.0", eslint: "^6.0.1", "eslint-config-eslint": "^5.0.1", "eslint-plugin-node": "^9.1.0", "eslint-release": "^1.0.0", espree: "^6.0.0", istanbul: "^0.4.5", mocha: "^6.1.4", "npm-license": "^0.3.3", shelljs: "^0.8.3", typescript: "^3.5.2" }, Hc = { name: "eslint-scope", description: "ECMAScript scope analyzer for ESLint", homepage: Vc, main: "lib/index.js", version: "5.0.0", engines: Uc, repository: "eslint/eslint-scope", bugs: qc, license: "BSD-2-Clause", scripts: Wc, files: $c, dependencies: Gc, devDependencies: zc }, Kc = n(Object.freeze({ __proto__: null, name: "eslint-scope", description: "ECMAScript scope analyzer for ESLint", homepage: Vc, main: "lib/index.js", version: "5.0.0", engines: Uc, repository: "eslint/eslint-scope", bugs: qc, license: "BSD-2-Clause", scripts: Wc, files: $c, dependencies: Gc, devDependencies: zc, default: Hc })), Jc = lc.Scope;
var Qc = { version: Kc.version, Reference: tc, Variable: nc, Scope: Jc, ScopeManager: Ec, analyze: function(e25, t2) {
  var r2 = function e26(t3, r3) {
    function n3(e27) {
      return i(e27) === "object" && e27 instanceof Object && !(e27 instanceof Array) && !(e27 instanceof RegExp);
    }
    for (var a2 in r3)
      if (Object.prototype.hasOwnProperty.call(r3, a2)) {
        var o2 = r3[a2];
        n3(o2) ? n3(t3[a2]) ? e26(t3[a2], o2) : t3[a2] = e26({}, o2) : t3[a2] = o2;
      }
    return t3;
  }({ optimistic: false, directive: false, nodejsScope: false, impliedStrict: false, sourceType: "script", ecmaVersion: 5, childVisitorKeys: null, fallback: "iteration" }, t2), n2 = new Ec(r2);
  return new Mc(r2, n2).visit(e25), Pu(n2.__currentScope === null, "currentScope should be null."), n2;
} }, Xc = ["left", "right"], Yc = ["left", "right"], Zc = ["elements"], el = ["elements"], tl = ["params", "body"], rl = ["argument"], nl$1 = ["body"], il = ["left", "right"], al = ["label"], ol = ["callee", "arguments"], sl = ["param", "body"], ul = ["body"], cl = ["id", "superClass", "body"], ll = ["id", "superClass", "body"], pl = ["test", "consequent", "alternate"], fl = ["label"], hl = [], dl = ["body", "test"], ml = [], gl = ["source"], yl = ["declaration"], vl = ["declaration", "specifiers", "source"], xl = ["exported", "local"], bl = ["expression"], El = ["argument"], Cl = ["argument"], Sl = ["init", "test", "update", "body"], kl = ["left", "right", "body"], Dl = ["left", "right", "body"], Fl = ["id", "params", "body"], Al = ["id", "params", "body"], wl = [], _l = ["test", "consequent", "alternate"], Tl = ["specifiers", "source"], Pl = ["local"], Il = ["source"], Bl = ["local"], Ol = ["imported", "local"], Ll = ["name", "value"], Nl = ["name"], jl = ["openingElement", "children", "closingElement"], Rl = [], Ml = ["expression"], Vl = [], Ul = ["object", "property"], ql = ["namespace", "name"], Wl = ["name", "attributes"], $l = ["argument"], Gl = [], zl = ["openingFragment", "children", "closingFragment"], Hl = [], Kl = ["label", "body"], Jl = ["left", "right"], Ql = ["object", "property"], Xl = ["meta", "property"], Yl = ["key", "value"], Zl = ["callee", "arguments"], ep = ["properties"], tp = ["properties"], rp = ["body"], np = ["key", "value"], ip = ["argument"], ap = ["argument"], op = ["expressions"], sp = ["argument"], up = [], cp = ["discriminant", "cases"], lp = ["test", "consequent"], pp = ["tag", "quasi"], fp = [], hp = ["quasis", "expressions"], dp = [], mp = ["argument"], gp = ["block", "handler", "finalizer"], yp = ["argument"], vp = ["argument"], xp = ["declarations"], bp = ["id", "init"], Ep = ["test", "body"], Cp = ["object", "body"], Sp = ["argument"], kp = { AssignmentExpression: Xc, AssignmentPattern: Yc, ArrayExpression: Zc, ArrayPattern: el, ArrowFunctionExpression: tl, AwaitExpression: rl, BlockStatement: nl$1, BinaryExpression: il, BreakStatement: al, CallExpression: ol, CatchClause: sl, ClassBody: ul, ClassDeclaration: cl, ClassExpression: ll, ConditionalExpression: pl, ContinueStatement: fl, DebuggerStatement: hl, DoWhileStatement: dl, EmptyStatement: ml, ExportAllDeclaration: gl, ExportDefaultDeclaration: yl, ExportNamedDeclaration: vl, ExportSpecifier: xl, ExpressionStatement: bl, ExperimentalRestProperty: El, ExperimentalSpreadProperty: Cl, ForStatement: Sl, ForInStatement: kl, ForOfStatement: Dl, FunctionDeclaration: Fl, FunctionExpression: Al, Identifier: wl, IfStatement: _l, ImportDeclaration: Tl, ImportDefaultSpecifier: Pl, ImportExpression: Il, ImportNamespaceSpecifier: Bl, ImportSpecifier: Ol, JSXAttribute: Ll, JSXClosingElement: Nl, JSXElement: jl, JSXEmptyExpression: Rl, JSXExpressionContainer: Ml, JSXIdentifier: Vl, JSXMemberExpression: Ul, JSXNamespacedName: ql, JSXOpeningElement: Wl, JSXSpreadAttribute: $l, JSXText: Gl, JSXFragment: zl, Literal: Hl, LabeledStatement: Kl, LogicalExpression: Jl, MemberExpression: Ql, MetaProperty: Xl, MethodDefinition: Yl, NewExpression: Zl, ObjectExpression: ep, ObjectPattern: tp, Program: rp, Property: np, RestElement: ip, ReturnStatement: ap, SequenceExpression: op, SpreadElement: sp, Super: up, SwitchStatement: cp, SwitchCase: lp, TaggedTemplateExpression: pp, TemplateElement: fp, TemplateLiteral: hp, ThisExpression: dp, ThrowStatement: mp, TryStatement: gp, UnaryExpression: yp, UpdateExpression: vp, VariableDeclaration: xp, VariableDeclarator: bp, WhileStatement: Ep, WithStatement: Cp, YieldExpression: Sp }, Dp = n(Object.freeze({ __proto__: null, AssignmentExpression: Xc, AssignmentPattern: Yc, ArrayExpression: Zc, ArrayPattern: el, ArrowFunctionExpression: tl, AwaitExpression: rl, BlockStatement: nl$1, BinaryExpression: il, BreakStatement: al, CallExpression: ol, CatchClause: sl, ClassBody: ul, ClassDeclaration: cl, ClassExpression: ll, ConditionalExpression: pl, ContinueStatement: fl, DebuggerStatement: hl, DoWhileStatement: dl, EmptyStatement: ml, ExportAllDeclaration: gl, ExportDefaultDeclaration: yl, ExportNamedDeclaration: vl, ExportSpecifier: xl, ExpressionStatement: bl, ExperimentalRestProperty: El, ExperimentalSpreadProperty: Cl, ForStatement: Sl, ForInStatement: kl, ForOfStatement: Dl, FunctionDeclaration: Fl, FunctionExpression: Al, Identifier: wl, IfStatement: _l, ImportDeclaration: Tl, ImportDefaultSpecifier: Pl, ImportExpression: Il, ImportNamespaceSpecifier: Bl, ImportSpecifier: Ol, JSXAttribute: Ll, JSXClosingElement: Nl, JSXElement: jl, JSXEmptyExpression: Rl, JSXExpressionContainer: Ml, JSXIdentifier: Vl, JSXMemberExpression: Ul, JSXNamespacedName: ql, JSXOpeningElement: Wl, JSXSpreadAttribute: $l, JSXText: Gl, JSXFragment: zl, Literal: Hl, LabeledStatement: Kl, LogicalExpression: Jl, MemberExpression: Ql, MetaProperty: Xl, MethodDefinition: Yl, NewExpression: Zl, ObjectExpression: ep, ObjectPattern: tp, Program: rp, Property: np, RestElement: ip, ReturnStatement: ap, SequenceExpression: op, SpreadElement: sp, Super: up, SwitchStatement: cp, SwitchCase: lp, TaggedTemplateExpression: pp, TemplateElement: fp, TemplateLiteral: hp, ThisExpression: dp, ThrowStatement: mp, TryStatement: gp, UnaryExpression: yp, UpdateExpression: vp, VariableDeclaration: xp, VariableDeclarator: bp, WhileStatement: Ep, WithStatement: Cp, YieldExpression: Sp, default: kp })), Fp = Object.freeze(Object.keys(Dp)), Ap = true, wp = false, _p = void 0;
try {
  for (var Tp, Pp = Fp[Symbol.iterator](); !(Ap = (Tp = Pp.next()).done); Ap = true) {
    var Ip = Tp.value;
    Object.freeze(Dp[Ip]);
  }
} catch (e25) {
  wp = true, _p = e25;
} finally {
  try {
    Ap || Pp.return == null || Pp.return();
  } finally {
    if (wp)
      throw _p;
  }
}
Object.freeze(Dp);
var Bp = new Set(["parent", "leadingComments", "trailingComments"]);
function Op(e25) {
  return !Bp.has(e25) && e25[0] !== "_";
}
var Lp = Object.freeze({ KEYS: Dp, getKeys: function(e25) {
  return Object.keys(e25).filter(Op);
}, unionWith: function(e25) {
  for (var t2 = Object.assign({}, Dp), r2 = 0, n2 = Object.keys(e25); r2 < n2.length; r2++) {
    var i2 = n2[r2];
    if (t2.hasOwnProperty(i2)) {
      var a2 = new Set(e25[i2]), o2 = true, s2 = false, u2 = void 0;
      try {
        for (var c2, l2 = t2[i2][Symbol.iterator](); !(o2 = (c2 = l2.next()).done); o2 = true) {
          var p2 = c2.value;
          a2.add(p2);
        }
      } catch (e26) {
        s2 = true, u2 = e26;
      } finally {
        try {
          o2 || l2.return == null || l2.return();
        } finally {
          if (s2)
            throw u2;
        }
      }
      t2[i2] = Object.freeze(Array.from(a2));
    } else
      t2[i2] = Object.freeze(Array.from(e25[i2]));
  }
  return Object.freeze(t2);
} }), Np = { 3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile", 5: "class enum extends super const export import", 6: "enum", strict: "implements interface let package private protected public static yield", strictBind: "eval arguments" }, jp = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", Rp = { 5: jp, "5module": jp + " export import", 6: jp + " const class extends export import super" }, Mp = /^in(stanceof)?$/, Vp = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7C6\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB67\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", Up = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F", qp = new RegExp("[" + Vp + "]"), Wp = new RegExp("[" + Vp + Up + "]");
Vp = Up = null;
var $p = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 477, 28, 11, 0, 9, 21, 155, 22, 13, 52, 76, 44, 33, 24, 27, 35, 30, 0, 12, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 0, 33, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 230, 43, 117, 63, 32, 0, 161, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 35, 56, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 270, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 754, 9486, 286, 50, 2, 18, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 2357, 44, 11, 6, 17, 0, 370, 43, 1301, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42710, 42, 4148, 12, 221, 3, 5761, 15, 7472, 3104, 541], Gp = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 525, 10, 176, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 4, 9, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 232, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 135, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 19723, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 262, 6, 10, 9, 419, 13, 1495, 6, 110, 6, 6, 9, 792487, 239];
function zp(e25, t2) {
  for (var r2 = 65536, n2 = 0; n2 < t2.length; n2 += 2) {
    if ((r2 += t2[n2]) > e25)
      return false;
    if ((r2 += t2[n2 + 1]) >= e25)
      return true;
  }
}
function Hp(e25, t2) {
  return e25 < 65 ? e25 === 36 : e25 < 91 || (e25 < 97 ? e25 === 95 : e25 < 123 || (e25 <= 65535 ? e25 >= 170 && qp.test(String.fromCharCode(e25)) : t2 !== false && zp(e25, $p)));
}
function Kp(e25, t2) {
  return e25 < 48 ? e25 === 36 : e25 < 58 || !(e25 < 65) && (e25 < 91 || (e25 < 97 ? e25 === 95 : e25 < 123 || (e25 <= 65535 ? e25 >= 170 && Wp.test(String.fromCharCode(e25)) : t2 !== false && (zp(e25, $p) || zp(e25, Gp)))));
}
var Jp = function(e25, t2) {
  t2 === void 0 && (t2 = {}), this.label = e25, this.keyword = t2.keyword, this.beforeExpr = !!t2.beforeExpr, this.startsExpr = !!t2.startsExpr, this.isLoop = !!t2.isLoop, this.isAssign = !!t2.isAssign, this.prefix = !!t2.prefix, this.postfix = !!t2.postfix, this.binop = t2.binop || null, this.updateContext = null;
};
function Qp(e25, t2) {
  return new Jp(e25, { beforeExpr: true, binop: t2 });
}
var Xp = { beforeExpr: true }, Yp = { startsExpr: true }, Zp = {};
function ef(e25, t2) {
  return t2 === void 0 && (t2 = {}), t2.keyword = e25, Zp[e25] = new Jp(e25, t2);
}
var tf = { num: new Jp("num", Yp), regexp: new Jp("regexp", Yp), string: new Jp("string", Yp), name: new Jp("name", Yp), eof: new Jp("eof"), bracketL: new Jp("[", { beforeExpr: true, startsExpr: true }), bracketR: new Jp("]"), braceL: new Jp("{", { beforeExpr: true, startsExpr: true }), braceR: new Jp("}"), parenL: new Jp("(", { beforeExpr: true, startsExpr: true }), parenR: new Jp(")"), comma: new Jp(",", Xp), semi: new Jp(";", Xp), colon: new Jp(":", Xp), dot: new Jp("."), question: new Jp("?", Xp), arrow: new Jp("=>", Xp), template: new Jp("template"), invalidTemplate: new Jp("invalidTemplate"), ellipsis: new Jp("...", Xp), backQuote: new Jp("`", Yp), dollarBraceL: new Jp("${", { beforeExpr: true, startsExpr: true }), eq: new Jp("=", { beforeExpr: true, isAssign: true }), assign: new Jp("_=", { beforeExpr: true, isAssign: true }), incDec: new Jp("++/--", { prefix: true, postfix: true, startsExpr: true }), prefix: new Jp("!/~", { beforeExpr: true, prefix: true, startsExpr: true }), logicalOR: Qp("||", 1), logicalAND: Qp("&&", 2), bitwiseOR: Qp("|", 3), bitwiseXOR: Qp("^", 4), bitwiseAND: Qp("&", 5), equality: Qp("==/!=/===/!==", 6), relational: Qp("</>/<=/>=", 7), bitShift: Qp("<</>>/>>>", 8), plusMin: new Jp("+/-", { beforeExpr: true, binop: 9, prefix: true, startsExpr: true }), modulo: Qp("%", 10), star: Qp("*", 10), slash: Qp("/", 10), starstar: new Jp("**", { beforeExpr: true }), _break: ef("break"), _case: ef("case", Xp), _catch: ef("catch"), _continue: ef("continue"), _debugger: ef("debugger"), _default: ef("default", Xp), _do: ef("do", { isLoop: true, beforeExpr: true }), _else: ef("else", Xp), _finally: ef("finally"), _for: ef("for", { isLoop: true }), _function: ef("function", Yp), _if: ef("if"), _return: ef("return", Xp), _switch: ef("switch"), _throw: ef("throw", Xp), _try: ef("try"), _var: ef("var"), _const: ef("const"), _while: ef("while", { isLoop: true }), _with: ef("with"), _new: ef("new", { beforeExpr: true, startsExpr: true }), _this: ef("this", Yp), _super: ef("super", Yp), _class: ef("class", Yp), _extends: ef("extends", Xp), _export: ef("export"), _import: ef("import", Yp), _null: ef("null", Yp), _true: ef("true", Yp), _false: ef("false", Yp), _in: ef("in", { beforeExpr: true, binop: 7 }), _instanceof: ef("instanceof", { beforeExpr: true, binop: 7 }), _typeof: ef("typeof", { beforeExpr: true, prefix: true, startsExpr: true }), _void: ef("void", { beforeExpr: true, prefix: true, startsExpr: true }), _delete: ef("delete", { beforeExpr: true, prefix: true, startsExpr: true }) }, rf = /\r\n?|\n|\u2028|\u2029/, nf = new RegExp(rf.source, "g");
function af(e25, t2) {
  return e25 === 10 || e25 === 13 || !t2 && (e25 === 8232 || e25 === 8233);
}
var of = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, sf = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, uf = Object.prototype, cf = uf.hasOwnProperty, lf = uf.toString;
function pf(e25, t2) {
  return cf.call(e25, t2);
}
var ff = Array.isArray || function(e25) {
  return lf.call(e25) === "[object Array]";
};
function hf(e25) {
  return new RegExp("^(?:" + e25.replace(/ /g, "|") + ")$");
}
var df = function(e25, t2) {
  this.line = e25, this.column = t2;
};
df.prototype.offset = function(e25) {
  return new df(this.line, this.column + e25);
};
var mf = function(e25, t2, r2) {
  this.start = t2, this.end = r2, e25.sourceFile !== null && (this.source = e25.sourceFile);
};
function gf(e25, t2) {
  for (var r2 = 1, n2 = 0; ; ) {
    nf.lastIndex = n2;
    var i2 = nf.exec(e25);
    if (!(i2 && i2.index < t2))
      return new df(r2, t2 - n2);
    ++r2, n2 = i2.index + i2[0].length;
  }
}
var yf = { ecmaVersion: 10, sourceType: "script", onInsertedSemicolon: null, onTrailingComma: null, allowReserved: null, allowReturnOutsideFunction: false, allowImportExportEverywhere: false, allowAwaitOutsideFunction: false, allowHashBang: false, locations: false, onToken: null, onComment: null, ranges: false, program: null, sourceFile: null, directSourceFile: null, preserveParens: false };
function vf(e25) {
  var t2 = {};
  for (var r2 in yf)
    t2[r2] = e25 && pf(e25, r2) ? e25[r2] : yf[r2];
  if (t2.ecmaVersion >= 2015 && (t2.ecmaVersion -= 2009), t2.allowReserved == null && (t2.allowReserved = t2.ecmaVersion < 5), ff(t2.onToken)) {
    var n2 = t2.onToken;
    t2.onToken = function(e26) {
      return n2.push(e26);
    };
  }
  return ff(t2.onComment) && (t2.onComment = function(e26, t3) {
    return function(r3, n3, i2, a2, o2, s2) {
      var u2 = { type: r3 ? "Block" : "Line", value: n3, start: i2, end: a2 };
      e26.locations && (u2.loc = new mf(this, o2, s2)), e26.ranges && (u2.range = [i2, a2]), t3.push(u2);
    };
  }(t2, t2.onComment)), t2;
}
var xf = 2, bf = 1 | xf, Ef = 4, Cf = 8;
function Sf(e25, t2) {
  return xf | (e25 ? Ef : 0) | (t2 ? Cf : 0);
}
var kf = function(e25, t2, r2) {
  this.options = e25 = vf(e25), this.sourceFile = e25.sourceFile, this.keywords = hf(Rp[e25.ecmaVersion >= 6 ? 6 : e25.sourceType === "module" ? "5module" : 5]);
  var n2 = "";
  if (e25.allowReserved !== true) {
    for (var i2 = e25.ecmaVersion; !(n2 = Np[i2]); i2--)
      ;
    e25.sourceType === "module" && (n2 += " await");
  }
  this.reservedWords = hf(n2);
  var a2 = (n2 ? n2 + " " : "") + Np.strict;
  this.reservedWordsStrict = hf(a2), this.reservedWordsStrictBind = hf(a2 + " " + Np.strictBind), this.input = String(t2), this.containsEsc = false, r2 ? (this.pos = r2, this.lineStart = this.input.lastIndexOf("\n", r2 - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(rf).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = tf.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = true, this.inModule = e25.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = {}, this.pos === 0 && e25.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(1), this.regexpState = null;
}, Df = { inFunction: { configurable: true }, inGenerator: { configurable: true }, inAsync: { configurable: true }, allowSuper: { configurable: true }, allowDirectSuper: { configurable: true }, treatFunctionsAsVar: { configurable: true } };
kf.prototype.parse = function() {
  var e25 = this.options.program || this.startNode();
  return this.nextToken(), this.parseTopLevel(e25);
}, Df.inFunction.get = function() {
  return (this.currentVarScope().flags & xf) > 0;
}, Df.inGenerator.get = function() {
  return (this.currentVarScope().flags & Cf) > 0;
}, Df.inAsync.get = function() {
  return (this.currentVarScope().flags & Ef) > 0;
}, Df.allowSuper.get = function() {
  return (64 & this.currentThisScope().flags) > 0;
}, Df.allowDirectSuper.get = function() {
  return (128 & this.currentThisScope().flags) > 0;
}, Df.treatFunctionsAsVar.get = function() {
  return this.treatFunctionsAsVarInScope(this.currentScope());
}, kf.prototype.inNonArrowFunction = function() {
  return (this.currentThisScope().flags & xf) > 0;
}, kf.extend = function() {
  for (var e25 = [], t2 = arguments.length; t2--; )
    e25[t2] = arguments[t2];
  for (var r2 = this, n2 = 0; n2 < e25.length; n2++)
    r2 = e25[n2](r2);
  return r2;
}, kf.parse = function(e25, t2) {
  return new this(t2, e25).parse();
}, kf.parseExpressionAt = function(e25, t2, r2) {
  var n2 = new this(r2, e25, t2);
  return n2.nextToken(), n2.parseExpression();
}, kf.tokenizer = function(e25, t2) {
  return new this(t2, e25);
}, Object.defineProperties(kf.prototype, Df);
var Ff = kf.prototype, Af = /^(?:'((?:\\.|[^'])*?)'|"((?:\\.|[^"])*?)")/;
function wf() {
  this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
}
Ff.strictDirective = function(e25) {
  for (; ; ) {
    sf.lastIndex = e25, e25 += sf.exec(this.input)[0].length;
    var t2 = Af.exec(this.input.slice(e25));
    if (!t2)
      return false;
    if ((t2[1] || t2[2]) === "use strict")
      return true;
    e25 += t2[0].length, sf.lastIndex = e25, e25 += sf.exec(this.input)[0].length, this.input[e25] === ";" && e25++;
  }
}, Ff.eat = function(e25) {
  return this.type === e25 && (this.next(), true);
}, Ff.isContextual = function(e25) {
  return this.type === tf.name && this.value === e25 && !this.containsEsc;
}, Ff.eatContextual = function(e25) {
  return !!this.isContextual(e25) && (this.next(), true);
}, Ff.expectContextual = function(e25) {
  this.eatContextual(e25) || this.unexpected();
}, Ff.canInsertSemicolon = function() {
  return this.type === tf.eof || this.type === tf.braceR || rf.test(this.input.slice(this.lastTokEnd, this.start));
}, Ff.insertSemicolon = function() {
  if (this.canInsertSemicolon())
    return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), true;
}, Ff.semicolon = function() {
  this.eat(tf.semi) || this.insertSemicolon() || this.unexpected();
}, Ff.afterTrailingComma = function(e25, t2) {
  if (this.type === e25)
    return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), t2 || this.next(), true;
}, Ff.expect = function(e25) {
  this.eat(e25) || this.unexpected();
}, Ff.unexpected = function(e25) {
  this.raise(e25 != null ? e25 : this.start, "Unexpected token");
}, Ff.checkPatternErrors = function(e25, t2) {
  if (e25) {
    e25.trailingComma > -1 && this.raiseRecoverable(e25.trailingComma, "Comma is not permitted after the rest element");
    var r2 = t2 ? e25.parenthesizedAssign : e25.parenthesizedBind;
    r2 > -1 && this.raiseRecoverable(r2, "Parenthesized pattern");
  }
}, Ff.checkExpressionErrors = function(e25, t2) {
  if (!e25)
    return false;
  var r2 = e25.shorthandAssign, n2 = e25.doubleProto;
  if (!t2)
    return r2 >= 0 || n2 >= 0;
  r2 >= 0 && this.raise(r2, "Shorthand property assignments are valid only in destructuring patterns"), n2 >= 0 && this.raiseRecoverable(n2, "Redefinition of __proto__ property");
}, Ff.checkYieldAwaitInDefaultParams = function() {
  this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
}, Ff.isSimpleAssignTarget = function(e25) {
  return e25.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(e25.expression) : e25.type === "Identifier" || e25.type === "MemberExpression";
};
var _f = kf.prototype;
_f.parseTopLevel = function(e25) {
  var t2 = {};
  for (e25.body || (e25.body = []); this.type !== tf.eof; ) {
    var r2 = this.parseStatement(null, true, t2);
    e25.body.push(r2);
  }
  if (this.inModule)
    for (var n2 = 0, i2 = Object.keys(this.undefinedExports); n2 < i2.length; n2 += 1) {
      var a2 = i2[n2];
      this.raiseRecoverable(this.undefinedExports[a2].start, "Export '" + a2 + "' is not defined");
    }
  return this.adaptDirectivePrologue(e25.body), this.next(), e25.sourceType = this.options.sourceType, this.finishNode(e25, "Program");
};
var Tf = { kind: "loop" }, Pf = { kind: "switch" };
_f.isLet = function(e25) {
  if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
    return false;
  sf.lastIndex = this.pos;
  var t2 = sf.exec(this.input), r2 = this.pos + t2[0].length, n2 = this.input.charCodeAt(r2);
  if (n2 === 91)
    return true;
  if (e25)
    return false;
  if (n2 === 123)
    return true;
  if (Hp(n2, true)) {
    for (var i2 = r2 + 1; Kp(this.input.charCodeAt(i2), true); )
      ++i2;
    var a2 = this.input.slice(r2, i2);
    if (!Mp.test(a2))
      return true;
  }
  return false;
}, _f.isAsyncFunction = function() {
  if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
    return false;
  sf.lastIndex = this.pos;
  var e25 = sf.exec(this.input), t2 = this.pos + e25[0].length;
  return !(rf.test(this.input.slice(this.pos, t2)) || this.input.slice(t2, t2 + 8) !== "function" || t2 + 8 !== this.input.length && Kp(this.input.charAt(t2 + 8)));
}, _f.parseStatement = function(e25, t2, r2) {
  var n2, i2 = this.type, a2 = this.startNode();
  switch (this.isLet(e25) && (i2 = tf._var, n2 = "let"), i2) {
    case tf._break:
    case tf._continue:
      return this.parseBreakContinueStatement(a2, i2.keyword);
    case tf._debugger:
      return this.parseDebuggerStatement(a2);
    case tf._do:
      return this.parseDoStatement(a2);
    case tf._for:
      return this.parseForStatement(a2);
    case tf._function:
      return e25 && (this.strict || e25 !== "if" && e25 !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(a2, false, !e25);
    case tf._class:
      return e25 && this.unexpected(), this.parseClass(a2, true);
    case tf._if:
      return this.parseIfStatement(a2);
    case tf._return:
      return this.parseReturnStatement(a2);
    case tf._switch:
      return this.parseSwitchStatement(a2);
    case tf._throw:
      return this.parseThrowStatement(a2);
    case tf._try:
      return this.parseTryStatement(a2);
    case tf._const:
    case tf._var:
      return n2 = n2 || this.value, e25 && n2 !== "var" && this.unexpected(), this.parseVarStatement(a2, n2);
    case tf._while:
      return this.parseWhileStatement(a2);
    case tf._with:
      return this.parseWithStatement(a2);
    case tf.braceL:
      return this.parseBlock(true, a2);
    case tf.semi:
      return this.parseEmptyStatement(a2);
    case tf._export:
    case tf._import:
      if (this.options.ecmaVersion > 10 && i2 === tf._import) {
        sf.lastIndex = this.pos;
        var o2 = sf.exec(this.input), s2 = this.pos + o2[0].length;
        if (this.input.charCodeAt(s2) === 40)
          return this.parseExpressionStatement(a2, this.parseExpression());
      }
      return this.options.allowImportExportEverywhere || (t2 || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), i2 === tf._import ? this.parseImport(a2) : this.parseExport(a2, r2);
    default:
      if (this.isAsyncFunction())
        return e25 && this.unexpected(), this.next(), this.parseFunctionStatement(a2, true, !e25);
      var u2 = this.value, c2 = this.parseExpression();
      return i2 === tf.name && c2.type === "Identifier" && this.eat(tf.colon) ? this.parseLabeledStatement(a2, u2, c2, e25) : this.parseExpressionStatement(a2, c2);
  }
}, _f.parseBreakContinueStatement = function(e25, t2) {
  var r2 = t2 === "break";
  this.next(), this.eat(tf.semi) || this.insertSemicolon() ? e25.label = null : this.type !== tf.name ? this.unexpected() : (e25.label = this.parseIdent(), this.semicolon());
  for (var n2 = 0; n2 < this.labels.length; ++n2) {
    var i2 = this.labels[n2];
    if (e25.label == null || i2.name === e25.label.name) {
      if (i2.kind != null && (r2 || i2.kind === "loop"))
        break;
      if (e25.label && r2)
        break;
    }
  }
  return n2 === this.labels.length && this.raise(e25.start, "Unsyntactic " + t2), this.finishNode(e25, r2 ? "BreakStatement" : "ContinueStatement");
}, _f.parseDebuggerStatement = function(e25) {
  return this.next(), this.semicolon(), this.finishNode(e25, "DebuggerStatement");
}, _f.parseDoStatement = function(e25) {
  return this.next(), this.labels.push(Tf), e25.body = this.parseStatement("do"), this.labels.pop(), this.expect(tf._while), e25.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(tf.semi) : this.semicolon(), this.finishNode(e25, "DoWhileStatement");
}, _f.parseForStatement = function(e25) {
  this.next();
  var t2 = this.options.ecmaVersion >= 9 && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction) && this.eatContextual("await") ? this.lastTokStart : -1;
  if (this.labels.push(Tf), this.enterScope(0), this.expect(tf.parenL), this.type === tf.semi)
    return t2 > -1 && this.unexpected(t2), this.parseFor(e25, null);
  var r2 = this.isLet();
  if (this.type === tf._var || this.type === tf._const || r2) {
    var n2 = this.startNode(), i2 = r2 ? "let" : this.value;
    return this.next(), this.parseVar(n2, true, i2), this.finishNode(n2, "VariableDeclaration"), (this.type === tf._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && n2.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === tf._in ? t2 > -1 && this.unexpected(t2) : e25.await = t2 > -1), this.parseForIn(e25, n2)) : (t2 > -1 && this.unexpected(t2), this.parseFor(e25, n2));
  }
  var a2 = new wf(), o2 = this.parseExpression(true, a2);
  return this.type === tf._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? (this.options.ecmaVersion >= 9 && (this.type === tf._in ? t2 > -1 && this.unexpected(t2) : e25.await = t2 > -1), this.toAssignable(o2, false, a2), this.checkLVal(o2), this.parseForIn(e25, o2)) : (this.checkExpressionErrors(a2, true), t2 > -1 && this.unexpected(t2), this.parseFor(e25, o2));
}, _f.parseFunctionStatement = function(e25, t2, r2) {
  return this.next(), this.parseFunction(e25, Bf | (r2 ? 0 : Of), false, t2);
}, _f.parseIfStatement = function(e25) {
  return this.next(), e25.test = this.parseParenExpression(), e25.consequent = this.parseStatement("if"), e25.alternate = this.eat(tf._else) ? this.parseStatement("if") : null, this.finishNode(e25, "IfStatement");
}, _f.parseReturnStatement = function(e25) {
  return this.inFunction || this.options.allowReturnOutsideFunction || this.raise(this.start, "'return' outside of function"), this.next(), this.eat(tf.semi) || this.insertSemicolon() ? e25.argument = null : (e25.argument = this.parseExpression(), this.semicolon()), this.finishNode(e25, "ReturnStatement");
}, _f.parseSwitchStatement = function(e25) {
  var t2;
  this.next(), e25.discriminant = this.parseParenExpression(), e25.cases = [], this.expect(tf.braceL), this.labels.push(Pf), this.enterScope(0);
  for (var r2 = false; this.type !== tf.braceR; )
    if (this.type === tf._case || this.type === tf._default) {
      var n2 = this.type === tf._case;
      t2 && this.finishNode(t2, "SwitchCase"), e25.cases.push(t2 = this.startNode()), t2.consequent = [], this.next(), n2 ? t2.test = this.parseExpression() : (r2 && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), r2 = true, t2.test = null), this.expect(tf.colon);
    } else
      t2 || this.unexpected(), t2.consequent.push(this.parseStatement(null));
  return this.exitScope(), t2 && this.finishNode(t2, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(e25, "SwitchStatement");
}, _f.parseThrowStatement = function(e25) {
  return this.next(), rf.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), e25.argument = this.parseExpression(), this.semicolon(), this.finishNode(e25, "ThrowStatement");
};
var If = [];
_f.parseTryStatement = function(e25) {
  if (this.next(), e25.block = this.parseBlock(), e25.handler = null, this.type === tf._catch) {
    var t2 = this.startNode();
    if (this.next(), this.eat(tf.parenL)) {
      t2.param = this.parseBindingAtom();
      var r2 = t2.param.type === "Identifier";
      this.enterScope(r2 ? 32 : 0), this.checkLVal(t2.param, r2 ? 4 : 2), this.expect(tf.parenR);
    } else
      this.options.ecmaVersion < 10 && this.unexpected(), t2.param = null, this.enterScope(0);
    t2.body = this.parseBlock(false), this.exitScope(), e25.handler = this.finishNode(t2, "CatchClause");
  }
  return e25.finalizer = this.eat(tf._finally) ? this.parseBlock() : null, e25.handler || e25.finalizer || this.raise(e25.start, "Missing catch or finally clause"), this.finishNode(e25, "TryStatement");
}, _f.parseVarStatement = function(e25, t2) {
  return this.next(), this.parseVar(e25, false, t2), this.semicolon(), this.finishNode(e25, "VariableDeclaration");
}, _f.parseWhileStatement = function(e25) {
  return this.next(), e25.test = this.parseParenExpression(), this.labels.push(Tf), e25.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(e25, "WhileStatement");
}, _f.parseWithStatement = function(e25) {
  return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), e25.object = this.parseParenExpression(), e25.body = this.parseStatement("with"), this.finishNode(e25, "WithStatement");
}, _f.parseEmptyStatement = function(e25) {
  return this.next(), this.finishNode(e25, "EmptyStatement");
}, _f.parseLabeledStatement = function(e25, t2, r2, n2) {
  for (var i2 = 0, a2 = this.labels; i2 < a2.length; i2 += 1) {
    a2[i2].name === t2 && this.raise(r2.start, "Label '" + t2 + "' is already declared");
  }
  for (var o2 = this.type.isLoop ? "loop" : this.type === tf._switch ? "switch" : null, s2 = this.labels.length - 1; s2 >= 0; s2--) {
    var u2 = this.labels[s2];
    if (u2.statementStart !== e25.start)
      break;
    u2.statementStart = this.start, u2.kind = o2;
  }
  return this.labels.push({ name: t2, kind: o2, statementStart: this.start }), e25.body = this.parseStatement(n2 ? n2.indexOf("label") === -1 ? n2 + "label" : n2 : "label"), this.labels.pop(), e25.label = r2, this.finishNode(e25, "LabeledStatement");
}, _f.parseExpressionStatement = function(e25, t2) {
  return e25.expression = t2, this.semicolon(), this.finishNode(e25, "ExpressionStatement");
}, _f.parseBlock = function(e25, t2) {
  for (e25 === void 0 && (e25 = true), t2 === void 0 && (t2 = this.startNode()), t2.body = [], this.expect(tf.braceL), e25 && this.enterScope(0); !this.eat(tf.braceR); ) {
    var r2 = this.parseStatement(null);
    t2.body.push(r2);
  }
  return e25 && this.exitScope(), this.finishNode(t2, "BlockStatement");
}, _f.parseFor = function(e25, t2) {
  return e25.init = t2, this.expect(tf.semi), e25.test = this.type === tf.semi ? null : this.parseExpression(), this.expect(tf.semi), e25.update = this.type === tf.parenR ? null : this.parseExpression(), this.expect(tf.parenR), e25.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e25, "ForStatement");
}, _f.parseForIn = function(e25, t2) {
  var r2 = this.type === tf._in;
  return this.next(), t2.type === "VariableDeclaration" && t2.declarations[0].init != null && (!r2 || this.options.ecmaVersion < 8 || this.strict || t2.kind !== "var" || t2.declarations[0].id.type !== "Identifier") ? this.raise(t2.start, (r2 ? "for-in" : "for-of") + " loop variable declaration may not have an initializer") : t2.type === "AssignmentPattern" && this.raise(t2.start, "Invalid left-hand side in for-loop"), e25.left = t2, e25.right = r2 ? this.parseExpression() : this.parseMaybeAssign(), this.expect(tf.parenR), e25.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e25, r2 ? "ForInStatement" : "ForOfStatement");
}, _f.parseVar = function(e25, t2, r2) {
  for (e25.declarations = [], e25.kind = r2; ; ) {
    var n2 = this.startNode();
    if (this.parseVarId(n2, r2), this.eat(tf.eq) ? n2.init = this.parseMaybeAssign(t2) : r2 !== "const" || this.type === tf._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? n2.id.type === "Identifier" || t2 && (this.type === tf._in || this.isContextual("of")) ? n2.init = null : this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : this.unexpected(), e25.declarations.push(this.finishNode(n2, "VariableDeclarator")), !this.eat(tf.comma))
      break;
  }
  return e25;
}, _f.parseVarId = function(e25, t2) {
  e25.id = this.parseBindingAtom(), this.checkLVal(e25.id, t2 === "var" ? 1 : 2, false);
};
var Bf = 1, Of = 2;
_f.parseFunction = function(e25, t2, r2, n2) {
  this.initFunction(e25), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !n2) && (this.type === tf.star && t2 & Of && this.unexpected(), e25.generator = this.eat(tf.star)), this.options.ecmaVersion >= 8 && (e25.async = !!n2), t2 & Bf && (e25.id = 4 & t2 && this.type !== tf.name ? null : this.parseIdent(), !e25.id || t2 & Of || this.checkLVal(e25.id, this.strict || e25.generator || e25.async ? this.treatFunctionsAsVar ? 1 : 2 : 3));
  var i2 = this.yieldPos, a2 = this.awaitPos, o2 = this.awaitIdentPos;
  return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Sf(e25.async, e25.generator)), t2 & Bf || (e25.id = this.type === tf.name ? this.parseIdent() : null), this.parseFunctionParams(e25), this.parseFunctionBody(e25, r2, false), this.yieldPos = i2, this.awaitPos = a2, this.awaitIdentPos = o2, this.finishNode(e25, t2 & Bf ? "FunctionDeclaration" : "FunctionExpression");
}, _f.parseFunctionParams = function(e25) {
  this.expect(tf.parenL), e25.params = this.parseBindingList(tf.parenR, false, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
}, _f.parseClass = function(e25, t2) {
  this.next();
  var r2 = this.strict;
  this.strict = true, this.parseClassId(e25, t2), this.parseClassSuper(e25);
  var n2 = this.startNode(), i2 = false;
  for (n2.body = [], this.expect(tf.braceL); !this.eat(tf.braceR); ) {
    var a2 = this.parseClassElement(e25.superClass !== null);
    a2 && (n2.body.push(a2), a2.type === "MethodDefinition" && a2.kind === "constructor" && (i2 && this.raise(a2.start, "Duplicate constructor in the same class"), i2 = true));
  }
  return e25.body = this.finishNode(n2, "ClassBody"), this.strict = r2, this.finishNode(e25, t2 ? "ClassDeclaration" : "ClassExpression");
}, _f.parseClassElement = function(e25) {
  var t2 = this;
  if (this.eat(tf.semi))
    return null;
  var r2 = this.startNode(), n2 = function(e26, n3) {
    n3 === void 0 && (n3 = false);
    var i3 = t2.start, a3 = t2.startLoc;
    return !!t2.eatContextual(e26) && (!(t2.type === tf.parenL || n3 && t2.canInsertSemicolon()) || (r2.key && t2.unexpected(), r2.computed = false, r2.key = t2.startNodeAt(i3, a3), r2.key.name = e26, t2.finishNode(r2.key, "Identifier"), false));
  };
  r2.kind = "method", r2.static = n2("static");
  var i2 = this.eat(tf.star), a2 = false;
  i2 || (this.options.ecmaVersion >= 8 && n2("async", true) ? (a2 = true, i2 = this.options.ecmaVersion >= 9 && this.eat(tf.star)) : n2("get") ? r2.kind = "get" : n2("set") && (r2.kind = "set")), r2.key || this.parsePropertyName(r2);
  var o2 = r2.key, s2 = false;
  return r2.computed || r2.static || !(o2.type === "Identifier" && o2.name === "constructor" || o2.type === "Literal" && o2.value === "constructor") ? r2.static && o2.type === "Identifier" && o2.name === "prototype" && this.raise(o2.start, "Classes may not have a static property named prototype") : (r2.kind !== "method" && this.raise(o2.start, "Constructor can't have get/set modifier"), i2 && this.raise(o2.start, "Constructor can't be a generator"), a2 && this.raise(o2.start, "Constructor can't be an async method"), r2.kind = "constructor", s2 = e25), this.parseClassMethod(r2, i2, a2, s2), r2.kind === "get" && r2.value.params.length !== 0 && this.raiseRecoverable(r2.value.start, "getter should have no params"), r2.kind === "set" && r2.value.params.length !== 1 && this.raiseRecoverable(r2.value.start, "setter should have exactly one param"), r2.kind === "set" && r2.value.params[0].type === "RestElement" && this.raiseRecoverable(r2.value.params[0].start, "Setter cannot use rest params"), r2;
}, _f.parseClassMethod = function(e25, t2, r2, n2) {
  return e25.value = this.parseMethod(t2, r2, n2), this.finishNode(e25, "MethodDefinition");
}, _f.parseClassId = function(e25, t2) {
  this.type === tf.name ? (e25.id = this.parseIdent(), t2 && this.checkLVal(e25.id, 2, false)) : (t2 === true && this.unexpected(), e25.id = null);
}, _f.parseClassSuper = function(e25) {
  e25.superClass = this.eat(tf._extends) ? this.parseExprSubscripts() : null;
}, _f.parseExport = function(e25, t2) {
  if (this.next(), this.eat(tf.star))
    return this.expectContextual("from"), this.type !== tf.string && this.unexpected(), e25.source = this.parseExprAtom(), this.semicolon(), this.finishNode(e25, "ExportAllDeclaration");
  if (this.eat(tf._default)) {
    var r2;
    if (this.checkExport(t2, "default", this.lastTokStart), this.type === tf._function || (r2 = this.isAsyncFunction())) {
      var n2 = this.startNode();
      this.next(), r2 && this.next(), e25.declaration = this.parseFunction(n2, 4 | Bf, false, r2);
    } else if (this.type === tf._class) {
      var i2 = this.startNode();
      e25.declaration = this.parseClass(i2, "nullableID");
    } else
      e25.declaration = this.parseMaybeAssign(), this.semicolon();
    return this.finishNode(e25, "ExportDefaultDeclaration");
  }
  if (this.shouldParseExportStatement())
    e25.declaration = this.parseStatement(null), e25.declaration.type === "VariableDeclaration" ? this.checkVariableExport(t2, e25.declaration.declarations) : this.checkExport(t2, e25.declaration.id.name, e25.declaration.id.start), e25.specifiers = [], e25.source = null;
  else {
    if (e25.declaration = null, e25.specifiers = this.parseExportSpecifiers(t2), this.eatContextual("from"))
      this.type !== tf.string && this.unexpected(), e25.source = this.parseExprAtom();
    else {
      for (var a2 = 0, o2 = e25.specifiers; a2 < o2.length; a2 += 1) {
        var s2 = o2[a2];
        this.checkUnreserved(s2.local), this.checkLocalExport(s2.local);
      }
      e25.source = null;
    }
    this.semicolon();
  }
  return this.finishNode(e25, "ExportNamedDeclaration");
}, _f.checkExport = function(e25, t2, r2) {
  e25 && (pf(e25, t2) && this.raiseRecoverable(r2, "Duplicate export '" + t2 + "'"), e25[t2] = true);
}, _f.checkPatternExport = function(e25, t2) {
  var r2 = t2.type;
  if (r2 === "Identifier")
    this.checkExport(e25, t2.name, t2.start);
  else if (r2 === "ObjectPattern")
    for (var n2 = 0, i2 = t2.properties; n2 < i2.length; n2 += 1) {
      var a2 = i2[n2];
      this.checkPatternExport(e25, a2);
    }
  else if (r2 === "ArrayPattern")
    for (var o2 = 0, s2 = t2.elements; o2 < s2.length; o2 += 1) {
      var u2 = s2[o2];
      u2 && this.checkPatternExport(e25, u2);
    }
  else
    r2 === "Property" ? this.checkPatternExport(e25, t2.value) : r2 === "AssignmentPattern" ? this.checkPatternExport(e25, t2.left) : r2 === "RestElement" ? this.checkPatternExport(e25, t2.argument) : r2 === "ParenthesizedExpression" && this.checkPatternExport(e25, t2.expression);
}, _f.checkVariableExport = function(e25, t2) {
  if (e25)
    for (var r2 = 0, n2 = t2; r2 < n2.length; r2 += 1) {
      var i2 = n2[r2];
      this.checkPatternExport(e25, i2.id);
    }
}, _f.shouldParseExportStatement = function() {
  return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
}, _f.parseExportSpecifiers = function(e25) {
  var t2 = [], r2 = true;
  for (this.expect(tf.braceL); !this.eat(tf.braceR); ) {
    if (r2)
      r2 = false;
    else if (this.expect(tf.comma), this.afterTrailingComma(tf.braceR))
      break;
    var n2 = this.startNode();
    n2.local = this.parseIdent(true), n2.exported = this.eatContextual("as") ? this.parseIdent(true) : n2.local, this.checkExport(e25, n2.exported.name, n2.exported.start), t2.push(this.finishNode(n2, "ExportSpecifier"));
  }
  return t2;
}, _f.parseImport = function(e25) {
  return this.next(), this.type === tf.string ? (e25.specifiers = If, e25.source = this.parseExprAtom()) : (e25.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), e25.source = this.type === tf.string ? this.parseExprAtom() : this.unexpected()), this.semicolon(), this.finishNode(e25, "ImportDeclaration");
}, _f.parseImportSpecifiers = function() {
  var e25 = [], t2 = true;
  if (this.type === tf.name) {
    var r2 = this.startNode();
    if (r2.local = this.parseIdent(), this.checkLVal(r2.local, 2), e25.push(this.finishNode(r2, "ImportDefaultSpecifier")), !this.eat(tf.comma))
      return e25;
  }
  if (this.type === tf.star) {
    var n2 = this.startNode();
    return this.next(), this.expectContextual("as"), n2.local = this.parseIdent(), this.checkLVal(n2.local, 2), e25.push(this.finishNode(n2, "ImportNamespaceSpecifier")), e25;
  }
  for (this.expect(tf.braceL); !this.eat(tf.braceR); ) {
    if (t2)
      t2 = false;
    else if (this.expect(tf.comma), this.afterTrailingComma(tf.braceR))
      break;
    var i2 = this.startNode();
    i2.imported = this.parseIdent(true), this.eatContextual("as") ? i2.local = this.parseIdent() : (this.checkUnreserved(i2.imported), i2.local = i2.imported), this.checkLVal(i2.local, 2), e25.push(this.finishNode(i2, "ImportSpecifier"));
  }
  return e25;
}, _f.adaptDirectivePrologue = function(e25) {
  for (var t2 = 0; t2 < e25.length && this.isDirectiveCandidate(e25[t2]); ++t2)
    e25[t2].directive = e25[t2].expression.raw.slice(1, -1);
}, _f.isDirectiveCandidate = function(e25) {
  return e25.type === "ExpressionStatement" && e25.expression.type === "Literal" && typeof e25.expression.value == "string" && (this.input[e25.start] === '"' || this.input[e25.start] === "'");
};
var Lf = kf.prototype;
Lf.toAssignable = function(e25, t2, r2) {
  if (this.options.ecmaVersion >= 6 && e25)
    switch (e25.type) {
      case "Identifier":
        this.inAsync && e25.name === "await" && this.raise(e25.start, "Cannot use 'await' as identifier inside an async function");
        break;
      case "ObjectPattern":
      case "ArrayPattern":
      case "RestElement":
        break;
      case "ObjectExpression":
        e25.type = "ObjectPattern", r2 && this.checkPatternErrors(r2, true);
        for (var n2 = 0, i2 = e25.properties; n2 < i2.length; n2 += 1) {
          var a2 = i2[n2];
          this.toAssignable(a2, t2), a2.type !== "RestElement" || a2.argument.type !== "ArrayPattern" && a2.argument.type !== "ObjectPattern" || this.raise(a2.argument.start, "Unexpected token");
        }
        break;
      case "Property":
        e25.kind !== "init" && this.raise(e25.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(e25.value, t2);
        break;
      case "ArrayExpression":
        e25.type = "ArrayPattern", r2 && this.checkPatternErrors(r2, true), this.toAssignableList(e25.elements, t2);
        break;
      case "SpreadElement":
        e25.type = "RestElement", this.toAssignable(e25.argument, t2), e25.argument.type === "AssignmentPattern" && this.raise(e25.argument.start, "Rest elements cannot have a default value");
        break;
      case "AssignmentExpression":
        e25.operator !== "=" && this.raise(e25.left.end, "Only '=' operator can be used for specifying default value."), e25.type = "AssignmentPattern", delete e25.operator, this.toAssignable(e25.left, t2);
      case "AssignmentPattern":
        break;
      case "ParenthesizedExpression":
        this.toAssignable(e25.expression, t2, r2);
        break;
      case "MemberExpression":
        if (!t2)
          break;
      default:
        this.raise(e25.start, "Assigning to rvalue");
    }
  else
    r2 && this.checkPatternErrors(r2, true);
  return e25;
}, Lf.toAssignableList = function(e25, t2) {
  for (var r2 = e25.length, n2 = 0; n2 < r2; n2++) {
    var i2 = e25[n2];
    i2 && this.toAssignable(i2, t2);
  }
  if (r2) {
    var a2 = e25[r2 - 1];
    this.options.ecmaVersion === 6 && t2 && a2 && a2.type === "RestElement" && a2.argument.type !== "Identifier" && this.unexpected(a2.argument.start);
  }
  return e25;
}, Lf.parseSpread = function(e25) {
  var t2 = this.startNode();
  return this.next(), t2.argument = this.parseMaybeAssign(false, e25), this.finishNode(t2, "SpreadElement");
}, Lf.parseRestBinding = function() {
  var e25 = this.startNode();
  return this.next(), this.options.ecmaVersion === 6 && this.type !== tf.name && this.unexpected(), e25.argument = this.parseBindingAtom(), this.finishNode(e25, "RestElement");
}, Lf.parseBindingAtom = function() {
  if (this.options.ecmaVersion >= 6)
    switch (this.type) {
      case tf.bracketL:
        var e25 = this.startNode();
        return this.next(), e25.elements = this.parseBindingList(tf.bracketR, true, true), this.finishNode(e25, "ArrayPattern");
      case tf.braceL:
        return this.parseObj(true);
    }
  return this.parseIdent();
}, Lf.parseBindingList = function(e25, t2, r2) {
  for (var n2 = [], i2 = true; !this.eat(e25); )
    if (i2 ? i2 = false : this.expect(tf.comma), t2 && this.type === tf.comma)
      n2.push(null);
    else {
      if (r2 && this.afterTrailingComma(e25))
        break;
      if (this.type === tf.ellipsis) {
        var a2 = this.parseRestBinding();
        this.parseBindingListItem(a2), n2.push(a2), this.type === tf.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.expect(e25);
        break;
      }
      var o2 = this.parseMaybeDefault(this.start, this.startLoc);
      this.parseBindingListItem(o2), n2.push(o2);
    }
  return n2;
}, Lf.parseBindingListItem = function(e25) {
  return e25;
}, Lf.parseMaybeDefault = function(e25, t2, r2) {
  if (r2 = r2 || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(tf.eq))
    return r2;
  var n2 = this.startNodeAt(e25, t2);
  return n2.left = r2, n2.right = this.parseMaybeAssign(), this.finishNode(n2, "AssignmentPattern");
}, Lf.checkLVal = function(e25, t2, r2) {
  switch (t2 === void 0 && (t2 = 0), e25.type) {
    case "Identifier":
      t2 === 2 && e25.name === "let" && this.raiseRecoverable(e25.start, "let is disallowed as a lexically bound name"), this.strict && this.reservedWordsStrictBind.test(e25.name) && this.raiseRecoverable(e25.start, (t2 ? "Binding " : "Assigning to ") + e25.name + " in strict mode"), r2 && (pf(r2, e25.name) && this.raiseRecoverable(e25.start, "Argument name clash"), r2[e25.name] = true), t2 !== 0 && t2 !== 5 && this.declareName(e25.name, t2, e25.start);
      break;
    case "MemberExpression":
      t2 && this.raiseRecoverable(e25.start, "Binding member expression");
      break;
    case "ObjectPattern":
      for (var n2 = 0, i2 = e25.properties; n2 < i2.length; n2 += 1) {
        var a2 = i2[n2];
        this.checkLVal(a2, t2, r2);
      }
      break;
    case "Property":
      this.checkLVal(e25.value, t2, r2);
      break;
    case "ArrayPattern":
      for (var o2 = 0, s2 = e25.elements; o2 < s2.length; o2 += 1) {
        var u2 = s2[o2];
        u2 && this.checkLVal(u2, t2, r2);
      }
      break;
    case "AssignmentPattern":
      this.checkLVal(e25.left, t2, r2);
      break;
    case "RestElement":
      this.checkLVal(e25.argument, t2, r2);
      break;
    case "ParenthesizedExpression":
      this.checkLVal(e25.expression, t2, r2);
      break;
    default:
      this.raise(e25.start, (t2 ? "Binding" : "Assigning to") + " rvalue");
  }
};
var Nf = kf.prototype;
Nf.checkPropClash = function(e25, t2, r2) {
  if (!(this.options.ecmaVersion >= 9 && e25.type === "SpreadElement" || this.options.ecmaVersion >= 6 && (e25.computed || e25.method || e25.shorthand))) {
    var n2, i2 = e25.key;
    switch (i2.type) {
      case "Identifier":
        n2 = i2.name;
        break;
      case "Literal":
        n2 = String(i2.value);
        break;
      default:
        return;
    }
    var a2 = e25.kind;
    if (this.options.ecmaVersion >= 6)
      n2 === "__proto__" && a2 === "init" && (t2.proto && (r2 && r2.doubleProto < 0 ? r2.doubleProto = i2.start : this.raiseRecoverable(i2.start, "Redefinition of __proto__ property")), t2.proto = true);
    else {
      var o2 = t2[n2 = "$" + n2];
      if (o2)
        (a2 === "init" ? this.strict && o2.init || o2.get || o2.set : o2.init || o2[a2]) && this.raiseRecoverable(i2.start, "Redefinition of property");
      else
        o2 = t2[n2] = { init: false, get: false, set: false };
      o2[a2] = true;
    }
  }
}, Nf.parseExpression = function(e25, t2) {
  var r2 = this.start, n2 = this.startLoc, i2 = this.parseMaybeAssign(e25, t2);
  if (this.type === tf.comma) {
    var a2 = this.startNodeAt(r2, n2);
    for (a2.expressions = [i2]; this.eat(tf.comma); )
      a2.expressions.push(this.parseMaybeAssign(e25, t2));
    return this.finishNode(a2, "SequenceExpression");
  }
  return i2;
}, Nf.parseMaybeAssign = function(e25, t2, r2) {
  if (this.isContextual("yield")) {
    if (this.inGenerator)
      return this.parseYield(e25);
    this.exprAllowed = false;
  }
  var n2 = false, i2 = -1, a2 = -1, o2 = -1;
  t2 ? (i2 = t2.parenthesizedAssign, a2 = t2.trailingComma, o2 = t2.shorthandAssign, t2.parenthesizedAssign = t2.trailingComma = t2.shorthandAssign = -1) : (t2 = new wf(), n2 = true);
  var s2 = this.start, u2 = this.startLoc;
  this.type !== tf.parenL && this.type !== tf.name || (this.potentialArrowAt = this.start);
  var c2 = this.parseMaybeConditional(e25, t2);
  if (r2 && (c2 = r2.call(this, c2, s2, u2)), this.type.isAssign) {
    var l2 = this.startNodeAt(s2, u2);
    return l2.operator = this.value, l2.left = this.type === tf.eq ? this.toAssignable(c2, false, t2) : c2, n2 || wf.call(t2), t2.shorthandAssign = -1, this.checkLVal(c2), this.next(), l2.right = this.parseMaybeAssign(e25), this.finishNode(l2, "AssignmentExpression");
  }
  return n2 && this.checkExpressionErrors(t2, true), i2 > -1 && (t2.parenthesizedAssign = i2), a2 > -1 && (t2.trailingComma = a2), o2 > -1 && (t2.shorthandAssign = o2), c2;
}, Nf.parseMaybeConditional = function(e25, t2) {
  var r2 = this.start, n2 = this.startLoc, i2 = this.parseExprOps(e25, t2);
  if (this.checkExpressionErrors(t2))
    return i2;
  if (this.eat(tf.question)) {
    var a2 = this.startNodeAt(r2, n2);
    return a2.test = i2, a2.consequent = this.parseMaybeAssign(), this.expect(tf.colon), a2.alternate = this.parseMaybeAssign(e25), this.finishNode(a2, "ConditionalExpression");
  }
  return i2;
}, Nf.parseExprOps = function(e25, t2) {
  var r2 = this.start, n2 = this.startLoc, i2 = this.parseMaybeUnary(t2, false);
  return this.checkExpressionErrors(t2) ? i2 : i2.start === r2 && i2.type === "ArrowFunctionExpression" ? i2 : this.parseExprOp(i2, r2, n2, -1, e25);
}, Nf.parseExprOp = function(e25, t2, r2, n2, i2) {
  var a2 = this.type.binop;
  if (a2 != null && (!i2 || this.type !== tf._in) && a2 > n2) {
    var o2 = this.type === tf.logicalOR || this.type === tf.logicalAND, s2 = this.value;
    this.next();
    var u2 = this.start, c2 = this.startLoc, l2 = this.parseExprOp(this.parseMaybeUnary(null, false), u2, c2, a2, i2), p2 = this.buildBinary(t2, r2, e25, l2, s2, o2);
    return this.parseExprOp(p2, t2, r2, n2, i2);
  }
  return e25;
}, Nf.buildBinary = function(e25, t2, r2, n2, i2, a2) {
  var o2 = this.startNodeAt(e25, t2);
  return o2.left = r2, o2.operator = i2, o2.right = n2, this.finishNode(o2, a2 ? "LogicalExpression" : "BinaryExpression");
}, Nf.parseMaybeUnary = function(e25, t2) {
  var r2, n2 = this.start, i2 = this.startLoc;
  if (this.isContextual("await") && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction))
    r2 = this.parseAwait(), t2 = true;
  else if (this.type.prefix) {
    var a2 = this.startNode(), o2 = this.type === tf.incDec;
    a2.operator = this.value, a2.prefix = true, this.next(), a2.argument = this.parseMaybeUnary(null, true), this.checkExpressionErrors(e25, true), o2 ? this.checkLVal(a2.argument) : this.strict && a2.operator === "delete" && a2.argument.type === "Identifier" ? this.raiseRecoverable(a2.start, "Deleting local variable in strict mode") : t2 = true, r2 = this.finishNode(a2, o2 ? "UpdateExpression" : "UnaryExpression");
  } else {
    if (r2 = this.parseExprSubscripts(e25), this.checkExpressionErrors(e25))
      return r2;
    for (; this.type.postfix && !this.canInsertSemicolon(); ) {
      var s2 = this.startNodeAt(n2, i2);
      s2.operator = this.value, s2.prefix = false, s2.argument = r2, this.checkLVal(r2), this.next(), r2 = this.finishNode(s2, "UpdateExpression");
    }
  }
  return !t2 && this.eat(tf.starstar) ? this.buildBinary(n2, i2, r2, this.parseMaybeUnary(null, false), "**", false) : r2;
}, Nf.parseExprSubscripts = function(e25) {
  var t2 = this.start, r2 = this.startLoc, n2 = this.parseExprAtom(e25), i2 = n2.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")";
  if (this.checkExpressionErrors(e25) || i2)
    return n2;
  var a2 = this.parseSubscripts(n2, t2, r2);
  return e25 && a2.type === "MemberExpression" && (e25.parenthesizedAssign >= a2.start && (e25.parenthesizedAssign = -1), e25.parenthesizedBind >= a2.start && (e25.parenthesizedBind = -1)), a2;
}, Nf.parseSubscripts = function(e25, t2, r2, n2) {
  for (var i2 = this.options.ecmaVersion >= 8 && e25.type === "Identifier" && e25.name === "async" && this.lastTokEnd === e25.end && !this.canInsertSemicolon() && this.input.slice(e25.start, e25.end) === "async"; ; ) {
    var a2 = this.parseSubscript(e25, t2, r2, n2, i2);
    if (a2 === e25 || a2.type === "ArrowFunctionExpression")
      return a2;
    e25 = a2;
  }
}, Nf.parseSubscript = function(e25, t2, r2, n2, i2) {
  var a2 = this.eat(tf.bracketL);
  if (a2 || this.eat(tf.dot)) {
    var o2 = this.startNodeAt(t2, r2);
    o2.object = e25, o2.property = a2 ? this.parseExpression() : this.parseIdent(this.options.allowReserved !== "never"), o2.computed = !!a2, a2 && this.expect(tf.bracketR), e25 = this.finishNode(o2, "MemberExpression");
  } else if (!n2 && this.eat(tf.parenL)) {
    var s2 = new wf(), u2 = this.yieldPos, c2 = this.awaitPos, l2 = this.awaitIdentPos;
    this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
    var p2 = this.parseExprList(tf.parenR, this.options.ecmaVersion >= 8, false, s2);
    if (i2 && !this.canInsertSemicolon() && this.eat(tf.arrow))
      return this.checkPatternErrors(s2, false), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = u2, this.awaitPos = c2, this.awaitIdentPos = l2, this.parseArrowExpression(this.startNodeAt(t2, r2), p2, true);
    this.checkExpressionErrors(s2, true), this.yieldPos = u2 || this.yieldPos, this.awaitPos = c2 || this.awaitPos, this.awaitIdentPos = l2 || this.awaitIdentPos;
    var f2 = this.startNodeAt(t2, r2);
    f2.callee = e25, f2.arguments = p2, e25 = this.finishNode(f2, "CallExpression");
  } else if (this.type === tf.backQuote) {
    var h2 = this.startNodeAt(t2, r2);
    h2.tag = e25, h2.quasi = this.parseTemplate({ isTagged: true }), e25 = this.finishNode(h2, "TaggedTemplateExpression");
  }
  return e25;
}, Nf.parseExprAtom = function(e25) {
  this.type === tf.slash && this.readRegexp();
  var t2, r2 = this.potentialArrowAt === this.start;
  switch (this.type) {
    case tf._super:
      return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), t2 = this.startNode(), this.next(), this.type !== tf.parenL || this.allowDirectSuper || this.raise(t2.start, "super() call outside constructor of a subclass"), this.type !== tf.dot && this.type !== tf.bracketL && this.type !== tf.parenL && this.unexpected(), this.finishNode(t2, "Super");
    case tf._this:
      return t2 = this.startNode(), this.next(), this.finishNode(t2, "ThisExpression");
    case tf.name:
      var n2 = this.start, i2 = this.startLoc, a2 = this.containsEsc, o2 = this.parseIdent(false);
      if (this.options.ecmaVersion >= 8 && !a2 && o2.name === "async" && !this.canInsertSemicolon() && this.eat(tf._function))
        return this.parseFunction(this.startNodeAt(n2, i2), 0, false, true);
      if (r2 && !this.canInsertSemicolon()) {
        if (this.eat(tf.arrow))
          return this.parseArrowExpression(this.startNodeAt(n2, i2), [o2], false);
        if (this.options.ecmaVersion >= 8 && o2.name === "async" && this.type === tf.name && !a2)
          return o2 = this.parseIdent(false), !this.canInsertSemicolon() && this.eat(tf.arrow) || this.unexpected(), this.parseArrowExpression(this.startNodeAt(n2, i2), [o2], true);
      }
      return o2;
    case tf.regexp:
      var s2 = this.value;
      return (t2 = this.parseLiteral(s2.value)).regex = { pattern: s2.pattern, flags: s2.flags }, t2;
    case tf.num:
    case tf.string:
      return this.parseLiteral(this.value);
    case tf._null:
    case tf._true:
    case tf._false:
      return (t2 = this.startNode()).value = this.type === tf._null ? null : this.type === tf._true, t2.raw = this.type.keyword, this.next(), this.finishNode(t2, "Literal");
    case tf.parenL:
      var u2 = this.start, c2 = this.parseParenAndDistinguishExpression(r2);
      return e25 && (e25.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(c2) && (e25.parenthesizedAssign = u2), e25.parenthesizedBind < 0 && (e25.parenthesizedBind = u2)), c2;
    case tf.bracketL:
      return t2 = this.startNode(), this.next(), t2.elements = this.parseExprList(tf.bracketR, true, true, e25), this.finishNode(t2, "ArrayExpression");
    case tf.braceL:
      return this.parseObj(false, e25);
    case tf._function:
      return t2 = this.startNode(), this.next(), this.parseFunction(t2, 0);
    case tf._class:
      return this.parseClass(this.startNode(), false);
    case tf._new:
      return this.parseNew();
    case tf.backQuote:
      return this.parseTemplate();
    case tf._import:
      return this.options.ecmaVersion >= 11 ? this.parseExprImport() : this.unexpected();
    default:
      this.unexpected();
  }
}, Nf.parseExprImport = function() {
  var e25 = this.startNode();
  switch (this.next(), this.type) {
    case tf.parenL:
      return this.parseDynamicImport(e25);
    default:
      this.unexpected();
  }
}, Nf.parseDynamicImport = function(e25) {
  if (this.next(), e25.source = this.parseMaybeAssign(), !this.eat(tf.parenR)) {
    var t2 = this.start;
    this.eat(tf.comma) && this.eat(tf.parenR) ? this.raiseRecoverable(t2, "Trailing comma is not allowed in import()") : this.unexpected(t2);
  }
  return this.finishNode(e25, "ImportExpression");
}, Nf.parseLiteral = function(e25) {
  var t2 = this.startNode();
  return t2.value = e25, t2.raw = this.input.slice(this.start, this.end), t2.raw.charCodeAt(t2.raw.length - 1) === 110 && (t2.bigint = t2.raw.slice(0, -1)), this.next(), this.finishNode(t2, "Literal");
}, Nf.parseParenExpression = function() {
  this.expect(tf.parenL);
  var e25 = this.parseExpression();
  return this.expect(tf.parenR), e25;
}, Nf.parseParenAndDistinguishExpression = function(e25) {
  var t2, r2 = this.start, n2 = this.startLoc, i2 = this.options.ecmaVersion >= 8;
  if (this.options.ecmaVersion >= 6) {
    this.next();
    var a2, o2 = this.start, s2 = this.startLoc, u2 = [], c2 = true, l2 = false, p2 = new wf(), f2 = this.yieldPos, h2 = this.awaitPos;
    for (this.yieldPos = 0, this.awaitPos = 0; this.type !== tf.parenR; ) {
      if (c2 ? c2 = false : this.expect(tf.comma), i2 && this.afterTrailingComma(tf.parenR, true)) {
        l2 = true;
        break;
      }
      if (this.type === tf.ellipsis) {
        a2 = this.start, u2.push(this.parseParenItem(this.parseRestBinding())), this.type === tf.comma && this.raise(this.start, "Comma is not permitted after the rest element");
        break;
      }
      u2.push(this.parseMaybeAssign(false, p2, this.parseParenItem));
    }
    var d2 = this.start, m2 = this.startLoc;
    if (this.expect(tf.parenR), e25 && !this.canInsertSemicolon() && this.eat(tf.arrow))
      return this.checkPatternErrors(p2, false), this.checkYieldAwaitInDefaultParams(), this.yieldPos = f2, this.awaitPos = h2, this.parseParenArrowList(r2, n2, u2);
    u2.length && !l2 || this.unexpected(this.lastTokStart), a2 && this.unexpected(a2), this.checkExpressionErrors(p2, true), this.yieldPos = f2 || this.yieldPos, this.awaitPos = h2 || this.awaitPos, u2.length > 1 ? ((t2 = this.startNodeAt(o2, s2)).expressions = u2, this.finishNodeAt(t2, "SequenceExpression", d2, m2)) : t2 = u2[0];
  } else
    t2 = this.parseParenExpression();
  if (this.options.preserveParens) {
    var g2 = this.startNodeAt(r2, n2);
    return g2.expression = t2, this.finishNode(g2, "ParenthesizedExpression");
  }
  return t2;
}, Nf.parseParenItem = function(e25) {
  return e25;
}, Nf.parseParenArrowList = function(e25, t2, r2) {
  return this.parseArrowExpression(this.startNodeAt(e25, t2), r2);
};
var jf = [];
Nf.parseNew = function() {
  var e25 = this.startNode(), t2 = this.parseIdent(true);
  if (this.options.ecmaVersion >= 6 && this.eat(tf.dot)) {
    e25.meta = t2;
    var r2 = this.containsEsc;
    return e25.property = this.parseIdent(true), (e25.property.name !== "target" || r2) && this.raiseRecoverable(e25.property.start, "The only valid meta property for new is new.target"), this.inNonArrowFunction() || this.raiseRecoverable(e25.start, "new.target can only be used in functions"), this.finishNode(e25, "MetaProperty");
  }
  var n2 = this.start, i2 = this.startLoc, a2 = this.type === tf._import;
  return e25.callee = this.parseSubscripts(this.parseExprAtom(), n2, i2, true), a2 && e25.callee.type === "ImportExpression" && this.raise(n2, "Cannot use new with import()"), this.eat(tf.parenL) ? e25.arguments = this.parseExprList(tf.parenR, this.options.ecmaVersion >= 8, false) : e25.arguments = jf, this.finishNode(e25, "NewExpression");
}, Nf.parseTemplateElement = function(e25) {
  var t2 = e25.isTagged, r2 = this.startNode();
  return this.type === tf.invalidTemplate ? (t2 || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), r2.value = { raw: this.value, cooked: null }) : r2.value = { raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"), cooked: this.value }, this.next(), r2.tail = this.type === tf.backQuote, this.finishNode(r2, "TemplateElement");
}, Nf.parseTemplate = function(e25) {
  e25 === void 0 && (e25 = {});
  var t2 = e25.isTagged;
  t2 === void 0 && (t2 = false);
  var r2 = this.startNode();
  this.next(), r2.expressions = [];
  var n2 = this.parseTemplateElement({ isTagged: t2 });
  for (r2.quasis = [n2]; !n2.tail; )
    this.type === tf.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(tf.dollarBraceL), r2.expressions.push(this.parseExpression()), this.expect(tf.braceR), r2.quasis.push(n2 = this.parseTemplateElement({ isTagged: t2 }));
  return this.next(), this.finishNode(r2, "TemplateLiteral");
}, Nf.isAsyncProp = function(e25) {
  return !e25.computed && e25.key.type === "Identifier" && e25.key.name === "async" && (this.type === tf.name || this.type === tf.num || this.type === tf.string || this.type === tf.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === tf.star) && !rf.test(this.input.slice(this.lastTokEnd, this.start));
}, Nf.parseObj = function(e25, t2) {
  var r2 = this.startNode(), n2 = true, i2 = {};
  for (r2.properties = [], this.next(); !this.eat(tf.braceR); ) {
    if (n2)
      n2 = false;
    else if (this.expect(tf.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(tf.braceR))
      break;
    var a2 = this.parseProperty(e25, t2);
    e25 || this.checkPropClash(a2, i2, t2), r2.properties.push(a2);
  }
  return this.finishNode(r2, e25 ? "ObjectPattern" : "ObjectExpression");
}, Nf.parseProperty = function(e25, t2) {
  var r2, n2, i2, a2, o2 = this.startNode();
  if (this.options.ecmaVersion >= 9 && this.eat(tf.ellipsis))
    return e25 ? (o2.argument = this.parseIdent(false), this.type === tf.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.finishNode(o2, "RestElement")) : (this.type === tf.parenL && t2 && (t2.parenthesizedAssign < 0 && (t2.parenthesizedAssign = this.start), t2.parenthesizedBind < 0 && (t2.parenthesizedBind = this.start)), o2.argument = this.parseMaybeAssign(false, t2), this.type === tf.comma && t2 && t2.trailingComma < 0 && (t2.trailingComma = this.start), this.finishNode(o2, "SpreadElement"));
  this.options.ecmaVersion >= 6 && (o2.method = false, o2.shorthand = false, (e25 || t2) && (i2 = this.start, a2 = this.startLoc), e25 || (r2 = this.eat(tf.star)));
  var s2 = this.containsEsc;
  return this.parsePropertyName(o2), !e25 && !s2 && this.options.ecmaVersion >= 8 && !r2 && this.isAsyncProp(o2) ? (n2 = true, r2 = this.options.ecmaVersion >= 9 && this.eat(tf.star), this.parsePropertyName(o2, t2)) : n2 = false, this.parsePropertyValue(o2, e25, r2, n2, i2, a2, t2, s2), this.finishNode(o2, "Property");
}, Nf.parsePropertyValue = function(e25, t2, r2, n2, i2, a2, o2, s2) {
  if ((r2 || n2) && this.type === tf.colon && this.unexpected(), this.eat(tf.colon))
    e25.value = t2 ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(false, o2), e25.kind = "init";
  else if (this.options.ecmaVersion >= 6 && this.type === tf.parenL)
    t2 && this.unexpected(), e25.kind = "init", e25.method = true, e25.value = this.parseMethod(r2, n2);
  else if (t2 || s2 || !(this.options.ecmaVersion >= 5) || e25.computed || e25.key.type !== "Identifier" || e25.key.name !== "get" && e25.key.name !== "set" || this.type === tf.comma || this.type === tf.braceR)
    this.options.ecmaVersion >= 6 && !e25.computed && e25.key.type === "Identifier" ? ((r2 || n2) && this.unexpected(), this.checkUnreserved(e25.key), e25.key.name !== "await" || this.awaitIdentPos || (this.awaitIdentPos = i2), e25.kind = "init", t2 ? e25.value = this.parseMaybeDefault(i2, a2, e25.key) : this.type === tf.eq && o2 ? (o2.shorthandAssign < 0 && (o2.shorthandAssign = this.start), e25.value = this.parseMaybeDefault(i2, a2, e25.key)) : e25.value = e25.key, e25.shorthand = true) : this.unexpected();
  else {
    (r2 || n2) && this.unexpected(), e25.kind = e25.key.name, this.parsePropertyName(e25), e25.value = this.parseMethod(false);
    var u2 = e25.kind === "get" ? 0 : 1;
    if (e25.value.params.length !== u2) {
      var c2 = e25.value.start;
      e25.kind === "get" ? this.raiseRecoverable(c2, "getter should have no params") : this.raiseRecoverable(c2, "setter should have exactly one param");
    } else
      e25.kind === "set" && e25.value.params[0].type === "RestElement" && this.raiseRecoverable(e25.value.params[0].start, "Setter cannot use rest params");
  }
}, Nf.parsePropertyName = function(e25) {
  if (this.options.ecmaVersion >= 6) {
    if (this.eat(tf.bracketL))
      return e25.computed = true, e25.key = this.parseMaybeAssign(), this.expect(tf.bracketR), e25.key;
    e25.computed = false;
  }
  return e25.key = this.type === tf.num || this.type === tf.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
}, Nf.initFunction = function(e25) {
  e25.id = null, this.options.ecmaVersion >= 6 && (e25.generator = e25.expression = false), this.options.ecmaVersion >= 8 && (e25.async = false);
}, Nf.parseMethod = function(e25, t2, r2) {
  var n2 = this.startNode(), i2 = this.yieldPos, a2 = this.awaitPos, o2 = this.awaitIdentPos;
  return this.initFunction(n2), this.options.ecmaVersion >= 6 && (n2.generator = e25), this.options.ecmaVersion >= 8 && (n2.async = !!t2), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(64 | Sf(t2, n2.generator) | (r2 ? 128 : 0)), this.expect(tf.parenL), n2.params = this.parseBindingList(tf.parenR, false, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(n2, false, true), this.yieldPos = i2, this.awaitPos = a2, this.awaitIdentPos = o2, this.finishNode(n2, "FunctionExpression");
}, Nf.parseArrowExpression = function(e25, t2, r2) {
  var n2 = this.yieldPos, i2 = this.awaitPos, a2 = this.awaitIdentPos;
  return this.enterScope(16 | Sf(r2, false)), this.initFunction(e25), this.options.ecmaVersion >= 8 && (e25.async = !!r2), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, e25.params = this.toAssignableList(t2, true), this.parseFunctionBody(e25, true, false), this.yieldPos = n2, this.awaitPos = i2, this.awaitIdentPos = a2, this.finishNode(e25, "ArrowFunctionExpression");
}, Nf.parseFunctionBody = function(e25, t2, r2) {
  var n2 = t2 && this.type !== tf.braceL, i2 = this.strict, a2 = false;
  if (n2)
    e25.body = this.parseMaybeAssign(), e25.expression = true, this.checkParams(e25, false);
  else {
    var o2 = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(e25.params);
    i2 && !o2 || (a2 = this.strictDirective(this.end)) && o2 && this.raiseRecoverable(e25.start, "Illegal 'use strict' directive in function with non-simple parameter list");
    var s2 = this.labels;
    this.labels = [], a2 && (this.strict = true), this.checkParams(e25, !i2 && !a2 && !t2 && !r2 && this.isSimpleParamList(e25.params)), e25.body = this.parseBlock(false), e25.expression = false, this.adaptDirectivePrologue(e25.body.body), this.labels = s2;
  }
  this.exitScope(), this.strict && e25.id && this.checkLVal(e25.id, 5), this.strict = i2;
}, Nf.isSimpleParamList = function(e25) {
  for (var t2 = 0, r2 = e25; t2 < r2.length; t2 += 1) {
    if (r2[t2].type !== "Identifier")
      return false;
  }
  return true;
}, Nf.checkParams = function(e25, t2) {
  for (var r2 = {}, n2 = 0, i2 = e25.params; n2 < i2.length; n2 += 1) {
    var a2 = i2[n2];
    this.checkLVal(a2, 1, t2 ? null : r2);
  }
}, Nf.parseExprList = function(e25, t2, r2, n2) {
  for (var i2 = [], a2 = true; !this.eat(e25); ) {
    if (a2)
      a2 = false;
    else if (this.expect(tf.comma), t2 && this.afterTrailingComma(e25))
      break;
    var o2 = void 0;
    r2 && this.type === tf.comma ? o2 = null : this.type === tf.ellipsis ? (o2 = this.parseSpread(n2), n2 && this.type === tf.comma && n2.trailingComma < 0 && (n2.trailingComma = this.start)) : o2 = this.parseMaybeAssign(false, n2), i2.push(o2);
  }
  return i2;
}, Nf.checkUnreserved = function(e25) {
  var t2 = e25.start, r2 = e25.end, n2 = e25.name;
  (this.inGenerator && n2 === "yield" && this.raiseRecoverable(t2, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && n2 === "await" && this.raiseRecoverable(t2, "Cannot use 'await' as identifier inside an async function"), this.keywords.test(n2) && this.raise(t2, "Unexpected keyword '" + n2 + "'"), this.options.ecmaVersion < 6 && this.input.slice(t2, r2).indexOf("\\") !== -1) || (this.strict ? this.reservedWordsStrict : this.reservedWords).test(n2) && (this.inAsync || n2 !== "await" || this.raiseRecoverable(t2, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(t2, "The keyword '" + n2 + "' is reserved"));
}, Nf.parseIdent = function(e25, t2) {
  var r2 = this.startNode();
  return this.type === tf.name ? r2.name = this.value : this.type.keyword ? (r2.name = this.type.keyword, r2.name !== "class" && r2.name !== "function" || this.lastTokEnd === this.lastTokStart + 1 && this.input.charCodeAt(this.lastTokStart) === 46 || this.context.pop()) : this.unexpected(), this.next(), this.finishNode(r2, "Identifier"), e25 || (this.checkUnreserved(r2), r2.name !== "await" || this.awaitIdentPos || (this.awaitIdentPos = r2.start)), r2;
}, Nf.parseYield = function(e25) {
  this.yieldPos || (this.yieldPos = this.start);
  var t2 = this.startNode();
  return this.next(), this.type === tf.semi || this.canInsertSemicolon() || this.type !== tf.star && !this.type.startsExpr ? (t2.delegate = false, t2.argument = null) : (t2.delegate = this.eat(tf.star), t2.argument = this.parseMaybeAssign(e25)), this.finishNode(t2, "YieldExpression");
}, Nf.parseAwait = function() {
  this.awaitPos || (this.awaitPos = this.start);
  var e25 = this.startNode();
  return this.next(), e25.argument = this.parseMaybeUnary(null, true), this.finishNode(e25, "AwaitExpression");
};
var Rf = kf.prototype;
Rf.raise = function(e25, t2) {
  var r2 = gf(this.input, e25);
  t2 += " (" + r2.line + ":" + r2.column + ")";
  var n2 = new SyntaxError(t2);
  throw n2.pos = e25, n2.loc = r2, n2.raisedAt = this.pos, n2;
}, Rf.raiseRecoverable = Rf.raise, Rf.curPosition = function() {
  if (this.options.locations)
    return new df(this.curLine, this.pos - this.lineStart);
};
var Mf = kf.prototype, Vf = function(e25) {
  this.flags = e25, this.var = [], this.lexical = [], this.functions = [];
};
Mf.enterScope = function(e25) {
  this.scopeStack.push(new Vf(e25));
}, Mf.exitScope = function() {
  this.scopeStack.pop();
}, Mf.treatFunctionsAsVarInScope = function(e25) {
  return e25.flags & xf || !this.inModule && 1 & e25.flags;
}, Mf.declareName = function(e25, t2, r2) {
  var n2 = false;
  if (t2 === 2) {
    var i2 = this.currentScope();
    n2 = i2.lexical.indexOf(e25) > -1 || i2.functions.indexOf(e25) > -1 || i2.var.indexOf(e25) > -1, i2.lexical.push(e25), this.inModule && 1 & i2.flags && delete this.undefinedExports[e25];
  } else if (t2 === 4) {
    this.currentScope().lexical.push(e25);
  } else if (t2 === 3) {
    var a2 = this.currentScope();
    n2 = this.treatFunctionsAsVar ? a2.lexical.indexOf(e25) > -1 : a2.lexical.indexOf(e25) > -1 || a2.var.indexOf(e25) > -1, a2.functions.push(e25);
  } else
    for (var o2 = this.scopeStack.length - 1; o2 >= 0; --o2) {
      var s2 = this.scopeStack[o2];
      if (s2.lexical.indexOf(e25) > -1 && !(32 & s2.flags && s2.lexical[0] === e25) || !this.treatFunctionsAsVarInScope(s2) && s2.functions.indexOf(e25) > -1) {
        n2 = true;
        break;
      }
      if (s2.var.push(e25), this.inModule && 1 & s2.flags && delete this.undefinedExports[e25], s2.flags & bf)
        break;
    }
  n2 && this.raiseRecoverable(r2, "Identifier '" + e25 + "' has already been declared");
}, Mf.checkLocalExport = function(e25) {
  this.scopeStack[0].lexical.indexOf(e25.name) === -1 && this.scopeStack[0].var.indexOf(e25.name) === -1 && (this.undefinedExports[e25.name] = e25);
}, Mf.currentScope = function() {
  return this.scopeStack[this.scopeStack.length - 1];
}, Mf.currentVarScope = function() {
  for (var e25 = this.scopeStack.length - 1; ; e25--) {
    var t2 = this.scopeStack[e25];
    if (t2.flags & bf)
      return t2;
  }
}, Mf.currentThisScope = function() {
  for (var e25 = this.scopeStack.length - 1; ; e25--) {
    var t2 = this.scopeStack[e25];
    if (t2.flags & bf && !(16 & t2.flags))
      return t2;
  }
};
var Uf = function(e25, t2, r2) {
  this.type = "", this.start = t2, this.end = 0, e25.options.locations && (this.loc = new mf(e25, r2)), e25.options.directSourceFile && (this.sourceFile = e25.options.directSourceFile), e25.options.ranges && (this.range = [t2, 0]);
}, qf = kf.prototype;
function Wf(e25, t2, r2, n2) {
  return e25.type = t2, e25.end = r2, this.options.locations && (e25.loc.end = n2), this.options.ranges && (e25.range[1] = r2), e25;
}
qf.startNode = function() {
  return new Uf(this, this.start, this.startLoc);
}, qf.startNodeAt = function(e25, t2) {
  return new Uf(this, e25, t2);
}, qf.finishNode = function(e25, t2) {
  return Wf.call(this, e25, t2, this.lastTokEnd, this.lastTokEndLoc);
}, qf.finishNodeAt = function(e25, t2, r2, n2) {
  return Wf.call(this, e25, t2, r2, n2);
};
var $f = function(e25, t2, r2, n2, i2) {
  this.token = e25, this.isExpr = !!t2, this.preserveSpace = !!r2, this.override = n2, this.generator = !!i2;
}, Gf = { b_stat: new $f("{", false), b_expr: new $f("{", true), b_tmpl: new $f("${", false), p_stat: new $f("(", false), p_expr: new $f("(", true), q_tmpl: new $f("`", true, true, function(e25) {
  return e25.tryReadTemplateToken();
}), f_stat: new $f("function", false), f_expr: new $f("function", true), f_expr_gen: new $f("function", true, false, null, true), f_gen: new $f("function", false, false, null, true) }, zf = kf.prototype;
zf.initialContext = function() {
  return [Gf.b_stat];
}, zf.braceIsBlock = function(e25) {
  var t2 = this.curContext();
  return t2 === Gf.f_expr || t2 === Gf.f_stat || (e25 !== tf.colon || t2 !== Gf.b_stat && t2 !== Gf.b_expr ? e25 === tf._return || e25 === tf.name && this.exprAllowed ? rf.test(this.input.slice(this.lastTokEnd, this.start)) : e25 === tf._else || e25 === tf.semi || e25 === tf.eof || e25 === tf.parenR || e25 === tf.arrow || (e25 === tf.braceL ? t2 === Gf.b_stat : e25 !== tf._var && e25 !== tf._const && e25 !== tf.name && !this.exprAllowed) : !t2.isExpr);
}, zf.inGeneratorContext = function() {
  for (var e25 = this.context.length - 1; e25 >= 1; e25--) {
    var t2 = this.context[e25];
    if (t2.token === "function")
      return t2.generator;
  }
  return false;
}, zf.updateContext = function(e25) {
  var t2, r2 = this.type;
  r2.keyword && e25 === tf.dot ? this.exprAllowed = false : (t2 = r2.updateContext) ? t2.call(this, e25) : this.exprAllowed = r2.beforeExpr;
}, tf.parenR.updateContext = tf.braceR.updateContext = function() {
  if (this.context.length !== 1) {
    var e25 = this.context.pop();
    e25 === Gf.b_stat && this.curContext().token === "function" && (e25 = this.context.pop()), this.exprAllowed = !e25.isExpr;
  } else
    this.exprAllowed = true;
}, tf.braceL.updateContext = function(e25) {
  this.context.push(this.braceIsBlock(e25) ? Gf.b_stat : Gf.b_expr), this.exprAllowed = true;
}, tf.dollarBraceL.updateContext = function() {
  this.context.push(Gf.b_tmpl), this.exprAllowed = true;
}, tf.parenL.updateContext = function(e25) {
  var t2 = e25 === tf._if || e25 === tf._for || e25 === tf._with || e25 === tf._while;
  this.context.push(t2 ? Gf.p_stat : Gf.p_expr), this.exprAllowed = true;
}, tf.incDec.updateContext = function() {
}, tf._function.updateContext = tf._class.updateContext = function(e25) {
  !e25.beforeExpr || e25 === tf.semi || e25 === tf._else || e25 === tf._return && rf.test(this.input.slice(this.lastTokEnd, this.start)) || (e25 === tf.colon || e25 === tf.braceL) && this.curContext() === Gf.b_stat ? this.context.push(Gf.f_stat) : this.context.push(Gf.f_expr), this.exprAllowed = false;
}, tf.backQuote.updateContext = function() {
  this.curContext() === Gf.q_tmpl ? this.context.pop() : this.context.push(Gf.q_tmpl), this.exprAllowed = false;
}, tf.star.updateContext = function(e25) {
  if (e25 === tf._function) {
    var t2 = this.context.length - 1;
    this.context[t2] === Gf.f_expr ? this.context[t2] = Gf.f_expr_gen : this.context[t2] = Gf.f_gen;
  }
  this.exprAllowed = true;
}, tf.name.updateContext = function(e25) {
  var t2 = false;
  this.options.ecmaVersion >= 6 && e25 !== tf.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (t2 = true), this.exprAllowed = t2;
};
var Hf = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", Kf = Hf + " Extended_Pictographic", Jf = { 9: Hf, 10: Kf, 11: "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS Extended_Pictographic" }, Qf = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", Xf = "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", Yf = Xf + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", Zf = { 9: Xf, 10: Yf, 11: "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho" }, eh = {};
function th(e25) {
  var t2 = eh[e25] = { binary: hf(Jf[e25] + " " + Qf), nonBinary: { General_Category: hf(Qf), Script: hf(Zf[e25]) } };
  t2.nonBinary.Script_Extensions = t2.nonBinary.Script, t2.nonBinary.gc = t2.nonBinary.General_Category, t2.nonBinary.sc = t2.nonBinary.Script, t2.nonBinary.scx = t2.nonBinary.Script_Extensions;
}
th(9), th(10), th(11);
var rh = kf.prototype, nh = function(e25) {
  this.parser = e25, this.validFlags = "gim" + (e25.options.ecmaVersion >= 6 ? "uy" : "") + (e25.options.ecmaVersion >= 9 ? "s" : ""), this.unicodeProperties = eh[e25.options.ecmaVersion >= 11 ? 11 : e25.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = false, this.switchN = false, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = false, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = [], this.backReferenceNames = [];
};
function ih(e25) {
  return e25 <= 65535 ? String.fromCharCode(e25) : (e25 -= 65536, String.fromCharCode(55296 + (e25 >> 10), 56320 + (1023 & e25)));
}
function ah(e25) {
  return e25 === 36 || e25 >= 40 && e25 <= 43 || e25 === 46 || e25 === 63 || e25 >= 91 && e25 <= 94 || e25 >= 123 && e25 <= 125;
}
function oh(e25) {
  return e25 >= 65 && e25 <= 90 || e25 >= 97 && e25 <= 122;
}
function sh(e25) {
  return oh(e25) || e25 === 95;
}
function uh(e25) {
  return sh(e25) || ch(e25);
}
function ch(e25) {
  return e25 >= 48 && e25 <= 57;
}
function lh(e25) {
  return e25 >= 48 && e25 <= 57 || e25 >= 65 && e25 <= 70 || e25 >= 97 && e25 <= 102;
}
function ph(e25) {
  return e25 >= 65 && e25 <= 70 ? e25 - 65 + 10 : e25 >= 97 && e25 <= 102 ? e25 - 97 + 10 : e25 - 48;
}
function fh(e25) {
  return e25 >= 48 && e25 <= 55;
}
nh.prototype.reset = function(e25, t2, r2) {
  var n2 = r2.indexOf("u") !== -1;
  this.start = 0 | e25, this.source = t2 + "", this.flags = r2, this.switchU = n2 && this.parser.options.ecmaVersion >= 6, this.switchN = n2 && this.parser.options.ecmaVersion >= 9;
}, nh.prototype.raise = function(e25) {
  this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + e25);
}, nh.prototype.at = function(e25) {
  var t2 = this.source, r2 = t2.length;
  if (e25 >= r2)
    return -1;
  var n2 = t2.charCodeAt(e25);
  return !this.switchU || n2 <= 55295 || n2 >= 57344 || e25 + 1 >= r2 ? n2 : (n2 << 10) + t2.charCodeAt(e25 + 1) - 56613888;
}, nh.prototype.nextIndex = function(e25) {
  var t2 = this.source, r2 = t2.length;
  if (e25 >= r2)
    return r2;
  var n2 = t2.charCodeAt(e25);
  return !this.switchU || n2 <= 55295 || n2 >= 57344 || e25 + 1 >= r2 ? e25 + 1 : e25 + 2;
}, nh.prototype.current = function() {
  return this.at(this.pos);
}, nh.prototype.lookahead = function() {
  return this.at(this.nextIndex(this.pos));
}, nh.prototype.advance = function() {
  this.pos = this.nextIndex(this.pos);
}, nh.prototype.eat = function(e25) {
  return this.current() === e25 && (this.advance(), true);
}, rh.validateRegExpFlags = function(e25) {
  for (var t2 = e25.validFlags, r2 = e25.flags, n2 = 0; n2 < r2.length; n2++) {
    var i2 = r2.charAt(n2);
    t2.indexOf(i2) === -1 && this.raise(e25.start, "Invalid regular expression flag"), r2.indexOf(i2, n2 + 1) > -1 && this.raise(e25.start, "Duplicate regular expression flag");
  }
}, rh.validateRegExpPattern = function(e25) {
  this.regexp_pattern(e25), !e25.switchN && this.options.ecmaVersion >= 9 && e25.groupNames.length > 0 && (e25.switchN = true, this.regexp_pattern(e25));
}, rh.regexp_pattern = function(e25) {
  e25.pos = 0, e25.lastIntValue = 0, e25.lastStringValue = "", e25.lastAssertionIsQuantifiable = false, e25.numCapturingParens = 0, e25.maxBackReference = 0, e25.groupNames.length = 0, e25.backReferenceNames.length = 0, this.regexp_disjunction(e25), e25.pos !== e25.source.length && (e25.eat(41) && e25.raise("Unmatched ')'"), (e25.eat(93) || e25.eat(125)) && e25.raise("Lone quantifier brackets")), e25.maxBackReference > e25.numCapturingParens && e25.raise("Invalid escape");
  for (var t2 = 0, r2 = e25.backReferenceNames; t2 < r2.length; t2 += 1) {
    var n2 = r2[t2];
    e25.groupNames.indexOf(n2) === -1 && e25.raise("Invalid named capture referenced");
  }
}, rh.regexp_disjunction = function(e25) {
  for (this.regexp_alternative(e25); e25.eat(124); )
    this.regexp_alternative(e25);
  this.regexp_eatQuantifier(e25, true) && e25.raise("Nothing to repeat"), e25.eat(123) && e25.raise("Lone quantifier brackets");
}, rh.regexp_alternative = function(e25) {
  for (; e25.pos < e25.source.length && this.regexp_eatTerm(e25); )
    ;
}, rh.regexp_eatTerm = function(e25) {
  return this.regexp_eatAssertion(e25) ? (e25.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(e25) && e25.switchU && e25.raise("Invalid quantifier"), true) : !(e25.switchU ? !this.regexp_eatAtom(e25) : !this.regexp_eatExtendedAtom(e25)) && (this.regexp_eatQuantifier(e25), true);
}, rh.regexp_eatAssertion = function(e25) {
  var t2 = e25.pos;
  if (e25.lastAssertionIsQuantifiable = false, e25.eat(94) || e25.eat(36))
    return true;
  if (e25.eat(92)) {
    if (e25.eat(66) || e25.eat(98))
      return true;
    e25.pos = t2;
  }
  if (e25.eat(40) && e25.eat(63)) {
    var r2 = false;
    if (this.options.ecmaVersion >= 9 && (r2 = e25.eat(60)), e25.eat(61) || e25.eat(33))
      return this.regexp_disjunction(e25), e25.eat(41) || e25.raise("Unterminated group"), e25.lastAssertionIsQuantifiable = !r2, true;
  }
  return e25.pos = t2, false;
}, rh.regexp_eatQuantifier = function(e25, t2) {
  return t2 === void 0 && (t2 = false), !!this.regexp_eatQuantifierPrefix(e25, t2) && (e25.eat(63), true);
}, rh.regexp_eatQuantifierPrefix = function(e25, t2) {
  return e25.eat(42) || e25.eat(43) || e25.eat(63) || this.regexp_eatBracedQuantifier(e25, t2);
}, rh.regexp_eatBracedQuantifier = function(e25, t2) {
  var r2 = e25.pos;
  if (e25.eat(123)) {
    var n2 = 0, i2 = -1;
    if (this.regexp_eatDecimalDigits(e25) && (n2 = e25.lastIntValue, e25.eat(44) && this.regexp_eatDecimalDigits(e25) && (i2 = e25.lastIntValue), e25.eat(125)))
      return i2 !== -1 && i2 < n2 && !t2 && e25.raise("numbers out of order in {} quantifier"), true;
    e25.switchU && !t2 && e25.raise("Incomplete quantifier"), e25.pos = r2;
  }
  return false;
}, rh.regexp_eatAtom = function(e25) {
  return this.regexp_eatPatternCharacters(e25) || e25.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e25) || this.regexp_eatCharacterClass(e25) || this.regexp_eatUncapturingGroup(e25) || this.regexp_eatCapturingGroup(e25);
}, rh.regexp_eatReverseSolidusAtomEscape = function(e25) {
  var t2 = e25.pos;
  if (e25.eat(92)) {
    if (this.regexp_eatAtomEscape(e25))
      return true;
    e25.pos = t2;
  }
  return false;
}, rh.regexp_eatUncapturingGroup = function(e25) {
  var t2 = e25.pos;
  if (e25.eat(40)) {
    if (e25.eat(63) && e25.eat(58)) {
      if (this.regexp_disjunction(e25), e25.eat(41))
        return true;
      e25.raise("Unterminated group");
    }
    e25.pos = t2;
  }
  return false;
}, rh.regexp_eatCapturingGroup = function(e25) {
  if (e25.eat(40)) {
    if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(e25) : e25.current() === 63 && e25.raise("Invalid group"), this.regexp_disjunction(e25), e25.eat(41))
      return e25.numCapturingParens += 1, true;
    e25.raise("Unterminated group");
  }
  return false;
}, rh.regexp_eatExtendedAtom = function(e25) {
  return e25.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e25) || this.regexp_eatCharacterClass(e25) || this.regexp_eatUncapturingGroup(e25) || this.regexp_eatCapturingGroup(e25) || this.regexp_eatInvalidBracedQuantifier(e25) || this.regexp_eatExtendedPatternCharacter(e25);
}, rh.regexp_eatInvalidBracedQuantifier = function(e25) {
  return this.regexp_eatBracedQuantifier(e25, true) && e25.raise("Nothing to repeat"), false;
}, rh.regexp_eatSyntaxCharacter = function(e25) {
  var t2 = e25.current();
  return !!ah(t2) && (e25.lastIntValue = t2, e25.advance(), true);
}, rh.regexp_eatPatternCharacters = function(e25) {
  for (var t2 = e25.pos, r2 = 0; (r2 = e25.current()) !== -1 && !ah(r2); )
    e25.advance();
  return e25.pos !== t2;
}, rh.regexp_eatExtendedPatternCharacter = function(e25) {
  var t2 = e25.current();
  return !(t2 === -1 || t2 === 36 || t2 >= 40 && t2 <= 43 || t2 === 46 || t2 === 63 || t2 === 91 || t2 === 94 || t2 === 124) && (e25.advance(), true);
}, rh.regexp_groupSpecifier = function(e25) {
  if (e25.eat(63)) {
    if (this.regexp_eatGroupName(e25))
      return e25.groupNames.indexOf(e25.lastStringValue) !== -1 && e25.raise("Duplicate capture group name"), void e25.groupNames.push(e25.lastStringValue);
    e25.raise("Invalid group");
  }
}, rh.regexp_eatGroupName = function(e25) {
  if (e25.lastStringValue = "", e25.eat(60)) {
    if (this.regexp_eatRegExpIdentifierName(e25) && e25.eat(62))
      return true;
    e25.raise("Invalid capture group name");
  }
  return false;
}, rh.regexp_eatRegExpIdentifierName = function(e25) {
  if (e25.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(e25)) {
    for (e25.lastStringValue += ih(e25.lastIntValue); this.regexp_eatRegExpIdentifierPart(e25); )
      e25.lastStringValue += ih(e25.lastIntValue);
    return true;
  }
  return false;
}, rh.regexp_eatRegExpIdentifierStart = function(e25) {
  var t2 = e25.pos, r2 = e25.current();
  return e25.advance(), r2 === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e25) && (r2 = e25.lastIntValue), function(e26) {
    return Hp(e26, true) || e26 === 36 || e26 === 95;
  }(r2) ? (e25.lastIntValue = r2, true) : (e25.pos = t2, false);
}, rh.regexp_eatRegExpIdentifierPart = function(e25) {
  var t2 = e25.pos, r2 = e25.current();
  return e25.advance(), r2 === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e25) && (r2 = e25.lastIntValue), function(e26) {
    return Kp(e26, true) || e26 === 36 || e26 === 95 || e26 === 8204 || e26 === 8205;
  }(r2) ? (e25.lastIntValue = r2, true) : (e25.pos = t2, false);
}, rh.regexp_eatAtomEscape = function(e25) {
  return !!(this.regexp_eatBackReference(e25) || this.regexp_eatCharacterClassEscape(e25) || this.regexp_eatCharacterEscape(e25) || e25.switchN && this.regexp_eatKGroupName(e25)) || (e25.switchU && (e25.current() === 99 && e25.raise("Invalid unicode escape"), e25.raise("Invalid escape")), false);
}, rh.regexp_eatBackReference = function(e25) {
  var t2 = e25.pos;
  if (this.regexp_eatDecimalEscape(e25)) {
    var r2 = e25.lastIntValue;
    if (e25.switchU)
      return r2 > e25.maxBackReference && (e25.maxBackReference = r2), true;
    if (r2 <= e25.numCapturingParens)
      return true;
    e25.pos = t2;
  }
  return false;
}, rh.regexp_eatKGroupName = function(e25) {
  if (e25.eat(107)) {
    if (this.regexp_eatGroupName(e25))
      return e25.backReferenceNames.push(e25.lastStringValue), true;
    e25.raise("Invalid named reference");
  }
  return false;
}, rh.regexp_eatCharacterEscape = function(e25) {
  return this.regexp_eatControlEscape(e25) || this.regexp_eatCControlLetter(e25) || this.regexp_eatZero(e25) || this.regexp_eatHexEscapeSequence(e25) || this.regexp_eatRegExpUnicodeEscapeSequence(e25) || !e25.switchU && this.regexp_eatLegacyOctalEscapeSequence(e25) || this.regexp_eatIdentityEscape(e25);
}, rh.regexp_eatCControlLetter = function(e25) {
  var t2 = e25.pos;
  if (e25.eat(99)) {
    if (this.regexp_eatControlLetter(e25))
      return true;
    e25.pos = t2;
  }
  return false;
}, rh.regexp_eatZero = function(e25) {
  return e25.current() === 48 && !ch(e25.lookahead()) && (e25.lastIntValue = 0, e25.advance(), true);
}, rh.regexp_eatControlEscape = function(e25) {
  var t2 = e25.current();
  return t2 === 116 ? (e25.lastIntValue = 9, e25.advance(), true) : t2 === 110 ? (e25.lastIntValue = 10, e25.advance(), true) : t2 === 118 ? (e25.lastIntValue = 11, e25.advance(), true) : t2 === 102 ? (e25.lastIntValue = 12, e25.advance(), true) : t2 === 114 && (e25.lastIntValue = 13, e25.advance(), true);
}, rh.regexp_eatControlLetter = function(e25) {
  var t2 = e25.current();
  return !!oh(t2) && (e25.lastIntValue = t2 % 32, e25.advance(), true);
}, rh.regexp_eatRegExpUnicodeEscapeSequence = function(e25) {
  var t2, r2 = e25.pos;
  if (e25.eat(117)) {
    if (this.regexp_eatFixedHexDigits(e25, 4)) {
      var n2 = e25.lastIntValue;
      if (e25.switchU && n2 >= 55296 && n2 <= 56319) {
        var i2 = e25.pos;
        if (e25.eat(92) && e25.eat(117) && this.regexp_eatFixedHexDigits(e25, 4)) {
          var a2 = e25.lastIntValue;
          if (a2 >= 56320 && a2 <= 57343)
            return e25.lastIntValue = 1024 * (n2 - 55296) + (a2 - 56320) + 65536, true;
        }
        e25.pos = i2, e25.lastIntValue = n2;
      }
      return true;
    }
    if (e25.switchU && e25.eat(123) && this.regexp_eatHexDigits(e25) && e25.eat(125) && ((t2 = e25.lastIntValue) >= 0 && t2 <= 1114111))
      return true;
    e25.switchU && e25.raise("Invalid unicode escape"), e25.pos = r2;
  }
  return false;
}, rh.regexp_eatIdentityEscape = function(e25) {
  if (e25.switchU)
    return !!this.regexp_eatSyntaxCharacter(e25) || !!e25.eat(47) && (e25.lastIntValue = 47, true);
  var t2 = e25.current();
  return !(t2 === 99 || e25.switchN && t2 === 107) && (e25.lastIntValue = t2, e25.advance(), true);
}, rh.regexp_eatDecimalEscape = function(e25) {
  e25.lastIntValue = 0;
  var t2 = e25.current();
  if (t2 >= 49 && t2 <= 57) {
    do {
      e25.lastIntValue = 10 * e25.lastIntValue + (t2 - 48), e25.advance();
    } while ((t2 = e25.current()) >= 48 && t2 <= 57);
    return true;
  }
  return false;
}, rh.regexp_eatCharacterClassEscape = function(e25) {
  var t2 = e25.current();
  if (function(e26) {
    return e26 === 100 || e26 === 68 || e26 === 115 || e26 === 83 || e26 === 119 || e26 === 87;
  }(t2))
    return e25.lastIntValue = -1, e25.advance(), true;
  if (e25.switchU && this.options.ecmaVersion >= 9 && (t2 === 80 || t2 === 112)) {
    if (e25.lastIntValue = -1, e25.advance(), e25.eat(123) && this.regexp_eatUnicodePropertyValueExpression(e25) && e25.eat(125))
      return true;
    e25.raise("Invalid property name");
  }
  return false;
}, rh.regexp_eatUnicodePropertyValueExpression = function(e25) {
  var t2 = e25.pos;
  if (this.regexp_eatUnicodePropertyName(e25) && e25.eat(61)) {
    var r2 = e25.lastStringValue;
    if (this.regexp_eatUnicodePropertyValue(e25)) {
      var n2 = e25.lastStringValue;
      return this.regexp_validateUnicodePropertyNameAndValue(e25, r2, n2), true;
    }
  }
  if (e25.pos = t2, this.regexp_eatLoneUnicodePropertyNameOrValue(e25)) {
    var i2 = e25.lastStringValue;
    return this.regexp_validateUnicodePropertyNameOrValue(e25, i2), true;
  }
  return false;
}, rh.regexp_validateUnicodePropertyNameAndValue = function(e25, t2, r2) {
  pf(e25.unicodeProperties.nonBinary, t2) || e25.raise("Invalid property name"), e25.unicodeProperties.nonBinary[t2].test(r2) || e25.raise("Invalid property value");
}, rh.regexp_validateUnicodePropertyNameOrValue = function(e25, t2) {
  e25.unicodeProperties.binary.test(t2) || e25.raise("Invalid property name");
}, rh.regexp_eatUnicodePropertyName = function(e25) {
  var t2 = 0;
  for (e25.lastStringValue = ""; sh(t2 = e25.current()); )
    e25.lastStringValue += ih(t2), e25.advance();
  return e25.lastStringValue !== "";
}, rh.regexp_eatUnicodePropertyValue = function(e25) {
  var t2 = 0;
  for (e25.lastStringValue = ""; uh(t2 = e25.current()); )
    e25.lastStringValue += ih(t2), e25.advance();
  return e25.lastStringValue !== "";
}, rh.regexp_eatLoneUnicodePropertyNameOrValue = function(e25) {
  return this.regexp_eatUnicodePropertyValue(e25);
}, rh.regexp_eatCharacterClass = function(e25) {
  if (e25.eat(91)) {
    if (e25.eat(94), this.regexp_classRanges(e25), e25.eat(93))
      return true;
    e25.raise("Unterminated character class");
  }
  return false;
}, rh.regexp_classRanges = function(e25) {
  for (; this.regexp_eatClassAtom(e25); ) {
    var t2 = e25.lastIntValue;
    if (e25.eat(45) && this.regexp_eatClassAtom(e25)) {
      var r2 = e25.lastIntValue;
      !e25.switchU || t2 !== -1 && r2 !== -1 || e25.raise("Invalid character class"), t2 !== -1 && r2 !== -1 && t2 > r2 && e25.raise("Range out of order in character class");
    }
  }
}, rh.regexp_eatClassAtom = function(e25) {
  var t2 = e25.pos;
  if (e25.eat(92)) {
    if (this.regexp_eatClassEscape(e25))
      return true;
    if (e25.switchU) {
      var r2 = e25.current();
      (r2 === 99 || fh(r2)) && e25.raise("Invalid class escape"), e25.raise("Invalid escape");
    }
    e25.pos = t2;
  }
  var n2 = e25.current();
  return n2 !== 93 && (e25.lastIntValue = n2, e25.advance(), true);
}, rh.regexp_eatClassEscape = function(e25) {
  var t2 = e25.pos;
  if (e25.eat(98))
    return e25.lastIntValue = 8, true;
  if (e25.switchU && e25.eat(45))
    return e25.lastIntValue = 45, true;
  if (!e25.switchU && e25.eat(99)) {
    if (this.regexp_eatClassControlLetter(e25))
      return true;
    e25.pos = t2;
  }
  return this.regexp_eatCharacterClassEscape(e25) || this.regexp_eatCharacterEscape(e25);
}, rh.regexp_eatClassControlLetter = function(e25) {
  var t2 = e25.current();
  return !(!ch(t2) && t2 !== 95) && (e25.lastIntValue = t2 % 32, e25.advance(), true);
}, rh.regexp_eatHexEscapeSequence = function(e25) {
  var t2 = e25.pos;
  if (e25.eat(120)) {
    if (this.regexp_eatFixedHexDigits(e25, 2))
      return true;
    e25.switchU && e25.raise("Invalid escape"), e25.pos = t2;
  }
  return false;
}, rh.regexp_eatDecimalDigits = function(e25) {
  var t2 = e25.pos, r2 = 0;
  for (e25.lastIntValue = 0; ch(r2 = e25.current()); )
    e25.lastIntValue = 10 * e25.lastIntValue + (r2 - 48), e25.advance();
  return e25.pos !== t2;
}, rh.regexp_eatHexDigits = function(e25) {
  var t2 = e25.pos, r2 = 0;
  for (e25.lastIntValue = 0; lh(r2 = e25.current()); )
    e25.lastIntValue = 16 * e25.lastIntValue + ph(r2), e25.advance();
  return e25.pos !== t2;
}, rh.regexp_eatLegacyOctalEscapeSequence = function(e25) {
  if (this.regexp_eatOctalDigit(e25)) {
    var t2 = e25.lastIntValue;
    if (this.regexp_eatOctalDigit(e25)) {
      var r2 = e25.lastIntValue;
      t2 <= 3 && this.regexp_eatOctalDigit(e25) ? e25.lastIntValue = 64 * t2 + 8 * r2 + e25.lastIntValue : e25.lastIntValue = 8 * t2 + r2;
    } else
      e25.lastIntValue = t2;
    return true;
  }
  return false;
}, rh.regexp_eatOctalDigit = function(e25) {
  var t2 = e25.current();
  return fh(t2) ? (e25.lastIntValue = t2 - 48, e25.advance(), true) : (e25.lastIntValue = 0, false);
}, rh.regexp_eatFixedHexDigits = function(e25, t2) {
  var r2 = e25.pos;
  e25.lastIntValue = 0;
  for (var n2 = 0; n2 < t2; ++n2) {
    var i2 = e25.current();
    if (!lh(i2))
      return e25.pos = r2, false;
    e25.lastIntValue = 16 * e25.lastIntValue + ph(i2), e25.advance();
  }
  return true;
};
var hh = function(e25) {
  this.type = e25.type, this.value = e25.value, this.start = e25.start, this.end = e25.end, e25.options.locations && (this.loc = new mf(e25, e25.startLoc, e25.endLoc)), e25.options.ranges && (this.range = [e25.start, e25.end]);
}, dh = kf.prototype;
function mh(e25) {
  return e25 <= 65535 ? String.fromCharCode(e25) : (e25 -= 65536, String.fromCharCode(55296 + (e25 >> 10), 56320 + (1023 & e25)));
}
dh.next = function() {
  this.options.onToken && this.options.onToken(new hh(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
}, dh.getToken = function() {
  return this.next(), new hh(this);
}, typeof Symbol != "undefined" && (dh[Symbol.iterator] = function() {
  var e25 = this;
  return { next: function() {
    var t2 = e25.getToken();
    return { done: t2.type === tf.eof, value: t2 };
  } };
}), dh.curContext = function() {
  return this.context[this.context.length - 1];
}, dh.nextToken = function() {
  var e25 = this.curContext();
  return e25 && e25.preserveSpace || this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length ? this.finishToken(tf.eof) : e25.override ? e25.override(this) : void this.readToken(this.fullCharCodeAtPos());
}, dh.readToken = function(e25) {
  return Hp(e25, this.options.ecmaVersion >= 6) || e25 === 92 ? this.readWord() : this.getTokenFromCode(e25);
}, dh.fullCharCodeAtPos = function() {
  var e25 = this.input.charCodeAt(this.pos);
  return e25 <= 55295 || e25 >= 57344 ? e25 : (e25 << 10) + this.input.charCodeAt(this.pos + 1) - 56613888;
}, dh.skipBlockComment = function() {
  var e25, t2 = this.options.onComment && this.curPosition(), r2 = this.pos, n2 = this.input.indexOf("*/", this.pos += 2);
  if (n2 === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = n2 + 2, this.options.locations)
    for (nf.lastIndex = r2; (e25 = nf.exec(this.input)) && e25.index < this.pos; )
      ++this.curLine, this.lineStart = e25.index + e25[0].length;
  this.options.onComment && this.options.onComment(true, this.input.slice(r2 + 2, n2), r2, this.pos, t2, this.curPosition());
}, dh.skipLineComment = function(e25) {
  for (var t2 = this.pos, r2 = this.options.onComment && this.curPosition(), n2 = this.input.charCodeAt(this.pos += e25); this.pos < this.input.length && !af(n2); )
    n2 = this.input.charCodeAt(++this.pos);
  this.options.onComment && this.options.onComment(false, this.input.slice(t2 + e25, this.pos), t2, this.pos, r2, this.curPosition());
}, dh.skipSpace = function() {
  e:
    for (; this.pos < this.input.length; ) {
      var e25 = this.input.charCodeAt(this.pos);
      switch (e25) {
        case 32:
        case 160:
          ++this.pos;
          break;
        case 13:
          this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
        case 10:
        case 8232:
        case 8233:
          ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
          break;
        case 47:
          switch (this.input.charCodeAt(this.pos + 1)) {
            case 42:
              this.skipBlockComment();
              break;
            case 47:
              this.skipLineComment(2);
              break;
            default:
              break e;
          }
          break;
        default:
          if (!(e25 > 8 && e25 < 14 || e25 >= 5760 && of.test(String.fromCharCode(e25))))
            break e;
          ++this.pos;
      }
    }
}, dh.finishToken = function(e25, t2) {
  this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
  var r2 = this.type;
  this.type = e25, this.value = t2, this.updateContext(r2);
}, dh.readToken_dot = function() {
  var e25 = this.input.charCodeAt(this.pos + 1);
  if (e25 >= 48 && e25 <= 57)
    return this.readNumber(true);
  var t2 = this.input.charCodeAt(this.pos + 2);
  return this.options.ecmaVersion >= 6 && e25 === 46 && t2 === 46 ? (this.pos += 3, this.finishToken(tf.ellipsis)) : (++this.pos, this.finishToken(tf.dot));
}, dh.readToken_slash = function() {
  var e25 = this.input.charCodeAt(this.pos + 1);
  return this.exprAllowed ? (++this.pos, this.readRegexp()) : e25 === 61 ? this.finishOp(tf.assign, 2) : this.finishOp(tf.slash, 1);
}, dh.readToken_mult_modulo_exp = function(e25) {
  var t2 = this.input.charCodeAt(this.pos + 1), r2 = 1, n2 = e25 === 42 ? tf.star : tf.modulo;
  return this.options.ecmaVersion >= 7 && e25 === 42 && t2 === 42 && (++r2, n2 = tf.starstar, t2 = this.input.charCodeAt(this.pos + 2)), t2 === 61 ? this.finishOp(tf.assign, r2 + 1) : this.finishOp(n2, r2);
}, dh.readToken_pipe_amp = function(e25) {
  var t2 = this.input.charCodeAt(this.pos + 1);
  return t2 === e25 ? this.finishOp(e25 === 124 ? tf.logicalOR : tf.logicalAND, 2) : t2 === 61 ? this.finishOp(tf.assign, 2) : this.finishOp(e25 === 124 ? tf.bitwiseOR : tf.bitwiseAND, 1);
}, dh.readToken_caret = function() {
  return this.input.charCodeAt(this.pos + 1) === 61 ? this.finishOp(tf.assign, 2) : this.finishOp(tf.bitwiseXOR, 1);
}, dh.readToken_plus_min = function(e25) {
  var t2 = this.input.charCodeAt(this.pos + 1);
  return t2 === e25 ? t2 !== 45 || this.inModule || this.input.charCodeAt(this.pos + 2) !== 62 || this.lastTokEnd !== 0 && !rf.test(this.input.slice(this.lastTokEnd, this.pos)) ? this.finishOp(tf.incDec, 2) : (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : t2 === 61 ? this.finishOp(tf.assign, 2) : this.finishOp(tf.plusMin, 1);
}, dh.readToken_lt_gt = function(e25) {
  var t2 = this.input.charCodeAt(this.pos + 1), r2 = 1;
  return t2 === e25 ? (r2 = e25 === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + r2) === 61 ? this.finishOp(tf.assign, r2 + 1) : this.finishOp(tf.bitShift, r2)) : t2 !== 33 || e25 !== 60 || this.inModule || this.input.charCodeAt(this.pos + 2) !== 45 || this.input.charCodeAt(this.pos + 3) !== 45 ? (t2 === 61 && (r2 = 2), this.finishOp(tf.relational, r2)) : (this.skipLineComment(4), this.skipSpace(), this.nextToken());
}, dh.readToken_eq_excl = function(e25) {
  var t2 = this.input.charCodeAt(this.pos + 1);
  return t2 === 61 ? this.finishOp(tf.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : e25 === 61 && t2 === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(tf.arrow)) : this.finishOp(e25 === 61 ? tf.eq : tf.prefix, 1);
}, dh.getTokenFromCode = function(e25) {
  switch (e25) {
    case 46:
      return this.readToken_dot();
    case 40:
      return ++this.pos, this.finishToken(tf.parenL);
    case 41:
      return ++this.pos, this.finishToken(tf.parenR);
    case 59:
      return ++this.pos, this.finishToken(tf.semi);
    case 44:
      return ++this.pos, this.finishToken(tf.comma);
    case 91:
      return ++this.pos, this.finishToken(tf.bracketL);
    case 93:
      return ++this.pos, this.finishToken(tf.bracketR);
    case 123:
      return ++this.pos, this.finishToken(tf.braceL);
    case 125:
      return ++this.pos, this.finishToken(tf.braceR);
    case 58:
      return ++this.pos, this.finishToken(tf.colon);
    case 63:
      return ++this.pos, this.finishToken(tf.question);
    case 96:
      if (this.options.ecmaVersion < 6)
        break;
      return ++this.pos, this.finishToken(tf.backQuote);
    case 48:
      var t2 = this.input.charCodeAt(this.pos + 1);
      if (t2 === 120 || t2 === 88)
        return this.readRadixNumber(16);
      if (this.options.ecmaVersion >= 6) {
        if (t2 === 111 || t2 === 79)
          return this.readRadixNumber(8);
        if (t2 === 98 || t2 === 66)
          return this.readRadixNumber(2);
      }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return this.readNumber(false);
    case 34:
    case 39:
      return this.readString(e25);
    case 47:
      return this.readToken_slash();
    case 37:
    case 42:
      return this.readToken_mult_modulo_exp(e25);
    case 124:
    case 38:
      return this.readToken_pipe_amp(e25);
    case 94:
      return this.readToken_caret();
    case 43:
    case 45:
      return this.readToken_plus_min(e25);
    case 60:
    case 62:
      return this.readToken_lt_gt(e25);
    case 61:
    case 33:
      return this.readToken_eq_excl(e25);
    case 126:
      return this.finishOp(tf.prefix, 1);
  }
  this.raise(this.pos, "Unexpected character '" + mh(e25) + "'");
}, dh.finishOp = function(e25, t2) {
  var r2 = this.input.slice(this.pos, this.pos + t2);
  return this.pos += t2, this.finishToken(e25, r2);
}, dh.readRegexp = function() {
  for (var e25, t2, r2 = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(r2, "Unterminated regular expression");
    var n2 = this.input.charAt(this.pos);
    if (rf.test(n2) && this.raise(r2, "Unterminated regular expression"), e25)
      e25 = false;
    else {
      if (n2 === "[")
        t2 = true;
      else if (n2 === "]" && t2)
        t2 = false;
      else if (n2 === "/" && !t2)
        break;
      e25 = n2 === "\\";
    }
    ++this.pos;
  }
  var i2 = this.input.slice(r2, this.pos);
  ++this.pos;
  var a2 = this.pos, o2 = this.readWord1();
  this.containsEsc && this.unexpected(a2);
  var s2 = this.regexpState || (this.regexpState = new nh(this));
  s2.reset(r2, i2, o2), this.validateRegExpFlags(s2), this.validateRegExpPattern(s2);
  var u2 = null;
  try {
    u2 = new RegExp(i2, o2);
  } catch (e26) {
  }
  return this.finishToken(tf.regexp, { pattern: i2, flags: o2, value: u2 });
}, dh.readInt = function(e25, t2) {
  for (var r2 = this.pos, n2 = 0, i2 = 0, a2 = t2 == null ? 1 / 0 : t2; i2 < a2; ++i2) {
    var o2 = this.input.charCodeAt(this.pos), s2 = void 0;
    if ((s2 = o2 >= 97 ? o2 - 97 + 10 : o2 >= 65 ? o2 - 65 + 10 : o2 >= 48 && o2 <= 57 ? o2 - 48 : 1 / 0) >= e25)
      break;
    ++this.pos, n2 = n2 * e25 + s2;
  }
  return this.pos === r2 || t2 != null && this.pos - r2 !== t2 ? null : n2;
}, dh.readRadixNumber = function(e25) {
  var t2 = this.pos;
  this.pos += 2;
  var r2 = this.readInt(e25);
  return r2 == null && this.raise(this.start + 2, "Expected number in radix " + e25), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (r2 = typeof BigInt != "undefined" ? BigInt(this.input.slice(t2, this.pos)) : null, ++this.pos) : Hp(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(tf.num, r2);
}, dh.readNumber = function(e25) {
  var t2 = this.pos;
  e25 || this.readInt(10) !== null || this.raise(t2, "Invalid number");
  var r2 = this.pos - t2 >= 2 && this.input.charCodeAt(t2) === 48;
  r2 && this.strict && this.raise(t2, "Invalid number"), r2 && /[89]/.test(this.input.slice(t2, this.pos)) && (r2 = false);
  var n2 = this.input.charCodeAt(this.pos);
  if (!r2 && !e25 && this.options.ecmaVersion >= 11 && n2 === 110) {
    var i2 = this.input.slice(t2, this.pos), a2 = typeof BigInt != "undefined" ? BigInt(i2) : null;
    return ++this.pos, Hp(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(tf.num, a2);
  }
  n2 !== 46 || r2 || (++this.pos, this.readInt(10), n2 = this.input.charCodeAt(this.pos)), n2 !== 69 && n2 !== 101 || r2 || ((n2 = this.input.charCodeAt(++this.pos)) !== 43 && n2 !== 45 || ++this.pos, this.readInt(10) === null && this.raise(t2, "Invalid number")), Hp(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
  var o2 = this.input.slice(t2, this.pos), s2 = r2 ? parseInt(o2, 8) : parseFloat(o2);
  return this.finishToken(tf.num, s2);
}, dh.readCodePoint = function() {
  var e25;
  if (this.input.charCodeAt(this.pos) === 123) {
    this.options.ecmaVersion < 6 && this.unexpected();
    var t2 = ++this.pos;
    e25 = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, e25 > 1114111 && this.invalidStringToken(t2, "Code point out of bounds");
  } else
    e25 = this.readHexChar(4);
  return e25;
}, dh.readString = function(e25) {
  for (var t2 = "", r2 = ++this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
    var n2 = this.input.charCodeAt(this.pos);
    if (n2 === e25)
      break;
    n2 === 92 ? (t2 += this.input.slice(r2, this.pos), t2 += this.readEscapedChar(false), r2 = this.pos) : (af(n2, this.options.ecmaVersion >= 10) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
  }
  return t2 += this.input.slice(r2, this.pos++), this.finishToken(tf.string, t2);
};
var gh = {};
dh.tryReadTemplateToken = function() {
  this.inTemplateElement = true;
  try {
    this.readTmplToken();
  } catch (e25) {
    if (e25 !== gh)
      throw e25;
    this.readInvalidTemplateToken();
  }
  this.inTemplateElement = false;
}, dh.invalidStringToken = function(e25, t2) {
  if (this.inTemplateElement && this.options.ecmaVersion >= 9)
    throw gh;
  this.raise(e25, t2);
}, dh.readTmplToken = function() {
  for (var e25 = "", t2 = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
    var r2 = this.input.charCodeAt(this.pos);
    if (r2 === 96 || r2 === 36 && this.input.charCodeAt(this.pos + 1) === 123)
      return this.pos !== this.start || this.type !== tf.template && this.type !== tf.invalidTemplate ? (e25 += this.input.slice(t2, this.pos), this.finishToken(tf.template, e25)) : r2 === 36 ? (this.pos += 2, this.finishToken(tf.dollarBraceL)) : (++this.pos, this.finishToken(tf.backQuote));
    if (r2 === 92)
      e25 += this.input.slice(t2, this.pos), e25 += this.readEscapedChar(true), t2 = this.pos;
    else if (af(r2)) {
      switch (e25 += this.input.slice(t2, this.pos), ++this.pos, r2) {
        case 13:
          this.input.charCodeAt(this.pos) === 10 && ++this.pos;
        case 10:
          e25 += "\n";
          break;
        default:
          e25 += String.fromCharCode(r2);
      }
      this.options.locations && (++this.curLine, this.lineStart = this.pos), t2 = this.pos;
    } else
      ++this.pos;
  }
}, dh.readInvalidTemplateToken = function() {
  for (; this.pos < this.input.length; this.pos++)
    switch (this.input[this.pos]) {
      case "\\":
        ++this.pos;
        break;
      case "$":
        if (this.input[this.pos + 1] !== "{")
          break;
      case "`":
        return this.finishToken(tf.invalidTemplate, this.input.slice(this.start, this.pos));
    }
  this.raise(this.start, "Unterminated template");
}, dh.readEscapedChar = function(e25) {
  var t2 = this.input.charCodeAt(++this.pos);
  switch (++this.pos, t2) {
    case 110:
      return "\n";
    case 114:
      return "\r";
    case 120:
      return String.fromCharCode(this.readHexChar(2));
    case 117:
      return mh(this.readCodePoint());
    case 116:
      return "	";
    case 98:
      return "\b";
    case 118:
      return "\v";
    case 102:
      return "\f";
    case 13:
      this.input.charCodeAt(this.pos) === 10 && ++this.pos;
    case 10:
      return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
    default:
      if (t2 >= 48 && t2 <= 55) {
        var r2 = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], n2 = parseInt(r2, 8);
        return n2 > 255 && (r2 = r2.slice(0, -1), n2 = parseInt(r2, 8)), this.pos += r2.length - 1, t2 = this.input.charCodeAt(this.pos), r2 === "0" && t2 !== 56 && t2 !== 57 || !this.strict && !e25 || this.invalidStringToken(this.pos - 1 - r2.length, e25 ? "Octal literal in template string" : "Octal literal in strict mode"), String.fromCharCode(n2);
      }
      return af(t2) ? "" : String.fromCharCode(t2);
  }
}, dh.readHexChar = function(e25) {
  var t2 = this.pos, r2 = this.readInt(16, e25);
  return r2 === null && this.invalidStringToken(t2, "Bad character escape sequence"), r2;
}, dh.readWord1 = function() {
  this.containsEsc = false;
  for (var e25 = "", t2 = true, r2 = this.pos, n2 = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
    var i2 = this.fullCharCodeAtPos();
    if (Kp(i2, n2))
      this.pos += i2 <= 65535 ? 1 : 2;
    else {
      if (i2 !== 92)
        break;
      this.containsEsc = true, e25 += this.input.slice(r2, this.pos);
      var a2 = this.pos;
      this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
      var o2 = this.readCodePoint();
      (t2 ? Hp : Kp)(o2, n2) || this.invalidStringToken(a2, "Invalid Unicode escape"), e25 += mh(o2), r2 = this.pos;
    }
    t2 = false;
  }
  return e25 + this.input.slice(r2, this.pos);
}, dh.readWord = function() {
  var e25 = this.readWord1(), t2 = tf.name;
  return this.keywords.test(e25) && (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + e25), t2 = Zp[e25]), this.finishToken(t2, e25);
};
kf.acorn = { Parser: kf, version: "7.1.0", defaultOptions: yf, Position: df, SourceLocation: mf, getLineInfo: gf, Node: Uf, TokenType: Jp, tokTypes: tf, keywordTypes: Zp, TokContext: $f, tokContexts: Gf, isIdentifierChar: Kp, isIdentifierStart: Hp, Token: hh, isNewLine: af, lineBreak: rf, lineBreakG: nf, nonASCIIwhitespace: of };
var yh = Object.freeze({ __proto__: null, Node: Uf, Parser: kf, Position: df, SourceLocation: mf, TokContext: $f, Token: hh, TokenType: Jp, defaultOptions: yf, getLineInfo: gf, isIdentifierChar: Kp, isIdentifierStart: Hp, isNewLine: af, keywordTypes: Zp, lineBreak: rf, lineBreakG: nf, nonASCIIwhitespace: of, parse: function(e25, t2) {
  return kf.parse(e25, t2);
}, parseExpressionAt: function(e25, t2, r2) {
  return kf.parseExpressionAt(e25, t2, r2);
}, tokContexts: Gf, tokTypes: tf, tokenizer: function(e25, t2) {
  return kf.tokenizer(e25, t2);
}, version: "7.1.0" }), vh = { quot: '"', amp: "&", apos: "'", lt: "<", gt: ">", nbsp: "\xA0", iexcl: "\xA1", cent: "\xA2", pound: "\xA3", curren: "\xA4", yen: "\xA5", brvbar: "\xA6", sect: "\xA7", uml: "\xA8", copy: "\xA9", ordf: "\xAA", laquo: "\xAB", not: "\xAC", shy: "\xAD", reg: "\xAE", macr: "\xAF", deg: "\xB0", plusmn: "\xB1", sup2: "\xB2", sup3: "\xB3", acute: "\xB4", micro: "\xB5", para: "\xB6", middot: "\xB7", cedil: "\xB8", sup1: "\xB9", ordm: "\xBA", raquo: "\xBB", frac14: "\xBC", frac12: "\xBD", frac34: "\xBE", iquest: "\xBF", Agrave: "\xC0", Aacute: "\xC1", Acirc: "\xC2", Atilde: "\xC3", Auml: "\xC4", Aring: "\xC5", AElig: "\xC6", Ccedil: "\xC7", Egrave: "\xC8", Eacute: "\xC9", Ecirc: "\xCA", Euml: "\xCB", Igrave: "\xCC", Iacute: "\xCD", Icirc: "\xCE", Iuml: "\xCF", ETH: "\xD0", Ntilde: "\xD1", Ograve: "\xD2", Oacute: "\xD3", Ocirc: "\xD4", Otilde: "\xD5", Ouml: "\xD6", times: "\xD7", Oslash: "\xD8", Ugrave: "\xD9", Uacute: "\xDA", Ucirc: "\xDB", Uuml: "\xDC", Yacute: "\xDD", THORN: "\xDE", szlig: "\xDF", agrave: "\xE0", aacute: "\xE1", acirc: "\xE2", atilde: "\xE3", auml: "\xE4", aring: "\xE5", aelig: "\xE6", ccedil: "\xE7", egrave: "\xE8", eacute: "\xE9", ecirc: "\xEA", euml: "\xEB", igrave: "\xEC", iacute: "\xED", icirc: "\xEE", iuml: "\xEF", eth: "\xF0", ntilde: "\xF1", ograve: "\xF2", oacute: "\xF3", ocirc: "\xF4", otilde: "\xF5", ouml: "\xF6", divide: "\xF7", oslash: "\xF8", ugrave: "\xF9", uacute: "\xFA", ucirc: "\xFB", uuml: "\xFC", yacute: "\xFD", thorn: "\xFE", yuml: "\xFF", OElig: "\u0152", oelig: "\u0153", Scaron: "\u0160", scaron: "\u0161", Yuml: "\u0178", fnof: "\u0192", circ: "\u02C6", tilde: "\u02DC", Alpha: "\u0391", Beta: "\u0392", Gamma: "\u0393", Delta: "\u0394", Epsilon: "\u0395", Zeta: "\u0396", Eta: "\u0397", Theta: "\u0398", Iota: "\u0399", Kappa: "\u039A", Lambda: "\u039B", Mu: "\u039C", Nu: "\u039D", Xi: "\u039E", Omicron: "\u039F", Pi: "\u03A0", Rho: "\u03A1", Sigma: "\u03A3", Tau: "\u03A4", Upsilon: "\u03A5", Phi: "\u03A6", Chi: "\u03A7", Psi: "\u03A8", Omega: "\u03A9", alpha: "\u03B1", beta: "\u03B2", gamma: "\u03B3", delta: "\u03B4", epsilon: "\u03B5", zeta: "\u03B6", eta: "\u03B7", theta: "\u03B8", iota: "\u03B9", kappa: "\u03BA", lambda: "\u03BB", mu: "\u03BC", nu: "\u03BD", xi: "\u03BE", omicron: "\u03BF", pi: "\u03C0", rho: "\u03C1", sigmaf: "\u03C2", sigma: "\u03C3", tau: "\u03C4", upsilon: "\u03C5", phi: "\u03C6", chi: "\u03C7", psi: "\u03C8", omega: "\u03C9", thetasym: "\u03D1", upsih: "\u03D2", piv: "\u03D6", ensp: "\u2002", emsp: "\u2003", thinsp: "\u2009", zwnj: "\u200C", zwj: "\u200D", lrm: "\u200E", rlm: "\u200F", ndash: "\u2013", mdash: "\u2014", lsquo: "\u2018", rsquo: "\u2019", sbquo: "\u201A", ldquo: "\u201C", rdquo: "\u201D", bdquo: "\u201E", dagger: "\u2020", Dagger: "\u2021", bull: "\u2022", hellip: "\u2026", permil: "\u2030", prime: "\u2032", Prime: "\u2033", lsaquo: "\u2039", rsaquo: "\u203A", oline: "\u203E", frasl: "\u2044", euro: "\u20AC", image: "\u2111", weierp: "\u2118", real: "\u211C", trade: "\u2122", alefsym: "\u2135", larr: "\u2190", uarr: "\u2191", rarr: "\u2192", darr: "\u2193", harr: "\u2194", crarr: "\u21B5", lArr: "\u21D0", uArr: "\u21D1", rArr: "\u21D2", dArr: "\u21D3", hArr: "\u21D4", forall: "\u2200", part: "\u2202", exist: "\u2203", empty: "\u2205", nabla: "\u2207", isin: "\u2208", notin: "\u2209", ni: "\u220B", prod: "\u220F", sum: "\u2211", minus: "\u2212", lowast: "\u2217", radic: "\u221A", prop: "\u221D", infin: "\u221E", ang: "\u2220", and: "\u2227", or: "\u2228", cap: "\u2229", cup: "\u222A", int: "\u222B", there4: "\u2234", sim: "\u223C", cong: "\u2245", asymp: "\u2248", ne: "\u2260", equiv: "\u2261", le: "\u2264", ge: "\u2265", sub: "\u2282", sup: "\u2283", nsub: "\u2284", sube: "\u2286", supe: "\u2287", oplus: "\u2295", otimes: "\u2297", perp: "\u22A5", sdot: "\u22C5", lceil: "\u2308", rceil: "\u2309", lfloor: "\u230A", rfloor: "\u230B", lang: "\u2329", rang: "\u232A", loz: "\u25CA", spades: "\u2660", clubs: "\u2663", hearts: "\u2665", diams: "\u2666" }, xh = { 3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile", 5: "class enum extends super const export import", 6: "enum", strict: "implements interface let package private protected public static yield", strictBind: "eval arguments" }, bh = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", Eh = { 5: bh, "5module": bh + " export import", 6: bh + " const class extends export import super" }, Ch = /^in(stanceof)?$/, Sh = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7C6\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB67\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", kh = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F", Dh = new RegExp("[" + Sh + "]"), Fh = new RegExp("[" + Sh + kh + "]");
Sh = kh = null;
var Ah = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 157, 310, 10, 21, 11, 7, 153, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 477, 28, 11, 0, 9, 21, 155, 22, 13, 52, 76, 44, 33, 24, 27, 35, 30, 0, 12, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 85, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 0, 33, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 230, 43, 117, 63, 32, 0, 161, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 35, 56, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 270, 921, 103, 110, 18, 195, 2749, 1070, 4050, 582, 8634, 568, 8, 30, 114, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 754, 9486, 286, 50, 2, 18, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 2357, 44, 11, 6, 17, 0, 370, 43, 1301, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42710, 42, 4148, 12, 221, 3, 5761, 15, 7472, 3104, 541], wh = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 525, 10, 176, 2, 54, 14, 32, 9, 16, 3, 46, 10, 54, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 4, 9, 83, 11, 7, 0, 161, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 232, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 19306, 9, 135, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 19723, 1, 5319, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 262, 6, 10, 9, 419, 13, 1495, 6, 110, 6, 6, 9, 792487, 239];
function _h(e25, t2) {
  for (var r2 = 65536, n2 = 0; n2 < t2.length; n2 += 2) {
    if ((r2 += t2[n2]) > e25)
      return false;
    if ((r2 += t2[n2 + 1]) >= e25)
      return true;
  }
}
function Th(e25, t2) {
  return e25 < 65 ? e25 === 36 : e25 < 91 || (e25 < 97 ? e25 === 95 : e25 < 123 || (e25 <= 65535 ? e25 >= 170 && Dh.test(String.fromCharCode(e25)) : t2 !== false && _h(e25, Ah)));
}
function Ph(e25, t2) {
  return e25 < 48 ? e25 === 36 : e25 < 58 || !(e25 < 65) && (e25 < 91 || (e25 < 97 ? e25 === 95 : e25 < 123 || (e25 <= 65535 ? e25 >= 170 && Fh.test(String.fromCharCode(e25)) : t2 !== false && (_h(e25, Ah) || _h(e25, wh)))));
}
var Ih = function(e25, t2) {
  t2 === void 0 && (t2 = {}), this.label = e25, this.keyword = t2.keyword, this.beforeExpr = !!t2.beforeExpr, this.startsExpr = !!t2.startsExpr, this.isLoop = !!t2.isLoop, this.isAssign = !!t2.isAssign, this.prefix = !!t2.prefix, this.postfix = !!t2.postfix, this.binop = t2.binop || null, this.updateContext = null;
};
function Bh(e25, t2) {
  return new Ih(e25, { beforeExpr: true, binop: t2 });
}
var Oh = { beforeExpr: true }, Lh = { startsExpr: true }, Nh = {};
function jh(e25, t2) {
  return t2 === void 0 && (t2 = {}), t2.keyword = e25, Nh[e25] = new Ih(e25, t2);
}
var Rh = { num: new Ih("num", Lh), regexp: new Ih("regexp", Lh), string: new Ih("string", Lh), name: new Ih("name", Lh), eof: new Ih("eof"), bracketL: new Ih("[", { beforeExpr: true, startsExpr: true }), bracketR: new Ih("]"), braceL: new Ih("{", { beforeExpr: true, startsExpr: true }), braceR: new Ih("}"), parenL: new Ih("(", { beforeExpr: true, startsExpr: true }), parenR: new Ih(")"), comma: new Ih(",", Oh), semi: new Ih(";", Oh), colon: new Ih(":", Oh), dot: new Ih("."), question: new Ih("?", Oh), arrow: new Ih("=>", Oh), template: new Ih("template"), invalidTemplate: new Ih("invalidTemplate"), ellipsis: new Ih("...", Oh), backQuote: new Ih("`", Lh), dollarBraceL: new Ih("${", { beforeExpr: true, startsExpr: true }), eq: new Ih("=", { beforeExpr: true, isAssign: true }), assign: new Ih("_=", { beforeExpr: true, isAssign: true }), incDec: new Ih("++/--", { prefix: true, postfix: true, startsExpr: true }), prefix: new Ih("!/~", { beforeExpr: true, prefix: true, startsExpr: true }), logicalOR: Bh("||", 1), logicalAND: Bh("&&", 2), bitwiseOR: Bh("|", 3), bitwiseXOR: Bh("^", 4), bitwiseAND: Bh("&", 5), equality: Bh("==/!=/===/!==", 6), relational: Bh("</>/<=/>=", 7), bitShift: Bh("<</>>/>>>", 8), plusMin: new Ih("+/-", { beforeExpr: true, binop: 9, prefix: true, startsExpr: true }), modulo: Bh("%", 10), star: Bh("*", 10), slash: Bh("/", 10), starstar: new Ih("**", { beforeExpr: true }), _break: jh("break"), _case: jh("case", Oh), _catch: jh("catch"), _continue: jh("continue"), _debugger: jh("debugger"), _default: jh("default", Oh), _do: jh("do", { isLoop: true, beforeExpr: true }), _else: jh("else", Oh), _finally: jh("finally"), _for: jh("for", { isLoop: true }), _function: jh("function", Lh), _if: jh("if"), _return: jh("return", Oh), _switch: jh("switch"), _throw: jh("throw", Oh), _try: jh("try"), _var: jh("var"), _const: jh("const"), _while: jh("while", { isLoop: true }), _with: jh("with"), _new: jh("new", { beforeExpr: true, startsExpr: true }), _this: jh("this", Lh), _super: jh("super", Lh), _class: jh("class", Lh), _extends: jh("extends", Oh), _export: jh("export"), _import: jh("import", Lh), _null: jh("null", Lh), _true: jh("true", Lh), _false: jh("false", Lh), _in: jh("in", { beforeExpr: true, binop: 7 }), _instanceof: jh("instanceof", { beforeExpr: true, binop: 7 }), _typeof: jh("typeof", { beforeExpr: true, prefix: true, startsExpr: true }), _void: jh("void", { beforeExpr: true, prefix: true, startsExpr: true }), _delete: jh("delete", { beforeExpr: true, prefix: true, startsExpr: true }) }, Mh = /\r\n?|\n|\u2028|\u2029/, Vh = new RegExp(Mh.source, "g");
function Uh(e25, t2) {
  return e25 === 10 || e25 === 13 || !t2 && (e25 === 8232 || e25 === 8233);
}
var qh = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Wh = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, $h = Object.prototype, Gh = $h.hasOwnProperty, zh = $h.toString;
function Hh(e25, t2) {
  return Gh.call(e25, t2);
}
var Kh = Array.isArray || function(e25) {
  return zh.call(e25) === "[object Array]";
};
function Jh(e25) {
  return new RegExp("^(?:" + e25.replace(/ /g, "|") + ")$");
}
var Qh = function(e25, t2) {
  this.line = e25, this.column = t2;
};
Qh.prototype.offset = function(e25) {
  return new Qh(this.line, this.column + e25);
};
var Xh = function(e25, t2, r2) {
  this.start = t2, this.end = r2, e25.sourceFile !== null && (this.source = e25.sourceFile);
};
function Yh(e25, t2) {
  for (var r2 = 1, n2 = 0; ; ) {
    Vh.lastIndex = n2;
    var i2 = Vh.exec(e25);
    if (!(i2 && i2.index < t2))
      return new Qh(r2, t2 - n2);
    ++r2, n2 = i2.index + i2[0].length;
  }
}
var Zh = { ecmaVersion: 9, sourceType: "script", onInsertedSemicolon: null, onTrailingComma: null, allowReserved: null, allowReturnOutsideFunction: false, allowImportExportEverywhere: false, allowAwaitOutsideFunction: false, allowHashBang: false, locations: false, onToken: null, onComment: null, ranges: false, program: null, sourceFile: null, directSourceFile: null, preserveParens: false };
function ed(e25) {
  var t2 = {};
  for (var r2 in Zh)
    t2[r2] = e25 && Hh(e25, r2) ? e25[r2] : Zh[r2];
  if (t2.ecmaVersion >= 2015 && (t2.ecmaVersion -= 2009), t2.allowReserved == null && (t2.allowReserved = t2.ecmaVersion < 5), Kh(t2.onToken)) {
    var n2 = t2.onToken;
    t2.onToken = function(e26) {
      return n2.push(e26);
    };
  }
  return Kh(t2.onComment) && (t2.onComment = function(e26, t3) {
    return function(r3, n3, i2, a2, o2, s2) {
      var u2 = { type: r3 ? "Block" : "Line", value: n3, start: i2, end: a2 };
      e26.locations && (u2.loc = new Xh(this, o2, s2)), e26.ranges && (u2.range = [i2, a2]), t3.push(u2);
    };
  }(t2, t2.onComment)), t2;
}
var td = 2, rd = 1 | td, nd = 4, id = 8;
function ad(e25, t2) {
  return td | (e25 ? nd : 0) | (t2 ? id : 0);
}
var od = function(e25, t2, r2) {
  this.options = e25 = ed(e25), this.sourceFile = e25.sourceFile, this.keywords = Jh(Eh[e25.ecmaVersion >= 6 ? 6 : e25.sourceType === "module" ? "5module" : 5]);
  var n2 = "";
  if (e25.allowReserved !== true) {
    for (var i2 = e25.ecmaVersion; !(n2 = xh[i2]); i2--)
      ;
    e25.sourceType === "module" && (n2 += " await");
  }
  this.reservedWords = Jh(n2);
  var a2 = (n2 ? n2 + " " : "") + xh.strict;
  this.reservedWordsStrict = Jh(a2), this.reservedWordsStrictBind = Jh(a2 + " " + xh.strictBind), this.input = String(t2), this.containsEsc = false, r2 ? (this.pos = r2, this.lineStart = this.input.lastIndexOf("\n", r2 - 1) + 1, this.curLine = this.input.slice(0, this.lineStart).split(Mh).length) : (this.pos = this.lineStart = 0, this.curLine = 1), this.type = Rh.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = true, this.inModule = e25.sourceType === "module", this.strict = this.inModule || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = {}, this.pos === 0 && e25.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(1), this.regexpState = null;
}, sd = { inFunction: { configurable: true }, inGenerator: { configurable: true }, inAsync: { configurable: true }, allowSuper: { configurable: true }, allowDirectSuper: { configurable: true }, treatFunctionsAsVar: { configurable: true } };
od.prototype.parse = function() {
  var e25 = this.options.program || this.startNode();
  return this.nextToken(), this.parseTopLevel(e25);
}, sd.inFunction.get = function() {
  return (this.currentVarScope().flags & td) > 0;
}, sd.inGenerator.get = function() {
  return (this.currentVarScope().flags & id) > 0;
}, sd.inAsync.get = function() {
  return (this.currentVarScope().flags & nd) > 0;
}, sd.allowSuper.get = function() {
  return (64 & this.currentThisScope().flags) > 0;
}, sd.allowDirectSuper.get = function() {
  return (128 & this.currentThisScope().flags) > 0;
}, sd.treatFunctionsAsVar.get = function() {
  return this.treatFunctionsAsVarInScope(this.currentScope());
}, od.prototype.inNonArrowFunction = function() {
  return (this.currentThisScope().flags & td) > 0;
}, od.extend = function() {
  for (var e25 = [], t2 = arguments.length; t2--; )
    e25[t2] = arguments[t2];
  for (var r2 = this, n2 = 0; n2 < e25.length; n2++)
    r2 = e25[n2](r2);
  return r2;
}, od.parse = function(e25, t2) {
  return new this(t2, e25).parse();
}, od.parseExpressionAt = function(e25, t2, r2) {
  var n2 = new this(r2, e25, t2);
  return n2.nextToken(), n2.parseExpression();
}, od.tokenizer = function(e25, t2) {
  return new this(t2, e25);
}, Object.defineProperties(od.prototype, sd);
var ud = od.prototype, cd = /^(?:'((?:\\.|[^'])*?)'|"((?:\\.|[^"])*?)")/;
function ld() {
  this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
}
ud.strictDirective = function(e25) {
  for (; ; ) {
    Wh.lastIndex = e25, e25 += Wh.exec(this.input)[0].length;
    var t2 = cd.exec(this.input.slice(e25));
    if (!t2)
      return false;
    if ((t2[1] || t2[2]) === "use strict")
      return true;
    e25 += t2[0].length, Wh.lastIndex = e25, e25 += Wh.exec(this.input)[0].length, this.input[e25] === ";" && e25++;
  }
}, ud.eat = function(e25) {
  return this.type === e25 && (this.next(), true);
}, ud.isContextual = function(e25) {
  return this.type === Rh.name && this.value === e25 && !this.containsEsc;
}, ud.eatContextual = function(e25) {
  return !!this.isContextual(e25) && (this.next(), true);
}, ud.expectContextual = function(e25) {
  this.eatContextual(e25) || this.unexpected();
}, ud.canInsertSemicolon = function() {
  return this.type === Rh.eof || this.type === Rh.braceR || Mh.test(this.input.slice(this.lastTokEnd, this.start));
}, ud.insertSemicolon = function() {
  if (this.canInsertSemicolon())
    return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), true;
}, ud.semicolon = function() {
  this.eat(Rh.semi) || this.insertSemicolon() || this.unexpected();
}, ud.afterTrailingComma = function(e25, t2) {
  if (this.type === e25)
    return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), t2 || this.next(), true;
}, ud.expect = function(e25) {
  this.eat(e25) || this.unexpected();
}, ud.unexpected = function(e25) {
  this.raise(e25 != null ? e25 : this.start, "Unexpected token");
}, ud.checkPatternErrors = function(e25, t2) {
  if (e25) {
    e25.trailingComma > -1 && this.raiseRecoverable(e25.trailingComma, "Comma is not permitted after the rest element");
    var r2 = t2 ? e25.parenthesizedAssign : e25.parenthesizedBind;
    r2 > -1 && this.raiseRecoverable(r2, "Parenthesized pattern");
  }
}, ud.checkExpressionErrors = function(e25, t2) {
  if (!e25)
    return false;
  var r2 = e25.shorthandAssign, n2 = e25.doubleProto;
  if (!t2)
    return r2 >= 0 || n2 >= 0;
  r2 >= 0 && this.raise(r2, "Shorthand property assignments are valid only in destructuring patterns"), n2 >= 0 && this.raiseRecoverable(n2, "Redefinition of __proto__ property");
}, ud.checkYieldAwaitInDefaultParams = function() {
  this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
}, ud.isSimpleAssignTarget = function(e25) {
  return e25.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(e25.expression) : e25.type === "Identifier" || e25.type === "MemberExpression";
};
var pd = od.prototype;
pd.parseTopLevel = function(e25) {
  var t2 = {};
  for (e25.body || (e25.body = []); this.type !== Rh.eof; ) {
    var r2 = this.parseStatement(null, true, t2);
    e25.body.push(r2);
  }
  if (this.inModule)
    for (var n2 = 0, i2 = Object.keys(this.undefinedExports); n2 < i2.length; n2 += 1) {
      var a2 = i2[n2];
      this.raiseRecoverable(this.undefinedExports[a2].start, "Export '" + a2 + "' is not defined");
    }
  return this.adaptDirectivePrologue(e25.body), this.next(), e25.sourceType = this.options.sourceType, this.finishNode(e25, "Program");
};
var fd = { kind: "loop" }, hd = { kind: "switch" };
pd.isLet = function(e25) {
  if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
    return false;
  Wh.lastIndex = this.pos;
  var t2 = Wh.exec(this.input), r2 = this.pos + t2[0].length, n2 = this.input.charCodeAt(r2);
  if (n2 === 91)
    return true;
  if (e25)
    return false;
  if (n2 === 123)
    return true;
  if (Th(n2, true)) {
    for (var i2 = r2 + 1; Ph(this.input.charCodeAt(i2), true); )
      ++i2;
    var a2 = this.input.slice(r2, i2);
    if (!Ch.test(a2))
      return true;
  }
  return false;
}, pd.isAsyncFunction = function() {
  if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
    return false;
  Wh.lastIndex = this.pos;
  var e25 = Wh.exec(this.input), t2 = this.pos + e25[0].length;
  return !(Mh.test(this.input.slice(this.pos, t2)) || this.input.slice(t2, t2 + 8) !== "function" || t2 + 8 !== this.input.length && Ph(this.input.charAt(t2 + 8)));
}, pd.parseStatement = function(e25, t2, r2) {
  var n2, i2 = this.type, a2 = this.startNode();
  switch (this.isLet(e25) && (i2 = Rh._var, n2 = "let"), i2) {
    case Rh._break:
    case Rh._continue:
      return this.parseBreakContinueStatement(a2, i2.keyword);
    case Rh._debugger:
      return this.parseDebuggerStatement(a2);
    case Rh._do:
      return this.parseDoStatement(a2);
    case Rh._for:
      return this.parseForStatement(a2);
    case Rh._function:
      return e25 && (this.strict || e25 !== "if" && e25 !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(a2, false, !e25);
    case Rh._class:
      return e25 && this.unexpected(), this.parseClass(a2, true);
    case Rh._if:
      return this.parseIfStatement(a2);
    case Rh._return:
      return this.parseReturnStatement(a2);
    case Rh._switch:
      return this.parseSwitchStatement(a2);
    case Rh._throw:
      return this.parseThrowStatement(a2);
    case Rh._try:
      return this.parseTryStatement(a2);
    case Rh._const:
    case Rh._var:
      return n2 = n2 || this.value, e25 && n2 !== "var" && this.unexpected(), this.parseVarStatement(a2, n2);
    case Rh._while:
      return this.parseWhileStatement(a2);
    case Rh._with:
      return this.parseWithStatement(a2);
    case Rh.braceL:
      return this.parseBlock(true, a2);
    case Rh.semi:
      return this.parseEmptyStatement(a2);
    case Rh._export:
    case Rh._import:
      if (this.options.ecmaVersion > 10 && i2 === Rh._import) {
        Wh.lastIndex = this.pos;
        var o2 = Wh.exec(this.input), s2 = this.pos + o2[0].length;
        if (this.input.charCodeAt(s2) === 40)
          return this.parseExpressionStatement(a2, this.parseExpression());
      }
      return this.options.allowImportExportEverywhere || (t2 || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), i2 === Rh._import ? this.parseImport(a2) : this.parseExport(a2, r2);
    default:
      if (this.isAsyncFunction())
        return e25 && this.unexpected(), this.next(), this.parseFunctionStatement(a2, true, !e25);
      var u2 = this.value, c2 = this.parseExpression();
      return i2 === Rh.name && c2.type === "Identifier" && this.eat(Rh.colon) ? this.parseLabeledStatement(a2, u2, c2, e25) : this.parseExpressionStatement(a2, c2);
  }
}, pd.parseBreakContinueStatement = function(e25, t2) {
  var r2 = t2 === "break";
  this.next(), this.eat(Rh.semi) || this.insertSemicolon() ? e25.label = null : this.type !== Rh.name ? this.unexpected() : (e25.label = this.parseIdent(), this.semicolon());
  for (var n2 = 0; n2 < this.labels.length; ++n2) {
    var i2 = this.labels[n2];
    if (e25.label == null || i2.name === e25.label.name) {
      if (i2.kind != null && (r2 || i2.kind === "loop"))
        break;
      if (e25.label && r2)
        break;
    }
  }
  return n2 === this.labels.length && this.raise(e25.start, "Unsyntactic " + t2), this.finishNode(e25, r2 ? "BreakStatement" : "ContinueStatement");
}, pd.parseDebuggerStatement = function(e25) {
  return this.next(), this.semicolon(), this.finishNode(e25, "DebuggerStatement");
}, pd.parseDoStatement = function(e25) {
  return this.next(), this.labels.push(fd), e25.body = this.parseStatement("do"), this.labels.pop(), this.expect(Rh._while), e25.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(Rh.semi) : this.semicolon(), this.finishNode(e25, "DoWhileStatement");
}, pd.parseForStatement = function(e25) {
  this.next();
  var t2 = this.options.ecmaVersion >= 9 && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction) && this.eatContextual("await") ? this.lastTokStart : -1;
  if (this.labels.push(fd), this.enterScope(0), this.expect(Rh.parenL), this.type === Rh.semi)
    return t2 > -1 && this.unexpected(t2), this.parseFor(e25, null);
  var r2 = this.isLet();
  if (this.type === Rh._var || this.type === Rh._const || r2) {
    var n2 = this.startNode(), i2 = r2 ? "let" : this.value;
    return this.next(), this.parseVar(n2, true, i2), this.finishNode(n2, "VariableDeclaration"), (this.type === Rh._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && n2.declarations.length === 1 ? (this.options.ecmaVersion >= 9 && (this.type === Rh._in ? t2 > -1 && this.unexpected(t2) : e25.await = t2 > -1), this.parseForIn(e25, n2)) : (t2 > -1 && this.unexpected(t2), this.parseFor(e25, n2));
  }
  var a2 = new ld(), o2 = this.parseExpression(true, a2);
  return this.type === Rh._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? (this.options.ecmaVersion >= 9 && (this.type === Rh._in ? t2 > -1 && this.unexpected(t2) : e25.await = t2 > -1), this.toAssignable(o2, false, a2), this.checkLVal(o2), this.parseForIn(e25, o2)) : (this.checkExpressionErrors(a2, true), t2 > -1 && this.unexpected(t2), this.parseFor(e25, o2));
}, pd.parseFunctionStatement = function(e25, t2, r2) {
  return this.next(), this.parseFunction(e25, md | (r2 ? 0 : gd), false, t2);
}, pd.parseIfStatement = function(e25) {
  return this.next(), e25.test = this.parseParenExpression(), e25.consequent = this.parseStatement("if"), e25.alternate = this.eat(Rh._else) ? this.parseStatement("if") : null, this.finishNode(e25, "IfStatement");
}, pd.parseReturnStatement = function(e25) {
  return this.inFunction || this.options.allowReturnOutsideFunction || this.raise(this.start, "'return' outside of function"), this.next(), this.eat(Rh.semi) || this.insertSemicolon() ? e25.argument = null : (e25.argument = this.parseExpression(), this.semicolon()), this.finishNode(e25, "ReturnStatement");
}, pd.parseSwitchStatement = function(e25) {
  var t2;
  this.next(), e25.discriminant = this.parseParenExpression(), e25.cases = [], this.expect(Rh.braceL), this.labels.push(hd), this.enterScope(0);
  for (var r2 = false; this.type !== Rh.braceR; )
    if (this.type === Rh._case || this.type === Rh._default) {
      var n2 = this.type === Rh._case;
      t2 && this.finishNode(t2, "SwitchCase"), e25.cases.push(t2 = this.startNode()), t2.consequent = [], this.next(), n2 ? t2.test = this.parseExpression() : (r2 && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), r2 = true, t2.test = null), this.expect(Rh.colon);
    } else
      t2 || this.unexpected(), t2.consequent.push(this.parseStatement(null));
  return this.exitScope(), t2 && this.finishNode(t2, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(e25, "SwitchStatement");
}, pd.parseThrowStatement = function(e25) {
  return this.next(), Mh.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), e25.argument = this.parseExpression(), this.semicolon(), this.finishNode(e25, "ThrowStatement");
};
var dd = [];
pd.parseTryStatement = function(e25) {
  if (this.next(), e25.block = this.parseBlock(), e25.handler = null, this.type === Rh._catch) {
    var t2 = this.startNode();
    if (this.next(), this.eat(Rh.parenL)) {
      t2.param = this.parseBindingAtom();
      var r2 = t2.param.type === "Identifier";
      this.enterScope(r2 ? 32 : 0), this.checkLVal(t2.param, r2 ? 4 : 2), this.expect(Rh.parenR);
    } else
      this.options.ecmaVersion < 10 && this.unexpected(), t2.param = null, this.enterScope(0);
    t2.body = this.parseBlock(false), this.exitScope(), e25.handler = this.finishNode(t2, "CatchClause");
  }
  return e25.finalizer = this.eat(Rh._finally) ? this.parseBlock() : null, e25.handler || e25.finalizer || this.raise(e25.start, "Missing catch or finally clause"), this.finishNode(e25, "TryStatement");
}, pd.parseVarStatement = function(e25, t2) {
  return this.next(), this.parseVar(e25, false, t2), this.semicolon(), this.finishNode(e25, "VariableDeclaration");
}, pd.parseWhileStatement = function(e25) {
  return this.next(), e25.test = this.parseParenExpression(), this.labels.push(fd), e25.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(e25, "WhileStatement");
}, pd.parseWithStatement = function(e25) {
  return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), e25.object = this.parseParenExpression(), e25.body = this.parseStatement("with"), this.finishNode(e25, "WithStatement");
}, pd.parseEmptyStatement = function(e25) {
  return this.next(), this.finishNode(e25, "EmptyStatement");
}, pd.parseLabeledStatement = function(e25, t2, r2, n2) {
  for (var i2 = 0, a2 = this.labels; i2 < a2.length; i2 += 1) {
    a2[i2].name === t2 && this.raise(r2.start, "Label '" + t2 + "' is already declared");
  }
  for (var o2 = this.type.isLoop ? "loop" : this.type === Rh._switch ? "switch" : null, s2 = this.labels.length - 1; s2 >= 0; s2--) {
    var u2 = this.labels[s2];
    if (u2.statementStart !== e25.start)
      break;
    u2.statementStart = this.start, u2.kind = o2;
  }
  return this.labels.push({ name: t2, kind: o2, statementStart: this.start }), e25.body = this.parseStatement(n2 ? n2.indexOf("label") === -1 ? n2 + "label" : n2 : "label"), this.labels.pop(), e25.label = r2, this.finishNode(e25, "LabeledStatement");
}, pd.parseExpressionStatement = function(e25, t2) {
  return e25.expression = t2, this.semicolon(), this.finishNode(e25, "ExpressionStatement");
}, pd.parseBlock = function(e25, t2) {
  for (e25 === void 0 && (e25 = true), t2 === void 0 && (t2 = this.startNode()), t2.body = [], this.expect(Rh.braceL), e25 && this.enterScope(0); !this.eat(Rh.braceR); ) {
    var r2 = this.parseStatement(null);
    t2.body.push(r2);
  }
  return e25 && this.exitScope(), this.finishNode(t2, "BlockStatement");
}, pd.parseFor = function(e25, t2) {
  return e25.init = t2, this.expect(Rh.semi), e25.test = this.type === Rh.semi ? null : this.parseExpression(), this.expect(Rh.semi), e25.update = this.type === Rh.parenR ? null : this.parseExpression(), this.expect(Rh.parenR), e25.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e25, "ForStatement");
}, pd.parseForIn = function(e25, t2) {
  var r2 = this.type === Rh._in;
  return this.next(), t2.type === "VariableDeclaration" && t2.declarations[0].init != null && (!r2 || this.options.ecmaVersion < 8 || this.strict || t2.kind !== "var" || t2.declarations[0].id.type !== "Identifier") ? this.raise(t2.start, (r2 ? "for-in" : "for-of") + " loop variable declaration may not have an initializer") : t2.type === "AssignmentPattern" && this.raise(t2.start, "Invalid left-hand side in for-loop"), e25.left = t2, e25.right = r2 ? this.parseExpression() : this.parseMaybeAssign(), this.expect(Rh.parenR), e25.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e25, r2 ? "ForInStatement" : "ForOfStatement");
}, pd.parseVar = function(e25, t2, r2) {
  for (e25.declarations = [], e25.kind = r2; ; ) {
    var n2 = this.startNode();
    if (this.parseVarId(n2, r2), this.eat(Rh.eq) ? n2.init = this.parseMaybeAssign(t2) : r2 !== "const" || this.type === Rh._in || this.options.ecmaVersion >= 6 && this.isContextual("of") ? n2.id.type === "Identifier" || t2 && (this.type === Rh._in || this.isContextual("of")) ? n2.init = null : this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : this.unexpected(), e25.declarations.push(this.finishNode(n2, "VariableDeclarator")), !this.eat(Rh.comma))
      break;
  }
  return e25;
}, pd.parseVarId = function(e25, t2) {
  e25.id = this.parseBindingAtom(), this.checkLVal(e25.id, t2 === "var" ? 1 : 2, false);
};
var md = 1, gd = 2;
pd.parseFunction = function(e25, t2, r2, n2) {
  this.initFunction(e25), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !n2) && (this.type === Rh.star && t2 & gd && this.unexpected(), e25.generator = this.eat(Rh.star)), this.options.ecmaVersion >= 8 && (e25.async = !!n2), t2 & md && (e25.id = 4 & t2 && this.type !== Rh.name ? null : this.parseIdent(), !e25.id || t2 & gd || this.checkLVal(e25.id, this.strict || e25.generator || e25.async ? this.treatFunctionsAsVar ? 1 : 2 : 3));
  var i2 = this.yieldPos, a2 = this.awaitPos, o2 = this.awaitIdentPos;
  return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(ad(e25.async, e25.generator)), t2 & md || (e25.id = this.type === Rh.name ? this.parseIdent() : null), this.parseFunctionParams(e25), this.parseFunctionBody(e25, r2, false), this.yieldPos = i2, this.awaitPos = a2, this.awaitIdentPos = o2, this.finishNode(e25, t2 & md ? "FunctionDeclaration" : "FunctionExpression");
}, pd.parseFunctionParams = function(e25) {
  this.expect(Rh.parenL), e25.params = this.parseBindingList(Rh.parenR, false, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
}, pd.parseClass = function(e25, t2) {
  this.next();
  var r2 = this.strict;
  this.strict = true, this.parseClassId(e25, t2), this.parseClassSuper(e25);
  var n2 = this.startNode(), i2 = false;
  for (n2.body = [], this.expect(Rh.braceL); !this.eat(Rh.braceR); ) {
    var a2 = this.parseClassElement(e25.superClass !== null);
    a2 && (n2.body.push(a2), a2.type === "MethodDefinition" && a2.kind === "constructor" && (i2 && this.raise(a2.start, "Duplicate constructor in the same class"), i2 = true));
  }
  return e25.body = this.finishNode(n2, "ClassBody"), this.strict = r2, this.finishNode(e25, t2 ? "ClassDeclaration" : "ClassExpression");
}, pd.parseClassElement = function(e25) {
  var t2 = this;
  if (this.eat(Rh.semi))
    return null;
  var r2 = this.startNode(), n2 = function(e26, n3) {
    n3 === void 0 && (n3 = false);
    var i3 = t2.start, a3 = t2.startLoc;
    return !!t2.eatContextual(e26) && (!(t2.type === Rh.parenL || n3 && t2.canInsertSemicolon()) || (r2.key && t2.unexpected(), r2.computed = false, r2.key = t2.startNodeAt(i3, a3), r2.key.name = e26, t2.finishNode(r2.key, "Identifier"), false));
  };
  r2.kind = "method", r2.static = n2("static");
  var i2 = this.eat(Rh.star), a2 = false;
  i2 || (this.options.ecmaVersion >= 8 && n2("async", true) ? (a2 = true, i2 = this.options.ecmaVersion >= 9 && this.eat(Rh.star)) : n2("get") ? r2.kind = "get" : n2("set") && (r2.kind = "set")), r2.key || this.parsePropertyName(r2);
  var o2 = r2.key, s2 = false;
  return r2.computed || r2.static || !(o2.type === "Identifier" && o2.name === "constructor" || o2.type === "Literal" && o2.value === "constructor") ? r2.static && o2.type === "Identifier" && o2.name === "prototype" && this.raise(o2.start, "Classes may not have a static property named prototype") : (r2.kind !== "method" && this.raise(o2.start, "Constructor can't have get/set modifier"), i2 && this.raise(o2.start, "Constructor can't be a generator"), a2 && this.raise(o2.start, "Constructor can't be an async method"), r2.kind = "constructor", s2 = e25), this.parseClassMethod(r2, i2, a2, s2), r2.kind === "get" && r2.value.params.length !== 0 && this.raiseRecoverable(r2.value.start, "getter should have no params"), r2.kind === "set" && r2.value.params.length !== 1 && this.raiseRecoverable(r2.value.start, "setter should have exactly one param"), r2.kind === "set" && r2.value.params[0].type === "RestElement" && this.raiseRecoverable(r2.value.params[0].start, "Setter cannot use rest params"), r2;
}, pd.parseClassMethod = function(e25, t2, r2, n2) {
  return e25.value = this.parseMethod(t2, r2, n2), this.finishNode(e25, "MethodDefinition");
}, pd.parseClassId = function(e25, t2) {
  this.type === Rh.name ? (e25.id = this.parseIdent(), t2 && this.checkLVal(e25.id, 2, false)) : (t2 === true && this.unexpected(), e25.id = null);
}, pd.parseClassSuper = function(e25) {
  e25.superClass = this.eat(Rh._extends) ? this.parseExprSubscripts() : null;
}, pd.parseExport = function(e25, t2) {
  if (this.next(), this.eat(Rh.star))
    return this.expectContextual("from"), this.type !== Rh.string && this.unexpected(), e25.source = this.parseExprAtom(), this.semicolon(), this.finishNode(e25, "ExportAllDeclaration");
  if (this.eat(Rh._default)) {
    var r2;
    if (this.checkExport(t2, "default", this.lastTokStart), this.type === Rh._function || (r2 = this.isAsyncFunction())) {
      var n2 = this.startNode();
      this.next(), r2 && this.next(), e25.declaration = this.parseFunction(n2, 4 | md, false, r2);
    } else if (this.type === Rh._class) {
      var i2 = this.startNode();
      e25.declaration = this.parseClass(i2, "nullableID");
    } else
      e25.declaration = this.parseMaybeAssign(), this.semicolon();
    return this.finishNode(e25, "ExportDefaultDeclaration");
  }
  if (this.shouldParseExportStatement())
    e25.declaration = this.parseStatement(null), e25.declaration.type === "VariableDeclaration" ? this.checkVariableExport(t2, e25.declaration.declarations) : this.checkExport(t2, e25.declaration.id.name, e25.declaration.id.start), e25.specifiers = [], e25.source = null;
  else {
    if (e25.declaration = null, e25.specifiers = this.parseExportSpecifiers(t2), this.eatContextual("from"))
      this.type !== Rh.string && this.unexpected(), e25.source = this.parseExprAtom();
    else {
      for (var a2 = 0, o2 = e25.specifiers; a2 < o2.length; a2 += 1) {
        var s2 = o2[a2];
        this.checkUnreserved(s2.local), this.checkLocalExport(s2.local);
      }
      e25.source = null;
    }
    this.semicolon();
  }
  return this.finishNode(e25, "ExportNamedDeclaration");
}, pd.checkExport = function(e25, t2, r2) {
  e25 && (Hh(e25, t2) && this.raiseRecoverable(r2, "Duplicate export '" + t2 + "'"), e25[t2] = true);
}, pd.checkPatternExport = function(e25, t2) {
  var r2 = t2.type;
  if (r2 === "Identifier")
    this.checkExport(e25, t2.name, t2.start);
  else if (r2 === "ObjectPattern")
    for (var n2 = 0, i2 = t2.properties; n2 < i2.length; n2 += 1) {
      var a2 = i2[n2];
      this.checkPatternExport(e25, a2);
    }
  else if (r2 === "ArrayPattern")
    for (var o2 = 0, s2 = t2.elements; o2 < s2.length; o2 += 1) {
      var u2 = s2[o2];
      u2 && this.checkPatternExport(e25, u2);
    }
  else
    r2 === "Property" ? this.checkPatternExport(e25, t2.value) : r2 === "AssignmentPattern" ? this.checkPatternExport(e25, t2.left) : r2 === "RestElement" ? this.checkPatternExport(e25, t2.argument) : r2 === "ParenthesizedExpression" && this.checkPatternExport(e25, t2.expression);
}, pd.checkVariableExport = function(e25, t2) {
  if (e25)
    for (var r2 = 0, n2 = t2; r2 < n2.length; r2 += 1) {
      var i2 = n2[r2];
      this.checkPatternExport(e25, i2.id);
    }
}, pd.shouldParseExportStatement = function() {
  return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
}, pd.parseExportSpecifiers = function(e25) {
  var t2 = [], r2 = true;
  for (this.expect(Rh.braceL); !this.eat(Rh.braceR); ) {
    if (r2)
      r2 = false;
    else if (this.expect(Rh.comma), this.afterTrailingComma(Rh.braceR))
      break;
    var n2 = this.startNode();
    n2.local = this.parseIdent(true), n2.exported = this.eatContextual("as") ? this.parseIdent(true) : n2.local, this.checkExport(e25, n2.exported.name, n2.exported.start), t2.push(this.finishNode(n2, "ExportSpecifier"));
  }
  return t2;
}, pd.parseImport = function(e25) {
  return this.next(), this.type === Rh.string ? (e25.specifiers = dd, e25.source = this.parseExprAtom()) : (e25.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), e25.source = this.type === Rh.string ? this.parseExprAtom() : this.unexpected()), this.semicolon(), this.finishNode(e25, "ImportDeclaration");
}, pd.parseImportSpecifiers = function() {
  var e25 = [], t2 = true;
  if (this.type === Rh.name) {
    var r2 = this.startNode();
    if (r2.local = this.parseIdent(), this.checkLVal(r2.local, 2), e25.push(this.finishNode(r2, "ImportDefaultSpecifier")), !this.eat(Rh.comma))
      return e25;
  }
  if (this.type === Rh.star) {
    var n2 = this.startNode();
    return this.next(), this.expectContextual("as"), n2.local = this.parseIdent(), this.checkLVal(n2.local, 2), e25.push(this.finishNode(n2, "ImportNamespaceSpecifier")), e25;
  }
  for (this.expect(Rh.braceL); !this.eat(Rh.braceR); ) {
    if (t2)
      t2 = false;
    else if (this.expect(Rh.comma), this.afterTrailingComma(Rh.braceR))
      break;
    var i2 = this.startNode();
    i2.imported = this.parseIdent(true), this.eatContextual("as") ? i2.local = this.parseIdent() : (this.checkUnreserved(i2.imported), i2.local = i2.imported), this.checkLVal(i2.local, 2), e25.push(this.finishNode(i2, "ImportSpecifier"));
  }
  return e25;
}, pd.adaptDirectivePrologue = function(e25) {
  for (var t2 = 0; t2 < e25.length && this.isDirectiveCandidate(e25[t2]); ++t2)
    e25[t2].directive = e25[t2].expression.raw.slice(1, -1);
}, pd.isDirectiveCandidate = function(e25) {
  return e25.type === "ExpressionStatement" && e25.expression.type === "Literal" && typeof e25.expression.value == "string" && (this.input[e25.start] === '"' || this.input[e25.start] === "'");
};
var yd = od.prototype;
yd.toAssignable = function(e25, t2, r2) {
  if (this.options.ecmaVersion >= 6 && e25)
    switch (e25.type) {
      case "Identifier":
        this.inAsync && e25.name === "await" && this.raise(e25.start, "Cannot use 'await' as identifier inside an async function");
        break;
      case "ObjectPattern":
      case "ArrayPattern":
      case "RestElement":
        break;
      case "ObjectExpression":
        e25.type = "ObjectPattern", r2 && this.checkPatternErrors(r2, true);
        for (var n2 = 0, i2 = e25.properties; n2 < i2.length; n2 += 1) {
          var a2 = i2[n2];
          this.toAssignable(a2, t2), a2.type !== "RestElement" || a2.argument.type !== "ArrayPattern" && a2.argument.type !== "ObjectPattern" || this.raise(a2.argument.start, "Unexpected token");
        }
        break;
      case "Property":
        e25.kind !== "init" && this.raise(e25.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(e25.value, t2);
        break;
      case "ArrayExpression":
        e25.type = "ArrayPattern", r2 && this.checkPatternErrors(r2, true), this.toAssignableList(e25.elements, t2);
        break;
      case "SpreadElement":
        e25.type = "RestElement", this.toAssignable(e25.argument, t2), e25.argument.type === "AssignmentPattern" && this.raise(e25.argument.start, "Rest elements cannot have a default value");
        break;
      case "AssignmentExpression":
        e25.operator !== "=" && this.raise(e25.left.end, "Only '=' operator can be used for specifying default value."), e25.type = "AssignmentPattern", delete e25.operator, this.toAssignable(e25.left, t2);
      case "AssignmentPattern":
        break;
      case "ParenthesizedExpression":
        this.toAssignable(e25.expression, t2, r2);
        break;
      case "MemberExpression":
        if (!t2)
          break;
      default:
        this.raise(e25.start, "Assigning to rvalue");
    }
  else
    r2 && this.checkPatternErrors(r2, true);
  return e25;
}, yd.toAssignableList = function(e25, t2) {
  for (var r2 = e25.length, n2 = 0; n2 < r2; n2++) {
    var i2 = e25[n2];
    i2 && this.toAssignable(i2, t2);
  }
  if (r2) {
    var a2 = e25[r2 - 1];
    this.options.ecmaVersion === 6 && t2 && a2 && a2.type === "RestElement" && a2.argument.type !== "Identifier" && this.unexpected(a2.argument.start);
  }
  return e25;
}, yd.parseSpread = function(e25) {
  var t2 = this.startNode();
  return this.next(), t2.argument = this.parseMaybeAssign(false, e25), this.finishNode(t2, "SpreadElement");
}, yd.parseRestBinding = function() {
  var e25 = this.startNode();
  return this.next(), this.options.ecmaVersion === 6 && this.type !== Rh.name && this.unexpected(), e25.argument = this.parseBindingAtom(), this.finishNode(e25, "RestElement");
}, yd.parseBindingAtom = function() {
  if (this.options.ecmaVersion >= 6)
    switch (this.type) {
      case Rh.bracketL:
        var e25 = this.startNode();
        return this.next(), e25.elements = this.parseBindingList(Rh.bracketR, true, true), this.finishNode(e25, "ArrayPattern");
      case Rh.braceL:
        return this.parseObj(true);
    }
  return this.parseIdent();
}, yd.parseBindingList = function(e25, t2, r2) {
  for (var n2 = [], i2 = true; !this.eat(e25); )
    if (i2 ? i2 = false : this.expect(Rh.comma), t2 && this.type === Rh.comma)
      n2.push(null);
    else {
      if (r2 && this.afterTrailingComma(e25))
        break;
      if (this.type === Rh.ellipsis) {
        var a2 = this.parseRestBinding();
        this.parseBindingListItem(a2), n2.push(a2), this.type === Rh.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.expect(e25);
        break;
      }
      var o2 = this.parseMaybeDefault(this.start, this.startLoc);
      this.parseBindingListItem(o2), n2.push(o2);
    }
  return n2;
}, yd.parseBindingListItem = function(e25) {
  return e25;
}, yd.parseMaybeDefault = function(e25, t2, r2) {
  if (r2 = r2 || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(Rh.eq))
    return r2;
  var n2 = this.startNodeAt(e25, t2);
  return n2.left = r2, n2.right = this.parseMaybeAssign(), this.finishNode(n2, "AssignmentPattern");
}, yd.checkLVal = function(e25, t2, r2) {
  switch (t2 === void 0 && (t2 = 0), e25.type) {
    case "Identifier":
      t2 === 2 && e25.name === "let" && this.raiseRecoverable(e25.start, "let is disallowed as a lexically bound name"), this.strict && this.reservedWordsStrictBind.test(e25.name) && this.raiseRecoverable(e25.start, (t2 ? "Binding " : "Assigning to ") + e25.name + " in strict mode"), r2 && (Hh(r2, e25.name) && this.raiseRecoverable(e25.start, "Argument name clash"), r2[e25.name] = true), t2 !== 0 && t2 !== 5 && this.declareName(e25.name, t2, e25.start);
      break;
    case "MemberExpression":
      t2 && this.raiseRecoverable(e25.start, "Binding member expression");
      break;
    case "ObjectPattern":
      for (var n2 = 0, i2 = e25.properties; n2 < i2.length; n2 += 1) {
        var a2 = i2[n2];
        this.checkLVal(a2, t2, r2);
      }
      break;
    case "Property":
      this.checkLVal(e25.value, t2, r2);
      break;
    case "ArrayPattern":
      for (var o2 = 0, s2 = e25.elements; o2 < s2.length; o2 += 1) {
        var u2 = s2[o2];
        u2 && this.checkLVal(u2, t2, r2);
      }
      break;
    case "AssignmentPattern":
      this.checkLVal(e25.left, t2, r2);
      break;
    case "RestElement":
      this.checkLVal(e25.argument, t2, r2);
      break;
    case "ParenthesizedExpression":
      this.checkLVal(e25.expression, t2, r2);
      break;
    default:
      this.raise(e25.start, (t2 ? "Binding" : "Assigning to") + " rvalue");
  }
};
var vd = od.prototype;
vd.checkPropClash = function(e25, t2, r2) {
  if (!(this.options.ecmaVersion >= 9 && e25.type === "SpreadElement" || this.options.ecmaVersion >= 6 && (e25.computed || e25.method || e25.shorthand))) {
    var n2, i2 = e25.key;
    switch (i2.type) {
      case "Identifier":
        n2 = i2.name;
        break;
      case "Literal":
        n2 = String(i2.value);
        break;
      default:
        return;
    }
    var a2 = e25.kind;
    if (this.options.ecmaVersion >= 6)
      n2 === "__proto__" && a2 === "init" && (t2.proto && (r2 && r2.doubleProto < 0 ? r2.doubleProto = i2.start : this.raiseRecoverable(i2.start, "Redefinition of __proto__ property")), t2.proto = true);
    else {
      var o2 = t2[n2 = "$" + n2];
      if (o2)
        (a2 === "init" ? this.strict && o2.init || o2.get || o2.set : o2.init || o2[a2]) && this.raiseRecoverable(i2.start, "Redefinition of property");
      else
        o2 = t2[n2] = { init: false, get: false, set: false };
      o2[a2] = true;
    }
  }
}, vd.parseExpression = function(e25, t2) {
  var r2 = this.start, n2 = this.startLoc, i2 = this.parseMaybeAssign(e25, t2);
  if (this.type === Rh.comma) {
    var a2 = this.startNodeAt(r2, n2);
    for (a2.expressions = [i2]; this.eat(Rh.comma); )
      a2.expressions.push(this.parseMaybeAssign(e25, t2));
    return this.finishNode(a2, "SequenceExpression");
  }
  return i2;
}, vd.parseMaybeAssign = function(e25, t2, r2) {
  if (this.isContextual("yield")) {
    if (this.inGenerator)
      return this.parseYield(e25);
    this.exprAllowed = false;
  }
  var n2 = false, i2 = -1, a2 = -1, o2 = -1;
  t2 ? (i2 = t2.parenthesizedAssign, a2 = t2.trailingComma, o2 = t2.shorthandAssign, t2.parenthesizedAssign = t2.trailingComma = t2.shorthandAssign = -1) : (t2 = new ld(), n2 = true);
  var s2 = this.start, u2 = this.startLoc;
  this.type !== Rh.parenL && this.type !== Rh.name || (this.potentialArrowAt = this.start);
  var c2 = this.parseMaybeConditional(e25, t2);
  if (r2 && (c2 = r2.call(this, c2, s2, u2)), this.type.isAssign) {
    var l2 = this.startNodeAt(s2, u2);
    return l2.operator = this.value, l2.left = this.type === Rh.eq ? this.toAssignable(c2, false, t2) : c2, n2 || ld.call(t2), t2.shorthandAssign = -1, this.checkLVal(c2), this.next(), l2.right = this.parseMaybeAssign(e25), this.finishNode(l2, "AssignmentExpression");
  }
  return n2 && this.checkExpressionErrors(t2, true), i2 > -1 && (t2.parenthesizedAssign = i2), a2 > -1 && (t2.trailingComma = a2), o2 > -1 && (t2.shorthandAssign = o2), c2;
}, vd.parseMaybeConditional = function(e25, t2) {
  var r2 = this.start, n2 = this.startLoc, i2 = this.parseExprOps(e25, t2);
  if (this.checkExpressionErrors(t2))
    return i2;
  if (this.eat(Rh.question)) {
    var a2 = this.startNodeAt(r2, n2);
    return a2.test = i2, a2.consequent = this.parseMaybeAssign(), this.expect(Rh.colon), a2.alternate = this.parseMaybeAssign(e25), this.finishNode(a2, "ConditionalExpression");
  }
  return i2;
}, vd.parseExprOps = function(e25, t2) {
  var r2 = this.start, n2 = this.startLoc, i2 = this.parseMaybeUnary(t2, false);
  return this.checkExpressionErrors(t2) ? i2 : i2.start === r2 && i2.type === "ArrowFunctionExpression" ? i2 : this.parseExprOp(i2, r2, n2, -1, e25);
}, vd.parseExprOp = function(e25, t2, r2, n2, i2) {
  var a2 = this.type.binop;
  if (a2 != null && (!i2 || this.type !== Rh._in) && a2 > n2) {
    var o2 = this.type === Rh.logicalOR || this.type === Rh.logicalAND, s2 = this.value;
    this.next();
    var u2 = this.start, c2 = this.startLoc, l2 = this.parseExprOp(this.parseMaybeUnary(null, false), u2, c2, a2, i2), p2 = this.buildBinary(t2, r2, e25, l2, s2, o2);
    return this.parseExprOp(p2, t2, r2, n2, i2);
  }
  return e25;
}, vd.buildBinary = function(e25, t2, r2, n2, i2, a2) {
  var o2 = this.startNodeAt(e25, t2);
  return o2.left = r2, o2.operator = i2, o2.right = n2, this.finishNode(o2, a2 ? "LogicalExpression" : "BinaryExpression");
}, vd.parseMaybeUnary = function(e25, t2) {
  var r2, n2 = this.start, i2 = this.startLoc;
  if (this.isContextual("await") && (this.inAsync || !this.inFunction && this.options.allowAwaitOutsideFunction))
    r2 = this.parseAwait(), t2 = true;
  else if (this.type.prefix) {
    var a2 = this.startNode(), o2 = this.type === Rh.incDec;
    a2.operator = this.value, a2.prefix = true, this.next(), a2.argument = this.parseMaybeUnary(null, true), this.checkExpressionErrors(e25, true), o2 ? this.checkLVal(a2.argument) : this.strict && a2.operator === "delete" && a2.argument.type === "Identifier" ? this.raiseRecoverable(a2.start, "Deleting local variable in strict mode") : t2 = true, r2 = this.finishNode(a2, o2 ? "UpdateExpression" : "UnaryExpression");
  } else {
    if (r2 = this.parseExprSubscripts(e25), this.checkExpressionErrors(e25))
      return r2;
    for (; this.type.postfix && !this.canInsertSemicolon(); ) {
      var s2 = this.startNodeAt(n2, i2);
      s2.operator = this.value, s2.prefix = false, s2.argument = r2, this.checkLVal(r2), this.next(), r2 = this.finishNode(s2, "UpdateExpression");
    }
  }
  return !t2 && this.eat(Rh.starstar) ? this.buildBinary(n2, i2, r2, this.parseMaybeUnary(null, false), "**", false) : r2;
}, vd.parseExprSubscripts = function(e25) {
  var t2 = this.start, r2 = this.startLoc, n2 = this.parseExprAtom(e25), i2 = n2.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")";
  if (this.checkExpressionErrors(e25) || i2)
    return n2;
  var a2 = this.parseSubscripts(n2, t2, r2);
  return e25 && a2.type === "MemberExpression" && (e25.parenthesizedAssign >= a2.start && (e25.parenthesizedAssign = -1), e25.parenthesizedBind >= a2.start && (e25.parenthesizedBind = -1)), a2;
}, vd.parseSubscripts = function(e25, t2, r2, n2) {
  for (var i2 = this.options.ecmaVersion >= 8 && e25.type === "Identifier" && e25.name === "async" && this.lastTokEnd === e25.end && !this.canInsertSemicolon() && this.input.slice(e25.start, e25.end) === "async"; ; ) {
    var a2 = this.parseSubscript(e25, t2, r2, n2, i2);
    if (a2 === e25 || a2.type === "ArrowFunctionExpression")
      return a2;
    e25 = a2;
  }
}, vd.parseSubscript = function(e25, t2, r2, n2, i2) {
  var a2 = this.eat(Rh.bracketL);
  if (a2 || this.eat(Rh.dot)) {
    var o2 = this.startNodeAt(t2, r2);
    o2.object = e25, o2.property = a2 ? this.parseExpression() : this.parseIdent(this.options.allowReserved !== "never"), o2.computed = !!a2, a2 && this.expect(Rh.bracketR), e25 = this.finishNode(o2, "MemberExpression");
  } else if (!n2 && this.eat(Rh.parenL)) {
    var s2 = new ld(), u2 = this.yieldPos, c2 = this.awaitPos, l2 = this.awaitIdentPos;
    this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
    var p2 = this.parseExprList(Rh.parenR, this.options.ecmaVersion >= 8 && e25.type !== "Import", false, s2);
    if (i2 && !this.canInsertSemicolon() && this.eat(Rh.arrow))
      return this.checkPatternErrors(s2, false), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = u2, this.awaitPos = c2, this.awaitIdentPos = l2, this.parseArrowExpression(this.startNodeAt(t2, r2), p2, true);
    this.checkExpressionErrors(s2, true), this.yieldPos = u2 || this.yieldPos, this.awaitPos = c2 || this.awaitPos, this.awaitIdentPos = l2 || this.awaitIdentPos;
    var f2 = this.startNodeAt(t2, r2);
    if (f2.callee = e25, f2.arguments = p2, f2.callee.type === "Import") {
      f2.arguments.length !== 1 && this.raise(f2.start, "import() requires exactly one argument");
      var h2 = f2.arguments[0];
      h2 && h2.type === "SpreadElement" && this.raise(h2.start, "... is not allowed in import()");
    }
    e25 = this.finishNode(f2, "CallExpression");
  } else if (this.type === Rh.backQuote) {
    var d2 = this.startNodeAt(t2, r2);
    d2.tag = e25, d2.quasi = this.parseTemplate({ isTagged: true }), e25 = this.finishNode(d2, "TaggedTemplateExpression");
  }
  return e25;
}, vd.parseExprAtom = function(e25) {
  this.type === Rh.slash && this.readRegexp();
  var t2, r2 = this.potentialArrowAt === this.start;
  switch (this.type) {
    case Rh._super:
      return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), t2 = this.startNode(), this.next(), this.type !== Rh.parenL || this.allowDirectSuper || this.raise(t2.start, "super() call outside constructor of a subclass"), this.type !== Rh.dot && this.type !== Rh.bracketL && this.type !== Rh.parenL && this.unexpected(), this.finishNode(t2, "Super");
    case Rh._this:
      return t2 = this.startNode(), this.next(), this.finishNode(t2, "ThisExpression");
    case Rh.name:
      var n2 = this.start, i2 = this.startLoc, a2 = this.containsEsc, o2 = this.parseIdent(false);
      if (this.options.ecmaVersion >= 8 && !a2 && o2.name === "async" && !this.canInsertSemicolon() && this.eat(Rh._function))
        return this.parseFunction(this.startNodeAt(n2, i2), 0, false, true);
      if (r2 && !this.canInsertSemicolon()) {
        if (this.eat(Rh.arrow))
          return this.parseArrowExpression(this.startNodeAt(n2, i2), [o2], false);
        if (this.options.ecmaVersion >= 8 && o2.name === "async" && this.type === Rh.name && !a2)
          return o2 = this.parseIdent(false), !this.canInsertSemicolon() && this.eat(Rh.arrow) || this.unexpected(), this.parseArrowExpression(this.startNodeAt(n2, i2), [o2], true);
      }
      return o2;
    case Rh.regexp:
      var s2 = this.value;
      return (t2 = this.parseLiteral(s2.value)).regex = { pattern: s2.pattern, flags: s2.flags }, t2;
    case Rh.num:
    case Rh.string:
      return this.parseLiteral(this.value);
    case Rh._null:
    case Rh._true:
    case Rh._false:
      return (t2 = this.startNode()).value = this.type === Rh._null ? null : this.type === Rh._true, t2.raw = this.type.keyword, this.next(), this.finishNode(t2, "Literal");
    case Rh.parenL:
      var u2 = this.start, c2 = this.parseParenAndDistinguishExpression(r2);
      return e25 && (e25.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(c2) && (e25.parenthesizedAssign = u2), e25.parenthesizedBind < 0 && (e25.parenthesizedBind = u2)), c2;
    case Rh.bracketL:
      return t2 = this.startNode(), this.next(), t2.elements = this.parseExprList(Rh.bracketR, true, true, e25), this.finishNode(t2, "ArrayExpression");
    case Rh.braceL:
      return this.parseObj(false, e25);
    case Rh._function:
      return t2 = this.startNode(), this.next(), this.parseFunction(t2, 0);
    case Rh._class:
      return this.parseClass(this.startNode(), false);
    case Rh._new:
      return this.parseNew();
    case Rh.backQuote:
      return this.parseTemplate();
    case Rh._import:
      return this.options.ecmaVersion > 10 ? this.parseDynamicImport() : this.unexpected();
    default:
      this.unexpected();
  }
}, vd.parseDynamicImport = function() {
  var e25 = this.startNode();
  return this.next(), this.type !== Rh.parenL && this.unexpected(), this.finishNode(e25, "Import");
}, vd.parseLiteral = function(e25) {
  var t2 = this.startNode();
  return t2.value = e25, t2.raw = this.input.slice(this.start, this.end), t2.raw.charCodeAt(t2.raw.length - 1) === 110 && (t2.bigint = t2.raw.slice(0, -1)), this.next(), this.finishNode(t2, "Literal");
}, vd.parseParenExpression = function() {
  this.expect(Rh.parenL);
  var e25 = this.parseExpression();
  return this.expect(Rh.parenR), e25;
}, vd.parseParenAndDistinguishExpression = function(e25) {
  var t2, r2 = this.start, n2 = this.startLoc, i2 = this.options.ecmaVersion >= 8;
  if (this.options.ecmaVersion >= 6) {
    this.next();
    var a2, o2 = this.start, s2 = this.startLoc, u2 = [], c2 = true, l2 = false, p2 = new ld(), f2 = this.yieldPos, h2 = this.awaitPos;
    for (this.yieldPos = 0, this.awaitPos = 0; this.type !== Rh.parenR; ) {
      if (c2 ? c2 = false : this.expect(Rh.comma), i2 && this.afterTrailingComma(Rh.parenR, true)) {
        l2 = true;
        break;
      }
      if (this.type === Rh.ellipsis) {
        a2 = this.start, u2.push(this.parseParenItem(this.parseRestBinding())), this.type === Rh.comma && this.raise(this.start, "Comma is not permitted after the rest element");
        break;
      }
      u2.push(this.parseMaybeAssign(false, p2, this.parseParenItem));
    }
    var d2 = this.start, m2 = this.startLoc;
    if (this.expect(Rh.parenR), e25 && !this.canInsertSemicolon() && this.eat(Rh.arrow))
      return this.checkPatternErrors(p2, false), this.checkYieldAwaitInDefaultParams(), this.yieldPos = f2, this.awaitPos = h2, this.parseParenArrowList(r2, n2, u2);
    u2.length && !l2 || this.unexpected(this.lastTokStart), a2 && this.unexpected(a2), this.checkExpressionErrors(p2, true), this.yieldPos = f2 || this.yieldPos, this.awaitPos = h2 || this.awaitPos, u2.length > 1 ? ((t2 = this.startNodeAt(o2, s2)).expressions = u2, this.finishNodeAt(t2, "SequenceExpression", d2, m2)) : t2 = u2[0];
  } else
    t2 = this.parseParenExpression();
  if (this.options.preserveParens) {
    var g2 = this.startNodeAt(r2, n2);
    return g2.expression = t2, this.finishNode(g2, "ParenthesizedExpression");
  }
  return t2;
}, vd.parseParenItem = function(e25) {
  return e25;
}, vd.parseParenArrowList = function(e25, t2, r2) {
  return this.parseArrowExpression(this.startNodeAt(e25, t2), r2);
};
var xd = [];
vd.parseNew = function() {
  var e25 = this.startNode(), t2 = this.parseIdent(true);
  if (this.options.ecmaVersion >= 6 && this.eat(Rh.dot)) {
    e25.meta = t2;
    var r2 = this.containsEsc;
    return e25.property = this.parseIdent(true), (e25.property.name !== "target" || r2) && this.raiseRecoverable(e25.property.start, "The only valid meta property for new is new.target"), this.inNonArrowFunction() || this.raiseRecoverable(e25.start, "new.target can only be used in functions"), this.finishNode(e25, "MetaProperty");
  }
  var n2 = this.start, i2 = this.startLoc;
  return e25.callee = this.parseSubscripts(this.parseExprAtom(), n2, i2, true), this.options.ecmaVersion > 10 && e25.callee.type === "Import" && this.raise(e25.callee.start, "Cannot use new with import(...)"), this.eat(Rh.parenL) ? e25.arguments = this.parseExprList(Rh.parenR, this.options.ecmaVersion >= 8 && e25.callee.type !== "Import", false) : e25.arguments = xd, this.finishNode(e25, "NewExpression");
}, vd.parseTemplateElement = function(e25) {
  var t2 = e25.isTagged, r2 = this.startNode();
  return this.type === Rh.invalidTemplate ? (t2 || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), r2.value = { raw: this.value, cooked: null }) : r2.value = { raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"), cooked: this.value }, this.next(), r2.tail = this.type === Rh.backQuote, this.finishNode(r2, "TemplateElement");
}, vd.parseTemplate = function(e25) {
  e25 === void 0 && (e25 = {});
  var t2 = e25.isTagged;
  t2 === void 0 && (t2 = false);
  var r2 = this.startNode();
  this.next(), r2.expressions = [];
  var n2 = this.parseTemplateElement({ isTagged: t2 });
  for (r2.quasis = [n2]; !n2.tail; )
    this.type === Rh.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(Rh.dollarBraceL), r2.expressions.push(this.parseExpression()), this.expect(Rh.braceR), r2.quasis.push(n2 = this.parseTemplateElement({ isTagged: t2 }));
  return this.next(), this.finishNode(r2, "TemplateLiteral");
}, vd.isAsyncProp = function(e25) {
  return !e25.computed && e25.key.type === "Identifier" && e25.key.name === "async" && (this.type === Rh.name || this.type === Rh.num || this.type === Rh.string || this.type === Rh.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === Rh.star) && !Mh.test(this.input.slice(this.lastTokEnd, this.start));
}, vd.parseObj = function(e25, t2) {
  var r2 = this.startNode(), n2 = true, i2 = {};
  for (r2.properties = [], this.next(); !this.eat(Rh.braceR); ) {
    if (n2)
      n2 = false;
    else if (this.expect(Rh.comma), this.afterTrailingComma(Rh.braceR))
      break;
    var a2 = this.parseProperty(e25, t2);
    e25 || this.checkPropClash(a2, i2, t2), r2.properties.push(a2);
  }
  return this.finishNode(r2, e25 ? "ObjectPattern" : "ObjectExpression");
}, vd.parseProperty = function(e25, t2) {
  var r2, n2, i2, a2, o2 = this.startNode();
  if (this.options.ecmaVersion >= 9 && this.eat(Rh.ellipsis))
    return e25 ? (o2.argument = this.parseIdent(false), this.type === Rh.comma && this.raise(this.start, "Comma is not permitted after the rest element"), this.finishNode(o2, "RestElement")) : (this.type === Rh.parenL && t2 && (t2.parenthesizedAssign < 0 && (t2.parenthesizedAssign = this.start), t2.parenthesizedBind < 0 && (t2.parenthesizedBind = this.start)), o2.argument = this.parseMaybeAssign(false, t2), this.type === Rh.comma && t2 && t2.trailingComma < 0 && (t2.trailingComma = this.start), this.finishNode(o2, "SpreadElement"));
  this.options.ecmaVersion >= 6 && (o2.method = false, o2.shorthand = false, (e25 || t2) && (i2 = this.start, a2 = this.startLoc), e25 || (r2 = this.eat(Rh.star)));
  var s2 = this.containsEsc;
  return this.parsePropertyName(o2), !e25 && !s2 && this.options.ecmaVersion >= 8 && !r2 && this.isAsyncProp(o2) ? (n2 = true, r2 = this.options.ecmaVersion >= 9 && this.eat(Rh.star), this.parsePropertyName(o2, t2)) : n2 = false, this.parsePropertyValue(o2, e25, r2, n2, i2, a2, t2, s2), this.finishNode(o2, "Property");
}, vd.parsePropertyValue = function(e25, t2, r2, n2, i2, a2, o2, s2) {
  if ((r2 || n2) && this.type === Rh.colon && this.unexpected(), this.eat(Rh.colon))
    e25.value = t2 ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(false, o2), e25.kind = "init";
  else if (this.options.ecmaVersion >= 6 && this.type === Rh.parenL)
    t2 && this.unexpected(), e25.kind = "init", e25.method = true, e25.value = this.parseMethod(r2, n2);
  else if (t2 || s2 || !(this.options.ecmaVersion >= 5) || e25.computed || e25.key.type !== "Identifier" || e25.key.name !== "get" && e25.key.name !== "set" || this.type === Rh.comma || this.type === Rh.braceR)
    this.options.ecmaVersion >= 6 && !e25.computed && e25.key.type === "Identifier" ? ((r2 || n2) && this.unexpected(), this.checkUnreserved(e25.key), e25.key.name !== "await" || this.awaitIdentPos || (this.awaitIdentPos = i2), e25.kind = "init", t2 ? e25.value = this.parseMaybeDefault(i2, a2, e25.key) : this.type === Rh.eq && o2 ? (o2.shorthandAssign < 0 && (o2.shorthandAssign = this.start), e25.value = this.parseMaybeDefault(i2, a2, e25.key)) : e25.value = e25.key, e25.shorthand = true) : this.unexpected();
  else {
    (r2 || n2) && this.unexpected(), e25.kind = e25.key.name, this.parsePropertyName(e25), e25.value = this.parseMethod(false);
    var u2 = e25.kind === "get" ? 0 : 1;
    if (e25.value.params.length !== u2) {
      var c2 = e25.value.start;
      e25.kind === "get" ? this.raiseRecoverable(c2, "getter should have no params") : this.raiseRecoverable(c2, "setter should have exactly one param");
    } else
      e25.kind === "set" && e25.value.params[0].type === "RestElement" && this.raiseRecoverable(e25.value.params[0].start, "Setter cannot use rest params");
  }
}, vd.parsePropertyName = function(e25) {
  if (this.options.ecmaVersion >= 6) {
    if (this.eat(Rh.bracketL))
      return e25.computed = true, e25.key = this.parseMaybeAssign(), this.expect(Rh.bracketR), e25.key;
    e25.computed = false;
  }
  return e25.key = this.type === Rh.num || this.type === Rh.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
}, vd.initFunction = function(e25) {
  e25.id = null, this.options.ecmaVersion >= 6 && (e25.generator = e25.expression = false), this.options.ecmaVersion >= 8 && (e25.async = false);
}, vd.parseMethod = function(e25, t2, r2) {
  var n2 = this.startNode(), i2 = this.yieldPos, a2 = this.awaitPos, o2 = this.awaitIdentPos;
  return this.initFunction(n2), this.options.ecmaVersion >= 6 && (n2.generator = e25), this.options.ecmaVersion >= 8 && (n2.async = !!t2), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(64 | ad(t2, n2.generator) | (r2 ? 128 : 0)), this.expect(Rh.parenL), n2.params = this.parseBindingList(Rh.parenR, false, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(n2, false, true), this.yieldPos = i2, this.awaitPos = a2, this.awaitIdentPos = o2, this.finishNode(n2, "FunctionExpression");
}, vd.parseArrowExpression = function(e25, t2, r2) {
  var n2 = this.yieldPos, i2 = this.awaitPos, a2 = this.awaitIdentPos;
  return this.enterScope(16 | ad(r2, false)), this.initFunction(e25), this.options.ecmaVersion >= 8 && (e25.async = !!r2), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, e25.params = this.toAssignableList(t2, true), this.parseFunctionBody(e25, true, false), this.yieldPos = n2, this.awaitPos = i2, this.awaitIdentPos = a2, this.finishNode(e25, "ArrowFunctionExpression");
}, vd.parseFunctionBody = function(e25, t2, r2) {
  var n2 = t2 && this.type !== Rh.braceL, i2 = this.strict, a2 = false;
  if (n2)
    e25.body = this.parseMaybeAssign(), e25.expression = true, this.checkParams(e25, false);
  else {
    var o2 = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(e25.params);
    i2 && !o2 || (a2 = this.strictDirective(this.end)) && o2 && this.raiseRecoverable(e25.start, "Illegal 'use strict' directive in function with non-simple parameter list");
    var s2 = this.labels;
    this.labels = [], a2 && (this.strict = true), this.checkParams(e25, !i2 && !a2 && !t2 && !r2 && this.isSimpleParamList(e25.params)), e25.body = this.parseBlock(false), e25.expression = false, this.adaptDirectivePrologue(e25.body.body), this.labels = s2;
  }
  this.exitScope(), this.strict && e25.id && this.checkLVal(e25.id, 5), this.strict = i2;
}, vd.isSimpleParamList = function(e25) {
  for (var t2 = 0, r2 = e25; t2 < r2.length; t2 += 1) {
    if (r2[t2].type !== "Identifier")
      return false;
  }
  return true;
}, vd.checkParams = function(e25, t2) {
  for (var r2 = {}, n2 = 0, i2 = e25.params; n2 < i2.length; n2 += 1) {
    var a2 = i2[n2];
    this.checkLVal(a2, 1, t2 ? null : r2);
  }
}, vd.parseExprList = function(e25, t2, r2, n2) {
  for (var i2 = [], a2 = true; !this.eat(e25); ) {
    if (a2)
      a2 = false;
    else if (this.expect(Rh.comma), t2 && this.afterTrailingComma(e25))
      break;
    var o2 = void 0;
    r2 && this.type === Rh.comma ? o2 = null : this.type === Rh.ellipsis ? (o2 = this.parseSpread(n2), n2 && this.type === Rh.comma && n2.trailingComma < 0 && (n2.trailingComma = this.start)) : o2 = this.parseMaybeAssign(false, n2), i2.push(o2);
  }
  return i2;
}, vd.checkUnreserved = function(e25) {
  var t2 = e25.start, r2 = e25.end, n2 = e25.name;
  (this.inGenerator && n2 === "yield" && this.raiseRecoverable(t2, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && n2 === "await" && this.raiseRecoverable(t2, "Cannot use 'await' as identifier inside an async function"), this.keywords.test(n2) && this.raise(t2, "Unexpected keyword '" + n2 + "'"), this.options.ecmaVersion < 6 && this.input.slice(t2, r2).indexOf("\\") !== -1) || (this.strict ? this.reservedWordsStrict : this.reservedWords).test(n2) && (this.inAsync || n2 !== "await" || this.raiseRecoverable(t2, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(t2, "The keyword '" + n2 + "' is reserved"));
}, vd.parseIdent = function(e25, t2) {
  var r2 = this.startNode();
  return this.type === Rh.name ? r2.name = this.value : this.type.keyword ? (r2.name = this.type.keyword, r2.name !== "class" && r2.name !== "function" || this.lastTokEnd === this.lastTokStart + 1 && this.input.charCodeAt(this.lastTokStart) === 46 || this.context.pop()) : this.unexpected(), this.next(), this.finishNode(r2, "Identifier"), e25 || (this.checkUnreserved(r2), r2.name !== "await" || this.awaitIdentPos || (this.awaitIdentPos = r2.start)), r2;
}, vd.parseYield = function(e25) {
  this.yieldPos || (this.yieldPos = this.start);
  var t2 = this.startNode();
  return this.next(), this.type === Rh.semi || this.canInsertSemicolon() || this.type !== Rh.star && !this.type.startsExpr ? (t2.delegate = false, t2.argument = null) : (t2.delegate = this.eat(Rh.star), t2.argument = this.parseMaybeAssign(e25)), this.finishNode(t2, "YieldExpression");
}, vd.parseAwait = function() {
  this.awaitPos || (this.awaitPos = this.start);
  var e25 = this.startNode();
  return this.next(), e25.argument = this.parseMaybeUnary(null, true), this.finishNode(e25, "AwaitExpression");
};
var bd = od.prototype;
bd.raise = function(e25, t2) {
  var r2 = Yh(this.input, e25);
  t2 += " (" + r2.line + ":" + r2.column + ")";
  var n2 = new SyntaxError(t2);
  throw n2.pos = e25, n2.loc = r2, n2.raisedAt = this.pos, n2;
}, bd.raiseRecoverable = bd.raise, bd.curPosition = function() {
  if (this.options.locations)
    return new Qh(this.curLine, this.pos - this.lineStart);
};
var Ed = od.prototype, Cd = function(e25) {
  this.flags = e25, this.var = [], this.lexical = [], this.functions = [];
};
Ed.enterScope = function(e25) {
  this.scopeStack.push(new Cd(e25));
}, Ed.exitScope = function() {
  this.scopeStack.pop();
}, Ed.treatFunctionsAsVarInScope = function(e25) {
  return e25.flags & td || !this.inModule && 1 & e25.flags;
}, Ed.declareName = function(e25, t2, r2) {
  var n2 = false;
  if (t2 === 2) {
    var i2 = this.currentScope();
    n2 = i2.lexical.indexOf(e25) > -1 || i2.functions.indexOf(e25) > -1 || i2.var.indexOf(e25) > -1, i2.lexical.push(e25), this.inModule && 1 & i2.flags && delete this.undefinedExports[e25];
  } else if (t2 === 4) {
    this.currentScope().lexical.push(e25);
  } else if (t2 === 3) {
    var a2 = this.currentScope();
    n2 = this.treatFunctionsAsVar ? a2.lexical.indexOf(e25) > -1 : a2.lexical.indexOf(e25) > -1 || a2.var.indexOf(e25) > -1, a2.functions.push(e25);
  } else
    for (var o2 = this.scopeStack.length - 1; o2 >= 0; --o2) {
      var s2 = this.scopeStack[o2];
      if (s2.lexical.indexOf(e25) > -1 && !(32 & s2.flags && s2.lexical[0] === e25) || !this.treatFunctionsAsVarInScope(s2) && s2.functions.indexOf(e25) > -1) {
        n2 = true;
        break;
      }
      if (s2.var.push(e25), this.inModule && 1 & s2.flags && delete this.undefinedExports[e25], s2.flags & rd)
        break;
    }
  n2 && this.raiseRecoverable(r2, "Identifier '" + e25 + "' has already been declared");
}, Ed.checkLocalExport = function(e25) {
  this.scopeStack[0].lexical.indexOf(e25.name) === -1 && this.scopeStack[0].var.indexOf(e25.name) === -1 && (this.undefinedExports[e25.name] = e25);
}, Ed.currentScope = function() {
  return this.scopeStack[this.scopeStack.length - 1];
}, Ed.currentVarScope = function() {
  for (var e25 = this.scopeStack.length - 1; ; e25--) {
    var t2 = this.scopeStack[e25];
    if (t2.flags & rd)
      return t2;
  }
}, Ed.currentThisScope = function() {
  for (var e25 = this.scopeStack.length - 1; ; e25--) {
    var t2 = this.scopeStack[e25];
    if (t2.flags & rd && !(16 & t2.flags))
      return t2;
  }
};
var Sd = function(e25, t2, r2) {
  this.type = "", this.start = t2, this.end = 0, e25.options.locations && (this.loc = new Xh(e25, r2)), e25.options.directSourceFile && (this.sourceFile = e25.options.directSourceFile), e25.options.ranges && (this.range = [t2, 0]);
}, kd = od.prototype;
function Dd(e25, t2, r2, n2) {
  return e25.type = t2, e25.end = r2, this.options.locations && (e25.loc.end = n2), this.options.ranges && (e25.range[1] = r2), e25;
}
kd.startNode = function() {
  return new Sd(this, this.start, this.startLoc);
}, kd.startNodeAt = function(e25, t2) {
  return new Sd(this, e25, t2);
}, kd.finishNode = function(e25, t2) {
  return Dd.call(this, e25, t2, this.lastTokEnd, this.lastTokEndLoc);
}, kd.finishNodeAt = function(e25, t2, r2, n2) {
  return Dd.call(this, e25, t2, r2, n2);
};
var Fd = function(e25, t2, r2, n2, i2) {
  this.token = e25, this.isExpr = !!t2, this.preserveSpace = !!r2, this.override = n2, this.generator = !!i2;
}, Ad = { b_stat: new Fd("{", false), b_expr: new Fd("{", true), b_tmpl: new Fd("${", false), p_stat: new Fd("(", false), p_expr: new Fd("(", true), q_tmpl: new Fd("`", true, true, function(e25) {
  return e25.tryReadTemplateToken();
}), f_stat: new Fd("function", false), f_expr: new Fd("function", true), f_expr_gen: new Fd("function", true, false, null, true), f_gen: new Fd("function", false, false, null, true) }, wd = od.prototype;
wd.initialContext = function() {
  return [Ad.b_stat];
}, wd.braceIsBlock = function(e25) {
  var t2 = this.curContext();
  return t2 === Ad.f_expr || t2 === Ad.f_stat || (e25 !== Rh.colon || t2 !== Ad.b_stat && t2 !== Ad.b_expr ? e25 === Rh._return || e25 === Rh.name && this.exprAllowed ? Mh.test(this.input.slice(this.lastTokEnd, this.start)) : e25 === Rh._else || e25 === Rh.semi || e25 === Rh.eof || e25 === Rh.parenR || e25 === Rh.arrow || (e25 === Rh.braceL ? t2 === Ad.b_stat : e25 !== Rh._var && e25 !== Rh._const && e25 !== Rh.name && !this.exprAllowed) : !t2.isExpr);
}, wd.inGeneratorContext = function() {
  for (var e25 = this.context.length - 1; e25 >= 1; e25--) {
    var t2 = this.context[e25];
    if (t2.token === "function")
      return t2.generator;
  }
  return false;
}, wd.updateContext = function(e25) {
  var t2, r2 = this.type;
  r2.keyword && e25 === Rh.dot ? this.exprAllowed = false : (t2 = r2.updateContext) ? t2.call(this, e25) : this.exprAllowed = r2.beforeExpr;
}, Rh.parenR.updateContext = Rh.braceR.updateContext = function() {
  if (this.context.length !== 1) {
    var e25 = this.context.pop();
    e25 === Ad.b_stat && this.curContext().token === "function" && (e25 = this.context.pop()), this.exprAllowed = !e25.isExpr;
  } else
    this.exprAllowed = true;
}, Rh.braceL.updateContext = function(e25) {
  this.context.push(this.braceIsBlock(e25) ? Ad.b_stat : Ad.b_expr), this.exprAllowed = true;
}, Rh.dollarBraceL.updateContext = function() {
  this.context.push(Ad.b_tmpl), this.exprAllowed = true;
}, Rh.parenL.updateContext = function(e25) {
  var t2 = e25 === Rh._if || e25 === Rh._for || e25 === Rh._with || e25 === Rh._while;
  this.context.push(t2 ? Ad.p_stat : Ad.p_expr), this.exprAllowed = true;
}, Rh.incDec.updateContext = function() {
}, Rh._function.updateContext = Rh._class.updateContext = function(e25) {
  !e25.beforeExpr || e25 === Rh.semi || e25 === Rh._else || e25 === Rh._return && Mh.test(this.input.slice(this.lastTokEnd, this.start)) || (e25 === Rh.colon || e25 === Rh.braceL) && this.curContext() === Ad.b_stat ? this.context.push(Ad.f_stat) : this.context.push(Ad.f_expr), this.exprAllowed = false;
}, Rh.backQuote.updateContext = function() {
  this.curContext() === Ad.q_tmpl ? this.context.pop() : this.context.push(Ad.q_tmpl), this.exprAllowed = false;
}, Rh.star.updateContext = function(e25) {
  if (e25 === Rh._function) {
    var t2 = this.context.length - 1;
    this.context[t2] === Ad.f_expr ? this.context[t2] = Ad.f_expr_gen : this.context[t2] = Ad.f_gen;
  }
  this.exprAllowed = true;
}, Rh.name.updateContext = function(e25) {
  var t2 = false;
  this.options.ecmaVersion >= 6 && e25 !== Rh.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (t2 = true), this.exprAllowed = t2;
};
var _d = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", Td = _d + " Extended_Pictographic", Pd = { 9: _d, 10: Td, 11: "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS Extended_Pictographic" }, Id = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", Bd = "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", Od = Bd + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", Ld = { 9: Bd, 10: Od, 11: "Adlam Adlm Ahom Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho" }, Nd = {};
function jd(e25) {
  var t2 = Nd[e25] = { binary: Jh(Pd[e25] + " " + Id), nonBinary: { General_Category: Jh(Id), Script: Jh(Ld[e25]) } };
  t2.nonBinary.Script_Extensions = t2.nonBinary.Script, t2.nonBinary.gc = t2.nonBinary.General_Category, t2.nonBinary.sc = t2.nonBinary.Script, t2.nonBinary.scx = t2.nonBinary.Script_Extensions;
}
jd(9), jd(10), jd(11);
var Rd = od.prototype, Md = function(e25) {
  this.parser = e25, this.validFlags = "gim" + (e25.options.ecmaVersion >= 6 ? "uy" : "") + (e25.options.ecmaVersion >= 9 ? "s" : ""), this.unicodeProperties = Nd[e25.options.ecmaVersion >= 11 ? 11 : e25.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = false, this.switchN = false, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = false, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = [], this.backReferenceNames = [];
};
function Vd(e25) {
  return e25 <= 65535 ? String.fromCharCode(e25) : (e25 -= 65536, String.fromCharCode(55296 + (e25 >> 10), 56320 + (1023 & e25)));
}
function Ud(e25) {
  return e25 === 36 || e25 >= 40 && e25 <= 43 || e25 === 46 || e25 === 63 || e25 >= 91 && e25 <= 94 || e25 >= 123 && e25 <= 125;
}
function qd(e25) {
  return e25 >= 65 && e25 <= 90 || e25 >= 97 && e25 <= 122;
}
function Wd(e25) {
  return qd(e25) || e25 === 95;
}
function $d(e25) {
  return Wd(e25) || Gd(e25);
}
function Gd(e25) {
  return e25 >= 48 && e25 <= 57;
}
function zd(e25) {
  return e25 >= 48 && e25 <= 57 || e25 >= 65 && e25 <= 70 || e25 >= 97 && e25 <= 102;
}
function Hd(e25) {
  return e25 >= 65 && e25 <= 70 ? e25 - 65 + 10 : e25 >= 97 && e25 <= 102 ? e25 - 97 + 10 : e25 - 48;
}
function Kd(e25) {
  return e25 >= 48 && e25 <= 55;
}
Md.prototype.reset = function(e25, t2, r2) {
  var n2 = r2.indexOf("u") !== -1;
  this.start = 0 | e25, this.source = t2 + "", this.flags = r2, this.switchU = n2 && this.parser.options.ecmaVersion >= 6, this.switchN = n2 && this.parser.options.ecmaVersion >= 9;
}, Md.prototype.raise = function(e25) {
  this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + e25);
}, Md.prototype.at = function(e25) {
  var t2 = this.source, r2 = t2.length;
  if (e25 >= r2)
    return -1;
  var n2 = t2.charCodeAt(e25);
  return !this.switchU || n2 <= 55295 || n2 >= 57344 || e25 + 1 >= r2 ? n2 : (n2 << 10) + t2.charCodeAt(e25 + 1) - 56613888;
}, Md.prototype.nextIndex = function(e25) {
  var t2 = this.source, r2 = t2.length;
  if (e25 >= r2)
    return r2;
  var n2 = t2.charCodeAt(e25);
  return !this.switchU || n2 <= 55295 || n2 >= 57344 || e25 + 1 >= r2 ? e25 + 1 : e25 + 2;
}, Md.prototype.current = function() {
  return this.at(this.pos);
}, Md.prototype.lookahead = function() {
  return this.at(this.nextIndex(this.pos));
}, Md.prototype.advance = function() {
  this.pos = this.nextIndex(this.pos);
}, Md.prototype.eat = function(e25) {
  return this.current() === e25 && (this.advance(), true);
}, Rd.validateRegExpFlags = function(e25) {
  for (var t2 = e25.validFlags, r2 = e25.flags, n2 = 0; n2 < r2.length; n2++) {
    var i2 = r2.charAt(n2);
    t2.indexOf(i2) === -1 && this.raise(e25.start, "Invalid regular expression flag"), r2.indexOf(i2, n2 + 1) > -1 && this.raise(e25.start, "Duplicate regular expression flag");
  }
}, Rd.validateRegExpPattern = function(e25) {
  this.regexp_pattern(e25), !e25.switchN && this.options.ecmaVersion >= 9 && e25.groupNames.length > 0 && (e25.switchN = true, this.regexp_pattern(e25));
}, Rd.regexp_pattern = function(e25) {
  e25.pos = 0, e25.lastIntValue = 0, e25.lastStringValue = "", e25.lastAssertionIsQuantifiable = false, e25.numCapturingParens = 0, e25.maxBackReference = 0, e25.groupNames.length = 0, e25.backReferenceNames.length = 0, this.regexp_disjunction(e25), e25.pos !== e25.source.length && (e25.eat(41) && e25.raise("Unmatched ')'"), (e25.eat(93) || e25.eat(125)) && e25.raise("Lone quantifier brackets")), e25.maxBackReference > e25.numCapturingParens && e25.raise("Invalid escape");
  for (var t2 = 0, r2 = e25.backReferenceNames; t2 < r2.length; t2 += 1) {
    var n2 = r2[t2];
    e25.groupNames.indexOf(n2) === -1 && e25.raise("Invalid named capture referenced");
  }
}, Rd.regexp_disjunction = function(e25) {
  for (this.regexp_alternative(e25); e25.eat(124); )
    this.regexp_alternative(e25);
  this.regexp_eatQuantifier(e25, true) && e25.raise("Nothing to repeat"), e25.eat(123) && e25.raise("Lone quantifier brackets");
}, Rd.regexp_alternative = function(e25) {
  for (; e25.pos < e25.source.length && this.regexp_eatTerm(e25); )
    ;
}, Rd.regexp_eatTerm = function(e25) {
  return this.regexp_eatAssertion(e25) ? (e25.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(e25) && e25.switchU && e25.raise("Invalid quantifier"), true) : !(e25.switchU ? !this.regexp_eatAtom(e25) : !this.regexp_eatExtendedAtom(e25)) && (this.regexp_eatQuantifier(e25), true);
}, Rd.regexp_eatAssertion = function(e25) {
  var t2 = e25.pos;
  if (e25.lastAssertionIsQuantifiable = false, e25.eat(94) || e25.eat(36))
    return true;
  if (e25.eat(92)) {
    if (e25.eat(66) || e25.eat(98))
      return true;
    e25.pos = t2;
  }
  if (e25.eat(40) && e25.eat(63)) {
    var r2 = false;
    if (this.options.ecmaVersion >= 9 && (r2 = e25.eat(60)), e25.eat(61) || e25.eat(33))
      return this.regexp_disjunction(e25), e25.eat(41) || e25.raise("Unterminated group"), e25.lastAssertionIsQuantifiable = !r2, true;
  }
  return e25.pos = t2, false;
}, Rd.regexp_eatQuantifier = function(e25, t2) {
  return t2 === void 0 && (t2 = false), !!this.regexp_eatQuantifierPrefix(e25, t2) && (e25.eat(63), true);
}, Rd.regexp_eatQuantifierPrefix = function(e25, t2) {
  return e25.eat(42) || e25.eat(43) || e25.eat(63) || this.regexp_eatBracedQuantifier(e25, t2);
}, Rd.regexp_eatBracedQuantifier = function(e25, t2) {
  var r2 = e25.pos;
  if (e25.eat(123)) {
    var n2 = 0, i2 = -1;
    if (this.regexp_eatDecimalDigits(e25) && (n2 = e25.lastIntValue, e25.eat(44) && this.regexp_eatDecimalDigits(e25) && (i2 = e25.lastIntValue), e25.eat(125)))
      return i2 !== -1 && i2 < n2 && !t2 && e25.raise("numbers out of order in {} quantifier"), true;
    e25.switchU && !t2 && e25.raise("Incomplete quantifier"), e25.pos = r2;
  }
  return false;
}, Rd.regexp_eatAtom = function(e25) {
  return this.regexp_eatPatternCharacters(e25) || e25.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e25) || this.regexp_eatCharacterClass(e25) || this.regexp_eatUncapturingGroup(e25) || this.regexp_eatCapturingGroup(e25);
}, Rd.regexp_eatReverseSolidusAtomEscape = function(e25) {
  var t2 = e25.pos;
  if (e25.eat(92)) {
    if (this.regexp_eatAtomEscape(e25))
      return true;
    e25.pos = t2;
  }
  return false;
}, Rd.regexp_eatUncapturingGroup = function(e25) {
  var t2 = e25.pos;
  if (e25.eat(40)) {
    if (e25.eat(63) && e25.eat(58)) {
      if (this.regexp_disjunction(e25), e25.eat(41))
        return true;
      e25.raise("Unterminated group");
    }
    e25.pos = t2;
  }
  return false;
}, Rd.regexp_eatCapturingGroup = function(e25) {
  if (e25.eat(40)) {
    if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(e25) : e25.current() === 63 && e25.raise("Invalid group"), this.regexp_disjunction(e25), e25.eat(41))
      return e25.numCapturingParens += 1, true;
    e25.raise("Unterminated group");
  }
  return false;
}, Rd.regexp_eatExtendedAtom = function(e25) {
  return e25.eat(46) || this.regexp_eatReverseSolidusAtomEscape(e25) || this.regexp_eatCharacterClass(e25) || this.regexp_eatUncapturingGroup(e25) || this.regexp_eatCapturingGroup(e25) || this.regexp_eatInvalidBracedQuantifier(e25) || this.regexp_eatExtendedPatternCharacter(e25);
}, Rd.regexp_eatInvalidBracedQuantifier = function(e25) {
  return this.regexp_eatBracedQuantifier(e25, true) && e25.raise("Nothing to repeat"), false;
}, Rd.regexp_eatSyntaxCharacter = function(e25) {
  var t2 = e25.current();
  return !!Ud(t2) && (e25.lastIntValue = t2, e25.advance(), true);
}, Rd.regexp_eatPatternCharacters = function(e25) {
  for (var t2 = e25.pos, r2 = 0; (r2 = e25.current()) !== -1 && !Ud(r2); )
    e25.advance();
  return e25.pos !== t2;
}, Rd.regexp_eatExtendedPatternCharacter = function(e25) {
  var t2 = e25.current();
  return !(t2 === -1 || t2 === 36 || t2 >= 40 && t2 <= 43 || t2 === 46 || t2 === 63 || t2 === 91 || t2 === 94 || t2 === 124) && (e25.advance(), true);
}, Rd.regexp_groupSpecifier = function(e25) {
  if (e25.eat(63)) {
    if (this.regexp_eatGroupName(e25))
      return e25.groupNames.indexOf(e25.lastStringValue) !== -1 && e25.raise("Duplicate capture group name"), void e25.groupNames.push(e25.lastStringValue);
    e25.raise("Invalid group");
  }
}, Rd.regexp_eatGroupName = function(e25) {
  if (e25.lastStringValue = "", e25.eat(60)) {
    if (this.regexp_eatRegExpIdentifierName(e25) && e25.eat(62))
      return true;
    e25.raise("Invalid capture group name");
  }
  return false;
}, Rd.regexp_eatRegExpIdentifierName = function(e25) {
  if (e25.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(e25)) {
    for (e25.lastStringValue += Vd(e25.lastIntValue); this.regexp_eatRegExpIdentifierPart(e25); )
      e25.lastStringValue += Vd(e25.lastIntValue);
    return true;
  }
  return false;
}, Rd.regexp_eatRegExpIdentifierStart = function(e25) {
  var t2 = e25.pos, r2 = e25.current();
  return e25.advance(), r2 === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e25) && (r2 = e25.lastIntValue), function(e26) {
    return Th(e26, true) || e26 === 36 || e26 === 95;
  }(r2) ? (e25.lastIntValue = r2, true) : (e25.pos = t2, false);
}, Rd.regexp_eatRegExpIdentifierPart = function(e25) {
  var t2 = e25.pos, r2 = e25.current();
  return e25.advance(), r2 === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e25) && (r2 = e25.lastIntValue), function(e26) {
    return Ph(e26, true) || e26 === 36 || e26 === 95 || e26 === 8204 || e26 === 8205;
  }(r2) ? (e25.lastIntValue = r2, true) : (e25.pos = t2, false);
}, Rd.regexp_eatAtomEscape = function(e25) {
  return !!(this.regexp_eatBackReference(e25) || this.regexp_eatCharacterClassEscape(e25) || this.regexp_eatCharacterEscape(e25) || e25.switchN && this.regexp_eatKGroupName(e25)) || (e25.switchU && (e25.current() === 99 && e25.raise("Invalid unicode escape"), e25.raise("Invalid escape")), false);
}, Rd.regexp_eatBackReference = function(e25) {
  var t2 = e25.pos;
  if (this.regexp_eatDecimalEscape(e25)) {
    var r2 = e25.lastIntValue;
    if (e25.switchU)
      return r2 > e25.maxBackReference && (e25.maxBackReference = r2), true;
    if (r2 <= e25.numCapturingParens)
      return true;
    e25.pos = t2;
  }
  return false;
}, Rd.regexp_eatKGroupName = function(e25) {
  if (e25.eat(107)) {
    if (this.regexp_eatGroupName(e25))
      return e25.backReferenceNames.push(e25.lastStringValue), true;
    e25.raise("Invalid named reference");
  }
  return false;
}, Rd.regexp_eatCharacterEscape = function(e25) {
  return this.regexp_eatControlEscape(e25) || this.regexp_eatCControlLetter(e25) || this.regexp_eatZero(e25) || this.regexp_eatHexEscapeSequence(e25) || this.regexp_eatRegExpUnicodeEscapeSequence(e25) || !e25.switchU && this.regexp_eatLegacyOctalEscapeSequence(e25) || this.regexp_eatIdentityEscape(e25);
}, Rd.regexp_eatCControlLetter = function(e25) {
  var t2 = e25.pos;
  if (e25.eat(99)) {
    if (this.regexp_eatControlLetter(e25))
      return true;
    e25.pos = t2;
  }
  return false;
}, Rd.regexp_eatZero = function(e25) {
  return e25.current() === 48 && !Gd(e25.lookahead()) && (e25.lastIntValue = 0, e25.advance(), true);
}, Rd.regexp_eatControlEscape = function(e25) {
  var t2 = e25.current();
  return t2 === 116 ? (e25.lastIntValue = 9, e25.advance(), true) : t2 === 110 ? (e25.lastIntValue = 10, e25.advance(), true) : t2 === 118 ? (e25.lastIntValue = 11, e25.advance(), true) : t2 === 102 ? (e25.lastIntValue = 12, e25.advance(), true) : t2 === 114 && (e25.lastIntValue = 13, e25.advance(), true);
}, Rd.regexp_eatControlLetter = function(e25) {
  var t2 = e25.current();
  return !!qd(t2) && (e25.lastIntValue = t2 % 32, e25.advance(), true);
}, Rd.regexp_eatRegExpUnicodeEscapeSequence = function(e25) {
  var t2, r2 = e25.pos;
  if (e25.eat(117)) {
    if (this.regexp_eatFixedHexDigits(e25, 4)) {
      var n2 = e25.lastIntValue;
      if (e25.switchU && n2 >= 55296 && n2 <= 56319) {
        var i2 = e25.pos;
        if (e25.eat(92) && e25.eat(117) && this.regexp_eatFixedHexDigits(e25, 4)) {
          var a2 = e25.lastIntValue;
          if (a2 >= 56320 && a2 <= 57343)
            return e25.lastIntValue = 1024 * (n2 - 55296) + (a2 - 56320) + 65536, true;
        }
        e25.pos = i2, e25.lastIntValue = n2;
      }
      return true;
    }
    if (e25.switchU && e25.eat(123) && this.regexp_eatHexDigits(e25) && e25.eat(125) && ((t2 = e25.lastIntValue) >= 0 && t2 <= 1114111))
      return true;
    e25.switchU && e25.raise("Invalid unicode escape"), e25.pos = r2;
  }
  return false;
}, Rd.regexp_eatIdentityEscape = function(e25) {
  if (e25.switchU)
    return !!this.regexp_eatSyntaxCharacter(e25) || !!e25.eat(47) && (e25.lastIntValue = 47, true);
  var t2 = e25.current();
  return !(t2 === 99 || e25.switchN && t2 === 107) && (e25.lastIntValue = t2, e25.advance(), true);
}, Rd.regexp_eatDecimalEscape = function(e25) {
  e25.lastIntValue = 0;
  var t2 = e25.current();
  if (t2 >= 49 && t2 <= 57) {
    do {
      e25.lastIntValue = 10 * e25.lastIntValue + (t2 - 48), e25.advance();
    } while ((t2 = e25.current()) >= 48 && t2 <= 57);
    return true;
  }
  return false;
}, Rd.regexp_eatCharacterClassEscape = function(e25) {
  var t2 = e25.current();
  if (function(e26) {
    return e26 === 100 || e26 === 68 || e26 === 115 || e26 === 83 || e26 === 119 || e26 === 87;
  }(t2))
    return e25.lastIntValue = -1, e25.advance(), true;
  if (e25.switchU && this.options.ecmaVersion >= 9 && (t2 === 80 || t2 === 112)) {
    if (e25.lastIntValue = -1, e25.advance(), e25.eat(123) && this.regexp_eatUnicodePropertyValueExpression(e25) && e25.eat(125))
      return true;
    e25.raise("Invalid property name");
  }
  return false;
}, Rd.regexp_eatUnicodePropertyValueExpression = function(e25) {
  var t2 = e25.pos;
  if (this.regexp_eatUnicodePropertyName(e25) && e25.eat(61)) {
    var r2 = e25.lastStringValue;
    if (this.regexp_eatUnicodePropertyValue(e25)) {
      var n2 = e25.lastStringValue;
      return this.regexp_validateUnicodePropertyNameAndValue(e25, r2, n2), true;
    }
  }
  if (e25.pos = t2, this.regexp_eatLoneUnicodePropertyNameOrValue(e25)) {
    var i2 = e25.lastStringValue;
    return this.regexp_validateUnicodePropertyNameOrValue(e25, i2), true;
  }
  return false;
}, Rd.regexp_validateUnicodePropertyNameAndValue = function(e25, t2, r2) {
  Hh(e25.unicodeProperties.nonBinary, t2) || e25.raise("Invalid property name"), e25.unicodeProperties.nonBinary[t2].test(r2) || e25.raise("Invalid property value");
}, Rd.regexp_validateUnicodePropertyNameOrValue = function(e25, t2) {
  e25.unicodeProperties.binary.test(t2) || e25.raise("Invalid property name");
}, Rd.regexp_eatUnicodePropertyName = function(e25) {
  var t2 = 0;
  for (e25.lastStringValue = ""; Wd(t2 = e25.current()); )
    e25.lastStringValue += Vd(t2), e25.advance();
  return e25.lastStringValue !== "";
}, Rd.regexp_eatUnicodePropertyValue = function(e25) {
  var t2 = 0;
  for (e25.lastStringValue = ""; $d(t2 = e25.current()); )
    e25.lastStringValue += Vd(t2), e25.advance();
  return e25.lastStringValue !== "";
}, Rd.regexp_eatLoneUnicodePropertyNameOrValue = function(e25) {
  return this.regexp_eatUnicodePropertyValue(e25);
}, Rd.regexp_eatCharacterClass = function(e25) {
  if (e25.eat(91)) {
    if (e25.eat(94), this.regexp_classRanges(e25), e25.eat(93))
      return true;
    e25.raise("Unterminated character class");
  }
  return false;
}, Rd.regexp_classRanges = function(e25) {
  for (; this.regexp_eatClassAtom(e25); ) {
    var t2 = e25.lastIntValue;
    if (e25.eat(45) && this.regexp_eatClassAtom(e25)) {
      var r2 = e25.lastIntValue;
      !e25.switchU || t2 !== -1 && r2 !== -1 || e25.raise("Invalid character class"), t2 !== -1 && r2 !== -1 && t2 > r2 && e25.raise("Range out of order in character class");
    }
  }
}, Rd.regexp_eatClassAtom = function(e25) {
  var t2 = e25.pos;
  if (e25.eat(92)) {
    if (this.regexp_eatClassEscape(e25))
      return true;
    if (e25.switchU) {
      var r2 = e25.current();
      (r2 === 99 || Kd(r2)) && e25.raise("Invalid class escape"), e25.raise("Invalid escape");
    }
    e25.pos = t2;
  }
  var n2 = e25.current();
  return n2 !== 93 && (e25.lastIntValue = n2, e25.advance(), true);
}, Rd.regexp_eatClassEscape = function(e25) {
  var t2 = e25.pos;
  if (e25.eat(98))
    return e25.lastIntValue = 8, true;
  if (e25.switchU && e25.eat(45))
    return e25.lastIntValue = 45, true;
  if (!e25.switchU && e25.eat(99)) {
    if (this.regexp_eatClassControlLetter(e25))
      return true;
    e25.pos = t2;
  }
  return this.regexp_eatCharacterClassEscape(e25) || this.regexp_eatCharacterEscape(e25);
}, Rd.regexp_eatClassControlLetter = function(e25) {
  var t2 = e25.current();
  return !(!Gd(t2) && t2 !== 95) && (e25.lastIntValue = t2 % 32, e25.advance(), true);
}, Rd.regexp_eatHexEscapeSequence = function(e25) {
  var t2 = e25.pos;
  if (e25.eat(120)) {
    if (this.regexp_eatFixedHexDigits(e25, 2))
      return true;
    e25.switchU && e25.raise("Invalid escape"), e25.pos = t2;
  }
  return false;
}, Rd.regexp_eatDecimalDigits = function(e25) {
  var t2 = e25.pos, r2 = 0;
  for (e25.lastIntValue = 0; Gd(r2 = e25.current()); )
    e25.lastIntValue = 10 * e25.lastIntValue + (r2 - 48), e25.advance();
  return e25.pos !== t2;
}, Rd.regexp_eatHexDigits = function(e25) {
  var t2 = e25.pos, r2 = 0;
  for (e25.lastIntValue = 0; zd(r2 = e25.current()); )
    e25.lastIntValue = 16 * e25.lastIntValue + Hd(r2), e25.advance();
  return e25.pos !== t2;
}, Rd.regexp_eatLegacyOctalEscapeSequence = function(e25) {
  if (this.regexp_eatOctalDigit(e25)) {
    var t2 = e25.lastIntValue;
    if (this.regexp_eatOctalDigit(e25)) {
      var r2 = e25.lastIntValue;
      t2 <= 3 && this.regexp_eatOctalDigit(e25) ? e25.lastIntValue = 64 * t2 + 8 * r2 + e25.lastIntValue : e25.lastIntValue = 8 * t2 + r2;
    } else
      e25.lastIntValue = t2;
    return true;
  }
  return false;
}, Rd.regexp_eatOctalDigit = function(e25) {
  var t2 = e25.current();
  return Kd(t2) ? (e25.lastIntValue = t2 - 48, e25.advance(), true) : (e25.lastIntValue = 0, false);
}, Rd.regexp_eatFixedHexDigits = function(e25, t2) {
  var r2 = e25.pos;
  e25.lastIntValue = 0;
  for (var n2 = 0; n2 < t2; ++n2) {
    var i2 = e25.current();
    if (!zd(i2))
      return e25.pos = r2, false;
    e25.lastIntValue = 16 * e25.lastIntValue + Hd(i2), e25.advance();
  }
  return true;
};
var Jd = function(e25) {
  this.type = e25.type, this.value = e25.value, this.start = e25.start, this.end = e25.end, e25.options.locations && (this.loc = new Xh(e25, e25.startLoc, e25.endLoc)), e25.options.ranges && (this.range = [e25.start, e25.end]);
}, Qd = od.prototype;
function Xd(e25) {
  return e25 <= 65535 ? String.fromCharCode(e25) : (e25 -= 65536, String.fromCharCode(55296 + (e25 >> 10), 56320 + (1023 & e25)));
}
Qd.next = function() {
  this.options.onToken && this.options.onToken(new Jd(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
}, Qd.getToken = function() {
  return this.next(), new Jd(this);
}, typeof Symbol != "undefined" && (Qd[Symbol.iterator] = function() {
  var e25 = this;
  return { next: function() {
    var t2 = e25.getToken();
    return { done: t2.type === Rh.eof, value: t2 };
  } };
}), Qd.curContext = function() {
  return this.context[this.context.length - 1];
}, Qd.nextToken = function() {
  var e25 = this.curContext();
  return e25 && e25.preserveSpace || this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length ? this.finishToken(Rh.eof) : e25.override ? e25.override(this) : void this.readToken(this.fullCharCodeAtPos());
}, Qd.readToken = function(e25) {
  return Th(e25, this.options.ecmaVersion >= 6) || e25 === 92 ? this.readWord() : this.getTokenFromCode(e25);
}, Qd.fullCharCodeAtPos = function() {
  var e25 = this.input.charCodeAt(this.pos);
  return e25 <= 55295 || e25 >= 57344 ? e25 : (e25 << 10) + this.input.charCodeAt(this.pos + 1) - 56613888;
}, Qd.skipBlockComment = function() {
  var e25, t2 = this.options.onComment && this.curPosition(), r2 = this.pos, n2 = this.input.indexOf("*/", this.pos += 2);
  if (n2 === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = n2 + 2, this.options.locations)
    for (Vh.lastIndex = r2; (e25 = Vh.exec(this.input)) && e25.index < this.pos; )
      ++this.curLine, this.lineStart = e25.index + e25[0].length;
  this.options.onComment && this.options.onComment(true, this.input.slice(r2 + 2, n2), r2, this.pos, t2, this.curPosition());
}, Qd.skipLineComment = function(e25) {
  for (var t2 = this.pos, r2 = this.options.onComment && this.curPosition(), n2 = this.input.charCodeAt(this.pos += e25); this.pos < this.input.length && !Uh(n2); )
    n2 = this.input.charCodeAt(++this.pos);
  this.options.onComment && this.options.onComment(false, this.input.slice(t2 + e25, this.pos), t2, this.pos, r2, this.curPosition());
}, Qd.skipSpace = function() {
  e:
    for (; this.pos < this.input.length; ) {
      var e25 = this.input.charCodeAt(this.pos);
      switch (e25) {
        case 32:
        case 160:
          ++this.pos;
          break;
        case 13:
          this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
        case 10:
        case 8232:
        case 8233:
          ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
          break;
        case 47:
          switch (this.input.charCodeAt(this.pos + 1)) {
            case 42:
              this.skipBlockComment();
              break;
            case 47:
              this.skipLineComment(2);
              break;
            default:
              break e;
          }
          break;
        default:
          if (!(e25 > 8 && e25 < 14 || e25 >= 5760 && qh.test(String.fromCharCode(e25))))
            break e;
          ++this.pos;
      }
    }
}, Qd.finishToken = function(e25, t2) {
  this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
  var r2 = this.type;
  this.type = e25, this.value = t2, this.updateContext(r2);
}, Qd.readToken_dot = function() {
  var e25 = this.input.charCodeAt(this.pos + 1);
  if (e25 >= 48 && e25 <= 57)
    return this.readNumber(true);
  var t2 = this.input.charCodeAt(this.pos + 2);
  return this.options.ecmaVersion >= 6 && e25 === 46 && t2 === 46 ? (this.pos += 3, this.finishToken(Rh.ellipsis)) : (++this.pos, this.finishToken(Rh.dot));
}, Qd.readToken_slash = function() {
  var e25 = this.input.charCodeAt(this.pos + 1);
  return this.exprAllowed ? (++this.pos, this.readRegexp()) : e25 === 61 ? this.finishOp(Rh.assign, 2) : this.finishOp(Rh.slash, 1);
}, Qd.readToken_mult_modulo_exp = function(e25) {
  var t2 = this.input.charCodeAt(this.pos + 1), r2 = 1, n2 = e25 === 42 ? Rh.star : Rh.modulo;
  return this.options.ecmaVersion >= 7 && e25 === 42 && t2 === 42 && (++r2, n2 = Rh.starstar, t2 = this.input.charCodeAt(this.pos + 2)), t2 === 61 ? this.finishOp(Rh.assign, r2 + 1) : this.finishOp(n2, r2);
}, Qd.readToken_pipe_amp = function(e25) {
  var t2 = this.input.charCodeAt(this.pos + 1);
  return t2 === e25 ? this.finishOp(e25 === 124 ? Rh.logicalOR : Rh.logicalAND, 2) : t2 === 61 ? this.finishOp(Rh.assign, 2) : this.finishOp(e25 === 124 ? Rh.bitwiseOR : Rh.bitwiseAND, 1);
}, Qd.readToken_caret = function() {
  return this.input.charCodeAt(this.pos + 1) === 61 ? this.finishOp(Rh.assign, 2) : this.finishOp(Rh.bitwiseXOR, 1);
}, Qd.readToken_plus_min = function(e25) {
  var t2 = this.input.charCodeAt(this.pos + 1);
  return t2 === e25 ? t2 !== 45 || this.inModule || this.input.charCodeAt(this.pos + 2) !== 62 || this.lastTokEnd !== 0 && !Mh.test(this.input.slice(this.lastTokEnd, this.pos)) ? this.finishOp(Rh.incDec, 2) : (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : t2 === 61 ? this.finishOp(Rh.assign, 2) : this.finishOp(Rh.plusMin, 1);
}, Qd.readToken_lt_gt = function(e25) {
  var t2 = this.input.charCodeAt(this.pos + 1), r2 = 1;
  return t2 === e25 ? (r2 = e25 === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + r2) === 61 ? this.finishOp(Rh.assign, r2 + 1) : this.finishOp(Rh.bitShift, r2)) : t2 !== 33 || e25 !== 60 || this.inModule || this.input.charCodeAt(this.pos + 2) !== 45 || this.input.charCodeAt(this.pos + 3) !== 45 ? (t2 === 61 && (r2 = 2), this.finishOp(Rh.relational, r2)) : (this.skipLineComment(4), this.skipSpace(), this.nextToken());
}, Qd.readToken_eq_excl = function(e25) {
  var t2 = this.input.charCodeAt(this.pos + 1);
  return t2 === 61 ? this.finishOp(Rh.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : e25 === 61 && t2 === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(Rh.arrow)) : this.finishOp(e25 === 61 ? Rh.eq : Rh.prefix, 1);
}, Qd.getTokenFromCode = function(e25) {
  switch (e25) {
    case 46:
      return this.readToken_dot();
    case 40:
      return ++this.pos, this.finishToken(Rh.parenL);
    case 41:
      return ++this.pos, this.finishToken(Rh.parenR);
    case 59:
      return ++this.pos, this.finishToken(Rh.semi);
    case 44:
      return ++this.pos, this.finishToken(Rh.comma);
    case 91:
      return ++this.pos, this.finishToken(Rh.bracketL);
    case 93:
      return ++this.pos, this.finishToken(Rh.bracketR);
    case 123:
      return ++this.pos, this.finishToken(Rh.braceL);
    case 125:
      return ++this.pos, this.finishToken(Rh.braceR);
    case 58:
      return ++this.pos, this.finishToken(Rh.colon);
    case 63:
      return ++this.pos, this.finishToken(Rh.question);
    case 96:
      if (this.options.ecmaVersion < 6)
        break;
      return ++this.pos, this.finishToken(Rh.backQuote);
    case 48:
      var t2 = this.input.charCodeAt(this.pos + 1);
      if (t2 === 120 || t2 === 88)
        return this.readRadixNumber(16);
      if (this.options.ecmaVersion >= 6) {
        if (t2 === 111 || t2 === 79)
          return this.readRadixNumber(8);
        if (t2 === 98 || t2 === 66)
          return this.readRadixNumber(2);
      }
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return this.readNumber(false);
    case 34:
    case 39:
      return this.readString(e25);
    case 47:
      return this.readToken_slash();
    case 37:
    case 42:
      return this.readToken_mult_modulo_exp(e25);
    case 124:
    case 38:
      return this.readToken_pipe_amp(e25);
    case 94:
      return this.readToken_caret();
    case 43:
    case 45:
      return this.readToken_plus_min(e25);
    case 60:
    case 62:
      return this.readToken_lt_gt(e25);
    case 61:
    case 33:
      return this.readToken_eq_excl(e25);
    case 126:
      return this.finishOp(Rh.prefix, 1);
  }
  this.raise(this.pos, "Unexpected character '" + Xd(e25) + "'");
}, Qd.finishOp = function(e25, t2) {
  var r2 = this.input.slice(this.pos, this.pos + t2);
  return this.pos += t2, this.finishToken(e25, r2);
}, Qd.readRegexp = function() {
  for (var e25, t2, r2 = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(r2, "Unterminated regular expression");
    var n2 = this.input.charAt(this.pos);
    if (Mh.test(n2) && this.raise(r2, "Unterminated regular expression"), e25)
      e25 = false;
    else {
      if (n2 === "[")
        t2 = true;
      else if (n2 === "]" && t2)
        t2 = false;
      else if (n2 === "/" && !t2)
        break;
      e25 = n2 === "\\";
    }
    ++this.pos;
  }
  var i2 = this.input.slice(r2, this.pos);
  ++this.pos;
  var a2 = this.pos, o2 = this.readWord1();
  this.containsEsc && this.unexpected(a2);
  var s2 = this.regexpState || (this.regexpState = new Md(this));
  s2.reset(r2, i2, o2), this.validateRegExpFlags(s2), this.validateRegExpPattern(s2);
  var u2 = null;
  try {
    u2 = new RegExp(i2, o2);
  } catch (e26) {
  }
  return this.finishToken(Rh.regexp, { pattern: i2, flags: o2, value: u2 });
}, Qd.readInt = function(e25, t2) {
  for (var r2 = this.pos, n2 = 0, i2 = 0, a2 = t2 == null ? 1 / 0 : t2; i2 < a2; ++i2) {
    var o2 = this.input.charCodeAt(this.pos), s2 = void 0;
    if ((s2 = o2 >= 97 ? o2 - 97 + 10 : o2 >= 65 ? o2 - 65 + 10 : o2 >= 48 && o2 <= 57 ? o2 - 48 : 1 / 0) >= e25)
      break;
    ++this.pos, n2 = n2 * e25 + s2;
  }
  return this.pos === r2 || t2 != null && this.pos - r2 !== t2 ? null : n2;
}, Qd.readRadixNumber = function(e25) {
  var t2 = this.pos;
  this.pos += 2;
  var r2 = this.readInt(e25);
  return r2 == null && this.raise(this.start + 2, "Expected number in radix " + e25), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (r2 = typeof BigInt != "undefined" ? BigInt(this.input.slice(t2, this.pos)) : null, ++this.pos) : Th(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(Rh.num, r2);
}, Qd.readNumber = function(e25) {
  var t2 = this.pos;
  e25 || this.readInt(10) !== null || this.raise(t2, "Invalid number");
  var r2 = this.pos - t2 >= 2 && this.input.charCodeAt(t2) === 48;
  r2 && this.strict && this.raise(t2, "Invalid number"), r2 && /[89]/.test(this.input.slice(t2, this.pos)) && (r2 = false);
  var n2 = this.input.charCodeAt(this.pos);
  if (!r2 && !e25 && this.options.ecmaVersion >= 11 && n2 === 110) {
    var i2 = this.input.slice(t2, this.pos), a2 = typeof BigInt != "undefined" ? BigInt(i2) : null;
    return ++this.pos, Th(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(Rh.num, a2);
  }
  n2 !== 46 || r2 || (++this.pos, this.readInt(10), n2 = this.input.charCodeAt(this.pos)), n2 !== 69 && n2 !== 101 || r2 || ((n2 = this.input.charCodeAt(++this.pos)) !== 43 && n2 !== 45 || ++this.pos, this.readInt(10) === null && this.raise(t2, "Invalid number")), Th(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
  var o2 = this.input.slice(t2, this.pos), s2 = r2 ? parseInt(o2, 8) : parseFloat(o2);
  return this.finishToken(Rh.num, s2);
}, Qd.readCodePoint = function() {
  var e25;
  if (this.input.charCodeAt(this.pos) === 123) {
    this.options.ecmaVersion < 6 && this.unexpected();
    var t2 = ++this.pos;
    e25 = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, e25 > 1114111 && this.invalidStringToken(t2, "Code point out of bounds");
  } else
    e25 = this.readHexChar(4);
  return e25;
}, Qd.readString = function(e25) {
  for (var t2 = "", r2 = ++this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
    var n2 = this.input.charCodeAt(this.pos);
    if (n2 === e25)
      break;
    n2 === 92 ? (t2 += this.input.slice(r2, this.pos), t2 += this.readEscapedChar(false), r2 = this.pos) : (Uh(n2, this.options.ecmaVersion >= 10) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
  }
  return t2 += this.input.slice(r2, this.pos++), this.finishToken(Rh.string, t2);
};
var Yd = {};
Qd.tryReadTemplateToken = function() {
  this.inTemplateElement = true;
  try {
    this.readTmplToken();
  } catch (e25) {
    if (e25 !== Yd)
      throw e25;
    this.readInvalidTemplateToken();
  }
  this.inTemplateElement = false;
}, Qd.invalidStringToken = function(e25, t2) {
  if (this.inTemplateElement && this.options.ecmaVersion >= 9)
    throw Yd;
  this.raise(e25, t2);
}, Qd.readTmplToken = function() {
  for (var e25 = "", t2 = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
    var r2 = this.input.charCodeAt(this.pos);
    if (r2 === 96 || r2 === 36 && this.input.charCodeAt(this.pos + 1) === 123)
      return this.pos !== this.start || this.type !== Rh.template && this.type !== Rh.invalidTemplate ? (e25 += this.input.slice(t2, this.pos), this.finishToken(Rh.template, e25)) : r2 === 36 ? (this.pos += 2, this.finishToken(Rh.dollarBraceL)) : (++this.pos, this.finishToken(Rh.backQuote));
    if (r2 === 92)
      e25 += this.input.slice(t2, this.pos), e25 += this.readEscapedChar(true), t2 = this.pos;
    else if (Uh(r2)) {
      switch (e25 += this.input.slice(t2, this.pos), ++this.pos, r2) {
        case 13:
          this.input.charCodeAt(this.pos) === 10 && ++this.pos;
        case 10:
          e25 += "\n";
          break;
        default:
          e25 += String.fromCharCode(r2);
      }
      this.options.locations && (++this.curLine, this.lineStart = this.pos), t2 = this.pos;
    } else
      ++this.pos;
  }
}, Qd.readInvalidTemplateToken = function() {
  for (; this.pos < this.input.length; this.pos++)
    switch (this.input[this.pos]) {
      case "\\":
        ++this.pos;
        break;
      case "$":
        if (this.input[this.pos + 1] !== "{")
          break;
      case "`":
        return this.finishToken(Rh.invalidTemplate, this.input.slice(this.start, this.pos));
    }
  this.raise(this.start, "Unterminated template");
}, Qd.readEscapedChar = function(e25) {
  var t2 = this.input.charCodeAt(++this.pos);
  switch (++this.pos, t2) {
    case 110:
      return "\n";
    case 114:
      return "\r";
    case 120:
      return String.fromCharCode(this.readHexChar(2));
    case 117:
      return Xd(this.readCodePoint());
    case 116:
      return "	";
    case 98:
      return "\b";
    case 118:
      return "\v";
    case 102:
      return "\f";
    case 13:
      this.input.charCodeAt(this.pos) === 10 && ++this.pos;
    case 10:
      return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
    default:
      if (t2 >= 48 && t2 <= 55) {
        var r2 = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], n2 = parseInt(r2, 8);
        return n2 > 255 && (r2 = r2.slice(0, -1), n2 = parseInt(r2, 8)), this.pos += r2.length - 1, t2 = this.input.charCodeAt(this.pos), r2 === "0" && t2 !== 56 && t2 !== 57 || !this.strict && !e25 || this.invalidStringToken(this.pos - 1 - r2.length, e25 ? "Octal literal in template string" : "Octal literal in strict mode"), String.fromCharCode(n2);
      }
      return Uh(t2) ? "" : String.fromCharCode(t2);
  }
}, Qd.readHexChar = function(e25) {
  var t2 = this.pos, r2 = this.readInt(16, e25);
  return r2 === null && this.invalidStringToken(t2, "Bad character escape sequence"), r2;
}, Qd.readWord1 = function() {
  this.containsEsc = false;
  for (var e25 = "", t2 = true, r2 = this.pos, n2 = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
    var i2 = this.fullCharCodeAtPos();
    if (Ph(i2, n2))
      this.pos += i2 <= 65535 ? 1 : 2;
    else {
      if (i2 !== 92)
        break;
      this.containsEsc = true, e25 += this.input.slice(r2, this.pos);
      var a2 = this.pos;
      this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
      var o2 = this.readCodePoint();
      (t2 ? Th : Ph)(o2, n2) || this.invalidStringToken(a2, "Invalid Unicode escape"), e25 += Xd(o2), r2 = this.pos;
    }
    t2 = false;
  }
  return e25 + this.input.slice(r2, this.pos);
}, Qd.readWord = function() {
  var e25 = this.readWord1(), t2 = Rh.name;
  return this.keywords.test(e25) && (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + e25), t2 = Nh[e25]), this.finishToken(t2, e25);
};
od.acorn = { Parser: od, version: "6.4.0", defaultOptions: Zh, Position: Qh, SourceLocation: Xh, getLineInfo: Yh, Node: Sd, TokenType: Ih, tokTypes: Rh, keywordTypes: Nh, TokContext: Fd, tokContexts: Ad, isIdentifierChar: Ph, isIdentifierStart: Th, Token: Jd, isNewLine: Uh, lineBreak: Mh, lineBreakG: Vh, nonASCIIwhitespace: qh };
var Zd = n(Object.freeze({ __proto__: null, Node: Sd, Parser: od, Position: Qh, SourceLocation: Xh, TokContext: Fd, Token: Jd, TokenType: Ih, defaultOptions: Zh, getLineInfo: Yh, isIdentifierChar: Ph, isIdentifierStart: Th, isNewLine: Uh, keywordTypes: Nh, lineBreak: Mh, lineBreakG: Vh, nonASCIIwhitespace: qh, parse: function(e25, t2) {
  return od.parse(e25, t2);
}, parseExpressionAt: function(e25, t2, r2) {
  return od.parseExpressionAt(e25, t2, r2);
}, tokContexts: Ad, tokTypes: Rh, tokenizer: function(e25, t2) {
  return od.tokenizer(e25, t2);
}, version: "6.4.0" })), em = r(function(e25) {
  var t2 = /^[\da-fA-F]+$/, r2 = /^\d+$/, n2 = new WeakMap();
  function i2(e26) {
    e26 = e26.Parser.acorn || e26;
    var t3 = n2.get(e26);
    if (!t3) {
      var r3 = e26.tokTypes, i3 = e26.TokContext, a2 = e26.TokenType, o3 = new i3("<tag", false), s2 = new i3("</tag", false), u2 = new i3("<tag>...</tag>", true, true), c2 = { tc_oTag: o3, tc_cTag: s2, tc_expr: u2 }, l2 = { jsxName: new a2("jsxName"), jsxText: new a2("jsxText", { beforeExpr: true }), jsxTagStart: new a2("jsxTagStart"), jsxTagEnd: new a2("jsxTagEnd") };
      l2.jsxTagStart.updateContext = function() {
        this.context.push(u2), this.context.push(o3), this.exprAllowed = false;
      }, l2.jsxTagEnd.updateContext = function(e27) {
        var t4 = this.context.pop();
        t4 === o3 && e27 === r3.slash || t4 === s2 ? (this.context.pop(), this.exprAllowed = this.curContext() === u2) : this.exprAllowed = true;
      }, t3 = { tokContexts: c2, tokTypes: l2 }, n2.set(e26, t3);
    }
    return t3;
  }
  function o2(e26) {
    return e26 ? e26.type === "JSXIdentifier" ? e26.name : e26.type === "JSXNamespacedName" ? e26.namespace.name + ":" + e26.name.name : e26.type === "JSXMemberExpression" ? o2(e26.object) + "." + o2(e26.property) : void 0 : e26;
  }
  e25.exports = function(e26) {
    return e26 = e26 || {}, function(n3) {
      return function(e27, n4) {
        var u2 = n4.acorn || Zd, c2 = i2(u2), l2 = u2.tokTypes, p2 = c2.tokTypes, d2 = u2.tokContexts, m2 = c2.tokContexts.tc_oTag, g2 = c2.tokContexts.tc_cTag, y2 = c2.tokContexts.tc_expr, b2 = u2.isNewLine, E2 = u2.isIdentifierStart, C2 = u2.isIdentifierChar;
        return function(n5) {
          function i3() {
            return a(this, i3), v(this, h(i3).apply(this, arguments));
          }
          return f(i3, n5), s(i3, [{ key: "jsx_readToken", value: function() {
            for (var e28 = "", t3 = this.pos; ; ) {
              this.pos >= this.input.length && this.raise(this.start, "Unterminated JSX contents");
              var r3 = this.input.charCodeAt(this.pos);
              switch (r3) {
                case 60:
                case 123:
                  return this.pos === this.start ? r3 === 60 && this.exprAllowed ? (++this.pos, this.finishToken(p2.jsxTagStart)) : this.getTokenFromCode(r3) : (e28 += this.input.slice(t3, this.pos), this.finishToken(p2.jsxText, e28));
                case 38:
                  e28 += this.input.slice(t3, this.pos), e28 += this.jsx_readEntity(), t3 = this.pos;
                  break;
                default:
                  b2(r3) ? (e28 += this.input.slice(t3, this.pos), e28 += this.jsx_readNewLine(true), t3 = this.pos) : ++this.pos;
              }
            }
          } }, { key: "jsx_readNewLine", value: function(e28) {
            var t3, r3 = this.input.charCodeAt(this.pos);
            return ++this.pos, r3 === 13 && this.input.charCodeAt(this.pos) === 10 ? (++this.pos, t3 = e28 ? "\n" : "\r\n") : t3 = String.fromCharCode(r3), this.options.locations && (++this.curLine, this.lineStart = this.pos), t3;
          } }, { key: "jsx_readString", value: function(e28) {
            for (var t3 = "", r3 = ++this.pos; ; ) {
              this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
              var n6 = this.input.charCodeAt(this.pos);
              if (n6 === e28)
                break;
              n6 === 38 ? (t3 += this.input.slice(r3, this.pos), t3 += this.jsx_readEntity(), r3 = this.pos) : b2(n6) ? (t3 += this.input.slice(r3, this.pos), t3 += this.jsx_readNewLine(false), r3 = this.pos) : ++this.pos;
            }
            return t3 += this.input.slice(r3, this.pos++), this.finishToken(l2.string, t3);
          } }, { key: "jsx_readEntity", value: function() {
            var e28, n6 = "", i4 = 0, a2 = this.input[this.pos];
            a2 !== "&" && this.raise(this.pos, "Entity must start with an ampersand");
            for (var o3 = ++this.pos; this.pos < this.input.length && i4++ < 10; ) {
              if ((a2 = this.input[this.pos++]) === ";") {
                n6[0] === "#" ? n6[1] === "x" ? (n6 = n6.substr(2), t2.test(n6) && (e28 = String.fromCharCode(parseInt(n6, 16)))) : (n6 = n6.substr(1), r2.test(n6) && (e28 = String.fromCharCode(parseInt(n6, 10)))) : e28 = vh[n6];
                break;
              }
              n6 += a2;
            }
            return e28 || (this.pos = o3, "&");
          } }, { key: "jsx_readWord", value: function() {
            var e28, t3 = this.pos;
            do {
              e28 = this.input.charCodeAt(++this.pos);
            } while (C2(e28) || e28 === 45);
            return this.finishToken(p2.jsxName, this.input.slice(t3, this.pos));
          } }, { key: "jsx_parseIdentifier", value: function() {
            var e28 = this.startNode();
            return this.type === p2.jsxName ? e28.name = this.value : this.type.keyword ? e28.name = this.type.keyword : this.unexpected(), this.next(), this.finishNode(e28, "JSXIdentifier");
          } }, { key: "jsx_parseNamespacedName", value: function() {
            var t3 = this.start, r3 = this.startLoc, n6 = this.jsx_parseIdentifier();
            if (!e27.allowNamespaces || !this.eat(l2.colon))
              return n6;
            var i4 = this.startNodeAt(t3, r3);
            return i4.namespace = n6, i4.name = this.jsx_parseIdentifier(), this.finishNode(i4, "JSXNamespacedName");
          } }, { key: "jsx_parseElementName", value: function() {
            if (this.type === p2.jsxTagEnd)
              return "";
            var t3 = this.start, r3 = this.startLoc, n6 = this.jsx_parseNamespacedName();
            for (this.type !== l2.dot || n6.type !== "JSXNamespacedName" || e27.allowNamespacedObjects || this.unexpected(); this.eat(l2.dot); ) {
              var i4 = this.startNodeAt(t3, r3);
              i4.object = n6, i4.property = this.jsx_parseIdentifier(), n6 = this.finishNode(i4, "JSXMemberExpression");
            }
            return n6;
          } }, { key: "jsx_parseAttributeValue", value: function() {
            switch (this.type) {
              case l2.braceL:
                var e28 = this.jsx_parseExpressionContainer();
                return e28.expression.type === "JSXEmptyExpression" && this.raise(e28.start, "JSX attributes must only be assigned a non-empty expression"), e28;
              case p2.jsxTagStart:
              case l2.string:
                return this.parseExprAtom();
              default:
                this.raise(this.start, "JSX value should be either an expression or a quoted JSX text");
            }
          } }, { key: "jsx_parseEmptyExpression", value: function() {
            var e28 = this.startNodeAt(this.lastTokEnd, this.lastTokEndLoc);
            return this.finishNodeAt(e28, "JSXEmptyExpression", this.start, this.startLoc);
          } }, { key: "jsx_parseExpressionContainer", value: function() {
            var e28 = this.startNode();
            return this.next(), e28.expression = this.type === l2.braceR ? this.jsx_parseEmptyExpression() : this.parseExpression(), this.expect(l2.braceR), this.finishNode(e28, "JSXExpressionContainer");
          } }, { key: "jsx_parseAttribute", value: function() {
            var e28 = this.startNode();
            return this.eat(l2.braceL) ? (this.expect(l2.ellipsis), e28.argument = this.parseMaybeAssign(), this.expect(l2.braceR), this.finishNode(e28, "JSXSpreadAttribute")) : (e28.name = this.jsx_parseNamespacedName(), e28.value = this.eat(l2.eq) ? this.jsx_parseAttributeValue() : null, this.finishNode(e28, "JSXAttribute"));
          } }, { key: "jsx_parseOpeningElementAt", value: function(e28, t3) {
            var r3 = this.startNodeAt(e28, t3);
            r3.attributes = [];
            var n6 = this.jsx_parseElementName();
            for (n6 && (r3.name = n6); this.type !== l2.slash && this.type !== p2.jsxTagEnd; )
              r3.attributes.push(this.jsx_parseAttribute());
            return r3.selfClosing = this.eat(l2.slash), this.expect(p2.jsxTagEnd), this.finishNode(r3, n6 ? "JSXOpeningElement" : "JSXOpeningFragment");
          } }, { key: "jsx_parseClosingElementAt", value: function(e28, t3) {
            var r3 = this.startNodeAt(e28, t3), n6 = this.jsx_parseElementName();
            return n6 && (r3.name = n6), this.expect(p2.jsxTagEnd), this.finishNode(r3, n6 ? "JSXClosingElement" : "JSXClosingFragment");
          } }, { key: "jsx_parseElementAt", value: function(e28, t3) {
            var r3 = this.startNodeAt(e28, t3), n6 = [], i4 = this.jsx_parseOpeningElementAt(e28, t3), a2 = null;
            if (!i4.selfClosing) {
              e:
                for (; ; )
                  switch (this.type) {
                    case p2.jsxTagStart:
                      if (e28 = this.start, t3 = this.startLoc, this.next(), this.eat(l2.slash)) {
                        a2 = this.jsx_parseClosingElementAt(e28, t3);
                        break e;
                      }
                      n6.push(this.jsx_parseElementAt(e28, t3));
                      break;
                    case p2.jsxText:
                      n6.push(this.parseExprAtom());
                      break;
                    case l2.braceL:
                      n6.push(this.jsx_parseExpressionContainer());
                      break;
                    default:
                      this.unexpected();
                  }
              o2(a2.name) !== o2(i4.name) && this.raise(a2.start, "Expected corresponding JSX closing tag for <" + o2(i4.name) + ">");
            }
            var s2 = i4.name ? "Element" : "Fragment";
            return r3["opening" + s2] = i4, r3["closing" + s2] = a2, r3.children = n6, this.type === l2.relational && this.value === "<" && this.raise(this.start, "Adjacent JSX elements must be wrapped in an enclosing tag"), this.finishNode(r3, "JSX" + s2);
          } }, { key: "jsx_parseText", value: function(e28) {
            var t3 = this.parseLiteral(e28);
            return t3.type = "JSXText", t3;
          } }, { key: "jsx_parseElement", value: function() {
            var e28 = this.start, t3 = this.startLoc;
            return this.next(), this.jsx_parseElementAt(e28, t3);
          } }, { key: "parseExprAtom", value: function(e28) {
            return this.type === p2.jsxText ? this.jsx_parseText(this.value) : this.type === p2.jsxTagStart ? this.jsx_parseElement() : x(h(i3.prototype), "parseExprAtom", this).call(this, e28);
          } }, { key: "readToken", value: function(e28) {
            var t3 = this.curContext();
            if (t3 === y2)
              return this.jsx_readToken();
            if (t3 === m2 || t3 === g2) {
              if (E2(e28))
                return this.jsx_readWord();
              if (e28 == 62)
                return ++this.pos, this.finishToken(p2.jsxTagEnd);
              if ((e28 === 34 || e28 === 39) && t3 == m2)
                return this.jsx_readString(e28);
            }
            return e28 === 60 && this.exprAllowed && this.input.charCodeAt(this.pos + 1) !== 33 ? (++this.pos, this.finishToken(p2.jsxTagStart)) : x(h(i3.prototype), "readToken", this).call(this, e28);
          } }, { key: "updateContext", value: function(e28) {
            if (this.type == l2.braceL) {
              var t3 = this.curContext();
              t3 == m2 ? this.context.push(d2.b_expr) : t3 == y2 ? this.context.push(d2.b_tmpl) : x(h(i3.prototype), "updateContext", this).call(this, e28), this.exprAllowed = true;
            } else {
              if (this.type !== l2.slash || e28 !== p2.jsxTagStart)
                return x(h(i3.prototype), "updateContext", this).call(this, e28);
              this.context.length -= 2, this.context.push(g2), this.exprAllowed = false;
            }
          } }], [{ key: "acornJsx", get: function() {
            return c2;
          } }]), i3;
        }(n4);
      }({ allowNamespaces: e26.allowNamespaces !== false, allowNamespacedObjects: !!e26.allowNamespacedObjects }, n3);
    };
  }, Object.defineProperty(e25.exports, "tokTypes", { get: function() {
    return i2(Zd).tokTypes;
  }, configurable: true, enumerable: true });
}), tm = { AssignmentExpression: "AssignmentExpression", AssignmentPattern: "AssignmentPattern", ArrayExpression: "ArrayExpression", ArrayPattern: "ArrayPattern", ArrowFunctionExpression: "ArrowFunctionExpression", AwaitExpression: "AwaitExpression", BlockStatement: "BlockStatement", BinaryExpression: "BinaryExpression", BreakStatement: "BreakStatement", CallExpression: "CallExpression", CatchClause: "CatchClause", ClassBody: "ClassBody", ClassDeclaration: "ClassDeclaration", ClassExpression: "ClassExpression", ConditionalExpression: "ConditionalExpression", ContinueStatement: "ContinueStatement", DoWhileStatement: "DoWhileStatement", DebuggerStatement: "DebuggerStatement", EmptyStatement: "EmptyStatement", ExpressionStatement: "ExpressionStatement", ForStatement: "ForStatement", ForInStatement: "ForInStatement", ForOfStatement: "ForOfStatement", FunctionDeclaration: "FunctionDeclaration", FunctionExpression: "FunctionExpression", Identifier: "Identifier", IfStatement: "IfStatement", Literal: "Literal", LabeledStatement: "LabeledStatement", LogicalExpression: "LogicalExpression", MemberExpression: "MemberExpression", MetaProperty: "MetaProperty", MethodDefinition: "MethodDefinition", NewExpression: "NewExpression", ObjectExpression: "ObjectExpression", ObjectPattern: "ObjectPattern", Program: "Program", Property: "Property", RestElement: "RestElement", ReturnStatement: "ReturnStatement", SequenceExpression: "SequenceExpression", SpreadElement: "SpreadElement", Super: "Super", SwitchCase: "SwitchCase", SwitchStatement: "SwitchStatement", TaggedTemplateExpression: "TaggedTemplateExpression", TemplateElement: "TemplateElement", TemplateLiteral: "TemplateLiteral", ThisExpression: "ThisExpression", ThrowStatement: "ThrowStatement", TryStatement: "TryStatement", UnaryExpression: "UnaryExpression", UpdateExpression: "UpdateExpression", VariableDeclaration: "VariableDeclaration", VariableDeclarator: "VariableDeclarator", WhileStatement: "WhileStatement", WithStatement: "WithStatement", YieldExpression: "YieldExpression", JSXIdentifier: "JSXIdentifier", JSXNamespacedName: "JSXNamespacedName", JSXMemberExpression: "JSXMemberExpression", JSXEmptyExpression: "JSXEmptyExpression", JSXExpressionContainer: "JSXExpressionContainer", JSXElement: "JSXElement", JSXClosingElement: "JSXClosingElement", JSXOpeningElement: "JSXOpeningElement", JSXAttribute: "JSXAttribute", JSXSpreadAttribute: "JSXSpreadAttribute", JSXText: "JSXText", ExportDefaultDeclaration: "ExportDefaultDeclaration", ExportNamedDeclaration: "ExportNamedDeclaration", ExportAllDeclaration: "ExportAllDeclaration", ExportSpecifier: "ExportSpecifier", ImportDeclaration: "ImportDeclaration", ImportSpecifier: "ImportSpecifier", ImportDefaultSpecifier: "ImportDefaultSpecifier", ImportNamespaceSpecifier: "ImportNamespaceSpecifier" }, rm = { Boolean: "Boolean", EOF: "<end>", Identifier: "Identifier", Keyword: "Keyword", Null: "Null", Numeric: "Numeric", Punctuator: "Punctuator", String: "String", RegularExpression: "RegularExpression", Template: "Template", JSXIdentifier: "JSXIdentifier", JSXText: "JSXText" };
function nm(e25, t2) {
  this._acornTokTypes = e25, this._tokens = [], this._curlyBrace = null, this._code = t2;
}
nm.prototype = { constructor: nm, translate: function(e25, t2) {
  var r2 = e25.type, n2 = this._acornTokTypes;
  if (r2 === n2.name)
    e25.type = rm.Identifier, e25.value === "static" && (e25.type = rm.Keyword), t2.ecmaVersion > 5 && (e25.value === "yield" || e25.value === "let") && (e25.type = rm.Keyword);
  else if (r2 === n2.semi || r2 === n2.comma || r2 === n2.parenL || r2 === n2.parenR || r2 === n2.braceL || r2 === n2.braceR || r2 === n2.dot || r2 === n2.bracketL || r2 === n2.colon || r2 === n2.question || r2 === n2.bracketR || r2 === n2.ellipsis || r2 === n2.arrow || r2 === n2.jsxTagStart || r2 === n2.incDec || r2 === n2.starstar || r2 === n2.jsxTagEnd || r2 === n2.prefix || r2.binop && !r2.keyword || r2.isAssign)
    e25.type = rm.Punctuator, e25.value = this._code.slice(e25.start, e25.end);
  else if (r2 === n2.jsxName)
    e25.type = rm.JSXIdentifier;
  else if (r2.label === "jsxText" || r2 === n2.jsxAttrValueToken)
    e25.type = rm.JSXText;
  else if (r2.keyword)
    r2.keyword === "true" || r2.keyword === "false" ? e25.type = rm.Boolean : r2.keyword === "null" ? e25.type = rm.Null : e25.type = rm.Keyword;
  else if (r2 === n2.num)
    e25.type = rm.Numeric, e25.value = this._code.slice(e25.start, e25.end);
  else if (r2 === n2.string)
    t2.jsxAttrValueToken ? (t2.jsxAttrValueToken = false, e25.type = rm.JSXText) : e25.type = rm.String, e25.value = this._code.slice(e25.start, e25.end);
  else if (r2 === n2.regexp) {
    e25.type = rm.RegularExpression;
    var i2 = e25.value;
    e25.regex = { flags: i2.flags, pattern: i2.pattern }, e25.value = "/".concat(i2.pattern, "/").concat(i2.flags);
  }
  return e25;
}, onToken: function(e25, t2) {
  var r2 = this, n2 = this._acornTokTypes, i2 = t2.tokens, a2 = this._tokens;
  function o2() {
    i2.push(function(e26, t3) {
      var r3 = e26[0], n3 = e26[e26.length - 1], i3 = { type: rm.Template, value: t3.slice(r3.start, n3.end) };
      return r3.loc && (i3.loc = { start: r3.loc.start, end: n3.loc.end }), r3.range && (i3.start = r3.range[0], i3.end = n3.range[1], i3.range = [i3.start, i3.end]), i3;
    }(r2._tokens, r2._code)), r2._tokens = [];
  }
  if (e25.type !== n2.eof) {
    if (e25.type === n2.backQuote)
      return this._curlyBrace && (i2.push(this.translate(this._curlyBrace, t2)), this._curlyBrace = null), a2.push(e25), void (a2.length > 1 && o2());
    if (e25.type === n2.dollarBraceL)
      return a2.push(e25), void o2();
    if (e25.type === n2.braceR)
      return this._curlyBrace && i2.push(this.translate(this._curlyBrace, t2)), void (this._curlyBrace = e25);
    if (e25.type === n2.template || e25.type === n2.invalidTemplate)
      return this._curlyBrace && (a2.push(this._curlyBrace), this._curlyBrace = null), void a2.push(e25);
    this._curlyBrace && (i2.push(this.translate(this._curlyBrace, t2)), this._curlyBrace = null), i2.push(this.translate(e25, t2));
  } else
    this._curlyBrace && i2.push(this.translate(this._curlyBrace, t2));
} };
var im = nm, am = 5, om = Symbol("espree's internal state"), sm = Symbol("espree's esprimaFinishNode");
function um(e25) {
  var t2 = function() {
    var e26 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : am;
    if (typeof e26 != "number")
      throw new Error("ecmaVersion must be a number. Received value of type ".concat(i(e26), " instead."));
    var t3 = e26;
    switch (t3 >= 2015 && (t3 -= 2009), t3) {
      case 3:
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
        return t3;
    }
    throw new Error("Invalid ecmaVersion.");
  }(e25.ecmaVersion), r2 = function() {
    var e26 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "script";
    if (e26 === "script" || e26 === "module")
      return e26;
    throw new Error("Invalid sourceType.");
  }(e25.sourceType), n2 = e25.range === true, a2 = e25.loc === true;
  if (r2 === "module" && t2 < 6)
    throw new Error("sourceType 'module' is not supported when ecmaVersion < 2015. Consider adding `{ ecmaVersion: 2015 }` to the parser options.");
  return Object.assign({}, e25, { ecmaVersion: t2, sourceType: r2, ranges: n2, locations: a2 });
}
var cm = function() {
  return function(e25) {
    var t2 = Object.assign({}, e25.acorn.tokTypes);
    return e25.acornJsx && Object.assign(t2, e25.acornJsx.tokTypes), function(r2) {
      function n2(e26, r3) {
        var o2;
        a(this, n2), i(e26) === "object" && e26 !== null || (e26 = {}), typeof r3 == "string" || r3 instanceof String || (r3 = String(r3));
        var s2 = um(e26), u2 = s2.ecmaFeatures || {}, c2 = s2.tokens === true ? new im(t2, r3) : null;
        return (o2 = v(this, h(n2).call(this, { ecmaVersion: s2.ecmaVersion, sourceType: s2.sourceType, ranges: s2.ranges, locations: s2.locations, allowReturnOutsideFunction: Boolean(u2.globalReturn), onToken: function(e27) {
          c2 && c2.onToken(e27, o2[om]), e27.type !== t2.eof && (o2[om].lastToken = e27);
        }, onComment: function(e27, t3, r4, n3, a2, s3) {
          if (o2[om].comments) {
            var u3 = function(e28, t4, r5, n4, a3, o3) {
              var s4 = { type: e28 ? "Block" : "Line", value: t4 };
              return typeof r5 == "number" && (s4.start = r5, s4.end = n4, s4.range = [r5, n4]), i(a3) === "object" && (s4.loc = { start: a3, end: o3 }), s4;
            }(e27, t3, r4, n3, a2, s3);
            o2[om].comments.push(u3);
          }
        } }, r3)))[om] = { tokens: c2 ? [] : null, comments: s2.comment === true ? [] : null, impliedStrict: u2.impliedStrict === true && o2.options.ecmaVersion >= 5, ecmaVersion: o2.options.ecmaVersion, jsxAttrValueToken: false, lastToken: null }, o2;
      }
      return f(n2, r2), s(n2, [{ key: "tokenize", value: function() {
        do {
          this.next();
        } while (this.type !== t2.eof);
        this.next();
        var e26 = this[om], r3 = e26.tokens;
        return e26.comments && (r3.comments = e26.comments), r3;
      } }, { key: "finishNode", value: function() {
        for (var e26, t3 = arguments.length, r3 = new Array(t3), i2 = 0; i2 < t3; i2++)
          r3[i2] = arguments[i2];
        var a2 = (e26 = x(h(n2.prototype), "finishNode", this)).call.apply(e26, [this].concat(r3));
        return this[sm](a2);
      } }, { key: "finishNodeAt", value: function() {
        for (var e26, t3 = arguments.length, r3 = new Array(t3), i2 = 0; i2 < t3; i2++)
          r3[i2] = arguments[i2];
        var a2 = (e26 = x(h(n2.prototype), "finishNodeAt", this)).call.apply(e26, [this].concat(r3));
        return this[sm](a2);
      } }, { key: "parse", value: function() {
        var e26 = this[om], t3 = x(h(n2.prototype), "parse", this).call(this);
        return t3.sourceType = this.options.sourceType, e26.comments && (t3.comments = e26.comments), e26.tokens && (t3.tokens = e26.tokens), t3.range && (t3.range[0] = t3.body.length ? t3.body[0].range[0] : t3.range[0], t3.range[1] = e26.lastToken ? e26.lastToken.range[1] : t3.range[1]), t3.loc && (t3.loc.start = t3.body.length ? t3.body[0].loc.start : t3.loc.start, t3.loc.end = e26.lastToken ? e26.lastToken.loc.end : t3.loc.end), t3;
      } }, { key: "parseTopLevel", value: function(e26) {
        return this[om].impliedStrict && (this.strict = true), x(h(n2.prototype), "parseTopLevel", this).call(this, e26);
      } }, { key: "raise", value: function(t3, r3) {
        var n3 = e25.acorn.getLineInfo(this.input, t3), i2 = new SyntaxError(r3);
        throw i2.index = t3, i2.lineNumber = n3.line, i2.column = n3.column + 1, i2;
      } }, { key: "raiseRecoverable", value: function(e26, t3) {
        this.raise(e26, t3);
      } }, { key: "unexpected", value: function(e26) {
        var t3 = "Unexpected token";
        if (e26 != null) {
          if (this.pos = e26, this.options.locations)
            for (; this.pos < this.lineStart; )
              this.lineStart = this.input.lastIndexOf("\n", this.lineStart - 2) + 1, --this.curLine;
          this.nextToken();
        }
        this.end > this.start && (t3 += " ".concat(this.input.slice(this.start, this.end))), this.raise(this.start, t3);
      } }, { key: "jsx_readString", value: function(e26) {
        var r3 = x(h(n2.prototype), "jsx_readString", this).call(this, e26);
        return this.type === t2.string && (this[om].jsxAttrValueToken = true), r3;
      } }, { key: sm, value: function(e26) {
        if (e26.type === "TemplateElement") {
          var t3 = this.input.slice(e26.end, e26.end + 2) === "${";
          e26.range && (e26.range[0]--, e26.range[1] += t3 ? 2 : 1), e26.loc && (e26.loc.start.column--, e26.loc.end.column += t3 ? 2 : 1);
        }
        return e26.type.indexOf("Function") > -1 && !e26.generator && (e26.generator = false), e26;
      } }]), n2;
    }(e25);
  };
}, lm = "An Esprima-compatible JavaScript parser built on Acorn", pm = "Nicholas C. Zakas <nicholas+npm@nczconsulting.com>", fm = "https://github.com/eslint/espree", hm = ["lib", "espree.js"], dm = { node: ">=6.0.0" }, mm = { url: "http://github.com/eslint/espree.git" }, gm = { acorn: "^7.1.0", "acorn-jsx": "^5.1.0", "eslint-visitor-keys": "^1.1.0" }, ym = { browserify: "^16.5.0", chai: "^4.2.0", eslint: "^6.0.1", "eslint-config-eslint": "^5.0.1", "eslint-plugin-node": "^9.1.0", "eslint-release": "^1.0.0", esprima: "latest", "esprima-fb": "^8001.2001.0-dev-harmony-fb", "json-diff": "^0.5.4", leche: "^2.3.0", mocha: "^6.2.0", nyc: "^14.1.1", regenerate: "^1.4.0", shelljs: "^0.3.0", "shelljs-nodecli": "^0.1.1", "unicode-6.3.0": "^0.7.5" }, vm = ["ast", "ecmascript", "javascript", "parser", "syntax", "acorn"], xm = { "generate-regex": "node tools/generate-identifier-regex.js", test: "npm run-script lint && node Makefile.js test", lint: "node Makefile.js lint", browserify: "node Makefile.js browserify", "generate-release": "eslint-generate-release", "generate-alpharelease": "eslint-generate-prerelease alpha", "generate-betarelease": "eslint-generate-prerelease beta", "generate-rcrelease": "eslint-generate-prerelease rc", "publish-release": "eslint-publish-release" }, bm = { name: "espree", description: lm, author: pm, homepage: fm, main: "espree.js", version: "6.1.2", files: hm, engines: dm, repository: "eslint/espree", bugs: mm, license: "BSD-2-Clause", dependencies: gm, devDependencies: ym, keywords: vm, scripts: xm }, Em = Object.freeze({ __proto__: null, name: "espree", description: lm, author: pm, homepage: fm, main: "espree.js", version: "6.1.2", files: hm, engines: dm, repository: "eslint/espree", bugs: mm, license: "BSD-2-Clause", dependencies: gm, devDependencies: ym, keywords: vm, scripts: xm, default: bm }), Cm = n(yh), Sm = n(Em), km = { _regular: null, _jsx: null, get regular() {
  return this._regular === null && (this._regular = Cm.Parser.extend(cm())), this._regular;
}, get jsx() {
  return this._jsx === null && (this._jsx = Cm.Parser.extend(em(), cm())), this._jsx;
}, get: function(e25) {
  return Boolean(e25 && e25.ecmaFeatures && e25.ecmaFeatures.jsx) ? this.jsx : this.regular;
} };
var Dm = { version: Sm.version, tokenize: function(e25, t2) {
  var r2 = km.get(t2);
  return t2 && t2.tokens === true || (t2 = Object.assign({}, t2, { tokens: true })), new r2(t2, e25).tokenize();
}, parse: function(e25, t2) {
  return new (km.get(t2))(t2, e25).parse();
}, Syntax: function() {
  var e25, t2 = {};
  for (e25 in typeof Object.create == "function" && (t2 = Object.create(null)), tm)
    Object.hasOwnProperty.call(tm, e25) && (t2[e25] = tm[e25]);
  return typeof Object.freeze == "function" && Object.freeze(t2), t2;
}(), VisitorKeys: Lp.KEYS }, Fm = r(function(t2, r2) {
  (function() {
    var n2, a2 = 200, o2 = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s2 = "Expected a function", u2 = "__lodash_hash_undefined__", c2 = 500, l2 = "__lodash_placeholder__", p2 = 1, f2 = 2, h2 = 4, d2 = 1, m2 = 2, g2 = 1, y2 = 2, v2 = 4, x2 = 8, b2 = 16, E2 = 32, C2 = 64, S2 = 128, k2 = 256, D2 = 512, F2 = 30, A2 = "...", w2 = 800, _2 = 16, T2 = 1, P2 = 2, I2 = 1 / 0, B2 = 9007199254740991, O2 = 17976931348623157e292, L2 = NaN, N2 = 4294967295, j2 = N2 - 1, R2 = N2 >>> 1, M2 = [["ary", S2], ["bind", g2], ["bindKey", y2], ["curry", x2], ["curryRight", b2], ["flip", D2], ["partial", E2], ["partialRight", C2], ["rearg", k2]], V2 = "[object Arguments]", U2 = "[object Array]", q2 = "[object AsyncFunction]", W2 = "[object Boolean]", $2 = "[object Date]", G2 = "[object DOMException]", z2 = "[object Error]", H2 = "[object Function]", K2 = "[object GeneratorFunction]", J2 = "[object Map]", Q2 = "[object Number]", X2 = "[object Null]", Y2 = "[object Object]", Z2 = "[object Proxy]", ee2 = "[object RegExp]", te2 = "[object Set]", re2 = "[object String]", ne2 = "[object Symbol]", ie2 = "[object Undefined]", ae2 = "[object WeakMap]", oe2 = "[object WeakSet]", se2 = "[object ArrayBuffer]", ue2 = "[object DataView]", ce2 = "[object Float32Array]", le2 = "[object Float64Array]", pe2 = "[object Int8Array]", fe2 = "[object Int16Array]", he2 = "[object Int32Array]", de2 = "[object Uint8Array]", me2 = "[object Uint8ClampedArray]", ge2 = "[object Uint16Array]", ye2 = "[object Uint32Array]", ve2 = /\b__p \+= '';/g, xe2 = /\b(__p \+=) '' \+/g, be2 = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ee2 = /&(?:amp|lt|gt|quot|#39);/g, Ce2 = /[&<>"']/g, Se2 = RegExp(Ee2.source), ke2 = RegExp(Ce2.source), De2 = /<%-([\s\S]+?)%>/g, Fe2 = /<%([\s\S]+?)%>/g, Ae2 = /<%=([\s\S]+?)%>/g, we2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, _e2 = /^\w*$/, Te2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Pe2 = /[\\^$.*+?()[\]{}|]/g, Ie2 = RegExp(Pe2.source), Be2 = /^\s+|\s+$/g, Oe2 = /^\s+/, Le2 = /\s+$/, Ne2 = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, je2 = /\{\n\/\* \[wrapped with (.+)\] \*/, Re2 = /,? & /, Me2 = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ve2 = /\\(\\)?/g, Ue2 = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, qe2 = /\w*$/, We2 = /^[-+]0x[0-9a-f]+$/i, $e2 = /^0b[01]+$/i, Ge2 = /^\[object .+?Constructor\]$/, ze2 = /^0o[0-7]+$/i, He2 = /^(?:0|[1-9]\d*)$/, Ke2 = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Je2 = /($^)/, Qe2 = /['\n\r\u2028\u2029\\]/g, Xe2 = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", Ye2 = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Ze2 = "[\\ud800-\\udfff]", et2 = "[" + Ye2 + "]", tt2 = "[" + Xe2 + "]", rt2 = "\\d+", nt2 = "[\\u2700-\\u27bf]", it2 = "[a-z\\xdf-\\xf6\\xf8-\\xff]", at2 = "[^\\ud800-\\udfff" + Ye2 + rt2 + "\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde]", ot2 = "\\ud83c[\\udffb-\\udfff]", st2 = "[^\\ud800-\\udfff]", ut2 = "(?:\\ud83c[\\udde6-\\uddff]){2}", ct2 = "[\\ud800-\\udbff][\\udc00-\\udfff]", lt2 = "[A-Z\\xc0-\\xd6\\xd8-\\xde]", pt2 = "(?:" + it2 + "|" + at2 + ")", ft2 = "(?:" + lt2 + "|" + at2 + ")", ht2 = "(?:" + tt2 + "|" + ot2 + ")?", dt2 = "[\\ufe0e\\ufe0f]?" + ht2 + ("(?:\\u200d(?:" + [st2, ut2, ct2].join("|") + ")[\\ufe0e\\ufe0f]?" + ht2 + ")*"), mt2 = "(?:" + [nt2, ut2, ct2].join("|") + ")" + dt2, gt2 = "(?:" + [st2 + tt2 + "?", tt2, ut2, ct2, Ze2].join("|") + ")", yt2 = RegExp("['\u2019]", "g"), vt = RegExp(tt2, "g"), xt = RegExp(ot2 + "(?=" + ot2 + ")|" + gt2 + dt2, "g"), bt = RegExp([lt2 + "?" + it2 + "+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=" + [et2, lt2, "$"].join("|") + ")", ft2 + "+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=" + [et2, lt2 + pt2, "$"].join("|") + ")", lt2 + "?" + pt2 + "+(?:['\u2019](?:d|ll|m|re|s|t|ve))?", lt2 + "+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?", "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rt2, mt2].join("|"), "g"), Et = RegExp("[\\u200d\\ud800-\\udfff" + Xe2 + "\\ufe0e\\ufe0f]"), Ct2 = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, St2 = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], kt2 = -1, Dt2 = {};
    Dt2[ce2] = Dt2[le2] = Dt2[pe2] = Dt2[fe2] = Dt2[he2] = Dt2[de2] = Dt2[me2] = Dt2[ge2] = Dt2[ye2] = true, Dt2[V2] = Dt2[U2] = Dt2[se2] = Dt2[W2] = Dt2[ue2] = Dt2[$2] = Dt2[z2] = Dt2[H2] = Dt2[J2] = Dt2[Q2] = Dt2[Y2] = Dt2[ee2] = Dt2[te2] = Dt2[re2] = Dt2[ae2] = false;
    var Ft2 = {};
    Ft2[V2] = Ft2[U2] = Ft2[se2] = Ft2[ue2] = Ft2[W2] = Ft2[$2] = Ft2[ce2] = Ft2[le2] = Ft2[pe2] = Ft2[fe2] = Ft2[he2] = Ft2[J2] = Ft2[Q2] = Ft2[Y2] = Ft2[ee2] = Ft2[te2] = Ft2[re2] = Ft2[ne2] = Ft2[de2] = Ft2[me2] = Ft2[ge2] = Ft2[ye2] = true, Ft2[z2] = Ft2[H2] = Ft2[ae2] = false;
    var At2 = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, wt2 = parseFloat, _t2 = parseInt, Tt2 = i(e) == "object" && e && e.Object === Object && e, Pt2 = (typeof self == "undefined" ? "undefined" : i(self)) == "object" && self && self.Object === Object && self, It2 = Tt2 || Pt2 || Function("return this")(), Bt2 = r2 && !r2.nodeType && r2, Ot2 = Bt2 && t2 && !t2.nodeType && t2, Lt2 = Ot2 && Ot2.exports === Bt2, Nt2 = Lt2 && Tt2.process, jt2 = function() {
      try {
        var e25 = Ot2 && Ot2.require && Ot2.require("util").types;
        return e25 || Nt2 && Nt2.binding && Nt2.binding("util");
      } catch (e26) {
      }
    }(), Rt2 = jt2 && jt2.isArrayBuffer, Mt2 = jt2 && jt2.isDate, Vt2 = jt2 && jt2.isMap, Ut2 = jt2 && jt2.isRegExp, qt2 = jt2 && jt2.isSet, Wt2 = jt2 && jt2.isTypedArray;
    function $t2(e25, t3, r3) {
      switch (r3.length) {
        case 0:
          return e25.call(t3);
        case 1:
          return e25.call(t3, r3[0]);
        case 2:
          return e25.call(t3, r3[0], r3[1]);
        case 3:
          return e25.call(t3, r3[0], r3[1], r3[2]);
      }
      return e25.apply(t3, r3);
    }
    function Gt2(e25, t3, r3, n3) {
      for (var i2 = -1, a3 = e25 == null ? 0 : e25.length; ++i2 < a3; ) {
        var o3 = e25[i2];
        t3(n3, o3, r3(o3), e25);
      }
      return n3;
    }
    function zt2(e25, t3) {
      for (var r3 = -1, n3 = e25 == null ? 0 : e25.length; ++r3 < n3 && t3(e25[r3], r3, e25) !== false; )
        ;
      return e25;
    }
    function Ht2(e25, t3) {
      for (var r3 = e25 == null ? 0 : e25.length; r3-- && t3(e25[r3], r3, e25) !== false; )
        ;
      return e25;
    }
    function Kt2(e25, t3) {
      for (var r3 = -1, n3 = e25 == null ? 0 : e25.length; ++r3 < n3; )
        if (!t3(e25[r3], r3, e25))
          return false;
      return true;
    }
    function Jt2(e25, t3) {
      for (var r3 = -1, n3 = e25 == null ? 0 : e25.length, i2 = 0, a3 = []; ++r3 < n3; ) {
        var o3 = e25[r3];
        t3(o3, r3, e25) && (a3[i2++] = o3);
      }
      return a3;
    }
    function Qt2(e25, t3) {
      return !!(e25 == null ? 0 : e25.length) && or2(e25, t3, 0) > -1;
    }
    function Xt2(e25, t3, r3) {
      for (var n3 = -1, i2 = e25 == null ? 0 : e25.length; ++n3 < i2; )
        if (r3(t3, e25[n3]))
          return true;
      return false;
    }
    function Yt2(e25, t3) {
      for (var r3 = -1, n3 = e25 == null ? 0 : e25.length, i2 = Array(n3); ++r3 < n3; )
        i2[r3] = t3(e25[r3], r3, e25);
      return i2;
    }
    function Zt2(e25, t3) {
      for (var r3 = -1, n3 = t3.length, i2 = e25.length; ++r3 < n3; )
        e25[i2 + r3] = t3[r3];
      return e25;
    }
    function er2(e25, t3, r3, n3) {
      var i2 = -1, a3 = e25 == null ? 0 : e25.length;
      for (n3 && a3 && (r3 = e25[++i2]); ++i2 < a3; )
        r3 = t3(r3, e25[i2], i2, e25);
      return r3;
    }
    function tr2(e25, t3, r3, n3) {
      var i2 = e25 == null ? 0 : e25.length;
      for (n3 && i2 && (r3 = e25[--i2]); i2--; )
        r3 = t3(r3, e25[i2], i2, e25);
      return r3;
    }
    function rr2(e25, t3) {
      for (var r3 = -1, n3 = e25 == null ? 0 : e25.length; ++r3 < n3; )
        if (t3(e25[r3], r3, e25))
          return true;
      return false;
    }
    var nr2 = lr2("length");
    function ir2(e25, t3, r3) {
      var n3;
      return r3(e25, function(e26, r4, i2) {
        if (t3(e26, r4, i2))
          return n3 = r4, false;
      }), n3;
    }
    function ar2(e25, t3, r3, n3) {
      for (var i2 = e25.length, a3 = r3 + (n3 ? 1 : -1); n3 ? a3-- : ++a3 < i2; )
        if (t3(e25[a3], a3, e25))
          return a3;
      return -1;
    }
    function or2(e25, t3, r3) {
      return t3 == t3 ? function(e26, t4, r4) {
        var n3 = r4 - 1, i2 = e26.length;
        for (; ++n3 < i2; )
          if (e26[n3] === t4)
            return n3;
        return -1;
      }(e25, t3, r3) : ar2(e25, ur2, r3);
    }
    function sr2(e25, t3, r3, n3) {
      for (var i2 = r3 - 1, a3 = e25.length; ++i2 < a3; )
        if (n3(e25[i2], t3))
          return i2;
      return -1;
    }
    function ur2(e25) {
      return e25 != e25;
    }
    function cr2(e25, t3) {
      var r3 = e25 == null ? 0 : e25.length;
      return r3 ? hr2(e25, t3) / r3 : L2;
    }
    function lr2(e25) {
      return function(t3) {
        return t3 == null ? n2 : t3[e25];
      };
    }
    function pr2(e25) {
      return function(t3) {
        return e25 == null ? n2 : e25[t3];
      };
    }
    function fr2(e25, t3, r3, n3, i2) {
      return i2(e25, function(e26, i3, a3) {
        r3 = n3 ? (n3 = false, e26) : t3(r3, e26, i3, a3);
      }), r3;
    }
    function hr2(e25, t3) {
      for (var r3, i2 = -1, a3 = e25.length; ++i2 < a3; ) {
        var o3 = t3(e25[i2]);
        o3 !== n2 && (r3 = r3 === n2 ? o3 : r3 + o3);
      }
      return r3;
    }
    function dr2(e25, t3) {
      for (var r3 = -1, n3 = Array(e25); ++r3 < e25; )
        n3[r3] = t3(r3);
      return n3;
    }
    function mr2(e25) {
      return function(t3) {
        return e25(t3);
      };
    }
    function gr2(e25, t3) {
      return Yt2(t3, function(t4) {
        return e25[t4];
      });
    }
    function yr2(e25, t3) {
      return e25.has(t3);
    }
    function vr2(e25, t3) {
      for (var r3 = -1, n3 = e25.length; ++r3 < n3 && or2(t3, e25[r3], 0) > -1; )
        ;
      return r3;
    }
    function xr2(e25, t3) {
      for (var r3 = e25.length; r3-- && or2(t3, e25[r3], 0) > -1; )
        ;
      return r3;
    }
    var br2 = pr2({ "\xC0": "A", "\xC1": "A", "\xC2": "A", "\xC3": "A", "\xC4": "A", "\xC5": "A", "\xE0": "a", "\xE1": "a", "\xE2": "a", "\xE3": "a", "\xE4": "a", "\xE5": "a", "\xC7": "C", "\xE7": "c", "\xD0": "D", "\xF0": "d", "\xC8": "E", "\xC9": "E", "\xCA": "E", "\xCB": "E", "\xE8": "e", "\xE9": "e", "\xEA": "e", "\xEB": "e", "\xCC": "I", "\xCD": "I", "\xCE": "I", "\xCF": "I", "\xEC": "i", "\xED": "i", "\xEE": "i", "\xEF": "i", "\xD1": "N", "\xF1": "n", "\xD2": "O", "\xD3": "O", "\xD4": "O", "\xD5": "O", "\xD6": "O", "\xD8": "O", "\xF2": "o", "\xF3": "o", "\xF4": "o", "\xF5": "o", "\xF6": "o", "\xF8": "o", "\xD9": "U", "\xDA": "U", "\xDB": "U", "\xDC": "U", "\xF9": "u", "\xFA": "u", "\xFB": "u", "\xFC": "u", "\xDD": "Y", "\xFD": "y", "\xFF": "y", "\xC6": "Ae", "\xE6": "ae", "\xDE": "Th", "\xFE": "th", "\xDF": "ss", "\u0100": "A", "\u0102": "A", "\u0104": "A", "\u0101": "a", "\u0103": "a", "\u0105": "a", "\u0106": "C", "\u0108": "C", "\u010A": "C", "\u010C": "C", "\u0107": "c", "\u0109": "c", "\u010B": "c", "\u010D": "c", "\u010E": "D", "\u0110": "D", "\u010F": "d", "\u0111": "d", "\u0112": "E", "\u0114": "E", "\u0116": "E", "\u0118": "E", "\u011A": "E", "\u0113": "e", "\u0115": "e", "\u0117": "e", "\u0119": "e", "\u011B": "e", "\u011C": "G", "\u011E": "G", "\u0120": "G", "\u0122": "G", "\u011D": "g", "\u011F": "g", "\u0121": "g", "\u0123": "g", "\u0124": "H", "\u0126": "H", "\u0125": "h", "\u0127": "h", "\u0128": "I", "\u012A": "I", "\u012C": "I", "\u012E": "I", "\u0130": "I", "\u0129": "i", "\u012B": "i", "\u012D": "i", "\u012F": "i", "\u0131": "i", "\u0134": "J", "\u0135": "j", "\u0136": "K", "\u0137": "k", "\u0138": "k", "\u0139": "L", "\u013B": "L", "\u013D": "L", "\u013F": "L", "\u0141": "L", "\u013A": "l", "\u013C": "l", "\u013E": "l", "\u0140": "l", "\u0142": "l", "\u0143": "N", "\u0145": "N", "\u0147": "N", "\u014A": "N", "\u0144": "n", "\u0146": "n", "\u0148": "n", "\u014B": "n", "\u014C": "O", "\u014E": "O", "\u0150": "O", "\u014D": "o", "\u014F": "o", "\u0151": "o", "\u0154": "R", "\u0156": "R", "\u0158": "R", "\u0155": "r", "\u0157": "r", "\u0159": "r", "\u015A": "S", "\u015C": "S", "\u015E": "S", "\u0160": "S", "\u015B": "s", "\u015D": "s", "\u015F": "s", "\u0161": "s", "\u0162": "T", "\u0164": "T", "\u0166": "T", "\u0163": "t", "\u0165": "t", "\u0167": "t", "\u0168": "U", "\u016A": "U", "\u016C": "U", "\u016E": "U", "\u0170": "U", "\u0172": "U", "\u0169": "u", "\u016B": "u", "\u016D": "u", "\u016F": "u", "\u0171": "u", "\u0173": "u", "\u0174": "W", "\u0175": "w", "\u0176": "Y", "\u0177": "y", "\u0178": "Y", "\u0179": "Z", "\u017B": "Z", "\u017D": "Z", "\u017A": "z", "\u017C": "z", "\u017E": "z", "\u0132": "IJ", "\u0133": "ij", "\u0152": "Oe", "\u0153": "oe", "\u0149": "'n", "\u017F": "s" }), Er2 = pr2({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" });
    function Cr(e25) {
      return "\\" + At2[e25];
    }
    function Sr(e25) {
      return Et.test(e25);
    }
    function kr(e25) {
      var t3 = -1, r3 = Array(e25.size);
      return e25.forEach(function(e26, n3) {
        r3[++t3] = [n3, e26];
      }), r3;
    }
    function Dr2(e25, t3) {
      return function(r3) {
        return e25(t3(r3));
      };
    }
    function Fr2(e25, t3) {
      for (var r3 = -1, n3 = e25.length, i2 = 0, a3 = []; ++r3 < n3; ) {
        var o3 = e25[r3];
        o3 !== t3 && o3 !== l2 || (e25[r3] = l2, a3[i2++] = r3);
      }
      return a3;
    }
    function Ar2(e25) {
      var t3 = -1, r3 = Array(e25.size);
      return e25.forEach(function(e26) {
        r3[++t3] = e26;
      }), r3;
    }
    function wr2(e25) {
      var t3 = -1, r3 = Array(e25.size);
      return e25.forEach(function(e26) {
        r3[++t3] = [e26, e26];
      }), r3;
    }
    function _r2(e25) {
      return Sr(e25) ? function(e26) {
        var t3 = xt.lastIndex = 0;
        for (; xt.test(e26); )
          ++t3;
        return t3;
      }(e25) : nr2(e25);
    }
    function Tr2(e25) {
      return Sr(e25) ? function(e26) {
        return e26.match(xt) || [];
      }(e25) : function(e26) {
        return e26.split("");
      }(e25);
    }
    var Pr2 = pr2({ "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" });
    var Ir2 = function e25(t3) {
      var r3, Xe3 = (t3 = t3 == null ? It2 : Ir2.defaults(It2.Object(), t3, Ir2.pick(It2, St2))).Array, Ye3 = t3.Date, Ze3 = t3.Error, et3 = t3.Function, tt3 = t3.Math, rt3 = t3.Object, nt3 = t3.RegExp, it3 = t3.String, at3 = t3.TypeError, ot3 = Xe3.prototype, st3 = et3.prototype, ut3 = rt3.prototype, ct3 = t3["__core-js_shared__"], lt3 = st3.toString, pt3 = ut3.hasOwnProperty, ft3 = 0, ht3 = (r3 = /[^.]+$/.exec(ct3 && ct3.keys && ct3.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r3 : "", dt3 = ut3.toString, mt3 = lt3.call(rt3), gt3 = It2._, xt2 = nt3("^" + lt3.call(pt3).replace(Pe2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Et2 = Lt2 ? t3.Buffer : n2, At3 = t3.Symbol, Tt3 = t3.Uint8Array, Pt3 = Et2 ? Et2.allocUnsafe : n2, Bt3 = Dr2(rt3.getPrototypeOf, rt3), Ot3 = rt3.create, Nt3 = ut3.propertyIsEnumerable, jt3 = ot3.splice, nr3 = At3 ? At3.isConcatSpreadable : n2, pr3 = At3 ? At3.iterator : n2, Br2 = At3 ? At3.toStringTag : n2, Or2 = function() {
        try {
          var e26 = Ma2(rt3, "defineProperty");
          return e26({}, "", {}), e26;
        } catch (e27) {
        }
      }(), Lr2 = t3.clearTimeout !== It2.clearTimeout && t3.clearTimeout, Nr2 = Ye3 && Ye3.now !== It2.Date.now && Ye3.now, jr2 = t3.setTimeout !== It2.setTimeout && t3.setTimeout, Rr2 = tt3.ceil, Mr2 = tt3.floor, Vr2 = rt3.getOwnPropertySymbols, Ur2 = Et2 ? Et2.isBuffer : n2, qr2 = t3.isFinite, Wr2 = ot3.join, $r2 = Dr2(rt3.keys, rt3), Gr2 = tt3.max, zr2 = tt3.min, Hr2 = Ye3.now, Kr2 = t3.parseInt, Jr2 = tt3.random, Qr2 = ot3.reverse, Xr2 = Ma2(t3, "DataView"), Yr2 = Ma2(t3, "Map"), Zr2 = Ma2(t3, "Promise"), en2 = Ma2(t3, "Set"), tn2 = Ma2(t3, "WeakMap"), rn2 = Ma2(rt3, "create"), nn2 = tn2 && new tn2(), an2 = {}, on2 = po2(Xr2), sn2 = po2(Yr2), un2 = po2(Zr2), cn2 = po2(en2), ln2 = po2(tn2), pn2 = At3 ? At3.prototype : n2, fn2 = pn2 ? pn2.valueOf : n2, hn2 = pn2 ? pn2.toString : n2;
      function dn2(e26) {
        if (_s2(e26) && !vs(e26) && !(e26 instanceof vn2)) {
          if (e26 instanceof yn2)
            return e26;
          if (pt3.call(e26, "__wrapped__"))
            return fo2(e26);
        }
        return new yn2(e26);
      }
      var mn2 = function() {
        function e26() {
        }
        return function(t4) {
          if (!ws2(t4))
            return {};
          if (Ot3)
            return Ot3(t4);
          e26.prototype = t4;
          var r4 = new e26();
          return e26.prototype = n2, r4;
        };
      }();
      function gn2() {
      }
      function yn2(e26, t4) {
        this.__wrapped__ = e26, this.__actions__ = [], this.__chain__ = !!t4, this.__index__ = 0, this.__values__ = n2;
      }
      function vn2(e26) {
        this.__wrapped__ = e26, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = false, this.__iteratees__ = [], this.__takeCount__ = N2, this.__views__ = [];
      }
      function xn2(e26) {
        var t4 = -1, r4 = e26 == null ? 0 : e26.length;
        for (this.clear(); ++t4 < r4; ) {
          var n3 = e26[t4];
          this.set(n3[0], n3[1]);
        }
      }
      function bn2(e26) {
        var t4 = -1, r4 = e26 == null ? 0 : e26.length;
        for (this.clear(); ++t4 < r4; ) {
          var n3 = e26[t4];
          this.set(n3[0], n3[1]);
        }
      }
      function En2(e26) {
        var t4 = -1, r4 = e26 == null ? 0 : e26.length;
        for (this.clear(); ++t4 < r4; ) {
          var n3 = e26[t4];
          this.set(n3[0], n3[1]);
        }
      }
      function Cn2(e26) {
        var t4 = -1, r4 = e26 == null ? 0 : e26.length;
        for (this.__data__ = new En2(); ++t4 < r4; )
          this.add(e26[t4]);
      }
      function Sn2(e26) {
        var t4 = this.__data__ = new bn2(e26);
        this.size = t4.size;
      }
      function kn2(e26, t4) {
        var r4 = vs(e26), n3 = !r4 && ys(e26), i2 = !r4 && !n3 && Cs2(e26), a3 = !r4 && !n3 && !i2 && js2(e26), o3 = r4 || n3 || i2 || a3, s3 = o3 ? dr2(e26.length, it3) : [], u3 = s3.length;
        for (var c3 in e26)
          !t4 && !pt3.call(e26, c3) || o3 && (c3 == "length" || i2 && (c3 == "offset" || c3 == "parent") || a3 && (c3 == "buffer" || c3 == "byteLength" || c3 == "byteOffset") || za2(c3, u3)) || s3.push(c3);
        return s3;
      }
      function Dn2(e26) {
        var t4 = e26.length;
        return t4 ? e26[Ci2(0, t4 - 1)] : n2;
      }
      function Fn2(e26, t4) {
        return uo2(na2(e26), Ln2(t4, 0, e26.length));
      }
      function An2(e26) {
        return uo2(na2(e26));
      }
      function wn2(e26, t4, r4) {
        (r4 === n2 || ds(e26[t4], r4)) && (r4 !== n2 || t4 in e26) || Bn2(e26, t4, r4);
      }
      function _n2(e26, t4, r4) {
        var i2 = e26[t4];
        pt3.call(e26, t4) && ds(i2, r4) && (r4 !== n2 || t4 in e26) || Bn2(e26, t4, r4);
      }
      function Tn2(e26, t4) {
        for (var r4 = e26.length; r4--; )
          if (ds(e26[r4][0], t4))
            return r4;
        return -1;
      }
      function Pn2(e26, t4, r4, n3) {
        return Vn2(e26, function(e27, i2, a3) {
          t4(n3, e27, r4(e27), a3);
        }), n3;
      }
      function In2(e26, t4) {
        return e26 && ia2(t4, au2(t4), e26);
      }
      function Bn2(e26, t4, r4) {
        t4 == "__proto__" && Or2 ? Or2(e26, t4, { configurable: true, enumerable: true, value: r4, writable: true }) : e26[t4] = r4;
      }
      function On2(e26, t4) {
        for (var r4 = -1, i2 = t4.length, a3 = Xe3(i2), o3 = e26 == null; ++r4 < i2; )
          a3[r4] = o3 ? n2 : eu2(e26, t4[r4]);
        return a3;
      }
      function Ln2(e26, t4, r4) {
        return e26 == e26 && (r4 !== n2 && (e26 = e26 <= r4 ? e26 : r4), t4 !== n2 && (e26 = e26 >= t4 ? e26 : t4)), e26;
      }
      function Nn2(e26, t4, r4, i2, a3, o3) {
        var s3, u3 = t4 & p2, c3 = t4 & f2, l3 = t4 & h2;
        if (r4 && (s3 = a3 ? r4(e26, i2, a3, o3) : r4(e26)), s3 !== n2)
          return s3;
        if (!ws2(e26))
          return e26;
        var d3 = vs(e26);
        if (d3) {
          if (s3 = function(e27) {
            var t5 = e27.length, r5 = new e27.constructor(t5);
            t5 && typeof e27[0] == "string" && pt3.call(e27, "index") && (r5.index = e27.index, r5.input = e27.input);
            return r5;
          }(e26), !u3)
            return na2(e26, s3);
        } else {
          var m3 = qa2(e26), g3 = m3 == H2 || m3 == K2;
          if (Cs2(e26))
            return Xi2(e26, u3);
          if (m3 == Y2 || m3 == V2 || g3 && !a3) {
            if (s3 = c3 || g3 ? {} : $a2(e26), !u3)
              return c3 ? function(e27, t5) {
                return ia2(e27, Ua2(e27), t5);
              }(e26, function(e27, t5) {
                return e27 && ia2(t5, ou2(t5), e27);
              }(s3, e26)) : function(e27, t5) {
                return ia2(e27, Va2(e27), t5);
              }(e26, In2(s3, e26));
          } else {
            if (!Ft2[m3])
              return a3 ? e26 : {};
            s3 = function(e27, t5, r5) {
              var n3 = e27.constructor;
              switch (t5) {
                case se2:
                  return Yi2(e27);
                case W2:
                case $2:
                  return new n3(+e27);
                case ue2:
                  return function(e28, t6) {
                    var r6 = t6 ? Yi2(e28.buffer) : e28.buffer;
                    return new e28.constructor(r6, e28.byteOffset, e28.byteLength);
                  }(e27, r5);
                case ce2:
                case le2:
                case pe2:
                case fe2:
                case he2:
                case de2:
                case me2:
                case ge2:
                case ye2:
                  return Zi2(e27, r5);
                case J2:
                  return new n3();
                case Q2:
                case re2:
                  return new n3(e27);
                case ee2:
                  return function(e28) {
                    var t6 = new e28.constructor(e28.source, qe2.exec(e28));
                    return t6.lastIndex = e28.lastIndex, t6;
                  }(e27);
                case te2:
                  return new n3();
                case ne2:
                  return i3 = e27, fn2 ? rt3(fn2.call(i3)) : {};
              }
              var i3;
            }(e26, m3, u3);
          }
        }
        o3 || (o3 = new Sn2());
        var y3 = o3.get(e26);
        if (y3)
          return y3;
        o3.set(e26, s3), Os2(e26) ? e26.forEach(function(n3) {
          s3.add(Nn2(n3, t4, r4, n3, e26, o3));
        }) : Ts2(e26) && e26.forEach(function(n3, i3) {
          s3.set(i3, Nn2(n3, t4, r4, i3, e26, o3));
        });
        var v3 = d3 ? n2 : (l3 ? c3 ? Ia2 : Pa2 : c3 ? ou2 : au2)(e26);
        return zt2(v3 || e26, function(n3, i3) {
          v3 && (n3 = e26[i3 = n3]), _n2(s3, i3, Nn2(n3, t4, r4, i3, e26, o3));
        }), s3;
      }
      function jn2(e26, t4, r4) {
        var i2 = r4.length;
        if (e26 == null)
          return !i2;
        for (e26 = rt3(e26); i2--; ) {
          var a3 = r4[i2], o3 = t4[a3], s3 = e26[a3];
          if (s3 === n2 && !(a3 in e26) || !o3(s3))
            return false;
        }
        return true;
      }
      function Rn2(e26, t4, r4) {
        if (typeof e26 != "function")
          throw new at3(s2);
        return io2(function() {
          e26.apply(n2, r4);
        }, t4);
      }
      function Mn2(e26, t4, r4, n3) {
        var i2 = -1, o3 = Qt2, s3 = true, u3 = e26.length, c3 = [], l3 = t4.length;
        if (!u3)
          return c3;
        r4 && (t4 = Yt2(t4, mr2(r4))), n3 ? (o3 = Xt2, s3 = false) : t4.length >= a2 && (o3 = yr2, s3 = false, t4 = new Cn2(t4));
        e:
          for (; ++i2 < u3; ) {
            var p3 = e26[i2], f3 = r4 == null ? p3 : r4(p3);
            if (p3 = n3 || p3 !== 0 ? p3 : 0, s3 && f3 == f3) {
              for (var h3 = l3; h3--; )
                if (t4[h3] === f3)
                  continue e;
              c3.push(p3);
            } else
              o3(t4, f3, n3) || c3.push(p3);
          }
        return c3;
      }
      dn2.templateSettings = { escape: De2, evaluate: Fe2, interpolate: Ae2, variable: "", imports: { _: dn2 } }, dn2.prototype = gn2.prototype, dn2.prototype.constructor = dn2, yn2.prototype = mn2(gn2.prototype), yn2.prototype.constructor = yn2, vn2.prototype = mn2(gn2.prototype), vn2.prototype.constructor = vn2, xn2.prototype.clear = function() {
        this.__data__ = rn2 ? rn2(null) : {}, this.size = 0;
      }, xn2.prototype.delete = function(e26) {
        var t4 = this.has(e26) && delete this.__data__[e26];
        return this.size -= t4 ? 1 : 0, t4;
      }, xn2.prototype.get = function(e26) {
        var t4 = this.__data__;
        if (rn2) {
          var r4 = t4[e26];
          return r4 === u2 ? n2 : r4;
        }
        return pt3.call(t4, e26) ? t4[e26] : n2;
      }, xn2.prototype.has = function(e26) {
        var t4 = this.__data__;
        return rn2 ? t4[e26] !== n2 : pt3.call(t4, e26);
      }, xn2.prototype.set = function(e26, t4) {
        var r4 = this.__data__;
        return this.size += this.has(e26) ? 0 : 1, r4[e26] = rn2 && t4 === n2 ? u2 : t4, this;
      }, bn2.prototype.clear = function() {
        this.__data__ = [], this.size = 0;
      }, bn2.prototype.delete = function(e26) {
        var t4 = this.__data__, r4 = Tn2(t4, e26);
        return !(r4 < 0) && (r4 == t4.length - 1 ? t4.pop() : jt3.call(t4, r4, 1), --this.size, true);
      }, bn2.prototype.get = function(e26) {
        var t4 = this.__data__, r4 = Tn2(t4, e26);
        return r4 < 0 ? n2 : t4[r4][1];
      }, bn2.prototype.has = function(e26) {
        return Tn2(this.__data__, e26) > -1;
      }, bn2.prototype.set = function(e26, t4) {
        var r4 = this.__data__, n3 = Tn2(r4, e26);
        return n3 < 0 ? (++this.size, r4.push([e26, t4])) : r4[n3][1] = t4, this;
      }, En2.prototype.clear = function() {
        this.size = 0, this.__data__ = { hash: new xn2(), map: new (Yr2 || bn2)(), string: new xn2() };
      }, En2.prototype.delete = function(e26) {
        var t4 = ja2(this, e26).delete(e26);
        return this.size -= t4 ? 1 : 0, t4;
      }, En2.prototype.get = function(e26) {
        return ja2(this, e26).get(e26);
      }, En2.prototype.has = function(e26) {
        return ja2(this, e26).has(e26);
      }, En2.prototype.set = function(e26, t4) {
        var r4 = ja2(this, e26), n3 = r4.size;
        return r4.set(e26, t4), this.size += r4.size == n3 ? 0 : 1, this;
      }, Cn2.prototype.add = Cn2.prototype.push = function(e26) {
        return this.__data__.set(e26, u2), this;
      }, Cn2.prototype.has = function(e26) {
        return this.__data__.has(e26);
      }, Sn2.prototype.clear = function() {
        this.__data__ = new bn2(), this.size = 0;
      }, Sn2.prototype.delete = function(e26) {
        var t4 = this.__data__, r4 = t4.delete(e26);
        return this.size = t4.size, r4;
      }, Sn2.prototype.get = function(e26) {
        return this.__data__.get(e26);
      }, Sn2.prototype.has = function(e26) {
        return this.__data__.has(e26);
      }, Sn2.prototype.set = function(e26, t4) {
        var r4 = this.__data__;
        if (r4 instanceof bn2) {
          var n3 = r4.__data__;
          if (!Yr2 || n3.length < a2 - 1)
            return n3.push([e26, t4]), this.size = ++r4.size, this;
          r4 = this.__data__ = new En2(n3);
        }
        return r4.set(e26, t4), this.size = r4.size, this;
      };
      var Vn2 = sa2(Kn2), Un2 = sa2(Jn2, true);
      function qn2(e26, t4) {
        var r4 = true;
        return Vn2(e26, function(e27, n3, i2) {
          return r4 = !!t4(e27, n3, i2);
        }), r4;
      }
      function Wn2(e26, t4, r4) {
        for (var i2 = -1, a3 = e26.length; ++i2 < a3; ) {
          var o3 = e26[i2], s3 = t4(o3);
          if (s3 != null && (u3 === n2 ? s3 == s3 && !Ns2(s3) : r4(s3, u3)))
            var u3 = s3, c3 = o3;
        }
        return c3;
      }
      function $n2(e26, t4) {
        var r4 = [];
        return Vn2(e26, function(e27, n3, i2) {
          t4(e27, n3, i2) && r4.push(e27);
        }), r4;
      }
      function Gn2(e26, t4, r4, n3, i2) {
        var a3 = -1, o3 = e26.length;
        for (r4 || (r4 = Ga2), i2 || (i2 = []); ++a3 < o3; ) {
          var s3 = e26[a3];
          t4 > 0 && r4(s3) ? t4 > 1 ? Gn2(s3, t4 - 1, r4, n3, i2) : Zt2(i2, s3) : n3 || (i2[i2.length] = s3);
        }
        return i2;
      }
      var zn = ua2(), Hn2 = ua2(true);
      function Kn2(e26, t4) {
        return e26 && zn(e26, t4, au2);
      }
      function Jn2(e26, t4) {
        return e26 && Hn2(e26, t4, au2);
      }
      function Qn2(e26, t4) {
        return Jt2(t4, function(t5) {
          return Ds2(e26[t5]);
        });
      }
      function Xn2(e26, t4) {
        for (var r4 = 0, i2 = (t4 = Hi2(t4, e26)).length; e26 != null && r4 < i2; )
          e26 = e26[lo2(t4[r4++])];
        return r4 && r4 == i2 ? e26 : n2;
      }
      function Yn2(e26, t4, r4) {
        var n3 = t4(e26);
        return vs(e26) ? n3 : Zt2(n3, r4(e26));
      }
      function Zn2(e26) {
        return e26 == null ? e26 === n2 ? ie2 : X2 : Br2 && Br2 in rt3(e26) ? function(e27) {
          var t4 = pt3.call(e27, Br2), r4 = e27[Br2];
          try {
            e27[Br2] = n2;
            var i2 = true;
          } catch (e28) {
          }
          var a3 = dt3.call(e27);
          i2 && (t4 ? e27[Br2] = r4 : delete e27[Br2]);
          return a3;
        }(e26) : function(e27) {
          return dt3.call(e27);
        }(e26);
      }
      function ei2(e26, t4) {
        return e26 > t4;
      }
      function ti2(e26, t4) {
        return e26 != null && pt3.call(e26, t4);
      }
      function ri2(e26, t4) {
        return e26 != null && t4 in rt3(e26);
      }
      function ni2(e26, t4, r4) {
        for (var i2 = r4 ? Xt2 : Qt2, a3 = e26[0].length, o3 = e26.length, s3 = o3, u3 = Xe3(o3), c3 = 1 / 0, l3 = []; s3--; ) {
          var p3 = e26[s3];
          s3 && t4 && (p3 = Yt2(p3, mr2(t4))), c3 = zr2(p3.length, c3), u3[s3] = !r4 && (t4 || a3 >= 120 && p3.length >= 120) ? new Cn2(s3 && p3) : n2;
        }
        p3 = e26[0];
        var f3 = -1, h3 = u3[0];
        e:
          for (; ++f3 < a3 && l3.length < c3; ) {
            var d3 = p3[f3], m3 = t4 ? t4(d3) : d3;
            if (d3 = r4 || d3 !== 0 ? d3 : 0, !(h3 ? yr2(h3, m3) : i2(l3, m3, r4))) {
              for (s3 = o3; --s3; ) {
                var g3 = u3[s3];
                if (!(g3 ? yr2(g3, m3) : i2(e26[s3], m3, r4)))
                  continue e;
              }
              h3 && h3.push(m3), l3.push(d3);
            }
          }
        return l3;
      }
      function ii2(e26, t4, r4) {
        var i2 = (e26 = to2(e26, t4 = Hi2(t4, e26))) == null ? e26 : e26[lo2(ko(t4))];
        return i2 == null ? n2 : $t2(i2, e26, r4);
      }
      function ai2(e26) {
        return _s2(e26) && Zn2(e26) == V2;
      }
      function oi2(e26, t4, r4, i2, a3) {
        return e26 === t4 || (e26 == null || t4 == null || !_s2(e26) && !_s2(t4) ? e26 != e26 && t4 != t4 : function(e27, t5, r5, i3, a4, o3) {
          var s3 = vs(e27), u3 = vs(t5), c3 = s3 ? U2 : qa2(e27), l3 = u3 ? U2 : qa2(t5), p3 = (c3 = c3 == V2 ? Y2 : c3) == Y2, f3 = (l3 = l3 == V2 ? Y2 : l3) == Y2, h3 = c3 == l3;
          if (h3 && Cs2(e27)) {
            if (!Cs2(t5))
              return false;
            s3 = true, p3 = false;
          }
          if (h3 && !p3)
            return o3 || (o3 = new Sn2()), s3 || js2(e27) ? _a2(e27, t5, r5, i3, a4, o3) : function(e28, t6, r6, n3, i4, a5, o4) {
              switch (r6) {
                case ue2:
                  if (e28.byteLength != t6.byteLength || e28.byteOffset != t6.byteOffset)
                    return false;
                  e28 = e28.buffer, t6 = t6.buffer;
                case se2:
                  return !(e28.byteLength != t6.byteLength || !a5(new Tt3(e28), new Tt3(t6)));
                case W2:
                case $2:
                case Q2:
                  return ds(+e28, +t6);
                case z2:
                  return e28.name == t6.name && e28.message == t6.message;
                case ee2:
                case re2:
                  return e28 == t6 + "";
                case J2:
                  var s4 = kr;
                case te2:
                  var u4 = n3 & d2;
                  if (s4 || (s4 = Ar2), e28.size != t6.size && !u4)
                    return false;
                  var c4 = o4.get(e28);
                  if (c4)
                    return c4 == t6;
                  n3 |= m2, o4.set(e28, t6);
                  var l4 = _a2(s4(e28), s4(t6), n3, i4, a5, o4);
                  return o4.delete(e28), l4;
                case ne2:
                  if (fn2)
                    return fn2.call(e28) == fn2.call(t6);
              }
              return false;
            }(e27, t5, c3, r5, i3, a4, o3);
          if (!(r5 & d2)) {
            var g3 = p3 && pt3.call(e27, "__wrapped__"), y3 = f3 && pt3.call(t5, "__wrapped__");
            if (g3 || y3) {
              var v3 = g3 ? e27.value() : e27, x3 = y3 ? t5.value() : t5;
              return o3 || (o3 = new Sn2()), a4(v3, x3, r5, i3, o3);
            }
          }
          if (!h3)
            return false;
          return o3 || (o3 = new Sn2()), function(e28, t6, r6, i4, a5, o4) {
            var s4 = r6 & d2, u4 = Pa2(e28), c4 = u4.length, l4 = Pa2(t6).length;
            if (c4 != l4 && !s4)
              return false;
            var p4 = c4;
            for (; p4--; ) {
              var f4 = u4[p4];
              if (!(s4 ? f4 in t6 : pt3.call(t6, f4)))
                return false;
            }
            var h4 = o4.get(e28);
            if (h4 && o4.get(t6))
              return h4 == t6;
            var m3 = true;
            o4.set(e28, t6), o4.set(t6, e28);
            var g4 = s4;
            for (; ++p4 < c4; ) {
              f4 = u4[p4];
              var y4 = e28[f4], v4 = t6[f4];
              if (i4)
                var x4 = s4 ? i4(v4, y4, f4, t6, e28, o4) : i4(y4, v4, f4, e28, t6, o4);
              if (!(x4 === n2 ? y4 === v4 || a5(y4, v4, r6, i4, o4) : x4)) {
                m3 = false;
                break;
              }
              g4 || (g4 = f4 == "constructor");
            }
            if (m3 && !g4) {
              var b3 = e28.constructor, E3 = t6.constructor;
              b3 != E3 && "constructor" in e28 && "constructor" in t6 && !(typeof b3 == "function" && b3 instanceof b3 && typeof E3 == "function" && E3 instanceof E3) && (m3 = false);
            }
            return o4.delete(e28), o4.delete(t6), m3;
          }(e27, t5, r5, i3, a4, o3);
        }(e26, t4, r4, i2, oi2, a3));
      }
      function si2(e26, t4, r4, i2) {
        var a3 = r4.length, o3 = a3, s3 = !i2;
        if (e26 == null)
          return !o3;
        for (e26 = rt3(e26); a3--; ) {
          var u3 = r4[a3];
          if (s3 && u3[2] ? u3[1] !== e26[u3[0]] : !(u3[0] in e26))
            return false;
        }
        for (; ++a3 < o3; ) {
          var c3 = (u3 = r4[a3])[0], l3 = e26[c3], p3 = u3[1];
          if (s3 && u3[2]) {
            if (l3 === n2 && !(c3 in e26))
              return false;
          } else {
            var f3 = new Sn2();
            if (i2)
              var h3 = i2(l3, p3, c3, e26, t4, f3);
            if (!(h3 === n2 ? oi2(p3, l3, d2 | m2, i2, f3) : h3))
              return false;
          }
        }
        return true;
      }
      function ui2(e26) {
        return !(!ws2(e26) || (t4 = e26, ht3 && ht3 in t4)) && (Ds2(e26) ? xt2 : Ge2).test(po2(e26));
        var t4;
      }
      function ci2(e26) {
        return typeof e26 == "function" ? e26 : e26 == null ? Pu2 : i(e26) == "object" ? vs(e26) ? mi2(e26[0], e26[1]) : di2(e26) : Vu2(e26);
      }
      function li2(e26) {
        if (!Xa2(e26))
          return $r2(e26);
        var t4 = [];
        for (var r4 in rt3(e26))
          pt3.call(e26, r4) && r4 != "constructor" && t4.push(r4);
        return t4;
      }
      function pi2(e26) {
        if (!ws2(e26))
          return function(e27) {
            var t5 = [];
            if (e27 != null)
              for (var r5 in rt3(e27))
                t5.push(r5);
            return t5;
          }(e26);
        var t4 = Xa2(e26), r4 = [];
        for (var n3 in e26)
          (n3 != "constructor" || !t4 && pt3.call(e26, n3)) && r4.push(n3);
        return r4;
      }
      function fi2(e26, t4) {
        return e26 < t4;
      }
      function hi2(e26, t4) {
        var r4 = -1, n3 = bs2(e26) ? Xe3(e26.length) : [];
        return Vn2(e26, function(e27, i2, a3) {
          n3[++r4] = t4(e27, i2, a3);
        }), n3;
      }
      function di2(e26) {
        var t4 = Ra2(e26);
        return t4.length == 1 && t4[0][2] ? Za2(t4[0][0], t4[0][1]) : function(r4) {
          return r4 === e26 || si2(r4, e26, t4);
        };
      }
      function mi2(e26, t4) {
        return Ka2(e26) && Ya2(t4) ? Za2(lo2(e26), t4) : function(r4) {
          var i2 = eu2(r4, e26);
          return i2 === n2 && i2 === t4 ? tu2(r4, e26) : oi2(t4, i2, d2 | m2);
        };
      }
      function gi2(e26, t4, r4, i2, a3) {
        e26 !== t4 && zn(t4, function(o3, s3) {
          if (a3 || (a3 = new Sn2()), ws2(o3))
            !function(e27, t5, r5, i3, a4, o4, s4) {
              var u4 = ro2(e27, r5), c3 = ro2(t5, r5), l3 = s4.get(c3);
              if (l3)
                return void wn2(e27, r5, l3);
              var p3 = o4 ? o4(u4, c3, r5 + "", e27, t5, s4) : n2, f3 = p3 === n2;
              if (f3) {
                var h3 = vs(c3), d3 = !h3 && Cs2(c3), m3 = !h3 && !d3 && js2(c3);
                p3 = c3, h3 || d3 || m3 ? vs(u4) ? p3 = u4 : Es2(u4) ? p3 = na2(u4) : d3 ? (f3 = false, p3 = Xi2(c3, true)) : m3 ? (f3 = false, p3 = Zi2(c3, true)) : p3 = [] : Is2(c3) || ys(c3) ? (p3 = u4, ys(u4) ? p3 = Gs2(u4) : ws2(u4) && !Ds2(u4) || (p3 = $a2(c3))) : f3 = false;
              }
              f3 && (s4.set(c3, p3), a4(p3, c3, i3, o4, s4), s4.delete(c3));
              wn2(e27, r5, p3);
            }(e26, t4, s3, r4, gi2, i2, a3);
          else {
            var u3 = i2 ? i2(ro2(e26, s3), o3, s3 + "", e26, t4, a3) : n2;
            u3 === n2 && (u3 = o3), wn2(e26, s3, u3);
          }
        }, ou2);
      }
      function yi2(e26, t4) {
        var r4 = e26.length;
        if (r4)
          return za2(t4 += t4 < 0 ? r4 : 0, r4) ? e26[t4] : n2;
      }
      function vi2(e26, t4, r4) {
        var n3 = -1;
        return t4 = Yt2(t4.length ? t4 : [Pu2], mr2(Na2())), function(e27, t5) {
          var r5 = e27.length;
          for (e27.sort(t5); r5--; )
            e27[r5] = e27[r5].value;
          return e27;
        }(hi2(e26, function(e27, r5, i2) {
          return { criteria: Yt2(t4, function(t5) {
            return t5(e27);
          }), index: ++n3, value: e27 };
        }), function(e27, t5) {
          return function(e28, t6, r5) {
            var n4 = -1, i2 = e28.criteria, a3 = t6.criteria, o3 = i2.length, s3 = r5.length;
            for (; ++n4 < o3; ) {
              var u3 = ea2(i2[n4], a3[n4]);
              if (u3) {
                if (n4 >= s3)
                  return u3;
                var c3 = r5[n4];
                return u3 * (c3 == "desc" ? -1 : 1);
              }
            }
            return e28.index - t6.index;
          }(e27, t5, r4);
        });
      }
      function xi2(e26, t4, r4) {
        for (var n3 = -1, i2 = t4.length, a3 = {}; ++n3 < i2; ) {
          var o3 = t4[n3], s3 = Xn2(e26, o3);
          r4(s3, o3) && Ai2(a3, Hi2(o3, e26), s3);
        }
        return a3;
      }
      function bi2(e26, t4, r4, n3) {
        var i2 = n3 ? sr2 : or2, a3 = -1, o3 = t4.length, s3 = e26;
        for (e26 === t4 && (t4 = na2(t4)), r4 && (s3 = Yt2(e26, mr2(r4))); ++a3 < o3; )
          for (var u3 = 0, c3 = t4[a3], l3 = r4 ? r4(c3) : c3; (u3 = i2(s3, l3, u3, n3)) > -1; )
            s3 !== e26 && jt3.call(s3, u3, 1), jt3.call(e26, u3, 1);
        return e26;
      }
      function Ei2(e26, t4) {
        for (var r4 = e26 ? t4.length : 0, n3 = r4 - 1; r4--; ) {
          var i2 = t4[r4];
          if (r4 == n3 || i2 !== a3) {
            var a3 = i2;
            za2(i2) ? jt3.call(e26, i2, 1) : Mi2(e26, i2);
          }
        }
        return e26;
      }
      function Ci2(e26, t4) {
        return e26 + Mr2(Jr2() * (t4 - e26 + 1));
      }
      function Si2(e26, t4) {
        var r4 = "";
        if (!e26 || t4 < 1 || t4 > B2)
          return r4;
        do {
          t4 % 2 && (r4 += e26), (t4 = Mr2(t4 / 2)) && (e26 += e26);
        } while (t4);
        return r4;
      }
      function ki2(e26, t4) {
        return ao2(eo2(e26, t4, Pu2), e26 + "");
      }
      function Di2(e26) {
        return Dn2(du2(e26));
      }
      function Fi2(e26, t4) {
        var r4 = du2(e26);
        return uo2(r4, Ln2(t4, 0, r4.length));
      }
      function Ai2(e26, t4, r4, i2) {
        if (!ws2(e26))
          return e26;
        for (var a3 = -1, o3 = (t4 = Hi2(t4, e26)).length, s3 = o3 - 1, u3 = e26; u3 != null && ++a3 < o3; ) {
          var c3 = lo2(t4[a3]), l3 = r4;
          if (a3 != s3) {
            var p3 = u3[c3];
            (l3 = i2 ? i2(p3, c3, u3) : n2) === n2 && (l3 = ws2(p3) ? p3 : za2(t4[a3 + 1]) ? [] : {});
          }
          _n2(u3, c3, l3), u3 = u3[c3];
        }
        return e26;
      }
      var wi2 = nn2 ? function(e26, t4) {
        return nn2.set(e26, t4), e26;
      } : Pu2, _i2 = Or2 ? function(e26, t4) {
        return Or2(e26, "toString", { configurable: true, enumerable: false, value: wu2(t4), writable: true });
      } : Pu2;
      function Ti2(e26) {
        return uo2(du2(e26));
      }
      function Pi2(e26, t4, r4) {
        var n3 = -1, i2 = e26.length;
        t4 < 0 && (t4 = -t4 > i2 ? 0 : i2 + t4), (r4 = r4 > i2 ? i2 : r4) < 0 && (r4 += i2), i2 = t4 > r4 ? 0 : r4 - t4 >>> 0, t4 >>>= 0;
        for (var a3 = Xe3(i2); ++n3 < i2; )
          a3[n3] = e26[n3 + t4];
        return a3;
      }
      function Ii2(e26, t4) {
        var r4;
        return Vn2(e26, function(e27, n3, i2) {
          return !(r4 = t4(e27, n3, i2));
        }), !!r4;
      }
      function Bi2(e26, t4, r4) {
        var n3 = 0, i2 = e26 == null ? n3 : e26.length;
        if (typeof t4 == "number" && t4 == t4 && i2 <= R2) {
          for (; n3 < i2; ) {
            var a3 = n3 + i2 >>> 1, o3 = e26[a3];
            o3 !== null && !Ns2(o3) && (r4 ? o3 <= t4 : o3 < t4) ? n3 = a3 + 1 : i2 = a3;
          }
          return i2;
        }
        return Oi2(e26, t4, Pu2, r4);
      }
      function Oi2(e26, t4, r4, i2) {
        t4 = r4(t4);
        for (var a3 = 0, o3 = e26 == null ? 0 : e26.length, s3 = t4 != t4, u3 = t4 === null, c3 = Ns2(t4), l3 = t4 === n2; a3 < o3; ) {
          var p3 = Mr2((a3 + o3) / 2), f3 = r4(e26[p3]), h3 = f3 !== n2, d3 = f3 === null, m3 = f3 == f3, g3 = Ns2(f3);
          if (s3)
            var y3 = i2 || m3;
          else
            y3 = l3 ? m3 && (i2 || h3) : u3 ? m3 && h3 && (i2 || !d3) : c3 ? m3 && h3 && !d3 && (i2 || !g3) : !d3 && !g3 && (i2 ? f3 <= t4 : f3 < t4);
          y3 ? a3 = p3 + 1 : o3 = p3;
        }
        return zr2(o3, j2);
      }
      function Li2(e26, t4) {
        for (var r4 = -1, n3 = e26.length, i2 = 0, a3 = []; ++r4 < n3; ) {
          var o3 = e26[r4], s3 = t4 ? t4(o3) : o3;
          if (!r4 || !ds(s3, u3)) {
            var u3 = s3;
            a3[i2++] = o3 === 0 ? 0 : o3;
          }
        }
        return a3;
      }
      function Ni(e26) {
        return typeof e26 == "number" ? e26 : Ns2(e26) ? L2 : +e26;
      }
      function ji(e26) {
        if (typeof e26 == "string")
          return e26;
        if (vs(e26))
          return Yt2(e26, ji) + "";
        if (Ns2(e26))
          return hn2 ? hn2.call(e26) : "";
        var t4 = e26 + "";
        return t4 == "0" && 1 / e26 == -I2 ? "-0" : t4;
      }
      function Ri(e26, t4, r4) {
        var n3 = -1, i2 = Qt2, o3 = e26.length, s3 = true, u3 = [], c3 = u3;
        if (r4)
          s3 = false, i2 = Xt2;
        else if (o3 >= a2) {
          var l3 = t4 ? null : Sa2(e26);
          if (l3)
            return Ar2(l3);
          s3 = false, i2 = yr2, c3 = new Cn2();
        } else
          c3 = t4 ? [] : u3;
        e:
          for (; ++n3 < o3; ) {
            var p3 = e26[n3], f3 = t4 ? t4(p3) : p3;
            if (p3 = r4 || p3 !== 0 ? p3 : 0, s3 && f3 == f3) {
              for (var h3 = c3.length; h3--; )
                if (c3[h3] === f3)
                  continue e;
              t4 && c3.push(f3), u3.push(p3);
            } else
              i2(c3, f3, r4) || (c3 !== u3 && c3.push(f3), u3.push(p3));
          }
        return u3;
      }
      function Mi2(e26, t4) {
        return (e26 = to2(e26, t4 = Hi2(t4, e26))) == null || delete e26[lo2(ko(t4))];
      }
      function Vi2(e26, t4, r4, n3) {
        return Ai2(e26, t4, r4(Xn2(e26, t4)), n3);
      }
      function Ui2(e26, t4, r4, n3) {
        for (var i2 = e26.length, a3 = n3 ? i2 : -1; (n3 ? a3-- : ++a3 < i2) && t4(e26[a3], a3, e26); )
          ;
        return r4 ? Pi2(e26, n3 ? 0 : a3, n3 ? a3 + 1 : i2) : Pi2(e26, n3 ? a3 + 1 : 0, n3 ? i2 : a3);
      }
      function qi2(e26, t4) {
        var r4 = e26;
        return r4 instanceof vn2 && (r4 = r4.value()), er2(t4, function(e27, t5) {
          return t5.func.apply(t5.thisArg, Zt2([e27], t5.args));
        }, r4);
      }
      function Wi2(e26, t4, r4) {
        var n3 = e26.length;
        if (n3 < 2)
          return n3 ? Ri(e26[0]) : [];
        for (var i2 = -1, a3 = Xe3(n3); ++i2 < n3; )
          for (var o3 = e26[i2], s3 = -1; ++s3 < n3; )
            s3 != i2 && (a3[i2] = Mn2(a3[i2] || o3, e26[s3], t4, r4));
        return Ri(Gn2(a3, 1), t4, r4);
      }
      function $i2(e26, t4, r4) {
        for (var i2 = -1, a3 = e26.length, o3 = t4.length, s3 = {}; ++i2 < a3; ) {
          var u3 = i2 < o3 ? t4[i2] : n2;
          r4(s3, e26[i2], u3);
        }
        return s3;
      }
      function Gi2(e26) {
        return Es2(e26) ? e26 : [];
      }
      function zi2(e26) {
        return typeof e26 == "function" ? e26 : Pu2;
      }
      function Hi2(e26, t4) {
        return vs(e26) ? e26 : Ka2(e26, t4) ? [e26] : co2(zs2(e26));
      }
      var Ki2 = ki2;
      function Ji2(e26, t4, r4) {
        var i2 = e26.length;
        return r4 = r4 === n2 ? i2 : r4, !t4 && r4 >= i2 ? e26 : Pi2(e26, t4, r4);
      }
      var Qi2 = Lr2 || function(e26) {
        return It2.clearTimeout(e26);
      };
      function Xi2(e26, t4) {
        if (t4)
          return e26.slice();
        var r4 = e26.length, n3 = Pt3 ? Pt3(r4) : new e26.constructor(r4);
        return e26.copy(n3), n3;
      }
      function Yi2(e26) {
        var t4 = new e26.constructor(e26.byteLength);
        return new Tt3(t4).set(new Tt3(e26)), t4;
      }
      function Zi2(e26, t4) {
        var r4 = t4 ? Yi2(e26.buffer) : e26.buffer;
        return new e26.constructor(r4, e26.byteOffset, e26.length);
      }
      function ea2(e26, t4) {
        if (e26 !== t4) {
          var r4 = e26 !== n2, i2 = e26 === null, a3 = e26 == e26, o3 = Ns2(e26), s3 = t4 !== n2, u3 = t4 === null, c3 = t4 == t4, l3 = Ns2(t4);
          if (!u3 && !l3 && !o3 && e26 > t4 || o3 && s3 && c3 && !u3 && !l3 || i2 && s3 && c3 || !r4 && c3 || !a3)
            return 1;
          if (!i2 && !o3 && !l3 && e26 < t4 || l3 && r4 && a3 && !i2 && !o3 || u3 && r4 && a3 || !s3 && a3 || !c3)
            return -1;
        }
        return 0;
      }
      function ta2(e26, t4, r4, n3) {
        for (var i2 = -1, a3 = e26.length, o3 = r4.length, s3 = -1, u3 = t4.length, c3 = Gr2(a3 - o3, 0), l3 = Xe3(u3 + c3), p3 = !n3; ++s3 < u3; )
          l3[s3] = t4[s3];
        for (; ++i2 < o3; )
          (p3 || i2 < a3) && (l3[r4[i2]] = e26[i2]);
        for (; c3--; )
          l3[s3++] = e26[i2++];
        return l3;
      }
      function ra2(e26, t4, r4, n3) {
        for (var i2 = -1, a3 = e26.length, o3 = -1, s3 = r4.length, u3 = -1, c3 = t4.length, l3 = Gr2(a3 - s3, 0), p3 = Xe3(l3 + c3), f3 = !n3; ++i2 < l3; )
          p3[i2] = e26[i2];
        for (var h3 = i2; ++u3 < c3; )
          p3[h3 + u3] = t4[u3];
        for (; ++o3 < s3; )
          (f3 || i2 < a3) && (p3[h3 + r4[o3]] = e26[i2++]);
        return p3;
      }
      function na2(e26, t4) {
        var r4 = -1, n3 = e26.length;
        for (t4 || (t4 = Xe3(n3)); ++r4 < n3; )
          t4[r4] = e26[r4];
        return t4;
      }
      function ia2(e26, t4, r4, i2) {
        var a3 = !r4;
        r4 || (r4 = {});
        for (var o3 = -1, s3 = t4.length; ++o3 < s3; ) {
          var u3 = t4[o3], c3 = i2 ? i2(r4[u3], e26[u3], u3, r4, e26) : n2;
          c3 === n2 && (c3 = e26[u3]), a3 ? Bn2(r4, u3, c3) : _n2(r4, u3, c3);
        }
        return r4;
      }
      function aa2(e26, t4) {
        return function(r4, n3) {
          var i2 = vs(r4) ? Gt2 : Pn2, a3 = t4 ? t4() : {};
          return i2(r4, e26, Na2(n3, 2), a3);
        };
      }
      function oa2(e26) {
        return ki2(function(t4, r4) {
          var i2 = -1, a3 = r4.length, o3 = a3 > 1 ? r4[a3 - 1] : n2, s3 = a3 > 2 ? r4[2] : n2;
          for (o3 = e26.length > 3 && typeof o3 == "function" ? (a3--, o3) : n2, s3 && Ha2(r4[0], r4[1], s3) && (o3 = a3 < 3 ? n2 : o3, a3 = 1), t4 = rt3(t4); ++i2 < a3; ) {
            var u3 = r4[i2];
            u3 && e26(t4, u3, i2, o3);
          }
          return t4;
        });
      }
      function sa2(e26, t4) {
        return function(r4, n3) {
          if (r4 == null)
            return r4;
          if (!bs2(r4))
            return e26(r4, n3);
          for (var i2 = r4.length, a3 = t4 ? i2 : -1, o3 = rt3(r4); (t4 ? a3-- : ++a3 < i2) && n3(o3[a3], a3, o3) !== false; )
            ;
          return r4;
        };
      }
      function ua2(e26) {
        return function(t4, r4, n3) {
          for (var i2 = -1, a3 = rt3(t4), o3 = n3(t4), s3 = o3.length; s3--; ) {
            var u3 = o3[e26 ? s3 : ++i2];
            if (r4(a3[u3], u3, a3) === false)
              break;
          }
          return t4;
        };
      }
      function ca2(e26) {
        return function(t4) {
          var r4 = Sr(t4 = zs2(t4)) ? Tr2(t4) : n2, i2 = r4 ? r4[0] : t4.charAt(0), a3 = r4 ? Ji2(r4, 1).join("") : t4.slice(1);
          return i2[e26]() + a3;
        };
      }
      function la2(e26) {
        return function(t4) {
          return er2(Du2(yu2(t4).replace(yt2, "")), e26, "");
        };
      }
      function pa2(e26) {
        return function() {
          var t4 = arguments;
          switch (t4.length) {
            case 0:
              return new e26();
            case 1:
              return new e26(t4[0]);
            case 2:
              return new e26(t4[0], t4[1]);
            case 3:
              return new e26(t4[0], t4[1], t4[2]);
            case 4:
              return new e26(t4[0], t4[1], t4[2], t4[3]);
            case 5:
              return new e26(t4[0], t4[1], t4[2], t4[3], t4[4]);
            case 6:
              return new e26(t4[0], t4[1], t4[2], t4[3], t4[4], t4[5]);
            case 7:
              return new e26(t4[0], t4[1], t4[2], t4[3], t4[4], t4[5], t4[6]);
          }
          var r4 = mn2(e26.prototype), n3 = e26.apply(r4, t4);
          return ws2(n3) ? n3 : r4;
        };
      }
      function fa2(e26) {
        return function(t4, r4, i2) {
          var a3 = rt3(t4);
          if (!bs2(t4)) {
            var o3 = Na2(r4, 3);
            t4 = au2(t4), r4 = function(e27) {
              return o3(a3[e27], e27, a3);
            };
          }
          var s3 = e26(t4, r4, i2);
          return s3 > -1 ? a3[o3 ? t4[s3] : s3] : n2;
        };
      }
      function ha2(e26) {
        return Ta2(function(t4) {
          var r4 = t4.length, i2 = r4, a3 = yn2.prototype.thru;
          for (e26 && t4.reverse(); i2--; ) {
            var o3 = t4[i2];
            if (typeof o3 != "function")
              throw new at3(s2);
            if (a3 && !u3 && Oa2(o3) == "wrapper")
              var u3 = new yn2([], true);
          }
          for (i2 = u3 ? i2 : r4; ++i2 < r4; ) {
            var c3 = Oa2(o3 = t4[i2]), l3 = c3 == "wrapper" ? Ba2(o3) : n2;
            u3 = l3 && Ja2(l3[0]) && l3[1] == (S2 | x2 | E2 | k2) && !l3[4].length && l3[9] == 1 ? u3[Oa2(l3[0])].apply(u3, l3[3]) : o3.length == 1 && Ja2(o3) ? u3[c3]() : u3.thru(o3);
          }
          return function() {
            var e27 = arguments, n3 = e27[0];
            if (u3 && e27.length == 1 && vs(n3))
              return u3.plant(n3).value();
            for (var i3 = 0, a4 = r4 ? t4[i3].apply(this, e27) : n3; ++i3 < r4; )
              a4 = t4[i3].call(this, a4);
            return a4;
          };
        });
      }
      function da2(e26, t4, r4, i2, a3, o3, s3, u3, c3, l3) {
        var p3 = t4 & S2, f3 = t4 & g2, h3 = t4 & y2, d3 = t4 & (x2 | b2), m3 = t4 & D2, v3 = h3 ? n2 : pa2(e26);
        return function g3() {
          for (var y3 = arguments.length, x3 = Xe3(y3), b3 = y3; b3--; )
            x3[b3] = arguments[b3];
          if (d3)
            var E3 = La2(g3), C3 = function(e27, t5) {
              for (var r5 = e27.length, n3 = 0; r5--; )
                e27[r5] === t5 && ++n3;
              return n3;
            }(x3, E3);
          if (i2 && (x3 = ta2(x3, i2, a3, d3)), o3 && (x3 = ra2(x3, o3, s3, d3)), y3 -= C3, d3 && y3 < l3) {
            var S3 = Fr2(x3, E3);
            return Ea2(e26, t4, da2, g3.placeholder, r4, x3, S3, u3, c3, l3 - y3);
          }
          var k3 = f3 ? r4 : this, D3 = h3 ? k3[e26] : e26;
          return y3 = x3.length, u3 ? x3 = function(e27, t5) {
            var r5 = e27.length, i3 = zr2(t5.length, r5), a4 = na2(e27);
            for (; i3--; ) {
              var o4 = t5[i3];
              e27[i3] = za2(o4, r5) ? a4[o4] : n2;
            }
            return e27;
          }(x3, u3) : m3 && y3 > 1 && x3.reverse(), p3 && c3 < y3 && (x3.length = c3), this && this !== It2 && this instanceof g3 && (D3 = v3 || pa2(D3)), D3.apply(k3, x3);
        };
      }
      function ma2(e26, t4) {
        return function(r4, n3) {
          return function(e27, t5, r5, n4) {
            return Kn2(e27, function(e28, i2, a3) {
              t5(n4, r5(e28), i2, a3);
            }), n4;
          }(r4, e26, t4(n3), {});
        };
      }
      function ga2(e26, t4) {
        return function(r4, i2) {
          var a3;
          if (r4 === n2 && i2 === n2)
            return t4;
          if (r4 !== n2 && (a3 = r4), i2 !== n2) {
            if (a3 === n2)
              return i2;
            typeof r4 == "string" || typeof i2 == "string" ? (r4 = ji(r4), i2 = ji(i2)) : (r4 = Ni(r4), i2 = Ni(i2)), a3 = e26(r4, i2);
          }
          return a3;
        };
      }
      function ya2(e26) {
        return Ta2(function(t4) {
          return t4 = Yt2(t4, mr2(Na2())), ki2(function(r4) {
            var n3 = this;
            return e26(t4, function(e27) {
              return $t2(e27, n3, r4);
            });
          });
        });
      }
      function va2(e26, t4) {
        var r4 = (t4 = t4 === n2 ? " " : ji(t4)).length;
        if (r4 < 2)
          return r4 ? Si2(t4, e26) : t4;
        var i2 = Si2(t4, Rr2(e26 / _r2(t4)));
        return Sr(t4) ? Ji2(Tr2(i2), 0, e26).join("") : i2.slice(0, e26);
      }
      function xa2(e26) {
        return function(t4, r4, i2) {
          return i2 && typeof i2 != "number" && Ha2(t4, r4, i2) && (r4 = i2 = n2), t4 = Us2(t4), r4 === n2 ? (r4 = t4, t4 = 0) : r4 = Us2(r4), function(e27, t5, r5, n3) {
            for (var i3 = -1, a3 = Gr2(Rr2((t5 - e27) / (r5 || 1)), 0), o3 = Xe3(a3); a3--; )
              o3[n3 ? a3 : ++i3] = e27, e27 += r5;
            return o3;
          }(t4, r4, i2 = i2 === n2 ? t4 < r4 ? 1 : -1 : Us2(i2), e26);
        };
      }
      function ba2(e26) {
        return function(t4, r4) {
          return typeof t4 == "string" && typeof r4 == "string" || (t4 = $s2(t4), r4 = $s2(r4)), e26(t4, r4);
        };
      }
      function Ea2(e26, t4, r4, i2, a3, o3, s3, u3, c3, l3) {
        var p3 = t4 & x2;
        t4 |= p3 ? E2 : C2, (t4 &= ~(p3 ? C2 : E2)) & v2 || (t4 &= ~(g2 | y2));
        var f3 = [e26, t4, a3, p3 ? o3 : n2, p3 ? s3 : n2, p3 ? n2 : o3, p3 ? n2 : s3, u3, c3, l3], h3 = r4.apply(n2, f3);
        return Ja2(e26) && no2(h3, f3), h3.placeholder = i2, oo2(h3, e26, t4);
      }
      function Ca2(e26) {
        var t4 = tt3[e26];
        return function(e27, r4) {
          if (e27 = $s2(e27), (r4 = r4 == null ? 0 : zr2(qs2(r4), 292)) && qr2(e27)) {
            var n3 = (zs2(e27) + "e").split("e");
            return +((n3 = (zs2(t4(n3[0] + "e" + (+n3[1] + r4))) + "e").split("e"))[0] + "e" + (+n3[1] - r4));
          }
          return t4(e27);
        };
      }
      var Sa2 = en2 && 1 / Ar2(new en2([, -0]))[1] == I2 ? function(e26) {
        return new en2(e26);
      } : Nu2;
      function ka2(e26) {
        return function(t4) {
          var r4 = qa2(t4);
          return r4 == J2 ? kr(t4) : r4 == te2 ? wr2(t4) : function(e27, t5) {
            return Yt2(t5, function(t6) {
              return [t6, e27[t6]];
            });
          }(t4, e26(t4));
        };
      }
      function Da2(e26, t4, r4, i2, a3, o3, u3, c3) {
        var p3 = t4 & y2;
        if (!p3 && typeof e26 != "function")
          throw new at3(s2);
        var f3 = i2 ? i2.length : 0;
        if (f3 || (t4 &= ~(E2 | C2), i2 = a3 = n2), u3 = u3 === n2 ? u3 : Gr2(qs2(u3), 0), c3 = c3 === n2 ? c3 : qs2(c3), f3 -= a3 ? a3.length : 0, t4 & C2) {
          var h3 = i2, d3 = a3;
          i2 = a3 = n2;
        }
        var m3 = p3 ? n2 : Ba2(e26), D3 = [e26, t4, r4, i2, a3, h3, d3, o3, u3, c3];
        if (m3 && function(e27, t5) {
          var r5 = e27[1], n3 = t5[1], i3 = r5 | n3, a4 = i3 < (g2 | y2 | S2), o4 = n3 == S2 && r5 == x2 || n3 == S2 && r5 == k2 && e27[7].length <= t5[8] || n3 == (S2 | k2) && t5[7].length <= t5[8] && r5 == x2;
          if (!a4 && !o4)
            return e27;
          n3 & g2 && (e27[2] = t5[2], i3 |= r5 & g2 ? 0 : v2);
          var s3 = t5[3];
          if (s3) {
            var u4 = e27[3];
            e27[3] = u4 ? ta2(u4, s3, t5[4]) : s3, e27[4] = u4 ? Fr2(e27[3], l2) : t5[4];
          }
          (s3 = t5[5]) && (u4 = e27[5], e27[5] = u4 ? ra2(u4, s3, t5[6]) : s3, e27[6] = u4 ? Fr2(e27[5], l2) : t5[6]);
          (s3 = t5[7]) && (e27[7] = s3);
          n3 & S2 && (e27[8] = e27[8] == null ? t5[8] : zr2(e27[8], t5[8]));
          e27[9] == null && (e27[9] = t5[9]);
          e27[0] = t5[0], e27[1] = i3;
        }(D3, m3), e26 = D3[0], t4 = D3[1], r4 = D3[2], i2 = D3[3], a3 = D3[4], !(c3 = D3[9] = D3[9] === n2 ? p3 ? 0 : e26.length : Gr2(D3[9] - f3, 0)) && t4 & (x2 | b2) && (t4 &= ~(x2 | b2)), t4 && t4 != g2)
          F3 = t4 == x2 || t4 == b2 ? function(e27, t5, r5) {
            var i3 = pa2(e27);
            return function a4() {
              for (var o4 = arguments.length, s3 = Xe3(o4), u4 = o4, c4 = La2(a4); u4--; )
                s3[u4] = arguments[u4];
              var l3 = o4 < 3 && s3[0] !== c4 && s3[o4 - 1] !== c4 ? [] : Fr2(s3, c4);
              return (o4 -= l3.length) < r5 ? Ea2(e27, t5, da2, a4.placeholder, n2, s3, l3, n2, n2, r5 - o4) : $t2(this && this !== It2 && this instanceof a4 ? i3 : e27, this, s3);
            };
          }(e26, t4, c3) : t4 != E2 && t4 != (g2 | E2) || a3.length ? da2.apply(n2, D3) : function(e27, t5, r5, n3) {
            var i3 = t5 & g2, a4 = pa2(e27);
            return function t6() {
              for (var o4 = -1, s3 = arguments.length, u4 = -1, c4 = n3.length, l3 = Xe3(c4 + s3), p4 = this && this !== It2 && this instanceof t6 ? a4 : e27; ++u4 < c4; )
                l3[u4] = n3[u4];
              for (; s3--; )
                l3[u4++] = arguments[++o4];
              return $t2(p4, i3 ? r5 : this, l3);
            };
          }(e26, t4, r4, i2);
        else
          var F3 = function(e27, t5, r5) {
            var n3 = t5 & g2, i3 = pa2(e27);
            return function t6() {
              return (this && this !== It2 && this instanceof t6 ? i3 : e27).apply(n3 ? r5 : this, arguments);
            };
          }(e26, t4, r4);
        return oo2((m3 ? wi2 : no2)(F3, D3), e26, t4);
      }
      function Fa2(e26, t4, r4, i2) {
        return e26 === n2 || ds(e26, ut3[r4]) && !pt3.call(i2, r4) ? t4 : e26;
      }
      function Aa2(e26, t4, r4, i2, a3, o3) {
        return ws2(e26) && ws2(t4) && (o3.set(t4, e26), gi2(e26, t4, n2, Aa2, o3), o3.delete(t4)), e26;
      }
      function wa2(e26) {
        return Is2(e26) ? n2 : e26;
      }
      function _a2(e26, t4, r4, i2, a3, o3) {
        var s3 = r4 & d2, u3 = e26.length, c3 = t4.length;
        if (u3 != c3 && !(s3 && c3 > u3))
          return false;
        var l3 = o3.get(e26);
        if (l3 && o3.get(t4))
          return l3 == t4;
        var p3 = -1, f3 = true, h3 = r4 & m2 ? new Cn2() : n2;
        for (o3.set(e26, t4), o3.set(t4, e26); ++p3 < u3; ) {
          var g3 = e26[p3], y3 = t4[p3];
          if (i2)
            var v3 = s3 ? i2(y3, g3, p3, t4, e26, o3) : i2(g3, y3, p3, e26, t4, o3);
          if (v3 !== n2) {
            if (v3)
              continue;
            f3 = false;
            break;
          }
          if (h3) {
            if (!rr2(t4, function(e27, t5) {
              if (!yr2(h3, t5) && (g3 === e27 || a3(g3, e27, r4, i2, o3)))
                return h3.push(t5);
            })) {
              f3 = false;
              break;
            }
          } else if (g3 !== y3 && !a3(g3, y3, r4, i2, o3)) {
            f3 = false;
            break;
          }
        }
        return o3.delete(e26), o3.delete(t4), f3;
      }
      function Ta2(e26) {
        return ao2(eo2(e26, n2, xo2), e26 + "");
      }
      function Pa2(e26) {
        return Yn2(e26, au2, Va2);
      }
      function Ia2(e26) {
        return Yn2(e26, ou2, Ua2);
      }
      var Ba2 = nn2 ? function(e26) {
        return nn2.get(e26);
      } : Nu2;
      function Oa2(e26) {
        for (var t4 = e26.name + "", r4 = an2[t4], n3 = pt3.call(an2, t4) ? r4.length : 0; n3--; ) {
          var i2 = r4[n3], a3 = i2.func;
          if (a3 == null || a3 == e26)
            return i2.name;
        }
        return t4;
      }
      function La2(e26) {
        return (pt3.call(dn2, "placeholder") ? dn2 : e26).placeholder;
      }
      function Na2() {
        var e26 = dn2.iteratee || Iu2;
        return e26 = e26 === Iu2 ? ci2 : e26, arguments.length ? e26(arguments[0], arguments[1]) : e26;
      }
      function ja2(e26, t4) {
        var r4 = e26.__data__;
        return function(e27) {
          var t5 = i(e27);
          return t5 == "string" || t5 == "number" || t5 == "symbol" || t5 == "boolean" ? e27 !== "__proto__" : e27 === null;
        }(t4) ? r4[typeof t4 == "string" ? "string" : "hash"] : r4.map;
      }
      function Ra2(e26) {
        for (var t4 = au2(e26), r4 = t4.length; r4--; ) {
          var n3 = t4[r4], i2 = e26[n3];
          t4[r4] = [n3, i2, Ya2(i2)];
        }
        return t4;
      }
      function Ma2(e26, t4) {
        var r4 = function(e27, t5) {
          return e27 == null ? n2 : e27[t5];
        }(e26, t4);
        return ui2(r4) ? r4 : n2;
      }
      var Va2 = Vr2 ? function(e26) {
        return e26 == null ? [] : (e26 = rt3(e26), Jt2(Vr2(e26), function(t4) {
          return Nt3.call(e26, t4);
        }));
      } : Wu2, Ua2 = Vr2 ? function(e26) {
        for (var t4 = []; e26; )
          Zt2(t4, Va2(e26)), e26 = Bt3(e26);
        return t4;
      } : Wu2, qa2 = Zn2;
      function Wa2(e26, t4, r4) {
        for (var n3 = -1, i2 = (t4 = Hi2(t4, e26)).length, a3 = false; ++n3 < i2; ) {
          var o3 = lo2(t4[n3]);
          if (!(a3 = e26 != null && r4(e26, o3)))
            break;
          e26 = e26[o3];
        }
        return a3 || ++n3 != i2 ? a3 : !!(i2 = e26 == null ? 0 : e26.length) && As2(i2) && za2(o3, i2) && (vs(e26) || ys(e26));
      }
      function $a2(e26) {
        return typeof e26.constructor != "function" || Xa2(e26) ? {} : mn2(Bt3(e26));
      }
      function Ga2(e26) {
        return vs(e26) || ys(e26) || !!(nr3 && e26 && e26[nr3]);
      }
      function za2(e26, t4) {
        var r4 = i(e26);
        return !!(t4 = t4 == null ? B2 : t4) && (r4 == "number" || r4 != "symbol" && He2.test(e26)) && e26 > -1 && e26 % 1 == 0 && e26 < t4;
      }
      function Ha2(e26, t4, r4) {
        if (!ws2(r4))
          return false;
        var n3 = i(t4);
        return !!(n3 == "number" ? bs2(r4) && za2(t4, r4.length) : n3 == "string" && t4 in r4) && ds(r4[t4], e26);
      }
      function Ka2(e26, t4) {
        if (vs(e26))
          return false;
        var r4 = i(e26);
        return !(r4 != "number" && r4 != "symbol" && r4 != "boolean" && e26 != null && !Ns2(e26)) || (_e2.test(e26) || !we2.test(e26) || t4 != null && e26 in rt3(t4));
      }
      function Ja2(e26) {
        var t4 = Oa2(e26), r4 = dn2[t4];
        if (typeof r4 != "function" || !(t4 in vn2.prototype))
          return false;
        if (e26 === r4)
          return true;
        var n3 = Ba2(r4);
        return !!n3 && e26 === n3[0];
      }
      (Xr2 && qa2(new Xr2(new ArrayBuffer(1))) != ue2 || Yr2 && qa2(new Yr2()) != J2 || Zr2 && qa2(Zr2.resolve()) != "[object Promise]" || en2 && qa2(new en2()) != te2 || tn2 && qa2(new tn2()) != ae2) && (qa2 = function(e26) {
        var t4 = Zn2(e26), r4 = t4 == Y2 ? e26.constructor : n2, i2 = r4 ? po2(r4) : "";
        if (i2)
          switch (i2) {
            case on2:
              return ue2;
            case sn2:
              return J2;
            case un2:
              return "[object Promise]";
            case cn2:
              return te2;
            case ln2:
              return ae2;
          }
        return t4;
      });
      var Qa2 = ct3 ? Ds2 : $u2;
      function Xa2(e26) {
        var t4 = e26 && e26.constructor;
        return e26 === (typeof t4 == "function" && t4.prototype || ut3);
      }
      function Ya2(e26) {
        return e26 == e26 && !ws2(e26);
      }
      function Za2(e26, t4) {
        return function(r4) {
          return r4 != null && (r4[e26] === t4 && (t4 !== n2 || e26 in rt3(r4)));
        };
      }
      function eo2(e26, t4, r4) {
        return t4 = Gr2(t4 === n2 ? e26.length - 1 : t4, 0), function() {
          for (var n3 = arguments, i2 = -1, a3 = Gr2(n3.length - t4, 0), o3 = Xe3(a3); ++i2 < a3; )
            o3[i2] = n3[t4 + i2];
          i2 = -1;
          for (var s3 = Xe3(t4 + 1); ++i2 < t4; )
            s3[i2] = n3[i2];
          return s3[t4] = r4(o3), $t2(e26, this, s3);
        };
      }
      function to2(e26, t4) {
        return t4.length < 2 ? e26 : Xn2(e26, Pi2(t4, 0, -1));
      }
      function ro2(e26, t4) {
        if ((t4 !== "constructor" || typeof e26[t4] != "function") && t4 != "__proto__")
          return e26[t4];
      }
      var no2 = so2(wi2), io2 = jr2 || function(e26, t4) {
        return It2.setTimeout(e26, t4);
      }, ao2 = so2(_i2);
      function oo2(e26, t4, r4) {
        var n3 = t4 + "";
        return ao2(e26, function(e27, t5) {
          var r5 = t5.length;
          if (!r5)
            return e27;
          var n4 = r5 - 1;
          return t5[n4] = (r5 > 1 ? "& " : "") + t5[n4], t5 = t5.join(r5 > 2 ? ", " : " "), e27.replace(Ne2, "{\n/* [wrapped with " + t5 + "] */\n");
        }(n3, function(e27, t5) {
          return zt2(M2, function(r5) {
            var n4 = "_." + r5[0];
            t5 & r5[1] && !Qt2(e27, n4) && e27.push(n4);
          }), e27.sort();
        }(function(e27) {
          var t5 = e27.match(je2);
          return t5 ? t5[1].split(Re2) : [];
        }(n3), r4)));
      }
      function so2(e26) {
        var t4 = 0, r4 = 0;
        return function() {
          var i2 = Hr2(), a3 = _2 - (i2 - r4);
          if (r4 = i2, a3 > 0) {
            if (++t4 >= w2)
              return arguments[0];
          } else
            t4 = 0;
          return e26.apply(n2, arguments);
        };
      }
      function uo2(e26, t4) {
        var r4 = -1, i2 = e26.length, a3 = i2 - 1;
        for (t4 = t4 === n2 ? i2 : t4; ++r4 < t4; ) {
          var o3 = Ci2(r4, a3), s3 = e26[o3];
          e26[o3] = e26[r4], e26[r4] = s3;
        }
        return e26.length = t4, e26;
      }
      var co2 = function(e26) {
        var t4 = us2(e26, function(e27) {
          return r4.size === c2 && r4.clear(), e27;
        }), r4 = t4.cache;
        return t4;
      }(function(e26) {
        var t4 = [];
        return e26.charCodeAt(0) === 46 && t4.push(""), e26.replace(Te2, function(e27, r4, n3, i2) {
          t4.push(n3 ? i2.replace(Ve2, "$1") : r4 || e27);
        }), t4;
      });
      function lo2(e26) {
        if (typeof e26 == "string" || Ns2(e26))
          return e26;
        var t4 = e26 + "";
        return t4 == "0" && 1 / e26 == -I2 ? "-0" : t4;
      }
      function po2(e26) {
        if (e26 != null) {
          try {
            return lt3.call(e26);
          } catch (e27) {
          }
          try {
            return e26 + "";
          } catch (e27) {
          }
        }
        return "";
      }
      function fo2(e26) {
        if (e26 instanceof vn2)
          return e26.clone();
        var t4 = new yn2(e26.__wrapped__, e26.__chain__);
        return t4.__actions__ = na2(e26.__actions__), t4.__index__ = e26.__index__, t4.__values__ = e26.__values__, t4;
      }
      var ho2 = ki2(function(e26, t4) {
        return Es2(e26) ? Mn2(e26, Gn2(t4, 1, Es2, true)) : [];
      }), mo2 = ki2(function(e26, t4) {
        var r4 = ko(t4);
        return Es2(r4) && (r4 = n2), Es2(e26) ? Mn2(e26, Gn2(t4, 1, Es2, true), Na2(r4, 2)) : [];
      }), go2 = ki2(function(e26, t4) {
        var r4 = ko(t4);
        return Es2(r4) && (r4 = n2), Es2(e26) ? Mn2(e26, Gn2(t4, 1, Es2, true), n2, r4) : [];
      });
      function yo2(e26, t4, r4) {
        var n3 = e26 == null ? 0 : e26.length;
        if (!n3)
          return -1;
        var i2 = r4 == null ? 0 : qs2(r4);
        return i2 < 0 && (i2 = Gr2(n3 + i2, 0)), ar2(e26, Na2(t4, 3), i2);
      }
      function vo2(e26, t4, r4) {
        var i2 = e26 == null ? 0 : e26.length;
        if (!i2)
          return -1;
        var a3 = i2 - 1;
        return r4 !== n2 && (a3 = qs2(r4), a3 = r4 < 0 ? Gr2(i2 + a3, 0) : zr2(a3, i2 - 1)), ar2(e26, Na2(t4, 3), a3, true);
      }
      function xo2(e26) {
        return (e26 == null ? 0 : e26.length) ? Gn2(e26, 1) : [];
      }
      function bo2(e26) {
        return e26 && e26.length ? e26[0] : n2;
      }
      var Eo2 = ki2(function(e26) {
        var t4 = Yt2(e26, Gi2);
        return t4.length && t4[0] === e26[0] ? ni2(t4) : [];
      }), Co = ki2(function(e26) {
        var t4 = ko(e26), r4 = Yt2(e26, Gi2);
        return t4 === ko(r4) ? t4 = n2 : r4.pop(), r4.length && r4[0] === e26[0] ? ni2(r4, Na2(t4, 2)) : [];
      }), So = ki2(function(e26) {
        var t4 = ko(e26), r4 = Yt2(e26, Gi2);
        return (t4 = typeof t4 == "function" ? t4 : n2) && r4.pop(), r4.length && r4[0] === e26[0] ? ni2(r4, n2, t4) : [];
      });
      function ko(e26) {
        var t4 = e26 == null ? 0 : e26.length;
        return t4 ? e26[t4 - 1] : n2;
      }
      var Do = ki2(Fo);
      function Fo(e26, t4) {
        return e26 && e26.length && t4 && t4.length ? bi2(e26, t4) : e26;
      }
      var Ao = Ta2(function(e26, t4) {
        var r4 = e26 == null ? 0 : e26.length, n3 = On2(e26, t4);
        return Ei2(e26, Yt2(t4, function(e27) {
          return za2(e27, r4) ? +e27 : e27;
        }).sort(ea2)), n3;
      });
      function wo(e26) {
        return e26 == null ? e26 : Qr2.call(e26);
      }
      var _o2 = ki2(function(e26) {
        return Ri(Gn2(e26, 1, Es2, true));
      }), To2 = ki2(function(e26) {
        var t4 = ko(e26);
        return Es2(t4) && (t4 = n2), Ri(Gn2(e26, 1, Es2, true), Na2(t4, 2));
      }), Po2 = ki2(function(e26) {
        var t4 = ko(e26);
        return t4 = typeof t4 == "function" ? t4 : n2, Ri(Gn2(e26, 1, Es2, true), n2, t4);
      });
      function Io2(e26) {
        if (!e26 || !e26.length)
          return [];
        var t4 = 0;
        return e26 = Jt2(e26, function(e27) {
          if (Es2(e27))
            return t4 = Gr2(e27.length, t4), true;
        }), dr2(t4, function(t5) {
          return Yt2(e26, lr2(t5));
        });
      }
      function Bo2(e26, t4) {
        if (!e26 || !e26.length)
          return [];
        var r4 = Io2(e26);
        return t4 == null ? r4 : Yt2(r4, function(e27) {
          return $t2(t4, n2, e27);
        });
      }
      var Oo2 = ki2(function(e26, t4) {
        return Es2(e26) ? Mn2(e26, t4) : [];
      }), Lo2 = ki2(function(e26) {
        return Wi2(Jt2(e26, Es2));
      }), No2 = ki2(function(e26) {
        var t4 = ko(e26);
        return Es2(t4) && (t4 = n2), Wi2(Jt2(e26, Es2), Na2(t4, 2));
      }), jo2 = ki2(function(e26) {
        var t4 = ko(e26);
        return t4 = typeof t4 == "function" ? t4 : n2, Wi2(Jt2(e26, Es2), n2, t4);
      }), Ro2 = ki2(Io2);
      var Mo2 = ki2(function(e26) {
        var t4 = e26.length, r4 = t4 > 1 ? e26[t4 - 1] : n2;
        return r4 = typeof r4 == "function" ? (e26.pop(), r4) : n2, Bo2(e26, r4);
      });
      function Vo2(e26) {
        var t4 = dn2(e26);
        return t4.__chain__ = true, t4;
      }
      function Uo2(e26, t4) {
        return t4(e26);
      }
      var qo2 = Ta2(function(e26) {
        var t4 = e26.length, r4 = t4 ? e26[0] : 0, i2 = this.__wrapped__, a3 = function(t5) {
          return On2(t5, e26);
        };
        return !(t4 > 1 || this.__actions__.length) && i2 instanceof vn2 && za2(r4) ? ((i2 = i2.slice(r4, +r4 + (t4 ? 1 : 0))).__actions__.push({ func: Uo2, args: [a3], thisArg: n2 }), new yn2(i2, this.__chain__).thru(function(e27) {
          return t4 && !e27.length && e27.push(n2), e27;
        })) : this.thru(a3);
      });
      var Wo2 = aa2(function(e26, t4, r4) {
        pt3.call(e26, r4) ? ++e26[r4] : Bn2(e26, r4, 1);
      });
      var $o2 = fa2(yo2), Go2 = fa2(vo2);
      function zo2(e26, t4) {
        return (vs(e26) ? zt2 : Vn2)(e26, Na2(t4, 3));
      }
      function Ho2(e26, t4) {
        return (vs(e26) ? Ht2 : Un2)(e26, Na2(t4, 3));
      }
      var Ko2 = aa2(function(e26, t4, r4) {
        pt3.call(e26, r4) ? e26[r4].push(t4) : Bn2(e26, r4, [t4]);
      });
      var Jo2 = ki2(function(e26, t4, r4) {
        var n3 = -1, i2 = typeof t4 == "function", a3 = bs2(e26) ? Xe3(e26.length) : [];
        return Vn2(e26, function(e27) {
          a3[++n3] = i2 ? $t2(t4, e27, r4) : ii2(e27, t4, r4);
        }), a3;
      }), Qo2 = aa2(function(e26, t4, r4) {
        Bn2(e26, r4, t4);
      });
      function Xo2(e26, t4) {
        return (vs(e26) ? Yt2 : hi2)(e26, Na2(t4, 3));
      }
      var Yo2 = aa2(function(e26, t4, r4) {
        e26[r4 ? 0 : 1].push(t4);
      }, function() {
        return [[], []];
      });
      var Zo2 = ki2(function(e26, t4) {
        if (e26 == null)
          return [];
        var r4 = t4.length;
        return r4 > 1 && Ha2(e26, t4[0], t4[1]) ? t4 = [] : r4 > 2 && Ha2(t4[0], t4[1], t4[2]) && (t4 = [t4[0]]), vi2(e26, Gn2(t4, 1), []);
      }), es2 = Nr2 || function() {
        return It2.Date.now();
      };
      function ts2(e26, t4, r4) {
        return t4 = r4 ? n2 : t4, t4 = e26 && t4 == null ? e26.length : t4, Da2(e26, S2, n2, n2, n2, n2, t4);
      }
      function rs2(e26, t4) {
        var r4;
        if (typeof t4 != "function")
          throw new at3(s2);
        return e26 = qs2(e26), function() {
          return --e26 > 0 && (r4 = t4.apply(this, arguments)), e26 <= 1 && (t4 = n2), r4;
        };
      }
      var ns2 = ki2(function(e26, t4, r4) {
        var n3 = g2;
        if (r4.length) {
          var i2 = Fr2(r4, La2(ns2));
          n3 |= E2;
        }
        return Da2(e26, n3, t4, r4, i2);
      }), is2 = ki2(function(e26, t4, r4) {
        var n3 = g2 | y2;
        if (r4.length) {
          var i2 = Fr2(r4, La2(is2));
          n3 |= E2;
        }
        return Da2(t4, n3, e26, r4, i2);
      });
      function as2(e26, t4, r4) {
        var i2, a3, o3, u3, c3, l3, p3 = 0, f3 = false, h3 = false, d3 = true;
        if (typeof e26 != "function")
          throw new at3(s2);
        function m3(t5) {
          var r5 = i2, o4 = a3;
          return i2 = a3 = n2, p3 = t5, u3 = e26.apply(o4, r5);
        }
        function g3(e27) {
          var r5 = e27 - l3;
          return l3 === n2 || r5 >= t4 || r5 < 0 || h3 && e27 - p3 >= o3;
        }
        function y3() {
          var e27 = es2();
          if (g3(e27))
            return v3(e27);
          c3 = io2(y3, function(e28) {
            var r5 = t4 - (e28 - l3);
            return h3 ? zr2(r5, o3 - (e28 - p3)) : r5;
          }(e27));
        }
        function v3(e27) {
          return c3 = n2, d3 && i2 ? m3(e27) : (i2 = a3 = n2, u3);
        }
        function x3() {
          var e27 = es2(), r5 = g3(e27);
          if (i2 = arguments, a3 = this, l3 = e27, r5) {
            if (c3 === n2)
              return function(e28) {
                return p3 = e28, c3 = io2(y3, t4), f3 ? m3(e28) : u3;
              }(l3);
            if (h3)
              return Qi2(c3), c3 = io2(y3, t4), m3(l3);
          }
          return c3 === n2 && (c3 = io2(y3, t4)), u3;
        }
        return t4 = $s2(t4) || 0, ws2(r4) && (f3 = !!r4.leading, o3 = (h3 = "maxWait" in r4) ? Gr2($s2(r4.maxWait) || 0, t4) : o3, d3 = "trailing" in r4 ? !!r4.trailing : d3), x3.cancel = function() {
          c3 !== n2 && Qi2(c3), p3 = 0, i2 = l3 = a3 = c3 = n2;
        }, x3.flush = function() {
          return c3 === n2 ? u3 : v3(es2());
        }, x3;
      }
      var os2 = ki2(function(e26, t4) {
        return Rn2(e26, 1, t4);
      }), ss2 = ki2(function(e26, t4, r4) {
        return Rn2(e26, $s2(t4) || 0, r4);
      });
      function us2(e26, t4) {
        if (typeof e26 != "function" || t4 != null && typeof t4 != "function")
          throw new at3(s2);
        var r4 = function r5() {
          var n3 = arguments, i2 = t4 ? t4.apply(this, n3) : n3[0], a3 = r5.cache;
          if (a3.has(i2))
            return a3.get(i2);
          var o3 = e26.apply(this, n3);
          return r5.cache = a3.set(i2, o3) || a3, o3;
        };
        return r4.cache = new (us2.Cache || En2)(), r4;
      }
      function cs(e26) {
        if (typeof e26 != "function")
          throw new at3(s2);
        return function() {
          var t4 = arguments;
          switch (t4.length) {
            case 0:
              return !e26.call(this);
            case 1:
              return !e26.call(this, t4[0]);
            case 2:
              return !e26.call(this, t4[0], t4[1]);
            case 3:
              return !e26.call(this, t4[0], t4[1], t4[2]);
          }
          return !e26.apply(this, t4);
        };
      }
      us2.Cache = En2;
      var ls = Ki2(function(e26, t4) {
        var r4 = (t4 = t4.length == 1 && vs(t4[0]) ? Yt2(t4[0], mr2(Na2())) : Yt2(Gn2(t4, 1), mr2(Na2()))).length;
        return ki2(function(n3) {
          for (var i2 = -1, a3 = zr2(n3.length, r4); ++i2 < a3; )
            n3[i2] = t4[i2].call(this, n3[i2]);
          return $t2(e26, this, n3);
        });
      }), ps = ki2(function(e26, t4) {
        var r4 = Fr2(t4, La2(ps));
        return Da2(e26, E2, n2, t4, r4);
      }), fs = ki2(function(e26, t4) {
        var r4 = Fr2(t4, La2(fs));
        return Da2(e26, C2, n2, t4, r4);
      }), hs = Ta2(function(e26, t4) {
        return Da2(e26, k2, n2, n2, n2, t4);
      });
      function ds(e26, t4) {
        return e26 === t4 || e26 != e26 && t4 != t4;
      }
      var ms = ba2(ei2), gs = ba2(function(e26, t4) {
        return e26 >= t4;
      }), ys = ai2(function() {
        return arguments;
      }()) ? ai2 : function(e26) {
        return _s2(e26) && pt3.call(e26, "callee") && !Nt3.call(e26, "callee");
      }, vs = Xe3.isArray, xs = Rt2 ? mr2(Rt2) : function(e26) {
        return _s2(e26) && Zn2(e26) == se2;
      };
      function bs2(e26) {
        return e26 != null && As2(e26.length) && !Ds2(e26);
      }
      function Es2(e26) {
        return _s2(e26) && bs2(e26);
      }
      var Cs2 = Ur2 || $u2, Ss2 = Mt2 ? mr2(Mt2) : function(e26) {
        return _s2(e26) && Zn2(e26) == $2;
      };
      function ks2(e26) {
        if (!_s2(e26))
          return false;
        var t4 = Zn2(e26);
        return t4 == z2 || t4 == G2 || typeof e26.message == "string" && typeof e26.name == "string" && !Is2(e26);
      }
      function Ds2(e26) {
        if (!ws2(e26))
          return false;
        var t4 = Zn2(e26);
        return t4 == H2 || t4 == K2 || t4 == q2 || t4 == Z2;
      }
      function Fs2(e26) {
        return typeof e26 == "number" && e26 == qs2(e26);
      }
      function As2(e26) {
        return typeof e26 == "number" && e26 > -1 && e26 % 1 == 0 && e26 <= B2;
      }
      function ws2(e26) {
        var t4 = i(e26);
        return e26 != null && (t4 == "object" || t4 == "function");
      }
      function _s2(e26) {
        return e26 != null && i(e26) == "object";
      }
      var Ts2 = Vt2 ? mr2(Vt2) : function(e26) {
        return _s2(e26) && qa2(e26) == J2;
      };
      function Ps2(e26) {
        return typeof e26 == "number" || _s2(e26) && Zn2(e26) == Q2;
      }
      function Is2(e26) {
        if (!_s2(e26) || Zn2(e26) != Y2)
          return false;
        var t4 = Bt3(e26);
        if (t4 === null)
          return true;
        var r4 = pt3.call(t4, "constructor") && t4.constructor;
        return typeof r4 == "function" && r4 instanceof r4 && lt3.call(r4) == mt3;
      }
      var Bs2 = Ut2 ? mr2(Ut2) : function(e26) {
        return _s2(e26) && Zn2(e26) == ee2;
      };
      var Os2 = qt2 ? mr2(qt2) : function(e26) {
        return _s2(e26) && qa2(e26) == te2;
      };
      function Ls2(e26) {
        return typeof e26 == "string" || !vs(e26) && _s2(e26) && Zn2(e26) == re2;
      }
      function Ns2(e26) {
        return i(e26) == "symbol" || _s2(e26) && Zn2(e26) == ne2;
      }
      var js2 = Wt2 ? mr2(Wt2) : function(e26) {
        return _s2(e26) && As2(e26.length) && !!Dt2[Zn2(e26)];
      };
      var Rs2 = ba2(fi2), Ms2 = ba2(function(e26, t4) {
        return e26 <= t4;
      });
      function Vs2(e26) {
        if (!e26)
          return [];
        if (bs2(e26))
          return Ls2(e26) ? Tr2(e26) : na2(e26);
        if (pr3 && e26[pr3])
          return function(e27) {
            for (var t5, r4 = []; !(t5 = e27.next()).done; )
              r4.push(t5.value);
            return r4;
          }(e26[pr3]());
        var t4 = qa2(e26);
        return (t4 == J2 ? kr : t4 == te2 ? Ar2 : du2)(e26);
      }
      function Us2(e26) {
        return e26 ? (e26 = $s2(e26)) === I2 || e26 === -I2 ? (e26 < 0 ? -1 : 1) * O2 : e26 == e26 ? e26 : 0 : e26 === 0 ? e26 : 0;
      }
      function qs2(e26) {
        var t4 = Us2(e26), r4 = t4 % 1;
        return t4 == t4 ? r4 ? t4 - r4 : t4 : 0;
      }
      function Ws2(e26) {
        return e26 ? Ln2(qs2(e26), 0, N2) : 0;
      }
      function $s2(e26) {
        if (typeof e26 == "number")
          return e26;
        if (Ns2(e26))
          return L2;
        if (ws2(e26)) {
          var t4 = typeof e26.valueOf == "function" ? e26.valueOf() : e26;
          e26 = ws2(t4) ? t4 + "" : t4;
        }
        if (typeof e26 != "string")
          return e26 === 0 ? e26 : +e26;
        e26 = e26.replace(Be2, "");
        var r4 = $e2.test(e26);
        return r4 || ze2.test(e26) ? _t2(e26.slice(2), r4 ? 2 : 8) : We2.test(e26) ? L2 : +e26;
      }
      function Gs2(e26) {
        return ia2(e26, ou2(e26));
      }
      function zs2(e26) {
        return e26 == null ? "" : ji(e26);
      }
      var Hs2 = oa2(function(e26, t4) {
        if (Xa2(t4) || bs2(t4))
          ia2(t4, au2(t4), e26);
        else
          for (var r4 in t4)
            pt3.call(t4, r4) && _n2(e26, r4, t4[r4]);
      }), Ks2 = oa2(function(e26, t4) {
        ia2(t4, ou2(t4), e26);
      }), Js2 = oa2(function(e26, t4, r4, n3) {
        ia2(t4, ou2(t4), e26, n3);
      }), Qs2 = oa2(function(e26, t4, r4, n3) {
        ia2(t4, au2(t4), e26, n3);
      }), Xs2 = Ta2(On2);
      var Ys2 = ki2(function(e26, t4) {
        e26 = rt3(e26);
        var r4 = -1, i2 = t4.length, a3 = i2 > 2 ? t4[2] : n2;
        for (a3 && Ha2(t4[0], t4[1], a3) && (i2 = 1); ++r4 < i2; )
          for (var o3 = t4[r4], s3 = ou2(o3), u3 = -1, c3 = s3.length; ++u3 < c3; ) {
            var l3 = s3[u3], p3 = e26[l3];
            (p3 === n2 || ds(p3, ut3[l3]) && !pt3.call(e26, l3)) && (e26[l3] = o3[l3]);
          }
        return e26;
      }), Zs2 = ki2(function(e26) {
        return e26.push(n2, Aa2), $t2(uu2, n2, e26);
      });
      function eu2(e26, t4, r4) {
        var i2 = e26 == null ? n2 : Xn2(e26, t4);
        return i2 === n2 ? r4 : i2;
      }
      function tu2(e26, t4) {
        return e26 != null && Wa2(e26, t4, ri2);
      }
      var ru2 = ma2(function(e26, t4, r4) {
        t4 != null && typeof t4.toString != "function" && (t4 = dt3.call(t4)), e26[t4] = r4;
      }, wu2(Pu2)), nu2 = ma2(function(e26, t4, r4) {
        t4 != null && typeof t4.toString != "function" && (t4 = dt3.call(t4)), pt3.call(e26, t4) ? e26[t4].push(r4) : e26[t4] = [r4];
      }, Na2), iu2 = ki2(ii2);
      function au2(e26) {
        return bs2(e26) ? kn2(e26) : li2(e26);
      }
      function ou2(e26) {
        return bs2(e26) ? kn2(e26, true) : pi2(e26);
      }
      var su2 = oa2(function(e26, t4, r4) {
        gi2(e26, t4, r4);
      }), uu2 = oa2(function(e26, t4, r4, n3) {
        gi2(e26, t4, r4, n3);
      }), cu2 = Ta2(function(e26, t4) {
        var r4 = {};
        if (e26 == null)
          return r4;
        var n3 = false;
        t4 = Yt2(t4, function(t5) {
          return t5 = Hi2(t5, e26), n3 || (n3 = t5.length > 1), t5;
        }), ia2(e26, Ia2(e26), r4), n3 && (r4 = Nn2(r4, p2 | f2 | h2, wa2));
        for (var i2 = t4.length; i2--; )
          Mi2(r4, t4[i2]);
        return r4;
      });
      var lu2 = Ta2(function(e26, t4) {
        return e26 == null ? {} : function(e27, t5) {
          return xi2(e27, t5, function(t6, r4) {
            return tu2(e27, r4);
          });
        }(e26, t4);
      });
      function pu2(e26, t4) {
        if (e26 == null)
          return {};
        var r4 = Yt2(Ia2(e26), function(e27) {
          return [e27];
        });
        return t4 = Na2(t4), xi2(e26, r4, function(e27, r5) {
          return t4(e27, r5[0]);
        });
      }
      var fu2 = ka2(au2), hu2 = ka2(ou2);
      function du2(e26) {
        return e26 == null ? [] : gr2(e26, au2(e26));
      }
      var mu2 = la2(function(e26, t4, r4) {
        return t4 = t4.toLowerCase(), e26 + (r4 ? gu2(t4) : t4);
      });
      function gu2(e26) {
        return ku2(zs2(e26).toLowerCase());
      }
      function yu2(e26) {
        return (e26 = zs2(e26)) && e26.replace(Ke2, br2).replace(vt, "");
      }
      var vu2 = la2(function(e26, t4, r4) {
        return e26 + (r4 ? "-" : "") + t4.toLowerCase();
      }), xu2 = la2(function(e26, t4, r4) {
        return e26 + (r4 ? " " : "") + t4.toLowerCase();
      }), bu2 = ca2("toLowerCase");
      var Eu2 = la2(function(e26, t4, r4) {
        return e26 + (r4 ? "_" : "") + t4.toLowerCase();
      });
      var Cu2 = la2(function(e26, t4, r4) {
        return e26 + (r4 ? " " : "") + ku2(t4);
      });
      var Su2 = la2(function(e26, t4, r4) {
        return e26 + (r4 ? " " : "") + t4.toUpperCase();
      }), ku2 = ca2("toUpperCase");
      function Du2(e26, t4, r4) {
        return e26 = zs2(e26), (t4 = r4 ? n2 : t4) === n2 ? function(e27) {
          return Ct2.test(e27);
        }(e26) ? function(e27) {
          return e27.match(bt) || [];
        }(e26) : function(e27) {
          return e27.match(Me2) || [];
        }(e26) : e26.match(t4) || [];
      }
      var Fu2 = ki2(function(e26, t4) {
        try {
          return $t2(e26, n2, t4);
        } catch (e27) {
          return ks2(e27) ? e27 : new Ze3(e27);
        }
      }), Au2 = Ta2(function(e26, t4) {
        return zt2(t4, function(t5) {
          t5 = lo2(t5), Bn2(e26, t5, ns2(e26[t5], e26));
        }), e26;
      });
      function wu2(e26) {
        return function() {
          return e26;
        };
      }
      var _u2 = ha2(), Tu2 = ha2(true);
      function Pu2(e26) {
        return e26;
      }
      function Iu2(e26) {
        return ci2(typeof e26 == "function" ? e26 : Nn2(e26, p2));
      }
      var Bu2 = ki2(function(e26, t4) {
        return function(r4) {
          return ii2(r4, e26, t4);
        };
      }), Ou2 = ki2(function(e26, t4) {
        return function(r4) {
          return ii2(e26, r4, t4);
        };
      });
      function Lu2(e26, t4, r4) {
        var n3 = au2(t4), i2 = Qn2(t4, n3);
        r4 != null || ws2(t4) && (i2.length || !n3.length) || (r4 = t4, t4 = e26, e26 = this, i2 = Qn2(t4, au2(t4)));
        var a3 = !(ws2(r4) && "chain" in r4 && !r4.chain), o3 = Ds2(e26);
        return zt2(i2, function(r5) {
          var n4 = t4[r5];
          e26[r5] = n4, o3 && (e26.prototype[r5] = function() {
            var t5 = this.__chain__;
            if (a3 || t5) {
              var r6 = e26(this.__wrapped__), i3 = r6.__actions__ = na2(this.__actions__);
              return i3.push({ func: n4, args: arguments, thisArg: e26 }), r6.__chain__ = t5, r6;
            }
            return n4.apply(e26, Zt2([this.value()], arguments));
          });
        }), e26;
      }
      function Nu2() {
      }
      var ju2 = ya2(Yt2), Ru2 = ya2(Kt2), Mu2 = ya2(rr2);
      function Vu2(e26) {
        return Ka2(e26) ? lr2(lo2(e26)) : function(e27) {
          return function(t4) {
            return Xn2(t4, e27);
          };
        }(e26);
      }
      var Uu2 = xa2(), qu2 = xa2(true);
      function Wu2() {
        return [];
      }
      function $u2() {
        return false;
      }
      var Gu2 = ga2(function(e26, t4) {
        return e26 + t4;
      }, 0), zu2 = Ca2("ceil"), Hu2 = ga2(function(e26, t4) {
        return e26 / t4;
      }, 1), Ku2 = Ca2("floor");
      var Ju2, Qu2 = ga2(function(e26, t4) {
        return e26 * t4;
      }, 1), Xu2 = Ca2("round"), Yu2 = ga2(function(e26, t4) {
        return e26 - t4;
      }, 0);
      return dn2.after = function(e26, t4) {
        if (typeof t4 != "function")
          throw new at3(s2);
        return e26 = qs2(e26), function() {
          if (--e26 < 1)
            return t4.apply(this, arguments);
        };
      }, dn2.ary = ts2, dn2.assign = Hs2, dn2.assignIn = Ks2, dn2.assignInWith = Js2, dn2.assignWith = Qs2, dn2.at = Xs2, dn2.before = rs2, dn2.bind = ns2, dn2.bindAll = Au2, dn2.bindKey = is2, dn2.castArray = function() {
        if (!arguments.length)
          return [];
        var e26 = arguments[0];
        return vs(e26) ? e26 : [e26];
      }, dn2.chain = Vo2, dn2.chunk = function(e26, t4, r4) {
        t4 = (r4 ? Ha2(e26, t4, r4) : t4 === n2) ? 1 : Gr2(qs2(t4), 0);
        var i2 = e26 == null ? 0 : e26.length;
        if (!i2 || t4 < 1)
          return [];
        for (var a3 = 0, o3 = 0, s3 = Xe3(Rr2(i2 / t4)); a3 < i2; )
          s3[o3++] = Pi2(e26, a3, a3 += t4);
        return s3;
      }, dn2.compact = function(e26) {
        for (var t4 = -1, r4 = e26 == null ? 0 : e26.length, n3 = 0, i2 = []; ++t4 < r4; ) {
          var a3 = e26[t4];
          a3 && (i2[n3++] = a3);
        }
        return i2;
      }, dn2.concat = function() {
        var e26 = arguments.length;
        if (!e26)
          return [];
        for (var t4 = Xe3(e26 - 1), r4 = arguments[0], n3 = e26; n3--; )
          t4[n3 - 1] = arguments[n3];
        return Zt2(vs(r4) ? na2(r4) : [r4], Gn2(t4, 1));
      }, dn2.cond = function(e26) {
        var t4 = e26 == null ? 0 : e26.length, r4 = Na2();
        return e26 = t4 ? Yt2(e26, function(e27) {
          if (typeof e27[1] != "function")
            throw new at3(s2);
          return [r4(e27[0]), e27[1]];
        }) : [], ki2(function(r5) {
          for (var n3 = -1; ++n3 < t4; ) {
            var i2 = e26[n3];
            if ($t2(i2[0], this, r5))
              return $t2(i2[1], this, r5);
          }
        });
      }, dn2.conforms = function(e26) {
        return function(e27) {
          var t4 = au2(e27);
          return function(r4) {
            return jn2(r4, e27, t4);
          };
        }(Nn2(e26, p2));
      }, dn2.constant = wu2, dn2.countBy = Wo2, dn2.create = function(e26, t4) {
        var r4 = mn2(e26);
        return t4 == null ? r4 : In2(r4, t4);
      }, dn2.curry = function e26(t4, r4, i2) {
        var a3 = Da2(t4, x2, n2, n2, n2, n2, n2, r4 = i2 ? n2 : r4);
        return a3.placeholder = e26.placeholder, a3;
      }, dn2.curryRight = function e26(t4, r4, i2) {
        var a3 = Da2(t4, b2, n2, n2, n2, n2, n2, r4 = i2 ? n2 : r4);
        return a3.placeholder = e26.placeholder, a3;
      }, dn2.debounce = as2, dn2.defaults = Ys2, dn2.defaultsDeep = Zs2, dn2.defer = os2, dn2.delay = ss2, dn2.difference = ho2, dn2.differenceBy = mo2, dn2.differenceWith = go2, dn2.drop = function(e26, t4, r4) {
        var i2 = e26 == null ? 0 : e26.length;
        return i2 ? Pi2(e26, (t4 = r4 || t4 === n2 ? 1 : qs2(t4)) < 0 ? 0 : t4, i2) : [];
      }, dn2.dropRight = function(e26, t4, r4) {
        var i2 = e26 == null ? 0 : e26.length;
        return i2 ? Pi2(e26, 0, (t4 = i2 - (t4 = r4 || t4 === n2 ? 1 : qs2(t4))) < 0 ? 0 : t4) : [];
      }, dn2.dropRightWhile = function(e26, t4) {
        return e26 && e26.length ? Ui2(e26, Na2(t4, 3), true, true) : [];
      }, dn2.dropWhile = function(e26, t4) {
        return e26 && e26.length ? Ui2(e26, Na2(t4, 3), true) : [];
      }, dn2.fill = function(e26, t4, r4, i2) {
        var a3 = e26 == null ? 0 : e26.length;
        return a3 ? (r4 && typeof r4 != "number" && Ha2(e26, t4, r4) && (r4 = 0, i2 = a3), function(e27, t5, r5, i3) {
          var a4 = e27.length;
          for ((r5 = qs2(r5)) < 0 && (r5 = -r5 > a4 ? 0 : a4 + r5), (i3 = i3 === n2 || i3 > a4 ? a4 : qs2(i3)) < 0 && (i3 += a4), i3 = r5 > i3 ? 0 : Ws2(i3); r5 < i3; )
            e27[r5++] = t5;
          return e27;
        }(e26, t4, r4, i2)) : [];
      }, dn2.filter = function(e26, t4) {
        return (vs(e26) ? Jt2 : $n2)(e26, Na2(t4, 3));
      }, dn2.flatMap = function(e26, t4) {
        return Gn2(Xo2(e26, t4), 1);
      }, dn2.flatMapDeep = function(e26, t4) {
        return Gn2(Xo2(e26, t4), I2);
      }, dn2.flatMapDepth = function(e26, t4, r4) {
        return r4 = r4 === n2 ? 1 : qs2(r4), Gn2(Xo2(e26, t4), r4);
      }, dn2.flatten = xo2, dn2.flattenDeep = function(e26) {
        return (e26 == null ? 0 : e26.length) ? Gn2(e26, I2) : [];
      }, dn2.flattenDepth = function(e26, t4) {
        return (e26 == null ? 0 : e26.length) ? Gn2(e26, t4 = t4 === n2 ? 1 : qs2(t4)) : [];
      }, dn2.flip = function(e26) {
        return Da2(e26, D2);
      }, dn2.flow = _u2, dn2.flowRight = Tu2, dn2.fromPairs = function(e26) {
        for (var t4 = -1, r4 = e26 == null ? 0 : e26.length, n3 = {}; ++t4 < r4; ) {
          var i2 = e26[t4];
          n3[i2[0]] = i2[1];
        }
        return n3;
      }, dn2.functions = function(e26) {
        return e26 == null ? [] : Qn2(e26, au2(e26));
      }, dn2.functionsIn = function(e26) {
        return e26 == null ? [] : Qn2(e26, ou2(e26));
      }, dn2.groupBy = Ko2, dn2.initial = function(e26) {
        return (e26 == null ? 0 : e26.length) ? Pi2(e26, 0, -1) : [];
      }, dn2.intersection = Eo2, dn2.intersectionBy = Co, dn2.intersectionWith = So, dn2.invert = ru2, dn2.invertBy = nu2, dn2.invokeMap = Jo2, dn2.iteratee = Iu2, dn2.keyBy = Qo2, dn2.keys = au2, dn2.keysIn = ou2, dn2.map = Xo2, dn2.mapKeys = function(e26, t4) {
        var r4 = {};
        return t4 = Na2(t4, 3), Kn2(e26, function(e27, n3, i2) {
          Bn2(r4, t4(e27, n3, i2), e27);
        }), r4;
      }, dn2.mapValues = function(e26, t4) {
        var r4 = {};
        return t4 = Na2(t4, 3), Kn2(e26, function(e27, n3, i2) {
          Bn2(r4, n3, t4(e27, n3, i2));
        }), r4;
      }, dn2.matches = function(e26) {
        return di2(Nn2(e26, p2));
      }, dn2.matchesProperty = function(e26, t4) {
        return mi2(e26, Nn2(t4, p2));
      }, dn2.memoize = us2, dn2.merge = su2, dn2.mergeWith = uu2, dn2.method = Bu2, dn2.methodOf = Ou2, dn2.mixin = Lu2, dn2.negate = cs, dn2.nthArg = function(e26) {
        return e26 = qs2(e26), ki2(function(t4) {
          return yi2(t4, e26);
        });
      }, dn2.omit = cu2, dn2.omitBy = function(e26, t4) {
        return pu2(e26, cs(Na2(t4)));
      }, dn2.once = function(e26) {
        return rs2(2, e26);
      }, dn2.orderBy = function(e26, t4, r4, i2) {
        return e26 == null ? [] : (vs(t4) || (t4 = t4 == null ? [] : [t4]), vs(r4 = i2 ? n2 : r4) || (r4 = r4 == null ? [] : [r4]), vi2(e26, t4, r4));
      }, dn2.over = ju2, dn2.overArgs = ls, dn2.overEvery = Ru2, dn2.overSome = Mu2, dn2.partial = ps, dn2.partialRight = fs, dn2.partition = Yo2, dn2.pick = lu2, dn2.pickBy = pu2, dn2.property = Vu2, dn2.propertyOf = function(e26) {
        return function(t4) {
          return e26 == null ? n2 : Xn2(e26, t4);
        };
      }, dn2.pull = Do, dn2.pullAll = Fo, dn2.pullAllBy = function(e26, t4, r4) {
        return e26 && e26.length && t4 && t4.length ? bi2(e26, t4, Na2(r4, 2)) : e26;
      }, dn2.pullAllWith = function(e26, t4, r4) {
        return e26 && e26.length && t4 && t4.length ? bi2(e26, t4, n2, r4) : e26;
      }, dn2.pullAt = Ao, dn2.range = Uu2, dn2.rangeRight = qu2, dn2.rearg = hs, dn2.reject = function(e26, t4) {
        return (vs(e26) ? Jt2 : $n2)(e26, cs(Na2(t4, 3)));
      }, dn2.remove = function(e26, t4) {
        var r4 = [];
        if (!e26 || !e26.length)
          return r4;
        var n3 = -1, i2 = [], a3 = e26.length;
        for (t4 = Na2(t4, 3); ++n3 < a3; ) {
          var o3 = e26[n3];
          t4(o3, n3, e26) && (r4.push(o3), i2.push(n3));
        }
        return Ei2(e26, i2), r4;
      }, dn2.rest = function(e26, t4) {
        if (typeof e26 != "function")
          throw new at3(s2);
        return ki2(e26, t4 = t4 === n2 ? t4 : qs2(t4));
      }, dn2.reverse = wo, dn2.sampleSize = function(e26, t4, r4) {
        return t4 = (r4 ? Ha2(e26, t4, r4) : t4 === n2) ? 1 : qs2(t4), (vs(e26) ? Fn2 : Fi2)(e26, t4);
      }, dn2.set = function(e26, t4, r4) {
        return e26 == null ? e26 : Ai2(e26, t4, r4);
      }, dn2.setWith = function(e26, t4, r4, i2) {
        return i2 = typeof i2 == "function" ? i2 : n2, e26 == null ? e26 : Ai2(e26, t4, r4, i2);
      }, dn2.shuffle = function(e26) {
        return (vs(e26) ? An2 : Ti2)(e26);
      }, dn2.slice = function(e26, t4, r4) {
        var i2 = e26 == null ? 0 : e26.length;
        return i2 ? (r4 && typeof r4 != "number" && Ha2(e26, t4, r4) ? (t4 = 0, r4 = i2) : (t4 = t4 == null ? 0 : qs2(t4), r4 = r4 === n2 ? i2 : qs2(r4)), Pi2(e26, t4, r4)) : [];
      }, dn2.sortBy = Zo2, dn2.sortedUniq = function(e26) {
        return e26 && e26.length ? Li2(e26) : [];
      }, dn2.sortedUniqBy = function(e26, t4) {
        return e26 && e26.length ? Li2(e26, Na2(t4, 2)) : [];
      }, dn2.split = function(e26, t4, r4) {
        return r4 && typeof r4 != "number" && Ha2(e26, t4, r4) && (t4 = r4 = n2), (r4 = r4 === n2 ? N2 : r4 >>> 0) ? (e26 = zs2(e26)) && (typeof t4 == "string" || t4 != null && !Bs2(t4)) && !(t4 = ji(t4)) && Sr(e26) ? Ji2(Tr2(e26), 0, r4) : e26.split(t4, r4) : [];
      }, dn2.spread = function(e26, t4) {
        if (typeof e26 != "function")
          throw new at3(s2);
        return t4 = t4 == null ? 0 : Gr2(qs2(t4), 0), ki2(function(r4) {
          var n3 = r4[t4], i2 = Ji2(r4, 0, t4);
          return n3 && Zt2(i2, n3), $t2(e26, this, i2);
        });
      }, dn2.tail = function(e26) {
        var t4 = e26 == null ? 0 : e26.length;
        return t4 ? Pi2(e26, 1, t4) : [];
      }, dn2.take = function(e26, t4, r4) {
        return e26 && e26.length ? Pi2(e26, 0, (t4 = r4 || t4 === n2 ? 1 : qs2(t4)) < 0 ? 0 : t4) : [];
      }, dn2.takeRight = function(e26, t4, r4) {
        var i2 = e26 == null ? 0 : e26.length;
        return i2 ? Pi2(e26, (t4 = i2 - (t4 = r4 || t4 === n2 ? 1 : qs2(t4))) < 0 ? 0 : t4, i2) : [];
      }, dn2.takeRightWhile = function(e26, t4) {
        return e26 && e26.length ? Ui2(e26, Na2(t4, 3), false, true) : [];
      }, dn2.takeWhile = function(e26, t4) {
        return e26 && e26.length ? Ui2(e26, Na2(t4, 3)) : [];
      }, dn2.tap = function(e26, t4) {
        return t4(e26), e26;
      }, dn2.throttle = function(e26, t4, r4) {
        var n3 = true, i2 = true;
        if (typeof e26 != "function")
          throw new at3(s2);
        return ws2(r4) && (n3 = "leading" in r4 ? !!r4.leading : n3, i2 = "trailing" in r4 ? !!r4.trailing : i2), as2(e26, t4, { leading: n3, maxWait: t4, trailing: i2 });
      }, dn2.thru = Uo2, dn2.toArray = Vs2, dn2.toPairs = fu2, dn2.toPairsIn = hu2, dn2.toPath = function(e26) {
        return vs(e26) ? Yt2(e26, lo2) : Ns2(e26) ? [e26] : na2(co2(zs2(e26)));
      }, dn2.toPlainObject = Gs2, dn2.transform = function(e26, t4, r4) {
        var n3 = vs(e26), i2 = n3 || Cs2(e26) || js2(e26);
        if (t4 = Na2(t4, 4), r4 == null) {
          var a3 = e26 && e26.constructor;
          r4 = i2 ? n3 ? new a3() : [] : ws2(e26) && Ds2(a3) ? mn2(Bt3(e26)) : {};
        }
        return (i2 ? zt2 : Kn2)(e26, function(e27, n4, i3) {
          return t4(r4, e27, n4, i3);
        }), r4;
      }, dn2.unary = function(e26) {
        return ts2(e26, 1);
      }, dn2.union = _o2, dn2.unionBy = To2, dn2.unionWith = Po2, dn2.uniq = function(e26) {
        return e26 && e26.length ? Ri(e26) : [];
      }, dn2.uniqBy = function(e26, t4) {
        return e26 && e26.length ? Ri(e26, Na2(t4, 2)) : [];
      }, dn2.uniqWith = function(e26, t4) {
        return t4 = typeof t4 == "function" ? t4 : n2, e26 && e26.length ? Ri(e26, n2, t4) : [];
      }, dn2.unset = function(e26, t4) {
        return e26 == null || Mi2(e26, t4);
      }, dn2.unzip = Io2, dn2.unzipWith = Bo2, dn2.update = function(e26, t4, r4) {
        return e26 == null ? e26 : Vi2(e26, t4, zi2(r4));
      }, dn2.updateWith = function(e26, t4, r4, i2) {
        return i2 = typeof i2 == "function" ? i2 : n2, e26 == null ? e26 : Vi2(e26, t4, zi2(r4), i2);
      }, dn2.values = du2, dn2.valuesIn = function(e26) {
        return e26 == null ? [] : gr2(e26, ou2(e26));
      }, dn2.without = Oo2, dn2.words = Du2, dn2.wrap = function(e26, t4) {
        return ps(zi2(t4), e26);
      }, dn2.xor = Lo2, dn2.xorBy = No2, dn2.xorWith = jo2, dn2.zip = Ro2, dn2.zipObject = function(e26, t4) {
        return $i2(e26 || [], t4 || [], _n2);
      }, dn2.zipObjectDeep = function(e26, t4) {
        return $i2(e26 || [], t4 || [], Ai2);
      }, dn2.zipWith = Mo2, dn2.entries = fu2, dn2.entriesIn = hu2, dn2.extend = Ks2, dn2.extendWith = Js2, Lu2(dn2, dn2), dn2.add = Gu2, dn2.attempt = Fu2, dn2.camelCase = mu2, dn2.capitalize = gu2, dn2.ceil = zu2, dn2.clamp = function(e26, t4, r4) {
        return r4 === n2 && (r4 = t4, t4 = n2), r4 !== n2 && (r4 = (r4 = $s2(r4)) == r4 ? r4 : 0), t4 !== n2 && (t4 = (t4 = $s2(t4)) == t4 ? t4 : 0), Ln2($s2(e26), t4, r4);
      }, dn2.clone = function(e26) {
        return Nn2(e26, h2);
      }, dn2.cloneDeep = function(e26) {
        return Nn2(e26, p2 | h2);
      }, dn2.cloneDeepWith = function(e26, t4) {
        return Nn2(e26, p2 | h2, t4 = typeof t4 == "function" ? t4 : n2);
      }, dn2.cloneWith = function(e26, t4) {
        return Nn2(e26, h2, t4 = typeof t4 == "function" ? t4 : n2);
      }, dn2.conformsTo = function(e26, t4) {
        return t4 == null || jn2(e26, t4, au2(t4));
      }, dn2.deburr = yu2, dn2.defaultTo = function(e26, t4) {
        return e26 == null || e26 != e26 ? t4 : e26;
      }, dn2.divide = Hu2, dn2.endsWith = function(e26, t4, r4) {
        e26 = zs2(e26), t4 = ji(t4);
        var i2 = e26.length, a3 = r4 = r4 === n2 ? i2 : Ln2(qs2(r4), 0, i2);
        return (r4 -= t4.length) >= 0 && e26.slice(r4, a3) == t4;
      }, dn2.eq = ds, dn2.escape = function(e26) {
        return (e26 = zs2(e26)) && ke2.test(e26) ? e26.replace(Ce2, Er2) : e26;
      }, dn2.escapeRegExp = function(e26) {
        return (e26 = zs2(e26)) && Ie2.test(e26) ? e26.replace(Pe2, "\\$&") : e26;
      }, dn2.every = function(e26, t4, r4) {
        var i2 = vs(e26) ? Kt2 : qn2;
        return r4 && Ha2(e26, t4, r4) && (t4 = n2), i2(e26, Na2(t4, 3));
      }, dn2.find = $o2, dn2.findIndex = yo2, dn2.findKey = function(e26, t4) {
        return ir2(e26, Na2(t4, 3), Kn2);
      }, dn2.findLast = Go2, dn2.findLastIndex = vo2, dn2.findLastKey = function(e26, t4) {
        return ir2(e26, Na2(t4, 3), Jn2);
      }, dn2.floor = Ku2, dn2.forEach = zo2, dn2.forEachRight = Ho2, dn2.forIn = function(e26, t4) {
        return e26 == null ? e26 : zn(e26, Na2(t4, 3), ou2);
      }, dn2.forInRight = function(e26, t4) {
        return e26 == null ? e26 : Hn2(e26, Na2(t4, 3), ou2);
      }, dn2.forOwn = function(e26, t4) {
        return e26 && Kn2(e26, Na2(t4, 3));
      }, dn2.forOwnRight = function(e26, t4) {
        return e26 && Jn2(e26, Na2(t4, 3));
      }, dn2.get = eu2, dn2.gt = ms, dn2.gte = gs, dn2.has = function(e26, t4) {
        return e26 != null && Wa2(e26, t4, ti2);
      }, dn2.hasIn = tu2, dn2.head = bo2, dn2.identity = Pu2, dn2.includes = function(e26, t4, r4, n3) {
        e26 = bs2(e26) ? e26 : du2(e26), r4 = r4 && !n3 ? qs2(r4) : 0;
        var i2 = e26.length;
        return r4 < 0 && (r4 = Gr2(i2 + r4, 0)), Ls2(e26) ? r4 <= i2 && e26.indexOf(t4, r4) > -1 : !!i2 && or2(e26, t4, r4) > -1;
      }, dn2.indexOf = function(e26, t4, r4) {
        var n3 = e26 == null ? 0 : e26.length;
        if (!n3)
          return -1;
        var i2 = r4 == null ? 0 : qs2(r4);
        return i2 < 0 && (i2 = Gr2(n3 + i2, 0)), or2(e26, t4, i2);
      }, dn2.inRange = function(e26, t4, r4) {
        return t4 = Us2(t4), r4 === n2 ? (r4 = t4, t4 = 0) : r4 = Us2(r4), function(e27, t5, r5) {
          return e27 >= zr2(t5, r5) && e27 < Gr2(t5, r5);
        }(e26 = $s2(e26), t4, r4);
      }, dn2.invoke = iu2, dn2.isArguments = ys, dn2.isArray = vs, dn2.isArrayBuffer = xs, dn2.isArrayLike = bs2, dn2.isArrayLikeObject = Es2, dn2.isBoolean = function(e26) {
        return e26 === true || e26 === false || _s2(e26) && Zn2(e26) == W2;
      }, dn2.isBuffer = Cs2, dn2.isDate = Ss2, dn2.isElement = function(e26) {
        return _s2(e26) && e26.nodeType === 1 && !Is2(e26);
      }, dn2.isEmpty = function(e26) {
        if (e26 == null)
          return true;
        if (bs2(e26) && (vs(e26) || typeof e26 == "string" || typeof e26.splice == "function" || Cs2(e26) || js2(e26) || ys(e26)))
          return !e26.length;
        var t4 = qa2(e26);
        if (t4 == J2 || t4 == te2)
          return !e26.size;
        if (Xa2(e26))
          return !li2(e26).length;
        for (var r4 in e26)
          if (pt3.call(e26, r4))
            return false;
        return true;
      }, dn2.isEqual = function(e26, t4) {
        return oi2(e26, t4);
      }, dn2.isEqualWith = function(e26, t4, r4) {
        var i2 = (r4 = typeof r4 == "function" ? r4 : n2) ? r4(e26, t4) : n2;
        return i2 === n2 ? oi2(e26, t4, n2, r4) : !!i2;
      }, dn2.isError = ks2, dn2.isFinite = function(e26) {
        return typeof e26 == "number" && qr2(e26);
      }, dn2.isFunction = Ds2, dn2.isInteger = Fs2, dn2.isLength = As2, dn2.isMap = Ts2, dn2.isMatch = function(e26, t4) {
        return e26 === t4 || si2(e26, t4, Ra2(t4));
      }, dn2.isMatchWith = function(e26, t4, r4) {
        return r4 = typeof r4 == "function" ? r4 : n2, si2(e26, t4, Ra2(t4), r4);
      }, dn2.isNaN = function(e26) {
        return Ps2(e26) && e26 != +e26;
      }, dn2.isNative = function(e26) {
        if (Qa2(e26))
          throw new Ze3(o2);
        return ui2(e26);
      }, dn2.isNil = function(e26) {
        return e26 == null;
      }, dn2.isNull = function(e26) {
        return e26 === null;
      }, dn2.isNumber = Ps2, dn2.isObject = ws2, dn2.isObjectLike = _s2, dn2.isPlainObject = Is2, dn2.isRegExp = Bs2, dn2.isSafeInteger = function(e26) {
        return Fs2(e26) && e26 >= -B2 && e26 <= B2;
      }, dn2.isSet = Os2, dn2.isString = Ls2, dn2.isSymbol = Ns2, dn2.isTypedArray = js2, dn2.isUndefined = function(e26) {
        return e26 === n2;
      }, dn2.isWeakMap = function(e26) {
        return _s2(e26) && qa2(e26) == ae2;
      }, dn2.isWeakSet = function(e26) {
        return _s2(e26) && Zn2(e26) == oe2;
      }, dn2.join = function(e26, t4) {
        return e26 == null ? "" : Wr2.call(e26, t4);
      }, dn2.kebabCase = vu2, dn2.last = ko, dn2.lastIndexOf = function(e26, t4, r4) {
        var i2 = e26 == null ? 0 : e26.length;
        if (!i2)
          return -1;
        var a3 = i2;
        return r4 !== n2 && (a3 = (a3 = qs2(r4)) < 0 ? Gr2(i2 + a3, 0) : zr2(a3, i2 - 1)), t4 == t4 ? function(e27, t5, r5) {
          for (var n3 = r5 + 1; n3--; )
            if (e27[n3] === t5)
              return n3;
          return n3;
        }(e26, t4, a3) : ar2(e26, ur2, a3, true);
      }, dn2.lowerCase = xu2, dn2.lowerFirst = bu2, dn2.lt = Rs2, dn2.lte = Ms2, dn2.max = function(e26) {
        return e26 && e26.length ? Wn2(e26, Pu2, ei2) : n2;
      }, dn2.maxBy = function(e26, t4) {
        return e26 && e26.length ? Wn2(e26, Na2(t4, 2), ei2) : n2;
      }, dn2.mean = function(e26) {
        return cr2(e26, Pu2);
      }, dn2.meanBy = function(e26, t4) {
        return cr2(e26, Na2(t4, 2));
      }, dn2.min = function(e26) {
        return e26 && e26.length ? Wn2(e26, Pu2, fi2) : n2;
      }, dn2.minBy = function(e26, t4) {
        return e26 && e26.length ? Wn2(e26, Na2(t4, 2), fi2) : n2;
      }, dn2.stubArray = Wu2, dn2.stubFalse = $u2, dn2.stubObject = function() {
        return {};
      }, dn2.stubString = function() {
        return "";
      }, dn2.stubTrue = function() {
        return true;
      }, dn2.multiply = Qu2, dn2.nth = function(e26, t4) {
        return e26 && e26.length ? yi2(e26, qs2(t4)) : n2;
      }, dn2.noConflict = function() {
        return It2._ === this && (It2._ = gt3), this;
      }, dn2.noop = Nu2, dn2.now = es2, dn2.pad = function(e26, t4, r4) {
        e26 = zs2(e26);
        var n3 = (t4 = qs2(t4)) ? _r2(e26) : 0;
        if (!t4 || n3 >= t4)
          return e26;
        var i2 = (t4 - n3) / 2;
        return va2(Mr2(i2), r4) + e26 + va2(Rr2(i2), r4);
      }, dn2.padEnd = function(e26, t4, r4) {
        e26 = zs2(e26);
        var n3 = (t4 = qs2(t4)) ? _r2(e26) : 0;
        return t4 && n3 < t4 ? e26 + va2(t4 - n3, r4) : e26;
      }, dn2.padStart = function(e26, t4, r4) {
        e26 = zs2(e26);
        var n3 = (t4 = qs2(t4)) ? _r2(e26) : 0;
        return t4 && n3 < t4 ? va2(t4 - n3, r4) + e26 : e26;
      }, dn2.parseInt = function(e26, t4, r4) {
        return r4 || t4 == null ? t4 = 0 : t4 && (t4 = +t4), Kr2(zs2(e26).replace(Oe2, ""), t4 || 0);
      }, dn2.random = function(e26, t4, r4) {
        if (r4 && typeof r4 != "boolean" && Ha2(e26, t4, r4) && (t4 = r4 = n2), r4 === n2 && (typeof t4 == "boolean" ? (r4 = t4, t4 = n2) : typeof e26 == "boolean" && (r4 = e26, e26 = n2)), e26 === n2 && t4 === n2 ? (e26 = 0, t4 = 1) : (e26 = Us2(e26), t4 === n2 ? (t4 = e26, e26 = 0) : t4 = Us2(t4)), e26 > t4) {
          var i2 = e26;
          e26 = t4, t4 = i2;
        }
        if (r4 || e26 % 1 || t4 % 1) {
          var a3 = Jr2();
          return zr2(e26 + a3 * (t4 - e26 + wt2("1e-" + ((a3 + "").length - 1))), t4);
        }
        return Ci2(e26, t4);
      }, dn2.reduce = function(e26, t4, r4) {
        var n3 = vs(e26) ? er2 : fr2, i2 = arguments.length < 3;
        return n3(e26, Na2(t4, 4), r4, i2, Vn2);
      }, dn2.reduceRight = function(e26, t4, r4) {
        var n3 = vs(e26) ? tr2 : fr2, i2 = arguments.length < 3;
        return n3(e26, Na2(t4, 4), r4, i2, Un2);
      }, dn2.repeat = function(e26, t4, r4) {
        return t4 = (r4 ? Ha2(e26, t4, r4) : t4 === n2) ? 1 : qs2(t4), Si2(zs2(e26), t4);
      }, dn2.replace = function() {
        var e26 = arguments, t4 = zs2(e26[0]);
        return e26.length < 3 ? t4 : t4.replace(e26[1], e26[2]);
      }, dn2.result = function(e26, t4, r4) {
        var i2 = -1, a3 = (t4 = Hi2(t4, e26)).length;
        for (a3 || (a3 = 1, e26 = n2); ++i2 < a3; ) {
          var o3 = e26 == null ? n2 : e26[lo2(t4[i2])];
          o3 === n2 && (i2 = a3, o3 = r4), e26 = Ds2(o3) ? o3.call(e26) : o3;
        }
        return e26;
      }, dn2.round = Xu2, dn2.runInContext = e25, dn2.sample = function(e26) {
        return (vs(e26) ? Dn2 : Di2)(e26);
      }, dn2.size = function(e26) {
        if (e26 == null)
          return 0;
        if (bs2(e26))
          return Ls2(e26) ? _r2(e26) : e26.length;
        var t4 = qa2(e26);
        return t4 == J2 || t4 == te2 ? e26.size : li2(e26).length;
      }, dn2.snakeCase = Eu2, dn2.some = function(e26, t4, r4) {
        var i2 = vs(e26) ? rr2 : Ii2;
        return r4 && Ha2(e26, t4, r4) && (t4 = n2), i2(e26, Na2(t4, 3));
      }, dn2.sortedIndex = function(e26, t4) {
        return Bi2(e26, t4);
      }, dn2.sortedIndexBy = function(e26, t4, r4) {
        return Oi2(e26, t4, Na2(r4, 2));
      }, dn2.sortedIndexOf = function(e26, t4) {
        var r4 = e26 == null ? 0 : e26.length;
        if (r4) {
          var n3 = Bi2(e26, t4);
          if (n3 < r4 && ds(e26[n3], t4))
            return n3;
        }
        return -1;
      }, dn2.sortedLastIndex = function(e26, t4) {
        return Bi2(e26, t4, true);
      }, dn2.sortedLastIndexBy = function(e26, t4, r4) {
        return Oi2(e26, t4, Na2(r4, 2), true);
      }, dn2.sortedLastIndexOf = function(e26, t4) {
        if (e26 == null ? 0 : e26.length) {
          var r4 = Bi2(e26, t4, true) - 1;
          if (ds(e26[r4], t4))
            return r4;
        }
        return -1;
      }, dn2.startCase = Cu2, dn2.startsWith = function(e26, t4, r4) {
        return e26 = zs2(e26), r4 = r4 == null ? 0 : Ln2(qs2(r4), 0, e26.length), t4 = ji(t4), e26.slice(r4, r4 + t4.length) == t4;
      }, dn2.subtract = Yu2, dn2.sum = function(e26) {
        return e26 && e26.length ? hr2(e26, Pu2) : 0;
      }, dn2.sumBy = function(e26, t4) {
        return e26 && e26.length ? hr2(e26, Na2(t4, 2)) : 0;
      }, dn2.template = function(e26, t4, r4) {
        var i2 = dn2.templateSettings;
        r4 && Ha2(e26, t4, r4) && (t4 = n2), e26 = zs2(e26), t4 = Js2({}, t4, i2, Fa2);
        var a3, o3, s3 = Js2({}, t4.imports, i2.imports, Fa2), u3 = au2(s3), c3 = gr2(s3, u3), l3 = 0, p3 = t4.interpolate || Je2, f3 = "__p += '", h3 = nt3((t4.escape || Je2).source + "|" + p3.source + "|" + (p3 === Ae2 ? Ue2 : Je2).source + "|" + (t4.evaluate || Je2).source + "|$", "g"), d3 = "//# sourceURL=" + (pt3.call(t4, "sourceURL") ? (t4.sourceURL + "").replace(/[\r\n]/g, " ") : "lodash.templateSources[" + ++kt2 + "]") + "\n";
        e26.replace(h3, function(t5, r5, n3, i3, s4, u4) {
          return n3 || (n3 = i3), f3 += e26.slice(l3, u4).replace(Qe2, Cr), r5 && (a3 = true, f3 += "' +\n__e(" + r5 + ") +\n'"), s4 && (o3 = true, f3 += "';\n" + s4 + ";\n__p += '"), n3 && (f3 += "' +\n((__t = (" + n3 + ")) == null ? '' : __t) +\n'"), l3 = u4 + t5.length, t5;
        }), f3 += "';\n";
        var m3 = pt3.call(t4, "variable") && t4.variable;
        m3 || (f3 = "with (obj) {\n" + f3 + "\n}\n"), f3 = (o3 ? f3.replace(ve2, "") : f3).replace(xe2, "$1").replace(be2, "$1;"), f3 = "function(" + (m3 || "obj") + ") {\n" + (m3 ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (a3 ? ", __e = _.escape" : "") + (o3 ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + f3 + "return __p\n}";
        var g3 = Fu2(function() {
          return et3(u3, d3 + "return " + f3).apply(n2, c3);
        });
        if (g3.source = f3, ks2(g3))
          throw g3;
        return g3;
      }, dn2.times = function(e26, t4) {
        if ((e26 = qs2(e26)) < 1 || e26 > B2)
          return [];
        var r4 = N2, n3 = zr2(e26, N2);
        t4 = Na2(t4), e26 -= N2;
        for (var i2 = dr2(n3, t4); ++r4 < e26; )
          t4(r4);
        return i2;
      }, dn2.toFinite = Us2, dn2.toInteger = qs2, dn2.toLength = Ws2, dn2.toLower = function(e26) {
        return zs2(e26).toLowerCase();
      }, dn2.toNumber = $s2, dn2.toSafeInteger = function(e26) {
        return e26 ? Ln2(qs2(e26), -B2, B2) : e26 === 0 ? e26 : 0;
      }, dn2.toString = zs2, dn2.toUpper = function(e26) {
        return zs2(e26).toUpperCase();
      }, dn2.trim = function(e26, t4, r4) {
        if ((e26 = zs2(e26)) && (r4 || t4 === n2))
          return e26.replace(Be2, "");
        if (!e26 || !(t4 = ji(t4)))
          return e26;
        var i2 = Tr2(e26), a3 = Tr2(t4);
        return Ji2(i2, vr2(i2, a3), xr2(i2, a3) + 1).join("");
      }, dn2.trimEnd = function(e26, t4, r4) {
        if ((e26 = zs2(e26)) && (r4 || t4 === n2))
          return e26.replace(Le2, "");
        if (!e26 || !(t4 = ji(t4)))
          return e26;
        var i2 = Tr2(e26);
        return Ji2(i2, 0, xr2(i2, Tr2(t4)) + 1).join("");
      }, dn2.trimStart = function(e26, t4, r4) {
        if ((e26 = zs2(e26)) && (r4 || t4 === n2))
          return e26.replace(Oe2, "");
        if (!e26 || !(t4 = ji(t4)))
          return e26;
        var i2 = Tr2(e26);
        return Ji2(i2, vr2(i2, Tr2(t4))).join("");
      }, dn2.truncate = function(e26, t4) {
        var r4 = F2, i2 = A2;
        if (ws2(t4)) {
          var a3 = "separator" in t4 ? t4.separator : a3;
          r4 = "length" in t4 ? qs2(t4.length) : r4, i2 = "omission" in t4 ? ji(t4.omission) : i2;
        }
        var o3 = (e26 = zs2(e26)).length;
        if (Sr(e26)) {
          var s3 = Tr2(e26);
          o3 = s3.length;
        }
        if (r4 >= o3)
          return e26;
        var u3 = r4 - _r2(i2);
        if (u3 < 1)
          return i2;
        var c3 = s3 ? Ji2(s3, 0, u3).join("") : e26.slice(0, u3);
        if (a3 === n2)
          return c3 + i2;
        if (s3 && (u3 += c3.length - u3), Bs2(a3)) {
          if (e26.slice(u3).search(a3)) {
            var l3, p3 = c3;
            for (a3.global || (a3 = nt3(a3.source, zs2(qe2.exec(a3)) + "g")), a3.lastIndex = 0; l3 = a3.exec(p3); )
              var f3 = l3.index;
            c3 = c3.slice(0, f3 === n2 ? u3 : f3);
          }
        } else if (e26.indexOf(ji(a3), u3) != u3) {
          var h3 = c3.lastIndexOf(a3);
          h3 > -1 && (c3 = c3.slice(0, h3));
        }
        return c3 + i2;
      }, dn2.unescape = function(e26) {
        return (e26 = zs2(e26)) && Se2.test(e26) ? e26.replace(Ee2, Pr2) : e26;
      }, dn2.uniqueId = function(e26) {
        var t4 = ++ft3;
        return zs2(e26) + t4;
      }, dn2.upperCase = Su2, dn2.upperFirst = ku2, dn2.each = zo2, dn2.eachRight = Ho2, dn2.first = bo2, Lu2(dn2, (Ju2 = {}, Kn2(dn2, function(e26, t4) {
        pt3.call(dn2.prototype, t4) || (Ju2[t4] = e26);
      }), Ju2), { chain: false }), dn2.VERSION = "4.17.15", zt2(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e26) {
        dn2[e26].placeholder = dn2;
      }), zt2(["drop", "take"], function(e26, t4) {
        vn2.prototype[e26] = function(r4) {
          r4 = r4 === n2 ? 1 : Gr2(qs2(r4), 0);
          var i2 = this.__filtered__ && !t4 ? new vn2(this) : this.clone();
          return i2.__filtered__ ? i2.__takeCount__ = zr2(r4, i2.__takeCount__) : i2.__views__.push({ size: zr2(r4, N2), type: e26 + (i2.__dir__ < 0 ? "Right" : "") }), i2;
        }, vn2.prototype[e26 + "Right"] = function(t5) {
          return this.reverse()[e26](t5).reverse();
        };
      }), zt2(["filter", "map", "takeWhile"], function(e26, t4) {
        var r4 = t4 + 1, n3 = r4 == T2 || r4 == 3;
        vn2.prototype[e26] = function(e27) {
          var t5 = this.clone();
          return t5.__iteratees__.push({ iteratee: Na2(e27, 3), type: r4 }), t5.__filtered__ = t5.__filtered__ || n3, t5;
        };
      }), zt2(["head", "last"], function(e26, t4) {
        var r4 = "take" + (t4 ? "Right" : "");
        vn2.prototype[e26] = function() {
          return this[r4](1).value()[0];
        };
      }), zt2(["initial", "tail"], function(e26, t4) {
        var r4 = "drop" + (t4 ? "" : "Right");
        vn2.prototype[e26] = function() {
          return this.__filtered__ ? new vn2(this) : this[r4](1);
        };
      }), vn2.prototype.compact = function() {
        return this.filter(Pu2);
      }, vn2.prototype.find = function(e26) {
        return this.filter(e26).head();
      }, vn2.prototype.findLast = function(e26) {
        return this.reverse().find(e26);
      }, vn2.prototype.invokeMap = ki2(function(e26, t4) {
        return typeof e26 == "function" ? new vn2(this) : this.map(function(r4) {
          return ii2(r4, e26, t4);
        });
      }), vn2.prototype.reject = function(e26) {
        return this.filter(cs(Na2(e26)));
      }, vn2.prototype.slice = function(e26, t4) {
        e26 = qs2(e26);
        var r4 = this;
        return r4.__filtered__ && (e26 > 0 || t4 < 0) ? new vn2(r4) : (e26 < 0 ? r4 = r4.takeRight(-e26) : e26 && (r4 = r4.drop(e26)), t4 !== n2 && (r4 = (t4 = qs2(t4)) < 0 ? r4.dropRight(-t4) : r4.take(t4 - e26)), r4);
      }, vn2.prototype.takeRightWhile = function(e26) {
        return this.reverse().takeWhile(e26).reverse();
      }, vn2.prototype.toArray = function() {
        return this.take(N2);
      }, Kn2(vn2.prototype, function(e26, t4) {
        var r4 = /^(?:filter|find|map|reject)|While$/.test(t4), i2 = /^(?:head|last)$/.test(t4), a3 = dn2[i2 ? "take" + (t4 == "last" ? "Right" : "") : t4], o3 = i2 || /^find/.test(t4);
        a3 && (dn2.prototype[t4] = function() {
          var t5 = this.__wrapped__, s3 = i2 ? [1] : arguments, u3 = t5 instanceof vn2, c3 = s3[0], l3 = u3 || vs(t5), p3 = function(e27) {
            var t6 = a3.apply(dn2, Zt2([e27], s3));
            return i2 && f3 ? t6[0] : t6;
          };
          l3 && r4 && typeof c3 == "function" && c3.length != 1 && (u3 = l3 = false);
          var f3 = this.__chain__, h3 = !!this.__actions__.length, d3 = o3 && !f3, m3 = u3 && !h3;
          if (!o3 && l3) {
            t5 = m3 ? t5 : new vn2(this);
            var g3 = e26.apply(t5, s3);
            return g3.__actions__.push({ func: Uo2, args: [p3], thisArg: n2 }), new yn2(g3, f3);
          }
          return d3 && m3 ? e26.apply(this, s3) : (g3 = this.thru(p3), d3 ? i2 ? g3.value()[0] : g3.value() : g3);
        });
      }), zt2(["pop", "push", "shift", "sort", "splice", "unshift"], function(e26) {
        var t4 = ot3[e26], r4 = /^(?:push|sort|unshift)$/.test(e26) ? "tap" : "thru", n3 = /^(?:pop|shift)$/.test(e26);
        dn2.prototype[e26] = function() {
          var e27 = arguments;
          if (n3 && !this.__chain__) {
            var i2 = this.value();
            return t4.apply(vs(i2) ? i2 : [], e27);
          }
          return this[r4](function(r5) {
            return t4.apply(vs(r5) ? r5 : [], e27);
          });
        };
      }), Kn2(vn2.prototype, function(e26, t4) {
        var r4 = dn2[t4];
        if (r4) {
          var n3 = r4.name + "";
          pt3.call(an2, n3) || (an2[n3] = []), an2[n3].push({ name: t4, func: r4 });
        }
      }), an2[da2(n2, y2).name] = [{ name: "wrapper", func: n2 }], vn2.prototype.clone = function() {
        var e26 = new vn2(this.__wrapped__);
        return e26.__actions__ = na2(this.__actions__), e26.__dir__ = this.__dir__, e26.__filtered__ = this.__filtered__, e26.__iteratees__ = na2(this.__iteratees__), e26.__takeCount__ = this.__takeCount__, e26.__views__ = na2(this.__views__), e26;
      }, vn2.prototype.reverse = function() {
        if (this.__filtered__) {
          var e26 = new vn2(this);
          e26.__dir__ = -1, e26.__filtered__ = true;
        } else
          (e26 = this.clone()).__dir__ *= -1;
        return e26;
      }, vn2.prototype.value = function() {
        var e26 = this.__wrapped__.value(), t4 = this.__dir__, r4 = vs(e26), n3 = t4 < 0, i2 = r4 ? e26.length : 0, a3 = function(e27, t5, r5) {
          var n4 = -1, i3 = r5.length;
          for (; ++n4 < i3; ) {
            var a4 = r5[n4], o4 = a4.size;
            switch (a4.type) {
              case "drop":
                e27 += o4;
                break;
              case "dropRight":
                t5 -= o4;
                break;
              case "take":
                t5 = zr2(t5, e27 + o4);
                break;
              case "takeRight":
                e27 = Gr2(e27, t5 - o4);
            }
          }
          return { start: e27, end: t5 };
        }(0, i2, this.__views__), o3 = a3.start, s3 = a3.end, u3 = s3 - o3, c3 = n3 ? s3 : o3 - 1, l3 = this.__iteratees__, p3 = l3.length, f3 = 0, h3 = zr2(u3, this.__takeCount__);
        if (!r4 || !n3 && i2 == u3 && h3 == u3)
          return qi2(e26, this.__actions__);
        var d3 = [];
        e:
          for (; u3-- && f3 < h3; ) {
            for (var m3 = -1, g3 = e26[c3 += t4]; ++m3 < p3; ) {
              var y3 = l3[m3], v3 = y3.iteratee, x3 = y3.type, b3 = v3(g3);
              if (x3 == P2)
                g3 = b3;
              else if (!b3) {
                if (x3 == T2)
                  continue e;
                break e;
              }
            }
            d3[f3++] = g3;
          }
        return d3;
      }, dn2.prototype.at = qo2, dn2.prototype.chain = function() {
        return Vo2(this);
      }, dn2.prototype.commit = function() {
        return new yn2(this.value(), this.__chain__);
      }, dn2.prototype.next = function() {
        this.__values__ === n2 && (this.__values__ = Vs2(this.value()));
        var e26 = this.__index__ >= this.__values__.length;
        return { done: e26, value: e26 ? n2 : this.__values__[this.__index__++] };
      }, dn2.prototype.plant = function(e26) {
        for (var t4, r4 = this; r4 instanceof gn2; ) {
          var i2 = fo2(r4);
          i2.__index__ = 0, i2.__values__ = n2, t4 ? a3.__wrapped__ = i2 : t4 = i2;
          var a3 = i2;
          r4 = r4.__wrapped__;
        }
        return a3.__wrapped__ = e26, t4;
      }, dn2.prototype.reverse = function() {
        var e26 = this.__wrapped__;
        if (e26 instanceof vn2) {
          var t4 = e26;
          return this.__actions__.length && (t4 = new vn2(this)), (t4 = t4.reverse()).__actions__.push({ func: Uo2, args: [wo], thisArg: n2 }), new yn2(t4, this.__chain__);
        }
        return this.thru(wo);
      }, dn2.prototype.toJSON = dn2.prototype.valueOf = dn2.prototype.value = function() {
        return qi2(this.__wrapped__, this.__actions__);
      }, dn2.prototype.first = dn2.prototype.head, pr3 && (dn2.prototype[pr3] = function() {
        return this;
      }), dn2;
    }();
    Ot2 ? ((Ot2.exports = Ir2)._ = Ir2, Bt2._ = Ir2) : It2._ = Ir2;
  }).call(e);
}), Am = { Array: false, ArrayBuffer: false, Atomics: false, BigInt: false, BigInt64Array: false, BigUint64Array: false, Boolean: false, constructor: false, DataView: false, Date: false, decodeURI: false, decodeURIComponent: false, encodeURI: false, encodeURIComponent: false, Error: false, escape: false, eval: false, EvalError: false, Float32Array: false, Float64Array: false, Function: false, globalThis: false, hasOwnProperty: false, Infinity: false, Int16Array: false, Int32Array: false, Int8Array: false, isFinite: false, isNaN: false, isPrototypeOf: false, JSON: false, Map: false, Math: false, NaN: false, Number: false, Object: false, parseFloat: false, parseInt: false, Promise: false, propertyIsEnumerable: false, Proxy: false, RangeError: false, ReferenceError: false, Reflect: false, RegExp: false, Set: false, SharedArrayBuffer: false, String: false, Symbol: false, SyntaxError: false, toLocaleString: false, toString: false, TypeError: false, Uint16Array: false, Uint32Array: false, Uint8Array: false, Uint8ClampedArray: false, undefined: false, unescape: false, URIError: false, valueOf: false, WeakMap: false, WeakSet: false }, wm = { Array: false, Boolean: false, constructor: false, Date: false, decodeURI: false, decodeURIComponent: false, encodeURI: false, encodeURIComponent: false, Error: false, escape: false, eval: false, EvalError: false, Function: false, hasOwnProperty: false, Infinity: false, isFinite: false, isNaN: false, isPrototypeOf: false, JSON: false, Math: false, NaN: false, Number: false, Object: false, parseFloat: false, parseInt: false, propertyIsEnumerable: false, RangeError: false, ReferenceError: false, RegExp: false, String: false, SyntaxError: false, toLocaleString: false, toString: false, TypeError: false, undefined: false, unescape: false, URIError: false, valueOf: false }, _m = { Array: false, ArrayBuffer: false, Boolean: false, constructor: false, DataView: false, Date: false, decodeURI: false, decodeURIComponent: false, encodeURI: false, encodeURIComponent: false, Error: false, escape: false, eval: false, EvalError: false, Float32Array: false, Float64Array: false, Function: false, hasOwnProperty: false, Infinity: false, Int16Array: false, Int32Array: false, Int8Array: false, isFinite: false, isNaN: false, isPrototypeOf: false, JSON: false, Map: false, Math: false, NaN: false, Number: false, Object: false, parseFloat: false, parseInt: false, Promise: false, propertyIsEnumerable: false, Proxy: false, RangeError: false, ReferenceError: false, Reflect: false, RegExp: false, Set: false, String: false, Symbol: false, SyntaxError: false, toLocaleString: false, toString: false, TypeError: false, Uint16Array: false, Uint32Array: false, Uint8Array: false, Uint8ClampedArray: false, undefined: false, unescape: false, URIError: false, valueOf: false, WeakMap: false, WeakSet: false }, Tm = { Array: false, ArrayBuffer: false, Atomics: false, Boolean: false, constructor: false, DataView: false, Date: false, decodeURI: false, decodeURIComponent: false, encodeURI: false, encodeURIComponent: false, Error: false, escape: false, eval: false, EvalError: false, Float32Array: false, Float64Array: false, Function: false, hasOwnProperty: false, Infinity: false, Int16Array: false, Int32Array: false, Int8Array: false, isFinite: false, isNaN: false, isPrototypeOf: false, JSON: false, Map: false, Math: false, NaN: false, Number: false, Object: false, parseFloat: false, parseInt: false, Promise: false, propertyIsEnumerable: false, Proxy: false, RangeError: false, ReferenceError: false, Reflect: false, RegExp: false, Set: false, SharedArrayBuffer: false, String: false, Symbol: false, SyntaxError: false, toLocaleString: false, toString: false, TypeError: false, Uint16Array: false, Uint32Array: false, Uint8Array: false, Uint8ClampedArray: false, undefined: false, unescape: false, URIError: false, valueOf: false, WeakMap: false, WeakSet: false }, Pm = { AbortController: false, AbortSignal: false, addEventListener: false, alert: false, AnalyserNode: false, Animation: false, AnimationEffectReadOnly: false, AnimationEffectTiming: false, AnimationEffectTimingReadOnly: false, AnimationEvent: false, AnimationPlaybackEvent: false, AnimationTimeline: false, applicationCache: false, ApplicationCache: false, ApplicationCacheErrorEvent: false, atob: false, Attr: false, Audio: false, AudioBuffer: false, AudioBufferSourceNode: false, AudioContext: false, AudioDestinationNode: false, AudioListener: false, AudioNode: false, AudioParam: false, AudioProcessingEvent: false, AudioScheduledSourceNode: false, "AudioWorkletGlobalScope ": false, AudioWorkletNode: false, AudioWorkletProcessor: false, BarProp: false, BaseAudioContext: false, BatteryManager: false, BeforeUnloadEvent: false, BiquadFilterNode: false, Blob: false, BlobEvent: false, blur: false, BroadcastChannel: false, btoa: false, BudgetService: false, ByteLengthQueuingStrategy: false, Cache: false, caches: false, CacheStorage: false, cancelAnimationFrame: false, cancelIdleCallback: false, CanvasCaptureMediaStreamTrack: false, CanvasGradient: false, CanvasPattern: false, CanvasRenderingContext2D: false, ChannelMergerNode: false, ChannelSplitterNode: false, CharacterData: false, clearInterval: false, clearTimeout: false, clientInformation: false, ClipboardEvent: false, close: false, closed: false, CloseEvent: false, Comment: false, CompositionEvent: false, confirm: false, console: false, ConstantSourceNode: false, ConvolverNode: false, CountQueuingStrategy: false, createImageBitmap: false, Credential: false, CredentialsContainer: false, crypto: false, Crypto: false, CryptoKey: false, CSS: false, CSSConditionRule: false, CSSFontFaceRule: false, CSSGroupingRule: false, CSSImportRule: false, CSSKeyframeRule: false, CSSKeyframesRule: false, CSSMediaRule: false, CSSNamespaceRule: false, CSSPageRule: false, CSSRule: false, CSSRuleList: false, CSSStyleDeclaration: false, CSSStyleRule: false, CSSStyleSheet: false, CSSSupportsRule: false, CustomElementRegistry: false, customElements: false, CustomEvent: false, DataTransfer: false, DataTransferItem: false, DataTransferItemList: false, defaultstatus: false, defaultStatus: false, DelayNode: false, DeviceMotionEvent: false, DeviceOrientationEvent: false, devicePixelRatio: false, dispatchEvent: false, document: false, Document: false, DocumentFragment: false, DocumentType: false, DOMError: false, DOMException: false, DOMImplementation: false, DOMMatrix: false, DOMMatrixReadOnly: false, DOMParser: false, DOMPoint: false, DOMPointReadOnly: false, DOMQuad: false, DOMRect: false, DOMRectReadOnly: false, DOMStringList: false, DOMStringMap: false, DOMTokenList: false, DragEvent: false, DynamicsCompressorNode: false, Element: false, ErrorEvent: false, event: false, Event: false, EventSource: false, EventTarget: false, external: false, fetch: false, File: false, FileList: false, FileReader: false, find: false, focus: false, FocusEvent: false, FontFace: false, FontFaceSetLoadEvent: false, FormData: false, frameElement: false, frames: false, GainNode: false, Gamepad: false, GamepadButton: false, GamepadEvent: false, getComputedStyle: false, getSelection: false, HashChangeEvent: false, Headers: false, history: false, History: false, HTMLAllCollection: false, HTMLAnchorElement: false, HTMLAreaElement: false, HTMLAudioElement: false, HTMLBaseElement: false, HTMLBodyElement: false, HTMLBRElement: false, HTMLButtonElement: false, HTMLCanvasElement: false, HTMLCollection: false, HTMLContentElement: false, HTMLDataElement: false, HTMLDataListElement: false, HTMLDetailsElement: false, HTMLDialogElement: false, HTMLDirectoryElement: false, HTMLDivElement: false, HTMLDListElement: false, HTMLDocument: false, HTMLElement: false, HTMLEmbedElement: false, HTMLFieldSetElement: false, HTMLFontElement: false, HTMLFormControlsCollection: false, HTMLFormElement: false, HTMLFrameElement: false, HTMLFrameSetElement: false, HTMLHeadElement: false, HTMLHeadingElement: false, HTMLHRElement: false, HTMLHtmlElement: false, HTMLIFrameElement: false, HTMLImageElement: false, HTMLInputElement: false, HTMLLabelElement: false, HTMLLegendElement: false, HTMLLIElement: false, HTMLLinkElement: false, HTMLMapElement: false, HTMLMarqueeElement: false, HTMLMediaElement: false, HTMLMenuElement: false, HTMLMetaElement: false, HTMLMeterElement: false, HTMLModElement: false, HTMLObjectElement: false, HTMLOListElement: false, HTMLOptGroupElement: false, HTMLOptionElement: false, HTMLOptionsCollection: false, HTMLOutputElement: false, HTMLParagraphElement: false, HTMLParamElement: false, HTMLPictureElement: false, HTMLPreElement: false, HTMLProgressElement: false, HTMLQuoteElement: false, HTMLScriptElement: false, HTMLSelectElement: false, HTMLShadowElement: false, HTMLSlotElement: false, HTMLSourceElement: false, HTMLSpanElement: false, HTMLStyleElement: false, HTMLTableCaptionElement: false, HTMLTableCellElement: false, HTMLTableColElement: false, HTMLTableElement: false, HTMLTableRowElement: false, HTMLTableSectionElement: false, HTMLTemplateElement: false, HTMLTextAreaElement: false, HTMLTimeElement: false, HTMLTitleElement: false, HTMLTrackElement: false, HTMLUListElement: false, HTMLUnknownElement: false, HTMLVideoElement: false, IDBCursor: false, IDBCursorWithValue: false, IDBDatabase: false, IDBFactory: false, IDBIndex: false, IDBKeyRange: false, IDBObjectStore: false, IDBOpenDBRequest: false, IDBRequest: false, IDBTransaction: false, IDBVersionChangeEvent: false, IdleDeadline: false, IIRFilterNode: false, Image: false, ImageBitmap: false, ImageBitmapRenderingContext: false, ImageCapture: false, ImageData: false, indexedDB: false, innerHeight: false, innerWidth: false, InputEvent: false, IntersectionObserver: false, IntersectionObserverEntry: false, Intl: false, isSecureContext: false, KeyboardEvent: false, KeyframeEffect: false, KeyframeEffectReadOnly: false, length: false, localStorage: false, location: true, Location: false, locationbar: false, matchMedia: false, MediaDeviceInfo: false, MediaDevices: false, MediaElementAudioSourceNode: false, MediaEncryptedEvent: false, MediaError: false, MediaKeyMessageEvent: false, MediaKeySession: false, MediaKeyStatusMap: false, MediaKeySystemAccess: false, MediaList: false, MediaQueryList: false, MediaQueryListEvent: false, MediaRecorder: false, MediaSettingsRange: false, MediaSource: false, MediaStream: false, MediaStreamAudioDestinationNode: false, MediaStreamAudioSourceNode: false, MediaStreamEvent: false, MediaStreamTrack: false, MediaStreamTrackEvent: false, menubar: false, MessageChannel: false, MessageEvent: false, MessagePort: false, MIDIAccess: false, MIDIConnectionEvent: false, MIDIInput: false, MIDIInputMap: false, MIDIMessageEvent: false, MIDIOutput: false, MIDIOutputMap: false, MIDIPort: false, MimeType: false, MimeTypeArray: false, MouseEvent: false, moveBy: false, moveTo: false, MutationEvent: false, MutationObserver: false, MutationRecord: false, name: false, NamedNodeMap: false, NavigationPreloadManager: false, navigator: false, Navigator: false, NetworkInformation: false, Node: false, NodeFilter: false, NodeIterator: false, NodeList: false, Notification: false, OfflineAudioCompletionEvent: false, OfflineAudioContext: false, offscreenBuffering: false, OffscreenCanvas: true, onabort: true, onafterprint: true, onanimationend: true, onanimationiteration: true, onanimationstart: true, onappinstalled: true, onauxclick: true, onbeforeinstallprompt: true, onbeforeprint: true, onbeforeunload: true, onblur: true, oncancel: true, oncanplay: true, oncanplaythrough: true, onchange: true, onclick: true, onclose: true, oncontextmenu: true, oncuechange: true, ondblclick: true, ondevicemotion: true, ondeviceorientation: true, ondeviceorientationabsolute: true, ondrag: true, ondragend: true, ondragenter: true, ondragleave: true, ondragover: true, ondragstart: true, ondrop: true, ondurationchange: true, onemptied: true, onended: true, onerror: true, onfocus: true, ongotpointercapture: true, onhashchange: true, oninput: true, oninvalid: true, onkeydown: true, onkeypress: true, onkeyup: true, onlanguagechange: true, onload: true, onloadeddata: true, onloadedmetadata: true, onloadstart: true, onlostpointercapture: true, onmessage: true, onmessageerror: true, onmousedown: true, onmouseenter: true, onmouseleave: true, onmousemove: true, onmouseout: true, onmouseover: true, onmouseup: true, onmousewheel: true, onoffline: true, ononline: true, onpagehide: true, onpageshow: true, onpause: true, onplay: true, onplaying: true, onpointercancel: true, onpointerdown: true, onpointerenter: true, onpointerleave: true, onpointermove: true, onpointerout: true, onpointerover: true, onpointerup: true, onpopstate: true, onprogress: true, onratechange: true, onrejectionhandled: true, onreset: true, onresize: true, onscroll: true, onsearch: true, onseeked: true, onseeking: true, onselect: true, onstalled: true, onstorage: true, onsubmit: true, onsuspend: true, ontimeupdate: true, ontoggle: true, ontransitionend: true, onunhandledrejection: true, onunload: true, onvolumechange: true, onwaiting: true, onwheel: true, open: false, openDatabase: false, opener: false, Option: false, origin: false, OscillatorNode: false, outerHeight: false, outerWidth: false, PageTransitionEvent: false, pageXOffset: false, pageYOffset: false, PannerNode: false, parent: false, Path2D: false, PaymentAddress: false, PaymentRequest: false, PaymentRequestUpdateEvent: false, PaymentResponse: false, performance: false, Performance: false, PerformanceEntry: false, PerformanceLongTaskTiming: false, PerformanceMark: false, PerformanceMeasure: false, PerformanceNavigation: false, PerformanceNavigationTiming: false, PerformanceObserver: false, PerformanceObserverEntryList: false, PerformancePaintTiming: false, PerformanceResourceTiming: false, PerformanceTiming: false, PeriodicWave: false, Permissions: false, PermissionStatus: false, personalbar: false, PhotoCapabilities: false, Plugin: false, PluginArray: false, PointerEvent: false, PopStateEvent: false, postMessage: false, Presentation: false, PresentationAvailability: false, PresentationConnection: false, PresentationConnectionAvailableEvent: false, PresentationConnectionCloseEvent: false, PresentationConnectionList: false, PresentationReceiver: false, PresentationRequest: false, print: false, ProcessingInstruction: false, ProgressEvent: false, PromiseRejectionEvent: false, prompt: false, PushManager: false, PushSubscription: false, PushSubscriptionOptions: false, queueMicrotask: false, RadioNodeList: false, Range: false, ReadableStream: false, registerProcessor: false, RemotePlayback: false, removeEventListener: false, Request: false, requestAnimationFrame: false, requestIdleCallback: false, resizeBy: false, ResizeObserver: false, ResizeObserverEntry: false, resizeTo: false, Response: false, RTCCertificate: false, RTCDataChannel: false, RTCDataChannelEvent: false, RTCDtlsTransport: false, RTCIceCandidate: false, RTCIceGatherer: false, RTCIceTransport: false, RTCPeerConnection: false, RTCPeerConnectionIceEvent: false, RTCRtpContributingSource: false, RTCRtpReceiver: false, RTCRtpSender: false, RTCSctpTransport: false, RTCSessionDescription: false, RTCStatsReport: false, RTCTrackEvent: false, screen: false, Screen: false, screenLeft: false, ScreenOrientation: false, screenTop: false, screenX: false, screenY: false, ScriptProcessorNode: false, scroll: false, scrollbars: false, scrollBy: false, scrollTo: false, scrollX: false, scrollY: false, SecurityPolicyViolationEvent: false, Selection: false, self: false, ServiceWorker: false, ServiceWorkerContainer: false, ServiceWorkerRegistration: false, sessionStorage: false, setInterval: false, setTimeout: false, ShadowRoot: false, SharedWorker: false, SourceBuffer: false, SourceBufferList: false, speechSynthesis: false, SpeechSynthesisEvent: false, SpeechSynthesisUtterance: false, StaticRange: false, status: false, statusbar: false, StereoPannerNode: false, stop: false, Storage: false, StorageEvent: false, StorageManager: false, styleMedia: false, StyleSheet: false, StyleSheetList: false, SubtleCrypto: false, SVGAElement: false, SVGAngle: false, SVGAnimatedAngle: false, SVGAnimatedBoolean: false, SVGAnimatedEnumeration: false, SVGAnimatedInteger: false, SVGAnimatedLength: false, SVGAnimatedLengthList: false, SVGAnimatedNumber: false, SVGAnimatedNumberList: false, SVGAnimatedPreserveAspectRatio: false, SVGAnimatedRect: false, SVGAnimatedString: false, SVGAnimatedTransformList: false, SVGAnimateElement: false, SVGAnimateMotionElement: false, SVGAnimateTransformElement: false, SVGAnimationElement: false, SVGCircleElement: false, SVGClipPathElement: false, SVGComponentTransferFunctionElement: false, SVGDefsElement: false, SVGDescElement: false, SVGDiscardElement: false, SVGElement: false, SVGEllipseElement: false, SVGFEBlendElement: false, SVGFEColorMatrixElement: false, SVGFEComponentTransferElement: false, SVGFECompositeElement: false, SVGFEConvolveMatrixElement: false, SVGFEDiffuseLightingElement: false, SVGFEDisplacementMapElement: false, SVGFEDistantLightElement: false, SVGFEDropShadowElement: false, SVGFEFloodElement: false, SVGFEFuncAElement: false, SVGFEFuncBElement: false, SVGFEFuncGElement: false, SVGFEFuncRElement: false, SVGFEGaussianBlurElement: false, SVGFEImageElement: false, SVGFEMergeElement: false, SVGFEMergeNodeElement: false, SVGFEMorphologyElement: false, SVGFEOffsetElement: false, SVGFEPointLightElement: false, SVGFESpecularLightingElement: false, SVGFESpotLightElement: false, SVGFETileElement: false, SVGFETurbulenceElement: false, SVGFilterElement: false, SVGForeignObjectElement: false, SVGGElement: false, SVGGeometryElement: false, SVGGradientElement: false, SVGGraphicsElement: false, SVGImageElement: false, SVGLength: false, SVGLengthList: false, SVGLinearGradientElement: false, SVGLineElement: false, SVGMarkerElement: false, SVGMaskElement: false, SVGMatrix: false, SVGMetadataElement: false, SVGMPathElement: false, SVGNumber: false, SVGNumberList: false, SVGPathElement: false, SVGPatternElement: false, SVGPoint: false, SVGPointList: false, SVGPolygonElement: false, SVGPolylineElement: false, SVGPreserveAspectRatio: false, SVGRadialGradientElement: false, SVGRect: false, SVGRectElement: false, SVGScriptElement: false, SVGSetElement: false, SVGStopElement: false, SVGStringList: false, SVGStyleElement: false, SVGSVGElement: false, SVGSwitchElement: false, SVGSymbolElement: false, SVGTextContentElement: false, SVGTextElement: false, SVGTextPathElement: false, SVGTextPositioningElement: false, SVGTitleElement: false, SVGTransform: false, SVGTransformList: false, SVGTSpanElement: false, SVGUnitTypes: false, SVGUseElement: false, SVGViewElement: false, TaskAttributionTiming: false, Text: false, TextDecoder: false, TextEncoder: false, TextEvent: false, TextMetrics: false, TextTrack: false, TextTrackCue: false, TextTrackCueList: false, TextTrackList: false, TimeRanges: false, toolbar: false, top: false, Touch: false, TouchEvent: false, TouchList: false, TrackEvent: false, TransitionEvent: false, TreeWalker: false, UIEvent: false, URL: false, URLSearchParams: false, ValidityState: false, visualViewport: false, VisualViewport: false, VTTCue: false, WaveShaperNode: false, WebAssembly: false, WebGL2RenderingContext: false, WebGLActiveInfo: false, WebGLBuffer: false, WebGLContextEvent: false, WebGLFramebuffer: false, WebGLProgram: false, WebGLQuery: false, WebGLRenderbuffer: false, WebGLRenderingContext: false, WebGLSampler: false, WebGLShader: false, WebGLShaderPrecisionFormat: false, WebGLSync: false, WebGLTexture: false, WebGLTransformFeedback: false, WebGLUniformLocation: false, WebGLVertexArrayObject: false, WebSocket: false, WheelEvent: false, window: false, Window: false, Worker: false, WritableStream: false, XMLDocument: false, XMLHttpRequest: false, XMLHttpRequestEventTarget: false, XMLHttpRequestUpload: false, XMLSerializer: false, XPathEvaluator: false, XPathExpression: false, XPathResult: false, XSLTProcessor: false }, Im = { addEventListener: false, applicationCache: false, atob: false, Blob: false, BroadcastChannel: false, btoa: false, Cache: false, caches: false, clearInterval: false, clearTimeout: false, close: true, console: false, fetch: false, FileReaderSync: false, FormData: false, Headers: false, IDBCursor: false, IDBCursorWithValue: false, IDBDatabase: false, IDBFactory: false, IDBIndex: false, IDBKeyRange: false, IDBObjectStore: false, IDBOpenDBRequest: false, IDBRequest: false, IDBTransaction: false, IDBVersionChangeEvent: false, ImageData: false, importScripts: true, indexedDB: false, location: false, MessageChannel: false, MessagePort: false, name: false, navigator: false, Notification: false, onclose: true, onconnect: true, onerror: true, onlanguagechange: true, onmessage: true, onoffline: true, ononline: true, onrejectionhandled: true, onunhandledrejection: true, performance: false, Performance: false, PerformanceEntry: false, PerformanceMark: false, PerformanceMeasure: false, PerformanceNavigation: false, PerformanceResourceTiming: false, PerformanceTiming: false, postMessage: true, Promise: false, queueMicrotask: false, removeEventListener: false, Request: false, Response: false, self: true, ServiceWorkerRegistration: false, setInterval: false, setTimeout: false, TextDecoder: false, TextEncoder: false, URL: false, URLSearchParams: false, WebSocket: false, Worker: false, WorkerGlobalScope: false, XMLHttpRequest: false }, Bm = { __dirname: false, __filename: false, Buffer: false, clearImmediate: false, clearInterval: false, clearTimeout: false, console: false, exports: true, global: false, Intl: false, module: false, process: false, queueMicrotask: false, require: false, setImmediate: false, setInterval: false, setTimeout: false, TextDecoder: false, TextEncoder: false, URL: false, URLSearchParams: false }, Om = { exports: true, global: false, module: false, require: false }, Lm = { define: false, require: false }, Nm = { after: false, afterEach: false, before: false, beforeEach: false, context: false, describe: false, it: false, mocha: false, run: false, setup: false, specify: false, suite: false, suiteSetup: false, suiteTeardown: false, teardown: false, test: false, xcontext: false, xdescribe: false, xit: false, xspecify: false }, jm = { afterAll: false, afterEach: false, beforeAll: false, beforeEach: false, describe: false, expect: false, expectAsync: false, fail: false, fdescribe: false, fit: false, it: false, jasmine: false, pending: false, runs: false, spyOn: false, spyOnAllFunctions: false, spyOnProperty: false, waits: false, waitsFor: false, xdescribe: false, xit: false }, Rm = { afterAll: false, afterEach: false, beforeAll: false, beforeEach: false, describe: false, expect: false, fdescribe: false, fit: false, it: false, jest: false, pit: false, require: false, test: false, xdescribe: false, xit: false, xtest: false }, Mm = { asyncTest: false, deepEqual: false, equal: false, expect: false, module: false, notDeepEqual: false, notEqual: false, notOk: false, notPropEqual: false, notStrictEqual: false, ok: false, propEqual: false, QUnit: false, raises: false, start: false, stop: false, strictEqual: false, test: false, throws: false }, Vm = { console: true, exports: true, phantom: true, require: true, WebPage: true }, Um = { emit: false, exports: false, getRow: false, log: false, module: false, provides: false, require: false, respond: false, send: false, start: false, sum: false }, qm = { defineClass: false, deserialize: false, gc: false, help: false, importClass: false, importPackage: false, java: false, load: false, loadClass: false, Packages: false, print: false, quit: false, readFile: false, readUrl: false, runCommand: false, seal: false, serialize: false, spawn: false, sync: false, toint32: false, version: false }, Wm = { __DIR__: false, __FILE__: false, __LINE__: false, com: false, edu: false, exit: false, java: false, Java: false, javafx: false, JavaImporter: false, javax: false, JSAdapter: false, load: false, loadWithNewGlobal: false, org: false, Packages: false, print: false, quit: false }, $m = { ActiveXObject: true, CollectGarbage: true, Debug: true, Enumerator: true, GetObject: true, RuntimeObject: true, ScriptEngine: true, ScriptEngineBuildVersion: true, ScriptEngineMajorVersion: true, ScriptEngineMinorVersion: true, VBArray: true, WScript: true, WSH: true, XDomainRequest: true }, Gm = { $: false, jQuery: false }, zm = { YAHOO: false, YAHOO_config: false, YUI: false, YUI_config: false }, Hm = { cat: false, cd: false, chmod: false, config: false, cp: false, dirs: false, echo: false, env: false, error: false, exec: false, exit: false, find: false, grep: false, ln: false, ls: false, mkdir: false, mv: false, popd: false, pushd: false, pwd: false, rm: false, sed: false, set: false, target: false, tempdir: false, test: false, touch: false, which: false }, Km = { $: false, $$: false, $A: false, $break: false, $continue: false, $F: false, $H: false, $R: false, $w: false, Abstract: false, Ajax: false, Autocompleter: false, Builder: false, Class: false, Control: false, Draggable: false, Draggables: false, Droppables: false, Effect: false, Element: false, Enumerable: false, Event: false, Field: false, Form: false, Hash: false, Insertion: false, ObjectRange: false, PeriodicalExecuter: false, Position: false, Prototype: false, Scriptaculous: false, Selector: false, Sortable: false, SortableObserver: false, Sound: false, Template: false, Toggle: false, Try: false }, Jm = { _: false, $: false, Accounts: false, AccountsClient: false, AccountsCommon: false, AccountsServer: false, App: false, Assets: false, Blaze: false, check: false, Cordova: false, DDP: false, DDPRateLimiter: false, DDPServer: false, Deps: false, EJSON: false, Email: false, HTTP: false, Log: false, Match: false, Meteor: false, Mongo: false, MongoInternals: false, Npm: false, Package: false, Plugin: false, process: false, Random: false, ReactiveDict: false, ReactiveVar: false, Router: false, ServiceConfiguration: false, Session: false, share: false, Spacebars: false, Template: false, Tinytest: false, Tracker: false, UI: false, Utils: false, WebApp: false, WebAppInternals: false }, Qm = { _isWindows: false, _rand: false, BulkWriteResult: false, cat: false, cd: false, connect: false, db: false, getHostName: false, getMemInfo: false, hostname: false, ISODate: false, listFiles: false, load: false, ls: false, md5sumFile: false, mkdir: false, Mongo: false, NumberInt: false, NumberLong: false, ObjectId: false, PlanCache: false, print: false, printjson: false, pwd: false, quit: false, removeFile: false, rs: false, sh: false, UUID: false, version: false, WriteResult: false }, Xm = { $: false, Application: false, Automation: false, console: false, delay: false, Library: false, ObjC: false, ObjectSpecifier: false, Path: false, Progress: false, Ref: false }, Ym = { addEventListener: false, applicationCache: false, atob: false, Blob: false, BroadcastChannel: false, btoa: false, Cache: false, caches: false, CacheStorage: false, clearInterval: false, clearTimeout: false, Client: false, clients: false, Clients: false, close: true, console: false, ExtendableEvent: false, ExtendableMessageEvent: false, fetch: false, FetchEvent: false, FileReaderSync: false, FormData: false, Headers: false, IDBCursor: false, IDBCursorWithValue: false, IDBDatabase: false, IDBFactory: false, IDBIndex: false, IDBKeyRange: false, IDBObjectStore: false, IDBOpenDBRequest: false, IDBRequest: false, IDBTransaction: false, IDBVersionChangeEvent: false, ImageData: false, importScripts: false, indexedDB: false, location: false, MessageChannel: false, MessagePort: false, name: false, navigator: false, Notification: false, onclose: true, onconnect: true, onerror: true, onfetch: true, oninstall: true, onlanguagechange: true, onmessage: true, onmessageerror: true, onnotificationclick: true, onnotificationclose: true, onoffline: true, ononline: true, onpush: true, onpushsubscriptionchange: true, onrejectionhandled: true, onsync: true, onunhandledrejection: true, performance: false, Performance: false, PerformanceEntry: false, PerformanceMark: false, PerformanceMeasure: false, PerformanceNavigation: false, PerformanceResourceTiming: false, PerformanceTiming: false, postMessage: true, Promise: false, queueMicrotask: false, registration: false, removeEventListener: false, Request: false, Response: false, self: false, ServiceWorker: false, ServiceWorkerContainer: false, ServiceWorkerGlobalScope: false, ServiceWorkerMessageEvent: false, ServiceWorkerRegistration: false, setInterval: false, setTimeout: false, skipWaiting: false, TextDecoder: false, TextEncoder: false, URL: false, URLSearchParams: false, WebSocket: false, WindowClient: false, Worker: false, WorkerGlobalScope: false, XMLHttpRequest: false }, Zm = { advanceClock: false, fakeClearInterval: false, fakeClearTimeout: false, fakeSetInterval: false, fakeSetTimeout: false, resetTimeouts: false, waitsForPromise: false }, eg = { andThen: false, click: false, currentPath: false, currentRouteName: false, currentURL: false, fillIn: false, find: false, findAll: false, findWithAssert: false, keyEvent: false, pauseTest: false, resumeTest: false, triggerEvent: false, visit: false, wait: false }, tg = { $: false, $$: false, browser: false, by: false, By: false, DartObject: false, element: false, protractor: false }, rg = { browser: false, chrome: false, opr: false }, ng = { cloneInto: false, createObjectIn: false, exportFunction: false, GM: false, GM_addStyle: false, GM_deleteValue: false, GM_getResourceText: false, GM_getResourceURL: false, GM_getValue: false, GM_info: false, GM_listValues: false, GM_log: false, GM_openInTab: false, GM_registerMenuCommand: false, GM_setClipboard: false, GM_setValue: false, GM_xmlhttpRequest: false, unsafeWindow: false }, ig = { $: false, $_: false, $$: false, $0: false, $1: false, $2: false, $3: false, $4: false, $x: false, chrome: false, clear: false, copy: false, debug: false, dir: false, dirxml: false, getEventListeners: false, inspect: false, keys: false, monitor: false, monitorEvents: false, profile: false, profileEnd: false, queryObjects: false, table: false, undebug: false, unmonitor: false, unmonitorEvents: false, values: false }, ag = { builtin: Am, es5: wm, es2015: _m, es2017: Tm, browser: Pm, worker: Im, node: Bm, commonjs: Om, amd: Lm, mocha: Nm, jasmine: jm, jest: Rm, qunit: Mm, phantomjs: Vm, couch: Um, rhino: qm, nashorn: Wm, wsh: $m, jquery: Gm, yui: zm, shelljs: Hm, prototypejs: Km, meteor: Jm, mongo: Qm, applescript: Xm, serviceworker: Ym, atomtest: Zm, embertest: eg, protractor: tg, "shared-node-browser": { clearInterval: false, clearTimeout: false, console: false, setInterval: false, setTimeout: false, URL: false, URLSearchParams: false }, webextensions: rg, greasemonkey: ng, devtools: ig }, og = n(Object.freeze({ __proto__: null, builtin: Am, es5: wm, es2015: _m, es2017: Tm, browser: Pm, worker: Im, node: Bm, commonjs: Om, amd: Lm, mocha: Nm, jasmine: jm, jest: Rm, qunit: Mm, phantomjs: Vm, couch: Um, rhino: qm, nashorn: Wm, wsh: $m, jquery: Gm, yui: zm, shelljs: Hm, prototypejs: Km, meteor: Jm, mongo: Qm, applescript: Xm, serviceworker: Ym, atomtest: Zm, embertest: eg, protractor: tg, webextensions: rg, greasemonkey: ng, devtools: ig, default: ag })), sg = 1e3, ug = 60 * sg, cg = 60 * ug, lg = 24 * cg, pg = 7 * lg, fg = 365.25 * lg, hg = function(e25, t2) {
  t2 = t2 || {};
  var r2 = i(e25);
  if (r2 === "string" && e25.length > 0)
    return function(e26) {
      if ((e26 = String(e26)).length > 100)
        return;
      var t3 = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(e26);
      if (!t3)
        return;
      var r3 = parseFloat(t3[1]);
      switch ((t3[2] || "ms").toLowerCase()) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return r3 * fg;
        case "weeks":
        case "week":
        case "w":
          return r3 * pg;
        case "days":
        case "day":
        case "d":
          return r3 * lg;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return r3 * cg;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return r3 * ug;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return r3 * sg;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return r3;
        default:
          return;
      }
    }(e25);
  if (r2 === "number" && isFinite(e25))
    return t2.long ? function(e26) {
      var t3 = Math.abs(e26);
      if (t3 >= lg)
        return dg(e26, t3, lg, "day");
      if (t3 >= cg)
        return dg(e26, t3, cg, "hour");
      if (t3 >= ug)
        return dg(e26, t3, ug, "minute");
      if (t3 >= sg)
        return dg(e26, t3, sg, "second");
      return e26 + " ms";
    }(e25) : function(e26) {
      var t3 = Math.abs(e26);
      if (t3 >= lg)
        return Math.round(e26 / lg) + "d";
      if (t3 >= cg)
        return Math.round(e26 / cg) + "h";
      if (t3 >= ug)
        return Math.round(e26 / ug) + "m";
      if (t3 >= sg)
        return Math.round(e26 / sg) + "s";
      return e26 + "ms";
    }(e25);
  throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e25));
};
function dg(e25, t2, r2, n2) {
  var i2 = t2 >= 1.5 * r2;
  return Math.round(e25 / r2) + " " + n2 + (i2 ? "s" : "");
}
var mg = function(e25) {
  function t2(e26) {
    for (var t3 = 0, n3 = 0; n3 < e26.length; n3++)
      t3 = (t3 << 5) - t3 + e26.charCodeAt(n3), t3 |= 0;
    return r2.colors[Math.abs(t3) % r2.colors.length];
  }
  function r2(e26) {
    var a3;
    function o2() {
      for (var e27 = arguments.length, t3 = new Array(e27), n3 = 0; n3 < e27; n3++)
        t3[n3] = arguments[n3];
      if (o2.enabled) {
        var i3 = o2, s2 = Number(new Date()), u2 = s2 - (a3 || s2);
        i3.diff = u2, i3.prev = a3, i3.curr = s2, a3 = s2, t3[0] = r2.coerce(t3[0]), typeof t3[0] != "string" && t3.unshift("%O");
        var c2 = 0;
        t3[0] = t3[0].replace(/%([a-zA-Z%])/g, function(e28, n4) {
          if (e28 === "%%")
            return e28;
          c2++;
          var a4 = r2.formatters[n4];
          if (typeof a4 == "function") {
            var o3 = t3[c2];
            e28 = a4.call(i3, o3), t3.splice(c2, 1), c2--;
          }
          return e28;
        }), r2.formatArgs.call(i3, t3), (i3.log || r2.log).apply(i3, t3);
      }
    }
    return o2.namespace = e26, o2.enabled = r2.enabled(e26), o2.useColors = r2.useColors(), o2.color = t2(e26), o2.destroy = n2, o2.extend = i2, typeof r2.init == "function" && r2.init(o2), r2.instances.push(o2), o2;
  }
  function n2() {
    var e26 = r2.instances.indexOf(this);
    return e26 !== -1 && (r2.instances.splice(e26, 1), true);
  }
  function i2(e26, t3) {
    var n3 = r2(this.namespace + (t3 === void 0 ? ":" : t3) + e26);
    return n3.log = this.log, n3;
  }
  function a2(e26) {
    return e26.toString().substring(2, e26.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  return r2.debug = r2, r2.default = r2, r2.coerce = function(e26) {
    if (e26 instanceof Error)
      return e26.stack || e26.message;
    return e26;
  }, r2.disable = function() {
    var e26 = [].concat(E(r2.names.map(a2)), E(r2.skips.map(a2).map(function(e27) {
      return "-" + e27;
    }))).join(",");
    return r2.enable(""), e26;
  }, r2.enable = function(e26) {
    var t3;
    r2.save(e26), r2.names = [], r2.skips = [];
    var n3 = (typeof e26 == "string" ? e26 : "").split(/[\s,]+/), i3 = n3.length;
    for (t3 = 0; t3 < i3; t3++)
      n3[t3] && ((e26 = n3[t3].replace(/\*/g, ".*?"))[0] === "-" ? r2.skips.push(new RegExp("^" + e26.substr(1) + "$")) : r2.names.push(new RegExp("^" + e26 + "$")));
    for (t3 = 0; t3 < r2.instances.length; t3++) {
      var a3 = r2.instances[t3];
      a3.enabled = r2.enabled(a3.namespace);
    }
  }, r2.enabled = function(e26) {
    if (e26[e26.length - 1] === "*")
      return true;
    var t3, n3;
    for (t3 = 0, n3 = r2.skips.length; t3 < n3; t3++)
      if (r2.skips[t3].test(e26))
        return false;
    for (t3 = 0, n3 = r2.names.length; t3 < n3; t3++)
      if (r2.names[t3].test(e26))
        return true;
    return false;
  }, r2.humanize = hg, Object.keys(e25).forEach(function(t3) {
    r2[t3] = e25[t3];
  }), r2.instances = [], r2.names = [], r2.skips = [], r2.formatters = {}, r2.selectColor = t2, r2.enable(r2.load()), r2;
}, gg = r(function(e25, t2) {
  t2.log = function() {
    var e26;
    return (typeof console == "undefined" ? "undefined" : i(console)) === "object" && console.log && (e26 = console).log.apply(e26, arguments);
  }, t2.formatArgs = function(t3) {
    if (t3[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + t3[0] + (this.useColors ? "%c " : " ") + "+" + e25.exports.humanize(this.diff), !this.useColors)
      return;
    var r2 = "color: " + this.color;
    t3.splice(1, 0, r2, "color: inherit");
    var n2 = 0, i2 = 0;
    t3[0].replace(/%[a-zA-Z%]/g, function(e26) {
      e26 !== "%%" && (n2++, e26 === "%c" && (i2 = n2));
    }), t3.splice(i2, 0, r2);
  }, t2.save = function(e26) {
    try {
      e26 ? t2.storage.setItem("debug", e26) : t2.storage.removeItem("debug");
    } catch (e27) {
    }
  }, t2.load = function() {
    var e26;
    try {
      e26 = t2.storage.getItem("debug");
    } catch (e27) {
    }
    !e26 && typeof process != "undefined" && "env" in process && (e26 = {}.DEBUG);
    return e26;
  }, t2.useColors = function() {
    if (typeof window != "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs))
      return true;
    if (typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/))
      return false;
    return typeof document != "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window != "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }, t2.storage = function() {
    try {
      return localStorage;
    } catch (e26) {
    }
  }(), t2.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], e25.exports = mg(t2), e25.exports.formatters.j = function(e26) {
    try {
      return JSON.stringify(e26);
    } catch (e27) {
      return "[UnexpectedJSONParseError]: " + e27.message;
    }
  };
});
gg.log, gg.formatArgs, gg.save, gg.load, gg.useColors, gg.storage, gg.colors;
function yg(e25, t2) {
  var r2 = t2.range[0], n2 = e25, i2 = false;
  do {
    i2 = false;
    var a2 = true, o2 = false, s2 = void 0;
    try {
      for (var u2, c2 = n2.childScopes[Symbol.iterator](); !(a2 = (u2 = c2.next()).done); a2 = true) {
        var l2 = u2.value, p2 = l2.block.range;
        if (p2[0] <= r2 && r2 < p2[1]) {
          n2 = l2, i2 = true;
          break;
        }
      }
    } catch (e26) {
      o2 = true, s2 = e26;
    } finally {
      try {
        a2 || c2.return == null || c2.return();
      } finally {
        if (o2)
          throw s2;
      }
    }
  } while (i2);
  return n2;
}
function vg(e25, t2) {
  var r2 = "", n2 = e25;
  for (typeof t2 == "string" ? r2 = t2 : (r2 = t2.name, n2 = yg(n2, t2)); n2 != null; ) {
    var i2 = n2.set.get(r2);
    if (i2 != null)
      return i2;
    n2 = n2.upper;
  }
  return null;
}
function xg(e25) {
  return !this(e25);
}
function bg(e25) {
  return xg.bind(e25);
}
function Eg(e25) {
  return e25.value === "=>" && e25.type === "Punctuator";
}
function Cg(e25) {
  return e25.value === "," && e25.type === "Punctuator";
}
function Sg(e25) {
  return e25.value === ";" && e25.type === "Punctuator";
}
function kg(e25) {
  return e25.value === ":" && e25.type === "Punctuator";
}
function Dg(e25) {
  return e25.value === "(" && e25.type === "Punctuator";
}
function Fg(e25) {
  return e25.value === ")" && e25.type === "Punctuator";
}
function Ag(e25) {
  return e25.value === "[" && e25.type === "Punctuator";
}
function wg(e25) {
  return e25.value === "]" && e25.type === "Punctuator";
}
function _g(e25) {
  return e25.value === "{" && e25.type === "Punctuator";
}
function Tg(e25) {
  return e25.value === "}" && e25.type === "Punctuator";
}
function Pg(e25) {
  return e25.type === "Line" || e25.type === "Block" || e25.type === "Shebang";
}
var Ig = bg(Eg), Bg = bg(Cg), Og = bg(Sg), Lg = bg(kg), Ng = bg(Dg), jg = bg(Fg), Rg = bg(Ag), Mg = bg(wg), Vg = bg(_g), Ug = bg(Tg), qg = bg(Pg);
function Wg(e25, t2) {
  return e25.id ? t2.getTokenAfter(e25.id, Dg) : t2.getFirstToken(e25, Dg);
}
function $g(e25, t2) {
  var r2 = e25.parent, n2 = null, i2 = null;
  if (e25.type === "ArrowFunctionExpression") {
    var a2 = t2.getTokenBefore(e25.body, Eg);
    n2 = a2.loc.start, i2 = a2.loc.end;
  } else
    r2.type === "Property" || r2.type === "MethodDefinition" ? (n2 = r2.loc.start, i2 = Wg(e25, t2).loc.start) : (n2 = e25.loc.start, i2 = Wg(e25, t2).loc.start);
  return { start: Object.assign({}, n2), end: Object.assign({}, i2) };
}
var Gg = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : typeof global != "undefined" ? global : {}, zg = Object.freeze(new Set(["Array", "ArrayBuffer", "BigInt", "BigInt64Array", "BigUint64Array", "Boolean", "DataView", "Date", "decodeURI", "decodeURIComponent", "encodeURI", "encodeURIComponent", "escape", "Float32Array", "Float64Array", "Function", "Infinity", "Int16Array", "Int32Array", "Int8Array", "isFinite", "isNaN", "isPrototypeOf", "JSON", "Map", "Math", "NaN", "Number", "Object", "parseFloat", "parseInt", "Promise", "Proxy", "Reflect", "RegExp", "Set", "String", "Symbol", "Uint16Array", "Uint32Array", "Uint8Array", "Uint8ClampedArray", "undefined", "unescape", "WeakMap", "WeakSet"])), Hg = new Set([Array.isArray, typeof BigInt == "function" ? BigInt : void 0, Boolean, Date, Date.parse, decodeURI, decodeURIComponent, encodeURI, encodeURIComponent, escape, isFinite, isNaN, isPrototypeOf].concat(E(Object.getOwnPropertyNames(Math).map(function(e25) {
  return Math[e25];
}).filter(function(e25) {
  return typeof e25 == "function";
})), [Number, Number.isFinite, Number.isNaN, Number.parseFloat, Number.parseInt, Object, Object.entries, Object.is, Object.isExtensible, Object.isFrozen, Object.isSealed, Object.keys, Object.values, parseFloat, parseInt, RegExp, String, String.fromCharCode, String.fromCodePoint, String.raw, Symbol, Symbol.for, Symbol.keyFor, unescape]).filter(function(e25) {
  return typeof e25 == "function";
})), Kg = new Set([Object.freeze, Object.preventExtensions, Object.seal]);
function Jg(e25, t2) {
  var r2 = function(e26, t3) {
    for (var r3 = e26; (i(r3) === "object" || typeof r3 == "function") && r3 !== null; ) {
      var n2 = Object.getOwnPropertyDescriptor(r3, t3);
      if (n2)
        return n2;
      r3 = Object.getPrototypeOf(r3);
    }
    return null;
  }(e25, t2);
  return r2 != null && r2.get != null;
}
function Qg(e25, t2) {
  for (var r2 = [], n2 = 0; n2 < e25.length; ++n2) {
    var i2 = e25[n2];
    if (i2 == null)
      r2.length = n2 + 1;
    else if (i2.type === "SpreadElement") {
      var a2 = Yg(i2.argument, t2);
      if (a2 == null)
        return null;
      r2.push.apply(r2, E(a2.value));
    } else {
      var o2 = Yg(i2, t2);
      if (o2 == null)
        return null;
      r2.push(o2.value);
    }
  }
  return r2;
}
var Xg = Object.freeze({ ArrayExpression: function(e25, t2) {
  var r2 = Qg(e25.elements, t2);
  return r2 != null ? { value: r2 } : null;
}, AssignmentExpression: function(e25, t2) {
  return e25.operator === "=" ? Yg(e25.right, t2) : null;
}, BinaryExpression: function(e25, t2) {
  if (e25.operator === "in" || e25.operator === "instanceof")
    return null;
  var r2 = Yg(e25.left, t2), n2 = Yg(e25.right, t2);
  if (r2 != null && n2 != null)
    switch (e25.operator) {
      case "==":
        return { value: r2.value == n2.value };
      case "!=":
        return { value: r2.value != n2.value };
      case "===":
        return { value: r2.value === n2.value };
      case "!==":
        return { value: r2.value !== n2.value };
      case "<":
        return { value: r2.value < n2.value };
      case "<=":
        return { value: r2.value <= n2.value };
      case ">":
        return { value: r2.value > n2.value };
      case ">=":
        return { value: r2.value >= n2.value };
      case "<<":
        return { value: r2.value << n2.value };
      case ">>":
        return { value: r2.value >> n2.value };
      case ">>>":
        return { value: r2.value >>> n2.value };
      case "+":
        return { value: r2.value + n2.value };
      case "-":
        return { value: r2.value - n2.value };
      case "*":
        return { value: r2.value * n2.value };
      case "/":
        return { value: r2.value / n2.value };
      case "%":
        return { value: r2.value % n2.value };
      case "**":
        return { value: Math.pow(r2.value, n2.value) };
      case "|":
        return { value: r2.value | n2.value };
      case "^":
        return { value: r2.value ^ n2.value };
      case "&":
        return { value: r2.value & n2.value };
    }
  return null;
}, CallExpression: function(e25, t2) {
  var r2 = e25.callee, n2 = Qg(e25.arguments, t2);
  if (n2 != null)
    if (r2.type === "MemberExpression") {
      var i2 = Yg(r2.object, t2), a2 = r2.computed ? Yg(r2.property, t2) : { value: r2.property.name };
      if (i2 != null && a2 != null) {
        var o2 = i2.value, s2 = a2.value;
        if (Hg.has(o2[s2]))
          return { value: o2[s2].apply(o2, E(n2)) };
        if (Kg.has(o2[s2]))
          return { value: n2[0] };
      }
    } else {
      var u2 = Yg(r2, t2);
      if (u2 != null) {
        var c2 = u2.value;
        if (Hg.has(c2))
          return { value: c2.apply(void 0, E(n2)) };
        if (Kg.has(c2))
          return { value: n2[0] };
      }
    }
  return null;
}, ConditionalExpression: function(e25, t2) {
  var r2 = Yg(e25.test, t2);
  return r2 != null ? r2.value ? Yg(e25.consequent, t2) : Yg(e25.alternate, t2) : null;
}, ExpressionStatement: function(e25, t2) {
  return Yg(e25.expression, t2);
}, Identifier: function(e25, t2) {
  if (t2 != null) {
    var r2 = vg(t2, e25);
    if (r2 != null && r2.defs.length === 0 && zg.has(r2.name) && r2.name in Gg)
      return { value: Gg[r2.name] };
    if (r2 != null && r2.defs.length === 1) {
      var n2 = r2.defs[0];
      if (n2.parent && n2.parent.kind === "const" && n2.node.id.type === "Identifier")
        return Yg(n2.node.init, t2);
    }
  }
  return null;
}, Literal: function(e25) {
  return e25.regex == null && e25.bigint == null || e25.value != null ? { value: e25.value } : null;
}, LogicalExpression: function(e25, t2) {
  var r2 = Yg(e25.left, t2);
  if (r2 != null) {
    if (e25.operator === "||" && Boolean(r2.value) === true || e25.operator === "&&" && Boolean(r2.value) === false)
      return r2;
    var n2 = Yg(e25.right, t2);
    if (n2 != null)
      return n2;
  }
  return null;
}, MemberExpression: function(e25, t2) {
  var r2 = Yg(e25.object, t2), n2 = e25.computed ? Yg(e25.property, t2) : { value: e25.property.name };
  return r2 == null || n2 == null || Jg(r2.value, n2.value) ? null : { value: r2.value[n2.value] };
}, NewExpression: function(e25, t2) {
  var r2 = Yg(e25.callee, t2), n2 = Qg(e25.arguments, t2);
  if (r2 != null && n2 != null) {
    var i2 = r2.value;
    if (Hg.has(i2))
      return { value: m(i2, E(n2)) };
  }
  return null;
}, ObjectExpression: function(e25, t2) {
  var r2 = {}, n2 = true, i2 = false, a2 = void 0;
  try {
    for (var o2, s2 = e25.properties[Symbol.iterator](); !(n2 = (o2 = s2.next()).done); n2 = true) {
      var u2 = o2.value;
      if (u2.type === "Property") {
        if (u2.kind !== "init")
          return null;
        var c2 = u2.computed ? Yg(u2.key, t2) : { value: u2.key.name }, l2 = Yg(u2.value, t2);
        if (c2 == null || l2 == null)
          return null;
        r2[c2.value] = l2.value;
      } else {
        if (u2.type !== "SpreadElement" && u2.type !== "ExperimentalSpreadProperty")
          return null;
        var p2 = Yg(u2.argument, t2);
        if (p2 == null)
          return null;
        Object.assign(r2, p2.value);
      }
    }
  } catch (e26) {
    i2 = true, a2 = e26;
  } finally {
    try {
      n2 || s2.return == null || s2.return();
    } finally {
      if (i2)
        throw a2;
    }
  }
  return { value: r2 };
}, SequenceExpression: function(e25, t2) {
  return Yg(e25.expressions[e25.expressions.length - 1], t2);
}, TaggedTemplateExpression: function(e25, t2) {
  var r2 = Yg(e25.tag, t2), n2 = Qg(e25.quasi.expressions, t2);
  if (r2 != null && n2 != null) {
    var i2 = r2.value, a2 = e25.quasi.quasis.map(function(e26) {
      return e26.value.cooked;
    });
    if (a2.raw = e25.quasi.quasis.map(function(e26) {
      return e26.value.raw;
    }), i2 === String.raw)
      return { value: i2.apply(void 0, [a2].concat(E(n2))) };
  }
  return null;
}, TemplateLiteral: function(e25, t2) {
  var r2 = Qg(e25.expressions, t2);
  if (r2 != null) {
    for (var n2 = e25.quasis[0].value.cooked, i2 = 0; i2 < r2.length; ++i2)
      n2 += r2[i2], n2 += e25.quasis[i2 + 1].value.cooked;
    return { value: n2 };
  }
  return null;
}, UnaryExpression: function(e25, t2) {
  if (e25.operator === "delete")
    return null;
  if (e25.operator === "void")
    return { value: void 0 };
  var r2 = Yg(e25.argument, t2);
  if (r2 != null)
    switch (e25.operator) {
      case "-":
        return { value: -r2.value };
      case "+":
        return { value: +r2.value };
      case "!":
        return { value: !r2.value };
      case "~":
        return { value: ~r2.value };
      case "typeof":
        return { value: i(r2.value) };
    }
  return null;
} });
function Yg(e25, t2) {
  return e25 != null && Object.hasOwnProperty.call(Xg, e25.type) ? Xg[e25.type](e25, t2) : null;
}
function Zg(e25) {
  var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  try {
    return Yg(e25, t2);
  } catch (e26) {
    return null;
  }
}
function ey(e25) {
  var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (e25 && e25.type === "Literal" && e25.value === null) {
    if (e25.regex)
      return "/".concat(e25.regex.pattern, "/").concat(e25.regex.flags);
    if (e25.bigint)
      return e25.bigint;
  }
  var r2 = Zg(e25, t2);
  return r2 && String(r2.value);
}
function ty(e25, t2) {
  switch (e25.type) {
    case "MemberExpression":
      return e25.computed ? ey(e25.property, t2) : e25.property.name;
    case "Property":
    case "MethodDefinition":
      return e25.computed ? ey(e25.key, t2) : e25.key.type === "Literal" ? String(e25.key.value) : e25.key.name;
  }
  return null;
}
function ry(e25) {
  var t2 = e25.parent, r2 = [];
  if (t2.type === "MethodDefinition" && t2.static && r2.push("static"), e25.async && r2.push("async"), e25.generator && r2.push("generator"), e25.type === "ArrowFunctionExpression")
    r2.push("arrow", "function");
  else if (t2.type === "Property" || t2.type === "MethodDefinition") {
    if (t2.kind === "constructor")
      return "constructor";
    t2.kind === "get" ? r2.push("getter") : t2.kind === "set" ? r2.push("setter") : r2.push("method");
  } else
    r2.push("function");
  if (e25.id)
    r2.push("'".concat(e25.id.name, "'"));
  else {
    var n2 = ty(t2);
    n2 && r2.push("'".concat(n2, "'"));
  }
  return r2.join(" ");
}
var ny = Object.freeze(new Set(["==", "!=", "<", "<=", ">", ">=", "<<", ">>", ">>>", "+", "-", "*", "/", "%", "|", "^", "&", "in"])), iy = Object.freeze(new Set(["-", "+", "!", "~"])), ay = Object.freeze(Object.assign(Object.create(null), { $visit: function(e25, t2, r2) {
  var n2 = e25.type;
  return typeof this[n2] == "function" ? this[n2](e25, t2, r2) : this.$visitChildren(e25, t2, r2);
}, $visitChildren: function(e25, t2, r2) {
  var n2 = e25.type, i2 = true, a2 = false, o2 = void 0;
  try {
    for (var s2, u2 = (r2[n2] || Lp.getKeys(e25))[Symbol.iterator](); !(i2 = (s2 = u2.next()).done); i2 = true) {
      var c2 = e25[s2.value];
      if (Array.isArray(c2)) {
        var l2 = true, p2 = false, f2 = void 0;
        try {
          for (var h2, d2 = c2[Symbol.iterator](); !(l2 = (h2 = d2.next()).done); l2 = true) {
            var m2 = h2.value;
            if (m2 && this.$visit(m2, t2, r2))
              return true;
          }
        } catch (e26) {
          p2 = true, f2 = e26;
        } finally {
          try {
            l2 || d2.return == null || d2.return();
          } finally {
            if (p2)
              throw f2;
          }
        }
      } else if (c2 && this.$visit(c2, t2, r2))
        return true;
    }
  } catch (e26) {
    a2 = true, o2 = e26;
  } finally {
    try {
      i2 || u2.return == null || u2.return();
    } finally {
      if (a2)
        throw o2;
    }
  }
  return false;
}, ArrowFunctionExpression: function() {
  return false;
}, AssignmentExpression: function() {
  return true;
}, AwaitExpression: function() {
  return true;
}, BinaryExpression: function(e25, t2, r2) {
  return !(!t2.considerImplicitTypeConversion || !ny.has(e25.operator) || e25.left.type === "Literal" && e25.right.type === "Literal") || this.$visitChildren(e25, t2, r2);
}, CallExpression: function() {
  return true;
}, FunctionExpression: function() {
  return false;
}, ImportExpression: function() {
  return true;
}, MemberExpression: function(e25, t2, r2) {
  return !!t2.considerGetters || (!(!t2.considerImplicitTypeConversion || !e25.computed || e25.property.type === "Literal") || this.$visitChildren(e25, t2, r2));
}, MethodDefinition: function(e25, t2, r2) {
  return !(!t2.considerImplicitTypeConversion || !e25.computed || e25.key.type === "Literal") || this.$visitChildren(e25, t2, r2);
}, NewExpression: function() {
  return true;
}, Property: function(e25, t2, r2) {
  return !(!t2.considerImplicitTypeConversion || !e25.computed || e25.key.type === "Literal") || this.$visitChildren(e25, t2, r2);
}, UnaryExpression: function(e25, t2, r2) {
  return e25.operator === "delete" || (!(!t2.considerImplicitTypeConversion || !iy.has(e25.operator) || e25.argument.type === "Literal") || this.$visitChildren(e25, t2, r2));
}, UpdateExpression: function() {
  return true;
}, YieldExpression: function() {
  return true;
} }));
function oy(e25, t2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n2 = r2.considerGetters, i2 = n2 !== void 0 && n2, a2 = r2.considerImplicitTypeConversion, o2 = a2 !== void 0 && a2;
  return ay.$visit(e25, { considerGetters: i2, considerImplicitTypeConversion: o2 }, t2.visitorKeys || Lp.KEYS);
}
function sy(e25, t2) {
  var r2 = e25.parent;
  switch (r2.type) {
    case "CallExpression":
    case "NewExpression":
      return r2.arguments.length === 1 && r2.arguments[0] === e25 ? t2.getTokenAfter(r2.callee, Dg) : null;
    case "DoWhileStatement":
      return r2.test === e25 ? t2.getTokenAfter(r2.body, Dg) : null;
    case "IfStatement":
    case "WhileStatement":
      return r2.test === e25 ? t2.getFirstToken(r2, 1) : null;
    case "ImportExpression":
      return r2.source === e25 ? t2.getFirstToken(r2, 1) : null;
    case "SwitchStatement":
      return r2.discriminant === e25 ? t2.getFirstToken(r2, 1) : null;
    case "WithStatement":
      return r2.object === e25 ? t2.getFirstToken(r2, 1) : null;
    default:
      return null;
  }
}
function uy(e25, t2, r2) {
  var n2, i2, a2, o2, s2;
  if (typeof e25 == "number") {
    if (i2 = t2, a2 = r2, !((n2 = 0 | e25) >= 1))
      throw new TypeError("'times' should be a positive integer.");
  } else
    n2 = 1, i2 = e25, a2 = t2;
  if (i2 == null)
    return false;
  o2 = s2 = i2;
  do {
    o2 = a2.getTokenBefore(o2), s2 = a2.getTokenAfter(s2);
  } while (o2 != null && s2 != null && Dg(o2) && Fg(s2) && o2 !== sy(i2, a2) && --n2 > 0);
  return n2 === 0;
}
var cy = /\$(?:[\$&'`]|[1-9][0-9]?)/g, ly = new WeakMap();
function py(e25, t2) {
  for (var r2 = false, n2 = t2 - 1; n2 >= 0 && e25.charCodeAt(n2) === 92; --n2)
    r2 = !r2;
  return r2;
}
var fy = function() {
  function e25(t2) {
    var r2 = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).escaped, n2 = r2 !== void 0 && r2;
    if (a(this, e25), !(t2 instanceof RegExp))
      throw new TypeError("'pattern' should be a RegExp instance.");
    if (!t2.flags.includes("g"))
      throw new Error("'pattern' should contains 'g' flag.");
    ly.set(this, { pattern: new RegExp(t2.source, t2.flags), escaped: Boolean(n2) });
  }
  return s(e25, [{ key: "execAll", value: regeneratorRuntime.mark(function e26(t2) {
    var r2, n2, i2, a2, o2;
    return regeneratorRuntime.wrap(function(e27) {
      for (; ; )
        switch (e27.prev = e27.next) {
          case 0:
            r2 = ly.get(this), n2 = r2.pattern, i2 = r2.escaped, a2 = null, o2 = 0, n2.lastIndex = 0;
          case 4:
            if ((a2 = n2.exec(t2)) == null) {
              e27.next = 12;
              break;
            }
            if (!i2 && py(t2, a2.index)) {
              e27.next = 10;
              break;
            }
            return o2 = n2.lastIndex, e27.next = 9, a2;
          case 9:
            n2.lastIndex = o2;
          case 10:
            e27.next = 4;
            break;
          case 12:
          case "end":
            return e27.stop();
        }
    }, e26, this);
  }) }, { key: "test", value: function(e26) {
    return !this.execAll(e26).next().done;
  } }, { key: Symbol.replace, value: function(e26, t2) {
    return typeof t2 == "function" ? function(e27, t3, r2) {
      var n2 = [], i2 = 0, a2 = true, o2 = false, s2 = void 0;
      try {
        for (var u2, c2 = e27.execAll(t3)[Symbol.iterator](); !(a2 = (u2 = c2.next()).done); a2 = true) {
          var l2 = u2.value;
          n2.push(t3.slice(i2, l2.index)), n2.push(String(r2.apply(void 0, E(l2).concat([l2.index, l2.input])))), i2 = l2.index + l2[0].length;
        }
      } catch (e28) {
        o2 = true, s2 = e28;
      } finally {
        try {
          a2 || c2.return == null || c2.return();
        } finally {
          if (o2)
            throw s2;
        }
      }
      return n2.push(t3.slice(i2)), n2.join("");
    }(this, String(e26), t2) : function(e27, t3, r2) {
      var n2 = [], i2 = 0, a2 = null;
      function o2(e28) {
        switch (e28) {
          case "$$":
            return "$";
          case "$&":
            return a2[0];
          case "$`":
            return t3.slice(0, a2.index);
          case "$'":
            return t3.slice(a2.index + a2[0].length);
          default:
            var r3 = e28.slice(1);
            return r3 in a2 ? a2[r3] : e28;
        }
      }
      var s2 = true, u2 = false, c2 = void 0;
      try {
        for (var l2, p2 = e27.execAll(t3)[Symbol.iterator](); !(s2 = (l2 = p2.next()).done); s2 = true)
          a2 = l2.value, n2.push(t3.slice(i2, a2.index)), n2.push(r2.replace(cy, o2)), i2 = a2.index + a2[0].length;
      } catch (e28) {
        u2 = true, c2 = e28;
      } finally {
        try {
          s2 || p2.return == null || p2.return();
        } finally {
          if (u2)
            throw c2;
        }
      }
      return n2.push(t3.slice(i2)), n2.join("");
    }(this, String(e26), String(t2));
  } }]), e25;
}(), hy = /^(?:Import|Export(?:All|Default|Named))Declaration$/, dy = Function.call.bind(Object.hasOwnProperty), my = Symbol("read"), gy = Symbol("call"), yy = Symbol("construct"), vy = Symbol("esm"), xy = { require: u({}, gy, true) };
function by(e25) {
  return e25 == null || e25.defs.length !== 0 || e25.references.some(function(e26) {
    return e26.isWrite();
  });
}
function Ey(e25) {
  var t2 = e25.parent;
  switch (t2 && t2.type) {
    case "ConditionalExpression":
      return t2.consequent === e25 || t2.alternate === e25;
    case "LogicalExpression":
      return true;
    case "SequenceExpression":
      return t2.expressions[t2.expressions.length - 1] === e25;
    default:
      return false;
  }
}
var Cy = function() {
  function e25(t2) {
    var r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n2 = r2.mode, i2 = n2 === void 0 ? "strict" : n2, o2 = r2.globalObjectNames, s2 = o2 === void 0 ? ["global", "self", "window"] : o2;
    a(this, e25), this.variableStack = [], this.globalScope = t2, this.mode = i2, this.globalObjectNames = s2.slice(0);
  }
  return s(e25, [{ key: "iterateGlobalReferences", value: regeneratorRuntime.mark(function e26(t2) {
    var r2, n2, i2, a2, o2, s2, u2, c2, l2, p2, f2, h2, d2, m2;
    return regeneratorRuntime.wrap(function(e27) {
      for (; ; )
        switch (e27.prev = e27.next) {
          case 0:
            r2 = 0, n2 = Object.keys(t2);
          case 1:
            if (!(r2 < n2.length)) {
              e27.next = 12;
              break;
            }
            if (i2 = n2[r2], a2 = t2[i2], o2 = [i2], !by(s2 = this.globalScope.set.get(i2))) {
              e27.next = 8;
              break;
            }
            return e27.abrupt("continue", 9);
          case 8:
            return e27.delegateYield(this._iterateVariableReferences(s2, o2, a2, true), "t0", 9);
          case 9:
            r2++, e27.next = 1;
            break;
          case 12:
            u2 = true, c2 = false, l2 = void 0, e27.prev = 15, p2 = this.globalObjectNames[Symbol.iterator]();
          case 17:
            if (u2 = (f2 = p2.next()).done) {
              e27.next = 27;
              break;
            }
            if (h2 = f2.value, d2 = [], !by(m2 = this.globalScope.set.get(h2))) {
              e27.next = 23;
              break;
            }
            return e27.abrupt("continue", 24);
          case 23:
            return e27.delegateYield(this._iterateVariableReferences(m2, d2, t2, false), "t1", 24);
          case 24:
            u2 = true, e27.next = 17;
            break;
          case 27:
            e27.next = 33;
            break;
          case 29:
            e27.prev = 29, e27.t2 = e27.catch(15), c2 = true, l2 = e27.t2;
          case 33:
            e27.prev = 33, e27.prev = 34, u2 || p2.return == null || p2.return();
          case 36:
            if (e27.prev = 36, !c2) {
              e27.next = 39;
              break;
            }
            throw l2;
          case 39:
            return e27.finish(36);
          case 40:
            return e27.finish(33);
          case 41:
          case "end":
            return e27.stop();
        }
    }, e26, this, [[15, 29, 33, 41], [34, , 36, 40]]);
  }) }, { key: "iterateCjsReferences", value: regeneratorRuntime.mark(function e26(t2) {
    var r2, n2, i2, a2, o2, s2, u2, c2, l2;
    return regeneratorRuntime.wrap(function(e27) {
      for (; ; )
        switch (e27.prev = e27.next) {
          case 0:
            r2 = true, n2 = false, i2 = void 0, e27.prev = 3, a2 = this.iterateGlobalReferences(xy)[Symbol.iterator]();
          case 5:
            if (r2 = (o2 = a2.next()).done) {
              e27.next = 19;
              break;
            }
            if (s2 = o2.value.node, (u2 = ey(s2.arguments[0])) != null && dy(t2, u2)) {
              e27.next = 10;
              break;
            }
            return e27.abrupt("continue", 16);
          case 10:
            if (c2 = t2[u2], l2 = [u2], !c2[my]) {
              e27.next = 15;
              break;
            }
            return e27.next = 15, { node: s2, path: l2, type: my, info: c2[my] };
          case 15:
            return e27.delegateYield(this._iteratePropertyReferences(s2, l2, c2), "t0", 16);
          case 16:
            r2 = true, e27.next = 5;
            break;
          case 19:
            e27.next = 25;
            break;
          case 21:
            e27.prev = 21, e27.t1 = e27.catch(3), n2 = true, i2 = e27.t1;
          case 25:
            e27.prev = 25, e27.prev = 26, r2 || a2.return == null || a2.return();
          case 28:
            if (e27.prev = 28, !n2) {
              e27.next = 31;
              break;
            }
            throw i2;
          case 31:
            return e27.finish(28);
          case 32:
            return e27.finish(25);
          case 33:
          case "end":
            return e27.stop();
        }
    }, e26, this, [[3, 21, 25, 33], [26, , 28, 32]]);
  }) }, { key: "iterateEsmReferences", value: regeneratorRuntime.mark(function e26(t2) {
    var r2, n2, i2, a2, o2, s2, u2, c2, l2, p2, f2, h2, d2, m2, g2, y2, v2, x2, b2, E2, C2, S2, k2, D2, F2, A2, w2, _2;
    return regeneratorRuntime.wrap(function(e27) {
      for (; ; )
        switch (e27.prev = e27.next) {
          case 0:
            r2 = this.globalScope.block, n2 = true, i2 = false, a2 = void 0, e27.prev = 4, o2 = r2.body[Symbol.iterator]();
          case 6:
            if (n2 = (s2 = o2.next()).done) {
              e27.next = 92;
              break;
            }
            if (u2 = s2.value, hy.test(u2.type) && u2.source != null) {
              e27.next = 10;
              break;
            }
            return e27.abrupt("continue", 89);
          case 10:
            if (c2 = u2.source.value, dy(t2, c2)) {
              e27.next = 13;
              break;
            }
            return e27.abrupt("continue", 89);
          case 13:
            if (l2 = t2[c2], p2 = [c2], !l2[my]) {
              e27.next = 18;
              break;
            }
            return e27.next = 18, { node: u2, path: p2, type: my, info: l2[my] };
          case 18:
            if (u2.type !== "ExportAllDeclaration") {
              e27.next = 31;
              break;
            }
            f2 = 0, h2 = Object.keys(l2);
          case 20:
            if (!(f2 < h2.length)) {
              e27.next = 29;
              break;
            }
            if (d2 = h2[f2], !(m2 = l2[d2])[my]) {
              e27.next = 26;
              break;
            }
            return e27.next = 26, { node: u2, path: p2.concat(d2), type: my, info: m2[my] };
          case 26:
            f2++, e27.next = 20;
            break;
          case 29:
            e27.next = 89;
            break;
          case 31:
            g2 = true, y2 = false, v2 = void 0, e27.prev = 34, x2 = u2.specifiers[Symbol.iterator]();
          case 36:
            if (g2 = (b2 = x2.next()).done) {
              e27.next = 75;
              break;
            }
            if (E2 = b2.value, C2 = dy(l2, vy), S2 = this._iterateImportReferences(E2, p2, C2 ? l2 : this.mode === "legacy" ? Object.assign({ default: l2 }, l2) : { default: l2 }), !C2) {
              e27.next = 44;
              break;
            }
            return e27.delegateYield(S2, "t0", 42);
          case 42:
            e27.next = 72;
            break;
          case 44:
            k2 = true, D2 = false, F2 = void 0, e27.prev = 47, A2 = S2[Symbol.iterator]();
          case 49:
            if (k2 = (w2 = A2.next()).done) {
              e27.next = 58;
              break;
            }
            if ((_2 = w2.value).path = _2.path.filter(Sy), !(_2.path.length >= 2 || _2.type !== my)) {
              e27.next = 55;
              break;
            }
            return e27.next = 55, _2;
          case 55:
            k2 = true, e27.next = 49;
            break;
          case 58:
            e27.next = 64;
            break;
          case 60:
            e27.prev = 60, e27.t1 = e27.catch(47), D2 = true, F2 = e27.t1;
          case 64:
            e27.prev = 64, e27.prev = 65, k2 || A2.return == null || A2.return();
          case 67:
            if (e27.prev = 67, !D2) {
              e27.next = 70;
              break;
            }
            throw F2;
          case 70:
            return e27.finish(67);
          case 71:
            return e27.finish(64);
          case 72:
            g2 = true, e27.next = 36;
            break;
          case 75:
            e27.next = 81;
            break;
          case 77:
            e27.prev = 77, e27.t2 = e27.catch(34), y2 = true, v2 = e27.t2;
          case 81:
            e27.prev = 81, e27.prev = 82, g2 || x2.return == null || x2.return();
          case 84:
            if (e27.prev = 84, !y2) {
              e27.next = 87;
              break;
            }
            throw v2;
          case 87:
            return e27.finish(84);
          case 88:
            return e27.finish(81);
          case 89:
            n2 = true, e27.next = 6;
            break;
          case 92:
            e27.next = 98;
            break;
          case 94:
            e27.prev = 94, e27.t3 = e27.catch(4), i2 = true, a2 = e27.t3;
          case 98:
            e27.prev = 98, e27.prev = 99, n2 || o2.return == null || o2.return();
          case 101:
            if (e27.prev = 101, !i2) {
              e27.next = 104;
              break;
            }
            throw a2;
          case 104:
            return e27.finish(101);
          case 105:
            return e27.finish(98);
          case 106:
          case "end":
            return e27.stop();
        }
    }, e26, this, [[4, 94, 98, 106], [34, 77, 81, 89], [47, 60, 64, 72], [65, , 67, 71], [82, , 84, 88], [99, , 101, 105]]);
  }) }, { key: "_iterateVariableReferences", value: regeneratorRuntime.mark(function e26(t2, r2, n2, i2) {
    var a2, o2, s2, u2, c2, l2, p2;
    return regeneratorRuntime.wrap(function(e27) {
      for (; ; )
        switch (e27.prev = e27.next) {
          case 0:
            if (!this.variableStack.includes(t2)) {
              e27.next = 2;
              break;
            }
            return e27.abrupt("return");
          case 2:
            this.variableStack.push(t2), e27.prev = 3, a2 = true, o2 = false, s2 = void 0, e27.prev = 7, u2 = t2.references[Symbol.iterator]();
          case 9:
            if (a2 = (c2 = u2.next()).done) {
              e27.next = 21;
              break;
            }
            if ((l2 = c2.value).isRead()) {
              e27.next = 13;
              break;
            }
            return e27.abrupt("continue", 18);
          case 13:
            if (p2 = l2.identifier, !i2 || !n2[my]) {
              e27.next = 17;
              break;
            }
            return e27.next = 17, { node: p2, path: r2, type: my, info: n2[my] };
          case 17:
            return e27.delegateYield(this._iteratePropertyReferences(p2, r2, n2), "t0", 18);
          case 18:
            a2 = true, e27.next = 9;
            break;
          case 21:
            e27.next = 27;
            break;
          case 23:
            e27.prev = 23, e27.t1 = e27.catch(7), o2 = true, s2 = e27.t1;
          case 27:
            e27.prev = 27, e27.prev = 28, a2 || u2.return == null || u2.return();
          case 30:
            if (e27.prev = 30, !o2) {
              e27.next = 33;
              break;
            }
            throw s2;
          case 33:
            return e27.finish(30);
          case 34:
            return e27.finish(27);
          case 35:
            return e27.prev = 35, this.variableStack.pop(), e27.finish(35);
          case 38:
          case "end":
            return e27.stop();
        }
    }, e26, this, [[3, , 35, 38], [7, 23, 27, 35], [28, , 30, 34]]);
  }) }, { key: "_iteratePropertyReferences", value: regeneratorRuntime.mark(function e26(t2, r2, n2) {
    var i2, a2, o2, s2;
    return regeneratorRuntime.wrap(function(e27) {
      for (; ; )
        switch (e27.prev = e27.next) {
          case 0:
            for (i2 = t2; Ey(i2); )
              i2 = i2.parent;
            if ((a2 = i2.parent).type !== "MemberExpression") {
              e27.next = 15;
              break;
            }
            if (a2.object !== i2) {
              e27.next = 14;
              break;
            }
            if ((o2 = ty(a2)) != null && dy(n2, o2)) {
              e27.next = 8;
              break;
            }
            return e27.abrupt("return");
          case 8:
            if (r2 = r2.concat(o2), !(s2 = n2[o2])[my]) {
              e27.next = 13;
              break;
            }
            return e27.next = 13, { node: a2, path: r2, type: my, info: s2[my] };
          case 13:
            return e27.delegateYield(this._iteratePropertyReferences(a2, r2, s2), "t0", 14);
          case 14:
            return e27.abrupt("return");
          case 15:
            if (a2.type !== "CallExpression") {
              e27.next = 20;
              break;
            }
            if (a2.callee !== i2 || !n2[gy]) {
              e27.next = 19;
              break;
            }
            return e27.next = 19, { node: a2, path: r2, type: gy, info: n2[gy] };
          case 19:
            return e27.abrupt("return");
          case 20:
            if (a2.type !== "NewExpression") {
              e27.next = 25;
              break;
            }
            if (a2.callee !== i2 || !n2[yy]) {
              e27.next = 24;
              break;
            }
            return e27.next = 24, { node: a2, path: r2, type: yy, info: n2[yy] };
          case 24:
            return e27.abrupt("return");
          case 25:
            if (a2.type !== "AssignmentExpression") {
              e27.next = 30;
              break;
            }
            if (a2.right !== i2) {
              e27.next = 29;
              break;
            }
            return e27.delegateYield(this._iterateLhsReferences(a2.left, r2, n2), "t1", 28);
          case 28:
            return e27.delegateYield(this._iteratePropertyReferences(a2, r2, n2), "t2", 29);
          case 29:
            return e27.abrupt("return");
          case 30:
            if (a2.type !== "AssignmentPattern") {
              e27.next = 34;
              break;
            }
            if (a2.right !== i2) {
              e27.next = 33;
              break;
            }
            return e27.delegateYield(this._iterateLhsReferences(a2.left, r2, n2), "t3", 33);
          case 33:
            return e27.abrupt("return");
          case 34:
            if (a2.type !== "VariableDeclarator") {
              e27.next = 37;
              break;
            }
            if (a2.init !== i2) {
              e27.next = 37;
              break;
            }
            return e27.delegateYield(this._iterateLhsReferences(a2.id, r2, n2), "t4", 37);
          case 37:
          case "end":
            return e27.stop();
        }
    }, e26, this);
  }) }, { key: "_iterateLhsReferences", value: regeneratorRuntime.mark(function e26(t2, r2, n2) {
    var i2, a2, o2, s2, u2, c2, l2, p2, f2, h2;
    return regeneratorRuntime.wrap(function(e27) {
      for (; ; )
        switch (e27.prev = e27.next) {
          case 0:
            if (t2.type !== "Identifier") {
              e27.next = 5;
              break;
            }
            if ((i2 = vg(this.globalScope, t2)) == null) {
              e27.next = 4;
              break;
            }
            return e27.delegateYield(this._iterateVariableReferences(i2, r2, n2, false), "t0", 4);
          case 4:
            return e27.abrupt("return");
          case 5:
            if (t2.type !== "ObjectPattern") {
              e27.next = 40;
              break;
            }
            a2 = true, o2 = false, s2 = void 0, e27.prev = 9, u2 = t2.properties[Symbol.iterator]();
          case 11:
            if (a2 = (c2 = u2.next()).done) {
              e27.next = 25;
              break;
            }
            if (l2 = c2.value, (p2 = ty(l2)) != null && dy(n2, p2)) {
              e27.next = 16;
              break;
            }
            return e27.abrupt("continue", 22);
          case 16:
            if (f2 = r2.concat(p2), !(h2 = n2[p2])[my]) {
              e27.next = 21;
              break;
            }
            return e27.next = 21, { node: l2, path: f2, type: my, info: h2[my] };
          case 21:
            return e27.delegateYield(this._iterateLhsReferences(l2.value, f2, h2), "t1", 22);
          case 22:
            a2 = true, e27.next = 11;
            break;
          case 25:
            e27.next = 31;
            break;
          case 27:
            e27.prev = 27, e27.t2 = e27.catch(9), o2 = true, s2 = e27.t2;
          case 31:
            e27.prev = 31, e27.prev = 32, a2 || u2.return == null || u2.return();
          case 34:
            if (e27.prev = 34, !o2) {
              e27.next = 37;
              break;
            }
            throw s2;
          case 37:
            return e27.finish(34);
          case 38:
            return e27.finish(31);
          case 39:
            return e27.abrupt("return");
          case 40:
            if (t2.type !== "AssignmentPattern") {
              e27.next = 42;
              break;
            }
            return e27.delegateYield(this._iterateLhsReferences(t2.left, r2, n2), "t3", 42);
          case 42:
          case "end":
            return e27.stop();
        }
    }, e26, this, [[9, 27, 31, 39], [32, , 34, 38]]);
  }) }, { key: "_iterateImportReferences", value: regeneratorRuntime.mark(function e26(t2, r2, n2) {
    var i2, a2, o2, s2, u2;
    return regeneratorRuntime.wrap(function(e27) {
      for (; ; )
        switch (e27.prev = e27.next) {
          case 0:
            if ((i2 = t2.type) !== "ImportSpecifier" && i2 !== "ImportDefaultSpecifier") {
              e27.next = 12;
              break;
            }
            if (a2 = i2 === "ImportDefaultSpecifier" ? "default" : t2.imported.name, dy(n2, a2)) {
              e27.next = 5;
              break;
            }
            return e27.abrupt("return");
          case 5:
            if (r2 = r2.concat(a2), !(o2 = n2[a2])[my]) {
              e27.next = 10;
              break;
            }
            return e27.next = 10, { node: t2, path: r2, type: my, info: o2[my] };
          case 10:
            return e27.delegateYield(this._iterateVariableReferences(vg(this.globalScope, t2.local), r2, o2, false), "t0", 11);
          case 11:
            return e27.abrupt("return");
          case 12:
            if (i2 !== "ImportNamespaceSpecifier") {
              e27.next = 15;
              break;
            }
            return e27.delegateYield(this._iterateVariableReferences(vg(this.globalScope, t2.local), r2, n2, false), "t1", 14);
          case 14:
            return e27.abrupt("return");
          case 15:
            if (i2 !== "ExportSpecifier") {
              e27.next = 24;
              break;
            }
            if (s2 = t2.local.name, dy(n2, s2)) {
              e27.next = 19;
              break;
            }
            return e27.abrupt("return");
          case 19:
            if (r2 = r2.concat(s2), !(u2 = n2[s2])[my]) {
              e27.next = 24;
              break;
            }
            return e27.next = 24, { node: t2, path: r2, type: my, info: u2[my] };
          case 24:
          case "end":
            return e27.stop();
        }
    }, e26, this);
  }) }]), e25;
}();
function Sy(e25, t2) {
  return !(t2 === 1 && e25 === "default");
}
Cy.READ = my, Cy.CALL = gy, Cy.CONSTRUCT = yy, Cy.ESM = vy;
var ky = { CALL: gy, CONSTRUCT: yy, ESM: vy, findVariable: vg, getFunctionHeadLocation: $g, getFunctionNameWithKind: ry, getInnermostScope: yg, getPropertyName: ty, getStaticValue: Zg, getStringIfConstant: ey, hasSideEffect: oy, isArrowToken: Eg, isClosingBraceToken: Tg, isClosingBracketToken: wg, isClosingParenToken: Fg, isColonToken: kg, isCommaToken: Cg, isCommentToken: Pg, isNotArrowToken: Ig, isNotClosingBraceToken: Ug, isNotClosingBracketToken: Mg, isNotClosingParenToken: jg, isNotColonToken: Lg, isNotCommaToken: Bg, isNotCommentToken: qg, isNotOpeningBraceToken: Vg, isNotOpeningBracketToken: Rg, isNotOpeningParenToken: Ng, isNotSemicolonToken: Og, isOpeningBraceToken: _g, isOpeningBracketToken: Ag, isOpeningParenToken: Dg, isParenthesized: uy, isSemicolonToken: Sg, PatternMatcher: fy, READ: my, ReferenceTracker: Cy }, Dy = n(Object.freeze({ __proto__: null, default: ky, CALL: gy, CONSTRUCT: yy, ESM: vy, PatternMatcher: fy, READ: my, ReferenceTracker: Cy, findVariable: vg, getFunctionHeadLocation: $g, getFunctionNameWithKind: ry, getInnermostScope: yg, getPropertyName: ty, getStaticValue: Zg, getStringIfConstant: ey, hasSideEffect: oy, isArrowToken: Eg, isClosingBraceToken: Tg, isClosingBracketToken: wg, isClosingParenToken: Fg, isColonToken: kg, isCommaToken: Cg, isCommentToken: Pg, isNotArrowToken: Ig, isNotClosingBraceToken: Ug, isNotClosingBracketToken: Mg, isNotClosingParenToken: jg, isNotColonToken: Lg, isNotCommaToken: Bg, isNotCommentToken: qg, isNotOpeningBraceToken: Vg, isNotOpeningBracketToken: Rg, isNotOpeningParenToken: Ng, isNotSemicolonToken: Og, isOpeningBraceToken: _g, isOpeningBracketToken: Ag, isOpeningParenToken: Dg, isParenthesized: uy, isSemicolonToken: Sg })), Fy = r(function(e25, t2) {
  function r2(e26) {
    return e26 && i(e26) == "object" && "default" in e26 ? e26.default : e26;
  }
  var n2 = r2(Lp), o2 = r2(Dm), u2 = r2(Fm), c2 = r2(og), l2 = r2(gg), p2 = r2(Dy), f2 = /\r\n|[\n\r\u2028\u2029]/;
  var h2 = { breakableTypePattern: /^(?:(?:Do)?While|For(?:In|Of)?|Switch)Statement$/, lineBreakPattern: f2, createGlobalLinebreakMatcher: function() {
    return new RegExp(f2.source, "gu");
  }, shebangPattern: /^#!((?:[\0-\t\x0B\f\x0E-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)/ };
  var d2 = l2("eslint:traverser");
  function m2() {
  }
  var g2 = function() {
    function e26() {
      a(this, e26), this._current = null, this._parents = [], this._skipped = false, this._broken = false, this._visitorKeys = null, this._enter = null, this._leave = null;
    }
    return s(e26, [{ key: "current", value: function() {
      return this._current;
    } }, { key: "parents", value: function() {
      return this._parents.slice(0);
    } }, { key: "break", value: function() {
      this._broken = true;
    } }, { key: "skip", value: function() {
      this._skipped = true;
    } }, { key: "traverse", value: function(e27, t3) {
      this._current = null, this._parents = [], this._skipped = false, this._broken = false, this._visitorKeys = t3.visitorKeys || n2.KEYS, this._enter = t3.enter || m2, this._leave = t3.leave || m2, this._traverse(e27, null);
    } }, { key: "_traverse", value: function(e27, t3) {
      if (function(e28) {
        return e28 !== null && i(e28) == "object" && typeof e28.type == "string";
      }(e27)) {
        if (this._current = e27, this._skipped = false, this._enter(e27, t3), !this._skipped && !this._broken) {
          var r3 = function(e28, t4) {
            var r4 = e28[t4.type];
            return r4 || (r4 = n2.getKeys(t4), d2('Unknown node type "%s": Estimated visitor keys %j', t4.type, r4)), r4;
          }(this._visitorKeys, e27);
          if (1 <= r3.length) {
            this._parents.push(e27);
            for (var a2 = 0; a2 < r3.length && !this._broken; ++a2) {
              var o3 = e27[r3[a2]];
              if (Array.isArray(o3))
                for (var s2 = 0; s2 < o3.length && !this._broken; ++s2)
                  this._traverse(o3[s2], e27);
              else
                this._traverse(o3, e27);
            }
            this._parents.pop();
          }
        }
        this._broken || this._leave(e27, t3), this._current = t3;
      }
    } }], [{ key: "getKeys", value: function(e27) {
      return n2.getKeys(e27);
    } }, { key: "traverse", value: function(t3, r3) {
      new e26().traverse(t3, r3);
    } }, { key: "DEFAULT_VISITOR_KEYS", get: function() {
      return n2.KEYS;
    } }]), e26;
  }();
  t2.Traverser = g2, t2.createCommonjsModule = function(e26, t3) {
    return e26(t3 = { exports: {} }, t3.exports), t3.exports;
  }, t2.espree = o2, t2.evk = n2, t2.getCjsExportFromNamespace = function(e26) {
    return e26 && e26.default || e26;
  }, t2.globals = c2, t2.lodash = u2, t2.require$$0 = p2, t2.require$$0$1 = h2, t2.require$$1 = l2;
}), Ay = (Fy.Traverser, Fy.createCommonjsModule, Fy.espree, Fy.evk, Fy.getCjsExportFromNamespace, Fy.globals, Fy.lodash, Fy.require$$0, Fy.require$$0$1, Fy.require$$1, r(function(e25, t2) {
  /** @license URI.js v4.2.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
  !function(e26) {
    function t3() {
      for (var e27 = arguments.length, t4 = Array(e27), r3 = 0; r3 < e27; r3++)
        t4[r3] = arguments[r3];
      if (t4.length > 1) {
        t4[0] = t4[0].slice(0, -1);
        for (var n3 = t4.length - 1, i3 = 1; i3 < n3; ++i3)
          t4[i3] = t4[i3].slice(1, -1);
        return t4[n3] = t4[n3].slice(1), t4.join("");
      }
      return t4[0];
    }
    function r2(e27) {
      return "(?:" + e27 + ")";
    }
    function n2(e27) {
      return e27 === void 0 ? "undefined" : e27 === null ? "null" : Object.prototype.toString.call(e27).split(" ").pop().split("]").shift().toLowerCase();
    }
    function i2(e27) {
      return e27.toUpperCase();
    }
    function a2(e27) {
      var n3 = t3("[0-9]", "[A-Fa-f]"), i3 = r2(r2("%[EFef]" + n3 + "%" + n3 + n3 + "%" + n3 + n3) + "|" + r2("%[89A-Fa-f]" + n3 + "%" + n3 + n3) + "|" + r2("%" + n3 + n3)), a3 = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", o3 = t3("[\\:\\/\\?\\#\\[\\]\\@]", a3), s3 = e27 ? "[\\uE000-\\uF8FF]" : "[]", u3 = t3("[A-Za-z]", "[0-9]", "[\\-\\.\\_\\~]", e27 ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]"), c3 = (r2("[A-Za-z]" + t3("[A-Za-z]", "[0-9]", "[\\+\\-\\.]") + "*"), r2(r2(i3 + "|" + t3(u3, a3, "[\\:]")) + "*"), r2(r2("25[0-5]") + "|" + r2("2[0-4][0-9]") + "|" + r2("1[0-9][0-9]") + "|" + r2("0?[1-9][0-9]") + "|0?0?[0-9]")), l3 = r2(c3 + "\\." + c3 + "\\." + c3 + "\\." + c3), p3 = r2(n3 + "{1,4}"), f3 = r2(r2(p3 + "\\:" + p3) + "|" + l3), h3 = r2(r2(p3 + "\\:") + "{6}" + f3), d3 = r2("\\:\\:" + r2(p3 + "\\:") + "{5}" + f3), m3 = r2(r2(p3) + "?\\:\\:" + r2(p3 + "\\:") + "{4}" + f3), g3 = r2(r2(r2(p3 + "\\:") + "{0,1}" + p3) + "?\\:\\:" + r2(p3 + "\\:") + "{3}" + f3), y3 = r2(r2(r2(p3 + "\\:") + "{0,2}" + p3) + "?\\:\\:" + r2(p3 + "\\:") + "{2}" + f3), v3 = r2(r2(r2(p3 + "\\:") + "{0,3}" + p3) + "?\\:\\:" + p3 + "\\:" + f3), x3 = r2(r2(r2(p3 + "\\:") + "{0,4}" + p3) + "?\\:\\:" + f3), b3 = r2(r2(r2(p3 + "\\:") + "{0,5}" + p3) + "?\\:\\:" + p3), E3 = r2(r2(r2(p3 + "\\:") + "{0,6}" + p3) + "?\\:\\:"), C3 = r2([h3, d3, m3, g3, y3, v3, x3, b3, E3].join("|")), S3 = r2(r2(u3 + "|" + i3) + "+"), k3 = (r2("[vV]" + n3 + "+\\." + t3(u3, a3, "[\\:]") + "+"), r2(r2(i3 + "|" + t3(u3, a3)) + "*"), r2(i3 + "|" + t3(u3, a3, "[\\:\\@]")));
      return r2(r2(i3 + "|" + t3(u3, a3, "[\\@]")) + "+"), r2(r2(k3 + "|" + t3("[\\/\\?]", s3)) + "*"), { NOT_SCHEME: new RegExp(t3("[^]", "[A-Za-z]", "[0-9]", "[\\+\\-\\.]"), "g"), NOT_USERINFO: new RegExp(t3("[^\\%\\:]", u3, a3), "g"), NOT_HOST: new RegExp(t3("[^\\%\\[\\]\\:]", u3, a3), "g"), NOT_PATH: new RegExp(t3("[^\\%\\/\\:\\@]", u3, a3), "g"), NOT_PATH_NOSCHEME: new RegExp(t3("[^\\%\\/\\@]", u3, a3), "g"), NOT_QUERY: new RegExp(t3("[^\\%]", u3, a3, "[\\:\\@\\/\\?]", s3), "g"), NOT_FRAGMENT: new RegExp(t3("[^\\%]", u3, a3, "[\\:\\@\\/\\?]"), "g"), ESCAPE: new RegExp(t3("[^]", u3, a3), "g"), UNRESERVED: new RegExp(u3, "g"), OTHER_CHARS: new RegExp(t3("[^\\%]", u3, o3), "g"), PCT_ENCODED: new RegExp(i3, "g"), IPV4ADDRESS: new RegExp("^(" + l3 + ")$"), IPV6ADDRESS: new RegExp("^\\[?(" + C3 + ")" + r2(r2("\\%25|\\%(?!" + n3 + "{2})") + "(" + S3 + ")") + "?\\]?$") };
    }
    var o2 = a2(false), s2 = a2(true), u2 = function(e27, t4) {
      if (Array.isArray(e27))
        return e27;
      if (Symbol.iterator in Object(e27))
        return function(e28, t5) {
          var r3 = [], n3 = true, i3 = false, a3 = void 0;
          try {
            for (var o3, s3 = e28[Symbol.iterator](); !(n3 = (o3 = s3.next()).done) && (r3.push(o3.value), !t5 || r3.length !== t5); n3 = true)
              ;
          } catch (e29) {
            i3 = true, a3 = e29;
          } finally {
            try {
              !n3 && s3.return && s3.return();
            } finally {
              if (i3)
                throw a3;
            }
          }
          return r3;
        }(e27, t4);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }, c2 = 2147483647, l2 = /^xn--/, p2 = /[^\0-\x7E]/, f2 = /[\x2E\u3002\uFF0E\uFF61]/g, h2 = { overflow: "Overflow: input needs wider integers to process", "not-basic": "Illegal input >= 0x80 (not a basic code point)", "invalid-input": "Invalid input" }, d2 = Math.floor, m2 = String.fromCharCode;
    function g2(e27) {
      throw new RangeError(h2[e27]);
    }
    function y2(e27, t4) {
      var r3 = e27.split("@"), n3 = "";
      r3.length > 1 && (n3 = r3[0] + "@", e27 = r3[1]);
      var i3 = function(e28, t5) {
        for (var r4 = [], n4 = e28.length; n4--; )
          r4[n4] = t5(e28[n4]);
        return r4;
      }((e27 = e27.replace(f2, ".")).split("."), t4).join(".");
      return n3 + i3;
    }
    function v2(e27) {
      for (var t4 = [], r3 = 0, n3 = e27.length; r3 < n3; ) {
        var i3 = e27.charCodeAt(r3++);
        if (i3 >= 55296 && i3 <= 56319 && r3 < n3) {
          var a3 = e27.charCodeAt(r3++);
          (64512 & a3) == 56320 ? t4.push(((1023 & i3) << 10) + (1023 & a3) + 65536) : (t4.push(i3), r3--);
        } else
          t4.push(i3);
      }
      return t4;
    }
    var x2 = function(e27, t4) {
      return e27 + 22 + 75 * (e27 < 26) - ((t4 != 0) << 5);
    }, b2 = function(e27, t4, r3) {
      var n3 = 0;
      for (e27 = r3 ? d2(e27 / 700) : e27 >> 1, e27 += d2(e27 / t4); e27 > 455; n3 += 36)
        e27 = d2(e27 / 35);
      return d2(n3 + 36 * e27 / (e27 + 38));
    }, E2 = function(e27) {
      var t4, r3 = [], n3 = e27.length, i3 = 0, a3 = 128, o3 = 72, s3 = e27.lastIndexOf("-");
      s3 < 0 && (s3 = 0);
      for (var u3 = 0; u3 < s3; ++u3)
        e27.charCodeAt(u3) >= 128 && g2("not-basic"), r3.push(e27.charCodeAt(u3));
      for (var l3 = s3 > 0 ? s3 + 1 : 0; l3 < n3; ) {
        for (var p3 = i3, f3 = 1, h3 = 36; ; h3 += 36) {
          l3 >= n3 && g2("invalid-input");
          var m3 = (t4 = e27.charCodeAt(l3++)) - 48 < 10 ? t4 - 22 : t4 - 65 < 26 ? t4 - 65 : t4 - 97 < 26 ? t4 - 97 : 36;
          (m3 >= 36 || m3 > d2((c2 - i3) / f3)) && g2("overflow"), i3 += m3 * f3;
          var y3 = h3 <= o3 ? 1 : h3 >= o3 + 26 ? 26 : h3 - o3;
          if (m3 < y3)
            break;
          var v3 = 36 - y3;
          f3 > d2(c2 / v3) && g2("overflow"), f3 *= v3;
        }
        var x3 = r3.length + 1;
        o3 = b2(i3 - p3, x3, p3 == 0), d2(i3 / x3) > c2 - a3 && g2("overflow"), a3 += d2(i3 / x3), i3 %= x3, r3.splice(i3++, 0, a3);
      }
      return String.fromCodePoint.apply(String, r3);
    }, C2 = function(e27) {
      var t4 = [], r3 = (e27 = v2(e27)).length, n3 = 128, i3 = 0, a3 = 72, o3 = true, s3 = false, u3 = void 0;
      try {
        for (var l3, p3 = e27[Symbol.iterator](); !(o3 = (l3 = p3.next()).done); o3 = true) {
          var f3 = l3.value;
          f3 < 128 && t4.push(m2(f3));
        }
      } catch (e28) {
        s3 = true, u3 = e28;
      } finally {
        try {
          !o3 && p3.return && p3.return();
        } finally {
          if (s3)
            throw u3;
        }
      }
      var h3 = t4.length, y3 = h3;
      for (h3 && t4.push("-"); y3 < r3; ) {
        var E3 = c2, C3 = true, S3 = false, k3 = void 0;
        try {
          for (var D3, F3 = e27[Symbol.iterator](); !(C3 = (D3 = F3.next()).done); C3 = true) {
            var A3 = D3.value;
            A3 >= n3 && A3 < E3 && (E3 = A3);
          }
        } catch (e28) {
          S3 = true, k3 = e28;
        } finally {
          try {
            !C3 && F3.return && F3.return();
          } finally {
            if (S3)
              throw k3;
          }
        }
        var w3 = y3 + 1;
        E3 - n3 > d2((c2 - i3) / w3) && g2("overflow"), i3 += (E3 - n3) * w3, n3 = E3;
        var _3 = true, T3 = false, P3 = void 0;
        try {
          for (var I3, B3 = e27[Symbol.iterator](); !(_3 = (I3 = B3.next()).done); _3 = true) {
            var O3 = I3.value;
            if (O3 < n3 && ++i3 > c2 && g2("overflow"), O3 == n3) {
              for (var L3 = i3, N3 = 36; ; N3 += 36) {
                var j3 = N3 <= a3 ? 1 : N3 >= a3 + 26 ? 26 : N3 - a3;
                if (L3 < j3)
                  break;
                var R3 = L3 - j3, M3 = 36 - j3;
                t4.push(m2(x2(j3 + R3 % M3, 0))), L3 = d2(R3 / M3);
              }
              t4.push(m2(x2(L3, 0))), a3 = b2(i3, w3, y3 == h3), i3 = 0, ++y3;
            }
          }
        } catch (e28) {
          T3 = true, P3 = e28;
        } finally {
          try {
            !_3 && B3.return && B3.return();
          } finally {
            if (T3)
              throw P3;
          }
        }
        ++i3, ++n3;
      }
      return t4.join("");
    }, S2 = { version: "2.1.0", ucs2: { decode: v2, encode: function(e27) {
      return String.fromCodePoint.apply(String, function(e28) {
        if (Array.isArray(e28)) {
          for (var t4 = 0, r3 = Array(e28.length); t4 < e28.length; t4++)
            r3[t4] = e28[t4];
          return r3;
        }
        return Array.from(e28);
      }(e27));
    } }, decode: E2, encode: C2, toASCII: function(e27) {
      return y2(e27, function(e28) {
        return p2.test(e28) ? "xn--" + C2(e28) : e28;
      });
    }, toUnicode: function(e27) {
      return y2(e27, function(e28) {
        return l2.test(e28) ? E2(e28.slice(4).toLowerCase()) : e28;
      });
    } }, k2 = {};
    function D2(e27) {
      var t4 = e27.charCodeAt(0);
      return t4 < 16 ? "%0" + t4.toString(16).toUpperCase() : t4 < 128 ? "%" + t4.toString(16).toUpperCase() : t4 < 2048 ? "%" + (t4 >> 6 | 192).toString(16).toUpperCase() + "%" + (63 & t4 | 128).toString(16).toUpperCase() : "%" + (t4 >> 12 | 224).toString(16).toUpperCase() + "%" + (t4 >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (63 & t4 | 128).toString(16).toUpperCase();
    }
    function F2(e27) {
      for (var t4 = "", r3 = 0, n3 = e27.length; r3 < n3; ) {
        var i3 = parseInt(e27.substr(r3 + 1, 2), 16);
        if (i3 < 128)
          t4 += String.fromCharCode(i3), r3 += 3;
        else if (i3 >= 194 && i3 < 224) {
          if (n3 - r3 >= 6) {
            var a3 = parseInt(e27.substr(r3 + 4, 2), 16);
            t4 += String.fromCharCode((31 & i3) << 6 | 63 & a3);
          } else
            t4 += e27.substr(r3, 6);
          r3 += 6;
        } else if (i3 >= 224) {
          if (n3 - r3 >= 9) {
            var o3 = parseInt(e27.substr(r3 + 4, 2), 16), s3 = parseInt(e27.substr(r3 + 7, 2), 16);
            t4 += String.fromCharCode((15 & i3) << 12 | (63 & o3) << 6 | 63 & s3);
          } else
            t4 += e27.substr(r3, 9);
          r3 += 9;
        } else
          t4 += e27.substr(r3, 3), r3 += 3;
      }
      return t4;
    }
    function A2(e27, t4) {
      function r3(e28) {
        var r4 = F2(e28);
        return r4.match(t4.UNRESERVED) ? r4 : e28;
      }
      return e27.scheme && (e27.scheme = String(e27.scheme).replace(t4.PCT_ENCODED, r3).toLowerCase().replace(t4.NOT_SCHEME, "")), e27.userinfo !== void 0 && (e27.userinfo = String(e27.userinfo).replace(t4.PCT_ENCODED, r3).replace(t4.NOT_USERINFO, D2).replace(t4.PCT_ENCODED, i2)), e27.host !== void 0 && (e27.host = String(e27.host).replace(t4.PCT_ENCODED, r3).toLowerCase().replace(t4.NOT_HOST, D2).replace(t4.PCT_ENCODED, i2)), e27.path !== void 0 && (e27.path = String(e27.path).replace(t4.PCT_ENCODED, r3).replace(e27.scheme ? t4.NOT_PATH : t4.NOT_PATH_NOSCHEME, D2).replace(t4.PCT_ENCODED, i2)), e27.query !== void 0 && (e27.query = String(e27.query).replace(t4.PCT_ENCODED, r3).replace(t4.NOT_QUERY, D2).replace(t4.PCT_ENCODED, i2)), e27.fragment !== void 0 && (e27.fragment = String(e27.fragment).replace(t4.PCT_ENCODED, r3).replace(t4.NOT_FRAGMENT, D2).replace(t4.PCT_ENCODED, i2)), e27;
    }
    function w2(e27) {
      return e27.replace(/^0*(.*)/, "$1") || "0";
    }
    function _2(e27, t4) {
      var r3 = e27.match(t4.IPV4ADDRESS) || [], n3 = u2(r3, 2)[1];
      return n3 ? n3.split(".").map(w2).join(".") : e27;
    }
    function T2(e27, t4) {
      var r3 = e27.match(t4.IPV6ADDRESS) || [], n3 = u2(r3, 3), i3 = n3[1], a3 = n3[2];
      if (i3) {
        for (var o3 = i3.toLowerCase().split("::").reverse(), s3 = u2(o3, 2), c3 = s3[0], l3 = s3[1], p3 = l3 ? l3.split(":").map(w2) : [], f3 = c3.split(":").map(w2), h3 = t4.IPV4ADDRESS.test(f3[f3.length - 1]), d3 = h3 ? 7 : 8, m3 = f3.length - d3, g3 = Array(d3), y3 = 0; y3 < d3; ++y3)
          g3[y3] = p3[y3] || f3[m3 + y3] || "";
        h3 && (g3[d3 - 1] = _2(g3[d3 - 1], t4));
        var v3 = g3.reduce(function(e28, t5, r4) {
          if (!t5 || t5 === "0") {
            var n4 = e28[e28.length - 1];
            n4 && n4.index + n4.length === r4 ? n4.length++ : e28.push({ index: r4, length: 1 });
          }
          return e28;
        }, []).sort(function(e28, t5) {
          return t5.length - e28.length;
        })[0], x3 = void 0;
        if (v3 && v3.length > 1) {
          var b3 = g3.slice(0, v3.index), E3 = g3.slice(v3.index + v3.length);
          x3 = b3.join(":") + "::" + E3.join(":");
        } else
          x3 = g3.join(":");
        return a3 && (x3 += "%" + a3), x3;
      }
      return e27;
    }
    var P2 = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i, I2 = "".match(/(){0}/)[1] === void 0;
    function B2(e27) {
      var t4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = {}, n3 = t4.iri !== false ? s2 : o2;
      t4.reference === "suffix" && (e27 = (t4.scheme ? t4.scheme + ":" : "") + "//" + e27);
      var i3 = e27.match(P2);
      if (i3) {
        I2 ? (r3.scheme = i3[1], r3.userinfo = i3[3], r3.host = i3[4], r3.port = parseInt(i3[5], 10), r3.path = i3[6] || "", r3.query = i3[7], r3.fragment = i3[8], isNaN(r3.port) && (r3.port = i3[5])) : (r3.scheme = i3[1] || void 0, r3.userinfo = e27.indexOf("@") !== -1 ? i3[3] : void 0, r3.host = e27.indexOf("//") !== -1 ? i3[4] : void 0, r3.port = parseInt(i3[5], 10), r3.path = i3[6] || "", r3.query = e27.indexOf("?") !== -1 ? i3[7] : void 0, r3.fragment = e27.indexOf("#") !== -1 ? i3[8] : void 0, isNaN(r3.port) && (r3.port = e27.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? i3[4] : void 0)), r3.host && (r3.host = T2(_2(r3.host, n3), n3)), r3.scheme !== void 0 || r3.userinfo !== void 0 || r3.host !== void 0 || r3.port !== void 0 || r3.path || r3.query !== void 0 ? r3.scheme === void 0 ? r3.reference = "relative" : r3.fragment === void 0 ? r3.reference = "absolute" : r3.reference = "uri" : r3.reference = "same-document", t4.reference && t4.reference !== "suffix" && t4.reference !== r3.reference && (r3.error = r3.error || "URI is not a " + t4.reference + " reference.");
        var a3 = k2[(t4.scheme || r3.scheme || "").toLowerCase()];
        if (t4.unicodeSupport || a3 && a3.unicodeSupport)
          A2(r3, n3);
        else {
          if (r3.host && (t4.domainHost || a3 && a3.domainHost))
            try {
              r3.host = S2.toASCII(r3.host.replace(n3.PCT_ENCODED, F2).toLowerCase());
            } catch (e28) {
              r3.error = r3.error || "Host's domain name can not be converted to ASCII via punycode: " + e28;
            }
          A2(r3, o2);
        }
        a3 && a3.parse && a3.parse(r3, t4);
      } else
        r3.error = r3.error || "URI can not be parsed.";
      return r3;
    }
    var O2 = /^\.\.?\//, L2 = /^\/\.(\/|$)/, N2 = /^\/\.\.(\/|$)/, j2 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function R2(e27) {
      for (var t4 = []; e27.length; )
        if (e27.match(O2))
          e27 = e27.replace(O2, "");
        else if (e27.match(L2))
          e27 = e27.replace(L2, "/");
        else if (e27.match(N2))
          e27 = e27.replace(N2, "/"), t4.pop();
        else if (e27 === "." || e27 === "..")
          e27 = "";
        else {
          var r3 = e27.match(j2);
          if (!r3)
            throw new Error("Unexpected dot segment condition");
          var n3 = r3[0];
          e27 = e27.slice(n3.length), t4.push(n3);
        }
      return t4.join("");
    }
    function M2(e27) {
      var t4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = t4.iri ? s2 : o2, n3 = [], i3 = k2[(t4.scheme || e27.scheme || "").toLowerCase()];
      if (i3 && i3.serialize && i3.serialize(e27, t4), e27.host) {
        if (r3.IPV6ADDRESS.test(e27.host))
          ;
        else if (t4.domainHost || i3 && i3.domainHost)
          try {
            e27.host = t4.iri ? S2.toUnicode(e27.host) : S2.toASCII(e27.host.replace(r3.PCT_ENCODED, F2).toLowerCase());
          } catch (r4) {
            e27.error = e27.error || "Host's domain name can not be converted to " + (t4.iri ? "Unicode" : "ASCII") + " via punycode: " + r4;
          }
      }
      A2(e27, r3), t4.reference !== "suffix" && e27.scheme && (n3.push(e27.scheme), n3.push(":"));
      var a3 = function(e28, t5) {
        var r4 = t5.iri !== false ? s2 : o2, n4 = [];
        return e28.userinfo !== void 0 && (n4.push(e28.userinfo), n4.push("@")), e28.host !== void 0 && n4.push(T2(_2(String(e28.host), r4), r4).replace(r4.IPV6ADDRESS, function(e29, t6, r5) {
          return "[" + t6 + (r5 ? "%25" + r5 : "") + "]";
        })), typeof e28.port == "number" && (n4.push(":"), n4.push(e28.port.toString(10))), n4.length ? n4.join("") : void 0;
      }(e27, t4);
      if (a3 !== void 0 && (t4.reference !== "suffix" && n3.push("//"), n3.push(a3), e27.path && e27.path.charAt(0) !== "/" && n3.push("/")), e27.path !== void 0) {
        var u3 = e27.path;
        t4.absolutePath || i3 && i3.absolutePath || (u3 = R2(u3)), a3 === void 0 && (u3 = u3.replace(/^\/\//, "/%2F")), n3.push(u3);
      }
      return e27.query !== void 0 && (n3.push("?"), n3.push(e27.query)), e27.fragment !== void 0 && (n3.push("#"), n3.push(e27.fragment)), n3.join("");
    }
    function V2(e27, t4) {
      var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n3 = {};
      return arguments[3] || (e27 = B2(M2(e27, r3), r3), t4 = B2(M2(t4, r3), r3)), !(r3 = r3 || {}).tolerant && t4.scheme ? (n3.scheme = t4.scheme, n3.userinfo = t4.userinfo, n3.host = t4.host, n3.port = t4.port, n3.path = R2(t4.path || ""), n3.query = t4.query) : (t4.userinfo !== void 0 || t4.host !== void 0 || t4.port !== void 0 ? (n3.userinfo = t4.userinfo, n3.host = t4.host, n3.port = t4.port, n3.path = R2(t4.path || ""), n3.query = t4.query) : (t4.path ? (t4.path.charAt(0) === "/" ? n3.path = R2(t4.path) : (e27.userinfo === void 0 && e27.host === void 0 && e27.port === void 0 || e27.path ? e27.path ? n3.path = e27.path.slice(0, e27.path.lastIndexOf("/") + 1) + t4.path : n3.path = t4.path : n3.path = "/" + t4.path, n3.path = R2(n3.path)), n3.query = t4.query) : (n3.path = e27.path, t4.query !== void 0 ? n3.query = t4.query : n3.query = e27.query), n3.userinfo = e27.userinfo, n3.host = e27.host, n3.port = e27.port), n3.scheme = e27.scheme), n3.fragment = t4.fragment, n3;
    }
    function U2(e27, t4) {
      return e27 && e27.toString().replace(t4 && t4.iri ? s2.PCT_ENCODED : o2.PCT_ENCODED, F2);
    }
    var q2 = { scheme: "http", domainHost: true, parse: function(e27, t4) {
      return e27.host || (e27.error = e27.error || "HTTP URIs must have a host."), e27;
    }, serialize: function(e27, t4) {
      return e27.port !== (String(e27.scheme).toLowerCase() !== "https" ? 80 : 443) && e27.port !== "" || (e27.port = void 0), e27.path || (e27.path = "/"), e27;
    } }, W2 = { scheme: "https", domainHost: q2.domainHost, parse: q2.parse, serialize: q2.serialize }, $2 = {}, G2 = "[A-Za-z0-9\\-\\.\\_\\~\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]", z2 = "[0-9A-Fa-f]", H2 = r2(r2("%[EFef][0-9A-Fa-f]%" + z2 + z2 + "%" + z2 + z2) + "|" + r2("%[89A-Fa-f][0-9A-Fa-f]%" + z2 + z2) + "|" + r2("%" + z2 + z2)), K2 = t3("[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]", '[\\"\\\\]'), J2 = new RegExp(G2, "g"), Q2 = new RegExp(H2, "g"), X2 = new RegExp(t3("[^]", "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]", "[\\.]", '[\\"]', K2), "g"), Y2 = new RegExp(t3("[^]", G2, "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]"), "g"), Z2 = Y2;
    function ee2(e27) {
      var t4 = F2(e27);
      return t4.match(J2) ? t4 : e27;
    }
    var te2 = { scheme: "mailto", parse: function(e27, t4) {
      var r3 = e27, n3 = r3.to = r3.path ? r3.path.split(",") : [];
      if (r3.path = void 0, r3.query) {
        for (var i3 = false, a3 = {}, o3 = r3.query.split("&"), s3 = 0, u3 = o3.length; s3 < u3; ++s3) {
          var c3 = o3[s3].split("=");
          switch (c3[0]) {
            case "to":
              for (var l3 = c3[1].split(","), p3 = 0, f3 = l3.length; p3 < f3; ++p3)
                n3.push(l3[p3]);
              break;
            case "subject":
              r3.subject = U2(c3[1], t4);
              break;
            case "body":
              r3.body = U2(c3[1], t4);
              break;
            default:
              i3 = true, a3[U2(c3[0], t4)] = U2(c3[1], t4);
          }
        }
        i3 && (r3.headers = a3);
      }
      r3.query = void 0;
      for (var h3 = 0, d3 = n3.length; h3 < d3; ++h3) {
        var m3 = n3[h3].split("@");
        if (m3[0] = U2(m3[0]), t4.unicodeSupport)
          m3[1] = U2(m3[1], t4).toLowerCase();
        else
          try {
            m3[1] = S2.toASCII(U2(m3[1], t4).toLowerCase());
          } catch (e28) {
            r3.error = r3.error || "Email address's domain name can not be converted to ASCII via punycode: " + e28;
          }
        n3[h3] = m3.join("@");
      }
      return r3;
    }, serialize: function(e27, t4) {
      var r3, n3 = e27, a3 = (r3 = e27.to) != null ? r3 instanceof Array ? r3 : typeof r3.length != "number" || r3.split || r3.setInterval || r3.call ? [r3] : Array.prototype.slice.call(r3) : [];
      if (a3) {
        for (var o3 = 0, s3 = a3.length; o3 < s3; ++o3) {
          var u3 = String(a3[o3]), c3 = u3.lastIndexOf("@"), l3 = u3.slice(0, c3).replace(Q2, ee2).replace(Q2, i2).replace(X2, D2), p3 = u3.slice(c3 + 1);
          try {
            p3 = t4.iri ? S2.toUnicode(p3) : S2.toASCII(U2(p3, t4).toLowerCase());
          } catch (e28) {
            n3.error = n3.error || "Email address's domain name can not be converted to " + (t4.iri ? "Unicode" : "ASCII") + " via punycode: " + e28;
          }
          a3[o3] = l3 + "@" + p3;
        }
        n3.path = a3.join(",");
      }
      var f3 = e27.headers = e27.headers || {};
      e27.subject && (f3.subject = e27.subject), e27.body && (f3.body = e27.body);
      var h3 = [];
      for (var d3 in f3)
        f3[d3] !== $2[d3] && h3.push(d3.replace(Q2, ee2).replace(Q2, i2).replace(Y2, D2) + "=" + f3[d3].replace(Q2, ee2).replace(Q2, i2).replace(Z2, D2));
      return h3.length && (n3.query = h3.join("&")), n3;
    } }, re2 = /^([^\:]+)\:(.*)/, ne2 = { scheme: "urn", parse: function(e27, t4) {
      var r3 = e27.path && e27.path.match(re2), n3 = e27;
      if (r3) {
        var i3 = t4.scheme || n3.scheme || "urn", a3 = r3[1].toLowerCase(), o3 = r3[2], s3 = i3 + ":" + (t4.nid || a3), u3 = k2[s3];
        n3.nid = a3, n3.nss = o3, n3.path = void 0, u3 && (n3 = u3.parse(n3, t4));
      } else
        n3.error = n3.error || "URN can not be parsed.";
      return n3;
    }, serialize: function(e27, t4) {
      var r3 = t4.scheme || e27.scheme || "urn", n3 = e27.nid, i3 = r3 + ":" + (t4.nid || n3), a3 = k2[i3];
      a3 && (e27 = a3.serialize(e27, t4));
      var o3 = e27, s3 = e27.nss;
      return o3.path = (n3 || t4.nid) + ":" + s3, o3;
    } }, ie2 = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/, ae2 = { scheme: "urn:uuid", parse: function(e27, t4) {
      var r3 = e27;
      return r3.uuid = r3.nss, r3.nss = void 0, t4.tolerant || r3.uuid && r3.uuid.match(ie2) || (r3.error = r3.error || "UUID is not valid."), r3;
    }, serialize: function(e27, t4) {
      var r3 = e27;
      return r3.nss = (e27.uuid || "").toLowerCase(), r3;
    } };
    k2[q2.scheme] = q2, k2[W2.scheme] = W2, k2[te2.scheme] = te2, k2[ne2.scheme] = ne2, k2[ae2.scheme] = ae2, e26.SCHEMES = k2, e26.pctEncChar = D2, e26.pctDecChars = F2, e26.parse = B2, e26.removeDotSegments = R2, e26.serialize = M2, e26.resolveComponents = V2, e26.resolve = function(e27, t4, r3) {
      var n3 = function(e28, t5) {
        var r4 = e28;
        if (t5)
          for (var n4 in t5)
            r4[n4] = t5[n4];
        return r4;
      }({ scheme: "null" }, r3);
      return M2(V2(B2(e27, n3), B2(t4, n3), n3, true), n3);
    }, e26.normalize = function(e27, t4) {
      return typeof e27 == "string" ? e27 = M2(B2(e27, t4), t4) : n2(e27) === "object" && (e27 = B2(M2(e27, t4), t4)), e27;
    }, e26.equal = function(e27, t4, r3) {
      return typeof e27 == "string" ? e27 = M2(B2(e27, r3), r3) : n2(e27) === "object" && (e27 = M2(e27, r3)), typeof t4 == "string" ? t4 = M2(B2(t4, r3), r3) : n2(t4) === "object" && (t4 = M2(t4, r3)), e27 === t4;
    }, e26.escapeComponent = function(e27, t4) {
      return e27 && e27.toString().replace(t4 && t4.iri ? s2.ESCAPE : o2.ESCAPE, D2);
    }, e26.unescapeComponent = U2, Object.defineProperty(e26, "__esModule", { value: true });
  }(t2);
}));
t(Ay);
var wy = Array.isArray, _y = Object.keys, Ty = Object.prototype.hasOwnProperty, Py = function e21(t2, r2) {
  if (t2 === r2)
    return true;
  if (t2 && r2 && i(t2) == "object" && i(r2) == "object") {
    var n2, a2, o2, s2 = wy(t2), u2 = wy(r2);
    if (s2 && u2) {
      if ((a2 = t2.length) != r2.length)
        return false;
      for (n2 = a2; n2-- != 0; )
        if (!e21(t2[n2], r2[n2]))
          return false;
      return true;
    }
    if (s2 != u2)
      return false;
    var c2 = t2 instanceof Date, l2 = r2 instanceof Date;
    if (c2 != l2)
      return false;
    if (c2 && l2)
      return t2.getTime() == r2.getTime();
    var p2 = t2 instanceof RegExp, f2 = r2 instanceof RegExp;
    if (p2 != f2)
      return false;
    if (p2 && f2)
      return t2.toString() == r2.toString();
    var h2 = _y(t2);
    if ((a2 = h2.length) !== _y(r2).length)
      return false;
    for (n2 = a2; n2-- != 0; )
      if (!Ty.call(r2, h2[n2]))
        return false;
    for (n2 = a2; n2-- != 0; )
      if (!e21(t2[o2 = h2[n2]], r2[o2]))
        return false;
    return true;
  }
  return t2 != t2 && r2 != r2;
}, Iy = { copy: function(e25, t2) {
  for (var r2 in t2 = t2 || {}, e25)
    t2[r2] = e25[r2];
  return t2;
}, checkDataType: By, checkDataTypes: function(e25, t2) {
  switch (e25.length) {
    case 1:
      return By(e25[0], t2, true);
    default:
      var r2 = "", n2 = Ly(e25);
      for (var i2 in n2.array && n2.object && (r2 = n2.null ? "(" : "(!" + t2 + " || ", r2 += "typeof " + t2 + ' !== "object")', delete n2.null, delete n2.array, delete n2.object), n2.number && delete n2.integer, n2)
        r2 += (r2 ? " && " : "") + By(i2, t2, true);
      return r2;
  }
}, coerceToTypes: function(e25, t2) {
  if (Array.isArray(t2)) {
    for (var r2 = [], n2 = 0; n2 < t2.length; n2++) {
      var i2 = t2[n2];
      Oy[i2] ? r2[r2.length] = i2 : e25 === "array" && i2 === "array" && (r2[r2.length] = i2);
    }
    if (r2.length)
      return r2;
  } else {
    if (Oy[t2])
      return [t2];
    if (e25 === "array" && t2 === "array")
      return ["array"];
  }
}, toHash: Ly, getProperty: Ry, escapeQuotes: My, equal: Py, ucs2length: function(e25) {
  for (var t2, r2 = 0, n2 = e25.length, i2 = 0; i2 < n2; )
    r2++, (t2 = e25.charCodeAt(i2++)) >= 55296 && t2 <= 56319 && i2 < n2 && (64512 & (t2 = e25.charCodeAt(i2))) == 56320 && i2++;
  return r2;
}, varOccurences: function(e25, t2) {
  t2 += "[^0-9]";
  var r2 = e25.match(new RegExp(t2, "g"));
  return r2 ? r2.length : 0;
}, varReplace: function(e25, t2, r2) {
  return t2 += "([^0-9])", r2 = r2.replace(/\$/g, "$$$$"), e25.replace(new RegExp(t2, "g"), r2 + "$1");
}, cleanUpCode: function(e25) {
  return e25.replace(Vy, "").replace(Uy, "").replace(qy, "if (!($1))");
}, finalCleanUpCode: function(e25, t2) {
  var r2 = e25.match(Wy);
  r2 && r2.length == 2 && (e25 = t2 ? e25.replace(Gy, "").replace(Ky, Jy) : e25.replace($y, "").replace(zy, Hy));
  return (r2 = e25.match(Qy)) && r2.length === 3 ? e25.replace(Xy, "") : e25;
}, schemaHasRules: function(e25, t2) {
  if (typeof e25 == "boolean")
    return !e25;
  for (var r2 in e25)
    if (t2[r2])
      return true;
}, schemaHasRulesExcept: function(e25, t2, r2) {
  if (typeof e25 == "boolean")
    return !e25 && r2 != "not";
  for (var n2 in e25)
    if (n2 != r2 && t2[n2])
      return true;
}, schemaUnknownRules: function(e25, t2) {
  if (typeof e25 == "boolean")
    return;
  for (var r2 in e25)
    if (!t2[r2])
      return r2;
}, toQuotedString: Yy, getPathExpr: function(e25, t2, r2, n2) {
  return tv(e25, r2 ? "'/' + " + t2 + (n2 ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : n2 ? "'[' + " + t2 + " + ']'" : "'[\\'' + " + t2 + " + '\\']'");
}, getPath: function(e25, t2, r2) {
  var n2 = Yy(r2 ? "/" + rv(t2) : Ry(t2));
  return tv(e25, n2);
}, getData: function(e25, t2, r2) {
  var n2, i2, a2, o2;
  if (e25 === "")
    return "rootData";
  if (e25[0] == "/") {
    if (!Zy.test(e25))
      throw new Error("Invalid JSON-pointer: " + e25);
    i2 = e25, a2 = "rootData";
  } else {
    if (!(o2 = e25.match(ev)))
      throw new Error("Invalid JSON-pointer: " + e25);
    if (n2 = +o2[1], (i2 = o2[2]) == "#") {
      if (n2 >= t2)
        throw new Error("Cannot access property/index " + n2 + " levels up, current level is " + t2);
      return r2[t2 - n2];
    }
    if (n2 > t2)
      throw new Error("Cannot access data " + n2 + " levels up, current level is " + t2);
    if (a2 = "data" + (t2 - n2 || ""), !i2)
      return a2;
  }
  for (var s2 = a2, u2 = i2.split("/"), c2 = 0; c2 < u2.length; c2++) {
    var l2 = u2[c2];
    l2 && (a2 += Ry(nv(l2)), s2 += " && " + a2);
  }
  return s2;
}, unescapeFragment: function(e25) {
  return nv(decodeURIComponent(e25));
}, unescapeJsonPointer: nv, escapeFragment: function(e25) {
  return encodeURIComponent(rv(e25));
}, escapeJsonPointer: rv };
function By(e25, t2, r2) {
  var n2 = r2 ? " !== " : " === ", i2 = r2 ? " || " : " && ", a2 = r2 ? "!" : "", o2 = r2 ? "" : "!";
  switch (e25) {
    case "null":
      return t2 + n2 + "null";
    case "array":
      return a2 + "Array.isArray(" + t2 + ")";
    case "object":
      return "(" + a2 + t2 + i2 + "typeof " + t2 + n2 + '"object"' + i2 + o2 + "Array.isArray(" + t2 + "))";
    case "integer":
      return "(typeof " + t2 + n2 + '"number"' + i2 + o2 + "(" + t2 + " % 1)" + i2 + t2 + n2 + t2 + ")";
    default:
      return "typeof " + t2 + n2 + '"' + e25 + '"';
  }
}
var Oy = Ly(["string", "number", "integer", "boolean", "null"]);
function Ly(e25) {
  for (var t2 = {}, r2 = 0; r2 < e25.length; r2++)
    t2[e25[r2]] = true;
  return t2;
}
var Ny = /^[a-z$_][a-z$_0-9]*$/i, jy = /'|\\/g;
function Ry(e25) {
  return typeof e25 == "number" ? "[" + e25 + "]" : Ny.test(e25) ? "." + e25 : "['" + My(e25) + "']";
}
function My(e25) {
  return e25.replace(jy, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
}
var Vy = /else\s*{\s*}/g, Uy = /if\s*\([^)]+\)\s*\{\s*\}(?!\s*else)/g, qy = /if\s*\(([^)]+)\)\s*\{\s*\}\s*else(?!\s*if)/g;
var Wy = /[^v.]errors/g, $y = /var errors = 0;|var vErrors = null;|validate.errors = vErrors;/g, Gy = /var errors = 0;|var vErrors = null;/g, zy = "return errors === 0;", Hy = "validate.errors = null; return true;", Ky = /if \(errors === 0\) return data;\s*else throw new ValidationError\(vErrors\);/, Jy = "return data;", Qy = /[^A-Za-z_$]rootData[^A-Za-z0-9_$]/g, Xy = /if \(rootData === undefined\) rootData = data;/;
function Yy(e25) {
  return "'" + My(e25) + "'";
}
var Zy = /^\/(?:[^~]|~0|~1)*$/, ev = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function tv(e25, t2) {
  return e25 == '""' ? t2 : (e25 + " + " + t2).replace(/' \+ '/g, "");
}
function rv(e25) {
  return e25.replace(/~/g, "~0").replace(/\//g, "~1");
}
function nv(e25) {
  return e25.replace(/~1/g, "/").replace(/~0/g, "~");
}
var iv = function(e25) {
  Iy.copy(e25, this);
};
var av = r(function(e25) {
  var t2 = e25.exports = function(e26, r2, n2) {
    typeof r2 == "function" && (n2 = r2, r2 = {}), function e27(r3, n3, a2, o2, s2, u2, c2, l2, p2, f2) {
      if (o2 && i(o2) == "object" && !Array.isArray(o2)) {
        for (var h2 in n3(o2, s2, u2, c2, l2, p2, f2), o2) {
          var d2 = o2[h2];
          if (Array.isArray(d2)) {
            if (h2 in t2.arrayKeywords)
              for (var m2 = 0; m2 < d2.length; m2++)
                e27(r3, n3, a2, d2[m2], s2 + "/" + h2 + "/" + m2, u2, s2, h2, o2, m2);
          } else if (h2 in t2.propsKeywords) {
            if (d2 && i(d2) == "object")
              for (var g2 in d2)
                e27(r3, n3, a2, d2[g2], s2 + "/" + h2 + "/" + g2.replace(/~/g, "~0").replace(/\//g, "~1"), u2, s2, h2, o2, g2);
          } else
            (h2 in t2.keywords || r3.allKeys && !(h2 in t2.skipKeywords)) && e27(r3, n3, a2, d2, s2 + "/" + h2, u2, s2, h2, o2);
        }
        a2(o2, s2, u2, c2, l2, p2, f2);
      }
    }(r2, typeof (n2 = r2.cb || n2) == "function" ? n2 : n2.pre || function() {
    }, n2.post || function() {
    }, e26, "", e26);
  };
  t2.keywords = { additionalItems: true, items: true, contains: true, additionalProperties: true, propertyNames: true, not: true }, t2.arrayKeywords = { items: true, allOf: true, anyOf: true, oneOf: true }, t2.propsKeywords = { definitions: true, properties: true, patternProperties: true, dependencies: true }, t2.skipKeywords = { default: true, enum: true, const: true, required: true, maximum: true, minimum: true, exclusiveMaximum: true, exclusiveMinimum: true, multipleOf: true, maxLength: true, minLength: true, pattern: true, format: true, maxItems: true, minItems: true, uniqueItems: true, maxProperties: true, minProperties: true };
}), ov = sv$2;
function sv$2(e25, t2, r2) {
  var n2 = this._refs[r2];
  if (typeof n2 == "string") {
    if (!this._refs[n2])
      return sv$2.call(this, e25, t2, n2);
    n2 = this._refs[n2];
  }
  if ((n2 = n2 || this._schemas[r2]) instanceof iv)
    return hv(n2.schema, this._opts.inlineRefs) ? n2.schema : n2.validate || this._compile(n2);
  var i2, a2, o2, s2 = uv.call(this, t2, r2);
  return s2 && (i2 = s2.schema, t2 = s2.root, o2 = s2.baseId), i2 instanceof iv ? a2 = i2.validate || e25.call(this, i2.schema, t2, void 0, o2) : i2 !== void 0 && (a2 = hv(i2, this._opts.inlineRefs) ? i2 : e25.call(this, i2, t2, void 0, o2)), a2;
}
function uv(e25, t2) {
  var r2 = Ay.parse(t2), n2 = mv(r2), i2 = dv(this._getId(e25.schema));
  if (Object.keys(e25.schema).length === 0 || n2 !== i2) {
    var a2 = yv(n2), o2 = this._refs[a2];
    if (typeof o2 == "string")
      return cv.call(this, e25, o2, r2);
    if (o2 instanceof iv)
      o2.validate || this._compile(o2), e25 = o2;
    else {
      if (!((o2 = this._schemas[a2]) instanceof iv))
        return;
      if (o2.validate || this._compile(o2), a2 == yv(t2))
        return { schema: o2, root: e25, baseId: i2 };
      e25 = o2;
    }
    if (!e25.schema)
      return;
    i2 = dv(this._getId(e25.schema));
  }
  return pv.call(this, r2, i2, e25.schema, e25);
}
function cv(e25, t2, r2) {
  var n2 = uv.call(this, e25, t2);
  if (n2) {
    var i2 = n2.schema, a2 = n2.baseId;
    e25 = n2.root;
    var o2 = this._getId(i2);
    return o2 && (a2 = vv(a2, o2)), pv.call(this, r2, a2, i2, e25);
  }
}
sv$2.normalizeId = yv, sv$2.fullPath = dv, sv$2.url = vv, sv$2.ids = function(e25) {
  var t2 = yv(this._getId(e25)), r2 = { "": t2 }, n2 = { "": dv(t2, false) }, i2 = {}, a2 = this;
  return av(e25, { allKeys: true }, function(e26, t3, o2, s2, u2, c2, l2) {
    if (t3 !== "") {
      var p2 = a2._getId(e26), f2 = r2[s2], h2 = n2[s2] + "/" + u2;
      if (l2 !== void 0 && (h2 += "/" + (typeof l2 == "number" ? l2 : Iy.escapeFragment(l2))), typeof p2 == "string") {
        p2 = f2 = yv(f2 ? Ay.resolve(f2, p2) : p2);
        var d2 = a2._refs[p2];
        if (typeof d2 == "string" && (d2 = a2._refs[d2]), d2 && d2.schema) {
          if (!Py(e26, d2.schema))
            throw new Error('id "' + p2 + '" resolves to more than one schema');
        } else if (p2 != yv(h2))
          if (p2[0] == "#") {
            if (i2[p2] && !Py(e26, i2[p2]))
              throw new Error('id "' + p2 + '" resolves to more than one schema');
            i2[p2] = e26;
          } else
            a2._refs[p2] = h2;
      }
      r2[t3] = f2, n2[t3] = h2;
    }
  }), i2;
}, sv$2.inlineRef = hv, sv$2.schema = uv;
var lv = Iy.toHash(["properties", "patternProperties", "enum", "dependencies", "definitions"]);
function pv(e25, t2, r2, n2) {
  if (e25.fragment = e25.fragment || "", e25.fragment.slice(0, 1) == "/") {
    for (var i2 = e25.fragment.split("/"), a2 = 1; a2 < i2.length; a2++) {
      var o2 = i2[a2];
      if (o2) {
        if ((r2 = r2[o2 = Iy.unescapeFragment(o2)]) === void 0)
          break;
        var s2;
        if (!lv[o2] && ((s2 = this._getId(r2)) && (t2 = vv(t2, s2)), r2.$ref)) {
          var u2 = vv(t2, r2.$ref), c2 = uv.call(this, n2, u2);
          c2 && (r2 = c2.schema, n2 = c2.root, t2 = c2.baseId);
        }
      }
    }
    return r2 !== void 0 && r2 !== n2.schema ? { schema: r2, root: n2, baseId: t2 } : void 0;
  }
}
var fv = Iy.toHash(["type", "format", "pattern", "maxLength", "minLength", "maxProperties", "minProperties", "maxItems", "minItems", "maximum", "minimum", "uniqueItems", "multipleOf", "required", "enum"]);
function hv(e25, t2) {
  return t2 !== false && (t2 === void 0 || t2 === true ? function e26(t3) {
    var r2;
    if (Array.isArray(t3)) {
      for (var n2 = 0; n2 < t3.length; n2++)
        if (i(r2 = t3[n2]) == "object" && !e26(r2))
          return false;
    } else
      for (var a2 in t3) {
        if (a2 == "$ref")
          return false;
        if (i(r2 = t3[a2]) == "object" && !e26(r2))
          return false;
      }
    return true;
  }(e25) : t2 ? function e26(t3) {
    var r2, n2 = 0;
    if (Array.isArray(t3)) {
      for (var a2 = 0; a2 < t3.length; a2++)
        if (i(r2 = t3[a2]) == "object" && (n2 += e26(r2)), n2 == 1 / 0)
          return 1 / 0;
    } else
      for (var o2 in t3) {
        if (o2 == "$ref")
          return 1 / 0;
        if (fv[o2])
          n2++;
        else if (i(r2 = t3[o2]) == "object" && (n2 += e26(r2) + 1), n2 == 1 / 0)
          return 1 / 0;
      }
    return n2;
  }(e25) <= t2 : void 0);
}
function dv(e25, t2) {
  return t2 !== false && (e25 = yv(e25)), mv(Ay.parse(e25));
}
function mv(e25) {
  return Ay.serialize(e25).split("#")[0] + "#";
}
var gv = /#\/?$/;
function yv(e25) {
  return e25 ? e25.replace(gv, "") : "";
}
function vv(e25, t2) {
  return t2 = yv(t2), Ay.resolve(e25, t2);
}
var xv = { Validation: Ev(function(e25) {
  this.message = "validation failed", this.errors = e25, this.ajv = this.validation = true;
}), MissingRef: Ev(bv) };
function bv(e25, t2, r2) {
  this.message = r2 || bv.message(e25, t2), this.missingRef = ov.url(e25, t2), this.missingSchema = ov.normalizeId(ov.fullPath(this.missingRef));
}
function Ev(e25) {
  return e25.prototype = Object.create(Error.prototype), e25.prototype.constructor = e25, e25;
}
bv.message = function(e25, t2) {
  return "can't resolve reference " + t2 + " from id " + e25;
};
var Cv = function(e25, t2) {
  t2 || (t2 = {}), typeof t2 == "function" && (t2 = { cmp: t2 });
  var r2 = typeof t2.cycles == "boolean" && t2.cycles, n2 = t2.cmp && function(e26) {
    return function(t3) {
      return function(r3, n3) {
        var i2 = { key: r3, value: t3[r3] }, a3 = { key: n3, value: t3[n3] };
        return e26(i2, a3);
      };
    };
  }(t2.cmp), a2 = [];
  return function e26(t3) {
    if (t3 && t3.toJSON && typeof t3.toJSON == "function" && (t3 = t3.toJSON()), t3 !== void 0) {
      if (typeof t3 == "number")
        return isFinite(t3) ? "" + t3 : "null";
      if (i(t3) !== "object")
        return JSON.stringify(t3);
      var o2, s2;
      if (Array.isArray(t3)) {
        for (s2 = "[", o2 = 0; o2 < t3.length; o2++)
          o2 && (s2 += ","), s2 += e26(t3[o2]) || "null";
        return s2 + "]";
      }
      if (t3 === null)
        return "null";
      if (a2.indexOf(t3) !== -1) {
        if (r2)
          return JSON.stringify("__cycle__");
        throw new TypeError("Converting circular structure to JSON");
      }
      var u2 = a2.push(t3) - 1, c2 = Object.keys(t3).sort(n2 && n2(t3));
      for (s2 = "", o2 = 0; o2 < c2.length; o2++) {
        var l2 = c2[o2], p2 = e26(t3[l2]);
        p2 && (s2 && (s2 += ","), s2 += JSON.stringify(l2) + ":" + p2);
      }
      return a2.splice(u2, 1), "{" + s2 + "}";
    }
  }(e25);
}, Sv = function(e25, t2, r2) {
  var n2 = "", i2 = e25.schema.$async === true, a2 = e25.util.schemaHasRulesExcept(e25.schema, e25.RULES.all, "$ref"), o2 = e25.self._getId(e25.schema);
  if (e25.opts.strictKeywords) {
    var s2 = e25.util.schemaUnknownRules(e25.schema, e25.RULES.keywords);
    if (s2) {
      var u2 = "unknown keyword: " + s2;
      if (e25.opts.strictKeywords !== "log")
        throw new Error(u2);
      e25.logger.warn(u2);
    }
  }
  if (e25.isTop && (n2 += " var validate = ", i2 && (e25.async = true, n2 += "async "), n2 += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ", o2 && (e25.opts.sourceCode || e25.opts.processCode) && (n2 += " /*# sourceURL=" + o2 + " */ ")), typeof e25.schema == "boolean" || !a2 && !e25.schema.$ref) {
    var c2 = e25.level, l2 = e25.dataLevel, p2 = e25.schema["false schema"], f2 = e25.schemaPath + e25.util.getProperty("false schema"), h2 = e25.errSchemaPath + "/false schema", d2 = !e25.opts.allErrors, m2 = "data" + (l2 || ""), g2 = "valid" + c2;
    if (e25.schema === false) {
      e25.isTop ? d2 = true : n2 += " var " + g2 + " = false; ", (X2 = X2 || []).push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'false schema' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(h2) + " , params: {} ", e25.opts.messages !== false && (n2 += " , message: 'boolean schema is false' "), e25.opts.verbose && (n2 += " , schema: false , parentSchema: validate.schema" + e25.schemaPath + " , data: " + m2 + " "), n2 += " } ") : n2 += " {} ";
      var y2 = n2;
      n2 = X2.pop(), !e25.compositeRule && d2 ? e25.async ? n2 += " throw new ValidationError([" + y2 + "]); " : n2 += " validate.errors = [" + y2 + "]; return false; " : n2 += " var err = " + y2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    } else
      e25.isTop ? n2 += i2 ? " return data; " : " validate.errors = null; return true; " : n2 += " var " + g2 + " = true; ";
    return e25.isTop && (n2 += " }; return validate; "), n2;
  }
  if (e25.isTop) {
    var v2 = e25.isTop;
    c2 = e25.level = 0, l2 = e25.dataLevel = 0, m2 = "data";
    if (e25.rootId = e25.resolve.fullPath(e25.self._getId(e25.root.schema)), e25.baseId = e25.baseId || e25.rootId, delete e25.isTop, e25.dataPathArr = [void 0], e25.schema.default !== void 0 && e25.opts.useDefaults && e25.opts.strictDefaults) {
      var x2 = "default is ignored in the schema root";
      if (e25.opts.strictDefaults !== "log")
        throw new Error(x2);
      e25.logger.warn(x2);
    }
    n2 += " var vErrors = null; ", n2 += " var errors = 0;     ", n2 += " if (rootData === undefined) rootData = data; ";
  } else {
    c2 = e25.level, m2 = "data" + ((l2 = e25.dataLevel) || "");
    if (o2 && (e25.baseId = e25.resolve.url(e25.baseId, o2)), i2 && !e25.async)
      throw new Error("async schema in sync schema");
    n2 += " var errs_" + c2 + " = errors;";
  }
  g2 = "valid" + c2, d2 = !e25.opts.allErrors;
  var b2 = "", E2 = "", C2 = e25.schema.type, S2 = Array.isArray(C2);
  if (C2 && e25.opts.nullable && e25.schema.nullable === true && (S2 ? C2.indexOf("null") == -1 && (C2 = C2.concat("null")) : C2 != "null" && (C2 = [C2, "null"], S2 = true)), S2 && C2.length == 1 && (C2 = C2[0], S2 = false), e25.schema.$ref && a2) {
    if (e25.opts.extendRefs == "fail")
      throw new Error('$ref: validation keywords used in schema at path "' + e25.errSchemaPath + '" (see option extendRefs)');
    e25.opts.extendRefs !== true && (a2 = false, e25.logger.warn('$ref: keywords ignored in schema at path "' + e25.errSchemaPath + '"'));
  }
  if (e25.schema.$comment && e25.opts.$comment && (n2 += " " + e25.RULES.all.$comment.code(e25, "$comment")), C2) {
    if (e25.opts.coerceTypes)
      var k2 = e25.util.coerceToTypes(e25.opts.coerceTypes, C2);
    var D2 = e25.RULES.types[C2];
    if (k2 || S2 || D2 === true || D2 && !Y2(D2)) {
      f2 = e25.schemaPath + ".type", h2 = e25.errSchemaPath + "/type", f2 = e25.schemaPath + ".type", h2 = e25.errSchemaPath + "/type";
      var F2 = S2 ? "checkDataTypes" : "checkDataType";
      if (n2 += " if (" + e25.util[F2](C2, m2, true) + ") { ", k2) {
        var A2 = "dataType" + c2, w2 = "coerced" + c2;
        n2 += " var " + A2 + " = typeof " + m2 + "; ", e25.opts.coerceTypes == "array" && (n2 += " if (" + A2 + " == 'object' && Array.isArray(" + m2 + ")) " + A2 + " = 'array'; "), n2 += " var " + w2 + " = undefined; ";
        var _2 = "", T2 = k2;
        if (T2)
          for (var P2, I2 = -1, B2 = T2.length - 1; I2 < B2; )
            P2 = T2[I2 += 1], I2 && (n2 += " if (" + w2 + " === undefined) { ", _2 += "}"), e25.opts.coerceTypes == "array" && P2 != "array" && (n2 += " if (" + A2 + " == 'array' && " + m2 + ".length == 1) { " + w2 + " = " + m2 + " = " + m2 + "[0]; " + A2 + " = typeof " + m2 + ";  } "), P2 == "string" ? n2 += " if (" + A2 + " == 'number' || " + A2 + " == 'boolean') " + w2 + " = '' + " + m2 + "; else if (" + m2 + " === null) " + w2 + " = ''; " : P2 == "number" || P2 == "integer" ? (n2 += " if (" + A2 + " == 'boolean' || " + m2 + " === null || (" + A2 + " == 'string' && " + m2 + " && " + m2 + " == +" + m2 + " ", P2 == "integer" && (n2 += " && !(" + m2 + " % 1)"), n2 += ")) " + w2 + " = +" + m2 + "; ") : P2 == "boolean" ? n2 += " if (" + m2 + " === 'false' || " + m2 + " === 0 || " + m2 + " === null) " + w2 + " = false; else if (" + m2 + " === 'true' || " + m2 + " === 1) " + w2 + " = true; " : P2 == "null" ? n2 += " if (" + m2 + " === '' || " + m2 + " === 0 || " + m2 + " === false) " + w2 + " = null; " : e25.opts.coerceTypes == "array" && P2 == "array" && (n2 += " if (" + A2 + " == 'string' || " + A2 + " == 'number' || " + A2 + " == 'boolean' || " + m2 + " == null) " + w2 + " = [" + m2 + "]; ");
        n2 += " " + _2 + " if (" + w2 + " === undefined) {   ", (X2 = X2 || []).push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'type' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(h2) + " , params: { type: '", n2 += S2 ? "" + C2.join(",") : "" + C2, n2 += "' } ", e25.opts.messages !== false && (n2 += " , message: 'should be ", n2 += S2 ? "" + C2.join(",") : "" + C2, n2 += "' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + f2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + m2 + " "), n2 += " } ") : n2 += " {} ";
        y2 = n2;
        n2 = X2.pop(), !e25.compositeRule && d2 ? e25.async ? n2 += " throw new ValidationError([" + y2 + "]); " : n2 += " validate.errors = [" + y2 + "]; return false; " : n2 += " var err = " + y2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n2 += " } else {  ";
        var O2 = l2 ? "data" + (l2 - 1 || "") : "parentData";
        n2 += " " + m2 + " = " + w2 + "; ", l2 || (n2 += "if (" + O2 + " !== undefined)"), n2 += " " + O2 + "[" + (l2 ? e25.dataPathArr[l2] : "parentDataProperty") + "] = " + w2 + "; } ";
      } else {
        (X2 = X2 || []).push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'type' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(h2) + " , params: { type: '", n2 += S2 ? "" + C2.join(",") : "" + C2, n2 += "' } ", e25.opts.messages !== false && (n2 += " , message: 'should be ", n2 += S2 ? "" + C2.join(",") : "" + C2, n2 += "' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + f2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + m2 + " "), n2 += " } ") : n2 += " {} ";
        y2 = n2;
        n2 = X2.pop(), !e25.compositeRule && d2 ? e25.async ? n2 += " throw new ValidationError([" + y2 + "]); " : n2 += " validate.errors = [" + y2 + "]; return false; " : n2 += " var err = " + y2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      }
      n2 += " } ";
    }
  }
  if (e25.schema.$ref && !a2)
    n2 += " " + e25.RULES.all.$ref.code(e25, "$ref") + " ", d2 && (n2 += " } if (errors === ", n2 += v2 ? "0" : "errs_" + c2, n2 += ") { ", E2 += "}");
  else {
    var L2 = e25.RULES;
    if (L2) {
      for (var N2 = -1, j2 = L2.length - 1; N2 < j2; )
        if (Y2(D2 = L2[N2 += 1])) {
          if (D2.type && (n2 += " if (" + e25.util.checkDataType(D2.type, m2) + ") { "), e25.opts.useDefaults) {
            if (D2.type == "object" && e25.schema.properties) {
              p2 = e25.schema.properties;
              var R2 = Object.keys(p2);
              if (R2)
                for (var M2, V2 = -1, U2 = R2.length - 1; V2 < U2; ) {
                  if (($2 = p2[M2 = R2[V2 += 1]]).default !== void 0) {
                    var q2 = m2 + e25.util.getProperty(M2);
                    if (e25.compositeRule) {
                      if (e25.opts.strictDefaults) {
                        x2 = "default is ignored for: " + q2;
                        if (e25.opts.strictDefaults !== "log")
                          throw new Error(x2);
                        e25.logger.warn(x2);
                      }
                    } else
                      n2 += " if (" + q2 + " === undefined ", e25.opts.useDefaults == "empty" && (n2 += " || " + q2 + " === null || " + q2 + " === '' "), n2 += " ) " + q2 + " = ", e25.opts.useDefaults == "shared" ? n2 += " " + e25.useDefault($2.default) + " " : n2 += " " + JSON.stringify($2.default) + " ", n2 += "; ";
                  }
                }
            } else if (D2.type == "array" && Array.isArray(e25.schema.items)) {
              var W2 = e25.schema.items;
              if (W2) {
                I2 = -1;
                for (var $2, G2 = W2.length - 1; I2 < G2; )
                  if (($2 = W2[I2 += 1]).default !== void 0) {
                    q2 = m2 + "[" + I2 + "]";
                    if (e25.compositeRule) {
                      if (e25.opts.strictDefaults) {
                        x2 = "default is ignored for: " + q2;
                        if (e25.opts.strictDefaults !== "log")
                          throw new Error(x2);
                        e25.logger.warn(x2);
                      }
                    } else
                      n2 += " if (" + q2 + " === undefined ", e25.opts.useDefaults == "empty" && (n2 += " || " + q2 + " === null || " + q2 + " === '' "), n2 += " ) " + q2 + " = ", e25.opts.useDefaults == "shared" ? n2 += " " + e25.useDefault($2.default) + " " : n2 += " " + JSON.stringify($2.default) + " ", n2 += "; ";
                  }
              }
            }
          }
          var z2 = D2.rules;
          if (z2) {
            for (var H2, K2 = -1, J2 = z2.length - 1; K2 < J2; )
              if (Z2(H2 = z2[K2 += 1])) {
                var Q2 = H2.code(e25, H2.keyword, D2.type);
                Q2 && (n2 += " " + Q2 + " ", d2 && (b2 += "}"));
              }
          }
          if (d2 && (n2 += " " + b2 + " ", b2 = ""), D2.type && (n2 += " } ", C2 && C2 === D2.type && !k2)) {
            n2 += " else { ";
            var X2;
            f2 = e25.schemaPath + ".type", h2 = e25.errSchemaPath + "/type";
            (X2 = X2 || []).push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'type' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(h2) + " , params: { type: '", n2 += S2 ? "" + C2.join(",") : "" + C2, n2 += "' } ", e25.opts.messages !== false && (n2 += " , message: 'should be ", n2 += S2 ? "" + C2.join(",") : "" + C2, n2 += "' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + f2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + m2 + " "), n2 += " } ") : n2 += " {} ";
            y2 = n2;
            n2 = X2.pop(), !e25.compositeRule && d2 ? e25.async ? n2 += " throw new ValidationError([" + y2 + "]); " : n2 += " validate.errors = [" + y2 + "]; return false; " : n2 += " var err = " + y2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n2 += " } ";
          }
          d2 && (n2 += " if (errors === ", n2 += v2 ? "0" : "errs_" + c2, n2 += ") { ", E2 += "}");
        }
    }
  }
  function Y2(e26) {
    for (var t3 = e26.rules, r3 = 0; r3 < t3.length; r3++)
      if (Z2(t3[r3]))
        return true;
  }
  function Z2(t3) {
    return e25.schema[t3.keyword] !== void 0 || t3.implements && function(t4) {
      for (var r3 = t4.implements, n3 = 0; n3 < r3.length; n3++)
        if (e25.schema[r3[n3]] !== void 0)
          return true;
    }(t3);
  }
  return d2 && (n2 += " " + E2 + " "), v2 ? (i2 ? (n2 += " if (errors === 0) return data;           ", n2 += " else throw new ValidationError(vErrors); ") : (n2 += " validate.errors = vErrors; ", n2 += " return errors === 0;       "), n2 += " }; return validate;") : n2 += " var " + g2 + " = errors === errs_" + c2 + ";", n2 = e25.util.cleanUpCode(n2), v2 && (n2 = e25.util.finalCleanUpCode(n2, i2)), n2;
}, kv = Iy.ucs2length, Dv = xv.Validation, Fv = function e22(t2, r2, n2, a2) {
  var o2 = this, s2 = this._opts, u2 = [void 0], c2 = {}, l2 = [], p2 = {}, f2 = [], h2 = {}, d2 = [];
  r2 = r2 || { schema: t2, refVal: u2, refs: c2 };
  var m2 = Av.call(this, t2, r2, a2), g2 = this._compilations[m2.index];
  if (m2.compiling)
    return g2.callValidate = function e25() {
      var t3 = g2.validate, r3 = t3.apply(this, arguments);
      return e25.errors = t3.errors, r3;
    };
  var y2 = this._formats, v2 = this.RULES;
  try {
    var x2 = E2(t2, r2, n2, a2);
    g2.validate = x2;
    var b2 = g2.callValidate;
    return b2 && (b2.schema = x2.schema, b2.errors = null, b2.refs = x2.refs, b2.refVal = x2.refVal, b2.root = x2.root, b2.$async = x2.$async, s2.sourceCode && (b2.source = x2.source)), x2;
  } finally {
    wv.call(this, t2, r2, a2);
  }
  function E2(t3, n3, i2, a3) {
    var p3 = !n3 || n3 && n3.schema == t3;
    if (n3.schema != r2.schema)
      return e22.call(o2, t3, n3, i2, a3);
    var h3, m3 = t3.$async === true, g3 = Sv({ isTop: true, schema: t3, isRoot: p3, baseId: a3, root: n3, schemaPath: "", errSchemaPath: "#", errorPath: '""', MissingRefError: xv.MissingRef, RULES: v2, validate: Sv, util: Iy, resolve: ov, resolveRef: C2, usePattern: D2, useDefault: F2, useCustomRule: A2, opts: s2, formats: y2, logger: o2.logger, self: o2 });
    g3 = Ov(u2, Iv) + Ov(l2, Tv) + Ov(f2, Pv) + Ov(d2, Bv) + g3, s2.processCode && (g3 = s2.processCode(g3));
    try {
      h3 = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", g3)(o2, v2, y2, r2, u2, f2, d2, Py, kv, Dv), u2[0] = h3;
    } catch (e25) {
      throw o2.logger.error("Error compiling schema, function code:", g3), e25;
    }
    return h3.schema = t3, h3.errors = null, h3.refs = c2, h3.refVal = u2, h3.root = p3 ? h3 : n3, m3 && (h3.$async = true), s2.sourceCode === true && (h3.source = { code: g3, patterns: l2, defaults: f2 }), h3;
  }
  function C2(t3, i2, a3) {
    i2 = ov.url(t3, i2);
    var l3, p3, f3 = c2[i2];
    if (f3 !== void 0)
      return k2(l3 = u2[f3], p3 = "refVal[" + f3 + "]");
    if (!a3 && r2.refs) {
      var h3 = r2.refs[i2];
      if (h3 !== void 0)
        return k2(l3 = r2.refVal[h3], p3 = S2(i2, l3));
    }
    p3 = S2(i2);
    var d3 = ov.call(o2, E2, r2, i2);
    if (d3 === void 0) {
      var m3 = n2 && n2[i2];
      m3 && (d3 = ov.inlineRef(m3, s2.inlineRefs) ? m3 : e22.call(o2, m3, r2, n2, t3));
    }
    if (d3 !== void 0)
      return function(e25, t4) {
        var r3 = c2[e25];
        u2[r3] = t4;
      }(i2, d3), k2(d3, p3);
    !function(e25) {
      delete c2[e25];
    }(i2);
  }
  function S2(e25, t3) {
    var r3 = u2.length;
    return u2[r3] = t3, c2[e25] = r3, "refVal" + r3;
  }
  function k2(e25, t3) {
    return i(e25) == "object" || typeof e25 == "boolean" ? { code: t3, schema: e25, inline: true } : { code: t3, $async: e25 && !!e25.$async };
  }
  function D2(e25) {
    var t3 = p2[e25];
    return t3 === void 0 && (t3 = p2[e25] = l2.length, l2[t3] = e25), "pattern" + t3;
  }
  function F2(e25) {
    switch (i(e25)) {
      case "boolean":
      case "number":
        return "" + e25;
      case "string":
        return Iy.toQuotedString(e25);
      case "object":
        if (e25 === null)
          return "null";
        var t3 = Cv(e25), r3 = h2[t3];
        return r3 === void 0 && (r3 = h2[t3] = f2.length, f2[r3] = e25), "default" + r3;
    }
  }
  function A2(e25, t3, r3, n3) {
    if (o2._opts.validateSchema !== false) {
      var i2 = e25.definition.dependencies;
      if (i2 && !i2.every(function(e26) {
        return Object.prototype.hasOwnProperty.call(r3, e26);
      }))
        throw new Error("parent schema must have all required keywords: " + i2.join(","));
      var a3 = e25.definition.validateSchema;
      if (a3) {
        if (!a3(t3)) {
          var u3 = "keyword schema is invalid: " + o2.errorsText(a3.errors);
          if (o2._opts.validateSchema != "log")
            throw new Error(u3);
          o2.logger.error(u3);
        }
      }
    }
    var c3, l3 = e25.definition.compile, p3 = e25.definition.inline, f3 = e25.definition.macro;
    if (l3)
      c3 = l3.call(o2, t3, r3, n3);
    else if (f3)
      c3 = f3.call(o2, t3, r3, n3), s2.validateSchema !== false && o2.validateSchema(c3, true);
    else if (p3)
      c3 = p3.call(o2, n3, e25.keyword, t3, r3);
    else if (!(c3 = e25.definition.validate))
      return;
    if (c3 === void 0)
      throw new Error('custom keyword "' + e25.keyword + '"failed to compile');
    var h3 = d2.length;
    return d2[h3] = c3, { code: "customRule" + h3, validate: c3 };
  }
};
function Av(e25, t2, r2) {
  var n2 = _v.call(this, e25, t2, r2);
  return n2 >= 0 ? { index: n2, compiling: true } : (n2 = this._compilations.length, this._compilations[n2] = { schema: e25, root: t2, baseId: r2 }, { index: n2, compiling: false });
}
function wv(e25, t2, r2) {
  var n2 = _v.call(this, e25, t2, r2);
  n2 >= 0 && this._compilations.splice(n2, 1);
}
function _v(e25, t2, r2) {
  for (var n2 = 0; n2 < this._compilations.length; n2++) {
    var i2 = this._compilations[n2];
    if (i2.schema == e25 && i2.root == t2 && i2.baseId == r2)
      return n2;
  }
  return -1;
}
function Tv(e25, t2) {
  return "var pattern" + e25 + " = new RegExp(" + Iy.toQuotedString(t2[e25]) + ");";
}
function Pv(e25) {
  return "var default" + e25 + " = defaults[" + e25 + "];";
}
function Iv(e25, t2) {
  return t2[e25] === void 0 ? "" : "var refVal" + e25 + " = refVal[" + e25 + "];";
}
function Bv(e25) {
  return "var customRule" + e25 + " = customRules[" + e25 + "];";
}
function Ov(e25, t2) {
  if (!e25.length)
    return "";
  for (var r2 = "", n2 = 0; n2 < e25.length; n2++)
    r2 += t2(n2, e25);
  return r2;
}
var Lv = r(function(e25) {
  var t2 = e25.exports = function() {
    this._cache = {};
  };
  t2.prototype.put = function(e26, t3) {
    this._cache[e26] = t3;
  }, t2.prototype.get = function(e26) {
    return this._cache[e26];
  }, t2.prototype.del = function(e26) {
    delete this._cache[e26];
  }, t2.prototype.clear = function() {
    this._cache = {};
  };
}), Nv = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, jv = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Rv = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d:\d\d)?$/i, Mv = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*$/i, Vv = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, Uv = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i, qv = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i, Wv = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i, $v = /^(?:\/(?:[^~/]|~0|~1)*)*$/, Gv = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i, zv = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/, Hv = Kv;
function Kv(e25) {
  return e25 = e25 == "full" ? "full" : "fast", Iy.copy(Kv[e25]);
}
function Jv(e25) {
  var t2 = e25.match(Nv);
  if (!t2)
    return false;
  var r2 = +t2[1], n2 = +t2[2], i2 = +t2[3];
  return n2 >= 1 && n2 <= 12 && i2 >= 1 && i2 <= (n2 == 2 && function(e26) {
    return e26 % 4 == 0 && (e26 % 100 != 0 || e26 % 400 == 0);
  }(r2) ? 29 : jv[n2]);
}
function Qv(e25, t2) {
  var r2 = e25.match(Rv);
  if (!r2)
    return false;
  var n2 = r2[1], i2 = r2[2], a2 = r2[3], o2 = r2[5];
  return (n2 <= 23 && i2 <= 59 && a2 <= 59 || n2 == 23 && i2 == 59 && a2 == 60) && (!t2 || o2);
}
Kv.fast = { date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/, time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d:\d\d)?$/i, "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d:\d\d)$/i, uri: /^(?:[a-z][a-z0-9+-.]*:)(?:\/?\/)?[^\s]*$/i, "uri-reference": /^(?:(?:[a-z][a-z0-9+-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i, "uri-template": Uv, url: qv, email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i, hostname: Mv, ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/, ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i, regex: ex, uuid: Wv, "json-pointer": $v, "json-pointer-uri-fragment": Gv, "relative-json-pointer": zv }, Kv.full = { date: Jv, time: Qv, "date-time": function(e25) {
  var t2 = e25.split(Xv);
  return t2.length == 2 && Jv(t2[0]) && Qv(t2[1], true);
}, uri: function(e25) {
  return Yv.test(e25) && Vv.test(e25);
}, "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i, "uri-template": Uv, url: qv, email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i, hostname: function(e25) {
  return e25.length <= 255 && Mv.test(e25);
}, ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/, ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i, regex: ex, uuid: Wv, "json-pointer": $v, "json-pointer-uri-fragment": Gv, "relative-json-pointer": zv };
var Xv = /t|\s/i;
var Yv = /\/|:/;
var Zv = /[^\\]\\Z/;
function ex(e25) {
  if (Zv.test(e25))
    return false;
  try {
    return new RegExp(e25), true;
  } catch (e26) {
    return false;
  }
}
var tx = function(e25, t2, r2) {
  var n2, i2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = e25.opts.$data && s2 && s2.$data;
  f2 ? (i2 += " var schema" + a2 + " = " + e25.util.getData(s2.$data, o2, e25.dataPathArr) + "; ", n2 = "schema" + a2) : n2 = s2;
  var h2 = t2 == "maximum", d2 = h2 ? "exclusiveMaximum" : "exclusiveMinimum", m2 = e25.schema[d2], g2 = e25.opts.$data && m2 && m2.$data, y2 = h2 ? "<" : ">", v2 = h2 ? ">" : "<", x2 = void 0;
  if (g2) {
    var b2 = e25.util.getData(m2.$data, o2, e25.dataPathArr), E2 = "exclusive" + a2, C2 = "exclType" + a2, S2 = "exclIsNumber" + a2, k2 = "' + " + (A2 = "op" + a2) + " + '";
    i2 += " var schemaExcl" + a2 + " = " + b2 + "; ", i2 += " var " + E2 + "; var " + C2 + " = typeof " + (b2 = "schemaExcl" + a2) + "; if (" + C2 + " != 'boolean' && " + C2 + " != 'undefined' && " + C2 + " != 'number') { ";
    var D2;
    x2 = d2;
    (D2 = D2 || []).push(i2), i2 = "", e25.createErrors !== false ? (i2 += " { keyword: '" + (x2 || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: {} ", e25.opts.messages !== false && (i2 += " , message: '" + d2 + " should be boolean' "), e25.opts.verbose && (i2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), i2 += " } ") : i2 += " {} ";
    var F2 = i2;
    i2 = D2.pop(), !e25.compositeRule && l2 ? e25.async ? i2 += " throw new ValidationError([" + F2 + "]); " : i2 += " validate.errors = [" + F2 + "]; return false; " : i2 += " var err = " + F2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i2 += " } else if ( ", f2 && (i2 += " (" + n2 + " !== undefined && typeof " + n2 + " != 'number') || "), i2 += " " + C2 + " == 'number' ? ( (" + E2 + " = " + n2 + " === undefined || " + b2 + " " + y2 + "= " + n2 + ") ? " + p2 + " " + v2 + "= " + b2 + " : " + p2 + " " + v2 + " " + n2 + " ) : ( (" + E2 + " = " + b2 + " === true) ? " + p2 + " " + v2 + "= " + n2 + " : " + p2 + " " + v2 + " " + n2 + " ) || " + p2 + " !== " + p2 + ") { var op" + a2 + " = " + E2 + " ? '" + y2 + "' : '" + y2 + "='; ", s2 === void 0 && (x2 = d2, c2 = e25.errSchemaPath + "/" + d2, n2 = b2, f2 = g2);
  } else {
    k2 = y2;
    if ((S2 = typeof m2 == "number") && f2) {
      var A2 = "'" + k2 + "'";
      i2 += " if ( ", f2 && (i2 += " (" + n2 + " !== undefined && typeof " + n2 + " != 'number') || "), i2 += " ( " + n2 + " === undefined || " + m2 + " " + y2 + "= " + n2 + " ? " + p2 + " " + v2 + "= " + m2 + " : " + p2 + " " + v2 + " " + n2 + " ) || " + p2 + " !== " + p2 + ") { ";
    } else {
      S2 && s2 === void 0 ? (E2 = true, x2 = d2, c2 = e25.errSchemaPath + "/" + d2, n2 = m2, v2 += "=") : (S2 && (n2 = Math[h2 ? "min" : "max"](m2, s2)), m2 === (!S2 || n2) ? (E2 = true, x2 = d2, c2 = e25.errSchemaPath + "/" + d2, v2 += "=") : (E2 = false, k2 += "="));
      A2 = "'" + k2 + "'";
      i2 += " if ( ", f2 && (i2 += " (" + n2 + " !== undefined && typeof " + n2 + " != 'number') || "), i2 += " " + p2 + " " + v2 + " " + n2 + " || " + p2 + " !== " + p2 + ") { ";
    }
  }
  x2 = x2 || t2, (D2 = D2 || []).push(i2), i2 = "", e25.createErrors !== false ? (i2 += " { keyword: '" + (x2 || "_limit") + "' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { comparison: " + A2 + ", limit: " + n2 + ", exclusive: " + E2 + " } ", e25.opts.messages !== false && (i2 += " , message: 'should be " + k2 + " ", i2 += f2 ? "' + " + n2 : n2 + "'"), e25.opts.verbose && (i2 += " , schema:  ", i2 += f2 ? "validate.schema" + u2 : "" + s2, i2 += "         , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), i2 += " } ") : i2 += " {} ";
  F2 = i2;
  return i2 = D2.pop(), !e25.compositeRule && l2 ? e25.async ? i2 += " throw new ValidationError([" + F2 + "]); " : i2 += " validate.errors = [" + F2 + "]; return false; " : i2 += " var err = " + F2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i2 += " } ", l2 && (i2 += " else { "), i2;
}, rx = function(e25, t2, r2) {
  var n2, i2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = e25.opts.$data && s2 && s2.$data;
  f2 ? (i2 += " var schema" + a2 + " = " + e25.util.getData(s2.$data, o2, e25.dataPathArr) + "; ", n2 = "schema" + a2) : n2 = s2, i2 += "if ( ", f2 && (i2 += " (" + n2 + " !== undefined && typeof " + n2 + " != 'number') || "), i2 += " " + p2 + ".length " + (t2 == "maxItems" ? ">" : "<") + " " + n2 + ") { ";
  var h2 = t2, d2 = d2 || [];
  d2.push(i2), i2 = "", e25.createErrors !== false ? (i2 += " { keyword: '" + (h2 || "_limitItems") + "' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { limit: " + n2 + " } ", e25.opts.messages !== false && (i2 += " , message: 'should NOT have ", i2 += t2 == "maxItems" ? "more" : "fewer", i2 += " than ", i2 += f2 ? "' + " + n2 + " + '" : "" + s2, i2 += " items' "), e25.opts.verbose && (i2 += " , schema:  ", i2 += f2 ? "validate.schema" + u2 : "" + s2, i2 += "         , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), i2 += " } ") : i2 += " {} ";
  var m2 = i2;
  return i2 = d2.pop(), !e25.compositeRule && l2 ? e25.async ? i2 += " throw new ValidationError([" + m2 + "]); " : i2 += " validate.errors = [" + m2 + "]; return false; " : i2 += " var err = " + m2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i2 += "} ", l2 && (i2 += " else { "), i2;
}, nx = function(e25, t2, r2) {
  var n2, i2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = e25.opts.$data && s2 && s2.$data;
  f2 ? (i2 += " var schema" + a2 + " = " + e25.util.getData(s2.$data, o2, e25.dataPathArr) + "; ", n2 = "schema" + a2) : n2 = s2;
  var h2 = t2 == "maxLength" ? ">" : "<";
  i2 += "if ( ", f2 && (i2 += " (" + n2 + " !== undefined && typeof " + n2 + " != 'number') || "), e25.opts.unicode === false ? i2 += " " + p2 + ".length " : i2 += " ucs2length(" + p2 + ") ", i2 += " " + h2 + " " + n2 + ") { ";
  var d2 = t2, m2 = m2 || [];
  m2.push(i2), i2 = "", e25.createErrors !== false ? (i2 += " { keyword: '" + (d2 || "_limitLength") + "' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { limit: " + n2 + " } ", e25.opts.messages !== false && (i2 += " , message: 'should NOT be ", i2 += t2 == "maxLength" ? "longer" : "shorter", i2 += " than ", i2 += f2 ? "' + " + n2 + " + '" : "" + s2, i2 += " characters' "), e25.opts.verbose && (i2 += " , schema:  ", i2 += f2 ? "validate.schema" + u2 : "" + s2, i2 += "         , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), i2 += " } ") : i2 += " {} ";
  var g2 = i2;
  return i2 = m2.pop(), !e25.compositeRule && l2 ? e25.async ? i2 += " throw new ValidationError([" + g2 + "]); " : i2 += " validate.errors = [" + g2 + "]; return false; " : i2 += " var err = " + g2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i2 += "} ", l2 && (i2 += " else { "), i2;
}, ix = function(e25, t2, r2) {
  var n2, i2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = e25.opts.$data && s2 && s2.$data;
  f2 ? (i2 += " var schema" + a2 + " = " + e25.util.getData(s2.$data, o2, e25.dataPathArr) + "; ", n2 = "schema" + a2) : n2 = s2, i2 += "if ( ", f2 && (i2 += " (" + n2 + " !== undefined && typeof " + n2 + " != 'number') || "), i2 += " Object.keys(" + p2 + ").length " + (t2 == "maxProperties" ? ">" : "<") + " " + n2 + ") { ";
  var h2 = t2, d2 = d2 || [];
  d2.push(i2), i2 = "", e25.createErrors !== false ? (i2 += " { keyword: '" + (h2 || "_limitProperties") + "' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { limit: " + n2 + " } ", e25.opts.messages !== false && (i2 += " , message: 'should NOT have ", i2 += t2 == "maxProperties" ? "more" : "fewer", i2 += " than ", i2 += f2 ? "' + " + n2 + " + '" : "" + s2, i2 += " properties' "), e25.opts.verbose && (i2 += " , schema:  ", i2 += f2 ? "validate.schema" + u2 : "" + s2, i2 += "         , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), i2 += " } ") : i2 += " {} ";
  var m2 = i2;
  return i2 = d2.pop(), !e25.compositeRule && l2 ? e25.async ? i2 += " throw new ValidationError([" + m2 + "]); " : i2 += " validate.errors = [" + m2 + "]; return false; " : i2 += " var err = " + m2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i2 += "} ", l2 && (i2 += " else { "), i2;
}, ax = { $ref: function(e25, t2, r2) {
  var n2, i2, a2 = " ", o2 = e25.level, s2 = e25.dataLevel, u2 = e25.schema[t2], c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (s2 || ""), f2 = "valid" + o2;
  if (u2 == "#" || u2 == "#/")
    e25.isRoot ? (n2 = e25.async, i2 = "validate") : (n2 = e25.root.schema.$async === true, i2 = "root.refVal[0]");
  else {
    var h2 = e25.resolveRef(e25.baseId, u2, e25.isRoot);
    if (h2 === void 0) {
      var d2 = e25.MissingRefError.message(e25.baseId, u2);
      if (e25.opts.missingRefs == "fail") {
        e25.logger.error(d2), (v2 = v2 || []).push(a2), a2 = "", e25.createErrors !== false ? (a2 += " { keyword: '$ref' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { ref: '" + e25.util.escapeQuotes(u2) + "' } ", e25.opts.messages !== false && (a2 += " , message: 'can\\'t resolve reference " + e25.util.escapeQuotes(u2) + "' "), e25.opts.verbose && (a2 += " , schema: " + e25.util.toQuotedString(u2) + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), a2 += " } ") : a2 += " {} ";
        var m2 = a2;
        a2 = v2.pop(), !e25.compositeRule && l2 ? e25.async ? a2 += " throw new ValidationError([" + m2 + "]); " : a2 += " validate.errors = [" + m2 + "]; return false; " : a2 += " var err = " + m2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l2 && (a2 += " if (false) { ");
      } else {
        if (e25.opts.missingRefs != "ignore")
          throw new e25.MissingRefError(e25.baseId, u2, d2);
        e25.logger.warn(d2), l2 && (a2 += " if (true) { ");
      }
    } else if (h2.inline) {
      var g2 = e25.util.copy(e25);
      g2.level++;
      var y2 = "valid" + g2.level;
      g2.schema = h2.schema, g2.schemaPath = "", g2.errSchemaPath = u2, a2 += " " + e25.validate(g2).replace(/validate\.schema/g, h2.code) + " ", l2 && (a2 += " if (" + y2 + ") { ");
    } else
      n2 = h2.$async === true || e25.async && h2.$async !== false, i2 = h2.code;
  }
  if (i2) {
    var v2;
    (v2 = v2 || []).push(a2), a2 = "", e25.opts.passContext ? a2 += " " + i2 + ".call(this, " : a2 += " " + i2 + "( ", a2 += " " + p2 + ", (dataPath || '')", e25.errorPath != '""' && (a2 += " + " + e25.errorPath);
    var x2 = a2 += " , " + (s2 ? "data" + (s2 - 1 || "") : "parentData") + " , " + (s2 ? e25.dataPathArr[s2] : "parentDataProperty") + ", rootData)  ";
    if (a2 = v2.pop(), n2) {
      if (!e25.async)
        throw new Error("async schema referenced by sync schema");
      l2 && (a2 += " var " + f2 + "; "), a2 += " try { await " + x2 + "; ", l2 && (a2 += " " + f2 + " = true; "), a2 += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ", l2 && (a2 += " " + f2 + " = false; "), a2 += " } ", l2 && (a2 += " if (" + f2 + ") { ");
    } else
      a2 += " if (!" + x2 + ") { if (vErrors === null) vErrors = " + i2 + ".errors; else vErrors = vErrors.concat(" + i2 + ".errors); errors = vErrors.length; } ", l2 && (a2 += " else { ");
  }
  return a2;
}, allOf: function(e25, t2, r2) {
  var n2 = " ", a2 = e25.schema[t2], o2 = e25.schemaPath + e25.util.getProperty(t2), s2 = e25.errSchemaPath + "/" + t2, u2 = !e25.opts.allErrors, c2 = e25.util.copy(e25), l2 = "";
  c2.level++;
  var p2 = "valid" + c2.level, f2 = c2.baseId, h2 = true, d2 = a2;
  if (d2)
    for (var m2, g2 = -1, y2 = d2.length - 1; g2 < y2; )
      m2 = d2[g2 += 1], (e25.opts.strictKeywords ? i(m2) == "object" && Object.keys(m2).length > 0 : e25.util.schemaHasRules(m2, e25.RULES.all)) && (h2 = false, c2.schema = m2, c2.schemaPath = o2 + "[" + g2 + "]", c2.errSchemaPath = s2 + "/" + g2, n2 += "  " + e25.validate(c2) + " ", c2.baseId = f2, u2 && (n2 += " if (" + p2 + ") { ", l2 += "}"));
  return u2 && (n2 += h2 ? " if (true) { " : " " + l2.slice(0, -1) + " "), n2 = e25.util.cleanUpCode(n2);
}, anyOf: function(e25, t2, r2) {
  var n2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = "valid" + a2, h2 = "errs__" + a2, d2 = e25.util.copy(e25), m2 = "";
  d2.level++;
  var g2 = "valid" + d2.level;
  if (s2.every(function(t3) {
    return e25.opts.strictKeywords ? i(t3) == "object" && Object.keys(t3).length > 0 : e25.util.schemaHasRules(t3, e25.RULES.all);
  })) {
    var y2 = d2.baseId;
    n2 += " var " + h2 + " = errors; var " + f2 + " = false;  ";
    var v2 = e25.compositeRule;
    e25.compositeRule = d2.compositeRule = true;
    var x2 = s2;
    if (x2)
      for (var b2, E2 = -1, C2 = x2.length - 1; E2 < C2; )
        b2 = x2[E2 += 1], d2.schema = b2, d2.schemaPath = u2 + "[" + E2 + "]", d2.errSchemaPath = c2 + "/" + E2, n2 += "  " + e25.validate(d2) + " ", d2.baseId = y2, n2 += " " + f2 + " = " + f2 + " || " + g2 + "; if (!" + f2 + ") { ", m2 += "}";
    e25.compositeRule = d2.compositeRule = v2, n2 += " " + m2 + " if (!" + f2 + ") {   var err =   ", e25.createErrors !== false ? (n2 += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: {} ", e25.opts.messages !== false && (n2 += " , message: 'should match some schema in anyOf' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ", n2 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e25.compositeRule && l2 && (e25.async ? n2 += " throw new ValidationError(vErrors); " : n2 += " validate.errors = vErrors; return false; "), n2 += " } else {  errors = " + h2 + "; if (vErrors !== null) { if (" + h2 + ") vErrors.length = " + h2 + "; else vErrors = null; } ", e25.opts.allErrors && (n2 += " } "), n2 = e25.util.cleanUpCode(n2);
  } else
    l2 && (n2 += " if (true) { ");
  return n2;
}, $comment: function(e25, t2, r2) {
  var n2 = " ", i2 = e25.schema[t2], a2 = e25.errSchemaPath + "/" + t2, o2 = (e25.opts.allErrors, e25.util.toQuotedString(i2));
  return e25.opts.$comment === true ? n2 += " console.log(" + o2 + ");" : typeof e25.opts.$comment == "function" && (n2 += " self._opts.$comment(" + o2 + ", " + e25.util.toQuotedString(a2) + ", validate.root.schema);"), n2;
}, const: function(e25, t2, r2) {
  var n2 = " ", i2 = e25.level, a2 = e25.dataLevel, o2 = e25.schema[t2], s2 = e25.schemaPath + e25.util.getProperty(t2), u2 = e25.errSchemaPath + "/" + t2, c2 = !e25.opts.allErrors, l2 = "data" + (a2 || ""), p2 = "valid" + i2, f2 = e25.opts.$data && o2 && o2.$data;
  f2 && (n2 += " var schema" + i2 + " = " + e25.util.getData(o2.$data, a2, e25.dataPathArr) + "; "), f2 || (n2 += " var schema" + i2 + " = validate.schema" + s2 + ";"), n2 += "var " + p2 + " = equal(" + l2 + ", schema" + i2 + "); if (!" + p2 + ") {   ";
  var h2 = h2 || [];
  h2.push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'const' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(u2) + " , params: { allowedValue: schema" + i2 + " } ", e25.opts.messages !== false && (n2 += " , message: 'should be equal to constant' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + s2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + l2 + " "), n2 += " } ") : n2 += " {} ";
  var d2 = n2;
  return n2 = h2.pop(), !e25.compositeRule && c2 ? e25.async ? n2 += " throw new ValidationError([" + d2 + "]); " : n2 += " validate.errors = [" + d2 + "]; return false; " : n2 += " var err = " + d2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n2 += " }", c2 && (n2 += " else { "), n2;
}, contains: function(e25, t2, r2) {
  var n2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = "valid" + a2, h2 = "errs__" + a2, d2 = e25.util.copy(e25);
  d2.level++;
  var m2 = "valid" + d2.level, g2 = "i" + a2, y2 = d2.dataLevel = e25.dataLevel + 1, v2 = "data" + y2, x2 = e25.baseId, b2 = e25.opts.strictKeywords ? i(s2) == "object" && Object.keys(s2).length > 0 : e25.util.schemaHasRules(s2, e25.RULES.all);
  if (n2 += "var " + h2 + " = errors;var " + f2 + ";", b2) {
    var E2 = e25.compositeRule;
    e25.compositeRule = d2.compositeRule = true, d2.schema = s2, d2.schemaPath = u2, d2.errSchemaPath = c2, n2 += " var " + m2 + " = false; for (var " + g2 + " = 0; " + g2 + " < " + p2 + ".length; " + g2 + "++) { ", d2.errorPath = e25.util.getPathExpr(e25.errorPath, g2, e25.opts.jsonPointers, true);
    var C2 = p2 + "[" + g2 + "]";
    d2.dataPathArr[y2] = g2;
    var S2 = e25.validate(d2);
    d2.baseId = x2, e25.util.varOccurences(S2, v2) < 2 ? n2 += " " + e25.util.varReplace(S2, v2, C2) + " " : n2 += " var " + v2 + " = " + C2 + "; " + S2 + " ", n2 += " if (" + m2 + ") break; }  ", e25.compositeRule = d2.compositeRule = E2, n2 += "  if (!" + m2 + ") {";
  } else
    n2 += " if (" + p2 + ".length == 0) {";
  var k2 = k2 || [];
  k2.push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'contains' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: {} ", e25.opts.messages !== false && (n2 += " , message: 'should contain a valid item' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ";
  var D2 = n2;
  return n2 = k2.pop(), !e25.compositeRule && l2 ? e25.async ? n2 += " throw new ValidationError([" + D2 + "]); " : n2 += " validate.errors = [" + D2 + "]; return false; " : n2 += " var err = " + D2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n2 += " } else { ", b2 && (n2 += "  errors = " + h2 + "; if (vErrors !== null) { if (" + h2 + ") vErrors.length = " + h2 + "; else vErrors = null; } "), e25.opts.allErrors && (n2 += " } "), n2 = e25.util.cleanUpCode(n2);
}, dependencies: function(e25, t2, r2) {
  var n2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = "errs__" + a2, h2 = e25.util.copy(e25), d2 = "";
  h2.level++;
  var m2 = "valid" + h2.level, g2 = {}, y2 = {}, v2 = e25.opts.ownProperties;
  for (C2 in s2) {
    var x2 = s2[C2], b2 = Array.isArray(x2) ? y2 : g2;
    b2[C2] = x2;
  }
  n2 += "var " + f2 + " = errors;";
  var E2 = e25.errorPath;
  for (var C2 in n2 += "var missing" + a2 + ";", y2)
    if ((b2 = y2[C2]).length) {
      if (n2 += " if ( " + p2 + e25.util.getProperty(C2) + " !== undefined ", v2 && (n2 += " && Object.prototype.hasOwnProperty.call(" + p2 + ", '" + e25.util.escapeQuotes(C2) + "') "), l2) {
        n2 += " && ( ";
        var S2 = b2;
        if (S2)
          for (var k2 = -1, D2 = S2.length - 1; k2 < D2; ) {
            P2 = S2[k2 += 1], k2 && (n2 += " || "), n2 += " ( ( " + (L2 = p2 + (O2 = e25.util.getProperty(P2))) + " === undefined ", v2 && (n2 += " || ! Object.prototype.hasOwnProperty.call(" + p2 + ", '" + e25.util.escapeQuotes(P2) + "') "), n2 += ") && (missing" + a2 + " = " + e25.util.toQuotedString(e25.opts.jsonPointers ? P2 : O2) + ") ) ";
          }
        n2 += ")) {  ";
        var F2 = "missing" + a2, A2 = "' + " + F2 + " + '";
        e25.opts._errorDataPathProperty && (e25.errorPath = e25.opts.jsonPointers ? e25.util.getPathExpr(E2, F2, true) : E2 + " + " + F2);
        var w2 = w2 || [];
        w2.push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { property: '" + e25.util.escapeQuotes(C2) + "', missingProperty: '" + A2 + "', depsCount: " + b2.length + ", deps: '" + e25.util.escapeQuotes(b2.length == 1 ? b2[0] : b2.join(", ")) + "' } ", e25.opts.messages !== false && (n2 += " , message: 'should have ", b2.length == 1 ? n2 += "property " + e25.util.escapeQuotes(b2[0]) : n2 += "properties " + e25.util.escapeQuotes(b2.join(", ")), n2 += " when property " + e25.util.escapeQuotes(C2) + " is present' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ";
        var _2 = n2;
        n2 = w2.pop(), !e25.compositeRule && l2 ? e25.async ? n2 += " throw new ValidationError([" + _2 + "]); " : n2 += " validate.errors = [" + _2 + "]; return false; " : n2 += " var err = " + _2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
      } else {
        n2 += " ) { ";
        var T2 = b2;
        if (T2)
          for (var P2, I2 = -1, B2 = T2.length - 1; I2 < B2; ) {
            P2 = T2[I2 += 1];
            var O2 = e25.util.getProperty(P2), L2 = (A2 = e25.util.escapeQuotes(P2), p2 + O2);
            e25.opts._errorDataPathProperty && (e25.errorPath = e25.util.getPath(E2, P2, e25.opts.jsonPointers)), n2 += " if ( " + L2 + " === undefined ", v2 && (n2 += " || ! Object.prototype.hasOwnProperty.call(" + p2 + ", '" + e25.util.escapeQuotes(P2) + "') "), n2 += ") {  var err =   ", e25.createErrors !== false ? (n2 += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { property: '" + e25.util.escapeQuotes(C2) + "', missingProperty: '" + A2 + "', depsCount: " + b2.length + ", deps: '" + e25.util.escapeQuotes(b2.length == 1 ? b2[0] : b2.join(", ")) + "' } ", e25.opts.messages !== false && (n2 += " , message: 'should have ", b2.length == 1 ? n2 += "property " + e25.util.escapeQuotes(b2[0]) : n2 += "properties " + e25.util.escapeQuotes(b2.join(", ")), n2 += " when property " + e25.util.escapeQuotes(C2) + " is present' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ", n2 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
          }
      }
      n2 += " }   ", l2 && (d2 += "}", n2 += " else { ");
    }
  e25.errorPath = E2;
  var N2 = h2.baseId;
  for (var C2 in g2) {
    x2 = g2[C2];
    (e25.opts.strictKeywords ? i(x2) == "object" && Object.keys(x2).length > 0 : e25.util.schemaHasRules(x2, e25.RULES.all)) && (n2 += " " + m2 + " = true; if ( " + p2 + e25.util.getProperty(C2) + " !== undefined ", v2 && (n2 += " && Object.prototype.hasOwnProperty.call(" + p2 + ", '" + e25.util.escapeQuotes(C2) + "') "), n2 += ") { ", h2.schema = x2, h2.schemaPath = u2 + e25.util.getProperty(C2), h2.errSchemaPath = c2 + "/" + e25.util.escapeFragment(C2), n2 += "  " + e25.validate(h2) + " ", h2.baseId = N2, n2 += " }  ", l2 && (n2 += " if (" + m2 + ") { ", d2 += "}"));
  }
  return l2 && (n2 += "   " + d2 + " if (" + f2 + " == errors) {"), n2 = e25.util.cleanUpCode(n2);
}, enum: function(e25, t2, r2) {
  var n2 = " ", i2 = e25.level, a2 = e25.dataLevel, o2 = e25.schema[t2], s2 = e25.schemaPath + e25.util.getProperty(t2), u2 = e25.errSchemaPath + "/" + t2, c2 = !e25.opts.allErrors, l2 = "data" + (a2 || ""), p2 = "valid" + i2, f2 = e25.opts.$data && o2 && o2.$data;
  f2 && (n2 += " var schema" + i2 + " = " + e25.util.getData(o2.$data, a2, e25.dataPathArr) + "; ");
  var h2 = "i" + i2, d2 = "schema" + i2;
  f2 || (n2 += " var " + d2 + " = validate.schema" + s2 + ";"), n2 += "var " + p2 + ";", f2 && (n2 += " if (schema" + i2 + " === undefined) " + p2 + " = true; else if (!Array.isArray(schema" + i2 + ")) " + p2 + " = false; else {"), n2 += p2 + " = false;for (var " + h2 + "=0; " + h2 + "<" + d2 + ".length; " + h2 + "++) if (equal(" + l2 + ", " + d2 + "[" + h2 + "])) { " + p2 + " = true; break; }", f2 && (n2 += "  }  "), n2 += " if (!" + p2 + ") {   ";
  var m2 = m2 || [];
  m2.push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'enum' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(u2) + " , params: { allowedValues: schema" + i2 + " } ", e25.opts.messages !== false && (n2 += " , message: 'should be equal to one of the allowed values' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + s2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + l2 + " "), n2 += " } ") : n2 += " {} ";
  var g2 = n2;
  return n2 = m2.pop(), !e25.compositeRule && c2 ? e25.async ? n2 += " throw new ValidationError([" + g2 + "]); " : n2 += " validate.errors = [" + g2 + "]; return false; " : n2 += " var err = " + g2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n2 += " }", c2 && (n2 += " else { "), n2;
}, format: function(e25, t2, r2) {
  var n2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || "");
  if (e25.opts.format === false)
    return l2 && (n2 += " if (true) { "), n2;
  var f2, h2 = e25.opts.$data && s2 && s2.$data;
  h2 ? (n2 += " var schema" + a2 + " = " + e25.util.getData(s2.$data, o2, e25.dataPathArr) + "; ", f2 = "schema" + a2) : f2 = s2;
  var d2 = e25.opts.unknownFormats, m2 = Array.isArray(d2);
  if (h2) {
    n2 += " var " + (g2 = "format" + a2) + " = formats[" + f2 + "]; var " + (y2 = "isObject" + a2) + " = typeof " + g2 + " == 'object' && !(" + g2 + " instanceof RegExp) && " + g2 + ".validate; var " + (v2 = "formatType" + a2) + " = " + y2 + " && " + g2 + ".type || 'string'; if (" + y2 + ") { ", e25.async && (n2 += " var async" + a2 + " = " + g2 + ".async; "), n2 += " " + g2 + " = " + g2 + ".validate; } if (  ", h2 && (n2 += " (" + f2 + " !== undefined && typeof " + f2 + " != 'string') || "), n2 += " (", d2 != "ignore" && (n2 += " (" + f2 + " && !" + g2 + " ", m2 && (n2 += " && self._opts.unknownFormats.indexOf(" + f2 + ") == -1 "), n2 += ") || "), n2 += " (" + g2 + " && " + v2 + " == '" + r2 + "' && !(typeof " + g2 + " == 'function' ? ", e25.async ? n2 += " (async" + a2 + " ? await " + g2 + "(" + p2 + ") : " + g2 + "(" + p2 + ")) " : n2 += " " + g2 + "(" + p2 + ") ", n2 += " : " + g2 + ".test(" + p2 + "))))) {";
  } else {
    var g2;
    if (!(g2 = e25.formats[s2])) {
      if (d2 == "ignore")
        return e25.logger.warn('unknown format "' + s2 + '" ignored in schema at path "' + e25.errSchemaPath + '"'), l2 && (n2 += " if (true) { "), n2;
      if (m2 && d2.indexOf(s2) >= 0)
        return l2 && (n2 += " if (true) { "), n2;
      throw new Error('unknown format "' + s2 + '" is used in schema at path "' + e25.errSchemaPath + '"');
    }
    var y2, v2 = (y2 = i(g2) == "object" && !(g2 instanceof RegExp) && g2.validate) && g2.type || "string";
    if (y2) {
      var x2 = g2.async === true;
      g2 = g2.validate;
    }
    if (v2 != r2)
      return l2 && (n2 += " if (true) { "), n2;
    if (x2) {
      if (!e25.async)
        throw new Error("async format in sync schema");
      n2 += " if (!(await " + (b2 = "formats" + e25.util.getProperty(s2) + ".validate") + "(" + p2 + "))) { ";
    } else {
      n2 += " if (! ";
      var b2 = "formats" + e25.util.getProperty(s2);
      y2 && (b2 += ".validate"), n2 += typeof g2 == "function" ? " " + b2 + "(" + p2 + ") " : " " + b2 + ".test(" + p2 + ") ", n2 += ") { ";
    }
  }
  var E2 = E2 || [];
  E2.push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'format' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { format:  ", n2 += h2 ? "" + f2 : "" + e25.util.toQuotedString(s2), n2 += "  } ", e25.opts.messages !== false && (n2 += ` , message: 'should match format "`, n2 += h2 ? "' + " + f2 + " + '" : "" + e25.util.escapeQuotes(s2), n2 += `"' `), e25.opts.verbose && (n2 += " , schema:  ", n2 += h2 ? "validate.schema" + u2 : "" + e25.util.toQuotedString(s2), n2 += "         , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ";
  var C2 = n2;
  return n2 = E2.pop(), !e25.compositeRule && l2 ? e25.async ? n2 += " throw new ValidationError([" + C2 + "]); " : n2 += " validate.errors = [" + C2 + "]; return false; " : n2 += " var err = " + C2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n2 += " } ", l2 && (n2 += " else { "), n2;
}, if: function(e25, t2, r2) {
  var n2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = "valid" + a2, h2 = "errs__" + a2, d2 = e25.util.copy(e25);
  d2.level++;
  var m2 = "valid" + d2.level, g2 = e25.schema.then, y2 = e25.schema.else, v2 = g2 !== void 0 && (e25.opts.strictKeywords ? i(g2) == "object" && Object.keys(g2).length > 0 : e25.util.schemaHasRules(g2, e25.RULES.all)), x2 = y2 !== void 0 && (e25.opts.strictKeywords ? i(y2) == "object" && Object.keys(y2).length > 0 : e25.util.schemaHasRules(y2, e25.RULES.all)), b2 = d2.baseId;
  if (v2 || x2) {
    var E2;
    d2.createErrors = false, d2.schema = s2, d2.schemaPath = u2, d2.errSchemaPath = c2, n2 += " var " + h2 + " = errors; var " + f2 + " = true;  ";
    var C2 = e25.compositeRule;
    e25.compositeRule = d2.compositeRule = true, n2 += "  " + e25.validate(d2) + " ", d2.baseId = b2, d2.createErrors = true, n2 += "  errors = " + h2 + "; if (vErrors !== null) { if (" + h2 + ") vErrors.length = " + h2 + "; else vErrors = null; }  ", e25.compositeRule = d2.compositeRule = C2, v2 ? (n2 += " if (" + m2 + ") {  ", d2.schema = e25.schema.then, d2.schemaPath = e25.schemaPath + ".then", d2.errSchemaPath = e25.errSchemaPath + "/then", n2 += "  " + e25.validate(d2) + " ", d2.baseId = b2, n2 += " " + f2 + " = " + m2 + "; ", v2 && x2 ? n2 += " var " + (E2 = "ifClause" + a2) + " = 'then'; " : E2 = "'then'", n2 += " } ", x2 && (n2 += " else { ")) : n2 += " if (!" + m2 + ") { ", x2 && (d2.schema = e25.schema.else, d2.schemaPath = e25.schemaPath + ".else", d2.errSchemaPath = e25.errSchemaPath + "/else", n2 += "  " + e25.validate(d2) + " ", d2.baseId = b2, n2 += " " + f2 + " = " + m2 + "; ", v2 && x2 ? n2 += " var " + (E2 = "ifClause" + a2) + " = 'else'; " : E2 = "'else'", n2 += " } "), n2 += " if (!" + f2 + ") {   var err =   ", e25.createErrors !== false ? (n2 += " { keyword: 'if' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { failingKeyword: " + E2 + " } ", e25.opts.messages !== false && (n2 += ` , message: 'should match "' + ` + E2 + ` + '" schema' `), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ", n2 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e25.compositeRule && l2 && (e25.async ? n2 += " throw new ValidationError(vErrors); " : n2 += " validate.errors = vErrors; return false; "), n2 += " }   ", l2 && (n2 += " else { "), n2 = e25.util.cleanUpCode(n2);
  } else
    l2 && (n2 += " if (true) { ");
  return n2;
}, items: function(e25, t2, r2) {
  var n2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = "valid" + a2, h2 = "errs__" + a2, d2 = e25.util.copy(e25), m2 = "";
  d2.level++;
  var g2 = "valid" + d2.level, y2 = "i" + a2, v2 = d2.dataLevel = e25.dataLevel + 1, x2 = "data" + v2, b2 = e25.baseId;
  if (n2 += "var " + h2 + " = errors;var " + f2 + ";", Array.isArray(s2)) {
    var E2 = e25.schema.additionalItems;
    if (E2 === false) {
      n2 += " " + f2 + " = " + p2 + ".length <= " + s2.length + "; ";
      var C2 = c2;
      c2 = e25.errSchemaPath + "/additionalItems", n2 += "  if (!" + f2 + ") {   ";
      var S2 = S2 || [];
      S2.push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { limit: " + s2.length + " } ", e25.opts.messages !== false && (n2 += " , message: 'should NOT have more than " + s2.length + " items' "), e25.opts.verbose && (n2 += " , schema: false , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ";
      var k2 = n2;
      n2 = S2.pop(), !e25.compositeRule && l2 ? e25.async ? n2 += " throw new ValidationError([" + k2 + "]); " : n2 += " validate.errors = [" + k2 + "]; return false; " : n2 += " var err = " + k2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n2 += " } ", c2 = C2, l2 && (m2 += "}", n2 += " else { ");
    }
    var D2 = s2;
    if (D2) {
      for (var F2, A2 = -1, w2 = D2.length - 1; A2 < w2; )
        if (F2 = D2[A2 += 1], e25.opts.strictKeywords ? i(F2) == "object" && Object.keys(F2).length > 0 : e25.util.schemaHasRules(F2, e25.RULES.all)) {
          n2 += " " + g2 + " = true; if (" + p2 + ".length > " + A2 + ") { ";
          var _2 = p2 + "[" + A2 + "]";
          d2.schema = F2, d2.schemaPath = u2 + "[" + A2 + "]", d2.errSchemaPath = c2 + "/" + A2, d2.errorPath = e25.util.getPathExpr(e25.errorPath, A2, e25.opts.jsonPointers, true), d2.dataPathArr[v2] = A2;
          var T2 = e25.validate(d2);
          d2.baseId = b2, e25.util.varOccurences(T2, x2) < 2 ? n2 += " " + e25.util.varReplace(T2, x2, _2) + " " : n2 += " var " + x2 + " = " + _2 + "; " + T2 + " ", n2 += " }  ", l2 && (n2 += " if (" + g2 + ") { ", m2 += "}");
        }
    }
    if (i(E2) == "object" && (e25.opts.strictKeywords ? i(E2) == "object" && Object.keys(E2).length > 0 : e25.util.schemaHasRules(E2, e25.RULES.all))) {
      d2.schema = E2, d2.schemaPath = e25.schemaPath + ".additionalItems", d2.errSchemaPath = e25.errSchemaPath + "/additionalItems", n2 += " " + g2 + " = true; if (" + p2 + ".length > " + s2.length + ") {  for (var " + y2 + " = " + s2.length + "; " + y2 + " < " + p2 + ".length; " + y2 + "++) { ", d2.errorPath = e25.util.getPathExpr(e25.errorPath, y2, e25.opts.jsonPointers, true);
      _2 = p2 + "[" + y2 + "]";
      d2.dataPathArr[v2] = y2;
      T2 = e25.validate(d2);
      d2.baseId = b2, e25.util.varOccurences(T2, x2) < 2 ? n2 += " " + e25.util.varReplace(T2, x2, _2) + " " : n2 += " var " + x2 + " = " + _2 + "; " + T2 + " ", l2 && (n2 += " if (!" + g2 + ") break; "), n2 += " } }  ", l2 && (n2 += " if (" + g2 + ") { ", m2 += "}");
    }
  } else if (e25.opts.strictKeywords ? i(s2) == "object" && Object.keys(s2).length > 0 : e25.util.schemaHasRules(s2, e25.RULES.all)) {
    d2.schema = s2, d2.schemaPath = u2, d2.errSchemaPath = c2, n2 += "  for (var " + y2 + " = 0; " + y2 + " < " + p2 + ".length; " + y2 + "++) { ", d2.errorPath = e25.util.getPathExpr(e25.errorPath, y2, e25.opts.jsonPointers, true);
    _2 = p2 + "[" + y2 + "]";
    d2.dataPathArr[v2] = y2;
    T2 = e25.validate(d2);
    d2.baseId = b2, e25.util.varOccurences(T2, x2) < 2 ? n2 += " " + e25.util.varReplace(T2, x2, _2) + " " : n2 += " var " + x2 + " = " + _2 + "; " + T2 + " ", l2 && (n2 += " if (!" + g2 + ") break; "), n2 += " }";
  }
  return l2 && (n2 += " " + m2 + " if (" + h2 + " == errors) {"), n2 = e25.util.cleanUpCode(n2);
}, maximum: tx, minimum: tx, maxItems: rx, minItems: rx, maxLength: nx, minLength: nx, maxProperties: ix, minProperties: ix, multipleOf: function(e25, t2, r2) {
  var n2, i2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = e25.opts.$data && s2 && s2.$data;
  f2 ? (i2 += " var schema" + a2 + " = " + e25.util.getData(s2.$data, o2, e25.dataPathArr) + "; ", n2 = "schema" + a2) : n2 = s2, i2 += "var division" + a2 + ";if (", f2 && (i2 += " " + n2 + " !== undefined && ( typeof " + n2 + " != 'number' || "), i2 += " (division" + a2 + " = " + p2 + " / " + n2 + ", ", e25.opts.multipleOfPrecision ? i2 += " Math.abs(Math.round(division" + a2 + ") - division" + a2 + ") > 1e-" + e25.opts.multipleOfPrecision + " " : i2 += " division" + a2 + " !== parseInt(division" + a2 + ") ", i2 += " ) ", f2 && (i2 += "  )  "), i2 += " ) {   ";
  var h2 = h2 || [];
  h2.push(i2), i2 = "", e25.createErrors !== false ? (i2 += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { multipleOf: " + n2 + " } ", e25.opts.messages !== false && (i2 += " , message: 'should be multiple of ", i2 += f2 ? "' + " + n2 : n2 + "'"), e25.opts.verbose && (i2 += " , schema:  ", i2 += f2 ? "validate.schema" + u2 : "" + s2, i2 += "         , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), i2 += " } ") : i2 += " {} ";
  var d2 = i2;
  return i2 = h2.pop(), !e25.compositeRule && l2 ? e25.async ? i2 += " throw new ValidationError([" + d2 + "]); " : i2 += " validate.errors = [" + d2 + "]; return false; " : i2 += " var err = " + d2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i2 += "} ", l2 && (i2 += " else { "), i2;
}, not: function(e25, t2, r2) {
  var n2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = "errs__" + a2, h2 = e25.util.copy(e25);
  h2.level++;
  var d2 = "valid" + h2.level;
  if (e25.opts.strictKeywords ? i(s2) == "object" && Object.keys(s2).length > 0 : e25.util.schemaHasRules(s2, e25.RULES.all)) {
    h2.schema = s2, h2.schemaPath = u2, h2.errSchemaPath = c2, n2 += " var " + f2 + " = errors;  ";
    var m2, g2 = e25.compositeRule;
    e25.compositeRule = h2.compositeRule = true, h2.createErrors = false, h2.opts.allErrors && (m2 = h2.opts.allErrors, h2.opts.allErrors = false), n2 += " " + e25.validate(h2) + " ", h2.createErrors = true, m2 && (h2.opts.allErrors = m2), e25.compositeRule = h2.compositeRule = g2, n2 += " if (" + d2 + ") {   ";
    var y2 = y2 || [];
    y2.push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'not' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: {} ", e25.opts.messages !== false && (n2 += " , message: 'should NOT be valid' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ";
    var v2 = n2;
    n2 = y2.pop(), !e25.compositeRule && l2 ? e25.async ? n2 += " throw new ValidationError([" + v2 + "]); " : n2 += " validate.errors = [" + v2 + "]; return false; " : n2 += " var err = " + v2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n2 += " } else {  errors = " + f2 + "; if (vErrors !== null) { if (" + f2 + ") vErrors.length = " + f2 + "; else vErrors = null; } ", e25.opts.allErrors && (n2 += " } ");
  } else
    n2 += "  var err =   ", e25.createErrors !== false ? (n2 += " { keyword: 'not' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: {} ", e25.opts.messages !== false && (n2 += " , message: 'should NOT be valid' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ", n2 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", l2 && (n2 += " if (false) { ");
  return n2;
}, oneOf: function(e25, t2, r2) {
  var n2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = "valid" + a2, h2 = "errs__" + a2, d2 = e25.util.copy(e25), m2 = "";
  d2.level++;
  var g2 = "valid" + d2.level, y2 = d2.baseId, v2 = "prevValid" + a2, x2 = "passingSchemas" + a2;
  n2 += "var " + h2 + " = errors , " + v2 + " = false , " + f2 + " = false , " + x2 + " = null; ";
  var b2 = e25.compositeRule;
  e25.compositeRule = d2.compositeRule = true;
  var E2 = s2;
  if (E2)
    for (var C2, S2 = -1, k2 = E2.length - 1; S2 < k2; )
      C2 = E2[S2 += 1], (e25.opts.strictKeywords ? i(C2) == "object" && Object.keys(C2).length > 0 : e25.util.schemaHasRules(C2, e25.RULES.all)) ? (d2.schema = C2, d2.schemaPath = u2 + "[" + S2 + "]", d2.errSchemaPath = c2 + "/" + S2, n2 += "  " + e25.validate(d2) + " ", d2.baseId = y2) : n2 += " var " + g2 + " = true; ", S2 && (n2 += " if (" + g2 + " && " + v2 + ") { " + f2 + " = false; " + x2 + " = [" + x2 + ", " + S2 + "]; } else { ", m2 += "}"), n2 += " if (" + g2 + ") { " + f2 + " = " + v2 + " = true; " + x2 + " = " + S2 + "; }";
  return e25.compositeRule = d2.compositeRule = b2, n2 += m2 + "if (!" + f2 + ") {   var err =   ", e25.createErrors !== false ? (n2 += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { passingSchemas: " + x2 + " } ", e25.opts.messages !== false && (n2 += " , message: 'should match exactly one schema in oneOf' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ", n2 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e25.compositeRule && l2 && (e25.async ? n2 += " throw new ValidationError(vErrors); " : n2 += " validate.errors = vErrors; return false; "), n2 += "} else {  errors = " + h2 + "; if (vErrors !== null) { if (" + h2 + ") vErrors.length = " + h2 + "; else vErrors = null; }", e25.opts.allErrors && (n2 += " } "), n2;
}, pattern: function(e25, t2, r2) {
  var n2, i2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = e25.opts.$data && s2 && s2.$data;
  f2 ? (i2 += " var schema" + a2 + " = " + e25.util.getData(s2.$data, o2, e25.dataPathArr) + "; ", n2 = "schema" + a2) : n2 = s2, i2 += "if ( ", f2 && (i2 += " (" + n2 + " !== undefined && typeof " + n2 + " != 'string') || "), i2 += " !" + (f2 ? "(new RegExp(" + n2 + "))" : e25.usePattern(s2)) + ".test(" + p2 + ") ) {   ";
  var h2 = h2 || [];
  h2.push(i2), i2 = "", e25.createErrors !== false ? (i2 += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { pattern:  ", i2 += f2 ? "" + n2 : "" + e25.util.toQuotedString(s2), i2 += "  } ", e25.opts.messages !== false && (i2 += ` , message: 'should match pattern "`, i2 += f2 ? "' + " + n2 + " + '" : "" + e25.util.escapeQuotes(s2), i2 += `"' `), e25.opts.verbose && (i2 += " , schema:  ", i2 += f2 ? "validate.schema" + u2 : "" + e25.util.toQuotedString(s2), i2 += "         , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), i2 += " } ") : i2 += " {} ";
  var d2 = i2;
  return i2 = h2.pop(), !e25.compositeRule && l2 ? e25.async ? i2 += " throw new ValidationError([" + d2 + "]); " : i2 += " validate.errors = [" + d2 + "]; return false; " : i2 += " var err = " + d2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i2 += "} ", l2 && (i2 += " else { "), i2;
}, properties: function(e25, t2, r2) {
  var n2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = "errs__" + a2, h2 = e25.util.copy(e25), d2 = "";
  h2.level++;
  var m2 = "valid" + h2.level, g2 = "key" + a2, y2 = "idx" + a2, v2 = h2.dataLevel = e25.dataLevel + 1, x2 = "data" + v2, b2 = "dataProperties" + a2, E2 = Object.keys(s2 || {}), C2 = e25.schema.patternProperties || {}, S2 = Object.keys(C2), k2 = e25.schema.additionalProperties, D2 = E2.length || S2.length, F2 = k2 === false, A2 = i(k2) == "object" && Object.keys(k2).length, w2 = e25.opts.removeAdditional, _2 = F2 || A2 || w2, T2 = e25.opts.ownProperties, P2 = e25.baseId, I2 = e25.schema.required;
  if (I2 && (!e25.opts.$data || !I2.$data) && I2.length < e25.opts.loopRequired)
    var B2 = e25.util.toHash(I2);
  if (n2 += "var " + f2 + " = errors;var " + m2 + " = true;", T2 && (n2 += " var " + b2 + " = undefined;"), _2) {
    if (n2 += T2 ? " " + b2 + " = " + b2 + " || Object.keys(" + p2 + "); for (var " + y2 + "=0; " + y2 + "<" + b2 + ".length; " + y2 + "++) { var " + g2 + " = " + b2 + "[" + y2 + "]; " : " for (var " + g2 + " in " + p2 + ") { ", D2) {
      if (n2 += " var isAdditional" + a2 + " = !(false ", E2.length)
        if (E2.length > 8)
          n2 += " || validate.schema" + u2 + ".hasOwnProperty(" + g2 + ") ";
        else {
          var O2 = E2;
          if (O2)
            for (var L2 = -1, N2 = O2.length - 1; L2 < N2; )
              J2 = O2[L2 += 1], n2 += " || " + g2 + " == " + e25.util.toQuotedString(J2) + " ";
        }
      if (S2.length) {
        var j2 = S2;
        if (j2)
          for (var R2 = -1, M2 = j2.length - 1; R2 < M2; )
            ae2 = j2[R2 += 1], n2 += " || " + e25.usePattern(ae2) + ".test(" + g2 + ") ";
      }
      n2 += " ); if (isAdditional" + a2 + ") { ";
    }
    if (w2 == "all")
      n2 += " delete " + p2 + "[" + g2 + "]; ";
    else {
      var V2 = e25.errorPath, U2 = "' + " + g2 + " + '";
      if (e25.opts._errorDataPathProperty && (e25.errorPath = e25.util.getPathExpr(e25.errorPath, g2, e25.opts.jsonPointers)), F2)
        if (w2)
          n2 += " delete " + p2 + "[" + g2 + "]; ";
        else {
          n2 += " " + m2 + " = false; ";
          var q2 = c2;
          c2 = e25.errSchemaPath + "/additionalProperties", (re2 = re2 || []).push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { additionalProperty: '" + U2 + "' } ", e25.opts.messages !== false && (n2 += " , message: '", e25.opts._errorDataPathProperty ? n2 += "is an invalid additional property" : n2 += "should NOT have additional properties", n2 += "' "), e25.opts.verbose && (n2 += " , schema: false , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ";
          var W2 = n2;
          n2 = re2.pop(), !e25.compositeRule && l2 ? e25.async ? n2 += " throw new ValidationError([" + W2 + "]); " : n2 += " validate.errors = [" + W2 + "]; return false; " : n2 += " var err = " + W2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c2 = q2, l2 && (n2 += " break; ");
        }
      else if (A2)
        if (w2 == "failing") {
          n2 += " var " + f2 + " = errors;  ";
          var $2 = e25.compositeRule;
          e25.compositeRule = h2.compositeRule = true, h2.schema = k2, h2.schemaPath = e25.schemaPath + ".additionalProperties", h2.errSchemaPath = e25.errSchemaPath + "/additionalProperties", h2.errorPath = e25.opts._errorDataPathProperty ? e25.errorPath : e25.util.getPathExpr(e25.errorPath, g2, e25.opts.jsonPointers);
          var G2 = p2 + "[" + g2 + "]";
          h2.dataPathArr[v2] = g2;
          var z2 = e25.validate(h2);
          h2.baseId = P2, e25.util.varOccurences(z2, x2) < 2 ? n2 += " " + e25.util.varReplace(z2, x2, G2) + " " : n2 += " var " + x2 + " = " + G2 + "; " + z2 + " ", n2 += " if (!" + m2 + ") { errors = " + f2 + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + p2 + "[" + g2 + "]; }  ", e25.compositeRule = h2.compositeRule = $2;
        } else {
          h2.schema = k2, h2.schemaPath = e25.schemaPath + ".additionalProperties", h2.errSchemaPath = e25.errSchemaPath + "/additionalProperties", h2.errorPath = e25.opts._errorDataPathProperty ? e25.errorPath : e25.util.getPathExpr(e25.errorPath, g2, e25.opts.jsonPointers);
          G2 = p2 + "[" + g2 + "]";
          h2.dataPathArr[v2] = g2;
          z2 = e25.validate(h2);
          h2.baseId = P2, e25.util.varOccurences(z2, x2) < 2 ? n2 += " " + e25.util.varReplace(z2, x2, G2) + " " : n2 += " var " + x2 + " = " + G2 + "; " + z2 + " ", l2 && (n2 += " if (!" + m2 + ") break; ");
        }
      e25.errorPath = V2;
    }
    D2 && (n2 += " } "), n2 += " }  ", l2 && (n2 += " if (" + m2 + ") { ", d2 += "}");
  }
  var H2 = e25.opts.useDefaults && !e25.compositeRule;
  if (E2.length) {
    var K2 = E2;
    if (K2)
      for (var J2, Q2 = -1, X2 = K2.length - 1; Q2 < X2; ) {
        var Y2 = s2[J2 = K2[Q2 += 1]];
        if (e25.opts.strictKeywords ? i(Y2) == "object" && Object.keys(Y2).length > 0 : e25.util.schemaHasRules(Y2, e25.RULES.all)) {
          var Z2 = e25.util.getProperty(J2), ee2 = (G2 = p2 + Z2, H2 && Y2.default !== void 0);
          h2.schema = Y2, h2.schemaPath = u2 + Z2, h2.errSchemaPath = c2 + "/" + e25.util.escapeFragment(J2), h2.errorPath = e25.util.getPath(e25.errorPath, J2, e25.opts.jsonPointers), h2.dataPathArr[v2] = e25.util.toQuotedString(J2);
          z2 = e25.validate(h2);
          if (h2.baseId = P2, e25.util.varOccurences(z2, x2) < 2) {
            z2 = e25.util.varReplace(z2, x2, G2);
            var te2 = G2;
          } else {
            te2 = x2;
            n2 += " var " + x2 + " = " + G2 + "; ";
          }
          if (ee2)
            n2 += " " + z2 + " ";
          else {
            if (B2 && B2[J2]) {
              n2 += " if ( " + te2 + " === undefined ", T2 && (n2 += " || ! Object.prototype.hasOwnProperty.call(" + p2 + ", '" + e25.util.escapeQuotes(J2) + "') "), n2 += ") { " + m2 + " = false; ";
              V2 = e25.errorPath, q2 = c2;
              var re2, ne2 = e25.util.escapeQuotes(J2);
              e25.opts._errorDataPathProperty && (e25.errorPath = e25.util.getPath(V2, J2, e25.opts.jsonPointers)), c2 = e25.errSchemaPath + "/required", (re2 = re2 || []).push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'required' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { missingProperty: '" + ne2 + "' } ", e25.opts.messages !== false && (n2 += " , message: '", e25.opts._errorDataPathProperty ? n2 += "is a required property" : n2 += "should have required property \\'" + ne2 + "\\'", n2 += "' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ";
              W2 = n2;
              n2 = re2.pop(), !e25.compositeRule && l2 ? e25.async ? n2 += " throw new ValidationError([" + W2 + "]); " : n2 += " validate.errors = [" + W2 + "]; return false; " : n2 += " var err = " + W2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", c2 = q2, e25.errorPath = V2, n2 += " } else { ";
            } else
              l2 ? (n2 += " if ( " + te2 + " === undefined ", T2 && (n2 += " || ! Object.prototype.hasOwnProperty.call(" + p2 + ", '" + e25.util.escapeQuotes(J2) + "') "), n2 += ") { " + m2 + " = true; } else { ") : (n2 += " if (" + te2 + " !== undefined ", T2 && (n2 += " &&   Object.prototype.hasOwnProperty.call(" + p2 + ", '" + e25.util.escapeQuotes(J2) + "') "), n2 += " ) { ");
            n2 += " " + z2 + " } ";
          }
        }
        l2 && (n2 += " if (" + m2 + ") { ", d2 += "}");
      }
  }
  if (S2.length) {
    var ie2 = S2;
    if (ie2)
      for (var ae2, oe2 = -1, se2 = ie2.length - 1; oe2 < se2; ) {
        Y2 = C2[ae2 = ie2[oe2 += 1]];
        if (e25.opts.strictKeywords ? i(Y2) == "object" && Object.keys(Y2).length > 0 : e25.util.schemaHasRules(Y2, e25.RULES.all)) {
          h2.schema = Y2, h2.schemaPath = e25.schemaPath + ".patternProperties" + e25.util.getProperty(ae2), h2.errSchemaPath = e25.errSchemaPath + "/patternProperties/" + e25.util.escapeFragment(ae2), n2 += T2 ? " " + b2 + " = " + b2 + " || Object.keys(" + p2 + "); for (var " + y2 + "=0; " + y2 + "<" + b2 + ".length; " + y2 + "++) { var " + g2 + " = " + b2 + "[" + y2 + "]; " : " for (var " + g2 + " in " + p2 + ") { ", n2 += " if (" + e25.usePattern(ae2) + ".test(" + g2 + ")) { ", h2.errorPath = e25.util.getPathExpr(e25.errorPath, g2, e25.opts.jsonPointers);
          G2 = p2 + "[" + g2 + "]";
          h2.dataPathArr[v2] = g2;
          z2 = e25.validate(h2);
          h2.baseId = P2, e25.util.varOccurences(z2, x2) < 2 ? n2 += " " + e25.util.varReplace(z2, x2, G2) + " " : n2 += " var " + x2 + " = " + G2 + "; " + z2 + " ", l2 && (n2 += " if (!" + m2 + ") break; "), n2 += " } ", l2 && (n2 += " else " + m2 + " = true; "), n2 += " }  ", l2 && (n2 += " if (" + m2 + ") { ", d2 += "}");
        }
      }
  }
  return l2 && (n2 += " " + d2 + " if (" + f2 + " == errors) {"), n2 = e25.util.cleanUpCode(n2);
}, propertyNames: function(e25, t2, r2) {
  var n2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = "errs__" + a2, h2 = e25.util.copy(e25);
  h2.level++;
  var d2 = "valid" + h2.level;
  if (n2 += "var " + f2 + " = errors;", e25.opts.strictKeywords ? i(s2) == "object" && Object.keys(s2).length > 0 : e25.util.schemaHasRules(s2, e25.RULES.all)) {
    h2.schema = s2, h2.schemaPath = u2, h2.errSchemaPath = c2;
    var m2 = "key" + a2, g2 = "idx" + a2, y2 = "i" + a2, v2 = "' + " + m2 + " + '", x2 = "data" + (h2.dataLevel = e25.dataLevel + 1), b2 = "dataProperties" + a2, E2 = e25.opts.ownProperties, C2 = e25.baseId;
    E2 && (n2 += " var " + b2 + " = undefined; "), n2 += E2 ? " " + b2 + " = " + b2 + " || Object.keys(" + p2 + "); for (var " + g2 + "=0; " + g2 + "<" + b2 + ".length; " + g2 + "++) { var " + m2 + " = " + b2 + "[" + g2 + "]; " : " for (var " + m2 + " in " + p2 + ") { ", n2 += " var startErrs" + a2 + " = errors; ";
    var S2 = m2, k2 = e25.compositeRule;
    e25.compositeRule = h2.compositeRule = true;
    var D2 = e25.validate(h2);
    h2.baseId = C2, e25.util.varOccurences(D2, x2) < 2 ? n2 += " " + e25.util.varReplace(D2, x2, S2) + " " : n2 += " var " + x2 + " = " + S2 + "; " + D2 + " ", e25.compositeRule = h2.compositeRule = k2, n2 += " if (!" + d2 + ") { for (var " + y2 + "=startErrs" + a2 + "; " + y2 + "<errors; " + y2 + "++) { vErrors[" + y2 + "].propertyName = " + m2 + "; }   var err =   ", e25.createErrors !== false ? (n2 += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { propertyName: '" + v2 + "' } ", e25.opts.messages !== false && (n2 += " , message: 'property name \\'" + v2 + "\\' is invalid' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ", n2 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e25.compositeRule && l2 && (e25.async ? n2 += " throw new ValidationError(vErrors); " : n2 += " validate.errors = vErrors; return false; "), l2 && (n2 += " break; "), n2 += " } }";
  }
  return l2 && (n2 += "  if (" + f2 + " == errors) {"), n2 = e25.util.cleanUpCode(n2);
}, required: function(e25, t2, r2) {
  var n2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = "valid" + a2, h2 = e25.opts.$data && s2 && s2.$data;
  h2 && (n2 += " var schema" + a2 + " = " + e25.util.getData(s2.$data, o2, e25.dataPathArr) + "; ");
  var d2 = "schema" + a2;
  if (!h2)
    if (s2.length < e25.opts.loopRequired && e25.schema.properties && Object.keys(e25.schema.properties).length) {
      var m2 = [], g2 = s2;
      if (g2)
        for (var y2, v2 = -1, x2 = g2.length - 1; v2 < x2; ) {
          y2 = g2[v2 += 1];
          var b2 = e25.schema.properties[y2];
          b2 && (e25.opts.strictKeywords ? i(b2) == "object" && Object.keys(b2).length > 0 : e25.util.schemaHasRules(b2, e25.RULES.all)) || (m2[m2.length] = y2);
        }
    } else
      m2 = s2;
  if (h2 || m2.length) {
    var E2 = e25.errorPath, C2 = h2 || m2.length >= e25.opts.loopRequired, S2 = e25.opts.ownProperties;
    if (l2)
      if (n2 += " var missing" + a2 + "; ", C2) {
        h2 || (n2 += " var " + d2 + " = validate.schema" + u2 + "; ");
        var k2 = "' + " + (T2 = "schema" + a2 + "[" + (A2 = "i" + a2) + "]") + " + '";
        e25.opts._errorDataPathProperty && (e25.errorPath = e25.util.getPathExpr(E2, T2, e25.opts.jsonPointers)), n2 += " var " + f2 + " = true; ", h2 && (n2 += " if (schema" + a2 + " === undefined) " + f2 + " = true; else if (!Array.isArray(schema" + a2 + ")) " + f2 + " = false; else {"), n2 += " for (var " + A2 + " = 0; " + A2 + " < " + d2 + ".length; " + A2 + "++) { " + f2 + " = " + p2 + "[" + d2 + "[" + A2 + "]] !== undefined ", S2 && (n2 += " &&   Object.prototype.hasOwnProperty.call(" + p2 + ", " + d2 + "[" + A2 + "]) "), n2 += "; if (!" + f2 + ") break; } ", h2 && (n2 += "  }  "), n2 += "  if (!" + f2 + ") {   ", (_2 = _2 || []).push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'required' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { missingProperty: '" + k2 + "' } ", e25.opts.messages !== false && (n2 += " , message: '", e25.opts._errorDataPathProperty ? n2 += "is a required property" : n2 += "should have required property \\'" + k2 + "\\'", n2 += "' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ";
        var D2 = n2;
        n2 = _2.pop(), !e25.compositeRule && l2 ? e25.async ? n2 += " throw new ValidationError([" + D2 + "]); " : n2 += " validate.errors = [" + D2 + "]; return false; " : n2 += " var err = " + D2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n2 += " } else { ";
      } else {
        n2 += " if ( ";
        var F2 = m2;
        if (F2)
          for (var A2 = -1, w2 = F2.length - 1; A2 < w2; ) {
            I2 = F2[A2 += 1], A2 && (n2 += " || "), n2 += " ( ( " + (N2 = p2 + (L2 = e25.util.getProperty(I2))) + " === undefined ", S2 && (n2 += " || ! Object.prototype.hasOwnProperty.call(" + p2 + ", '" + e25.util.escapeQuotes(I2) + "') "), n2 += ") && (missing" + a2 + " = " + e25.util.toQuotedString(e25.opts.jsonPointers ? I2 : L2) + ") ) ";
          }
        n2 += ") {  ";
        var _2;
        k2 = "' + " + (T2 = "missing" + a2) + " + '";
        e25.opts._errorDataPathProperty && (e25.errorPath = e25.opts.jsonPointers ? e25.util.getPathExpr(E2, T2, true) : E2 + " + " + T2), (_2 = _2 || []).push(n2), n2 = "", e25.createErrors !== false ? (n2 += " { keyword: 'required' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { missingProperty: '" + k2 + "' } ", e25.opts.messages !== false && (n2 += " , message: '", e25.opts._errorDataPathProperty ? n2 += "is a required property" : n2 += "should have required property \\'" + k2 + "\\'", n2 += "' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ";
        D2 = n2;
        n2 = _2.pop(), !e25.compositeRule && l2 ? e25.async ? n2 += " throw new ValidationError([" + D2 + "]); " : n2 += " validate.errors = [" + D2 + "]; return false; " : n2 += " var err = " + D2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", n2 += " } else { ";
      }
    else if (C2) {
      h2 || (n2 += " var " + d2 + " = validate.schema" + u2 + "; ");
      var T2;
      k2 = "' + " + (T2 = "schema" + a2 + "[" + (A2 = "i" + a2) + "]") + " + '";
      e25.opts._errorDataPathProperty && (e25.errorPath = e25.util.getPathExpr(E2, T2, e25.opts.jsonPointers)), h2 && (n2 += " if (" + d2 + " && !Array.isArray(" + d2 + ")) {  var err =   ", e25.createErrors !== false ? (n2 += " { keyword: 'required' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { missingProperty: '" + k2 + "' } ", e25.opts.messages !== false && (n2 += " , message: '", e25.opts._errorDataPathProperty ? n2 += "is a required property" : n2 += "should have required property \\'" + k2 + "\\'", n2 += "' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ", n2 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + d2 + " !== undefined) { "), n2 += " for (var " + A2 + " = 0; " + A2 + " < " + d2 + ".length; " + A2 + "++) { if (" + p2 + "[" + d2 + "[" + A2 + "]] === undefined ", S2 && (n2 += " || ! Object.prototype.hasOwnProperty.call(" + p2 + ", " + d2 + "[" + A2 + "]) "), n2 += ") {  var err =   ", e25.createErrors !== false ? (n2 += " { keyword: 'required' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { missingProperty: '" + k2 + "' } ", e25.opts.messages !== false && (n2 += " , message: '", e25.opts._errorDataPathProperty ? n2 += "is a required property" : n2 += "should have required property \\'" + k2 + "\\'", n2 += "' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ", n2 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ", h2 && (n2 += "  }  ");
    } else {
      var P2 = m2;
      if (P2)
        for (var I2, B2 = -1, O2 = P2.length - 1; B2 < O2; ) {
          I2 = P2[B2 += 1];
          var L2 = e25.util.getProperty(I2), N2 = (k2 = e25.util.escapeQuotes(I2), p2 + L2);
          e25.opts._errorDataPathProperty && (e25.errorPath = e25.util.getPath(E2, I2, e25.opts.jsonPointers)), n2 += " if ( " + N2 + " === undefined ", S2 && (n2 += " || ! Object.prototype.hasOwnProperty.call(" + p2 + ", '" + e25.util.escapeQuotes(I2) + "') "), n2 += ") {  var err =   ", e25.createErrors !== false ? (n2 += " { keyword: 'required' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { missingProperty: '" + k2 + "' } ", e25.opts.messages !== false && (n2 += " , message: '", e25.opts._errorDataPathProperty ? n2 += "is a required property" : n2 += "should have required property \\'" + k2 + "\\'", n2 += "' "), e25.opts.verbose && (n2 += " , schema: validate.schema" + u2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), n2 += " } ") : n2 += " {} ", n2 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
        }
    }
    e25.errorPath = E2;
  } else
    l2 && (n2 += " if (true) {");
  return n2;
}, uniqueItems: function(e25, t2, r2) {
  var n2, i2 = " ", a2 = e25.level, o2 = e25.dataLevel, s2 = e25.schema[t2], u2 = e25.schemaPath + e25.util.getProperty(t2), c2 = e25.errSchemaPath + "/" + t2, l2 = !e25.opts.allErrors, p2 = "data" + (o2 || ""), f2 = "valid" + a2, h2 = e25.opts.$data && s2 && s2.$data;
  if (h2 ? (i2 += " var schema" + a2 + " = " + e25.util.getData(s2.$data, o2, e25.dataPathArr) + "; ", n2 = "schema" + a2) : n2 = s2, (s2 || h2) && e25.opts.uniqueItems !== false) {
    h2 && (i2 += " var " + f2 + "; if (" + n2 + " === false || " + n2 + " === undefined) " + f2 + " = true; else if (typeof " + n2 + " != 'boolean') " + f2 + " = false; else { "), i2 += " var i = " + p2 + ".length , " + f2 + " = true , j; if (i > 1) { ";
    var d2 = e25.schema.items && e25.schema.items.type, m2 = Array.isArray(d2);
    if (!d2 || d2 == "object" || d2 == "array" || m2 && (d2.indexOf("object") >= 0 || d2.indexOf("array") >= 0))
      i2 += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + p2 + "[i], " + p2 + "[j])) { " + f2 + " = false; break outer; } } } ";
    else {
      i2 += " var itemIndices = {}, item; for (;i--;) { var item = " + p2 + "[i]; ";
      var g2 = "checkDataType" + (m2 ? "s" : "");
      i2 += " if (" + e25.util[g2](d2, "item", true) + ") continue; ", m2 && (i2 += ` if (typeof item == 'string') item = '"' + item; `), i2 += " if (typeof itemIndices[item] == 'number') { " + f2 + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ";
    }
    i2 += " } ", h2 && (i2 += "  }  "), i2 += " if (!" + f2 + ") {   ";
    var y2 = y2 || [];
    y2.push(i2), i2 = "", e25.createErrors !== false ? (i2 += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(c2) + " , params: { i: i, j: j } ", e25.opts.messages !== false && (i2 += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' "), e25.opts.verbose && (i2 += " , schema:  ", i2 += h2 ? "validate.schema" + u2 : "" + s2, i2 += "         , parentSchema: validate.schema" + e25.schemaPath + " , data: " + p2 + " "), i2 += " } ") : i2 += " {} ";
    var v2 = i2;
    i2 = y2.pop(), !e25.compositeRule && l2 ? e25.async ? i2 += " throw new ValidationError([" + v2 + "]); " : i2 += " validate.errors = [" + v2 + "]; return false; " : i2 += " var err = " + v2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", i2 += " } ", l2 && (i2 += " else { ");
  } else
    l2 && (i2 += " if (true) { ");
  return i2;
}, validate: Sv }, ox = Iy.toHash, sx = function() {
  var e25 = [{ type: "number", rules: [{ maximum: ["exclusiveMaximum"] }, { minimum: ["exclusiveMinimum"] }, "multipleOf", "format"] }, { type: "string", rules: ["maxLength", "minLength", "pattern", "format"] }, { type: "array", rules: ["maxItems", "minItems", "items", "contains", "uniqueItems"] }, { type: "object", rules: ["maxProperties", "minProperties", "required", "dependencies", "propertyNames", { properties: ["additionalProperties", "patternProperties"] }] }, { rules: ["$ref", "const", "enum", "not", "anyOf", "oneOf", "allOf", "if"] }], t2 = ["type", "$comment"];
  return e25.all = ox(t2), e25.types = ox(["number", "integer", "string", "array", "object", "boolean", "null"]), e25.forEach(function(r2) {
    r2.rules = r2.rules.map(function(r3) {
      var n2;
      if (i(r3) == "object") {
        var a2 = Object.keys(r3)[0];
        n2 = r3[a2], r3 = a2, n2.forEach(function(r4) {
          t2.push(r4), e25.all[r4] = true;
        });
      }
      return t2.push(r3), e25.all[r3] = { keyword: r3, code: ax[r3], implements: n2 };
    }), e25.all.$comment = { keyword: "$comment", code: ax.$comment }, r2.type && (e25.types[r2.type] = r2);
  }), e25.keywords = ox(t2.concat(["$schema", "$id", "id", "$data", "$async", "title", "description", "default", "definitions", "examples", "readOnly", "writeOnly", "contentMediaType", "contentEncoding", "additionalItems", "then", "else"])), e25.custom = {}, e25;
}, ux = ["multipleOf", "maximum", "exclusiveMaximum", "minimum", "exclusiveMinimum", "maxLength", "minLength", "pattern", "additionalItems", "maxItems", "minItems", "uniqueItems", "maxProperties", "minProperties", "required", "additionalProperties", "enum", "format", "const"], cx = function(e25, t2) {
  for (var r2 = 0; r2 < t2.length; r2++) {
    e25 = JSON.parse(JSON.stringify(e25));
    var n2, i2 = t2[r2].split("/"), a2 = e25;
    for (n2 = 1; n2 < i2.length; n2++)
      a2 = a2[i2[n2]];
    for (n2 = 0; n2 < ux.length; n2++) {
      var o2 = ux[n2], s2 = a2[o2];
      s2 && (a2[o2] = { anyOf: [s2, { $ref: "https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#" }] });
    }
  }
  return e25;
}, lx = xv.MissingRef, px = function e23(t2, r2, n2) {
  var i2 = this;
  if (typeof this._opts.loadSchema != "function")
    throw new Error("options.loadSchema should be a function");
  typeof r2 == "function" && (n2 = r2, r2 = void 0);
  var a2 = o2(t2).then(function() {
    var e25 = i2._addSchema(t2, void 0, r2);
    return e25.validate || function e26(t3) {
      try {
        return i2._compile(t3);
      } catch (n3) {
        if (n3 instanceof lx)
          return function(n4) {
            var a3 = n4.missingSchema;
            if (c2(a3))
              throw new Error("Schema " + a3 + " is loaded but " + n4.missingRef + " cannot be resolved");
            var s2 = i2._loadingSchemas[a3];
            s2 || (s2 = i2._loadingSchemas[a3] = i2._opts.loadSchema(a3)).then(u2, u2);
            return s2.then(function(e27) {
              if (!c2(a3))
                return o2(e27).then(function() {
                  c2(a3) || i2.addSchema(e27, a3, void 0, r2);
                });
            }).then(function() {
              return e26(t3);
            });
            function u2() {
              delete i2._loadingSchemas[a3];
            }
            function c2(e27) {
              return i2._refs[e27] || i2._schemas[e27];
            }
          }(n3);
        throw n3;
      }
    }(e25);
  });
  n2 && a2.then(function(e25) {
    n2(null, e25);
  }, n2);
  return a2;
  function o2(t3) {
    var r3 = t3.$schema;
    return r3 && !i2.getSchema(r3) ? e23.call(i2, { $ref: r3 }, true) : Promise.resolve();
  }
};
var fx = function(e25, t2, r2) {
  var n2, i2, a2 = " ", o2 = e25.level, s2 = e25.dataLevel, u2 = e25.schema[t2], c2 = e25.schemaPath + e25.util.getProperty(t2), l2 = e25.errSchemaPath + "/" + t2, p2 = !e25.opts.allErrors, f2 = "data" + (s2 || ""), h2 = "valid" + o2, d2 = "errs__" + o2, m2 = e25.opts.$data && u2 && u2.$data;
  m2 ? (a2 += " var schema" + o2 + " = " + e25.util.getData(u2.$data, s2, e25.dataPathArr) + "; ", i2 = "schema" + o2) : i2 = u2;
  var g2, y2, v2, x2, b2, E2 = "definition" + o2, C2 = this.definition, S2 = "";
  if (m2 && C2.$data) {
    b2 = "keywordValidate" + o2;
    var k2 = C2.validateSchema;
    a2 += " var " + E2 + " = RULES.custom['" + t2 + "'].definition; var " + b2 + " = " + E2 + ".validate;";
  } else {
    if (!(x2 = e25.useCustomRule(this, u2, e25.schema, e25)))
      return;
    i2 = "validate.schema" + c2, b2 = x2.code, g2 = C2.compile, y2 = C2.inline, v2 = C2.macro;
  }
  var D2 = b2 + ".errors", F2 = "i" + o2, A2 = "ruleErr" + o2, w2 = C2.async;
  if (w2 && !e25.async)
    throw new Error("async keyword in sync schema");
  if (y2 || v2 || (a2 += D2 + " = null;"), a2 += "var " + d2 + " = errors;var " + h2 + ";", m2 && C2.$data && (S2 += "}", a2 += " if (" + i2 + " === undefined) { " + h2 + " = true; } else { ", k2 && (S2 += "}", a2 += " " + h2 + " = " + E2 + ".validateSchema(" + i2 + "); if (" + h2 + ") { ")), y2)
    C2.statements ? a2 += " " + x2.validate + " " : a2 += " " + h2 + " = " + x2.validate + "; ";
  else if (v2) {
    var _2 = e25.util.copy(e25);
    S2 = "";
    _2.level++;
    var T2 = "valid" + _2.level;
    _2.schema = x2.validate, _2.schemaPath = "";
    var P2 = e25.compositeRule;
    e25.compositeRule = _2.compositeRule = true;
    var I2 = e25.validate(_2).replace(/validate\.schema/g, b2);
    e25.compositeRule = _2.compositeRule = P2, a2 += " " + I2;
  } else {
    (N2 = N2 || []).push(a2), a2 = "", a2 += "  " + b2 + ".call( ", e25.opts.passContext ? a2 += "this" : a2 += "self", g2 || C2.schema === false ? a2 += " , " + f2 + " " : a2 += " , " + i2 + " , " + f2 + " , validate.schema" + e25.schemaPath + " ", a2 += " , (dataPath || '')", e25.errorPath != '""' && (a2 += " + " + e25.errorPath);
    var B2 = s2 ? "data" + (s2 - 1 || "") : "parentData", O2 = s2 ? e25.dataPathArr[s2] : "parentDataProperty", L2 = a2 += " , " + B2 + " , " + O2 + " , rootData )  ";
    a2 = N2.pop(), C2.errors === false ? (a2 += " " + h2 + " = ", w2 && (a2 += "await "), a2 += L2 + "; ") : a2 += w2 ? " var " + (D2 = "customErrors" + o2) + " = null; try { " + h2 + " = await " + L2 + "; } catch (e) { " + h2 + " = false; if (e instanceof ValidationError) " + D2 + " = e.errors; else throw e; } " : " " + D2 + " = null; " + h2 + " = " + L2 + "; ";
  }
  if (C2.modifying && (a2 += " if (" + B2 + ") " + f2 + " = " + B2 + "[" + O2 + "];"), a2 += "" + S2, C2.valid)
    p2 && (a2 += " if (true) { ");
  else {
    var N2;
    a2 += " if ( ", C2.valid === void 0 ? (a2 += " !", a2 += v2 ? "" + T2 : "" + h2) : a2 += " " + !C2.valid + " ", a2 += ") { ", n2 = this.keyword, (N2 = N2 || []).push(a2), a2 = "", (N2 = N2 || []).push(a2), a2 = "", e25.createErrors !== false ? (a2 += " { keyword: '" + (n2 || "custom") + "' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(l2) + " , params: { keyword: '" + this.keyword + "' } ", e25.opts.messages !== false && (a2 += ` , message: 'should pass "` + this.keyword + `" keyword validation' `), e25.opts.verbose && (a2 += " , schema: validate.schema" + c2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + f2 + " "), a2 += " } ") : a2 += " {} ";
    var j2 = a2;
    a2 = N2.pop(), !e25.compositeRule && p2 ? e25.async ? a2 += " throw new ValidationError([" + j2 + "]); " : a2 += " validate.errors = [" + j2 + "]; return false; " : a2 += " var err = " + j2 + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    var R2 = a2;
    a2 = N2.pop(), y2 ? C2.errors ? C2.errors != "full" && (a2 += "  for (var " + F2 + "=" + d2 + "; " + F2 + "<errors; " + F2 + "++) { var " + A2 + " = vErrors[" + F2 + "]; if (" + A2 + ".dataPath === undefined) " + A2 + ".dataPath = (dataPath || '') + " + e25.errorPath + "; if (" + A2 + ".schemaPath === undefined) { " + A2 + '.schemaPath = "' + l2 + '"; } ', e25.opts.verbose && (a2 += " " + A2 + ".schema = " + i2 + "; " + A2 + ".data = " + f2 + "; "), a2 += " } ") : C2.errors === false ? a2 += " " + R2 + " " : (a2 += " if (" + d2 + " == errors) { " + R2 + " } else {  for (var " + F2 + "=" + d2 + "; " + F2 + "<errors; " + F2 + "++) { var " + A2 + " = vErrors[" + F2 + "]; if (" + A2 + ".dataPath === undefined) " + A2 + ".dataPath = (dataPath || '') + " + e25.errorPath + "; if (" + A2 + ".schemaPath === undefined) { " + A2 + '.schemaPath = "' + l2 + '"; } ', e25.opts.verbose && (a2 += " " + A2 + ".schema = " + i2 + "; " + A2 + ".data = " + f2 + "; "), a2 += " } } ") : v2 ? (a2 += "   var err =   ", e25.createErrors !== false ? (a2 += " { keyword: '" + (n2 || "custom") + "' , dataPath: (dataPath || '') + " + e25.errorPath + " , schemaPath: " + e25.util.toQuotedString(l2) + " , params: { keyword: '" + this.keyword + "' } ", e25.opts.messages !== false && (a2 += ` , message: 'should pass "` + this.keyword + `" keyword validation' `), e25.opts.verbose && (a2 += " , schema: validate.schema" + c2 + " , parentSchema: validate.schema" + e25.schemaPath + " , data: " + f2 + " "), a2 += " } ") : a2 += " {} ", a2 += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ", !e25.compositeRule && p2 && (e25.async ? a2 += " throw new ValidationError(vErrors); " : a2 += " validate.errors = vErrors; return false; ")) : C2.errors === false ? a2 += " " + R2 + " " : (a2 += " if (Array.isArray(" + D2 + ")) { if (vErrors === null) vErrors = " + D2 + "; else vErrors = vErrors.concat(" + D2 + "); errors = vErrors.length;  for (var " + F2 + "=" + d2 + "; " + F2 + "<errors; " + F2 + "++) { var " + A2 + " = vErrors[" + F2 + "]; if (" + A2 + ".dataPath === undefined) " + A2 + ".dataPath = (dataPath || '') + " + e25.errorPath + ";  " + A2 + '.schemaPath = "' + l2 + '";  ', e25.opts.verbose && (a2 += " " + A2 + ".schema = " + i2 + "; " + A2 + ".data = " + f2 + "; "), a2 += " } } else { " + R2 + " } "), a2 += " } ", p2 && (a2 += " else { ");
  }
  return a2;
}, hx = "http://json-schema.org/draft-07/schema#", dx = "http://json-schema.org/draft-07/schema#", mx = "Core schema meta-schema", gx = { schemaArray: { type: "array", minItems: 1, items: { $ref: "#" } }, nonNegativeInteger: { type: "integer", minimum: 0 }, nonNegativeIntegerDefault0: { allOf: [{ $ref: "#/definitions/nonNegativeInteger" }, { default: 0 }] }, simpleTypes: { enum: ["array", "boolean", "integer", "null", "number", "object", "string"] }, stringArray: { type: "array", items: { type: "string" }, uniqueItems: true, default: [] } }, yx = ["object", "boolean"], vx = { $id: { type: "string", format: "uri-reference" }, $schema: { type: "string", format: "uri" }, $ref: { type: "string", format: "uri-reference" }, $comment: { type: "string" }, title: { type: "string" }, description: { type: "string" }, default: true, readOnly: { type: "boolean", default: false }, examples: { type: "array", items: true }, multipleOf: { type: "number", exclusiveMinimum: 0 }, maximum: { type: "number" }, exclusiveMaximum: { type: "number" }, minimum: { type: "number" }, exclusiveMinimum: { type: "number" }, maxLength: { $ref: "#/definitions/nonNegativeInteger" }, minLength: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, pattern: { type: "string", format: "regex" }, additionalItems: { $ref: "#" }, items: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }], default: true }, maxItems: { $ref: "#/definitions/nonNegativeInteger" }, minItems: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, uniqueItems: { type: "boolean", default: false }, contains: { $ref: "#" }, maxProperties: { $ref: "#/definitions/nonNegativeInteger" }, minProperties: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, required: { $ref: "#/definitions/stringArray" }, additionalProperties: { $ref: "#" }, definitions: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, properties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, patternProperties: { type: "object", additionalProperties: { $ref: "#" }, propertyNames: { format: "regex" }, default: {} }, dependencies: { type: "object", additionalProperties: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }] } }, propertyNames: { $ref: "#" }, const: true, enum: { type: "array", items: true, minItems: 1, uniqueItems: true }, type: { anyOf: [{ $ref: "#/definitions/simpleTypes" }, { type: "array", items: { $ref: "#/definitions/simpleTypes" }, minItems: 1, uniqueItems: true }] }, format: { type: "string" }, contentMediaType: { type: "string" }, contentEncoding: { type: "string" }, if: { $ref: "#" }, then: { $ref: "#" }, else: { $ref: "#" }, allOf: { $ref: "#/definitions/schemaArray" }, anyOf: { $ref: "#/definitions/schemaArray" }, oneOf: { $ref: "#/definitions/schemaArray" }, not: { $ref: "#" } }, xx = { $schema: hx, $id: dx, title: mx, definitions: gx, type: yx, properties: vx, default: true }, bx = n(Object.freeze({ __proto__: null, $schema: hx, $id: dx, title: mx, definitions: gx, type: yx, properties: vx, default: xx })), Ex = { $id: "https://github.com/epoberezkin/ajv/blob/master/lib/definition_schema.js", definitions: { simpleTypes: bx.definitions.simpleTypes }, type: "object", dependencies: { schema: ["validate"], $data: ["validate"], statements: ["inline"], valid: { not: { required: ["macro"] } } }, properties: { type: bx.properties.type, schema: { type: "boolean" }, statements: { type: "boolean" }, dependencies: { type: "array", items: { type: "string" } }, metaSchema: { type: "object" }, modifying: { type: "boolean" }, valid: { type: "boolean" }, $data: { type: "boolean" }, async: { type: "boolean" }, errors: { anyOf: [{ type: "boolean" }, { const: "full" }] } } }, Cx = /^[a-z_$][a-z0-9_$-]*$/i, Sx = function(e25, t2) {
  var r2 = this.RULES;
  if (r2.keywords[e25])
    throw new Error("Keyword " + e25 + " is already defined");
  if (!Cx.test(e25))
    throw new Error("Keyword " + e25 + " is not a valid identifier");
  if (t2) {
    this.validateKeyword(t2, true);
    var n2 = t2.type;
    if (Array.isArray(n2))
      for (var i2 = 0; i2 < n2.length; i2++)
        o2(e25, n2[i2], t2);
    else
      o2(e25, n2, t2);
    var a2 = t2.metaSchema;
    a2 && (t2.$data && this._opts.$data && (a2 = { anyOf: [a2, { $ref: "https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#" }] }), t2.validateSchema = this.compile(a2, true));
  }
  function o2(e26, t3, n3) {
    for (var i3, a3 = 0; a3 < r2.length; a3++) {
      var o3 = r2[a3];
      if (o3.type == t3) {
        i3 = o3;
        break;
      }
    }
    i3 || (i3 = { type: t3, rules: [] }, r2.push(i3));
    var s2 = { keyword: e26, definition: n3, custom: true, code: fx, implements: n3.implements };
    i3.rules.push(s2), r2.custom[e26] = s2;
  }
  return r2.keywords[e25] = r2.all[e25] = true, this;
}, kx = function(e25) {
  var t2 = this.RULES.custom[e25];
  return t2 ? t2.definition : this.RULES.keywords[e25] || false;
}, Dx = function(e25) {
  var t2 = this.RULES;
  delete t2.keywords[e25], delete t2.all[e25], delete t2.custom[e25];
  for (var r2 = 0; r2 < t2.length; r2++)
    for (var n2 = t2[r2].rules, i2 = 0; i2 < n2.length; i2++)
      if (n2[i2].keyword == e25) {
        n2.splice(i2, 1);
        break;
      }
  return this;
}, Fx = function e24(t2, r2) {
  e24.errors = null;
  var n2 = this._validateKeyword = this._validateKeyword || this.compile(Ex, true);
  if (n2(t2))
    return true;
  if (e24.errors = n2.errors, r2)
    throw new Error("custom keyword definition is invalid: " + this.errorsText(n2.errors));
  return false;
};
var Ax = "http://json-schema.org/draft-07/schema#", wx = "https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/data.json#", _x = "Meta-schema for $data reference (JSON Schema extension proposal)", Tx = ["$data"], Px = { $data: { type: "string", anyOf: [{ format: "relative-json-pointer" }, { format: "json-pointer" }] } }, Ix = { $schema: Ax, $id: wx, description: _x, type: "object", required: Tx, properties: Px, additionalProperties: false }, Bx = n(Object.freeze({ __proto__: null, $schema: Ax, $id: wx, description: _x, type: "object", required: Tx, properties: Px, additionalProperties: false, default: Ix })), Ox = Rx;
Rx.prototype.validate = function(e25, t2) {
  var r2;
  if (typeof e25 == "string") {
    if (!(r2 = this.getSchema(e25)))
      throw new Error('no schema with key or ref "' + e25 + '"');
  } else {
    var n2 = this._addSchema(e25);
    r2 = n2.validate || this._compile(n2);
  }
  var i2 = r2(t2);
  r2.$async !== true && (this.errors = r2.errors);
  return i2;
}, Rx.prototype.compile = function(e25, t2) {
  var r2 = this._addSchema(e25, void 0, t2);
  return r2.validate || this._compile(r2);
}, Rx.prototype.addSchema = function(e25, t2, r2, n2) {
  if (Array.isArray(e25)) {
    for (var i2 = 0; i2 < e25.length; i2++)
      this.addSchema(e25[i2], void 0, r2, n2);
    return this;
  }
  var a2 = this._getId(e25);
  if (a2 !== void 0 && typeof a2 != "string")
    throw new Error("schema id must be string");
  return $x(this, t2 = ov.normalizeId(t2 || a2)), this._schemas[t2] = this._addSchema(e25, r2, n2, true), this;
}, Rx.prototype.addMetaSchema = function(e25, t2, r2) {
  return this.addSchema(e25, t2, r2, true), this;
}, Rx.prototype.validateSchema = function(e25, t2) {
  var r2 = e25.$schema;
  if (r2 !== void 0 && typeof r2 != "string")
    throw new Error("$schema must be a string");
  if (!(r2 = r2 || this._opts.defaultMeta || function(e26) {
    var t3 = e26._opts.meta;
    return e26._opts.defaultMeta = i(t3) == "object" ? e26._getId(t3) || t3 : e26.getSchema(Lx) ? Lx : void 0, e26._opts.defaultMeta;
  }(this)))
    return this.logger.warn("meta-schema not available"), this.errors = null, true;
  var n2 = this.validate(r2, e25);
  if (!n2 && t2) {
    var a2 = "schema is invalid: " + this.errorsText();
    if (this._opts.validateSchema != "log")
      throw new Error(a2);
    this.logger.error(a2);
  }
  return n2;
}, Rx.prototype.getSchema = function(e25) {
  var t2 = Mx(this, e25);
  switch (i(t2)) {
    case "object":
      return t2.validate || this._compile(t2);
    case "string":
      return this.getSchema(t2);
    case "undefined":
      return function(e26, t3) {
        var r2 = ov.schema.call(e26, { schema: {} }, t3);
        if (r2) {
          var n2 = r2.schema, i2 = r2.root, a2 = r2.baseId, o2 = Fv.call(e26, n2, i2, void 0, a2);
          return e26._fragments[t3] = new iv({ ref: t3, fragment: true, schema: n2, root: i2, baseId: a2, validate: o2 }), o2;
        }
      }(this, e25);
  }
}, Rx.prototype.removeSchema = function(e25) {
  if (e25 instanceof RegExp)
    return Vx(this, this._schemas, e25), Vx(this, this._refs, e25), this;
  switch (i(e25)) {
    case "undefined":
      return Vx(this, this._schemas), Vx(this, this._refs), this._cache.clear(), this;
    case "string":
      var t2 = Mx(this, e25);
      return t2 && this._cache.del(t2.cacheKey), delete this._schemas[e25], delete this._refs[e25], this;
    case "object":
      var r2 = this._opts.serialize, n2 = r2 ? r2(e25) : e25;
      this._cache.del(n2);
      var a2 = this._getId(e25);
      a2 && (a2 = ov.normalizeId(a2), delete this._schemas[a2], delete this._refs[a2]);
  }
  return this;
}, Rx.prototype.addFormat = function(e25, t2) {
  typeof t2 == "string" && (t2 = new RegExp(t2));
  return this._formats[e25] = t2, this;
}, Rx.prototype.errorsText = function(e25, t2) {
  if (!(e25 = e25 || this.errors))
    return "No errors";
  for (var r2 = (t2 = t2 || {}).separator === void 0 ? ", " : t2.separator, n2 = t2.dataVar === void 0 ? "data" : t2.dataVar, i2 = "", a2 = 0; a2 < e25.length; a2++) {
    var o2 = e25[a2];
    o2 && (i2 += n2 + o2.dataPath + " " + o2.message + r2);
  }
  return i2.slice(0, -r2.length);
}, Rx.prototype._addSchema = function(e25, t2, r2, n2) {
  if (i(e25) != "object" && typeof e25 != "boolean")
    throw new Error("schema should be object or boolean");
  var a2 = this._opts.serialize, o2 = a2 ? a2(e25) : e25, s2 = this._cache.get(o2);
  if (s2)
    return s2;
  n2 = n2 || this._opts.addUsedSchema !== false;
  var u2 = ov.normalizeId(this._getId(e25));
  u2 && n2 && $x(this, u2);
  var c2, l2 = this._opts.validateSchema !== false && !t2;
  l2 && !(c2 = u2 && u2 == ov.normalizeId(e25.$schema)) && this.validateSchema(e25, true);
  var p2 = ov.ids.call(this, e25), f2 = new iv({ id: u2, schema: e25, localRefs: p2, cacheKey: o2, meta: r2 });
  u2[0] != "#" && n2 && (this._refs[u2] = f2);
  this._cache.put(o2, f2), l2 && c2 && this.validateSchema(e25, true);
  return f2;
}, Rx.prototype._compile = function(e25, t2) {
  if (e25.compiling)
    return e25.validate = i2, i2.schema = e25.schema, i2.errors = null, i2.root = t2 || i2, e25.schema.$async === true && (i2.$async = true), i2;
  var r2, n2;
  e25.compiling = true, e25.meta && (r2 = this._opts, this._opts = this._metaOpts);
  try {
    n2 = Fv.call(this, e25.schema, t2, e25.localRefs);
  } catch (t3) {
    throw delete e25.validate, t3;
  } finally {
    e25.compiling = false, e25.meta && (this._opts = r2);
  }
  return e25.validate = n2, e25.refs = n2.refs, e25.refVal = n2.refVal, e25.root = n2.root, n2;
  function i2() {
    var t3 = e25.validate, r3 = t3.apply(this, arguments);
    return i2.errors = t3.errors, r3;
  }
}, Rx.prototype.compileAsync = px, Rx.prototype.addKeyword = Sx, Rx.prototype.getKeyword = kx, Rx.prototype.removeKeyword = Dx, Rx.prototype.validateKeyword = Fx, Rx.ValidationError = xv.Validation, Rx.MissingRefError = xv.MissingRef, Rx.$dataMetaSchema = cx;
var Lx = "http://json-schema.org/draft-07/schema", Nx = ["removeAdditional", "useDefaults", "coerceTypes", "strictDefaults"], jx = ["/properties"];
function Rx(e25) {
  if (!(this instanceof Rx))
    return new Rx(e25);
  e25 = this._opts = Iy.copy(e25) || {}, function(e26) {
    var t2 = e26._opts.logger;
    if (t2 === false)
      e26.logger = { log: Gx, warn: Gx, error: Gx };
    else {
      if (t2 === void 0 && (t2 = console), !(i(t2) == "object" && t2.log && t2.warn && t2.error))
        throw new Error("logger must implement log, warn and error methods");
      e26.logger = t2;
    }
  }(this), this._schemas = {}, this._refs = {}, this._fragments = {}, this._formats = Hv(e25.format), this._cache = e25.cache || new Lv(), this._loadingSchemas = {}, this._compilations = [], this.RULES = sx(), this._getId = function(e26) {
    switch (e26.schemaId) {
      case "auto":
        return Wx;
      case "id":
        return Ux;
      default:
        return qx;
    }
  }(e25), e25.loopRequired = e25.loopRequired || 1 / 0, e25.errorDataPath == "property" && (e25._errorDataPathProperty = true), e25.serialize === void 0 && (e25.serialize = Cv), this._metaOpts = function(e26) {
    for (var t2 = Iy.copy(e26._opts), r2 = 0; r2 < Nx.length; r2++)
      delete t2[Nx[r2]];
    return t2;
  }(this), e25.formats && function(e26) {
    for (var t2 in e26._opts.formats) {
      var r2 = e26._opts.formats[t2];
      e26.addFormat(t2, r2);
    }
  }(this), function(e26) {
    var t2;
    e26._opts.$data && (t2 = Bx, e26.addMetaSchema(t2, t2.$id, true));
    if (e26._opts.meta === false)
      return;
    var r2 = bx;
    e26._opts.$data && (r2 = cx(r2, jx));
    e26.addMetaSchema(r2, Lx, true), e26._refs["http://json-schema.org/schema"] = Lx;
  }(this), i(e25.meta) == "object" && this.addMetaSchema(e25.meta), e25.nullable && this.addKeyword("nullable", { metaSchema: { type: "boolean" } }), function(e26) {
    var t2 = e26._opts.schemas;
    if (!t2)
      return;
    if (Array.isArray(t2))
      e26.addSchema(t2);
    else
      for (var r2 in t2)
        e26.addSchema(t2[r2], r2);
  }(this);
}
function Mx(e25, t2) {
  return t2 = ov.normalizeId(t2), e25._schemas[t2] || e25._refs[t2] || e25._fragments[t2];
}
function Vx(e25, t2, r2) {
  for (var n2 in t2) {
    var i2 = t2[n2];
    i2.meta || r2 && !r2.test(n2) || (e25._cache.del(i2.cacheKey), delete t2[n2]);
  }
}
function Ux(e25) {
  return e25.$id && this.logger.warn("schema $id ignored", e25.$id), e25.id;
}
function qx(e25) {
  return e25.id && this.logger.warn("schema id ignored", e25.id), e25.$id;
}
function Wx(e25) {
  if (e25.$id && e25.id && e25.$id != e25.id)
    throw new Error("schema $id is different from id");
  return e25.$id || e25.id;
}
function $x(e25, t2) {
  if (e25._schemas[t2] || e25._refs[t2])
    throw new Error('schema with key or id "' + t2 + '" already exists');
}
function Gx() {
}
var zx, Hx = "http://json-schema.org/draft-04/schema#", Kx = "http://json-schema.org/draft-04/schema#", Jx = { schemaArray: { type: "array", minItems: 1, items: { $ref: "#" } }, positiveInteger: { type: "integer", minimum: 0 }, positiveIntegerDefault0: { allOf: [{ $ref: "#/definitions/positiveInteger" }, { default: 0 }] }, simpleTypes: { enum: ["array", "boolean", "integer", "null", "number", "object", "string"] }, stringArray: { type: "array", items: { type: "string" }, minItems: 1, uniqueItems: true } }, Qx = { id: { type: "string" }, $schema: { type: "string" }, title: { type: "string" }, description: { type: "string" }, default: {}, multipleOf: { type: "number", minimum: 0, exclusiveMinimum: true }, maximum: { type: "number" }, exclusiveMaximum: { type: "boolean", default: false }, minimum: { type: "number" }, exclusiveMinimum: { type: "boolean", default: false }, maxLength: { $ref: "#/definitions/positiveInteger" }, minLength: { $ref: "#/definitions/positiveIntegerDefault0" }, pattern: { type: "string", format: "regex" }, additionalItems: { anyOf: [{ type: "boolean" }, { $ref: "#" }], default: {} }, items: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }], default: {} }, maxItems: { $ref: "#/definitions/positiveInteger" }, minItems: { $ref: "#/definitions/positiveIntegerDefault0" }, uniqueItems: { type: "boolean", default: false }, maxProperties: { $ref: "#/definitions/positiveInteger" }, minProperties: { $ref: "#/definitions/positiveIntegerDefault0" }, required: { $ref: "#/definitions/stringArray" }, additionalProperties: { anyOf: [{ type: "boolean" }, { $ref: "#" }], default: {} }, definitions: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, properties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, patternProperties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, dependencies: { type: "object", additionalProperties: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }] } }, enum: { type: "array", minItems: 1, uniqueItems: true }, type: { anyOf: [{ $ref: "#/definitions/simpleTypes" }, { type: "array", items: { $ref: "#/definitions/simpleTypes" }, minItems: 1, uniqueItems: true }] }, format: { type: "string" }, allOf: { $ref: "#/definitions/schemaArray" }, anyOf: { $ref: "#/definitions/schemaArray" }, oneOf: { $ref: "#/definitions/schemaArray" }, not: { $ref: "#" } }, Xx = { exclusiveMaximum: ["maximum"], exclusiveMinimum: ["minimum"] }, Yx = { id: Hx, $schema: Kx, description: "Core schema meta-schema", definitions: Jx, type: "object", properties: Qx, dependencies: Xx, default: {} }, Zx = Object.freeze({ __proto__: null, id: Hx, $schema: Kx, description: "Core schema meta-schema", definitions: Jx, type: "object", properties: Qx, dependencies: Xx, default: Yx }), eb = [].slice, tb = {}.toString;
zx = nb(function(e25, t2) {
  return e25.apply(null, t2);
});
var rb = { curry: function(e25) {
  return nb(e25);
}, flip: nb(function(e25, t2, r2) {
  return e25(r2, t2);
}), fix: function(e25) {
  return function(t2) {
    return function() {
      return e25(t2(t2)).apply(null, arguments);
    };
  }(function(t2) {
    return function() {
      return e25(t2(t2)).apply(null, arguments);
    };
  });
}, apply: zx, over: nb(function(e25, t2, r2, n2) {
  return e25(t2(r2), t2(n2));
}), memoize: function(e25) {
  var t2;
  return t2 = {}, function() {
    var r2, n2, i2;
    return r2 = eb.call(arguments), n2 = function() {
      var e26, t3, n3, a2 = [];
      for (e26 = 0, n3 = (t3 = r2).length; e26 < n3; ++e26)
        i2 = t3[e26], a2.push(i2 + tb.call(i2).slice(8, -1));
      return a2;
    }().join(""), t2[n2] = n2 in t2 ? t2[n2] : e25.apply(null, r2);
  };
} };
function nb(e25, t2) {
  var r2;
  return function n2(i2) {
    return e25.length > 1 ? function() {
      var a2 = i2 ? i2.concat() : [];
      return r2 = t2 && r2 || this, a2.push.apply(a2, arguments) < e25.length && arguments.length ? n2.call(r2, a2) : e25.apply(r2, a2);
    } : e25;
  }();
}
var ib, ab, ob, sb, ub, cb, lb, pb, fb, hb, db, mb, gb, yb, vb, xb, bb, Eb, Cb, Sb, kb, Db, Fb, Ab, wb, _b, Tb, Pb, Ib, Bb, Ob, Lb, Nb, jb, Rb, Mb, Vb, Ub, qb, Wb, $b, Gb, zb, Hb, Kb, Jb, Qb, Xb, Yb, Zb, eE, tE, rE, nE, iE, aE, oE, sE, uE, cE, lE, pE, fE, hE, dE, mE, gE, yE, vE, xE = {}.toString, bE = [].slice;
ib = SE(function(e25, t2) {
  var r2, n2;
  for (r2 = 0, n2 = t2.length; r2 < n2; ++r2)
    e25(t2[r2]);
  return t2;
}), ab = SE(function(e25, t2) {
  var r2, n2, i2, a2 = [];
  for (r2 = 0, n2 = t2.length; r2 < n2; ++r2)
    i2 = t2[r2], a2.push(e25(i2));
  return a2;
}), ob = function(e25) {
  var t2, r2, n2, i2 = [];
  for (t2 = 0, r2 = e25.length; t2 < r2; ++t2)
    (n2 = e25[t2]) && i2.push(n2);
  return i2;
}, sb = SE(function(e25, t2) {
  var r2, n2, i2, a2 = [];
  for (r2 = 0, n2 = t2.length; r2 < n2; ++r2)
    e25(i2 = t2[r2]) && a2.push(i2);
  return a2;
}), ub = SE(function(e25, t2) {
  var r2, n2, i2, a2 = [];
  for (r2 = 0, n2 = t2.length; r2 < n2; ++r2)
    e25(i2 = t2[r2]) || a2.push(i2);
  return a2;
}), cb = SE(function(e25, t2) {
  var r2, n2, i2, a2, o2;
  for (r2 = [], n2 = [], i2 = 0, a2 = t2.length; i2 < a2; ++i2)
    (e25(o2 = t2[i2]) ? r2 : n2).push(o2);
  return [r2, n2];
}), lb = SE(function(e25, t2) {
  var r2, n2, i2;
  for (r2 = 0, n2 = t2.length; r2 < n2; ++r2)
    if (e25(i2 = t2[r2]))
      return i2;
}), pb = fb = function(e25) {
  return e25[0];
}, hb = function(e25) {
  if (e25.length)
    return e25.slice(1);
}, db = function(e25) {
  return e25[e25.length - 1];
}, mb = function(e25) {
  if (e25.length)
    return e25.slice(0, -1);
}, gb = function(e25) {
  return !e25.length;
}, yb = function(e25) {
  return e25.concat().reverse();
}, vb = function(e25) {
  var t2, r2, n2, i2;
  for (t2 = [], r2 = 0, n2 = e25.length; r2 < n2; ++r2)
    kE(i2 = e25[r2], t2) || t2.push(i2);
  return t2;
}, xb = SE(function(e25, t2) {
  var r2, n2, i2, a2, o2, s2 = [];
  for (r2 = [], n2 = 0, i2 = t2.length; n2 < i2; ++n2)
    kE(o2 = e25(a2 = t2[n2]), r2) || (r2.push(o2), s2.push(a2));
  return s2;
}), bb = Eb = SE(function(e25, t2, r2) {
  var n2, i2;
  for (n2 = 0, i2 = r2.length; n2 < i2; ++n2)
    t2 = e25(t2, r2[n2]);
  return t2;
}), Cb = Sb = SE(function(e25, t2) {
  return bb(e25, t2[0], t2.slice(1));
}), kb = SE(function(e25, t2, r2) {
  var n2;
  for (n2 = r2.length - 1; n2 >= 0; --n2)
    t2 = e25(r2[n2], t2);
  return t2;
}), Db = SE(function(e25, t2) {
  return kb(e25, t2[t2.length - 1], t2.slice(0, -1));
}), Fb = SE(function(e25, t2) {
  var r2, n2, i2;
  for (r2 = [], n2 = t2; (i2 = e25(n2)) != null; )
    r2.push(i2[0]), n2 = i2[1];
  return r2;
}), Ab = function(e25) {
  return [].concat.apply([], e25);
}, wb = SE(function(e25, t2) {
  var r2;
  return [].concat.apply([], function() {
    var n2, i2, a2, o2 = [];
    for (n2 = 0, a2 = (i2 = t2).length; n2 < a2; ++n2)
      r2 = i2[n2], o2.push(e25(r2));
    return o2;
  }());
}), _b = function(e25) {
  var t2;
  return [].concat.apply([], function() {
    var r2, n2, i2, a2 = [];
    for (r2 = 0, i2 = (n2 = e25).length; r2 < i2; ++r2)
      t2 = n2[r2], xE.call(t2).slice(8, -1) === "Array" ? a2.push(_b(t2)) : a2.push(t2);
    return a2;
  }());
}, Tb = function(e25) {
  var t2, r2, n2, i2, a2, o2, s2;
  t2 = bE.call(arguments, 1), r2 = [];
  e:
    for (n2 = 0, i2 = e25.length; n2 < i2; ++n2) {
      for (a2 = e25[n2], o2 = 0, s2 = t2.length; o2 < s2; ++o2)
        if (kE(a2, t2[o2]))
          continue e;
      r2.push(a2);
    }
  return r2;
}, Pb = function(e25) {
  var t2, r2, n2, i2, a2, o2, s2;
  t2 = bE.call(arguments, 1), r2 = [];
  e:
    for (n2 = 0, i2 = e25.length; n2 < i2; ++n2) {
      for (a2 = e25[n2], o2 = 0, s2 = t2.length; o2 < s2; ++o2)
        if (!kE(a2, t2[o2]))
          continue e;
      r2.push(a2);
    }
  return r2;
}, Ib = function() {
  var e25, t2, r2, n2, i2, a2, o2, s2;
  for (t2 = [], r2 = 0, n2 = (e25 = bE.call(arguments)).length; r2 < n2; ++r2)
    for (a2 = 0, o2 = (i2 = e25[r2]).length; a2 < o2; ++a2)
      kE(s2 = i2[a2], t2) || t2.push(s2);
  return t2;
}, Bb = SE(function(e25, t2) {
  var r2, n2, i2, a2;
  for (r2 = {}, n2 = 0, i2 = t2.length; n2 < i2; ++n2)
    (a2 = e25(t2[n2])) in r2 ? r2[a2] += 1 : r2[a2] = 1;
  return r2;
}), Ob = SE(function(e25, t2) {
  var r2, n2, i2, a2, o2;
  for (r2 = {}, n2 = 0, i2 = t2.length; n2 < i2; ++n2)
    (o2 = e25(a2 = t2[n2])) in r2 ? r2[o2].push(a2) : r2[o2] = [a2];
  return r2;
}), Lb = function(e25) {
  var t2, r2;
  for (t2 = 0, r2 = e25.length; t2 < r2; ++t2)
    if (!e25[t2])
      return false;
  return true;
}, Nb = function(e25) {
  var t2, r2;
  for (t2 = 0, r2 = e25.length; t2 < r2; ++t2)
    if (e25[t2])
      return true;
  return false;
}, jb = SE(function(e25, t2) {
  var r2, n2;
  for (r2 = 0, n2 = t2.length; r2 < n2; ++r2)
    if (e25(t2[r2]))
      return true;
  return false;
}), Rb = SE(function(e25, t2) {
  var r2, n2;
  for (r2 = 0, n2 = t2.length; r2 < n2; ++r2)
    if (!e25(t2[r2]))
      return false;
  return true;
}), Mb = function(e25) {
  return e25.concat().sort(function(e26, t2) {
    return e26 > t2 ? 1 : e26 < t2 ? -1 : 0;
  });
}, Vb = SE(function(e25, t2) {
  return t2.concat().sort(e25);
}), Ub = SE(function(e25, t2) {
  return t2.concat().sort(function(t3, r2) {
    return e25(t3) > e25(r2) ? 1 : e25(t3) < e25(r2) ? -1 : 0;
  });
}), qb = function(e25) {
  var t2, r2, n2;
  for (t2 = 0, r2 = 0, n2 = e25.length; r2 < n2; ++r2)
    t2 += e25[r2];
  return t2;
}, Wb = function(e25) {
  var t2, r2, n2;
  for (t2 = 1, r2 = 0, n2 = e25.length; r2 < n2; ++r2)
    t2 *= e25[r2];
  return t2;
}, $b = Gb = function(e25) {
  var t2, r2, n2;
  for (t2 = 0, r2 = 0, n2 = e25.length; r2 < n2; ++r2)
    t2 += e25[r2];
  return t2 / e25.length;
}, zb = function(e25) {
  var t2, r2, n2, i2, a2;
  for (t2 = e25[0], r2 = 0, i2 = (n2 = e25.slice(1)).length; r2 < i2; ++r2)
    (a2 = n2[r2]) > t2 && (t2 = a2);
  return t2;
}, Hb = function(e25) {
  var t2, r2, n2, i2, a2;
  for (t2 = e25[0], r2 = 0, i2 = (n2 = e25.slice(1)).length; r2 < i2; ++r2)
    (a2 = n2[r2]) < t2 && (t2 = a2);
  return t2;
}, Kb = SE(function(e25, t2) {
  var r2, n2, i2, a2, o2;
  for (r2 = t2[0], n2 = 0, a2 = (i2 = t2.slice(1)).length; n2 < a2; ++n2)
    e25(o2 = i2[n2]) > e25(r2) && (r2 = o2);
  return r2;
}), Jb = SE(function(e25, t2) {
  var r2, n2, i2, a2, o2;
  for (r2 = t2[0], n2 = 0, a2 = (i2 = t2.slice(1)).length; n2 < a2; ++n2)
    e25(o2 = i2[n2]) < e25(r2) && (r2 = o2);
  return r2;
}), Qb = Xb = SE(function(e25, t2, r2) {
  var n2, i2;
  return n2 = t2, [t2].concat(function() {
    var t3, a2, o2, s2 = [];
    for (t3 = 0, o2 = (a2 = r2).length; t3 < o2; ++t3)
      i2 = a2[t3], s2.push(n2 = e25(n2, i2));
    return s2;
  }());
}), Yb = Zb = SE(function(e25, t2) {
  if (t2.length)
    return Qb(e25, t2[0], t2.slice(1));
}), eE = SE(function(e25, t2, r2) {
  return r2 = r2.concat().reverse(), Qb(e25, t2, r2).reverse();
}), tE = SE(function(e25, t2) {
  if (t2.length)
    return t2 = t2.concat().reverse(), Qb(e25, t2[0], t2.slice(1)).reverse();
}), rE = SE(function(e25, t2, r2) {
  return r2.slice(e25, t2);
}), nE = SE(function(e25, t2) {
  return e25 <= 0 ? t2.slice(0, 0) : t2.slice(0, e25);
}), iE = SE(function(e25, t2) {
  return e25 <= 0 ? t2 : t2.slice(e25);
}), aE = SE(function(e25, t2) {
  return [nE(e25, t2), iE(e25, t2)];
}), oE = SE(function(e25, t2) {
  var r2, n2;
  if (!(r2 = t2.length))
    return t2;
  for (n2 = 0; n2 < r2 && e25(t2[n2]); )
    n2 += 1;
  return t2.slice(0, n2);
}), sE = SE(function(e25, t2) {
  var r2, n2;
  if (!(r2 = t2.length))
    return t2;
  for (n2 = 0; n2 < r2 && e25(t2[n2]); )
    n2 += 1;
  return t2.slice(n2);
}), uE = SE(function(e25, t2) {
  return [oE(e25, t2), sE(e25, t2)];
}), cE = SE(function(e25, t2) {
  return uE(function() {
    var e26 = arguments;
    return function() {
      var t3, r2;
      for (r2 = e26[0].apply(this, arguments), t3 = 1; t3 < e26.length; ++t3)
        r2 = e26[t3](r2);
      return r2;
    };
  }(e25, DE), t2);
}), lE = SE(function(e25, t2) {
  var r2, n2, i2, a2, o2, s2;
  for (r2 = [], n2 = t2.length, i2 = 0, a2 = e25.length; i2 < a2 && (o2 = i2, s2 = e25[i2], o2 !== n2); ++i2)
    r2.push([s2, t2[o2]]);
  return r2;
}), pE = SE(function(e25, t2, r2) {
  var n2, i2, a2, o2, s2, u2;
  for (n2 = [], i2 = r2.length, a2 = 0, o2 = t2.length; a2 < o2 && (s2 = a2, u2 = t2[a2], s2 !== i2); ++a2)
    n2.push(e25(u2, r2[s2]));
  return n2;
}), fE = function() {
  var e25, t2, r2, n2, i2, a2, o2, s2, u2, c2 = [];
  for (t2 = void 0, r2 = 0, n2 = (e25 = bE.call(arguments)).length; r2 < n2; ++r2)
    t2 <= (a2 = (i2 = e25[r2]).length) || (t2 = a2);
  for (r2 = 0; r2 < t2; ++r2) {
    for (o2 = r2, s2 = [], u2 = 0, n2 = e25.length; u2 < n2; ++u2)
      i2 = e25[u2], s2.push(i2[o2]);
    c2.push(s2);
  }
  return c2;
}, hE = function(e25) {
  var t2, r2, n2, i2, a2, o2, s2, u2 = [];
  for (r2 = void 0, n2 = 0, i2 = (t2 = bE.call(arguments, 1)).length; n2 < i2; ++n2)
    r2 <= (o2 = (a2 = t2[n2]).length) || (r2 = o2);
  for (n2 = 0; n2 < r2; ++n2)
    s2 = n2, u2.push(e25.apply(null, c2()));
  return u2;
  function c2() {
    var e26, r3, n3, i3 = [];
    for (e26 = 0, n3 = (r3 = t2).length; e26 < n3; ++e26)
      a2 = r3[e26], i3.push(a2[s2]);
    return i3;
  }
}, dE = SE(function(e25, t2) {
  return e25 < 0 ? t2[t2.length + e25] : t2[e25];
}), mE = SE(function(e25, t2) {
  var r2, n2, i2;
  for (r2 = 0, n2 = t2.length; r2 < n2; ++r2)
    if (i2 = r2, t2[r2] === e25)
      return i2;
}), gE = SE(function(e25, t2) {
  var r2, n2, i2, a2 = [];
  for (r2 = 0, n2 = t2.length; r2 < n2; ++r2)
    i2 = r2, t2[r2] === e25 && a2.push(i2);
  return a2;
}), yE = SE(function(e25, t2) {
  var r2, n2, i2;
  for (r2 = 0, n2 = t2.length; r2 < n2; ++r2)
    if (i2 = r2, e25(t2[r2]))
      return i2;
}), vE = SE(function(e25, t2) {
  var r2, n2, i2, a2 = [];
  for (r2 = 0, n2 = t2.length; r2 < n2; ++r2)
    i2 = r2, e25(t2[r2]) && a2.push(i2);
  return a2;
});
var EE, CE = { each: ib, map: ab, filter: sb, compact: ob, reject: ub, partition: cb, find: lb, head: pb, first: fb, tail: hb, last: db, initial: mb, empty: gb, reverse: yb, difference: Tb, intersection: Pb, union: Ib, countBy: Bb, groupBy: Ob, fold: bb, fold1: Cb, foldl: Eb, foldl1: Sb, foldr: kb, foldr1: Db, unfoldr: Fb, andList: Lb, orList: Nb, any: jb, all: Rb, unique: vb, uniqueBy: xb, sort: Mb, sortWith: Vb, sortBy: Ub, sum: qb, product: Wb, mean: $b, average: Gb, concat: Ab, concatMap: wb, flatten: _b, maximum: zb, minimum: Hb, maximumBy: Kb, minimumBy: Jb, scan: Qb, scan1: Yb, scanl: Xb, scanl1: Zb, scanr: eE, scanr1: tE, slice: rE, take: nE, drop: iE, splitAt: aE, takeWhile: oE, dropWhile: sE, span: uE, breakList: cE, zip: lE, zipWith: pE, zipAll: fE, zipAllWith: hE, at: dE, elemIndex: mE, elemIndices: gE, findIndex: yE, findIndices: vE };
function SE(e25, t2) {
  var r2;
  return function n2(i2) {
    return e25.length > 1 ? function() {
      var a2 = i2 ? i2.concat() : [];
      return r2 = t2 && r2 || this, a2.push.apply(a2, arguments) < e25.length && arguments.length ? n2.call(r2, a2) : e25.apply(r2, a2);
    } : e25;
  }();
}
function kE(e25, t2) {
  for (var r2 = -1, n2 = t2.length >>> 0; ++r2 < n2; )
    if (e25 === t2[r2])
      return true;
  return false;
}
function DE(e25) {
  return !e25;
}
EE = function(e25) {
  var t2, r2, n2 = {};
  for (t2 in e25)
    (r2 = e25[t2]) && (n2[t2] = r2);
  return n2;
};
var FE = { values: function(e25) {
  var t2, r2, n2 = [];
  for (t2 in e25)
    r2 = e25[t2], n2.push(r2);
  return n2;
}, keys: function(e25) {
  var t2, r2 = [];
  for (t2 in e25)
    r2.push(t2);
  return r2;
}, pairsToObj: function(e25) {
  var t2, r2, n2, i2 = {};
  for (t2 = 0, r2 = e25.length; t2 < r2; ++t2)
    i2[(n2 = e25[t2])[0]] = n2[1];
  return i2;
}, objToPairs: function(e25) {
  var t2, r2, n2 = [];
  for (t2 in e25)
    r2 = e25[t2], n2.push([t2, r2]);
  return n2;
}, listsToObj: AE(function(e25, t2) {
  var r2, n2, i2, a2 = {};
  for (r2 = 0, n2 = e25.length; r2 < n2; ++r2)
    i2 = r2, a2[e25[r2]] = t2[i2];
  return a2;
}), objToLists: function(e25) {
  var t2, r2, n2, i2;
  for (n2 in t2 = [], r2 = [], e25)
    i2 = e25[n2], t2.push(n2), r2.push(i2);
  return [t2, r2];
}, empty: function(e25) {
  var t2;
  for (t2 in e25)
    return false;
  return true;
}, each: AE(function(e25, t2) {
  var r2;
  for (r2 in t2)
    e25(t2[r2]);
  return t2;
}), map: AE(function(e25, t2) {
  var r2, n2, i2 = {};
  for (r2 in t2)
    n2 = t2[r2], i2[r2] = e25(n2);
  return i2;
}), filter: AE(function(e25, t2) {
  var r2, n2, i2 = {};
  for (r2 in t2)
    e25(n2 = t2[r2]) && (i2[r2] = n2);
  return i2;
}), compact: EE, reject: AE(function(e25, t2) {
  var r2, n2, i2 = {};
  for (r2 in t2)
    e25(n2 = t2[r2]) || (i2[r2] = n2);
  return i2;
}), partition: AE(function(e25, t2) {
  var r2, n2, i2, a2;
  for (i2 in r2 = {}, n2 = {}, t2)
    (e25(a2 = t2[i2]) ? r2 : n2)[i2] = a2;
  return [r2, n2];
}), find: AE(function(e25, t2) {
  var r2, n2;
  for (r2 in t2)
    if (e25(n2 = t2[r2]))
      return n2;
}) };
function AE(e25, t2) {
  var r2;
  return function n2(i2) {
    return e25.length > 1 ? function() {
      var a2 = i2 ? i2.concat() : [];
      return r2 = t2 && r2 || this, a2.push.apply(a2, arguments) < e25.length && arguments.length ? n2.call(r2, a2) : e25.apply(r2, a2);
    } : e25;
  }();
}
var wE, _E, TE, PE, IE, BE, OE, LE, NE, jE, RE, ME, VE, UE, qE, WE, $E, GE, zE, HE, KE, JE, QE, XE, YE, ZE, eC, tC, rC, nC, iC, aC, oC = { split: sC(function(e25, t2) {
  return t2.split(e25);
}), join: sC(function(e25, t2) {
  return t2.join(e25);
}), lines: function(e25) {
  return e25.length ? e25.split("\n") : [];
}, unlines: function(e25) {
  return e25.join("\n");
}, words: function(e25) {
  return e25.length ? e25.split(/[ ]+/) : [];
}, unwords: function(e25) {
  return e25.join(" ");
}, chars: function(e25) {
  return e25.split("");
}, unchars: function(e25) {
  return e25.join("");
}, reverse: function(e25) {
  return e25.split("").reverse().join("");
}, repeat: sC(function(e25, t2) {
  var r2, n2;
  for (r2 = "", n2 = 0; n2 < e25; ++n2)
    r2 += t2;
  return r2;
}), capitalize: function(e25) {
  return e25.charAt(0).toUpperCase() + e25.slice(1);
}, camelize: function(e25) {
  return e25.replace(/[-_]+(.)?/g, function(e26, t2) {
    return (t2 != null ? t2 : "").toUpperCase();
  });
}, dasherize: function(e25) {
  return e25.replace(/([^-A-Z])([A-Z]+)/g, function(e26, t2, r2) {
    return t2 + "-" + (r2.length > 1 ? r2 : r2.toLowerCase());
  }).replace(/^([A-Z]+)/, function(e26, t2) {
    return t2.length > 1 ? t2 + "-" : t2.toLowerCase();
  });
} };
function sC(e25, t2) {
  var r2;
  return function n2(i2) {
    return e25.length > 1 ? function() {
      var a2 = i2 ? i2.concat() : [];
      return r2 = t2 && r2 || this, a2.push.apply(a2, arguments) < e25.length && arguments.length ? n2.call(r2, a2) : e25.apply(r2, a2);
    } : e25;
  }();
}
function uC(e25, t2) {
  var r2;
  return function n2(i2) {
    return e25.length > 1 ? function() {
      var a2 = i2 ? i2.concat() : [];
      return r2 = t2 && r2 || this, a2.push.apply(a2, arguments) < e25.length && arguments.length ? n2.call(r2, a2) : e25.apply(r2, a2);
    } : e25;
  }();
}
wE = uC(function(e25, t2) {
  return e25 > t2 ? e25 : t2;
}), _E = uC(function(e25, t2) {
  return e25 < t2 ? e25 : t2;
}), TE = function(e25) {
  return -e25;
}, PE = Math.abs, IE = function(e25) {
  return e25 < 0 ? -1 : e25 > 0 ? 1 : 0;
}, BE = uC(function(e25, t2) {
  return ~~(e25 / t2);
}), OE = uC(function(e25, t2) {
  return e25 % t2;
}), LE = uC(function(e25, t2) {
  return Math.floor(e25 / t2);
}), NE = uC(function(e25, t2) {
  var r2;
  return (e25 % (r2 = t2) + r2) % r2;
}), jE = function(e25) {
  return 1 / e25;
}, ME = 2 * (RE = Math.PI), VE = Math.exp, UE = Math.sqrt, qE = Math.log, WE = uC(function(e25, t2) {
  return Math.pow(e25, t2);
}), $E = Math.sin, GE = Math.tan, zE = Math.cos, HE = Math.asin, KE = Math.acos, JE = Math.atan, QE = uC(function(e25, t2) {
  return Math.atan2(e25, t2);
}), XE = function(e25) {
  return ~~e25;
}, YE = Math.round, ZE = Math.ceil, eC = Math.floor, tC = function(e25) {
  return e25 != e25;
}, rC = function(e25) {
  return e25 % 2 == 0;
}, nC = function(e25) {
  return e25 % 2 != 0;
}, iC = uC(function(e25, t2) {
  var r2;
  for (e25 = Math.abs(e25), t2 = Math.abs(t2); t2 !== 0; )
    r2 = e25 % t2, e25 = t2, t2 = r2;
  return e25;
}), aC = uC(function(e25, t2) {
  return Math.abs(Math.floor(e25 / iC(e25, t2) * t2));
});
var cC, lC, pC, fC, hC, dC, mC, gC, yC, vC = {}.toString;
cC = rb, lC = CE, pC = FE, fC = oC, hC = { max: wE, min: _E, negate: TE, abs: PE, signum: IE, quot: BE, rem: OE, div: LE, mod: NE, recip: jE, pi: RE, tau: ME, exp: VE, sqrt: UE, ln: qE, pow: WE, sin: $E, tan: GE, cos: zE, acos: KE, asin: HE, atan: JE, atan2: QE, truncate: XE, round: YE, ceiling: ZE, floor: eC, isItNaN: tC, even: rC, odd: nC, gcd: iC, lcm: aC }, dC = function(e25) {
  return e25;
}, mC = bC(function(e25, t2) {
  return vC.call(t2).slice(8, -1) === e25;
}), gC = bC(function(e25, t2) {
  var r2, n2 = [];
  for (r2 = 0; r2 < e25; ++r2)
    n2.push(t2);
  return n2;
}), fC.empty = lC.empty, fC.slice = lC.slice, fC.take = lC.take, fC.drop = lC.drop, fC.splitAt = lC.splitAt, fC.takeWhile = lC.takeWhile, fC.dropWhile = lC.dropWhile, fC.span = lC.span, fC.breakStr = lC.breakList, (yC = { Func: cC, List: lC, Obj: pC, Str: fC, Num: hC, id: dC, isType: mC, replicate: gC }).each = lC.each, yC.map = lC.map, yC.filter = lC.filter, yC.compact = lC.compact, yC.reject = lC.reject, yC.partition = lC.partition, yC.find = lC.find, yC.head = lC.head, yC.first = lC.first, yC.tail = lC.tail, yC.last = lC.last, yC.initial = lC.initial, yC.empty = lC.empty, yC.reverse = lC.reverse, yC.difference = lC.difference, yC.intersection = lC.intersection, yC.union = lC.union, yC.countBy = lC.countBy, yC.groupBy = lC.groupBy, yC.fold = lC.fold, yC.foldl = lC.foldl, yC.fold1 = lC.fold1, yC.foldl1 = lC.foldl1, yC.foldr = lC.foldr, yC.foldr1 = lC.foldr1, yC.unfoldr = lC.unfoldr, yC.andList = lC.andList, yC.orList = lC.orList, yC.any = lC.any, yC.all = lC.all, yC.unique = lC.unique, yC.uniqueBy = lC.uniqueBy, yC.sort = lC.sort, yC.sortWith = lC.sortWith, yC.sortBy = lC.sortBy, yC.sum = lC.sum, yC.product = lC.product, yC.mean = lC.mean, yC.average = lC.average, yC.concat = lC.concat, yC.concatMap = lC.concatMap, yC.flatten = lC.flatten, yC.maximum = lC.maximum, yC.minimum = lC.minimum, yC.maximumBy = lC.maximumBy, yC.minimumBy = lC.minimumBy, yC.scan = lC.scan, yC.scanl = lC.scanl, yC.scan1 = lC.scan1, yC.scanl1 = lC.scanl1, yC.scanr = lC.scanr, yC.scanr1 = lC.scanr1, yC.slice = lC.slice, yC.take = lC.take, yC.drop = lC.drop, yC.splitAt = lC.splitAt, yC.takeWhile = lC.takeWhile, yC.dropWhile = lC.dropWhile, yC.span = lC.span, yC.breakList = lC.breakList, yC.zip = lC.zip, yC.zipWith = lC.zipWith, yC.zipAll = lC.zipAll, yC.zipAllWith = lC.zipAllWith, yC.at = lC.at, yC.elemIndex = lC.elemIndex, yC.elemIndices = lC.elemIndices, yC.findIndex = lC.findIndex, yC.findIndices = lC.findIndices, yC.apply = cC.apply, yC.curry = cC.curry, yC.flip = cC.flip, yC.fix = cC.fix, yC.over = cC.over, yC.split = fC.split, yC.join = fC.join, yC.lines = fC.lines, yC.unlines = fC.unlines, yC.words = fC.words, yC.unwords = fC.unwords, yC.chars = fC.chars, yC.unchars = fC.unchars, yC.repeat = fC.repeat, yC.capitalize = fC.capitalize, yC.camelize = fC.camelize, yC.dasherize = fC.dasherize, yC.values = pC.values, yC.keys = pC.keys, yC.pairsToObj = pC.pairsToObj, yC.objToPairs = pC.objToPairs, yC.listsToObj = pC.listsToObj, yC.objToLists = pC.objToLists, yC.max = hC.max, yC.min = hC.min, yC.negate = hC.negate, yC.abs = hC.abs, yC.signum = hC.signum, yC.quot = hC.quot, yC.rem = hC.rem, yC.div = hC.div, yC.mod = hC.mod, yC.recip = hC.recip, yC.pi = hC.pi, yC.tau = hC.tau, yC.exp = hC.exp, yC.sqrt = hC.sqrt, yC.ln = hC.ln, yC.pow = hC.pow, yC.sin = hC.sin, yC.tan = hC.tan, yC.cos = hC.cos, yC.acos = hC.acos, yC.asin = hC.asin, yC.atan = hC.atan, yC.atan2 = hC.atan2, yC.truncate = hC.truncate, yC.round = hC.round, yC.ceiling = hC.ceiling, yC.floor = hC.floor, yC.isItNaN = hC.isItNaN, yC.even = hC.even, yC.odd = hC.odd, yC.gcd = hC.gcd, yC.lcm = hC.lcm, yC.VERSION = "1.1.2";
var xC = yC;
function bC(e25, t2) {
  var r2;
  return function n2(i2) {
    return e25.length > 1 ? function() {
      var a2 = i2 ? i2.concat() : [];
      return r2 = t2 && r2 || this, a2.push.apply(a2, arguments) < e25.length && arguments.length ? n2.call(r2, a2) : e25.apply(r2, a2);
    } : e25;
  }();
}
var EC = r(function(t2) {
  (function() {
    var e25, r2, n2;
    function i2(e26, t3) {
      if (e26[0] === t3)
        return e26.shift();
      throw new Error("Expected '" + t3 + "', but got '" + e26[0] + "' instead in " + JSON.stringify(e26) + ".");
    }
    function a2(e26, t3) {
      if (e26[0] === t3)
        return e26.shift();
    }
    function o2(e26, t3, r3) {
      var n3, o3, s3, u3;
      for (n3 = t3[0], o3 = t3[1], r3 && i2(e26, n3), s3 = [], u3 = "," + (r3 ? o3 : ""); e26.length && r3 && e26[0] !== o3; )
        s3.push(p2(e26, u3)), a2(e26, ",");
      return r3 && i2(e26, o3), s3;
    }
    function s2(e26, t3) {
      return o2(e26, ["[", "]"], t3);
    }
    function u2(e26, t3) {
      return o2(e26, ["(", ")"], t3);
    }
    function c2(e26, t3) {
      var r3, n3, o3;
      for (t3 && i2(e26, "{"), r3 = {}, n3 = "," + (t3 ? "}" : ""); e26.length && (!t3 || e26[0] !== "}"); )
        o3 = l2(e26, ":"), i2(e26, ":"), r3[o3] = p2(e26, n3), a2(e26, ",");
      return t3 && i2(e26, "}"), r3;
    }
    function l2(e26, t3) {
      var r3;
      for (t3 == null && (t3 = ""), r3 = ""; e26.length && t3.indexOf(e26[0]) === -1; )
        r3 += e26.shift();
      return r3;
    }
    function p2(e26, t3) {
      switch (e26[0]) {
        case "[":
          return s2(e26, true);
        case "(":
          return u2(e26, true);
        case "{":
          return c2(e26, true);
        default:
          return l2(e26, t3);
      }
    }
    function f2(e26) {
      return !e26;
    }
    e25 = xC.reject, r2 = /\[\]\(\)}{:,/.source, n2 = RegExp(`("(?:\\\\"|[^"])*")|('(?:\\\\'|[^'])*')|(/(?:\\\\/|[^/])*/[a-zA-Z]*)|(#.*#)|([` + r2 + "])|([^\\s" + r2 + "](?:\\s*[^\\s" + r2 + "]+)*)|\\s*"), t2.exports = function(t3, r3, i3) {
      var a3;
      if (i3 == null && (i3 = {}), !i3.explicit && t3.length === 1 && t3[0].type === "String")
        return "'" + r3.replace(/\\'/g, "\\\\'") + "'";
      if (!(a3 = function(e26, t4, r4) {
        var n3, i4, a4, o3, l3, f3, h2, d2;
        return i4 = (n3 = t4[0]).type, a4 = n3.structure, o3 = e26.concat(), r4.explicit || t4.length !== 1 || (i4 || !a4) && i4 !== "Array" && i4 !== "Object" ? f3 = p2(e26) : (l3 = a4 === "array" || i4 === "Array" ? s2(e26, e26[0] === "[") : a4 === "tuple" ? u2(e26, e26[0] === "(") : c2(e26, e26[0] === "{"), f3 = e26.length ? p2(a4 === "array" || i4 === "Array" ? ((h2 = o3).unshift("["), h2.push("]"), h2) : ((d2 = o3).unshift("("), d2.push(")"), d2)) : l3), f3;
      }(e25(f2, r3.split(n2)), t3, i3)))
        throw new Error("Error parsing '" + r3 + "'.");
      return a3;
    };
  }).call(e);
}), CC = r(function(t2) {
  (function() {
    var e25, r2;
    function n2(e26) {
      var t3;
      if ((t3 = e26[0]) == null)
        throw new Error("Unexpected end of input.");
      return t3;
    }
    function i2(t3) {
      var r3;
      if (r3 = n2(t3), !e25.test(r3))
        throw new Error("Expected text, got '" + r3 + "' instead.");
      return t3.shift();
    }
    function a2(e26, t3) {
      var r3;
      if ((r3 = n2(e26)) !== t3)
        throw new Error("Expected '" + t3 + "', got '" + r3 + "' instead.");
      return e26.shift();
    }
    function o2(e26, t3) {
      return e26[0] === t3 ? e26.shift() : null;
    }
    function s2(e26) {
      var t3;
      return t3 = i2(e26), a2(e26, ":"), [t3, l2(e26)];
    }
    function u2(e26) {
      switch (e26[0]) {
        case "[":
          return function(e27) {
            var t3;
            if (a2(e27, "["), n2(e27) === "]")
              throw new Error("Must specify type of Array - eg. [Type], got [] instead.");
            return t3 = l2(e27), a2(e27, "]"), { structure: "array", of: t3 };
          }(e26);
        case "(":
          return function(e27) {
            var t3;
            if (t3 = [], a2(e27, "("), n2(e27) === ")")
              throw new Error("Tuple must be of at least length 1 - eg. (Type), got () instead.");
            for (; t3.push(l2(e27)), o2(e27, ","), n2(e27) !== ")"; )
              ;
            return a2(e27, ")"), { structure: "tuple", of: t3 };
          }(e26);
        case "{":
          return function(e27) {
            var t3, r3, i3, u3, c3;
            for (t3 = {}, a2(e27, "{"), r3 = false; ; ) {
              if (o2(e27, "...")) {
                r3 = true;
                break;
              }
              if (u3 = (i3 = s2(e27))[0], c3 = i3[1], t3[u3] = c3, o2(e27, ","), n2(e27) === "}")
                break;
            }
            return a2(e27, "}"), { structure: "fields", of: t3, subset: r3 };
          }(e26);
      }
    }
    function c2(t3) {
      var r3, o3, s3, c3;
      if ((o3 = (r3 = n2(t3)) === "*") || e25.test(r3))
        return s3 = o3 ? a2(t3, "*") : i2(t3), (c3 = u2(t3)) ? (c3.type = s3, c3) : { type: s3 };
      if (!(c3 = u2(t3)))
        throw new Error("Unexpected character: " + r3);
      return c3;
    }
    function l2(e26) {
      var t3, r3, i3, a3, s3;
      if (n2(e26) === "::")
        throw new Error("No comment before comment separator '::' found.");
      for ((t3 = e26[1]) != null && t3 === "::" && (e26.shift(), e26.shift()), r3 = [], i3 = {}, n2(e26) === "Maybe" && (e26.shift(), r3 = [{ type: "Undefined" }, { type: "Null" }], i3 = { Undefined: true, Null: true }); i3[s3 = (a3 = c2(e26)).type] || r3.push(a3), i3[s3] = true, o2(e26, "|"); )
        ;
      return r3;
    }
    e25 = /[\$\w]+/, r2 = RegExp("\\.\\.\\.|::|->|" + e25.source + "|\\S", "g"), t2.exports = function(e26) {
      var t3;
      if (!e26.length)
        throw new Error("No type specified.");
      if (function(e27, t4) {
        var r3 = -1, n3 = t4.length >>> 0;
        for (; ++r3 < n3; )
          if (e27 === t4[r3])
            return true;
        return false;
      }("->", t3 = e26.match(r2) || []))
        throw new Error("Function types are not supported. To validate that something is a function, you may use 'Function'.");
      try {
        return l2(t3);
      } catch (r3) {
        throw new Error(r3.message + " - Remaining tokens: " + JSON.stringify(t3) + " - Initial input: '" + e26 + "'");
      }
    };
  }).call(e);
}), SC = r(function(t2) {
  (function() {
    var e25, r2, n2, i2, a2, o2, s2, u2 = {}.toString;
    function c2(e26, t3) {
      if (!(e26 instanceof Object))
        return false;
      switch (t3.structure) {
        case "fields":
          return function(e27, t4) {
            var r3, n3, i3, a3, o3, s3, u3;
            for (i3 in r3 = {}, n3 = 0, e27)
              r3[i3] = true, n3++;
            for (o3 in a3 = 0, s3 = t4.of) {
              if (u3 = s3[o3], !p2(e27[o3], u3))
                return false;
              r3[o3] && a3++;
            }
            return t4.subset || n3 === a3;
          }(e26, t3);
        case "array":
          return function(e27, t4) {
            return n2(function(e28) {
              return p2(e28, t4.of);
            }, e27);
          }(e26, t3);
        case "tuple":
          return function(e27, t4) {
            var r3, n3, i3, a3, o3;
            for (r3 = 0, n3 = 0, a3 = (i3 = t4.of).length; n3 < a3; ++n3) {
              if (o3 = i3[n3], !p2(e27[r3], o3))
                return false;
              r3++;
            }
            return e27.length <= r3;
          }(e26, t3);
      }
    }
    function l2(e26, t3) {
      var r3, n3, i3, l3;
      if (r3 = t3.type, n3 = t3.structure, r3)
        return r3 === "*" || ((i3 = s2[r3] || a2[r3]) ? i3.typeOf === u2.call(e26).slice(8, -1) && i3.validate(e26) : r3 === u2.call(e26).slice(8, -1) && (!n3 || c2(e26, t3)));
      if (n3)
        return (!(l3 = o2[n3]) || l3 === u2.call(e26).slice(8, -1)) && c2(e26, t3);
      throw new Error("No type defined. Input: " + e26 + ".");
    }
    function p2(e26, t3) {
      if (u2.call(t3).slice(8, -1) !== "Array")
        throw new Error("Types must be in an array. Input: " + e26 + ".");
      return r2(function(t4) {
        return l2(e26, t4);
      }, t3);
    }
    r2 = (e25 = xC).any, n2 = e25.all, i2 = e25.isItNaN, a2 = { Number: { typeOf: "Number", validate: function(e26) {
      return !i2(e26);
    } }, NaN: { typeOf: "Number", validate: i2 }, Int: { typeOf: "Number", validate: function(e26) {
      return !i2(e26) && e26 % 1 == 0;
    } }, Float: { typeOf: "Number", validate: function(e26) {
      return !i2(e26);
    } }, Date: { typeOf: "Date", validate: function(e26) {
      return !i2(e26.getTime());
    } } }, o2 = { array: "Array", tuple: "Array" }, t2.exports = function(e26, t3, r3) {
      return r3 == null && (r3 = {}), s2 = r3.customTypes || {}, p2(t3, e26);
    };
  }).call(e);
}), kC = r(function(t2) {
  (function() {
    var e25, r2, n2;
    e25 = CC, r2 = SC, n2 = function(t3, n3, i2) {
      return r2(e25(t3), n3, i2);
    }, t2.exports = { VERSION: "0.3.2", typeCheck: n2, parsedTypeCheck: r2, parseType: e25 };
  }).call(e);
}), DC = (kC.VERSION, kC.typeCheck, kC.parsedTypeCheck, kC.parseType, r(function(t2) {
  (function() {
    var e25, r2, n2 = {}.toString;
    function i2(e26, t3, r3) {
      var i3, a3;
      return n2.call(e26).slice(8, -1) !== "Array" ? { type: "Nothing" } : (i3 = t3.of, { type: "Just", value: function() {
        var t4, n3, o3, u2 = [];
        for (t4 = 0, o3 = (n3 = e26).length; t4 < o3; ++t4)
          a3 = n3[t4], u2.push(s2(a3, i3, r3));
        return u2;
      }() });
    }
    function a2(e26, t3, r3) {
      var i3, a3, o3;
      return n2.call(e26).slice(8, -1) !== "Object" ? { type: "Nothing" } : (i3 = t3.of, { type: "Just", value: function() {
        var t4, n3 = {};
        for (a3 in t4 = e26)
          o3 = t4[a3], n3[s2(a3, [{ type: "String" }], r3)] = s2(o3, i3[a3] || [{ type: "*" }], r3);
        return n3;
      }() });
    }
    function o2(e26, t3, o3) {
      var u2, c2, l2, p2;
      if (u2 = t3.type, c2 = t3.structure, u2) {
        if (!(l2 = ((p2 = o3.customTypes[u2]) != null ? p2.cast : void 0) || r2[u2]))
          throw new Error("Type not defined: " + u2 + ".");
        return l2(e26, o3, s2);
      }
      switch (c2) {
        case "array":
          return i2(e26, t3, o3);
        case "tuple":
          return function(e27, t4, r3) {
            var i3, a3, o4, u3, c3, l3, p3;
            if (n2.call(e27).slice(8, -1) !== "Array")
              return { type: "Nothing" };
            for (i3 = [], a3 = 0, o4 = 0, c3 = (u3 = t4.of).length; o4 < c3; ++o4)
              l3 = u3[o4], p3 = s2(e27[a3], l3, r3), n2.call(p3).slice(8, -1) !== "Undefined" && i3.push(p3), a3++;
            return e27.length <= a3 ? { type: "Just", value: i3 } : { type: "Nothing" };
          }(e26, t3, o3);
        case "fields":
          return a2(e26, t3, o3);
      }
    }
    function s2(t3, r3, n3) {
      var i3, a3, s3, u2, c2, l2;
      for (i3 = 0, a3 = r3.length; i3 < a3; ++i3)
        if (c2 = (u2 = o2(t3, s3 = r3[i3], n3)).type, l2 = u2.value, c2 !== "Nothing" && e25([s3], l2, { customTypes: n3.customTypes }))
          return l2;
      throw new Error("Value " + JSON.stringify(t3) + " does not type check against " + JSON.stringify(r3) + ".");
    }
    e25 = kC.parsedTypeCheck, r2 = { "*": function(e26, t3) {
      switch (n2.call(e26).slice(8, -1)) {
        case "Array":
          return o2(e26, { type: "Array" }, t3);
        case "Object":
          return o2(e26, { type: "Object" }, t3);
        default:
          return { type: "Just", value: s2(e26, [{ type: "Undefined" }, { type: "Null" }, { type: "NaN" }, { type: "Boolean" }, { type: "Number" }, { type: "Date" }, { type: "RegExp" }, { type: "Array" }, { type: "Object" }, { type: "String" }], (t3.explicit = true, t3)) };
      }
    }, Undefined: function(e26) {
      return e26 === "undefined" || e26 === void 0 ? { type: "Just", value: void 0 } : { type: "Nothing" };
    }, Null: function(e26) {
      return e26 === "null" ? { type: "Just", value: null } : { type: "Nothing" };
    }, NaN: function(e26) {
      function t3(t4) {
        return e26.apply(this, arguments);
      }
      return t3.toString = function() {
        return e26.toString();
      }, t3;
    }(function(e26) {
      return e26 === "NaN" ? { type: "Just", value: NaN } : { type: "Nothing" };
    }), Boolean: function(e26) {
      return e26 === "true" ? { type: "Just", value: true } : e26 === "false" ? { type: "Just", value: false } : { type: "Nothing" };
    }, Number: function(e26) {
      return { type: "Just", value: +e26 };
    }, Int: function(e26) {
      return { type: "Just", value: +e26 };
    }, Float: function(e26) {
      return { type: "Just", value: +e26 };
    }, Date: function(e26) {
      function t3(t4, r3) {
        return e26.apply(this, arguments);
      }
      return t3.toString = function() {
        return e26.toString();
      }, t3;
    }(function(e26, t3) {
      var r3;
      return (r3 = /^\#([\s\S]*)\#$/.exec(e26)) ? { type: "Just", value: new Date(+r3[1] || r3[1]) } : t3.explicit ? { type: "Nothing" } : { type: "Just", value: new Date(+e26 || e26) };
    }), RegExp: function(e26) {
      function t3(t4, r3) {
        return e26.apply(this, arguments);
      }
      return t3.toString = function() {
        return e26.toString();
      }, t3;
    }(function(e26, t3) {
      var r3;
      return (r3 = /^\/([\s\S]*)\/([gimy]*)$/.exec(e26)) ? { type: "Just", value: new RegExp(r3[1], r3[2]) } : t3.explicit ? { type: "Nothing" } : { type: "Just", value: new RegExp(e26) };
    }), Array: function(e26, t3) {
      return i2(e26, { of: [{ type: "*" }] }, t3);
    }, Object: function(e26, t3) {
      return a2(e26, { of: {} }, t3);
    }, String: function(e26) {
      var t3;
      return n2.call(e26).slice(8, -1) !== "String" ? { type: "Nothing" } : (t3 = e26.match(/^'([\s\S]*)'$/)) ? { type: "Just", value: t3[1].replace(/\\'/g, "'") } : (t3 = e26.match(/^"([\s\S]*)"$/)) ? { type: "Just", value: t3[1].replace(/\\"/g, '"') } : { type: "Just", value: e26 };
    } }, t2.exports = s2;
  }).call(e);
})), FC = r(function(t2) {
  (function() {
    var e25, r2, n2, i2, a2;
    e25 = EC, r2 = DC, n2 = kC.parseType, i2 = function(t3, n3, i3) {
      return i3 == null && (i3 = {}), i3.explicit == null && (i3.explicit = false), i3.customTypes == null && (i3.customTypes = {}), r2(e25(t3, n3, i3), t3, i3);
    }, a2 = function(e26, t3, r3) {
      return i2(n2(e26), t3, r3);
    }, t2.exports = { VERSION: "0.3.0", parse: a2, parsedTypeParse: i2 };
  }).call(e);
}), AC = (FC.VERSION, FC.parse, FC.parsedTypeParse, r(function(t2) {
  var r2 = function() {
    function e25(e26) {
      return '"' + e26.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\x08/g, "\\b").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\f/g, "\\f").replace(/\r/g, "\\r").replace(/[\x00-\x07\x0B\x0E-\x1F\x80-\uFFFF]/g, escape) + '"';
    }
    var t3 = { parse: function(t4, r3) {
      var n2 = { start: function() {
        var e26, t5, r4, n3, a3, o3 = "start@" + i2, u3 = s2[o3];
        if (u3)
          return i2 = u3.nextPos, u3.result;
        n3 = i2, a3 = i2, (e26 = c2()) !== null && (t5 = f2()) !== null && (r4 = c2()) !== null ? e26 = [e26, t5, r4] : (e26 = null, i2 = a3);
        e26 !== null && (l3 = e26[1], e26 = l3.length === 1 ? l3[0] : { type: "matches", selectors: l3 });
        var l3;
        e26 === null && (i2 = n3);
        e26 === null && (n3 = i2, (e26 = c2()) !== null && (e26 = void 0), e26 === null && (i2 = n3));
        return s2[o3] = { nextPos: i2, result: e26 }, e26;
      }, _: c2, identifierName: l2, binaryOp: p2, selectors: f2, selector: h2, sequence: d2, atom: m2, wildcard: g2, identifier: y2, attr: v2, attrOps: x2, attrEqOps: b2, attrName: E2, attrValue: C2, string: S2, number: k2, path: D2, type: F2, regex: A2, field: w2, negation: _2, matches: T2, has: P2, firstChild: I2, lastChild: B2, nthChild: O2, nthLastChild: L2, class: N2 };
      if (r3 !== void 0) {
        if (n2[r3] === void 0)
          throw new Error("Invalid rule name: " + e25(r3) + ".");
      } else
        r3 = "start";
      var i2 = 0, a2 = 0, o2 = [], s2 = {};
      function u2(e26) {
        i2 < a2 || (i2 > a2 && (a2 = i2, o2 = []), o2.push(e26));
      }
      function c2() {
        var e26, r4, n3 = "_@" + i2, a3 = s2[n3];
        if (a3)
          return i2 = a3.nextPos, a3.result;
        for (e26 = [], t4.charCodeAt(i2) === 32 ? (r4 = " ", i2++) : (r4 = null, u2('" "')); r4 !== null; )
          e26.push(r4), t4.charCodeAt(i2) === 32 ? (r4 = " ", i2++) : (r4 = null, u2('" "'));
        return s2[n3] = { nextPos: i2, result: e26 }, e26;
      }
      function l2() {
        var e26, r4, n3, a3 = "identifierName@" + i2, o3 = s2[a3];
        if (o3)
          return i2 = o3.nextPos, o3.result;
        if (n3 = i2, /^[^ [\],():#!=><~+.]/.test(t4.charAt(i2)) ? (r4 = t4.charAt(i2), i2++) : (r4 = null, u2("[^ [\\],():#!=><~+.]")), r4 !== null)
          for (e26 = []; r4 !== null; )
            e26.push(r4), /^[^ [\],():#!=><~+.]/.test(t4.charAt(i2)) ? (r4 = t4.charAt(i2), i2++) : (r4 = null, u2("[^ [\\],():#!=><~+.]"));
        else
          e26 = null;
        return e26 !== null && (e26 = function(e27, t5) {
          return t5.join("");
        }(0, e26)), e26 === null && (i2 = n3), s2[a3] = { nextPos: i2, result: e26 }, e26;
      }
      function p2() {
        var e26, r4, n3, a3, o3, l3 = "binaryOp@" + i2, p3 = s2[l3];
        return p3 ? (i2 = p3.nextPos, p3.result) : (a3 = i2, o3 = i2, (e26 = c2()) !== null ? (t4.charCodeAt(i2) === 62 ? (r4 = ">", i2++) : (r4 = null, u2('">"')), r4 !== null && (n3 = c2()) !== null ? e26 = [e26, r4, n3] : (e26 = null, i2 = o3)) : (e26 = null, i2 = o3), e26 !== null && (e26 = "child"), e26 === null && (i2 = a3), e26 === null && (a3 = i2, o3 = i2, (e26 = c2()) !== null ? (t4.charCodeAt(i2) === 126 ? (r4 = "~", i2++) : (r4 = null, u2('"~"')), r4 !== null && (n3 = c2()) !== null ? e26 = [e26, r4, n3] : (e26 = null, i2 = o3)) : (e26 = null, i2 = o3), e26 !== null && (e26 = "sibling"), e26 === null && (i2 = a3), e26 === null && (a3 = i2, o3 = i2, (e26 = c2()) !== null ? (t4.charCodeAt(i2) === 43 ? (r4 = "+", i2++) : (r4 = null, u2('"+"')), r4 !== null && (n3 = c2()) !== null ? e26 = [e26, r4, n3] : (e26 = null, i2 = o3)) : (e26 = null, i2 = o3), e26 !== null && (e26 = "adjacent"), e26 === null && (i2 = a3), e26 === null && (a3 = i2, o3 = i2, t4.charCodeAt(i2) === 32 ? (e26 = " ", i2++) : (e26 = null, u2('" "')), e26 !== null && (r4 = c2()) !== null ? e26 = [e26, r4] : (e26 = null, i2 = o3), e26 !== null && (e26 = "descendant"), e26 === null && (i2 = a3)))), s2[l3] = { nextPos: i2, result: e26 }, e26);
      }
      function f2() {
        var e26, r4, n3, a3, o3, l3, p3, f3, d3, m3 = "selectors@" + i2, g3 = s2[m3];
        if (g3)
          return i2 = g3.nextPos, g3.result;
        if (p3 = i2, f3 = i2, (e26 = h2()) !== null) {
          for (r4 = [], d3 = i2, (n3 = c2()) !== null ? (t4.charCodeAt(i2) === 44 ? (a3 = ",", i2++) : (a3 = null, u2('","')), a3 !== null && (o3 = c2()) !== null && (l3 = h2()) !== null ? n3 = [n3, a3, o3, l3] : (n3 = null, i2 = d3)) : (n3 = null, i2 = d3); n3 !== null; )
            r4.push(n3), d3 = i2, (n3 = c2()) !== null ? (t4.charCodeAt(i2) === 44 ? (a3 = ",", i2++) : (a3 = null, u2('","')), a3 !== null && (o3 = c2()) !== null && (l3 = h2()) !== null ? n3 = [n3, a3, o3, l3] : (n3 = null, i2 = d3)) : (n3 = null, i2 = d3);
          r4 !== null ? e26 = [e26, r4] : (e26 = null, i2 = f3);
        } else
          e26 = null, i2 = f3;
        return e26 !== null && (e26 = function(e27, t5, r5) {
          return [t5].concat(r5.map(function(e28) {
            return e28[3];
          }));
        }(0, e26[0], e26[1])), e26 === null && (i2 = p3), s2[m3] = { nextPos: i2, result: e26 }, e26;
      }
      function h2() {
        var e26, t5, r4, n3, a3, o3, u3, c3, l3 = "selector@" + i2, f3 = s2[l3];
        if (f3)
          return i2 = f3.nextPos, f3.result;
        if (a3 = i2, o3 = i2, (e26 = d2()) !== null) {
          for (t5 = [], u3 = i2, (r4 = p2()) !== null && (n3 = d2()) !== null ? r4 = [r4, n3] : (r4 = null, i2 = u3); r4 !== null; )
            t5.push(r4), u3 = i2, (r4 = p2()) !== null && (n3 = d2()) !== null ? r4 = [r4, n3] : (r4 = null, i2 = u3);
          t5 !== null ? e26 = [e26, t5] : (e26 = null, i2 = o3);
        } else
          e26 = null, i2 = o3;
        return e26 !== null && (c3 = e26[0], e26 = e26[1].reduce(function(e27, t6) {
          return { type: t6[0], left: e27, right: t6[1] };
        }, c3)), e26 === null && (i2 = a3), s2[l3] = { nextPos: i2, result: e26 }, e26;
      }
      function d2() {
        var e26, r4, n3, a3, o3, c3, l3, p3, f3 = "sequence@" + i2, h3 = s2[f3];
        if (h3)
          return i2 = h3.nextPos, h3.result;
        if (a3 = i2, o3 = i2, t4.charCodeAt(i2) === 33 ? (e26 = "!", i2++) : (e26 = null, u2('"!"')), (e26 = e26 !== null ? e26 : "") !== null) {
          if ((n3 = m2()) !== null)
            for (r4 = []; n3 !== null; )
              r4.push(n3), n3 = m2();
          else
            r4 = null;
          r4 !== null ? e26 = [e26, r4] : (e26 = null, i2 = o3);
        } else
          e26 = null, i2 = o3;
        return e26 !== null && (c3 = e26[0], l3 = e26[1], p3 = l3.length === 1 ? l3[0] : { type: "compound", selectors: l3 }, c3 && (p3.subject = true), e26 = p3), e26 === null && (i2 = a3), s2[f3] = { nextPos: i2, result: e26 }, e26;
      }
      function m2() {
        var e26, t5 = "atom@" + i2, r4 = s2[t5];
        return r4 ? (i2 = r4.nextPos, r4.result) : ((e26 = g2()) === null && (e26 = y2()) === null && (e26 = v2()) === null && (e26 = w2()) === null && (e26 = _2()) === null && (e26 = T2()) === null && (e26 = P2()) === null && (e26 = I2()) === null && (e26 = B2()) === null && (e26 = O2()) === null && (e26 = L2()) === null && (e26 = N2()), s2[t5] = { nextPos: i2, result: e26 }, e26);
      }
      function g2() {
        var e26, r4, n3 = "wildcard@" + i2, a3 = s2[n3];
        return a3 ? (i2 = a3.nextPos, a3.result) : (r4 = i2, t4.charCodeAt(i2) === 42 ? (e26 = "*", i2++) : (e26 = null, u2('"*"')), e26 !== null && (e26 = { type: "wildcard", value: e26 }), e26 === null && (i2 = r4), s2[n3] = { nextPos: i2, result: e26 }, e26);
      }
      function y2() {
        var e26, r4, n3, a3, o3 = "identifier@" + i2, c3 = s2[o3];
        return c3 ? (i2 = c3.nextPos, c3.result) : (n3 = i2, a3 = i2, t4.charCodeAt(i2) === 35 ? (e26 = "#", i2++) : (e26 = null, u2('"#"')), (e26 = e26 !== null ? e26 : "") !== null && (r4 = l2()) !== null ? e26 = [e26, r4] : (e26 = null, i2 = a3), e26 !== null && (e26 = function(e27, t5) {
          return { type: "identifier", value: t5 };
        }(0, e26[1])), e26 === null && (i2 = n3), s2[o3] = { nextPos: i2, result: e26 }, e26);
      }
      function v2() {
        var e26, r4, n3, a3, o3, l3, p3, f3 = "attr@" + i2, h3 = s2[f3];
        return h3 ? (i2 = h3.nextPos, h3.result) : (l3 = i2, p3 = i2, t4.charCodeAt(i2) === 91 ? (e26 = "[", i2++) : (e26 = null, u2('"["')), e26 !== null && (r4 = c2()) !== null && (n3 = C2()) !== null && (a3 = c2()) !== null ? (t4.charCodeAt(i2) === 93 ? (o3 = "]", i2++) : (o3 = null, u2('"]"')), o3 !== null ? e26 = [e26, r4, n3, a3, o3] : (e26 = null, i2 = p3)) : (e26 = null, i2 = p3), e26 !== null && (e26 = e26[2]), e26 === null && (i2 = l3), s2[f3] = { nextPos: i2, result: e26 }, e26);
      }
      function x2() {
        var e26, r4, n3, a3, o3 = "attrOps@" + i2, c3 = s2[o3];
        return c3 ? (i2 = c3.nextPos, c3.result) : (n3 = i2, a3 = i2, /^[><!]/.test(t4.charAt(i2)) ? (e26 = t4.charAt(i2), i2++) : (e26 = null, u2("[><!]")), (e26 = e26 !== null ? e26 : "") !== null ? (t4.charCodeAt(i2) === 61 ? (r4 = "=", i2++) : (r4 = null, u2('"="')), r4 !== null ? e26 = [e26, r4] : (e26 = null, i2 = a3)) : (e26 = null, i2 = a3), e26 !== null && (e26 = e26[0] + "="), e26 === null && (i2 = n3), e26 === null && (/^[><]/.test(t4.charAt(i2)) ? (e26 = t4.charAt(i2), i2++) : (e26 = null, u2("[><]"))), s2[o3] = { nextPos: i2, result: e26 }, e26);
      }
      function b2() {
        var e26, r4, n3, a3, o3 = "attrEqOps@" + i2, c3 = s2[o3];
        return c3 ? (i2 = c3.nextPos, c3.result) : (n3 = i2, a3 = i2, t4.charCodeAt(i2) === 33 ? (e26 = "!", i2++) : (e26 = null, u2('"!"')), (e26 = e26 !== null ? e26 : "") !== null ? (t4.charCodeAt(i2) === 61 ? (r4 = "=", i2++) : (r4 = null, u2('"="')), r4 !== null ? e26 = [e26, r4] : (e26 = null, i2 = a3)) : (e26 = null, i2 = a3), e26 !== null && (e26 = e26[0] + "="), e26 === null && (i2 = n3), s2[o3] = { nextPos: i2, result: e26 }, e26);
      }
      function E2() {
        var e26, r4, n3, a3 = "attrName@" + i2, o3 = s2[a3];
        if (o3)
          return i2 = o3.nextPos, o3.result;
        if (n3 = i2, (r4 = l2()) === null && (t4.charCodeAt(i2) === 46 ? (r4 = ".", i2++) : (r4 = null, u2('"."'))), r4 !== null)
          for (e26 = []; r4 !== null; )
            e26.push(r4), (r4 = l2()) === null && (t4.charCodeAt(i2) === 46 ? (r4 = ".", i2++) : (r4 = null, u2('"."')));
        else
          e26 = null;
        return e26 !== null && (e26 = function(e27, t5) {
          return t5.join("");
        }(0, e26)), e26 === null && (i2 = n3), s2[a3] = { nextPos: i2, result: e26 }, e26;
      }
      function C2() {
        var e26, t5, r4, n3, a3, o3, u3, l3 = "attrValue@" + i2, p3 = s2[l3];
        return p3 ? (i2 = p3.nextPos, p3.result) : (o3 = i2, u3 = i2, (e26 = E2()) !== null && (t5 = c2()) !== null && (r4 = b2()) !== null && (n3 = c2()) !== null ? ((a3 = F2()) === null && (a3 = A2()), a3 !== null ? e26 = [e26, t5, r4, n3, a3] : (e26 = null, i2 = u3)) : (e26 = null, i2 = u3), e26 !== null && (e26 = function(e27, t6, r5, n4) {
          return { type: "attribute", name: t6, operator: r5, value: n4 };
        }(0, e26[0], e26[2], e26[4])), e26 === null && (i2 = o3), e26 === null && (o3 = i2, u3 = i2, (e26 = E2()) !== null && (t5 = c2()) !== null && (r4 = x2()) !== null && (n3 = c2()) !== null ? ((a3 = S2()) === null && (a3 = k2()) === null && (a3 = D2()), a3 !== null ? e26 = [e26, t5, r4, n3, a3] : (e26 = null, i2 = u3)) : (e26 = null, i2 = u3), e26 !== null && (e26 = function(e27, t6, r5, n4) {
          return { type: "attribute", name: t6, operator: r5, value: n4 };
        }(0, e26[0], e26[2], e26[4])), e26 === null && (i2 = o3), e26 === null && (o3 = i2, (e26 = E2()) !== null && (e26 = function(e27, t6) {
          return { type: "attribute", name: t6 };
        }(0, e26)), e26 === null && (i2 = o3))), s2[l3] = { nextPos: i2, result: e26 }, e26);
      }
      function S2() {
        var e26, r4, n3, a3, o3, c3, l3, p3, f3, h3, d3 = "string@" + i2, m3 = s2[d3];
        if (m3)
          return i2 = m3.nextPos, m3.result;
        if (o3 = i2, c3 = i2, t4.charCodeAt(i2) === 34 ? (e26 = '"', i2++) : (e26 = null, u2('"\\""')), e26 !== null) {
          for (r4 = [], /^[^\\"]/.test(t4.charAt(i2)) ? (n3 = t4.charAt(i2), i2++) : (n3 = null, u2('[^\\\\"]')), n3 === null && (l3 = i2, p3 = i2, t4.charCodeAt(i2) === 92 ? (n3 = "\\", i2++) : (n3 = null, u2('"\\\\"')), n3 !== null ? (t4.length > i2 ? (a3 = t4.charAt(i2), i2++) : (a3 = null, u2("any character")), a3 !== null ? n3 = [n3, a3] : (n3 = null, i2 = p3)) : (n3 = null, i2 = p3), n3 !== null && (f3 = n3[0], h3 = n3[1], n3 = f3 + h3), n3 === null && (i2 = l3)); n3 !== null; )
            r4.push(n3), /^[^\\"]/.test(t4.charAt(i2)) ? (n3 = t4.charAt(i2), i2++) : (n3 = null, u2('[^\\\\"]')), n3 === null && (l3 = i2, p3 = i2, t4.charCodeAt(i2) === 92 ? (n3 = "\\", i2++) : (n3 = null, u2('"\\\\"')), n3 !== null ? (t4.length > i2 ? (a3 = t4.charAt(i2), i2++) : (a3 = null, u2("any character")), a3 !== null ? n3 = [n3, a3] : (n3 = null, i2 = p3)) : (n3 = null, i2 = p3), n3 !== null && (n3 = function(e27, t5, r5) {
              return t5 + r5;
            }(0, n3[0], n3[1])), n3 === null && (i2 = l3));
          r4 !== null ? (t4.charCodeAt(i2) === 34 ? (n3 = '"', i2++) : (n3 = null, u2('"\\""')), n3 !== null ? e26 = [e26, r4, n3] : (e26 = null, i2 = c3)) : (e26 = null, i2 = c3);
        } else
          e26 = null, i2 = c3;
        if (e26 !== null && (e26 = function(e27, t5) {
          return { type: "literal", value: M2(t5.join("")) };
        }(0, e26[1])), e26 === null && (i2 = o3), e26 === null) {
          if (o3 = i2, c3 = i2, t4.charCodeAt(i2) === 39 ? (e26 = "'", i2++) : (e26 = null, u2(`"'"`)), e26 !== null) {
            for (r4 = [], /^[^\\']/.test(t4.charAt(i2)) ? (n3 = t4.charAt(i2), i2++) : (n3 = null, u2("[^\\\\']")), n3 === null && (l3 = i2, p3 = i2, t4.charCodeAt(i2) === 92 ? (n3 = "\\", i2++) : (n3 = null, u2('"\\\\"')), n3 !== null ? (t4.length > i2 ? (a3 = t4.charAt(i2), i2++) : (a3 = null, u2("any character")), a3 !== null ? n3 = [n3, a3] : (n3 = null, i2 = p3)) : (n3 = null, i2 = p3), n3 !== null && (n3 = function(e27, t5, r5) {
              return t5 + r5;
            }(0, n3[0], n3[1])), n3 === null && (i2 = l3)); n3 !== null; )
              r4.push(n3), /^[^\\']/.test(t4.charAt(i2)) ? (n3 = t4.charAt(i2), i2++) : (n3 = null, u2("[^\\\\']")), n3 === null && (l3 = i2, p3 = i2, t4.charCodeAt(i2) === 92 ? (n3 = "\\", i2++) : (n3 = null, u2('"\\\\"')), n3 !== null ? (t4.length > i2 ? (a3 = t4.charAt(i2), i2++) : (a3 = null, u2("any character")), a3 !== null ? n3 = [n3, a3] : (n3 = null, i2 = p3)) : (n3 = null, i2 = p3), n3 !== null && (n3 = function(e27, t5, r5) {
                return t5 + r5;
              }(0, n3[0], n3[1])), n3 === null && (i2 = l3));
            r4 !== null ? (t4.charCodeAt(i2) === 39 ? (n3 = "'", i2++) : (n3 = null, u2(`"'"`)), n3 !== null ? e26 = [e26, r4, n3] : (e26 = null, i2 = c3)) : (e26 = null, i2 = c3);
          } else
            e26 = null, i2 = c3;
          e26 !== null && (e26 = function(e27, t5) {
            return { type: "literal", value: M2(t5.join("")) };
          }(0, e26[1])), e26 === null && (i2 = o3);
        }
        return s2[d3] = { nextPos: i2, result: e26 }, e26;
      }
      function k2() {
        var e26, r4, n3, a3, o3, c3, l3, p3, f3 = "number@" + i2, h3 = s2[f3];
        if (h3)
          return i2 = h3.nextPos, h3.result;
        for (a3 = i2, o3 = i2, c3 = i2, e26 = [], /^[0-9]/.test(t4.charAt(i2)) ? (r4 = t4.charAt(i2), i2++) : (r4 = null, u2("[0-9]")); r4 !== null; )
          e26.push(r4), /^[0-9]/.test(t4.charAt(i2)) ? (r4 = t4.charAt(i2), i2++) : (r4 = null, u2("[0-9]"));
        if (e26 !== null ? (t4.charCodeAt(i2) === 46 ? (r4 = ".", i2++) : (r4 = null, u2('"."')), r4 !== null ? e26 = [e26, r4] : (e26 = null, i2 = c3)) : (e26 = null, i2 = c3), (e26 = e26 !== null ? e26 : "") !== null) {
          if (/^[0-9]/.test(t4.charAt(i2)) ? (n3 = t4.charAt(i2), i2++) : (n3 = null, u2("[0-9]")), n3 !== null)
            for (r4 = []; n3 !== null; )
              r4.push(n3), /^[0-9]/.test(t4.charAt(i2)) ? (n3 = t4.charAt(i2), i2++) : (n3 = null, u2("[0-9]"));
          else
            r4 = null;
          r4 !== null ? e26 = [e26, r4] : (e26 = null, i2 = o3);
        } else
          e26 = null, i2 = o3;
        return e26 !== null && (l3 = e26[0], p3 = e26[1], e26 = { type: "literal", value: parseFloat((l3 ? l3.join("") : "") + p3.join("")) }), e26 === null && (i2 = a3), s2[f3] = { nextPos: i2, result: e26 }, e26;
      }
      function D2() {
        var e26, t5, r4 = "path@" + i2, n3 = s2[r4];
        return n3 ? (i2 = n3.nextPos, n3.result) : (t5 = i2, (e26 = l2()) !== null && (e26 = function(e27, t6) {
          return { type: "literal", value: t6 };
        }(0, e26)), e26 === null && (i2 = t5), s2[r4] = { nextPos: i2, result: e26 }, e26);
      }
      function F2() {
        var e26, r4, n3, a3, o3, l3, p3, f3 = "type@" + i2, h3 = s2[f3];
        if (h3)
          return i2 = h3.nextPos, h3.result;
        if (l3 = i2, p3 = i2, t4.substr(i2, 5) === "type(" ? (e26 = "type(", i2 += 5) : (e26 = null, u2('"type("')), e26 !== null)
          if ((r4 = c2()) !== null) {
            if (/^[^ )]/.test(t4.charAt(i2)) ? (a3 = t4.charAt(i2), i2++) : (a3 = null, u2("[^ )]")), a3 !== null)
              for (n3 = []; a3 !== null; )
                n3.push(a3), /^[^ )]/.test(t4.charAt(i2)) ? (a3 = t4.charAt(i2), i2++) : (a3 = null, u2("[^ )]"));
            else
              n3 = null;
            n3 !== null && (a3 = c2()) !== null ? (t4.charCodeAt(i2) === 41 ? (o3 = ")", i2++) : (o3 = null, u2('")"')), o3 !== null ? e26 = [e26, r4, n3, a3, o3] : (e26 = null, i2 = p3)) : (e26 = null, i2 = p3);
          } else
            e26 = null, i2 = p3;
        else
          e26 = null, i2 = p3;
        return e26 !== null && (e26 = { type: "type", value: e26[2].join("") }), e26 === null && (i2 = l3), s2[f3] = { nextPos: i2, result: e26 }, e26;
      }
      function A2() {
        var e26, r4, n3, a3, o3, c3 = "regex@" + i2, l3 = s2[c3];
        if (l3)
          return i2 = l3.nextPos, l3.result;
        if (a3 = i2, o3 = i2, t4.charCodeAt(i2) === 47 ? (e26 = "/", i2++) : (e26 = null, u2('"/"')), e26 !== null) {
          if (/^[^\/]/.test(t4.charAt(i2)) ? (n3 = t4.charAt(i2), i2++) : (n3 = null, u2("[^\\/]")), n3 !== null)
            for (r4 = []; n3 !== null; )
              r4.push(n3), /^[^\/]/.test(t4.charAt(i2)) ? (n3 = t4.charAt(i2), i2++) : (n3 = null, u2("[^\\/]"));
          else
            r4 = null;
          r4 !== null ? (t4.charCodeAt(i2) === 47 ? (n3 = "/", i2++) : (n3 = null, u2('"/"')), n3 !== null ? e26 = [e26, r4, n3] : (e26 = null, i2 = o3)) : (e26 = null, i2 = o3);
        } else
          e26 = null, i2 = o3;
        return e26 !== null && (e26 = function(e27, t5) {
          return { type: "regexp", value: new RegExp(t5.join("")) };
        }(0, e26[1])), e26 === null && (i2 = a3), s2[c3] = { nextPos: i2, result: e26 }, e26;
      }
      function w2() {
        var e26, r4, n3, a3, o3, c3, p3, f3, h3 = "field@" + i2, d3 = s2[h3];
        if (d3)
          return i2 = d3.nextPos, d3.result;
        if (c3 = i2, p3 = i2, t4.charCodeAt(i2) === 46 ? (e26 = ".", i2++) : (e26 = null, u2('"."')), e26 !== null)
          if ((r4 = l2()) !== null) {
            for (n3 = [], f3 = i2, t4.charCodeAt(i2) === 46 ? (a3 = ".", i2++) : (a3 = null, u2('"."')), a3 !== null && (o3 = l2()) !== null ? a3 = [a3, o3] : (a3 = null, i2 = f3); a3 !== null; )
              n3.push(a3), f3 = i2, t4.charCodeAt(i2) === 46 ? (a3 = ".", i2++) : (a3 = null, u2('"."')), a3 !== null && (o3 = l2()) !== null ? a3 = [a3, o3] : (a3 = null, i2 = f3);
            n3 !== null ? e26 = [e26, r4, n3] : (e26 = null, i2 = p3);
          } else
            e26 = null, i2 = p3;
        else
          e26 = null, i2 = p3;
        return e26 !== null && (e26 = function(e27, t5, r5) {
          return { type: "field", name: r5.reduce(function(e28, t6) {
            return e28 + t6[0] + t6[1];
          }, t5) };
        }(0, e26[1], e26[2])), e26 === null && (i2 = c3), s2[h3] = { nextPos: i2, result: e26 }, e26;
      }
      function _2() {
        var e26, r4, n3, a3, o3, l3, p3, h3 = "negation@" + i2, d3 = s2[h3];
        return d3 ? (i2 = d3.nextPos, d3.result) : (l3 = i2, p3 = i2, t4.substr(i2, 5) === ":not(" ? (e26 = ":not(", i2 += 5) : (e26 = null, u2('":not("')), e26 !== null && (r4 = c2()) !== null && (n3 = f2()) !== null && (a3 = c2()) !== null ? (t4.charCodeAt(i2) === 41 ? (o3 = ")", i2++) : (o3 = null, u2('")"')), o3 !== null ? e26 = [e26, r4, n3, a3, o3] : (e26 = null, i2 = p3)) : (e26 = null, i2 = p3), e26 !== null && (e26 = { type: "not", selectors: e26[2] }), e26 === null && (i2 = l3), s2[h3] = { nextPos: i2, result: e26 }, e26);
      }
      function T2() {
        var e26, r4, n3, a3, o3, l3, p3, h3 = "matches@" + i2, d3 = s2[h3];
        return d3 ? (i2 = d3.nextPos, d3.result) : (l3 = i2, p3 = i2, t4.substr(i2, 9) === ":matches(" ? (e26 = ":matches(", i2 += 9) : (e26 = null, u2('":matches("')), e26 !== null && (r4 = c2()) !== null && (n3 = f2()) !== null && (a3 = c2()) !== null ? (t4.charCodeAt(i2) === 41 ? (o3 = ")", i2++) : (o3 = null, u2('")"')), o3 !== null ? e26 = [e26, r4, n3, a3, o3] : (e26 = null, i2 = p3)) : (e26 = null, i2 = p3), e26 !== null && (e26 = { type: "matches", selectors: e26[2] }), e26 === null && (i2 = l3), s2[h3] = { nextPos: i2, result: e26 }, e26);
      }
      function P2() {
        var e26, r4, n3, a3, o3, l3, p3, h3 = "has@" + i2, d3 = s2[h3];
        return d3 ? (i2 = d3.nextPos, d3.result) : (l3 = i2, p3 = i2, t4.substr(i2, 5) === ":has(" ? (e26 = ":has(", i2 += 5) : (e26 = null, u2('":has("')), e26 !== null && (r4 = c2()) !== null && (n3 = f2()) !== null && (a3 = c2()) !== null ? (t4.charCodeAt(i2) === 41 ? (o3 = ")", i2++) : (o3 = null, u2('")"')), o3 !== null ? e26 = [e26, r4, n3, a3, o3] : (e26 = null, i2 = p3)) : (e26 = null, i2 = p3), e26 !== null && (e26 = { type: "has", selectors: e26[2] }), e26 === null && (i2 = l3), s2[h3] = { nextPos: i2, result: e26 }, e26);
      }
      function I2() {
        var e26, r4, n3 = "firstChild@" + i2, a3 = s2[n3];
        return a3 ? (i2 = a3.nextPos, a3.result) : (r4 = i2, t4.substr(i2, 12) === ":first-child" ? (e26 = ":first-child", i2 += 12) : (e26 = null, u2('":first-child"')), e26 !== null && (e26 = j2(1)), e26 === null && (i2 = r4), s2[n3] = { nextPos: i2, result: e26 }, e26);
      }
      function B2() {
        var e26, r4, n3 = "lastChild@" + i2, a3 = s2[n3];
        return a3 ? (i2 = a3.nextPos, a3.result) : (r4 = i2, t4.substr(i2, 11) === ":last-child" ? (e26 = ":last-child", i2 += 11) : (e26 = null, u2('":last-child"')), e26 !== null && (e26 = R2(1)), e26 === null && (i2 = r4), s2[n3] = { nextPos: i2, result: e26 }, e26);
      }
      function O2() {
        var e26, r4, n3, a3, o3, l3, p3, f3, h3 = "nthChild@" + i2, d3 = s2[h3];
        if (d3)
          return i2 = d3.nextPos, d3.result;
        if (l3 = i2, p3 = i2, t4.substr(i2, 11) === ":nth-child(" ? (e26 = ":nth-child(", i2 += 11) : (e26 = null, u2('":nth-child("')), e26 !== null)
          if ((r4 = c2()) !== null) {
            if (/^[0-9]/.test(t4.charAt(i2)) ? (a3 = t4.charAt(i2), i2++) : (a3 = null, u2("[0-9]")), a3 !== null)
              for (n3 = []; a3 !== null; )
                n3.push(a3), /^[0-9]/.test(t4.charAt(i2)) ? (a3 = t4.charAt(i2), i2++) : (a3 = null, u2("[0-9]"));
            else
              n3 = null;
            n3 !== null && (a3 = c2()) !== null ? (t4.charCodeAt(i2) === 41 ? (o3 = ")", i2++) : (o3 = null, u2('")"')), o3 !== null ? e26 = [e26, r4, n3, a3, o3] : (e26 = null, i2 = p3)) : (e26 = null, i2 = p3);
          } else
            e26 = null, i2 = p3;
        else
          e26 = null, i2 = p3;
        return e26 !== null && (f3 = e26[2], e26 = j2(parseInt(f3.join(""), 10))), e26 === null && (i2 = l3), s2[h3] = { nextPos: i2, result: e26 }, e26;
      }
      function L2() {
        var e26, r4, n3, a3, o3, l3, p3, f3, h3 = "nthLastChild@" + i2, d3 = s2[h3];
        if (d3)
          return i2 = d3.nextPos, d3.result;
        if (l3 = i2, p3 = i2, t4.substr(i2, 16) === ":nth-last-child(" ? (e26 = ":nth-last-child(", i2 += 16) : (e26 = null, u2('":nth-last-child("')), e26 !== null)
          if ((r4 = c2()) !== null) {
            if (/^[0-9]/.test(t4.charAt(i2)) ? (a3 = t4.charAt(i2), i2++) : (a3 = null, u2("[0-9]")), a3 !== null)
              for (n3 = []; a3 !== null; )
                n3.push(a3), /^[0-9]/.test(t4.charAt(i2)) ? (a3 = t4.charAt(i2), i2++) : (a3 = null, u2("[0-9]"));
            else
              n3 = null;
            n3 !== null && (a3 = c2()) !== null ? (t4.charCodeAt(i2) === 41 ? (o3 = ")", i2++) : (o3 = null, u2('")"')), o3 !== null ? e26 = [e26, r4, n3, a3, o3] : (e26 = null, i2 = p3)) : (e26 = null, i2 = p3);
          } else
            e26 = null, i2 = p3;
        else
          e26 = null, i2 = p3;
        return e26 !== null && (f3 = e26[2], e26 = R2(parseInt(f3.join(""), 10))), e26 === null && (i2 = l3), s2[h3] = { nextPos: i2, result: e26 }, e26;
      }
      function N2() {
        var e26, r4, n3, a3, o3 = "class@" + i2, c3 = s2[o3];
        return c3 ? (i2 = c3.nextPos, c3.result) : (n3 = i2, a3 = i2, t4.charCodeAt(i2) === 58 ? (e26 = ":", i2++) : (e26 = null, u2('":"')), e26 !== null ? (t4.substr(i2, 9).toLowerCase() === "statement" ? (r4 = t4.substr(i2, 9), i2 += 9) : (r4 = null, u2('"statement"')), r4 === null && (t4.substr(i2, 10).toLowerCase() === "expression" ? (r4 = t4.substr(i2, 10), i2 += 10) : (r4 = null, u2('"expression"')), r4 === null && (t4.substr(i2, 11).toLowerCase() === "declaration" ? (r4 = t4.substr(i2, 11), i2 += 11) : (r4 = null, u2('"declaration"')), r4 === null && (t4.substr(i2, 8).toLowerCase() === "function" ? (r4 = t4.substr(i2, 8), i2 += 8) : (r4 = null, u2('"function"')), r4 === null && (t4.substr(i2, 7).toLowerCase() === "pattern" ? (r4 = t4.substr(i2, 7), i2 += 7) : (r4 = null, u2('"pattern"')))))), r4 !== null ? e26 = [e26, r4] : (e26 = null, i2 = a3)) : (e26 = null, i2 = a3), e26 !== null && (e26 = { type: "class", name: e26[1] }), e26 === null && (i2 = n3), s2[o3] = { nextPos: i2, result: e26 }, e26);
      }
      function j2(e26) {
        return { type: "nth-child", index: { type: "literal", value: e26 } };
      }
      function R2(e26) {
        return { type: "nth-last-child", index: { type: "literal", value: e26 } };
      }
      function M2(e26) {
        return e26.replace(/\\(.)/g, function(e27, t5) {
          switch (t5) {
            case "a":
              return "a";
            case "b":
              return "\b";
            case "f":
              return "\f";
            case "n":
              return "\n";
            case "r":
              return "\r";
            case "t":
              return "	";
            case "v":
              return "\v";
            default:
              return t5;
          }
        });
      }
      var V2 = n2[r3]();
      if (V2 === null || i2 !== t4.length) {
        var U2 = Math.max(i2, a2), q2 = U2 < t4.length ? t4.charAt(U2) : null, W2 = function() {
          for (var e26 = 1, r4 = 1, n3 = false, o3 = 0; o3 < Math.max(i2, a2); o3++) {
            var s3 = t4.charAt(o3);
            s3 === "\n" ? (n3 || e26++, r4 = 1, n3 = false) : s3 === "\r" || s3 === "\u2028" || s3 === "\u2029" ? (e26++, r4 = 1, n3 = true) : (r4++, n3 = false);
          }
          return { line: e26, column: r4 };
        }();
        throw new this.SyntaxError(function(e26) {
          e26.sort();
          for (var t5 = null, r4 = [], n3 = 0; n3 < e26.length; n3++)
            e26[n3] !== t5 && (r4.push(e26[n3]), t5 = e26[n3]);
          return r4;
        }(o2), q2, U2, W2.line, W2.column);
      }
      return V2;
    }, toSource: function() {
      return this._source;
    }, SyntaxError: function(t4, r3, n2, i2, a2) {
      this.name = "SyntaxError", this.expected = t4, this.found = r3, this.message = function(t5, r4) {
        var n3;
        switch (t5.length) {
          case 0:
            n3 = "end of input";
            break;
          case 1:
            n3 = t5[0];
            break;
          default:
            n3 = t5.slice(0, t5.length - 1).join(", ") + " or " + t5[t5.length - 1];
        }
        return "Expected " + n3 + " but " + (r4 ? e25(r4) : "end of input") + " found.";
      }(t4, r3), this.offset = n2, this.line = i2, this.column = a2;
    } };
    return t3.SyntaxError.prototype = Error.prototype, t3;
  }();
  t2.exports ? t2.exports = r2 : e.esquery = r2;
})), wC = r(function(e25) {
  !function() {
    var t2 = Zu, r2 = AC, n2 = Array.isArray || function(e26) {
      return {}.toString.call(e26) === "[object Array]";
    }, a2 = {}, o2 = {};
    function s2() {
      function e26(t3, r3, i2) {
        var a3, o3, s4;
        if (i2.length === 0)
          return t3 === r3;
        if (r3 == null)
          return false;
        if (a3 = r3[i2[0]], o3 = i2.slice(1), n2(a3)) {
          for (s4 = 0, l = a3.length; s4 < l; ++s4)
            if (e26(t3, a3[s4], o3))
              return true;
          return false;
        }
        return e26(t3, a3, o3);
      }
      function s3(r3, n3, l2) {
        var f3, h3, d3, m2;
        if (!n3)
          return true;
        if (!r3)
          return false;
        switch (l2 || (l2 = []), n3.type) {
          case "wildcard":
            return true;
          case "identifier":
            return n3.value.toLowerCase() === r3.type.toLowerCase();
          case "field":
            return e26(r3, l2[(f3 = n3.name.split(".")).length - 1], f3);
          case "matches":
            for (h3 = 0, d3 = n3.selectors.length; h3 < d3; ++h3)
              if (s3(r3, n3.selectors[h3], l2))
                return true;
            return false;
          case "compound":
            for (h3 = 0, d3 = n3.selectors.length; h3 < d3; ++h3)
              if (!s3(r3, n3.selectors[h3], l2))
                return false;
            return true;
          case "not":
            for (h3 = 0, d3 = n3.selectors.length; h3 < d3; ++h3)
              if (s3(r3, n3.selectors[h3], l2))
                return false;
            return true;
          case "has":
            var g2, y2 = [];
            for (h3 = 0, d3 = n3.selectors.length; h3 < d3; ++h3)
              g2 = [], t2.traverse(r3, { enter: function(e27, t3) {
                t3 != null && g2.unshift(t3), s3(e27, n3.selectors[h3], g2) && y2.push(e27);
              }, leave: function() {
                g2.shift();
              } });
            return y2.length !== 0;
          case "child":
            return !!s3(r3, n3.right, l2) && s3(l2[0], n3.left, l2.slice(1));
          case "descendant":
            if (s3(r3, n3.right, l2)) {
              for (h3 = 0, d3 = l2.length; h3 < d3; ++h3)
                if (s3(l2[h3], n3.left, l2.slice(h3 + 1)))
                  return true;
            }
            return false;
          case "attribute":
            switch (m2 = function(e27, t3) {
              var r4, n4 = t3.split(".");
              for (r4 = 0; r4 < n4.length; r4++) {
                if (e27 == null)
                  return e27;
                e27 = e27[n4[r4]];
              }
              return e27;
            }(r3, n3.name), n3.operator) {
              case null:
              case void 0:
                return m2 != null;
              case "=":
                switch (n3.value.type) {
                  case "regexp":
                    return typeof m2 == "string" && n3.value.value.test(m2);
                  case "literal":
                    return "" + n3.value.value == "" + m2;
                  case "type":
                    return n3.value.value === i(m2);
                }
              case "!=":
                switch (n3.value.type) {
                  case "regexp":
                    return !n3.value.value.test(m2);
                  case "literal":
                    return "" + n3.value.value != "" + m2;
                  case "type":
                    return n3.value.value !== i(m2);
                }
              case "<=":
                return m2 <= n3.value.value;
              case "<":
                return m2 < n3.value.value;
              case ">":
                return m2 > n3.value.value;
              case ">=":
                return m2 >= n3.value.value;
            }
          case "sibling":
            return s3(r3, n3.right, l2) && u2(r3, n3.left, l2, a2) || n3.left.subject && s3(r3, n3.left, l2) && u2(r3, n3.right, l2, o2);
          case "adjacent":
            return s3(r3, n3.right, l2) && c2(r3, n3.left, l2, a2) || n3.right.subject && s3(r3, n3.left, l2) && c2(r3, n3.right, l2, o2);
          case "nth-child":
            return s3(r3, n3.right, l2) && p2(r3, l2, function(e27) {
              return n3.index.value - 1;
            });
          case "nth-last-child":
            return s3(r3, n3.right, l2) && p2(r3, l2, function(e27) {
              return e27 - n3.index.value;
            });
          case "class":
            if (!r3.type)
              return false;
            switch (n3.name.toLowerCase()) {
              case "statement":
                if (r3.type.slice(-9) === "Statement")
                  return true;
              case "declaration":
                return r3.type.slice(-11) === "Declaration";
              case "pattern":
                if (r3.type.slice(-7) === "Pattern")
                  return true;
              case "expression":
                return r3.type.slice(-10) === "Expression" || r3.type.slice(-7) === "Literal" || r3.type === "Identifier" && (l2.length === 0 || l2[0].type !== "MetaProperty") || r3.type === "MetaProperty";
              case "function":
                return r3.type.slice(0, 8) === "Function" || r3.type === "ArrowFunctionExpression";
            }
            throw new Error("Unknown class name: " + n3.name);
        }
        throw new Error("Unknown selector type: " + n3.type);
      }
      function u2(e27, r3, i2, o3) {
        var u3, c3, l2, p3, f3, h3, d3, m2, g2 = i2[0];
        if (!g2)
          return false;
        for (p3 = 0, f3 = (l2 = t2.VisitorKeys[g2.type]).length; p3 < f3; ++p3)
          if (u3 = g2[l2[p3]], n2(u3)) {
            if ((c3 = u3.indexOf(e27)) < 0)
              continue;
            for (o3 === a2 ? (d3 = 0, m2 = c3) : (d3 = c3 + 1, m2 = u3.length), h3 = d3; h3 < m2; ++h3)
              if (s3(u3[h3], r3, i2))
                return true;
          }
        return false;
      }
      function c2(e27, r3, i2, u3) {
        var c3, l2, p3, f3, h3, d3 = i2[0];
        if (!d3)
          return false;
        for (p3 = 0, f3 = (l2 = t2.VisitorKeys[d3.type]).length; p3 < f3; ++p3)
          if (c3 = d3[l2[p3]], n2(c3)) {
            if ((h3 = c3.indexOf(e27)) < 0)
              continue;
            if (u3 === a2 && h3 > 0 && s3(c3[h3 - 1], r3, i2))
              return true;
            if (u3 === o2 && h3 < c3.length - 1 && s3(c3[h3 + 1], r3, i2))
              return true;
          }
        return false;
      }
      function p2(e27, r3, i2) {
        var a3, o3, s4, u3, c3, l2 = r3[0];
        if (!l2)
          return false;
        for (s4 = 0, u3 = (o3 = t2.VisitorKeys[l2.type]).length; s4 < u3; ++s4)
          if (a3 = l2[o3[s4]], n2(a3) && (c3 = a3.indexOf(e27)) >= 0 && c3 === i2(a3.length))
            return true;
        return false;
      }
      function f2(e27, r3) {
        var n3, a3, o3, u3, c3, l2 = [], p3 = [];
        return r3 ? (n3 = function e28(t3, r4) {
          var n4, a4;
          if (t3 == null || i(t3) != "object")
            return [];
          for (a4 in r4 == null && (r4 = t3), n4 = t3.subject ? [r4] : [], t3)
            ({}).hasOwnProperty.call(t3, a4) && [].push.apply(n4, e28(t3[a4], a4 === "left" ? t3[a4] : r4));
          return n4;
        }(r3), t2.traverse(e27, { enter: function(e28, t3) {
          if (t3 != null && l2.unshift(t3), s3(e28, r3, l2))
            if (n3.length)
              for (a3 = 0, o3 = n3.length; a3 < o3; ++a3)
                for (s3(e28, n3[a3], l2) && p3.push(e28), u3 = 0, c3 = l2.length; u3 < c3; ++u3)
                  s3(l2[u3], n3[a3], l2.slice(u3 + 1)) && p3.push(l2[u3]);
            else
              p3.push(e28);
        }, leave: function() {
          l2.shift();
        } }), p3) : p3;
      }
      function h2(e27) {
        return r2.parse(e27);
      }
      function d2(e27, t3) {
        return f2(e27, h2(t3));
      }
      return d2.parse = h2, d2.match = f2, d2.matches = s3, d2.query = d2;
    }
    e25.exports ? e25.exports = s2() : this.esquery = s2();
  }();
}), _C = n(Zx);
function TC(e25) {
  return e25 && i(e25) == "object" && "default" in e25 ? e25.default : e25;
}
var PC = TC(Ws), IC = TC(Qc), BC = TC(Cu), OC = TC(Ox), LC = TC(_C), NC = TC(Pu), jC = TC(FC), RC = TC(wC);
var MC, VC = function(e25, t2) {
  for (var r2 = {}, n2 = 0, i2 = Object.entries(e25); n2 < i2.length; n2++) {
    var a2 = b(i2[n2], 2), o2 = a2[0], s2 = a2[1];
    Object.hasOwnProperty.call(t2, o2) || (r2[o2] = s2);
  }
  return r2;
}(Fy.globals.es2015, Fy.globals.es5), UC = { Atomics: false, SharedArrayBuffer: false }, qC = new Map(Object.entries({ builtin: { globals: Fy.globals.es5 }, es6: { globals: VC, parserOptions: { ecmaVersion: 6 } }, es2015: { globals: VC, parserOptions: { ecmaVersion: 6 } }, es2017: { globals: p({}, VC, {}, UC), parserOptions: { ecmaVersion: 8 } }, es2020: { globals: p({}, VC, {}, UC, {}, { BigInt: false, BigInt64Array: false, BigUint64Array: false }), parserOptions: { ecmaVersion: 11 } }, browser: { globals: Fy.globals.browser }, node: { globals: Fy.globals.node, parserOptions: { ecmaFeatures: { globalReturn: true } } }, "shared-node-browser": { globals: Fy.globals["shared-node-browser"] }, worker: { globals: Fy.globals.worker }, serviceworker: { globals: Fy.globals.serviceworker }, commonjs: { globals: Fy.globals.commonjs, parserOptions: { ecmaFeatures: { globalReturn: true } } }, amd: { globals: Fy.globals.amd }, mocha: { globals: Fy.globals.mocha }, jasmine: { globals: Fy.globals.jasmine }, jest: { globals: Fy.globals.jest }, phantomjs: { globals: Fy.globals.phantomjs }, jquery: { globals: Fy.globals.jquery }, qunit: { globals: Fy.globals.qunit }, prototypejs: { globals: Fy.globals.prototypejs }, shelljs: { globals: Fy.globals.shelljs }, meteor: { globals: Fy.globals.meteor }, mongo: { globals: Fy.globals.mongo }, protractor: { globals: Fy.globals.protractor }, applescript: { globals: Fy.globals.applescript }, nashorn: { globals: Fy.globals.nashorn }, atomtest: { globals: Fy.globals.atomtest }, embertest: { globals: Fy.globals.embertest }, webextensions: { globals: Fy.globals.webextensions }, greasemonkey: { globals: Fy.globals.greasemonkey } })), WC = "eslint@6.7.1", $C = "sha512-UWzBS79pNcsDSxgxbdjkmzn/B6BhsXMfUaOHnNwyE8nD+Q6pyT96ow2MccVayUTV4yMid4qLhMiQaywctRkBLA==", GC = {}, zC = { type: "range", registry: true, raw: "eslint@^6.0.0", name: "eslint", escapedName: "eslint", rawSpec: "^6.0.0", saveSpec: null, fetchSpec: "^6.0.0" }, HC = ["#DEV:/"], KC = "https://registry.npmjs.org/eslint/-/eslint-6.7.1.tgz", JC = "269ccccec3ef60ab32358a44d147ac209154b919", QC = "/home/runner/work/eslint4b/eslint4b", XC = { name: "Nicholas C. Zakas", email: "nicholas+npm@nczconsulting.com" }, YC = { eslint: "./bin/eslint.js" }, ZC = { url: "https://github.com/eslint/eslint/issues/" }, eS = { "@babel/code-frame": "^7.0.0", ajv: "^6.10.0", chalk: "^2.1.0", "cross-spawn": "^6.0.5", debug: "^4.0.1", doctrine: "^3.0.0", "eslint-scope": "^5.0.0", "eslint-utils": "^1.4.3", "eslint-visitor-keys": "^1.1.0", espree: "^6.1.2", esquery: "^1.0.1", esutils: "^2.0.2", "file-entry-cache": "^5.0.1", "functional-red-black-tree": "^1.0.1", "glob-parent": "^5.0.0", globals: "^12.1.0", ignore: "^4.0.6", "import-fresh": "^3.0.0", imurmurhash: "^0.1.4", inquirer: "^7.0.0", "is-glob": "^4.0.0", "js-yaml": "^3.13.1", "json-stable-stringify-without-jsonify": "^1.0.1", levn: "^0.3.0", lodash: "^4.17.14", minimatch: "^3.0.4", mkdirp: "^0.5.1", "natural-compare": "^1.4.0", optionator: "^0.8.3", progress: "^2.0.0", regexpp: "^2.0.1", semver: "^6.1.2", "strip-ansi": "^5.2.0", "strip-json-comments": "^3.0.1", table: "^5.2.3", "text-table": "^0.2.0", "v8-compile-cache": "^2.0.3" }, tS = "An AST-based pattern checker for JavaScript.", rS = { "@babel/core": "^7.4.3", "@babel/preset-env": "^7.4.3", acorn: "^7.1.0", "babel-loader": "^8.0.5", chai: "^4.0.1", cheerio: "^0.22.0", "common-tags": "^1.8.0", "core-js": "^3.1.3", dateformat: "^3.0.3", ejs: "^2.6.1", eslint: "file:.", "eslint-config-eslint": "file:packages/eslint-config-eslint", "eslint-plugin-eslint-plugin": "^2.0.1", "eslint-plugin-internal-rules": "file:tools/internal-rules", "eslint-plugin-jsdoc": "^15.9.5", "eslint-plugin-node": "^9.0.0", "eslint-release": "^1.2.0", eslump: "^2.0.0", esprima: "^4.0.1", glob: "^7.1.3", jsdoc: "^3.5.5", karma: "^4.0.1", "karma-chrome-launcher": "^2.2.0", "karma-mocha": "^1.3.0", "karma-mocha-reporter": "^2.2.3", "karma-webpack": "^4.0.0-rc.6", leche: "^2.2.3", "lint-staged": "^8.1.5", "load-perf": "^0.2.0", markdownlint: "^0.15.0", "markdownlint-cli": "^0.17.0", "metro-memory-fs": "^0.54.1", mocha: "^6.1.2", "mocha-junit-reporter": "^1.23.0", "npm-license": "^0.3.3", nyc: "^14.1.1", proxyquire: "^2.0.1", puppeteer: "^1.18.0", recast: "^0.18.1", "regenerator-runtime": "^0.13.2", shelljs: "^0.8.2", sinon: "^7.3.2", temp: "^0.9.0", webpack: "^4.35.0", "webpack-cli": "^3.3.5", yorkie: "^2.0.0" }, nS = { node: "^8.10.0 || ^10.13.0 || >=11.10.1" }, iS = ["LICENSE", "README.md", "bin", "conf", "lib", "messages"], aS = "https://opencollective.com/eslint", oS = { "pre-commit": "lint-staged" }, sS = ["ast", "lint", "javascript", "ecmascript", "espree"], uS = { type: "git", url: "git+https://github.com/eslint/eslint.git" }, cS = { docs: "node Makefile.js docs", fix: "node Makefile.js lint -- fix", fuzz: "node Makefile.js fuzz", "generate-alpharelease": "node Makefile.js generatePrerelease -- alpha", "generate-betarelease": "node Makefile.js generatePrerelease -- beta", "generate-rcrelease": "node Makefile.js generatePrerelease -- rc", "generate-release": "node Makefile.js generateRelease", gensite: "node Makefile.js gensite", lint: "node Makefile.js lint", perf: "node Makefile.js perf", "publish-release": "node Makefile.js publishRelease", test: "node Makefile.js test", "test:cli": "mocha", webpack: "node Makefile.js webpack" }, lS = { _from: "eslint@^6.0.0", _id: WC, _inBundle: false, _integrity: $C, _location: "/eslint", _phantomChildren: GC, _requested: zC, _requiredBy: HC, _resolved: KC, _shasum: JC, _spec: "eslint@^6.0.0", _where: QC, author: XC, bin: YC, bugs: ZC, bundleDependencies: false, dependencies: eS, deprecated: false, description: tS, devDependencies: rS, engines: nS, files: iS, funding: aS, gitHooks: oS, homepage: "https://eslint.org", keywords: sS, license: "MIT", "lint-staged": { "*.js": ["eslint --fix", "git add"], "*.md": "markdownlint" }, main: "./lib/api.js", name: "eslint", repository: uS, scripts: cS, version: "6.7.1" }, pS = Object.freeze({ __proto__: null, _from: "eslint@^6.0.0", _id: WC, _inBundle: false, _integrity: $C, _location: "/eslint", _phantomChildren: GC, _requested: zC, _requiredBy: HC, _resolved: KC, _shasum: JC, _spec: "eslint@^6.0.0", _where: QC, author: XC, bin: YC, bugs: ZC, bundleDependencies: false, dependencies: eS, deprecated: false, description: tS, devDependencies: rS, engines: nS, files: iS, funding: aS, gitHooks: oS, homepage: "https://eslint.org", keywords: sS, license: "MIT", main: "./lib/api.js", name: "eslint", repository: uS, scripts: cS, version: "6.7.1", default: lS }), fS = Fy.createCommonjsModule(function(e25) {
  var t2 = ["off", "warn", "error"], r2 = t2.reduce(function(e26, t3, r3) {
    return e26[t3] = r3, e26;
  }, {}), n2 = [0, 1, 2, "off", "warn", "error"];
  e25.exports = { getRuleSeverity: function(e26) {
    var t3 = Array.isArray(e26) ? e26[0] : e26;
    return t3 === 0 || t3 === 1 || t3 === 2 ? t3 : typeof t3 == "string" && r2[t3.toLowerCase()] || 0;
  }, normalizeToStrings: function(e26) {
    e26.rules && Object.keys(e26.rules).forEach(function(r3) {
      var n3 = e26.rules[r3];
      typeof n3 == "number" ? e26.rules[r3] = t2[n3] || t2[0] : Array.isArray(n3) && typeof n3[0] == "number" && (n3[0] = t2[n3[0]] || t2[0]);
    });
  }, isErrorSeverity: function(t3) {
    return e25.exports.getRuleSeverity(t3) === 2;
  }, isValidSeverity: function(e26) {
    var t3 = Array.isArray(e26) ? e26[0] : e26;
    return typeof t3 == "string" && (t3 = t3.toLowerCase()), n2.indexOf(t3) !== -1;
  }, isEverySeverityValid: function(e26) {
    var t3 = this;
    return Object.keys(e26).every(function(r3) {
      return t3.isValidSeverity(e26[r3]);
    });
  }, normalizeConfigGlobal: function(e26) {
    switch (e26) {
      case "off":
        return "off";
      case true:
      case "true":
      case "writeable":
      case "writable":
        return "writable";
      case null:
      case false:
      case "false":
      case "readable":
      case "readonly":
        return "readonly";
      default:
        throw new Error("'".concat(e26, "' is not a valid configuration for a global (use 'readonly', 'writable', or 'off')"));
    }
  } };
}), hS = (fS.getRuleSeverity, fS.normalizeToStrings, fS.isErrorSeverity, fS.isValidSeverity, fS.isEverySeverityValid, fS.normalizeConfigGlobal, { env: { type: "object" }, extends: { $ref: "#/definitions/stringOrStrings" }, globals: { type: "object" }, overrides: { type: "array", items: { $ref: "#/definitions/overrideConfig" }, additionalItems: false }, parser: { type: ["string", "null"] }, parserOptions: { type: "object" }, plugins: { type: "array" }, processor: { type: "string" }, rules: { type: "object" }, settings: { type: "object" }, noInlineConfig: { type: "boolean" }, reportUnusedDisableDirectives: { type: "boolean" }, ecmaFeatures: { type: "object" } }), dS = { definitions: { stringOrStrings: { oneOf: [{ type: "string" }, { type: "array", items: { type: "string" }, additionalItems: false }] }, stringOrStringsRequired: { oneOf: [{ type: "string" }, { type: "array", items: { type: "string" }, additionalItems: false, minItems: 1 }] }, objectConfig: { type: "object", properties: p({ root: { type: "boolean" }, ignorePatterns: { $ref: "#/definitions/stringOrStrings" } }, hS), additionalProperties: false }, overrideConfig: { type: "object", properties: p({ excludedFiles: { $ref: "#/definitions/stringOrStrings" }, files: { $ref: "#/definitions/stringOrStringsRequired" } }, hS), required: ["files"], additionalProperties: false } }, $ref: "#/definitions/objectConfig" }, mS = new Map(), gS = function() {
  var e25 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t2 = new OC(p({ meta: false, useDefaults: true, validateSchema: false, missingRefs: "ignore", verbose: true, schemaId: "auto" }, e25));
  return t2.addMetaSchema(LC), t2._opts.defaultMeta = LC.id, t2;
}(), yS = new WeakMap(), vS = Function.prototype, xS = { ESLINT_LEGACY_ECMAFEATURES: "The 'ecmaFeatures' config file property is deprecated, and has no effect." }, bS = { error: 2, warn: 1, off: 0 };
function ES(e25) {
  if (!e25)
    return null;
  var t2 = e25.schema || e25.meta && e25.meta.schema;
  return Array.isArray(t2) ? t2.length ? { type: "array", items: t2, minItems: 0, maxItems: t2.length } : { type: "array", minItems: 0, maxItems: 0 } : t2 || null;
}
function CS(e25, t2, r2) {
  var n2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  try {
    (function(e26) {
      var t3 = Array.isArray(e26) ? e26[0] : e26, r3 = typeof t3 == "string" ? bS[t3.toLowerCase()] : t3;
      if (r3 === 0 || r3 === 1 || r3 === 2)
        return r3;
      throw new Error("	Severity should be one of the following: 0 = off, 1 = warn, 2 = error (you passed '".concat(BC.inspect(t3).replace(/'/g, '"').replace(/\n/g, ""), "').\n"));
    })(r2) !== 0 && function(e26, t3) {
      if (!yS.has(e26)) {
        var r3 = ES(e26);
        r3 && yS.set(e26, gS.compile(r3));
      }
      var n3 = yS.get(e26);
      if (n3 && (n3(t3), n3.errors))
        throw new Error(n3.errors.map(function(e27) {
          return "	Value ".concat(JSON.stringify(e27.data), " ").concat(e27.message, ".\n");
        }).join(""));
    }(e25, Array.isArray(r2) ? r2.slice(1) : []);
  } catch (e26) {
    var i2 = 'Configuration for rule "'.concat(t2, '" is invalid:\n').concat(e26.message);
    throw typeof n2 == "string" ? new Error("".concat(n2, ":\n	").concat(i2)) : new Error(i2);
  }
}
function SS(e25, t2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : vS;
  e25 && Object.keys(e25).forEach(function(e26) {
    if (!(r2(e26) || qC.get(e26) || null))
      throw new Error("".concat(t2, ':\n	Environment key "').concat(e26, '" is unknown\n'));
  });
}
function kS(e25, t2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : vS;
  e25 && Object.keys(e25).forEach(function(n2) {
    CS(r2(n2) || mS.get(n2) || null, n2, e25[n2], t2);
  });
}
function DS(e25) {
  var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  e25 && Object.entries(e25).forEach(function(e26) {
    var r2 = b(e26, 2), n2 = r2[0], i2 = r2[1];
    try {
      fS.normalizeConfigGlobal(i2);
    } catch (i3) {
      throw new Error("ESLint configuration of global '".concat(n2, "' in ").concat(t2, " is invalid:\n").concat(i3.message));
    }
  });
}
function FS(e25, t2, r2) {
  if (e25 && !r2(e25))
    throw new Error("ESLint configuration of processor in '".concat(t2, "' is invalid: '").concat(e25, "' was not found."));
}
var AS = Fy.lodash.memoize(function(e25, t2) {
  var r2 = PC.relative(process.cwd(), e25), n2 = xS[t2];
  process.emitWarning("".concat(n2, ' (found in "').concat(r2, '")'), "DeprecationWarning", t2);
});
function wS(e25) {
  var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!(MC = MC || gS.compile(dS))(e25))
    throw new Error("ESLint configuration in ".concat(t2, " is invalid:\n").concat(function(e26) {
      return e26.map(function(e27) {
        if (e27.keyword === "additionalProperties") {
          var t3 = e27.dataPath.length ? "".concat(e27.dataPath.slice(1), ".").concat(e27.params.additionalProperty) : e27.params.additionalProperty;
          return 'Unexpected top-level property "'.concat(t3, '"');
        }
        if (e27.keyword === "type") {
          var r2 = e27.dataPath.slice(1), n2 = Array.isArray(e27.schema) ? e27.schema.join("/") : e27.schema, i2 = JSON.stringify(e27.data);
          return 'Property "'.concat(r2, '" is the wrong type (expected ').concat(n2, " but got `").concat(i2, "`)");
        }
        var a2 = e27.dataPath[0] === "." ? e27.dataPath.slice(1) : e27.dataPath;
        return '"'.concat(a2, '" ').concat(e27.message, ". Value: ").concat(JSON.stringify(e27.data));
      }).map(function(e27) {
        return "	- ".concat(e27, ".\n");
      }).join("");
    }(MC.errors)));
  Object.hasOwnProperty.call(e25, "ecmaFeatures") && AS(t2, "ESLINT_LEGACY_ECMAFEATURES");
}
var _S = new WeakSet();
var TS = { getRuleOptionsSchema: ES, validate: function(e25, t2, r2, n2) {
  wS(e25, t2), kS(e25.rules, t2, r2), SS(e25.env, t2, n2), DS(e25.globals, t2);
  var i2 = true, a2 = false, o2 = void 0;
  try {
    for (var s2, u2 = (e25.overrides || [])[Symbol.iterator](); !(i2 = (s2 = u2.next()).done); i2 = true) {
      var c2 = s2.value;
      kS(c2.rules, t2, r2), SS(c2.env, t2, n2), DS(e25.globals, t2);
    }
  } catch (e26) {
    a2 = true, o2 = e26;
  } finally {
    try {
      i2 || u2.return == null || u2.return();
    } finally {
      if (a2)
        throw o2;
    }
  }
}, validateConfigArray: function(e25) {
  var t2 = Map.prototype.get.bind(e25.pluginEnvironments), r2 = Map.prototype.get.bind(e25.pluginProcessors), n2 = Map.prototype.get.bind(e25.pluginRules), i2 = true, a2 = false, o2 = void 0;
  try {
    for (var s2, u2 = e25[Symbol.iterator](); !(i2 = (s2 = u2.next()).done); i2 = true) {
      var c2 = s2.value;
      _S.has(c2) || (_S.add(c2), SS(c2.env, c2.name, t2), DS(c2.globals, c2.name), FS(c2.processor, c2.name, r2), kS(c2.rules, c2.name, n2));
    }
  } catch (e26) {
    a2 = true, o2 = e26;
  } finally {
    try {
      i2 || u2.return == null || u2.return();
    } finally {
      if (a2)
        throw o2;
    }
  }
}, validateConfigSchema: wS, validateRuleOptions: CS }, PS = function() {
  function e25() {
    a(this, e25), this.current = null;
  }
  return s(e25, [{ key: "getOneToken", value: function() {
    return this.moveNext() ? this.current : null;
  } }, { key: "getAllTokens", value: function() {
    for (var e26 = []; this.moveNext(); )
      e26.push(this.current);
    return e26;
  } }, { key: "moveNext", value: function() {
    throw new Error("Not implemented.");
  } }]), e25;
}();
function IS(e25) {
  return e25.range[0];
}
var BS = { search: function(e25, t2) {
  return Fy.lodash.sortedIndexBy(e25, { range: [t2] }, IS);
}, getFirstIndex: function(e25, t2, r2) {
  if (r2 in t2)
    return t2[r2];
  if (r2 - 1 in t2) {
    var n2 = t2[r2 - 1], i2 = 0 <= n2 && n2 < e25.length ? e25[n2] : null;
    return i2 && i2.range[0] >= r2 ? n2 : n2 + 1;
  }
  return 0;
}, getLastIndex: function(e25, t2, r2) {
  if (r2 in t2)
    return t2[r2] - 1;
  if (r2 - 1 in t2) {
    var n2 = t2[r2 - 1], i2 = 0 <= n2 && n2 < e25.length ? e25[n2] : null;
    return i2 && i2.range[1] > r2 ? n2 - 1 : n2;
  }
  return e25.length - 1;
} }, OS = function(e25) {
  function t2(e26, r2, n2, i2, o2) {
    var s2;
    return a(this, t2), (s2 = v(this, h(t2).call(this))).tokens = e26, s2.comments = r2, s2.tokenIndex = BS.getLastIndex(e26, n2, o2), s2.commentIndex = BS.search(r2, o2) - 1, s2.border = i2, s2;
  }
  return f(t2, PS), s(t2, [{ key: "moveNext", value: function() {
    var e26 = 0 <= this.tokenIndex ? this.tokens[this.tokenIndex] : null, t3 = 0 <= this.commentIndex ? this.comments[this.commentIndex] : null;
    return e26 && (!t3 || e26.range[1] > t3.range[1]) ? (this.current = e26, this.tokenIndex -= 1) : t3 ? (this.current = t3, this.commentIndex -= 1) : this.current = null, !!this.current && (this.border === -1 || this.current.range[0] >= this.border);
  } }]), t2;
}(), LS = function(e25) {
  function t2(e26, r2, n2, i2, o2) {
    var s2;
    return a(this, t2), (s2 = v(this, h(t2).call(this))).tokens = e26, s2.index = BS.getLastIndex(e26, n2, o2), s2.indexEnd = BS.getFirstIndex(e26, n2, i2), s2;
  }
  return f(t2, PS), s(t2, [{ key: "moveNext", value: function() {
    return !!(this.index >= this.indexEnd) && (this.current = this.tokens[this.index], this.index -= 1, true);
  } }, { key: "getOneToken", value: function() {
    return this.index >= this.indexEnd ? this.tokens[this.index] : null;
  } }]), t2;
}(), NS = function(e25) {
  function t2(e26) {
    var r2;
    return a(this, t2), (r2 = v(this, h(t2).call(this))).cursor = e26, r2;
  }
  return f(t2, PS), s(t2, [{ key: "moveNext", value: function() {
    var e26 = this.cursor.moveNext();
    return this.current = this.cursor.current, e26;
  } }]), t2;
}(), jS = function(e25) {
  function t2(e26, r2) {
    var n2;
    return a(this, t2), (n2 = v(this, h(t2).call(this, e26))).predicate = r2, n2;
  }
  return f(t2, NS), s(t2, [{ key: "moveNext", value: function() {
    for (var e26 = this.predicate; x(h(t2.prototype), "moveNext", this).call(this); )
      if (e26(this.current))
        return true;
    return false;
  } }]), t2;
}(), RS = function(e25) {
  function t2(e26, r2, n2, i2, o2) {
    var s2;
    return a(this, t2), (s2 = v(this, h(t2).call(this))).tokens = e26, s2.comments = r2, s2.tokenIndex = BS.getFirstIndex(e26, n2, i2), s2.commentIndex = BS.search(r2, i2), s2.border = o2, s2;
  }
  return f(t2, PS), s(t2, [{ key: "moveNext", value: function() {
    var e26 = this.tokenIndex < this.tokens.length ? this.tokens[this.tokenIndex] : null, t3 = this.commentIndex < this.comments.length ? this.comments[this.commentIndex] : null;
    return e26 && (!t3 || e26.range[0] < t3.range[0]) ? (this.current = e26, this.tokenIndex += 1) : t3 ? (this.current = t3, this.commentIndex += 1) : this.current = null, !!this.current && (this.border === -1 || this.current.range[1] <= this.border);
  } }]), t2;
}(), MS = function(e25) {
  function t2(e26, r2, n2, i2, o2) {
    var s2;
    return a(this, t2), (s2 = v(this, h(t2).call(this))).tokens = e26, s2.index = BS.getFirstIndex(e26, n2, i2), s2.indexEnd = BS.getLastIndex(e26, n2, o2), s2;
  }
  return f(t2, PS), s(t2, [{ key: "moveNext", value: function() {
    return !!(this.index <= this.indexEnd) && (this.current = this.tokens[this.index], this.index += 1, true);
  } }, { key: "getOneToken", value: function() {
    return this.index <= this.indexEnd ? this.tokens[this.index] : null;
  } }, { key: "getAllTokens", value: function() {
    return this.tokens.slice(this.index, this.indexEnd + 1);
  } }]), t2;
}(), VS = function(e25) {
  function t2(e26, r2) {
    var n2;
    return a(this, t2), (n2 = v(this, h(t2).call(this, e26))).count = r2, n2;
  }
  return f(t2, NS), s(t2, [{ key: "moveNext", value: function() {
    return !!(0 < this.count) && (this.count -= 1, x(h(t2.prototype), "moveNext", this).call(this));
  } }]), t2;
}(), US = function(e25) {
  function t2(e26, r2) {
    var n2;
    return a(this, t2), (n2 = v(this, h(t2).call(this, e26))).count = r2, n2;
  }
  return f(t2, NS), s(t2, [{ key: "moveNext", value: function() {
    for (; 0 < this.count; )
      if (this.count -= 1, !x(h(t2.prototype), "moveNext", this).call(this))
        return false;
    return x(h(t2.prototype), "moveNext", this).call(this);
  } }]), t2;
}(), qS = function() {
  function e25(t2, r2) {
    a(this, e25), this.TokenCursor = t2, this.TokenCommentCursor = r2;
  }
  return s(e25, [{ key: "createBaseCursor", value: function(e26, t2, r2, n2, i2, a2) {
    return new (a2 ? this.TokenCommentCursor : this.TokenCursor)(e26, t2, r2, n2, i2);
  } }, { key: "createCursor", value: function(e26, t2, r2, n2, i2, a2, o2, s2, u2) {
    var c2 = this.createBaseCursor(e26, t2, r2, n2, i2, a2);
    return o2 && (c2 = new jS(c2, o2)), 1 <= s2 && (c2 = new US(c2, s2)), 0 <= u2 && (c2 = new VS(c2, u2)), c2;
  } }]), e25;
}(), WS = { forward: new qS(MS, RS), backward: new qS(LS, OS) }, $S = function(e25) {
  function t2(e26, r2, n2, i2, o2, s2, u2) {
    var c2;
    return a(this, t2), (c2 = v(this, h(t2).call(this, e26, r2, n2, i2, o2))).index = Math.max(0, c2.index - s2), c2.indexEnd = Math.min(e26.length - 1, c2.indexEnd + u2), c2;
  }
  return f(t2, MS), t2;
}(), GS = Fy.require$$0.isCommentToken, zS = Symbol("tokens"), HS = Symbol("comments"), KS = Symbol("indexMap");
function JS(e25, t2, r2, n2, i2, a2, o2) {
  var s2 = false, u2 = 0, c2 = null;
  return typeof o2 == "number" ? u2 = 0 | o2 : typeof o2 == "function" ? c2 = o2 : o2 && (s2 = !!o2.includeComments, u2 = 0 | o2.skip, c2 = o2.filter || null), NC(0 <= u2, "options.skip should be zero or a positive integer."), NC(!c2 || typeof c2 == "function", "options.filter should be a function."), e25.createCursor(t2, r2, n2, i2, a2, s2, c2, u2, -1);
}
function QS(e25, t2, r2, n2, i2, a2, o2) {
  var s2 = false, u2 = 0, c2 = false, l2 = null;
  return typeof o2 == "number" ? (u2 = 0 | o2, c2 = true) : typeof o2 == "function" ? l2 = o2 : o2 && (s2 = !!o2.includeComments, u2 = 0 | o2.count, c2 = typeof o2.count == "number", l2 = o2.filter || null), NC(0 <= u2, "options.count should be zero or a positive integer."), NC(!l2 || typeof l2 == "function", "options.filter should be a function."), e25.createCursor(t2, r2, n2, i2, a2, s2, l2, 0, c2 ? u2 : -1);
}
function XS(e25, t2, r2, n2, i2, a2, o2) {
  return a2 === void 0 && o2 === void 0 ? new MS(e25, t2, r2, n2, i2) : typeof a2 == "number" || a2 === void 0 ? new $S(e25, t2, r2, n2, i2, 0 | a2, 0 | o2) : QS(WS.forward, e25, t2, r2, n2, i2, a2);
}
function YS(e25) {
  for (var t2 = [], r2 = e25.getOneToken(); r2 && GS(r2); )
    t2.push(r2), r2 = e25.getOneToken();
  return t2;
}
var ZS = function() {
  function e25(t2, r2) {
    a(this, e25), this[zS] = t2, this[HS] = r2, this[KS] = function(e26, t3) {
      for (var r3 = Number.MAX_SAFE_INTEGER, n2 = Object.create(null), i2 = 0, a2 = 0, o2 = 0, s2 = null; i2 < e26.length || a2 < t3.length; ) {
        for (o2 = a2 < t3.length ? t3[a2].range[0] : r3; i2 < e26.length && (s2 = e26[i2].range)[0] < o2; )
          n2[s2[0]] = i2, n2[s2[1] - 1] = i2, i2 += 1;
        for (o2 = i2 < e26.length ? e26[i2].range[0] : r3; a2 < t3.length && (s2 = t3[a2].range)[0] < o2; )
          n2[s2[0]] = i2, n2[s2[1] - 1] = i2, a2 += 1;
      }
      return n2;
    }(t2, r2);
  }
  return s(e25, [{ key: "getTokenByRangeStart", value: function(e26, t2) {
    var r2 = t2 && t2.includeComments, n2 = WS.forward.createBaseCursor(this[zS], this[HS], this[KS], e26, -1, r2).getOneToken();
    return n2 && n2.range[0] === e26 ? n2 : null;
  } }, { key: "getFirstToken", value: function(e26, t2) {
    return JS(WS.forward, this[zS], this[HS], this[KS], e26.range[0], e26.range[1], t2).getOneToken();
  } }, { key: "getLastToken", value: function(e26, t2) {
    return JS(WS.backward, this[zS], this[HS], this[KS], e26.range[0], e26.range[1], t2).getOneToken();
  } }, { key: "getTokenBefore", value: function(e26, t2) {
    return JS(WS.backward, this[zS], this[HS], this[KS], -1, e26.range[0], t2).getOneToken();
  } }, { key: "getTokenAfter", value: function(e26, t2) {
    return JS(WS.forward, this[zS], this[HS], this[KS], e26.range[1], -1, t2).getOneToken();
  } }, { key: "getFirstTokenBetween", value: function(e26, t2, r2) {
    return JS(WS.forward, this[zS], this[HS], this[KS], e26.range[1], t2.range[0], r2).getOneToken();
  } }, { key: "getLastTokenBetween", value: function(e26, t2, r2) {
    return JS(WS.backward, this[zS], this[HS], this[KS], e26.range[1], t2.range[0], r2).getOneToken();
  } }, { key: "getTokenOrCommentBefore", value: function(e26, t2) {
    return this.getTokenBefore(e26, { includeComments: true, skip: t2 });
  } }, { key: "getTokenOrCommentAfter", value: function(e26, t2) {
    return this.getTokenAfter(e26, { includeComments: true, skip: t2 });
  } }, { key: "getFirstTokens", value: function(e26, t2) {
    return QS(WS.forward, this[zS], this[HS], this[KS], e26.range[0], e26.range[1], t2).getAllTokens();
  } }, { key: "getLastTokens", value: function(e26, t2) {
    return QS(WS.backward, this[zS], this[HS], this[KS], e26.range[0], e26.range[1], t2).getAllTokens().reverse();
  } }, { key: "getTokensBefore", value: function(e26, t2) {
    return QS(WS.backward, this[zS], this[HS], this[KS], -1, e26.range[0], t2).getAllTokens().reverse();
  } }, { key: "getTokensAfter", value: function(e26, t2) {
    return QS(WS.forward, this[zS], this[HS], this[KS], e26.range[1], -1, t2).getAllTokens();
  } }, { key: "getFirstTokensBetween", value: function(e26, t2, r2) {
    return QS(WS.forward, this[zS], this[HS], this[KS], e26.range[1], t2.range[0], r2).getAllTokens();
  } }, { key: "getLastTokensBetween", value: function(e26, t2, r2) {
    return QS(WS.backward, this[zS], this[HS], this[KS], e26.range[1], t2.range[0], r2).getAllTokens().reverse();
  } }, { key: "getTokens", value: function(e26, t2, r2) {
    return XS(this[zS], this[HS], this[KS], e26.range[0], e26.range[1], t2, r2).getAllTokens();
  } }, { key: "getTokensBetween", value: function(e26, t2, r2) {
    return XS(this[zS], this[HS], this[KS], e26.range[1], t2.range[0], r2, r2).getAllTokens();
  } }, { key: "commentsExistBetween", value: function(e26, t2) {
    var r2 = BS.search(this[HS], e26.range[1]);
    return r2 < this[HS].length && this[HS][r2].range[1] <= t2.range[0];
  } }, { key: "getCommentsBefore", value: function(e26) {
    return YS(QS(WS.backward, this[zS], this[HS], this[KS], -1, e26.range[0], { includeComments: true })).reverse();
  } }, { key: "getCommentsAfter", value: function(e26) {
    return YS(QS(WS.forward, this[zS], this[HS], this[KS], e26.range[1], -1, { includeComments: true }));
  } }, { key: "getCommentsInside", value: function(e26) {
    return this.getTokens(e26, { includeComments: true, filter: GS });
  } }]), e25;
}(), ek = Fy.require$$0.isCommentToken;
var tk = { SourceCode: function(e25) {
  function t2(e26, r2) {
    var n2, o2, s2, u2, c2, l2;
    a(this, t2), typeof e26 == "string" ? (o2 = e26, s2 = r2) : i(e26) == "object" && e26 !== null && (o2 = e26.text, s2 = e26.ast, u2 = e26.parserServices, c2 = e26.scopeManager, l2 = e26.visitorKeys), function(e27) {
      if (!e27.tokens)
        throw new Error("AST is missing the tokens array.");
      if (!e27.comments)
        throw new Error("AST is missing the comments array.");
      if (!e27.loc)
        throw new Error("AST is missing location information.");
      if (!e27.range)
        throw new Error("AST is missing range information");
    }(s2), (n2 = v(this, h(t2).call(this, s2.tokens, s2.comments))).hasBOM = o2.charCodeAt(0) === 65279, n2.text = n2.hasBOM ? o2.slice(1) : o2, n2.ast = s2, n2.parserServices = u2 || {}, n2.scopeManager = c2 || null, n2.visitorKeys = l2 || Fy.Traverser.DEFAULT_VISITOR_KEYS;
    var p2 = n2.text.match(Fy.require$$0$1.shebangPattern);
    p2 && s2.comments.length && s2.comments[0].value === p2[1] && (s2.comments[0].type = "Shebang"), n2.tokensAndComments = function(e27, t3) {
      for (var r3 = [], n3 = 0, i2 = 0; n3 < e27.length || i2 < t3.length; )
        i2 >= t3.length || n3 < e27.length && e27[n3].range[0] < t3[i2].range[0] ? r3.push(e27[n3++]) : r3.push(t3[i2++]);
      return r3;
    }(s2.tokens, s2.comments), n2.lines = [], n2.lineStartIndices = [0];
    for (var f2, d2 = Fy.require$$0$1.createGlobalLinebreakMatcher(); f2 = d2.exec(n2.text); )
      n2.lines.push(n2.text.slice(n2.lineStartIndices[n2.lineStartIndices.length - 1], f2.index)), n2.lineStartIndices.push(f2.index + f2[0].length);
    return n2.lines.push(n2.text.slice(n2.lineStartIndices[n2.lineStartIndices.length - 1])), n2._commentCache = new WeakMap(), Object.freeze(y(n2)), Object.freeze(n2.lines), n2;
  }
  return f(t2, ZS), s(t2, [{ key: "getText", value: function(e26, t3, r2) {
    return e26 ? this.text.slice(Math.max(e26.range[0] - (t3 || 0), 0), e26.range[1] + (r2 || 0)) : this.text;
  } }, { key: "getLines", value: function() {
    return this.lines;
  } }, { key: "getAllComments", value: function() {
    return this.ast.comments;
  } }, { key: "getComments", value: function(e26) {
    if (this._commentCache.has(e26))
      return this._commentCache.get(e26);
    var t3 = { leading: [], trailing: [] };
    if (e26.type === "Program")
      e26.body.length === 0 && (t3.leading = e26.comments);
    else {
      ((e26.type === "BlockStatement" || e26.type === "ClassBody") && e26.body.length === 0 || e26.type === "ObjectExpression" && e26.properties.length === 0 || e26.type === "ArrayExpression" && e26.elements.length === 0 || e26.type === "SwitchStatement" && e26.cases.length === 0) && (t3.trailing = this.getTokens(e26, { includeComments: true, filter: ek }));
      for (var r2 = this.getTokenBefore(e26, { includeComments: true }); r2 && ek(r2) && !(e26.parent && r2.start < e26.parent.start); )
        t3.leading.push(r2), r2 = this.getTokenBefore(r2, { includeComments: true });
      for (t3.leading.reverse(), r2 = this.getTokenAfter(e26, { includeComments: true }); r2 && ek(r2) && !(e26.parent && r2.end > e26.parent.end); )
        t3.trailing.push(r2), r2 = this.getTokenAfter(r2, { includeComments: true });
    }
    return this._commentCache.set(e26, t3), t3;
  } }, { key: "getJSDocComment", value: function(e26) {
    var t3 = this, r2 = function(e27) {
      var r3 = t3.getTokenBefore(e27, { includeComments: true });
      return r3 && ek(r3) && r3.type === "Block" && r3.value.charAt(0) === "*" && 1 >= e27.loc.start.line - r3.loc.end.line ? r3 : null;
    }, n2 = e26.parent;
    switch (e26.type) {
      case "ClassDeclaration":
      case "FunctionDeclaration":
        return r2(function(e27) {
          return e27.type === "ExportDefaultDeclaration" || e27.type === "ExportNamedDeclaration" || e27.type === "ExportAllDeclaration" || e27.type === "ExportSpecifier";
        }(n2) ? n2 : e26);
      case "ClassExpression":
        return r2(n2.parent);
      case "ArrowFunctionExpression":
      case "FunctionExpression":
        if (n2.type !== "CallExpression" && n2.type !== "NewExpression") {
          for (; !this.getCommentsBefore(n2).length && !/Function/.test(n2.type) && n2.type !== "MethodDefinition" && n2.type !== "Property" && (n2 = n2.parent); )
            ;
          if (n2 && n2.type !== "FunctionDeclaration" && n2.type !== "Program")
            return r2(n2);
        }
        return r2(e26);
      default:
        return null;
    }
  } }, { key: "getNodeByRangeIndex", value: function(e26) {
    var t3 = null;
    return Fy.Traverser.traverse(this.ast, { visitorKeys: this.visitorKeys, enter: function(r2) {
      r2.range[0] <= e26 && e26 < r2.range[1] ? t3 = r2 : this.skip();
    }, leave: function(e27) {
      e27 === t3 && this.break();
    } }), t3;
  } }, { key: "isSpaceBetween", value: function(e26, t3) {
    if (function(e27, t4) {
      return e27.range[0] <= t4.range[0] && e27.range[1] >= t4.range[0] || t4.range[0] <= e27.range[0] && t4.range[1] >= e27.range[0];
    }(e26, t3))
      return false;
    for (var r2 = b(e26.range[1] <= t3.range[0] ? [e26, t3] : [t3, e26], 2), n2 = r2[0], i2 = r2[1], a2 = this.getLastToken(n2) || n2, o2 = this.getFirstToken(i2) || i2, s2 = a2; s2 !== o2; ) {
      var u2 = this.getTokenAfter(s2, { includeComments: true });
      if (s2.range[1] !== u2.range[0])
        return true;
      s2 = u2;
    }
    return false;
  } }, { key: "isSpaceBetweenTokens", value: function() {
    return this.isSpaceBetween.apply(this, arguments);
  } }, { key: "getLocFromIndex", value: function(e26) {
    if (typeof e26 != "number")
      throw new TypeError("Expected `index` to be a number.");
    if (0 > e26 || e26 > this.text.length)
      throw new RangeError("Index out of range (requested index ".concat(e26, ", but source text has length ").concat(this.text.length, ")."));
    if (e26 === this.text.length)
      return { line: this.lines.length, column: this.lines[this.lines.length - 1].length };
    var t3 = Fy.lodash.sortedLastIndex(this.lineStartIndices, e26);
    return { line: t3, column: e26 - this.lineStartIndices[t3 - 1] };
  } }, { key: "getIndexFromLoc", value: function(e26) {
    if (i(e26) != "object" || typeof e26.line != "number" || typeof e26.column != "number")
      throw new TypeError("Expected `loc` to be an object with numeric `line` and `column` properties.");
    if (0 >= e26.line)
      throw new RangeError("Line number out of range (line ".concat(e26.line, " requested). Line numbers should be 1-based."));
    if (e26.line > this.lineStartIndices.length)
      throw new RangeError("Line number out of range (line ".concat(e26.line, " requested, but only ").concat(this.lineStartIndices.length, " lines present)."));
    var t3 = this.lineStartIndices[e26.line - 1], r2 = e26.line === this.lineStartIndices.length ? this.text.length : this.lineStartIndices[e26.line], n2 = t3 + e26.column;
    if (e26.line === this.lineStartIndices.length && n2 > r2 || e26.line < this.lineStartIndices.length && n2 >= r2)
      throw new RangeError("Column number out of range (column ".concat(e26.column, " requested, but the length of line ").concat(e26.line, " is ").concat(r2 - t3, ")."));
    return n2;
  } }], [{ key: "splitLines", value: function(e26) {
    return e26.split(Fy.require$$0$1.createGlobalLinebreakMatcher());
  } }]), t2;
}() }, rk = Fy.require$$1("eslint:code-path");
function nk(e25) {
  return e25.id + (e25.reachable ? "" : "!");
}
var ik = { enabled: rk.enabled, dump: rk, dumpState: rk.enabled ? function(e25, t2, r2) {
  for (var n2 = 0; n2 < t2.currentSegments.length; ++n2) {
    var i2 = t2.currentSegments[n2].internal;
    r2 ? i2.exitNodes.push(e25) : i2.nodes.push(e25);
  }
  rk(["".concat(t2.currentSegments.map(nk).join(","), ")"), "".concat(e25.type).concat(r2 ? ":exit" : "")].join(" "));
} : rk, dumpDot: rk.enabled ? function(e25) {
  var t2 = '\ndigraph {\nnode[shape=box,style="rounded,filled",fillcolor=white];\ninitial[label="",shape=circle,style=filled,fillcolor=black,width=0.25,height=0.25];\n';
  0 < e25.returnedSegments.length && (t2 += 'final[label="",shape=doublecircle,style=filled,fillcolor=black,width=0.25,height=0.25];\n'), 0 < e25.thrownSegments.length && (t2 += 'thrown[label="\u2718",shape=circle,width=0.3,height=0.3,fixedsize];\n');
  var r2 = Object.create(null), n2 = this.makeDotArrows(e25, r2);
  for (var i2 in r2) {
    var a2 = r2[i2];
    t2 += "".concat(i2, "["), t2 += a2.reachable ? 'label="' : 'style="rounded,dashed,filled",fillcolor="#FF9800",label="<<unreachable>>\\n', t2 += 0 < a2.internal.nodes.length || 0 < a2.internal.exitNodes.length ? [].concat(a2.internal.nodes.map(function(e26) {
      switch (e26.type) {
        case "Identifier":
          return "".concat(e26.type, " (").concat(e26.name, ")");
        case "Literal":
          return "".concat(e26.type, " (").concat(e26.value, ")");
        default:
          return e26.type;
      }
    }), a2.internal.exitNodes.map(function(e26) {
      switch (e26.type) {
        case "Identifier":
          return "".concat(e26.type, ":exit (").concat(e26.name, ")");
        case "Literal":
          return "".concat(e26.type, ":exit (").concat(e26.value, ")");
        default:
          return "".concat(e26.type, ":exit");
      }
    })).join("\\n") : "????", t2 += '"];\n';
  }
  t2 += "".concat(n2, "\n"), rk("DOT", t2 += "}");
} : rk, makeDotArrows: function(e25, t2) {
  for (var r2 = [[e25.initialSegment, 0]], n2 = t2 || Object.create(null), i2 = e25.initialSegment.id, a2 = "initial->".concat(e25.initialSegment.id); 0 < r2.length; ) {
    var o2 = r2.pop(), s2 = o2[0], u2 = o2[1];
    if (!n2[s2.id] || u2 !== 0) {
      n2[s2.id] = s2;
      var c2 = s2.allNextSegments[u2];
      c2 && (a2 += i2 === s2.id ? "->".concat(c2.id) : ";\n".concat(s2.id, "->").concat(c2.id), i2 = c2.id, r2.unshift([s2, 1 + u2]), r2.push([c2, 0]));
    }
  }
  return e25.returnedSegments.forEach(function(e26) {
    a2 += i2 === e26.id ? "->final" : ";\n".concat(e26.id, "->final"), i2 = null;
  }), e25.thrownSegments.forEach(function(e26) {
    a2 += i2 === e26.id ? "->thrown" : ";\n".concat(e26.id, "->thrown"), i2 = null;
  }), "".concat(a2, ";");
} };
function ak(e25) {
  return e25.reachable;
}
var ok = function() {
  function e25(t2, r2, n2) {
    a(this, e25), this.id = t2, this.nextSegments = [], this.prevSegments = r2.filter(ak), this.allNextSegments = [], this.allPrevSegments = r2, this.reachable = n2, Object.defineProperty(this, "internal", { value: { used: false, loopedPrevSegments: [] } }), ik.enabled && (this.internal.nodes = [], this.internal.exitNodes = []);
  }
  return s(e25, [{ key: "isLoopedPrevSegment", value: function(e26) {
    return this.internal.loopedPrevSegments.indexOf(e26) !== -1;
  } }], [{ key: "newRoot", value: function(t2) {
    return new e25(t2, [], true);
  } }, { key: "newNext", value: function(t2, r2) {
    return new e25(t2, e25.flattenUnusedSegments(r2), r2.some(ak));
  } }, { key: "newUnreachable", value: function(t2, r2) {
    var n2 = new e25(t2, e25.flattenUnusedSegments(r2), false);
    return e25.markUsed(n2), n2;
  } }, { key: "newDisconnected", value: function(t2, r2) {
    return new e25(t2, [], r2.some(ak));
  } }, { key: "markUsed", value: function(e26) {
    var t2;
    if (!e26.internal.used)
      if (e26.internal.used = true, e26.reachable)
        for (t2 = 0; t2 < e26.allPrevSegments.length; ++t2) {
          var r2 = e26.allPrevSegments[t2];
          r2.allNextSegments.push(e26), r2.nextSegments.push(e26);
        }
      else
        for (t2 = 0; t2 < e26.allPrevSegments.length; ++t2)
          e26.allPrevSegments[t2].allNextSegments.push(e26);
  } }, { key: "markPrevSegmentAsLooped", value: function(e26, t2) {
    e26.internal.loopedPrevSegments.push(t2);
  } }, { key: "flattenUnusedSegments", value: function(e26) {
    for (var t2 = Object.create(null), r2 = [], n2 = 0; n2 < e26.length; ++n2) {
      var i2 = e26[n2];
      if (!t2[i2.id])
        if (i2.internal.used)
          t2[i2.id] = true, r2.push(i2);
        else
          for (var a2 = 0; a2 < i2.allPrevSegments.length; ++a2) {
            var o2 = i2.allPrevSegments[a2];
            t2[o2.id] || (t2[o2.id] = true, r2.push(o2));
          }
    }
    return r2;
  } }]), e25;
}();
function sk(e25) {
  return e25.reachable;
}
function uk(e25, t2, r2, n2) {
  for (var i2 = e25.segmentsList, a2 = 0 <= t2 ? t2 : i2.length + t2, o2 = 0 <= r2 ? r2 : i2.length + r2, s2 = [], u2 = 0; u2 < e25.count; ++u2) {
    for (var c2 = [], l2 = a2; l2 <= o2; ++l2)
      c2.push(i2[l2][u2]);
    s2.push(n2(e25.idGenerator.next(), c2));
  }
  return s2;
}
function ck(e25, t2) {
  for (var r2 = t2; r2.length > e25.count; ) {
    for (var n2 = [], i2 = 0, a2 = 0 | r2.length / 2; i2 < a2; ++i2)
      n2.push(ok.newNext(e25.idGenerator.next(), [r2[i2], r2[i2 + a2]]));
    r2 = n2;
  }
  return r2;
}
var lk = function() {
  function e25(t2, r2, n2) {
    a(this, e25), this.idGenerator = t2, this.upper = r2, this.count = n2, this.segmentsList = [];
  }
  return s(e25, [{ key: "makeNext", value: function(e26, t2) {
    return uk(this, e26, t2, ok.newNext);
  } }, { key: "makeUnreachable", value: function(e26, t2) {
    return uk(this, e26, t2, ok.newUnreachable);
  } }, { key: "makeDisconnected", value: function(e26, t2) {
    return uk(this, e26, t2, ok.newDisconnected);
  } }, { key: "add", value: function(e26) {
    NC(e26.length >= this.count, "".concat(e26.length, " >= ").concat(this.count)), this.segmentsList.push(ck(this, e26));
  } }, { key: "replaceHead", value: function(e26) {
    NC(e26.length >= this.count, "".concat(e26.length, " >= ").concat(this.count)), this.segmentsList.splice(-1, 1, ck(this, e26));
  } }, { key: "addAll", value: function(e26) {
    NC(e26.count === this.count);
    for (var t2 = e26.segmentsList, r2 = 0; r2 < t2.length; ++r2)
      this.segmentsList.push(t2[r2]);
  } }, { key: "clear", value: function() {
    this.segmentsList = [];
  } }, { key: "head", get: function() {
    var e26 = this.segmentsList;
    return e26.length === 0 ? [] : e26[e26.length - 1];
  } }, { key: "empty", get: function() {
    return this.segmentsList.length === 0;
  } }, { key: "reachable", get: function() {
    var e26 = this.head;
    return 0 < e26.length && e26.some(sk);
  } }], [{ key: "newRoot", value: function(t2) {
    var r2 = new e25(t2, null, 1);
    return r2.add([ok.newRoot(t2.next())]), r2;
  } }, { key: "newEmpty", value: function(t2, r2) {
    return new e25(t2.idGenerator, t2, (r2 ? 2 : 1) * t2.count);
  } }]), e25;
}();
function pk(e25, t2, r2, n2) {
  for (var i2 = 0; i2 < n2.length; ++i2) {
    var a2 = n2[i2];
    e25.push(a2), t2.indexOf(a2) === -1 && r2.push(a2);
  }
}
function fk(e25) {
  for (var t2 = e25.tryContext; t2; ) {
    if (t2.hasFinalizer && t2.position !== "finally")
      return t2;
    t2 = t2.upper;
  }
  return e25;
}
function hk(e25) {
  for (var t2 = e25.tryContext; t2; ) {
    if (t2.position === "try" || t2.hasFinalizer && t2.position === "catch")
      return t2;
    t2 = t2.upper;
  }
  return e25;
}
function dk(e25, t2) {
  e25.splice(e25.indexOf(t2), 1);
}
function mk(e25, t2, r2) {
  for (var n2 = ok.flattenUnusedSegments(t2), i2 = ok.flattenUnusedSegments(r2), a2 = Math.min(n2.length, i2.length), o2 = 0; o2 < a2; ++o2) {
    var s2 = n2[o2], u2 = i2[o2];
    u2.reachable && s2.nextSegments.push(u2), s2.reachable && u2.prevSegments.push(s2), s2.allNextSegments.push(u2), u2.allPrevSegments.push(s2), 2 <= u2.allPrevSegments.length && ok.markPrevSegmentAsLooped(u2, s2), e25.notifyLooped(s2, u2);
  }
}
function gk(e25, t2, r2) {
  t2.processed || (t2.trueForkContext.add(r2), t2.falseForkContext.add(r2)), e25.test !== true && e25.brokenForkContext.addAll(t2.falseForkContext), e25.endOfTestSegments = t2.trueForkContext.makeNext(0, -1);
}
var yk = function() {
  function e25(t2, r2) {
    a(this, e25), this.idGenerator = t2, this.notifyLooped = r2, this.forkContext = lk.newRoot(t2), this.choiceContext = null, this.switchContext = null, this.tryContext = null, this.loopContext = null, this.breakContext = null, this.currentSegments = [], this.initialSegment = this.forkContext.head[0];
    var n2 = this.finalSegments = [], i2 = this.returnedForkContext = [], o2 = this.thrownForkContext = [];
    i2.add = pk.bind(null, i2, o2, n2), o2.add = pk.bind(null, o2, i2, n2);
  }
  return s(e25, [{ key: "pushForkContext", value: function(e26) {
    return this.forkContext = lk.newEmpty(this.forkContext, e26), this.forkContext;
  } }, { key: "popForkContext", value: function() {
    var e26 = this.forkContext;
    return this.forkContext = e26.upper, this.forkContext.replaceHead(e26.makeNext(0, -1)), e26;
  } }, { key: "forkPath", value: function() {
    this.forkContext.add(this.parentForkContext.makeNext(-1, -1));
  } }, { key: "forkBypassPath", value: function() {
    this.forkContext.add(this.parentForkContext.head);
  } }, { key: "pushChoiceContext", value: function(e26, t2) {
    this.choiceContext = { upper: this.choiceContext, kind: e26, isForkingAsResult: t2, trueForkContext: lk.newEmpty(this.forkContext), falseForkContext: lk.newEmpty(this.forkContext), processed: false };
  } }, { key: "popChoiceContext", value: function() {
    var e26 = this.choiceContext;
    this.choiceContext = e26.upper;
    var t2 = this.forkContext, r2 = t2.head;
    switch (e26.kind) {
      case "&&":
      case "||":
        if (e26.processed || (e26.trueForkContext.add(r2), e26.falseForkContext.add(r2)), e26.isForkingAsResult) {
          var n2 = this.choiceContext;
          return n2.trueForkContext.addAll(e26.trueForkContext), n2.falseForkContext.addAll(e26.falseForkContext), n2.processed = true, e26;
        }
        break;
      case "test":
        e26.processed ? (e26.falseForkContext.clear(), e26.falseForkContext.add(r2)) : (e26.trueForkContext.clear(), e26.trueForkContext.add(r2));
        break;
      case "loop":
        return e26;
      default:
        throw new Error("unreachable");
    }
    var i2 = e26.trueForkContext;
    return i2.addAll(e26.falseForkContext), t2.replaceHead(i2.makeNext(0, -1)), e26;
  } }, { key: "makeLogicalRight", value: function() {
    var e26 = this.choiceContext, t2 = this.forkContext;
    if (e26.processed) {
      var r2 = e26.kind === "&&" ? e26.trueForkContext : e26.falseForkContext;
      t2.replaceHead(r2.makeNext(0, -1)), r2.clear(), e26.processed = false;
    } else
      e26.kind === "&&" ? e26.falseForkContext.add(t2.head) : e26.trueForkContext.add(t2.head), t2.replaceHead(t2.makeNext(-1, -1));
  } }, { key: "makeIfConsequent", value: function() {
    var e26 = this.choiceContext, t2 = this.forkContext;
    e26.processed || (e26.trueForkContext.add(t2.head), e26.falseForkContext.add(t2.head)), e26.processed = false, t2.replaceHead(e26.trueForkContext.makeNext(0, -1));
  } }, { key: "makeIfAlternate", value: function() {
    var e26 = this.choiceContext, t2 = this.forkContext;
    e26.trueForkContext.clear(), e26.trueForkContext.add(t2.head), e26.processed = true, t2.replaceHead(e26.falseForkContext.makeNext(0, -1));
  } }, { key: "pushSwitchContext", value: function(e26, t2) {
    this.switchContext = { upper: this.switchContext, hasCase: e26, defaultSegments: null, defaultBodySegments: null, foundDefault: false, lastIsDefault: false, countForks: 0 }, this.pushBreakContext(true, t2);
  } }, { key: "popSwitchContext", value: function() {
    var e26 = this.switchContext;
    this.switchContext = e26.upper;
    var t2 = this.forkContext, r2 = this.popBreakContext().brokenForkContext;
    if (e26.countForks !== 0) {
      var n2 = t2.head;
      this.forkBypassPath();
      var i2 = t2.head;
      r2.add(n2), e26.lastIsDefault || (e26.defaultBodySegments ? (function(e27, t3) {
        for (var r3 = 0; r3 < e27.length; ++r3) {
          var n3 = e27[r3], i3 = t3[r3];
          dk(n3.nextSegments, i3), dk(n3.allNextSegments, i3), dk(i3.prevSegments, n3), dk(i3.allPrevSegments, n3);
        }
      }(e26.defaultSegments, e26.defaultBodySegments), mk(this, i2, e26.defaultBodySegments)) : r2.add(i2));
      for (var a2 = 0; a2 < e26.countForks; ++a2)
        this.forkContext = this.forkContext.upper;
      this.forkContext.replaceHead(r2.makeNext(0, -1));
    } else
      r2.empty || (r2.add(t2.makeNext(-1, -1)), t2.replaceHead(r2.makeNext(0, -1)));
  } }, { key: "makeSwitchCaseBody", value: function(e26, t2) {
    var r2 = this.switchContext;
    if (r2.hasCase) {
      var n2 = this.forkContext, i2 = this.pushForkContext();
      i2.add(n2.makeNext(0, -1)), t2 ? (r2.defaultSegments = n2.head, e26 ? r2.foundDefault = true : r2.defaultBodySegments = i2.head) : !e26 && r2.foundDefault && (r2.foundDefault = false, r2.defaultBodySegments = i2.head), r2.lastIsDefault = t2, r2.countForks += 1;
    }
  } }, { key: "pushTryContext", value: function(e26) {
    this.tryContext = { upper: this.tryContext, position: "try", hasFinalizer: e26, returnedForkContext: e26 ? lk.newEmpty(this.forkContext) : null, thrownForkContext: lk.newEmpty(this.forkContext), lastOfTryIsReachable: false, lastOfCatchIsReachable: false };
  } }, { key: "popTryContext", value: function() {
    var e26 = this.tryContext;
    if (this.tryContext = e26.upper, e26.position !== "catch") {
      var t2 = e26.returnedForkContext, r2 = e26.thrownForkContext;
      if (!t2.empty || !r2.empty) {
        var n2 = this.forkContext.head;
        this.forkContext = this.forkContext.upper;
        var i2 = n2.slice(0, 0 | n2.length / 2), a2 = n2.slice(0 | n2.length / 2);
        t2.empty || fk(this).returnedForkContext.add(a2), r2.empty || hk(this).thrownForkContext.add(a2), this.forkContext.replaceHead(i2), e26.lastOfTryIsReachable || e26.lastOfCatchIsReachable || this.forkContext.makeUnreachable();
      }
    } else
      this.popForkContext();
  } }, { key: "makeCatchBlock", value: function() {
    var e26 = this.tryContext, t2 = this.forkContext, r2 = e26.thrownForkContext;
    e26.position = "catch", e26.thrownForkContext = lk.newEmpty(t2), e26.lastOfTryIsReachable = t2.reachable, r2.add(t2.head);
    var n2 = r2.makeNext(0, -1);
    this.pushForkContext(), this.forkBypassPath(), this.forkContext.add(n2);
  } }, { key: "makeFinallyBlock", value: function() {
    var e26 = this.tryContext, t2 = this.forkContext, r2 = e26.returnedForkContext, n2 = e26.thrownForkContext, i2 = t2.head;
    if (e26.position === "catch" ? (this.popForkContext(), t2 = this.forkContext, e26.lastOfCatchIsReachable = t2.reachable) : e26.lastOfTryIsReachable = t2.reachable, e26.position = "finally", !r2.empty || !n2.empty) {
      for (var a2 = t2.makeNext(-1, -1), o2 = 0; o2 < t2.count; ++o2) {
        for (var s2 = [i2[o2]], u2 = 0; u2 < r2.segmentsList.length; ++u2)
          s2.push(r2.segmentsList[u2][o2]);
        for (var c2 = 0; c2 < n2.segmentsList.length; ++c2)
          s2.push(n2.segmentsList[c2][o2]);
        a2.push(ok.newNext(this.idGenerator.next(), s2));
      }
      this.pushForkContext(true), this.forkContext.add(a2);
    }
  } }, { key: "makeFirstThrowablePathInTryBlock", value: function() {
    var e26 = this.forkContext;
    if (e26.reachable) {
      var t2 = hk(this);
      t2 !== this && t2.position === "try" && t2.thrownForkContext.empty && (t2.thrownForkContext.add(e26.head), e26.replaceHead(e26.makeNext(-1, -1)));
    }
  } }, { key: "pushLoopContext", value: function(e26, t2) {
    var r2 = this.forkContext, n2 = this.pushBreakContext(true, t2);
    switch (e26) {
      case "WhileStatement":
        this.pushChoiceContext("loop", false), this.loopContext = { upper: this.loopContext, type: e26, label: t2, test: void 0, continueDestSegments: null, brokenForkContext: n2.brokenForkContext };
        break;
      case "DoWhileStatement":
        this.pushChoiceContext("loop", false), this.loopContext = { upper: this.loopContext, type: e26, label: t2, test: void 0, entrySegments: null, continueForkContext: lk.newEmpty(r2), brokenForkContext: n2.brokenForkContext };
        break;
      case "ForStatement":
        this.pushChoiceContext("loop", false), this.loopContext = { upper: this.loopContext, type: e26, label: t2, test: void 0, endOfInitSegments: null, testSegments: null, endOfTestSegments: null, updateSegments: null, endOfUpdateSegments: null, continueDestSegments: null, brokenForkContext: n2.brokenForkContext };
        break;
      case "ForInStatement":
      case "ForOfStatement":
        this.loopContext = { upper: this.loopContext, type: e26, label: t2, prevSegments: null, leftSegments: null, endOfLeftSegments: null, continueDestSegments: null, brokenForkContext: n2.brokenForkContext };
        break;
      default:
        throw new Error('unknown type: "'.concat(e26, '"'));
    }
  } }, { key: "popLoopContext", value: function() {
    var e26 = this.loopContext;
    this.loopContext = e26.upper;
    var t2 = this.forkContext, r2 = this.popBreakContext().brokenForkContext;
    switch (e26.type) {
      case "WhileStatement":
      case "ForStatement":
        this.popChoiceContext(), mk(this, t2.head, e26.continueDestSegments);
        break;
      case "DoWhileStatement":
        var n2 = this.popChoiceContext();
        n2.processed || (n2.trueForkContext.add(t2.head), n2.falseForkContext.add(t2.head)), e26.test !== true && r2.addAll(n2.falseForkContext);
        for (var i2 = n2.trueForkContext.segmentsList, a2 = 0; a2 < i2.length; ++a2)
          mk(this, i2[a2], e26.entrySegments);
        break;
      case "ForInStatement":
      case "ForOfStatement":
        r2.add(t2.head), mk(this, t2.head, e26.leftSegments);
        break;
      default:
        throw new Error("unreachable");
    }
    r2.empty ? t2.replaceHead(t2.makeUnreachable(-1, -1)) : t2.replaceHead(r2.makeNext(0, -1));
  } }, { key: "makeWhileTest", value: function(e26) {
    var t2 = this.loopContext, r2 = this.forkContext, n2 = r2.makeNext(0, -1);
    t2.test = e26, t2.continueDestSegments = n2, r2.replaceHead(n2);
  } }, { key: "makeWhileBody", value: function() {
    var e26 = this.loopContext, t2 = this.choiceContext, r2 = this.forkContext;
    t2.processed || (t2.trueForkContext.add(r2.head), t2.falseForkContext.add(r2.head)), e26.test !== true && e26.brokenForkContext.addAll(t2.falseForkContext), r2.replaceHead(t2.trueForkContext.makeNext(0, -1));
  } }, { key: "makeDoWhileBody", value: function() {
    var e26 = this.loopContext, t2 = this.forkContext, r2 = t2.makeNext(-1, -1);
    e26.entrySegments = r2, t2.replaceHead(r2);
  } }, { key: "makeDoWhileTest", value: function(e26) {
    var t2 = this.loopContext, r2 = this.forkContext;
    if (t2.test = e26, !t2.continueForkContext.empty) {
      t2.continueForkContext.add(r2.head);
      var n2 = t2.continueForkContext.makeNext(0, -1);
      r2.replaceHead(n2);
    }
  } }, { key: "makeForTest", value: function(e26) {
    var t2 = this.loopContext, r2 = this.forkContext, n2 = r2.head, i2 = r2.makeNext(-1, -1);
    t2.test = e26, t2.endOfInitSegments = n2, t2.continueDestSegments = t2.testSegments = i2, r2.replaceHead(i2);
  } }, { key: "makeForUpdate", value: function() {
    var e26 = this.loopContext, t2 = this.choiceContext, r2 = this.forkContext;
    e26.testSegments ? gk(e26, t2, r2.head) : e26.endOfInitSegments = r2.head;
    var n2 = r2.makeDisconnected(-1, -1);
    e26.continueDestSegments = e26.updateSegments = n2, r2.replaceHead(n2);
  } }, { key: "makeForBody", value: function() {
    var e26 = this.loopContext, t2 = this.choiceContext, r2 = this.forkContext;
    e26.updateSegments ? (e26.endOfUpdateSegments = r2.head, e26.testSegments && mk(this, e26.endOfUpdateSegments, e26.testSegments)) : e26.testSegments ? gk(e26, t2, r2.head) : e26.endOfInitSegments = r2.head;
    var n2 = e26.endOfTestSegments;
    if (!n2) {
      var i2 = lk.newEmpty(r2);
      i2.add(e26.endOfInitSegments), e26.endOfUpdateSegments && i2.add(e26.endOfUpdateSegments), n2 = i2.makeNext(0, -1);
    }
    e26.continueDestSegments = e26.continueDestSegments || n2, r2.replaceHead(n2);
  } }, { key: "makeForInOfLeft", value: function() {
    var e26 = this.loopContext, t2 = this.forkContext, r2 = t2.makeDisconnected(-1, -1);
    e26.prevSegments = t2.head, e26.leftSegments = e26.continueDestSegments = r2, t2.replaceHead(r2);
  } }, { key: "makeForInOfRight", value: function() {
    var e26 = this.loopContext, t2 = this.forkContext, r2 = lk.newEmpty(t2);
    r2.add(e26.prevSegments);
    var n2 = r2.makeNext(-1, -1);
    e26.endOfLeftSegments = t2.head, t2.replaceHead(n2);
  } }, { key: "makeForInOfBody", value: function() {
    var e26 = this.loopContext, t2 = this.forkContext, r2 = lk.newEmpty(t2);
    r2.add(e26.endOfLeftSegments);
    var n2 = r2.makeNext(-1, -1);
    mk(this, t2.head, e26.leftSegments), e26.brokenForkContext.add(t2.head), t2.replaceHead(n2);
  } }, { key: "pushBreakContext", value: function(e26, t2) {
    return this.breakContext = { upper: this.breakContext, breakable: e26, label: t2, brokenForkContext: lk.newEmpty(this.forkContext) }, this.breakContext;
  } }, { key: "popBreakContext", value: function() {
    var e26 = this.breakContext, t2 = this.forkContext;
    if (this.breakContext = e26.upper, !e26.breakable) {
      var r2 = e26.brokenForkContext;
      r2.empty || (r2.add(t2.head), t2.replaceHead(r2.makeNext(0, -1)));
    }
    return e26;
  } }, { key: "makeBreak", value: function(e26) {
    var t2 = this.forkContext;
    if (t2.reachable) {
      var r2 = function(e27, t3) {
        for (var r3 = e27.breakContext; r3; ) {
          if (t3 ? r3.label === t3 : r3.breakable)
            return r3;
          r3 = r3.upper;
        }
        return null;
      }(this, e26);
      r2 && r2.brokenForkContext.add(t2.head), t2.replaceHead(t2.makeUnreachable(-1, -1));
    }
  } }, { key: "makeContinue", value: function(e26) {
    var t2 = this.forkContext;
    if (t2.reachable) {
      var r2 = function(e27, t3) {
        if (!t3)
          return e27.loopContext;
        for (var r3 = e27.loopContext; r3; ) {
          if (r3.label === t3)
            return r3;
          r3 = r3.upper;
        }
        return null;
      }(this, e26);
      r2 && (r2.continueDestSegments ? (mk(this, t2.head, r2.continueDestSegments), (r2.type === "ForInStatement" || r2.type === "ForOfStatement") && r2.brokenForkContext.add(t2.head)) : r2.continueForkContext.add(t2.head)), t2.replaceHead(t2.makeUnreachable(-1, -1));
    }
  } }, { key: "makeReturn", value: function() {
    var e26 = this.forkContext;
    e26.reachable && (fk(this).returnedForkContext.add(e26.head), e26.replaceHead(e26.makeUnreachable(-1, -1)));
  } }, { key: "makeThrow", value: function() {
    var e26 = this.forkContext;
    e26.reachable && (hk(this).thrownForkContext.add(e26.head), e26.replaceHead(e26.makeUnreachable(-1, -1)));
  } }, { key: "makeFinal", value: function() {
    var e26 = this.currentSegments;
    0 < e26.length && e26[0].reachable && this.returnedForkContext.add(e26);
  } }, { key: "headSegments", get: function() {
    return this.forkContext.head;
  } }, { key: "parentForkContext", get: function() {
    var e26 = this.forkContext;
    return e26 && e26.upper;
  } }]), e25;
}(), vk = function() {
  function e25(t2) {
    a(this, e25), this.prefix = t2 + "", this.n = 0;
  }
  return s(e25, [{ key: "next", value: function() {
    return this.n = 0 | 1 + this.n, 0 > this.n && (this.n = 1), this.prefix + this.n;
  } }]), e25;
}(), xk = function() {
  function e25(t2, r2, n2) {
    a(this, e25), this.id = t2, this.upper = r2, this.childCodePaths = [], Object.defineProperty(this, "internal", { value: new yk(new vk("".concat(t2, "_")), n2) }), r2 && r2.childCodePaths.push(this);
  }
  return s(e25, [{ key: "traverseSegments", value: function(e26, t2) {
    function r2(e27) {
      return p2[e27.id] || l2.isLoopedPrevSegment(e27);
    }
    var n2, i2;
    typeof e26 == "function" ? (i2 = e26, n2 = {}) : (n2 = e26 || {}, i2 = t2);
    for (var a2 = n2.first || this.internal.initialSegment, o2 = n2.last, s2 = null, u2 = 0, c2 = 0, l2 = null, p2 = Object.create(null), f2 = [[a2, 0]], h2 = null, d2 = false, m2 = { skip: function() {
      1 >= f2.length ? d2 = true : h2 = f2[f2.length - 2][0];
    }, break: function() {
      d2 = true;
    } }; 0 < f2.length; ) {
      if (s2 = f2[f2.length - 1], l2 = s2[0], (u2 = s2[1]) === 0) {
        if (p2[l2.id]) {
          f2.pop();
          continue;
        }
        if (l2 !== a2 && 0 < l2.prevSegments.length && !l2.prevSegments.every(r2)) {
          f2.pop();
          continue;
        }
        if (h2 && l2.prevSegments.indexOf(h2) !== -1 && (h2 = null), p2[l2.id] = true, !h2 && (i2.call(this, l2, m2), l2 === o2 && m2.skip(), d2))
          break;
      }
      u2 < (c2 = l2.nextSegments.length - 1) ? (s2[1] += 1, f2.push([l2.nextSegments[u2], 0])) : u2 === c2 ? (s2[0] = l2.nextSegments[u2], s2[1] = 0) : f2.pop();
    }
  } }, { key: "initialSegment", get: function() {
    return this.internal.initialSegment;
  } }, { key: "finalSegments", get: function() {
    return this.internal.finalSegments;
  } }, { key: "returnedSegments", get: function() {
    return this.internal.returnedForkContext;
  } }, { key: "thrownSegments", get: function() {
    return this.internal.thrownForkContext;
  } }, { key: "currentSegments", get: function() {
    return this.internal.currentSegments;
  } }], [{ key: "getState", value: function(e26) {
    return e26.internal;
  } }]), e25;
}(), bk = Fy.require$$0$1.breakableTypePattern;
function Ek(e25) {
  return !!e25.test;
}
function Ck(e25) {
  return e25 === "&&" || e25 === "||";
}
function Sk(e25) {
  return e25.parent.type === "LabeledStatement" ? e25.parent.label.name : null;
}
function kk(e25) {
  return e25.type === "Literal" ? !!e25.value : void 0;
}
function Dk(e25, t2) {
  var r2, n2, i2, a2 = e25.codePath, o2 = xk.getState(a2), s2 = o2.currentSegments, u2 = o2.headSegments, c2 = Math.max(s2.length, u2.length);
  for (r2 = 0; r2 < c2; ++r2)
    (n2 = s2[r2]) !== (i2 = u2[r2]) && n2 && (ik.dump("onCodePathSegmentEnd ".concat(n2.id)), n2.reachable && e25.emitter.emit("onCodePathSegmentEnd", n2, t2));
  for (o2.currentSegments = u2, r2 = 0; r2 < c2; ++r2)
    (n2 = s2[r2]) !== (i2 = u2[r2]) && i2 && (ik.dump("onCodePathSegmentStart ".concat(i2.id)), ok.markUsed(i2), i2.reachable && e25.emitter.emit("onCodePathSegmentStart", i2, t2));
}
function Fk(e25, t2) {
  var r2 = e25.codePath, n2 = r2 && xk.getState(r2), i2 = t2.parent;
  switch (t2.type) {
    case "Program":
    case "FunctionDeclaration":
    case "FunctionExpression":
    case "ArrowFunctionExpression":
      r2 && (Dk(e25, t2), ik.dumpState(t2, n2, false)), r2 = e25.codePath = new xk(e25.idGenerator.next(), r2, e25.onLooped), n2 = xk.getState(r2), ik.dump("onCodePathStart ".concat(r2.id)), e25.emitter.emit("onCodePathStart", r2, t2);
      break;
    case "LogicalExpression":
      Ck(t2.operator) && n2.pushChoiceContext(t2.operator, function(e26) {
        var t3 = e26.parent;
        switch (t3.type) {
          case "ConditionalExpression":
          case "IfStatement":
          case "WhileStatement":
          case "DoWhileStatement":
          case "ForStatement":
            return t3.test === e26;
          case "LogicalExpression":
            return Ck(t3.operator);
          default:
            return false;
        }
      }(t2));
      break;
    case "ConditionalExpression":
    case "IfStatement":
      n2.pushChoiceContext("test", false);
      break;
    case "SwitchStatement":
      n2.pushSwitchContext(t2.cases.some(Ek), Sk(t2));
      break;
    case "TryStatement":
      n2.pushTryContext(!!t2.finalizer);
      break;
    case "SwitchCase":
      i2.discriminant !== t2 && i2.cases[0] !== t2 && n2.forkPath();
      break;
    case "WhileStatement":
    case "DoWhileStatement":
    case "ForStatement":
    case "ForInStatement":
    case "ForOfStatement":
      n2.pushLoopContext(t2.type, Sk(t2));
      break;
    case "LabeledStatement":
      bk.test(t2.body.type) || n2.pushBreakContext(false, t2.label.name);
  }
  Dk(e25, t2), ik.dumpState(t2, n2, false);
}
function Ak(e25, t2) {
  switch (t2.type) {
    case "Program":
    case "FunctionDeclaration":
    case "FunctionExpression":
    case "ArrowFunctionExpression":
      var r2 = e25.codePath;
      xk.getState(r2).makeFinal(), function(e26, t3) {
        for (var r3 = xk.getState(e26.codePath), n2 = r3.currentSegments, i2 = 0; i2 < n2.length; ++i2) {
          var a2 = n2[i2];
          ik.dump("onCodePathSegmentEnd ".concat(a2.id)), a2.reachable && e26.emitter.emit("onCodePathSegmentEnd", a2, t3);
        }
        r3.currentSegments = [];
      }(e25, t2), ik.dump("onCodePathEnd ".concat(r2.id)), e25.emitter.emit("onCodePathEnd", r2, t2), ik.dumpDot(r2), (r2 = e25.codePath = e25.codePath.upper) && ik.dumpState(t2, xk.getState(r2), true);
  }
}
var wk = function() {
  function e25(t2) {
    a(this, e25), this.original = t2, this.emitter = t2.emitter, this.codePath = null, this.idGenerator = new vk("s"), this.currentNode = null, this.onLooped = this.onLooped.bind(this);
  }
  return s(e25, [{ key: "enterNode", value: function(e26) {
    this.currentNode = e26, e26.parent && function(e27, t2) {
      var r2 = e27.codePath, n2 = xk.getState(r2), i2 = t2.parent;
      switch (i2.type) {
        case "LogicalExpression":
          i2.right === t2 && Ck(i2.operator) && n2.makeLogicalRight();
          break;
        case "ConditionalExpression":
        case "IfStatement":
          i2.consequent === t2 ? n2.makeIfConsequent() : i2.alternate === t2 && n2.makeIfAlternate();
          break;
        case "SwitchCase":
          i2.consequent[0] === t2 && n2.makeSwitchCaseBody(false, !i2.test);
          break;
        case "TryStatement":
          i2.handler === t2 ? n2.makeCatchBlock() : i2.finalizer === t2 && n2.makeFinallyBlock();
          break;
        case "WhileStatement":
          i2.test === t2 ? n2.makeWhileTest(kk(t2)) : (NC(i2.body === t2), n2.makeWhileBody());
          break;
        case "DoWhileStatement":
          i2.body === t2 ? n2.makeDoWhileBody() : (NC(i2.test === t2), n2.makeDoWhileTest(kk(t2)));
          break;
        case "ForStatement":
          i2.test === t2 ? n2.makeForTest(kk(t2)) : i2.update === t2 ? n2.makeForUpdate() : i2.body === t2 && n2.makeForBody();
          break;
        case "ForInStatement":
        case "ForOfStatement":
          i2.left === t2 ? n2.makeForInOfLeft() : i2.right === t2 ? n2.makeForInOfRight() : (NC(i2.body === t2), n2.makeForInOfBody());
          break;
        case "AssignmentPattern":
          i2.right === t2 && (n2.pushForkContext(), n2.forkBypassPath(), n2.forkPath());
      }
    }(this, e26), Fk(this, e26), this.original.enterNode(e26), this.currentNode = null;
  } }, { key: "leaveNode", value: function(e26) {
    this.currentNode = e26, function(e27, t2) {
      var r2 = e27.codePath, n2 = xk.getState(r2), i2 = false;
      switch (t2.type) {
        case "IfStatement":
        case "ConditionalExpression":
          n2.popChoiceContext();
          break;
        case "LogicalExpression":
          Ck(t2.operator) && n2.popChoiceContext();
          break;
        case "SwitchStatement":
          n2.popSwitchContext();
          break;
        case "SwitchCase":
          t2.consequent.length === 0 && n2.makeSwitchCaseBody(true, !t2.test), n2.forkContext.reachable && (i2 = true);
          break;
        case "TryStatement":
          n2.popTryContext();
          break;
        case "BreakStatement":
          Dk(e27, t2), n2.makeBreak(t2.label && t2.label.name), i2 = true;
          break;
        case "ContinueStatement":
          Dk(e27, t2), n2.makeContinue(t2.label && t2.label.name), i2 = true;
          break;
        case "ReturnStatement":
          Dk(e27, t2), n2.makeReturn(), i2 = true;
          break;
        case "ThrowStatement":
          Dk(e27, t2), n2.makeThrow(), i2 = true;
          break;
        case "Identifier":
          (function(e28) {
            var t3 = e28.parent;
            switch (t3.type) {
              case "LabeledStatement":
              case "BreakStatement":
              case "ContinueStatement":
              case "ArrayPattern":
              case "RestElement":
              case "ImportSpecifier":
              case "ImportDefaultSpecifier":
              case "ImportNamespaceSpecifier":
              case "CatchClause":
                return false;
              case "FunctionDeclaration":
              case "FunctionExpression":
              case "ArrowFunctionExpression":
              case "ClassDeclaration":
              case "ClassExpression":
              case "VariableDeclarator":
                return t3.id !== e28;
              case "Property":
              case "MethodDefinition":
                return t3.key !== e28 || t3.computed || t3.shorthand;
              case "AssignmentPattern":
                return t3.key !== e28;
              default:
                return true;
            }
          })(t2) && (n2.makeFirstThrowablePathInTryBlock(), i2 = true);
          break;
        case "CallExpression":
        case "ImportExpression":
        case "MemberExpression":
        case "NewExpression":
          n2.makeFirstThrowablePathInTryBlock();
          break;
        case "WhileStatement":
        case "DoWhileStatement":
        case "ForStatement":
        case "ForInStatement":
        case "ForOfStatement":
          n2.popLoopContext();
          break;
        case "AssignmentPattern":
          n2.popForkContext();
          break;
        case "LabeledStatement":
          bk.test(t2.body.type) || n2.popBreakContext();
      }
      i2 || Dk(e27, t2), ik.dumpState(t2, n2, true);
    }(this, e26), this.original.leaveNode(e26), Ak(this, e26), this.currentNode = null;
  } }, { key: "onLooped", value: function(e26, t2) {
    e26.reachable && t2.reachable && (ik.dump("onCodePathSegmentLoop ".concat(e26.id, " -> ").concat(t2.id)), this.emitter.emit("onCodePathSegmentLoop", e26, t2, this.currentNode));
  } }]), e25;
}();
function _k(e25, t2) {
  return e25.line - t2.line || e25.column - t2.column;
}
function Tk(e25) {
  var t2 = [], r2 = 0, n2 = null, i2 = new Map(), a2 = new Set(), o2 = new Set(), s2 = true, u2 = false, c2 = void 0;
  try {
    for (var l2, p2 = e25.problems[Symbol.iterator](); !(s2 = (l2 = p2.next()).done); s2 = true) {
      for (var f2 = l2.value; r2 < e25.directives.length && 0 >= _k(e25.directives[r2], f2); ) {
        var h2 = e25.directives[r2++];
        switch (h2.type) {
          case "disable":
            h2.ruleId === null ? (n2 = h2, i2.clear(), a2.clear()) : n2 ? (a2.delete(h2.ruleId), i2.set(h2.ruleId, h2)) : i2.set(h2.ruleId, h2);
            break;
          case "enable":
            h2.ruleId === null ? (n2 = null, i2.clear()) : n2 ? (a2.add(h2.ruleId), i2.delete(h2.ruleId)) : i2.delete(h2.ruleId);
        }
      }
      i2.has(f2.ruleId) ? o2.add(i2.get(f2.ruleId)) : n2 && !a2.has(f2.ruleId) ? o2.add(n2) : t2.push(f2);
    }
  } catch (e26) {
    u2 = true, c2 = e26;
  } finally {
    try {
      s2 || p2.return == null || p2.return();
    } finally {
      if (u2)
        throw c2;
    }
  }
  return { problems: t2, unusedDisableDirectives: e25.directives.filter(function(e26) {
    return e26.type === "disable" && !o2.has(e26);
  }).map(function(t3) {
    return { ruleId: null, message: t3.ruleId ? "Unused eslint-disable directive (no problems were reported from '".concat(t3.ruleId, "').") : "Unused eslint-disable directive (no problems were reported).", line: t3.unprocessedDirective.line, column: t3.unprocessedDirective.column, severity: e25.reportUnusedDisableDirectives === "warn" ? 1 : 2, nodeType: null };
  }) };
}
var Pk = Fy.require$$1("eslint:config-comment-parser"), Ik = function() {
  function e25() {
    a(this, e25);
  }
  return s(e25, [{ key: "parseStringConfig", value: function(e26, t2) {
    Pk("Parsing String config");
    var r2 = {};
    return e26.replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*([,:])[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*/g, "$1").split(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|,+/).forEach(function(e27) {
      if (e27) {
        var n2 = b(e27.split(":"), 2), i2 = n2[0], a2 = n2[1], o2 = a2 === void 0 ? null : a2;
        r2[i2] = { value: o2, comment: t2 };
      }
    }), r2;
  } }, { key: "parseJsonConfig", value: function(e26, t2) {
    Pk("Parsing JSON config");
    var r2 = {};
    try {
      if (r2 = jC.parse("Object", e26) || {}, fS.isEverySeverityValid(r2))
        return { success: true, config: r2 };
    } catch (e27) {
      Pk("Levn parsing failed; falling back to manual parsing.");
    }
    r2 = {};
    var n2 = e26.replace(/([\x2D\/-9A-Za-z]+):/g, '"$1":').replace(/(\]|[0-9])[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+(?=")/, "$1,");
    try {
      r2 = JSON.parse("{".concat(n2, "}"));
    } catch (e27) {
      return Pk("Manual parsing failed."), { success: false, error: { ruleId: null, fatal: true, severity: 2, message: "Failed to parse JSON from '".concat(n2, "': ").concat(e27.message), line: t2.start.line, column: t2.start.column + 1 } };
    }
    return { success: true, config: r2 };
  } }, { key: "parseListConfig", value: function(e26) {
    Pk("Parsing list config");
    var t2 = {};
    return e26.replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*,[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*/g, ",").split(/,+/).forEach(function(e27) {
      var r2 = e27.trim();
      r2 && (t2[r2] = true);
    }), t2;
  } }]), e25;
}();
function Bk(e25) {
  switch (e25.type) {
    case "identifier":
      return [e25.value];
    case "matches":
      var t2, r2 = e25.selectors.map(Bk);
      return r2.every(Boolean) ? (t2 = Fy.lodash).union.apply(t2, E(r2)) : null;
    case "compound":
      var n2, i2 = e25.selectors.map(Bk).filter(function(e26) {
        return e26;
      });
      return i2.length ? (n2 = Fy.lodash).intersection.apply(n2, E(i2)) : null;
    case "child":
    case "descendant":
    case "sibling":
    case "adjacent":
      return Bk(e25.right);
    default:
      return null;
  }
}
function Ok(e25) {
  switch (e25.type) {
    case "child":
    case "descendant":
    case "sibling":
    case "adjacent":
      return Ok(e25.left) + Ok(e25.right);
    case "compound":
    case "not":
    case "matches":
      return e25.selectors.reduce(function(e26, t2) {
        return e26 + Ok(t2);
      }, 0);
    case "attribute":
    case "field":
    case "nth-child":
    case "nth-last-child":
      return 1;
    default:
      return 0;
  }
}
function Lk(e25) {
  switch (e25.type) {
    case "child":
    case "descendant":
    case "sibling":
    case "adjacent":
      return Lk(e25.left) + Lk(e25.right);
    case "compound":
    case "not":
    case "matches":
      return e25.selectors.reduce(function(e26, t2) {
        return e26 + Lk(t2);
      }, 0);
    case "identifier":
      return 1;
    default:
      return 0;
  }
}
function Nk(e25, t2) {
  return e25.attributeCount - t2.attributeCount || e25.identifierCount - t2.identifierCount || (e25.rawSelector <= t2.rawSelector ? -1 : 1);
}
var jk = Fy.lodash.memoize(function(e25) {
  var t2 = function(e26) {
    try {
      return RC.parse(e26.replace(/:exit$/, ""));
    } catch (t3) {
      if (typeof t3.offset == "number")
        throw new SyntaxError('Syntax error in selector "'.concat(e26, '" at position ').concat(t3.offset, ": ").concat(t3.message));
      throw t3;
    }
  }(e25);
  return { rawSelector: e25, isExit: e25.endsWith(":exit"), parsedSelector: t2, listenerTypes: Bk(t2), attributeCount: Ok(t2), identifierCount: Lk(t2) };
}), Rk = function() {
  function e25(t2) {
    var r2 = this;
    a(this, e25), this.emitter = t2, this.currentAncestry = [], this.enterSelectorsByNodeType = new Map(), this.exitSelectorsByNodeType = new Map(), this.anyTypeEnterSelectors = [], this.anyTypeExitSelectors = [], t2.eventNames().forEach(function(e26) {
      var t3 = jk(e26);
      if (t3.listenerTypes) {
        var n2 = t3.isExit ? r2.exitSelectorsByNodeType : r2.enterSelectorsByNodeType;
        t3.listenerTypes.forEach(function(e27) {
          n2.has(e27) || n2.set(e27, []), n2.get(e27).push(t3);
        });
      } else {
        (t3.isExit ? r2.anyTypeExitSelectors : r2.anyTypeEnterSelectors).push(t3);
      }
    }), this.anyTypeEnterSelectors.sort(Nk), this.anyTypeExitSelectors.sort(Nk), this.enterSelectorsByNodeType.forEach(function(e26) {
      return e26.sort(Nk);
    }), this.exitSelectorsByNodeType.forEach(function(e26) {
      return e26.sort(Nk);
    });
  }
  return s(e25, [{ key: "applySelector", value: function(e26, t2) {
    RC.matches(e26, t2.parsedSelector, this.currentAncestry) && this.emitter.emit(t2.rawSelector, e26);
  } }, { key: "applySelectors", value: function(e26, t2) {
    for (var r2 = (t2 ? this.exitSelectorsByNodeType : this.enterSelectorsByNodeType).get(e26.type) || [], n2 = t2 ? this.anyTypeExitSelectors : this.anyTypeEnterSelectors, i2 = 0, a2 = 0; i2 < r2.length || a2 < n2.length; )
      i2 >= r2.length || a2 < n2.length && 0 > Nk(n2[a2], r2[i2]) ? this.applySelector(e26, n2[a2++]) : this.applySelector(e26, r2[i2++]);
  } }, { key: "enterNode", value: function(e26) {
    e26.parent && this.currentAncestry.unshift(e26.parent), this.applySelectors(e26, false);
  } }, { key: "leaveNode", value: function(e26) {
    this.applySelectors(e26, true), this.currentAncestry.shift();
  } }]), e25;
}();
function Mk(e25, t2) {
  return { range: [e25, e25], text: t2 };
}
var Vk = Object.freeze({ insertTextAfter: function(e25, t2) {
  return this.insertTextAfterRange(e25.range, t2);
}, insertTextAfterRange: function(e25, t2) {
  return Mk(e25[1], t2);
}, insertTextBefore: function(e25, t2) {
  return this.insertTextBeforeRange(e25.range, t2);
}, insertTextBeforeRange: function(e25, t2) {
  return Mk(e25[0], t2);
}, replaceText: function(e25, t2) {
  return this.replaceTextRange(e25.range, t2);
}, replaceTextRange: function(e25, t2) {
  return { range: e25, text: t2 };
}, remove: function(e25) {
  return this.removeRange(e25.range);
}, removeRange: function(e25) {
  return { range: e25, text: "" };
} }), Uk = function(e25, t2) {
  return t2 ? e25.replace(/\{\{((?:[\0-z\|~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\}\}/g, function(e26, r2) {
    var n2 = r2.trim();
    return n2 in t2 ? t2[n2] : e26;
  }) : e25;
};
function qk() {
  return arguments.length === 1 ? Object.assign({}, arguments.length <= 0 ? void 0 : arguments[0]) : typeof (arguments.length <= 1 ? void 0 : arguments[1]) == "string" ? { node: arguments.length <= 0 ? void 0 : arguments[0], message: arguments.length <= 1 ? void 0 : arguments[1], data: arguments.length <= 2 ? void 0 : arguments[2], fix: arguments.length <= 3 ? void 0 : arguments[3] } : { node: arguments.length <= 0 ? void 0 : arguments[0], loc: arguments.length <= 1 ? void 0 : arguments[1], message: arguments.length <= 2 ? void 0 : arguments[2], data: arguments.length <= 3 ? void 0 : arguments[3], fix: arguments.length <= 4 ? void 0 : arguments[4] };
}
function Wk(e25) {
  e25.node ? NC(i(e25.node) == "object", "Node must be an object") : NC(e25.loc, "Node must be provided when reporting error if location is not provided");
}
function $k(e25) {
  return e25.loc ? e25.loc.start ? e25.loc : { start: e25.loc, end: null } : e25.node.loc;
}
function Gk(e25, t2) {
  return e25.range[0] - t2.range[0] || e25.range[1] - t2.range[1];
}
function zk(e25, t2) {
  if (typeof e25.fix != "function")
    return null;
  var r2 = e25.fix(Vk);
  return r2 && Symbol.iterator in r2 ? function(e26, t3) {
    var r3 = Math.max;
    if (e26.length === 0)
      return null;
    if (e26.length === 1)
      return e26[0];
    e26.sort(Gk);
    var n2 = t3.text, i2 = e26[0].range[0], a2 = e26[e26.length - 1].range[1], o2 = "", s2 = Number.MIN_SAFE_INTEGER, u2 = true, c2 = false, l2 = void 0;
    try {
      for (var p2, f2 = e26[Symbol.iterator](); !(u2 = (p2 = f2.next()).done); u2 = true) {
        var h2 = p2.value;
        NC(h2.range[0] >= s2, "Fix objects must not be overlapped in a report."), 0 <= h2.range[0] && (o2 += n2.slice(r3(0, i2, s2), h2.range[0])), o2 += h2.text, s2 = h2.range[1];
      }
    } catch (e27) {
      c2 = true, l2 = e27;
    } finally {
      try {
        u2 || f2.return == null || f2.return();
      } finally {
        if (c2)
          throw l2;
      }
    }
    return { range: [i2, a2], text: o2 += n2.slice(r3(0, i2, s2), a2) };
  }(Array.from(r2), t2) : r2;
}
function Hk(e25, t2, r2) {
  return e25.suggest && Array.isArray(e25.suggest) ? e25.suggest.map(function(e26) {
    var n2 = e26.desc || r2[e26.messageId];
    return p({}, e26, { desc: Uk(n2, e26.data), fix: zk(e26, t2) });
  }) : [];
}
function Kk(e25) {
  var t2 = { ruleId: e25.ruleId, severity: e25.severity, message: e25.message, line: e25.loc.start.line, column: e25.loc.start.column + 1, nodeType: e25.node && e25.node.type || null };
  return e25.messageId && (t2.messageId = e25.messageId), e25.loc.end && (t2.endLine = e25.loc.end.line, t2.endColumn = e25.loc.end.column + 1), e25.fix && (t2.fix = e25.fix), e25.suggestions && 0 < e25.suggestions.length && (t2.suggestions = e25.suggestions), t2;
}
function Jk(e25, t2) {
  e25 && Array.isArray(e25) && e25.forEach(function(e26) {
    if (e26.messageId) {
      var r2 = e26.messageId;
      if (!t2)
        throw new TypeError("context.report() called with a suggest option with a messageId '".concat(r2, "', but no messages were present in the rule metadata."));
      if (!t2[r2])
        throw new TypeError("context.report() called with a suggest option with a messageId '".concat(r2, "' which is not present in the 'messages' config: ").concat(JSON.stringify(t2, null, 2)));
      if (e26.desc)
        throw new TypeError("context.report() called with a suggest option that defines both a 'messageId' and an 'desc'. Please only pass one.");
    } else if (!e26.desc)
      throw new TypeError("context.report() called with a suggest option that doesn't have either a `desc` or `messageId`");
    if (typeof e26.fix != "function")
      throw new TypeError("context.report() called with a suggest option without a fix function. See: ".concat(e26));
  });
}
var Qk = function(e25) {
  return function() {
    var t2, r2 = qk.apply(void 0, arguments), n2 = e25.messageIds;
    if (Wk(r2), r2.messageId) {
      if (!n2)
        throw new TypeError("context.report() called with a messageId, but no messages were present in the rule metadata.");
      var i2 = r2.messageId;
      if (r2.message)
        throw new TypeError("context.report() called with a message and a messageId. Please only pass one.");
      if (!n2 || !Object.prototype.hasOwnProperty.call(n2, i2))
        throw new TypeError("context.report() called with a messageId of '".concat(i2, "' which is not present in the 'messages' config: ").concat(JSON.stringify(n2, null, 2)));
      t2 = n2[i2];
    } else {
      if (!r2.message)
        throw new TypeError("Missing `message` property in report() call; add a message that describes the linting problem.");
      t2 = r2.message;
    }
    return Jk(r2.suggest, n2), Kk({ ruleId: e25.ruleId, severity: e25.severity, node: r2.node, message: Uk(t2, r2.data), messageId: r2.messageId, loc: $k(r2), fix: e25.disableFixes ? null : zk(r2, e25.sourceCode), suggestions: e25.disableFixes ? [] : Hk(r2, e25.sourceCode, n2) });
  };
};
var Xk = function() {
  function e25() {
    a(this, e25), this._rules = Object.create(null);
  }
  return s(e25, [{ key: "define", value: function(e26, t2) {
    this._rules[e26] = function(e27) {
      return typeof e27 == "function" ? Object.assign({ create: e27 }, e27) : e27;
    }(t2);
  } }, { key: "get", value: function(e26) {
    return typeof this._rules[e26] == "string" && this.define(e26, null), this._rules[e26] ? this._rules[e26] : mS.has(e26) ? mS.get(e26) : null;
  } }, { key: Symbol.iterator, value: regeneratorRuntime.mark(function e26() {
    var t2, r2, n2;
    return regeneratorRuntime.wrap(function(e27) {
      for (; ; )
        switch (e27.prev = e27.next) {
          case 0:
            return e27.delegateYield(mS, "t0", 1);
          case 1:
            t2 = 0, r2 = Object.keys(this._rules);
          case 2:
            if (!(t2 < r2.length)) {
              e27.next = 9;
              break;
            }
            return n2 = r2[t2], e27.next = 6, [n2, this.get(n2)];
          case 6:
            t2++, e27.next = 2;
            break;
          case 9:
          case "end":
            return e27.stop();
        }
    }, e26, this);
  }) }]), e25;
}(), Yk = function() {
  var e25 = Object.create(null);
  return Object.freeze({ on: function(t2, r2) {
    t2 in e25 ? e25[t2].push(r2) : e25[t2] = [r2];
  }, emit: function(t2) {
    for (var r2 = arguments.length, n2 = new Array(r2 > 1 ? r2 - 1 : 0), i2 = 1; i2 < r2; i2++)
      n2[i2 - 1] = arguments[i2];
    t2 in e25 && e25[t2].forEach(function(e26) {
      return e26.apply(void 0, n2);
    });
  }, eventNames: function() {
    return Object.keys(e25);
  } });
}, Zk = Fy.require$$1("eslint:source-code-fixer"), eD = "\uFEFF";
function tD(e25, t2) {
  return e25.fix.range[0] - t2.fix.range[0] || e25.fix.range[1] - t2.fix.range[1];
}
function rD(e25, t2) {
  return e25.line - t2.line || e25.column - t2.column;
}
function nD() {
  Object.freeze(this);
}
nD.applyFixes = function(e25, t2, r2) {
  function n2(e26) {
    var t3 = e26.fix, r3 = t3.range[0], n3 = t3.range[1];
    return c2 >= r3 || r3 > n3 ? (a2.push(e26), false) : ((0 > r3 && 0 <= n3 || r3 === 0 && t3.text.startsWith(eD)) && (l2 = ""), l2 += u2.slice(i2(0, c2), i2(0, r3)), l2 += t3.text, c2 = n3, true);
  }
  var i2 = Math.max;
  if (Zk("Applying fixes"), r2 === false)
    return Zk("shouldFix parameter was false, not attempting fixes"), { fixed: false, messages: t2, output: e25 };
  var a2 = [], o2 = [], s2 = e25.startsWith(eD) ? eD : "", u2 = s2 ? e25.slice(1) : e25, c2 = Number.NEGATIVE_INFINITY, l2 = s2;
  if (t2.forEach(function(e26) {
    Object.prototype.hasOwnProperty.call(e26, "fix") ? o2.push(e26) : a2.push(e26);
  }), o2.length) {
    Zk("Found fixes to apply");
    var p2 = false, f2 = true, h2 = false, d2 = void 0;
    try {
      for (var m2, g2 = o2.sort(tD)[Symbol.iterator](); !(f2 = (m2 = g2.next()).done); f2 = true) {
        var y2 = m2.value;
        typeof r2 != "function" || r2(y2) ? (n2(y2), p2 = true) : a2.push(y2);
      }
    } catch (e26) {
      h2 = true, d2 = e26;
    } finally {
      try {
        f2 || g2.return == null || g2.return();
      } finally {
        if (h2)
          throw d2;
      }
    }
    return l2 += u2.slice(i2(0, c2)), { fixed: p2, messages: a2.sort(rD), output: l2 };
  }
  return Zk("No fixes to apply"), { fixed: false, messages: t2, output: s2 + u2 };
};
var iD = nD, aD = { "generator-star": ["generator-star-spacing"], "global-strict": ["strict"], "no-arrow-condition": ["no-confusing-arrow", "no-constant-condition"], "no-comma-dangle": ["comma-dangle"], "no-empty-class": ["no-empty-character-class"], "no-empty-label": ["no-labels"], "no-extra-strict": ["strict"], "no-reserved-keys": ["quote-props"], "no-space-before-semi": ["semi-spacing"], "no-wrap-func": ["no-extra-parens"], "space-after-function-name": ["space-before-function-paren"], "space-after-keywords": ["keyword-spacing"], "space-before-function-parentheses": ["space-before-function-paren"], "space-before-keywords": ["keyword-spacing"], "space-in-brackets": ["object-curly-spacing", "array-bracket-spacing", "computed-property-spacing"], "space-return-throw-case": ["keyword-spacing"], "space-unary-word-ops": ["space-unary-ops"], "spaced-line-comment": ["spaced-comment"] }, oD = { rules: aD }, sD = Object.freeze({ __proto__: null, rules: aD, default: oD }), uD = Fy.getCjsExportFromNamespace(pS), cD = Fy.getCjsExportFromNamespace(sD), lD = tk.SourceCode, pD = Fy.require$$1("eslint:linter"), fD = new Ik(), hD = { start: { line: 1, column: 0 }, end: { line: 1, column: 1 } };
function dD(e25) {
  var t2 = e25.ruleId, r2 = t2 === void 0 ? null : t2, n2 = e25.loc, i2 = n2 === void 0 ? hD : n2, a2 = e25.message, o2 = a2 === void 0 ? function(e26) {
    return Object.prototype.hasOwnProperty.call(cD.rules, e26) ? "Rule '".concat(e26, "' was removed and replaced by: ").concat(cD.rules[e26].join(", ")) : "Definition for rule '".concat(e26, "' was not found.");
  }(e25.ruleId) : a2, s2 = e25.severity, u2 = s2 === void 0 ? 2 : s2;
  return { ruleId: r2, message: o2, line: i2.start.line, column: i2.start.column + 1, endLine: i2.end.line, endColumn: i2.end.column + 1, severity: u2, nodeType: null };
}
function mD(e25, t2, r2, n2) {
  var i2 = {}, a2 = Object.create(null), o2 = {}, s2 = [], u2 = [];
  return t2.comments.filter(function(e26) {
    return e26.type !== "Shebang";
  }).forEach(function(e26) {
    var t3 = e26.value.trim(), c2 = /^(eslint(?:\x2Denv|\x2Denable|\x2Ddisable(?:(?:\x2Dnext)?\x2Dline)?)?|exported|globals?)(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]|$)/.exec(t3);
    if (c2) {
      var l2 = c2[1], p2 = /^eslint\x2Ddisable\x2D(next\x2D)?line$/.test(l2);
      if (e26.type !== "Line" || p2) {
        if (n2) {
          var f2 = e26.type === "Block" ? "/*".concat(l2, "*/") : "//".concat(l2);
          return void s2.push(dD({ ruleId: null, message: "'".concat(f2, "' has no effect because you have 'noInlineConfig' setting in ").concat(n2, "."), loc: e26.loc, severity: 1 }));
        }
        if (p2 && e26.loc.start.line !== e26.loc.end.line)
          return void s2.push(dD({ ruleId: null, message: "".concat(l2, " comment should not span multiple lines."), loc: e26.loc }));
        var h2 = t3.slice(c2.index + l2.length);
        switch (l2) {
          case "eslint-disable":
          case "eslint-enable":
          case "eslint-disable-next-line":
          case "eslint-disable-line":
            var d2 = function(e27) {
              var t4 = e27.type, r3 = e27.loc, n3 = e27.value, i3 = e27.ruleMapper, a3 = Object.keys(fD.parseListConfig(n3)), o3 = a3.length ? a3 : [null], s3 = { directives: [], directiveProblems: [] }, u3 = true, c3 = false, l3 = void 0;
              try {
                for (var p3, f3 = o3[Symbol.iterator](); !(u3 = (p3 = f3.next()).done); u3 = true) {
                  var h3 = p3.value;
                  h3 === null || i3(h3) !== null ? s3.directives.push({ type: t4, line: r3.start.line, column: r3.start.column + 1, ruleId: h3 }) : s3.directiveProblems.push(dD({ ruleId: h3, loc: r3 }));
                }
              } catch (e28) {
                c3 = true, l3 = e28;
              } finally {
                try {
                  u3 || f3.return == null || f3.return();
                } finally {
                  if (c3)
                    throw l3;
                }
              }
              return s3;
            }({ type: l2.slice(7), loc: e26.loc, value: h2, ruleMapper: r2 }), m2 = d2.directives, g2 = d2.directiveProblems;
            u2.push.apply(u2, E(m2)), s2.push.apply(s2, E(g2));
            break;
          case "exported":
            Object.assign(o2, fD.parseStringConfig(h2, e26));
            break;
          case "globals":
          case "global":
            for (var y2 = 0, v2 = Object.entries(fD.parseStringConfig(h2, e26)); y2 < v2.length; y2++) {
              var x2 = b(v2[y2], 2), C2 = x2[0], S2 = x2[1].value, k2 = void 0;
              try {
                k2 = fS.normalizeConfigGlobal(S2);
              } catch (t4) {
                s2.push(dD({ ruleId: null, loc: e26.loc, message: t4.message }));
                continue;
              }
              a2[C2] ? (a2[C2].comments.push(e26), a2[C2].value = k2) : a2[C2] = { comments: [e26], value: k2 };
            }
            break;
          case "eslint":
            var D2 = fD.parseJsonConfig(h2, e26.loc);
            D2.success ? Object.keys(D2.config).forEach(function(t4) {
              var n3 = r2(t4), a3 = D2.config[t4];
              if (n3 !== null) {
                try {
                  TS.validateRuleOptions(n3, t4, a3);
                } catch (r3) {
                  return void s2.push(dD({ ruleId: t4, message: r3.message, loc: e26.loc }));
                }
                i2[t4] = a3;
              } else
                s2.push(dD({ ruleId: t4, loc: e26.loc }));
            }) : s2.push(D2.error);
        }
      }
    }
  }), { configuredRules: i2, enabledGlobals: a2, exportedVariables: o2, problems: s2, disableDirectives: u2 };
}
var gD = /\/\*[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*eslint\x2Denv[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\*\//g;
function yD(e25) {
  var t2 = e25.split(PC.sep), r2 = t2.lastIndexOf("<text>");
  return r2 === -1 ? e25 : t2.slice(r2).join(PC.sep);
}
function vD(e25) {
  return Array.isArray(e25) ? e25.slice(1) : [];
}
function xD(e25, t2, r2) {
  var n2 = t2.ecmaFeatures || {}, i2 = t2.ecmaVersion || 5;
  return IC.analyze(e25, { ignoreEval: true, nodejsScope: n2.globalReturn, impliedStrict: n2.impliedStrict, ecmaVersion: i2, sourceType: t2.sourceType || "script", childVisitorKeys: r2 || Fy.evk.KEYS, fallback: Fy.Traverser.getKeys });
}
function bD(e25, t2) {
  for (var r2 = t2.type !== "Program", n2 = t2; n2; n2 = n2.parent) {
    var i2 = e25.acquire(n2, r2);
    if (i2)
      return i2.type === "function-expression-name" ? i2.childScopes[0] : i2;
  }
  return e25.scopes[0];
}
var ED = { getSource: "getText", getSourceLines: "getLines", getAllComments: "getAllComments", getNodeByRangeIndex: "getNodeByRangeIndex", getComments: "getComments", getCommentsBefore: "getCommentsBefore", getCommentsAfter: "getCommentsAfter", getCommentsInside: "getCommentsInside", getJSDocComment: "getJSDocComment", getFirstToken: "getFirstToken", getFirstTokens: "getFirstTokens", getLastToken: "getLastToken", getLastTokens: "getLastTokens", getTokenAfter: "getTokenAfter", getTokenBefore: "getTokenBefore", getTokenByRangeStart: "getTokenByRangeStart", getTokens: "getTokens", getTokensAfter: "getTokensAfter", getTokensBefore: "getTokensBefore", getTokensBetween: "getTokensBetween" }, CD = Object.freeze(Object.keys(ED).reduce(function(e25, t2) {
  return Object.assign(e25, u({}, t2, function() {
    var e26;
    return (e26 = this.getSourceCode())[ED[t2]].apply(e26, arguments);
  }));
}, {}));
function SD(e25, t2, r2, n2, i2, a2, o2, s2, u2) {
  var c2 = Yk(), l2 = [], p2 = e25.ast;
  Fy.Traverser.traverse(e25.ast, { enter: function(e26, t3) {
    e26.parent = t3, l2.push({ isEntering: true, node: e26 });
  }, leave: function(e26) {
    l2.push({ isEntering: false, node: e26 });
  }, visitorKeys: e25.visitorKeys });
  var f2 = Object.freeze(Object.assign(Object.create(CD), { getAncestors: function() {
    return function(e26) {
      for (var t3 = [], r3 = e26.parent; r3; r3 = r3.parent)
        t3.push(r3);
      return t3.reverse();
    }(p2);
  }, getDeclaredVariables: e25.scopeManager.getDeclaredVariables.bind(e25.scopeManager), getCwd: function() {
    return u2;
  }, getFilename: function() {
    return o2;
  }, getScope: function() {
    return bD(e25.scopeManager, p2);
  }, getSourceCode: function() {
    return e25;
  }, markVariableAsUsed: function(t3) {
    return function(e26, t4, r3, n3) {
      for (var i3 = r3.ecmaFeatures && r3.ecmaFeatures.globalReturn || r3.sourceType === "module", a3 = bD(e26, t4), o3 = a3.type === "global" && i3 ? a3.childScopes[0] : a3; o3; o3 = o3.upper) {
        var s3 = o3.variables.find(function(e27) {
          return e27.name === n3;
        });
        if (s3)
          return s3.eslintUsed = true, true;
      }
      return false;
    }(e25.scopeManager, p2, n2, t3);
  }, parserOptions: n2, parserPath: i2, parserServices: e25.parserServices, settings: a2 })), h2 = [];
  Object.keys(t2).forEach(function(n3) {
    var i3 = fS.getRuleSeverity(t2[n3]);
    if (i3 !== 0) {
      var a3 = r2(n3);
      if (a3 !== null) {
        var o3 = a3.meta && a3.meta.messages, u3 = null, l3 = Object.freeze(Object.assign(Object.create(f2), { id: n3, options: vD(t2[n3]), report: function() {
          u3 === null && (u3 = Qk({ ruleId: n3, severity: i3, sourceCode: e25, messageIds: o3, disableFixes: s2 }));
          var t3 = u3.apply(void 0, arguments);
          if (t3.fix && a3.meta && !a3.meta.fixable)
            throw new Error("Fixable rules should export a `meta.fixable` property.");
          h2.push(t3);
        } })), p3 = function(e26, t3) {
          try {
            return e26.create(t3);
          } catch (e27) {
            throw e27.message = "Error while loading rule '".concat(t3.id, "': ").concat(e27.message), e27;
          }
        }(a3, l3);
        Object.keys(p3).forEach(function(e26) {
          c2.on(e26, p3[e26]);
        });
      } else
        h2.push(dD({ ruleId: n3 }));
    }
  });
  var d2 = new wk(new Rk(c2));
  return l2.forEach(function(e26) {
    p2 = e26.node;
    try {
      e26.isEntering ? d2.enterNode(p2) : d2.leaveNode(p2);
    } catch (e27) {
      throw e27.currentNode = p2, e27;
    }
  }), h2;
}
function kD(e25, t2) {
  return e25.lastConfigArray && e25.lastConfigArray.pluginRules.get(t2) || e25.ruleMap.get(t2);
}
function DD(e25) {
  return e25 || ((typeof process == "undefined" ? "undefined" : i(process)) == "object" ? process.cwd() : void 0);
}
var FD = new WeakMap(), AD = { linter_1: { Linter: { Linter: function() {
  function e25() {
    var t2 = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).cwd;
    a(this, e25), FD.set(this, { cwd: DD(t2), lastConfigArray: null, lastSourceCode: null, parserMap: new Map([["espree", Fy.espree]]), ruleMap: new Xk() }), this.version = uD.version;
  }
  return s(e25, [{ key: "_verifyWithoutProcessors", value: function(e26, t2, r2) {
    var n2, a2 = FD.get(this), o2 = t2 || {}, s2 = function(e27, t3) {
      var r3 = t3.noInlineConfig === true, n3 = e27.allowInlineConfig === false, i2 = t3.configNameOfNoInlineConfig ? " (".concat(t3.configNameOfNoInlineConfig, ")") : "", a3 = e27.reportUnusedDisableDirectives;
      return typeof a3 == "boolean" && (a3 = a3 ? "error" : "off"), typeof a3 != "string" && (a3 = t3.reportUnusedDisableDirectives ? "warn" : "off"), { filename: yD(e27.filename || "<input>"), allowInlineConfig: !n3, warnInlineConfig: r3 && !n3 ? "your config".concat(i2) : null, reportUnusedDisableDirectives: a3, disableFixes: !!e27.disableFixes };
    }(r2, o2);
    typeof e26 == "string" ? (a2.lastSourceCode = null, n2 = e26) : (a2.lastSourceCode = e26, n2 = e26.text);
    var u2 = "espree", c2 = Fy.espree;
    if (i(o2.parser) == "object" && o2.parser !== null)
      u2 = o2.parser.filePath, c2 = o2.parser.definition;
    else if (typeof o2.parser == "string") {
      if (!a2.parserMap.has(o2.parser))
        return [{ ruleId: null, fatal: true, severity: 2, message: "Configured parser '".concat(o2.parser, "' was not found."), line: 0, column: 0 }];
      u2 = o2.parser, c2 = a2.parserMap.get(o2.parser);
    }
    var l2 = s2.allowInlineConfig && !s2.warnInlineConfig ? function(e27) {
      var t3, r3;
      for (gD.lastIndex = 0; t3 = gD.exec(e27); )
        r3 = Object.assign(r3 || {}, fD.parseListConfig(t3[1]));
      return r3;
    }(n2) : {}, p2 = Object.assign({ builtin: true }, o2.env, l2), f2 = Object.keys(p2).filter(function(e27) {
      return p2[e27];
    }).map(function(e27) {
      return function(e28, t3) {
        return e28.lastConfigArray && e28.lastConfigArray.pluginEnvironments.get(t3) || qC.get(t3) || null;
      }(a2, e27);
    }).filter(function(e27) {
      return e27;
    }), h2 = function(e27, t3, r3) {
      var n3 = r3.filter(function(e28) {
        return e28.parserOptions;
      }).reduce(function(e28, t4) {
        return Fy.lodash.merge(e28, t4.parserOptions);
      }, {}), i2 = Fy.lodash.merge(n3, t3 || {});
      return i2.sourceType === "module" && (i2.ecmaFeatures = Object.assign({}, i2.ecmaFeatures, { globalReturn: false })), i2.ecmaVersion = function(e28) {
        return 2015 <= e28 ? e28 - 2009 : e28;
      }(i2.ecmaVersion), i2;
    }(0, o2.parserOptions || {}, f2), d2 = function(e27, t3) {
      return Object.assign.apply(Object, [{}].concat(E(t3.filter(function(e28) {
        return e28.globals;
      }).map(function(e28) {
        return e28.globals;
      })), [e27]));
    }(o2.globals || {}, f2), m2 = o2.settings || {};
    if (a2.lastSourceCode)
      a2.lastSourceCode.scopeManager || (a2.lastSourceCode = new lD({ text: a2.lastSourceCode.text, ast: a2.lastSourceCode.ast, parserServices: a2.lastSourceCode.parserServices, visitorKeys: a2.lastSourceCode.visitorKeys, scopeManager: xD(a2.lastSourceCode.ast, h2) }));
    else {
      var g2 = function(e27, t3, r3, n3) {
        var i2 = function(e28) {
          return e28.charCodeAt(0) === 65279 ? e28.slice(1) : e28;
        }(e27).replace(Fy.require$$0$1.shebangPattern, function(e28, t4) {
          return "//".concat(t4);
        }), a3 = Object.assign({}, r3, { loc: true, range: true, raw: true, tokens: true, comment: true, eslintVisitorKeys: true, eslintScopeManager: true, filePath: n3 });
        try {
          var o3 = typeof t3.parseForESLint == "function" ? t3.parseForESLint(i2, a3) : { ast: t3.parse(i2, a3) }, s3 = o3.ast, u3 = o3.services || {}, c3 = o3.visitorKeys || Fy.evk.KEYS, l3 = o3.scopeManager || xD(s3, a3, c3);
          return { success: true, sourceCode: new lD({ text: e27, ast: s3, parserServices: u3, scopeManager: l3, visitorKeys: c3 }) };
        } catch (e28) {
          var p3 = "Parsing error: ".concat(e28.message.replace(/^line [0-9]+:/i, "").trim());
          return pD("%s\n%s", p3, e28.stack), { success: false, error: { ruleId: null, fatal: true, severity: 2, message: p3, line: e28.lineNumber, column: e28.column } };
        }
      }(n2, c2, h2, s2.filename);
      if (!g2.success)
        return [g2.error];
      a2.lastSourceCode = g2.sourceCode;
    }
    var y2 = a2.lastSourceCode, v2 = s2.allowInlineConfig ? mD(s2.filename, y2.ast, function(e27) {
      return kD(a2, e27);
    }, s2.warnInlineConfig) : { configuredRules: {}, enabledGlobals: {}, exportedVariables: {}, problems: [], disableDirectives: [] };
    !function(e27, t3, r3) {
      var n3 = r3.exportedVariables, i2 = r3.enabledGlobals, a3 = true, o3 = false, s3 = void 0;
      try {
        for (var u3, c3 = new Set([].concat(E(Object.keys(t3)), E(Object.keys(i2))))[Symbol.iterator](); !(a3 = (u3 = c3.next()).done); a3 = true) {
          var l3 = u3.value, p3 = t3[l3] === void 0 ? void 0 : fS.normalizeConfigGlobal(t3[l3]), f3 = i2[l3] && i2[l3].value || p3, h3 = i2[l3] && i2[l3].comments;
          if (f3 !== "off") {
            var d3 = e27.set.get(l3);
            d3 || (d3 = new IC.Variable(l3, e27), e27.variables.push(d3), e27.set.set(l3, d3)), d3.eslintImplicitGlobalSetting = p3, d3.eslintExplicitGlobal = h3 !== void 0, d3.eslintExplicitGlobalComments = h3, d3.writeable = f3 === "writable";
          }
        }
      } catch (e28) {
        o3 = true, s3 = e28;
      } finally {
        try {
          a3 || c3.return == null || c3.return();
        } finally {
          if (o3)
            throw s3;
        }
      }
      Object.keys(n3).forEach(function(t4) {
        var r4 = e27.set.get(t4);
        r4 && (r4.eslintUsed = true);
      }), e27.through = e27.through.filter(function(t4) {
        var r4 = t4.identifier.name, n4 = e27.set.get(r4);
        return !n4 || (t4.resolved = n4, n4.references.push(t4), false);
      });
    }(y2.scopeManager.scopes[0], d2, { exportedVariables: v2.exportedVariables, enabledGlobals: v2.enabledGlobals });
    var x2, b2 = Object.assign({}, o2.rules, v2.configuredRules);
    try {
      x2 = SD(y2, b2, function(e27) {
        return kD(a2, e27);
      }, h2, u2, m2, s2.filename, s2.disableFixes, a2.cwd);
    } catch (e27) {
      if (e27.message += "\nOccurred while linting ".concat(s2.filename), pD("An error occurred while traversing"), pD("Filename:", s2.filename), e27.currentNode) {
        var C2 = e27.currentNode.loc.start.line;
        pD("Line:", C2), e27.message += ":".concat(C2);
      }
      throw pD("Parser Options:", h2), pD("Parser Path:", u2), pD("Settings:", m2), e27;
    }
    return function(e27) {
      var t3 = e27.directives, r3 = e27.problems, n3 = e27.reportUnusedDisableDirectives, i2 = n3 === void 0 ? "off" : n3, a3 = t3.filter(function(e28) {
        return e28.type === "disable" || e28.type === "enable";
      }).map(function(e28) {
        return Object.assign({}, e28, { unprocessedDirective: e28 });
      }).sort(_k), o3 = Fy.lodash.flatMap(t3, function(e28) {
        switch (e28.type) {
          case "disable":
          case "enable":
            return [];
          case "disable-line":
            return [{ type: "disable", line: e28.line, column: 1, ruleId: e28.ruleId, unprocessedDirective: e28 }, { type: "enable", line: e28.line + 1, column: 0, ruleId: e28.ruleId, unprocessedDirective: e28 }];
          case "disable-next-line":
            return [{ type: "disable", line: e28.line + 1, column: 1, ruleId: e28.ruleId, unprocessedDirective: e28 }, { type: "enable", line: e28.line + 2, column: 0, ruleId: e28.ruleId, unprocessedDirective: e28 }];
          default:
            throw new TypeError("Unrecognized directive type '".concat(e28.type, "'"));
        }
      }).sort(_k), s3 = Tk({ problems: r3, directives: a3, reportUnusedDisableDirectives: i2 }), u3 = Tk({ problems: s3.problems, directives: o3, reportUnusedDisableDirectives: i2 });
      return i2 === "off" ? u3.problems : u3.problems.concat(s3.unusedDisableDirectives).concat(u3.unusedDisableDirectives).sort(_k);
    }({ directives: v2.disableDirectives, problems: x2.concat(v2.problems).sort(function(e27, t3) {
      return e27.line - t3.line || e27.column - t3.column;
    }), reportUnusedDisableDirectives: s2.reportUnusedDisableDirectives });
  } }, { key: "verify", value: function(e26, t2, r2) {
    pD("Verify");
    var n2 = typeof r2 == "string" ? { filename: r2 } : r2 || {};
    return t2 && typeof t2.extractConfig == "function" ? this._verifyWithConfigArray(e26, t2, n2) : n2.preprocess || n2.postprocess ? this._verifyWithProcessor(e26, t2, n2) : this._verifyWithoutProcessors(e26, t2, n2);
  } }, { key: "_verifyWithConfigArray", value: function(e26, t2, r2) {
    pD("With ConfigArray: %s", r2.filename), FD.get(this).lastConfigArray = t2;
    var n2 = t2.extractConfig(r2.filename), i2 = n2.processor && t2.pluginProcessors.get(n2.processor);
    if (i2) {
      pD("Apply the processor: %o", n2.processor);
      var a2 = i2.preprocess, o2 = i2.postprocess, s2 = i2.supportsAutofix, u2 = r2.disableFixes || !s2;
      return this._verifyWithProcessor(e26, n2, p({}, r2, { disableFixes: u2, postprocess: o2, preprocess: a2 }), t2);
    }
    return this._verifyWithoutProcessors(e26, n2, r2);
  } }, { key: "_verifyWithProcessor", value: function(e26, t2, r2, n2) {
    var a2 = this, o2 = r2.filename || "<input>", s2 = yD(o2), u2 = function(e27) {
      return i(e27) == "object" ? (e27.hasBOM ? "\uFEFF" : "") + e27.text : e27 + "";
    }(e26), c2 = r2.preprocess || function(e27) {
      return [e27];
    }, l2 = r2.postprocess || Fy.lodash.flatten, f2 = r2.filterCodeBlock || function(e27) {
      return e27.endsWith(".js");
    }, h2 = PC.extname(o2);
    return l2(c2(u2, s2).map(function(e27, i2) {
      if (pD("A code block was found: %o", e27.filename || "(unnamed)"), typeof e27 == "string")
        return a2._verifyWithoutProcessors(e27, t2, r2);
      var s3 = e27.text, u3 = PC.join(o2, "".concat(i2, "_").concat(e27.filename));
      return f2(u3, s3) ? n2 && PC.extname(u3) !== h2 ? (pD("Resolving configuration again because the file extension was changed."), a2._verifyWithConfigArray(s3, n2, p({}, r2, { filename: u3 }))) : a2._verifyWithoutProcessors(s3, t2, p({}, r2, { filename: u3 })) : (pD("This code block was skipped."), []);
    }), s2);
  } }, { key: "getSourceCode", value: function() {
    return FD.get(this).lastSourceCode;
  } }, { key: "defineRule", value: function(e26, t2) {
    FD.get(this).ruleMap.define(e26, t2);
  } }, { key: "defineRules", value: function(e26) {
    var t2 = this;
    Object.getOwnPropertyNames(e26).forEach(function(r2) {
      t2.defineRule(r2, e26[r2]);
    });
  } }, { key: "getRules", value: function() {
    var e26 = FD.get(this), t2 = e26.lastConfigArray, r2 = e26.ruleMap;
    return new Map(regeneratorRuntime.mark(function e27() {
      return regeneratorRuntime.wrap(function(e28) {
        for (; ; )
          switch (e28.prev = e28.next) {
            case 0:
              return e28.delegateYield(r2, "t0", 1);
            case 1:
              if (e28.t1 = t2, !e28.t1) {
                e28.next = 4;
                break;
              }
              return e28.delegateYield(t2.pluginRules, "t2", 4);
            case 4:
            case "end":
              return e28.stop();
          }
      }, e27);
    })());
  } }, { key: "defineParser", value: function(e26, t2) {
    FD.get(this).parserMap.set(e26, t2);
  } }, { key: "verifyAndFix", value: function(e26, t2, r2) {
    var n2, i2 = [], a2 = false, o2 = 0, s2 = e26, u2 = r2 && r2.filename || "".concat(e26.slice(0, 10), "..."), c2 = !(r2 && r2.fix !== void 0) || r2.fix;
    do {
      if (o2++, pD("Linting code for ".concat(u2, " (pass ").concat(o2, ")")), i2 = this.verify(s2, t2, r2), pD("Generating fixed text for ".concat(u2, " (pass ").concat(o2, ")")), n2 = iD.applyFixes(s2, i2, c2), i2.length === 1 && i2[0].fatal)
        break;
      a2 = a2 || n2.fixed, s2 = n2.output;
    } while (n2.fixed && o2 < 10);
    return n2.fixed && (n2.messages = this.verify(s2, t2, r2)), n2.fixed = a2, n2.output = s2, n2;
  } }], [{ key: "version", get: function() {
    return uD.version;
  } }]), e25;
}(), getLinterInternalSlots: function(e25) {
  return FD.get(e25);
} }.Linter, SourceCodeFixer: iD, interpolate: Uk }.Linter }, wD = r(function(e25) {
  !function() {
    function t2(e26) {
      if (e26 == null)
        return false;
      switch (e26.type) {
        case "BlockStatement":
        case "BreakStatement":
        case "ContinueStatement":
        case "DebuggerStatement":
        case "DoWhileStatement":
        case "EmptyStatement":
        case "ExpressionStatement":
        case "ForInStatement":
        case "ForStatement":
        case "IfStatement":
        case "LabeledStatement":
        case "ReturnStatement":
        case "SwitchStatement":
        case "ThrowStatement":
        case "TryStatement":
        case "VariableDeclaration":
        case "WhileStatement":
        case "WithStatement":
          return true;
      }
      return false;
    }
    function r2(e26) {
      switch (e26.type) {
        case "IfStatement":
          return e26.alternate != null ? e26.alternate : e26.consequent;
        case "LabeledStatement":
        case "ForStatement":
        case "ForInStatement":
        case "WhileStatement":
        case "WithStatement":
          return e26.body;
      }
      return null;
    }
    e25.exports = { isExpression: function(e26) {
      if (e26 == null)
        return false;
      switch (e26.type) {
        case "ArrayExpression":
        case "AssignmentExpression":
        case "BinaryExpression":
        case "CallExpression":
        case "ConditionalExpression":
        case "FunctionExpression":
        case "Identifier":
        case "Literal":
        case "LogicalExpression":
        case "MemberExpression":
        case "NewExpression":
        case "ObjectExpression":
        case "SequenceExpression":
        case "ThisExpression":
        case "UnaryExpression":
        case "UpdateExpression":
          return true;
      }
      return false;
    }, isStatement: t2, isIterationStatement: function(e26) {
      if (e26 == null)
        return false;
      switch (e26.type) {
        case "DoWhileStatement":
        case "ForInStatement":
        case "ForStatement":
        case "WhileStatement":
          return true;
      }
      return false;
    }, isSourceElement: function(e26) {
      return t2(e26) || e26 != null && e26.type === "FunctionDeclaration";
    }, isProblematicIfStatement: function(e26) {
      var t3;
      if (e26.type !== "IfStatement")
        return false;
      if (e26.alternate == null)
        return false;
      t3 = e26.consequent;
      do {
        if (t3.type === "IfStatement" && t3.alternate == null)
          return true;
        t3 = r2(t3);
      } while (t3);
      return false;
    }, trailingStatement: r2 };
  }();
}), _D = (wD.isExpression, wD.isStatement, wD.isIterationStatement, wD.isSourceElement, wD.isProblematicIfStatement, wD.trailingStatement, r(function(e25) {
  !function() {
    var t2, r2, n2, i2, a2, o2;
    function s2(e26) {
      return e26 <= 65535 ? String.fromCharCode(e26) : String.fromCharCode(Math.floor((e26 - 65536) / 1024) + 55296) + String.fromCharCode((e26 - 65536) % 1024 + 56320);
    }
    for (r2 = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/, NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/ }, t2 = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/, NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/ }, n2 = [5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279], i2 = new Array(128), o2 = 0; o2 < 128; ++o2)
      i2[o2] = o2 >= 97 && o2 <= 122 || o2 >= 65 && o2 <= 90 || o2 === 36 || o2 === 95;
    for (a2 = new Array(128), o2 = 0; o2 < 128; ++o2)
      a2[o2] = o2 >= 97 && o2 <= 122 || o2 >= 65 && o2 <= 90 || o2 >= 48 && o2 <= 57 || o2 === 36 || o2 === 95;
    e25.exports = { isDecimalDigit: function(e26) {
      return 48 <= e26 && e26 <= 57;
    }, isHexDigit: function(e26) {
      return 48 <= e26 && e26 <= 57 || 97 <= e26 && e26 <= 102 || 65 <= e26 && e26 <= 70;
    }, isOctalDigit: function(e26) {
      return e26 >= 48 && e26 <= 55;
    }, isWhiteSpace: function(e26) {
      return e26 === 32 || e26 === 9 || e26 === 11 || e26 === 12 || e26 === 160 || e26 >= 5760 && n2.indexOf(e26) >= 0;
    }, isLineTerminator: function(e26) {
      return e26 === 10 || e26 === 13 || e26 === 8232 || e26 === 8233;
    }, isIdentifierStartES5: function(e26) {
      return e26 < 128 ? i2[e26] : r2.NonAsciiIdentifierStart.test(s2(e26));
    }, isIdentifierPartES5: function(e26) {
      return e26 < 128 ? a2[e26] : r2.NonAsciiIdentifierPart.test(s2(e26));
    }, isIdentifierStartES6: function(e26) {
      return e26 < 128 ? i2[e26] : t2.NonAsciiIdentifierStart.test(s2(e26));
    }, isIdentifierPartES6: function(e26) {
      return e26 < 128 ? a2[e26] : t2.NonAsciiIdentifierPart.test(s2(e26));
    } };
  }();
})), TD = (_D.isDecimalDigit, _D.isHexDigit, _D.isOctalDigit, _D.isWhiteSpace, _D.isLineTerminator, _D.isIdentifierStartES5, _D.isIdentifierPartES5, _D.isIdentifierStartES6, _D.isIdentifierPartES6, r(function(e25) {
  !function() {
    var t2 = _D;
    function r2(e26, t3) {
      return !(!t3 && e26 === "yield") && n2(e26, t3);
    }
    function n2(e26, t3) {
      if (t3 && function(e27) {
        switch (e27) {
          case "implements":
          case "interface":
          case "package":
          case "private":
          case "protected":
          case "public":
          case "static":
          case "let":
            return true;
          default:
            return false;
        }
      }(e26))
        return true;
      switch (e26.length) {
        case 2:
          return e26 === "if" || e26 === "in" || e26 === "do";
        case 3:
          return e26 === "var" || e26 === "for" || e26 === "new" || e26 === "try";
        case 4:
          return e26 === "this" || e26 === "else" || e26 === "case" || e26 === "void" || e26 === "with" || e26 === "enum";
        case 5:
          return e26 === "while" || e26 === "break" || e26 === "catch" || e26 === "throw" || e26 === "const" || e26 === "yield" || e26 === "class" || e26 === "super";
        case 6:
          return e26 === "return" || e26 === "typeof" || e26 === "delete" || e26 === "switch" || e26 === "export" || e26 === "import";
        case 7:
          return e26 === "default" || e26 === "finally" || e26 === "extends";
        case 8:
          return e26 === "function" || e26 === "continue" || e26 === "debugger";
        case 10:
          return e26 === "instanceof";
        default:
          return false;
      }
    }
    function i2(e26, t3) {
      return e26 === "null" || e26 === "true" || e26 === "false" || r2(e26, t3);
    }
    function a2(e26, t3) {
      return e26 === "null" || e26 === "true" || e26 === "false" || n2(e26, t3);
    }
    function o2(e26) {
      var r3, n3, i3;
      if (e26.length === 0)
        return false;
      if (i3 = e26.charCodeAt(0), !t2.isIdentifierStartES5(i3))
        return false;
      for (r3 = 1, n3 = e26.length; r3 < n3; ++r3)
        if (i3 = e26.charCodeAt(r3), !t2.isIdentifierPartES5(i3))
          return false;
      return true;
    }
    function s2(e26) {
      var r3, n3, i3, a3, o3;
      if (e26.length === 0)
        return false;
      for (o3 = t2.isIdentifierStartES6, r3 = 0, n3 = e26.length; r3 < n3; ++r3) {
        if (55296 <= (i3 = e26.charCodeAt(r3)) && i3 <= 56319) {
          if (++r3 >= n3)
            return false;
          if (!(56320 <= (a3 = e26.charCodeAt(r3)) && a3 <= 57343))
            return false;
          i3 = 1024 * (i3 - 55296) + (a3 - 56320) + 65536;
        }
        if (!o3(i3))
          return false;
        o3 = t2.isIdentifierPartES6;
      }
      return true;
    }
    e25.exports = { isKeywordES5: r2, isKeywordES6: n2, isReservedWordES5: i2, isReservedWordES6: a2, isRestrictedWord: function(e26) {
      return e26 === "eval" || e26 === "arguments";
    }, isIdentifierNameES5: o2, isIdentifierNameES6: s2, isIdentifierES5: function(e26, t3) {
      return o2(e26) && !i2(e26, t3);
    }, isIdentifierES6: function(e26, t3) {
      return s2(e26) && !a2(e26, t3);
    } };
  }();
})), PD = (TD.isKeywordES5, TD.isKeywordES6, TD.isReservedWordES5, TD.isReservedWordES6, TD.isRestrictedWord, TD.isIdentifierNameES5, TD.isIdentifierNameES6, TD.isIdentifierES5, TD.isIdentifierES6, r(function(e25, t2) {
  t2.ast = wD, t2.code = _D, t2.keyword = TD;
})), ID = (PD.ast, PD.code, PD.keyword, function(e25) {
  return new MD(e25 || HD, null);
}), BD = 0, OD = 1;
function LD(e25, t2, r2, n2, i2, a2) {
  this._color = e25, this.key = t2, this.value = r2, this.left = n2, this.right = i2, this._count = a2;
}
function ND(e25) {
  return new LD(e25._color, e25.key, e25.value, e25.left, e25.right, e25._count);
}
function jD(e25, t2) {
  return new LD(e25, t2.key, t2.value, t2.left, t2.right, t2._count);
}
function RD(e25) {
  e25._count = 1 + (e25.left ? e25.left._count : 0) + (e25.right ? e25.right._count : 0);
}
function MD(e25, t2) {
  this._compare = e25, this.root = t2;
}
var VD = MD.prototype;
function UD(e25, t2) {
  var r2;
  if (t2.left && (r2 = UD(e25, t2.left)))
    return r2;
  return (r2 = e25(t2.key, t2.value)) || (t2.right ? UD(e25, t2.right) : void 0);
}
function qD(e25, t2, r2, n2) {
  if (t2(e25, n2.key) <= 0) {
    var i2;
    if (n2.left) {
      if (i2 = qD(e25, t2, r2, n2.left))
        return i2;
    }
    if (i2 = r2(n2.key, n2.value))
      return i2;
  }
  if (n2.right)
    return qD(e25, t2, r2, n2.right);
}
function WD(e25, t2, r2, n2, i2) {
  var a2, o2 = r2(e25, i2.key), s2 = r2(t2, i2.key);
  if (o2 <= 0) {
    if (i2.left && (a2 = WD(e25, t2, r2, n2, i2.left)))
      return a2;
    if (s2 > 0 && (a2 = n2(i2.key, i2.value)))
      return a2;
  }
  if (s2 > 0 && i2.right)
    return WD(e25, t2, r2, n2, i2.right);
}
function $D(e25, t2) {
  this.tree = e25, this._stack = t2;
}
Object.defineProperty(VD, "keys", { get: function() {
  var e25 = [];
  return this.forEach(function(t2, r2) {
    e25.push(t2);
  }), e25;
} }), Object.defineProperty(VD, "values", { get: function() {
  var e25 = [];
  return this.forEach(function(t2, r2) {
    e25.push(r2);
  }), e25;
} }), Object.defineProperty(VD, "length", { get: function() {
  return this.root ? this.root._count : 0;
} }), VD.insert = function(e25, t2) {
  for (var r2 = this._compare, n2 = this.root, i2 = [], a2 = []; n2; ) {
    var o2 = r2(e25, n2.key);
    i2.push(n2), a2.push(o2), n2 = o2 <= 0 ? n2.left : n2.right;
  }
  i2.push(new LD(BD, e25, t2, null, null, 1));
  for (var s2 = i2.length - 2; s2 >= 0; --s2) {
    n2 = i2[s2];
    a2[s2] <= 0 ? i2[s2] = new LD(n2._color, n2.key, n2.value, i2[s2 + 1], n2.right, n2._count + 1) : i2[s2] = new LD(n2._color, n2.key, n2.value, n2.left, i2[s2 + 1], n2._count + 1);
  }
  for (s2 = i2.length - 1; s2 > 1; --s2) {
    var u2 = i2[s2 - 1];
    n2 = i2[s2];
    if (u2._color === OD || n2._color === OD)
      break;
    var c2 = i2[s2 - 2];
    if (c2.left === u2)
      if (u2.left === n2) {
        if (!(l2 = c2.right) || l2._color !== BD) {
          if (c2._color = BD, c2.left = u2.right, u2._color = OD, u2.right = c2, i2[s2 - 2] = u2, i2[s2 - 1] = n2, RD(c2), RD(u2), s2 >= 3)
            (p2 = i2[s2 - 3]).left === c2 ? p2.left = u2 : p2.right = u2;
          break;
        }
        u2._color = OD, c2.right = jD(OD, l2), c2._color = BD, s2 -= 1;
      } else {
        if (!(l2 = c2.right) || l2._color !== BD) {
          if (u2.right = n2.left, c2._color = BD, c2.left = n2.right, n2._color = OD, n2.left = u2, n2.right = c2, i2[s2 - 2] = n2, i2[s2 - 1] = u2, RD(c2), RD(u2), RD(n2), s2 >= 3)
            (p2 = i2[s2 - 3]).left === c2 ? p2.left = n2 : p2.right = n2;
          break;
        }
        u2._color = OD, c2.right = jD(OD, l2), c2._color = BD, s2 -= 1;
      }
    else if (u2.right === n2) {
      if (!(l2 = c2.left) || l2._color !== BD) {
        if (c2._color = BD, c2.right = u2.left, u2._color = OD, u2.left = c2, i2[s2 - 2] = u2, i2[s2 - 1] = n2, RD(c2), RD(u2), s2 >= 3)
          (p2 = i2[s2 - 3]).right === c2 ? p2.right = u2 : p2.left = u2;
        break;
      }
      u2._color = OD, c2.left = jD(OD, l2), c2._color = BD, s2 -= 1;
    } else {
      var l2;
      if (!(l2 = c2.left) || l2._color !== BD) {
        var p2;
        if (u2.left = n2.right, c2._color = BD, c2.right = n2.left, n2._color = OD, n2.right = u2, n2.left = c2, i2[s2 - 2] = n2, i2[s2 - 1] = u2, RD(c2), RD(u2), RD(n2), s2 >= 3)
          (p2 = i2[s2 - 3]).right === c2 ? p2.right = n2 : p2.left = n2;
        break;
      }
      u2._color = OD, c2.left = jD(OD, l2), c2._color = BD, s2 -= 1;
    }
  }
  return i2[0]._color = OD, new MD(r2, i2[0]);
}, VD.forEach = function(e25, t2, r2) {
  if (this.root)
    switch (arguments.length) {
      case 1:
        return UD(e25, this.root);
      case 2:
        return qD(t2, this._compare, e25, this.root);
      case 3:
        if (this._compare(t2, r2) >= 0)
          return;
        return WD(t2, r2, this._compare, e25, this.root);
    }
}, Object.defineProperty(VD, "begin", { get: function() {
  for (var e25 = [], t2 = this.root; t2; )
    e25.push(t2), t2 = t2.left;
  return new $D(this, e25);
} }), Object.defineProperty(VD, "end", { get: function() {
  for (var e25 = [], t2 = this.root; t2; )
    e25.push(t2), t2 = t2.right;
  return new $D(this, e25);
} }), VD.at = function(e25) {
  if (e25 < 0)
    return new $D(this, []);
  for (var t2 = this.root, r2 = []; ; ) {
    if (r2.push(t2), t2.left) {
      if (e25 < t2.left._count) {
        t2 = t2.left;
        continue;
      }
      e25 -= t2.left._count;
    }
    if (!e25)
      return new $D(this, r2);
    if (e25 -= 1, !t2.right)
      break;
    if (e25 >= t2.right._count)
      break;
    t2 = t2.right;
  }
  return new $D(this, []);
}, VD.ge = function(e25) {
  for (var t2 = this._compare, r2 = this.root, n2 = [], i2 = 0; r2; ) {
    var a2 = t2(e25, r2.key);
    n2.push(r2), a2 <= 0 && (i2 = n2.length), r2 = a2 <= 0 ? r2.left : r2.right;
  }
  return n2.length = i2, new $D(this, n2);
}, VD.gt = function(e25) {
  for (var t2 = this._compare, r2 = this.root, n2 = [], i2 = 0; r2; ) {
    var a2 = t2(e25, r2.key);
    n2.push(r2), a2 < 0 && (i2 = n2.length), r2 = a2 < 0 ? r2.left : r2.right;
  }
  return n2.length = i2, new $D(this, n2);
}, VD.lt = function(e25) {
  for (var t2 = this._compare, r2 = this.root, n2 = [], i2 = 0; r2; ) {
    var a2 = t2(e25, r2.key);
    n2.push(r2), a2 > 0 && (i2 = n2.length), r2 = a2 <= 0 ? r2.left : r2.right;
  }
  return n2.length = i2, new $D(this, n2);
}, VD.le = function(e25) {
  for (var t2 = this._compare, r2 = this.root, n2 = [], i2 = 0; r2; ) {
    var a2 = t2(e25, r2.key);
    n2.push(r2), a2 >= 0 && (i2 = n2.length), r2 = a2 < 0 ? r2.left : r2.right;
  }
  return n2.length = i2, new $D(this, n2);
}, VD.find = function(e25) {
  for (var t2 = this._compare, r2 = this.root, n2 = []; r2; ) {
    var i2 = t2(e25, r2.key);
    if (n2.push(r2), i2 === 0)
      return new $D(this, n2);
    r2 = i2 <= 0 ? r2.left : r2.right;
  }
  return new $D(this, []);
}, VD.remove = function(e25) {
  var t2 = this.find(e25);
  return t2 ? t2.remove() : this;
}, VD.get = function(e25) {
  for (var t2 = this._compare, r2 = this.root; r2; ) {
    var n2 = t2(e25, r2.key);
    if (n2 === 0)
      return r2.value;
    r2 = n2 <= 0 ? r2.left : r2.right;
  }
};
var GD = $D.prototype;
function zD(e25, t2) {
  e25.key = t2.key, e25.value = t2.value, e25.left = t2.left, e25.right = t2.right, e25._color = t2._color, e25._count = t2._count;
}
function HD(e25, t2) {
  return e25 < t2 ? -1 : e25 > t2 ? 1 : 0;
}
Object.defineProperty(GD, "valid", { get: function() {
  return this._stack.length > 0;
} }), Object.defineProperty(GD, "node", { get: function() {
  return this._stack.length > 0 ? this._stack[this._stack.length - 1] : null;
}, enumerable: true }), GD.clone = function() {
  return new $D(this.tree, this._stack.slice());
}, GD.remove = function() {
  var e25 = this._stack;
  if (e25.length === 0)
    return this.tree;
  var t2 = new Array(e25.length), r2 = e25[e25.length - 1];
  t2[t2.length - 1] = new LD(r2._color, r2.key, r2.value, r2.left, r2.right, r2._count);
  for (var n2 = e25.length - 2; n2 >= 0; --n2) {
    (r2 = e25[n2]).left === e25[n2 + 1] ? t2[n2] = new LD(r2._color, r2.key, r2.value, t2[n2 + 1], r2.right, r2._count) : t2[n2] = new LD(r2._color, r2.key, r2.value, r2.left, t2[n2 + 1], r2._count);
  }
  if ((r2 = t2[t2.length - 1]).left && r2.right) {
    var i2 = t2.length;
    for (r2 = r2.left; r2.right; )
      t2.push(r2), r2 = r2.right;
    var a2 = t2[i2 - 1];
    t2.push(new LD(r2._color, a2.key, a2.value, r2.left, r2.right, r2._count)), t2[i2 - 1].key = r2.key, t2[i2 - 1].value = r2.value;
    for (n2 = t2.length - 2; n2 >= i2; --n2)
      r2 = t2[n2], t2[n2] = new LD(r2._color, r2.key, r2.value, r2.left, t2[n2 + 1], r2._count);
    t2[i2 - 1].left = t2[i2];
  }
  if ((r2 = t2[t2.length - 1])._color === BD) {
    var o2 = t2[t2.length - 2];
    o2.left === r2 ? o2.left = null : o2.right === r2 && (o2.right = null), t2.pop();
    for (n2 = 0; n2 < t2.length; ++n2)
      t2[n2]._count--;
    return new MD(this.tree._compare, t2[0]);
  }
  if (r2.left || r2.right) {
    r2.left ? zD(r2, r2.left) : r2.right && zD(r2, r2.right), r2._color = OD;
    for (n2 = 0; n2 < t2.length - 1; ++n2)
      t2[n2]._count--;
    return new MD(this.tree._compare, t2[0]);
  }
  if (t2.length === 1)
    return new MD(this.tree._compare, null);
  for (n2 = 0; n2 < t2.length; ++n2)
    t2[n2]._count--;
  var s2 = t2[t2.length - 2];
  return function(e26) {
    for (var t3, r3, n3, i3, a3 = e26.length - 1; a3 >= 0; --a3) {
      if (t3 = e26[a3], a3 === 0)
        return void (t3._color = OD);
      if ((r3 = e26[a3 - 1]).left === t3) {
        if ((n3 = r3.right).right && n3.right._color === BD) {
          if (i3 = (n3 = r3.right = ND(n3)).right = ND(n3.right), r3.right = n3.left, n3.left = r3, n3.right = i3, n3._color = r3._color, t3._color = OD, r3._color = OD, i3._color = OD, RD(r3), RD(n3), a3 > 1)
            (o3 = e26[a3 - 2]).left === r3 ? o3.left = n3 : o3.right = n3;
          return void (e26[a3 - 1] = n3);
        }
        if (n3.left && n3.left._color === BD) {
          if (i3 = (n3 = r3.right = ND(n3)).left = ND(n3.left), r3.right = i3.left, n3.left = i3.right, i3.left = r3, i3.right = n3, i3._color = r3._color, r3._color = OD, n3._color = OD, t3._color = OD, RD(r3), RD(n3), RD(i3), a3 > 1)
            (o3 = e26[a3 - 2]).left === r3 ? o3.left = i3 : o3.right = i3;
          return void (e26[a3 - 1] = i3);
        }
        if (n3._color === OD) {
          if (r3._color === BD)
            return r3._color = OD, void (r3.right = jD(BD, n3));
          r3.right = jD(BD, n3);
          continue;
        }
        n3 = ND(n3), r3.right = n3.left, n3.left = r3, n3._color = r3._color, r3._color = BD, RD(r3), RD(n3), a3 > 1 && ((o3 = e26[a3 - 2]).left === r3 ? o3.left = n3 : o3.right = n3), e26[a3 - 1] = n3, e26[a3] = r3, a3 + 1 < e26.length ? e26[a3 + 1] = t3 : e26.push(t3), a3 += 2;
      } else {
        if ((n3 = r3.left).left && n3.left._color === BD) {
          if (i3 = (n3 = r3.left = ND(n3)).left = ND(n3.left), r3.left = n3.right, n3.right = r3, n3.left = i3, n3._color = r3._color, t3._color = OD, r3._color = OD, i3._color = OD, RD(r3), RD(n3), a3 > 1)
            (o3 = e26[a3 - 2]).right === r3 ? o3.right = n3 : o3.left = n3;
          return void (e26[a3 - 1] = n3);
        }
        if (n3.right && n3.right._color === BD) {
          if (i3 = (n3 = r3.left = ND(n3)).right = ND(n3.right), r3.left = i3.right, n3.right = i3.left, i3.right = r3, i3.left = n3, i3._color = r3._color, r3._color = OD, n3._color = OD, t3._color = OD, RD(r3), RD(n3), RD(i3), a3 > 1)
            (o3 = e26[a3 - 2]).right === r3 ? o3.right = i3 : o3.left = i3;
          return void (e26[a3 - 1] = i3);
        }
        if (n3._color === OD) {
          if (r3._color === BD)
            return r3._color = OD, void (r3.left = jD(BD, n3));
          r3.left = jD(BD, n3);
          continue;
        }
        var o3;
        n3 = ND(n3), r3.left = n3.right, n3.right = r3, n3._color = r3._color, r3._color = BD, RD(r3), RD(n3), a3 > 1 && ((o3 = e26[a3 - 2]).right === r3 ? o3.right = n3 : o3.left = n3), e26[a3 - 1] = n3, e26[a3] = r3, a3 + 1 < e26.length ? e26[a3 + 1] = t3 : e26.push(t3), a3 += 2;
      }
    }
  }(t2), s2.left === r2 ? s2.left = null : s2.right = null, new MD(this.tree._compare, t2[0]);
}, Object.defineProperty(GD, "key", { get: function() {
  if (this._stack.length > 0)
    return this._stack[this._stack.length - 1].key;
}, enumerable: true }), Object.defineProperty(GD, "value", { get: function() {
  if (this._stack.length > 0)
    return this._stack[this._stack.length - 1].value;
}, enumerable: true }), Object.defineProperty(GD, "index", { get: function() {
  var e25 = 0, t2 = this._stack;
  if (t2.length === 0) {
    var r2 = this.tree.root;
    return r2 ? r2._count : 0;
  }
  t2[t2.length - 1].left && (e25 = t2[t2.length - 1].left._count);
  for (var n2 = t2.length - 2; n2 >= 0; --n2)
    t2[n2 + 1] === t2[n2].right && (++e25, t2[n2].left && (e25 += t2[n2].left._count));
  return e25;
}, enumerable: true }), GD.next = function() {
  var e25 = this._stack;
  if (e25.length !== 0) {
    var t2 = e25[e25.length - 1];
    if (t2.right)
      for (t2 = t2.right; t2; )
        e25.push(t2), t2 = t2.left;
    else
      for (e25.pop(); e25.length > 0 && e25[e25.length - 1].right === t2; )
        t2 = e25[e25.length - 1], e25.pop();
  }
}, Object.defineProperty(GD, "hasNext", { get: function() {
  var e25 = this._stack;
  if (e25.length === 0)
    return false;
  if (e25[e25.length - 1].right)
    return true;
  for (var t2 = e25.length - 1; t2 > 0; --t2)
    if (e25[t2 - 1].left === e25[t2])
      return true;
  return false;
} }), GD.update = function(e25) {
  var t2 = this._stack;
  if (t2.length === 0)
    throw new Error("Can't update empty node!");
  var r2 = new Array(t2.length), n2 = t2[t2.length - 1];
  r2[r2.length - 1] = new LD(n2._color, n2.key, e25, n2.left, n2.right, n2._count);
  for (var i2 = t2.length - 2; i2 >= 0; --i2)
    (n2 = t2[i2]).left === t2[i2 + 1] ? r2[i2] = new LD(n2._color, n2.key, n2.value, r2[i2 + 1], n2.right, n2._count) : r2[i2] = new LD(n2._color, n2.key, n2.value, n2.left, r2[i2 + 1], n2._count);
  return new MD(this.tree._compare, r2[0]);
}, GD.prev = function() {
  var e25 = this._stack;
  if (e25.length !== 0) {
    var t2 = e25[e25.length - 1];
    if (t2.left)
      for (t2 = t2.left; t2; )
        e25.push(t2), t2 = t2.right;
    else
      for (e25.pop(); e25.length > 0 && e25[e25.length - 1].left === t2; )
        t2 = e25[e25.length - 1], e25.pop();
  }
}, Object.defineProperty(GD, "hasPrev", { get: function() {
  var e25 = this._stack;
  if (e25.length === 0)
    return false;
  if (e25[e25.length - 1].left)
    return true;
  for (var t2 = e25.length - 1; t2 > 0; --t2)
    if (e25[t2 - 1].right === e25[t2])
      return true;
  return false;
} });
var KD = Object.freeze({});
function JD(e25) {
  return !(e25 < 48) && (e25 < 58 || !(e25 < 65) && (e25 < 91 || (e25 === 95 || !(e25 < 97) && (e25 < 123 || (QD(e25) || function(e26) {
    if (e26 < 7376)
      return e26 < 3458 ? e26 < 2691 ? e26 < 2363 ? e26 < 1770 ? e26 < 1479 ? e26 === 183 || !(e26 < 768) && (e26 < 880 || (e26 === 903 || !(e26 < 1155) && (e26 < 1160 || !(e26 < 1425) && (e26 < 1470 || (e26 === 1471 || !(e26 < 1473) && (e26 < 1475 || !(e26 < 1476) && e26 < 1478)))))) : e26 === 1479 || !(e26 < 1552) && (e26 < 1563 || !(e26 < 1611) && (e26 < 1632 || !(e26 < 1632) && (e26 < 1642 || (e26 === 1648 || !(e26 < 1750) && (e26 < 1757 || !(e26 < 1759) && (e26 < 1765 || !(e26 < 1767) && e26 < 1769)))))) : e26 < 2070 ? !(e26 < 1770) && (e26 < 1774 || !(e26 < 1776) && (e26 < 1786 || (e26 === 1809 || !(e26 < 1840) && (e26 < 1867 || !(e26 < 1958) && (e26 < 1969 || !(e26 < 1984) && (e26 < 1994 || !(e26 < 2027) && (e26 < 2036 || e26 === 2045))))))) : e26 < 2074 || !(e26 < 2075) && (e26 < 2084 || !(e26 < 2085) && (e26 < 2088 || !(e26 < 2089) && (e26 < 2094 || !(e26 < 2137) && (e26 < 2140 || !(e26 < 2259) && (e26 < 2274 || !(e26 < 2275) && (e26 < 2307 || (e26 === 2307 || e26 === 2362))))))) : e26 < 2509 ? e26 < 2402 ? e26 === 2363 || (e26 === 2364 || !(e26 < 2366) && (e26 < 2369 || !(e26 < 2369) && (e26 < 2377 || !(e26 < 2377) && (e26 < 2381 || (e26 === 2381 || !(e26 < 2382) && (e26 < 2384 || !(e26 < 2385) && e26 < 2392)))))) : e26 < 2404 || !(e26 < 2406) && (e26 < 2416 || (e26 === 2433 || !(e26 < 2434) && (e26 < 2436 || (e26 === 2492 || !(e26 < 2494) && (e26 < 2497 || !(e26 < 2497) && (e26 < 2501 || !(e26 < 2503) && (e26 < 2505 || !(e26 < 2507) && e26 < 2509))))))) : e26 < 2622 ? e26 === 2509 || (e26 === 2519 || !(e26 < 2530) && (e26 < 2532 || !(e26 < 2534) && (e26 < 2544 || (e26 === 2558 || !(e26 < 2561) && (e26 < 2563 || (e26 === 2563 || e26 === 2620)))))) : e26 < 2625 || !(e26 < 2625) && (e26 < 2627 || !(e26 < 2631) && (e26 < 2633 || !(e26 < 2635) && (e26 < 2638 || (e26 === 2641 || !(e26 < 2662) && (e26 < 2672 || !(e26 < 2672) && (e26 < 2674 || (e26 === 2677 || !(e26 < 2689) && e26 < 2691))))))) : e26 < 3072 ? e26 < 2881 ? e26 < 2786 ? e26 === 2691 || (e26 === 2748 || !(e26 < 2750) && (e26 < 2753 || !(e26 < 2753) && (e26 < 2758 || !(e26 < 2759) && (e26 < 2761 || (e26 === 2761 || !(e26 < 2763) && (e26 < 2765 || e26 === 2765)))))) : e26 < 2788 || !(e26 < 2790) && (e26 < 2800 || !(e26 < 2810) && (e26 < 2816 || (e26 === 2817 || !(e26 < 2818) && (e26 < 2820 || (e26 === 2876 || (e26 === 2878 || (e26 === 2879 || e26 === 2880))))))) : e26 < 2946 ? !(e26 < 2881) && (e26 < 2885 || !(e26 < 2887) && (e26 < 2889 || !(e26 < 2891) && (e26 < 2893 || (e26 === 2893 || (e26 === 2902 || (e26 === 2903 || !(e26 < 2914) && (e26 < 2916 || !(e26 < 2918) && e26 < 2928))))))) : e26 === 2946 || !(e26 < 3006) && (e26 < 3008 || (e26 === 3008 || !(e26 < 3009) && (e26 < 3011 || !(e26 < 3014) && (e26 < 3017 || !(e26 < 3018) && (e26 < 3021 || (e26 === 3021 || (e26 === 3031 || !(e26 < 3046) && e26 < 3056))))))) : e26 < 3271 ? e26 < 3170 ? e26 === 3072 || !(e26 < 3073) && (e26 < 3076 || (e26 === 3076 || !(e26 < 3134) && (e26 < 3137 || !(e26 < 3137) && (e26 < 3141 || !(e26 < 3142) && (e26 < 3145 || !(e26 < 3146) && (e26 < 3150 || !(e26 < 3157) && e26 < 3159)))))) : e26 < 3172 || !(e26 < 3174) && (e26 < 3184 || (e26 === 3201 || !(e26 < 3202) && (e26 < 3204 || (e26 === 3260 || (e26 === 3262 || (e26 === 3263 || !(e26 < 3264) && (e26 < 3269 || e26 === 3270))))))) : e26 < 3387 ? !(e26 < 3271) && (e26 < 3273 || !(e26 < 3274) && (e26 < 3276 || !(e26 < 3276) && (e26 < 3278 || !(e26 < 3285) && (e26 < 3287 || !(e26 < 3298) && (e26 < 3300 || !(e26 < 3302) && (e26 < 3312 || !(e26 < 3328) && (e26 < 3330 || !(e26 < 3330) && e26 < 3332))))))) : e26 < 3389 || !(e26 < 3390) && (e26 < 3393 || !(e26 < 3393) && (e26 < 3397 || !(e26 < 3398) && (e26 < 3401 || !(e26 < 3402) && (e26 < 3405 || (e26 === 3405 || (e26 === 3415 || !(e26 < 3426) && (e26 < 3428 || !(e26 < 3430) && e26 < 3440))))))) : e26 < 6112 ? e26 < 4152 ? e26 < 3864 ? e26 < 3633 ? !(e26 < 3458) && (e26 < 3460 || (e26 === 3530 || !(e26 < 3535) && (e26 < 3538 || !(e26 < 3538) && (e26 < 3541 || (e26 === 3542 || !(e26 < 3544) && (e26 < 3552 || !(e26 < 3558) && (e26 < 3568 || !(e26 < 3570) && e26 < 3572))))))) : e26 === 3633 || !(e26 < 3636) && (e26 < 3643 || !(e26 < 3655) && (e26 < 3663 || !(e26 < 3664) && (e26 < 3674 || (e26 === 3761 || !(e26 < 3764) && (e26 < 3770 || !(e26 < 3771) && (e26 < 3773 || !(e26 < 3784) && (e26 < 3790 || !(e26 < 3792) && e26 < 3802))))))) : e26 < 3968 ? !(e26 < 3864) && (e26 < 3866 || !(e26 < 3872) && (e26 < 3882 || (e26 === 3893 || (e26 === 3895 || (e26 === 3897 || !(e26 < 3902) && (e26 < 3904 || !(e26 < 3953) && (e26 < 3967 || e26 === 3967))))))) : e26 < 3973 || !(e26 < 3974) && (e26 < 3976 || !(e26 < 3981) && (e26 < 3992 || !(e26 < 3993) && (e26 < 4029 || (e26 === 4038 || !(e26 < 4139) && (e26 < 4141 || !(e26 < 4141) && (e26 < 4145 || (e26 === 4145 || !(e26 < 4146) && e26 < 4152))))))) : e26 < 4240 ? e26 < 4194 ? e26 === 4152 || !(e26 < 4153) && (e26 < 4155 || !(e26 < 4155) && (e26 < 4157 || !(e26 < 4157) && (e26 < 4159 || !(e26 < 4160) && (e26 < 4170 || !(e26 < 4182) && (e26 < 4184 || !(e26 < 4184) && (e26 < 4186 || !(e26 < 4190) && e26 < 4193)))))) : e26 < 4197 || !(e26 < 4199) && (e26 < 4206 || !(e26 < 4209) && (e26 < 4213 || (e26 === 4226 || !(e26 < 4227) && (e26 < 4229 || !(e26 < 4229) && (e26 < 4231 || !(e26 < 4231) && (e26 < 4237 || (e26 === 4237 || e26 === 4239))))))) : e26 < 6002 ? !(e26 < 4240) && (e26 < 4250 || !(e26 < 4250) && (e26 < 4253 || (e26 === 4253 || !(e26 < 4957) && (e26 < 4960 || !(e26 < 4969) && (e26 < 4978 || !(e26 < 5906) && (e26 < 5909 || !(e26 < 5938) && (e26 < 5941 || !(e26 < 5970) && e26 < 5972))))))) : e26 < 6004 || !(e26 < 6068) && (e26 < 6070 || (e26 === 6070 || !(e26 < 6071) && (e26 < 6078 || !(e26 < 6078) && (e26 < 6086 || (e26 === 6086 || !(e26 < 6087) && (e26 < 6089 || !(e26 < 6089) && (e26 < 6100 || e26 === 6109))))))) : e26 < 6916 ? e26 < 6683 ? e26 < 6448 ? !(e26 < 6112) && (e26 < 6122 || !(e26 < 6155) && (e26 < 6158 || !(e26 < 6160) && (e26 < 6170 || (e26 === 6313 || !(e26 < 6432) && (e26 < 6435 || !(e26 < 6435) && (e26 < 6439 || !(e26 < 6439) && (e26 < 6441 || !(e26 < 6441) && e26 < 6444))))))) : e26 < 6450 || (e26 === 6450 || !(e26 < 6451) && (e26 < 6457 || !(e26 < 6457) && (e26 < 6460 || !(e26 < 6470) && (e26 < 6480 || !(e26 < 6608) && (e26 < 6618 || (e26 === 6618 || !(e26 < 6679) && (e26 < 6681 || !(e26 < 6681) && e26 < 6683))))))) : e26 < 6755 ? e26 === 6683 || (e26 === 6741 || (e26 === 6742 || (e26 === 6743 || !(e26 < 6744) && (e26 < 6751 || (e26 === 6752 || (e26 === 6753 || e26 === 6754)))))) : e26 < 6757 || !(e26 < 6757) && (e26 < 6765 || !(e26 < 6765) && (e26 < 6771 || !(e26 < 6771) && (e26 < 6781 || (e26 === 6783 || !(e26 < 6784) && (e26 < 6794 || !(e26 < 6800) && (e26 < 6810 || !(e26 < 6832) && (e26 < 6846 || !(e26 < 6912) && e26 < 6916))))))) : e26 < 7082 ? e26 < 6979 ? e26 === 6916 || (e26 === 6964 || (e26 === 6965 || !(e26 < 6966) && (e26 < 6971 || (e26 === 6971 || (e26 === 6972 || !(e26 < 6973) && (e26 < 6978 || e26 === 6978)))))) : e26 < 6981 || !(e26 < 6992) && (e26 < 7002 || !(e26 < 7019) && (e26 < 7028 || !(e26 < 7040) && (e26 < 7042 || (e26 === 7042 || (e26 === 7073 || !(e26 < 7074) && (e26 < 7078 || !(e26 < 7078) && (e26 < 7080 || !(e26 < 7080) && e26 < 7082))))))) : e26 < 7150 ? e26 === 7082 || !(e26 < 7083) && (e26 < 7086 || !(e26 < 7088) && (e26 < 7098 || (e26 === 7142 || (e26 === 7143 || !(e26 < 7144) && (e26 < 7146 || !(e26 < 7146) && (e26 < 7149 || e26 === 7149)))))) : e26 === 7150 || !(e26 < 7151) && (e26 < 7154 || !(e26 < 7154) && (e26 < 7156 || !(e26 < 7204) && (e26 < 7212 || !(e26 < 7212) && (e26 < 7220 || !(e26 < 7220) && (e26 < 7222 || !(e26 < 7222) && (e26 < 7224 || !(e26 < 7232) && (e26 < 7242 || !(e26 < 7248) && e26 < 7258)))))));
    if (e26 < 70206)
      return e26 < 43703 ? e26 < 43188 ? e26 < 11647 ? e26 < 7416 ? !(e26 < 7376) && (e26 < 7379 || !(e26 < 7380) && (e26 < 7393 || (e26 === 7393 || !(e26 < 7394) && (e26 < 7401 || (e26 === 7405 || !(e26 < 7410) && (e26 < 7412 || (e26 === 7412 || e26 === 7415))))))) : e26 < 7418 || !(e26 < 7616) && (e26 < 7674 || !(e26 < 7675) && (e26 < 7680 || !(e26 < 8255) && (e26 < 8257 || (e26 === 8276 || !(e26 < 8400) && (e26 < 8413 || (e26 === 8417 || !(e26 < 8421) && (e26 < 8433 || !(e26 < 11503) && e26 < 11506))))))) : e26 < 42654 ? e26 === 11647 || !(e26 < 11744) && (e26 < 11776 || !(e26 < 12330) && (e26 < 12334 || !(e26 < 12334) && (e26 < 12336 || !(e26 < 12441) && (e26 < 12443 || !(e26 < 42528) && (e26 < 42538 || (e26 === 42607 || !(e26 < 42612) && e26 < 42622)))))) : e26 < 42656 || !(e26 < 42736) && (e26 < 42738 || (e26 === 43010 || (e26 === 43014 || (e26 === 43019 || !(e26 < 43043) && (e26 < 43045 || !(e26 < 43045) && (e26 < 43047 || (e26 === 43047 || !(e26 < 43136) && e26 < 43138))))))) : e26 < 43472 ? e26 < 43346 ? !(e26 < 43188) && (e26 < 43204 || !(e26 < 43204) && (e26 < 43206 || !(e26 < 43216) && (e26 < 43226 || !(e26 < 43232) && (e26 < 43250 || (e26 === 43263 || !(e26 < 43264) && (e26 < 43274 || !(e26 < 43302) && (e26 < 43310 || !(e26 < 43335) && e26 < 43346))))))) : e26 < 43348 || !(e26 < 43392) && (e26 < 43395 || (e26 === 43395 || (e26 === 43443 || !(e26 < 43444) && (e26 < 43446 || !(e26 < 43446) && (e26 < 43450 || !(e26 < 43450) && (e26 < 43452 || (e26 === 43452 || !(e26 < 43453) && e26 < 43457))))))) : e26 < 43587 ? !(e26 < 43472) && (e26 < 43482 || (e26 === 43493 || !(e26 < 43504) && (e26 < 43514 || !(e26 < 43561) && (e26 < 43567 || !(e26 < 43567) && (e26 < 43569 || !(e26 < 43569) && (e26 < 43571 || !(e26 < 43571) && (e26 < 43573 || !(e26 < 43573) && e26 < 43575))))))) : e26 === 43587 || (e26 === 43596 || (e26 === 43597 || !(e26 < 43600) && (e26 < 43610 || (e26 === 43643 || (e26 === 43644 || (e26 === 43645 || (e26 === 43696 || !(e26 < 43698) && e26 < 43701))))))) : e26 < 68912 ? e26 < 65024 ? e26 < 44003 ? !(e26 < 43703) && (e26 < 43705 || !(e26 < 43710) && (e26 < 43712 || (e26 === 43713 || (e26 === 43755 || !(e26 < 43756) && (e26 < 43758 || !(e26 < 43758) && (e26 < 43760 || (e26 === 43765 || e26 === 43766))))))) : e26 < 44005 || (e26 === 44005 || !(e26 < 44006) && (e26 < 44008 || (e26 === 44008 || !(e26 < 44009) && (e26 < 44011 || (e26 === 44012 || (e26 === 44013 || !(e26 < 44016) && (e26 < 44026 || e26 === 64286))))))) : e26 < 66422 ? !(e26 < 65024) && (e26 < 65040 || !(e26 < 65056) && (e26 < 65072 || !(e26 < 65075) && (e26 < 65077 || !(e26 < 65101) && (e26 < 65104 || !(e26 < 65296) && (e26 < 65306 || (e26 === 65343 || (e26 === 66045 || e26 === 66272))))))) : e26 < 66427 || !(e26 < 66720) && (e26 < 66730 || !(e26 < 68097) && (e26 < 68100 || !(e26 < 68101) && (e26 < 68103 || !(e26 < 68108) && (e26 < 68112 || !(e26 < 68152) && (e26 < 68155 || (e26 === 68159 || !(e26 < 68325) && (e26 < 68327 || !(e26 < 68900) && e26 < 68904))))))) : e26 < 69933 ? e26 < 69762 ? !(e26 < 68912) && (e26 < 68922 || !(e26 < 69446) && (e26 < 69457 || (e26 === 69632 || (e26 === 69633 || (e26 === 69634 || !(e26 < 69688) && (e26 < 69703 || !(e26 < 69734) && (e26 < 69744 || !(e26 < 69759) && e26 < 69762))))))) : e26 === 69762 || !(e26 < 69808) && (e26 < 69811 || !(e26 < 69811) && (e26 < 69815 || !(e26 < 69815) && (e26 < 69817 || !(e26 < 69817) && (e26 < 69819 || !(e26 < 69872) && (e26 < 69882 || !(e26 < 69888) && (e26 < 69891 || !(e26 < 69927) && (e26 < 69932 || e26 === 69932))))))) : e26 < 70079 ? !(e26 < 69933) && (e26 < 69941 || !(e26 < 69942) && (e26 < 69952 || !(e26 < 69957) && (e26 < 69959 || (e26 === 70003 || !(e26 < 70016) && (e26 < 70018 || (e26 === 70018 || !(e26 < 70067) && (e26 < 70070 || !(e26 < 70070) && e26 < 70079))))))) : e26 < 70081 || !(e26 < 70089) && (e26 < 70093 || !(e26 < 70096) && (e26 < 70106 || !(e26 < 70188) && (e26 < 70191 || !(e26 < 70191) && (e26 < 70194 || !(e26 < 70194) && (e26 < 70196 || (e26 === 70196 || (e26 === 70197 || !(e26 < 70198) && e26 < 70200)))))));
    if (e26 < 72243)
      return e26 < 71087 ? e26 < 70709 ? e26 < 70462 ? e26 === 70206 || (e26 === 70367 || !(e26 < 70368) && (e26 < 70371 || !(e26 < 70371) && (e26 < 70379 || !(e26 < 70384) && (e26 < 70394 || !(e26 < 70400) && (e26 < 70402 || !(e26 < 70402) && (e26 < 70404 || !(e26 < 70459) && e26 < 70461)))))) : e26 < 70464 || (e26 === 70464 || !(e26 < 70465) && (e26 < 70469 || !(e26 < 70471) && (e26 < 70473 || !(e26 < 70475) && (e26 < 70478 || (e26 === 70487 || !(e26 < 70498) && (e26 < 70500 || !(e26 < 70502) && (e26 < 70509 || !(e26 < 70512) && e26 < 70517))))))) : e26 < 70832 ? !(e26 < 70709) && (e26 < 70712 || !(e26 < 70712) && (e26 < 70720 || !(e26 < 70720) && (e26 < 70722 || !(e26 < 70722) && (e26 < 70725 || (e26 === 70725 || (e26 === 70726 || !(e26 < 70736) && (e26 < 70746 || e26 === 70750))))))) : e26 < 70835 || !(e26 < 70835) && (e26 < 70841 || (e26 === 70841 || (e26 === 70842 || !(e26 < 70843) && (e26 < 70847 || !(e26 < 70847) && (e26 < 70849 || (e26 === 70849 || !(e26 < 70850) && (e26 < 70852 || !(e26 < 70864) && e26 < 70874))))))) : e26 < 71342 ? e26 < 71219 ? !(e26 < 71087) && (e26 < 71090 || !(e26 < 71090) && (e26 < 71094 || !(e26 < 71096) && (e26 < 71100 || !(e26 < 71100) && (e26 < 71102 || (e26 === 71102 || !(e26 < 71103) && (e26 < 71105 || !(e26 < 71132) && (e26 < 71134 || !(e26 < 71216) && e26 < 71219))))))) : e26 < 71227 || !(e26 < 71227) && (e26 < 71229 || (e26 === 71229 || (e26 === 71230 || !(e26 < 71231) && (e26 < 71233 || !(e26 < 71248) && (e26 < 71258 || (e26 === 71339 || (e26 === 71340 || e26 === 71341))))))) : e26 < 71462 ? !(e26 < 71342) && (e26 < 71344 || !(e26 < 71344) && (e26 < 71350 || (e26 === 71350 || (e26 === 71351 || !(e26 < 71360) && (e26 < 71370 || !(e26 < 71453) && (e26 < 71456 || !(e26 < 71456) && (e26 < 71458 || !(e26 < 71458) && e26 < 71462))))))) : e26 === 71462 || !(e26 < 71463) && (e26 < 71468 || !(e26 < 71472) && (e26 < 71482 || !(e26 < 71724) && (e26 < 71727 || !(e26 < 71727) && (e26 < 71736 || (e26 === 71736 || !(e26 < 71737) && (e26 < 71739 || !(e26 < 71904) && (e26 < 71914 || !(e26 < 72193) && e26 < 72203)))))));
    if (e26 < 73111)
      return e26 < 72873 ? e26 < 72343 ? !(e26 < 72243) && (e26 < 72249 || (e26 === 72249 || !(e26 < 72251) && (e26 < 72255 || (e26 === 72263 || !(e26 < 72273) && (e26 < 72279 || !(e26 < 72279) && (e26 < 72281 || !(e26 < 72281) && (e26 < 72284 || !(e26 < 72330) && e26 < 72343))))))) : e26 === 72343 || !(e26 < 72344) && (e26 < 72346 || (e26 === 72751 || !(e26 < 72752) && (e26 < 72759 || !(e26 < 72760) && (e26 < 72766 || (e26 === 72766 || (e26 === 72767 || !(e26 < 72784) && (e26 < 72794 || !(e26 < 72850) && e26 < 72872))))))) : e26 < 73020 ? e26 === 72873 || !(e26 < 72874) && (e26 < 72881 || (e26 === 72881 || !(e26 < 72882) && (e26 < 72884 || (e26 === 72884 || !(e26 < 72885) && (e26 < 72887 || !(e26 < 73009) && (e26 < 73015 || e26 === 73018)))))) : e26 < 73022 || !(e26 < 73023) && (e26 < 73030 || (e26 === 73031 || !(e26 < 73040) && (e26 < 73050 || !(e26 < 73098) && (e26 < 73103 || !(e26 < 73104) && (e26 < 73106 || !(e26 < 73107) && (e26 < 73109 || (e26 === 73109 || e26 === 73110)))))));
    if (e26 < 119362)
      return e26 < 94033 ? e26 === 73111 || !(e26 < 73120) && (e26 < 73130 || !(e26 < 73459) && (e26 < 73461 || !(e26 < 73461) && (e26 < 73463 || !(e26 < 92768) && (e26 < 92778 || !(e26 < 92912) && (e26 < 92917 || !(e26 < 92976) && (e26 < 92983 || !(e26 < 93008) && e26 < 93018)))))) : e26 < 94079 || !(e26 < 94095) && (e26 < 94099 || !(e26 < 113821) && (e26 < 113823 || !(e26 < 119141) && (e26 < 119143 || !(e26 < 119143) && (e26 < 119146 || !(e26 < 119149) && (e26 < 119155 || !(e26 < 119163) && (e26 < 119171 || !(e26 < 119173) && (e26 < 119180 || !(e26 < 119210) && e26 < 119214)))))));
    if (e26 < 122880)
      return !(e26 < 119362) && (e26 < 119365 || !(e26 < 120782) && (e26 < 120832 || !(e26 < 121344) && (e26 < 121399 || !(e26 < 121403) && (e26 < 121453 || (e26 === 121461 || (e26 === 121476 || !(e26 < 121499) && (e26 < 121504 || !(e26 < 121505) && e26 < 121520)))))));
    return e26 < 122887 || !(e26 < 122888) && (e26 < 122905 || !(e26 < 122907) && (e26 < 122914 || !(e26 < 122915) && (e26 < 122917 || !(e26 < 122918) && (e26 < 122923 || !(e26 < 125136) && (e26 < 125143 || !(e26 < 125252) && (e26 < 125259 || !(e26 < 125264) && (e26 < 125274 || !(e26 < 917760) && e26 < 918e3)))))));
  }(e25))))));
}
function QD(e25) {
  return e25 < 12449 ? e25 < 3776 ? e25 < 2613 ? e25 < 1765 ? e25 < 890 ? e25 < 660 ? e25 < 248 ? e25 === 170 || (e25 === 181 || (e25 === 186 || !(e25 < 192) && (e25 < 215 || !(e25 < 216) && e25 < 247))) : e25 < 443 || (e25 === 443 || !(e25 < 444) && (e25 < 448 || !(e25 < 448) && (e25 < 452 || !(e25 < 452) && e25 < 660))) : e25 < 748 ? e25 === 660 || !(e25 < 661) && (e25 < 688 || !(e25 < 688) && (e25 < 706 || !(e25 < 710) && (e25 < 722 || !(e25 < 736) && e25 < 741))) : e25 === 748 || (e25 === 750 || !(e25 < 880) && (e25 < 884 || (e25 === 884 || !(e25 < 886) && e25 < 888))) : e25 < 1329 ? e25 < 908 ? e25 === 890 || !(e25 < 891) && (e25 < 894 || (e25 === 895 || (e25 === 902 || !(e25 < 904) && e25 < 907))) : e25 === 908 || !(e25 < 910) && (e25 < 930 || !(e25 < 931) && (e25 < 1014 || !(e25 < 1015) && (e25 < 1154 || !(e25 < 1162) && e25 < 1328))) : e25 < 1568 ? !(e25 < 1329) && (e25 < 1367 || (e25 === 1369 || !(e25 < 1376) && (e25 < 1417 || !(e25 < 1488) && (e25 < 1515 || !(e25 < 1519) && e25 < 1523)))) : e25 < 1600 || (e25 === 1600 || !(e25 < 1601) && (e25 < 1611 || !(e25 < 1646) && (e25 < 1648 || !(e25 < 1649) && (e25 < 1748 || e25 === 1749)))) : e25 < 2384 ? e25 < 2042 ? e25 < 1810 ? !(e25 < 1765) && (e25 < 1767 || !(e25 < 1774) && (e25 < 1776 || !(e25 < 1786) && (e25 < 1789 || (e25 === 1791 || e25 === 1808)))) : e25 < 1840 || !(e25 < 1869) && (e25 < 1958 || (e25 === 1969 || !(e25 < 1994) && (e25 < 2027 || !(e25 < 2036) && e25 < 2038))) : e25 < 2112 ? e25 === 2042 || !(e25 < 2048) && (e25 < 2070 || (e25 === 2074 || (e25 === 2084 || e25 === 2088))) : e25 < 2137 || !(e25 < 2144) && (e25 < 2155 || !(e25 < 2208) && (e25 < 2229 || !(e25 < 2230) && (e25 < 2238 || !(e25 < 2308) && (e25 < 2362 || e25 === 2365)))) : e25 < 2493 ? e25 < 2447 ? e25 === 2384 || !(e25 < 2392) && (e25 < 2402 || (e25 === 2417 || !(e25 < 2418) && (e25 < 2433 || !(e25 < 2437) && e25 < 2445))) : e25 < 2449 || !(e25 < 2451) && (e25 < 2473 || !(e25 < 2474) && (e25 < 2481 || (e25 === 2482 || !(e25 < 2486) && e25 < 2490))) : e25 < 2556 ? e25 === 2493 || (e25 === 2510 || !(e25 < 2524) && (e25 < 2526 || !(e25 < 2527) && (e25 < 2530 || !(e25 < 2544) && e25 < 2546))) : e25 === 2556 || !(e25 < 2565) && (e25 < 2571 || !(e25 < 2575) && (e25 < 2577 || !(e25 < 2579) && (e25 < 2601 || !(e25 < 2602) && (e25 < 2609 || !(e25 < 2610) && e25 < 2612)))) : e25 < 3168 ? e25 < 2877 ? e25 < 2741 ? e25 < 2693 ? !(e25 < 2613) && (e25 < 2615 || !(e25 < 2616) && (e25 < 2618 || !(e25 < 2649) && (e25 < 2653 || (e25 === 2654 || !(e25 < 2674) && e25 < 2677)))) : e25 < 2702 || !(e25 < 2703) && (e25 < 2706 || !(e25 < 2707) && (e25 < 2729 || !(e25 < 2730) && (e25 < 2737 || !(e25 < 2738) && e25 < 2740))) : e25 < 2821 ? !(e25 < 2741) && (e25 < 2746 || (e25 === 2749 || (e25 === 2768 || !(e25 < 2784) && (e25 < 2786 || e25 === 2809)))) : e25 < 2829 || !(e25 < 2831) && (e25 < 2833 || !(e25 < 2835) && (e25 < 2857 || !(e25 < 2858) && (e25 < 2865 || !(e25 < 2866) && (e25 < 2868 || !(e25 < 2869) && e25 < 2874)))) : e25 < 2974 ? e25 < 2949 ? e25 === 2877 || !(e25 < 2908) && (e25 < 2910 || !(e25 < 2911) && (e25 < 2914 || (e25 === 2929 || e25 === 2947))) : e25 < 2955 || !(e25 < 2958) && (e25 < 2961 || !(e25 < 2962) && (e25 < 2966 || !(e25 < 2969) && (e25 < 2971 || e25 === 2972))) : e25 < 3077 ? !(e25 < 2974) && (e25 < 2976 || !(e25 < 2979) && (e25 < 2981 || !(e25 < 2984) && (e25 < 2987 || !(e25 < 2990) && (e25 < 3002 || e25 === 3024)))) : e25 < 3085 || !(e25 < 3086) && (e25 < 3089 || !(e25 < 3090) && (e25 < 3113 || !(e25 < 3114) && (e25 < 3130 || (e25 === 3133 || !(e25 < 3160) && e25 < 3163)))) : e25 < 3507 ? e25 < 3313 ? e25 < 3242 ? !(e25 < 3168) && (e25 < 3170 || (e25 === 3200 || !(e25 < 3205) && (e25 < 3213 || !(e25 < 3214) && (e25 < 3217 || !(e25 < 3218) && e25 < 3241)))) : e25 < 3252 || !(e25 < 3253) && (e25 < 3258 || (e25 === 3261 || (e25 === 3294 || !(e25 < 3296) && e25 < 3298))) : e25 < 3406 ? !(e25 < 3313) && (e25 < 3315 || !(e25 < 3333) && (e25 < 3341 || !(e25 < 3342) && (e25 < 3345 || !(e25 < 3346) && (e25 < 3387 || e25 === 3389)))) : e25 === 3406 || !(e25 < 3412) && (e25 < 3415 || !(e25 < 3423) && (e25 < 3426 || !(e25 < 3450) && (e25 < 3456 || !(e25 < 3461) && (e25 < 3479 || !(e25 < 3482) && e25 < 3506)))) : e25 < 3722 ? e25 < 3648 ? !(e25 < 3507) && (e25 < 3516 || (e25 === 3517 || !(e25 < 3520) && (e25 < 3527 || !(e25 < 3585) && (e25 < 3633 || !(e25 < 3634) && e25 < 3636)))) : e25 < 3654 || (e25 === 3654 || !(e25 < 3713) && (e25 < 3715 || (e25 === 3716 || !(e25 < 3719) && e25 < 3721))) : e25 < 3749 ? e25 === 3722 || (e25 === 3725 || !(e25 < 3732) && (e25 < 3736 || !(e25 < 3737) && (e25 < 3744 || !(e25 < 3745) && e25 < 3748))) : e25 === 3749 || (e25 === 3751 || !(e25 < 3754) && (e25 < 3756 || !(e25 < 3757) && (e25 < 3761 || !(e25 < 3762) && (e25 < 3764 || e25 === 3773)))) : e25 < 7401 ? e25 < 5743 ? e25 < 4349 ? e25 < 4186 ? e25 < 3913 ? !(e25 < 3776) && (e25 < 3781 || (e25 === 3782 || !(e25 < 3804) && (e25 < 3808 || (e25 === 3840 || !(e25 < 3904) && e25 < 3912)))) : e25 < 3949 || !(e25 < 3976) && (e25 < 3981 || !(e25 < 4096) && (e25 < 4139 || (e25 === 4159 || !(e25 < 4176) && e25 < 4182))) : e25 < 4238 ? !(e25 < 4186) && (e25 < 4190 || (e25 === 4193 || !(e25 < 4197) && (e25 < 4199 || !(e25 < 4206) && (e25 < 4209 || !(e25 < 4213) && e25 < 4226)))) : e25 === 4238 || !(e25 < 4256) && (e25 < 4294 || (e25 === 4295 || (e25 === 4301 || !(e25 < 4304) && (e25 < 4347 || e25 === 4348)))) : e25 < 4792 ? e25 < 4698 ? !(e25 < 4349) && (e25 < 4352 || !(e25 < 4352) && (e25 < 4681 || !(e25 < 4682) && (e25 < 4686 || !(e25 < 4688) && (e25 < 4695 || e25 === 4696)))) : e25 < 4702 || !(e25 < 4704) && (e25 < 4745 || !(e25 < 4746) && (e25 < 4750 || !(e25 < 4752) && (e25 < 4785 || !(e25 < 4786) && e25 < 4790))) : e25 < 4882 ? !(e25 < 4792) && (e25 < 4799 || (e25 === 4800 || !(e25 < 4802) && (e25 < 4806 || !(e25 < 4808) && (e25 < 4823 || !(e25 < 4824) && e25 < 4881)))) : e25 < 4886 || !(e25 < 4888) && (e25 < 4955 || !(e25 < 4992) && (e25 < 5008 || !(e25 < 5024) && (e25 < 5110 || !(e25 < 5112) && (e25 < 5118 || !(e25 < 5121) && e25 < 5741)))) : e25 < 6320 ? e25 < 5998 ? e25 < 5888 ? !(e25 < 5743) && (e25 < 5760 || !(e25 < 5761) && (e25 < 5787 || !(e25 < 5792) && (e25 < 5867 || !(e25 < 5870) && (e25 < 5873 || !(e25 < 5873) && e25 < 5881)))) : e25 < 5901 || !(e25 < 5902) && (e25 < 5906 || !(e25 < 5920) && (e25 < 5938 || !(e25 < 5952) && (e25 < 5970 || !(e25 < 5984) && e25 < 5997))) : e25 < 6211 ? !(e25 < 5998) && (e25 < 6001 || !(e25 < 6016) && (e25 < 6068 || (e25 === 6103 || (e25 === 6108 || !(e25 < 6176) && e25 < 6211)))) : e25 === 6211 || !(e25 < 6212) && (e25 < 6265 || !(e25 < 6272) && (e25 < 6277 || !(e25 < 6277) && (e25 < 6279 || !(e25 < 6279) && (e25 < 6313 || e25 === 6314)))) : e25 < 6981 ? e25 < 6576 ? !(e25 < 6320) && (e25 < 6390 || !(e25 < 6400) && (e25 < 6431 || !(e25 < 6480) && (e25 < 6510 || !(e25 < 6512) && (e25 < 6517 || !(e25 < 6528) && e25 < 6572)))) : e25 < 6602 || !(e25 < 6656) && (e25 < 6679 || !(e25 < 6688) && (e25 < 6741 || (e25 === 6823 || !(e25 < 6917) && e25 < 6964))) : e25 < 7245 ? !(e25 < 6981) && (e25 < 6988 || !(e25 < 7043) && (e25 < 7073 || !(e25 < 7086) && (e25 < 7088 || !(e25 < 7098) && (e25 < 7142 || !(e25 < 7168) && e25 < 7204)))) : e25 < 7248 || !(e25 < 7258) && (e25 < 7288 || !(e25 < 7288) && (e25 < 7294 || !(e25 < 7296) && (e25 < 7305 || !(e25 < 7312) && (e25 < 7355 || !(e25 < 7357) && e25 < 7360)))) : e25 < 8495 ? e25 < 8130 ? e25 < 7960 ? e25 < 7531 ? !(e25 < 7401) && (e25 < 7405 || !(e25 < 7406) && (e25 < 7410 || !(e25 < 7413) && (e25 < 7415 || !(e25 < 7424) && (e25 < 7468 || !(e25 < 7468) && e25 < 7531)))) : e25 < 7544 || (e25 === 7544 || !(e25 < 7545) && (e25 < 7579 || !(e25 < 7579) && (e25 < 7616 || !(e25 < 7680) && e25 < 7958))) : e25 < 8027 ? !(e25 < 7960) && (e25 < 7966 || !(e25 < 7968) && (e25 < 8006 || !(e25 < 8008) && (e25 < 8014 || !(e25 < 8016) && (e25 < 8024 || e25 === 8025)))) : e25 === 8027 || (e25 === 8029 || !(e25 < 8031) && (e25 < 8062 || !(e25 < 8064) && (e25 < 8117 || !(e25 < 8118) && (e25 < 8125 || e25 === 8126)))) : e25 < 8450 ? e25 < 8178 ? !(e25 < 8130) && (e25 < 8133 || !(e25 < 8134) && (e25 < 8141 || !(e25 < 8144) && (e25 < 8148 || !(e25 < 8150) && (e25 < 8156 || !(e25 < 8160) && e25 < 8173)))) : e25 < 8181 || !(e25 < 8182) && (e25 < 8189 || (e25 === 8305 || (e25 === 8319 || !(e25 < 8336) && e25 < 8349))) : e25 < 8473 ? e25 === 8450 || (e25 === 8455 || !(e25 < 8458) && (e25 < 8468 || (e25 === 8469 || e25 === 8472))) : e25 < 8478 || (e25 === 8484 || (e25 === 8486 || (e25 === 8488 || !(e25 < 8490) && (e25 < 8494 || e25 === 8494)))) : e25 < 11648 ? e25 < 11312 ? e25 < 8526 ? !(e25 < 8495) && (e25 < 8501 || !(e25 < 8501) && (e25 < 8505 || (e25 === 8505 || !(e25 < 8508) && (e25 < 8512 || !(e25 < 8517) && e25 < 8522)))) : e25 === 8526 || !(e25 < 8544) && (e25 < 8579 || !(e25 < 8579) && (e25 < 8581 || !(e25 < 8581) && (e25 < 8585 || !(e25 < 11264) && e25 < 11311))) : e25 < 11506 ? !(e25 < 11312) && (e25 < 11359 || !(e25 < 11360) && (e25 < 11388 || !(e25 < 11388) && (e25 < 11390 || !(e25 < 11390) && (e25 < 11493 || !(e25 < 11499) && e25 < 11503)))) : e25 < 11508 || !(e25 < 11520) && (e25 < 11558 || (e25 === 11559 || (e25 === 11565 || !(e25 < 11568) && (e25 < 11624 || e25 === 11631)))) : e25 < 12294 ? e25 < 11712 ? !(e25 < 11648) && (e25 < 11671 || !(e25 < 11680) && (e25 < 11687 || !(e25 < 11688) && (e25 < 11695 || !(e25 < 11696) && (e25 < 11703 || !(e25 < 11704) && e25 < 11711)))) : e25 < 11719 || !(e25 < 11720) && (e25 < 11727 || !(e25 < 11728) && (e25 < 11735 || !(e25 < 11736) && (e25 < 11743 || e25 === 12293))) : e25 < 12347 ? e25 === 12294 || (e25 === 12295 || !(e25 < 12321) && (e25 < 12330 || !(e25 < 12337) && (e25 < 12342 || !(e25 < 12344) && e25 < 12347))) : e25 === 12347 || (e25 === 12348 || !(e25 < 12353) && (e25 < 12439 || !(e25 < 12443) && (e25 < 12445 || !(e25 < 12445) && (e25 < 12447 || e25 === 12447)))) : e25 < 68448 ? e25 < 55216 ? e25 < 43138 ? e25 < 42623 ? e25 < 40981 ? e25 < 12704 ? !(e25 < 12449) && (e25 < 12539 || !(e25 < 12540) && (e25 < 12543 || (e25 === 12543 || !(e25 < 12549) && (e25 < 12592 || !(e25 < 12593) && e25 < 12687)))) : e25 < 12731 || !(e25 < 12784) && (e25 < 12800 || !(e25 < 13312) && (e25 < 19894 || !(e25 < 19968) && (e25 < 40944 || !(e25 < 40960) && e25 < 40981))) : e25 < 42508 ? e25 === 40981 || !(e25 < 40982) && (e25 < 42125 || !(e25 < 42192) && (e25 < 42232 || !(e25 < 42232) && (e25 < 42238 || !(e25 < 42240) && e25 < 42508))) : e25 === 42508 || !(e25 < 42512) && (e25 < 42528 || !(e25 < 42538) && (e25 < 42540 || !(e25 < 42560) && (e25 < 42606 || e25 === 42606))) : e25 < 42891 ? e25 < 42775 ? e25 === 42623 || !(e25 < 42624) && (e25 < 42652 || !(e25 < 42652) && (e25 < 42654 || !(e25 < 42656) && (e25 < 42726 || !(e25 < 42726) && e25 < 42736))) : e25 < 42784 || !(e25 < 42786) && (e25 < 42864 || (e25 === 42864 || !(e25 < 42865) && (e25 < 42888 || e25 === 42888))) : e25 < 43002 ? !(e25 < 42891) && (e25 < 42895 || (e25 === 42895 || !(e25 < 42896) && (e25 < 42938 || (e25 === 42999 || !(e25 < 43e3) && e25 < 43002)))) : e25 === 43002 || !(e25 < 43003) && (e25 < 43010 || !(e25 < 43011) && (e25 < 43014 || !(e25 < 43015) && (e25 < 43019 || !(e25 < 43020) && (e25 < 43043 || !(e25 < 43072) && e25 < 43124)))) : e25 < 43697 ? e25 < 43494 ? e25 < 43312 ? !(e25 < 43138) && (e25 < 43188 || !(e25 < 43250) && (e25 < 43256 || (e25 === 43259 || !(e25 < 43261) && (e25 < 43263 || !(e25 < 43274) && e25 < 43302)))) : e25 < 43335 || !(e25 < 43360) && (e25 < 43389 || !(e25 < 43396) && (e25 < 43443 || (e25 === 43471 || !(e25 < 43488) && e25 < 43493))) : e25 < 43588 ? e25 === 43494 || !(e25 < 43495) && (e25 < 43504 || !(e25 < 43514) && (e25 < 43519 || !(e25 < 43520) && (e25 < 43561 || !(e25 < 43584) && e25 < 43587))) : e25 < 43596 || !(e25 < 43616) && (e25 < 43632 || (e25 === 43632 || !(e25 < 43633) && (e25 < 43639 || (e25 === 43642 || !(e25 < 43646) && e25 < 43696)))) : e25 < 43777 ? e25 < 43739 ? e25 === 43697 || !(e25 < 43701) && (e25 < 43703 || !(e25 < 43705) && (e25 < 43710 || (e25 === 43712 || e25 === 43714))) : e25 < 43741 || (e25 === 43741 || !(e25 < 43744) && (e25 < 43755 || (e25 === 43762 || !(e25 < 43763) && e25 < 43765))) : e25 < 43824 ? !(e25 < 43777) && (e25 < 43783 || !(e25 < 43785) && (e25 < 43791 || !(e25 < 43793) && (e25 < 43799 || !(e25 < 43808) && (e25 < 43815 || !(e25 < 43816) && e25 < 43823)))) : e25 < 43867 || !(e25 < 43868) && (e25 < 43872 || !(e25 < 43872) && (e25 < 43878 || !(e25 < 43888) && (e25 < 43968 || !(e25 < 43968) && (e25 < 44003 || !(e25 < 44032) && e25 < 55204)))) : e25 < 66349 ? e25 < 65345 ? e25 < 64318 ? e25 < 64275 ? !(e25 < 55216) && (e25 < 55239 || !(e25 < 55243) && (e25 < 55292 || !(e25 < 63744) && (e25 < 64110 || !(e25 < 64112) && (e25 < 64218 || !(e25 < 64256) && e25 < 64263)))) : e25 < 64280 || (e25 === 64285 || !(e25 < 64287) && (e25 < 64297 || !(e25 < 64298) && (e25 < 64311 || !(e25 < 64312) && e25 < 64317))) : e25 < 64848 ? e25 === 64318 || !(e25 < 64320) && (e25 < 64322 || !(e25 < 64323) && (e25 < 64325 || !(e25 < 64326) && (e25 < 64434 || !(e25 < 64467) && e25 < 64830))) : e25 < 64912 || !(e25 < 64914) && (e25 < 64968 || !(e25 < 65008) && (e25 < 65020 || !(e25 < 65136) && (e25 < 65141 || !(e25 < 65142) && (e25 < 65277 || !(e25 < 65313) && e25 < 65339)))) : e25 < 65536 ? e25 < 65440 ? !(e25 < 65345) && (e25 < 65371 || !(e25 < 65382) && (e25 < 65392 || (e25 === 65392 || !(e25 < 65393) && (e25 < 65438 || !(e25 < 65438) && e25 < 65440)))) : e25 < 65471 || !(e25 < 65474) && (e25 < 65480 || !(e25 < 65482) && (e25 < 65488 || !(e25 < 65490) && (e25 < 65496 || !(e25 < 65498) && e25 < 65501))) : e25 < 65616 ? !(e25 < 65536) && (e25 < 65548 || !(e25 < 65549) && (e25 < 65575 || !(e25 < 65576) && (e25 < 65595 || !(e25 < 65596) && (e25 < 65598 || !(e25 < 65599) && e25 < 65614)))) : e25 < 65630 || !(e25 < 65664) && (e25 < 65787 || !(e25 < 65856) && (e25 < 65909 || !(e25 < 66176) && (e25 < 66205 || !(e25 < 66208) && (e25 < 66257 || !(e25 < 66304) && e25 < 66336)))) : e25 < 67639 ? e25 < 66640 ? e25 < 66432 ? !(e25 < 66349) && (e25 < 66369 || (e25 === 66369 || !(e25 < 66370) && (e25 < 66378 || (e25 === 66378 || !(e25 < 66384) && e25 < 66422)))) : e25 < 66462 || !(e25 < 66464) && (e25 < 66500 || !(e25 < 66504) && (e25 < 66512 || !(e25 < 66513) && (e25 < 66518 || !(e25 < 66560) && e25 < 66640))) : e25 < 67072 ? !(e25 < 66640) && (e25 < 66718 || !(e25 < 66736) && (e25 < 66772 || !(e25 < 66776) && (e25 < 66812 || !(e25 < 66816) && (e25 < 66856 || !(e25 < 66864) && e25 < 66916)))) : e25 < 67383 || !(e25 < 67392) && (e25 < 67414 || !(e25 < 67424) && (e25 < 67432 || !(e25 < 67584) && (e25 < 67590 || (e25 === 67592 || !(e25 < 67594) && e25 < 67638)))) : e25 < 68030 ? e25 < 67808 ? !(e25 < 67639) && (e25 < 67641 || (e25 === 67644 || !(e25 < 67647) && (e25 < 67670 || !(e25 < 67680) && (e25 < 67703 || !(e25 < 67712) && e25 < 67743)))) : e25 < 67827 || !(e25 < 67828) && (e25 < 67830 || !(e25 < 67840) && (e25 < 67862 || !(e25 < 67872) && (e25 < 67898 || !(e25 < 67968) && e25 < 68024))) : e25 < 68192 ? !(e25 < 68030) && (e25 < 68032 || (e25 === 68096 || !(e25 < 68112) && (e25 < 68116 || !(e25 < 68117) && (e25 < 68120 || !(e25 < 68121) && e25 < 68150)))) : e25 < 68221 || !(e25 < 68224) && (e25 < 68253 || !(e25 < 68288) && (e25 < 68296 || !(e25 < 68297) && (e25 < 68325 || !(e25 < 68352) && (e25 < 68406 || !(e25 < 68416) && e25 < 68438)))) : e25 < 93760 ? e25 < 71040 ? e25 < 70163 ? e25 < 69763 ? e25 < 68864 ? !(e25 < 68448) && (e25 < 68467 || !(e25 < 68480) && (e25 < 68498 || !(e25 < 68608) && (e25 < 68681 || !(e25 < 68736) && (e25 < 68787 || !(e25 < 68800) && e25 < 68851)))) : e25 < 68900 || !(e25 < 69376) && (e25 < 69405 || (e25 === 69415 || !(e25 < 69424) && (e25 < 69446 || !(e25 < 69635) && e25 < 69688))) : e25 < 70006 ? !(e25 < 69763) && (e25 < 69808 || !(e25 < 69840) && (e25 < 69865 || !(e25 < 69891) && (e25 < 69927 || (e25 === 69956 || !(e25 < 69968) && e25 < 70003)))) : e25 === 70006 || !(e25 < 70019) && (e25 < 70067 || !(e25 < 70081) && (e25 < 70085 || (e25 === 70106 || (e25 === 70108 || !(e25 < 70144) && e25 < 70162)))) : e25 < 70442 ? e25 < 70303 ? !(e25 < 70163) && (e25 < 70188 || !(e25 < 70272) && (e25 < 70279 || (e25 === 70280 || !(e25 < 70282) && (e25 < 70286 || !(e25 < 70287) && e25 < 70302)))) : e25 < 70313 || !(e25 < 70320) && (e25 < 70367 || !(e25 < 70405) && (e25 < 70413 || !(e25 < 70415) && (e25 < 70417 || !(e25 < 70419) && e25 < 70441))) : e25 < 70493 ? !(e25 < 70442) && (e25 < 70449 || !(e25 < 70450) && (e25 < 70452 || !(e25 < 70453) && (e25 < 70458 || (e25 === 70461 || e25 === 70480)))) : e25 < 70498 || !(e25 < 70656) && (e25 < 70709 || !(e25 < 70727) && (e25 < 70731 || !(e25 < 70784) && (e25 < 70832 || !(e25 < 70852) && (e25 < 70854 || e25 === 70855)))) : e25 < 72960 ? e25 < 72203 ? e25 < 71424 ? !(e25 < 71040) && (e25 < 71087 || !(e25 < 71128) && (e25 < 71132 || !(e25 < 71168) && (e25 < 71216 || (e25 === 71236 || !(e25 < 71296) && e25 < 71339)))) : e25 < 71451 || !(e25 < 71680) && (e25 < 71724 || !(e25 < 71840) && (e25 < 71904 || (e25 === 71935 || e25 === 72192))) : e25 < 72349 ? !(e25 < 72203) && (e25 < 72243 || (e25 === 72250 || (e25 === 72272 || !(e25 < 72284) && (e25 < 72324 || !(e25 < 72326) && e25 < 72330)))) : e25 === 72349 || !(e25 < 72384) && (e25 < 72441 || !(e25 < 72704) && (e25 < 72713 || !(e25 < 72714) && (e25 < 72751 || (e25 === 72768 || !(e25 < 72818) && e25 < 72848)))) : e25 < 74752 ? e25 < 73063 ? !(e25 < 72960) && (e25 < 72967 || !(e25 < 72968) && (e25 < 72970 || !(e25 < 72971) && (e25 < 73009 || (e25 === 73030 || !(e25 < 73056) && e25 < 73062)))) : e25 < 73065 || !(e25 < 73066) && (e25 < 73098 || (e25 === 73112 || !(e25 < 73440) && (e25 < 73459 || !(e25 < 73728) && e25 < 74650))) : e25 < 92736 ? !(e25 < 74752) && (e25 < 74863 || !(e25 < 74880) && (e25 < 75076 || !(e25 < 77824) && (e25 < 78895 || !(e25 < 82944) && (e25 < 83527 || !(e25 < 92160) && e25 < 92729)))) : e25 < 92767 || !(e25 < 92880) && (e25 < 92910 || !(e25 < 92928) && (e25 < 92976 || !(e25 < 92992) && (e25 < 92996 || !(e25 < 93027) && (e25 < 93048 || !(e25 < 93053) && e25 < 93072)))) : e25 < 120772 ? e25 < 119997 ? e25 < 113776 ? e25 < 94208 ? !(e25 < 93760) && (e25 < 93824 || !(e25 < 93952) && (e25 < 94021 || (e25 === 94032 || !(e25 < 94099) && (e25 < 94112 || !(e25 < 94176) && e25 < 94178)))) : e25 < 100338 || !(e25 < 100352) && (e25 < 101107 || !(e25 < 110592) && (e25 < 110879 || !(e25 < 110960) && (e25 < 111356 || !(e25 < 113664) && e25 < 113771))) : e25 < 119966 ? !(e25 < 113776) && (e25 < 113789 || !(e25 < 113792) && (e25 < 113801 || !(e25 < 113808) && (e25 < 113818 || !(e25 < 119808) && (e25 < 119893 || !(e25 < 119894) && e25 < 119965)))) : e25 < 119968 || (e25 === 119970 || !(e25 < 119973) && (e25 < 119975 || !(e25 < 119977) && (e25 < 119981 || !(e25 < 119982) && (e25 < 119994 || e25 === 119995)))) : e25 < 120146 ? e25 < 120094 ? !(e25 < 119997) && (e25 < 120004 || !(e25 < 120005) && (e25 < 120070 || !(e25 < 120071) && (e25 < 120075 || !(e25 < 120077) && (e25 < 120085 || !(e25 < 120086) && e25 < 120093)))) : e25 < 120122 || !(e25 < 120123) && (e25 < 120127 || !(e25 < 120128) && (e25 < 120133 || (e25 === 120134 || !(e25 < 120138) && e25 < 120145))) : e25 < 120598 ? !(e25 < 120146) && (e25 < 120486 || !(e25 < 120488) && (e25 < 120513 || !(e25 < 120514) && (e25 < 120539 || !(e25 < 120540) && (e25 < 120571 || !(e25 < 120572) && e25 < 120597)))) : e25 < 120629 || !(e25 < 120630) && (e25 < 120655 || !(e25 < 120656) && (e25 < 120687 || !(e25 < 120688) && (e25 < 120713 || !(e25 < 120714) && (e25 < 120745 || !(e25 < 120746) && e25 < 120771)))) : e25 < 126555 ? e25 < 126521 ? e25 < 126497 ? !(e25 < 120772) && (e25 < 120780 || !(e25 < 124928) && (e25 < 125125 || !(e25 < 125184) && (e25 < 125252 || !(e25 < 126464) && (e25 < 126468 || !(e25 < 126469) && e25 < 126496)))) : e25 < 126499 || (e25 === 126500 || (e25 === 126503 || !(e25 < 126505) && (e25 < 126515 || !(e25 < 126516) && e25 < 126520))) : e25 < 126539 ? e25 === 126521 || (e25 === 126523 || (e25 === 126530 || (e25 === 126535 || e25 === 126537))) : e25 === 126539 || !(e25 < 126541) && (e25 < 126544 || !(e25 < 126545) && (e25 < 126547 || (e25 === 126548 || (e25 === 126551 || e25 === 126553)))) : e25 < 126592 ? e25 < 126567 ? e25 === 126555 || (e25 === 126557 || (e25 === 126559 || !(e25 < 126561) && (e25 < 126563 || e25 === 126564))) : e25 < 126571 || !(e25 < 126572) && (e25 < 126579 || !(e25 < 126580) && (e25 < 126584 || !(e25 < 126585) && (e25 < 126589 || e25 === 126590))) : e25 < 131072 ? !(e25 < 126592) && (e25 < 126602 || !(e25 < 126603) && (e25 < 126620 || !(e25 < 126625) && (e25 < 126628 || !(e25 < 126629) && (e25 < 126634 || !(e25 < 126635) && e25 < 126652)))) : e25 < 173783 || !(e25 < 173824) && (e25 < 177973 || !(e25 < 177984) && (e25 < 178206 || !(e25 < 178208) && (e25 < 183970 || !(e25 < 183984) && (e25 < 191457 || !(e25 < 194560) && e25 < 195102))));
}
var XD = { $LONE: new Set(["ASCII", "ASCII_Hex_Digit", "AHex", "Alphabetic", "Alpha", "Any", "Assigned", "Bidi_Control", "Bidi_C", "Bidi_Mirrored", "Bidi_M", "Case_Ignorable", "CI", "Cased", "Changes_When_Casefolded", "CWCF", "Changes_When_Casemapped", "CWCM", "Changes_When_Lowercased", "CWL", "Changes_When_NFKC_Casefolded", "CWKCF", "Changes_When_Titlecased", "CWT", "Changes_When_Uppercased", "CWU", "Dash", "Default_Ignorable_Code_Point", "DI", "Deprecated", "Dep", "Diacritic", "Dia", "Emoji", "Emoji_Component", "Emoji_Modifier", "Emoji_Modifier_Base", "Emoji_Presentation", "Extender", "Ext", "Grapheme_Base", "Gr_Base", "Grapheme_Extend", "Gr_Ext", "Hex_Digit", "Hex", "IDS_Binary_Operator", "IDSB", "IDS_Trinary_Operator", "IDST", "ID_Continue", "IDC", "ID_Start", "IDS", "Ideographic", "Ideo", "Join_Control", "Join_C", "Logical_Order_Exception", "LOE", "Lowercase", "Lower", "Math", "Noncharacter_Code_Point", "NChar", "Pattern_Syntax", "Pat_Syn", "Pattern_White_Space", "Pat_WS", "Quotation_Mark", "QMark", "Radical", "Regional_Indicator", "RI", "Sentence_Terminal", "STerm", "Soft_Dotted", "SD", "Terminal_Punctuation", "Term", "Unified_Ideograph", "UIdeo", "Uppercase", "Upper", "Variation_Selector", "VS", "White_Space", "space", "XID_Continue", "XIDC", "XID_Start", "XIDS"]), General_Category: new Set(["Cased_Letter", "LC", "Close_Punctuation", "Pe", "Connector_Punctuation", "Pc", "Control", "Cc", "cntrl", "Currency_Symbol", "Sc", "Dash_Punctuation", "Pd", "Decimal_Number", "Nd", "digit", "Enclosing_Mark", "Me", "Final_Punctuation", "Pf", "Format", "Cf", "Initial_Punctuation", "Pi", "Letter", "L", "Letter_Number", "Nl", "Line_Separator", "Zl", "Lowercase_Letter", "Ll", "Mark", "M", "Combining_Mark", "Math_Symbol", "Sm", "Modifier_Letter", "Lm", "Modifier_Symbol", "Sk", "Nonspacing_Mark", "Mn", "Number", "N", "Open_Punctuation", "Ps", "Other", "C", "Other_Letter", "Lo", "Other_Number", "No", "Other_Punctuation", "Po", "Other_Symbol", "So", "Paragraph_Separator", "Zp", "Private_Use", "Co", "Punctuation", "P", "punct", "Separator", "Z", "Space_Separator", "Zs", "Spacing_Mark", "Mc", "Surrogate", "Cs", "Symbol", "S", "Titlecase_Letter", "Lt", "Unassigned", "Cn", "Uppercase_Letter", "Lu"]), Script: new Set(["Adlam", "Adlm", "Ahom", "Anatolian_Hieroglyphs", "Hluw", "Arabic", "Arab", "Armenian", "Armn", "Avestan", "Avst", "Balinese", "Bali", "Bamum", "Bamu", "Bassa_Vah", "Bass", "Batak", "Batk", "Bengali", "Beng", "Bhaiksuki", "Bhks", "Bopomofo", "Bopo", "Brahmi", "Brah", "Braille", "Brai", "Buginese", "Bugi", "Buhid", "Buhd", "Canadian_Aboriginal", "Cans", "Carian", "Cari", "Caucasian_Albanian", "Aghb", "Chakma", "Cakm", "Cham", "Cherokee", "Cher", "Common", "Zyyy", "Coptic", "Copt", "Qaac", "Cuneiform", "Xsux", "Cypriot", "Cprt", "Cyrillic", "Cyrl", "Deseret", "Dsrt", "Devanagari", "Deva", "Duployan", "Dupl", "Egyptian_Hieroglyphs", "Egyp", "Elbasan", "Elba", "Ethiopic", "Ethi", "Georgian", "Geor", "Glagolitic", "Glag", "Gothic", "Goth", "Grantha", "Gran", "Greek", "Grek", "Gujarati", "Gujr", "Gurmukhi", "Guru", "Han", "Hani", "Hangul", "Hang", "Hanunoo", "Hano", "Hatran", "Hatr", "Hebrew", "Hebr", "Hiragana", "Hira", "Imperial_Aramaic", "Armi", "Inherited", "Zinh", "Qaai", "Inscriptional_Pahlavi", "Phli", "Inscriptional_Parthian", "Prti", "Javanese", "Java", "Kaithi", "Kthi", "Kannada", "Knda", "Katakana", "Kana", "Kayah_Li", "Kali", "Kharoshthi", "Khar", "Khmer", "Khmr", "Khojki", "Khoj", "Khudawadi", "Sind", "Lao", "Laoo", "Latin", "Latn", "Lepcha", "Lepc", "Limbu", "Limb", "Linear_A", "Lina", "Linear_B", "Linb", "Lisu", "Lycian", "Lyci", "Lydian", "Lydi", "Mahajani", "Mahj", "Malayalam", "Mlym", "Mandaic", "Mand", "Manichaean", "Mani", "Marchen", "Marc", "Masaram_Gondi", "Gonm", "Meetei_Mayek", "Mtei", "Mende_Kikakui", "Mend", "Meroitic_Cursive", "Merc", "Meroitic_Hieroglyphs", "Mero", "Miao", "Plrd", "Modi", "Mongolian", "Mong", "Mro", "Mroo", "Multani", "Mult", "Myanmar", "Mymr", "Nabataean", "Nbat", "New_Tai_Lue", "Talu", "Newa", "Nko", "Nkoo", "Nushu", "Nshu", "Ogham", "Ogam", "Ol_Chiki", "Olck", "Old_Hungarian", "Hung", "Old_Italic", "Ital", "Old_North_Arabian", "Narb", "Old_Permic", "Perm", "Old_Persian", "Xpeo", "Old_South_Arabian", "Sarb", "Old_Turkic", "Orkh", "Oriya", "Orya", "Osage", "Osge", "Osmanya", "Osma", "Pahawh_Hmong", "Hmng", "Palmyrene", "Palm", "Pau_Cin_Hau", "Pauc", "Phags_Pa", "Phag", "Phoenician", "Phnx", "Psalter_Pahlavi", "Phlp", "Rejang", "Rjng", "Runic", "Runr", "Samaritan", "Samr", "Saurashtra", "Saur", "Sharada", "Shrd", "Shavian", "Shaw", "Siddham", "Sidd", "SignWriting", "Sgnw", "Sinhala", "Sinh", "Sora_Sompeng", "Sora", "Soyombo", "Soyo", "Sundanese", "Sund", "Syloti_Nagri", "Sylo", "Syriac", "Syrc", "Tagalog", "Tglg", "Tagbanwa", "Tagb", "Tai_Le", "Tale", "Tai_Tham", "Lana", "Tai_Viet", "Tavt", "Takri", "Takr", "Tamil", "Taml", "Tangut", "Tang", "Telugu", "Telu", "Thaana", "Thaa", "Thai", "Tibetan", "Tibt", "Tifinagh", "Tfng", "Tirhuta", "Tirh", "Ugaritic", "Ugar", "Vai", "Vaii", "Warang_Citi", "Wara", "Yi", "Yiii", "Zanabazar_Square", "Zanb"]) };
XD.gc = XD.General_Category, XD.sc = XD.Script_Extensions = XD.scx = XD.Script;
var YD = 10, ZD = 13, eF = 36, tF = 40, rF = 41, nF = 42, iF = 43, aF = 46, oF = 48, sF = 55, uF = 57, cF = 63, lF = 65, pF = 70, fF = 90, hF = 95, dF = 97, mF = 102, gF = 122, yF = 91, vF = 92, xF = 93, bF = 94, EF = 123, CF = 124, SF = 125, kF = 8204, DF = 8205, FF = 8232, AF = 8233, wF = 0, _F = 1114111;
function TF(e25) {
  return e25 >= lF && e25 <= fF || e25 >= dF && e25 <= gF;
}
function PF(e25) {
  return e25 >= oF && e25 <= uF;
}
function IF(e25) {
  return e25 >= oF && e25 <= uF || e25 >= lF && e25 <= pF || e25 >= dF && e25 <= mF;
}
function BF(e25) {
  return e25 === YD || e25 === ZD || e25 === FF || e25 === AF;
}
function OF(e25) {
  return e25 >= dF && e25 <= mF ? e25 - dF + 10 : e25 >= lF && e25 <= pF ? e25 - lF + 10 : e25 - oF;
}
var LF = { at: function(e25, t2, r2) {
  return r2 < t2 ? e25.charCodeAt(r2) : -1;
}, width: function(e25) {
  return 1;
} }, NF = { at: function(e25, t2, r2) {
  return r2 < t2 ? e25.codePointAt(r2) : -1;
}, width: function(e25) {
  return e25 > 65535 ? 2 : 1;
} }, jF = function() {
  function e25() {
    a(this, e25), this._impl = LF, this._s = "", this._i = 0, this._end = 0, this._cp1 = -1, this._w1 = 1, this._cp2 = -1, this._w2 = 1, this._cp3 = -1, this._w3 = 1, this._cp4 = -1;
  }
  return s(e25, [{ key: "reset", value: function(e26, t2, r2, n2) {
    this._impl = n2 ? NF : LF, this._s = e26, this._end = r2, this.rewind(t2);
  } }, { key: "rewind", value: function(e26) {
    var t2 = this._impl;
    this._i = e26, this._cp1 = t2.at(this._s, this._end, e26), this._w1 = t2.width(this._cp1), this._cp2 = t2.at(this._s, this._end, e26 + this._w1), this._w2 = t2.width(this._cp2), this._cp3 = t2.at(this._s, this._end, e26 + this._w1 + this._w2), this._w3 = t2.width(this._cp3), this._cp4 = t2.at(this._s, this._end, e26 + this._w1 + this._w2 + this._w3);
  } }, { key: "advance", value: function() {
    if (this._cp1 !== -1) {
      var e26 = this._impl;
      this._i += this._w1, this._cp1 = this._cp2, this._w1 = this._w2, this._cp2 = this._cp3, this._w2 = e26.width(this._cp2), this._cp3 = this._cp4, this._w3 = e26.width(this._cp3), this._cp4 = e26.at(this._s, this._end, this._i + this._w1 + this._w2 + this._w3);
    }
  } }, { key: "eat", value: function(e26) {
    return this._cp1 === e26 && (this.advance(), true);
  } }, { key: "eat2", value: function(e26, t2) {
    return this._cp1 === e26 && this._cp2 === t2 && (this.advance(), this.advance(), true);
  } }, { key: "eat3", value: function(e26, t2, r2) {
    return this._cp1 === e26 && this._cp2 === t2 && this._cp3 === r2 && (this.advance(), this.advance(), this.advance(), true);
  } }, { key: "source", get: function() {
    return this._s;
  } }, { key: "index", get: function() {
    return this._i;
  } }, { key: "currentCodePoint", get: function() {
    return this._cp1;
  } }, { key: "nextCodePoint", get: function() {
    return this._cp2;
  } }, { key: "nextCodePoint2", get: function() {
    return this._cp3;
  } }, { key: "nextCodePoint3", get: function() {
    return this._cp4;
  } }]), e25;
}(), RF = function(e25) {
  function t2(e26, r2, n2, i2) {
    var o2;
    return a(this, t2), e26 && (e26[0] !== "/" && (e26 = "/".concat(e26, "/").concat(r2 ? "u" : "")), e26 = ": ".concat(e26)), (o2 = v(this, h(t2).call(this, "Invalid regular expression".concat(e26, ": ").concat(i2)))).index = n2, o2;
  }
  return f(t2, g(SyntaxError)), t2;
}();
function MF(e25) {
  return e25 === bF || e25 === eF || e25 === vF || e25 === aF || e25 === nF || e25 === iF || e25 === cF || e25 === tF || e25 === rF || e25 === yF || e25 === xF || e25 === EF || e25 === SF || e25 === CF;
}
function VF(e25) {
  return function(e26) {
    return !(e26 < 65) && (e26 < 91 || !(e26 < 97) && (e26 < 123 || QD(e26)));
  }(e25) || e25 === eF || e25 === hF;
}
function UF(e25) {
  return TF(e25) || e25 === hF;
}
function qF(e25, t2) {
  return XD.hasOwnProperty(e25) && XD[e25].has(t2);
}
var WF = function() {
  function e25(t2) {
    a(this, e25), this._reader = new jF(), this._uFlag = false, this._nFlag = false, this._lastIntValue = 0, this._lastMinValue = 0, this._lastMaxValue = 0, this._lastStrValue = "", this._lastKeyValue = "", this._lastValValue = "", this._lastAssertionIsQuantifiable = false, this._numCapturingParens = 0, this._groupNames = new Set(), this._backreferenceNames = new Set(), this._options = t2 || {};
  }
  return s(e25, [{ key: "validateLiteral", value: function(e26) {
    var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e26.length;
    if (this._uFlag = this._nFlag = false, this.reset(e26, t2, r2), this.onLiteralEnter(t2), this.eat(47) && this.eatRegExpBody() && this.eat(47)) {
      var n2 = this.index, i2 = e26.indexOf("u", n2) !== -1;
      this.validateFlags(e26, n2, r2), this.validatePattern(e26, t2 + 1, n2 - 1, i2);
    } else if (t2 >= r2)
      this.raise("Empty");
    else {
      var a2 = String.fromCodePoint(this.currentCodePoint);
      this.raise("Unexpected character '".concat(a2, "'"));
    }
    this.onLiteralLeave(t2, r2);
  } }, { key: "validateFlags", value: function(e26) {
    for (var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e26.length, n2 = new Set(), i2 = false, a2 = false, o2 = false, s2 = false, u2 = false, c2 = false, l2 = t2; l2 < r2; ++l2) {
      var p2 = e26.charCodeAt(l2);
      n2.has(p2) && this.raise("Duplicated flag '".concat(e26[l2], "'")), n2.add(p2), p2 === 103 ? i2 = true : p2 === 105 ? a2 = true : p2 === 109 ? o2 = true : p2 === 117 && this.ecmaVersion >= 2015 ? u2 = true : p2 === 121 && this.ecmaVersion >= 2015 ? s2 = true : p2 === 115 && this.ecmaVersion >= 2018 ? c2 = true : this.raise("Invalid flag '".concat(e26[l2], "'"));
    }
    this.onFlags(t2, r2, i2, a2, o2, u2, s2, c2);
  } }, { key: "validatePattern", value: function(e26) {
    var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e26.length, n2 = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
    this._uFlag = n2 && this.ecmaVersion >= 2015, this._nFlag = n2 && this.ecmaVersion >= 2018, this.reset(e26, t2, r2), this.pattern(), !this._nFlag && this.ecmaVersion >= 2018 && this._groupNames.size > 0 && (this._nFlag = true, this.rewind(t2), this.pattern());
  } }, { key: "onLiteralEnter", value: function(e26) {
    this._options.onLiteralEnter && this._options.onLiteralEnter(e26);
  } }, { key: "onLiteralLeave", value: function(e26, t2) {
    this._options.onLiteralLeave && this._options.onLiteralLeave(e26, t2);
  } }, { key: "onFlags", value: function(e26, t2, r2, n2, i2, a2, o2, s2) {
    this._options.onFlags && this._options.onFlags(e26, t2, r2, n2, i2, a2, o2, s2);
  } }, { key: "onPatternEnter", value: function(e26) {
    this._options.onPatternEnter && this._options.onPatternEnter(e26);
  } }, { key: "onPatternLeave", value: function(e26, t2) {
    this._options.onPatternLeave && this._options.onPatternLeave(e26, t2);
  } }, { key: "onDisjunctionEnter", value: function(e26) {
    this._options.onDisjunctionEnter && this._options.onDisjunctionEnter(e26);
  } }, { key: "onDisjunctionLeave", value: function(e26, t2) {
    this._options.onDisjunctionLeave && this._options.onDisjunctionLeave(e26, t2);
  } }, { key: "onAlternativeEnter", value: function(e26, t2) {
    this._options.onAlternativeEnter && this._options.onAlternativeEnter(e26, t2);
  } }, { key: "onAlternativeLeave", value: function(e26, t2, r2) {
    this._options.onAlternativeLeave && this._options.onAlternativeLeave(e26, t2, r2);
  } }, { key: "onGroupEnter", value: function(e26) {
    this._options.onGroupEnter && this._options.onGroupEnter(e26);
  } }, { key: "onGroupLeave", value: function(e26, t2) {
    this._options.onGroupLeave && this._options.onGroupLeave(e26, t2);
  } }, { key: "onCapturingGroupEnter", value: function(e26, t2) {
    this._options.onCapturingGroupEnter && this._options.onCapturingGroupEnter(e26, t2);
  } }, { key: "onCapturingGroupLeave", value: function(e26, t2, r2) {
    this._options.onCapturingGroupLeave && this._options.onCapturingGroupLeave(e26, t2, r2);
  } }, { key: "onQuantifier", value: function(e26, t2, r2, n2, i2) {
    this._options.onQuantifier && this._options.onQuantifier(e26, t2, r2, n2, i2);
  } }, { key: "onLookaroundAssertionEnter", value: function(e26, t2, r2) {
    this._options.onLookaroundAssertionEnter && this._options.onLookaroundAssertionEnter(e26, t2, r2);
  } }, { key: "onLookaroundAssertionLeave", value: function(e26, t2, r2, n2) {
    this._options.onLookaroundAssertionLeave && this._options.onLookaroundAssertionLeave(e26, t2, r2, n2);
  } }, { key: "onEdgeAssertion", value: function(e26, t2, r2) {
    this._options.onEdgeAssertion && this._options.onEdgeAssertion(e26, t2, r2);
  } }, { key: "onWordBoundaryAssertion", value: function(e26, t2, r2, n2) {
    this._options.onWordBoundaryAssertion && this._options.onWordBoundaryAssertion(e26, t2, r2, n2);
  } }, { key: "onAnyCharacterSet", value: function(e26, t2, r2) {
    this._options.onAnyCharacterSet && this._options.onAnyCharacterSet(e26, t2, r2);
  } }, { key: "onEscapeCharacterSet", value: function(e26, t2, r2, n2) {
    this._options.onEscapeCharacterSet && this._options.onEscapeCharacterSet(e26, t2, r2, n2);
  } }, { key: "onUnicodePropertyCharacterSet", value: function(e26, t2, r2, n2, i2, a2) {
    this._options.onUnicodePropertyCharacterSet && this._options.onUnicodePropertyCharacterSet(e26, t2, r2, n2, i2, a2);
  } }, { key: "onCharacter", value: function(e26, t2, r2) {
    this._options.onCharacter && this._options.onCharacter(e26, t2, r2);
  } }, { key: "onBackreference", value: function(e26, t2, r2) {
    this._options.onBackreference && this._options.onBackreference(e26, t2, r2);
  } }, { key: "onCharacterClassEnter", value: function(e26, t2) {
    this._options.onCharacterClassEnter && this._options.onCharacterClassEnter(e26, t2);
  } }, { key: "onCharacterClassLeave", value: function(e26, t2, r2) {
    this._options.onCharacterClassLeave && this._options.onCharacterClassLeave(e26, t2, r2);
  } }, { key: "onCharacterClassRange", value: function(e26, t2, r2, n2) {
    this._options.onCharacterClassRange && this._options.onCharacterClassRange(e26, t2, r2, n2);
  } }, { key: "reset", value: function(e26, t2, r2) {
    this._reader.reset(e26, t2, r2, this._uFlag);
  } }, { key: "rewind", value: function(e26) {
    this._reader.rewind(e26);
  } }, { key: "advance", value: function() {
    this._reader.advance();
  } }, { key: "eat", value: function(e26) {
    return this._reader.eat(e26);
  } }, { key: "eat2", value: function(e26, t2) {
    return this._reader.eat2(e26, t2);
  } }, { key: "eat3", value: function(e26, t2, r2) {
    return this._reader.eat3(e26, t2, r2);
  } }, { key: "raise", value: function(e26) {
    throw new RF(this.source, this._uFlag, this.index, e26);
  } }, { key: "eatRegExpBody", value: function() {
    for (var e26 = this.index, t2 = false, r2 = false; ; ) {
      var n2 = this.currentCodePoint;
      if (n2 === -1 || BF(n2)) {
        var i2 = t2 ? "character class" : "regular expression";
        this.raise("Unterminated ".concat(i2));
      }
      if (r2)
        r2 = false;
      else if (n2 === vF)
        r2 = true;
      else if (n2 === yF)
        t2 = true;
      else if (n2 === xF)
        t2 = false;
      else if (n2 === 47 && !t2 || n2 === nF && this.index === e26)
        break;
      this.advance();
    }
    return this.index !== e26;
  } }, { key: "pattern", value: function() {
    var e26 = this.index;
    this._numCapturingParens = this.countCapturingParens(), this._groupNames.clear(), this._backreferenceNames.clear(), this.onPatternEnter(e26), this.disjunction();
    var t2 = this.currentCodePoint;
    if (this.currentCodePoint !== -1) {
      t2 === rF && this.raise("Unmatched ')'"), t2 === vF && this.raise("\\ at end of pattern"), t2 !== xF && t2 !== SF || this.raise("Lone quantifier brackets");
      var r2 = String.fromCodePoint(t2);
      this.raise("Unexpected character '".concat(r2, "'"));
    }
    var n2 = true, i2 = false, a2 = void 0;
    try {
      for (var o2, s2 = this._backreferenceNames[Symbol.iterator](); !(n2 = (o2 = s2.next()).done); n2 = true) {
        var u2 = o2.value;
        this._groupNames.has(u2) || this.raise("Invalid named capture referenced");
      }
    } catch (e27) {
      i2 = true, a2 = e27;
    } finally {
      try {
        n2 || s2.return == null || s2.return();
      } finally {
        if (i2)
          throw a2;
      }
    }
    this.onPatternLeave(e26, this.index);
  } }, { key: "countCapturingParens", value: function() {
    for (var e26 = this.index, t2 = false, r2 = false, n2 = 0, i2 = 0; (i2 = this.currentCodePoint) !== -1; )
      r2 ? r2 = false : i2 === vF ? r2 = true : i2 === yF ? t2 = true : i2 === xF ? t2 = false : i2 !== tF || t2 || this.nextCodePoint === cF && (this.nextCodePoint2 !== 60 || this.nextCodePoint3 === 61 || this.nextCodePoint3 === 33) || (n2 += 1), this.advance();
    return this.rewind(e26), n2;
  } }, { key: "disjunction", value: function() {
    var e26 = this.index, t2 = 0;
    for (this.onDisjunctionEnter(e26), this.alternative(t2++); this.eat(CF); )
      this.alternative(t2++);
    this.eatQuantifier(true) && this.raise("Nothing to repeat"), this.eat(EF) && this.raise("Lone quantifier brackets"), this.onDisjunctionLeave(e26, this.index);
  } }, { key: "alternative", value: function(e26) {
    var t2 = this.index;
    for (this.onAlternativeEnter(t2, e26); this.currentCodePoint !== -1 && this.eatTerm(); )
      ;
    this.onAlternativeLeave(t2, this.index, e26);
  } }, { key: "eatTerm", value: function() {
    return this.eatAssertion() ? (this._lastAssertionIsQuantifiable && this.eatQuantifier(), true) : !(this.strict ? !this.eatAtom() : !this.eatExtendedAtom()) && (this.eatQuantifier(), true);
  } }, { key: "eatAssertion", value: function() {
    var e26 = this.index;
    if (this._lastAssertionIsQuantifiable = false, this.eat(bF))
      return this.onEdgeAssertion(e26, this.index, "start"), true;
    if (this.eat(eF))
      return this.onEdgeAssertion(e26, this.index, "end"), true;
    if (this.eat2(vF, 66))
      return this.onWordBoundaryAssertion(e26, this.index, "word", true), true;
    if (this.eat2(vF, 98))
      return this.onWordBoundaryAssertion(e26, this.index, "word", false), true;
    if (this.eat2(tF, cF)) {
      var t2 = this.ecmaVersion >= 2018 && this.eat(60), r2 = false;
      if (this.eat(61) || (r2 = this.eat(33))) {
        var n2 = t2 ? "lookbehind" : "lookahead";
        return this.onLookaroundAssertionEnter(e26, n2, r2), this.disjunction(), this.eat(rF) || this.raise("Unterminated group"), this._lastAssertionIsQuantifiable = !t2 && !this.strict, this.onLookaroundAssertionLeave(e26, this.index, n2, r2), true;
      }
      this.rewind(e26);
    }
    return false;
  } }, { key: "eatQuantifier", value: function() {
    var e26 = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], t2 = this.index, r2 = 0, n2 = 0, i2 = false;
    if (this.eat(nF))
      r2 = 0, n2 = Number.POSITIVE_INFINITY;
    else if (this.eat(iF))
      r2 = 1, n2 = Number.POSITIVE_INFINITY;
    else if (this.eat(cF))
      r2 = 0, n2 = 1;
    else {
      if (!this.eatBracedQuantifier(e26))
        return false;
      r2 = this._lastMinValue, n2 = this._lastMaxValue;
    }
    return i2 = !this.eat(cF), e26 || this.onQuantifier(t2, this.index, r2, n2, i2), true;
  } }, { key: "eatBracedQuantifier", value: function(e26) {
    var t2 = this.index;
    if (this.eat(EF)) {
      if (this._lastMinValue = 0, this._lastMaxValue = Number.POSITIVE_INFINITY, this.eatDecimalDigits() && (this._lastMinValue = this._lastMaxValue = this._lastIntValue, this.eat(44) && (this._lastMaxValue = this.eatDecimalDigits() ? this._lastIntValue : Number.POSITIVE_INFINITY), this.eat(SF)))
        return !e26 && this._lastMaxValue < this._lastMinValue && this.raise("numbers out of order in {} quantifier"), true;
      !e26 && this.strict && this.raise("Incomplete quantifier"), this.rewind(t2);
    }
    return false;
  } }, { key: "eatAtom", value: function() {
    return this.eatPatternCharacter() || this.eatDot() || this.eatReverseSolidusAtomEscape() || this.eatCharacterClass() || this.eatUncapturingGroup() || this.eatCapturingGroup();
  } }, { key: "eatDot", value: function() {
    return !!this.eat(aF) && (this.onAnyCharacterSet(this.index - 1, this.index, "any"), true);
  } }, { key: "eatReverseSolidusAtomEscape", value: function() {
    var e26 = this.index;
    if (this.eat(vF)) {
      if (this.eatAtomEscape())
        return true;
      this.rewind(e26);
    }
    return false;
  } }, { key: "eatUncapturingGroup", value: function() {
    var e26 = this.index;
    return !!this.eat3(tF, cF, 58) && (this.onGroupEnter(e26), this.disjunction(), this.eat(rF) || this.raise("Unterminated group"), this.onGroupLeave(e26, this.index), true);
  } }, { key: "eatCapturingGroup", value: function() {
    var e26 = this.index;
    if (this.eat(tF)) {
      this._lastStrValue = "", this.ecmaVersion >= 2018 ? this.groupSpecifier() : this.currentCodePoint === cF && this.raise("Invalid group");
      var t2 = this._lastStrValue || null;
      return this.onCapturingGroupEnter(e26, t2), this.disjunction(), this.eat(rF) || this.raise("Unterminated group"), this.onCapturingGroupLeave(e26, this.index, t2), true;
    }
    return false;
  } }, { key: "eatExtendedAtom", value: function() {
    return this.eatDot() || this.eatReverseSolidusAtomEscape() || this.eatReverseSolidusFollowedByC() || this.eatCharacterClass() || this.eatUncapturingGroup() || this.eatCapturingGroup() || this.eatInvalidBracedQuantifier() || this.eatExtendedPatternCharacter();
  } }, { key: "eatReverseSolidusFollowedByC", value: function() {
    return this.currentCodePoint === vF && this.nextCodePoint === 99 && (this._lastIntValue = this.currentCodePoint, this.advance(), this.onCharacter(this.index - 1, this.index, vF), true);
  } }, { key: "eatInvalidBracedQuantifier", value: function() {
    return this.eatBracedQuantifier(true) && this.raise("Nothing to repeat"), false;
  } }, { key: "eatSyntaxCharacter", value: function() {
    return !!MF(this.currentCodePoint) && (this._lastIntValue = this.currentCodePoint, this.advance(), true);
  } }, { key: "eatPatternCharacter", value: function() {
    var e26 = this.index, t2 = this.currentCodePoint;
    return t2 !== -1 && !MF(t2) && (this.advance(), this.onCharacter(e26, this.index, t2), true);
  } }, { key: "eatExtendedPatternCharacter", value: function() {
    var e26 = this.index, t2 = this.currentCodePoint;
    return t2 !== -1 && t2 !== bF && t2 !== eF && t2 !== vF && t2 !== aF && t2 !== nF && t2 !== iF && t2 !== cF && t2 !== tF && t2 !== rF && t2 !== yF && t2 !== CF && (this.advance(), this.onCharacter(e26, this.index, t2), true);
  } }, { key: "groupSpecifier", value: function() {
    if (this._lastStrValue = "", this.eat(cF)) {
      if (this.eatGroupName()) {
        if (!this._groupNames.has(this._lastStrValue))
          return void this._groupNames.add(this._lastStrValue);
        this.raise("Duplicate capture group name");
      }
      this.raise("Invalid group");
    }
  } }, { key: "eatGroupName", value: function() {
    if (this._lastStrValue = "", this.eat(60)) {
      if (this.eatRegExpIdentifierName() && this.eat(62))
        return true;
      this.raise("Invalid capture group name");
    }
    return false;
  } }, { key: "eatRegExpIdentifierName", value: function() {
    if (this._lastStrValue = "", this.eatRegExpIdentifierStart()) {
      for (this._lastStrValue += String.fromCodePoint(this._lastIntValue); this.eatRegExpIdentifierPart(); )
        this._lastStrValue += String.fromCodePoint(this._lastIntValue);
      return true;
    }
    return false;
  } }, { key: "eatRegExpIdentifierStart", value: function() {
    var e26 = this.index, t2 = this.currentCodePoint;
    return this.advance(), t2 === vF && this.eatRegExpUnicodeEscapeSequence() && (t2 = this._lastIntValue), VF(t2) ? (this._lastIntValue = t2, true) : (this.index !== e26 && this.rewind(e26), false);
  } }, { key: "eatRegExpIdentifierPart", value: function() {
    var e26 = this.index, t2 = this.currentCodePoint;
    return this.advance(), t2 === vF && this.eatRegExpUnicodeEscapeSequence() && (t2 = this._lastIntValue), function(e27) {
      return JD(e27) || e27 === eF || e27 === hF || e27 === kF || e27 === DF;
    }(t2) ? (this._lastIntValue = t2, true) : (this.index !== e26 && this.rewind(e26), false);
  } }, { key: "eatAtomEscape", value: function() {
    return !!(this.eatBackreference() || this.eatCharacterClassEscape() || this.eatCharacterEscape() || this._nFlag && this.eatKGroupName()) || ((this.strict || this._uFlag) && this.raise("Invalid escape"), false);
  } }, { key: "eatBackreference", value: function() {
    var e26 = this.index;
    if (this.eatDecimalEscape()) {
      var t2 = this._lastIntValue;
      if (t2 <= this._numCapturingParens)
        return this.onBackreference(e26 - 1, this.index, t2), true;
      this.strict && this.raise("Invalid escape"), this.rewind(e26);
    }
    return false;
  } }, { key: "eatKGroupName", value: function() {
    var e26 = this.index;
    if (this.eat(107)) {
      if (this.eatGroupName()) {
        var t2 = this._lastStrValue;
        return this._backreferenceNames.add(t2), this.onBackreference(e26 - 1, this.index, t2), true;
      }
      this.raise("Invalid named reference");
    }
    return false;
  } }, { key: "eatCharacterEscape", value: function() {
    var e26 = this.index;
    return !!(this.eatControlEscape() || this.eatCControlLetter() || this.eatZero() || this.eatHexEscapeSequence() || this.eatRegExpUnicodeEscapeSequence() || !this.strict && this.eatLegacyOctalEscapeSequence() || this.eatIdentityEscape()) && (this.onCharacter(e26 - 1, this.index, this._lastIntValue), true);
  } }, { key: "eatCControlLetter", value: function() {
    var e26 = this.index;
    if (this.eat(99)) {
      if (this.eatControlLetter())
        return true;
      this.rewind(e26);
    }
    return false;
  } }, { key: "eatZero", value: function() {
    return this.currentCodePoint === oF && !PF(this.nextCodePoint) && (this._lastIntValue = 0, this.advance(), true);
  } }, { key: "eatControlEscape", value: function() {
    return this.eat(116) ? (this._lastIntValue = 9, true) : this.eat(110) ? (this._lastIntValue = YD, true) : this.eat(118) ? (this._lastIntValue = 11, true) : this.eat(mF) ? (this._lastIntValue = 12, true) : !!this.eat(114) && (this._lastIntValue = ZD, true);
  } }, { key: "eatControlLetter", value: function() {
    var e26 = this.currentCodePoint;
    return !!TF(e26) && (this.advance(), this._lastIntValue = e26 % 32, true);
  } }, { key: "eatRegExpUnicodeEscapeSequence", value: function() {
    var e26 = this.index;
    if (this.eat(117)) {
      if (this.eatFixedHexDigits(4)) {
        var t2 = this._lastIntValue;
        if (this._uFlag && t2 >= 55296 && t2 <= 56319) {
          var r2 = this.index;
          if (this.eat(vF) && this.eat(117) && this.eatFixedHexDigits(4)) {
            var n2 = this._lastIntValue;
            if (n2 >= 56320 && n2 <= 57343)
              return this._lastIntValue = 1024 * (t2 - 55296) + (n2 - 56320) + 65536, true;
          }
          this.rewind(r2), this._lastIntValue = t2;
        }
        return true;
      }
      if (this._uFlag && this.eat(EF) && this.eatHexDigits() && this.eat(SF) && function(e27) {
        return e27 >= wF && e27 <= _F;
      }(this._lastIntValue))
        return true;
      (this.strict || this._uFlag) && this.raise("Invalid unicode escape"), this.rewind(e26);
    }
    return false;
  } }, { key: "eatIdentityEscape", value: function() {
    return this._uFlag ? !!this.eatSyntaxCharacter() || !!this.eat(47) && (this._lastIntValue = 47, true) : !!this.isValidIdentityEscape(this.currentCodePoint) && (this._lastIntValue = this.currentCodePoint, this.advance(), true);
  } }, { key: "isValidIdentityEscape", value: function(e26) {
    return e26 !== -1 && (this.strict ? !JD(e26) : e26 !== 99 && (!this._nFlag || e26 !== 107));
  } }, { key: "eatDecimalEscape", value: function() {
    this._lastIntValue = 0;
    var e26 = this.currentCodePoint;
    if (e26 >= 49 && e26 <= uF) {
      do {
        this._lastIntValue = 10 * this._lastIntValue + (e26 - oF), this.advance();
      } while ((e26 = this.currentCodePoint) >= oF && e26 <= uF);
      return true;
    }
    return false;
  } }, { key: "eatCharacterClassEscape", value: function() {
    var e26 = this.index;
    if (this.eat(100))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(e26 - 1, this.index, "digit", false), true;
    if (this.eat(68))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(e26 - 1, this.index, "digit", true), true;
    if (this.eat(115))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(e26 - 1, this.index, "space", false), true;
    if (this.eat(83))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(e26 - 1, this.index, "space", true), true;
    if (this.eat(119))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(e26 - 1, this.index, "word", false), true;
    if (this.eat(87))
      return this._lastIntValue = -1, this.onEscapeCharacterSet(e26 - 1, this.index, "word", true), true;
    var t2 = false;
    if (this._uFlag && this.ecmaVersion >= 2018 && (this.eat(112) || (t2 = this.eat(80)))) {
      if (this._lastIntValue = -1, this.eat(EF) && this.eatUnicodePropertyValueExpression() && this.eat(SF))
        return this.onUnicodePropertyCharacterSet(e26 - 1, this.index, "property", this._lastKeyValue, this._lastValValue || null, t2), true;
      this.raise("Invalid property name");
    }
    return false;
  } }, { key: "eatUnicodePropertyValueExpression", value: function() {
    var e26 = this.index;
    if (this.eatUnicodePropertyName() && this.eat(61) && (this._lastKeyValue = this._lastStrValue, this.eatUnicodePropertyValue())) {
      if (this._lastValValue = this._lastStrValue, qF(this._lastKeyValue, this._lastValValue))
        return true;
      this.raise("Invalid property name");
    }
    if (this.rewind(e26), this.eatLoneUnicodePropertyNameOrValue()) {
      var t2 = this._lastStrValue;
      if (qF("General_Category", t2))
        return this._lastKeyValue = "General_Category", this._lastValValue = t2, true;
      if (function(e27) {
        return XD.$LONE.has(e27);
      }(t2))
        return this._lastKeyValue = t2, this._lastValValue = "", true;
      this.raise("Invalid property name");
    }
    return false;
  } }, { key: "eatUnicodePropertyName", value: function() {
    for (this._lastStrValue = ""; UF(this.currentCodePoint); )
      this._lastStrValue += String.fromCodePoint(this.currentCodePoint), this.advance();
    return this._lastStrValue !== "";
  } }, { key: "eatUnicodePropertyValue", value: function() {
    for (this._lastStrValue = ""; UF(e26 = this.currentCodePoint) || PF(e26); )
      this._lastStrValue += String.fromCodePoint(this.currentCodePoint), this.advance();
    var e26;
    return this._lastStrValue !== "";
  } }, { key: "eatLoneUnicodePropertyNameOrValue", value: function() {
    return this.eatUnicodePropertyValue();
  } }, { key: "eatCharacterClass", value: function() {
    var e26 = this.index;
    if (this.eat(yF)) {
      var t2 = this.eat(bF);
      return this.onCharacterClassEnter(e26, t2), this.classRanges(), this.eat(xF) || this.raise("Unterminated character class"), this.onCharacterClassLeave(e26, this.index, t2), true;
    }
    return false;
  } }, { key: "classRanges", value: function() {
    for (var e26 = this.index; this.eatClassAtom(); ) {
      var t2 = this._lastIntValue, r2 = this.index;
      if (this.eat(45) && (this.onCharacter(r2, this.index, 45), this.eatClassAtom())) {
        var n2 = this._lastIntValue;
        t2 === -1 || n2 === -1 ? this.strict && this.raise("Invalid character class") : t2 > n2 ? this.raise("Range out of order in character class") : this.onCharacterClassRange(e26, this.index, t2, n2);
      }
      e26 = this.index;
    }
  } }, { key: "eatClassAtom", value: function() {
    var e26 = this.index;
    if (this.eat(vF)) {
      if (this.eatClassEscape())
        return true;
      this._uFlag && this.raise("Invalid escape"), this.rewind(e26);
    }
    var t2 = this.currentCodePoint;
    return t2 !== -1 && t2 !== xF && (this.advance(), this._lastIntValue = t2, this.onCharacter(e26, this.index, t2), true);
  } }, { key: "eatClassEscape", value: function() {
    var e26 = this.index;
    if (this.eat(98))
      return this._lastIntValue = 8, this.onCharacter(e26 - 1, this.index, 8), true;
    if (this._uFlag && this.eat(45))
      return this._lastIntValue = 45, this.onCharacter(e26 - 1, this.index, 45), true;
    if (!this._uFlag && this.eat(99)) {
      if (this.eatClassControlLetter())
        return this.onCharacter(e26 - 1, this.index, this._lastIntValue), true;
      this.rewind(e26);
    }
    return this.eatCharacterClassEscape() || this.eatCharacterEscape();
  } }, { key: "eatClassControlLetter", value: function() {
    var e26 = this.currentCodePoint;
    return !(!PF(e26) && e26 !== hF) && (this.advance(), this._lastIntValue = e26 % 32, true);
  } }, { key: "eatHexEscapeSequence", value: function() {
    var e26 = this.index;
    if (this.eat(120)) {
      if (this.eatFixedHexDigits(2))
        return true;
      this._uFlag && this.raise("Invalid escape"), this.rewind(e26);
    }
    return false;
  } }, { key: "eatDecimalDigits", value: function() {
    var e26 = this.index;
    for (this._lastIntValue = 0; PF(this.currentCodePoint); )
      this._lastIntValue = 10 * this._lastIntValue + OF(this.currentCodePoint), this.advance();
    return this.index !== e26;
  } }, { key: "eatHexDigits", value: function() {
    var e26 = this.index;
    for (this._lastIntValue = 0; IF(this.currentCodePoint); )
      this._lastIntValue = 16 * this._lastIntValue + OF(this.currentCodePoint), this.advance();
    return this.index !== e26;
  } }, { key: "eatLegacyOctalEscapeSequence", value: function() {
    if (this.eatOctalDigit()) {
      var e26 = this._lastIntValue;
      if (this.eatOctalDigit()) {
        var t2 = this._lastIntValue;
        e26 <= 3 && this.eatOctalDigit() ? this._lastIntValue = 64 * e26 + 8 * t2 + this._lastIntValue : this._lastIntValue = 8 * e26 + t2;
      } else
        this._lastIntValue = e26;
      return true;
    }
    return false;
  } }, { key: "eatOctalDigit", value: function() {
    var e26 = this.currentCodePoint;
    return function(e27) {
      return e27 >= oF && e27 <= sF;
    }(e26) ? (this.advance(), this._lastIntValue = e26 - oF, true) : (this._lastIntValue = 0, false);
  } }, { key: "eatFixedHexDigits", value: function(e26) {
    var t2 = this.index;
    this._lastIntValue = 0;
    for (var r2 = 0; r2 < e26; ++r2) {
      var n2 = this.currentCodePoint;
      if (!IF(n2))
        return this.rewind(t2), false;
      this._lastIntValue = 16 * this._lastIntValue + OF(n2), this.advance();
    }
    return true;
  } }, { key: "strict", get: function() {
    return Boolean(this._options.strict || this._uFlag);
  } }, { key: "ecmaVersion", get: function() {
    return this._options.ecmaVersion || 2018;
  } }, { key: "source", get: function() {
    return this._reader.source;
  } }, { key: "index", get: function() {
    return this._reader.index;
  } }, { key: "currentCodePoint", get: function() {
    return this._reader.currentCodePoint;
  } }, { key: "nextCodePoint", get: function() {
    return this._reader.nextCodePoint;
  } }, { key: "nextCodePoint2", get: function() {
    return this._reader.nextCodePoint2;
  } }, { key: "nextCodePoint3", get: function() {
    return this._reader.nextCodePoint3;
  } }]), e25;
}(), $F = {}, GF = {}, zF = {}, HF = function() {
  function e25(t2) {
    a(this, e25), this._node = $F, this._flags = GF, this._backreferences = [], this._capturingGroups = [], this.source = "", this.strict = Boolean(t2 && t2.strict), this.ecmaVersion = t2 && t2.ecmaVersion || 2018;
  }
  return s(e25, [{ key: "onFlags", value: function(e26, t2, r2, n2, i2, a2, o2, s2) {
    this._flags = { type: "Flags", parent: null, start: e26, end: t2, raw: this.source.slice(e26, t2), global: r2, ignoreCase: n2, multiline: i2, unicode: a2, sticky: o2, dotAll: s2 };
  } }, { key: "onPatternEnter", value: function(e26) {
    this._node = { type: "Pattern", parent: null, start: e26, end: e26, raw: "", alternatives: [] }, this._backreferences.length = 0, this._capturingGroups.length = 0;
  } }, { key: "onPatternLeave", value: function(e26, t2) {
    var r2 = this;
    this._node.end = t2, this._node.raw = this.source.slice(e26, t2);
    var n2 = true, i2 = false, a2 = void 0;
    try {
      for (var o2, s2 = function() {
        var e27 = o2.value, t3 = e27.ref, n3 = typeof t3 == "number" ? r2._capturingGroups[t3 - 1] : r2._capturingGroups.find(function(e28) {
          return e28.name === t3;
        });
        e27.resolved = n3, n3.references.push(e27);
      }, u2 = this._backreferences[Symbol.iterator](); !(n2 = (o2 = u2.next()).done); n2 = true)
        s2();
    } catch (e27) {
      i2 = true, a2 = e27;
    } finally {
      try {
        n2 || u2.return == null || u2.return();
      } finally {
        if (i2)
          throw a2;
      }
    }
  } }, { key: "onAlternativeEnter", value: function(e26) {
    var t2 = this._node;
    if (t2.type !== "Assertion" && t2.type !== "CapturingGroup" && t2.type !== "Group" && t2.type !== "Pattern")
      throw new Error("UnknownError");
    this._node = { type: "Alternative", parent: t2, start: e26, end: e26, raw: "", elements: [] }, t2.alternatives.push(this._node);
  } }, { key: "onAlternativeLeave", value: function(e26, t2) {
    var r2 = this._node;
    if (r2.type !== "Alternative")
      throw new Error("UnknownError");
    r2.end = t2, r2.raw = this.source.slice(e26, t2), this._node = r2.parent;
  } }, { key: "onGroupEnter", value: function(e26) {
    var t2 = this._node;
    if (t2.type !== "Alternative")
      throw new Error("UnknownError");
    this._node = { type: "Group", parent: t2, start: e26, end: e26, raw: "", alternatives: [] }, t2.elements.push(this._node);
  } }, { key: "onGroupLeave", value: function(e26, t2) {
    var r2 = this._node;
    if (r2.type !== "Group" || r2.parent.type !== "Alternative")
      throw new Error("UnknownError");
    r2.end = t2, r2.raw = this.source.slice(e26, t2), this._node = r2.parent;
  } }, { key: "onCapturingGroupEnter", value: function(e26, t2) {
    var r2 = this._node;
    if (r2.type !== "Alternative")
      throw new Error("UnknownError");
    this._node = { type: "CapturingGroup", parent: r2, start: e26, end: e26, raw: "", name: t2, alternatives: [], references: [] }, r2.elements.push(this._node), this._capturingGroups.push(this._node);
  } }, { key: "onCapturingGroupLeave", value: function(e26, t2) {
    var r2 = this._node;
    if (r2.type !== "CapturingGroup" || r2.parent.type !== "Alternative")
      throw new Error("UnknownError");
    r2.end = t2, r2.raw = this.source.slice(e26, t2), this._node = r2.parent;
  } }, { key: "onQuantifier", value: function(e26, t2, r2, n2, i2) {
    var a2 = this._node;
    if (a2.type !== "Alternative")
      throw new Error("UnknownError");
    var o2 = a2.elements.pop();
    if (o2 == null || o2.type === "Quantifier" || o2.type === "Assertion" && o2.kind !== "lookahead")
      throw new Error("UnknownError");
    var s2 = { type: "Quantifier", parent: a2, start: o2.start, end: t2, raw: this.source.slice(o2.start, t2), min: r2, max: n2, greedy: i2, element: o2 };
    a2.elements.push(s2), o2.parent = s2;
  } }, { key: "onLookaroundAssertionEnter", value: function(e26, t2, r2) {
    var n2 = this._node;
    if (n2.type !== "Alternative")
      throw new Error("UnknownError");
    this._node = { type: "Assertion", parent: n2, start: e26, end: e26, raw: "", kind: t2, negate: r2, alternatives: [] }, n2.elements.push(this._node);
  } }, { key: "onLookaroundAssertionLeave", value: function(e26, t2) {
    var r2 = this._node;
    if (r2.type !== "Assertion" || r2.parent.type !== "Alternative")
      throw new Error("UnknownError");
    r2.end = t2, r2.raw = this.source.slice(e26, t2), this._node = r2.parent;
  } }, { key: "onEdgeAssertion", value: function(e26, t2, r2) {
    var n2 = this._node;
    if (n2.type !== "Alternative")
      throw new Error("UnknownError");
    n2.elements.push({ type: "Assertion", parent: n2, start: e26, end: t2, raw: this.source.slice(e26, t2), kind: r2 });
  } }, { key: "onWordBoundaryAssertion", value: function(e26, t2, r2, n2) {
    var i2 = this._node;
    if (i2.type !== "Alternative")
      throw new Error("UnknownError");
    i2.elements.push({ type: "Assertion", parent: i2, start: e26, end: t2, raw: this.source.slice(e26, t2), kind: r2, negate: n2 });
  } }, { key: "onAnyCharacterSet", value: function(e26, t2, r2) {
    var n2 = this._node;
    if (n2.type !== "Alternative")
      throw new Error("UnknownError");
    n2.elements.push({ type: "CharacterSet", parent: n2, start: e26, end: t2, raw: this.source.slice(e26, t2), kind: r2 });
  } }, { key: "onEscapeCharacterSet", value: function(e26, t2, r2, n2) {
    var i2 = this._node;
    if (i2.type !== "Alternative" && i2.type !== "CharacterClass")
      throw new Error("UnknownError");
    i2.elements.push({ type: "CharacterSet", parent: i2, start: e26, end: t2, raw: this.source.slice(e26, t2), kind: r2, negate: n2 });
  } }, { key: "onUnicodePropertyCharacterSet", value: function(e26, t2, r2, n2, i2, a2) {
    var o2 = this._node;
    if (o2.type !== "Alternative" && o2.type !== "CharacterClass")
      throw new Error("UnknownError");
    o2.elements.push({ type: "CharacterSet", parent: o2, start: e26, end: t2, raw: this.source.slice(e26, t2), kind: r2, key: n2, value: i2, negate: a2 });
  } }, { key: "onCharacter", value: function(e26, t2, r2) {
    var n2 = this._node;
    if (n2.type !== "Alternative" && n2.type !== "CharacterClass")
      throw new Error("UnknownError");
    n2.elements.push({ type: "Character", parent: n2, start: e26, end: t2, raw: this.source.slice(e26, t2), value: r2 });
  } }, { key: "onBackreference", value: function(e26, t2, r2) {
    var n2 = this._node;
    if (n2.type !== "Alternative")
      throw new Error("UnknownError");
    var i2 = { type: "Backreference", parent: n2, start: e26, end: t2, raw: this.source.slice(e26, t2), ref: r2, resolved: zF };
    n2.elements.push(i2), this._backreferences.push(i2);
  } }, { key: "onCharacterClassEnter", value: function(e26, t2) {
    var r2 = this._node;
    if (r2.type !== "Alternative")
      throw new Error("UnknownError");
    this._node = { type: "CharacterClass", parent: r2, start: e26, end: e26, raw: "", negate: t2, elements: [] }, r2.elements.push(this._node);
  } }, { key: "onCharacterClassLeave", value: function(e26, t2) {
    var r2 = this._node;
    if (r2.type !== "CharacterClass" || r2.parent.type !== "Alternative")
      throw new Error("UnknownError");
    r2.end = t2, r2.raw = this.source.slice(e26, t2), this._node = r2.parent;
  } }, { key: "onCharacterClassRange", value: function(e26, t2) {
    var r2 = this._node;
    if (r2.type !== "CharacterClass")
      throw new Error("UnknownError");
    var n2 = r2.elements, i2 = n2.pop(), a2 = n2.pop(), o2 = n2.pop();
    if (!o2 || !i2 || !a2 || o2.type !== "Character" || i2.type !== "Character" || a2.type !== "Character" || a2.value !== 45)
      throw new Error("UnknownError");
    var s2 = { type: "CharacterClassRange", parent: r2, start: e26, end: t2, raw: this.source.slice(e26, t2), min: o2, max: i2 };
    o2.parent = s2, i2.parent = s2, n2.push(s2);
  } }, { key: "pattern", get: function() {
    if (this._node.type !== "Pattern")
      throw new Error("UnknownError");
    return this._node;
  } }, { key: "flags", get: function() {
    if (this._flags.type !== "Flags")
      throw new Error("UnknownError");
    return this._flags;
  } }]), e25;
}(), KF = function() {
  function e25(t2) {
    a(this, e25), this._state = new HF(t2), this._validator = new WF(this._state);
  }
  return s(e25, [{ key: "parseLiteral", value: function(e26) {
    var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e26.length;
    this._state.source = e26, this._validator.validateLiteral(e26, t2, r2);
    var n2 = this._state.pattern, i2 = this._state.flags, a2 = { type: "RegExpLiteral", parent: null, start: t2, end: r2, raw: e26, pattern: n2, flags: i2 };
    return n2.parent = a2, i2.parent = a2, a2;
  } }, { key: "parseFlags", value: function(e26) {
    var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e26.length;
    return this._state.source = e26, this._validator.validateFlags(e26, t2, r2), this._state.flags;
  } }, { key: "parsePattern", value: function(e26) {
    var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : e26.length, n2 = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
    return this._state.source = e26, this._validator.validatePattern(e26, t2, r2, n2), this._state.pattern;
  } }]), e25;
}(), JF = function() {
  function e25(t2) {
    a(this, e25), this._handlers = t2;
  }
  return s(e25, [{ key: "visit", value: function(e26) {
    switch (e26.type) {
      case "Alternative":
        this.visitAlternative(e26);
        break;
      case "Assertion":
        this.visitAssertion(e26);
        break;
      case "Backreference":
        this.visitBackreference(e26);
        break;
      case "CapturingGroup":
        this.visitCapturingGroup(e26);
        break;
      case "Character":
        this.visitCharacter(e26);
        break;
      case "CharacterClass":
        this.visitCharacterClass(e26);
        break;
      case "CharacterClassRange":
        this.visitCharacterClassRange(e26);
        break;
      case "CharacterSet":
        this.visitCharacterSet(e26);
        break;
      case "Flags":
        this.visitFlags(e26);
        break;
      case "Group":
        this.visitGroup(e26);
        break;
      case "Pattern":
        this.visitPattern(e26);
        break;
      case "Quantifier":
        this.visitQuantifier(e26);
        break;
      case "RegExpLiteral":
        this.visitRegExpLiteral(e26);
        break;
      default:
        throw new Error("Unknown type: ".concat(e26.type));
    }
  } }, { key: "visitAlternative", value: function(e26) {
    this._handlers.onAlternativeEnter && this._handlers.onAlternativeEnter(e26), e26.elements.forEach(this.visit, this), this._handlers.onAlternativeLeave && this._handlers.onAlternativeLeave(e26);
  } }, { key: "visitAssertion", value: function(e26) {
    this._handlers.onAssertionEnter && this._handlers.onAssertionEnter(e26), e26.kind !== "lookahead" && e26.kind !== "lookbehind" || e26.alternatives.forEach(this.visit, this), this._handlers.onAssertionLeave && this._handlers.onAssertionLeave(e26);
  } }, { key: "visitBackreference", value: function(e26) {
    this._handlers.onBackreferenceEnter && this._handlers.onBackreferenceEnter(e26), this._handlers.onBackreferenceLeave && this._handlers.onBackreferenceLeave(e26);
  } }, { key: "visitCapturingGroup", value: function(e26) {
    this._handlers.onCapturingGroupEnter && this._handlers.onCapturingGroupEnter(e26), e26.alternatives.forEach(this.visit, this), this._handlers.onCapturingGroupLeave && this._handlers.onCapturingGroupLeave(e26);
  } }, { key: "visitCharacter", value: function(e26) {
    this._handlers.onCharacterEnter && this._handlers.onCharacterEnter(e26), this._handlers.onCharacterLeave && this._handlers.onCharacterLeave(e26);
  } }, { key: "visitCharacterClass", value: function(e26) {
    this._handlers.onCharacterClassEnter && this._handlers.onCharacterClassEnter(e26), e26.elements.forEach(this.visit, this), this._handlers.onCharacterClassLeave && this._handlers.onCharacterClassLeave(e26);
  } }, { key: "visitCharacterClassRange", value: function(e26) {
    this._handlers.onCharacterClassRangeEnter && this._handlers.onCharacterClassRangeEnter(e26), this.visitCharacter(e26.min), this.visitCharacter(e26.max), this._handlers.onCharacterClassRangeLeave && this._handlers.onCharacterClassRangeLeave(e26);
  } }, { key: "visitCharacterSet", value: function(e26) {
    this._handlers.onCharacterSetEnter && this._handlers.onCharacterSetEnter(e26), this._handlers.onCharacterSetLeave && this._handlers.onCharacterSetLeave(e26);
  } }, { key: "visitFlags", value: function(e26) {
    this._handlers.onFlagsEnter && this._handlers.onFlagsEnter(e26), this._handlers.onFlagsLeave && this._handlers.onFlagsLeave(e26);
  } }, { key: "visitGroup", value: function(e26) {
    this._handlers.onGroupEnter && this._handlers.onGroupEnter(e26), e26.alternatives.forEach(this.visit, this), this._handlers.onGroupLeave && this._handlers.onGroupLeave(e26);
  } }, { key: "visitPattern", value: function(e26) {
    this._handlers.onPatternEnter && this._handlers.onPatternEnter(e26), e26.alternatives.forEach(this.visit, this), this._handlers.onPatternLeave && this._handlers.onPatternLeave(e26);
  } }, { key: "visitQuantifier", value: function(e26) {
    this._handlers.onQuantifierEnter && this._handlers.onQuantifierEnter(e26), this.visit(e26.element), this._handlers.onQuantifierLeave && this._handlers.onQuantifierLeave(e26);
  } }, { key: "visitRegExpLiteral", value: function(e26) {
    this._handlers.onRegExpLiteralEnter && this._handlers.onRegExpLiteralEnter(e26), this.visitPattern(e26.pattern), this.visitFlags(e26.flags), this._handlers.onRegExpLiteralLeave && this._handlers.onRegExpLiteralLeave(e26);
  } }]), e25;
}();
var QF = Object.freeze({ __proto__: null, AST: KD, RegExpParser: KF, RegExpValidator: WF, parseRegExpLiteral: function(e25, t2) {
  return new KF(t2).parseLiteral(String(e25));
}, validateRegExpLiteral: function(e25, t2) {
  return new WF(t2).validateLiteral(e25);
}, visitRegExpAST: function(e25, t2) {
  new JF(t2).visit(e25);
} });
function XF(e25) {
  return Array.isArray(e25) ? e25 : [e25];
}
var YF = /^\s+$/, ZF = /^\\!/, eA = /^\\#/, tA = typeof Symbol != "undefined" ? Symbol.for("node-ignore") : "node-ignore", rA = function(e25, t2, r2) {
  return Object.defineProperty(e25, t2, { value: r2 });
}, nA = /([0-z])-([0-z])/g, iA = [[/\\?\s+$/, function(e25) {
  return e25.indexOf("\\") === 0 ? " " : "";
}], [/\\\s/g, function() {
  return " ";
}], [/[\\^$.|*+(){]/g, function(e25) {
  return "\\".concat(e25);
}], [/\[([^\]/]*)($|\])/g, function(e25, t2, r2) {
  return r2 === "]" ? "[".concat(t2.replace(nA, function(e26, t3, r3) {
    return t3.charCodeAt(0) <= r3.charCodeAt(0) ? e26 : "";
  }), "]") : "\\".concat(e25);
}], [/(?!\\)\?/g, function() {
  return "[^/]";
}], [/^\//, function() {
  return "^";
}], [/\//g, function() {
  return "\\/";
}], [/^\^*\\\*\\\*\\\//, function() {
  return "^(?:.*\\/)?";
}]], aA = [[/^(?=[^^])/, function() {
  return /\/(?!$)/.test(this) ? "^" : "(?:^|\\/)";
}], [/\\\/\\\*\\\*(?=\\\/|$)/g, function(e25, t2, r2) {
  return t2 + 6 < r2.length ? "(?:\\/[^\\/]+)*" : "\\/.+";
}], [/(^|[^\\]+)\\\*(?=.+)/g, function(e25, t2) {
  return "".concat(t2, "[^\\/]*");
}], [/(\^|\\\/)?\\\*$/, function(e25, t2) {
  var r2 = t2 ? "".concat(t2, "[^/]+") : "[^/]*";
  return "".concat(r2, "(?=$|\\/$)");
}], [/\\\\\\/g, function() {
  return "\\";
}]], oA = [].concat(iA, [[/(?:[^*/])$/, function(e25) {
  return "".concat(e25, "(?=$|\\/)");
}]], aA), sA = [].concat(iA, [[/(?:[^*])$/, function(e25) {
  return "".concat(e25, "(?=$|\\/$)");
}]], aA), uA = Object.create(null), cA = function(e25, t2) {
  var r2 = e25, n2 = false;
  return e25.indexOf("!") === 0 && (n2 = true, e25 = e25.substr(1)), { origin: r2, pattern: e25 = e25.replace(ZF, "!").replace(eA, "#"), negative: n2, regex: function(e26, t3, r3) {
    var n3 = uA[e26];
    if (n3)
      return n3;
    var i2 = (t3 ? sA : oA).reduce(function(t4, r4) {
      return t4.replace(r4[0], r4[1].bind(e26));
    }, e26);
    return uA[e26] = r3 ? new RegExp(i2, "i") : new RegExp(i2);
  }(e25, n2, t2) };
}, lA = function() {
  function e25() {
    var t2 = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).ignorecase, r2 = t2 === void 0 || t2;
    a(this, e25), this._rules = [], this._ignorecase = r2, rA(this, tA, true), this._initCache();
  }
  return s(e25, [{ key: "_initCache", value: function() {
    this._cache = Object.create(null);
  } }, { key: "add", value: function(e26) {
    return this._added = false, typeof e26 == "string" && (e26 = e26.split(/\r?\n/g)), XF(e26).forEach(this._addPattern, this), this._added && this._initCache(), this;
  } }, { key: "addPattern", value: function(e26) {
    return this.add(e26);
  } }, { key: "_addPattern", value: function(e26) {
    if (e26 && e26[tA])
      return this._rules = this._rules.concat(e26._rules), void (this._added = true);
    if (function(e27) {
      return e27 && typeof e27 == "string" && !YF.test(e27) && e27.indexOf("#") !== 0;
    }(e26)) {
      var t2 = cA(e26, this._ignorecase);
      this._added = true, this._rules.push(t2);
    }
  } }, { key: "filter", value: function(e26) {
    var t2 = this;
    return XF(e26).filter(function(e27) {
      return t2._filter(e27);
    });
  } }, { key: "createFilter", value: function() {
    var e26 = this;
    return function(t2) {
      return e26._filter(t2);
    };
  } }, { key: "ignores", value: function(e26) {
    return !this._filter(e26);
  } }, { key: "_filter", value: function(e26, t2) {
    return !!e26 && (e26 in this._cache ? this._cache[e26] : (t2 || (t2 = e26.split("/")), t2.pop(), this._cache[e26] = t2.length ? this._filter(t2.join("/") + "/", t2) && this._test(e26) : this._test(e26)));
  } }, { key: "_test", value: function(e26) {
    var t2 = 0;
    return this._rules.forEach(function(r2) {
      t2 ^ r2.negative || (t2 = r2.negative ^ r2.regex.test(e26));
    }), !t2;
  } }]), e25;
}();
if (typeof process != "undefined" && (process.env && {}.IGNORE_TEST_WIN32 || process.platform === "win32")) {
  var pA = lA.prototype._filter;
  lA.prototype._filter = function(e25, t2) {
    var r2;
    return e25 = /^\\\\\?\\/.test(r2 = e25) || /[^\x00-\x80]+/.test(r2) ? r2 : r2.replace(/\\/g, "/"), pA.call(this, e25, t2);
  };
}
var fA = r(function(e25) {
  /*
     * @version    1.4.0
     * @date       2015-10-26
     * @stability  3 - Stable
     * @author     Lauri Rooden (https://github.com/litejs/natural-compare-lite)
     * @license    MIT License
     */
  var t2 = function(e26, t3) {
    var r2, n2, i2 = 1, a2 = 0, o2 = 0, s2 = String.alphabet;
    function u2(e27, t4, n3) {
      if (n3) {
        for (r2 = t4; (n3 = u2(e27, r2)) < 76 && n3 > 65; )
          ++r2;
        return +e27.slice(t4 - 1, r2);
      }
      return (n3 = s2 && s2.indexOf(e27.charAt(t4))) > -1 ? n3 + 76 : (n3 = e27.charCodeAt(t4) || 0) < 45 || n3 > 127 ? n3 : n3 < 46 ? 65 : n3 < 48 ? n3 - 1 : n3 < 58 ? n3 + 18 : n3 < 65 ? n3 - 11 : n3 < 91 ? n3 + 11 : n3 < 97 ? n3 - 37 : n3 < 123 ? n3 + 5 : n3 - 63;
    }
    if ((e26 += "") != (t3 += "")) {
      for (; i2; )
        if (n2 = u2(e26, a2++), i2 = u2(t3, o2++), n2 < 76 && i2 < 76 && n2 > 66 && i2 > 66 && (n2 = u2(e26, a2, a2), i2 = u2(t3, o2, a2 = r2), o2 = r2), n2 != i2)
          return n2 < i2 ? -1 : 1;
    }
    return 0;
  };
  try {
    e25.exports = t2;
  } catch (e26) {
    String.naturalCompare = t2;
  }
}), hA = "https://github.com/eslint/doctrine", dA = { node: ">=6.0.0" }, mA = { lib: "./lib" }, gA = ["lib"], yA = [{ name: "Nicholas C. Zakas", email: "nicholas+npm@nczconsulting.com", web: "https://www.nczonline.net" }, { name: "Yusuke Suzuki", email: "utatane.tea@gmail.com", web: "https://github.com/Constellation" }], vA = { coveralls: "^3.0.1", dateformat: "^1.0.11", eslint: "^1.10.3", "eslint-release": "^1.0.0", linefix: "^0.1.1", mocha: "^3.4.2", "npm-license": "^0.3.1", nyc: "^10.3.2", semver: "^5.0.3", shelljs: "^0.5.3", "shelljs-nodecli": "^0.1.1", should: "^5.0.1" }, xA = { pretest: "npm run lint", test: "nyc mocha", coveralls: "nyc report --reporter=text-lcov | coveralls", lint: "eslint lib/", "generate-release": "eslint-generate-release", "generate-alpharelease": "eslint-generate-prerelease alpha", "generate-betarelease": "eslint-generate-prerelease beta", "generate-rcrelease": "eslint-generate-prerelease rc", "publish-release": "eslint-publish-release" }, bA = { esutils: "^2.0.2" }, EA = { name: "doctrine", description: "JSDoc parser", homepage: hA, main: "lib/doctrine.js", version: "3.0.0", engines: dA, directories: mA, files: gA, maintainers: yA, repository: "eslint/doctrine", devDependencies: vA, license: "Apache-2.0", scripts: xA, dependencies: bA }, CA = n(Object.freeze({ __proto__: null, name: "doctrine", description: "JSDoc parser", homepage: hA, main: "lib/doctrine.js", version: "3.0.0", engines: dA, directories: mA, files: gA, maintainers: yA, repository: "eslint/doctrine", devDependencies: vA, license: "Apache-2.0", scripts: xA, dependencies: bA, default: EA })), SA = r(function(e25, t2) {
  !function() {
    var e26, r2;
    function n2(e27) {
      this.name = "DoctrineError", this.message = e27;
    }
    e26 = CA.version, t2.VERSION = e26, n2.prototype = ((r2 = function() {
    }).prototype = Error.prototype, new r2()), n2.prototype.constructor = n2, t2.DoctrineError = n2, t2.throwError = function(e27) {
      throw new n2(e27);
    }, t2.assert = Pu;
  }();
}), kA = (SA.VERSION, SA.DoctrineError, SA.throwError, SA.assert, r(function(e25, t2) {
  !function() {
    var e26, r2, n2, i2, a2, o2, s2, u2, c2, l2, p2, f2;
    function h2(e27) {
      return "><(){}[],:*|?!=".indexOf(String.fromCharCode(e27)) === -1 && !c2.code.isWhiteSpace(e27) && !c2.code.isLineTerminator(e27);
    }
    function d2(e27, t3, r3, n3) {
      this._previous = e27, this._index = t3, this._token = r3, this._value = n3;
    }
    function m2(e27, t3) {
      return f2 && (e27.range = [t3[0] + p2, t3[1] + p2]), e27;
    }
    function g2() {
      var e27 = n2.charAt(a2);
      return a2 += 1, e27;
    }
    function y2(e27) {
      var t3, r3, o3, s3 = 0;
      for (r3 = e27 === "u" ? 4 : 2, t3 = 0; t3 < r3; ++t3) {
        if (!(a2 < i2 && c2.code.isHexDigit(n2.charCodeAt(a2))))
          return "";
        o3 = g2(), s3 = 16 * s3 + "0123456789abcdef".indexOf(o3.toLowerCase());
      }
      return String.fromCharCode(s3);
    }
    function v2() {
      var e27, t3;
      if (e27 = "", (t3 = n2.charCodeAt(a2)) !== 46) {
        if (e27 = g2(), t3 = n2.charCodeAt(a2), e27 === "0") {
          if (t3 === 120 || t3 === 88) {
            for (e27 += g2(); a2 < i2 && (t3 = n2.charCodeAt(a2), c2.code.isHexDigit(t3)); )
              e27 += g2();
            return e27.length <= 2 && l2.throwError("unexpected token"), a2 < i2 && (t3 = n2.charCodeAt(a2), c2.code.isIdentifierStartES5(t3) && l2.throwError("unexpected token")), u2 = parseInt(e27, 16), r2.NUMBER;
          }
          if (c2.code.isOctalDigit(t3)) {
            for (e27 += g2(); a2 < i2 && (t3 = n2.charCodeAt(a2), c2.code.isOctalDigit(t3)); )
              e27 += g2();
            return a2 < i2 && (t3 = n2.charCodeAt(a2), (c2.code.isIdentifierStartES5(t3) || c2.code.isDecimalDigit(t3)) && l2.throwError("unexpected token")), u2 = parseInt(e27, 8), r2.NUMBER;
          }
          c2.code.isDecimalDigit(t3) && l2.throwError("unexpected token");
        }
        for (; a2 < i2 && (t3 = n2.charCodeAt(a2), c2.code.isDecimalDigit(t3)); )
          e27 += g2();
      }
      if (t3 === 46)
        for (e27 += g2(); a2 < i2 && (t3 = n2.charCodeAt(a2), c2.code.isDecimalDigit(t3)); )
          e27 += g2();
      if (t3 === 101 || t3 === 69)
        if (e27 += g2(), (t3 = n2.charCodeAt(a2)) !== 43 && t3 !== 45 || (e27 += g2()), t3 = n2.charCodeAt(a2), c2.code.isDecimalDigit(t3))
          for (e27 += g2(); a2 < i2 && (t3 = n2.charCodeAt(a2), c2.code.isDecimalDigit(t3)); )
            e27 += g2();
        else
          l2.throwError("unexpected token");
      return a2 < i2 && (t3 = n2.charCodeAt(a2), c2.code.isIdentifierStartES5(t3) && l2.throwError("unexpected token")), u2 = parseFloat(e27), r2.NUMBER;
    }
    function x2() {
      var e27;
      for (o2 = a2; a2 < i2 && c2.code.isWhiteSpace(n2.charCodeAt(a2)); )
        g2();
      if (a2 >= i2)
        return s2 = r2.EOF;
      switch (e27 = n2.charCodeAt(a2)) {
        case 39:
        case 34:
          return s2 = function() {
            var e28, t3, o3, s3, p3, f3 = "";
            for (e28 = n2.charAt(a2), ++a2; a2 < i2; ) {
              if ((t3 = g2()) === e28) {
                e28 = "";
                break;
              }
              if (t3 === "\\")
                if (t3 = g2(), c2.code.isLineTerminator(t3.charCodeAt(0)))
                  t3 === "\r" && n2.charCodeAt(a2) === 10 && ++a2;
                else
                  switch (t3) {
                    case "n":
                      f3 += "\n";
                      break;
                    case "r":
                      f3 += "\r";
                      break;
                    case "t":
                      f3 += "	";
                      break;
                    case "u":
                    case "x":
                      p3 = a2, (s3 = y2(t3)) ? f3 += s3 : (a2 = p3, f3 += t3);
                      break;
                    case "b":
                      f3 += "\b";
                      break;
                    case "f":
                      f3 += "\f";
                      break;
                    case "v":
                      f3 += "\v";
                      break;
                    default:
                      c2.code.isOctalDigit(t3.charCodeAt(0)) ? (o3 = "01234567".indexOf(t3), a2 < i2 && c2.code.isOctalDigit(n2.charCodeAt(a2)) && (o3 = 8 * o3 + "01234567".indexOf(g2()), "0123".indexOf(t3) >= 0 && a2 < i2 && c2.code.isOctalDigit(n2.charCodeAt(a2)) && (o3 = 8 * o3 + "01234567".indexOf(g2()))), f3 += String.fromCharCode(o3)) : f3 += t3;
                  }
              else {
                if (c2.code.isLineTerminator(t3.charCodeAt(0)))
                  break;
                f3 += t3;
              }
            }
            return e28 !== "" && l2.throwError("unexpected quote"), u2 = f3, r2.STRING;
          }();
        case 58:
          return g2(), s2 = r2.COLON;
        case 44:
          return g2(), s2 = r2.COMMA;
        case 40:
          return g2(), s2 = r2.LPAREN;
        case 41:
          return g2(), s2 = r2.RPAREN;
        case 91:
          return g2(), s2 = r2.LBRACK;
        case 93:
          return g2(), s2 = r2.RBRACK;
        case 123:
          return g2(), s2 = r2.LBRACE;
        case 125:
          return g2(), s2 = r2.RBRACE;
        case 46:
          if (a2 + 1 < i2) {
            if ((e27 = n2.charCodeAt(a2 + 1)) === 60)
              return g2(), g2(), s2 = r2.DOT_LT;
            if (e27 === 46 && a2 + 2 < i2 && n2.charCodeAt(a2 + 2) === 46)
              return g2(), g2(), g2(), s2 = r2.REST;
            if (c2.code.isDecimalDigit(e27))
              return s2 = v2();
          }
          return s2 = r2.ILLEGAL;
        case 60:
          return g2(), s2 = r2.LT;
        case 62:
          return g2(), s2 = r2.GT;
        case 42:
          return g2(), s2 = r2.STAR;
        case 124:
          return g2(), s2 = r2.PIPE;
        case 63:
          return g2(), s2 = r2.QUESTION;
        case 33:
          return g2(), s2 = r2.BANG;
        case 61:
          return g2(), s2 = r2.EQUAL;
        case 45:
          return s2 = v2();
        default:
          return c2.code.isDecimalDigit(e27) ? s2 = v2() : (l2.assert(h2(e27)), s2 = function() {
            for (u2 = g2(); a2 < i2 && h2(n2.charCodeAt(a2)); ) {
              if (n2.charCodeAt(a2) === 46) {
                if (a2 + 1 >= i2)
                  return r2.ILLEGAL;
                if (n2.charCodeAt(a2 + 1) === 60)
                  break;
              }
              u2 += g2();
            }
            return r2.NAME;
          }());
      }
    }
    function b2(e27, t3) {
      l2.assert(s2 === e27, t3 || "consumed token not matched"), x2();
    }
    function E2(e27, t3) {
      s2 !== e27 && l2.throwError(t3 || "unexpected token"), x2();
    }
    function C2() {
      var t3, n3, i3 = o2;
      return n3 = u2, t3 = s2 === r2.NAME || s2 === r2.STRING ? (x2(), n3) : s2 === r2.NUMBER ? (b2(r2.NUMBER), String(n3)) : void l2.throwError("unexpected token"), s2 === r2.COLON ? (b2(r2.COLON), m2({ type: e26.FieldType, key: t3, value: A2() }, [i3, o2])) : m2({ type: e26.FieldType, key: t3, value: null }, [i3, o2]);
    }
    function S2() {
      var t3, n3, i3 = a2 - u2.length;
      return t3 = function() {
        var t4 = u2, n4 = a2 - t4.length;
        return E2(r2.NAME), s2 !== r2.COLON || t4 !== "module" && t4 !== "external" && t4 !== "event" || (b2(r2.COLON), t4 += ":" + u2, E2(r2.NAME)), m2({ type: e26.NameExpression, name: t4 }, [n4, o2]);
      }(), s2 === r2.DOT_LT || s2 === r2.LT ? (x2(), n3 = function() {
        var e27 = [];
        for (e27.push(w2()); s2 === r2.COMMA; )
          b2(r2.COMMA), e27.push(w2());
        return e27;
      }(), E2(r2.GT), m2({ type: e26.TypeApplication, expression: t3, applications: n3 }, [i3, o2])) : t3;
    }
    function k2() {
      for (var t3, n3, i3, u3 = [], c3 = false, p3 = false, f3 = a2 - 3; s2 !== r2.RPAREN; )
        s2 === r2.REST && (b2(r2.REST), p3 = true), n3 = o2, (t3 = A2()).type === e26.NameExpression && s2 === r2.COLON && (i3 = o2 - t3.name.length, b2(r2.COLON), t3 = m2({ type: e26.ParameterType, name: t3.name, expression: A2() }, [i3, o2])), s2 === r2.EQUAL ? (b2(r2.EQUAL), t3 = m2({ type: e26.OptionalType, expression: t3 }, [n3, o2]), c3 = true) : c3 && l2.throwError("unexpected token"), p3 && (t3 = m2({ type: e26.RestType, expression: t3 }, [f3, o2])), u3.push(t3), s2 !== r2.RPAREN && E2(r2.COMMA);
      return u3;
    }
    function D2() {
      var t3, n3, i3, c3, p3, f3 = a2 - u2.length;
      return l2.assert(s2 === r2.NAME && u2 === "function", "FunctionType should start with 'function'"), b2(r2.NAME), E2(r2.LPAREN), t3 = false, i3 = [], n3 = null, s2 !== r2.RPAREN && (s2 !== r2.NAME || u2 !== "this" && u2 !== "new" ? i3 = k2() : (t3 = u2 === "new", b2(r2.NAME), E2(r2.COLON), n3 = S2(), s2 === r2.COMMA && (b2(r2.COMMA), i3 = k2()))), E2(r2.RPAREN), c3 = null, s2 === r2.COLON && (b2(r2.COLON, "ResultType should start with :"), c3 = s2 === r2.NAME && u2 === "void" ? (b2(r2.NAME), { type: e26.VoidLiteral }) : A2()), p3 = m2({ type: e26.FunctionType, params: i3, result: c3 }, [f3, o2]), n3 && (p3.this = n3, t3 && (p3.new = true)), p3;
    }
    function F2() {
      var t3, n3;
      switch (s2) {
        case r2.STAR:
          return b2(r2.STAR), m2({ type: e26.AllLiteral }, [o2 - 1, o2]);
        case r2.LPAREN:
          return function() {
            var t4, n4 = a2 - 1;
            if (b2(r2.LPAREN, "UnionType should start with ("), t4 = [], s2 !== r2.RPAREN)
              for (; t4.push(A2()), s2 !== r2.RPAREN; )
                E2(r2.PIPE);
            return b2(r2.RPAREN, "UnionType should end with )"), m2({ type: e26.UnionType, elements: t4 }, [n4, o2]);
          }();
        case r2.LBRACK:
          return function() {
            var t4, n4, i3 = a2 - 1;
            for (b2(r2.LBRACK, "ArrayType should start with ["), t4 = []; s2 !== r2.RBRACK; ) {
              if (s2 === r2.REST) {
                n4 = a2 - 3, b2(r2.REST), t4.push(m2({ type: e26.RestType, expression: A2() }, [n4, o2]));
                break;
              }
              t4.push(A2()), s2 !== r2.RBRACK && E2(r2.COMMA);
            }
            return E2(r2.RBRACK), m2({ type: e26.ArrayType, elements: t4 }, [i3, o2]);
          }();
        case r2.LBRACE:
          return function() {
            var t4, n4, i3 = a2 - 1;
            if (b2(r2.LBRACE, "RecordType should start with {"), t4 = [], s2 === r2.COMMA)
              b2(r2.COMMA);
            else
              for (; s2 !== r2.RBRACE; )
                t4.push(C2()), s2 !== r2.RBRACE && E2(r2.COMMA);
            return n4 = a2, E2(r2.RBRACE), m2({ type: e26.RecordType, fields: t4 }, [i3, n4]);
          }();
        case r2.NAME:
          if (n3 = a2 - u2.length, u2 === "null")
            return b2(r2.NAME), m2({ type: e26.NullLiteral }, [n3, o2]);
          if (u2 === "undefined")
            return b2(r2.NAME), m2({ type: e26.UndefinedLiteral }, [n3, o2]);
          if (u2 === "true" || u2 === "false")
            return b2(r2.NAME), m2({ type: e26.BooleanLiteralType, value: u2 === "true" }, [n3, o2]);
          if (t3 = d2.save(), u2 === "function")
            try {
              return D2();
            } catch (e27) {
              t3.restore();
            }
          return S2();
        case r2.STRING:
          return x2(), m2({ type: e26.StringLiteralType, value: u2 }, [o2 - u2.length - 2, o2]);
        case r2.NUMBER:
          return x2(), m2({ type: e26.NumericLiteralType, value: u2 }, [o2 - String(u2).length, o2]);
        default:
          l2.throwError("unexpected token");
      }
    }
    function A2() {
      var t3, n3;
      return s2 === r2.QUESTION ? (n3 = a2 - 1, b2(r2.QUESTION), s2 === r2.COMMA || s2 === r2.EQUAL || s2 === r2.RBRACE || s2 === r2.RPAREN || s2 === r2.PIPE || s2 === r2.EOF || s2 === r2.RBRACK || s2 === r2.GT ? m2({ type: e26.NullableLiteral }, [n3, o2]) : m2({ type: e26.NullableType, expression: F2(), prefix: true }, [n3, o2])) : s2 === r2.BANG ? (n3 = a2 - 1, b2(r2.BANG), m2({ type: e26.NonNullableType, expression: F2(), prefix: true }, [n3, o2])) : (n3 = o2, t3 = F2(), s2 === r2.BANG ? (b2(r2.BANG), m2({ type: e26.NonNullableType, expression: t3, prefix: false }, [n3, o2])) : s2 === r2.QUESTION ? (b2(r2.QUESTION), m2({ type: e26.NullableType, expression: t3, prefix: false }, [n3, o2])) : s2 === r2.LBRACK ? (b2(r2.LBRACK), E2(r2.RBRACK, "expected an array-style type declaration (" + u2 + "[])"), m2({ type: e26.TypeApplication, expression: m2({ type: e26.NameExpression, name: "Array" }, [n3, o2]), applications: [t3] }, [n3, o2])) : t3);
    }
    function w2() {
      var t3, n3;
      if (t3 = A2(), s2 !== r2.PIPE)
        return t3;
      for (n3 = [t3], b2(r2.PIPE); n3.push(A2()), s2 === r2.PIPE; )
        b2(r2.PIPE);
      return m2({ type: e26.UnionType, elements: n3 }, [0, a2]);
    }
    c2 = PD, l2 = SA, e26 = { NullableLiteral: "NullableLiteral", AllLiteral: "AllLiteral", NullLiteral: "NullLiteral", UndefinedLiteral: "UndefinedLiteral", VoidLiteral: "VoidLiteral", UnionType: "UnionType", ArrayType: "ArrayType", RecordType: "RecordType", FieldType: "FieldType", FunctionType: "FunctionType", ParameterType: "ParameterType", RestType: "RestType", NonNullableType: "NonNullableType", OptionalType: "OptionalType", NullableType: "NullableType", NameExpression: "NameExpression", TypeApplication: "TypeApplication", StringLiteralType: "StringLiteralType", NumericLiteralType: "NumericLiteralType", BooleanLiteralType: "BooleanLiteralType" }, r2 = { ILLEGAL: 0, DOT_LT: 1, REST: 2, LT: 3, GT: 4, LPAREN: 5, RPAREN: 6, LBRACE: 7, RBRACE: 8, LBRACK: 9, RBRACK: 10, COMMA: 11, COLON: 12, STAR: 13, PIPE: 14, QUESTION: 15, BANG: 16, EQUAL: 17, NAME: 18, STRING: 19, NUMBER: 20, EOF: 21 }, d2.prototype.restore = function() {
      o2 = this._previous, a2 = this._index, s2 = this._token, u2 = this._value;
    }, d2.save = function() {
      return new d2(o2, a2, s2, u2);
    }, t2.parseType = function(e27, t3) {
      var u3;
      return i2 = (n2 = e27).length, a2 = 0, o2 = 0, f2 = t3 && t3.range, p2 = t3 && t3.startIndex || 0, x2(), u3 = w2(), t3 && t3.midstream ? { expression: u3, index: o2 } : (s2 !== r2.EOF && l2.throwError("not reach to EOF"), u3);
    }, t2.parseParamType = function(t3, u3) {
      var c3;
      return i2 = (n2 = t3).length, a2 = 0, o2 = 0, f2 = u3 && u3.range, p2 = u3 && u3.startIndex || 0, x2(), c3 = function() {
        var t4;
        return s2 === r2.REST ? (b2(r2.REST), m2({ type: e26.RestType, expression: w2() }, [0, a2])) : (t4 = w2(), s2 === r2.EQUAL ? (b2(r2.EQUAL), m2({ type: e26.OptionalType, expression: t4 }, [0, a2])) : t4);
      }(), u3 && u3.midstream ? { expression: c3, index: o2 } : (s2 !== r2.EOF && l2.throwError("not reach to EOF"), c3);
    }, t2.stringify = function(t3, r3) {
      return r3 == null && (r3 = {}), function t4(r4, n3, i3) {
        var a3, o3, s3;
        switch (r4.type) {
          case e26.NullableLiteral:
            a3 = "?";
            break;
          case e26.AllLiteral:
            a3 = "*";
            break;
          case e26.NullLiteral:
            a3 = "null";
            break;
          case e26.UndefinedLiteral:
            a3 = "undefined";
            break;
          case e26.VoidLiteral:
            a3 = "void";
            break;
          case e26.UnionType:
            for (a3 = i3 ? "" : "(", o3 = 0, s3 = r4.elements.length; o3 < s3; ++o3)
              a3 += t4(r4.elements[o3], n3), o3 + 1 !== s3 && (a3 += n3 ? "|" : " | ");
            i3 || (a3 += ")");
            break;
          case e26.ArrayType:
            for (a3 = "[", o3 = 0, s3 = r4.elements.length; o3 < s3; ++o3)
              a3 += t4(r4.elements[o3], n3), o3 + 1 !== s3 && (a3 += n3 ? "," : ", ");
            a3 += "]";
            break;
          case e26.RecordType:
            for (a3 = "{", o3 = 0, s3 = r4.fields.length; o3 < s3; ++o3)
              a3 += t4(r4.fields[o3], n3), o3 + 1 !== s3 && (a3 += n3 ? "," : ", ");
            a3 += "}";
            break;
          case e26.FieldType:
            a3 = r4.value ? r4.key + (n3 ? ":" : ": ") + t4(r4.value, n3) : r4.key;
            break;
          case e26.FunctionType:
            for (a3 = n3 ? "function(" : "function (", r4.this && (r4.new ? a3 += n3 ? "new:" : "new: " : a3 += n3 ? "this:" : "this: ", a3 += t4(r4.this, n3), r4.params.length !== 0 && (a3 += n3 ? "," : ", ")), o3 = 0, s3 = r4.params.length; o3 < s3; ++o3)
              a3 += t4(r4.params[o3], n3), o3 + 1 !== s3 && (a3 += n3 ? "," : ", ");
            a3 += ")", r4.result && (a3 += (n3 ? ":" : ": ") + t4(r4.result, n3));
            break;
          case e26.ParameterType:
            a3 = r4.name + (n3 ? ":" : ": ") + t4(r4.expression, n3);
            break;
          case e26.RestType:
            a3 = "...", r4.expression && (a3 += t4(r4.expression, n3));
            break;
          case e26.NonNullableType:
            a3 = r4.prefix ? "!" + t4(r4.expression, n3) : t4(r4.expression, n3) + "!";
            break;
          case e26.OptionalType:
            a3 = t4(r4.expression, n3) + "=";
            break;
          case e26.NullableType:
            a3 = r4.prefix ? "?" + t4(r4.expression, n3) : t4(r4.expression, n3) + "?";
            break;
          case e26.NameExpression:
            a3 = r4.name;
            break;
          case e26.TypeApplication:
            for (a3 = t4(r4.expression, n3) + ".<", o3 = 0, s3 = r4.applications.length; o3 < s3; ++o3)
              a3 += t4(r4.applications[o3], n3), o3 + 1 !== s3 && (a3 += n3 ? "," : ", ");
            a3 += ">";
            break;
          case e26.StringLiteralType:
            a3 = '"' + r4.value + '"';
            break;
          case e26.NumericLiteralType:
          case e26.BooleanLiteralType:
            a3 = String(r4.value);
            break;
          default:
            l2.throwError("Unknown type " + r4.type);
        }
        return a3;
      }(t3, r3.compact, r3.topLevel);
    }, t2.Syntax = e26;
  }();
})), DA = (kA.parseType, kA.parseParamType, kA.stringify, kA.Syntax, r(function(e25, t2) {
  !function() {
    var e26, r2, n2, i2, a2, o2;
    function s2(e27, t3, r3) {
      return e27.slice(t3, r3);
    }
    function u2(e27) {
      return e27 === "param" || e27 === "argument" || e27 === "arg";
    }
    function c2(e27) {
      return e27 === "return" || e27 === "returns";
    }
    function l2(e27) {
      return e27 === "property" || e27 === "prop";
    }
    function p2(e27) {
      return u2(e27) || l2(e27) || e27 === "alias" || e27 === "this" || e27 === "mixes" || e27 === "requires";
    }
    function f2(e27) {
      return l2(e27) || u2(e27);
    }
    function h2(e27) {
      return u2(e27) || c2(e27) || e27 === "define" || e27 === "enum" || e27 === "implements" || e27 === "this" || e27 === "type" || e27 === "typedef" || l2(e27);
    }
    i2 = PD, e26 = kA, r2 = SA, o2 = Object.prototype.hasOwnProperty, a2 = function(e27, t3) {
      return o2.call(e27, t3);
    };
    var d2 = "[ \\f\\t\\v\\u00a0\\u1680\\u180e\\u2000-\\u200a\\u202f\\u205f\\u3000\\ufeff]", m2 = "(" + d2 + "*(?:\\*" + d2 + "?)?)(.+|[\r\n\u2028\u2029])";
    function g2(e27) {
      return e27.replace(/^\/\*\*?/, "").replace(/\*\/$/, "").replace(new RegExp(m2, "g"), "$2").replace(/\s*$/, "");
    }
    !function(t3) {
      var n3, o3, d3, y2, v2, x2, b2, E2, C2;
      function S2() {
        var e27 = v2.charCodeAt(o3);
        return o3 += 1, !i2.code.isLineTerminator(e27) || e27 === 13 && v2.charCodeAt(o3) === 10 || (d3 += 1), String.fromCharCode(e27);
      }
      function k2(t4, n4, a3) {
        for (var s3, u3, c3, l3, p3 = false; o3 < n4; ) {
          if (s3 = v2.charCodeAt(o3), !i2.code.isWhiteSpace(s3)) {
            if (s3 === 123) {
              S2();
              break;
            }
            p3 = true;
            break;
          }
          S2();
        }
        if (p3)
          return null;
        for (u3 = 1, c3 = ""; o3 < n4; )
          if (s3 = v2.charCodeAt(o3), i2.code.isLineTerminator(s3))
            S2();
          else {
            if (s3 === 125) {
              if ((u3 -= 1) === 0) {
                S2();
                break;
              }
            } else
              s3 === 123 && (u3 += 1);
            c3 === "" && (l3 = o3), c3 += S2();
          }
        return u3 !== 0 ? r2.throwError("Braces are not balanced") : f2(t4) ? e26.parseParamType(c3, { startIndex: w2(l3), range: a3 }) : e26.parseType(c3, { startIndex: w2(l3), range: a3 });
      }
      function D2(e27) {
        var t4;
        if (!i2.code.isIdentifierStartES5(v2.charCodeAt(o3)) && !v2[o3].match(/[0-9]/))
          return null;
        for (t4 = S2(); o3 < e27 && i2.code.isIdentifierPartES5(v2.charCodeAt(o3)); )
          t4 += S2();
        return t4;
      }
      function F2(e27) {
        for (; o3 < e27 && (i2.code.isWhiteSpace(v2.charCodeAt(o3)) || i2.code.isLineTerminator(v2.charCodeAt(o3))); )
          S2();
      }
      function A2(e27, t4, r3) {
        var n4, a3, s3 = "";
        if (F2(e27), o3 >= e27)
          return null;
        if (v2.charCodeAt(o3) === 91) {
          if (!t4)
            return null;
          n4 = true, s3 = S2();
        }
        if (s3 += D2(e27), r3)
          for (v2.charCodeAt(o3) !== 58 || s3 !== "module" && s3 !== "external" && s3 !== "event" || (s3 += S2(), s3 += D2(e27)), v2.charCodeAt(o3) === 91 && v2.charCodeAt(o3 + 1) === 93 && (s3 += S2(), s3 += S2()); v2.charCodeAt(o3) === 46 || v2.charCodeAt(o3) === 47 || v2.charCodeAt(o3) === 35 || v2.charCodeAt(o3) === 45 || v2.charCodeAt(o3) === 126; )
            s3 += S2(), s3 += D2(e27);
        if (n4) {
          if (F2(e27), v2.charCodeAt(o3) === 61) {
            var u3;
            s3 += S2(), F2(e27);
            for (var c3 = 1; o3 < e27; ) {
              if (u3 = v2.charCodeAt(o3), i2.code.isWhiteSpace(u3) && (a3 || (F2(e27), u3 = v2.charCodeAt(o3))), u3 === 39 && (a3 ? a3 === "'" && (a3 = "") : a3 = "'"), u3 === 34 && (a3 ? a3 === '"' && (a3 = "") : a3 = '"'), u3 === 91)
                c3++;
              else if (u3 === 93 && --c3 == 0)
                break;
              s3 += S2();
            }
          }
          if (F2(e27), o3 >= e27 || v2.charCodeAt(o3) !== 93)
            return null;
          s3 += S2();
        }
        return s3;
      }
      function w2(e27) {
        return v2 === x2 ? e27 : function(e28, t4) {
          for (var r3, n4 = e28.replace(/^\/\*\*?/, ""), i3 = 0, a3 = new RegExp(m2, "g"); r3 = a3.exec(n4); )
            if (i3 += r3[1].length, r3.index + r3[0].length > t4 + i3)
              return t4 + i3 + e28.length - n4.length;
          return e28.replace(/\*\/$/, "").replace(/\s*$/, "").length;
        }(x2, e27);
      }
      function _2(e27, t4) {
        this._options = e27, this._title = t4.toLowerCase(), this._tag = { title: t4, description: null }, this._options.lineNumbers && (this._tag.lineNumber = d3), this._first = o3 - t4.length - 1, this._last = 0, this._extra = {};
      }
      function T2(e27) {
        var t4, n4;
        if (!function() {
          for (; o3 < y2 && v2.charCodeAt(o3) !== 64; )
            S2();
          return !(o3 >= y2) && (r2.assert(v2.charCodeAt(o3) === 64), true);
        }())
          return null;
        for (n4 = (t4 = new _2(e27, function() {
          var e28, t5 = "";
          for (S2(); o3 < y2 && ((e28 = v2.charCodeAt(o3)) >= 97 && e28 <= 122 || e28 >= 65 && e28 <= 90 || e28 >= 48 && e28 <= 57); )
            t5 += S2();
          return t5;
        }())).parse(); o3 < t4._last; )
          S2();
        return n4;
      }
      _2.prototype.addError = function(e27) {
        var t4 = Array.prototype.slice.call(arguments, 1), n4 = e27.replace(/%(\d)/g, function(e28, n5) {
          return r2.assert(n5 < t4.length, "Message reference must be in range"), t4[n5];
        });
        return this._tag.errors || (this._tag.errors = []), C2 && r2.throwError(n4), this._tag.errors.push(n4), b2;
      }, _2.prototype.parseType = function() {
        if (h2(this._title))
          try {
            if (this._tag.type = k2(this._title, this._last, this._options.range), !(this._tag.type || u2(this._title) || c2(this._title) || this.addError("Missing or invalid tag type")))
              return false;
          } catch (e27) {
            if (this._tag.type = null, !this.addError(e27.message))
              return false;
          }
        else if (function(e27) {
          return h2(e27) || e27 === "throws" || e27 === "const" || e27 === "constant" || e27 === "namespace" || e27 === "member" || e27 === "var" || e27 === "module" || e27 === "constructor" || e27 === "class" || e27 === "extends" || e27 === "augments" || e27 === "public" || e27 === "private" || e27 === "protected";
        }(this._title))
          try {
            this._tag.type = k2(this._title, this._last, this._options.range);
          } catch (e27) {
          }
        return true;
      }, _2.prototype._parseNamePath = function(e27) {
        var t4;
        return !!((t4 = A2(this._last, E2 && f2(this._title), true)) || e27 || this.addError("Missing or invalid tag name")) && (this._tag.name = t4, true);
      }, _2.prototype.parseNamePath = function() {
        return this._parseNamePath(false);
      }, _2.prototype.parseNamePathOptional = function() {
        return this._parseNamePath(true);
      }, _2.prototype.parseName = function() {
        var e27, t4;
        if (function(e28) {
          return p2(e28) || e28 === "const" || e28 === "constant";
        }(this._title))
          if (this._tag.name = A2(this._last, E2 && f2(this._title), function(e28) {
            return l2(e28) || u2(e28);
          }(this._title)), this._tag.name)
            (t4 = this._tag.name).charAt(0) === "[" && t4.charAt(t4.length - 1) === "]" && ((e27 = t4.substring(1, t4.length - 1).split("=")).length > 1 && (this._tag.default = e27.slice(1).join("=")), this._tag.name = e27[0], this._tag.type && this._tag.type.type !== "OptionalType" && (this._tag.type = { type: "OptionalType", expression: this._tag.type }));
          else {
            if (!p2(this._title))
              return true;
            if (u2(this._title) && this._tag.type && this._tag.type.name)
              this._extra.name = this._tag.type, this._tag.name = this._tag.type.name, this._tag.type = null;
            else if (!this.addError("Missing or invalid tag name"))
              return false;
          }
        return true;
      }, _2.prototype.parseDescription = function() {
        var e27 = s2(v2, o3, this._last).trim();
        return e27 && (/^-\s+/.test(e27) && (e27 = e27.substring(2)), this._tag.description = e27), true;
      }, _2.prototype.parseCaption = function() {
        var e27 = s2(v2, o3, this._last).trim(), t4 = e27.indexOf("<caption>"), r3 = e27.indexOf("</caption>");
        return t4 >= 0 && r3 >= 0 ? (this._tag.caption = e27.substring(t4 + "<caption>".length, r3).trim(), this._tag.description = e27.substring(r3 + "</caption>".length).trim()) : this._tag.description = e27, true;
      }, _2.prototype.parseKind = function() {
        var e27, t4;
        return t4 = { class: true, constant: true, event: true, external: true, file: true, function: true, member: true, mixin: true, module: true, namespace: true, typedef: true }, e27 = s2(v2, o3, this._last).trim(), this._tag.kind = e27, !(!a2(t4, e27) && !this.addError("Invalid kind name '%0'", e27));
      }, _2.prototype.parseAccess = function() {
        var e27;
        return e27 = s2(v2, o3, this._last).trim(), this._tag.access = e27, !(e27 !== "private" && e27 !== "protected" && e27 !== "public" && !this.addError("Invalid access name '%0'", e27));
      }, _2.prototype.parseThis = function() {
        var e27 = s2(v2, o3, this._last).trim();
        return e27 && e27.charAt(0) === "{" ? this.parseType() && this._tag.type.type === "NameExpression" || this._tag.type.type === "UnionType" ? (this._tag.name = this._tag.type.name, true) : this.addError("Invalid name for this") : this.parseNamePath();
      }, _2.prototype.parseVariation = function() {
        var e27, t4;
        return t4 = s2(v2, o3, this._last).trim(), e27 = parseFloat(t4, 10), this._tag.variation = e27, !(isNaN(e27) && !this.addError("Invalid variation '%0'", t4));
      }, _2.prototype.ensureEnd = function() {
        var e27 = s2(v2, o3, this._last).trim();
        return !(e27 && !this.addError("Unknown content '%0'", e27));
      }, _2.prototype.epilogue = function() {
        var e27;
        return e27 = this._tag.description, !(f2(this._title) && !this._tag.type && e27 && e27.charAt(0) === "[" && (this._tag.type = this._extra.name, this._tag.name || (this._tag.name = void 0), !E2 && !this.addError("Missing or invalid tag name")));
      }, n3 = { access: ["parseAccess"], alias: ["parseNamePath", "ensureEnd"], augments: ["parseType", "parseNamePathOptional", "ensureEnd"], constructor: ["parseType", "parseNamePathOptional", "ensureEnd"], class: ["parseType", "parseNamePathOptional", "ensureEnd"], extends: ["parseType", "parseNamePathOptional", "ensureEnd"], example: ["parseCaption"], deprecated: ["parseDescription"], global: ["ensureEnd"], inner: ["ensureEnd"], instance: ["ensureEnd"], kind: ["parseKind"], mixes: ["parseNamePath", "ensureEnd"], mixin: ["parseNamePathOptional", "ensureEnd"], member: ["parseType", "parseNamePathOptional", "ensureEnd"], method: ["parseNamePathOptional", "ensureEnd"], module: ["parseType", "parseNamePathOptional", "ensureEnd"], func: ["parseNamePathOptional", "ensureEnd"], function: ["parseNamePathOptional", "ensureEnd"], var: ["parseType", "parseNamePathOptional", "ensureEnd"], name: ["parseNamePath", "ensureEnd"], namespace: ["parseType", "parseNamePathOptional", "ensureEnd"], private: ["parseType", "parseDescription"], protected: ["parseType", "parseDescription"], public: ["parseType", "parseDescription"], readonly: ["ensureEnd"], requires: ["parseNamePath", "ensureEnd"], since: ["parseDescription"], static: ["ensureEnd"], summary: ["parseDescription"], this: ["parseThis", "ensureEnd"], todo: ["parseDescription"], typedef: ["parseType", "parseNamePathOptional"], variation: ["parseVariation"], version: ["parseDescription"] }, _2.prototype.parse = function() {
        var e27, t4, r3;
        if (!this._title && !this.addError("Missing or invalid title"))
          return null;
        for (this._last = function() {
          var e28, t5, r4 = o3;
          for (t5 = false; r4 < y2; ) {
            if (e28 = v2.charCodeAt(r4), !i2.code.isLineTerminator(e28) || e28 === 13 && v2.charCodeAt(r4 + 1) === 10) {
              if (t5) {
                if (e28 === 64)
                  break;
                i2.code.isWhiteSpace(e28) || (t5 = false);
              }
            } else
              t5 = true;
            r4 += 1;
          }
          return r4;
        }(this._title), this._options.range && (this._tag.range = [this._first, v2.slice(0, this._last).replace(/\s*$/, "").length].map(w2)), e27 = 0, t4 = (r3 = a2(n3, this._title) ? n3[this._title] : ["parseType", "parseName", "parseDescription", "epilogue"]).length; e27 < t4; ++e27)
          if (!this[r3[e27]]())
            return null;
        return this._tag;
      }, t3.parse = function(e27, t4) {
        var n4, a3, s3, u3, c3, l3 = [];
        if (t4 === void 0 && (t4 = {}), v2 = typeof t4.unwrap == "boolean" && t4.unwrap ? g2(e27) : e27, x2 = e27, t4.tags)
          if (Array.isArray(t4.tags))
            for (s3 = {}, u3 = 0, c3 = t4.tags.length; u3 < c3; u3++)
              typeof t4.tags[u3] == "string" ? s3[t4.tags[u3]] = true : r2.throwError('Invalid "tags" parameter: ' + t4.tags);
          else
            r2.throwError('Invalid "tags" parameter: ' + t4.tags);
        for (y2 = v2.length, o3 = 0, d3 = 0, b2 = t4.recoverable, E2 = t4.sloppy, C2 = t4.strict, a3 = function(e28) {
          var t5, r3, n5 = "";
          for (r3 = true; o3 < y2 && (t5 = v2.charCodeAt(o3), !r3 || t5 !== 64); )
            i2.code.isLineTerminator(t5) ? r3 = true : r3 && !i2.code.isWhiteSpace(t5) && (r3 = false), n5 += S2();
          return e28 ? n5 : n5.trim();
        }(t4.preserveWhitespace); n4 = T2(t4); )
          s3 && !s3.hasOwnProperty(n4.title) || l3.push(n4);
        return { description: a3, tags: l3 };
      };
    }(n2 = {}), t2.version = r2.VERSION, t2.parse = n2.parse, t2.parseType = e26.parseType, t2.parseParamType = e26.parseParamType, t2.unwrapComment = g2, t2.Syntax = function(e27) {
      var t3, r3 = {};
      for (t3 in e27)
        e27.hasOwnProperty(t3) && (r3[t3] = e27[t3]);
      return r3;
    }(e26.Syntax), t2.Error = r2.DoctrineError, t2.type = { Syntax: t2.Syntax, parseType: e26.parseType, parseParamType: e26.parseParamType, stringify: e26.stringify };
  }();
})), FA = (DA.version, DA.parse, DA.parseType, DA.parseParamType, DA.unwrapComment, DA.Syntax, DA.Error, DA.type, n(QF)), AA = regeneratorRuntime.mark(eI);
function wA(e25) {
  return e25 && i(e25) == "object" && "default" in e25 ? e25.default : e25;
}
var _A = wA(PD), TA = wA(ID), PA = wA(FA), IA = wA(function(e25) {
  return new lA(e25);
}), BA = wA(fA), OA = wA(DA), LA = Fy.createCommonjsModule(function(e25) {
  function t2(e26, t3, r3) {
    var n3 = e26.identifier, i3 = t3 === 0 || r3[t3 - 1].identifier !== n3;
    return n3 && e26.init === false && e26.isWrite() && i3;
  }
  function r2(e26) {
    return e26[0] !== e26[0].toLocaleLowerCase();
  }
  function n2(e26) {
    return e26.id && r2(e26.id.name);
  }
  function i2(e26) {
    for (var t3 = e26; t3; t3 = t3.parent)
      if (P2.test(t3.type))
        return t3;
    return null;
  }
  function a2(e26) {
    return !(!e26 || !P2.test(e26.type));
  }
  function o2(e26) {
    return !(!e26 || !I2.test(e26.type));
  }
  function s2(t3) {
    return e25.exports.isNullLiteral(t3) || t3.type === "Identifier" && t3.name === "undefined" || t3.type === "UnaryExpression" && t3.operator === "void";
  }
  function u2(e26) {
    return e26.parent.type === "CallExpression" && e26.parent.callee === e26;
  }
  function c2(e26) {
    return e26.type === "MemberExpression" && e26.object.type === "Identifier" && e26.object.name === "Reflect" && e26.property.type === "Identifier" && e26.property.name === "apply" && e26.computed === false;
  }
  function l2(e26) {
    return e26.type === "MemberExpression" && e26.object.type === "Identifier" && B2.test(e26.object.name) && e26.property.type === "Identifier" && e26.property.name === "from" && e26.computed === false;
  }
  function p2(e26) {
    for (var t3 = e26; t3.type === "MemberExpression" && !t3.computed; t3 = t3.property)
      if (t3.property.type === "Identifier")
        return O2.test(t3.property.name);
    return false;
  }
  function f2(e26) {
    return function(t3) {
      return !e26(t3);
    };
  }
  function h2(e26, t3) {
    var r3 = t3.getJSDocComment(e26);
    return !(!r3 || !N2.test(r3.value)) || t3.getCommentsBefore(e26).some(function(e27) {
      return N2.test(e27.value);
    });
  }
  function d2(e26) {
    return e26.value === "=>" && e26.type === "Punctuator";
  }
  function m2(e26) {
    return e26.value === "," && e26.type === "Punctuator";
  }
  function g2(e26) {
    return e26.value === "." && e26.type === "Punctuator";
  }
  function y2(e26) {
    return e26.value === ";" && e26.type === "Punctuator";
  }
  function v2(e26) {
    return e26.value === ":" && e26.type === "Punctuator";
  }
  function x2(e26) {
    return e26.value === "(" && e26.type === "Punctuator";
  }
  function b2(e26) {
    return e26.value === ")" && e26.type === "Punctuator";
  }
  function E2(e26) {
    return e26.value === "[" && e26.type === "Punctuator";
  }
  function C2(e26) {
    return e26.value === "]" && e26.type === "Punctuator";
  }
  function S2(e26) {
    return e26.value === "{" && e26.type === "Punctuator";
  }
  function k2(e26) {
    return e26.value === "}" && e26.type === "Punctuator";
  }
  function D2(e26, t3) {
    return e26.id ? t3.getTokenAfter(e26.id, x2) : t3.getFirstToken(e26, x2);
  }
  var F2 = Fy.require$$0$1, A2 = F2.breakableTypePattern, w2 = F2.createGlobalLinebreakMatcher, _2 = F2.lineBreakPattern, T2 = F2.shebangPattern, P2 = /^(?:Function(?:Declaration|Expression)|ArrowFunctionExpression)$/, I2 = /^(?:DoWhile|For|ForIn|ForOf|While)Statement$/, B2 = /Array$/, O2 = /^(?:every|filter|find|findIndex|forEach|map|some)$/, L2 = /^(?:bind|call|apply)$/, N2 = /^[\t-\r \*\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*@this/m, j2 = new Set(["\r\n", "\r", "\n", "\u2028", "\u2029"]), R2 = new Set(["Program", "BlockStatement", "SwitchCase"]), M2 = /^(0|[1-9][0-9]*)$/, V2 = /^(?:(?:[\0-\[\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\/8-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\0(?![0-9]))*\\(?:[1-7]|0[0-9])/;
  e25.exports = { COMMENTS_IGNORE_PATTERN: /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:eslint|jshint[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|jslint[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|istanbul[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|globals?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|exported[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+|jscs)/, LINEBREAKS: j2, LINEBREAK_MATCHER: _2, SHEBANG_MATCHER: T2, STATEMENT_LIST_PARENTS: R2, isTokenOnSameLine: function(e26, t3) {
    return e26.loc.end.line === t3.loc.start.line;
  }, isNullOrUndefined: s2, isCallee: u2, isES5Constructor: n2, getUpperFunction: i2, isFunction: a2, isLoop: o2, isInLoop: function(e26) {
    for (var t3 = e26; t3 && !a2(t3); t3 = t3.parent)
      if (o2(t3))
        return true;
    return false;
  }, isArrayFromMethod: l2, isParenthesised: function(e26, t3) {
    var r3 = e26.getTokenBefore(t3), n3 = e26.getTokenAfter(t3);
    return !(!r3 || !n3) && r3.value === "(" && r3.range[1] <= t3.range[0] && n3.value === ")" && n3.range[0] >= t3.range[1];
  }, createGlobalLinebreakMatcher: w2, equalTokens: function(e26, t3, r3) {
    var n3 = r3.getTokens(e26), i3 = r3.getTokens(t3);
    if (n3.length !== i3.length)
      return false;
    for (var a3 = 0; a3 < n3.length; ++a3)
      if (n3[a3].type !== i3[a3].type || n3[a3].value !== i3[a3].value)
        return false;
    return true;
  }, isArrowToken: d2, isClosingBraceToken: k2, isClosingBracketToken: C2, isClosingParenToken: b2, isColonToken: v2, isCommaToken: m2, isCommentToken: function(e26) {
    return e26.type === "Line" || e26.type === "Block" || e26.type === "Shebang";
  }, isDotToken: g2, isKeywordToken: function(e26) {
    return e26.type === "Keyword";
  }, isNotClosingBraceToken: f2(k2), isNotClosingBracketToken: f2(C2), isNotClosingParenToken: f2(b2), isNotColonToken: f2(v2), isNotCommaToken: f2(m2), isNotDotToken: f2(g2), isNotOpeningBraceToken: f2(S2), isNotOpeningBracketToken: f2(E2), isNotOpeningParenToken: f2(x2), isNotSemicolonToken: f2(y2), isOpeningBraceToken: S2, isOpeningBracketToken: E2, isOpeningParenToken: x2, isSemicolonToken: y2, isStringLiteral: function(e26) {
    return e26.type === "Literal" && typeof e26.value == "string" || e26.type === "TemplateLiteral";
  }, isBreakableStatement: function(e26) {
    return A2.test(e26.type);
  }, getModifyingReferences: function(e26) {
    return e26.filter(t2);
  }, isSurroundedBy: function(e26, t3) {
    return e26[0] === t3 && e26[e26.length - 1] === t3;
  }, isDirectiveComment: function(e26) {
    var t3 = e26.value.trim();
    return e26.type === "Line" && t3.indexOf("eslint-") === 0 || e26.type === "Block" && (t3.indexOf("global ") === 0 || t3.indexOf("eslint ") === 0 || t3.indexOf("eslint-") === 0);
  }, getTrailingStatement: _A.ast.trailingStatement, getVariableByName: function(e26, t3) {
    for (var r3 = e26; r3; ) {
      var n3 = r3.set.get(t3);
      if (n3)
        return n3;
      r3 = r3.upper;
    }
    return null;
  }, isDefaultThisBinding: function(e26, t3) {
    var a3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o3 = a3.capIsConstructor, f3 = o3 === void 0 || o3;
    if (f3 && n2(e26) || h2(e26, t3))
      return false;
    for (var d3 = e26.id === null, m3 = e26; m3; ) {
      var g3 = m3.parent;
      switch (g3.type) {
        case "LogicalExpression":
        case "ConditionalExpression":
          m3 = g3;
          break;
        case "ReturnStatement":
          var y3 = i2(g3);
          if (y3 === null || !u2(y3))
            return true;
          m3 = y3.parent;
          break;
        case "ArrowFunctionExpression":
          if (m3 !== g3.body || !u2(g3))
            return true;
          m3 = g3.parent;
          break;
        case "Property":
        case "MethodDefinition":
          return g3.value !== m3;
        case "AssignmentExpression":
        case "AssignmentPattern":
          return g3.left.type !== "MemberExpression" && !(f3 && d3 && g3.left.type === "Identifier" && r2(g3.left.name));
        case "VariableDeclarator":
          return !(f3 && d3 && g3.init === m3 && g3.id.type === "Identifier" && r2(g3.id.name));
        case "MemberExpression":
          return g3.object !== m3 || g3.property.type !== "Identifier" || !L2.test(g3.property.name) || !u2(g3) || g3.parent.arguments.length === 0 || s2(g3.parent.arguments[0]);
        case "CallExpression":
          return c2(g3.callee) ? g3.arguments.length !== 3 || g3.arguments[0] !== m3 || s2(g3.arguments[1]) : l2(g3.callee) ? g3.arguments.length !== 3 || g3.arguments[1] !== m3 || s2(g3.arguments[2]) : !p2(g3.callee) || g3.arguments.length !== 2 || g3.arguments[0] !== m3 || s2(g3.arguments[1]);
        default:
          return true;
      }
    }
    return true;
  }, getPrecedence: function(e26) {
    switch (e26.type) {
      case "SequenceExpression":
        return 0;
      case "AssignmentExpression":
      case "ArrowFunctionExpression":
      case "YieldExpression":
        return 1;
      case "ConditionalExpression":
        return 3;
      case "LogicalExpression":
        switch (e26.operator) {
          case "||":
            return 4;
          case "&&":
            return 5;
        }
      case "BinaryExpression":
        switch (e26.operator) {
          case "|":
            return 6;
          case "^":
            return 7;
          case "&":
            return 8;
          case "==":
          case "!=":
          case "===":
          case "!==":
            return 9;
          case "<":
          case "<=":
          case ">":
          case ">=":
          case "in":
          case "instanceof":
            return 10;
          case "<<":
          case ">>":
          case ">>>":
            return 11;
          case "+":
          case "-":
            return 12;
          case "*":
          case "/":
          case "%":
            return 13;
          case "**":
            return 15;
        }
      case "UnaryExpression":
      case "AwaitExpression":
        return 16;
      case "UpdateExpression":
        return 17;
      case "CallExpression":
      case "ImportExpression":
        return 18;
      case "NewExpression":
        return 19;
      default:
        return 20;
    }
  }, isEmptyBlock: function(e26) {
    return !(!e26 || e26.type !== "BlockStatement" || e26.body.length !== 0);
  }, isEmptyFunction: function(t3) {
    return a2(t3) && e25.exports.isEmptyBlock(t3.body);
  }, getStaticPropertyName: function(e26) {
    var t3;
    switch (e26 && e26.type) {
      case "Property":
      case "MethodDefinition":
        t3 = e26.key;
        break;
      case "MemberExpression":
        t3 = e26.property;
    }
    switch (t3 && t3.type) {
      case "Literal":
        return t3.value + "";
      case "TemplateLiteral":
        if (t3.expressions.length === 0 && t3.quasis.length === 1)
          return t3.quasis[0].value.cooked;
        break;
      case "Identifier":
        if (!e26.computed)
          return t3.name;
    }
    return null;
  }, getDirectivePrologue: function(e26) {
    var t3 = [];
    if (e26.type === "Program" || e26.type === "FunctionDeclaration" || e26.type === "FunctionExpression" || e26.type === "ArrowFunctionExpression" && e26.body.type === "BlockStatement") {
      var r3 = e26.type === "Program" ? e26.body : e26.body.body, n3 = true, i3 = false, a3 = void 0;
      try {
        for (var o3, s3 = r3[Symbol.iterator](); !(n3 = (o3 = s3.next()).done); n3 = true) {
          var u3 = o3.value;
          if (u3.type !== "ExpressionStatement" || u3.expression.type !== "Literal")
            break;
          t3.push(u3);
        }
      } catch (e27) {
        i3 = true, a3 = e27;
      } finally {
        try {
          n3 || s3.return == null || s3.return();
        } finally {
          if (i3)
            throw a3;
        }
      }
    }
    return t3;
  }, isDecimalInteger: function(e26) {
    return e26.type === "Literal" && typeof e26.value == "number" && M2.test(e26.raw);
  }, isDecimalIntegerNumericToken: function(e26) {
    return e26.type === "Numeric" && M2.test(e26.value);
  }, getFunctionNameWithKind: function(t3) {
    var r3 = t3.parent, n3 = [];
    if (r3.type === "MethodDefinition" && r3.static && n3.push("static"), t3.async && n3.push("async"), t3.generator && n3.push("generator"), t3.type === "ArrowFunctionExpression")
      n3.push("arrow", "function");
    else if (r3.type === "Property" || r3.type === "MethodDefinition") {
      if (r3.kind === "constructor")
        return "constructor";
      r3.kind === "get" ? n3.push("getter") : r3.kind === "set" ? n3.push("setter") : n3.push("method");
    } else
      n3.push("function");
    if (t3.id)
      n3.push("'".concat(t3.id.name, "'"));
    else {
      var i3 = e25.exports.getStaticPropertyName(r3);
      i3 !== null && n3.push("'".concat(i3, "'"));
    }
    return n3.join(" ");
  }, getFunctionHeadLoc: function(e26, t3) {
    var r3 = e26.parent, n3 = null, i3 = null;
    if (e26.type === "ArrowFunctionExpression") {
      var a3 = t3.getTokenBefore(e26.body, d2);
      n3 = a3.loc.start, i3 = a3.loc.end;
    } else
      r3.type === "Property" || r3.type === "MethodDefinition" ? (n3 = r3.loc.start, i3 = D2(e26, t3).loc.start) : (n3 = e26.loc.start, i3 = D2(e26, t3).loc.start);
    return { start: Object.assign({}, n3), end: Object.assign({}, i3) };
  }, getNextLocation: function(e26, t3) {
    var r3 = e26.getIndexFromLoc(t3);
    return r3 + 1 > e26.text.length ? null : e26.getLocFromIndex(r3 + 1);
  }, getParenthesisedText: function(e26, t3) {
    for (var r3 = e26.getFirstToken(t3), n3 = e26.getLastToken(t3); e26.getTokenBefore(r3) && e26.getTokenBefore(r3).type === "Punctuator" && e26.getTokenBefore(r3).value === "(" && e26.getTokenAfter(n3) && e26.getTokenAfter(n3).type === "Punctuator" && e26.getTokenAfter(n3).value === ")"; )
      r3 = e26.getTokenBefore(r3), n3 = e26.getTokenAfter(n3);
    return e26.getText().slice(r3.range[0], n3.range[1]);
  }, couldBeError: function(t3) {
    switch (t3.type) {
      case "Identifier":
      case "CallExpression":
      case "NewExpression":
      case "MemberExpression":
      case "TaggedTemplateExpression":
      case "YieldExpression":
      case "AwaitExpression":
        return true;
      case "AssignmentExpression":
        return e25.exports.couldBeError(t3.right);
      case "SequenceExpression":
        var r3 = t3.expressions;
        return r3.length !== 0 && e25.exports.couldBeError(r3[r3.length - 1]);
      case "LogicalExpression":
        return e25.exports.couldBeError(t3.left) || e25.exports.couldBeError(t3.right);
      case "ConditionalExpression":
        return e25.exports.couldBeError(t3.consequent) || e25.exports.couldBeError(t3.alternate);
      default:
        return false;
    }
  }, isNullLiteral: function(e26) {
    return e26.type === "Literal" && e26.value === null && !e26.regex && !e26.bigint;
  }, canTokensBeAdjacent: function(e26, t3) {
    var r3;
    if (typeof e26 == "string") {
      var n3 = Fy.espree.tokenize(e26, { ecmaVersion: 2015 });
      r3 = n3[n3.length - 1];
    } else
      r3 = e26;
    var i3 = typeof t3 == "string" ? Fy.espree.tokenize(t3, { ecmaVersion: 2015 })[0] : t3;
    if (r3.type === "Punctuator" || i3.type === "Punctuator") {
      if (r3.type === "Punctuator" && i3.type === "Punctuator") {
        var a3 = new Set(["+", "++"]), o3 = new Set(["-", "--"]);
        return !(a3.has(r3.value) && a3.has(i3.value) || o3.has(r3.value) && o3.has(i3.value));
      }
      return true;
    }
    return r3.type === "String" || i3.type === "String" || r3.type === "Template" || i3.type === "Template" || !(r3.type === "Numeric" || i3.type !== "Numeric" || !i3.value.startsWith("."));
  }, getNameLocationInGlobalDirectiveComment: function(e26, t3, r3) {
    var n3 = new RegExp("[\\s,]".concat(Fy.lodash.escapeRegExp(r3), "(?:$|[\\s,:])"), "gu");
    n3.lastIndex = t3.value.indexOf("global") + 6;
    var i3 = n3.exec(t3.value);
    return e26.getLocFromIndex(t3.range[0] + 2 + (i3 ? i3.index + 1 : 0));
  }, hasOctalEscapeSequence: function(e26) {
    return V2.test(e26);
  } };
});
LA.COMMENTS_IGNORE_PATTERN, LA.LINEBREAKS, LA.LINEBREAK_MATCHER, LA.SHEBANG_MATCHER, LA.STATEMENT_LIST_PARENTS, LA.isTokenOnSameLine, LA.isNullOrUndefined, LA.isCallee, LA.isES5Constructor, LA.getUpperFunction, LA.isFunction, LA.isLoop, LA.isInLoop, LA.isArrayFromMethod, LA.isParenthesised, LA.createGlobalLinebreakMatcher, LA.equalTokens, LA.isArrowToken, LA.isClosingBraceToken, LA.isClosingBracketToken, LA.isClosingParenToken, LA.isColonToken, LA.isCommaToken, LA.isCommentToken, LA.isDotToken, LA.isKeywordToken, LA.isNotClosingBraceToken, LA.isNotClosingBracketToken, LA.isNotClosingParenToken, LA.isNotColonToken, LA.isNotCommaToken, LA.isNotDotToken, LA.isNotOpeningBraceToken, LA.isNotOpeningBracketToken, LA.isNotOpeningParenToken, LA.isNotSemicolonToken, LA.isOpeningBraceToken, LA.isOpeningBracketToken, LA.isOpeningParenToken, LA.isSemicolonToken, LA.isStringLiteral, LA.isBreakableStatement, LA.getModifyingReferences, LA.isSurroundedBy, LA.isDirectiveComment, LA.getTrailingStatement, LA.getVariableByName, LA.isDefaultThisBinding, LA.getPrecedence, LA.isEmptyBlock, LA.isEmptyFunction, LA.getStaticPropertyName, LA.getDirectivePrologue, LA.isDecimalInteger, LA.isDecimalIntegerNumericToken, LA.getFunctionNameWithKind, LA.getFunctionHeadLoc, LA.getNextLocation, LA.getParenthesisedText, LA.couldBeError, LA.isNullLiteral, LA.canTokensBeAdjacent, LA.getNameLocationInGlobalDirectiveComment, LA.hasOctalEscapeSequence;
function NA(e25) {
  return e25.kind === "get" || e25.kind === "set";
}
function jA(e25, t2) {
  return e25.type === "Identifier" && e25.name === t2;
}
function RA(e25, t2, r2, n2) {
  var i2 = e25.parent;
  return i2.type === "CallExpression" && i2.callee.type === "MemberExpression" && i2.callee.computed === false && jA(i2.callee.object, r2) && jA(i2.callee.property, n2) && i2.arguments[t2] === e25;
}
var MA = { meta: { type: "suggestion", docs: { description: "enforce getter and setter pairs in objects and classes", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/accessor-pairs" }, schema: [{ type: "object", properties: { getWithoutSet: { type: "boolean", default: false }, setWithoutGet: { type: "boolean", default: true }, enforceForClassMembers: { type: "boolean", default: false } }, additionalProperties: false }], messages: { missingGetterInPropertyDescriptor: "Getter is not present in property descriptor.", missingSetterInPropertyDescriptor: "Setter is not present in property descriptor.", missingGetterInObjectLiteral: "Getter is not present for {{ name }}.", missingSetterInObjectLiteral: "Setter is not present for {{ name }}.", missingGetterInClass: "Getter is not present for class {{ name }}.", missingSetterInClass: "Setter is not present for class {{ name }}." } }, create: function(e25) {
  function t2(t3, r3) {
    t3.type === "Property" ? e25.report({ node: t3, messageId: "".concat(r3, "InObjectLiteral"), loc: LA.getFunctionHeadLoc(t3.value, l2), data: { name: LA.getFunctionNameWithKind(t3.value) } }) : t3.type === "MethodDefinition" ? e25.report({ node: t3, messageId: "".concat(r3, "InClass"), loc: LA.getFunctionHeadLoc(t3.value, l2), data: { name: LA.getFunctionNameWithKind(t3.value) } }) : e25.report({ node: t3, messageId: "".concat(r3, "InPropertyDescriptor") });
  }
  function r2(e26, r3) {
    var n3 = true, i3 = false, a3 = void 0;
    try {
      for (var o3, s3 = e26[Symbol.iterator](); !(n3 = (o3 = s3.next()).done); n3 = true) {
        t2(o3.value, r3);
      }
    } catch (e27) {
      i3 = true, a3 = e27;
    } finally {
      try {
        n3 || s3.return == null || s3.return();
      } finally {
        if (i3)
          throw a3;
      }
    }
  }
  function n2(e26) {
    var t3 = LA.getStaticPropertyName(e26);
    return { key: t3 === null ? l2.getTokens(e26.key) : t3, getters: e26.kind === "get" ? [e26] : [], setters: e26.kind === "set" ? [e26] : [] };
  }
  function i2(e26, t3) {
    var r3, n3, i3 = e26.find(function(e27) {
      return function(e28, t4) {
        return typeof e28 == "string" && typeof t4 == "string" ? e28 == t4 : !(!Array.isArray(e28) || !Array.isArray(t4)) && function(e29, t5) {
          if (e29.length !== t5.length)
            return false;
          for (var r4 = 0; r4 < e29.length; r4++) {
            var n4 = e29[r4], i4 = t5[r4];
            if (n4.type !== i4.type || n4.value !== i4.value)
              return false;
          }
          return true;
        }(e28, t4);
      }(e27.key, t3.key);
    });
    return i3 ? ((r3 = i3.getters).push.apply(r3, E(t3.getters)), (n3 = i3.setters).push.apply(n3, E(t3.setters))) : e26.push(t3), e26;
  }
  function a2(e26) {
    var t3 = e26.filter(NA).map(n2).reduce(i2, []), a3 = true, o3 = false, c3 = void 0;
    try {
      for (var l3, p3 = t3[Symbol.iterator](); !(a3 = (l3 = p3.next()).done); a3 = true) {
        var f2 = l3.value, h2 = f2.getters, d2 = f2.setters;
        u2 && d2.length && !h2.length && r2(d2, "missingGetter"), s2 && h2.length && !d2.length && r2(h2, "missingSetter");
      }
    } catch (e27) {
      o3 = true, c3 = e27;
    } finally {
      try {
        a3 || p3.return == null || p3.return();
      } finally {
        if (o3)
          throw c3;
      }
    }
  }
  var o2 = e25.options[0] || {}, s2 = o2.getWithoutSet === true, u2 = o2.setWithoutGet !== false, c2 = o2.enforceForClassMembers === true, l2 = e25.getSourceCode(), p2 = {};
  return (u2 || s2) && (p2.ObjectExpression = function(e26) {
    (function(e27) {
      a2(e27.properties.filter(function(e28) {
        return e28.type === "Property";
      }));
    })(e26), function(e27) {
      if (RA(e27, 2, "Object", "defineProperty") || RA(e27, 2, "Reflect", "defineProperty"))
        return true;
      var t3 = e27.parent.parent;
      return t3.type === "ObjectExpression" && (RA(t3, 1, "Object", "create") || RA(t3, 1, "Object", "defineProperties"));
    }(e26) && function(e27) {
      var r3 = e27.properties.filter(function(e28) {
        return e28.type === "Property" && e28.kind === "init" && !e28.computed;
      }).map(function(e28) {
        return e28.key.name;
      }), n3 = r3.includes("get"), i3 = r3.includes("set");
      u2 && i3 && !n3 && t2(e27, "missingGetter"), s2 && n3 && !i3 && t2(e27, "missingSetter");
    }(e26);
  }, c2 && (p2.ClassBody = function(e26) {
    var t3 = e26.body.filter(function(e27) {
      return e27.type === "MethodDefinition";
    });
    a2(t3.filter(function(e27) {
      return e27.static;
    })), a2(t3.filter(function(e27) {
      return !e27.static;
    }));
  })), p2;
} }, VA = { meta: { type: "layout", docs: { description: "enforce linebreaks after opening and before closing array brackets", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/array-bracket-newline" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never", "consistent"] }, { type: "object", properties: { multiline: { type: "boolean" }, minItems: { type: ["integer", "null"], minimum: 0 } }, additionalProperties: false }] }], messages: { unexpectedOpeningLinebreak: "There should be no linebreak after '['.", unexpectedClosingLinebreak: "There should be no linebreak before ']'.", missingOpeningLinebreak: "A linebreak is required after '['.", missingClosingLinebreak: "A linebreak is required before ']'." } }, create: function(e25) {
  function t2(e26) {
    var t3 = function(e27) {
      var t4 = false, r3 = false, i3 = 0;
      return e27 ? e27 === "consistent" ? (t4 = true, i3 = n2) : e27 === "always" || e27.minItems === 0 ? i3 = 0 : e27 === "never" ? i3 = n2 : (r3 = !!e27.multiline, i3 = e27.minItems || n2) : (t4 = false, r3 = true, i3 = n2), { consistent: t4, multiline: r3, minItems: i3 };
    }(e26);
    return { ArrayExpression: t3, ArrayPattern: t3 };
  }
  function r2(r3) {
    var n3 = r3.elements, a2 = t2(e25.options[0])[r3.type], o2 = i2.getFirstToken(r3), s2 = i2.getLastToken(r3), u2 = i2.getTokenAfter(o2, { includeComments: true }), c2 = i2.getTokenBefore(s2, { includeComments: true }), l2 = i2.getTokenAfter(o2), p2 = i2.getTokenBefore(s2);
    n3.length >= a2.minItems || a2.multiline && 0 < n3.length && u2.loc.start.line !== c2.loc.end.line || n3.length === 0 && u2.type === "Block" && u2.loc.start.line !== c2.loc.end.line && u2 === c2 || a2.consistent && o2.loc.end.line !== l2.loc.start.line ? (LA.isTokenOnSameLine(o2, l2) && function(t3, r4) {
      e25.report({ node: t3, loc: r4.loc, messageId: "missingOpeningLinebreak", fix: function(e26) {
        return e26.insertTextAfter(r4, "\n");
      } });
    }(r3, o2), LA.isTokenOnSameLine(p2, s2) && function(t3, r4) {
      e25.report({ node: t3, loc: r4.loc, messageId: "missingClosingLinebreak", fix: function(e26) {
        return e26.insertTextBefore(r4, "\n");
      } });
    }(r3, s2)) : (!LA.isTokenOnSameLine(o2, l2) && function(t3, r4) {
      e25.report({ node: t3, loc: r4.loc, messageId: "unexpectedOpeningLinebreak", fix: function(e26) {
        var t4 = i2.getTokenAfter(r4, { includeComments: true });
        return LA.isCommentToken(t4) ? null : e26.removeRange([r4.range[1], t4.range[0]]);
      } });
    }(r3, o2), !LA.isTokenOnSameLine(p2, s2) && function(t3, r4) {
      e25.report({ node: t3, loc: r4.loc, messageId: "unexpectedClosingLinebreak", fix: function(e26) {
        var t4 = i2.getTokenBefore(r4, { includeComments: true });
        return LA.isCommentToken(t4) ? null : e26.removeRange([t4.range[1], r4.range[0]]);
      } });
    }(r3, s2));
  }
  var n2 = Number.POSITIVE_INFINITY, i2 = e25.getSourceCode();
  return { ArrayPattern: r2, ArrayExpression: r2 };
} }, UA = { meta: { type: "layout", docs: { description: "enforce consistent spacing inside array brackets", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/array-bracket-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { singleValue: { type: "boolean" }, objectsInArrays: { type: "boolean" }, arraysInArrays: { type: "boolean" } }, additionalProperties: false }], messages: { unexpectedSpaceAfter: "There should be no space after '{{tokenValue}}'.", unexpectedSpaceBefore: "There should be no space before '{{tokenValue}}'.", missingSpaceAfter: "A space is required after '{{tokenValue}}'.", missingSpaceBefore: "A space is required before '{{tokenValue}}'." } }, create: function(e25) {
  function t2(t3) {
    return !!e25.options[1] && e25.options[1][t3] === !c2;
  }
  function r2(t3, r3) {
    e25.report({ node: t3, loc: r3.loc.start, messageId: "unexpectedSpaceAfter", data: { tokenValue: r3.value }, fix: function(e26) {
      var t4 = l2.getTokenAfter(r3);
      return e26.removeRange([r3.range[1], t4.range[0]]);
    } });
  }
  function n2(t3, r3) {
    e25.report({ node: t3, loc: r3.loc.start, messageId: "unexpectedSpaceBefore", data: { tokenValue: r3.value }, fix: function(e26) {
      var t4 = l2.getTokenBefore(r3);
      return e26.removeRange([t4.range[1], r3.range[0]]);
    } });
  }
  function i2(t3, r3) {
    e25.report({ node: t3, loc: r3.loc.start, messageId: "missingSpaceAfter", data: { tokenValue: r3.value }, fix: function(e26) {
      return e26.insertTextAfter(r3, " ");
    } });
  }
  function a2(t3, r3) {
    e25.report({ node: t3, loc: r3.loc.start, messageId: "missingSpaceBefore", data: { tokenValue: r3.value }, fix: function(e26) {
      return e26.insertTextBefore(r3, " ");
    } });
  }
  function o2(e26) {
    return e26 && (e26.type === "ObjectExpression" || e26.type === "ObjectPattern");
  }
  function s2(e26) {
    return e26 && (e26.type === "ArrayExpression" || e26.type === "ArrayPattern");
  }
  function u2(e26) {
    if (!p2.spaced || e26.elements.length !== 0) {
      var t3 = l2.getFirstToken(e26), u3 = l2.getFirstToken(e26, 1), c3 = e26.typeAnnotation ? l2.getTokenBefore(e26.typeAnnotation) : l2.getLastToken(e26), f2 = l2.getTokenBefore(c3), h2 = e26.elements[0], d2 = e26.elements[e26.elements.length - 1], m2 = p2.objectsInArraysException && o2(h2) || p2.arraysInArraysException && s2(h2) || p2.singleElementException && e26.elements.length === 1 ? !p2.spaced : p2.spaced, g2 = p2.objectsInArraysException && o2(d2) || p2.arraysInArraysException && s2(d2) || p2.singleElementException && e26.elements.length === 1 ? !p2.spaced : p2.spaced;
      LA.isTokenOnSameLine(t3, u3) && (m2 && !l2.isSpaceBetweenTokens(t3, u3) && i2(e26, t3), !m2 && l2.isSpaceBetweenTokens(t3, u3) && r2(e26, t3)), t3 !== f2 && LA.isTokenOnSameLine(f2, c3) && (g2 && !l2.isSpaceBetweenTokens(f2, c3) && a2(e26, c3), !g2 && l2.isSpaceBetweenTokens(f2, c3) && n2(e26, c3));
    }
  }
  var c2 = e25.options[0] === "always", l2 = e25.getSourceCode(), p2 = { spaced: c2, singleElementException: t2("singleValue"), objectsInArraysException: t2("objectsInArrays"), arraysInArraysException: t2("arraysInArrays") };
  return { ArrayPattern: u2, ArrayExpression: u2 };
} }, qA = /^(?:Arrow)?FunctionExpression$/, WA = /^(?:every|filter|find(?:Index)?|map|reduce(?:Right)?|some|sort)$/;
function $A(e25) {
  return e25.reachable;
}
function GA(e25, t2) {
  return e25.type === "ArrowFunctionExpression" ? t2.getTokenBefore(e25.body) : e25.id || e25;
}
function zA(e25) {
  return e25.type === "MemberExpression" && WA.test(LA.getStaticPropertyName(e25) || "");
}
function HA(e25) {
  for (var t2 = e25; t2; ) {
    var r2 = t2.parent;
    switch (r2.type) {
      case "LogicalExpression":
      case "ConditionalExpression":
        t2 = r2;
        break;
      case "ReturnStatement":
        var n2 = LA.getUpperFunction(r2);
        if (n2 === null || !LA.isCallee(n2))
          return false;
        t2 = n2.parent;
        break;
      case "CallExpression":
        return LA.isArrayFromMethod(r2.callee) ? 2 <= r2.arguments.length && r2.arguments[1] === t2 : !!zA(r2.callee) && 1 <= r2.arguments.length && r2.arguments[0] === t2;
      default:
        return false;
    }
  }
  return false;
}
var KA = { meta: { type: "problem", docs: { description: "enforce `return` statements in callbacks of array methods", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/array-callback-return" }, schema: [{ type: "object", properties: { allowImplicit: { type: "boolean", default: false } }, additionalProperties: false }], messages: { expectedAtEnd: "Expected to return a value at the end of {{name}}.", expectedInside: "Expected to return a value in {{name}}.", expectedReturnValue: "{{name}} expected a return value." } }, create: function(e25) {
  function t2(t3) {
    n2.shouldCheck && n2.codePath.currentSegments.some($A) && e25.report({ node: t3, loc: GA(t3, e25.getSourceCode()).loc.start, messageId: n2.hasReturn ? "expectedAtEnd" : "expectedInside", data: { name: LA.getFunctionNameWithKind(n2.node) } });
  }
  var r2 = e25.options[0] || { allowImplicit: false }, n2 = { upper: null, codePath: null, hasReturn: false, shouldCheck: false, node: null };
  return { onCodePathStart: function(e26, t3) {
    n2 = { upper: n2, codePath: e26, hasReturn: false, shouldCheck: qA.test(t3.type) && t3.body.type === "BlockStatement" && HA(t3) && !t3.async && !t3.generator, node: t3 };
  }, onCodePathEnd: function() {
    n2 = n2.upper;
  }, ReturnStatement: function(t3) {
    n2.shouldCheck && (n2.hasReturn = true, !r2.allowImplicit && !t3.argument && e25.report({ node: t3, messageId: "expectedReturnValue", data: { name: Fy.lodash.upperFirst(LA.getFunctionNameWithKind(n2.node)) } }));
  }, "FunctionExpression:exit": t2, "ArrowFunctionExpression:exit": t2 };
} }, JA = { meta: { type: "layout", docs: { description: "enforce line breaks after each array element", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/array-element-newline" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never", "consistent"] }, { type: "object", properties: { multiline: { type: "boolean" }, minItems: { type: ["integer", "null"], minimum: 0 } }, additionalProperties: false }] }], messages: { unexpectedLineBreak: "There should be no linebreak here.", missingLineBreak: "There should be a linebreak after this element." } }, create: function(e25) {
  function t2(e26) {
    var t3 = function(e27) {
      var t4, r3 = false, n3 = false, i3 = e27 || "always";
      return i3 && i3 !== "always" && i3.minItems !== 0 ? i3 === "never" ? t4 = a2 : i3 === "consistent" ? (r3 = true, t4 = a2) : (n3 = !!i3.multiline, t4 = i3.minItems || a2) : t4 = 0, { consistent: r3, multiline: n3, minItems: t4 };
    }(e26);
    return { ArrayExpression: t3, ArrayPattern: t3 };
  }
  function r2(t3) {
    var r3 = o2.getTokenBefore(t3, { includeComments: true });
    e25.report({ loc: { start: r3.loc.end, end: t3.loc.start }, messageId: "unexpectedLineBreak", fix: function(e26) {
      if (LA.isCommentToken(r3))
        return null;
      if (!LA.isTokenOnSameLine(r3, t3))
        return e26.replaceTextRange([r3.range[1], t3.range[0]], " ");
      var n3 = o2.getTokenBefore(r3, { includeComments: true });
      return LA.isCommentToken(n3) ? null : e26.replaceTextRange([n3.range[1], r3.range[0]], "");
    } });
  }
  function n2(t3) {
    var r3 = o2.getTokenBefore(t3, { includeComments: true });
    e25.report({ loc: { start: r3.loc.end, end: t3.loc.start }, messageId: "missingLineBreak", fix: function(e26) {
      return e26.replaceTextRange([r3.range[1], t3.range[0]], "\n");
    } });
  }
  function i2(i3) {
    var a3 = i3.elements, s2 = t2(e25.options[0])[i3.type], u2 = false;
    s2.multiline && (u2 = a3.filter(function(e26) {
      return e26 !== null;
    }).some(function(e26) {
      return e26.loc.start.line !== e26.loc.end.line;
    }));
    var c2 = i3.elements.map(function(e26, t3) {
      var r3 = a3[t3 - 1];
      if (t3 === 0 || e26 === null || r3 === null)
        return false;
      var n3 = o2.getFirstTokenBetween(r3, e26, LA.isCommaToken), i4 = o2.getTokenBefore(n3), s3 = o2.getTokenAfter(n3);
      return !LA.isTokenOnSameLine(i4, s3);
    }).filter(function(e26) {
      return e26 === true;
    }).length, l2 = a3.length >= s2.minItems || s2.multiline && u2 || s2.consistent && 0 < c2 && c2 < i3.elements.length;
    a3.forEach(function(e26, t3) {
      var i4 = a3[t3 - 1];
      if (t3 !== 0 && e26 !== null && i4 !== null) {
        var s3 = o2.getFirstTokenBetween(i4, e26, LA.isCommaToken), u3 = o2.getTokenBefore(s3), c3 = o2.getTokenAfter(s3);
        l2 ? LA.isTokenOnSameLine(u3, c3) && n2(c3) : !LA.isTokenOnSameLine(u3, c3) && r2(c3);
      }
    });
  }
  var a2 = Number.POSITIVE_INFINITY, o2 = e25.getSourceCode();
  return { ArrayPattern: i2, ArrayExpression: i2 };
} }, QA = { meta: { type: "suggestion", docs: { description: "require braces around arrow function bodies", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/arrow-body-style" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["always", "never"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["as-needed"] }, { type: "object", properties: { requireReturnForObjectLiteral: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] }, fixable: "code", messages: { unexpectedOtherBlock: "Unexpected block statement surrounding arrow body.", unexpectedEmptyBlock: "Unexpected block statement surrounding arrow body; put a value of `undefined` immediately after the `=>`.", unexpectedObjectBlock: "Unexpected block statement surrounding arrow body; parenthesize the returned value and move it immediately after the `=>`.", unexpectedSingleBlock: "Unexpected block statement surrounding arrow body; move the returned value immediately after the `=>`.", expectedBlock: "Expected block statement surrounding arrow body." } }, create: function(e25) {
  var t2 = e25.options, r2 = t2[0] === "always", n2 = !t2[0] || t2[0] === "as-needed", i2 = t2[0] === "never", a2 = t2[1] && t2[1].requireReturnForObjectLiteral, o2 = e25.getSourceCode();
  return { "ArrowFunctionExpression:exit": function(t3) {
    var s2 = t3.body;
    if (s2.type === "BlockStatement") {
      var u2, c2 = s2.body;
      if (c2.length !== 1 && !i2)
        return;
      if (n2 && a2 && c2[0].type === "ReturnStatement" && c2[0].argument && c2[0].argument.type === "ObjectExpression")
        return;
      if (i2 || n2 && c2[0].type === "ReturnStatement")
        u2 = c2.length === 0 ? "unexpectedEmptyBlock" : 1 < c2.length ? "unexpectedOtherBlock" : c2[0].argument === null ? "unexpectedSingleBlock" : LA.isOpeningBraceToken(o2.getFirstToken(c2[0], { skip: 1 })) ? "unexpectedObjectBlock" : "unexpectedSingleBlock", e25.report({ node: t3, loc: s2.loc.start, messageId: u2, fix: function(e26) {
          var t4 = [];
          if (c2.length !== 1 || c2[0].type !== "ReturnStatement" || !c2[0].argument || function(e27) {
            return e27 && e27.type === "Punctuator" && /^[\(\+\x2D\/\[`]/.test(e27.value);
          }(o2.getTokenAfter(s2)))
            return t4;
          var r3 = o2.getFirstToken(s2), n3 = o2.getLastToken(s2), i3 = o2.getFirstToken(c2[0], 1), a3 = o2.getLastToken(c2[0]);
          return o2.commentsExistBetween(r3, i3) || o2.commentsExistBetween(a3, n3) ? t4.push(e26.remove(r3), e26.remove(n3), e26.remove(o2.getTokenAfter(r3))) : t4.push(e26.removeRange([r3.range[0], i3.range[0]]), e26.removeRange([a3.range[1], n3.range[1]])), (LA.isOpeningBraceToken(i3) || c2[0].argument.type === "SequenceExpression") && t4.push(e26.insertTextBefore(i3, "("), e26.insertTextAfter(a3, ")")), LA.isSemicolonToken(a3) && t4.push(e26.remove(a3)), t4;
        } });
    } else
      (r2 || n2 && a2 && s2.type === "ObjectExpression") && e25.report({ node: t3, loc: s2.loc.start, messageId: "expectedBlock", fix: function(e26) {
        var r3 = [], n3 = o2.getTokenBefore(s2, LA.isArrowToken), i3 = o2.getTokenAfter(n3), a3 = o2.getLastToken(t3), u3 = LA.isOpeningParenToken(i3) && LA.isOpeningBraceToken(o2.getTokenAfter(i3));
        return r3.push(e26.insertTextBefore(i3, "{return "), e26.insertTextAfter(a3, "}")), u3 && r3.push(e26.remove(i3), e26.remove(function(e27) {
          for (var t4 = o2.getNodeByRangeIndex(e27.range[1]); !LA.isParenthesised(o2, t4); )
            t4 = t4.parent;
          return o2.getTokenAfter(t4);
        }(i3))), r3;
      } });
  } };
} };
function XA(e25) {
  return { start: e25.params[0].loc.start, end: e25.params[e25.params.length - 1].loc.end };
}
var YA = { meta: { type: "layout", docs: { description: "require parentheses around arrow function arguments", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/arrow-parens" }, fixable: "code", schema: [{ enum: ["always", "as-needed"] }, { type: "object", properties: { requireForBlockBody: { type: "boolean", default: false } }, additionalProperties: false }], messages: { unexpectedParens: "Unexpected parentheses around single function argument.", expectedParens: "Expected parentheses around arrow function argument.", unexpectedParensInline: "Unexpected parentheses around single function argument having a body with no curly braces.", expectedParensBlock: "Expected parentheses around arrow function argument having a body with curly braces." } }, create: function(e25) {
  var t2 = e25.options[0] === "as-needed", r2 = t2 && e25.options[1] && e25.options[1].requireForBlockBody === true, n2 = e25.getSourceCode();
  return { ArrowFunctionExpression: function(i2) {
    function a2(e26) {
      var t3 = n2.getTokenAfter(s2), r3 = n2.getTokenAfter(t3, LA.isClosingParenToken), i3 = o2 ? n2.getTokenBefore(s2) : null, a3 = i3 && i3.range[1] === s2.range[0];
      return e26.replaceTextRange([s2.range[0], r3.range[1]], "".concat(a3 ? " " : "").concat(t3.value));
    }
    var o2 = i2.async, s2 = n2.getFirstToken(i2, o2 ? 1 : 0);
    !r2 || i2.params.length !== 1 || i2.params[0].type !== "Identifier" || i2.params[0].typeAnnotation || i2.body.type === "BlockStatement" || i2.returnType ? r2 && i2.body.type === "BlockStatement" ? LA.isOpeningParenToken(s2) || e25.report({ node: i2, messageId: "expectedParensBlock", loc: XA(i2), fix: function(e26) {
      return e26.replaceText(s2, "(".concat(s2.value, ")"));
    } }) : !t2 || i2.params.length !== 1 || i2.params[0].type !== "Identifier" || i2.params[0].typeAnnotation || i2.returnType ? s2.type === "Identifier" && n2.getTokenAfter(s2).value !== ")" && e25.report({ node: i2, messageId: "expectedParens", loc: XA(i2), fix: function(e26) {
      return e26.replaceText(s2, "(".concat(s2.value, ")"));
    } }) : LA.isOpeningParenToken(s2) && e25.report({ node: i2, messageId: "unexpectedParens", loc: XA(i2), fix: a2 }) : LA.isOpeningParenToken(s2) && e25.report({ node: i2, messageId: "unexpectedParensInline", loc: XA(i2), fix: a2 });
  } };
} }, ZA = { meta: { type: "layout", docs: { description: "enforce consistent spacing before and after the arrow in arrow functions", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/arrow-spacing" }, fixable: "whitespace", schema: [{ type: "object", properties: { before: { type: "boolean", default: true }, after: { type: "boolean", default: true } }, additionalProperties: false }], messages: { expectedBefore: "Missing space before =>.", unexpectedBefore: "Unexpected space before =>.", expectedAfter: "Missing space after =>.", unexpectedAfter: "Unexpected space after =>." } }, create: function(e25) {
  function t2(e26) {
    var t3 = n2.getTokenBefore(e26.body, LA.isArrowToken);
    return { before: n2.getTokenBefore(t3), arrow: t3, after: n2.getTokenAfter(t3) };
  }
  var r2 = Object.assign({}, e25.options[0]);
  r2.before = r2.before !== false, r2.after = r2.after !== false;
  var n2 = e25.getSourceCode();
  return { ArrowFunctionExpression: function(n3) {
    var i2 = t2(n3), a2 = function(e26) {
      return { before: e26.arrow.range[0] - e26.before.range[1], after: e26.after.range[0] - e26.arrow.range[1] };
    }(i2);
    r2.before ? a2.before === 0 && e25.report({ node: i2.before, messageId: "expectedBefore", fix: function(e26) {
      return e26.insertTextBefore(i2.arrow, " ");
    } }) : 0 < a2.before && e25.report({ node: i2.before, messageId: "unexpectedBefore", fix: function(e26) {
      return e26.removeRange([i2.before.range[1], i2.arrow.range[0]]);
    } }), r2.after ? a2.after === 0 && e25.report({ node: i2.after, messageId: "expectedAfter", fix: function(e26) {
      return e26.insertTextAfter(i2.arrow, " ");
    } }) : 0 < a2.after && e25.report({ node: i2.after, messageId: "unexpectedAfter", fix: function(e26) {
      return e26.removeRange([i2.arrow.range[1], i2.after.range[0]]);
    } });
  } };
} }, ew = { meta: { type: "layout", docs: { description: "disallow or enforce spaces inside of blocks after opening block and before closing block", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/block-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }], messages: { missing: "Requires a space {{location}} '{{token}}'.", extra: "Unexpected space(s) {{location}} '{{token}}'." } }, create: function(e25) {
  function t2(e26, t3) {
    return !LA.isTokenOnSameLine(e26, t3) || a2.isSpaceBetweenTokens(e26, t3) === n2;
  }
  function r2(r3) {
    var o2 = function(e26) {
      return e26.type === "SwitchStatement" ? 0 < e26.cases.length ? a2.getTokenBefore(e26.cases[0]) : a2.getLastToken(e26, 1) : a2.getFirstToken(e26);
    }(r3), s2 = a2.getLastToken(r3), u2 = a2.getTokenAfter(o2, { includeComments: true }), c2 = a2.getTokenBefore(s2, { includeComments: true });
    o2.type === "Punctuator" && o2.value === "{" && s2.type === "Punctuator" && s2.value === "}" && u2 !== s2 && (n2 || u2.type !== "Line") && (!t2(o2, u2) && e25.report({ node: r3, loc: o2.loc.start, messageId: i2, data: { location: "after", token: o2.value }, fix: function(e26) {
      return n2 ? e26.insertTextBefore(u2, " ") : e26.removeRange([o2.range[1], u2.range[0]]);
    } }), !t2(c2, s2) && e25.report({ node: r3, loc: s2.loc.start, messageId: i2, data: { location: "before", token: s2.value }, fix: function(e26) {
      return n2 ? e26.insertTextAfter(c2, " ") : e26.removeRange([c2.range[1], s2.range[0]]);
    } }));
  }
  var n2 = e25.options[0] !== "never", i2 = n2 ? "missing" : "extra", a2 = e25.getSourceCode();
  return { BlockStatement: r2, SwitchStatement: r2 };
} }, tw = { meta: { type: "layout", docs: { description: "enforce consistent brace style for blocks", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/brace-style" }, schema: [{ enum: ["1tbs", "stroustrup", "allman"] }, { type: "object", properties: { allowSingleLine: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "whitespace", messages: { nextLineOpen: "Opening curly brace does not appear on the same line as controlling statement.", sameLineOpen: "Opening curly brace appears on the same line as controlling statement.", blockSameLine: "Statement inside of curly braces should be on next line.", nextLineClose: "Closing curly brace does not appear on the same line as the subsequent block.", singleLineClose: "Closing curly brace should be on the same line as opening curly brace or on the line after the previous block.", sameLineClose: "Closing curly brace appears on the same line as the subsequent block." } }, create: function(e25) {
  function t2(e26, t3) {
    var r3 = [e26.range[1], t3.range[0]];
    return o2.text.slice(r3[0], r3[1]).trim() ? null : function(e27) {
      return e27.replaceTextRange(r3, " ");
    };
  }
  function r2(r3, n3) {
    var s2 = o2.getTokenBefore(r3), u2 = o2.getTokenAfter(r3), c2 = o2.getTokenBefore(n3), l2 = a2.allowSingleLine && LA.isTokenOnSameLine(r3, n3);
    i2 === "allman" || LA.isTokenOnSameLine(s2, r3) || e25.report({ node: r3, messageId: "nextLineOpen", fix: t2(s2, r3) }), i2 === "allman" && LA.isTokenOnSameLine(s2, r3) && !l2 && e25.report({ node: r3, messageId: "sameLineOpen", fix: function(e26) {
      return e26.insertTextBefore(r3, "\n");
    } }), LA.isTokenOnSameLine(r3, u2) && u2 !== n3 && !l2 && e25.report({ node: r3, messageId: "blockSameLine", fix: function(e26) {
      return e26.insertTextAfter(r3, "\n");
    } }), c2 !== r3 && !l2 && LA.isTokenOnSameLine(c2, n3) && e25.report({ node: n3, messageId: "singleLineClose", fix: function(e26) {
      return e26.insertTextBefore(n3, "\n");
    } });
  }
  function n2(r3) {
    var n3 = o2.getTokenAfter(r3);
    i2 !== "1tbs" || LA.isTokenOnSameLine(r3, n3) || e25.report({ node: r3, messageId: "nextLineClose", fix: t2(r3, n3) }), i2 !== "1tbs" && LA.isTokenOnSameLine(r3, n3) && e25.report({ node: r3, messageId: "sameLineClose", fix: function(e26) {
      return e26.insertTextAfter(r3, "\n");
    } });
  }
  var i2 = e25.options[0] || "1tbs", a2 = e25.options[1] || {}, o2 = e25.getSourceCode();
  return { BlockStatement: function(e26) {
    LA.STATEMENT_LIST_PARENTS.has(e26.parent.type) || r2(o2.getFirstToken(e26), o2.getLastToken(e26));
  }, ClassBody: function(e26) {
    r2(o2.getFirstToken(e26), o2.getLastToken(e26));
  }, SwitchStatement: function(e26) {
    var t3 = o2.getLastToken(e26);
    r2(o2.getTokenBefore(e26.cases.length ? e26.cases[0] : t3), t3);
  }, IfStatement: function(e26) {
    e26.consequent.type === "BlockStatement" && e26.alternate && n2(o2.getLastToken(e26.consequent));
  }, TryStatement: function(e26) {
    n2(o2.getLastToken(e26.block)), e26.handler && e26.finalizer && n2(o2.getLastToken(e26.handler.body));
  } };
} }, rw = { meta: { type: "suggestion", docs: { description: "enforce camelcase naming convention", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/camelcase" }, schema: [{ type: "object", properties: { ignoreDestructuring: { type: "boolean", default: false }, ignoreImports: { type: "boolean", default: false }, properties: { enum: ["always", "never"] }, allow: { type: "array", items: [{ type: "string" }], minItems: 0, uniqueItems: true } }, additionalProperties: false }], messages: { notCamelCase: "Identifier '{{name}}' is not in camel case." } }, create: function(e25) {
  function t2(e26) {
    return e26.includes("_") && e26 !== e26.toUpperCase();
  }
  function r2(e26) {
    return u2.some(function(t3) {
      return e26 === t3 || e26.match(new RegExp(t3, "u"));
    });
  }
  function n2(t3) {
    c2.includes(t3) || (c2.push(t3), e25.report({ node: t3, messageId: "notCamelCase", data: { name: t3.name } }));
  }
  var i2 = e25.options[0] || {}, a2 = i2.properties || "", o2 = i2.ignoreDestructuring, s2 = i2.ignoreImports, u2 = i2.allow || [];
  a2 !== "always" && a2 !== "never" && (a2 = "always");
  var c2 = [], l2 = new Set(["CallExpression", "NewExpression"]);
  return { Identifier: function(e26) {
    var i3 = e26.name, u3 = t2(i3.replace(/^_+|_+$/g, "")), c3 = e26.parent.type === "MemberExpression" ? e26.parent.parent : e26.parent;
    if (!r2(i3))
      if (e26.parent.type === "MemberExpression") {
        if (a2 === "never")
          return;
        e26.parent.object.type === "Identifier" && e26.parent.object.name === e26.name && u3 ? n2(e26) : c3.type === "AssignmentExpression" && u3 && (c3.right.type !== "MemberExpression" || c3.left.type === "MemberExpression" && c3.left.property.name === e26.name) && n2(e26);
      } else if (e26.parent.type === "Property" || e26.parent.type === "AssignmentPattern") {
        if (e26.parent.parent && e26.parent.parent.type === "ObjectPattern") {
          e26.parent.shorthand && e26.parent.value.left && u3 && n2(e26);
          var p2 = e26.parent.key.name === e26.parent.value.name;
          if (t2(i3) && e26.parent.computed && n2(e26), e26.parent.key === e26 && e26.parent.value !== e26)
            return;
          e26.parent.value.name && u3 && (!p2 || !o2) && n2(e26);
        }
        if (a2 === "never" || o2 && function(e27) {
          for (var t3 = e27; t3; ) {
            var r3 = t3.parent;
            if (r3 && r3.type === "Property" && r3.computed && r3.key === t3)
              return false;
            if (t3.type === "ObjectPattern")
              return true;
            t3 = r3;
          }
          return false;
        }(e26))
          return;
        !u3 || l2.has(c3.type) || e26.parent.right === e26 || n2(e26);
      } else if (["ImportSpecifier", "ImportNamespaceSpecifier", "ImportDefaultSpecifier"].includes(e26.parent.type)) {
        if (e26.parent.type === "ImportSpecifier" && s2)
          return;
        e26.parent.local && e26.parent.local.name === e26.name && u3 && n2(e26);
      } else
        u3 && !l2.has(c3.type) && n2(e26);
  } };
} }, nw = /[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B2\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA7AD\uA7B0\uA7B1\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB5F\uAB64\uAB65\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|(?:\uD800(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF])|(?:\uD801(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67])|(?:\uD802(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91])|(?:\uD803(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC48])|(?:\uD804(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDE00-\uDE11\uDE13-\uDE2B\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF5D-\uDF61])|(?:\uD805(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDE00-\uDE2F\uDE44\uDE80-\uDEAA])|(?:\uD806(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8])|(?:\uD808(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDF98])|(?:[\uD80C\uD840-\uD868\uD86A-\uD86C](?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|(?:\uD80D(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC2E])|(?:\uD81A(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F])|(?:\uD81B(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDF00-\uDF44\uDF50\uDF93-\uDF9F])|(?:\uD82C(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00\uDC01])|(?:\uD82F(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99])|(?:\uD835(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB])|(?:\uD83A(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDCC4])|(?:\uD83B(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB])|(?:\uD869(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDED6\uDF00-\uDFFF])|(?:\uD86D(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDF34\uDF40-\uDFFF])|(?:\uD86E(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDC1D])|(?:\uD87E(?![\uDC00-\uDFFF]))(?:(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDE1D])/, iw = LA.COMMENTS_IGNORE_PATTERN, aw = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/g, ow = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:[\0-\x08\x0E-\x1F!"\$-\.0-9;->@-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+:\/\/(?:[\0-"\$->@-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, sw = { type: "object", properties: { ignorePattern: { type: "string" }, ignoreInlineComments: { type: "boolean" }, ignoreConsecutiveComments: { type: "boolean" } }, additionalProperties: false }, uw = { ignorePattern: "", ignoreInlineComments: false, ignoreConsecutiveComments: false };
function cw(e25, t2) {
  return Object.assign({}, uw, e25[t2] || e25);
}
var lw = { meta: { type: "suggestion", docs: { description: "enforce or disallow capitalization of the first letter of a comment", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/capitalized-comments" }, fixable: "code", schema: [{ enum: ["always", "never"] }, { oneOf: [sw, { type: "object", properties: { line: sw, block: sw }, additionalProperties: false }] }], messages: { unexpectedLowercaseComment: "Comments should not begin with a lowercase character.", unexpectedUppercaseComment: "Comments should not begin with an uppercase character." } }, create: function(e25) {
  function t2(e26) {
    var t3 = s2.getTokenBefore(e26, { includeComments: true }), r3 = s2.getTokenAfter(e26, { includeComments: true });
    return !(!t3 || !r3 || e26.loc.start.line !== t3.loc.end.line || e26.loc.end.line !== r3.loc.start.line);
  }
  function r2(e26) {
    var t3 = s2.getTokenBefore(e26, { includeComments: true });
    return !(!t3 || ["Block", "Line"].indexOf(t3.type) === -1);
  }
  function n2(e26, n3) {
    if (iw.test(e26.value))
      return true;
    var i3 = e26.value.replace(/\*/g, "");
    if (n3.ignorePatternRegExp && n3.ignorePatternRegExp.test(i3))
      return true;
    if (n3.ignoreInlineComments && t2(e26))
      return true;
    if (n3.ignoreConsecutiveComments && r2(e26))
      return true;
    if (ow.test(i3))
      return true;
    var o3 = i3.replace(aw, "");
    if (o3.length === 0)
      return true;
    var s3 = o3[0];
    if (!nw.test(s3))
      return true;
    var u2 = s3 !== s3.toLocaleLowerCase(), c2 = s3 !== s3.toLocaleUpperCase();
    return !(a2 === "always" && c2 || a2 === "never" && u2);
  }
  function i2(t3) {
    var r3 = o2[t3.type];
    if (!n2(t3, r3)) {
      var i3 = a2 === "always" ? "unexpectedLowercaseComment" : "unexpectedUppercaseComment";
      e25.report({ node: null, loc: t3.loc, messageId: i3, fix: function(e26) {
        var r4 = t3.value.match(nw);
        return e26.replaceTextRange([t3.range[0] + r4.index + 2, t3.range[0] + r4.index + 3], a2 === "always" ? r4[0].toLocaleUpperCase() : r4[0].toLocaleLowerCase());
      } });
    }
  }
  var a2 = e25.options[0] || "always", o2 = function() {
    var e26 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return { Line: cw(e26, "line"), Block: cw(e26, "block") };
  }(e25.options[1]), s2 = e25.getSourceCode();
  return function(e26) {
    Object.keys(e26).forEach(function(t3) {
      var r3 = e26[t3].ignorePattern;
      if (r3) {
        var n3 = RegExp("^\\s*(?:".concat(r3, ")"), "u");
        e26[t3].ignorePatternRegExp = n3;
      }
    });
  }(o2), { Program: function() {
    s2.getAllComments().filter(function(e26) {
      return e26.type !== "Shebang";
    }).forEach(i2);
  } };
} }, pw = { meta: { type: "suggestion", docs: { description: "enforce that class methods utilize `this`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/class-methods-use-this" }, schema: [{ type: "object", properties: { exceptMethods: { type: "array", items: { type: "string" } } }, additionalProperties: false }], messages: { missingThis: "Expected 'this' to be used by class {{name}}." } }, create: function(e25) {
  function t2() {
    s2.push(false);
  }
  function r2(e26) {
    return function(e27) {
      return !e27.static && e27.kind !== "constructor" && e27.type === "MethodDefinition";
    }(e26) && (e26.computed || !o2.has(e26.key.name));
  }
  function n2(t3) {
    var n3 = s2.pop();
    r2(t3.parent) && !n3 && e25.report({ node: t3, messageId: "missingThis", data: { name: LA.getFunctionNameWithKind(t3) } });
  }
  function i2() {
    s2.length && (s2[s2.length - 1] = true);
  }
  var a2 = Object.assign({}, e25.options[0]), o2 = new Set(a2.exceptMethods || []), s2 = [];
  return { FunctionDeclaration: t2, "FunctionDeclaration:exit": n2, FunctionExpression: t2, "FunctionExpression:exit": n2, ThisExpression: i2, Super: i2 };
} }, fw = Object.freeze({ arrays: "never", objects: "never", imports: "never", exports: "never", functions: "never" });
var hw = { meta: { type: "layout", docs: { description: "require or disallow trailing commas", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/comma-dangle" }, fixable: "code", schema: { definitions: { value: { enum: ["always-multiline", "always", "never", "only-multiline"] }, valueWithIgnore: { enum: ["always-multiline", "always", "ignore", "never", "only-multiline"] } }, type: "array", items: [{ oneOf: [{ $ref: "#/definitions/value" }, { type: "object", properties: { arrays: { $ref: "#/definitions/valueWithIgnore" }, objects: { $ref: "#/definitions/valueWithIgnore" }, imports: { $ref: "#/definitions/valueWithIgnore" }, exports: { $ref: "#/definitions/valueWithIgnore" }, functions: { $ref: "#/definitions/valueWithIgnore" } }, additionalProperties: false }] }] }, messages: { unexpected: "Unexpected trailing comma.", missing: "Missing trailing comma." } }, create: function(e25) {
  function t2(e26) {
    switch (e26.type) {
      case "ObjectExpression":
      case "ObjectPattern":
        return Fy.lodash.last(e26.properties);
      case "ArrayExpression":
      case "ArrayPattern":
        return Fy.lodash.last(e26.elements);
      case "ImportDeclaration":
      case "ExportNamedDeclaration":
        return Fy.lodash.last(e26.specifiers);
      case "FunctionDeclaration":
      case "FunctionExpression":
      case "ArrowFunctionExpression":
        return Fy.lodash.last(e26.params);
      case "CallExpression":
      case "NewExpression":
        return Fy.lodash.last(e26.arguments);
      default:
        return null;
    }
  }
  function r2(e26, t3) {
    switch (e26.type) {
      case "ObjectExpression":
      case "ArrayExpression":
      case "CallExpression":
      case "NewExpression":
        return u2.getLastToken(e26, 1);
      default:
        var r3 = u2.getTokenAfter(t3);
        return LA.isCommaToken(r3) ? r3 : u2.getLastToken(t3);
    }
  }
  function n2(e26) {
    var n3 = t2(e26);
    if (!n3)
      return false;
    var i2 = r2(e26, n3);
    return u2.getTokenAfter(i2).loc.end.line !== i2.loc.end.line;
  }
  function a2(n3) {
    var i2 = t2(n3);
    if (i2 && (n3.type !== "ImportDeclaration" || i2.type === "ImportSpecifier")) {
      var a3 = r2(n3, i2);
      LA.isCommaToken(a3) && e25.report({ node: i2, loc: a3.loc, messageId: "unexpected", fix: function(e26) {
        return e26.remove(a3);
      } });
    }
  }
  function o2(n3) {
    var i2 = t2(n3);
    if (i2 && (n3.type !== "ImportDeclaration" || i2.type === "ImportSpecifier"))
      if (function(e26) {
        return e26.type !== "RestElement" && e26.type !== "RestProperty" && e26.type !== "ExperimentalRestProperty";
      }(i2)) {
        var o3 = r2(n3, i2);
        o3.value !== "," && e25.report({ node: i2, loc: { start: o3.loc.end, end: LA.getNextLocation(u2, o3.loc.end) }, messageId: "missing", fix: function(e26) {
          return e26.insertTextAfter(o3, ",");
        } });
      } else
        a2(n3);
  }
  var s2 = function(e26, t3) {
    return typeof e26 == "string" ? { arrays: e26, objects: e26, imports: e26, exports: e26, functions: !t3 || 8 > t3 ? "ignore" : e26 } : i(e26) == "object" && e26 !== null ? { arrays: e26.arrays || fw.arrays, objects: e26.objects || fw.objects, imports: e26.imports || fw.imports, exports: e26.exports || fw.exports, functions: e26.functions || fw.functions } : fw;
  }(e25.options[0], e25.parserOptions.ecmaVersion), u2 = e25.getSourceCode(), c2 = { always: o2, "always-multiline": function(e26) {
    n2(e26) ? o2(e26) : a2(e26);
  }, "only-multiline": function(e26) {
    n2(e26) || a2(e26);
  }, never: a2, ignore: Fy.lodash.noop };
  return { ObjectExpression: c2[s2.objects], ObjectPattern: c2[s2.objects], ArrayExpression: c2[s2.arrays], ArrayPattern: c2[s2.arrays], ImportDeclaration: c2[s2.imports], ExportNamedDeclaration: c2[s2.exports], FunctionDeclaration: c2[s2.functions], FunctionExpression: c2[s2.functions], ArrowFunctionExpression: c2[s2.functions], CallExpression: c2[s2.functions], NewExpression: c2[s2.functions] };
} }, dw = { meta: { type: "layout", docs: { description: "enforce consistent spacing before and after commas", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/comma-spacing" }, fixable: "whitespace", schema: [{ type: "object", properties: { before: { type: "boolean", default: false }, after: { type: "boolean", default: true } }, additionalProperties: false }], messages: { missing: "A space is required {{loc}} ','.", unexpected: "There should be no space {{loc}} ','." } }, create: function(e25) {
  function t2(t3, r3, n3) {
    e25.report({ node: t3, fix: function(e26) {
      return o2[r3] ? r3 === "before" ? e26.insertTextBefore(t3, " ") : e26.insertTextAfter(t3, " ") : (r3 === "before" ? (i3 = n3.range[1], a3 = t3.range[0]) : (i3 = t3.range[1], a3 = n3.range[0]), e26.replaceTextRange([i3, a3], ""));
      var i3, a3;
    }, messageId: o2[r3] ? "missing" : "unexpected", data: { loc: r3 } });
  }
  function r2(e26, r3) {
    e26.left && LA.isTokenOnSameLine(e26.left, e26.comma) && o2.before !== i2.isSpaceBetweenTokens(e26.left, e26.comma) && t2(r3, "before", e26.left), e26.right && LA.isClosingParenToken(e26.right) || e26.right && !o2.after && e26.right.type === "Line" || e26.right && LA.isTokenOnSameLine(e26.comma, e26.right) && o2.after !== i2.isSpaceBetweenTokens(e26.comma, e26.right) && t2(r3, "after", e26.right);
  }
  function n2(e26) {
    var t3 = i2.getFirstToken(e26);
    e26.elements.forEach(function(e27) {
      var r3;
      e27 === null ? (r3 = i2.getTokenAfter(t3), LA.isCommaToken(r3) && s2.push(r3)) : r3 = i2.getTokenAfter(e27), t3 = r3;
    });
  }
  var i2 = e25.getSourceCode(), a2 = i2.tokensAndComments, o2 = { before: !!e25.options[0] && e25.options[0].before, after: !e25.options[0] || e25.options[0].after }, s2 = [];
  return { "Program:exit": function() {
    a2.forEach(function(e26, t3) {
      if (LA.isCommaToken(e26) && (!e26 || e26.type !== "JSXText")) {
        var n3 = a2[t3 - 1], i3 = a2[t3 + 1];
        r2({ comma: e26, left: LA.isCommaToken(n3) || -1 < s2.indexOf(e26) ? null : n3, right: LA.isCommaToken(i3) ? null : i3 }, e26);
      }
    });
  }, ArrayExpression: n2, ArrayPattern: n2 };
} }, mw = { meta: { type: "layout", docs: { description: "enforce consistent comma style", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/comma-style" }, fixable: "code", schema: [{ enum: ["first", "last"] }, { type: "object", properties: { exceptions: { type: "object", additionalProperties: { type: "boolean" } } }, additionalProperties: false }], messages: { unexpectedLineBeforeAndAfterComma: "Bad line breaking before and after ','.", expectedCommaFirst: "',' should be placed first.", expectedCommaLast: "',' should be placed last." } }, create: function(e25) {
  function t2(e26, t3, r3, n3) {
    var i3 = a2.text.slice(t3.range[1], r3.range[0]) + a2.text.slice(r3.range[1], n3.range[0]), o3 = [t3.range[1], n3.range[0]];
    return function(t4) {
      return t4.replaceTextRange(o3, function(e27, t5) {
        return e27 === "between" ? ",".concat(t5.replace(LA.LINEBREAK_MATCHER, "")) : e27 === "first" ? "".concat(t5, ",") : e27 === "last" ? ",".concat(t5) : "";
      }(e26, i3));
    };
  }
  function r2(r3, n3, o3, s3) {
    if (LA.isTokenOnSameLine(n3, o3) && LA.isTokenOnSameLine(r3, n3))
      ;
    else if (LA.isTokenOnSameLine(n3, o3) || LA.isTokenOnSameLine(r3, n3))
      i2 !== "first" || LA.isTokenOnSameLine(n3, o3) ? i2 === "last" && LA.isTokenOnSameLine(n3, o3) && e25.report({ node: s3, loc: { line: n3.loc.end.line, column: n3.loc.end.column }, messageId: "expectedCommaLast", fix: t2(i2, r3, n3, o3) }) : e25.report({ node: s3, messageId: "expectedCommaFirst", fix: t2(i2, r3, n3, o3) });
    else {
      var u3 = a2.getCommentsAfter(n3)[0], c3 = u3 && u3.type === "Block" && LA.isTokenOnSameLine(n3, u3) ? i2 : "between";
      e25.report({ node: s3, loc: { line: n3.loc.end.line, column: n3.loc.start.column }, messageId: "unexpectedLineBeforeAndAfterComma", fix: t2(c3, r3, n3, o3) });
    }
  }
  function n2(e26, t3) {
    var n3 = e26[t3], i3 = e26.type === "ArrayExpression" || e26.type === "ArrayPattern";
    if (1 < n3.length || i3) {
      var o3 = a2.getFirstToken(e26);
      if (n3.forEach(function(e27) {
        var t4 = e27 ? a2.getTokenBefore(e27) : o3, n4 = e27 ? a2.getFirstToken(e27) : a2.getTokenAfter(t4);
        if (LA.isCommaToken(t4) && r2(o3, t4, n4, e27 || n4), e27) {
          var i4 = a2.getTokenAfter(e27, LA.isNotClosingParenToken);
          o3 = i4 ? a2.getTokenBefore(i4) : a2.ast.tokens[a2.ast.tokens.length - 1];
        }
      }), i3) {
        var s3 = a2.getLastToken(e26), u3 = a2.getTokenBefore(s3);
        LA.isCommaToken(u3) && r2(a2.getTokenBefore(u3), u3, s3, s3);
      }
    }
  }
  var i2 = e25.options[0] || "last", a2 = e25.getSourceCode(), o2 = { ArrayPattern: true, ArrowFunctionExpression: true, CallExpression: true, FunctionDeclaration: true, FunctionExpression: true, ImportDeclaration: true, ObjectPattern: true, NewExpression: true };
  if (e25.options.length === 2 && Object.prototype.hasOwnProperty.call(e25.options[1], "exceptions"))
    for (var s2 = Object.keys(e25.options[1].exceptions), u2 = 0; u2 < s2.length; u2++)
      o2[s2[u2]] = e25.options[1].exceptions[s2[u2]];
  var c2 = {};
  return o2.VariableDeclaration || (c2.VariableDeclaration = function(e26) {
    n2(e26, "declarations");
  }), o2.ObjectExpression || (c2.ObjectExpression = function(e26) {
    n2(e26, "properties");
  }), o2.ObjectPattern || (c2.ObjectPattern = function(e26) {
    n2(e26, "properties");
  }), o2.ArrayExpression || (c2.ArrayExpression = function(e26) {
    n2(e26, "elements");
  }), o2.ArrayPattern || (c2.ArrayPattern = function(e26) {
    n2(e26, "elements");
  }), o2.FunctionDeclaration || (c2.FunctionDeclaration = function(e26) {
    n2(e26, "params");
  }), o2.FunctionExpression || (c2.FunctionExpression = function(e26) {
    n2(e26, "params");
  }), o2.ArrowFunctionExpression || (c2.ArrowFunctionExpression = function(e26) {
    n2(e26, "params");
  }), o2.CallExpression || (c2.CallExpression = function(e26) {
    n2(e26, "arguments");
  }), o2.ImportDeclaration || (c2.ImportDeclaration = function(e26) {
    n2(e26, "specifiers");
  }), o2.NewExpression || (c2.NewExpression = function(e26) {
    n2(e26, "arguments");
  }), c2;
} }, gw = { meta: { type: "suggestion", docs: { description: "enforce a maximum cyclomatic complexity allowed in a program", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/complexity" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: false }] }], messages: { complex: "{{name}} has a complexity of {{complexity}}. Maximum allowed is {{max}}." } }, create: function(e25) {
  function t2() {
    s2.push(1);
  }
  function r2(t3) {
    var r3 = Fy.lodash.upperFirst(LA.getFunctionNameWithKind(t3)), n3 = s2.pop();
    n3 > o2 && e25.report({ node: t3, messageId: "complex", data: { name: r3, complexity: n3, max: o2 } });
  }
  function n2() {
    s2.length && s2[s2.length - 1]++;
  }
  var a2 = e25.options[0], o2 = 20;
  i(a2) == "object" && (Object.prototype.hasOwnProperty.call(a2, "maximum") || Object.prototype.hasOwnProperty.call(a2, "max")) ? o2 = a2.maximum || a2.max : typeof a2 == "number" && (o2 = a2);
  var s2 = [];
  return { FunctionDeclaration: t2, FunctionExpression: t2, ArrowFunctionExpression: t2, "FunctionDeclaration:exit": r2, "FunctionExpression:exit": r2, "ArrowFunctionExpression:exit": r2, CatchClause: n2, ConditionalExpression: n2, LogicalExpression: n2, ForStatement: n2, ForInStatement: n2, ForOfStatement: n2, IfStatement: n2, SwitchCase: function(e26) {
    e26.test && n2();
  }, WhileStatement: n2, DoWhileStatement: n2 };
} }, yw = { meta: { type: "layout", docs: { description: "enforce consistent spacing inside computed property brackets", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/computed-property-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { enforceForClassMembers: { type: "boolean", default: false } }, additionalProperties: false }], messages: { unexpectedSpaceBefore: "There should be no space before '{{tokenValue}}'.", unexpectedSpaceAfter: "There should be no space after '{{tokenValue}}'.", missingSpaceBefore: "A space is required before '{{tokenValue}}'.", missingSpaceAfter: "A space is required after '{{tokenValue}}'." } }, create: function(e25) {
  function t2(t3, r3, n3) {
    e25.report({ node: t3, loc: r3.loc.start, messageId: "unexpectedSpaceAfter", data: { tokenValue: r3.value }, fix: function(e26) {
      return e26.removeRange([r3.range[1], n3.range[0]]);
    } });
  }
  function r2(t3, r3, n3) {
    e25.report({ node: t3, loc: r3.loc.start, messageId: "unexpectedSpaceBefore", data: { tokenValue: r3.value }, fix: function(e26) {
      return e26.removeRange([n3.range[1], r3.range[0]]);
    } });
  }
  function n2(t3, r3) {
    e25.report({ node: t3, loc: r3.loc.start, messageId: "missingSpaceAfter", data: { tokenValue: r3.value }, fix: function(e26) {
      return e26.insertTextAfter(r3, " ");
    } });
  }
  function i2(t3, r3) {
    e25.report({ node: t3, loc: r3.loc.start, messageId: "missingSpaceBefore", data: { tokenValue: r3.value }, fix: function(e26) {
      return e26.insertTextBefore(r3, " ");
    } });
  }
  function a2(e26) {
    return function(a3) {
      if (a3.computed) {
        var u3 = a3[e26], c3 = o2.getTokenBefore(u3, LA.isOpeningBracketToken), l2 = o2.getTokenAfter(c3, { includeComments: true }), p2 = o2.getTokenAfter(u3, LA.isClosingBracketToken), f2 = o2.getTokenBefore(p2, { includeComments: true });
        LA.isTokenOnSameLine(c3, l2) && (s2 ? !o2.isSpaceBetweenTokens(c3, l2) && LA.isTokenOnSameLine(c3, l2) && n2(a3, c3) : o2.isSpaceBetweenTokens(c3, l2) && t2(a3, c3, l2)), LA.isTokenOnSameLine(f2, p2) && (s2 ? !o2.isSpaceBetweenTokens(f2, p2) && LA.isTokenOnSameLine(f2, p2) && i2(a3, p2) : o2.isSpaceBetweenTokens(f2, p2) && r2(a3, p2, f2));
      }
    };
  }
  var o2 = e25.getSourceCode(), s2 = e25.options[0] === "always", u2 = e25.options[1] && e25.options[1].enforceForClassMembers, c2 = { Property: a2("key"), MemberExpression: a2("property") };
  return u2 && (c2.MethodDefinition = a2("key")), c2;
} };
function vw(e25) {
  return !e25.reachable;
}
var xw = { meta: { type: "suggestion", docs: { description: "require `return` statements to either always or never specify values", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/consistent-return" }, schema: [{ type: "object", properties: { treatUndefinedAsUnspecified: { type: "boolean", default: false } }, additionalProperties: false }], messages: { missingReturn: "Expected to return a value at the end of {{name}}.", missingReturnValue: "{{name}} expected a return value.", unexpectedReturnValue: "{{name}} expected no return value." } }, create: function(e25) {
  function t2(t3) {
    var r3, i2;
    !n2.hasReturnValue || n2.codePath.currentSegments.every(vw) || LA.isES5Constructor(t3) || function(e26) {
      return e26.type === "FunctionExpression" && e26.parent && e26.parent.type === "MethodDefinition" && e26.parent.kind === "constructor";
    }(t3) || (t3.type === "Program" ? (r3 = { line: 1, column: 0 }, i2 = "program") : r3 = t3.type === "ArrowFunctionExpression" ? e25.getSourceCode().getTokenBefore(t3.body, LA.isArrowToken).loc.start : t3.parent.type === "MethodDefinition" || t3.parent.type === "Property" && t3.parent.method ? t3.parent.key.loc.start : (t3.id || t3).loc.start, !i2 && (i2 = LA.getFunctionNameWithKind(t3)), e25.report({ node: t3, loc: r3, messageId: "missingReturn", data: { name: i2 } }));
  }
  var r2 = (e25.options[0] || {}).treatUndefinedAsUnspecified === true, n2 = null;
  return { onCodePathStart: function(e26, t3) {
    n2 = { upper: n2, codePath: e26, hasReturn: false, hasReturnValue: false, messageId: "", node: t3 };
  }, onCodePathEnd: function() {
    n2 = n2.upper;
  }, ReturnStatement: function(t3) {
    var i2 = t3.argument, a2 = !!i2;
    r2 && a2 && (a2 = !function(e26, t4) {
      return e26.type === "Identifier" && e26.name === t4;
    }(i2, "undefined") && i2.operator !== "void"), n2.hasReturn ? n2.hasReturnValue !== a2 && e25.report({ node: t3, messageId: n2.messageId, data: n2.data }) : (n2.hasReturn = true, n2.hasReturnValue = a2, n2.messageId = a2 ? "missingReturnValue" : "unexpectedReturnValue", n2.data = { name: n2.node.type === "Program" ? "Program" : Fy.lodash.upperFirst(LA.getFunctionNameWithKind(n2.node)) });
  }, "Program:exit": t2, "FunctionDeclaration:exit": t2, "FunctionExpression:exit": t2, "ArrowFunctionExpression:exit": t2 };
} };
function bw(e25) {
  return e25.reachable;
}
function Ew(e25) {
  if (!e25)
    return false;
  switch (e25.type) {
    case "ClassExpression":
    case "FunctionExpression":
    case "ThisExpression":
    case "MemberExpression":
    case "CallExpression":
    case "NewExpression":
    case "YieldExpression":
    case "TaggedTemplateExpression":
    case "MetaProperty":
      return true;
    case "Identifier":
      return e25.name !== "undefined";
    case "AssignmentExpression":
      return Ew(e25.right);
    case "LogicalExpression":
      return Ew(e25.left) || Ew(e25.right);
    case "ConditionalExpression":
      return Ew(e25.alternate) || Ew(e25.consequent);
    case "SequenceExpression":
      return Ew(e25.expressions[e25.expressions.length - 1]);
    default:
      return false;
  }
}
var Cw = { meta: { type: "problem", docs: { description: "require `super()` calls in constructors", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/constructor-super" }, schema: [], messages: { missingSome: "Lacked a call of 'super()' in some code paths.", missingAll: "Expected to call 'super()'.", duplicate: "Unexpected duplicate 'super()'.", badSuper: "Unexpected 'super()' because 'super' is not a constructor.", unexpected: "Unexpected 'super()'." } }, create: function(e25) {
  function t2(e26) {
    return e26.reachable && i2[e26.id].calledInSomePaths;
  }
  function r2(e26) {
    return !(e26.nextSegments.length !== 1 || !e26.nextSegments[0].isLoopedPrevSegment(e26)) || e26.reachable && i2[e26.id].calledInEveryPaths;
  }
  var n2 = null, i2 = Object.create(null);
  return { onCodePathStart: function(e26, t3) {
    if (function(e27) {
      return e27.type === "FunctionExpression" && e27.parent.type === "MethodDefinition" && e27.parent.kind === "constructor";
    }(t3)) {
      var r3 = t3.parent.parent.parent.superClass;
      n2 = { upper: n2, isConstructor: true, hasExtends: !!r3, superIsConstructor: Ew(r3), codePath: e26 };
    } else
      n2 = { upper: n2, isConstructor: false, hasExtends: false, superIsConstructor: false, codePath: e26 };
  }, onCodePathEnd: function(i3, a2) {
    var o2 = n2.hasExtends;
    if (n2 = n2.upper, o2) {
      var s2 = i3.returnedSegments, u2 = s2.every(r2), c2 = s2.some(t2);
      u2 || e25.report({ messageId: c2 ? "missingSome" : "missingAll", node: a2.parent });
    }
  }, onCodePathSegmentStart: function(e26) {
    if (n2 && n2.isConstructor && n2.hasExtends) {
      var a2 = i2[e26.id] = { calledInSomePaths: false, calledInEveryPaths: false, validNodes: [] }, o2 = e26.prevSegments;
      0 < o2.length && (a2.calledInSomePaths = o2.some(t2), a2.calledInEveryPaths = o2.every(r2));
    }
  }, onCodePathSegmentLoop: function(a2, o2) {
    if (n2 && n2.isConstructor && n2.hasExtends) {
      var s2 = 2 <= o2.prevSegments.length;
      n2.codePath.traverseSegments({ first: o2, last: a2 }, function(n3) {
        var a3 = i2[n3.id], o3 = n3.prevSegments;
        if (a3.calledInSomePaths = o3.some(t2), a3.calledInEveryPaths = o3.every(r2), a3.calledInSomePaths || s2) {
          var u2 = a3.validNodes;
          a3.validNodes = [];
          for (var c2 = 0; c2 < u2.length; ++c2) {
            var l2 = u2[c2];
            e25.report({ messageId: "duplicate", node: l2 });
          }
        }
      });
    }
  }, "CallExpression:exit": function(t3) {
    if (n2 && n2.isConstructor && t3.callee.type === "Super")
      if (n2.hasExtends) {
        for (var r3 = n2.codePath.currentSegments, a2 = false, o2 = null, s2 = 0; s2 < r3.length; ++s2) {
          var u2 = r3[s2];
          u2.reachable && (o2 = i2[u2.id], a2 = a2 || o2.calledInSomePaths, o2.calledInSomePaths = o2.calledInEveryPaths = true);
        }
        o2 && (a2 ? e25.report({ messageId: "duplicate", node: t3 }) : n2.superIsConstructor ? o2.validNodes.push(t3) : e25.report({ messageId: "badSuper", node: t3 }));
      } else
        n2.codePath.currentSegments.some(bw) && e25.report({ messageId: "unexpected", node: t3 });
  }, ReturnStatement: function(e26) {
    if (n2 && n2.isConstructor && n2.hasExtends && e26.argument)
      for (var t3 = n2.codePath.currentSegments, r3 = 0; r3 < t3.length; ++r3) {
        var a2 = t3[r3];
        if (a2.reachable) {
          var o2 = i2[a2.id];
          o2.calledInSomePaths = o2.calledInEveryPaths = true;
        }
      }
  }, "Program:exit": function() {
    i2 = Object.create(null);
  } };
} }, Sw = { meta: { type: "suggestion", docs: { description: "enforce consistent brace style for all control statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/curly" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["all"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["multi", "multi-line", "multi-or-nest"] }, { enum: ["consistent"] }], minItems: 0, maxItems: 2 }] }, fixable: "code", messages: { missingCurlyAfter: "Expected { after '{{name}}'.", missingCurlyAfterCondition: "Expected { after '{{name}}' condition.", unexpectedCurlyAfter: "Unnecessary { after '{{name}}'.", unexpectedCurlyAfterCondition: "Unnecessary { after '{{name}}' condition." } }, create: function(e25) {
  function t2(e26) {
    if (e26.type === "EmptyStatement")
      return true;
    var t3 = l2.getFirstToken(e26), r3 = l2.getLastToken(e26), n3 = LA.isSemicolonToken(r3) ? l2.getTokenBefore(r3) : r3;
    return t3.loc.start.line === n3.loc.end.line;
  }
  function r2(e26) {
    return e26.type === "VariableDeclaration" ? e26.kind === "const" || e26.kind === "let" : e26.type === "FunctionDeclaration" || e26.type === "ClassDeclaration";
  }
  function n2(e26) {
    return e26.value === "else" && e26.type === "Keyword";
  }
  function i2(e26) {
    return e26.alternate && l2.getFirstTokenBetween(e26.consequent, e26.alternate, n2);
  }
  function a2(n3, a3, c3, p2) {
    var f2 = a3.type === "BlockStatement", h2 = null;
    if (n3.type === "IfStatement" && n3.consequent === a3 && function(e26) {
      if (e26.alternate && e26.consequent.type === "BlockStatement") {
        if (2 <= e26.consequent.body.length)
          return true;
        for (var t3 = e26.consequent.body[0]; t3; t3 = LA.getTrailingStatement(t3))
          if (t3.type === "IfStatement" && !t3.alternate)
            return true;
      }
      return false;
    }(n3))
      h2 = true;
    else if (o2)
      f2 && a3.body.length === 1 && !r2(a3.body[0]) && (h2 = false);
    else if (s2)
      (function(e26) {
        var t3 = l2.getTokenBefore(e26), r3 = l2.getLastToken(e26), n4 = LA.isSemicolonToken(r3) ? l2.getTokenBefore(r3) : r3;
        return t3.loc.start.line === n4.loc.end.line;
      })(a3) || (h2 = true);
    else if (u2)
      if (f2 && a3.body.length === 1 && t2(a3.body[0])) {
        var d2 = l2.getCommentsBefore(a3.body[0]);
        h2 = !!r2(a3.body[0]) || 0 < d2.length;
      } else
        t2(a3) || (h2 = true);
    else
      h2 = true;
    return { actual: f2, expected: h2, check: function() {
      this.expected !== null && this.expected !== this.actual && (this.expected ? e25.report({ node: n3, loc: (c3 === "else" ? i2(n3) : n3).loc.start, messageId: p2 && p2.condition ? "missingCurlyAfterCondition" : "missingCurlyAfter", data: { name: c3 }, fix: function(e26) {
        return e26.replaceText(a3, "{".concat(l2.getText(a3), "}"));
      } }) : e25.report({ node: n3, loc: (c3 === "else" ? i2(n3) : n3).loc.start, messageId: p2 && p2.condition ? "unexpectedCurlyAfterCondition" : "unexpectedCurlyAfter", data: { name: c3 }, fix: function(e26) {
        var t3 = n3.type === "DoWhileStatement" && l2.getTokenBefore(a3).range[1] === a3.range[0] && !LA.canTokensBeAdjacent("do", l2.getFirstToken(a3, { skip: 1 })), r3 = l2.getFirstToken(a3), i3 = l2.getLastToken(a3), o3 = l2.getTokenBefore(i3);
        if (function(e27) {
          var t4 = l2.getTokenBefore(e27), r4 = l2.getTokenAfter(e27), n4 = l2.getNodeByRangeIndex(t4.range[0]);
          return !(LA.isSemicolonToken(t4) || !r4 || n4.type === "BlockStatement" && n4.parent.type !== "FunctionExpression" && n4.parent.type !== "ArrowFunctionExpression" || t4.loc.end.line !== r4.loc.start.line && !/^[\(\+\x2D\/\[`]/.test(r4.value) && (t4.type !== "Punctuator" || t4.value !== "++" && t4.value !== "--"));
        }(i3))
          return null;
        var s3 = l2.getText().slice(r3.range[1], o3.range[0]) + l2.getText(o3) + l2.getText().slice(o3.range[1], i3.range[0]);
        return e26.replaceText(a3, (t3 ? " " : "") + s3);
      } }));
    } };
  }
  var o2 = e25.options[0] === "multi", s2 = e25.options[0] === "multi-line", u2 = e25.options[0] === "multi-or-nest", c2 = e25.options[1] === "consistent", l2 = e25.getSourceCode();
  return { IfStatement: function(e26) {
    e26.parent.type !== "IfStatement" && function(e27) {
      for (var t3 = [], r3 = e27; r3; r3 = r3.alternate)
        if (t3.push(a2(r3, r3.consequent, "if", { condition: true })), r3.alternate && r3.alternate.type !== "IfStatement") {
          t3.push(a2(r3, r3.alternate, "else"));
          break;
        }
      if (c2) {
        var n3 = t3.some(function(e28) {
          return e28.expected === null ? e28.actual : e28.expected;
        });
        t3.forEach(function(e28) {
          e28.expected = n3;
        });
      }
      return t3;
    }(e26).forEach(function(e27) {
      e27.check();
    });
  }, WhileStatement: function(e26) {
    a2(e26, e26.body, "while", { condition: true }).check();
  }, DoWhileStatement: function(e26) {
    a2(e26, e26.body, "do").check();
  }, ForStatement: function(e26) {
    a2(e26, e26.body, "for", { condition: true }).check();
  }, ForInStatement: function(e26) {
    a2(e26, e26.body, "for-in").check();
  }, ForOfStatement: function(e26) {
    a2(e26, e26.body, "for-of").check();
  } };
} }, kw = /^no default$/i, Dw = { meta: { type: "suggestion", docs: { description: "require `default` cases in `switch` statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/default-case" }, schema: [{ type: "object", properties: { commentPattern: { type: "string" } }, additionalProperties: false }], messages: { missingDefaultCase: "Expected a default case." } }, create: function(e25) {
  function t2(e26) {
    return e26[e26.length - 1];
  }
  var r2 = e25.options[0] || {}, n2 = r2.commentPattern ? new RegExp(r2.commentPattern, "u") : kw, i2 = e25.getSourceCode();
  return { SwitchStatement: function(r3) {
    if (r3.cases.length && !r3.cases.some(function(e26) {
      return e26.test === null;
    })) {
      var a2, o2 = t2(r3.cases), s2 = i2.getCommentsAfter(o2);
      s2.length && (a2 = t2(s2)), a2 && n2.test(a2.value.trim()) || e25.report({ node: r3, messageId: "missingDefaultCase" });
    }
  } };
} }, Fw = { meta: { type: "layout", docs: { description: "enforce consistent newlines before and after dots", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/dot-location" }, schema: [{ enum: ["object", "property"] }], fixable: "code", messages: { expectedDotAfterObject: "Expected dot to be on same line as object.", expectedDotBeforeProperty: "Expected dot to be on same line as property." } }, create: function(e25) {
  function t2(t3) {
    var r3 = t3.property, a2 = i2.getTokenBefore(r3), o2 = i2.getTokenBefore(a2), s2 = i2.getText().slice(o2.range[1], a2.range[0]), u2 = i2.getText().slice(a2.range[1], r3.range[0]);
    if (n2) {
      if (!LA.isTokenOnSameLine(o2, a2)) {
        var c2 = LA.isDecimalIntegerNumericToken(o2) ? " " : "";
        e25.report({ node: t3, loc: a2.loc, messageId: "expectedDotAfterObject", fix: function(e26) {
          return e26.replaceTextRange([o2.range[1], r3.range[0]], "".concat(c2, ".").concat(s2).concat(u2));
        } });
      }
    } else
      LA.isTokenOnSameLine(a2, r3) || e25.report({ node: t3, loc: a2.loc, messageId: "expectedDotBeforeProperty", fix: function(e26) {
        return e26.replaceTextRange([o2.range[1], r3.range[0]], "".concat(s2).concat(u2, "."));
      } });
  }
  var r2 = e25.options[0], n2 = r2 === "object" || !r2, i2 = e25.getSourceCode();
  return { MemberExpression: function(e26) {
    e26.computed || t2(e26);
  } };
} }, Aw = ["abstract", "boolean", "break", "byte", "case", "catch", "char", "class", "const", "continue", "debugger", "default", "delete", "do", "double", "else", "enum", "export", "extends", "false", "final", "finally", "float", "for", "function", "goto", "if", "implements", "import", "in", "instanceof", "int", "interface", "long", "native", "new", "null", "package", "private", "protected", "public", "return", "short", "static", "super", "switch", "synchronized", "this", "throw", "throws", "transient", "true", "try", "typeof", "var", "void", "volatile", "while", "with"], ww = /^[\$A-Z_a-z][\$0-9A-Z_a-z]*$/, _w = new Set(["string", "boolean"]), Tw = { meta: { type: "suggestion", docs: { description: "enforce dot notation whenever possible", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/dot-notation" }, schema: [{ type: "object", properties: { allowKeywords: { type: "boolean", default: true }, allowPattern: { type: "string", default: "" } }, additionalProperties: false }], fixable: "code", messages: { useDot: "[{{key}}] is better written in dot notation.", useBrackets: ".{{key}} is a syntax error." } }, create: function(e25) {
  function t2(t3, n3) {
    if (ww.test(n3) && (a2 || Aw.indexOf(n3 + "") === -1) && (!r2 || !r2.test(n3))) {
      var i2 = t3.property.type === "Literal" ? JSON.stringify(n3) : "`".concat(n3, "`");
      e25.report({ node: t3.property, messageId: "useDot", data: { key: i2 }, fix: function(e26) {
        var r3 = o2.getTokenAfter(t3.object, LA.isOpeningBracketToken), i3 = o2.getLastToken(t3);
        if (o2.getFirstTokenBetween(r3, i3, { includeComments: true, filter: LA.isCommentToken }))
          return null;
        var a3 = o2.getTokenAfter(i3), s2 = a3 && i3.range[1] === a3.range[0] && !LA.canTokensBeAdjacent(n3 + "", a3), u2 = LA.isDecimalInteger(t3.object) ? " " : "", c2 = s2 ? " " : "";
        return e26.replaceTextRange([r3.range[0], i3.range[1]], "".concat(u2, ".").concat(n3).concat(c2));
      } });
    }
  }
  var r2, n2 = e25.options[0] || {}, a2 = n2.allowKeywords === void 0 || n2.allowKeywords, o2 = e25.getSourceCode();
  return n2.allowPattern && (r2 = new RegExp(n2.allowPattern, "u")), { MemberExpression: function(r3) {
    r3.computed && r3.property.type === "Literal" && (_w.has(i(r3.property.value)) || LA.isNullLiteral(r3.property)) && t2(r3, r3.property.value), r3.computed && r3.property.type === "TemplateLiteral" && r3.property.expressions.length === 0 && t2(r3, r3.property.quasis[0].value.cooked), a2 || r3.computed || Aw.indexOf(r3.property.name + "") === -1 || e25.report({ node: r3.property, messageId: "useBrackets", data: { key: r3.property.name }, fix: function(e26) {
      var t3 = o2.getTokenBefore(r3.property), n3 = o2.text.slice(t3.range[1], r3.property.range[0]);
      return n3.trim() ? null : r3.object.type === "Identifier" && r3.object.name === "let" ? null : e26.replaceTextRange([t3.range[0], r3.property.range[1]], "[".concat(n3, '"').concat(r3.property.name, '"]'));
    } });
  } };
} }, Pw = { meta: { type: "layout", docs: { description: "require or disallow newline at the end of files", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/eol-last" }, fixable: "whitespace", schema: [{ enum: ["always", "never", "unix", "windows"] }], messages: { missing: "Newline required at end of file but not found.", unexpected: "Newline not allowed at end of file." } }, create: function(e25) {
  return { Program: function(t2) {
    var r2 = e25.getSourceCode(), n2 = r2.getText(), i2 = { column: Fy.lodash.last(r2.lines).length, line: r2.lines.length }, a2 = Fy.lodash.endsWith(n2, "\n");
    if (n2.length) {
      var o2 = e25.options[0] || "always", s2 = false;
      o2 === "unix" && (o2 = "always"), o2 === "windows" && (o2 = "always", s2 = true), o2 !== "always" || a2 ? o2 === "never" && a2 && e25.report({ node: t2, loc: i2, messageId: "unexpected", fix: function(e26) {
        var t3 = /(?:\r?\n)+$/.exec(r2.text).index, n3 = r2.text.length;
        return e26.replaceTextRange([t3, n3], "");
      } }) : e25.report({ node: t2, loc: i2, messageId: "missing", fix: function(e26) {
        return e26.insertTextAfterRange([0, n2.length], s2 ? "\r".concat("\n") : "\n");
      } });
    }
  } };
} }, Iw = { meta: { type: "suggestion", docs: { description: "require the use of `===` and `!==`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/eqeqeq" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["always"] }, { type: "object", properties: { null: { enum: ["always", "never", "ignore"] } }, additionalProperties: false }], additionalItems: false }, { type: "array", items: [{ enum: ["smart", "allow-null"] }], additionalItems: false }] }, fixable: "code", messages: { unexpected: "Expected '{{expectedOperator}}' and instead saw '{{actualOperator}}'." } }, create: function(e25) {
  function t2(e26) {
    return e26.type === "UnaryExpression" && e26.operator === "typeof";
  }
  function r2(e26) {
    return t2(e26.left) || t2(e26.right);
  }
  function n2(e26) {
    return e26.left.type === "Literal" && e26.right.type === "Literal" && i(e26.left.value) == i(e26.right.value);
  }
  function a2(t3, i2) {
    var a3 = u2.getFirstTokenBetween(t3.left, t3.right, function(e26) {
      return e26.value === t3.operator;
    });
    e25.report({ node: t3, loc: a3.loc, messageId: "unexpected", data: { expectedOperator: i2, actualOperator: t3.operator }, fix: function(e26) {
      return r2(t3) || n2(t3) ? e26.replaceText(a3, i2) : null;
    } });
  }
  var o2 = e25.options[0] || "always", s2 = e25.options[1] || {}, u2 = e25.getSourceCode(), c2 = o2 === "always" ? s2.null || "always" : "ignore";
  return { BinaryExpression: function(e26) {
    var t3 = function(e27) {
      return LA.isNullLiteral(e27.right) || LA.isNullLiteral(e27.left);
    }(e26);
    return e26.operator !== "==" && e26.operator !== "!=" ? void (c2 === "never" && t3 && a2(e26, e26.operator.slice(0, -1))) : void (o2 === "smart" && (r2(e26) || n2(e26) || t3) || !(c2 === "always") && t3 || a2(e26, "".concat(e26.operator, "=")));
  } };
} }, Bw = { meta: { type: "layout", docs: { description: "require or disallow spacing between function identifiers and their invocations", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/func-call-spacing" }, fixable: "whitespace", schema: { anyOf: [{ type: "array", items: [{ enum: ["never"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["always"] }, { type: "object", properties: { allowNewlines: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] }, messages: { unexpected: "Unexpected newline between function name and paren.", missing: "Missing space between function name and paren." } }, create: function(e25) {
  function t2(t3, i3, o2) {
    var s2 = a2.slice(i3.range[1], o2.range[0]).replace(/\/\*(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\*\//g, ""), u2 = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/.test(s2), c2 = u2 && LA.LINEBREAK_MATCHER.test(s2);
    r2 && u2 ? e25.report({ node: t3, loc: i3.loc.start, messageId: "unexpected", fix: function(e26) {
      return c2 ? null : e26.removeRange([i3.range[1], o2.range[0]]);
    } }) : r2 || u2 ? !r2 && !n2 && c2 && e25.report({ node: t3, loc: i3.loc.start, messageId: "unexpected", fix: function(e26) {
      return e26.replaceTextRange([i3.range[1], o2.range[0]], " ");
    } }) : e25.report({ node: t3, loc: i3.loc.start, messageId: "missing", fix: function(e26) {
      return e26.insertTextBefore(o2, " ");
    } });
  }
  var r2 = e25.options[0] !== "always", n2 = !r2 && e25.options[1] && e25.options[1].allowNewlines, i2 = e25.getSourceCode(), a2 = i2.getText();
  return { "CallExpression, NewExpression": function(e26) {
    var r3 = i2.getLastToken(e26), n3 = i2.getLastToken(e26.callee), a3 = i2.getFirstTokenBetween(n3, r3, LA.isOpeningParenToken), o2 = a3 && i2.getTokenBefore(a3);
    a3 && a3.range[1] < e26.range[1] && t2(e26, o2, a3);
  }, ImportExpression: function(e26) {
    var r3 = i2.getFirstToken(e26);
    t2(e26, r3, i2.getTokenAfter(r3));
  } };
} };
function Ow(e25, t2) {
  return 6 <= t2 ? _A.keyword.isIdentifierES6(e25) : _A.keyword.isIdentifierES5(e25);
}
var Lw = { type: "object", properties: { considerPropertyDescriptor: { type: "boolean" }, includeCommonJSModuleExports: { type: "boolean" } }, additionalProperties: false }, Nw = { meta: { type: "suggestion", docs: { description: "require function names to match the name of the variable or property to which they are assigned", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/func-name-matching" }, schema: { anyOf: [{ type: "array", additionalItems: false, items: [{ enum: ["always", "never"] }, Lw] }, { type: "array", additionalItems: false, items: [Lw] }] }, messages: { matchProperty: "Function name `{{funcName}}` should match property name `{{name}}`.", matchVariable: "Function name `{{funcName}}` should match variable name `{{name}}`.", notMatchProperty: "Function name `{{funcName}}` should not match property name `{{name}}`.", notMatchVariable: "Function name `{{funcName}}` should not match variable name `{{name}}`." } }, create: function(e25) {
  function t2(e26, t3, r3) {
    return !!r3 && r3.type === "CallExpression" && r3.callee.type === "MemberExpression" && r3.callee.object.name === e26 && r3.callee.property.name === t3;
  }
  function r2(e26, t3) {
    return s2 === "always" && e26 !== t3 || s2 === "never" && e26 === t3;
  }
  function n2(t3, r3, n3, i2) {
    var a3;
    a3 = s2 === "always" && i2 ? "matchProperty" : s2 === "always" ? "matchVariable" : i2 ? "notMatchProperty" : "notMatchVariable", e25.report({ node: t3, messageId: a3, data: { name: r3, funcName: n3 } });
  }
  function a2(e26) {
    return e26.type === "Literal" && typeof e26.value == "string";
  }
  var o2 = (i(e25.options[0]) == "object" ? e25.options[0] : e25.options[1]) || {}, s2 = typeof e25.options[0] == "string" ? e25.options[0] : "always", u2 = o2.considerPropertyDescriptor, c2 = o2.includeCommonJSModuleExports, l2 = e25.parserOptions && e25.parserOptions.ecmaVersion ? e25.parserOptions.ecmaVersion : 5;
  return { VariableDeclarator: function(e26) {
    !e26.init || e26.init.type !== "FunctionExpression" || e26.id.type !== "Identifier" || e26.init.id && r2(e26.id.name, e26.init.id.name) && n2(e26, e26.id.name, e26.init.id.name, false);
  }, AssignmentExpression: function(e26) {
    if (!(e26.right.type !== "FunctionExpression" || e26.left.computed && e26.left.property.type !== "Literal" || !c2 && function(e27) {
      if (e27.type === "MemberExpression" && e27.object.type === "Identifier" && e27.object.name === "module") {
        if (e27.property.type === "Identifier" && e27.property.name === "exports")
          return true;
        if (e27.property.type === "Literal" && e27.property.value === "exports")
          return true;
      }
      return false;
    }(e26.left) || e26.left.type !== "Identifier" && e26.left.type !== "MemberExpression")) {
      var t3 = e26.left.type === "MemberExpression", i2 = t3 ? LA.getStaticPropertyName(e26.left) : e26.left.name;
      e26.right.id && Ow(i2) && r2(i2, e26.right.id.name) && n2(e26, i2, e26.right.id.name, t3);
    }
  }, Property: function(e26) {
    if (e26.value.type === "FunctionExpression" && e26.value.id && (!e26.computed || a2(e26.key))) {
      if (e26.key.type === "Identifier") {
        var i2 = e26.value.id.name, o3 = e26.key.name;
        if (u2 && o3 === "value")
          if (t2("Object", "defineProperty", e26.parent.parent) || t2("Reflect", "defineProperty", e26.parent.parent)) {
            var s3 = e26.parent.parent.arguments[1];
            a2(s3) && r2(s3.value, i2) && n2(e26, s3.value, i2, true);
          } else
            t2("Object", "defineProperties", e26.parent.parent.parent.parent) ? (o3 = e26.parent.parent.key.name, !e26.parent.parent.computed && r2(o3, i2) && n2(e26, o3, i2, true)) : t2("Object", "create", e26.parent.parent.parent.parent) ? (o3 = e26.parent.parent.key.name, !e26.parent.parent.computed && r2(o3, i2) && n2(e26, o3, i2, true)) : r2(o3, i2) && n2(e26, o3, i2, true);
        else
          r2(o3, i2) && n2(e26, o3, i2, true);
        return;
      }
      a2(e26.key) && Ow(e26.key.value, l2) && r2(e26.key.value, e26.value.id.name) && n2(e26, e26.key.value, e26.value.id.name, true);
    }
  } };
} };
var jw = { meta: { type: "suggestion", docs: { description: "require or disallow named `function` expressions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/func-names" }, schema: { definitions: { value: { enum: ["always", "as-needed", "never"] } }, items: [{ $ref: "#/definitions/value" }, { type: "object", properties: { generators: { $ref: "#/definitions/value" } }, additionalProperties: false }] }, messages: { unnamed: "Unexpected unnamed {{name}}.", named: "Unexpected named {{name}}." } }, create: function(e25) {
  function t2(e26) {
    var t3 = e26.parent;
    return t3.type === "MethodDefinition" || t3.type === "Property" && (t3.method || t3.kind === "get" || t3.kind === "set");
  }
  function r2(t3) {
    e25.report({ node: t3, messageId: "unnamed", loc: LA.getFunctionHeadLoc(t3, i2), data: { name: LA.getFunctionNameWithKind(t3) } });
  }
  function n2(t3) {
    e25.report({ node: t3, messageId: "named", loc: LA.getFunctionHeadLoc(t3, i2), data: { name: LA.getFunctionNameWithKind(t3) } });
  }
  var i2 = e25.getSourceCode();
  return { "FunctionExpression:exit": function(i3) {
    var a2 = e25.getDeclaredVariables(i3)[0];
    if (!(function(e26) {
      return e26 && e26.defs[0].type === "FunctionName";
    }(a2) && 0 < a2.references.length)) {
      var o2 = !(!i3.id || !i3.id.name), s2 = function(t3) {
        return t3.generator && 1 < e25.options.length && e25.options[1].generators ? e25.options[1].generators : e25.options[0] || "always";
      }(i3);
      s2 === "never" ? o2 && n2(i3) : s2 === "as-needed" ? !o2 && !function(e26) {
        var r3 = e26.parent;
        return t2(e26) || r3.type === "VariableDeclarator" && r3.id.type === "Identifier" && r3.init === e26 || r3.type === "Property" && r3.value === e26 || r3.type === "AssignmentExpression" && r3.left.type === "Identifier" && r3.right === e26 || r3.type === "ExportDefaultDeclaration" && r3.declaration === e26 || r3.type === "AssignmentPattern" && r3.right === e26;
      }(i3) && r2(i3) : !o2 && !t2(i3) && r2(i3);
    }
  } };
} }, Rw = { meta: { type: "layout", docs: { description: "enforce consistent line breaks inside function parentheses", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/function-paren-newline" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never", "consistent", "multiline", "multiline-arguments"] }, { type: "object", properties: { minItems: { type: "integer", minimum: 0 } }, additionalProperties: false }] }], messages: { expectedBefore: "Expected newline before ')'.", expectedAfter: "Expected newline after '('.", expectedBetween: "Expected newline between arguments/params.", unexpectedBefore: "Unexpected newline before ')'.", unexpectedAfter: "Unexpected newline after '('." } }, create: function(e25) {
  function t2(e26, t3) {
    return p2 && e26.length === 1 ? t3 : l2 || p2 ? e26.some(function(t4, r3) {
      return r3 !== e26.length - 1 && t4.loc.end.line !== e26[r3 + 1].loc.start.line;
    }) : f2 ? t3 : e26.length >= o2;
  }
  function r2(r3, n3) {
    var i2 = r3.leftParen, a3 = r3.rightParen, o3 = s2.getTokenAfter(i2), u2 = s2.getTokenBefore(a3), c3 = !LA.isTokenOnSameLine(i2, o3), l3 = !LA.isTokenOnSameLine(u2, a3), p3 = t2(n3, c3);
    c3 && !p3 ? e25.report({ node: i2, messageId: "unexpectedAfter", fix: function(e26) {
      return s2.getText().slice(i2.range[1], o3.range[0]).trim() ? null : e26.removeRange([i2.range[1], o3.range[0]]);
    } }) : !c3 && p3 && e25.report({ node: i2, messageId: "expectedAfter", fix: function(e26) {
      return e26.insertTextAfter(i2, "\n");
    } }), l3 && !p3 ? e25.report({ node: a3, messageId: "unexpectedBefore", fix: function(e26) {
      return s2.getText().slice(u2.range[1], a3.range[0]).trim() ? null : e26.removeRange([u2.range[1], a3.range[0]]);
    } }) : !l3 && p3 && e25.report({ node: a3, messageId: "expectedBefore", fix: function(e26) {
      return e26.insertTextBefore(a3, "\n");
    } });
  }
  function n2(r3, n3) {
    for (var i2 = r3.leftParen, a3 = s2.getTokenAfter(i2), o3 = !LA.isTokenOnSameLine(i2, a3), u2 = t2(n3, o3), c3 = function(t3) {
      var r4 = n3[t3], i3 = n3[t3 + 1];
      !(r4.loc.end.line !== i3.loc.start.line) && u2 && e25.report({ node: r4, messageId: "expectedBetween", fix: function(e26) {
        return e26.insertTextBefore(i3, "\n");
      } });
    }, l3 = 0; l3 <= n3.length - 2; l3++)
      c3(l3);
  }
  function a2(e26) {
    switch (e26.type) {
      case "NewExpression":
        if (!(e26.arguments.length || LA.isOpeningParenToken(s2.getLastToken(e26, { skip: 1 })) && LA.isClosingParenToken(s2.getLastToken(e26))))
          return null;
      case "CallExpression":
        return { leftParen: s2.getTokenAfter(e26.callee, LA.isOpeningParenToken), rightParen: s2.getLastToken(e26) };
      case "FunctionDeclaration":
      case "FunctionExpression":
        var t3 = s2.getFirstToken(e26, LA.isOpeningParenToken);
        return { leftParen: t3, rightParen: e26.params.length ? s2.getTokenAfter(e26.params[e26.params.length - 1], LA.isClosingParenToken) : s2.getTokenAfter(t3) };
      case "ArrowFunctionExpression":
        var r3 = s2.getFirstToken(e26);
        return LA.isOpeningParenToken(r3) ? { leftParen: r3, rightParen: s2.getTokenBefore(e26.body, LA.isClosingParenToken) } : null;
      case "ImportExpression":
        return { leftParen: s2.getFirstToken(e26, 1), rightParen: s2.getLastToken(e26) };
      default:
        throw new TypeError("unexpected node with type ".concat(e26.type));
    }
  }
  var o2, s2 = e25.getSourceCode(), c2 = e25.options[0] || "multiline", l2 = c2 === "multiline", p2 = c2 === "multiline-arguments", f2 = c2 === "consistent";
  return o2 = i(c2) == "object" ? c2.minItems : c2 === "always" ? 0 : c2 === "never" ? 1 / 0 : null, u({}, ["ArrowFunctionExpression", "CallExpression", "FunctionDeclaration", "FunctionExpression", "ImportExpression", "NewExpression"], function(e26) {
    var t3, i2 = a2(e26);
    t3 = e26.type === "ImportExpression" ? [e26.source] : LA.isFunction(e26) ? e26.params : e26.arguments, i2 && (r2(i2, t3), p2 && n2(i2, t3));
  });
} }, Mw = { oneOf: [{ enum: ["before", "after", "both", "neither"] }, { type: "object", properties: { before: { type: "boolean" }, after: { type: "boolean" } }, additionalProperties: false }] }, Vw = { meta: { type: "layout", docs: { description: "enforce consistent spacing around `*` operators in generator functions", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/generator-star-spacing" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["before", "after", "both", "neither"] }, { type: "object", properties: { before: { type: "boolean" }, after: { type: "boolean" }, named: Mw, anonymous: Mw, method: Mw }, additionalProperties: false }] }], messages: { missingBefore: "Missing space before *.", missingAfter: "Missing space after *.", unexpectedBefore: "Unexpected space before *.", unexpectedAfter: "Unexpected space after *." } }, create: function(e25) {
  function t2(e26, t3) {
    return e26 ? typeof e26 == "string" ? o2[e26] : Object.assign({}, t3, e26) : t3;
  }
  function r2(e26) {
    return e26.value === "*" && e26.type === "Punctuator";
  }
  function n2(e26) {
    return u2.getFirstToken(e26.parent.method || e26.parent.type === "MethodDefinition" ? e26.parent : e26, r2);
  }
  function i2(t3, r3, n3, i3) {
    if (!!(i3.range[0] - n3.range[1]) !== s2[t3][r3]) {
      var a3 = n3.value === "*", o3 = s2[t3][r3], u3 = a3 ? n3 : i3, c2 = "".concat(o3 ? "missing" : "unexpected").concat(function(e26) {
        return e26[0].toUpperCase() + e26.slice(1);
      }(r3));
      e25.report({ node: u3, messageId: c2, fix: function(e26) {
        return o3 ? a3 ? e26.insertTextAfter(u3, " ") : e26.insertTextBefore(u3, " ") : e26.removeRange([n3.range[1], i3.range[0]]);
      } });
    }
  }
  function a2(e26) {
    if (e26.generator) {
      var t3 = n2(e26), r3 = u2.getTokenBefore(t3), a3 = u2.getTokenAfter(t3), o3 = "named";
      e26.parent.type === "MethodDefinition" || e26.parent.type === "Property" && e26.parent.method ? o3 = "method" : !e26.id && (o3 = "anonymous"), o3 == "method" && t3 === u2.getFirstToken(e26.parent) || i2(o3, "before", r3, t3), i2(o3, "after", t3, a3);
    }
  }
  var o2 = { before: { before: true, after: false }, after: { before: false, after: true }, both: { before: true, after: true }, neither: { before: false, after: false } }, s2 = function(e26) {
    var r3 = t2(e26, o2.before);
    return { named: t2(e26.named, r3), anonymous: t2(e26.anonymous, r3), method: t2(e26.method, r3) };
  }(e25.options[0] || {}), u2 = e25.getSourceCode();
  return { FunctionDeclaration: a2, FunctionExpression: a2 };
} }, Uw = /^(?:Arrow)?FunctionExpression$/;
function qw(e25) {
  return e25.reachable;
}
function Ww(e25) {
  return e25.id || e25;
}
var $w = { meta: { type: "problem", docs: { description: "enforce `return` statements in getters", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/getter-return" }, fixable: null, schema: [{ type: "object", properties: { allowImplicit: { type: "boolean", default: false } }, additionalProperties: false }], messages: { expected: "Expected to return a value in {{name}}.", expectedAlways: "Expected {{name}} to always return a value." } }, create: function(e25) {
  function t2(t3) {
    i2.shouldCheck && i2.codePath.currentSegments.some(qw) && e25.report({ node: t3, loc: Ww(t3).loc.start, messageId: i2.hasReturn ? "expectedAlways" : "expected", data: { name: LA.getFunctionNameWithKind(i2.node) } });
  }
  function r2(e26) {
    var t3 = e26.parent;
    if (Uw.test(e26.type) && e26.body.type === "BlockStatement") {
      if (t3.kind === "get")
        return true;
      if (t3.type === "Property" && LA.getStaticPropertyName(t3) === "get" && t3.parent.type === "ObjectExpression") {
        if (t3.parent.parent.type === "CallExpression" && LA.getStaticPropertyName(t3.parent.parent.callee) === "defineProperty")
          return true;
        if (t3.parent.parent.type === "Property" && t3.parent.parent.parent.type === "ObjectExpression" && t3.parent.parent.parent.parent.type === "CallExpression" && LA.getStaticPropertyName(t3.parent.parent.parent.parent.callee) === "defineProperties")
          return true;
      }
    }
    return false;
  }
  var n2 = e25.options[0] || { allowImplicit: false }, i2 = { upper: null, codePath: null, hasReturn: false, shouldCheck: false, node: null };
  return { onCodePathStart: function(e26, t3) {
    i2 = { upper: i2, codePath: e26, hasReturn: false, shouldCheck: r2(t3), node: t3 };
  }, onCodePathEnd: function() {
    i2 = i2.upper;
  }, ReturnStatement: function(t3) {
    i2.shouldCheck && (i2.hasReturn = true, !n2.allowImplicit && !t3.argument && e25.report({ node: t3, messageId: "expected", data: { name: LA.getFunctionNameWithKind(i2.node) } }));
  }, "FunctionExpression:exit": t2, "ArrowFunctionExpression:exit": t2 };
} }, Gw = ["AssignmentExpression", "VariableDeclarator", "MemberExpression", "ExpressionStatement", "CallExpression", "ConditionalExpression", "Program", "VariableDeclaration"];
var zw = { meta: { type: "suggestion", docs: { description: "require `require()` calls to be placed at top-level module scope", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/global-require" }, schema: [], messages: { unexpected: "Unexpected require()." } }, create: function(e25) {
  return { CallExpression: function(t2) {
    var r2 = e25.getScope();
    t2.callee.name !== "require" || function(e26, t3) {
      var r3 = function(e27, t4) {
        var r4 = e27.references.filter(function(e28) {
          return e28.identifier.range[0] === t4.range[0] && e28.identifier.range[1] === t4.range[1];
        });
        return r4.length === 1 ? r4[0] : null;
      }(e26, t3);
      return r3 && r3.resolved && 0 < r3.resolved.defs.length;
    }(r2, t2.callee) || (e25.getAncestors().every(function(e26) {
      return -1 < Gw.indexOf(e26.type);
    }) || e25.report({ node: t2, messageId: "unexpected" }));
  } };
} };
function Hw(e25) {
  return e25.kind === "get" || e25.kind === "set";
}
var Kw = { meta: { type: "suggestion", docs: { description: "require grouped accessor pairs in object literals and classes", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/grouped-accessor-pairs" }, schema: [{ enum: ["anyOrder", "getBeforeSet", "setBeforeGet"] }], messages: { notGrouped: "Accessor pair {{ formerName }} and {{ latterName }} should be grouped.", invalidOrder: "Expected {{ latterName }} to be before {{ formerName }}." } }, create: function(e25) {
  function t2(t3, r3, n3) {
    e25.report({ node: n3, messageId: t3, loc: LA.getFunctionHeadLoc(n3.value, o2), data: { formerName: LA.getFunctionNameWithKind(r3.value), latterName: LA.getFunctionNameWithKind(n3.value) } });
  }
  function r2(e26) {
    var t3 = LA.getStaticPropertyName(e26);
    return { key: t3 === null ? o2.getTokens(e26.key) : t3, getters: e26.kind === "get" ? [e26] : [], setters: e26.kind === "set" ? [e26] : [] };
  }
  function n2(e26, t3) {
    var r3, n3, i3 = e26.find(function(e27) {
      return function(e28, t4) {
        return typeof e28 == "string" && typeof t4 == "string" ? e28 == t4 : !(!Array.isArray(e28) || !Array.isArray(t4)) && function(e29, t5) {
          if (e29.length !== t5.length)
            return false;
          for (var r4 = 0; r4 < e29.length; r4++) {
            var n4 = e29[r4], i4 = t5[r4];
            if (n4.type !== i4.type || n4.value !== i4.value)
              return false;
          }
          return true;
        }(e28, t4);
      }(e27.key, t3.key);
    });
    return i3 ? ((r3 = i3.getters).push.apply(r3, E(t3.getters)), (n3 = i3.setters).push.apply(n3, E(t3.setters))) : e26.push(t3), e26;
  }
  function i2(e26, i3) {
    var o3 = e26.filter(i3).filter(Hw).map(r2).reduce(n2, []), s2 = true, u2 = false, c2 = void 0;
    try {
      for (var l2, p2 = o3[Symbol.iterator](); !(s2 = (l2 = p2.next()).done); s2 = true) {
        var f2 = l2.value, h2 = f2.getters, d2 = f2.setters;
        if (h2.length === 1 && d2.length === 1) {
          var m2 = b(h2, 1)[0], g2 = b(d2, 1)[0], y2 = e26.indexOf(m2), v2 = e26.indexOf(g2), x2 = y2 < v2 ? m2 : g2, E2 = y2 < v2 ? g2 : m2;
          1 < Math.abs(y2 - v2) ? t2("notGrouped", x2, E2) : (a2 === "getBeforeSet" && y2 > v2 || a2 === "setBeforeGet" && y2 < v2) && t2("invalidOrder", x2, E2);
        }
      }
    } catch (e27) {
      u2 = true, c2 = e27;
    } finally {
      try {
        s2 || p2.return == null || p2.return();
      } finally {
        if (u2)
          throw c2;
      }
    }
  }
  var a2 = e25.options[0] || "anyOrder", o2 = e25.getSourceCode();
  return { ObjectExpression: function(e26) {
    i2(e26.properties, function(e27) {
      return e27.type === "Property";
    });
  }, ClassBody: function(e26) {
    i2(e26.body, function(e27) {
      return e27.type === "MethodDefinition" && !e27.static;
    }), i2(e26.body, function(e27) {
      return e27.type === "MethodDefinition" && e27.static;
    });
  } };
} }, Jw = { meta: { type: "suggestion", docs: { description: "require error handling in callbacks", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/handle-callback-err" }, schema: [{ type: "string" }], messages: { expected: "Expected error to be handled." } }, create: function(e25) {
  function t2(e26) {
    return function(e27) {
      return e27[0] === "^";
    }(n2) ? new RegExp(n2, "u").test(e26) : e26 === n2;
  }
  function r2(r3) {
    var n3 = function(e26) {
      return e26.variables.filter(function(e27) {
        return e27.defs[0] && e27.defs[0].type === "Parameter";
      });
    }(e25.getScope())[0];
    n3 && t2(n3.name) && n3.references.length === 0 && e25.report({ node: r3, messageId: "expected" });
  }
  var n2 = e25.options[0] || "err";
  return { FunctionDeclaration: r2, FunctionExpression: r2, ArrowFunctionExpression: r2 };
} }, Qw = { meta: { type: "suggestion", docs: { description: "require identifiers to match a specified regular expression", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/id-match" }, schema: [{ type: "string" }, { type: "object", properties: { properties: { type: "boolean", default: false }, onlyDeclarations: { type: "boolean", default: false }, ignoreDestructuring: { type: "boolean", default: false } } }], messages: { notMatch: "Identifier '{{name}}' does not match the pattern '{{pattern}}'." } }, create: function(e25) {
  function t2(e26) {
    return !a2.test(e26);
  }
  function r2(e26, r3) {
    return (!u2 || f2.has(e26.type)) && !p2.has(e26.type) && t2(r3);
  }
  function n2(t3) {
    l2.has(t3) || (e25.report({ node: t3, messageId: "notMatch", data: { name: t3.name, pattern: i2 } }), l2.set(t3, true));
  }
  var i2 = e25.options[0] || "^.+$", a2 = new RegExp(i2, "u"), o2 = e25.options[1] || {}, s2 = !!o2.properties, u2 = !!o2.onlyDeclarations, c2 = !!o2.ignoreDestructuring, l2 = new Map(), p2 = new Set(["CallExpression", "NewExpression"]), f2 = new Set(["FunctionDeclaration", "VariableDeclarator"]), h2 = new Set(["ImportSpecifier", "ImportNamespaceSpecifier", "ImportDefaultSpecifier"]);
  return { Identifier: function(e26) {
    var i3 = e26.name, a3 = e26.parent, o3 = a3.type === "MemberExpression" ? a3.parent : a3;
    if (a3.type === "MemberExpression") {
      if (!s2)
        return;
      a3.object.type === "Identifier" && a3.object.name === i3 ? t2(i3) && n2(e26) : o3.type === "AssignmentExpression" && o3.left.type === "MemberExpression" && o3.left.property.name === e26.name ? t2(i3) && n2(e26) : o3.type === "AssignmentExpression" && o3.right.type !== "MemberExpression" && t2(i3) && n2(e26);
    } else if (a3.type === "Property" || a3.type === "AssignmentPattern") {
      if (a3.parent && a3.parent.type === "ObjectPattern") {
        a3.shorthand && a3.value.left && t2(i3) && n2(e26);
        var u3 = a3.key.name === a3.value.name;
        if (!u3 && a3.key === e26)
          return;
        a3.value.name && t2(i3) && (!u3 || !c2) && n2(e26);
      }
      if (!s2 || c2 && function(e27) {
        for (var t3 = e27.parent; t3; ) {
          if (t3.type === "ObjectPattern")
            return true;
          t3 = t3.parent;
        }
        return false;
      }(e26))
        return;
      a3.right !== e26 && r2(o3, i3) && n2(e26);
    } else
      h2.has(a3.type) ? a3.local && a3.local.name === e26.name && t2(i3) && n2(e26) : r2(o3, i3) && n2(e26);
  } };
} }, Xw = LA.isCommentToken, Yw = LA.isNotOpeningParenToken, Zw = { meta: { type: "layout", docs: { description: "enforce the location of arrow function bodies", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/implicit-arrow-linebreak" }, fixable: "whitespace", schema: [{ enum: ["beside", "below"] }], messages: { expected: "Expected a linebreak before this expression.", unexpected: "Expected no linebreak before this expression." } }, create: function(e25) {
  function t2(t3) {
    if (t3.body.type !== "BlockStatement") {
      var i2 = r2.getTokenBefore(t3.body, Yw), a2 = r2.getTokenAfter(i2);
      i2.loc.end.line === a2.loc.start.line && n2 === "below" ? e25.report({ node: a2, messageId: "expected", fix: function(e26) {
        return e26.insertTextBefore(a2, "\n");
      } }) : i2.loc.end.line !== a2.loc.start.line && n2 === "beside" && e25.report({ node: a2, messageId: "unexpected", fix: function(e26) {
        return r2.getFirstTokenBetween(i2, a2, { includeComments: true, filter: Xw }) ? null : e26.replaceTextRange([i2.range[1], a2.range[0]], " ");
      } });
    }
  }
  var r2 = e25.getSourceCode(), n2 = e25.options[0] || "beside";
  return { ArrowFunctionExpression: function(e26) {
    return t2(e26);
  } };
} }, e_ = { meta: { type: "layout", docs: { description: "enforce consistent indentation", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/indent-legacy" }, deprecated: true, replacedBy: ["indent"], fixable: "whitespace", schema: [{ oneOf: [{ enum: ["tab"] }, { type: "integer", minimum: 0 }] }, { type: "object", properties: { SwitchCase: { type: "integer", minimum: 0 }, VariableDeclarator: { oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { var: { type: "integer", minimum: 0 }, let: { type: "integer", minimum: 0 }, const: { type: "integer", minimum: 0 } } }] }, outerIIFEBody: { type: "integer", minimum: 0 }, MemberExpression: { type: "integer", minimum: 0 }, FunctionDeclaration: { type: "object", properties: { parameters: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] }, body: { type: "integer", minimum: 0 } } }, FunctionExpression: { type: "object", properties: { parameters: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] }, body: { type: "integer", minimum: 0 } } }, CallExpression: { type: "object", properties: { parameters: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] } } }, ArrayExpression: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] }, ObjectExpression: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first"] }] } }, additionalProperties: false }], messages: { expected: "Expected indentation of {{expected}} but found {{actual}}." } }, create: function(e25) {
  function t2(e26, t3, r3) {
    var n3 = "".concat(e26, " ").concat(x2).concat(e26 === 1 ? "" : "s"), i2 = "space".concat(t3 === 1 ? "" : "s"), a3 = "tab".concat(r3 === 1 ? "" : "s");
    return { expected: n3, actual: 0 < t3 && 0 < r3 ? "".concat(t3, " ").concat(i2, " and ").concat(r3, " ").concat(a3) : 0 < t3 ? x2 === "space" ? t3 : "".concat(t3, " ").concat(i2) : 0 < r3 ? x2 === "tab" ? r3 : "".concat(r3, " ").concat(a3) : "0" };
  }
  function r2(r3, n3, i2, a3, o3, s3) {
    if (!i2 || !a3) {
      var u3 = (x2 === "space" ? " " : "	").repeat(n3), c3 = s3 ? [r3.range[1] - r3.loc.end.column, r3.range[1] - r3.loc.end.column + i2 + a3] : [r3.range[0] - r3.loc.start.column, r3.range[0] - r3.loc.start.column + i2 + a3];
      e25.report({ node: r3, loc: o3, messageId: "expected", data: t2(n3, i2, a3), fix: function(e26) {
        return e26.replaceTextRange(c3, u3);
      } });
    }
  }
  function n2(e26, t3) {
    var r3 = t3 ? C2.getLastToken(e26) : C2.getFirstToken(e26), n3 = C2.getText(r3, r3.loc.start.column).split(""), i2 = n3.slice(0, n3.findIndex(function(e27) {
      return e27 !== " " && e27 !== "	";
    })), a3 = i2.filter(function(e27) {
      return e27 === " ";
    }).length, o3 = i2.filter(function(e27) {
      return e27 === "	";
    }).length;
    return { space: a3, tab: o3, goodChar: x2 === "space" ? a3 : o3, badChar: x2 === "space" ? o3 : a3 };
  }
  function a2(e26, t3) {
    var r3 = t3 === true ? C2.getLastToken(e26, 1) : C2.getTokenBefore(e26);
    return (t3 === true ? e26.loc.end.line : e26.loc.start.line) !== (r3 ? r3.loc.end.line : -1);
  }
  function o2(e26, t3) {
    var i2 = n2(e26, false);
    (e26.type !== "ArrayExpression" && e26.type !== "ObjectExpression" && (i2.goodChar !== t3 || i2.badChar !== 0) && a2(e26) && r2(e26, t3, i2.space, i2.tab), e26.type === "IfStatement" && e26.alternate) && (o2(C2.getTokenBefore(e26.alternate), t3), a2(e26.alternate) || o2(e26.alternate, t3));
    e26.type === "TryStatement" && e26.handler && o2(C2.getFirstToken(e26.handler), t3);
    e26.type === "TryStatement" && e26.finalizer && o2(C2.getTokenBefore(e26.finalizer), t3);
    e26.type === "DoWhileStatement" && o2(C2.getTokenAfter(e26.body), t3);
  }
  function s2(e26, t3) {
    e26.forEach(function(e27) {
      return o2(e27, t3);
    });
  }
  function u2(e26, t3) {
    var i2 = C2.getLastToken(e26), o3 = n2(i2, true);
    (o3.goodChar !== t3 || o3.badChar !== 0) && a2(e26, true) && r2(e26, t3, o3.space, o3.tab, { line: i2.loc.start.line, column: i2.loc.start.column }, true);
  }
  function c2(e26, t3) {
    var i2 = n2(e26, false);
    (i2.goodChar !== t3 || i2.badChar !== 0) && a2(e26) && r2(e26, t3, i2.space, i2.tab, { line: e26.loc.start.line, column: e26.loc.start.column });
  }
  function l2(e26, t3, r3) {
    for (var n3 = e26.parent, i2 = new Set(r3 || ["Program"]); n3.type !== t3 && !i2.has(n3.type) && n3.type !== "Program"; )
      n3 = n3.parent;
    return n3.type === t3 ? n3 : null;
  }
  function p2(e26) {
    return l2(e26, "VariableDeclarator");
  }
  function f2(e26, t3) {
    return t3 && t3.parent.loc.start.line === e26.loc.start.line && 1 < t3.parent.declarations.length;
  }
  function h2(e26) {
    var t3 = C2.getLastToken(e26);
    return e26.loc.start.line === t3.loc.end.line;
  }
  function d2(e26) {
    if (!h2(e26)) {
      var t3, r3, i2 = e26.type === "ArrayExpression" ? e26.elements : e26.properties;
      i2 = i2.filter(function(e27) {
        return e27 !== null;
      });
      var o3 = p2(e26);
      if (a2(e26)) {
        var l3 = e26.parent;
        if (t3 = n2(l3).goodChar, o3 && o3.loc.start.line === e26.loc.start.line)
          o3 || function(e27) {
            return !(e27.type !== "ArrayExpression" || !e27.elements[0]) && e27.elements[0].loc.start.line === e27.loc.start.line && e27.elements[0].type === "ObjectExpression";
          }(l3) || l3.type === "MemberExpression" || l3.type === "ExpressionStatement" || l3.type === "AssignmentExpression" || l3.type === "Property" || (t3 += b2);
        else if (l3.type !== "VariableDeclarator" || o3 === o3.parent.declarations[0])
          if (l3.type === "VariableDeclarator" && o3.loc.start.line === l3.loc.start.line)
            t3 += b2 * E2.VariableDeclarator[o3.parent.kind];
          else if (l3.type === "ObjectExpression" || l3.type === "ArrayExpression") {
            var d3 = e26.parent.type === "ObjectExpression" ? e26.parent.properties : e26.parent.elements;
            d3[0] && d3[0].loc.start.line === l3.loc.start.line && d3[0].loc.end.line !== l3.loc.start.line || (typeof E2[l3.type] == "number" ? t3 += E2[l3.type] * b2 : t3 = d3[0].loc.start.column);
          } else
            l3.type === "CallExpression" || l3.type === "NewExpression" ? typeof E2.CallExpression.arguments == "number" ? t3 += E2.CallExpression.arguments * b2 : E2.CallExpression.arguments === "first" ? l3.arguments.indexOf(e26) !== -1 && (t3 = l3.arguments[0].loc.start.column) : t3 += b2 : (l3.type === "LogicalExpression" || l3.type === "ArrowFunctionExpression") && (t3 += b2);
        c2(e26, t3);
      } else
        t3 = n2(e26).goodChar;
      r3 = E2[e26.type] === "first" ? i2.length ? i2[0].loc.start.column : 0 : t3 + b2 * E2[e26.type], f2(e26, o3) && (r3 += b2 * E2.VariableDeclarator[o3.parent.kind]), s2(i2, r3), 0 < i2.length && i2[i2.length - 1].loc.end.line === e26.loc.end.line || u2(e26, t3 + (f2(e26, o3) ? E2.VariableDeclarator[o3.parent.kind] * b2 : 0));
    }
  }
  function m2(e26) {
    if (!h2(e26))
      if (!e26.parent || e26.parent.type !== "FunctionExpression" && e26.parent.type !== "FunctionDeclaration" && e26.parent.type !== "ArrowFunctionExpression") {
        var t3, r3;
        r3 = e26.parent && ["IfStatement", "WhileStatement", "ForStatement", "ForInStatement", "ForOfStatement", "DoWhileStatement", "ClassDeclaration", "TryStatement"].indexOf(e26.parent.type) !== -1 && function(e27) {
          return e27.type === "BlockStatement" || e27.type === "ClassBody" || e27.body && e27.body.type === "BlockStatement" || e27.consequent && e27.consequent.type === "BlockStatement";
        }(e26) ? n2(e26.parent).goodChar : e26.parent && e26.parent.type === "CatchClause" ? n2(e26.parent.parent).goodChar : n2(e26).goodChar, 0 < (t3 = e26.type === "IfStatement" && e26.consequent.type !== "BlockStatement" ? [e26.consequent] : Array.isArray(e26.body) ? e26.body : [e26.body]).length && s2(t3, r3 + b2), e26.type === "BlockStatement" && u2(e26, r3);
      } else
        !function(e27) {
          var t4, r4 = e27.parent;
          if (t4 = !r4.parent || r4.parent.type !== "Property" && r4.parent.type !== "ArrayExpression" ? n2(r4).goodChar : n2(r4, false).goodChar, r4.parent.type === "CallExpression") {
            var i2 = r4.parent;
            r4.type !== "FunctionExpression" && r4.type !== "ArrowFunctionExpression" ? i2 && i2.loc.start.line < e27.loc.start.line && (t4 = n2(i2).goodChar) : function(e28) {
              var t5 = e28.parent;
              return !!(2 <= t5.arguments.length && t5.arguments[1] === e28) && t5.arguments[0].loc.end.line > t5.arguments[0].loc.start.line;
            }(r4) && i2.callee.loc.start.line === i2.callee.loc.end.line && !a2(r4) && (t4 = n2(i2).goodChar);
          }
          var o3 = b2;
          E2.outerIIFEBody !== null && function(e28) {
            var t5 = e28.parent, r5 = t5.parent;
            if (t5.type !== "CallExpression" || t5.callee !== e28)
              return false;
            for (; r5.type === "UnaryExpression" && (r5.operator === "!" || r5.operator === "~" || r5.operator === "+" || r5.operator === "-") || r5.type === "AssignmentExpression" || r5.type === "LogicalExpression" || r5.type === "SequenceExpression" || r5.type === "VariableDeclarator"; )
              r5 = r5.parent;
            return (r5.type === "ExpressionStatement" || r5.type === "VariableDeclaration") && r5.parent && r5.parent.type === "Program";
          }(r4) ? o3 = E2.outerIIFEBody * b2 : r4.type === "FunctionExpression" ? o3 = E2.FunctionExpression.body * b2 : r4.type === "FunctionDeclaration" && (o3 = E2.FunctionDeclaration.body * b2), t4 += o3;
          var c3 = p2(e27);
          c3 && f2(e27, c3) && (t4 += b2 * E2.VariableDeclarator[c3.parent.kind]), 0 < e27.body.length && s2(e27.body, t4), u2(e27, t4 - o3);
        }(e26);
  }
  function g2(e26) {
    e26.body.type !== "BlockStatement" && m2(e26);
  }
  function y2(e26, t3) {
    var r3, i2 = e26.type === "SwitchStatement" ? e26 : e26.parent, a3 = t3 === void 0 ? n2(i2).goodChar : t3;
    return D2[i2.loc.start.line] ? D2[i2.loc.start.line] : (r3 = 0 < i2.cases.length && E2.SwitchCase === 0 ? a3 : a3 + b2 * E2.SwitchCase, D2[i2.loc.start.line] = r3, r3);
  }
  var v2 = null, x2 = "space", b2 = 4, E2 = { SwitchCase: 0, VariableDeclarator: { var: 1, let: 1, const: 1 }, outerIIFEBody: null, FunctionDeclaration: { parameters: v2, body: 1 }, FunctionExpression: { parameters: v2, body: 1 }, CallExpression: { arguments: v2 }, ArrayExpression: 1, ObjectExpression: 1 }, C2 = e25.getSourceCode();
  if (e25.options.length && (e25.options[0] === "tab" ? (b2 = 1, x2 = "tab") : typeof e25.options[0] == "number" && (b2 = e25.options[0], x2 = "space"), e25.options[1])) {
    var S2 = e25.options[1];
    E2.SwitchCase = S2.SwitchCase || 0;
    var k2 = S2.VariableDeclarator;
    typeof k2 == "number" ? E2.VariableDeclarator = { var: k2, let: k2, const: k2 } : i(k2) == "object" && Object.assign(E2.VariableDeclarator, k2), typeof S2.outerIIFEBody == "number" && (E2.outerIIFEBody = S2.outerIIFEBody), typeof S2.MemberExpression == "number" && (E2.MemberExpression = S2.MemberExpression), i(S2.FunctionDeclaration) == "object" && Object.assign(E2.FunctionDeclaration, S2.FunctionDeclaration), i(S2.FunctionExpression) == "object" && Object.assign(E2.FunctionExpression, S2.FunctionExpression), i(S2.CallExpression) == "object" && Object.assign(E2.CallExpression, S2.CallExpression), (typeof S2.ArrayExpression == "number" || typeof S2.ArrayExpression == "string") && (E2.ArrayExpression = S2.ArrayExpression), (typeof S2.ObjectExpression == "number" || typeof S2.ObjectExpression == "string") && (E2.ObjectExpression = S2.ObjectExpression);
  }
  var D2 = {};
  return { Program: function(e26) {
    0 < e26.body.length && s2(e26.body, n2(e26).goodChar);
  }, ClassBody: m2, BlockStatement: m2, WhileStatement: g2, ForStatement: g2, ForInStatement: g2, ForOfStatement: g2, DoWhileStatement: g2, IfStatement: function(e26) {
    e26.consequent.type !== "BlockStatement" && e26.consequent.loc.start.line > e26.loc.start.line && m2(e26);
  }, VariableDeclaration: function(e26) {
    e26.declarations[e26.declarations.length - 1].loc.start.line > e26.declarations[0].loc.start.line && function(e27) {
      var t3 = function(e28) {
        return e28.declarations.reduce(function(t4, r4) {
          var n3 = t4[t4.length - 1];
          return (r4.loc.start.line !== e28.loc.start.line && !n3 || n3 && n3.loc.start.line !== r4.loc.start.line) && t4.push(r4), t4;
        }, []);
      }(e27), r3 = n2(e27).goodChar, i2 = t3[t3.length - 1], a3 = r3 + b2 * E2.VariableDeclarator[e27.kind];
      if (s2(t3, a3), !(C2.getLastToken(e27).loc.end.line <= i2.loc.end.line)) {
        var o3 = C2.getTokenBefore(i2);
        o3.value === "," ? u2(e27, n2(o3).goodChar) : u2(e27, a3 - b2);
      }
    }(e26);
  }, ObjectExpression: function(e26) {
    d2(e26);
  }, ArrayExpression: function(e26) {
    d2(e26);
  }, MemberExpression: function(e26) {
    if (E2.MemberExpression !== void 0 && !h2(e26) && !l2(e26, "VariableDeclarator", ["FunctionExpression", "ArrowFunctionExpression"]) && !l2(e26, "AssignmentExpression", ["FunctionExpression"])) {
      var t3 = n2(e26).goodChar + b2 * E2.MemberExpression, r3 = [e26.property], i2 = C2.getTokenBefore(e26.property);
      i2.type === "Punctuator" && i2.value === "." && r3.push(i2), s2(r3, t3);
    }
  }, SwitchStatement: function(e26) {
    var t3 = n2(e26).goodChar, r3 = y2(e26, t3);
    s2(e26.cases, r3), u2(e26, t3);
  }, SwitchCase: function(e26) {
    if (!h2(e26)) {
      var t3 = y2(e26);
      s2(e26.consequent, t3 + b2);
    }
  }, FunctionDeclaration: function(e26) {
    h2(e26) || (E2.FunctionDeclaration.parameters === "first" && e26.params.length ? s2(e26.params.slice(1), e26.params[0].loc.start.column) : E2.FunctionDeclaration.parameters !== null && s2(e26.params, n2(e26).goodChar + b2 * E2.FunctionDeclaration.parameters));
  }, FunctionExpression: function(e26) {
    h2(e26) || (E2.FunctionExpression.parameters === "first" && e26.params.length ? s2(e26.params.slice(1), e26.params[0].loc.start.column) : E2.FunctionExpression.parameters !== null && s2(e26.params, n2(e26).goodChar + b2 * E2.FunctionExpression.parameters));
  }, ReturnStatement: function(e26) {
    if (!h2(e26)) {
      var t3 = n2(e26).goodChar;
      !function(e27) {
        var t4 = C2.getText(e27).replace(C2.getText(e27.argument), "");
        return /^return[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*?\([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*?\);*?/.test(t4);
      }(e26) ? o2(e26, t3) : function(e27, t4) {
        var i2 = C2.getLastToken(e27, LA.isClosingParenToken);
        if (!C2.getText(i2, i2.loc.start.column).slice(0, -1).trim()) {
          var a3 = n2(i2, true);
          a3.goodChar !== t4 && r2(e27, t4, a3.space, a3.tab, { line: i2.loc.start.line, column: i2.loc.start.column }, true);
        }
      }(e26, t3);
    }
  }, CallExpression: function(e26) {
    h2(e26) || (E2.CallExpression.arguments === "first" && e26.arguments.length ? s2(e26.arguments.slice(1), e26.arguments[0].loc.start.column) : E2.CallExpression.arguments !== null && s2(e26.arguments, n2(e26).goodChar + b2 * E2.CallExpression.arguments));
  } };
} }, t_ = new Set(["AssignmentExpression", "AssignmentPattern", "ArrayExpression", "ArrayPattern", "ArrowFunctionExpression", "AwaitExpression", "BlockStatement", "BinaryExpression", "BreakStatement", "CallExpression", "CatchClause", "ClassBody", "ClassDeclaration", "ClassExpression", "ConditionalExpression", "ContinueStatement", "DoWhileStatement", "DebuggerStatement", "EmptyStatement", "ExperimentalRestProperty", "ExperimentalSpreadProperty", "ExpressionStatement", "ForStatement", "ForInStatement", "ForOfStatement", "FunctionDeclaration", "FunctionExpression", "Identifier", "IfStatement", "Literal", "LabeledStatement", "LogicalExpression", "MemberExpression", "MetaProperty", "MethodDefinition", "NewExpression", "ObjectExpression", "ObjectPattern", "Program", "Property", "RestElement", "ReturnStatement", "SequenceExpression", "SpreadElement", "Super", "SwitchCase", "SwitchStatement", "TaggedTemplateExpression", "TemplateElement", "TemplateLiteral", "ThisExpression", "ThrowStatement", "TryStatement", "UnaryExpression", "UpdateExpression", "VariableDeclaration", "VariableDeclarator", "WhileStatement", "WithStatement", "YieldExpression", "JSXFragment", "JSXOpeningFragment", "JSXClosingFragment", "JSXIdentifier", "JSXNamespacedName", "JSXMemberExpression", "JSXEmptyExpression", "JSXExpressionContainer", "JSXElement", "JSXClosingElement", "JSXOpeningElement", "JSXAttribute", "JSXSpreadAttribute", "JSXText", "ExportDefaultDeclaration", "ExportNamedDeclaration", "ExportAllDeclaration", "ExportSpecifier", "ImportDeclaration", "ImportSpecifier", "ImportDefaultSpecifier", "ImportNamespaceSpecifier", "ImportExpression"]), r_ = function() {
  function e25() {
    a(this, e25), this._rbTree = TA();
  }
  return s(e25, [{ key: "insert", value: function(e26, t2) {
    var r2 = this._rbTree.find(e26);
    this._rbTree = r2.valid ? r2.update(t2) : this._rbTree.insert(e26, t2);
  } }, { key: "findLe", value: function(e26) {
    var t2 = this._rbTree.le(e26);
    return t2 && { key: t2.key, value: t2.value };
  } }, { key: "deleteRange", value: function(e26, t2) {
    if (e26 !== t2)
      for (var r2 = this._rbTree.ge(e26); r2.valid && r2.key < t2; )
        this._rbTree = this._rbTree.remove(r2.key), r2.next();
  } }]), e25;
}(), n_ = function() {
  function e25(t2) {
    a(this, e25), this.sourceCode = t2, this.firstTokensByLineNumber = t2.tokensAndComments.reduce(function(e26, r2) {
      return e26.has(r2.loc.start.line) || e26.set(r2.loc.start.line, r2), !e26.has(r2.loc.end.line) && t2.text.slice(r2.range[1] - r2.loc.end.column, r2.range[1]).trim() && e26.set(r2.loc.end.line, r2), e26;
    }, new Map());
  }
  return s(e25, [{ key: "getFirstTokenOfLine", value: function(e26) {
    return this.firstTokensByLineNumber.get(e26.loc.start.line);
  } }, { key: "isFirstTokenOfLine", value: function(e26) {
    return this.getFirstTokenOfLine(e26) === e26;
  } }, { key: "getTokenIndent", value: function(e26) {
    return this.sourceCode.text.slice(e26.range[0] - e26.loc.start.column, e26.range[0]);
  } }]), e25;
}(), i_ = function() {
  function e25(t2, r2, n2) {
    a(this, e25), this._tokenInfo = t2, this._indentSize = r2, this._indentType = n2, this._tree = new r_(), this._tree.insert(0, { offset: 0, from: null, force: false }), this._lockedFirstTokens = new WeakMap(), this._desiredIndentCache = new WeakMap(), this._ignoredTokens = new WeakSet();
  }
  return s(e25, [{ key: "_getOffsetDescriptor", value: function(e26) {
    return this._tree.findLe(e26.range[0]).value;
  } }, { key: "matchOffsetOf", value: function(e26, t2) {
    this._lockedFirstTokens.set(t2, e26);
  } }, { key: "setDesiredOffset", value: function(e26, t2, r2) {
    return this.setDesiredOffsets(e26.range, t2, r2);
  } }, { key: "setDesiredOffsets", value: function(e26, t2, r2, n2) {
    var i2 = { offset: r2, from: t2, force: n2 }, a2 = this._tree.findLe(e26[1]).value, o2 = t2 && t2.range[0] >= e26[0] && t2.range[1] <= e26[1], s2 = o2 && this._getOffsetDescriptor(t2);
    this._tree.deleteRange(e26[0] + 1, e26[1]), this._tree.insert(e26[0], i2), o2 && (this._tree.insert(t2.range[0], s2), this._tree.insert(t2.range[1], i2)), this._tree.insert(e26[1], a2);
  } }, { key: "getDesiredIndent", value: function(e26) {
    if (!this._desiredIndentCache.has(e26))
      if (this._ignoredTokens.has(e26))
        this._desiredIndentCache.set(e26, this._tokenInfo.getTokenIndent(e26));
      else if (this._lockedFirstTokens.has(e26)) {
        var t2 = this._lockedFirstTokens.get(e26);
        this._desiredIndentCache.set(e26, this.getDesiredIndent(this._tokenInfo.getFirstTokenOfLine(t2)) + this._indentType.repeat(t2.loc.start.column - this._tokenInfo.getFirstTokenOfLine(t2).loc.start.column));
      } else {
        var r2 = this._getOffsetDescriptor(e26), n2 = !r2.from || r2.from.loc.start.line !== e26.loc.start.line || /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*?\n/.test(e26.value) || r2.force ? r2.offset * this._indentSize : 0;
        this._desiredIndentCache.set(e26, (r2.from ? this.getDesiredIndent(r2.from) : "") + this._indentType.repeat(n2));
      }
    return this._desiredIndentCache.get(e26);
  } }, { key: "ignoreToken", value: function(e26) {
    this._tokenInfo.isFirstTokenOfLine(e26) && this._ignoredTokens.add(e26);
  } }, { key: "getFirstDependency", value: function(e26) {
    return this._getOffsetDescriptor(e26).from;
  } }]), e25;
}(), a_ = { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["first", "off"] }] }, o_ = { meta: { type: "layout", docs: { description: "enforce consistent indentation", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/indent" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["tab"] }, { type: "integer", minimum: 0 }] }, { type: "object", properties: { SwitchCase: { type: "integer", minimum: 0, default: 0 }, VariableDeclarator: { oneOf: [a_, { type: "object", properties: { var: a_, let: a_, const: a_ }, additionalProperties: false }] }, outerIIFEBody: { type: "integer", minimum: 0 }, MemberExpression: { oneOf: [{ type: "integer", minimum: 0 }, { enum: ["off"] }] }, FunctionDeclaration: { type: "object", properties: { parameters: a_, body: { type: "integer", minimum: 0 } }, additionalProperties: false }, FunctionExpression: { type: "object", properties: { parameters: a_, body: { type: "integer", minimum: 0 } }, additionalProperties: false }, CallExpression: { type: "object", properties: { arguments: a_ }, additionalProperties: false }, ArrayExpression: a_, ObjectExpression: a_, ImportDeclaration: a_, flatTernaryExpressions: { type: "boolean", default: false }, ignoredNodes: { type: "array", items: { type: "string", not: { pattern: ":exit$" } } }, ignoreComments: { type: "boolean", default: false } }, additionalProperties: false }], messages: { wrongIndentation: "Expected indentation of {{expected}} but found {{actual}}." } }, create: function(e25) {
  function t2(e26, t3, r3) {
    var n3 = "".concat(e26, " ").concat(p2).concat(e26 === 1 ? "" : "s"), i3 = "space".concat(t3 === 1 ? "" : "s"), a3 = "tab".concat(r3 === 1 ? "" : "s");
    return { expected: n3, actual: 0 < t3 ? p2 === "space" ? t3 : "".concat(t3, " ").concat(i3) : 0 < r3 ? p2 === "tab" ? r3 : "".concat(r3, " ").concat(a3) : "0" };
  }
  function r2(r3, n3) {
    var i3 = Array.from(m2.getTokenIndent(r3)), a3 = i3.filter(function(e26) {
      return e26 === " ";
    }).length, o3 = i3.filter(function(e26) {
      return e26 === "	";
    }).length;
    e25.report({ node: r3, messageId: "wrongIndentation", data: t2(n3.length, a3, o3), loc: { start: { line: r3.loc.start.line, column: 0 }, end: { line: r3.loc.start.line, column: r3.loc.start.column } }, fix: function(e26) {
      var t3 = [r3.range[0] - r3.loc.start.column, r3.range[0]];
      return e26.replaceTextRange(t3, n3);
    } });
  }
  function n2(e26, t3) {
    var r3 = m2.getTokenIndent(e26);
    return r3 === t3 || r3.includes(" ") && r3.includes("	");
  }
  function i2(e26, t3, r3, n3) {
    function i3(e27) {
      for (var r4 = d2.getTokenBefore(e27); LA.isOpeningParenToken(r4) && r4 !== t3; )
        r4 = d2.getTokenBefore(r4);
      return d2.getTokenAfter(r4);
    }
    g2.setDesiredOffsets([t3.range[1], r3.range[0]], t3, typeof n3 == "number" ? n3 : 1), g2.setDesiredOffset(r3, t3, 0), n3 === "first" && e26.length && !e26[0] || e26.forEach(function(r4, a3) {
      if (r4 && (n3 === "off" && g2.ignoreToken(i3(r4)), a3 !== 0))
        if (n3 === "first" && m2.isFirstTokenOfLine(i3(r4)))
          g2.matchOffsetOf(i3(e26[0]), i3(r4));
        else {
          var o3 = e26[a3 - 1], s3 = o3 && i3(o3), u2 = o3 && d2.getLastToken(o3);
          o3 && u2.loc.end.line - function(e27) {
            var t4 = e27.match(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/)[0].match(LA.createGlobalLinebreakMatcher());
            return t4 === null ? 0 : t4.length;
          }(u2.value) > t3.loc.end.line && g2.setDesiredOffsets([o3.range[1], r4.range[1]], s3, 0);
        }
    });
  }
  function a2(e26) {
    if (e26.type !== "BlockStatement") {
      for (var t3 = d2.getTokenBefore(e26, LA.isNotOpeningParenToken), r3 = d2.getFirstToken(e26), n3 = d2.getLastToken(e26); LA.isOpeningParenToken(d2.getTokenBefore(r3)) && LA.isClosingParenToken(d2.getTokenAfter(n3)); )
        r3 = d2.getTokenBefore(r3), n3 = d2.getTokenAfter(n3);
      g2.setDesiredOffsets([r3.range[0], n3.range[1]], t3, 1);
      var i3 = d2.getLastToken(e26);
      e26.type !== "EmptyStatement" && LA.isSemicolonToken(i3) && g2.setDesiredOffset(i3, t3, 0);
    }
  }
  function o2(e26) {
    var t3 = e26.arguments.length ? d2.getFirstTokenBetween(e26.callee, e26.arguments[0], LA.isOpeningParenToken) : d2.getLastToken(e26, 1), r3 = d2.getLastToken(e26);
    y2.add(t3), y2.add(r3), g2.setDesiredOffset(t3, d2.getTokenBefore(t3), 0), i2(e26.arguments, t3, r3, h2.CallExpression.arguments);
  }
  function s2(e26) {
    var t3 = new Set(d2.getTokens(e26, { includeComments: true }));
    t3.forEach(function(e27) {
      if (!t3.has(g2.getFirstDependency(e27))) {
        var r3 = m2.getFirstTokenOfLine(e27);
        e27 === r3 ? g2.ignoreToken(e27) : g2.setDesiredOffset(e27, r3, 0);
      }
    });
  }
  function c2(e26, t3) {
    var r3 = e26.loc.end.line, n3 = t3.loc.start.line;
    if (r3 === n3 || r3 === n3 - 1)
      return false;
    for (var i3 = r3 + 1; i3 < n3; ++i3)
      if (!m2.firstTokensByLineNumber.has(i3))
        return true;
    return false;
  }
  function l2(e26) {
    C2.add(e26), v2.add(d2.getFirstToken(e26));
  }
  var p2 = "space", f2 = 4, h2 = { SwitchCase: 0, VariableDeclarator: { var: 1, let: 1, const: 1 }, outerIIFEBody: 1, FunctionDeclaration: { parameters: 1, body: 1 }, FunctionExpression: { parameters: 1, body: 1 }, CallExpression: { arguments: 1 }, MemberExpression: 1, ArrayExpression: 1, ObjectExpression: 1, ImportDeclaration: 1, flatTernaryExpressions: false, ignoredNodes: [], ignoreComments: false };
  e25.options.length && (e25.options[0] === "tab" ? (f2 = 1, p2 = "tab") : (f2 = e25.options[0], p2 = "space"), e25.options[1] && (Object.assign(h2, e25.options[1]), (typeof h2.VariableDeclarator == "number" || h2.VariableDeclarator === "first") && (h2.VariableDeclarator = { var: h2.VariableDeclarator, let: h2.VariableDeclarator, const: h2.VariableDeclarator })));
  var d2 = e25.getSourceCode(), m2 = new n_(d2), g2 = new i_(m2, f2, p2 == "space" ? " " : "	"), y2 = new WeakSet(), v2 = new Set(), x2 = { "ArrayExpression, ArrayPattern": function(e26) {
    var t3 = d2.getFirstToken(e26), r3 = d2.getTokenAfter(Fy.lodash.findLast(e26.elements) || t3, LA.isClosingBracketToken);
    i2(e26.elements, t3, r3, h2.ArrayExpression);
  }, "ObjectExpression, ObjectPattern": function(e26) {
    var t3 = d2.getFirstToken(e26), r3 = d2.getTokenAfter(e26.properties.length ? e26.properties[e26.properties.length - 1] : t3, LA.isClosingBraceToken);
    i2(e26.properties, t3, r3, h2.ObjectExpression);
  }, ArrowFunctionExpression: function(e26) {
    var t3 = d2.getFirstToken(e26);
    if (LA.isOpeningParenToken(t3)) {
      var r3 = t3, n3 = d2.getTokenBefore(e26.body, LA.isClosingParenToken);
      y2.add(r3), y2.add(n3), i2(e26.params, r3, n3, h2.FunctionExpression.parameters);
    }
    a2(e26.body);
  }, AssignmentExpression: function(e26) {
    var t3 = d2.getFirstTokenBetween(e26.left, e26.right, function(t4) {
      return t4.value === e26.operator;
    });
    g2.setDesiredOffsets([t3.range[0], e26.range[1]], d2.getLastToken(e26.left), 1), g2.ignoreToken(t3), g2.ignoreToken(d2.getTokenAfter(t3));
  }, "BinaryExpression, LogicalExpression": function(e26) {
    var t3 = d2.getFirstTokenBetween(e26.left, e26.right, function(t4) {
      return t4.value === e26.operator;
    }), r3 = d2.getTokenAfter(t3);
    g2.ignoreToken(t3), g2.ignoreToken(r3), g2.setDesiredOffset(r3, t3, 0);
  }, "BlockStatement, ClassBody": function(e26) {
    var t3;
    t3 = e26.parent && function(e27) {
      if (!e27.parent || e27.parent.type !== "CallExpression" || e27.parent.callee !== e27)
        return false;
      for (var t4 = e27.parent && e27.parent.parent; t4.type === "UnaryExpression" && -1 < ["!", "~", "+", "-"].indexOf(t4.operator) || t4.type === "AssignmentExpression" || t4.type === "LogicalExpression" || t4.type === "SequenceExpression" || t4.type === "VariableDeclarator"; )
        t4 = t4.parent;
      return (t4.type === "ExpressionStatement" || t4.type === "VariableDeclaration") && t4.parent.type === "Program";
    }(e26.parent) ? h2.outerIIFEBody : !e26.parent || e26.parent.type !== "FunctionExpression" && e26.parent.type !== "ArrowFunctionExpression" ? e26.parent && e26.parent.type === "FunctionDeclaration" ? h2.FunctionDeclaration.body : 1 : h2.FunctionExpression.body, LA.STATEMENT_LIST_PARENTS.has(e26.parent.type) || g2.setDesiredOffset(d2.getFirstToken(e26), d2.getFirstToken(e26.parent), 0), i2(e26.body, d2.getFirstToken(e26), d2.getLastToken(e26), t3);
  }, CallExpression: o2, "ClassDeclaration[superClass], ClassExpression[superClass]": function(e26) {
    var t3 = d2.getFirstToken(e26), r3 = d2.getTokenBefore(e26.superClass, LA.isNotOpeningParenToken);
    g2.setDesiredOffsets([r3.range[0], e26.body.range[0]], t3, 1);
  }, ConditionalExpression: function(e26) {
    var t3 = d2.getFirstToken(e26);
    if (!h2.flatTernaryExpressions || !LA.isTokenOnSameLine(e26.test, e26.consequent) || function(e27, t4) {
      for (var r4 = t4; r4.parent && !r4.parent.type.endsWith("Statement") && !r4.parent.type.endsWith("Declaration"); )
        r4 = r4.parent;
      return !(r4 = r4.parent) || r4.loc.start.line === e27.loc.start.line;
    }(t3, e26)) {
      var r3 = d2.getFirstTokenBetween(e26.test, e26.consequent, function(e27) {
        return e27.type === "Punctuator" && e27.value === "?";
      }), n3 = d2.getFirstTokenBetween(e26.consequent, e26.alternate, function(e27) {
        return e27.type === "Punctuator" && e27.value === ":";
      }), i3 = d2.getTokenAfter(r3), a3 = d2.getTokenBefore(n3), o3 = d2.getTokenAfter(n3);
      g2.setDesiredOffset(r3, t3, 1), g2.setDesiredOffset(n3, t3, 1), g2.setDesiredOffset(i3, t3, 1), a3.loc.end.line === o3.loc.start.line ? g2.setDesiredOffset(o3, i3, 0) : g2.setDesiredOffset(o3, t3, 1);
    }
  }, "DoWhileStatement, WhileStatement, ForInStatement, ForOfStatement": function(e26) {
    return a2(e26.body);
  }, ExportNamedDeclaration: function(e26) {
    if (e26.declaration === null) {
      var t3 = d2.getLastToken(e26, LA.isClosingBraceToken);
      i2(e26.specifiers, d2.getFirstToken(e26, { skip: 1 }), t3, 1), e26.source && g2.setDesiredOffsets([t3.range[1], e26.range[1]], d2.getFirstToken(e26), 1);
    }
  }, ForStatement: function(e26) {
    var t3 = d2.getFirstToken(e26, 1);
    e26.init && g2.setDesiredOffsets(e26.init.range, t3, 1), e26.test && g2.setDesiredOffsets(e26.test.range, t3, 1), e26.update && g2.setDesiredOffsets(e26.update.range, t3, 1), a2(e26.body);
  }, "FunctionDeclaration, FunctionExpression": function(e26) {
    var t3 = d2.getTokenBefore(e26.body), r3 = d2.getTokenBefore(e26.params.length ? e26.params[0] : t3);
    y2.add(r3), y2.add(t3), i2(e26.params, r3, t3, h2[e26.type].parameters);
  }, IfStatement: function(e26) {
    a2(e26.consequent), e26.alternate && e26.alternate.type !== "IfStatement" && a2(e26.alternate);
  }, ImportDeclaration: function(e26) {
    if (e26.specifiers.some(function(e27) {
      return e27.type === "ImportSpecifier";
    })) {
      var t3 = d2.getFirstToken(e26, LA.isOpeningBraceToken), r3 = d2.getLastToken(e26, LA.isClosingBraceToken);
      i2(e26.specifiers.filter(function(e27) {
        return e27.type === "ImportSpecifier";
      }), t3, r3, h2.ImportDeclaration);
    }
    var n3 = d2.getLastToken(e26, function(e27) {
      return e27.type === "Identifier" && e27.value === "from";
    }), a3 = d2.getLastToken(e26, function(e27) {
      return e27.type === "String";
    }), o3 = d2.getLastToken(e26, function(e27) {
      return e27.type === "Punctuator" && e27.value === ";";
    });
    if (n3) {
      var s3 = o3 && o3.range[1] === a3.range[1] ? e26.range[1] : a3.range[1];
      g2.setDesiredOffsets([n3.range[0], s3], d2.getFirstToken(e26), 1);
    }
  }, ImportExpression: function(e26) {
    var t3 = d2.getFirstToken(e26, 1), r3 = d2.getLastToken(e26);
    y2.add(t3), y2.add(r3), g2.setDesiredOffset(t3, d2.getTokenBefore(t3), 0), i2([e26.source], t3, r3, h2.CallExpression.arguments);
  }, "MemberExpression, JSXMemberExpression, MetaProperty": function(e26) {
    var t3 = e26.type === "MetaProperty" ? e26.meta : e26.object, r3 = d2.getFirstTokenBetween(t3, e26.property, LA.isNotClosingParenToken), n3 = d2.getTokenAfter(r3), i3 = d2.getTokensBetween(t3, e26.property, { filter: LA.isClosingParenToken }).length, a3 = i3 ? d2.getTokenBefore(t3, { skip: i3 - 1 }) : d2.getFirstToken(t3), o3 = d2.getTokenBefore(r3), s3 = e26.computed ? r3 : n3;
    e26.computed && (g2.setDesiredOffset(d2.getLastToken(e26), r3, 0), g2.setDesiredOffsets(e26.property.range, r3, 1));
    var u2 = o3.loc.end.line === s3.loc.start.line ? o3 : a3;
    typeof h2.MemberExpression == "number" ? (g2.setDesiredOffset(r3, u2, h2.MemberExpression), g2.setDesiredOffset(n3, e26.computed ? r3 : u2, h2.MemberExpression)) : (g2.ignoreToken(r3), g2.ignoreToken(n3), g2.setDesiredOffset(r3, u2, 0), g2.setDesiredOffset(n3, r3, 0));
  }, NewExpression: function(e26) {
    (0 < e26.arguments.length || LA.isClosingParenToken(d2.getLastToken(e26)) && LA.isOpeningParenToken(d2.getLastToken(e26, 1))) && o2(e26);
  }, Property: function(e26) {
    if (!e26.shorthand && !e26.method && e26.kind === "init") {
      var t3 = d2.getFirstTokenBetween(e26.key, e26.value, LA.isColonToken);
      g2.ignoreToken(d2.getTokenAfter(t3));
    }
  }, SwitchStatement: function(e26) {
    var t3 = d2.getTokenAfter(e26.discriminant, LA.isOpeningBraceToken), r3 = d2.getLastToken(e26);
    g2.setDesiredOffsets([t3.range[1], r3.range[0]], t3, h2.SwitchCase), e26.cases.length && d2.getTokensBetween(e26.cases[e26.cases.length - 1], r3, { includeComments: true, filter: LA.isCommentToken }).forEach(function(e27) {
      return g2.ignoreToken(e27);
    });
  }, SwitchCase: function(e26) {
    if (e26.consequent.length !== 1 || e26.consequent[0].type !== "BlockStatement") {
      var t3 = d2.getFirstToken(e26), r3 = d2.getTokenAfter(e26);
      g2.setDesiredOffsets([t3.range[1], r3.range[0]], t3, 1);
    }
  }, TemplateLiteral: function(e26) {
    e26.expressions.forEach(function(t3, r3) {
      var n3 = e26.quasis[r3], i3 = e26.quasis[r3 + 1], a3 = n3.loc.start.line === n3.loc.end.line ? d2.getFirstToken(n3) : null;
      g2.setDesiredOffsets([n3.range[1], i3.range[0]], a3, 1), g2.setDesiredOffset(d2.getFirstToken(i3), a3, 0);
    });
  }, VariableDeclaration: function(e26) {
    var t3 = Object.prototype.hasOwnProperty.call(h2.VariableDeclarator, e26.kind) ? h2.VariableDeclarator[e26.kind] : 1, r3 = d2.getFirstToken(e26), n3 = d2.getLastToken(e26);
    if (h2.VariableDeclarator[e26.kind] === "first") {
      if (1 < e26.declarations.length)
        return void i2(e26.declarations, r3, n3, "first");
      t3 = 1;
    }
    e26.declarations[e26.declarations.length - 1].loc.start.line > e26.loc.start.line ? g2.setDesiredOffsets(e26.range, r3, t3, true) : g2.setDesiredOffsets(e26.range, r3, t3), LA.isSemicolonToken(n3) && g2.ignoreToken(n3);
  }, VariableDeclarator: function(e26) {
    if (e26.init) {
      var t3 = d2.getTokenBefore(e26.init, LA.isNotOpeningParenToken), r3 = d2.getTokenAfter(t3);
      g2.ignoreToken(t3), g2.ignoreToken(r3), g2.setDesiredOffsets([r3.range[0], e26.range[1]], t3, 1), g2.setDesiredOffset(t3, d2.getLastToken(e26.id), 0);
    }
  }, "JSXAttribute[value]": function(e26) {
    var t3 = d2.getFirstTokenBetween(e26.name, e26.value, function(e27) {
      return e27.type === "Punctuator" && e27.value === "=";
    });
    g2.setDesiredOffsets([t3.range[0], e26.value.range[1]], d2.getFirstToken(e26.name), 1);
  }, JSXElement: function(e26) {
    e26.closingElement && i2(e26.children, d2.getFirstToken(e26.openingElement), d2.getFirstToken(e26.closingElement), 1);
  }, JSXOpeningElement: function(e26) {
    var t3, r3 = d2.getFirstToken(e26);
    e26.selfClosing ? (t3 = d2.getLastToken(e26, { skip: 1 }), g2.setDesiredOffset(d2.getLastToken(e26), t3, 0)) : t3 = d2.getLastToken(e26), g2.setDesiredOffsets(e26.name.range, d2.getFirstToken(e26)), i2(e26.attributes, r3, t3, 1);
  }, JSXClosingElement: function(e26) {
    var t3 = d2.getFirstToken(e26);
    g2.setDesiredOffsets(e26.name.range, t3, 1);
  }, JSXFragment: function(e26) {
    var t3 = d2.getFirstToken(e26.openingFragment), r3 = d2.getFirstToken(e26.closingFragment);
    i2(e26.children, t3, r3, 1);
  }, JSXOpeningFragment: function(e26) {
    var t3 = d2.getFirstToken(e26), r3 = d2.getLastToken(e26);
    g2.setDesiredOffsets(e26.range, t3, 1), g2.matchOffsetOf(t3, r3);
  }, JSXClosingFragment: function(e26) {
    var t3 = d2.getFirstToken(e26), r3 = d2.getLastToken(e26, { skip: 1 }), n3 = d2.getLastToken(e26), i3 = LA.isTokenOnSameLine(r3, n3) ? r3 : n3;
    g2.setDesiredOffsets(e26.range, t3, 1), g2.matchOffsetOf(t3, i3);
  }, JSXExpressionContainer: function(e26) {
    var t3 = d2.getFirstToken(e26), r3 = d2.getLastToken(e26);
    g2.setDesiredOffsets([t3.range[1], r3.range[0]], t3, 1);
  }, JSXSpreadAttribute: function(e26) {
    var t3 = d2.getFirstToken(e26), r3 = d2.getLastToken(e26);
    g2.setDesiredOffsets([t3.range[1], r3.range[0]], t3, 1);
  }, "*": function(e26) {
    var t3 = d2.getFirstToken(e26);
    t3 && !v2.has(t3) && g2.setDesiredOffsets(e26.range, t3, 0);
  } }, b2 = [], E2 = Fy.lodash.mapValues(x2, function(e26) {
    return function(t3) {
      return b2.push({ listener: e26, node: t3 });
    };
  }), C2 = new Set(), S2 = h2.ignoredNodes.reduce(function(e26, t3) {
    return Object.assign(e26, u({}, t3, l2));
  }, {});
  return Object.assign(E2, S2, { "*:exit": function(e26) {
    t_.has(e26.type) || l2(e26);
  }, "Program:exit": function() {
    h2.ignoreComments && d2.getAllComments().forEach(function(e27) {
      return g2.ignoreToken(e27);
    }), b2.filter(function(e27) {
      return !C2.has(e27.node);
    }).forEach(function(e27) {
      return e27.listener(e27.node);
    }), C2.forEach(s2), function(e27) {
      var t3 = [], r3 = [];
      e27.forEach(function(e28) {
        LA.isOpeningParenToken(e28) ? t3.push(e28) : LA.isClosingParenToken(e28) && r3.unshift({ left: t3.pop(), right: e28 });
      }), r3.forEach(function(e28) {
        var t4 = e28.left, r4 = e28.right;
        if (!y2.has(t4) && !y2.has(r4)) {
          var n3 = new Set(d2.getTokensBetween(t4, r4));
          n3.forEach(function(e29) {
            n3.has(g2.getFirstDependency(e29)) || g2.setDesiredOffset(e29, t4, 1);
          });
        }
        g2.setDesiredOffset(r4, t4, 0);
      });
    }(d2.ast.tokens);
    var e26 = d2.ast.comments.reduce(function(e27, t3) {
      var r3 = d2.getTokenBefore(t3, { includeComments: true });
      return e27.set(t3, e27.has(r3) ? e27.get(r3) : r3);
    }, new WeakMap());
    d2.lines.forEach(function(t3, i3) {
      var a3 = i3 + 1;
      if (m2.firstTokensByLineNumber.has(a3)) {
        var o3 = m2.firstTokensByLineNumber.get(a3);
        if (o3.loc.start.line === a3) {
          if (LA.isCommentToken(o3)) {
            var s3 = e26.get(o3), u2 = s3 ? d2.getTokenAfter(s3) : d2.ast.tokens[0], l3 = s3 && !c2(s3, o3), p3 = u2 && !c2(o3, u2);
            if (u2 && LA.isSemicolonToken(u2) && !LA.isTokenOnSameLine(o3, u2) && g2.setDesiredOffset(o3, u2, 0), l3 && n2(o3, g2.getDesiredIndent(s3)) || p3 && n2(o3, g2.getDesiredIndent(u2)))
              return;
          }
          n2(o3, g2.getDesiredIndent(o3)) || r2(o3, g2.getDesiredIndent(o3));
        }
      }
    });
  } });
} };
function s_(e25) {
  return e25.type === "ForInStatement" || e25.type === "ForOfStatement" || e25.type === "ForStatement";
}
function u_(e25) {
  var t2 = e25.parent, r2 = t2.parent;
  return s_(r2) ? r2.type === "ForStatement" ? r2.init === t2 : r2.left === t2 : !!e25.init;
}
var c_ = { meta: { type: "suggestion", docs: { description: "require or disallow initialization in variable declarations", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/init-declarations" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["always"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["never"] }, { type: "object", properties: { ignoreForLoopInit: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] }, messages: { initialized: "Variable '{{idName}}' should be initialized on declaration.", notInitialized: "Variable '{{idName}}' should not be initialized on declaration." } }, create: function(e25) {
  var t2 = e25.options[0] || "always", r2 = e25.options[1] || {};
  return { "VariableDeclaration:exit": function(n2) {
    for (var i2 = n2.kind, a2 = n2.declarations, o2 = 0; o2 < a2.length; ++o2) {
      var s2 = a2[o2], u2 = s2.id, c2 = u_(s2), l2 = r2.ignoreForLoopInit && s_(n2.parent), p2 = "";
      t2 !== "always" || c2 ? t2 === "never" && i2 !== "const" && c2 && !l2 && (p2 = "notInitialized") : p2 = "initialized", u2.type === "Identifier" && p2 && e25.report({ node: s2, messageId: p2, data: { idName: u2.name } });
    }
  } };
} }, l_ = { "prefer-double": { quote: '"', description: "singlequote", convert: function(e25) {
  return e25.replace(/'/g, '"');
} }, "prefer-single": { quote: "'", description: "doublequote", convert: function(e25) {
  return e25.replace(/"/g, "'");
} } }, p_ = { meta: { type: "layout", docs: { description: "enforce the consistent use of either double or single quotes in JSX attributes", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/jsx-quotes" }, fixable: "whitespace", schema: [{ enum: ["prefer-single", "prefer-double"] }], messages: { unexpected: "Unexpected usage of {{description}}." } }, create: function(e25) {
  var t2 = e25.options[0] || "prefer-double", r2 = l_[t2];
  return { JSXAttribute: function(t3) {
    var n2 = t3.value;
    n2 && LA.isStringLiteral(n2) && !function(e26) {
      return e26.value.indexOf(r2.quote) !== -1 || LA.isSurroundedBy(e26.raw, r2.quote);
    }(n2) && e25.report({ node: n2, messageId: "unexpected", data: { description: r2.description }, fix: function(e26) {
      return e26.replaceText(n2, r2.convert(n2.raw));
    } });
  } };
} };
function f_(e25) {
  return e25[e25.length - 1];
}
function h_(e25) {
  return e25.loc.end.line === e25.loc.start.line;
}
function d_(e25, t2) {
  return e25.mode = t2.mode || "strict", e25.beforeColon = t2.beforeColon === void 0 ? 0 : +t2.beforeColon, e25.afterColon = t2.afterColon === void 0 ? 1 : +t2.afterColon, t2.align !== void 0 && (i(t2.align) == "object" ? e25.align = t2.align : e25.align = { on: t2.align, mode: e25.mode, beforeColon: e25.beforeColon, afterColon: e25.afterColon }), e25;
}
var m_ = { meta: { type: "layout", docs: { description: "enforce consistent spacing between keys and values in object literal properties", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/key-spacing" }, fixable: "whitespace", schema: [{ anyOf: [{ type: "object", properties: { align: { anyOf: [{ enum: ["colon", "value"] }, { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, on: { enum: ["colon", "value"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false }] }, mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false }, { type: "object", properties: { singleLine: { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false }, multiLine: { type: "object", properties: { align: { anyOf: [{ enum: ["colon", "value"] }, { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, on: { enum: ["colon", "value"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false }] }, mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false } }, additionalProperties: false }, { type: "object", properties: { singleLine: { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false }, multiLine: { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false }, align: { type: "object", properties: { mode: { enum: ["strict", "minimum"] }, on: { enum: ["colon", "value"] }, beforeColon: { type: "boolean" }, afterColon: { type: "boolean" } }, additionalProperties: false } }, additionalProperties: false }] }], messages: { extraKey: "Extra space after {{computed}}key '{{key}}'.", extraValue: "Extra space before value for {{computed}}key '{{key}}'.", missingKey: "Missing space after {{computed}}key '{{key}}'.", missingValue: "Missing space before value for {{computed}}key '{{key}}'." } }, create: function(e25) {
  function t2(e26) {
    return !(e26.method || e26.shorthand || e26.kind !== "init" || e26.type !== "Property");
  }
  function r2(e26) {
    var t3 = e26.key;
    return e26.computed ? d2.getText().slice(t3.range[0], t3.range[1]) : e26.key.name || e26.key.value;
  }
  function n2(t3, n3, i2, a3, o3) {
    var s3 = i2.length - a3, u3 = function(e26) {
      return d2.getTokenAfter(e26, LA.isColonToken);
    }(t3.key), c3 = d2.getTokenBefore(u3, { includeComments: true }), l3 = d2.getTokenAfter(u3, { includeComments: true }), p3 = n3 === "key", f3 = p3 ? c3.loc.start : l3.loc.start, h3 = 0 < s3, m2 = Math.abs(s3), g2 = Array(m2 + 1).join(" ");
    if ((s3 && o3 === "strict" || 0 > s3 && o3 === "minimum" || 0 < s3 && !a3 && o3 === "minimum") && (!a3 || !function(e26) {
      return LA.LINEBREAK_MATCHER.test(e26);
    }(i2))) {
      var y2, v2;
      if (h3)
        v2 = p3 ? [c3.range[1], c3.range[1] + m2] : [l3.range[0] - m2, l3.range[0]], y2 = function(e26) {
          return e26.removeRange(v2);
        };
      else
        y2 = p3 ? function(e26) {
          return e26.insertTextAfter(c3, g2);
        } : function(e26) {
          return e26.insertTextBefore(l3, g2);
        };
      var x2;
      x2 = h3 ? n3 === "key" ? "extraKey" : "extraValue" : n3 === "key" ? "missingKey" : "missingValue", e25.report({ node: t3[n3], loc: f3, messageId: x2, data: { computed: t3.computed ? "computed " : "", key: r2(t3) }, fix: y2 });
    }
  }
  function a2(e26) {
    var t3 = d2.getFirstToken(e26);
    return function(e27) {
      var t4 = d2.getTokenAfter(e27, LA.isColonToken);
      return d2.getTokenBefore(t4);
    }(e26.key).range[1] - t3.range[0];
  }
  function o2(e26) {
    var t3 = /([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*):([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)/.exec(d2.getText().slice(e26.key.range[1], e26.value.range[0]));
    return t3 ? { beforeColon: t3[1], afterColon: t3[2] } : null;
  }
  function s2(e26) {
    return e26.properties.length === 1 ? [e26.properties] : e26.properties.reduce(function(e27, t3) {
      var r3 = f_(e27), n3 = f_(r3);
      return !n3 || function(e28, t4) {
        var r4 = e28.loc.start.line, n4 = t4.loc.start.line;
        if (1 >= n4 - r4)
          return true;
        var i2 = d2.getCommentsBefore(t4);
        if (i2.length && 1 >= i2[0].loc.start.line - r4 && 1 >= n4 - f_(i2).loc.end.line) {
          for (var a3 = 1; a3 < i2.length; a3++)
            if (1 < i2[a3].loc.start.line - i2[a3 - 1].loc.end.line)
              return false;
          return true;
        }
        return false;
      }(n3, t3) ? r3.push(t3) : e27.push([t3]), e27;
    }, [[]]);
  }
  function u2(e26) {
    s2(e26).forEach(function(e27) {
      !function(e28) {
        var t3, r3, i2, s3 = e28.length, u3 = e28.map(a2), c3 = h2.on, l3 = Math.max.apply(Math, E(u3));
        h2 && 1 < s3 ? (t3 = h2.beforeColon, r3 = h2.afterColon, i2 = h2.mode) : (t3 = p2.beforeColon, r3 = p2.afterColon, i2 = h2.mode), l3 += c3 === "colon" ? t3 : r3;
        for (var f3 = 0; f3 < s3; f3++) {
          var d3 = e28[f3], m2 = o2(d3);
          if (m2) {
            var g2 = u3[f3];
            c3 === "value" ? (n2(d3, "key", m2.beforeColon, t3, i2), n2(d3, "value", m2.afterColon, l3 - g2, i2)) : (n2(d3, "key", m2.beforeColon, l3 - g2, i2), n2(d3, "value", m2.afterColon, r3, i2));
          }
        }
      }(e27.filter(t2));
    });
  }
  function c2(e26, t3) {
    var r3 = o2(e26);
    r3 && (n2(e26, "key", r3.beforeColon, t3.beforeColon, t3.mode), n2(e26, "value", r3.afterColon, t3.afterColon, t3.mode));
  }
  var l2 = function(e26, t3) {
    return i(t3.align) == "object" ? (e26.align = d_({}, t3.align), e26.align.on = t3.align.on || "colon", e26.align.mode = t3.align.mode || "strict", e26.multiLine = d_({}, t3.multiLine || t3), e26.singleLine = d_({}, t3.singleLine || t3)) : (e26.multiLine = d_({}, t3.multiLine || t3), e26.singleLine = d_({}, t3.singleLine || t3), e26.multiLine.align && (e26.align = { on: e26.multiLine.align.on, mode: e26.multiLine.align.mode || e26.multiLine.mode, beforeColon: e26.multiLine.align.beforeColon, afterColon: e26.multiLine.align.afterColon })), e26;
  }({}, e25.options[0] || {}), p2 = l2.multiLine, f2 = l2.singleLine, h2 = l2.align || null, d2 = e25.getSourceCode();
  return h2 ? { ObjectExpression: function(e26) {
    h_(e26) ? function(e27) {
      for (var t3 = e27.length, r3 = 0; r3 < t3; r3++)
        c2(e27[r3], f2);
    }(e26.properties.filter(t2)) : u2(e26);
  } } : { Property: function(e26) {
    c2(e26, h_(e26.parent) ? f2 : p2);
  } };
} }, g_ = /^[\)>\]\}]$/, y_ = /^(?:[!\(<\[\{~]|\+\+?|\x2D\x2D?)$/, v_ = /^[\)\*>\]\}]$/, x_ = /^[\*\{]$/, b_ = /\$\{$/, E_ = /^\}/, C_ = /^(?:JSXElement|RegularExpression|String|Template)$/, S_ = Aw.concat(["as", "async", "await", "from", "get", "let", "of", "set", "yield"]);
function k_(e25) {
  return e25.type === "Template" && b_.test(e25.value);
}
function D_(e25) {
  return e25.type === "Template" && E_.test(e25.value);
}
!function() {
  S_.sort();
  for (var e25 = 1; e25 < S_.length; ++e25)
    if (S_[e25] === S_[e25 - 1])
      throw new Error("Duplication was found in the keyword list: ".concat(S_[e25]));
}();
var F_ = { meta: { type: "layout", docs: { description: "enforce consistent spacing before and after keywords", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/keyword-spacing" }, fixable: "whitespace", schema: [{ type: "object", properties: { before: { type: "boolean", default: true }, after: { type: "boolean", default: true }, overrides: { type: "object", properties: S_.reduce(function(e25, t2) {
  return e25[t2] = { type: "object", properties: { before: { type: "boolean" }, after: { type: "boolean" } }, additionalProperties: false }, e25;
}, {}), additionalProperties: false } }, additionalProperties: false }], messages: { expectedBefore: 'Expected space(s) before "{{value}}".', expectedAfter: 'Expected space(s) after "{{value}}".', unexpectedBefore: 'Unexpected space(s) before "{{value}}".', unexpectedAfter: 'Unexpected space(s) after "{{value}}".' } }, create: function(e25) {
  function t2(t3, r3) {
    var n3 = m2.getTokenBefore(t3);
    n3 && (C_.test(n3.type) || r3.test(n3.value)) && !k_(n3) && LA.isTokenOnSameLine(n3, t3) && !m2.isSpaceBetweenTokens(n3, t3) && e25.report({ loc: t3.loc.start, messageId: "expectedBefore", data: t3, fix: function(e26) {
      return e26.insertTextBefore(t3, " ");
    } });
  }
  function r2(t3, r3) {
    var n3 = m2.getTokenBefore(t3);
    n3 && (C_.test(n3.type) || r3.test(n3.value)) && !k_(n3) && LA.isTokenOnSameLine(n3, t3) && m2.isSpaceBetweenTokens(n3, t3) && e25.report({ loc: t3.loc.start, messageId: "unexpectedBefore", data: t3, fix: function(e26) {
      return e26.removeRange([n3.range[1], t3.range[0]]);
    } });
  }
  function n2(t3, r3) {
    var n3 = m2.getTokenAfter(t3);
    n3 && (C_.test(n3.type) || r3.test(n3.value)) && !D_(n3) && LA.isTokenOnSameLine(t3, n3) && !m2.isSpaceBetweenTokens(t3, n3) && e25.report({ loc: t3.loc.start, messageId: "expectedAfter", data: t3, fix: function(e26) {
      return e26.insertTextAfter(t3, " ");
    } });
  }
  function i2(t3, r3) {
    var n3 = m2.getTokenAfter(t3);
    n3 && (C_.test(n3.type) || r3.test(n3.value)) && !D_(n3) && LA.isTokenOnSameLine(t3, n3) && m2.isSpaceBetweenTokens(t3, n3) && e25.report({ loc: t3.loc.start, messageId: "unexpectedAfter", data: t3, fix: function(e26) {
      return e26.removeRange([t3.range[1], n3.range[0]]);
    } });
  }
  function a2(e26, t3) {
    g2[e26.value].before(e26, t3 || g_);
  }
  function o2(e26, t3) {
    g2[e26.value].after(e26, t3 || y_);
  }
  function s2(e26) {
    a2(e26), o2(e26);
  }
  function u2(e26) {
    var t3 = e26 && m2.getFirstToken(e26);
    t3 && t3.type === "Keyword" && s2(t3);
  }
  function c2(e26) {
    var t3 = e26 && m2.getFirstToken(e26);
    t3 && t3.type === "Keyword" && a2(t3);
  }
  function l2(e26) {
    e26 && s2(m2.getTokenBefore(e26, LA.isKeywordToken));
  }
  function p2(e26) {
    var t3 = e26 && m2.getFirstToken(e26);
    t3 && (t3.type === "Keyword" && t3.value === "function" || t3.value === "async") && a2(t3);
  }
  function f2(e26) {
    u2(e26), l2(e26.superClass);
  }
  function h2(e26) {
    var t3 = m2.getFirstToken(e26);
    if (a2(t3, v_), o2(t3, x_), e26.type === "ExportDefaultDeclaration" && s2(m2.getTokenAfter(t3)), e26.source) {
      var r3 = m2.getTokenBefore(e26.source);
      a2(r3, v_), o2(r3, x_);
    }
  }
  function d2(e26) {
    if (e26.static && u2(e26), e26.kind === "get" || e26.kind === "set" || (e26.method || e26.type === "MethodDefinition") && e26.value.async) {
      var t3 = m2.getTokenBefore(e26.key, function(e27) {
        switch (e27.value) {
          case "get":
          case "set":
          case "async":
            return true;
          default:
            return false;
        }
      });
      if (!t3)
        throw new Error("Failed to find token get, set, or async beside method name");
      s2(t3);
    }
  }
  var m2 = e25.getSourceCode(), g2 = function() {
    for (var e26 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a3 = e26.before !== false, o3 = e26.after !== false, s3 = { before: a3 ? t2 : r2, after: o3 ? n2 : i2 }, u3 = e26 && e26.overrides || {}, c3 = Object.create(null), l3 = 0; l3 < S_.length; ++l3) {
      var p3 = S_[l3], f3 = u3[p3];
      if (f3) {
        var h3 = "before" in f3 ? f3.before : a3, d3 = "after" in f3 ? f3.after : o3;
        c3[p3] = { before: h3 ? t2 : r2, after: d3 ? n2 : i2 };
      } else
        c3[p3] = s3;
    }
    return c3;
  }(e25.options[0]);
  return { DebuggerStatement: u2, WithStatement: u2, BreakStatement: u2, ContinueStatement: u2, ReturnStatement: u2, ThrowStatement: u2, TryStatement: function(e26) {
    u2(e26), u2(e26.handler), l2(e26.finalizer);
  }, IfStatement: function(e26) {
    u2(e26), l2(e26.alternate);
  }, SwitchStatement: u2, SwitchCase: u2, DoWhileStatement: function(e26) {
    u2(e26), l2(e26.test);
  }, ForInStatement: function(e26) {
    u2(e26), l2(e26.right);
  }, ForOfStatement: function(e26) {
    e26.await ? (a2(m2.getFirstToken(e26, 0)), o2(m2.getFirstToken(e26, 1))) : u2(e26), s2(m2.getTokenBefore(e26.right, LA.isNotOpeningParenToken));
  }, ForStatement: u2, WhileStatement: u2, ClassDeclaration: f2, ExportNamedDeclaration: h2, ExportDefaultDeclaration: h2, ExportAllDeclaration: h2, FunctionDeclaration: p2, ImportDeclaration: h2, VariableDeclaration: u2, ArrowFunctionExpression: p2, AwaitExpression: function(e26) {
    a2(m2.getFirstToken(e26));
  }, ClassExpression: f2, FunctionExpression: p2, NewExpression: c2, Super: c2, ThisExpression: c2, UnaryExpression: c2, YieldExpression: c2, ImportNamespaceSpecifier: function(e26) {
    a2(m2.getFirstToken(e26, 1), v_);
  }, MethodDefinition: d2, Property: d2 };
} }, A_ = { meta: { type: "layout", docs: { description: "enforce position of line comments", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/line-comment-position" }, schema: [{ oneOf: [{ enum: ["above", "beside"] }, { type: "object", properties: { position: { enum: ["above", "beside"] }, ignorePattern: { type: "string" }, applyDefaultPatterns: { type: "boolean" }, applyDefaultIgnorePatterns: { type: "boolean" } }, additionalProperties: false }] }], messages: { above: "Expected comment to be above code.", beside: "Expected comment to be beside code." } }, create: function(e25) {
  var t2, r2, n2 = e25.options[0], i2 = true;
  n2 && typeof n2 != "string" ? (t2 = !n2.position || n2.position === "above", r2 = n2.ignorePattern, i2 = Object.prototype.hasOwnProperty.call(n2, "applyDefaultIgnorePatterns") ? n2.applyDefaultIgnorePatterns : n2.applyDefaultPatterns !== false) : t2 = !n2 || n2 === "above";
  var a2 = LA.COMMENTS_IGNORE_PATTERN, o2 = /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*falls?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?through/, s2 = new RegExp(r2, "u"), u2 = e25.getSourceCode();
  return { Program: function() {
    u2.getAllComments().filter(function(e26) {
      return e26.type === "Line";
    }).forEach(function(n3) {
      if (!(i2 && (a2.test(n3.value) || o2.test(n3.value)) || r2 && s2.test(n3.value))) {
        var c2 = u2.getTokenBefore(n3, { includeComments: true }), l2 = c2 && c2.loc.end.line === n3.loc.start.line;
        t2 ? l2 && e25.report({ node: n3, messageId: "above" }) : !l2 && e25.report({ node: n3, messageId: "beside" });
      }
    });
  } };
} }, w_ = { meta: { type: "layout", docs: { description: "enforce consistent linebreak style", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/linebreak-style" }, fixable: "whitespace", schema: [{ enum: ["unix", "windows"] }], messages: { expectedLF: "Expected linebreaks to be 'LF' but found 'CRLF'.", expectedCRLF: "Expected linebreaks to be 'CRLF' but found 'LF'." } }, create: function(e25) {
  function t2(e26, t3) {
    return function(r3) {
      return r3.replaceTextRange(e26, t3);
    };
  }
  var r2 = e25.getSourceCode();
  return { Program: function(n2) {
    for (var i2, a2 = (e25.options[0] || "unix") === "unix", o2 = a2 ? "\n" : "\r\n", s2 = r2.getText(), u2 = LA.createGlobalLinebreakMatcher(), c2 = 0; (i2 = u2.exec(s2)) !== null; )
      if (c2++, i2[0] !== o2) {
        var l2 = i2.index, p2 = [l2, l2 + i2[0].length];
        e25.report({ node: n2, loc: { line: c2, column: r2.lines[c2 - 1].length }, messageId: a2 ? "expectedLF" : "expectedCRLF", fix: t2(p2, o2) });
      }
  } };
} };
var __ = { meta: { type: "layout", docs: { description: "require empty lines around comments", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/lines-around-comment" }, fixable: "whitespace", schema: [{ type: "object", properties: { beforeBlockComment: { type: "boolean", default: true }, afterBlockComment: { type: "boolean", default: false }, beforeLineComment: { type: "boolean", default: false }, afterLineComment: { type: "boolean", default: false }, allowBlockStart: { type: "boolean", default: false }, allowBlockEnd: { type: "boolean", default: false }, allowClassStart: { type: "boolean" }, allowClassEnd: { type: "boolean" }, allowObjectStart: { type: "boolean" }, allowObjectEnd: { type: "boolean" }, allowArrayStart: { type: "boolean" }, allowArrayEnd: { type: "boolean" }, ignorePattern: { type: "string" }, applyDefaultIgnorePatterns: { type: "boolean" } }, additionalProperties: false }], messages: { after: "Expected line after comment.", before: "Expected line before comment." } }, create: function(e25) {
  function t2(e26, t3) {
    return e26.type === t3 || e26.body && e26.body.type === t3 || e26.consequent && e26.consequent.type === t3;
  }
  function r2(e26) {
    return x2.getNodeByRangeIndex(e26.range[0]);
  }
  function n2(e26, n3) {
    var i3 = r2(e26);
    return i3 && t2(i3, n3) && e26.loc.start.line - i3.loc.start.line == 1;
  }
  function i2(e26, n3) {
    var i3 = r2(e26);
    return i3 && t2(i3, n3) && i3.loc.end.line - e26.loc.end.line == 1;
  }
  function a2(e26) {
    return n2(e26, "ClassBody") || n2(e26, "BlockStatement") || n2(e26, "SwitchCase");
  }
  function o2(e26) {
    return i2(e26, "ClassBody") || i2(e26, "BlockStatement") || i2(e26, "SwitchCase") || i2(e26, "SwitchStatement");
  }
  function s2(e26) {
    return n2(e26, "ClassBody");
  }
  function u2(e26) {
    return i2(e26, "ClassBody");
  }
  function c2(e26) {
    return n2(e26, "ObjectExpression") || n2(e26, "ObjectPattern");
  }
  function l2(e26) {
    return i2(e26, "ObjectExpression") || i2(e26, "ObjectPattern");
  }
  function p2(e26) {
    return n2(e26, "ArrayExpression") || n2(e26, "ArrayPattern");
  }
  function f2(e26) {
    return i2(e26, "ArrayExpression") || i2(e26, "ArrayPattern");
  }
  function h2(t3, r3) {
    if (!(v2 && g2.test(t3.value) || m2 && y2.test(t3.value))) {
      var n3 = r3.after, i3 = r3.before, h3 = t3.loc.start.line - 1, b3 = t3.loc.end.line + 1, C3 = function(e26) {
        var t4 = e26;
        do {
          t4 = x2.getTokenBefore(t4, { includeComments: true });
        } while (t4 && LA.isCommentToken(t4));
        if (t4 && LA.isTokenOnSameLine(t4, e26))
          return true;
        t4 = e26;
        do {
          t4 = x2.getTokenAfter(t4, { includeComments: true });
        } while (t4 && LA.isCommentToken(t4));
        return !(!t4 || !LA.isTokenOnSameLine(e26, t4));
      }(t3), S3 = d2.allowBlockStart && a2(t3) && !(d2.allowClassStart === false && s2(t3)), k3 = d2.allowBlockEnd && o2(t3) && !(d2.allowClassEnd === false && u2(t3)), F2 = d2.allowClassStart && s2(t3), A2 = d2.allowClassEnd && u2(t3), w2 = d2.allowObjectStart && c2(t3), _2 = d2.allowObjectEnd && l2(t3), T2 = d2.allowArrayStart && p2(t3), P2 = d2.allowArrayEnd && f2(t3);
      if (1 > h3 && (i3 = false), b3 >= E2 && (n3 = false), !C3) {
        var I2 = x2.getTokenBefore(t3, { includeComments: true }), B2 = x2.getTokenAfter(t3, { includeComments: true });
        if (!(S3 || F2 || w2 || T2) && i3 && !Fy.lodash.includes(D2, h3) && (!LA.isCommentToken(I2) || !LA.isTokenOnSameLine(I2, t3))) {
          var O2 = t3.range[0] - t3.loc.start.column, L2 = [O2, O2];
          e25.report({ node: t3, messageId: "before", fix: function(e26) {
            return e26.insertTextBeforeRange(L2, "\n");
          } });
        }
        k3 || A2 || _2 || P2 || !n3 || Fy.lodash.includes(D2, b3) || LA.isCommentToken(B2) && LA.isTokenOnSameLine(t3, B2) || e25.report({ node: t3, messageId: "after", fix: function(e26) {
          return e26.insertTextAfter(t3, "\n");
        } });
      }
    }
  }
  var d2 = Object.assign({}, e25.options[0]), m2 = d2.ignorePattern, g2 = LA.COMMENTS_IGNORE_PATTERN, y2 = new RegExp(m2, "u"), v2 = d2.applyDefaultIgnorePatterns !== false;
  d2.beforeBlockComment = !(d2.beforeBlockComment !== void 0) || d2.beforeBlockComment;
  var x2 = e25.getSourceCode(), b2 = x2.lines, E2 = b2.length + 1, C2 = x2.getAllComments(), S2 = function(e26) {
    var t3 = [];
    return e26.forEach(function(e27) {
      var r3 = e27.loc.start.line, n3 = e27.loc.end.line;
      t3.push(r3, n3);
    }), t3;
  }(C2), k2 = function(e26) {
    return e26.map(function(e27, t3) {
      return { code: e27.trim(), num: t3 + 1 };
    }).filter(function(e27) {
      return !e27.code;
    }).map(function(e27) {
      return e27.num;
    });
  }(b2), D2 = S2.concat(k2);
  return { Program: function() {
    C2.forEach(function(e26) {
      e26.type === "Line" ? (d2.beforeLineComment || d2.afterLineComment) && h2(e26, { after: d2.afterLineComment, before: d2.beforeLineComment }) : e26.type === "Block" && (d2.beforeBlockComment || d2.afterBlockComment) && h2(e26, { after: d2.afterBlockComment, before: d2.beforeBlockComment });
    });
  } };
} }, T_ = { meta: { type: "layout", docs: { description: "require or disallow newlines around directives", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/lines-around-directive" }, schema: [{ oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { before: { enum: ["always", "never"] }, after: { enum: ["always", "never"] } }, additionalProperties: false, minProperties: 2 }] }], fixable: "whitespace", messages: { expected: 'Expected newline {{location}} "{{value}}" directive.', unexpected: 'Unexpected newline {{location}} "{{value}}" directive.' }, deprecated: true, replacedBy: ["padding-line-between-statements"] }, create: function(e25) {
  function t2(e26) {
    var t3 = o2.getTokenBefore(e26, { includeComments: true }), r3 = t3 ? t3.loc.end.line : 0;
    return 2 <= e26.loc.start.line - r3;
  }
  function r2(e26) {
    var t3 = o2.getLastToken(e26), r3 = o2.getTokenBefore(t3);
    return LA.isSemicolonToken(t3) && t3.loc.start.line > r3.loc.end.line ? r3 : t3;
  }
  function n2(e26) {
    var t3 = r2(e26);
    return 2 <= o2.getTokenAfter(t3, { includeComments: true }).loc.start.line - t3.loc.end.line;
  }
  function i2(t3, n3, i3) {
    e25.report({ node: t3, messageId: i3 ? "expected" : "unexpected", data: { value: t3.expression.value, location: n3 }, fix: function(e26) {
      var a3 = r2(t3);
      return i3 ? n3 === "before" ? e26.insertTextBefore(t3, "\n") : e26.insertTextAfter(a3, "\n") : e26.removeRange(n3 === "before" ? [t3.range[0] - 1, t3.range[0]] : [a3.range[1], a3.range[1] + 1]);
    } });
  }
  function a2(e26) {
    var r3 = LA.getDirectivePrologue(e26);
    if (r3.length) {
      var a3 = r3[0], s3 = o2.getCommentsBefore(a3);
      s3.length ? (u2 === "always" && !t2(a3) && i2(a3, "before", true), u2 === "never" && t2(a3) && i2(a3, "before", false)) : e26.type === "Program" && u2 === "never" && !s3.length && t2(a3) && i2(a3, "before", false);
      var l2 = r3[r3.length - 1], p2 = e26.type === "Program" ? e26.body : e26.body.body;
      (l2 !== p2[p2.length - 1] || l2.trailingComments) && (c2 === "always" && !n2(l2) && i2(l2, "after", true), c2 === "never" && n2(l2) && i2(l2, "after", false));
    }
  }
  var o2 = e25.getSourceCode(), s2 = e25.options[0] || "always", u2 = typeof s2 == "string" ? s2 : s2.before, c2 = typeof s2 == "string" ? s2 : s2.after;
  return { Program: a2, FunctionDeclaration: a2, FunctionExpression: a2, ArrowFunctionExpression: a2 };
} }, P_ = { meta: { type: "layout", docs: { description: "require or disallow an empty line between class members", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/lines-between-class-members" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { exceptAfterSingleLine: { type: "boolean", default: false } }, additionalProperties: false }], messages: { never: "Unexpected blank line between class members.", always: "Expected blank line between class members." } }, create: function(e25) {
  var t2 = [];
  t2[0] = e25.options[0] || "always", t2[1] = e25.options[1] || { exceptAfterSingleLine: false };
  var r2 = e25.getSourceCode();
  return { ClassBody: function(n2) {
    for (var i2 = n2.body, a2 = function(n3) {
      var a3 = r2.getFirstToken(i2[n3]), o3 = r2.getLastToken(i2[n3]), s2 = r2.getFirstToken(i2[n3 + 1]), u2 = function(e26, t3) {
        var n4 = r2.getCommentsBefore(t3), i3 = n4.length;
        if (i3 === 0)
          return 1 <= t3.loc.start.line - e26.loc.end.line - 1;
        for (var a4 = 0, o4 = -1, s3 = 0; s3 < i3; s3++) {
          a4 += n4[s3].loc.end.line - n4[s3].loc.start.line + 1, o4 === n4[s3].loc.start.line && (a4 -= 1), o4 = n4[s3].loc.end.line;
        }
        return e26.loc.end.line === n4[0].loc.start.line && (a4 -= 1), n4[i3 - 1].loc.end.line === t3.loc.start.line && (a4 -= 1), 1 <= t3.loc.start.line - e26.loc.end.line - 1 - a4;
      }(o3, s2), c2 = !!LA.isTokenOnSameLine(a3, o3) && t2[1].exceptAfterSingleLine;
      (t2[0] !== "always" || c2 || u2) && (t2[0] !== "never" || !u2) || e25.report({ node: i2[n3 + 1], messageId: u2 ? "never" : "always", fix: function(e26) {
        return u2 ? e26.replaceTextRange([o3.range[1], s2.range[0]], "\n") : e26.insertTextAfter(o3, "\n");
      } });
    }, o2 = 0; o2 < i2.length - 1; o2++)
      a2(o2);
  } };
} }, I_ = { meta: { type: "suggestion", docs: { description: "enforce a maximum depth that blocks can be nested", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-depth" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: false }] }], messages: { tooDeeply: "Blocks are nested too deeply ({{depth}}). Maximum allowed is {{maxDepth}}." } }, create: function(e25) {
  function t2() {
    o2.push(0);
  }
  function r2() {
    o2.pop();
  }
  function n2(t3) {
    var r3 = ++o2[o2.length - 1];
    r3 > u2 && e25.report({ node: t3, messageId: "tooDeeply", data: { depth: r3, maxDepth: u2 } });
  }
  function a2() {
    o2[o2.length - 1]--;
  }
  var o2 = [], s2 = e25.options[0], u2 = 4;
  return i(s2) == "object" && (Object.prototype.hasOwnProperty.call(s2, "maximum") || Object.prototype.hasOwnProperty.call(s2, "max")) && (u2 = s2.maximum || s2.max), typeof s2 == "number" && (u2 = s2), { Program: t2, FunctionDeclaration: t2, FunctionExpression: t2, ArrowFunctionExpression: t2, IfStatement: function(e26) {
    e26.parent.type !== "IfStatement" && n2(e26);
  }, SwitchStatement: n2, TryStatement: n2, DoWhileStatement: n2, WhileStatement: n2, WithStatement: n2, ForStatement: n2, ForInStatement: n2, ForOfStatement: n2, "IfStatement:exit": a2, "SwitchStatement:exit": a2, "TryStatement:exit": a2, "DoWhileStatement:exit": a2, "WhileStatement:exit": a2, "WithStatement:exit": a2, "ForStatement:exit": a2, "ForInStatement:exit": a2, "ForOfStatement:exit": a2, "FunctionDeclaration:exit": r2, "FunctionExpression:exit": r2, "ArrowFunctionExpression:exit": r2, "Program:exit": r2 };
} }, B_ = { type: "object", properties: { code: { type: "integer", minimum: 0 }, comments: { type: "integer", minimum: 0 }, tabWidth: { type: "integer", minimum: 0 }, ignorePattern: { type: "string" }, ignoreComments: { type: "boolean" }, ignoreStrings: { type: "boolean" }, ignoreUrls: { type: "boolean" }, ignoreTemplateLiterals: { type: "boolean" }, ignoreRegExpLiterals: { type: "boolean" }, ignoreTrailingComments: { type: "boolean" } }, additionalProperties: false }, O_ = { anyOf: [B_, { type: "integer", minimum: 0 }] }, L_ = { meta: { type: "layout", docs: { description: "enforce a maximum line length", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-len" }, schema: [O_, O_, B_], messages: { max: "This line has a length of {{lineLength}}. Maximum allowed is {{maxLength}}.", maxComment: "This line has a comment length of {{lineLength}}. Maximum allowed is {{maxCommentLength}}." } }, create: function(e25) {
  function t2(e26, t3, r3) {
    return r3 && r3.loc.start.line === t3 && t3 <= r3.loc.end.line && (r3.loc.end.line > t3 || r3.loc.end.column === e26.length);
  }
  function r2(e26, t3) {
    return e26.slice(0, t3.loc.start.column).replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+$/, "");
  }
  function n2(e26, t3, r3) {
    Array.isArray(e26[t3]) || (e26[t3] = []), e26[t3].push(r3);
  }
  function i2(e26, t3) {
    for (var r3 = t3.loc.start.line; r3 <= t3.loc.end.line; ++r3)
      n2(e26, r3, t3);
    return e26;
  }
  var a2 = /(?:[\0-"\$-\.0-9;->@-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]):\/\/(?:[\0-"\$->@-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, o2 = e25.getSourceCode(), s2 = Object.assign({}, e25.options[e25.options.length - 1]);
  typeof e25.options[0] == "number" && (s2.code = e25.options[0]), typeof e25.options[1] == "number" && (s2.tabWidth = e25.options[1]);
  var u2 = typeof s2.code == "number" ? s2.code : 80, c2 = typeof s2.tabWidth == "number" ? s2.tabWidth : 4, l2 = !!s2.ignoreComments, p2 = !!s2.ignoreStrings, f2 = !!s2.ignoreTemplateLiterals, h2 = !!s2.ignoreRegExpLiterals, d2 = !!s2.ignoreTrailingComments || !!s2.ignoreComments, m2 = !!s2.ignoreUrls, g2 = s2.comments, y2 = s2.ignorePattern || null;
  return y2 && (y2 = new RegExp(y2, "u")), { Program: function(n3) {
    var s3 = o2.lines, v2 = l2 || g2 || d2 ? o2.getAllComments() : [], x2 = 0, b2 = o2.ast.tokens.filter(function(e26) {
      return e26.type === "String" || e26.type === "JSXText" && o2.getNodeByRangeIndex(e26.range[0] - 1).type === "JSXAttribute";
    }).reduce(i2, {}), E2 = o2.ast.tokens.filter(function(e26) {
      return e26.type === "Template";
    }).reduce(i2, {}), C2 = o2.ast.tokens.filter(function(e26) {
      return e26.type === "RegularExpression";
    }).reduce(i2, {});
    s3.forEach(function(i3, o3) {
      var s4, S2 = o3 + 1, k2 = false;
      if (x2 < v2.length) {
        var D2 = null;
        do {
          D2 = v2[++x2];
        } while (D2 && D2.loc.start.line <= S2);
        if (function(e26, t3, r3) {
          var n4 = r3.loc.start, i4 = r3.loc.end, a3 = !e26.slice(0, r3.loc.start.column).trim();
          return r3 && (n4.line < t3 || n4.line === t3 && a3) && (i4.line > t3 || i4.line === t3 && i4.column === e26.length);
        }(i3, S2, D2 = v2[--x2]))
          k2 = true, s4 = i3;
        else if (d2 && t2(i3, S2, D2)) {
          s4 = r2(i3, D2);
          for (var F2 = x2; t2(s4, S2, v2[--F2]); )
            s4 = r2(s4, v2[F2]);
        } else
          s4 = i3;
      } else
        s4 = i3;
      if (!(y2 && y2.test(s4) || m2 && a2.test(s4) || p2 && b2[S2] || f2 && E2[S2] || h2 && C2[S2])) {
        var A2 = function(e26, t3) {
          var r3 = 0;
          return e26.replace(/\t/g, function(e27, n4) {
            r3 += t3 - (t3 ? (n4 + r3) % t3 : 0) - 1;
          }), Array.from(e26).length + r3;
        }(s4, c2);
        k2 && l2 || (k2 && g2 ? A2 > g2 && e25.report({ node: n3, loc: { line: S2, column: 0 }, messageId: "maxComment", data: { lineLength: A2, maxCommentLength: g2 } }) : A2 > u2 && e25.report({ node: n3, loc: { line: S2, column: 0 }, messageId: "max", data: { lineLength: A2, maxLength: u2 } }));
      }
    });
  } };
} };
var N_ = { meta: { type: "suggestion", docs: { description: "enforce a maximum number of line of code in a function", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-lines-per-function" }, schema: [{ oneOf: [{ type: "object", properties: { max: { type: "integer", minimum: 0 }, skipComments: { type: "boolean" }, skipBlankLines: { type: "boolean" }, IIFEs: { type: "boolean" } }, additionalProperties: false }, { type: "integer", minimum: 1 }] }], messages: { exceed: "{{name}} has too many lines ({{lineCount}}). Maximum allowed is {{maxLines}}." } }, create: function(e25) {
  function t2(e26, t3, r3) {
    var n3 = r3.loc.start, i2 = r3.loc.end, a3 = n3.line === t3 && !e26.slice(0, n3.column).trim(), o3 = i2.line === t3 && !e26.slice(i2.column).trim();
    return r3 && (n3.line < t3 || a3) && (i2.line > t3 || o3);
  }
  function r2(r3) {
    var n3 = function(e26) {
      return !(!e26.parent || e26 !== e26.parent.value || e26.parent.type !== "MethodDefinition" && (e26.parent.type !== "Property" || e26.parent.method !== true && e26.parent.kind !== "get" && e26.parent.kind !== "set"));
    }(r3) ? r3.parent : r3;
    if (l2 || !function(e26) {
      return e26.type === "FunctionExpression" && e26.parent && e26.parent.type === "CallExpression" && e26.parent.callee === e26;
    }(n3)) {
      for (var i2 = 0, o3 = n3.loc.start.line - 1; o3 < n3.loc.end.line; ++o3) {
        var f2 = a2[o3];
        u2 && p2.has(o3 + 1) && t2(f2, o3 + 1, p2.get(o3 + 1)) || c2 && f2.match(/^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/) || i2++;
      }
      if (i2 > s2) {
        var h2 = Fy.lodash.upperFirst(LA.getFunctionNameWithKind(r3));
        e25.report({ node: n3, messageId: "exceed", data: { name: h2, lineCount: i2, maxLines: s2 } });
      }
    }
  }
  var n2 = e25.getSourceCode(), a2 = n2.lines, o2 = e25.options[0], s2 = 50, u2 = false, c2 = false, l2 = false;
  i(o2) == "object" ? (s2 = typeof o2.max == "number" ? o2.max : 50, u2 = !!o2.skipComments, c2 = !!o2.skipBlankLines, l2 = !!o2.IIFEs) : typeof o2 == "number" && (s2 = o2);
  var p2 = function(e26) {
    var t3 = new Map();
    return e26 ? (e26.forEach(function(e27) {
      for (var r3 = e27.loc.start.line; r3 <= e27.loc.end.line; r3++)
        t3.set(r3, e27);
    }), t3) : t3;
  }(n2.getAllComments());
  return { FunctionDeclaration: r2, FunctionExpression: r2, ArrowFunctionExpression: r2 };
} }, j_ = { meta: { type: "suggestion", docs: { description: "enforce a maximum number of lines per file", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-lines" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { max: { type: "integer", minimum: 0 }, skipComments: { type: "boolean" }, skipBlankLines: { type: "boolean" } }, additionalProperties: false }] }], messages: { exceed: "File has too many lines ({{actual}}). Maximum allowed is {{max}}." } }, create: function(e25) {
  function t2(e26) {
    return e26 && (e26.type === "Block" || e26.type === "Line");
  }
  function r2(e26) {
    var r3, n3 = e26.loc.start.line, i2 = e26.loc.end.line;
    r3 = e26;
    do {
      r3 = u2.getTokenBefore(r3, { includeComments: true });
    } while (t2(r3));
    r3 && LA.isTokenOnSameLine(r3, e26) && (n3 += 1), r3 = e26;
    do {
      r3 = u2.getTokenAfter(r3, { includeComments: true });
    } while (t2(r3));
    return r3 && LA.isTokenOnSameLine(e26, r3) && (i2 -= 1), n3 <= i2 ? Fy.lodash.range(n3, i2 + 1) : [];
  }
  var n2 = e25.options[0], a2 = 300;
  i(n2) == "object" && Object.prototype.hasOwnProperty.call(n2, "max") ? a2 = n2.max : typeof n2 == "number" && (a2 = n2);
  var o2 = n2 && n2.skipComments, s2 = n2 && n2.skipBlankLines, u2 = e25.getSourceCode();
  return { "Program:exit": function() {
    var t3 = u2.lines.map(function(e26, t4) {
      return { lineNumber: t4 + 1, text: e26 };
    });
    if (s2 && (t3 = t3.filter(function(e26) {
      return e26.text.trim() !== "";
    })), o2) {
      var n3 = u2.getAllComments(), i2 = Fy.lodash.flatten(n3.map(function(e26) {
        return r2(e26);
      }));
      t3 = t3.filter(function(e26) {
        return !Fy.lodash.includes(i2, e26.lineNumber);
      });
    }
    t3.length > a2 && e25.report({ loc: { line: 1, column: 0 }, messageId: "exceed", data: { max: a2, actual: t3.length } });
  } };
} }, R_ = { meta: { type: "suggestion", docs: { description: "enforce a maximum depth that callbacks can be nested", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-nested-callbacks" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: false }] }], messages: { exceed: "Too many nested callbacks ({{num}}). Maximum allowed is {{max}}." } }, create: function(e25) {
  function t2(t3) {
    if (t3.parent.type === "CallExpression" && o2.push(t3), o2.length > a2) {
      var r3 = { num: o2.length, max: a2 };
      e25.report({ node: t3, messageId: "exceed", data: r3 });
    }
  }
  function r2() {
    o2.pop();
  }
  var n2 = e25.options[0], a2 = 10;
  i(n2) == "object" && (Object.prototype.hasOwnProperty.call(n2, "maximum") || Object.prototype.hasOwnProperty.call(n2, "max")) ? a2 = n2.maximum || n2.max : typeof n2 == "number" && (a2 = n2);
  var o2 = [];
  return { ArrowFunctionExpression: t2, "ArrowFunctionExpression:exit": r2, FunctionExpression: t2, "FunctionExpression:exit": r2 };
} }, M_ = { meta: { type: "suggestion", docs: { description: "enforce a maximum number of parameters in function definitions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-params" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: false }] }], messages: { exceed: "{{name}} has too many parameters ({{count}}). Maximum allowed is {{max}}." } }, create: function(e25) {
  function t2(t3) {
    t3.params.length > a2 && e25.report({ loc: LA.getFunctionHeadLoc(t3, r2), node: t3, messageId: "exceed", data: { name: Fy.lodash.upperFirst(LA.getFunctionNameWithKind(t3)), count: t3.params.length, max: a2 } });
  }
  var r2 = e25.getSourceCode(), n2 = e25.options[0], a2 = 3;
  return i(n2) == "object" && (Object.prototype.hasOwnProperty.call(n2, "maximum") || Object.prototype.hasOwnProperty.call(n2, "max")) && (a2 = n2.maximum || n2.max), typeof n2 == "number" && (a2 = n2), { FunctionDeclaration: t2, ArrowFunctionExpression: t2, FunctionExpression: t2 };
} }, V_ = { meta: { type: "layout", docs: { description: "enforce a maximum number of statements allowed per line", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-statements-per-line" }, schema: [{ type: "object", properties: { max: { type: "integer", minimum: 1, default: 1 } }, additionalProperties: false }], messages: { exceed: "This line has {{numberOfStatementsOnThisLine}} {{statements}}. Maximum allowed is {{maxStatementsPerLine}}." } }, create: function(e25) {
  function t2() {
    i2 && e25.report({ node: i2, messageId: "exceed", data: { numberOfStatementsOnThisLine: c2, maxStatementsPerLine: s2, statements: c2 === 1 ? "statement" : "statements" } }), i2 = null;
  }
  function r2(e26) {
    var r3 = e26.loc.start.line;
    l2.test(e26.parent.type) && e26.parent.alternate !== e26 || (r3 === u2 ? c2 += 1 : (t2(), c2 = 1, u2 = r3), c2 === s2 + 1 && (i2 = i2 || e26));
  }
  function n2(e26) {
    var r3 = function(e27) {
      return a2.getLastToken(e27, LA.isNotSemicolonToken);
    }(e26).loc.end.line;
    r3 !== u2 && (t2(), c2 = 1, u2 = r3);
  }
  var i2, a2 = e25.getSourceCode(), o2 = e25.options[0] || {}, s2 = o2.max === void 0 ? 1 : o2.max, u2 = 0, c2 = 0, l2 = /^(?:(?:DoWhile|For|ForIn|ForOf|If|Labeled|While)Statement|Export(?:Default|Named)Declaration)$/;
  return { BreakStatement: r2, ClassDeclaration: r2, ContinueStatement: r2, DebuggerStatement: r2, DoWhileStatement: r2, ExpressionStatement: r2, ForInStatement: r2, ForOfStatement: r2, ForStatement: r2, FunctionDeclaration: r2, IfStatement: r2, ImportDeclaration: r2, LabeledStatement: r2, ReturnStatement: r2, SwitchStatement: r2, ThrowStatement: r2, TryStatement: r2, VariableDeclaration: r2, WhileStatement: r2, WithStatement: r2, ExportNamedDeclaration: r2, ExportDefaultDeclaration: r2, ExportAllDeclaration: r2, "BreakStatement:exit": n2, "ClassDeclaration:exit": n2, "ContinueStatement:exit": n2, "DebuggerStatement:exit": n2, "DoWhileStatement:exit": n2, "ExpressionStatement:exit": n2, "ForInStatement:exit": n2, "ForOfStatement:exit": n2, "ForStatement:exit": n2, "FunctionDeclaration:exit": n2, "IfStatement:exit": n2, "ImportDeclaration:exit": n2, "LabeledStatement:exit": n2, "ReturnStatement:exit": n2, "SwitchStatement:exit": n2, "ThrowStatement:exit": n2, "TryStatement:exit": n2, "VariableDeclaration:exit": n2, "WhileStatement:exit": n2, "WithStatement:exit": n2, "ExportNamedDeclaration:exit": n2, "ExportDefaultDeclaration:exit": n2, "ExportAllDeclaration:exit": n2, "Program:exit": t2 };
} }, U_ = { meta: { type: "suggestion", docs: { description: "enforce a maximum number of statements allowed in function blocks", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/max-statements" }, schema: [{ oneOf: [{ type: "integer", minimum: 0 }, { type: "object", properties: { maximum: { type: "integer", minimum: 0 }, max: { type: "integer", minimum: 0 } }, additionalProperties: false }] }, { type: "object", properties: { ignoreTopLevelFunctions: { type: "boolean" } }, additionalProperties: false }], messages: { exceed: "{{name}} has too many statements ({{count}}). Maximum allowed is {{max}}." } }, create: function(e25) {
  function t2(t3, r3, n3) {
    if (r3 > n3) {
      var i2 = Fy.lodash.upperFirst(LA.getFunctionNameWithKind(t3));
      e25.report({ node: t3, messageId: "exceed", data: { name: i2, count: r3, max: n3 } });
    }
  }
  function r2() {
    a2.push(0);
  }
  function n2(e26) {
    var r3 = a2.pop();
    s2 && a2.length === 0 ? u2.push({ node: e26, count: r3 }) : t2(e26, r3, c2);
  }
  var a2 = [], o2 = e25.options[0], s2 = e25.options[1] && e25.options[1].ignoreTopLevelFunctions || false, u2 = [], c2 = 10;
  return i(o2) == "object" && (Object.prototype.hasOwnProperty.call(o2, "maximum") || Object.prototype.hasOwnProperty.call(o2, "max")) ? c2 = o2.maximum || o2.max : typeof o2 == "number" && (c2 = o2), { FunctionDeclaration: r2, FunctionExpression: r2, ArrowFunctionExpression: r2, BlockStatement: function(e26) {
    a2[a2.length - 1] += e26.body.length;
  }, "FunctionDeclaration:exit": n2, "FunctionExpression:exit": n2, "ArrowFunctionExpression:exit": n2, "Program:exit": function() {
    u2.length === 1 || u2.forEach(function(e26) {
      var r3 = e26.count;
      t2(e26.node, r3, c2);
    });
  } };
} }, q_ = { meta: { type: "suggestion", docs: { description: "enforce a particular style for multiline comments", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/multiline-comment-style" }, fixable: "whitespace", schema: [{ enum: ["starred-block", "separate-lines", "bare-block"] }], messages: { expectedBlock: "Expected a block comment instead of consecutive line comments.", expectedBareBlock: "Expected a block comment without padding stars.", startNewline: "Expected a linebreak after '/*'.", endNewline: "Expected a linebreak before '*/'.", missingStar: "Expected a '*' at the start of this line.", alignment: "Expected this line to be aligned with the start of the comment.", expectedLines: "Expected multiple line comments instead of a block comment." } }, create: function(e25) {
  function t2(e26) {
    var t3 = b(e26, 1)[0];
    if (t3.type !== "Block")
      return false;
    var r3 = t3.value.split(LA.LINEBREAK_MATCHER);
    return 0 < r3.length && r3.every(function(e27, t4) {
      return (t4 === 0 || t4 === r3.length - 1 ? /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/ : /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*/).test(e27);
    });
  }
  function r2(e26) {
    var t3 = b(e26, 1)[0];
    if (t3.type !== "Block")
      return false;
    var r3 = t3.value.split(LA.LINEBREAK_MATCHER);
    return /^\*[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/.test(r3[0]) && r3.slice(1, -1).every(function(e27) {
      return /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]* /.test(e27);
    }) && /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/.test(r3[r3.length - 1]);
  }
  function n2(e26) {
    var r3 = b(e26, 1)[0];
    return r3.type === "Line" ? function(e27) {
      var t3 = e27.map(function(e28) {
        return e28.value;
      }).filter(function(e28) {
        return e28.trim().length;
      }).every(function(e28) {
        return e28.startsWith(" ");
      });
      return e27.map(function(e28) {
        var r4 = e28.value;
        return t3 ? r4.replace(/^ /, "") : r4;
      });
    }(e26) : t2(e26) ? function(e27) {
      var t3 = e27.value.split(LA.LINEBREAK_MATCHER).filter(function(e28, t4, r5) {
        return t4 !== 0 && t4 !== r5.length - 1;
      }).map(function(e28) {
        return e28.replace(/^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "");
      }), r4 = t3.map(function(e28) {
        return e28.replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*/, "");
      }).filter(function(e28) {
        return e28.trim().length;
      }).every(function(e28) {
        return e28.startsWith(" ");
      });
      return t3.map(function(e28) {
        return e28.replace(r4 ? /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\* ?/ : /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*/, "");
      });
    }(r3) : function(e27) {
      var t3 = e27.value.split(LA.LINEBREAK_MATCHER).map(function(e28) {
        return e28.replace(/^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "");
      }), r4 = "".concat(o2.text.slice(e27.range[0] - e27.loc.start.column, e27.range[0]), "   "), n3 = "", i3 = true, a3 = false, s3 = void 0;
      try {
        for (var u3, c2 = t3.entries()[Symbol.iterator](); !(i3 = (u3 = c2.next()).done); i3 = true) {
          var l2 = b(u3.value, 2), p2 = l2[0], f2 = l2[1];
          if (f2.trim().length && p2 !== 0) {
            var h2 = b(f2.match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)/), 2)[1];
            if (h2.length < r4.length) {
              var d2 = r4.slice(h2.length - r4.length);
              d2.length > n3.length && (n3 = d2);
            }
          }
        }
      } catch (e28) {
        a3 = true, s3 = e28;
      } finally {
        try {
          i3 || c2.return == null || c2.return();
        } finally {
          if (a3)
            throw s3;
        }
      }
      return t3.map(function(e28) {
        var t4 = b(e28.match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)/), 3), i4 = t4[1], a4 = t4[2];
        return i4.length > r4.length ? "".concat(i4.slice(r4.length - (n3.length + i4.length))).concat(a4) : i4.length < r4.length ? "".concat(i4.slice(r4.length)).concat(a4) : a4;
      });
    }(r3);
  }
  function i2(e26) {
    return o2.text.slice(e26.range[0] - e26.loc.start.column, e26.range[0]);
  }
  function a2(e26, t3) {
    return "/* ".concat(t3.join("\n".concat(i2(e26), "   ")), " */");
  }
  var o2 = e25.getSourceCode(), s2 = e25.options[0] || "starred-block", u2 = { "starred-block": function(t3) {
    var r3 = b(t3, 1)[0], a3 = n2(t3);
    a3.some(function(e26) {
      return e26.includes("*/");
    }) || (1 < t3.length ? e25.report({ loc: { start: r3.loc.start, end: t3[t3.length - 1].loc.end }, messageId: "expectedBlock", fix: function(e26) {
      var n3 = [r3.range[0], t3[t3.length - 1].range[1]];
      return a3.some(function(e27) {
        return e27.startsWith("/");
      }) ? null : e26.replaceTextRange(n3, function(e27, t4) {
        var r4 = i2(e27);
        return "/*\n".concat(t4.map(function(e28) {
          return "".concat(r4, " * ").concat(e28);
        }).join("\n"), "\n").concat(r4, " */");
      }(r3, a3));
    } }) : function() {
      var t4 = r3.value.split(LA.LINEBREAK_MATCHER), n3 = i2(r3), a4 = "".concat(n3, " *");
      if (!/^\*?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/.test(t4[0])) {
        var s3 = r3.value.startsWith("*") ? r3.range[0] + 1 : r3.range[0];
        e25.report({ loc: { start: r3.loc.start, end: { line: r3.loc.start.line, column: r3.loc.start.column + 2 } }, messageId: "startNewline", fix: function(e26) {
          return e26.insertTextAfterRange([s3, s3 + 2], "\n".concat(a4));
        } });
      }
      /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/.test(t4[t4.length - 1]) || e25.report({ loc: { start: { line: r3.loc.end.line, column: r3.loc.end.column - 2 }, end: r3.loc.end }, messageId: "endNewline", fix: function(e26) {
        return e26.replaceTextRange([r3.range[1] - 2, r3.range[1]], "\n".concat(a4, "/"));
      } });
      for (var u3 = function(n4) {
        var i3 = o2.lines[n4 - 1], s4 = function(e26) {
          return /^[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*/.test(e26);
        }(i3) ? "alignment" : "missingStar";
        i3.startsWith(a4) || e25.report({ loc: { start: { line: n4, column: 0 }, end: { line: n4, column: i3.length } }, messageId: s4, fix: function(e26) {
          var u4 = o2.getIndexFromLoc({ line: n4, column: 0 });
          if (s4 === "alignment") {
            var c3 = b(i3.match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\*)/) || [], 2)[1], l2 = u4 + (c3 === void 0 ? "" : c3).length;
            return e26.replaceTextRange([u4, l2], a4);
          }
          var p2, f2 = b(i3.match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)/) || [], 2)[1], h2 = f2 === void 0 ? "" : f2, d2 = u4 + h2.length, m2 = true, g2 = false, y2 = void 0;
          try {
            for (var v2, x2 = t4.entries()[Symbol.iterator](); !(m2 = (v2 = x2.next()).done); m2 = true) {
              var E2 = b(v2.value, 2), C2 = E2[0], S2 = E2[1];
              if (/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+/.test(S2)) {
                var k2 = b(o2.lines[r3.loc.start.line - 1 + C2].match(/^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*(?:\/?\*)?([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*))/) || [], 3), D2 = k2[1], F2 = D2 === void 0 ? "" : D2, A2 = k2[2], w2 = A2 === void 0 ? "" : A2;
                p2 = "".concat(h2.slice(F2.length)).concat(w2);
                break;
              }
            }
          } catch (e27) {
            g2 = true, y2 = e27;
          } finally {
            try {
              m2 || x2.return == null || x2.return();
            } finally {
              if (g2)
                throw y2;
            }
          }
          return e26.replaceTextRange([u4, d2], "".concat(a4).concat(p2));
        } });
      }, c2 = r3.loc.start.line + 1; c2 <= r3.loc.end.line; c2++)
        u3(c2);
    }());
  }, "separate-lines": function(t3) {
    var a3 = b(t3, 1)[0];
    if (a3.type === "Block" && !r2(t3)) {
      var s3 = n2(t3), u3 = o2.getTokenAfter(a3, { includeComments: true });
      u3 && a3.loc.end.line === u3.loc.start.line || e25.report({ loc: { start: a3.loc.start, end: { line: a3.loc.start.line, column: a3.loc.start.column + 2 } }, messageId: "expectedLines", fix: function(e26) {
        return e26.replaceText(a3, function(e27, t4) {
          return t4.map(function(e28) {
            return "// ".concat(e28);
          }).join("\n".concat(i2(e27)));
        }(a3, s3));
      } });
    }
  }, "bare-block": function(i3) {
    if (!r2(i3)) {
      var o3 = b(i3, 1)[0], s3 = n2(i3);
      o3.type === "Line" && 1 < s3.length && !s3.some(function(e26) {
        return e26.includes("*/");
      }) && e25.report({ loc: { start: o3.loc.start, end: i3[i3.length - 1].loc.end }, messageId: "expectedBlock", fix: function(e26) {
        return e26.replaceTextRange([o3.range[0], i3[i3.length - 1].range[1]], a2(o3, s3));
      } }), t2(i3) && e25.report({ loc: { start: o3.loc.start, end: { line: o3.loc.start.line, column: o3.loc.start.column + 2 } }, messageId: "expectedBareBlock", fix: function(e26) {
        return e26.replaceText(o3, a2(o3, s3));
      } });
    }
  } };
  return { Program: function() {
    return o2.getAllComments().filter(function(e26) {
      return e26.type !== "Shebang";
    }).filter(function(e26) {
      return !LA.COMMENTS_IGNORE_PATTERN.test(e26.value);
    }).filter(function(e26) {
      var t3 = o2.getTokenBefore(e26, { includeComments: true });
      return !t3 || t3.loc.end.line < e26.loc.start.line;
    }).reduce(function(e26, t3, r3, n3) {
      var i3 = o2.getTokenBefore(t3, { includeComments: true });
      return t3.type === "Line" && r3 && n3[r3 - 1].type === "Line" && i3 && i3.loc.end.line === t3.loc.start.line - 1 && i3 === n3[r3 - 1] ? e26[e26.length - 1].push(t3) : e26.push([t3]), e26;
    }, []).filter(function(e26) {
      return e26.length !== 1 || e26[0].loc.start.line !== e26[0].loc.end.line;
    }).forEach(u2[s2]);
  } };
} }, W_ = { meta: { type: "layout", docs: { description: "enforce newlines between operands of ternary expressions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/multiline-ternary" }, schema: [{ enum: ["always", "always-multiline", "never"] }], messages: { expectedTestCons: "Expected newline between test and consequent of ternary expression.", expectedConsAlt: "Expected newline between consequent and alternate of ternary expression.", unexpectedTestCons: "Unexpected newline between test and consequent of ternary expression.", unexpectedConsAlt: "Unexpected newline between consequent and alternate of ternary expression." } }, create: function(e25) {
  function t2(t3, r3, n2) {
    e25.report({ node: t3, messageId: "".concat(n2 ? "expected" : "unexpected").concat(t3 === r3.test ? "TestCons" : "ConsAlt") });
  }
  var r2 = e25.options[0];
  return { ConditionalExpression: function(e26) {
    var n2 = LA.isTokenOnSameLine(e26.test, e26.consequent), i2 = LA.isTokenOnSameLine(e26.consequent, e26.alternate);
    if (r2 === "never")
      n2 || t2(e26.test, e26, false), i2 || t2(e26.consequent, e26, false);
    else {
      if (r2 === "always-multiline" && e26.loc.start.line === e26.loc.end.line)
        return;
      n2 && t2(e26.test, e26, true), i2 && t2(e26.consequent, e26, true);
    }
  } };
} }, $_ = ["Array", "Boolean", "Date", "Error", "Function", "Number", "Object", "RegExp", "String", "Symbol", "BigInt"];
function G_(e25, t2, r2) {
  if (Object.prototype.hasOwnProperty.call(e25, t2) && !Array.isArray(e25[t2]))
    throw new TypeError("".concat(t2, ", if provided, must be an Array"));
  return e25[t2] || r2;
}
function z_(e25, t2) {
  return e25[t2] = true, e25;
}
var H_ = { meta: { type: "suggestion", docs: { description: "require constructor names to begin with a capital letter", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/new-cap" }, schema: [{ type: "object", properties: { newIsCap: { type: "boolean", default: true }, capIsNew: { type: "boolean", default: true }, newIsCapExceptions: { type: "array", items: { type: "string" } }, newIsCapExceptionPattern: { type: "string" }, capIsNewExceptions: { type: "array", items: { type: "string" } }, capIsNewExceptionPattern: { type: "string" }, properties: { type: "boolean", default: true } }, additionalProperties: false }], messages: { upper: "A function with a name starting with an uppercase letter should only be used as a constructor.", lower: "A constructor name should not start with a lowercase letter." } }, create: function(e25) {
  function t2(e26) {
    var t3 = "";
    if (e26.callee.type === "MemberExpression") {
      var r3 = e26.callee.property;
      r3.type === "Literal" && typeof r3.value == "string" ? t3 = r3.value : r3.type === "Identifier" && !e26.callee.computed && (t3 = r3.name);
    } else
      t3 = e26.callee.name;
    return t3;
  }
  function r2(e26) {
    var t3 = e26.charAt(0), r3 = t3.toLowerCase();
    return r3 === t3.toUpperCase() ? "non-alpha" : t3 === r3 ? "lower" : "upper";
  }
  function n2(e26, t3, r3, n3) {
    var i3 = f2.getText(t3.callee);
    return !(!e26[r3] && !e26[i3]) || !(!n3 || !n3.test(i3)) || (r3 === "UTC" && t3.callee.type === "MemberExpression" ? t3.callee.object.type === "Identifier" && t3.callee.object.name === "Date" : o2 && t3.callee.type === "MemberExpression");
  }
  function i2(t3, r3) {
    var n3 = t3.callee;
    n3.type === "MemberExpression" && (n3 = n3.property), e25.report({ node: t3, loc: n3.loc.start, messageId: r3 });
  }
  var a2 = Object.assign({}, e25.options[0]);
  a2.newIsCap = a2.newIsCap !== false, a2.capIsNew = a2.capIsNew !== false;
  var o2 = a2.properties === false, s2 = G_(a2, "newIsCapExceptions", []).reduce(z_, {}), u2 = a2.newIsCapExceptionPattern ? new RegExp(a2.newIsCapExceptionPattern, "u") : null, c2 = function(e26) {
    var t3 = G_(e26, "capIsNewExceptions", $_);
    return t3 !== $_ && (t3 = t3.concat($_)), t3.reduce(z_, {});
  }(a2), l2 = a2.capIsNewExceptionPattern ? new RegExp(a2.capIsNewExceptionPattern, "u") : null, p2 = {}, f2 = e25.getSourceCode();
  return a2.newIsCap && (p2.NewExpression = function(e26) {
    var a3 = t2(e26);
    a3 && (r2(a3) !== "lower" || n2(s2, e26, a3, u2) || i2(e26, "lower"));
  }), a2.capIsNew && (p2.CallExpression = function(e26) {
    var a3 = t2(e26);
    a3 && (r2(a3) !== "upper" || n2(c2, e26, a3, l2) || i2(e26, "upper"));
  }), p2;
} }, K_ = { meta: { type: "layout", docs: { description: "enforce or disallow parentheses when invoking a constructor with no arguments", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/new-parens" }, fixable: "code", schema: { anyOf: [{ type: "array", items: [{ enum: ["always", "never"] }], minItems: 0, maxItems: 1 }] }, messages: { missing: "Missing '()' invoking a constructor.", unnecessary: "Unnecessary '()' invoking a constructor with no arguments." } }, create: function(e25) {
  var t2 = e25.options[0] !== "never", r2 = e25.getSourceCode();
  return { NewExpression: function(n2) {
    if (n2.arguments.length === 0) {
      var i2 = r2.getLastToken(n2), a2 = i2 && LA.isClosingParenToken(i2) && LA.isOpeningParenToken(r2.getTokenBefore(i2)) && n2.callee.range[1] < n2.range[1];
      t2 ? !a2 && e25.report({ node: n2, messageId: "missing", fix: function(e26) {
        return e26.insertTextAfter(n2, "()");
      } }) : a2 && e25.report({ node: n2, messageId: "unnecessary", fix: function(e26) {
        return [e26.remove(r2.getTokenBefore(i2)), e26.remove(i2), e26.insertTextBefore(n2, "("), e26.insertTextAfter(n2, ")")];
      } });
    }
  } };
} }, J_ = { meta: { type: "layout", docs: { description: "require or disallow an empty line after variable declarations", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/newline-after-var" }, schema: [{ enum: ["never", "always"] }], fixable: "whitespace", messages: { expected: "Expected blank line after variable declarations.", unexpected: "Unexpected blank line after variable declarations." }, deprecated: true, replacedBy: ["padding-line-between-statements"] }, create: function(e25) {
  function t2(e26) {
    var r3 = i2[e26];
    return i2[r3 + 1] ? t2(r3 + 1) : r3;
  }
  var r2 = e25.getSourceCode(), n2 = e25.options[0] === "never" ? "never" : "always", i2 = r2.getAllComments().reduce(function(e26, t3) {
    return e26[t3.loc.start.line] = t3.loc.end.line, e26;
  }, {});
  return { VariableDeclaration: function(a2) {
    var o2 = function(e26) {
      var t3 = r2.getLastToken(e26);
      if (t3.type === "Punctuator" && t3.value === ";") {
        var n3 = r2.getTokenBefore(t3);
        if (n3.loc.end.line !== t3.loc.start.line)
          return n3;
      }
      return t3;
    }(a2), s2 = o2 === r2.getLastToken(a2) ? r2.getTokenAfter(a2) : r2.getLastToken(a2), u2 = o2.loc.end.line + 1;
    if (s2 && !function(e26) {
      return e26 === "ForStatement" || e26 === "ForInStatement" || e26 === "ForOfStatement";
    }(a2.parent.type) && !function(e26) {
      return e26 === "ExportNamedDeclaration" || e26 === "ExportSpecifier" || e26 === "ExportDefaultDeclaration" || e26 === "ExportAllDeclaration";
    }(a2.parent.type) && !(s2.type === "Keyword" && function(e26) {
      return e26 === "var" || e26 === "let" || e26 === "const";
    }(s2.value) || function(e26) {
      var t3 = r2.getTokenAfter(e26);
      return !t3 || t3.type === "Punctuator" && t3.value === "}";
    }(a2))) {
      var c2 = s2.loc.start.line > u2, l2 = i2[u2] !== void 0;
      n2 === "never" && c2 && !l2 && e25.report({ node: a2, messageId: "unexpected", data: { identifier: a2.name }, fix: function(e26) {
        var t3 = r2.getText().slice(o2.range[1], s2.range[0]).split(LA.LINEBREAK_MATCHER);
        return e26.replaceTextRange([o2.range[1], s2.range[0]], "".concat(t3.slice(0, -1).join(""), "\n").concat(t3[t3.length - 1]));
      } }), n2 !== "always" || c2 && (!l2 || function(e26, r3) {
        return e26.loc.start.line > t2(r3) + 1;
      }(s2, u2)) || e25.report({ node: a2, messageId: "expected", data: { identifier: a2.name }, fix: function(e26) {
        return (c2 ? t2(u2) : o2.loc.end.line) === s2.loc.start.line ? e26.insertTextBefore(s2, "\n\n") : e26.insertTextBeforeRange([s2.range[0] - s2.loc.start.column, s2.range[1]], "\n");
      } });
    }
  } };
} }, Q_ = { meta: { type: "layout", docs: { description: "require an empty line before `return` statements", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/newline-before-return" }, fixable: "whitespace", schema: [], messages: { expected: "Expected newline before return statement." }, deprecated: true, replacedBy: ["padding-line-between-statements"] }, create: function(e25) {
  function t2(e26, t3) {
    var r3 = i2.getTokenBefore(e26);
    return t3.some(function(e27) {
      return r3.value === e27;
    });
  }
  function r2(e26) {
    var r3 = e26.parent.type;
    return e26.parent.body ? Array.isArray(e26.parent.body) ? e26.parent.body[0] === e26 : e26.parent.body === e26 : t2(e26, r3 === "IfStatement" ? ["else", ")"] : r3 === "DoWhileStatement" ? ["do"] : r3 === "SwitchCase" ? [":"] : [")"]);
  }
  function n2(e26) {
    var t3 = e26.loc.start.line, r3 = function(e27) {
      var t4 = i2.getTokenBefore(e27);
      return t4 ? t4.loc.end.line : 0;
    }(e26), n3 = function(e27, t4) {
      var r4 = i2.getCommentsBefore(e27), n4 = 0;
      return r4.length ? (r4.forEach(function(r5) {
        n4++, r5.type === "Block" && (n4 += r5.loc.end.line - r5.loc.start.line), r5.loc.start.line === t4 && n4--, r5.loc.end.line === e27.loc.start.line && n4--;
      }), n4) : n4;
    }(e26, r3);
    return 1 < t3 - r3 - n3;
  }
  var i2 = e25.getSourceCode();
  return { ReturnStatement: function(t3) {
    r2(t3) || n2(t3) || e25.report({ node: t3, messageId: "expected", fix: function(e26) {
      if (function(e27) {
        var t4 = i2.getCommentsBefore(e27), r4 = t4[t4.length - 1], n4 = i2.getTokenBefore(e27);
        return !(t4.length !== 0 && (r4.loc.end.line !== n4.loc.end.line || r4.loc.end.line === e27.loc.start.line));
      }(t3)) {
        var r3 = i2.getTokenBefore(t3), n3 = t3.loc.start.line === r3.loc.end.line ? "\n\n" : "\n";
        return e26.insertTextBefore(t3, n3);
      }
      return null;
    } });
  } };
} }, X_ = { meta: { type: "layout", docs: { description: "require a newline after each call in a method chain", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/newline-per-chained-call" }, fixable: "whitespace", schema: [{ type: "object", properties: { ignoreChainWithDepth: { type: "integer", minimum: 1, maximum: 10, default: 2 } }, additionalProperties: false }], messages: { expected: "Expected line break before `{{callee}}`." } }, create: function(e25) {
  function t2(e26) {
    var t3 = function(e27) {
      return e27.computed ? "[" : ".";
    }(e26), r3 = n2.getText(e26.property).split(LA.LINEBREAK_MATCHER), i2 = e26.computed && r3.length === 1 ? "]" : "";
    return t3 + r3[0] + i2;
  }
  var r2 = (e25.options[0] || {}).ignoreChainWithDepth || 2, n2 = e25.getSourceCode();
  return { "CallExpression:exit": function(i2) {
    if (i2.callee && i2.callee.type === "MemberExpression") {
      for (var a2 = i2.callee, o2 = a2.object, s2 = 1; o2 && o2.callee; )
        s2 += 1, o2 = o2.callee.object;
      s2 > r2 && LA.isTokenOnSameLine(a2.object, a2.property) && e25.report({ node: a2.property, loc: a2.property.loc.start, messageId: "expected", data: { callee: t2(a2) }, fix: function(e26) {
        var t3 = n2.getTokenAfter(a2.object, LA.isNotClosingParenToken);
        return e26.insertTextBefore(t3, "\n");
      } });
    }
  } };
} }, Y_ = LA.getStaticPropertyName;
function Z_(e25) {
  return /^(alert|confirm|prompt)$/.test(e25);
}
function eT(e25, t2) {
  var r2 = function(e26, t3) {
    var r3 = e26.references.filter(function(e27) {
      return e27.identifier.range[0] === t3.range[0] && e27.identifier.range[1] === t3.range[1];
    });
    return r3.length === 1 ? r3[0] : null;
  }(e25, t2);
  return r2 && r2.resolved && 0 < r2.resolved.defs.length;
}
var tT = { meta: { type: "suggestion", docs: { description: "disallow the use of `alert`, `confirm`, and `prompt`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-alert" }, schema: [], messages: { unexpected: "Unexpected {{name}}." } }, create: function(e25) {
  return { CallExpression: function(t2) {
    var r2 = t2.callee, n2 = e25.getScope();
    if (r2.type === "Identifier") {
      var i2 = r2.name;
      !eT(n2, r2) && Z_(r2.name) && e25.report({ node: t2, messageId: "unexpected", data: { name: i2 } });
    } else if (r2.type === "MemberExpression" && function(e26, t3) {
      return !(e26.type !== "global" || t3.type !== "ThisExpression") || !(t3.name !== "window") && !eT(e26, t3);
    }(n2, r2.object)) {
      var a2 = Y_(r2);
      Z_(a2) && e25.report({ node: t2, messageId: "unexpected", data: { name: a2 } });
    }
  } };
} };
function rT(e25) {
  var t2 = e25.type;
  return t2 === "FunctionDeclaration" || t2 === "FunctionExpression" || t2 === "ArrowFunctionExpression" || t2 === "ForOfStatement" && e25.await === true;
}
function nT(e25, t2) {
  switch (t2.type) {
    case "ForStatement":
      return e25 === t2.test || e25 === t2.update || e25 === t2.body;
    case "ForOfStatement":
    case "ForInStatement":
      return e25 === t2.body;
    case "WhileStatement":
    case "DoWhileStatement":
      return e25 === t2.test || e25 === t2.body;
    default:
      return false;
  }
}
var iT = { meta: { type: "problem", docs: { description: "disallow `await` inside of loops", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-await-in-loop" }, schema: [], messages: { unexpectedAwait: "Unexpected `await` inside a loop." } }, create: function(e25) {
  function t2(t3) {
    if (t3.type !== "ForOfStatement" || t3.await)
      for (var r2 = t3, n2 = r2.parent; n2 && !rT(n2); ) {
        if (nT(r2, n2))
          return void e25.report({ node: t3, messageId: "unexpectedAwait" });
        r2 = n2, n2 = n2.parent;
      }
  }
  return { AwaitExpression: t2, ForOfStatement: t2 };
} }, aT = ["^", "|", "&", "<<", ">>", ">>>", "^=", "|=", "&=", "<<=", ">>=", ">>>=", "~"], oT = { meta: { type: "suggestion", docs: { description: "disallow bitwise operators", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-bitwise" }, schema: [{ type: "object", properties: { allow: { type: "array", items: { enum: aT }, uniqueItems: true }, int32Hint: { type: "boolean", default: false } }, additionalProperties: false }], messages: { unexpected: "Unexpected use of '{{operator}}'." } }, create: function(e25) {
  function t2(t3) {
    e25.report({ node: t3, messageId: "unexpected", data: { operator: t3.operator } });
  }
  function r2(e26) {
    !function(e27) {
      return aT.indexOf(e27.operator) !== -1;
    }(e26) || function(e27) {
      return i2.indexOf(e27.operator) !== -1;
    }(e26) || function(e27) {
      return a2 && e27.operator === "|" && e27.right && e27.right.type === "Literal" && e27.right.value === 0;
    }(e26) || t2(e26);
  }
  var n2 = e25.options[0] || {}, i2 = n2.allow || [], a2 = n2.int32Hint === true;
  return { AssignmentExpression: r2, BinaryExpression: r2, UnaryExpression: r2 };
} }, sT = { meta: { type: "suggestion", docs: { description: "disallow `catch` clause parameters from shadowing variables in the outer scope", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-catch-shadow" }, replacedBy: ["no-shadow"], deprecated: true, schema: [], messages: { mutable: "Value of '{{name}}' may be overwritten in IE 8 and earlier." } }, create: function(e25) {
  return { "CatchClause[param!=null]": function(t2) {
    var r2 = e25.getScope();
    r2.block === t2 && (r2 = r2.upper), function(e26, t3) {
      return LA.getVariableByName(e26, t3) !== null;
    }(r2, t2.param.name) && e25.report({ node: t2, messageId: "mutable", data: { name: t2.param.name } });
  } };
} }, uT = { meta: { type: "problem", docs: { description: "disallow reassigning class members", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/no-class-assign" }, schema: [], messages: { class: "'{{name}}' is a class." } }, create: function(e25) {
  function t2(t3) {
    LA.getModifyingReferences(t3.references).forEach(function(t4) {
      e25.report({ node: t4.identifier, messageId: "class", data: { name: t4.identifier.name } });
    });
  }
  function r2(r3) {
    e25.getDeclaredVariables(r3).forEach(t2);
  }
  return { ClassDeclaration: r2, ClassExpression: r2 };
} }, cT = { meta: { type: "problem", docs: { description: "disallow comparing against -0", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-compare-neg-zero" }, fixable: null, schema: [], messages: { unexpected: "Do not use the '{{operator}}' operator to compare against -0." } }, create: function(e25) {
  function t2(e26) {
    return e26.type === "UnaryExpression" && e26.operator === "-" && e26.argument.type === "Literal" && e26.argument.value === 0;
  }
  var r2 = new Set([">", ">=", "<", "<=", "==", "===", "!=", "!=="]);
  return { BinaryExpression: function(n2) {
    r2.has(n2.operator) && (t2(n2.left) || t2(n2.right)) && e25.report({ node: n2, messageId: "unexpected", data: { operator: n2.operator } });
  } };
} }, lT = new Set(["IfStatement", "WhileStatement", "DoWhileStatement", "ForStatement", "ConditionalExpression"]), pT = { DoWhileStatement: "a 'do...while' statement", ForStatement: "a 'for' statement", IfStatement: "an 'if' statement", WhileStatement: "a 'while' statement" }, fT = { meta: { type: "problem", docs: { description: "disallow assignment operators in conditional expressions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-cond-assign" }, schema: [{ enum: ["except-parens", "always"] }], messages: { unexpected: "Unexpected assignment within {{type}}.", missing: "Expected a conditional expression and instead saw an assignment." } }, create: function(e25) {
  function t2(e26) {
    return e26.parent && lT.has(e26.parent.type) && e26 === e26.parent.test;
  }
  function r2(e26) {
    var r3 = e26;
    do {
      if (t2(r3))
        return r3.parent;
    } while ((r3 = r3.parent) && !LA.isFunction(r3));
    return null;
  }
  function n2(t3) {
    t3.test && t3.test.type === "AssignmentExpression" && (t3.type === "ForStatement" ? !LA.isParenthesised(a2, t3.test) : !function(e26) {
      var t4 = a2.getTokenBefore(e26, 1), r3 = a2.getTokenAfter(e26, 1);
      return LA.isParenthesised(a2, e26) && t4 && LA.isOpeningParenToken(t4) && t4.range[1] <= e26.range[0] && LA.isClosingParenToken(r3) && r3.range[0] >= e26.range[1];
    }(t3.test)) && e25.report({ node: t3.test, messageId: "missing" });
  }
  var i2 = e25.options[0] || "except-parens", a2 = e25.getSourceCode();
  return i2 === "always" ? { AssignmentExpression: function(t3) {
    var n3 = r2(t3);
    n3 && e25.report({ node: t3, messageId: "unexpected", data: { type: pT[n3.type] || n3.type } });
  } } : { DoWhileStatement: n2, ForStatement: n2, IfStatement: n2, WhileStatement: n2, ConditionalExpression: n2 };
} };
var hT = { meta: { type: "suggestion", docs: { description: "disallow arrow functions where they could be confused with comparisons", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-confusing-arrow" }, fixable: "code", schema: [{ type: "object", properties: { allowParens: { type: "boolean", default: true } }, additionalProperties: false }], messages: { confusing: "Arrow function used ambiguously with a conditional expression." } }, create: function(e25) {
  var t2 = e25.options[0] || {}, r2 = t2.allowParens || t2.allowParens === void 0, n2 = e25.getSourceCode();
  return { ArrowFunctionExpression: function(t3) {
    var i2 = t3.body;
    (function(e26) {
      return e26 && e26.type === "ConditionalExpression";
    })(i2) && (!r2 || !LA.isParenthesised(n2, i2)) && e25.report({ node: t3, messageId: "confusing", fix: function(e26) {
      return r2 && e26.replaceText(t3.body, "(".concat(n2.getText(t3.body), ")"));
    } });
  } };
} }, dT = { meta: { type: "suggestion", docs: { description: "disallow the use of `console`", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-console" }, schema: [{ type: "object", properties: { allow: { type: "array", items: { type: "string" }, minItems: 1, uniqueItems: true } }, additionalProperties: false }], messages: { unexpected: "Unexpected console statement." } }, create: function(e25) {
  function t2(e26) {
    var t3 = e26.identifier;
    return t3 && t3.name === "console";
  }
  function r2(e26) {
    var t3 = e26.identifier, r3 = t3.parent;
    return r3.type === "MemberExpression" && r3.object === t3 && !function(e27) {
      var t4 = LA.getStaticPropertyName(e27);
      return t4 && i2.indexOf(t4) !== -1;
    }(r3);
  }
  function n2(t3) {
    var r3 = t3.identifier.parent;
    e25.report({ node: r3, loc: r3.loc, messageId: "unexpected" });
  }
  var i2 = (e25.options[0] || {}).allow || [];
  return { "Program:exit": function() {
    var i3 = e25.getScope(), a2 = LA.getVariableByName(i3, "console"), o2 = a2 && 0 < a2.defs.length, s2 = a2 ? a2.references : i3.through.filter(t2);
    o2 || s2.filter(r2).forEach(n2);
  } };
} }, mT = { meta: { type: "problem", docs: { description: "disallow reassigning `const` variables", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/no-const-assign" }, schema: [], messages: { const: "'{{name}}' is constant." } }, create: function(e25) {
  function t2(t3) {
    LA.getModifyingReferences(t3.references).forEach(function(t4) {
      e25.report({ node: t4.identifier, messageId: "const", data: { name: t4.identifier.name } });
    });
  }
  return { VariableDeclaration: function(r2) {
    r2.kind === "const" && e25.getDeclaredVariables(r2).forEach(t2);
  } };
} }, gT = ["===", "!==", "==", "!="], yT = [">", "<", ">=", "<=", "in", "instanceof"], vT = { meta: { type: "problem", docs: { description: "disallow constant expressions in conditions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-constant-condition" }, schema: [{ type: "object", properties: { checkLoops: { type: "boolean", default: true } }, additionalProperties: false }], messages: { unexpected: "Unexpected constant condition." } }, create: function(e25) {
  function t2(e26, r3) {
    switch (e26.type) {
      case "Literal":
        return r3 === "||" && e26.value === true || r3 === "&&" && e26.value === false;
      case "UnaryExpression":
        return r3 === "&&" && e26.operator === "void";
      case "LogicalExpression":
        return t2(e26.left, e26.operator) || t2(e26.right, e26.operator);
    }
    return false;
  }
  function r2(e26, n3) {
    switch (e26.type) {
      case "Literal":
      case "ArrowFunctionExpression":
      case "FunctionExpression":
      case "ObjectExpression":
      case "ArrayExpression":
        return true;
      case "UnaryExpression":
        return !(e26.operator !== "void") || e26.operator === "typeof" && n3 || r2(e26.argument, true);
      case "BinaryExpression":
        return r2(e26.left, false) && r2(e26.right, false) && e26.operator !== "in";
      case "LogicalExpression":
        var i3 = r2(e26.left, n3), a3 = r2(e26.right, n3), o3 = i3 && t2(e26.left, e26.operator), s3 = a3 && t2(e26.right, e26.operator);
        return i3 && a3 || e26.operator === "||" && a3 && e26.right.value && (!e26.parent || e26.parent.type !== "BinaryExpression" || !(gT.includes(e26.parent.operator) || yT.includes(e26.parent.operator))) || o3 || s3;
      case "AssignmentExpression":
        return e26.operator === "=" && r2(e26.right, n3);
      case "SequenceExpression":
        return r2(e26.expressions[e26.expressions.length - 1], n3);
    }
    return false;
  }
  function n2(t3) {
    l2.has(t3) && (l2.delete(t3), e25.report({ node: t3.test, messageId: "unexpected" }));
  }
  function i2(t3) {
    t3.test && r2(t3.test, true) && e25.report({ node: t3.test, messageId: "unexpected" });
  }
  function a2() {
    c2.push(l2), l2 = new Set();
  }
  function o2() {
    l2 = c2.pop();
  }
  function s2(e26) {
    u2 && function(e27) {
      e27.test && r2(e27.test, true) && l2.add(e27);
    }(e26);
  }
  var u2 = (e25.options[0] || {}).checkLoops !== false, c2 = [], l2 = new Set();
  return { ConditionalExpression: i2, IfStatement: i2, WhileStatement: s2, "WhileStatement:exit": n2, DoWhileStatement: s2, "DoWhileStatement:exit": n2, ForStatement: s2, "ForStatement > .test": function(e26) {
    return s2(e26.parent);
  }, "ForStatement:exit": n2, FunctionDeclaration: a2, "FunctionDeclaration:exit": o2, FunctionExpression: a2, "FunctionExpression:exit": o2, YieldExpression: function() {
    return l2.clear();
  } };
} }, xT = PA.RegExpValidator, bT = new (function() {
  function e25() {
    a(this, e25), this.ecmaVersion = 2018, this._source = "", this._controlChars = [], this._validator = new xT(this);
  }
  return s(e25, [{ key: "onPatternEnter", value: function() {
    this._controlChars = [];
  } }, { key: "onCharacter", value: function(e26, t2, r2) {
    0 <= r2 && 31 >= r2 && (this._source.codePointAt(e26) === r2 || this._source.slice(e26, t2).startsWith("\\x") || this._source.slice(e26, t2).startsWith("\\u")) && this._controlChars.push("\\x".concat("0".concat(r2.toString(16)).slice(-2)));
  } }, { key: "collectControlChars", value: function(e26) {
    try {
      this._source = e26, this._validator.validatePattern(e26);
    } catch (e27) {
    }
    return this._controlChars;
  } }]), e25;
}())(), ET = { meta: { type: "problem", docs: { description: "disallow control characters in regular expressions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-control-regex" }, schema: [], messages: { unexpected: "Unexpected control character(s) in regular expression: {{controlChars}}." } }, create: function(e25) {
  return { Literal: function(t2) {
    var r2 = function(e26) {
      return e26.regex ? e26.regex.pattern : typeof e26.value != "string" || e26.parent.type !== "NewExpression" && e26.parent.type !== "CallExpression" || e26.parent.callee.type !== "Identifier" || e26.parent.callee.name !== "RegExp" || e26.parent.arguments[0] !== e26 ? null : e26.value;
    }(t2);
    if (r2) {
      var n2 = bT.collectControlChars(r2);
      0 < n2.length && e25.report({ node: t2, messageId: "unexpected", data: { controlChars: n2.join(", ") } });
    }
  } };
} }, CT = { meta: { type: "problem", docs: { description: "disallow duplicate class members", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/no-dupe-class-members" }, schema: [], messages: { unexpected: "Duplicate name '{{name}}'." } }, create: function(e25) {
  function t2(e26, t3) {
    var n2 = r2[r2.length - 1], i2 = "$".concat(e26);
    return n2[i2] || (n2[i2] = { nonStatic: { init: false, get: false, set: false }, static: { init: false, get: false, set: false } }), n2[i2][t3 ? "static" : "nonStatic"];
  }
  var r2 = [];
  return { Program: function() {
    r2 = [];
  }, ClassBody: function() {
    r2.push(Object.create(null));
  }, "ClassBody:exit": function() {
    r2.pop();
  }, MethodDefinition: function(r3) {
    if (!r3.computed) {
      var n2 = function(e26) {
        switch (e26.type) {
          case "Identifier":
            return e26.name;
          case "Literal":
            return e26.value + "";
          default:
            return "";
        }
      }(r3.key), i2 = t2(n2, r3.static), a2 = false;
      r3.kind === "get" ? (a2 = i2.init || i2.get, i2.get = true) : r3.kind === "set" ? (a2 = i2.init || i2.set, i2.set = true) : (a2 = i2.init || i2.get || i2.set, i2.init = true), a2 && e25.report({ node: r3, messageId: "unexpected", data: { name: n2 } });
    }
  } };
} };
function ST(e25, t2, r2) {
  return t2.every(function(t3) {
    return r2.some(function(r3) {
      return e25(t3, r3);
    });
  });
}
function kT(e25, t2) {
  return t2.type === "LogicalExpression" && t2.operator === e25 ? [].concat(E(kT(e25, t2.left)), E(kT(e25, t2.right))) : [t2];
}
var DT = kT.bind(null, "||"), FT = kT.bind(null, "&&"), AT = { meta: { type: "problem", docs: { description: "disallow duplicate conditions in if-else-if chains", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-dupe-else-if" }, schema: [], messages: { unexpected: "This branch can never execute. Its condition is a duplicate or covered by previous conditions in the if-else-if chain." } }, create: function(e25) {
  var t2 = e25.getSourceCode(), r2 = ST.bind(null, function e26(r3, n2) {
    return !(r3.type !== n2.type) && (r3.type !== "LogicalExpression" || r3.operator !== "||" && r3.operator !== "&&" || r3.operator !== n2.operator ? LA.equalTokens(r3, n2, t2) : e26(r3.left, n2.left) && e26(r3.right, n2.right) || e26(r3.left, n2.right) && e26(r3.right, n2.left));
  });
  return { IfStatement: function(t3) {
    for (var n2 = t3.test, i2 = n2.type === "LogicalExpression" && n2.operator === "&&" ? [n2].concat(E(FT(n2))) : [n2], a2 = function(t4, i3) {
      t4 = t4.parent;
      var a3 = DT(t4.test).map(FT);
      if ((i3 = i3.map(function(e26) {
        return e26.filter(function(e27) {
          return !a3.some(function(t5) {
            return r2(t5, e27);
          });
        });
      })).some(function(e26) {
        return e26.length === 0;
      }))
        return e25.report({ node: n2, messageId: "unexpected" }), o2 = t4, s2 = i3, "break";
      o2 = t4, s2 = i3;
    }, o2 = t3, s2 = i2.map(function(e26) {
      return DT(e26).map(FT);
    }); o2.parent && o2.parent.type === "IfStatement" && o2.parent.alternate === o2; ) {
      if (a2(o2, s2) === "break")
        break;
    }
  } };
} }, wT = /^(?:init|get)$/, _T = /^(?:init|set)$/, TT = function() {
  function e25(t2, r2) {
    a(this, e25), this.upper = t2, this.node = r2, this.properties = new Map();
  }
  return s(e25, [{ key: "getPropertyInfo", value: function(e26) {
    var t2 = LA.getStaticPropertyName(e26);
    return this.properties.has(t2) || this.properties.set(t2, { get: false, set: false }), this.properties.get(t2);
  } }, { key: "isPropertyDefined", value: function(e26) {
    var t2 = this.getPropertyInfo(e26);
    return wT.test(e26.kind) && t2.get || _T.test(e26.kind) && t2.set;
  } }, { key: "defineProperty", value: function(e26) {
    var t2 = this.getPropertyInfo(e26);
    wT.test(e26.kind) && (t2.get = true), _T.test(e26.kind) && (t2.set = true);
  } }]), e25;
}(), PT = { meta: { type: "problem", docs: { description: "disallow duplicate keys in object literals", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-dupe-keys" }, schema: [], messages: { unexpected: "Duplicate key '{{name}}'." } }, create: function(e25) {
  var t2 = null;
  return { ObjectExpression: function(e26) {
    t2 = new TT(t2, e26);
  }, "ObjectExpression:exit": function() {
    t2 = t2.upper;
  }, Property: function(r2) {
    var n2 = LA.getStaticPropertyName(r2);
    r2.parent.type !== "ObjectExpression" || n2 === null || (t2.isPropertyDefined(r2) && e25.report({ node: t2.node, loc: r2.key.loc, messageId: "unexpected", data: { name: n2 } }), t2.defineProperty(r2));
  } };
} }, IT = { meta: { type: "problem", docs: { description: "disallow duplicate case labels", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-duplicate-case" }, schema: [], messages: { unexpected: "Duplicate case label." } }, create: function(e25) {
  var t2 = e25.getSourceCode();
  return { SwitchStatement: function(r2) {
    var n2 = new Set(), i2 = true, a2 = false, o2 = void 0;
    try {
      for (var s2, u2 = r2.cases[Symbol.iterator](); !(i2 = (s2 = u2.next()).done); i2 = true) {
        var c2 = s2.value;
        if (c2.test) {
          var l2 = t2.getText(c2.test);
          n2.has(l2) ? e25.report({ node: c2, messageId: "unexpected" }) : n2.add(l2);
        }
      }
    } catch (e26) {
      a2 = true, o2 = e26;
    } finally {
      try {
        i2 || u2.return == null || u2.return();
      } finally {
        if (a2)
          throw o2;
      }
    }
  } };
} };
function BT(e25) {
  return e25 && e25.source && e25.source.value ? e25.source.value.trim() : "";
}
function OT(e25, t2, r2, n2, i2) {
  n2.indexOf(r2) !== -1 && e25.report({ node: t2, messageId: i2, data: { module: r2 } });
}
function LT(e25, t2, r2, n2) {
  return function(i2) {
    var a2 = BT(i2);
    a2 && (OT(e25, i2, a2, r2, "import"), t2 && OT(e25, i2, a2, n2, "importAs"), r2.push(a2));
  };
}
function NT(e25, t2, r2) {
  return function(n2) {
    var i2 = BT(n2);
    i2 && (OT(e25, n2, i2, r2, "export"), OT(e25, n2, i2, t2, "exportAs"), r2.push(i2));
  };
}
var jT = { meta: { type: "problem", docs: { description: "disallow duplicate module imports", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-duplicate-imports" }, schema: [{ type: "object", properties: { includeExports: { type: "boolean", default: false } }, additionalProperties: false }], messages: { import: "'{{module}}' import is duplicated.", importAs: "'{{module}}' import is duplicated as export.", export: "'{{module}}' export is duplicated.", exportAs: "'{{module}}' export is duplicated as import." } }, create: function(e25) {
  var t2 = (e25.options[0] || {}).includeExports, r2 = [], n2 = [], i2 = { ImportDeclaration: LT(e25, t2, r2, n2) };
  return t2 && (i2.ExportNamedDeclaration = NT(e25, r2, n2), i2.ExportAllDeclaration = NT(e25, r2, n2)), i2;
} }, RT = function() {
  function e25(t2, r2) {
    a(this, e25), this.fixer = t2, this.sourceCode = r2, this.retainedRange = null;
  }
  return s(e25, [{ key: "retainRange", value: function(e26) {
    return this.retainedRange = e26, this;
  } }, { key: "retainEnclosingFunction", value: function(e26) {
    var t2 = LA.getUpperFunction(e26);
    return this.retainRange(t2 ? t2.range : this.sourceCode.ast.range);
  } }, { key: "retainSurroundingTokens", value: function(e26) {
    var t2 = this.sourceCode.getTokenBefore(e26) || e26, r2 = this.sourceCode.getTokenAfter(e26) || e26;
    return this.retainRange([t2.range[0], r2.range[1]]);
  } }, { key: "replaceTextRange", value: function(e26, t2) {
    var r2;
    return r2 = this.retainedRange ? [Math.min(this.retainedRange[0], e26[0]), Math.max(this.retainedRange[1], e26[1])] : e26, this.fixer.replaceTextRange(r2, this.sourceCode.text.slice(r2[0], e26[0]) + t2 + this.sourceCode.text.slice(e26[1], r2[1]));
  } }, { key: "remove", value: function(e26) {
    return this.replaceTextRange(e26.range, "");
  } }]), e25;
}(), MT = { meta: { type: "suggestion", docs: { description: "disallow `else` blocks after `return` statements in `if` statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-else-return" }, schema: [{ type: "object", properties: { allowElseIf: { type: "boolean", default: true } }, additionalProperties: false }], fixable: "code", messages: { unexpected: "Unnecessary 'else' after 'return'." } }, create: function(e25) {
  function t2(e26, t3) {
    if (e26.type === "FunctionDeclaration")
      return false;
    if (e26.type !== "BlockStatement")
      return true;
    var r3 = t3.childScopes.find(function(t4) {
      return t4.block === e26;
    });
    return !r3 || function(e27, t4) {
      if (e27.length === 0)
        return true;
      var r4 = t4.variableScope;
      if (t4.variables.filter(function(e28) {
        return 0 < e28.defs.length;
      }).some(function(t5) {
        var r5 = t5.name;
        return e27.includes(r5);
      }))
        return false;
      if (t4 !== r4 && t4.upper.type === "catch" && t4.upper.variables.some(function(t5) {
        var r5 = t5.name;
        return e27.includes(r5);
      }))
        return false;
      if (t4.variables.filter(function(e28) {
        var t5 = e28.defs, r5 = e28.references;
        return t5.length === 0 && 0 < r5.length;
      }).some(function(t5) {
        var r5 = t5.name;
        return e27.includes(r5);
      }))
        return false;
      if (t4.through.some(function(t5) {
        return e27.includes(t5.identifier.name);
      }))
        return false;
      if (t4 !== r4) {
        var n3 = t4.block.range;
        if (r4.variables.filter(function(t5) {
          var r5 = t5.name;
          return e27.includes(r5);
        }).some(function(e28) {
          return e28.defs.some(function(e29) {
            var t5 = e29.node.range;
            return n3[0] <= t5[0] && t5[1] <= n3[1];
          });
        }))
          return false;
      }
      return true;
    }(r3.variables.map(function(e27) {
      return e27.name;
    }), t3);
  }
  function r2(r3) {
    var n3 = e25.getScope();
    e25.report({ node: r3, messageId: "unexpected", fix: function(i3) {
      if (!t2(r3, n3))
        return null;
      var a3, o3, s2 = e25.getSourceCode(), u2 = s2.getFirstToken(r3), c2 = s2.getTokenBefore(u2), l2 = s2.getText(r3), p2 = s2.getTokenBefore(c2);
      o3 = u2.type === "Punctuator" && u2.value === "{" ? s2.getTokenAfter(u2) : u2;
      var f2 = r3.parent.consequent.type !== "BlockStatement" && p2.value !== ";", h2 = /^[\(\+\x2D\/\[`]/.test(o3.value);
      if (f2 && h2)
        return null;
      var d2 = s2.getLastToken(r3), m2 = s2.getTokenBefore(d2);
      if (m2.value !== ";") {
        var g2 = s2.getTokenAfter(d2), y2 = g2 && /^[\(\+\x2D\/\[`]/.test(g2.value), v2 = g2 && g2.loc.start.line === m2.loc.start.line;
        if (y2 || v2 && g2.value !== "}")
          return null;
      }
      return a3 = u2.type === "Punctuator" && u2.value === "{" ? l2.slice(1, -1) : l2, new RT(i3, s2).retainEnclosingFunction(r3).replaceTextRange([c2.range[0], r3.range[1]], a3);
    } });
  }
  function n2(e26) {
    return e26.type === "ReturnStatement";
  }
  function i2(e26) {
    if (e26.type === "BlockStatement") {
      var t3 = e26.body, r3 = t3[t3.length - 1];
      return r3 && n2(r3);
    }
    return n2(e26);
  }
  function a2(e26) {
    return n2(e26) || function(e27) {
      return e27.type === "IfStatement" && function(e28) {
        return e28.alternate && e28.consequent;
      }(e27) && i2(e27.alternate) && i2(e27.consequent);
    }(e26);
  }
  function o2(e26) {
    return e26.type === "BlockStatement" ? e26.body.some(a2) : a2(e26);
  }
  return { "IfStatement:exit": !(e25.options[0] && e25.options[0].allowElseIf === false) ? function(e26) {
    var t3 = e26.parent;
    if (LA.STATEMENT_LIST_PARENTS.has(t3.type)) {
      for (var n3, i3 = [], a3 = e26; a3.type === "IfStatement"; a3 = a3.alternate) {
        if (!a3.alternate)
          return;
        i3.push(a3.consequent), n3 = a3.alternate;
      }
      i3.every(o2) && r2(n3);
    }
  } : function(e26) {
    var t3 = e26.parent;
    if (LA.STATEMENT_LIST_PARENTS.has(t3.type)) {
      var n3 = e26.alternate;
      n3 && o2(e26.consequent) && r2(n3);
    }
  } };
} }, VT = /^\/((?:[\0-Z\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\[((?:[\0-\[\^-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))+\])*\/[gimsuy]*$/, UT = { meta: { type: "problem", docs: { description: "disallow empty character classes in regular expressions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-empty-character-class" }, schema: [], messages: { unexpected: "Empty class." } }, create: function(e25) {
  var t2 = e25.getSourceCode();
  return { Literal: function(r2) {
    var n2 = t2.getFirstToken(r2);
    n2.type !== "RegularExpression" || VT.test(n2.value) || e25.report({ node: r2, messageId: "unexpected" });
  } };
} };
var qT = { meta: { type: "suggestion", docs: { description: "disallow empty functions", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-empty-function" }, schema: [{ type: "object", properties: { allow: { type: "array", items: { enum: Object.freeze(["functions", "arrowFunctions", "generatorFunctions", "methods", "generatorMethods", "getters", "setters", "constructors"]) }, uniqueItems: true } }, additionalProperties: false }], messages: { unexpected: "Unexpected empty {{name}}." } }, create: function(e25) {
  function t2(t3) {
    var i2 = function(e26) {
      var t4 = e26.parent, r3 = "";
      if (e26.type === "ArrowFunctionExpression")
        return "arrowFunctions";
      if (t4.type === "Property") {
        if (t4.kind === "get")
          return "getters";
        if (t4.kind === "set")
          return "setters";
        r3 = t4.method ? "methods" : "functions";
      } else if (t4.type === "MethodDefinition") {
        if (t4.kind === "get")
          return "getters";
        if (t4.kind === "set")
          return "setters";
        if (t4.kind === "constructor")
          return "constructors";
        r3 = "methods";
      } else
        r3 = "functions";
      var n3 = "";
      if (e26.generator)
        n3 = "generator";
      else {
        if (!e26.async)
          return r3;
        n3 = "async";
      }
      return n3 + r3[0].toUpperCase() + r3.slice(1);
    }(t3), a2 = LA.getFunctionNameWithKind(t3), o2 = n2.getTokens(t3.body, { includeComments: true, filter: LA.isCommentToken });
    r2.indexOf(i2) === -1 && t3.body.type === "BlockStatement" && t3.body.body.length === 0 && o2.length === 0 && e25.report({ node: t3, loc: t3.body.loc.start, messageId: "unexpected", data: { name: a2 } });
  }
  var r2 = (e25.options[0] || {}).allow || [], n2 = e25.getSourceCode();
  return { ArrowFunctionExpression: t2, FunctionDeclaration: t2, FunctionExpression: t2 };
} }, WT = { meta: { type: "suggestion", docs: { description: "disallow empty block statements", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-empty" }, schema: [{ type: "object", properties: { allowEmptyCatch: { type: "boolean", default: false } }, additionalProperties: false }], messages: { unexpected: "Empty {{type}} statement." } }, create: function(e25) {
  var t2 = (e25.options[0] || {}).allowEmptyCatch || false, r2 = e25.getSourceCode();
  return { BlockStatement: function(n2) {
    n2.body.length !== 0 || LA.isFunction(n2.parent) || t2 && n2.parent.type === "CatchClause" || 0 < r2.getCommentsInside(n2).length || e25.report({ node: n2, messageId: "unexpected", data: { type: "block" } });
  }, SwitchStatement: function(t3) {
    (t3.cases === void 0 || t3.cases.length === 0) && e25.report({ node: t3, messageId: "unexpected", data: { type: "switch" } });
  } };
} }, $T = Object.freeze(["global", "window"]);
function GT(e25, t2) {
  return e25.type === "Identifier" && e25.name === t2;
}
function zT(e25, t2) {
  switch (e25.type) {
    case "Literal":
      return e25.value === t2;
    case "TemplateLiteral":
      return e25.expressions.length === 0 && e25.quasis[0].value.cooked === t2;
    default:
      return false;
  }
}
function HT(e25, t2) {
  return e25.type === "MemberExpression" && (e25.computed ? zT : GT)(e25.property, t2);
}
var KT = { meta: { type: "suggestion", docs: { description: "disallow the use of `eval()`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-eval" }, schema: [{ type: "object", properties: { allowIndirect: { type: "boolean", default: false } }, additionalProperties: false }], messages: { unexpected: "eval can be harmful." } }, create: function(e25) {
  function t2(t3) {
    var r3 = e25.getScope().isStrict;
    o2 = { upper: o2, node: t3, strict: r3, defaultThis: false, initialized: r3 };
  }
  function r2() {
    o2 = o2.upper;
  }
  function n2(t3) {
    var r3 = t3.parent, n3 = t3.type === "MemberExpression" ? t3.property : t3, i3 = r3.type === "CallExpression" && r3.callee === t3 ? r3 : t3;
    e25.report({ node: i3, loc: n3.loc.start, messageId: "unexpected" });
  }
  var i2 = !(!e25.options[0] || !e25.options[0].allowIndirect), a2 = e25.getSourceCode(), o2 = null;
  return i2 ? { "CallExpression:exit": function(e26) {
    var t3 = e26.callee;
    GT(t3, "eval") && n2(t3);
  } } : { "CallExpression:exit": function(e26) {
    var t3 = e26.callee;
    GT(t3, "eval") && n2(t3);
  }, Program: function(t3) {
    var r3 = e25.getScope(), n3 = e25.parserOptions.ecmaFeatures || {}, i3 = r3.isStrict || t3.sourceType === "module" || n3.globalReturn && r3.childScopes[0].isStrict;
    o2 = { upper: null, node: t3, strict: i3, defaultThis: true, initialized: true };
  }, "Program:exit": function() {
    var t3 = e25.getScope();
    r2(), function(e26) {
      var t4 = LA.getVariableByName(e26, "eval");
      if (t4)
        for (var r3 = t4.references, i3 = 0; i3 < r3.length; ++i3) {
          var a3 = r3[i3].identifier;
          a3.name !== "eval" || LA.isCallee(a3) || n2(a3);
        }
    }(t3), function(e26) {
      for (var t4 = 0; t4 < $T.length; ++t4) {
        var r3 = $T[t4], i3 = LA.getVariableByName(e26, r3);
        if (i3)
          for (var a3 = i3.references, o3 = 0; o3 < a3.length; ++o3) {
            for (var s2 = a3[o3].identifier.parent; HT(s2, r3); )
              s2 = s2.parent;
            HT(s2, "eval") && n2(s2);
          }
      }
    }(t3);
  }, FunctionDeclaration: t2, "FunctionDeclaration:exit": r2, FunctionExpression: t2, "FunctionExpression:exit": r2, ArrowFunctionExpression: t2, "ArrowFunctionExpression:exit": r2, ThisExpression: function(e26) {
    HT(e26.parent, "eval") && (!o2.initialized && (o2.initialized = true, o2.defaultThis = LA.isDefaultThisBinding(o2.node, a2)), !o2.strict && o2.defaultThis && n2(e26.parent));
  } };
} }, JT = { meta: { type: "problem", docs: { description: "disallow reassigning exceptions in `catch` clauses", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-ex-assign" }, schema: [], messages: { unexpected: "Do not assign to the exception parameter." } }, create: function(e25) {
  function t2(t3) {
    LA.getModifyingReferences(t3.references).forEach(function(t4) {
      e25.report({ node: t4.identifier, messageId: "unexpected" });
    });
  }
  return { CatchClause: function(r2) {
    e25.getDeclaredVariables(r2).forEach(t2);
  } };
} }, QT = new Set(["defineProperty", "defineProperties"]), XT = { meta: { type: "suggestion", docs: { description: "disallow extending native types", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-extend-native" }, schema: [{ type: "object", properties: { exceptions: { type: "array", items: { type: "string" }, uniqueItems: true } }, additionalProperties: false }], messages: { unexpected: "{{builtin}} prototype is read only, properties should not be added." } }, create: function(e25) {
  function t2(t3, r3) {
    e25.report({ node: t3, messageId: "unexpected", data: { builtin: r3 } });
  }
  function r2(e26) {
    return !(!e26 || !e26.parent || e26.parent.type !== "MemberExpression" || e26.parent.object !== e26 || LA.getStaticPropertyName(e26.parent) !== "prototype");
  }
  function n2(e26) {
    !function(e27) {
      return !(!r2(e27) || e27.parent.parent.type !== "MemberExpression" || e27.parent.parent.parent.type !== "AssignmentExpression" || e27.parent.parent.parent.left !== e27.parent.parent);
    }(e26) ? function(e27) {
      return !(!r2(e27) || e27.parent.parent.type !== "CallExpression" || e27.parent.parent.arguments[0] !== e27.parent || e27.parent.parent.callee.type !== "MemberExpression" || e27.parent.parent.callee.object.type !== "Identifier" || e27.parent.parent.callee.object.name !== "Object" || e27.parent.parent.callee.property.type !== "Identifier" || !QT.has(e27.parent.parent.callee.property.name));
    }(e26) && t2(e26.parent.parent, e26.name) : t2(e26.parent.parent.parent, e26.name);
  }
  var i2 = e25.options[0] || {}, a2 = new Set(i2.exceptions || []), o2 = new Set(Object.keys(Fy.globals.builtin).filter(function(e26) {
    return e26[0].toUpperCase() === e26[0];
  }).filter(function(e26) {
    return !a2.has(e26);
  }));
  return { "Program:exit": function() {
    var t3 = e25.getScope();
    o2.forEach(function(e26) {
      var r3 = t3.set.get(e26);
      r3 && r3.references && r3.references.map(function(e27) {
        return e27.identifier;
      }).forEach(n2);
    });
  } };
} }, YT = new Set(["Literal", "Identifier", "ThisExpression", "FunctionExpression"]), ZT = { meta: { type: "suggestion", docs: { description: "disallow unnecessary calls to `.bind()`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-extra-bind" }, schema: [], fixable: "code", messages: { unexpected: "The function binding is unnecessary." } }, create: function(e25) {
  function t2(t3) {
    e25.report({ node: t3.parent.parent, messageId: "unexpected", loc: t3.parent.property.loc.start, fix: function(e26) {
      if (t3.parent.parent.arguments.length && !function(e27) {
        return YT.has(e27.type);
      }(t3.parent.parent.arguments[0]))
        return null;
      var r3 = a2.getFirstTokenBetween(t3.parent.object, t3.parent.property, LA.isNotClosingParenToken), n3 = a2.getLastToken(t3.parent.parent);
      return a2.commentsExistBetween(r3, n3) ? null : e26.removeRange([r3.range[0], t3.parent.parent.range[1]]);
    } });
  }
  function r2(e26) {
    var t3 = e26.parent, r3 = t3.parent;
    return r3 && r3.type === "CallExpression" && r3.callee === t3 && r3.arguments.length === 1 && r3.arguments[0].type !== "SpreadElement" && t3.type === "MemberExpression" && t3.object === e26 && LA.getStaticPropertyName(t3) === "bind";
  }
  function n2(e26) {
    o2 = { isBound: r2(e26), thisFound: false, upper: o2 };
  }
  function i2(e26) {
    o2.isBound && !o2.thisFound && t2(e26), o2 = o2.upper;
  }
  var a2 = e25.getSourceCode(), o2 = null;
  return { "ArrowFunctionExpression:exit": function(e26) {
    r2(e26) && t2(e26);
  }, FunctionDeclaration: n2, "FunctionDeclaration:exit": i2, FunctionExpression: n2, "FunctionExpression:exit": i2, ThisExpression: function() {
    o2 && (o2.thisFound = true);
  } };
} }, eP = { meta: { type: "suggestion", docs: { description: "disallow unnecessary boolean casts", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-extra-boolean-cast" }, schema: [], fixable: "code", messages: { unexpectedCall: "Redundant Boolean call.", unexpectedNegation: "Redundant double negation." } }, create: function(e25) {
  function t2(e26, t3) {
    return i2.indexOf(t3.type) !== -1 && e26 === t3.test || t3.type === "UnaryExpression" && t3.operator === "!";
  }
  function r2(e26) {
    return !!n2.getCommentsInside(e26).length;
  }
  var n2 = e25.getSourceCode(), i2 = ["IfStatement", "DoWhileStatement", "WhileStatement", "ConditionalExpression", "ForStatement"];
  return { UnaryExpression: function(i3) {
    var a2 = e25.getAncestors(), o2 = a2.pop(), s2 = a2.pop();
    i3.operator !== "!" || o2.type !== "UnaryExpression" || o2.operator !== "!" || (t2(o2, s2) || (s2.type === "CallExpression" || s2.type === "NewExpression") && s2.callee.type === "Identifier" && s2.callee.name === "Boolean") && e25.report({ node: o2, messageId: "unexpectedNegation", fix: function(e26) {
      if (r2(o2))
        return null;
      var t3 = "", a3 = n2.getTokenBefore(o2), s3 = n2.getFirstToken(i3.argument);
      return a3 && a3.range[1] === o2.range[0] && !LA.canTokensBeAdjacent(a3, s3) && (t3 = " "), e26.replaceText(o2, t3 + n2.getText(i3.argument));
    } });
  }, CallExpression: function(i3) {
    var a2 = i3.parent;
    i3.callee.type !== "Identifier" || i3.callee.name !== "Boolean" || t2(i3, a2) && e25.report({ node: i3, messageId: "unexpectedCall", fix: function(e26) {
      if (!i3.arguments.length) {
        if (a2.type === "UnaryExpression" && a2.operator === "!") {
          if (r2(a2))
            return null;
          var t3 = "", o2 = n2.getTokenBefore(a2);
          return o2 && o2.range[1] === a2.range[0] && !LA.canTokensBeAdjacent(o2, "true") && (t3 = " "), e26.replaceText(a2, t3 + "true");
        }
        return r2(i3) ? null : e26.replaceText(i3, "false");
      }
      if (1 < i3.arguments.length || i3.arguments[0].type === "SpreadElement" || r2(i3))
        return null;
      var s2 = i3.arguments[0];
      return LA.getPrecedence(s2) < LA.getPrecedence(i3.parent) ? e26.replaceText(i3, "(".concat(n2.getText(s2), ")")) : e26.replaceText(i3, n2.getText(s2));
    } });
  } };
} }, tP = { meta: { type: "suggestion", docs: { description: "disallow unnecessary labels", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-extra-label" }, schema: [], fixable: "code", messages: { unexpected: "This label '{{name}}' is unnecessary." } }, create: function(e25) {
  function t2(e26) {
    a2 = { label: e26.parent.type === "LabeledStatement" ? e26.parent.label : null, breakable: true, upper: a2 };
  }
  function r2() {
    a2 = a2.upper;
  }
  function n2(t3) {
    if (t3.label) {
      for (var r3 = t3.label, n3 = a2; n3 !== null; n3 = n3.upper)
        if (n3.breakable || n3.label && n3.label.name === r3.name)
          return void (n3.breakable && n3.label && n3.label.name === r3.name && e25.report({ node: r3, messageId: "unexpected", data: r3, fix: function(e26) {
            var n4 = i2.getFirstToken(t3);
            return i2.commentsExistBetween(n4, r3) ? null : e26.removeRange([n4.range[1], r3.range[1]]);
          } }));
    }
  }
  var i2 = e25.getSourceCode(), a2 = null;
  return { WhileStatement: t2, "WhileStatement:exit": r2, DoWhileStatement: t2, "DoWhileStatement:exit": r2, ForStatement: t2, "ForStatement:exit": r2, ForInStatement: t2, "ForInStatement:exit": r2, ForOfStatement: t2, "ForOfStatement:exit": r2, SwitchStatement: t2, "SwitchStatement:exit": r2, LabeledStatement: function(e26) {
    LA.isBreakableStatement(e26.body) || (a2 = { label: e26.label, breakable: false, upper: a2 });
  }, "LabeledStatement:exit": function(e26) {
    LA.isBreakableStatement(e26.body) || (a2 = a2.upper);
  }, BreakStatement: n2, ContinueStatement: n2 };
} }, rP = Fy.require$$0.isParenthesized, nP = { meta: { type: "layout", docs: { description: "disallow unnecessary parentheses", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-extra-parens" }, fixable: "code", schema: { anyOf: [{ type: "array", items: [{ enum: ["functions"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["all"] }, { type: "object", properties: { conditionalAssign: { type: "boolean" }, nestedBinaryExpressions: { type: "boolean" }, returnAssign: { type: "boolean" }, ignoreJSX: { enum: ["none", "all", "single-line", "multi-line"] }, enforceForArrowConditionals: { type: "boolean" }, enforceForSequenceExpressions: { type: "boolean" }, enforceForNewInMemberExpressions: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] }, messages: { unexpected: "Unnecessary parentheses around expression." } }, create: function(e25) {
  function t2(e26) {
    if (e26.type === "JSXElement" || e26.type === "JSXFragment") {
      var t3 = e26.loc.start.line === e26.loc.end.line;
      switch (P2) {
        case "all":
          return false;
        case "multi-line":
          return t3;
        case "single-line":
          return !t3;
      }
    }
    return !(e26.type === "SequenceExpression" && B2) && (A2 || e26.type === "FunctionExpression" || e26.type === "ArrowFunctionExpression");
  }
  function r2(e26) {
    return rP(1, e26, k2);
  }
  function n2(e26) {
    return rP(2, e26, k2);
  }
  function i2(e26) {
    return t2(e26) && r2(e26);
  }
  function a2(e26) {
    return t2(e26) && n2(e26);
  }
  function o2(e26) {
    return w2 && e26.test.type === "AssignmentExpression";
  }
  function s2(e26) {
    var t3 = k2.getLastToken(e26), r3 = k2.getTokenBefore(t3);
    return 0 < e26.arguments.length || LA.isOpeningParenToken(r3) && LA.isClosingParenToken(t3) && e26.callee.range[1] < e26.range[1];
  }
  function u2(e26) {
    return !(e26.type !== "AssignmentExpression" && (e26.type !== "ConditionalExpression" || e26.consequent.type !== "AssignmentExpression" && e26.alternate.type !== "AssignmentExpression") && !(e26.left && e26.left.type === "AssignmentExpression" || e26.right && e26.right.type === "AssignmentExpression"));
  }
  function c2(e26) {
    return !(!T2 || !function(e27) {
      for (var t3 = e27; t3; t3 = t3.parent)
        if (t3.type === "ReturnStatement" || t3.type === "ArrowFunctionExpression" && t3.body.type !== "BlockStatement")
          return true;
      return false;
    }(e26)) && (e26.type === "ReturnStatement" ? e26.argument && u2(e26.argument) : e26.type === "ArrowFunctionExpression" && e26.body.type !== "BlockStatement" ? u2(e26.body) : u2(e26));
  }
  function l2(e26, t3) {
    return e26.loc.end.line === t3.loc.start.line ? i2(t3) : a2(t3);
  }
  function p2(e26) {
    return e26.type === "CallExpression" && e26.callee.type === "FunctionExpression";
  }
  function f2(t3) {
    function i3() {
      e25.report({ node: t3, loc: a3.loc, messageId: "unexpected", fix: function(e26) {
        var r3 = k2.text.slice(a3.range[1], o3.range[0]);
        return e26.replaceTextRange([a3.range[0], o3.range[1]], (function(e27) {
          var t4 = k2.getTokenBefore(e27), r4 = k2.getTokenBefore(e27, 1), n3 = k2.getFirstToken(e27);
          return r4 && r4.range[1] === t4.range[0] && t4.range[1] === n3.range[0] && !LA.canTokensBeAdjacent(r4, n3);
        }(t3) ? " " : "") + r3 + (function(e27) {
          var t4 = k2.getTokensAfter(e27, { count: 2 }), r4 = t4[0], n3 = t4[1], i4 = k2.getLastToken(e27);
          return r4 && n3 && !k2.isSpaceBetweenTokens(r4, n3) && !LA.canTokensBeAdjacent(i4, n3);
        }(t3) ? " " : ""));
      } });
    }
    var a3 = k2.getTokenBefore(t3), o3 = k2.getTokenAfter(t3);
    if (!n2(t3)) {
      if (D2.has(k2.getFirstToken(t3)))
        return;
      if (p2(t3) && !r2(t3.callee))
        return;
    }
    return S2 ? void S2.reports.push({ node: t3, finishReport: i3 }) : void i3();
  }
  function h2(e26) {
    e26.type === "UnaryExpression" && e26.argument.type === "BinaryExpression" && e26.argument.operator === "**" || i2(e26.argument) && F2(e26.argument) >= F2(e26) && f2(e26.argument);
  }
  function d2(e26) {
    var t3 = e26.callee;
    if (i2(t3) && F2(t3) >= F2(e26)) {
      var r3 = t3.type === "NewExpression" && !s2(t3);
      !a2(t3) && (p2(e26) || r3 || t3.type === "MemberExpression" && function(e27) {
        for (var t4 = e27.object, r4 = e27.object.type; r4 === "MemberExpression"; )
          r4 = (t4 = t4.object).type;
        return r4 === "CallExpression";
      }(t3)) || f2(e26.callee);
    }
    e26.arguments.filter(function(e27) {
      return i2(e27) && F2(e27) >= L2;
    }).forEach(f2);
  }
  function m2(e26) {
    var t3 = F2(e26), r3 = F2(e26.left), n3 = F2(e26.right), a3 = e26.operator === "**", o3 = _2 && (e26.left.type === "BinaryExpression" || e26.left.type === "LogicalExpression") || e26.left.type === "UnaryExpression" && a3, s3 = _2 && (e26.right.type === "BinaryExpression" || e26.right.type === "LogicalExpression");
    !o3 && i2(e26.left) && (r3 > t3 || r3 === t3 && !a3) && f2(e26.left), !s3 && i2(e26.right) && (n3 > t3 || n3 === t3 && a3) && f2(e26.right);
  }
  function g2(e26) {
    e26.superClass && ((F2(e26.superClass) > N2 ? i2(e26.superClass) : a2(e26.superClass)) && f2(e26.superClass));
  }
  function y2(e26) {
    (F2(e26.argument) >= L2 ? i2(e26.argument) : a2(e26.argument)) && f2(e26.argument);
  }
  function v2(e26) {
    var t3 = r2(e26) ? k2.getTokenBefore(e26) : k2.getFirstToken(e26), n3 = k2.getTokenAfter(t3, LA.isNotOpeningParenToken), a3 = n3 ? k2.getTokenAfter(n3) : null, o3 = n3 ? k2.getTokenAfter(n3, LA.isNotClosingParenToken) : null;
    LA.isOpeningParenToken(t3) && (LA.isOpeningBraceToken(n3) || n3.type === "Keyword" && (n3.value === "function" || n3.value === "class" || n3.value === "let" && o3 && (LA.isOpeningBracketToken(o3) || o3.type === "Identifier")) || n3 && n3.type === "Identifier" && n3.value === "async" && a3 && a3.type === "Keyword" && a3.value === "function") && D2.add(n3), i2(e26) && f2(e26);
  }
  function x2(e26, t3) {
    return function(e27, t4) {
      for (var r3 = [e27], n3 = e27; n3 !== t4; ) {
        if ((n3 = n3.parent) === null)
          throw new Error("Nodes are not in the ancestor-descendant relationship.");
        r3.push(n3);
      }
      return r3;
    }(t3, e26).reverse();
  }
  function b2(e26, t3) {
    switch (e26.type) {
      case "ArrayExpression":
      case "ArrayPattern":
      case "BlockStatement":
      case "ObjectExpression":
      case "ObjectPattern":
      case "TemplateLiteral":
        return true;
      case "ArrowFunctionExpression":
      case "FunctionExpression":
        return e26.params.includes(t3);
      case "CallExpression":
      case "NewExpression":
        return e26.arguments.includes(t3);
      case "MemberExpression":
        return e26.computed && e26.property === t3;
      case "ConditionalExpression":
        return e26.consequent === t3;
      default:
        return false;
    }
  }
  function C2(e26) {
    return S2.reports.some(function(t3) {
      return t3.node === e26;
    });
  }
  var S2, k2 = e25.getSourceCode(), D2 = new WeakSet(), F2 = LA.getPrecedence, A2 = e25.options[0] !== "functions", w2 = A2 && e25.options[1] && e25.options[1].conditionalAssign === false, _2 = A2 && e25.options[1] && e25.options[1].nestedBinaryExpressions === false, T2 = A2 && e25.options[1] && e25.options[1].returnAssign === false, P2 = A2 && e25.options[1] && e25.options[1].ignoreJSX, I2 = A2 && e25.options[1] && e25.options[1].enforceForArrowConditionals === false, B2 = A2 && e25.options[1] && e25.options[1].enforceForSequenceExpressions === false, O2 = A2 && e25.options[1] && e25.options[1].enforceForNewInMemberExpressions === false, L2 = F2({ type: "AssignmentExpression" }), N2 = F2({ type: "UpdateExpression" });
  return { ArrayExpression: function(e26) {
    e26.elements.filter(function(e27) {
      return e27 && i2(e27) && F2(e27) >= L2;
    }).forEach(f2);
  }, ArrowFunctionExpression: function(e26) {
    if (!c2(e26) && (e26.body.type !== "ConditionalExpression" || !I2 || n2(e26.body)) && e26.body.type !== "BlockStatement") {
      var t3 = k2.getFirstToken(e26.body, LA.isNotOpeningParenToken), r3 = k2.getTokenBefore(t3);
      LA.isOpeningParenToken(r3) && LA.isOpeningBraceToken(t3) && D2.add(t3), i2(e26.body) && F2(e26.body) >= L2 && f2(e26.body);
    }
  }, AssignmentExpression: function(e26) {
    c2(e26) || i2(e26.right) && F2(e26.right) >= F2(e26) && f2(e26.right);
  }, BinaryExpression: function(e26) {
    S2 && e26.operator === "in" && S2.inExpressionNodes.push(e26), m2(e26);
  }, CallExpression: d2, ClassBody: function(e26) {
    e26.body.filter(function(e27) {
      return e27.type === "MethodDefinition" && e27.computed && e27.key && i2(e27.key) && F2(e27.key) >= L2;
    }).forEach(function(e27) {
      return f2(e27.key);
    });
  }, ConditionalExpression: function(e26) {
    c2(e26) || (i2(e26.test) && F2(e26.test) >= F2({ type: "LogicalExpression", operator: "||" }) && f2(e26.test), i2(e26.consequent) && F2(e26.consequent) >= L2 && f2(e26.consequent), i2(e26.alternate) && F2(e26.alternate) >= L2 && f2(e26.alternate));
  }, DoWhileStatement: function(e26) {
    i2(e26.test) && !o2(e26) && f2(e26.test);
  }, ExportDefaultDeclaration: function(e26) {
    return v2(e26.declaration);
  }, ExpressionStatement: function(e26) {
    return v2(e26.expression);
  }, "ForInStatement, ForOfStatement": function(e26) {
    if (e26.left.type !== "VariableDeclarator") {
      var t3 = k2.getFirstToken(e26.left, LA.isNotOpeningParenToken);
      t3.value === "let" && (t3.range[1] === e26.left.range[1] || LA.isOpeningBracketToken(k2.getTokenAfter(t3, LA.isNotClosingParenToken))) && D2.add(t3);
    }
    (e26.type !== "ForOfStatement" || e26.right.type !== "SequenceExpression") && i2(e26.right) && f2(e26.right), i2(e26.left) && f2(e26.left);
  }, ForStatement: function(e26) {
    e26.test && i2(e26.test) && !o2(e26) && f2(e26.test), e26.update && i2(e26.update) && f2(e26.update), e26.init && (S2 = { upper: S2, inExpressionNodes: [], reports: [] }, i2(e26.init) && f2(e26.init));
  }, "ForStatement > *.init:exit": function(e26) {
    S2.reports.length && S2.inExpressionNodes.forEach(function(t3) {
      for (var i3, a3 = x2(e26, t3), o3 = 0; o3 < a3.length; o3++) {
        var s3 = a3[o3];
        if (o3 < a3.length - 1) {
          if (b2(s3, a3[o3 + 1]))
            return;
        }
        if (r2(s3)) {
          if (!C2(s3))
            return;
          if (n2(s3))
            return;
          i3 || (i3 = s3);
        }
      }
      !function(e27) {
        S2.reports = S2.reports.filter(function(t4) {
          return t4.node !== e27;
        });
      }(i3);
    }), function() {
      var e27, t3, r3 = S2, n3 = r3.upper, i3 = r3.inExpressionNodes, a3 = r3.reports;
      n3 ? ((e27 = n3.inExpressionNodes).push.apply(e27, E(i3)), (t3 = n3.reports).push.apply(t3, E(a3))) : a3.forEach(function(e28) {
        return (0, e28.finishReport)();
      }), S2 = n3;
    }();
  }, IfStatement: function(e26) {
    i2(e26.test) && !o2(e26) && f2(e26.test);
  }, ImportExpression: function(e26) {
    var t3 = e26.source;
    t3.type === "SequenceExpression" ? a2(t3) && f2(t3) : i2(t3) && f2(t3);
  }, LogicalExpression: m2, MemberExpression: function(e26) {
    var t3 = i2(e26.object);
    t3 && F2(e26.object) >= F2(e26) && (e26.computed || !(LA.isDecimalInteger(e26.object) || e26.object.type === "Literal" && e26.object.regex)) && f2(e26.object), t3 && e26.object.type === "CallExpression" && e26.parent.type !== "NewExpression" && f2(e26.object), t3 && !O2 && e26.object.type === "NewExpression" && s2(e26.object) && f2(e26.object), e26.computed && i2(e26.property) && f2(e26.property);
  }, NewExpression: d2, ObjectExpression: function(e26) {
    e26.properties.filter(function(e27) {
      var t3 = e27.value;
      return t3 && i2(t3) && F2(t3) >= L2;
    }).forEach(function(e27) {
      return f2(e27.value);
    });
  }, Property: function(e26) {
    if (e26.computed) {
      var t3 = e26.key;
      t3 && i2(t3) && F2(t3) >= L2 && f2(t3);
    }
  }, ReturnStatement: function(e26) {
    var t3 = k2.getFirstToken(e26);
    c2(e26) || e26.argument && l2(t3, e26.argument) && (e26.argument.type !== "Literal" || !e26.argument.regex) && f2(e26.argument);
  }, SequenceExpression: function(e26) {
    e26.expressions.filter(function(t3) {
      return i2(t3) && F2(t3) >= F2(e26);
    }).forEach(f2);
  }, SwitchCase: function(e26) {
    e26.test && i2(e26.test) && f2(e26.test);
  }, SwitchStatement: function(e26) {
    i2(e26.discriminant) && f2(e26.discriminant);
  }, ThrowStatement: function(e26) {
    l2(k2.getFirstToken(e26), e26.argument) && f2(e26.argument);
  }, UnaryExpression: h2, UpdateExpression: h2, AwaitExpression: h2, VariableDeclarator: function(e26) {
    e26.init && i2(e26.init) && F2(e26.init) >= L2 && (e26.init.type !== "Literal" || !e26.init.regex) && f2(e26.init);
  }, WhileStatement: function(e26) {
    i2(e26.test) && !o2(e26) && f2(e26.test);
  }, WithStatement: function(e26) {
    i2(e26.object) && f2(e26.object);
  }, YieldExpression: function(e26) {
    if (e26.argument) {
      var t3 = k2.getFirstToken(e26);
      (F2(e26.argument) >= F2(e26) && l2(t3, e26.argument) || a2(e26.argument)) && f2(e26.argument);
    }
  }, ClassDeclaration: g2, ClassExpression: g2, SpreadElement: y2, SpreadProperty: y2, ExperimentalSpreadProperty: y2, TemplateLiteral: function(e26) {
    e26.expressions.filter(function(e27) {
      return e27 && i2(e27);
    }).forEach(f2);
  }, AssignmentPattern: function(e26) {
    var t3 = e26.right;
    t3 && i2(t3) && F2(t3) >= L2 && f2(t3);
  } };
} }, iP = { meta: { type: "suggestion", docs: { description: "disallow unnecessary semicolons", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-extra-semi" }, fixable: "code", schema: [], messages: { unexpected: "Unnecessary semicolon." } }, create: function(e25) {
  function t2(t3) {
    e25.report({ node: t3, messageId: "unexpected", fix: function(r3) {
      return new RT(r3, e25.getSourceCode()).retainSurroundingTokens(t3).remove(t3);
    } });
  }
  function r2(e26) {
    for (var r3 = e26; r3.type === "Punctuator" && !LA.isClosingBraceToken(r3); r3 = n2.getTokenAfter(r3))
      LA.isSemicolonToken(r3) && t2(r3);
  }
  var n2 = e25.getSourceCode();
  return { EmptyStatement: function(e26) {
    var r3 = e26.parent;
    ["ForStatement", "ForInStatement", "ForOfStatement", "WhileStatement", "DoWhileStatement", "IfStatement", "LabeledStatement", "WithStatement"].indexOf(r3.type) === -1 && t2(e26);
  }, ClassBody: function(e26) {
    r2(n2.getFirstToken(e26, 1));
  }, MethodDefinition: function(e26) {
    r2(n2.getTokenAfter(e26));
  } };
} }, aP = /fall[s\u017F]?[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?through/i;
function oP(e25) {
  return e25.reachable;
}
var sP = { meta: { type: "problem", docs: { description: "disallow fallthrough of `case` statements", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-fallthrough" }, schema: [{ type: "object", properties: { commentPattern: { type: "string", default: "" } }, additionalProperties: false }], messages: { case: "Expected a 'break' statement before 'case'.", default: "Expected a 'break' statement before 'default'." } }, create: function(e25) {
  var t2, r2 = e25.options[0] || {}, n2 = null, i2 = e25.getSourceCode(), a2 = null;
  return t2 = r2.commentPattern ? new RegExp(r2.commentPattern, "u") : aP, { onCodePathStart: function(e26) {
    n2 = e26;
  }, onCodePathEnd: function() {
    n2 = n2.upper;
  }, SwitchCase: function(r3) {
    a2 && !function(e26, t3, r4) {
      var n3 = t3.getSourceCode(), i3 = Fy.lodash.last(n3.getCommentsBefore(e26));
      return !(!i3 || !r4.test(i3.value));
    }(r3, e25, t2) && e25.report({ messageId: r3.test ? "case" : "default", node: r3 }), a2 = null;
  }, "SwitchCase:exit": function(e26) {
    var t3 = i2.getTokenAfter(e26);
    n2.currentSegments.some(oP) && (0 < e26.consequent.length || function(e27, t4) {
      return t4.loc.start.line > e27.loc.end.line + 1;
    }(e26, t3)) && Fy.lodash.last(e26.parent.cases) !== e26 && (a2 = e26);
  } };
} }, uP = { meta: { type: "suggestion", docs: { description: "disallow leading or trailing decimal points in numeric literals", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-floating-decimal" }, schema: [], fixable: "code", messages: { leading: "A leading decimal point can be confused with a dot.", trailing: "A trailing decimal point can be confused with a dot." } }, create: function(e25) {
  var t2 = e25.getSourceCode();
  return { Literal: function(r2) {
    typeof r2.value == "number" && (r2.raw.startsWith(".") && e25.report({ node: r2, messageId: "leading", fix: function(e26) {
      var n2 = t2.getTokenBefore(r2), i2 = n2 && n2.range[1] === r2.range[0] && !LA.canTokensBeAdjacent(n2, "0".concat(r2.raw));
      return e26.insertTextBefore(r2, i2 ? " 0" : "0");
    } }), r2.raw.indexOf(".") === r2.raw.length - 1 && e25.report({ node: r2, messageId: "trailing", fix: function(e26) {
      return e26.insertTextAfter(r2, "0");
    } }));
  } };
} }, cP = { meta: { type: "problem", docs: { description: "disallow reassigning `function` declarations", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-func-assign" }, schema: [] }, create: function(e25) {
  function t2(t3) {
    LA.getModifyingReferences(t3).forEach(function(t4) {
      e25.report({ node: t4.identifier, message: "'{{name}}' is a function.", data: { name: t4.identifier.name } });
    });
  }
  function r2(e26) {
    e26.defs[0].type === "FunctionName" && t2(e26.references);
  }
  function n2(t3) {
    e25.getDeclaredVariables(t3).forEach(r2);
  }
  return { FunctionDeclaration: n2, FunctionExpression: n2 };
} }, lP = /^(?:i|lastI)ndexOf$/;
function pP(e25) {
  return e25.type === "Literal" && typeof e25.value == "number" || e25.type === "CallExpression" && (e25.callee.name === "Number" || e25.callee.name === "parseInt" || e25.callee.name === "parseFloat");
}
function fP(e25) {
  return LA.isStringLiteral(e25) && (e25.value === "" || e25.type === "TemplateLiteral" && e25.quasis.length === 1 && e25.quasis[0].value.cooked === "");
}
function hP(e25) {
  return fP(e25.left) ? e25.right : e25.left;
}
var dP = { meta: { type: "suggestion", docs: { description: "disallow shorthand type conversions", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-implicit-coercion" }, fixable: "code", schema: [{ type: "object", properties: { boolean: { type: "boolean", default: true }, number: { type: "boolean", default: true }, string: { type: "boolean", default: true }, allow: { type: "array", items: { enum: ["~", "!!", "+", "*"] }, uniqueItems: true } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3, r3, i2) {
    e25.report({ node: t3, message: "use `{{recommendation}}` instead.", data: { recommendation: r3 }, fix: function(e26) {
      if (!i2)
        return null;
      var a2 = n2.getTokenBefore(t3);
      return a2 && a2.range[1] === t3.range[0] && !LA.canTokensBeAdjacent(a2, r3) ? e26.replaceText(t3, " ".concat(r3)) : e26.replaceText(t3, r3);
    } });
  }
  var r2 = function(e26) {
    return { boolean: !("boolean" in e26) || e26.boolean, number: !("number" in e26) || e26.number, string: !("string" in e26) || e26.string, allow: e26.allow || [] };
  }(e25.options[0] || {}), n2 = e25.getSourceCode();
  return { UnaryExpression: function(e26) {
    0 <= r2.allow.indexOf("!!") || !r2.boolean || !function(e27) {
      return e27.operator === "!" && e27.argument.type === "UnaryExpression" && e27.argument.operator === "!";
    }(e26) || t2(e26, "Boolean(".concat(n2.getText(e26.argument.argument), ")"), true);
    0 <= r2.allow.indexOf("~") || !r2.boolean || !function(e27) {
      return e27.operator === "~" && e27.argument.type === "CallExpression" && e27.argument.callee.type === "MemberExpression" && e27.argument.callee.property.type === "Identifier" && lP.test(e27.argument.callee.property.name);
    }(e26) || t2(e26, "".concat(n2.getText(e26.argument), " !== -1"), false);
    0 <= r2.allow.indexOf("+") || !r2.number || e26.operator !== "+" || pP(e26.argument) || t2(e26, "Number(".concat(n2.getText(e26.argument), ")"), true);
  }, "BinaryExpression:exit": function(e26) {
    var i2 = 0 <= r2.allow.indexOf("*"), a2 = !i2 && r2.number && function(e27) {
      return e27.operator === "*" && (e27.left.type === "Literal" && e27.left.value === 1 || e27.right.type === "Literal" && e27.right.value === 1);
    }(e26) && function(e27) {
      var t3 = e27.left, r3 = e27.right;
      return r3.type === "BinaryExpression" || pP(r3) ? t3.type === "BinaryExpression" || pP(t3) ? null : t3 : r3;
    }(e26);
    a2 && t2(e26, "Number(".concat(n2.getText(a2), ")"), true);
    !(i2 = 0 <= r2.allow.indexOf("+")) && r2.string && function(e27) {
      return e27.operator === "+" && (fP(e27.left) && !LA.isStringLiteral(e27.right) || fP(e27.right) && !LA.isStringLiteral(e27.left));
    }(e26) && t2(e26, "String(".concat(n2.getText(hP(e26)), ")"), true);
  }, AssignmentExpression: function(e26) {
    if (!(0 <= r2.allow.indexOf("+")) && r2.string && function(e27) {
      return e27.operator === "+=" && fP(e27.right);
    }(e26)) {
      var i2 = n2.getText(hP(e26));
      t2(e26, "".concat(i2, " = String(").concat(i2, ")"), true);
    }
  } };
} }, mP = Fy.require$$0, gP = mP.findVariable, yP = mP.getPropertyName, vP = { Object: new Set(["assign", "defineProperties", "defineProperty", "freeze", "setPrototypeOf"]), Reflect: new Set(["defineProperty", "deleteProperty", "set", "setPrototypeOf"]) };
function xP(e25, t2) {
  var r2 = e25.parent;
  return r2.type === "MemberExpression" && r2.object === e25 && (function(e26) {
    var t3 = e26.parent;
    return t3.type === "AssignmentExpression" && t3.left === e26 || t3.type === "ArrayPattern" || t3.type === "Property" && t3.value === e26 && t3.parent.type === "ObjectPattern" || t3.type === "RestElement" || t3.type === "AssignmentPattern" && t3.left === e26;
  }(r2) || function(e26) {
    var t3 = e26.parent;
    return t3.type === "UpdateExpression" && t3.argument === e26 || t3.type === "UnaryExpression" && t3.operator === "delete" && t3.argument === e26;
  }(r2) || function(e26) {
    var t3 = e26.parent;
    return t3.type === "ForInStatement" && t3.left === e26 || t3.type === "ForOfStatement" && t3.left === e26;
  }(r2)) || function(e26, t3) {
    var r3 = e26.parent;
    if (r3.type === "CallExpression" && r3.arguments[0] === e26 && r3.callee.type === "MemberExpression" && r3.callee.object.type === "Identifier") {
      var n2 = r3.callee, i2 = n2.object;
      if (Object.keys(vP).includes(i2.name)) {
        var a2 = gP(t3, i2);
        return a2 !== null && a2.scope.type === "global" && vP[i2.name].has(yP(n2, t3));
      }
    }
    return false;
  }(e25, t2);
}
function bP(e25) {
  for (var t2 = e25.parent; t2 && t2.type !== "AssignmentExpression" && t2.type !== "UpdateExpression" && t2.type !== "UnaryExpression" && t2.type !== "CallExpression" && t2.type !== "ForInStatement" && t2.type !== "ForOfStatement"; )
    t2 = t2.parent;
  return t2 || e25;
}
var EP = { meta: { type: "problem", docs: { description: "disallow assigning to imported bindings", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-import-assign" }, schema: [], messages: { readonly: "'{{name}}' is read-only.", readonlyMember: "The members of '{{name}}' are read-only." } }, create: function(e25) {
  return { ImportDeclaration: function(t2) {
    var r2 = e25.getScope(), n2 = true, i2 = false, a2 = void 0;
    try {
      for (var o2, s2 = e25.getDeclaredVariables(t2)[Symbol.iterator](); !(n2 = (o2 = s2.next()).done); n2 = true) {
        var u2 = o2.value, c2 = u2.defs.some(function(e26) {
          return e26.node.type === "ImportNamespaceSpecifier";
        }), l2 = null, p2 = true, f2 = false, h2 = void 0;
        try {
          for (var d2, m2 = u2.references[Symbol.iterator](); !(p2 = (d2 = m2.next()).done); p2 = true) {
            var g2 = d2.value, y2 = g2.identifier;
            y2 !== l2 && (l2 = y2, g2.isWrite() ? e25.report({ node: bP(y2), messageId: "readonly", data: { name: y2.name } }) : c2 && xP(y2, r2) && e25.report({ node: bP(y2), messageId: "readonlyMember", data: { name: y2.name } }));
          }
        } catch (e26) {
          f2 = true, h2 = e26;
        } finally {
          try {
            p2 || m2.return == null || m2.return();
          } finally {
            if (f2)
              throw h2;
          }
        }
      }
    } catch (e26) {
      i2 = true, a2 = e26;
    } finally {
      try {
        n2 || s2.return == null || s2.return();
      } finally {
        if (i2)
          throw a2;
      }
    }
  } };
} }, CP = { meta: { type: "suggestion", docs: { description: "disallow inline comments after code", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-inline-comments" }, schema: [] }, create: function(e25) {
  function t2(t3) {
    var n2 = r2.lines[t3.loc.start.line - 1] + "", i2 = r2.lines[t3.loc.end.line - 1] + "", a2 = n2.slice(0, t3.loc.start.column).trim(), o2 = i2.slice(t3.loc.end.column).trim(), s2 = !a2, u2 = !o2;
    if (!s2 || !u2) {
      if ((s2 || a2 === "{") && (u2 || o2 === "}")) {
        var c2 = r2.getNodeByRangeIndex(t3.range[0]);
        if (c2 && c2.type === "JSXEmptyExpression")
          return;
      }
      LA.isDirectiveComment(t3) || e25.report({ node: t3, message: "Unexpected comment inline with code." });
    }
  }
  var r2 = e25.getSourceCode();
  return { Program: function() {
    r2.getAllComments().filter(function(e26) {
      return e26.type !== "Shebang";
    }).forEach(t2);
  } };
} }, SP = new PA.RegExpValidator({ ecmaVersion: 2018 }), kP = /[gimsuy]/g, DP = void 0, FP = { meta: { type: "problem", docs: { description: "disallow invalid regular expression strings in `RegExp` constructors", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-invalid-regexp" }, schema: [{ type: "object", properties: { allowConstructorFlags: { type: "array", items: { type: "string" } } }, additionalProperties: false }] }, create: function(e25) {
  function t2(e26) {
    return e26 && e26.type === "Literal" && typeof e26.value == "string";
  }
  function r2(e26, t3) {
    try {
      return SP.validatePattern(e26, DP, DP, t3), null;
    } catch (e27) {
      return e27.message;
    }
  }
  var n2 = e25.options[0], i2 = null;
  if (n2 && n2.allowConstructorFlags) {
    var a2 = n2.allowConstructorFlags.join("").replace(kP, "");
    a2 && (i2 = new RegExp("[".concat(a2, "]"), "giu"));
  }
  return { "CallExpression, NewExpression": function(n3) {
    if (n3.callee.type === "Identifier" && n3.callee.name === "RegExp" && t2(n3.arguments[0])) {
      var a3 = n3.arguments[0].value, o2 = t2(n3.arguments[1]) ? n3.arguments[1].value : "";
      i2 && (o2 = o2.replace(i2, ""));
      var s2 = function(e26) {
        try {
          return SP.validateFlags(e26), null;
        } catch (t3) {
          return "Invalid flags supplied to RegExp constructor '".concat(e26, "'");
        }
      }(o2) || (o2 ? r2(a3, o2.indexOf("u") !== -1) : r2(a3, true) && r2(a3, false));
      s2 && e25.report({ node: n3, message: "{{message}}.", data: { message: s2 } });
    }
  } };
} }, AP = { meta: { type: "suggestion", docs: { description: "disallow `this` keywords outside of classes or class-like objects", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-invalid-this" }, schema: [{ type: "object", properties: { capIsConstructor: { type: "boolean", default: true } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3) {
    i2.push({ init: !e25.getScope().isStrict, node: t3, valid: true });
  }
  function r2() {
    i2.pop();
  }
  var n2 = (e25.options[0] || {}).capIsConstructor !== false, i2 = [], a2 = e25.getSourceCode();
  return i2.getCurrent = function() {
    var e26 = this[this.length - 1];
    return e26.init || (e26.init = true, e26.valid = !LA.isDefaultThisBinding(e26.node, a2, { capIsConstructor: n2 })), e26;
  }, { Program: function(t3) {
    var r3 = e25.getScope(), n3 = e25.parserOptions.ecmaFeatures || {};
    i2.push({ init: true, node: t3, valid: !(r3.isStrict || t3.sourceType === "module" || n3.globalReturn && r3.childScopes[0].isStrict) });
  }, "Program:exit": function() {
    i2.pop();
  }, FunctionDeclaration: t2, "FunctionDeclaration:exit": r2, FunctionExpression: t2, "FunctionExpression:exit": r2, ThisExpression: function(t3) {
    var r3 = i2.getCurrent();
    r3 && !r3.valid && e25.report({ node: t3, message: "Unexpected 'this'." });
  } };
} }, wP = /[\x0B\f\x85\xA0\u1680\u180E\u2000-\u200B\u2028\u2029\u202F\u205F\u3000\uFEFF]/, _P = /[\x0B\f\x85\xA0\u1680\u180E\u2000-\u200B\u202F\u205F\u3000\uFEFF]+/gm, TP = /[\u2028\u2029]/gm, PP = LA.createGlobalLinebreakMatcher(), IP = { meta: { type: "problem", docs: { description: "disallow irregular whitespace", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-irregular-whitespace" }, schema: [{ type: "object", properties: { skipComments: { type: "boolean", default: false }, skipStrings: { type: "boolean", default: true }, skipTemplates: { type: "boolean", default: false }, skipRegExps: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e25) {
  function t2(e26) {
    var t3 = e26.loc.start, r3 = e26.loc.end;
    a2 = a2.filter(function(e27) {
      var n3 = e27.loc;
      return !(n3.line >= t3.line && n3.line <= r3.line && n3.column >= t3.column && (n3.column <= r3.column || n3.line < r3.line));
    });
  }
  function r2(e26) {
    var r3 = u2 && typeof e26.value == "string", n3 = c2 && !!e26.regex;
    (r3 || n3) && wP.test(e26.raw) && t2(e26);
  }
  function n2(e26) {
    wP.test(e26.value) && t2(e26);
  }
  function i2() {
  }
  var a2 = [], o2 = e25.options[0] || {}, s2 = !!o2.skipComments, u2 = o2.skipStrings !== false, c2 = !!o2.skipRegExps, l2 = !!o2.skipTemplates, p2 = e25.getSourceCode(), f2 = p2.getAllComments(), h2 = {};
  return wP.test(p2.getText()) ? (h2.Program = function(e26) {
    (function(e27) {
      p2.lines.forEach(function(t3, r3) {
        for (var n3; (n3 = _P.exec(t3)) !== null; ) {
          var i3 = { line: r3 + 1, column: n3.index };
          a2.push({ node: e27, message: "Irregular whitespace not allowed.", loc: i3 });
        }
      });
    })(e26), function(e27) {
      for (var t3, r3 = p2.getText(), n3 = p2.lines, i3 = r3.match(PP), o3 = -1; (t3 = TP.exec(r3)) !== null; ) {
        var s3 = i3.indexOf(t3[0], o3 + 1) || 0, u3 = { line: s3 + 1, column: n3[s3].length };
        a2.push({ node: e27, message: "Irregular whitespace not allowed.", loc: u3 }), o3 = s3;
      }
    }(e26);
  }, h2.Identifier = r2, h2.Literal = r2, h2.TemplateElement = l2 ? function(e26) {
    typeof e26.value.raw == "string" && wP.test(e26.value.raw) && t2(e26);
  } : i2, h2["Program:exit"] = function() {
    s2 && f2.forEach(n2), a2.forEach(function(t3) {
      return e25.report(t3);
    });
  }) : h2.Program = i2, h2;
} }, BP = { meta: { type: "suggestion", docs: { description: "disallow labels that share a name with a variable", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-label-var" }, schema: [] }, create: function(e25) {
  return { LabeledStatement: function(t2) {
    (function(e26, t3) {
      return LA.getVariableByName(e26, t3) !== null;
    })(e25.getScope(), t2.label.name) && e25.report({ node: t2, message: "Found identifier with same name as label." });
  } };
} }, OP = { meta: { type: "suggestion", docs: { description: "disallow labeled statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-labels" }, schema: [{ type: "object", properties: { allowLoop: { type: "boolean", default: false }, allowSwitch: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e25) {
  function t2(e26) {
    return LA.isLoop(e26) ? "loop" : e26.type === "SwitchStatement" ? "switch" : "other";
  }
  function r2(e26) {
    return e26 === "loop" ? a2 : !(e26 != "switch") && o2;
  }
  function n2(e26) {
    for (var t3 = s2; t3; ) {
      if (t3.label === e26)
        return t3.kind;
      t3 = t3.upper;
    }
    return "other";
  }
  var i2 = e25.options[0], a2 = i2 && i2.allowLoop, o2 = i2 && i2.allowSwitch, s2 = null;
  return { LabeledStatement: function(e26) {
    s2 = { label: e26.label.name, kind: t2(e26.body), upper: s2 };
  }, "LabeledStatement:exit": function(t3) {
    r2(s2.kind) || e25.report({ node: t3, message: "Unexpected labeled statement." }), s2 = s2.upper;
  }, BreakStatement: function(t3) {
    t3.label && !r2(n2(t3.label.name)) && e25.report({ node: t3, message: "Unexpected label in break statement." });
  }, ContinueStatement: function(t3) {
    t3.label && !r2(n2(t3.label.name)) && e25.report({ node: t3, message: "Unexpected label in continue statement." });
  } };
} };
function LP(e25) {
  for (var t2 = e25; t2.parent; t2 = t2.parent) {
    var r2 = t2.parent;
    switch (r2.type) {
      case "WhileStatement":
      case "DoWhileStatement":
        return r2;
      case "ForStatement":
        if (r2.init !== t2)
          return r2;
        break;
      case "ForInStatement":
      case "ForOfStatement":
        if (r2.right !== t2)
          return r2;
        break;
      case "ArrowFunctionExpression":
      case "FunctionExpression":
      case "FunctionDeclaration":
        return null;
    }
  }
  return null;
}
function NP(e25, t2) {
  var r2 = t2.resolved, n2 = r2 && r2.defs[0], i2 = n2 && n2.parent, a2 = i2 && i2.type === "VariableDeclaration" ? i2.kind : "";
  if (a2 === "const")
    return true;
  if (a2 === "let" && i2.range[0] > e25.range[0] && i2.range[1] < e25.range[1])
    return true;
  var o2 = function(e26, t3) {
    for (var r3 = t3 ? t3.range[1] : 0, n3 = e26, i3 = e26; i3 && i3.range[0] >= r3; )
      n3 = i3, i3 = LP(i3);
    return n3;
  }(e25, a2 === "let" ? i2 : null).range[0];
  return !!r2 && r2.references.every(function(e26) {
    var t3 = e26.identifier;
    return !e26.isWrite() || r2.scope.variableScope === e26.from.variableScope && t3.range[0] < o2;
  });
}
var jP = { meta: { type: "suggestion", docs: { description: "disallow function declarations that contain unsafe references inside loop statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-loop-func" }, schema: [], messages: { unsafeRefs: "Function declared in a loop contains unsafe references to variable(s) {{ varNames }}." } }, create: function(e25) {
  function t2(t3) {
    var r2 = LP(t3);
    if (r2) {
      var n2 = e25.getScope().through.filter(function(e26) {
        return !NP(r2, e26);
      }).map(function(e26) {
        return e26.identifier.name;
      });
      0 < n2.length && e25.report({ node: t3, messageId: "unsafeRefs", data: { varNames: "'".concat(n2.join("', '"), "'") } });
    }
  }
  return { ArrowFunctionExpression: t2, FunctionExpression: t2, FunctionDeclaration: t2 };
} }, RP = new Set([768, 769, 770, 771, 772, 773, 774, 775, 776, 777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 787, 788, 789, 790, 791, 792, 793, 794, 795, 796, 797, 798, 799, 800, 801, 802, 803, 804, 805, 806, 807, 808, 809, 810, 811, 812, 813, 814, 815, 816, 817, 818, 819, 820, 821, 822, 823, 824, 825, 826, 827, 828, 829, 830, 831, 832, 833, 834, 835, 836, 837, 838, 839, 840, 841, 842, 843, 844, 845, 846, 847, 848, 849, 850, 851, 852, 853, 854, 855, 856, 857, 858, 859, 860, 861, 862, 863, 864, 865, 866, 867, 868, 869, 870, 871, 872, 873, 874, 875, 876, 877, 878, 879, 1155, 1156, 1157, 1158, 1159, 1160, 1161, 1425, 1426, 1427, 1428, 1429, 1430, 1431, 1432, 1433, 1434, 1435, 1436, 1437, 1438, 1439, 1440, 1441, 1442, 1443, 1444, 1445, 1446, 1447, 1448, 1449, 1450, 1451, 1452, 1453, 1454, 1455, 1456, 1457, 1458, 1459, 1460, 1461, 1462, 1463, 1464, 1465, 1466, 1467, 1468, 1469, 1471, 1473, 1474, 1476, 1477, 1479, 1552, 1553, 1554, 1555, 1556, 1557, 1558, 1559, 1560, 1561, 1562, 1611, 1612, 1613, 1614, 1615, 1616, 1617, 1618, 1619, 1620, 1621, 1622, 1623, 1624, 1625, 1626, 1627, 1628, 1629, 1630, 1631, 1648, 1750, 1751, 1752, 1753, 1754, 1755, 1756, 1759, 1760, 1761, 1762, 1763, 1764, 1767, 1768, 1770, 1771, 1772, 1773, 1809, 1840, 1841, 1842, 1843, 1844, 1845, 1846, 1847, 1848, 1849, 1850, 1851, 1852, 1853, 1854, 1855, 1856, 1857, 1858, 1859, 1860, 1861, 1862, 1863, 1864, 1865, 1866, 1958, 1959, 1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035, 2070, 2071, 2072, 2073, 2075, 2076, 2077, 2078, 2079, 2080, 2081, 2082, 2083, 2085, 2086, 2087, 2089, 2090, 2091, 2092, 2093, 2137, 2138, 2139, 2260, 2261, 2262, 2263, 2264, 2265, 2266, 2267, 2268, 2269, 2270, 2271, 2272, 2273, 2275, 2276, 2277, 2278, 2279, 2280, 2281, 2282, 2283, 2284, 2285, 2286, 2287, 2288, 2289, 2290, 2291, 2292, 2293, 2294, 2295, 2296, 2297, 2298, 2299, 2300, 2301, 2302, 2303, 2304, 2305, 2306, 2307, 2362, 2363, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2385, 2386, 2387, 2388, 2389, 2390, 2391, 2402, 2403, 2433, 2434, 2435, 2492, 2494, 2495, 2496, 2497, 2498, 2499, 2500, 2503, 2504, 2507, 2508, 2509, 2519, 2530, 2531, 2561, 2562, 2563, 2620, 2622, 2623, 2624, 2625, 2626, 2631, 2632, 2635, 2636, 2637, 2641, 2672, 2673, 2677, 2689, 2690, 2691, 2748, 2750, 2751, 2752, 2753, 2754, 2755, 2756, 2757, 2759, 2760, 2761, 2763, 2764, 2765, 2786, 2787, 2810, 2811, 2812, 2813, 2814, 2815, 2817, 2818, 2819, 2876, 2878, 2879, 2880, 2881, 2882, 2883, 2884, 2887, 2888, 2891, 2892, 2893, 2902, 2903, 2914, 2915, 2946, 3006, 3007, 3008, 3009, 3010, 3014, 3015, 3016, 3018, 3019, 3020, 3021, 3031, 3072, 3073, 3074, 3075, 3134, 3135, 3136, 3137, 3138, 3139, 3140, 3142, 3143, 3144, 3146, 3147, 3148, 3149, 3157, 3158, 3170, 3171, 3201, 3202, 3203, 3260, 3262, 3263, 3264, 3265, 3266, 3267, 3268, 3270, 3271, 3272, 3274, 3275, 3276, 3277, 3285, 3286, 3298, 3299, 3328, 3329, 3330, 3331, 3387, 3388, 3390, 3391, 3392, 3393, 3394, 3395, 3396, 3398, 3399, 3400, 3402, 3403, 3404, 3405, 3415, 3426, 3427, 3458, 3459, 3530, 3535, 3536, 3537, 3538, 3539, 3540, 3542, 3544, 3545, 3546, 3547, 3548, 3549, 3550, 3551, 3570, 3571, 3633, 3636, 3637, 3638, 3639, 3640, 3641, 3642, 3655, 3656, 3657, 3658, 3659, 3660, 3661, 3662, 3761, 3764, 3765, 3766, 3767, 3768, 3769, 3771, 3772, 3784, 3785, 3786, 3787, 3788, 3789, 3864, 3865, 3893, 3895, 3897, 3902, 3903, 3953, 3954, 3955, 3956, 3957, 3958, 3959, 3960, 3961, 3962, 3963, 3964, 3965, 3966, 3967, 3968, 3969, 3970, 3971, 3972, 3974, 3975, 3981, 3982, 3983, 3984, 3985, 3986, 3987, 3988, 3989, 3990, 3991, 3993, 3994, 3995, 3996, 3997, 3998, 3999, 4e3, 4001, 4002, 4003, 4004, 4005, 4006, 4007, 4008, 4009, 4010, 4011, 4012, 4013, 4014, 4015, 4016, 4017, 4018, 4019, 4020, 4021, 4022, 4023, 4024, 4025, 4026, 4027, 4028, 4038, 4139, 4140, 4141, 4142, 4143, 4144, 4145, 4146, 4147, 4148, 4149, 4150, 4151, 4152, 4153, 4154, 4155, 4156, 4157, 4158, 4182, 4183, 4184, 4185, 4190, 4191, 4192, 4194, 4195, 4196, 4199, 4200, 4201, 4202, 4203, 4204, 4205, 4209, 4210, 4211, 4212, 4226, 4227, 4228, 4229, 4230, 4231, 4232, 4233, 4234, 4235, 4236, 4237, 4239, 4250, 4251, 4252, 4253, 4957, 4958, 4959, 5906, 5907, 5908, 5938, 5939, 5940, 5970, 5971, 6002, 6003, 6068, 6069, 6070, 6071, 6072, 6073, 6074, 6075, 6076, 6077, 6078, 6079, 6080, 6081, 6082, 6083, 6084, 6085, 6086, 6087, 6088, 6089, 6090, 6091, 6092, 6093, 6094, 6095, 6096, 6097, 6098, 6099, 6109, 6155, 6156, 6157, 6277, 6278, 6313, 6432, 6433, 6434, 6435, 6436, 6437, 6438, 6439, 6440, 6441, 6442, 6443, 6448, 6449, 6450, 6451, 6452, 6453, 6454, 6455, 6456, 6457, 6458, 6459, 6679, 6680, 6681, 6682, 6683, 6741, 6742, 6743, 6744, 6745, 6746, 6747, 6748, 6749, 6750, 6752, 6753, 6754, 6755, 6756, 6757, 6758, 6759, 6760, 6761, 6762, 6763, 6764, 6765, 6766, 6767, 6768, 6769, 6770, 6771, 6772, 6773, 6774, 6775, 6776, 6777, 6778, 6779, 6780, 6783, 6832, 6833, 6834, 6835, 6836, 6837, 6838, 6839, 6840, 6841, 6842, 6843, 6844, 6845, 6846, 6912, 6913, 6914, 6915, 6916, 6964, 6965, 6966, 6967, 6968, 6969, 6970, 6971, 6972, 6973, 6974, 6975, 6976, 6977, 6978, 6979, 6980, 7019, 7020, 7021, 7022, 7023, 7024, 7025, 7026, 7027, 7040, 7041, 7042, 7073, 7074, 7075, 7076, 7077, 7078, 7079, 7080, 7081, 7082, 7083, 7084, 7085, 7142, 7143, 7144, 7145, 7146, 7147, 7148, 7149, 7150, 7151, 7152, 7153, 7154, 7155, 7204, 7205, 7206, 7207, 7208, 7209, 7210, 7211, 7212, 7213, 7214, 7215, 7216, 7217, 7218, 7219, 7220, 7221, 7222, 7223, 7376, 7377, 7378, 7380, 7381, 7382, 7383, 7384, 7385, 7386, 7387, 7388, 7389, 7390, 7391, 7392, 7393, 7394, 7395, 7396, 7397, 7398, 7399, 7400, 7405, 7410, 7411, 7412, 7415, 7416, 7417, 7616, 7617, 7618, 7619, 7620, 7621, 7622, 7623, 7624, 7625, 7626, 7627, 7628, 7629, 7630, 7631, 7632, 7633, 7634, 7635, 7636, 7637, 7638, 7639, 7640, 7641, 7642, 7643, 7644, 7645, 7646, 7647, 7648, 7649, 7650, 7651, 7652, 7653, 7654, 7655, 7656, 7657, 7658, 7659, 7660, 7661, 7662, 7663, 7664, 7665, 7666, 7667, 7668, 7669, 7670, 7671, 7672, 7673, 7675, 7676, 7677, 7678, 7679, 8400, 8401, 8402, 8403, 8404, 8405, 8406, 8407, 8408, 8409, 8410, 8411, 8412, 8413, 8414, 8415, 8416, 8417, 8418, 8419, 8420, 8421, 8422, 8423, 8424, 8425, 8426, 8427, 8428, 8429, 8430, 8431, 8432, 11503, 11504, 11505, 11647, 11744, 11745, 11746, 11747, 11748, 11749, 11750, 11751, 11752, 11753, 11754, 11755, 11756, 11757, 11758, 11759, 11760, 11761, 11762, 11763, 11764, 11765, 11766, 11767, 11768, 11769, 11770, 11771, 11772, 11773, 11774, 11775, 12330, 12331, 12332, 12333, 12334, 12335, 12441, 12442, 42607, 42608, 42609, 42610, 42612, 42613, 42614, 42615, 42616, 42617, 42618, 42619, 42620, 42621, 42654, 42655, 42736, 42737, 43010, 43014, 43019, 43043, 43044, 43045, 43046, 43047, 43136, 43137, 43188, 43189, 43190, 43191, 43192, 43193, 43194, 43195, 43196, 43197, 43198, 43199, 43200, 43201, 43202, 43203, 43204, 43205, 43232, 43233, 43234, 43235, 43236, 43237, 43238, 43239, 43240, 43241, 43242, 43243, 43244, 43245, 43246, 43247, 43248, 43249, 43302, 43303, 43304, 43305, 43306, 43307, 43308, 43309, 43335, 43336, 43337, 43338, 43339, 43340, 43341, 43342, 43343, 43344, 43345, 43346, 43347, 43392, 43393, 43394, 43395, 43443, 43444, 43445, 43446, 43447, 43448, 43449, 43450, 43451, 43452, 43453, 43454, 43455, 43456, 43493, 43561, 43562, 43563, 43564, 43565, 43566, 43567, 43568, 43569, 43570, 43571, 43572, 43573, 43574, 43587, 43596, 43597, 43643, 43644, 43645, 43696, 43698, 43699, 43700, 43703, 43704, 43710, 43711, 43713, 43755, 43756, 43757, 43758, 43759, 43765, 43766, 44003, 44004, 44005, 44006, 44007, 44008, 44009, 44010, 44012, 44013, 64286, 65024, 65025, 65026, 65027, 65028, 65029, 65030, 65031, 65032, 65033, 65034, 65035, 65036, 65037, 65038, 65039, 65056, 65057, 65058, 65059, 65060, 65061, 65062, 65063, 65064, 65065, 65066, 65067, 65068, 65069, 65070, 65071, 66045, 66272, 66422, 66423, 66424, 66425, 66426, 68097, 68098, 68099, 68101, 68102, 68108, 68109, 68110, 68111, 68152, 68153, 68154, 68159, 68325, 68326, 69632, 69633, 69634, 69688, 69689, 69690, 69691, 69692, 69693, 69694, 69695, 69696, 69697, 69698, 69699, 69700, 69701, 69702, 69759, 69760, 69761, 69762, 69808, 69809, 69810, 69811, 69812, 69813, 69814, 69815, 69816, 69817, 69818, 69888, 69889, 69890, 69927, 69928, 69929, 69930, 69931, 69932, 69933, 69934, 69935, 69936, 69937, 69938, 69939, 69940, 70003, 70016, 70017, 70018, 70067, 70068, 70069, 70070, 70071, 70072, 70073, 70074, 70075, 70076, 70077, 70078, 70079, 70080, 70090, 70091, 70092, 70188, 70189, 70190, 70191, 70192, 70193, 70194, 70195, 70196, 70197, 70198, 70199, 70206, 70367, 70368, 70369, 70370, 70371, 70372, 70373, 70374, 70375, 70376, 70377, 70378, 70400, 70401, 70402, 70403, 70460, 70462, 70463, 70464, 70465, 70466, 70467, 70468, 70471, 70472, 70475, 70476, 70477, 70487, 70498, 70499, 70502, 70503, 70504, 70505, 70506, 70507, 70508, 70512, 70513, 70514, 70515, 70516, 70709, 70710, 70711, 70712, 70713, 70714, 70715, 70716, 70717, 70718, 70719, 70720, 70721, 70722, 70723, 70724, 70725, 70726, 70832, 70833, 70834, 70835, 70836, 70837, 70838, 70839, 70840, 70841, 70842, 70843, 70844, 70845, 70846, 70847, 70848, 70849, 70850, 70851, 71087, 71088, 71089, 71090, 71091, 71092, 71093, 71096, 71097, 71098, 71099, 71100, 71101, 71102, 71103, 71104, 71132, 71133, 71216, 71217, 71218, 71219, 71220, 71221, 71222, 71223, 71224, 71225, 71226, 71227, 71228, 71229, 71230, 71231, 71232, 71339, 71340, 71341, 71342, 71343, 71344, 71345, 71346, 71347, 71348, 71349, 71350, 71351, 71453, 71454, 71455, 71456, 71457, 71458, 71459, 71460, 71461, 71462, 71463, 71464, 71465, 71466, 71467, 72193, 72194, 72195, 72196, 72197, 72198, 72199, 72200, 72201, 72202, 72243, 72244, 72245, 72246, 72247, 72248, 72249, 72251, 72252, 72253, 72254, 72263, 72273, 72274, 72275, 72276, 72277, 72278, 72279, 72280, 72281, 72282, 72283, 72330, 72331, 72332, 72333, 72334, 72335, 72336, 72337, 72338, 72339, 72340, 72341, 72342, 72343, 72344, 72345, 72751, 72752, 72753, 72754, 72755, 72756, 72757, 72758, 72760, 72761, 72762, 72763, 72764, 72765, 72766, 72767, 72850, 72851, 72852, 72853, 72854, 72855, 72856, 72857, 72858, 72859, 72860, 72861, 72862, 72863, 72864, 72865, 72866, 72867, 72868, 72869, 72870, 72871, 72873, 72874, 72875, 72876, 72877, 72878, 72879, 72880, 72881, 72882, 72883, 72884, 72885, 72886, 73009, 73010, 73011, 73012, 73013, 73014, 73018, 73020, 73021, 73023, 73024, 73025, 73026, 73027, 73028, 73029, 73031, 92912, 92913, 92914, 92915, 92916, 92976, 92977, 92978, 92979, 92980, 92981, 92982, 94033, 94034, 94035, 94036, 94037, 94038, 94039, 94040, 94041, 94042, 94043, 94044, 94045, 94046, 94047, 94048, 94049, 94050, 94051, 94052, 94053, 94054, 94055, 94056, 94057, 94058, 94059, 94060, 94061, 94062, 94063, 94064, 94065, 94066, 94067, 94068, 94069, 94070, 94071, 94072, 94073, 94074, 94075, 94076, 94077, 94078, 94095, 94096, 94097, 94098, 113821, 113822, 119141, 119142, 119143, 119144, 119145, 119149, 119150, 119151, 119152, 119153, 119154, 119163, 119164, 119165, 119166, 119167, 119168, 119169, 119170, 119173, 119174, 119175, 119176, 119177, 119178, 119179, 119210, 119211, 119212, 119213, 119362, 119363, 119364, 121344, 121345, 121346, 121347, 121348, 121349, 121350, 121351, 121352, 121353, 121354, 121355, 121356, 121357, 121358, 121359, 121360, 121361, 121362, 121363, 121364, 121365, 121366, 121367, 121368, 121369, 121370, 121371, 121372, 121373, 121374, 121375, 121376, 121377, 121378, 121379, 121380, 121381, 121382, 121383, 121384, 121385, 121386, 121387, 121388, 121389, 121390, 121391, 121392, 121393, 121394, 121395, 121396, 121397, 121398, 121403, 121404, 121405, 121406, 121407, 121408, 121409, 121410, 121411, 121412, 121413, 121414, 121415, 121416, 121417, 121418, 121419, 121420, 121421, 121422, 121423, 121424, 121425, 121426, 121427, 121428, 121429, 121430, 121431, 121432, 121433, 121434, 121435, 121436, 121437, 121438, 121439, 121440, 121441, 121442, 121443, 121444, 121445, 121446, 121447, 121448, 121449, 121450, 121451, 121452, 121461, 121476, 121499, 121500, 121501, 121502, 121503, 121505, 121506, 121507, 121508, 121509, 121510, 121511, 121512, 121513, 121514, 121515, 121516, 121517, 121518, 121519, 122880, 122881, 122882, 122883, 122884, 122885, 122886, 122888, 122889, 122890, 122891, 122892, 122893, 122894, 122895, 122896, 122897, 122898, 122899, 122900, 122901, 122902, 122903, 122904, 122907, 122908, 122909, 122910, 122911, 122912, 122913, 122915, 122916, 122918, 122919, 122920, 122921, 122922, 125136, 125137, 125138, 125139, 125140, 125141, 125142, 125252, 125253, 125254, 125255, 125256, 125257, 125258, 917760, 917761, 917762, 917763, 917764, 917765, 917766, 917767, 917768, 917769, 917770, 917771, 917772, 917773, 917774, 917775, 917776, 917777, 917778, 917779, 917780, 917781, 917782, 917783, 917784, 917785, 917786, 917787, 917788, 917789, 917790, 917791, 917792, 917793, 917794, 917795, 917796, 917797, 917798, 917799, 917800, 917801, 917802, 917803, 917804, 917805, 917806, 917807, 917808, 917809, 917810, 917811, 917812, 917813, 917814, 917815, 917816, 917817, 917818, 917819, 917820, 917821, 917822, 917823, 917824, 917825, 917826, 917827, 917828, 917829, 917830, 917831, 917832, 917833, 917834, 917835, 917836, 917837, 917838, 917839, 917840, 917841, 917842, 917843, 917844, 917845, 917846, 917847, 917848, 917849, 917850, 917851, 917852, 917853, 917854, 917855, 917856, 917857, 917858, 917859, 917860, 917861, 917862, 917863, 917864, 917865, 917866, 917867, 917868, 917869, 917870, 917871, 917872, 917873, 917874, 917875, 917876, 917877, 917878, 917879, 917880, 917881, 917882, 917883, 917884, 917885, 917886, 917887, 917888, 917889, 917890, 917891, 917892, 917893, 917894, 917895, 917896, 917897, 917898, 917899, 917900, 917901, 917902, 917903, 917904, 917905, 917906, 917907, 917908, 917909, 917910, 917911, 917912, 917913, 917914, 917915, 917916, 917917, 917918, 917919, 917920, 917921, 917922, 917923, 917924, 917925, 917926, 917927, 917928, 917929, 917930, 917931, 917932, 917933, 917934, 917935, 917936, 917937, 917938, 917939, 917940, 917941, 917942, 917943, 917944, 917945, 917946, 917947, 917948, 917949, 917950, 917951, 917952, 917953, 917954, 917955, 917956, 917957, 917958, 917959, 917960, 917961, 917962, 917963, 917964, 917965, 917966, 917967, 917968, 917969, 917970, 917971, 917972, 917973, 917974, 917975, 917976, 917977, 917978, 917979, 917980, 917981, 917982, 917983, 917984, 917985, 917986, 917987, 917988, 917989, 917990, 917991, 917992, 917993, 917994, 917995, 917996, 917997, 917998, 917999]), MP = function(e25) {
  return RP.has(e25);
}, VP = function(e25) {
  return 127995 <= e25 && 127999 >= e25;
}, UP = function(e25) {
  return 127462 <= e25 && 127487 >= e25;
}, qP = function(e25, t2) {
  return 55296 <= e25 && 56320 > e25 && 56320 <= t2 && 57344 > t2;
}, WP = Fy.require$$0, $P = WP.CALL, GP = WP.CONSTRUCT, zP = WP.ReferenceTracker, HP = WP.getStringIfConstant, KP = PA.RegExpParser, JP = PA.visitRegExpAST, QP = MP, XP = VP, YP = UP, ZP = qP;
function eI(e25) {
  var t2, r2, n2, i2, a2, o2, s2;
  return regeneratorRuntime.wrap(function(u2) {
    for (; ; )
      switch (u2.prev = u2.next) {
        case 0:
          t2 = [], r2 = true, n2 = false, i2 = void 0, u2.prev = 4, a2 = e25[Symbol.iterator]();
        case 6:
          if (r2 = (o2 = a2.next()).done) {
            u2.next = 26;
            break;
          }
          s2 = o2.value, u2.t0 = s2.type, u2.next = u2.t0 === "Character" ? 11 : u2.t0 === "CharacterClassRange" ? 13 : u2.t0 === "CharacterSet" ? 18 : 23;
          break;
        case 11:
          return t2.push(s2.value), u2.abrupt("break", 23);
        case 13:
          return t2.push(s2.min.value), u2.next = 16, t2;
        case 16:
          return t2 = [s2.max.value], u2.abrupt("break", 23);
        case 18:
          if (u2.t1 = 0 < t2.length, !u2.t1) {
            u2.next = 23;
            break;
          }
          return u2.next = 22, t2;
        case 22:
          t2 = [];
        case 23:
          r2 = true, u2.next = 6;
          break;
        case 26:
          u2.next = 32;
          break;
        case 28:
          u2.prev = 28, u2.t2 = u2.catch(4), n2 = true, i2 = u2.t2;
        case 32:
          u2.prev = 32, u2.prev = 33, r2 || a2.return == null || a2.return();
        case 35:
          if (u2.prev = 35, !n2) {
            u2.next = 38;
            break;
          }
          throw i2;
        case 38:
          return u2.finish(35);
        case 39:
          return u2.finish(32);
        case 40:
          if (u2.t3 = 0 < t2.length, !u2.t3) {
            u2.next = 44;
            break;
          }
          return u2.next = 44, t2;
        case 44:
        case "end":
          return u2.stop();
      }
  }, AA, null, [[4, 28, 32, 40], [33, , 35, 39]]);
}
var tI = { surrogatePairWithoutUFlag: function(e25) {
  return e25.some(function(t2, r2) {
    return r2 !== 0 && ZP(e25[r2 - 1], t2);
  });
}, combiningClass: function(e25) {
  return e25.some(function(t2, r2) {
    return r2 !== 0 && QP(t2) && !QP(e25[r2 - 1]);
  });
}, emojiModifier: function(e25) {
  return e25.some(function(t2, r2) {
    return r2 !== 0 && XP(t2) && !XP(e25[r2 - 1]);
  });
}, regionalIndicatorSymbol: function(e25) {
  return e25.some(function(t2, r2) {
    return r2 !== 0 && YP(t2) && YP(e25[r2 - 1]);
  });
}, zwj: function(e25) {
  var t2 = e25.length - 1;
  return e25.some(function(r2, n2) {
    return n2 !== 0 && n2 !== t2 && r2 === 8205 && e25[n2 - 1] !== 8205 && e25[n2 + 1] !== 8205;
  });
} }, rI = Object.keys(tI), nI = { meta: { type: "problem", docs: { description: "disallow characters which are made with multiple code points in character class syntax", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-misleading-character-class" }, schema: [], messages: { surrogatePairWithoutUFlag: "Unexpected surrogate pair in character class. Use 'u' flag.", combiningClass: "Unexpected combined character in character class.", emojiModifier: "Unexpected modified Emoji in character class.", regionalIndicatorSymbol: "Unexpected national flag in character class.", zwj: "Unexpected joined character sequence in character class." } }, create: function(e25) {
  function t2(t3, n2, i2) {
    var a2, o2 = { surrogatePairWithoutUFlag: false, combiningClass: false, variationSelector: false, emojiModifier: false, regionalIndicatorSymbol: false, zwj: false };
    try {
      a2 = r2.parsePattern(n2, 0, n2.length, i2.includes("u"));
    } catch (t4) {
      return;
    }
    JP(a2, { onCharacterClassEnter: function(e26) {
      var t4 = true, r3 = false, n3 = void 0;
      try {
        for (var i3, a3 = eI(e26.elements)[Symbol.iterator](); !(t4 = (i3 = a3.next()).done); t4 = true) {
          var s3 = i3.value, u3 = true, c3 = false, l3 = void 0;
          try {
            for (var p3, f3 = rI[Symbol.iterator](); !(u3 = (p3 = f3.next()).done); u3 = true) {
              var h2 = p3.value;
              o2[h2] = o2[h2] || tI[h2](s3);
            }
          } catch (e27) {
            c3 = true, l3 = e27;
          } finally {
            try {
              u3 || f3.return == null || f3.return();
            } finally {
              if (c3)
                throw l3;
            }
          }
        }
      } catch (e27) {
        r3 = true, n3 = e27;
      } finally {
        try {
          t4 || a3.return == null || a3.return();
        } finally {
          if (r3)
            throw n3;
        }
      }
    } });
    var s2 = true, u2 = false, c2 = void 0;
    try {
      for (var l2, p2 = rI[Symbol.iterator](); !(s2 = (l2 = p2.next()).done); s2 = true) {
        var f2 = l2.value;
        o2[f2] && e25.report({ node: t3, messageId: f2 });
      }
    } catch (e26) {
      u2 = true, c2 = e26;
    } finally {
      try {
        s2 || p2.return == null || p2.return();
      } finally {
        if (u2)
          throw c2;
      }
    }
  }
  var r2 = new KP();
  return { "Literal[regex]": function(e26) {
    t2(e26, e26.regex.pattern, e26.regex.flags);
  }, Program: function() {
    var r3 = e25.getScope(), n2 = new zP(r3), i2 = true, a2 = false, o2 = void 0;
    try {
      for (var s2, c2 = n2.iterateGlobalReferences({ RegExp: (l2 = {}, u(l2, $P, true), u(l2, GP, true), l2) })[Symbol.iterator](); !(i2 = (s2 = c2.next()).done); i2 = true) {
        var l2, p2 = s2.value.node, f2 = b(p2.arguments, 2), h2 = f2[0], d2 = f2[1], m2 = HP(h2, r3), g2 = HP(d2, r3);
        typeof m2 == "string" && t2(p2, m2, g2 || "");
      }
    } catch (e26) {
      a2 = true, o2 = e26;
    } finally {
      try {
        i2 || c2.return == null || c2.return();
      } finally {
        if (a2)
          throw o2;
      }
    }
  } };
} }, iI = ["+", "-", "*", "/", "%", "**"], aI = ["&", "|", "^", "~", "<<", ">>", ">>>"], oI = ["==", "!=", "===", "!==", ">", ">=", "<", "<="], sI = ["&&", "||"], uI = ["in", "instanceof"], cI = [].concat(iI, aI, oI, sI, uI, ["?:"]), lI = [iI, aI, oI, sI, uI], pI = /^(?:Binary|Logical|Conditional)Expression$/;
function fI(e25) {
  return e25.type === "ConditionalExpression" ? e25.test : e25.left;
}
var hI = { meta: { type: "suggestion", docs: { description: "disallow mixed binary operators", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-mixed-operators" }, schema: [{ type: "object", properties: { groups: { type: "array", items: { type: "array", items: { enum: cI }, minItems: 2, uniqueItems: true }, uniqueItems: true }, allowSamePrecedence: { type: "boolean", default: true } }, additionalProperties: false }] }, create: function(e25) {
  function t2(e26) {
    var t3 = e26, r3 = e26.parent;
    return !function(e27, t4, r4) {
      return e27.some(function(e28) {
        return e28.indexOf(t4) !== -1 && e28.indexOf(r4) !== -1;
      });
    }(o2.groups, t3.operator, r3.type === "ConditionalExpression" ? "?:" : r3.operator) || o2.allowSamePrecedence && LA.getPrecedence(t3) === LA.getPrecedence(r3);
  }
  function r2(e26) {
    return a2.getTokenAfter(fI(e26), LA.isNotClosingParenToken);
  }
  function n2(t3) {
    var n3 = t3.parent, i3 = fI(n3) === t3 ? t3 : n3, a3 = fI(n3) === t3 ? n3 : t3, o3 = "Unexpected mix of '{{leftOperator}}' and '{{rightOperator}}'.", s2 = { leftOperator: i3.operator || "?:", rightOperator: a3.operator || "?:" };
    e25.report({ node: i3, loc: r2(i3).loc, message: o3, data: s2 }), e25.report({ node: a3, loc: r2(a3).loc, message: o3, data: s2 });
  }
  function i2(e26) {
    pI.test(e26.parent.type) && (e26.parent.type === "ConditionalExpression" && !t2(e26) && function(e27) {
      return !LA.isParenthesised(a2, e27) && !LA.isParenthesised(a2, e27.test);
    }(e26.parent) ? n2(e26) : pI.test(e26.parent.type) && function(e27) {
      return e27.operator !== e27.parent.operator && !LA.isParenthesised(a2, e27);
    }(e26) && !t2(e26) && n2(e26));
  }
  var a2 = e25.getSourceCode(), o2 = function() {
    var e26 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return { groups: e26.groups && 0 < e26.groups.length ? e26.groups : lI, allowSamePrecedence: e26.allowSamePrecedence !== false };
  }(e25.options[0]);
  return { BinaryExpression: i2, LogicalExpression: i2 };
} }, dI = { meta: { type: "suggestion", docs: { description: "disallow `require` calls to be mixed with regular variable declarations", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-mixed-requires" }, schema: [{ oneOf: [{ type: "boolean" }, { type: "object", properties: { grouping: { type: "boolean" }, allowCall: { type: "boolean" } }, additionalProperties: false }] }] }, create: function(e25) {
  function t2(e26) {
    return e26 ? e26.type === "CallExpression" && e26.callee.type === "Identifier" && e26.callee.name === "require" ? "require" : s2 && e26.type === "CallExpression" && e26.callee.type === "CallExpression" ? t2(e26.callee) : e26.type === "MemberExpression" ? t2(e26.object) : "other" : "uninitialized";
  }
  function r2(e26) {
    var r3 = {};
    return e26.forEach(function(e27) {
      var n3 = t2(e27.init);
      r3[n3] = true;
    }), !(!r3[c2] || !r3[l2] && !r3[p2]);
  }
  function n2(e26) {
    var r3 = {};
    return e26.forEach(function(e27) {
      t2(e27.init) === c2 && (r3[function e28(t3) {
        if (t3.type === "MemberExpression")
          return e28(t3.object);
        if (t3.arguments.length === 0)
          return f2;
        var r4 = t3.arguments[0];
        return r4.type !== "Literal" || typeof r4.value != "string" ? "computed" : u2.indexOf(r4.value) === -1 ? /^\.{0,2}\//.test(r4.value) ? "file" : "module" : "core";
      }(e27.init)] = true);
    }), 1 >= Object.keys(r3).length;
  }
  var a2 = e25.options[0], o2 = false, s2 = false;
  i(a2) == "object" ? (o2 = a2.grouping, s2 = a2.allowCall) : o2 = !!a2;
  var u2 = ["assert", "buffer", "child_process", "cluster", "crypto", "dgram", "dns", "domain", "events", "fs", "http", "https", "net", "os", "path", "punycode", "querystring", "readline", "repl", "smalloc", "stream", "string_decoder", "tls", "tty", "url", "util", "v8", "vm", "zlib"], c2 = "require", l2 = "uninitialized", p2 = "other", f2 = "computed";
  return { VariableDeclaration: function(t3) {
    r2(t3.declarations) ? e25.report({ node: t3, message: "Do not mix 'require' and other declarations." }) : o2 && !n2(t3.declarations) && e25.report({ node: t3, message: "Do not mix core, module, file and computed requires." });
  } };
} }, mI = { meta: { type: "layout", docs: { description: "disallow multiple spaces", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-multi-spaces" }, fixable: "whitespace", schema: [{ type: "object", properties: { exceptions: { type: "object", patternProperties: { "^([A-Z][a-z]*)+$": { type: "boolean" } }, additionalProperties: false }, ignoreEOLComments: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e25) {
  function t2(e26) {
    var t3 = e26.value.split("\n"), r3 = t3[0], n3 = "".concat(r3.slice(0, 12), "...");
    return t3.length === 1 && 12 >= r3.length ? r3 : n3;
  }
  var r2 = e25.getSourceCode(), n2 = e25.options[0] || {}, i2 = n2.ignoreEOLComments, a2 = Object.assign({ Property: true }, n2.exceptions), o2 = 0 < Object.keys(a2).filter(function(e26) {
    return a2[e26];
  }).length;
  return { Program: function() {
    r2.tokensAndComments.forEach(function(n3, s2, u2) {
      if (s2 !== u2.length - 1) {
        var c2 = u2[s2 + 1];
        if (r2.text.slice(n3.range[1], c2.range[0]).includes("  ") && !(n3.loc.end.line < c2.loc.start.line) && !(i2 && LA.isCommentToken(c2) && (s2 === u2.length - 2 || c2.loc.end.line < u2[s2 + 2].loc.start.line))) {
          if (o2) {
            var l2 = r2.getNodeByRangeIndex(c2.range[0] - 1);
            if (l2 && a2[l2.type])
              return;
          }
          var p2;
          p2 = c2.type === "Block" ? "/*".concat(t2(c2), "*/") : c2.type === "Line" ? "//".concat(t2(c2)) : c2.value, e25.report({ node: c2, loc: { start: n3.loc.end, end: c2.loc.start }, message: "Multiple spaces found before '{{displayValue}}'.", data: { displayValue: p2 }, fix: function(e26) {
            return e26.replaceTextRange([n3.range[1], c2.range[0]], " ");
          } });
        }
      }
    });
  } };
} }, gI = { meta: { type: "suggestion", docs: { description: "disallow multiline strings", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-multi-str" }, schema: [] }, create: function(e25) {
  return { Literal: function(t2) {
    LA.LINEBREAK_MATCHER.test(t2.raw) && !function(e26) {
      return e26.type.indexOf("JSX") === 0;
    }(t2.parent) && e25.report({ node: t2, message: "Multiline support is limited to browsers supporting ES5 only." });
  } };
} }, yI = { meta: { type: "layout", docs: { description: "disallow multiple empty lines", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-multiple-empty-lines" }, fixable: "whitespace", schema: [{ type: "object", properties: { max: { type: "integer", minimum: 0 }, maxEOF: { type: "integer", minimum: 0 }, maxBOF: { type: "integer", minimum: 0 } }, required: ["max"], additionalProperties: false }] }, create: function(e25) {
  var t2 = 2, r2 = t2, n2 = t2;
  e25.options.length && (t2 = e25.options[0].max, r2 = e25.options[0].maxEOF === void 0 ? t2 : e25.options[0].maxEOF, n2 = e25.options[0].maxBOF === void 0 ? t2 : e25.options[0].maxBOF);
  var i2 = e25.getSourceCode(), a2 = i2.lines[i2.lines.length - 1] === "" ? i2.lines.slice(0, -1) : i2.lines, o2 = new Set();
  return { TemplateLiteral: function(e26) {
    e26.quasis.forEach(function(e27) {
      for (var t3 = e27.loc.start.line; t3 < e27.loc.end.line; t3++)
        o2.add(t3);
    });
  }, "Program:exit": function(s2) {
    return a2.reduce(function(e26, t3, r3) {
      return (t3.trim() || o2.has(r3 + 1)) && e26.push(r3 + 1), e26;
    }, []).concat(a2.length + 1).reduce(function(o3, u2) {
      var c2, l2;
      return o3 === 0 ? (c2 = "Too many blank lines at the beginning of file. Max of {{max}} allowed.", l2 = n2) : u2 === a2.length + 1 ? (c2 = "Too many blank lines at the end of file. Max of {{max}} allowed.", l2 = r2) : (c2 = "More than {{max}} blank {{pluralizedLines}} not allowed.", l2 = t2), u2 - o3 - 1 > l2 && e25.report({ node: s2, loc: { start: { line: o3 + 1, column: 0 }, end: { line: u2, column: 0 } }, message: c2, data: { max: l2, pluralizedLines: l2 === 1 ? "line" : "lines" }, fix: function(e26) {
        var t3 = i2.getIndexFromLoc({ line: o3 + 1, column: 0 }), r3 = u2 - l2, n3 = r3 <= a2.length ? i2.getIndexFromLoc({ line: r3, column: 0 }) : i2.text.length;
        return e26.removeRange([t3, n3]);
      } }), u2;
    }, 0);
  } };
} }, vI = Fy.require$$0, xI = vI.CALL, bI = vI.ReferenceTracker, EI = ["Atomics", "JSON", "Math", "Reflect"], CI = { meta: { type: "problem", docs: { description: "disallow calling global object properties as functions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-obj-calls" }, schema: [], messages: { unexpectedCall: "'{{name}}' is not a function." } }, create: function(e25) {
  return { Program: function() {
    var t2 = e25.getScope(), r2 = new bI(t2), n2 = {}, i2 = true, a2 = false, o2 = void 0;
    try {
      for (var s2, c2 = EI[Symbol.iterator](); !(i2 = (s2 = c2.next()).done); i2 = true) {
        n2[s2.value] = u({}, xI, true);
      }
    } catch (e26) {
      a2 = true, o2 = e26;
    } finally {
      try {
        i2 || c2.return == null || c2.return();
      } finally {
        if (a2)
          throw o2;
      }
    }
    var l2 = true, p2 = false, f2 = void 0;
    try {
      for (var h2, d2 = r2.iterateGlobalReferences(n2)[Symbol.iterator](); !(l2 = (h2 = d2.next()).done); l2 = true) {
        var m2 = h2.value.node;
        e25.report({ node: m2, messageId: "unexpectedCall", data: { name: m2.callee.name } });
      }
    } catch (e26) {
      p2 = true, f2 = e26;
    } finally {
      try {
        l2 || d2.return == null || d2.return();
      } finally {
        if (p2)
          throw f2;
      }
    }
  } };
} }, SI = /(?:Statement|Declaration|Function(?:Expression)?|Program)$/, kI = { meta: { type: "suggestion", docs: { description: "disallow reassigning `function` parameters", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-param-reassign" }, schema: [{ oneOf: [{ type: "object", properties: { props: { enum: [false] } }, additionalProperties: false }, { type: "object", properties: { props: { enum: [true] }, ignorePropertyModificationsFor: { type: "array", items: { type: "string" }, uniqueItems: true }, ignorePropertyModificationsForRegex: { type: "array", items: { type: "string" }, uniqueItems: true } }, additionalProperties: false }] }] }, create: function(e25) {
  function t2(e26) {
    return o2.includes(e26) || s2.some(function(t3) {
      return new RegExp(t3, "u").test(e26);
    });
  }
  function r2(r3, n3, i3) {
    var o3 = r3.identifier;
    o3 && !r3.init && (n3 === 0 || i3[n3 - 1].identifier !== o3) && (r3.isWrite() ? e25.report({ node: o3, message: "Assignment to function parameter '{{name}}'.", data: { name: o3.name } }) : a2 && function(e26) {
      for (var t3 = e26.identifier, r4 = t3.parent; r4 && (!SI.test(r4.type) || r4.type === "ForInStatement" || r4.type === "ForOfStatement"); ) {
        switch (r4.type) {
          case "AssignmentExpression":
            return r4.left === t3;
          case "UpdateExpression":
            return true;
          case "UnaryExpression":
            if (r4.operator === "delete")
              return true;
            break;
          case "ForInStatement":
          case "ForOfStatement":
            return !(r4.left !== t3);
          case "CallExpression":
            if (r4.callee !== t3)
              return false;
            break;
          case "MemberExpression":
            if (r4.property === t3)
              return false;
            break;
          case "Property":
            if (r4.key === t3)
              return false;
            break;
          case "ConditionalExpression":
            if (r4.test === t3)
              return false;
        }
        r4 = (t3 = r4).parent;
      }
      return false;
    }(r3) && !t2(o3.name) && e25.report({ node: o3, message: "Assignment to property of function parameter '{{name}}'.", data: { name: o3.name } }));
  }
  function n2(e26) {
    e26.defs[0].type === "Parameter" && e26.references.forEach(r2);
  }
  function i2(t3) {
    e25.getDeclaredVariables(t3).forEach(n2);
  }
  var a2 = e25.options[0] && e25.options[0].props, o2 = e25.options[0] && e25.options[0].ignorePropertyModificationsFor || [], s2 = e25.options[0] && e25.options[0].ignorePropertyModificationsForRegex || [];
  return { "FunctionDeclaration:exit": i2, "FunctionExpression:exit": i2, "ArrowFunctionExpression:exit": i2 };
} }, DI = { meta: { type: "suggestion", docs: { description: "disallow the unary operators `++` and `--`", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-plusplus" }, schema: [{ type: "object", properties: { allowForLoopAfterthoughts: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e25) {
  var t2 = e25.options[0], r2 = false;
  return i(t2) == "object" && (r2 = t2.allowForLoopAfterthoughts === true), { UpdateExpression: function(t3) {
    r2 && t3.parent.type === "ForStatement" || e25.report({ node: t3, message: "Unary operator '{{operator}}' used.", data: { operator: t3.operator } });
  } };
} }, FI = { meta: { type: "suggestion", docs: { description: "disallow variable redeclaration", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-redeclare" }, messages: { redeclared: "'{{id}}' is already defined.", redeclaredAsBuiltin: "'{{id}}' is already defined as a built-in global variable.", redeclaredBySyntax: "'{{id}}' is already defined by a variable declaration." }, schema: [{ type: "object", properties: { builtinGlobals: { type: "boolean", default: true } }, additionalProperties: false }] }, create: function(e25) {
  var t2 = regeneratorRuntime.mark(r2);
  function r2(e26) {
    var r3, n3, i3, s2, u2, c2, l2, p2, f2, h2, d2, m2;
    return regeneratorRuntime.wrap(function(t3) {
      for (; ; )
        switch (t3.prev = t3.next) {
          case 0:
            if (t3.t0 = a2.builtinGlobals && (e26.eslintImplicitGlobalSetting === "readonly" || e26.eslintImplicitGlobalSetting === "writable"), !t3.t0) {
              t3.next = 4;
              break;
            }
            return t3.next = 4, { type: "builtin" };
          case 4:
            r3 = true, n3 = false, i3 = void 0, t3.prev = 7, s2 = e26.identifiers[Symbol.iterator]();
          case 9:
            if (r3 = (u2 = s2.next()).done) {
              t3.next = 16;
              break;
            }
            return c2 = u2.value, t3.next = 13, { type: "syntax", node: c2, loc: c2.loc };
          case 13:
            r3 = true, t3.next = 9;
            break;
          case 16:
            t3.next = 22;
            break;
          case 18:
            t3.prev = 18, t3.t1 = t3.catch(7), n3 = true, i3 = t3.t1;
          case 22:
            t3.prev = 22, t3.prev = 23, r3 || s2.return == null || s2.return();
          case 25:
            if (t3.prev = 25, !n3) {
              t3.next = 28;
              break;
            }
            throw i3;
          case 28:
            return t3.finish(25);
          case 29:
            return t3.finish(22);
          case 30:
            if (!e26.eslintExplicitGlobalComments) {
              t3.next = 57;
              break;
            }
            l2 = true, p2 = false, f2 = void 0, t3.prev = 34, h2 = e26.eslintExplicitGlobalComments[Symbol.iterator]();
          case 36:
            if (l2 = (d2 = h2.next()).done) {
              t3.next = 43;
              break;
            }
            return m2 = d2.value, t3.next = 40, { type: "comment", node: m2, loc: LA.getNameLocationInGlobalDirectiveComment(o2, m2, e26.name) };
          case 40:
            l2 = true, t3.next = 36;
            break;
          case 43:
            t3.next = 49;
            break;
          case 45:
            t3.prev = 45, t3.t2 = t3.catch(34), p2 = true, f2 = t3.t2;
          case 49:
            t3.prev = 49, t3.prev = 50, l2 || h2.return == null || h2.return();
          case 52:
            if (t3.prev = 52, !p2) {
              t3.next = 55;
              break;
            }
            throw f2;
          case 55:
            return t3.finish(52);
          case 56:
            return t3.finish(49);
          case 57:
          case "end":
            return t3.stop();
        }
    }, t2, null, [[7, 18, 22, 30], [23, , 25, 29], [34, 45, 49, 57], [50, , 52, 56]]);
  }
  function n2(t3) {
    var n3, i3 = true, a3 = false, o3 = void 0;
    try {
      for (var s2, u2 = t3.variables[Symbol.iterator](); !(i3 = (s2 = u2.next()).done); i3 = true) {
        var c2 = s2.value, l2 = r2(c2), p2 = C(n3 = l2) || S(n3) || k(), f2 = p2[0], h2 = p2.slice(1);
        if (h2.length !== 0) {
          var d2 = f2.type === "builtin" ? "redeclaredAsBuiltin" : "redeclaredBySyntax", m2 = { id: c2.name }, g2 = true, y2 = false, v2 = void 0;
          try {
            for (var x2, b2 = h2[Symbol.iterator](); !(g2 = (x2 = b2.next()).done); g2 = true) {
              var E2 = x2.value, D2 = E2.type, F2 = E2.node, A2 = E2.loc, w2 = D2 === f2.type ? "redeclared" : d2;
              e25.report({ node: F2, loc: A2, messageId: w2, data: m2 });
            }
          } catch (e26) {
            y2 = true, v2 = e26;
          } finally {
            try {
              g2 || b2.return == null || b2.return();
            } finally {
              if (y2)
                throw v2;
            }
          }
        }
      }
    } catch (e26) {
      a3 = true, o3 = e26;
    } finally {
      try {
        i3 || u2.return == null || u2.return();
      } finally {
        if (a3)
          throw o3;
      }
    }
  }
  function i2(t3) {
    var r3 = e25.getScope();
    r3.block === t3 && n2(r3);
  }
  var a2 = { builtinGlobals: !(e25.options.length !== 0 && !e25.options[0].builtinGlobals) }, o2 = e25.getSourceCode();
  return { Program: function() {
    var t3 = e25.getScope();
    n2(t3), t3.type === "global" && t3.childScopes[0] && t3.block === t3.childScopes[0].block && n2(t3.childScopes[0]);
  }, FunctionDeclaration: i2, FunctionExpression: i2, ArrowFunctionExpression: i2, BlockStatement: i2, ForStatement: i2, ForInStatement: i2, ForOfStatement: i2, SwitchStatement: i2 };
} }, AI = new PA.RegExpParser(), wI = / {2}/;
function _I(e25) {
  return e25 && e25.type === "Literal" && typeof e25.value == "string";
}
var TI = { meta: { type: "suggestion", docs: { description: "disallow multiple spaces in regular expressions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-regex-spaces" }, schema: [], fixable: "code" }, create: function(e25) {
  function t2(t3, r3, n2, a2, o2) {
    if (wI.test(n2)) {
      var s2, u2 = [];
      try {
        s2 = AI.parsePattern(r3, 0, r3.length, o2.includes("u"));
      } catch (t4) {
        return;
      }
      PA.visitRegExpAST(s2, { onCharacterClassEnter: function(e26) {
        u2.push(e26);
      } });
      for (var c2, l2 = /( {2,})(?: [\*\+\?\{]|(?:[\0-\),->@-z\|-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|$)/g, p2 = function(i2) {
        var o3 = i2[1].length, s3 = i2.index;
        if (u2.every(function(e26) {
          var t4 = e26.start, r4 = e26.end;
          return s3 < t4 || r4 <= s3;
        }))
          return { v: void e25.report({ node: t3, message: "Spaces are hard to count. Use {{{length}}}.", data: { length: o3 }, fix: function(e26) {
            return r3 === n2 ? e26.replaceTextRange([a2 + s3, a2 + s3 + o3], " {".concat(o3, "}")) : null;
          } }) };
      }; c2 = l2.exec(r3); ) {
        var f2 = p2(c2);
        if (i(f2) === "object")
          return f2.v;
      }
    }
  }
  function r2(r3) {
    var n2 = e25.getScope(), i2 = LA.getVariableByName(n2, "RegExp"), a2 = i2 && 0 < i2.defs.length, o2 = r3.arguments[0], s2 = r3.arguments[1];
    r3.callee.type === "Identifier" && r3.callee.name === "RegExp" && _I(o2) && !a2 && t2(r3, o2.value, o2.raw.slice(1, -1), o2.range[0] + 1, _I(s2) ? s2.value : "");
  }
  return { Literal: function(e26) {
    if (e26.regex) {
      var r3 = e26.regex.pattern, n2 = e26.raw.slice(1, e26.raw.lastIndexOf("/"));
      t2(e26, r3, n2, e26.range[0] + 1, e26.regex.flags);
    }
  }, CallExpression: r2, NewExpression: r2 };
} }, PI = "Unexpected use of '{{name}}'.", II = "Unexpected use of '{{name}}'. {{customMessage}}", BI = { meta: { type: "suggestion", docs: { description: "disallow specified global variables", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-restricted-globals" }, schema: { type: "array", items: { oneOf: [{ type: "string" }, { type: "object", properties: { name: { type: "string" }, message: { type: "string" } }, required: ["name"], additionalProperties: false }] }, uniqueItems: true, minItems: 0 } }, create: function(e25) {
  function t2(t3) {
    var r3 = t3.identifier.name, i2 = n2[r3], a2 = i2 ? II : PI;
    e25.report({ node: t3.identifier, message: a2, data: { name: r3, customMessage: i2 } });
  }
  function r2(e26) {
    return Object.prototype.hasOwnProperty.call(n2, e26);
  }
  if (e25.options.length === 0)
    return {};
  var n2 = e25.options.reduce(function(e26, t3) {
    return typeof t3 == "string" ? e26[t3] = null : e26[t3.name] = t3.message, e26;
  }, {});
  return { Program: function() {
    var n3 = e25.getScope();
    n3.variables.forEach(function(e26) {
      !e26.defs.length && r2(e26.name) && e26.references.forEach(t2);
    }), n3.through.forEach(function(e26) {
      r2(e26.identifier.name) && t2(e26);
    });
  } };
} }, OI = { type: "array", items: { anyOf: [{ type: "string" }, { type: "object", properties: { name: { type: "string" }, message: { type: "string", minLength: 1 }, importNames: { type: "array", items: { type: "string" } } }, additionalProperties: false, required: ["name"] }] }, uniqueItems: true }, LI = { meta: { type: "suggestion", docs: { description: "disallow specified modules when loaded by `import`", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-restricted-imports" }, messages: { path: "'{{importSource}}' import is restricted from being used.", pathWithCustomMessage: "'{{importSource}}' import is restricted from being used. {{customMessage}}", patterns: "'{{importSource}}' import is restricted from being used by a pattern.", everything: "* import is invalid because '{{importNames}}' from '{{importSource}}' is restricted.", everythingWithCustomMessage: "* import is invalid because '{{importNames}}' from '{{importSource}}' is restricted. {{customMessage}}" }, schema: { anyOf: [OI, { type: "array", items: { type: "object", properties: { paths: OI, patterns: { type: "array", items: { type: "string" }, uniqueItems: true } }, additionalProperties: false }, additionalItems: false }] } }, create: function(e25) {
  function t2(t3) {
    var r3 = t3.source.value.trim(), n3 = f2[r3] && f2[r3].message;
    e25.report({ node: t3, messageId: n3 ? "pathWithCustomMessage" : "path", data: { importSource: r3, customMessage: n3 } });
  }
  function r2(t3) {
    var r3 = t3.source.value.trim();
    e25.report({ node: t3, messageId: "patterns", data: { importSource: r3 } });
  }
  function n2(t3, r3) {
    var n3 = f2[t3].importNames, i2 = f2[t3] && f2[t3].message;
    e25.report({ node: r3, messageId: i2 ? "everythingWithCustomMessage" : "everything", data: { importSource: t3, importNames: n3, customMessage: i2 } });
  }
  function a2(e26, t3) {
    return Object.prototype.hasOwnProperty.call(f2, e26) && f2[e26].importNames && function(e27) {
      return e27.has("*");
    }(t3);
  }
  function o2(e26, t3) {
    var r3 = false;
    return Object.prototype.hasOwnProperty.call(f2, e26) && (r3 = !f2[e26].importNames || function(e27, t4) {
      return t4.some(function(t5) {
        return e27.has(t5);
      });
    }(t3, f2[e26].importNames)), r3;
  }
  function s2(e26) {
    var i2 = e26.source.value.trim(), s3 = e26.specifiers ? e26.specifiers.reduce(function(e27, t3) {
      return t3.type === "ImportDefaultSpecifier" ? e27.add("default") : t3.type === "ImportNamespaceSpecifier" ? e27.add("*") : t3.imported ? e27.add(t3.imported.name) : t3.local && e27.add(t3.local.name), e27;
    }, new Set()) : new Set();
    a2(i2, s3) && n2(i2, e26), o2(i2, s3) && t2(e26), function(e27) {
      return 0 < p2.length && h2.ignores(e27);
    }(i2) && r2(e26);
  }
  var u2 = Array.isArray(e25.options) ? e25.options : [], c2 = i(u2[0]) == "object" && (Object.prototype.hasOwnProperty.call(u2[0], "paths") || Object.prototype.hasOwnProperty.call(u2[0], "patterns")), l2 = (c2 ? u2[0].paths : e25.options) || [], p2 = (c2 ? u2[0].patterns : []) || [], f2 = l2.reduce(function(e26, t3) {
    return typeof t3 == "string" ? e26[t3] = { message: null } : e26[t3.name] = { message: t3.message, importNames: t3.importNames }, e26;
  }, {});
  if (Object.keys(l2).length === 0 && p2.length === 0)
    return {};
  var h2 = IA().add(p2);
  return { ImportDeclaration: s2, ExportNamedDeclaration: function(e26) {
    e26.source && s2(e26);
  }, ExportAllDeclaration: s2 };
} }, NI = "'{{moduleName}}' module is restricted from being used.", jI = "'{{moduleName}}' module is restricted from being used. {{customMessage}}", RI = { type: "array", items: { anyOf: [{ type: "string" }, { type: "object", properties: { name: { type: "string" }, message: { type: "string", minLength: 1 } }, additionalProperties: false, required: ["name"] }] }, uniqueItems: true }, MI = { meta: { type: "suggestion", docs: { description: "disallow specified modules when loaded by `require`", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-restricted-modules" }, schema: { anyOf: [RI, { type: "array", items: { type: "object", properties: { paths: RI, patterns: { type: "array", items: { type: "string" }, uniqueItems: true } }, additionalProperties: false }, additionalItems: false }] } }, create: function(e25) {
  var t2 = Array.isArray(e25.options) ? e25.options : [], r2 = i(t2[0]) == "object" && (Object.prototype.hasOwnProperty.call(t2[0], "paths") || Object.prototype.hasOwnProperty.call(t2[0], "patterns")), n2 = (r2 ? t2[0].paths : e25.options) || [], a2 = (r2 ? t2[0].patterns : []) || [], o2 = n2.reduce(function(e26, t3) {
    return typeof t3 == "string" ? e26[t3] = null : e26[t3.name] = t3.message, e26;
  }, {});
  if (Object.keys(n2).length === 0 && a2.length === 0)
    return {};
  var s2 = IA().add(a2);
  return { CallExpression: function(t3) {
    if (function(e26) {
      return e26.callee.type === "Identifier" && e26.callee.name === "require";
    }(t3) && t3.arguments.length && function(e26) {
      return e26 && e26.type === "Literal" && typeof e26.value == "string";
    }(t3.arguments[0])) {
      var r3 = t3.arguments[0].value.trim();
      (function(e26) {
        return Object.prototype.hasOwnProperty.call(o2, e26);
      })(r3) && function(t4) {
        var r4 = t4.arguments[0].value.trim(), n3 = o2[r4], i2 = n3 ? jI : NI;
        e25.report({ node: t4, message: i2, data: { moduleName: r4, customMessage: n3 } });
      }(t3), 0 < a2.length && s2.ignores(r3) && e25.report({ node: t3, message: "'{{moduleName}}' module is restricted from being used by a pattern.", data: { moduleName: r3 } });
    }
  } };
} }, VI = { meta: { type: "suggestion", docs: { description: "disallow certain properties on certain objects", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-restricted-properties" }, schema: { type: "array", items: { anyOf: [{ type: "object", properties: { object: { type: "string" }, property: { type: "string" }, message: { type: "string" } }, additionalProperties: false, required: ["object"] }, { type: "object", properties: { object: { type: "string" }, property: { type: "string" }, message: { type: "string" } }, additionalProperties: false, required: ["property"] }] }, uniqueItems: true } }, create: function(e25) {
  function t2(t3, r3, n3) {
    if (n3 !== null) {
      var s2 = i2.get(r3), u2 = s2 ? s2.get(n3) : a2.get(r3), c2 = o2.get(n3);
      if (u2) {
        var l2 = u2.message ? " ".concat(u2.message) : "";
        e25.report({ node: t3, message: "'{{objectName}}.{{propertyName}}' is restricted from being used.{{message}}", data: { objectName: r3, propertyName: n3, message: l2 } });
      } else if (c2) {
        var p2 = c2.message ? " ".concat(c2.message) : "";
        e25.report({ node: t3, message: "'{{propertyName}}' is restricted from being used.{{message}}", data: { propertyName: n3, message: p2 } });
      }
    }
  }
  function r2(e26) {
    if (e26.right.type === "Identifier") {
      var r3 = e26.right.name;
      e26.left.type === "ObjectPattern" && e26.left.properties.forEach(function(n3) {
        t2(e26.left, r3, LA.getStaticPropertyName(n3));
      });
    }
  }
  var n2 = e25.options;
  if (n2.length === 0)
    return {};
  var i2 = new Map(), a2 = new Map(), o2 = new Map();
  return n2.forEach(function(e26) {
    var t3 = e26.object, r3 = e26.property;
    t3 === void 0 ? o2.set(r3, { message: e26.message }) : r3 === void 0 ? a2.set(t3, { message: e26.message }) : (!i2.has(t3) && i2.set(t3, new Map()), i2.get(t3).set(r3, { message: e26.message }));
  }), { MemberExpression: function(e26) {
    t2(e26, e26.object && e26.object.name, LA.getStaticPropertyName(e26));
  }, VariableDeclarator: function(e26) {
    if (e26.init && e26.init.type === "Identifier") {
      var r3 = e26.init.name;
      e26.id.type === "ObjectPattern" && e26.id.properties.forEach(function(n3) {
        t2(e26.id, r3, LA.getStaticPropertyName(n3));
      });
    }
  }, AssignmentExpression: r2, AssignmentPattern: r2 };
} }, UI = { meta: { type: "suggestion", docs: { description: "disallow specified syntax", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-restricted-syntax" }, schema: { type: "array", items: { oneOf: [{ type: "string" }, { type: "object", properties: { selector: { type: "string" }, message: { type: "string" } }, required: ["selector"], additionalProperties: false }] }, uniqueItems: true, minItems: 0 } }, create: function(e25) {
  return e25.options.reduce(function(t2, r2) {
    var n2 = typeof r2 == "string", i2 = !n2 && !!r2.message, a2 = n2 ? r2 : r2.selector, o2 = i2 ? r2.message : "Using '{{selector}}' is not allowed.";
    return Object.assign(t2, u({}, a2, function(t3) {
      e25.report({ node: t3, message: o2, data: i2 ? {} : { selector: a2 } });
    }));
  }, {});
} }, qI = /^(?:[A-Za-z]+?Statement|ArrowFunctionExpression|FunctionExpression|ClassExpression)$/, WI = { meta: { type: "suggestion", docs: { description: "disallow assignment operators in `return` statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-return-assign" }, schema: [{ enum: ["except-parens", "always"] }] }, create: function(e25) {
  var t2 = (e25.options[0] || "except-parens") !== "except-parens", r2 = e25.getSourceCode();
  return { AssignmentExpression: function(n2) {
    if (t2 || !LA.isParenthesised(r2, n2)) {
      for (var i2 = n2, a2 = i2.parent; a2 && !qI.test(a2.type); )
        i2 = a2, a2 = a2.parent;
      a2 && a2.type === "ReturnStatement" ? e25.report({ node: a2, message: "Return statement should not contain assignment." }) : a2 && a2.type === "ArrowFunctionExpression" && a2.body === i2 && e25.report({ node: a2, message: "Arrow function should not return assignment." });
    }
  } };
} }, $I = "Redundant use of `await` on a return value.", GI = { meta: { type: "suggestion", docs: { description: "disallow unnecessary `return await`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-return-await" }, fixable: null, schema: [] }, create: function(e25) {
  function t2(t3) {
    e25.report({ node: e25.getSourceCode().getFirstToken(t3), loc: t3.loc, message: $I });
  }
  function r2(e26) {
    for (var t3 = e26; !LA.isFunction(t3) && t3.type !== "Program"; ) {
      if (t3.parent.type === "TryStatement" && (t3 === t3.parent.block || t3 === t3.parent.handler && t3.parent.finalizer))
        return true;
      t3 = t3.parent;
    }
    return false;
  }
  return { AwaitExpression: function(e26) {
    (function e27(t3) {
      return !(t3.parent.type !== "ArrowFunctionExpression") || (t3.parent.type === "ReturnStatement" ? !r2(t3.parent) : t3.parent.type !== "ConditionalExpression" || t3 !== t3.parent.consequent && t3 !== t3.parent.alternate ? t3.parent.type === "LogicalExpression" && t3 === t3.parent.right ? e27(t3.parent) : !(t3.parent.type !== "SequenceExpression" || t3 !== t3.parent.expressions[t3.parent.expressions.length - 1]) && e27(t3.parent) : e27(t3.parent));
    })(e26) && !r2(e26) && t2(e26);
  } };
} }, zI = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+/g;
function HI(e25, t2) {
  if (!function(e26, t3) {
    if (e26.property.type === "Identifier" && e26.property.type === t3.property.type && e26.property.name === t3.property.name && e26.computed === t3.computed)
      return true;
    var r3 = LA.getStaticPropertyName(e26), n3 = LA.getStaticPropertyName(t3);
    return r3 !== null && r3 === n3;
  }(e25, t2))
    return false;
  var r2 = e25.object, n2 = t2.object;
  return !(r2.type !== n2.type) && (r2.type === "MemberExpression" ? HI(r2, n2) : !(r2.type !== "ThisExpression") || r2.type === "Identifier" && r2.name === n2.name);
}
var KI = { meta: { type: "problem", docs: { description: "disallow assignments where both sides are exactly the same", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-self-assign" }, schema: [{ type: "object", properties: { props: { type: "boolean", default: true } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3) {
    e25.report({ node: t3, message: "'{{name}}' is assigned to itself.", data: { name: r2.getText(t3).replace(zI, "") } });
  }
  var r2 = e25.getSourceCode(), n2 = b(e25.options, 1)[0], i2 = (n2 = n2 === void 0 ? {} : n2).props, a2 = i2 === void 0 || i2;
  return { AssignmentExpression: function(e26) {
    e26.operator === "=" && function e27(t3, r3, n3, i3) {
      if (t3 && r3)
        if (t3.type === "Identifier" && r3.type === "Identifier" && t3.name === r3.name)
          i3(r3);
        else if (t3.type === "ArrayPattern" && r3.type === "ArrayExpression")
          for (var a3 = Math.min(t3.elements.length, r3.elements.length), o2 = 0; o2 < a3; ++o2) {
            var s2 = t3.elements[o2], u2 = r3.elements[o2];
            if (s2 && s2.type === "RestElement" && o2 < r3.elements.length - 1)
              break;
            if (e27(s2, u2, n3, i3), u2 && u2.type === "SpreadElement")
              break;
          }
        else if (t3.type === "RestElement" && r3.type === "SpreadElement")
          e27(t3.argument, r3.argument, n3, i3);
        else if (t3.type === "ObjectPattern" && r3.type === "ObjectExpression" && 1 <= r3.properties.length) {
          for (var c2 = 0, l2 = r3.properties.length - 1; 0 <= l2; --l2) {
            var p2 = r3.properties[l2].type;
            if (p2 === "SpreadElement" || p2 === "ExperimentalSpreadProperty") {
              c2 = l2 + 1;
              break;
            }
          }
          for (var f2 = 0; f2 < t3.properties.length; ++f2)
            for (var h2 = c2; h2 < r3.properties.length; ++h2)
              e27(t3.properties[f2], r3.properties[h2], n3, i3);
        } else if (t3.type !== "Property" || r3.type !== "Property" || r3.kind !== "init" || r3.method)
          n3 && t3.type === "MemberExpression" && r3.type === "MemberExpression" && HI(t3, r3) && i3(r3);
        else {
          var d2 = LA.getStaticPropertyName(t3);
          d2 !== null && d2 === LA.getStaticPropertyName(r3) && e27(t3.value, r3.value, n3, i3);
        }
    }(e26.left, e26.right, a2, t2);
  } };
} }, JI = { meta: { type: "problem", docs: { description: "disallow comparisons where both sides are exactly the same", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-self-compare" }, schema: [] }, create: function(e25) {
  function t2(e26, t3) {
    var n2 = r2.getTokens(e26), i2 = r2.getTokens(t3);
    return n2.length === i2.length && n2.every(function(e27, t4) {
      return e27.type === i2[t4].type && e27.value === i2[t4].value;
    });
  }
  var r2 = e25.getSourceCode();
  return { BinaryExpression: function(r3) {
    new Set(["===", "==", "!==", "!=", ">", "<", ">=", "<="]).has(r3.operator) && t2(r3.left, r3.right) && e25.report({ node: r3, message: "Comparing to itself is potentially pointless." });
  } };
} }, QI = { meta: { type: "suggestion", docs: { description: "disallow comma operators", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-sequences" }, schema: [] }, create: function(e25) {
  function t2(e26) {
    return e26.parent && i2[e26.parent.type] && e26 === e26.parent[i2[e26.parent.type]];
  }
  function r2(e26) {
    return LA.isParenthesised(n2, e26);
  }
  var n2 = e25.getSourceCode(), i2 = { DoWhileStatement: "test", IfStatement: "test", SwitchStatement: "discriminant", WhileStatement: "test", WithStatement: "object", ArrowFunctionExpression: "body" };
  return { SequenceExpression: function(i3) {
    if (i3.parent.type !== "ForStatement" || i3 !== i3.parent.init && i3 !== i3.parent.update) {
      if (t2(i3)) {
        if (function(e26) {
          var t3 = n2.getTokenBefore(e26, 1), i4 = n2.getTokenAfter(e26, 1);
          return r2(e26) && t3 && i4 && LA.isOpeningParenToken(t3) && t3.range[1] <= e26.range[0] && LA.isClosingParenToken(i4) && i4.range[0] >= e26.range[1];
        }(i3))
          return;
      } else if (r2(i3))
        return;
      var a2 = n2.getTokenAfter(i3.expressions[0], LA.isCommaToken);
      e25.report({ node: i3, loc: a2.loc, message: "Unexpected use of comma operator." });
    }
  } };
} }, XI = Fy.require$$0.findVariable;
function YI(e25, t2, r2, n2, i2) {
  var a2 = e25.parent;
  return a2.type === "CallExpression" && a2.arguments[i2] === e25 && a2.callee.type === "MemberExpression" && LA.getStaticPropertyName(a2.callee) === n2 && a2.callee.object.type === "Identifier" && a2.callee.object.name === r2 && function(e26, t3) {
    var r3 = XI(t3, e26);
    return r3 !== null && r3.scope.type === "global" && r3.defs.length === 0;
  }(a2.callee.object, t2);
}
function ZI(e25, t2) {
  var r2 = e25.parent;
  return !(r2.kind !== "set" || r2.value !== e25) || !(r2.type !== "Property" || r2.value !== e25 || LA.getStaticPropertyName(r2) !== "set" || r2.parent.type !== "ObjectExpression" || !function(e26, t3) {
    if (YI(e26, t3, "Object", "defineProperty", 2) || YI(e26, t3, "Reflect", "defineProperty", 2))
      return true;
    var r3 = e26.parent;
    if (r3.type === "Property" && r3.value === e26) {
      var n2 = r3.parent;
      if (n2.type === "ObjectExpression" && (YI(n2, t3, "Object", "create", 1) || YI(n2, t3, "Object", "defineProperties", 1)))
        return true;
    }
    return false;
  }(r2.parent, t2));
}
var eB = { meta: { type: "problem", docs: { description: "disallow returning values from setters", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-setter-return" }, schema: [], messages: { returnsValue: "Setter cannot return a value." } }, create: function(e25) {
  function t2(t3) {
    var r3 = function(e26) {
      var t4 = e26.upper;
      return t4.type === "function-expression-name" ? t4.upper : t4;
    }(e25.getScope());
    i2 = { upper: i2, isSetter: ZI(t3, r3) };
  }
  function r2() {
    i2 = i2.upper;
  }
  function n2(t3) {
    e25.report({ node: t3, messageId: "returnsValue" });
  }
  var i2 = null;
  return { FunctionDeclaration: t2, FunctionExpression: t2, ArrowFunctionExpression: function(e26) {
    t2(e26), i2.isSetter && e26.expression && n2(e26.body);
  }, "FunctionDeclaration:exit": r2, "FunctionExpression:exit": r2, "ArrowFunctionExpression:exit": r2, ReturnStatement: function(e26) {
    i2 && i2.isSetter && e26.argument && n2(e26);
  } };
} };
function tB(e25) {
  return e25.name === "undefined" && e25.references.every(function(e26) {
    return !e26.isWrite();
  }) && e25.defs.every(function(e26) {
    return e26.node.type === "VariableDeclarator" && e26.node.init === null;
  });
}
var rB = { meta: { type: "suggestion", docs: { description: "disallow identifiers from shadowing restricted names", category: "Variables", recommended: true, url: "https://eslint.org/docs/rules/no-shadow-restricted-names" }, schema: [] }, create: function(e25) {
  var t2 = new Set(["undefined", "NaN", "Infinity", "arguments", "eval"]);
  return { "VariableDeclaration, :function, CatchClause": function(r2) {
    var n2 = true, i2 = false, a2 = void 0;
    try {
      for (var o2, s2 = e25.getDeclaredVariables(r2)[Symbol.iterator](); !(n2 = (o2 = s2.next()).done); n2 = true) {
        var u2 = o2.value;
        0 < u2.defs.length && t2.has(u2.name) && !tB(u2) && e25.report({ node: u2.defs[0].name, message: "Shadowing of global property '{{idName}}'.", data: { idName: u2.name } });
      }
    } catch (e26) {
      i2 = true, a2 = e26;
    } finally {
      try {
        n2 || s2.return == null || s2.return();
      } finally {
        if (i2)
          throw a2;
      }
    }
  } };
} }, nB = { meta: { type: "suggestion", docs: { description: "disallow variable declarations from shadowing variables declared in the outer scope", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-shadow" }, schema: [{ type: "object", properties: { builtinGlobals: { type: "boolean", default: false }, hoist: { enum: ["all", "functions", "never"], default: "functions" }, allow: { type: "array", items: { type: "string" } } }, additionalProperties: false }] }, create: function(e25) {
  function t2(e26) {
    return s2.allow.indexOf(e26.name) !== -1;
  }
  function r2(e26) {
    var t3 = e26.scope.block;
    return t3.type === "ClassDeclaration" && t3.id === e26.identifiers[0];
  }
  function n2(e26, t3) {
    var r3 = t3.scope, n3 = t3.defs[0], i3 = n3 && n3.parent && n3.parent.range, a3 = e26.scope, o3 = e26.defs[0], s3 = o3 && o3.name.range;
    return i3 && s3 && i3[0] < s3[0] && s3[1] < i3[1] && (o3.type === "FunctionName" && o3.node.type === "FunctionExpression" || o3.node.type === "ClassExpression") && r3 === a3.upper;
  }
  function i2(e26) {
    var t3 = e26.defs[0];
    return t3 && t3.name.range;
  }
  function a2(e26, t3) {
    var r3 = t3.defs[0], n3 = i2(e26), a3 = i2(t3);
    return n3 && a3 && n3[1] < a3[0] && (s2.hoist !== "functions" || !r3 || r3.node.type !== "FunctionDeclaration");
  }
  function o2(i3) {
    for (var o3 = i3.variables, u2 = 0; u2 < o3.length; ++u2) {
      var c2 = o3[u2];
      if (c2.identifiers.length !== 0 && !r2(c2) && !t2(c2)) {
        var l2 = LA.getVariableByName(i3.upper, c2.name);
        l2 && (0 < l2.identifiers.length || s2.builtinGlobals && "writeable" in l2) && !n2(c2, l2) && (s2.hoist === "all" || !a2(c2, l2)) && e25.report({ node: c2.identifiers[0], message: "'{{name}}' is already declared in the upper scope.", data: c2 });
      }
    }
  }
  var s2 = { builtinGlobals: e25.options[0] && e25.options[0].builtinGlobals, hoist: e25.options[0] && e25.options[0].hoist || "functions", allow: e25.options[0] && e25.options[0].allow || [] };
  return { "Program:exit": function() {
    for (var t3 = e25.getScope().childScopes.slice(); t3.length; ) {
      var r3 = t3.pop();
      t3.push.apply(t3, E(r3.childScopes)), o2(r3);
    }
  } };
} }, iB = { meta: { type: "suggestion", docs: { description: "disallow synchronous methods", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-sync" }, schema: [{ type: "object", properties: { allowAtRootLevel: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e25) {
  return u({}, e25.options[0] && e25.options[0].allowAtRootLevel ? ":function MemberExpression[property.name=/.*Sync$/]" : "MemberExpression[property.name=/.*Sync$/]", function(t2) {
    e25.report({ node: t2, message: "Unexpected sync method: '{{propertyName}}'.", data: { propertyName: t2.property.name } });
  });
} }, aB = /\t+/g, oB = /(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, sB = { meta: { type: "layout", docs: { description: "disallow all tabs", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-tabs" }, schema: [{ type: "object", properties: { allowIndentationTabs: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e25) {
  var t2 = e25.getSourceCode(), r2 = e25.options && e25.options[0] && e25.options[0].allowIndentationTabs;
  return { Program: function(n2) {
    t2.getLines().forEach(function(t3, i2) {
      for (var a2; (a2 = aB.exec(t3)) !== null; )
        (!r2 || oB.test(t3.slice(0, a2.index))) && e25.report({ node: n2, loc: { start: { line: i2 + 1, column: a2.index }, end: { line: i2 + 1, column: a2.index + a2[0].length } }, message: "Unexpected tab character." });
    });
  } };
} };
var uB = { meta: { type: "problem", docs: { description: "disallow `this`/`super` before calling `super()` in constructors", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/no-this-before-super" }, schema: [] }, create: function(e25) {
  function t2(e26) {
    return !e26.reachable || o2[e26.id].superCalled;
  }
  function r2() {
    return !!(a2 && a2.isConstructor && a2.hasExtends);
  }
  function n2() {
    return r2() && !a2.codePath.currentSegments.every(t2);
  }
  function i2(e26) {
    for (var t3 = a2.codePath.currentSegments, r3 = 0; r3 < t3.length; ++r3) {
      var n3 = t3[r3];
      n3.reachable && o2[n3.id].invalidNodes.push(e26);
    }
  }
  var a2 = null, o2 = Object.create(null);
  return { onCodePathStart: function(e26, t3) {
    if (function(e27) {
      return e27.type === "FunctionExpression" && e27.parent.type === "MethodDefinition" && e27.parent.kind === "constructor";
    }(t3)) {
      var r3 = t3.parent.parent.parent;
      a2 = { upper: a2, isConstructor: true, hasExtends: !(!r3.superClass || LA.isNullOrUndefined(r3.superClass)), codePath: e26 };
    } else
      a2 = { upper: a2, isConstructor: false, hasExtends: false, codePath: e26 };
  }, onCodePathEnd: function(t3) {
    var r3 = a2.hasExtends;
    a2 = a2.upper, r3 && t3.traverseSegments(function(t4, r4) {
      for (var n3 = o2[t4.id], i3 = 0; i3 < n3.invalidNodes.length; ++i3) {
        var a3 = n3.invalidNodes[i3];
        e25.report({ message: "'{{kind}}' is not allowed before 'super()'.", node: a3, data: { kind: a3.type === "Super" ? "super" : "this" } });
      }
      n3.superCalled && r4.skip();
    });
  }, onCodePathSegmentStart: function(e26) {
    r2() && (o2[e26.id] = { superCalled: 0 < e26.prevSegments.length && e26.prevSegments.every(t2), invalidNodes: [] });
  }, onCodePathSegmentLoop: function(e26, n3) {
    r2() && a2.codePath.traverseSegments({ first: n3, last: e26 }, function(e27, r3) {
      var n4 = o2[e27.id];
      n4.superCalled ? (n4.invalidNodes = [], r3.skip()) : 0 < e27.prevSegments.length && e27.prevSegments.every(t2) && (n4.superCalled = true, n4.invalidNodes = []);
    });
  }, ThisExpression: function(e26) {
    n2() && i2(e26);
  }, Super: function(e26) {
    !LA.isCallee(e26) && n2() && i2(e26);
  }, "CallExpression:exit": function(e26) {
    e26.callee.type === "Super" && n2() && function() {
      for (var e27 = a2.codePath.currentSegments, t3 = 0; t3 < e27.length; ++t3) {
        var r3 = e27[t3];
        r3.reachable && (o2[r3.id].superCalled = true);
      }
    }();
  }, "Program:exit": function() {
    o2 = Object.create(null);
  } };
} }, cB = { meta: { type: "suggestion", docs: { description: "disallow throwing literals as exceptions", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-throw-literal" }, schema: [], messages: { object: "Expected an error object to be thrown.", undef: "Do not throw undefined." } }, create: function(e25) {
  return { ThrowStatement: function(t2) {
    LA.couldBeError(t2.argument) ? t2.argument.type === "Identifier" && t2.argument.name === "undefined" && e25.report({ node: t2, messageId: "undef" }) : e25.report({ node: t2, messageId: "object" });
  } };
} }, lB = { meta: { type: "layout", docs: { description: "disallow trailing whitespace at the end of lines", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-trailing-spaces" }, fixable: "whitespace", schema: [{ type: "object", properties: { skipBlankLines: { type: "boolean", default: false }, ignoreComments: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3, r3, n3) {
    e25.report({ node: t3, loc: r3, message: "Trailing spaces not allowed.", fix: function(e26) {
      return e26.removeRange(n3);
    } });
  }
  var r2 = e25.getSourceCode(), n2 = "[ 	\xA0\u2000-\u200B\u3000]", i2 = e25.options[0] || {}, a2 = i2.skipBlankLines || false, o2 = i2.ignoreComments || false;
  return { Program: function(e26) {
    for (var i3 = new RegExp("".concat(n2, "+$"), "u"), s2 = new RegExp("^".concat(n2, "*$"), "u"), u2 = r2.lines, c2 = r2.getText().match(LA.createGlobalLinebreakMatcher()), l2 = function(e27) {
      var t3 = new Set();
      return e27.forEach(function(e28) {
        for (var r3 = e28.type === "Block" ? e28.loc.end.line - 1 : e28.loc.end.line, n3 = e28.loc.start.line; n3 <= r3; n3++)
          t3.add(n3);
      }), t3;
    }(r2.getAllComments()), p2 = 0, f2 = [], h2 = 0, d2 = u2.length; h2 < d2; h2++) {
      var m2 = h2 + 1, g2 = c2 && c2[h2] ? c2[h2].length : 1, y2 = u2[h2].length + g2, v2 = i3.exec(u2[h2]);
      if (v2) {
        var x2 = { start: { line: m2, column: v2.index }, end: { line: m2, column: y2 - g2 } }, b2 = p2 + x2.start.column, E2 = p2 + x2.end.column, C2 = r2.getNodeByRangeIndex(b2);
        if (C2 && C2.type === "TemplateElement" && b2 > C2.parent.range[0] && E2 < C2.parent.range[1]) {
          p2 += y2;
          continue;
        }
        if (a2 && s2.test(u2[h2])) {
          p2 += y2;
          continue;
        }
        f2 = [b2, E2], o2 && l2.has(m2) || t2(e26, x2, f2);
      }
      p2 += y2;
    }
  } };
} }, pB = { meta: { type: "suggestion", docs: { description: "disallow initializing variables to `undefined`", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-undef-init" }, schema: [], fixable: "code" }, create: function(e25) {
  var t2 = e25.getSourceCode();
  return { VariableDeclarator: function(r2) {
    var n2 = t2.getText(r2.id), i2 = r2.init && r2.init.name, a2 = e25.getScope(), o2 = LA.getVariableByName(a2, "undefined"), s2 = o2 && 0 < o2.defs.length, u2 = t2.getLastToken(r2);
    i2 !== "undefined" || r2.parent.kind === "const" || s2 || e25.report({ node: r2, message: "It's not necessary to initialize '{{name}}' to undefined.", data: { name: n2 }, fix: function(e26) {
      return r2.parent.kind === "var" ? null : r2.id.type === "ArrayPattern" || r2.id.type === "ObjectPattern" ? null : t2.commentsExistBetween(r2.id, u2) ? null : e26.removeRange([r2.id.range[1], r2.range[1]]);
    } });
  } };
} };
var fB = { meta: { type: "problem", docs: { description: "disallow the use of undeclared variables unless mentioned in `/*global */` comments", category: "Variables", recommended: true, url: "https://eslint.org/docs/rules/no-undef" }, schema: [{ type: "object", properties: { typeof: { type: "boolean", default: false } }, additionalProperties: false }], messages: { undef: "'{{name}}' is not defined." } }, create: function(e25) {
  var t2 = e25.options[0], r2 = t2 && t2.typeof === true || false;
  return { "Program:exit": function() {
    e25.getScope().through.forEach(function(t3) {
      var n2 = t3.identifier;
      !r2 && function(e26) {
        var t4 = e26.parent;
        return t4.type === "UnaryExpression" && t4.operator === "typeof";
      }(n2) || e25.report({ node: n2, messageId: "undef", data: n2 });
    });
  } };
} }, hB = { meta: { type: "suggestion", docs: { description: "disallow the use of `undefined` as an identifier", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-undefined" }, schema: [] }, create: function(e25) {
  function t2(t3) {
    e25.report({ node: t3, message: "Unexpected use of undefined." });
  }
  function r2(e26) {
    var r3 = e26.set.get("undefined");
    if (r3) {
      var n2 = r3.references, i2 = r3.defs;
      n2.filter(function(e27) {
        return !e27.init;
      }).forEach(function(e27) {
        return t2(e27.identifier);
      }), i2.forEach(function(e27) {
        return t2(e27.name);
      });
    }
  }
  return { "Program:exit": function() {
    for (var t3 = [e25.getScope()]; t3.length; ) {
      var n2 = t3.pop();
      t3.push.apply(t3, E(n2.childScopes)), r2(n2);
    }
  } };
} }, dB = { meta: { type: "problem", docs: { description: "disallow confusing multiline expressions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-unexpected-multiline" }, schema: [], messages: { function: "Unexpected newline between function and ( of function call.", property: "Unexpected newline between object and [ of property access.", taggedTemplate: "Unexpected newline between template tag and template literal.", division: "Unexpected newline between numerator and division operator." } }, create: function(e25) {
  function t2(t3, r3) {
    var i2 = n2.getTokenAfter(t3, LA.isNotClosingParenToken), a2 = n2.getTokenBefore(i2);
    i2.loc.start.line !== a2.loc.end.line && e25.report({ node: t3, loc: i2.loc.start, messageId: r3, data: { char: i2.value } });
  }
  var r2 = /^[gimsuy]+$/, n2 = e25.getSourceCode();
  return { MemberExpression: function(e26) {
    e26.computed && t2(e26.object, "property");
  }, TaggedTemplateExpression: function(t3) {
    t3.tag.loc.end.line === t3.quasi.loc.start.line || e25.report({ node: t3, loc: t3.loc.start, messageId: "taggedTemplate" });
  }, CallExpression: function(e26) {
    e26.arguments.length === 0 || t2(e26.callee, "function");
  }, "BinaryExpression[operator='/'] > BinaryExpression[operator='/'].left": function(e26) {
    var i2 = n2.getTokenAfter(e26, function(e27) {
      return e27.value === "/";
    }), a2 = n2.getTokenAfter(i2);
    a2.type === "Identifier" && r2.test(a2.value) && i2.range[1] === a2.range[0] && t2(e26.left, "division");
  } };
} }, mB = /(?:(?:Call|Class|Function|Member|New|Yield)Expression|Statement|Declaration)$/, gB = /^(?:DoWhile|For|While)Statement$/, yB = /^(?:BinaryExpression|ConditionalExpression)$/, vB = /^(?:ArrowFunction|Class|Function)Expression$/, xB = /^(?:Call|Member|New|TaggedTemplate|Yield)Expression$/;
function bB(e25) {
  if (e25.init) {
    var t2 = e25.resolved && e25.resolved.defs[0];
    if (!t2 || t2.type !== "Variable" || t2.parent.kind !== "var")
      return false;
  }
  return e25.isWrite();
}
function EB(e25) {
  return !e25.modified;
}
function CB(e25) {
  return !(e25.modified || e25.group);
}
function SB(e25, t2) {
  var r2 = e25.range, n2 = t2.identifier.range;
  return r2[0] <= n2[0] && n2[1] <= r2[1];
}
var kB = { WhileStatement: SB, DoWhileStatement: SB, ForStatement: function(e25, t2) {
  return SB(e25, t2) && !(e25.init && SB(e25.init, t2));
} };
function DB(e25) {
  for (var t2 = e25.identifier; t2; ) {
    if (t2.type === "FunctionDeclaration")
      return t2.id ? t2 : null;
    t2 = t2.parent;
  }
  return null;
}
var FB = { meta: { type: "problem", docs: { description: "disallow unmodified loop conditions", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-unmodified-loop-condition" }, schema: [] }, create: function(e25) {
  function t2(t3) {
    var r3 = t3.reference.identifier;
    e25.report({ node: r3, message: "'{{name}}' is not modified in this loop.", data: r3 });
  }
  function r2(e26) {
    e26.every(EB) && e26.forEach(t2);
  }
  function n2(e26) {
    var t3 = false;
    return Fy.Traverser.traverse(e26, { visitorKeys: o2.visitorKeys, enter: function(e27) {
      xB.test(e27.type) ? (t3 = true, this.break()) : vB.test(e27.type) && this.skip();
    } }), t3;
  }
  function i2(e26) {
    if (e26.init)
      return null;
    for (var t3 = null, r3 = e26.identifier, i3 = r3.parent; i3; ) {
      if (mB.test(i3.type)) {
        if (gB.test(i3.type) && i3.test === r3)
          return { reference: e26, group: t3, isInLoop: kB[i3.type].bind(null, i3), modified: false };
        break;
      }
      if (yB.test(i3.type)) {
        if (n2(i3))
          break;
        t3 = i3;
      }
      r3 = i3, i3 = i3.parent;
    }
    return null;
  }
  function a2(e26) {
    var r3 = e26.references.map(i2).filter(Boolean);
    if (r3.length !== 0) {
      !function(e27) {
        for (var t3 = 0; t3 < e27.length; ++t3) {
          var r4 = e27[t3];
          if (r4.group) {
            var n4 = s2.get(r4.group);
            n4 || (n4 = [], s2.set(r4.group, n4)), n4.push(r4);
          }
        }
      }(r3);
      var n3 = e26.references.filter(bB);
      0 < n3.length && function(e27, t3) {
        for (var r4 = 0; r4 < e27.length; ++r4)
          for (var n4 = e27[r4], i3 = 0; !n4.modified && i3 < t3.length; ++i3) {
            var a3 = t3[i3], o3 = void 0, s3 = void 0, u2 = n4.isInLoop(a3) || !!((o3 = DB(a3)) && (s3 = LA.getVariableByName(a3.from.upper, o3.id.name)) && s3.references.some(n4.isInLoop));
            n4.modified = u2;
          }
      }(r3, n3), r3.filter(CB).forEach(t2);
    }
  }
  var o2 = e25.getSourceCode(), s2 = null;
  return { "Program:exit": function() {
    var t3, n3 = [e25.getScope()];
    for (s2 = new Map(); t3 = n3.pop(); )
      n3.push.apply(n3, E(t3.childScopes)), t3.variables.forEach(a2);
    s2.forEach(r2), s2 = null;
  } };
} }, AB = new Set(["==", "===", "!=", "!==", ">", ">=", "<", "<=", "in", "instanceof"]), wB = { "==": "!=", "!=": "==", "===": "!==", "!==": "===" }, _B = LA.getPrecedence({ type: "LogicalExpression", operator: "||" }), TB = { meta: { type: "suggestion", docs: { description: "disallow ternary operators when simpler alternatives exist", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-unneeded-ternary" }, schema: [{ type: "object", properties: { defaultAssignment: { type: "boolean", default: true } }, additionalProperties: false }], fixable: "code" }, create: function(e25) {
  function t2(e26) {
    return e26.type === "Literal" && typeof e26.value == "boolean";
  }
  function r2(e26) {
    if (e26.type === "BinaryExpression" && Object.prototype.hasOwnProperty.call(wB, e26.operator)) {
      var t3 = i2.getFirstTokenBetween(e26.left, e26.right, function(t4) {
        return t4.value === e26.operator;
      }), r3 = i2.getText();
      return r3.slice(e26.range[0], t3.range[0]) + wB[e26.operator] + r3.slice(t3.range[1], e26.range[1]);
    }
    return LA.getPrecedence(e26) < LA.getPrecedence({ type: "UnaryExpression" }) ? "!(".concat(LA.getParenthesisedText(i2, e26), ")") : "!".concat(LA.getParenthesisedText(i2, e26));
  }
  var n2 = (e25.options[0] || {}).defaultAssignment !== false, i2 = e25.getSourceCode();
  return { ConditionalExpression: function(a2) {
    t2(a2.alternate) && t2(a2.consequent) ? e25.report({ node: a2, loc: a2.consequent.loc.start, message: "Unnecessary use of boolean literals in conditional expression.", fix: function(e26) {
      return a2.consequent.value === a2.alternate.value ? a2.test.type === "Identifier" ? e26.replaceText(a2, a2.consequent.value.toString()) : null : a2.alternate.value ? e26.replaceText(a2, r2(a2.test)) : e26.replaceText(a2, function(e27) {
        return e27.type === "BinaryExpression" && AB.has(e27.operator) || e27.type === "UnaryExpression" && e27.operator === "!";
      }(a2.test) ? LA.getParenthesisedText(i2, a2.test) : "!".concat(r2(a2.test)));
    } }) : !n2 && function(e26) {
      return e26.test.type === "Identifier" && e26.consequent.type === "Identifier" && e26.test.name === e26.consequent.name;
    }(a2) && e25.report({ node: a2, loc: a2.consequent.loc.start, message: "Unnecessary use of conditional expression for default assignment.", fix: function(e26) {
      var t3 = LA.getPrecedence(a2.alternate) < _B && !LA.isParenthesised(i2, a2.alternate) ? "(".concat(i2.getText(a2.alternate), ")") : LA.getParenthesisedText(i2, a2.alternate), r3 = LA.getParenthesisedText(i2, a2.test);
      return e26.replaceText(a2, "".concat(r3, " || ").concat(t3));
    } });
  } };
} };
function PB(e25) {
  return !!e25.init;
}
function IB(e25) {
  return !e25.reachable;
}
var BB = function() {
  function e25(t2) {
    a(this, e25), this.sourceCode = t2, this.startNode = null, this.endNode = null;
  }
  return s(e25, [{ key: "contains", value: function(e26) {
    return e26.range[0] >= this.startNode.range[0] && e26.range[1] <= this.endNode.range[1];
  } }, { key: "isConsecutive", value: function(e26) {
    return this.contains(this.sourceCode.getTokenBefore(e26));
  } }, { key: "merge", value: function(e26) {
    this.endNode = e26;
  } }, { key: "reset", value: function(e26) {
    this.startNode = this.endNode = e26;
  } }, { key: "location", get: function() {
    return { start: this.startNode.loc.start, end: this.endNode.loc.end };
  } }, { key: "isEmpty", get: function() {
    return !(this.startNode && this.endNode);
  } }]), e25;
}(), OB = { meta: { type: "problem", docs: { description: "disallow unreachable code after `return`, `throw`, `continue`, and `break` statements", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-unreachable" }, schema: [] }, create: function(e25) {
  function t2(t3) {
    var i2 = null;
    if (t3 && r2.currentSegments.every(IB)) {
      if (n2.isEmpty)
        return void n2.reset(t3);
      if (n2.contains(t3))
        return;
      if (n2.isConsecutive(t3))
        return void n2.merge(t3);
      i2 = t3;
    }
    n2.isEmpty || e25.report({ message: "Unreachable code.", loc: n2.location, node: n2.startNode }), n2.reset(i2);
  }
  var r2 = null, n2 = new BB(e25.getSourceCode());
  return { onCodePathStart: function(e26) {
    r2 = e26;
  }, onCodePathEnd: function() {
    r2 = r2.upper;
  }, BlockStatement: t2, BreakStatement: t2, ClassDeclaration: t2, ContinueStatement: t2, DebuggerStatement: t2, DoWhileStatement: t2, ExpressionStatement: t2, ForInStatement: t2, ForOfStatement: t2, ForStatement: t2, IfStatement: t2, ImportDeclaration: t2, LabeledStatement: t2, ReturnStatement: t2, SwitchStatement: t2, ThrowStatement: t2, TryStatement: t2, VariableDeclaration: function(e26) {
    (e26.kind !== "var" || e26.declarations.some(PB)) && t2(e26);
  }, WhileStatement: t2, WithStatement: t2, ExportNamedDeclaration: t2, ExportDefaultDeclaration: t2, ExportAllDeclaration: t2, "Program:exit": function() {
    t2();
  } };
} }, LB = /^(?:Program|(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression)$/, NB = /^(?:Program|(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|DoWhileStatement|WhileStatement|ForOfStatement|ForInStatement|ForStatement|SwitchStatement)$/, jB = /^(?:Program|(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|DoWhileStatement|WhileStatement|ForOfStatement|ForInStatement|ForStatement)$/, RB = { meta: { type: "problem", docs: { description: "disallow control flow statements in `finally` blocks", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-unsafe-finally" }, schema: [] }, create: function(e25) {
  function t2(e26) {
    return e26.parent.type === "TryStatement" && e26.parent.finalizer === e26;
  }
  function r2(e26, r3) {
    var n3, i2 = false;
    n3 = e26.type !== "BreakStatement" || e26.label ? e26.type === "ContinueStatement" ? jB : LB : NB;
    for (var a2 = e26; a2 && !n3.test(a2.type); a2 = a2.parent)
      if (a2.parent.label && r3 && a2.parent.label.name === r3.name && (i2 = true), t2(a2))
        return !(r3 && i2);
    return false;
  }
  function n2(t3) {
    r2(t3, t3.label) && e25.report({ message: "Unsafe usage of {{nodeType}}.", data: { nodeType: t3.type }, node: t3, line: t3.loc.line, column: t3.loc.column });
  }
  return { ReturnStatement: n2, ThrowStatement: n2, BreakStatement: n2, ContinueStatement: n2 };
} };
var MB = { meta: { type: "problem", docs: { description: "disallow negating the left operand of relational operators", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-unsafe-negation" }, schema: [{ type: "object", properties: { enforceForOrderingRelations: { type: "boolean", default: false } }, additionalProperties: false }], fixable: null, messages: { unexpected: "Unexpected negating the left operand of '{{operator}}' operator." } }, create: function(e25) {
  var t2 = e25.getSourceCode(), r2 = (e25.options[0] || {}).enforceForOrderingRelations === true;
  return { BinaryExpression: function(n2) {
    var i2 = r2 && function(e26) {
      return e26 === "<" || e26 === ">" || e26 === ">=" || e26 === "<=";
    }(n2.operator);
    (function(e26) {
      return e26 === "in" || e26 === "instanceof";
    }(n2.operator) || i2) && function(e26) {
      return e26.type === "UnaryExpression" && e26.operator === "!";
    }(n2.left) && !LA.isParenthesised(t2, n2.left) && e25.report({ node: n2, loc: n2.left.loc, messageId: "unexpected", data: { operator: n2.operator } });
  } };
} }, VB = { meta: { type: "problem", docs: { description: "disallow unused variables", category: "Variables", recommended: true, url: "https://eslint.org/docs/rules/no-unused-vars" }, schema: [{ oneOf: [{ enum: ["all", "local"] }, { type: "object", properties: { vars: { enum: ["all", "local"] }, varsIgnorePattern: { type: "string" }, args: { enum: ["all", "after-used", "none"] }, ignoreRestSiblings: { type: "boolean" }, argsIgnorePattern: { type: "string" }, caughtErrors: { enum: ["all", "none"] }, caughtErrorsIgnorePattern: { type: "string" } } }] }] }, create: function(e25) {
  function t2(e26) {
    var t3, r3, n3 = e26.defs && e26.defs[0] && e26.defs[0].type;
    n3 === "CatchClause" && f2.caughtErrorsIgnorePattern ? (t3 = "args", r3 = f2.caughtErrorsIgnorePattern.toString()) : n3 === "Parameter" && f2.argsIgnorePattern ? (t3 = "args", r3 = f2.argsIgnorePattern.toString()) : n3 !== "Parameter" && f2.varsIgnorePattern && (t3 = "vars", r3 = f2.varsIgnorePattern.toString());
    var i3 = t3 ? " Allowed unused ".concat(t3, " must match ").concat(r3, ".") : "";
    return "'{{name}}' is defined but never used.".concat(i3);
  }
  function r2() {
    var e26 = f2.varsIgnorePattern ? " Allowed unused vars must match ".concat(f2.varsIgnorePattern.toString(), ".") : "";
    return "'{{name}}' is assigned a value but never used.".concat(e26);
  }
  function n2(e26) {
    var t3 = e26.defs[0];
    if (t3) {
      var r3 = t3.node;
      if (r3.type === "VariableDeclarator")
        r3 = r3.parent;
      else if (t3.type === "Parameter")
        return false;
      return r3.parent.type.indexOf("Export") === 0;
    }
    return false;
  }
  function i2(e26) {
    return !!f2.ignoreRestSiblings && e26.defs.some(function(e27) {
      var t3 = e27.name.parent, r3 = t3.parent;
      return t3.type === "Property" && r3.type === "ObjectPattern" && p2.test(r3.properties[r3.properties.length - 1].type);
    });
  }
  function a2(e26, t3) {
    return e26.range[0] >= t3.range[0] && e26.range[1] <= t3.range[1];
  }
  function o2(e26, t3) {
    var r3 = LA.getUpperFunction(e26);
    return r3 && a2(r3, t3) && function(e27, t4) {
      for (var r4 = e27, n3 = e27.parent; n3 && a2(n3, t4); ) {
        switch (n3.type) {
          case "SequenceExpression":
            if (n3.expressions[n3.expressions.length - 1] !== r4)
              return false;
            break;
          case "CallExpression":
          case "NewExpression":
            return n3.callee !== r4;
          case "AssignmentExpression":
          case "TaggedTemplateExpression":
          case "YieldExpression":
            return true;
          default:
            if (d2.test(n3.type))
              return true;
        }
        r4 = n3, n3 = n3.parent;
      }
      return false;
    }(r3, t3);
  }
  function s2(e26) {
    var t3 = function(e27) {
      var t4 = [];
      return e27.defs.forEach(function(e28) {
        var r4 = e28.type, n4 = e28.node;
        r4 === "FunctionName" && t4.push(n4), r4 === "Variable" && n4.init && (n4.init.type === "FunctionExpression" || n4.init.type === "ArrowFunctionExpression") && t4.push(n4.init);
      }), t4;
    }(e26), r3 = 0 < t3.length, n3 = null;
    return e26.references.some(function(e27) {
      if (function(e28) {
        var t4 = e28.identifier.parent;
        return t4.type === "VariableDeclarator" && (t4 = t4.parent.parent), t4.type === "ForInStatement" && (!!(t4 = t4.body.type === "BlockStatement" ? t4.body.body[0] : t4.body) && t4.type === "ReturnStatement");
      }(e27))
        return true;
      var i3 = function(e28, t4) {
        var r4 = e28.identifier, n4 = r4.parent, i4 = n4.parent;
        return e28.isRead() && (n4.type === "AssignmentExpression" && i4.type === "ExpressionStatement" && n4.left === r4 || n4.type === "UpdateExpression" && i4.type === "ExpressionStatement" || t4 && a2(r4, t4) && !o2(r4, t4));
      }(e27, n3);
      return n3 = function(e28, t4) {
        var r4 = e28.identifier, n4 = r4.parent, i4 = n4.parent, o3 = e28.from.variableScope !== e28.resolved.scope.variableScope || LA.isInLoop(r4);
        return t4 && a2(r4, t4) ? t4 : n4.type !== "AssignmentExpression" || i4.type !== "ExpressionStatement" || r4 !== n4.left || o3 ? null : n4.right;
      }(e27, n3), function(e28) {
        return e28.isRead();
      }(e27) && !i3 && !(r3 && function(e28, t4) {
        for (var r4 = e28.from; r4; ) {
          if (0 <= t4.indexOf(r4.block))
            return true;
          r4 = r4.upper;
        }
        return false;
      }(e27, t3));
    });
  }
  function u2(t3) {
    var r3 = t3.defs[0], n3 = e25.getDeclaredVariables(r3.node);
    return !n3.slice(n3.indexOf(t3) + 1).some(function(e26) {
      return 0 < e26.references.length || e26.eslintUsed;
    });
  }
  function c2(e26, t3) {
    var r3, a3, o3 = e26.variables, l3 = e26.childScopes;
    if (e26.type !== "global" || f2.vars === "all")
      for (r3 = 0, a3 = o3.length; r3 < a3; ++r3) {
        var p3 = o3[r3];
        if ((e26.type !== "class" || e26.block.id !== p3.identifiers[0]) && !(e26.functionExpressionScope || p3.eslintUsed || e26.type === "function" && p3.name === "arguments" && p3.identifiers.length === 0)) {
          var h3 = p3.defs[0];
          if (h3) {
            var d3 = h3.type;
            if (d3 === "CatchClause") {
              if (f2.caughtErrors === "none")
                continue;
              if (f2.caughtErrorsIgnorePattern && f2.caughtErrorsIgnorePattern.test(h3.name.name))
                continue;
            }
            if (d3 === "Parameter") {
              if ((h3.node.parent.type === "Property" || h3.node.parent.type === "MethodDefinition") && h3.node.parent.kind === "set")
                continue;
              if (f2.args === "none")
                continue;
              if (f2.argsIgnorePattern && f2.argsIgnorePattern.test(h3.name.name))
                continue;
              if (f2.args === "after-used" && LA.isFunction(h3.name.parent) && !u2(p3))
                continue;
            } else if (f2.varsIgnorePattern && f2.varsIgnorePattern.test(h3.name.name))
              continue;
          }
          s2(p3) || n2(p3) || i2(p3) || t3.push(p3);
        }
      }
    for (r3 = 0, a3 = l3.length; r3 < a3; ++r3)
      c2(l3[r3], t3);
    return t3;
  }
  var l2 = e25.getSourceCode(), p2 = /^(?:RestElement|(?:Experimental)?RestProperty)$/, f2 = { vars: "all", args: "after-used", ignoreRestSiblings: false, caughtErrors: "none" }, h2 = e25.options[0];
  h2 && (typeof h2 == "string" ? f2.vars = h2 : (f2.vars = h2.vars || f2.vars, f2.args = h2.args || f2.args, f2.ignoreRestSiblings = h2.ignoreRestSiblings || f2.ignoreRestSiblings, f2.caughtErrors = h2.caughtErrors || f2.caughtErrors, h2.varsIgnorePattern && (f2.varsIgnorePattern = new RegExp(h2.varsIgnorePattern, "u")), h2.argsIgnorePattern && (f2.argsIgnorePattern = new RegExp(h2.argsIgnorePattern, "u")), h2.caughtErrorsIgnorePattern && (f2.caughtErrorsIgnorePattern = new RegExp(h2.caughtErrorsIgnorePattern, "u"))));
  var d2 = /(?:Statement|Declaration)$/;
  return { "Program:exit": function(n3) {
    for (var i3 = c2(e25.getScope(), []), a3 = 0, o3 = i3.length; a3 < o3; ++a3) {
      var s3 = i3[a3];
      if (0 < s3.defs.length)
        e25.report({ node: s3.identifiers[0], message: s3.references.some(function(e26) {
          return e26.isWrite();
        }) ? r2() : t2(s3), data: s3 });
      else if (s3.eslintExplicitGlobalComments) {
        var u3 = s3.eslintExplicitGlobalComments[0];
        e25.report({ node: n3, loc: LA.getNameLocationInGlobalDirectiveComment(l2, u3, s3.name), message: t2(s3), data: s3 });
      }
    }
  } };
} }, UB = /^(?:(?:Function|Class)(?:Declaration|Expression)|ArrowFunctionExpression|CatchClause|ImportDeclaration|ExportNamedDeclaration)$/, qB = /^For(?:In|Of)Statement$/;
function WB(e25, t2) {
  return e25 && e25.range[0] <= t2 && t2 <= e25.range[1];
}
var $B = { meta: { type: "problem", docs: { description: "disallow the use of variables before they are defined", category: "Variables", recommended: false, url: "https://eslint.org/docs/rules/no-use-before-define" }, schema: [{ oneOf: [{ enum: ["nofunc"] }, { type: "object", properties: { functions: { type: "boolean" }, classes: { type: "boolean" }, variables: { type: "boolean" } }, additionalProperties: false }] }] }, create: function(e25) {
  function t2(e26, t3) {
    return function(e27) {
      return e27.defs[0].type === "FunctionName";
    }(e26) ? n2.functions : function(e27, t4) {
      return e27.defs[0].type === "ClassName" && e27.scope.variableScope !== t4.from.variableScope;
    }(e26, t3) ? n2.classes : !function(e27, t4) {
      return e27.defs[0].type === "Variable" && e27.scope.variableScope !== t4.from.variableScope;
    }(e26, t3) || n2.variables;
  }
  function r2(n3) {
    n3.references.forEach(function(r3) {
      var n4 = r3.resolved;
      !r3.init && n4 && n4.identifiers.length !== 0 && (!(n4.identifiers[0].range[1] < r3.identifier.range[1]) || function(e26, t3) {
        if (e26.scope !== t3.from)
          return false;
        for (var r4 = e26.identifiers[0].parent, n5 = t3.identifier.range[1]; r4; ) {
          if (r4.type === "VariableDeclarator") {
            if (WB(r4.init, n5))
              return true;
            if (qB.test(r4.parent.parent.type) && WB(r4.parent.parent.right, n5))
              return true;
            break;
          }
          if (r4.type === "AssignmentPattern") {
            if (WB(r4.right, n5))
              return true;
          } else if (UB.test(r4.type))
            break;
          r4 = r4.parent;
        }
        return false;
      }(n4, r3)) && t2(n4, r3) && e25.report({ node: r3.identifier, message: "'{{name}}' was used before it was defined.", data: r3.identifier });
    }), n3.childScopes.forEach(r2);
  }
  var n2 = function(e26) {
    var t3 = true, r3 = true, n3 = true;
    return typeof e26 == "string" ? t3 = e26 != "nofunc" : i(e26) == "object" && e26 !== null && (t3 = e26.functions !== false, r3 = e26.classes !== false, n3 = e26.variables !== false), { functions: t3, classes: r3, variables: n3 };
  }(e25.options[0]);
  return { Program: function() {
    r2(e25.getScope());
  } };
} };
var GB = { meta: { type: "suggestion", docs: { description: "disallow unnecessary calls to `.call()` and `.apply()`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-useless-call" }, schema: [] }, create: function(e25) {
  var t2 = e25.getSourceCode();
  return { CallExpression: function(r2) {
    if (function(e26) {
      return e26.callee.type === "MemberExpression" && e26.callee.property.type === "Identifier" && e26.callee.computed === false && (e26.callee.property.name === "call" && 1 <= e26.arguments.length || e26.callee.property.name === "apply" && e26.arguments.length === 2 && e26.arguments[1].type === "ArrayExpression");
    }(r2)) {
      var n2 = r2.callee.object;
      (function(e26, t3, r3) {
        return e26 ? LA.equalTokens(e26, t3, r3) : LA.isNullOrUndefined(t3);
      })(n2.type === "MemberExpression" ? n2.object : null, r2.arguments[0], t2) && e25.report({ node: r2, message: "unnecessary '.{{name}}()'.", data: { name: r2.callee.property.name } });
    }
  } };
} }, zB = "Unnecessarily computed property [{{property}}] found.", HB = { meta: { type: "suggestion", docs: { description: "disallow unnecessary computed property keys in objects and classes", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-useless-computed-key" }, schema: [{ type: "object", properties: { enforceForClassMembers: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "code" }, create: function(e25) {
  function t2(t3) {
    if (t3.computed) {
      var n2, a2 = t3.key, o2 = i(a2.value);
      n2 = t3.type === "MethodDefinition" ? t3.static ? "prototype" : "constructor" : "__proto__", a2.type === "Literal" && (o2 === "string" || o2 === "number") && a2.value !== n2 && e25.report({ node: t3, message: zB, data: { property: r2.getText(a2) }, fix: function(e26) {
        var n3 = r2.getFirstToken(t3, LA.isOpeningBracketToken), i2 = r2.getFirstTokenBetween(t3.key, t3.value, LA.isClosingBracketToken), o3 = r2.getTokensBetween(n3, i2, 1);
        if (o3.slice(0, -1).some(function(e27, t4) {
          return r2.getText().slice(e27.range[1], o3[t4 + 1].range[0]).trim();
        }))
          return null;
        var s2 = r2.getTokenBefore(n3), u2 = (s2.range[1] === n3.range[0] && !LA.canTokensBeAdjacent(s2, r2.getFirstToken(a2)) ? " " : "") + a2.raw;
        return e26.replaceTextRange([n3.range[0], i2.range[1]], u2);
      } });
    }
  }
  var r2 = e25.getSourceCode();
  return { Property: t2, MethodDefinition: e25.options[0] && e25.options[0].enforceForClassMembers ? t2 : Fy.lodash.noop };
} };
function KB(e25) {
  return e25.type === "BinaryExpression" && e25.operator === "+";
}
function JB(e25) {
  return e25.value === "+" && e25.type === "Punctuator";
}
var QB = { meta: { type: "suggestion", docs: { description: "disallow unnecessary concatenation of literals or template literals", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-useless-concat" }, schema: [] }, create: function(e25) {
  var t2 = e25.getSourceCode();
  return { BinaryExpression: function(r2) {
    if (r2.operator === "+") {
      var n2 = function(e26) {
        for (var t3 = e26.left; KB(t3); )
          t3 = t3.right;
        return t3;
      }(r2), i2 = function(e26) {
        for (var t3 = e26.right; KB(t3); )
          t3 = t3.left;
        return t3;
      }(r2);
      if (LA.isStringLiteral(n2) && LA.isStringLiteral(i2) && LA.isTokenOnSameLine(n2, i2)) {
        var a2 = t2.getFirstTokenBetween(n2, i2, JB);
        e25.report({ node: r2, loc: a2.loc.start, message: "Unexpected string concatenation of literals." });
      }
    }
  } };
} };
function XB(e25) {
  return e25.type === "Identifier" || e25.type === "RestElement";
}
function YB(e25, t2) {
  return e25.type === "Identifier" && t2.type === "Identifier" && e25.name === t2.name;
}
function ZB(e25, t2) {
  return YB(e25, t2) || function(e26, t3) {
    return e26.type === "RestElement" && t3.type === "SpreadElement" && YB(e26.argument, t3.argument);
  }(e25, t2);
}
function eO(e25, t2) {
  return function(e26) {
    return e26.length === 1 && e26[0].type === "ExpressionStatement" && e26[0].expression.type === "CallExpression" && e26[0].expression.callee.type === "Super";
  }(e25) && t2.every(XB) && (function(e26) {
    return e26.length === 1 && e26[0].type === "SpreadElement" && e26[0].argument.type === "Identifier" && e26[0].argument.name === "arguments";
  }(e25[0].expression.arguments) || function(e26, t3) {
    if (e26.length !== t3.length)
      return false;
    for (var r2 = 0; r2 < e26.length; ++r2)
      if (!ZB(e26[r2], t3[r2]))
        return false;
    return true;
  }(t2, e25[0].expression.arguments));
}
var tO = { meta: { type: "suggestion", docs: { description: "disallow unnecessary constructors", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-useless-constructor" }, schema: [] }, create: function(e25) {
  return { MethodDefinition: function(t2) {
    if (t2.kind === "constructor") {
      var r2 = t2.value.body.body, n2 = t2.value.params;
      (t2.parent.parent.superClass ? eO(r2, n2) : r2.length === 0) && e25.report({ node: t2, message: "Useless constructor." });
    }
  } };
} };
function rO(e25, t2) {
  return new Set(regeneratorRuntime.mark(function r2() {
    return regeneratorRuntime.wrap(function(r3) {
      for (; ; )
        switch (r3.prev = r3.next) {
          case 0:
            return r3.delegateYield(e25, "t0", 1);
          case 1:
            return r3.delegateYield(t2, "t1", 2);
          case 2:
          case "end":
            return r3.stop();
        }
    }, r2);
  })());
}
var nO = rO(new Set("\\nrvtbfux"), LA.LINEBREAKS), iO = new Set("\\bcdDfnpPrsStvwWxu0123456789]"), aO = rO(iO, new Set("^/.$*+?[{}|()Bk"));
var oO = { meta: { type: "suggestion", docs: { description: "disallow unnecessary escape characters", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-useless-escape", suggestion: true }, messages: { unnecessaryEscape: "Unnecessary escape character: \\{{character}}.", removeEscape: "Remove the `\\`. This maintains the current functionality.", escapeBackslash: "Replace the `\\` with `\\\\` to include the actual backslash character." }, schema: [] }, create: function(e25) {
  function t2(t3, r3, n3) {
    var a2 = i2.getLocFromIndex(i2.getIndexFromLoc(t3.loc.start) + r3), o2 = i2.getIndexFromLoc(t3.loc.start) + r3, s2 = [o2, o2 + 1];
    e25.report({ node: t3, loc: { start: a2, end: { line: a2.line, column: a2.column + 1 } }, messageId: "unnecessaryEscape", data: { character: n3 }, suggest: [{ messageId: "removeEscape", fix: function(e26) {
      return e26.removeRange(s2);
    } }, { messageId: "escapeBackslash", fix: function(e26) {
      return e26.insertTextBeforeRange(s2, "\\");
    } }] });
  }
  function r2(e26, r3) {
    var n3, i3 = e26.type === "TemplateElement", a2 = r3[0][1], o2 = !nO.has(a2);
    i3 ? (n3 = a2 === "`", a2 === "$" ? o2 = r3.input[r3.index + 2] !== "{" : a2 === "{" && (o2 = r3.input[r3.index - 1] !== "$")) : n3 = a2 === e26.raw[0], o2 && !n3 && t2(e26, r3.index + 1, r3[0].slice(1));
  }
  function n2(e26) {
    var n3 = e26.type === "TemplateElement";
    if (!(n3 && e26.parent && e26.parent.parent && e26.parent.parent.type === "TaggedTemplateExpression" && e26.parent === e26.parent.parent.quasi))
      if (typeof e26.value == "string" || n3) {
        if (e26.parent.type === "JSXAttribute" || e26.parent.type === "JSXElement" || e26.parent.type === "JSXFragment")
          return;
        for (var i3, a2 = n3 ? e26.value.raw : e26.raw.slice(1, -1), o2 = /\\(?:[\0-\/:-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g; i3 = o2.exec(a2); )
          r2(e26, i3);
      } else
        e26.regex && function(e27) {
          var t3 = [];
          return e27.split("").reduce(function(e28, r3, n4) {
            if (!e28.escapeNextChar) {
              if (r3 === "\\")
                return Object.assign(e28, { escapeNextChar: true });
              if (r3 === "[" && !e28.inCharClass)
                return Object.assign(e28, { inCharClass: true, startingCharClass: true });
              if (r3 === "]" && e28.inCharClass)
                return t3.length && t3[t3.length - 1].inCharClass && (t3[t3.length - 1].endsCharClass = true), Object.assign(e28, { inCharClass: false, startingCharClass: false });
            }
            return t3.push({ text: r3, index: n4, escaped: e28.escapeNextChar, inCharClass: e28.inCharClass, startsCharClass: e28.startingCharClass, endsCharClass: false }), Object.assign(e28, { escapeNextChar: false, startingCharClass: false });
          }, { escapeNextChar: false, inCharClass: false, startingCharClass: false }), t3;
        }(e26.regex.pattern).filter(function(e27) {
          return e27.text !== "-" || !e27.inCharClass || e27.startsCharClass || e27.endsCharClass;
        }).filter(function(e27) {
          return !(e27.text === "^" && e27.startsCharClass);
        }).filter(function(e27) {
          return e27.escaped;
        }).filter(function(e27) {
          return !(e27.inCharClass ? iO : aO).has(e27.text);
        }).forEach(function(r3) {
          return t2(e26, r3.index, r3.text);
        });
  }
  var i2 = e25.getSourceCode();
  return { Literal: n2, TemplateElement: n2 };
} }, sO = { meta: { type: "suggestion", docs: { description: "disallow renaming import, export, and destructured assignments to the same name", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-useless-rename" }, fixable: "code", schema: [{ type: "object", properties: { ignoreDestructuring: { type: "boolean", default: false }, ignoreImport: { type: "boolean", default: false }, ignoreExport: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3, n3, i3, a3) {
    var o3 = n3.type === "Identifier" ? n3.name : n3.value;
    return e25.report({ node: t3, message: "{{type}} {{name}} unnecessarily renamed.", data: { name: o3, type: a3 }, fix: function(e26) {
      if (r2.commentsExistBetween(n3, i3))
        return null;
      var t4 = i3.type === "AssignmentPattern" ? r2.getText(i3) : o3;
      return e26.replaceTextRange([n3.range[0], i3.range[1]], t4);
    } });
  }
  var r2 = e25.getSourceCode(), n2 = e25.options[0] || {}, i2 = n2.ignoreDestructuring === true, a2 = n2.ignoreImport === true, o2 = n2.ignoreExport === true;
  return { ObjectPattern: function(e26) {
    if (!i2) {
      var r3 = true, n3 = false, a3 = void 0;
      try {
        for (var o3, s2 = e26.properties[Symbol.iterator](); !(r3 = (o3 = s2.next()).done); r3 = true) {
          var u2 = o3.value;
          if (u2.type !== "ExperimentalRestProperty") {
            if (!u2.shorthand && u2.type !== "RestElement" && !u2.computed)
              (u2.key.type === "Identifier" && u2.key.name || u2.key.type === "Literal" && u2.key.value) === (u2.value.type === "AssignmentPattern" ? u2.value.left.name : u2.value.name) && t2(u2, u2.key, u2.value, "Destructuring assignment");
          }
        }
      } catch (e27) {
        n3 = true, a3 = e27;
      } finally {
        try {
          r3 || s2.return == null || s2.return();
        } finally {
          if (n3)
            throw a3;
        }
      }
    }
  }, ImportSpecifier: function(e26) {
    a2 || e26.imported.name === e26.local.name && e26.imported.range[0] !== e26.local.range[0] && t2(e26, e26.imported, e26.local, "Import");
  }, ExportSpecifier: function(e26) {
    o2 || e26.local.name === e26.exported.name && e26.local.range[0] !== e26.exported.range[0] && t2(e26, e26.local, e26.exported, "Export");
  } };
} };
function uO(e25, t2) {
  var r2 = e25.indexOf(t2);
  r2 !== -1 && e25.splice(r2, 1);
}
var cO = { meta: { type: "suggestion", docs: { description: "disallow redundant return statements", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-useless-return" }, fixable: "code", schema: [] }, create: function(e25) {
  function t2(e26) {
    var t3 = a2.get(e26);
    return !t3 || t3.returned;
  }
  function r2(e26, n3, i3) {
    var o3 = i3 || new WeakSet(), s3 = true, u3 = false, c2 = void 0;
    try {
      for (var l2, p2 = n3[Symbol.iterator](); !(s3 = (l2 = p2.next()).done); s3 = true) {
        var f2 = l2.value;
        f2.reachable ? e26.push.apply(e26, E(a2.get(f2).uselessReturns)) : o3.has(f2) || (o3.add(f2), r2(e26, f2.allPrevSegments.filter(t2), o3));
      }
    } catch (e27) {
      u3 = true, c2 = e27;
    } finally {
      try {
        s3 || p2.return == null || p2.return();
      } finally {
        if (u3)
          throw c2;
      }
    }
    return e26;
  }
  function n2(e26) {
    if (!e26.reachable)
      return o2.add(e26), void e26.allPrevSegments.filter(t2).filter(function(e27) {
        return !o2.has(e27);
      }).forEach(n2);
    var r3 = a2.get(e26), i3 = true, s3 = false, c2 = void 0;
    try {
      for (var l2, p2 = r3.uselessReturns[Symbol.iterator](); !(i3 = (l2 = p2.next()).done); i3 = true) {
        var f2 = l2.value;
        uO(u2.uselessReturns, f2);
      }
    } catch (e27) {
      s3 = true, c2 = e27;
    } finally {
      try {
        i3 || p2.return == null || p2.return();
      } finally {
        if (s3)
          throw c2;
      }
    }
    r3.uselessReturns = [];
  }
  function i2() {
    u2.codePath.currentSegments.forEach(n2);
  }
  var a2 = new WeakMap(), o2 = new WeakSet(), s2 = e25.getSourceCode(), u2 = null;
  return { onCodePathStart: function(e26) {
    u2 = { upper: u2, uselessReturns: [], codePath: e26 };
  }, onCodePathEnd: function() {
    var t3 = true, r3 = false, n3 = void 0;
    try {
      for (var i3, a3 = function() {
        var t4 = i3.value;
        e25.report({ node: t4, loc: t4.loc, message: "Unnecessary return statement.", fix: function(e26) {
          return function(e27) {
            return LA.STATEMENT_LIST_PARENTS.has(e27.parent.type);
          }(t4) && !s2.getCommentsInside(t4).length ? new RT(e26, s2).retainEnclosingFunction(t4).remove(t4) : null;
        } });
      }, o3 = u2.uselessReturns[Symbol.iterator](); !(t3 = (i3 = o3.next()).done); t3 = true)
        a3();
    } catch (e26) {
      r3 = true, n3 = e26;
    } finally {
      try {
        t3 || o3.return == null || o3.return();
      } finally {
        if (r3)
          throw n3;
      }
    }
    u2 = u2.upper;
  }, onCodePathSegmentStart: function(e26) {
    var t3 = { uselessReturns: r2([], e26.allPrevSegments), returned: false };
    a2.set(e26, t3);
  }, ReturnStatement: function(e26) {
    if (e26.argument && i2(), !(e26.argument || LA.isInLoop(e26) || function(e27) {
      for (var t4 = e27; t4 && t4.parent && !LA.isFunction(t4); t4 = t4.parent)
        if (t4.parent.type === "TryStatement" && t4.parent.finalizer === t4)
          return true;
      return false;
    }(e26)) && u2.codePath.currentSegments.some(function(e27) {
      return e27.reachable;
    })) {
      var t3 = true, r3 = false, n3 = void 0;
      try {
        for (var o3, s3 = u2.codePath.currentSegments[Symbol.iterator](); !(t3 = (o3 = s3.next()).done); t3 = true) {
          var c2 = o3.value, l2 = a2.get(c2);
          l2 && (l2.uselessReturns.push(e26), l2.returned = true);
        }
      } catch (e27) {
        r3 = true, n3 = e27;
      } finally {
        try {
          t3 || s3.return == null || s3.return();
        } finally {
          if (r3)
            throw n3;
        }
      }
      u2.uselessReturns.push(e26);
    }
  }, ClassDeclaration: i2, ContinueStatement: i2, DebuggerStatement: i2, DoWhileStatement: i2, EmptyStatement: i2, ExpressionStatement: i2, ForInStatement: i2, ForOfStatement: i2, ForStatement: i2, IfStatement: i2, ImportDeclaration: i2, LabeledStatement: i2, SwitchStatement: i2, ThrowStatement: i2, TryStatement: i2, VariableDeclaration: i2, WhileStatement: i2, WithStatement: i2, ExportNamedDeclaration: i2, ExportDefaultDeclaration: i2, ExportAllDeclaration: i2 };
} };
function lO(e25) {
  return !!e25.scope && e25.scope.type === "global";
}
function pO(e25) {
  for (var t2 = e25; t2.type !== "function" && t2.type !== "global"; )
    t2 = t2.upper;
  return t2;
}
function fO(e25) {
  var t2 = pO(e25.scope);
  return e25.references.some(function(e26) {
    return pO(e26.from) !== t2;
  });
}
function hO(e25) {
  return (e25.parent.type === "ForOfStatement" || e25.parent.type === "ForInStatement") && e25 === e25.parent.left;
}
var dO = /^(?:Program|BlockStatement|SwitchStatement|ForStatement|ForInStatement|ForOfStatement)$/;
function mO(e25) {
  return 2 <= e25.defs.length;
}
function gO(e25) {
  return e25.name === "let";
}
var yO = { meta: { type: "suggestion", docs: { description: "require `let` or `const` instead of `var`", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/no-var" }, schema: [], fixable: "code" }, create: function(e25) {
  function t2(t3) {
    return !!t3.init && e25.getDeclaredVariables(t3).some(function(e26) {
      var t4 = e26.range[0], r3 = e26.range[1];
      return function(e27) {
        var n3 = e27.defs[0].name, i3 = n3.range[0], a2 = n3.parent.type === "AssignmentPattern" ? n3.parent.right : null, o2 = a2 && a2.range[0], s2 = a2 && a2.range[1];
        return e27.references.some(function(e28) {
          var n4 = e28.identifier.range[0], u2 = e28.identifier.range[1];
          return !e28.init && (n4 < i3 || a2 !== null && n4 >= o2 && u2 <= s2 || n4 >= t4 && u2 <= r3);
        });
      };
    }(t3.init));
  }
  function r2(r3) {
    var n3 = e25.getDeclaredVariables(r3), i3 = function(e26) {
      for (var t3 = e26; t3; t3 = t3.parent)
        if (dO.test(t3.type))
          return t3;
      return null;
    }(r3);
    if (r3.parent.type === "SwitchCase" || r3.declarations.some(t2) || n3.some(lO) || n3.some(mO) || n3.some(function(e26) {
      function t3(t4) {
        var r4 = e26.range, n4 = t4.identifier.range;
        return n4[0] < r4[0] || n4[1] > r4[1];
      }
      return function(e27) {
        return e27.references.some(t3);
      };
    }(i3)) || n3.some(gO))
      return false;
    if (LA.isInLoop(r3)) {
      if (n3.some(fO))
        return false;
      if (!hO(r3) && !function(e26) {
        return e26.declarations.every(function(e27) {
          return e27.init !== null;
        });
      }(r3))
        return false;
    }
    return !!(hO(r3) || r3.parent.type === "ForStatement" && r3.parent.init === r3 || LA.STATEMENT_LIST_PARENTS.has(r3.parent.type));
  }
  function n2(t3) {
    e25.report({ node: t3, message: "Unexpected var, use let or const instead.", fix: function(e26) {
      var n3 = i2.getFirstToken(t3, { filter: function(e27) {
        return e27.value === "var";
      } });
      return r2(t3) ? e26.replaceText(n3, "let") : null;
    } });
  }
  var i2 = e25.getSourceCode();
  return { "VariableDeclaration:exit": function(e26) {
    e26.kind === "var" && n2(e26);
  } };
} }, vO = Fy.lodash.escapeRegExp, xO = { meta: { type: "suggestion", docs: { description: "disallow specified warning terms in comments", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-warning-comments" }, schema: [{ type: "object", properties: { terms: { type: "array", items: { type: "string" } }, location: { enum: ["start", "anywhere"] } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3) {
    LA.isDirectiveComment(t3) && o2.test(t3.value) || function(e26) {
      var t4 = [];
      return s2.forEach(function(r3, n3) {
        r3.test(e26) && t4.push(i2[n3]);
      }), t4;
    }(t3.value).forEach(function(r3) {
      e25.report({ node: t3, message: "Unexpected '{{matchedTerm}}' comment.", data: { matchedTerm: r3 } });
    });
  }
  var r2 = e25.getSourceCode(), n2 = e25.options[0] || {}, i2 = n2.terms || ["todo", "fixme", "xxx"], a2 = n2.location || "start", o2 = /\bno\x2Dwarning\x2Dcomments\b/, s2 = i2.map(function(e26) {
    var t3, r3 = vO(e26), n3 = "\\b", i3 = /[0-9A-Z_a-z]$/.test(e26) ? "\\b" : "";
    return t3 = a2 === "start" ? "^\\s*" : /^[0-9A-Z_a-z]/.test(e26) ? n3 : "", a2 === "start" ? new RegExp(t3 + r3 + i3, "iu") : new RegExp(t3 + r3 + i3 + "|".concat(n3) + e26 + n3, "iu");
  });
  return { Program: function() {
    r2.getAllComments().filter(function(e26) {
      return e26.type !== "Shebang";
    }).forEach(t2);
  } };
} }, bO = { meta: { type: "layout", docs: { description: "disallow whitespace before properties", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-whitespace-before-property" }, fixable: "whitespace", schema: [] }, create: function(e25) {
  function t2(t3, n2, i2) {
    var a2 = t3.computed ? "" : ".";
    e25.report({ node: t3, message: "Unexpected whitespace before property {{propName}}.", data: { propName: r2.getText(t3.property) }, fix: function(e26) {
      return !t3.computed && LA.isDecimalInteger(t3.object) ? null : e26.replaceTextRange([n2.range[1], i2.range[0]], a2);
    } });
  }
  var r2 = e25.getSourceCode();
  return { MemberExpression: function(e26) {
    var n2, i2;
    LA.isTokenOnSameLine(e26.object, e26.property) && (e26.computed ? (n2 = r2.getTokenBefore(e26.property, LA.isOpeningBracketToken), i2 = r2.getTokenBefore(n2)) : (n2 = r2.getFirstToken(e26.property), i2 = r2.getTokenBefore(n2, 1)), r2.isSpaceBetweenTokens(i2, n2) && t2(e26, i2, n2));
  } };
} }, EO = { enum: ["beside", "below", "any"] }, CO = { meta: { type: "layout", docs: { description: "enforce the location of single-line statements", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/nonblock-statement-body-position" }, fixable: "whitespace", schema: [EO, { properties: { overrides: { properties: { if: EO, else: EO, while: EO, do: EO, for: EO }, additionalProperties: false } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3, n2) {
    var i2 = function(t4) {
      return e25.options[1] && e25.options[1].overrides && e25.options[1].overrides[t4] || e25.options[0] || "beside";
    }(n2);
    if (t3.type !== "BlockStatement" && i2 !== "any") {
      var a2 = r2.getTokenBefore(t3);
      a2.loc.end.line === t3.loc.start.line && i2 === "below" ? e25.report({ node: t3, message: "Expected a linebreak before this statement.", fix: function(e26) {
        return e26.insertTextBefore(t3, "\n");
      } }) : a2.loc.end.line !== t3.loc.start.line && i2 === "beside" && e25.report({ node: t3, message: "Expected no linebreak before this statement.", fix: function(e26) {
        return r2.getText().slice(a2.range[1], t3.range[0]).trim() ? null : e26.replaceTextRange([a2.range[1], t3.range[0]], " ");
      } });
    }
  }
  var r2 = e25.getSourceCode();
  return { IfStatement: function(e26) {
    t2(e26.consequent, "if"), e26.alternate && e26.alternate.type !== "IfStatement" && t2(e26.alternate, "else");
  }, WhileStatement: function(e26) {
    return t2(e26.body, "while");
  }, DoWhileStatement: function(e26) {
    return t2(e26.body, "do");
  }, ForStatement: function(e26) {
    return t2(e26.body, "for");
  }, ForInStatement: function(e26) {
    return t2(e26.body, "for");
  }, ForOfStatement: function(e26) {
    return t2(e26.body, "for");
  } };
} }, SO = { oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { multiline: { type: "boolean" }, minProperties: { type: "integer", minimum: 0 }, consistent: { type: "boolean" } }, additionalProperties: false, minProperties: 1 }] };
function kO(e25) {
  var t2 = Number.POSITIVE_INFINITY, r2 = false, n2 = t2, i2 = false;
  return e25 ? e25 === "always" ? n2 = 0 : e25 === "never" ? n2 = t2 : (r2 = !!e25.multiline, n2 = e25.minProperties || t2, i2 = !!e25.consistent) : i2 = true, { multiline: r2, minProperties: n2, consistent: i2 };
}
var DO = { meta: { type: "layout", docs: { description: "enforce consistent line breaks inside braces", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/object-curly-newline" }, fixable: "whitespace", schema: [{ oneOf: [SO, { type: "object", properties: { ObjectExpression: SO, ObjectPattern: SO, ImportDeclaration: SO, ExportDeclaration: SO }, additionalProperties: false, minProperties: 1 }] }] }, create: function(e25) {
  function t2(t3) {
    var i2 = n2[t3.type];
    if ((t3.type !== "ImportDeclaration" || t3.specifiers.some(function(e26) {
      return e26.type === "ImportSpecifier";
    })) && (t3.type !== "ExportNamedDeclaration" || t3.specifiers.some(function(e26) {
      return e26.type === "ExportSpecifier";
    }))) {
      var a2 = r2.getFirstToken(t3, function(e26) {
        return e26.value === "{";
      }), o2 = t3.typeAnnotation ? r2.getTokenBefore(t3.typeAnnotation) : r2.getLastToken(t3, function(e26) {
        return e26.value === "}";
      }), s2 = r2.getTokenAfter(a2, { includeComments: true }), u2 = r2.getTokenBefore(o2, { includeComments: true }), c2 = function(e26, t4, r3, n3) {
        var i3;
        return (i3 = e26.type === "ObjectExpression" || e26.type === "ObjectPattern" ? e26.properties : e26.specifiers.filter(function(e27) {
          return e27.type === "ImportSpecifier" || e27.type === "ExportSpecifier";
        })).length >= t4.minProperties || t4.multiline && 0 < i3.length && r3.loc.start.line !== n3.loc.end.line;
      }(t3, i2, s2, u2), l2 = LA.isCommentToken(s2), p2 = LA.isCommentToken(u2);
      if (s2 = r2.getTokenAfter(a2), u2 = r2.getTokenBefore(o2), c2)
        LA.isTokenOnSameLine(a2, s2) && e25.report({ message: "Expected a line break after this opening brace.", node: t3, loc: a2.loc.start, fix: function(e26) {
          return l2 ? null : e26.insertTextAfter(a2, "\n");
        } }), LA.isTokenOnSameLine(u2, o2) && e25.report({ message: "Expected a line break before this closing brace.", node: t3, loc: o2.loc.start, fix: function(e26) {
          return p2 ? null : e26.insertTextBefore(o2, "\n");
        } });
      else {
        var f2 = i2.consistent, h2 = !LA.isTokenOnSameLine(a2, s2), d2 = !LA.isTokenOnSameLine(u2, o2);
        (!f2 && h2 || f2 && h2 && !d2) && e25.report({ message: "Unexpected line break after this opening brace.", node: t3, loc: a2.loc.start, fix: function(e26) {
          return l2 ? null : e26.removeRange([a2.range[1], s2.range[0]]);
        } }), (!f2 && d2 || f2 && !h2 && d2) && e25.report({ message: "Unexpected line break before this closing brace.", node: t3, loc: o2.loc.start, fix: function(e26) {
          return p2 ? null : e26.removeRange([u2.range[1], o2.range[0]]);
        } });
      }
    }
  }
  var r2 = e25.getSourceCode(), n2 = function(e26) {
    var t3 = Fy.lodash.overSome([Fy.lodash.isPlainObject, Fy.lodash.isString]);
    if (Fy.lodash.isPlainObject(e26) && Fy.lodash.some(e26, t3))
      return { ObjectExpression: kO(e26.ObjectExpression), ObjectPattern: kO(e26.ObjectPattern), ImportDeclaration: kO(e26.ImportDeclaration), ExportNamedDeclaration: kO(e26.ExportDeclaration) };
    var r3 = kO(e26);
    return { ObjectExpression: r3, ObjectPattern: r3, ImportDeclaration: r3, ExportNamedDeclaration: r3 };
  }(e25.options[0]);
  return { ObjectExpression: t2, ObjectPattern: t2, ImportDeclaration: t2, ExportNamedDeclaration: t2 };
} }, FO = { meta: { type: "layout", docs: { description: "enforce consistent spacing inside braces", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/object-curly-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { arraysInObjects: { type: "boolean" }, objectsInObjects: { type: "boolean" } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3) {
    return !!e25.options[1] && e25.options[1][t3] === !u2;
  }
  function r2(t3, r3) {
    var n3 = e25.getSourceCode().getTokenAfter(r3, { includeComments: true });
    e25.report({ node: t3, loc: { start: r3.loc.end, end: n3.loc.start }, message: "There should be no space after '{{token}}'.", data: { token: r3.value }, fix: function(e26) {
      return e26.removeRange([r3.range[1], n3.range[0]]);
    } });
  }
  function n2(t3, r3) {
    var n3 = e25.getSourceCode().getTokenBefore(r3, { includeComments: true });
    e25.report({ node: t3, loc: { start: n3.loc.end, end: r3.loc.start }, message: "There should be no space before '{{token}}'.", data: { token: r3.value }, fix: function(e26) {
      return e26.removeRange([n3.range[1], r3.range[0]]);
    } });
  }
  function i2(t3, r3) {
    e25.report({ node: t3, loc: r3.loc, message: "A space is required after '{{token}}'.", data: { token: r3.value }, fix: function(e26) {
      return e26.insertTextAfter(r3, " ");
    } });
  }
  function a2(t3, r3) {
    e25.report({ node: t3, loc: r3.loc, message: "A space is required before '{{token}}'.", data: { token: r3.value }, fix: function(e26) {
      return e26.insertTextBefore(r3, " ");
    } });
  }
  function o2(e26, t3, o3, s3, u3) {
    if (LA.isTokenOnSameLine(t3, o3)) {
      var p2 = c2.isSpaceBetweenTokens(t3, o3);
      l2.spaced && !p2 && i2(e26, t3), !l2.spaced && p2 && o3.type !== "Line" && r2(e26, t3);
    }
    if (LA.isTokenOnSameLine(s3, u3)) {
      var f2 = (l2.arraysInObjectsException && LA.isClosingBracketToken(s3) || l2.objectsInObjectsException && LA.isClosingBraceToken(s3)) && c2.getNodeByRangeIndex(s3.range[0]).type, h2 = l2.arraysInObjectsException && f2 === "ArrayExpression" || l2.objectsInObjectsException && (f2 === "ObjectExpression" || f2 === "ObjectPattern") ? !l2.spaced : l2.spaced, d2 = c2.isSpaceBetweenTokens(s3, u3);
      h2 && !d2 && a2(e26, u3), !h2 && d2 && n2(e26, u3);
    }
  }
  function s2(e26) {
    if (e26.properties.length !== 0) {
      var t3 = c2.getFirstToken(e26), r3 = function(e27) {
        var t4 = e27.properties[e27.properties.length - 1];
        return c2.getTokenAfter(t4, LA.isClosingBraceToken);
      }(e26);
      o2(e26, t3, c2.getTokenAfter(t3, { includeComments: true }), c2.getTokenBefore(r3, { includeComments: true }), r3);
    }
  }
  var u2 = e25.options[0] === "always", c2 = e25.getSourceCode(), l2 = { spaced: u2, arraysInObjectsException: t2("arraysInObjects"), objectsInObjectsException: t2("objectsInObjects") };
  return { ObjectPattern: s2, ObjectExpression: s2, ImportDeclaration: function(e26) {
    if (e26.specifiers.length !== 0) {
      var t3 = e26.specifiers[0], r3 = e26.specifiers[e26.specifiers.length - 1];
      if (r3.type === "ImportSpecifier") {
        t3.type !== "ImportSpecifier" && (t3 = e26.specifiers[1]);
        var n3 = c2.getTokenBefore(t3), i3 = c2.getTokenAfter(r3, LA.isNotCommaToken);
        o2(e26, n3, c2.getTokenAfter(n3, { includeComments: true }), c2.getTokenBefore(i3, { includeComments: true }), i3);
      }
    }
  }, ExportNamedDeclaration: function(e26) {
    if (e26.specifiers.length !== 0) {
      var t3 = e26.specifiers[0], r3 = e26.specifiers[e26.specifiers.length - 1], n3 = c2.getTokenBefore(t3), i3 = c2.getTokenAfter(r3, LA.isNotCommaToken);
      o2(e26, n3, c2.getTokenAfter(n3, { includeComments: true }), c2.getTokenBefore(i3, { includeComments: true }), i3);
    }
  } };
} }, AO = "always", wO = "never", _O = "methods", TO = "properties", PO = "consistent", IO = "consistent-as-needed", BO = { meta: { type: "suggestion", docs: { description: "require or disallow method and property shorthand syntax for object literals", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/object-shorthand" }, fixable: "code", schema: { anyOf: [{ type: "array", items: [{ enum: ["always", "methods", "properties", "never", "consistent", "consistent-as-needed"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["always", "methods", "properties"] }, { type: "object", properties: { avoidQuotes: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }, { type: "array", items: [{ enum: ["always", "methods"] }, { type: "object", properties: { ignoreConstructors: { type: "boolean" }, avoidQuotes: { type: "boolean" }, avoidExplicitReturnArrows: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] } }, create: function(e25) {
  function t2(e26) {
    return e26.kind !== "set" && e26.kind !== "get" && e26.type !== "SpreadElement" && e26.type !== "SpreadProperty" && e26.type !== "ExperimentalSpreadProperty";
  }
  function r2(e26) {
    return e26.type === "Literal" && typeof e26.value == "string";
  }
  function n2(e26) {
    return e26.shorthand || e26.method;
  }
  function i2(e26) {
    var t3 = e26.value;
    return t3.type === "FunctionExpression" ? !t3.id : !(t3.type !== "Identifier") && LA.getStaticPropertyName(e26) === t3.name;
  }
  function a2(r3, a3) {
    var o3 = r3.properties.filter(t2);
    if (0 < o3.length) {
      var s3 = o3.filter(n2);
      if (s3.length !== o3.length) {
        if (0 < s3.length)
          e25.report({ node: r3, message: "Unexpected mix of shorthand and non-shorthand properties." });
        else if (a3) {
          o3.every(i2) && e25.report({ node: r3, message: "Expected shorthand for all properties." });
        }
      }
    }
  }
  function o2() {
    E2.unshift(new Set()), e25.getScope().variables.filter(function(e26) {
      return e26.name === "arguments";
    }).forEach(function(e26) {
      e26.references.map(function(e27) {
        return e27.identifier;
      }).forEach(function(e27) {
        return S2.add(e27);
      });
    });
  }
  function s2() {
    E2.shift();
  }
  function u2() {
    E2[0].forEach(function(e26) {
      return C2.add(e26);
    });
  }
  var c2 = e25.options[0] || AO, l2 = c2 === _O || c2 === AO, p2 = c2 === TO || c2 === AO, f2 = c2 === wO, h2 = c2 === PO, d2 = c2 === IO, m2 = e25.options[1] || {}, g2 = m2.ignoreConstructors, y2 = m2.avoidQuotes, v2 = !!m2.avoidExplicitReturnArrows, x2 = e25.getSourceCode(), b2 = /(?:[\0-#%-\/:-\^`-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, E2 = [], C2 = new WeakSet(), S2 = new WeakSet();
  return { Program: o2, FunctionDeclaration: o2, FunctionExpression: o2, "Program:exit": s2, "FunctionDeclaration:exit": s2, "FunctionExpression:exit": s2, ArrowFunctionExpression: function(e26) {
    E2[0].add(e26);
  }, "ArrowFunctionExpression:exit": function(e26) {
    E2[0].delete(e26);
  }, ThisExpression: u2, Super: u2, MetaProperty: function(e26) {
    e26.meta.name === "new" && e26.property.name === "target" && u2();
  }, Identifier: function(e26) {
    S2.has(e26) && u2();
  }, ObjectExpression: function(e26) {
    h2 ? a2(e26, false) : d2 && a2(e26, true);
  }, "Property:exit": function(t3) {
    var n3 = t3.method || t3.shorthand;
    if (t3.parent.type !== "ObjectPattern" && t3.kind !== "get" && t3.kind !== "set" && (!t3.computed || t3.value.type === "FunctionExpression" || t3.value.type === "ArrowFunctionExpression"))
      if (n3)
        if (t3.method && (f2 || y2 && r2(t3.key))) {
          var i3 = f2 ? "Expected longform method syntax." : "Expected longform method syntax for string literal keys.";
          e25.report({ node: t3, message: i3, fix: function(e26) {
            return function(e27, t4) {
              var r3 = t4.computed ? x2.getTokens(t4).find(function(e28) {
                return e28.value === "[";
              }) : x2.getFirstToken(t4.key), n4 = t4.computed ? x2.getTokensBetween(t4.key, t4.value).find(function(e28) {
                return e28.value === "]";
              }) : x2.getLastToken(t4.key), i4 = x2.text.slice(r3.range[0], n4.range[1]), a3 = "function";
              return t4.value.async && (a3 = "async ".concat(a3)), t4.value.generator && (a3 = "".concat(a3, "*")), e27.replaceTextRange([t4.range[0], n4.range[1]], "".concat(i4, ": ").concat(a3));
            }(e26, t3);
          } });
        } else
          f2 && e25.report({ node: t3, message: "Expected longform property syntax.", fix: function(e26) {
            return e26.insertTextAfter(t3.key, ": ".concat(t3.key.name));
          } });
      else if (!l2 || t3.value.id || t3.value.type !== "FunctionExpression" && t3.value.type !== "ArrowFunctionExpression") {
        if (t3.value.type === "Identifier" && t3.key.name === t3.value.name && p2)
          e25.report({ node: t3, message: "Expected property shorthand.", fix: function(e26) {
            return e26.replaceText(t3, t3.value.name);
          } });
        else if (t3.value.type === "Identifier" && t3.key.type === "Literal" && t3.key.value === t3.value.name && p2) {
          if (y2)
            return;
          e25.report({ node: t3, message: "Expected property shorthand.", fix: function(e26) {
            return e26.replaceText(t3, t3.value.name);
          } });
        }
      } else {
        if (g2 && t3.key.type === "Identifier" && function(e26) {
          var t4 = b2.exec(e26);
          if (!t4)
            return false;
          var r3 = e26.charAt(t4.index);
          return r3 === r3.toUpperCase();
        }(t3.key.name))
          return;
        if (y2 && r2(t3.key))
          return;
        (t3.value.type === "FunctionExpression" || t3.value.type === "ArrowFunctionExpression" && t3.value.body.type === "BlockStatement" && v2 && !C2.has(t3.value)) && e25.report({ node: t3, message: "Expected method shorthand.", fix: function(e26) {
          return function(e27, t4) {
            var r3 = t4.computed ? x2.getFirstToken(t4, LA.isOpeningBracketToken) : x2.getFirstToken(t4.key), n4 = t4.computed ? x2.getFirstTokenBetween(t4.key, t4.value, LA.isClosingBracketToken) : x2.getLastToken(t4.key), i4 = x2.text.slice(r3.range[0], n4.range[1]), a3 = "";
            if (x2.commentsExistBetween(n4, t4.value))
              return null;
            t4.value.async && (a3 += "async "), t4.value.generator && (a3 += "*");
            var o3 = [r3.range[0], t4.range[1]], s3 = a3 + i4;
            if (t4.value.type === "FunctionExpression") {
              var u3 = x2.getTokens(t4.value).find(function(e28) {
                return e28.type === "Keyword" && e28.value === "function";
              }), c3 = t4.value.generator ? x2.getTokenAfter(u3) : u3;
              return e27.replaceTextRange(o3, s3 + x2.text.slice(c3.range[1], t4.value.range[1]));
            }
            var l3, p3 = x2.getTokenBefore(t4.value.body, LA.isArrowToken), f3 = x2.text.slice(p3.range[1], t4.value.range[1]), h3 = false;
            if (l3 = t4.value.params.length === 0 ? x2.getFirstToken(t4.value, LA.isOpeningParenToken) : x2.getTokenBefore(t4.value.params[0]), t4.value.params.length === 1) {
              var d3 = LA.isOpeningParenToken(l3), m3 = l3.range[0] < t4.range[0];
              h3 = !d3 || m3;
            }
            var g3 = h3 ? t4.value.params[0].range[0] : l3.range[0], y3 = x2.getTokenBefore(p3).range[1], v3 = x2.text.slice(g3, y3), b3 = h3 ? "(".concat(v3, ")") : v3;
            return e27.replaceTextRange(o3, s3 + b3 + f3);
          }(e26, t3);
        } });
      }
  } };
} }, OO = { meta: { type: "suggestion", docs: { description: "enforce variables to be declared either together or separately in functions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/one-var" }, fixable: "code", schema: [{ oneOf: [{ enum: ["always", "never", "consecutive"] }, { type: "object", properties: { separateRequires: { type: "boolean" }, var: { enum: ["always", "never", "consecutive"] }, let: { enum: ["always", "never", "consecutive"] }, const: { enum: ["always", "never", "consecutive"] } }, additionalProperties: false }, { type: "object", properties: { initialized: { enum: ["always", "never", "consecutive"] }, uninitialized: { enum: ["always", "never", "consecutive"] } }, additionalProperties: false }] }] }, create: function(e25) {
  function t2() {
    v2.push({ let: { initialized: false, uninitialized: false }, const: { initialized: false, uninitialized: false } });
  }
  function r2() {
    y2.push({ initialized: false, uninitialized: false }), t2();
  }
  function n2() {
    v2.pop();
  }
  function a2() {
    y2.pop(), n2();
  }
  function o2(e26) {
    return e26.init && e26.init.type === "CallExpression" && e26.init.callee.name === "require";
  }
  function s2(e26) {
    for (var t3 = { uninitialized: 0, initialized: 0 }, r3 = 0; r3 < e26.length; r3++)
      e26[r3].init === null ? t3.uninitialized++ : t3.initialized++;
    return t3;
  }
  function u2(e26, t3) {
    var r3 = s2(t3), n3 = m2[e26] || {}, i2 = function(e27) {
      var t4;
      return e27 === "var" ? t4 = y2[y2.length - 1] : e27 === "let" ? t4 = v2[v2.length - 1].let : e27 == "const" && (t4 = v2[v2.length - 1].const), t4;
    }(e26), a3 = t3.some(o2);
    return !(n3.uninitialized === p2 && n3.initialized === p2 && (i2.uninitialized || i2.initialized) && !a3 || 0 < r3.uninitialized && n3.uninitialized === p2 && i2.uninitialized || 0 < r3.initialized && n3.initialized === p2 && i2.initialized && !a3 || i2.required && a3 || (function(e27, t4, r4) {
      for (var n4 = 0; n4 < t4.length; n4++)
        t4[n4].init === null ? m2[e27] && m2[e27].uninitialized === p2 && (r4.uninitialized = true) : m2[e27] && m2[e27].initialized === p2 && (m2.separateRequires && o2(t4[n4]) ? r4.required = true : r4.initialized = true);
    }(e26, t3, i2), 0));
  }
  function c2(e26) {
    var t3 = e26[0], r3 = Array.isArray(t3.parent.parent.body) ? t3.parent.parent.body : [], n3 = r3.findIndex(function(e27) {
      return e27.range[0] === t3.parent.range[0];
    }), i2 = r3[n3 - 1];
    return function(e27) {
      var r4 = g2.getTokenBefore(t3), n4 = g2.getTokenBefore(r4), a3 = [];
      return i2 && i2.kind === g2.getText(r4) && (n4.value === ";" ? a3.push(e27.replaceText(n4, ",")) : a3.push(e27.insertTextAfter(n4, ",")), a3.push(e27.replaceText(r4, ""))), a3;
    };
  }
  function l2(e26) {
    return function(t3) {
      return e26.declarations.map(function(r3) {
        var n3 = g2.getTokenAfter(r3);
        if (n3 === null)
          return null;
        var i2 = g2.getTokenAfter(n3, { includeComments: true });
        if (n3.value !== ",")
          return null;
        if (i2.range[0] === n3.range[1])
          return t3.replaceText(n3, "; ".concat(e26.kind, " "));
        if (i2.loc.start.line > n3.loc.end.line || i2.type === "Line" || i2.type === "Block") {
          for (var a3 = i2; a3.type === "Line" || a3.type === "Block"; )
            a3 = g2.getTokenAfter(a3, { includeComments: true });
          return t3.replaceTextRange([n3.range[0], a3.range[0]], ";".concat(g2.text.slice(n3.range[1], a3.range[0])).concat(e26.kind, " "));
        }
        return t3.replaceText(n3, "; ".concat(e26.kind));
      }).filter(function(e27) {
        return e27;
      });
    };
  }
  var p2 = "always", f2 = "never", h2 = "consecutive", d2 = e25.options[0] || "always", m2 = {};
  typeof d2 == "string" ? (m2.var = { uninitialized: d2, initialized: d2 }, m2.let = { uninitialized: d2, initialized: d2 }, m2.const = { uninitialized: d2, initialized: d2 }) : i(d2) == "object" && (m2.separateRequires = !!d2.separateRequires, m2.var = { uninitialized: d2.var, initialized: d2.var }, m2.let = { uninitialized: d2.let, initialized: d2.let }, m2.const = { uninitialized: d2.const, initialized: d2.const }, Object.prototype.hasOwnProperty.call(d2, "uninitialized") && (m2.var.uninitialized = d2.uninitialized, m2.let.uninitialized = d2.uninitialized, m2.const.uninitialized = d2.uninitialized), Object.prototype.hasOwnProperty.call(d2, "initialized") && (m2.var.initialized = d2.initialized, m2.let.initialized = d2.initialized, m2.const.initialized = d2.initialized));
  var g2 = e25.getSourceCode(), y2 = [], v2 = [];
  return { Program: r2, FunctionDeclaration: r2, FunctionExpression: r2, ArrowFunctionExpression: r2, BlockStatement: t2, ForStatement: t2, ForInStatement: t2, ForOfStatement: t2, SwitchStatement: t2, VariableDeclaration: function(t3) {
    var r3 = t3.parent, n3 = t3.kind;
    if (m2[n3]) {
      var i2 = t3.declarations, a3 = s2(i2), d3 = i2.some(o2) && !i2.every(o2);
      m2[n3].initialized === p2 && m2.separateRequires && d3 && e25.report({ node: t3, message: "Split requires to be separated into a single block." });
      var g3 = r3.body && 0 < r3.body.length && r3.body.indexOf(t3) || 0;
      if (0 < g3) {
        var y3 = r3.body[g3 - 1], v3 = y3.type === "VariableDeclaration", x2 = i2.concat(y3.declarations || []);
        if (v3 && y3.kind === n3 && (!x2.some(o2) || x2.every(o2))) {
          var b2 = s2(y3.declarations);
          m2[n3].initialized === h2 && m2[n3].uninitialized === h2 ? e25.report({ node: t3, message: "Combine this with the previous '{{type}}' statement.", data: { type: n3 }, fix: c2(i2) }) : m2[n3].initialized === h2 && 0 < a3.initialized && 0 < b2.initialized ? e25.report({ node: t3, message: "Combine this with the previous '{{type}}' statement with initialized variables.", data: { type: n3 }, fix: c2(i2) }) : m2[n3].uninitialized === h2 && 0 < a3.uninitialized && 0 < b2.uninitialized && e25.report({ node: t3, message: "Combine this with the previous '{{type}}' statement with uninitialized variables.", data: { type: n3 }, fix: c2(i2) });
        }
      }
      if (!u2(n3, i2)) {
        if (m2[n3].initialized === p2 && m2[n3].uninitialized === p2)
          e25.report({ node: t3, message: "Combine this with the previous '{{type}}' statement.", data: { type: n3 }, fix: c2(i2) });
        else if (m2[n3].initialized === p2 && 0 < a3.initialized && e25.report({ node: t3, message: "Combine this with the previous '{{type}}' statement with initialized variables.", data: { type: n3 }, fix: c2(i2) }), m2[n3].uninitialized === p2 && 0 < a3.uninitialized) {
          if (t3.parent.left === t3 && (t3.parent.type === "ForInStatement" || t3.parent.type === "ForOfStatement"))
            return;
          e25.report({ node: t3, message: "Combine this with the previous '{{type}}' statement with uninitialized variables.", data: { type: n3 }, fix: c2(i2) });
        }
      }
      if (r3.type !== "ForStatement" || r3.init !== t3)
        1 < a3.uninitialized + a3.initialized && (m2[n3].initialized === f2 && m2[n3].uninitialized === f2 ? e25.report({ node: t3, message: "Split '{{type}}' declarations into multiple statements.", data: { type: n3 }, fix: l2(t3) }) : m2[n3].initialized === f2 && 0 < a3.initialized ? e25.report({ node: t3, message: "Split initialized '{{type}}' declarations into multiple statements.", data: { type: n3 }, fix: l2(t3) }) : m2[n3].uninitialized === f2 && 0 < a3.uninitialized && e25.report({ node: t3, message: "Split uninitialized '{{type}}' declarations into multiple statements.", data: { type: n3 }, fix: l2(t3) }));
    }
  }, "ForStatement:exit": n2, "ForOfStatement:exit": n2, "ForInStatement:exit": n2, "SwitchStatement:exit": n2, "BlockStatement:exit": n2, "Program:exit": a2, "FunctionDeclaration:exit": a2, "FunctionExpression:exit": a2, "ArrowFunctionExpression:exit": a2 };
} };
function LO(e25) {
  return 0 <= ["*", "&", "^", "|"].indexOf(e25);
}
function NO(e25, t2) {
  if (e25.type !== t2.type)
    return false;
  switch (e25.type) {
    case "Identifier":
      return e25.name === t2.name;
    case "Literal":
      return e25.value === t2.value;
    case "MemberExpression":
      return NO(e25.object, t2.object) && NO(e25.property, t2.property);
    case "ThisExpression":
      return true;
    default:
      return false;
  }
}
function jO(e25) {
  return e25.type === "Identifier" || e25.type === "MemberExpression" && (e25.object.type === "Identifier" || e25.object.type === "ThisExpression") && (!e25.computed || e25.property.type === "Literal");
}
var RO = { meta: { type: "suggestion", docs: { description: "require or disallow assignment operator shorthand where possible", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/operator-assignment" }, schema: [{ enum: ["always", "never"] }], fixable: "code", messages: { replaced: "Assignment can be replaced with operator assignment.", unexpected: "Unexpected operator assignment shorthand." } }, create: function(e25) {
  function t2(e26) {
    return r2.getFirstTokenBetween(e26.left, e26.right, function(t3) {
      return t3.value === e26.operator;
    });
  }
  var r2 = e25.getSourceCode();
  return { AssignmentExpression: e25.options[0] === "never" ? function(n2) {
    n2.operator !== "=" && e25.report({ node: n2, messageId: "unexpected", fix: function(e26) {
      if (jO(n2.left)) {
        var i2, a2 = r2.getFirstToken(n2), o2 = t2(n2), s2 = r2.getText().slice(n2.range[0], o2.range[0]), u2 = n2.operator.slice(0, -1);
        if (r2.commentsExistBetween(a2, o2))
          return null;
        if (LA.getPrecedence(n2.right) <= LA.getPrecedence({ type: "BinaryExpression", operator: u2 }) && !LA.isParenthesised(r2, n2.right))
          i2 = "".concat(r2.text.slice(o2.range[1], n2.right.range[0]), "(").concat(r2.getText(n2.right), ")");
        else {
          var c2 = r2.getFirstToken(n2.right), l2 = "";
          o2.range[1] !== c2.range[0] || LA.canTokensBeAdjacent(u2, c2) || (l2 = " "), i2 = "".concat(l2).concat(r2.text.slice(o2.range[1], n2.range[1]));
        }
        return e26.replaceText(n2, "".concat(s2, "= ").concat(s2).concat(u2).concat(i2));
      }
      return null;
    } });
  } : function(n2) {
    if (n2.operator === "=" && n2.right.type === "BinaryExpression") {
      var i2 = n2.left, a2 = n2.right, o2 = a2.operator;
      (LO(o2) || function(e26) {
        return 0 <= ["+", "-", "/", "%", "<<", ">>", ">>>", "**"].indexOf(e26);
      }(o2)) && (NO(i2, a2.left) ? e25.report({ node: n2, messageId: "replaced", fix: function(e26) {
        if (jO(i2)) {
          var o3 = t2(n2), s2 = t2(a2), u2 = r2.getText().slice(n2.range[0], o3.range[0]), c2 = r2.getText().slice(s2.range[1], n2.right.range[1]);
          return r2.commentsExistBetween(o3, s2) ? null : e26.replaceText(n2, "".concat(u2).concat(a2.operator, "=").concat(c2));
        }
        return null;
      } }) : NO(i2, a2.right) && LO(o2) && e25.report({ node: n2, messageId: "replaced" }));
    }
  } };
} }, MO = { meta: { type: "layout", docs: { description: "enforce consistent linebreak style for operators", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/operator-linebreak" }, schema: [{ enum: ["after", "before", "none", null] }, { type: "object", properties: { overrides: { type: "object", properties: { anyOf: { type: "string", enum: ["after", "before", "none", "ignore"] } } } }, additionalProperties: false }], fixable: "code" }, create: function(e25) {
  function t2(t3, r3) {
    var n3 = s2.getTokenAfter(r3, LA.isNotClosingParenToken), a3 = s2.getTokenBefore(n3), u2 = s2.getTokenAfter(n3), c2 = n3.value, l2 = o2[c2], p2 = l2 || i2, f2 = function(e26, t4) {
      return function(r4) {
        var n4, i3, a4 = s2.getTokenBefore(e26), o3 = s2.getTokenAfter(e26), u3 = s2.text.slice(a4.range[1], e26.range[0]), c3 = s2.text.slice(e26.range[1], o3.range[0]);
        if (!LA.isTokenOnSameLine(a4, e26) !== !LA.isTokenOnSameLine(e26, o3) && t4 !== "none") {
          if (s2.getTokenBefore(e26, { includeComments: true }) !== a4 && s2.getTokenAfter(e26, { includeComments: true }) !== o3)
            return null;
          n4 = c3, i3 = u3;
        } else {
          var l3 = LA.createGlobalLinebreakMatcher();
          if (n4 = t4 === "before" || u3.trim() ? u3 : u3.replace(l3, ""), i3 = t4 === "after" || c3.trim() ? c3 : c3.replace(l3, ""), n4 === u3 && i3 === c3)
            return null;
        }
        return i3 === "" && o3.type === "Punctuator" && "+-".includes(e26.value) && o3.value === e26.value && (i3 += " "), r4.replaceTextRange([a4.range[1], o3.range[0]], n4 + e26.value + i3);
      };
    }(n3, p2);
    LA.isTokenOnSameLine(a3, n3) && LA.isTokenOnSameLine(n3, u2) || (l2 === "ignore" || LA.isTokenOnSameLine(a3, n3) || LA.isTokenOnSameLine(n3, u2) ? p2 === "before" && LA.isTokenOnSameLine(a3, n3) ? e25.report({ node: t3, loc: { line: n3.loc.end.line, column: n3.loc.end.column }, message: "'{{operator}}' should be placed at the beginning of the line.", data: { operator: c2 }, fix: f2 }) : p2 === "after" && LA.isTokenOnSameLine(n3, u2) ? e25.report({ node: t3, loc: { line: n3.loc.end.line, column: n3.loc.end.column }, message: "'{{operator}}' should be placed at the end of the line.", data: { operator: c2 }, fix: f2 }) : p2 === "none" && e25.report({ node: t3, loc: { line: n3.loc.end.line, column: n3.loc.end.column }, message: "There should be no line break before or after '{{operator}}'.", data: { operator: c2 }, fix: f2 }) : e25.report({ node: t3, loc: { line: n3.loc.end.line, column: n3.loc.end.column }, message: "Bad line breaking before and after '{{operator}}'.", data: { operator: c2 }, fix: f2 }));
  }
  function r2(e26) {
    t2(e26, e26.left);
  }
  var n2 = !e25.options[0], i2 = e25.options[0] || "after", a2 = e25.options[1] || {}, o2 = a2.overrides ? Object.assign({}, a2.overrides) : {};
  n2 && !o2["?"] && (o2["?"] = "before"), n2 && !o2[":"] && (o2[":"] = "before");
  var s2 = e25.getSourceCode();
  return { BinaryExpression: r2, LogicalExpression: r2, AssignmentExpression: r2, VariableDeclarator: function(e26) {
    e26.init && t2(e26, e26.id);
  }, ConditionalExpression: function(e26) {
    t2(e26, e26.test), t2(e26, e26.consequent);
  } };
} }, VO = { meta: { type: "layout", docs: { description: "require or disallow padding within blocks", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/padded-blocks" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { blocks: { enum: ["always", "never"] }, switches: { enum: ["always", "never"] }, classes: { enum: ["always", "never"] } }, additionalProperties: false, minProperties: 1 }] }, { type: "object", properties: { allowSingleLineBlocks: { type: "boolean" } } }] }, create: function(e25) {
  function t2(e26) {
    return e26.type === "Line" || e26.type === "Block";
  }
  function r2(e26, t3) {
    return 2 <= t3.loc.start.line - e26.loc.end.line;
  }
  function n2(e26) {
    var r3, n3 = e26;
    do {
      r3 = n3, n3 = f2.getTokenAfter(n3, { includeComments: true });
    } while (t2(n3) && n3.loc.start.line === r3.loc.end.line);
    return n3;
  }
  function i2(e26) {
    var r3, n3 = e26;
    do {
      r3 = n3, n3 = f2.getTokenBefore(n3, { includeComments: true });
    } while (t2(n3) && n3.loc.end.line === r3.loc.start.line);
    return n3;
  }
  function a2(t3) {
    var a3 = n2(function(e26) {
      return e26.type === "SwitchStatement" ? f2.getTokenBefore(e26.cases[0]) : f2.getFirstToken(e26);
    }(t3)), s3 = f2.getTokenBefore(a3, { includeComments: true }), u3 = i2(f2.getLastToken(t3)), c3 = f2.getTokenAfter(u3, { includeComments: true }), h3 = r2(s3, a3), d2 = r2(u3, c3);
    o2.allowSingleLineBlocks && LA.isTokenOnSameLine(s3, c3) || (function(e26) {
      switch (e26.type) {
        case "BlockStatement":
          return o2.blocks;
        case "SwitchStatement":
          return o2.switches;
        case "ClassBody":
          return o2.classes;
        default:
          throw new Error("unreachable");
      }
    }(t3) ? (!h3 && e25.report({ node: t3, loc: { line: s3.loc.start.line, column: s3.loc.start.column }, fix: function(e26) {
      return e26.insertTextAfter(s3, "\n");
    }, message: l2 }), !d2 && e25.report({ node: t3, loc: { line: c3.loc.end.line, column: c3.loc.end.column - 1 }, fix: function(e26) {
      return e26.insertTextBefore(c3, "\n");
    }, message: l2 })) : (h3 && e25.report({ node: t3, loc: { line: s3.loc.start.line, column: s3.loc.start.column }, fix: function(e26) {
      return e26.replaceTextRange([s3.range[1], a3.range[0] - a3.loc.start.column], "\n");
    }, message: p2 }), d2 && e25.report({ node: t3, loc: { line: c3.loc.end.line, column: c3.loc.end.column - 1 }, message: p2, fix: function(e26) {
      return e26.replaceTextRange([u3.range[1], c3.range[0] - c3.loc.start.column], "\n");
    } })));
  }
  var o2 = {}, s2 = e25.options[0] || "always", u2 = e25.options[1] || {};
  if (typeof s2 == "string") {
    var c2 = s2 === "always";
    o2.blocks = c2, o2.switches = c2, o2.classes = c2;
  } else
    Object.prototype.hasOwnProperty.call(s2, "blocks") && (o2.blocks = s2.blocks === "always"), Object.prototype.hasOwnProperty.call(s2, "switches") && (o2.switches = s2.switches === "always"), Object.prototype.hasOwnProperty.call(s2, "classes") && (o2.classes = s2.classes === "always");
  Object.prototype.hasOwnProperty.call(u2, "allowSingleLineBlocks") && (o2.allowSingleLineBlocks = u2.allowSingleLineBlocks === true);
  var l2 = "Block must be padded by blank lines.", p2 = "Block must not be padded by blank lines.", f2 = e25.getSourceCode(), h2 = {};
  return Object.prototype.hasOwnProperty.call(o2, "switches") && (h2.SwitchStatement = function(e26) {
    e26.cases.length === 0 || a2(e26);
  }), Object.prototype.hasOwnProperty.call(o2, "blocks") && (h2.BlockStatement = function(e26) {
    e26.body.length === 0 || a2(e26);
  }), Object.prototype.hasOwnProperty.call(o2, "classes") && (h2.ClassBody = function(e26) {
    e26.body.length === 0 || a2(e26);
  }), h2;
} }, UO = ("[".concat(Array.from(LA.LINEBREAKS).join(""), "]"), /^([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*?)[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*;?)$/), qO = /^(?:module[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\.[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*)?exports(?:[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\.|[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*\[|$)/, WO = /^require\(/;
function $O(e25) {
  return { test: function(t2, r2) {
    return r2.getFirstToken(t2).value === e25;
  } };
}
function GO(e25) {
  return { test: function(t2, r2) {
    return t2.loc.start.line === t2.loc.end.line && r2.getFirstToken(t2).value === e25;
  } };
}
function zO(e25) {
  return { test: function(t2, r2) {
    return t2.loc.start.line !== t2.loc.end.line && r2.getFirstToken(t2).value === e25;
  } };
}
function HO(e25) {
  return { test: function(t2) {
    return t2.type === e25;
  } };
}
function KO(e25) {
  if (e25.type === "ExpressionStatement") {
    var t2 = e25.expression;
    return t2.type === "UnaryExpression" && (t2 = t2.argument), t2.type === "CallExpression" && LA.isFunction(t2.callee);
  }
  return false;
}
function JO(e25, t2) {
  if (t2.type === "DoWhileStatement" && t2.body.type === "BlockStatement")
    return true;
  if (KO(t2))
    return true;
  var r2 = e25.getLastToken(t2, LA.isNotSemicolonToken), n2 = r2 && LA.isClosingBraceToken(r2) ? e25.getNodeByRangeIndex(r2.range[0]) : null;
  return !!n2 && (n2.type === "BlockStatement" || n2.type === "SwitchStatement");
}
function QO(e25, t2) {
  return e25.type === "ExpressionStatement" && (e25.parent.type === "Program" || e25.parent.type === "BlockStatement" && LA.isFunction(e25.parent.parent)) && e25.expression.type === "Literal" && typeof e25.expression.value == "string" && !LA.isParenthesised(t2, e25.expression);
}
function XO(e25, t2) {
  if (QO(e25, t2)) {
    var r2 = true, n2 = false, i2 = void 0;
    try {
      for (var a2, o2 = e25.parent.body[Symbol.iterator](); !(r2 = (a2 = o2.next()).done); r2 = true) {
        var s2 = a2.value;
        if (s2 === e25)
          break;
        if (!QO(s2, t2))
          return false;
      }
    } catch (e26) {
      n2 = true, i2 = e26;
    } finally {
      try {
        r2 || o2.return == null || o2.return();
      } finally {
        if (n2)
          throw i2;
      }
    }
    return true;
  }
  return false;
}
function YO(e25, t2) {
  var r2 = e25.getLastToken(t2), n2 = e25.getTokenBefore(r2), i2 = e25.getTokenAfter(r2);
  return !!(n2 && i2 && n2.range[0] >= t2.range[0] && LA.isSemicolonToken(r2) && r2.loc.start.line !== n2.loc.end.line && r2.loc.end.line === i2.loc.start.line) ? n2 : r2;
}
function ZO(e25, t2, r2) {
  return t2 + r2;
}
var eL = { any: { verify: function() {
} }, never: { verify: function(e25, t2, r2, n2) {
  n2.length === 0 || e25.report({ node: r2, message: "Unexpected blank line before this statement.", fix: function(t3) {
    if (2 <= n2.length)
      return null;
    var r3 = n2[0][0], i2 = n2[0][1], a2 = r3.range[1], o2 = i2.range[0], s2 = e25.getSourceCode().text.slice(a2, o2).replace(UO, ZO);
    return t3.replaceTextRange([a2, o2], s2);
  } });
} }, always: { verify: function(e25, t2, r2, n2) {
  0 < n2.length || e25.report({ node: r2, message: "Expected blank line before this statement.", fix: function(n3) {
    var i2 = e25.getSourceCode(), a2 = YO(i2, t2), o2 = i2.getFirstTokenBetween(a2, r2, { includeComments: true, filter: function(e26) {
      return !LA.isTokenOnSameLine(a2, e26) || (a2 = e26, false);
    } }) || r2, s2 = LA.isTokenOnSameLine(a2, o2) ? "\n\n" : "\n";
    return n3.insertTextAfter(a2, s2);
  } });
} } }, tL = { "*": { test: function() {
  return true;
} }, "block-like": { test: function(e25, t2) {
  return JO(t2, e25);
} }, "cjs-export": { test: function(e25, t2) {
  return e25.type === "ExpressionStatement" && e25.expression.type === "AssignmentExpression" && qO.test(t2.getText(e25.expression.left));
} }, "cjs-import": { test: function(e25, t2) {
  return e25.type === "VariableDeclaration" && 0 < e25.declarations.length && !!e25.declarations[0].init && WO.test(t2.getText(e25.declarations[0].init));
} }, directive: { test: XO }, expression: { test: function(e25, t2) {
  return e25.type === "ExpressionStatement" && !XO(e25, t2);
} }, iife: { test: KO }, "multiline-block-like": { test: function(e25, t2) {
  return e25.loc.start.line !== e25.loc.end.line && JO(t2, e25);
} }, "multiline-expression": { test: function(e25, t2) {
  return e25.loc.start.line !== e25.loc.end.line && e25.type === "ExpressionStatement" && !XO(e25, t2);
} }, "multiline-const": zO("const"), "multiline-let": zO("let"), "multiline-var": zO("var"), "singleline-const": GO("const"), "singleline-let": GO("let"), "singleline-var": GO("var"), block: HO("BlockStatement"), empty: HO("EmptyStatement"), function: HO("FunctionDeclaration"), break: $O("break"), case: $O("case"), class: $O("class"), const: $O("const"), continue: $O("continue"), debugger: $O("debugger"), default: $O("default"), do: $O("do"), export: $O("export"), for: $O("for"), if: $O("if"), import: $O("import"), let: $O("let"), return: $O("return"), switch: $O("switch"), throw: $O("throw"), try: $O("try"), var: $O("var"), while: $O("while"), with: $O("with") }, rL = { meta: { type: "layout", docs: { description: "require or disallow padding lines between statements", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/padding-line-between-statements" }, fixable: "whitespace", schema: { definitions: { paddingType: { enum: Object.keys(eL) }, statementType: { anyOf: [{ enum: Object.keys(tL) }, { type: "array", items: { enum: Object.keys(tL) }, minItems: 1, uniqueItems: true, additionalItems: false }] } }, type: "array", items: { type: "object", properties: { blankLine: { $ref: "#/definitions/paddingType" }, prev: { $ref: "#/definitions/statementType" }, next: { $ref: "#/definitions/statementType" } }, additionalProperties: false, required: ["blankLine", "prev", "next"] }, additionalItems: false } }, create: function(e25) {
  function t2() {
    u2 = { upper: u2, prevNode: null };
  }
  function r2() {
    u2 = u2.upper;
  }
  function n2(e26, t3) {
    for (var r3 = e26; r3.type === "LabeledStatement"; )
      r3 = r3.body;
    return Array.isArray(t3) ? t3.some(n2.bind(null, r3)) : tL[t3].test(r3, o2);
  }
  function i2(e26, t3) {
    for (var r3 = s2.length - 1; 0 <= r3; --r3) {
      var i3 = s2[r3];
      if (n2(e26, i3.prev) && n2(t3, i3.next))
        return eL[i3.blankLine];
    }
    return eL.any;
  }
  function a2(t3) {
    var r3 = t3.parent.type;
    if (LA.STATEMENT_LIST_PARENTS.has(r3) || r3 === "SwitchStatement") {
      var n3 = u2.prevNode;
      if (n3) {
        var a3 = i2(n3, t3), s3 = function(e26, t4) {
          var r4 = [], n4 = YO(o2, e26);
          if (2 <= t4.loc.start.line - n4.loc.end.line)
            do {
              var i3 = o2.getTokenAfter(n4, { includeComments: true });
              2 <= i3.loc.start.line - n4.loc.end.line && r4.push([n4, i3]), n4 = i3;
            } while (n4.range[0] < t4.range[0]);
          return r4;
        }(n3, t3);
        a3.verify(e25, n3, t3, s3);
      }
      u2.prevNode = t3;
    }
  }
  var o2 = e25.getSourceCode(), s2 = e25.options || [], u2 = null;
  return { Program: t2, BlockStatement: t2, SwitchStatement: t2, "Program:exit": r2, "BlockStatement:exit": r2, "SwitchStatement:exit": r2, ":statement": a2, SwitchCase: function(e26) {
    a2(e26), t2();
  }, "SwitchCase:exit": r2 };
} };
var nL = { meta: { type: "suggestion", docs: { description: "require using arrow functions for callbacks", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-arrow-callback" }, schema: [{ type: "object", properties: { allowNamedFunctions: { type: "boolean", default: false }, allowUnboundThis: { type: "boolean", default: true } }, additionalProperties: false }], fixable: "code" }, create: function(e25) {
  function t2() {
    s2.push({ this: false, super: false, meta: false });
  }
  function r2() {
    return s2.pop();
  }
  var n2 = e25.options[0] || {}, i2 = n2.allowUnboundThis !== false, a2 = n2.allowNamedFunctions, o2 = e25.getSourceCode(), s2 = [];
  return { Program: function() {
    s2 = [];
  }, ThisExpression: function() {
    var e26 = s2[s2.length - 1];
    e26 && (e26.this = true);
  }, Super: function() {
    var e26 = s2[s2.length - 1];
    e26 && (e26.super = true);
  }, MetaProperty: function(e26) {
    var t3 = s2[s2.length - 1];
    t3 && function(e27, t4, r3) {
      return e27.meta.name === t4 && e27.property.name === r3;
    }(e26, "new", "target") && (t3.meta = true);
  }, FunctionDeclaration: t2, "FunctionDeclaration:exit": r2, FunctionExpression: t2, "FunctionExpression:exit": function(t3) {
    var n3 = r2();
    if (!(a2 && t3.id && t3.id.name || t3.generator)) {
      var s3 = e25.getDeclaredVariables(t3)[0];
      if (!(function(e26) {
        return e26 && e26.defs[0].type === "FunctionName";
      }(s3) && 0 < s3.references.length)) {
        var u2 = function(e26) {
          for (var t4 = e26.variables, r3 = 0; r3 < t4.length; ++r3) {
            var n4 = t4[r3];
            if (n4.name === "arguments")
              return n4.identifiers.length === 0 ? n4 : null;
          }
          return null;
        }(e25.getScope());
        if (!(u2 && 0 < u2.references.length)) {
          var c2 = function(e26) {
            for (var t4 = { isCallback: false, isLexicalThis: false }, r3 = e26, n4 = e26.parent; r3; ) {
              switch (n4.type) {
                case "LogicalExpression":
                case "ConditionalExpression":
                  break;
                case "MemberExpression":
                  if (n4.object !== r3 || n4.property.computed || n4.property.type !== "Identifier" || n4.property.name !== "bind" || n4.parent.type !== "CallExpression" || n4.parent.callee !== n4)
                    return t4;
                  t4.isLexicalThis = n4.parent.arguments.length === 1 && n4.parent.arguments[0].type === "ThisExpression", n4 = n4.parent;
                  break;
                case "CallExpression":
                case "NewExpression":
                  return n4.callee !== r3 && (t4.isCallback = true), t4;
                default:
                  return t4;
              }
              r3 = n4, n4 = n4.parent;
            }
            throw new Error("unreachable");
          }(t3);
          !c2.isCallback || i2 && n3.this && !c2.isLexicalThis || n3.super || n3.meta || e25.report({ node: t3, message: "Unexpected function expression.", fix: function(e26) {
            if (!c2.isLexicalThis && n3.this || function(e27) {
              return e27.every(function(e28) {
                return e28.type === "Identifier";
              }) && e27.length !== new Set(e27.map(function(e28) {
                return e28.name;
              })).size;
            }(t3.params))
              return null;
            var r3 = t3.params.length ? o2.getTokenBefore(t3.params[0]) : o2.getTokenBefore(t3.body, 1), i3 = o2.getTokenBefore(t3.body), a3 = t3.async ? "async " : "", s4 = o2.text.slice(r3.range[0], i3.range[1]), u3 = "".concat(a3).concat(s4, " => ").concat(o2.getText(t3.body)), l2 = c2.isLexicalThis ? t3.parent.parent : t3, p2 = l2.parent.type !== "CallExpression" && l2.parent.type !== "ConditionalExpression" ? "(".concat(u3, ")") : u3;
            return e26.replaceText(l2, p2);
          } });
        }
      }
    }
  } };
} }, iL = /^(?:(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?Pattern|RestElement|SpreadProperty|ExperimentalRestProperty|Property)$/, aL = /^(?:Program|BlockStatement|SwitchCase)$/, oL = /^(?:VariableDeclarator|AssignmentExpression)$/;
function sL(e25, t2) {
  if (t2.through.find(function(t3) {
    return t3.resolved && t3.resolved.name === e25;
  }))
    return true;
  var r2 = LA.getVariableByName(t2, e25);
  return r2 !== null && r2.defs.some(function(e26) {
    return e26.type === "Parameter";
  });
}
function uL(e25) {
  if (!e25.isWrite())
    return null;
  for (var t2 = e25.identifier.parent; iL.test(t2.type); )
    t2 = t2.parent;
  return oL.test(t2.type) ? t2 : null;
}
function cL(e25) {
  switch (e25.type) {
    case "ObjectPattern":
      return e25.properties.some(function(e26) {
        return !!e26 && cL(e26.argument || e26.value);
      });
    case "ArrayPattern":
      return e25.elements.some(function(e26) {
        return !!e26 && cL(e26);
      });
    case "AssignmentPattern":
      return cL(e25.left);
    case "MemberExpression":
      return true;
  }
  return false;
}
function lL(e25, t2) {
  if (e25.eslintUsed && e25.scope.type === "global")
    return null;
  for (var r2 = null, n2 = false, i2 = e25.references, a2 = 0; a2 < i2.length; ++a2) {
    var o2 = i2[a2];
    if (o2.isWrite()) {
      if (r2 !== null && r2.identifier !== o2.identifier)
        return null;
      var s2 = uL(o2);
      if (s2 !== null && s2.left !== void 0) {
        var u2 = s2.left, c2 = false, l2 = false;
        if (u2.type === "ObjectPattern")
          c2 = u2.properties.filter(function(e26) {
            return e26.value;
          }).map(function(e26) {
            return e26.value.name;
          }).some(function(t3) {
            return sL(t3, e25.scope);
          }), l2 = cL(u2);
        else if (u2.type === "ArrayPattern") {
          c2 = u2.elements.map(function(e26) {
            return e26 && e26.name;
          }).some(function(t3) {
            return sL(t3, e25.scope);
          }), l2 = cL(u2);
        }
        if (c2 || l2)
          return null;
      }
      r2 = o2;
    } else if (o2.isRead() && r2 === null) {
      if (t2)
        return null;
      n2 = true;
    }
  }
  return r2 !== null && r2.from === e25.scope && function(e26) {
    for (var t3 = e26.parent; iL.test(t3.type); )
      t3 = t3.parent;
    return t3.type === "VariableDeclarator" || t3.type === "AssignmentExpression" && t3.parent.type === "ExpressionStatement" && aL.test(t3.parent.parent.type);
  }(r2.identifier) ? n2 ? e25.defs[0].name : r2.identifier : null;
}
var pL = { meta: { type: "suggestion", docs: { description: "require `const` declarations for variables that are never reassigned after declared", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-const" }, fixable: "code", schema: [{ type: "object", properties: { destructuring: { enum: ["any", "all"], default: "any" }, ignoreReadBeforeAssign: { type: "boolean", default: false } }, additionalProperties: false }], messages: { useConst: "'{{name}}' is never reassigned. Use 'const' instead." } }, create: function(e25) {
  function t2(t3) {
    var r3 = t3.filter(Boolean);
    if (t3.length && (i2 || r3.length === t3.length)) {
      var a3 = function e26(t4, r4, n3) {
        return !t4 || n3(t4) ? null : t4.type === r4 ? t4 : e26(t4.parent, r4, n3);
      }(t3[0], "VariableDeclaration", function(e26) {
        return e26.type.endsWith("Statement");
      }), o3 = a3 === null;
      if (!o3 && 0 < a3.declarations.length) {
        var l2 = a3.declarations[0];
        if (l2.init) {
          var p2 = l2.init.parent;
          p2.type === "VariableDeclarator" && (p2.id.name !== c2 && (c2 = p2.id.name, s2 = 0), p2.id.type === "ObjectPattern" && p2.init.name !== c2 && (c2 = p2.init.name, s2 = 0), p2.id !== u2 && (u2 = p2.id, s2 = 0));
        }
      }
      var f2 = a3 && (a3.parent.type === "ForInStatement" || a3.parent.type === "ForOfStatement" || a3.declarations.every(function(e26) {
        return e26.init;
      })) && r3.length === t3.length;
      !o3 && a3.declarations && a3.declarations.length !== 1 && a3 && a3.declarations && 1 <= a3.declarations.length && (s2 += r3.length, f2 = f2 && s2 === a3.declarations.length), r3.forEach(function(t4) {
        e25.report({ node: t4, messageId: "useConst", data: t4, fix: f2 ? function(e26) {
          return e26.replaceText(n2.getFirstToken(a3, function(e27) {
            return e27.value === a3.kind;
          }), "const");
        } : null });
      });
    }
  }
  var r2 = e25.options[0] || {}, n2 = e25.getSourceCode(), i2 = r2.destructuring !== "all", a2 = r2.ignoreReadBeforeAssign === true, o2 = [], s2 = 0, u2 = null, c2 = "";
  return { "Program:exit": function() {
    (function(e26, t3) {
      for (var r3 = new Map(), n3 = 0; n3 < e26.length; ++n3)
        for (var i3 = e26[n3], a3 = i3.references, o3 = lL(i3, t3), s3 = null, u3 = 0; u3 < a3.length; ++u3) {
          var c3 = a3[u3], l2 = c3.identifier;
          if (l2 !== s3) {
            s3 = l2;
            var p2 = uL(c3);
            p2 && (r3.has(p2) ? r3.get(p2).push(o3) : r3.set(p2, [o3]));
          }
        }
      return r3;
    })(o2, a2).forEach(t2);
  }, VariableDeclaration: function(t3) {
    t3.kind !== "let" || function(e26) {
      return e26.parent.type === "ForStatement" && e26.parent.init === e26;
    }(t3) || o2.push.apply(o2, E(e25.getDeclaredVariables(t3)));
  } };
} }, fL = { meta: { type: "suggestion", docs: { description: "require destructuring from arrays and/or objects", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-destructuring" }, fixable: "code", schema: [{ oneOf: [{ type: "object", properties: { VariableDeclarator: { type: "object", properties: { array: { type: "boolean" }, object: { type: "boolean" } }, additionalProperties: false }, AssignmentExpression: { type: "object", properties: { array: { type: "boolean" }, object: { type: "boolean" } }, additionalProperties: false } }, additionalProperties: false }, { type: "object", properties: { array: { type: "boolean" }, object: { type: "boolean" } }, additionalProperties: false }] }, { type: "object", properties: { enforceForRenamedProperties: { type: "boolean" } }, additionalProperties: false }] }, create: function(e25) {
  function t2(e26, t3) {
    return s2 && s2[e26] && s2[e26][t3];
  }
  function r2(t3, r3, n3) {
    e25.report({ node: t3, message: "Use {{type}} destructuring.", data: { type: r3 }, fix: n3 });
  }
  function n2(t3, r3) {
    var n3 = r3.init, i3 = e25.getSourceCode();
    return t3.replaceText(r3, "{".concat(n3.property.name, "} = ").concat(i3.getText(n3.object)));
  }
  function i2(e26, i3, a3) {
    if (i3.type === "MemberExpression" && i3.object.type !== "Super") {
      if (function(e27) {
        return Number.isInteger(e27.property.value);
      }(i3))
        return void (t2(a3.type, "array") && r2(a3, "array", null));
      var s3 = function(e27) {
        return e27.type === "VariableDeclarator" && e27.id.type === "Identifier" && e27.init.type === "MemberExpression" && e27.id.name === e27.init.property.name;
      }(a3) ? function(e27) {
        return n2(e27, a3);
      } : null;
      if (t2(a3.type, "object") && o2)
        return void r2(a3, "object", s3);
      if (t2(a3.type, "object")) {
        var u2 = i3.property;
        (u2.type !== "Literal" || e26.name !== u2.value) && (u2.type !== "Identifier" || e26.name !== u2.name || i3.computed) || r2(a3, "object", s3);
      }
    }
  }
  var a2 = e25.options[0], o2 = e25.options[1] && e25.options[1].enforceForRenamedProperties, s2 = { VariableDeclarator: { array: true, object: true }, AssignmentExpression: { array: true, object: true } };
  return a2 && (s2 = a2.array !== void 0 || a2.object !== void 0 ? { VariableDeclarator: a2, AssignmentExpression: a2 } : a2), { VariableDeclarator: function(e26) {
    e26.init && e26.init.type === "MemberExpression" && i2(e26.id, e26.init, e26);
  }, AssignmentExpression: function(e26) {
    e26.operator === "=" && i2(e26.left, e26.right, e26);
  } };
} }, hL = Fy.require$$0, dL = hL.CALL, mL = hL.ReferenceTracker, gL = LA.getPrecedence({ type: "BinaryExpression", operator: "**" });
function yL(e25, t2) {
  return t2 ? "(".concat(e25, ")") : e25;
}
var vL = { meta: { type: "suggestion", docs: { description: "disallow the use of `Math.pow` in favor of the `**` operator", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/prefer-exponentiation-operator" }, schema: [], fixable: "code", messages: { useExponentiation: "Use the '**' operator instead of 'Math.pow'." } }, create: function(e25) {
  function t2(t3) {
    e25.report({ node: t3, messageId: "useExponentiation", fix: function(e26) {
      if (t3.arguments.length !== 2 || t3.arguments.some(function(e27) {
        return e27.type === "SpreadElement";
      }) || 0 < r2.getCommentsInside(t3).length)
        return null;
      var n2 = t3.arguments[0], i2 = t3.arguments[1], a2 = r2.getText(n2), o2 = r2.getText(i2), s2 = function(e27) {
        return LA.getPrecedence(e27) <= gL || e27.type === "UnaryExpression";
      }(n2), u2 = function(e27) {
        return LA.getPrecedence(e27) < gL;
      }(i2), c2 = function(e27, t4) {
        var r3 = e27.parent;
        return (r3.type === "ClassDeclaration" || r3.type.endsWith("Expression") && LA.getPrecedence(r3) >= gL && (r3.type !== "BinaryExpression" || r3.operator !== "**" || r3.right !== e27) && !((r3.type === "CallExpression" || r3.type === "NewExpression") && r3.arguments.includes(e27)) && !(r3.type === "MemberExpression" && r3.computed && r3.property === e27) && r3.type !== "ArrayExpression") && !LA.isParenthesised(t4, e27);
      }(t3, r2), l2 = "", p2 = "";
      if (!c2) {
        if (!s2) {
          var f2 = r2.getFirstToken(n2), h2 = r2.getTokenBefore(t3);
          h2 && h2.range[1] === t3.range[0] && !LA.canTokensBeAdjacent(h2, f2) && (l2 = " ");
        }
        if (!u2) {
          var d2 = r2.getLastToken(i2), m2 = r2.getTokenAfter(t3);
          m2 && t3.range[1] === m2.range[0] && !LA.canTokensBeAdjacent(d2, m2) && (p2 = " ");
        }
      }
      var g2 = yL(a2, s2), y2 = yL(o2, u2), v2 = yL("".concat(g2, "**").concat(y2), c2);
      return e26.replaceText(t3, "".concat(l2).concat(v2).concat(p2));
    } });
  }
  var r2 = e25.getSourceCode();
  return { Program: function() {
    var r3 = e25.getScope(), n2 = new mL(r3), i2 = { Math: { pow: u({}, dL, true) } }, a2 = true, o2 = false, s2 = void 0;
    try {
      for (var c2, l2 = n2.iterateGlobalReferences(i2)[Symbol.iterator](); !(a2 = (c2 = l2.next()).done); a2 = true) {
        t2(c2.value.node);
      }
    } catch (e26) {
      o2 = true, s2 = e26;
    } finally {
      try {
        a2 || l2.return == null || l2.return();
      } finally {
        if (o2)
          throw s2;
      }
    }
  } };
} }, xL = Fy.require$$0, bL = xL.CALL, EL = xL.CONSTRUCT, CL = xL.ReferenceTracker, SL = xL.getStringIfConstant, kL = new PA.RegExpParser(), DL = { meta: { type: "suggestion", docs: { description: "enforce using named capture group in regular expression", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/prefer-named-capture-group" }, schema: [], messages: { required: "Capture group '{{group}}' should be converted to a named or non-capturing group." } }, create: function(e25) {
  function t2(t3, r2, n2) {
    var i2;
    try {
      i2 = kL.parsePattern(t3, 0, t3.length, n2);
    } catch (e26) {
      return;
    }
    PA.visitRegExpAST(i2, { onCapturingGroupEnter: function(t4) {
      t4.name || e25.report({ node: r2, messageId: "required", data: { group: t4.raw } });
    } });
  }
  return { Literal: function(e26) {
    e26.regex && t2(e26.regex.pattern, e26, e26.regex.flags.includes("u"));
  }, Program: function() {
    var r2, n2 = e25.getScope(), i2 = new CL(n2), a2 = { RegExp: (r2 = {}, u(r2, bL, true), u(r2, EL, true), r2) }, o2 = true, s2 = false, c2 = void 0;
    try {
      for (var l2, p2 = i2.iterateGlobalReferences(a2)[Symbol.iterator](); !(o2 = (l2 = p2.next()).done); o2 = true) {
        var f2 = l2.value.node, h2 = SL(f2.arguments[0]), d2 = SL(f2.arguments[1]);
        h2 && t2(h2, f2, d2 && d2.includes("u"));
      }
    } catch (e26) {
      s2 = true, c2 = e26;
    } finally {
      try {
        o2 || p2.return == null || p2.return();
      } finally {
        if (s2)
          throw c2;
      }
    }
  } };
} };
var FL = { meta: { type: "suggestion", docs: { description: "disallow `parseInt()` and `Number.parseInt()` in favor of binary, octal, and hexadecimal literals", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-numeric-literals" }, schema: [], fixable: "code" }, create: function(e25) {
  var t2 = e25.getSourceCode(), r2 = { 2: "binary", 8: "octal", 16: "hexadecimal" }, n2 = { 2: "0b", 8: "0o", 16: "0x" };
  return { CallExpression: function(i2) {
    if (i2.arguments.length === 2) {
      var a2 = r2[i2.arguments[1].value];
      (function(e26) {
        switch (e26.type) {
          case "Identifier":
            return e26.name === "parseInt";
          case "MemberExpression":
            return e26.object.type === "Identifier" && e26.object.name === "Number" && e26.property.type === "Identifier" && e26.property.name === "parseInt";
        }
        return false;
      })(i2.callee) && a2 && i2.arguments[0].type === "Literal" && e25.report({ node: i2, message: "Use {{radixName}} literals instead of {{functionName}}().", data: { radixName: a2, functionName: t2.getText(i2.callee) }, fix: function(e26) {
        if (t2.getCommentsInside(i2).length)
          return null;
        var r3 = "".concat(n2[i2.arguments[1].value]).concat(i2.arguments[0].value);
        if (+r3 !== parseInt(i2.arguments[0].value, i2.arguments[1].value))
          return null;
        var a3 = t2.getTokenBefore(i2), o2 = t2.getTokenAfter(i2), s2 = "", u2 = "";
        return a3 && a3.range[1] === i2.range[0] && !LA.canTokensBeAdjacent(a3, r3) && (s2 = " "), o2 && i2.range[1] === o2.range[0] && !LA.canTokensBeAdjacent(r3, o2) && (u2 = " "), e26.replaceText(i2, "".concat(s2).concat(r3).concat(u2));
      } });
    }
  } };
} }, AL = Fy.require$$0, wL = AL.CALL, _L = AL.ReferenceTracker, TL = LA.isCommaToken, PL = LA.isOpeningParenToken, IL = LA.isClosingParenToken, BL = LA.isParenthesised, OL = /[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]/;
function LL(e25) {
  return e25.arguments.some(function(e26) {
    return e26.type === "SpreadElement";
  });
}
function NL(e25, t2) {
  var r2 = e25.parent;
  switch (r2.type) {
    case "VariableDeclarator":
    case "ArrayExpression":
    case "ReturnStatement":
    case "CallExpression":
    case "Property":
      return false;
    case "AssignmentExpression":
      return r2.left === e25 && !BL(t2, e25);
    default:
      return !BL(t2, e25);
  }
}
function jL(e25, t2) {
  switch (e25.type) {
    case "AssignmentExpression":
    case "ArrowFunctionExpression":
    case "ConditionalExpression":
      return !BL(t2, e25);
    default:
      return false;
  }
}
function RL(e25, t2, r2) {
  for (var n2 = [r2.getFirstToken(e25), r2.getLastToken(e25)], i2 = r2.getTokenBefore(e25), a2 = r2.getTokenAfter(e25); i2 && a2 && i2.range[0] > t2.range[0] && PL(i2) && IL(a2); )
    n2.push(i2, a2), i2 = r2.getTokenBefore(i2), a2 = r2.getTokenAfter(a2);
  return n2.sort(function(e26, t3) {
    return e26.range[0] - t3.range[0];
  });
}
function ML(e25, t2) {
  var r2 = t2.text, n2 = e25.range[0], i2 = t2.getTokenBefore(e25, { includeComments: true });
  if (i2 && i2.type === "Line")
    return n2;
  for (; OL.test(r2[n2 - 1] || ""); )
    n2 -= 1;
  return n2;
}
function VL(e25, t2) {
  for (var r2 = t2.text, n2 = e25.range[1]; OL.test(r2[n2] || ""); )
    n2 += 1;
  return n2;
}
function UL(e25, t2) {
  return regeneratorRuntime.mark(function r2(n2) {
    var i2, a2, o2, s2, u2, c2, l2, p2, f2, h2, d2, m2, g2, y2, v2, x2, b2, E2, C2, S2, k2;
    return regeneratorRuntime.wrap(function(r3) {
      for (; ; )
        switch (r3.prev = r3.next) {
          case 0:
            return i2 = t2.getTokenAfter(e25.callee, PL), a2 = t2.getLastToken(e25), r3.next = 3, n2.remove(e25.callee);
          case 3:
            if (!NL(e25, t2)) {
              r3.next = 10;
              break;
            }
            return r3.next = 6, n2.replaceText(i2, "({");
          case 6:
            return r3.next = 8, n2.replaceText(a2, "})");
          case 8:
            r3.next = 14;
            break;
          case 10:
            return r3.next = 12, n2.replaceText(i2, "{");
          case 12:
            return r3.next = 14, n2.replaceText(a2, "}");
          case 14:
            o2 = true, s2 = false, u2 = void 0, r3.prev = 17, c2 = e25.arguments[Symbol.iterator]();
          case 19:
            if (o2 = (l2 = c2.next()).done) {
              r3.next = 73;
              break;
            }
            if (p2 = l2.value, f2 = RL(p2, i2, t2), h2 = f2.shift(), d2 = f2.pop(), p2.type !== "ObjectExpression") {
              r3.next = 61;
              break;
            }
            m2 = t2.getLastToken(p2, 1), g2 = t2.getTokenAfter(d2), y2 = true, v2 = false, x2 = void 0, r3.prev = 27, b2 = f2[Symbol.iterator]();
          case 29:
            if (y2 = (E2 = b2.next()).done) {
              r3.next = 36;
              break;
            }
            return C2 = E2.value, r3.next = 33, n2.remove(C2);
          case 33:
            y2 = true, r3.next = 29;
            break;
          case 36:
            r3.next = 42;
            break;
          case 38:
            r3.prev = 38, r3.t0 = r3.catch(27), v2 = true, x2 = r3.t0;
          case 42:
            r3.prev = 42, r3.prev = 43, y2 || b2.return == null || b2.return();
          case 45:
            if (r3.prev = 45, !v2) {
              r3.next = 48;
              break;
            }
            throw x2;
          case 48:
            return r3.finish(45);
          case 49:
            return r3.finish(42);
          case 50:
            return S2 = [h2.range[0], VL(h2, t2)], k2 = [Math.max(ML(d2, t2), S2[1]), d2.range[1]], r3.next = 53, n2.removeRange(S2);
          case 53:
            return r3.next = 55, n2.removeRange(k2);
          case 55:
            if (r3.t1 = (p2.properties.length === 0 || TL(m2)) && TL(g2), !r3.t1) {
              r3.next = 59;
              break;
            }
            return r3.next = 59, n2.remove(g2);
          case 59:
            r3.next = 70;
            break;
          case 61:
            if (!jL(p2, t2)) {
              r3.next = 68;
              break;
            }
            return r3.next = 64, n2.insertTextBefore(h2, "...(");
          case 64:
            return r3.next = 66, n2.insertTextAfter(d2, ")");
          case 66:
            r3.next = 70;
            break;
          case 68:
            return r3.next = 70, n2.insertTextBefore(h2, "...");
          case 70:
            o2 = true, r3.next = 19;
            break;
          case 73:
            r3.next = 79;
            break;
          case 75:
            r3.prev = 75, r3.t2 = r3.catch(17), s2 = true, u2 = r3.t2;
          case 79:
            r3.prev = 79, r3.prev = 80, o2 || c2.return == null || c2.return();
          case 82:
            if (r3.prev = 82, !s2) {
              r3.next = 85;
              break;
            }
            throw u2;
          case 85:
            return r3.finish(82);
          case 86:
            return r3.finish(79);
          case 87:
          case "end":
            return r3.stop();
        }
    }, r2, null, [[17, 75, 79, 87], [27, 38, 42, 50], [43, , 45, 49], [80, , 82, 86]]);
  });
}
var qL = { meta: { type: "suggestion", docs: { description: "disallow using Object.assign with an object literal as the first argument and prefer the use of object spread instead.", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/prefer-object-spread" }, schema: [], fixable: "code", messages: { useSpreadMessage: "Use an object spread instead of `Object.assign` eg: `{ ...foo }`.", useLiteralMessage: "Use an object literal instead of `Object.assign`. eg: `{ foo: bar }`." } }, create: function(e25) {
  var t2 = e25.getSourceCode();
  return { Program: function() {
    var r2 = e25.getScope(), n2 = new _L(r2), i2 = { Object: { assign: u({}, wL, true) } }, a2 = true, o2 = false, s2 = void 0;
    try {
      for (var c2, l2 = n2.iterateGlobalReferences(i2)[Symbol.iterator](); !(a2 = (c2 = l2.next()).done); a2 = true) {
        var p2 = c2.value.node;
        if (1 <= p2.arguments.length && p2.arguments[0].type === "ObjectExpression" && !LL(p2)) {
          var f2 = p2.arguments.length === 1 ? "useLiteralMessage" : "useSpreadMessage", h2 = UL(p2, t2);
          e25.report({ node: p2, messageId: f2, fix: h2 });
        }
      }
    } catch (e26) {
      o2 = true, s2 = e26;
    } finally {
      try {
        a2 || l2.return == null || l2.return();
      } finally {
        if (o2)
          throw s2;
      }
    }
  } };
} }, WL = { meta: { type: "suggestion", docs: { description: "require using Error objects as Promise rejection reasons", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/prefer-promise-reject-errors" }, fixable: null, schema: [{ type: "object", properties: { allowEmptyReject: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3) {
    (t3.arguments.length || !r2) && (t3.arguments.length && LA.couldBeError(t3.arguments[0]) && (t3.arguments[0].type !== "Identifier" || t3.arguments[0].name !== "undefined") || e25.report({ node: t3, message: "Expected the Promise rejection reason to be an Error." }));
  }
  var r2 = e25.options.length && e25.options[0].allowEmptyReject;
  return { CallExpression: function(e26) {
    (function(e27) {
      return e27.callee.type === "MemberExpression" && e27.callee.object.type === "Identifier" && e27.callee.object.name === "Promise" && e27.callee.property.type === "Identifier" && e27.callee.property.name === "reject";
    })(e26) && t2(e26);
  }, "NewExpression:exit": function(r3) {
    r3.callee.type === "Identifier" && r3.callee.name === "Promise" && r3.arguments.length && LA.isFunction(r3.arguments[0]) && 1 < r3.arguments[0].params.length && r3.arguments[0].params[1].type === "Identifier" && e25.getDeclaredVariables(r3.arguments[0]).find(function(e26) {
      return e26.name === r3.arguments[0].params[1].name;
    }).references.filter(function(e26) {
      return e26.isRead();
    }).filter(function(e26) {
      return e26.identifier.parent.type === "CallExpression" && e26.identifier === e26.identifier.parent.callee;
    }).forEach(function(e26) {
      return t2(e26.identifier.parent);
    });
  } };
} }, $L = { meta: { type: "suggestion", docs: { description: "require `Reflect` methods where applicable", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-reflect" }, deprecated: true, replacedBy: [], schema: [{ type: "object", properties: { exceptions: { type: "array", items: { enum: ["apply", "call", "delete", "defineProperty", "getOwnPropertyDescriptor", "getPrototypeOf", "setPrototypeOf", "isExtensible", "getOwnPropertyNames", "preventExtensions"] }, uniqueItems: true } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3, r3, n3) {
    e25.report({ node: t3, message: "Avoid using {{existing}}, instead use {{substitute}}.", data: { existing: r3, substitute: n3 } });
  }
  var r2 = { apply: "Function.prototype.apply", call: "Function.prototype.call", defineProperty: "Object.defineProperty", getOwnPropertyDescriptor: "Object.getOwnPropertyDescriptor", getPrototypeOf: "Object.getPrototypeOf", setPrototypeOf: "Object.setPrototypeOf", isExtensible: "Object.isExtensible", getOwnPropertyNames: "Object.getOwnPropertyNames", preventExtensions: "Object.preventExtensions" }, n2 = { apply: "Reflect.apply", call: "Reflect.apply", defineProperty: "Reflect.defineProperty", getOwnPropertyDescriptor: "Reflect.getOwnPropertyDescriptor", getPrototypeOf: "Reflect.getPrototypeOf", setPrototypeOf: "Reflect.setPrototypeOf", isExtensible: "Reflect.isExtensible", getOwnPropertyNames: "Reflect.getOwnPropertyNames", preventExtensions: "Reflect.preventExtensions" }, i2 = (e25.options[0] || {}).exceptions || [];
  return { CallExpression: function(e26) {
    var a2 = (e26.callee.property || {}).name, o2 = (e26.callee.object || {}).name === "Reflect", s2 = Object.prototype.hasOwnProperty.call(n2, a2), u2 = i2.indexOf(a2) !== -1;
    !s2 || o2 || u2 || t2(e26, r2[a2], n2[a2]);
  }, UnaryExpression: function(e26) {
    var r3 = e26.operator === "delete", n3 = e26.argument.type === "Identifier", a2 = i2.indexOf("delete") !== -1;
    !r3 || n3 || a2 || t2(e26, "the delete keyword", "Reflect.deleteProperty");
  } };
} }, GL = Fy.require$$0, zL = GL.CALL, HL = GL.CONSTRUCT, KL = GL.ReferenceTracker, JL = GL.findVariable;
function QL(e25) {
  return e25.type === "TemplateLiteral" && e25.expressions.length === 0;
}
var XL = { meta: { type: "suggestion", docs: { description: "disallow use of the `RegExp` constructor in favor of regular expression literals", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/prefer-regex-literals" }, schema: [], messages: { unexpectedRegExp: "Use a regular expression literal instead of the 'RegExp' constructor." } }, create: function(e25) {
  function t2(t3) {
    var r3 = e25.getScope(), n2 = JL(r3, t3);
    return n2 !== null && n2.scope.type === "global" && n2.defs.length === 0;
  }
  function r2(e26) {
    return function(e27) {
      return e27.type === "Literal" && typeof e27.value == "string";
    }(e26) || QL(e26) || function(e27) {
      return e27.type === "TaggedTemplateExpression" && e27.tag.type === "MemberExpression" && e27.tag.object.type === "Identifier" && e27.tag.object.name === "String" && t2(e27.tag.object) && LA.getStaticPropertyName(e27.tag) === "raw" && QL(e27.quasi);
    }(e26);
  }
  return { Program: function() {
    var t3, n2 = e25.getScope(), i2 = new KL(n2), a2 = { RegExp: (t3 = {}, u(t3, zL, true), u(t3, HL, true), t3) }, o2 = true, s2 = false, c2 = void 0;
    try {
      for (var l2, p2 = i2.iterateGlobalReferences(a2)[Symbol.iterator](); !(o2 = (l2 = p2.next()).done); o2 = true) {
        var f2 = l2.value.node, h2 = f2.arguments;
        (h2.length === 1 || h2.length === 2) && h2.every(r2) && e25.report({ node: f2, messageId: "unexpectedRegExp" });
      }
    } catch (e26) {
      s2 = true, c2 = e26;
    } finally {
      try {
        o2 || p2.return == null || p2.return();
      } finally {
        if (s2)
          throw c2;
      }
    }
  } };
} };
function YL(e25) {
  var t2 = e25.identifier, r2 = t2.parent;
  return r2.type !== "MemberExpression" || r2.object !== t2 || r2.computed;
}
var ZL = { meta: { type: "suggestion", docs: { description: "require rest parameters instead of `arguments`", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-rest-params" }, schema: [] }, create: function(e25) {
  function t2(t3) {
    e25.report({ node: t3.identifier, loc: t3.identifier.loc, message: "Use the rest parameters instead of 'arguments'." });
  }
  function r2() {
    var r3 = function(e26) {
      for (var t3 = e26.variables, r4 = 0; r4 < t3.length; ++r4) {
        var n2 = t3[r4];
        if (n2.name === "arguments")
          return n2.identifiers.length === 0 ? n2 : null;
      }
      return null;
    }(e25.getScope());
    r3 && r3.references.filter(YL).forEach(t2);
  }
  return { "FunctionDeclaration:exit": r2, "FunctionExpression:exit": r2 };
} };
var eN = { meta: { type: "suggestion", docs: { description: "require spread operators instead of `.apply()`", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-spread" }, schema: [], fixable: null }, create: function(e25) {
  var t2 = e25.getSourceCode();
  return { CallExpression: function(r2) {
    if (function(e26) {
      return e26.callee.type === "MemberExpression" && e26.callee.property.type === "Identifier" && e26.callee.property.name === "apply" && e26.callee.computed === false && e26.arguments.length === 2 && e26.arguments[1].type !== "ArrayExpression" && e26.arguments[1].type !== "SpreadElement";
    }(r2)) {
      var n2 = r2.callee.object;
      (function(e26, t3, r3) {
        return e26 ? LA.equalTokens(e26, t3, r3) : LA.isNullOrUndefined(t3);
      })(n2.type === "MemberExpression" ? n2.object : null, r2.arguments[0], t2) && e25.report({ node: r2, message: "Use the spread operator instead of '.apply()'." });
    }
  } };
} };
function tN(e25) {
  return e25.type === "BinaryExpression" && e25.operator === "+";
}
function rN(e25) {
  for (var t2 = e25; tN(t2.parent); )
    t2 = t2.parent;
  return t2;
}
function nN(e25) {
  return tN(e25) ? nN(e25.left) || nN(e25.right) : function(e26) {
    return !!(e26.type === "Literal" && typeof e26.value == "string") && LA.hasOctalEscapeSequence(e26.raw);
  }(e25);
}
function iN(e25) {
  return tN(e25) ? iN(e25.right) || iN(e25.left) : !LA.isStringLiteral(e25);
}
function aN(e25) {
  return e25.type === "BinaryExpression" ? aN(e25.left) : e25.type === "TemplateLiteral" ? e25.expressions.length && e25.quasis.length && e25.quasis[0].range[0] === e25.quasis[0].range[1] : e25.type !== "Literal" || typeof e25.value != "string";
}
var oN = { meta: { type: "suggestion", docs: { description: "require template literals instead of string concatenation", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/prefer-template" }, schema: [], fixable: "code" }, create: function(e25) {
  function t2(e26, t3) {
    var r3 = [e26].concat(i2.getTokensBetween(e26, t3)).concat(t3), n3 = i2.getText();
    return r3.slice(0, -1).reduce(function(e27, t4, i3) {
      return e27 + n3.slice(t4.range[1], r3[i3 + 1].range[0]);
    }, "");
  }
  function r2(e26, n3, a3) {
    if (e26.type === "Literal" && typeof e26.value == "string")
      return "`".concat(e26.raw.slice(1, -1).replace(/\\*(\$\{|`)/g, function(e27) {
        return e27.lastIndexOf("\\") % 2 ? "\\".concat(e27) : e27;
      }).replace(new RegExp("\\\\".concat(e26.raw[0]), "gu"), e26.raw[0]), "`");
    if (e26.type === "TemplateLiteral")
      return i2.getText(e26);
    if (tN(e26) && function e27(t3) {
      return tN(t3) ? e27(t3.right) || e27(t3.left) : LA.isStringLiteral(t3);
    }(e26) && iN(e26)) {
      var o2 = i2.getFirstTokenBetween(e26.left, e26.right, function(e27) {
        return e27.value === "+";
      }), s2 = t2(e26.left, o2), u2 = t2(o2, e26.right), c2 = function(e27) {
        return e27.type === "BinaryExpression" ? aN(e27.right) : e27.type === "TemplateLiteral" ? e27.expressions.length && e27.quasis.length && e27.quasis[e27.quasis.length - 1].range[0] === e27.quasis[e27.quasis.length - 1].range[1] : e27.type !== "Literal" || typeof e27.value != "string";
      }(e26.left), l2 = aN(e26.right);
      return c2 ? r2(e26.left, n3, s2 + u2).slice(0, -1) + r2(e26.right, null, a3).slice(1) : l2 ? r2(e26.left, n3, null).slice(0, -1) + r2(e26.right, s2 + u2, a3).slice(1) : "".concat(r2(e26.left, n3, null)).concat(s2, "+").concat(u2).concat(r2(e26.right, a3, null));
    }
    return "`${".concat(n3 || "").concat(i2.getText(e26)).concat(a3 || "", "}`");
  }
  function n2(t3) {
    if (LA.isStringLiteral(t3) && tN(t3.parent)) {
      var n3 = rN(t3.parent);
      a2[n3.range[0]] || (a2[n3.range[0]] = true, iN(n3) && e25.report({ node: n3, message: "Unexpected string concatenation.", fix: function(e26) {
        return function(e27, t4) {
          var n4 = rN(t4.parent);
          return nN(n4) ? null : e27.replaceText(n4, r2(n4, null, null));
        }(e26, t3);
      } }));
    }
  }
  var i2 = e25.getSourceCode(), a2 = Object.create(null);
  return { Program: function() {
    a2 = Object.create(null);
  }, Literal: n2, TemplateLiteral: n2 };
} }, sN = { meta: { type: "suggestion", docs: { description: "require quotes around object literal property names", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/quote-props" }, schema: { anyOf: [{ type: "array", items: [{ enum: ["always", "as-needed", "consistent", "consistent-as-needed"] }], minItems: 0, maxItems: 1 }, { type: "array", items: [{ enum: ["always", "as-needed", "consistent", "consistent-as-needed"] }, { type: "object", properties: { keywords: { type: "boolean" }, unnecessary: { type: "boolean" }, numbers: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] }, fixable: "code" }, create: function(e25) {
  function t2(e26) {
    return 0 <= Aw.indexOf(e26);
  }
  function r2(e26, t3, r3) {
    return t3.length === 1 && t3[0].start === 0 && t3[0].end === e26.length && (0 <= ["Identifier", "Keyword", "Null", "Boolean"].indexOf(t3[0].type) || t3[0].type === "Numeric" && !r3 && +t3[0].value + "" === t3[0].value);
  }
  function n2(e26) {
    return e26.type === "Identifier" ? e26.name : e26.value;
  }
  function i2(e26) {
    return e26.type === "Literal" && typeof e26.value == "string" ? g2.getText(e26) : '"'.concat(e26.type === "Identifier" ? e26.name : e26.value, '"');
  }
  function a2(a3) {
    var o3 = a3.key;
    if (!(a3.method || a3.computed || a3.shorthand))
      if (o3.type === "Literal" && typeof o3.value == "string") {
        var s3;
        try {
          s3 = Fy.espree.tokenize(o3.value);
        } catch (e26) {
          return;
        }
        if (s3.length !== 1)
          return;
        if (t2(s3[0].value) && c2)
          return;
        l2 && r2(o3.value, s3, p2) && e25.report({ node: a3, message: f2, data: { property: o3.value }, fix: function(e26) {
          return e26.replaceText(o3, n2(o3));
        } });
      } else
        c2 && o3.type === "Identifier" && t2(o3.name) ? e25.report({ node: a3, message: m2, data: { property: o3.name }, fix: function(e26) {
          return e26.replaceText(o3, i2(o3));
        } }) : p2 && o3.type === "Literal" && typeof o3.value == "number" && e25.report({ node: a3, message: d2, data: { property: o3.value }, fix: function(e26) {
          return e26.replaceText(o3, i2(o3));
        } });
  }
  function o2(t3) {
    var r3 = t3.key;
    t3.method || t3.computed || t3.shorthand || r3.type === "Literal" && typeof r3.value == "string" || e25.report({ node: t3, message: h2, data: { property: r3.name || r3.value }, fix: function(e26) {
      return e26.replaceText(r3, i2(r3));
    } });
  }
  function s2(a3, o3) {
    var s3 = [], u3 = [], l3 = null, p3 = false;
    a3.properties.forEach(function(e26) {
      var n3 = e26.key;
      if (n3 && !e26.method && !e26.computed && !e26.shorthand) {
        if (n3.type !== "Literal" || typeof n3.value != "string")
          c2 && o3 && n3.type === "Identifier" && t2(n3.name) ? (u3.push(e26), p3 = true, l3 = n3.name) : u3.push(e26);
        else if (s3.push(e26), o3) {
          var i3;
          try {
            i3 = Fy.espree.tokenize(n3.value);
          } catch (e27) {
            return void (p3 = true);
          }
          p3 = p3 || !r2(n3.value, i3) || c2 && t2(i3[0].value);
        }
      }
    }), o3 && s3.length && !p3 ? s3.forEach(function(t3) {
      e25.report({ node: t3, message: "Properties shouldn't be quoted as all quotes are redundant.", fix: function(e26) {
        return e26.replaceText(t3.key, n2(t3.key));
      } });
    }) : u3.length && l3 ? u3.forEach(function(t3) {
      e25.report({ node: t3, message: "Properties should be quoted as '{{property}}' is a reserved word.", data: { property: l3 }, fix: function(e26) {
        return e26.replaceText(t3.key, i2(t3.key));
      } });
    }) : s3.length && u3.length && u3.forEach(function(t3) {
      e25.report({ node: t3, message: "Inconsistently quoted property '{{key}}' found.", data: { key: t3.key.name || t3.key.value }, fix: function(e26) {
        return e26.replaceText(t3.key, i2(t3.key));
      } });
    });
  }
  var u2 = e25.options[0], c2 = e25.options[1] && e25.options[1].keywords, l2 = !e25.options[1] || e25.options[1].unnecessary !== false, p2 = e25.options[1] && e25.options[1].numbers, f2 = "Unnecessarily quoted property '{{property}}' found.", h2 = "Unquoted property '{{property}}' found.", d2 = "Unquoted number literal '{{property}}' used as key.", m2 = "Unquoted reserved word '{{property}}' used as key.", g2 = e25.getSourceCode();
  return { Property: function(e26) {
    u2 !== "always" && u2 || o2(e26), u2 === "as-needed" && a2(e26);
  }, ObjectExpression: function(e26) {
    u2 === "consistent" && s2(e26, false), u2 === "consistent-as-needed" && s2(e26, true);
  } };
} }, uN = { double: { quote: '"', alternateQuote: "'", description: "doublequote" }, single: { quote: "'", alternateQuote: '"', description: "singlequote" }, backtick: { quote: "`", alternateQuote: '"', description: "backtick" } }, cN = /(^|(?:[\0-\[\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))(\\\\)*[]/;
uN.double.convert = uN.single.convert = uN.backtick.convert = function(e25) {
  var t2 = this.quote, r2 = e25[0];
  return t2 === r2 ? e25 : t2 + e25.slice(1, -1).replace(/\\(\$\{|\r\n?|\n|(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))|["'`]|\$\{|(\r\n?|\n)/g, function(e26, n2, i2) {
    return n2 === r2 || r2 === "`" && n2 === "${" ? n2 : e26 === t2 || t2 === "`" && e26 === "${" ? "\\".concat(e26) : i2 && r2 === "`" ? "\\n" : e26;
  }) + t2;
};
var lN = { meta: { type: "layout", docs: { description: "enforce the consistent use of either backticks, double, or single quotes", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/quotes" }, fixable: "code", schema: [{ enum: ["single", "double", "backtick"] }, { anyOf: [{ enum: ["avoid-escape"] }, { type: "object", properties: { avoidEscape: { type: "boolean" }, allowTemplateLiterals: { type: "boolean" } }, additionalProperties: false }] }] }, create: function(e25) {
  function t2(e26) {
    return e26.type === "ExpressionStatement" && e26.expression.type === "Literal" && typeof e26.expression.value == "string";
  }
  function r2(e26) {
    var r3 = e26.parent.parent;
    if (r3.type !== "Program" && (r3.type !== "BlockStatement" || !LA.isFunction(r3.parent)))
      return false;
    for (var n3 = 0; n3 < r3.body.length; ++n3) {
      var i3 = r3.body[n3];
      if (i3 === e26.parent)
        return true;
      if (!t2(i3))
        break;
    }
    return false;
  }
  function n2(e26) {
    var t3 = e26.parent;
    switch (t3.type) {
      case "ExpressionStatement":
        return r2(e26);
      case "Property":
      case "MethodDefinition":
        return t3.key === e26 && !t3.computed;
      case "ImportDeclaration":
      case "ExportNamedDeclaration":
      case "ExportAllDeclaration":
        return t3.source === e26;
      default:
        return false;
    }
  }
  var i2 = e25.options[0], a2 = uN[i2 || "double"], o2 = e25.options[1], s2 = o2 && o2.allowTemplateLiterals === true, u2 = e25.getSourceCode(), c2 = o2 && o2.avoidEscape === true;
  return o2 === "avoid-escape" && (c2 = true), { Literal: function(t3) {
    var r3 = t3.value, o3 = t3.raw;
    if (a2 && typeof r3 == "string") {
      var s3 = i2 === "backtick" && n2(t3) || function(e26) {
        return e26.parent.type === "JSXAttribute" || e26.parent.type === "JSXElement" || e26.parent.type === "JSXFragment";
      }(t3) || LA.isSurroundedBy(o3, a2.quote);
      !s3 && c2 && (s3 = LA.isSurroundedBy(o3, a2.alternateQuote) && 0 <= o3.indexOf(a2.quote)), s3 || e25.report({ node: t3, message: "Strings must use {{description}}.", data: { description: a2.description }, fix: function(e26) {
        return i2 === "backtick" && LA.hasOctalEscapeSequence(o3) ? null : e26.replaceText(t3, a2.convert(t3.raw));
      } });
    }
  }, TemplateLiteral: function(t3) {
    s2 || i2 === "backtick" || function(e26) {
      return e26.parent.type === "TaggedTemplateExpression" && e26 === e26.parent.quasi || (0 < e26.expressions.length || !!(1 <= e26.quasis.length && cN.test(e26.quasis[0].value.raw)));
    }(t3) || e25.report({ node: t3, message: "Strings must use {{description}}.", data: { description: a2.description }, fix: function(e26) {
      return r2(t3) ? null : e26.replaceText(t3, a2.convert(u2.getText(t3)));
    } });
  } };
} }, pN = "always", fN = "as-needed";
function hN(e25) {
  return 1 <= e25.defs.length;
}
var dN = { meta: { type: "suggestion", docs: { description: "enforce the consistent use of the radix argument when using `parseInt()`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/radix" }, schema: [{ enum: ["always", "as-needed"] }] }, create: function(e25) {
  function t2(t3) {
    var n2 = t3.arguments;
    switch (n2.length) {
      case 0:
        e25.report({ node: t3, message: "Missing parameters." });
        break;
      case 1:
        r2 === pN && e25.report({ node: t3, message: "Missing radix parameter." });
        break;
      default:
        r2 === fN && function(e26) {
          return e26.type === "Literal" && e26.value === 10;
        }(n2[1]) ? e25.report({ node: t3, message: "Redundant radix parameter." }) : !function(e26) {
          return !(e26.type === "Literal" && typeof e26.value != "number" || e26.type === "Identifier" && e26.name === "undefined");
        }(n2[1]) && e25.report({ node: t3, message: "Invalid radix parameter." });
    }
  }
  var r2 = e25.options[0] || pN;
  return { "Program:exit": function() {
    var r3, n2 = e25.getScope();
    hN(r3 = LA.getVariableByName(n2, "parseInt")) || r3.references.forEach(function(e26) {
      var r4 = e26.identifier;
      LA.isCallee(r4) && t2(r4.parent);
    }), hN(r3 = LA.getVariableByName(n2, "Number")) || r3.references.forEach(function(e26) {
      var r4 = e26.identifier.parent;
      (function(e27) {
        return e27.type === "MemberExpression" && !e27.computed && e27.property.type === "Identifier" && e27.property.name === "parseInt";
      })(r4) && LA.isCallee(r4) && t2(r4.parent);
    });
  } };
} };
function mN(e25) {
  var t2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Map(), r2 = true, n2 = false, i2 = void 0;
  try {
    for (var a2, o2 = e25.references[Symbol.iterator](); !(r2 = (a2 = o2.next()).done); r2 = true) {
      var s2 = a2.value;
      t2.set(s2.identifier, s2);
    }
  } catch (e26) {
    n2 = true, i2 = e26;
  } finally {
    try {
      r2 || o2.return == null || o2.return();
    } finally {
      if (n2)
        throw i2;
    }
  }
  var u2 = true, c2 = false, l2 = void 0;
  try {
    for (var p2, f2 = e25.childScopes[Symbol.iterator](); !(u2 = (p2 = f2.next()).done); u2 = true) {
      var h2 = p2.value;
      h2.type !== "function" && mN(h2, t2);
    }
  } catch (e26) {
    c2 = true, l2 = e26;
  } finally {
    try {
      u2 || f2.return == null || f2.return();
    } finally {
      if (c2)
        throw l2;
    }
  }
  return t2;
}
var gN = function() {
  function e25() {
    a(this, e25), this.info = new WeakMap();
  }
  return s(e25, [{ key: "initialize", value: function(e26) {
    var t2 = new Set(), r2 = new Set(), n2 = true, i2 = false, a2 = void 0;
    try {
      for (var o2, s2 = e26.prevSegments[Symbol.iterator](); !(n2 = (o2 = s2.next()).done); n2 = true) {
        var u2 = o2.value, c2 = this.info.get(u2);
        c2 && (c2.outdatedReadVariableNames.forEach(Set.prototype.add, t2), c2.freshReadVariableNames.forEach(Set.prototype.add, r2));
      }
    } catch (e27) {
      i2 = true, a2 = e27;
    } finally {
      try {
        n2 || s2.return == null || s2.return();
      } finally {
        if (i2)
          throw a2;
      }
    }
    this.info.set(e26, { outdatedReadVariableNames: t2, freshReadVariableNames: r2 });
  } }, { key: "markAsRead", value: function(e26, t2) {
    var r2 = true, n2 = false, i2 = void 0;
    try {
      for (var a2, o2 = e26[Symbol.iterator](); !(r2 = (a2 = o2.next()).done); r2 = true) {
        var s2 = a2.value, u2 = this.info.get(s2);
        u2 && u2.freshReadVariableNames.add(t2);
      }
    } catch (e27) {
      n2 = true, i2 = e27;
    } finally {
      try {
        r2 || o2.return == null || o2.return();
      } finally {
        if (n2)
          throw i2;
      }
    }
  } }, { key: "makeOutdated", value: function(e26) {
    var t2 = true, r2 = false, n2 = void 0;
    try {
      for (var i2, a2 = e26[Symbol.iterator](); !(t2 = (i2 = a2.next()).done); t2 = true) {
        var o2 = i2.value, s2 = this.info.get(o2);
        s2 && (s2.freshReadVariableNames.forEach(Set.prototype.add, s2.outdatedReadVariableNames), s2.freshReadVariableNames.clear());
      }
    } catch (e27) {
      r2 = true, n2 = e27;
    } finally {
      try {
        t2 || a2.return == null || a2.return();
      } finally {
        if (r2)
          throw n2;
      }
    }
  } }, { key: "isOutdated", value: function(e26, t2) {
    var r2 = true, n2 = false, i2 = void 0;
    try {
      for (var a2, o2 = e26[Symbol.iterator](); !(r2 = (a2 = o2.next()).done); r2 = true) {
        var s2 = a2.value, u2 = this.info.get(s2);
        if (u2 && u2.outdatedReadVariableNames.has(t2))
          return true;
      }
    } catch (e27) {
      n2 = true, i2 = e27;
    } finally {
      try {
        r2 || o2.return == null || o2.return();
      } finally {
        if (n2)
          throw i2;
      }
    }
    return false;
  } }]), e25;
}(), yN = { meta: { type: "problem", docs: { description: "disallow assignments that can lead to race conditions due to usage of `await` or `yield`", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/require-atomic-updates" }, fixable: null, schema: [], messages: { nonAtomicUpdate: "Possible race condition: `{{value}}` might be reassigned based on an outdated value of `{{value}}`." } }, create: function(e25) {
  var t2 = e25.getSourceCode(), r2 = new Map(), n2 = new gN(), i2 = null;
  return { onCodePathStart: function(t3) {
    var r3 = e25.getScope(), n3 = r3.type === "function" && (r3.block.async || r3.block.generator);
    i2 = { upper: i2, codePath: t3, referenceMap: n3 ? mN(r3) : null };
  }, onCodePathEnd: function() {
    i2 = i2.upper;
  }, onCodePathSegmentStart: function(e26) {
    n2.initialize(e26);
  }, Identifier: function(e26) {
    var t3 = i2, a2 = t3.codePath, o2 = t3.referenceMap, s2 = o2 && o2.get(e26);
    if (s2) {
      var u2 = s2.identifier.name, c2 = s2.resolved, l2 = function(e27) {
        if (e27.writeExpr)
          return e27.writeExpr;
        for (var t4 = e27.identifier; t4; ) {
          var r3 = t4.parent.type;
          if (r3 === "AssignmentExpression" && t4.parent.left === t4)
            return t4.parent.right;
          if (r3 !== "MemberExpression" || t4.parent.object !== t4)
            break;
          t4 = t4.parent;
        }
        return null;
      }(s2), p2 = s2.identifier.parent.type === "MemberExpression";
      if (s2.isRead() && !(l2 && l2.parent.operator === "=") && n2.markAsRead(a2.currentSegments, u2), l2 && l2.parent.right === l2 && !function(e27, t4) {
        if (!e27)
          return false;
        if (t4 && e27.defs.some(function(e28) {
          return e28.type === "Parameter";
        }))
          return false;
        var r3 = e27.scope.variableScope;
        return e27.references.every(function(e28) {
          return e28.from.variableScope === r3;
        });
      }(c2, p2)) {
        var f2 = r2.get(l2);
        f2 || (f2 = [], r2.set(l2, f2)), f2.push(s2);
      }
    }
  }, ":expression:exit": function(a2) {
    var o2 = i2, s2 = o2.codePath;
    if (o2.referenceMap) {
      (a2.type === "AwaitExpression" || a2.type === "YieldExpression") && n2.makeOutdated(s2.currentSegments);
      var u2 = r2.get(a2);
      if (u2) {
        r2.delete(a2);
        var c2 = true, l2 = false, p2 = void 0;
        try {
          for (var f2, h2 = u2[Symbol.iterator](); !(c2 = (f2 = h2.next()).done); c2 = true) {
            var d2 = f2.value.identifier.name;
            n2.isOutdated(s2.currentSegments, d2) && e25.report({ node: a2.parent, messageId: "nonAtomicUpdate", data: { value: t2.getText(a2.parent.left) } });
          }
        } catch (e26) {
          l2 = true, p2 = e26;
        } finally {
          try {
            c2 || h2.return == null || h2.return();
          } finally {
            if (l2)
              throw p2;
          }
        }
      }
    }
  } };
} };
function vN(e25) {
  return e25[0].toUpperCase() + e25.slice(1);
}
var xN = { meta: { type: "suggestion", docs: { description: "disallow async functions which have no `await` expression", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/require-await" }, schema: [] }, create: function(e25) {
  function t2() {
    i2 = { upper: i2, hasAwait: false };
  }
  function r2(t3) {
    !t3.async || i2.hasAwait || LA.isEmptyFunction(t3) || e25.report({ node: t3, loc: LA.getFunctionHeadLoc(t3, n2), message: "{{name}} has no 'await' expression.", data: { name: vN(LA.getFunctionNameWithKind(t3)) } }), i2 = i2.upper;
  }
  var n2 = e25.getSourceCode(), i2 = null;
  return { FunctionDeclaration: t2, FunctionExpression: t2, ArrowFunctionExpression: t2, "FunctionDeclaration:exit": r2, "FunctionExpression:exit": r2, "ArrowFunctionExpression:exit": r2, AwaitExpression: function() {
    i2 && (i2.hasAwait = true);
  }, ForOfStatement: function(e26) {
    !i2 || e26.await && (i2.hasAwait = true);
  } };
} }, bN = { meta: { type: "suggestion", docs: { description: "require JSDoc comments", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/require-jsdoc" }, schema: [{ type: "object", properties: { require: { type: "object", properties: { ClassDeclaration: { type: "boolean", default: false }, MethodDefinition: { type: "boolean", default: false }, FunctionDeclaration: { type: "boolean", default: true }, ArrowFunctionExpression: { type: "boolean", default: false }, FunctionExpression: { type: "boolean", default: false } }, additionalProperties: false, default: {} } }, additionalProperties: false }], deprecated: true, replacedBy: [] }, create: function(e25) {
  function t2(t3) {
    e25.report({ node: t3, message: "Missing JSDoc comment." });
  }
  function r2(e26) {
    n2.getJSDocComment(e26) || t2(e26);
  }
  var n2 = e25.getSourceCode(), i2 = Object.assign({ FunctionDeclaration: true, MethodDefinition: false, ClassDeclaration: false, ArrowFunctionExpression: false, FunctionExpression: false }, e25.options[0] && e25.options[0].require);
  return { FunctionDeclaration: function(e26) {
    i2.FunctionDeclaration && r2(e26);
  }, FunctionExpression: function(e26) {
    (i2.MethodDefinition && e26.parent.type === "MethodDefinition" || i2.FunctionExpression && (e26.parent.type === "VariableDeclarator" || e26.parent.type === "Property" && e26 === e26.parent.value)) && r2(e26);
  }, ClassDeclaration: function(e26) {
    i2.ClassDeclaration && r2(e26);
  }, ArrowFunctionExpression: function(e26) {
    i2.ArrowFunctionExpression && e26.parent.type === "VariableDeclarator" && r2(e26);
  } };
} }, EN = Fy.require$$0, CN = EN.CALL, SN = EN.CONSTRUCT, kN = EN.ReferenceTracker, DN = EN.getStringIfConstant, FN = { meta: { type: "suggestion", docs: { description: "enforce the use of `u` flag on RegExp", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/require-unicode-regexp" }, messages: { requireUFlag: "Use the 'u' flag." }, schema: [] }, create: function(e25) {
  return { "Literal[regex]": function(t2) {
    (t2.regex.flags || "").includes("u") || e25.report({ node: t2, messageId: "requireUFlag" });
  }, Program: function() {
    var t2, r2 = e25.getScope(), n2 = new kN(r2), i2 = { RegExp: (t2 = {}, u(t2, CN, true), u(t2, SN, true), t2) }, a2 = true, o2 = false, s2 = void 0;
    try {
      for (var c2, l2 = n2.iterateGlobalReferences(i2)[Symbol.iterator](); !(a2 = (c2 = l2.next()).done); a2 = true) {
        var p2 = c2.value.node, f2 = p2.arguments[1], h2 = DN(f2, r2);
        f2 && (typeof h2 != "string" || h2.includes("u")) || e25.report({ node: p2, messageId: "requireUFlag" });
      }
    } catch (e26) {
      o2 = true, s2 = e26;
    } finally {
      try {
        a2 || l2.return == null || l2.return();
      } finally {
        if (o2)
          throw s2;
      }
    }
  } };
} }, AN = { meta: { type: "layout", docs: { description: "enforce consistent spacing before and after semicolons", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/semi-spacing" }, fixable: "whitespace", schema: [{ type: "object", properties: { before: { type: "boolean", default: false }, after: { type: "boolean", default: true } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3, r3) {
    if (LA.isSemicolonToken(t3)) {
      var n3 = t3.loc.start;
      !function(e26) {
        var t4 = a2.getTokenBefore(e26);
        return t4 && LA.isTokenOnSameLine(t4, e26) && a2.isSpaceBetweenTokens(t4, e26);
      }(t3) ? o2 && e25.report({ node: r3, loc: n3, message: "Missing whitespace before semicolon.", fix: function(e26) {
        return e26.insertTextBefore(t3, " ");
      } }) : !o2 && e25.report({ node: r3, loc: n3, message: "Unexpected whitespace before semicolon.", fix: function(e26) {
        var r4 = a2.getTokenBefore(t3);
        return e26.removeRange([r4.range[1], t3.range[0]]);
      } }), function(e26) {
        var t4 = a2.getTokenBefore(e26);
        return !(t4 && LA.isTokenOnSameLine(e26, t4));
      }(t3) || function(e26) {
        var t4 = a2.getTokenAfter(e26);
        return !(t4 && LA.isTokenOnSameLine(e26, t4));
      }(t3) || function(e26) {
        var t4 = a2.getTokenAfter(e26);
        return t4 && LA.isClosingBraceToken(t4) || LA.isClosingParenToken(t4);
      }(t3) || (function(e26) {
        var t4 = a2.getTokenAfter(e26);
        return t4 && LA.isTokenOnSameLine(e26, t4) && a2.isSpaceBetweenTokens(e26, t4);
      }(t3) ? !s2 && e25.report({ node: r3, loc: n3, message: "Unexpected whitespace after semicolon.", fix: function(e26) {
        var r4 = a2.getTokenAfter(t3);
        return e26.removeRange([t3.range[1], r4.range[0]]);
      } }) : s2 && e25.report({ node: r3, loc: n3, message: "Missing whitespace after semicolon.", fix: function(e26) {
        return e26.insertTextAfter(t3, " ");
      } }));
    }
  }
  function r2(e26) {
    t2(a2.getLastToken(e26), e26);
  }
  var n2 = e25.options[0], a2 = e25.getSourceCode(), o2 = false, s2 = true;
  return i(n2) == "object" && (o2 = n2.before, s2 = n2.after), { VariableDeclaration: r2, ExpressionStatement: r2, BreakStatement: r2, ContinueStatement: r2, DebuggerStatement: r2, ReturnStatement: r2, ThrowStatement: r2, ImportDeclaration: r2, ExportNamedDeclaration: r2, ExportAllDeclaration: r2, ExportDefaultDeclaration: r2, ForStatement: function(e26) {
    e26.init && t2(a2.getTokenAfter(e26.init), e26), e26.test && t2(a2.getTokenAfter(e26.test), e26);
  } };
} }, wN = ":matches(".concat("BreakStatement,ContinueStatement,DebuggerStatement,DoWhileStatement,ExportAllDeclaration,ExportDefaultDeclaration,ExportNamedDeclaration,ExpressionStatement,ImportDeclaration,ReturnStatement,ThrowStatement,VariableDeclaration", ")");
var _N = { asc: function(e25, t2) {
  return e25 <= t2;
}, ascI: function(e25, t2) {
  return e25.toLowerCase() <= t2.toLowerCase();
}, ascN: function(e25, t2) {
  return 0 >= BA(e25, t2);
}, ascIN: function(e25, t2) {
  return 0 >= BA(e25.toLowerCase(), t2.toLowerCase());
}, desc: function(e25, t2) {
  return _N.asc(t2, e25);
}, descI: function(e25, t2) {
  return _N.ascI(t2, e25);
}, descN: function(e25, t2) {
  return _N.ascN(t2, e25);
}, descIN: function(e25, t2) {
  return _N.ascIN(t2, e25);
} };
function TN(e25) {
  return "(?:".concat(Fy.lodash.escapeRegExp(e25), ")");
}
function PN(e25) {
  return "".concat(TN(e25), "+");
}
function IN(e25) {
  var t2 = "";
  return e25.length === 0 ? t2 += "\\s" : (t2 += "(?:\\s|", e25.length === 1 ? t2 += PN(e25[0]) : (t2 += "(?:", t2 += e25.map(PN).join("|"), t2 += ")"), t2 += "(?:$|[".concat(Array.from(LA.LINEBREAKS).join(""), "]))")), t2;
}
function BN(e25, t2) {
  var r2 = "^";
  return e25.length === 1 ? r2 += TN(e25[0]) : (r2 += "(?:", r2 += e25.map(TN).join("|"), r2 += ")"), r2 += "?", r2 += IN(t2), new RegExp(r2, "u");
}
function ON(e25) {
  var t2 = "^(".concat(e25.map(TN).join("|"), ")?[ 	]+");
  return new RegExp(t2, "u");
}
function LN(e25) {
  for (var t2 = [], r2 = 0; r2 < e25.length; r2++) {
    var n2 = e25[r2];
    if (n2.type !== "ExpressionStatement" || n2.expression.type !== "Literal" || n2.expression.value !== "use strict")
      break;
    t2[r2] = n2;
  }
  return t2;
}
function NN(e25) {
  return e25.type === "Identifier";
}
function jN(e25) {
  return e25.every(NN);
}
var RN = /\$\{$/, MN = /^\}/;
function VN(e25) {
  return !!e25 && e25.type === "Identifier" && e25.name === "NaN";
}
function UN(e25) {
  return 0 <= ["<", "<="].indexOf(e25);
}
function qN(e25) {
  return e25.type === "UnaryExpression" && e25.operator === "-" && e25.prefix && e25.argument.type === "Literal" && typeof e25.argument.value == "number";
}
function WN(e25, t2) {
  return e25.type === "Literal" ? e25 : qN(e25) ? { type: "Literal", value: -e25.argument.value, raw: "-".concat(e25.argument.value) } : t2 ? { type: "Literal", value: t2, raw: t2 + "" } : null;
}
function $N(e25, t2) {
  if (e25.type !== t2.type)
    return false;
  switch (e25.type) {
    case "Identifier":
      return e25.name === t2.name;
    case "Literal":
      return e25.value === t2.value;
    case "MemberExpression":
      var r2 = LA.getStaticPropertyName(e25);
      return r2 === null ? e25.computed === t2.computed && $N(e25.object, t2.object) && $N(e25.property, t2.property) : $N(e25.object, t2.object) && r2 === LA.getStaticPropertyName(t2);
    case "ThisExpression":
      return true;
    default:
      return false;
  }
}
var GN = { "accessor-pairs": MA, "array-bracket-newline": VA, "array-bracket-spacing": UA, "array-callback-return": KA, "array-element-newline": JA, "arrow-body-style": QA, "arrow-parens": YA, "arrow-spacing": ZA, "block-scoped-var": { meta: { type: "suggestion", docs: { description: "enforce the use of variables within the scope they are defined", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/block-scoped-var" }, schema: [], messages: { outOfScope: "'{{name}}' used outside of binding context." } }, create: function(e25) {
  function t2(e26) {
    i2.push(e26.range);
  }
  function r2() {
    i2.pop();
  }
  function n2(t3) {
    var r3 = t3.identifier;
    e25.report({ node: r3, messageId: "outOfScope", data: { name: r3.name } });
  }
  var i2 = [];
  return { Program: function(e26) {
    i2 = [e26.range];
  }, BlockStatement: t2, "BlockStatement:exit": r2, ForStatement: t2, "ForStatement:exit": r2, ForInStatement: t2, "ForInStatement:exit": r2, ForOfStatement: t2, "ForOfStatement:exit": r2, SwitchStatement: t2, "SwitchStatement:exit": r2, CatchClause: t2, "CatchClause:exit": r2, VariableDeclaration: function(t3) {
    function r3(e26) {
      var t4 = e26.identifier.range;
      return t4[0] < a2[0] || t4[1] > a2[1];
    }
    if (t3.kind === "var")
      for (var a2 = i2[i2.length - 1], o2 = e25.getDeclaredVariables(t3), s2 = 0; s2 < o2.length; ++s2)
        o2[s2].references.filter(r3).forEach(n2);
  } };
} }, "block-spacing": ew, "brace-style": tw, "callback-return": { meta: { type: "suggestion", docs: { description: "require `return` statements after callbacks", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/callback-return" }, schema: [{ type: "array", items: { type: "string" } }], messages: { missingReturn: "Expected return with your callback function." } }, create: function(e25) {
  function t2(e26, r3) {
    return e26.parent ? r3.indexOf(e26.parent.type) === -1 ? t2(e26.parent, r3) : e26.parent : null;
  }
  function r2(e26) {
    return function e27(t3) {
      if (t3.type === "Identifier")
        return true;
      if (t3.type === "MemberExpression") {
        if (t3.object.type === "Identifier")
          return true;
        if (t3.object.type === "MemberExpression")
          return e27(t3.object);
      }
      return false;
    }(e26.callee) && -1 < i2.indexOf(a2.getText(e26.callee));
  }
  function n2(e26, t3) {
    return !(!t3 || t3.type !== "ExpressionStatement" || t3.expression !== e26 && (t3.expression.type !== "BinaryExpression" && t3.expression.type !== "LogicalExpression" || t3.expression.right !== e26));
  }
  var i2 = e25.options[0] || ["callback", "cb", "next"], a2 = e25.getSourceCode();
  return { CallExpression: function(i3) {
    if (r2(i3)) {
      var a3 = t2(i3, ["BlockStatement", "ReturnStatement", "ArrowFunctionExpression"]) || {};
      if (a3.type !== "ReturnStatement" && a3.type !== "ArrowFunctionExpression") {
        if (a3.type === "BlockStatement") {
          var o2 = a3.body[a3.body.length - 1];
          if (n2(i3, o2)) {
            var s2 = a3.parent.type;
            if (s2 === "FunctionExpression" || s2 === "FunctionDeclaration" || s2 === "ArrowFunctionExpression")
              return;
          }
          if (o2.type === "ReturnStatement" && n2(i3, a3.body[a3.body.length - 2]))
            return;
        }
        t2(i3, ["FunctionDeclaration", "FunctionExpression", "ArrowFunctionExpression"]) && e25.report({ node: i3, messageId: "missingReturn" });
      }
    }
  } };
} }, camelcase: rw, "capitalized-comments": lw, "class-methods-use-this": pw, "comma-dangle": hw, "comma-spacing": dw, "comma-style": mw, complexity: gw, "computed-property-spacing": yw, "consistent-return": xw, "consistent-this": { meta: { type: "suggestion", docs: { description: "enforce consistent naming when capturing the current execution context", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/consistent-this" }, schema: { type: "array", items: { type: "string", minLength: 1 }, uniqueItems: true }, messages: { aliasNotAssignedToThis: "Designated alias '{{name}}' is not assigned to 'this'.", unexpectedAlias: "Unexpected alias '{{name}}' for 'this'." } }, create: function(e25) {
  function t2(t3, r3) {
    e25.report({ node: t3, messageId: "aliasNotAssignedToThis", data: { name: r3 } });
  }
  function r2(r3, n3, i3) {
    var o2 = i3.type === "ThisExpression";
    a2.indexOf(n3) === -1 ? o2 && e25.report({ node: r3, messageId: "unexpectedAlias", data: { name: n3 } }) : (!o2 || r3.operator && r3.operator !== "=") && t2(r3, n3);
  }
  function n2(e26, r3) {
    var n3 = r3.set.get(e26);
    n3 && !n3.defs.some(function(e27) {
      return e27.node.type === "VariableDeclarator" && e27.node.init !== null;
    }) && (n3.references.some(function(e27) {
      var t3 = e27.writeExpr;
      return e27.from === r3 && t3 && t3.type === "ThisExpression" && t3.parent.operator === "=";
    }) || n3.defs.map(function(e27) {
      return e27.node;
    }).forEach(function(r4) {
      t2(r4, e26);
    }));
  }
  function i2() {
    var t3 = e25.getScope();
    a2.forEach(function(e26) {
      n2(e26, t3);
    });
  }
  var a2 = [];
  return e25.options.length === 0 ? a2.push("that") : a2 = e25.options, { "Program:exit": i2, "FunctionExpression:exit": i2, "FunctionDeclaration:exit": i2, VariableDeclarator: function(e26) {
    var t3 = e26.id, n3 = t3.type === "ArrayPattern" || t3.type === "ObjectPattern";
    e26.init === null || n3 || r2(e26, t3.name, e26.init);
  }, AssignmentExpression: function(e26) {
    e26.left.type === "Identifier" && r2(e26, e26.left.name, e26.right);
  } };
} }, "constructor-super": Cw, curly: Sw, "default-case": Dw, "default-param-last": { meta: { type: "suggestion", docs: { description: "enforce default parameters to be last", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/default-param-last" }, schema: [], messages: { shouldBeLast: "Default parameters should be last." } }, create: function(e25) {
  function t2(t3) {
    for (var r2 = false, n2 = t3.params.length - 1; 0 <= n2; n2 -= 1) {
      var i2 = t3.params[n2];
      i2.type === "AssignmentPattern" || i2.type === "RestElement" ? r2 && i2.type === "AssignmentPattern" && e25.report({ node: i2, messageId: "shouldBeLast" }) : r2 = true;
    }
  }
  return { FunctionDeclaration: t2, FunctionExpression: t2, ArrowFunctionExpression: t2 };
} }, "dot-location": Fw, "dot-notation": Tw, "eol-last": Pw, eqeqeq: Iw, "for-direction": { meta: { type: "problem", docs: { description: 'enforce "for" loop update clause moving the counter in the right direction.', category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/for-direction" }, fixable: null, schema: [], messages: { incorrectDirection: "The update clause in this loop moves the variable in the wrong direction." } }, create: function(e25) {
  function t2(t3) {
    e25.report({ node: t3, messageId: "incorrectDirection" });
  }
  function r2(e26, t3) {
    if (e26.right.type === "UnaryExpression") {
      if (e26.right.operator === "-")
        return -t3;
    } else if (e26.right.type === "Identifier")
      return 0;
    return t3;
  }
  return { ForStatement: function(e26) {
    if (e26.test && e26.test.type === "BinaryExpression" && e26.test.left.type === "Identifier" && e26.update) {
      var n2, i2 = e26.test.left.name, a2 = e26.test.operator, o2 = e26.update;
      if (a2 === "<" || a2 === "<=")
        n2 = -1;
      else {
        if (a2 !== ">" && a2 !== ">=")
          return;
        n2 = 1;
      }
      o2.type === "UpdateExpression" ? function(e27, t3) {
        if (e27.argument.type === "Identifier" && e27.argument.name === t3) {
          if (e27.operator === "++")
            return 1;
          if (e27.operator === "--")
            return -1;
        }
        return 0;
      }(o2, i2) === n2 && t2(e26) : o2.type === "AssignmentExpression" && function(e27, t3) {
        if (e27.left.name === t3) {
          if (e27.operator === "+=")
            return r2(e27, 1);
          if (e27.operator === "-=")
            return r2(e27, -1);
        }
        return 0;
      }(o2, i2) === n2 && t2(e26);
    }
  } };
} }, "func-call-spacing": Bw, "func-name-matching": Nw, "func-names": jw, "func-style": { meta: { type: "suggestion", docs: { description: "enforce the consistent use of either `function` declarations or expressions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/func-style" }, schema: [{ enum: ["declaration", "expression"] }, { type: "object", properties: { allowArrowFunctions: { type: "boolean", default: false } }, additionalProperties: false }], messages: { expression: "Expected a function expression.", declaration: "Expected a function declaration." } }, create: function(e25) {
  var t2 = e25.options[0], r2 = e25.options[1] && e25.options[1].allowArrowFunctions, n2 = t2 === "declaration", i2 = [], a2 = { FunctionDeclaration: function(t3) {
    i2.push(false), n2 || t3.parent.type === "ExportDefaultDeclaration" || e25.report({ node: t3, messageId: "expression" });
  }, "FunctionDeclaration:exit": function() {
    i2.pop();
  }, FunctionExpression: function(t3) {
    i2.push(false), n2 && t3.parent.type === "VariableDeclarator" && e25.report({ node: t3.parent, messageId: "declaration" });
  }, "FunctionExpression:exit": function() {
    i2.pop();
  }, ThisExpression: function() {
    0 < i2.length && (i2[i2.length - 1] = true);
  } };
  return r2 || (a2.ArrowFunctionExpression = function() {
    i2.push(false);
  }, a2["ArrowFunctionExpression:exit"] = function(t3) {
    var r3 = i2.pop();
    n2 && !r3 && t3.parent.type === "VariableDeclarator" && e25.report({ node: t3.parent, messageId: "declaration" });
  }), a2;
} }, "function-call-argument-newline": { meta: { type: "layout", docs: { description: "enforce line breaks between arguments of a function call", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/function-call-argument-newline" }, fixable: "whitespace", schema: [{ enum: ["always", "never", "consistent"] }], messages: { unexpectedLineBreak: "There should be no line break here.", missingLineBreak: "There should be a line break after this argument." } }, create: function(e25) {
  function t2(t3, r3) {
    for (var i3 = 1; i3 < t3.arguments.length; i3++) {
      var a2 = n2.getLastToken(t3.arguments[i3 - 1]), o2 = n2.getFirstToken(t3.arguments[i3]);
      if (r3.check(a2, o2)) {
        var s2 = n2.getTokenBefore(o2, { includeComments: true }), u2 = s2.type === "Line";
        e25.report({ node: t3, loc: { start: s2.loc.end, end: o2.loc.start }, messageId: r3.messageId, fix: u2 ? null : r3.createFix(o2, s2) });
      }
    }
  }
  function r2(r3) {
    if (!(2 > r3.arguments.length)) {
      var a2 = e25.options[0] || "always";
      if (a2 === "never")
        t2(r3, i2.unexpected);
      else if (a2 === "always")
        t2(r3, i2.missing);
      else if (a2 === "consistent") {
        var o2 = n2.getLastToken(r3.arguments[0]), s2 = n2.getFirstToken(r3.arguments[1]);
        o2.loc.end.line === s2.loc.start.line ? t2(r3, i2.unexpected) : t2(r3, i2.missing);
      }
    }
  }
  var n2 = e25.getSourceCode(), i2 = { unexpected: { messageId: "unexpectedLineBreak", check: function(e26, t3) {
    return e26.loc.end.line !== t3.loc.start.line;
  }, createFix: function(e26, t3) {
    return function(r3) {
      return r3.replaceTextRange([t3.range[1], e26.range[0]], " ");
    };
  } }, missing: { messageId: "missingLineBreak", check: function(e26, t3) {
    return e26.loc.end.line === t3.loc.start.line;
  }, createFix: function(e26, t3) {
    return function(r3) {
      return r3.replaceTextRange([t3.range[1], e26.range[0]], "\n");
    };
  } } };
  return { CallExpression: r2, NewExpression: r2 };
} }, "function-paren-newline": Rw, "generator-star-spacing": Vw, "getter-return": $w, "global-require": zw, "grouped-accessor-pairs": Kw, "guard-for-in": { meta: { type: "suggestion", docs: { description: "require `for-in` loops to include an `if` statement", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/guard-for-in" }, schema: [], messages: { wrap: "The body of a for-in should be wrapped in an if statement to filter unwanted properties from the prototype." } }, create: function(e25) {
  return { ForInStatement: function(t2) {
    var r2 = t2.body;
    if (!(r2.type === "EmptyStatement" || r2.type === "IfStatement" || r2.type === "BlockStatement" && r2.body.length === 0 || r2.type === "BlockStatement" && r2.body.length === 1 && r2.body[0].type === "IfStatement")) {
      if (r2.type === "BlockStatement" && 1 <= r2.body.length && r2.body[0].type === "IfStatement") {
        var n2 = r2.body[0];
        if (n2.consequent.type === "ContinueStatement")
          return;
        if (n2.consequent.type === "BlockStatement" && n2.consequent.body.length === 1 && n2.consequent.body[0].type === "ContinueStatement")
          return;
      }
      e25.report({ node: t2, messageId: "wrap" });
    }
  } };
} }, "handle-callback-err": Jw, "id-blacklist": { meta: { type: "suggestion", docs: { description: "disallow specified identifiers", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/id-blacklist" }, schema: { type: "array", items: { type: "string" }, uniqueItems: true }, messages: { blacklisted: "Identifier '{{name}}' is blacklisted." } }, create: function(e25) {
  function t2(e26) {
    return i2.indexOf(e26) !== -1;
  }
  function r2(e26, r3) {
    return e26.type !== "CallExpression" && e26.type !== "NewExpression" && t2(r3);
  }
  function n2(t3) {
    e25.report({ node: t3, messageId: "blacklisted", data: { name: t3.name } });
  }
  var i2 = e25.options;
  return { Identifier: function(e26) {
    var i3 = e26.name, a2 = e26.parent.type === "MemberExpression" ? e26.parent.parent : e26.parent;
    e26.parent.type === "MemberExpression" ? e26.parent.object.type === "Identifier" && e26.parent.object.name === e26.name ? t2(i3) && n2(e26) : a2.type === "AssignmentExpression" && (a2.right.type !== "MemberExpression" || a2.left.type === "MemberExpression" && a2.left.property.name === e26.name) && t2(i3) && n2(e26) : (e26.parent.type, r2(a2, i3) && n2(e26));
  } };
} }, "id-length": { meta: { type: "suggestion", docs: { description: "enforce minimum and maximum identifier lengths", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/id-length" }, schema: [{ type: "object", properties: { min: { type: "integer", default: 2 }, max: { type: "integer" }, exceptions: { type: "array", uniqueItems: true, items: { type: "string" } }, properties: { enum: ["always", "never"] } }, additionalProperties: false }], messages: { tooShort: "Identifier name '{{name}}' is too short (< {{min}}).", tooLong: "Identifier name '{{name}}' is too long (> {{max}})." } }, create: function(e25) {
  var t2 = e25.options[0] || {}, r2 = t2.min === void 0 ? 2 : t2.min, n2 = t2.max === void 0 ? 1 / 0 : t2.max, i2 = t2.properties !== "never", a2 = (t2.exceptions ? t2.exceptions : []).reduce(function(e26, t3) {
    return e26[t3] = true, e26;
  }, {}), o2 = { MemberExpression: i2 && function(e26) {
    return !e26.computed && (e26.parent.left === e26 && e26.parent.type === "AssignmentExpression" || e26.parent.type === "Property" && e26.parent.value === e26 && e26.parent.parent.type === "ObjectPattern" && e26.parent.parent.parent.left === e26.parent.parent);
  }, AssignmentPattern: function(e26, t3) {
    return e26.left === t3;
  }, VariableDeclarator: function(e26, t3) {
    return e26.id === t3;
  }, Property: i2 && function(e26, t3) {
    return e26.key === t3;
  }, ImportDefaultSpecifier: true, RestElement: true, FunctionExpression: true, ArrowFunctionExpression: true, ClassDeclaration: true, FunctionDeclaration: true, MethodDefinition: true, CatchClause: true };
  return { Identifier: function(t3) {
    var i3 = t3.name, s2 = t3.parent, u2 = i3.length < r2, c2 = i3.length > n2;
    if ((u2 || c2) && !a2[i3]) {
      var l2 = o2[s2.type];
      l2 && (l2 === true || l2(s2, t3)) && e25.report({ node: t3, messageId: u2 ? "tooShort" : "tooLong", data: { name: i3, min: r2, max: n2 } });
    }
  } };
} }, "id-match": Qw, "implicit-arrow-linebreak": Zw, "indent-legacy": e_, indent: o_, "init-declarations": c_, "jsx-quotes": p_, "key-spacing": m_, "keyword-spacing": F_, "line-comment-position": A_, "linebreak-style": w_, "lines-around-comment": __, "lines-around-directive": T_, "lines-between-class-members": P_, "max-classes-per-file": { meta: { type: "suggestion", docs: { description: "enforce a maximum number of classes per file", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/max-classes-per-file" }, schema: [{ type: "integer", minimum: 1 }], messages: { maximumExceeded: "File has too many classes ({{ classCount }}). Maximum allowed is {{ max }}." } }, create: function(e25) {
  var t2 = e25.options[0] || 1, r2 = 0;
  return { Program: function() {
    r2 = 0;
  }, "Program:exit": function(n2) {
    r2 > t2 && e25.report({ node: n2, messageId: "maximumExceeded", data: { classCount: r2, max: t2 } });
  }, "ClassDeclaration, ClassExpression": function() {
    r2++;
  } };
} }, "max-depth": I_, "max-len": L_, "max-lines-per-function": N_, "max-lines": j_, "max-nested-callbacks": R_, "max-params": M_, "max-statements-per-line": V_, "max-statements": U_, "multiline-comment-style": q_, "multiline-ternary": W_, "new-cap": H_, "new-parens": K_, "newline-after-var": J_, "newline-before-return": Q_, "newline-per-chained-call": X_, "no-alert": tT, "no-array-constructor": { meta: { type: "suggestion", docs: { description: "disallow `Array` constructors", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-array-constructor" }, schema: [], messages: { preferLiteral: "The array literal notation [] is preferable." } }, create: function(e25) {
  function t2(t3) {
    t3.arguments.length !== 1 && t3.callee.type === "Identifier" && t3.callee.name === "Array" && e25.report({ node: t3, messageId: "preferLiteral" });
  }
  return { CallExpression: t2, NewExpression: t2 };
} }, "no-async-promise-executor": { meta: { type: "problem", docs: { description: "disallow using an async function as a Promise executor", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-async-promise-executor" }, fixable: null, schema: [], messages: { async: "Promise executor functions should not be async." } }, create: function(e25) {
  return { "NewExpression[callee.name='Promise'][arguments.0.async=true]": function(t2) {
    e25.report({ node: e25.getSourceCode().getFirstToken(t2.arguments[0], function(e26) {
      return e26.value === "async";
    }), messageId: "async" });
  } };
} }, "no-await-in-loop": iT, "no-bitwise": oT, "no-buffer-constructor": { meta: { type: "problem", docs: { description: "disallow use of the `Buffer()` constructor", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-buffer-constructor" }, schema: [], messages: { deprecated: "{{expr}} is deprecated. Use Buffer.from(), Buffer.alloc(), or Buffer.allocUnsafe() instead." } }, create: function(e25) {
  return { "CallExpression[callee.name='Buffer'], NewExpression[callee.name='Buffer']": function(t2) {
    e25.report({ node: t2, messageId: "deprecated", data: { expr: t2.type === "CallExpression" ? "Buffer()" : "new Buffer()" } });
  } };
} }, "no-caller": { meta: { type: "suggestion", docs: { description: "disallow the use of `arguments.caller` or `arguments.callee`", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-caller" }, schema: [], messages: { unexpected: "Avoid arguments.{{prop}}." } }, create: function(e25) {
  return { MemberExpression: function(t2) {
    var r2 = t2.object.name, n2 = t2.property.name;
    r2 === "arguments" && !t2.computed && n2 && n2.match(/^calle[er]$/) && e25.report({ node: t2, messageId: "unexpected", data: { prop: n2 } });
  } };
} }, "no-case-declarations": { meta: { type: "suggestion", docs: { description: "disallow lexical declarations in case clauses", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-case-declarations" }, schema: [], messages: { unexpected: "Unexpected lexical declaration in case block." } }, create: function(e25) {
  function t2(e26) {
    switch (e26.type) {
      case "FunctionDeclaration":
      case "ClassDeclaration":
        return true;
      case "VariableDeclaration":
        return e26.kind !== "var";
      default:
        return false;
    }
  }
  return { SwitchCase: function(r2) {
    for (var n2 = 0; n2 < r2.consequent.length; n2++) {
      var i2 = r2.consequent[n2];
      t2(i2) && e25.report({ node: i2, messageId: "unexpected" });
    }
  } };
} }, "no-catch-shadow": sT, "no-class-assign": uT, "no-compare-neg-zero": cT, "no-cond-assign": fT, "no-confusing-arrow": hT, "no-console": dT, "no-const-assign": mT, "no-constant-condition": vT, "no-constructor-return": { meta: { type: "problem", docs: { description: "disallow returning value from constructor", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-constructor-return" }, schema: {}, fixable: null, messages: { unexpected: "Unexpected return statement in constructor." } }, create: function(e25) {
  var t2 = [];
  return { onCodePathStart: function(e26, r2) {
    t2.push(r2);
  }, onCodePathEnd: function() {
    t2.pop();
  }, ReturnStatement: function(r2) {
    var n2 = t2[t2.length - 1];
    !n2.parent || n2.parent.type === "MethodDefinition" && n2.parent.kind === "constructor" && (r2.parent.parent === n2 || r2.argument) && e25.report({ node: r2, messageId: "unexpected" });
  } };
} }, "no-continue": { meta: { type: "suggestion", docs: { description: "disallow `continue` statements", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-continue" }, schema: [], messages: { unexpected: "Unexpected use of continue statement." } }, create: function(e25) {
  return { ContinueStatement: function(t2) {
    e25.report({ node: t2, messageId: "unexpected" });
  } };
} }, "no-control-regex": ET, "no-debugger": { meta: { type: "problem", docs: { description: "disallow the use of `debugger`", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-debugger" }, fixable: null, schema: [], messages: { unexpected: "Unexpected 'debugger' statement." } }, create: function(e25) {
  return { DebuggerStatement: function(t2) {
    e25.report({ node: t2, messageId: "unexpected" });
  } };
} }, "no-delete-var": { meta: { type: "suggestion", docs: { description: "disallow deleting variables", category: "Variables", recommended: true, url: "https://eslint.org/docs/rules/no-delete-var" }, schema: [], messages: { unexpected: "Variables should not be deleted." } }, create: function(e25) {
  return { UnaryExpression: function(t2) {
    t2.operator === "delete" && t2.argument.type === "Identifier" && e25.report({ node: t2, messageId: "unexpected" });
  } };
} }, "no-div-regex": { meta: { type: "suggestion", docs: { description: "disallow division operators explicitly at the beginning of regular expressions", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-div-regex" }, fixable: "code", schema: [], messages: { unexpected: "A regular expression literal can be confused with '/='." } }, create: function(e25) {
  var t2 = e25.getSourceCode();
  return { Literal: function(r2) {
    var n2 = t2.getFirstToken(r2);
    n2.type === "RegularExpression" && n2.value[1] === "=" && e25.report({ node: r2, messageId: "unexpected", fix: function(e26) {
      return e26.replaceTextRange([n2.range[0] + 1, n2.range[0] + 2], "[=]");
    } });
  } };
} }, "no-dupe-args": { meta: { type: "problem", docs: { description: "disallow duplicate arguments in `function` definitions", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-dupe-args" }, schema: [], messages: { unexpected: "Duplicate param '{{name}}'." } }, create: function(e25) {
  function t2(e26) {
    return e26.type === "Parameter";
  }
  function r2(r3) {
    for (var n2 = e25.getDeclaredVariables(r3), i2 = 0; i2 < n2.length; ++i2) {
      var a2 = n2[i2];
      2 <= a2.defs.filter(t2).length && e25.report({ node: r3, messageId: "unexpected", data: { name: a2.name } });
    }
  }
  return { FunctionDeclaration: r2, FunctionExpression: r2 };
} }, "no-dupe-class-members": CT, "no-dupe-else-if": AT, "no-dupe-keys": PT, "no-duplicate-case": IT, "no-duplicate-imports": jT, "no-else-return": MT, "no-empty-character-class": UT, "no-empty-function": qT, "no-empty-pattern": { meta: { type: "problem", docs: { description: "disallow empty destructuring patterns", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-empty-pattern" }, schema: [], messages: { unexpected: "Unexpected empty {{type}} pattern." } }, create: function(e25) {
  return { ObjectPattern: function(t2) {
    t2.properties.length === 0 && e25.report({ node: t2, messageId: "unexpected", data: { type: "object" } });
  }, ArrayPattern: function(t2) {
    t2.elements.length === 0 && e25.report({ node: t2, messageId: "unexpected", data: { type: "array" } });
  } };
} }, "no-empty": WT, "no-eq-null": { meta: { type: "suggestion", docs: { description: "disallow `null` comparisons without type-checking operators", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-eq-null" }, schema: [], messages: { unexpected: "Use '===' to compare with null." } }, create: function(e25) {
  return { BinaryExpression: function(t2) {
    var r2 = t2.operator === "==" || t2.operator === "!=";
    (t2.right.type === "Literal" && t2.right.raw === "null" && r2 || t2.left.type === "Literal" && t2.left.raw === "null" && r2) && e25.report({ node: t2, messageId: "unexpected" });
  } };
} }, "no-eval": KT, "no-ex-assign": JT, "no-extend-native": XT, "no-extra-bind": ZT, "no-extra-boolean-cast": eP, "no-extra-label": tP, "no-extra-parens": nP, "no-extra-semi": iP, "no-fallthrough": sP, "no-floating-decimal": uP, "no-func-assign": cP, "no-global-assign": { meta: { type: "suggestion", docs: { description: "disallow assignments to native objects or read-only global variables", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-global-assign" }, schema: [{ type: "object", properties: { exceptions: { type: "array", items: { type: "string" }, uniqueItems: true } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3, r3, n3) {
    var i3 = t3.identifier;
    t3.init === false && t3.isWrite() && (r3 === 0 || n3[r3 - 1].identifier !== i3) && e25.report({ node: i3, message: "Read-only global '{{name}}' should not be modified.", data: i3 });
  }
  function r2(e26) {
    e26.writeable === false && i2.indexOf(e26.name) === -1 && e26.references.forEach(t2);
  }
  var n2 = e25.options[0], i2 = n2 && n2.exceptions || [];
  return { Program: function() {
    e25.getScope().variables.forEach(r2);
  } };
} }, "no-implicit-coercion": dP, "no-implicit-globals": { meta: { type: "suggestion", docs: { description: "disallow declarations in the global scope", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-implicit-globals" }, schema: [{ type: "object", properties: { lexicalBindings: { type: "boolean", default: false } }, additionalProperties: false }], messages: { globalNonLexicalBinding: "Unexpected {{kind}} declaration in the global scope, wrap in an IIFE for a local variable, assign as global property for a global variable.", globalLexicalBinding: "Unexpected {{kind}} declaration in the global scope, wrap in a block or in an IIFE.", globalVariableLeak: "Global variable leak, declare the variable if it is intended to be local.", assignmentToReadonlyGlobal: "Unexpected assignment to read-only global variable.", redeclarationOfReadonlyGlobal: "Unexpected redeclaration of read-only global variable." } }, create: function(e25) {
  function t2(t3, r3, n2) {
    e25.report({ node: t3, messageId: r3, data: { kind: n2 } });
  }
  var r2 = e25.options[0] && e25.options[0].lexicalBindings === true;
  return { Program: function() {
    var n2 = e25.getScope();
    n2.variables.forEach(function(e26) {
      var n3 = e26.writeable === false;
      e26.writeable === true || e26.defs.forEach(function(e27) {
        var i2 = e27.node;
        (e27.type === "FunctionName" || e27.type === "Variable" && e27.parent.kind === "var") && (n3 ? t2(i2, "redeclarationOfReadonlyGlobal") : t2(i2, "globalNonLexicalBinding", e27.type === "FunctionName" ? "function" : "'".concat(e27.parent.kind, "'"))), r2 && (e27.type === "ClassName" || e27.type === "Variable" && (e27.parent.kind === "let" || e27.parent.kind === "const")) && (n3 ? t2(i2, "redeclarationOfReadonlyGlobal") : t2(i2, "globalLexicalBinding", e27.type === "ClassName" ? "class" : "'".concat(e27.parent.kind, "'")));
      });
    }), n2.implicit.variables.forEach(function(e26) {
      var r3, i2 = n2.set.get(e26.name);
      if (i2) {
        if (i2.writeable)
          return;
        r3 = "assignmentToReadonlyGlobal";
      } else
        r3 = "globalVariableLeak";
      e26.defs.forEach(function(e27) {
        t2(e27.node, r3);
      });
    });
  } };
} }, "no-implied-eval": { meta: { type: "suggestion", docs: { description: "disallow the use of `eval()`-like methods", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-implied-eval" }, schema: [] }, create: function(e25) {
  function t2(e26) {
    return e26 ? e26[e26.length - 1] : null;
  }
  function r2(e26) {
    var t3 = e26.callee.type === "MemberExpression";
    return (e26.callee.type === "Identifier" && a2.test(e26.callee.name) || t3 && function(e27) {
      var t4 = e27.object, r3 = e27.property, n3 = a2.test(r3.name) || a2.test(r3.value);
      return t4.name === "window" && n3;
    }(e26.callee)) && e26.arguments.length;
  }
  function n2(e26) {
    return e26.parent === t2(t2(o2)) && (e26.parent.type !== "CallExpression" || e26 === e26.parent.arguments[0]);
  }
  function i2(t3) {
    if (n2(t3)) {
      var r3 = o2.pop();
      e25.report({ node: r3[0], message: "Implied eval. Consider passing a function instead of a string." });
    }
  }
  var a2 = /^(setTimeout|setInterval|execScript)$/, o2 = [];
  return { CallExpression: function(e26) {
    r2(e26) && o2.push([e26]);
  }, "CallExpression:exit": function(e26) {
    e26 === t2(t2(o2)) && o2.pop();
  }, BinaryExpression: function(e26) {
    e26.operator === "+" && n2(e26) && t2(o2).push(e26);
  }, "BinaryExpression:exit": function(e26) {
    e26 === t2(t2(o2)) && t2(o2).pop();
  }, Literal: function(e26) {
    typeof e26.value == "string" && i2(e26);
  }, TemplateLiteral: function(e26) {
    i2(e26);
  } };
} }, "no-import-assign": EP, "no-inline-comments": CP, "no-inner-declarations": { meta: { type: "problem", docs: { description: "disallow variable or `function` declarations in nested blocks", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-inner-declarations" }, schema: [{ enum: ["functions", "both"] }] }, create: function(e25) {
  function t2(t3) {
    var r2 = function() {
      for (var t4 = e25.getAncestors(), r3 = t4.pop(), n2 = 1; r3 && 0 > ["Program", "FunctionDeclaration", "FunctionExpression", "ArrowFunctionExpression"].indexOf(r3.type); )
        n2 += 1, r3 = t4.pop();
      return { type: r3.type, distance: n2 };
    }();
    r2.type === "Program" && r2.distance === 1 || r2.distance === 2 || e25.report({ node: t3, message: "Move {{type}} declaration to {{body}} root.", data: { type: t3.type === "FunctionDeclaration" ? "function" : "variable", body: r2.type === "Program" ? "program" : "function body" } });
  }
  return { FunctionDeclaration: t2, VariableDeclaration: function(r2) {
    e25.options[0] === "both" && r2.kind === "var" && t2(r2);
  } };
} }, "no-invalid-regexp": FP, "no-invalid-this": AP, "no-irregular-whitespace": IP, "no-iterator": { meta: { type: "suggestion", docs: { description: "disallow the use of the `__iterator__` property", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-iterator" }, schema: [] }, create: function(e25) {
  return { MemberExpression: function(t2) {
    (t2.property && t2.property.type === "Identifier" && t2.property.name === "__iterator__" && !t2.computed || t2.property.type === "Literal" && t2.property.value === "__iterator__") && e25.report({ node: t2, message: "Reserved name '__iterator__'." });
  } };
} }, "no-label-var": BP, "no-labels": OP, "no-lone-blocks": { meta: { type: "suggestion", docs: { description: "disallow unnecessary nested blocks", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-lone-blocks" }, schema: [] }, create: function(e25) {
  function t2(t3) {
    var r3 = t3.parent.type === "BlockStatement" ? "Nested block is redundant." : "Block is redundant.";
    e25.report({ node: t3, message: r3 });
  }
  function r2(e26) {
    return e26.parent.type === "BlockStatement" || e26.parent.type === "Program" || e26.parent.type === "SwitchCase" && (e26.parent.consequent[0] !== e26 || e26.parent.consequent.length !== 1);
  }
  function n2() {
    if (a2.length !== 0) {
      var t3 = e25.getAncestors().pop();
      a2[a2.length - 1] === t3 && a2.pop();
    }
  }
  var i2, a2 = [];
  return i2 = { BlockStatement: function(e26) {
    r2(e26) && t2(e26);
  } }, 6 <= e25.parserOptions.ecmaVersion && ((i2 = { BlockStatement: function(e26) {
    r2(e26) && a2.push(e26);
  }, "BlockStatement:exit": function(e26) {
    0 < a2.length && a2[a2.length - 1] === e26 ? (a2.pop(), t2(e26)) : e26.parent.type === "BlockStatement" && e26.parent.body.length === 1 && t2(e26);
  } }).VariableDeclaration = function(e26) {
    (e26.kind === "let" || e26.kind === "const") && n2();
  }, i2.FunctionDeclaration = function() {
    e25.getScope().isStrict && n2();
  }, i2.ClassDeclaration = n2), i2;
} }, "no-lonely-if": { meta: { type: "suggestion", docs: { description: "disallow `if` statements as the only statement in `else` blocks", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-lonely-if" }, schema: [], fixable: "code" }, create: function(e25) {
  var t2 = e25.getSourceCode();
  return { IfStatement: function(r2) {
    var n2 = e25.getAncestors(), i2 = n2.pop(), a2 = n2.pop();
    i2 && i2.type === "BlockStatement" && i2.body.length === 1 && a2 && a2.type === "IfStatement" && i2 === a2.alternate && e25.report({ node: r2, message: "Unexpected if as the only statement in an else block.", fix: function(e26) {
      var n3 = t2.getFirstToken(i2), a3 = t2.getLastToken(i2), o2 = t2.getTokenBefore(n3), s2 = t2.getTokenAfter(a3), u2 = t2.getLastToken(r2.consequent), c2 = t2.getText();
      return c2.slice(n3.range[1], r2.range[0]).trim() || c2.slice(r2.range[1], a3.range[0]).trim() ? null : r2.consequent.type !== "BlockStatement" && u2.value !== ";" && s2 && (r2.consequent.loc.end.line === s2.loc.start.line || /^[\(\+\x2D\/\[`]/.test(s2.value) || u2.value === "++" || u2.value === "--") ? null : e26.replaceTextRange([n3.range[0], a3.range[1]], (o2.range[1] === n3.range[0] ? " " : "") + t2.getText(r2));
    } });
  } };
} }, "no-loop-func": jP, "no-magic-numbers": { meta: { type: "suggestion", docs: { description: "disallow magic numbers", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-magic-numbers" }, schema: [{ type: "object", properties: { detectObjects: { type: "boolean", default: false }, enforceConst: { type: "boolean", default: false }, ignore: { type: "array", items: { type: "number" }, uniqueItems: true }, ignoreArrayIndexes: { type: "boolean", default: false } }, additionalProperties: false }], messages: { useConst: "Number constants declarations must use 'const'.", noMagic: "No magic number: {{raw}}." } }, create: function(e25) {
  function t2(e26) {
    return o2.indexOf(e26) !== -1;
  }
  function r2(e26) {
    return e26.type === "MemberExpression" && s2;
  }
  var n2 = e25.options[0] || {}, i2 = !!n2.detectObjects, a2 = !!n2.enforceConst, o2 = n2.ignore || [], s2 = !!n2.ignoreArrayIndexes;
  return { Literal: function(n3) {
    var o3, s3, u2, c2, l2 = i2 ? [] : ["ObjectExpression", "Property", "AssignmentExpression"];
    (function(e26) {
      return typeof e26.value == "number";
    })(n3) && (n3.parent.type === "UnaryExpression" && n3.parent.operator === "-" ? (s3 = (o3 = n3.parent).parent, u2 = -n3.value, c2 = "-".concat(n3.raw)) : (o3 = n3, s3 = n3.parent, u2 = n3.value, c2 = n3.raw), t2(u2) || function(e26, t3) {
      return e26.type === "CallExpression" && t3 === e26.arguments[1] && (e26.callee.name === "parseInt" || e26.callee.type === "MemberExpression" && e26.callee.object.name === "Number" && e26.callee.property.name === "parseInt");
    }(s3, o3) || r2(s3) || function(e26) {
      return e26.type.indexOf("JSX") === 0;
    }(s3) || (s3.type === "VariableDeclarator" ? a2 && s3.parent.kind !== "const" && e25.report({ node: o3, messageId: "useConst" }) : (l2.indexOf(s3.type) === -1 || s3.type === "AssignmentExpression" && s3.left.type === "Identifier") && e25.report({ node: o3, messageId: "noMagic", data: { raw: c2 } })));
  } };
} }, "no-misleading-character-class": nI, "no-mixed-operators": hI, "no-mixed-requires": dI, "no-mixed-spaces-and-tabs": { meta: { type: "layout", docs: { description: "disallow mixed spaces and tabs for indentation", category: "Stylistic Issues", recommended: true, url: "https://eslint.org/docs/rules/no-mixed-spaces-and-tabs" }, schema: [{ enum: ["smart-tabs", true, false] }] }, create: function(e25) {
  function t2(e26, t3, r3) {
    return !!(t3 < e26.start.line) || t3 === e26.start.line && r3 < e26.start.column;
  }
  function r2(e26, t3, r3) {
    return !!(t3 > e26.end.line) || t3 === e26.end.line && r3 > e26.end.column;
  }
  var n2, i2 = e25.getSourceCode(), a2 = [];
  switch (e25.options[0]) {
    case true:
    case "smart-tabs":
      n2 = true;
      break;
    default:
      n2 = false;
  }
  return { TemplateElement: function(e26) {
    a2.push(e26.loc);
  }, "Program:exit": function(o2) {
    var s2 = /^(?=[\t ]*(\t | \t))/, u2 = i2.lines;
    i2.getAllComments().forEach(function(e26) {
      a2.push(e26.loc);
    }), a2.sort(function(e26, r3) {
      return t2(e26, r3.start.line, r3.start.column) ? 1 : t2(r3, e26.start.line, r3.start.column) ? -1 : 0;
    }), n2 && (s2 = /^(?=[\t ]* \t)/), u2.forEach(function(n3, i3) {
      var u3 = s2.exec(n3);
      if (u3) {
        for (var c2 = i3 + 1, l2 = u3.index + 1, p2 = 0; p2 < a2.length; p2++)
          if (!t2(a2[p2], c2, l2) && !r2(a2[p2], c2, l2))
            return;
        e25.report({ node: o2, loc: { line: c2, column: l2 }, message: "Mixed spaces and tabs." });
      }
    });
  } };
} }, "no-multi-assign": { meta: { type: "suggestion", docs: { description: "disallow use of chained assignment expressions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-multi-assign" }, schema: [] }, create: function(e25) {
  return { AssignmentExpression: function(t2) {
    ["AssignmentExpression", "VariableDeclarator"].indexOf(t2.parent.type) !== -1 && e25.report({ node: t2, message: "Unexpected chained assignment." });
  } };
} }, "no-multi-spaces": mI, "no-multi-str": gI, "no-multiple-empty-lines": yI, "no-native-reassign": { meta: { type: "suggestion", docs: { description: "disallow assignments to native objects or read-only global variables", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-native-reassign" }, deprecated: true, replacedBy: ["no-global-assign"], schema: [{ type: "object", properties: { exceptions: { type: "array", items: { type: "string" }, uniqueItems: true } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3, r3, n3) {
    var i3 = t3.identifier;
    t3.init === false && t3.isWrite() && (r3 === 0 || n3[r3 - 1].identifier !== i3) && e25.report({ node: i3, message: "Read-only global '{{name}}' should not be modified.", data: i3 });
  }
  function r2(e26) {
    e26.writeable === false && i2.indexOf(e26.name) === -1 && e26.references.forEach(t2);
  }
  var n2 = e25.options[0], i2 = n2 && n2.exceptions || [];
  return { Program: function() {
    e25.getScope().variables.forEach(r2);
  } };
} }, "no-negated-condition": { meta: { type: "suggestion", docs: { description: "disallow negated conditions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-negated-condition" }, schema: [] }, create: function(e25) {
  function t2(e26) {
    return function(e27) {
      return e27.type === "UnaryExpression" && e27.operator === "!";
    }(e26.test) || function(e27) {
      return e27.type === "BinaryExpression" && (e27.operator === "!=" || e27.operator === "!==");
    }(e26.test);
  }
  return { IfStatement: function(r2) {
    !function(e26) {
      return e26.alternate && e26.alternate.type !== "IfStatement";
    }(r2) || t2(r2) && e25.report({ node: r2, message: "Unexpected negated condition." });
  }, ConditionalExpression: function(r2) {
    t2(r2) && e25.report({ node: r2, message: "Unexpected negated condition." });
  } };
} }, "no-negated-in-lhs": { meta: { type: "problem", docs: { description: "disallow negating the left operand in `in` expressions", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-negated-in-lhs" }, replacedBy: ["no-unsafe-negation"], deprecated: true, schema: [] }, create: function(e25) {
  return { BinaryExpression: function(t2) {
    t2.operator === "in" && t2.left.type === "UnaryExpression" && t2.left.operator === "!" && e25.report({ node: t2, message: "The 'in' expression's left operand is negated." });
  } };
} }, "no-nested-ternary": { meta: { type: "suggestion", docs: { description: "disallow nested ternary expressions", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-nested-ternary" }, schema: [] }, create: function(e25) {
  return { ConditionalExpression: function(t2) {
    (t2.alternate.type === "ConditionalExpression" || t2.consequent.type === "ConditionalExpression") && e25.report({ node: t2, message: "Do not nest ternary expressions." });
  } };
} }, "no-new-func": { meta: { type: "suggestion", docs: { description: "disallow `new` operators with the `Function` object", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-new-func" }, schema: [] }, create: function(e25) {
  function t2(t3) {
    e25.report({ node: t3, message: "The Function constructor is eval." });
  }
  return { "NewExpression[callee.name = 'Function']": t2, "CallExpression[callee.name = 'Function']": t2 };
} }, "no-new-object": { meta: { type: "suggestion", docs: { description: "disallow `Object` constructors", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-new-object" }, schema: [] }, create: function(e25) {
  return { NewExpression: function(t2) {
    t2.callee.name === "Object" && e25.report({ node: t2, message: "The object literal notation {} is preferrable." });
  } };
} }, "no-new-require": { meta: { type: "suggestion", docs: { description: "disallow `new` operators with calls to `require`", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-new-require" }, schema: [] }, create: function(e25) {
  return { NewExpression: function(t2) {
    t2.callee.type === "Identifier" && t2.callee.name === "require" && e25.report({ node: t2, message: "Unexpected use of new with require." });
  } };
} }, "no-new-symbol": { meta: { type: "problem", docs: { description: "disallow `new` operators with the `Symbol` object", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/no-new-symbol" }, schema: [] }, create: function(e25) {
  return { "Program:exit": function() {
    var t2 = e25.getScope().set.get("Symbol");
    t2 && t2.defs.length === 0 && t2.references.forEach(function(t3) {
      var r2 = t3.identifier;
      r2.parent && r2.parent.type === "NewExpression" && e25.report({ node: r2, message: "`Symbol` cannot be called as a constructor." });
    });
  } };
} }, "no-new-wrappers": { meta: { type: "suggestion", docs: { description: "disallow `new` operators with the `String`, `Number`, and `Boolean` objects", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-new-wrappers" }, schema: [] }, create: function(e25) {
  return { NewExpression: function(t2) {
    -1 < ["String", "Number", "Boolean", "Math", "JSON"].indexOf(t2.callee.name) && e25.report({ node: t2, message: "Do not use {{fn}} as a constructor.", data: { fn: t2.callee.name } });
  } };
} }, "no-new": { meta: { type: "suggestion", docs: { description: "disallow `new` operators outside of assignments or comparisons", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-new" }, schema: [] }, create: function(e25) {
  return { "ExpressionStatement > NewExpression": function(t2) {
    e25.report({ node: t2.parent, message: "Do not use 'new' for side effects." });
  } };
} }, "no-obj-calls": CI, "no-octal-escape": { meta: { type: "suggestion", docs: { description: "disallow octal escape sequences in string literals", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-octal-escape" }, schema: [], messages: { octalEscapeSequence: "Don't use octal: '\\{{sequence}}'. Use '\\u....' instead." } }, create: function(e25) {
  return { Literal: function(t2) {
    if (typeof t2.value == "string") {
      var r2 = t2.raw.match(/^(?:(?:[\0-\[\]-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])|\\(?:[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))*?\\([0-3][0-7]{1,2}|[4-7][0-7]|0(?=[89])|[1-7])/);
      r2 && e25.report({ node: t2, messageId: "octalEscapeSequence", data: { sequence: r2[1] } });
    }
  } };
} }, "no-octal": { meta: { type: "suggestion", docs: { description: "disallow octal literals", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-octal" }, schema: [] }, create: function(e25) {
  return { Literal: function(t2) {
    typeof t2.value == "number" && /^0[0-9]/.test(t2.raw) && e25.report({ node: t2, message: "Octal literals should not be used." });
  } };
} }, "no-param-reassign": kI, "no-path-concat": { meta: { type: "suggestion", docs: { description: "disallow string concatenation with `__dirname` and `__filename`", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-path-concat" }, schema: [] }, create: function(e25) {
  var t2 = /^__(?:dir|file)name$/;
  return { BinaryExpression: function(r2) {
    var n2 = r2.left, i2 = r2.right;
    r2.operator === "+" && (n2.type === "Identifier" && t2.test(n2.name) || i2.type === "Identifier" && t2.test(i2.name)) && e25.report({ node: r2, message: "Use path.join() or path.resolve() instead of + to create paths." });
  } };
} }, "no-plusplus": DI, "no-process-env": { meta: { type: "suggestion", docs: { description: "disallow the use of `process.env`", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-process-env" }, schema: [] }, create: function(e25) {
  return { MemberExpression: function(t2) {
    var r2 = t2.object.name, n2 = t2.property.name;
    r2 === "process" && !t2.computed && n2 && n2 === "env" && e25.report({ node: t2, message: "Unexpected use of process.env." });
  } };
} }, "no-process-exit": { meta: { type: "suggestion", docs: { description: "disallow the use of `process.exit()`", category: "Node.js and CommonJS", recommended: false, url: "https://eslint.org/docs/rules/no-process-exit" }, schema: [] }, create: function(e25) {
  return { "CallExpression > MemberExpression.callee[object.name = 'process'][property.name = 'exit']": function(t2) {
    e25.report({ node: t2.parent, message: "Don't use process.exit(); throw an error instead." });
  } };
} }, "no-proto": { meta: { type: "suggestion", docs: { description: "disallow the use of the `__proto__` property", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-proto" }, schema: [] }, create: function(e25) {
  return { MemberExpression: function(t2) {
    (t2.property && t2.property.type === "Identifier" && t2.property.name === "__proto__" && !t2.computed || t2.property.type === "Literal" && t2.property.value === "__proto__") && e25.report({ node: t2, message: "The '__proto__' property is deprecated." });
  } };
} }, "no-prototype-builtins": { meta: { type: "problem", docs: { description: "disallow calling some `Object.prototype` methods directly on objects", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-prototype-builtins" }, schema: [] }, create: function(e25) {
  var t2 = ["hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable"];
  return { CallExpression: function(r2) {
    if (r2.callee.type === "MemberExpression" && !r2.callee.computed) {
      var n2 = r2.callee.property.name;
      -1 < t2.indexOf(n2) && e25.report({ message: "Do not access Object.prototype method '{{prop}}' from target object.", loc: r2.callee.property.loc.start, data: { prop: n2 }, node: r2 });
    }
  } };
} }, "no-redeclare": FI, "no-regex-spaces": TI, "no-restricted-globals": BI, "no-restricted-imports": LI, "no-restricted-modules": MI, "no-restricted-properties": VI, "no-restricted-syntax": UI, "no-return-assign": WI, "no-return-await": GI, "no-script-url": { meta: { type: "suggestion", docs: { description: "disallow `javascript:` urls", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-script-url" }, schema: [] }, create: function(e25) {
  return { Literal: function(t2) {
    t2.value && typeof t2.value == "string" && (t2.value.toLowerCase().indexOf("javascript:") === 0 && e25.report({ node: t2, message: "Script URL is a form of eval." }));
  } };
} }, "no-self-assign": KI, "no-self-compare": JI, "no-sequences": QI, "no-setter-return": eB, "no-shadow-restricted-names": rB, "no-shadow": nB, "no-spaced-func": { meta: { type: "layout", docs: { description: "disallow spacing between function identifiers and their applications (deprecated)", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-spaced-func" }, deprecated: true, replacedBy: ["func-call-spacing"], fixable: "whitespace", schema: [] }, create: function(e25) {
  function t2(t3) {
    for (var n2 = r2.getLastToken(t3.callee), i2 = n2, a2 = r2.getTokenAfter(n2); a2 && a2.range[1] < t3.range[1] && a2.value !== "("; )
      i2 = a2, a2 = r2.getTokenAfter(a2);
    a2 && a2.range[1] < t3.range[1] && r2.isSpaceBetweenTokens(i2, a2) && e25.report({ node: t3, loc: n2.loc.start, message: "Unexpected space between function name and paren.", fix: function(e26) {
      return e26.removeRange([i2.range[1], a2.range[0]]);
    } });
  }
  var r2 = e25.getSourceCode();
  return { CallExpression: t2, NewExpression: t2 };
} }, "no-sparse-arrays": { meta: { type: "problem", docs: { description: "disallow sparse arrays", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/no-sparse-arrays" }, schema: [] }, create: function(e25) {
  return { ArrayExpression: function(t2) {
    -1 < t2.elements.indexOf(null) && e25.report({ node: t2, message: "Unexpected comma in middle of array." });
  } };
} }, "no-sync": iB, "no-tabs": sB, "no-template-curly-in-string": { meta: { type: "problem", docs: { description: "disallow template literal placeholder syntax in regular strings", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/no-template-curly-in-string" }, schema: [] }, create: function(e25) {
  var t2 = /\$\{(?:[\0-\|~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+\}/;
  return { Literal: function(r2) {
    typeof r2.value == "string" && t2.test(r2.value) && e25.report({ node: r2, message: "Unexpected template string expression." });
  } };
} }, "no-ternary": { meta: { type: "suggestion", docs: { description: "disallow ternary operators", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-ternary" }, schema: [] }, create: function(e25) {
  return { ConditionalExpression: function(t2) {
    e25.report({ node: t2, message: "Ternary operator used." });
  } };
} }, "no-this-before-super": uB, "no-throw-literal": cB, "no-trailing-spaces": lB, "no-undef-init": pB, "no-undef": fB, "no-undefined": hB, "no-underscore-dangle": { meta: { type: "suggestion", docs: { description: "disallow dangling underscores in identifiers", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/no-underscore-dangle" }, schema: [{ type: "object", properties: { allow: { type: "array", items: { type: "string" } }, allowAfterThis: { type: "boolean", default: false }, allowAfterSuper: { type: "boolean", default: false }, allowAfterThisConstructor: { type: "boolean", default: false }, enforceInMethodNames: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e25) {
  function t2(e26) {
    return a2.some(function(t3) {
      return t3 === e26;
    });
  }
  function r2(e26) {
    var t3 = e26.length;
    return e26 !== "_" && (e26[0] === "_" || e26[t3 - 1] === "_");
  }
  function n2(t3) {
    var n3 = t3.key.name, i3 = t3.type === "MethodDefinition" || t3.type === "Property" && t3.method;
    n3 !== void 0 && c2 && i3 && r2(n3) && e25.report({ node: t3, message: "Unexpected dangling '_' in '{{identifier}}'.", data: { identifier: n3 } });
  }
  var i2 = e25.options[0] || {}, a2 = i2.allow ? i2.allow : [], o2 = i2.allowAfterThis !== void 0 && i2.allowAfterThis, s2 = i2.allowAfterSuper !== void 0 && i2.allowAfterSuper, u2 = i2.allowAfterThisConstructor !== void 0 && i2.allowAfterThisConstructor, c2 = i2.enforceInMethodNames !== void 0 && i2.enforceInMethodNames;
  return { FunctionDeclaration: function(n3) {
    if (n3.id) {
      var i3 = n3.id.name;
      i3 !== void 0 && r2(i3) && !t2(i3) && e25.report({ node: n3, message: "Unexpected dangling '_' in '{{identifier}}'.", data: { identifier: i3 } });
    }
  }, VariableDeclarator: function(n3) {
    var i3 = n3.id.name;
    i3 === void 0 || !r2(i3) || function(e26) {
      return e26 === "_";
    }(i3) || t2(i3) || e25.report({ node: n3, message: "Unexpected dangling '_' in '{{identifier}}'.", data: { identifier: i3 } });
  }, MemberExpression: function(n3) {
    var i3 = n3.property.name, a3 = n3.object.type === "ThisExpression", c3 = n3.object.type === "Super", l2 = function(e26) {
      return e26.object.type === "MemberExpression" && e26.object.property.name === "constructor" && e26.object.object.type === "ThisExpression";
    }(n3);
    i3 === void 0 || !r2(i3) || a3 && o2 || c3 && s2 || l2 && u2 || function(e26) {
      return e26 === "__proto__";
    }(i3) || t2(i3) || e25.report({ node: n3, message: "Unexpected dangling '_' in '{{identifier}}'.", data: { identifier: i3 } });
  }, MethodDefinition: n2, Property: n2 };
} }, "no-unexpected-multiline": dB, "no-unmodified-loop-condition": FB, "no-unneeded-ternary": TB, "no-unreachable": OB, "no-unsafe-finally": RB, "no-unsafe-negation": MB, "no-unused-expressions": { meta: { type: "suggestion", docs: { description: "disallow unused expressions", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-unused-expressions" }, schema: [{ type: "object", properties: { allowShortCircuit: { type: "boolean", default: false }, allowTernary: { type: "boolean", default: false }, allowTaggedTemplates: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e25) {
  function t2(e26) {
    return e26.type === "ExpressionStatement" && e26.expression.type === "Literal" && typeof e26.expression.value == "string";
  }
  function r2(e26) {
    return function(e27, t3) {
      for (var r3 = 0; r3 < t3.length; ++r3)
        if (!e27(t3[r3]))
          return t3.slice(0, r3);
      return t3.slice();
    }(t2, e26.body);
  }
  var n2 = e25.options[0] || {}, i2 = n2.allowShortCircuit || false, a2 = n2.allowTernary || false, o2 = n2.allowTaggedTemplates || false;
  return { ExpressionStatement: function(t3) {
    (function e26(t4) {
      return a2 && t4.type === "ConditionalExpression" ? e26(t4.consequent) && e26(t4.alternate) : i2 && t4.type === "LogicalExpression" ? e26(t4.right) : !(!o2 || t4.type !== "TaggedTemplateExpression") || /^(?:Assignment|Call|New|Update|Yield|Await)Expression$/.test(t4.type) || t4.type === "UnaryExpression" && 0 <= ["delete", "void"].indexOf(t4.operator);
    })(t3.expression) || function(e26, t4) {
      var n3 = t4[t4.length - 1], i3 = t4[t4.length - 2];
      return (n3.type === "Program" || n3.type === "BlockStatement" && /Function/.test(i3.type)) && 0 <= r2(n3).indexOf(e26);
    }(t3, e25.getAncestors()) || e25.report({ node: t3, message: "Expected an assignment or function call and instead saw an expression." });
  } };
} }, "no-unused-labels": { meta: { type: "suggestion", docs: { description: "disallow unused labels", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-unused-labels" }, schema: [], fixable: "code", messages: { unused: "'{{name}}:' is defined but never used." } }, create: function(e25) {
  function t2(e26) {
    if (e26.label)
      for (var t3 = e26.label.name, r3 = n2; r3; ) {
        if (r3.label === t3) {
          r3.used = true;
          break;
        }
        r3 = r3.upper;
      }
  }
  var r2 = e25.getSourceCode(), n2 = null;
  return { LabeledStatement: function(e26) {
    n2 = { label: e26.label.name, used: false, upper: n2 };
  }, "LabeledStatement:exit": function(t3) {
    n2.used || e25.report({ node: t3.label, messageId: "unused", data: t3.label, fix: function(e26) {
      return r2.getTokenAfter(t3.label, { includeComments: true }) === r2.getTokenBefore(t3.body, { includeComments: true }) ? e26.removeRange([t3.range[0], t3.body.range[0]]) : null;
    } }), n2 = n2.upper;
  }, BreakStatement: t2, ContinueStatement: t2 };
} }, "no-unused-vars": VB, "no-use-before-define": $B, "no-useless-call": GB, "no-useless-catch": { meta: { type: "suggestion", docs: { description: "disallow unnecessary `catch` clauses", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-useless-catch" }, schema: [] }, create: function(e25) {
  return { CatchClause: function(t2) {
    t2.param && t2.param.type === "Identifier" && t2.body.body.length && t2.body.body[0].type === "ThrowStatement" && t2.body.body[0].argument.type === "Identifier" && t2.body.body[0].argument.name === t2.param.name && (t2.parent.finalizer ? e25.report({ node: t2, message: "Unnecessary catch clause." }) : e25.report({ node: t2.parent, message: "Unnecessary try/catch wrapper." }));
  } };
} }, "no-useless-computed-key": HB, "no-useless-concat": QB, "no-useless-constructor": tO, "no-useless-escape": oO, "no-useless-rename": sO, "no-useless-return": cO, "no-var": yO, "no-void": { meta: { type: "suggestion", docs: { description: "disallow `void` operators", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/no-void" }, schema: [] }, create: function(e25) {
  return { UnaryExpression: function(t2) {
    t2.operator === "void" && e25.report({ node: t2, message: "Expected 'undefined' and instead saw 'void'." });
  } };
} }, "no-warning-comments": xO, "no-whitespace-before-property": bO, "no-with": { meta: { type: "suggestion", docs: { description: "disallow `with` statements", category: "Best Practices", recommended: true, url: "https://eslint.org/docs/rules/no-with" }, schema: [] }, create: function(e25) {
  return { WithStatement: function(t2) {
    e25.report({ node: t2, message: "Unexpected use of 'with' statement." });
  } };
} }, "nonblock-statement-body-position": CO, "object-curly-newline": DO, "object-curly-spacing": FO, "object-property-newline": { meta: { type: "layout", docs: { description: "enforce placing object properties on separate lines", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/object-property-newline" }, schema: [{ type: "object", properties: { allowAllPropertiesOnSameLine: { type: "boolean", default: false }, allowMultiplePropertiesPerLine: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "whitespace" }, create: function(e25) {
  var t2 = e25.options[0] && (e25.options[0].allowAllPropertiesOnSameLine || e25.options[0].allowMultiplePropertiesPerLine), r2 = t2 ? "Object properties must go on a new line if they aren't all on the same line." : "Object properties must go on a new line.", n2 = e25.getSourceCode();
  return { ObjectExpression: function(i2) {
    if (t2 && 1 < i2.properties.length) {
      var a2 = n2.getFirstToken(i2.properties[0]), o2 = n2.getLastToken(i2.properties[i2.properties.length - 1]);
      if (a2.loc.end.line === o2.loc.start.line)
        return;
    }
    for (var s2 = function(t3) {
      var a3 = n2.getLastToken(i2.properties[t3 - 1]), o3 = n2.getFirstToken(i2.properties[t3]);
      a3.loc.end.line === o3.loc.start.line && e25.report({ node: i2, loc: o3.loc.start, message: r2, fix: function(e26) {
        var t4 = [n2.getTokenBefore(o3).range[1], o3.range[0]];
        return n2.text.slice(t4[0], t4[1]).trim() ? null : e26.replaceTextRange(t4, "\n");
      } });
    }, u2 = 1; u2 < i2.properties.length; u2++)
      s2(u2);
  } };
} }, "object-shorthand": BO, "one-var-declaration-per-line": { meta: { type: "suggestion", docs: { description: "require or disallow newlines around variable declarations", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/one-var-declaration-per-line" }, schema: [{ enum: ["always", "initializations"] }], fixable: "whitespace" }, create: function(e25) {
  var t2 = e25.options[0] === "always";
  return { VariableDeclaration: function(r2) {
    var n2;
    (function(e26) {
      return e26 === "ForStatement" || e26 === "ForInStatement" || e26 === "ForOfStatement";
    })(r2.parent.type) || r2.declarations.forEach(function(i2) {
      n2 && n2.loc.end.line === i2.loc.start.line && (t2 || n2.init || i2.init) && e25.report({ node: r2, message: "Expected variable declaration to be on a new line.", loc: i2.loc.start, fix: function(e26) {
        return e26.insertTextBefore(i2, "\n");
      } }), n2 = i2;
    });
  } };
} }, "one-var": OO, "operator-assignment": RO, "operator-linebreak": MO, "padded-blocks": VO, "padding-line-between-statements": rL, "prefer-arrow-callback": nL, "prefer-const": pL, "prefer-destructuring": fL, "prefer-exponentiation-operator": vL, "prefer-named-capture-group": DL, "prefer-numeric-literals": FL, "prefer-object-spread": qL, "prefer-promise-reject-errors": WL, "prefer-reflect": $L, "prefer-regex-literals": XL, "prefer-rest-params": ZL, "prefer-spread": eN, "prefer-template": oN, "quote-props": sN, quotes: lN, radix: dN, "require-atomic-updates": yN, "require-await": xN, "require-jsdoc": bN, "require-unicode-regexp": FN, "require-yield": { meta: { type: "suggestion", docs: { description: "require generator functions to contain `yield`", category: "ECMAScript 6", recommended: true, url: "https://eslint.org/docs/rules/require-yield" }, schema: [] }, create: function(e25) {
  function t2(e26) {
    e26.generator && n2.push(0);
  }
  function r2(t3) {
    t3.generator && (n2.pop() === 0 && 0 < t3.body.body.length && e25.report({ node: t3, message: "This generator function does not have 'yield'." }));
  }
  var n2 = [];
  return { FunctionDeclaration: t2, "FunctionDeclaration:exit": r2, FunctionExpression: t2, "FunctionExpression:exit": r2, YieldExpression: function() {
    0 < n2.length && (n2[n2.length - 1] += 1);
  } };
} }, "rest-spread-spacing": { meta: { type: "layout", docs: { description: "enforce spacing between rest and spread operators and their expressions", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/rest-spread-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }] }, create: function(e25) {
  function t2(t3) {
    var i2, a2 = r2.getFirstToken(t3), o2 = r2.getTokenAfter(a2), s2 = r2.isSpaceBetweenTokens(a2, o2);
    switch (t3.type) {
      case "SpreadElement":
        i2 = "spread", t3.parent.type === "ObjectExpression" && (i2 += " property");
        break;
      case "RestElement":
        i2 = "rest", t3.parent.type === "ObjectPattern" && (i2 += " property");
        break;
      case "ExperimentalSpreadProperty":
        i2 = "spread property";
        break;
      case "ExperimentalRestProperty":
        i2 = "rest property";
        break;
      default:
        return;
    }
    n2 && !s2 ? e25.report({ node: t3, loc: { line: a2.loc.end.line, column: a2.loc.end.column }, message: "Expected whitespace after {{type}} operator.", data: { type: i2 }, fix: function(e26) {
      return e26.replaceTextRange([a2.range[1], o2.range[0]], " ");
    } }) : !n2 && s2 && e25.report({ node: t3, loc: { line: a2.loc.end.line, column: a2.loc.end.column }, message: "Unexpected whitespace after {{type}} operator.", data: { type: i2 }, fix: function(e26) {
      return e26.removeRange([a2.range[1], o2.range[0]]);
    } });
  }
  var r2 = e25.getSourceCode(), n2 = e25.options[0] === "always";
  return { SpreadElement: t2, RestElement: t2, ExperimentalSpreadProperty: t2, ExperimentalRestProperty: t2 };
} }, "semi-spacing": AN, "semi-style": { meta: { type: "layout", docs: { description: "enforce location of semicolons", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/semi-style" }, schema: [{ enum: ["last", "first"] }], fixable: "whitespace" }, create: function(e25) {
  var t2;
  function r2(t3, r3) {
    var i3 = n2.getTokenBefore(t3), a2 = n2.getTokenAfter(t3), o2 = !i3 || LA.isTokenOnSameLine(i3, t3), s2 = !a2 || LA.isTokenOnSameLine(t3, a2);
    (r3 !== "last" || o2) && (r3 !== "first" || s2) || e25.report({ loc: t3.loc, message: "Expected this semicolon to be at {{pos}}.", data: { pos: r3 === "last" ? "the end of the previous line" : "the beginning of the next line" }, fix: function(e26) {
      if (i3 && a2 && n2.commentsExistBetween(i3, a2))
        return null;
      var o3 = i3 ? i3.range[1] : t3.range[0], s3 = a2 ? a2.range[0] : t3.range[1], u2 = r3 === "last" ? ";\n" : "\n;";
      return e26.replaceTextRange([o3, s3], u2);
    } });
  }
  var n2 = e25.getSourceCode(), i2 = e25.options[0] || "last";
  return u(t2 = {}, wN, function(e26) {
    if (i2 !== "first" || !function(e27) {
      var t4 = e27.parent.type;
      if (t4 === "IfStatement" && e27.parent.consequent === e27 && e27.parent.alternate)
        return true;
      if (t4 === "DoWhileStatement")
        return true;
      var r3 = function(e28) {
        var t5 = e28.type;
        return t5 === "BlockStatement" || t5 === "Program" ? e28.body : t5 === "SwitchCase" ? e28.consequent : null;
      }(e27.parent);
      return r3 !== null && r3[r3.length - 1] === e27;
    }(e26)) {
      var t3 = n2.getLastToken(e26);
      LA.isSemicolonToken(t3) && r2(t3, i2);
    }
  }), u(t2, "ForStatement", function(e26) {
    var t3 = e26.init && n2.getTokenAfter(e26.init, LA.isSemicolonToken), i3 = e26.test && n2.getTokenAfter(e26.test, LA.isSemicolonToken);
    t3 && r2(t3, "last"), i3 && r2(i3, "last");
  }), t2;
} }, semi: { meta: { type: "layout", docs: { description: "require or disallow semicolons instead of ASI", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/semi" }, fixable: "code", schema: { anyOf: [{ type: "array", items: [{ enum: ["never"] }, { type: "object", properties: { beforeStatementContinuationChars: { enum: ["always", "any", "never"] } }, additionalProperties: false }], minItems: 0, maxItems: 2 }, { type: "array", items: [{ enum: ["always"] }, { type: "object", properties: { omitLastInOneLineBlock: { type: "boolean" } }, additionalProperties: false }], minItems: 0, maxItems: 2 }] } }, create: function(e25) {
  function t2(t3, r3) {
    var n3, i3, a3, o3 = p2.getLastToken(t3);
    r3 ? (n3 = "Extra semicolon.", a3 = o3.loc, i3 = function(e26) {
      return new RT(e26, p2).retainSurroundingTokens(o3).remove(o3);
    }) : (n3 = "Missing semicolon.", a3 = { start: o3.loc.end, end: LA.getNextLocation(p2, o3.loc.end) }, i3 = function(e26) {
      return e26.insertTextAfter(o3, ";");
    }), e25.report({ node: t3, loc: a3, message: n3, fix: i3 });
  }
  function r2(e26) {
    var t3 = e26.type;
    return t3 !== "DoWhileStatement" && t3 !== "BreakStatement" && t3 !== "ContinueStatement" && t3 !== "DebuggerStatement" && t3 !== "ImportDeclaration" && t3 !== "ExportAllDeclaration" && (t3 === "ReturnStatement" ? !!e26.argument : t3 === "ExportNamedDeclaration" ? !!e26.declaration : !function(e27) {
      if (!LA.isClosingBraceToken(e27))
        return false;
      var t4 = p2.getNodeByRangeIndex(e27.range[0]);
      return t4.type === "BlockStatement" && t4.parent.type === "ArrowFunctionExpression";
    }(p2.getLastToken(e26, 1)));
  }
  function n2(e26) {
    return !!e26 && o2.test(e26.value) && e26.value !== "++" && e26.value !== "--";
  }
  function i2(e26) {
    return !(!function(e27) {
      var t3 = p2.getTokenAfter(e27);
      return !t3 || LA.isClosingBraceToken(t3) || LA.isSemicolonToken(t3);
    }(p2.getLastToken(e26)) && (function(e27) {
      var t3 = p2.getLastToken(e27, 1), r3 = p2.getTokenAfter(e27);
      return !!r3 && LA.isTokenOnSameLine(t3, r3);
    }(e26) || (l2 !== "never" || r2(e26)) && n2(p2.getTokenAfter(e26))));
  }
  function a2(e26) {
    var r3 = LA.isSemicolonToken(p2.getLastToken(e26));
    if (u2)
      r3 && i2(e26) ? t2(e26, true) : !r3 && l2 === "always" && n2(p2.getTokenAfter(e26)) && t2(e26);
    else {
      var a3 = c2 && function(e27) {
        var t3 = e27.parent, r4 = p2.getTokenAfter(e27);
        return !(!r4 || r4.value !== "}" || !t3 || t3.type !== "BlockStatement" || t3.loc.start.line !== t3.loc.end.line);
      }(e26);
      r3 && a3 ? t2(e26, true) : !r3 && !a3 && t2(e26);
    }
  }
  var o2 = /^[\(\+\x2D\/\[`]/, s2 = e25.options[1], u2 = e25.options[0] === "never", c2 = !(!s2 || !s2.omitLastInOneLineBlock), l2 = s2 && s2.beforeStatementContinuationChars || "any", p2 = e25.getSourceCode();
  return { VariableDeclaration: function(e26) {
    var t3 = e26.parent;
    t3.type === "ForStatement" && t3.init === e26 || /^For(?:In|Of)Statement/.test(t3.type) && t3.left === e26 || a2(e26);
  }, ExpressionStatement: a2, ReturnStatement: a2, ThrowStatement: a2, DoWhileStatement: a2, DebuggerStatement: a2, BreakStatement: a2, ContinueStatement: a2, ImportDeclaration: a2, ExportAllDeclaration: a2, ExportNamedDeclaration: function(e26) {
    e26.declaration || a2(e26);
  }, ExportDefaultDeclaration: function(e26) {
    /(?:Class|Function)Declaration/.test(e26.declaration.type) || a2(e26);
  } };
} }, "sort-imports": { meta: { type: "suggestion", docs: { description: "enforce sorted import declarations within modules", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/sort-imports" }, schema: [{ type: "object", properties: { ignoreCase: { type: "boolean", default: false }, memberSyntaxSortOrder: { type: "array", items: { enum: ["none", "all", "multiple", "single"] }, uniqueItems: true, minItems: 4, maxItems: 4 }, ignoreDeclarationSort: { type: "boolean", default: false }, ignoreMemberSort: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "code" }, create: function(e25) {
  function t2(e26) {
    return s2.indexOf(function(e27) {
      return e27.specifiers.length === 0 ? "none" : e27.specifiers[0].type === "ImportNamespaceSpecifier" ? "all" : e27.specifiers.length === 1 ? "single" : "multiple";
    }(e26));
  }
  function r2(e26) {
    return e26.specifiers[0] ? e26.specifiers[0].local.name : null;
  }
  var n2 = e25.options[0] || {}, i2 = n2.ignoreCase || false, a2 = n2.ignoreDeclarationSort || false, o2 = n2.ignoreMemberSort || false, s2 = n2.memberSyntaxSortOrder || ["none", "all", "multiple", "single"], u2 = e25.getSourceCode(), c2 = null;
  return { ImportDeclaration: function(n3) {
    if (!a2) {
      if (c2) {
        var l2 = t2(n3), p2 = t2(c2), f2 = r2(n3), h2 = r2(c2);
        i2 && (h2 = h2 && h2.toLowerCase(), f2 = f2 && f2.toLowerCase()), l2 === p2 ? h2 && f2 && f2 < h2 && e25.report({ node: n3, message: "Imports should be sorted alphabetically." }) : l2 < p2 && e25.report({ node: n3, message: "Expected '{{syntaxA}}' syntax before '{{syntaxB}}' syntax.", data: { syntaxA: s2[l2], syntaxB: s2[p2] } });
      }
      c2 = n3;
    }
    if (!o2) {
      var d2 = n3.specifiers.filter(function(e26) {
        return e26.type === "ImportSpecifier";
      }), m2 = i2 ? function(e26) {
        return e26.local.name.toLowerCase();
      } : function(e26) {
        return e26.local.name;
      }, g2 = d2.map(m2).findIndex(function(e26, t3, r3) {
        return r3[t3 - 1] > e26;
      });
      g2 !== -1 && e25.report({ node: d2[g2], message: "Member '{{memberName}}' of the import declaration should be sorted alphabetically.", data: { memberName: d2[g2].local.name }, fix: function(e26) {
        return d2.some(function(e27) {
          return u2.getCommentsBefore(e27).length || u2.getCommentsAfter(e27).length;
        }) ? null : e26.replaceTextRange([d2[0].range[0], d2[d2.length - 1].range[1]], d2.slice().sort(function(e27, t3) {
          return m2(e27) > m2(t3) ? 1 : -1;
        }).reduce(function(e27, t3, r3) {
          var n4 = r3 === d2.length - 1 ? "" : u2.getText().slice(d2[r3].range[1], d2[r3 + 1].range[0]);
          return e27 + u2.getText(t3) + n4;
        }, ""));
      } });
    }
  } };
} }, "sort-keys": { meta: { type: "suggestion", docs: { description: "require object keys to be sorted", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/sort-keys" }, schema: [{ enum: ["asc", "desc"] }, { type: "object", properties: { caseSensitive: { type: "boolean", default: true }, natural: { type: "boolean", default: false }, minKeys: { type: "integer", minimum: 2, default: 2 } }, additionalProperties: false }] }, create: function(e25) {
  var t2 = e25.options[0] || "asc", r2 = e25.options[1], n2 = r2 && r2.caseSensitive === false, i2 = r2 && r2.natural, a2 = r2 && r2.minKeys, o2 = _N[t2 + (n2 ? "I" : "") + (i2 ? "N" : "")], s2 = null;
  return { ObjectExpression: function(e26) {
    s2 = { upper: s2, prevName: null, numKeys: e26.properties.length };
  }, "ObjectExpression:exit": function() {
    s2 = s2.upper;
  }, SpreadElement: function(e26) {
    e26.parent.type === "ObjectExpression" && (s2.prevName = null);
  }, Property: function(r3) {
    if (r3.parent.type !== "ObjectPattern") {
      var u2 = s2.prevName, c2 = s2.numKeys, l2 = function(e26) {
        var t3 = LA.getStaticPropertyName(e26);
        return t3 === null ? e26.key.name || null : t3;
      }(r3);
      l2 !== null && (s2.prevName = l2), u2 === null || l2 === null || c2 < a2 || !o2(u2, l2) && e25.report({ node: r3, loc: r3.key.loc, message: "Expected object keys to be in {{natual}}{{insensitive}}{{order}}ending order. '{{thisName}}' should be before '{{prevName}}'.", data: { thisName: l2, prevName: u2, order: t2, insensitive: n2 ? "insensitive " : "", natual: i2 ? "natural " : "" } });
    }
  } };
} }, "sort-vars": { meta: { type: "suggestion", docs: { description: "require variables within the same declaration block to be sorted", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/sort-vars" }, schema: [{ type: "object", properties: { ignoreCase: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "code" }, create: function(e25) {
  var t2 = (e25.options[0] || {}).ignoreCase || false, r2 = e25.getSourceCode();
  return { VariableDeclaration: function(n2) {
    var i2 = n2.declarations.filter(function(e26) {
      return e26.id.type === "Identifier";
    }), a2 = t2 ? function(e26) {
      return e26.id.name.toLowerCase();
    } : function(e26) {
      return e26.id.name;
    }, o2 = i2.some(function(e26) {
      return e26.init !== null && e26.init.type !== "Literal";
    }), s2 = false;
    i2.slice(1).reduce(function(t3, n3) {
      var u2 = a2(t3);
      return a2(n3) < u2 ? (e25.report({ node: n3, message: "Variables within the same declaration block should be sorted alphabetically.", fix: function(e26) {
        return o2 || s2 ? null : e26.replaceTextRange([i2[0].range[0], i2[i2.length - 1].range[1]], i2.slice().sort(function(e27, t4) {
          return a2(e27) > a2(t4) ? 1 : -1;
        }).reduce(function(e27, t4, n4) {
          var a3 = n4 === i2.length - 1 ? "" : r2.getText().slice(i2[n4].range[1], i2[n4 + 1].range[0]);
          return e27 + r2.getText(t4) + a3;
        }, ""));
      } }), s2 = true, t3) : n3;
    }, i2[0]);
  } };
} }, "space-before-blocks": { meta: { type: "layout", docs: { description: "enforce consistent spacing before blocks", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/space-before-blocks" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { keywords: { enum: ["always", "never", "off"] }, functions: { enum: ["always", "never", "off"] }, classes: { enum: ["always", "never", "off"] } }, additionalProperties: false }] }] }, create: function(e25) {
  function t2(t3) {
    var r3 = n2.getTokenBefore(t3);
    if (r3 && !function(e26) {
      return e26.type === "Punctuator" && e26.value === "=>" || e26.type === "Keyword";
    }(r3) && LA.isTokenOnSameLine(r3, t3)) {
      var i2, p2, f2 = n2.isSpaceBetweenTokens(r3, t3), h2 = e25.getAncestors().pop();
      h2.type === "FunctionExpression" || h2.type === "FunctionDeclaration" ? (i2 = a2, p2 = u2) : t3.type === "ClassBody" ? (i2 = s2, p2 = l2) : (i2 = o2, p2 = c2), i2 && !f2 ? e25.report({ node: t3, message: "Missing space before opening brace.", fix: function(e26) {
        return e26.insertTextBefore(t3, " ");
      } }) : p2 && f2 && e25.report({ node: t3, message: "Unexpected space before opening brace.", fix: function(e26) {
        return e26.removeRange([r3.range[1], t3.range[0]]);
      } });
    }
  }
  var r2 = e25.options[0], n2 = e25.getSourceCode(), a2 = true, o2 = true, s2 = true, u2 = false, c2 = false, l2 = false;
  return i(r2) == "object" ? (a2 = r2.functions === "always", o2 = r2.keywords === "always", s2 = r2.classes === "always", u2 = r2.functions === "never", c2 = r2.keywords === "never", l2 = r2.classes === "never") : r2 === "never" && (a2 = false, o2 = false, s2 = false, u2 = true, c2 = true, l2 = true), { BlockStatement: t2, ClassBody: t2, SwitchStatement: function(e26) {
    var r3 = e26.cases;
    t2(0 < r3.length ? n2.getTokenBefore(r3[0]) : n2.getLastToken(e26, 1));
  } };
} }, "space-before-function-paren": { meta: { type: "layout", docs: { description: "enforce consistent spacing before `function` definition opening parenthesis", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/space-before-function-paren" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["always", "never"] }, { type: "object", properties: { anonymous: { enum: ["always", "never", "ignore"] }, named: { enum: ["always", "never", "ignore"] }, asyncArrow: { enum: ["always", "never", "ignore"] } }, additionalProperties: false }] }] }, create: function(e25) {
  function t2(e26) {
    if (e26.type !== "ArrowFunctionExpression") {
      if (function(e27) {
        if (e27.id)
          return true;
        var t3 = e27.parent;
        return t3.type === "MethodDefinition" || t3.type === "Property" && (t3.kind === "get" || t3.kind === "set" || t3.method);
      }(e26))
        return o2.named || a2;
      if (!e26.generator)
        return o2.anonymous || a2;
    } else if (e26.async && LA.isOpeningParenToken(n2.getFirstToken(e26, { skip: 1 })))
      return o2.asyncArrow || a2;
    return "ignore";
  }
  function r2(r3) {
    var i2 = t2(r3);
    if (i2 !== "ignore") {
      var a3 = n2.getFirstToken(r3, LA.isOpeningParenToken), o3 = n2.getTokenBefore(a3), s2 = n2.isSpaceBetweenTokens(o3, a3);
      s2 && i2 === "never" ? e25.report({ node: r3, loc: o3.loc.end, message: "Unexpected space before function parentheses.", fix: function(e26) {
        var t3 = n2.getCommentsBefore(a3);
        return t3.some(function(e27) {
          return e27.type === "Line";
        }) ? null : e26.replaceTextRange([o3.range[1], a3.range[0]], t3.reduce(function(e27, t4) {
          return e27 + n2.getText(t4);
        }, ""));
      } }) : !s2 && i2 === "always" && e25.report({ node: r3, loc: o3.loc.end, message: "Missing space before function parentheses.", fix: function(e26) {
        return e26.insertTextAfter(o3, " ");
      } });
    }
  }
  var n2 = e25.getSourceCode(), a2 = typeof e25.options[0] == "string" ? e25.options[0] : "always", o2 = i(e25.options[0]) == "object" ? e25.options[0] : {};
  return { ArrowFunctionExpression: r2, FunctionDeclaration: r2, FunctionExpression: r2 };
} }, "space-in-parens": { meta: { type: "layout", docs: { description: "enforce consistent spacing inside parentheses", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/space-in-parens" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { exceptions: { type: "array", items: { enum: ["{}", "[]", "()", "empty"] }, uniqueItems: true } }, additionalProperties: false }], messages: { missingOpeningSpace: "There must be a space after this paren.", missingClosingSpace: "There must be a space before this paren.", rejectedOpeningSpace: "There should be no space after this paren.", rejectedClosingSpace: "There should be no space before this paren." } }, create: function(e25) {
  function t2(e26) {
    return s2.openers.includes(e26.value);
  }
  function r2(e26) {
    return s2.closers.includes(e26.value);
  }
  function n2(e26, r3) {
    return !p2.isSpaceBetweenTokens(e26, r3) && (l2.empty || !LA.isClosingParenToken(r3)) && (u2 ? !t2(r3) : t2(r3));
  }
  function i2(e26, r3) {
    return !!LA.isTokenOnSameLine(e26, r3) && r3.type !== "Line" && !!p2.isSpaceBetweenTokens(e26, r3) && (u2 ? t2(r3) : !t2(r3));
  }
  function a2(e26, t3) {
    return !p2.isSpaceBetweenTokens(e26, t3) && (l2.empty || !LA.isOpeningParenToken(e26)) && (u2 ? !r2(e26) : r2(e26));
  }
  function o2(e26, t3) {
    return !!LA.isTokenOnSameLine(e26, t3) && !!p2.isSpaceBetweenTokens(e26, t3) && (u2 ? r2(e26) : !r2(e26));
  }
  var s2, u2 = e25.options[0] === "always", c2 = e25.options[1] && e25.options[1].exceptions || [], l2 = {};
  c2.length && (l2.braceException = c2.includes("{}"), l2.bracketException = c2.includes("[]"), l2.parenException = c2.includes("()"), l2.empty = c2.includes("empty"));
  var p2 = e25.getSourceCode();
  return { Program: function(t3) {
    s2 = function() {
      var e26 = [], t4 = [];
      return l2.braceException && (e26.push("{"), t4.push("}")), l2.bracketException && (e26.push("["), t4.push("]")), l2.parenException && (e26.push("("), t4.push(")")), l2.empty && (e26.push(")"), t4.push("(")), { openers: e26, closers: t4 };
    }();
    var r3 = p2.tokensAndComments;
    r3.forEach(function(s3, u3) {
      var c3 = r3[u3 - 1], l3 = r3[u3 + 1];
      (LA.isOpeningParenToken(s3) || LA.isClosingParenToken(s3)) && (s3.value === "(" && n2(s3, l3) && e25.report({ node: t3, loc: s3.loc, messageId: "missingOpeningSpace", fix: function(e26) {
        return e26.insertTextAfter(s3, " ");
      } }), s3.value === "(" && i2(s3, l3) && e25.report({ node: t3, loc: { start: s3.loc.end, end: l3.loc.start }, messageId: "rejectedOpeningSpace", fix: function(e26) {
        return e26.removeRange([s3.range[1], l3.range[0]]);
      } }), s3.value === ")" && a2(c3, s3) && e25.report({ node: t3, loc: s3.loc, messageId: "missingClosingSpace", fix: function(e26) {
        return e26.insertTextBefore(s3, " ");
      } }), s3.value === ")" && o2(c3, s3) && e25.report({ node: t3, loc: { start: c3.loc.end, end: s3.loc.start }, messageId: "rejectedClosingSpace", fix: function(e26) {
        return e26.removeRange([c3.range[1], s3.range[0]]);
      } }));
    });
  } };
} }, "space-infix-ops": { meta: { type: "layout", docs: { description: "require spacing around infix operators", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/space-infix-ops" }, fixable: "whitespace", schema: [{ type: "object", properties: { int32Hint: { type: "boolean", default: false } }, additionalProperties: false }] }, create: function(e25) {
  function t2(e26, t3, r3) {
    var n3 = a2.getFirstTokenBetween(e26, t3, function(e27) {
      return e27.value === r3;
    }), i3 = a2.getTokenBefore(n3), o2 = a2.getTokenAfter(n3);
    return a2.isSpaceBetweenTokens(i3, n3) && a2.isSpaceBetweenTokens(n3, o2) ? null : n3;
  }
  function r2(t3, r3) {
    e25.report({ node: t3, loc: r3.loc, message: "Operator '{{operator}}' must be spaced.", data: { operator: r3.value }, fix: function(e26) {
      var t4 = a2.getTokenBefore(r3), n3 = a2.getTokenAfter(r3), i3 = "";
      return r3.range[0] - t4.range[1] == 0 && (i3 = " "), i3 += r3.value, n3.range[0] - r3.range[1] == 0 && (i3 += " "), e26.replaceText(r3, i3);
    } });
  }
  function n2(e26) {
    var n3 = t2(e26.left.typeAnnotation ? e26.left.typeAnnotation : e26.left, e26.right, e26.operator || "=");
    n3 && (!i2 || !a2.getText(e26).endsWith("|0")) && r2(e26, n3);
  }
  var i2 = !!e25.options[0] && e25.options[0].int32Hint === true, a2 = e25.getSourceCode();
  return { AssignmentExpression: n2, AssignmentPattern: n2, BinaryExpression: n2, LogicalExpression: n2, ConditionalExpression: function(e26) {
    var n3 = t2(e26.test, e26.consequent, "?"), i3 = t2(e26.consequent, e26.alternate, ":");
    n3 ? r2(e26, n3) : i3 && r2(e26, i3);
  }, VariableDeclarator: function(e26) {
    var n3 = e26.id.typeAnnotation ? e26.id.typeAnnotation : e26.id, i3 = e26.init;
    if (i3) {
      var a3 = t2(n3, i3, "=");
      a3 && r2(e26, a3);
    }
  } };
} }, "space-unary-ops": { meta: { type: "layout", docs: { description: "enforce consistent spacing before or after unary operators", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/space-unary-ops" }, fixable: "whitespace", schema: [{ type: "object", properties: { words: { type: "boolean", default: true }, nonwords: { type: "boolean", default: false }, overrides: { type: "object", additionalProperties: { type: "boolean" } } }, additionalProperties: false }], messages: { unexpectedBefore: "Unexpected space before unary operator '{{operator}}'.", unexpectedAfter: "Unexpected space after unary operator '{{operator}}'.", unexpectedAfterWord: "Unexpected space after unary word operator '{{word}}'.", wordOperator: "Unary word operator '{{word}}' must be followed by whitespace.", operator: "Unary operator '{{operator}}' must be followed by whitespace.", beforeUnaryExpressions: "Space is required before unary expressions '{{token}}'." } }, create: function(e25) {
  function t2(e26) {
    return c2.overrides && Object.prototype.hasOwnProperty.call(c2.overrides, e26);
  }
  function r2(e26) {
    return c2.overrides[e26];
  }
  function n2(t3, r3, n3, i3) {
    n3.range[0] === r3.range[1] && e25.report({ node: t3, messageId: "wordOperator", data: { word: i3 }, fix: function(e26) {
      return e26.insertTextAfter(r3, " ");
    } });
  }
  function i2(t3, r3, n3, i3) {
    LA.canTokensBeAdjacent(r3, n3) && n3.range[0] > r3.range[1] && e25.report({ node: t3, messageId: "unexpectedAfterWord", data: { word: i3 }, fix: function(e26) {
      return e26.removeRange([r3.range[1], n3.range[0]]);
    } });
  }
  function a2(e26, a3, o3, s3) {
    t2(s3) ? r2(s3) ? n2(e26, a3, o3, s3) : i2(e26, a3, o3, s3) : c2.words ? n2(e26, a3, o3, s3) : i2(e26, a3, o3, s3);
  }
  function o2(t3, r3, n3) {
    if (t3.prefix) {
      if (function(e26) {
        return e26 && e26.type === "UnaryExpression" && e26.argument.operator === "!" && e26.argument && e26.argument.type === "UnaryExpression" && e26.argument.operator === "!";
      }(t3))
        return;
      r3.range[1] === n3.range[0] && e25.report({ node: t3, messageId: "operator", data: { operator: r3.value }, fix: function(e26) {
        return e26.insertTextAfter(r3, " ");
      } });
    } else
      r3.range[1] === n3.range[0] && e25.report({ node: t3, messageId: "beforeUnaryExpressions", data: { token: n3.value }, fix: function(e26) {
        return e26.insertTextBefore(n3, " ");
      } });
  }
  function s2(t3, r3, n3) {
    t3.prefix ? n3.range[0] > r3.range[1] && e25.report({ node: t3, messageId: "unexpectedAfter", data: { operator: r3.value }, fix: function(e26) {
      return LA.canTokensBeAdjacent(r3, n3) ? e26.removeRange([r3.range[1], n3.range[0]]) : null;
    } }) : n3.range[0] > r3.range[1] && e25.report({ node: t3, messageId: "unexpectedBefore", data: { operator: n3.value }, fix: function(e26) {
      return e26.removeRange([r3.range[1], n3.range[0]]);
    } });
  }
  function u2(e26) {
    var n3 = e26.type !== "UpdateExpression" || e26.prefix ? l2.getFirstTokens(e26, 2) : l2.getLastTokens(e26, 2), i3 = n3[0], u3 = n3[1];
    if (e26.type !== "NewExpression" && !e26.prefix || i3.type !== "Keyword") {
      var p2 = e26.prefix ? n3[0].value : n3[1].value;
      t2(p2) ? r2(p2) ? o2(e26, i3, u3) : s2(e26, i3, u3) : c2.nonwords ? o2(e26, i3, u3) : s2(e26, i3, u3);
    } else
      a2(e26, i3, u3, i3.value);
  }
  var c2 = e25.options[0] || { words: true, nonwords: false }, l2 = e25.getSourceCode();
  return { UnaryExpression: u2, UpdateExpression: u2, NewExpression: u2, YieldExpression: function(e26) {
    var t3 = l2.getFirstTokens(e26, 3);
    !e26.argument || e26.delegate || a2(e26, t3[0], t3[1], "yield");
  }, AwaitExpression: function(e26) {
    var t3 = l2.getFirstTokens(e26, 3);
    a2(e26, t3[0], t3[1], "await");
  } };
} }, "spaced-comment": { meta: { type: "suggestion", docs: { description: "enforce consistent spacing after the `//` or `/*` in a comment", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/spaced-comment" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }, { type: "object", properties: { exceptions: { type: "array", items: { type: "string" } }, markers: { type: "array", items: { type: "string" } }, line: { type: "object", properties: { exceptions: { type: "array", items: { type: "string" } }, markers: { type: "array", items: { type: "string" } } }, additionalProperties: false }, block: { type: "object", properties: { exceptions: { type: "array", items: { type: "string" } }, markers: { type: "array", items: { type: "string" } }, balanced: { type: "boolean", default: false } }, additionalProperties: false } }, additionalProperties: false }] }, create: function(e25) {
  function t2(t3, r3, n3, i3) {
    var o3 = t3.type.toLowerCase() === "block" ? "/*" : "//";
    e25.report({ node: t3, fix: function(e26) {
      var r4 = t3.range[0], i4 = r4 + 2;
      return a2 ? (n3 && (i4 += n3[0].length), e26.insertTextAfterRange([r4, i4], " ")) : (i4 += n3[0].length, e26.replaceTextRange([r4, i4], o3 + (n3[1] ? n3[1] : "")));
    }, message: r3, data: { refChar: i3 } });
  }
  function r2(t3, r3, n3) {
    e25.report({ node: t3, fix: function(e26) {
      if (a2)
        return e26.insertTextAfterRange([t3.range[0], t3.range[1] - 2], " ");
      var r4 = t3.range[1] - 2, i3 = r4 - n3[0].length;
      return e26.replaceTextRange([i3, r4], "");
    }, message: r3 });
  }
  function n2(e26) {
    var n3 = e26.type.toLowerCase(), i3 = u2[n3], o3 = n3 === "block" ? "/*" : "//";
    if (e26.value.length !== 0 && !i3.markers.has(e26.value)) {
      var c2 = i3.beginRegex.exec(e26.value), l2 = i3.endRegex.exec(e26.value);
      if (a2) {
        if (!c2) {
          var p2 = i3.captureMarker.exec(e26.value), f2 = p2 ? o3 + p2[0] : o3;
          i3.hasExceptions ? t2(e26, "Expected exception block, space or tab after '{{refChar}}' in comment.", p2, f2) : t2(e26, "Expected space or tab after '{{refChar}}' in comment.", p2, f2);
        }
        s2 && n3 === "block" && !l2 && r2(e26, "Expected space or tab before '*/' in comment.");
      } else
        c2 && (c2[1] ? t2(e26, "Unexpected space or tab after marker ({{refChar}}) in comment.", c2, c2[1]) : t2(e26, "Unexpected space or tab after '{{refChar}}' in comment.", c2, o3)), s2 && n3 === "block" && l2 && r2(e26, "Unexpected space or tab before '*/' in comment.", l2);
    }
  }
  var i2 = e25.getSourceCode(), a2 = e25.options[0] !== "never", o2 = e25.options[1] || {}, s2 = o2.block && o2.block.balanced, u2 = ["block", "line"].reduce(function(e26, t3) {
    var r3 = function(e27) {
      return e27.indexOf("*") === -1 ? e27.concat("*") : e27;
    }(o2[t3] && o2[t3].markers || o2.markers || []), n3 = o2[t3] && o2[t3].exceptions || o2.exceptions || [];
    return e26[t3] = { beginRegex: a2 ? BN(r3, n3) : ON(r3), endRegex: s2 && a2 ? new RegExp("".concat(IN(n3), "$"), "u") : new RegExp("[ 	]+$", "u"), hasExceptions: 0 < n3.length, captureMarker: new RegExp("^(".concat(r3.map(TN).join("|"), ")"), "u"), markers: new Set(r3) }, e26;
  }, {});
  return { Program: function() {
    i2.getAllComments().filter(function(e26) {
      return e26.type !== "Shebang";
    }).forEach(n2);
  } };
} }, strict: { meta: { type: "suggestion", docs: { description: "require or disallow strict mode directives", category: "Strict Mode", recommended: false, url: "https://eslint.org/docs/rules/strict" }, schema: [{ enum: ["never", "global", "function", "safe"] }], fixable: "code", messages: { function: "Use the function form of 'use strict'.", global: "Use the global form of 'use strict'.", multiple: "Multiple 'use strict' directives.", never: "Strict mode is not permitted.", unnecessary: "Unnecessary 'use strict' directive.", module: "'use strict' is unnecessary inside of modules.", implied: "'use strict' is unnecessary when implied strict mode is enabled.", unnecessaryInClasses: "'use strict' is unnecessary inside of classes.", nonSimpleParameterList: "'use strict' directive inside a function with non-simple parameter list throws a syntax error since ES2016.", wrap: "Wrap {{name}} in a function with 'use strict' directive." } }, create: function(e25) {
  function t2(e26) {
    return e26 === "multiple" || e26 === "unnecessary" || e26 === "module" || e26 === "implied" || e26 === "unnecessaryInClasses";
  }
  function r2(e26) {
    return function(t3) {
      return t3.remove(e26);
    };
  }
  function n2(t3, n3, i3, a3, o3) {
    t3.slice(n3, i3).forEach(function(t4) {
      e25.report({ node: t4, messageId: a3, fix: o3 ? r2(t4) : null });
    });
  }
  function i2(e26, t3, r3) {
    n2(e26, 0, e26.length, t3, r3);
  }
  function a2(e26, t3, r3) {
    n2(e26, 1, e26.length, t3, r3);
  }
  function o2(t3, n3) {
    var i3 = 0 < p2.length, o3 = l2.length === 0 && p2.length === 0, s3 = 0 < l2.length && l2[l2.length - 1], u3 = 0 < n3.length;
    u3 ? (jN(t3.params) ? s3 ? e25.report({ node: n3[0], messageId: "unnecessary", fix: r2(n3[0]) }) : i3 && e25.report({ node: n3[0], messageId: "unnecessaryInClasses", fix: r2(n3[0]) }) : e25.report({ node: n3[0], messageId: "nonSimpleParameterList" }), a2(n3, "multiple", true)) : o3 && (jN(t3.params) ? e25.report({ node: t3, messageId: "function" }) : e25.report({ node: t3, messageId: "wrap", data: { name: LA.getFunctionNameWithKind(t3) } })), l2.push(s3 || u3);
  }
  function s2() {
    l2.pop();
  }
  function u2(r3) {
    var n3 = r3.body.type === "BlockStatement" ? LN(r3.body.body) : [];
    f2 === "function" ? o2(r3, n3) : 0 < n3.length && (jN(r3.params) ? i2(n3, f2, t2(f2)) : (e25.report({ node: n3[0], messageId: "nonSimpleParameterList" }), a2(n3, "multiple", true)));
  }
  var c2 = e25.parserOptions.ecmaFeatures || {}, l2 = [], p2 = [], f2 = e25.options[0] || "safe";
  c2.impliedStrict ? f2 = "implied" : f2 === "safe" && (f2 = c2.globalReturn ? "global" : "function");
  var h2 = { Program: function(r3) {
    var n3 = LN(r3.body);
    r3.sourceType === "module" && (f2 = "module"), f2 === "global" ? (0 < r3.body.length && n3.length === 0 && e25.report({ node: r3, messageId: "global" }), a2(n3, "multiple", true)) : i2(n3, f2, t2(f2));
  }, FunctionDeclaration: u2, FunctionExpression: u2, ArrowFunctionExpression: u2 };
  return f2 === "function" && Object.assign(h2, { ClassBody: function() {
    p2.push(true);
  }, "ClassBody:exit": function() {
    p2.pop();
  }, "FunctionDeclaration:exit": s2, "FunctionExpression:exit": s2, "ArrowFunctionExpression:exit": s2 }), h2;
} }, "switch-colon-spacing": { meta: { type: "layout", docs: { description: "enforce spacing around colons of switch statements", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/switch-colon-spacing" }, schema: [{ type: "object", properties: { before: { type: "boolean", default: false }, after: { type: "boolean", default: true } }, additionalProperties: false }], fixable: "whitespace", messages: { expectedBefore: "Expected space(s) before this colon.", expectedAfter: "Expected space(s) after this colon.", unexpectedBefore: "Unexpected space(s) before this colon.", unexpectedAfter: "Unexpected space(s) after this colon." } }, create: function(e25) {
  function t2(e26, t3, r3) {
    return LA.isClosingBraceToken(t3) || !LA.isTokenOnSameLine(e26, t3) || n2.isSpaceBetweenTokens(e26, t3) === r3;
  }
  function r2(e26, t3, r3, i3) {
    return function(e27, t4) {
      return n2.getFirstTokenBetween(e27, t4, { includeComments: true, filter: LA.isCommentToken }) !== null;
    }(t3, r3) ? null : i3 ? e26.insertTextAfter(t3, " ") : e26.removeRange([t3.range[1], r3.range[0]]);
  }
  var n2 = e25.getSourceCode(), i2 = e25.options[0] || {}, a2 = i2.before === true, o2 = i2.after !== false;
  return { SwitchCase: function(i3) {
    var s2 = function(e26) {
      return e26.test ? n2.getTokenAfter(e26.test, LA.isColonToken) : n2.getFirstToken(e26, 1);
    }(i3), u2 = n2.getTokenBefore(s2), c2 = n2.getTokenAfter(s2);
    t2(u2, s2, a2) || e25.report({ node: i3, loc: s2.loc, messageId: a2 ? "expectedBefore" : "unexpectedBefore", fix: function(e26) {
      return r2(e26, u2, s2, a2);
    } }), t2(s2, c2, o2) || e25.report({ node: i3, loc: s2.loc, messageId: o2 ? "expectedAfter" : "unexpectedAfter", fix: function(e26) {
      return r2(e26, s2, c2, o2);
    } });
  } };
} }, "symbol-description": { meta: { type: "suggestion", docs: { description: "require symbol descriptions", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/symbol-description" }, fixable: null, schema: [], messages: { expected: "Expected Symbol to have a description." } }, create: function(e25) {
  function t2(t3) {
    t3.arguments.length === 0 && e25.report({ node: t3, messageId: "expected" });
  }
  return { "Program:exit": function() {
    var r2 = e25.getScope(), n2 = LA.getVariableByName(r2, "Symbol");
    n2 && n2.defs.length === 0 && n2.references.forEach(function(e26) {
      var r3 = e26.identifier;
      LA.isCallee(r3) && t2(r3.parent);
    });
  } };
} }, "template-curly-spacing": { meta: { type: "layout", docs: { description: "require or disallow spacing around embedded expressions of template strings", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/template-curly-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }], messages: { expectedBefore: "Expected space(s) before '}'.", expectedAfter: "Expected space(s) after '${'.", unexpectedBefore: "Unexpected space(s) before '}'.", unexpectedAfter: "Unexpected space(s) after '${'." } }, create: function(e25) {
  function t2(t3) {
    var r3 = n2.getTokenBefore(t3);
    r3 && MN.test(t3.value) && LA.isTokenOnSameLine(r3, t3) && n2.isSpaceBetweenTokens(r3, t3) !== i2 && e25.report({ loc: t3.loc.start, messageId: "".concat(a2, "Before"), fix: function(e26) {
      return i2 ? e26.insertTextBefore(t3, " ") : e26.removeRange([r3.range[1], t3.range[0]]);
    } });
  }
  function r2(t3) {
    var r3 = n2.getTokenAfter(t3);
    r3 && RN.test(t3.value) && LA.isTokenOnSameLine(t3, r3) && n2.isSpaceBetweenTokens(t3, r3) !== i2 && e25.report({ loc: { line: t3.loc.end.line, column: t3.loc.end.column - 2 }, messageId: "".concat(a2, "After"), fix: function(e26) {
      return i2 ? e26.insertTextAfter(t3, " ") : e26.removeRange([t3.range[1], r3.range[0]]);
    } });
  }
  var n2 = e25.getSourceCode(), i2 = e25.options[0] === "always", a2 = i2 ? "expected" : "unexpected";
  return { TemplateElement: function(e26) {
    var i3 = n2.getFirstToken(e26);
    t2(i3), r2(i3);
  } };
} }, "template-tag-spacing": { meta: { type: "layout", docs: { description: "require or disallow spacing between template tags and their literals", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/template-tag-spacing" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }], messages: { unexpected: "Unexpected space between template tag and template literal.", missing: "Missing space between template tag and template literal." } }, create: function(e25) {
  var t2 = e25.options[0] !== "always", r2 = e25.getSourceCode();
  return { TaggedTemplateExpression: function(n2) {
    var i2 = r2.getTokenBefore(n2.quasi), a2 = r2.getFirstToken(n2.quasi), o2 = r2.isSpaceBetweenTokens(i2, a2);
    t2 && o2 ? e25.report({ node: n2, loc: i2.loc.start, messageId: "unexpected", fix: function(e26) {
      var t3 = r2.getCommentsBefore(n2.quasi);
      return t3.some(function(e27) {
        return e27.type === "Line";
      }) ? null : e26.replaceTextRange([i2.range[1], a2.range[0]], t3.reduce(function(e27, t4) {
        return e27 + r2.getText(t4);
      }, ""));
    } }) : !t2 && !o2 && e25.report({ node: n2, loc: i2.loc.start, messageId: "missing", fix: function(e26) {
      return e26.insertTextAfter(i2, " ");
    } });
  } };
} }, "unicode-bom": { meta: { type: "layout", docs: { description: "require or disallow Unicode byte order mark (BOM)", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/unicode-bom" }, fixable: "whitespace", schema: [{ enum: ["always", "never"] }], messages: { expected: "Expected Unicode BOM (Byte Order Mark).", unexpected: "Unexpected Unicode BOM (Byte Order Mark)." } }, create: function(e25) {
  return { Program: function(t2) {
    var r2 = e25.getSourceCode(), n2 = { column: 0, line: 1 }, i2 = e25.options[0] || "never";
    r2.hasBOM || i2 !== "always" ? r2.hasBOM && i2 === "never" && e25.report({ node: t2, loc: n2, messageId: "unexpected", fix: function(e26) {
      return e26.removeRange([-1, 0]);
    } }) : e25.report({ node: t2, loc: n2, messageId: "expected", fix: function(e26) {
      return e26.insertTextBeforeRange([0, 1], "\uFEFF");
    } });
  } };
} }, "use-isnan": { meta: { type: "problem", docs: { description: "require calls to `isNaN()` when checking for `NaN`", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/use-isnan" }, schema: [{ type: "object", properties: { enforceForSwitchCase: { type: "boolean", default: false }, enforceForIndexOf: { type: "boolean", default: false } }, additionalProperties: false }], messages: { comparisonWithNaN: "Use the isNaN function to compare with NaN.", switchNaN: "'switch(NaN)' can never match a case clause. Use Number.isNaN instead of the switch.", caseNaN: "'case NaN' can never match. Use Number.isNaN before the switch.", indexOfNaN: "Array prototype method '{{ methodName }}' cannot find NaN." } }, create: function(e25) {
  var t2 = e25.options[0] && e25.options[0].enforceForSwitchCase, r2 = e25.options[0] && e25.options[0].enforceForIndexOf, n2 = { BinaryExpression: function(t3) {
    /^(?:[<>]|[!=]=)=?$/.test(t3.operator) && (VN(t3.left) || VN(t3.right)) && e25.report({ node: t3, messageId: "comparisonWithNaN" });
  } };
  return t2 && (n2.SwitchStatement = function(t3) {
    VN(t3.discriminant) && e25.report({ node: t3, messageId: "switchNaN" });
    var r3 = true, n3 = false, i2 = void 0;
    try {
      for (var a2, o2 = t3.cases[Symbol.iterator](); !(r3 = (a2 = o2.next()).done); r3 = true) {
        var s2 = a2.value;
        VN(s2.test) && e25.report({ node: s2, messageId: "caseNaN" });
      }
    } catch (e26) {
      n3 = true, i2 = e26;
    } finally {
      try {
        r3 || o2.return == null || o2.return();
      } finally {
        if (n3)
          throw i2;
      }
    }
  }), r2 && (n2.CallExpression = function(t3) {
    var r3 = t3.callee;
    if (r3.type === "MemberExpression") {
      var n3 = LA.getStaticPropertyName(r3);
      (n3 === "indexOf" || n3 === "lastIndexOf") && t3.arguments.length === 1 && VN(t3.arguments[0]) && e25.report({ node: t3, messageId: "indexOfNaN", data: { methodName: n3 } });
    }
  }), n2;
} }, "valid-jsdoc": { meta: { type: "suggestion", docs: { description: "enforce valid JSDoc comments", category: "Possible Errors", recommended: false, url: "https://eslint.org/docs/rules/valid-jsdoc" }, schema: [{ type: "object", properties: { prefer: { type: "object", additionalProperties: { type: "string" } }, preferType: { type: "object", additionalProperties: { type: "string" } }, requireReturn: { type: "boolean", default: true }, requireParamDescription: { type: "boolean", default: true }, requireReturnDescription: { type: "boolean", default: true }, matchDescription: { type: "string" }, requireReturnType: { type: "boolean", default: true }, requireParamType: { type: "boolean", default: true } }, additionalProperties: false }], fixable: "code", messages: { unexpectedTag: "Unexpected @{{title}} tag; function has no return statement.", expected: "Expected JSDoc for '{{name}}' but found '{{jsdocName}}'.", use: "Use @{{name}} instead.", useType: "Use '{{expectedTypeName}}' instead of '{{currentTypeName}}'.", syntaxError: "JSDoc syntax error.", missingBrace: "JSDoc type missing brace.", missingParamDesc: "Missing JSDoc parameter description for '{{name}}'.", missingParamType: "Missing JSDoc parameter type for '{{name}}'.", missingReturnType: "Missing JSDoc return type.", missingReturnDesc: "Missing JSDoc return description.", missingReturn: "Missing JSDoc @{{returns}} for function.", missingParam: "Missing JSDoc for parameter '{{name}}'.", duplicateParam: "Duplicate JSDoc parameter '{{name}}'.", unsatisfiedDesc: "JSDoc description does not satisfy the regex pattern." }, deprecated: true, replacedBy: [] }, create: function(e25) {
  function t2(e26) {
    return e26.type === "ClassExpression" || e26.type === "ClassDeclaration";
  }
  function r2(e26) {
    v2.push({ returnPresent: e26.type === "ArrowFunctionExpression" && e26.body.type !== "BlockStatement" || t2(e26) || e26.async });
  }
  function n2(e26) {
    return e26.type === null || e26.type.name === "void" || e26.type.type === "UndefinedLiteral";
  }
  function i2(e26) {
    var t3;
    return e26.name ? t3 = e26 : e26.expression && (t3 = e26.expression), { currentType: t3, expectedTypeName: t3 && g2[t3.name] };
  }
  function a2(e26, t3) {
    return { start: l2.getLocFromIndex(e26.range[0] + 2 + t3.range[0]), end: l2.getLocFromIndex(e26.range[0] + 2 + t3.range[1]) };
  }
  function o2(t3, r3) {
    if (r3 && function(e26) {
      return e26 !== "UndefinedLiteral" && e26 !== "NullLiteral" && e26 !== "NullableLiteral" && e26 !== "FunctionType" && e26 !== "AllLiteral";
    }(r3.type)) {
      var n3 = [], s3 = [];
      switch (r3.type) {
        case "TypeApplication":
          s3 = r3.applications[0].type === "UnionType" ? r3.applications[0].elements : r3.applications, n3.push(i2(r3));
          break;
        case "RecordType":
          s3 = r3.fields;
          break;
        case "UnionType":
        case "ArrayType":
          s3 = r3.elements;
          break;
        case "FieldType":
          r3.value && n3.push(i2(r3.value));
          break;
        default:
          n3.push(i2(r3));
      }
      s3.forEach(o2.bind(null, t3)), n3.forEach(function(r4) {
        r4.expectedTypeName && r4.expectedTypeName !== r4.currentType.name && e25.report({ node: t3, messageId: "useType", loc: a2(t3, r4.currentType), data: { currentTypeName: r4.currentType.name, expectedTypeName: r4.expectedTypeName }, fix: function(e26) {
          return e26.replaceTextRange(r4.currentType.range.map(function(e27) {
            return t3.range[0] + 2 + e27;
          }), r4.expectedTypeName);
        } });
      });
    }
  }
  function s2(r3) {
    var i3, s3 = l2.getJSDocComment(r3), g3 = v2.pop(), x2 = Object.create(null), b2 = [], E2 = false, C2 = false, S2 = false, k2 = false, D2 = false;
    if (s3) {
      var F2;
      try {
        F2 = OA.parse(s3.value, { strict: true, unwrap: true, sloppy: true, range: true });
      } catch (t3) {
        return void (/brace[s\u017F]/i.test(t3.message) ? e25.report({ node: s3, messageId: "missingBrace" }) : e25.report({ node: s3, messageId: "syntaxError" }));
      }
      F2.tags.forEach(function(t3) {
        switch (t3.title.toLowerCase()) {
          case "param":
          case "arg":
          case "argument":
            b2.push(t3);
            break;
          case "return":
          case "returns":
            E2 = true, i3 = t3;
            break;
          case "constructor":
          case "class":
            C2 = true;
            break;
          case "override":
          case "inheritdoc":
            k2 = true;
            break;
          case "abstract":
          case "virtual":
            D2 = true;
            break;
          case "interface":
            S2 = true;
        }
        if (Object.prototype.hasOwnProperty.call(c2, t3.title) && t3.title !== c2[t3.title]) {
          var r4 = a2(s3, t3);
          e25.report({ node: s3, messageId: "use", loc: { start: r4.start, end: { line: r4.start.line, column: r4.start.column + "@".concat(t3.title).length } }, data: { name: c2[t3.title] }, fix: function(e26) {
            return e26.replaceTextRange([s3.range[0] + t3.range[0] + 3, s3.range[0] + t3.range[0] + t3.title.length + 3], c2[t3.title]);
          } });
        }
        y2 && t3.type && o2(s3, t3.type);
      }), b2.forEach(function(t3) {
        m2 && !t3.type && e25.report({ node: s3, messageId: "missingParamType", loc: a2(s3, t3), data: { name: t3.name } }), !t3.description && f2 && e25.report({ node: s3, messageId: "missingParamDesc", loc: a2(s3, t3), data: { name: t3.name } }), x2[t3.name] ? e25.report({ node: s3, messageId: "duplicateParam", loc: a2(s3, t3), data: { name: t3.name } }) : t3.name.indexOf(".") === -1 && (x2[t3.name] = t3);
      }), E2 && (p2 || g3.returnPresent || i3.type !== null && n2(i3) || D2 ? (d2 && !i3.type && e25.report({ node: s3, messageId: "missingReturnType" }), !n2(i3) && !i3.description && h2 && e25.report({ node: s3, messageId: "missingReturnDesc" })) : e25.report({ node: s3, messageId: "unexpectedTag", loc: a2(s3, i3), data: { title: i3.title } })), k2 || E2 || C2 || S2 || r3.parent.kind === "get" || r3.parent.kind === "constructor" || r3.parent.kind === "set" || t2(r3) || !p2 && (!g3.returnPresent || r3.async) || e25.report({ node: s3, messageId: "missingReturn", data: { returns: c2.returns || "returns" } });
      var A2 = Object.keys(x2);
      if (r3.params && r3.params.forEach(function(t3, r4) {
        var n3 = t3.type === "AssignmentPattern" ? t3.left : t3;
        if (n3.type === "Identifier") {
          var i4 = n3.name;
          A2[r4] && i4 !== A2[r4] ? e25.report({ node: s3, messageId: "expected", loc: a2(s3, x2[A2[r4]]), data: { name: i4, jsdocName: A2[r4] } }) : !x2[i4] && !k2 && e25.report({ node: s3, messageId: "missingParam", data: { name: i4 } });
        }
      }), u2.matchDescription)
        new RegExp(u2.matchDescription, "u").test(F2.description) || e25.report({ node: s3, messageId: "unsatisfiedDesc" });
    }
  }
  var u2 = e25.options[0] || {}, c2 = u2.prefer || {}, l2 = e25.getSourceCode(), p2 = u2.requireReturn !== false, f2 = u2.requireParamDescription !== false, h2 = u2.requireReturnDescription !== false, d2 = u2.requireReturnType !== false, m2 = u2.requireParamType !== false, g2 = u2.preferType || {}, y2 = Object.keys(g2).length !== 0, v2 = [];
  return { ArrowFunctionExpression: r2, FunctionExpression: r2, FunctionDeclaration: r2, ClassExpression: r2, ClassDeclaration: r2, "ArrowFunctionExpression:exit": s2, "FunctionExpression:exit": s2, "FunctionDeclaration:exit": s2, "ClassExpression:exit": s2, "ClassDeclaration:exit": s2, ReturnStatement: function(e26) {
    var t3 = v2[v2.length - 1];
    t3 && e26.argument !== null && (t3.returnPresent = true);
  } };
} }, "valid-typeof": { meta: { type: "problem", docs: { description: "enforce comparing `typeof` expressions against valid strings", category: "Possible Errors", recommended: true, url: "https://eslint.org/docs/rules/valid-typeof" }, schema: [{ type: "object", properties: { requireStringLiterals: { type: "boolean", default: false } }, additionalProperties: false }], messages: { invalidValue: "Invalid typeof comparison value.", notString: "Typeof comparisons should be to string literals." } }, create: function(e25) {
  function t2(e26) {
    return e26.type === "UnaryExpression" && e26.operator === "typeof";
  }
  var r2 = ["symbol", "undefined", "object", "boolean", "number", "string", "function", "bigint"], n2 = ["==", "===", "!=", "!=="], i2 = e25.options[0] && e25.options[0].requireStringLiterals;
  return { UnaryExpression: function(a2) {
    if (t2(a2)) {
      var o2 = e25.getAncestors().pop();
      if (o2.type === "BinaryExpression" && n2.indexOf(o2.operator) !== -1) {
        var s2 = o2.left === a2 ? o2.right : o2.left;
        if (s2.type === "Literal" || s2.type === "TemplateLiteral" && !s2.expressions.length) {
          var u2 = s2.type === "Literal" ? s2.value : s2.quasis[0].value.cooked;
          r2.indexOf(u2) === -1 && e25.report({ node: s2, messageId: "invalidValue" });
        } else
          i2 && !t2(s2) && e25.report({ node: s2, messageId: "notString" });
      }
    }
  } };
} }, "vars-on-top": { meta: { type: "suggestion", docs: { description: "require `var` declarations be placed at the top of their containing scope", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/vars-on-top" }, schema: [], messages: { top: "All 'var' declarations must be at the top of the function scope." } }, create: function(e25) {
  function t2(e26) {
    return e26.type === "ExpressionStatement" && e26.expression.type === "Literal" && typeof e26.expression.value == "string";
  }
  function r2(e26) {
    return e26.type === "ImportDeclaration" || e26.type === "ImportSpecifier" || e26.type === "ImportDefaultSpecifier" || e26.type === "ImportNamespaceSpecifier";
  }
  function n2(e26) {
    return e26.type === "VariableDeclaration" || e26.type === "ExportNamedDeclaration" && e26.declaration && e26.declaration.type === "VariableDeclaration";
  }
  function i2(e26, i3) {
    for (var a3 = i3.length, o3 = 0; o3 < a3 && (t2(i3[o3]) || r2(i3[o3])); ++o3)
      ;
    for (; o3 < a3; ++o3) {
      if (!n2(i3[o3]))
        return false;
      if (i3[o3] === e26)
        return true;
    }
    return false;
  }
  function a2(t3, r3) {
    i2(t3, r3.body) || e25.report({ node: t3, messageId: "top" });
  }
  function o2(t3, r3, n3) {
    /Function/.test(n3.type) && r3.type === "BlockStatement" && i2(t3, r3.body) || e25.report({ node: t3, messageId: "top" });
  }
  return { "VariableDeclaration[kind='var']": function(e26) {
    e26.parent.type === "ExportNamedDeclaration" ? a2(e26.parent, e26.parent.parent) : e26.parent.type === "Program" ? a2(e26, e26.parent) : o2(e26, e26.parent, e26.parent.parent);
  } };
} }, "wrap-iife": { meta: { type: "layout", docs: { description: "require parentheses around immediate `function` invocations", category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/wrap-iife" }, schema: [{ enum: ["outside", "inside", "any"] }, { type: "object", properties: { functionPrototypeMethods: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "code", messages: { wrapInvocation: "Wrap an immediate function invocation in parentheses.", wrapExpression: "Wrap only the function expression in parens.", moveInvocation: "Move the invocation into the parens that contain the function." } }, create: function(e25) {
  function t2(e26) {
    return LA.isParenthesised(a2, e26);
  }
  function r2(e26) {
    var t3 = e26.callee;
    return t3.type === "FunctionExpression" ? t3 : !i2 || t3.type !== "MemberExpression" || t3.object.type !== "FunctionExpression" || LA.getStaticPropertyName(t3) !== "call" && LA.getStaticPropertyName(t3) !== "apply" ? null : t3.object;
  }
  var n2 = e25.options[0] || "outside", i2 = e25.options[1] && e25.options[1].functionPrototypeMethods, a2 = e25.getSourceCode();
  return { CallExpression: function(i3) {
    var o2 = r2(i3);
    if (o2) {
      var s2 = t2(i3), u2 = t2(o2);
      s2 || u2 ? n2 !== "inside" || u2 ? n2 === "outside" && !s2 && e25.report({ node: i3, messageId: "moveInvocation", fix: function(e26) {
        var t3 = a2.getTokenAfter(o2);
        return e26.replaceTextRange([t3.range[0], i3.range[1]], "".concat(a2.getText().slice(t3.range[1], i3.range[1]), ")"));
      } }) : e25.report({ node: i3, messageId: "wrapExpression", fix: function(e26) {
        var t3 = a2.getTokenAfter(i3);
        return e26.replaceTextRange([o2.range[1], t3.range[1]], ")".concat(a2.getText().slice(o2.range[1], t3.range[0])));
      } }) : e25.report({ node: i3, messageId: "wrapInvocation", fix: function(e26) {
        var t3 = n2 === "inside" ? o2 : i3;
        return e26.replaceText(t3, "(".concat(a2.getText(t3), ")"));
      } });
    }
  } };
} }, "wrap-regex": { meta: { type: "layout", docs: { description: "require parenthesis around regex literals", category: "Stylistic Issues", recommended: false, url: "https://eslint.org/docs/rules/wrap-regex" }, schema: [], fixable: "code", messages: { requireParens: "Wrap the regexp literal in parens to disambiguate the slash." } }, create: function(e25) {
  var t2 = e25.getSourceCode();
  return { Literal: function(r2) {
    if (t2.getFirstToken(r2).type === "RegularExpression") {
      var n2 = t2.getTokenBefore(r2), i2 = t2.getTokenAfter(r2), a2 = e25.getAncestors(), o2 = a2[a2.length - 1];
      o2.type !== "MemberExpression" || o2.object !== r2 || n2 && n2.value === "(" && i2 && i2.value === ")" || e25.report({ node: r2, messageId: "requireParens", fix: function(e26) {
        return e26.replaceText(r2, "(".concat(t2.getText(r2), ")"));
      } });
    }
  } };
} }, "yield-star-spacing": { meta: { type: "layout", docs: { description: "require or disallow spacing around the `*` in `yield*` expressions", category: "ECMAScript 6", recommended: false, url: "https://eslint.org/docs/rules/yield-star-spacing" }, fixable: "whitespace", schema: [{ oneOf: [{ enum: ["before", "after", "both", "neither"] }, { type: "object", properties: { before: { type: "boolean" }, after: { type: "boolean" } }, additionalProperties: false }] }], messages: { missingBefore: "Missing space before *.", missingAfter: "Missing space after *.", unexpectedBefore: "Unexpected space before *.", unexpectedAfter: "Unexpected space after *." } }, create: function(e25) {
  function t2(t3, i2, a2) {
    if (r2.isSpaceBetweenTokens(i2, a2) !== n2[t3]) {
      var o2, s2 = i2.value === "*", u2 = n2[t3], c2 = s2 ? i2 : a2;
      o2 = u2 ? t3 === "before" ? "missingBefore" : "missingAfter" : t3 === "before" ? "unexpectedBefore" : "unexpectedAfter", e25.report({ node: c2, messageId: o2, fix: function(e26) {
        return u2 ? s2 ? e26.insertTextAfter(c2, " ") : e26.insertTextBefore(c2, " ") : e26.removeRange([i2.range[1], a2.range[0]]);
      } });
    }
  }
  var r2 = e25.getSourceCode(), n2 = function(e26) {
    return e26 && typeof e26 != "string" ? e26 : { before: { before: true, after: false }, after: { before: false, after: true }, both: { before: true, after: true }, neither: { before: false, after: false } }[e26 || "after"];
  }(e25.options[0]);
  return { YieldExpression: function(e26) {
    if (e26.delegate) {
      var n3 = r2.getFirstTokens(e26, 3), i2 = n3[0], a2 = n3[1], o2 = n3[2];
      t2("before", i2, a2), t2("after", a2, o2);
    }
  } };
} }, yoda: { meta: { type: "suggestion", docs: { description: 'require or disallow "Yoda" conditions', category: "Best Practices", recommended: false, url: "https://eslint.org/docs/rules/yoda" }, schema: [{ enum: ["always", "never"] }, { type: "object", properties: { exceptRange: { type: "boolean", default: false }, onlyEquality: { type: "boolean", default: false } }, additionalProperties: false }], fixable: "code", messages: { expected: "Expected literal to be on the {{expectedSide}} side of {{operator}}." } }, create: function(e25) {
  function t2(e26) {
    var t3 = e26.left, r3 = e26.right;
    return e26.type === "LogicalExpression" && t3.type === "BinaryExpression" && r3.type === "BinaryExpression" && UN(t3.operator) && UN(r3.operator) && (function() {
      var n3, i3;
      return e26.operator === "&&" && (n3 = WN(t3.left)) && (i3 = WN(r3.right, Number.POSITIVE_INFINITY)) && n3.value <= i3.value && $N(t3.right, r3.left);
    }() || function() {
      var n3, i3;
      return e26.operator === "||" && (n3 = WN(t3.right, Number.NEGATIVE_INFINITY)) && (i3 = WN(r3.left)) && n3.value <= i3.value && $N(t3.left, r3.right);
    }()) && LA.isParenthesised(o2, e26);
  }
  function r2(e26) {
    var t3 = o2.getTokenBefore(e26), r3 = o2.getFirstTokenBetween(e26.left, e26.right, function(t4) {
      return t4.value === e26.operator;
    }), n3 = o2.getText().slice(o2.getTokenBefore(r3).range[1], r3.range[0]), i3 = o2.getText().slice(r3.range[1], o2.getTokenAfter(r3).range[0]), a3 = o2.getText().slice(e26.range[0], o2.getTokenBefore(r3).range[1]), u2 = o2.getTokenAfter(r3), c2 = o2.getText().slice(u2.range[0], e26.range[1]), l2 = "";
    return t3 && t3.range[1] === e26.range[0] && !LA.canTokensBeAdjacent(t3, u2) && (l2 = " "), l2 + c2 + n3 + s2[r3.value] + i3 + a3;
  }
  var n2 = e25.options[0] === "always", i2 = e25.options[1] && e25.options[1].exceptRange, a2 = e25.options[1] && e25.options[1].onlyEquality, o2 = e25.getSourceCode(), s2 = { "===": "===", "!==": "!==", "==": "==", "!=": "!=", "<": ">", ">": "<", "<=": ">=", ">=": "<=" };
  return { BinaryExpression: function(o3) {
    var s3 = n2 ? o3.left : o3.right, u2 = n2 ? o3.right : o3.left;
    u2.type !== "Literal" && !qN(u2) || s3.type === "Literal" || qN(s3) || !function(e26) {
      return /^(==|===)$/.test(e26);
    }(o3.operator) && a2 || !function(e26) {
      return /^(==|===|!=|!==|<|>|<=|>=)$/.test(e26);
    }(o3.operator) || i2 && t2(e25.getAncestors().pop()) || e25.report({ node: o3, messageId: "expected", data: { operator: o3.operator, expectedSide: n2 ? "left" : "right" }, fix: function(e26) {
      return e26.replaceText(o3, r2(o3));
    } });
  } };
} } }, zN = function(e25) {
  function t2() {
    var e26;
    return a(this, t2), (e26 = v(this, h(t2).call(this))).defineRules(GN), e26;
  }
  return f(t2, AD.linter_1), t2;
}();
var parserBabel$1 = { exports: {} };
(function(module2, exports2) {
  (function(e25) {
    module2.exports = e25();
  })(function() {
    var v2 = (l2, h2) => () => (h2 || l2((h2 = { exports: {} }).exports, h2), h2.exports);
    var le2 = v2((md2, oi2) => {
      var St2 = function(l2) {
        return l2 && l2.Math == Math && l2;
      };
      oi2.exports = St2(typeof globalThis == "object" && globalThis) || St2(typeof window == "object" && window) || St2(typeof self == "object" && self) || St2(typeof commonjsGlobal == "object" && commonjsGlobal) || function() {
        return this;
      }() || Function("return this")();
    });
    var he2 = v2((yd2, li2) => {
      li2.exports = function(l2) {
        try {
          return !!l2();
        } catch {
          return true;
        }
      };
    });
    var ve2 = v2((xd2, hi2) => {
      var Nh2 = he2();
      hi2.exports = !Nh2(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    });
    var wt2 = v2((gd2, ui2) => {
      var kh2 = he2();
      ui2.exports = !kh2(function() {
        var l2 = function() {
        }.bind();
        return typeof l2 != "function" || l2.hasOwnProperty("prototype");
      });
    });
    var Nt2 = v2((Pd2, ci2) => {
      var Dh2 = wt2(), It2 = Function.prototype.call;
      ci2.exports = Dh2 ? It2.bind(It2) : function() {
        return It2.apply(It2, arguments);
      };
    });
    var mi2 = v2((di2) => {
      var pi2 = {}.propertyIsEnumerable, fi2 = Object.getOwnPropertyDescriptor, Fh2 = fi2 && !pi2.call({ 1: 2 }, 1);
      di2.f = Fh2 ? function(h2) {
        var f2 = fi2(this, h2);
        return !!f2 && f2.enumerable;
      } : pi2;
    });
    var As2 = v2((Td2, yi2) => {
      yi2.exports = function(l2, h2) {
        return { enumerable: !(l2 & 1), configurable: !(l2 & 2), writable: !(l2 & 4), value: h2 };
      };
    });
    var ue2 = v2((vd2, Pi2) => {
      var xi2 = wt2(), gi2 = Function.prototype, Ts2 = gi2.call, Lh2 = xi2 && gi2.bind.bind(Ts2, Ts2);
      Pi2.exports = xi2 ? Lh2 : function(l2) {
        return function() {
          return Ts2.apply(l2, arguments);
        };
      };
    });
    var rt2 = v2((Ed2, Ti2) => {
      var Ai2 = ue2(), Oh2 = Ai2({}.toString), Bh2 = Ai2("".slice);
      Ti2.exports = function(l2) {
        return Bh2(Oh2(l2), 8, -1);
      };
    });
    var Ei2 = v2((Cd2, vi2) => {
      var Mh2 = ue2(), _h2 = he2(), Rh2 = rt2(), vs = Object, jh2 = Mh2("".split);
      vi2.exports = _h2(function() {
        return !vs("z").propertyIsEnumerable(0);
      }) ? function(l2) {
        return Rh2(l2) == "String" ? jh2(l2, "") : vs(l2);
      } : vs;
    });
    var Es2 = v2((bd2, Ci2) => {
      Ci2.exports = function(l2) {
        return l2 == null;
      };
    });
    var Cs2 = v2((Sd2, bi2) => {
      var qh2 = Es2(), Uh2 = TypeError;
      bi2.exports = function(l2) {
        if (qh2(l2))
          throw Uh2("Can't call method on " + l2);
        return l2;
      };
    });
    var kt2 = v2((wd2, Si2) => {
      var $h2 = Ei2(), Hh2 = Cs2();
      Si2.exports = function(l2) {
        return $h2(Hh2(l2));
      };
    });
    var Ss2 = v2((Id2, wi2) => {
      var bs2 = typeof document == "object" && document.all, zh2 = typeof bs2 > "u" && bs2 !== void 0;
      wi2.exports = { all: bs2, IS_HTMLDDA: zh2 };
    });
    var ne2 = v2((Nd2, Ni) => {
      var Ii2 = Ss2(), Vh2 = Ii2.all;
      Ni.exports = Ii2.IS_HTMLDDA ? function(l2) {
        return typeof l2 == "function" || l2 === Vh2;
      } : function(l2) {
        return typeof l2 == "function";
      };
    });
    var Oe2 = v2((kd2, Fi2) => {
      var ki2 = ne2(), Di2 = Ss2(), Kh2 = Di2.all;
      Fi2.exports = Di2.IS_HTMLDDA ? function(l2) {
        return typeof l2 == "object" ? l2 !== null : ki2(l2) || l2 === Kh2;
      } : function(l2) {
        return typeof l2 == "object" ? l2 !== null : ki2(l2);
      };
    });
    var it2 = v2((Dd2, Li2) => {
      var ws2 = le2(), Wh2 = ne2(), Gh2 = function(l2) {
        return Wh2(l2) ? l2 : void 0;
      };
      Li2.exports = function(l2, h2) {
        return arguments.length < 2 ? Gh2(ws2[l2]) : ws2[l2] && ws2[l2][h2];
      };
    });
    var Bi2 = v2((Fd2, Oi2) => {
      var Jh2 = ue2();
      Oi2.exports = Jh2({}.isPrototypeOf);
    });
    var _i2 = v2((Ld2, Mi2) => {
      var Xh2 = it2();
      Mi2.exports = Xh2("navigator", "userAgent") || "";
    });
    var zi2 = v2((Od2, Hi2) => {
      var $i2 = le2(), Is2 = _i2(), Ri = $i2.process, ji = $i2.Deno, qi2 = Ri && Ri.versions || ji && ji.version, Ui2 = qi2 && qi2.v8, ce2, Dt2;
      Ui2 && (ce2 = Ui2.split("."), Dt2 = ce2[0] > 0 && ce2[0] < 4 ? 1 : +(ce2[0] + ce2[1]));
      !Dt2 && Is2 && (ce2 = Is2.match(/Edge\/(\d+)/), (!ce2 || ce2[1] >= 74) && (ce2 = Is2.match(/Chrome\/(\d+)/), ce2 && (Dt2 = +ce2[1])));
      Hi2.exports = Dt2;
    });
    var Ns2 = v2((Bd2, Ki2) => {
      var Vi2 = zi2(), Yh2 = he2();
      Ki2.exports = !!Object.getOwnPropertySymbols && !Yh2(function() {
        var l2 = Symbol();
        return !String(l2) || !(Object(l2) instanceof Symbol) || !Symbol.sham && Vi2 && Vi2 < 41;
      });
    });
    var ks2 = v2((Md2, Wi2) => {
      var Qh2 = Ns2();
      Wi2.exports = Qh2 && !Symbol.sham && typeof Symbol.iterator == "symbol";
    });
    var Ds2 = v2((_d2, Gi2) => {
      var Zh2 = it2(), eu2 = ne2(), tu2 = Bi2(), su2 = ks2(), ru2 = Object;
      Gi2.exports = su2 ? function(l2) {
        return typeof l2 == "symbol";
      } : function(l2) {
        var h2 = Zh2("Symbol");
        return eu2(h2) && tu2(h2.prototype, ru2(l2));
      };
    });
    var Xi2 = v2((Rd2, Ji2) => {
      var iu2 = String;
      Ji2.exports = function(l2) {
        try {
          return iu2(l2);
        } catch {
          return "Object";
        }
      };
    });
    var Ft2 = v2((jd2, Yi2) => {
      var au2 = ne2(), nu2 = Xi2(), ou2 = TypeError;
      Yi2.exports = function(l2) {
        if (au2(l2))
          return l2;
        throw ou2(nu2(l2) + " is not a function");
      };
    });
    var Zi2 = v2((qd2, Qi2) => {
      var lu2 = Ft2(), hu2 = Es2();
      Qi2.exports = function(l2, h2) {
        var f2 = l2[h2];
        return hu2(f2) ? void 0 : lu2(f2);
      };
    });
    var ta2 = v2((Ud2, ea2) => {
      var Fs2 = Nt2(), Ls2 = ne2(), Os2 = Oe2(), uu2 = TypeError;
      ea2.exports = function(l2, h2) {
        var f2, d2;
        if (h2 === "string" && Ls2(f2 = l2.toString) && !Os2(d2 = Fs2(f2, l2)) || Ls2(f2 = l2.valueOf) && !Os2(d2 = Fs2(f2, l2)) || h2 !== "string" && Ls2(f2 = l2.toString) && !Os2(d2 = Fs2(f2, l2)))
          return d2;
        throw uu2("Can't convert object to primitive value");
      };
    });
    var ra2 = v2(($d2, sa2) => {
      sa2.exports = false;
    });
    var Lt2 = v2((Hd2, aa2) => {
      var ia2 = le2(), cu2 = Object.defineProperty;
      aa2.exports = function(l2, h2) {
        try {
          cu2(ia2, l2, { value: h2, configurable: true, writable: true });
        } catch {
          ia2[l2] = h2;
        }
        return h2;
      };
    });
    var Ot2 = v2((zd2, oa2) => {
      var pu2 = le2(), fu2 = Lt2(), na2 = "__core-js_shared__", du2 = pu2[na2] || fu2(na2, {});
      oa2.exports = du2;
    });
    var Bs2 = v2((Vd2, ha2) => {
      var mu2 = ra2(), la2 = Ot2();
      (ha2.exports = function(l2, h2) {
        return la2[l2] || (la2[l2] = h2 !== void 0 ? h2 : {});
      })("versions", []).push({ version: "3.26.1", mode: mu2 ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
    });
    var Ms2 = v2((Kd2, ua2) => {
      var yu2 = Cs2(), xu2 = Object;
      ua2.exports = function(l2) {
        return xu2(yu2(l2));
      };
    });
    var Ie2 = v2((Wd2, ca2) => {
      var gu2 = ue2(), Pu2 = Ms2(), Au2 = gu2({}.hasOwnProperty);
      ca2.exports = Object.hasOwn || function(h2, f2) {
        return Au2(Pu2(h2), f2);
      };
    });
    var _s2 = v2((Gd2, pa2) => {
      var Tu2 = ue2(), vu2 = 0, Eu2 = Math.random(), Cu2 = Tu2(1 .toString);
      pa2.exports = function(l2) {
        return "Symbol(" + (l2 === void 0 ? "" : l2) + ")_" + Cu2(++vu2 + Eu2, 36);
      };
    });
    var at2 = v2((Jd2, xa2) => {
      var bu2 = le2(), Su2 = Bs2(), fa2 = Ie2(), wu2 = _s2(), da2 = Ns2(), ya2 = ks2(), Ke2 = Su2("wks"), Be2 = bu2.Symbol, ma2 = Be2 && Be2.for, Iu2 = ya2 ? Be2 : Be2 && Be2.withoutSetter || wu2;
      xa2.exports = function(l2) {
        if (!fa2(Ke2, l2) || !(da2 || typeof Ke2[l2] == "string")) {
          var h2 = "Symbol." + l2;
          da2 && fa2(Be2, l2) ? Ke2[l2] = Be2[l2] : ya2 && ma2 ? Ke2[l2] = ma2(h2) : Ke2[l2] = Iu2(h2);
        }
        return Ke2[l2];
      };
    });
    var Ta2 = v2((Xd2, Aa2) => {
      var Nu2 = Nt2(), ga2 = Oe2(), Pa2 = Ds2(), ku2 = Zi2(), Du2 = ta2(), Fu2 = at2(), Lu2 = TypeError, Ou2 = Fu2("toPrimitive");
      Aa2.exports = function(l2, h2) {
        if (!ga2(l2) || Pa2(l2))
          return l2;
        var f2 = ku2(l2, Ou2), d2;
        if (f2) {
          if (h2 === void 0 && (h2 = "default"), d2 = Nu2(f2, l2, h2), !ga2(d2) || Pa2(d2))
            return d2;
          throw Lu2("Can't convert object to primitive value");
        }
        return h2 === void 0 && (h2 = "number"), Du2(l2, h2);
      };
    });
    var Rs2 = v2((Yd2, va2) => {
      var Bu2 = Ta2(), Mu2 = Ds2();
      va2.exports = function(l2) {
        var h2 = Bu2(l2, "string");
        return Mu2(h2) ? h2 : h2 + "";
      };
    });
    var ba2 = v2((Qd2, Ca2) => {
      var _u2 = le2(), Ea2 = Oe2(), js2 = _u2.document, Ru2 = Ea2(js2) && Ea2(js2.createElement);
      Ca2.exports = function(l2) {
        return Ru2 ? js2.createElement(l2) : {};
      };
    });
    var qs2 = v2((Zd2, Sa2) => {
      var ju2 = ve2(), qu2 = he2(), Uu2 = ba2();
      Sa2.exports = !ju2 && !qu2(function() {
        return Object.defineProperty(Uu2("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    });
    var Us2 = v2((Ia2) => {
      var $u2 = ve2(), Hu2 = Nt2(), zu2 = mi2(), Vu2 = As2(), Ku2 = kt2(), Wu2 = Rs2(), Gu2 = Ie2(), Ju2 = qs2(), wa2 = Object.getOwnPropertyDescriptor;
      Ia2.f = $u2 ? wa2 : function(h2, f2) {
        if (h2 = Ku2(h2), f2 = Wu2(f2), Ju2)
          try {
            return wa2(h2, f2);
          } catch {
          }
        if (Gu2(h2, f2))
          return Vu2(!Hu2(zu2.f, h2, f2), h2[f2]);
      };
    });
    var ka2 = v2((tm2, Na2) => {
      var Xu2 = ve2(), Yu2 = he2();
      Na2.exports = Xu2 && Yu2(function() {
        return Object.defineProperty(function() {
        }, "prototype", { value: 42, writable: false }).prototype != 42;
      });
    });
    var Bt2 = v2((sm2, Da2) => {
      var Qu2 = Oe2(), Zu2 = String, ec2 = TypeError;
      Da2.exports = function(l2) {
        if (Qu2(l2))
          return l2;
        throw ec2(Zu2(l2) + " is not an object");
      };
    });
    var nt2 = v2((La2) => {
      var tc2 = ve2(), sc2 = qs2(), rc2 = ka2(), Mt2 = Bt2(), Fa2 = Rs2(), ic2 = TypeError, $s2 = Object.defineProperty, ac2 = Object.getOwnPropertyDescriptor, Hs2 = "enumerable", zs2 = "configurable", Vs2 = "writable";
      La2.f = tc2 ? rc2 ? function(h2, f2, d2) {
        if (Mt2(h2), f2 = Fa2(f2), Mt2(d2), typeof h2 == "function" && f2 === "prototype" && "value" in d2 && Vs2 in d2 && !d2[Vs2]) {
          var y2 = ac2(h2, f2);
          y2 && y2[Vs2] && (h2[f2] = d2.value, d2 = { configurable: zs2 in d2 ? d2[zs2] : y2[zs2], enumerable: Hs2 in d2 ? d2[Hs2] : y2[Hs2], writable: false });
        }
        return $s2(h2, f2, d2);
      } : $s2 : function(h2, f2, d2) {
        if (Mt2(h2), f2 = Fa2(f2), Mt2(d2), sc2)
          try {
            return $s2(h2, f2, d2);
          } catch {
          }
        if ("get" in d2 || "set" in d2)
          throw ic2("Accessors not supported");
        return "value" in d2 && (h2[f2] = d2.value), h2;
      };
    });
    var Ks2 = v2((im2, Oa2) => {
      var nc2 = ve2(), oc2 = nt2(), lc2 = As2();
      Oa2.exports = nc2 ? function(l2, h2, f2) {
        return oc2.f(l2, h2, lc2(1, f2));
      } : function(l2, h2, f2) {
        return l2[h2] = f2, l2;
      };
    });
    var _a2 = v2((am2, Ma2) => {
      var Ws2 = ve2(), hc2 = Ie2(), Ba2 = Function.prototype, uc2 = Ws2 && Object.getOwnPropertyDescriptor, Gs2 = hc2(Ba2, "name"), cc2 = Gs2 && function() {
      }.name === "something", pc2 = Gs2 && (!Ws2 || Ws2 && uc2(Ba2, "name").configurable);
      Ma2.exports = { EXISTS: Gs2, PROPER: cc2, CONFIGURABLE: pc2 };
    });
    var Xs2 = v2((nm2, Ra2) => {
      var fc2 = ue2(), dc2 = ne2(), Js2 = Ot2(), mc2 = fc2(Function.toString);
      dc2(Js2.inspectSource) || (Js2.inspectSource = function(l2) {
        return mc2(l2);
      });
      Ra2.exports = Js2.inspectSource;
    });
    var Ua2 = v2((om2, qa2) => {
      var yc2 = le2(), xc2 = ne2(), ja2 = yc2.WeakMap;
      qa2.exports = xc2(ja2) && /native code/.test(String(ja2));
    });
    var za2 = v2((lm2, Ha2) => {
      var gc2 = Bs2(), Pc2 = _s2(), $a2 = gc2("keys");
      Ha2.exports = function(l2) {
        return $a2[l2] || ($a2[l2] = Pc2(l2));
      };
    });
    var Ys2 = v2((hm2, Va2) => {
      Va2.exports = {};
    });
    var Ja2 = v2((um2, Ga2) => {
      var Ac2 = Ua2(), Wa2 = le2(), Tc2 = Oe2(), vc2 = Ks2(), Qs2 = Ie2(), Zs2 = Ot2(), Ec2 = za2(), Cc2 = Ys2(), Ka2 = "Object already initialized", er2 = Wa2.TypeError, bc2 = Wa2.WeakMap, _t2, ot2, Rt2, Sc2 = function(l2) {
        return Rt2(l2) ? ot2(l2) : _t2(l2, {});
      }, wc2 = function(l2) {
        return function(h2) {
          var f2;
          if (!Tc2(h2) || (f2 = ot2(h2)).type !== l2)
            throw er2("Incompatible receiver, " + l2 + " required");
          return f2;
        };
      };
      Ac2 || Zs2.state ? (pe2 = Zs2.state || (Zs2.state = new bc2()), pe2.get = pe2.get, pe2.has = pe2.has, pe2.set = pe2.set, _t2 = function(l2, h2) {
        if (pe2.has(l2))
          throw er2(Ka2);
        return h2.facade = l2, pe2.set(l2, h2), h2;
      }, ot2 = function(l2) {
        return pe2.get(l2) || {};
      }, Rt2 = function(l2) {
        return pe2.has(l2);
      }) : (Me2 = Ec2("state"), Cc2[Me2] = true, _t2 = function(l2, h2) {
        if (Qs2(l2, Me2))
          throw er2(Ka2);
        return h2.facade = l2, vc2(l2, Me2, h2), h2;
      }, ot2 = function(l2) {
        return Qs2(l2, Me2) ? l2[Me2] : {};
      }, Rt2 = function(l2) {
        return Qs2(l2, Me2);
      });
      var pe2, Me2;
      Ga2.exports = { set: _t2, get: ot2, has: Rt2, enforce: Sc2, getterFor: wc2 };
    });
    var sr2 = v2((cm2, Ya2) => {
      var Ic2 = he2(), Nc2 = ne2(), jt2 = Ie2(), tr2 = ve2(), kc2 = _a2().CONFIGURABLE, Dc2 = Xs2(), Xa2 = Ja2(), Fc2 = Xa2.enforce, Lc2 = Xa2.get, qt2 = Object.defineProperty, Oc2 = tr2 && !Ic2(function() {
        return qt2(function() {
        }, "length", { value: 8 }).length !== 8;
      }), Bc2 = String(String).split("String"), Mc2 = Ya2.exports = function(l2, h2, f2) {
        String(h2).slice(0, 7) === "Symbol(" && (h2 = "[" + String(h2).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), f2 && f2.getter && (h2 = "get " + h2), f2 && f2.setter && (h2 = "set " + h2), (!jt2(l2, "name") || kc2 && l2.name !== h2) && (tr2 ? qt2(l2, "name", { value: h2, configurable: true }) : l2.name = h2), Oc2 && f2 && jt2(f2, "arity") && l2.length !== f2.arity && qt2(l2, "length", { value: f2.arity });
        try {
          f2 && jt2(f2, "constructor") && f2.constructor ? tr2 && qt2(l2, "prototype", { writable: false }) : l2.prototype && (l2.prototype = void 0);
        } catch {
        }
        var d2 = Fc2(l2);
        return jt2(d2, "source") || (d2.source = Bc2.join(typeof h2 == "string" ? h2 : "")), l2;
      };
      Function.prototype.toString = Mc2(function() {
        return Nc2(this) && Lc2(this).source || Dc2(this);
      }, "toString");
    });
    var Za2 = v2((pm2, Qa2) => {
      var _c2 = ne2(), Rc2 = nt2(), jc2 = sr2(), qc2 = Lt2();
      Qa2.exports = function(l2, h2, f2, d2) {
        d2 || (d2 = {});
        var y2 = d2.enumerable, P2 = d2.name !== void 0 ? d2.name : h2;
        if (_c2(f2) && jc2(f2, P2, d2), d2.global)
          y2 ? l2[h2] = f2 : qc2(h2, f2);
        else {
          try {
            d2.unsafe ? l2[h2] && (y2 = true) : delete l2[h2];
          } catch {
          }
          y2 ? l2[h2] = f2 : Rc2.f(l2, h2, { value: f2, enumerable: false, configurable: !d2.nonConfigurable, writable: !d2.nonWritable });
        }
        return l2;
      };
    });
    var tn2 = v2((fm2, en2) => {
      var Uc2 = Math.ceil, $c2 = Math.floor;
      en2.exports = Math.trunc || function(h2) {
        var f2 = +h2;
        return (f2 > 0 ? $c2 : Uc2)(f2);
      };
    });
    var rr2 = v2((dm2, sn2) => {
      var Hc2 = tn2();
      sn2.exports = function(l2) {
        var h2 = +l2;
        return h2 !== h2 || h2 === 0 ? 0 : Hc2(h2);
      };
    });
    var an2 = v2((mm2, rn2) => {
      var zc2 = rr2(), Vc2 = Math.max, Kc2 = Math.min;
      rn2.exports = function(l2, h2) {
        var f2 = zc2(l2);
        return f2 < 0 ? Vc2(f2 + h2, 0) : Kc2(f2, h2);
      };
    });
    var on2 = v2((ym2, nn2) => {
      var Wc2 = rr2(), Gc2 = Math.min;
      nn2.exports = function(l2) {
        return l2 > 0 ? Gc2(Wc2(l2), 9007199254740991) : 0;
      };
    });
    var Ut2 = v2((xm2, ln2) => {
      var Jc2 = on2();
      ln2.exports = function(l2) {
        return Jc2(l2.length);
      };
    });
    var cn2 = v2((gm2, un2) => {
      var Xc2 = kt2(), Yc2 = an2(), Qc2 = Ut2(), hn2 = function(l2) {
        return function(h2, f2, d2) {
          var y2 = Xc2(h2), P2 = Qc2(y2), g2 = Yc2(d2, P2), T2;
          if (l2 && f2 != f2) {
            for (; P2 > g2; )
              if (T2 = y2[g2++], T2 != T2)
                return true;
          } else
            for (; P2 > g2; g2++)
              if ((l2 || g2 in y2) && y2[g2] === f2)
                return l2 || g2 || 0;
          return !l2 && -1;
        };
      };
      un2.exports = { includes: hn2(true), indexOf: hn2(false) };
    });
    var dn2 = v2((Pm2, fn2) => {
      var Zc2 = ue2(), ir2 = Ie2(), ep2 = kt2(), tp2 = cn2().indexOf, sp2 = Ys2(), pn2 = Zc2([].push);
      fn2.exports = function(l2, h2) {
        var f2 = ep2(l2), d2 = 0, y2 = [], P2;
        for (P2 in f2)
          !ir2(sp2, P2) && ir2(f2, P2) && pn2(y2, P2);
        for (; h2.length > d2; )
          ir2(f2, P2 = h2[d2++]) && (~tp2(y2, P2) || pn2(y2, P2));
        return y2;
      };
    });
    var yn2 = v2((Am2, mn2) => {
      mn2.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    });
    var gn2 = v2((xn2) => {
      var rp2 = dn2(), ip2 = yn2(), ap2 = ip2.concat("length", "prototype");
      xn2.f = Object.getOwnPropertyNames || function(h2) {
        return rp2(h2, ap2);
      };
    });
    var An2 = v2((Pn2) => {
      Pn2.f = Object.getOwnPropertySymbols;
    });
    var vn2 = v2((Em2, Tn2) => {
      var np2 = it2(), op2 = ue2(), lp2 = gn2(), hp2 = An2(), up2 = Bt2(), cp2 = op2([].concat);
      Tn2.exports = np2("Reflect", "ownKeys") || function(h2) {
        var f2 = lp2.f(up2(h2)), d2 = hp2.f;
        return d2 ? cp2(f2, d2(h2)) : f2;
      };
    });
    var bn2 = v2((Cm2, Cn2) => {
      var En2 = Ie2(), pp2 = vn2(), fp2 = Us2(), dp2 = nt2();
      Cn2.exports = function(l2, h2, f2) {
        for (var d2 = pp2(h2), y2 = dp2.f, P2 = fp2.f, g2 = 0; g2 < d2.length; g2++) {
          var T2 = d2[g2];
          !En2(l2, T2) && !(f2 && En2(f2, T2)) && y2(l2, T2, P2(h2, T2));
        }
      };
    });
    var wn2 = v2((bm2, Sn2) => {
      var mp2 = he2(), yp2 = ne2(), xp2 = /#|\.prototype\./, lt2 = function(l2, h2) {
        var f2 = Pp[gp2(l2)];
        return f2 == Tp ? true : f2 == Ap2 ? false : yp2(h2) ? mp2(h2) : !!h2;
      }, gp2 = lt2.normalize = function(l2) {
        return String(l2).replace(xp2, ".").toLowerCase();
      }, Pp = lt2.data = {}, Ap2 = lt2.NATIVE = "N", Tp = lt2.POLYFILL = "P";
      Sn2.exports = lt2;
    });
    var nr2 = v2((Sm2, In2) => {
      var ar2 = le2(), vp2 = Us2().f, Ep2 = Ks2(), Cp2 = Za2(), bp2 = Lt2(), Sp2 = bn2(), wp2 = wn2();
      In2.exports = function(l2, h2) {
        var f2 = l2.target, d2 = l2.global, y2 = l2.stat, P2, g2, T2, S2, F2, I2;
        if (d2 ? g2 = ar2 : y2 ? g2 = ar2[f2] || bp2(f2, {}) : g2 = (ar2[f2] || {}).prototype, g2)
          for (T2 in h2) {
            if (F2 = h2[T2], l2.dontCallGetSet ? (I2 = vp2(g2, T2), S2 = I2 && I2.value) : S2 = g2[T2], P2 = wp2(d2 ? T2 : f2 + (y2 ? "." : "#") + T2, l2.forced), !P2 && S2 !== void 0) {
              if (typeof F2 == typeof S2)
                continue;
              Sp2(F2, S2);
            }
            (l2.sham || S2 && S2.sham) && Ep2(F2, "sham", true), Cp2(g2, T2, F2, l2);
          }
      };
    });
    var Nn2 = v2(() => {
      var Ip = nr2(), or2 = le2();
      Ip({ global: true, forced: or2.globalThis !== or2 }, { globalThis: or2 });
    });
    var kn2 = v2(() => {
      Nn2();
    });
    var Ln2 = v2((Dm2, Fn2) => {
      var Dn2 = sr2(), Np2 = nt2();
      Fn2.exports = function(l2, h2, f2) {
        return f2.get && Dn2(f2.get, h2, { getter: true }), f2.set && Dn2(f2.set, h2, { setter: true }), Np2.f(l2, h2, f2);
      };
    });
    var Bn2 = v2((Fm2, On2) => {
      var kp2 = Bt2();
      On2.exports = function() {
        var l2 = kp2(this), h2 = "";
        return l2.hasIndices && (h2 += "d"), l2.global && (h2 += "g"), l2.ignoreCase && (h2 += "i"), l2.multiline && (h2 += "m"), l2.dotAll && (h2 += "s"), l2.unicode && (h2 += "u"), l2.unicodeSets && (h2 += "v"), l2.sticky && (h2 += "y"), h2;
      };
    });
    var Rn2 = v2(() => {
      var Dp2 = le2(), Fp2 = ve2(), Lp2 = Ln2(), Op2 = Bn2(), Bp2 = he2(), Mn2 = Dp2.RegExp, _n2 = Mn2.prototype, Mp2 = Fp2 && Bp2(function() {
        var l2 = true;
        try {
          Mn2(".", "d");
        } catch {
          l2 = false;
        }
        var h2 = {}, f2 = "", d2 = l2 ? "dgimsy" : "gimsy", y2 = function(S2, F2) {
          Object.defineProperty(h2, S2, { get: function() {
            return f2 += F2, true;
          } });
        }, P2 = { dotAll: "s", global: "g", ignoreCase: "i", multiline: "m", sticky: "y" };
        l2 && (P2.hasIndices = "d");
        for (var g2 in P2)
          y2(g2, P2[g2]);
        var T2 = Object.getOwnPropertyDescriptor(_n2, "flags").get.call(h2);
        return T2 !== d2 || f2 !== d2;
      });
      Mp2 && Lp2(_n2, "flags", { configurable: true, get: Op2 });
    });
    var lr2 = v2((Bm2, jn2) => {
      var _p2 = rt2();
      jn2.exports = Array.isArray || function(h2) {
        return _p2(h2) == "Array";
      };
    });
    var Un2 = v2((Mm2, qn2) => {
      var Rp2 = TypeError, jp2 = 9007199254740991;
      qn2.exports = function(l2) {
        if (l2 > jp2)
          throw Rp2("Maximum allowed index exceeded");
        return l2;
      };
    });
    var Hn2 = v2((_m2, $n2) => {
      var qp2 = rt2(), Up2 = ue2();
      $n2.exports = function(l2) {
        if (qp2(l2) === "Function")
          return Up2(l2);
      };
    });
    var Kn2 = v2((Rm2, Vn2) => {
      var zn = Hn2(), $p2 = Ft2(), Hp2 = wt2(), zp2 = zn(zn.bind);
      Vn2.exports = function(l2, h2) {
        return $p2(l2), h2 === void 0 ? l2 : Hp2 ? zp2(l2, h2) : function() {
          return l2.apply(h2, arguments);
        };
      };
    });
    var Jn2 = v2((jm2, Gn2) => {
      var Vp2 = lr2(), Kp2 = Ut2(), Wp2 = Un2(), Gp2 = Kn2(), Wn2 = function(l2, h2, f2, d2, y2, P2, g2, T2) {
        for (var S2 = y2, F2 = 0, I2 = g2 ? Gp2(g2, T2) : false, C2, L2; F2 < d2; )
          F2 in f2 && (C2 = I2 ? I2(f2[F2], F2, h2) : f2[F2], P2 > 0 && Vp2(C2) ? (L2 = Kp2(C2), S2 = Wn2(l2, h2, C2, L2, S2, P2 - 1) - 1) : (Wp2(S2 + 1), l2[S2] = C2), S2++), F2++;
        return S2;
      };
      Gn2.exports = Wn2;
    });
    var Qn2 = v2((qm2, Yn2) => {
      var Jp2 = at2(), Xp2 = Jp2("toStringTag"), Xn2 = {};
      Xn2[Xp2] = "z";
      Yn2.exports = String(Xn2) === "[object z]";
    });
    var eo2 = v2((Um2, Zn2) => {
      var Yp2 = Qn2(), Qp2 = ne2(), $t2 = rt2(), Zp2 = at2(), ef2 = Zp2("toStringTag"), tf2 = Object, sf2 = $t2(function() {
        return arguments;
      }()) == "Arguments", rf2 = function(l2, h2) {
        try {
          return l2[h2];
        } catch {
        }
      };
      Zn2.exports = Yp2 ? $t2 : function(l2) {
        var h2, f2, d2;
        return l2 === void 0 ? "Undefined" : l2 === null ? "Null" : typeof (f2 = rf2(h2 = tf2(l2), ef2)) == "string" ? f2 : sf2 ? $t2(h2) : (d2 = $t2(h2)) == "Object" && Qp2(h2.callee) ? "Arguments" : d2;
      };
    });
    var no2 = v2(($m2, ao2) => {
      var af2 = ue2(), nf2 = he2(), to2 = ne2(), of2 = eo2(), lf2 = it2(), hf2 = Xs2(), so2 = function() {
      }, uf2 = [], ro2 = lf2("Reflect", "construct"), hr2 = /^\s*(?:class|function)\b/, cf2 = af2(hr2.exec), pf2 = !hr2.exec(so2), ht2 = function(h2) {
        if (!to2(h2))
          return false;
        try {
          return ro2(so2, uf2, h2), true;
        } catch {
          return false;
        }
      }, io2 = function(h2) {
        if (!to2(h2))
          return false;
        switch (of2(h2)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return false;
        }
        try {
          return pf2 || !!cf2(hr2, hf2(h2));
        } catch {
          return true;
        }
      };
      io2.sham = true;
      ao2.exports = !ro2 || nf2(function() {
        var l2;
        return ht2(ht2.call) || !ht2(Object) || !ht2(function() {
          l2 = true;
        }) || l2;
      }) ? io2 : ht2;
    });
    var uo2 = v2((Hm2, ho2) => {
      var oo2 = lr2(), ff2 = no2(), df2 = Oe2(), mf2 = at2(), yf2 = mf2("species"), lo2 = Array;
      ho2.exports = function(l2) {
        var h2;
        return oo2(l2) && (h2 = l2.constructor, ff2(h2) && (h2 === lo2 || oo2(h2.prototype)) ? h2 = void 0 : df2(h2) && (h2 = h2[yf2], h2 === null && (h2 = void 0))), h2 === void 0 ? lo2 : h2;
      };
    });
    var po2 = v2((zm2, co2) => {
      var xf2 = uo2();
      co2.exports = function(l2, h2) {
        return new (xf2(l2))(h2 === 0 ? 0 : h2);
      };
    });
    var fo2 = v2(() => {
      var gf2 = nr2(), Pf2 = Jn2(), Af2 = Ft2(), Tf2 = Ms2(), vf2 = Ut2(), Ef2 = po2();
      gf2({ target: "Array", proto: true }, { flatMap: function(h2) {
        var f2 = Tf2(this), d2 = vf2(f2), y2;
        return Af2(h2), y2 = Ef2(f2, 0), y2.length = Pf2(y2, f2, f2, d2, 0, 1, h2, arguments.length > 1 ? arguments[1] : void 0), y2;
      } });
    });
    var fd2 = v2((Zm2, Ho2) => {
      kn2();
      Rn2();
      fo2();
      var fr2 = Object.defineProperty, Cf2 = Object.getOwnPropertyDescriptor, dr2 = Object.getOwnPropertyNames, bf2 = Object.prototype.hasOwnProperty, Ao = (l2, h2) => function() {
        return l2 && (h2 = (0, l2[dr2(l2)[0]])(l2 = 0)), h2;
      }, K2 = (l2, h2) => function() {
        return h2 || (0, l2[dr2(l2)[0]])((h2 = { exports: {} }).exports, h2), h2.exports;
      }, Sf2 = (l2, h2) => {
        for (var f2 in h2)
          fr2(l2, f2, { get: h2[f2], enumerable: true });
      }, wf2 = (l2, h2, f2, d2) => {
        if (h2 && typeof h2 == "object" || typeof h2 == "function")
          for (let y2 of dr2(h2))
            !bf2.call(l2, y2) && y2 !== f2 && fr2(l2, y2, { get: () => h2[y2], enumerable: !(d2 = Cf2(h2, y2)) || d2.enumerable });
        return l2;
      }, If2 = (l2) => wf2(fr2({}, "__esModule", { value: true }), l2), V2 = Ao({ "<define:process>"() {
      } }), Nf2 = K2({ "src/utils/try-combinations.js"(l2, h2) {
        V2();
        function f2() {
          let d2;
          for (var y2 = arguments.length, P2 = new Array(y2), g2 = 0; g2 < y2; g2++)
            P2[g2] = arguments[g2];
          for (let [T2, S2] of P2.entries())
            try {
              return { result: S2() };
            } catch (F2) {
              T2 === 0 && (d2 = F2);
            }
          return { error: d2 };
        }
        h2.exports = f2;
      } }), To2 = K2({ "src/language-js/utils/get-shebang.js"(l2, h2) {
        V2();
        function f2(d2) {
          if (!d2.startsWith("#!"))
            return "";
          let y2 = d2.indexOf(`
`);
          return y2 === -1 ? d2 : d2.slice(0, y2);
        }
        h2.exports = f2;
      } }), kf2 = K2({ "src/utils/text/skip-inline-comment.js"(l2, h2) {
        V2();
        function f2(d2, y2) {
          if (y2 === false)
            return false;
          if (d2.charAt(y2) === "/" && d2.charAt(y2 + 1) === "*") {
            for (let P2 = y2 + 2; P2 < d2.length; ++P2)
              if (d2.charAt(P2) === "*" && d2.charAt(P2 + 1) === "/")
                return P2 + 2;
          }
          return y2;
        }
        h2.exports = f2;
      } }), Df2 = K2({ "src/utils/text/skip-newline.js"(l2, h2) {
        V2();
        function f2(d2, y2, P2) {
          let g2 = P2 && P2.backwards;
          if (y2 === false)
            return false;
          let T2 = d2.charAt(y2);
          if (g2) {
            if (d2.charAt(y2 - 1) === "\r" && T2 === `
`)
              return y2 - 2;
            if (T2 === `
` || T2 === "\r" || T2 === "\u2028" || T2 === "\u2029")
              return y2 - 1;
          } else {
            if (T2 === "\r" && d2.charAt(y2 + 1) === `
`)
              return y2 + 2;
            if (T2 === `
` || T2 === "\r" || T2 === "\u2028" || T2 === "\u2029")
              return y2 + 1;
          }
          return y2;
        }
        h2.exports = f2;
      } }), vo2 = K2({ "src/utils/text/skip.js"(l2, h2) {
        V2();
        function f2(T2) {
          return (S2, F2, I2) => {
            let C2 = I2 && I2.backwards;
            if (F2 === false)
              return false;
            let { length: L2 } = S2, j2 = F2;
            for (; j2 >= 0 && j2 < L2; ) {
              let k2 = S2.charAt(j2);
              if (T2 instanceof RegExp) {
                if (!T2.test(k2))
                  return j2;
              } else if (!T2.includes(k2))
                return j2;
              C2 ? j2-- : j2++;
            }
            return j2 === -1 || j2 === L2 ? j2 : false;
          };
        }
        var d2 = f2(/\s/), y2 = f2(" 	"), P2 = f2(",; 	"), g2 = f2(/[^\n\r]/);
        h2.exports = { skipWhitespace: d2, skipSpaces: y2, skipToLineEnd: P2, skipEverythingButNewLine: g2 };
      } }), Ff2 = K2({ "src/utils/text/skip-trailing-comment.js"(l2, h2) {
        V2();
        var { skipEverythingButNewLine: f2 } = vo2();
        function d2(y2, P2) {
          return P2 === false ? false : y2.charAt(P2) === "/" && y2.charAt(P2 + 1) === "/" ? f2(y2, P2) : P2;
        }
        h2.exports = d2;
      } }), Lf2 = K2({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(l2, h2) {
        V2();
        var f2 = kf2(), d2 = Df2(), y2 = Ff2(), { skipSpaces: P2 } = vo2();
        function g2(T2, S2) {
          let F2 = null, I2 = S2;
          for (; I2 !== F2; )
            F2 = I2, I2 = P2(T2, I2), I2 = f2(T2, I2), I2 = y2(T2, I2), I2 = d2(T2, I2);
          return I2;
        }
        h2.exports = g2;
      } }), Eo2 = {};
      Sf2(Eo2, { EOL: () => pr2, arch: () => Of2, cpus: () => ko, default: () => Bo2, endianness: () => Co, freemem: () => Io2, getNetworkInterfaces: () => Oo2, hostname: () => bo2, loadavg: () => So, networkInterfaces: () => Lo2, platform: () => Bf2, release: () => Fo, tmpDir: () => ur2, tmpdir: () => cr2, totalmem: () => No2, type: () => Do, uptime: () => wo });
      function Co() {
        if (typeof Ht2 > "u") {
          var l2 = new ArrayBuffer(2), h2 = new Uint8Array(l2), f2 = new Uint16Array(l2);
          if (h2[0] = 1, h2[1] = 2, f2[0] === 258)
            Ht2 = "BE";
          else if (f2[0] === 513)
            Ht2 = "LE";
          else
            throw new Error("unable to figure out endianess");
        }
        return Ht2;
      }
      function bo2() {
        return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
      }
      function So() {
        return [];
      }
      function wo() {
        return 0;
      }
      function Io2() {
        return Number.MAX_VALUE;
      }
      function No2() {
        return Number.MAX_VALUE;
      }
      function ko() {
        return [];
      }
      function Do() {
        return "Browser";
      }
      function Fo() {
        return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
      }
      function Lo2() {
      }
      function Oo2() {
      }
      function Of2() {
        return "javascript";
      }
      function Bf2() {
        return "browser";
      }
      function ur2() {
        return "/tmp";
      }
      var Ht2, cr2, pr2, Bo2, Mf2 = Ao({ "node-modules-polyfills:os"() {
        V2(), cr2 = ur2, pr2 = `
`, Bo2 = { EOL: pr2, tmpdir: cr2, tmpDir: ur2, networkInterfaces: Lo2, getNetworkInterfaces: Oo2, release: Fo, type: Do, cpus: ko, totalmem: No2, freemem: Io2, uptime: wo, loadavg: So, hostname: bo2, endianness: Co };
      } }), _f2 = K2({ "node-modules-polyfills-commonjs:os"(l2, h2) {
        V2();
        var f2 = (Mf2(), If2(Eo2));
        if (f2 && f2.default) {
          h2.exports = f2.default;
          for (let d2 in f2)
            h2.exports[d2] = f2[d2];
        } else
          f2 && (h2.exports = f2);
      } }), Rf2 = K2({ "node_modules/detect-newline/index.js"(l2, h2) {
        V2();
        var f2 = (d2) => {
          if (typeof d2 != "string")
            throw new TypeError("Expected a string");
          let y2 = d2.match(/(?:\r?\n)/g) || [];
          if (y2.length === 0)
            return;
          let P2 = y2.filter((T2) => T2 === `\r
`).length, g2 = y2.length - P2;
          return P2 > g2 ? `\r
` : `
`;
        };
        h2.exports = f2, h2.exports.graceful = (d2) => typeof d2 == "string" && f2(d2) || `
`;
      } }), jf2 = K2({ "node_modules/jest-docblock/build/index.js"(l2) {
        V2(), Object.defineProperty(l2, "__esModule", { value: true }), l2.extract = j2, l2.parse = H2, l2.parseWithComments = W2, l2.print = B2, l2.strip = k2;
        function h2() {
          let u2 = _f2();
          return h2 = function() {
            return u2;
          }, u2;
        }
        function f2() {
          let u2 = d2(Rf2());
          return f2 = function() {
            return u2;
          }, u2;
        }
        function d2(u2) {
          return u2 && u2.__esModule ? u2 : { default: u2 };
        }
        var y2 = /\*\/$/, P2 = /^\/\*\*?/, g2 = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, T2 = /(^|\s+)\/\/([^\r\n]*)/g, S2 = /^(\r?\n)+/, F2 = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, I2 = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, C2 = /(\r?\n|^) *\* ?/g, L2 = [];
        function j2(u2) {
          let G2 = u2.match(g2);
          return G2 ? G2[0].trimLeft() : "";
        }
        function k2(u2) {
          let G2 = u2.match(g2);
          return G2 && G2[0] ? u2.substring(G2[0].length) : u2;
        }
        function H2(u2) {
          return W2(u2).pragmas;
        }
        function W2(u2) {
          let G2 = (0, f2().default)(u2) || h2().EOL;
          u2 = u2.replace(P2, "").replace(y2, "").replace(C2, "$1");
          let oe2 = "";
          for (; oe2 !== u2; )
            oe2 = u2, u2 = u2.replace(F2, `${G2}$1 $2${G2}`);
          u2 = u2.replace(S2, "").trimRight();
          let X2 = Object.create(null), _e2 = u2.replace(I2, "").replace(S2, "").trimRight(), Z2;
          for (; Z2 = I2.exec(u2); ) {
            let $2 = Z2[2].replace(T2, "");
            typeof X2[Z2[1]] == "string" || Array.isArray(X2[Z2[1]]) ? X2[Z2[1]] = L2.concat(X2[Z2[1]], $2) : X2[Z2[1]] = $2;
          }
          return { comments: _e2, pragmas: X2 };
        }
        function B2(u2) {
          let { comments: G2 = "", pragmas: oe2 = {} } = u2, X2 = (0, f2().default)(G2) || h2().EOL, _e2 = "/**", Z2 = " *", $2 = " */", M2 = Object.keys(oe2), E2 = M2.map((ee2) => _2(ee2, oe2[ee2])).reduce((ee2, fe2) => ee2.concat(fe2), []).map((ee2) => `${Z2} ${ee2}${X2}`).join("");
          if (!G2) {
            if (M2.length === 0)
              return "";
            if (M2.length === 1 && !Array.isArray(oe2[M2[0]])) {
              let ee2 = oe2[M2[0]];
              return `${_e2} ${_2(M2[0], ee2)[0]}${$2}`;
            }
          }
          let Je2 = G2.split(X2).map((ee2) => `${Z2} ${ee2}`).join(X2) + X2;
          return _e2 + X2 + (G2 ? Je2 : "") + (G2 && M2.length ? Z2 + X2 : "") + E2 + $2;
        }
        function _2(u2, G2) {
          return L2.concat(G2).map((oe2) => `@${u2} ${oe2}`.trim());
        }
      } }), qf2 = K2({ "src/common/end-of-line.js"(l2, h2) {
        V2();
        function f2(g2) {
          let T2 = g2.indexOf("\r");
          return T2 >= 0 ? g2.charAt(T2 + 1) === `
` ? "crlf" : "cr" : "lf";
        }
        function d2(g2) {
          switch (g2) {
            case "cr":
              return "\r";
            case "crlf":
              return `\r
`;
            default:
              return `
`;
          }
        }
        function y2(g2, T2) {
          let S2;
          switch (T2) {
            case `
`:
              S2 = /\n/g;
              break;
            case "\r":
              S2 = /\r/g;
              break;
            case `\r
`:
              S2 = /\r\n/g;
              break;
            default:
              throw new Error(`Unexpected "eol" ${JSON.stringify(T2)}.`);
          }
          let F2 = g2.match(S2);
          return F2 ? F2.length : 0;
        }
        function P2(g2) {
          return g2.replace(/\r\n?/g, `
`);
        }
        h2.exports = { guessEndOfLine: f2, convertEndOfLineToChars: d2, countEndOfLineChars: y2, normalizeEndOfLine: P2 };
      } }), Uf2 = K2({ "src/language-js/pragma.js"(l2, h2) {
        V2();
        var { parseWithComments: f2, strip: d2, extract: y2, print: P2 } = jf2(), { normalizeEndOfLine: g2 } = qf2(), T2 = To2();
        function S2(C2) {
          let L2 = T2(C2);
          L2 && (C2 = C2.slice(L2.length + 1));
          let j2 = y2(C2), { pragmas: k2, comments: H2 } = f2(j2);
          return { shebang: L2, text: C2, pragmas: k2, comments: H2 };
        }
        function F2(C2) {
          let L2 = Object.keys(S2(C2).pragmas);
          return L2.includes("prettier") || L2.includes("format");
        }
        function I2(C2) {
          let { shebang: L2, text: j2, pragmas: k2, comments: H2 } = S2(C2), W2 = d2(j2), B2 = P2({ pragmas: Object.assign({ format: "" }, k2), comments: H2.trimStart() });
          return (L2 ? `${L2}
` : "") + g2(B2) + (W2.startsWith(`
`) ? `
` : `

`) + W2;
        }
        h2.exports = { hasPragma: F2, insertPragma: I2 };
      } }), mr2 = K2({ "src/utils/is-non-empty-array.js"(l2, h2) {
        V2();
        function f2(d2) {
          return Array.isArray(d2) && d2.length > 0;
        }
        h2.exports = f2;
      } }), Mo2 = K2({ "src/language-js/loc.js"(l2, h2) {
        V2();
        var f2 = mr2();
        function d2(S2) {
          var F2, I2;
          let C2 = S2.range ? S2.range[0] : S2.start, L2 = (F2 = (I2 = S2.declaration) === null || I2 === void 0 ? void 0 : I2.decorators) !== null && F2 !== void 0 ? F2 : S2.decorators;
          return f2(L2) ? Math.min(d2(L2[0]), C2) : C2;
        }
        function y2(S2) {
          return S2.range ? S2.range[1] : S2.end;
        }
        function P2(S2, F2) {
          let I2 = d2(S2);
          return Number.isInteger(I2) && I2 === d2(F2);
        }
        function g2(S2, F2) {
          let I2 = y2(S2);
          return Number.isInteger(I2) && I2 === y2(F2);
        }
        function T2(S2, F2) {
          return P2(S2, F2) && g2(S2, F2);
        }
        h2.exports = { locStart: d2, locEnd: y2, hasSameLocStart: P2, hasSameLoc: T2 };
      } }), _o2 = K2({ "src/language-js/parse/utils/create-parser.js"(l2, h2) {
        V2();
        var { hasPragma: f2 } = Uf2(), { locStart: d2, locEnd: y2 } = Mo2();
        function P2(g2) {
          return g2 = typeof g2 == "function" ? { parse: g2 } : g2, Object.assign({ astFormat: "estree", hasPragma: f2, locStart: d2, locEnd: y2 }, g2);
        }
        h2.exports = P2;
      } }), yr2 = K2({ "src/common/parser-create-error.js"(l2, h2) {
        V2();
        function f2(d2, y2) {
          let P2 = new SyntaxError(d2 + " (" + y2.start.line + ":" + y2.start.column + ")");
          return P2.loc = y2, P2;
        }
        h2.exports = f2;
      } }), Ro2 = K2({ "src/language-js/parse/utils/create-babel-parse-error.js"(l2, h2) {
        V2();
        var f2 = yr2();
        function d2(y2) {
          let { message: P2, loc: g2 } = y2;
          return f2(P2.replace(/ \(.*\)/, ""), { start: { line: g2 ? g2.line : 0, column: g2 ? g2.column + 1 : 0 } });
        }
        h2.exports = d2;
      } }), $f2 = K2({ "src/language-js/utils/is-ts-keyword-type.js"(l2, h2) {
        V2();
        function f2(d2) {
          let { type: y2 } = d2;
          return y2.startsWith("TS") && y2.endsWith("Keyword");
        }
        h2.exports = f2;
      } }), Hf2 = K2({ "src/language-js/utils/is-block-comment.js"(l2, h2) {
        V2();
        var f2 = new Set(["Block", "CommentBlock", "MultiLine"]), d2 = (y2) => f2.has(y2 == null ? void 0 : y2.type);
        h2.exports = d2;
      } }), zf2 = K2({ "src/language-js/utils/is-type-cast-comment.js"(l2, h2) {
        V2();
        var f2 = Hf2();
        function d2(y2) {
          return f2(y2) && y2.value[0] === "*" && /@type\b/.test(y2.value);
        }
        h2.exports = d2;
      } }), Vf2 = K2({ "src/utils/get-last.js"(l2, h2) {
        V2();
        var f2 = (d2) => d2[d2.length - 1];
        h2.exports = f2;
      } }), jo2 = K2({ "src/language-js/parse/postprocess/visit-node.js"(l2, h2) {
        V2();
        function f2(d2, y2) {
          if (Array.isArray(d2)) {
            for (let P2 = 0; P2 < d2.length; P2++)
              d2[P2] = f2(d2[P2], y2);
            return d2;
          }
          if (d2 && typeof d2 == "object" && typeof d2.type == "string") {
            let P2 = Object.keys(d2);
            for (let g2 = 0; g2 < P2.length; g2++)
              d2[P2[g2]] = f2(d2[P2[g2]], y2);
            return y2(d2) || d2;
          }
          return d2;
        }
        h2.exports = f2;
      } }), qo2 = K2({ "src/language-js/parse/postprocess/throw-syntax-error.js"(l2, h2) {
        V2();
        var f2 = yr2();
        function d2(y2, P2) {
          let { start: g2, end: T2 } = y2.loc;
          throw f2(P2, { start: { line: g2.line, column: g2.column + 1 }, end: { line: T2.line, column: T2.column + 1 } });
        }
        h2.exports = d2;
      } }), Kf2 = K2({ "src/language-js/parse/postprocess/typescript.js"(l2, h2) {
        V2();
        var f2 = mr2(), d2 = jo2(), y2 = qo2(), P2 = { AbstractKeyword: 126, SourceFile: 308, PropertyDeclaration: 169 };
        function g2(I2) {
          for (; I2 && I2.kind !== P2.SourceFile; )
            I2 = I2.parent;
          return I2;
        }
        function T2(I2) {
          let { illegalDecorators: C2 } = I2;
          if (!f2(C2))
            return;
          let [{ expression: L2 }] = C2, j2 = g2(L2), [k2, H2] = [L2.pos, L2.end].map((W2) => {
            let { line: B2, character: _2 } = j2.getLineAndCharacterOfPosition(W2);
            return { line: B2 + 1, column: _2 };
          });
          y2({ loc: { start: k2, end: H2 } }, "Decorators are not valid here.");
        }
        function S2(I2, C2) {
          I2.kind !== P2.PropertyDeclaration || I2.modifiers && !I2.modifiers.some((L2) => L2.kind === P2.AbstractKeyword) || I2.initializer && C2.value === null && y2(C2, "Abstract property cannot have an initializer");
        }
        function F2(I2, C2) {
          let { esTreeNodeToTSNodeMap: L2, tsNodeToESTreeNodeMap: j2 } = C2.tsParseResult;
          d2(I2, (k2) => {
            let H2 = L2.get(k2);
            if (!H2)
              return;
            let W2 = j2.get(H2);
            W2 === k2 && (T2(H2), S2(H2, W2));
          });
        }
        h2.exports = { throwErrorForInvalidNodes: F2 };
      } }), Wf2 = K2({ "src/language-js/parse/postprocess/index.js"(l2, h2) {
        V2();
        var { locStart: f2, locEnd: d2 } = Mo2(), y2 = $f2(), P2 = zf2(), g2 = Vf2(), T2 = jo2(), { throwErrorForInvalidNodes: S2 } = Kf2(), F2 = qo2();
        function I2(k2, H2) {
          if (H2.parser === "typescript" && /@|abstract/.test(H2.originalText) && S2(k2, H2), H2.parser !== "typescript" && H2.parser !== "flow" && H2.parser !== "acorn" && H2.parser !== "espree" && H2.parser !== "meriyah") {
            let B2 = new Set();
            k2 = T2(k2, (_2) => {
              _2.leadingComments && _2.leadingComments.some(P2) && B2.add(f2(_2));
            }), k2 = T2(k2, (_2) => {
              if (_2.type === "ParenthesizedExpression") {
                let { expression: u2 } = _2;
                if (u2.type === "TypeCastExpression")
                  return u2.range = _2.range, u2;
                let G2 = f2(_2);
                if (!B2.has(G2))
                  return u2.extra = Object.assign(Object.assign({}, u2.extra), {}, { parenthesized: true }), u2;
              }
            });
          }
          return k2 = T2(k2, (B2) => {
            switch (B2.type) {
              case "ChainExpression":
                return C2(B2.expression);
              case "LogicalExpression": {
                if (L2(B2))
                  return j2(B2);
                break;
              }
              case "VariableDeclaration": {
                let _2 = g2(B2.declarations);
                _2 && _2.init && W2(B2, _2);
                break;
              }
              case "TSParenthesizedType":
                return y2(B2.typeAnnotation) || B2.typeAnnotation.type === "TSThisType" || (B2.typeAnnotation.range = [f2(B2), d2(B2)]), B2.typeAnnotation;
              case "TSTypeParameter":
                if (typeof B2.name == "string") {
                  let _2 = f2(B2);
                  B2.name = { type: "Identifier", name: B2.name, range: [_2, _2 + B2.name.length] };
                }
                break;
              case "ObjectExpression":
                if (H2.parser === "typescript") {
                  let _2 = B2.properties.find((u2) => u2.type === "Property" && u2.value.type === "TSEmptyBodyFunctionExpression");
                  _2 && F2(_2.value, "Unexpected token.");
                }
                break;
              case "SequenceExpression": {
                let _2 = g2(B2.expressions);
                B2.range = [f2(B2), Math.min(d2(_2), d2(B2))];
                break;
              }
              case "TopicReference":
                H2.__isUsingHackPipeline = true;
                break;
              case "ExportAllDeclaration": {
                let { exported: _2 } = B2;
                if (H2.parser === "meriyah" && _2 && _2.type === "Identifier") {
                  let u2 = H2.originalText.slice(f2(_2), d2(_2));
                  (u2.startsWith('"') || u2.startsWith("'")) && (B2.exported = Object.assign(Object.assign({}, B2.exported), {}, { type: "Literal", value: B2.exported.name, raw: u2 }));
                }
                break;
              }
              case "PropertyDefinition":
                if (H2.parser === "meriyah" && B2.static && !B2.computed && !B2.key) {
                  let _2 = "static", u2 = f2(B2);
                  Object.assign(B2, { static: false, key: { type: "Identifier", name: _2, range: [u2, u2 + _2.length] } });
                }
                break;
            }
          }), k2;
          function W2(B2, _2) {
            H2.originalText[d2(_2)] !== ";" && (B2.range = [f2(B2), d2(_2)]);
          }
        }
        function C2(k2) {
          switch (k2.type) {
            case "CallExpression":
              k2.type = "OptionalCallExpression", k2.callee = C2(k2.callee);
              break;
            case "MemberExpression":
              k2.type = "OptionalMemberExpression", k2.object = C2(k2.object);
              break;
            case "TSNonNullExpression":
              k2.expression = C2(k2.expression);
              break;
          }
          return k2;
        }
        function L2(k2) {
          return k2.type === "LogicalExpression" && k2.right.type === "LogicalExpression" && k2.operator === k2.right.operator;
        }
        function j2(k2) {
          return L2(k2) ? j2({ type: "LogicalExpression", operator: k2.operator, left: j2({ type: "LogicalExpression", operator: k2.operator, left: k2.left, right: k2.right.left, range: [f2(k2.left), d2(k2.right.left)] }), right: k2.right.right, range: [f2(k2), d2(k2)] }) : k2;
        }
        h2.exports = I2;
      } }), Uo2 = K2({ "node_modules/@babel/parser/lib/index.js"(l2) {
        V2(), Object.defineProperty(l2, "__esModule", { value: true });
        function h2(t2, r2) {
          if (t2 == null)
            return {};
          var e25 = {}, s2 = Object.keys(t2), i2, a2;
          for (a2 = 0; a2 < s2.length; a2++)
            i2 = s2[a2], !(r2.indexOf(i2) >= 0) && (e25[i2] = t2[i2]);
          return e25;
        }
        var f2 = class {
          constructor(t2, r2, e25) {
            this.line = void 0, this.column = void 0, this.index = void 0, this.line = t2, this.column = r2, this.index = e25;
          }
        }, d2 = class {
          constructor(t2, r2) {
            this.start = void 0, this.end = void 0, this.filename = void 0, this.identifierName = void 0, this.start = t2, this.end = r2;
          }
        };
        function y2(t2, r2) {
          let { line: e25, column: s2, index: i2 } = t2;
          return new f2(e25, s2 + r2, i2 + r2);
        }
        var P2 = { SyntaxError: "BABEL_PARSER_SYNTAX_ERROR", SourceTypeModuleError: "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED" }, g2 = function(t2) {
          let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t2.length - 1;
          return { get() {
            return t2.reduce((e25, s2) => e25[s2], this);
          }, set(e25) {
            t2.reduce((s2, i2, a2) => a2 === r2 ? s2[i2] = e25 : s2[i2], this);
          } };
        }, T2 = (t2, r2, e25) => Object.keys(e25).map((s2) => [s2, e25[s2]]).filter((s2) => {
          let [, i2] = s2;
          return !!i2;
        }).map((s2) => {
          let [i2, a2] = s2;
          return [i2, typeof a2 == "function" ? { value: a2, enumerable: false } : typeof a2.reflect == "string" ? Object.assign({}, a2, g2(a2.reflect.split("."))) : a2];
        }).reduce((s2, i2) => {
          let [a2, n2] = i2;
          return Object.defineProperty(s2, a2, Object.assign({ configurable: true }, n2));
        }, Object.assign(new t2(), r2)), S2 = { ImportMetaOutsideModule: { message: `import.meta may appear only with 'sourceType: "module"'`, code: P2.SourceTypeModuleError }, ImportOutsideModule: { message: `'import' and 'export' may appear only with 'sourceType: "module"'`, code: P2.SourceTypeModuleError } }, F2 = { ArrayPattern: "array destructuring pattern", AssignmentExpression: "assignment expression", AssignmentPattern: "assignment expression", ArrowFunctionExpression: "arrow function expression", ConditionalExpression: "conditional expression", CatchClause: "catch clause", ForOfStatement: "for-of statement", ForInStatement: "for-in statement", ForStatement: "for-loop", FormalParameters: "function parameter list", Identifier: "identifier", ImportSpecifier: "import specifier", ImportDefaultSpecifier: "import default specifier", ImportNamespaceSpecifier: "import namespace specifier", ObjectPattern: "object destructuring pattern", ParenthesizedExpression: "parenthesized expression", RestElement: "rest element", UpdateExpression: { true: "prefix operation", false: "postfix operation" }, VariableDeclarator: "variable declaration", YieldExpression: "yield expression" }, I2 = (t2) => {
          let { type: r2, prefix: e25 } = t2;
          return r2 === "UpdateExpression" ? F2.UpdateExpression[String(e25)] : F2[r2];
        }, C2 = { AccessorIsGenerator: (t2) => {
          let { kind: r2 } = t2;
          return `A ${r2}ter cannot be a generator.`;
        }, ArgumentsInClass: "'arguments' is only allowed in functions and class methods.", AsyncFunctionInSingleStatementContext: "Async functions can only be declared at the top level or inside a block.", AwaitBindingIdentifier: "Can not use 'await' as identifier inside an async function.", AwaitBindingIdentifierInStaticBlock: "Can not use 'await' as identifier inside a static block.", AwaitExpressionFormalParameter: "'await' is not allowed in async function parameters.", AwaitNotInAsyncContext: "'await' is only allowed within async functions and at the top levels of modules.", AwaitNotInAsyncFunction: "'await' is only allowed within async functions.", BadGetterArity: "A 'get' accessor must not have any formal parameters.", BadSetterArity: "A 'set' accessor must have exactly one formal parameter.", BadSetterRestParameter: "A 'set' accessor function argument must not be a rest parameter.", ConstructorClassField: "Classes may not have a field named 'constructor'.", ConstructorClassPrivateField: "Classes may not have a private field named '#constructor'.", ConstructorIsAccessor: "Class constructor may not be an accessor.", ConstructorIsAsync: "Constructor can't be an async function.", ConstructorIsGenerator: "Constructor can't be a generator.", DeclarationMissingInitializer: (t2) => {
          let { kind: r2 } = t2;
          return `Missing initializer in ${r2} declaration.`;
        }, DecoratorArgumentsOutsideParentheses: "Decorator arguments must be moved inside parentheses: use '@(decorator(args))' instead of '@(decorator)(args)'.", DecoratorBeforeExport: "Decorators must be placed *before* the 'export' keyword. You can set the 'decoratorsBeforeExport' option to false to use the 'export @decorator class {}' syntax.", DecoratorConstructor: "Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?", DecoratorExportClass: "Using the export keyword between a decorator and a class is not allowed. Please use `export @dec class` instead.", DecoratorSemicolon: "Decorators must not be followed by a semicolon.", DecoratorStaticBlock: "Decorators can't be used with a static block.", DeletePrivateField: "Deleting a private field is not allowed.", DestructureNamedImport: "ES2015 named imports do not destructure. Use another statement for destructuring after the import.", DuplicateConstructor: "Duplicate constructor in the same class.", DuplicateDefaultExport: "Only one default export allowed per module.", DuplicateExport: (t2) => {
          let { exportName: r2 } = t2;
          return `\`${r2}\` has already been exported. Exported identifiers must be unique.`;
        }, DuplicateProto: "Redefinition of __proto__ property.", DuplicateRegExpFlags: "Duplicate regular expression flag.", ElementAfterRest: "Rest element must be last element.", EscapedCharNotAnIdentifier: "Invalid Unicode escape.", ExportBindingIsString: (t2) => {
          let { localName: r2, exportName: e25 } = t2;
          return `A string literal cannot be used as an exported binding without \`from\`.
- Did you mean \`export { '${r2}' as '${e25}' } from 'some-module'\`?`;
        }, ExportDefaultFromAsIdentifier: "'from' is not allowed as an identifier after 'export default'.", ForInOfLoopInitializer: (t2) => {
          let { type: r2 } = t2;
          return `'${r2 === "ForInStatement" ? "for-in" : "for-of"}' loop variable declaration may not have an initializer.`;
        }, ForInUsing: "For-in loop may not start with 'using' declaration.", ForOfAsync: "The left-hand side of a for-of loop may not be 'async'.", ForOfLet: "The left-hand side of a for-of loop may not start with 'let'.", GeneratorInSingleStatementContext: "Generators can only be declared at the top level or inside a block.", IllegalBreakContinue: (t2) => {
          let { type: r2 } = t2;
          return `Unsyntactic ${r2 === "BreakStatement" ? "break" : "continue"}.`;
        }, IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list.", IllegalReturn: "'return' outside of function.", ImportBindingIsString: (t2) => {
          let { importName: r2 } = t2;
          return `A string literal cannot be used as an imported binding.
- Did you mean \`import { "${r2}" as foo }\`?`;
        }, ImportCallArgumentTrailingComma: "Trailing comma is disallowed inside import(...) arguments.", ImportCallArity: (t2) => {
          let { maxArgumentCount: r2 } = t2;
          return `\`import()\` requires exactly ${r2 === 1 ? "one argument" : "one or two arguments"}.`;
        }, ImportCallNotNewExpression: "Cannot use new with import(...).", ImportCallSpreadArgument: "`...` is not allowed in `import()`.", ImportJSONBindingNotDefault: "A JSON module can only be imported with `default`.", ImportReflectionHasAssertion: "`import module x` cannot have assertions.", ImportReflectionNotBinding: 'Only `import module x from "./module"` is valid.', IncompatibleRegExpUVFlags: "The 'u' and 'v' regular expression flags cannot be enabled at the same time.", InvalidBigIntLiteral: "Invalid BigIntLiteral.", InvalidCodePoint: "Code point out of bounds.", InvalidCoverInitializedName: "Invalid shorthand property initializer.", InvalidDecimal: "Invalid decimal.", InvalidDigit: (t2) => {
          let { radix: r2 } = t2;
          return `Expected number in radix ${r2}.`;
        }, InvalidEscapeSequence: "Bad character escape sequence.", InvalidEscapeSequenceTemplate: "Invalid escape sequence in template.", InvalidEscapedReservedWord: (t2) => {
          let { reservedWord: r2 } = t2;
          return `Escape sequence in keyword ${r2}.`;
        }, InvalidIdentifier: (t2) => {
          let { identifierName: r2 } = t2;
          return `Invalid identifier ${r2}.`;
        }, InvalidLhs: (t2) => {
          let { ancestor: r2 } = t2;
          return `Invalid left-hand side in ${I2(r2)}.`;
        }, InvalidLhsBinding: (t2) => {
          let { ancestor: r2 } = t2;
          return `Binding invalid left-hand side in ${I2(r2)}.`;
        }, InvalidNumber: "Invalid number.", InvalidOrMissingExponent: "Floating-point numbers require a valid exponent after the 'e'.", InvalidOrUnexpectedToken: (t2) => {
          let { unexpected: r2 } = t2;
          return `Unexpected character '${r2}'.`;
        }, InvalidParenthesizedAssignment: "Invalid parenthesized assignment pattern.", InvalidPrivateFieldResolution: (t2) => {
          let { identifierName: r2 } = t2;
          return `Private name #${r2} is not defined.`;
        }, InvalidPropertyBindingPattern: "Binding member expression.", InvalidRecordProperty: "Only properties and spread elements are allowed in record definitions.", InvalidRestAssignmentPattern: "Invalid rest operator's argument.", LabelRedeclaration: (t2) => {
          let { labelName: r2 } = t2;
          return `Label '${r2}' is already declared.`;
        }, LetInLexicalBinding: "'let' is not allowed to be used as a name in 'let' or 'const' declarations.", LineTerminatorBeforeArrow: "No line break is allowed before '=>'.", MalformedRegExpFlags: "Invalid regular expression flag.", MissingClassName: "A class name is required.", MissingEqInAssignment: "Only '=' operator can be used for specifying default value.", MissingSemicolon: "Missing semicolon.", MissingPlugin: (t2) => {
          let { missingPlugin: r2 } = t2;
          return `This experimental syntax requires enabling the parser plugin: ${r2.map((e25) => JSON.stringify(e25)).join(", ")}.`;
        }, MissingOneOfPlugins: (t2) => {
          let { missingPlugin: r2 } = t2;
          return `This experimental syntax requires enabling one of the following parser plugin(s): ${r2.map((e25) => JSON.stringify(e25)).join(", ")}.`;
        }, MissingUnicodeEscape: "Expecting Unicode escape sequence \\uXXXX.", MixingCoalesceWithLogical: "Nullish coalescing operator(??) requires parens when mixing with logical operators.", ModuleAttributeDifferentFromType: "The only accepted module attribute is `type`.", ModuleAttributeInvalidValue: "Only string literals are allowed as module attribute values.", ModuleAttributesWithDuplicateKeys: (t2) => {
          let { key: r2 } = t2;
          return `Duplicate key "${r2}" is not allowed in module attributes.`;
        }, ModuleExportNameHasLoneSurrogate: (t2) => {
          let { surrogateCharCode: r2 } = t2;
          return `An export name cannot include a lone surrogate, found '\\u${r2.toString(16)}'.`;
        }, ModuleExportUndefined: (t2) => {
          let { localName: r2 } = t2;
          return `Export '${r2}' is not defined.`;
        }, MultipleDefaultsInSwitch: "Multiple default clauses.", NewlineAfterThrow: "Illegal newline after throw.", NoCatchOrFinally: "Missing catch or finally clause.", NumberIdentifier: "Identifier directly after number.", NumericSeparatorInEscapeSequence: "Numeric separators are not allowed inside unicode escape sequences or hex escape sequences.", ObsoleteAwaitStar: "'await*' has been removed from the async functions proposal. Use Promise.all() instead.", OptionalChainingNoNew: "Constructors in/after an Optional Chain are not allowed.", OptionalChainingNoTemplate: "Tagged Template Literals are not allowed in optionalChain.", OverrideOnConstructor: "'override' modifier cannot appear on a constructor declaration.", ParamDupe: "Argument name clash.", PatternHasAccessor: "Object pattern can't contain getter or setter.", PatternHasMethod: "Object pattern can't contain methods.", PrivateInExpectedIn: (t2) => {
          let { identifierName: r2 } = t2;
          return `Private names are only allowed in property accesses (\`obj.#${r2}\`) or in \`in\` expressions (\`#${r2} in obj\`).`;
        }, PrivateNameRedeclaration: (t2) => {
          let { identifierName: r2 } = t2;
          return `Duplicate private name #${r2}.`;
        }, RecordExpressionBarIncorrectEndSyntaxType: "Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", RecordExpressionBarIncorrectStartSyntaxType: "Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", RecordExpressionHashIncorrectStartSyntaxType: "Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.", RecordNoProto: "'__proto__' is not allowed in Record expressions.", RestTrailingComma: "Unexpected trailing comma after rest element.", SloppyFunction: "In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement.", StaticPrototype: "Classes may not have static property named prototype.", SuperNotAllowed: "`super()` is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?", SuperPrivateField: "Private fields can't be accessed on super.", TrailingDecorator: "Decorators must be attached to a class element.", TupleExpressionBarIncorrectEndSyntaxType: "Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", TupleExpressionBarIncorrectStartSyntaxType: "Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", TupleExpressionHashIncorrectStartSyntaxType: "Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.", UnexpectedArgumentPlaceholder: "Unexpected argument placeholder.", UnexpectedAwaitAfterPipelineBody: 'Unexpected "await" after pipeline body; await must have parentheses in minimal proposal.', UnexpectedDigitAfterHash: "Unexpected digit after hash token.", UnexpectedImportExport: "'import' and 'export' may only appear at the top level.", UnexpectedKeyword: (t2) => {
          let { keyword: r2 } = t2;
          return `Unexpected keyword '${r2}'.`;
        }, UnexpectedLeadingDecorator: "Leading decorators must be attached to a class declaration.", UnexpectedLexicalDeclaration: "Lexical declaration cannot appear in a single-statement context.", UnexpectedNewTarget: "`new.target` can only be used in functions or class properties.", UnexpectedNumericSeparator: "A numeric separator is only allowed between two digits.", UnexpectedPrivateField: "Unexpected private name.", UnexpectedReservedWord: (t2) => {
          let { reservedWord: r2 } = t2;
          return `Unexpected reserved word '${r2}'.`;
        }, UnexpectedSuper: "'super' is only allowed in object methods and classes.", UnexpectedToken: (t2) => {
          let { expected: r2, unexpected: e25 } = t2;
          return `Unexpected token${e25 ? ` '${e25}'.` : ""}${r2 ? `, expected "${r2}"` : ""}`;
        }, UnexpectedTokenUnaryExponentiation: "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.", UnexpectedUsingDeclaration: "Using declaration cannot appear in the top level when source type is `script`.", UnsupportedBind: "Binding should be performed on object property.", UnsupportedDecoratorExport: "A decorated export must export a class declaration.", UnsupportedDefaultExport: "Only expressions, functions or classes are allowed as the `default` export.", UnsupportedImport: "`import` can only be used in `import()` or `import.meta`.", UnsupportedMetaProperty: (t2) => {
          let { target: r2, onlyValidPropertyName: e25 } = t2;
          return `The only valid meta property for ${r2} is ${r2}.${e25}.`;
        }, UnsupportedParameterDecorator: "Decorators cannot be used to decorate parameters.", UnsupportedPropertyDecorator: "Decorators cannot be used to decorate object literal properties.", UnsupportedSuper: "'super' can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop]).", UnterminatedComment: "Unterminated comment.", UnterminatedRegExp: "Unterminated regular expression.", UnterminatedString: "Unterminated string constant.", UnterminatedTemplate: "Unterminated template.", UsingDeclarationHasBindingPattern: "Using declaration cannot have destructuring patterns.", VarRedeclaration: (t2) => {
          let { identifierName: r2 } = t2;
          return `Identifier '${r2}' has already been declared.`;
        }, YieldBindingIdentifier: "Can not use 'yield' as identifier inside a generator.", YieldInParameter: "Yield expression is not allowed in formal parameters.", ZeroDigitNumericSeparator: "Numeric separator can not be used after leading 0." }, L2 = { StrictDelete: "Deleting local variable in strict mode.", StrictEvalArguments: (t2) => {
          let { referenceName: r2 } = t2;
          return `Assigning to '${r2}' in strict mode.`;
        }, StrictEvalArgumentsBinding: (t2) => {
          let { bindingName: r2 } = t2;
          return `Binding '${r2}' in strict mode.`;
        }, StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block.", StrictNumericEscape: "The only valid numeric escape in strict mode is '\\0'.", StrictOctalLiteral: "Legacy octal literals are not allowed in strict mode.", StrictWith: "'with' in strict mode." }, j2 = new Set(["ArrowFunctionExpression", "AssignmentExpression", "ConditionalExpression", "YieldExpression"]), k2 = { PipeBodyIsTighter: "Unexpected yield after pipeline body; any yield expression acting as Hack-style pipe body must be parenthesized due to its loose operator precedence.", PipeTopicRequiresHackPipes: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.', PipeTopicUnbound: "Topic reference is unbound; it must be inside a pipe body.", PipeTopicUnconfiguredToken: (t2) => {
          let { token: r2 } = t2;
          return `Invalid topic token ${r2}. In order to use ${r2} as a topic reference, the pipelineOperator plugin must be configured with { "proposal": "hack", "topicToken": "${r2}" }.`;
        }, PipeTopicUnused: "Hack-style pipe body does not contain a topic reference; Hack-style pipes must use topic at least once.", PipeUnparenthesizedBody: (t2) => {
          let { type: r2 } = t2;
          return `Hack-style pipe body cannot be an unparenthesized ${I2({ type: r2 })}; please wrap it in parentheses.`;
        }, PipelineBodyNoArrow: 'Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized.', PipelineBodySequenceExpression: "Pipeline body may not be a comma-separated sequence expression.", PipelineHeadSequenceExpression: "Pipeline head should not be a comma-separated sequence expression.", PipelineTopicUnused: "Pipeline is in topic style but does not use topic reference.", PrimaryTopicNotAllowed: "Topic reference was used in a lexical context without topic binding.", PrimaryTopicRequiresSmartPipeline: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.' }, H2 = ["toMessage"], W2 = ["message"];
        function B2(t2) {
          let { toMessage: r2 } = t2, e25 = h2(t2, H2);
          return function s2(i2) {
            let { loc: a2, details: n2 } = i2;
            return T2(SyntaxError, Object.assign({}, e25, { loc: a2 }), { clone() {
              let o2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c2 = o2.loc || {};
              return s2({ loc: new f2("line" in c2 ? c2.line : this.loc.line, "column" in c2 ? c2.column : this.loc.column, "index" in c2 ? c2.index : this.loc.index), details: Object.assign({}, this.details, o2.details) });
            }, details: { value: n2, enumerable: false }, message: { get() {
              return `${r2(this.details)} (${this.loc.line}:${this.loc.column})`;
            }, set(o2) {
              Object.defineProperty(this, "message", { value: o2 });
            } }, pos: { reflect: "loc.index", enumerable: true }, missingPlugin: "missingPlugin" in n2 && { reflect: "details.missingPlugin", enumerable: true } });
          };
        }
        function _2(t2, r2) {
          if (Array.isArray(t2))
            return (s2) => _2(s2, t2[0]);
          let e25 = {};
          for (let s2 of Object.keys(t2)) {
            let i2 = t2[s2], a2 = typeof i2 == "string" ? { message: () => i2 } : typeof i2 == "function" ? { message: i2 } : i2, { message: n2 } = a2, o2 = h2(a2, W2), c2 = typeof n2 == "string" ? () => n2 : n2;
            e25[s2] = B2(Object.assign({ code: P2.SyntaxError, reasonCode: s2, toMessage: c2 }, r2 ? { syntaxPlugin: r2 } : {}, o2));
          }
          return e25;
        }
        var u2 = Object.assign({}, _2(S2), _2(C2), _2(L2), _2`pipelineOperator`(k2)), { defineProperty: G2 } = Object, oe2 = (t2, r2) => G2(t2, r2, { enumerable: false, value: t2[r2] });
        function X2(t2) {
          return t2.loc.start && oe2(t2.loc.start, "index"), t2.loc.end && oe2(t2.loc.end, "index"), t2;
        }
        var _e2 = (t2) => class extends t2 {
          parse() {
            let e25 = X2(super.parse());
            return this.options.tokens && (e25.tokens = e25.tokens.map(X2)), e25;
          }
          parseRegExpLiteral(e25) {
            let { pattern: s2, flags: i2 } = e25, a2 = null;
            try {
              a2 = new RegExp(s2, i2);
            } catch {
            }
            let n2 = this.estreeParseLiteral(a2);
            return n2.regex = { pattern: s2, flags: i2 }, n2;
          }
          parseBigIntLiteral(e25) {
            let s2;
            try {
              s2 = BigInt(e25);
            } catch {
              s2 = null;
            }
            let i2 = this.estreeParseLiteral(s2);
            return i2.bigint = String(i2.value || e25), i2;
          }
          parseDecimalLiteral(e25) {
            let i2 = this.estreeParseLiteral(null);
            return i2.decimal = String(i2.value || e25), i2;
          }
          estreeParseLiteral(e25) {
            return this.parseLiteral(e25, "Literal");
          }
          parseStringLiteral(e25) {
            return this.estreeParseLiteral(e25);
          }
          parseNumericLiteral(e25) {
            return this.estreeParseLiteral(e25);
          }
          parseNullLiteral() {
            return this.estreeParseLiteral(null);
          }
          parseBooleanLiteral(e25) {
            return this.estreeParseLiteral(e25);
          }
          directiveToStmt(e25) {
            let s2 = e25.value;
            delete e25.value, s2.type = "Literal", s2.raw = s2.extra.raw, s2.value = s2.extra.expressionValue;
            let i2 = e25;
            return i2.type = "ExpressionStatement", i2.expression = s2, i2.directive = s2.extra.rawValue, delete s2.extra, i2;
          }
          initFunction(e25, s2) {
            super.initFunction(e25, s2), e25.expression = false;
          }
          checkDeclaration(e25) {
            e25 != null && this.isObjectProperty(e25) ? this.checkDeclaration(e25.value) : super.checkDeclaration(e25);
          }
          getObjectOrClassMethodParams(e25) {
            return e25.value.params;
          }
          isValidDirective(e25) {
            var s2;
            return e25.type === "ExpressionStatement" && e25.expression.type === "Literal" && typeof e25.expression.value == "string" && !((s2 = e25.expression.extra) != null && s2.parenthesized);
          }
          parseBlockBody(e25, s2, i2, a2, n2) {
            super.parseBlockBody(e25, s2, i2, a2, n2);
            let o2 = e25.directives.map((c2) => this.directiveToStmt(c2));
            e25.body = o2.concat(e25.body), delete e25.directives;
          }
          pushClassMethod(e25, s2, i2, a2, n2, o2) {
            this.parseMethod(s2, i2, a2, n2, o2, "ClassMethod", true), s2.typeParameters && (s2.value.typeParameters = s2.typeParameters, delete s2.typeParameters), e25.body.push(s2);
          }
          parsePrivateName() {
            let e25 = super.parsePrivateName();
            return this.getPluginOption("estree", "classFeatures") ? this.convertPrivateNameToPrivateIdentifier(e25) : e25;
          }
          convertPrivateNameToPrivateIdentifier(e25) {
            let s2 = super.getPrivateNameSV(e25);
            return e25 = e25, delete e25.id, e25.name = s2, e25.type = "PrivateIdentifier", e25;
          }
          isPrivateName(e25) {
            return this.getPluginOption("estree", "classFeatures") ? e25.type === "PrivateIdentifier" : super.isPrivateName(e25);
          }
          getPrivateNameSV(e25) {
            return this.getPluginOption("estree", "classFeatures") ? e25.name : super.getPrivateNameSV(e25);
          }
          parseLiteral(e25, s2) {
            let i2 = super.parseLiteral(e25, s2);
            return i2.raw = i2.extra.raw, delete i2.extra, i2;
          }
          parseFunctionBody(e25, s2) {
            let i2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            super.parseFunctionBody(e25, s2, i2), e25.expression = e25.body.type !== "BlockStatement";
          }
          parseMethod(e25, s2, i2, a2, n2, o2) {
            let c2 = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, p2 = this.startNode();
            return p2.kind = e25.kind, p2 = super.parseMethod(p2, s2, i2, a2, n2, o2, c2), p2.type = "FunctionExpression", delete p2.kind, e25.value = p2, o2 === "ClassPrivateMethod" && (e25.computed = false), this.finishNode(e25, "MethodDefinition");
          }
          parseClassProperty() {
            let e25 = super.parseClassProperty(...arguments);
            return this.getPluginOption("estree", "classFeatures") && (e25.type = "PropertyDefinition"), e25;
          }
          parseClassPrivateProperty() {
            let e25 = super.parseClassPrivateProperty(...arguments);
            return this.getPluginOption("estree", "classFeatures") && (e25.type = "PropertyDefinition", e25.computed = false), e25;
          }
          parseObjectMethod(e25, s2, i2, a2, n2) {
            let o2 = super.parseObjectMethod(e25, s2, i2, a2, n2);
            return o2 && (o2.type = "Property", o2.kind === "method" && (o2.kind = "init"), o2.shorthand = false), o2;
          }
          parseObjectProperty(e25, s2, i2, a2) {
            let n2 = super.parseObjectProperty(e25, s2, i2, a2);
            return n2 && (n2.kind = "init", n2.type = "Property"), n2;
          }
          isValidLVal(e25, s2, i2) {
            return e25 === "Property" ? "value" : super.isValidLVal(e25, s2, i2);
          }
          isAssignable(e25, s2) {
            return e25 != null && this.isObjectProperty(e25) ? this.isAssignable(e25.value, s2) : super.isAssignable(e25, s2);
          }
          toAssignable(e25) {
            let s2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            if (e25 != null && this.isObjectProperty(e25)) {
              let { key: i2, value: a2 } = e25;
              this.isPrivateName(i2) && this.classScope.usePrivateName(this.getPrivateNameSV(i2), i2.loc.start), this.toAssignable(a2, s2);
            } else
              super.toAssignable(e25, s2);
          }
          toAssignableObjectExpressionProp(e25, s2, i2) {
            e25.kind === "get" || e25.kind === "set" ? this.raise(u2.PatternHasAccessor, { at: e25.key }) : e25.method ? this.raise(u2.PatternHasMethod, { at: e25.key }) : super.toAssignableObjectExpressionProp(e25, s2, i2);
          }
          finishCallExpression(e25, s2) {
            let i2 = super.finishCallExpression(e25, s2);
            if (i2.callee.type === "Import") {
              if (i2.type = "ImportExpression", i2.source = i2.arguments[0], this.hasPlugin("importAssertions")) {
                var a2;
                i2.attributes = (a2 = i2.arguments[1]) != null ? a2 : null;
              }
              delete i2.arguments, delete i2.callee;
            }
            return i2;
          }
          toReferencedArguments(e25) {
            e25.type !== "ImportExpression" && super.toReferencedArguments(e25);
          }
          parseExport(e25, s2) {
            let i2 = this.state.lastTokStartLoc, a2 = super.parseExport(e25, s2);
            switch (a2.type) {
              case "ExportAllDeclaration":
                a2.exported = null;
                break;
              case "ExportNamedDeclaration":
                a2.specifiers.length === 1 && a2.specifiers[0].type === "ExportNamespaceSpecifier" && (a2.type = "ExportAllDeclaration", a2.exported = a2.specifiers[0].exported, delete a2.specifiers);
              case "ExportDefaultDeclaration":
                {
                  var n2;
                  let { declaration: o2 } = a2;
                  (o2 == null ? void 0 : o2.type) === "ClassDeclaration" && ((n2 = o2.decorators) == null ? void 0 : n2.length) > 0 && o2.start === a2.start && this.resetStartLocation(a2, i2);
                }
                break;
            }
            return a2;
          }
          parseSubscript(e25, s2, i2, a2) {
            let n2 = super.parseSubscript(e25, s2, i2, a2);
            if (a2.optionalChainMember) {
              if ((n2.type === "OptionalMemberExpression" || n2.type === "OptionalCallExpression") && (n2.type = n2.type.substring(8)), a2.stop) {
                let o2 = this.startNodeAtNode(n2);
                return o2.expression = n2, this.finishNode(o2, "ChainExpression");
              }
            } else
              (n2.type === "MemberExpression" || n2.type === "CallExpression") && (n2.optional = false);
            return n2;
          }
          hasPropertyAsPrivateName(e25) {
            return e25.type === "ChainExpression" && (e25 = e25.expression), super.hasPropertyAsPrivateName(e25);
          }
          isOptionalChain(e25) {
            return e25.type === "ChainExpression";
          }
          isObjectProperty(e25) {
            return e25.type === "Property" && e25.kind === "init" && !e25.method;
          }
          isObjectMethod(e25) {
            return e25.method || e25.kind === "get" || e25.kind === "set";
          }
          finishNodeAt(e25, s2, i2) {
            return X2(super.finishNodeAt(e25, s2, i2));
          }
          resetStartLocation(e25, s2) {
            super.resetStartLocation(e25, s2), X2(e25);
          }
          resetEndLocation(e25) {
            let s2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
            super.resetEndLocation(e25, s2), X2(e25);
          }
        }, Z2 = class {
          constructor(t2, r2) {
            this.token = void 0, this.preserveSpace = void 0, this.token = t2, this.preserveSpace = !!r2;
          }
        }, $2 = { brace: new Z2("{"), j_oTag: new Z2("<tag"), j_cTag: new Z2("</tag"), j_expr: new Z2("<tag>...</tag>", true) };
        $2.template = new Z2("`", true);
        var M2 = true, E2 = true, Je2 = true, ee2 = true, fe2 = true, zo2 = true, xr2 = class {
          constructor(t2) {
            let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            this.label = void 0, this.keyword = void 0, this.beforeExpr = void 0, this.startsExpr = void 0, this.rightAssociative = void 0, this.isLoop = void 0, this.isAssign = void 0, this.prefix = void 0, this.postfix = void 0, this.binop = void 0, this.label = t2, this.keyword = r2.keyword, this.beforeExpr = !!r2.beforeExpr, this.startsExpr = !!r2.startsExpr, this.rightAssociative = !!r2.rightAssociative, this.isLoop = !!r2.isLoop, this.isAssign = !!r2.isAssign, this.prefix = !!r2.prefix, this.postfix = !!r2.postfix, this.binop = r2.binop != null ? r2.binop : null, this.updateContext = null;
          }
        }, zt2 = new Map();
        function U2(t2) {
          let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          r2.keyword = t2;
          let e25 = N2(t2, r2);
          return zt2.set(t2, e25), e25;
        }
        function re2(t2, r2) {
          return N2(t2, { beforeExpr: M2, binop: r2 });
        }
        var Xe2 = -1, me2 = [], Vt2 = [], Kt2 = [], Wt2 = [], Gt2 = [], Jt2 = [];
        function N2(t2) {
          let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          var e25, s2, i2, a2;
          return ++Xe2, Vt2.push(t2), Kt2.push((e25 = r2.binop) != null ? e25 : -1), Wt2.push((s2 = r2.beforeExpr) != null ? s2 : false), Gt2.push((i2 = r2.startsExpr) != null ? i2 : false), Jt2.push((a2 = r2.prefix) != null ? a2 : false), me2.push(new xr2(t2, r2)), Xe2;
        }
        function q2(t2) {
          let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          var e25, s2, i2, a2;
          return ++Xe2, zt2.set(t2, Xe2), Vt2.push(t2), Kt2.push((e25 = r2.binop) != null ? e25 : -1), Wt2.push((s2 = r2.beforeExpr) != null ? s2 : false), Gt2.push((i2 = r2.startsExpr) != null ? i2 : false), Jt2.push((a2 = r2.prefix) != null ? a2 : false), me2.push(new xr2("name", r2)), Xe2;
        }
        var Vo2 = { bracketL: N2("[", { beforeExpr: M2, startsExpr: E2 }), bracketHashL: N2("#[", { beforeExpr: M2, startsExpr: E2 }), bracketBarL: N2("[|", { beforeExpr: M2, startsExpr: E2 }), bracketR: N2("]"), bracketBarR: N2("|]"), braceL: N2("{", { beforeExpr: M2, startsExpr: E2 }), braceBarL: N2("{|", { beforeExpr: M2, startsExpr: E2 }), braceHashL: N2("#{", { beforeExpr: M2, startsExpr: E2 }), braceR: N2("}"), braceBarR: N2("|}"), parenL: N2("(", { beforeExpr: M2, startsExpr: E2 }), parenR: N2(")"), comma: N2(",", { beforeExpr: M2 }), semi: N2(";", { beforeExpr: M2 }), colon: N2(":", { beforeExpr: M2 }), doubleColon: N2("::", { beforeExpr: M2 }), dot: N2("."), question: N2("?", { beforeExpr: M2 }), questionDot: N2("?."), arrow: N2("=>", { beforeExpr: M2 }), template: N2("template"), ellipsis: N2("...", { beforeExpr: M2 }), backQuote: N2("`", { startsExpr: E2 }), dollarBraceL: N2("${", { beforeExpr: M2, startsExpr: E2 }), templateTail: N2("...`", { startsExpr: E2 }), templateNonTail: N2("...${", { beforeExpr: M2, startsExpr: E2 }), at: N2("@"), hash: N2("#", { startsExpr: E2 }), interpreterDirective: N2("#!..."), eq: N2("=", { beforeExpr: M2, isAssign: ee2 }), assign: N2("_=", { beforeExpr: M2, isAssign: ee2 }), slashAssign: N2("_=", { beforeExpr: M2, isAssign: ee2 }), xorAssign: N2("_=", { beforeExpr: M2, isAssign: ee2 }), moduloAssign: N2("_=", { beforeExpr: M2, isAssign: ee2 }), incDec: N2("++/--", { prefix: fe2, postfix: zo2, startsExpr: E2 }), bang: N2("!", { beforeExpr: M2, prefix: fe2, startsExpr: E2 }), tilde: N2("~", { beforeExpr: M2, prefix: fe2, startsExpr: E2 }), doubleCaret: N2("^^", { startsExpr: E2 }), doubleAt: N2("@@", { startsExpr: E2 }), pipeline: re2("|>", 0), nullishCoalescing: re2("??", 1), logicalOR: re2("||", 1), logicalAND: re2("&&", 2), bitwiseOR: re2("|", 3), bitwiseXOR: re2("^", 4), bitwiseAND: re2("&", 5), equality: re2("==/!=/===/!==", 6), lt: re2("</>/<=/>=", 7), gt: re2("</>/<=/>=", 7), relational: re2("</>/<=/>=", 7), bitShift: re2("<</>>/>>>", 8), bitShiftL: re2("<</>>/>>>", 8), bitShiftR: re2("<</>>/>>>", 8), plusMin: N2("+/-", { beforeExpr: M2, binop: 9, prefix: fe2, startsExpr: E2 }), modulo: N2("%", { binop: 10, startsExpr: E2 }), star: N2("*", { binop: 10 }), slash: re2("/", 10), exponent: N2("**", { beforeExpr: M2, binop: 11, rightAssociative: true }), _in: U2("in", { beforeExpr: M2, binop: 7 }), _instanceof: U2("instanceof", { beforeExpr: M2, binop: 7 }), _break: U2("break"), _case: U2("case", { beforeExpr: M2 }), _catch: U2("catch"), _continue: U2("continue"), _debugger: U2("debugger"), _default: U2("default", { beforeExpr: M2 }), _else: U2("else", { beforeExpr: M2 }), _finally: U2("finally"), _function: U2("function", { startsExpr: E2 }), _if: U2("if"), _return: U2("return", { beforeExpr: M2 }), _switch: U2("switch"), _throw: U2("throw", { beforeExpr: M2, prefix: fe2, startsExpr: E2 }), _try: U2("try"), _var: U2("var"), _const: U2("const"), _with: U2("with"), _new: U2("new", { beforeExpr: M2, startsExpr: E2 }), _this: U2("this", { startsExpr: E2 }), _super: U2("super", { startsExpr: E2 }), _class: U2("class", { startsExpr: E2 }), _extends: U2("extends", { beforeExpr: M2 }), _export: U2("export"), _import: U2("import", { startsExpr: E2 }), _null: U2("null", { startsExpr: E2 }), _true: U2("true", { startsExpr: E2 }), _false: U2("false", { startsExpr: E2 }), _typeof: U2("typeof", { beforeExpr: M2, prefix: fe2, startsExpr: E2 }), _void: U2("void", { beforeExpr: M2, prefix: fe2, startsExpr: E2 }), _delete: U2("delete", { beforeExpr: M2, prefix: fe2, startsExpr: E2 }), _do: U2("do", { isLoop: Je2, beforeExpr: M2 }), _for: U2("for", { isLoop: Je2 }), _while: U2("while", { isLoop: Je2 }), _as: q2("as", { startsExpr: E2 }), _assert: q2("assert", { startsExpr: E2 }), _async: q2("async", { startsExpr: E2 }), _await: q2("await", { startsExpr: E2 }), _from: q2("from", { startsExpr: E2 }), _get: q2("get", { startsExpr: E2 }), _let: q2("let", { startsExpr: E2 }), _meta: q2("meta", { startsExpr: E2 }), _of: q2("of", { startsExpr: E2 }), _sent: q2("sent", { startsExpr: E2 }), _set: q2("set", { startsExpr: E2 }), _static: q2("static", { startsExpr: E2 }), _using: q2("using", { startsExpr: E2 }), _yield: q2("yield", { startsExpr: E2 }), _asserts: q2("asserts", { startsExpr: E2 }), _checks: q2("checks", { startsExpr: E2 }), _exports: q2("exports", { startsExpr: E2 }), _global: q2("global", { startsExpr: E2 }), _implements: q2("implements", { startsExpr: E2 }), _intrinsic: q2("intrinsic", { startsExpr: E2 }), _infer: q2("infer", { startsExpr: E2 }), _is: q2("is", { startsExpr: E2 }), _mixins: q2("mixins", { startsExpr: E2 }), _proto: q2("proto", { startsExpr: E2 }), _require: q2("require", { startsExpr: E2 }), _satisfies: q2("satisfies", { startsExpr: E2 }), _keyof: q2("keyof", { startsExpr: E2 }), _readonly: q2("readonly", { startsExpr: E2 }), _unique: q2("unique", { startsExpr: E2 }), _abstract: q2("abstract", { startsExpr: E2 }), _declare: q2("declare", { startsExpr: E2 }), _enum: q2("enum", { startsExpr: E2 }), _module: q2("module", { startsExpr: E2 }), _namespace: q2("namespace", { startsExpr: E2 }), _interface: q2("interface", { startsExpr: E2 }), _type: q2("type", { startsExpr: E2 }), _opaque: q2("opaque", { startsExpr: E2 }), name: N2("name", { startsExpr: E2 }), string: N2("string", { startsExpr: E2 }), num: N2("num", { startsExpr: E2 }), bigint: N2("bigint", { startsExpr: E2 }), decimal: N2("decimal", { startsExpr: E2 }), regexp: N2("regexp", { startsExpr: E2 }), privateName: N2("#name", { startsExpr: E2 }), eof: N2("eof"), jsxName: N2("jsxName"), jsxText: N2("jsxText", { beforeExpr: true }), jsxTagStart: N2("jsxTagStart", { startsExpr: true }), jsxTagEnd: N2("jsxTagEnd"), placeholder: N2("%%", { startsExpr: true }) };
        function z2(t2) {
          return t2 >= 93 && t2 <= 130;
        }
        function Ko2(t2) {
          return t2 <= 92;
        }
        function ye2(t2) {
          return t2 >= 58 && t2 <= 130;
        }
        function gr2(t2) {
          return t2 >= 58 && t2 <= 134;
        }
        function Wo2(t2) {
          return Wt2[t2];
        }
        function Xt2(t2) {
          return Gt2[t2];
        }
        function Go2(t2) {
          return t2 >= 29 && t2 <= 33;
        }
        function Pr2(t2) {
          return t2 >= 127 && t2 <= 129;
        }
        function Jo2(t2) {
          return t2 >= 90 && t2 <= 92;
        }
        function Yt2(t2) {
          return t2 >= 58 && t2 <= 92;
        }
        function Xo2(t2) {
          return t2 >= 39 && t2 <= 59;
        }
        function Yo2(t2) {
          return t2 === 34;
        }
        function Qo2(t2) {
          return Jt2[t2];
        }
        function Zo2(t2) {
          return t2 >= 119 && t2 <= 121;
        }
        function el2(t2) {
          return t2 >= 122 && t2 <= 128;
        }
        function Ee2(t2) {
          return Vt2[t2];
        }
        function ut2(t2) {
          return Kt2[t2];
        }
        function tl2(t2) {
          return t2 === 57;
        }
        function ct2(t2) {
          return t2 >= 24 && t2 <= 25;
        }
        function xe2(t2) {
          return me2[t2];
        }
        me2[8].updateContext = (t2) => {
          t2.pop();
        }, me2[5].updateContext = me2[7].updateContext = me2[23].updateContext = (t2) => {
          t2.push($2.brace);
        }, me2[22].updateContext = (t2) => {
          t2[t2.length - 1] === $2.template ? t2.pop() : t2.push($2.template);
        }, me2[140].updateContext = (t2) => {
          t2.push($2.j_expr, $2.j_oTag);
        };
        var Qt2 = "\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC", Ar2 = "\u200C\u200D\xB7\u0300-\u036F\u0387\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u0669\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u06F0-\u06F9\u0711\u0730-\u074A\u07A6-\u07B0\u07C0-\u07C9\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0966-\u096F\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09E6-\u09EF\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A66-\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AE6-\u0AEF\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B66-\u0B6F\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0BE6-\u0BEF\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C66-\u0C6F\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CE6-\u0CEF\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D66-\u0D6F\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0E50-\u0E59\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0ED0-\u0ED9\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1040-\u1049\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F-\u109D\u135D-\u135F\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u18A9\u1920-\u192B\u1930-\u193B\u1946-\u194F\u19D0-\u19DA\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B04\u1B34-\u1B44\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BB0-\u1BB9\u1BE6-\u1BF3\u1C24-\u1C37\u1C40-\u1C49\u1C50-\u1C59\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u203F\u2040\u2054\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA620-\uA629\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F1\uA8FF-\uA909\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9D0-\uA9D9\uA9E5\uA9F0-\uA9F9\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA50-\uAA59\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uABF0-\uABF9\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFF10-\uFF19\uFF3F", sl2 = new RegExp("[" + Qt2 + "]"), rl2 = new RegExp("[" + Qt2 + Ar2 + "]");
        Qt2 = Ar2 = null;
        var Tr2 = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938, 6, 4191], il2 = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
        function Zt2(t2, r2) {
          let e25 = 65536;
          for (let s2 = 0, i2 = r2.length; s2 < i2; s2 += 2) {
            if (e25 += r2[s2], e25 > t2)
              return false;
            if (e25 += r2[s2 + 1], e25 >= t2)
              return true;
          }
          return false;
        }
        function ge2(t2) {
          return t2 < 65 ? t2 === 36 : t2 <= 90 ? true : t2 < 97 ? t2 === 95 : t2 <= 122 ? true : t2 <= 65535 ? t2 >= 170 && sl2.test(String.fromCharCode(t2)) : Zt2(t2, Tr2);
        }
        function Re2(t2) {
          return t2 < 48 ? t2 === 36 : t2 < 58 ? true : t2 < 65 ? false : t2 <= 90 ? true : t2 < 97 ? t2 === 95 : t2 <= 122 ? true : t2 <= 65535 ? t2 >= 170 && rl2.test(String.fromCharCode(t2)) : Zt2(t2, Tr2) || Zt2(t2, il2);
        }
        var es2 = { keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"], strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"], strictBind: ["eval", "arguments"] }, al2 = new Set(es2.keyword), nl2 = new Set(es2.strict), ol2 = new Set(es2.strictBind);
        function vr2(t2, r2) {
          return r2 && t2 === "await" || t2 === "enum";
        }
        function Er2(t2, r2) {
          return vr2(t2, r2) || nl2.has(t2);
        }
        function Cr(t2) {
          return ol2.has(t2);
        }
        function br2(t2, r2) {
          return Er2(t2, r2) || Cr(t2);
        }
        function ll2(t2) {
          return al2.has(t2);
        }
        function hl2(t2, r2, e25) {
          return t2 === 64 && r2 === 64 && ge2(e25);
        }
        var ul2 = new Set(["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete", "implements", "interface", "let", "package", "private", "protected", "public", "static", "yield", "eval", "arguments", "enum", "await"]);
        function cl2(t2) {
          return ul2.has(t2);
        }
        var je2 = 0, qe2 = 1, Pe2 = 2, ts2 = 4, Sr = 8, pt2 = 16, wr2 = 32, Ne2 = 64, ft2 = 128, Ue2 = 256, dt2 = qe2 | Pe2 | ft2 | Ue2, Ae2 = 1, ke2 = 2, Ir2 = 4, Ce2 = 8, mt2 = 16, Nr2 = 64, yt2 = 128, ss2 = 256, rs2 = 512, is2 = 1024, as2 = 2048, Ye2 = 4096, kr = Ae2 | ke2 | Ce2 | yt2, De2 = Ae2 | 0 | Ce2 | 0, xt = Ae2 | 0 | Ir2 | 0, Dr2 = Ae2 | 0 | mt2 | 0, pl2 = 0 | ke2 | 0 | yt2, fl2 = 0 | ke2 | 0 | 0, Fr2 = Ae2 | ke2 | Ce2 | ss2, Lr2 = 0 | is2, be2 = 0 | Nr2, dl2 = Ae2 | 0 | 0 | Nr2, ml2 = Fr2 | rs2, yl2 = 0 | is2, Or2 = 0 | ke2 | 0 | Ye2, xl2 = as2, gt2 = 4, ns2 = 2, os2 = 1, ls = ns2 | os2, gl2 = ns2 | gt2, Pl2 = os2 | gt2, Al2 = ns2, Tl2 = os2, hs = 0, us2 = class {
          constructor(t2) {
            this.var = new Set(), this.lexical = new Set(), this.functions = new Set(), this.flags = t2;
          }
        }, cs = class {
          constructor(t2, r2) {
            this.parser = void 0, this.scopeStack = [], this.inModule = void 0, this.undefinedExports = new Map(), this.parser = t2, this.inModule = r2;
          }
          get inTopLevel() {
            return (this.currentScope().flags & qe2) > 0;
          }
          get inFunction() {
            return (this.currentVarScopeFlags() & Pe2) > 0;
          }
          get allowSuper() {
            return (this.currentThisScopeFlags() & pt2) > 0;
          }
          get allowDirectSuper() {
            return (this.currentThisScopeFlags() & wr2) > 0;
          }
          get inClass() {
            return (this.currentThisScopeFlags() & Ne2) > 0;
          }
          get inClassAndNotInNonArrowFunction() {
            let t2 = this.currentThisScopeFlags();
            return (t2 & Ne2) > 0 && (t2 & Pe2) === 0;
          }
          get inStaticBlock() {
            for (let t2 = this.scopeStack.length - 1; ; t2--) {
              let { flags: r2 } = this.scopeStack[t2];
              if (r2 & ft2)
                return true;
              if (r2 & (dt2 | Ne2))
                return false;
            }
          }
          get inNonArrowFunction() {
            return (this.currentThisScopeFlags() & Pe2) > 0;
          }
          get treatFunctionsAsVar() {
            return this.treatFunctionsAsVarInScope(this.currentScope());
          }
          createScope(t2) {
            return new us2(t2);
          }
          enter(t2) {
            this.scopeStack.push(this.createScope(t2));
          }
          exit() {
            return this.scopeStack.pop().flags;
          }
          treatFunctionsAsVarInScope(t2) {
            return !!(t2.flags & (Pe2 | ft2) || !this.parser.inModule && t2.flags & qe2);
          }
          declareName(t2, r2, e25) {
            let s2 = this.currentScope();
            if (r2 & Ce2 || r2 & mt2)
              this.checkRedeclarationInScope(s2, t2, r2, e25), r2 & mt2 ? s2.functions.add(t2) : s2.lexical.add(t2), r2 & Ce2 && this.maybeExportDefined(s2, t2);
            else if (r2 & Ir2)
              for (let i2 = this.scopeStack.length - 1; i2 >= 0 && (s2 = this.scopeStack[i2], this.checkRedeclarationInScope(s2, t2, r2, e25), s2.var.add(t2), this.maybeExportDefined(s2, t2), !(s2.flags & dt2)); --i2)
                ;
            this.parser.inModule && s2.flags & qe2 && this.undefinedExports.delete(t2);
          }
          maybeExportDefined(t2, r2) {
            this.parser.inModule && t2.flags & qe2 && this.undefinedExports.delete(r2);
          }
          checkRedeclarationInScope(t2, r2, e25, s2) {
            this.isRedeclaredInScope(t2, r2, e25) && this.parser.raise(u2.VarRedeclaration, { at: s2, identifierName: r2 });
          }
          isRedeclaredInScope(t2, r2, e25) {
            return e25 & Ae2 ? e25 & Ce2 ? t2.lexical.has(r2) || t2.functions.has(r2) || t2.var.has(r2) : e25 & mt2 ? t2.lexical.has(r2) || !this.treatFunctionsAsVarInScope(t2) && t2.var.has(r2) : t2.lexical.has(r2) && !(t2.flags & Sr && t2.lexical.values().next().value === r2) || !this.treatFunctionsAsVarInScope(t2) && t2.functions.has(r2) : false;
          }
          checkLocalExport(t2) {
            let { name: r2 } = t2, e25 = this.scopeStack[0];
            !e25.lexical.has(r2) && !e25.var.has(r2) && !e25.functions.has(r2) && this.undefinedExports.set(r2, t2.loc.start);
          }
          currentScope() {
            return this.scopeStack[this.scopeStack.length - 1];
          }
          currentVarScopeFlags() {
            for (let t2 = this.scopeStack.length - 1; ; t2--) {
              let { flags: r2 } = this.scopeStack[t2];
              if (r2 & dt2)
                return r2;
            }
          }
          currentThisScopeFlags() {
            for (let t2 = this.scopeStack.length - 1; ; t2--) {
              let { flags: r2 } = this.scopeStack[t2];
              if (r2 & (dt2 | Ne2) && !(r2 & ts2))
                return r2;
            }
          }
        }, vl2 = class extends us2 {
          constructor() {
            super(...arguments), this.declareFunctions = new Set();
          }
        }, El2 = class extends cs {
          createScope(t2) {
            return new vl2(t2);
          }
          declareName(t2, r2, e25) {
            let s2 = this.currentScope();
            if (r2 & as2) {
              this.checkRedeclarationInScope(s2, t2, r2, e25), this.maybeExportDefined(s2, t2), s2.declareFunctions.add(t2);
              return;
            }
            super.declareName(t2, r2, e25);
          }
          isRedeclaredInScope(t2, r2, e25) {
            return super.isRedeclaredInScope(t2, r2, e25) ? true : e25 & as2 ? !t2.declareFunctions.has(r2) && (t2.lexical.has(r2) || t2.functions.has(r2)) : false;
          }
          checkLocalExport(t2) {
            this.scopeStack[0].declareFunctions.has(t2.name) || super.checkLocalExport(t2);
          }
        }, Cl2 = class {
          constructor() {
            this.sawUnambiguousESM = false, this.ambiguousScriptDifferentAst = false;
          }
          hasPlugin(t2) {
            if (typeof t2 == "string")
              return this.plugins.has(t2);
            {
              let [r2, e25] = t2;
              if (!this.hasPlugin(r2))
                return false;
              let s2 = this.plugins.get(r2);
              for (let i2 of Object.keys(e25))
                if ((s2 == null ? void 0 : s2[i2]) !== e25[i2])
                  return false;
              return true;
            }
          }
          getPluginOption(t2, r2) {
            var e25;
            return (e25 = this.plugins.get(t2)) == null ? void 0 : e25[r2];
          }
        };
        function Br2(t2, r2) {
          t2.trailingComments === void 0 ? t2.trailingComments = r2 : t2.trailingComments.unshift(...r2);
        }
        function bl2(t2, r2) {
          t2.leadingComments === void 0 ? t2.leadingComments = r2 : t2.leadingComments.unshift(...r2);
        }
        function Qe2(t2, r2) {
          t2.innerComments === void 0 ? t2.innerComments = r2 : t2.innerComments.unshift(...r2);
        }
        function Ze2(t2, r2, e25) {
          let s2 = null, i2 = r2.length;
          for (; s2 === null && i2 > 0; )
            s2 = r2[--i2];
          s2 === null || s2.start > e25.start ? Qe2(t2, e25.comments) : Br2(s2, e25.comments);
        }
        var Sl2 = class extends Cl2 {
          addComment(t2) {
            this.filename && (t2.loc.filename = this.filename), this.state.comments.push(t2);
          }
          processComment(t2) {
            let { commentStack: r2 } = this.state, e25 = r2.length;
            if (e25 === 0)
              return;
            let s2 = e25 - 1, i2 = r2[s2];
            i2.start === t2.end && (i2.leadingNode = t2, s2--);
            let { start: a2 } = t2;
            for (; s2 >= 0; s2--) {
              let n2 = r2[s2], o2 = n2.end;
              if (o2 > a2)
                n2.containingNode = t2, this.finalizeComment(n2), r2.splice(s2, 1);
              else {
                o2 === a2 && (n2.trailingNode = t2);
                break;
              }
            }
          }
          finalizeComment(t2) {
            let { comments: r2 } = t2;
            if (t2.leadingNode !== null || t2.trailingNode !== null)
              t2.leadingNode !== null && Br2(t2.leadingNode, r2), t2.trailingNode !== null && bl2(t2.trailingNode, r2);
            else {
              let { containingNode: e25, start: s2 } = t2;
              if (this.input.charCodeAt(s2 - 1) === 44)
                switch (e25.type) {
                  case "ObjectExpression":
                  case "ObjectPattern":
                  case "RecordExpression":
                    Ze2(e25, e25.properties, t2);
                    break;
                  case "CallExpression":
                  case "OptionalCallExpression":
                    Ze2(e25, e25.arguments, t2);
                    break;
                  case "FunctionDeclaration":
                  case "FunctionExpression":
                  case "ArrowFunctionExpression":
                  case "ObjectMethod":
                  case "ClassMethod":
                  case "ClassPrivateMethod":
                    Ze2(e25, e25.params, t2);
                    break;
                  case "ArrayExpression":
                  case "ArrayPattern":
                  case "TupleExpression":
                    Ze2(e25, e25.elements, t2);
                    break;
                  case "ExportNamedDeclaration":
                  case "ImportDeclaration":
                    Ze2(e25, e25.specifiers, t2);
                    break;
                  default:
                    Qe2(e25, r2);
                }
              else
                Qe2(e25, r2);
            }
          }
          finalizeRemainingComments() {
            let { commentStack: t2 } = this.state;
            for (let r2 = t2.length - 1; r2 >= 0; r2--)
              this.finalizeComment(t2[r2]);
            this.state.commentStack = [];
          }
          resetPreviousNodeTrailingComments(t2) {
            let { commentStack: r2 } = this.state, { length: e25 } = r2;
            if (e25 === 0)
              return;
            let s2 = r2[e25 - 1];
            s2.leadingNode === t2 && (s2.leadingNode = null);
          }
          takeSurroundingComments(t2, r2, e25) {
            let { commentStack: s2 } = this.state, i2 = s2.length;
            if (i2 === 0)
              return;
            let a2 = i2 - 1;
            for (; a2 >= 0; a2--) {
              let n2 = s2[a2], o2 = n2.end;
              if (n2.start === e25)
                n2.leadingNode = t2;
              else if (o2 === r2)
                n2.trailingNode = t2;
              else if (o2 < r2)
                break;
            }
          }
        }, ps = /\r\n?|[\n\u2028\u2029]/, Pt2 = new RegExp(ps.source, "g");
        function et2(t2) {
          switch (t2) {
            case 10:
            case 13:
            case 8232:
            case 8233:
              return true;
            default:
              return false;
          }
        }
        var fs = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, wl2 = /(?:[^\S\n\r\u2028\u2029]|\/\/.*|\/\*.*?\*\/)*/y, Mr2 = new RegExp("(?=(" + wl2.source + "))\\1" + /(?=[\n\r\u2028\u2029]|\/\*(?!.*?\*\/)|$)/.source, "y");
        function Il2(t2) {
          switch (t2) {
            case 9:
            case 11:
            case 12:
            case 32:
            case 160:
            case 5760:
            case 8192:
            case 8193:
            case 8194:
            case 8195:
            case 8196:
            case 8197:
            case 8198:
            case 8199:
            case 8200:
            case 8201:
            case 8202:
            case 8239:
            case 8287:
            case 12288:
            case 65279:
              return true;
            default:
              return false;
          }
        }
        var _r2 = class {
          constructor() {
            this.strict = void 0, this.curLine = void 0, this.lineStart = void 0, this.startLoc = void 0, this.endLoc = void 0, this.errors = [], this.potentialArrowAt = -1, this.noArrowAt = [], this.noArrowParamsConversionAt = [], this.maybeInArrowParameters = false, this.inType = false, this.noAnonFunctionType = false, this.hasFlowComment = false, this.isAmbientContext = false, this.inAbstractClass = false, this.inDisallowConditionalTypesContext = false, this.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null }, this.soloAwait = false, this.inFSharpPipelineDirectBody = false, this.labels = [], this.comments = [], this.commentStack = [], this.pos = 0, this.type = 137, this.value = null, this.start = 0, this.end = 0, this.lastTokEndLoc = null, this.lastTokStartLoc = null, this.lastTokStart = 0, this.context = [$2.brace], this.canStartJSXElement = true, this.containsEsc = false, this.firstInvalidTemplateEscapePos = null, this.strictErrors = new Map(), this.tokensLength = 0;
          }
          init(t2) {
            let { strictMode: r2, sourceType: e25, startLine: s2, startColumn: i2 } = t2;
            this.strict = r2 === false ? false : r2 === true ? true : e25 === "module", this.curLine = s2, this.lineStart = -i2, this.startLoc = this.endLoc = new f2(s2, i2, 0);
          }
          curPosition() {
            return new f2(this.curLine, this.pos - this.lineStart, this.pos);
          }
          clone(t2) {
            let r2 = new _r2(), e25 = Object.keys(this);
            for (let s2 = 0, i2 = e25.length; s2 < i2; s2++) {
              let a2 = e25[s2], n2 = this[a2];
              !t2 && Array.isArray(n2) && (n2 = n2.slice()), r2[a2] = n2;
            }
            return r2;
          }
        }, Nl2 = function(r2) {
          return r2 >= 48 && r2 <= 57;
        }, Rr2 = { decBinOct: new Set([46, 66, 69, 79, 95, 98, 101, 111]), hex: new Set([46, 88, 95, 120]) }, At2 = { bin: (t2) => t2 === 48 || t2 === 49, oct: (t2) => t2 >= 48 && t2 <= 55, dec: (t2) => t2 >= 48 && t2 <= 57, hex: (t2) => t2 >= 48 && t2 <= 57 || t2 >= 65 && t2 <= 70 || t2 >= 97 && t2 <= 102 };
        function jr2(t2, r2, e25, s2, i2, a2) {
          let n2 = e25, o2 = s2, c2 = i2, p2 = "", m2 = null, x2 = e25, { length: A2 } = r2;
          for (; ; ) {
            if (e25 >= A2) {
              a2.unterminated(n2, o2, c2), p2 += r2.slice(x2, e25);
              break;
            }
            let b2 = r2.charCodeAt(e25);
            if (kl2(t2, b2, r2, e25)) {
              p2 += r2.slice(x2, e25);
              break;
            }
            if (b2 === 92) {
              p2 += r2.slice(x2, e25);
              let O2 = Dl2(r2, e25, s2, i2, t2 === "template", a2);
              O2.ch === null && !m2 ? m2 = { pos: e25, lineStart: s2, curLine: i2 } : p2 += O2.ch, { pos: e25, lineStart: s2, curLine: i2 } = O2, x2 = e25;
            } else
              b2 === 8232 || b2 === 8233 ? (++e25, ++i2, s2 = e25) : b2 === 10 || b2 === 13 ? t2 === "template" ? (p2 += r2.slice(x2, e25) + `
`, ++e25, b2 === 13 && r2.charCodeAt(e25) === 10 && ++e25, ++i2, x2 = s2 = e25) : a2.unterminated(n2, o2, c2) : ++e25;
          }
          return { pos: e25, str: p2, firstInvalidLoc: m2, lineStart: s2, curLine: i2, containsInvalid: !!m2 };
        }
        function kl2(t2, r2, e25, s2) {
          return t2 === "template" ? r2 === 96 || r2 === 36 && e25.charCodeAt(s2 + 1) === 123 : r2 === (t2 === "double" ? 34 : 39);
        }
        function Dl2(t2, r2, e25, s2, i2, a2) {
          let n2 = !i2;
          r2++;
          let o2 = (p2) => ({ pos: r2, ch: p2, lineStart: e25, curLine: s2 }), c2 = t2.charCodeAt(r2++);
          switch (c2) {
            case 110:
              return o2(`
`);
            case 114:
              return o2("\r");
            case 120: {
              let p2;
              return { code: p2, pos: r2 } = ds(t2, r2, e25, s2, 2, false, n2, a2), o2(p2 === null ? null : String.fromCharCode(p2));
            }
            case 117: {
              let p2;
              return { code: p2, pos: r2 } = Ur2(t2, r2, e25, s2, n2, a2), o2(p2 === null ? null : String.fromCodePoint(p2));
            }
            case 116:
              return o2("	");
            case 98:
              return o2("\b");
            case 118:
              return o2("\v");
            case 102:
              return o2("\f");
            case 13:
              t2.charCodeAt(r2) === 10 && ++r2;
            case 10:
              e25 = r2, ++s2;
            case 8232:
            case 8233:
              return o2("");
            case 56:
            case 57:
              if (i2)
                return o2(null);
              a2.strictNumericEscape(r2 - 1, e25, s2);
            default:
              if (c2 >= 48 && c2 <= 55) {
                let p2 = r2 - 1, x2 = t2.slice(p2, r2 + 2).match(/^[0-7]+/)[0], A2 = parseInt(x2, 8);
                A2 > 255 && (x2 = x2.slice(0, -1), A2 = parseInt(x2, 8)), r2 += x2.length - 1;
                let b2 = t2.charCodeAt(r2);
                if (x2 !== "0" || b2 === 56 || b2 === 57) {
                  if (i2)
                    return o2(null);
                  a2.strictNumericEscape(p2, e25, s2);
                }
                return o2(String.fromCharCode(A2));
              }
              return o2(String.fromCharCode(c2));
          }
        }
        function ds(t2, r2, e25, s2, i2, a2, n2, o2) {
          let c2 = r2, p2;
          return { n: p2, pos: r2 } = qr2(t2, r2, e25, s2, 16, i2, a2, false, o2, !n2), p2 === null && (n2 ? o2.invalidEscapeSequence(c2, e25, s2) : r2 = c2 - 1), { code: p2, pos: r2 };
        }
        function qr2(t2, r2, e25, s2, i2, a2, n2, o2, c2, p2) {
          let m2 = r2, x2 = i2 === 16 ? Rr2.hex : Rr2.decBinOct, A2 = i2 === 16 ? At2.hex : i2 === 10 ? At2.dec : i2 === 8 ? At2.oct : At2.bin, b2 = false, O2 = 0;
          for (let R2 = 0, Y2 = a2 == null ? 1 / 0 : a2; R2 < Y2; ++R2) {
            let Q2 = t2.charCodeAt(r2), J2;
            if (Q2 === 95 && o2 !== "bail") {
              let se2 = t2.charCodeAt(r2 - 1), Ve2 = t2.charCodeAt(r2 + 1);
              if (o2) {
                if (Number.isNaN(Ve2) || !A2(Ve2) || x2.has(se2) || x2.has(Ve2)) {
                  if (p2)
                    return { n: null, pos: r2 };
                  c2.unexpectedNumericSeparator(r2, e25, s2);
                }
              } else {
                if (p2)
                  return { n: null, pos: r2 };
                c2.numericSeparatorInEscapeSequence(r2, e25, s2);
              }
              ++r2;
              continue;
            }
            if (Q2 >= 97 ? J2 = Q2 - 97 + 10 : Q2 >= 65 ? J2 = Q2 - 65 + 10 : Nl2(Q2) ? J2 = Q2 - 48 : J2 = 1 / 0, J2 >= i2) {
              if (J2 <= 9 && p2)
                return { n: null, pos: r2 };
              if (J2 <= 9 && c2.invalidDigit(r2, e25, s2, i2))
                J2 = 0;
              else if (n2)
                J2 = 0, b2 = true;
              else
                break;
            }
            ++r2, O2 = O2 * i2 + J2;
          }
          return r2 === m2 || a2 != null && r2 - m2 !== a2 || b2 ? { n: null, pos: r2 } : { n: O2, pos: r2 };
        }
        function Ur2(t2, r2, e25, s2, i2, a2) {
          let n2 = t2.charCodeAt(r2), o2;
          if (n2 === 123) {
            if (++r2, { code: o2, pos: r2 } = ds(t2, r2, e25, s2, t2.indexOf("}", r2) - r2, true, i2, a2), ++r2, o2 !== null && o2 > 1114111)
              if (i2)
                a2.invalidCodePoint(r2, e25, s2);
              else
                return { code: null, pos: r2 };
          } else
            ({ code: o2, pos: r2 } = ds(t2, r2, e25, s2, 4, false, i2, a2));
          return { code: o2, pos: r2 };
        }
        var Fl2 = ["at"], Ll2 = ["at"];
        function tt2(t2, r2, e25) {
          return new f2(e25, t2 - r2, t2);
        }
        var Ol2 = new Set([103, 109, 115, 105, 121, 117, 100, 118]), Se2 = class {
          constructor(t2) {
            this.type = t2.type, this.value = t2.value, this.start = t2.start, this.end = t2.end, this.loc = new d2(t2.startLoc, t2.endLoc);
          }
        }, Bl2 = class extends Sl2 {
          constructor(t2, r2) {
            super(), this.isLookahead = void 0, this.tokens = [], this.errorHandlers_readInt = { invalidDigit: (e25, s2, i2, a2) => this.options.errorRecovery ? (this.raise(u2.InvalidDigit, { at: tt2(e25, s2, i2), radix: a2 }), true) : false, numericSeparatorInEscapeSequence: this.errorBuilder(u2.NumericSeparatorInEscapeSequence), unexpectedNumericSeparator: this.errorBuilder(u2.UnexpectedNumericSeparator) }, this.errorHandlers_readCodePoint = Object.assign({}, this.errorHandlers_readInt, { invalidEscapeSequence: this.errorBuilder(u2.InvalidEscapeSequence), invalidCodePoint: this.errorBuilder(u2.InvalidCodePoint) }), this.errorHandlers_readStringContents_string = Object.assign({}, this.errorHandlers_readCodePoint, { strictNumericEscape: (e25, s2, i2) => {
              this.recordStrictModeErrors(u2.StrictNumericEscape, { at: tt2(e25, s2, i2) });
            }, unterminated: (e25, s2, i2) => {
              throw this.raise(u2.UnterminatedString, { at: tt2(e25 - 1, s2, i2) });
            } }), this.errorHandlers_readStringContents_template = Object.assign({}, this.errorHandlers_readCodePoint, { strictNumericEscape: this.errorBuilder(u2.StrictNumericEscape), unterminated: (e25, s2, i2) => {
              throw this.raise(u2.UnterminatedTemplate, { at: tt2(e25, s2, i2) });
            } }), this.state = new _r2(), this.state.init(t2), this.input = r2, this.length = r2.length, this.isLookahead = false;
          }
          pushToken(t2) {
            this.tokens.length = this.state.tokensLength, this.tokens.push(t2), ++this.state.tokensLength;
          }
          next() {
            this.checkKeywordEscapes(), this.options.tokens && this.pushToken(new Se2(this.state)), this.state.lastTokStart = this.state.start, this.state.lastTokEndLoc = this.state.endLoc, this.state.lastTokStartLoc = this.state.startLoc, this.nextToken();
          }
          eat(t2) {
            return this.match(t2) ? (this.next(), true) : false;
          }
          match(t2) {
            return this.state.type === t2;
          }
          createLookaheadState(t2) {
            return { pos: t2.pos, value: null, type: t2.type, start: t2.start, end: t2.end, context: [this.curContext()], inType: t2.inType, startLoc: t2.startLoc, lastTokEndLoc: t2.lastTokEndLoc, curLine: t2.curLine, lineStart: t2.lineStart, curPosition: t2.curPosition };
          }
          lookahead() {
            let t2 = this.state;
            this.state = this.createLookaheadState(t2), this.isLookahead = true, this.nextToken(), this.isLookahead = false;
            let r2 = this.state;
            return this.state = t2, r2;
          }
          nextTokenStart() {
            return this.nextTokenStartSince(this.state.pos);
          }
          nextTokenStartSince(t2) {
            return fs.lastIndex = t2, fs.test(this.input) ? fs.lastIndex : t2;
          }
          lookaheadCharCode() {
            return this.input.charCodeAt(this.nextTokenStart());
          }
          codePointAtPos(t2) {
            let r2 = this.input.charCodeAt(t2);
            if ((r2 & 64512) === 55296 && ++t2 < this.input.length) {
              let e25 = this.input.charCodeAt(t2);
              (e25 & 64512) === 56320 && (r2 = 65536 + ((r2 & 1023) << 10) + (e25 & 1023));
            }
            return r2;
          }
          setStrict(t2) {
            this.state.strict = t2, t2 && (this.state.strictErrors.forEach((r2) => {
              let [e25, s2] = r2;
              return this.raise(e25, { at: s2 });
            }), this.state.strictErrors.clear());
          }
          curContext() {
            return this.state.context[this.state.context.length - 1];
          }
          nextToken() {
            if (this.skipSpace(), this.state.start = this.state.pos, this.isLookahead || (this.state.startLoc = this.state.curPosition()), this.state.pos >= this.length) {
              this.finishToken(137);
              return;
            }
            this.getTokenFromCode(this.codePointAtPos(this.state.pos));
          }
          skipBlockComment(t2) {
            let r2;
            this.isLookahead || (r2 = this.state.curPosition());
            let e25 = this.state.pos, s2 = this.input.indexOf(t2, e25 + 2);
            if (s2 === -1)
              throw this.raise(u2.UnterminatedComment, { at: this.state.curPosition() });
            for (this.state.pos = s2 + t2.length, Pt2.lastIndex = e25 + 2; Pt2.test(this.input) && Pt2.lastIndex <= s2; )
              ++this.state.curLine, this.state.lineStart = Pt2.lastIndex;
            if (this.isLookahead)
              return;
            let i2 = { type: "CommentBlock", value: this.input.slice(e25 + 2, s2), start: e25, end: s2 + t2.length, loc: new d2(r2, this.state.curPosition()) };
            return this.options.tokens && this.pushToken(i2), i2;
          }
          skipLineComment(t2) {
            let r2 = this.state.pos, e25;
            this.isLookahead || (e25 = this.state.curPosition());
            let s2 = this.input.charCodeAt(this.state.pos += t2);
            if (this.state.pos < this.length)
              for (; !et2(s2) && ++this.state.pos < this.length; )
                s2 = this.input.charCodeAt(this.state.pos);
            if (this.isLookahead)
              return;
            let i2 = this.state.pos, n2 = { type: "CommentLine", value: this.input.slice(r2 + t2, i2), start: r2, end: i2, loc: new d2(e25, this.state.curPosition()) };
            return this.options.tokens && this.pushToken(n2), n2;
          }
          skipSpace() {
            let t2 = this.state.pos, r2 = [];
            e:
              for (; this.state.pos < this.length; ) {
                let e25 = this.input.charCodeAt(this.state.pos);
                switch (e25) {
                  case 32:
                  case 160:
                  case 9:
                    ++this.state.pos;
                    break;
                  case 13:
                    this.input.charCodeAt(this.state.pos + 1) === 10 && ++this.state.pos;
                  case 10:
                  case 8232:
                  case 8233:
                    ++this.state.pos, ++this.state.curLine, this.state.lineStart = this.state.pos;
                    break;
                  case 47:
                    switch (this.input.charCodeAt(this.state.pos + 1)) {
                      case 42: {
                        let s2 = this.skipBlockComment("*/");
                        s2 !== void 0 && (this.addComment(s2), this.options.attachComment && r2.push(s2));
                        break;
                      }
                      case 47: {
                        let s2 = this.skipLineComment(2);
                        s2 !== void 0 && (this.addComment(s2), this.options.attachComment && r2.push(s2));
                        break;
                      }
                      default:
                        break e;
                    }
                    break;
                  default:
                    if (Il2(e25))
                      ++this.state.pos;
                    else if (e25 === 45 && !this.inModule) {
                      let s2 = this.state.pos;
                      if (this.input.charCodeAt(s2 + 1) === 45 && this.input.charCodeAt(s2 + 2) === 62 && (t2 === 0 || this.state.lineStart > t2)) {
                        let i2 = this.skipLineComment(3);
                        i2 !== void 0 && (this.addComment(i2), this.options.attachComment && r2.push(i2));
                      } else
                        break e;
                    } else if (e25 === 60 && !this.inModule) {
                      let s2 = this.state.pos;
                      if (this.input.charCodeAt(s2 + 1) === 33 && this.input.charCodeAt(s2 + 2) === 45 && this.input.charCodeAt(s2 + 3) === 45) {
                        let i2 = this.skipLineComment(4);
                        i2 !== void 0 && (this.addComment(i2), this.options.attachComment && r2.push(i2));
                      } else
                        break e;
                    } else
                      break e;
                }
              }
            if (r2.length > 0) {
              let e25 = this.state.pos, s2 = { start: t2, end: e25, comments: r2, leadingNode: null, trailingNode: null, containingNode: null };
              this.state.commentStack.push(s2);
            }
          }
          finishToken(t2, r2) {
            this.state.end = this.state.pos, this.state.endLoc = this.state.curPosition();
            let e25 = this.state.type;
            this.state.type = t2, this.state.value = r2, this.isLookahead || this.updateContext(e25);
          }
          replaceToken(t2) {
            this.state.type = t2, this.updateContext();
          }
          readToken_numberSign() {
            if (this.state.pos === 0 && this.readToken_interpreter())
              return;
            let t2 = this.state.pos + 1, r2 = this.codePointAtPos(t2);
            if (r2 >= 48 && r2 <= 57)
              throw this.raise(u2.UnexpectedDigitAfterHash, { at: this.state.curPosition() });
            if (r2 === 123 || r2 === 91 && this.hasPlugin("recordAndTuple")) {
              if (this.expectPlugin("recordAndTuple"), this.getPluginOption("recordAndTuple", "syntaxType") === "bar")
                throw this.raise(r2 === 123 ? u2.RecordExpressionHashIncorrectStartSyntaxType : u2.TupleExpressionHashIncorrectStartSyntaxType, { at: this.state.curPosition() });
              this.state.pos += 2, r2 === 123 ? this.finishToken(7) : this.finishToken(1);
            } else
              ge2(r2) ? (++this.state.pos, this.finishToken(136, this.readWord1(r2))) : r2 === 92 ? (++this.state.pos, this.finishToken(136, this.readWord1())) : this.finishOp(27, 1);
          }
          readToken_dot() {
            let t2 = this.input.charCodeAt(this.state.pos + 1);
            if (t2 >= 48 && t2 <= 57) {
              this.readNumber(true);
              return;
            }
            t2 === 46 && this.input.charCodeAt(this.state.pos + 2) === 46 ? (this.state.pos += 3, this.finishToken(21)) : (++this.state.pos, this.finishToken(16));
          }
          readToken_slash() {
            this.input.charCodeAt(this.state.pos + 1) === 61 ? this.finishOp(31, 2) : this.finishOp(56, 1);
          }
          readToken_interpreter() {
            if (this.state.pos !== 0 || this.length < 2)
              return false;
            let t2 = this.input.charCodeAt(this.state.pos + 1);
            if (t2 !== 33)
              return false;
            let r2 = this.state.pos;
            for (this.state.pos += 1; !et2(t2) && ++this.state.pos < this.length; )
              t2 = this.input.charCodeAt(this.state.pos);
            let e25 = this.input.slice(r2 + 2, this.state.pos);
            return this.finishToken(28, e25), true;
          }
          readToken_mult_modulo(t2) {
            let r2 = t2 === 42 ? 55 : 54, e25 = 1, s2 = this.input.charCodeAt(this.state.pos + 1);
            t2 === 42 && s2 === 42 && (e25++, s2 = this.input.charCodeAt(this.state.pos + 2), r2 = 57), s2 === 61 && !this.state.inType && (e25++, r2 = t2 === 37 ? 33 : 30), this.finishOp(r2, e25);
          }
          readToken_pipe_amp(t2) {
            let r2 = this.input.charCodeAt(this.state.pos + 1);
            if (r2 === t2) {
              this.input.charCodeAt(this.state.pos + 2) === 61 ? this.finishOp(30, 3) : this.finishOp(t2 === 124 ? 41 : 42, 2);
              return;
            }
            if (t2 === 124) {
              if (r2 === 62) {
                this.finishOp(39, 2);
                return;
              }
              if (this.hasPlugin("recordAndTuple") && r2 === 125) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                  throw this.raise(u2.RecordExpressionBarIncorrectEndSyntaxType, { at: this.state.curPosition() });
                this.state.pos += 2, this.finishToken(9);
                return;
              }
              if (this.hasPlugin("recordAndTuple") && r2 === 93) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                  throw this.raise(u2.TupleExpressionBarIncorrectEndSyntaxType, { at: this.state.curPosition() });
                this.state.pos += 2, this.finishToken(4);
                return;
              }
            }
            if (r2 === 61) {
              this.finishOp(30, 2);
              return;
            }
            this.finishOp(t2 === 124 ? 43 : 45, 1);
          }
          readToken_caret() {
            let t2 = this.input.charCodeAt(this.state.pos + 1);
            if (t2 === 61 && !this.state.inType)
              this.finishOp(32, 2);
            else if (t2 === 94 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "^^" }])) {
              if (this.finishOp(37, 2), this.input.codePointAt(this.state.pos) === 94)
                throw this.unexpected();
            } else
              this.finishOp(44, 1);
          }
          readToken_atSign() {
            this.input.charCodeAt(this.state.pos + 1) === 64 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "@@" }]) ? this.finishOp(38, 2) : this.finishOp(26, 1);
          }
          readToken_plus_min(t2) {
            let r2 = this.input.charCodeAt(this.state.pos + 1);
            if (r2 === t2) {
              this.finishOp(34, 2);
              return;
            }
            r2 === 61 ? this.finishOp(30, 2) : this.finishOp(53, 1);
          }
          readToken_lt() {
            let { pos: t2 } = this.state, r2 = this.input.charCodeAt(t2 + 1);
            if (r2 === 60) {
              if (this.input.charCodeAt(t2 + 2) === 61) {
                this.finishOp(30, 3);
                return;
              }
              this.finishOp(51, 2);
              return;
            }
            if (r2 === 61) {
              this.finishOp(49, 2);
              return;
            }
            this.finishOp(47, 1);
          }
          readToken_gt() {
            let { pos: t2 } = this.state, r2 = this.input.charCodeAt(t2 + 1);
            if (r2 === 62) {
              let e25 = this.input.charCodeAt(t2 + 2) === 62 ? 3 : 2;
              if (this.input.charCodeAt(t2 + e25) === 61) {
                this.finishOp(30, e25 + 1);
                return;
              }
              this.finishOp(52, e25);
              return;
            }
            if (r2 === 61) {
              this.finishOp(49, 2);
              return;
            }
            this.finishOp(48, 1);
          }
          readToken_eq_excl(t2) {
            let r2 = this.input.charCodeAt(this.state.pos + 1);
            if (r2 === 61) {
              this.finishOp(46, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
              return;
            }
            if (t2 === 61 && r2 === 62) {
              this.state.pos += 2, this.finishToken(19);
              return;
            }
            this.finishOp(t2 === 61 ? 29 : 35, 1);
          }
          readToken_question() {
            let t2 = this.input.charCodeAt(this.state.pos + 1), r2 = this.input.charCodeAt(this.state.pos + 2);
            t2 === 63 ? r2 === 61 ? this.finishOp(30, 3) : this.finishOp(40, 2) : t2 === 46 && !(r2 >= 48 && r2 <= 57) ? (this.state.pos += 2, this.finishToken(18)) : (++this.state.pos, this.finishToken(17));
          }
          getTokenFromCode(t2) {
            switch (t2) {
              case 46:
                this.readToken_dot();
                return;
              case 40:
                ++this.state.pos, this.finishToken(10);
                return;
              case 41:
                ++this.state.pos, this.finishToken(11);
                return;
              case 59:
                ++this.state.pos, this.finishToken(13);
                return;
              case 44:
                ++this.state.pos, this.finishToken(12);
                return;
              case 91:
                if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                  if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                    throw this.raise(u2.TupleExpressionBarIncorrectStartSyntaxType, { at: this.state.curPosition() });
                  this.state.pos += 2, this.finishToken(2);
                } else
                  ++this.state.pos, this.finishToken(0);
                return;
              case 93:
                ++this.state.pos, this.finishToken(3);
                return;
              case 123:
                if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                  if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar")
                    throw this.raise(u2.RecordExpressionBarIncorrectStartSyntaxType, { at: this.state.curPosition() });
                  this.state.pos += 2, this.finishToken(6);
                } else
                  ++this.state.pos, this.finishToken(5);
                return;
              case 125:
                ++this.state.pos, this.finishToken(8);
                return;
              case 58:
                this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58 ? this.finishOp(15, 2) : (++this.state.pos, this.finishToken(14));
                return;
              case 63:
                this.readToken_question();
                return;
              case 96:
                this.readTemplateToken();
                return;
              case 48: {
                let r2 = this.input.charCodeAt(this.state.pos + 1);
                if (r2 === 120 || r2 === 88) {
                  this.readRadixNumber(16);
                  return;
                }
                if (r2 === 111 || r2 === 79) {
                  this.readRadixNumber(8);
                  return;
                }
                if (r2 === 98 || r2 === 66) {
                  this.readRadixNumber(2);
                  return;
                }
              }
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                this.readNumber(false);
                return;
              case 34:
              case 39:
                this.readString(t2);
                return;
              case 47:
                this.readToken_slash();
                return;
              case 37:
              case 42:
                this.readToken_mult_modulo(t2);
                return;
              case 124:
              case 38:
                this.readToken_pipe_amp(t2);
                return;
              case 94:
                this.readToken_caret();
                return;
              case 43:
              case 45:
                this.readToken_plus_min(t2);
                return;
              case 60:
                this.readToken_lt();
                return;
              case 62:
                this.readToken_gt();
                return;
              case 61:
              case 33:
                this.readToken_eq_excl(t2);
                return;
              case 126:
                this.finishOp(36, 1);
                return;
              case 64:
                this.readToken_atSign();
                return;
              case 35:
                this.readToken_numberSign();
                return;
              case 92:
                this.readWord();
                return;
              default:
                if (ge2(t2)) {
                  this.readWord(t2);
                  return;
                }
            }
            throw this.raise(u2.InvalidOrUnexpectedToken, { at: this.state.curPosition(), unexpected: String.fromCodePoint(t2) });
          }
          finishOp(t2, r2) {
            let e25 = this.input.slice(this.state.pos, this.state.pos + r2);
            this.state.pos += r2, this.finishToken(t2, e25);
          }
          readRegexp() {
            let t2 = this.state.startLoc, r2 = this.state.start + 1, e25, s2, { pos: i2 } = this.state;
            for (; ; ++i2) {
              if (i2 >= this.length)
                throw this.raise(u2.UnterminatedRegExp, { at: y2(t2, 1) });
              let c2 = this.input.charCodeAt(i2);
              if (et2(c2))
                throw this.raise(u2.UnterminatedRegExp, { at: y2(t2, 1) });
              if (e25)
                e25 = false;
              else {
                if (c2 === 91)
                  s2 = true;
                else if (c2 === 93 && s2)
                  s2 = false;
                else if (c2 === 47 && !s2)
                  break;
                e25 = c2 === 92;
              }
            }
            let a2 = this.input.slice(r2, i2);
            ++i2;
            let n2 = "", o2 = () => y2(t2, i2 + 2 - r2);
            for (; i2 < this.length; ) {
              let c2 = this.codePointAtPos(i2), p2 = String.fromCharCode(c2);
              if (Ol2.has(c2))
                c2 === 118 ? (this.expectPlugin("regexpUnicodeSets", o2()), n2.includes("u") && this.raise(u2.IncompatibleRegExpUVFlags, { at: o2() })) : c2 === 117 && n2.includes("v") && this.raise(u2.IncompatibleRegExpUVFlags, { at: o2() }), n2.includes(p2) && this.raise(u2.DuplicateRegExpFlags, { at: o2() });
              else if (Re2(c2) || c2 === 92)
                this.raise(u2.MalformedRegExpFlags, { at: o2() });
              else
                break;
              ++i2, n2 += p2;
            }
            this.state.pos = i2, this.finishToken(135, { pattern: a2, flags: n2 });
          }
          readInt(t2, r2) {
            let e25 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, s2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, { n: i2, pos: a2 } = qr2(this.input, this.state.pos, this.state.lineStart, this.state.curLine, t2, r2, e25, s2, this.errorHandlers_readInt, false);
            return this.state.pos = a2, i2;
          }
          readRadixNumber(t2) {
            let r2 = this.state.curPosition(), e25 = false;
            this.state.pos += 2;
            let s2 = this.readInt(t2);
            s2 == null && this.raise(u2.InvalidDigit, { at: y2(r2, 2), radix: t2 });
            let i2 = this.input.charCodeAt(this.state.pos);
            if (i2 === 110)
              ++this.state.pos, e25 = true;
            else if (i2 === 109)
              throw this.raise(u2.InvalidDecimal, { at: r2 });
            if (ge2(this.codePointAtPos(this.state.pos)))
              throw this.raise(u2.NumberIdentifier, { at: this.state.curPosition() });
            if (e25) {
              let a2 = this.input.slice(r2.index, this.state.pos).replace(/[_n]/g, "");
              this.finishToken(133, a2);
              return;
            }
            this.finishToken(132, s2);
          }
          readNumber(t2) {
            let r2 = this.state.pos, e25 = this.state.curPosition(), s2 = false, i2 = false, a2 = false, n2 = false, o2 = false;
            !t2 && this.readInt(10) === null && this.raise(u2.InvalidNumber, { at: this.state.curPosition() });
            let c2 = this.state.pos - r2 >= 2 && this.input.charCodeAt(r2) === 48;
            if (c2) {
              let A2 = this.input.slice(r2, this.state.pos);
              if (this.recordStrictModeErrors(u2.StrictOctalLiteral, { at: e25 }), !this.state.strict) {
                let b2 = A2.indexOf("_");
                b2 > 0 && this.raise(u2.ZeroDigitNumericSeparator, { at: y2(e25, b2) });
              }
              o2 = c2 && !/[89]/.test(A2);
            }
            let p2 = this.input.charCodeAt(this.state.pos);
            if (p2 === 46 && !o2 && (++this.state.pos, this.readInt(10), s2 = true, p2 = this.input.charCodeAt(this.state.pos)), (p2 === 69 || p2 === 101) && !o2 && (p2 = this.input.charCodeAt(++this.state.pos), (p2 === 43 || p2 === 45) && ++this.state.pos, this.readInt(10) === null && this.raise(u2.InvalidOrMissingExponent, { at: e25 }), s2 = true, n2 = true, p2 = this.input.charCodeAt(this.state.pos)), p2 === 110 && ((s2 || c2) && this.raise(u2.InvalidBigIntLiteral, { at: e25 }), ++this.state.pos, i2 = true), p2 === 109 && (this.expectPlugin("decimal", this.state.curPosition()), (n2 || c2) && this.raise(u2.InvalidDecimal, { at: e25 }), ++this.state.pos, a2 = true), ge2(this.codePointAtPos(this.state.pos)))
              throw this.raise(u2.NumberIdentifier, { at: this.state.curPosition() });
            let m2 = this.input.slice(r2, this.state.pos).replace(/[_mn]/g, "");
            if (i2) {
              this.finishToken(133, m2);
              return;
            }
            if (a2) {
              this.finishToken(134, m2);
              return;
            }
            let x2 = o2 ? parseInt(m2, 8) : parseFloat(m2);
            this.finishToken(132, x2);
          }
          readCodePoint(t2) {
            let { code: r2, pos: e25 } = Ur2(this.input, this.state.pos, this.state.lineStart, this.state.curLine, t2, this.errorHandlers_readCodePoint);
            return this.state.pos = e25, r2;
          }
          readString(t2) {
            let { str: r2, pos: e25, curLine: s2, lineStart: i2 } = jr2(t2 === 34 ? "double" : "single", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_string);
            this.state.pos = e25 + 1, this.state.lineStart = i2, this.state.curLine = s2, this.finishToken(131, r2);
          }
          readTemplateContinuation() {
            this.match(8) || this.unexpected(null, 8), this.state.pos--, this.readTemplateToken();
          }
          readTemplateToken() {
            let t2 = this.input[this.state.pos], { str: r2, firstInvalidLoc: e25, pos: s2, curLine: i2, lineStart: a2 } = jr2("template", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_template);
            this.state.pos = s2 + 1, this.state.lineStart = a2, this.state.curLine = i2, e25 && (this.state.firstInvalidTemplateEscapePos = new f2(e25.curLine, e25.pos - e25.lineStart, e25.pos)), this.input.codePointAt(s2) === 96 ? this.finishToken(24, e25 ? null : t2 + r2 + "`") : (this.state.pos++, this.finishToken(25, e25 ? null : t2 + r2 + "${"));
          }
          recordStrictModeErrors(t2, r2) {
            let { at: e25 } = r2, s2 = e25.index;
            this.state.strict && !this.state.strictErrors.has(s2) ? this.raise(t2, { at: e25 }) : this.state.strictErrors.set(s2, [t2, e25]);
          }
          readWord1(t2) {
            this.state.containsEsc = false;
            let r2 = "", e25 = this.state.pos, s2 = this.state.pos;
            for (t2 !== void 0 && (this.state.pos += t2 <= 65535 ? 1 : 2); this.state.pos < this.length; ) {
              let i2 = this.codePointAtPos(this.state.pos);
              if (Re2(i2))
                this.state.pos += i2 <= 65535 ? 1 : 2;
              else if (i2 === 92) {
                this.state.containsEsc = true, r2 += this.input.slice(s2, this.state.pos);
                let a2 = this.state.curPosition(), n2 = this.state.pos === e25 ? ge2 : Re2;
                if (this.input.charCodeAt(++this.state.pos) !== 117) {
                  this.raise(u2.MissingUnicodeEscape, { at: this.state.curPosition() }), s2 = this.state.pos - 1;
                  continue;
                }
                ++this.state.pos;
                let o2 = this.readCodePoint(true);
                o2 !== null && (n2(o2) || this.raise(u2.EscapedCharNotAnIdentifier, { at: a2 }), r2 += String.fromCodePoint(o2)), s2 = this.state.pos;
              } else
                break;
            }
            return r2 + this.input.slice(s2, this.state.pos);
          }
          readWord(t2) {
            let r2 = this.readWord1(t2), e25 = zt2.get(r2);
            e25 !== void 0 ? this.finishToken(e25, Ee2(e25)) : this.finishToken(130, r2);
          }
          checkKeywordEscapes() {
            let { type: t2 } = this.state;
            Yt2(t2) && this.state.containsEsc && this.raise(u2.InvalidEscapedReservedWord, { at: this.state.startLoc, reservedWord: Ee2(t2) });
          }
          raise(t2, r2) {
            let { at: e25 } = r2, s2 = h2(r2, Fl2), i2 = e25 instanceof f2 ? e25 : e25.loc.start, a2 = t2({ loc: i2, details: s2 });
            if (!this.options.errorRecovery)
              throw a2;
            return this.isLookahead || this.state.errors.push(a2), a2;
          }
          raiseOverwrite(t2, r2) {
            let { at: e25 } = r2, s2 = h2(r2, Ll2), i2 = e25 instanceof f2 ? e25 : e25.loc.start, a2 = i2.index, n2 = this.state.errors;
            for (let o2 = n2.length - 1; o2 >= 0; o2--) {
              let c2 = n2[o2];
              if (c2.loc.index === a2)
                return n2[o2] = t2({ loc: i2, details: s2 });
              if (c2.loc.index < a2)
                break;
            }
            return this.raise(t2, r2);
          }
          updateContext(t2) {
          }
          unexpected(t2, r2) {
            throw this.raise(u2.UnexpectedToken, { expected: r2 ? Ee2(r2) : null, at: t2 != null ? t2 : this.state.startLoc });
          }
          expectPlugin(t2, r2) {
            if (this.hasPlugin(t2))
              return true;
            throw this.raise(u2.MissingPlugin, { at: r2 != null ? r2 : this.state.startLoc, missingPlugin: [t2] });
          }
          expectOnePlugin(t2) {
            if (!t2.some((r2) => this.hasPlugin(r2)))
              throw this.raise(u2.MissingOneOfPlugins, { at: this.state.startLoc, missingPlugin: t2 });
          }
          errorBuilder(t2) {
            return (r2, e25, s2) => {
              this.raise(t2, { at: tt2(r2, e25, s2) });
            };
          }
        }, Ml2 = class {
          constructor() {
            this.privateNames = new Set(), this.loneAccessors = new Map(), this.undefinedPrivateNames = new Map();
          }
        }, _l2 = class {
          constructor(t2) {
            this.parser = void 0, this.stack = [], this.undefinedPrivateNames = new Map(), this.parser = t2;
          }
          current() {
            return this.stack[this.stack.length - 1];
          }
          enter() {
            this.stack.push(new Ml2());
          }
          exit() {
            let t2 = this.stack.pop(), r2 = this.current();
            for (let [e25, s2] of Array.from(t2.undefinedPrivateNames))
              r2 ? r2.undefinedPrivateNames.has(e25) || r2.undefinedPrivateNames.set(e25, s2) : this.parser.raise(u2.InvalidPrivateFieldResolution, { at: s2, identifierName: e25 });
          }
          declarePrivateName(t2, r2, e25) {
            let { privateNames: s2, loneAccessors: i2, undefinedPrivateNames: a2 } = this.current(), n2 = s2.has(t2);
            if (r2 & ls) {
              let o2 = n2 && i2.get(t2);
              if (o2) {
                let c2 = o2 & gt2, p2 = r2 & gt2, m2 = o2 & ls, x2 = r2 & ls;
                n2 = m2 === x2 || c2 !== p2, n2 || i2.delete(t2);
              } else
                n2 || i2.set(t2, r2);
            }
            n2 && this.parser.raise(u2.PrivateNameRedeclaration, { at: e25, identifierName: t2 }), s2.add(t2), a2.delete(t2);
          }
          usePrivateName(t2, r2) {
            let e25;
            for (e25 of this.stack)
              if (e25.privateNames.has(t2))
                return;
            e25 ? e25.undefinedPrivateNames.set(t2, r2) : this.parser.raise(u2.InvalidPrivateFieldResolution, { at: r2, identifierName: t2 });
          }
        }, Rl2 = 0, $r2 = 1, ms = 2, Hr2 = 3, Tt2 = class {
          constructor() {
            let t2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Rl2;
            this.type = void 0, this.type = t2;
          }
          canBeArrowParameterDeclaration() {
            return this.type === ms || this.type === $r2;
          }
          isCertainlyParameterDeclaration() {
            return this.type === Hr2;
          }
        }, zr2 = class extends Tt2 {
          constructor(t2) {
            super(t2), this.declarationErrors = new Map();
          }
          recordDeclarationError(t2, r2) {
            let { at: e25 } = r2, s2 = e25.index;
            this.declarationErrors.set(s2, [t2, e25]);
          }
          clearDeclarationError(t2) {
            this.declarationErrors.delete(t2);
          }
          iterateErrors(t2) {
            this.declarationErrors.forEach(t2);
          }
        }, jl2 = class {
          constructor(t2) {
            this.parser = void 0, this.stack = [new Tt2()], this.parser = t2;
          }
          enter(t2) {
            this.stack.push(t2);
          }
          exit() {
            this.stack.pop();
          }
          recordParameterInitializerError(t2, r2) {
            let { at: e25 } = r2, s2 = { at: e25.loc.start }, { stack: i2 } = this, a2 = i2.length - 1, n2 = i2[a2];
            for (; !n2.isCertainlyParameterDeclaration(); ) {
              if (n2.canBeArrowParameterDeclaration())
                n2.recordDeclarationError(t2, s2);
              else
                return;
              n2 = i2[--a2];
            }
            this.parser.raise(t2, s2);
          }
          recordArrowParameterBindingError(t2, r2) {
            let { at: e25 } = r2, { stack: s2 } = this, i2 = s2[s2.length - 1], a2 = { at: e25.loc.start };
            if (i2.isCertainlyParameterDeclaration())
              this.parser.raise(t2, a2);
            else if (i2.canBeArrowParameterDeclaration())
              i2.recordDeclarationError(t2, a2);
            else
              return;
          }
          recordAsyncArrowParametersError(t2) {
            let { at: r2 } = t2, { stack: e25 } = this, s2 = e25.length - 1, i2 = e25[s2];
            for (; i2.canBeArrowParameterDeclaration(); )
              i2.type === ms && i2.recordDeclarationError(u2.AwaitBindingIdentifier, { at: r2 }), i2 = e25[--s2];
          }
          validateAsPattern() {
            let { stack: t2 } = this, r2 = t2[t2.length - 1];
            r2.canBeArrowParameterDeclaration() && r2.iterateErrors((e25) => {
              let [s2, i2] = e25;
              this.parser.raise(s2, { at: i2 });
              let a2 = t2.length - 2, n2 = t2[a2];
              for (; n2.canBeArrowParameterDeclaration(); )
                n2.clearDeclarationError(i2.index), n2 = t2[--a2];
            });
          }
        };
        function ql2() {
          return new Tt2(Hr2);
        }
        function Ul2() {
          return new zr2($r2);
        }
        function $l2() {
          return new zr2(ms);
        }
        function Vr2() {
          return new Tt2();
        }
        var $e2 = 0, Kr2 = 1, vt = 2, Wr2 = 4, He2 = 8, Hl2 = class {
          constructor() {
            this.stacks = [];
          }
          enter(t2) {
            this.stacks.push(t2);
          }
          exit() {
            this.stacks.pop();
          }
          currentFlags() {
            return this.stacks[this.stacks.length - 1];
          }
          get hasAwait() {
            return (this.currentFlags() & vt) > 0;
          }
          get hasYield() {
            return (this.currentFlags() & Kr2) > 0;
          }
          get hasReturn() {
            return (this.currentFlags() & Wr2) > 0;
          }
          get hasIn() {
            return (this.currentFlags() & He2) > 0;
          }
        };
        function Et(t2, r2) {
          return (t2 ? vt : 0) | (r2 ? Kr2 : 0);
        }
        var zl2 = class extends Bl2 {
          addExtra(t2, r2, e25) {
            let s2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
            if (!t2)
              return;
            let i2 = t2.extra = t2.extra || {};
            s2 ? i2[r2] = e25 : Object.defineProperty(i2, r2, { enumerable: s2, value: e25 });
          }
          isContextual(t2) {
            return this.state.type === t2 && !this.state.containsEsc;
          }
          isUnparsedContextual(t2, r2) {
            let e25 = t2 + r2.length;
            if (this.input.slice(t2, e25) === r2) {
              let s2 = this.input.charCodeAt(e25);
              return !(Re2(s2) || (s2 & 64512) === 55296);
            }
            return false;
          }
          isLookaheadContextual(t2) {
            let r2 = this.nextTokenStart();
            return this.isUnparsedContextual(r2, t2);
          }
          eatContextual(t2) {
            return this.isContextual(t2) ? (this.next(), true) : false;
          }
          expectContextual(t2, r2) {
            if (!this.eatContextual(t2))
              throw r2 != null ? this.raise(r2, { at: this.state.startLoc }) : this.unexpected(null, t2);
          }
          canInsertSemicolon() {
            return this.match(137) || this.match(8) || this.hasPrecedingLineBreak();
          }
          hasPrecedingLineBreak() {
            return ps.test(this.input.slice(this.state.lastTokEndLoc.index, this.state.start));
          }
          hasFollowingLineBreak() {
            return Mr2.lastIndex = this.state.end, Mr2.test(this.input);
          }
          isLineTerminator() {
            return this.eat(13) || this.canInsertSemicolon();
          }
          semicolon() {
            ((arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true) ? this.isLineTerminator() : this.eat(13)) || this.raise(u2.MissingSemicolon, { at: this.state.lastTokEndLoc });
          }
          expect(t2, r2) {
            this.eat(t2) || this.unexpected(r2, t2);
          }
          tryParse(t2) {
            let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.clone(), e25 = { node: null };
            try {
              let s2 = t2(function() {
                let i2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                throw e25.node = i2, e25;
              });
              if (this.state.errors.length > r2.errors.length) {
                let i2 = this.state;
                return this.state = r2, this.state.tokensLength = i2.tokensLength, { node: s2, error: i2.errors[r2.errors.length], thrown: false, aborted: false, failState: i2 };
              }
              return { node: s2, error: null, thrown: false, aborted: false, failState: null };
            } catch (s2) {
              let i2 = this.state;
              if (this.state = r2, s2 instanceof SyntaxError)
                return { node: null, error: s2, thrown: true, aborted: false, failState: i2 };
              if (s2 === e25)
                return { node: e25.node, error: null, thrown: false, aborted: true, failState: i2 };
              throw s2;
            }
          }
          checkExpressionErrors(t2, r2) {
            if (!t2)
              return false;
            let { shorthandAssignLoc: e25, doubleProtoLoc: s2, privateKeyLoc: i2, optionalParametersLoc: a2 } = t2, n2 = !!e25 || !!s2 || !!a2 || !!i2;
            if (!r2)
              return n2;
            e25 != null && this.raise(u2.InvalidCoverInitializedName, { at: e25 }), s2 != null && this.raise(u2.DuplicateProto, { at: s2 }), i2 != null && this.raise(u2.UnexpectedPrivateField, { at: i2 }), a2 != null && this.unexpected(a2);
          }
          isLiteralPropertyName() {
            return gr2(this.state.type);
          }
          isPrivateName(t2) {
            return t2.type === "PrivateName";
          }
          getPrivateNameSV(t2) {
            return t2.id.name;
          }
          hasPropertyAsPrivateName(t2) {
            return (t2.type === "MemberExpression" || t2.type === "OptionalMemberExpression") && this.isPrivateName(t2.property);
          }
          isOptionalChain(t2) {
            return t2.type === "OptionalMemberExpression" || t2.type === "OptionalCallExpression";
          }
          isObjectProperty(t2) {
            return t2.type === "ObjectProperty";
          }
          isObjectMethod(t2) {
            return t2.type === "ObjectMethod";
          }
          initializeScopes() {
            let t2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.sourceType === "module", r2 = this.state.labels;
            this.state.labels = [];
            let e25 = this.exportedIdentifiers;
            this.exportedIdentifiers = new Set();
            let s2 = this.inModule;
            this.inModule = t2;
            let i2 = this.scope, a2 = this.getScopeHandler();
            this.scope = new a2(this, t2);
            let n2 = this.prodParam;
            this.prodParam = new Hl2();
            let o2 = this.classScope;
            this.classScope = new _l2(this);
            let c2 = this.expressionScope;
            return this.expressionScope = new jl2(this), () => {
              this.state.labels = r2, this.exportedIdentifiers = e25, this.inModule = s2, this.scope = i2, this.prodParam = n2, this.classScope = o2, this.expressionScope = c2;
            };
          }
          enterInitialScopes() {
            let t2 = $e2;
            this.inModule && (t2 |= vt), this.scope.enter(qe2), this.prodParam.enter(t2);
          }
          checkDestructuringPrivate(t2) {
            let { privateKeyLoc: r2 } = t2;
            r2 !== null && this.expectPlugin("destructuringPrivate", r2);
          }
        }, Ct2 = class {
          constructor() {
            this.shorthandAssignLoc = null, this.doubleProtoLoc = null, this.privateKeyLoc = null, this.optionalParametersLoc = null;
          }
        }, bt = class {
          constructor(t2, r2, e25) {
            this.type = "", this.start = r2, this.end = 0, this.loc = new d2(e25), t2 != null && t2.options.ranges && (this.range = [r2, 0]), t2 != null && t2.filename && (this.loc.filename = t2.filename);
          }
        }, ys = bt.prototype;
        ys.__clone = function() {
          let t2 = new bt(void 0, this.start, this.loc.start), r2 = Object.keys(this);
          for (let e25 = 0, s2 = r2.length; e25 < s2; e25++) {
            let i2 = r2[e25];
            i2 !== "leadingComments" && i2 !== "trailingComments" && i2 !== "innerComments" && (t2[i2] = this[i2]);
          }
          return t2;
        };
        function Vl2(t2) {
          return Te2(t2);
        }
        function Te2(t2) {
          let { type: r2, start: e25, end: s2, loc: i2, range: a2, extra: n2, name: o2 } = t2, c2 = Object.create(ys);
          return c2.type = r2, c2.start = e25, c2.end = s2, c2.loc = i2, c2.range = a2, c2.extra = n2, c2.name = o2, r2 === "Placeholder" && (c2.expectedNode = t2.expectedNode), c2;
        }
        function Kl2(t2) {
          let { type: r2, start: e25, end: s2, loc: i2, range: a2, extra: n2 } = t2;
          if (r2 === "Placeholder")
            return Vl2(t2);
          let o2 = Object.create(ys);
          return o2.type = r2, o2.start = e25, o2.end = s2, o2.loc = i2, o2.range = a2, t2.raw !== void 0 ? o2.raw = t2.raw : o2.extra = n2, o2.value = t2.value, o2;
        }
        var Wl2 = class extends zl2 {
          startNode() {
            return new bt(this, this.state.start, this.state.startLoc);
          }
          startNodeAt(t2) {
            return new bt(this, t2.index, t2);
          }
          startNodeAtNode(t2) {
            return this.startNodeAt(t2.loc.start);
          }
          finishNode(t2, r2) {
            return this.finishNodeAt(t2, r2, this.state.lastTokEndLoc);
          }
          finishNodeAt(t2, r2, e25) {
            return t2.type = r2, t2.end = e25.index, t2.loc.end = e25, this.options.ranges && (t2.range[1] = e25.index), this.options.attachComment && this.processComment(t2), t2;
          }
          resetStartLocation(t2, r2) {
            t2.start = r2.index, t2.loc.start = r2, this.options.ranges && (t2.range[0] = r2.index);
          }
          resetEndLocation(t2) {
            let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.state.lastTokEndLoc;
            t2.end = r2.index, t2.loc.end = r2, this.options.ranges && (t2.range[1] = r2.index);
          }
          resetStartLocationFromNode(t2, r2) {
            this.resetStartLocation(t2, r2.loc.start);
          }
        }, Gl2 = new Set(["_", "any", "bool", "boolean", "empty", "extends", "false", "interface", "mixed", "null", "number", "static", "string", "true", "typeof", "void"]), D2 = _2`flow`({ AmbiguousConditionalArrow: "Ambiguous expression: wrap the arrow functions in parentheses to disambiguate.", AmbiguousDeclareModuleKind: "Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module.", AssignReservedType: (t2) => {
          let { reservedType: r2 } = t2;
          return `Cannot overwrite reserved type ${r2}.`;
        }, DeclareClassElement: "The `declare` modifier can only appear on class fields.", DeclareClassFieldInitializer: "Initializers are not allowed in fields with the `declare` modifier.", DuplicateDeclareModuleExports: "Duplicate `declare module.exports` statement.", EnumBooleanMemberNotInitialized: (t2) => {
          let { memberName: r2, enumName: e25 } = t2;
          return `Boolean enum members need to be initialized. Use either \`${r2} = true,\` or \`${r2} = false,\` in enum \`${e25}\`.`;
        }, EnumDuplicateMemberName: (t2) => {
          let { memberName: r2, enumName: e25 } = t2;
          return `Enum member names need to be unique, but the name \`${r2}\` has already been used before in enum \`${e25}\`.`;
        }, EnumInconsistentMemberValues: (t2) => {
          let { enumName: r2 } = t2;
          return `Enum \`${r2}\` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.`;
        }, EnumInvalidExplicitType: (t2) => {
          let { invalidEnumType: r2, enumName: e25 } = t2;
          return `Enum type \`${r2}\` is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${e25}\`.`;
        }, EnumInvalidExplicitTypeUnknownSupplied: (t2) => {
          let { enumName: r2 } = t2;
          return `Supplied enum type is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${r2}\`.`;
        }, EnumInvalidMemberInitializerPrimaryType: (t2) => {
          let { enumName: r2, memberName: e25, explicitType: s2 } = t2;
          return `Enum \`${r2}\` has type \`${s2}\`, so the initializer of \`${e25}\` needs to be a ${s2} literal.`;
        }, EnumInvalidMemberInitializerSymbolType: (t2) => {
          let { enumName: r2, memberName: e25 } = t2;
          return `Symbol enum members cannot be initialized. Use \`${e25},\` in enum \`${r2}\`.`;
        }, EnumInvalidMemberInitializerUnknownType: (t2) => {
          let { enumName: r2, memberName: e25 } = t2;
          return `The enum member initializer for \`${e25}\` needs to be a literal (either a boolean, number, or string) in enum \`${r2}\`.`;
        }, EnumInvalidMemberName: (t2) => {
          let { enumName: r2, memberName: e25, suggestion: s2 } = t2;
          return `Enum member names cannot start with lowercase 'a' through 'z'. Instead of using \`${e25}\`, consider using \`${s2}\`, in enum \`${r2}\`.`;
        }, EnumNumberMemberNotInitialized: (t2) => {
          let { enumName: r2, memberName: e25 } = t2;
          return `Number enum members need to be initialized, e.g. \`${e25} = 1\` in enum \`${r2}\`.`;
        }, EnumStringMemberInconsistentlyInitailized: (t2) => {
          let { enumName: r2 } = t2;
          return `String enum members need to consistently either all use initializers, or use no initializers, in enum \`${r2}\`.`;
        }, GetterMayNotHaveThisParam: "A getter cannot have a `this` parameter.", ImportReflectionHasImportType: "An `import module` declaration can not use `type` or `typeof` keyword.", ImportTypeShorthandOnlyInPureImport: "The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements.", InexactInsideExact: "Explicit inexact syntax cannot appear inside an explicit exact object type.", InexactInsideNonObject: "Explicit inexact syntax cannot appear in class or interface definitions.", InexactVariance: "Explicit inexact syntax cannot have variance.", InvalidNonTypeImportInDeclareModule: "Imports within a `declare module` body must always be `import type` or `import typeof`.", MissingTypeParamDefault: "Type parameter declaration needs a default, since a preceding type parameter declaration has a default.", NestedDeclareModule: "`declare module` cannot be used inside another `declare module`.", NestedFlowComment: "Cannot have a flow comment inside another flow comment.", PatternIsOptional: Object.assign({ message: "A binding pattern parameter cannot be optional in an implementation signature." }, { reasonCode: "OptionalBindingPattern" }), SetterMayNotHaveThisParam: "A setter cannot have a `this` parameter.", SpreadVariance: "Spread properties cannot have variance.", ThisParamAnnotationRequired: "A type annotation is required for the `this` parameter.", ThisParamBannedInConstructor: "Constructors cannot have a `this` parameter; constructors don't bind `this` like other functions.", ThisParamMayNotBeOptional: "The `this` parameter cannot be optional.", ThisParamMustBeFirst: "The `this` parameter must be the first function parameter.", ThisParamNoDefault: "The `this` parameter may not have a default value.", TypeBeforeInitializer: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.", TypeCastInPattern: "The type cast expression is expected to be wrapped with parenthesis.", UnexpectedExplicitInexactInObject: "Explicit inexact syntax must appear at the end of an inexact object.", UnexpectedReservedType: (t2) => {
          let { reservedType: r2 } = t2;
          return `Unexpected reserved type ${r2}.`;
        }, UnexpectedReservedUnderscore: "`_` is only allowed as a type argument to call or new.", UnexpectedSpaceBetweenModuloChecks: "Spaces between `%` and `checks` are not allowed here.", UnexpectedSpreadType: "Spread operator cannot appear in class or interface definitions.", UnexpectedSubtractionOperand: 'Unexpected token, expected "number" or "bigint".', UnexpectedTokenAfterTypeParameter: "Expected an arrow function after this type parameter declaration.", UnexpectedTypeParameterBeforeAsyncArrowFunction: "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`.", UnsupportedDeclareExportKind: (t2) => {
          let { unsupportedExportKind: r2, suggestion: e25 } = t2;
          return `\`declare export ${r2}\` is not supported. Use \`${e25}\` instead.`;
        }, UnsupportedStatementInDeclareModule: "Only declares and type imports are allowed inside declare module.", UnterminatedFlowComment: "Unterminated flow-comment." });
        function Jl2(t2) {
          return t2.type === "DeclareExportAllDeclaration" || t2.type === "DeclareExportDeclaration" && (!t2.declaration || t2.declaration.type !== "TypeAlias" && t2.declaration.type !== "InterfaceDeclaration");
        }
        function xs(t2) {
          return t2.importKind === "type" || t2.importKind === "typeof";
        }
        function Gr2(t2) {
          return ye2(t2) && t2 !== 97;
        }
        var Xl2 = { const: "declare export var", let: "declare export var", type: "export type", interface: "export interface" };
        function Yl2(t2, r2) {
          let e25 = [], s2 = [];
          for (let i2 = 0; i2 < t2.length; i2++)
            (r2(t2[i2], i2, t2) ? e25 : s2).push(t2[i2]);
          return [e25, s2];
        }
        var Ql2 = /\*?\s*@((?:no)?flow)\b/, Zl2 = (t2) => class extends t2 {
          constructor() {
            super(...arguments), this.flowPragma = void 0;
          }
          getScopeHandler() {
            return El2;
          }
          shouldParseTypes() {
            return this.getPluginOption("flow", "all") || this.flowPragma === "flow";
          }
          shouldParseEnums() {
            return !!this.getPluginOption("flow", "enums");
          }
          finishToken(e25, s2) {
            return e25 !== 131 && e25 !== 13 && e25 !== 28 && this.flowPragma === void 0 && (this.flowPragma = null), super.finishToken(e25, s2);
          }
          addComment(e25) {
            if (this.flowPragma === void 0) {
              let s2 = Ql2.exec(e25.value);
              if (s2)
                if (s2[1] === "flow")
                  this.flowPragma = "flow";
                else if (s2[1] === "noflow")
                  this.flowPragma = "noflow";
                else
                  throw new Error("Unexpected flow pragma");
            }
            return super.addComment(e25);
          }
          flowParseTypeInitialiser(e25) {
            let s2 = this.state.inType;
            this.state.inType = true, this.expect(e25 || 14);
            let i2 = this.flowParseType();
            return this.state.inType = s2, i2;
          }
          flowParsePredicate() {
            let e25 = this.startNode(), s2 = this.state.startLoc;
            return this.next(), this.expectContextual(108), this.state.lastTokStart > s2.index + 1 && this.raise(D2.UnexpectedSpaceBetweenModuloChecks, { at: s2 }), this.eat(10) ? (e25.value = super.parseExpression(), this.expect(11), this.finishNode(e25, "DeclaredPredicate")) : this.finishNode(e25, "InferredPredicate");
          }
          flowParseTypeAndPredicateInitialiser() {
            let e25 = this.state.inType;
            this.state.inType = true, this.expect(14);
            let s2 = null, i2 = null;
            return this.match(54) ? (this.state.inType = e25, i2 = this.flowParsePredicate()) : (s2 = this.flowParseType(), this.state.inType = e25, this.match(54) && (i2 = this.flowParsePredicate())), [s2, i2];
          }
          flowParseDeclareClass(e25) {
            return this.next(), this.flowParseInterfaceish(e25, true), this.finishNode(e25, "DeclareClass");
          }
          flowParseDeclareFunction(e25) {
            this.next();
            let s2 = e25.id = this.parseIdentifier(), i2 = this.startNode(), a2 = this.startNode();
            this.match(47) ? i2.typeParameters = this.flowParseTypeParameterDeclaration() : i2.typeParameters = null, this.expect(10);
            let n2 = this.flowParseFunctionTypeParams();
            return i2.params = n2.params, i2.rest = n2.rest, i2.this = n2._this, this.expect(11), [i2.returnType, e25.predicate] = this.flowParseTypeAndPredicateInitialiser(), a2.typeAnnotation = this.finishNode(i2, "FunctionTypeAnnotation"), s2.typeAnnotation = this.finishNode(a2, "TypeAnnotation"), this.resetEndLocation(s2), this.semicolon(), this.scope.declareName(e25.id.name, xl2, e25.id.loc.start), this.finishNode(e25, "DeclareFunction");
          }
          flowParseDeclare(e25, s2) {
            if (this.match(80))
              return this.flowParseDeclareClass(e25);
            if (this.match(68))
              return this.flowParseDeclareFunction(e25);
            if (this.match(74))
              return this.flowParseDeclareVariable(e25);
            if (this.eatContextual(125))
              return this.match(16) ? this.flowParseDeclareModuleExports(e25) : (s2 && this.raise(D2.NestedDeclareModule, { at: this.state.lastTokStartLoc }), this.flowParseDeclareModule(e25));
            if (this.isContextual(128))
              return this.flowParseDeclareTypeAlias(e25);
            if (this.isContextual(129))
              return this.flowParseDeclareOpaqueType(e25);
            if (this.isContextual(127))
              return this.flowParseDeclareInterface(e25);
            if (this.match(82))
              return this.flowParseDeclareExportDeclaration(e25, s2);
            throw this.unexpected();
          }
          flowParseDeclareVariable(e25) {
            return this.next(), e25.id = this.flowParseTypeAnnotatableIdentifier(true), this.scope.declareName(e25.id.name, xt, e25.id.loc.start), this.semicolon(), this.finishNode(e25, "DeclareVariable");
          }
          flowParseDeclareModule(e25) {
            this.scope.enter(je2), this.match(131) ? e25.id = super.parseExprAtom() : e25.id = this.parseIdentifier();
            let s2 = e25.body = this.startNode(), i2 = s2.body = [];
            for (this.expect(5); !this.match(8); ) {
              let o2 = this.startNode();
              this.match(83) ? (this.next(), !this.isContextual(128) && !this.match(87) && this.raise(D2.InvalidNonTypeImportInDeclareModule, { at: this.state.lastTokStartLoc }), super.parseImport(o2)) : (this.expectContextual(123, D2.UnsupportedStatementInDeclareModule), o2 = this.flowParseDeclare(o2, true)), i2.push(o2);
            }
            this.scope.exit(), this.expect(8), this.finishNode(s2, "BlockStatement");
            let a2 = null, n2 = false;
            return i2.forEach((o2) => {
              Jl2(o2) ? (a2 === "CommonJS" && this.raise(D2.AmbiguousDeclareModuleKind, { at: o2 }), a2 = "ES") : o2.type === "DeclareModuleExports" && (n2 && this.raise(D2.DuplicateDeclareModuleExports, { at: o2 }), a2 === "ES" && this.raise(D2.AmbiguousDeclareModuleKind, { at: o2 }), a2 = "CommonJS", n2 = true);
            }), e25.kind = a2 || "CommonJS", this.finishNode(e25, "DeclareModule");
          }
          flowParseDeclareExportDeclaration(e25, s2) {
            if (this.expect(82), this.eat(65))
              return this.match(68) || this.match(80) ? e25.declaration = this.flowParseDeclare(this.startNode()) : (e25.declaration = this.flowParseType(), this.semicolon()), e25.default = true, this.finishNode(e25, "DeclareExportDeclaration");
            if (this.match(75) || this.isLet() || (this.isContextual(128) || this.isContextual(127)) && !s2) {
              let i2 = this.state.value;
              throw this.raise(D2.UnsupportedDeclareExportKind, { at: this.state.startLoc, unsupportedExportKind: i2, suggestion: Xl2[i2] });
            }
            if (this.match(74) || this.match(68) || this.match(80) || this.isContextual(129))
              return e25.declaration = this.flowParseDeclare(this.startNode()), e25.default = false, this.finishNode(e25, "DeclareExportDeclaration");
            if (this.match(55) || this.match(5) || this.isContextual(127) || this.isContextual(128) || this.isContextual(129))
              return e25 = this.parseExport(e25, null), e25.type === "ExportNamedDeclaration" && (e25.type = "ExportDeclaration", e25.default = false, delete e25.exportKind), e25.type = "Declare" + e25.type, e25;
            throw this.unexpected();
          }
          flowParseDeclareModuleExports(e25) {
            return this.next(), this.expectContextual(109), e25.typeAnnotation = this.flowParseTypeAnnotation(), this.semicolon(), this.finishNode(e25, "DeclareModuleExports");
          }
          flowParseDeclareTypeAlias(e25) {
            this.next();
            let s2 = this.flowParseTypeAlias(e25);
            return s2.type = "DeclareTypeAlias", s2;
          }
          flowParseDeclareOpaqueType(e25) {
            this.next();
            let s2 = this.flowParseOpaqueType(e25, true);
            return s2.type = "DeclareOpaqueType", s2;
          }
          flowParseDeclareInterface(e25) {
            return this.next(), this.flowParseInterfaceish(e25), this.finishNode(e25, "DeclareInterface");
          }
          flowParseInterfaceish(e25) {
            let s2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            if (e25.id = this.flowParseRestrictedIdentifier(!s2, true), this.scope.declareName(e25.id.name, s2 ? Dr2 : De2, e25.id.loc.start), this.match(47) ? e25.typeParameters = this.flowParseTypeParameterDeclaration() : e25.typeParameters = null, e25.extends = [], e25.implements = [], e25.mixins = [], this.eat(81))
              do
                e25.extends.push(this.flowParseInterfaceExtends());
              while (!s2 && this.eat(12));
            if (this.isContextual(115)) {
              this.next();
              do
                e25.mixins.push(this.flowParseInterfaceExtends());
              while (this.eat(12));
            }
            if (this.isContextual(111)) {
              this.next();
              do
                e25.implements.push(this.flowParseInterfaceExtends());
              while (this.eat(12));
            }
            e25.body = this.flowParseObjectType({ allowStatic: s2, allowExact: false, allowSpread: false, allowProto: s2, allowInexact: false });
          }
          flowParseInterfaceExtends() {
            let e25 = this.startNode();
            return e25.id = this.flowParseQualifiedTypeIdentifier(), this.match(47) ? e25.typeParameters = this.flowParseTypeParameterInstantiation() : e25.typeParameters = null, this.finishNode(e25, "InterfaceExtends");
          }
          flowParseInterface(e25) {
            return this.flowParseInterfaceish(e25), this.finishNode(e25, "InterfaceDeclaration");
          }
          checkNotUnderscore(e25) {
            e25 === "_" && this.raise(D2.UnexpectedReservedUnderscore, { at: this.state.startLoc });
          }
          checkReservedType(e25, s2, i2) {
            Gl2.has(e25) && this.raise(i2 ? D2.AssignReservedType : D2.UnexpectedReservedType, { at: s2, reservedType: e25 });
          }
          flowParseRestrictedIdentifier(e25, s2) {
            return this.checkReservedType(this.state.value, this.state.startLoc, s2), this.parseIdentifier(e25);
          }
          flowParseTypeAlias(e25) {
            return e25.id = this.flowParseRestrictedIdentifier(false, true), this.scope.declareName(e25.id.name, De2, e25.id.loc.start), this.match(47) ? e25.typeParameters = this.flowParseTypeParameterDeclaration() : e25.typeParameters = null, e25.right = this.flowParseTypeInitialiser(29), this.semicolon(), this.finishNode(e25, "TypeAlias");
          }
          flowParseOpaqueType(e25, s2) {
            return this.expectContextual(128), e25.id = this.flowParseRestrictedIdentifier(true, true), this.scope.declareName(e25.id.name, De2, e25.id.loc.start), this.match(47) ? e25.typeParameters = this.flowParseTypeParameterDeclaration() : e25.typeParameters = null, e25.supertype = null, this.match(14) && (e25.supertype = this.flowParseTypeInitialiser(14)), e25.impltype = null, s2 || (e25.impltype = this.flowParseTypeInitialiser(29)), this.semicolon(), this.finishNode(e25, "OpaqueType");
          }
          flowParseTypeParameter() {
            let e25 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, s2 = this.state.startLoc, i2 = this.startNode(), a2 = this.flowParseVariance(), n2 = this.flowParseTypeAnnotatableIdentifier();
            return i2.name = n2.name, i2.variance = a2, i2.bound = n2.typeAnnotation, this.match(29) ? (this.eat(29), i2.default = this.flowParseType()) : e25 && this.raise(D2.MissingTypeParamDefault, { at: s2 }), this.finishNode(i2, "TypeParameter");
          }
          flowParseTypeParameterDeclaration() {
            let e25 = this.state.inType, s2 = this.startNode();
            s2.params = [], this.state.inType = true, this.match(47) || this.match(140) ? this.next() : this.unexpected();
            let i2 = false;
            do {
              let a2 = this.flowParseTypeParameter(i2);
              s2.params.push(a2), a2.default && (i2 = true), this.match(48) || this.expect(12);
            } while (!this.match(48));
            return this.expect(48), this.state.inType = e25, this.finishNode(s2, "TypeParameterDeclaration");
          }
          flowParseTypeParameterInstantiation() {
            let e25 = this.startNode(), s2 = this.state.inType;
            e25.params = [], this.state.inType = true, this.expect(47);
            let i2 = this.state.noAnonFunctionType;
            for (this.state.noAnonFunctionType = false; !this.match(48); )
              e25.params.push(this.flowParseType()), this.match(48) || this.expect(12);
            return this.state.noAnonFunctionType = i2, this.expect(48), this.state.inType = s2, this.finishNode(e25, "TypeParameterInstantiation");
          }
          flowParseTypeParameterInstantiationCallOrNew() {
            let e25 = this.startNode(), s2 = this.state.inType;
            for (e25.params = [], this.state.inType = true, this.expect(47); !this.match(48); )
              e25.params.push(this.flowParseTypeOrImplicitInstantiation()), this.match(48) || this.expect(12);
            return this.expect(48), this.state.inType = s2, this.finishNode(e25, "TypeParameterInstantiation");
          }
          flowParseInterfaceType() {
            let e25 = this.startNode();
            if (this.expectContextual(127), e25.extends = [], this.eat(81))
              do
                e25.extends.push(this.flowParseInterfaceExtends());
              while (this.eat(12));
            return e25.body = this.flowParseObjectType({ allowStatic: false, allowExact: false, allowSpread: false, allowProto: false, allowInexact: false }), this.finishNode(e25, "InterfaceTypeAnnotation");
          }
          flowParseObjectPropertyKey() {
            return this.match(132) || this.match(131) ? super.parseExprAtom() : this.parseIdentifier(true);
          }
          flowParseObjectTypeIndexer(e25, s2, i2) {
            return e25.static = s2, this.lookahead().type === 14 ? (e25.id = this.flowParseObjectPropertyKey(), e25.key = this.flowParseTypeInitialiser()) : (e25.id = null, e25.key = this.flowParseType()), this.expect(3), e25.value = this.flowParseTypeInitialiser(), e25.variance = i2, this.finishNode(e25, "ObjectTypeIndexer");
          }
          flowParseObjectTypeInternalSlot(e25, s2) {
            return e25.static = s2, e25.id = this.flowParseObjectPropertyKey(), this.expect(3), this.expect(3), this.match(47) || this.match(10) ? (e25.method = true, e25.optional = false, e25.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e25.loc.start))) : (e25.method = false, this.eat(17) && (e25.optional = true), e25.value = this.flowParseTypeInitialiser()), this.finishNode(e25, "ObjectTypeInternalSlot");
          }
          flowParseObjectTypeMethodish(e25) {
            for (e25.params = [], e25.rest = null, e25.typeParameters = null, e25.this = null, this.match(47) && (e25.typeParameters = this.flowParseTypeParameterDeclaration()), this.expect(10), this.match(78) && (e25.this = this.flowParseFunctionTypeParam(true), e25.this.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); )
              e25.params.push(this.flowParseFunctionTypeParam(false)), this.match(11) || this.expect(12);
            return this.eat(21) && (e25.rest = this.flowParseFunctionTypeParam(false)), this.expect(11), e25.returnType = this.flowParseTypeInitialiser(), this.finishNode(e25, "FunctionTypeAnnotation");
          }
          flowParseObjectTypeCallProperty(e25, s2) {
            let i2 = this.startNode();
            return e25.static = s2, e25.value = this.flowParseObjectTypeMethodish(i2), this.finishNode(e25, "ObjectTypeCallProperty");
          }
          flowParseObjectType(e25) {
            let { allowStatic: s2, allowExact: i2, allowSpread: a2, allowProto: n2, allowInexact: o2 } = e25, c2 = this.state.inType;
            this.state.inType = true;
            let p2 = this.startNode();
            p2.callProperties = [], p2.properties = [], p2.indexers = [], p2.internalSlots = [];
            let m2, x2, A2 = false;
            for (i2 && this.match(6) ? (this.expect(6), m2 = 9, x2 = true) : (this.expect(5), m2 = 8, x2 = false), p2.exact = x2; !this.match(m2); ) {
              let O2 = false, R2 = null, Y2 = null, Q2 = this.startNode();
              if (n2 && this.isContextual(116)) {
                let se2 = this.lookahead();
                se2.type !== 14 && se2.type !== 17 && (this.next(), R2 = this.state.startLoc, s2 = false);
              }
              if (s2 && this.isContextual(104)) {
                let se2 = this.lookahead();
                se2.type !== 14 && se2.type !== 17 && (this.next(), O2 = true);
              }
              let J2 = this.flowParseVariance();
              if (this.eat(0))
                R2 != null && this.unexpected(R2), this.eat(0) ? (J2 && this.unexpected(J2.loc.start), p2.internalSlots.push(this.flowParseObjectTypeInternalSlot(Q2, O2))) : p2.indexers.push(this.flowParseObjectTypeIndexer(Q2, O2, J2));
              else if (this.match(10) || this.match(47))
                R2 != null && this.unexpected(R2), J2 && this.unexpected(J2.loc.start), p2.callProperties.push(this.flowParseObjectTypeCallProperty(Q2, O2));
              else {
                let se2 = "init";
                if (this.isContextual(98) || this.isContextual(103)) {
                  let Ih2 = this.lookahead();
                  gr2(Ih2.type) && (se2 = this.state.value, this.next());
                }
                let Ve2 = this.flowParseObjectTypeProperty(Q2, O2, R2, J2, se2, a2, o2 != null ? o2 : !x2);
                Ve2 === null ? (A2 = true, Y2 = this.state.lastTokStartLoc) : p2.properties.push(Ve2);
              }
              this.flowObjectTypeSemicolon(), Y2 && !this.match(8) && !this.match(9) && this.raise(D2.UnexpectedExplicitInexactInObject, { at: Y2 });
            }
            this.expect(m2), a2 && (p2.inexact = A2);
            let b2 = this.finishNode(p2, "ObjectTypeAnnotation");
            return this.state.inType = c2, b2;
          }
          flowParseObjectTypeProperty(e25, s2, i2, a2, n2, o2, c2) {
            if (this.eat(21))
              return this.match(12) || this.match(13) || this.match(8) || this.match(9) ? (o2 ? c2 || this.raise(D2.InexactInsideExact, { at: this.state.lastTokStartLoc }) : this.raise(D2.InexactInsideNonObject, { at: this.state.lastTokStartLoc }), a2 && this.raise(D2.InexactVariance, { at: a2 }), null) : (o2 || this.raise(D2.UnexpectedSpreadType, { at: this.state.lastTokStartLoc }), i2 != null && this.unexpected(i2), a2 && this.raise(D2.SpreadVariance, { at: a2 }), e25.argument = this.flowParseType(), this.finishNode(e25, "ObjectTypeSpreadProperty"));
            {
              e25.key = this.flowParseObjectPropertyKey(), e25.static = s2, e25.proto = i2 != null, e25.kind = n2;
              let p2 = false;
              return this.match(47) || this.match(10) ? (e25.method = true, i2 != null && this.unexpected(i2), a2 && this.unexpected(a2.loc.start), e25.value = this.flowParseObjectTypeMethodish(this.startNodeAt(e25.loc.start)), (n2 === "get" || n2 === "set") && this.flowCheckGetterSetterParams(e25), !o2 && e25.key.name === "constructor" && e25.value.this && this.raise(D2.ThisParamBannedInConstructor, { at: e25.value.this })) : (n2 !== "init" && this.unexpected(), e25.method = false, this.eat(17) && (p2 = true), e25.value = this.flowParseTypeInitialiser(), e25.variance = a2), e25.optional = p2, this.finishNode(e25, "ObjectTypeProperty");
            }
          }
          flowCheckGetterSetterParams(e25) {
            let s2 = e25.kind === "get" ? 0 : 1, i2 = e25.value.params.length + (e25.value.rest ? 1 : 0);
            e25.value.this && this.raise(e25.kind === "get" ? D2.GetterMayNotHaveThisParam : D2.SetterMayNotHaveThisParam, { at: e25.value.this }), i2 !== s2 && this.raise(e25.kind === "get" ? u2.BadGetterArity : u2.BadSetterArity, { at: e25 }), e25.kind === "set" && e25.value.rest && this.raise(u2.BadSetterRestParameter, { at: e25 });
          }
          flowObjectTypeSemicolon() {
            !this.eat(13) && !this.eat(12) && !this.match(8) && !this.match(9) && this.unexpected();
          }
          flowParseQualifiedTypeIdentifier(e25, s2) {
            e25 != null || (e25 = this.state.startLoc);
            let a2 = s2 || this.flowParseRestrictedIdentifier(true);
            for (; this.eat(16); ) {
              let n2 = this.startNodeAt(e25);
              n2.qualification = a2, n2.id = this.flowParseRestrictedIdentifier(true), a2 = this.finishNode(n2, "QualifiedTypeIdentifier");
            }
            return a2;
          }
          flowParseGenericType(e25, s2) {
            let i2 = this.startNodeAt(e25);
            return i2.typeParameters = null, i2.id = this.flowParseQualifiedTypeIdentifier(e25, s2), this.match(47) && (i2.typeParameters = this.flowParseTypeParameterInstantiation()), this.finishNode(i2, "GenericTypeAnnotation");
          }
          flowParseTypeofType() {
            let e25 = this.startNode();
            return this.expect(87), e25.argument = this.flowParsePrimaryType(), this.finishNode(e25, "TypeofTypeAnnotation");
          }
          flowParseTupleType() {
            let e25 = this.startNode();
            for (e25.types = [], this.expect(0); this.state.pos < this.length && !this.match(3) && (e25.types.push(this.flowParseType()), !this.match(3)); )
              this.expect(12);
            return this.expect(3), this.finishNode(e25, "TupleTypeAnnotation");
          }
          flowParseFunctionTypeParam(e25) {
            let s2 = null, i2 = false, a2 = null, n2 = this.startNode(), o2 = this.lookahead(), c2 = this.state.type === 78;
            return o2.type === 14 || o2.type === 17 ? (c2 && !e25 && this.raise(D2.ThisParamMustBeFirst, { at: n2 }), s2 = this.parseIdentifier(c2), this.eat(17) && (i2 = true, c2 && this.raise(D2.ThisParamMayNotBeOptional, { at: n2 })), a2 = this.flowParseTypeInitialiser()) : a2 = this.flowParseType(), n2.name = s2, n2.optional = i2, n2.typeAnnotation = a2, this.finishNode(n2, "FunctionTypeParam");
          }
          reinterpretTypeAsFunctionTypeParam(e25) {
            let s2 = this.startNodeAt(e25.loc.start);
            return s2.name = null, s2.optional = false, s2.typeAnnotation = e25, this.finishNode(s2, "FunctionTypeParam");
          }
          flowParseFunctionTypeParams() {
            let e25 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], s2 = null, i2 = null;
            for (this.match(78) && (i2 = this.flowParseFunctionTypeParam(true), i2.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); )
              e25.push(this.flowParseFunctionTypeParam(false)), this.match(11) || this.expect(12);
            return this.eat(21) && (s2 = this.flowParseFunctionTypeParam(false)), { params: e25, rest: s2, _this: i2 };
          }
          flowIdentToTypeAnnotation(e25, s2, i2) {
            switch (i2.name) {
              case "any":
                return this.finishNode(s2, "AnyTypeAnnotation");
              case "bool":
              case "boolean":
                return this.finishNode(s2, "BooleanTypeAnnotation");
              case "mixed":
                return this.finishNode(s2, "MixedTypeAnnotation");
              case "empty":
                return this.finishNode(s2, "EmptyTypeAnnotation");
              case "number":
                return this.finishNode(s2, "NumberTypeAnnotation");
              case "string":
                return this.finishNode(s2, "StringTypeAnnotation");
              case "symbol":
                return this.finishNode(s2, "SymbolTypeAnnotation");
              default:
                return this.checkNotUnderscore(i2.name), this.flowParseGenericType(e25, i2);
            }
          }
          flowParsePrimaryType() {
            let e25 = this.state.startLoc, s2 = this.startNode(), i2, a2, n2 = false, o2 = this.state.noAnonFunctionType;
            switch (this.state.type) {
              case 5:
                return this.flowParseObjectType({ allowStatic: false, allowExact: false, allowSpread: true, allowProto: false, allowInexact: true });
              case 6:
                return this.flowParseObjectType({ allowStatic: false, allowExact: true, allowSpread: true, allowProto: false, allowInexact: false });
              case 0:
                return this.state.noAnonFunctionType = false, a2 = this.flowParseTupleType(), this.state.noAnonFunctionType = o2, a2;
              case 47:
                return s2.typeParameters = this.flowParseTypeParameterDeclaration(), this.expect(10), i2 = this.flowParseFunctionTypeParams(), s2.params = i2.params, s2.rest = i2.rest, s2.this = i2._this, this.expect(11), this.expect(19), s2.returnType = this.flowParseType(), this.finishNode(s2, "FunctionTypeAnnotation");
              case 10:
                if (this.next(), !this.match(11) && !this.match(21))
                  if (z2(this.state.type) || this.match(78)) {
                    let c2 = this.lookahead().type;
                    n2 = c2 !== 17 && c2 !== 14;
                  } else
                    n2 = true;
                if (n2) {
                  if (this.state.noAnonFunctionType = false, a2 = this.flowParseType(), this.state.noAnonFunctionType = o2, this.state.noAnonFunctionType || !(this.match(12) || this.match(11) && this.lookahead().type === 19))
                    return this.expect(11), a2;
                  this.eat(12);
                }
                return a2 ? i2 = this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(a2)]) : i2 = this.flowParseFunctionTypeParams(), s2.params = i2.params, s2.rest = i2.rest, s2.this = i2._this, this.expect(11), this.expect(19), s2.returnType = this.flowParseType(), s2.typeParameters = null, this.finishNode(s2, "FunctionTypeAnnotation");
              case 131:
                return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
              case 85:
              case 86:
                return s2.value = this.match(85), this.next(), this.finishNode(s2, "BooleanLiteralTypeAnnotation");
              case 53:
                if (this.state.value === "-") {
                  if (this.next(), this.match(132))
                    return this.parseLiteralAtNode(-this.state.value, "NumberLiteralTypeAnnotation", s2);
                  if (this.match(133))
                    return this.parseLiteralAtNode(-this.state.value, "BigIntLiteralTypeAnnotation", s2);
                  throw this.raise(D2.UnexpectedSubtractionOperand, { at: this.state.startLoc });
                }
                throw this.unexpected();
              case 132:
                return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");
              case 133:
                return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");
              case 88:
                return this.next(), this.finishNode(s2, "VoidTypeAnnotation");
              case 84:
                return this.next(), this.finishNode(s2, "NullLiteralTypeAnnotation");
              case 78:
                return this.next(), this.finishNode(s2, "ThisTypeAnnotation");
              case 55:
                return this.next(), this.finishNode(s2, "ExistsTypeAnnotation");
              case 87:
                return this.flowParseTypeofType();
              default:
                if (Yt2(this.state.type)) {
                  let c2 = Ee2(this.state.type);
                  return this.next(), super.createIdentifier(s2, c2);
                } else if (z2(this.state.type))
                  return this.isContextual(127) ? this.flowParseInterfaceType() : this.flowIdentToTypeAnnotation(e25, s2, this.parseIdentifier());
            }
            throw this.unexpected();
          }
          flowParsePostfixType() {
            let e25 = this.state.startLoc, s2 = this.flowParsePrimaryType(), i2 = false;
            for (; (this.match(0) || this.match(18)) && !this.canInsertSemicolon(); ) {
              let a2 = this.startNodeAt(e25), n2 = this.eat(18);
              i2 = i2 || n2, this.expect(0), !n2 && this.match(3) ? (a2.elementType = s2, this.next(), s2 = this.finishNode(a2, "ArrayTypeAnnotation")) : (a2.objectType = s2, a2.indexType = this.flowParseType(), this.expect(3), i2 ? (a2.optional = n2, s2 = this.finishNode(a2, "OptionalIndexedAccessType")) : s2 = this.finishNode(a2, "IndexedAccessType"));
            }
            return s2;
          }
          flowParsePrefixType() {
            let e25 = this.startNode();
            return this.eat(17) ? (e25.typeAnnotation = this.flowParsePrefixType(), this.finishNode(e25, "NullableTypeAnnotation")) : this.flowParsePostfixType();
          }
          flowParseAnonFunctionWithoutParens() {
            let e25 = this.flowParsePrefixType();
            if (!this.state.noAnonFunctionType && this.eat(19)) {
              let s2 = this.startNodeAt(e25.loc.start);
              return s2.params = [this.reinterpretTypeAsFunctionTypeParam(e25)], s2.rest = null, s2.this = null, s2.returnType = this.flowParseType(), s2.typeParameters = null, this.finishNode(s2, "FunctionTypeAnnotation");
            }
            return e25;
          }
          flowParseIntersectionType() {
            let e25 = this.startNode();
            this.eat(45);
            let s2 = this.flowParseAnonFunctionWithoutParens();
            for (e25.types = [s2]; this.eat(45); )
              e25.types.push(this.flowParseAnonFunctionWithoutParens());
            return e25.types.length === 1 ? s2 : this.finishNode(e25, "IntersectionTypeAnnotation");
          }
          flowParseUnionType() {
            let e25 = this.startNode();
            this.eat(43);
            let s2 = this.flowParseIntersectionType();
            for (e25.types = [s2]; this.eat(43); )
              e25.types.push(this.flowParseIntersectionType());
            return e25.types.length === 1 ? s2 : this.finishNode(e25, "UnionTypeAnnotation");
          }
          flowParseType() {
            let e25 = this.state.inType;
            this.state.inType = true;
            let s2 = this.flowParseUnionType();
            return this.state.inType = e25, s2;
          }
          flowParseTypeOrImplicitInstantiation() {
            if (this.state.type === 130 && this.state.value === "_") {
              let e25 = this.state.startLoc, s2 = this.parseIdentifier();
              return this.flowParseGenericType(e25, s2);
            } else
              return this.flowParseType();
          }
          flowParseTypeAnnotation() {
            let e25 = this.startNode();
            return e25.typeAnnotation = this.flowParseTypeInitialiser(), this.finishNode(e25, "TypeAnnotation");
          }
          flowParseTypeAnnotatableIdentifier(e25) {
            let s2 = e25 ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
            return this.match(14) && (s2.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(s2)), s2;
          }
          typeCastToParameter(e25) {
            return e25.expression.typeAnnotation = e25.typeAnnotation, this.resetEndLocation(e25.expression, e25.typeAnnotation.loc.end), e25.expression;
          }
          flowParseVariance() {
            let e25 = null;
            return this.match(53) ? (e25 = this.startNode(), this.state.value === "+" ? e25.kind = "plus" : e25.kind = "minus", this.next(), this.finishNode(e25, "Variance")) : e25;
          }
          parseFunctionBody(e25, s2) {
            let i2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            return s2 ? this.forwardNoArrowParamsConversionAt(e25, () => super.parseFunctionBody(e25, true, i2)) : super.parseFunctionBody(e25, false, i2);
          }
          parseFunctionBodyAndFinish(e25, s2) {
            let i2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            if (this.match(14)) {
              let a2 = this.startNode();
              [a2.typeAnnotation, e25.predicate] = this.flowParseTypeAndPredicateInitialiser(), e25.returnType = a2.typeAnnotation ? this.finishNode(a2, "TypeAnnotation") : null;
            }
            return super.parseFunctionBodyAndFinish(e25, s2, i2);
          }
          parseStatementLike(e25) {
            if (this.state.strict && this.isContextual(127)) {
              let i2 = this.lookahead();
              if (ye2(i2.type)) {
                let a2 = this.startNode();
                return this.next(), this.flowParseInterface(a2);
              }
            } else if (this.shouldParseEnums() && this.isContextual(124)) {
              let i2 = this.startNode();
              return this.next(), this.flowParseEnumDeclaration(i2);
            }
            let s2 = super.parseStatementLike(e25);
            return this.flowPragma === void 0 && !this.isValidDirective(s2) && (this.flowPragma = null), s2;
          }
          parseExpressionStatement(e25, s2, i2) {
            if (s2.type === "Identifier") {
              if (s2.name === "declare") {
                if (this.match(80) || z2(this.state.type) || this.match(68) || this.match(74) || this.match(82))
                  return this.flowParseDeclare(e25);
              } else if (z2(this.state.type)) {
                if (s2.name === "interface")
                  return this.flowParseInterface(e25);
                if (s2.name === "type")
                  return this.flowParseTypeAlias(e25);
                if (s2.name === "opaque")
                  return this.flowParseOpaqueType(e25, false);
              }
            }
            return super.parseExpressionStatement(e25, s2, i2);
          }
          shouldParseExportDeclaration() {
            let { type: e25 } = this.state;
            return Pr2(e25) || this.shouldParseEnums() && e25 === 124 ? !this.state.containsEsc : super.shouldParseExportDeclaration();
          }
          isExportDefaultSpecifier() {
            let { type: e25 } = this.state;
            return Pr2(e25) || this.shouldParseEnums() && e25 === 124 ? this.state.containsEsc : super.isExportDefaultSpecifier();
          }
          parseExportDefaultExpression() {
            if (this.shouldParseEnums() && this.isContextual(124)) {
              let e25 = this.startNode();
              return this.next(), this.flowParseEnumDeclaration(e25);
            }
            return super.parseExportDefaultExpression();
          }
          parseConditional(e25, s2, i2) {
            if (!this.match(17))
              return e25;
            if (this.state.maybeInArrowParameters) {
              let A2 = this.lookaheadCharCode();
              if (A2 === 44 || A2 === 61 || A2 === 58 || A2 === 41)
                return this.setOptionalParametersError(i2), e25;
            }
            this.expect(17);
            let a2 = this.state.clone(), n2 = this.state.noArrowAt, o2 = this.startNodeAt(s2), { consequent: c2, failed: p2 } = this.tryParseConditionalConsequent(), [m2, x2] = this.getArrowLikeExpressions(c2);
            if (p2 || x2.length > 0) {
              let A2 = [...n2];
              if (x2.length > 0) {
                this.state = a2, this.state.noArrowAt = A2;
                for (let b2 = 0; b2 < x2.length; b2++)
                  A2.push(x2[b2].start);
                ({ consequent: c2, failed: p2 } = this.tryParseConditionalConsequent()), [m2, x2] = this.getArrowLikeExpressions(c2);
              }
              p2 && m2.length > 1 && this.raise(D2.AmbiguousConditionalArrow, { at: a2.startLoc }), p2 && m2.length === 1 && (this.state = a2, A2.push(m2[0].start), this.state.noArrowAt = A2, { consequent: c2, failed: p2 } = this.tryParseConditionalConsequent());
            }
            return this.getArrowLikeExpressions(c2, true), this.state.noArrowAt = n2, this.expect(14), o2.test = e25, o2.consequent = c2, o2.alternate = this.forwardNoArrowParamsConversionAt(o2, () => this.parseMaybeAssign(void 0, void 0)), this.finishNode(o2, "ConditionalExpression");
          }
          tryParseConditionalConsequent() {
            this.state.noArrowParamsConversionAt.push(this.state.start);
            let e25 = this.parseMaybeAssignAllowIn(), s2 = !this.match(14);
            return this.state.noArrowParamsConversionAt.pop(), { consequent: e25, failed: s2 };
          }
          getArrowLikeExpressions(e25, s2) {
            let i2 = [e25], a2 = [];
            for (; i2.length !== 0; ) {
              let n2 = i2.pop();
              n2.type === "ArrowFunctionExpression" ? (n2.typeParameters || !n2.returnType ? this.finishArrowValidation(n2) : a2.push(n2), i2.push(n2.body)) : n2.type === "ConditionalExpression" && (i2.push(n2.consequent), i2.push(n2.alternate));
            }
            return s2 ? (a2.forEach((n2) => this.finishArrowValidation(n2)), [a2, []]) : Yl2(a2, (n2) => n2.params.every((o2) => this.isAssignable(o2, true)));
          }
          finishArrowValidation(e25) {
            var s2;
            this.toAssignableList(e25.params, (s2 = e25.extra) == null ? void 0 : s2.trailingCommaLoc, false), this.scope.enter(Pe2 | ts2), super.checkParams(e25, false, true), this.scope.exit();
          }
          forwardNoArrowParamsConversionAt(e25, s2) {
            let i2;
            return this.state.noArrowParamsConversionAt.indexOf(e25.start) !== -1 ? (this.state.noArrowParamsConversionAt.push(this.state.start), i2 = s2(), this.state.noArrowParamsConversionAt.pop()) : i2 = s2(), i2;
          }
          parseParenItem(e25, s2) {
            if (e25 = super.parseParenItem(e25, s2), this.eat(17) && (e25.optional = true, this.resetEndLocation(e25)), this.match(14)) {
              let i2 = this.startNodeAt(s2);
              return i2.expression = e25, i2.typeAnnotation = this.flowParseTypeAnnotation(), this.finishNode(i2, "TypeCastExpression");
            }
            return e25;
          }
          assertModuleNodeAllowed(e25) {
            e25.type === "ImportDeclaration" && (e25.importKind === "type" || e25.importKind === "typeof") || e25.type === "ExportNamedDeclaration" && e25.exportKind === "type" || e25.type === "ExportAllDeclaration" && e25.exportKind === "type" || super.assertModuleNodeAllowed(e25);
          }
          parseExport(e25, s2) {
            let i2 = super.parseExport(e25, s2);
            return (i2.type === "ExportNamedDeclaration" || i2.type === "ExportAllDeclaration") && (i2.exportKind = i2.exportKind || "value"), i2;
          }
          parseExportDeclaration(e25) {
            if (this.isContextual(128)) {
              e25.exportKind = "type";
              let s2 = this.startNode();
              return this.next(), this.match(5) ? (e25.specifiers = this.parseExportSpecifiers(true), super.parseExportFrom(e25), null) : this.flowParseTypeAlias(s2);
            } else if (this.isContextual(129)) {
              e25.exportKind = "type";
              let s2 = this.startNode();
              return this.next(), this.flowParseOpaqueType(s2, false);
            } else if (this.isContextual(127)) {
              e25.exportKind = "type";
              let s2 = this.startNode();
              return this.next(), this.flowParseInterface(s2);
            } else if (this.shouldParseEnums() && this.isContextual(124)) {
              e25.exportKind = "value";
              let s2 = this.startNode();
              return this.next(), this.flowParseEnumDeclaration(s2);
            } else
              return super.parseExportDeclaration(e25);
          }
          eatExportStar(e25) {
            return super.eatExportStar(e25) ? true : this.isContextual(128) && this.lookahead().type === 55 ? (e25.exportKind = "type", this.next(), this.next(), true) : false;
          }
          maybeParseExportNamespaceSpecifier(e25) {
            let { startLoc: s2 } = this.state, i2 = super.maybeParseExportNamespaceSpecifier(e25);
            return i2 && e25.exportKind === "type" && this.unexpected(s2), i2;
          }
          parseClassId(e25, s2, i2) {
            super.parseClassId(e25, s2, i2), this.match(47) && (e25.typeParameters = this.flowParseTypeParameterDeclaration());
          }
          parseClassMember(e25, s2, i2) {
            let { startLoc: a2 } = this.state;
            if (this.isContextual(123)) {
              if (super.parseClassMemberFromModifier(e25, s2))
                return;
              s2.declare = true;
            }
            super.parseClassMember(e25, s2, i2), s2.declare && (s2.type !== "ClassProperty" && s2.type !== "ClassPrivateProperty" && s2.type !== "PropertyDefinition" ? this.raise(D2.DeclareClassElement, { at: a2 }) : s2.value && this.raise(D2.DeclareClassFieldInitializer, { at: s2.value }));
          }
          isIterator(e25) {
            return e25 === "iterator" || e25 === "asyncIterator";
          }
          readIterator() {
            let e25 = super.readWord1(), s2 = "@@" + e25;
            (!this.isIterator(e25) || !this.state.inType) && this.raise(u2.InvalidIdentifier, { at: this.state.curPosition(), identifierName: s2 }), this.finishToken(130, s2);
          }
          getTokenFromCode(e25) {
            let s2 = this.input.charCodeAt(this.state.pos + 1);
            return e25 === 123 && s2 === 124 ? this.finishOp(6, 2) : this.state.inType && (e25 === 62 || e25 === 60) ? this.finishOp(e25 === 62 ? 48 : 47, 1) : this.state.inType && e25 === 63 ? s2 === 46 ? this.finishOp(18, 2) : this.finishOp(17, 1) : hl2(e25, s2, this.input.charCodeAt(this.state.pos + 2)) ? (this.state.pos += 2, this.readIterator()) : super.getTokenFromCode(e25);
          }
          isAssignable(e25, s2) {
            return e25.type === "TypeCastExpression" ? this.isAssignable(e25.expression, s2) : super.isAssignable(e25, s2);
          }
          toAssignable(e25) {
            let s2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            !s2 && e25.type === "AssignmentExpression" && e25.left.type === "TypeCastExpression" && (e25.left = this.typeCastToParameter(e25.left)), super.toAssignable(e25, s2);
          }
          toAssignableList(e25, s2, i2) {
            for (let a2 = 0; a2 < e25.length; a2++) {
              let n2 = e25[a2];
              (n2 == null ? void 0 : n2.type) === "TypeCastExpression" && (e25[a2] = this.typeCastToParameter(n2));
            }
            super.toAssignableList(e25, s2, i2);
          }
          toReferencedList(e25, s2) {
            for (let a2 = 0; a2 < e25.length; a2++) {
              var i2;
              let n2 = e25[a2];
              n2 && n2.type === "TypeCastExpression" && !((i2 = n2.extra) != null && i2.parenthesized) && (e25.length > 1 || !s2) && this.raise(D2.TypeCastInPattern, { at: n2.typeAnnotation });
            }
            return e25;
          }
          parseArrayLike(e25, s2, i2, a2) {
            let n2 = super.parseArrayLike(e25, s2, i2, a2);
            return s2 && !this.state.maybeInArrowParameters && this.toReferencedList(n2.elements), n2;
          }
          isValidLVal(e25, s2, i2) {
            return e25 === "TypeCastExpression" || super.isValidLVal(e25, s2, i2);
          }
          parseClassProperty(e25) {
            return this.match(14) && (e25.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassProperty(e25);
          }
          parseClassPrivateProperty(e25) {
            return this.match(14) && (e25.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassPrivateProperty(e25);
          }
          isClassMethod() {
            return this.match(47) || super.isClassMethod();
          }
          isClassProperty() {
            return this.match(14) || super.isClassProperty();
          }
          isNonstaticConstructor(e25) {
            return !this.match(14) && super.isNonstaticConstructor(e25);
          }
          pushClassMethod(e25, s2, i2, a2, n2, o2) {
            if (s2.variance && this.unexpected(s2.variance.loc.start), delete s2.variance, this.match(47) && (s2.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassMethod(e25, s2, i2, a2, n2, o2), s2.params && n2) {
              let c2 = s2.params;
              c2.length > 0 && this.isThisParam(c2[0]) && this.raise(D2.ThisParamBannedInConstructor, { at: s2 });
            } else if (s2.type === "MethodDefinition" && n2 && s2.value.params) {
              let c2 = s2.value.params;
              c2.length > 0 && this.isThisParam(c2[0]) && this.raise(D2.ThisParamBannedInConstructor, { at: s2 });
            }
          }
          pushClassPrivateMethod(e25, s2, i2, a2) {
            s2.variance && this.unexpected(s2.variance.loc.start), delete s2.variance, this.match(47) && (s2.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassPrivateMethod(e25, s2, i2, a2);
          }
          parseClassSuper(e25) {
            if (super.parseClassSuper(e25), e25.superClass && this.match(47) && (e25.superTypeParameters = this.flowParseTypeParameterInstantiation()), this.isContextual(111)) {
              this.next();
              let s2 = e25.implements = [];
              do {
                let i2 = this.startNode();
                i2.id = this.flowParseRestrictedIdentifier(true), this.match(47) ? i2.typeParameters = this.flowParseTypeParameterInstantiation() : i2.typeParameters = null, s2.push(this.finishNode(i2, "ClassImplements"));
              } while (this.eat(12));
            }
          }
          checkGetterSetterParams(e25) {
            super.checkGetterSetterParams(e25);
            let s2 = this.getObjectOrClassMethodParams(e25);
            if (s2.length > 0) {
              let i2 = s2[0];
              this.isThisParam(i2) && e25.kind === "get" ? this.raise(D2.GetterMayNotHaveThisParam, { at: i2 }) : this.isThisParam(i2) && this.raise(D2.SetterMayNotHaveThisParam, { at: i2 });
            }
          }
          parsePropertyNamePrefixOperator(e25) {
            e25.variance = this.flowParseVariance();
          }
          parseObjPropValue(e25, s2, i2, a2, n2, o2, c2) {
            e25.variance && this.unexpected(e25.variance.loc.start), delete e25.variance;
            let p2;
            this.match(47) && !o2 && (p2 = this.flowParseTypeParameterDeclaration(), this.match(10) || this.unexpected());
            let m2 = super.parseObjPropValue(e25, s2, i2, a2, n2, o2, c2);
            return p2 && ((m2.value || m2).typeParameters = p2), m2;
          }
          parseAssignableListItemTypes(e25) {
            return this.eat(17) && (e25.type !== "Identifier" && this.raise(D2.PatternIsOptional, { at: e25 }), this.isThisParam(e25) && this.raise(D2.ThisParamMayNotBeOptional, { at: e25 }), e25.optional = true), this.match(14) ? e25.typeAnnotation = this.flowParseTypeAnnotation() : this.isThisParam(e25) && this.raise(D2.ThisParamAnnotationRequired, { at: e25 }), this.match(29) && this.isThisParam(e25) && this.raise(D2.ThisParamNoDefault, { at: e25 }), this.resetEndLocation(e25), e25;
          }
          parseMaybeDefault(e25, s2) {
            let i2 = super.parseMaybeDefault(e25, s2);
            return i2.type === "AssignmentPattern" && i2.typeAnnotation && i2.right.start < i2.typeAnnotation.start && this.raise(D2.TypeBeforeInitializer, { at: i2.typeAnnotation }), i2;
          }
          shouldParseDefaultImport(e25) {
            return xs(e25) ? Gr2(this.state.type) : super.shouldParseDefaultImport(e25);
          }
          checkImportReflection(e25) {
            super.checkImportReflection(e25), e25.module && e25.importKind !== "value" && this.raise(D2.ImportReflectionHasImportType, { at: e25.specifiers[0].loc.start });
          }
          parseImportSpecifierLocal(e25, s2, i2) {
            s2.local = xs(e25) ? this.flowParseRestrictedIdentifier(true, true) : this.parseIdentifier(), e25.specifiers.push(this.finishImportSpecifier(s2, i2));
          }
          maybeParseDefaultImportSpecifier(e25) {
            e25.importKind = "value";
            let s2 = null;
            if (this.match(87) ? s2 = "typeof" : this.isContextual(128) && (s2 = "type"), s2) {
              let i2 = this.lookahead(), { type: a2 } = i2;
              s2 === "type" && a2 === 55 && this.unexpected(null, i2.type), (Gr2(a2) || a2 === 5 || a2 === 55) && (this.next(), e25.importKind = s2);
            }
            return super.maybeParseDefaultImportSpecifier(e25);
          }
          parseImportSpecifier(e25, s2, i2, a2, n2) {
            let o2 = e25.imported, c2 = null;
            o2.type === "Identifier" && (o2.name === "type" ? c2 = "type" : o2.name === "typeof" && (c2 = "typeof"));
            let p2 = false;
            if (this.isContextual(93) && !this.isLookaheadContextual("as")) {
              let x2 = this.parseIdentifier(true);
              c2 !== null && !ye2(this.state.type) ? (e25.imported = x2, e25.importKind = c2, e25.local = Te2(x2)) : (e25.imported = o2, e25.importKind = null, e25.local = this.parseIdentifier());
            } else {
              if (c2 !== null && ye2(this.state.type))
                e25.imported = this.parseIdentifier(true), e25.importKind = c2;
              else {
                if (s2)
                  throw this.raise(u2.ImportBindingIsString, { at: e25, importName: o2.value });
                e25.imported = o2, e25.importKind = null;
              }
              this.eatContextual(93) ? e25.local = this.parseIdentifier() : (p2 = true, e25.local = Te2(e25.imported));
            }
            let m2 = xs(e25);
            return i2 && m2 && this.raise(D2.ImportTypeShorthandOnlyInPureImport, { at: e25 }), (i2 || m2) && this.checkReservedType(e25.local.name, e25.local.loc.start, true), p2 && !i2 && !m2 && this.checkReservedWord(e25.local.name, e25.loc.start, true, true), this.finishImportSpecifier(e25, "ImportSpecifier");
          }
          parseBindingAtom() {
            switch (this.state.type) {
              case 78:
                return this.parseIdentifier(true);
              default:
                return super.parseBindingAtom();
            }
          }
          parseFunctionParams(e25, s2) {
            let i2 = e25.kind;
            i2 !== "get" && i2 !== "set" && this.match(47) && (e25.typeParameters = this.flowParseTypeParameterDeclaration()), super.parseFunctionParams(e25, s2);
          }
          parseVarId(e25, s2) {
            super.parseVarId(e25, s2), this.match(14) && (e25.id.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(e25.id));
          }
          parseAsyncArrowFromCallExpression(e25, s2) {
            if (this.match(14)) {
              let i2 = this.state.noAnonFunctionType;
              this.state.noAnonFunctionType = true, e25.returnType = this.flowParseTypeAnnotation(), this.state.noAnonFunctionType = i2;
            }
            return super.parseAsyncArrowFromCallExpression(e25, s2);
          }
          shouldParseAsyncArrow() {
            return this.match(14) || super.shouldParseAsyncArrow();
          }
          parseMaybeAssign(e25, s2) {
            var i2;
            let a2 = null, n2;
            if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
              if (a2 = this.state.clone(), n2 = this.tryParse(() => super.parseMaybeAssign(e25, s2), a2), !n2.error)
                return n2.node;
              let { context: p2 } = this.state, m2 = p2[p2.length - 1];
              (m2 === $2.j_oTag || m2 === $2.j_expr) && p2.pop();
            }
            if ((i2 = n2) != null && i2.error || this.match(47)) {
              var o2, c2;
              a2 = a2 || this.state.clone();
              let p2, m2 = this.tryParse((A2) => {
                var b2;
                p2 = this.flowParseTypeParameterDeclaration();
                let O2 = this.forwardNoArrowParamsConversionAt(p2, () => {
                  let Y2 = super.parseMaybeAssign(e25, s2);
                  return this.resetStartLocationFromNode(Y2, p2), Y2;
                });
                (b2 = O2.extra) != null && b2.parenthesized && A2();
                let R2 = this.maybeUnwrapTypeCastExpression(O2);
                return R2.type !== "ArrowFunctionExpression" && A2(), R2.typeParameters = p2, this.resetStartLocationFromNode(R2, p2), O2;
              }, a2), x2 = null;
              if (m2.node && this.maybeUnwrapTypeCastExpression(m2.node).type === "ArrowFunctionExpression") {
                if (!m2.error && !m2.aborted)
                  return m2.node.async && this.raise(D2.UnexpectedTypeParameterBeforeAsyncArrowFunction, { at: p2 }), m2.node;
                x2 = m2.node;
              }
              if ((o2 = n2) != null && o2.node)
                return this.state = n2.failState, n2.node;
              if (x2)
                return this.state = m2.failState, x2;
              throw (c2 = n2) != null && c2.thrown ? n2.error : m2.thrown ? m2.error : this.raise(D2.UnexpectedTokenAfterTypeParameter, { at: p2 });
            }
            return super.parseMaybeAssign(e25, s2);
          }
          parseArrow(e25) {
            if (this.match(14)) {
              let s2 = this.tryParse(() => {
                let i2 = this.state.noAnonFunctionType;
                this.state.noAnonFunctionType = true;
                let a2 = this.startNode();
                return [a2.typeAnnotation, e25.predicate] = this.flowParseTypeAndPredicateInitialiser(), this.state.noAnonFunctionType = i2, this.canInsertSemicolon() && this.unexpected(), this.match(19) || this.unexpected(), a2;
              });
              if (s2.thrown)
                return null;
              s2.error && (this.state = s2.failState), e25.returnType = s2.node.typeAnnotation ? this.finishNode(s2.node, "TypeAnnotation") : null;
            }
            return super.parseArrow(e25);
          }
          shouldParseArrow(e25) {
            return this.match(14) || super.shouldParseArrow(e25);
          }
          setArrowFunctionParameters(e25, s2) {
            this.state.noArrowParamsConversionAt.indexOf(e25.start) !== -1 ? e25.params = s2 : super.setArrowFunctionParameters(e25, s2);
          }
          checkParams(e25, s2, i2) {
            let a2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
            if (!(i2 && this.state.noArrowParamsConversionAt.indexOf(e25.start) !== -1)) {
              for (let n2 = 0; n2 < e25.params.length; n2++)
                this.isThisParam(e25.params[n2]) && n2 > 0 && this.raise(D2.ThisParamMustBeFirst, { at: e25.params[n2] });
              return super.checkParams(e25, s2, i2, a2);
            }
          }
          parseParenAndDistinguishExpression(e25) {
            return super.parseParenAndDistinguishExpression(e25 && this.state.noArrowAt.indexOf(this.state.start) === -1);
          }
          parseSubscripts(e25, s2, i2) {
            if (e25.type === "Identifier" && e25.name === "async" && this.state.noArrowAt.indexOf(s2.index) !== -1) {
              this.next();
              let a2 = this.startNodeAt(s2);
              a2.callee = e25, a2.arguments = super.parseCallExpressionArguments(11, false), e25 = this.finishNode(a2, "CallExpression");
            } else if (e25.type === "Identifier" && e25.name === "async" && this.match(47)) {
              let a2 = this.state.clone(), n2 = this.tryParse((c2) => this.parseAsyncArrowWithTypeParameters(s2) || c2(), a2);
              if (!n2.error && !n2.aborted)
                return n2.node;
              let o2 = this.tryParse(() => super.parseSubscripts(e25, s2, i2), a2);
              if (o2.node && !o2.error)
                return o2.node;
              if (n2.node)
                return this.state = n2.failState, n2.node;
              if (o2.node)
                return this.state = o2.failState, o2.node;
              throw n2.error || o2.error;
            }
            return super.parseSubscripts(e25, s2, i2);
          }
          parseSubscript(e25, s2, i2, a2) {
            if (this.match(18) && this.isLookaheadToken_lt()) {
              if (a2.optionalChainMember = true, i2)
                return a2.stop = true, e25;
              this.next();
              let n2 = this.startNodeAt(s2);
              return n2.callee = e25, n2.typeArguments = this.flowParseTypeParameterInstantiation(), this.expect(10), n2.arguments = this.parseCallExpressionArguments(11, false), n2.optional = true, this.finishCallExpression(n2, true);
            } else if (!i2 && this.shouldParseTypes() && this.match(47)) {
              let n2 = this.startNodeAt(s2);
              n2.callee = e25;
              let o2 = this.tryParse(() => (n2.typeArguments = this.flowParseTypeParameterInstantiationCallOrNew(), this.expect(10), n2.arguments = super.parseCallExpressionArguments(11, false), a2.optionalChainMember && (n2.optional = false), this.finishCallExpression(n2, a2.optionalChainMember)));
              if (o2.node)
                return o2.error && (this.state = o2.failState), o2.node;
            }
            return super.parseSubscript(e25, s2, i2, a2);
          }
          parseNewCallee(e25) {
            super.parseNewCallee(e25);
            let s2 = null;
            this.shouldParseTypes() && this.match(47) && (s2 = this.tryParse(() => this.flowParseTypeParameterInstantiationCallOrNew()).node), e25.typeArguments = s2;
          }
          parseAsyncArrowWithTypeParameters(e25) {
            let s2 = this.startNodeAt(e25);
            if (this.parseFunctionParams(s2), !!this.parseArrow(s2))
              return super.parseArrowExpression(s2, void 0, true);
          }
          readToken_mult_modulo(e25) {
            let s2 = this.input.charCodeAt(this.state.pos + 1);
            if (e25 === 42 && s2 === 47 && this.state.hasFlowComment) {
              this.state.hasFlowComment = false, this.state.pos += 2, this.nextToken();
              return;
            }
            super.readToken_mult_modulo(e25);
          }
          readToken_pipe_amp(e25) {
            let s2 = this.input.charCodeAt(this.state.pos + 1);
            if (e25 === 124 && s2 === 125) {
              this.finishOp(9, 2);
              return;
            }
            super.readToken_pipe_amp(e25);
          }
          parseTopLevel(e25, s2) {
            let i2 = super.parseTopLevel(e25, s2);
            return this.state.hasFlowComment && this.raise(D2.UnterminatedFlowComment, { at: this.state.curPosition() }), i2;
          }
          skipBlockComment() {
            if (this.hasPlugin("flowComments") && this.skipFlowComment()) {
              if (this.state.hasFlowComment)
                throw this.raise(D2.NestedFlowComment, { at: this.state.startLoc });
              this.hasFlowCommentCompletion();
              let e25 = this.skipFlowComment();
              e25 && (this.state.pos += e25, this.state.hasFlowComment = true);
              return;
            }
            return super.skipBlockComment(this.state.hasFlowComment ? "*-/" : "*/");
          }
          skipFlowComment() {
            let { pos: e25 } = this.state, s2 = 2;
            for (; [32, 9].includes(this.input.charCodeAt(e25 + s2)); )
              s2++;
            let i2 = this.input.charCodeAt(s2 + e25), a2 = this.input.charCodeAt(s2 + e25 + 1);
            return i2 === 58 && a2 === 58 ? s2 + 2 : this.input.slice(s2 + e25, s2 + e25 + 12) === "flow-include" ? s2 + 12 : i2 === 58 && a2 !== 58 ? s2 : false;
          }
          hasFlowCommentCompletion() {
            if (this.input.indexOf("*/", this.state.pos) === -1)
              throw this.raise(u2.UnterminatedComment, { at: this.state.curPosition() });
          }
          flowEnumErrorBooleanMemberNotInitialized(e25, s2) {
            let { enumName: i2, memberName: a2 } = s2;
            this.raise(D2.EnumBooleanMemberNotInitialized, { at: e25, memberName: a2, enumName: i2 });
          }
          flowEnumErrorInvalidMemberInitializer(e25, s2) {
            return this.raise(s2.explicitType ? s2.explicitType === "symbol" ? D2.EnumInvalidMemberInitializerSymbolType : D2.EnumInvalidMemberInitializerPrimaryType : D2.EnumInvalidMemberInitializerUnknownType, Object.assign({ at: e25 }, s2));
          }
          flowEnumErrorNumberMemberNotInitialized(e25, s2) {
            let { enumName: i2, memberName: a2 } = s2;
            this.raise(D2.EnumNumberMemberNotInitialized, { at: e25, enumName: i2, memberName: a2 });
          }
          flowEnumErrorStringMemberInconsistentlyInitailized(e25, s2) {
            let { enumName: i2 } = s2;
            this.raise(D2.EnumStringMemberInconsistentlyInitailized, { at: e25, enumName: i2 });
          }
          flowEnumMemberInit() {
            let e25 = this.state.startLoc, s2 = () => this.match(12) || this.match(8);
            switch (this.state.type) {
              case 132: {
                let i2 = this.parseNumericLiteral(this.state.value);
                return s2() ? { type: "number", loc: i2.loc.start, value: i2 } : { type: "invalid", loc: e25 };
              }
              case 131: {
                let i2 = this.parseStringLiteral(this.state.value);
                return s2() ? { type: "string", loc: i2.loc.start, value: i2 } : { type: "invalid", loc: e25 };
              }
              case 85:
              case 86: {
                let i2 = this.parseBooleanLiteral(this.match(85));
                return s2() ? { type: "boolean", loc: i2.loc.start, value: i2 } : { type: "invalid", loc: e25 };
              }
              default:
                return { type: "invalid", loc: e25 };
            }
          }
          flowEnumMemberRaw() {
            let e25 = this.state.startLoc, s2 = this.parseIdentifier(true), i2 = this.eat(29) ? this.flowEnumMemberInit() : { type: "none", loc: e25 };
            return { id: s2, init: i2 };
          }
          flowEnumCheckExplicitTypeMismatch(e25, s2, i2) {
            let { explicitType: a2 } = s2;
            a2 !== null && a2 !== i2 && this.flowEnumErrorInvalidMemberInitializer(e25, s2);
          }
          flowEnumMembers(e25) {
            let { enumName: s2, explicitType: i2 } = e25, a2 = new Set(), n2 = { booleanMembers: [], numberMembers: [], stringMembers: [], defaultedMembers: [] }, o2 = false;
            for (; !this.match(8); ) {
              if (this.eat(21)) {
                o2 = true;
                break;
              }
              let c2 = this.startNode(), { id: p2, init: m2 } = this.flowEnumMemberRaw(), x2 = p2.name;
              if (x2 === "")
                continue;
              /^[a-z]/.test(x2) && this.raise(D2.EnumInvalidMemberName, { at: p2, memberName: x2, suggestion: x2[0].toUpperCase() + x2.slice(1), enumName: s2 }), a2.has(x2) && this.raise(D2.EnumDuplicateMemberName, { at: p2, memberName: x2, enumName: s2 }), a2.add(x2);
              let A2 = { enumName: s2, explicitType: i2, memberName: x2 };
              switch (c2.id = p2, m2.type) {
                case "boolean": {
                  this.flowEnumCheckExplicitTypeMismatch(m2.loc, A2, "boolean"), c2.init = m2.value, n2.booleanMembers.push(this.finishNode(c2, "EnumBooleanMember"));
                  break;
                }
                case "number": {
                  this.flowEnumCheckExplicitTypeMismatch(m2.loc, A2, "number"), c2.init = m2.value, n2.numberMembers.push(this.finishNode(c2, "EnumNumberMember"));
                  break;
                }
                case "string": {
                  this.flowEnumCheckExplicitTypeMismatch(m2.loc, A2, "string"), c2.init = m2.value, n2.stringMembers.push(this.finishNode(c2, "EnumStringMember"));
                  break;
                }
                case "invalid":
                  throw this.flowEnumErrorInvalidMemberInitializer(m2.loc, A2);
                case "none":
                  switch (i2) {
                    case "boolean":
                      this.flowEnumErrorBooleanMemberNotInitialized(m2.loc, A2);
                      break;
                    case "number":
                      this.flowEnumErrorNumberMemberNotInitialized(m2.loc, A2);
                      break;
                    default:
                      n2.defaultedMembers.push(this.finishNode(c2, "EnumDefaultedMember"));
                  }
              }
              this.match(8) || this.expect(12);
            }
            return { members: n2, hasUnknownMembers: o2 };
          }
          flowEnumStringMembers(e25, s2, i2) {
            let { enumName: a2 } = i2;
            if (e25.length === 0)
              return s2;
            if (s2.length === 0)
              return e25;
            if (s2.length > e25.length) {
              for (let n2 of e25)
                this.flowEnumErrorStringMemberInconsistentlyInitailized(n2, { enumName: a2 });
              return s2;
            } else {
              for (let n2 of s2)
                this.flowEnumErrorStringMemberInconsistentlyInitailized(n2, { enumName: a2 });
              return e25;
            }
          }
          flowEnumParseExplicitType(e25) {
            let { enumName: s2 } = e25;
            if (!this.eatContextual(101))
              return null;
            if (!z2(this.state.type))
              throw this.raise(D2.EnumInvalidExplicitTypeUnknownSupplied, { at: this.state.startLoc, enumName: s2 });
            let { value: i2 } = this.state;
            return this.next(), i2 !== "boolean" && i2 !== "number" && i2 !== "string" && i2 !== "symbol" && this.raise(D2.EnumInvalidExplicitType, { at: this.state.startLoc, enumName: s2, invalidEnumType: i2 }), i2;
          }
          flowEnumBody(e25, s2) {
            let i2 = s2.name, a2 = s2.loc.start, n2 = this.flowEnumParseExplicitType({ enumName: i2 });
            this.expect(5);
            let { members: o2, hasUnknownMembers: c2 } = this.flowEnumMembers({ enumName: i2, explicitType: n2 });
            switch (e25.hasUnknownMembers = c2, n2) {
              case "boolean":
                return e25.explicitType = true, e25.members = o2.booleanMembers, this.expect(8), this.finishNode(e25, "EnumBooleanBody");
              case "number":
                return e25.explicitType = true, e25.members = o2.numberMembers, this.expect(8), this.finishNode(e25, "EnumNumberBody");
              case "string":
                return e25.explicitType = true, e25.members = this.flowEnumStringMembers(o2.stringMembers, o2.defaultedMembers, { enumName: i2 }), this.expect(8), this.finishNode(e25, "EnumStringBody");
              case "symbol":
                return e25.members = o2.defaultedMembers, this.expect(8), this.finishNode(e25, "EnumSymbolBody");
              default: {
                let p2 = () => (e25.members = [], this.expect(8), this.finishNode(e25, "EnumStringBody"));
                e25.explicitType = false;
                let m2 = o2.booleanMembers.length, x2 = o2.numberMembers.length, A2 = o2.stringMembers.length, b2 = o2.defaultedMembers.length;
                if (!m2 && !x2 && !A2 && !b2)
                  return p2();
                if (!m2 && !x2)
                  return e25.members = this.flowEnumStringMembers(o2.stringMembers, o2.defaultedMembers, { enumName: i2 }), this.expect(8), this.finishNode(e25, "EnumStringBody");
                if (!x2 && !A2 && m2 >= b2) {
                  for (let O2 of o2.defaultedMembers)
                    this.flowEnumErrorBooleanMemberNotInitialized(O2.loc.start, { enumName: i2, memberName: O2.id.name });
                  return e25.members = o2.booleanMembers, this.expect(8), this.finishNode(e25, "EnumBooleanBody");
                } else if (!m2 && !A2 && x2 >= b2) {
                  for (let O2 of o2.defaultedMembers)
                    this.flowEnumErrorNumberMemberNotInitialized(O2.loc.start, { enumName: i2, memberName: O2.id.name });
                  return e25.members = o2.numberMembers, this.expect(8), this.finishNode(e25, "EnumNumberBody");
                } else
                  return this.raise(D2.EnumInconsistentMemberValues, { at: a2, enumName: i2 }), p2();
              }
            }
          }
          flowParseEnumDeclaration(e25) {
            let s2 = this.parseIdentifier();
            return e25.id = s2, e25.body = this.flowEnumBody(this.startNode(), s2), this.finishNode(e25, "EnumDeclaration");
          }
          isLookaheadToken_lt() {
            let e25 = this.nextTokenStart();
            if (this.input.charCodeAt(e25) === 60) {
              let s2 = this.input.charCodeAt(e25 + 1);
              return s2 !== 60 && s2 !== 61;
            }
            return false;
          }
          maybeUnwrapTypeCastExpression(e25) {
            return e25.type === "TypeCastExpression" ? e25.expression : e25;
          }
        }, eh2 = { __proto__: null, quot: '"', amp: "&", apos: "'", lt: "<", gt: ">", nbsp: "\xA0", iexcl: "\xA1", cent: "\xA2", pound: "\xA3", curren: "\xA4", yen: "\xA5", brvbar: "\xA6", sect: "\xA7", uml: "\xA8", copy: "\xA9", ordf: "\xAA", laquo: "\xAB", not: "\xAC", shy: "\xAD", reg: "\xAE", macr: "\xAF", deg: "\xB0", plusmn: "\xB1", sup2: "\xB2", sup3: "\xB3", acute: "\xB4", micro: "\xB5", para: "\xB6", middot: "\xB7", cedil: "\xB8", sup1: "\xB9", ordm: "\xBA", raquo: "\xBB", frac14: "\xBC", frac12: "\xBD", frac34: "\xBE", iquest: "\xBF", Agrave: "\xC0", Aacute: "\xC1", Acirc: "\xC2", Atilde: "\xC3", Auml: "\xC4", Aring: "\xC5", AElig: "\xC6", Ccedil: "\xC7", Egrave: "\xC8", Eacute: "\xC9", Ecirc: "\xCA", Euml: "\xCB", Igrave: "\xCC", Iacute: "\xCD", Icirc: "\xCE", Iuml: "\xCF", ETH: "\xD0", Ntilde: "\xD1", Ograve: "\xD2", Oacute: "\xD3", Ocirc: "\xD4", Otilde: "\xD5", Ouml: "\xD6", times: "\xD7", Oslash: "\xD8", Ugrave: "\xD9", Uacute: "\xDA", Ucirc: "\xDB", Uuml: "\xDC", Yacute: "\xDD", THORN: "\xDE", szlig: "\xDF", agrave: "\xE0", aacute: "\xE1", acirc: "\xE2", atilde: "\xE3", auml: "\xE4", aring: "\xE5", aelig: "\xE6", ccedil: "\xE7", egrave: "\xE8", eacute: "\xE9", ecirc: "\xEA", euml: "\xEB", igrave: "\xEC", iacute: "\xED", icirc: "\xEE", iuml: "\xEF", eth: "\xF0", ntilde: "\xF1", ograve: "\xF2", oacute: "\xF3", ocirc: "\xF4", otilde: "\xF5", ouml: "\xF6", divide: "\xF7", oslash: "\xF8", ugrave: "\xF9", uacute: "\xFA", ucirc: "\xFB", uuml: "\xFC", yacute: "\xFD", thorn: "\xFE", yuml: "\xFF", OElig: "\u0152", oelig: "\u0153", Scaron: "\u0160", scaron: "\u0161", Yuml: "\u0178", fnof: "\u0192", circ: "\u02C6", tilde: "\u02DC", Alpha: "\u0391", Beta: "\u0392", Gamma: "\u0393", Delta: "\u0394", Epsilon: "\u0395", Zeta: "\u0396", Eta: "\u0397", Theta: "\u0398", Iota: "\u0399", Kappa: "\u039A", Lambda: "\u039B", Mu: "\u039C", Nu: "\u039D", Xi: "\u039E", Omicron: "\u039F", Pi: "\u03A0", Rho: "\u03A1", Sigma: "\u03A3", Tau: "\u03A4", Upsilon: "\u03A5", Phi: "\u03A6", Chi: "\u03A7", Psi: "\u03A8", Omega: "\u03A9", alpha: "\u03B1", beta: "\u03B2", gamma: "\u03B3", delta: "\u03B4", epsilon: "\u03B5", zeta: "\u03B6", eta: "\u03B7", theta: "\u03B8", iota: "\u03B9", kappa: "\u03BA", lambda: "\u03BB", mu: "\u03BC", nu: "\u03BD", xi: "\u03BE", omicron: "\u03BF", pi: "\u03C0", rho: "\u03C1", sigmaf: "\u03C2", sigma: "\u03C3", tau: "\u03C4", upsilon: "\u03C5", phi: "\u03C6", chi: "\u03C7", psi: "\u03C8", omega: "\u03C9", thetasym: "\u03D1", upsih: "\u03D2", piv: "\u03D6", ensp: "\u2002", emsp: "\u2003", thinsp: "\u2009", zwnj: "\u200C", zwj: "\u200D", lrm: "\u200E", rlm: "\u200F", ndash: "\u2013", mdash: "\u2014", lsquo: "\u2018", rsquo: "\u2019", sbquo: "\u201A", ldquo: "\u201C", rdquo: "\u201D", bdquo: "\u201E", dagger: "\u2020", Dagger: "\u2021", bull: "\u2022", hellip: "\u2026", permil: "\u2030", prime: "\u2032", Prime: "\u2033", lsaquo: "\u2039", rsaquo: "\u203A", oline: "\u203E", frasl: "\u2044", euro: "\u20AC", image: "\u2111", weierp: "\u2118", real: "\u211C", trade: "\u2122", alefsym: "\u2135", larr: "\u2190", uarr: "\u2191", rarr: "\u2192", darr: "\u2193", harr: "\u2194", crarr: "\u21B5", lArr: "\u21D0", uArr: "\u21D1", rArr: "\u21D2", dArr: "\u21D3", hArr: "\u21D4", forall: "\u2200", part: "\u2202", exist: "\u2203", empty: "\u2205", nabla: "\u2207", isin: "\u2208", notin: "\u2209", ni: "\u220B", prod: "\u220F", sum: "\u2211", minus: "\u2212", lowast: "\u2217", radic: "\u221A", prop: "\u221D", infin: "\u221E", ang: "\u2220", and: "\u2227", or: "\u2228", cap: "\u2229", cup: "\u222A", int: "\u222B", there4: "\u2234", sim: "\u223C", cong: "\u2245", asymp: "\u2248", ne: "\u2260", equiv: "\u2261", le: "\u2264", ge: "\u2265", sub: "\u2282", sup: "\u2283", nsub: "\u2284", sube: "\u2286", supe: "\u2287", oplus: "\u2295", otimes: "\u2297", perp: "\u22A5", sdot: "\u22C5", lceil: "\u2308", rceil: "\u2309", lfloor: "\u230A", rfloor: "\u230B", lang: "\u2329", rang: "\u232A", loz: "\u25CA", spades: "\u2660", clubs: "\u2663", hearts: "\u2665", diams: "\u2666" }, Fe2 = _2`jsx`({ AttributeIsEmpty: "JSX attributes must only be assigned a non-empty expression.", MissingClosingTagElement: (t2) => {
          let { openingTagName: r2 } = t2;
          return `Expected corresponding JSX closing tag for <${r2}>.`;
        }, MissingClosingTagFragment: "Expected corresponding JSX closing tag for <>.", UnexpectedSequenceExpression: "Sequence expressions cannot be directly nested inside JSX. Did you mean to wrap it in parentheses (...)?", UnexpectedToken: (t2) => {
          let { unexpected: r2, HTMLEntity: e25 } = t2;
          return `Unexpected token \`${r2}\`. Did you mean \`${e25}\` or \`{'${r2}'}\`?`;
        }, UnsupportedJsxValue: "JSX value should be either an expression or a quoted JSX text.", UnterminatedJsxContent: "Unterminated JSX contents.", UnwrappedAdjacentJSXElements: "Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?" });
        function we2(t2) {
          return t2 ? t2.type === "JSXOpeningFragment" || t2.type === "JSXClosingFragment" : false;
        }
        function ze2(t2) {
          if (t2.type === "JSXIdentifier")
            return t2.name;
          if (t2.type === "JSXNamespacedName")
            return t2.namespace.name + ":" + t2.name.name;
          if (t2.type === "JSXMemberExpression")
            return ze2(t2.object) + "." + ze2(t2.property);
          throw new Error("Node had unexpected type: " + t2.type);
        }
        var th2 = (t2) => class extends t2 {
          jsxReadToken() {
            let e25 = "", s2 = this.state.pos;
            for (; ; ) {
              if (this.state.pos >= this.length)
                throw this.raise(Fe2.UnterminatedJsxContent, { at: this.state.startLoc });
              let i2 = this.input.charCodeAt(this.state.pos);
              switch (i2) {
                case 60:
                case 123:
                  return this.state.pos === this.state.start ? i2 === 60 && this.state.canStartJSXElement ? (++this.state.pos, this.finishToken(140)) : super.getTokenFromCode(i2) : (e25 += this.input.slice(s2, this.state.pos), this.finishToken(139, e25));
                case 38:
                  e25 += this.input.slice(s2, this.state.pos), e25 += this.jsxReadEntity(), s2 = this.state.pos;
                  break;
                case 62:
                case 125:
                default:
                  et2(i2) ? (e25 += this.input.slice(s2, this.state.pos), e25 += this.jsxReadNewLine(true), s2 = this.state.pos) : ++this.state.pos;
              }
            }
          }
          jsxReadNewLine(e25) {
            let s2 = this.input.charCodeAt(this.state.pos), i2;
            return ++this.state.pos, s2 === 13 && this.input.charCodeAt(this.state.pos) === 10 ? (++this.state.pos, i2 = e25 ? `
` : `\r
`) : i2 = String.fromCharCode(s2), ++this.state.curLine, this.state.lineStart = this.state.pos, i2;
          }
          jsxReadString(e25) {
            let s2 = "", i2 = ++this.state.pos;
            for (; ; ) {
              if (this.state.pos >= this.length)
                throw this.raise(u2.UnterminatedString, { at: this.state.startLoc });
              let a2 = this.input.charCodeAt(this.state.pos);
              if (a2 === e25)
                break;
              a2 === 38 ? (s2 += this.input.slice(i2, this.state.pos), s2 += this.jsxReadEntity(), i2 = this.state.pos) : et2(a2) ? (s2 += this.input.slice(i2, this.state.pos), s2 += this.jsxReadNewLine(false), i2 = this.state.pos) : ++this.state.pos;
            }
            return s2 += this.input.slice(i2, this.state.pos++), this.finishToken(131, s2);
          }
          jsxReadEntity() {
            let e25 = ++this.state.pos;
            if (this.codePointAtPos(this.state.pos) === 35) {
              ++this.state.pos;
              let s2 = 10;
              this.codePointAtPos(this.state.pos) === 120 && (s2 = 16, ++this.state.pos);
              let i2 = this.readInt(s2, void 0, false, "bail");
              if (i2 !== null && this.codePointAtPos(this.state.pos) === 59)
                return ++this.state.pos, String.fromCodePoint(i2);
            } else {
              let s2 = 0, i2 = false;
              for (; s2++ < 10 && this.state.pos < this.length && !(i2 = this.codePointAtPos(this.state.pos) == 59); )
                ++this.state.pos;
              if (i2) {
                let a2 = this.input.slice(e25, this.state.pos), n2 = eh2[a2];
                if (++this.state.pos, n2)
                  return n2;
              }
            }
            return this.state.pos = e25, "&";
          }
          jsxReadWord() {
            let e25, s2 = this.state.pos;
            do
              e25 = this.input.charCodeAt(++this.state.pos);
            while (Re2(e25) || e25 === 45);
            return this.finishToken(138, this.input.slice(s2, this.state.pos));
          }
          jsxParseIdentifier() {
            let e25 = this.startNode();
            return this.match(138) ? e25.name = this.state.value : Yt2(this.state.type) ? e25.name = Ee2(this.state.type) : this.unexpected(), this.next(), this.finishNode(e25, "JSXIdentifier");
          }
          jsxParseNamespacedName() {
            let e25 = this.state.startLoc, s2 = this.jsxParseIdentifier();
            if (!this.eat(14))
              return s2;
            let i2 = this.startNodeAt(e25);
            return i2.namespace = s2, i2.name = this.jsxParseIdentifier(), this.finishNode(i2, "JSXNamespacedName");
          }
          jsxParseElementName() {
            let e25 = this.state.startLoc, s2 = this.jsxParseNamespacedName();
            if (s2.type === "JSXNamespacedName")
              return s2;
            for (; this.eat(16); ) {
              let i2 = this.startNodeAt(e25);
              i2.object = s2, i2.property = this.jsxParseIdentifier(), s2 = this.finishNode(i2, "JSXMemberExpression");
            }
            return s2;
          }
          jsxParseAttributeValue() {
            let e25;
            switch (this.state.type) {
              case 5:
                return e25 = this.startNode(), this.setContext($2.brace), this.next(), e25 = this.jsxParseExpressionContainer(e25, $2.j_oTag), e25.expression.type === "JSXEmptyExpression" && this.raise(Fe2.AttributeIsEmpty, { at: e25 }), e25;
              case 140:
              case 131:
                return this.parseExprAtom();
              default:
                throw this.raise(Fe2.UnsupportedJsxValue, { at: this.state.startLoc });
            }
          }
          jsxParseEmptyExpression() {
            let e25 = this.startNodeAt(this.state.lastTokEndLoc);
            return this.finishNodeAt(e25, "JSXEmptyExpression", this.state.startLoc);
          }
          jsxParseSpreadChild(e25) {
            return this.next(), e25.expression = this.parseExpression(), this.setContext($2.j_expr), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e25, "JSXSpreadChild");
          }
          jsxParseExpressionContainer(e25, s2) {
            if (this.match(8))
              e25.expression = this.jsxParseEmptyExpression();
            else {
              let i2 = this.parseExpression();
              e25.expression = i2;
            }
            return this.setContext(s2), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e25, "JSXExpressionContainer");
          }
          jsxParseAttribute() {
            let e25 = this.startNode();
            return this.match(5) ? (this.setContext($2.brace), this.next(), this.expect(21), e25.argument = this.parseMaybeAssignAllowIn(), this.setContext($2.j_oTag), this.state.canStartJSXElement = true, this.expect(8), this.finishNode(e25, "JSXSpreadAttribute")) : (e25.name = this.jsxParseNamespacedName(), e25.value = this.eat(29) ? this.jsxParseAttributeValue() : null, this.finishNode(e25, "JSXAttribute"));
          }
          jsxParseOpeningElementAt(e25) {
            let s2 = this.startNodeAt(e25);
            return this.eat(141) ? this.finishNode(s2, "JSXOpeningFragment") : (s2.name = this.jsxParseElementName(), this.jsxParseOpeningElementAfterName(s2));
          }
          jsxParseOpeningElementAfterName(e25) {
            let s2 = [];
            for (; !this.match(56) && !this.match(141); )
              s2.push(this.jsxParseAttribute());
            return e25.attributes = s2, e25.selfClosing = this.eat(56), this.expect(141), this.finishNode(e25, "JSXOpeningElement");
          }
          jsxParseClosingElementAt(e25) {
            let s2 = this.startNodeAt(e25);
            return this.eat(141) ? this.finishNode(s2, "JSXClosingFragment") : (s2.name = this.jsxParseElementName(), this.expect(141), this.finishNode(s2, "JSXClosingElement"));
          }
          jsxParseElementAt(e25) {
            let s2 = this.startNodeAt(e25), i2 = [], a2 = this.jsxParseOpeningElementAt(e25), n2 = null;
            if (!a2.selfClosing) {
              e:
                for (; ; )
                  switch (this.state.type) {
                    case 140:
                      if (e25 = this.state.startLoc, this.next(), this.eat(56)) {
                        n2 = this.jsxParseClosingElementAt(e25);
                        break e;
                      }
                      i2.push(this.jsxParseElementAt(e25));
                      break;
                    case 139:
                      i2.push(this.parseExprAtom());
                      break;
                    case 5: {
                      let o2 = this.startNode();
                      this.setContext($2.brace), this.next(), this.match(21) ? i2.push(this.jsxParseSpreadChild(o2)) : i2.push(this.jsxParseExpressionContainer(o2, $2.j_expr));
                      break;
                    }
                    default:
                      throw this.unexpected();
                  }
              we2(a2) && !we2(n2) && n2 !== null ? this.raise(Fe2.MissingClosingTagFragment, { at: n2 }) : !we2(a2) && we2(n2) ? this.raise(Fe2.MissingClosingTagElement, { at: n2, openingTagName: ze2(a2.name) }) : !we2(a2) && !we2(n2) && ze2(n2.name) !== ze2(a2.name) && this.raise(Fe2.MissingClosingTagElement, { at: n2, openingTagName: ze2(a2.name) });
            }
            if (we2(a2) ? (s2.openingFragment = a2, s2.closingFragment = n2) : (s2.openingElement = a2, s2.closingElement = n2), s2.children = i2, this.match(47))
              throw this.raise(Fe2.UnwrappedAdjacentJSXElements, { at: this.state.startLoc });
            return we2(a2) ? this.finishNode(s2, "JSXFragment") : this.finishNode(s2, "JSXElement");
          }
          jsxParseElement() {
            let e25 = this.state.startLoc;
            return this.next(), this.jsxParseElementAt(e25);
          }
          setContext(e25) {
            let { context: s2 } = this.state;
            s2[s2.length - 1] = e25;
          }
          parseExprAtom(e25) {
            return this.match(139) ? this.parseLiteral(this.state.value, "JSXText") : this.match(140) ? this.jsxParseElement() : this.match(47) && this.input.charCodeAt(this.state.pos) !== 33 ? (this.replaceToken(140), this.jsxParseElement()) : super.parseExprAtom(e25);
          }
          skipSpace() {
            this.curContext().preserveSpace || super.skipSpace();
          }
          getTokenFromCode(e25) {
            let s2 = this.curContext();
            if (s2 === $2.j_expr)
              return this.jsxReadToken();
            if (s2 === $2.j_oTag || s2 === $2.j_cTag) {
              if (ge2(e25))
                return this.jsxReadWord();
              if (e25 === 62)
                return ++this.state.pos, this.finishToken(141);
              if ((e25 === 34 || e25 === 39) && s2 === $2.j_oTag)
                return this.jsxReadString(e25);
            }
            return e25 === 60 && this.state.canStartJSXElement && this.input.charCodeAt(this.state.pos + 1) !== 33 ? (++this.state.pos, this.finishToken(140)) : super.getTokenFromCode(e25);
          }
          updateContext(e25) {
            let { context: s2, type: i2 } = this.state;
            if (i2 === 56 && e25 === 140)
              s2.splice(-2, 2, $2.j_cTag), this.state.canStartJSXElement = false;
            else if (i2 === 140)
              s2.push($2.j_oTag);
            else if (i2 === 141) {
              let a2 = s2[s2.length - 1];
              a2 === $2.j_oTag && e25 === 56 || a2 === $2.j_cTag ? (s2.pop(), this.state.canStartJSXElement = s2[s2.length - 1] === $2.j_expr) : (this.setContext($2.j_expr), this.state.canStartJSXElement = true);
            } else
              this.state.canStartJSXElement = Wo2(i2);
          }
        }, sh2 = class extends us2 {
          constructor() {
            super(...arguments), this.types = new Set(), this.enums = new Set(), this.constEnums = new Set(), this.classes = new Set(), this.exportOnlyBindings = new Set();
          }
        }, rh2 = class extends cs {
          constructor() {
            super(...arguments), this.importsStack = [];
          }
          createScope(t2) {
            return this.importsStack.push(new Set()), new sh2(t2);
          }
          enter(t2) {
            t2 == Ue2 && this.importsStack.push(new Set()), super.enter(t2);
          }
          exit() {
            let t2 = super.exit();
            return t2 == Ue2 && this.importsStack.pop(), t2;
          }
          hasImport(t2, r2) {
            let e25 = this.importsStack.length;
            if (this.importsStack[e25 - 1].has(t2))
              return true;
            if (!r2 && e25 > 1) {
              for (let s2 = 0; s2 < e25 - 1; s2++)
                if (this.importsStack[s2].has(t2))
                  return true;
            }
            return false;
          }
          declareName(t2, r2, e25) {
            if (r2 & Ye2) {
              this.hasImport(t2, true) && this.parser.raise(u2.VarRedeclaration, { at: e25, identifierName: t2 }), this.importsStack[this.importsStack.length - 1].add(t2);
              return;
            }
            let s2 = this.currentScope();
            if (r2 & is2) {
              this.maybeExportDefined(s2, t2), s2.exportOnlyBindings.add(t2);
              return;
            }
            super.declareName(t2, r2, e25), r2 & ke2 && (r2 & Ae2 || (this.checkRedeclarationInScope(s2, t2, r2, e25), this.maybeExportDefined(s2, t2)), s2.types.add(t2)), r2 & ss2 && s2.enums.add(t2), r2 & rs2 && s2.constEnums.add(t2), r2 & yt2 && s2.classes.add(t2);
          }
          isRedeclaredInScope(t2, r2, e25) {
            if (t2.enums.has(r2)) {
              if (e25 & ss2) {
                let s2 = !!(e25 & rs2), i2 = t2.constEnums.has(r2);
                return s2 !== i2;
              }
              return true;
            }
            return e25 & yt2 && t2.classes.has(r2) ? t2.lexical.has(r2) ? !!(e25 & Ae2) : false : e25 & ke2 && t2.types.has(r2) ? true : super.isRedeclaredInScope(t2, r2, e25);
          }
          checkLocalExport(t2) {
            let { name: r2 } = t2;
            if (this.hasImport(r2))
              return;
            let e25 = this.scopeStack.length;
            for (let s2 = e25 - 1; s2 >= 0; s2--) {
              let i2 = this.scopeStack[s2];
              if (i2.types.has(r2) || i2.exportOnlyBindings.has(r2))
                return;
            }
            super.checkLocalExport(t2);
          }
        }, ih2 = (t2, r2) => Object.hasOwnProperty.call(t2, r2) && t2[r2];
        function ah2(t2) {
          if (t2 == null)
            throw new Error(`Unexpected ${t2} value.`);
          return t2;
        }
        function Jr2(t2) {
          if (!t2)
            throw new Error("Assert fail");
        }
        var w2 = _2`typescript`({ AbstractMethodHasImplementation: (t2) => {
          let { methodName: r2 } = t2;
          return `Method '${r2}' cannot have an implementation because it is marked abstract.`;
        }, AbstractPropertyHasInitializer: (t2) => {
          let { propertyName: r2 } = t2;
          return `Property '${r2}' cannot have an initializer because it is marked abstract.`;
        }, AccesorCannotDeclareThisParameter: "'get' and 'set' accessors cannot declare 'this' parameters.", AccesorCannotHaveTypeParameters: "An accessor cannot have type parameters.", AccessorCannotBeOptional: "An 'accessor' property cannot be declared optional.", ClassMethodHasDeclare: "Class methods cannot have the 'declare' modifier.", ClassMethodHasReadonly: "Class methods cannot have the 'readonly' modifier.", ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference: "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference.", ConstructorHasTypeParameters: "Type parameters cannot appear on a constructor declaration.", DeclareAccessor: (t2) => {
          let { kind: r2 } = t2;
          return `'declare' is not allowed in ${r2}ters.`;
        }, DeclareClassFieldHasInitializer: "Initializers are not allowed in ambient contexts.", DeclareFunctionHasImplementation: "An implementation cannot be declared in ambient contexts.", DuplicateAccessibilityModifier: (t2) => {
          return "Accessibility modifier already seen.";
        }, DuplicateModifier: (t2) => {
          let { modifier: r2 } = t2;
          return `Duplicate modifier: '${r2}'.`;
        }, EmptyHeritageClauseType: (t2) => {
          let { token: r2 } = t2;
          return `'${r2}' list cannot be empty.`;
        }, EmptyTypeArguments: "Type argument list cannot be empty.", EmptyTypeParameters: "Type parameter list cannot be empty.", ExpectedAmbientAfterExportDeclare: "'export declare' must be followed by an ambient declaration.", ImportAliasHasImportType: "An import alias can not use 'import type'.", ImportReflectionHasImportType: "An `import module` declaration can not use `type` modifier", IncompatibleModifiers: (t2) => {
          let { modifiers: r2 } = t2;
          return `'${r2[0]}' modifier cannot be used with '${r2[1]}' modifier.`;
        }, IndexSignatureHasAbstract: "Index signatures cannot have the 'abstract' modifier.", IndexSignatureHasAccessibility: (t2) => {
          let { modifier: r2 } = t2;
          return `Index signatures cannot have an accessibility modifier ('${r2}').`;
        }, IndexSignatureHasDeclare: "Index signatures cannot have the 'declare' modifier.", IndexSignatureHasOverride: "'override' modifier cannot appear on an index signature.", IndexSignatureHasStatic: "Index signatures cannot have the 'static' modifier.", InitializerNotAllowedInAmbientContext: "Initializers are not allowed in ambient contexts.", InvalidModifierOnTypeMember: (t2) => {
          let { modifier: r2 } = t2;
          return `'${r2}' modifier cannot appear on a type member.`;
        }, InvalidModifierOnTypeParameter: (t2) => {
          let { modifier: r2 } = t2;
          return `'${r2}' modifier cannot appear on a type parameter.`;
        }, InvalidModifierOnTypeParameterPositions: (t2) => {
          let { modifier: r2 } = t2;
          return `'${r2}' modifier can only appear on a type parameter of a class, interface or type alias.`;
        }, InvalidModifiersOrder: (t2) => {
          let { orderedModifiers: r2 } = t2;
          return `'${r2[0]}' modifier must precede '${r2[1]}' modifier.`;
        }, InvalidPropertyAccessAfterInstantiationExpression: "Invalid property access after an instantiation expression. You can either wrap the instantiation expression in parentheses, or delete the type arguments.", InvalidTupleMemberLabel: "Tuple members must be labeled with a simple identifier.", MissingInterfaceName: "'interface' declarations must be followed by an identifier.", MixedLabeledAndUnlabeledElements: "Tuple members must all have names or all not have names.", NonAbstractClassHasAbstractMethod: "Abstract methods can only appear within an abstract class.", NonClassMethodPropertyHasAbstractModifer: "'abstract' modifier can only appear on a class, method, or property declaration.", OptionalTypeBeforeRequired: "A required element cannot follow an optional element.", OverrideNotInSubClass: "This member cannot have an 'override' modifier because its containing class does not extend another class.", PatternIsOptional: "A binding pattern parameter cannot be optional in an implementation signature.", PrivateElementHasAbstract: "Private elements cannot have the 'abstract' modifier.", PrivateElementHasAccessibility: (t2) => {
          let { modifier: r2 } = t2;
          return `Private elements cannot have an accessibility modifier ('${r2}').`;
        }, ReadonlyForMethodSignature: "'readonly' modifier can only appear on a property declaration or index signature.", ReservedArrowTypeParam: "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma, as in `<T,>() => ...`.", ReservedTypeAssertion: "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead.", SetAccesorCannotHaveOptionalParameter: "A 'set' accessor cannot have an optional parameter.", SetAccesorCannotHaveRestParameter: "A 'set' accessor cannot have rest parameter.", SetAccesorCannotHaveReturnType: "A 'set' accessor cannot have a return type annotation.", SingleTypeParameterWithoutTrailingComma: (t2) => {
          let { typeParameterName: r2 } = t2;
          return `Single type parameter ${r2} should have a trailing comma. Example usage: <${r2},>.`;
        }, StaticBlockCannotHaveModifier: "Static class blocks cannot have any modifier.", TypeAnnotationAfterAssign: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.", TypeImportCannotSpecifyDefaultAndNamed: "A type-only import can specify a default import or named bindings, but not both.", TypeModifierIsUsedInTypeExports: "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement.", TypeModifierIsUsedInTypeImports: "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement.", UnexpectedParameterModifier: "A parameter property is only allowed in a constructor implementation.", UnexpectedReadonly: "'readonly' type modifier is only permitted on array and tuple literal types.", UnexpectedTypeAnnotation: "Did not expect a type annotation here.", UnexpectedTypeCastInParameter: "Unexpected type cast in parameter position.", UnsupportedImportTypeArgument: "Argument in a type import must be a string literal.", UnsupportedParameterPropertyKind: "A parameter property may not be declared using a binding pattern.", UnsupportedSignatureParameterKind: (t2) => {
          let { type: r2 } = t2;
          return `Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got ${r2}.`;
        } });
        function nh2(t2) {
          switch (t2) {
            case "any":
              return "TSAnyKeyword";
            case "boolean":
              return "TSBooleanKeyword";
            case "bigint":
              return "TSBigIntKeyword";
            case "never":
              return "TSNeverKeyword";
            case "number":
              return "TSNumberKeyword";
            case "object":
              return "TSObjectKeyword";
            case "string":
              return "TSStringKeyword";
            case "symbol":
              return "TSSymbolKeyword";
            case "undefined":
              return "TSUndefinedKeyword";
            case "unknown":
              return "TSUnknownKeyword";
            default:
              return;
          }
        }
        function Xr2(t2) {
          return t2 === "private" || t2 === "public" || t2 === "protected";
        }
        function oh2(t2) {
          return t2 === "in" || t2 === "out";
        }
        var lh2 = (t2) => class extends t2 {
          getScopeHandler() {
            return rh2;
          }
          tsIsIdentifier() {
            return z2(this.state.type);
          }
          tsTokenCanFollowModifier() {
            return (this.match(0) || this.match(5) || this.match(55) || this.match(21) || this.match(136) || this.isLiteralPropertyName()) && !this.hasPrecedingLineBreak();
          }
          tsNextTokenCanFollowModifier() {
            return this.next(), this.tsTokenCanFollowModifier();
          }
          tsParseModifier(e25, s2) {
            if (!z2(this.state.type) && this.state.type !== 58)
              return;
            let i2 = this.state.value;
            if (e25.indexOf(i2) !== -1) {
              if (s2 && this.tsIsStartOfStaticBlocks())
                return;
              if (this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this)))
                return i2;
            }
          }
          tsParseModifiers(e25) {
            let { modified: s2, allowedModifiers: i2, disallowedModifiers: a2, stopOnStartOfClassStaticBlock: n2, errorTemplate: o2 = w2.InvalidModifierOnTypeMember } = e25, c2 = (m2, x2, A2, b2) => {
              x2 === A2 && s2[b2] && this.raise(w2.InvalidModifiersOrder, { at: m2, orderedModifiers: [A2, b2] });
            }, p2 = (m2, x2, A2, b2) => {
              (s2[A2] && x2 === b2 || s2[b2] && x2 === A2) && this.raise(w2.IncompatibleModifiers, { at: m2, modifiers: [A2, b2] });
            };
            for (; ; ) {
              let { startLoc: m2 } = this.state, x2 = this.tsParseModifier(i2.concat(a2 != null ? a2 : []), n2);
              if (!x2)
                break;
              Xr2(x2) ? s2.accessibility ? this.raise(w2.DuplicateAccessibilityModifier, { at: m2, modifier: x2 }) : (c2(m2, x2, x2, "override"), c2(m2, x2, x2, "static"), c2(m2, x2, x2, "readonly"), s2.accessibility = x2) : oh2(x2) ? (s2[x2] && this.raise(w2.DuplicateModifier, { at: m2, modifier: x2 }), s2[x2] = true, c2(m2, x2, "in", "out")) : (Object.hasOwnProperty.call(s2, x2) ? this.raise(w2.DuplicateModifier, { at: m2, modifier: x2 }) : (c2(m2, x2, "static", "readonly"), c2(m2, x2, "static", "override"), c2(m2, x2, "override", "readonly"), c2(m2, x2, "abstract", "override"), p2(m2, x2, "declare", "override"), p2(m2, x2, "static", "abstract")), s2[x2] = true), a2 != null && a2.includes(x2) && this.raise(o2, { at: m2, modifier: x2 });
            }
          }
          tsIsListTerminator(e25) {
            switch (e25) {
              case "EnumMembers":
              case "TypeMembers":
                return this.match(8);
              case "HeritageClauseElement":
                return this.match(5);
              case "TupleElementTypes":
                return this.match(3);
              case "TypeParametersOrArguments":
                return this.match(48);
            }
            throw new Error("Unreachable");
          }
          tsParseList(e25, s2) {
            let i2 = [];
            for (; !this.tsIsListTerminator(e25); )
              i2.push(s2());
            return i2;
          }
          tsParseDelimitedList(e25, s2, i2) {
            return ah2(this.tsParseDelimitedListWorker(e25, s2, true, i2));
          }
          tsParseDelimitedListWorker(e25, s2, i2, a2) {
            let n2 = [], o2 = -1;
            for (; !this.tsIsListTerminator(e25); ) {
              o2 = -1;
              let c2 = s2();
              if (c2 == null)
                return;
              if (n2.push(c2), this.eat(12)) {
                o2 = this.state.lastTokStart;
                continue;
              }
              if (this.tsIsListTerminator(e25))
                break;
              i2 && this.expect(12);
              return;
            }
            return a2 && (a2.value = o2), n2;
          }
          tsParseBracketedList(e25, s2, i2, a2, n2) {
            a2 || (i2 ? this.expect(0) : this.expect(47));
            let o2 = this.tsParseDelimitedList(e25, s2, n2);
            return i2 ? this.expect(3) : this.expect(48), o2;
          }
          tsParseImportType() {
            let e25 = this.startNode();
            return this.expect(83), this.expect(10), this.match(131) || this.raise(w2.UnsupportedImportTypeArgument, { at: this.state.startLoc }), e25.argument = super.parseExprAtom(), this.expect(11), this.eat(16) && (e25.qualifier = this.tsParseEntityName()), this.match(47) && (e25.typeParameters = this.tsParseTypeArguments()), this.finishNode(e25, "TSImportType");
          }
          tsParseEntityName() {
            let e25 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, s2 = this.parseIdentifier(e25);
            for (; this.eat(16); ) {
              let i2 = this.startNodeAtNode(s2);
              i2.left = s2, i2.right = this.parseIdentifier(e25), s2 = this.finishNode(i2, "TSQualifiedName");
            }
            return s2;
          }
          tsParseTypeReference() {
            let e25 = this.startNode();
            return e25.typeName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e25.typeParameters = this.tsParseTypeArguments()), this.finishNode(e25, "TSTypeReference");
          }
          tsParseThisTypePredicate(e25) {
            this.next();
            let s2 = this.startNodeAtNode(e25);
            return s2.parameterName = e25, s2.typeAnnotation = this.tsParseTypeAnnotation(false), s2.asserts = false, this.finishNode(s2, "TSTypePredicate");
          }
          tsParseThisTypeNode() {
            let e25 = this.startNode();
            return this.next(), this.finishNode(e25, "TSThisType");
          }
          tsParseTypeQuery() {
            let e25 = this.startNode();
            return this.expect(87), this.match(83) ? e25.exprName = this.tsParseImportType() : e25.exprName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (e25.typeParameters = this.tsParseTypeArguments()), this.finishNode(e25, "TSTypeQuery");
          }
          tsParseInOutModifiers(e25) {
            this.tsParseModifiers({ modified: e25, allowedModifiers: ["in", "out"], disallowedModifiers: ["public", "private", "protected", "readonly", "declare", "abstract", "override"], errorTemplate: w2.InvalidModifierOnTypeParameter });
          }
          tsParseNoneModifiers(e25) {
            this.tsParseModifiers({ modified: e25, allowedModifiers: [], disallowedModifiers: ["in", "out"], errorTemplate: w2.InvalidModifierOnTypeParameterPositions });
          }
          tsParseTypeParameter() {
            let e25 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.tsParseNoneModifiers.bind(this), s2 = this.startNode();
            return e25(s2), s2.name = this.tsParseTypeParameterName(), s2.constraint = this.tsEatThenParseType(81), s2.default = this.tsEatThenParseType(29), this.finishNode(s2, "TSTypeParameter");
          }
          tsTryParseTypeParameters(e25) {
            if (this.match(47))
              return this.tsParseTypeParameters(e25);
          }
          tsParseTypeParameters(e25) {
            let s2 = this.startNode();
            this.match(47) || this.match(140) ? this.next() : this.unexpected();
            let i2 = { value: -1 };
            return s2.params = this.tsParseBracketedList("TypeParametersOrArguments", this.tsParseTypeParameter.bind(this, e25), false, true, i2), s2.params.length === 0 && this.raise(w2.EmptyTypeParameters, { at: s2 }), i2.value !== -1 && this.addExtra(s2, "trailingComma", i2.value), this.finishNode(s2, "TSTypeParameterDeclaration");
          }
          tsFillSignature(e25, s2) {
            let i2 = e25 === 19, a2 = "parameters", n2 = "typeAnnotation";
            s2.typeParameters = this.tsTryParseTypeParameters(), this.expect(10), s2[a2] = this.tsParseBindingListForSignature(), i2 ? s2[n2] = this.tsParseTypeOrTypePredicateAnnotation(e25) : this.match(e25) && (s2[n2] = this.tsParseTypeOrTypePredicateAnnotation(e25));
          }
          tsParseBindingListForSignature() {
            return super.parseBindingList(11, 41).map((e25) => (e25.type !== "Identifier" && e25.type !== "RestElement" && e25.type !== "ObjectPattern" && e25.type !== "ArrayPattern" && this.raise(w2.UnsupportedSignatureParameterKind, { at: e25, type: e25.type }), e25));
          }
          tsParseTypeMemberSemicolon() {
            !this.eat(12) && !this.isLineTerminator() && this.expect(13);
          }
          tsParseSignatureMember(e25, s2) {
            return this.tsFillSignature(14, s2), this.tsParseTypeMemberSemicolon(), this.finishNode(s2, e25);
          }
          tsIsUnambiguouslyIndexSignature() {
            return this.next(), z2(this.state.type) ? (this.next(), this.match(14)) : false;
          }
          tsTryParseIndexSignature(e25) {
            if (!(this.match(0) && this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this))))
              return;
            this.expect(0);
            let s2 = this.parseIdentifier();
            s2.typeAnnotation = this.tsParseTypeAnnotation(), this.resetEndLocation(s2), this.expect(3), e25.parameters = [s2];
            let i2 = this.tsTryParseTypeAnnotation();
            return i2 && (e25.typeAnnotation = i2), this.tsParseTypeMemberSemicolon(), this.finishNode(e25, "TSIndexSignature");
          }
          tsParsePropertyOrMethodSignature(e25, s2) {
            this.eat(17) && (e25.optional = true);
            let i2 = e25;
            if (this.match(10) || this.match(47)) {
              s2 && this.raise(w2.ReadonlyForMethodSignature, { at: e25 });
              let a2 = i2;
              a2.kind && this.match(47) && this.raise(w2.AccesorCannotHaveTypeParameters, { at: this.state.curPosition() }), this.tsFillSignature(14, a2), this.tsParseTypeMemberSemicolon();
              let n2 = "parameters", o2 = "typeAnnotation";
              if (a2.kind === "get")
                a2[n2].length > 0 && (this.raise(u2.BadGetterArity, { at: this.state.curPosition() }), this.isThisParam(a2[n2][0]) && this.raise(w2.AccesorCannotDeclareThisParameter, { at: this.state.curPosition() }));
              else if (a2.kind === "set") {
                if (a2[n2].length !== 1)
                  this.raise(u2.BadSetterArity, { at: this.state.curPosition() });
                else {
                  let c2 = a2[n2][0];
                  this.isThisParam(c2) && this.raise(w2.AccesorCannotDeclareThisParameter, { at: this.state.curPosition() }), c2.type === "Identifier" && c2.optional && this.raise(w2.SetAccesorCannotHaveOptionalParameter, { at: this.state.curPosition() }), c2.type === "RestElement" && this.raise(w2.SetAccesorCannotHaveRestParameter, { at: this.state.curPosition() });
                }
                a2[o2] && this.raise(w2.SetAccesorCannotHaveReturnType, { at: a2[o2] });
              } else
                a2.kind = "method";
              return this.finishNode(a2, "TSMethodSignature");
            } else {
              let a2 = i2;
              s2 && (a2.readonly = true);
              let n2 = this.tsTryParseTypeAnnotation();
              return n2 && (a2.typeAnnotation = n2), this.tsParseTypeMemberSemicolon(), this.finishNode(a2, "TSPropertySignature");
            }
          }
          tsParseTypeMember() {
            let e25 = this.startNode();
            if (this.match(10) || this.match(47))
              return this.tsParseSignatureMember("TSCallSignatureDeclaration", e25);
            if (this.match(77)) {
              let i2 = this.startNode();
              return this.next(), this.match(10) || this.match(47) ? this.tsParseSignatureMember("TSConstructSignatureDeclaration", e25) : (e25.key = this.createIdentifier(i2, "new"), this.tsParsePropertyOrMethodSignature(e25, false));
            }
            this.tsParseModifiers({ modified: e25, allowedModifiers: ["readonly"], disallowedModifiers: ["declare", "abstract", "private", "protected", "public", "static", "override"] });
            let s2 = this.tsTryParseIndexSignature(e25);
            return s2 || (super.parsePropertyName(e25), !e25.computed && e25.key.type === "Identifier" && (e25.key.name === "get" || e25.key.name === "set") && this.tsTokenCanFollowModifier() && (e25.kind = e25.key.name, super.parsePropertyName(e25)), this.tsParsePropertyOrMethodSignature(e25, !!e25.readonly));
          }
          tsParseTypeLiteral() {
            let e25 = this.startNode();
            return e25.members = this.tsParseObjectTypeMembers(), this.finishNode(e25, "TSTypeLiteral");
          }
          tsParseObjectTypeMembers() {
            this.expect(5);
            let e25 = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
            return this.expect(8), e25;
          }
          tsIsStartOfMappedType() {
            return this.next(), this.eat(53) ? this.isContextual(120) : (this.isContextual(120) && this.next(), !this.match(0) || (this.next(), !this.tsIsIdentifier()) ? false : (this.next(), this.match(58)));
          }
          tsParseMappedTypeParameter() {
            let e25 = this.startNode();
            return e25.name = this.tsParseTypeParameterName(), e25.constraint = this.tsExpectThenParseType(58), this.finishNode(e25, "TSTypeParameter");
          }
          tsParseMappedType() {
            let e25 = this.startNode();
            return this.expect(5), this.match(53) ? (e25.readonly = this.state.value, this.next(), this.expectContextual(120)) : this.eatContextual(120) && (e25.readonly = true), this.expect(0), e25.typeParameter = this.tsParseMappedTypeParameter(), e25.nameType = this.eatContextual(93) ? this.tsParseType() : null, this.expect(3), this.match(53) ? (e25.optional = this.state.value, this.next(), this.expect(17)) : this.eat(17) && (e25.optional = true), e25.typeAnnotation = this.tsTryParseType(), this.semicolon(), this.expect(8), this.finishNode(e25, "TSMappedType");
          }
          tsParseTupleType() {
            let e25 = this.startNode();
            e25.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), true, false);
            let s2 = false, i2 = null;
            return e25.elementTypes.forEach((a2) => {
              let { type: o2 } = a2;
              s2 && o2 !== "TSRestType" && o2 !== "TSOptionalType" && !(o2 === "TSNamedTupleMember" && a2.optional) && this.raise(w2.OptionalTypeBeforeRequired, { at: a2 }), s2 || (s2 = o2 === "TSNamedTupleMember" && a2.optional || o2 === "TSOptionalType");
              let c2 = o2;
              o2 === "TSRestType" && (a2 = a2.typeAnnotation, c2 = a2.type);
              let p2 = c2 === "TSNamedTupleMember";
              i2 != null || (i2 = p2), i2 !== p2 && this.raise(w2.MixedLabeledAndUnlabeledElements, { at: a2 });
            }), this.finishNode(e25, "TSTupleType");
          }
          tsParseTupleElementType() {
            let { startLoc: e25 } = this.state, s2 = this.eat(21), i2 = this.tsParseType(), a2 = this.eat(17);
            if (this.eat(14)) {
              let o2 = this.startNodeAtNode(i2);
              o2.optional = a2, i2.type === "TSTypeReference" && !i2.typeParameters && i2.typeName.type === "Identifier" ? o2.label = i2.typeName : (this.raise(w2.InvalidTupleMemberLabel, { at: i2 }), o2.label = i2), o2.elementType = this.tsParseType(), i2 = this.finishNode(o2, "TSNamedTupleMember");
            } else if (a2) {
              let o2 = this.startNodeAtNode(i2);
              o2.typeAnnotation = i2, i2 = this.finishNode(o2, "TSOptionalType");
            }
            if (s2) {
              let o2 = this.startNodeAt(e25);
              o2.typeAnnotation = i2, i2 = this.finishNode(o2, "TSRestType");
            }
            return i2;
          }
          tsParseParenthesizedType() {
            let e25 = this.startNode();
            return this.expect(10), e25.typeAnnotation = this.tsParseType(), this.expect(11), this.finishNode(e25, "TSParenthesizedType");
          }
          tsParseFunctionOrConstructorType(e25, s2) {
            let i2 = this.startNode();
            return e25 === "TSConstructorType" && (i2.abstract = !!s2, s2 && this.next(), this.next()), this.tsInAllowConditionalTypesContext(() => this.tsFillSignature(19, i2)), this.finishNode(i2, e25);
          }
          tsParseLiteralTypeNode() {
            let e25 = this.startNode();
            return e25.literal = (() => {
              switch (this.state.type) {
                case 132:
                case 133:
                case 131:
                case 85:
                case 86:
                  return super.parseExprAtom();
                default:
                  throw this.unexpected();
              }
            })(), this.finishNode(e25, "TSLiteralType");
          }
          tsParseTemplateLiteralType() {
            let e25 = this.startNode();
            return e25.literal = super.parseTemplate(false), this.finishNode(e25, "TSLiteralType");
          }
          parseTemplateSubstitution() {
            return this.state.inType ? this.tsParseType() : super.parseTemplateSubstitution();
          }
          tsParseThisTypeOrThisTypePredicate() {
            let e25 = this.tsParseThisTypeNode();
            return this.isContextual(114) && !this.hasPrecedingLineBreak() ? this.tsParseThisTypePredicate(e25) : e25;
          }
          tsParseNonArrayType() {
            switch (this.state.type) {
              case 131:
              case 132:
              case 133:
              case 85:
              case 86:
                return this.tsParseLiteralTypeNode();
              case 53:
                if (this.state.value === "-") {
                  let e25 = this.startNode(), s2 = this.lookahead();
                  if (s2.type !== 132 && s2.type !== 133)
                    throw this.unexpected();
                  return e25.literal = this.parseMaybeUnary(), this.finishNode(e25, "TSLiteralType");
                }
                break;
              case 78:
                return this.tsParseThisTypeOrThisTypePredicate();
              case 87:
                return this.tsParseTypeQuery();
              case 83:
                return this.tsParseImportType();
              case 5:
                return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();
              case 0:
                return this.tsParseTupleType();
              case 10:
                return this.tsParseParenthesizedType();
              case 25:
              case 24:
                return this.tsParseTemplateLiteralType();
              default: {
                let { type: e25 } = this.state;
                if (z2(e25) || e25 === 88 || e25 === 84) {
                  let s2 = e25 === 88 ? "TSVoidKeyword" : e25 === 84 ? "TSNullKeyword" : nh2(this.state.value);
                  if (s2 !== void 0 && this.lookaheadCharCode() !== 46) {
                    let i2 = this.startNode();
                    return this.next(), this.finishNode(i2, s2);
                  }
                  return this.tsParseTypeReference();
                }
              }
            }
            throw this.unexpected();
          }
          tsParseArrayTypeOrHigher() {
            let e25 = this.tsParseNonArrayType();
            for (; !this.hasPrecedingLineBreak() && this.eat(0); )
              if (this.match(3)) {
                let s2 = this.startNodeAtNode(e25);
                s2.elementType = e25, this.expect(3), e25 = this.finishNode(s2, "TSArrayType");
              } else {
                let s2 = this.startNodeAtNode(e25);
                s2.objectType = e25, s2.indexType = this.tsParseType(), this.expect(3), e25 = this.finishNode(s2, "TSIndexedAccessType");
              }
            return e25;
          }
          tsParseTypeOperator() {
            let e25 = this.startNode(), s2 = this.state.value;
            return this.next(), e25.operator = s2, e25.typeAnnotation = this.tsParseTypeOperatorOrHigher(), s2 === "readonly" && this.tsCheckTypeAnnotationForReadOnly(e25), this.finishNode(e25, "TSTypeOperator");
          }
          tsCheckTypeAnnotationForReadOnly(e25) {
            switch (e25.typeAnnotation.type) {
              case "TSTupleType":
              case "TSArrayType":
                return;
              default:
                this.raise(w2.UnexpectedReadonly, { at: e25 });
            }
          }
          tsParseInferType() {
            let e25 = this.startNode();
            this.expectContextual(113);
            let s2 = this.startNode();
            return s2.name = this.tsParseTypeParameterName(), s2.constraint = this.tsTryParse(() => this.tsParseConstraintForInferType()), e25.typeParameter = this.finishNode(s2, "TSTypeParameter"), this.finishNode(e25, "TSInferType");
          }
          tsParseConstraintForInferType() {
            if (this.eat(81)) {
              let e25 = this.tsInDisallowConditionalTypesContext(() => this.tsParseType());
              if (this.state.inDisallowConditionalTypesContext || !this.match(17))
                return e25;
            }
          }
          tsParseTypeOperatorOrHigher() {
            return Zo2(this.state.type) && !this.state.containsEsc ? this.tsParseTypeOperator() : this.isContextual(113) ? this.tsParseInferType() : this.tsInAllowConditionalTypesContext(() => this.tsParseArrayTypeOrHigher());
          }
          tsParseUnionOrIntersectionType(e25, s2, i2) {
            let a2 = this.startNode(), n2 = this.eat(i2), o2 = [];
            do
              o2.push(s2());
            while (this.eat(i2));
            return o2.length === 1 && !n2 ? o2[0] : (a2.types = o2, this.finishNode(a2, e25));
          }
          tsParseIntersectionTypeOrHigher() {
            return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), 45);
          }
          tsParseUnionTypeOrHigher() {
            return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), 43);
          }
          tsIsStartOfFunctionType() {
            return this.match(47) ? true : this.match(10) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
          }
          tsSkipParameterStart() {
            if (z2(this.state.type) || this.match(78))
              return this.next(), true;
            if (this.match(5)) {
              let { errors: e25 } = this.state, s2 = e25.length;
              try {
                return this.parseObjectLike(8, true), e25.length === s2;
              } catch {
                return false;
              }
            }
            if (this.match(0)) {
              this.next();
              let { errors: e25 } = this.state, s2 = e25.length;
              try {
                return super.parseBindingList(3, 93, true), e25.length === s2;
              } catch {
                return false;
              }
            }
            return false;
          }
          tsIsUnambiguouslyStartOfFunctionType() {
            return this.next(), !!(this.match(11) || this.match(21) || this.tsSkipParameterStart() && (this.match(14) || this.match(12) || this.match(17) || this.match(29) || this.match(11) && (this.next(), this.match(19))));
          }
          tsParseTypeOrTypePredicateAnnotation(e25) {
            return this.tsInType(() => {
              let s2 = this.startNode();
              this.expect(e25);
              let i2 = this.startNode(), a2 = !!this.tsTryParse(this.tsParseTypePredicateAsserts.bind(this));
              if (a2 && this.match(78)) {
                let c2 = this.tsParseThisTypeOrThisTypePredicate();
                return c2.type === "TSThisType" ? (i2.parameterName = c2, i2.asserts = true, i2.typeAnnotation = null, c2 = this.finishNode(i2, "TSTypePredicate")) : (this.resetStartLocationFromNode(c2, i2), c2.asserts = true), s2.typeAnnotation = c2, this.finishNode(s2, "TSTypeAnnotation");
              }
              let n2 = this.tsIsIdentifier() && this.tsTryParse(this.tsParseTypePredicatePrefix.bind(this));
              if (!n2)
                return a2 ? (i2.parameterName = this.parseIdentifier(), i2.asserts = a2, i2.typeAnnotation = null, s2.typeAnnotation = this.finishNode(i2, "TSTypePredicate"), this.finishNode(s2, "TSTypeAnnotation")) : this.tsParseTypeAnnotation(false, s2);
              let o2 = this.tsParseTypeAnnotation(false);
              return i2.parameterName = n2, i2.typeAnnotation = o2, i2.asserts = a2, s2.typeAnnotation = this.finishNode(i2, "TSTypePredicate"), this.finishNode(s2, "TSTypeAnnotation");
            });
          }
          tsTryParseTypeOrTypePredicateAnnotation() {
            return this.match(14) ? this.tsParseTypeOrTypePredicateAnnotation(14) : void 0;
          }
          tsTryParseTypeAnnotation() {
            return this.match(14) ? this.tsParseTypeAnnotation() : void 0;
          }
          tsTryParseType() {
            return this.tsEatThenParseType(14);
          }
          tsParseTypePredicatePrefix() {
            let e25 = this.parseIdentifier();
            if (this.isContextual(114) && !this.hasPrecedingLineBreak())
              return this.next(), e25;
          }
          tsParseTypePredicateAsserts() {
            if (this.state.type !== 107)
              return false;
            let e25 = this.state.containsEsc;
            return this.next(), !z2(this.state.type) && !this.match(78) ? false : (e25 && this.raise(u2.InvalidEscapedReservedWord, { at: this.state.lastTokStartLoc, reservedWord: "asserts" }), true);
          }
          tsParseTypeAnnotation() {
            let e25 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, s2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.startNode();
            return this.tsInType(() => {
              e25 && this.expect(14), s2.typeAnnotation = this.tsParseType();
            }), this.finishNode(s2, "TSTypeAnnotation");
          }
          tsParseType() {
            Jr2(this.state.inType);
            let e25 = this.tsParseNonConditionalType();
            if (this.state.inDisallowConditionalTypesContext || this.hasPrecedingLineBreak() || !this.eat(81))
              return e25;
            let s2 = this.startNodeAtNode(e25);
            return s2.checkType = e25, s2.extendsType = this.tsInDisallowConditionalTypesContext(() => this.tsParseNonConditionalType()), this.expect(17), s2.trueType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.expect(14), s2.falseType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.finishNode(s2, "TSConditionalType");
          }
          isAbstractConstructorSignature() {
            return this.isContextual(122) && this.lookahead().type === 77;
          }
          tsParseNonConditionalType() {
            return this.tsIsStartOfFunctionType() ? this.tsParseFunctionOrConstructorType("TSFunctionType") : this.match(77) ? this.tsParseFunctionOrConstructorType("TSConstructorType") : this.isAbstractConstructorSignature() ? this.tsParseFunctionOrConstructorType("TSConstructorType", true) : this.tsParseUnionTypeOrHigher();
          }
          tsParseTypeAssertion() {
            this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(w2.ReservedTypeAssertion, { at: this.state.startLoc });
            let e25 = this.startNode();
            return e25.typeAnnotation = this.tsInType(() => (this.next(), this.match(75) ? this.tsParseTypeReference() : this.tsParseType())), this.expect(48), e25.expression = this.parseMaybeUnary(), this.finishNode(e25, "TSTypeAssertion");
          }
          tsParseHeritageClause(e25) {
            let s2 = this.state.startLoc, i2 = this.tsParseDelimitedList("HeritageClauseElement", () => {
              let a2 = this.startNode();
              return a2.expression = this.tsParseEntityName(), this.match(47) && (a2.typeParameters = this.tsParseTypeArguments()), this.finishNode(a2, "TSExpressionWithTypeArguments");
            });
            return i2.length || this.raise(w2.EmptyHeritageClauseType, { at: s2, token: e25 }), i2;
          }
          tsParseInterfaceDeclaration(e25) {
            let s2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (this.hasFollowingLineBreak())
              return null;
            this.expectContextual(127), s2.declare && (e25.declare = true), z2(this.state.type) ? (e25.id = this.parseIdentifier(), this.checkIdentifier(e25.id, pl2)) : (e25.id = null, this.raise(w2.MissingInterfaceName, { at: this.state.startLoc })), e25.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this)), this.eat(81) && (e25.extends = this.tsParseHeritageClause("extends"));
            let i2 = this.startNode();
            return i2.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this)), e25.body = this.finishNode(i2, "TSInterfaceBody"), this.finishNode(e25, "TSInterfaceDeclaration");
          }
          tsParseTypeAliasDeclaration(e25) {
            return e25.id = this.parseIdentifier(), this.checkIdentifier(e25.id, fl2), e25.typeAnnotation = this.tsInType(() => {
              if (e25.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this)), this.expect(29), this.isContextual(112) && this.lookahead().type !== 16) {
                let s2 = this.startNode();
                return this.next(), this.finishNode(s2, "TSIntrinsicKeyword");
              }
              return this.tsParseType();
            }), this.semicolon(), this.finishNode(e25, "TSTypeAliasDeclaration");
          }
          tsInNoContext(e25) {
            let s2 = this.state.context;
            this.state.context = [s2[0]];
            try {
              return e25();
            } finally {
              this.state.context = s2;
            }
          }
          tsInType(e25) {
            let s2 = this.state.inType;
            this.state.inType = true;
            try {
              return e25();
            } finally {
              this.state.inType = s2;
            }
          }
          tsInDisallowConditionalTypesContext(e25) {
            let s2 = this.state.inDisallowConditionalTypesContext;
            this.state.inDisallowConditionalTypesContext = true;
            try {
              return e25();
            } finally {
              this.state.inDisallowConditionalTypesContext = s2;
            }
          }
          tsInAllowConditionalTypesContext(e25) {
            let s2 = this.state.inDisallowConditionalTypesContext;
            this.state.inDisallowConditionalTypesContext = false;
            try {
              return e25();
            } finally {
              this.state.inDisallowConditionalTypesContext = s2;
            }
          }
          tsEatThenParseType(e25) {
            return this.match(e25) ? this.tsNextThenParseType() : void 0;
          }
          tsExpectThenParseType(e25) {
            return this.tsDoThenParseType(() => this.expect(e25));
          }
          tsNextThenParseType() {
            return this.tsDoThenParseType(() => this.next());
          }
          tsDoThenParseType(e25) {
            return this.tsInType(() => (e25(), this.tsParseType()));
          }
          tsParseEnumMember() {
            let e25 = this.startNode();
            return e25.id = this.match(131) ? super.parseStringLiteral(this.state.value) : this.parseIdentifier(true), this.eat(29) && (e25.initializer = super.parseMaybeAssignAllowIn()), this.finishNode(e25, "TSEnumMember");
          }
          tsParseEnumDeclaration(e25) {
            let s2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return s2.const && (e25.const = true), s2.declare && (e25.declare = true), this.expectContextual(124), e25.id = this.parseIdentifier(), this.checkIdentifier(e25.id, e25.const ? ml2 : Fr2), this.expect(5), e25.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this)), this.expect(8), this.finishNode(e25, "TSEnumDeclaration");
          }
          tsParseModuleBlock() {
            let e25 = this.startNode();
            return this.scope.enter(je2), this.expect(5), super.parseBlockOrModuleBlockBody(e25.body = [], void 0, true, 8), this.scope.exit(), this.finishNode(e25, "TSModuleBlock");
          }
          tsParseModuleOrNamespaceDeclaration(e25) {
            let s2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            if (e25.id = this.parseIdentifier(), s2 || this.checkIdentifier(e25.id, yl2), this.eat(16)) {
              let i2 = this.startNode();
              this.tsParseModuleOrNamespaceDeclaration(i2, true), e25.body = i2;
            } else
              this.scope.enter(Ue2), this.prodParam.enter($e2), e25.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit();
            return this.finishNode(e25, "TSModuleDeclaration");
          }
          tsParseAmbientExternalModuleDeclaration(e25) {
            return this.isContextual(110) ? (e25.global = true, e25.id = this.parseIdentifier()) : this.match(131) ? e25.id = super.parseStringLiteral(this.state.value) : this.unexpected(), this.match(5) ? (this.scope.enter(Ue2), this.prodParam.enter($e2), e25.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit()) : this.semicolon(), this.finishNode(e25, "TSModuleDeclaration");
          }
          tsParseImportEqualsDeclaration(e25, s2) {
            e25.isExport = s2 || false, e25.id = this.parseIdentifier(), this.checkIdentifier(e25.id, Ye2), this.expect(29);
            let i2 = this.tsParseModuleReference();
            return e25.importKind === "type" && i2.type !== "TSExternalModuleReference" && this.raise(w2.ImportAliasHasImportType, { at: i2 }), e25.moduleReference = i2, this.semicolon(), this.finishNode(e25, "TSImportEqualsDeclaration");
          }
          tsIsExternalModuleReference() {
            return this.isContextual(117) && this.lookaheadCharCode() === 40;
          }
          tsParseModuleReference() {
            return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(false);
          }
          tsParseExternalModuleReference() {
            let e25 = this.startNode();
            if (this.expectContextual(117), this.expect(10), !this.match(131))
              throw this.unexpected();
            return e25.expression = super.parseExprAtom(), this.expect(11), this.finishNode(e25, "TSExternalModuleReference");
          }
          tsLookAhead(e25) {
            let s2 = this.state.clone(), i2 = e25();
            return this.state = s2, i2;
          }
          tsTryParseAndCatch(e25) {
            let s2 = this.tryParse((i2) => e25() || i2());
            if (!(s2.aborted || !s2.node))
              return s2.error && (this.state = s2.failState), s2.node;
          }
          tsTryParse(e25) {
            let s2 = this.state.clone(), i2 = e25();
            if (i2 !== void 0 && i2 !== false)
              return i2;
            this.state = s2;
          }
          tsTryParseDeclare(e25) {
            if (this.isLineTerminator())
              return;
            let s2 = this.state.type, i2;
            return this.isContextual(99) && (s2 = 74, i2 = "let"), this.tsInAmbientContext(() => {
              if (s2 === 68)
                return e25.declare = true, super.parseFunctionStatement(e25, false, false);
              if (s2 === 80)
                return e25.declare = true, this.parseClass(e25, true, false);
              if (s2 === 124)
                return this.tsParseEnumDeclaration(e25, { declare: true });
              if (s2 === 110)
                return this.tsParseAmbientExternalModuleDeclaration(e25);
              if (s2 === 75 || s2 === 74)
                return !this.match(75) || !this.isLookaheadContextual("enum") ? (e25.declare = true, this.parseVarStatement(e25, i2 || this.state.value, true)) : (this.expect(75), this.tsParseEnumDeclaration(e25, { const: true, declare: true }));
              if (s2 === 127) {
                let a2 = this.tsParseInterfaceDeclaration(e25, { declare: true });
                if (a2)
                  return a2;
              }
              if (z2(s2))
                return this.tsParseDeclaration(e25, this.state.value, true, null);
            });
          }
          tsTryParseExportDeclaration() {
            return this.tsParseDeclaration(this.startNode(), this.state.value, true, null);
          }
          tsParseExpressionStatement(e25, s2, i2) {
            switch (s2.name) {
              case "declare": {
                let a2 = this.tsTryParseDeclare(e25);
                if (a2)
                  return a2.declare = true, a2;
                break;
              }
              case "global":
                if (this.match(5)) {
                  this.scope.enter(Ue2), this.prodParam.enter($e2);
                  let a2 = e25;
                  return a2.global = true, a2.id = s2, a2.body = this.tsParseModuleBlock(), this.scope.exit(), this.prodParam.exit(), this.finishNode(a2, "TSModuleDeclaration");
                }
                break;
              default:
                return this.tsParseDeclaration(e25, s2.name, false, i2);
            }
          }
          tsParseDeclaration(e25, s2, i2, a2) {
            switch (s2) {
              case "abstract":
                if (this.tsCheckLineTerminator(i2) && (this.match(80) || z2(this.state.type)))
                  return this.tsParseAbstractDeclaration(e25, a2);
                break;
              case "module":
                if (this.tsCheckLineTerminator(i2)) {
                  if (this.match(131))
                    return this.tsParseAmbientExternalModuleDeclaration(e25);
                  if (z2(this.state.type))
                    return this.tsParseModuleOrNamespaceDeclaration(e25);
                }
                break;
              case "namespace":
                if (this.tsCheckLineTerminator(i2) && z2(this.state.type))
                  return this.tsParseModuleOrNamespaceDeclaration(e25);
                break;
              case "type":
                if (this.tsCheckLineTerminator(i2) && z2(this.state.type))
                  return this.tsParseTypeAliasDeclaration(e25);
                break;
            }
          }
          tsCheckLineTerminator(e25) {
            return e25 ? this.hasFollowingLineBreak() ? false : (this.next(), true) : !this.isLineTerminator();
          }
          tsTryParseGenericAsyncArrowFunction(e25) {
            if (!this.match(47))
              return;
            let s2 = this.state.maybeInArrowParameters;
            this.state.maybeInArrowParameters = true;
            let i2 = this.tsTryParseAndCatch(() => {
              let a2 = this.startNodeAt(e25);
              return a2.typeParameters = this.tsParseTypeParameters(), super.parseFunctionParams(a2), a2.returnType = this.tsTryParseTypeOrTypePredicateAnnotation(), this.expect(19), a2;
            });
            if (this.state.maybeInArrowParameters = s2, !!i2)
              return super.parseArrowExpression(i2, null, true);
          }
          tsParseTypeArgumentsInExpression() {
            if (this.reScan_lt() === 47)
              return this.tsParseTypeArguments();
          }
          tsParseTypeArguments() {
            let e25 = this.startNode();
            return e25.params = this.tsInType(() => this.tsInNoContext(() => (this.expect(47), this.tsParseDelimitedList("TypeParametersOrArguments", this.tsParseType.bind(this))))), e25.params.length === 0 && this.raise(w2.EmptyTypeArguments, { at: e25 }), this.expect(48), this.finishNode(e25, "TSTypeParameterInstantiation");
          }
          tsIsDeclarationStart() {
            return el2(this.state.type);
          }
          isExportDefaultSpecifier() {
            return this.tsIsDeclarationStart() ? false : super.isExportDefaultSpecifier();
          }
          parseAssignableListItem(e25, s2) {
            let i2 = this.state.startLoc, a2, n2 = false, o2 = false;
            if (e25 !== void 0) {
              let m2 = {};
              this.tsParseModifiers({ modified: m2, allowedModifiers: ["public", "private", "protected", "override", "readonly"] }), a2 = m2.accessibility, o2 = m2.override, n2 = m2.readonly, e25 === false && (a2 || n2 || o2) && this.raise(w2.UnexpectedParameterModifier, { at: i2 });
            }
            let c2 = this.parseMaybeDefault();
            this.parseAssignableListItemTypes(c2);
            let p2 = this.parseMaybeDefault(c2.loc.start, c2);
            if (a2 || n2 || o2) {
              let m2 = this.startNodeAt(i2);
              return s2.length && (m2.decorators = s2), a2 && (m2.accessibility = a2), n2 && (m2.readonly = n2), o2 && (m2.override = o2), p2.type !== "Identifier" && p2.type !== "AssignmentPattern" && this.raise(w2.UnsupportedParameterPropertyKind, { at: m2 }), m2.parameter = p2, this.finishNode(m2, "TSParameterProperty");
            }
            return s2.length && (c2.decorators = s2), p2;
          }
          isSimpleParameter(e25) {
            return e25.type === "TSParameterProperty" && super.isSimpleParameter(e25.parameter) || super.isSimpleParameter(e25);
          }
          parseFunctionBodyAndFinish(e25, s2) {
            let i2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            this.match(14) && (e25.returnType = this.tsParseTypeOrTypePredicateAnnotation(14));
            let a2 = s2 === "FunctionDeclaration" ? "TSDeclareFunction" : s2 === "ClassMethod" || s2 === "ClassPrivateMethod" ? "TSDeclareMethod" : void 0;
            return a2 && !this.match(5) && this.isLineTerminator() ? this.finishNode(e25, a2) : a2 === "TSDeclareFunction" && this.state.isAmbientContext && (this.raise(w2.DeclareFunctionHasImplementation, { at: e25 }), e25.declare) ? super.parseFunctionBodyAndFinish(e25, a2, i2) : super.parseFunctionBodyAndFinish(e25, s2, i2);
          }
          registerFunctionStatementId(e25) {
            !e25.body && e25.id ? this.checkIdentifier(e25.id, Lr2) : super.registerFunctionStatementId(e25);
          }
          tsCheckForInvalidTypeCasts(e25) {
            e25.forEach((s2) => {
              (s2 == null ? void 0 : s2.type) === "TSTypeCastExpression" && this.raise(w2.UnexpectedTypeAnnotation, { at: s2.typeAnnotation });
            });
          }
          toReferencedList(e25, s2) {
            return this.tsCheckForInvalidTypeCasts(e25), e25;
          }
          parseArrayLike(e25, s2, i2, a2) {
            let n2 = super.parseArrayLike(e25, s2, i2, a2);
            return n2.type === "ArrayExpression" && this.tsCheckForInvalidTypeCasts(n2.elements), n2;
          }
          parseSubscript(e25, s2, i2, a2) {
            if (!this.hasPrecedingLineBreak() && this.match(35)) {
              this.state.canStartJSXElement = false, this.next();
              let o2 = this.startNodeAt(s2);
              return o2.expression = e25, this.finishNode(o2, "TSNonNullExpression");
            }
            let n2 = false;
            if (this.match(18) && this.lookaheadCharCode() === 60) {
              if (i2)
                return a2.stop = true, e25;
              a2.optionalChainMember = n2 = true, this.next();
            }
            if (this.match(47) || this.match(51)) {
              let o2, c2 = this.tsTryParseAndCatch(() => {
                if (!i2 && this.atPossibleAsyncArrow(e25)) {
                  let A2 = this.tsTryParseGenericAsyncArrowFunction(s2);
                  if (A2)
                    return A2;
                }
                let p2 = this.tsParseTypeArgumentsInExpression();
                if (!p2)
                  return;
                if (n2 && !this.match(10)) {
                  o2 = this.state.curPosition();
                  return;
                }
                if (ct2(this.state.type)) {
                  let A2 = super.parseTaggedTemplateExpression(e25, s2, a2);
                  return A2.typeParameters = p2, A2;
                }
                if (!i2 && this.eat(10)) {
                  let A2 = this.startNodeAt(s2);
                  return A2.callee = e25, A2.arguments = this.parseCallExpressionArguments(11, false), this.tsCheckForInvalidTypeCasts(A2.arguments), A2.typeParameters = p2, a2.optionalChainMember && (A2.optional = n2), this.finishCallExpression(A2, a2.optionalChainMember);
                }
                let m2 = this.state.type;
                if (m2 === 48 || m2 === 52 || m2 !== 10 && Xt2(m2) && !this.hasPrecedingLineBreak())
                  return;
                let x2 = this.startNodeAt(s2);
                return x2.expression = e25, x2.typeParameters = p2, this.finishNode(x2, "TSInstantiationExpression");
              });
              if (o2 && this.unexpected(o2, 10), c2)
                return c2.type === "TSInstantiationExpression" && (this.match(16) || this.match(18) && this.lookaheadCharCode() !== 40) && this.raise(w2.InvalidPropertyAccessAfterInstantiationExpression, { at: this.state.startLoc }), c2;
            }
            return super.parseSubscript(e25, s2, i2, a2);
          }
          parseNewCallee(e25) {
            var s2;
            super.parseNewCallee(e25);
            let { callee: i2 } = e25;
            i2.type === "TSInstantiationExpression" && !((s2 = i2.extra) != null && s2.parenthesized) && (e25.typeParameters = i2.typeParameters, e25.callee = i2.expression);
          }
          parseExprOp(e25, s2, i2) {
            let a2;
            if (ut2(58) > i2 && !this.hasPrecedingLineBreak() && (this.isContextual(93) || (a2 = this.isContextual(118)))) {
              let n2 = this.startNodeAt(s2);
              return n2.expression = e25, n2.typeAnnotation = this.tsInType(() => (this.next(), this.match(75) ? (a2 && this.raise(u2.UnexpectedKeyword, { at: this.state.startLoc, keyword: "const" }), this.tsParseTypeReference()) : this.tsParseType())), this.finishNode(n2, a2 ? "TSSatisfiesExpression" : "TSAsExpression"), this.reScan_lt_gt(), this.parseExprOp(n2, s2, i2);
            }
            return super.parseExprOp(e25, s2, i2);
          }
          checkReservedWord(e25, s2, i2, a2) {
            this.state.isAmbientContext || super.checkReservedWord(e25, s2, i2, a2);
          }
          checkImportReflection(e25) {
            super.checkImportReflection(e25), e25.module && e25.importKind !== "value" && this.raise(w2.ImportReflectionHasImportType, { at: e25.specifiers[0].loc.start });
          }
          checkDuplicateExports() {
          }
          parseImport(e25) {
            if (e25.importKind = "value", z2(this.state.type) || this.match(55) || this.match(5)) {
              let i2 = this.lookahead();
              if (this.isContextual(128) && i2.type !== 12 && i2.type !== 97 && i2.type !== 29 && (e25.importKind = "type", this.next(), i2 = this.lookahead()), z2(this.state.type) && i2.type === 29)
                return this.tsParseImportEqualsDeclaration(e25);
            }
            let s2 = super.parseImport(e25);
            return s2.importKind === "type" && s2.specifiers.length > 1 && s2.specifiers[0].type === "ImportDefaultSpecifier" && this.raise(w2.TypeImportCannotSpecifyDefaultAndNamed, { at: s2 }), s2;
          }
          parseExport(e25, s2) {
            if (this.match(83))
              return this.next(), this.isContextual(128) && this.lookaheadCharCode() !== 61 ? (e25.importKind = "type", this.next()) : e25.importKind = "value", this.tsParseImportEqualsDeclaration(e25, true);
            if (this.eat(29)) {
              let i2 = e25;
              return i2.expression = super.parseExpression(), this.semicolon(), this.finishNode(i2, "TSExportAssignment");
            } else if (this.eatContextual(93)) {
              let i2 = e25;
              return this.expectContextual(126), i2.id = this.parseIdentifier(), this.semicolon(), this.finishNode(i2, "TSNamespaceExportDeclaration");
            } else
              return this.isContextual(128) && this.lookahead().type === 5 ? (this.next(), e25.exportKind = "type") : e25.exportKind = "value", super.parseExport(e25, s2);
          }
          isAbstractClass() {
            return this.isContextual(122) && this.lookahead().type === 80;
          }
          parseExportDefaultExpression() {
            if (this.isAbstractClass()) {
              let e25 = this.startNode();
              return this.next(), e25.abstract = true, this.parseClass(e25, true, true);
            }
            if (this.match(127)) {
              let e25 = this.tsParseInterfaceDeclaration(this.startNode());
              if (e25)
                return e25;
            }
            return super.parseExportDefaultExpression();
          }
          parseVarStatement(e25, s2) {
            let i2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, { isAmbientContext: a2 } = this.state, n2 = super.parseVarStatement(e25, s2, i2 || a2);
            if (!a2)
              return n2;
            for (let { id: o2, init: c2 } of n2.declarations)
              c2 && (s2 !== "const" || o2.typeAnnotation ? this.raise(w2.InitializerNotAllowedInAmbientContext, { at: c2 }) : c2.type !== "StringLiteral" && c2.type !== "BooleanLiteral" && c2.type !== "NumericLiteral" && c2.type !== "BigIntLiteral" && (c2.type !== "TemplateLiteral" || c2.expressions.length > 0) && !hh2(c2) && this.raise(w2.ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference, { at: c2 }));
            return n2;
          }
          parseStatementContent(e25, s2) {
            if (this.match(75) && this.isLookaheadContextual("enum")) {
              let i2 = this.startNode();
              return this.expect(75), this.tsParseEnumDeclaration(i2, { const: true });
            }
            if (this.isContextual(124))
              return this.tsParseEnumDeclaration(this.startNode());
            if (this.isContextual(127)) {
              let i2 = this.tsParseInterfaceDeclaration(this.startNode());
              if (i2)
                return i2;
            }
            return super.parseStatementContent(e25, s2);
          }
          parseAccessModifier() {
            return this.tsParseModifier(["public", "protected", "private"]);
          }
          tsHasSomeModifiers(e25, s2) {
            return s2.some((i2) => Xr2(i2) ? e25.accessibility === i2 : !!e25[i2]);
          }
          tsIsStartOfStaticBlocks() {
            return this.isContextual(104) && this.lookaheadCharCode() === 123;
          }
          parseClassMember(e25, s2, i2) {
            let a2 = ["declare", "private", "public", "protected", "override", "abstract", "readonly", "static"];
            this.tsParseModifiers({ modified: s2, allowedModifiers: a2, disallowedModifiers: ["in", "out"], stopOnStartOfClassStaticBlock: true, errorTemplate: w2.InvalidModifierOnTypeParameterPositions });
            let n2 = () => {
              this.tsIsStartOfStaticBlocks() ? (this.next(), this.next(), this.tsHasSomeModifiers(s2, a2) && this.raise(w2.StaticBlockCannotHaveModifier, { at: this.state.curPosition() }), super.parseClassStaticBlock(e25, s2)) : this.parseClassMemberWithIsStatic(e25, s2, i2, !!s2.static);
            };
            s2.declare ? this.tsInAmbientContext(n2) : n2();
          }
          parseClassMemberWithIsStatic(e25, s2, i2, a2) {
            let n2 = this.tsTryParseIndexSignature(s2);
            if (n2) {
              e25.body.push(n2), s2.abstract && this.raise(w2.IndexSignatureHasAbstract, { at: s2 }), s2.accessibility && this.raise(w2.IndexSignatureHasAccessibility, { at: s2, modifier: s2.accessibility }), s2.declare && this.raise(w2.IndexSignatureHasDeclare, { at: s2 }), s2.override && this.raise(w2.IndexSignatureHasOverride, { at: s2 });
              return;
            }
            !this.state.inAbstractClass && s2.abstract && this.raise(w2.NonAbstractClassHasAbstractMethod, { at: s2 }), s2.override && (i2.hadSuperClass || this.raise(w2.OverrideNotInSubClass, { at: s2 })), super.parseClassMemberWithIsStatic(e25, s2, i2, a2);
          }
          parsePostMemberNameModifiers(e25) {
            this.eat(17) && (e25.optional = true), e25.readonly && this.match(10) && this.raise(w2.ClassMethodHasReadonly, { at: e25 }), e25.declare && this.match(10) && this.raise(w2.ClassMethodHasDeclare, { at: e25 });
          }
          parseExpressionStatement(e25, s2, i2) {
            return (s2.type === "Identifier" ? this.tsParseExpressionStatement(e25, s2, i2) : void 0) || super.parseExpressionStatement(e25, s2, i2);
          }
          shouldParseExportDeclaration() {
            return this.tsIsDeclarationStart() ? true : super.shouldParseExportDeclaration();
          }
          parseConditional(e25, s2, i2) {
            if (!this.state.maybeInArrowParameters || !this.match(17))
              return super.parseConditional(e25, s2, i2);
            let a2 = this.tryParse(() => super.parseConditional(e25, s2));
            return a2.node ? (a2.error && (this.state = a2.failState), a2.node) : (a2.error && super.setOptionalParametersError(i2, a2.error), e25);
          }
          parseParenItem(e25, s2) {
            if (e25 = super.parseParenItem(e25, s2), this.eat(17) && (e25.optional = true, this.resetEndLocation(e25)), this.match(14)) {
              let i2 = this.startNodeAt(s2);
              return i2.expression = e25, i2.typeAnnotation = this.tsParseTypeAnnotation(), this.finishNode(i2, "TSTypeCastExpression");
            }
            return e25;
          }
          parseExportDeclaration(e25) {
            if (!this.state.isAmbientContext && this.isContextual(123))
              return this.tsInAmbientContext(() => this.parseExportDeclaration(e25));
            let s2 = this.state.startLoc, i2 = this.eatContextual(123);
            if (i2 && (this.isContextual(123) || !this.shouldParseExportDeclaration()))
              throw this.raise(w2.ExpectedAmbientAfterExportDeclare, { at: this.state.startLoc });
            let n2 = z2(this.state.type) && this.tsTryParseExportDeclaration() || super.parseExportDeclaration(e25);
            return n2 ? ((n2.type === "TSInterfaceDeclaration" || n2.type === "TSTypeAliasDeclaration" || i2) && (e25.exportKind = "type"), i2 && (this.resetStartLocation(n2, s2), n2.declare = true), n2) : null;
          }
          parseClassId(e25, s2, i2, a2) {
            if ((!s2 || i2) && this.isContextual(111))
              return;
            super.parseClassId(e25, s2, i2, e25.declare ? Lr2 : kr);
            let n2 = this.tsTryParseTypeParameters(this.tsParseInOutModifiers.bind(this));
            n2 && (e25.typeParameters = n2);
          }
          parseClassPropertyAnnotation(e25) {
            e25.optional || (this.eat(35) ? e25.definite = true : this.eat(17) && (e25.optional = true));
            let s2 = this.tsTryParseTypeAnnotation();
            s2 && (e25.typeAnnotation = s2);
          }
          parseClassProperty(e25) {
            if (this.parseClassPropertyAnnotation(e25), this.state.isAmbientContext && !(e25.readonly && !e25.typeAnnotation) && this.match(29) && this.raise(w2.DeclareClassFieldHasInitializer, { at: this.state.startLoc }), e25.abstract && this.match(29)) {
              let { key: s2 } = e25;
              this.raise(w2.AbstractPropertyHasInitializer, { at: this.state.startLoc, propertyName: s2.type === "Identifier" && !e25.computed ? s2.name : `[${this.input.slice(s2.start, s2.end)}]` });
            }
            return super.parseClassProperty(e25);
          }
          parseClassPrivateProperty(e25) {
            return e25.abstract && this.raise(w2.PrivateElementHasAbstract, { at: e25 }), e25.accessibility && this.raise(w2.PrivateElementHasAccessibility, { at: e25, modifier: e25.accessibility }), this.parseClassPropertyAnnotation(e25), super.parseClassPrivateProperty(e25);
          }
          parseClassAccessorProperty(e25) {
            return this.parseClassPropertyAnnotation(e25), e25.optional && this.raise(w2.AccessorCannotBeOptional, { at: e25 }), super.parseClassAccessorProperty(e25);
          }
          pushClassMethod(e25, s2, i2, a2, n2, o2) {
            let c2 = this.tsTryParseTypeParameters();
            c2 && n2 && this.raise(w2.ConstructorHasTypeParameters, { at: c2 });
            let { declare: p2 = false, kind: m2 } = s2;
            p2 && (m2 === "get" || m2 === "set") && this.raise(w2.DeclareAccessor, { at: s2, kind: m2 }), c2 && (s2.typeParameters = c2), super.pushClassMethod(e25, s2, i2, a2, n2, o2);
          }
          pushClassPrivateMethod(e25, s2, i2, a2) {
            let n2 = this.tsTryParseTypeParameters();
            n2 && (s2.typeParameters = n2), super.pushClassPrivateMethod(e25, s2, i2, a2);
          }
          declareClassPrivateMethodInScope(e25, s2) {
            e25.type !== "TSDeclareMethod" && (e25.type === "MethodDefinition" && !e25.value.body || super.declareClassPrivateMethodInScope(e25, s2));
          }
          parseClassSuper(e25) {
            super.parseClassSuper(e25), e25.superClass && (this.match(47) || this.match(51)) && (e25.superTypeParameters = this.tsParseTypeArgumentsInExpression()), this.eatContextual(111) && (e25.implements = this.tsParseHeritageClause("implements"));
          }
          parseObjPropValue(e25, s2, i2, a2, n2, o2, c2) {
            let p2 = this.tsTryParseTypeParameters();
            return p2 && (e25.typeParameters = p2), super.parseObjPropValue(e25, s2, i2, a2, n2, o2, c2);
          }
          parseFunctionParams(e25, s2) {
            let i2 = this.tsTryParseTypeParameters();
            i2 && (e25.typeParameters = i2), super.parseFunctionParams(e25, s2);
          }
          parseVarId(e25, s2) {
            super.parseVarId(e25, s2), e25.id.type === "Identifier" && !this.hasPrecedingLineBreak() && this.eat(35) && (e25.definite = true);
            let i2 = this.tsTryParseTypeAnnotation();
            i2 && (e25.id.typeAnnotation = i2, this.resetEndLocation(e25.id));
          }
          parseAsyncArrowFromCallExpression(e25, s2) {
            return this.match(14) && (e25.returnType = this.tsParseTypeAnnotation()), super.parseAsyncArrowFromCallExpression(e25, s2);
          }
          parseMaybeAssign(e25, s2) {
            var i2, a2, n2, o2, c2, p2, m2;
            let x2, A2, b2;
            if (this.hasPlugin("jsx") && (this.match(140) || this.match(47))) {
              if (x2 = this.state.clone(), A2 = this.tryParse(() => super.parseMaybeAssign(e25, s2), x2), !A2.error)
                return A2.node;
              let { context: Y2 } = this.state, Q2 = Y2[Y2.length - 1];
              (Q2 === $2.j_oTag || Q2 === $2.j_expr) && Y2.pop();
            }
            if (!((i2 = A2) != null && i2.error) && !this.match(47))
              return super.parseMaybeAssign(e25, s2);
            (!x2 || x2 === this.state) && (x2 = this.state.clone());
            let O2, R2 = this.tryParse((Y2) => {
              var Q2, J2;
              O2 = this.tsParseTypeParameters();
              let se2 = super.parseMaybeAssign(e25, s2);
              return (se2.type !== "ArrowFunctionExpression" || (Q2 = se2.extra) != null && Q2.parenthesized) && Y2(), ((J2 = O2) == null ? void 0 : J2.params.length) !== 0 && this.resetStartLocationFromNode(se2, O2), se2.typeParameters = O2, se2;
            }, x2);
            if (!R2.error && !R2.aborted)
              return O2 && this.reportReservedArrowTypeParam(O2), R2.node;
            if (!A2 && (Jr2(!this.hasPlugin("jsx")), b2 = this.tryParse(() => super.parseMaybeAssign(e25, s2), x2), !b2.error))
              return b2.node;
            if ((a2 = A2) != null && a2.node)
              return this.state = A2.failState, A2.node;
            if (R2.node)
              return this.state = R2.failState, O2 && this.reportReservedArrowTypeParam(O2), R2.node;
            if ((n2 = b2) != null && n2.node)
              return this.state = b2.failState, b2.node;
            throw (o2 = A2) != null && o2.thrown ? A2.error : R2.thrown ? R2.error : (c2 = b2) != null && c2.thrown ? b2.error : ((p2 = A2) == null ? void 0 : p2.error) || R2.error || ((m2 = b2) == null ? void 0 : m2.error);
          }
          reportReservedArrowTypeParam(e25) {
            var s2;
            e25.params.length === 1 && !((s2 = e25.extra) != null && s2.trailingComma) && this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(w2.ReservedArrowTypeParam, { at: e25 });
          }
          parseMaybeUnary(e25, s2) {
            return !this.hasPlugin("jsx") && this.match(47) ? this.tsParseTypeAssertion() : super.parseMaybeUnary(e25, s2);
          }
          parseArrow(e25) {
            if (this.match(14)) {
              let s2 = this.tryParse((i2) => {
                let a2 = this.tsParseTypeOrTypePredicateAnnotation(14);
                return (this.canInsertSemicolon() || !this.match(19)) && i2(), a2;
              });
              if (s2.aborted)
                return;
              s2.thrown || (s2.error && (this.state = s2.failState), e25.returnType = s2.node);
            }
            return super.parseArrow(e25);
          }
          parseAssignableListItemTypes(e25) {
            this.eat(17) && (e25.type !== "Identifier" && !this.state.isAmbientContext && !this.state.inType && this.raise(w2.PatternIsOptional, { at: e25 }), e25.optional = true);
            let s2 = this.tsTryParseTypeAnnotation();
            return s2 && (e25.typeAnnotation = s2), this.resetEndLocation(e25), e25;
          }
          isAssignable(e25, s2) {
            switch (e25.type) {
              case "TSTypeCastExpression":
                return this.isAssignable(e25.expression, s2);
              case "TSParameterProperty":
                return true;
              default:
                return super.isAssignable(e25, s2);
            }
          }
          toAssignable(e25) {
            let s2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            switch (e25.type) {
              case "ParenthesizedExpression":
                this.toAssignableParenthesizedExpression(e25, s2);
                break;
              case "TSAsExpression":
              case "TSSatisfiesExpression":
              case "TSNonNullExpression":
              case "TSTypeAssertion":
                s2 ? this.expressionScope.recordArrowParameterBindingError(w2.UnexpectedTypeCastInParameter, { at: e25 }) : this.raise(w2.UnexpectedTypeCastInParameter, { at: e25 }), this.toAssignable(e25.expression, s2);
                break;
              case "AssignmentExpression":
                !s2 && e25.left.type === "TSTypeCastExpression" && (e25.left = this.typeCastToParameter(e25.left));
              default:
                super.toAssignable(e25, s2);
            }
          }
          toAssignableParenthesizedExpression(e25, s2) {
            switch (e25.expression.type) {
              case "TSAsExpression":
              case "TSSatisfiesExpression":
              case "TSNonNullExpression":
              case "TSTypeAssertion":
              case "ParenthesizedExpression":
                this.toAssignable(e25.expression, s2);
                break;
              default:
                super.toAssignable(e25, s2);
            }
          }
          checkToRestConversion(e25, s2) {
            switch (e25.type) {
              case "TSAsExpression":
              case "TSSatisfiesExpression":
              case "TSTypeAssertion":
              case "TSNonNullExpression":
                this.checkToRestConversion(e25.expression, false);
                break;
              default:
                super.checkToRestConversion(e25, s2);
            }
          }
          isValidLVal(e25, s2, i2) {
            return ih2({ TSTypeCastExpression: true, TSParameterProperty: "parameter", TSNonNullExpression: "expression", TSAsExpression: (i2 !== be2 || !s2) && ["expression", true], TSSatisfiesExpression: (i2 !== be2 || !s2) && ["expression", true], TSTypeAssertion: (i2 !== be2 || !s2) && ["expression", true] }, e25) || super.isValidLVal(e25, s2, i2);
          }
          parseBindingAtom() {
            switch (this.state.type) {
              case 78:
                return this.parseIdentifier(true);
              default:
                return super.parseBindingAtom();
            }
          }
          parseMaybeDecoratorArguments(e25) {
            if (this.match(47) || this.match(51)) {
              let s2 = this.tsParseTypeArgumentsInExpression();
              if (this.match(10)) {
                let i2 = super.parseMaybeDecoratorArguments(e25);
                return i2.typeParameters = s2, i2;
              }
              this.unexpected(null, 10);
            }
            return super.parseMaybeDecoratorArguments(e25);
          }
          checkCommaAfterRest(e25) {
            return this.state.isAmbientContext && this.match(12) && this.lookaheadCharCode() === e25 ? (this.next(), false) : super.checkCommaAfterRest(e25);
          }
          isClassMethod() {
            return this.match(47) || super.isClassMethod();
          }
          isClassProperty() {
            return this.match(35) || this.match(14) || super.isClassProperty();
          }
          parseMaybeDefault(e25, s2) {
            let i2 = super.parseMaybeDefault(e25, s2);
            return i2.type === "AssignmentPattern" && i2.typeAnnotation && i2.right.start < i2.typeAnnotation.start && this.raise(w2.TypeAnnotationAfterAssign, { at: i2.typeAnnotation }), i2;
          }
          getTokenFromCode(e25) {
            if (this.state.inType) {
              if (e25 === 62)
                return this.finishOp(48, 1);
              if (e25 === 60)
                return this.finishOp(47, 1);
            }
            return super.getTokenFromCode(e25);
          }
          reScan_lt_gt() {
            let { type: e25 } = this.state;
            e25 === 47 ? (this.state.pos -= 1, this.readToken_lt()) : e25 === 48 && (this.state.pos -= 1, this.readToken_gt());
          }
          reScan_lt() {
            let { type: e25 } = this.state;
            return e25 === 51 ? (this.state.pos -= 2, this.finishOp(47, 1), 47) : e25;
          }
          toAssignableList(e25, s2, i2) {
            for (let a2 = 0; a2 < e25.length; a2++) {
              let n2 = e25[a2];
              (n2 == null ? void 0 : n2.type) === "TSTypeCastExpression" && (e25[a2] = this.typeCastToParameter(n2));
            }
            super.toAssignableList(e25, s2, i2);
          }
          typeCastToParameter(e25) {
            return e25.expression.typeAnnotation = e25.typeAnnotation, this.resetEndLocation(e25.expression, e25.typeAnnotation.loc.end), e25.expression;
          }
          shouldParseArrow(e25) {
            return this.match(14) ? e25.every((s2) => this.isAssignable(s2, true)) : super.shouldParseArrow(e25);
          }
          shouldParseAsyncArrow() {
            return this.match(14) || super.shouldParseAsyncArrow();
          }
          canHaveLeadingDecorator() {
            return super.canHaveLeadingDecorator() || this.isAbstractClass();
          }
          jsxParseOpeningElementAfterName(e25) {
            if (this.match(47) || this.match(51)) {
              let s2 = this.tsTryParseAndCatch(() => this.tsParseTypeArgumentsInExpression());
              s2 && (e25.typeParameters = s2);
            }
            return super.jsxParseOpeningElementAfterName(e25);
          }
          getGetterSetterExpectedParamCount(e25) {
            let s2 = super.getGetterSetterExpectedParamCount(e25), a2 = this.getObjectOrClassMethodParams(e25)[0];
            return a2 && this.isThisParam(a2) ? s2 + 1 : s2;
          }
          parseCatchClauseParam() {
            let e25 = super.parseCatchClauseParam(), s2 = this.tsTryParseTypeAnnotation();
            return s2 && (e25.typeAnnotation = s2, this.resetEndLocation(e25)), e25;
          }
          tsInAmbientContext(e25) {
            let s2 = this.state.isAmbientContext;
            this.state.isAmbientContext = true;
            try {
              return e25();
            } finally {
              this.state.isAmbientContext = s2;
            }
          }
          parseClass(e25, s2, i2) {
            let a2 = this.state.inAbstractClass;
            this.state.inAbstractClass = !!e25.abstract;
            try {
              return super.parseClass(e25, s2, i2);
            } finally {
              this.state.inAbstractClass = a2;
            }
          }
          tsParseAbstractDeclaration(e25, s2) {
            if (this.match(80))
              return e25.abstract = true, this.maybeTakeDecorators(s2, this.parseClass(e25, true, false));
            if (this.isContextual(127)) {
              if (!this.hasFollowingLineBreak())
                return e25.abstract = true, this.raise(w2.NonClassMethodPropertyHasAbstractModifer, { at: e25 }), this.tsParseInterfaceDeclaration(e25);
            } else
              this.unexpected(null, 80);
          }
          parseMethod(e25, s2, i2, a2, n2, o2, c2) {
            let p2 = super.parseMethod(e25, s2, i2, a2, n2, o2, c2);
            if (p2.abstract && (this.hasPlugin("estree") ? !!p2.value.body : !!p2.body)) {
              let { key: x2 } = p2;
              this.raise(w2.AbstractMethodHasImplementation, { at: p2, methodName: x2.type === "Identifier" && !p2.computed ? x2.name : `[${this.input.slice(x2.start, x2.end)}]` });
            }
            return p2;
          }
          tsParseTypeParameterName() {
            return this.parseIdentifier().name;
          }
          shouldParseAsAmbientContext() {
            return !!this.getPluginOption("typescript", "dts");
          }
          parse() {
            return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = true), super.parse();
          }
          getExpression() {
            return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = true), super.getExpression();
          }
          parseExportSpecifier(e25, s2, i2, a2) {
            return !s2 && a2 ? (this.parseTypeOnlyImportExportSpecifier(e25, false, i2), this.finishNode(e25, "ExportSpecifier")) : (e25.exportKind = "value", super.parseExportSpecifier(e25, s2, i2, a2));
          }
          parseImportSpecifier(e25, s2, i2, a2, n2) {
            return !s2 && a2 ? (this.parseTypeOnlyImportExportSpecifier(e25, true, i2), this.finishNode(e25, "ImportSpecifier")) : (e25.importKind = "value", super.parseImportSpecifier(e25, s2, i2, a2, i2 ? Or2 : Ye2));
          }
          parseTypeOnlyImportExportSpecifier(e25, s2, i2) {
            let a2 = s2 ? "imported" : "local", n2 = s2 ? "local" : "exported", o2 = e25[a2], c2, p2 = false, m2 = true, x2 = o2.loc.start;
            if (this.isContextual(93)) {
              let b2 = this.parseIdentifier();
              if (this.isContextual(93)) {
                let O2 = this.parseIdentifier();
                ye2(this.state.type) ? (p2 = true, o2 = b2, c2 = s2 ? this.parseIdentifier() : this.parseModuleExportName(), m2 = false) : (c2 = O2, m2 = false);
              } else
                ye2(this.state.type) ? (m2 = false, c2 = s2 ? this.parseIdentifier() : this.parseModuleExportName()) : (p2 = true, o2 = b2);
            } else
              ye2(this.state.type) && (p2 = true, s2 ? (o2 = this.parseIdentifier(true), this.isContextual(93) || this.checkReservedWord(o2.name, o2.loc.start, true, true)) : o2 = this.parseModuleExportName());
            p2 && i2 && this.raise(s2 ? w2.TypeModifierIsUsedInTypeImports : w2.TypeModifierIsUsedInTypeExports, { at: x2 }), e25[a2] = o2, e25[n2] = c2;
            let A2 = s2 ? "importKind" : "exportKind";
            e25[A2] = p2 ? "type" : "value", m2 && this.eatContextual(93) && (e25[n2] = s2 ? this.parseIdentifier() : this.parseModuleExportName()), e25[n2] || (e25[n2] = Te2(e25[a2])), s2 && this.checkIdentifier(e25[n2], p2 ? Or2 : Ye2);
          }
        };
        function hh2(t2) {
          if (t2.type !== "MemberExpression")
            return false;
          let { computed: r2, property: e25 } = t2;
          return r2 && e25.type !== "StringLiteral" && (e25.type !== "TemplateLiteral" || e25.expressions.length > 0) ? false : Yr2(t2.object);
        }
        function Yr2(t2) {
          return t2.type === "Identifier" ? true : t2.type !== "MemberExpression" || t2.computed ? false : Yr2(t2.object);
        }
        var Qr2 = _2`placeholders`({ ClassNameIsRequired: "A class name is required.", UnexpectedSpace: "Unexpected space in placeholder." }), uh2 = (t2) => class extends t2 {
          parsePlaceholder(e25) {
            if (this.match(142)) {
              let s2 = this.startNode();
              return this.next(), this.assertNoSpace(), s2.name = super.parseIdentifier(true), this.assertNoSpace(), this.expect(142), this.finishPlaceholder(s2, e25);
            }
          }
          finishPlaceholder(e25, s2) {
            let i2 = !!(e25.expectedNode && e25.type === "Placeholder");
            return e25.expectedNode = s2, i2 ? e25 : this.finishNode(e25, "Placeholder");
          }
          getTokenFromCode(e25) {
            return e25 === 37 && this.input.charCodeAt(this.state.pos + 1) === 37 ? this.finishOp(142, 2) : super.getTokenFromCode(e25);
          }
          parseExprAtom(e25) {
            return this.parsePlaceholder("Expression") || super.parseExprAtom(e25);
          }
          parseIdentifier(e25) {
            return this.parsePlaceholder("Identifier") || super.parseIdentifier(e25);
          }
          checkReservedWord(e25, s2, i2, a2) {
            e25 !== void 0 && super.checkReservedWord(e25, s2, i2, a2);
          }
          parseBindingAtom() {
            return this.parsePlaceholder("Pattern") || super.parseBindingAtom();
          }
          isValidLVal(e25, s2, i2) {
            return e25 === "Placeholder" || super.isValidLVal(e25, s2, i2);
          }
          toAssignable(e25, s2) {
            e25 && e25.type === "Placeholder" && e25.expectedNode === "Expression" ? e25.expectedNode = "Pattern" : super.toAssignable(e25, s2);
          }
          chStartsBindingIdentifier(e25, s2) {
            return !!(super.chStartsBindingIdentifier(e25, s2) || this.lookahead().type === 142);
          }
          verifyBreakContinue(e25, s2) {
            e25.label && e25.label.type === "Placeholder" || super.verifyBreakContinue(e25, s2);
          }
          parseExpressionStatement(e25, s2) {
            if (s2.type !== "Placeholder" || s2.extra && s2.extra.parenthesized)
              return super.parseExpressionStatement(e25, s2);
            if (this.match(14)) {
              let i2 = e25;
              return i2.label = this.finishPlaceholder(s2, "Identifier"), this.next(), i2.body = super.parseStatementOrFunctionDeclaration(false), this.finishNode(i2, "LabeledStatement");
            }
            return this.semicolon(), e25.name = s2.name, this.finishPlaceholder(e25, "Statement");
          }
          parseBlock(e25, s2, i2) {
            return this.parsePlaceholder("BlockStatement") || super.parseBlock(e25, s2, i2);
          }
          parseFunctionId(e25) {
            return this.parsePlaceholder("Identifier") || super.parseFunctionId(e25);
          }
          parseClass(e25, s2, i2) {
            let a2 = s2 ? "ClassDeclaration" : "ClassExpression";
            this.next();
            let n2 = this.state.strict, o2 = this.parsePlaceholder("Identifier");
            if (o2)
              if (this.match(81) || this.match(142) || this.match(5))
                e25.id = o2;
              else {
                if (i2 || !s2)
                  return e25.id = null, e25.body = this.finishPlaceholder(o2, "ClassBody"), this.finishNode(e25, a2);
                throw this.raise(Qr2.ClassNameIsRequired, { at: this.state.startLoc });
              }
            else
              this.parseClassId(e25, s2, i2);
            return super.parseClassSuper(e25), e25.body = this.parsePlaceholder("ClassBody") || super.parseClassBody(!!e25.superClass, n2), this.finishNode(e25, a2);
          }
          parseExport(e25, s2) {
            let i2 = this.parsePlaceholder("Identifier");
            if (!i2)
              return super.parseExport(e25, s2);
            if (!this.isContextual(97) && !this.match(12))
              return e25.specifiers = [], e25.source = null, e25.declaration = this.finishPlaceholder(i2, "Declaration"), this.finishNode(e25, "ExportNamedDeclaration");
            this.expectPlugin("exportDefaultFrom");
            let a2 = this.startNode();
            return a2.exported = i2, e25.specifiers = [this.finishNode(a2, "ExportDefaultSpecifier")], super.parseExport(e25, s2);
          }
          isExportDefaultSpecifier() {
            if (this.match(65)) {
              let e25 = this.nextTokenStart();
              if (this.isUnparsedContextual(e25, "from") && this.input.startsWith(Ee2(142), this.nextTokenStartSince(e25 + 4)))
                return true;
            }
            return super.isExportDefaultSpecifier();
          }
          maybeParseExportDefaultSpecifier(e25) {
            return e25.specifiers && e25.specifiers.length > 0 ? true : super.maybeParseExportDefaultSpecifier(e25);
          }
          checkExport(e25) {
            let { specifiers: s2 } = e25;
            s2 != null && s2.length && (e25.specifiers = s2.filter((i2) => i2.exported.type === "Placeholder")), super.checkExport(e25), e25.specifiers = s2;
          }
          parseImport(e25) {
            let s2 = this.parsePlaceholder("Identifier");
            if (!s2)
              return super.parseImport(e25);
            if (e25.specifiers = [], !this.isContextual(97) && !this.match(12))
              return e25.source = this.finishPlaceholder(s2, "StringLiteral"), this.semicolon(), this.finishNode(e25, "ImportDeclaration");
            let i2 = this.startNodeAtNode(s2);
            return i2.local = s2, e25.specifiers.push(this.finishNode(i2, "ImportDefaultSpecifier")), this.eat(12) && (this.maybeParseStarImportSpecifier(e25) || this.parseNamedImportSpecifiers(e25)), this.expectContextual(97), e25.source = this.parseImportSource(), this.semicolon(), this.finishNode(e25, "ImportDeclaration");
          }
          parseImportSource() {
            return this.parsePlaceholder("StringLiteral") || super.parseImportSource();
          }
          assertNoSpace() {
            this.state.start > this.state.lastTokEndLoc.index && this.raise(Qr2.UnexpectedSpace, { at: this.state.lastTokEndLoc });
          }
        }, ch2 = (t2) => class extends t2 {
          parseV8Intrinsic() {
            if (this.match(54)) {
              let e25 = this.state.startLoc, s2 = this.startNode();
              if (this.next(), z2(this.state.type)) {
                let i2 = this.parseIdentifierName(), a2 = this.createIdentifier(s2, i2);
                if (a2.type = "V8IntrinsicIdentifier", this.match(10))
                  return a2;
              }
              this.unexpected(e25);
            }
          }
          parseExprAtom(e25) {
            return this.parseV8Intrinsic() || super.parseExprAtom(e25);
          }
        };
        function te2(t2, r2) {
          let [e25, s2] = typeof r2 == "string" ? [r2, {}] : r2, i2 = Object.keys(s2), a2 = i2.length === 0;
          return t2.some((n2) => {
            if (typeof n2 == "string")
              return a2 && n2 === e25;
            {
              let [o2, c2] = n2;
              if (o2 !== e25)
                return false;
              for (let p2 of i2)
                if (c2[p2] !== s2[p2])
                  return false;
              return true;
            }
          });
        }
        function Le2(t2, r2, e25) {
          let s2 = t2.find((i2) => Array.isArray(i2) ? i2[0] === r2 : i2 === r2);
          return s2 && Array.isArray(s2) && s2.length > 1 ? s2[1][e25] : null;
        }
        var Zr2 = ["minimal", "fsharp", "hack", "smart"], ei2 = ["^^", "@@", "^", "%", "#"], ti2 = ["hash", "bar"];
        function ph2(t2) {
          if (te2(t2, "decorators")) {
            if (te2(t2, "decorators-legacy"))
              throw new Error("Cannot use the decorators and decorators-legacy plugin together");
            let r2 = Le2(t2, "decorators", "decoratorsBeforeExport");
            if (r2 != null && typeof r2 != "boolean")
              throw new Error("'decoratorsBeforeExport' must be a boolean.");
            let e25 = Le2(t2, "decorators", "allowCallParenthesized");
            if (e25 != null && typeof e25 != "boolean")
              throw new Error("'allowCallParenthesized' must be a boolean.");
          }
          if (te2(t2, "flow") && te2(t2, "typescript"))
            throw new Error("Cannot combine flow and typescript plugins.");
          if (te2(t2, "placeholders") && te2(t2, "v8intrinsic"))
            throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
          if (te2(t2, "pipelineOperator")) {
            let r2 = Le2(t2, "pipelineOperator", "proposal");
            if (!Zr2.includes(r2)) {
              let s2 = Zr2.map((i2) => `"${i2}"`).join(", ");
              throw new Error(`"pipelineOperator" requires "proposal" option whose value must be one of: ${s2}.`);
            }
            let e25 = te2(t2, ["recordAndTuple", { syntaxType: "hash" }]);
            if (r2 === "hack") {
              if (te2(t2, "placeholders"))
                throw new Error("Cannot combine placeholders plugin and Hack-style pipes.");
              if (te2(t2, "v8intrinsic"))
                throw new Error("Cannot combine v8intrinsic plugin and Hack-style pipes.");
              let s2 = Le2(t2, "pipelineOperator", "topicToken");
              if (!ei2.includes(s2)) {
                let i2 = ei2.map((a2) => `"${a2}"`).join(", ");
                throw new Error(`"pipelineOperator" in "proposal": "hack" mode also requires a "topicToken" option whose value must be one of: ${i2}.`);
              }
              if (s2 === "#" && e25)
                throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "hack", topicToken: "#" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
            } else if (r2 === "smart" && e25)
              throw new Error('Plugin conflict between `["pipelineOperator", { proposal: "smart" }]` and `["recordAndtuple", { syntaxType: "hash"}]`.');
          }
          if (te2(t2, "moduleAttributes")) {
            if (te2(t2, "importAssertions"))
              throw new Error("Cannot combine importAssertions and moduleAttributes plugins.");
            if (Le2(t2, "moduleAttributes", "version") !== "may-2020")
              throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
          }
          if (te2(t2, "recordAndTuple") && Le2(t2, "recordAndTuple", "syntaxType") != null && !ti2.includes(Le2(t2, "recordAndTuple", "syntaxType")))
            throw new Error("The 'syntaxType' option of the 'recordAndTuple' plugin must be one of: " + ti2.map((r2) => `'${r2}'`).join(", "));
          if (te2(t2, "asyncDoExpressions") && !te2(t2, "doExpressions")) {
            let r2 = new Error("'asyncDoExpressions' requires 'doExpressions', please add 'doExpressions' to parser plugins.");
            throw r2.missingPlugins = "doExpressions", r2;
          }
        }
        var si2 = { estree: _e2, jsx: th2, flow: Zl2, typescript: lh2, v8intrinsic: ch2, placeholders: uh2 }, fh2 = Object.keys(si2), ri2 = { sourceType: "script", sourceFilename: void 0, startColumn: 0, startLine: 1, allowAwaitOutsideFunction: false, allowReturnOutsideFunction: false, allowImportExportEverywhere: false, allowSuperOutsideMethod: false, allowUndeclaredExports: false, plugins: [], strictMode: null, ranges: false, tokens: false, createParenthesizedExpressions: false, errorRecovery: false, attachComment: true };
        function dh2(t2) {
          let r2 = {};
          for (let e25 of Object.keys(ri2))
            r2[e25] = t2 && t2[e25] != null ? t2[e25] : ri2[e25];
          return r2;
        }
        var mh2 = (t2, r2) => Object.hasOwnProperty.call(t2, r2) && t2[r2], ii2 = (t2) => t2.type === "ParenthesizedExpression" ? ii2(t2.expression) : t2, yh2 = class extends Wl2 {
          toAssignable(t2) {
            let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var e25, s2;
            let i2;
            switch ((t2.type === "ParenthesizedExpression" || (e25 = t2.extra) != null && e25.parenthesized) && (i2 = ii2(t2), r2 ? i2.type === "Identifier" ? this.expressionScope.recordArrowParameterBindingError(u2.InvalidParenthesizedAssignment, { at: t2 }) : i2.type !== "MemberExpression" && this.raise(u2.InvalidParenthesizedAssignment, { at: t2 }) : this.raise(u2.InvalidParenthesizedAssignment, { at: t2 })), t2.type) {
              case "Identifier":
              case "ObjectPattern":
              case "ArrayPattern":
              case "AssignmentPattern":
              case "RestElement":
                break;
              case "ObjectExpression":
                t2.type = "ObjectPattern";
                for (let n2 = 0, o2 = t2.properties.length, c2 = o2 - 1; n2 < o2; n2++) {
                  var a2;
                  let p2 = t2.properties[n2], m2 = n2 === c2;
                  this.toAssignableObjectExpressionProp(p2, m2, r2), m2 && p2.type === "RestElement" && (a2 = t2.extra) != null && a2.trailingCommaLoc && this.raise(u2.RestTrailingComma, { at: t2.extra.trailingCommaLoc });
                }
                break;
              case "ObjectProperty": {
                let { key: n2, value: o2 } = t2;
                this.isPrivateName(n2) && this.classScope.usePrivateName(this.getPrivateNameSV(n2), n2.loc.start), this.toAssignable(o2, r2);
                break;
              }
              case "SpreadElement":
                throw new Error("Internal @babel/parser error (this is a bug, please report it). SpreadElement should be converted by .toAssignable's caller.");
              case "ArrayExpression":
                t2.type = "ArrayPattern", this.toAssignableList(t2.elements, (s2 = t2.extra) == null ? void 0 : s2.trailingCommaLoc, r2);
                break;
              case "AssignmentExpression":
                t2.operator !== "=" && this.raise(u2.MissingEqInAssignment, { at: t2.left.loc.end }), t2.type = "AssignmentPattern", delete t2.operator, this.toAssignable(t2.left, r2);
                break;
              case "ParenthesizedExpression":
                this.toAssignable(i2, r2);
                break;
            }
          }
          toAssignableObjectExpressionProp(t2, r2, e25) {
            if (t2.type === "ObjectMethod")
              this.raise(t2.kind === "get" || t2.kind === "set" ? u2.PatternHasAccessor : u2.PatternHasMethod, { at: t2.key });
            else if (t2.type === "SpreadElement") {
              t2.type = "RestElement";
              let s2 = t2.argument;
              this.checkToRestConversion(s2, false), this.toAssignable(s2, e25), r2 || this.raise(u2.RestTrailingComma, { at: t2 });
            } else
              this.toAssignable(t2, e25);
          }
          toAssignableList(t2, r2, e25) {
            let s2 = t2.length - 1;
            for (let i2 = 0; i2 <= s2; i2++) {
              let a2 = t2[i2];
              if (a2) {
                if (a2.type === "SpreadElement") {
                  a2.type = "RestElement";
                  let n2 = a2.argument;
                  this.checkToRestConversion(n2, true), this.toAssignable(n2, e25);
                } else
                  this.toAssignable(a2, e25);
                a2.type === "RestElement" && (i2 < s2 ? this.raise(u2.RestTrailingComma, { at: a2 }) : r2 && this.raise(u2.RestTrailingComma, { at: r2 }));
              }
            }
          }
          isAssignable(t2, r2) {
            switch (t2.type) {
              case "Identifier":
              case "ObjectPattern":
              case "ArrayPattern":
              case "AssignmentPattern":
              case "RestElement":
                return true;
              case "ObjectExpression": {
                let e25 = t2.properties.length - 1;
                return t2.properties.every((s2, i2) => s2.type !== "ObjectMethod" && (i2 === e25 || s2.type !== "SpreadElement") && this.isAssignable(s2));
              }
              case "ObjectProperty":
                return this.isAssignable(t2.value);
              case "SpreadElement":
                return this.isAssignable(t2.argument);
              case "ArrayExpression":
                return t2.elements.every((e25) => e25 === null || this.isAssignable(e25));
              case "AssignmentExpression":
                return t2.operator === "=";
              case "ParenthesizedExpression":
                return this.isAssignable(t2.expression);
              case "MemberExpression":
              case "OptionalMemberExpression":
                return !r2;
              default:
                return false;
            }
          }
          toReferencedList(t2, r2) {
            return t2;
          }
          toReferencedListDeep(t2, r2) {
            this.toReferencedList(t2, r2);
            for (let e25 of t2)
              (e25 == null ? void 0 : e25.type) === "ArrayExpression" && this.toReferencedListDeep(e25.elements);
          }
          parseSpread(t2) {
            let r2 = this.startNode();
            return this.next(), r2.argument = this.parseMaybeAssignAllowIn(t2, void 0), this.finishNode(r2, "SpreadElement");
          }
          parseRestBinding() {
            let t2 = this.startNode();
            return this.next(), t2.argument = this.parseBindingAtom(), this.finishNode(t2, "RestElement");
          }
          parseBindingAtom() {
            switch (this.state.type) {
              case 0: {
                let t2 = this.startNode();
                return this.next(), t2.elements = this.parseBindingList(3, 93, true), this.finishNode(t2, "ArrayPattern");
              }
              case 5:
                return this.parseObjectLike(8, true);
            }
            return this.parseIdentifier();
          }
          parseBindingList(t2, r2, e25, s2) {
            let i2 = [], a2 = true;
            for (; !this.eat(t2); )
              if (a2 ? a2 = false : this.expect(12), e25 && this.match(12))
                i2.push(null);
              else {
                if (this.eat(t2))
                  break;
                if (this.match(21)) {
                  if (i2.push(this.parseAssignableListItemTypes(this.parseRestBinding())), !this.checkCommaAfterRest(r2)) {
                    this.expect(t2);
                    break;
                  }
                } else {
                  let n2 = [];
                  for (this.match(26) && this.hasPlugin("decorators") && this.raise(u2.UnsupportedParameterDecorator, { at: this.state.startLoc }); this.match(26); )
                    n2.push(this.parseDecorator());
                  i2.push(this.parseAssignableListItem(s2, n2));
                }
              }
            return i2;
          }
          parseBindingRestProperty(t2) {
            return this.next(), t2.argument = this.parseIdentifier(), this.checkCommaAfterRest(125), this.finishNode(t2, "RestElement");
          }
          parseBindingProperty() {
            let t2 = this.startNode(), { type: r2, startLoc: e25 } = this.state;
            return r2 === 21 ? this.parseBindingRestProperty(t2) : (r2 === 136 ? (this.expectPlugin("destructuringPrivate", e25), this.classScope.usePrivateName(this.state.value, e25), t2.key = this.parsePrivateName()) : this.parsePropertyName(t2), t2.method = false, this.parseObjPropValue(t2, e25, false, false, true, false));
          }
          parseAssignableListItem(t2, r2) {
            let e25 = this.parseMaybeDefault();
            this.parseAssignableListItemTypes(e25);
            let s2 = this.parseMaybeDefault(e25.loc.start, e25);
            return r2.length && (e25.decorators = r2), s2;
          }
          parseAssignableListItemTypes(t2) {
            return t2;
          }
          parseMaybeDefault(t2, r2) {
            var s2;
            if (t2 != null || (t2 = this.state.startLoc), r2 = (s2 = r2) != null ? s2 : this.parseBindingAtom(), !this.eat(29))
              return r2;
            let i2 = this.startNodeAt(t2);
            return i2.left = r2, i2.right = this.parseMaybeAssignAllowIn(), this.finishNode(i2, "AssignmentPattern");
          }
          isValidLVal(t2, r2, e25) {
            return mh2({ AssignmentPattern: "left", RestElement: "argument", ObjectProperty: "value", ParenthesizedExpression: "expression", ArrayPattern: "elements", ObjectPattern: "properties" }, t2);
          }
          checkLVal(t2, r2) {
            let { in: e25, binding: s2 = be2, checkClashes: i2 = false, strictModeChanged: a2 = false, allowingSloppyLetBinding: n2 = !(s2 & Ce2), hasParenthesizedAncestor: o2 = false } = r2;
            var c2;
            let p2 = t2.type;
            if (this.isObjectMethod(t2))
              return;
            if (p2 === "MemberExpression") {
              s2 !== be2 && this.raise(u2.InvalidPropertyBindingPattern, { at: t2 });
              return;
            }
            if (t2.type === "Identifier") {
              this.checkIdentifier(t2, s2, a2, n2);
              let { name: O2 } = t2;
              i2 && (i2.has(O2) ? this.raise(u2.ParamDupe, { at: t2 }) : i2.add(O2));
              return;
            }
            let m2 = this.isValidLVal(t2.type, !(o2 || (c2 = t2.extra) != null && c2.parenthesized) && e25.type === "AssignmentExpression", s2);
            if (m2 === true)
              return;
            if (m2 === false) {
              let O2 = s2 === be2 ? u2.InvalidLhs : u2.InvalidLhsBinding;
              this.raise(O2, { at: t2, ancestor: e25.type === "UpdateExpression" ? { type: "UpdateExpression", prefix: e25.prefix } : { type: e25.type } });
              return;
            }
            let [x2, A2] = Array.isArray(m2) ? m2 : [m2, p2 === "ParenthesizedExpression"], b2 = t2.type === "ArrayPattern" || t2.type === "ObjectPattern" || t2.type === "ParenthesizedExpression" ? t2 : e25;
            for (let O2 of [].concat(t2[x2]))
              O2 && this.checkLVal(O2, { in: b2, binding: s2, checkClashes: i2, allowingSloppyLetBinding: n2, strictModeChanged: a2, hasParenthesizedAncestor: A2 });
          }
          checkIdentifier(t2, r2) {
            let e25 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, s2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !(r2 & Ce2);
            this.state.strict && (e25 ? br2(t2.name, this.inModule) : Cr(t2.name)) && (r2 === be2 ? this.raise(u2.StrictEvalArguments, { at: t2, referenceName: t2.name }) : this.raise(u2.StrictEvalArgumentsBinding, { at: t2, bindingName: t2.name })), !s2 && t2.name === "let" && this.raise(u2.LetInLexicalBinding, { at: t2 }), r2 & be2 || this.declareNameFromIdentifier(t2, r2);
          }
          declareNameFromIdentifier(t2, r2) {
            this.scope.declareName(t2.name, r2, t2.loc.start);
          }
          checkToRestConversion(t2, r2) {
            switch (t2.type) {
              case "ParenthesizedExpression":
                this.checkToRestConversion(t2.expression, r2);
                break;
              case "Identifier":
              case "MemberExpression":
                break;
              case "ArrayExpression":
              case "ObjectExpression":
                if (r2)
                  break;
              default:
                this.raise(u2.InvalidRestAssignmentPattern, { at: t2 });
            }
          }
          checkCommaAfterRest(t2) {
            return this.match(12) ? (this.raise(this.lookaheadCharCode() === t2 ? u2.RestTrailingComma : u2.ElementAfterRest, { at: this.state.startLoc }), true) : false;
          }
        }, xh2 = class extends yh2 {
          checkProto(t2, r2, e25, s2) {
            if (t2.type === "SpreadElement" || this.isObjectMethod(t2) || t2.computed || t2.shorthand)
              return;
            let i2 = t2.key;
            if ((i2.type === "Identifier" ? i2.name : i2.value) === "__proto__") {
              if (r2) {
                this.raise(u2.RecordNoProto, { at: i2 });
                return;
              }
              e25.used && (s2 ? s2.doubleProtoLoc === null && (s2.doubleProtoLoc = i2.loc.start) : this.raise(u2.DuplicateProto, { at: i2 })), e25.used = true;
            }
          }
          shouldExitDescending(t2, r2) {
            return t2.type === "ArrowFunctionExpression" && t2.start === r2;
          }
          getExpression() {
            this.enterInitialScopes(), this.nextToken();
            let t2 = this.parseExpression();
            return this.match(137) || this.unexpected(), this.finalizeRemainingComments(), t2.comments = this.state.comments, t2.errors = this.state.errors, this.options.tokens && (t2.tokens = this.tokens), t2;
          }
          parseExpression(t2, r2) {
            return t2 ? this.disallowInAnd(() => this.parseExpressionBase(r2)) : this.allowInAnd(() => this.parseExpressionBase(r2));
          }
          parseExpressionBase(t2) {
            let r2 = this.state.startLoc, e25 = this.parseMaybeAssign(t2);
            if (this.match(12)) {
              let s2 = this.startNodeAt(r2);
              for (s2.expressions = [e25]; this.eat(12); )
                s2.expressions.push(this.parseMaybeAssign(t2));
              return this.toReferencedList(s2.expressions), this.finishNode(s2, "SequenceExpression");
            }
            return e25;
          }
          parseMaybeAssignDisallowIn(t2, r2) {
            return this.disallowInAnd(() => this.parseMaybeAssign(t2, r2));
          }
          parseMaybeAssignAllowIn(t2, r2) {
            return this.allowInAnd(() => this.parseMaybeAssign(t2, r2));
          }
          setOptionalParametersError(t2, r2) {
            var e25;
            t2.optionalParametersLoc = (e25 = r2 == null ? void 0 : r2.loc) != null ? e25 : this.state.startLoc;
          }
          parseMaybeAssign(t2, r2) {
            let e25 = this.state.startLoc;
            if (this.isContextual(106) && this.prodParam.hasYield) {
              let n2 = this.parseYield();
              return r2 && (n2 = r2.call(this, n2, e25)), n2;
            }
            let s2;
            t2 ? s2 = false : (t2 = new Ct2(), s2 = true);
            let { type: i2 } = this.state;
            (i2 === 10 || z2(i2)) && (this.state.potentialArrowAt = this.state.start);
            let a2 = this.parseMaybeConditional(t2);
            if (r2 && (a2 = r2.call(this, a2, e25)), Go2(this.state.type)) {
              let n2 = this.startNodeAt(e25), o2 = this.state.value;
              if (n2.operator = o2, this.match(29)) {
                this.toAssignable(a2, true), n2.left = a2;
                let c2 = e25.index;
                t2.doubleProtoLoc != null && t2.doubleProtoLoc.index >= c2 && (t2.doubleProtoLoc = null), t2.shorthandAssignLoc != null && t2.shorthandAssignLoc.index >= c2 && (t2.shorthandAssignLoc = null), t2.privateKeyLoc != null && t2.privateKeyLoc.index >= c2 && (this.checkDestructuringPrivate(t2), t2.privateKeyLoc = null);
              } else
                n2.left = a2;
              return this.next(), n2.right = this.parseMaybeAssign(), this.checkLVal(a2, { in: this.finishNode(n2, "AssignmentExpression") }), n2;
            } else
              s2 && this.checkExpressionErrors(t2, true);
            return a2;
          }
          parseMaybeConditional(t2) {
            let r2 = this.state.startLoc, e25 = this.state.potentialArrowAt, s2 = this.parseExprOps(t2);
            return this.shouldExitDescending(s2, e25) ? s2 : this.parseConditional(s2, r2, t2);
          }
          parseConditional(t2, r2, e25) {
            if (this.eat(17)) {
              let s2 = this.startNodeAt(r2);
              return s2.test = t2, s2.consequent = this.parseMaybeAssignAllowIn(), this.expect(14), s2.alternate = this.parseMaybeAssign(), this.finishNode(s2, "ConditionalExpression");
            }
            return t2;
          }
          parseMaybeUnaryOrPrivate(t2) {
            return this.match(136) ? this.parsePrivateName() : this.parseMaybeUnary(t2);
          }
          parseExprOps(t2) {
            let r2 = this.state.startLoc, e25 = this.state.potentialArrowAt, s2 = this.parseMaybeUnaryOrPrivate(t2);
            return this.shouldExitDescending(s2, e25) ? s2 : this.parseExprOp(s2, r2, -1);
          }
          parseExprOp(t2, r2, e25) {
            if (this.isPrivateName(t2)) {
              let i2 = this.getPrivateNameSV(t2);
              (e25 >= ut2(58) || !this.prodParam.hasIn || !this.match(58)) && this.raise(u2.PrivateInExpectedIn, { at: t2, identifierName: i2 }), this.classScope.usePrivateName(i2, t2.loc.start);
            }
            let s2 = this.state.type;
            if (Xo2(s2) && (this.prodParam.hasIn || !this.match(58))) {
              let i2 = ut2(s2);
              if (i2 > e25) {
                if (s2 === 39) {
                  if (this.expectPlugin("pipelineOperator"), this.state.inFSharpPipelineDirectBody)
                    return t2;
                  this.checkPipelineAtInfixOperator(t2, r2);
                }
                let a2 = this.startNodeAt(r2);
                a2.left = t2, a2.operator = this.state.value;
                let n2 = s2 === 41 || s2 === 42, o2 = s2 === 40;
                if (o2 && (i2 = ut2(42)), this.next(), s2 === 39 && this.hasPlugin(["pipelineOperator", { proposal: "minimal" }]) && this.state.type === 96 && this.prodParam.hasAwait)
                  throw this.raise(u2.UnexpectedAwaitAfterPipelineBody, { at: this.state.startLoc });
                a2.right = this.parseExprOpRightExpr(s2, i2);
                let c2 = this.finishNode(a2, n2 || o2 ? "LogicalExpression" : "BinaryExpression"), p2 = this.state.type;
                if (o2 && (p2 === 41 || p2 === 42) || n2 && p2 === 40)
                  throw this.raise(u2.MixingCoalesceWithLogical, { at: this.state.startLoc });
                return this.parseExprOp(c2, r2, e25);
              }
            }
            return t2;
          }
          parseExprOpRightExpr(t2, r2) {
            let e25 = this.state.startLoc;
            switch (t2) {
              case 39:
                switch (this.getPluginOption("pipelineOperator", "proposal")) {
                  case "hack":
                    return this.withTopicBindingContext(() => this.parseHackPipeBody());
                  case "smart":
                    return this.withTopicBindingContext(() => {
                      if (this.prodParam.hasYield && this.isContextual(106))
                        throw this.raise(u2.PipeBodyIsTighter, { at: this.state.startLoc });
                      return this.parseSmartPipelineBodyInStyle(this.parseExprOpBaseRightExpr(t2, r2), e25);
                    });
                  case "fsharp":
                    return this.withSoloAwaitPermittingContext(() => this.parseFSharpPipelineBody(r2));
                }
              default:
                return this.parseExprOpBaseRightExpr(t2, r2);
            }
          }
          parseExprOpBaseRightExpr(t2, r2) {
            let e25 = this.state.startLoc;
            return this.parseExprOp(this.parseMaybeUnaryOrPrivate(), e25, tl2(t2) ? r2 - 1 : r2);
          }
          parseHackPipeBody() {
            var t2;
            let { startLoc: r2 } = this.state, e25 = this.parseMaybeAssign();
            return j2.has(e25.type) && !((t2 = e25.extra) != null && t2.parenthesized) && this.raise(u2.PipeUnparenthesizedBody, { at: r2, type: e25.type }), this.topicReferenceWasUsedInCurrentContext() || this.raise(u2.PipeTopicUnused, { at: r2 }), e25;
          }
          checkExponentialAfterUnary(t2) {
            this.match(57) && this.raise(u2.UnexpectedTokenUnaryExponentiation, { at: t2.argument });
          }
          parseMaybeUnary(t2, r2) {
            let e25 = this.state.startLoc, s2 = this.isContextual(96);
            if (s2 && this.isAwaitAllowed()) {
              this.next();
              let o2 = this.parseAwait(e25);
              return r2 || this.checkExponentialAfterUnary(o2), o2;
            }
            let i2 = this.match(34), a2 = this.startNode();
            if (Qo2(this.state.type)) {
              a2.operator = this.state.value, a2.prefix = true, this.match(72) && this.expectPlugin("throwExpressions");
              let o2 = this.match(89);
              if (this.next(), a2.argument = this.parseMaybeUnary(null, true), this.checkExpressionErrors(t2, true), this.state.strict && o2) {
                let c2 = a2.argument;
                c2.type === "Identifier" ? this.raise(u2.StrictDelete, { at: a2 }) : this.hasPropertyAsPrivateName(c2) && this.raise(u2.DeletePrivateField, { at: a2 });
              }
              if (!i2)
                return r2 || this.checkExponentialAfterUnary(a2), this.finishNode(a2, "UnaryExpression");
            }
            let n2 = this.parseUpdate(a2, i2, t2);
            if (s2) {
              let { type: o2 } = this.state;
              if ((this.hasPlugin("v8intrinsic") ? Xt2(o2) : Xt2(o2) && !this.match(54)) && !this.isAmbiguousAwait())
                return this.raiseOverwrite(u2.AwaitNotInAsyncContext, { at: e25 }), this.parseAwait(e25);
            }
            return n2;
          }
          parseUpdate(t2, r2, e25) {
            if (r2) {
              let a2 = t2;
              return this.checkLVal(a2.argument, { in: this.finishNode(a2, "UpdateExpression") }), t2;
            }
            let s2 = this.state.startLoc, i2 = this.parseExprSubscripts(e25);
            if (this.checkExpressionErrors(e25, false))
              return i2;
            for (; Yo2(this.state.type) && !this.canInsertSemicolon(); ) {
              let a2 = this.startNodeAt(s2);
              a2.operator = this.state.value, a2.prefix = false, a2.argument = i2, this.next(), this.checkLVal(i2, { in: i2 = this.finishNode(a2, "UpdateExpression") });
            }
            return i2;
          }
          parseExprSubscripts(t2) {
            let r2 = this.state.startLoc, e25 = this.state.potentialArrowAt, s2 = this.parseExprAtom(t2);
            return this.shouldExitDescending(s2, e25) ? s2 : this.parseSubscripts(s2, r2);
          }
          parseSubscripts(t2, r2, e25) {
            let s2 = { optionalChainMember: false, maybeAsyncArrow: this.atPossibleAsyncArrow(t2), stop: false };
            do
              t2 = this.parseSubscript(t2, r2, e25, s2), s2.maybeAsyncArrow = false;
            while (!s2.stop);
            return t2;
          }
          parseSubscript(t2, r2, e25, s2) {
            let { type: i2 } = this.state;
            if (!e25 && i2 === 15)
              return this.parseBind(t2, r2, e25, s2);
            if (ct2(i2))
              return this.parseTaggedTemplateExpression(t2, r2, s2);
            let a2 = false;
            if (i2 === 18) {
              if (e25 && this.lookaheadCharCode() === 40)
                return s2.stop = true, t2;
              s2.optionalChainMember = a2 = true, this.next();
            }
            if (!e25 && this.match(10))
              return this.parseCoverCallAndAsyncArrowHead(t2, r2, s2, a2);
            {
              let n2 = this.eat(0);
              return n2 || a2 || this.eat(16) ? this.parseMember(t2, r2, s2, n2, a2) : (s2.stop = true, t2);
            }
          }
          parseMember(t2, r2, e25, s2, i2) {
            let a2 = this.startNodeAt(r2);
            return a2.object = t2, a2.computed = s2, s2 ? (a2.property = this.parseExpression(), this.expect(3)) : this.match(136) ? (t2.type === "Super" && this.raise(u2.SuperPrivateField, { at: r2 }), this.classScope.usePrivateName(this.state.value, this.state.startLoc), a2.property = this.parsePrivateName()) : a2.property = this.parseIdentifier(true), e25.optionalChainMember ? (a2.optional = i2, this.finishNode(a2, "OptionalMemberExpression")) : this.finishNode(a2, "MemberExpression");
          }
          parseBind(t2, r2, e25, s2) {
            let i2 = this.startNodeAt(r2);
            return i2.object = t2, this.next(), i2.callee = this.parseNoCallExpr(), s2.stop = true, this.parseSubscripts(this.finishNode(i2, "BindExpression"), r2, e25);
          }
          parseCoverCallAndAsyncArrowHead(t2, r2, e25, s2) {
            let i2 = this.state.maybeInArrowParameters, a2 = null;
            this.state.maybeInArrowParameters = true, this.next();
            let n2 = this.startNodeAt(r2);
            n2.callee = t2;
            let { maybeAsyncArrow: o2, optionalChainMember: c2 } = e25;
            o2 && (this.expressionScope.enter($l2()), a2 = new Ct2()), c2 && (n2.optional = s2), s2 ? n2.arguments = this.parseCallExpressionArguments(11) : n2.arguments = this.parseCallExpressionArguments(11, t2.type === "Import", t2.type !== "Super", n2, a2);
            let p2 = this.finishCallExpression(n2, c2);
            return o2 && this.shouldParseAsyncArrow() && !s2 ? (e25.stop = true, this.checkDestructuringPrivate(a2), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), p2 = this.parseAsyncArrowFromCallExpression(this.startNodeAt(r2), p2)) : (o2 && (this.checkExpressionErrors(a2, true), this.expressionScope.exit()), this.toReferencedArguments(p2)), this.state.maybeInArrowParameters = i2, p2;
          }
          toReferencedArguments(t2, r2) {
            this.toReferencedListDeep(t2.arguments, r2);
          }
          parseTaggedTemplateExpression(t2, r2, e25) {
            let s2 = this.startNodeAt(r2);
            return s2.tag = t2, s2.quasi = this.parseTemplate(true), e25.optionalChainMember && this.raise(u2.OptionalChainingNoTemplate, { at: r2 }), this.finishNode(s2, "TaggedTemplateExpression");
          }
          atPossibleAsyncArrow(t2) {
            return t2.type === "Identifier" && t2.name === "async" && this.state.lastTokEndLoc.index === t2.end && !this.canInsertSemicolon() && t2.end - t2.start === 5 && t2.start === this.state.potentialArrowAt;
          }
          finishCallExpression(t2, r2) {
            if (t2.callee.type === "Import")
              if (t2.arguments.length === 2 && (this.hasPlugin("moduleAttributes") || this.expectPlugin("importAssertions")), t2.arguments.length === 0 || t2.arguments.length > 2)
                this.raise(u2.ImportCallArity, { at: t2, maxArgumentCount: this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") ? 2 : 1 });
              else
                for (let e25 of t2.arguments)
                  e25.type === "SpreadElement" && this.raise(u2.ImportCallSpreadArgument, { at: e25 });
            return this.finishNode(t2, r2 ? "OptionalCallExpression" : "CallExpression");
          }
          parseCallExpressionArguments(t2, r2, e25, s2, i2) {
            let a2 = [], n2 = true, o2 = this.state.inFSharpPipelineDirectBody;
            for (this.state.inFSharpPipelineDirectBody = false; !this.eat(t2); ) {
              if (n2)
                n2 = false;
              else if (this.expect(12), this.match(t2)) {
                r2 && !this.hasPlugin("importAssertions") && !this.hasPlugin("moduleAttributes") && this.raise(u2.ImportCallArgumentTrailingComma, { at: this.state.lastTokStartLoc }), s2 && this.addTrailingCommaExtraToNode(s2), this.next();
                break;
              }
              a2.push(this.parseExprListItem(false, i2, e25));
            }
            return this.state.inFSharpPipelineDirectBody = o2, a2;
          }
          shouldParseAsyncArrow() {
            return this.match(19) && !this.canInsertSemicolon();
          }
          parseAsyncArrowFromCallExpression(t2, r2) {
            var e25;
            return this.resetPreviousNodeTrailingComments(r2), this.expect(19), this.parseArrowExpression(t2, r2.arguments, true, (e25 = r2.extra) == null ? void 0 : e25.trailingCommaLoc), r2.innerComments && Qe2(t2, r2.innerComments), r2.callee.trailingComments && Qe2(t2, r2.callee.trailingComments), t2;
          }
          parseNoCallExpr() {
            let t2 = this.state.startLoc;
            return this.parseSubscripts(this.parseExprAtom(), t2, true);
          }
          parseExprAtom(t2) {
            let r2, e25 = null, { type: s2 } = this.state;
            switch (s2) {
              case 79:
                return this.parseSuper();
              case 83:
                return r2 = this.startNode(), this.next(), this.match(16) ? this.parseImportMetaProperty(r2) : (this.match(10) || this.raise(u2.UnsupportedImport, { at: this.state.lastTokStartLoc }), this.finishNode(r2, "Import"));
              case 78:
                return r2 = this.startNode(), this.next(), this.finishNode(r2, "ThisExpression");
              case 90:
                return this.parseDo(this.startNode(), false);
              case 56:
              case 31:
                return this.readRegexp(), this.parseRegExpLiteral(this.state.value);
              case 132:
                return this.parseNumericLiteral(this.state.value);
              case 133:
                return this.parseBigIntLiteral(this.state.value);
              case 134:
                return this.parseDecimalLiteral(this.state.value);
              case 131:
                return this.parseStringLiteral(this.state.value);
              case 84:
                return this.parseNullLiteral();
              case 85:
                return this.parseBooleanLiteral(true);
              case 86:
                return this.parseBooleanLiteral(false);
              case 10: {
                let i2 = this.state.potentialArrowAt === this.state.start;
                return this.parseParenAndDistinguishExpression(i2);
              }
              case 2:
              case 1:
                return this.parseArrayLike(this.state.type === 2 ? 4 : 3, false, true);
              case 0:
                return this.parseArrayLike(3, true, false, t2);
              case 6:
              case 7:
                return this.parseObjectLike(this.state.type === 6 ? 9 : 8, false, true);
              case 5:
                return this.parseObjectLike(8, false, false, t2);
              case 68:
                return this.parseFunctionOrFunctionSent();
              case 26:
                e25 = this.parseDecorators();
              case 80:
                return this.parseClass(this.maybeTakeDecorators(e25, this.startNode()), false);
              case 77:
                return this.parseNewOrNewTarget();
              case 25:
              case 24:
                return this.parseTemplate(false);
              case 15: {
                r2 = this.startNode(), this.next(), r2.object = null;
                let i2 = r2.callee = this.parseNoCallExpr();
                if (i2.type === "MemberExpression")
                  return this.finishNode(r2, "BindExpression");
                throw this.raise(u2.UnsupportedBind, { at: i2 });
              }
              case 136:
                return this.raise(u2.PrivateInExpectedIn, { at: this.state.startLoc, identifierName: this.state.value }), this.parsePrivateName();
              case 33:
                return this.parseTopicReferenceThenEqualsSign(54, "%");
              case 32:
                return this.parseTopicReferenceThenEqualsSign(44, "^");
              case 37:
              case 38:
                return this.parseTopicReference("hack");
              case 44:
              case 54:
              case 27: {
                let i2 = this.getPluginOption("pipelineOperator", "proposal");
                if (i2)
                  return this.parseTopicReference(i2);
                throw this.unexpected();
              }
              case 47: {
                let i2 = this.input.codePointAt(this.nextTokenStart());
                if (ge2(i2) || i2 === 62) {
                  this.expectOnePlugin(["jsx", "flow", "typescript"]);
                  break;
                } else
                  throw this.unexpected();
              }
              default:
                if (z2(s2)) {
                  if (this.isContextual(125) && this.lookaheadCharCode() === 123 && !this.hasFollowingLineBreak())
                    return this.parseModuleExpression();
                  let i2 = this.state.potentialArrowAt === this.state.start, a2 = this.state.containsEsc, n2 = this.parseIdentifier();
                  if (!a2 && n2.name === "async" && !this.canInsertSemicolon()) {
                    let { type: o2 } = this.state;
                    if (o2 === 68)
                      return this.resetPreviousNodeTrailingComments(n2), this.next(), this.parseAsyncFunctionExpression(this.startNodeAtNode(n2));
                    if (z2(o2))
                      return this.lookaheadCharCode() === 61 ? this.parseAsyncArrowUnaryFunction(this.startNodeAtNode(n2)) : n2;
                    if (o2 === 90)
                      return this.resetPreviousNodeTrailingComments(n2), this.parseDo(this.startNodeAtNode(n2), true);
                  }
                  return i2 && this.match(19) && !this.canInsertSemicolon() ? (this.next(), this.parseArrowExpression(this.startNodeAtNode(n2), [n2], false)) : n2;
                } else
                  throw this.unexpected();
            }
          }
          parseTopicReferenceThenEqualsSign(t2, r2) {
            let e25 = this.getPluginOption("pipelineOperator", "proposal");
            if (e25)
              return this.state.type = t2, this.state.value = r2, this.state.pos--, this.state.end--, this.state.endLoc = y2(this.state.endLoc, -1), this.parseTopicReference(e25);
            throw this.unexpected();
          }
          parseTopicReference(t2) {
            let r2 = this.startNode(), e25 = this.state.startLoc, s2 = this.state.type;
            return this.next(), this.finishTopicReference(r2, e25, t2, s2);
          }
          finishTopicReference(t2, r2, e25, s2) {
            if (this.testTopicReferenceConfiguration(e25, r2, s2)) {
              let i2 = e25 === "smart" ? "PipelinePrimaryTopicReference" : "TopicReference";
              return this.topicReferenceIsAllowedInCurrentContext() || this.raise(e25 === "smart" ? u2.PrimaryTopicNotAllowed : u2.PipeTopicUnbound, { at: r2 }), this.registerTopicReference(), this.finishNode(t2, i2);
            } else
              throw this.raise(u2.PipeTopicUnconfiguredToken, { at: r2, token: Ee2(s2) });
          }
          testTopicReferenceConfiguration(t2, r2, e25) {
            switch (t2) {
              case "hack":
                return this.hasPlugin(["pipelineOperator", { topicToken: Ee2(e25) }]);
              case "smart":
                return e25 === 27;
              default:
                throw this.raise(u2.PipeTopicRequiresHackPipes, { at: r2 });
            }
          }
          parseAsyncArrowUnaryFunction(t2) {
            this.prodParam.enter(Et(true, this.prodParam.hasYield));
            let r2 = [this.parseIdentifier()];
            return this.prodParam.exit(), this.hasPrecedingLineBreak() && this.raise(u2.LineTerminatorBeforeArrow, { at: this.state.curPosition() }), this.expect(19), this.parseArrowExpression(t2, r2, true);
          }
          parseDo(t2, r2) {
            this.expectPlugin("doExpressions"), r2 && this.expectPlugin("asyncDoExpressions"), t2.async = r2, this.next();
            let e25 = this.state.labels;
            return this.state.labels = [], r2 ? (this.prodParam.enter(vt), t2.body = this.parseBlock(), this.prodParam.exit()) : t2.body = this.parseBlock(), this.state.labels = e25, this.finishNode(t2, "DoExpression");
          }
          parseSuper() {
            let t2 = this.startNode();
            return this.next(), this.match(10) && !this.scope.allowDirectSuper && !this.options.allowSuperOutsideMethod ? this.raise(u2.SuperNotAllowed, { at: t2 }) : !this.scope.allowSuper && !this.options.allowSuperOutsideMethod && this.raise(u2.UnexpectedSuper, { at: t2 }), !this.match(10) && !this.match(0) && !this.match(16) && this.raise(u2.UnsupportedSuper, { at: t2 }), this.finishNode(t2, "Super");
          }
          parsePrivateName() {
            let t2 = this.startNode(), r2 = this.startNodeAt(y2(this.state.startLoc, 1)), e25 = this.state.value;
            return this.next(), t2.id = this.createIdentifier(r2, e25), this.finishNode(t2, "PrivateName");
          }
          parseFunctionOrFunctionSent() {
            let t2 = this.startNode();
            if (this.next(), this.prodParam.hasYield && this.match(16)) {
              let r2 = this.createIdentifier(this.startNodeAtNode(t2), "function");
              return this.next(), this.match(102) ? this.expectPlugin("functionSent") : this.hasPlugin("functionSent") || this.unexpected(), this.parseMetaProperty(t2, r2, "sent");
            }
            return this.parseFunction(t2);
          }
          parseMetaProperty(t2, r2, e25) {
            t2.meta = r2;
            let s2 = this.state.containsEsc;
            return t2.property = this.parseIdentifier(true), (t2.property.name !== e25 || s2) && this.raise(u2.UnsupportedMetaProperty, { at: t2.property, target: r2.name, onlyValidPropertyName: e25 }), this.finishNode(t2, "MetaProperty");
          }
          parseImportMetaProperty(t2) {
            let r2 = this.createIdentifier(this.startNodeAtNode(t2), "import");
            return this.next(), this.isContextual(100) && (this.inModule || this.raise(u2.ImportMetaOutsideModule, { at: r2 }), this.sawUnambiguousESM = true), this.parseMetaProperty(t2, r2, "meta");
          }
          parseLiteralAtNode(t2, r2, e25) {
            return this.addExtra(e25, "rawValue", t2), this.addExtra(e25, "raw", this.input.slice(e25.start, this.state.end)), e25.value = t2, this.next(), this.finishNode(e25, r2);
          }
          parseLiteral(t2, r2) {
            let e25 = this.startNode();
            return this.parseLiteralAtNode(t2, r2, e25);
          }
          parseStringLiteral(t2) {
            return this.parseLiteral(t2, "StringLiteral");
          }
          parseNumericLiteral(t2) {
            return this.parseLiteral(t2, "NumericLiteral");
          }
          parseBigIntLiteral(t2) {
            return this.parseLiteral(t2, "BigIntLiteral");
          }
          parseDecimalLiteral(t2) {
            return this.parseLiteral(t2, "DecimalLiteral");
          }
          parseRegExpLiteral(t2) {
            let r2 = this.parseLiteral(t2.value, "RegExpLiteral");
            return r2.pattern = t2.pattern, r2.flags = t2.flags, r2;
          }
          parseBooleanLiteral(t2) {
            let r2 = this.startNode();
            return r2.value = t2, this.next(), this.finishNode(r2, "BooleanLiteral");
          }
          parseNullLiteral() {
            let t2 = this.startNode();
            return this.next(), this.finishNode(t2, "NullLiteral");
          }
          parseParenAndDistinguishExpression(t2) {
            let r2 = this.state.startLoc, e25;
            this.next(), this.expressionScope.enter(Ul2());
            let s2 = this.state.maybeInArrowParameters, i2 = this.state.inFSharpPipelineDirectBody;
            this.state.maybeInArrowParameters = true, this.state.inFSharpPipelineDirectBody = false;
            let a2 = this.state.startLoc, n2 = [], o2 = new Ct2(), c2 = true, p2, m2;
            for (; !this.match(11); ) {
              if (c2)
                c2 = false;
              else if (this.expect(12, o2.optionalParametersLoc === null ? null : o2.optionalParametersLoc), this.match(11)) {
                m2 = this.state.startLoc;
                break;
              }
              if (this.match(21)) {
                let b2 = this.state.startLoc;
                if (p2 = this.state.startLoc, n2.push(this.parseParenItem(this.parseRestBinding(), b2)), !this.checkCommaAfterRest(41))
                  break;
              } else
                n2.push(this.parseMaybeAssignAllowIn(o2, this.parseParenItem));
            }
            let x2 = this.state.lastTokEndLoc;
            this.expect(11), this.state.maybeInArrowParameters = s2, this.state.inFSharpPipelineDirectBody = i2;
            let A2 = this.startNodeAt(r2);
            return t2 && this.shouldParseArrow(n2) && (A2 = this.parseArrow(A2)) ? (this.checkDestructuringPrivate(o2), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), this.parseArrowExpression(A2, n2, false), A2) : (this.expressionScope.exit(), n2.length || this.unexpected(this.state.lastTokStartLoc), m2 && this.unexpected(m2), p2 && this.unexpected(p2), this.checkExpressionErrors(o2, true), this.toReferencedListDeep(n2, true), n2.length > 1 ? (e25 = this.startNodeAt(a2), e25.expressions = n2, this.finishNode(e25, "SequenceExpression"), this.resetEndLocation(e25, x2)) : e25 = n2[0], this.wrapParenthesis(r2, e25));
          }
          wrapParenthesis(t2, r2) {
            if (!this.options.createParenthesizedExpressions)
              return this.addExtra(r2, "parenthesized", true), this.addExtra(r2, "parenStart", t2.index), this.takeSurroundingComments(r2, t2.index, this.state.lastTokEndLoc.index), r2;
            let e25 = this.startNodeAt(t2);
            return e25.expression = r2, this.finishNode(e25, "ParenthesizedExpression");
          }
          shouldParseArrow(t2) {
            return !this.canInsertSemicolon();
          }
          parseArrow(t2) {
            if (this.eat(19))
              return t2;
          }
          parseParenItem(t2, r2) {
            return t2;
          }
          parseNewOrNewTarget() {
            let t2 = this.startNode();
            if (this.next(), this.match(16)) {
              let r2 = this.createIdentifier(this.startNodeAtNode(t2), "new");
              this.next();
              let e25 = this.parseMetaProperty(t2, r2, "target");
              return !this.scope.inNonArrowFunction && !this.scope.inClass && this.raise(u2.UnexpectedNewTarget, { at: e25 }), e25;
            }
            return this.parseNew(t2);
          }
          parseNew(t2) {
            if (this.parseNewCallee(t2), this.eat(10)) {
              let r2 = this.parseExprList(11);
              this.toReferencedList(r2), t2.arguments = r2;
            } else
              t2.arguments = [];
            return this.finishNode(t2, "NewExpression");
          }
          parseNewCallee(t2) {
            t2.callee = this.parseNoCallExpr(), t2.callee.type === "Import" ? this.raise(u2.ImportCallNotNewExpression, { at: t2.callee }) : this.isOptionalChain(t2.callee) ? this.raise(u2.OptionalChainingNoNew, { at: this.state.lastTokEndLoc }) : this.eat(18) && this.raise(u2.OptionalChainingNoNew, { at: this.state.startLoc });
          }
          parseTemplateElement(t2) {
            let { start: r2, startLoc: e25, end: s2, value: i2 } = this.state, a2 = r2 + 1, n2 = this.startNodeAt(y2(e25, 1));
            i2 === null && (t2 || this.raise(u2.InvalidEscapeSequenceTemplate, { at: y2(this.state.firstInvalidTemplateEscapePos, 1) }));
            let o2 = this.match(24), c2 = o2 ? -1 : -2, p2 = s2 + c2;
            n2.value = { raw: this.input.slice(a2, p2).replace(/\r\n?/g, `
`), cooked: i2 === null ? null : i2.slice(1, c2) }, n2.tail = o2, this.next();
            let m2 = this.finishNode(n2, "TemplateElement");
            return this.resetEndLocation(m2, y2(this.state.lastTokEndLoc, c2)), m2;
          }
          parseTemplate(t2) {
            let r2 = this.startNode();
            r2.expressions = [];
            let e25 = this.parseTemplateElement(t2);
            for (r2.quasis = [e25]; !e25.tail; )
              r2.expressions.push(this.parseTemplateSubstitution()), this.readTemplateContinuation(), r2.quasis.push(e25 = this.parseTemplateElement(t2));
            return this.finishNode(r2, "TemplateLiteral");
          }
          parseTemplateSubstitution() {
            return this.parseExpression();
          }
          parseObjectLike(t2, r2, e25, s2) {
            e25 && this.expectPlugin("recordAndTuple");
            let i2 = this.state.inFSharpPipelineDirectBody;
            this.state.inFSharpPipelineDirectBody = false;
            let a2 = Object.create(null), n2 = true, o2 = this.startNode();
            for (o2.properties = [], this.next(); !this.match(t2); ) {
              if (n2)
                n2 = false;
              else if (this.expect(12), this.match(t2)) {
                this.addTrailingCommaExtraToNode(o2);
                break;
              }
              let p2;
              r2 ? p2 = this.parseBindingProperty() : (p2 = this.parsePropertyDefinition(s2), this.checkProto(p2, e25, a2, s2)), e25 && !this.isObjectProperty(p2) && p2.type !== "SpreadElement" && this.raise(u2.InvalidRecordProperty, { at: p2 }), p2.shorthand && this.addExtra(p2, "shorthand", true), o2.properties.push(p2);
            }
            this.next(), this.state.inFSharpPipelineDirectBody = i2;
            let c2 = "ObjectExpression";
            return r2 ? c2 = "ObjectPattern" : e25 && (c2 = "RecordExpression"), this.finishNode(o2, c2);
          }
          addTrailingCommaExtraToNode(t2) {
            this.addExtra(t2, "trailingComma", this.state.lastTokStart), this.addExtra(t2, "trailingCommaLoc", this.state.lastTokStartLoc, false);
          }
          maybeAsyncOrAccessorProp(t2) {
            return !t2.computed && t2.key.type === "Identifier" && (this.isLiteralPropertyName() || this.match(0) || this.match(55));
          }
          parsePropertyDefinition(t2) {
            let r2 = [];
            if (this.match(26))
              for (this.hasPlugin("decorators") && this.raise(u2.UnsupportedPropertyDecorator, { at: this.state.startLoc }); this.match(26); )
                r2.push(this.parseDecorator());
            let e25 = this.startNode(), s2 = false, i2 = false, a2;
            if (this.match(21))
              return r2.length && this.unexpected(), this.parseSpread();
            r2.length && (e25.decorators = r2, r2 = []), e25.method = false, t2 && (a2 = this.state.startLoc);
            let n2 = this.eat(55);
            this.parsePropertyNamePrefixOperator(e25);
            let o2 = this.state.containsEsc, c2 = this.parsePropertyName(e25, t2);
            if (!n2 && !o2 && this.maybeAsyncOrAccessorProp(e25)) {
              let p2 = c2.name;
              p2 === "async" && !this.hasPrecedingLineBreak() && (s2 = true, this.resetPreviousNodeTrailingComments(c2), n2 = this.eat(55), this.parsePropertyName(e25)), (p2 === "get" || p2 === "set") && (i2 = true, this.resetPreviousNodeTrailingComments(c2), e25.kind = p2, this.match(55) && (n2 = true, this.raise(u2.AccessorIsGenerator, { at: this.state.curPosition(), kind: p2 }), this.next()), this.parsePropertyName(e25));
            }
            return this.parseObjPropValue(e25, a2, n2, s2, false, i2, t2);
          }
          getGetterSetterExpectedParamCount(t2) {
            return t2.kind === "get" ? 0 : 1;
          }
          getObjectOrClassMethodParams(t2) {
            return t2.params;
          }
          checkGetterSetterParams(t2) {
            var r2;
            let e25 = this.getGetterSetterExpectedParamCount(t2), s2 = this.getObjectOrClassMethodParams(t2);
            s2.length !== e25 && this.raise(t2.kind === "get" ? u2.BadGetterArity : u2.BadSetterArity, { at: t2 }), t2.kind === "set" && ((r2 = s2[s2.length - 1]) == null ? void 0 : r2.type) === "RestElement" && this.raise(u2.BadSetterRestParameter, { at: t2 });
          }
          parseObjectMethod(t2, r2, e25, s2, i2) {
            if (i2) {
              let a2 = this.parseMethod(t2, r2, false, false, false, "ObjectMethod");
              return this.checkGetterSetterParams(a2), a2;
            }
            if (e25 || r2 || this.match(10))
              return s2 && this.unexpected(), t2.kind = "method", t2.method = true, this.parseMethod(t2, r2, e25, false, false, "ObjectMethod");
          }
          parseObjectProperty(t2, r2, e25, s2) {
            if (t2.shorthand = false, this.eat(14))
              return t2.value = e25 ? this.parseMaybeDefault(this.state.startLoc) : this.parseMaybeAssignAllowIn(s2), this.finishNode(t2, "ObjectProperty");
            if (!t2.computed && t2.key.type === "Identifier") {
              if (this.checkReservedWord(t2.key.name, t2.key.loc.start, true, false), e25)
                t2.value = this.parseMaybeDefault(r2, Te2(t2.key));
              else if (this.match(29)) {
                let i2 = this.state.startLoc;
                s2 != null ? s2.shorthandAssignLoc === null && (s2.shorthandAssignLoc = i2) : this.raise(u2.InvalidCoverInitializedName, { at: i2 }), t2.value = this.parseMaybeDefault(r2, Te2(t2.key));
              } else
                t2.value = Te2(t2.key);
              return t2.shorthand = true, this.finishNode(t2, "ObjectProperty");
            }
          }
          parseObjPropValue(t2, r2, e25, s2, i2, a2, n2) {
            let o2 = this.parseObjectMethod(t2, e25, s2, i2, a2) || this.parseObjectProperty(t2, r2, i2, n2);
            return o2 || this.unexpected(), o2;
          }
          parsePropertyName(t2, r2) {
            if (this.eat(0))
              t2.computed = true, t2.key = this.parseMaybeAssignAllowIn(), this.expect(3);
            else {
              let { type: e25, value: s2 } = this.state, i2;
              if (ye2(e25))
                i2 = this.parseIdentifier(true);
              else
                switch (e25) {
                  case 132:
                    i2 = this.parseNumericLiteral(s2);
                    break;
                  case 131:
                    i2 = this.parseStringLiteral(s2);
                    break;
                  case 133:
                    i2 = this.parseBigIntLiteral(s2);
                    break;
                  case 134:
                    i2 = this.parseDecimalLiteral(s2);
                    break;
                  case 136: {
                    let a2 = this.state.startLoc;
                    r2 != null ? r2.privateKeyLoc === null && (r2.privateKeyLoc = a2) : this.raise(u2.UnexpectedPrivateField, { at: a2 }), i2 = this.parsePrivateName();
                    break;
                  }
                  default:
                    throw this.unexpected();
                }
              t2.key = i2, e25 !== 136 && (t2.computed = false);
            }
            return t2.key;
          }
          initFunction(t2, r2) {
            t2.id = null, t2.generator = false, t2.async = r2;
          }
          parseMethod(t2, r2, e25, s2, i2, a2) {
            let n2 = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
            this.initFunction(t2, e25), t2.generator = r2;
            let o2 = s2;
            this.scope.enter(Pe2 | pt2 | (n2 ? Ne2 : 0) | (i2 ? wr2 : 0)), this.prodParam.enter(Et(e25, t2.generator)), this.parseFunctionParams(t2, o2);
            let c2 = this.parseFunctionBodyAndFinish(t2, a2, true);
            return this.prodParam.exit(), this.scope.exit(), c2;
          }
          parseArrayLike(t2, r2, e25, s2) {
            e25 && this.expectPlugin("recordAndTuple");
            let i2 = this.state.inFSharpPipelineDirectBody;
            this.state.inFSharpPipelineDirectBody = false;
            let a2 = this.startNode();
            return this.next(), a2.elements = this.parseExprList(t2, !e25, s2, a2), this.state.inFSharpPipelineDirectBody = i2, this.finishNode(a2, e25 ? "TupleExpression" : "ArrayExpression");
          }
          parseArrowExpression(t2, r2, e25, s2) {
            this.scope.enter(Pe2 | ts2);
            let i2 = Et(e25, false);
            !this.match(5) && this.prodParam.hasIn && (i2 |= He2), this.prodParam.enter(i2), this.initFunction(t2, e25);
            let a2 = this.state.maybeInArrowParameters;
            return r2 && (this.state.maybeInArrowParameters = true, this.setArrowFunctionParameters(t2, r2, s2)), this.state.maybeInArrowParameters = false, this.parseFunctionBody(t2, true), this.prodParam.exit(), this.scope.exit(), this.state.maybeInArrowParameters = a2, this.finishNode(t2, "ArrowFunctionExpression");
          }
          setArrowFunctionParameters(t2, r2, e25) {
            this.toAssignableList(r2, e25, false), t2.params = r2;
          }
          parseFunctionBodyAndFinish(t2, r2) {
            let e25 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            return this.parseFunctionBody(t2, false, e25), this.finishNode(t2, r2);
          }
          parseFunctionBody(t2, r2) {
            let e25 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, s2 = r2 && !this.match(5);
            if (this.expressionScope.enter(Vr2()), s2)
              t2.body = this.parseMaybeAssign(), this.checkParams(t2, false, r2, false);
            else {
              let i2 = this.state.strict, a2 = this.state.labels;
              this.state.labels = [], this.prodParam.enter(this.prodParam.currentFlags() | Wr2), t2.body = this.parseBlock(true, false, (n2) => {
                let o2 = !this.isSimpleParamList(t2.params);
                n2 && o2 && this.raise(u2.IllegalLanguageModeDirective, { at: (t2.kind === "method" || t2.kind === "constructor") && t2.key ? t2.key.loc.end : t2 });
                let c2 = !i2 && this.state.strict;
                this.checkParams(t2, !this.state.strict && !r2 && !e25 && !o2, r2, c2), this.state.strict && t2.id && this.checkIdentifier(t2.id, dl2, c2);
              }), this.prodParam.exit(), this.state.labels = a2;
            }
            this.expressionScope.exit();
          }
          isSimpleParameter(t2) {
            return t2.type === "Identifier";
          }
          isSimpleParamList(t2) {
            for (let r2 = 0, e25 = t2.length; r2 < e25; r2++)
              if (!this.isSimpleParameter(t2[r2]))
                return false;
            return true;
          }
          checkParams(t2, r2, e25) {
            let s2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, i2 = !r2 && new Set(), a2 = { type: "FormalParameters" };
            for (let n2 of t2.params)
              this.checkLVal(n2, { in: a2, binding: xt, checkClashes: i2, strictModeChanged: s2 });
          }
          parseExprList(t2, r2, e25, s2) {
            let i2 = [], a2 = true;
            for (; !this.eat(t2); ) {
              if (a2)
                a2 = false;
              else if (this.expect(12), this.match(t2)) {
                s2 && this.addTrailingCommaExtraToNode(s2), this.next();
                break;
              }
              i2.push(this.parseExprListItem(r2, e25));
            }
            return i2;
          }
          parseExprListItem(t2, r2, e25) {
            let s2;
            if (this.match(12))
              t2 || this.raise(u2.UnexpectedToken, { at: this.state.curPosition(), unexpected: "," }), s2 = null;
            else if (this.match(21)) {
              let i2 = this.state.startLoc;
              s2 = this.parseParenItem(this.parseSpread(r2), i2);
            } else if (this.match(17)) {
              this.expectPlugin("partialApplication"), e25 || this.raise(u2.UnexpectedArgumentPlaceholder, { at: this.state.startLoc });
              let i2 = this.startNode();
              this.next(), s2 = this.finishNode(i2, "ArgumentPlaceholder");
            } else
              s2 = this.parseMaybeAssignAllowIn(r2, this.parseParenItem);
            return s2;
          }
          parseIdentifier(t2) {
            let r2 = this.startNode(), e25 = this.parseIdentifierName(t2);
            return this.createIdentifier(r2, e25);
          }
          createIdentifier(t2, r2) {
            return t2.name = r2, t2.loc.identifierName = r2, this.finishNode(t2, "Identifier");
          }
          parseIdentifierName(t2) {
            let r2, { startLoc: e25, type: s2 } = this.state;
            if (ye2(s2))
              r2 = this.state.value;
            else
              throw this.unexpected();
            let i2 = Ko2(s2);
            return t2 ? i2 && this.replaceToken(130) : this.checkReservedWord(r2, e25, i2, false), this.next(), r2;
          }
          checkReservedWord(t2, r2, e25, s2) {
            if (t2.length > 10 || !cl2(t2))
              return;
            if (t2 === "yield") {
              if (this.prodParam.hasYield) {
                this.raise(u2.YieldBindingIdentifier, { at: r2 });
                return;
              }
            } else if (t2 === "await") {
              if (this.prodParam.hasAwait) {
                this.raise(u2.AwaitBindingIdentifier, { at: r2 });
                return;
              }
              if (this.scope.inStaticBlock) {
                this.raise(u2.AwaitBindingIdentifierInStaticBlock, { at: r2 });
                return;
              }
              this.expressionScope.recordAsyncArrowParametersError({ at: r2 });
            } else if (t2 === "arguments" && this.scope.inClassAndNotInNonArrowFunction) {
              this.raise(u2.ArgumentsInClass, { at: r2 });
              return;
            }
            if (e25 && ll2(t2)) {
              this.raise(u2.UnexpectedKeyword, { at: r2, keyword: t2 });
              return;
            }
            (this.state.strict ? s2 ? br2 : Er2 : vr2)(t2, this.inModule) && this.raise(u2.UnexpectedReservedWord, { at: r2, reservedWord: t2 });
          }
          isAwaitAllowed() {
            return !!(this.prodParam.hasAwait || this.options.allowAwaitOutsideFunction && !this.scope.inFunction);
          }
          parseAwait(t2) {
            let r2 = this.startNodeAt(t2);
            return this.expressionScope.recordParameterInitializerError(u2.AwaitExpressionFormalParameter, { at: r2 }), this.eat(55) && this.raise(u2.ObsoleteAwaitStar, { at: r2 }), !this.scope.inFunction && !this.options.allowAwaitOutsideFunction && (this.isAmbiguousAwait() ? this.ambiguousScriptDifferentAst = true : this.sawUnambiguousESM = true), this.state.soloAwait || (r2.argument = this.parseMaybeUnary(null, true)), this.finishNode(r2, "AwaitExpression");
          }
          isAmbiguousAwait() {
            if (this.hasPrecedingLineBreak())
              return true;
            let { type: t2 } = this.state;
            return t2 === 53 || t2 === 10 || t2 === 0 || ct2(t2) || t2 === 101 && !this.state.containsEsc || t2 === 135 || t2 === 56 || this.hasPlugin("v8intrinsic") && t2 === 54;
          }
          parseYield() {
            let t2 = this.startNode();
            this.expressionScope.recordParameterInitializerError(u2.YieldInParameter, { at: t2 }), this.next();
            let r2 = false, e25 = null;
            if (!this.hasPrecedingLineBreak())
              switch (r2 = this.eat(55), this.state.type) {
                case 13:
                case 137:
                case 8:
                case 11:
                case 3:
                case 9:
                case 14:
                case 12:
                  if (!r2)
                    break;
                default:
                  e25 = this.parseMaybeAssign();
              }
            return t2.delegate = r2, t2.argument = e25, this.finishNode(t2, "YieldExpression");
          }
          checkPipelineAtInfixOperator(t2, r2) {
            this.hasPlugin(["pipelineOperator", { proposal: "smart" }]) && t2.type === "SequenceExpression" && this.raise(u2.PipelineHeadSequenceExpression, { at: r2 });
          }
          parseSmartPipelineBodyInStyle(t2, r2) {
            if (this.isSimpleReference(t2)) {
              let e25 = this.startNodeAt(r2);
              return e25.callee = t2, this.finishNode(e25, "PipelineBareFunction");
            } else {
              let e25 = this.startNodeAt(r2);
              return this.checkSmartPipeTopicBodyEarlyErrors(r2), e25.expression = t2, this.finishNode(e25, "PipelineTopicExpression");
            }
          }
          isSimpleReference(t2) {
            switch (t2.type) {
              case "MemberExpression":
                return !t2.computed && this.isSimpleReference(t2.object);
              case "Identifier":
                return true;
              default:
                return false;
            }
          }
          checkSmartPipeTopicBodyEarlyErrors(t2) {
            if (this.match(19))
              throw this.raise(u2.PipelineBodyNoArrow, { at: this.state.startLoc });
            this.topicReferenceWasUsedInCurrentContext() || this.raise(u2.PipelineTopicUnused, { at: t2 });
          }
          withTopicBindingContext(t2) {
            let r2 = this.state.topicContext;
            this.state.topicContext = { maxNumOfResolvableTopics: 1, maxTopicIndex: null };
            try {
              return t2();
            } finally {
              this.state.topicContext = r2;
            }
          }
          withSmartMixTopicForbiddingContext(t2) {
            if (this.hasPlugin(["pipelineOperator", { proposal: "smart" }])) {
              let r2 = this.state.topicContext;
              this.state.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null };
              try {
                return t2();
              } finally {
                this.state.topicContext = r2;
              }
            } else
              return t2();
          }
          withSoloAwaitPermittingContext(t2) {
            let r2 = this.state.soloAwait;
            this.state.soloAwait = true;
            try {
              return t2();
            } finally {
              this.state.soloAwait = r2;
            }
          }
          allowInAnd(t2) {
            let r2 = this.prodParam.currentFlags();
            if (He2 & ~r2) {
              this.prodParam.enter(r2 | He2);
              try {
                return t2();
              } finally {
                this.prodParam.exit();
              }
            }
            return t2();
          }
          disallowInAnd(t2) {
            let r2 = this.prodParam.currentFlags();
            if (He2 & r2) {
              this.prodParam.enter(r2 & ~He2);
              try {
                return t2();
              } finally {
                this.prodParam.exit();
              }
            }
            return t2();
          }
          registerTopicReference() {
            this.state.topicContext.maxTopicIndex = 0;
          }
          topicReferenceIsAllowedInCurrentContext() {
            return this.state.topicContext.maxNumOfResolvableTopics >= 1;
          }
          topicReferenceWasUsedInCurrentContext() {
            return this.state.topicContext.maxTopicIndex != null && this.state.topicContext.maxTopicIndex >= 0;
          }
          parseFSharpPipelineBody(t2) {
            let r2 = this.state.startLoc;
            this.state.potentialArrowAt = this.state.start;
            let e25 = this.state.inFSharpPipelineDirectBody;
            this.state.inFSharpPipelineDirectBody = true;
            let s2 = this.parseExprOp(this.parseMaybeUnaryOrPrivate(), r2, t2);
            return this.state.inFSharpPipelineDirectBody = e25, s2;
          }
          parseModuleExpression() {
            this.expectPlugin("moduleBlocks");
            let t2 = this.startNode();
            this.next(), this.match(5) || this.unexpected(null, 5);
            let r2 = this.startNodeAt(this.state.endLoc);
            this.next();
            let e25 = this.initializeScopes(true);
            this.enterInitialScopes();
            try {
              t2.body = this.parseProgram(r2, 8, "module");
            } finally {
              e25();
            }
            return this.finishNode(t2, "ModuleExpression");
          }
          parsePropertyNamePrefixOperator(t2) {
          }
        }, gs = { kind: "loop" }, gh2 = { kind: "switch" }, ie2 = { Expression: 0, Declaration: 1, HangingDeclaration: 2, NullableId: 4, Async: 8 }, ae2 = { StatementOnly: 0, AllowImportExport: 1, AllowDeclaration: 2, AllowFunctionDeclaration: 4, AllowLabeledFunction: 8 }, Ph2 = /[\uD800-\uDFFF]/u, Ps2 = /in(?:stanceof)?/y;
        function Ah2(t2, r2) {
          for (let e25 = 0; e25 < t2.length; e25++) {
            let s2 = t2[e25], { type: i2 } = s2;
            if (typeof i2 == "number") {
              {
                if (i2 === 136) {
                  let { loc: a2, start: n2, value: o2, end: c2 } = s2, p2 = n2 + 1, m2 = y2(a2.start, 1);
                  t2.splice(e25, 1, new Se2({ type: xe2(27), value: "#", start: n2, end: p2, startLoc: a2.start, endLoc: m2 }), new Se2({ type: xe2(130), value: o2, start: p2, end: c2, startLoc: m2, endLoc: a2.end })), e25++;
                  continue;
                }
                if (ct2(i2)) {
                  let { loc: a2, start: n2, value: o2, end: c2 } = s2, p2 = n2 + 1, m2 = y2(a2.start, 1), x2;
                  r2.charCodeAt(n2) === 96 ? x2 = new Se2({ type: xe2(22), value: "`", start: n2, end: p2, startLoc: a2.start, endLoc: m2 }) : x2 = new Se2({ type: xe2(8), value: "}", start: n2, end: p2, startLoc: a2.start, endLoc: m2 });
                  let A2, b2, O2, R2;
                  i2 === 24 ? (b2 = c2 - 1, O2 = y2(a2.end, -1), A2 = o2 === null ? null : o2.slice(1, -1), R2 = new Se2({ type: xe2(22), value: "`", start: b2, end: c2, startLoc: O2, endLoc: a2.end })) : (b2 = c2 - 2, O2 = y2(a2.end, -2), A2 = o2 === null ? null : o2.slice(1, -2), R2 = new Se2({ type: xe2(23), value: "${", start: b2, end: c2, startLoc: O2, endLoc: a2.end })), t2.splice(e25, 1, x2, new Se2({ type: xe2(20), value: A2, start: p2, end: b2, startLoc: m2, endLoc: O2 }), R2), e25 += 2;
                  continue;
                }
              }
              s2.type = xe2(i2);
            }
          }
          return t2;
        }
        var Th2 = class extends xh2 {
          parseTopLevel(t2, r2) {
            return t2.program = this.parseProgram(r2), t2.comments = this.state.comments, this.options.tokens && (t2.tokens = Ah2(this.tokens, this.input)), this.finishNode(t2, "File");
          }
          parseProgram(t2) {
            let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 137, e25 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.options.sourceType;
            if (t2.sourceType = e25, t2.interpreter = this.parseInterpreterDirective(), this.parseBlockBody(t2, true, true, r2), this.inModule && !this.options.allowUndeclaredExports && this.scope.undefinedExports.size > 0)
              for (let [i2, a2] of Array.from(this.scope.undefinedExports))
                this.raise(u2.ModuleExportUndefined, { at: a2, localName: i2 });
            let s2;
            return r2 === 137 ? s2 = this.finishNode(t2, "Program") : s2 = this.finishNodeAt(t2, "Program", y2(this.state.startLoc, -1)), s2;
          }
          stmtToDirective(t2) {
            let r2 = t2;
            r2.type = "Directive", r2.value = r2.expression, delete r2.expression;
            let e25 = r2.value, s2 = e25.value, i2 = this.input.slice(e25.start, e25.end), a2 = e25.value = i2.slice(1, -1);
            return this.addExtra(e25, "raw", i2), this.addExtra(e25, "rawValue", a2), this.addExtra(e25, "expressionValue", s2), e25.type = "DirectiveLiteral", r2;
          }
          parseInterpreterDirective() {
            if (!this.match(28))
              return null;
            let t2 = this.startNode();
            return t2.value = this.state.value, this.next(), this.finishNode(t2, "InterpreterDirective");
          }
          isLet() {
            return this.isContextual(99) ? this.hasFollowingBindingAtom() : false;
          }
          chStartsBindingIdentifier(t2, r2) {
            if (ge2(t2)) {
              if (Ps2.lastIndex = r2, Ps2.test(this.input)) {
                let e25 = this.codePointAtPos(Ps2.lastIndex);
                if (!Re2(e25) && e25 !== 92)
                  return false;
              }
              return true;
            } else
              return t2 === 92;
          }
          chStartsBindingPattern(t2) {
            return t2 === 91 || t2 === 123;
          }
          hasFollowingBindingAtom() {
            let t2 = this.nextTokenStart(), r2 = this.codePointAtPos(t2);
            return this.chStartsBindingPattern(r2) || this.chStartsBindingIdentifier(r2, t2);
          }
          hasFollowingBindingIdentifier() {
            let t2 = this.nextTokenStart(), r2 = this.codePointAtPos(t2);
            return this.chStartsBindingIdentifier(r2, t2);
          }
          startsUsingForOf() {
            let t2 = this.lookahead();
            return t2.type === 101 && !t2.containsEsc ? false : (this.expectPlugin("explicitResourceManagement"), true);
          }
          parseModuleItem() {
            return this.parseStatementLike(ae2.AllowImportExport | ae2.AllowDeclaration | ae2.AllowFunctionDeclaration | ae2.AllowLabeledFunction);
          }
          parseStatementListItem() {
            return this.parseStatementLike(ae2.AllowDeclaration | ae2.AllowFunctionDeclaration | ae2.AllowLabeledFunction);
          }
          parseStatementOrFunctionDeclaration(t2) {
            return this.parseStatementLike(ae2.AllowFunctionDeclaration | (t2 ? 0 : ae2.AllowLabeledFunction));
          }
          parseStatement() {
            return this.parseStatementLike(ae2.StatementOnly);
          }
          parseStatementLike(t2) {
            let r2 = null;
            return this.match(26) && (r2 = this.parseDecorators(true)), this.parseStatementContent(t2, r2);
          }
          parseStatementContent(t2, r2) {
            let e25 = this.state.type, s2 = this.startNode(), i2 = !!(t2 & ae2.AllowDeclaration), a2 = !!(t2 & ae2.AllowFunctionDeclaration), n2 = t2 & ae2.AllowImportExport;
            switch (e25) {
              case 60:
                return this.parseBreakContinueStatement(s2, true);
              case 63:
                return this.parseBreakContinueStatement(s2, false);
              case 64:
                return this.parseDebuggerStatement(s2);
              case 90:
                return this.parseDoWhileStatement(s2);
              case 91:
                return this.parseForStatement(s2);
              case 68:
                if (this.lookaheadCharCode() === 46)
                  break;
                return i2 || (this.state.strict ? this.raise(u2.StrictFunction, { at: this.state.startLoc }) : a2 || this.raise(u2.SloppyFunction, { at: this.state.startLoc })), this.parseFunctionStatement(s2, false, !i2 && a2);
              case 80:
                return i2 || this.unexpected(), this.parseClass(this.maybeTakeDecorators(r2, s2), true);
              case 69:
                return this.parseIfStatement(s2);
              case 70:
                return this.parseReturnStatement(s2);
              case 71:
                return this.parseSwitchStatement(s2);
              case 72:
                return this.parseThrowStatement(s2);
              case 73:
                return this.parseTryStatement(s2);
              case 105:
                if (this.hasFollowingLineBreak() || this.state.containsEsc || !this.hasFollowingBindingIdentifier())
                  break;
                return this.expectPlugin("explicitResourceManagement"), !this.scope.inModule && this.scope.inTopLevel ? this.raise(u2.UnexpectedUsingDeclaration, { at: this.state.startLoc }) : i2 || this.raise(u2.UnexpectedLexicalDeclaration, { at: this.state.startLoc }), this.parseVarStatement(s2, "using");
              case 99: {
                if (this.state.containsEsc)
                  break;
                let p2 = this.nextTokenStart(), m2 = this.codePointAtPos(p2);
                if (m2 !== 91 && (!i2 && this.hasFollowingLineBreak() || !this.chStartsBindingIdentifier(m2, p2) && m2 !== 123))
                  break;
              }
              case 75:
                i2 || this.raise(u2.UnexpectedLexicalDeclaration, { at: this.state.startLoc });
              case 74: {
                let p2 = this.state.value;
                return this.parseVarStatement(s2, p2);
              }
              case 92:
                return this.parseWhileStatement(s2);
              case 76:
                return this.parseWithStatement(s2);
              case 5:
                return this.parseBlock();
              case 13:
                return this.parseEmptyStatement(s2);
              case 83: {
                let p2 = this.lookaheadCharCode();
                if (p2 === 40 || p2 === 46)
                  break;
              }
              case 82: {
                !this.options.allowImportExportEverywhere && !n2 && this.raise(u2.UnexpectedImportExport, { at: this.state.startLoc }), this.next();
                let p2;
                return e25 === 83 ? (p2 = this.parseImport(s2), p2.type === "ImportDeclaration" && (!p2.importKind || p2.importKind === "value") && (this.sawUnambiguousESM = true)) : (p2 = this.parseExport(s2, r2), (p2.type === "ExportNamedDeclaration" && (!p2.exportKind || p2.exportKind === "value") || p2.type === "ExportAllDeclaration" && (!p2.exportKind || p2.exportKind === "value") || p2.type === "ExportDefaultDeclaration") && (this.sawUnambiguousESM = true)), this.assertModuleNodeAllowed(p2), p2;
              }
              default:
                if (this.isAsyncFunction())
                  return i2 || this.raise(u2.AsyncFunctionInSingleStatementContext, { at: this.state.startLoc }), this.next(), this.parseFunctionStatement(s2, true, !i2 && a2);
            }
            let o2 = this.state.value, c2 = this.parseExpression();
            return z2(e25) && c2.type === "Identifier" && this.eat(14) ? this.parseLabeledStatement(s2, o2, c2, t2) : this.parseExpressionStatement(s2, c2, r2);
          }
          assertModuleNodeAllowed(t2) {
            !this.options.allowImportExportEverywhere && !this.inModule && this.raise(u2.ImportOutsideModule, { at: t2 });
          }
          decoratorsEnabledBeforeExport() {
            return this.hasPlugin("decorators-legacy") ? true : this.hasPlugin("decorators") && !!this.getPluginOption("decorators", "decoratorsBeforeExport");
          }
          maybeTakeDecorators(t2, r2, e25) {
            return t2 && (r2.decorators = t2, this.resetStartLocationFromNode(r2, t2[0]), e25 && this.resetStartLocationFromNode(e25, r2)), r2;
          }
          canHaveLeadingDecorator() {
            return this.match(80);
          }
          parseDecorators(t2) {
            let r2 = [];
            do
              r2.push(this.parseDecorator());
            while (this.match(26));
            if (this.match(82))
              t2 || this.unexpected(), this.decoratorsEnabledBeforeExport() || this.raise(u2.DecoratorExportClass, { at: this.state.startLoc });
            else if (!this.canHaveLeadingDecorator())
              throw this.raise(u2.UnexpectedLeadingDecorator, { at: this.state.startLoc });
            return r2;
          }
          parseDecorator() {
            this.expectOnePlugin(["decorators", "decorators-legacy"]);
            let t2 = this.startNode();
            if (this.next(), this.hasPlugin("decorators")) {
              let r2 = this.state.startLoc, e25;
              if (this.match(10)) {
                let s2 = this.state.startLoc;
                this.next(), e25 = this.parseExpression(), this.expect(11), e25 = this.wrapParenthesis(s2, e25);
                let i2 = this.state.startLoc;
                t2.expression = this.parseMaybeDecoratorArguments(e25), this.getPluginOption("decorators", "allowCallParenthesized") === false && t2.expression !== e25 && this.raise(u2.DecoratorArgumentsOutsideParentheses, { at: i2 });
              } else {
                for (e25 = this.parseIdentifier(false); this.eat(16); ) {
                  let s2 = this.startNodeAt(r2);
                  s2.object = e25, this.match(136) ? (this.classScope.usePrivateName(this.state.value, this.state.startLoc), s2.property = this.parsePrivateName()) : s2.property = this.parseIdentifier(true), s2.computed = false, e25 = this.finishNode(s2, "MemberExpression");
                }
                t2.expression = this.parseMaybeDecoratorArguments(e25);
              }
            } else
              t2.expression = this.parseExprSubscripts();
            return this.finishNode(t2, "Decorator");
          }
          parseMaybeDecoratorArguments(t2) {
            if (this.eat(10)) {
              let r2 = this.startNodeAtNode(t2);
              return r2.callee = t2, r2.arguments = this.parseCallExpressionArguments(11, false), this.toReferencedList(r2.arguments), this.finishNode(r2, "CallExpression");
            }
            return t2;
          }
          parseBreakContinueStatement(t2, r2) {
            return this.next(), this.isLineTerminator() ? t2.label = null : (t2.label = this.parseIdentifier(), this.semicolon()), this.verifyBreakContinue(t2, r2), this.finishNode(t2, r2 ? "BreakStatement" : "ContinueStatement");
          }
          verifyBreakContinue(t2, r2) {
            let e25;
            for (e25 = 0; e25 < this.state.labels.length; ++e25) {
              let s2 = this.state.labels[e25];
              if ((t2.label == null || s2.name === t2.label.name) && (s2.kind != null && (r2 || s2.kind === "loop") || t2.label && r2))
                break;
            }
            if (e25 === this.state.labels.length) {
              let s2 = r2 ? "BreakStatement" : "ContinueStatement";
              this.raise(u2.IllegalBreakContinue, { at: t2, type: s2 });
            }
          }
          parseDebuggerStatement(t2) {
            return this.next(), this.semicolon(), this.finishNode(t2, "DebuggerStatement");
          }
          parseHeaderExpression() {
            this.expect(10);
            let t2 = this.parseExpression();
            return this.expect(11), t2;
          }
          parseDoWhileStatement(t2) {
            return this.next(), this.state.labels.push(gs), t2.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.state.labels.pop(), this.expect(92), t2.test = this.parseHeaderExpression(), this.eat(13), this.finishNode(t2, "DoWhileStatement");
          }
          parseForStatement(t2) {
            this.next(), this.state.labels.push(gs);
            let r2 = null;
            if (this.isAwaitAllowed() && this.eatContextual(96) && (r2 = this.state.lastTokStartLoc), this.scope.enter(je2), this.expect(10), this.match(13))
              return r2 !== null && this.unexpected(r2), this.parseFor(t2, null);
            let e25 = this.isContextual(99), s2 = this.isContextual(105) && !this.hasFollowingLineBreak(), i2 = e25 && this.hasFollowingBindingAtom() || s2 && this.hasFollowingBindingIdentifier() && this.startsUsingForOf();
            if (this.match(74) || this.match(75) || i2) {
              let p2 = this.startNode(), m2 = this.state.value;
              this.next(), this.parseVar(p2, true, m2);
              let x2 = this.finishNode(p2, "VariableDeclaration"), A2 = this.match(58);
              return A2 && s2 && this.raise(u2.ForInUsing, { at: x2 }), (A2 || this.isContextual(101)) && x2.declarations.length === 1 ? this.parseForIn(t2, x2, r2) : (r2 !== null && this.unexpected(r2), this.parseFor(t2, x2));
            }
            let a2 = this.isContextual(95), n2 = new Ct2(), o2 = this.parseExpression(true, n2), c2 = this.isContextual(101);
            if (c2 && (e25 && this.raise(u2.ForOfLet, { at: o2 }), r2 === null && a2 && o2.type === "Identifier" && this.raise(u2.ForOfAsync, { at: o2 })), c2 || this.match(58)) {
              this.checkDestructuringPrivate(n2), this.toAssignable(o2, true);
              let p2 = c2 ? "ForOfStatement" : "ForInStatement";
              return this.checkLVal(o2, { in: { type: p2 } }), this.parseForIn(t2, o2, r2);
            } else
              this.checkExpressionErrors(n2, true);
            return r2 !== null && this.unexpected(r2), this.parseFor(t2, o2);
          }
          parseFunctionStatement(t2, r2, e25) {
            return this.next(), this.parseFunction(t2, ie2.Declaration | (e25 ? ie2.HangingDeclaration : 0) | (r2 ? ie2.Async : 0));
          }
          parseIfStatement(t2) {
            return this.next(), t2.test = this.parseHeaderExpression(), t2.consequent = this.parseStatementOrFunctionDeclaration(true), t2.alternate = this.eat(66) ? this.parseStatementOrFunctionDeclaration(true) : null, this.finishNode(t2, "IfStatement");
          }
          parseReturnStatement(t2) {
            return !this.prodParam.hasReturn && !this.options.allowReturnOutsideFunction && this.raise(u2.IllegalReturn, { at: this.state.startLoc }), this.next(), this.isLineTerminator() ? t2.argument = null : (t2.argument = this.parseExpression(), this.semicolon()), this.finishNode(t2, "ReturnStatement");
          }
          parseSwitchStatement(t2) {
            this.next(), t2.discriminant = this.parseHeaderExpression();
            let r2 = t2.cases = [];
            this.expect(5), this.state.labels.push(gh2), this.scope.enter(je2);
            let e25;
            for (let s2; !this.match(8); )
              if (this.match(61) || this.match(65)) {
                let i2 = this.match(61);
                e25 && this.finishNode(e25, "SwitchCase"), r2.push(e25 = this.startNode()), e25.consequent = [], this.next(), i2 ? e25.test = this.parseExpression() : (s2 && this.raise(u2.MultipleDefaultsInSwitch, { at: this.state.lastTokStartLoc }), s2 = true, e25.test = null), this.expect(14);
              } else
                e25 ? e25.consequent.push(this.parseStatementListItem()) : this.unexpected();
            return this.scope.exit(), e25 && this.finishNode(e25, "SwitchCase"), this.next(), this.state.labels.pop(), this.finishNode(t2, "SwitchStatement");
          }
          parseThrowStatement(t2) {
            return this.next(), this.hasPrecedingLineBreak() && this.raise(u2.NewlineAfterThrow, { at: this.state.lastTokEndLoc }), t2.argument = this.parseExpression(), this.semicolon(), this.finishNode(t2, "ThrowStatement");
          }
          parseCatchClauseParam() {
            let t2 = this.parseBindingAtom(), r2 = t2.type === "Identifier";
            return this.scope.enter(r2 ? Sr : 0), this.checkLVal(t2, { in: { type: "CatchClause" }, binding: De2, allowingSloppyLetBinding: true }), t2;
          }
          parseTryStatement(t2) {
            if (this.next(), t2.block = this.parseBlock(), t2.handler = null, this.match(62)) {
              let r2 = this.startNode();
              this.next(), this.match(10) ? (this.expect(10), r2.param = this.parseCatchClauseParam(), this.expect(11)) : (r2.param = null, this.scope.enter(je2)), r2.body = this.withSmartMixTopicForbiddingContext(() => this.parseBlock(false, false)), this.scope.exit(), t2.handler = this.finishNode(r2, "CatchClause");
            }
            return t2.finalizer = this.eat(67) ? this.parseBlock() : null, !t2.handler && !t2.finalizer && this.raise(u2.NoCatchOrFinally, { at: t2 }), this.finishNode(t2, "TryStatement");
          }
          parseVarStatement(t2, r2) {
            let e25 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            return this.next(), this.parseVar(t2, false, r2, e25), this.semicolon(), this.finishNode(t2, "VariableDeclaration");
          }
          parseWhileStatement(t2) {
            return this.next(), t2.test = this.parseHeaderExpression(), this.state.labels.push(gs), t2.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.state.labels.pop(), this.finishNode(t2, "WhileStatement");
          }
          parseWithStatement(t2) {
            return this.state.strict && this.raise(u2.StrictWith, { at: this.state.startLoc }), this.next(), t2.object = this.parseHeaderExpression(), t2.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.finishNode(t2, "WithStatement");
          }
          parseEmptyStatement(t2) {
            return this.next(), this.finishNode(t2, "EmptyStatement");
          }
          parseLabeledStatement(t2, r2, e25, s2) {
            for (let a2 of this.state.labels)
              a2.name === r2 && this.raise(u2.LabelRedeclaration, { at: e25, labelName: r2 });
            let i2 = Jo2(this.state.type) ? "loop" : this.match(71) ? "switch" : null;
            for (let a2 = this.state.labels.length - 1; a2 >= 0; a2--) {
              let n2 = this.state.labels[a2];
              if (n2.statementStart === t2.start)
                n2.statementStart = this.state.start, n2.kind = i2;
              else
                break;
            }
            return this.state.labels.push({ name: r2, kind: i2, statementStart: this.state.start }), t2.body = s2 & ae2.AllowLabeledFunction ? this.parseStatementOrFunctionDeclaration(false) : this.parseStatement(), this.state.labels.pop(), t2.label = e25, this.finishNode(t2, "LabeledStatement");
          }
          parseExpressionStatement(t2, r2, e25) {
            return t2.expression = r2, this.semicolon(), this.finishNode(t2, "ExpressionStatement");
          }
          parseBlock() {
            let t2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, e25 = arguments.length > 2 ? arguments[2] : void 0, s2 = this.startNode();
            return t2 && this.state.strictErrors.clear(), this.expect(5), r2 && this.scope.enter(je2), this.parseBlockBody(s2, t2, false, 8, e25), r2 && this.scope.exit(), this.finishNode(s2, "BlockStatement");
          }
          isValidDirective(t2) {
            return t2.type === "ExpressionStatement" && t2.expression.type === "StringLiteral" && !t2.expression.extra.parenthesized;
          }
          parseBlockBody(t2, r2, e25, s2, i2) {
            let a2 = t2.body = [], n2 = t2.directives = [];
            this.parseBlockOrModuleBlockBody(a2, r2 ? n2 : void 0, e25, s2, i2);
          }
          parseBlockOrModuleBlockBody(t2, r2, e25, s2, i2) {
            let a2 = this.state.strict, n2 = false, o2 = false;
            for (; !this.match(s2); ) {
              let c2 = e25 ? this.parseModuleItem() : this.parseStatementListItem();
              if (r2 && !o2) {
                if (this.isValidDirective(c2)) {
                  let p2 = this.stmtToDirective(c2);
                  r2.push(p2), !n2 && p2.value.value === "use strict" && (n2 = true, this.setStrict(true));
                  continue;
                }
                o2 = true, this.state.strictErrors.clear();
              }
              t2.push(c2);
            }
            i2 && i2.call(this, n2), a2 || this.setStrict(false), this.next();
          }
          parseFor(t2, r2) {
            return t2.init = r2, this.semicolon(false), t2.test = this.match(13) ? null : this.parseExpression(), this.semicolon(false), t2.update = this.match(11) ? null : this.parseExpression(), this.expect(11), t2.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.scope.exit(), this.state.labels.pop(), this.finishNode(t2, "ForStatement");
          }
          parseForIn(t2, r2, e25) {
            let s2 = this.match(58);
            return this.next(), s2 ? e25 !== null && this.unexpected(e25) : t2.await = e25 !== null, r2.type === "VariableDeclaration" && r2.declarations[0].init != null && (!s2 || this.state.strict || r2.kind !== "var" || r2.declarations[0].id.type !== "Identifier") && this.raise(u2.ForInOfLoopInitializer, { at: r2, type: s2 ? "ForInStatement" : "ForOfStatement" }), r2.type === "AssignmentPattern" && this.raise(u2.InvalidLhs, { at: r2, ancestor: { type: "ForStatement" } }), t2.left = r2, t2.right = s2 ? this.parseExpression() : this.parseMaybeAssignAllowIn(), this.expect(11), t2.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.scope.exit(), this.state.labels.pop(), this.finishNode(t2, s2 ? "ForInStatement" : "ForOfStatement");
          }
          parseVar(t2, r2, e25) {
            let s2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, i2 = t2.declarations = [];
            for (t2.kind = e25; ; ) {
              let a2 = this.startNode();
              if (this.parseVarId(a2, e25), a2.init = this.eat(29) ? r2 ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn() : null, a2.init === null && !s2 && (a2.id.type !== "Identifier" && !(r2 && (this.match(58) || this.isContextual(101))) ? this.raise(u2.DeclarationMissingInitializer, { at: this.state.lastTokEndLoc, kind: "destructuring" }) : e25 === "const" && !(this.match(58) || this.isContextual(101)) && this.raise(u2.DeclarationMissingInitializer, { at: this.state.lastTokEndLoc, kind: "const" })), i2.push(this.finishNode(a2, "VariableDeclarator")), !this.eat(12))
                break;
            }
            return t2;
          }
          parseVarId(t2, r2) {
            let e25 = this.parseBindingAtom();
            this.checkLVal(e25, { in: { type: "VariableDeclarator" }, binding: r2 === "var" ? xt : De2 }), t2.id = e25;
          }
          parseAsyncFunctionExpression(t2) {
            return this.parseFunction(t2, ie2.Async);
          }
          parseFunction(t2) {
            let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ie2.Expression, e25 = r2 & ie2.HangingDeclaration, s2 = !!(r2 & ie2.Declaration), i2 = s2 && !(r2 & ie2.NullableId), a2 = !!(r2 & ie2.Async);
            this.initFunction(t2, a2), this.match(55) && (e25 && this.raise(u2.GeneratorInSingleStatementContext, { at: this.state.startLoc }), this.next(), t2.generator = true), s2 && (t2.id = this.parseFunctionId(i2));
            let n2 = this.state.maybeInArrowParameters;
            return this.state.maybeInArrowParameters = false, this.scope.enter(Pe2), this.prodParam.enter(Et(a2, t2.generator)), s2 || (t2.id = this.parseFunctionId()), this.parseFunctionParams(t2, false), this.withSmartMixTopicForbiddingContext(() => {
              this.parseFunctionBodyAndFinish(t2, s2 ? "FunctionDeclaration" : "FunctionExpression");
            }), this.prodParam.exit(), this.scope.exit(), s2 && !e25 && this.registerFunctionStatementId(t2), this.state.maybeInArrowParameters = n2, t2;
          }
          parseFunctionId(t2) {
            return t2 || z2(this.state.type) ? this.parseIdentifier() : null;
          }
          parseFunctionParams(t2, r2) {
            this.expect(10), this.expressionScope.enter(ql2()), t2.params = this.parseBindingList(11, 41, false, r2), this.expressionScope.exit();
          }
          registerFunctionStatementId(t2) {
            t2.id && this.scope.declareName(t2.id.name, this.state.strict || t2.generator || t2.async ? this.scope.treatFunctionsAsVar ? xt : De2 : Dr2, t2.id.loc.start);
          }
          parseClass(t2, r2, e25) {
            this.next();
            let s2 = this.state.strict;
            return this.state.strict = true, this.parseClassId(t2, r2, e25), this.parseClassSuper(t2), t2.body = this.parseClassBody(!!t2.superClass, s2), this.finishNode(t2, r2 ? "ClassDeclaration" : "ClassExpression");
          }
          isClassProperty() {
            return this.match(29) || this.match(13) || this.match(8);
          }
          isClassMethod() {
            return this.match(10);
          }
          isNonstaticConstructor(t2) {
            return !t2.computed && !t2.static && (t2.key.name === "constructor" || t2.key.value === "constructor");
          }
          parseClassBody(t2, r2) {
            this.classScope.enter();
            let e25 = { hadConstructor: false, hadSuperClass: t2 }, s2 = [], i2 = this.startNode();
            if (i2.body = [], this.expect(5), this.withSmartMixTopicForbiddingContext(() => {
              for (; !this.match(8); ) {
                if (this.eat(13)) {
                  if (s2.length > 0)
                    throw this.raise(u2.DecoratorSemicolon, { at: this.state.lastTokEndLoc });
                  continue;
                }
                if (this.match(26)) {
                  s2.push(this.parseDecorator());
                  continue;
                }
                let a2 = this.startNode();
                s2.length && (a2.decorators = s2, this.resetStartLocationFromNode(a2, s2[0]), s2 = []), this.parseClassMember(i2, a2, e25), a2.kind === "constructor" && a2.decorators && a2.decorators.length > 0 && this.raise(u2.DecoratorConstructor, { at: a2 });
              }
            }), this.state.strict = r2, this.next(), s2.length)
              throw this.raise(u2.TrailingDecorator, { at: this.state.startLoc });
            return this.classScope.exit(), this.finishNode(i2, "ClassBody");
          }
          parseClassMemberFromModifier(t2, r2) {
            let e25 = this.parseIdentifier(true);
            if (this.isClassMethod()) {
              let s2 = r2;
              return s2.kind = "method", s2.computed = false, s2.key = e25, s2.static = false, this.pushClassMethod(t2, s2, false, false, false, false), true;
            } else if (this.isClassProperty()) {
              let s2 = r2;
              return s2.computed = false, s2.key = e25, s2.static = false, t2.body.push(this.parseClassProperty(s2)), true;
            }
            return this.resetPreviousNodeTrailingComments(e25), false;
          }
          parseClassMember(t2, r2, e25) {
            let s2 = this.isContextual(104);
            if (s2) {
              if (this.parseClassMemberFromModifier(t2, r2))
                return;
              if (this.eat(5)) {
                this.parseClassStaticBlock(t2, r2);
                return;
              }
            }
            this.parseClassMemberWithIsStatic(t2, r2, e25, s2);
          }
          parseClassMemberWithIsStatic(t2, r2, e25, s2) {
            let i2 = r2, a2 = r2, n2 = r2, o2 = r2, c2 = r2, p2 = i2, m2 = i2;
            if (r2.static = s2, this.parsePropertyNamePrefixOperator(r2), this.eat(55)) {
              p2.kind = "method";
              let R2 = this.match(136);
              if (this.parseClassElementName(p2), R2) {
                this.pushClassPrivateMethod(t2, a2, true, false);
                return;
              }
              this.isNonstaticConstructor(i2) && this.raise(u2.ConstructorIsGenerator, { at: i2.key }), this.pushClassMethod(t2, i2, true, false, false, false);
              return;
            }
            let x2 = z2(this.state.type) && !this.state.containsEsc, A2 = this.match(136), b2 = this.parseClassElementName(r2), O2 = this.state.startLoc;
            if (this.parsePostMemberNameModifiers(m2), this.isClassMethod()) {
              if (p2.kind = "method", A2) {
                this.pushClassPrivateMethod(t2, a2, false, false);
                return;
              }
              let R2 = this.isNonstaticConstructor(i2), Y2 = false;
              R2 && (i2.kind = "constructor", e25.hadConstructor && !this.hasPlugin("typescript") && this.raise(u2.DuplicateConstructor, { at: b2 }), R2 && this.hasPlugin("typescript") && r2.override && this.raise(u2.OverrideOnConstructor, { at: b2 }), e25.hadConstructor = true, Y2 = e25.hadSuperClass), this.pushClassMethod(t2, i2, false, false, R2, Y2);
            } else if (this.isClassProperty())
              A2 ? this.pushClassPrivateProperty(t2, o2) : this.pushClassProperty(t2, n2);
            else if (x2 && b2.name === "async" && !this.isLineTerminator()) {
              this.resetPreviousNodeTrailingComments(b2);
              let R2 = this.eat(55);
              m2.optional && this.unexpected(O2), p2.kind = "method";
              let Y2 = this.match(136);
              this.parseClassElementName(p2), this.parsePostMemberNameModifiers(m2), Y2 ? this.pushClassPrivateMethod(t2, a2, R2, true) : (this.isNonstaticConstructor(i2) && this.raise(u2.ConstructorIsAsync, { at: i2.key }), this.pushClassMethod(t2, i2, R2, true, false, false));
            } else if (x2 && (b2.name === "get" || b2.name === "set") && !(this.match(55) && this.isLineTerminator())) {
              this.resetPreviousNodeTrailingComments(b2), p2.kind = b2.name;
              let R2 = this.match(136);
              this.parseClassElementName(i2), R2 ? this.pushClassPrivateMethod(t2, a2, false, false) : (this.isNonstaticConstructor(i2) && this.raise(u2.ConstructorIsAccessor, { at: i2.key }), this.pushClassMethod(t2, i2, false, false, false, false)), this.checkGetterSetterParams(i2);
            } else if (x2 && b2.name === "accessor" && !this.isLineTerminator()) {
              this.expectPlugin("decoratorAutoAccessors"), this.resetPreviousNodeTrailingComments(b2);
              let R2 = this.match(136);
              this.parseClassElementName(n2), this.pushClassAccessorProperty(t2, c2, R2);
            } else
              this.isLineTerminator() ? A2 ? this.pushClassPrivateProperty(t2, o2) : this.pushClassProperty(t2, n2) : this.unexpected();
          }
          parseClassElementName(t2) {
            let { type: r2, value: e25 } = this.state;
            if ((r2 === 130 || r2 === 131) && t2.static && e25 === "prototype" && this.raise(u2.StaticPrototype, { at: this.state.startLoc }), r2 === 136) {
              e25 === "constructor" && this.raise(u2.ConstructorClassPrivateField, { at: this.state.startLoc });
              let s2 = this.parsePrivateName();
              return t2.key = s2, s2;
            }
            return this.parsePropertyName(t2);
          }
          parseClassStaticBlock(t2, r2) {
            var e25;
            this.scope.enter(Ne2 | ft2 | pt2);
            let s2 = this.state.labels;
            this.state.labels = [], this.prodParam.enter($e2);
            let i2 = r2.body = [];
            this.parseBlockOrModuleBlockBody(i2, void 0, false, 8), this.prodParam.exit(), this.scope.exit(), this.state.labels = s2, t2.body.push(this.finishNode(r2, "StaticBlock")), (e25 = r2.decorators) != null && e25.length && this.raise(u2.DecoratorStaticBlock, { at: r2 });
          }
          pushClassProperty(t2, r2) {
            !r2.computed && (r2.key.name === "constructor" || r2.key.value === "constructor") && this.raise(u2.ConstructorClassField, { at: r2.key }), t2.body.push(this.parseClassProperty(r2));
          }
          pushClassPrivateProperty(t2, r2) {
            let e25 = this.parseClassPrivateProperty(r2);
            t2.body.push(e25), this.classScope.declarePrivateName(this.getPrivateNameSV(e25.key), hs, e25.key.loc.start);
          }
          pushClassAccessorProperty(t2, r2, e25) {
            if (!e25 && !r2.computed) {
              let i2 = r2.key;
              (i2.name === "constructor" || i2.value === "constructor") && this.raise(u2.ConstructorClassField, { at: i2 });
            }
            let s2 = this.parseClassAccessorProperty(r2);
            t2.body.push(s2), e25 && this.classScope.declarePrivateName(this.getPrivateNameSV(s2.key), hs, s2.key.loc.start);
          }
          pushClassMethod(t2, r2, e25, s2, i2, a2) {
            t2.body.push(this.parseMethod(r2, e25, s2, i2, a2, "ClassMethod", true));
          }
          pushClassPrivateMethod(t2, r2, e25, s2) {
            let i2 = this.parseMethod(r2, e25, s2, false, false, "ClassPrivateMethod", true);
            t2.body.push(i2);
            let a2 = i2.kind === "get" ? i2.static ? gl2 : Al2 : i2.kind === "set" ? i2.static ? Pl2 : Tl2 : hs;
            this.declareClassPrivateMethodInScope(i2, a2);
          }
          declareClassPrivateMethodInScope(t2, r2) {
            this.classScope.declarePrivateName(this.getPrivateNameSV(t2.key), r2, t2.key.loc.start);
          }
          parsePostMemberNameModifiers(t2) {
          }
          parseClassPrivateProperty(t2) {
            return this.parseInitializer(t2), this.semicolon(), this.finishNode(t2, "ClassPrivateProperty");
          }
          parseClassProperty(t2) {
            return this.parseInitializer(t2), this.semicolon(), this.finishNode(t2, "ClassProperty");
          }
          parseClassAccessorProperty(t2) {
            return this.parseInitializer(t2), this.semicolon(), this.finishNode(t2, "ClassAccessorProperty");
          }
          parseInitializer(t2) {
            this.scope.enter(Ne2 | pt2), this.expressionScope.enter(Vr2()), this.prodParam.enter($e2), t2.value = this.eat(29) ? this.parseMaybeAssignAllowIn() : null, this.expressionScope.exit(), this.prodParam.exit(), this.scope.exit();
          }
          parseClassId(t2, r2, e25) {
            let s2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : kr;
            if (z2(this.state.type))
              t2.id = this.parseIdentifier(), r2 && this.declareNameFromIdentifier(t2.id, s2);
            else if (e25 || !r2)
              t2.id = null;
            else
              throw this.raise(u2.MissingClassName, { at: this.state.startLoc });
          }
          parseClassSuper(t2) {
            t2.superClass = this.eat(81) ? this.parseExprSubscripts() : null;
          }
          parseExport(t2, r2) {
            let e25 = this.maybeParseExportDefaultSpecifier(t2), s2 = !e25 || this.eat(12), i2 = s2 && this.eatExportStar(t2), a2 = i2 && this.maybeParseExportNamespaceSpecifier(t2), n2 = s2 && (!a2 || this.eat(12)), o2 = e25 || i2;
            if (i2 && !a2) {
              if (e25 && this.unexpected(), r2)
                throw this.raise(u2.UnsupportedDecoratorExport, { at: t2 });
              return this.parseExportFrom(t2, true), this.finishNode(t2, "ExportAllDeclaration");
            }
            let c2 = this.maybeParseExportNamedSpecifiers(t2);
            if (e25 && s2 && !i2 && !c2 || a2 && n2 && !c2)
              throw this.unexpected(null, 5);
            let p2;
            if (o2 || c2) {
              if (p2 = false, r2)
                throw this.raise(u2.UnsupportedDecoratorExport, { at: t2 });
              this.parseExportFrom(t2, o2);
            } else
              p2 = this.maybeParseExportDeclaration(t2);
            if (o2 || c2 || p2) {
              var m2;
              let x2 = t2;
              if (this.checkExport(x2, true, false, !!x2.source), ((m2 = x2.declaration) == null ? void 0 : m2.type) === "ClassDeclaration")
                this.maybeTakeDecorators(r2, x2.declaration, x2);
              else if (r2)
                throw this.raise(u2.UnsupportedDecoratorExport, { at: t2 });
              return this.finishNode(x2, "ExportNamedDeclaration");
            }
            if (this.eat(65)) {
              let x2 = t2, A2 = this.parseExportDefaultExpression();
              if (x2.declaration = A2, A2.type === "ClassDeclaration")
                this.maybeTakeDecorators(r2, A2, x2);
              else if (r2)
                throw this.raise(u2.UnsupportedDecoratorExport, { at: t2 });
              return this.checkExport(x2, true, true), this.finishNode(x2, "ExportDefaultDeclaration");
            }
            throw this.unexpected(null, 5);
          }
          eatExportStar(t2) {
            return this.eat(55);
          }
          maybeParseExportDefaultSpecifier(t2) {
            if (this.isExportDefaultSpecifier()) {
              this.expectPlugin("exportDefaultFrom");
              let r2 = this.startNode();
              return r2.exported = this.parseIdentifier(true), t2.specifiers = [this.finishNode(r2, "ExportDefaultSpecifier")], true;
            }
            return false;
          }
          maybeParseExportNamespaceSpecifier(t2) {
            if (this.isContextual(93)) {
              t2.specifiers || (t2.specifiers = []);
              let r2 = this.startNodeAt(this.state.lastTokStartLoc);
              return this.next(), r2.exported = this.parseModuleExportName(), t2.specifiers.push(this.finishNode(r2, "ExportNamespaceSpecifier")), true;
            }
            return false;
          }
          maybeParseExportNamedSpecifiers(t2) {
            if (this.match(5)) {
              t2.specifiers || (t2.specifiers = []);
              let r2 = t2.exportKind === "type";
              return t2.specifiers.push(...this.parseExportSpecifiers(r2)), t2.source = null, t2.declaration = null, this.hasPlugin("importAssertions") && (t2.assertions = []), true;
            }
            return false;
          }
          maybeParseExportDeclaration(t2) {
            return this.shouldParseExportDeclaration() ? (t2.specifiers = [], t2.source = null, this.hasPlugin("importAssertions") && (t2.assertions = []), t2.declaration = this.parseExportDeclaration(t2), true) : false;
          }
          isAsyncFunction() {
            if (!this.isContextual(95))
              return false;
            let t2 = this.nextTokenStart();
            return !ps.test(this.input.slice(this.state.pos, t2)) && this.isUnparsedContextual(t2, "function");
          }
          parseExportDefaultExpression() {
            let t2 = this.startNode();
            if (this.match(68))
              return this.next(), this.parseFunction(t2, ie2.Declaration | ie2.NullableId);
            if (this.isAsyncFunction())
              return this.next(), this.next(), this.parseFunction(t2, ie2.Declaration | ie2.NullableId | ie2.Async);
            if (this.match(80))
              return this.parseClass(t2, true, true);
            if (this.match(26))
              return this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") && this.raise(u2.DecoratorBeforeExport, { at: this.state.startLoc }), this.parseClass(this.maybeTakeDecorators(this.parseDecorators(false), this.startNode()), true, true);
            if (this.match(75) || this.match(74) || this.isLet())
              throw this.raise(u2.UnsupportedDefaultExport, { at: this.state.startLoc });
            let r2 = this.parseMaybeAssignAllowIn();
            return this.semicolon(), r2;
          }
          parseExportDeclaration(t2) {
            return this.match(80) ? this.parseClass(this.startNode(), true, false) : this.parseStatementListItem();
          }
          isExportDefaultSpecifier() {
            let { type: t2 } = this.state;
            if (z2(t2)) {
              if (t2 === 95 && !this.state.containsEsc || t2 === 99)
                return false;
              if ((t2 === 128 || t2 === 127) && !this.state.containsEsc) {
                let { type: s2 } = this.lookahead();
                if (z2(s2) && s2 !== 97 || s2 === 5)
                  return this.expectOnePlugin(["flow", "typescript"]), false;
              }
            } else if (!this.match(65))
              return false;
            let r2 = this.nextTokenStart(), e25 = this.isUnparsedContextual(r2, "from");
            if (this.input.charCodeAt(r2) === 44 || z2(this.state.type) && e25)
              return true;
            if (this.match(65) && e25) {
              let s2 = this.input.charCodeAt(this.nextTokenStartSince(r2 + 4));
              return s2 === 34 || s2 === 39;
            }
            return false;
          }
          parseExportFrom(t2, r2) {
            if (this.eatContextual(97)) {
              t2.source = this.parseImportSource(), this.checkExport(t2);
              let e25 = this.maybeParseImportAssertions();
              e25 && (t2.assertions = e25, this.checkJSONModuleImport(t2));
            } else
              r2 && this.unexpected();
            this.semicolon();
          }
          shouldParseExportDeclaration() {
            let { type: t2 } = this.state;
            if (t2 === 26 && (this.expectOnePlugin(["decorators", "decorators-legacy"]), this.hasPlugin("decorators"))) {
              if (this.getPluginOption("decorators", "decoratorsBeforeExport"))
                throw this.raise(u2.DecoratorBeforeExport, { at: this.state.startLoc });
              return true;
            }
            return t2 === 74 || t2 === 75 || t2 === 68 || t2 === 80 || this.isLet() || this.isAsyncFunction();
          }
          checkExport(t2, r2, e25, s2) {
            if (r2) {
              if (e25) {
                if (this.checkDuplicateExports(t2, "default"), this.hasPlugin("exportDefaultFrom")) {
                  var i2;
                  let a2 = t2.declaration;
                  a2.type === "Identifier" && a2.name === "from" && a2.end - a2.start === 4 && !((i2 = a2.extra) != null && i2.parenthesized) && this.raise(u2.ExportDefaultFromAsIdentifier, { at: a2 });
                }
              } else if (t2.specifiers && t2.specifiers.length)
                for (let a2 of t2.specifiers) {
                  let { exported: n2 } = a2, o2 = n2.type === "Identifier" ? n2.name : n2.value;
                  if (this.checkDuplicateExports(a2, o2), !s2 && a2.local) {
                    let { local: c2 } = a2;
                    c2.type !== "Identifier" ? this.raise(u2.ExportBindingIsString, { at: a2, localName: c2.value, exportName: o2 }) : (this.checkReservedWord(c2.name, c2.loc.start, true, false), this.scope.checkLocalExport(c2));
                  }
                }
              else if (t2.declaration) {
                if (t2.declaration.type === "FunctionDeclaration" || t2.declaration.type === "ClassDeclaration") {
                  let a2 = t2.declaration.id;
                  if (!a2)
                    throw new Error("Assertion failure");
                  this.checkDuplicateExports(t2, a2.name);
                } else if (t2.declaration.type === "VariableDeclaration")
                  for (let a2 of t2.declaration.declarations)
                    this.checkDeclaration(a2.id);
              }
            }
          }
          checkDeclaration(t2) {
            if (t2.type === "Identifier")
              this.checkDuplicateExports(t2, t2.name);
            else if (t2.type === "ObjectPattern")
              for (let r2 of t2.properties)
                this.checkDeclaration(r2);
            else if (t2.type === "ArrayPattern")
              for (let r2 of t2.elements)
                r2 && this.checkDeclaration(r2);
            else
              t2.type === "ObjectProperty" ? this.checkDeclaration(t2.value) : t2.type === "RestElement" ? this.checkDeclaration(t2.argument) : t2.type === "AssignmentPattern" && this.checkDeclaration(t2.left);
          }
          checkDuplicateExports(t2, r2) {
            this.exportedIdentifiers.has(r2) && (r2 === "default" ? this.raise(u2.DuplicateDefaultExport, { at: t2 }) : this.raise(u2.DuplicateExport, { at: t2, exportName: r2 })), this.exportedIdentifiers.add(r2);
          }
          parseExportSpecifiers(t2) {
            let r2 = [], e25 = true;
            for (this.expect(5); !this.eat(8); ) {
              if (e25)
                e25 = false;
              else if (this.expect(12), this.eat(8))
                break;
              let s2 = this.isContextual(128), i2 = this.match(131), a2 = this.startNode();
              a2.local = this.parseModuleExportName(), r2.push(this.parseExportSpecifier(a2, i2, t2, s2));
            }
            return r2;
          }
          parseExportSpecifier(t2, r2, e25, s2) {
            return this.eatContextual(93) ? t2.exported = this.parseModuleExportName() : r2 ? t2.exported = Kl2(t2.local) : t2.exported || (t2.exported = Te2(t2.local)), this.finishNode(t2, "ExportSpecifier");
          }
          parseModuleExportName() {
            if (this.match(131)) {
              let t2 = this.parseStringLiteral(this.state.value), r2 = t2.value.match(Ph2);
              return r2 && this.raise(u2.ModuleExportNameHasLoneSurrogate, { at: t2, surrogateCharCode: r2[0].charCodeAt(0) }), t2;
            }
            return this.parseIdentifier(true);
          }
          isJSONModuleImport(t2) {
            return t2.assertions != null ? t2.assertions.some((r2) => {
              let { key: e25, value: s2 } = r2;
              return s2.value === "json" && (e25.type === "Identifier" ? e25.name === "type" : e25.value === "type");
            }) : false;
          }
          checkImportReflection(t2) {
            if (t2.module) {
              var r2;
              (t2.specifiers.length !== 1 || t2.specifiers[0].type !== "ImportDefaultSpecifier") && this.raise(u2.ImportReflectionNotBinding, { at: t2.specifiers[0].loc.start }), ((r2 = t2.assertions) == null ? void 0 : r2.length) > 0 && this.raise(u2.ImportReflectionHasAssertion, { at: t2.specifiers[0].loc.start });
            }
          }
          checkJSONModuleImport(t2) {
            if (this.isJSONModuleImport(t2) && t2.type !== "ExportAllDeclaration") {
              let { specifiers: r2 } = t2;
              if (r2 != null) {
                let e25 = r2.find((s2) => {
                  let i2;
                  if (s2.type === "ExportSpecifier" ? i2 = s2.local : s2.type === "ImportSpecifier" && (i2 = s2.imported), i2 !== void 0)
                    return i2.type === "Identifier" ? i2.name !== "default" : i2.value !== "default";
                });
                e25 !== void 0 && this.raise(u2.ImportJSONBindingNotDefault, { at: e25.loc.start });
              }
            }
          }
          parseMaybeImportReflection(t2) {
            let r2 = false;
            if (this.isContextual(125)) {
              let e25 = this.lookahead(), s2 = e25.type;
              z2(s2) ? (s2 !== 97 || this.input.charCodeAt(this.nextTokenStartSince(e25.end)) === 102) && (r2 = true) : s2 !== 12 && (r2 = true);
            }
            r2 ? (this.expectPlugin("importReflection"), this.next(), t2.module = true) : this.hasPlugin("importReflection") && (t2.module = false);
          }
          parseImport(t2) {
            if (t2.specifiers = [], !this.match(131)) {
              this.parseMaybeImportReflection(t2);
              let s2 = !this.maybeParseDefaultImportSpecifier(t2) || this.eat(12), i2 = s2 && this.maybeParseStarImportSpecifier(t2);
              s2 && !i2 && this.parseNamedImportSpecifiers(t2), this.expectContextual(97);
            }
            t2.source = this.parseImportSource();
            let r2 = this.maybeParseImportAssertions();
            if (r2)
              t2.assertions = r2;
            else {
              let e25 = this.maybeParseModuleAttributes();
              e25 && (t2.attributes = e25);
            }
            return this.checkImportReflection(t2), this.checkJSONModuleImport(t2), this.semicolon(), this.finishNode(t2, "ImportDeclaration");
          }
          parseImportSource() {
            return this.match(131) || this.unexpected(), this.parseExprAtom();
          }
          shouldParseDefaultImport(t2) {
            return z2(this.state.type);
          }
          parseImportSpecifierLocal(t2, r2, e25) {
            r2.local = this.parseIdentifier(), t2.specifiers.push(this.finishImportSpecifier(r2, e25));
          }
          finishImportSpecifier(t2, r2) {
            let e25 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : De2;
            return this.checkLVal(t2.local, { in: t2, binding: e25 }), this.finishNode(t2, r2);
          }
          parseAssertEntries() {
            let t2 = [], r2 = new Set();
            do {
              if (this.match(8))
                break;
              let e25 = this.startNode(), s2 = this.state.value;
              if (r2.has(s2) && this.raise(u2.ModuleAttributesWithDuplicateKeys, { at: this.state.startLoc, key: s2 }), r2.add(s2), this.match(131) ? e25.key = this.parseStringLiteral(s2) : e25.key = this.parseIdentifier(true), this.expect(14), !this.match(131))
                throw this.raise(u2.ModuleAttributeInvalidValue, { at: this.state.startLoc });
              e25.value = this.parseStringLiteral(this.state.value), t2.push(this.finishNode(e25, "ImportAttribute"));
            } while (this.eat(12));
            return t2;
          }
          maybeParseModuleAttributes() {
            if (this.match(76) && !this.hasPrecedingLineBreak())
              this.expectPlugin("moduleAttributes"), this.next();
            else
              return this.hasPlugin("moduleAttributes") ? [] : null;
            let t2 = [], r2 = new Set();
            do {
              let e25 = this.startNode();
              if (e25.key = this.parseIdentifier(true), e25.key.name !== "type" && this.raise(u2.ModuleAttributeDifferentFromType, { at: e25.key }), r2.has(e25.key.name) && this.raise(u2.ModuleAttributesWithDuplicateKeys, { at: e25.key, key: e25.key.name }), r2.add(e25.key.name), this.expect(14), !this.match(131))
                throw this.raise(u2.ModuleAttributeInvalidValue, { at: this.state.startLoc });
              e25.value = this.parseStringLiteral(this.state.value), this.finishNode(e25, "ImportAttribute"), t2.push(e25);
            } while (this.eat(12));
            return t2;
          }
          maybeParseImportAssertions() {
            if (this.isContextual(94) && !this.hasPrecedingLineBreak())
              this.expectPlugin("importAssertions"), this.next();
            else
              return this.hasPlugin("importAssertions") ? [] : null;
            this.eat(5);
            let t2 = this.parseAssertEntries();
            return this.eat(8), t2;
          }
          maybeParseDefaultImportSpecifier(t2) {
            return this.shouldParseDefaultImport(t2) ? (this.parseImportSpecifierLocal(t2, this.startNode(), "ImportDefaultSpecifier"), true) : false;
          }
          maybeParseStarImportSpecifier(t2) {
            if (this.match(55)) {
              let r2 = this.startNode();
              return this.next(), this.expectContextual(93), this.parseImportSpecifierLocal(t2, r2, "ImportNamespaceSpecifier"), true;
            }
            return false;
          }
          parseNamedImportSpecifiers(t2) {
            let r2 = true;
            for (this.expect(5); !this.eat(8); ) {
              if (r2)
                r2 = false;
              else {
                if (this.eat(14))
                  throw this.raise(u2.DestructureNamedImport, { at: this.state.startLoc });
                if (this.expect(12), this.eat(8))
                  break;
              }
              let e25 = this.startNode(), s2 = this.match(131), i2 = this.isContextual(128);
              e25.imported = this.parseModuleExportName();
              let a2 = this.parseImportSpecifier(e25, s2, t2.importKind === "type" || t2.importKind === "typeof", i2, void 0);
              t2.specifiers.push(a2);
            }
          }
          parseImportSpecifier(t2, r2, e25, s2, i2) {
            if (this.eatContextual(93))
              t2.local = this.parseIdentifier();
            else {
              let { imported: a2 } = t2;
              if (r2)
                throw this.raise(u2.ImportBindingIsString, { at: t2, importName: a2.value });
              this.checkReservedWord(a2.name, t2.loc.start, true, true), t2.local || (t2.local = Te2(a2));
            }
            return this.finishImportSpecifier(t2, "ImportSpecifier", i2);
          }
          isThisParam(t2) {
            return t2.type === "Identifier" && t2.name === "this";
          }
        }, ai2 = class extends Th2 {
          constructor(t2, r2) {
            t2 = dh2(t2), super(t2, r2), this.options = t2, this.initializeScopes(), this.plugins = vh2(this.options.plugins), this.filename = t2.sourceFilename;
          }
          getScopeHandler() {
            return cs;
          }
          parse() {
            this.enterInitialScopes();
            let t2 = this.startNode(), r2 = this.startNode();
            return this.nextToken(), t2.errors = null, this.parseTopLevel(t2, r2), t2.errors = this.state.errors, t2;
          }
        };
        function vh2(t2) {
          let r2 = new Map();
          for (let e25 of t2) {
            let [s2, i2] = Array.isArray(e25) ? e25 : [e25, {}];
            r2.has(s2) || r2.set(s2, i2 || {});
          }
          return r2;
        }
        function Eh2(t2, r2) {
          var e25;
          if (((e25 = r2) == null ? void 0 : e25.sourceType) === "unambiguous") {
            r2 = Object.assign({}, r2);
            try {
              r2.sourceType = "module";
              let s2 = st2(r2, t2), i2 = s2.parse();
              if (s2.sawUnambiguousESM)
                return i2;
              if (s2.ambiguousScriptDifferentAst)
                try {
                  return r2.sourceType = "script", st2(r2, t2).parse();
                } catch {
                }
              else
                i2.program.sourceType = "script";
              return i2;
            } catch (s2) {
              try {
                return r2.sourceType = "script", st2(r2, t2).parse();
              } catch {
              }
              throw s2;
            }
          } else
            return st2(r2, t2).parse();
        }
        function Ch2(t2, r2) {
          let e25 = st2(r2, t2);
          return e25.options.strictMode && (e25.state.strict = true), e25.getExpression();
        }
        function bh2(t2) {
          let r2 = {};
          for (let e25 of Object.keys(t2))
            r2[e25] = xe2(t2[e25]);
          return r2;
        }
        var Sh2 = bh2(Vo2);
        function st2(t2, r2) {
          let e25 = ai2;
          return t2 != null && t2.plugins && (ph2(t2.plugins), e25 = wh2(t2.plugins)), new e25(t2, r2);
        }
        var ni2 = {};
        function wh2(t2) {
          let r2 = fh2.filter((i2) => te2(t2, i2)), e25 = r2.join("/"), s2 = ni2[e25];
          if (!s2) {
            s2 = ai2;
            for (let i2 of r2)
              s2 = si2[i2](s2);
            ni2[e25] = s2;
          }
          return s2;
        }
        l2.parse = Eh2, l2.parseExpression = Ch2, l2.tokTypes = Sh2;
      } }), Gf2 = K2({ "src/language-js/parse/json.js"(l2, h2) {
        V2();
        var f2 = mr2(), d2 = yr2(), y2 = _o2(), P2 = Ro2();
        function g2() {
          let C2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { allowComments: L2 = true } = C2;
          return function(k2) {
            let { parseExpression: H2 } = Uo2(), W2;
            try {
              W2 = H2(k2, { tokens: true, ranges: true });
            } catch (B2) {
              throw P2(B2);
            }
            if (!L2 && f2(W2.comments))
              throw T2(W2.comments[0], "Comment");
            return S2(W2), W2;
          };
        }
        function T2(C2, L2) {
          let [j2, k2] = [C2.loc.start, C2.loc.end].map((H2) => {
            let { line: W2, column: B2 } = H2;
            return { line: W2, column: B2 + 1 };
          });
          return d2(`${L2} is not allowed in JSON.`, { start: j2, end: k2 });
        }
        function S2(C2) {
          switch (C2.type) {
            case "ArrayExpression":
              for (let L2 of C2.elements)
                L2 !== null && S2(L2);
              return;
            case "ObjectExpression":
              for (let L2 of C2.properties)
                S2(L2);
              return;
            case "ObjectProperty":
              if (C2.computed)
                throw T2(C2.key, "Computed key");
              if (C2.shorthand)
                throw T2(C2.key, "Shorthand property");
              C2.key.type !== "Identifier" && S2(C2.key), S2(C2.value);
              return;
            case "UnaryExpression": {
              let { operator: L2, argument: j2 } = C2;
              if (L2 !== "+" && L2 !== "-")
                throw T2(C2, `Operator '${C2.operator}'`);
              if (j2.type === "NumericLiteral" || j2.type === "Identifier" && (j2.name === "Infinity" || j2.name === "NaN"))
                return;
              throw T2(j2, `Operator '${L2}' before '${j2.type}'`);
            }
            case "Identifier":
              if (C2.name !== "Infinity" && C2.name !== "NaN" && C2.name !== "undefined")
                throw T2(C2, `Identifier '${C2.name}'`);
              return;
            case "TemplateLiteral":
              if (f2(C2.expressions))
                throw T2(C2.expressions[0], "'TemplateLiteral' with expression");
              for (let L2 of C2.quasis)
                S2(L2);
              return;
            case "NullLiteral":
            case "BooleanLiteral":
            case "NumericLiteral":
            case "StringLiteral":
            case "TemplateElement":
              return;
            default:
              throw T2(C2, `'${C2.type}'`);
          }
        }
        var F2 = g2(), I2 = { json: y2({ parse: F2, hasPragma() {
          return true;
        } }), json5: y2(F2), "json-stringify": y2({ parse: g2({ allowComments: false }), astFormat: "estree-json" }) };
        h2.exports = I2;
      } });
      V2();
      var Jf2 = Nf2(), Xf2 = To2(), Yf2 = Lf2(), We2 = _o2(), Qf2 = Ro2(), Zf2 = Wf2(), ed2 = Gf2(), td2 = { sourceType: "module", allowImportExportEverywhere: true, allowReturnOutsideFunction: true, allowSuperOutsideMethod: true, allowUndeclaredExports: true, errorRecovery: true, createParenthesizedExpressions: true, plugins: ["doExpressions", "exportDefaultFrom", "functionBind", "functionSent", "throwExpressions", "partialApplication", ["decorators", { decoratorsBeforeExport: false }], "importAssertions", "decimal", "moduleBlocks", "asyncDoExpressions", "regexpUnicodeSets", "destructuringPrivate", "decoratorAutoAccessors"], tokens: true, ranges: true }, sd2 = ["recordAndTuple", { syntaxType: "hash" }], mo2 = "v8intrinsic", yo2 = [["pipelineOperator", { proposal: "hack", topicToken: "%" }], ["pipelineOperator", { proposal: "minimal" }], ["pipelineOperator", { proposal: "fsharp" }]], de2 = function(l2) {
        let h2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : td2;
        return Object.assign(Object.assign({}, h2), {}, { plugins: [...h2.plugins, ...l2] });
      }, rd2 = /@(?:no)?flow\b/;
      function id2(l2, h2) {
        if (h2.filepath && h2.filepath.endsWith(".js.flow"))
          return true;
        let f2 = Xf2(l2);
        f2 && (l2 = l2.slice(f2.length));
        let d2 = Yf2(l2, 0);
        return d2 !== false && (l2 = l2.slice(0, d2)), rd2.test(l2);
      }
      function ad2(l2, h2, f2) {
        let d2 = Uo2()[l2], y2 = d2(h2, f2), P2 = y2.errors.find((g2) => !cd2.has(g2.reasonCode));
        if (P2)
          throw P2;
        return y2;
      }
      function Ge2(l2) {
        for (var h2 = arguments.length, f2 = new Array(h2 > 1 ? h2 - 1 : 0), d2 = 1; d2 < h2; d2++)
          f2[d2 - 1] = arguments[d2];
        return function(y2, P2) {
          let g2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          if ((g2.parser === "babel" || g2.parser === "__babel_estree") && id2(y2, g2))
            return g2.parser = "babel-flow", $o2(y2, P2, g2);
          let T2 = f2;
          g2.__babelSourceType === "script" && (T2 = T2.map((C2) => Object.assign(Object.assign({}, C2), {}, { sourceType: "script" }))), /#[[{]/.test(y2) && (T2 = T2.map((C2) => de2([sd2], C2)));
          let S2 = /%[A-Z]/.test(y2);
          y2.includes("|>") ? T2 = (S2 ? [...yo2, mo2] : yo2).flatMap((L2) => T2.map((j2) => de2([L2], j2))) : S2 && (T2 = T2.map((C2) => de2([mo2], C2)));
          let { result: F2, error: I2 } = Jf2(...T2.map((C2) => () => ad2(l2, y2, C2)));
          if (!F2)
            throw Qf2(I2);
          return g2.originalText = y2, Zf2(F2, g2);
        };
      }
      var nd2 = Ge2("parse", de2(["jsx", "flow"])), $o2 = Ge2("parse", de2(["jsx", ["flow", { all: true, enums: true }]])), od2 = Ge2("parse", de2(["jsx", "typescript"]), de2(["typescript"])), ld2 = Ge2("parse", de2(["jsx", "flow", "estree"])), hd2 = Ge2("parseExpression", de2(["jsx"])), ud2 = Ge2("parseExpression", de2(["typescript"])), cd2 = new Set(["StrictNumericEscape", "StrictWith", "StrictOctalLiteral", "StrictDelete", "StrictEvalArguments", "StrictEvalArgumentsBinding", "StrictFunction", "EmptyTypeArguments", "EmptyTypeParameters", "ConstructorHasTypeParameters", "UnsupportedParameterPropertyKind", "UnexpectedParameterModifier", "MixedLabeledAndUnlabeledElements", "InvalidTupleMemberLabel", "NonClassMethodPropertyHasAbstractModifer", "ReadonlyForMethodSignature", "ClassMethodHasDeclare", "ClassMethodHasReadonly", "InvalidModifierOnTypeMember", "DuplicateAccessibilityModifier", "IndexSignatureHasDeclare", "DecoratorExportClass", "ParamDupe", "InvalidDecimal", "RestTrailingComma", "UnsupportedParameterDecorator", "UnterminatedJsxContent", "UnexpectedReservedWord", "ModuleAttributesWithDuplicateKeys", "LineTerminatorBeforeArrow", "InvalidEscapeSequenceTemplate", "NonAbstractClassHasAbstractMethod", "UnsupportedPropertyDecorator", "OptionalTypeBeforeRequired", "PatternIsOptional", "OptionalBindingPattern", "DeclareClassFieldHasInitializer", "TypeImportCannotSpecifyDefaultAndNamed", "DeclareFunctionHasImplementation", "ConstructorClassField", "VarRedeclaration", "InvalidPrivateFieldResolution", "DuplicateExport"]), xo2 = We2(nd2), go2 = We2(od2), Po2 = We2(hd2), pd2 = We2(ud2);
      Ho2.exports = { parsers: Object.assign(Object.assign({ babel: xo2, "babel-flow": We2($o2), "babel-ts": go2 }, ed2), {}, { __js_expression: Po2, __vue_expression: Po2, __vue_ts_expression: pd2, __vue_event_binding: xo2, __vue_ts_event_binding: go2, __babel_estree: We2(ld2) }) };
    });
    return fd2();
  });
})(parserBabel$1);
var parserBabel = /* @__PURE__ */ getDefaultExportFromCjs(parserBabel$1.exports);
var parserHtml$1 = { exports: {} };
(function(module2, exports2) {
  (function(e25) {
    module2.exports = e25();
  })(function() {
    var S2 = (e25, r2) => () => (r2 || e25((r2 = { exports: {} }).exports, r2), r2.exports);
    var ee2 = S2((cc2, Kr2) => {
      var Ne2 = function(e25) {
        return e25 && e25.Math == Math && e25;
      };
      Kr2.exports = Ne2(typeof globalThis == "object" && globalThis) || Ne2(typeof window == "object" && window) || Ne2(typeof self == "object" && self) || Ne2(typeof commonjsGlobal == "object" && commonjsGlobal) || function() {
        return this;
      }() || Function("return this")();
    });
    var se2 = S2((hc2, Jr2) => {
      Jr2.exports = function(e25) {
        try {
          return !!e25();
        } catch {
          return true;
        }
      };
    });
    var ae2 = S2((pc2, Zr2) => {
      var qs2 = se2();
      Zr2.exports = !qs2(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    });
    var Oe2 = S2((fc2, eu2) => {
      var Is2 = se2();
      eu2.exports = !Is2(function() {
        var e25 = function() {
        }.bind();
        return typeof e25 != "function" || e25.hasOwnProperty("prototype");
      });
    });
    var De2 = S2((dc2, ru2) => {
      var Rs2 = Oe2(), qe2 = Function.prototype.call;
      ru2.exports = Rs2 ? qe2.bind(qe2) : function() {
        return qe2.apply(qe2, arguments);
      };
    });
    var su2 = S2((nu2) => {
      var uu2 = {}.propertyIsEnumerable, tu2 = Object.getOwnPropertyDescriptor, xs = tu2 && !uu2.call({ 1: 2 }, 1);
      nu2.f = xs ? function(r2) {
        var u2 = tu2(this, r2);
        return !!u2 && u2.enumerable;
      } : uu2;
    });
    var Ie2 = S2((Cc2, iu2) => {
      iu2.exports = function(e25, r2) {
        return { enumerable: !(e25 & 1), configurable: !(e25 & 2), writable: !(e25 & 4), value: r2 };
      };
    });
    var re2 = S2((mc2, Du2) => {
      var au2 = Oe2(), ou2 = Function.prototype, er2 = ou2.call, Ps2 = au2 && ou2.bind.bind(er2, er2);
      Du2.exports = au2 ? Ps2 : function(e25) {
        return function() {
          return er2.apply(e25, arguments);
        };
      };
    });
    var me2 = S2((gc2, cu2) => {
      var lu2 = re2(), ks2 = lu2({}.toString), Ls2 = lu2("".slice);
      cu2.exports = function(e25) {
        return Ls2(ks2(e25), 8, -1);
      };
    });
    var pu2 = S2((Fc2, hu2) => {
      var $s2 = re2(), Ms2 = se2(), js2 = me2(), rr2 = Object, Us2 = $s2("".split);
      hu2.exports = Ms2(function() {
        return !rr2("z").propertyIsEnumerable(0);
      }) ? function(e25) {
        return js2(e25) == "String" ? Us2(e25, "") : rr2(e25);
      } : rr2;
    });
    var Re2 = S2((Ac2, fu2) => {
      fu2.exports = function(e25) {
        return e25 == null;
      };
    });
    var ur2 = S2((vc2, du2) => {
      var Gs2 = Re2(), Vs2 = TypeError;
      du2.exports = function(e25) {
        if (Gs2(e25))
          throw Vs2("Can't call method on " + e25);
        return e25;
      };
    });
    var xe2 = S2((_c2, Eu2) => {
      var Xs2 = pu2(), Hs2 = ur2();
      Eu2.exports = function(e25) {
        return Xs2(Hs2(e25));
      };
    });
    var nr2 = S2((Sc2, Cu2) => {
      var tr2 = typeof document == "object" && document.all, zs2 = typeof tr2 > "u" && tr2 !== void 0;
      Cu2.exports = { all: tr2, IS_HTMLDDA: zs2 };
    });
    var Y2 = S2((yc2, gu2) => {
      var mu2 = nr2(), Ws2 = mu2.all;
      gu2.exports = mu2.IS_HTMLDDA ? function(e25) {
        return typeof e25 == "function" || e25 === Ws2;
      } : function(e25) {
        return typeof e25 == "function";
      };
    });
    var le2 = S2((Tc2, vu2) => {
      var Fu2 = Y2(), Au2 = nr2(), Ys2 = Au2.all;
      vu2.exports = Au2.IS_HTMLDDA ? function(e25) {
        return typeof e25 == "object" ? e25 !== null : Fu2(e25) || e25 === Ys2;
      } : function(e25) {
        return typeof e25 == "object" ? e25 !== null : Fu2(e25);
      };
    });
    var ge2 = S2((Bc2, _u2) => {
      var sr2 = ee2(), Qs2 = Y2(), Ks2 = function(e25) {
        return Qs2(e25) ? e25 : void 0;
      };
      _u2.exports = function(e25, r2) {
        return arguments.length < 2 ? Ks2(sr2[e25]) : sr2[e25] && sr2[e25][r2];
      };
    });
    var ir2 = S2((bc2, Su2) => {
      var Js2 = re2();
      Su2.exports = Js2({}.isPrototypeOf);
    });
    var Tu2 = S2((wc2, yu2) => {
      var Zs2 = ge2();
      yu2.exports = Zs2("navigator", "userAgent") || "";
    });
    var Iu2 = S2((Nc2, qu2) => {
      var Ou2 = ee2(), ar2 = Tu2(), Bu2 = Ou2.process, bu2 = Ou2.Deno, wu2 = Bu2 && Bu2.versions || bu2 && bu2.version, Nu2 = wu2 && wu2.v8, ue2, Pe2;
      Nu2 && (ue2 = Nu2.split("."), Pe2 = ue2[0] > 0 && ue2[0] < 4 ? 1 : +(ue2[0] + ue2[1]));
      !Pe2 && ar2 && (ue2 = ar2.match(/Edge\/(\d+)/), (!ue2 || ue2[1] >= 74) && (ue2 = ar2.match(/Chrome\/(\d+)/), ue2 && (Pe2 = +ue2[1])));
      qu2.exports = Pe2;
    });
    var or2 = S2((Oc2, xu2) => {
      var Ru2 = Iu2(), ei2 = se2();
      xu2.exports = !!Object.getOwnPropertySymbols && !ei2(function() {
        var e25 = Symbol();
        return !String(e25) || !(Object(e25) instanceof Symbol) || !Symbol.sham && Ru2 && Ru2 < 41;
      });
    });
    var Dr2 = S2((qc2, Pu2) => {
      var ri2 = or2();
      Pu2.exports = ri2 && !Symbol.sham && typeof Symbol.iterator == "symbol";
    });
    var lr2 = S2((Ic2, ku2) => {
      var ui2 = ge2(), ti2 = Y2(), ni2 = ir2(), si2 = Dr2(), ii2 = Object;
      ku2.exports = si2 ? function(e25) {
        return typeof e25 == "symbol";
      } : function(e25) {
        var r2 = ui2("Symbol");
        return ti2(r2) && ni2(r2.prototype, ii2(e25));
      };
    });
    var ke2 = S2((Rc2, Lu2) => {
      var ai2 = String;
      Lu2.exports = function(e25) {
        try {
          return ai2(e25);
        } catch {
          return "Object";
        }
      };
    });
    var Fe2 = S2((xc2, $u2) => {
      var oi2 = Y2(), Di2 = ke2(), li2 = TypeError;
      $u2.exports = function(e25) {
        if (oi2(e25))
          return e25;
        throw li2(Di2(e25) + " is not a function");
      };
    });
    var Le2 = S2((Pc2, Mu2) => {
      var ci2 = Fe2(), hi2 = Re2();
      Mu2.exports = function(e25, r2) {
        var u2 = e25[r2];
        return hi2(u2) ? void 0 : ci2(u2);
      };
    });
    var Uu2 = S2((kc2, ju2) => {
      var cr2 = De2(), hr2 = Y2(), pr2 = le2(), pi2 = TypeError;
      ju2.exports = function(e25, r2) {
        var u2, n2;
        if (r2 === "string" && hr2(u2 = e25.toString) && !pr2(n2 = cr2(u2, e25)) || hr2(u2 = e25.valueOf) && !pr2(n2 = cr2(u2, e25)) || r2 !== "string" && hr2(u2 = e25.toString) && !pr2(n2 = cr2(u2, e25)))
          return n2;
        throw pi2("Can't convert object to primitive value");
      };
    });
    var Vu2 = S2((Lc2, Gu2) => {
      Gu2.exports = false;
    });
    var $e2 = S2(($c2, Hu2) => {
      var Xu2 = ee2(), fi2 = Object.defineProperty;
      Hu2.exports = function(e25, r2) {
        try {
          fi2(Xu2, e25, { value: r2, configurable: true, writable: true });
        } catch {
          Xu2[e25] = r2;
        }
        return r2;
      };
    });
    var Me2 = S2((Mc2, Wu2) => {
      var di2 = ee2(), Ei2 = $e2(), zu2 = "__core-js_shared__", Ci2 = di2[zu2] || Ei2(zu2, {});
      Wu2.exports = Ci2;
    });
    var fr2 = S2((jc2, Qu2) => {
      var mi2 = Vu2(), Yu2 = Me2();
      (Qu2.exports = function(e25, r2) {
        return Yu2[e25] || (Yu2[e25] = r2 !== void 0 ? r2 : {});
      })("versions", []).push({ version: "3.26.1", mode: mi2 ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
    });
    var dr2 = S2((Uc2, Ku2) => {
      var gi2 = ur2(), Fi2 = Object;
      Ku2.exports = function(e25) {
        return Fi2(gi2(e25));
      };
    });
    var oe2 = S2((Gc2, Ju2) => {
      var Ai2 = re2(), vi2 = dr2(), _i2 = Ai2({}.hasOwnProperty);
      Ju2.exports = Object.hasOwn || function(r2, u2) {
        return _i2(vi2(r2), u2);
      };
    });
    var Er2 = S2((Vc2, Zu2) => {
      var Si2 = re2(), yi2 = 0, Ti2 = Math.random(), Bi2 = Si2(1 .toString);
      Zu2.exports = function(e25) {
        return "Symbol(" + (e25 === void 0 ? "" : e25) + ")_" + Bi2(++yi2 + Ti2, 36);
      };
    });
    var he2 = S2((Xc2, nt2) => {
      var bi2 = ee2(), wi2 = fr2(), et2 = oe2(), Ni = Er2(), rt2 = or2(), tt2 = Dr2(), fe2 = wi2("wks"), ce2 = bi2.Symbol, ut2 = ce2 && ce2.for, Oi2 = tt2 ? ce2 : ce2 && ce2.withoutSetter || Ni;
      nt2.exports = function(e25) {
        if (!et2(fe2, e25) || !(rt2 || typeof fe2[e25] == "string")) {
          var r2 = "Symbol." + e25;
          rt2 && et2(ce2, e25) ? fe2[e25] = ce2[e25] : tt2 && ut2 ? fe2[e25] = ut2(r2) : fe2[e25] = Oi2(r2);
        }
        return fe2[e25];
      };
    });
    var ot2 = S2((Hc2, at2) => {
      var qi2 = De2(), st2 = le2(), it2 = lr2(), Ii2 = Le2(), Ri = Uu2(), xi2 = he2(), Pi2 = TypeError, ki2 = xi2("toPrimitive");
      at2.exports = function(e25, r2) {
        if (!st2(e25) || it2(e25))
          return e25;
        var u2 = Ii2(e25, ki2), n2;
        if (u2) {
          if (r2 === void 0 && (r2 = "default"), n2 = qi2(u2, e25, r2), !st2(n2) || it2(n2))
            return n2;
          throw Pi2("Can't convert object to primitive value");
        }
        return r2 === void 0 && (r2 = "number"), Ri(e25, r2);
      };
    });
    var je2 = S2((zc2, Dt2) => {
      var Li2 = ot2(), $i2 = lr2();
      Dt2.exports = function(e25) {
        var r2 = Li2(e25, "string");
        return $i2(r2) ? r2 : r2 + "";
      };
    });
    var ht2 = S2((Wc2, ct2) => {
      var Mi2 = ee2(), lt2 = le2(), Cr = Mi2.document, ji = lt2(Cr) && lt2(Cr.createElement);
      ct2.exports = function(e25) {
        return ji ? Cr.createElement(e25) : {};
      };
    });
    var mr2 = S2((Yc2, pt2) => {
      var Ui2 = ae2(), Gi2 = se2(), Vi2 = ht2();
      pt2.exports = !Ui2 && !Gi2(function() {
        return Object.defineProperty(Vi2("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    });
    var gr2 = S2((dt2) => {
      var Xi2 = ae2(), Hi2 = De2(), zi2 = su2(), Wi2 = Ie2(), Yi2 = xe2(), Qi2 = je2(), Ki2 = oe2(), Ji2 = mr2(), ft2 = Object.getOwnPropertyDescriptor;
      dt2.f = Xi2 ? ft2 : function(r2, u2) {
        if (r2 = Yi2(r2), u2 = Qi2(u2), Ji2)
          try {
            return ft2(r2, u2);
          } catch {
          }
        if (Ki2(r2, u2))
          return Wi2(!Hi2(zi2.f, r2, u2), r2[u2]);
      };
    });
    var Ct2 = S2((Kc2, Et) => {
      var Zi2 = ae2(), ea2 = se2();
      Et.exports = Zi2 && ea2(function() {
        return Object.defineProperty(function() {
        }, "prototype", { value: 42, writable: false }).prototype != 42;
      });
    });
    var de2 = S2((Jc2, mt2) => {
      var ra2 = le2(), ua2 = String, ta2 = TypeError;
      mt2.exports = function(e25) {
        if (ra2(e25))
          return e25;
        throw ta2(ua2(e25) + " is not an object");
      };
    });
    var Ae2 = S2((Ft2) => {
      var na2 = ae2(), sa2 = mr2(), ia2 = Ct2(), Ue2 = de2(), gt2 = je2(), aa2 = TypeError, Fr2 = Object.defineProperty, oa2 = Object.getOwnPropertyDescriptor, Ar2 = "enumerable", vr2 = "configurable", _r2 = "writable";
      Ft2.f = na2 ? ia2 ? function(r2, u2, n2) {
        if (Ue2(r2), u2 = gt2(u2), Ue2(n2), typeof r2 == "function" && u2 === "prototype" && "value" in n2 && _r2 in n2 && !n2[_r2]) {
          var D2 = oa2(r2, u2);
          D2 && D2[_r2] && (r2[u2] = n2.value, n2 = { configurable: vr2 in n2 ? n2[vr2] : D2[vr2], enumerable: Ar2 in n2 ? n2[Ar2] : D2[Ar2], writable: false });
        }
        return Fr2(r2, u2, n2);
      } : Fr2 : function(r2, u2, n2) {
        if (Ue2(r2), u2 = gt2(u2), Ue2(n2), sa2)
          try {
            return Fr2(r2, u2, n2);
          } catch {
          }
        if ("get" in n2 || "set" in n2)
          throw aa2("Accessors not supported");
        return "value" in n2 && (r2[u2] = n2.value), r2;
      };
    });
    var Sr = S2((e25, At2) => {
      var Da2 = ae2(), la2 = Ae2(), ca2 = Ie2();
      At2.exports = Da2 ? function(e26, r2, u2) {
        return la2.f(e26, r2, ca2(1, u2));
      } : function(e26, r2, u2) {
        return e26[r2] = u2, e26;
      };
    });
    var St2 = S2((r2, _t2) => {
      var yr2 = ae2(), ha2 = oe2(), vt = Function.prototype, pa2 = yr2 && Object.getOwnPropertyDescriptor, Tr2 = ha2(vt, "name"), fa2 = Tr2 && function() {
      }.name === "something", da2 = Tr2 && (!yr2 || yr2 && pa2(vt, "name").configurable);
      _t2.exports = { EXISTS: Tr2, PROPER: fa2, CONFIGURABLE: da2 };
    });
    var br2 = S2((u2, yt2) => {
      var Ea2 = re2(), Ca2 = Y2(), Br2 = Me2(), ma2 = Ea2(Function.toString);
      Ca2(Br2.inspectSource) || (Br2.inspectSource = function(e25) {
        return ma2(e25);
      });
      yt2.exports = Br2.inspectSource;
    });
    var bt = S2((t2, Bt2) => {
      var ga2 = ee2(), Fa2 = Y2(), Tt2 = ga2.WeakMap;
      Bt2.exports = Fa2(Tt2) && /native code/.test(String(Tt2));
    });
    var Ot2 = S2((n2, Nt2) => {
      var Aa2 = fr2(), va2 = Er2(), wt2 = Aa2("keys");
      Nt2.exports = function(e25) {
        return wt2[e25] || (wt2[e25] = va2(e25));
      };
    });
    var wr2 = S2((s2, qt2) => {
      qt2.exports = {};
    });
    var Pt2 = S2((i2, xt) => {
      var _a2 = bt(), Rt2 = ee2(), Sa2 = le2(), ya2 = Sr(), Nr2 = oe2(), Or2 = Me2(), Ta2 = Ot2(), Ba2 = wr2(), It2 = "Object already initialized", qr2 = Rt2.TypeError, ba2 = Rt2.WeakMap, Ge2, ve2, Ve2, wa2 = function(e25) {
        return Ve2(e25) ? ve2(e25) : Ge2(e25, {});
      }, Na2 = function(e25) {
        return function(r2) {
          var u2;
          if (!Sa2(r2) || (u2 = ve2(r2)).type !== e25)
            throw qr2("Incompatible receiver, " + e25 + " required");
          return u2;
        };
      };
      _a2 || Or2.state ? (te2 = Or2.state || (Or2.state = new ba2()), te2.get = te2.get, te2.has = te2.has, te2.set = te2.set, Ge2 = function(e25, r2) {
        if (te2.has(e25))
          throw qr2(It2);
        return r2.facade = e25, te2.set(e25, r2), r2;
      }, ve2 = function(e25) {
        return te2.get(e25) || {};
      }, Ve2 = function(e25) {
        return te2.has(e25);
      }) : (pe2 = Ta2("state"), Ba2[pe2] = true, Ge2 = function(e25, r2) {
        if (Nr2(e25, pe2))
          throw qr2(It2);
        return r2.facade = e25, ya2(e25, pe2, r2), r2;
      }, ve2 = function(e25) {
        return Nr2(e25, pe2) ? e25[pe2] : {};
      }, Ve2 = function(e25) {
        return Nr2(e25, pe2);
      });
      var te2, pe2;
      xt.exports = { set: Ge2, get: ve2, has: Ve2, enforce: wa2, getterFor: Na2 };
    });
    var $t2 = S2((a2, Lt2) => {
      var Oa2 = se2(), qa2 = Y2(), Xe2 = oe2(), Ir2 = ae2(), Ia2 = St2().CONFIGURABLE, Ra2 = br2(), kt2 = Pt2(), xa2 = kt2.enforce, Pa2 = kt2.get, He2 = Object.defineProperty, ka2 = Ir2 && !Oa2(function() {
        return He2(function() {
        }, "length", { value: 8 }).length !== 8;
      }), La2 = String(String).split("String"), $a2 = Lt2.exports = function(e25, r2, u2) {
        String(r2).slice(0, 7) === "Symbol(" && (r2 = "[" + String(r2).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), u2 && u2.getter && (r2 = "get " + r2), u2 && u2.setter && (r2 = "set " + r2), (!Xe2(e25, "name") || Ia2 && e25.name !== r2) && (Ir2 ? He2(e25, "name", { value: r2, configurable: true }) : e25.name = r2), ka2 && u2 && Xe2(u2, "arity") && e25.length !== u2.arity && He2(e25, "length", { value: u2.arity });
        try {
          u2 && Xe2(u2, "constructor") && u2.constructor ? Ir2 && He2(e25, "prototype", { writable: false }) : e25.prototype && (e25.prototype = void 0);
        } catch {
        }
        var n2 = xa2(e25);
        return Xe2(n2, "source") || (n2.source = La2.join(typeof r2 == "string" ? r2 : "")), e25;
      };
      Function.prototype.toString = $a2(function() {
        return qa2(this) && Pa2(this).source || Ra2(this);
      }, "toString");
    });
    var jt2 = S2((o2, Mt2) => {
      var Ma2 = Y2(), ja2 = Ae2(), Ua2 = $t2(), Ga2 = $e2();
      Mt2.exports = function(e25, r2, u2, n2) {
        n2 || (n2 = {});
        var D2 = n2.enumerable, s2 = n2.name !== void 0 ? n2.name : r2;
        if (Ma2(u2) && Ua2(u2, s2, n2), n2.global)
          D2 ? e25[r2] = u2 : Ga2(r2, u2);
        else {
          try {
            n2.unsafe ? e25[r2] && (D2 = true) : delete e25[r2];
          } catch {
          }
          D2 ? e25[r2] = u2 : ja2.f(e25, r2, { value: u2, enumerable: false, configurable: !n2.nonConfigurable, writable: !n2.nonWritable });
        }
        return e25;
      };
    });
    var Gt2 = S2((D2, Ut2) => {
      var Va2 = Math.ceil, Xa2 = Math.floor;
      Ut2.exports = Math.trunc || function(r2) {
        var u2 = +r2;
        return (u2 > 0 ? Xa2 : Va2)(u2);
      };
    });
    var Rr2 = S2((l2, Vt2) => {
      var Ha2 = Gt2();
      Vt2.exports = function(e25) {
        var r2 = +e25;
        return r2 !== r2 || r2 === 0 ? 0 : Ha2(r2);
      };
    });
    var Ht2 = S2((c2, Xt2) => {
      var za2 = Rr2(), Wa2 = Math.max, Ya2 = Math.min;
      Xt2.exports = function(e25, r2) {
        var u2 = za2(e25);
        return u2 < 0 ? Wa2(u2 + r2, 0) : Ya2(u2, r2);
      };
    });
    var Wt2 = S2((h2, zt2) => {
      var Qa2 = Rr2(), Ka2 = Math.min;
      zt2.exports = function(e25) {
        return e25 > 0 ? Ka2(Qa2(e25), 9007199254740991) : 0;
      };
    });
    var _e2 = S2((p2, Yt2) => {
      var Ja2 = Wt2();
      Yt2.exports = function(e25) {
        return Ja2(e25.length);
      };
    });
    var Jt2 = S2((f2, Kt2) => {
      var Za2 = xe2(), eo2 = Ht2(), ro2 = _e2(), Qt2 = function(e25) {
        return function(r2, u2, n2) {
          var D2 = Za2(r2), s2 = ro2(D2), i2 = eo2(n2, s2), f3;
          if (e25 && u2 != u2) {
            for (; s2 > i2; )
              if (f3 = D2[i2++], f3 != f3)
                return true;
          } else
            for (; s2 > i2; i2++)
              if ((e25 || i2 in D2) && D2[i2] === u2)
                return e25 || i2 || 0;
          return !e25 && -1;
        };
      };
      Kt2.exports = { includes: Qt2(true), indexOf: Qt2(false) };
    });
    var rn2 = S2((d2, en2) => {
      var uo2 = re2(), xr2 = oe2(), to2 = xe2(), no2 = Jt2().indexOf, so2 = wr2(), Zt2 = uo2([].push);
      en2.exports = function(e25, r2) {
        var u2 = to2(e25), n2 = 0, D2 = [], s2;
        for (s2 in u2)
          !xr2(so2, s2) && xr2(u2, s2) && Zt2(D2, s2);
        for (; r2.length > n2; )
          xr2(u2, s2 = r2[n2++]) && (~no2(D2, s2) || Zt2(D2, s2));
        return D2;
      };
    });
    var tn2 = S2((E2, un2) => {
      un2.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    });
    var sn2 = S2((nn2) => {
      var io2 = rn2(), ao2 = tn2(), oo2 = ao2.concat("length", "prototype");
      nn2.f = Object.getOwnPropertyNames || function(r2) {
        return io2(r2, oo2);
      };
    });
    var on2 = S2((an2) => {
      an2.f = Object.getOwnPropertySymbols;
    });
    var ln2 = S2((g2, Dn2) => {
      var Do = ge2(), lo2 = re2(), co2 = sn2(), ho2 = on2(), po2 = de2(), fo2 = lo2([].concat);
      Dn2.exports = Do("Reflect", "ownKeys") || function(r2) {
        var u2 = co2.f(po2(r2)), n2 = ho2.f;
        return n2 ? fo2(u2, n2(r2)) : u2;
      };
    });
    var pn2 = S2((F2, hn2) => {
      var cn2 = oe2(), Eo2 = ln2(), Co = gr2(), mo2 = Ae2();
      hn2.exports = function(e25, r2, u2) {
        for (var n2 = Eo2(r2), D2 = mo2.f, s2 = Co.f, i2 = 0; i2 < n2.length; i2++) {
          var f2 = n2[i2];
          !cn2(e25, f2) && !(u2 && cn2(u2, f2)) && D2(e25, f2, s2(r2, f2));
        }
      };
    });
    var dn2 = S2((A2, fn2) => {
      var go2 = se2(), Fo = Y2(), Ao = /#|\.prototype\./, Se2 = function(e25, r2) {
        var u2 = _o2[vo2(e25)];
        return u2 == yo2 ? true : u2 == So ? false : Fo(r2) ? go2(r2) : !!r2;
      }, vo2 = Se2.normalize = function(e25) {
        return String(e25).replace(Ao, ".").toLowerCase();
      }, _o2 = Se2.data = {}, So = Se2.NATIVE = "N", yo2 = Se2.POLYFILL = "P";
      fn2.exports = Se2;
    });
    var ze2 = S2((v2, En2) => {
      var Pr2 = ee2(), To2 = gr2().f, Bo2 = Sr(), bo2 = jt2(), wo = $e2(), No2 = pn2(), Oo2 = dn2();
      En2.exports = function(e25, r2) {
        var u2 = e25.target, n2 = e25.global, D2 = e25.stat, s2, i2, f2, c2, F2, a2;
        if (n2 ? i2 = Pr2 : D2 ? i2 = Pr2[u2] || wo(u2, {}) : i2 = (Pr2[u2] || {}).prototype, i2)
          for (f2 in r2) {
            if (F2 = r2[f2], e25.dontCallGetSet ? (a2 = To2(i2, f2), c2 = a2 && a2.value) : c2 = i2[f2], s2 = Oo2(n2 ? f2 : u2 + (D2 ? "." : "#") + f2, e25.forced), !s2 && c2 !== void 0) {
              if (typeof F2 == typeof c2)
                continue;
              No2(F2, c2);
            }
            (e25.sham || c2 && c2.sham) && Bo2(F2, "sham", true), bo2(i2, f2, F2, e25);
          }
      };
    });
    var Cn2 = S2(() => {
      var qo2 = ze2(), kr = ee2();
      qo2({ global: true, forced: kr.globalThis !== kr }, { globalThis: kr });
    });
    var mn2 = S2(() => {
      Cn2();
    });
    var Lr2 = S2((B2, gn2) => {
      var Io2 = me2();
      gn2.exports = Array.isArray || function(r2) {
        return Io2(r2) == "Array";
      };
    });
    var An2 = S2((b2, Fn2) => {
      var Ro2 = TypeError, xo2 = 9007199254740991;
      Fn2.exports = function(e25) {
        if (e25 > xo2)
          throw Ro2("Maximum allowed index exceeded");
        return e25;
      };
    });
    var _n2 = S2((w2, vn2) => {
      var Po2 = me2(), ko = re2();
      vn2.exports = function(e25) {
        if (Po2(e25) === "Function")
          return ko(e25);
      };
    });
    var $r2 = S2((N2, yn2) => {
      var Sn2 = _n2(), Lo2 = Fe2(), $o2 = Oe2(), Mo2 = Sn2(Sn2.bind);
      yn2.exports = function(e25, r2) {
        return Lo2(e25), r2 === void 0 ? e25 : $o2 ? Mo2(e25, r2) : function() {
          return e25.apply(r2, arguments);
        };
      };
    });
    var bn2 = S2((O2, Bn2) => {
      var jo2 = Lr2(), Uo2 = _e2(), Go2 = An2(), Vo2 = $r2(), Tn2 = function(e25, r2, u2, n2, D2, s2, i2, f2) {
        for (var c2 = D2, F2 = 0, a2 = i2 ? Vo2(i2, f2) : false, l2, h2; F2 < n2; )
          F2 in u2 && (l2 = a2 ? a2(u2[F2], F2, r2) : u2[F2], s2 > 0 && jo2(l2) ? (h2 = Uo2(l2), c2 = Tn2(e25, r2, l2, h2, c2, s2 - 1) - 1) : (Go2(c2 + 1), e25[c2] = l2), c2++), F2++;
        return c2;
      };
      Bn2.exports = Tn2;
    });
    var On2 = S2((q2, Nn2) => {
      var Xo2 = he2(), Ho2 = Xo2("toStringTag"), wn2 = {};
      wn2[Ho2] = "z";
      Nn2.exports = String(wn2) === "[object z]";
    });
    var Mr2 = S2((I2, qn2) => {
      var zo2 = On2(), Wo2 = Y2(), We2 = me2(), Yo2 = he2(), Qo2 = Yo2("toStringTag"), Ko2 = Object, Jo2 = We2(function() {
        return arguments;
      }()) == "Arguments", Zo2 = function(e25, r2) {
        try {
          return e25[r2];
        } catch {
        }
      };
      qn2.exports = zo2 ? We2 : function(e25) {
        var r2, u2, n2;
        return e25 === void 0 ? "Undefined" : e25 === null ? "Null" : typeof (u2 = Zo2(r2 = Ko2(e25), Qo2)) == "string" ? u2 : Jo2 ? We2(r2) : (n2 = We2(r2)) == "Object" && Wo2(r2.callee) ? "Arguments" : n2;
      };
    });
    var Ln2 = S2((R2, kn2) => {
      var eD2 = re2(), rD2 = se2(), In2 = Y2(), uD2 = Mr2(), tD2 = ge2(), nD2 = br2(), Rn2 = function() {
      }, sD2 = [], xn2 = tD2("Reflect", "construct"), jr2 = /^\s*(?:class|function)\b/, iD2 = eD2(jr2.exec), aD2 = !jr2.exec(Rn2), ye2 = function(r2) {
        if (!In2(r2))
          return false;
        try {
          return xn2(Rn2, sD2, r2), true;
        } catch {
          return false;
        }
      }, Pn2 = function(r2) {
        if (!In2(r2))
          return false;
        switch (uD2(r2)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return false;
        }
        try {
          return aD2 || !!iD2(jr2, nD2(r2));
        } catch {
          return true;
        }
      };
      Pn2.sham = true;
      kn2.exports = !xn2 || rD2(function() {
        var e25;
        return ye2(ye2.call) || !ye2(Object) || !ye2(function() {
          e25 = true;
        }) || e25;
      }) ? Pn2 : ye2;
    });
    var Un2 = S2((x2, jn2) => {
      var $n2 = Lr2(), oD2 = Ln2(), DD2 = le2(), lD2 = he2(), cD2 = lD2("species"), Mn2 = Array;
      jn2.exports = function(e25) {
        var r2;
        return $n2(e25) && (r2 = e25.constructor, oD2(r2) && (r2 === Mn2 || $n2(r2.prototype)) ? r2 = void 0 : DD2(r2) && (r2 = r2[cD2], r2 === null && (r2 = void 0))), r2 === void 0 ? Mn2 : r2;
      };
    });
    var Vn2 = S2((P2, Gn2) => {
      var hD2 = Un2();
      Gn2.exports = function(e25, r2) {
        return new (hD2(e25))(r2 === 0 ? 0 : r2);
      };
    });
    var Xn2 = S2(() => {
      var pD2 = ze2(), fD2 = bn2(), dD2 = Fe2(), ED2 = dr2(), CD2 = _e2(), mD2 = Vn2();
      pD2({ target: "Array", proto: true }, { flatMap: function(r2) {
        var u2 = ED2(this), n2 = CD2(u2), D2;
        return dD2(r2), D2 = mD2(u2, 0), D2.length = fD2(D2, u2, u2, n2, 0, 1, r2, arguments.length > 1 ? arguments[1] : void 0), D2;
      } });
    });
    var Ur2 = S2(($2, Hn2) => {
      Hn2.exports = {};
    });
    var Wn2 = S2((M2, zn) => {
      var gD2 = he2(), FD2 = Ur2(), AD2 = gD2("iterator"), vD2 = Array.prototype;
      zn.exports = function(e25) {
        return e25 !== void 0 && (FD2.Array === e25 || vD2[AD2] === e25);
      };
    });
    var Gr2 = S2((j2, Qn2) => {
      var _D2 = Mr2(), Yn2 = Le2(), SD2 = Re2(), yD2 = Ur2(), TD2 = he2(), BD2 = TD2("iterator");
      Qn2.exports = function(e25) {
        if (!SD2(e25))
          return Yn2(e25, BD2) || Yn2(e25, "@@iterator") || yD2[_D2(e25)];
      };
    });
    var Jn2 = S2((U2, Kn2) => {
      var bD2 = De2(), wD2 = Fe2(), ND2 = de2(), OD2 = ke2(), qD2 = Gr2(), ID2 = TypeError;
      Kn2.exports = function(e25, r2) {
        var u2 = arguments.length < 2 ? qD2(e25) : r2;
        if (wD2(u2))
          return ND2(bD2(u2, e25));
        throw ID2(OD2(e25) + " is not iterable");
      };
    });
    var rs2 = S2((G2, es2) => {
      var RD2 = De2(), Zn2 = de2(), xD2 = Le2();
      es2.exports = function(e25, r2, u2) {
        var n2, D2;
        Zn2(e25);
        try {
          if (n2 = xD2(e25, "return"), !n2) {
            if (r2 === "throw")
              throw u2;
            return u2;
          }
          n2 = RD2(n2, e25);
        } catch (s2) {
          D2 = true, n2 = s2;
        }
        if (r2 === "throw")
          throw u2;
        if (D2)
          throw n2;
        return Zn2(n2), u2;
      };
    });
    var is2 = S2((V2, ss2) => {
      var PD2 = $r2(), kD2 = De2(), LD2 = de2(), $D2 = ke2(), MD2 = Wn2(), jD2 = _e2(), us2 = ir2(), UD2 = Jn2(), GD2 = Gr2(), ts2 = rs2(), VD2 = TypeError, Ye2 = function(e25, r2) {
        this.stopped = e25, this.result = r2;
      }, ns2 = Ye2.prototype;
      ss2.exports = function(e25, r2, u2) {
        var n2 = u2 && u2.that, D2 = !!(u2 && u2.AS_ENTRIES), s2 = !!(u2 && u2.IS_RECORD), i2 = !!(u2 && u2.IS_ITERATOR), f2 = !!(u2 && u2.INTERRUPTED), c2 = PD2(r2, n2), F2, a2, l2, h2, C2, d2, m2, T2 = function(g2) {
          return F2 && ts2(F2, "normal", g2), new Ye2(true, g2);
        }, w2 = function(g2) {
          return D2 ? (LD2(g2), f2 ? c2(g2[0], g2[1], T2) : c2(g2[0], g2[1])) : f2 ? c2(g2, T2) : c2(g2);
        };
        if (s2)
          F2 = e25.iterator;
        else if (i2)
          F2 = e25;
        else {
          if (a2 = GD2(e25), !a2)
            throw VD2($D2(e25) + " is not iterable");
          if (MD2(a2)) {
            for (l2 = 0, h2 = jD2(e25); h2 > l2; l2++)
              if (C2 = w2(e25[l2]), C2 && us2(ns2, C2))
                return C2;
            return new Ye2(false);
          }
          F2 = UD2(e25, a2);
        }
        for (d2 = s2 ? e25.next : F2.next; !(m2 = kD2(d2, F2)).done; ) {
          try {
            C2 = w2(m2.value);
          } catch (g2) {
            ts2(F2, "throw", g2);
          }
          if (typeof C2 == "object" && C2 && us2(ns2, C2))
            return C2;
        }
        return new Ye2(false);
      };
    });
    var os2 = S2((X2, as2) => {
      var XD2 = je2(), HD2 = Ae2(), zD2 = Ie2();
      as2.exports = function(e25, r2, u2) {
        var n2 = XD2(r2);
        n2 in e25 ? HD2.f(e25, n2, zD2(0, u2)) : e25[n2] = u2;
      };
    });
    var Ds2 = S2(() => {
      var WD2 = ze2(), YD2 = is2(), QD2 = os2();
      WD2({ target: "Object", stat: true }, { fromEntries: function(r2) {
        var u2 = {};
        return YD2(r2, function(n2, D2) {
          QD2(u2, n2, D2);
        }, { AS_ENTRIES: true }), u2;
      } });
    });
    var Dc2 = S2((W2, Os2) => {
      var KD2 = ["cliName", "cliCategory", "cliDescription"];
      function JD2(e25, r2) {
        if (e25 == null)
          return {};
        var u2 = ZD2(e25, r2), n2, D2;
        if (Object.getOwnPropertySymbols) {
          var s2 = Object.getOwnPropertySymbols(e25);
          for (D2 = 0; D2 < s2.length; D2++)
            n2 = s2[D2], !(r2.indexOf(n2) >= 0) && Object.prototype.propertyIsEnumerable.call(e25, n2) && (u2[n2] = e25[n2]);
        }
        return u2;
      }
      function ZD2(e25, r2) {
        if (e25 == null)
          return {};
        var u2 = {}, n2 = Object.keys(e25), D2, s2;
        for (s2 = 0; s2 < n2.length; s2++)
          D2 = n2[s2], !(r2.indexOf(D2) >= 0) && (u2[D2] = e25[D2]);
        return u2;
      }
      mn2();
      Xn2();
      Ds2();
      var el2 = Object.create, Je2 = Object.defineProperty, rl2 = Object.getOwnPropertyDescriptor, Xr2 = Object.getOwnPropertyNames, ul2 = Object.getPrototypeOf, tl2 = Object.prototype.hasOwnProperty, Ee2 = (e25, r2) => function() {
        return e25 && (r2 = (0, e25[Xr2(e25)[0]])(e25 = 0)), r2;
      }, I2 = (e25, r2) => function() {
        return r2 || (0, e25[Xr2(e25)[0]])((r2 = { exports: {} }).exports, r2), r2.exports;
      }, ps = (e25, r2) => {
        for (var u2 in r2)
          Je2(e25, u2, { get: r2[u2], enumerable: true });
      }, fs = (e25, r2, u2, n2) => {
        if (r2 && typeof r2 == "object" || typeof r2 == "function")
          for (let D2 of Xr2(r2))
            !tl2.call(e25, D2) && D2 !== u2 && Je2(e25, D2, { get: () => r2[D2], enumerable: !(n2 = rl2(r2, D2)) || n2.enumerable });
        return e25;
      }, nl2 = (e25, r2, u2) => (u2 = e25 != null ? el2(ul2(e25)) : {}, fs(r2 || !e25 || !e25.__esModule ? Je2(u2, "default", { value: e25, enumerable: true }) : u2, e25)), ds = (e25) => fs(Je2({}, "__esModule", { value: true }), e25), Te2, q2 = Ee2({ "<define:process>"() {
        Te2 = { env: {}, argv: [] };
      } }), Es2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/chars.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true }), e25.$EOF = 0, e25.$BSPACE = 8, e25.$TAB = 9, e25.$LF = 10, e25.$VTAB = 11, e25.$FF = 12, e25.$CR = 13, e25.$SPACE = 32, e25.$BANG = 33, e25.$DQ = 34, e25.$HASH = 35, e25.$$ = 36, e25.$PERCENT = 37, e25.$AMPERSAND = 38, e25.$SQ = 39, e25.$LPAREN = 40, e25.$RPAREN = 41, e25.$STAR = 42, e25.$PLUS = 43, e25.$COMMA = 44, e25.$MINUS = 45, e25.$PERIOD = 46, e25.$SLASH = 47, e25.$COLON = 58, e25.$SEMICOLON = 59, e25.$LT = 60, e25.$EQ = 61, e25.$GT = 62, e25.$QUESTION = 63, e25.$0 = 48, e25.$7 = 55, e25.$9 = 57, e25.$A = 65, e25.$E = 69, e25.$F = 70, e25.$X = 88, e25.$Z = 90, e25.$LBRACKET = 91, e25.$BACKSLASH = 92, e25.$RBRACKET = 93, e25.$CARET = 94, e25.$_ = 95, e25.$a = 97, e25.$b = 98, e25.$e = 101, e25.$f = 102, e25.$n = 110, e25.$r = 114, e25.$t = 116, e25.$u = 117, e25.$v = 118, e25.$x = 120, e25.$z = 122, e25.$LBRACE = 123, e25.$BAR = 124, e25.$RBRACE = 125, e25.$NBSP = 160, e25.$PIPE = 124, e25.$TILDA = 126, e25.$AT = 64, e25.$BT = 96;
        function r2(f2) {
          return f2 >= e25.$TAB && f2 <= e25.$SPACE || f2 == e25.$NBSP;
        }
        e25.isWhitespace = r2;
        function u2(f2) {
          return e25.$0 <= f2 && f2 <= e25.$9;
        }
        e25.isDigit = u2;
        function n2(f2) {
          return f2 >= e25.$a && f2 <= e25.$z || f2 >= e25.$A && f2 <= e25.$Z;
        }
        e25.isAsciiLetter = n2;
        function D2(f2) {
          return f2 >= e25.$a && f2 <= e25.$f || f2 >= e25.$A && f2 <= e25.$F || u2(f2);
        }
        e25.isAsciiHexDigit = D2;
        function s2(f2) {
          return f2 === e25.$LF || f2 === e25.$CR;
        }
        e25.isNewLine = s2;
        function i2(f2) {
          return e25.$0 <= f2 && f2 <= e25.$7;
        }
        e25.isOctalDigit = i2;
      } }), sl2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = class {
          constructor(n2, D2, s2) {
            this.filePath = n2, this.name = D2, this.members = s2;
          }
          assertNoMembers() {
            if (this.members.length)
              throw new Error(`Illegal state: symbol without members expected, but got ${JSON.stringify(this)}.`);
          }
        };
        e25.StaticSymbol = r2;
        var u2 = class {
          constructor() {
            this.cache = new Map();
          }
          get(n2, D2, s2) {
            s2 = s2 || [];
            let i2 = s2.length ? `.${s2.join(".")}` : "", f2 = `"${n2}".${D2}${i2}`, c2 = this.cache.get(f2);
            return c2 || (c2 = new r2(n2, D2, s2), this.cache.set(f2, c2)), c2;
          }
        };
        e25.StaticSymbolCache = u2;
      } }), il2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/util.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = /-+([a-z0-9])/g;
        function u2(o2) {
          return o2.replace(r2, function() {
            for (var E2 = arguments.length, p2 = new Array(E2), A2 = 0; A2 < E2; A2++)
              p2[A2] = arguments[A2];
            return p2[1].toUpperCase();
          });
        }
        e25.dashCaseToCamelCase = u2;
        function n2(o2, E2) {
          return s2(o2, ":", E2);
        }
        e25.splitAtColon = n2;
        function D2(o2, E2) {
          return s2(o2, ".", E2);
        }
        e25.splitAtPeriod = D2;
        function s2(o2, E2, p2) {
          let A2 = o2.indexOf(E2);
          return A2 == -1 ? p2 : [o2.slice(0, A2).trim(), o2.slice(A2 + 1).trim()];
        }
        function i2(o2, E2, p2) {
          return Array.isArray(o2) ? E2.visitArray(o2, p2) : g2(o2) ? E2.visitStringMap(o2, p2) : o2 == null || typeof o2 == "string" || typeof o2 == "number" || typeof o2 == "boolean" ? E2.visitPrimitive(o2, p2) : E2.visitOther(o2, p2);
        }
        e25.visitValue = i2;
        function f2(o2) {
          return o2 != null;
        }
        e25.isDefined = f2;
        function c2(o2) {
          return o2 === void 0 ? null : o2;
        }
        e25.noUndefined = c2;
        var F2 = class {
          visitArray(o2, E2) {
            return o2.map((p2) => i2(p2, this, E2));
          }
          visitStringMap(o2, E2) {
            let p2 = {};
            return Object.keys(o2).forEach((A2) => {
              p2[A2] = i2(o2[A2], this, E2);
            }), p2;
          }
          visitPrimitive(o2, E2) {
            return o2;
          }
          visitOther(o2, E2) {
            return o2;
          }
        };
        e25.ValueTransformer = F2, e25.SyncAsync = { assertSync: (o2) => {
          if (_2(o2))
            throw new Error("Illegal state: value cannot be a promise");
          return o2;
        }, then: (o2, E2) => _2(o2) ? o2.then(E2) : E2(o2), all: (o2) => o2.some(_2) ? Promise.all(o2) : o2 };
        function a2(o2) {
          throw new Error(`Internal Error: ${o2}`);
        }
        e25.error = a2;
        function l2(o2, E2) {
          let p2 = Error(o2);
          return p2[h2] = true, E2 && (p2[C2] = E2), p2;
        }
        e25.syntaxError = l2;
        var h2 = "ngSyntaxError", C2 = "ngParseErrors";
        function d2(o2) {
          return o2[h2];
        }
        e25.isSyntaxError = d2;
        function m2(o2) {
          return o2[C2] || [];
        }
        e25.getParseErrors = m2;
        function T2(o2) {
          return o2.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
        }
        e25.escapeRegExp = T2;
        var w2 = Object.getPrototypeOf({});
        function g2(o2) {
          return typeof o2 == "object" && o2 !== null && Object.getPrototypeOf(o2) === w2;
        }
        function N2(o2) {
          let E2 = "";
          for (let p2 = 0; p2 < o2.length; p2++) {
            let A2 = o2.charCodeAt(p2);
            if (A2 >= 55296 && A2 <= 56319 && o2.length > p2 + 1) {
              let P2 = o2.charCodeAt(p2 + 1);
              P2 >= 56320 && P2 <= 57343 && (p2++, A2 = (A2 - 55296 << 10) + P2 - 56320 + 65536);
            }
            A2 <= 127 ? E2 += String.fromCharCode(A2) : A2 <= 2047 ? E2 += String.fromCharCode(A2 >> 6 & 31 | 192, A2 & 63 | 128) : A2 <= 65535 ? E2 += String.fromCharCode(A2 >> 12 | 224, A2 >> 6 & 63 | 128, A2 & 63 | 128) : A2 <= 2097151 && (E2 += String.fromCharCode(A2 >> 18 & 7 | 240, A2 >> 12 & 63 | 128, A2 >> 6 & 63 | 128, A2 & 63 | 128));
          }
          return E2;
        }
        e25.utf8Encode = N2;
        function R2(o2) {
          if (typeof o2 == "string")
            return o2;
          if (o2 instanceof Array)
            return "[" + o2.map(R2).join(", ") + "]";
          if (o2 == null)
            return "" + o2;
          if (o2.overriddenName)
            return `${o2.overriddenName}`;
          if (o2.name)
            return `${o2.name}`;
          if (!o2.toString)
            return "object";
          let E2 = o2.toString();
          if (E2 == null)
            return "" + E2;
          let p2 = E2.indexOf(`
`);
          return p2 === -1 ? E2 : E2.substring(0, p2);
        }
        e25.stringify = R2;
        function j2(o2) {
          return typeof o2 == "function" && o2.hasOwnProperty("__forward_ref__") ? o2() : o2;
        }
        e25.resolveForwardRef = j2;
        function _2(o2) {
          return !!o2 && typeof o2.then == "function";
        }
        e25.isPromise = _2;
        var O2 = class {
          constructor(o2) {
            this.full = o2;
            let E2 = o2.split(".");
            this.major = E2[0], this.minor = E2[1], this.patch = E2.slice(2).join(".");
          }
        };
        e25.Version = O2;
        var x2 = typeof window < "u" && window, k2 = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, $2 = typeof globalThis < "u" && globalThis, t2 = $2 || x2 || k2;
        e25.global = t2;
      } }), al2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = sl2(), u2 = il2(), n2 = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
        function D2(p2) {
          return p2.replace(/\W/g, "_");
        }
        e25.sanitizeIdentifier = D2;
        var s2 = 0;
        function i2(p2) {
          if (!p2 || !p2.reference)
            return null;
          let A2 = p2.reference;
          if (A2 instanceof r2.StaticSymbol)
            return A2.name;
          if (A2.__anonymousType)
            return A2.__anonymousType;
          let P2 = u2.stringify(A2);
          return P2.indexOf("(") >= 0 ? (P2 = `anonymous_${s2++}`, A2.__anonymousType = P2) : P2 = D2(P2), P2;
        }
        e25.identifierName = i2;
        function f2(p2) {
          let A2 = p2.reference;
          return A2 instanceof r2.StaticSymbol ? A2.filePath : `./${u2.stringify(A2)}`;
        }
        e25.identifierModuleUrl = f2;
        function c2(p2, A2) {
          return `View_${i2({ reference: p2 })}_${A2}`;
        }
        e25.viewClassName = c2;
        function F2(p2) {
          return `RenderType_${i2({ reference: p2 })}`;
        }
        e25.rendererTypeName = F2;
        function a2(p2) {
          return `HostView_${i2({ reference: p2 })}`;
        }
        e25.hostViewClassName = a2;
        function l2(p2) {
          return `${i2({ reference: p2 })}NgFactory`;
        }
        e25.componentFactoryName = l2;
        var h2;
        (function(p2) {
          p2[p2.Pipe = 0] = "Pipe", p2[p2.Directive = 1] = "Directive", p2[p2.NgModule = 2] = "NgModule", p2[p2.Injectable = 3] = "Injectable";
        })(h2 = e25.CompileSummaryKind || (e25.CompileSummaryKind = {}));
        function C2(p2) {
          return p2.value != null ? D2(p2.value) : i2(p2.identifier);
        }
        e25.tokenName = C2;
        function d2(p2) {
          return p2.identifier != null ? p2.identifier.reference : p2.value;
        }
        e25.tokenReference = d2;
        var m2 = class {
          constructor() {
            let { moduleUrl: p2, styles: A2, styleUrls: P2 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            this.moduleUrl = p2 || null, this.styles = _2(A2), this.styleUrls = _2(P2);
          }
        };
        e25.CompileStylesheetMetadata = m2;
        var T2 = class {
          constructor(p2) {
            let { encapsulation: A2, template: P2, templateUrl: M2, htmlAst: z2, styles: V2, styleUrls: X2, externalStylesheets: H2, animations: Q2, ngContentSelectors: K2, interpolation: J2, isInline: v2, preserveWhitespaces: y2 } = p2;
            if (this.encapsulation = A2, this.template = P2, this.templateUrl = M2, this.htmlAst = z2, this.styles = _2(V2), this.styleUrls = _2(X2), this.externalStylesheets = _2(H2), this.animations = Q2 ? x2(Q2) : [], this.ngContentSelectors = K2 || [], J2 && J2.length != 2)
              throw new Error("'interpolation' should have a start and an end symbol.");
            this.interpolation = J2, this.isInline = v2, this.preserveWhitespaces = y2;
          }
          toSummary() {
            return { ngContentSelectors: this.ngContentSelectors, encapsulation: this.encapsulation, styles: this.styles, animations: this.animations };
          }
        };
        e25.CompileTemplateMetadata = T2;
        var w2 = class {
          static create(p2) {
            let { isHost: A2, type: P2, isComponent: M2, selector: z2, exportAs: V2, changeDetection: X2, inputs: H2, outputs: Q2, host: K2, providers: J2, viewProviders: v2, queries: y2, guards: B2, viewQueries: b2, entryComponents: L2, template: U2, componentViewType: G2, rendererType: W3, componentFactory: ne2 } = p2, be2 = {}, we2 = {}, Wr2 = {};
            K2 != null && Object.keys(K2).forEach((Z2) => {
              let ie2 = K2[Z2], Ce2 = Z2.match(n2);
              Ce2 === null ? Wr2[Z2] = ie2 : Ce2[1] != null ? we2[Ce2[1]] = ie2 : Ce2[2] != null && (be2[Ce2[2]] = ie2);
            });
            let Yr2 = {};
            H2 != null && H2.forEach((Z2) => {
              let ie2 = u2.splitAtColon(Z2, [Z2, Z2]);
              Yr2[ie2[0]] = ie2[1];
            });
            let Qr2 = {};
            return Q2 != null && Q2.forEach((Z2) => {
              let ie2 = u2.splitAtColon(Z2, [Z2, Z2]);
              Qr2[ie2[0]] = ie2[1];
            }), new w2({ isHost: A2, type: P2, isComponent: !!M2, selector: z2, exportAs: V2, changeDetection: X2, inputs: Yr2, outputs: Qr2, hostListeners: be2, hostProperties: we2, hostAttributes: Wr2, providers: J2, viewProviders: v2, queries: y2, guards: B2, viewQueries: b2, entryComponents: L2, template: U2, componentViewType: G2, rendererType: W3, componentFactory: ne2 });
          }
          constructor(p2) {
            let { isHost: A2, type: P2, isComponent: M2, selector: z2, exportAs: V2, changeDetection: X2, inputs: H2, outputs: Q2, hostListeners: K2, hostProperties: J2, hostAttributes: v2, providers: y2, viewProviders: B2, queries: b2, guards: L2, viewQueries: U2, entryComponents: G2, template: W3, componentViewType: ne2, rendererType: be2, componentFactory: we2 } = p2;
            this.isHost = !!A2, this.type = P2, this.isComponent = M2, this.selector = z2, this.exportAs = V2, this.changeDetection = X2, this.inputs = H2, this.outputs = Q2, this.hostListeners = K2, this.hostProperties = J2, this.hostAttributes = v2, this.providers = _2(y2), this.viewProviders = _2(B2), this.queries = _2(b2), this.guards = L2, this.viewQueries = _2(U2), this.entryComponents = _2(G2), this.template = W3, this.componentViewType = ne2, this.rendererType = be2, this.componentFactory = we2;
          }
          toSummary() {
            return { summaryKind: h2.Directive, type: this.type, isComponent: this.isComponent, selector: this.selector, exportAs: this.exportAs, inputs: this.inputs, outputs: this.outputs, hostListeners: this.hostListeners, hostProperties: this.hostProperties, hostAttributes: this.hostAttributes, providers: this.providers, viewProviders: this.viewProviders, queries: this.queries, guards: this.guards, viewQueries: this.viewQueries, entryComponents: this.entryComponents, changeDetection: this.changeDetection, template: this.template && this.template.toSummary(), componentViewType: this.componentViewType, rendererType: this.rendererType, componentFactory: this.componentFactory };
          }
        };
        e25.CompileDirectiveMetadata = w2;
        var g2 = class {
          constructor(p2) {
            let { type: A2, name: P2, pure: M2 } = p2;
            this.type = A2, this.name = P2, this.pure = !!M2;
          }
          toSummary() {
            return { summaryKind: h2.Pipe, type: this.type, name: this.name, pure: this.pure };
          }
        };
        e25.CompilePipeMetadata = g2;
        var N2 = class {
        };
        e25.CompileShallowModuleMetadata = N2;
        var R2 = class {
          constructor(p2) {
            let { type: A2, providers: P2, declaredDirectives: M2, exportedDirectives: z2, declaredPipes: V2, exportedPipes: X2, entryComponents: H2, bootstrapComponents: Q2, importedModules: K2, exportedModules: J2, schemas: v2, transitiveModule: y2, id: B2 } = p2;
            this.type = A2 || null, this.declaredDirectives = _2(M2), this.exportedDirectives = _2(z2), this.declaredPipes = _2(V2), this.exportedPipes = _2(X2), this.providers = _2(P2), this.entryComponents = _2(H2), this.bootstrapComponents = _2(Q2), this.importedModules = _2(K2), this.exportedModules = _2(J2), this.schemas = _2(v2), this.id = B2 || null, this.transitiveModule = y2 || null;
          }
          toSummary() {
            let p2 = this.transitiveModule;
            return { summaryKind: h2.NgModule, type: this.type, entryComponents: p2.entryComponents, providers: p2.providers, modules: p2.modules, exportedDirectives: p2.exportedDirectives, exportedPipes: p2.exportedPipes };
          }
        };
        e25.CompileNgModuleMetadata = R2;
        var j2 = class {
          constructor() {
            this.directivesSet = new Set(), this.directives = [], this.exportedDirectivesSet = new Set(), this.exportedDirectives = [], this.pipesSet = new Set(), this.pipes = [], this.exportedPipesSet = new Set(), this.exportedPipes = [], this.modulesSet = new Set(), this.modules = [], this.entryComponentsSet = new Set(), this.entryComponents = [], this.providers = [];
          }
          addProvider(p2, A2) {
            this.providers.push({ provider: p2, module: A2 });
          }
          addDirective(p2) {
            this.directivesSet.has(p2.reference) || (this.directivesSet.add(p2.reference), this.directives.push(p2));
          }
          addExportedDirective(p2) {
            this.exportedDirectivesSet.has(p2.reference) || (this.exportedDirectivesSet.add(p2.reference), this.exportedDirectives.push(p2));
          }
          addPipe(p2) {
            this.pipesSet.has(p2.reference) || (this.pipesSet.add(p2.reference), this.pipes.push(p2));
          }
          addExportedPipe(p2) {
            this.exportedPipesSet.has(p2.reference) || (this.exportedPipesSet.add(p2.reference), this.exportedPipes.push(p2));
          }
          addModule(p2) {
            this.modulesSet.has(p2.reference) || (this.modulesSet.add(p2.reference), this.modules.push(p2));
          }
          addEntryComponent(p2) {
            this.entryComponentsSet.has(p2.componentType) || (this.entryComponentsSet.add(p2.componentType), this.entryComponents.push(p2));
          }
        };
        e25.TransitiveCompileNgModuleMetadata = j2;
        function _2(p2) {
          return p2 || [];
        }
        var O2 = class {
          constructor(p2, A2) {
            let { useClass: P2, useValue: M2, useExisting: z2, useFactory: V2, deps: X2, multi: H2 } = A2;
            this.token = p2, this.useClass = P2 || null, this.useValue = M2, this.useExisting = z2, this.useFactory = V2 || null, this.dependencies = X2 || null, this.multi = !!H2;
          }
        };
        e25.ProviderMeta = O2;
        function x2(p2) {
          return p2.reduce((A2, P2) => {
            let M2 = Array.isArray(P2) ? x2(P2) : P2;
            return A2.concat(M2);
          }, []);
        }
        e25.flatten = x2;
        function k2(p2) {
          return p2.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
        }
        function $2(p2, A2, P2) {
          let M2;
          return P2.isInline ? A2.type.reference instanceof r2.StaticSymbol ? M2 = `${A2.type.reference.filePath}.${A2.type.reference.name}.html` : M2 = `${i2(p2)}/${i2(A2.type)}.html` : M2 = P2.templateUrl, A2.type.reference instanceof r2.StaticSymbol ? M2 : k2(M2);
        }
        e25.templateSourceUrl = $2;
        function t2(p2, A2) {
          let P2 = p2.moduleUrl.split(/\/\\/g), M2 = P2[P2.length - 1];
          return k2(`css/${A2}${M2}.ngstyle.js`);
        }
        e25.sharedStylesheetJitUrl = t2;
        function o2(p2) {
          return k2(`${i2(p2.type)}/module.ngfactory.js`);
        }
        e25.ngModuleJitUrl = o2;
        function E2(p2, A2) {
          return k2(`${i2(p2)}/${i2(A2.type)}.ngfactory.js`);
        }
        e25.templateJitUrl = E2;
      } }), Be2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Es2(), u2 = al2(), n2 = class {
          constructor(a2, l2, h2, C2) {
            this.file = a2, this.offset = l2, this.line = h2, this.col = C2;
          }
          toString() {
            return this.offset != null ? `${this.file.url}@${this.line}:${this.col}` : this.file.url;
          }
          moveBy(a2) {
            let l2 = this.file.content, h2 = l2.length, C2 = this.offset, d2 = this.line, m2 = this.col;
            for (; C2 > 0 && a2 < 0; )
              if (C2--, a2++, l2.charCodeAt(C2) == r2.$LF) {
                d2--;
                let w2 = l2.substr(0, C2 - 1).lastIndexOf(String.fromCharCode(r2.$LF));
                m2 = w2 > 0 ? C2 - w2 : C2;
              } else
                m2--;
            for (; C2 < h2 && a2 > 0; ) {
              let T2 = l2.charCodeAt(C2);
              C2++, a2--, T2 == r2.$LF ? (d2++, m2 = 0) : m2++;
            }
            return new n2(this.file, C2, d2, m2);
          }
          getContext(a2, l2) {
            let h2 = this.file.content, C2 = this.offset;
            if (C2 != null) {
              C2 > h2.length - 1 && (C2 = h2.length - 1);
              let d2 = C2, m2 = 0, T2 = 0;
              for (; m2 < a2 && C2 > 0 && (C2--, m2++, !(h2[C2] == `
` && ++T2 == l2)); )
                ;
              for (m2 = 0, T2 = 0; m2 < a2 && d2 < h2.length - 1 && (d2++, m2++, !(h2[d2] == `
` && ++T2 == l2)); )
                ;
              return { before: h2.substring(C2, this.offset), after: h2.substring(this.offset, d2 + 1) };
            }
            return null;
          }
        };
        e25.ParseLocation = n2;
        var D2 = class {
          constructor(a2, l2) {
            this.content = a2, this.url = l2;
          }
        };
        e25.ParseSourceFile = D2;
        var s2 = class {
          constructor(a2, l2) {
            let h2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            this.start = a2, this.end = l2, this.details = h2;
          }
          toString() {
            return this.start.file.content.substring(this.start.offset, this.end.offset);
          }
        };
        e25.ParseSourceSpan = s2, e25.EMPTY_PARSE_LOCATION = new n2(new D2("", ""), 0, 0, 0), e25.EMPTY_SOURCE_SPAN = new s2(e25.EMPTY_PARSE_LOCATION, e25.EMPTY_PARSE_LOCATION);
        var i2;
        (function(a2) {
          a2[a2.WARNING = 0] = "WARNING", a2[a2.ERROR = 1] = "ERROR";
        })(i2 = e25.ParseErrorLevel || (e25.ParseErrorLevel = {}));
        var f2 = class {
          constructor(a2, l2) {
            let h2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : i2.ERROR;
            this.span = a2, this.msg = l2, this.level = h2;
          }
          contextualMessage() {
            let a2 = this.span.start.getContext(100, 3);
            return a2 ? `${this.msg} ("${a2.before}[${i2[this.level]} ->]${a2.after}")` : this.msg;
          }
          toString() {
            let a2 = this.span.details ? `, ${this.span.details}` : "";
            return `${this.contextualMessage()}: ${this.span.start}${a2}`;
          }
        };
        e25.ParseError = f2;
        function c2(a2, l2) {
          let h2 = u2.identifierModuleUrl(l2), C2 = h2 != null ? `in ${a2} ${u2.identifierName(l2)} in ${h2}` : `in ${a2} ${u2.identifierName(l2)}`, d2 = new D2("", C2);
          return new s2(new n2(d2, -1, -1, -1), new n2(d2, -1, -1, -1));
        }
        e25.typeSourceSpan = c2;
        function F2(a2, l2, h2) {
          let C2 = `in ${a2} ${l2} in ${h2}`, d2 = new D2("", C2);
          return new s2(new n2(d2, -1, -1, -1), new n2(d2, -1, -1, -1));
        }
        e25.r3JitTypeSourceSpan = F2;
      } }), ol2 = I2({ "src/utils/front-matter/parse.js"(e25, r2) {
        q2();
        var u2 = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
        function n2(D2) {
          let s2 = D2.match(u2);
          if (!s2)
            return { content: D2 };
          let { startDelimiter: i2, language: f2, value: c2 = "", endDelimiter: F2 } = s2.groups, a2 = f2.trim() || "yaml";
          if (i2 === "+++" && (a2 = "toml"), a2 !== "yaml" && i2 !== F2)
            return { content: D2 };
          let [l2] = s2;
          return { frontMatter: { type: "front-matter", lang: a2, value: c2, startDelimiter: i2, endDelimiter: F2, raw: l2.replace(/\n$/, "") }, content: l2.replace(/[^\n]/g, " ") + D2.slice(l2.length) };
        }
        r2.exports = n2;
      } }), Cs2 = I2({ "src/utils/get-last.js"(e25, r2) {
        q2();
        var u2 = (n2) => n2[n2.length - 1];
        r2.exports = u2;
      } }), Dl2 = I2({ "src/common/parser-create-error.js"(e25, r2) {
        q2();
        function u2(n2, D2) {
          let s2 = new SyntaxError(n2 + " (" + D2.start.line + ":" + D2.start.column + ")");
          return s2.loc = D2, s2;
        }
        r2.exports = u2;
      } }), ms = {};
      ps(ms, { default: () => ll2 });
      function ll2(e25) {
        if (typeof e25 != "string")
          throw new TypeError("Expected a string");
        return e25.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
      }
      var cl2 = Ee2({ "node_modules/escape-string-regexp/index.js"() {
        q2();
      } }), gs = I2({ "node_modules/semver/internal/debug.js"(e25, r2) {
        q2();
        var u2 = typeof Te2 == "object" && Te2.env && Te2.env.NODE_DEBUG && /\bsemver\b/i.test(Te2.env.NODE_DEBUG) ? function() {
          for (var n2 = arguments.length, D2 = new Array(n2), s2 = 0; s2 < n2; s2++)
            D2[s2] = arguments[s2];
          return console.error("SEMVER", ...D2);
        } : () => {
        };
        r2.exports = u2;
      } }), Fs2 = I2({ "node_modules/semver/internal/constants.js"(e25, r2) {
        q2();
        var u2 = "2.0.0", n2 = 256, D2 = Number.MAX_SAFE_INTEGER || 9007199254740991, s2 = 16;
        r2.exports = { SEMVER_SPEC_VERSION: u2, MAX_LENGTH: n2, MAX_SAFE_INTEGER: D2, MAX_SAFE_COMPONENT_LENGTH: s2 };
      } }), hl2 = I2({ "node_modules/semver/internal/re.js"(e25, r2) {
        q2();
        var { MAX_SAFE_COMPONENT_LENGTH: u2 } = Fs2(), n2 = gs();
        e25 = r2.exports = {};
        var D2 = e25.re = [], s2 = e25.src = [], i2 = e25.t = {}, f2 = 0, c2 = (F2, a2, l2) => {
          let h2 = f2++;
          n2(F2, h2, a2), i2[F2] = h2, s2[h2] = a2, D2[h2] = new RegExp(a2, l2 ? "g" : void 0);
        };
        c2("NUMERICIDENTIFIER", "0|[1-9]\\d*"), c2("NUMERICIDENTIFIERLOOSE", "[0-9]+"), c2("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), c2("MAINVERSION", `(${s2[i2.NUMERICIDENTIFIER]})\\.(${s2[i2.NUMERICIDENTIFIER]})\\.(${s2[i2.NUMERICIDENTIFIER]})`), c2("MAINVERSIONLOOSE", `(${s2[i2.NUMERICIDENTIFIERLOOSE]})\\.(${s2[i2.NUMERICIDENTIFIERLOOSE]})\\.(${s2[i2.NUMERICIDENTIFIERLOOSE]})`), c2("PRERELEASEIDENTIFIER", `(?:${s2[i2.NUMERICIDENTIFIER]}|${s2[i2.NONNUMERICIDENTIFIER]})`), c2("PRERELEASEIDENTIFIERLOOSE", `(?:${s2[i2.NUMERICIDENTIFIERLOOSE]}|${s2[i2.NONNUMERICIDENTIFIER]})`), c2("PRERELEASE", `(?:-(${s2[i2.PRERELEASEIDENTIFIER]}(?:\\.${s2[i2.PRERELEASEIDENTIFIER]})*))`), c2("PRERELEASELOOSE", `(?:-?(${s2[i2.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${s2[i2.PRERELEASEIDENTIFIERLOOSE]})*))`), c2("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), c2("BUILD", `(?:\\+(${s2[i2.BUILDIDENTIFIER]}(?:\\.${s2[i2.BUILDIDENTIFIER]})*))`), c2("FULLPLAIN", `v?${s2[i2.MAINVERSION]}${s2[i2.PRERELEASE]}?${s2[i2.BUILD]}?`), c2("FULL", `^${s2[i2.FULLPLAIN]}$`), c2("LOOSEPLAIN", `[v=\\s]*${s2[i2.MAINVERSIONLOOSE]}${s2[i2.PRERELEASELOOSE]}?${s2[i2.BUILD]}?`), c2("LOOSE", `^${s2[i2.LOOSEPLAIN]}$`), c2("GTLT", "((?:<|>)?=?)"), c2("XRANGEIDENTIFIERLOOSE", `${s2[i2.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), c2("XRANGEIDENTIFIER", `${s2[i2.NUMERICIDENTIFIER]}|x|X|\\*`), c2("XRANGEPLAIN", `[v=\\s]*(${s2[i2.XRANGEIDENTIFIER]})(?:\\.(${s2[i2.XRANGEIDENTIFIER]})(?:\\.(${s2[i2.XRANGEIDENTIFIER]})(?:${s2[i2.PRERELEASE]})?${s2[i2.BUILD]}?)?)?`), c2("XRANGEPLAINLOOSE", `[v=\\s]*(${s2[i2.XRANGEIDENTIFIERLOOSE]})(?:\\.(${s2[i2.XRANGEIDENTIFIERLOOSE]})(?:\\.(${s2[i2.XRANGEIDENTIFIERLOOSE]})(?:${s2[i2.PRERELEASELOOSE]})?${s2[i2.BUILD]}?)?)?`), c2("XRANGE", `^${s2[i2.GTLT]}\\s*${s2[i2.XRANGEPLAIN]}$`), c2("XRANGELOOSE", `^${s2[i2.GTLT]}\\s*${s2[i2.XRANGEPLAINLOOSE]}$`), c2("COERCE", `(^|[^\\d])(\\d{1,${u2}})(?:\\.(\\d{1,${u2}}))?(?:\\.(\\d{1,${u2}}))?(?:$|[^\\d])`), c2("COERCERTL", s2[i2.COERCE], true), c2("LONETILDE", "(?:~>?)"), c2("TILDETRIM", `(\\s*)${s2[i2.LONETILDE]}\\s+`, true), e25.tildeTrimReplace = "$1~", c2("TILDE", `^${s2[i2.LONETILDE]}${s2[i2.XRANGEPLAIN]}$`), c2("TILDELOOSE", `^${s2[i2.LONETILDE]}${s2[i2.XRANGEPLAINLOOSE]}$`), c2("LONECARET", "(?:\\^)"), c2("CARETTRIM", `(\\s*)${s2[i2.LONECARET]}\\s+`, true), e25.caretTrimReplace = "$1^", c2("CARET", `^${s2[i2.LONECARET]}${s2[i2.XRANGEPLAIN]}$`), c2("CARETLOOSE", `^${s2[i2.LONECARET]}${s2[i2.XRANGEPLAINLOOSE]}$`), c2("COMPARATORLOOSE", `^${s2[i2.GTLT]}\\s*(${s2[i2.LOOSEPLAIN]})$|^$`), c2("COMPARATOR", `^${s2[i2.GTLT]}\\s*(${s2[i2.FULLPLAIN]})$|^$`), c2("COMPARATORTRIM", `(\\s*)${s2[i2.GTLT]}\\s*(${s2[i2.LOOSEPLAIN]}|${s2[i2.XRANGEPLAIN]})`, true), e25.comparatorTrimReplace = "$1$2$3", c2("HYPHENRANGE", `^\\s*(${s2[i2.XRANGEPLAIN]})\\s+-\\s+(${s2[i2.XRANGEPLAIN]})\\s*$`), c2("HYPHENRANGELOOSE", `^\\s*(${s2[i2.XRANGEPLAINLOOSE]})\\s+-\\s+(${s2[i2.XRANGEPLAINLOOSE]})\\s*$`), c2("STAR", "(<|>)?=?\\s*\\*"), c2("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), c2("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
      } }), pl2 = I2({ "node_modules/semver/internal/parse-options.js"(e25, r2) {
        q2();
        var u2 = ["includePrerelease", "loose", "rtl"], n2 = (D2) => D2 ? typeof D2 != "object" ? { loose: true } : u2.filter((s2) => D2[s2]).reduce((s2, i2) => (s2[i2] = true, s2), {}) : {};
        r2.exports = n2;
      } }), fl2 = I2({ "node_modules/semver/internal/identifiers.js"(e25, r2) {
        q2();
        var u2 = /^[0-9]+$/, n2 = (s2, i2) => {
          let f2 = u2.test(s2), c2 = u2.test(i2);
          return f2 && c2 && (s2 = +s2, i2 = +i2), s2 === i2 ? 0 : f2 && !c2 ? -1 : c2 && !f2 ? 1 : s2 < i2 ? -1 : 1;
        }, D2 = (s2, i2) => n2(i2, s2);
        r2.exports = { compareIdentifiers: n2, rcompareIdentifiers: D2 };
      } }), dl2 = I2({ "node_modules/semver/classes/semver.js"(e25, r2) {
        q2();
        var u2 = gs(), { MAX_LENGTH: n2, MAX_SAFE_INTEGER: D2 } = Fs2(), { re: s2, t: i2 } = hl2(), f2 = pl2(), { compareIdentifiers: c2 } = fl2(), F2 = class {
          constructor(a2, l2) {
            if (l2 = f2(l2), a2 instanceof F2) {
              if (a2.loose === !!l2.loose && a2.includePrerelease === !!l2.includePrerelease)
                return a2;
              a2 = a2.version;
            } else if (typeof a2 != "string")
              throw new TypeError(`Invalid Version: ${a2}`);
            if (a2.length > n2)
              throw new TypeError(`version is longer than ${n2} characters`);
            u2("SemVer", a2, l2), this.options = l2, this.loose = !!l2.loose, this.includePrerelease = !!l2.includePrerelease;
            let h2 = a2.trim().match(l2.loose ? s2[i2.LOOSE] : s2[i2.FULL]);
            if (!h2)
              throw new TypeError(`Invalid Version: ${a2}`);
            if (this.raw = a2, this.major = +h2[1], this.minor = +h2[2], this.patch = +h2[3], this.major > D2 || this.major < 0)
              throw new TypeError("Invalid major version");
            if (this.minor > D2 || this.minor < 0)
              throw new TypeError("Invalid minor version");
            if (this.patch > D2 || this.patch < 0)
              throw new TypeError("Invalid patch version");
            h2[4] ? this.prerelease = h2[4].split(".").map((C2) => {
              if (/^[0-9]+$/.test(C2)) {
                let d2 = +C2;
                if (d2 >= 0 && d2 < D2)
                  return d2;
              }
              return C2;
            }) : this.prerelease = [], this.build = h2[5] ? h2[5].split(".") : [], this.format();
          }
          format() {
            return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
          }
          toString() {
            return this.version;
          }
          compare(a2) {
            if (u2("SemVer.compare", this.version, this.options, a2), !(a2 instanceof F2)) {
              if (typeof a2 == "string" && a2 === this.version)
                return 0;
              a2 = new F2(a2, this.options);
            }
            return a2.version === this.version ? 0 : this.compareMain(a2) || this.comparePre(a2);
          }
          compareMain(a2) {
            return a2 instanceof F2 || (a2 = new F2(a2, this.options)), c2(this.major, a2.major) || c2(this.minor, a2.minor) || c2(this.patch, a2.patch);
          }
          comparePre(a2) {
            if (a2 instanceof F2 || (a2 = new F2(a2, this.options)), this.prerelease.length && !a2.prerelease.length)
              return -1;
            if (!this.prerelease.length && a2.prerelease.length)
              return 1;
            if (!this.prerelease.length && !a2.prerelease.length)
              return 0;
            let l2 = 0;
            do {
              let h2 = this.prerelease[l2], C2 = a2.prerelease[l2];
              if (u2("prerelease compare", l2, h2, C2), h2 === void 0 && C2 === void 0)
                return 0;
              if (C2 === void 0)
                return 1;
              if (h2 === void 0)
                return -1;
              if (h2 === C2)
                continue;
              return c2(h2, C2);
            } while (++l2);
          }
          compareBuild(a2) {
            a2 instanceof F2 || (a2 = new F2(a2, this.options));
            let l2 = 0;
            do {
              let h2 = this.build[l2], C2 = a2.build[l2];
              if (u2("prerelease compare", l2, h2, C2), h2 === void 0 && C2 === void 0)
                return 0;
              if (C2 === void 0)
                return 1;
              if (h2 === void 0)
                return -1;
              if (h2 === C2)
                continue;
              return c2(h2, C2);
            } while (++l2);
          }
          inc(a2, l2) {
            switch (a2) {
              case "premajor":
                this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", l2);
                break;
              case "preminor":
                this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", l2);
                break;
              case "prepatch":
                this.prerelease.length = 0, this.inc("patch", l2), this.inc("pre", l2);
                break;
              case "prerelease":
                this.prerelease.length === 0 && this.inc("patch", l2), this.inc("pre", l2);
                break;
              case "major":
                (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                break;
              case "minor":
                (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                break;
              case "patch":
                this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                break;
              case "pre":
                if (this.prerelease.length === 0)
                  this.prerelease = [0];
                else {
                  let h2 = this.prerelease.length;
                  for (; --h2 >= 0; )
                    typeof this.prerelease[h2] == "number" && (this.prerelease[h2]++, h2 = -2);
                  h2 === -1 && this.prerelease.push(0);
                }
                l2 && (c2(this.prerelease[0], l2) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [l2, 0]) : this.prerelease = [l2, 0]);
                break;
              default:
                throw new Error(`invalid increment argument: ${a2}`);
            }
            return this.format(), this.raw = this.version, this;
          }
        };
        r2.exports = F2;
      } }), Hr2 = I2({ "node_modules/semver/functions/compare.js"(e25, r2) {
        q2();
        var u2 = dl2(), n2 = (D2, s2, i2) => new u2(D2, i2).compare(new u2(s2, i2));
        r2.exports = n2;
      } }), El2 = I2({ "node_modules/semver/functions/lt.js"(e25, r2) {
        q2();
        var u2 = Hr2(), n2 = (D2, s2, i2) => u2(D2, s2, i2) < 0;
        r2.exports = n2;
      } }), Cl2 = I2({ "node_modules/semver/functions/gte.js"(e25, r2) {
        q2();
        var u2 = Hr2(), n2 = (D2, s2, i2) => u2(D2, s2, i2) >= 0;
        r2.exports = n2;
      } }), ml2 = I2({ "src/utils/arrayify.js"(e25, r2) {
        q2(), r2.exports = (u2, n2) => Object.entries(u2).map((D2) => {
          let [s2, i2] = D2;
          return Object.assign({ [n2]: s2 }, i2);
        });
      } }), gl2 = I2({ "package.json"(e25, r2) {
        r2.exports = { version: "2.8.2" };
      } }), Fl2 = I2({ "node_modules/outdent/lib/index.js"(e25, r2) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true }), e25.outdent = void 0;
        function u2() {
          for (var g2 = [], N2 = 0; N2 < arguments.length; N2++)
            g2[N2] = arguments[N2];
        }
        function n2() {
          return typeof WeakMap < "u" ? new WeakMap() : D2();
        }
        function D2() {
          return { add: u2, delete: u2, get: u2, set: u2, has: function(g2) {
            return false;
          } };
        }
        var s2 = Object.prototype.hasOwnProperty, i2 = function(g2, N2) {
          return s2.call(g2, N2);
        };
        function f2(g2, N2) {
          for (var R2 in N2)
            i2(N2, R2) && (g2[R2] = N2[R2]);
          return g2;
        }
        var c2 = /^[ \t]*(?:\r\n|\r|\n)/, F2 = /(?:\r\n|\r|\n)[ \t]*$/, a2 = /^(?:[\r\n]|$)/, l2 = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, h2 = /^[ \t]*[\r\n][ \t\r\n]*$/;
        function C2(g2, N2, R2) {
          var j2 = 0, _2 = g2[0].match(l2);
          _2 && (j2 = _2[1].length);
          var O2 = "(\\r\\n|\\r|\\n).{0," + j2 + "}", x2 = new RegExp(O2, "g");
          N2 && (g2 = g2.slice(1));
          var k2 = R2.newline, $2 = R2.trimLeadingNewline, t2 = R2.trimTrailingNewline, o2 = typeof k2 == "string", E2 = g2.length, p2 = g2.map(function(A2, P2) {
            return A2 = A2.replace(x2, "$1"), P2 === 0 && $2 && (A2 = A2.replace(c2, "")), P2 === E2 - 1 && t2 && (A2 = A2.replace(F2, "")), o2 && (A2 = A2.replace(/\r\n|\n|\r/g, function(M2) {
              return k2;
            })), A2;
          });
          return p2;
        }
        function d2(g2, N2) {
          for (var R2 = "", j2 = 0, _2 = g2.length; j2 < _2; j2++)
            R2 += g2[j2], j2 < _2 - 1 && (R2 += N2[j2]);
          return R2;
        }
        function m2(g2) {
          return i2(g2, "raw") && i2(g2, "length");
        }
        function T2(g2) {
          var N2 = n2(), R2 = n2();
          function j2(O2) {
            for (var x2 = [], k2 = 1; k2 < arguments.length; k2++)
              x2[k2 - 1] = arguments[k2];
            if (m2(O2)) {
              var $2 = O2, t2 = (x2[0] === j2 || x2[0] === w2) && h2.test($2[0]) && a2.test($2[1]), o2 = t2 ? R2 : N2, E2 = o2.get($2);
              if (E2 || (E2 = C2($2, t2, g2), o2.set($2, E2)), x2.length === 0)
                return E2[0];
              var p2 = d2(E2, t2 ? x2.slice(1) : x2);
              return p2;
            } else
              return T2(f2(f2({}, g2), O2 || {}));
          }
          var _2 = f2(j2, { string: function(O2) {
            return C2([O2], false, g2)[0];
          } });
          return _2;
        }
        var w2 = T2({ trimLeadingNewline: true, trimTrailingNewline: true });
        if (e25.outdent = w2, e25.default = w2, typeof r2 < "u")
          try {
            r2.exports = w2, Object.defineProperty(w2, "__esModule", { value: true }), w2.default = w2, w2.outdent = w2;
          } catch {
          }
      } }), Al2 = I2({ "src/main/core-options.js"(e25, r2) {
        q2();
        var { outdent: u2 } = Fl2(), n2 = "Config", D2 = "Editor", s2 = "Format", i2 = "Other", f2 = "Output", c2 = "Global", F2 = "Special", a2 = { cursorOffset: { since: "1.4.0", category: F2, type: "int", default: -1, range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 }, description: u2`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `, cliCategory: D2 }, endOfLine: { since: "1.15.0", category: c2, type: "choice", default: [{ since: "1.15.0", value: "auto" }, { since: "2.0.0", value: "lf" }], description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: u2`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        ` }] }, filepath: { since: "1.4.0", category: F2, type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: i2, cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { since: "1.8.0", category: F2, type: "boolean", default: false, description: "Insert @format pragma into file's first docblock comment.", cliCategory: i2 }, parser: { since: "0.0.10", category: c2, type: "choice", default: [{ since: "0.0.10", value: "babylon" }, { since: "1.13.0", value: void 0 }], description: "Which parser to use.", exception: (l2) => typeof l2 == "string" || typeof l2 == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", since: "1.16.0", description: "JavaScript" }, { value: "babel-flow", since: "1.16.0", description: "Flow" }, { value: "babel-ts", since: "2.0.0", description: "TypeScript" }, { value: "typescript", since: "1.4.0", description: "TypeScript" }, { value: "acorn", since: "2.6.0", description: "JavaScript" }, { value: "espree", since: "2.2.0", description: "JavaScript" }, { value: "meriyah", since: "2.2.0", description: "JavaScript" }, { value: "css", since: "1.7.1", description: "CSS" }, { value: "less", since: "1.7.1", description: "Less" }, { value: "scss", since: "1.7.1", description: "SCSS" }, { value: "json", since: "1.5.0", description: "JSON" }, { value: "json5", since: "1.13.0", description: "JSON5" }, { value: "json-stringify", since: "1.13.0", description: "JSON.stringify" }, { value: "graphql", since: "1.5.0", description: "GraphQL" }, { value: "markdown", since: "1.8.0", description: "Markdown" }, { value: "mdx", since: "1.15.0", description: "MDX" }, { value: "vue", since: "1.10.0", description: "Vue" }, { value: "yaml", since: "1.14.0", description: "YAML" }, { value: "glimmer", since: "2.3.0", description: "Ember / Handlebars" }, { value: "html", since: "1.15.0", description: "HTML" }, { value: "angular", since: "1.15.0", description: "Angular" }, { value: "lwc", since: "1.17.0", description: "Lightning Web Components" }] }, plugins: { since: "1.10.0", type: "path", array: true, default: [{ value: [] }], category: c2, description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (l2) => typeof l2 == "string" || typeof l2 == "object", cliName: "plugin", cliCategory: n2 }, pluginSearchDirs: { since: "1.13.0", type: "path", array: true, default: [{ value: [] }], category: c2, description: u2`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `, exception: (l2) => typeof l2 == "string" || typeof l2 == "object", cliName: "plugin-search-dir", cliCategory: n2 }, printWidth: { since: "0.0.0", category: c2, type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, rangeEnd: { since: "1.4.0", category: F2, type: "int", default: Number.POSITIVE_INFINITY, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: u2`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: D2 }, rangeStart: { since: "1.4.0", category: F2, type: "int", default: 0, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: u2`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: D2 }, requirePragma: { since: "1.7.0", category: F2, type: "boolean", default: false, description: u2`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `, cliCategory: i2 }, tabWidth: { type: "int", category: c2, default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, useTabs: { since: "1.0.0", category: c2, type: "boolean", default: false, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { since: "2.1.0", category: c2, type: "choice", default: [{ since: "2.1.0", value: "auto" }], description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
        r2.exports = { CATEGORY_CONFIG: n2, CATEGORY_EDITOR: D2, CATEGORY_FORMAT: s2, CATEGORY_OTHER: i2, CATEGORY_OUTPUT: f2, CATEGORY_GLOBAL: c2, CATEGORY_SPECIAL: F2, options: a2 };
      } }), vl2 = I2({ "src/main/support.js"(e25, r2) {
        q2();
        var u2 = { compare: Hr2(), lt: El2(), gte: Cl2() }, n2 = ml2(), D2 = gl2().version, s2 = Al2().options;
        function i2() {
          let { plugins: c2 = [], showUnreleased: F2 = false, showDeprecated: a2 = false, showInternal: l2 = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, h2 = D2.split("-", 1)[0], C2 = c2.flatMap((g2) => g2.languages || []).filter(m2), d2 = n2(Object.assign({}, ...c2.map((g2) => {
            let { options: N2 } = g2;
            return N2;
          }), s2), "name").filter((g2) => m2(g2) && T2(g2)).sort((g2, N2) => g2.name === N2.name ? 0 : g2.name < N2.name ? -1 : 1).map(w2).map((g2) => {
            g2 = Object.assign({}, g2), Array.isArray(g2.default) && (g2.default = g2.default.length === 1 ? g2.default[0].value : g2.default.filter(m2).sort((R2, j2) => u2.compare(j2.since, R2.since))[0].value), Array.isArray(g2.choices) && (g2.choices = g2.choices.filter((R2) => m2(R2) && T2(R2)), g2.name === "parser" && f2(g2, C2, c2));
            let N2 = Object.fromEntries(c2.filter((R2) => R2.defaultOptions && R2.defaultOptions[g2.name] !== void 0).map((R2) => [R2.name, R2.defaultOptions[g2.name]]));
            return Object.assign(Object.assign({}, g2), {}, { pluginDefaults: N2 });
          });
          return { languages: C2, options: d2 };
          function m2(g2) {
            return F2 || !("since" in g2) || g2.since && u2.gte(h2, g2.since);
          }
          function T2(g2) {
            return a2 || !("deprecated" in g2) || g2.deprecated && u2.lt(h2, g2.deprecated);
          }
          function w2(g2) {
            if (l2)
              return g2;
            return JD2(g2, KD2);
          }
        }
        function f2(c2, F2, a2) {
          let l2 = new Set(c2.choices.map((h2) => h2.value));
          for (let h2 of F2)
            if (h2.parsers) {
              for (let C2 of h2.parsers)
                if (!l2.has(C2)) {
                  l2.add(C2);
                  let d2 = a2.find((T2) => T2.parsers && T2.parsers[C2]), m2 = h2.name;
                  d2 && d2.name && (m2 += ` (plugin: ${d2.name})`), c2.choices.push({ value: C2, description: m2 });
                }
            }
        }
        r2.exports = { getSupportInfo: i2 };
      } }), _l2 = I2({ "src/utils/is-non-empty-array.js"(e25, r2) {
        q2();
        function u2(n2) {
          return Array.isArray(n2) && n2.length > 0;
        }
        r2.exports = u2;
      } });
      function Sl2() {
        let { onlyFirst: e25 = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r2 = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
        return new RegExp(r2, e25 ? void 0 : "g");
      }
      var yl2 = Ee2({ "node_modules/strip-ansi/node_modules/ansi-regex/index.js"() {
        q2();
      } });
      function Tl2(e25) {
        if (typeof e25 != "string")
          throw new TypeError(`Expected a \`string\`, got \`${typeof e25}\``);
        return e25.replace(Sl2(), "");
      }
      var Bl2 = Ee2({ "node_modules/strip-ansi/index.js"() {
        q2(), yl2();
      } });
      function bl2(e25) {
        return Number.isInteger(e25) ? e25 >= 4352 && (e25 <= 4447 || e25 === 9001 || e25 === 9002 || 11904 <= e25 && e25 <= 12871 && e25 !== 12351 || 12880 <= e25 && e25 <= 19903 || 19968 <= e25 && e25 <= 42182 || 43360 <= e25 && e25 <= 43388 || 44032 <= e25 && e25 <= 55203 || 63744 <= e25 && e25 <= 64255 || 65040 <= e25 && e25 <= 65049 || 65072 <= e25 && e25 <= 65131 || 65281 <= e25 && e25 <= 65376 || 65504 <= e25 && e25 <= 65510 || 110592 <= e25 && e25 <= 110593 || 127488 <= e25 && e25 <= 127569 || 131072 <= e25 && e25 <= 262141) : false;
      }
      var wl2 = Ee2({ "node_modules/is-fullwidth-code-point/index.js"() {
        q2();
      } }), Nl2 = I2({ "node_modules/emoji-regex/index.js"(e25, r2) {
        q2(), r2.exports = function() {
          return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
        };
      } }), As2 = {};
      ps(As2, { default: () => Ol2 });
      function Ol2(e25) {
        if (typeof e25 != "string" || e25.length === 0 || (e25 = Tl2(e25), e25.length === 0))
          return 0;
        e25 = e25.replace((0, vs.default)(), "  ");
        let r2 = 0;
        for (let u2 = 0; u2 < e25.length; u2++) {
          let n2 = e25.codePointAt(u2);
          n2 <= 31 || n2 >= 127 && n2 <= 159 || n2 >= 768 && n2 <= 879 || (n2 > 65535 && u2++, r2 += bl2(n2) ? 2 : 1);
        }
        return r2;
      }
      var vs, ql2 = Ee2({ "node_modules/string-width/index.js"() {
        q2(), Bl2(), wl2(), vs = nl2(Nl2());
      } }), Il2 = I2({ "src/utils/get-string-width.js"(e25, r2) {
        q2();
        var u2 = (ql2(), ds(As2)).default, n2 = /[^\x20-\x7F]/;
        function D2(s2) {
          return s2 ? n2.test(s2) ? u2(s2) : s2.length : 0;
        }
        r2.exports = D2;
      } }), zr2 = I2({ "src/utils/text/skip.js"(e25, r2) {
        q2();
        function u2(f2) {
          return (c2, F2, a2) => {
            let l2 = a2 && a2.backwards;
            if (F2 === false)
              return false;
            let { length: h2 } = c2, C2 = F2;
            for (; C2 >= 0 && C2 < h2; ) {
              let d2 = c2.charAt(C2);
              if (f2 instanceof RegExp) {
                if (!f2.test(d2))
                  return C2;
              } else if (!f2.includes(d2))
                return C2;
              l2 ? C2-- : C2++;
            }
            return C2 === -1 || C2 === h2 ? C2 : false;
          };
        }
        var n2 = u2(/\s/), D2 = u2(" 	"), s2 = u2(",; 	"), i2 = u2(/[^\n\r]/);
        r2.exports = { skipWhitespace: n2, skipSpaces: D2, skipToLineEnd: s2, skipEverythingButNewLine: i2 };
      } }), _s2 = I2({ "src/utils/text/skip-inline-comment.js"(e25, r2) {
        q2();
        function u2(n2, D2) {
          if (D2 === false)
            return false;
          if (n2.charAt(D2) === "/" && n2.charAt(D2 + 1) === "*") {
            for (let s2 = D2 + 2; s2 < n2.length; ++s2)
              if (n2.charAt(s2) === "*" && n2.charAt(s2 + 1) === "/")
                return s2 + 2;
          }
          return D2;
        }
        r2.exports = u2;
      } }), Ss2 = I2({ "src/utils/text/skip-trailing-comment.js"(e25, r2) {
        q2();
        var { skipEverythingButNewLine: u2 } = zr2();
        function n2(D2, s2) {
          return s2 === false ? false : D2.charAt(s2) === "/" && D2.charAt(s2 + 1) === "/" ? u2(D2, s2) : s2;
        }
        r2.exports = n2;
      } }), ys = I2({ "src/utils/text/skip-newline.js"(e25, r2) {
        q2();
        function u2(n2, D2, s2) {
          let i2 = s2 && s2.backwards;
          if (D2 === false)
            return false;
          let f2 = n2.charAt(D2);
          if (i2) {
            if (n2.charAt(D2 - 1) === "\r" && f2 === `
`)
              return D2 - 2;
            if (f2 === `
` || f2 === "\r" || f2 === "\u2028" || f2 === "\u2029")
              return D2 - 1;
          } else {
            if (f2 === "\r" && n2.charAt(D2 + 1) === `
`)
              return D2 + 2;
            if (f2 === `
` || f2 === "\r" || f2 === "\u2028" || f2 === "\u2029")
              return D2 + 1;
          }
          return D2;
        }
        r2.exports = u2;
      } }), Rl2 = I2({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(e25, r2) {
        q2();
        var u2 = _s2(), n2 = ys(), D2 = Ss2(), { skipSpaces: s2 } = zr2();
        function i2(f2, c2) {
          let F2 = null, a2 = c2;
          for (; a2 !== F2; )
            F2 = a2, a2 = s2(f2, a2), a2 = u2(f2, a2), a2 = D2(f2, a2), a2 = n2(f2, a2);
          return a2;
        }
        r2.exports = i2;
      } }), xl2 = I2({ "src/common/util.js"(e25, r2) {
        q2();
        var { default: u2 } = (cl2(), ds(ms)), n2 = Cs2(), { getSupportInfo: D2 } = vl2(), s2 = _l2(), i2 = Il2(), { skipWhitespace: f2, skipSpaces: c2, skipToLineEnd: F2, skipEverythingButNewLine: a2 } = zr2(), l2 = _s2(), h2 = Ss2(), C2 = ys(), d2 = Rl2(), m2 = (v2) => v2[v2.length - 2];
        function T2(v2) {
          return (y2, B2, b2) => {
            let L2 = b2 && b2.backwards;
            if (B2 === false)
              return false;
            let { length: U2 } = y2, G2 = B2;
            for (; G2 >= 0 && G2 < U2; ) {
              let W3 = y2.charAt(G2);
              if (v2 instanceof RegExp) {
                if (!v2.test(W3))
                  return G2;
              } else if (!v2.includes(W3))
                return G2;
              L2 ? G2-- : G2++;
            }
            return G2 === -1 || G2 === U2 ? G2 : false;
          };
        }
        function w2(v2, y2) {
          let B2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, b2 = c2(v2, B2.backwards ? y2 - 1 : y2, B2), L2 = C2(v2, b2, B2);
          return b2 !== L2;
        }
        function g2(v2, y2, B2) {
          for (let b2 = y2; b2 < B2; ++b2)
            if (v2.charAt(b2) === `
`)
              return true;
          return false;
        }
        function N2(v2, y2, B2) {
          let b2 = B2(y2) - 1;
          b2 = c2(v2, b2, { backwards: true }), b2 = C2(v2, b2, { backwards: true }), b2 = c2(v2, b2, { backwards: true });
          let L2 = C2(v2, b2, { backwards: true });
          return b2 !== L2;
        }
        function R2(v2, y2) {
          let B2 = null, b2 = y2;
          for (; b2 !== B2; )
            B2 = b2, b2 = F2(v2, b2), b2 = l2(v2, b2), b2 = c2(v2, b2);
          return b2 = h2(v2, b2), b2 = C2(v2, b2), b2 !== false && w2(v2, b2);
        }
        function j2(v2, y2, B2) {
          return R2(v2, B2(y2));
        }
        function _2(v2, y2, B2) {
          return d2(v2, B2(y2));
        }
        function O2(v2, y2, B2) {
          return v2.charAt(_2(v2, y2, B2));
        }
        function x2(v2, y2) {
          let B2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return c2(v2, B2.backwards ? y2 - 1 : y2, B2) !== y2;
        }
        function k2(v2, y2) {
          let B2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, b2 = 0;
          for (let L2 = B2; L2 < v2.length; ++L2)
            v2[L2] === "	" ? b2 = b2 + y2 - b2 % y2 : b2++;
          return b2;
        }
        function $2(v2, y2) {
          let B2 = v2.lastIndexOf(`
`);
          return B2 === -1 ? 0 : k2(v2.slice(B2 + 1).match(/^[\t ]*/)[0], y2);
        }
        function t2(v2, y2) {
          let B2 = { quote: '"', regex: /"/g, escaped: "&quot;" }, b2 = { quote: "'", regex: /'/g, escaped: "&apos;" }, L2 = y2 === "'" ? b2 : B2, U2 = L2 === b2 ? B2 : b2, G2 = L2;
          if (v2.includes(L2.quote) || v2.includes(U2.quote)) {
            let W3 = (v2.match(L2.regex) || []).length, ne2 = (v2.match(U2.regex) || []).length;
            G2 = W3 > ne2 ? U2 : L2;
          }
          return G2;
        }
        function o2(v2, y2) {
          let B2 = v2.slice(1, -1), b2 = y2.parser === "json" || y2.parser === "json5" && y2.quoteProps === "preserve" && !y2.singleQuote ? '"' : y2.__isInHtmlAttribute ? "'" : t2(B2, y2.singleQuote ? "'" : '"').quote;
          return E2(B2, b2, !(y2.parser === "css" || y2.parser === "less" || y2.parser === "scss" || y2.__embeddedInHtml));
        }
        function E2(v2, y2, B2) {
          let b2 = y2 === '"' ? "'" : '"', L2 = /\\(.)|(["'])/gs, U2 = v2.replace(L2, (G2, W3, ne2) => W3 === b2 ? W3 : ne2 === y2 ? "\\" + ne2 : ne2 || (B2 && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(W3) ? W3 : "\\" + W3));
          return y2 + U2 + y2;
        }
        function p2(v2) {
          return v2.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
        }
        function A2(v2, y2) {
          let B2 = v2.match(new RegExp(`(${u2(y2)})+`, "g"));
          return B2 === null ? 0 : B2.reduce((b2, L2) => Math.max(b2, L2.length / y2.length), 0);
        }
        function P2(v2, y2) {
          let B2 = v2.match(new RegExp(`(${u2(y2)})+`, "g"));
          if (B2 === null)
            return 0;
          let b2 = new Map(), L2 = 0;
          for (let U2 of B2) {
            let G2 = U2.length / y2.length;
            b2.set(G2, true), G2 > L2 && (L2 = G2);
          }
          for (let U2 = 1; U2 < L2; U2++)
            if (!b2.get(U2))
              return U2;
          return L2 + 1;
        }
        function M2(v2, y2) {
          (v2.comments || (v2.comments = [])).push(y2), y2.printed = false, y2.nodeDescription = J2(v2);
        }
        function z2(v2, y2) {
          y2.leading = true, y2.trailing = false, M2(v2, y2);
        }
        function V2(v2, y2, B2) {
          y2.leading = false, y2.trailing = false, B2 && (y2.marker = B2), M2(v2, y2);
        }
        function X2(v2, y2) {
          y2.leading = false, y2.trailing = true, M2(v2, y2);
        }
        function H2(v2, y2) {
          let { languages: B2 } = D2({ plugins: y2.plugins }), b2 = B2.find((L2) => {
            let { name: U2 } = L2;
            return U2.toLowerCase() === v2;
          }) || B2.find((L2) => {
            let { aliases: U2 } = L2;
            return Array.isArray(U2) && U2.includes(v2);
          }) || B2.find((L2) => {
            let { extensions: U2 } = L2;
            return Array.isArray(U2) && U2.includes(`.${v2}`);
          });
          return b2 && b2.parsers[0];
        }
        function Q2(v2) {
          return v2 && v2.type === "front-matter";
        }
        function K2(v2) {
          let y2 = new WeakMap();
          return function(B2) {
            return y2.has(B2) || y2.set(B2, Symbol(v2)), y2.get(B2);
          };
        }
        function J2(v2) {
          let y2 = v2.type || v2.kind || "(unknown type)", B2 = String(v2.name || v2.id && (typeof v2.id == "object" ? v2.id.name : v2.id) || v2.key && (typeof v2.key == "object" ? v2.key.name : v2.key) || v2.value && (typeof v2.value == "object" ? "" : String(v2.value)) || v2.operator || "");
          return B2.length > 20 && (B2 = B2.slice(0, 19) + "\u2026"), y2 + (B2 ? " " + B2 : "");
        }
        r2.exports = { inferParserByLanguage: H2, getStringWidth: i2, getMaxContinuousCount: A2, getMinNotPresentContinuousCount: P2, getPenultimate: m2, getLast: n2, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: d2, getNextNonSpaceNonCommentCharacterIndex: _2, getNextNonSpaceNonCommentCharacter: O2, skip: T2, skipWhitespace: f2, skipSpaces: c2, skipToLineEnd: F2, skipEverythingButNewLine: a2, skipInlineComment: l2, skipTrailingComment: h2, skipNewline: C2, isNextLineEmptyAfterIndex: R2, isNextLineEmpty: j2, isPreviousLineEmpty: N2, hasNewline: w2, hasNewlineInRange: g2, hasSpaces: x2, getAlignmentSize: k2, getIndentSize: $2, getPreferredQuote: t2, printString: o2, printNumber: p2, makeString: E2, addLeadingComment: z2, addDanglingComment: V2, addTrailingComment: X2, isFrontMatterNode: Q2, isNonEmptyArray: s2, createGroupIdMapper: K2 };
      } }), Pl2 = I2({ "vendors/html-tag-names.json"(e25, r2) {
        r2.exports = { htmlTagNames: ["a", "abbr", "acronym", "address", "applet", "area", "article", "aside", "audio", "b", "base", "basefont", "bdi", "bdo", "bgsound", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "command", "content", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "embed", "fieldset", "figcaption", "figure", "font", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "image", "img", "input", "ins", "isindex", "kbd", "keygen", "label", "legend", "li", "link", "listing", "main", "map", "mark", "marquee", "math", "menu", "menuitem", "meta", "meter", "multicol", "nav", "nextid", "nobr", "noembed", "noframes", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "plaintext", "pre", "progress", "q", "rb", "rbc", "rp", "rt", "rtc", "ruby", "s", "samp", "script", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "svg", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "tt", "u", "ul", "var", "video", "wbr", "xmp"] };
      } }), Ts2 = I2({ "src/language-html/utils/array-to-map.js"(e25, r2) {
        q2();
        function u2(n2) {
          let D2 = Object.create(null);
          for (let s2 of n2)
            D2[s2] = true;
          return D2;
        }
        r2.exports = u2;
      } }), kl2 = I2({ "src/language-html/utils/html-tag-names.js"(e25, r2) {
        q2();
        var { htmlTagNames: u2 } = Pl2(), n2 = Ts2(), D2 = n2(u2);
        r2.exports = D2;
      } }), Ll2 = I2({ "vendors/html-element-attributes.json"(e25, r2) {
        r2.exports = { htmlElementAttributes: { "*": ["accesskey", "autocapitalize", "autofocus", "class", "contenteditable", "dir", "draggable", "enterkeyhint", "hidden", "id", "inputmode", "is", "itemid", "itemprop", "itemref", "itemscope", "itemtype", "lang", "nonce", "slot", "spellcheck", "style", "tabindex", "title", "translate"], a: ["charset", "coords", "download", "href", "hreflang", "name", "ping", "referrerpolicy", "rel", "rev", "shape", "target", "type"], applet: ["align", "alt", "archive", "code", "codebase", "height", "hspace", "name", "object", "vspace", "width"], area: ["alt", "coords", "download", "href", "hreflang", "nohref", "ping", "referrerpolicy", "rel", "shape", "target", "type"], audio: ["autoplay", "controls", "crossorigin", "loop", "muted", "preload", "src"], base: ["href", "target"], basefont: ["color", "face", "size"], blockquote: ["cite"], body: ["alink", "background", "bgcolor", "link", "text", "vlink"], br: ["clear"], button: ["disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "name", "type", "value"], canvas: ["height", "width"], caption: ["align"], col: ["align", "char", "charoff", "span", "valign", "width"], colgroup: ["align", "char", "charoff", "span", "valign", "width"], data: ["value"], del: ["cite", "datetime"], details: ["open"], dialog: ["open"], dir: ["compact"], div: ["align"], dl: ["compact"], embed: ["height", "src", "type", "width"], fieldset: ["disabled", "form", "name"], font: ["color", "face", "size"], form: ["accept", "accept-charset", "action", "autocomplete", "enctype", "method", "name", "novalidate", "target"], frame: ["frameborder", "longdesc", "marginheight", "marginwidth", "name", "noresize", "scrolling", "src"], frameset: ["cols", "rows"], h1: ["align"], h2: ["align"], h3: ["align"], h4: ["align"], h5: ["align"], h6: ["align"], head: ["profile"], hr: ["align", "noshade", "size", "width"], html: ["manifest", "version"], iframe: ["align", "allow", "allowfullscreen", "allowpaymentrequest", "allowusermedia", "frameborder", "height", "loading", "longdesc", "marginheight", "marginwidth", "name", "referrerpolicy", "sandbox", "scrolling", "src", "srcdoc", "width"], img: ["align", "alt", "border", "crossorigin", "decoding", "height", "hspace", "ismap", "loading", "longdesc", "name", "referrerpolicy", "sizes", "src", "srcset", "usemap", "vspace", "width"], input: ["accept", "align", "alt", "autocomplete", "checked", "dirname", "disabled", "form", "formaction", "formenctype", "formmethod", "formnovalidate", "formtarget", "height", "ismap", "list", "max", "maxlength", "min", "minlength", "multiple", "name", "pattern", "placeholder", "readonly", "required", "size", "src", "step", "type", "usemap", "value", "width"], ins: ["cite", "datetime"], isindex: ["prompt"], label: ["for", "form"], legend: ["align"], li: ["type", "value"], link: ["as", "charset", "color", "crossorigin", "disabled", "href", "hreflang", "imagesizes", "imagesrcset", "integrity", "media", "referrerpolicy", "rel", "rev", "sizes", "target", "type"], map: ["name"], menu: ["compact"], meta: ["charset", "content", "http-equiv", "media", "name", "scheme"], meter: ["high", "low", "max", "min", "optimum", "value"], object: ["align", "archive", "border", "classid", "codebase", "codetype", "data", "declare", "form", "height", "hspace", "name", "standby", "type", "typemustmatch", "usemap", "vspace", "width"], ol: ["compact", "reversed", "start", "type"], optgroup: ["disabled", "label"], option: ["disabled", "label", "selected", "value"], output: ["for", "form", "name"], p: ["align"], param: ["name", "type", "value", "valuetype"], pre: ["width"], progress: ["max", "value"], q: ["cite"], script: ["async", "charset", "crossorigin", "defer", "integrity", "language", "nomodule", "referrerpolicy", "src", "type"], select: ["autocomplete", "disabled", "form", "multiple", "name", "required", "size"], slot: ["name"], source: ["height", "media", "sizes", "src", "srcset", "type", "width"], style: ["media", "type"], table: ["align", "bgcolor", "border", "cellpadding", "cellspacing", "frame", "rules", "summary", "width"], tbody: ["align", "char", "charoff", "valign"], td: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"], textarea: ["autocomplete", "cols", "dirname", "disabled", "form", "maxlength", "minlength", "name", "placeholder", "readonly", "required", "rows", "wrap"], tfoot: ["align", "char", "charoff", "valign"], th: ["abbr", "align", "axis", "bgcolor", "char", "charoff", "colspan", "headers", "height", "nowrap", "rowspan", "scope", "valign", "width"], thead: ["align", "char", "charoff", "valign"], time: ["datetime"], tr: ["align", "bgcolor", "char", "charoff", "valign"], track: ["default", "kind", "label", "src", "srclang"], ul: ["compact", "type"], video: ["autoplay", "controls", "crossorigin", "height", "loop", "muted", "playsinline", "poster", "preload", "src", "width"] } };
      } }), $l2 = I2({ "src/language-html/utils/map-object.js"(e25, r2) {
        q2();
        function u2(n2, D2) {
          let s2 = Object.create(null);
          for (let [i2, f2] of Object.entries(n2))
            s2[i2] = D2(f2, i2);
          return s2;
        }
        r2.exports = u2;
      } }), Ml2 = I2({ "src/language-html/utils/html-elements-attributes.js"(e25, r2) {
        q2();
        var { htmlElementAttributes: u2 } = Ll2(), n2 = $l2(), D2 = Ts2(), s2 = n2(u2, D2);
        r2.exports = s2;
      } }), jl2 = I2({ "src/language-html/utils/is-unknown-namespace.js"(e25, r2) {
        q2();
        function u2(n2) {
          return n2.type === "element" && !n2.hasExplicitNamespace && !["html", "svg"].includes(n2.namespace);
        }
        r2.exports = u2;
      } }), Ul2 = I2({ "src/language-html/pragma.js"(e25, r2) {
        q2();
        function u2(D2) {
          return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(D2);
        }
        function n2(D2) {
          return `<!-- @format -->

` + D2.replace(/^\s*\n/, "");
        }
        r2.exports = { hasPragma: u2, insertPragma: n2 };
      } }), Gl2 = I2({ "src/language-html/ast.js"(e25, r2) {
        q2();
        var u2 = { attrs: true, children: true }, n2 = new Set(["parent"]), D2 = class {
          constructor() {
            let i2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            for (let f2 of new Set([...n2, ...Object.keys(i2)]))
              this.setProperty(f2, i2[f2]);
          }
          setProperty(i2, f2) {
            if (this[i2] !== f2) {
              if (i2 in u2 && (f2 = f2.map((c2) => this.createChild(c2))), !n2.has(i2)) {
                this[i2] = f2;
                return;
              }
              Object.defineProperty(this, i2, { value: f2, enumerable: false, configurable: true });
            }
          }
          map(i2) {
            let f2;
            for (let c2 in u2) {
              let F2 = this[c2];
              if (F2) {
                let a2 = s2(F2, (l2) => l2.map(i2));
                f2 !== F2 && (f2 || (f2 = new D2({ parent: this.parent })), f2.setProperty(c2, a2));
              }
            }
            if (f2)
              for (let c2 in this)
                c2 in u2 || (f2[c2] = this[c2]);
            return i2(f2 || this);
          }
          walk(i2) {
            for (let f2 in u2) {
              let c2 = this[f2];
              if (c2)
                for (let F2 = 0; F2 < c2.length; F2++)
                  c2[F2].walk(i2);
            }
            i2(this);
          }
          createChild(i2) {
            let f2 = i2 instanceof D2 ? i2.clone() : new D2(i2);
            return f2.setProperty("parent", this), f2;
          }
          insertChildBefore(i2, f2) {
            this.children.splice(this.children.indexOf(i2), 0, this.createChild(f2));
          }
          removeChild(i2) {
            this.children.splice(this.children.indexOf(i2), 1);
          }
          replaceChild(i2, f2) {
            this.children[this.children.indexOf(i2)] = this.createChild(f2);
          }
          clone() {
            return new D2(this);
          }
          get firstChild() {
            var i2;
            return (i2 = this.children) === null || i2 === void 0 ? void 0 : i2[0];
          }
          get lastChild() {
            var i2;
            return (i2 = this.children) === null || i2 === void 0 ? void 0 : i2[this.children.length - 1];
          }
          get prev() {
            var i2;
            return (i2 = this.parent) === null || i2 === void 0 ? void 0 : i2.children[this.parent.children.indexOf(this) - 1];
          }
          get next() {
            var i2;
            return (i2 = this.parent) === null || i2 === void 0 ? void 0 : i2.children[this.parent.children.indexOf(this) + 1];
          }
          get rawName() {
            return this.hasExplicitNamespace ? this.fullName : this.name;
          }
          get fullName() {
            return this.namespace ? this.namespace + ":" + this.name : this.name;
          }
          get attrMap() {
            return Object.fromEntries(this.attrs.map((i2) => [i2.fullName, i2.value]));
          }
        };
        function s2(i2, f2) {
          let c2 = i2.map(f2);
          return c2.some((F2, a2) => F2 !== i2[a2]) ? c2 : i2;
        }
        r2.exports = { Node: D2 };
      } }), Vl2 = I2({ "src/language-html/conditional-comment.js"(e25, r2) {
        q2();
        var { ParseSourceSpan: u2 } = Be2(), n2 = [{ regex: /^(\[if([^\]]*)]>)(.*?)<!\s*\[endif]$/s, parse: s2 }, { regex: /^\[if([^\]]*)]><!$/, parse: i2 }, { regex: /^<!\s*\[endif]$/, parse: f2 }];
        function D2(c2, F2) {
          if (c2.value)
            for (let { regex: a2, parse: l2 } of n2) {
              let h2 = c2.value.match(a2);
              if (h2)
                return l2(c2, F2, h2);
            }
          return null;
        }
        function s2(c2, F2, a2) {
          let [, l2, h2, C2] = a2, d2 = 4 + l2.length, m2 = c2.sourceSpan.start.moveBy(d2), T2 = m2.moveBy(C2.length), [w2, g2] = (() => {
            try {
              return [true, F2(C2, m2).children];
            } catch {
              return [false, [{ type: "text", value: C2, sourceSpan: new u2(m2, T2) }]];
            }
          })();
          return { type: "ieConditionalComment", complete: w2, children: g2, condition: h2.trim().replace(/\s+/g, " "), sourceSpan: c2.sourceSpan, startSourceSpan: new u2(c2.sourceSpan.start, m2), endSourceSpan: new u2(T2, c2.sourceSpan.end) };
        }
        function i2(c2, F2, a2) {
          let [, l2] = a2;
          return { type: "ieConditionalStartComment", condition: l2.trim().replace(/\s+/g, " "), sourceSpan: c2.sourceSpan };
        }
        function f2(c2) {
          return { type: "ieConditionalEndComment", sourceSpan: c2.sourceSpan };
        }
        r2.exports = { parseIeConditionalComment: D2 };
      } }), Xl2 = I2({ "src/language-html/loc.js"(e25, r2) {
        q2();
        function u2(D2) {
          return D2.sourceSpan.start.offset;
        }
        function n2(D2) {
          return D2.sourceSpan.end.offset;
        }
        r2.exports = { locStart: u2, locEnd: n2 };
      } }), Ze2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/tags.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        (function(c2) {
          c2[c2.RAW_TEXT = 0] = "RAW_TEXT", c2[c2.ESCAPABLE_RAW_TEXT = 1] = "ESCAPABLE_RAW_TEXT", c2[c2.PARSABLE_DATA = 2] = "PARSABLE_DATA";
        })(e25.TagContentType || (e25.TagContentType = {}));
        function u2(c2) {
          if (c2[0] != ":")
            return [null, c2];
          let F2 = c2.indexOf(":", 1);
          if (F2 == -1)
            throw new Error(`Unsupported format "${c2}" expecting ":namespace:name"`);
          return [c2.slice(1, F2), c2.slice(F2 + 1)];
        }
        e25.splitNsName = u2;
        function n2(c2) {
          return u2(c2)[1] === "ng-container";
        }
        e25.isNgContainer = n2;
        function D2(c2) {
          return u2(c2)[1] === "ng-content";
        }
        e25.isNgContent = D2;
        function s2(c2) {
          return u2(c2)[1] === "ng-template";
        }
        e25.isNgTemplate = s2;
        function i2(c2) {
          return c2 === null ? null : u2(c2)[0];
        }
        e25.getNsPrefix = i2;
        function f2(c2, F2) {
          return c2 ? `:${c2}:${F2}` : F2;
        }
        e25.mergeNsAndName = f2, e25.NAMED_ENTITIES = { Aacute: "\xC1", aacute: "\xE1", Abreve: "\u0102", abreve: "\u0103", ac: "\u223E", acd: "\u223F", acE: "\u223E\u0333", Acirc: "\xC2", acirc: "\xE2", acute: "\xB4", Acy: "\u0410", acy: "\u0430", AElig: "\xC6", aelig: "\xE6", af: "\u2061", Afr: "\u{1D504}", afr: "\u{1D51E}", Agrave: "\xC0", agrave: "\xE0", alefsym: "\u2135", aleph: "\u2135", Alpha: "\u0391", alpha: "\u03B1", Amacr: "\u0100", amacr: "\u0101", amalg: "\u2A3F", AMP: "&", amp: "&", And: "\u2A53", and: "\u2227", andand: "\u2A55", andd: "\u2A5C", andslope: "\u2A58", andv: "\u2A5A", ang: "\u2220", ange: "\u29A4", angle: "\u2220", angmsd: "\u2221", angmsdaa: "\u29A8", angmsdab: "\u29A9", angmsdac: "\u29AA", angmsdad: "\u29AB", angmsdae: "\u29AC", angmsdaf: "\u29AD", angmsdag: "\u29AE", angmsdah: "\u29AF", angrt: "\u221F", angrtvb: "\u22BE", angrtvbd: "\u299D", angsph: "\u2222", angst: "\xC5", angzarr: "\u237C", Aogon: "\u0104", aogon: "\u0105", Aopf: "\u{1D538}", aopf: "\u{1D552}", ap: "\u2248", apacir: "\u2A6F", apE: "\u2A70", ape: "\u224A", apid: "\u224B", apos: "'", ApplyFunction: "\u2061", approx: "\u2248", approxeq: "\u224A", Aring: "\xC5", aring: "\xE5", Ascr: "\u{1D49C}", ascr: "\u{1D4B6}", Assign: "\u2254", ast: "*", asymp: "\u2248", asympeq: "\u224D", Atilde: "\xC3", atilde: "\xE3", Auml: "\xC4", auml: "\xE4", awconint: "\u2233", awint: "\u2A11", backcong: "\u224C", backepsilon: "\u03F6", backprime: "\u2035", backsim: "\u223D", backsimeq: "\u22CD", Backslash: "\u2216", Barv: "\u2AE7", barvee: "\u22BD", Barwed: "\u2306", barwed: "\u2305", barwedge: "\u2305", bbrk: "\u23B5", bbrktbrk: "\u23B6", bcong: "\u224C", Bcy: "\u0411", bcy: "\u0431", bdquo: "\u201E", becaus: "\u2235", Because: "\u2235", because: "\u2235", bemptyv: "\u29B0", bepsi: "\u03F6", bernou: "\u212C", Bernoullis: "\u212C", Beta: "\u0392", beta: "\u03B2", beth: "\u2136", between: "\u226C", Bfr: "\u{1D505}", bfr: "\u{1D51F}", bigcap: "\u22C2", bigcirc: "\u25EF", bigcup: "\u22C3", bigodot: "\u2A00", bigoplus: "\u2A01", bigotimes: "\u2A02", bigsqcup: "\u2A06", bigstar: "\u2605", bigtriangledown: "\u25BD", bigtriangleup: "\u25B3", biguplus: "\u2A04", bigvee: "\u22C1", bigwedge: "\u22C0", bkarow: "\u290D", blacklozenge: "\u29EB", blacksquare: "\u25AA", blacktriangle: "\u25B4", blacktriangledown: "\u25BE", blacktriangleleft: "\u25C2", blacktriangleright: "\u25B8", blank: "\u2423", blk12: "\u2592", blk14: "\u2591", blk34: "\u2593", block: "\u2588", bne: "=\u20E5", bnequiv: "\u2261\u20E5", bNot: "\u2AED", bnot: "\u2310", Bopf: "\u{1D539}", bopf: "\u{1D553}", bot: "\u22A5", bottom: "\u22A5", bowtie: "\u22C8", boxbox: "\u29C9", boxDL: "\u2557", boxDl: "\u2556", boxdL: "\u2555", boxdl: "\u2510", boxDR: "\u2554", boxDr: "\u2553", boxdR: "\u2552", boxdr: "\u250C", boxH: "\u2550", boxh: "\u2500", boxHD: "\u2566", boxHd: "\u2564", boxhD: "\u2565", boxhd: "\u252C", boxHU: "\u2569", boxHu: "\u2567", boxhU: "\u2568", boxhu: "\u2534", boxminus: "\u229F", boxplus: "\u229E", boxtimes: "\u22A0", boxUL: "\u255D", boxUl: "\u255C", boxuL: "\u255B", boxul: "\u2518", boxUR: "\u255A", boxUr: "\u2559", boxuR: "\u2558", boxur: "\u2514", boxV: "\u2551", boxv: "\u2502", boxVH: "\u256C", boxVh: "\u256B", boxvH: "\u256A", boxvh: "\u253C", boxVL: "\u2563", boxVl: "\u2562", boxvL: "\u2561", boxvl: "\u2524", boxVR: "\u2560", boxVr: "\u255F", boxvR: "\u255E", boxvr: "\u251C", bprime: "\u2035", Breve: "\u02D8", breve: "\u02D8", brvbar: "\xA6", Bscr: "\u212C", bscr: "\u{1D4B7}", bsemi: "\u204F", bsim: "\u223D", bsime: "\u22CD", bsol: "\\", bsolb: "\u29C5", bsolhsub: "\u27C8", bull: "\u2022", bullet: "\u2022", bump: "\u224E", bumpE: "\u2AAE", bumpe: "\u224F", Bumpeq: "\u224E", bumpeq: "\u224F", Cacute: "\u0106", cacute: "\u0107", Cap: "\u22D2", cap: "\u2229", capand: "\u2A44", capbrcup: "\u2A49", capcap: "\u2A4B", capcup: "\u2A47", capdot: "\u2A40", CapitalDifferentialD: "\u2145", caps: "\u2229\uFE00", caret: "\u2041", caron: "\u02C7", Cayleys: "\u212D", ccaps: "\u2A4D", Ccaron: "\u010C", ccaron: "\u010D", Ccedil: "\xC7", ccedil: "\xE7", Ccirc: "\u0108", ccirc: "\u0109", Cconint: "\u2230", ccups: "\u2A4C", ccupssm: "\u2A50", Cdot: "\u010A", cdot: "\u010B", cedil: "\xB8", Cedilla: "\xB8", cemptyv: "\u29B2", cent: "\xA2", CenterDot: "\xB7", centerdot: "\xB7", Cfr: "\u212D", cfr: "\u{1D520}", CHcy: "\u0427", chcy: "\u0447", check: "\u2713", checkmark: "\u2713", Chi: "\u03A7", chi: "\u03C7", cir: "\u25CB", circ: "\u02C6", circeq: "\u2257", circlearrowleft: "\u21BA", circlearrowright: "\u21BB", circledast: "\u229B", circledcirc: "\u229A", circleddash: "\u229D", CircleDot: "\u2299", circledR: "\xAE", circledS: "\u24C8", CircleMinus: "\u2296", CirclePlus: "\u2295", CircleTimes: "\u2297", cirE: "\u29C3", cire: "\u2257", cirfnint: "\u2A10", cirmid: "\u2AEF", cirscir: "\u29C2", ClockwiseContourIntegral: "\u2232", CloseCurlyDoubleQuote: "\u201D", CloseCurlyQuote: "\u2019", clubs: "\u2663", clubsuit: "\u2663", Colon: "\u2237", colon: ":", Colone: "\u2A74", colone: "\u2254", coloneq: "\u2254", comma: ",", commat: "@", comp: "\u2201", compfn: "\u2218", complement: "\u2201", complexes: "\u2102", cong: "\u2245", congdot: "\u2A6D", Congruent: "\u2261", Conint: "\u222F", conint: "\u222E", ContourIntegral: "\u222E", Copf: "\u2102", copf: "\u{1D554}", coprod: "\u2210", Coproduct: "\u2210", COPY: "\xA9", copy: "\xA9", copysr: "\u2117", CounterClockwiseContourIntegral: "\u2233", crarr: "\u21B5", Cross: "\u2A2F", cross: "\u2717", Cscr: "\u{1D49E}", cscr: "\u{1D4B8}", csub: "\u2ACF", csube: "\u2AD1", csup: "\u2AD0", csupe: "\u2AD2", ctdot: "\u22EF", cudarrl: "\u2938", cudarrr: "\u2935", cuepr: "\u22DE", cuesc: "\u22DF", cularr: "\u21B6", cularrp: "\u293D", Cup: "\u22D3", cup: "\u222A", cupbrcap: "\u2A48", CupCap: "\u224D", cupcap: "\u2A46", cupcup: "\u2A4A", cupdot: "\u228D", cupor: "\u2A45", cups: "\u222A\uFE00", curarr: "\u21B7", curarrm: "\u293C", curlyeqprec: "\u22DE", curlyeqsucc: "\u22DF", curlyvee: "\u22CE", curlywedge: "\u22CF", curren: "\xA4", curvearrowleft: "\u21B6", curvearrowright: "\u21B7", cuvee: "\u22CE", cuwed: "\u22CF", cwconint: "\u2232", cwint: "\u2231", cylcty: "\u232D", Dagger: "\u2021", dagger: "\u2020", daleth: "\u2138", Darr: "\u21A1", dArr: "\u21D3", darr: "\u2193", dash: "\u2010", Dashv: "\u2AE4", dashv: "\u22A3", dbkarow: "\u290F", dblac: "\u02DD", Dcaron: "\u010E", dcaron: "\u010F", Dcy: "\u0414", dcy: "\u0434", DD: "\u2145", dd: "\u2146", ddagger: "\u2021", ddarr: "\u21CA", DDotrahd: "\u2911", ddotseq: "\u2A77", deg: "\xB0", Del: "\u2207", Delta: "\u0394", delta: "\u03B4", demptyv: "\u29B1", dfisht: "\u297F", Dfr: "\u{1D507}", dfr: "\u{1D521}", dHar: "\u2965", dharl: "\u21C3", dharr: "\u21C2", DiacriticalAcute: "\xB4", DiacriticalDot: "\u02D9", DiacriticalDoubleAcute: "\u02DD", DiacriticalGrave: "`", DiacriticalTilde: "\u02DC", diam: "\u22C4", Diamond: "\u22C4", diamond: "\u22C4", diamondsuit: "\u2666", diams: "\u2666", die: "\xA8", DifferentialD: "\u2146", digamma: "\u03DD", disin: "\u22F2", div: "\xF7", divide: "\xF7", divideontimes: "\u22C7", divonx: "\u22C7", DJcy: "\u0402", djcy: "\u0452", dlcorn: "\u231E", dlcrop: "\u230D", dollar: "$", Dopf: "\u{1D53B}", dopf: "\u{1D555}", Dot: "\xA8", dot: "\u02D9", DotDot: "\u20DC", doteq: "\u2250", doteqdot: "\u2251", DotEqual: "\u2250", dotminus: "\u2238", dotplus: "\u2214", dotsquare: "\u22A1", doublebarwedge: "\u2306", DoubleContourIntegral: "\u222F", DoubleDot: "\xA8", DoubleDownArrow: "\u21D3", DoubleLeftArrow: "\u21D0", DoubleLeftRightArrow: "\u21D4", DoubleLeftTee: "\u2AE4", DoubleLongLeftArrow: "\u27F8", DoubleLongLeftRightArrow: "\u27FA", DoubleLongRightArrow: "\u27F9", DoubleRightArrow: "\u21D2", DoubleRightTee: "\u22A8", DoubleUpArrow: "\u21D1", DoubleUpDownArrow: "\u21D5", DoubleVerticalBar: "\u2225", DownArrow: "\u2193", Downarrow: "\u21D3", downarrow: "\u2193", DownArrowBar: "\u2913", DownArrowUpArrow: "\u21F5", DownBreve: "\u0311", downdownarrows: "\u21CA", downharpoonleft: "\u21C3", downharpoonright: "\u21C2", DownLeftRightVector: "\u2950", DownLeftTeeVector: "\u295E", DownLeftVector: "\u21BD", DownLeftVectorBar: "\u2956", DownRightTeeVector: "\u295F", DownRightVector: "\u21C1", DownRightVectorBar: "\u2957", DownTee: "\u22A4", DownTeeArrow: "\u21A7", drbkarow: "\u2910", drcorn: "\u231F", drcrop: "\u230C", Dscr: "\u{1D49F}", dscr: "\u{1D4B9}", DScy: "\u0405", dscy: "\u0455", dsol: "\u29F6", Dstrok: "\u0110", dstrok: "\u0111", dtdot: "\u22F1", dtri: "\u25BF", dtrif: "\u25BE", duarr: "\u21F5", duhar: "\u296F", dwangle: "\u29A6", DZcy: "\u040F", dzcy: "\u045F", dzigrarr: "\u27FF", Eacute: "\xC9", eacute: "\xE9", easter: "\u2A6E", Ecaron: "\u011A", ecaron: "\u011B", ecir: "\u2256", Ecirc: "\xCA", ecirc: "\xEA", ecolon: "\u2255", Ecy: "\u042D", ecy: "\u044D", eDDot: "\u2A77", Edot: "\u0116", eDot: "\u2251", edot: "\u0117", ee: "\u2147", efDot: "\u2252", Efr: "\u{1D508}", efr: "\u{1D522}", eg: "\u2A9A", Egrave: "\xC8", egrave: "\xE8", egs: "\u2A96", egsdot: "\u2A98", el: "\u2A99", Element: "\u2208", elinters: "\u23E7", ell: "\u2113", els: "\u2A95", elsdot: "\u2A97", Emacr: "\u0112", emacr: "\u0113", empty: "\u2205", emptyset: "\u2205", EmptySmallSquare: "\u25FB", emptyv: "\u2205", EmptyVerySmallSquare: "\u25AB", emsp: "\u2003", emsp13: "\u2004", emsp14: "\u2005", ENG: "\u014A", eng: "\u014B", ensp: "\u2002", Eogon: "\u0118", eogon: "\u0119", Eopf: "\u{1D53C}", eopf: "\u{1D556}", epar: "\u22D5", eparsl: "\u29E3", eplus: "\u2A71", epsi: "\u03B5", Epsilon: "\u0395", epsilon: "\u03B5", epsiv: "\u03F5", eqcirc: "\u2256", eqcolon: "\u2255", eqsim: "\u2242", eqslantgtr: "\u2A96", eqslantless: "\u2A95", Equal: "\u2A75", equals: "=", EqualTilde: "\u2242", equest: "\u225F", Equilibrium: "\u21CC", equiv: "\u2261", equivDD: "\u2A78", eqvparsl: "\u29E5", erarr: "\u2971", erDot: "\u2253", Escr: "\u2130", escr: "\u212F", esdot: "\u2250", Esim: "\u2A73", esim: "\u2242", Eta: "\u0397", eta: "\u03B7", ETH: "\xD0", eth: "\xF0", Euml: "\xCB", euml: "\xEB", euro: "\u20AC", excl: "!", exist: "\u2203", Exists: "\u2203", expectation: "\u2130", ExponentialE: "\u2147", exponentiale: "\u2147", fallingdotseq: "\u2252", Fcy: "\u0424", fcy: "\u0444", female: "\u2640", ffilig: "\uFB03", fflig: "\uFB00", ffllig: "\uFB04", Ffr: "\u{1D509}", ffr: "\u{1D523}", filig: "\uFB01", FilledSmallSquare: "\u25FC", FilledVerySmallSquare: "\u25AA", fjlig: "fj", flat: "\u266D", fllig: "\uFB02", fltns: "\u25B1", fnof: "\u0192", Fopf: "\u{1D53D}", fopf: "\u{1D557}", ForAll: "\u2200", forall: "\u2200", fork: "\u22D4", forkv: "\u2AD9", Fouriertrf: "\u2131", fpartint: "\u2A0D", frac12: "\xBD", frac13: "\u2153", frac14: "\xBC", frac15: "\u2155", frac16: "\u2159", frac18: "\u215B", frac23: "\u2154", frac25: "\u2156", frac34: "\xBE", frac35: "\u2157", frac38: "\u215C", frac45: "\u2158", frac56: "\u215A", frac58: "\u215D", frac78: "\u215E", frasl: "\u2044", frown: "\u2322", Fscr: "\u2131", fscr: "\u{1D4BB}", gacute: "\u01F5", Gamma: "\u0393", gamma: "\u03B3", Gammad: "\u03DC", gammad: "\u03DD", gap: "\u2A86", Gbreve: "\u011E", gbreve: "\u011F", Gcedil: "\u0122", Gcirc: "\u011C", gcirc: "\u011D", Gcy: "\u0413", gcy: "\u0433", Gdot: "\u0120", gdot: "\u0121", gE: "\u2267", ge: "\u2265", gEl: "\u2A8C", gel: "\u22DB", geq: "\u2265", geqq: "\u2267", geqslant: "\u2A7E", ges: "\u2A7E", gescc: "\u2AA9", gesdot: "\u2A80", gesdoto: "\u2A82", gesdotol: "\u2A84", gesl: "\u22DB\uFE00", gesles: "\u2A94", Gfr: "\u{1D50A}", gfr: "\u{1D524}", Gg: "\u22D9", gg: "\u226B", ggg: "\u22D9", gimel: "\u2137", GJcy: "\u0403", gjcy: "\u0453", gl: "\u2277", gla: "\u2AA5", glE: "\u2A92", glj: "\u2AA4", gnap: "\u2A8A", gnapprox: "\u2A8A", gnE: "\u2269", gne: "\u2A88", gneq: "\u2A88", gneqq: "\u2269", gnsim: "\u22E7", Gopf: "\u{1D53E}", gopf: "\u{1D558}", grave: "`", GreaterEqual: "\u2265", GreaterEqualLess: "\u22DB", GreaterFullEqual: "\u2267", GreaterGreater: "\u2AA2", GreaterLess: "\u2277", GreaterSlantEqual: "\u2A7E", GreaterTilde: "\u2273", Gscr: "\u{1D4A2}", gscr: "\u210A", gsim: "\u2273", gsime: "\u2A8E", gsiml: "\u2A90", GT: ">", Gt: "\u226B", gt: ">", gtcc: "\u2AA7", gtcir: "\u2A7A", gtdot: "\u22D7", gtlPar: "\u2995", gtquest: "\u2A7C", gtrapprox: "\u2A86", gtrarr: "\u2978", gtrdot: "\u22D7", gtreqless: "\u22DB", gtreqqless: "\u2A8C", gtrless: "\u2277", gtrsim: "\u2273", gvertneqq: "\u2269\uFE00", gvnE: "\u2269\uFE00", Hacek: "\u02C7", hairsp: "\u200A", half: "\xBD", hamilt: "\u210B", HARDcy: "\u042A", hardcy: "\u044A", hArr: "\u21D4", harr: "\u2194", harrcir: "\u2948", harrw: "\u21AD", Hat: "^", hbar: "\u210F", Hcirc: "\u0124", hcirc: "\u0125", hearts: "\u2665", heartsuit: "\u2665", hellip: "\u2026", hercon: "\u22B9", Hfr: "\u210C", hfr: "\u{1D525}", HilbertSpace: "\u210B", hksearow: "\u2925", hkswarow: "\u2926", hoarr: "\u21FF", homtht: "\u223B", hookleftarrow: "\u21A9", hookrightarrow: "\u21AA", Hopf: "\u210D", hopf: "\u{1D559}", horbar: "\u2015", HorizontalLine: "\u2500", Hscr: "\u210B", hscr: "\u{1D4BD}", hslash: "\u210F", Hstrok: "\u0126", hstrok: "\u0127", HumpDownHump: "\u224E", HumpEqual: "\u224F", hybull: "\u2043", hyphen: "\u2010", Iacute: "\xCD", iacute: "\xED", ic: "\u2063", Icirc: "\xCE", icirc: "\xEE", Icy: "\u0418", icy: "\u0438", Idot: "\u0130", IEcy: "\u0415", iecy: "\u0435", iexcl: "\xA1", iff: "\u21D4", Ifr: "\u2111", ifr: "\u{1D526}", Igrave: "\xCC", igrave: "\xEC", ii: "\u2148", iiiint: "\u2A0C", iiint: "\u222D", iinfin: "\u29DC", iiota: "\u2129", IJlig: "\u0132", ijlig: "\u0133", Im: "\u2111", Imacr: "\u012A", imacr: "\u012B", image: "\u2111", ImaginaryI: "\u2148", imagline: "\u2110", imagpart: "\u2111", imath: "\u0131", imof: "\u22B7", imped: "\u01B5", Implies: "\u21D2", in: "\u2208", incare: "\u2105", infin: "\u221E", infintie: "\u29DD", inodot: "\u0131", Int: "\u222C", int: "\u222B", intcal: "\u22BA", integers: "\u2124", Integral: "\u222B", intercal: "\u22BA", Intersection: "\u22C2", intlarhk: "\u2A17", intprod: "\u2A3C", InvisibleComma: "\u2063", InvisibleTimes: "\u2062", IOcy: "\u0401", iocy: "\u0451", Iogon: "\u012E", iogon: "\u012F", Iopf: "\u{1D540}", iopf: "\u{1D55A}", Iota: "\u0399", iota: "\u03B9", iprod: "\u2A3C", iquest: "\xBF", Iscr: "\u2110", iscr: "\u{1D4BE}", isin: "\u2208", isindot: "\u22F5", isinE: "\u22F9", isins: "\u22F4", isinsv: "\u22F3", isinv: "\u2208", it: "\u2062", Itilde: "\u0128", itilde: "\u0129", Iukcy: "\u0406", iukcy: "\u0456", Iuml: "\xCF", iuml: "\xEF", Jcirc: "\u0134", jcirc: "\u0135", Jcy: "\u0419", jcy: "\u0439", Jfr: "\u{1D50D}", jfr: "\u{1D527}", jmath: "\u0237", Jopf: "\u{1D541}", jopf: "\u{1D55B}", Jscr: "\u{1D4A5}", jscr: "\u{1D4BF}", Jsercy: "\u0408", jsercy: "\u0458", Jukcy: "\u0404", jukcy: "\u0454", Kappa: "\u039A", kappa: "\u03BA", kappav: "\u03F0", Kcedil: "\u0136", kcedil: "\u0137", Kcy: "\u041A", kcy: "\u043A", Kfr: "\u{1D50E}", kfr: "\u{1D528}", kgreen: "\u0138", KHcy: "\u0425", khcy: "\u0445", KJcy: "\u040C", kjcy: "\u045C", Kopf: "\u{1D542}", kopf: "\u{1D55C}", Kscr: "\u{1D4A6}", kscr: "\u{1D4C0}", lAarr: "\u21DA", Lacute: "\u0139", lacute: "\u013A", laemptyv: "\u29B4", lagran: "\u2112", Lambda: "\u039B", lambda: "\u03BB", Lang: "\u27EA", lang: "\u27E8", langd: "\u2991", langle: "\u27E8", lap: "\u2A85", Laplacetrf: "\u2112", laquo: "\xAB", Larr: "\u219E", lArr: "\u21D0", larr: "\u2190", larrb: "\u21E4", larrbfs: "\u291F", larrfs: "\u291D", larrhk: "\u21A9", larrlp: "\u21AB", larrpl: "\u2939", larrsim: "\u2973", larrtl: "\u21A2", lat: "\u2AAB", lAtail: "\u291B", latail: "\u2919", late: "\u2AAD", lates: "\u2AAD\uFE00", lBarr: "\u290E", lbarr: "\u290C", lbbrk: "\u2772", lbrace: "{", lbrack: "[", lbrke: "\u298B", lbrksld: "\u298F", lbrkslu: "\u298D", Lcaron: "\u013D", lcaron: "\u013E", Lcedil: "\u013B", lcedil: "\u013C", lceil: "\u2308", lcub: "{", Lcy: "\u041B", lcy: "\u043B", ldca: "\u2936", ldquo: "\u201C", ldquor: "\u201E", ldrdhar: "\u2967", ldrushar: "\u294B", ldsh: "\u21B2", lE: "\u2266", le: "\u2264", LeftAngleBracket: "\u27E8", LeftArrow: "\u2190", Leftarrow: "\u21D0", leftarrow: "\u2190", LeftArrowBar: "\u21E4", LeftArrowRightArrow: "\u21C6", leftarrowtail: "\u21A2", LeftCeiling: "\u2308", LeftDoubleBracket: "\u27E6", LeftDownTeeVector: "\u2961", LeftDownVector: "\u21C3", LeftDownVectorBar: "\u2959", LeftFloor: "\u230A", leftharpoondown: "\u21BD", leftharpoonup: "\u21BC", leftleftarrows: "\u21C7", LeftRightArrow: "\u2194", Leftrightarrow: "\u21D4", leftrightarrow: "\u2194", leftrightarrows: "\u21C6", leftrightharpoons: "\u21CB", leftrightsquigarrow: "\u21AD", LeftRightVector: "\u294E", LeftTee: "\u22A3", LeftTeeArrow: "\u21A4", LeftTeeVector: "\u295A", leftthreetimes: "\u22CB", LeftTriangle: "\u22B2", LeftTriangleBar: "\u29CF", LeftTriangleEqual: "\u22B4", LeftUpDownVector: "\u2951", LeftUpTeeVector: "\u2960", LeftUpVector: "\u21BF", LeftUpVectorBar: "\u2958", LeftVector: "\u21BC", LeftVectorBar: "\u2952", lEg: "\u2A8B", leg: "\u22DA", leq: "\u2264", leqq: "\u2266", leqslant: "\u2A7D", les: "\u2A7D", lescc: "\u2AA8", lesdot: "\u2A7F", lesdoto: "\u2A81", lesdotor: "\u2A83", lesg: "\u22DA\uFE00", lesges: "\u2A93", lessapprox: "\u2A85", lessdot: "\u22D6", lesseqgtr: "\u22DA", lesseqqgtr: "\u2A8B", LessEqualGreater: "\u22DA", LessFullEqual: "\u2266", LessGreater: "\u2276", lessgtr: "\u2276", LessLess: "\u2AA1", lesssim: "\u2272", LessSlantEqual: "\u2A7D", LessTilde: "\u2272", lfisht: "\u297C", lfloor: "\u230A", Lfr: "\u{1D50F}", lfr: "\u{1D529}", lg: "\u2276", lgE: "\u2A91", lHar: "\u2962", lhard: "\u21BD", lharu: "\u21BC", lharul: "\u296A", lhblk: "\u2584", LJcy: "\u0409", ljcy: "\u0459", Ll: "\u22D8", ll: "\u226A", llarr: "\u21C7", llcorner: "\u231E", Lleftarrow: "\u21DA", llhard: "\u296B", lltri: "\u25FA", Lmidot: "\u013F", lmidot: "\u0140", lmoust: "\u23B0", lmoustache: "\u23B0", lnap: "\u2A89", lnapprox: "\u2A89", lnE: "\u2268", lne: "\u2A87", lneq: "\u2A87", lneqq: "\u2268", lnsim: "\u22E6", loang: "\u27EC", loarr: "\u21FD", lobrk: "\u27E6", LongLeftArrow: "\u27F5", Longleftarrow: "\u27F8", longleftarrow: "\u27F5", LongLeftRightArrow: "\u27F7", Longleftrightarrow: "\u27FA", longleftrightarrow: "\u27F7", longmapsto: "\u27FC", LongRightArrow: "\u27F6", Longrightarrow: "\u27F9", longrightarrow: "\u27F6", looparrowleft: "\u21AB", looparrowright: "\u21AC", lopar: "\u2985", Lopf: "\u{1D543}", lopf: "\u{1D55D}", loplus: "\u2A2D", lotimes: "\u2A34", lowast: "\u2217", lowbar: "_", LowerLeftArrow: "\u2199", LowerRightArrow: "\u2198", loz: "\u25CA", lozenge: "\u25CA", lozf: "\u29EB", lpar: "(", lparlt: "\u2993", lrarr: "\u21C6", lrcorner: "\u231F", lrhar: "\u21CB", lrhard: "\u296D", lrm: "\u200E", lrtri: "\u22BF", lsaquo: "\u2039", Lscr: "\u2112", lscr: "\u{1D4C1}", Lsh: "\u21B0", lsh: "\u21B0", lsim: "\u2272", lsime: "\u2A8D", lsimg: "\u2A8F", lsqb: "[", lsquo: "\u2018", lsquor: "\u201A", Lstrok: "\u0141", lstrok: "\u0142", LT: "<", Lt: "\u226A", lt: "<", ltcc: "\u2AA6", ltcir: "\u2A79", ltdot: "\u22D6", lthree: "\u22CB", ltimes: "\u22C9", ltlarr: "\u2976", ltquest: "\u2A7B", ltri: "\u25C3", ltrie: "\u22B4", ltrif: "\u25C2", ltrPar: "\u2996", lurdshar: "\u294A", luruhar: "\u2966", lvertneqq: "\u2268\uFE00", lvnE: "\u2268\uFE00", macr: "\xAF", male: "\u2642", malt: "\u2720", maltese: "\u2720", Map: "\u2905", map: "\u21A6", mapsto: "\u21A6", mapstodown: "\u21A7", mapstoleft: "\u21A4", mapstoup: "\u21A5", marker: "\u25AE", mcomma: "\u2A29", Mcy: "\u041C", mcy: "\u043C", mdash: "\u2014", mDDot: "\u223A", measuredangle: "\u2221", MediumSpace: "\u205F", Mellintrf: "\u2133", Mfr: "\u{1D510}", mfr: "\u{1D52A}", mho: "\u2127", micro: "\xB5", mid: "\u2223", midast: "*", midcir: "\u2AF0", middot: "\xB7", minus: "\u2212", minusb: "\u229F", minusd: "\u2238", minusdu: "\u2A2A", MinusPlus: "\u2213", mlcp: "\u2ADB", mldr: "\u2026", mnplus: "\u2213", models: "\u22A7", Mopf: "\u{1D544}", mopf: "\u{1D55E}", mp: "\u2213", Mscr: "\u2133", mscr: "\u{1D4C2}", mstpos: "\u223E", Mu: "\u039C", mu: "\u03BC", multimap: "\u22B8", mumap: "\u22B8", nabla: "\u2207", Nacute: "\u0143", nacute: "\u0144", nang: "\u2220\u20D2", nap: "\u2249", napE: "\u2A70\u0338", napid: "\u224B\u0338", napos: "\u0149", napprox: "\u2249", natur: "\u266E", natural: "\u266E", naturals: "\u2115", nbsp: "\xA0", nbump: "\u224E\u0338", nbumpe: "\u224F\u0338", ncap: "\u2A43", Ncaron: "\u0147", ncaron: "\u0148", Ncedil: "\u0145", ncedil: "\u0146", ncong: "\u2247", ncongdot: "\u2A6D\u0338", ncup: "\u2A42", Ncy: "\u041D", ncy: "\u043D", ndash: "\u2013", ne: "\u2260", nearhk: "\u2924", neArr: "\u21D7", nearr: "\u2197", nearrow: "\u2197", nedot: "\u2250\u0338", NegativeMediumSpace: "\u200B", NegativeThickSpace: "\u200B", NegativeThinSpace: "\u200B", NegativeVeryThinSpace: "\u200B", nequiv: "\u2262", nesear: "\u2928", nesim: "\u2242\u0338", NestedGreaterGreater: "\u226B", NestedLessLess: "\u226A", NewLine: `
`, nexist: "\u2204", nexists: "\u2204", Nfr: "\u{1D511}", nfr: "\u{1D52B}", ngE: "\u2267\u0338", nge: "\u2271", ngeq: "\u2271", ngeqq: "\u2267\u0338", ngeqslant: "\u2A7E\u0338", nges: "\u2A7E\u0338", nGg: "\u22D9\u0338", ngsim: "\u2275", nGt: "\u226B\u20D2", ngt: "\u226F", ngtr: "\u226F", nGtv: "\u226B\u0338", nhArr: "\u21CE", nharr: "\u21AE", nhpar: "\u2AF2", ni: "\u220B", nis: "\u22FC", nisd: "\u22FA", niv: "\u220B", NJcy: "\u040A", njcy: "\u045A", nlArr: "\u21CD", nlarr: "\u219A", nldr: "\u2025", nlE: "\u2266\u0338", nle: "\u2270", nLeftarrow: "\u21CD", nleftarrow: "\u219A", nLeftrightarrow: "\u21CE", nleftrightarrow: "\u21AE", nleq: "\u2270", nleqq: "\u2266\u0338", nleqslant: "\u2A7D\u0338", nles: "\u2A7D\u0338", nless: "\u226E", nLl: "\u22D8\u0338", nlsim: "\u2274", nLt: "\u226A\u20D2", nlt: "\u226E", nltri: "\u22EA", nltrie: "\u22EC", nLtv: "\u226A\u0338", nmid: "\u2224", NoBreak: "\u2060", NonBreakingSpace: "\xA0", Nopf: "\u2115", nopf: "\u{1D55F}", Not: "\u2AEC", not: "\xAC", NotCongruent: "\u2262", NotCupCap: "\u226D", NotDoubleVerticalBar: "\u2226", NotElement: "\u2209", NotEqual: "\u2260", NotEqualTilde: "\u2242\u0338", NotExists: "\u2204", NotGreater: "\u226F", NotGreaterEqual: "\u2271", NotGreaterFullEqual: "\u2267\u0338", NotGreaterGreater: "\u226B\u0338", NotGreaterLess: "\u2279", NotGreaterSlantEqual: "\u2A7E\u0338", NotGreaterTilde: "\u2275", NotHumpDownHump: "\u224E\u0338", NotHumpEqual: "\u224F\u0338", notin: "\u2209", notindot: "\u22F5\u0338", notinE: "\u22F9\u0338", notinva: "\u2209", notinvb: "\u22F7", notinvc: "\u22F6", NotLeftTriangle: "\u22EA", NotLeftTriangleBar: "\u29CF\u0338", NotLeftTriangleEqual: "\u22EC", NotLess: "\u226E", NotLessEqual: "\u2270", NotLessGreater: "\u2278", NotLessLess: "\u226A\u0338", NotLessSlantEqual: "\u2A7D\u0338", NotLessTilde: "\u2274", NotNestedGreaterGreater: "\u2AA2\u0338", NotNestedLessLess: "\u2AA1\u0338", notni: "\u220C", notniva: "\u220C", notnivb: "\u22FE", notnivc: "\u22FD", NotPrecedes: "\u2280", NotPrecedesEqual: "\u2AAF\u0338", NotPrecedesSlantEqual: "\u22E0", NotReverseElement: "\u220C", NotRightTriangle: "\u22EB", NotRightTriangleBar: "\u29D0\u0338", NotRightTriangleEqual: "\u22ED", NotSquareSubset: "\u228F\u0338", NotSquareSubsetEqual: "\u22E2", NotSquareSuperset: "\u2290\u0338", NotSquareSupersetEqual: "\u22E3", NotSubset: "\u2282\u20D2", NotSubsetEqual: "\u2288", NotSucceeds: "\u2281", NotSucceedsEqual: "\u2AB0\u0338", NotSucceedsSlantEqual: "\u22E1", NotSucceedsTilde: "\u227F\u0338", NotSuperset: "\u2283\u20D2", NotSupersetEqual: "\u2289", NotTilde: "\u2241", NotTildeEqual: "\u2244", NotTildeFullEqual: "\u2247", NotTildeTilde: "\u2249", NotVerticalBar: "\u2224", npar: "\u2226", nparallel: "\u2226", nparsl: "\u2AFD\u20E5", npart: "\u2202\u0338", npolint: "\u2A14", npr: "\u2280", nprcue: "\u22E0", npre: "\u2AAF\u0338", nprec: "\u2280", npreceq: "\u2AAF\u0338", nrArr: "\u21CF", nrarr: "\u219B", nrarrc: "\u2933\u0338", nrarrw: "\u219D\u0338", nRightarrow: "\u21CF", nrightarrow: "\u219B", nrtri: "\u22EB", nrtrie: "\u22ED", nsc: "\u2281", nsccue: "\u22E1", nsce: "\u2AB0\u0338", Nscr: "\u{1D4A9}", nscr: "\u{1D4C3}", nshortmid: "\u2224", nshortparallel: "\u2226", nsim: "\u2241", nsime: "\u2244", nsimeq: "\u2244", nsmid: "\u2224", nspar: "\u2226", nsqsube: "\u22E2", nsqsupe: "\u22E3", nsub: "\u2284", nsubE: "\u2AC5\u0338", nsube: "\u2288", nsubset: "\u2282\u20D2", nsubseteq: "\u2288", nsubseteqq: "\u2AC5\u0338", nsucc: "\u2281", nsucceq: "\u2AB0\u0338", nsup: "\u2285", nsupE: "\u2AC6\u0338", nsupe: "\u2289", nsupset: "\u2283\u20D2", nsupseteq: "\u2289", nsupseteqq: "\u2AC6\u0338", ntgl: "\u2279", Ntilde: "\xD1", ntilde: "\xF1", ntlg: "\u2278", ntriangleleft: "\u22EA", ntrianglelefteq: "\u22EC", ntriangleright: "\u22EB", ntrianglerighteq: "\u22ED", Nu: "\u039D", nu: "\u03BD", num: "#", numero: "\u2116", numsp: "\u2007", nvap: "\u224D\u20D2", nVDash: "\u22AF", nVdash: "\u22AE", nvDash: "\u22AD", nvdash: "\u22AC", nvge: "\u2265\u20D2", nvgt: ">\u20D2", nvHarr: "\u2904", nvinfin: "\u29DE", nvlArr: "\u2902", nvle: "\u2264\u20D2", nvlt: "<\u20D2", nvltrie: "\u22B4\u20D2", nvrArr: "\u2903", nvrtrie: "\u22B5\u20D2", nvsim: "\u223C\u20D2", nwarhk: "\u2923", nwArr: "\u21D6", nwarr: "\u2196", nwarrow: "\u2196", nwnear: "\u2927", Oacute: "\xD3", oacute: "\xF3", oast: "\u229B", ocir: "\u229A", Ocirc: "\xD4", ocirc: "\xF4", Ocy: "\u041E", ocy: "\u043E", odash: "\u229D", Odblac: "\u0150", odblac: "\u0151", odiv: "\u2A38", odot: "\u2299", odsold: "\u29BC", OElig: "\u0152", oelig: "\u0153", ofcir: "\u29BF", Ofr: "\u{1D512}", ofr: "\u{1D52C}", ogon: "\u02DB", Ograve: "\xD2", ograve: "\xF2", ogt: "\u29C1", ohbar: "\u29B5", ohm: "\u03A9", oint: "\u222E", olarr: "\u21BA", olcir: "\u29BE", olcross: "\u29BB", oline: "\u203E", olt: "\u29C0", Omacr: "\u014C", omacr: "\u014D", Omega: "\u03A9", omega: "\u03C9", Omicron: "\u039F", omicron: "\u03BF", omid: "\u29B6", ominus: "\u2296", Oopf: "\u{1D546}", oopf: "\u{1D560}", opar: "\u29B7", OpenCurlyDoubleQuote: "\u201C", OpenCurlyQuote: "\u2018", operp: "\u29B9", oplus: "\u2295", Or: "\u2A54", or: "\u2228", orarr: "\u21BB", ord: "\u2A5D", order: "\u2134", orderof: "\u2134", ordf: "\xAA", ordm: "\xBA", origof: "\u22B6", oror: "\u2A56", orslope: "\u2A57", orv: "\u2A5B", oS: "\u24C8", Oscr: "\u{1D4AA}", oscr: "\u2134", Oslash: "\xD8", oslash: "\xF8", osol: "\u2298", Otilde: "\xD5", otilde: "\xF5", Otimes: "\u2A37", otimes: "\u2297", otimesas: "\u2A36", Ouml: "\xD6", ouml: "\xF6", ovbar: "\u233D", OverBar: "\u203E", OverBrace: "\u23DE", OverBracket: "\u23B4", OverParenthesis: "\u23DC", par: "\u2225", para: "\xB6", parallel: "\u2225", parsim: "\u2AF3", parsl: "\u2AFD", part: "\u2202", PartialD: "\u2202", Pcy: "\u041F", pcy: "\u043F", percnt: "%", period: ".", permil: "\u2030", perp: "\u22A5", pertenk: "\u2031", Pfr: "\u{1D513}", pfr: "\u{1D52D}", Phi: "\u03A6", phi: "\u03C6", phiv: "\u03D5", phmmat: "\u2133", phone: "\u260E", Pi: "\u03A0", pi: "\u03C0", pitchfork: "\u22D4", piv: "\u03D6", planck: "\u210F", planckh: "\u210E", plankv: "\u210F", plus: "+", plusacir: "\u2A23", plusb: "\u229E", pluscir: "\u2A22", plusdo: "\u2214", plusdu: "\u2A25", pluse: "\u2A72", PlusMinus: "\xB1", plusmn: "\xB1", plussim: "\u2A26", plustwo: "\u2A27", pm: "\xB1", Poincareplane: "\u210C", pointint: "\u2A15", Popf: "\u2119", popf: "\u{1D561}", pound: "\xA3", Pr: "\u2ABB", pr: "\u227A", prap: "\u2AB7", prcue: "\u227C", prE: "\u2AB3", pre: "\u2AAF", prec: "\u227A", precapprox: "\u2AB7", preccurlyeq: "\u227C", Precedes: "\u227A", PrecedesEqual: "\u2AAF", PrecedesSlantEqual: "\u227C", PrecedesTilde: "\u227E", preceq: "\u2AAF", precnapprox: "\u2AB9", precneqq: "\u2AB5", precnsim: "\u22E8", precsim: "\u227E", Prime: "\u2033", prime: "\u2032", primes: "\u2119", prnap: "\u2AB9", prnE: "\u2AB5", prnsim: "\u22E8", prod: "\u220F", Product: "\u220F", profalar: "\u232E", profline: "\u2312", profsurf: "\u2313", prop: "\u221D", Proportion: "\u2237", Proportional: "\u221D", propto: "\u221D", prsim: "\u227E", prurel: "\u22B0", Pscr: "\u{1D4AB}", pscr: "\u{1D4C5}", Psi: "\u03A8", psi: "\u03C8", puncsp: "\u2008", Qfr: "\u{1D514}", qfr: "\u{1D52E}", qint: "\u2A0C", Qopf: "\u211A", qopf: "\u{1D562}", qprime: "\u2057", Qscr: "\u{1D4AC}", qscr: "\u{1D4C6}", quaternions: "\u210D", quatint: "\u2A16", quest: "?", questeq: "\u225F", QUOT: '"', quot: '"', rAarr: "\u21DB", race: "\u223D\u0331", Racute: "\u0154", racute: "\u0155", radic: "\u221A", raemptyv: "\u29B3", Rang: "\u27EB", rang: "\u27E9", rangd: "\u2992", range: "\u29A5", rangle: "\u27E9", raquo: "\xBB", Rarr: "\u21A0", rArr: "\u21D2", rarr: "\u2192", rarrap: "\u2975", rarrb: "\u21E5", rarrbfs: "\u2920", rarrc: "\u2933", rarrfs: "\u291E", rarrhk: "\u21AA", rarrlp: "\u21AC", rarrpl: "\u2945", rarrsim: "\u2974", Rarrtl: "\u2916", rarrtl: "\u21A3", rarrw: "\u219D", rAtail: "\u291C", ratail: "\u291A", ratio: "\u2236", rationals: "\u211A", RBarr: "\u2910", rBarr: "\u290F", rbarr: "\u290D", rbbrk: "\u2773", rbrace: "}", rbrack: "]", rbrke: "\u298C", rbrksld: "\u298E", rbrkslu: "\u2990", Rcaron: "\u0158", rcaron: "\u0159", Rcedil: "\u0156", rcedil: "\u0157", rceil: "\u2309", rcub: "}", Rcy: "\u0420", rcy: "\u0440", rdca: "\u2937", rdldhar: "\u2969", rdquo: "\u201D", rdquor: "\u201D", rdsh: "\u21B3", Re: "\u211C", real: "\u211C", realine: "\u211B", realpart: "\u211C", reals: "\u211D", rect: "\u25AD", REG: "\xAE", reg: "\xAE", ReverseElement: "\u220B", ReverseEquilibrium: "\u21CB", ReverseUpEquilibrium: "\u296F", rfisht: "\u297D", rfloor: "\u230B", Rfr: "\u211C", rfr: "\u{1D52F}", rHar: "\u2964", rhard: "\u21C1", rharu: "\u21C0", rharul: "\u296C", Rho: "\u03A1", rho: "\u03C1", rhov: "\u03F1", RightAngleBracket: "\u27E9", RightArrow: "\u2192", Rightarrow: "\u21D2", rightarrow: "\u2192", RightArrowBar: "\u21E5", RightArrowLeftArrow: "\u21C4", rightarrowtail: "\u21A3", RightCeiling: "\u2309", RightDoubleBracket: "\u27E7", RightDownTeeVector: "\u295D", RightDownVector: "\u21C2", RightDownVectorBar: "\u2955", RightFloor: "\u230B", rightharpoondown: "\u21C1", rightharpoonup: "\u21C0", rightleftarrows: "\u21C4", rightleftharpoons: "\u21CC", rightrightarrows: "\u21C9", rightsquigarrow: "\u219D", RightTee: "\u22A2", RightTeeArrow: "\u21A6", RightTeeVector: "\u295B", rightthreetimes: "\u22CC", RightTriangle: "\u22B3", RightTriangleBar: "\u29D0", RightTriangleEqual: "\u22B5", RightUpDownVector: "\u294F", RightUpTeeVector: "\u295C", RightUpVector: "\u21BE", RightUpVectorBar: "\u2954", RightVector: "\u21C0", RightVectorBar: "\u2953", ring: "\u02DA", risingdotseq: "\u2253", rlarr: "\u21C4", rlhar: "\u21CC", rlm: "\u200F", rmoust: "\u23B1", rmoustache: "\u23B1", rnmid: "\u2AEE", roang: "\u27ED", roarr: "\u21FE", robrk: "\u27E7", ropar: "\u2986", Ropf: "\u211D", ropf: "\u{1D563}", roplus: "\u2A2E", rotimes: "\u2A35", RoundImplies: "\u2970", rpar: ")", rpargt: "\u2994", rppolint: "\u2A12", rrarr: "\u21C9", Rrightarrow: "\u21DB", rsaquo: "\u203A", Rscr: "\u211B", rscr: "\u{1D4C7}", Rsh: "\u21B1", rsh: "\u21B1", rsqb: "]", rsquo: "\u2019", rsquor: "\u2019", rthree: "\u22CC", rtimes: "\u22CA", rtri: "\u25B9", rtrie: "\u22B5", rtrif: "\u25B8", rtriltri: "\u29CE", RuleDelayed: "\u29F4", ruluhar: "\u2968", rx: "\u211E", Sacute: "\u015A", sacute: "\u015B", sbquo: "\u201A", Sc: "\u2ABC", sc: "\u227B", scap: "\u2AB8", Scaron: "\u0160", scaron: "\u0161", sccue: "\u227D", scE: "\u2AB4", sce: "\u2AB0", Scedil: "\u015E", scedil: "\u015F", Scirc: "\u015C", scirc: "\u015D", scnap: "\u2ABA", scnE: "\u2AB6", scnsim: "\u22E9", scpolint: "\u2A13", scsim: "\u227F", Scy: "\u0421", scy: "\u0441", sdot: "\u22C5", sdotb: "\u22A1", sdote: "\u2A66", searhk: "\u2925", seArr: "\u21D8", searr: "\u2198", searrow: "\u2198", sect: "\xA7", semi: ";", seswar: "\u2929", setminus: "\u2216", setmn: "\u2216", sext: "\u2736", Sfr: "\u{1D516}", sfr: "\u{1D530}", sfrown: "\u2322", sharp: "\u266F", SHCHcy: "\u0429", shchcy: "\u0449", SHcy: "\u0428", shcy: "\u0448", ShortDownArrow: "\u2193", ShortLeftArrow: "\u2190", shortmid: "\u2223", shortparallel: "\u2225", ShortRightArrow: "\u2192", ShortUpArrow: "\u2191", shy: "\xAD", Sigma: "\u03A3", sigma: "\u03C3", sigmaf: "\u03C2", sigmav: "\u03C2", sim: "\u223C", simdot: "\u2A6A", sime: "\u2243", simeq: "\u2243", simg: "\u2A9E", simgE: "\u2AA0", siml: "\u2A9D", simlE: "\u2A9F", simne: "\u2246", simplus: "\u2A24", simrarr: "\u2972", slarr: "\u2190", SmallCircle: "\u2218", smallsetminus: "\u2216", smashp: "\u2A33", smeparsl: "\u29E4", smid: "\u2223", smile: "\u2323", smt: "\u2AAA", smte: "\u2AAC", smtes: "\u2AAC\uFE00", SOFTcy: "\u042C", softcy: "\u044C", sol: "/", solb: "\u29C4", solbar: "\u233F", Sopf: "\u{1D54A}", sopf: "\u{1D564}", spades: "\u2660", spadesuit: "\u2660", spar: "\u2225", sqcap: "\u2293", sqcaps: "\u2293\uFE00", sqcup: "\u2294", sqcups: "\u2294\uFE00", Sqrt: "\u221A", sqsub: "\u228F", sqsube: "\u2291", sqsubset: "\u228F", sqsubseteq: "\u2291", sqsup: "\u2290", sqsupe: "\u2292", sqsupset: "\u2290", sqsupseteq: "\u2292", squ: "\u25A1", Square: "\u25A1", square: "\u25A1", SquareIntersection: "\u2293", SquareSubset: "\u228F", SquareSubsetEqual: "\u2291", SquareSuperset: "\u2290", SquareSupersetEqual: "\u2292", SquareUnion: "\u2294", squarf: "\u25AA", squf: "\u25AA", srarr: "\u2192", Sscr: "\u{1D4AE}", sscr: "\u{1D4C8}", ssetmn: "\u2216", ssmile: "\u2323", sstarf: "\u22C6", Star: "\u22C6", star: "\u2606", starf: "\u2605", straightepsilon: "\u03F5", straightphi: "\u03D5", strns: "\xAF", Sub: "\u22D0", sub: "\u2282", subdot: "\u2ABD", subE: "\u2AC5", sube: "\u2286", subedot: "\u2AC3", submult: "\u2AC1", subnE: "\u2ACB", subne: "\u228A", subplus: "\u2ABF", subrarr: "\u2979", Subset: "\u22D0", subset: "\u2282", subseteq: "\u2286", subseteqq: "\u2AC5", SubsetEqual: "\u2286", subsetneq: "\u228A", subsetneqq: "\u2ACB", subsim: "\u2AC7", subsub: "\u2AD5", subsup: "\u2AD3", succ: "\u227B", succapprox: "\u2AB8", succcurlyeq: "\u227D", Succeeds: "\u227B", SucceedsEqual: "\u2AB0", SucceedsSlantEqual: "\u227D", SucceedsTilde: "\u227F", succeq: "\u2AB0", succnapprox: "\u2ABA", succneqq: "\u2AB6", succnsim: "\u22E9", succsim: "\u227F", SuchThat: "\u220B", Sum: "\u2211", sum: "\u2211", sung: "\u266A", Sup: "\u22D1", sup: "\u2283", sup1: "\xB9", sup2: "\xB2", sup3: "\xB3", supdot: "\u2ABE", supdsub: "\u2AD8", supE: "\u2AC6", supe: "\u2287", supedot: "\u2AC4", Superset: "\u2283", SupersetEqual: "\u2287", suphsol: "\u27C9", suphsub: "\u2AD7", suplarr: "\u297B", supmult: "\u2AC2", supnE: "\u2ACC", supne: "\u228B", supplus: "\u2AC0", Supset: "\u22D1", supset: "\u2283", supseteq: "\u2287", supseteqq: "\u2AC6", supsetneq: "\u228B", supsetneqq: "\u2ACC", supsim: "\u2AC8", supsub: "\u2AD4", supsup: "\u2AD6", swarhk: "\u2926", swArr: "\u21D9", swarr: "\u2199", swarrow: "\u2199", swnwar: "\u292A", szlig: "\xDF", Tab: "	", target: "\u2316", Tau: "\u03A4", tau: "\u03C4", tbrk: "\u23B4", Tcaron: "\u0164", tcaron: "\u0165", Tcedil: "\u0162", tcedil: "\u0163", Tcy: "\u0422", tcy: "\u0442", tdot: "\u20DB", telrec: "\u2315", Tfr: "\u{1D517}", tfr: "\u{1D531}", there4: "\u2234", Therefore: "\u2234", therefore: "\u2234", Theta: "\u0398", theta: "\u03B8", thetasym: "\u03D1", thetav: "\u03D1", thickapprox: "\u2248", thicksim: "\u223C", ThickSpace: "\u205F\u200A", thinsp: "\u2009", ThinSpace: "\u2009", thkap: "\u2248", thksim: "\u223C", THORN: "\xDE", thorn: "\xFE", Tilde: "\u223C", tilde: "\u02DC", TildeEqual: "\u2243", TildeFullEqual: "\u2245", TildeTilde: "\u2248", times: "\xD7", timesb: "\u22A0", timesbar: "\u2A31", timesd: "\u2A30", tint: "\u222D", toea: "\u2928", top: "\u22A4", topbot: "\u2336", topcir: "\u2AF1", Topf: "\u{1D54B}", topf: "\u{1D565}", topfork: "\u2ADA", tosa: "\u2929", tprime: "\u2034", TRADE: "\u2122", trade: "\u2122", triangle: "\u25B5", triangledown: "\u25BF", triangleleft: "\u25C3", trianglelefteq: "\u22B4", triangleq: "\u225C", triangleright: "\u25B9", trianglerighteq: "\u22B5", tridot: "\u25EC", trie: "\u225C", triminus: "\u2A3A", TripleDot: "\u20DB", triplus: "\u2A39", trisb: "\u29CD", tritime: "\u2A3B", trpezium: "\u23E2", Tscr: "\u{1D4AF}", tscr: "\u{1D4C9}", TScy: "\u0426", tscy: "\u0446", TSHcy: "\u040B", tshcy: "\u045B", Tstrok: "\u0166", tstrok: "\u0167", twixt: "\u226C", twoheadleftarrow: "\u219E", twoheadrightarrow: "\u21A0", Uacute: "\xDA", uacute: "\xFA", Uarr: "\u219F", uArr: "\u21D1", uarr: "\u2191", Uarrocir: "\u2949", Ubrcy: "\u040E", ubrcy: "\u045E", Ubreve: "\u016C", ubreve: "\u016D", Ucirc: "\xDB", ucirc: "\xFB", Ucy: "\u0423", ucy: "\u0443", udarr: "\u21C5", Udblac: "\u0170", udblac: "\u0171", udhar: "\u296E", ufisht: "\u297E", Ufr: "\u{1D518}", ufr: "\u{1D532}", Ugrave: "\xD9", ugrave: "\xF9", uHar: "\u2963", uharl: "\u21BF", uharr: "\u21BE", uhblk: "\u2580", ulcorn: "\u231C", ulcorner: "\u231C", ulcrop: "\u230F", ultri: "\u25F8", Umacr: "\u016A", umacr: "\u016B", uml: "\xA8", UnderBar: "_", UnderBrace: "\u23DF", UnderBracket: "\u23B5", UnderParenthesis: "\u23DD", Union: "\u22C3", UnionPlus: "\u228E", Uogon: "\u0172", uogon: "\u0173", Uopf: "\u{1D54C}", uopf: "\u{1D566}", UpArrow: "\u2191", Uparrow: "\u21D1", uparrow: "\u2191", UpArrowBar: "\u2912", UpArrowDownArrow: "\u21C5", UpDownArrow: "\u2195", Updownarrow: "\u21D5", updownarrow: "\u2195", UpEquilibrium: "\u296E", upharpoonleft: "\u21BF", upharpoonright: "\u21BE", uplus: "\u228E", UpperLeftArrow: "\u2196", UpperRightArrow: "\u2197", Upsi: "\u03D2", upsi: "\u03C5", upsih: "\u03D2", Upsilon: "\u03A5", upsilon: "\u03C5", UpTee: "\u22A5", UpTeeArrow: "\u21A5", upuparrows: "\u21C8", urcorn: "\u231D", urcorner: "\u231D", urcrop: "\u230E", Uring: "\u016E", uring: "\u016F", urtri: "\u25F9", Uscr: "\u{1D4B0}", uscr: "\u{1D4CA}", utdot: "\u22F0", Utilde: "\u0168", utilde: "\u0169", utri: "\u25B5", utrif: "\u25B4", uuarr: "\u21C8", Uuml: "\xDC", uuml: "\xFC", uwangle: "\u29A7", vangrt: "\u299C", varepsilon: "\u03F5", varkappa: "\u03F0", varnothing: "\u2205", varphi: "\u03D5", varpi: "\u03D6", varpropto: "\u221D", vArr: "\u21D5", varr: "\u2195", varrho: "\u03F1", varsigma: "\u03C2", varsubsetneq: "\u228A\uFE00", varsubsetneqq: "\u2ACB\uFE00", varsupsetneq: "\u228B\uFE00", varsupsetneqq: "\u2ACC\uFE00", vartheta: "\u03D1", vartriangleleft: "\u22B2", vartriangleright: "\u22B3", Vbar: "\u2AEB", vBar: "\u2AE8", vBarv: "\u2AE9", Vcy: "\u0412", vcy: "\u0432", VDash: "\u22AB", Vdash: "\u22A9", vDash: "\u22A8", vdash: "\u22A2", Vdashl: "\u2AE6", Vee: "\u22C1", vee: "\u2228", veebar: "\u22BB", veeeq: "\u225A", vellip: "\u22EE", Verbar: "\u2016", verbar: "|", Vert: "\u2016", vert: "|", VerticalBar: "\u2223", VerticalLine: "|", VerticalSeparator: "\u2758", VerticalTilde: "\u2240", VeryThinSpace: "\u200A", Vfr: "\u{1D519}", vfr: "\u{1D533}", vltri: "\u22B2", vnsub: "\u2282\u20D2", vnsup: "\u2283\u20D2", Vopf: "\u{1D54D}", vopf: "\u{1D567}", vprop: "\u221D", vrtri: "\u22B3", Vscr: "\u{1D4B1}", vscr: "\u{1D4CB}", vsubnE: "\u2ACB\uFE00", vsubne: "\u228A\uFE00", vsupnE: "\u2ACC\uFE00", vsupne: "\u228B\uFE00", Vvdash: "\u22AA", vzigzag: "\u299A", Wcirc: "\u0174", wcirc: "\u0175", wedbar: "\u2A5F", Wedge: "\u22C0", wedge: "\u2227", wedgeq: "\u2259", weierp: "\u2118", Wfr: "\u{1D51A}", wfr: "\u{1D534}", Wopf: "\u{1D54E}", wopf: "\u{1D568}", wp: "\u2118", wr: "\u2240", wreath: "\u2240", Wscr: "\u{1D4B2}", wscr: "\u{1D4CC}", xcap: "\u22C2", xcirc: "\u25EF", xcup: "\u22C3", xdtri: "\u25BD", Xfr: "\u{1D51B}", xfr: "\u{1D535}", xhArr: "\u27FA", xharr: "\u27F7", Xi: "\u039E", xi: "\u03BE", xlArr: "\u27F8", xlarr: "\u27F5", xmap: "\u27FC", xnis: "\u22FB", xodot: "\u2A00", Xopf: "\u{1D54F}", xopf: "\u{1D569}", xoplus: "\u2A01", xotime: "\u2A02", xrArr: "\u27F9", xrarr: "\u27F6", Xscr: "\u{1D4B3}", xscr: "\u{1D4CD}", xsqcup: "\u2A06", xuplus: "\u2A04", xutri: "\u25B3", xvee: "\u22C1", xwedge: "\u22C0", Yacute: "\xDD", yacute: "\xFD", YAcy: "\u042F", yacy: "\u044F", Ycirc: "\u0176", ycirc: "\u0177", Ycy: "\u042B", ycy: "\u044B", yen: "\xA5", Yfr: "\u{1D51C}", yfr: "\u{1D536}", YIcy: "\u0407", yicy: "\u0457", Yopf: "\u{1D550}", yopf: "\u{1D56A}", Yscr: "\u{1D4B4}", yscr: "\u{1D4CE}", YUcy: "\u042E", yucy: "\u044E", Yuml: "\u0178", yuml: "\xFF", Zacute: "\u0179", zacute: "\u017A", Zcaron: "\u017D", zcaron: "\u017E", Zcy: "\u0417", zcy: "\u0437", Zdot: "\u017B", zdot: "\u017C", zeetrf: "\u2128", ZeroWidthSpace: "\u200B", Zeta: "\u0396", zeta: "\u03B6", Zfr: "\u2128", zfr: "\u{1D537}", ZHcy: "\u0416", zhcy: "\u0436", zigrarr: "\u21DD", Zopf: "\u2124", zopf: "\u{1D56B}", Zscr: "\u{1D4B5}", zscr: "\u{1D4CF}", zwj: "\u200D", zwnj: "\u200C" }, e25.NGSP_UNICODE = "\uE500", e25.NAMED_ENTITIES.ngsp = e25.NGSP_UNICODE;
      } }), Bs2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/html_tags.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Ze2(), u2 = class {
          constructor() {
            let { closedByChildren: i2, implicitNamespacePrefix: f2, contentType: c2 = r2.TagContentType.PARSABLE_DATA, closedByParent: F2 = false, isVoid: a2 = false, ignoreFirstLf: l2 = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            this.closedByChildren = {}, this.closedByParent = false, this.canSelfClose = false, i2 && i2.length > 0 && i2.forEach((h2) => this.closedByChildren[h2] = true), this.isVoid = a2, this.closedByParent = F2 || a2, this.implicitNamespacePrefix = f2 || null, this.contentType = c2, this.ignoreFirstLf = l2;
          }
          isClosedByChild(i2) {
            return this.isVoid || i2.toLowerCase() in this.closedByChildren;
          }
        };
        e25.HtmlTagDefinition = u2;
        var n2, D2;
        function s2(i2) {
          return D2 || (n2 = new u2(), D2 = { base: new u2({ isVoid: true }), meta: new u2({ isVoid: true }), area: new u2({ isVoid: true }), embed: new u2({ isVoid: true }), link: new u2({ isVoid: true }), img: new u2({ isVoid: true }), input: new u2({ isVoid: true }), param: new u2({ isVoid: true }), hr: new u2({ isVoid: true }), br: new u2({ isVoid: true }), source: new u2({ isVoid: true }), track: new u2({ isVoid: true }), wbr: new u2({ isVoid: true }), p: new u2({ closedByChildren: ["address", "article", "aside", "blockquote", "div", "dl", "fieldset", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "main", "nav", "ol", "p", "pre", "section", "table", "ul"], closedByParent: true }), thead: new u2({ closedByChildren: ["tbody", "tfoot"] }), tbody: new u2({ closedByChildren: ["tbody", "tfoot"], closedByParent: true }), tfoot: new u2({ closedByChildren: ["tbody"], closedByParent: true }), tr: new u2({ closedByChildren: ["tr"], closedByParent: true }), td: new u2({ closedByChildren: ["td", "th"], closedByParent: true }), th: new u2({ closedByChildren: ["td", "th"], closedByParent: true }), col: new u2({ isVoid: true }), svg: new u2({ implicitNamespacePrefix: "svg" }), math: new u2({ implicitNamespacePrefix: "math" }), li: new u2({ closedByChildren: ["li"], closedByParent: true }), dt: new u2({ closedByChildren: ["dt", "dd"] }), dd: new u2({ closedByChildren: ["dt", "dd"], closedByParent: true }), rb: new u2({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), rt: new u2({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), rtc: new u2({ closedByChildren: ["rb", "rtc", "rp"], closedByParent: true }), rp: new u2({ closedByChildren: ["rb", "rt", "rtc", "rp"], closedByParent: true }), optgroup: new u2({ closedByChildren: ["optgroup"], closedByParent: true }), option: new u2({ closedByChildren: ["option", "optgroup"], closedByParent: true }), pre: new u2({ ignoreFirstLf: true }), listing: new u2({ ignoreFirstLf: true }), style: new u2({ contentType: r2.TagContentType.RAW_TEXT }), script: new u2({ contentType: r2.TagContentType.RAW_TEXT }), title: new u2({ contentType: r2.TagContentType.ESCAPABLE_RAW_TEXT }), textarea: new u2({ contentType: r2.TagContentType.ESCAPABLE_RAW_TEXT, ignoreFirstLf: true }) }), D2[i2] || n2;
        }
        e25.getHtmlTagDefinition = s2;
      } }), Hl2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/ast_path.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = class {
          constructor(u2) {
            let n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
            this.path = u2, this.position = n2;
          }
          get empty() {
            return !this.path || !this.path.length;
          }
          get head() {
            return this.path[0];
          }
          get tail() {
            return this.path[this.path.length - 1];
          }
          parentOf(u2) {
            return u2 && this.path[this.path.indexOf(u2) - 1];
          }
          childOf(u2) {
            return this.path[this.path.indexOf(u2) + 1];
          }
          first(u2) {
            for (let n2 = this.path.length - 1; n2 >= 0; n2--) {
              let D2 = this.path[n2];
              if (D2 instanceof u2)
                return D2;
            }
          }
          push(u2) {
            this.path.push(u2);
          }
          pop() {
            return this.path.pop();
          }
        };
        e25.AstPath = r2;
      } }), bs2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/ast.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Hl2(), u2 = class {
          constructor(d2, m2, T2) {
            this.value = d2, this.sourceSpan = m2, this.i18n = T2, this.type = "text";
          }
          visit(d2, m2) {
            return d2.visitText(this, m2);
          }
        };
        e25.Text = u2;
        var n2 = class {
          constructor(d2, m2) {
            this.value = d2, this.sourceSpan = m2, this.type = "cdata";
          }
          visit(d2, m2) {
            return d2.visitCdata(this, m2);
          }
        };
        e25.CDATA = n2;
        var D2 = class {
          constructor(d2, m2, T2, w2, g2, N2) {
            this.switchValue = d2, this.type = m2, this.cases = T2, this.sourceSpan = w2, this.switchValueSourceSpan = g2, this.i18n = N2;
          }
          visit(d2, m2) {
            return d2.visitExpansion(this, m2);
          }
        };
        e25.Expansion = D2;
        var s2 = class {
          constructor(d2, m2, T2, w2, g2) {
            this.value = d2, this.expression = m2, this.sourceSpan = T2, this.valueSourceSpan = w2, this.expSourceSpan = g2;
          }
          visit(d2, m2) {
            return d2.visitExpansionCase(this, m2);
          }
        };
        e25.ExpansionCase = s2;
        var i2 = class {
          constructor(d2, m2, T2) {
            let w2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, g2 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, N2 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
            this.name = d2, this.value = m2, this.sourceSpan = T2, this.valueSpan = w2, this.nameSpan = g2, this.i18n = N2, this.type = "attribute";
          }
          visit(d2, m2) {
            return d2.visitAttribute(this, m2);
          }
        };
        e25.Attribute = i2;
        var f2 = class {
          constructor(d2, m2, T2, w2) {
            let g2 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, N2 = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, R2 = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, j2 = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
            this.name = d2, this.attrs = m2, this.children = T2, this.sourceSpan = w2, this.startSourceSpan = g2, this.endSourceSpan = N2, this.nameSpan = R2, this.i18n = j2, this.type = "element";
          }
          visit(d2, m2) {
            return d2.visitElement(this, m2);
          }
        };
        e25.Element = f2;
        var c2 = class {
          constructor(d2, m2) {
            this.value = d2, this.sourceSpan = m2, this.type = "comment";
          }
          visit(d2, m2) {
            return d2.visitComment(this, m2);
          }
        };
        e25.Comment = c2;
        var F2 = class {
          constructor(d2, m2) {
            this.value = d2, this.sourceSpan = m2, this.type = "docType";
          }
          visit(d2, m2) {
            return d2.visitDocType(this, m2);
          }
        };
        e25.DocType = F2;
        function a2(d2, m2) {
          let T2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, w2 = [], g2 = d2.visit ? (N2) => d2.visit(N2, T2) || N2.visit(d2, T2) : (N2) => N2.visit(d2, T2);
          return m2.forEach((N2) => {
            let R2 = g2(N2);
            R2 && w2.push(R2);
          }), w2;
        }
        e25.visitAll = a2;
        var l2 = class {
          constructor() {
          }
          visitElement(d2, m2) {
            this.visitChildren(m2, (T2) => {
              T2(d2.attrs), T2(d2.children);
            });
          }
          visitAttribute(d2, m2) {
          }
          visitText(d2, m2) {
          }
          visitCdata(d2, m2) {
          }
          visitComment(d2, m2) {
          }
          visitDocType(d2, m2) {
          }
          visitExpansion(d2, m2) {
            return this.visitChildren(m2, (T2) => {
              T2(d2.cases);
            });
          }
          visitExpansionCase(d2, m2) {
          }
          visitChildren(d2, m2) {
            let T2 = [], w2 = this;
            function g2(N2) {
              N2 && T2.push(a2(w2, N2, d2));
            }
            return m2(g2), Array.prototype.concat.apply([], T2);
          }
        };
        e25.RecursiveVisitor = l2;
        function h2(d2) {
          let m2 = d2.sourceSpan.start.offset, T2 = d2.sourceSpan.end.offset;
          return d2 instanceof f2 && (d2.endSourceSpan ? T2 = d2.endSourceSpan.end.offset : d2.children && d2.children.length && (T2 = h2(d2.children[d2.children.length - 1]).end)), { start: m2, end: T2 };
        }
        function C2(d2, m2) {
          let T2 = [], w2 = new class extends l2 {
            visit(g2, N2) {
              let R2 = h2(g2);
              if (R2.start <= m2 && m2 < R2.end)
                T2.push(g2);
              else
                return true;
            }
          }();
          return a2(w2, d2), new r2.AstPath(T2, m2);
        }
        e25.findNode = C2;
      } }), zl2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/assertions.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        function r2(D2, s2) {
          if (s2 != null) {
            if (!Array.isArray(s2))
              throw new Error(`Expected '${D2}' to be an array of strings.`);
            for (let i2 = 0; i2 < s2.length; i2 += 1)
              if (typeof s2[i2] != "string")
                throw new Error(`Expected '${D2}' to be an array of strings.`);
          }
        }
        e25.assertArrayOfStrings = r2;
        var u2 = [/^\s*$/, /[<>]/, /^[{}]$/, /&(#|[a-z])/i, /^\/\//];
        function n2(D2, s2) {
          if (s2 != null && !(Array.isArray(s2) && s2.length == 2))
            throw new Error(`Expected '${D2}' to be an array, [start, end].`);
          if (s2 != null) {
            let i2 = s2[0], f2 = s2[1];
            u2.forEach((c2) => {
              if (c2.test(i2) || c2.test(f2))
                throw new Error(`['${i2}', '${f2}'] contains unusable interpolation symbol.`);
            });
          }
        }
        e25.assertInterpolationSymbols = n2;
      } }), Wl2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/interpolation_config.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = zl2(), u2 = class {
          constructor(n2, D2) {
            this.start = n2, this.end = D2;
          }
          static fromArray(n2) {
            return n2 ? (r2.assertInterpolationSymbols("interpolation", n2), new u2(n2[0], n2[1])) : e25.DEFAULT_INTERPOLATION_CONFIG;
          }
        };
        e25.InterpolationConfig = u2, e25.DEFAULT_INTERPOLATION_CONFIG = new u2("{{", "}}");
      } }), Yl2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/lexer.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Es2(), u2 = Be2(), n2 = Wl2(), D2 = Ze2(), s2;
        (function(t2) {
          t2[t2.TAG_OPEN_START = 0] = "TAG_OPEN_START", t2[t2.TAG_OPEN_END = 1] = "TAG_OPEN_END", t2[t2.TAG_OPEN_END_VOID = 2] = "TAG_OPEN_END_VOID", t2[t2.TAG_CLOSE = 3] = "TAG_CLOSE", t2[t2.TEXT = 4] = "TEXT", t2[t2.ESCAPABLE_RAW_TEXT = 5] = "ESCAPABLE_RAW_TEXT", t2[t2.RAW_TEXT = 6] = "RAW_TEXT", t2[t2.COMMENT_START = 7] = "COMMENT_START", t2[t2.COMMENT_END = 8] = "COMMENT_END", t2[t2.CDATA_START = 9] = "CDATA_START", t2[t2.CDATA_END = 10] = "CDATA_END", t2[t2.ATTR_NAME = 11] = "ATTR_NAME", t2[t2.ATTR_QUOTE = 12] = "ATTR_QUOTE", t2[t2.ATTR_VALUE = 13] = "ATTR_VALUE", t2[t2.DOC_TYPE_START = 14] = "DOC_TYPE_START", t2[t2.DOC_TYPE_END = 15] = "DOC_TYPE_END", t2[t2.EXPANSION_FORM_START = 16] = "EXPANSION_FORM_START", t2[t2.EXPANSION_CASE_VALUE = 17] = "EXPANSION_CASE_VALUE", t2[t2.EXPANSION_CASE_EXP_START = 18] = "EXPANSION_CASE_EXP_START", t2[t2.EXPANSION_CASE_EXP_END = 19] = "EXPANSION_CASE_EXP_END", t2[t2.EXPANSION_FORM_END = 20] = "EXPANSION_FORM_END", t2[t2.EOF = 21] = "EOF";
        })(s2 = e25.TokenType || (e25.TokenType = {}));
        var i2 = class {
          constructor(t2, o2, E2) {
            this.type = t2, this.parts = o2, this.sourceSpan = E2;
          }
        };
        e25.Token = i2;
        var f2 = class extends u2.ParseError {
          constructor(t2, o2, E2) {
            super(E2, t2), this.tokenType = o2;
          }
        };
        e25.TokenError = f2;
        var c2 = class {
          constructor(t2, o2) {
            this.tokens = t2, this.errors = o2;
          }
        };
        e25.TokenizeResult = c2;
        function F2(t2, o2, E2) {
          let p2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
          return new d2(new u2.ParseSourceFile(t2, o2), E2, p2).tokenize();
        }
        e25.tokenize = F2;
        var a2 = /\r\n?/g;
        function l2(t2) {
          return `Unexpected character "${t2 === r2.$EOF ? "EOF" : String.fromCharCode(t2)}"`;
        }
        function h2(t2) {
          return `Unknown entity "${t2}" - use the "&#<decimal>;" or  "&#x<hex>;" syntax`;
        }
        var C2 = class {
          constructor(t2) {
            this.error = t2;
          }
        }, d2 = class {
          constructor(t2, o2, E2) {
            this._getTagContentType = o2, this._currentTokenStart = null, this._currentTokenType = null, this._expansionCaseStack = [], this._inInterpolation = false, this._fullNameStack = [], this.tokens = [], this.errors = [], this._tokenizeIcu = E2.tokenizeExpansionForms || false, this._interpolationConfig = E2.interpolationConfig || n2.DEFAULT_INTERPOLATION_CONFIG, this._leadingTriviaCodePoints = E2.leadingTriviaChars && E2.leadingTriviaChars.map((A2) => A2.codePointAt(0) || 0), this._canSelfClose = E2.canSelfClose || false, this._allowHtmComponentClosingTags = E2.allowHtmComponentClosingTags || false;
            let p2 = E2.range || { endPos: t2.content.length, startPos: 0, startLine: 0, startCol: 0 };
            this._cursor = E2.escapedString ? new k2(t2, p2) : new x2(t2, p2);
            try {
              this._cursor.init();
            } catch (A2) {
              this.handleError(A2);
            }
          }
          _processCarriageReturns(t2) {
            return t2.replace(a2, `
`);
          }
          tokenize() {
            for (; this._cursor.peek() !== r2.$EOF; ) {
              let t2 = this._cursor.clone();
              try {
                if (this._attemptCharCode(r2.$LT))
                  if (this._attemptCharCode(r2.$BANG))
                    this._attemptStr("[CDATA[") ? this._consumeCdata(t2) : this._attemptStr("--") ? this._consumeComment(t2) : this._attemptStrCaseInsensitive("doctype") ? this._consumeDocType(t2) : this._consumeBogusComment(t2);
                  else if (this._attemptCharCode(r2.$SLASH))
                    this._consumeTagClose(t2);
                  else {
                    let o2 = this._cursor.clone();
                    this._attemptCharCode(r2.$QUESTION) ? (this._cursor = o2, this._consumeBogusComment(t2)) : this._consumeTagOpen(t2);
                  }
                else
                  this._tokenizeIcu && this._tokenizeExpansionForm() || this._consumeText();
              } catch (o2) {
                this.handleError(o2);
              }
            }
            return this._beginToken(s2.EOF), this._endToken([]), new c2(O2(this.tokens), this.errors);
          }
          _tokenizeExpansionForm() {
            if (this.isExpansionFormStart())
              return this._consumeExpansionFormStart(), true;
            if (R2(this._cursor.peek()) && this._isInExpansionForm())
              return this._consumeExpansionCaseStart(), true;
            if (this._cursor.peek() === r2.$RBRACE) {
              if (this._isInExpansionCase())
                return this._consumeExpansionCaseEnd(), true;
              if (this._isInExpansionForm())
                return this._consumeExpansionFormEnd(), true;
            }
            return false;
          }
          _beginToken(t2) {
            let o2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cursor.clone();
            this._currentTokenStart = o2, this._currentTokenType = t2;
          }
          _endToken(t2) {
            let o2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._cursor.clone();
            if (this._currentTokenStart === null)
              throw new f2("Programming error - attempted to end a token when there was no start to the token", this._currentTokenType, this._cursor.getSpan(o2));
            if (this._currentTokenType === null)
              throw new f2("Programming error - attempted to end a token which has no token type", null, this._cursor.getSpan(this._currentTokenStart));
            let E2 = new i2(this._currentTokenType, t2, this._cursor.getSpan(this._currentTokenStart, this._leadingTriviaCodePoints));
            return this.tokens.push(E2), this._currentTokenStart = null, this._currentTokenType = null, E2;
          }
          _createError(t2, o2) {
            this._isInExpansionForm() && (t2 += ` (Do you have an unescaped "{" in your template? Use "{{ '{' }}") to escape it.)`);
            let E2 = new f2(t2, this._currentTokenType, o2);
            return this._currentTokenStart = null, this._currentTokenType = null, new C2(E2);
          }
          handleError(t2) {
            if (t2 instanceof $2 && (t2 = this._createError(t2.msg, this._cursor.getSpan(t2.cursor))), t2 instanceof C2)
              this.errors.push(t2.error);
            else
              throw t2;
          }
          _attemptCharCode(t2) {
            return this._cursor.peek() === t2 ? (this._cursor.advance(), true) : false;
          }
          _attemptCharCodeCaseInsensitive(t2) {
            return j2(this._cursor.peek(), t2) ? (this._cursor.advance(), true) : false;
          }
          _requireCharCode(t2) {
            let o2 = this._cursor.clone();
            if (!this._attemptCharCode(t2))
              throw this._createError(l2(this._cursor.peek()), this._cursor.getSpan(o2));
          }
          _attemptStr(t2) {
            let o2 = t2.length;
            if (this._cursor.charsLeft() < o2)
              return false;
            let E2 = this._cursor.clone();
            for (let p2 = 0; p2 < o2; p2++)
              if (!this._attemptCharCode(t2.charCodeAt(p2)))
                return this._cursor = E2, false;
            return true;
          }
          _attemptStrCaseInsensitive(t2) {
            for (let o2 = 0; o2 < t2.length; o2++)
              if (!this._attemptCharCodeCaseInsensitive(t2.charCodeAt(o2)))
                return false;
            return true;
          }
          _requireStr(t2) {
            let o2 = this._cursor.clone();
            if (!this._attemptStr(t2))
              throw this._createError(l2(this._cursor.peek()), this._cursor.getSpan(o2));
          }
          _requireStrCaseInsensitive(t2) {
            let o2 = this._cursor.clone();
            if (!this._attemptStrCaseInsensitive(t2))
              throw this._createError(l2(this._cursor.peek()), this._cursor.getSpan(o2));
          }
          _attemptCharCodeUntilFn(t2) {
            for (; !t2(this._cursor.peek()); )
              this._cursor.advance();
          }
          _requireCharCodeUntilFn(t2, o2) {
            let E2 = this._cursor.clone();
            if (this._attemptCharCodeUntilFn(t2), this._cursor.clone().diff(E2) < o2)
              throw this._createError(l2(this._cursor.peek()), this._cursor.getSpan(E2));
          }
          _attemptUntilChar(t2) {
            for (; this._cursor.peek() !== t2; )
              this._cursor.advance();
          }
          _readChar(t2) {
            if (t2 && this._cursor.peek() === r2.$AMPERSAND)
              return this._decodeEntity();
            {
              let o2 = String.fromCodePoint(this._cursor.peek());
              return this._cursor.advance(), o2;
            }
          }
          _decodeEntity() {
            let t2 = this._cursor.clone();
            if (this._cursor.advance(), this._attemptCharCode(r2.$HASH)) {
              let o2 = this._attemptCharCode(r2.$x) || this._attemptCharCode(r2.$X), E2 = this._cursor.clone();
              if (this._attemptCharCodeUntilFn(g2), this._cursor.peek() != r2.$SEMICOLON)
                throw this._createError(l2(this._cursor.peek()), this._cursor.getSpan());
              let p2 = this._cursor.getChars(E2);
              this._cursor.advance();
              try {
                let A2 = parseInt(p2, o2 ? 16 : 10);
                return String.fromCharCode(A2);
              } catch {
                throw this._createError(h2(this._cursor.getChars(t2)), this._cursor.getSpan());
              }
            } else {
              let o2 = this._cursor.clone();
              if (this._attemptCharCodeUntilFn(N2), this._cursor.peek() != r2.$SEMICOLON)
                return this._cursor = o2, "&";
              let E2 = this._cursor.getChars(o2);
              this._cursor.advance();
              let p2 = D2.NAMED_ENTITIES[E2];
              if (!p2)
                throw this._createError(h2(E2), this._cursor.getSpan(t2));
              return p2;
            }
          }
          _consumeRawText(t2, o2) {
            this._beginToken(t2 ? s2.ESCAPABLE_RAW_TEXT : s2.RAW_TEXT);
            let E2 = [];
            for (; ; ) {
              let p2 = this._cursor.clone(), A2 = o2();
              if (this._cursor = p2, A2)
                break;
              E2.push(this._readChar(t2));
            }
            return this._endToken([this._processCarriageReturns(E2.join(""))]);
          }
          _consumeComment(t2) {
            this._beginToken(s2.COMMENT_START, t2), this._endToken([]), this._consumeRawText(false, () => this._attemptStr("-->")), this._beginToken(s2.COMMENT_END), this._requireStr("-->"), this._endToken([]);
          }
          _consumeBogusComment(t2) {
            this._beginToken(s2.COMMENT_START, t2), this._endToken([]), this._consumeRawText(false, () => this._cursor.peek() === r2.$GT), this._beginToken(s2.COMMENT_END), this._cursor.advance(), this._endToken([]);
          }
          _consumeCdata(t2) {
            this._beginToken(s2.CDATA_START, t2), this._endToken([]), this._consumeRawText(false, () => this._attemptStr("]]>")), this._beginToken(s2.CDATA_END), this._requireStr("]]>"), this._endToken([]);
          }
          _consumeDocType(t2) {
            this._beginToken(s2.DOC_TYPE_START, t2), this._endToken([]), this._consumeRawText(false, () => this._cursor.peek() === r2.$GT), this._beginToken(s2.DOC_TYPE_END), this._cursor.advance(), this._endToken([]);
          }
          _consumePrefixAndName() {
            let t2 = this._cursor.clone(), o2 = "";
            for (; this._cursor.peek() !== r2.$COLON && !w2(this._cursor.peek()); )
              this._cursor.advance();
            let E2;
            this._cursor.peek() === r2.$COLON ? (o2 = this._cursor.getChars(t2), this._cursor.advance(), E2 = this._cursor.clone()) : E2 = t2, this._requireCharCodeUntilFn(T2, o2 === "" ? 0 : 1);
            let p2 = this._cursor.getChars(E2);
            return [o2, p2];
          }
          _consumeTagOpen(t2) {
            let o2, E2, p2, A2 = this.tokens.length, P2 = this._cursor.clone(), M2 = [];
            try {
              if (!r2.isAsciiLetter(this._cursor.peek()))
                throw this._createError(l2(this._cursor.peek()), this._cursor.getSpan(t2));
              for (p2 = this._consumeTagOpenStart(t2), E2 = p2.parts[0], o2 = p2.parts[1], this._attemptCharCodeUntilFn(m2); this._cursor.peek() !== r2.$SLASH && this._cursor.peek() !== r2.$GT; ) {
                let [V2, X2] = this._consumeAttributeName();
                if (this._attemptCharCodeUntilFn(m2), this._attemptCharCode(r2.$EQ)) {
                  this._attemptCharCodeUntilFn(m2);
                  let H2 = this._consumeAttributeValue();
                  M2.push({ prefix: V2, name: X2, value: H2 });
                } else
                  M2.push({ prefix: V2, name: X2 });
                this._attemptCharCodeUntilFn(m2);
              }
              this._consumeTagOpenEnd();
            } catch (V2) {
              if (V2 instanceof C2) {
                this._cursor = P2, p2 && (this.tokens.length = A2), this._beginToken(s2.TEXT, t2), this._endToken(["<"]);
                return;
              }
              throw V2;
            }
            if (this._canSelfClose && this.tokens[this.tokens.length - 1].type === s2.TAG_OPEN_END_VOID)
              return;
            let z2 = this._getTagContentType(o2, E2, this._fullNameStack.length > 0, M2);
            this._handleFullNameStackForTagOpen(E2, o2), z2 === D2.TagContentType.RAW_TEXT ? this._consumeRawTextWithTagClose(E2, o2, false) : z2 === D2.TagContentType.ESCAPABLE_RAW_TEXT && this._consumeRawTextWithTagClose(E2, o2, true);
          }
          _consumeRawTextWithTagClose(t2, o2, E2) {
            this._consumeRawText(E2, () => !this._attemptCharCode(r2.$LT) || !this._attemptCharCode(r2.$SLASH) || (this._attemptCharCodeUntilFn(m2), !this._attemptStrCaseInsensitive(t2 ? `${t2}:${o2}` : o2)) ? false : (this._attemptCharCodeUntilFn(m2), this._attemptCharCode(r2.$GT)));
            this._beginToken(s2.TAG_CLOSE), this._requireCharCodeUntilFn((A2) => A2 === r2.$GT, 3), this._cursor.advance(), this._endToken([t2, o2]), this._handleFullNameStackForTagClose(t2, o2);
          }
          _consumeTagOpenStart(t2) {
            this._beginToken(s2.TAG_OPEN_START, t2);
            let o2 = this._consumePrefixAndName();
            return this._endToken(o2);
          }
          _consumeAttributeName() {
            let t2 = this._cursor.peek();
            if (t2 === r2.$SQ || t2 === r2.$DQ)
              throw this._createError(l2(t2), this._cursor.getSpan());
            this._beginToken(s2.ATTR_NAME);
            let o2 = this._consumePrefixAndName();
            return this._endToken(o2), o2;
          }
          _consumeAttributeValue() {
            let t2;
            if (this._cursor.peek() === r2.$SQ || this._cursor.peek() === r2.$DQ) {
              this._beginToken(s2.ATTR_QUOTE);
              let o2 = this._cursor.peek();
              this._cursor.advance(), this._endToken([String.fromCodePoint(o2)]), this._beginToken(s2.ATTR_VALUE);
              let E2 = [];
              for (; this._cursor.peek() !== o2; )
                E2.push(this._readChar(true));
              t2 = this._processCarriageReturns(E2.join("")), this._endToken([t2]), this._beginToken(s2.ATTR_QUOTE), this._cursor.advance(), this._endToken([String.fromCodePoint(o2)]);
            } else {
              this._beginToken(s2.ATTR_VALUE);
              let o2 = this._cursor.clone();
              this._requireCharCodeUntilFn(T2, 1), t2 = this._processCarriageReturns(this._cursor.getChars(o2)), this._endToken([t2]);
            }
            return t2;
          }
          _consumeTagOpenEnd() {
            let t2 = this._attemptCharCode(r2.$SLASH) ? s2.TAG_OPEN_END_VOID : s2.TAG_OPEN_END;
            this._beginToken(t2), this._requireCharCode(r2.$GT), this._endToken([]);
          }
          _consumeTagClose(t2) {
            if (this._beginToken(s2.TAG_CLOSE, t2), this._attemptCharCodeUntilFn(m2), this._allowHtmComponentClosingTags && this._attemptCharCode(r2.$SLASH))
              this._attemptCharCodeUntilFn(m2), this._requireCharCode(r2.$GT), this._endToken([]);
            else {
              let [o2, E2] = this._consumePrefixAndName();
              this._attemptCharCodeUntilFn(m2), this._requireCharCode(r2.$GT), this._endToken([o2, E2]), this._handleFullNameStackForTagClose(o2, E2);
            }
          }
          _consumeExpansionFormStart() {
            this._beginToken(s2.EXPANSION_FORM_START), this._requireCharCode(r2.$LBRACE), this._endToken([]), this._expansionCaseStack.push(s2.EXPANSION_FORM_START), this._beginToken(s2.RAW_TEXT);
            let t2 = this._readUntil(r2.$COMMA);
            this._endToken([t2]), this._requireCharCode(r2.$COMMA), this._attemptCharCodeUntilFn(m2), this._beginToken(s2.RAW_TEXT);
            let o2 = this._readUntil(r2.$COMMA);
            this._endToken([o2]), this._requireCharCode(r2.$COMMA), this._attemptCharCodeUntilFn(m2);
          }
          _consumeExpansionCaseStart() {
            this._beginToken(s2.EXPANSION_CASE_VALUE);
            let t2 = this._readUntil(r2.$LBRACE).trim();
            this._endToken([t2]), this._attemptCharCodeUntilFn(m2), this._beginToken(s2.EXPANSION_CASE_EXP_START), this._requireCharCode(r2.$LBRACE), this._endToken([]), this._attemptCharCodeUntilFn(m2), this._expansionCaseStack.push(s2.EXPANSION_CASE_EXP_START);
          }
          _consumeExpansionCaseEnd() {
            this._beginToken(s2.EXPANSION_CASE_EXP_END), this._requireCharCode(r2.$RBRACE), this._endToken([]), this._attemptCharCodeUntilFn(m2), this._expansionCaseStack.pop();
          }
          _consumeExpansionFormEnd() {
            this._beginToken(s2.EXPANSION_FORM_END), this._requireCharCode(r2.$RBRACE), this._endToken([]), this._expansionCaseStack.pop();
          }
          _consumeText() {
            let t2 = this._cursor.clone();
            this._beginToken(s2.TEXT, t2);
            let o2 = [];
            do
              this._interpolationConfig && this._attemptStr(this._interpolationConfig.start) ? (o2.push(this._interpolationConfig.start), this._inInterpolation = true) : this._interpolationConfig && this._inInterpolation && this._attemptStr(this._interpolationConfig.end) ? (o2.push(this._interpolationConfig.end), this._inInterpolation = false) : o2.push(this._readChar(true));
            while (!this._isTextEnd());
            this._endToken([this._processCarriageReturns(o2.join(""))]);
          }
          _isTextEnd() {
            return !!(this._cursor.peek() === r2.$LT || this._cursor.peek() === r2.$EOF || this._tokenizeIcu && !this._inInterpolation && (this.isExpansionFormStart() || this._cursor.peek() === r2.$RBRACE && this._isInExpansionCase()));
          }
          _readUntil(t2) {
            let o2 = this._cursor.clone();
            return this._attemptUntilChar(t2), this._cursor.getChars(o2);
          }
          _isInExpansionCase() {
            return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === s2.EXPANSION_CASE_EXP_START;
          }
          _isInExpansionForm() {
            return this._expansionCaseStack.length > 0 && this._expansionCaseStack[this._expansionCaseStack.length - 1] === s2.EXPANSION_FORM_START;
          }
          isExpansionFormStart() {
            if (this._cursor.peek() !== r2.$LBRACE)
              return false;
            if (this._interpolationConfig) {
              let t2 = this._cursor.clone(), o2 = this._attemptStr(this._interpolationConfig.start);
              return this._cursor = t2, !o2;
            }
            return true;
          }
          _handleFullNameStackForTagOpen(t2, o2) {
            let E2 = D2.mergeNsAndName(t2, o2);
            (this._fullNameStack.length === 0 || this._fullNameStack[this._fullNameStack.length - 1] === E2) && this._fullNameStack.push(E2);
          }
          _handleFullNameStackForTagClose(t2, o2) {
            let E2 = D2.mergeNsAndName(t2, o2);
            this._fullNameStack.length !== 0 && this._fullNameStack[this._fullNameStack.length - 1] === E2 && this._fullNameStack.pop();
          }
        };
        function m2(t2) {
          return !r2.isWhitespace(t2) || t2 === r2.$EOF;
        }
        function T2(t2) {
          return r2.isWhitespace(t2) || t2 === r2.$GT || t2 === r2.$SLASH || t2 === r2.$SQ || t2 === r2.$DQ || t2 === r2.$EQ;
        }
        function w2(t2) {
          return (t2 < r2.$a || r2.$z < t2) && (t2 < r2.$A || r2.$Z < t2) && (t2 < r2.$0 || t2 > r2.$9);
        }
        function g2(t2) {
          return t2 == r2.$SEMICOLON || t2 == r2.$EOF || !r2.isAsciiHexDigit(t2);
        }
        function N2(t2) {
          return t2 == r2.$SEMICOLON || t2 == r2.$EOF || !r2.isAsciiLetter(t2);
        }
        function R2(t2) {
          return t2 === r2.$EQ || r2.isAsciiLetter(t2) || r2.isDigit(t2);
        }
        function j2(t2, o2) {
          return _2(t2) == _2(o2);
        }
        function _2(t2) {
          return t2 >= r2.$a && t2 <= r2.$z ? t2 - r2.$a + r2.$A : t2;
        }
        function O2(t2) {
          let o2 = [], E2;
          for (let p2 = 0; p2 < t2.length; p2++) {
            let A2 = t2[p2];
            E2 && E2.type == s2.TEXT && A2.type == s2.TEXT ? (E2.parts[0] += A2.parts[0], E2.sourceSpan.end = A2.sourceSpan.end) : (E2 = A2, o2.push(E2));
          }
          return o2;
        }
        var x2 = class {
          constructor(t2, o2) {
            if (t2 instanceof x2)
              this.file = t2.file, this.input = t2.input, this.end = t2.end, this.state = Object.assign({}, t2.state);
            else {
              if (!o2)
                throw new Error("Programming error: the range argument must be provided with a file argument.");
              this.file = t2, this.input = t2.content, this.end = o2.endPos, this.state = { peek: -1, offset: o2.startPos, line: o2.startLine, column: o2.startCol };
            }
          }
          clone() {
            return new x2(this);
          }
          peek() {
            return this.state.peek;
          }
          charsLeft() {
            return this.end - this.state.offset;
          }
          diff(t2) {
            return this.state.offset - t2.state.offset;
          }
          advance() {
            this.advanceState(this.state);
          }
          init() {
            this.updatePeek(this.state);
          }
          getSpan(t2, o2) {
            if (t2 = t2 || this, o2)
              for (t2 = t2.clone(); this.diff(t2) > 0 && o2.indexOf(t2.peek()) !== -1; )
                t2.advance();
            return new u2.ParseSourceSpan(new u2.ParseLocation(t2.file, t2.state.offset, t2.state.line, t2.state.column), new u2.ParseLocation(this.file, this.state.offset, this.state.line, this.state.column));
          }
          getChars(t2) {
            return this.input.substring(t2.state.offset, this.state.offset);
          }
          charAt(t2) {
            return this.input.charCodeAt(t2);
          }
          advanceState(t2) {
            if (t2.offset >= this.end)
              throw this.state = t2, new $2('Unexpected character "EOF"', this);
            let o2 = this.charAt(t2.offset);
            o2 === r2.$LF ? (t2.line++, t2.column = 0) : r2.isNewLine(o2) || t2.column++, t2.offset++, this.updatePeek(t2);
          }
          updatePeek(t2) {
            t2.peek = t2.offset >= this.end ? r2.$EOF : this.charAt(t2.offset);
          }
        }, k2 = class extends x2 {
          constructor(t2, o2) {
            t2 instanceof k2 ? (super(t2), this.internalState = Object.assign({}, t2.internalState)) : (super(t2, o2), this.internalState = this.state);
          }
          advance() {
            this.state = this.internalState, super.advance(), this.processEscapeSequence();
          }
          init() {
            super.init(), this.processEscapeSequence();
          }
          clone() {
            return new k2(this);
          }
          getChars(t2) {
            let o2 = t2.clone(), E2 = "";
            for (; o2.internalState.offset < this.internalState.offset; )
              E2 += String.fromCodePoint(o2.peek()), o2.advance();
            return E2;
          }
          processEscapeSequence() {
            let t2 = () => this.internalState.peek;
            if (t2() === r2.$BACKSLASH)
              if (this.internalState = Object.assign({}, this.state), this.advanceState(this.internalState), t2() === r2.$n)
                this.state.peek = r2.$LF;
              else if (t2() === r2.$r)
                this.state.peek = r2.$CR;
              else if (t2() === r2.$v)
                this.state.peek = r2.$VTAB;
              else if (t2() === r2.$t)
                this.state.peek = r2.$TAB;
              else if (t2() === r2.$b)
                this.state.peek = r2.$BSPACE;
              else if (t2() === r2.$f)
                this.state.peek = r2.$FF;
              else if (t2() === r2.$u)
                if (this.advanceState(this.internalState), t2() === r2.$LBRACE) {
                  this.advanceState(this.internalState);
                  let o2 = this.clone(), E2 = 0;
                  for (; t2() !== r2.$RBRACE; )
                    this.advanceState(this.internalState), E2++;
                  this.state.peek = this.decodeHexDigits(o2, E2);
                } else {
                  let o2 = this.clone();
                  this.advanceState(this.internalState), this.advanceState(this.internalState), this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(o2, 4);
                }
              else if (t2() === r2.$x) {
                this.advanceState(this.internalState);
                let o2 = this.clone();
                this.advanceState(this.internalState), this.state.peek = this.decodeHexDigits(o2, 2);
              } else if (r2.isOctalDigit(t2())) {
                let o2 = "", E2 = 0, p2 = this.clone();
                for (; r2.isOctalDigit(t2()) && E2 < 3; )
                  p2 = this.clone(), o2 += String.fromCodePoint(t2()), this.advanceState(this.internalState), E2++;
                this.state.peek = parseInt(o2, 8), this.internalState = p2.internalState;
              } else
                r2.isNewLine(this.internalState.peek) ? (this.advanceState(this.internalState), this.state = this.internalState) : this.state.peek = this.internalState.peek;
          }
          decodeHexDigits(t2, o2) {
            let E2 = this.input.substr(t2.internalState.offset, o2), p2 = parseInt(E2, 16);
            if (isNaN(p2))
              throw t2.state = t2.internalState, new $2("Invalid hexadecimal escape sequence", t2);
            return p2;
          }
        }, $2 = class {
          constructor(t2, o2) {
            this.msg = t2, this.cursor = o2;
          }
        };
        e25.CursorError = $2;
      } }), ls = I2({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/parser.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Be2(), u2 = bs2(), n2 = Yl2(), D2 = Ze2(), s2 = class extends r2.ParseError {
          constructor(a2, l2, h2) {
            super(l2, h2), this.elementName = a2;
          }
          static create(a2, l2, h2) {
            return new s2(a2, l2, h2);
          }
        };
        e25.TreeError = s2;
        var i2 = class {
          constructor(a2, l2) {
            this.rootNodes = a2, this.errors = l2;
          }
        };
        e25.ParseTreeResult = i2;
        var f2 = class {
          constructor(a2) {
            this.getTagDefinition = a2;
          }
          parse(a2, l2, h2) {
            let C2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, d2 = arguments.length > 4 ? arguments[4] : void 0, m2 = (x2) => function(k2) {
              for (var $2 = arguments.length, t2 = new Array($2 > 1 ? $2 - 1 : 0), o2 = 1; o2 < $2; o2++)
                t2[o2 - 1] = arguments[o2];
              return x2(k2.toLowerCase(), ...t2);
            }, T2 = C2 ? this.getTagDefinition : m2(this.getTagDefinition), w2 = (x2) => T2(x2).contentType, g2 = C2 ? d2 : m2(d2), N2 = d2 ? (x2, k2, $2, t2) => {
              let o2 = g2(x2, k2, $2, t2);
              return o2 !== void 0 ? o2 : w2(x2);
            } : w2, R2 = n2.tokenize(a2, l2, N2, h2), j2 = h2 && h2.canSelfClose || false, _2 = h2 && h2.allowHtmComponentClosingTags || false, O2 = new c2(R2.tokens, T2, j2, _2, C2).build();
            return new i2(O2.rootNodes, R2.errors.concat(O2.errors));
          }
        };
        e25.Parser = f2;
        var c2 = class {
          constructor(a2, l2, h2, C2, d2) {
            this.tokens = a2, this.getTagDefinition = l2, this.canSelfClose = h2, this.allowHtmComponentClosingTags = C2, this.isTagNameCaseSensitive = d2, this._index = -1, this._rootNodes = [], this._errors = [], this._elementStack = [], this._advance();
          }
          build() {
            for (; this._peek.type !== n2.TokenType.EOF; )
              this._peek.type === n2.TokenType.TAG_OPEN_START ? this._consumeStartTag(this._advance()) : this._peek.type === n2.TokenType.TAG_CLOSE ? (this._closeVoidElement(), this._consumeEndTag(this._advance())) : this._peek.type === n2.TokenType.CDATA_START ? (this._closeVoidElement(), this._consumeCdata(this._advance())) : this._peek.type === n2.TokenType.COMMENT_START ? (this._closeVoidElement(), this._consumeComment(this._advance())) : this._peek.type === n2.TokenType.TEXT || this._peek.type === n2.TokenType.RAW_TEXT || this._peek.type === n2.TokenType.ESCAPABLE_RAW_TEXT ? (this._closeVoidElement(), this._consumeText(this._advance())) : this._peek.type === n2.TokenType.EXPANSION_FORM_START ? this._consumeExpansion(this._advance()) : this._peek.type === n2.TokenType.DOC_TYPE_START ? this._consumeDocType(this._advance()) : this._advance();
            return new i2(this._rootNodes, this._errors);
          }
          _advance() {
            let a2 = this._peek;
            return this._index < this.tokens.length - 1 && this._index++, this._peek = this.tokens[this._index], a2;
          }
          _advanceIf(a2) {
            return this._peek.type === a2 ? this._advance() : null;
          }
          _consumeCdata(a2) {
            let l2 = this._advance(), h2 = this._getText(l2), C2 = this._advanceIf(n2.TokenType.CDATA_END);
            this._addToParent(new u2.CDATA(h2, new r2.ParseSourceSpan(a2.sourceSpan.start, (C2 || l2).sourceSpan.end)));
          }
          _consumeComment(a2) {
            let l2 = this._advanceIf(n2.TokenType.RAW_TEXT), h2 = this._advanceIf(n2.TokenType.COMMENT_END), C2 = l2 != null ? l2.parts[0].trim() : null, d2 = new r2.ParseSourceSpan(a2.sourceSpan.start, (h2 || l2 || a2).sourceSpan.end);
            this._addToParent(new u2.Comment(C2, d2));
          }
          _consumeDocType(a2) {
            let l2 = this._advanceIf(n2.TokenType.RAW_TEXT), h2 = this._advanceIf(n2.TokenType.DOC_TYPE_END), C2 = l2 != null ? l2.parts[0].trim() : null, d2 = new r2.ParseSourceSpan(a2.sourceSpan.start, (h2 || l2 || a2).sourceSpan.end);
            this._addToParent(new u2.DocType(C2, d2));
          }
          _consumeExpansion(a2) {
            let l2 = this._advance(), h2 = this._advance(), C2 = [];
            for (; this._peek.type === n2.TokenType.EXPANSION_CASE_VALUE; ) {
              let m2 = this._parseExpansionCase();
              if (!m2)
                return;
              C2.push(m2);
            }
            if (this._peek.type !== n2.TokenType.EXPANSION_FORM_END) {
              this._errors.push(s2.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '}'."));
              return;
            }
            let d2 = new r2.ParseSourceSpan(a2.sourceSpan.start, this._peek.sourceSpan.end);
            this._addToParent(new u2.Expansion(l2.parts[0], h2.parts[0], C2, d2, l2.sourceSpan)), this._advance();
          }
          _parseExpansionCase() {
            let a2 = this._advance();
            if (this._peek.type !== n2.TokenType.EXPANSION_CASE_EXP_START)
              return this._errors.push(s2.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '{'.")), null;
            let l2 = this._advance(), h2 = this._collectExpansionExpTokens(l2);
            if (!h2)
              return null;
            let C2 = this._advance();
            h2.push(new n2.Token(n2.TokenType.EOF, [], C2.sourceSpan));
            let d2 = new c2(h2, this.getTagDefinition, this.canSelfClose, this.allowHtmComponentClosingTags, this.isTagNameCaseSensitive).build();
            if (d2.errors.length > 0)
              return this._errors = this._errors.concat(d2.errors), null;
            let m2 = new r2.ParseSourceSpan(a2.sourceSpan.start, C2.sourceSpan.end), T2 = new r2.ParseSourceSpan(l2.sourceSpan.start, C2.sourceSpan.end);
            return new u2.ExpansionCase(a2.parts[0], d2.rootNodes, m2, a2.sourceSpan, T2);
          }
          _collectExpansionExpTokens(a2) {
            let l2 = [], h2 = [n2.TokenType.EXPANSION_CASE_EXP_START];
            for (; ; ) {
              if ((this._peek.type === n2.TokenType.EXPANSION_FORM_START || this._peek.type === n2.TokenType.EXPANSION_CASE_EXP_START) && h2.push(this._peek.type), this._peek.type === n2.TokenType.EXPANSION_CASE_EXP_END)
                if (F2(h2, n2.TokenType.EXPANSION_CASE_EXP_START)) {
                  if (h2.pop(), h2.length == 0)
                    return l2;
                } else
                  return this._errors.push(s2.create(null, a2.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
              if (this._peek.type === n2.TokenType.EXPANSION_FORM_END)
                if (F2(h2, n2.TokenType.EXPANSION_FORM_START))
                  h2.pop();
                else
                  return this._errors.push(s2.create(null, a2.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
              if (this._peek.type === n2.TokenType.EOF)
                return this._errors.push(s2.create(null, a2.sourceSpan, "Invalid ICU message. Missing '}'.")), null;
              l2.push(this._advance());
            }
          }
          _getText(a2) {
            let l2 = a2.parts[0];
            if (l2.length > 0 && l2[0] == `
`) {
              let h2 = this._getParentElement();
              h2 != null && h2.children.length == 0 && this.getTagDefinition(h2.name).ignoreFirstLf && (l2 = l2.substring(1));
            }
            return l2;
          }
          _consumeText(a2) {
            let l2 = this._getText(a2);
            l2.length > 0 && this._addToParent(new u2.Text(l2, a2.sourceSpan));
          }
          _closeVoidElement() {
            let a2 = this._getParentElement();
            a2 && this.getTagDefinition(a2.name).isVoid && this._elementStack.pop();
          }
          _consumeStartTag(a2) {
            let l2 = a2.parts[0], h2 = a2.parts[1], C2 = [];
            for (; this._peek.type === n2.TokenType.ATTR_NAME; )
              C2.push(this._consumeAttr(this._advance()));
            let d2 = this._getElementFullName(l2, h2, this._getParentElement()), m2 = false;
            if (this._peek.type === n2.TokenType.TAG_OPEN_END_VOID) {
              this._advance(), m2 = true;
              let R2 = this.getTagDefinition(d2);
              this.canSelfClose || R2.canSelfClose || D2.getNsPrefix(d2) !== null || R2.isVoid || this._errors.push(s2.create(d2, a2.sourceSpan, `Only void and foreign elements can be self closed "${a2.parts[1]}"`));
            } else
              this._peek.type === n2.TokenType.TAG_OPEN_END && (this._advance(), m2 = false);
            let T2 = this._peek.sourceSpan.start, w2 = new r2.ParseSourceSpan(a2.sourceSpan.start, T2), g2 = new r2.ParseSourceSpan(a2.sourceSpan.start.moveBy(1), a2.sourceSpan.end), N2 = new u2.Element(d2, C2, [], w2, w2, void 0, g2);
            this._pushElement(N2), m2 && (this._popElement(d2), N2.endSourceSpan = w2);
          }
          _pushElement(a2) {
            let l2 = this._getParentElement();
            l2 && this.getTagDefinition(l2.name).isClosedByChild(a2.name) && this._elementStack.pop(), this._addToParent(a2), this._elementStack.push(a2);
          }
          _consumeEndTag(a2) {
            let l2 = this.allowHtmComponentClosingTags && a2.parts.length === 0 ? null : this._getElementFullName(a2.parts[0], a2.parts[1], this._getParentElement());
            if (this._getParentElement() && (this._getParentElement().endSourceSpan = a2.sourceSpan), l2 && this.getTagDefinition(l2).isVoid)
              this._errors.push(s2.create(l2, a2.sourceSpan, `Void elements do not have end tags "${a2.parts[1]}"`));
            else if (!this._popElement(l2)) {
              let h2 = `Unexpected closing tag "${l2}". It may happen when the tag has already been closed by another tag. For more info see https://www.w3.org/TR/html5/syntax.html#closing-elements-that-have-implied-end-tags`;
              this._errors.push(s2.create(l2, a2.sourceSpan, h2));
            }
          }
          _popElement(a2) {
            for (let l2 = this._elementStack.length - 1; l2 >= 0; l2--) {
              let h2 = this._elementStack[l2];
              if (!a2 || (D2.getNsPrefix(h2.name) ? h2.name == a2 : h2.name.toLowerCase() == a2.toLowerCase()))
                return this._elementStack.splice(l2, this._elementStack.length - l2), true;
              if (!this.getTagDefinition(h2.name).closedByParent)
                return false;
            }
            return false;
          }
          _consumeAttr(a2) {
            let l2 = D2.mergeNsAndName(a2.parts[0], a2.parts[1]), h2 = a2.sourceSpan.end, C2 = "", d2, m2;
            if (this._peek.type === n2.TokenType.ATTR_QUOTE && (m2 = this._advance().sourceSpan.start), this._peek.type === n2.TokenType.ATTR_VALUE) {
              let T2 = this._advance();
              C2 = T2.parts[0], h2 = T2.sourceSpan.end, d2 = T2.sourceSpan;
            }
            return this._peek.type === n2.TokenType.ATTR_QUOTE && (h2 = this._advance().sourceSpan.end, d2 = new r2.ParseSourceSpan(m2, h2)), new u2.Attribute(l2, C2, new r2.ParseSourceSpan(a2.sourceSpan.start, h2), d2, a2.sourceSpan);
          }
          _getParentElement() {
            return this._elementStack.length > 0 ? this._elementStack[this._elementStack.length - 1] : null;
          }
          _getParentElementSkippingContainers() {
            let a2 = null;
            for (let l2 = this._elementStack.length - 1; l2 >= 0; l2--) {
              if (!D2.isNgContainer(this._elementStack[l2].name))
                return { parent: this._elementStack[l2], container: a2 };
              a2 = this._elementStack[l2];
            }
            return { parent: null, container: a2 };
          }
          _addToParent(a2) {
            let l2 = this._getParentElement();
            l2 != null ? l2.children.push(a2) : this._rootNodes.push(a2);
          }
          _insertBeforeContainer(a2, l2, h2) {
            if (!l2)
              this._addToParent(h2), this._elementStack.push(h2);
            else {
              if (a2) {
                let C2 = a2.children.indexOf(l2);
                a2.children[C2] = h2;
              } else
                this._rootNodes.push(h2);
              h2.children.push(l2), this._elementStack.splice(this._elementStack.indexOf(l2), 0, h2);
            }
          }
          _getElementFullName(a2, l2, h2) {
            return a2 === "" && (a2 = this.getTagDefinition(l2).implicitNamespacePrefix || "", a2 === "" && h2 != null && (a2 = D2.getNsPrefix(h2.name))), D2.mergeNsAndName(a2, l2);
          }
        };
        function F2(a2, l2) {
          return a2.length > 0 && a2[a2.length - 1] === l2;
        }
      } }), Ql2 = I2({ "node_modules/angular-html-parser/lib/compiler/src/ml_parser/html_parser.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Bs2(), u2 = ls(), n2 = ls();
        e25.ParseTreeResult = n2.ParseTreeResult, e25.TreeError = n2.TreeError;
        var D2 = class extends u2.Parser {
          constructor() {
            super(r2.getHtmlTagDefinition);
          }
          parse(s2, i2, f2) {
            let c2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, F2 = arguments.length > 4 ? arguments[4] : void 0;
            return super.parse(s2, i2, f2, c2, F2);
          }
        };
        e25.HtmlParser = D2;
      } }), ws2 = I2({ "node_modules/angular-html-parser/lib/angular-html-parser/src/index.js"(e25) {
        q2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Ql2(), u2 = Ze2();
        e25.TagContentType = u2.TagContentType;
        var n2 = null, D2 = () => (n2 || (n2 = new r2.HtmlParser()), n2);
        function s2(i2) {
          let f2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { canSelfClose: c2 = false, allowHtmComponentClosingTags: F2 = false, isTagNameCaseSensitive: a2 = false, getTagContentType: l2 } = f2;
          return D2().parse(i2, "angular-html-parser", { tokenizeExpansionForms: false, interpolationConfig: void 0, canSelfClose: c2, allowHtmComponentClosingTags: F2 }, a2, l2);
        }
        e25.parse = s2;
      } });
      q2();
      var { ParseSourceSpan: Qe2, ParseLocation: cs, ParseSourceFile: Kl2 } = Be2(), Jl2 = ol2(), Zl2 = Cs2(), ec2 = Dl2(), { inferParserByLanguage: rc2 } = xl2(), uc2 = kl2(), Vr2 = Ml2(), hs = jl2(), { hasPragma: tc2 } = Ul2(), { Node: nc2 } = Gl2(), { parseIeConditionalComment: sc2 } = Vl2(), { locStart: ic2, locEnd: ac2 } = Xl2();
      function oc2(e25, r2, u2) {
        let { recognizeSelfClosing: n2, normalizeTagName: D2, normalizeAttributeName: s2, allowHtmComponentClosingTags: i2, isTagNameCaseSensitive: f2, getTagContentType: c2 } = r2, F2 = ws2(), { RecursiveVisitor: a2, visitAll: l2 } = bs2(), { ParseSourceSpan: h2 } = Be2(), { getHtmlTagDefinition: C2 } = Bs2(), { rootNodes: d2, errors: m2 } = F2.parse(e25, { canSelfClose: n2, allowHtmComponentClosingTags: i2, isTagNameCaseSensitive: f2, getTagContentType: c2 });
        if (u2.parser === "vue")
          if (d2.some((O2) => O2.type === "docType" && O2.value === "html" || O2.type === "element" && O2.name.toLowerCase() === "html")) {
            n2 = true, D2 = true, s2 = true, i2 = true, f2 = false;
            let O2 = F2.parse(e25, { canSelfClose: n2, allowHtmComponentClosingTags: i2, isTagNameCaseSensitive: f2 });
            d2 = O2.rootNodes, m2 = O2.errors;
          } else {
            let O2 = (x2) => {
              if (!x2 || x2.type !== "element" || x2.name !== "template")
                return false;
              let k2 = x2.attrs.find((t2) => t2.name === "lang"), $2 = k2 && k2.value;
              return !$2 || rc2($2, u2) === "html";
            };
            if (d2.some(O2)) {
              let x2, k2 = () => F2.parse(e25, { canSelfClose: n2, allowHtmComponentClosingTags: i2, isTagNameCaseSensitive: f2 }), $2 = () => x2 || (x2 = k2()), t2 = (o2) => $2().rootNodes.find((E2) => {
                let { startSourceSpan: p2 } = E2;
                return p2 && p2.start.offset === o2.startSourceSpan.start.offset;
              });
              for (let o2 = 0; o2 < d2.length; o2++) {
                let E2 = d2[o2], { endSourceSpan: p2, startSourceSpan: A2 } = E2;
                if (p2 === null)
                  m2 = $2().errors, d2[o2] = t2(E2) || E2;
                else if (O2(E2)) {
                  let M2 = $2(), z2 = A2.end.offset, V2 = p2.start.offset;
                  for (let X2 of M2.errors) {
                    let { offset: H2 } = X2.span.start;
                    if (z2 < H2 && H2 < V2) {
                      m2 = [X2];
                      break;
                    }
                  }
                  d2[o2] = t2(E2) || E2;
                }
              }
            }
          }
        if (m2.length > 0) {
          let { msg: _2, span: { start: O2, end: x2 } } = m2[0];
          throw ec2(_2, { start: { line: O2.line + 1, column: O2.col + 1 }, end: { line: x2.line + 1, column: x2.col + 1 } });
        }
        let T2 = (_2) => {
          let O2 = _2.name.startsWith(":") ? _2.name.slice(1).split(":")[0] : null, x2 = _2.nameSpan.toString(), k2 = O2 !== null && x2.startsWith(`${O2}:`), $2 = k2 ? x2.slice(O2.length + 1) : x2;
          _2.name = $2, _2.namespace = O2, _2.hasExplicitNamespace = k2;
        }, w2 = (_2) => {
          switch (_2.type) {
            case "element":
              T2(_2);
              for (let O2 of _2.attrs)
                T2(O2), O2.valueSpan ? (O2.value = O2.valueSpan.toString(), /["']/.test(O2.value[0]) && (O2.value = O2.value.slice(1, -1))) : O2.value = null;
              break;
            case "comment":
              _2.value = _2.sourceSpan.toString().slice(4, -3);
              break;
            case "text":
              _2.value = _2.sourceSpan.toString();
              break;
          }
        }, g2 = (_2, O2) => {
          let x2 = _2.toLowerCase();
          return O2(x2) ? x2 : _2;
        }, N2 = (_2) => {
          if (_2.type === "element" && (D2 && (!_2.namespace || _2.namespace === _2.tagDefinition.implicitNamespacePrefix || hs(_2)) && (_2.name = g2(_2.name, (O2) => O2 in uc2)), s2)) {
            let O2 = Vr2[_2.name] || Object.create(null);
            for (let x2 of _2.attrs)
              x2.namespace || (x2.name = g2(x2.name, (k2) => _2.name in Vr2 && (k2 in Vr2["*"] || k2 in O2)));
          }
        }, R2 = (_2) => {
          _2.sourceSpan && _2.endSourceSpan && (_2.sourceSpan = new h2(_2.sourceSpan.start, _2.endSourceSpan.end));
        }, j2 = (_2) => {
          if (_2.type === "element") {
            let O2 = C2(f2 ? _2.name : _2.name.toLowerCase());
            !_2.namespace || _2.namespace === O2.implicitNamespacePrefix || hs(_2) ? _2.tagDefinition = O2 : _2.tagDefinition = C2("");
          }
        };
        return l2(new class extends a2 {
          visit(_2) {
            w2(_2), j2(_2), N2(_2), R2(_2);
          }
        }(), d2), d2;
      }
      function Ns2(e25, r2, u2) {
        let n2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, { frontMatter: D2, content: s2 } = n2 ? Jl2(e25) : { frontMatter: null, content: e25 }, i2 = new Kl2(e25, r2.filepath), f2 = new cs(i2, 0, 0, 0), c2 = f2.moveBy(e25.length), F2 = { type: "root", sourceSpan: new Qe2(f2, c2), children: oc2(s2, u2, r2) };
        if (D2) {
          let h2 = new cs(i2, 0, 0, 0), C2 = h2.moveBy(D2.raw.length);
          D2.sourceSpan = new Qe2(h2, C2), F2.children.unshift(D2);
        }
        let a2 = new nc2(F2), l2 = (h2, C2) => {
          let { offset: d2 } = C2, m2 = e25.slice(0, d2).replace(/[^\n\r]/g, " "), w2 = Ns2(m2 + h2, r2, u2, false);
          w2.sourceSpan = new Qe2(C2, Zl2(w2.children).sourceSpan.end);
          let g2 = w2.children[0];
          return g2.length === d2 ? w2.children.shift() : (g2.sourceSpan = new Qe2(g2.sourceSpan.start.moveBy(d2), g2.sourceSpan.end), g2.value = g2.value.slice(d2)), w2;
        };
        return a2.walk((h2) => {
          if (h2.type === "comment") {
            let C2 = sc2(h2, l2);
            C2 && h2.parent.replaceChild(h2, C2);
          }
        }), a2;
      }
      function Ke2() {
        let { name: e25, recognizeSelfClosing: r2 = false, normalizeTagName: u2 = false, normalizeAttributeName: n2 = false, allowHtmComponentClosingTags: D2 = false, isTagNameCaseSensitive: s2 = false, getTagContentType: i2 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return { parse: (f2, c2, F2) => Ns2(f2, Object.assign({ parser: e25 }, F2), { recognizeSelfClosing: r2, normalizeTagName: u2, normalizeAttributeName: n2, allowHtmComponentClosingTags: D2, isTagNameCaseSensitive: s2, getTagContentType: i2 }), hasPragma: tc2, astFormat: "html", locStart: ic2, locEnd: ac2 };
      }
      Os2.exports = { parsers: { html: Ke2({ name: "html", recognizeSelfClosing: true, normalizeTagName: true, normalizeAttributeName: true, allowHtmComponentClosingTags: true }), angular: Ke2({ name: "angular" }), vue: Ke2({ name: "vue", recognizeSelfClosing: true, isTagNameCaseSensitive: true, getTagContentType: (e25, r2, u2, n2) => {
        if (e25.toLowerCase() !== "html" && !u2 && (e25 !== "template" || n2.some((D2) => {
          let { name: s2, value: i2 } = D2;
          return s2 === "lang" && i2 !== "html" && i2 !== "" && i2 !== void 0;
        })))
          return ws2().TagContentType.RAW_TEXT;
      } }), lwc: Ke2({ name: "lwc" }) } };
    });
    return Dc2();
  });
})(parserHtml$1);
var parserHtml = /* @__PURE__ */ getDefaultExportFromCjs(parserHtml$1.exports);
var standalone = { exports: {} };
(function(module2, exports2) {
  (function(e25) {
    module2.exports = e25();
  })(function() {
    var xe2 = (e25, r2) => () => (r2 || e25((r2 = { exports: {} }).exports, r2), r2.exports);
    var pt2 = xe2((t0, pu2) => {
      var ir2 = function(e25) {
        return e25 && e25.Math == Math && e25;
      };
      pu2.exports = ir2(typeof globalThis == "object" && globalThis) || ir2(typeof window == "object" && window) || ir2(typeof self == "object" && self) || ir2(typeof commonjsGlobal == "object" && commonjsGlobal) || function() {
        return this;
      }() || Function("return this")();
    });
    var Dt2 = xe2((r0, fu2) => {
      fu2.exports = function(e25) {
        try {
          return !!e25();
        } catch {
          return true;
        }
      };
    });
    var yt2 = xe2((n0, Du2) => {
      var Mo2 = Dt2();
      Du2.exports = !Mo2(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    });
    var ar2 = xe2((u0, mu2) => {
      var Ro2 = Dt2();
      mu2.exports = !Ro2(function() {
        var e25 = function() {
        }.bind();
        return typeof e25 != "function" || e25.hasOwnProperty("prototype");
      });
    });
    var At2 = xe2((s0, du2) => {
      var $o2 = ar2(), or2 = Function.prototype.call;
      du2.exports = $o2 ? or2.bind(or2) : function() {
        return or2.apply(or2, arguments);
      };
    });
    var vu2 = xe2((hu2) => {
      var gu2 = {}.propertyIsEnumerable, yu2 = Object.getOwnPropertyDescriptor, Vo2 = yu2 && !gu2.call({ 1: 2 }, 1);
      hu2.f = Vo2 ? function(r2) {
        var t2 = yu2(this, r2);
        return !!t2 && t2.enumerable;
      } : gu2;
    });
    var lr2 = xe2((a0, Cu2) => {
      Cu2.exports = function(e25, r2) {
        return { enumerable: !(e25 & 1), configurable: !(e25 & 2), writable: !(e25 & 4), value: r2 };
      };
    });
    var mt2 = xe2((o0, Au2) => {
      var Eu2 = ar2(), Fu2 = Function.prototype, Wr2 = Fu2.call, Wo2 = Eu2 && Fu2.bind.bind(Wr2, Wr2);
      Au2.exports = Eu2 ? Wo2 : function(e25) {
        return function() {
          return Wr2.apply(e25, arguments);
        };
      };
    });
    var Vt2 = xe2((l0, xu2) => {
      var Su2 = mt2(), Ho2 = Su2({}.toString), Go2 = Su2("".slice);
      xu2.exports = function(e25) {
        return Go2(Ho2(e25), 8, -1);
      };
    });
    var Tu2 = xe2((c0, bu2) => {
      var Uo2 = mt2(), Jo2 = Dt2(), zo2 = Vt2(), Hr2 = Object, Xo2 = Uo2("".split);
      bu2.exports = Jo2(function() {
        return !Hr2("z").propertyIsEnumerable(0);
      }) ? function(e25) {
        return zo2(e25) == "String" ? Xo2(e25, "") : Hr2(e25);
      } : Hr2;
    });
    var cr2 = xe2((p0, Bu2) => {
      Bu2.exports = function(e25) {
        return e25 == null;
      };
    });
    var Gr2 = xe2((f0, Nu2) => {
      var Ko2 = cr2(), Yo2 = TypeError;
      Nu2.exports = function(e25) {
        if (Ko2(e25))
          throw Yo2("Can't call method on " + e25);
        return e25;
      };
    });
    var pr2 = xe2((D0, wu2) => {
      var Qo2 = Tu2(), Zo2 = Gr2();
      wu2.exports = function(e25) {
        return Qo2(Zo2(e25));
      };
    });
    var Jr2 = xe2((m0, _u2) => {
      var Ur2 = typeof document == "object" && document.all, el2 = typeof Ur2 > "u" && Ur2 !== void 0;
      _u2.exports = { all: Ur2, IS_HTMLDDA: el2 };
    });
    var ot2 = xe2((d0, Iu2) => {
      var Pu2 = Jr2(), tl2 = Pu2.all;
      Iu2.exports = Pu2.IS_HTMLDDA ? function(e25) {
        return typeof e25 == "function" || e25 === tl2;
      } : function(e25) {
        return typeof e25 == "function";
      };
    });
    var St2 = xe2((g0, Ou2) => {
      var ku2 = ot2(), Lu2 = Jr2(), rl2 = Lu2.all;
      Ou2.exports = Lu2.IS_HTMLDDA ? function(e25) {
        return typeof e25 == "object" ? e25 !== null : ku2(e25) || e25 === rl2;
      } : function(e25) {
        return typeof e25 == "object" ? e25 !== null : ku2(e25);
      };
    });
    var Wt2 = xe2((y0, ju2) => {
      var zr2 = pt2(), nl2 = ot2(), ul2 = function(e25) {
        return nl2(e25) ? e25 : void 0;
      };
      ju2.exports = function(e25, r2) {
        return arguments.length < 2 ? ul2(zr2[e25]) : zr2[e25] && zr2[e25][r2];
      };
    });
    var Xr2 = xe2((h0, qu2) => {
      var sl2 = mt2();
      qu2.exports = sl2({}.isPrototypeOf);
    });
    var Ru2 = xe2((v0, Mu2) => {
      var il2 = Wt2();
      Mu2.exports = il2("navigator", "userAgent") || "";
    });
    var Ju2 = xe2((C0, Uu2) => {
      var Gu2 = pt2(), Kr2 = Ru2(), $u2 = Gu2.process, Vu2 = Gu2.Deno, Wu2 = $u2 && $u2.versions || Vu2 && Vu2.version, Hu2 = Wu2 && Wu2.v8, dt2, fr2;
      Hu2 && (dt2 = Hu2.split("."), fr2 = dt2[0] > 0 && dt2[0] < 4 ? 1 : +(dt2[0] + dt2[1]));
      !fr2 && Kr2 && (dt2 = Kr2.match(/Edge\/(\d+)/), (!dt2 || dt2[1] >= 74) && (dt2 = Kr2.match(/Chrome\/(\d+)/), dt2 && (fr2 = +dt2[1])));
      Uu2.exports = fr2;
    });
    var Yr2 = xe2((E0, Xu2) => {
      var zu2 = Ju2(), al2 = Dt2();
      Xu2.exports = !!Object.getOwnPropertySymbols && !al2(function() {
        var e25 = Symbol();
        return !String(e25) || !(Object(e25) instanceof Symbol) || !Symbol.sham && zu2 && zu2 < 41;
      });
    });
    var Qr2 = xe2((F0, Ku2) => {
      var ol2 = Yr2();
      Ku2.exports = ol2 && !Symbol.sham && typeof Symbol.iterator == "symbol";
    });
    var Zr2 = xe2((A0, Yu2) => {
      var ll2 = Wt2(), cl2 = ot2(), pl2 = Xr2(), fl2 = Qr2(), Dl2 = Object;
      Yu2.exports = fl2 ? function(e25) {
        return typeof e25 == "symbol";
      } : function(e25) {
        var r2 = ll2("Symbol");
        return cl2(r2) && pl2(r2.prototype, Dl2(e25));
      };
    });
    var Dr2 = xe2((S0, Qu2) => {
      var ml2 = String;
      Qu2.exports = function(e25) {
        try {
          return ml2(e25);
        } catch {
          return "Object";
        }
      };
    });
    var Ht2 = xe2((x0, Zu2) => {
      var dl2 = ot2(), gl2 = Dr2(), yl2 = TypeError;
      Zu2.exports = function(e25) {
        if (dl2(e25))
          return e25;
        throw yl2(gl2(e25) + " is not a function");
      };
    });
    var mr2 = xe2((b0, es2) => {
      var hl2 = Ht2(), vl2 = cr2();
      es2.exports = function(e25, r2) {
        var t2 = e25[r2];
        return vl2(t2) ? void 0 : hl2(t2);
      };
    });
    var rs2 = xe2((T0, ts2) => {
      var en2 = At2(), tn2 = ot2(), rn2 = St2(), Cl2 = TypeError;
      ts2.exports = function(e25, r2) {
        var t2, s2;
        if (r2 === "string" && tn2(t2 = e25.toString) && !rn2(s2 = en2(t2, e25)) || tn2(t2 = e25.valueOf) && !rn2(s2 = en2(t2, e25)) || r2 !== "string" && tn2(t2 = e25.toString) && !rn2(s2 = en2(t2, e25)))
          return s2;
        throw Cl2("Can't convert object to primitive value");
      };
    });
    var us2 = xe2((B0, ns2) => {
      ns2.exports = false;
    });
    var dr2 = xe2((N0, is2) => {
      var ss2 = pt2(), El2 = Object.defineProperty;
      is2.exports = function(e25, r2) {
        try {
          El2(ss2, e25, { value: r2, configurable: true, writable: true });
        } catch {
          ss2[e25] = r2;
        }
        return r2;
      };
    });
    var gr2 = xe2((w0, os2) => {
      var Fl2 = pt2(), Al2 = dr2(), as2 = "__core-js_shared__", Sl2 = Fl2[as2] || Al2(as2, {});
      os2.exports = Sl2;
    });
    var nn2 = xe2((_0, cs) => {
      var xl2 = us2(), ls = gr2();
      (cs.exports = function(e25, r2) {
        return ls[e25] || (ls[e25] = r2 !== void 0 ? r2 : {});
      })("versions", []).push({ version: "3.26.1", mode: xl2 ? "pure" : "global", copyright: "\xA9 2014-2022 Denis Pushkarev (zloirock.ru)", license: "https://github.com/zloirock/core-js/blob/v3.26.1/LICENSE", source: "https://github.com/zloirock/core-js" });
    });
    var yr2 = xe2((P0, ps) => {
      var bl2 = Gr2(), Tl2 = Object;
      ps.exports = function(e25) {
        return Tl2(bl2(e25));
      };
    });
    var Ct2 = xe2((I0, fs) => {
      var Bl2 = mt2(), Nl2 = yr2(), wl2 = Bl2({}.hasOwnProperty);
      fs.exports = Object.hasOwn || function(r2, t2) {
        return wl2(Nl2(r2), t2);
      };
    });
    var un2 = xe2((k0, Ds2) => {
      var _l2 = mt2(), Pl2 = 0, Il2 = Math.random(), kl2 = _l2(1 .toString);
      Ds2.exports = function(e25) {
        return "Symbol(" + (e25 === void 0 ? "" : e25) + ")_" + kl2(++Pl2 + Il2, 36);
      };
    });
    var bt = xe2((L0, hs) => {
      var Ll2 = pt2(), Ol2 = nn2(), ms = Ct2(), jl2 = un2(), ds = Yr2(), ys = Qr2(), Pt2 = Ol2("wks"), xt = Ll2.Symbol, gs = xt && xt.for, ql2 = ys ? xt : xt && xt.withoutSetter || jl2;
      hs.exports = function(e25) {
        if (!ms(Pt2, e25) || !(ds || typeof Pt2[e25] == "string")) {
          var r2 = "Symbol." + e25;
          ds && ms(xt, e25) ? Pt2[e25] = xt[e25] : ys && gs ? Pt2[e25] = gs(r2) : Pt2[e25] = ql2(r2);
        }
        return Pt2[e25];
      };
    });
    var Fs2 = xe2((O0, Es2) => {
      var Ml2 = At2(), vs = St2(), Cs2 = Zr2(), Rl2 = mr2(), $l2 = rs2(), Vl2 = bt(), Wl2 = TypeError, Hl2 = Vl2("toPrimitive");
      Es2.exports = function(e25, r2) {
        if (!vs(e25) || Cs2(e25))
          return e25;
        var t2 = Rl2(e25, Hl2), s2;
        if (t2) {
          if (r2 === void 0 && (r2 = "default"), s2 = Ml2(t2, e25, r2), !vs(s2) || Cs2(s2))
            return s2;
          throw Wl2("Can't convert object to primitive value");
        }
        return r2 === void 0 && (r2 = "number"), $l2(e25, r2);
      };
    });
    var hr2 = xe2((j0, As2) => {
      var Gl2 = Fs2(), Ul2 = Zr2();
      As2.exports = function(e25) {
        var r2 = Gl2(e25, "string");
        return Ul2(r2) ? r2 : r2 + "";
      };
    });
    var bs2 = xe2((q0, xs) => {
      var Jl2 = pt2(), Ss2 = St2(), sn2 = Jl2.document, zl2 = Ss2(sn2) && Ss2(sn2.createElement);
      xs.exports = function(e25) {
        return zl2 ? sn2.createElement(e25) : {};
      };
    });
    var an2 = xe2((M0, Ts2) => {
      var Xl2 = yt2(), Kl2 = Dt2(), Yl2 = bs2();
      Ts2.exports = !Xl2 && !Kl2(function() {
        return Object.defineProperty(Yl2("div"), "a", { get: function() {
          return 7;
        } }).a != 7;
      });
    });
    var on2 = xe2((Ns2) => {
      var Ql2 = yt2(), Zl2 = At2(), ec2 = vu2(), tc2 = lr2(), rc2 = pr2(), nc2 = hr2(), uc2 = Ct2(), sc2 = an2(), Bs2 = Object.getOwnPropertyDescriptor;
      Ns2.f = Ql2 ? Bs2 : function(r2, t2) {
        if (r2 = rc2(r2), t2 = nc2(t2), sc2)
          try {
            return Bs2(r2, t2);
          } catch {
          }
        if (uc2(r2, t2))
          return tc2(!Zl2(ec2.f, r2, t2), r2[t2]);
      };
    });
    var _s2 = xe2(($0, ws2) => {
      var ic2 = yt2(), ac2 = Dt2();
      ws2.exports = ic2 && ac2(function() {
        return Object.defineProperty(function() {
        }, "prototype", { value: 42, writable: false }).prototype != 42;
      });
    });
    var Tt2 = xe2((V0, Ps2) => {
      var oc2 = St2(), lc2 = String, cc2 = TypeError;
      Ps2.exports = function(e25) {
        if (oc2(e25))
          return e25;
        throw cc2(lc2(e25) + " is not an object");
      };
    });
    var It2 = xe2((ks2) => {
      var pc2 = yt2(), fc2 = an2(), Dc2 = _s2(), vr2 = Tt2(), Is2 = hr2(), mc2 = TypeError, ln2 = Object.defineProperty, dc2 = Object.getOwnPropertyDescriptor, cn2 = "enumerable", pn2 = "configurable", fn2 = "writable";
      ks2.f = pc2 ? Dc2 ? function(r2, t2, s2) {
        if (vr2(r2), t2 = Is2(t2), vr2(s2), typeof r2 == "function" && t2 === "prototype" && "value" in s2 && fn2 in s2 && !s2[fn2]) {
          var a2 = dc2(r2, t2);
          a2 && a2[fn2] && (r2[t2] = s2.value, s2 = { configurable: pn2 in s2 ? s2[pn2] : a2[pn2], enumerable: cn2 in s2 ? s2[cn2] : a2[cn2], writable: false });
        }
        return ln2(r2, t2, s2);
      } : ln2 : function(r2, t2, s2) {
        if (vr2(r2), t2 = Is2(t2), vr2(s2), fc2)
          try {
            return ln2(r2, t2, s2);
          } catch {
          }
        if ("get" in s2 || "set" in s2)
          throw mc2("Accessors not supported");
        return "value" in s2 && (r2[t2] = s2.value), r2;
      };
    });
    var Dn2 = xe2((H0, Ls2) => {
      var gc2 = yt2(), yc2 = It2(), hc2 = lr2();
      Ls2.exports = gc2 ? function(e25, r2, t2) {
        return yc2.f(e25, r2, hc2(1, t2));
      } : function(e25, r2, t2) {
        return e25[r2] = t2, e25;
      };
    });
    var qs2 = xe2((G0, js2) => {
      var mn2 = yt2(), vc2 = Ct2(), Os2 = Function.prototype, Cc2 = mn2 && Object.getOwnPropertyDescriptor, dn2 = vc2(Os2, "name"), Ec2 = dn2 && function() {
      }.name === "something", Fc2 = dn2 && (!mn2 || mn2 && Cc2(Os2, "name").configurable);
      js2.exports = { EXISTS: dn2, PROPER: Ec2, CONFIGURABLE: Fc2 };
    });
    var yn2 = xe2((U0, Ms2) => {
      var Ac2 = mt2(), Sc2 = ot2(), gn2 = gr2(), xc2 = Ac2(Function.toString);
      Sc2(gn2.inspectSource) || (gn2.inspectSource = function(e25) {
        return xc2(e25);
      });
      Ms2.exports = gn2.inspectSource;
    });
    var Vs2 = xe2((J0, $s2) => {
      var bc2 = pt2(), Tc2 = ot2(), Rs2 = bc2.WeakMap;
      $s2.exports = Tc2(Rs2) && /native code/.test(String(Rs2));
    });
    var Gs2 = xe2((z0, Hs2) => {
      var Bc2 = nn2(), Nc2 = un2(), Ws2 = Bc2("keys");
      Hs2.exports = function(e25) {
        return Ws2[e25] || (Ws2[e25] = Nc2(e25));
      };
    });
    var hn2 = xe2((X0, Us2) => {
      Us2.exports = {};
    });
    var Ks2 = xe2((K0, Xs2) => {
      var wc2 = Vs2(), zs2 = pt2(), _c2 = St2(), Pc2 = Dn2(), vn2 = Ct2(), Cn2 = gr2(), Ic2 = Gs2(), kc2 = hn2(), Js2 = "Object already initialized", En2 = zs2.TypeError, Lc2 = zs2.WeakMap, Cr, Gt2, Er2, Oc2 = function(e25) {
        return Er2(e25) ? Gt2(e25) : Cr(e25, {});
      }, jc2 = function(e25) {
        return function(r2) {
          var t2;
          if (!_c2(r2) || (t2 = Gt2(r2)).type !== e25)
            throw En2("Incompatible receiver, " + e25 + " required");
          return t2;
        };
      };
      wc2 || Cn2.state ? (gt2 = Cn2.state || (Cn2.state = new Lc2()), gt2.get = gt2.get, gt2.has = gt2.has, gt2.set = gt2.set, Cr = function(e25, r2) {
        if (gt2.has(e25))
          throw En2(Js2);
        return r2.facade = e25, gt2.set(e25, r2), r2;
      }, Gt2 = function(e25) {
        return gt2.get(e25) || {};
      }, Er2 = function(e25) {
        return gt2.has(e25);
      }) : (Bt2 = Ic2("state"), kc2[Bt2] = true, Cr = function(e25, r2) {
        if (vn2(e25, Bt2))
          throw En2(Js2);
        return r2.facade = e25, Pc2(e25, Bt2, r2), r2;
      }, Gt2 = function(e25) {
        return vn2(e25, Bt2) ? e25[Bt2] : {};
      }, Er2 = function(e25) {
        return vn2(e25, Bt2);
      });
      var gt2, Bt2;
      Xs2.exports = { set: Cr, get: Gt2, has: Er2, enforce: Oc2, getterFor: jc2 };
    });
    var An2 = xe2((Y0, Qs2) => {
      var qc2 = Dt2(), Mc2 = ot2(), Fr2 = Ct2(), Fn2 = yt2(), Rc2 = qs2().CONFIGURABLE, $c2 = yn2(), Ys2 = Ks2(), Vc2 = Ys2.enforce, Wc2 = Ys2.get, Ar2 = Object.defineProperty, Hc2 = Fn2 && !qc2(function() {
        return Ar2(function() {
        }, "length", { value: 8 }).length !== 8;
      }), Gc2 = String(String).split("String"), Uc2 = Qs2.exports = function(e25, r2, t2) {
        String(r2).slice(0, 7) === "Symbol(" && (r2 = "[" + String(r2).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), t2 && t2.getter && (r2 = "get " + r2), t2 && t2.setter && (r2 = "set " + r2), (!Fr2(e25, "name") || Rc2 && e25.name !== r2) && (Fn2 ? Ar2(e25, "name", { value: r2, configurable: true }) : e25.name = r2), Hc2 && t2 && Fr2(t2, "arity") && e25.length !== t2.arity && Ar2(e25, "length", { value: t2.arity });
        try {
          t2 && Fr2(t2, "constructor") && t2.constructor ? Fn2 && Ar2(e25, "prototype", { writable: false }) : e25.prototype && (e25.prototype = void 0);
        } catch {
        }
        var s2 = Vc2(e25);
        return Fr2(s2, "source") || (s2.source = Gc2.join(typeof r2 == "string" ? r2 : "")), e25;
      };
      Function.prototype.toString = Uc2(function() {
        return Mc2(this) && Wc2(this).source || $c2(this);
      }, "toString");
    });
    var ei2 = xe2((Q0, Zs2) => {
      var Jc2 = ot2(), zc2 = It2(), Xc2 = An2(), Kc2 = dr2();
      Zs2.exports = function(e25, r2, t2, s2) {
        s2 || (s2 = {});
        var a2 = s2.enumerable, n2 = s2.name !== void 0 ? s2.name : r2;
        if (Jc2(t2) && Xc2(t2, n2, s2), s2.global)
          a2 ? e25[r2] = t2 : Kc2(r2, t2);
        else {
          try {
            s2.unsafe ? e25[r2] && (a2 = true) : delete e25[r2];
          } catch {
          }
          a2 ? e25[r2] = t2 : zc2.f(e25, r2, { value: t2, enumerable: false, configurable: !s2.nonConfigurable, writable: !s2.nonWritable });
        }
        return e25;
      };
    });
    var ri2 = xe2((Z0, ti2) => {
      var Yc2 = Math.ceil, Qc2 = Math.floor;
      ti2.exports = Math.trunc || function(r2) {
        var t2 = +r2;
        return (t2 > 0 ? Qc2 : Yc2)(t2);
      };
    });
    var Sr = xe2((ey2, ni2) => {
      var Zc2 = ri2();
      ni2.exports = function(e25) {
        var r2 = +e25;
        return r2 !== r2 || r2 === 0 ? 0 : Zc2(r2);
      };
    });
    var si2 = xe2((ty2, ui2) => {
      var ep2 = Sr(), tp2 = Math.max, rp2 = Math.min;
      ui2.exports = function(e25, r2) {
        var t2 = ep2(e25);
        return t2 < 0 ? tp2(t2 + r2, 0) : rp2(t2, r2);
      };
    });
    var ai2 = xe2((ry2, ii2) => {
      var np2 = Sr(), up2 = Math.min;
      ii2.exports = function(e25) {
        return e25 > 0 ? up2(np2(e25), 9007199254740991) : 0;
      };
    });
    var kt2 = xe2((ny2, oi2) => {
      var sp2 = ai2();
      oi2.exports = function(e25) {
        return sp2(e25.length);
      };
    });
    var pi2 = xe2((uy2, ci2) => {
      var ip2 = pr2(), ap2 = si2(), op2 = kt2(), li2 = function(e25) {
        return function(r2, t2, s2) {
          var a2 = ip2(r2), n2 = op2(a2), u2 = ap2(s2, n2), i2;
          if (e25 && t2 != t2) {
            for (; n2 > u2; )
              if (i2 = a2[u2++], i2 != i2)
                return true;
          } else
            for (; n2 > u2; u2++)
              if ((e25 || u2 in a2) && a2[u2] === t2)
                return e25 || u2 || 0;
          return !e25 && -1;
        };
      };
      ci2.exports = { includes: li2(true), indexOf: li2(false) };
    });
    var mi2 = xe2((sy2, Di2) => {
      var lp2 = mt2(), Sn2 = Ct2(), cp2 = pr2(), pp2 = pi2().indexOf, fp2 = hn2(), fi2 = lp2([].push);
      Di2.exports = function(e25, r2) {
        var t2 = cp2(e25), s2 = 0, a2 = [], n2;
        for (n2 in t2)
          !Sn2(fp2, n2) && Sn2(t2, n2) && fi2(a2, n2);
        for (; r2.length > s2; )
          Sn2(t2, n2 = r2[s2++]) && (~pp2(a2, n2) || fi2(a2, n2));
        return a2;
      };
    });
    var gi2 = xe2((iy2, di2) => {
      di2.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
    });
    var hi2 = xe2((yi2) => {
      var Dp2 = mi2(), mp2 = gi2(), dp2 = mp2.concat("length", "prototype");
      yi2.f = Object.getOwnPropertyNames || function(r2) {
        return Dp2(r2, dp2);
      };
    });
    var Ci2 = xe2((vi2) => {
      vi2.f = Object.getOwnPropertySymbols;
    });
    var Fi2 = xe2((ly2, Ei2) => {
      var gp2 = Wt2(), yp2 = mt2(), hp2 = hi2(), vp2 = Ci2(), Cp2 = Tt2(), Ep2 = yp2([].concat);
      Ei2.exports = gp2("Reflect", "ownKeys") || function(r2) {
        var t2 = hp2.f(Cp2(r2)), s2 = vp2.f;
        return s2 ? Ep2(t2, s2(r2)) : t2;
      };
    });
    var xi2 = xe2((cy2, Si2) => {
      var Ai2 = Ct2(), Fp2 = Fi2(), Ap2 = on2(), Sp2 = It2();
      Si2.exports = function(e25, r2, t2) {
        for (var s2 = Fp2(r2), a2 = Sp2.f, n2 = Ap2.f, u2 = 0; u2 < s2.length; u2++) {
          var i2 = s2[u2];
          !Ai2(e25, i2) && !(t2 && Ai2(t2, i2)) && a2(e25, i2, n2(r2, i2));
        }
      };
    });
    var Ti2 = xe2((py2, bi2) => {
      var xp2 = Dt2(), bp2 = ot2(), Tp = /#|\.prototype\./, Ut2 = function(e25, r2) {
        var t2 = Np2[Bp2(e25)];
        return t2 == _p2 ? true : t2 == wp2 ? false : bp2(r2) ? xp2(r2) : !!r2;
      }, Bp2 = Ut2.normalize = function(e25) {
        return String(e25).replace(Tp, ".").toLowerCase();
      }, Np2 = Ut2.data = {}, wp2 = Ut2.NATIVE = "N", _p2 = Ut2.POLYFILL = "P";
      bi2.exports = Ut2;
    });
    var Jt2 = xe2((fy2, Bi2) => {
      var xn2 = pt2(), Pp = on2().f, Ip = Dn2(), kp2 = ei2(), Lp2 = dr2(), Op2 = xi2(), jp2 = Ti2();
      Bi2.exports = function(e25, r2) {
        var t2 = e25.target, s2 = e25.global, a2 = e25.stat, n2, u2, i2, l2, p2, d2;
        if (s2 ? u2 = xn2 : a2 ? u2 = xn2[t2] || Lp2(t2, {}) : u2 = (xn2[t2] || {}).prototype, u2)
          for (i2 in r2) {
            if (p2 = r2[i2], e25.dontCallGetSet ? (d2 = Pp(u2, i2), l2 = d2 && d2.value) : l2 = u2[i2], n2 = jp2(s2 ? i2 : t2 + (a2 ? "." : "#") + i2, e25.forced), !n2 && l2 !== void 0) {
              if (typeof p2 == typeof l2)
                continue;
              Op2(p2, l2);
            }
            (e25.sham || l2 && l2.sham) && Ip(p2, "sham", true), kp2(u2, i2, p2, e25);
          }
      };
    });
    var bn2 = xe2((Dy2, Ni) => {
      var qp2 = Vt2();
      Ni.exports = Array.isArray || function(r2) {
        return qp2(r2) == "Array";
      };
    });
    var _i2 = xe2((my2, wi2) => {
      var Mp2 = TypeError, Rp2 = 9007199254740991;
      wi2.exports = function(e25) {
        if (e25 > Rp2)
          throw Mp2("Maximum allowed index exceeded");
        return e25;
      };
    });
    var Ii2 = xe2((dy2, Pi2) => {
      var $p2 = Vt2(), Vp2 = mt2();
      Pi2.exports = function(e25) {
        if ($p2(e25) === "Function")
          return Vp2(e25);
      };
    });
    var Tn2 = xe2((gy2, Li2) => {
      var ki2 = Ii2(), Wp2 = Ht2(), Hp2 = ar2(), Gp2 = ki2(ki2.bind);
      Li2.exports = function(e25, r2) {
        return Wp2(e25), r2 === void 0 ? e25 : Hp2 ? Gp2(e25, r2) : function() {
          return e25.apply(r2, arguments);
        };
      };
    });
    var Bn2 = xe2((yy2, ji) => {
      var Up2 = bn2(), Jp2 = kt2(), zp2 = _i2(), Xp2 = Tn2(), Oi2 = function(e25, r2, t2, s2, a2, n2, u2, i2) {
        for (var l2 = a2, p2 = 0, d2 = u2 ? Xp2(u2, i2) : false, y2, g2; p2 < s2; )
          p2 in t2 && (y2 = d2 ? d2(t2[p2], p2, r2) : t2[p2], n2 > 0 && Up2(y2) ? (g2 = Jp2(y2), l2 = Oi2(e25, r2, y2, g2, l2, n2 - 1) - 1) : (zp2(l2 + 1), e25[l2] = y2), l2++), p2++;
        return l2;
      };
      ji.exports = Oi2;
    });
    var Ri = xe2((hy2, Mi2) => {
      var Kp2 = bt(), Yp2 = Kp2("toStringTag"), qi2 = {};
      qi2[Yp2] = "z";
      Mi2.exports = String(qi2) === "[object z]";
    });
    var Nn2 = xe2((vy2, $i2) => {
      var Qp2 = Ri(), Zp2 = ot2(), xr2 = Vt2(), ef2 = bt(), tf2 = ef2("toStringTag"), rf2 = Object, nf2 = xr2(function() {
        return arguments;
      }()) == "Arguments", uf2 = function(e25, r2) {
        try {
          return e25[r2];
        } catch {
        }
      };
      $i2.exports = Qp2 ? xr2 : function(e25) {
        var r2, t2, s2;
        return e25 === void 0 ? "Undefined" : e25 === null ? "Null" : typeof (t2 = uf2(r2 = rf2(e25), tf2)) == "string" ? t2 : nf2 ? xr2(r2) : (s2 = xr2(r2)) == "Object" && Zp2(r2.callee) ? "Arguments" : s2;
      };
    });
    var Ji2 = xe2((Cy2, Ui2) => {
      var sf2 = mt2(), af2 = Dt2(), Vi2 = ot2(), of2 = Nn2(), lf2 = Wt2(), cf2 = yn2(), Wi2 = function() {
      }, pf2 = [], Hi2 = lf2("Reflect", "construct"), wn2 = /^\s*(?:class|function)\b/, ff2 = sf2(wn2.exec), Df2 = !wn2.exec(Wi2), zt2 = function(r2) {
        if (!Vi2(r2))
          return false;
        try {
          return Hi2(Wi2, pf2, r2), true;
        } catch {
          return false;
        }
      }, Gi2 = function(r2) {
        if (!Vi2(r2))
          return false;
        switch (of2(r2)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return false;
        }
        try {
          return Df2 || !!ff2(wn2, cf2(r2));
        } catch {
          return true;
        }
      };
      Gi2.sham = true;
      Ui2.exports = !Hi2 || af2(function() {
        var e25;
        return zt2(zt2.call) || !zt2(Object) || !zt2(function() {
          e25 = true;
        }) || e25;
      }) ? Gi2 : zt2;
    });
    var Yi2 = xe2((Ey2, Ki2) => {
      var zi2 = bn2(), mf2 = Ji2(), df2 = St2(), gf2 = bt(), yf2 = gf2("species"), Xi2 = Array;
      Ki2.exports = function(e25) {
        var r2;
        return zi2(e25) && (r2 = e25.constructor, mf2(r2) && (r2 === Xi2 || zi2(r2.prototype)) ? r2 = void 0 : df2(r2) && (r2 = r2[yf2], r2 === null && (r2 = void 0))), r2 === void 0 ? Xi2 : r2;
      };
    });
    var _n2 = xe2((Fy2, Qi2) => {
      var hf2 = Yi2();
      Qi2.exports = function(e25, r2) {
        return new (hf2(e25))(r2 === 0 ? 0 : r2);
      };
    });
    var Zi2 = xe2(() => {
      var vf2 = Jt2(), Cf2 = Bn2(), Ef2 = Ht2(), Ff2 = yr2(), Af2 = kt2(), Sf2 = _n2();
      vf2({ target: "Array", proto: true }, { flatMap: function(r2) {
        var t2 = Ff2(this), s2 = Af2(t2), a2;
        return Ef2(r2), a2 = Sf2(t2, 0), a2.length = Cf2(a2, t2, t2, s2, 0, 1, r2, arguments.length > 1 ? arguments[1] : void 0), a2;
      } });
    });
    var Pn2 = xe2((xy2, ea2) => {
      ea2.exports = {};
    });
    var ra2 = xe2((by2, ta2) => {
      var xf2 = bt(), bf2 = Pn2(), Tf2 = xf2("iterator"), Bf2 = Array.prototype;
      ta2.exports = function(e25) {
        return e25 !== void 0 && (bf2.Array === e25 || Bf2[Tf2] === e25);
      };
    });
    var In2 = xe2((Ty2, ua2) => {
      var Nf2 = Nn2(), na2 = mr2(), wf2 = cr2(), _f2 = Pn2(), Pf2 = bt(), If2 = Pf2("iterator");
      ua2.exports = function(e25) {
        if (!wf2(e25))
          return na2(e25, If2) || na2(e25, "@@iterator") || _f2[Nf2(e25)];
      };
    });
    var ia2 = xe2((By2, sa2) => {
      var kf2 = At2(), Lf2 = Ht2(), Of2 = Tt2(), jf2 = Dr2(), qf2 = In2(), Mf2 = TypeError;
      sa2.exports = function(e25, r2) {
        var t2 = arguments.length < 2 ? qf2(e25) : r2;
        if (Lf2(t2))
          return Of2(kf2(t2, e25));
        throw Mf2(jf2(e25) + " is not iterable");
      };
    });
    var la2 = xe2((Ny2, oa2) => {
      var Rf2 = At2(), aa2 = Tt2(), $f2 = mr2();
      oa2.exports = function(e25, r2, t2) {
        var s2, a2;
        aa2(e25);
        try {
          if (s2 = $f2(e25, "return"), !s2) {
            if (r2 === "throw")
              throw t2;
            return t2;
          }
          s2 = Rf2(s2, e25);
        } catch (n2) {
          a2 = true, s2 = n2;
        }
        if (r2 === "throw")
          throw t2;
        if (a2)
          throw s2;
        return aa2(s2), t2;
      };
    });
    var ma2 = xe2((wy2, Da2) => {
      var Vf2 = Tn2(), Wf2 = At2(), Hf2 = Tt2(), Gf2 = Dr2(), Uf2 = ra2(), Jf2 = kt2(), ca2 = Xr2(), zf2 = ia2(), Xf2 = In2(), pa2 = la2(), Kf2 = TypeError, br2 = function(e25, r2) {
        this.stopped = e25, this.result = r2;
      }, fa2 = br2.prototype;
      Da2.exports = function(e25, r2, t2) {
        var s2 = t2 && t2.that, a2 = !!(t2 && t2.AS_ENTRIES), n2 = !!(t2 && t2.IS_RECORD), u2 = !!(t2 && t2.IS_ITERATOR), i2 = !!(t2 && t2.INTERRUPTED), l2 = Vf2(r2, s2), p2, d2, y2, g2, c2, D2, E2, _2 = function(F2) {
          return p2 && pa2(p2, "normal", F2), new br2(true, F2);
        }, w2 = function(F2) {
          return a2 ? (Hf2(F2), i2 ? l2(F2[0], F2[1], _2) : l2(F2[0], F2[1])) : i2 ? l2(F2, _2) : l2(F2);
        };
        if (n2)
          p2 = e25.iterator;
        else if (u2)
          p2 = e25;
        else {
          if (d2 = Xf2(e25), !d2)
            throw Kf2(Gf2(e25) + " is not iterable");
          if (Uf2(d2)) {
            for (y2 = 0, g2 = Jf2(e25); g2 > y2; y2++)
              if (c2 = w2(e25[y2]), c2 && ca2(fa2, c2))
                return c2;
            return new br2(false);
          }
          p2 = zf2(e25, d2);
        }
        for (D2 = n2 ? e25.next : p2.next; !(E2 = Wf2(D2, p2)).done; ) {
          try {
            c2 = w2(E2.value);
          } catch (F2) {
            pa2(p2, "throw", F2);
          }
          if (typeof c2 == "object" && c2 && ca2(fa2, c2))
            return c2;
        }
        return new br2(false);
      };
    });
    var ga2 = xe2((_y2, da2) => {
      var Yf2 = hr2(), Qf2 = It2(), Zf2 = lr2();
      da2.exports = function(e25, r2, t2) {
        var s2 = Yf2(r2);
        s2 in e25 ? Qf2.f(e25, s2, Zf2(0, t2)) : e25[s2] = t2;
      };
    });
    var ya2 = xe2(() => {
      var eD2 = Jt2(), tD2 = ma2(), rD2 = ga2();
      eD2({ target: "Object", stat: true }, { fromEntries: function(r2) {
        var t2 = {};
        return tD2(r2, function(s2, a2) {
          rD2(t2, s2, a2);
        }, { AS_ENTRIES: true }), t2;
      } });
    });
    var Ca2 = xe2((ky2, va2) => {
      var ha2 = An2(), nD2 = It2();
      va2.exports = function(e25, r2, t2) {
        return t2.get && ha2(t2.get, r2, { getter: true }), t2.set && ha2(t2.set, r2, { setter: true }), nD2.f(e25, r2, t2);
      };
    });
    var Fa2 = xe2((Ly2, Ea2) => {
      var uD2 = Tt2();
      Ea2.exports = function() {
        var e25 = uD2(this), r2 = "";
        return e25.hasIndices && (r2 += "d"), e25.global && (r2 += "g"), e25.ignoreCase && (r2 += "i"), e25.multiline && (r2 += "m"), e25.dotAll && (r2 += "s"), e25.unicode && (r2 += "u"), e25.unicodeSets && (r2 += "v"), e25.sticky && (r2 += "y"), r2;
      };
    });
    var xa2 = xe2(() => {
      var sD2 = pt2(), iD2 = yt2(), aD2 = Ca2(), oD2 = Fa2(), lD2 = Dt2(), Aa2 = sD2.RegExp, Sa2 = Aa2.prototype, cD2 = iD2 && lD2(function() {
        var e25 = true;
        try {
          Aa2(".", "d");
        } catch {
          e25 = false;
        }
        var r2 = {}, t2 = "", s2 = e25 ? "dgimsy" : "gimsy", a2 = function(l2, p2) {
          Object.defineProperty(r2, l2, { get: function() {
            return t2 += p2, true;
          } });
        }, n2 = { dotAll: "s", global: "g", ignoreCase: "i", multiline: "m", sticky: "y" };
        e25 && (n2.hasIndices = "d");
        for (var u2 in n2)
          a2(u2, n2[u2]);
        var i2 = Object.getOwnPropertyDescriptor(Sa2, "flags").get.call(r2);
        return i2 !== s2 || t2 !== s2;
      });
      cD2 && aD2(Sa2, "flags", { configurable: true, get: oD2 });
    });
    var ba2 = xe2(() => {
      var pD2 = Jt2(), kn2 = pt2();
      pD2({ global: true, forced: kn2.globalThis !== kn2 }, { globalThis: kn2 });
    });
    var Ta2 = xe2(() => {
      ba2();
    });
    var Ba2 = xe2(() => {
      var fD2 = Jt2(), DD2 = Bn2(), mD2 = yr2(), dD2 = kt2(), gD2 = Sr(), yD2 = _n2();
      fD2({ target: "Array", proto: true }, { flat: function() {
        var r2 = arguments.length ? arguments[0] : void 0, t2 = mD2(this), s2 = dD2(t2), a2 = yD2(t2, 0);
        return a2.length = DD2(a2, t2, t2, s2, 0, r2 === void 0 ? 1 : gD2(r2)), a2;
      } });
    });
    var Zg2 = xe2((Gy2, jo2) => {
      var hD2 = ["cliName", "cliCategory", "cliDescription"], vD2 = ["_"], CD2 = ["languageId"];
      function Hn2(e25, r2) {
        if (e25 == null)
          return {};
        var t2 = ED2(e25, r2), s2, a2;
        if (Object.getOwnPropertySymbols) {
          var n2 = Object.getOwnPropertySymbols(e25);
          for (a2 = 0; a2 < n2.length; a2++)
            s2 = n2[a2], !(r2.indexOf(s2) >= 0) && Object.prototype.propertyIsEnumerable.call(e25, s2) && (t2[s2] = e25[s2]);
        }
        return t2;
      }
      function ED2(e25, r2) {
        if (e25 == null)
          return {};
        var t2 = {}, s2 = Object.keys(e25), a2, n2;
        for (n2 = 0; n2 < s2.length; n2++)
          a2 = s2[n2], !(r2.indexOf(a2) >= 0) && (t2[a2] = e25[a2]);
        return t2;
      }
      Zi2();
      ya2();
      xa2();
      Ta2();
      Ba2();
      var FD2 = Object.create, _r2 = Object.defineProperty, AD2 = Object.getOwnPropertyDescriptor, Gn2 = Object.getOwnPropertyNames, SD2 = Object.getPrototypeOf, xD2 = Object.prototype.hasOwnProperty, ht2 = (e25, r2) => function() {
        return e25 && (r2 = (0, e25[Gn2(e25)[0]])(e25 = 0)), r2;
      }, Z2 = (e25, r2) => function() {
        return r2 || (0, e25[Gn2(e25)[0]])((r2 = { exports: {} }).exports, r2), r2.exports;
      }, Kt2 = (e25, r2) => {
        for (var t2 in r2)
          _r2(e25, t2, { get: r2[t2], enumerable: true });
      }, Pa2 = (e25, r2, t2, s2) => {
        if (r2 && typeof r2 == "object" || typeof r2 == "function")
          for (let a2 of Gn2(r2))
            !xD2.call(e25, a2) && a2 !== t2 && _r2(e25, a2, { get: () => r2[a2], enumerable: !(s2 = AD2(r2, a2)) || s2.enumerable });
        return e25;
      }, bD2 = (e25, r2, t2) => (t2 = e25 != null ? FD2(SD2(e25)) : {}, Pa2(r2 || !e25 || !e25.__esModule ? _r2(t2, "default", { value: e25, enumerable: true }) : t2, e25)), ft2 = (e25) => Pa2(_r2({}, "__esModule", { value: true }), e25), wt2, ne2 = ht2({ "<define:process>"() {
        wt2 = { env: {}, argv: [] };
      } }), Ia2 = Z2({ "package.json"(e25, r2) {
        r2.exports = { version: "2.8.2" };
      } }), TD2 = Z2({ "node_modules/diff/lib/diff/base.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true }), e25.default = r2;
        function r2() {
        }
        r2.prototype = { diff: function(n2, u2) {
          var i2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, l2 = i2.callback;
          typeof i2 == "function" && (l2 = i2, i2 = {}), this.options = i2;
          var p2 = this;
          function d2(A2) {
            return l2 ? (setTimeout(function() {
              l2(void 0, A2);
            }, 0), true) : A2;
          }
          n2 = this.castInput(n2), u2 = this.castInput(u2), n2 = this.removeEmpty(this.tokenize(n2)), u2 = this.removeEmpty(this.tokenize(u2));
          var y2 = u2.length, g2 = n2.length, c2 = 1, D2 = y2 + g2, E2 = [{ newPos: -1, components: [] }], _2 = this.extractCommon(E2[0], u2, n2, 0);
          if (E2[0].newPos + 1 >= y2 && _2 + 1 >= g2)
            return d2([{ value: this.join(u2), count: u2.length }]);
          function w2() {
            for (var A2 = -1 * c2; A2 <= c2; A2 += 2) {
              var N2 = void 0, I2 = E2[A2 - 1], P2 = E2[A2 + 1], H2 = (P2 ? P2.newPos : 0) - A2;
              I2 && (E2[A2 - 1] = void 0);
              var f2 = I2 && I2.newPos + 1 < y2, b2 = P2 && 0 <= H2 && H2 < g2;
              if (!f2 && !b2) {
                E2[A2] = void 0;
                continue;
              }
              if (!f2 || b2 && I2.newPos < P2.newPos ? (N2 = s2(P2), p2.pushComponent(N2.components, void 0, true)) : (N2 = I2, N2.newPos++, p2.pushComponent(N2.components, true, void 0)), H2 = p2.extractCommon(N2, u2, n2, A2), N2.newPos + 1 >= y2 && H2 + 1 >= g2)
                return d2(t2(p2, N2.components, u2, n2, p2.useLongestToken));
              E2[A2] = N2;
            }
            c2++;
          }
          if (l2)
            (function A2() {
              setTimeout(function() {
                if (c2 > D2)
                  return l2();
                w2() || A2();
              }, 0);
            })();
          else
            for (; c2 <= D2; ) {
              var F2 = w2();
              if (F2)
                return F2;
            }
        }, pushComponent: function(n2, u2, i2) {
          var l2 = n2[n2.length - 1];
          l2 && l2.added === u2 && l2.removed === i2 ? n2[n2.length - 1] = { count: l2.count + 1, added: u2, removed: i2 } : n2.push({ count: 1, added: u2, removed: i2 });
        }, extractCommon: function(n2, u2, i2, l2) {
          for (var p2 = u2.length, d2 = i2.length, y2 = n2.newPos, g2 = y2 - l2, c2 = 0; y2 + 1 < p2 && g2 + 1 < d2 && this.equals(u2[y2 + 1], i2[g2 + 1]); )
            y2++, g2++, c2++;
          return c2 && n2.components.push({ count: c2 }), n2.newPos = y2, g2;
        }, equals: function(n2, u2) {
          return this.options.comparator ? this.options.comparator(n2, u2) : n2 === u2 || this.options.ignoreCase && n2.toLowerCase() === u2.toLowerCase();
        }, removeEmpty: function(n2) {
          for (var u2 = [], i2 = 0; i2 < n2.length; i2++)
            n2[i2] && u2.push(n2[i2]);
          return u2;
        }, castInput: function(n2) {
          return n2;
        }, tokenize: function(n2) {
          return n2.split("");
        }, join: function(n2) {
          return n2.join("");
        } };
        function t2(a2, n2, u2, i2, l2) {
          for (var p2 = 0, d2 = n2.length, y2 = 0, g2 = 0; p2 < d2; p2++) {
            var c2 = n2[p2];
            if (c2.removed) {
              if (c2.value = a2.join(i2.slice(g2, g2 + c2.count)), g2 += c2.count, p2 && n2[p2 - 1].added) {
                var E2 = n2[p2 - 1];
                n2[p2 - 1] = n2[p2], n2[p2] = E2;
              }
            } else {
              if (!c2.added && l2) {
                var D2 = u2.slice(y2, y2 + c2.count);
                D2 = D2.map(function(w2, F2) {
                  var A2 = i2[g2 + F2];
                  return A2.length > w2.length ? A2 : w2;
                }), c2.value = a2.join(D2);
              } else
                c2.value = a2.join(u2.slice(y2, y2 + c2.count));
              y2 += c2.count, c2.added || (g2 += c2.count);
            }
          }
          var _2 = n2[d2 - 1];
          return d2 > 1 && typeof _2.value == "string" && (_2.added || _2.removed) && a2.equals("", _2.value) && (n2[d2 - 2].value += _2.value, n2.pop()), n2;
        }
        function s2(a2) {
          return { newPos: a2.newPos, components: a2.components.slice(0) };
        }
      } }), BD2 = Z2({ "node_modules/diff/lib/diff/array.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true }), e25.diffArrays = a2, e25.arrayDiff = void 0;
        var r2 = t2(TD2());
        function t2(n2) {
          return n2 && n2.__esModule ? n2 : { default: n2 };
        }
        var s2 = new r2.default();
        e25.arrayDiff = s2, s2.tokenize = function(n2) {
          return n2.slice();
        }, s2.join = s2.removeEmpty = function(n2) {
          return n2;
        };
        function a2(n2, u2, i2) {
          return s2.diff(n2, u2, i2);
        }
      } }), Un2 = Z2({ "src/document/doc-builders.js"(e25, r2) {
        ne2();
        function t2(v2) {
          return { type: "concat", parts: v2 };
        }
        function s2(v2) {
          return { type: "indent", contents: v2 };
        }
        function a2(v2, o2) {
          return { type: "align", contents: o2, n: v2 };
        }
        function n2(v2) {
          let o2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return { type: "group", id: o2.id, contents: v2, break: Boolean(o2.shouldBreak), expandedStates: o2.expandedStates };
        }
        function u2(v2) {
          return a2(Number.NEGATIVE_INFINITY, v2);
        }
        function i2(v2) {
          return a2({ type: "root" }, v2);
        }
        function l2(v2) {
          return a2(-1, v2);
        }
        function p2(v2, o2) {
          return n2(v2[0], Object.assign(Object.assign({}, o2), {}, { expandedStates: v2 }));
        }
        function d2(v2) {
          return { type: "fill", parts: v2 };
        }
        function y2(v2, o2) {
          let h2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return { type: "if-break", breakContents: v2, flatContents: o2, groupId: h2.groupId };
        }
        function g2(v2, o2) {
          return { type: "indent-if-break", contents: v2, groupId: o2.groupId, negate: o2.negate };
        }
        function c2(v2) {
          return { type: "line-suffix", contents: v2 };
        }
        var D2 = { type: "line-suffix-boundary" }, E2 = { type: "break-parent" }, _2 = { type: "trim" }, w2 = { type: "line", hard: true }, F2 = { type: "line", hard: true, literal: true }, A2 = { type: "line" }, N2 = { type: "line", soft: true }, I2 = t2([w2, E2]), P2 = t2([F2, E2]), H2 = { type: "cursor", placeholder: Symbol("cursor") };
        function f2(v2, o2) {
          let h2 = [];
          for (let C2 = 0; C2 < o2.length; C2++)
            C2 !== 0 && h2.push(v2), h2.push(o2[C2]);
          return t2(h2);
        }
        function b2(v2, o2, h2) {
          let C2 = v2;
          if (o2 > 0) {
            for (let S2 = 0; S2 < Math.floor(o2 / h2); ++S2)
              C2 = s2(C2);
            C2 = a2(o2 % h2, C2), C2 = a2(Number.NEGATIVE_INFINITY, C2);
          }
          return C2;
        }
        function m2(v2, o2) {
          return { type: "label", label: v2, contents: o2 };
        }
        r2.exports = { concat: t2, join: f2, line: A2, softline: N2, hardline: I2, literalline: P2, group: n2, conditionalGroup: p2, fill: d2, lineSuffix: c2, lineSuffixBoundary: D2, cursor: H2, breakParent: E2, ifBreak: y2, trim: _2, indent: s2, indentIfBreak: g2, align: a2, addAlignmentToDoc: b2, markAsRoot: i2, dedentToRoot: u2, dedent: l2, hardlineWithoutBreakParent: w2, literallineWithoutBreakParent: F2, label: m2 };
      } }), Jn2 = Z2({ "src/common/end-of-line.js"(e25, r2) {
        ne2();
        function t2(u2) {
          let i2 = u2.indexOf("\r");
          return i2 >= 0 ? u2.charAt(i2 + 1) === `
` ? "crlf" : "cr" : "lf";
        }
        function s2(u2) {
          switch (u2) {
            case "cr":
              return "\r";
            case "crlf":
              return `\r
`;
            default:
              return `
`;
          }
        }
        function a2(u2, i2) {
          let l2;
          switch (i2) {
            case `
`:
              l2 = /\n/g;
              break;
            case "\r":
              l2 = /\r/g;
              break;
            case `\r
`:
              l2 = /\r\n/g;
              break;
            default:
              throw new Error(`Unexpected "eol" ${JSON.stringify(i2)}.`);
          }
          let p2 = u2.match(l2);
          return p2 ? p2.length : 0;
        }
        function n2(u2) {
          return u2.replace(/\r\n?/g, `
`);
        }
        r2.exports = { guessEndOfLine: t2, convertEndOfLineToChars: s2, countEndOfLineChars: a2, normalizeEndOfLine: n2 };
      } }), lt2 = Z2({ "src/utils/get-last.js"(e25, r2) {
        ne2();
        var t2 = (s2) => s2[s2.length - 1];
        r2.exports = t2;
      } });
      function ND2() {
        let { onlyFirst: e25 = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r2 = ["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)", "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");
        return new RegExp(r2, e25 ? void 0 : "g");
      }
      var wD2 = ht2({ "node_modules/strip-ansi/node_modules/ansi-regex/index.js"() {
        ne2();
      } });
      function _D2(e25) {
        if (typeof e25 != "string")
          throw new TypeError(`Expected a \`string\`, got \`${typeof e25}\``);
        return e25.replace(ND2(), "");
      }
      var PD2 = ht2({ "node_modules/strip-ansi/index.js"() {
        ne2(), wD2();
      } });
      function ID2(e25) {
        return Number.isInteger(e25) ? e25 >= 4352 && (e25 <= 4447 || e25 === 9001 || e25 === 9002 || 11904 <= e25 && e25 <= 12871 && e25 !== 12351 || 12880 <= e25 && e25 <= 19903 || 19968 <= e25 && e25 <= 42182 || 43360 <= e25 && e25 <= 43388 || 44032 <= e25 && e25 <= 55203 || 63744 <= e25 && e25 <= 64255 || 65040 <= e25 && e25 <= 65049 || 65072 <= e25 && e25 <= 65131 || 65281 <= e25 && e25 <= 65376 || 65504 <= e25 && e25 <= 65510 || 110592 <= e25 && e25 <= 110593 || 127488 <= e25 && e25 <= 127569 || 131072 <= e25 && e25 <= 262141) : false;
      }
      var kD2 = ht2({ "node_modules/is-fullwidth-code-point/index.js"() {
        ne2();
      } }), LD2 = Z2({ "node_modules/emoji-regex/index.js"(e25, r2) {
        ne2(), r2.exports = function() {
          return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
        };
      } }), ka2 = {};
      Kt2(ka2, { default: () => OD2 });
      function OD2(e25) {
        if (typeof e25 != "string" || e25.length === 0 || (e25 = _D2(e25), e25.length === 0))
          return 0;
        e25 = e25.replace((0, La2.default)(), "  ");
        let r2 = 0;
        for (let t2 = 0; t2 < e25.length; t2++) {
          let s2 = e25.codePointAt(t2);
          s2 <= 31 || s2 >= 127 && s2 <= 159 || s2 >= 768 && s2 <= 879 || (s2 > 65535 && t2++, r2 += ID2(s2) ? 2 : 1);
        }
        return r2;
      }
      var La2, jD2 = ht2({ "node_modules/string-width/index.js"() {
        ne2(), PD2(), kD2(), La2 = bD2(LD2());
      } }), Oa2 = Z2({ "src/utils/get-string-width.js"(e25, r2) {
        ne2();
        var t2 = (jD2(), ft2(ka2)).default, s2 = /[^\x20-\x7F]/;
        function a2(n2) {
          return n2 ? s2.test(n2) ? t2(n2) : n2.length : 0;
        }
        r2.exports = a2;
      } }), Yt2 = Z2({ "src/document/doc-utils.js"(e25, r2) {
        ne2();
        var t2 = lt2(), { literalline: s2, join: a2 } = Un2(), n2 = (o2) => Array.isArray(o2) || o2 && o2.type === "concat", u2 = (o2) => {
          if (Array.isArray(o2))
            return o2;
          if (o2.type !== "concat" && o2.type !== "fill")
            throw new Error("Expect doc type to be `concat` or `fill`.");
          return o2.parts;
        }, i2 = {};
        function l2(o2, h2, C2, S2) {
          let x2 = [o2];
          for (; x2.length > 0; ) {
            let T2 = x2.pop();
            if (T2 === i2) {
              C2(x2.pop());
              continue;
            }
            if (C2 && x2.push(T2, i2), !h2 || h2(T2) !== false)
              if (n2(T2) || T2.type === "fill") {
                let k2 = u2(T2);
                for (let M2 = k2.length, R2 = M2 - 1; R2 >= 0; --R2)
                  x2.push(k2[R2]);
              } else if (T2.type === "if-break")
                T2.flatContents && x2.push(T2.flatContents), T2.breakContents && x2.push(T2.breakContents);
              else if (T2.type === "group" && T2.expandedStates)
                if (S2)
                  for (let k2 = T2.expandedStates.length, M2 = k2 - 1; M2 >= 0; --M2)
                    x2.push(T2.expandedStates[M2]);
                else
                  x2.push(T2.contents);
              else
                T2.contents && x2.push(T2.contents);
          }
        }
        function p2(o2, h2) {
          let C2 = new Map();
          return S2(o2);
          function S2(T2) {
            if (C2.has(T2))
              return C2.get(T2);
            let k2 = x2(T2);
            return C2.set(T2, k2), k2;
          }
          function x2(T2) {
            if (Array.isArray(T2))
              return h2(T2.map(S2));
            if (T2.type === "concat" || T2.type === "fill") {
              let k2 = T2.parts.map(S2);
              return h2(Object.assign(Object.assign({}, T2), {}, { parts: k2 }));
            }
            if (T2.type === "if-break") {
              let k2 = T2.breakContents && S2(T2.breakContents), M2 = T2.flatContents && S2(T2.flatContents);
              return h2(Object.assign(Object.assign({}, T2), {}, { breakContents: k2, flatContents: M2 }));
            }
            if (T2.type === "group" && T2.expandedStates) {
              let k2 = T2.expandedStates.map(S2), M2 = k2[0];
              return h2(Object.assign(Object.assign({}, T2), {}, { contents: M2, expandedStates: k2 }));
            }
            if (T2.contents) {
              let k2 = S2(T2.contents);
              return h2(Object.assign(Object.assign({}, T2), {}, { contents: k2 }));
            }
            return h2(T2);
          }
        }
        function d2(o2, h2, C2) {
          let S2 = C2, x2 = false;
          function T2(k2) {
            let M2 = h2(k2);
            if (M2 !== void 0 && (x2 = true, S2 = M2), x2)
              return false;
          }
          return l2(o2, T2), S2;
        }
        function y2(o2) {
          if (o2.type === "group" && o2.break || o2.type === "line" && o2.hard || o2.type === "break-parent")
            return true;
        }
        function g2(o2) {
          return d2(o2, y2, false);
        }
        function c2(o2) {
          if (o2.length > 0) {
            let h2 = t2(o2);
            !h2.expandedStates && !h2.break && (h2.break = "propagated");
          }
          return null;
        }
        function D2(o2) {
          let h2 = new Set(), C2 = [];
          function S2(T2) {
            if (T2.type === "break-parent" && c2(C2), T2.type === "group") {
              if (C2.push(T2), h2.has(T2))
                return false;
              h2.add(T2);
            }
          }
          function x2(T2) {
            T2.type === "group" && C2.pop().break && c2(C2);
          }
          l2(o2, S2, x2, true);
        }
        function E2(o2) {
          return o2.type === "line" && !o2.hard ? o2.soft ? "" : " " : o2.type === "if-break" ? o2.flatContents || "" : o2;
        }
        function _2(o2) {
          return p2(o2, E2);
        }
        var w2 = (o2, h2) => o2 && o2.type === "line" && o2.hard && h2 && h2.type === "break-parent";
        function F2(o2) {
          if (!o2)
            return o2;
          if (n2(o2) || o2.type === "fill") {
            let h2 = u2(o2);
            for (; h2.length > 1 && w2(...h2.slice(-2)); )
              h2.length -= 2;
            if (h2.length > 0) {
              let C2 = F2(t2(h2));
              h2[h2.length - 1] = C2;
            }
            return Array.isArray(o2) ? h2 : Object.assign(Object.assign({}, o2), {}, { parts: h2 });
          }
          switch (o2.type) {
            case "align":
            case "indent":
            case "indent-if-break":
            case "group":
            case "line-suffix":
            case "label": {
              let h2 = F2(o2.contents);
              return Object.assign(Object.assign({}, o2), {}, { contents: h2 });
            }
            case "if-break": {
              let h2 = F2(o2.breakContents), C2 = F2(o2.flatContents);
              return Object.assign(Object.assign({}, o2), {}, { breakContents: h2, flatContents: C2 });
            }
          }
          return o2;
        }
        function A2(o2) {
          return F2(I2(o2));
        }
        function N2(o2) {
          switch (o2.type) {
            case "fill":
              if (o2.parts.every((C2) => C2 === ""))
                return "";
              break;
            case "group":
              if (!o2.contents && !o2.id && !o2.break && !o2.expandedStates)
                return "";
              if (o2.contents.type === "group" && o2.contents.id === o2.id && o2.contents.break === o2.break && o2.contents.expandedStates === o2.expandedStates)
                return o2.contents;
              break;
            case "align":
            case "indent":
            case "indent-if-break":
            case "line-suffix":
              if (!o2.contents)
                return "";
              break;
            case "if-break":
              if (!o2.flatContents && !o2.breakContents)
                return "";
              break;
          }
          if (!n2(o2))
            return o2;
          let h2 = [];
          for (let C2 of u2(o2)) {
            if (!C2)
              continue;
            let [S2, ...x2] = n2(C2) ? u2(C2) : [C2];
            typeof S2 == "string" && typeof t2(h2) == "string" ? h2[h2.length - 1] += S2 : h2.push(S2), h2.push(...x2);
          }
          return h2.length === 0 ? "" : h2.length === 1 ? h2[0] : Array.isArray(o2) ? h2 : Object.assign(Object.assign({}, o2), {}, { parts: h2 });
        }
        function I2(o2) {
          return p2(o2, (h2) => N2(h2));
        }
        function P2(o2) {
          let h2 = [], C2 = o2.filter(Boolean);
          for (; C2.length > 0; ) {
            let S2 = C2.shift();
            if (S2) {
              if (n2(S2)) {
                C2.unshift(...u2(S2));
                continue;
              }
              if (h2.length > 0 && typeof t2(h2) == "string" && typeof S2 == "string") {
                h2[h2.length - 1] += S2;
                continue;
              }
              h2.push(S2);
            }
          }
          return h2;
        }
        function H2(o2) {
          return p2(o2, (h2) => Array.isArray(h2) ? P2(h2) : h2.parts ? Object.assign(Object.assign({}, h2), {}, { parts: P2(h2.parts) }) : h2);
        }
        function f2(o2) {
          return p2(o2, (h2) => typeof h2 == "string" && h2.includes(`
`) ? b2(h2) : h2);
        }
        function b2(o2) {
          let h2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : s2;
          return a2(h2, o2.split(`
`)).parts;
        }
        function m2(o2) {
          if (o2.type === "line")
            return true;
        }
        function v2(o2) {
          return d2(o2, m2, false);
        }
        r2.exports = { isConcat: n2, getDocParts: u2, willBreak: g2, traverseDoc: l2, findInDoc: d2, mapDoc: p2, propagateBreaks: D2, removeLines: _2, stripTrailingHardline: A2, normalizeParts: P2, normalizeDoc: H2, cleanDoc: I2, replaceTextEndOfLine: b2, replaceEndOfLine: f2, canBreak: v2 };
      } }), qD2 = Z2({ "src/document/doc-printer.js"(e25, r2) {
        ne2();
        var { convertEndOfLineToChars: t2 } = Jn2(), s2 = lt2(), a2 = Oa2(), { fill: n2, cursor: u2, indent: i2 } = Un2(), { isConcat: l2, getDocParts: p2 } = Yt2(), d2, y2 = 1, g2 = 2;
        function c2() {
          return { value: "", length: 0, queue: [] };
        }
        function D2(N2, I2) {
          return _2(N2, { type: "indent" }, I2);
        }
        function E2(N2, I2, P2) {
          return I2 === Number.NEGATIVE_INFINITY ? N2.root || c2() : I2 < 0 ? _2(N2, { type: "dedent" }, P2) : I2 ? I2.type === "root" ? Object.assign(Object.assign({}, N2), {}, { root: N2 }) : _2(N2, { type: typeof I2 == "string" ? "stringAlign" : "numberAlign", n: I2 }, P2) : N2;
        }
        function _2(N2, I2, P2) {
          let H2 = I2.type === "dedent" ? N2.queue.slice(0, -1) : [...N2.queue, I2], f2 = "", b2 = 0, m2 = 0, v2 = 0;
          for (let k2 of H2)
            switch (k2.type) {
              case "indent":
                C2(), P2.useTabs ? o2(1) : h2(P2.tabWidth);
                break;
              case "stringAlign":
                C2(), f2 += k2.n, b2 += k2.n.length;
                break;
              case "numberAlign":
                m2 += 1, v2 += k2.n;
                break;
              default:
                throw new Error(`Unexpected type '${k2.type}'`);
            }
          return x2(), Object.assign(Object.assign({}, N2), {}, { value: f2, length: b2, queue: H2 });
          function o2(k2) {
            f2 += "	".repeat(k2), b2 += P2.tabWidth * k2;
          }
          function h2(k2) {
            f2 += " ".repeat(k2), b2 += k2;
          }
          function C2() {
            P2.useTabs ? S2() : x2();
          }
          function S2() {
            m2 > 0 && o2(m2), T2();
          }
          function x2() {
            v2 > 0 && h2(v2), T2();
          }
          function T2() {
            m2 = 0, v2 = 0;
          }
        }
        function w2(N2) {
          if (N2.length === 0)
            return 0;
          let I2 = 0;
          for (; N2.length > 0 && typeof s2(N2) == "string" && /^[\t ]*$/.test(s2(N2)); )
            I2 += N2.pop().length;
          if (N2.length > 0 && typeof s2(N2) == "string") {
            let P2 = s2(N2).replace(/[\t ]*$/, "");
            I2 += s2(N2).length - P2.length, N2[N2.length - 1] = P2;
          }
          return I2;
        }
        function F2(N2, I2, P2, H2, f2) {
          let b2 = I2.length, m2 = [N2], v2 = [];
          for (; P2 >= 0; ) {
            if (m2.length === 0) {
              if (b2 === 0)
                return true;
              m2.push(I2[--b2]);
              continue;
            }
            let { mode: o2, doc: h2 } = m2.pop();
            if (typeof h2 == "string")
              v2.push(h2), P2 -= a2(h2);
            else if (l2(h2) || h2.type === "fill") {
              let C2 = p2(h2);
              for (let S2 = C2.length - 1; S2 >= 0; S2--)
                m2.push({ mode: o2, doc: C2[S2] });
            } else
              switch (h2.type) {
                case "indent":
                case "align":
                case "indent-if-break":
                case "label":
                  m2.push({ mode: o2, doc: h2.contents });
                  break;
                case "trim":
                  P2 += w2(v2);
                  break;
                case "group": {
                  if (f2 && h2.break)
                    return false;
                  let C2 = h2.break ? y2 : o2, S2 = h2.expandedStates && C2 === y2 ? s2(h2.expandedStates) : h2.contents;
                  m2.push({ mode: C2, doc: S2 });
                  break;
                }
                case "if-break": {
                  let S2 = (h2.groupId ? d2[h2.groupId] || g2 : o2) === y2 ? h2.breakContents : h2.flatContents;
                  S2 && m2.push({ mode: o2, doc: S2 });
                  break;
                }
                case "line":
                  if (o2 === y2 || h2.hard)
                    return true;
                  h2.soft || (v2.push(" "), P2--);
                  break;
                case "line-suffix":
                  H2 = true;
                  break;
                case "line-suffix-boundary":
                  if (H2)
                    return false;
                  break;
              }
          }
          return false;
        }
        function A2(N2, I2) {
          d2 = {};
          let P2 = I2.printWidth, H2 = t2(I2.endOfLine), f2 = 0, b2 = [{ ind: c2(), mode: y2, doc: N2 }], m2 = [], v2 = false, o2 = [];
          for (; b2.length > 0; ) {
            let { ind: C2, mode: S2, doc: x2 } = b2.pop();
            if (typeof x2 == "string") {
              let T2 = H2 !== `
` ? x2.replace(/\n/g, H2) : x2;
              m2.push(T2), f2 += a2(T2);
            } else if (l2(x2)) {
              let T2 = p2(x2);
              for (let k2 = T2.length - 1; k2 >= 0; k2--)
                b2.push({ ind: C2, mode: S2, doc: T2[k2] });
            } else
              switch (x2.type) {
                case "cursor":
                  m2.push(u2.placeholder);
                  break;
                case "indent":
                  b2.push({ ind: D2(C2, I2), mode: S2, doc: x2.contents });
                  break;
                case "align":
                  b2.push({ ind: E2(C2, x2.n, I2), mode: S2, doc: x2.contents });
                  break;
                case "trim":
                  f2 -= w2(m2);
                  break;
                case "group":
                  switch (S2) {
                    case g2:
                      if (!v2) {
                        b2.push({ ind: C2, mode: x2.break ? y2 : g2, doc: x2.contents });
                        break;
                      }
                    case y2: {
                      v2 = false;
                      let T2 = { ind: C2, mode: g2, doc: x2.contents }, k2 = P2 - f2, M2 = o2.length > 0;
                      if (!x2.break && F2(T2, b2, k2, M2))
                        b2.push(T2);
                      else if (x2.expandedStates) {
                        let R2 = s2(x2.expandedStates);
                        if (x2.break) {
                          b2.push({ ind: C2, mode: y2, doc: R2 });
                          break;
                        } else
                          for (let q2 = 1; q2 < x2.expandedStates.length + 1; q2++)
                            if (q2 >= x2.expandedStates.length) {
                              b2.push({ ind: C2, mode: y2, doc: R2 });
                              break;
                            } else {
                              let U2 = x2.expandedStates[q2], L2 = { ind: C2, mode: g2, doc: U2 };
                              if (F2(L2, b2, k2, M2)) {
                                b2.push(L2);
                                break;
                              }
                            }
                      } else
                        b2.push({ ind: C2, mode: y2, doc: x2.contents });
                      break;
                    }
                  }
                  x2.id && (d2[x2.id] = s2(b2).mode);
                  break;
                case "fill": {
                  let T2 = P2 - f2, { parts: k2 } = x2;
                  if (k2.length === 0)
                    break;
                  let [M2, R2] = k2, q2 = { ind: C2, mode: g2, doc: M2 }, U2 = { ind: C2, mode: y2, doc: M2 }, L2 = F2(q2, [], T2, o2.length > 0, true);
                  if (k2.length === 1) {
                    L2 ? b2.push(q2) : b2.push(U2);
                    break;
                  }
                  let Y2 = { ind: C2, mode: g2, doc: R2 }, V2 = { ind: C2, mode: y2, doc: R2 };
                  if (k2.length === 2) {
                    L2 ? b2.push(Y2, q2) : b2.push(V2, U2);
                    break;
                  }
                  k2.splice(0, 2);
                  let j2 = { ind: C2, mode: S2, doc: n2(k2) }, K2 = k2[0];
                  F2({ ind: C2, mode: g2, doc: [M2, R2, K2] }, [], T2, o2.length > 0, true) ? b2.push(j2, Y2, q2) : L2 ? b2.push(j2, V2, q2) : b2.push(j2, V2, U2);
                  break;
                }
                case "if-break":
                case "indent-if-break": {
                  let T2 = x2.groupId ? d2[x2.groupId] : S2;
                  if (T2 === y2) {
                    let k2 = x2.type === "if-break" ? x2.breakContents : x2.negate ? x2.contents : i2(x2.contents);
                    k2 && b2.push({ ind: C2, mode: S2, doc: k2 });
                  }
                  if (T2 === g2) {
                    let k2 = x2.type === "if-break" ? x2.flatContents : x2.negate ? i2(x2.contents) : x2.contents;
                    k2 && b2.push({ ind: C2, mode: S2, doc: k2 });
                  }
                  break;
                }
                case "line-suffix":
                  o2.push({ ind: C2, mode: S2, doc: x2.contents });
                  break;
                case "line-suffix-boundary":
                  o2.length > 0 && b2.push({ ind: C2, mode: S2, doc: { type: "line", hard: true } });
                  break;
                case "line":
                  switch (S2) {
                    case g2:
                      if (x2.hard)
                        v2 = true;
                      else {
                        x2.soft || (m2.push(" "), f2 += 1);
                        break;
                      }
                    case y2:
                      if (o2.length > 0) {
                        b2.push({ ind: C2, mode: S2, doc: x2 }, ...o2.reverse()), o2.length = 0;
                        break;
                      }
                      x2.literal ? C2.root ? (m2.push(H2, C2.root.value), f2 = C2.root.length) : (m2.push(H2), f2 = 0) : (f2 -= w2(m2), m2.push(H2 + C2.value), f2 = C2.length);
                      break;
                  }
                  break;
                case "label":
                  b2.push({ ind: C2, mode: S2, doc: x2.contents });
                  break;
              }
            b2.length === 0 && o2.length > 0 && (b2.push(...o2.reverse()), o2.length = 0);
          }
          let h2 = m2.indexOf(u2.placeholder);
          if (h2 !== -1) {
            let C2 = m2.indexOf(u2.placeholder, h2 + 1), S2 = m2.slice(0, h2).join(""), x2 = m2.slice(h2 + 1, C2).join(""), T2 = m2.slice(C2 + 1).join("");
            return { formatted: S2 + x2 + T2, cursorNodeStart: S2.length, cursorNodeText: x2 };
          }
          return { formatted: m2.join("") };
        }
        r2.exports = { printDocToString: A2 };
      } }), MD2 = Z2({ "src/document/doc-debug.js"(e25, r2) {
        ne2();
        var { isConcat: t2, getDocParts: s2 } = Yt2();
        function a2(u2) {
          if (!u2)
            return "";
          if (t2(u2)) {
            let i2 = [];
            for (let l2 of s2(u2))
              if (t2(l2))
                i2.push(...a2(l2).parts);
              else {
                let p2 = a2(l2);
                p2 !== "" && i2.push(p2);
              }
            return { type: "concat", parts: i2 };
          }
          return u2.type === "if-break" ? Object.assign(Object.assign({}, u2), {}, { breakContents: a2(u2.breakContents), flatContents: a2(u2.flatContents) }) : u2.type === "group" ? Object.assign(Object.assign({}, u2), {}, { contents: a2(u2.contents), expandedStates: u2.expandedStates && u2.expandedStates.map(a2) }) : u2.type === "fill" ? { type: "fill", parts: u2.parts.map(a2) } : u2.contents ? Object.assign(Object.assign({}, u2), {}, { contents: a2(u2.contents) }) : u2;
        }
        function n2(u2) {
          let i2 = Object.create(null), l2 = new Set();
          return p2(a2(u2));
          function p2(y2, g2, c2) {
            if (typeof y2 == "string")
              return JSON.stringify(y2);
            if (t2(y2)) {
              let D2 = s2(y2).map(p2).filter(Boolean);
              return D2.length === 1 ? D2[0] : `[${D2.join(", ")}]`;
            }
            if (y2.type === "line") {
              let D2 = Array.isArray(c2) && c2[g2 + 1] && c2[g2 + 1].type === "break-parent";
              return y2.literal ? D2 ? "literalline" : "literallineWithoutBreakParent" : y2.hard ? D2 ? "hardline" : "hardlineWithoutBreakParent" : y2.soft ? "softline" : "line";
            }
            if (y2.type === "break-parent")
              return Array.isArray(c2) && c2[g2 - 1] && c2[g2 - 1].type === "line" && c2[g2 - 1].hard ? void 0 : "breakParent";
            if (y2.type === "trim")
              return "trim";
            if (y2.type === "indent")
              return "indent(" + p2(y2.contents) + ")";
            if (y2.type === "align")
              return y2.n === Number.NEGATIVE_INFINITY ? "dedentToRoot(" + p2(y2.contents) + ")" : y2.n < 0 ? "dedent(" + p2(y2.contents) + ")" : y2.n.type === "root" ? "markAsRoot(" + p2(y2.contents) + ")" : "align(" + JSON.stringify(y2.n) + ", " + p2(y2.contents) + ")";
            if (y2.type === "if-break")
              return "ifBreak(" + p2(y2.breakContents) + (y2.flatContents ? ", " + p2(y2.flatContents) : "") + (y2.groupId ? (y2.flatContents ? "" : ', ""') + `, { groupId: ${d2(y2.groupId)} }` : "") + ")";
            if (y2.type === "indent-if-break") {
              let D2 = [];
              y2.negate && D2.push("negate: true"), y2.groupId && D2.push(`groupId: ${d2(y2.groupId)}`);
              let E2 = D2.length > 0 ? `, { ${D2.join(", ")} }` : "";
              return `indentIfBreak(${p2(y2.contents)}${E2})`;
            }
            if (y2.type === "group") {
              let D2 = [];
              y2.break && y2.break !== "propagated" && D2.push("shouldBreak: true"), y2.id && D2.push(`id: ${d2(y2.id)}`);
              let E2 = D2.length > 0 ? `, { ${D2.join(", ")} }` : "";
              return y2.expandedStates ? `conditionalGroup([${y2.expandedStates.map((_2) => p2(_2)).join(",")}]${E2})` : `group(${p2(y2.contents)}${E2})`;
            }
            if (y2.type === "fill")
              return `fill([${y2.parts.map((D2) => p2(D2)).join(", ")}])`;
            if (y2.type === "line-suffix")
              return "lineSuffix(" + p2(y2.contents) + ")";
            if (y2.type === "line-suffix-boundary")
              return "lineSuffixBoundary";
            if (y2.type === "label")
              return `label(${JSON.stringify(y2.label)}, ${p2(y2.contents)})`;
            throw new Error("Unknown doc type " + y2.type);
          }
          function d2(y2) {
            if (typeof y2 != "symbol")
              return JSON.stringify(String(y2));
            if (y2 in i2)
              return i2[y2];
            let g2 = String(y2).slice(7, -1) || "symbol";
            for (let c2 = 0; ; c2++) {
              let D2 = g2 + (c2 > 0 ? ` #${c2}` : "");
              if (!l2.has(D2))
                return l2.add(D2), i2[y2] = `Symbol.for(${JSON.stringify(D2)})`;
            }
          }
        }
        r2.exports = { printDocToDebug: n2 };
      } }), Me2 = Z2({ "src/document/index.js"(e25, r2) {
        ne2(), r2.exports = { builders: Un2(), printer: qD2(), utils: Yt2(), debug: MD2() };
      } }), ja2 = {};
      Kt2(ja2, { default: () => RD2 });
      function RD2(e25) {
        if (typeof e25 != "string")
          throw new TypeError("Expected a string");
        return e25.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
      }
      var $D2 = ht2({ "node_modules/escape-string-regexp/index.js"() {
        ne2();
      } }), qa2 = Z2({ "node_modules/semver/internal/debug.js"(e25, r2) {
        ne2();
        var t2 = typeof wt2 == "object" && wt2.env && wt2.env.NODE_DEBUG && /\bsemver\b/i.test(wt2.env.NODE_DEBUG) ? function() {
          for (var s2 = arguments.length, a2 = new Array(s2), n2 = 0; n2 < s2; n2++)
            a2[n2] = arguments[n2];
          return console.error("SEMVER", ...a2);
        } : () => {
        };
        r2.exports = t2;
      } }), Ma2 = Z2({ "node_modules/semver/internal/constants.js"(e25, r2) {
        ne2();
        var t2 = "2.0.0", s2 = 256, a2 = Number.MAX_SAFE_INTEGER || 9007199254740991, n2 = 16;
        r2.exports = { SEMVER_SPEC_VERSION: t2, MAX_LENGTH: s2, MAX_SAFE_INTEGER: a2, MAX_SAFE_COMPONENT_LENGTH: n2 };
      } }), VD2 = Z2({ "node_modules/semver/internal/re.js"(e25, r2) {
        ne2();
        var { MAX_SAFE_COMPONENT_LENGTH: t2 } = Ma2(), s2 = qa2();
        e25 = r2.exports = {};
        var a2 = e25.re = [], n2 = e25.src = [], u2 = e25.t = {}, i2 = 0, l2 = (p2, d2, y2) => {
          let g2 = i2++;
          s2(p2, g2, d2), u2[p2] = g2, n2[g2] = d2, a2[g2] = new RegExp(d2, y2 ? "g" : void 0);
        };
        l2("NUMERICIDENTIFIER", "0|[1-9]\\d*"), l2("NUMERICIDENTIFIERLOOSE", "[0-9]+"), l2("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), l2("MAINVERSION", `(${n2[u2.NUMERICIDENTIFIER]})\\.(${n2[u2.NUMERICIDENTIFIER]})\\.(${n2[u2.NUMERICIDENTIFIER]})`), l2("MAINVERSIONLOOSE", `(${n2[u2.NUMERICIDENTIFIERLOOSE]})\\.(${n2[u2.NUMERICIDENTIFIERLOOSE]})\\.(${n2[u2.NUMERICIDENTIFIERLOOSE]})`), l2("PRERELEASEIDENTIFIER", `(?:${n2[u2.NUMERICIDENTIFIER]}|${n2[u2.NONNUMERICIDENTIFIER]})`), l2("PRERELEASEIDENTIFIERLOOSE", `(?:${n2[u2.NUMERICIDENTIFIERLOOSE]}|${n2[u2.NONNUMERICIDENTIFIER]})`), l2("PRERELEASE", `(?:-(${n2[u2.PRERELEASEIDENTIFIER]}(?:\\.${n2[u2.PRERELEASEIDENTIFIER]})*))`), l2("PRERELEASELOOSE", `(?:-?(${n2[u2.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${n2[u2.PRERELEASEIDENTIFIERLOOSE]})*))`), l2("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), l2("BUILD", `(?:\\+(${n2[u2.BUILDIDENTIFIER]}(?:\\.${n2[u2.BUILDIDENTIFIER]})*))`), l2("FULLPLAIN", `v?${n2[u2.MAINVERSION]}${n2[u2.PRERELEASE]}?${n2[u2.BUILD]}?`), l2("FULL", `^${n2[u2.FULLPLAIN]}$`), l2("LOOSEPLAIN", `[v=\\s]*${n2[u2.MAINVERSIONLOOSE]}${n2[u2.PRERELEASELOOSE]}?${n2[u2.BUILD]}?`), l2("LOOSE", `^${n2[u2.LOOSEPLAIN]}$`), l2("GTLT", "((?:<|>)?=?)"), l2("XRANGEIDENTIFIERLOOSE", `${n2[u2.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), l2("XRANGEIDENTIFIER", `${n2[u2.NUMERICIDENTIFIER]}|x|X|\\*`), l2("XRANGEPLAIN", `[v=\\s]*(${n2[u2.XRANGEIDENTIFIER]})(?:\\.(${n2[u2.XRANGEIDENTIFIER]})(?:\\.(${n2[u2.XRANGEIDENTIFIER]})(?:${n2[u2.PRERELEASE]})?${n2[u2.BUILD]}?)?)?`), l2("XRANGEPLAINLOOSE", `[v=\\s]*(${n2[u2.XRANGEIDENTIFIERLOOSE]})(?:\\.(${n2[u2.XRANGEIDENTIFIERLOOSE]})(?:\\.(${n2[u2.XRANGEIDENTIFIERLOOSE]})(?:${n2[u2.PRERELEASELOOSE]})?${n2[u2.BUILD]}?)?)?`), l2("XRANGE", `^${n2[u2.GTLT]}\\s*${n2[u2.XRANGEPLAIN]}$`), l2("XRANGELOOSE", `^${n2[u2.GTLT]}\\s*${n2[u2.XRANGEPLAINLOOSE]}$`), l2("COERCE", `(^|[^\\d])(\\d{1,${t2}})(?:\\.(\\d{1,${t2}}))?(?:\\.(\\d{1,${t2}}))?(?:$|[^\\d])`), l2("COERCERTL", n2[u2.COERCE], true), l2("LONETILDE", "(?:~>?)"), l2("TILDETRIM", `(\\s*)${n2[u2.LONETILDE]}\\s+`, true), e25.tildeTrimReplace = "$1~", l2("TILDE", `^${n2[u2.LONETILDE]}${n2[u2.XRANGEPLAIN]}$`), l2("TILDELOOSE", `^${n2[u2.LONETILDE]}${n2[u2.XRANGEPLAINLOOSE]}$`), l2("LONECARET", "(?:\\^)"), l2("CARETTRIM", `(\\s*)${n2[u2.LONECARET]}\\s+`, true), e25.caretTrimReplace = "$1^", l2("CARET", `^${n2[u2.LONECARET]}${n2[u2.XRANGEPLAIN]}$`), l2("CARETLOOSE", `^${n2[u2.LONECARET]}${n2[u2.XRANGEPLAINLOOSE]}$`), l2("COMPARATORLOOSE", `^${n2[u2.GTLT]}\\s*(${n2[u2.LOOSEPLAIN]})$|^$`), l2("COMPARATOR", `^${n2[u2.GTLT]}\\s*(${n2[u2.FULLPLAIN]})$|^$`), l2("COMPARATORTRIM", `(\\s*)${n2[u2.GTLT]}\\s*(${n2[u2.LOOSEPLAIN]}|${n2[u2.XRANGEPLAIN]})`, true), e25.comparatorTrimReplace = "$1$2$3", l2("HYPHENRANGE", `^\\s*(${n2[u2.XRANGEPLAIN]})\\s+-\\s+(${n2[u2.XRANGEPLAIN]})\\s*$`), l2("HYPHENRANGELOOSE", `^\\s*(${n2[u2.XRANGEPLAINLOOSE]})\\s+-\\s+(${n2[u2.XRANGEPLAINLOOSE]})\\s*$`), l2("STAR", "(<|>)?=?\\s*\\*"), l2("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), l2("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
      } }), WD2 = Z2({ "node_modules/semver/internal/parse-options.js"(e25, r2) {
        ne2();
        var t2 = ["includePrerelease", "loose", "rtl"], s2 = (a2) => a2 ? typeof a2 != "object" ? { loose: true } : t2.filter((n2) => a2[n2]).reduce((n2, u2) => (n2[u2] = true, n2), {}) : {};
        r2.exports = s2;
      } }), HD2 = Z2({ "node_modules/semver/internal/identifiers.js"(e25, r2) {
        ne2();
        var t2 = /^[0-9]+$/, s2 = (n2, u2) => {
          let i2 = t2.test(n2), l2 = t2.test(u2);
          return i2 && l2 && (n2 = +n2, u2 = +u2), n2 === u2 ? 0 : i2 && !l2 ? -1 : l2 && !i2 ? 1 : n2 < u2 ? -1 : 1;
        }, a2 = (n2, u2) => s2(u2, n2);
        r2.exports = { compareIdentifiers: s2, rcompareIdentifiers: a2 };
      } }), GD2 = Z2({ "node_modules/semver/classes/semver.js"(e25, r2) {
        ne2();
        var t2 = qa2(), { MAX_LENGTH: s2, MAX_SAFE_INTEGER: a2 } = Ma2(), { re: n2, t: u2 } = VD2(), i2 = WD2(), { compareIdentifiers: l2 } = HD2(), p2 = class {
          constructor(d2, y2) {
            if (y2 = i2(y2), d2 instanceof p2) {
              if (d2.loose === !!y2.loose && d2.includePrerelease === !!y2.includePrerelease)
                return d2;
              d2 = d2.version;
            } else if (typeof d2 != "string")
              throw new TypeError(`Invalid Version: ${d2}`);
            if (d2.length > s2)
              throw new TypeError(`version is longer than ${s2} characters`);
            t2("SemVer", d2, y2), this.options = y2, this.loose = !!y2.loose, this.includePrerelease = !!y2.includePrerelease;
            let g2 = d2.trim().match(y2.loose ? n2[u2.LOOSE] : n2[u2.FULL]);
            if (!g2)
              throw new TypeError(`Invalid Version: ${d2}`);
            if (this.raw = d2, this.major = +g2[1], this.minor = +g2[2], this.patch = +g2[3], this.major > a2 || this.major < 0)
              throw new TypeError("Invalid major version");
            if (this.minor > a2 || this.minor < 0)
              throw new TypeError("Invalid minor version");
            if (this.patch > a2 || this.patch < 0)
              throw new TypeError("Invalid patch version");
            g2[4] ? this.prerelease = g2[4].split(".").map((c2) => {
              if (/^[0-9]+$/.test(c2)) {
                let D2 = +c2;
                if (D2 >= 0 && D2 < a2)
                  return D2;
              }
              return c2;
            }) : this.prerelease = [], this.build = g2[5] ? g2[5].split(".") : [], this.format();
          }
          format() {
            return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
          }
          toString() {
            return this.version;
          }
          compare(d2) {
            if (t2("SemVer.compare", this.version, this.options, d2), !(d2 instanceof p2)) {
              if (typeof d2 == "string" && d2 === this.version)
                return 0;
              d2 = new p2(d2, this.options);
            }
            return d2.version === this.version ? 0 : this.compareMain(d2) || this.comparePre(d2);
          }
          compareMain(d2) {
            return d2 instanceof p2 || (d2 = new p2(d2, this.options)), l2(this.major, d2.major) || l2(this.minor, d2.minor) || l2(this.patch, d2.patch);
          }
          comparePre(d2) {
            if (d2 instanceof p2 || (d2 = new p2(d2, this.options)), this.prerelease.length && !d2.prerelease.length)
              return -1;
            if (!this.prerelease.length && d2.prerelease.length)
              return 1;
            if (!this.prerelease.length && !d2.prerelease.length)
              return 0;
            let y2 = 0;
            do {
              let g2 = this.prerelease[y2], c2 = d2.prerelease[y2];
              if (t2("prerelease compare", y2, g2, c2), g2 === void 0 && c2 === void 0)
                return 0;
              if (c2 === void 0)
                return 1;
              if (g2 === void 0)
                return -1;
              if (g2 === c2)
                continue;
              return l2(g2, c2);
            } while (++y2);
          }
          compareBuild(d2) {
            d2 instanceof p2 || (d2 = new p2(d2, this.options));
            let y2 = 0;
            do {
              let g2 = this.build[y2], c2 = d2.build[y2];
              if (t2("prerelease compare", y2, g2, c2), g2 === void 0 && c2 === void 0)
                return 0;
              if (c2 === void 0)
                return 1;
              if (g2 === void 0)
                return -1;
              if (g2 === c2)
                continue;
              return l2(g2, c2);
            } while (++y2);
          }
          inc(d2, y2) {
            switch (d2) {
              case "premajor":
                this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", y2);
                break;
              case "preminor":
                this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", y2);
                break;
              case "prepatch":
                this.prerelease.length = 0, this.inc("patch", y2), this.inc("pre", y2);
                break;
              case "prerelease":
                this.prerelease.length === 0 && this.inc("patch", y2), this.inc("pre", y2);
                break;
              case "major":
                (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
                break;
              case "minor":
                (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
                break;
              case "patch":
                this.prerelease.length === 0 && this.patch++, this.prerelease = [];
                break;
              case "pre":
                if (this.prerelease.length === 0)
                  this.prerelease = [0];
                else {
                  let g2 = this.prerelease.length;
                  for (; --g2 >= 0; )
                    typeof this.prerelease[g2] == "number" && (this.prerelease[g2]++, g2 = -2);
                  g2 === -1 && this.prerelease.push(0);
                }
                y2 && (l2(this.prerelease[0], y2) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = [y2, 0]) : this.prerelease = [y2, 0]);
                break;
              default:
                throw new Error(`invalid increment argument: ${d2}`);
            }
            return this.format(), this.raw = this.version, this;
          }
        };
        r2.exports = p2;
      } }), zn = Z2({ "node_modules/semver/functions/compare.js"(e25, r2) {
        ne2();
        var t2 = GD2(), s2 = (a2, n2, u2) => new t2(a2, u2).compare(new t2(n2, u2));
        r2.exports = s2;
      } }), UD2 = Z2({ "node_modules/semver/functions/lt.js"(e25, r2) {
        ne2();
        var t2 = zn(), s2 = (a2, n2, u2) => t2(a2, n2, u2) < 0;
        r2.exports = s2;
      } }), JD2 = Z2({ "node_modules/semver/functions/gte.js"(e25, r2) {
        ne2();
        var t2 = zn(), s2 = (a2, n2, u2) => t2(a2, n2, u2) >= 0;
        r2.exports = s2;
      } }), zD2 = Z2({ "src/utils/arrayify.js"(e25, r2) {
        ne2(), r2.exports = (t2, s2) => Object.entries(t2).map((a2) => {
          let [n2, u2] = a2;
          return Object.assign({ [s2]: n2 }, u2);
        });
      } }), XD2 = Z2({ "node_modules/outdent/lib/index.js"(e25, r2) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true }), e25.outdent = void 0;
        function t2() {
          for (var F2 = [], A2 = 0; A2 < arguments.length; A2++)
            F2[A2] = arguments[A2];
        }
        function s2() {
          return typeof WeakMap < "u" ? new WeakMap() : a2();
        }
        function a2() {
          return { add: t2, delete: t2, get: t2, set: t2, has: function(F2) {
            return false;
          } };
        }
        var n2 = Object.prototype.hasOwnProperty, u2 = function(F2, A2) {
          return n2.call(F2, A2);
        };
        function i2(F2, A2) {
          for (var N2 in A2)
            u2(A2, N2) && (F2[N2] = A2[N2]);
          return F2;
        }
        var l2 = /^[ \t]*(?:\r\n|\r|\n)/, p2 = /(?:\r\n|\r|\n)[ \t]*$/, d2 = /^(?:[\r\n]|$)/, y2 = /(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/, g2 = /^[ \t]*[\r\n][ \t\r\n]*$/;
        function c2(F2, A2, N2) {
          var I2 = 0, P2 = F2[0].match(y2);
          P2 && (I2 = P2[1].length);
          var H2 = "(\\r\\n|\\r|\\n).{0," + I2 + "}", f2 = new RegExp(H2, "g");
          A2 && (F2 = F2.slice(1));
          var b2 = N2.newline, m2 = N2.trimLeadingNewline, v2 = N2.trimTrailingNewline, o2 = typeof b2 == "string", h2 = F2.length, C2 = F2.map(function(S2, x2) {
            return S2 = S2.replace(f2, "$1"), x2 === 0 && m2 && (S2 = S2.replace(l2, "")), x2 === h2 - 1 && v2 && (S2 = S2.replace(p2, "")), o2 && (S2 = S2.replace(/\r\n|\n|\r/g, function(T2) {
              return b2;
            })), S2;
          });
          return C2;
        }
        function D2(F2, A2) {
          for (var N2 = "", I2 = 0, P2 = F2.length; I2 < P2; I2++)
            N2 += F2[I2], I2 < P2 - 1 && (N2 += A2[I2]);
          return N2;
        }
        function E2(F2) {
          return u2(F2, "raw") && u2(F2, "length");
        }
        function _2(F2) {
          var A2 = s2(), N2 = s2();
          function I2(H2) {
            for (var f2 = [], b2 = 1; b2 < arguments.length; b2++)
              f2[b2 - 1] = arguments[b2];
            if (E2(H2)) {
              var m2 = H2, v2 = (f2[0] === I2 || f2[0] === w2) && g2.test(m2[0]) && d2.test(m2[1]), o2 = v2 ? N2 : A2, h2 = o2.get(m2);
              if (h2 || (h2 = c2(m2, v2, F2), o2.set(m2, h2)), f2.length === 0)
                return h2[0];
              var C2 = D2(h2, v2 ? f2.slice(1) : f2);
              return C2;
            } else
              return _2(i2(i2({}, F2), H2 || {}));
          }
          var P2 = i2(I2, { string: function(H2) {
            return c2([H2], false, F2)[0];
          } });
          return P2;
        }
        var w2 = _2({ trimLeadingNewline: true, trimTrailingNewline: true });
        if (e25.outdent = w2, e25.default = w2, typeof r2 < "u")
          try {
            r2.exports = w2, Object.defineProperty(w2, "__esModule", { value: true }), w2.default = w2, w2.outdent = w2;
          } catch {
          }
      } }), KD2 = Z2({ "src/main/core-options.js"(e25, r2) {
        ne2();
        var { outdent: t2 } = XD2(), s2 = "Config", a2 = "Editor", n2 = "Format", u2 = "Other", i2 = "Output", l2 = "Global", p2 = "Special", d2 = { cursorOffset: { since: "1.4.0", category: p2, type: "int", default: -1, range: { start: -1, end: Number.POSITIVE_INFINITY, step: 1 }, description: t2`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `, cliCategory: a2 }, endOfLine: { since: "1.15.0", category: l2, type: "choice", default: [{ since: "1.15.0", value: "auto" }, { since: "2.0.0", value: "lf" }], description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: t2`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        ` }] }, filepath: { since: "1.4.0", category: p2, type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: u2, cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { since: "1.8.0", category: p2, type: "boolean", default: false, description: "Insert @format pragma into file's first docblock comment.", cliCategory: u2 }, parser: { since: "0.0.10", category: l2, type: "choice", default: [{ since: "0.0.10", value: "babylon" }, { since: "1.13.0", value: void 0 }], description: "Which parser to use.", exception: (y2) => typeof y2 == "string" || typeof y2 == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", since: "1.16.0", description: "JavaScript" }, { value: "babel-flow", since: "1.16.0", description: "Flow" }, { value: "babel-ts", since: "2.0.0", description: "TypeScript" }, { value: "typescript", since: "1.4.0", description: "TypeScript" }, { value: "acorn", since: "2.6.0", description: "JavaScript" }, { value: "espree", since: "2.2.0", description: "JavaScript" }, { value: "meriyah", since: "2.2.0", description: "JavaScript" }, { value: "css", since: "1.7.1", description: "CSS" }, { value: "less", since: "1.7.1", description: "Less" }, { value: "scss", since: "1.7.1", description: "SCSS" }, { value: "json", since: "1.5.0", description: "JSON" }, { value: "json5", since: "1.13.0", description: "JSON5" }, { value: "json-stringify", since: "1.13.0", description: "JSON.stringify" }, { value: "graphql", since: "1.5.0", description: "GraphQL" }, { value: "markdown", since: "1.8.0", description: "Markdown" }, { value: "mdx", since: "1.15.0", description: "MDX" }, { value: "vue", since: "1.10.0", description: "Vue" }, { value: "yaml", since: "1.14.0", description: "YAML" }, { value: "glimmer", since: "2.3.0", description: "Ember / Handlebars" }, { value: "html", since: "1.15.0", description: "HTML" }, { value: "angular", since: "1.15.0", description: "Angular" }, { value: "lwc", since: "1.17.0", description: "Lightning Web Components" }] }, plugins: { since: "1.10.0", type: "path", array: true, default: [{ value: [] }], category: l2, description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (y2) => typeof y2 == "string" || typeof y2 == "object", cliName: "plugin", cliCategory: s2 }, pluginSearchDirs: { since: "1.13.0", type: "path", array: true, default: [{ value: [] }], category: l2, description: t2`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `, exception: (y2) => typeof y2 == "string" || typeof y2 == "object", cliName: "plugin-search-dir", cliCategory: s2 }, printWidth: { since: "0.0.0", category: l2, type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, rangeEnd: { since: "1.4.0", category: p2, type: "int", default: Number.POSITIVE_INFINITY, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t2`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: a2 }, rangeStart: { since: "1.4.0", category: p2, type: "int", default: 0, range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 }, description: t2`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `, cliCategory: a2 }, requirePragma: { since: "1.7.0", category: p2, type: "boolean", default: false, description: t2`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `, cliCategory: u2 }, tabWidth: { type: "int", category: l2, default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: Number.POSITIVE_INFINITY, step: 1 } }, useTabs: { since: "1.0.0", category: l2, type: "boolean", default: false, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { since: "2.1.0", category: l2, type: "choice", default: [{ since: "2.1.0", value: "auto" }], description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
        r2.exports = { CATEGORY_CONFIG: s2, CATEGORY_EDITOR: a2, CATEGORY_FORMAT: n2, CATEGORY_OTHER: u2, CATEGORY_OUTPUT: i2, CATEGORY_GLOBAL: l2, CATEGORY_SPECIAL: p2, options: d2 };
      } }), Xn2 = Z2({ "src/main/support.js"(e25, r2) {
        ne2();
        var t2 = { compare: zn(), lt: UD2(), gte: JD2() }, s2 = zD2(), a2 = Ia2().version, n2 = KD2().options;
        function u2() {
          let { plugins: l2 = [], showUnreleased: p2 = false, showDeprecated: d2 = false, showInternal: y2 = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g2 = a2.split("-", 1)[0], c2 = l2.flatMap((F2) => F2.languages || []).filter(E2), D2 = s2(Object.assign({}, ...l2.map((F2) => {
            let { options: A2 } = F2;
            return A2;
          }), n2), "name").filter((F2) => E2(F2) && _2(F2)).sort((F2, A2) => F2.name === A2.name ? 0 : F2.name < A2.name ? -1 : 1).map(w2).map((F2) => {
            F2 = Object.assign({}, F2), Array.isArray(F2.default) && (F2.default = F2.default.length === 1 ? F2.default[0].value : F2.default.filter(E2).sort((N2, I2) => t2.compare(I2.since, N2.since))[0].value), Array.isArray(F2.choices) && (F2.choices = F2.choices.filter((N2) => E2(N2) && _2(N2)), F2.name === "parser" && i2(F2, c2, l2));
            let A2 = Object.fromEntries(l2.filter((N2) => N2.defaultOptions && N2.defaultOptions[F2.name] !== void 0).map((N2) => [N2.name, N2.defaultOptions[F2.name]]));
            return Object.assign(Object.assign({}, F2), {}, { pluginDefaults: A2 });
          });
          return { languages: c2, options: D2 };
          function E2(F2) {
            return p2 || !("since" in F2) || F2.since && t2.gte(g2, F2.since);
          }
          function _2(F2) {
            return d2 || !("deprecated" in F2) || F2.deprecated && t2.lt(g2, F2.deprecated);
          }
          function w2(F2) {
            if (y2)
              return F2;
            return Hn2(F2, hD2);
          }
        }
        function i2(l2, p2, d2) {
          let y2 = new Set(l2.choices.map((g2) => g2.value));
          for (let g2 of p2)
            if (g2.parsers) {
              for (let c2 of g2.parsers)
                if (!y2.has(c2)) {
                  y2.add(c2);
                  let D2 = d2.find((_2) => _2.parsers && _2.parsers[c2]), E2 = g2.name;
                  D2 && D2.name && (E2 += ` (plugin: ${D2.name})`), l2.choices.push({ value: c2, description: E2 });
                }
            }
        }
        r2.exports = { getSupportInfo: u2 };
      } }), Kn2 = Z2({ "src/utils/is-non-empty-array.js"(e25, r2) {
        ne2();
        function t2(s2) {
          return Array.isArray(s2) && s2.length > 0;
        }
        r2.exports = t2;
      } }), Pr2 = Z2({ "src/utils/text/skip.js"(e25, r2) {
        ne2();
        function t2(i2) {
          return (l2, p2, d2) => {
            let y2 = d2 && d2.backwards;
            if (p2 === false)
              return false;
            let { length: g2 } = l2, c2 = p2;
            for (; c2 >= 0 && c2 < g2; ) {
              let D2 = l2.charAt(c2);
              if (i2 instanceof RegExp) {
                if (!i2.test(D2))
                  return c2;
              } else if (!i2.includes(D2))
                return c2;
              y2 ? c2-- : c2++;
            }
            return c2 === -1 || c2 === g2 ? c2 : false;
          };
        }
        var s2 = t2(/\s/), a2 = t2(" 	"), n2 = t2(",; 	"), u2 = t2(/[^\n\r]/);
        r2.exports = { skipWhitespace: s2, skipSpaces: a2, skipToLineEnd: n2, skipEverythingButNewLine: u2 };
      } }), Ra2 = Z2({ "src/utils/text/skip-inline-comment.js"(e25, r2) {
        ne2();
        function t2(s2, a2) {
          if (a2 === false)
            return false;
          if (s2.charAt(a2) === "/" && s2.charAt(a2 + 1) === "*") {
            for (let n2 = a2 + 2; n2 < s2.length; ++n2)
              if (s2.charAt(n2) === "*" && s2.charAt(n2 + 1) === "/")
                return n2 + 2;
          }
          return a2;
        }
        r2.exports = t2;
      } }), $a2 = Z2({ "src/utils/text/skip-trailing-comment.js"(e25, r2) {
        ne2();
        var { skipEverythingButNewLine: t2 } = Pr2();
        function s2(a2, n2) {
          return n2 === false ? false : a2.charAt(n2) === "/" && a2.charAt(n2 + 1) === "/" ? t2(a2, n2) : n2;
        }
        r2.exports = s2;
      } }), Va2 = Z2({ "src/utils/text/skip-newline.js"(e25, r2) {
        ne2();
        function t2(s2, a2, n2) {
          let u2 = n2 && n2.backwards;
          if (a2 === false)
            return false;
          let i2 = s2.charAt(a2);
          if (u2) {
            if (s2.charAt(a2 - 1) === "\r" && i2 === `
`)
              return a2 - 2;
            if (i2 === `
` || i2 === "\r" || i2 === "\u2028" || i2 === "\u2029")
              return a2 - 1;
          } else {
            if (i2 === "\r" && s2.charAt(a2 + 1) === `
`)
              return a2 + 2;
            if (i2 === `
` || i2 === "\r" || i2 === "\u2028" || i2 === "\u2029")
              return a2 + 1;
          }
          return a2;
        }
        r2.exports = t2;
      } }), YD2 = Z2({ "src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(e25, r2) {
        ne2();
        var t2 = Ra2(), s2 = Va2(), a2 = $a2(), { skipSpaces: n2 } = Pr2();
        function u2(i2, l2) {
          let p2 = null, d2 = l2;
          for (; d2 !== p2; )
            p2 = d2, d2 = n2(i2, d2), d2 = t2(i2, d2), d2 = a2(i2, d2), d2 = s2(i2, d2);
          return d2;
        }
        r2.exports = u2;
      } }), Ue2 = Z2({ "src/common/util.js"(e25, r2) {
        ne2();
        var { default: t2 } = ($D2(), ft2(ja2)), s2 = lt2(), { getSupportInfo: a2 } = Xn2(), n2 = Kn2(), u2 = Oa2(), { skipWhitespace: i2, skipSpaces: l2, skipToLineEnd: p2, skipEverythingButNewLine: d2 } = Pr2(), y2 = Ra2(), g2 = $a2(), c2 = Va2(), D2 = YD2(), E2 = (V2) => V2[V2.length - 2];
        function _2(V2) {
          return (j2, K2, se2) => {
            let Q2 = se2 && se2.backwards;
            if (K2 === false)
              return false;
            let { length: ce2 } = j2, W2 = K2;
            for (; W2 >= 0 && W2 < ce2; ) {
              let X2 = j2.charAt(W2);
              if (V2 instanceof RegExp) {
                if (!V2.test(X2))
                  return W2;
              } else if (!V2.includes(X2))
                return W2;
              Q2 ? W2-- : W2++;
            }
            return W2 === -1 || W2 === ce2 ? W2 : false;
          };
        }
        function w2(V2, j2) {
          let K2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, se2 = l2(V2, K2.backwards ? j2 - 1 : j2, K2), Q2 = c2(V2, se2, K2);
          return se2 !== Q2;
        }
        function F2(V2, j2, K2) {
          for (let se2 = j2; se2 < K2; ++se2)
            if (V2.charAt(se2) === `
`)
              return true;
          return false;
        }
        function A2(V2, j2, K2) {
          let se2 = K2(j2) - 1;
          se2 = l2(V2, se2, { backwards: true }), se2 = c2(V2, se2, { backwards: true }), se2 = l2(V2, se2, { backwards: true });
          let Q2 = c2(V2, se2, { backwards: true });
          return se2 !== Q2;
        }
        function N2(V2, j2) {
          let K2 = null, se2 = j2;
          for (; se2 !== K2; )
            K2 = se2, se2 = p2(V2, se2), se2 = y2(V2, se2), se2 = l2(V2, se2);
          return se2 = g2(V2, se2), se2 = c2(V2, se2), se2 !== false && w2(V2, se2);
        }
        function I2(V2, j2, K2) {
          return N2(V2, K2(j2));
        }
        function P2(V2, j2, K2) {
          return D2(V2, K2(j2));
        }
        function H2(V2, j2, K2) {
          return V2.charAt(P2(V2, j2, K2));
        }
        function f2(V2, j2) {
          let K2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return l2(V2, K2.backwards ? j2 - 1 : j2, K2) !== j2;
        }
        function b2(V2, j2) {
          let K2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, se2 = 0;
          for (let Q2 = K2; Q2 < V2.length; ++Q2)
            V2[Q2] === "	" ? se2 = se2 + j2 - se2 % j2 : se2++;
          return se2;
        }
        function m2(V2, j2) {
          let K2 = V2.lastIndexOf(`
`);
          return K2 === -1 ? 0 : b2(V2.slice(K2 + 1).match(/^[\t ]*/)[0], j2);
        }
        function v2(V2, j2) {
          let K2 = { quote: '"', regex: /"/g, escaped: "&quot;" }, se2 = { quote: "'", regex: /'/g, escaped: "&apos;" }, Q2 = j2 === "'" ? se2 : K2, ce2 = Q2 === se2 ? K2 : se2, W2 = Q2;
          if (V2.includes(Q2.quote) || V2.includes(ce2.quote)) {
            let X2 = (V2.match(Q2.regex) || []).length, de2 = (V2.match(ce2.regex) || []).length;
            W2 = X2 > de2 ? ce2 : Q2;
          }
          return W2;
        }
        function o2(V2, j2) {
          let K2 = V2.slice(1, -1), se2 = j2.parser === "json" || j2.parser === "json5" && j2.quoteProps === "preserve" && !j2.singleQuote ? '"' : j2.__isInHtmlAttribute ? "'" : v2(K2, j2.singleQuote ? "'" : '"').quote;
          return h2(K2, se2, !(j2.parser === "css" || j2.parser === "less" || j2.parser === "scss" || j2.__embeddedInHtml));
        }
        function h2(V2, j2, K2) {
          let se2 = j2 === '"' ? "'" : '"', Q2 = /\\(.)|(["'])/gs, ce2 = V2.replace(Q2, (W2, X2, de2) => X2 === se2 ? X2 : de2 === j2 ? "\\" + de2 : de2 || (K2 && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(X2) ? X2 : "\\" + X2));
          return j2 + ce2 + j2;
        }
        function C2(V2) {
          return V2.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/, "$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/, "$1").replace(/^([+-])?\./, "$10.").replace(/(\.\d+?)0+(?=e|$)/, "$1").replace(/\.(?=e|$)/, "");
        }
        function S2(V2, j2) {
          let K2 = V2.match(new RegExp(`(${t2(j2)})+`, "g"));
          return K2 === null ? 0 : K2.reduce((se2, Q2) => Math.max(se2, Q2.length / j2.length), 0);
        }
        function x2(V2, j2) {
          let K2 = V2.match(new RegExp(`(${t2(j2)})+`, "g"));
          if (K2 === null)
            return 0;
          let se2 = new Map(), Q2 = 0;
          for (let ce2 of K2) {
            let W2 = ce2.length / j2.length;
            se2.set(W2, true), W2 > Q2 && (Q2 = W2);
          }
          for (let ce2 = 1; ce2 < Q2; ce2++)
            if (!se2.get(ce2))
              return ce2;
          return Q2 + 1;
        }
        function T2(V2, j2) {
          (V2.comments || (V2.comments = [])).push(j2), j2.printed = false, j2.nodeDescription = Y2(V2);
        }
        function k2(V2, j2) {
          j2.leading = true, j2.trailing = false, T2(V2, j2);
        }
        function M2(V2, j2, K2) {
          j2.leading = false, j2.trailing = false, K2 && (j2.marker = K2), T2(V2, j2);
        }
        function R2(V2, j2) {
          j2.leading = false, j2.trailing = true, T2(V2, j2);
        }
        function q2(V2, j2) {
          let { languages: K2 } = a2({ plugins: j2.plugins }), se2 = K2.find((Q2) => {
            let { name: ce2 } = Q2;
            return ce2.toLowerCase() === V2;
          }) || K2.find((Q2) => {
            let { aliases: ce2 } = Q2;
            return Array.isArray(ce2) && ce2.includes(V2);
          }) || K2.find((Q2) => {
            let { extensions: ce2 } = Q2;
            return Array.isArray(ce2) && ce2.includes(`.${V2}`);
          });
          return se2 && se2.parsers[0];
        }
        function U2(V2) {
          return V2 && V2.type === "front-matter";
        }
        function L2(V2) {
          let j2 = new WeakMap();
          return function(K2) {
            return j2.has(K2) || j2.set(K2, Symbol(V2)), j2.get(K2);
          };
        }
        function Y2(V2) {
          let j2 = V2.type || V2.kind || "(unknown type)", K2 = String(V2.name || V2.id && (typeof V2.id == "object" ? V2.id.name : V2.id) || V2.key && (typeof V2.key == "object" ? V2.key.name : V2.key) || V2.value && (typeof V2.value == "object" ? "" : String(V2.value)) || V2.operator || "");
          return K2.length > 20 && (K2 = K2.slice(0, 19) + "\u2026"), j2 + (K2 ? " " + K2 : "");
        }
        r2.exports = { inferParserByLanguage: q2, getStringWidth: u2, getMaxContinuousCount: S2, getMinNotPresentContinuousCount: x2, getPenultimate: E2, getLast: s2, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: D2, getNextNonSpaceNonCommentCharacterIndex: P2, getNextNonSpaceNonCommentCharacter: H2, skip: _2, skipWhitespace: i2, skipSpaces: l2, skipToLineEnd: p2, skipEverythingButNewLine: d2, skipInlineComment: y2, skipTrailingComment: g2, skipNewline: c2, isNextLineEmptyAfterIndex: N2, isNextLineEmpty: I2, isPreviousLineEmpty: A2, hasNewline: w2, hasNewlineInRange: F2, hasSpaces: f2, getAlignmentSize: b2, getIndentSize: m2, getPreferredQuote: v2, printString: o2, printNumber: C2, makeString: h2, addLeadingComment: k2, addDanglingComment: M2, addTrailingComment: R2, isFrontMatterNode: U2, isNonEmptyArray: n2, createGroupIdMapper: L2 };
      } }), Wa2 = {};
      Kt2(Wa2, { basename: () => za2, default: () => Ka2, delimiter: () => Mn2, dirname: () => Ja2, extname: () => Xa2, isAbsolute: () => Qn2, join: () => Ga2, normalize: () => Yn2, relative: () => Ua2, resolve: () => wr2, sep: () => qn2 });
      function Ha2(e25, r2) {
        for (var t2 = 0, s2 = e25.length - 1; s2 >= 0; s2--) {
          var a2 = e25[s2];
          a2 === "." ? e25.splice(s2, 1) : a2 === ".." ? (e25.splice(s2, 1), t2++) : t2 && (e25.splice(s2, 1), t2--);
        }
        if (r2)
          for (; t2--; t2)
            e25.unshift("..");
        return e25;
      }
      function wr2() {
        for (var e25 = "", r2 = false, t2 = arguments.length - 1; t2 >= -1 && !r2; t2--) {
          var s2 = t2 >= 0 ? arguments[t2] : "/";
          if (typeof s2 != "string")
            throw new TypeError("Arguments to path.resolve must be strings");
          if (!s2)
            continue;
          e25 = s2 + "/" + e25, r2 = s2.charAt(0) === "/";
        }
        return e25 = Ha2(Zn2(e25.split("/"), function(a2) {
          return !!a2;
        }), !r2).join("/"), (r2 ? "/" : "") + e25 || ".";
      }
      function Yn2(e25) {
        var r2 = Qn2(e25), t2 = Ya2(e25, -1) === "/";
        return e25 = Ha2(Zn2(e25.split("/"), function(s2) {
          return !!s2;
        }), !r2).join("/"), !e25 && !r2 && (e25 = "."), e25 && t2 && (e25 += "/"), (r2 ? "/" : "") + e25;
      }
      function Qn2(e25) {
        return e25.charAt(0) === "/";
      }
      function Ga2() {
        var e25 = Array.prototype.slice.call(arguments, 0);
        return Yn2(Zn2(e25, function(r2, t2) {
          if (typeof r2 != "string")
            throw new TypeError("Arguments to path.join must be strings");
          return r2;
        }).join("/"));
      }
      function Ua2(e25, r2) {
        e25 = wr2(e25).substr(1), r2 = wr2(r2).substr(1);
        function t2(p2) {
          for (var d2 = 0; d2 < p2.length && p2[d2] === ""; d2++)
            ;
          for (var y2 = p2.length - 1; y2 >= 0 && p2[y2] === ""; y2--)
            ;
          return d2 > y2 ? [] : p2.slice(d2, y2 - d2 + 1);
        }
        for (var s2 = t2(e25.split("/")), a2 = t2(r2.split("/")), n2 = Math.min(s2.length, a2.length), u2 = n2, i2 = 0; i2 < n2; i2++)
          if (s2[i2] !== a2[i2]) {
            u2 = i2;
            break;
          }
        for (var l2 = [], i2 = u2; i2 < s2.length; i2++)
          l2.push("..");
        return l2 = l2.concat(a2.slice(u2)), l2.join("/");
      }
      function Ja2(e25) {
        var r2 = Ir2(e25), t2 = r2[0], s2 = r2[1];
        return !t2 && !s2 ? "." : (s2 && (s2 = s2.substr(0, s2.length - 1)), t2 + s2);
      }
      function za2(e25, r2) {
        var t2 = Ir2(e25)[2];
        return r2 && t2.substr(-1 * r2.length) === r2 && (t2 = t2.substr(0, t2.length - r2.length)), t2;
      }
      function Xa2(e25) {
        return Ir2(e25)[3];
      }
      function Zn2(e25, r2) {
        if (e25.filter)
          return e25.filter(r2);
        for (var t2 = [], s2 = 0; s2 < e25.length; s2++)
          r2(e25[s2], s2, e25) && t2.push(e25[s2]);
        return t2;
      }
      var Na2, Ir2, qn2, Mn2, Ka2, Ya2, QD2 = ht2({ "node-modules-polyfills:path"() {
        ne2(), Na2 = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/, Ir2 = function(e25) {
          return Na2.exec(e25).slice(1);
        }, qn2 = "/", Mn2 = ":", Ka2 = { extname: Xa2, basename: za2, dirname: Ja2, sep: qn2, delimiter: Mn2, relative: Ua2, join: Ga2, isAbsolute: Qn2, normalize: Yn2, resolve: wr2 }, Ya2 = "ab".substr(-1) === "b" ? function(e25, r2, t2) {
          return e25.substr(r2, t2);
        } : function(e25, r2, t2) {
          return r2 < 0 && (r2 = e25.length + r2), e25.substr(r2, t2);
        };
      } }), ZD2 = Z2({ "node-modules-polyfills-commonjs:path"(e25, r2) {
        ne2();
        var t2 = (QD2(), ft2(Wa2));
        if (t2 && t2.default) {
          r2.exports = t2.default;
          for (let s2 in t2)
            r2.exports[s2] = t2[s2];
        } else
          t2 && (r2.exports = t2);
      } }), Qt2 = Z2({ "src/common/errors.js"(e25, r2) {
        ne2();
        var t2 = class extends Error {
        }, s2 = class extends Error {
        }, a2 = class extends Error {
        }, n2 = class extends Error {
        };
        r2.exports = { ConfigError: t2, DebugError: s2, UndefinedParserError: a2, ArgExpansionBailout: n2 };
      } }), vt = {};
      Kt2(vt, { __assign: () => Nr2, __asyncDelegator: () => fm2, __asyncGenerator: () => pm2, __asyncValues: () => Dm2, __await: () => Xt2, __awaiter: () => sm2, __classPrivateFieldGet: () => ym2, __classPrivateFieldSet: () => hm2, __createBinding: () => am2, __decorate: () => rm2, __exportStar: () => om2, __extends: () => em2, __generator: () => im2, __importDefault: () => gm2, __importStar: () => dm2, __makeTemplateObject: () => mm2, __metadata: () => um2, __param: () => nm2, __read: () => Qa2, __rest: () => tm2, __spread: () => lm2, __spreadArrays: () => cm2, __values: () => Rn2 });
      function em2(e25, r2) {
        Br2(e25, r2);
        function t2() {
          this.constructor = e25;
        }
        e25.prototype = r2 === null ? Object.create(r2) : (t2.prototype = r2.prototype, new t2());
      }
      function tm2(e25, r2) {
        var t2 = {};
        for (var s2 in e25)
          Object.prototype.hasOwnProperty.call(e25, s2) && r2.indexOf(s2) < 0 && (t2[s2] = e25[s2]);
        if (e25 != null && typeof Object.getOwnPropertySymbols == "function")
          for (var a2 = 0, s2 = Object.getOwnPropertySymbols(e25); a2 < s2.length; a2++)
            r2.indexOf(s2[a2]) < 0 && Object.prototype.propertyIsEnumerable.call(e25, s2[a2]) && (t2[s2[a2]] = e25[s2[a2]]);
        return t2;
      }
      function rm2(e25, r2, t2, s2) {
        var a2 = arguments.length, n2 = a2 < 3 ? r2 : s2 === null ? s2 = Object.getOwnPropertyDescriptor(r2, t2) : s2, u2;
        if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
          n2 = Reflect.decorate(e25, r2, t2, s2);
        else
          for (var i2 = e25.length - 1; i2 >= 0; i2--)
            (u2 = e25[i2]) && (n2 = (a2 < 3 ? u2(n2) : a2 > 3 ? u2(r2, t2, n2) : u2(r2, t2)) || n2);
        return a2 > 3 && n2 && Object.defineProperty(r2, t2, n2), n2;
      }
      function nm2(e25, r2) {
        return function(t2, s2) {
          r2(t2, s2, e25);
        };
      }
      function um2(e25, r2) {
        if (typeof Reflect == "object" && typeof Reflect.metadata == "function")
          return Reflect.metadata(e25, r2);
      }
      function sm2(e25, r2, t2, s2) {
        function a2(n2) {
          return n2 instanceof t2 ? n2 : new t2(function(u2) {
            u2(n2);
          });
        }
        return new (t2 || (t2 = Promise))(function(n2, u2) {
          function i2(d2) {
            try {
              p2(s2.next(d2));
            } catch (y2) {
              u2(y2);
            }
          }
          function l2(d2) {
            try {
              p2(s2.throw(d2));
            } catch (y2) {
              u2(y2);
            }
          }
          function p2(d2) {
            d2.done ? n2(d2.value) : a2(d2.value).then(i2, l2);
          }
          p2((s2 = s2.apply(e25, r2 || [])).next());
        });
      }
      function im2(e25, r2) {
        var t2 = { label: 0, sent: function() {
          if (n2[0] & 1)
            throw n2[1];
          return n2[1];
        }, trys: [], ops: [] }, s2, a2, n2, u2;
        return u2 = { next: i2(0), throw: i2(1), return: i2(2) }, typeof Symbol == "function" && (u2[Symbol.iterator] = function() {
          return this;
        }), u2;
        function i2(p2) {
          return function(d2) {
            return l2([p2, d2]);
          };
        }
        function l2(p2) {
          if (s2)
            throw new TypeError("Generator is already executing.");
          for (; t2; )
            try {
              if (s2 = 1, a2 && (n2 = p2[0] & 2 ? a2.return : p2[0] ? a2.throw || ((n2 = a2.return) && n2.call(a2), 0) : a2.next) && !(n2 = n2.call(a2, p2[1])).done)
                return n2;
              switch (a2 = 0, n2 && (p2 = [p2[0] & 2, n2.value]), p2[0]) {
                case 0:
                case 1:
                  n2 = p2;
                  break;
                case 4:
                  return t2.label++, { value: p2[1], done: false };
                case 5:
                  t2.label++, a2 = p2[1], p2 = [0];
                  continue;
                case 7:
                  p2 = t2.ops.pop(), t2.trys.pop();
                  continue;
                default:
                  if (n2 = t2.trys, !(n2 = n2.length > 0 && n2[n2.length - 1]) && (p2[0] === 6 || p2[0] === 2)) {
                    t2 = 0;
                    continue;
                  }
                  if (p2[0] === 3 && (!n2 || p2[1] > n2[0] && p2[1] < n2[3])) {
                    t2.label = p2[1];
                    break;
                  }
                  if (p2[0] === 6 && t2.label < n2[1]) {
                    t2.label = n2[1], n2 = p2;
                    break;
                  }
                  if (n2 && t2.label < n2[2]) {
                    t2.label = n2[2], t2.ops.push(p2);
                    break;
                  }
                  n2[2] && t2.ops.pop(), t2.trys.pop();
                  continue;
              }
              p2 = r2.call(e25, t2);
            } catch (d2) {
              p2 = [6, d2], a2 = 0;
            } finally {
              s2 = n2 = 0;
            }
          if (p2[0] & 5)
            throw p2[1];
          return { value: p2[0] ? p2[1] : void 0, done: true };
        }
      }
      function am2(e25, r2, t2, s2) {
        s2 === void 0 && (s2 = t2), e25[s2] = r2[t2];
      }
      function om2(e25, r2) {
        for (var t2 in e25)
          t2 !== "default" && !r2.hasOwnProperty(t2) && (r2[t2] = e25[t2]);
      }
      function Rn2(e25) {
        var r2 = typeof Symbol == "function" && Symbol.iterator, t2 = r2 && e25[r2], s2 = 0;
        if (t2)
          return t2.call(e25);
        if (e25 && typeof e25.length == "number")
          return { next: function() {
            return e25 && s2 >= e25.length && (e25 = void 0), { value: e25 && e25[s2++], done: !e25 };
          } };
        throw new TypeError(r2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      }
      function Qa2(e25, r2) {
        var t2 = typeof Symbol == "function" && e25[Symbol.iterator];
        if (!t2)
          return e25;
        var s2 = t2.call(e25), a2, n2 = [], u2;
        try {
          for (; (r2 === void 0 || r2-- > 0) && !(a2 = s2.next()).done; )
            n2.push(a2.value);
        } catch (i2) {
          u2 = { error: i2 };
        } finally {
          try {
            a2 && !a2.done && (t2 = s2.return) && t2.call(s2);
          } finally {
            if (u2)
              throw u2.error;
          }
        }
        return n2;
      }
      function lm2() {
        for (var e25 = [], r2 = 0; r2 < arguments.length; r2++)
          e25 = e25.concat(Qa2(arguments[r2]));
        return e25;
      }
      function cm2() {
        for (var e25 = 0, r2 = 0, t2 = arguments.length; r2 < t2; r2++)
          e25 += arguments[r2].length;
        for (var s2 = Array(e25), a2 = 0, r2 = 0; r2 < t2; r2++)
          for (var n2 = arguments[r2], u2 = 0, i2 = n2.length; u2 < i2; u2++, a2++)
            s2[a2] = n2[u2];
        return s2;
      }
      function Xt2(e25) {
        return this instanceof Xt2 ? (this.v = e25, this) : new Xt2(e25);
      }
      function pm2(e25, r2, t2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var s2 = t2.apply(e25, r2 || []), a2, n2 = [];
        return a2 = {}, u2("next"), u2("throw"), u2("return"), a2[Symbol.asyncIterator] = function() {
          return this;
        }, a2;
        function u2(g2) {
          s2[g2] && (a2[g2] = function(c2) {
            return new Promise(function(D2, E2) {
              n2.push([g2, c2, D2, E2]) > 1 || i2(g2, c2);
            });
          });
        }
        function i2(g2, c2) {
          try {
            l2(s2[g2](c2));
          } catch (D2) {
            y2(n2[0][3], D2);
          }
        }
        function l2(g2) {
          g2.value instanceof Xt2 ? Promise.resolve(g2.value.v).then(p2, d2) : y2(n2[0][2], g2);
        }
        function p2(g2) {
          i2("next", g2);
        }
        function d2(g2) {
          i2("throw", g2);
        }
        function y2(g2, c2) {
          g2(c2), n2.shift(), n2.length && i2(n2[0][0], n2[0][1]);
        }
      }
      function fm2(e25) {
        var r2, t2;
        return r2 = {}, s2("next"), s2("throw", function(a2) {
          throw a2;
        }), s2("return"), r2[Symbol.iterator] = function() {
          return this;
        }, r2;
        function s2(a2, n2) {
          r2[a2] = e25[a2] ? function(u2) {
            return (t2 = !t2) ? { value: Xt2(e25[a2](u2)), done: a2 === "return" } : n2 ? n2(u2) : u2;
          } : n2;
        }
      }
      function Dm2(e25) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var r2 = e25[Symbol.asyncIterator], t2;
        return r2 ? r2.call(e25) : (e25 = typeof Rn2 == "function" ? Rn2(e25) : e25[Symbol.iterator](), t2 = {}, s2("next"), s2("throw"), s2("return"), t2[Symbol.asyncIterator] = function() {
          return this;
        }, t2);
        function s2(n2) {
          t2[n2] = e25[n2] && function(u2) {
            return new Promise(function(i2, l2) {
              u2 = e25[n2](u2), a2(i2, l2, u2.done, u2.value);
            });
          };
        }
        function a2(n2, u2, i2, l2) {
          Promise.resolve(l2).then(function(p2) {
            n2({ value: p2, done: i2 });
          }, u2);
        }
      }
      function mm2(e25, r2) {
        return Object.defineProperty ? Object.defineProperty(e25, "raw", { value: r2 }) : e25.raw = r2, e25;
      }
      function dm2(e25) {
        if (e25 && e25.__esModule)
          return e25;
        var r2 = {};
        if (e25 != null)
          for (var t2 in e25)
            Object.hasOwnProperty.call(e25, t2) && (r2[t2] = e25[t2]);
        return r2.default = e25, r2;
      }
      function gm2(e25) {
        return e25 && e25.__esModule ? e25 : { default: e25 };
      }
      function ym2(e25, r2) {
        if (!r2.has(e25))
          throw new TypeError("attempted to get private field on non-instance");
        return r2.get(e25);
      }
      function hm2(e25, r2, t2) {
        if (!r2.has(e25))
          throw new TypeError("attempted to set private field on non-instance");
        return r2.set(e25, t2), t2;
      }
      var Br2, Nr2, Et = ht2({ "node_modules/tslib/tslib.es6.js"() {
        ne2(), Br2 = function(e25, r2) {
          return Br2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t2, s2) {
            t2.__proto__ = s2;
          } || function(t2, s2) {
            for (var a2 in s2)
              s2.hasOwnProperty(a2) && (t2[a2] = s2[a2]);
          }, Br2(e25, r2);
        }, Nr2 = function() {
          return Nr2 = Object.assign || function(r2) {
            for (var t2, s2 = 1, a2 = arguments.length; s2 < a2; s2++) {
              t2 = arguments[s2];
              for (var n2 in t2)
                Object.prototype.hasOwnProperty.call(t2, n2) && (r2[n2] = t2[n2]);
            }
            return r2;
          }, Nr2.apply(this, arguments);
        };
      } }), Za2 = Z2({ "node_modules/vnopts/lib/descriptors/api.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true }), e25.apiDescriptor = { key: (r2) => /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(r2) ? r2 : JSON.stringify(r2), value(r2) {
          if (r2 === null || typeof r2 != "object")
            return JSON.stringify(r2);
          if (Array.isArray(r2))
            return `[${r2.map((s2) => e25.apiDescriptor.value(s2)).join(", ")}]`;
          let t2 = Object.keys(r2);
          return t2.length === 0 ? "{}" : `{ ${t2.map((s2) => `${e25.apiDescriptor.key(s2)}: ${e25.apiDescriptor.value(r2[s2])}`).join(", ")} }`;
        }, pair: (r2) => {
          let { key: t2, value: s2 } = r2;
          return e25.apiDescriptor.value({ [t2]: s2 });
        } };
      } }), vm2 = Z2({ "node_modules/vnopts/lib/descriptors/index.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = (Et(), ft2(vt));
        r2.__exportStar(Za2(), e25);
      } }), kr = Z2({ "scripts/build/shims/chalk.cjs"(e25, r2) {
        ne2();
        var t2 = (s2) => s2;
        t2.grey = t2, t2.red = t2, t2.bold = t2, t2.yellow = t2, t2.blue = t2, t2.default = t2, r2.exports = t2;
      } }), eo2 = Z2({ "node_modules/vnopts/lib/handlers/deprecated/common.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = kr();
        e25.commonDeprecatedHandler = (t2, s2, a2) => {
          let { descriptor: n2 } = a2, u2 = [`${r2.default.yellow(typeof t2 == "string" ? n2.key(t2) : n2.pair(t2))} is deprecated`];
          return s2 && u2.push(`we now treat it as ${r2.default.blue(typeof s2 == "string" ? n2.key(s2) : n2.pair(s2))}`), u2.join("; ") + ".";
        };
      } }), Cm2 = Z2({ "node_modules/vnopts/lib/handlers/deprecated/index.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = (Et(), ft2(vt));
        r2.__exportStar(eo2(), e25);
      } }), Em2 = Z2({ "node_modules/vnopts/lib/handlers/invalid/common.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = kr();
        e25.commonInvalidHandler = (t2, s2, a2) => [`Invalid ${r2.default.red(a2.descriptor.key(t2))} value.`, `Expected ${r2.default.blue(a2.schemas[t2].expected(a2))},`, `but received ${r2.default.red(a2.descriptor.value(s2))}.`].join(" ");
      } }), to2 = Z2({ "node_modules/vnopts/lib/handlers/invalid/index.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = (Et(), ft2(vt));
        r2.__exportStar(Em2(), e25);
      } }), Fm2 = Z2({ "node_modules/vnopts/node_modules/leven/index.js"(e25, r2) {
        ne2();
        var t2 = [], s2 = [];
        r2.exports = function(a2, n2) {
          if (a2 === n2)
            return 0;
          var u2 = a2;
          a2.length > n2.length && (a2 = n2, n2 = u2);
          var i2 = a2.length, l2 = n2.length;
          if (i2 === 0)
            return l2;
          if (l2 === 0)
            return i2;
          for (; i2 > 0 && a2.charCodeAt(~-i2) === n2.charCodeAt(~-l2); )
            i2--, l2--;
          if (i2 === 0)
            return l2;
          for (var p2 = 0; p2 < i2 && a2.charCodeAt(p2) === n2.charCodeAt(p2); )
            p2++;
          if (i2 -= p2, l2 -= p2, i2 === 0)
            return l2;
          for (var d2, y2, g2, c2, D2 = 0, E2 = 0; D2 < i2; )
            s2[p2 + D2] = a2.charCodeAt(p2 + D2), t2[D2] = ++D2;
          for (; E2 < l2; )
            for (d2 = n2.charCodeAt(p2 + E2), g2 = E2++, y2 = E2, D2 = 0; D2 < i2; D2++)
              c2 = d2 === s2[p2 + D2] ? g2 : g2 + 1, g2 = t2[D2], y2 = t2[D2] = g2 > y2 ? c2 > y2 ? y2 + 1 : c2 : c2 > g2 ? g2 + 1 : c2;
          return y2;
        };
      } }), ro2 = Z2({ "node_modules/vnopts/lib/handlers/unknown/leven.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = kr(), t2 = Fm2();
        e25.levenUnknownHandler = (s2, a2, n2) => {
          let { descriptor: u2, logger: i2, schemas: l2 } = n2, p2 = [`Ignored unknown option ${r2.default.yellow(u2.pair({ key: s2, value: a2 }))}.`], d2 = Object.keys(l2).sort().find((y2) => t2(s2, y2) < 3);
          d2 && p2.push(`Did you mean ${r2.default.blue(u2.key(d2))}?`), i2.warn(p2.join(" "));
        };
      } }), Am2 = Z2({ "node_modules/vnopts/lib/handlers/unknown/index.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = (Et(), ft2(vt));
        r2.__exportStar(ro2(), e25);
      } }), Sm2 = Z2({ "node_modules/vnopts/lib/handlers/index.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = (Et(), ft2(vt));
        r2.__exportStar(Cm2(), e25), r2.__exportStar(to2(), e25), r2.__exportStar(Am2(), e25);
      } }), Ft2 = Z2({ "node_modules/vnopts/lib/schema.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = ["default", "expected", "validate", "deprecated", "forward", "redirect", "overlap", "preprocess", "postprocess"];
        function t2(n2, u2) {
          let i2 = new n2(u2), l2 = Object.create(i2);
          for (let p2 of r2)
            p2 in u2 && (l2[p2] = a2(u2[p2], i2, s2.prototype[p2].length));
          return l2;
        }
        e25.createSchema = t2;
        var s2 = class {
          constructor(n2) {
            this.name = n2.name;
          }
          static create(n2) {
            return t2(this, n2);
          }
          default(n2) {
          }
          expected(n2) {
            return "nothing";
          }
          validate(n2, u2) {
            return false;
          }
          deprecated(n2, u2) {
            return false;
          }
          forward(n2, u2) {
          }
          redirect(n2, u2) {
          }
          overlap(n2, u2, i2) {
            return n2;
          }
          preprocess(n2, u2) {
            return n2;
          }
          postprocess(n2, u2) {
            return n2;
          }
        };
        e25.Schema = s2;
        function a2(n2, u2, i2) {
          return typeof n2 == "function" ? function() {
            for (var l2 = arguments.length, p2 = new Array(l2), d2 = 0; d2 < l2; d2++)
              p2[d2] = arguments[d2];
            return n2(...p2.slice(0, i2 - 1), u2, ...p2.slice(i2 - 1));
          } : () => n2;
        }
      } }), xm2 = Z2({ "node_modules/vnopts/lib/schemas/alias.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Ft2(), t2 = class extends r2.Schema {
          constructor(s2) {
            super(s2), this._sourceName = s2.sourceName;
          }
          expected(s2) {
            return s2.schemas[this._sourceName].expected(s2);
          }
          validate(s2, a2) {
            return a2.schemas[this._sourceName].validate(s2, a2);
          }
          redirect(s2, a2) {
            return this._sourceName;
          }
        };
        e25.AliasSchema = t2;
      } }), bm2 = Z2({ "node_modules/vnopts/lib/schemas/any.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Ft2(), t2 = class extends r2.Schema {
          expected() {
            return "anything";
          }
          validate() {
            return true;
          }
        };
        e25.AnySchema = t2;
      } }), Tm2 = Z2({ "node_modules/vnopts/lib/schemas/array.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = (Et(), ft2(vt)), t2 = Ft2(), s2 = class extends t2.Schema {
          constructor(n2) {
            var { valueSchema: u2, name: i2 = u2.name } = n2, l2 = r2.__rest(n2, ["valueSchema", "name"]);
            super(Object.assign({}, l2, { name: i2 })), this._valueSchema = u2;
          }
          expected(n2) {
            return `an array of ${this._valueSchema.expected(n2)}`;
          }
          validate(n2, u2) {
            if (!Array.isArray(n2))
              return false;
            let i2 = [];
            for (let l2 of n2) {
              let p2 = u2.normalizeValidateResult(this._valueSchema.validate(l2, u2), l2);
              p2 !== true && i2.push(p2.value);
            }
            return i2.length === 0 ? true : { value: i2 };
          }
          deprecated(n2, u2) {
            let i2 = [];
            for (let l2 of n2) {
              let p2 = u2.normalizeDeprecatedResult(this._valueSchema.deprecated(l2, u2), l2);
              p2 !== false && i2.push(...p2.map((d2) => {
                let { value: y2 } = d2;
                return { value: [y2] };
              }));
            }
            return i2;
          }
          forward(n2, u2) {
            let i2 = [];
            for (let l2 of n2) {
              let p2 = u2.normalizeForwardResult(this._valueSchema.forward(l2, u2), l2);
              i2.push(...p2.map(a2));
            }
            return i2;
          }
          redirect(n2, u2) {
            let i2 = [], l2 = [];
            for (let p2 of n2) {
              let d2 = u2.normalizeRedirectResult(this._valueSchema.redirect(p2, u2), p2);
              "remain" in d2 && i2.push(d2.remain), l2.push(...d2.redirect.map(a2));
            }
            return i2.length === 0 ? { redirect: l2 } : { redirect: l2, remain: i2 };
          }
          overlap(n2, u2) {
            return n2.concat(u2);
          }
        };
        e25.ArraySchema = s2;
        function a2(n2) {
          let { from: u2, to: i2 } = n2;
          return { from: [u2], to: i2 };
        }
      } }), Bm2 = Z2({ "node_modules/vnopts/lib/schemas/boolean.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Ft2(), t2 = class extends r2.Schema {
          expected() {
            return "true or false";
          }
          validate(s2) {
            return typeof s2 == "boolean";
          }
        };
        e25.BooleanSchema = t2;
      } }), eu2 = Z2({ "node_modules/vnopts/lib/utils.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        function r2(c2, D2) {
          let E2 = Object.create(null);
          for (let _2 of c2) {
            let w2 = _2[D2];
            if (E2[w2])
              throw new Error(`Duplicate ${D2} ${JSON.stringify(w2)}`);
            E2[w2] = _2;
          }
          return E2;
        }
        e25.recordFromArray = r2;
        function t2(c2, D2) {
          let E2 = new Map();
          for (let _2 of c2) {
            let w2 = _2[D2];
            if (E2.has(w2))
              throw new Error(`Duplicate ${D2} ${JSON.stringify(w2)}`);
            E2.set(w2, _2);
          }
          return E2;
        }
        e25.mapFromArray = t2;
        function s2() {
          let c2 = Object.create(null);
          return (D2) => {
            let E2 = JSON.stringify(D2);
            return c2[E2] ? true : (c2[E2] = true, false);
          };
        }
        e25.createAutoChecklist = s2;
        function a2(c2, D2) {
          let E2 = [], _2 = [];
          for (let w2 of c2)
            D2(w2) ? E2.push(w2) : _2.push(w2);
          return [E2, _2];
        }
        e25.partition = a2;
        function n2(c2) {
          return c2 === Math.floor(c2);
        }
        e25.isInt = n2;
        function u2(c2, D2) {
          if (c2 === D2)
            return 0;
          let E2 = typeof c2, _2 = typeof D2, w2 = ["undefined", "object", "boolean", "number", "string"];
          return E2 !== _2 ? w2.indexOf(E2) - w2.indexOf(_2) : E2 !== "string" ? Number(c2) - Number(D2) : c2.localeCompare(D2);
        }
        e25.comparePrimitive = u2;
        function i2(c2) {
          return c2 === void 0 ? {} : c2;
        }
        e25.normalizeDefaultResult = i2;
        function l2(c2, D2) {
          return c2 === true ? true : c2 === false ? { value: D2 } : c2;
        }
        e25.normalizeValidateResult = l2;
        function p2(c2, D2) {
          let E2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
          return c2 === false ? false : c2 === true ? E2 ? true : [{ value: D2 }] : "value" in c2 ? [c2] : c2.length === 0 ? false : c2;
        }
        e25.normalizeDeprecatedResult = p2;
        function d2(c2, D2) {
          return typeof c2 == "string" || "key" in c2 ? { from: D2, to: c2 } : "from" in c2 ? { from: c2.from, to: c2.to } : { from: D2, to: c2.to };
        }
        e25.normalizeTransferResult = d2;
        function y2(c2, D2) {
          return c2 === void 0 ? [] : Array.isArray(c2) ? c2.map((E2) => d2(E2, D2)) : [d2(c2, D2)];
        }
        e25.normalizeForwardResult = y2;
        function g2(c2, D2) {
          let E2 = y2(typeof c2 == "object" && "redirect" in c2 ? c2.redirect : c2, D2);
          return E2.length === 0 ? { remain: D2, redirect: E2 } : typeof c2 == "object" && "remain" in c2 ? { remain: c2.remain, redirect: E2 } : { redirect: E2 };
        }
        e25.normalizeRedirectResult = g2;
      } }), Nm2 = Z2({ "node_modules/vnopts/lib/schemas/choice.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Ft2(), t2 = eu2(), s2 = class extends r2.Schema {
          constructor(a2) {
            super(a2), this._choices = t2.mapFromArray(a2.choices.map((n2) => n2 && typeof n2 == "object" ? n2 : { value: n2 }), "value");
          }
          expected(a2) {
            let { descriptor: n2 } = a2, u2 = Array.from(this._choices.keys()).map((p2) => this._choices.get(p2)).filter((p2) => !p2.deprecated).map((p2) => p2.value).sort(t2.comparePrimitive).map(n2.value), i2 = u2.slice(0, -2), l2 = u2.slice(-2);
            return i2.concat(l2.join(" or ")).join(", ");
          }
          validate(a2) {
            return this._choices.has(a2);
          }
          deprecated(a2) {
            let n2 = this._choices.get(a2);
            return n2 && n2.deprecated ? { value: a2 } : false;
          }
          forward(a2) {
            let n2 = this._choices.get(a2);
            return n2 ? n2.forward : void 0;
          }
          redirect(a2) {
            let n2 = this._choices.get(a2);
            return n2 ? n2.redirect : void 0;
          }
        };
        e25.ChoiceSchema = s2;
      } }), no2 = Z2({ "node_modules/vnopts/lib/schemas/number.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Ft2(), t2 = class extends r2.Schema {
          expected() {
            return "a number";
          }
          validate(s2, a2) {
            return typeof s2 == "number";
          }
        };
        e25.NumberSchema = t2;
      } }), wm2 = Z2({ "node_modules/vnopts/lib/schemas/integer.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = eu2(), t2 = no2(), s2 = class extends t2.NumberSchema {
          expected() {
            return "an integer";
          }
          validate(a2, n2) {
            return n2.normalizeValidateResult(super.validate(a2, n2), a2) === true && r2.isInt(a2);
          }
        };
        e25.IntegerSchema = s2;
      } }), _m2 = Z2({ "node_modules/vnopts/lib/schemas/string.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Ft2(), t2 = class extends r2.Schema {
          expected() {
            return "a string";
          }
          validate(s2) {
            return typeof s2 == "string";
          }
        };
        e25.StringSchema = t2;
      } }), Pm2 = Z2({ "node_modules/vnopts/lib/schemas/index.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = (Et(), ft2(vt));
        r2.__exportStar(xm2(), e25), r2.__exportStar(bm2(), e25), r2.__exportStar(Tm2(), e25), r2.__exportStar(Bm2(), e25), r2.__exportStar(Nm2(), e25), r2.__exportStar(wm2(), e25), r2.__exportStar(no2(), e25), r2.__exportStar(_m2(), e25);
      } }), Im2 = Z2({ "node_modules/vnopts/lib/defaults.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Za2(), t2 = eo2(), s2 = to2(), a2 = ro2();
        e25.defaultDescriptor = r2.apiDescriptor, e25.defaultUnknownHandler = a2.levenUnknownHandler, e25.defaultInvalidHandler = s2.commonInvalidHandler, e25.defaultDeprecatedHandler = t2.commonDeprecatedHandler;
      } }), km2 = Z2({ "node_modules/vnopts/lib/normalize.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = Im2(), t2 = eu2();
        e25.normalize = (a2, n2, u2) => new s2(n2, u2).normalize(a2);
        var s2 = class {
          constructor(a2, n2) {
            let { logger: u2 = console, descriptor: i2 = r2.defaultDescriptor, unknown: l2 = r2.defaultUnknownHandler, invalid: p2 = r2.defaultInvalidHandler, deprecated: d2 = r2.defaultDeprecatedHandler } = n2 || {};
            this._utils = { descriptor: i2, logger: u2 || { warn: () => {
            } }, schemas: t2.recordFromArray(a2, "name"), normalizeDefaultResult: t2.normalizeDefaultResult, normalizeDeprecatedResult: t2.normalizeDeprecatedResult, normalizeForwardResult: t2.normalizeForwardResult, normalizeRedirectResult: t2.normalizeRedirectResult, normalizeValidateResult: t2.normalizeValidateResult }, this._unknownHandler = l2, this._invalidHandler = p2, this._deprecatedHandler = d2, this.cleanHistory();
          }
          cleanHistory() {
            this._hasDeprecationWarned = t2.createAutoChecklist();
          }
          normalize(a2) {
            let n2 = {}, u2 = [a2], i2 = () => {
              for (; u2.length !== 0; ) {
                let l2 = u2.shift(), p2 = this._applyNormalization(l2, n2);
                u2.push(...p2);
              }
            };
            i2();
            for (let l2 of Object.keys(this._utils.schemas)) {
              let p2 = this._utils.schemas[l2];
              if (!(l2 in n2)) {
                let d2 = t2.normalizeDefaultResult(p2.default(this._utils));
                "value" in d2 && u2.push({ [l2]: d2.value });
              }
            }
            i2();
            for (let l2 of Object.keys(this._utils.schemas)) {
              let p2 = this._utils.schemas[l2];
              l2 in n2 && (n2[l2] = p2.postprocess(n2[l2], this._utils));
            }
            return n2;
          }
          _applyNormalization(a2, n2) {
            let u2 = [], [i2, l2] = t2.partition(Object.keys(a2), (p2) => p2 in this._utils.schemas);
            for (let p2 of i2) {
              let d2 = this._utils.schemas[p2], y2 = d2.preprocess(a2[p2], this._utils), g2 = t2.normalizeValidateResult(d2.validate(y2, this._utils), y2);
              if (g2 !== true) {
                let { value: w2 } = g2, F2 = this._invalidHandler(p2, w2, this._utils);
                throw typeof F2 == "string" ? new Error(F2) : F2;
              }
              let c2 = (w2) => {
                let { from: F2, to: A2 } = w2;
                u2.push(typeof A2 == "string" ? { [A2]: F2 } : { [A2.key]: A2.value });
              }, D2 = (w2) => {
                let { value: F2, redirectTo: A2 } = w2, N2 = t2.normalizeDeprecatedResult(d2.deprecated(F2, this._utils), y2, true);
                if (N2 !== false)
                  if (N2 === true)
                    this._hasDeprecationWarned(p2) || this._utils.logger.warn(this._deprecatedHandler(p2, A2, this._utils));
                  else
                    for (let { value: I2 } of N2) {
                      let P2 = { key: p2, value: I2 };
                      if (!this._hasDeprecationWarned(P2)) {
                        let H2 = typeof A2 == "string" ? { key: A2, value: I2 } : A2;
                        this._utils.logger.warn(this._deprecatedHandler(P2, H2, this._utils));
                      }
                    }
              };
              t2.normalizeForwardResult(d2.forward(y2, this._utils), y2).forEach(c2);
              let _2 = t2.normalizeRedirectResult(d2.redirect(y2, this._utils), y2);
              if (_2.redirect.forEach(c2), "remain" in _2) {
                let w2 = _2.remain;
                n2[p2] = p2 in n2 ? d2.overlap(n2[p2], w2, this._utils) : w2, D2({ value: w2 });
              }
              for (let { from: w2, to: F2 } of _2.redirect)
                D2({ value: w2, redirectTo: F2 });
            }
            for (let p2 of l2) {
              let d2 = a2[p2], y2 = this._unknownHandler(p2, d2, this._utils);
              if (y2)
                for (let g2 of Object.keys(y2)) {
                  let c2 = { [g2]: y2[g2] };
                  g2 in this._utils.schemas ? u2.push(c2) : Object.assign(n2, c2);
                }
            }
            return u2;
          }
        };
        e25.Normalizer = s2;
      } }), Lm2 = Z2({ "node_modules/vnopts/lib/index.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = (Et(), ft2(vt));
        r2.__exportStar(vm2(), e25), r2.__exportStar(Sm2(), e25), r2.__exportStar(Pm2(), e25), r2.__exportStar(km2(), e25), r2.__exportStar(Ft2(), e25);
      } }), Om2 = Z2({ "src/main/options-normalizer.js"(e25, r2) {
        ne2();
        var t2 = Lm2(), s2 = lt2(), a2 = { key: (g2) => g2.length === 1 ? `-${g2}` : `--${g2}`, value: (g2) => t2.apiDescriptor.value(g2), pair: (g2) => {
          let { key: c2, value: D2 } = g2;
          return D2 === false ? `--no-${c2}` : D2 === true ? a2.key(c2) : D2 === "" ? `${a2.key(c2)} without an argument` : `${a2.key(c2)}=${D2}`;
        } }, n2 = (g2) => {
          let { colorsModule: c2, levenshteinDistance: D2 } = g2;
          return class extends t2.ChoiceSchema {
            constructor(_2) {
              let { name: w2, flags: F2 } = _2;
              super({ name: w2, choices: F2 }), this._flags = [...F2].sort();
            }
            preprocess(_2, w2) {
              if (typeof _2 == "string" && _2.length > 0 && !this._flags.includes(_2)) {
                let F2 = this._flags.find((A2) => D2(A2, _2) < 3);
                if (F2)
                  return w2.logger.warn([`Unknown flag ${c2.yellow(w2.descriptor.value(_2))},`, `did you mean ${c2.blue(w2.descriptor.value(F2))}?`].join(" ")), F2;
              }
              return _2;
            }
            expected() {
              return "a flag";
            }
          };
        }, u2;
        function i2(g2, c2) {
          let { logger: D2 = false, isCLI: E2 = false, passThrough: _2 = false, colorsModule: w2 = null, levenshteinDistance: F2 = null } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, A2 = _2 ? Array.isArray(_2) ? (b2, m2) => _2.includes(b2) ? { [b2]: m2 } : void 0 : (b2, m2) => ({ [b2]: m2 }) : (b2, m2, v2) => {
            let o2 = v2.schemas, C2 = Hn2(o2, vD2);
            return t2.levenUnknownHandler(b2, m2, Object.assign(Object.assign({}, v2), {}, { schemas: C2 }));
          }, N2 = E2 ? a2 : t2.apiDescriptor, I2 = l2(c2, { isCLI: E2, colorsModule: w2, levenshteinDistance: F2 }), P2 = new t2.Normalizer(I2, { logger: D2, unknown: A2, descriptor: N2 }), H2 = D2 !== false;
          H2 && u2 && (P2._hasDeprecationWarned = u2);
          let f2 = P2.normalize(g2);
          return H2 && (u2 = P2._hasDeprecationWarned), E2 && f2["plugin-search"] === false && (f2["plugin-search-dir"] = false), f2;
        }
        function l2(g2, c2) {
          let { isCLI: D2, colorsModule: E2, levenshteinDistance: _2 } = c2, w2 = [];
          D2 && w2.push(t2.AnySchema.create({ name: "_" }));
          for (let F2 of g2)
            w2.push(p2(F2, { isCLI: D2, optionInfos: g2, colorsModule: E2, levenshteinDistance: _2 })), F2.alias && D2 && w2.push(t2.AliasSchema.create({ name: F2.alias, sourceName: F2.name }));
          return w2;
        }
        function p2(g2, c2) {
          let { isCLI: D2, optionInfos: E2, colorsModule: _2, levenshteinDistance: w2 } = c2, { name: F2 } = g2;
          if (F2 === "plugin-search-dir" || F2 === "pluginSearchDirs")
            return t2.AnySchema.create({ name: F2, preprocess(P2) {
              return P2 === false || (P2 = Array.isArray(P2) ? P2 : [P2]), P2;
            }, validate(P2) {
              return P2 === false ? true : P2.every((H2) => typeof H2 == "string");
            }, expected() {
              return "false or paths to plugin search dir";
            } });
          let A2 = { name: F2 }, N2, I2 = {};
          switch (g2.type) {
            case "int":
              N2 = t2.IntegerSchema, D2 && (A2.preprocess = Number);
              break;
            case "string":
              N2 = t2.StringSchema;
              break;
            case "choice":
              N2 = t2.ChoiceSchema, A2.choices = g2.choices.map((P2) => typeof P2 == "object" && P2.redirect ? Object.assign(Object.assign({}, P2), {}, { redirect: { to: { key: g2.name, value: P2.redirect } } }) : P2);
              break;
            case "boolean":
              N2 = t2.BooleanSchema;
              break;
            case "flag":
              N2 = n2({ colorsModule: _2, levenshteinDistance: w2 }), A2.flags = E2.flatMap((P2) => [P2.alias, P2.description && P2.name, P2.oppositeDescription && `no-${P2.name}`].filter(Boolean));
              break;
            case "path":
              N2 = t2.StringSchema;
              break;
            default:
              throw new Error(`Unexpected type ${g2.type}`);
          }
          if (g2.exception ? A2.validate = (P2, H2, f2) => g2.exception(P2) || H2.validate(P2, f2) : A2.validate = (P2, H2, f2) => P2 === void 0 || H2.validate(P2, f2), g2.redirect && (I2.redirect = (P2) => P2 ? { to: { key: g2.redirect.option, value: g2.redirect.value } } : void 0), g2.deprecated && (I2.deprecated = true), D2 && !g2.array) {
            let P2 = A2.preprocess || ((H2) => H2);
            A2.preprocess = (H2, f2, b2) => f2.preprocess(P2(Array.isArray(H2) ? s2(H2) : H2), b2);
          }
          return g2.array ? t2.ArraySchema.create(Object.assign(Object.assign(Object.assign({}, D2 ? { preprocess: (P2) => Array.isArray(P2) ? P2 : [P2] } : {}), I2), {}, { valueSchema: N2.create(A2) })) : N2.create(Object.assign(Object.assign({}, A2), I2));
        }
        function d2(g2, c2, D2) {
          return i2(g2, c2, D2);
        }
        function y2(g2, c2, D2) {
          return i2(g2, c2, Object.assign({ isCLI: true }, D2));
        }
        r2.exports = { normalizeApiOptions: d2, normalizeCliOptions: y2 };
      } }), ut2 = Z2({ "src/language-js/loc.js"(e25, r2) {
        ne2();
        var t2 = Kn2();
        function s2(l2) {
          var p2, d2;
          let y2 = l2.range ? l2.range[0] : l2.start, g2 = (p2 = (d2 = l2.declaration) === null || d2 === void 0 ? void 0 : d2.decorators) !== null && p2 !== void 0 ? p2 : l2.decorators;
          return t2(g2) ? Math.min(s2(g2[0]), y2) : y2;
        }
        function a2(l2) {
          return l2.range ? l2.range[1] : l2.end;
        }
        function n2(l2, p2) {
          let d2 = s2(l2);
          return Number.isInteger(d2) && d2 === s2(p2);
        }
        function u2(l2, p2) {
          let d2 = a2(l2);
          return Number.isInteger(d2) && d2 === a2(p2);
        }
        function i2(l2, p2) {
          return n2(l2, p2) && u2(l2, p2);
        }
        r2.exports = { locStart: s2, locEnd: a2, hasSameLocStart: n2, hasSameLoc: i2 };
      } }), jm2 = Z2({ "src/main/load-parser.js"(e25, r2) {
        ne2(), r2.exports = () => {
        };
      } }), qm2 = Z2({ "scripts/build/shims/babel-highlight.cjs"(e25, r2) {
        ne2();
        var t2 = kr(), s2 = { shouldHighlight: () => false, getChalk: () => t2 };
        r2.exports = s2;
      } }), Mm2 = Z2({ "node_modules/@babel/code-frame/lib/index.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true }), e25.codeFrameColumns = u2, e25.default = i2;
        var r2 = qm2(), t2 = false;
        function s2(l2) {
          return { gutter: l2.grey, marker: l2.red.bold, message: l2.red.bold };
        }
        var a2 = /\r\n|[\n\r\u2028\u2029]/;
        function n2(l2, p2, d2) {
          let y2 = Object.assign({ column: 0, line: -1 }, l2.start), g2 = Object.assign({}, y2, l2.end), { linesAbove: c2 = 2, linesBelow: D2 = 3 } = d2 || {}, E2 = y2.line, _2 = y2.column, w2 = g2.line, F2 = g2.column, A2 = Math.max(E2 - (c2 + 1), 0), N2 = Math.min(p2.length, w2 + D2);
          E2 === -1 && (A2 = 0), w2 === -1 && (N2 = p2.length);
          let I2 = w2 - E2, P2 = {};
          if (I2)
            for (let H2 = 0; H2 <= I2; H2++) {
              let f2 = H2 + E2;
              if (!_2)
                P2[f2] = true;
              else if (H2 === 0) {
                let b2 = p2[f2 - 1].length;
                P2[f2] = [_2, b2 - _2 + 1];
              } else if (H2 === I2)
                P2[f2] = [0, F2];
              else {
                let b2 = p2[f2 - H2].length;
                P2[f2] = [0, b2];
              }
            }
          else
            _2 === F2 ? _2 ? P2[E2] = [_2, 0] : P2[E2] = true : P2[E2] = [_2, F2 - _2];
          return { start: A2, end: N2, markerLines: P2 };
        }
        function u2(l2, p2) {
          let d2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, y2 = (d2.highlightCode || d2.forceColor) && (0, r2.shouldHighlight)(d2), g2 = (0, r2.getChalk)(d2), c2 = s2(g2), D2 = (H2, f2) => y2 ? H2(f2) : f2, E2 = l2.split(a2), { start: _2, end: w2, markerLines: F2 } = n2(p2, E2, d2), A2 = p2.start && typeof p2.start.column == "number", N2 = String(w2).length, P2 = (y2 ? (0, r2.default)(l2, d2) : l2).split(a2, w2).slice(_2, w2).map((H2, f2) => {
            let b2 = _2 + 1 + f2, v2 = ` ${` ${b2}`.slice(-N2)} |`, o2 = F2[b2], h2 = !F2[b2 + 1];
            if (o2) {
              let C2 = "";
              if (Array.isArray(o2)) {
                let S2 = H2.slice(0, Math.max(o2[0] - 1, 0)).replace(/[^\t]/g, " "), x2 = o2[1] || 1;
                C2 = [`
 `, D2(c2.gutter, v2.replace(/\d/g, " ")), " ", S2, D2(c2.marker, "^").repeat(x2)].join(""), h2 && d2.message && (C2 += " " + D2(c2.message, d2.message));
              }
              return [D2(c2.marker, ">"), D2(c2.gutter, v2), H2.length > 0 ? ` ${H2}` : "", C2].join("");
            } else
              return ` ${D2(c2.gutter, v2)}${H2.length > 0 ? ` ${H2}` : ""}`;
          }).join(`
`);
          return d2.message && !A2 && (P2 = `${" ".repeat(N2 + 1)}${d2.message}
${P2}`), y2 ? g2.reset(P2) : P2;
        }
        function i2(l2, p2, d2) {
          let y2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
          if (!t2) {
            t2 = true;
            let c2 = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
            if (wt2.emitWarning)
              wt2.emitWarning(c2, "DeprecationWarning");
            else {
              let D2 = new Error(c2);
              D2.name = "DeprecationWarning", console.warn(new Error(c2));
            }
          }
          return d2 = Math.max(d2, 0), u2(l2, { start: { column: d2, line: p2 } }, y2);
        }
      } }), tu2 = Z2({ "src/main/parser.js"(e25, r2) {
        ne2();
        var { ConfigError: t2 } = Qt2(), s2 = ut2();
        jm2();
        var { locStart: n2, locEnd: u2 } = s2, i2 = Object.getOwnPropertyNames, l2 = Object.getOwnPropertyDescriptor;
        function p2(g2) {
          let c2 = {};
          for (let D2 of g2.plugins)
            if (D2.parsers)
              for (let E2 of i2(D2.parsers))
                Object.defineProperty(c2, E2, l2(D2.parsers, E2));
          return c2;
        }
        function d2(g2) {
          let c2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : p2(g2);
          if (typeof g2.parser == "function")
            return { parse: g2.parser, astFormat: "estree", locStart: n2, locEnd: u2 };
          if (typeof g2.parser == "string") {
            if (Object.prototype.hasOwnProperty.call(c2, g2.parser))
              return c2[g2.parser];
            throw new t2(`Couldn't resolve parser "${g2.parser}". Parsers must be explicitly added to the standalone bundle.`);
          }
        }
        function y2(g2, c2) {
          let D2 = p2(c2), E2 = Object.defineProperties({}, Object.fromEntries(Object.keys(D2).map((w2) => [w2, { enumerable: true, get() {
            return D2[w2].parse;
          } }]))), _2 = d2(c2, D2);
          try {
            return _2.preprocess && (g2 = _2.preprocess(g2, c2)), { text: g2, ast: _2.parse(g2, E2, c2) };
          } catch (w2) {
            let { loc: F2 } = w2;
            if (F2) {
              let { codeFrameColumns: A2 } = Mm2();
              throw w2.codeFrame = A2(g2, F2, { highlightCode: true }), w2.message += `
` + w2.codeFrame, w2;
            }
            throw w2;
          }
        }
        r2.exports = { parse: y2, resolveParser: d2 };
      } }), uo2 = Z2({ "src/main/options.js"(e25, r2) {
        ne2();
        var t2 = ZD2(), { UndefinedParserError: s2 } = Qt2(), { getSupportInfo: a2 } = Xn2(), n2 = Om2(), { resolveParser: u2 } = tu2(), i2 = { astFormat: "estree", printer: {}, originalText: void 0, locStart: null, locEnd: null };
        function l2(y2) {
          let g2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, c2 = Object.assign({}, y2), D2 = a2({ plugins: y2.plugins, showUnreleased: true, showDeprecated: true }).options, E2 = Object.assign(Object.assign({}, i2), Object.fromEntries(D2.filter((N2) => N2.default !== void 0).map((N2) => [N2.name, N2.default])));
          if (!c2.parser) {
            if (!c2.filepath)
              (g2.logger || console).warn("No parser and no filepath given, using 'babel' the parser now but this will throw an error in the future. Please specify a parser or a filepath so one can be inferred."), c2.parser = "babel";
            else if (c2.parser = d2(c2.filepath, c2.plugins), !c2.parser)
              throw new s2(`No parser could be inferred for file: ${c2.filepath}`);
          }
          let _2 = u2(n2.normalizeApiOptions(c2, [D2.find((N2) => N2.name === "parser")], { passThrough: true, logger: false }));
          c2.astFormat = _2.astFormat, c2.locEnd = _2.locEnd, c2.locStart = _2.locStart;
          let w2 = p2(c2);
          c2.printer = w2.printers[c2.astFormat];
          let F2 = Object.fromEntries(D2.filter((N2) => N2.pluginDefaults && N2.pluginDefaults[w2.name] !== void 0).map((N2) => [N2.name, N2.pluginDefaults[w2.name]])), A2 = Object.assign(Object.assign({}, E2), F2);
          for (let [N2, I2] of Object.entries(A2))
            (c2[N2] === null || c2[N2] === void 0) && (c2[N2] = I2);
          return c2.parser === "json" && (c2.trailingComma = "none"), n2.normalizeApiOptions(c2, D2, Object.assign({ passThrough: Object.keys(i2) }, g2));
        }
        function p2(y2) {
          let { astFormat: g2 } = y2;
          if (!g2)
            throw new Error("getPlugin() requires astFormat to be set");
          let c2 = y2.plugins.find((D2) => D2.printers && D2.printers[g2]);
          if (!c2)
            throw new Error(`Couldn't find plugin for AST format "${g2}"`);
          return c2;
        }
        function d2(y2, g2) {
          let c2 = t2.basename(y2).toLowerCase(), E2 = a2({ plugins: g2 }).languages.filter((_2) => _2.since !== null).find((_2) => _2.extensions && _2.extensions.some((w2) => c2.endsWith(w2)) || _2.filenames && _2.filenames.some((w2) => w2.toLowerCase() === c2));
          return E2 && E2.parsers[0];
        }
        r2.exports = { normalize: l2, hiddenDefaults: i2, inferParser: d2 };
      } }), Rm2 = Z2({ "src/main/massage-ast.js"(e25, r2) {
        ne2();
        function t2(s2, a2, n2) {
          if (Array.isArray(s2))
            return s2.map((p2) => t2(p2, a2, n2)).filter(Boolean);
          if (!s2 || typeof s2 != "object")
            return s2;
          let u2 = a2.printer.massageAstNode, i2;
          u2 && u2.ignoredProperties ? i2 = u2.ignoredProperties : i2 = new Set();
          let l2 = {};
          for (let [p2, d2] of Object.entries(s2))
            !i2.has(p2) && typeof d2 != "function" && (l2[p2] = t2(d2, a2, s2));
          if (u2) {
            let p2 = u2(s2, l2, n2);
            if (p2 === null)
              return;
            if (p2)
              return p2;
          }
          return l2;
        }
        r2.exports = t2;
      } }), Zt2 = Z2({ "scripts/build/shims/assert.cjs"(e25, r2) {
        ne2();
        var t2 = () => {
        };
        t2.ok = t2, t2.strictEqual = t2, r2.exports = t2;
      } }), et2 = Z2({ "src/main/comments.js"(e25, r2) {
        ne2();
        var t2 = Zt2(), { builders: { line: s2, hardline: a2, breakParent: n2, indent: u2, lineSuffix: i2, join: l2, cursor: p2 } } = Me2(), { hasNewline: d2, skipNewline: y2, skipSpaces: g2, isPreviousLineEmpty: c2, addLeadingComment: D2, addDanglingComment: E2, addTrailingComment: _2 } = Ue2(), w2 = new WeakMap();
        function F2(k2, M2, R2) {
          if (!k2)
            return;
          let { printer: q2, locStart: U2, locEnd: L2 } = M2;
          if (R2) {
            if (q2.canAttachComment && q2.canAttachComment(k2)) {
              let V2;
              for (V2 = R2.length - 1; V2 >= 0 && !(U2(R2[V2]) <= U2(k2) && L2(R2[V2]) <= L2(k2)); --V2)
                ;
              R2.splice(V2 + 1, 0, k2);
              return;
            }
          } else if (w2.has(k2))
            return w2.get(k2);
          let Y2 = q2.getCommentChildNodes && q2.getCommentChildNodes(k2, M2) || typeof k2 == "object" && Object.entries(k2).filter((V2) => {
            let [j2] = V2;
            return j2 !== "enclosingNode" && j2 !== "precedingNode" && j2 !== "followingNode" && j2 !== "tokens" && j2 !== "comments" && j2 !== "parent";
          }).map((V2) => {
            let [, j2] = V2;
            return j2;
          });
          if (Y2) {
            R2 || (R2 = [], w2.set(k2, R2));
            for (let V2 of Y2)
              F2(V2, M2, R2);
            return R2;
          }
        }
        function A2(k2, M2, R2, q2) {
          let { locStart: U2, locEnd: L2 } = R2, Y2 = U2(M2), V2 = L2(M2), j2 = F2(k2, R2), K2, se2, Q2 = 0, ce2 = j2.length;
          for (; Q2 < ce2; ) {
            let W2 = Q2 + ce2 >> 1, X2 = j2[W2], de2 = U2(X2), ie2 = L2(X2);
            if (de2 <= Y2 && V2 <= ie2)
              return A2(X2, M2, R2, X2);
            if (ie2 <= Y2) {
              K2 = X2, Q2 = W2 + 1;
              continue;
            }
            if (V2 <= de2) {
              se2 = X2, ce2 = W2;
              continue;
            }
            throw new Error("Comment location overlaps with node location");
          }
          if (q2 && q2.type === "TemplateLiteral") {
            let { quasis: W2 } = q2, X2 = v2(W2, M2, R2);
            K2 && v2(W2, K2, R2) !== X2 && (K2 = null), se2 && v2(W2, se2, R2) !== X2 && (se2 = null);
          }
          return { enclosingNode: q2, precedingNode: K2, followingNode: se2 };
        }
        var N2 = () => false;
        function I2(k2, M2, R2, q2) {
          if (!Array.isArray(k2))
            return;
          let U2 = [], { locStart: L2, locEnd: Y2, printer: { handleComments: V2 = {} } } = q2, { avoidAstMutation: j2, ownLine: K2 = N2, endOfLine: se2 = N2, remaining: Q2 = N2 } = V2, ce2 = k2.map((W2, X2) => Object.assign(Object.assign({}, A2(M2, W2, q2)), {}, { comment: W2, text: R2, options: q2, ast: M2, isLastComment: k2.length - 1 === X2 }));
          for (let [W2, X2] of ce2.entries()) {
            let { comment: de2, precedingNode: ie2, enclosingNode: Ee2, followingNode: z2, text: ue2, options: J2, ast: le2, isLastComment: ge2 } = X2;
            if (J2.parser === "json" || J2.parser === "json5" || J2.parser === "__js_expression" || J2.parser === "__vue_expression" || J2.parser === "__vue_ts_expression") {
              if (L2(de2) - L2(le2) <= 0) {
                D2(le2, de2);
                continue;
              }
              if (Y2(de2) - Y2(le2) >= 0) {
                _2(le2, de2);
                continue;
              }
            }
            let pe2;
            if (j2 ? pe2 = [X2] : (de2.enclosingNode = Ee2, de2.precedingNode = ie2, de2.followingNode = z2, pe2 = [de2, ue2, J2, le2, ge2]), H2(ue2, J2, ce2, W2))
              de2.placement = "ownLine", K2(...pe2) || (z2 ? D2(z2, de2) : ie2 ? _2(ie2, de2) : E2(Ee2 || le2, de2));
            else if (f2(ue2, J2, ce2, W2))
              de2.placement = "endOfLine", se2(...pe2) || (ie2 ? _2(ie2, de2) : z2 ? D2(z2, de2) : E2(Ee2 || le2, de2));
            else if (de2.placement = "remaining", !Q2(...pe2))
              if (ie2 && z2) {
                let Ae2 = U2.length;
                Ae2 > 0 && U2[Ae2 - 1].followingNode !== z2 && b2(U2, ue2, J2), U2.push(X2);
              } else
                ie2 ? _2(ie2, de2) : z2 ? D2(z2, de2) : E2(Ee2 || le2, de2);
          }
          if (b2(U2, R2, q2), !j2)
            for (let W2 of k2)
              delete W2.precedingNode, delete W2.enclosingNode, delete W2.followingNode;
        }
        var P2 = (k2) => !/[\S\n\u2028\u2029]/.test(k2);
        function H2(k2, M2, R2, q2) {
          let { comment: U2, precedingNode: L2 } = R2[q2], { locStart: Y2, locEnd: V2 } = M2, j2 = Y2(U2);
          if (L2)
            for (let K2 = q2 - 1; K2 >= 0; K2--) {
              let { comment: se2, precedingNode: Q2 } = R2[K2];
              if (Q2 !== L2 || !P2(k2.slice(V2(se2), j2)))
                break;
              j2 = Y2(se2);
            }
          return d2(k2, j2, { backwards: true });
        }
        function f2(k2, M2, R2, q2) {
          let { comment: U2, followingNode: L2 } = R2[q2], { locStart: Y2, locEnd: V2 } = M2, j2 = V2(U2);
          if (L2)
            for (let K2 = q2 + 1; K2 < R2.length; K2++) {
              let { comment: se2, followingNode: Q2 } = R2[K2];
              if (Q2 !== L2 || !P2(k2.slice(j2, Y2(se2))))
                break;
              j2 = V2(se2);
            }
          return d2(k2, j2);
        }
        function b2(k2, M2, R2) {
          let q2 = k2.length;
          if (q2 === 0)
            return;
          let { precedingNode: U2, followingNode: L2, enclosingNode: Y2 } = k2[0], V2 = R2.printer.getGapRegex && R2.printer.getGapRegex(Y2) || /^[\s(]*$/, j2 = R2.locStart(L2), K2;
          for (K2 = q2; K2 > 0; --K2) {
            let { comment: se2, precedingNode: Q2, followingNode: ce2 } = k2[K2 - 1];
            t2.strictEqual(Q2, U2), t2.strictEqual(ce2, L2);
            let W2 = M2.slice(R2.locEnd(se2), j2);
            if (V2.test(W2))
              j2 = R2.locStart(se2);
            else
              break;
          }
          for (let [se2, { comment: Q2 }] of k2.entries())
            se2 < K2 ? _2(U2, Q2) : D2(L2, Q2);
          for (let se2 of [U2, L2])
            se2.comments && se2.comments.length > 1 && se2.comments.sort((Q2, ce2) => R2.locStart(Q2) - R2.locStart(ce2));
          k2.length = 0;
        }
        function m2(k2, M2) {
          let R2 = k2.getValue();
          return R2.printed = true, M2.printer.printComment(k2, M2);
        }
        function v2(k2, M2, R2) {
          let q2 = R2.locStart(M2) - 1;
          for (let U2 = 1; U2 < k2.length; ++U2)
            if (q2 < R2.locStart(k2[U2]))
              return U2 - 1;
          return 0;
        }
        function o2(k2, M2) {
          let R2 = k2.getValue(), q2 = [m2(k2, M2)], { printer: U2, originalText: L2, locStart: Y2, locEnd: V2 } = M2;
          if (U2.isBlockComment && U2.isBlockComment(R2)) {
            let se2 = d2(L2, V2(R2)) ? d2(L2, Y2(R2), { backwards: true }) ? a2 : s2 : " ";
            q2.push(se2);
          } else
            q2.push(a2);
          let K2 = y2(L2, g2(L2, V2(R2)));
          return K2 !== false && d2(L2, K2) && q2.push(a2), q2;
        }
        function h2(k2, M2) {
          let R2 = k2.getValue(), q2 = m2(k2, M2), { printer: U2, originalText: L2, locStart: Y2 } = M2, V2 = U2.isBlockComment && U2.isBlockComment(R2);
          if (d2(L2, Y2(R2), { backwards: true })) {
            let K2 = c2(L2, R2, Y2);
            return i2([a2, K2 ? a2 : "", q2]);
          }
          let j2 = [" ", q2];
          return V2 || (j2 = [i2(j2), n2]), j2;
        }
        function C2(k2, M2, R2, q2) {
          let U2 = [], L2 = k2.getValue();
          return !L2 || !L2.comments || (k2.each(() => {
            let Y2 = k2.getValue();
            !Y2.leading && !Y2.trailing && (!q2 || q2(Y2)) && U2.push(m2(k2, M2));
          }, "comments"), U2.length === 0) ? "" : R2 ? l2(a2, U2) : u2([a2, l2(a2, U2)]);
        }
        function S2(k2, M2, R2) {
          let q2 = k2.getValue();
          if (!q2)
            return {};
          let U2 = q2.comments || [];
          R2 && (U2 = U2.filter((j2) => !R2.has(j2)));
          let L2 = q2 === M2.cursorNode;
          if (U2.length === 0) {
            let j2 = L2 ? p2 : "";
            return { leading: j2, trailing: j2 };
          }
          let Y2 = [], V2 = [];
          return k2.each(() => {
            let j2 = k2.getValue();
            if (R2 && R2.has(j2))
              return;
            let { leading: K2, trailing: se2 } = j2;
            K2 ? Y2.push(o2(k2, M2)) : se2 && V2.push(h2(k2, M2));
          }, "comments"), L2 && (Y2.unshift(p2), V2.push(p2)), { leading: Y2, trailing: V2 };
        }
        function x2(k2, M2, R2, q2) {
          let { leading: U2, trailing: L2 } = S2(k2, R2, q2);
          return !U2 && !L2 ? M2 : [U2, M2, L2];
        }
        function T2(k2) {
          if (k2)
            for (let M2 of k2) {
              if (!M2.printed)
                throw new Error('Comment "' + M2.value.trim() + '" was not printed. Please report this error!');
              delete M2.printed;
            }
        }
        r2.exports = { attach: I2, printComments: x2, printCommentsSeparately: S2, printDanglingComments: C2, getSortedChildNodes: F2, ensureAllCommentsPrinted: T2 };
      } }), $m2 = Z2({ "src/common/ast-path.js"(e25, r2) {
        ne2();
        var t2 = lt2();
        function s2(u2, i2) {
          let l2 = a2(u2.stack, i2);
          return l2 === -1 ? null : u2.stack[l2];
        }
        function a2(u2, i2) {
          for (let l2 = u2.length - 1; l2 >= 0; l2 -= 2) {
            let p2 = u2[l2];
            if (p2 && !Array.isArray(p2) && --i2 < 0)
              return l2;
          }
          return -1;
        }
        var n2 = class {
          constructor(u2) {
            this.stack = [u2];
          }
          getName() {
            let { stack: u2 } = this, { length: i2 } = u2;
            return i2 > 1 ? u2[i2 - 2] : null;
          }
          getValue() {
            return t2(this.stack);
          }
          getNode() {
            let u2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            return s2(this, u2);
          }
          getParentNode() {
            let u2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
            return s2(this, u2 + 1);
          }
          call(u2) {
            let { stack: i2 } = this, { length: l2 } = i2, p2 = t2(i2);
            for (var d2 = arguments.length, y2 = new Array(d2 > 1 ? d2 - 1 : 0), g2 = 1; g2 < d2; g2++)
              y2[g2 - 1] = arguments[g2];
            for (let D2 of y2)
              p2 = p2[D2], i2.push(D2, p2);
            let c2 = u2(this);
            return i2.length = l2, c2;
          }
          callParent(u2) {
            let i2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, l2 = a2(this.stack, i2 + 1), p2 = this.stack.splice(l2 + 1), d2 = u2(this);
            return this.stack.push(...p2), d2;
          }
          each(u2) {
            let { stack: i2 } = this, { length: l2 } = i2, p2 = t2(i2);
            for (var d2 = arguments.length, y2 = new Array(d2 > 1 ? d2 - 1 : 0), g2 = 1; g2 < d2; g2++)
              y2[g2 - 1] = arguments[g2];
            for (let c2 of y2)
              p2 = p2[c2], i2.push(c2, p2);
            for (let c2 = 0; c2 < p2.length; ++c2)
              i2.push(c2, p2[c2]), u2(this, c2, p2), i2.length -= 2;
            i2.length = l2;
          }
          map(u2) {
            let i2 = [];
            for (var l2 = arguments.length, p2 = new Array(l2 > 1 ? l2 - 1 : 0), d2 = 1; d2 < l2; d2++)
              p2[d2 - 1] = arguments[d2];
            return this.each((y2, g2, c2) => {
              i2[g2] = u2(y2, g2, c2);
            }, ...p2), i2;
          }
          try(u2) {
            let { stack: i2 } = this, l2 = [...i2];
            try {
              return u2();
            } finally {
              i2.length = 0, i2.push(...l2);
            }
          }
          match() {
            let u2 = this.stack.length - 1, i2 = null, l2 = this.stack[u2--];
            for (var p2 = arguments.length, d2 = new Array(p2), y2 = 0; y2 < p2; y2++)
              d2[y2] = arguments[y2];
            for (let g2 of d2) {
              if (l2 === void 0)
                return false;
              let c2 = null;
              if (typeof i2 == "number" && (c2 = i2, i2 = this.stack[u2--], l2 = this.stack[u2--]), g2 && !g2(l2, i2, c2))
                return false;
              i2 = this.stack[u2--], l2 = this.stack[u2--];
            }
            return true;
          }
          findAncestor(u2) {
            let i2 = this.stack.length - 1, l2 = null, p2 = this.stack[i2--];
            for (; p2; ) {
              let d2 = null;
              if (typeof l2 == "number" && (d2 = l2, l2 = this.stack[i2--], p2 = this.stack[i2--]), l2 !== null && u2(p2, l2, d2))
                return p2;
              l2 = this.stack[i2--], p2 = this.stack[i2--];
            }
          }
        };
        r2.exports = n2;
      } }), Vm2 = Z2({ "src/main/multiparser.js"(e25, r2) {
        ne2();
        var { utils: { stripTrailingHardline: t2 } } = Me2(), { normalize: s2 } = uo2(), a2 = et2();
        function n2(i2, l2, p2, d2) {
          if (p2.printer.embed && p2.embeddedLanguageFormatting === "auto")
            return p2.printer.embed(i2, l2, (y2, g2, c2) => u2(y2, g2, p2, d2, c2), p2);
        }
        function u2(i2, l2, p2, d2) {
          let { stripTrailingHardline: y2 = false } = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, g2 = s2(Object.assign(Object.assign(Object.assign({}, p2), l2), {}, { parentParser: p2.parser, originalText: i2 }), { passThrough: true }), c2 = tu2().parse(i2, g2), { ast: D2 } = c2;
          i2 = c2.text;
          let E2 = D2.comments;
          delete D2.comments, a2.attach(E2, D2, i2, g2), g2[Symbol.for("comments")] = E2 || [], g2[Symbol.for("tokens")] = D2.tokens || [];
          let _2 = d2(D2, g2);
          return a2.ensureAllCommentsPrinted(E2), y2 ? typeof _2 == "string" ? _2.replace(/(?:\r?\n)*$/, "") : t2(_2) : _2;
        }
        r2.exports = { printSubtree: n2 };
      } }), Wm2 = Z2({ "src/main/ast-to-doc.js"(e25, r2) {
        ne2();
        var t2 = $m2(), { builders: { hardline: s2, addAlignmentToDoc: a2 }, utils: { propagateBreaks: n2 } } = Me2(), { printComments: u2 } = et2(), i2 = Vm2();
        function l2(y2, g2) {
          let c2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, { printer: D2 } = g2;
          D2.preprocess && (y2 = D2.preprocess(y2, g2));
          let E2 = new Map(), _2 = new t2(y2), w2 = F2();
          return c2 > 0 && (w2 = a2([s2, w2], c2, g2.tabWidth)), n2(w2), w2;
          function F2(N2, I2) {
            return N2 === void 0 || N2 === _2 ? A2(I2) : Array.isArray(N2) ? _2.call(() => A2(I2), ...N2) : _2.call(() => A2(I2), N2);
          }
          function A2(N2) {
            let I2 = _2.getValue(), P2 = I2 && typeof I2 == "object" && N2 === void 0;
            if (P2 && E2.has(I2))
              return E2.get(I2);
            let H2 = d2(_2, g2, F2, N2);
            return P2 && E2.set(I2, H2), H2;
          }
        }
        function p2(y2, g2) {
          let { originalText: c2, [Symbol.for("comments")]: D2, locStart: E2, locEnd: _2 } = g2, w2 = E2(y2), F2 = _2(y2), A2 = new Set();
          for (let N2 of D2)
            E2(N2) >= w2 && _2(N2) <= F2 && (N2.printed = true, A2.add(N2));
          return { doc: c2.slice(w2, F2), printedComments: A2 };
        }
        function d2(y2, g2, c2, D2) {
          let E2 = y2.getValue(), { printer: _2 } = g2, w2, F2;
          if (_2.hasPrettierIgnore && _2.hasPrettierIgnore(y2))
            ({ doc: w2, printedComments: F2 } = p2(E2, g2));
          else {
            if (E2)
              try {
                w2 = i2.printSubtree(y2, c2, g2, l2);
              } catch (A2) {
                if (globalThis.PRETTIER_DEBUG)
                  throw A2;
              }
            w2 || (w2 = _2.print(y2, g2, c2, D2));
          }
          return (!_2.willPrintOwnComments || !_2.willPrintOwnComments(y2, g2)) && (w2 = u2(y2, w2, g2, F2)), w2;
        }
        r2.exports = l2;
      } }), Hm2 = Z2({ "src/main/range-util.js"(e25, r2) {
        ne2();
        var t2 = Zt2(), s2 = et2(), a2 = (D2) => {
          let { parser: E2 } = D2;
          return E2 === "json" || E2 === "json5" || E2 === "json-stringify";
        };
        function n2(D2, E2) {
          let _2 = [D2.node, ...D2.parentNodes], w2 = new Set([E2.node, ...E2.parentNodes]);
          return _2.find((F2) => d2.has(F2.type) && w2.has(F2));
        }
        function u2(D2) {
          let E2 = D2.length - 1;
          for (; ; ) {
            let _2 = D2[E2];
            if (_2 && (_2.type === "Program" || _2.type === "File"))
              E2--;
            else
              break;
          }
          return D2.slice(0, E2 + 1);
        }
        function i2(D2, E2, _2) {
          let { locStart: w2, locEnd: F2 } = _2, A2 = D2.node, N2 = E2.node;
          if (A2 === N2)
            return { startNode: A2, endNode: N2 };
          let I2 = w2(D2.node);
          for (let H2 of u2(E2.parentNodes))
            if (w2(H2) >= I2)
              N2 = H2;
            else
              break;
          let P2 = F2(E2.node);
          for (let H2 of u2(D2.parentNodes)) {
            if (F2(H2) <= P2)
              A2 = H2;
            else
              break;
            if (A2 === N2)
              break;
          }
          return { startNode: A2, endNode: N2 };
        }
        function l2(D2, E2, _2, w2) {
          let F2 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], A2 = arguments.length > 5 ? arguments[5] : void 0, { locStart: N2, locEnd: I2 } = _2, P2 = N2(D2), H2 = I2(D2);
          if (!(E2 > H2 || E2 < P2 || A2 === "rangeEnd" && E2 === P2 || A2 === "rangeStart" && E2 === H2)) {
            for (let f2 of s2.getSortedChildNodes(D2, _2)) {
              let b2 = l2(f2, E2, _2, w2, [D2, ...F2], A2);
              if (b2)
                return b2;
            }
            if (!w2 || w2(D2, F2[0]))
              return { node: D2, parentNodes: F2 };
          }
        }
        function p2(D2, E2) {
          return E2 !== "DeclareExportDeclaration" && D2 !== "TypeParameterDeclaration" && (D2 === "Directive" || D2 === "TypeAlias" || D2 === "TSExportAssignment" || D2.startsWith("Declare") || D2.startsWith("TSDeclare") || D2.endsWith("Statement") || D2.endsWith("Declaration"));
        }
        var d2 = new Set(["ObjectExpression", "ArrayExpression", "StringLiteral", "NumericLiteral", "BooleanLiteral", "NullLiteral", "UnaryExpression", "TemplateLiteral"]), y2 = new Set(["OperationDefinition", "FragmentDefinition", "VariableDefinition", "TypeExtensionDefinition", "ObjectTypeDefinition", "FieldDefinition", "DirectiveDefinition", "EnumTypeDefinition", "EnumValueDefinition", "InputValueDefinition", "InputObjectTypeDefinition", "SchemaDefinition", "OperationTypeDefinition", "InterfaceTypeDefinition", "UnionTypeDefinition", "ScalarTypeDefinition"]);
        function g2(D2, E2, _2) {
          if (!E2)
            return false;
          switch (D2.parser) {
            case "flow":
            case "babel":
            case "babel-flow":
            case "babel-ts":
            case "typescript":
            case "acorn":
            case "espree":
            case "meriyah":
            case "__babel_estree":
              return p2(E2.type, _2 && _2.type);
            case "json":
            case "json5":
            case "json-stringify":
              return d2.has(E2.type);
            case "graphql":
              return y2.has(E2.kind);
            case "vue":
              return E2.tag !== "root";
          }
          return false;
        }
        function c2(D2, E2, _2) {
          let { rangeStart: w2, rangeEnd: F2, locStart: A2, locEnd: N2 } = E2;
          t2.ok(F2 > w2);
          let I2 = D2.slice(w2, F2).search(/\S/), P2 = I2 === -1;
          if (!P2)
            for (w2 += I2; F2 > w2 && !/\S/.test(D2[F2 - 1]); --F2)
              ;
          let H2 = l2(_2, w2, E2, (v2, o2) => g2(E2, v2, o2), [], "rangeStart"), f2 = P2 ? H2 : l2(_2, F2, E2, (v2) => g2(E2, v2), [], "rangeEnd");
          if (!H2 || !f2)
            return { rangeStart: 0, rangeEnd: 0 };
          let b2, m2;
          if (a2(E2)) {
            let v2 = n2(H2, f2);
            b2 = v2, m2 = v2;
          } else
            ({ startNode: b2, endNode: m2 } = i2(H2, f2, E2));
          return { rangeStart: Math.min(A2(b2), A2(m2)), rangeEnd: Math.max(N2(b2), N2(m2)) };
        }
        r2.exports = { calculateRange: c2, findNodeAtOffset: l2 };
      } }), Gm2 = Z2({ "src/main/core.js"(e25, r2) {
        ne2();
        var { diffArrays: t2 } = BD2(), { printer: { printDocToString: s2 }, debug: { printDocToDebug: a2 } } = Me2(), { getAlignmentSize: n2 } = Ue2(), { guessEndOfLine: u2, convertEndOfLineToChars: i2, countEndOfLineChars: l2, normalizeEndOfLine: p2 } = Jn2(), d2 = uo2().normalize, y2 = Rm2(), g2 = et2(), c2 = tu2(), D2 = Wm2(), E2 = Hm2(), _2 = "\uFEFF", w2 = Symbol("cursor");
        function F2(m2, v2, o2) {
          let h2 = v2.comments;
          return h2 && (delete v2.comments, g2.attach(h2, v2, m2, o2)), o2[Symbol.for("comments")] = h2 || [], o2[Symbol.for("tokens")] = v2.tokens || [], o2.originalText = m2, h2;
        }
        function A2(m2, v2) {
          let o2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
          if (!m2 || m2.trim().length === 0)
            return { formatted: "", cursorOffset: -1, comments: [] };
          let { ast: h2, text: C2 } = c2.parse(m2, v2);
          if (v2.cursorOffset >= 0) {
            let k2 = E2.findNodeAtOffset(h2, v2.cursorOffset, v2);
            k2 && k2.node && (v2.cursorNode = k2.node);
          }
          let S2 = F2(C2, h2, v2), x2 = D2(h2, v2, o2), T2 = s2(x2, v2);
          if (g2.ensureAllCommentsPrinted(S2), o2 > 0) {
            let k2 = T2.formatted.trim();
            T2.cursorNodeStart !== void 0 && (T2.cursorNodeStart -= T2.formatted.indexOf(k2)), T2.formatted = k2 + i2(v2.endOfLine);
          }
          if (v2.cursorOffset >= 0) {
            let k2, M2, R2, q2, U2;
            if (v2.cursorNode && T2.cursorNodeText ? (k2 = v2.locStart(v2.cursorNode), M2 = C2.slice(k2, v2.locEnd(v2.cursorNode)), R2 = v2.cursorOffset - k2, q2 = T2.cursorNodeStart, U2 = T2.cursorNodeText) : (k2 = 0, M2 = C2, R2 = v2.cursorOffset, q2 = 0, U2 = T2.formatted), M2 === U2)
              return { formatted: T2.formatted, cursorOffset: q2 + R2, comments: S2 };
            let L2 = [...M2];
            L2.splice(R2, 0, w2);
            let Y2 = [...U2], V2 = t2(L2, Y2), j2 = q2;
            for (let K2 of V2)
              if (K2.removed) {
                if (K2.value.includes(w2))
                  break;
              } else
                j2 += K2.count;
            return { formatted: T2.formatted, cursorOffset: j2, comments: S2 };
          }
          return { formatted: T2.formatted, cursorOffset: -1, comments: S2 };
        }
        function N2(m2, v2) {
          let { ast: o2, text: h2 } = c2.parse(m2, v2), { rangeStart: C2, rangeEnd: S2 } = E2.calculateRange(h2, v2, o2), x2 = h2.slice(C2, S2), T2 = Math.min(C2, h2.lastIndexOf(`
`, C2) + 1), k2 = h2.slice(T2, C2).match(/^\s*/)[0], M2 = n2(k2, v2.tabWidth), R2 = A2(x2, Object.assign(Object.assign({}, v2), {}, { rangeStart: 0, rangeEnd: Number.POSITIVE_INFINITY, cursorOffset: v2.cursorOffset > C2 && v2.cursorOffset <= S2 ? v2.cursorOffset - C2 : -1, endOfLine: "lf" }), M2), q2 = R2.formatted.trimEnd(), { cursorOffset: U2 } = v2;
          U2 > S2 ? U2 += q2.length - x2.length : R2.cursorOffset >= 0 && (U2 = R2.cursorOffset + C2);
          let L2 = h2.slice(0, C2) + q2 + h2.slice(S2);
          if (v2.endOfLine !== "lf") {
            let Y2 = i2(v2.endOfLine);
            U2 >= 0 && Y2 === `\r
` && (U2 += l2(L2.slice(0, U2), `
`)), L2 = L2.replace(/\n/g, Y2);
          }
          return { formatted: L2, cursorOffset: U2, comments: R2.comments };
        }
        function I2(m2, v2, o2) {
          return typeof v2 != "number" || Number.isNaN(v2) || v2 < 0 || v2 > m2.length ? o2 : v2;
        }
        function P2(m2, v2) {
          let { cursorOffset: o2, rangeStart: h2, rangeEnd: C2 } = v2;
          return o2 = I2(m2, o2, -1), h2 = I2(m2, h2, 0), C2 = I2(m2, C2, m2.length), Object.assign(Object.assign({}, v2), {}, { cursorOffset: o2, rangeStart: h2, rangeEnd: C2 });
        }
        function H2(m2, v2) {
          let { cursorOffset: o2, rangeStart: h2, rangeEnd: C2, endOfLine: S2 } = P2(m2, v2), x2 = m2.charAt(0) === _2;
          if (x2 && (m2 = m2.slice(1), o2--, h2--, C2--), S2 === "auto" && (S2 = u2(m2)), m2.includes("\r")) {
            let T2 = (k2) => l2(m2.slice(0, Math.max(k2, 0)), `\r
`);
            o2 -= T2(o2), h2 -= T2(h2), C2 -= T2(C2), m2 = p2(m2);
          }
          return { hasBOM: x2, text: m2, options: P2(m2, Object.assign(Object.assign({}, v2), {}, { cursorOffset: o2, rangeStart: h2, rangeEnd: C2, endOfLine: S2 })) };
        }
        function f2(m2, v2) {
          let o2 = c2.resolveParser(v2);
          return !o2.hasPragma || o2.hasPragma(m2);
        }
        function b2(m2, v2) {
          let { hasBOM: o2, text: h2, options: C2 } = H2(m2, d2(v2));
          if (C2.rangeStart >= C2.rangeEnd && h2 !== "" || C2.requirePragma && !f2(h2, C2))
            return { formatted: m2, cursorOffset: v2.cursorOffset, comments: [] };
          let S2;
          return C2.rangeStart > 0 || C2.rangeEnd < h2.length ? S2 = N2(h2, C2) : (!C2.requirePragma && C2.insertPragma && C2.printer.insertPragma && !f2(h2, C2) && (h2 = C2.printer.insertPragma(h2)), S2 = A2(h2, C2)), o2 && (S2.formatted = _2 + S2.formatted, S2.cursorOffset >= 0 && S2.cursorOffset++), S2;
        }
        r2.exports = { formatWithCursor: b2, parse(m2, v2, o2) {
          let { text: h2, options: C2 } = H2(m2, d2(v2)), S2 = c2.parse(h2, C2);
          return o2 && (S2.ast = y2(S2.ast, C2)), S2;
        }, formatAST(m2, v2) {
          v2 = d2(v2);
          let o2 = D2(m2, v2);
          return s2(o2, v2);
        }, formatDoc(m2, v2) {
          return b2(a2(m2), Object.assign(Object.assign({}, v2), {}, { parser: "__js_expression" })).formatted;
        }, printToDoc(m2, v2) {
          v2 = d2(v2);
          let { ast: o2, text: h2 } = c2.parse(m2, v2);
          return F2(h2, o2, v2), D2(o2, v2);
        }, printDocToString(m2, v2) {
          return s2(m2, d2(v2));
        } };
      } }), Um2 = Z2({ "src/common/util-shared.js"(e25, r2) {
        ne2();
        var { getMaxContinuousCount: t2, getStringWidth: s2, getAlignmentSize: a2, getIndentSize: n2, skip: u2, skipWhitespace: i2, skipSpaces: l2, skipNewline: p2, skipToLineEnd: d2, skipEverythingButNewLine: y2, skipInlineComment: g2, skipTrailingComment: c2, hasNewline: D2, hasNewlineInRange: E2, hasSpaces: _2, isNextLineEmpty: w2, isNextLineEmptyAfterIndex: F2, isPreviousLineEmpty: A2, getNextNonSpaceNonCommentCharacterIndex: N2, makeString: I2, addLeadingComment: P2, addDanglingComment: H2, addTrailingComment: f2 } = Ue2();
        r2.exports = { getMaxContinuousCount: t2, getStringWidth: s2, getAlignmentSize: a2, getIndentSize: n2, skip: u2, skipWhitespace: i2, skipSpaces: l2, skipNewline: p2, skipToLineEnd: d2, skipEverythingButNewLine: y2, skipInlineComment: g2, skipTrailingComment: c2, hasNewline: D2, hasNewlineInRange: E2, hasSpaces: _2, isNextLineEmpty: w2, isNextLineEmptyAfterIndex: F2, isPreviousLineEmpty: A2, getNextNonSpaceNonCommentCharacterIndex: N2, makeString: I2, addLeadingComment: P2, addDanglingComment: H2, addTrailingComment: f2 };
      } }), _t2 = Z2({ "src/utils/create-language.js"(e25, r2) {
        ne2(), r2.exports = function(t2, s2) {
          let { languageId: a2 } = t2, n2 = Hn2(t2, CD2);
          return Object.assign(Object.assign({ linguistLanguageId: a2 }, n2), s2(t2));
        };
      } }), Jm2 = Z2({ "node_modules/esutils/lib/ast.js"(e25, r2) {
        ne2(), function() {
          function t2(l2) {
            if (l2 == null)
              return false;
            switch (l2.type) {
              case "ArrayExpression":
              case "AssignmentExpression":
              case "BinaryExpression":
              case "CallExpression":
              case "ConditionalExpression":
              case "FunctionExpression":
              case "Identifier":
              case "Literal":
              case "LogicalExpression":
              case "MemberExpression":
              case "NewExpression":
              case "ObjectExpression":
              case "SequenceExpression":
              case "ThisExpression":
              case "UnaryExpression":
              case "UpdateExpression":
                return true;
            }
            return false;
          }
          function s2(l2) {
            if (l2 == null)
              return false;
            switch (l2.type) {
              case "DoWhileStatement":
              case "ForInStatement":
              case "ForStatement":
              case "WhileStatement":
                return true;
            }
            return false;
          }
          function a2(l2) {
            if (l2 == null)
              return false;
            switch (l2.type) {
              case "BlockStatement":
              case "BreakStatement":
              case "ContinueStatement":
              case "DebuggerStatement":
              case "DoWhileStatement":
              case "EmptyStatement":
              case "ExpressionStatement":
              case "ForInStatement":
              case "ForStatement":
              case "IfStatement":
              case "LabeledStatement":
              case "ReturnStatement":
              case "SwitchStatement":
              case "ThrowStatement":
              case "TryStatement":
              case "VariableDeclaration":
              case "WhileStatement":
              case "WithStatement":
                return true;
            }
            return false;
          }
          function n2(l2) {
            return a2(l2) || l2 != null && l2.type === "FunctionDeclaration";
          }
          function u2(l2) {
            switch (l2.type) {
              case "IfStatement":
                return l2.alternate != null ? l2.alternate : l2.consequent;
              case "LabeledStatement":
              case "ForStatement":
              case "ForInStatement":
              case "WhileStatement":
              case "WithStatement":
                return l2.body;
            }
            return null;
          }
          function i2(l2) {
            var p2;
            if (l2.type !== "IfStatement" || l2.alternate == null)
              return false;
            p2 = l2.consequent;
            do {
              if (p2.type === "IfStatement" && p2.alternate == null)
                return true;
              p2 = u2(p2);
            } while (p2);
            return false;
          }
          r2.exports = { isExpression: t2, isStatement: a2, isIterationStatement: s2, isSourceElement: n2, isProblematicIfStatement: i2, trailingStatement: u2 };
        }();
      } }), so2 = Z2({ "node_modules/esutils/lib/code.js"(e25, r2) {
        ne2(), function() {
          var t2, s2, a2, n2, u2, i2;
          s2 = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/, NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/ }, t2 = { NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/, NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/ };
          function l2(F2) {
            return 48 <= F2 && F2 <= 57;
          }
          function p2(F2) {
            return 48 <= F2 && F2 <= 57 || 97 <= F2 && F2 <= 102 || 65 <= F2 && F2 <= 70;
          }
          function d2(F2) {
            return F2 >= 48 && F2 <= 55;
          }
          a2 = [5760, 8192, 8193, 8194, 8195, 8196, 8197, 8198, 8199, 8200, 8201, 8202, 8239, 8287, 12288, 65279];
          function y2(F2) {
            return F2 === 32 || F2 === 9 || F2 === 11 || F2 === 12 || F2 === 160 || F2 >= 5760 && a2.indexOf(F2) >= 0;
          }
          function g2(F2) {
            return F2 === 10 || F2 === 13 || F2 === 8232 || F2 === 8233;
          }
          function c2(F2) {
            if (F2 <= 65535)
              return String.fromCharCode(F2);
            var A2 = String.fromCharCode(Math.floor((F2 - 65536) / 1024) + 55296), N2 = String.fromCharCode((F2 - 65536) % 1024 + 56320);
            return A2 + N2;
          }
          for (n2 = new Array(128), i2 = 0; i2 < 128; ++i2)
            n2[i2] = i2 >= 97 && i2 <= 122 || i2 >= 65 && i2 <= 90 || i2 === 36 || i2 === 95;
          for (u2 = new Array(128), i2 = 0; i2 < 128; ++i2)
            u2[i2] = i2 >= 97 && i2 <= 122 || i2 >= 65 && i2 <= 90 || i2 >= 48 && i2 <= 57 || i2 === 36 || i2 === 95;
          function D2(F2) {
            return F2 < 128 ? n2[F2] : s2.NonAsciiIdentifierStart.test(c2(F2));
          }
          function E2(F2) {
            return F2 < 128 ? u2[F2] : s2.NonAsciiIdentifierPart.test(c2(F2));
          }
          function _2(F2) {
            return F2 < 128 ? n2[F2] : t2.NonAsciiIdentifierStart.test(c2(F2));
          }
          function w2(F2) {
            return F2 < 128 ? u2[F2] : t2.NonAsciiIdentifierPart.test(c2(F2));
          }
          r2.exports = { isDecimalDigit: l2, isHexDigit: p2, isOctalDigit: d2, isWhiteSpace: y2, isLineTerminator: g2, isIdentifierStartES5: D2, isIdentifierPartES5: E2, isIdentifierStartES6: _2, isIdentifierPartES6: w2 };
        }();
      } }), zm2 = Z2({ "node_modules/esutils/lib/keyword.js"(e25, r2) {
        ne2(), function() {
          var t2 = so2();
          function s2(D2) {
            switch (D2) {
              case "implements":
              case "interface":
              case "package":
              case "private":
              case "protected":
              case "public":
              case "static":
              case "let":
                return true;
              default:
                return false;
            }
          }
          function a2(D2, E2) {
            return !E2 && D2 === "yield" ? false : n2(D2, E2);
          }
          function n2(D2, E2) {
            if (E2 && s2(D2))
              return true;
            switch (D2.length) {
              case 2:
                return D2 === "if" || D2 === "in" || D2 === "do";
              case 3:
                return D2 === "var" || D2 === "for" || D2 === "new" || D2 === "try";
              case 4:
                return D2 === "this" || D2 === "else" || D2 === "case" || D2 === "void" || D2 === "with" || D2 === "enum";
              case 5:
                return D2 === "while" || D2 === "break" || D2 === "catch" || D2 === "throw" || D2 === "const" || D2 === "yield" || D2 === "class" || D2 === "super";
              case 6:
                return D2 === "return" || D2 === "typeof" || D2 === "delete" || D2 === "switch" || D2 === "export" || D2 === "import";
              case 7:
                return D2 === "default" || D2 === "finally" || D2 === "extends";
              case 8:
                return D2 === "function" || D2 === "continue" || D2 === "debugger";
              case 10:
                return D2 === "instanceof";
              default:
                return false;
            }
          }
          function u2(D2, E2) {
            return D2 === "null" || D2 === "true" || D2 === "false" || a2(D2, E2);
          }
          function i2(D2, E2) {
            return D2 === "null" || D2 === "true" || D2 === "false" || n2(D2, E2);
          }
          function l2(D2) {
            return D2 === "eval" || D2 === "arguments";
          }
          function p2(D2) {
            var E2, _2, w2;
            if (D2.length === 0 || (w2 = D2.charCodeAt(0), !t2.isIdentifierStartES5(w2)))
              return false;
            for (E2 = 1, _2 = D2.length; E2 < _2; ++E2)
              if (w2 = D2.charCodeAt(E2), !t2.isIdentifierPartES5(w2))
                return false;
            return true;
          }
          function d2(D2, E2) {
            return (D2 - 55296) * 1024 + (E2 - 56320) + 65536;
          }
          function y2(D2) {
            var E2, _2, w2, F2, A2;
            if (D2.length === 0)
              return false;
            for (A2 = t2.isIdentifierStartES6, E2 = 0, _2 = D2.length; E2 < _2; ++E2) {
              if (w2 = D2.charCodeAt(E2), 55296 <= w2 && w2 <= 56319) {
                if (++E2, E2 >= _2 || (F2 = D2.charCodeAt(E2), !(56320 <= F2 && F2 <= 57343)))
                  return false;
                w2 = d2(w2, F2);
              }
              if (!A2(w2))
                return false;
              A2 = t2.isIdentifierPartES6;
            }
            return true;
          }
          function g2(D2, E2) {
            return p2(D2) && !u2(D2, E2);
          }
          function c2(D2, E2) {
            return y2(D2) && !i2(D2, E2);
          }
          r2.exports = { isKeywordES5: a2, isKeywordES6: n2, isReservedWordES5: u2, isReservedWordES6: i2, isRestrictedWord: l2, isIdentifierNameES5: p2, isIdentifierNameES6: y2, isIdentifierES5: g2, isIdentifierES6: c2 };
        }();
      } }), Xm2 = Z2({ "node_modules/esutils/lib/utils.js"(e25) {
        ne2(), function() {
          e25.ast = Jm2(), e25.code = so2(), e25.keyword = zm2();
        }();
      } }), Ot2 = Z2({ "src/language-js/utils/is-block-comment.js"(e25, r2) {
        ne2();
        var t2 = new Set(["Block", "CommentBlock", "MultiLine"]), s2 = (a2) => t2.has(a2 == null ? void 0 : a2.type);
        r2.exports = s2;
      } }), Km2 = Z2({ "src/language-js/utils/is-node-matches.js"(e25, r2) {
        ne2();
        function t2(a2, n2) {
          let u2 = n2.split(".");
          for (let i2 = u2.length - 1; i2 >= 0; i2--) {
            let l2 = u2[i2];
            if (i2 === 0)
              return a2.type === "Identifier" && a2.name === l2;
            if (a2.type !== "MemberExpression" || a2.optional || a2.computed || a2.property.type !== "Identifier" || a2.property.name !== l2)
              return false;
            a2 = a2.object;
          }
        }
        function s2(a2, n2) {
          return n2.some((u2) => t2(a2, u2));
        }
        r2.exports = s2;
      } }), Ke2 = Z2({ "src/language-js/utils/index.js"(e25, r2) {
        ne2();
        var t2 = Xm2().keyword.isIdentifierNameES5, { getLast: s2, hasNewline: a2, skipWhitespace: n2, isNonEmptyArray: u2, isNextLineEmptyAfterIndex: i2, getStringWidth: l2 } = Ue2(), { locStart: p2, locEnd: d2, hasSameLocStart: y2 } = ut2(), g2 = Ot2(), c2 = Km2(), D2 = "(?:(?=.)\\s)", E2 = new RegExp(`^${D2}*:`), _2 = new RegExp(`^${D2}*::`);
        function w2(O2) {
          var me2, Pe2;
          return ((me2 = O2.extra) === null || me2 === void 0 ? void 0 : me2.parenthesized) && g2((Pe2 = O2.trailingComments) === null || Pe2 === void 0 ? void 0 : Pe2[0]) && E2.test(O2.trailingComments[0].value);
        }
        function F2(O2) {
          let me2 = O2 == null ? void 0 : O2[0];
          return g2(me2) && _2.test(me2.value);
        }
        function A2(O2, me2) {
          if (!O2 || typeof O2 != "object")
            return false;
          if (Array.isArray(O2))
            return O2.some((He2) => A2(He2, me2));
          let Pe2 = me2(O2);
          return typeof Pe2 == "boolean" ? Pe2 : Object.values(O2).some((He2) => A2(He2, me2));
        }
        function N2(O2) {
          return O2.type === "AssignmentExpression" || O2.type === "BinaryExpression" || O2.type === "LogicalExpression" || O2.type === "NGPipeExpression" || O2.type === "ConditionalExpression" || de2(O2) || ie2(O2) || O2.type === "SequenceExpression" || O2.type === "TaggedTemplateExpression" || O2.type === "BindExpression" || O2.type === "UpdateExpression" && !O2.prefix || st2(O2) || O2.type === "TSNonNullExpression";
        }
        function I2(O2) {
          var me2, Pe2, He2, Ge2, it2, Qe2;
          return O2.expressions ? O2.expressions[0] : (me2 = (Pe2 = (He2 = (Ge2 = (it2 = (Qe2 = O2.left) !== null && Qe2 !== void 0 ? Qe2 : O2.test) !== null && it2 !== void 0 ? it2 : O2.callee) !== null && Ge2 !== void 0 ? Ge2 : O2.object) !== null && He2 !== void 0 ? He2 : O2.tag) !== null && Pe2 !== void 0 ? Pe2 : O2.argument) !== null && me2 !== void 0 ? me2 : O2.expression;
        }
        function P2(O2, me2) {
          if (me2.expressions)
            return ["expressions", 0];
          if (me2.left)
            return ["left"];
          if (me2.test)
            return ["test"];
          if (me2.object)
            return ["object"];
          if (me2.callee)
            return ["callee"];
          if (me2.tag)
            return ["tag"];
          if (me2.argument)
            return ["argument"];
          if (me2.expression)
            return ["expression"];
          throw new Error("Unexpected node has no left side.");
        }
        function H2(O2) {
          return O2 = new Set(O2), (me2) => O2.has(me2 == null ? void 0 : me2.type);
        }
        var f2 = H2(["Line", "CommentLine", "SingleLine", "HashbangComment", "HTMLOpen", "HTMLClose"]), b2 = H2(["ExportDefaultDeclaration", "ExportDefaultSpecifier", "DeclareExportDeclaration", "ExportNamedDeclaration", "ExportAllDeclaration"]);
        function m2(O2) {
          let me2 = O2.getParentNode();
          return O2.getName() === "declaration" && b2(me2) ? me2 : null;
        }
        var v2 = H2(["BooleanLiteral", "DirectiveLiteral", "Literal", "NullLiteral", "NumericLiteral", "BigIntLiteral", "DecimalLiteral", "RegExpLiteral", "StringLiteral", "TemplateLiteral", "TSTypeLiteral", "JSXText"]);
        function o2(O2) {
          return O2.type === "NumericLiteral" || O2.type === "Literal" && typeof O2.value == "number";
        }
        function h2(O2) {
          return O2.type === "UnaryExpression" && (O2.operator === "+" || O2.operator === "-") && o2(O2.argument);
        }
        function C2(O2) {
          return O2.type === "StringLiteral" || O2.type === "Literal" && typeof O2.value == "string";
        }
        var S2 = H2(["ObjectTypeAnnotation", "TSTypeLiteral", "TSMappedType"]), x2 = H2(["FunctionExpression", "ArrowFunctionExpression"]);
        function T2(O2) {
          return O2.type === "FunctionExpression" || O2.type === "ArrowFunctionExpression" && O2.body.type === "BlockStatement";
        }
        function k2(O2) {
          return de2(O2) && O2.callee.type === "Identifier" && ["async", "inject", "fakeAsync", "waitForAsync"].includes(O2.callee.name);
        }
        var M2 = H2(["JSXElement", "JSXFragment"]);
        function R2(O2, me2) {
          if (O2.parentParser !== "markdown" && O2.parentParser !== "mdx")
            return false;
          let Pe2 = me2.getNode();
          if (!Pe2.expression || !M2(Pe2.expression))
            return false;
          let He2 = me2.getParentNode();
          return He2.type === "Program" && He2.body.length === 1;
        }
        function q2(O2) {
          return O2.kind === "get" || O2.kind === "set";
        }
        function U2(O2) {
          return q2(O2) || y2(O2, O2.value);
        }
        function L2(O2) {
          return (O2.type === "ObjectTypeProperty" || O2.type === "ObjectTypeInternalSlot") && O2.value.type === "FunctionTypeAnnotation" && !O2.static && !U2(O2);
        }
        function Y2(O2) {
          return (O2.type === "TypeAnnotation" || O2.type === "TSTypeAnnotation") && O2.typeAnnotation.type === "FunctionTypeAnnotation" && !O2.static && !y2(O2, O2.typeAnnotation);
        }
        var V2 = H2(["BinaryExpression", "LogicalExpression", "NGPipeExpression"]);
        function j2(O2) {
          return ie2(O2) || O2.type === "BindExpression" && Boolean(O2.object);
        }
        var K2 = new Set(["AnyTypeAnnotation", "TSAnyKeyword", "NullLiteralTypeAnnotation", "TSNullKeyword", "ThisTypeAnnotation", "TSThisType", "NumberTypeAnnotation", "TSNumberKeyword", "VoidTypeAnnotation", "TSVoidKeyword", "BooleanTypeAnnotation", "TSBooleanKeyword", "BigIntTypeAnnotation", "TSBigIntKeyword", "SymbolTypeAnnotation", "TSSymbolKeyword", "StringTypeAnnotation", "TSStringKeyword", "BooleanLiteralTypeAnnotation", "StringLiteralTypeAnnotation", "BigIntLiteralTypeAnnotation", "NumberLiteralTypeAnnotation", "TSLiteralType", "TSTemplateLiteralType", "EmptyTypeAnnotation", "MixedTypeAnnotation", "TSNeverKeyword", "TSObjectKeyword", "TSUndefinedKeyword", "TSUnknownKeyword"]);
        function se2(O2) {
          return O2 ? !!((O2.type === "GenericTypeAnnotation" || O2.type === "TSTypeReference") && !O2.typeParameters || K2.has(O2.type)) : false;
        }
        function Q2(O2) {
          let me2 = /^(?:before|after)(?:Each|All)$/;
          return O2.callee.type === "Identifier" && me2.test(O2.callee.name) && O2.arguments.length === 1;
        }
        var ce2 = ["it", "it.only", "it.skip", "describe", "describe.only", "describe.skip", "test", "test.only", "test.skip", "test.step", "test.describe", "test.describe.only", "test.describe.parallel", "test.describe.parallel.only", "test.describe.serial", "test.describe.serial.only", "skip", "xit", "xdescribe", "xtest", "fit", "fdescribe", "ftest"];
        function W2(O2) {
          return c2(O2, ce2);
        }
        function X2(O2, me2) {
          if (O2.type !== "CallExpression")
            return false;
          if (O2.arguments.length === 1) {
            if (k2(O2) && me2 && X2(me2))
              return x2(O2.arguments[0]);
            if (Q2(O2))
              return k2(O2.arguments[0]);
          } else if ((O2.arguments.length === 2 || O2.arguments.length === 3) && (O2.arguments[0].type === "TemplateLiteral" || C2(O2.arguments[0])) && W2(O2.callee))
            return O2.arguments[2] && !o2(O2.arguments[2]) ? false : (O2.arguments.length === 2 ? x2(O2.arguments[1]) : T2(O2.arguments[1]) && he2(O2.arguments[1]).length <= 1) || k2(O2.arguments[1]);
          return false;
        }
        var de2 = H2(["CallExpression", "OptionalCallExpression"]), ie2 = H2(["MemberExpression", "OptionalMemberExpression"]);
        function Ee2(O2) {
          let me2 = "expressions";
          O2.type === "TSTemplateLiteralType" && (me2 = "types");
          let Pe2 = O2[me2];
          return Pe2.length === 0 ? false : Pe2.every((He2) => {
            if (Re2(He2))
              return false;
            if (He2.type === "Identifier" || He2.type === "ThisExpression")
              return true;
            if (ie2(He2)) {
              let Ge2 = He2;
              for (; ie2(Ge2); )
                if (Ge2.property.type !== "Identifier" && Ge2.property.type !== "Literal" && Ge2.property.type !== "StringLiteral" && Ge2.property.type !== "NumericLiteral" || (Ge2 = Ge2.object, Re2(Ge2)))
                  return false;
              return Ge2.type === "Identifier" || Ge2.type === "ThisExpression";
            }
            return false;
          });
        }
        function z2(O2, me2) {
          return O2 === "+" || O2 === "-" ? O2 + me2 : me2;
        }
        function ue2(O2, me2) {
          let Pe2 = p2(me2), He2 = n2(O2, d2(me2));
          return He2 !== false && O2.slice(Pe2, Pe2 + 2) === "/*" && O2.slice(He2, He2 + 2) === "*/";
        }
        function J2(O2, me2) {
          return M2(me2) ? je2(me2) : Re2(me2, Be2.Leading, (Pe2) => a2(O2, d2(Pe2)));
        }
        function le2(O2, me2) {
          return me2.parser !== "json" && C2(O2.key) && De2(O2.key).slice(1, -1) === O2.key.value && (t2(O2.key.value) && !(me2.parser === "babel-ts" && O2.type === "ClassProperty" || me2.parser === "typescript" && O2.type === "PropertyDefinition") || ge2(O2.key.value) && String(Number(O2.key.value)) === O2.key.value && (me2.parser === "babel" || me2.parser === "acorn" || me2.parser === "espree" || me2.parser === "meriyah" || me2.parser === "__babel_estree"));
        }
        function ge2(O2) {
          return /^(?:\d+|\d+\.\d+)$/.test(O2);
        }
        function pe2(O2, me2) {
          let Pe2 = /^[fx]?(?:describe|it|test)$/;
          return me2.type === "TaggedTemplateExpression" && me2.quasi === O2 && me2.tag.type === "MemberExpression" && me2.tag.property.type === "Identifier" && me2.tag.property.name === "each" && (me2.tag.object.type === "Identifier" && Pe2.test(me2.tag.object.name) || me2.tag.object.type === "MemberExpression" && me2.tag.object.property.type === "Identifier" && (me2.tag.object.property.name === "only" || me2.tag.object.property.name === "skip") && me2.tag.object.object.type === "Identifier" && Pe2.test(me2.tag.object.object.name));
        }
        function Ae2(O2) {
          return O2.quasis.some((me2) => me2.value.raw.includes(`
`));
        }
        function Ce2(O2, me2) {
          return (O2.type === "TemplateLiteral" && Ae2(O2) || O2.type === "TaggedTemplateExpression" && Ae2(O2.quasi)) && !a2(me2, p2(O2), { backwards: true });
        }
        function Oe2(O2) {
          if (!Re2(O2))
            return false;
          let me2 = s2(ae2(O2, Be2.Dangling));
          return me2 && !g2(me2);
        }
        function Ie2(O2) {
          if (O2.length <= 1)
            return false;
          let me2 = 0;
          for (let Pe2 of O2)
            if (x2(Pe2)) {
              if (me2 += 1, me2 > 1)
                return true;
            } else if (de2(Pe2)) {
              for (let He2 of Pe2.arguments)
                if (x2(He2))
                  return true;
            }
          return false;
        }
        function we2(O2) {
          let me2 = O2.getValue(), Pe2 = O2.getParentNode();
          return de2(me2) && de2(Pe2) && Pe2.callee === me2 && me2.arguments.length > Pe2.arguments.length && Pe2.arguments.length > 0;
        }
        function _e2(O2, me2) {
          if (me2 >= 2)
            return false;
          let Pe2 = (Qe2) => _e2(Qe2, me2 + 1), He2 = O2.type === "Literal" && "regex" in O2 && O2.regex.pattern || O2.type === "RegExpLiteral" && O2.pattern;
          if (He2 && l2(He2) > 5)
            return false;
          if (O2.type === "Literal" || O2.type === "BigIntLiteral" || O2.type === "DecimalLiteral" || O2.type === "BooleanLiteral" || O2.type === "NullLiteral" || O2.type === "NumericLiteral" || O2.type === "RegExpLiteral" || O2.type === "StringLiteral" || O2.type === "Identifier" || O2.type === "ThisExpression" || O2.type === "Super" || O2.type === "PrivateName" || O2.type === "PrivateIdentifier" || O2.type === "ArgumentPlaceholder" || O2.type === "Import")
            return true;
          if (O2.type === "TemplateLiteral")
            return O2.quasis.every((Qe2) => !Qe2.value.raw.includes(`
`)) && O2.expressions.every(Pe2);
          if (O2.type === "ObjectExpression")
            return O2.properties.every((Qe2) => !Qe2.computed && (Qe2.shorthand || Qe2.value && Pe2(Qe2.value)));
          if (O2.type === "ArrayExpression")
            return O2.elements.every((Qe2) => Qe2 === null || Pe2(Qe2));
          if (tt2(O2))
            return (O2.type === "ImportExpression" || _e2(O2.callee, me2)) && Ye2(O2).every(Pe2);
          if (ie2(O2))
            return _e2(O2.object, me2) && _e2(O2.property, me2);
          let Ge2 = { "!": true, "-": true, "+": true, "~": true };
          if (O2.type === "UnaryExpression" && Ge2[O2.operator])
            return _e2(O2.argument, me2);
          let it2 = { "++": true, "--": true };
          return O2.type === "UpdateExpression" && it2[O2.operator] ? _e2(O2.argument, me2) : O2.type === "TSNonNullExpression" ? _e2(O2.expression, me2) : false;
        }
        function De2(O2) {
          var me2, Pe2;
          return (me2 = (Pe2 = O2.extra) === null || Pe2 === void 0 ? void 0 : Pe2.raw) !== null && me2 !== void 0 ? me2 : O2.raw;
        }
        function G2(O2) {
          return O2;
        }
        function oe2(O2) {
          return O2.filepath && /\.tsx$/i.test(O2.filepath);
        }
        function ee2(O2) {
          let me2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "es5";
          return O2.trailingComma === "es5" && me2 === "es5" || O2.trailingComma === "all" && (me2 === "all" || me2 === "es5");
        }
        function re2(O2, me2) {
          switch (O2.type) {
            case "BinaryExpression":
            case "LogicalExpression":
            case "AssignmentExpression":
            case "NGPipeExpression":
              return re2(O2.left, me2);
            case "MemberExpression":
            case "OptionalMemberExpression":
              return re2(O2.object, me2);
            case "TaggedTemplateExpression":
              return O2.tag.type === "FunctionExpression" ? false : re2(O2.tag, me2);
            case "CallExpression":
            case "OptionalCallExpression":
              return O2.callee.type === "FunctionExpression" ? false : re2(O2.callee, me2);
            case "ConditionalExpression":
              return re2(O2.test, me2);
            case "UpdateExpression":
              return !O2.prefix && re2(O2.argument, me2);
            case "BindExpression":
              return O2.object && re2(O2.object, me2);
            case "SequenceExpression":
              return re2(O2.expressions[0], me2);
            case "TSSatisfiesExpression":
            case "TSAsExpression":
            case "TSNonNullExpression":
              return re2(O2.expression, me2);
            default:
              return me2(O2);
          }
        }
        var be2 = { "==": true, "!=": true, "===": true, "!==": true }, ve2 = { "*": true, "/": true, "%": true }, fe2 = { ">>": true, ">>>": true, "<<": true };
        function B2(O2, me2) {
          return !(te2(me2) !== te2(O2) || O2 === "**" || be2[O2] && be2[me2] || me2 === "%" && ve2[O2] || O2 === "%" && ve2[me2] || me2 !== O2 && ve2[me2] && ve2[O2] || fe2[O2] && fe2[me2]);
        }
        var $2 = new Map([["|>"], ["??"], ["||"], ["&&"], ["|"], ["^"], ["&"], ["==", "===", "!=", "!=="], ["<", ">", "<=", ">=", "in", "instanceof"], [">>", "<<", ">>>"], ["+", "-"], ["*", "/", "%"], ["**"]].flatMap((O2, me2) => O2.map((Pe2) => [Pe2, me2])));
        function te2(O2) {
          return $2.get(O2);
        }
        function ye2(O2) {
          return Boolean(fe2[O2]) || O2 === "|" || O2 === "^" || O2 === "&";
        }
        function Fe2(O2) {
          var me2;
          if (O2.rest)
            return true;
          let Pe2 = he2(O2);
          return ((me2 = s2(Pe2)) === null || me2 === void 0 ? void 0 : me2.type) === "RestElement";
        }
        var Ne2 = new WeakMap();
        function he2(O2) {
          if (Ne2.has(O2))
            return Ne2.get(O2);
          let me2 = [];
          return O2.this && me2.push(O2.this), Array.isArray(O2.parameters) ? me2.push(...O2.parameters) : Array.isArray(O2.params) && me2.push(...O2.params), O2.rest && me2.push(O2.rest), Ne2.set(O2, me2), me2;
        }
        function ze2(O2, me2) {
          let Pe2 = O2.getValue(), He2 = 0, Ge2 = (it2) => me2(it2, He2++);
          Pe2.this && O2.call(Ge2, "this"), Array.isArray(Pe2.parameters) ? O2.each(Ge2, "parameters") : Array.isArray(Pe2.params) && O2.each(Ge2, "params"), Pe2.rest && O2.call(Ge2, "rest");
        }
        var Te2 = new WeakMap();
        function Ye2(O2) {
          if (Te2.has(O2))
            return Te2.get(O2);
          let me2 = O2.arguments;
          return O2.type === "ImportExpression" && (me2 = [O2.source], O2.attributes && me2.push(O2.attributes)), Te2.set(O2, me2), me2;
        }
        function Se2(O2, me2) {
          let Pe2 = O2.getValue();
          Pe2.type === "ImportExpression" ? (O2.call((He2) => me2(He2, 0), "source"), Pe2.attributes && O2.call((He2) => me2(He2, 1), "attributes")) : O2.each(me2, "arguments");
        }
        function ke2(O2) {
          return O2.value.trim() === "prettier-ignore" && !O2.unignore;
        }
        function je2(O2) {
          return O2 && (O2.prettierIgnore || Re2(O2, Be2.PrettierIgnore));
        }
        function Je2(O2) {
          let me2 = O2.getValue();
          return je2(me2);
        }
        var Be2 = { Leading: 1 << 1, Trailing: 1 << 2, Dangling: 1 << 3, Block: 1 << 4, Line: 1 << 5, PrettierIgnore: 1 << 6, First: 1 << 7, Last: 1 << 8 }, qe2 = (O2, me2) => {
          if (typeof O2 == "function" && (me2 = O2, O2 = 0), O2 || me2)
            return (Pe2, He2, Ge2) => !(O2 & Be2.Leading && !Pe2.leading || O2 & Be2.Trailing && !Pe2.trailing || O2 & Be2.Dangling && (Pe2.leading || Pe2.trailing) || O2 & Be2.Block && !g2(Pe2) || O2 & Be2.Line && !f2(Pe2) || O2 & Be2.First && He2 !== 0 || O2 & Be2.Last && He2 !== Ge2.length - 1 || O2 & Be2.PrettierIgnore && !ke2(Pe2) || me2 && !me2(Pe2));
        };
        function Re2(O2, me2, Pe2) {
          if (!u2(O2 == null ? void 0 : O2.comments))
            return false;
          let He2 = qe2(me2, Pe2);
          return He2 ? O2.comments.some(He2) : true;
        }
        function ae2(O2, me2, Pe2) {
          if (!Array.isArray(O2 == null ? void 0 : O2.comments))
            return [];
          let He2 = qe2(me2, Pe2);
          return He2 ? O2.comments.filter(He2) : O2.comments;
        }
        var nt2 = (O2, me2) => {
          let { originalText: Pe2 } = me2;
          return i2(Pe2, d2(O2));
        };
        function tt2(O2) {
          return de2(O2) || O2.type === "NewExpression" || O2.type === "ImportExpression";
        }
        function Ve2(O2) {
          return O2 && (O2.type === "ObjectProperty" || O2.type === "Property" && !O2.method && O2.kind === "init");
        }
        function We2(O2) {
          return Boolean(O2.__isUsingHackPipeline);
        }
        var Xe2 = Symbol("ifWithoutBlockAndSameLineComment");
        function st2(O2) {
          return O2.type === "TSAsExpression" || O2.type === "TSSatisfiesExpression";
        }
        r2.exports = { getFunctionParameters: he2, iterateFunctionParametersPath: ze2, getCallArguments: Ye2, iterateCallArgumentsPath: Se2, hasRestParameter: Fe2, getLeftSide: I2, getLeftSidePathName: P2, getParentExportDeclaration: m2, getTypeScriptMappedTypeModifier: z2, hasFlowAnnotationComment: F2, hasFlowShorthandAnnotationComment: w2, hasLeadingOwnLineComment: J2, hasNakedLeftSide: N2, hasNode: A2, hasIgnoreComment: Je2, hasNodeIgnoreComment: je2, identity: G2, isBinaryish: V2, isCallLikeExpression: tt2, isEnabledHackPipeline: We2, isLineComment: f2, isPrettierIgnoreComment: ke2, isCallExpression: de2, isMemberExpression: ie2, isExportDeclaration: b2, isFlowAnnotationComment: ue2, isFunctionCompositionArgs: Ie2, isFunctionNotation: U2, isFunctionOrArrowExpression: x2, isGetterOrSetter: q2, isJestEachTemplateLiteral: pe2, isJsxNode: M2, isLiteral: v2, isLongCurriedCallExpression: we2, isSimpleCallArgument: _e2, isMemberish: j2, isNumericLiteral: o2, isSignedNumericLiteral: h2, isObjectProperty: Ve2, isObjectType: S2, isObjectTypePropertyAFunction: L2, isSimpleType: se2, isSimpleNumber: ge2, isSimpleTemplateLiteral: Ee2, isStringLiteral: C2, isStringPropSafeToUnquote: le2, isTemplateOnItsOwnLine: Ce2, isTestCall: X2, isTheOnlyJsxElementInMarkdown: R2, isTSXFile: oe2, isTypeAnnotationAFunction: Y2, isNextLineEmpty: nt2, needsHardlineAfterDanglingComment: Oe2, rawText: De2, shouldPrintComma: ee2, isBitwiseOperator: ye2, shouldFlatten: B2, startsWithNoLookaheadToken: re2, getPrecedence: te2, hasComment: Re2, getComments: ae2, CommentCheckFlags: Be2, markerForIfWithoutBlockAndSameLineComment: Xe2, isTSTypeExpression: st2 };
      } }), jt2 = Z2({ "src/language-js/print/template-literal.js"(e25, r2) {
        ne2();
        var t2 = lt2(), { getStringWidth: s2, getIndentSize: a2 } = Ue2(), { builders: { join: n2, hardline: u2, softline: i2, group: l2, indent: p2, align: d2, lineSuffixBoundary: y2, addAlignmentToDoc: g2 }, printer: { printDocToString: c2 }, utils: { mapDoc: D2 } } = Me2(), { isBinaryish: E2, isJestEachTemplateLiteral: _2, isSimpleTemplateLiteral: w2, hasComment: F2, isMemberExpression: A2, isTSTypeExpression: N2 } = Ke2();
        function I2(v2, o2, h2) {
          let C2 = v2.getValue();
          if (C2.type === "TemplateLiteral" && _2(C2, v2.getParentNode())) {
            let R2 = P2(v2, h2, o2);
            if (R2)
              return R2;
          }
          let x2 = "expressions";
          C2.type === "TSTemplateLiteralType" && (x2 = "types");
          let T2 = [], k2 = v2.map(o2, x2), M2 = w2(C2);
          return M2 && (k2 = k2.map((R2) => c2(R2, Object.assign(Object.assign({}, h2), {}, { printWidth: Number.POSITIVE_INFINITY })).formatted)), T2.push(y2, "`"), v2.each((R2) => {
            let q2 = R2.getName();
            if (T2.push(o2()), q2 < k2.length) {
              let { tabWidth: U2 } = h2, L2 = R2.getValue(), Y2 = a2(L2.value.raw, U2), V2 = k2[q2];
              if (!M2) {
                let K2 = C2[x2][q2];
                (F2(K2) || A2(K2) || K2.type === "ConditionalExpression" || K2.type === "SequenceExpression" || N2(K2) || E2(K2)) && (V2 = [p2([i2, V2]), i2]);
              }
              let j2 = Y2 === 0 && L2.value.raw.endsWith(`
`) ? d2(Number.NEGATIVE_INFINITY, V2) : g2(V2, Y2, U2);
              T2.push(l2(["${", j2, y2, "}"]));
            }
          }, "quasis"), T2.push("`"), T2;
        }
        function P2(v2, o2, h2) {
          let C2 = v2.getNode(), S2 = C2.quasis[0].value.raw.trim().split(/\s*\|\s*/);
          if (S2.length > 1 || S2.some((x2) => x2.length > 0)) {
            o2.__inJestEach = true;
            let x2 = v2.map(h2, "expressions");
            o2.__inJestEach = false;
            let T2 = [], k2 = x2.map((L2) => "${" + c2(L2, Object.assign(Object.assign({}, o2), {}, { printWidth: Number.POSITIVE_INFINITY, endOfLine: "lf" })).formatted + "}"), M2 = [{ hasLineBreak: false, cells: [] }];
            for (let L2 = 1; L2 < C2.quasis.length; L2++) {
              let Y2 = t2(M2), V2 = k2[L2 - 1];
              Y2.cells.push(V2), V2.includes(`
`) && (Y2.hasLineBreak = true), C2.quasis[L2].value.raw.includes(`
`) && M2.push({ hasLineBreak: false, cells: [] });
            }
            let R2 = Math.max(S2.length, ...M2.map((L2) => L2.cells.length)), q2 = Array.from({ length: R2 }).fill(0), U2 = [{ cells: S2 }, ...M2.filter((L2) => L2.cells.length > 0)];
            for (let { cells: L2 } of U2.filter((Y2) => !Y2.hasLineBreak))
              for (let [Y2, V2] of L2.entries())
                q2[Y2] = Math.max(q2[Y2], s2(V2));
            return T2.push(y2, "`", p2([u2, n2(u2, U2.map((L2) => n2(" | ", L2.cells.map((Y2, V2) => L2.hasLineBreak ? Y2 : Y2 + " ".repeat(q2[V2] - s2(Y2))))))]), u2, "`"), T2;
          }
        }
        function H2(v2, o2) {
          let h2 = v2.getValue(), C2 = o2();
          return F2(h2) && (C2 = l2([p2([i2, C2]), i2])), ["${", C2, y2, "}"];
        }
        function f2(v2, o2) {
          return v2.map((h2) => H2(h2, o2), "expressions");
        }
        function b2(v2, o2) {
          return D2(v2, (h2) => typeof h2 == "string" ? o2 ? h2.replace(/(\\*)`/g, "$1$1\\`") : m2(h2) : h2);
        }
        function m2(v2) {
          return v2.replace(/([\\`]|\${)/g, "\\$1");
        }
        r2.exports = { printTemplateLiteral: I2, printTemplateExpressions: f2, escapeTemplateCharacters: b2, uncookTemplateElementValue: m2 };
      } }), Ym2 = Z2({ "src/language-js/embed/markdown.js"(e25, r2) {
        ne2();
        var { builders: { indent: t2, softline: s2, literalline: a2, dedentToRoot: n2 } } = Me2(), { escapeTemplateCharacters: u2 } = jt2();
        function i2(p2, d2, y2) {
          let c2 = p2.getValue().quasis[0].value.raw.replace(/((?:\\\\)*)\\`/g, (w2, F2) => "\\".repeat(F2.length / 2) + "`"), D2 = l2(c2), E2 = D2 !== "";
          E2 && (c2 = c2.replace(new RegExp(`^${D2}`, "gm"), ""));
          let _2 = u2(y2(c2, { parser: "markdown", __inJsTemplate: true }, { stripTrailingHardline: true }), true);
          return ["`", E2 ? t2([s2, _2]) : [a2, n2(_2)], s2, "`"];
        }
        function l2(p2) {
          let d2 = p2.match(/^([^\S\n]*)\S/m);
          return d2 === null ? "" : d2[1];
        }
        r2.exports = i2;
      } }), Qm2 = Z2({ "src/language-js/embed/css.js"(e25, r2) {
        ne2();
        var { isNonEmptyArray: t2 } = Ue2(), { builders: { indent: s2, hardline: a2, softline: n2 }, utils: { mapDoc: u2, replaceEndOfLine: i2, cleanDoc: l2 } } = Me2(), { printTemplateExpressions: p2 } = jt2();
        function d2(c2, D2, E2) {
          let _2 = c2.getValue(), w2 = _2.quasis.map((P2) => P2.value.raw), F2 = 0, A2 = w2.reduce((P2, H2, f2) => f2 === 0 ? H2 : P2 + "@prettier-placeholder-" + F2++ + "-id" + H2, ""), N2 = E2(A2, { parser: "scss" }, { stripTrailingHardline: true }), I2 = p2(c2, D2);
          return y2(N2, _2, I2);
        }
        function y2(c2, D2, E2) {
          if (D2.quasis.length === 1 && !D2.quasis[0].value.raw.trim())
            return "``";
          let w2 = g2(c2, E2);
          if (!w2)
            throw new Error("Couldn't insert all the expressions");
          return ["`", s2([a2, w2]), n2, "`"];
        }
        function g2(c2, D2) {
          if (!t2(D2))
            return c2;
          let E2 = 0, _2 = u2(l2(c2), (w2) => typeof w2 != "string" || !w2.includes("@prettier-placeholder") ? w2 : w2.split(/@prettier-placeholder-(\d+)-id/).map((F2, A2) => A2 % 2 === 0 ? i2(F2) : (E2++, D2[F2])));
          return D2.length === E2 ? _2 : null;
        }
        r2.exports = d2;
      } }), Zm2 = Z2({ "src/language-js/embed/graphql.js"(e25, r2) {
        ne2();
        var { builders: { indent: t2, join: s2, hardline: a2 } } = Me2(), { escapeTemplateCharacters: n2, printTemplateExpressions: u2 } = jt2();
        function i2(p2, d2, y2) {
          let g2 = p2.getValue(), c2 = g2.quasis.length;
          if (c2 === 1 && g2.quasis[0].value.raw.trim() === "")
            return "``";
          let D2 = u2(p2, d2), E2 = [];
          for (let _2 = 0; _2 < c2; _2++) {
            let w2 = g2.quasis[_2], F2 = _2 === 0, A2 = _2 === c2 - 1, N2 = w2.value.cooked, I2 = N2.split(`
`), P2 = I2.length, H2 = D2[_2], f2 = P2 > 2 && I2[0].trim() === "" && I2[1].trim() === "", b2 = P2 > 2 && I2[P2 - 1].trim() === "" && I2[P2 - 2].trim() === "", m2 = I2.every((o2) => /^\s*(?:#[^\n\r]*)?$/.test(o2));
            if (!A2 && /#[^\n\r]*$/.test(I2[P2 - 1]))
              return null;
            let v2 = null;
            m2 ? v2 = l2(I2) : v2 = y2(N2, { parser: "graphql" }, { stripTrailingHardline: true }), v2 ? (v2 = n2(v2, false), !F2 && f2 && E2.push(""), E2.push(v2), !A2 && b2 && E2.push("")) : !F2 && !A2 && f2 && E2.push(""), H2 && E2.push(H2);
          }
          return ["`", t2([a2, s2(a2, E2)]), a2, "`"];
        }
        function l2(p2) {
          let d2 = [], y2 = false, g2 = p2.map((c2) => c2.trim());
          for (let [c2, D2] of g2.entries())
            D2 !== "" && (g2[c2 - 1] === "" && y2 ? d2.push([a2, D2]) : d2.push(D2), y2 = true);
          return d2.length === 0 ? null : s2(a2, d2);
        }
        r2.exports = i2;
      } }), ed2 = Z2({ "src/language-js/embed/html.js"(e25, r2) {
        ne2();
        var { builders: { indent: t2, line: s2, hardline: a2, group: n2 }, utils: { mapDoc: u2 } } = Me2(), { printTemplateExpressions: i2, uncookTemplateElementValue: l2 } = jt2(), p2 = 0;
        function d2(y2, g2, c2, D2, E2) {
          let { parser: _2 } = E2, w2 = y2.getValue(), F2 = p2;
          p2 = p2 + 1 >>> 0;
          let A2 = (h2) => `PRETTIER_HTML_PLACEHOLDER_${h2}_${F2}_IN_JS`, N2 = w2.quasis.map((h2, C2, S2) => C2 === S2.length - 1 ? h2.value.cooked : h2.value.cooked + A2(C2)).join(""), I2 = i2(y2, g2);
          if (I2.length === 0 && N2.trim().length === 0)
            return "``";
          let P2 = new RegExp(A2("(\\d+)"), "g"), H2 = 0, f2 = c2(N2, { parser: _2, __onHtmlRoot(h2) {
            H2 = h2.children.length;
          } }, { stripTrailingHardline: true }), b2 = u2(f2, (h2) => {
            if (typeof h2 != "string")
              return h2;
            let C2 = [], S2 = h2.split(P2);
            for (let x2 = 0; x2 < S2.length; x2++) {
              let T2 = S2[x2];
              if (x2 % 2 === 0) {
                T2 && (T2 = l2(T2), D2.__embeddedInHtml && (T2 = T2.replace(/<\/(script)\b/gi, "<\\/$1")), C2.push(T2));
                continue;
              }
              let k2 = Number(T2);
              C2.push(I2[k2]);
            }
            return C2;
          }), m2 = /^\s/.test(N2) ? " " : "", v2 = /\s$/.test(N2) ? " " : "", o2 = D2.htmlWhitespaceSensitivity === "ignore" ? a2 : m2 && v2 ? s2 : null;
          return n2(o2 ? ["`", t2([o2, n2(b2)]), o2, "`"] : ["`", m2, H2 > 1 ? t2(n2(b2)) : n2(b2), v2, "`"]);
        }
        r2.exports = d2;
      } }), td2 = Z2({ "src/language-js/embed.js"(e25, r2) {
        ne2();
        var { hasComment: t2, CommentCheckFlags: s2, isObjectProperty: a2 } = Ke2(), n2 = Ym2(), u2 = Qm2(), i2 = Zm2(), l2 = ed2();
        function p2(f2) {
          if (g2(f2) || _2(f2) || w2(f2) || c2(f2))
            return "css";
          if (N2(f2))
            return "graphql";
          if (P2(f2))
            return "html";
          if (D2(f2))
            return "angular";
          if (y2(f2))
            return "markdown";
        }
        function d2(f2, b2, m2, v2) {
          let o2 = f2.getValue();
          if (o2.type !== "TemplateLiteral" || H2(o2))
            return;
          let h2 = p2(f2);
          if (h2) {
            if (h2 === "markdown")
              return n2(f2, b2, m2);
            if (h2 === "css")
              return u2(f2, b2, m2);
            if (h2 === "graphql")
              return i2(f2, b2, m2);
            if (h2 === "html" || h2 === "angular")
              return l2(f2, b2, m2, v2, { parser: h2 });
          }
        }
        function y2(f2) {
          let b2 = f2.getValue(), m2 = f2.getParentNode();
          return m2 && m2.type === "TaggedTemplateExpression" && b2.quasis.length === 1 && m2.tag.type === "Identifier" && (m2.tag.name === "md" || m2.tag.name === "markdown");
        }
        function g2(f2) {
          let b2 = f2.getValue(), m2 = f2.getParentNode(), v2 = f2.getParentNode(1);
          return v2 && b2.quasis && m2.type === "JSXExpressionContainer" && v2.type === "JSXElement" && v2.openingElement.name.name === "style" && v2.openingElement.attributes.some((o2) => o2.name.name === "jsx") || m2 && m2.type === "TaggedTemplateExpression" && m2.tag.type === "Identifier" && m2.tag.name === "css" || m2 && m2.type === "TaggedTemplateExpression" && m2.tag.type === "MemberExpression" && m2.tag.object.name === "css" && (m2.tag.property.name === "global" || m2.tag.property.name === "resolve");
        }
        function c2(f2) {
          return f2.match((b2) => b2.type === "TemplateLiteral", (b2, m2) => b2.type === "ArrayExpression" && m2 === "elements", (b2, m2) => a2(b2) && b2.key.type === "Identifier" && b2.key.name === "styles" && m2 === "value", ...E2);
        }
        function D2(f2) {
          return f2.match((b2) => b2.type === "TemplateLiteral", (b2, m2) => a2(b2) && b2.key.type === "Identifier" && b2.key.name === "template" && m2 === "value", ...E2);
        }
        var E2 = [(f2, b2) => f2.type === "ObjectExpression" && b2 === "properties", (f2, b2) => f2.type === "CallExpression" && f2.callee.type === "Identifier" && f2.callee.name === "Component" && b2 === "arguments", (f2, b2) => f2.type === "Decorator" && b2 === "expression"];
        function _2(f2) {
          let b2 = f2.getParentNode();
          if (!b2 || b2.type !== "TaggedTemplateExpression")
            return false;
          let m2 = b2.tag.type === "ParenthesizedExpression" ? b2.tag.expression : b2.tag;
          switch (m2.type) {
            case "MemberExpression":
              return F2(m2.object) || A2(m2);
            case "CallExpression":
              return F2(m2.callee) || m2.callee.type === "MemberExpression" && (m2.callee.object.type === "MemberExpression" && (F2(m2.callee.object.object) || A2(m2.callee.object)) || m2.callee.object.type === "CallExpression" && F2(m2.callee.object.callee));
            case "Identifier":
              return m2.name === "css";
            default:
              return false;
          }
        }
        function w2(f2) {
          let b2 = f2.getParentNode(), m2 = f2.getParentNode(1);
          return m2 && b2.type === "JSXExpressionContainer" && m2.type === "JSXAttribute" && m2.name.type === "JSXIdentifier" && m2.name.name === "css";
        }
        function F2(f2) {
          return f2.type === "Identifier" && f2.name === "styled";
        }
        function A2(f2) {
          return /^[A-Z]/.test(f2.object.name) && f2.property.name === "extend";
        }
        function N2(f2) {
          let b2 = f2.getValue(), m2 = f2.getParentNode();
          return I2(b2, "GraphQL") || m2 && (m2.type === "TaggedTemplateExpression" && (m2.tag.type === "MemberExpression" && m2.tag.object.name === "graphql" && m2.tag.property.name === "experimental" || m2.tag.type === "Identifier" && (m2.tag.name === "gql" || m2.tag.name === "graphql")) || m2.type === "CallExpression" && m2.callee.type === "Identifier" && m2.callee.name === "graphql");
        }
        function I2(f2, b2) {
          return t2(f2, s2.Block | s2.Leading, (m2) => {
            let { value: v2 } = m2;
            return v2 === ` ${b2} `;
          });
        }
        function P2(f2) {
          return I2(f2.getValue(), "HTML") || f2.match((b2) => b2.type === "TemplateLiteral", (b2, m2) => b2.type === "TaggedTemplateExpression" && b2.tag.type === "Identifier" && b2.tag.name === "html" && m2 === "quasi");
        }
        function H2(f2) {
          let { quasis: b2 } = f2;
          return b2.some((m2) => {
            let { value: { cooked: v2 } } = m2;
            return v2 === null;
          });
        }
        r2.exports = d2;
      } }), rd2 = Z2({ "src/language-js/clean.js"(e25, r2) {
        ne2();
        var t2 = Ot2(), s2 = new Set(["range", "raw", "comments", "leadingComments", "trailingComments", "innerComments", "extra", "start", "end", "loc", "flags", "errors", "tokens"]), a2 = (u2) => {
          for (let i2 of u2.quasis)
            delete i2.value;
        };
        function n2(u2, i2, l2) {
          if (u2.type === "Program" && delete i2.sourceType, (u2.type === "BigIntLiteral" || u2.type === "BigIntLiteralTypeAnnotation") && i2.value && (i2.value = i2.value.toLowerCase()), (u2.type === "BigIntLiteral" || u2.type === "Literal") && i2.bigint && (i2.bigint = i2.bigint.toLowerCase()), u2.type === "DecimalLiteral" && (i2.value = Number(i2.value)), u2.type === "Literal" && i2.decimal && (i2.decimal = Number(i2.decimal)), u2.type === "EmptyStatement" || u2.type === "JSXText" || u2.type === "JSXExpressionContainer" && (u2.expression.type === "Literal" || u2.expression.type === "StringLiteral") && u2.expression.value === " ")
            return null;
          if ((u2.type === "Property" || u2.type === "ObjectProperty" || u2.type === "MethodDefinition" || u2.type === "ClassProperty" || u2.type === "ClassMethod" || u2.type === "PropertyDefinition" || u2.type === "TSDeclareMethod" || u2.type === "TSPropertySignature" || u2.type === "ObjectTypeProperty") && typeof u2.key == "object" && u2.key && (u2.key.type === "Literal" || u2.key.type === "NumericLiteral" || u2.key.type === "StringLiteral" || u2.key.type === "Identifier") && delete i2.key, u2.type === "JSXElement" && u2.openingElement.name.name === "style" && u2.openingElement.attributes.some((y2) => y2.name.name === "jsx"))
            for (let { type: y2, expression: g2 } of i2.children)
              y2 === "JSXExpressionContainer" && g2.type === "TemplateLiteral" && a2(g2);
          u2.type === "JSXAttribute" && u2.name.name === "css" && u2.value.type === "JSXExpressionContainer" && u2.value.expression.type === "TemplateLiteral" && a2(i2.value.expression), u2.type === "JSXAttribute" && u2.value && u2.value.type === "Literal" && /["']|&quot;|&apos;/.test(u2.value.value) && (i2.value.value = i2.value.value.replace(/["']|&quot;|&apos;/g, '"'));
          let p2 = u2.expression || u2.callee;
          if (u2.type === "Decorator" && p2.type === "CallExpression" && p2.callee.name === "Component" && p2.arguments.length === 1) {
            let y2 = u2.expression.arguments[0].properties;
            for (let [g2, c2] of i2.expression.arguments[0].properties.entries())
              switch (y2[g2].key.name) {
                case "styles":
                  c2.value.type === "ArrayExpression" && a2(c2.value.elements[0]);
                  break;
                case "template":
                  c2.value.type === "TemplateLiteral" && a2(c2.value);
                  break;
              }
          }
          if (u2.type === "TaggedTemplateExpression" && (u2.tag.type === "MemberExpression" || u2.tag.type === "Identifier" && (u2.tag.name === "gql" || u2.tag.name === "graphql" || u2.tag.name === "css" || u2.tag.name === "md" || u2.tag.name === "markdown" || u2.tag.name === "html") || u2.tag.type === "CallExpression") && a2(i2.quasi), u2.type === "TemplateLiteral") {
            var d2;
            (((d2 = u2.leadingComments) === null || d2 === void 0 ? void 0 : d2.some((g2) => t2(g2) && ["GraphQL", "HTML"].some((c2) => g2.value === ` ${c2} `))) || l2.type === "CallExpression" && l2.callee.name === "graphql" || !u2.leadingComments) && a2(i2);
          }
          if (u2.type === "InterpreterDirective" && (i2.value = i2.value.trimEnd()), (u2.type === "TSIntersectionType" || u2.type === "TSUnionType") && u2.types.length === 1)
            return i2.types[0];
        }
        n2.ignoredProperties = s2, r2.exports = n2;
      } }), io2 = {};
      Kt2(io2, { EOL: () => Wn2, arch: () => nd2, cpus: () => Do, default: () => vo2, endianness: () => ao2, freemem: () => po2, getNetworkInterfaces: () => ho2, hostname: () => oo2, loadavg: () => lo2, networkInterfaces: () => yo2, platform: () => ud2, release: () => go2, tmpDir: () => $n2, tmpdir: () => Vn2, totalmem: () => fo2, type: () => mo2, uptime: () => co2 });
      function ao2() {
        if (typeof Tr2 > "u") {
          var e25 = new ArrayBuffer(2), r2 = new Uint8Array(e25), t2 = new Uint16Array(e25);
          if (r2[0] = 1, r2[1] = 2, t2[0] === 258)
            Tr2 = "BE";
          else if (t2[0] === 513)
            Tr2 = "LE";
          else
            throw new Error("unable to figure out endianess");
        }
        return Tr2;
      }
      function oo2() {
        return typeof globalThis.location < "u" ? globalThis.location.hostname : "";
      }
      function lo2() {
        return [];
      }
      function co2() {
        return 0;
      }
      function po2() {
        return Number.MAX_VALUE;
      }
      function fo2() {
        return Number.MAX_VALUE;
      }
      function Do() {
        return [];
      }
      function mo2() {
        return "Browser";
      }
      function go2() {
        return typeof globalThis.navigator < "u" ? globalThis.navigator.appVersion : "";
      }
      function yo2() {
      }
      function ho2() {
      }
      function nd2() {
        return "javascript";
      }
      function ud2() {
        return "browser";
      }
      function $n2() {
        return "/tmp";
      }
      var Tr2, Vn2, Wn2, vo2, sd2 = ht2({ "node-modules-polyfills:os"() {
        ne2(), Vn2 = $n2, Wn2 = `
`, vo2 = { EOL: Wn2, tmpdir: Vn2, tmpDir: $n2, networkInterfaces: yo2, getNetworkInterfaces: ho2, release: go2, type: mo2, cpus: Do, totalmem: fo2, freemem: po2, uptime: co2, loadavg: lo2, hostname: oo2, endianness: ao2 };
      } }), id2 = Z2({ "node-modules-polyfills-commonjs:os"(e25, r2) {
        ne2();
        var t2 = (sd2(), ft2(io2));
        if (t2 && t2.default) {
          r2.exports = t2.default;
          for (let s2 in t2)
            r2.exports[s2] = t2[s2];
        } else
          t2 && (r2.exports = t2);
      } }), ad2 = Z2({ "node_modules/detect-newline/index.js"(e25, r2) {
        ne2();
        var t2 = (s2) => {
          if (typeof s2 != "string")
            throw new TypeError("Expected a string");
          let a2 = s2.match(/(?:\r?\n)/g) || [];
          if (a2.length === 0)
            return;
          let n2 = a2.filter((i2) => i2 === `\r
`).length, u2 = a2.length - n2;
          return n2 > u2 ? `\r
` : `
`;
        };
        r2.exports = t2, r2.exports.graceful = (s2) => typeof s2 == "string" && t2(s2) || `
`;
      } }), od2 = Z2({ "node_modules/jest-docblock/build/index.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true }), e25.extract = c2, e25.parse = E2, e25.parseWithComments = _2, e25.print = w2, e25.strip = D2;
        function r2() {
          let A2 = id2();
          return r2 = function() {
            return A2;
          }, A2;
        }
        function t2() {
          let A2 = s2(ad2());
          return t2 = function() {
            return A2;
          }, A2;
        }
        function s2(A2) {
          return A2 && A2.__esModule ? A2 : { default: A2 };
        }
        var a2 = /\*\/$/, n2 = /^\/\*\*?/, u2 = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, i2 = /(^|\s+)\/\/([^\r\n]*)/g, l2 = /^(\r?\n)+/, p2 = /(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g, d2 = /(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g, y2 = /(\r?\n|^) *\* ?/g, g2 = [];
        function c2(A2) {
          let N2 = A2.match(u2);
          return N2 ? N2[0].trimLeft() : "";
        }
        function D2(A2) {
          let N2 = A2.match(u2);
          return N2 && N2[0] ? A2.substring(N2[0].length) : A2;
        }
        function E2(A2) {
          return _2(A2).pragmas;
        }
        function _2(A2) {
          let N2 = (0, t2().default)(A2) || r2().EOL;
          A2 = A2.replace(n2, "").replace(a2, "").replace(y2, "$1");
          let I2 = "";
          for (; I2 !== A2; )
            I2 = A2, A2 = A2.replace(p2, `${N2}$1 $2${N2}`);
          A2 = A2.replace(l2, "").trimRight();
          let P2 = Object.create(null), H2 = A2.replace(d2, "").replace(l2, "").trimRight(), f2;
          for (; f2 = d2.exec(A2); ) {
            let b2 = f2[2].replace(i2, "");
            typeof P2[f2[1]] == "string" || Array.isArray(P2[f2[1]]) ? P2[f2[1]] = g2.concat(P2[f2[1]], b2) : P2[f2[1]] = b2;
          }
          return { comments: H2, pragmas: P2 };
        }
        function w2(A2) {
          let { comments: N2 = "", pragmas: I2 = {} } = A2, P2 = (0, t2().default)(N2) || r2().EOL, H2 = "/**", f2 = " *", b2 = " */", m2 = Object.keys(I2), v2 = m2.map((h2) => F2(h2, I2[h2])).reduce((h2, C2) => h2.concat(C2), []).map((h2) => `${f2} ${h2}${P2}`).join("");
          if (!N2) {
            if (m2.length === 0)
              return "";
            if (m2.length === 1 && !Array.isArray(I2[m2[0]])) {
              let h2 = I2[m2[0]];
              return `${H2} ${F2(m2[0], h2)[0]}${b2}`;
            }
          }
          let o2 = N2.split(P2).map((h2) => `${f2} ${h2}`).join(P2) + P2;
          return H2 + P2 + (N2 ? o2 : "") + (N2 && m2.length ? f2 + P2 : "") + v2 + b2;
        }
        function F2(A2, N2) {
          return g2.concat(N2).map((I2) => `@${A2} ${I2}`.trim());
        }
      } }), ld2 = Z2({ "src/language-js/utils/get-shebang.js"(e25, r2) {
        ne2();
        function t2(s2) {
          if (!s2.startsWith("#!"))
            return "";
          let a2 = s2.indexOf(`
`);
          return a2 === -1 ? s2 : s2.slice(0, a2);
        }
        r2.exports = t2;
      } }), Co = Z2({ "src/language-js/pragma.js"(e25, r2) {
        ne2();
        var { parseWithComments: t2, strip: s2, extract: a2, print: n2 } = od2(), { normalizeEndOfLine: u2 } = Jn2(), i2 = ld2();
        function l2(y2) {
          let g2 = i2(y2);
          g2 && (y2 = y2.slice(g2.length + 1));
          let c2 = a2(y2), { pragmas: D2, comments: E2 } = t2(c2);
          return { shebang: g2, text: y2, pragmas: D2, comments: E2 };
        }
        function p2(y2) {
          let g2 = Object.keys(l2(y2).pragmas);
          return g2.includes("prettier") || g2.includes("format");
        }
        function d2(y2) {
          let { shebang: g2, text: c2, pragmas: D2, comments: E2 } = l2(y2), _2 = s2(c2), w2 = n2({ pragmas: Object.assign({ format: "" }, D2), comments: E2.trimStart() });
          return (g2 ? `${g2}
` : "") + u2(w2) + (_2.startsWith(`
`) ? `
` : `

`) + _2;
        }
        r2.exports = { hasPragma: p2, insertPragma: d2 };
      } }), Eo2 = Z2({ "src/language-js/comments.js"(e25, r2) {
        ne2();
        var { getLast: t2, hasNewline: s2, getNextNonSpaceNonCommentCharacterIndexWithStartIndex: a2, getNextNonSpaceNonCommentCharacter: n2, hasNewlineInRange: u2, addLeadingComment: i2, addTrailingComment: l2, addDanglingComment: p2, getNextNonSpaceNonCommentCharacterIndex: d2, isNonEmptyArray: y2 } = Ue2(), { getFunctionParameters: g2, isPrettierIgnoreComment: c2, isJsxNode: D2, hasFlowShorthandAnnotationComment: E2, hasFlowAnnotationComment: _2, hasIgnoreComment: w2, isCallLikeExpression: F2, getCallArguments: A2, isCallExpression: N2, isMemberExpression: I2, isObjectProperty: P2, isLineComment: H2, getComments: f2, CommentCheckFlags: b2, markerForIfWithoutBlockAndSameLineComment: m2 } = Ke2(), { locStart: v2, locEnd: o2 } = ut2(), h2 = Ot2();
        function C2(fe2) {
          return [De2, ie2, L2, R2, q2, U2, K2, pe2, J2, ge2, Ae2, Ce2, Q2, Ee2, z2].some((B2) => B2(fe2));
        }
        function S2(fe2) {
          return [M2, ie2, Y2, Ae2, R2, q2, U2, K2, Ee2, ue2, le2, ge2, we2, z2, oe2].some((B2) => B2(fe2));
        }
        function x2(fe2) {
          return [De2, R2, q2, V2, de2, Q2, ge2, X2, W2, G2, z2, _e2].some((B2) => B2(fe2));
        }
        function T2(fe2, B2) {
          let $2 = (fe2.body || fe2.properties).find((te2) => {
            let { type: ye2 } = te2;
            return ye2 !== "EmptyStatement";
          });
          $2 ? i2($2, B2) : p2(fe2, B2);
        }
        function k2(fe2, B2) {
          fe2.type === "BlockStatement" ? T2(fe2, B2) : i2(fe2, B2);
        }
        function M2(fe2) {
          let { comment: B2, followingNode: $2 } = fe2;
          return $2 && be2(B2) ? (i2($2, B2), true) : false;
        }
        function R2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2, followingNode: ye2, text: Fe2 } = fe2;
          if ((te2 == null ? void 0 : te2.type) !== "IfStatement" || !ye2)
            return false;
          if (n2(Fe2, B2, o2) === ")")
            return l2($2, B2), true;
          if ($2 === te2.consequent && ye2 === te2.alternate) {
            if ($2.type === "BlockStatement")
              l2($2, B2);
            else {
              let he2 = B2.type === "SingleLine" || B2.loc.start.line === B2.loc.end.line, ze2 = B2.loc.start.line === $2.loc.start.line;
              he2 && ze2 ? p2($2, B2, m2) : p2(te2, B2);
            }
            return true;
          }
          return ye2.type === "BlockStatement" ? (T2(ye2, B2), true) : ye2.type === "IfStatement" ? (k2(ye2.consequent, B2), true) : te2.consequent === ye2 ? (i2(ye2, B2), true) : false;
        }
        function q2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2, followingNode: ye2, text: Fe2 } = fe2;
          return (te2 == null ? void 0 : te2.type) !== "WhileStatement" || !ye2 ? false : n2(Fe2, B2, o2) === ")" ? (l2($2, B2), true) : ye2.type === "BlockStatement" ? (T2(ye2, B2), true) : te2.body === ye2 ? (i2(ye2, B2), true) : false;
        }
        function U2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2, followingNode: ye2 } = fe2;
          return (te2 == null ? void 0 : te2.type) !== "TryStatement" && (te2 == null ? void 0 : te2.type) !== "CatchClause" || !ye2 ? false : te2.type === "CatchClause" && $2 ? (l2($2, B2), true) : ye2.type === "BlockStatement" ? (T2(ye2, B2), true) : ye2.type === "TryStatement" ? (k2(ye2.finalizer, B2), true) : ye2.type === "CatchClause" ? (k2(ye2.body, B2), true) : false;
        }
        function L2(fe2) {
          let { comment: B2, enclosingNode: $2, followingNode: te2 } = fe2;
          return I2($2) && (te2 == null ? void 0 : te2.type) === "Identifier" ? (i2($2, B2), true) : false;
        }
        function Y2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2, followingNode: ye2, text: Fe2 } = fe2, Ne2 = $2 && !u2(Fe2, o2($2), v2(B2));
          return (!$2 || !Ne2) && ((te2 == null ? void 0 : te2.type) === "ConditionalExpression" || (te2 == null ? void 0 : te2.type) === "TSConditionalType") && ye2 ? (i2(ye2, B2), true) : false;
        }
        function V2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2 } = fe2;
          return P2(te2) && te2.shorthand && te2.key === $2 && te2.value.type === "AssignmentPattern" ? (l2(te2.value.left, B2), true) : false;
        }
        var j2 = new Set(["ClassDeclaration", "ClassExpression", "DeclareClass", "DeclareInterface", "InterfaceDeclaration", "TSInterfaceDeclaration"]);
        function K2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2, followingNode: ye2 } = fe2;
          if (j2.has(te2 == null ? void 0 : te2.type)) {
            if (y2(te2.decorators) && !(ye2 && ye2.type === "Decorator"))
              return l2(t2(te2.decorators), B2), true;
            if (te2.body && ye2 === te2.body)
              return T2(te2.body, B2), true;
            if (ye2) {
              if (te2.superClass && ye2 === te2.superClass && $2 && ($2 === te2.id || $2 === te2.typeParameters))
                return l2($2, B2), true;
              for (let Fe2 of ["implements", "extends", "mixins"])
                if (te2[Fe2] && ye2 === te2[Fe2][0])
                  return $2 && ($2 === te2.id || $2 === te2.typeParameters || $2 === te2.superClass) ? l2($2, B2) : p2(te2, B2, Fe2), true;
            }
          }
          return false;
        }
        var se2 = new Set(["ClassMethod", "ClassProperty", "PropertyDefinition", "TSAbstractPropertyDefinition", "TSAbstractMethodDefinition", "TSDeclareMethod", "MethodDefinition", "ClassAccessorProperty", "AccessorProperty", "TSAbstractAccessorProperty"]);
        function Q2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2, text: ye2 } = fe2;
          return te2 && $2 && n2(ye2, B2, o2) === "(" && (te2.type === "Property" || te2.type === "TSDeclareMethod" || te2.type === "TSAbstractMethodDefinition") && $2.type === "Identifier" && te2.key === $2 && n2(ye2, $2, o2) !== ":" || ($2 == null ? void 0 : $2.type) === "Decorator" && se2.has(te2 == null ? void 0 : te2.type) ? (l2($2, B2), true) : false;
        }
        var ce2 = new Set(["FunctionDeclaration", "FunctionExpression", "ClassMethod", "MethodDefinition", "ObjectMethod"]);
        function W2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2, text: ye2 } = fe2;
          return n2(ye2, B2, o2) !== "(" ? false : $2 && ce2.has(te2 == null ? void 0 : te2.type) ? (l2($2, B2), true) : false;
        }
        function X2(fe2) {
          let { comment: B2, enclosingNode: $2, text: te2 } = fe2;
          if (($2 == null ? void 0 : $2.type) !== "ArrowFunctionExpression")
            return false;
          let ye2 = d2(te2, B2, o2);
          return ye2 !== false && te2.slice(ye2, ye2 + 2) === "=>" ? (p2($2, B2), true) : false;
        }
        function de2(fe2) {
          let { comment: B2, enclosingNode: $2, text: te2 } = fe2;
          return n2(te2, B2, o2) !== ")" ? false : $2 && (ee2($2) && g2($2).length === 0 || F2($2) && A2($2).length === 0) ? (p2($2, B2), true) : (($2 == null ? void 0 : $2.type) === "MethodDefinition" || ($2 == null ? void 0 : $2.type) === "TSAbstractMethodDefinition") && g2($2.value).length === 0 ? (p2($2.value, B2), true) : false;
        }
        function ie2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2, followingNode: ye2, text: Fe2 } = fe2;
          if (($2 == null ? void 0 : $2.type) === "FunctionTypeParam" && (te2 == null ? void 0 : te2.type) === "FunctionTypeAnnotation" && (ye2 == null ? void 0 : ye2.type) !== "FunctionTypeParam" || (($2 == null ? void 0 : $2.type) === "Identifier" || ($2 == null ? void 0 : $2.type) === "AssignmentPattern") && te2 && ee2(te2) && n2(Fe2, B2, o2) === ")")
            return l2($2, B2), true;
          if ((te2 == null ? void 0 : te2.type) === "FunctionDeclaration" && (ye2 == null ? void 0 : ye2.type) === "BlockStatement") {
            let Ne2 = (() => {
              let he2 = g2(te2);
              if (he2.length > 0)
                return a2(Fe2, o2(t2(he2)));
              let ze2 = a2(Fe2, o2(te2.id));
              return ze2 !== false && a2(Fe2, ze2 + 1);
            })();
            if (v2(B2) > Ne2)
              return T2(ye2, B2), true;
          }
          return false;
        }
        function Ee2(fe2) {
          let { comment: B2, enclosingNode: $2 } = fe2;
          return ($2 == null ? void 0 : $2.type) === "LabeledStatement" ? (i2($2, B2), true) : false;
        }
        function z2(fe2) {
          let { comment: B2, enclosingNode: $2 } = fe2;
          return (($2 == null ? void 0 : $2.type) === "ContinueStatement" || ($2 == null ? void 0 : $2.type) === "BreakStatement") && !$2.label ? (l2($2, B2), true) : false;
        }
        function ue2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2 } = fe2;
          return N2(te2) && $2 && te2.callee === $2 && te2.arguments.length > 0 ? (i2(te2.arguments[0], B2), true) : false;
        }
        function J2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2, followingNode: ye2 } = fe2;
          return (te2 == null ? void 0 : te2.type) === "UnionTypeAnnotation" || (te2 == null ? void 0 : te2.type) === "TSUnionType" ? (c2(B2) && (ye2.prettierIgnore = true, B2.unignore = true), $2 ? (l2($2, B2), true) : false) : (((ye2 == null ? void 0 : ye2.type) === "UnionTypeAnnotation" || (ye2 == null ? void 0 : ye2.type) === "TSUnionType") && c2(B2) && (ye2.types[0].prettierIgnore = true, B2.unignore = true), false);
        }
        function le2(fe2) {
          let { comment: B2, enclosingNode: $2 } = fe2;
          return P2($2) ? (i2($2, B2), true) : false;
        }
        function ge2(fe2) {
          let { comment: B2, enclosingNode: $2, followingNode: te2, ast: ye2, isLastComment: Fe2 } = fe2;
          return ye2 && ye2.body && ye2.body.length === 0 ? (Fe2 ? p2(ye2, B2) : i2(ye2, B2), true) : ($2 == null ? void 0 : $2.type) === "Program" && ($2 == null ? void 0 : $2.body.length) === 0 && !y2($2.directives) ? (Fe2 ? p2($2, B2) : i2($2, B2), true) : (te2 == null ? void 0 : te2.type) === "Program" && (te2 == null ? void 0 : te2.body.length) === 0 && ($2 == null ? void 0 : $2.type) === "ModuleExpression" ? (p2(te2, B2), true) : false;
        }
        function pe2(fe2) {
          let { comment: B2, enclosingNode: $2 } = fe2;
          return ($2 == null ? void 0 : $2.type) === "ForInStatement" || ($2 == null ? void 0 : $2.type) === "ForOfStatement" ? (i2($2, B2), true) : false;
        }
        function Ae2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2, text: ye2 } = fe2;
          if ((te2 == null ? void 0 : te2.type) === "ImportSpecifier" || (te2 == null ? void 0 : te2.type) === "ExportSpecifier")
            return i2(te2, B2), true;
          let Fe2 = ($2 == null ? void 0 : $2.type) === "ImportSpecifier" && (te2 == null ? void 0 : te2.type) === "ImportDeclaration", Ne2 = ($2 == null ? void 0 : $2.type) === "ExportSpecifier" && (te2 == null ? void 0 : te2.type) === "ExportNamedDeclaration";
          return (Fe2 || Ne2) && s2(ye2, o2(B2)) ? (l2($2, B2), true) : false;
        }
        function Ce2(fe2) {
          let { comment: B2, enclosingNode: $2 } = fe2;
          return ($2 == null ? void 0 : $2.type) === "AssignmentPattern" ? (i2($2, B2), true) : false;
        }
        var Oe2 = new Set(["VariableDeclarator", "AssignmentExpression", "TypeAlias", "TSTypeAliasDeclaration"]), Ie2 = new Set(["ObjectExpression", "ArrayExpression", "TemplateLiteral", "TaggedTemplateExpression", "ObjectTypeAnnotation", "TSTypeLiteral"]);
        function we2(fe2) {
          let { comment: B2, enclosingNode: $2, followingNode: te2 } = fe2;
          return Oe2.has($2 == null ? void 0 : $2.type) && te2 && (Ie2.has(te2.type) || h2(B2)) ? (i2(te2, B2), true) : false;
        }
        function _e2(fe2) {
          let { comment: B2, enclosingNode: $2, followingNode: te2, text: ye2 } = fe2;
          return !te2 && (($2 == null ? void 0 : $2.type) === "TSMethodSignature" || ($2 == null ? void 0 : $2.type) === "TSDeclareFunction" || ($2 == null ? void 0 : $2.type) === "TSAbstractMethodDefinition") && n2(ye2, B2, o2) === ";" ? (l2($2, B2), true) : false;
        }
        function De2(fe2) {
          let { comment: B2, enclosingNode: $2, followingNode: te2 } = fe2;
          if (c2(B2) && ($2 == null ? void 0 : $2.type) === "TSMappedType" && (te2 == null ? void 0 : te2.type) === "TSTypeParameter" && te2.constraint)
            return $2.prettierIgnore = true, B2.unignore = true, true;
        }
        function G2(fe2) {
          let { comment: B2, precedingNode: $2, enclosingNode: te2, followingNode: ye2 } = fe2;
          return (te2 == null ? void 0 : te2.type) !== "TSMappedType" ? false : (ye2 == null ? void 0 : ye2.type) === "TSTypeParameter" && ye2.name ? (i2(ye2.name, B2), true) : ($2 == null ? void 0 : $2.type) === "TSTypeParameter" && $2.constraint ? (l2($2.constraint, B2), true) : false;
        }
        function oe2(fe2) {
          let { comment: B2, enclosingNode: $2, followingNode: te2 } = fe2;
          return !$2 || $2.type !== "SwitchCase" || $2.test || !te2 || te2 !== $2.consequent[0] ? false : (te2.type === "BlockStatement" && H2(B2) ? T2(te2, B2) : p2($2, B2), true);
        }
        function ee2(fe2) {
          return fe2.type === "ArrowFunctionExpression" || fe2.type === "FunctionExpression" || fe2.type === "FunctionDeclaration" || fe2.type === "ObjectMethod" || fe2.type === "ClassMethod" || fe2.type === "TSDeclareFunction" || fe2.type === "TSCallSignatureDeclaration" || fe2.type === "TSConstructSignatureDeclaration" || fe2.type === "TSMethodSignature" || fe2.type === "TSConstructorType" || fe2.type === "TSFunctionType" || fe2.type === "TSDeclareMethod";
        }
        function re2(fe2, B2) {
          if ((B2.parser === "typescript" || B2.parser === "flow" || B2.parser === "acorn" || B2.parser === "espree" || B2.parser === "meriyah" || B2.parser === "__babel_estree") && fe2.type === "MethodDefinition" && fe2.value && fe2.value.type === "FunctionExpression" && g2(fe2.value).length === 0 && !fe2.value.returnType && !y2(fe2.value.typeParameters) && fe2.value.body)
            return [...fe2.decorators || [], fe2.key, fe2.value.body];
        }
        function be2(fe2) {
          return h2(fe2) && fe2.value[0] === "*" && /@type\b/.test(fe2.value);
        }
        function ve2(fe2) {
          let B2 = fe2.getValue(), $2 = fe2.getParentNode(), te2 = (ye2) => _2(f2(ye2, b2.Leading)) || _2(f2(ye2, b2.Trailing));
          return (B2 && (D2(B2) || E2(B2) || N2($2) && te2(B2)) || $2 && ($2.type === "JSXSpreadAttribute" || $2.type === "JSXSpreadChild" || $2.type === "UnionTypeAnnotation" || $2.type === "TSUnionType" || ($2.type === "ClassDeclaration" || $2.type === "ClassExpression") && $2.superClass === B2)) && (!w2(fe2) || $2.type === "UnionTypeAnnotation" || $2.type === "TSUnionType");
        }
        r2.exports = { handleOwnLineComment: C2, handleEndOfLineComment: S2, handleRemainingComment: x2, isTypeCastComment: be2, getCommentChildNodes: re2, willPrintOwnComments: ve2 };
      } }), qt2 = Z2({ "src/language-js/needs-parens.js"(e25, r2) {
        ne2();
        var t2 = lt2(), s2 = Kn2(), { getFunctionParameters: a2, getLeftSidePathName: n2, hasFlowShorthandAnnotationComment: u2, hasNakedLeftSide: i2, hasNode: l2, isBitwiseOperator: p2, startsWithNoLookaheadToken: d2, shouldFlatten: y2, getPrecedence: g2, isCallExpression: c2, isMemberExpression: D2, isObjectProperty: E2, isTSTypeExpression: _2 } = Ke2();
        function w2(f2, b2) {
          let m2 = f2.getParentNode();
          if (!m2)
            return false;
          let v2 = f2.getName(), o2 = f2.getNode();
          if (b2.__isInHtmlInterpolation && !b2.bracketSpacing && I2(o2) && P2(f2))
            return true;
          if (F2(o2))
            return false;
          if (b2.parser !== "flow" && u2(f2.getValue()))
            return true;
          if (o2.type === "Identifier") {
            if (o2.extra && o2.extra.parenthesized && /^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(o2.name) || v2 === "left" && (o2.name === "async" && !m2.await || o2.name === "let") && m2.type === "ForOfStatement")
              return true;
            if (o2.name === "let") {
              var h2;
              let S2 = (h2 = f2.findAncestor((x2) => x2.type === "ForOfStatement")) === null || h2 === void 0 ? void 0 : h2.left;
              if (S2 && d2(S2, (x2) => x2 === o2))
                return true;
            }
            if (v2 === "object" && o2.name === "let" && m2.type === "MemberExpression" && m2.computed && !m2.optional) {
              let S2 = f2.findAncestor((T2) => T2.type === "ExpressionStatement" || T2.type === "ForStatement" || T2.type === "ForInStatement"), x2 = S2 ? S2.type === "ExpressionStatement" ? S2.expression : S2.type === "ForStatement" ? S2.init : S2.left : void 0;
              if (x2 && d2(x2, (T2) => T2 === o2))
                return true;
            }
            return false;
          }
          if (o2.type === "ObjectExpression" || o2.type === "FunctionExpression" || o2.type === "ClassExpression" || o2.type === "DoExpression") {
            var C2;
            let S2 = (C2 = f2.findAncestor((x2) => x2.type === "ExpressionStatement")) === null || C2 === void 0 ? void 0 : C2.expression;
            if (S2 && d2(S2, (x2) => x2 === o2))
              return true;
          }
          switch (m2.type) {
            case "ParenthesizedExpression":
              return false;
            case "ClassDeclaration":
            case "ClassExpression": {
              if (v2 === "superClass" && (o2.type === "ArrowFunctionExpression" || o2.type === "AssignmentExpression" || o2.type === "AwaitExpression" || o2.type === "BinaryExpression" || o2.type === "ConditionalExpression" || o2.type === "LogicalExpression" || o2.type === "NewExpression" || o2.type === "ObjectExpression" || o2.type === "SequenceExpression" || o2.type === "TaggedTemplateExpression" || o2.type === "UnaryExpression" || o2.type === "UpdateExpression" || o2.type === "YieldExpression" || o2.type === "TSNonNullExpression"))
                return true;
              break;
            }
            case "ExportDefaultDeclaration":
              return H2(f2, b2) || o2.type === "SequenceExpression";
            case "Decorator": {
              if (v2 === "expression") {
                let S2 = false, x2 = false, T2 = o2;
                for (; T2; )
                  switch (T2.type) {
                    case "MemberExpression":
                      x2 = true, T2 = T2.object;
                      break;
                    case "CallExpression":
                      if (x2 || S2)
                        return b2.parser !== "typescript";
                      S2 = true, T2 = T2.callee;
                      break;
                    case "Identifier":
                      return false;
                    case "TaggedTemplateExpression":
                      return b2.parser !== "typescript";
                    default:
                      return true;
                  }
                return true;
              }
              break;
            }
            case "ArrowFunctionExpression": {
              if (v2 === "body" && o2.type !== "SequenceExpression" && d2(o2, (S2) => S2.type === "ObjectExpression"))
                return true;
              break;
            }
          }
          switch (o2.type) {
            case "UpdateExpression":
              if (m2.type === "UnaryExpression")
                return o2.prefix && (o2.operator === "++" && m2.operator === "+" || o2.operator === "--" && m2.operator === "-");
            case "UnaryExpression":
              switch (m2.type) {
                case "UnaryExpression":
                  return o2.operator === m2.operator && (o2.operator === "+" || o2.operator === "-");
                case "BindExpression":
                  return true;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return v2 === "object";
                case "TaggedTemplateExpression":
                  return true;
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return v2 === "callee";
                case "BinaryExpression":
                  return v2 === "left" && m2.operator === "**";
                case "TSNonNullExpression":
                  return true;
                default:
                  return false;
              }
            case "BinaryExpression": {
              if (m2.type === "UpdateExpression" || o2.operator === "in" && A2(f2))
                return true;
              if (o2.operator === "|>" && o2.extra && o2.extra.parenthesized) {
                let S2 = f2.getParentNode(1);
                if (S2.type === "BinaryExpression" && S2.operator === "|>")
                  return true;
              }
            }
            case "TSTypeAssertion":
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "LogicalExpression":
              switch (m2.type) {
                case "TSSatisfiesExpression":
                case "TSAsExpression":
                  return !_2(o2);
                case "ConditionalExpression":
                  return _2(o2);
                case "CallExpression":
                case "NewExpression":
                case "OptionalCallExpression":
                  return v2 === "callee";
                case "ClassExpression":
                case "ClassDeclaration":
                  return v2 === "superClass";
                case "TSTypeAssertion":
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "JSXSpreadAttribute":
                case "SpreadElement":
                case "SpreadProperty":
                case "BindExpression":
                case "AwaitExpression":
                case "TSNonNullExpression":
                case "UpdateExpression":
                  return true;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return v2 === "object";
                case "AssignmentExpression":
                case "AssignmentPattern":
                  return v2 === "left" && (o2.type === "TSTypeAssertion" || _2(o2));
                case "LogicalExpression":
                  if (o2.type === "LogicalExpression")
                    return m2.operator !== o2.operator;
                case "BinaryExpression": {
                  let { operator: S2, type: x2 } = o2;
                  if (!S2 && x2 !== "TSTypeAssertion")
                    return true;
                  let T2 = g2(S2), k2 = m2.operator, M2 = g2(k2);
                  return M2 > T2 || v2 === "right" && M2 === T2 || M2 === T2 && !y2(k2, S2) ? true : M2 < T2 && S2 === "%" ? k2 === "+" || k2 === "-" : !!p2(k2);
                }
                default:
                  return false;
              }
            case "SequenceExpression":
              switch (m2.type) {
                case "ReturnStatement":
                  return false;
                case "ForStatement":
                  return false;
                case "ExpressionStatement":
                  return v2 !== "expression";
                case "ArrowFunctionExpression":
                  return v2 !== "body";
                default:
                  return true;
              }
            case "YieldExpression":
              if (m2.type === "UnaryExpression" || m2.type === "AwaitExpression" || _2(m2) || m2.type === "TSNonNullExpression")
                return true;
            case "AwaitExpression":
              switch (m2.type) {
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "LogicalExpression":
                case "SpreadElement":
                case "SpreadProperty":
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "TSNonNullExpression":
                case "BindExpression":
                  return true;
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return v2 === "object";
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return v2 === "callee";
                case "ConditionalExpression":
                  return v2 === "test";
                case "BinaryExpression":
                  return !(!o2.argument && m2.operator === "|>");
                default:
                  return false;
              }
            case "TSConditionalType":
              if (v2 === "extendsType" && m2.type === "TSConditionalType")
                return true;
            case "TSFunctionType":
            case "TSConstructorType":
              if (v2 === "extendsType" && m2.type === "TSConditionalType") {
                let S2 = (o2.returnType || o2.typeAnnotation).typeAnnotation;
                if (S2.type === "TSInferType" && S2.typeParameter.constraint)
                  return true;
              }
              if (v2 === "checkType" && m2.type === "TSConditionalType")
                return true;
            case "TSUnionType":
            case "TSIntersectionType":
              if ((m2.type === "TSUnionType" || m2.type === "TSIntersectionType") && m2.types.length > 1 && (!o2.types || o2.types.length > 1))
                return true;
            case "TSInferType":
              if (o2.type === "TSInferType" && m2.type === "TSRestType")
                return false;
            case "TSTypeOperator":
              return m2.type === "TSArrayType" || m2.type === "TSOptionalType" || m2.type === "TSRestType" || v2 === "objectType" && m2.type === "TSIndexedAccessType" || m2.type === "TSTypeOperator" || m2.type === "TSTypeAnnotation" && f2.getParentNode(1).type.startsWith("TSJSDoc");
            case "TSTypeQuery":
              return v2 === "objectType" && m2.type === "TSIndexedAccessType" || v2 === "elementType" && m2.type === "TSArrayType";
            case "ArrayTypeAnnotation":
              return m2.type === "NullableTypeAnnotation";
            case "IntersectionTypeAnnotation":
            case "UnionTypeAnnotation":
              return m2.type === "ArrayTypeAnnotation" || m2.type === "NullableTypeAnnotation" || m2.type === "IntersectionTypeAnnotation" || m2.type === "UnionTypeAnnotation" || v2 === "objectType" && (m2.type === "IndexedAccessType" || m2.type === "OptionalIndexedAccessType");
            case "NullableTypeAnnotation":
              return m2.type === "ArrayTypeAnnotation" || v2 === "objectType" && (m2.type === "IndexedAccessType" || m2.type === "OptionalIndexedAccessType");
            case "FunctionTypeAnnotation": {
              let S2 = m2.type === "NullableTypeAnnotation" ? f2.getParentNode(1) : m2;
              return S2.type === "UnionTypeAnnotation" || S2.type === "IntersectionTypeAnnotation" || S2.type === "ArrayTypeAnnotation" || v2 === "objectType" && (S2.type === "IndexedAccessType" || S2.type === "OptionalIndexedAccessType") || S2.type === "NullableTypeAnnotation" || m2.type === "FunctionTypeParam" && m2.name === null && a2(o2).some((x2) => x2.typeAnnotation && x2.typeAnnotation.type === "NullableTypeAnnotation");
            }
            case "OptionalIndexedAccessType":
              return v2 === "objectType" && m2.type === "IndexedAccessType";
            case "TypeofTypeAnnotation":
              return v2 === "objectType" && (m2.type === "IndexedAccessType" || m2.type === "OptionalIndexedAccessType");
            case "StringLiteral":
            case "NumericLiteral":
            case "Literal":
              if (typeof o2.value == "string" && m2.type === "ExpressionStatement" && !m2.directive) {
                let S2 = f2.getParentNode(1);
                return S2.type === "Program" || S2.type === "BlockStatement";
              }
              return v2 === "object" && m2.type === "MemberExpression" && typeof o2.value == "number";
            case "AssignmentExpression": {
              let S2 = f2.getParentNode(1);
              return v2 === "body" && m2.type === "ArrowFunctionExpression" ? true : v2 === "key" && (m2.type === "ClassProperty" || m2.type === "PropertyDefinition") && m2.computed || (v2 === "init" || v2 === "update") && m2.type === "ForStatement" ? false : m2.type === "ExpressionStatement" ? o2.left.type === "ObjectPattern" : !(v2 === "key" && m2.type === "TSPropertySignature" || m2.type === "AssignmentExpression" || m2.type === "SequenceExpression" && S2 && S2.type === "ForStatement" && (S2.init === m2 || S2.update === m2) || v2 === "value" && m2.type === "Property" && S2 && S2.type === "ObjectPattern" && S2.properties.includes(m2) || m2.type === "NGChainedExpression");
            }
            case "ConditionalExpression":
              switch (m2.type) {
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "SpreadElement":
                case "SpreadProperty":
                case "BinaryExpression":
                case "LogicalExpression":
                case "NGPipeExpression":
                case "ExportDefaultDeclaration":
                case "AwaitExpression":
                case "JSXSpreadAttribute":
                case "TSTypeAssertion":
                case "TypeCastExpression":
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "TSNonNullExpression":
                  return true;
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return v2 === "callee";
                case "ConditionalExpression":
                  return v2 === "test";
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return v2 === "object";
                default:
                  return false;
              }
            case "FunctionExpression":
              switch (m2.type) {
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return v2 === "callee";
                case "TaggedTemplateExpression":
                  return true;
                default:
                  return false;
              }
            case "ArrowFunctionExpression":
              switch (m2.type) {
                case "BinaryExpression":
                  return m2.operator !== "|>" || o2.extra && o2.extra.parenthesized;
                case "NewExpression":
                case "CallExpression":
                case "OptionalCallExpression":
                  return v2 === "callee";
                case "MemberExpression":
                case "OptionalMemberExpression":
                  return v2 === "object";
                case "TSAsExpression":
                case "TSSatisfiesExpression":
                case "TSNonNullExpression":
                case "BindExpression":
                case "TaggedTemplateExpression":
                case "UnaryExpression":
                case "LogicalExpression":
                case "AwaitExpression":
                case "TSTypeAssertion":
                  return true;
                case "ConditionalExpression":
                  return v2 === "test";
                default:
                  return false;
              }
            case "ClassExpression":
              if (s2(o2.decorators))
                return true;
              switch (m2.type) {
                case "NewExpression":
                  return v2 === "callee";
                default:
                  return false;
              }
            case "OptionalMemberExpression":
            case "OptionalCallExpression": {
              let S2 = f2.getParentNode(1);
              if (v2 === "object" && m2.type === "MemberExpression" || v2 === "callee" && (m2.type === "CallExpression" || m2.type === "NewExpression") || m2.type === "TSNonNullExpression" && S2.type === "MemberExpression" && S2.object === m2)
                return true;
            }
            case "CallExpression":
            case "MemberExpression":
            case "TaggedTemplateExpression":
            case "TSNonNullExpression":
              if (v2 === "callee" && (m2.type === "BindExpression" || m2.type === "NewExpression")) {
                let S2 = o2;
                for (; S2; )
                  switch (S2.type) {
                    case "CallExpression":
                    case "OptionalCallExpression":
                      return true;
                    case "MemberExpression":
                    case "OptionalMemberExpression":
                    case "BindExpression":
                      S2 = S2.object;
                      break;
                    case "TaggedTemplateExpression":
                      S2 = S2.tag;
                      break;
                    case "TSNonNullExpression":
                      S2 = S2.expression;
                      break;
                    default:
                      return false;
                  }
              }
              return false;
            case "BindExpression":
              return v2 === "callee" && (m2.type === "BindExpression" || m2.type === "NewExpression") || v2 === "object" && D2(m2);
            case "NGPipeExpression":
              return !(m2.type === "NGRoot" || m2.type === "NGMicrosyntaxExpression" || m2.type === "ObjectProperty" && !(o2.extra && o2.extra.parenthesized) || m2.type === "ArrayExpression" || c2(m2) && m2.arguments[v2] === o2 || v2 === "right" && m2.type === "NGPipeExpression" || v2 === "property" && m2.type === "MemberExpression" || m2.type === "AssignmentExpression");
            case "JSXFragment":
            case "JSXElement":
              return v2 === "callee" || v2 === "left" && m2.type === "BinaryExpression" && m2.operator === "<" || m2.type !== "ArrayExpression" && m2.type !== "ArrowFunctionExpression" && m2.type !== "AssignmentExpression" && m2.type !== "AssignmentPattern" && m2.type !== "BinaryExpression" && m2.type !== "NewExpression" && m2.type !== "ConditionalExpression" && m2.type !== "ExpressionStatement" && m2.type !== "JsExpressionRoot" && m2.type !== "JSXAttribute" && m2.type !== "JSXElement" && m2.type !== "JSXExpressionContainer" && m2.type !== "JSXFragment" && m2.type !== "LogicalExpression" && !c2(m2) && !E2(m2) && m2.type !== "ReturnStatement" && m2.type !== "ThrowStatement" && m2.type !== "TypeCastExpression" && m2.type !== "VariableDeclarator" && m2.type !== "YieldExpression";
            case "TypeAnnotation":
              return v2 === "returnType" && m2.type === "ArrowFunctionExpression" && N2(o2);
          }
          return false;
        }
        function F2(f2) {
          return f2.type === "BlockStatement" || f2.type === "BreakStatement" || f2.type === "ClassBody" || f2.type === "ClassDeclaration" || f2.type === "ClassMethod" || f2.type === "ClassProperty" || f2.type === "PropertyDefinition" || f2.type === "ClassPrivateProperty" || f2.type === "ContinueStatement" || f2.type === "DebuggerStatement" || f2.type === "DeclareClass" || f2.type === "DeclareExportAllDeclaration" || f2.type === "DeclareExportDeclaration" || f2.type === "DeclareFunction" || f2.type === "DeclareInterface" || f2.type === "DeclareModule" || f2.type === "DeclareModuleExports" || f2.type === "DeclareVariable" || f2.type === "DoWhileStatement" || f2.type === "EnumDeclaration" || f2.type === "ExportAllDeclaration" || f2.type === "ExportDefaultDeclaration" || f2.type === "ExportNamedDeclaration" || f2.type === "ExpressionStatement" || f2.type === "ForInStatement" || f2.type === "ForOfStatement" || f2.type === "ForStatement" || f2.type === "FunctionDeclaration" || f2.type === "IfStatement" || f2.type === "ImportDeclaration" || f2.type === "InterfaceDeclaration" || f2.type === "LabeledStatement" || f2.type === "MethodDefinition" || f2.type === "ReturnStatement" || f2.type === "SwitchStatement" || f2.type === "ThrowStatement" || f2.type === "TryStatement" || f2.type === "TSDeclareFunction" || f2.type === "TSEnumDeclaration" || f2.type === "TSImportEqualsDeclaration" || f2.type === "TSInterfaceDeclaration" || f2.type === "TSModuleDeclaration" || f2.type === "TSNamespaceExportDeclaration" || f2.type === "TypeAlias" || f2.type === "VariableDeclaration" || f2.type === "WhileStatement" || f2.type === "WithStatement";
        }
        function A2(f2) {
          let b2 = 0, m2 = f2.getValue();
          for (; m2; ) {
            let v2 = f2.getParentNode(b2++);
            if (v2 && v2.type === "ForStatement" && v2.init === m2)
              return true;
            m2 = v2;
          }
          return false;
        }
        function N2(f2) {
          return l2(f2, (b2) => b2.type === "ObjectTypeAnnotation" && l2(b2, (m2) => m2.type === "FunctionTypeAnnotation" || void 0) || void 0);
        }
        function I2(f2) {
          switch (f2.type) {
            case "ObjectExpression":
              return true;
            default:
              return false;
          }
        }
        function P2(f2) {
          let b2 = f2.getValue(), m2 = f2.getParentNode(), v2 = f2.getName();
          switch (m2.type) {
            case "NGPipeExpression":
              if (typeof v2 == "number" && m2.arguments[v2] === b2 && m2.arguments.length - 1 === v2)
                return f2.callParent(P2);
              break;
            case "ObjectProperty":
              if (v2 === "value") {
                let o2 = f2.getParentNode(1);
                return t2(o2.properties) === m2;
              }
              break;
            case "BinaryExpression":
            case "LogicalExpression":
              if (v2 === "right")
                return f2.callParent(P2);
              break;
            case "ConditionalExpression":
              if (v2 === "alternate")
                return f2.callParent(P2);
              break;
            case "UnaryExpression":
              if (m2.prefix)
                return f2.callParent(P2);
              break;
          }
          return false;
        }
        function H2(f2, b2) {
          let m2 = f2.getValue(), v2 = f2.getParentNode();
          return m2.type === "FunctionExpression" || m2.type === "ClassExpression" ? v2.type === "ExportDefaultDeclaration" || !w2(f2, b2) : !i2(m2) || v2.type !== "ExportDefaultDeclaration" && w2(f2, b2) ? false : f2.call((o2) => H2(o2, b2), ...n2(f2, m2));
        }
        r2.exports = w2;
      } }), Fo = Z2({ "src/language-js/print-preprocess.js"(e25, r2) {
        ne2();
        function t2(s2, a2) {
          switch (a2.parser) {
            case "json":
            case "json5":
            case "json-stringify":
            case "__js_expression":
            case "__vue_expression":
            case "__vue_ts_expression":
              return Object.assign(Object.assign({}, s2), {}, { type: a2.parser.startsWith("__") ? "JsExpressionRoot" : "JsonRoot", node: s2, comments: [], rootMarker: a2.rootMarker });
            default:
              return s2;
          }
        }
        r2.exports = t2;
      } }), cd2 = Z2({ "src/language-js/print/html-binding.js"(e25, r2) {
        ne2();
        var { builders: { join: t2, line: s2, group: a2, softline: n2, indent: u2 } } = Me2();
        function i2(p2, d2, y2) {
          let g2 = p2.getValue();
          if (d2.__onHtmlBindingRoot && p2.getName() === null && d2.__onHtmlBindingRoot(g2, d2), g2.type === "File") {
            if (d2.__isVueForBindingLeft)
              return p2.call((c2) => {
                let D2 = t2([",", s2], c2.map(y2, "params")), { params: E2 } = c2.getValue();
                return E2.length === 1 ? D2 : ["(", u2([n2, a2(D2)]), n2, ")"];
              }, "program", "body", 0);
            if (d2.__isVueBindings)
              return p2.call((c2) => t2([",", s2], c2.map(y2, "params")), "program", "body", 0);
          }
        }
        function l2(p2) {
          switch (p2.type) {
            case "MemberExpression":
              switch (p2.property.type) {
                case "Identifier":
                case "NumericLiteral":
                case "StringLiteral":
                  return l2(p2.object);
              }
              return false;
            case "Identifier":
              return true;
            default:
              return false;
          }
        }
        r2.exports = { isVueEventBindingExpression: l2, printHtmlBinding: i2 };
      } }), ru2 = Z2({ "src/language-js/print/binaryish.js"(e25, r2) {
        ne2();
        var { printComments: t2 } = et2(), { getLast: s2 } = Ue2(), { builders: { join: a2, line: n2, softline: u2, group: i2, indent: l2, align: p2, indentIfBreak: d2 }, utils: { cleanDoc: y2, getDocParts: g2, isConcat: c2 } } = Me2(), { hasLeadingOwnLineComment: D2, isBinaryish: E2, isJsxNode: _2, shouldFlatten: w2, hasComment: F2, CommentCheckFlags: A2, isCallExpression: N2, isMemberExpression: I2, isObjectProperty: P2, isEnabledHackPipeline: H2 } = Ke2(), f2 = 0;
        function b2(o2, h2, C2) {
          let S2 = o2.getValue(), x2 = o2.getParentNode(), T2 = o2.getParentNode(1), k2 = S2 !== x2.body && (x2.type === "IfStatement" || x2.type === "WhileStatement" || x2.type === "SwitchStatement" || x2.type === "DoWhileStatement"), M2 = H2(h2) && S2.operator === "|>", R2 = m2(o2, C2, h2, false, k2);
          if (k2)
            return R2;
          if (M2)
            return i2(R2);
          if (N2(x2) && x2.callee === S2 || x2.type === "UnaryExpression" || I2(x2) && !x2.computed)
            return i2([l2([u2, ...R2]), u2]);
          let q2 = x2.type === "ReturnStatement" || x2.type === "ThrowStatement" || x2.type === "JSXExpressionContainer" && T2.type === "JSXAttribute" || S2.operator !== "|" && x2.type === "JsExpressionRoot" || S2.type !== "NGPipeExpression" && (x2.type === "NGRoot" && h2.parser === "__ng_binding" || x2.type === "NGMicrosyntaxExpression" && T2.type === "NGMicrosyntax" && T2.body.length === 1) || S2 === x2.body && x2.type === "ArrowFunctionExpression" || S2 !== x2.body && x2.type === "ForStatement" || x2.type === "ConditionalExpression" && T2.type !== "ReturnStatement" && T2.type !== "ThrowStatement" && !N2(T2) || x2.type === "TemplateLiteral", U2 = x2.type === "AssignmentExpression" || x2.type === "VariableDeclarator" || x2.type === "ClassProperty" || x2.type === "PropertyDefinition" || x2.type === "TSAbstractPropertyDefinition" || x2.type === "ClassPrivateProperty" || P2(x2), L2 = E2(S2.left) && w2(S2.operator, S2.left.operator);
          if (q2 || v2(S2) && !L2 || !v2(S2) && U2)
            return i2(R2);
          if (R2.length === 0)
            return "";
          let Y2 = _2(S2.right), V2 = R2.findIndex((W2) => typeof W2 != "string" && !Array.isArray(W2) && W2.type === "group"), j2 = R2.slice(0, V2 === -1 ? 1 : V2 + 1), K2 = R2.slice(j2.length, Y2 ? -1 : void 0), se2 = Symbol("logicalChain-" + ++f2), Q2 = i2([...j2, l2(K2)], { id: se2 });
          if (!Y2)
            return Q2;
          let ce2 = s2(R2);
          return i2([Q2, d2(ce2, { groupId: se2 })]);
        }
        function m2(o2, h2, C2, S2, x2) {
          let T2 = o2.getValue();
          if (!E2(T2))
            return [i2(h2())];
          let k2 = [];
          w2(T2.operator, T2.left.operator) ? k2 = o2.call((K2) => m2(K2, h2, C2, true, x2), "left") : k2.push(i2(h2("left")));
          let M2 = v2(T2), R2 = (T2.operator === "|>" || T2.type === "NGPipeExpression" || T2.operator === "|" && C2.parser === "__vue_expression") && !D2(C2.originalText, T2.right), q2 = T2.type === "NGPipeExpression" ? "|" : T2.operator, U2 = T2.type === "NGPipeExpression" && T2.arguments.length > 0 ? i2(l2([n2, ": ", a2([n2, ": "], o2.map(h2, "arguments").map((K2) => p2(2, i2(K2))))])) : "", L2;
          if (M2)
            L2 = [q2, " ", h2("right"), U2];
          else {
            let se2 = H2(C2) && q2 === "|>" ? o2.call((Q2) => m2(Q2, h2, C2, true, x2), "right") : h2("right");
            L2 = [R2 ? n2 : "", q2, R2 ? " " : n2, se2, U2];
          }
          let Y2 = o2.getParentNode(), V2 = F2(T2.left, A2.Trailing | A2.Line), j2 = V2 || !(x2 && T2.type === "LogicalExpression") && Y2.type !== T2.type && T2.left.type !== T2.type && T2.right.type !== T2.type;
          if (k2.push(R2 ? "" : " ", j2 ? i2(L2, { shouldBreak: V2 }) : L2), S2 && F2(T2)) {
            let K2 = y2(t2(o2, k2, C2));
            return c2(K2) || K2.type === "fill" ? g2(K2) : [K2];
          }
          return k2;
        }
        function v2(o2) {
          return o2.type !== "LogicalExpression" ? false : !!(o2.right.type === "ObjectExpression" && o2.right.properties.length > 0 || o2.right.type === "ArrayExpression" && o2.right.elements.length > 0 || _2(o2.right));
        }
        r2.exports = { printBinaryishExpression: b2, shouldInlineLogicalExpression: v2 };
      } }), pd2 = Z2({ "src/language-js/print/angular.js"(e25, r2) {
        ne2();
        var { builders: { join: t2, line: s2, group: a2 } } = Me2(), { hasNode: n2, hasComment: u2, getComments: i2 } = Ke2(), { printBinaryishExpression: l2 } = ru2();
        function p2(g2, c2, D2) {
          let E2 = g2.getValue();
          if (E2.type.startsWith("NG"))
            switch (E2.type) {
              case "NGRoot":
                return [D2("node"), u2(E2.node) ? " //" + i2(E2.node)[0].value.trimEnd() : ""];
              case "NGPipeExpression":
                return l2(g2, c2, D2);
              case "NGChainedExpression":
                return a2(t2([";", s2], g2.map((_2) => y2(_2) ? D2() : ["(", D2(), ")"], "expressions")));
              case "NGEmptyExpression":
                return "";
              case "NGQuotedExpression":
                return [E2.prefix, ": ", E2.value.trim()];
              case "NGMicrosyntax":
                return g2.map((_2, w2) => [w2 === 0 ? "" : d2(_2.getValue(), w2, E2) ? " " : [";", s2], D2()], "body");
              case "NGMicrosyntaxKey":
                return /^[$_a-z][\w$]*(?:-[$_a-z][\w$])*$/i.test(E2.name) ? E2.name : JSON.stringify(E2.name);
              case "NGMicrosyntaxExpression":
                return [D2("expression"), E2.alias === null ? "" : [" as ", D2("alias")]];
              case "NGMicrosyntaxKeyedExpression": {
                let _2 = g2.getName(), w2 = g2.getParentNode(), F2 = d2(E2, _2, w2) || (_2 === 1 && (E2.key.name === "then" || E2.key.name === "else") || _2 === 2 && E2.key.name === "else" && w2.body[_2 - 1].type === "NGMicrosyntaxKeyedExpression" && w2.body[_2 - 1].key.name === "then") && w2.body[0].type === "NGMicrosyntaxExpression";
                return [D2("key"), F2 ? " " : ": ", D2("expression")];
              }
              case "NGMicrosyntaxLet":
                return ["let ", D2("key"), E2.value === null ? "" : [" = ", D2("value")]];
              case "NGMicrosyntaxAs":
                return [D2("key"), " as ", D2("alias")];
              default:
                throw new Error(`Unknown Angular node type: ${JSON.stringify(E2.type)}.`);
            }
        }
        function d2(g2, c2, D2) {
          return g2.type === "NGMicrosyntaxKeyedExpression" && g2.key.name === "of" && c2 === 1 && D2.body[0].type === "NGMicrosyntaxLet" && D2.body[0].value === null;
        }
        function y2(g2) {
          return n2(g2.getValue(), (c2) => {
            switch (c2.type) {
              case void 0:
                return false;
              case "CallExpression":
              case "OptionalCallExpression":
              case "AssignmentExpression":
                return true;
            }
          });
        }
        r2.exports = { printAngular: p2 };
      } }), fd2 = Z2({ "src/language-js/print/jsx.js"(e25, r2) {
        ne2();
        var { printComments: t2, printDanglingComments: s2, printCommentsSeparately: a2 } = et2(), { builders: { line: n2, hardline: u2, softline: i2, group: l2, indent: p2, conditionalGroup: d2, fill: y2, ifBreak: g2, lineSuffixBoundary: c2, join: D2 }, utils: { willBreak: E2 } } = Me2(), { getLast: _2, getPreferredQuote: w2 } = Ue2(), { isJsxNode: F2, rawText: A2, isLiteral: N2, isCallExpression: I2, isStringLiteral: P2, isBinaryish: H2, hasComment: f2, CommentCheckFlags: b2, hasNodeIgnoreComment: m2 } = Ke2(), v2 = qt2(), { willPrintOwnComments: o2 } = Eo2(), h2 = (J2) => J2 === "" || J2 === n2 || J2 === u2 || J2 === i2;
        function C2(J2, le2, ge2) {
          let pe2 = J2.getValue();
          if (pe2.type === "JSXElement" && ie2(pe2))
            return [ge2("openingElement"), ge2("closingElement")];
          let Ae2 = pe2.type === "JSXElement" ? ge2("openingElement") : ge2("openingFragment"), Ce2 = pe2.type === "JSXElement" ? ge2("closingElement") : ge2("closingFragment");
          if (pe2.children.length === 1 && pe2.children[0].type === "JSXExpressionContainer" && (pe2.children[0].expression.type === "TemplateLiteral" || pe2.children[0].expression.type === "TaggedTemplateExpression"))
            return [Ae2, ...J2.map(ge2, "children"), Ce2];
          pe2.children = pe2.children.map(($2) => z2($2) ? { type: "JSXText", value: " ", raw: " " } : $2);
          let Oe2 = pe2.children.some(F2), Ie2 = pe2.children.filter(($2) => $2.type === "JSXExpressionContainer").length > 1, we2 = pe2.type === "JSXElement" && pe2.openingElement.attributes.length > 1, _e2 = E2(Ae2) || Oe2 || we2 || Ie2, De2 = J2.getParentNode().rootMarker === "mdx", G2 = le2.singleQuote ? "{' '}" : '{" "}', oe2 = De2 ? " " : g2([G2, i2], " "), ee2 = pe2.openingElement && pe2.openingElement.name && pe2.openingElement.name.name === "fbt", re2 = S2(J2, le2, ge2, oe2, ee2), be2 = pe2.children.some(($2) => Ee2($2));
          for (let $2 = re2.length - 2; $2 >= 0; $2--) {
            let te2 = re2[$2] === "" && re2[$2 + 1] === "", ye2 = re2[$2] === u2 && re2[$2 + 1] === "" && re2[$2 + 2] === u2, Fe2 = (re2[$2] === i2 || re2[$2] === u2) && re2[$2 + 1] === "" && re2[$2 + 2] === oe2, Ne2 = re2[$2] === oe2 && re2[$2 + 1] === "" && (re2[$2 + 2] === i2 || re2[$2 + 2] === u2), he2 = re2[$2] === oe2 && re2[$2 + 1] === "" && re2[$2 + 2] === oe2, ze2 = re2[$2] === i2 && re2[$2 + 1] === "" && re2[$2 + 2] === u2 || re2[$2] === u2 && re2[$2 + 1] === "" && re2[$2 + 2] === i2;
            ye2 && be2 || te2 || Fe2 || he2 || ze2 ? re2.splice($2, 2) : Ne2 && re2.splice($2 + 1, 2);
          }
          for (; re2.length > 0 && h2(_2(re2)); )
            re2.pop();
          for (; re2.length > 1 && h2(re2[0]) && h2(re2[1]); )
            re2.shift(), re2.shift();
          let ve2 = [];
          for (let [$2, te2] of re2.entries()) {
            if (te2 === oe2) {
              if ($2 === 1 && re2[$2 - 1] === "") {
                if (re2.length === 2) {
                  ve2.push(G2);
                  continue;
                }
                ve2.push([G2, u2]);
                continue;
              } else if ($2 === re2.length - 1) {
                ve2.push(G2);
                continue;
              } else if (re2[$2 - 1] === "" && re2[$2 - 2] === u2) {
                ve2.push(G2);
                continue;
              }
            }
            ve2.push(te2), E2(te2) && (_e2 = true);
          }
          let fe2 = be2 ? y2(ve2) : l2(ve2, { shouldBreak: true });
          if (De2)
            return fe2;
          let B2 = l2([Ae2, p2([u2, fe2]), u2, Ce2]);
          return _e2 ? B2 : d2([l2([Ae2, ...re2, Ce2]), B2]);
        }
        function S2(J2, le2, ge2, pe2, Ae2) {
          let Ce2 = [];
          return J2.each((Oe2, Ie2, we2) => {
            let _e2 = Oe2.getValue();
            if (N2(_e2)) {
              let De2 = A2(_e2);
              if (Ee2(_e2)) {
                let G2 = De2.split(W2);
                if (G2[0] === "") {
                  if (Ce2.push(""), G2.shift(), /\n/.test(G2[0])) {
                    let ee2 = we2[Ie2 + 1];
                    Ce2.push(T2(Ae2, G2[1], _e2, ee2));
                  } else
                    Ce2.push(pe2);
                  G2.shift();
                }
                let oe2;
                if (_2(G2) === "" && (G2.pop(), oe2 = G2.pop()), G2.length === 0)
                  return;
                for (let [ee2, re2] of G2.entries())
                  ee2 % 2 === 1 ? Ce2.push(n2) : Ce2.push(re2);
                if (oe2 !== void 0)
                  if (/\n/.test(oe2)) {
                    let ee2 = we2[Ie2 + 1];
                    Ce2.push(T2(Ae2, _2(Ce2), _e2, ee2));
                  } else
                    Ce2.push(pe2);
                else {
                  let ee2 = we2[Ie2 + 1];
                  Ce2.push(x2(Ae2, _2(Ce2), _e2, ee2));
                }
              } else
                /\n/.test(De2) ? De2.match(/\n/g).length > 1 && Ce2.push("", u2) : Ce2.push("", pe2);
            } else {
              let De2 = ge2();
              Ce2.push(De2);
              let G2 = we2[Ie2 + 1];
              if (G2 && Ee2(G2)) {
                let ee2 = de2(A2(G2)).split(W2)[0];
                Ce2.push(x2(Ae2, ee2, _e2, G2));
              } else
                Ce2.push(u2);
            }
          }, "children"), Ce2;
        }
        function x2(J2, le2, ge2, pe2) {
          return J2 ? "" : ge2.type === "JSXElement" && !ge2.closingElement || pe2 && pe2.type === "JSXElement" && !pe2.closingElement ? le2.length === 1 ? i2 : u2 : i2;
        }
        function T2(J2, le2, ge2, pe2) {
          return J2 ? u2 : le2.length === 1 ? ge2.type === "JSXElement" && !ge2.closingElement || pe2 && pe2.type === "JSXElement" && !pe2.closingElement ? u2 : i2 : u2;
        }
        function k2(J2, le2, ge2) {
          let pe2 = J2.getParentNode();
          if (!pe2 || { ArrayExpression: true, JSXAttribute: true, JSXElement: true, JSXExpressionContainer: true, JSXFragment: true, ExpressionStatement: true, CallExpression: true, OptionalCallExpression: true, ConditionalExpression: true, JsExpressionRoot: true }[pe2.type])
            return le2;
          let Ce2 = J2.match(void 0, (Ie2) => Ie2.type === "ArrowFunctionExpression", I2, (Ie2) => Ie2.type === "JSXExpressionContainer"), Oe2 = v2(J2, ge2);
          return l2([Oe2 ? "" : g2("("), p2([i2, le2]), i2, Oe2 ? "" : g2(")")], { shouldBreak: Ce2 });
        }
        function M2(J2, le2, ge2) {
          let pe2 = J2.getValue(), Ae2 = [];
          if (Ae2.push(ge2("name")), pe2.value) {
            let Ce2;
            if (P2(pe2.value)) {
              let Ie2 = A2(pe2.value).slice(1, -1).replace(/&apos;/g, "'").replace(/&quot;/g, '"'), { escaped: we2, quote: _e2, regex: De2 } = w2(Ie2, le2.jsxSingleQuote ? "'" : '"');
              Ie2 = Ie2.replace(De2, we2);
              let { leading: G2, trailing: oe2 } = J2.call(() => a2(J2, le2), "value");
              Ce2 = [G2, _e2, Ie2, _e2, oe2];
            } else
              Ce2 = ge2("value");
            Ae2.push("=", Ce2);
          }
          return Ae2;
        }
        function R2(J2, le2, ge2) {
          let pe2 = J2.getValue(), Ae2 = (Ce2, Oe2) => Ce2.type === "JSXEmptyExpression" || !f2(Ce2) && (Ce2.type === "ArrayExpression" || Ce2.type === "ObjectExpression" || Ce2.type === "ArrowFunctionExpression" || Ce2.type === "AwaitExpression" && (Ae2(Ce2.argument, Ce2) || Ce2.argument.type === "JSXElement") || I2(Ce2) || Ce2.type === "FunctionExpression" || Ce2.type === "TemplateLiteral" || Ce2.type === "TaggedTemplateExpression" || Ce2.type === "DoExpression" || F2(Oe2) && (Ce2.type === "ConditionalExpression" || H2(Ce2)));
          return Ae2(pe2.expression, J2.getParentNode(0)) ? l2(["{", ge2("expression"), c2, "}"]) : l2(["{", p2([i2, ge2("expression")]), i2, c2, "}"]);
        }
        function q2(J2, le2, ge2) {
          let pe2 = J2.getValue(), Ae2 = pe2.name && f2(pe2.name) || pe2.typeParameters && f2(pe2.typeParameters);
          if (pe2.selfClosing && pe2.attributes.length === 0 && !Ae2)
            return ["<", ge2("name"), ge2("typeParameters"), " />"];
          if (pe2.attributes && pe2.attributes.length === 1 && pe2.attributes[0].value && P2(pe2.attributes[0].value) && !pe2.attributes[0].value.value.includes(`
`) && !Ae2 && !f2(pe2.attributes[0]))
            return l2(["<", ge2("name"), ge2("typeParameters"), " ", ...J2.map(ge2, "attributes"), pe2.selfClosing ? " />" : ">"]);
          let Ce2 = pe2.attributes && pe2.attributes.some((Ie2) => Ie2.value && P2(Ie2.value) && Ie2.value.value.includes(`
`)), Oe2 = le2.singleAttributePerLine && pe2.attributes.length > 1 ? u2 : n2;
          return l2(["<", ge2("name"), ge2("typeParameters"), p2(J2.map(() => [Oe2, ge2()], "attributes")), ...U2(pe2, le2, Ae2)], { shouldBreak: Ce2 });
        }
        function U2(J2, le2, ge2) {
          return J2.selfClosing ? [n2, "/>"] : L2(J2, le2, ge2) ? [">"] : [i2, ">"];
        }
        function L2(J2, le2, ge2) {
          let pe2 = J2.attributes.length > 0 && f2(_2(J2.attributes), b2.Trailing);
          return J2.attributes.length === 0 && !ge2 || (le2.bracketSameLine || le2.jsxBracketSameLine) && (!ge2 || J2.attributes.length > 0) && !pe2;
        }
        function Y2(J2, le2, ge2) {
          let pe2 = J2.getValue(), Ae2 = [];
          Ae2.push("</");
          let Ce2 = ge2("name");
          return f2(pe2.name, b2.Leading | b2.Line) ? Ae2.push(p2([u2, Ce2]), u2) : f2(pe2.name, b2.Leading | b2.Block) ? Ae2.push(" ", Ce2) : Ae2.push(Ce2), Ae2.push(">"), Ae2;
        }
        function V2(J2, le2) {
          let ge2 = J2.getValue(), pe2 = f2(ge2), Ae2 = f2(ge2, b2.Line), Ce2 = ge2.type === "JSXOpeningFragment";
          return [Ce2 ? "<" : "</", p2([Ae2 ? u2 : pe2 && !Ce2 ? " " : "", s2(J2, le2, true)]), Ae2 ? u2 : "", ">"];
        }
        function j2(J2, le2, ge2) {
          let pe2 = t2(J2, C2(J2, le2, ge2), le2);
          return k2(J2, pe2, le2);
        }
        function K2(J2, le2) {
          let ge2 = J2.getValue(), pe2 = f2(ge2, b2.Line);
          return [s2(J2, le2, !pe2), pe2 ? u2 : ""];
        }
        function se2(J2, le2, ge2) {
          let pe2 = J2.getValue();
          return ["{", J2.call((Ae2) => {
            let Ce2 = ["...", ge2()], Oe2 = Ae2.getValue();
            return !f2(Oe2) || !o2(Ae2) ? Ce2 : [p2([i2, t2(Ae2, Ce2, le2)]), i2];
          }, pe2.type === "JSXSpreadAttribute" ? "argument" : "expression"), "}"];
        }
        function Q2(J2, le2, ge2) {
          let pe2 = J2.getValue();
          if (pe2.type.startsWith("JSX"))
            switch (pe2.type) {
              case "JSXAttribute":
                return M2(J2, le2, ge2);
              case "JSXIdentifier":
                return String(pe2.name);
              case "JSXNamespacedName":
                return D2(":", [ge2("namespace"), ge2("name")]);
              case "JSXMemberExpression":
                return D2(".", [ge2("object"), ge2("property")]);
              case "JSXSpreadAttribute":
                return se2(J2, le2, ge2);
              case "JSXSpreadChild":
                return se2(J2, le2, ge2);
              case "JSXExpressionContainer":
                return R2(J2, le2, ge2);
              case "JSXFragment":
              case "JSXElement":
                return j2(J2, le2, ge2);
              case "JSXOpeningElement":
                return q2(J2, le2, ge2);
              case "JSXClosingElement":
                return Y2(J2, le2, ge2);
              case "JSXOpeningFragment":
              case "JSXClosingFragment":
                return V2(J2, le2);
              case "JSXEmptyExpression":
                return K2(J2, le2);
              case "JSXText":
                throw new Error("JSXText should be handled by JSXElement");
              default:
                throw new Error(`Unknown JSX node type: ${JSON.stringify(pe2.type)}.`);
            }
        }
        var ce2 = ` 
\r	`, W2 = new RegExp("([" + ce2 + "]+)"), X2 = new RegExp("[^" + ce2 + "]"), de2 = (J2) => J2.replace(new RegExp("(?:^" + W2.source + "|" + W2.source + "$)"), "");
        function ie2(J2) {
          if (J2.children.length === 0)
            return true;
          if (J2.children.length > 1)
            return false;
          let le2 = J2.children[0];
          return N2(le2) && !Ee2(le2);
        }
        function Ee2(J2) {
          return N2(J2) && (X2.test(A2(J2)) || !/\n/.test(A2(J2)));
        }
        function z2(J2) {
          return J2.type === "JSXExpressionContainer" && N2(J2.expression) && J2.expression.value === " " && !f2(J2.expression);
        }
        function ue2(J2) {
          let le2 = J2.getValue(), ge2 = J2.getParentNode();
          if (!ge2 || !le2 || !F2(le2) || !F2(ge2))
            return false;
          let pe2 = ge2.children.indexOf(le2), Ae2 = null;
          for (let Ce2 = pe2; Ce2 > 0; Ce2--) {
            let Oe2 = ge2.children[Ce2 - 1];
            if (!(Oe2.type === "JSXText" && !Ee2(Oe2))) {
              Ae2 = Oe2;
              break;
            }
          }
          return Ae2 && Ae2.type === "JSXExpressionContainer" && Ae2.expression.type === "JSXEmptyExpression" && m2(Ae2.expression);
        }
        r2.exports = { hasJsxIgnoreComment: ue2, printJsx: Q2 };
      } }), ct2 = Z2({ "src/language-js/print/misc.js"(e25, r2) {
        ne2();
        var { isNonEmptyArray: t2 } = Ue2(), { builders: { indent: s2, join: a2, line: n2 } } = Me2(), { isFlowAnnotationComment: u2 } = Ke2();
        function i2(_2) {
          let w2 = _2.getValue();
          return !w2.optional || w2.type === "Identifier" && w2 === _2.getParentNode().key ? "" : w2.type === "OptionalCallExpression" || w2.type === "OptionalMemberExpression" && w2.computed ? "?." : "?";
        }
        function l2(_2) {
          return _2.getValue().definite || _2.match(void 0, (w2, F2) => F2 === "id" && w2.type === "VariableDeclarator" && w2.definite) ? "!" : "";
        }
        function p2(_2, w2, F2) {
          let A2 = _2.getValue();
          return A2.typeArguments ? F2("typeArguments") : A2.typeParameters ? F2("typeParameters") : "";
        }
        function d2(_2, w2, F2) {
          let A2 = _2.getValue();
          if (!A2.typeAnnotation)
            return "";
          let N2 = _2.getParentNode(), I2 = N2.type === "DeclareFunction" && N2.id === A2;
          return u2(w2.originalText, A2.typeAnnotation) ? [" /*: ", F2("typeAnnotation"), " */"] : [I2 ? "" : ": ", F2("typeAnnotation")];
        }
        function y2(_2, w2, F2) {
          return ["::", F2("callee")];
        }
        function g2(_2, w2, F2) {
          let A2 = _2.getValue();
          return t2(A2.modifiers) ? [a2(" ", _2.map(F2, "modifiers")), " "] : "";
        }
        function c2(_2, w2, F2) {
          return _2.type === "EmptyStatement" ? ";" : _2.type === "BlockStatement" || F2 ? [" ", w2] : s2([n2, w2]);
        }
        function D2(_2, w2, F2) {
          return ["...", F2("argument"), d2(_2, w2, F2)];
        }
        function E2(_2, w2) {
          let F2 = _2.slice(1, -1);
          if (F2.includes('"') || F2.includes("'"))
            return _2;
          let A2 = w2.singleQuote ? "'" : '"';
          return A2 + F2 + A2;
        }
        r2.exports = { printOptionalToken: i2, printDefiniteToken: l2, printFunctionTypeParameters: p2, printBindExpressionCallee: y2, printTypeScriptModifiers: g2, printTypeAnnotation: d2, printRestSpread: D2, adjustClause: c2, printDirective: E2 };
      } }), er2 = Z2({ "src/language-js/print/array.js"(e25, r2) {
        ne2();
        var { printDanglingComments: t2 } = et2(), { builders: { line: s2, softline: a2, hardline: n2, group: u2, indent: i2, ifBreak: l2, fill: p2 } } = Me2(), { getLast: d2, hasNewline: y2 } = Ue2(), { shouldPrintComma: g2, hasComment: c2, CommentCheckFlags: D2, isNextLineEmpty: E2, isNumericLiteral: _2, isSignedNumericLiteral: w2 } = Ke2(), { locStart: F2 } = ut2(), { printOptionalToken: A2, printTypeAnnotation: N2 } = ct2();
        function I2(b2, m2, v2) {
          let o2 = b2.getValue(), h2 = [], C2 = o2.type === "TupleExpression" ? "#[" : "[", S2 = "]";
          if (o2.elements.length === 0)
            c2(o2, D2.Dangling) ? h2.push(u2([C2, t2(b2, m2), a2, S2])) : h2.push(C2, S2);
          else {
            let x2 = d2(o2.elements), T2 = !(x2 && x2.type === "RestElement"), k2 = x2 === null, M2 = Symbol("array"), R2 = !m2.__inJestEach && o2.elements.length > 1 && o2.elements.every((L2, Y2, V2) => {
              let j2 = L2 && L2.type;
              if (j2 !== "ArrayExpression" && j2 !== "ObjectExpression")
                return false;
              let K2 = V2[Y2 + 1];
              if (K2 && j2 !== K2.type)
                return false;
              let se2 = j2 === "ArrayExpression" ? "elements" : "properties";
              return L2[se2] && L2[se2].length > 1;
            }), q2 = P2(o2, m2), U2 = T2 ? k2 ? "," : g2(m2) ? q2 ? l2(",", "", { groupId: M2 }) : l2(",") : "" : "";
            h2.push(u2([C2, i2([a2, q2 ? f2(b2, m2, v2, U2) : [H2(b2, m2, "elements", v2), U2], t2(b2, m2, true)]), a2, S2], { shouldBreak: R2, id: M2 }));
          }
          return h2.push(A2(b2), N2(b2, m2, v2)), h2;
        }
        function P2(b2, m2) {
          return b2.elements.length > 1 && b2.elements.every((v2) => v2 && (_2(v2) || w2(v2) && !c2(v2.argument)) && !c2(v2, D2.Trailing | D2.Line, (o2) => !y2(m2.originalText, F2(o2), { backwards: true })));
        }
        function H2(b2, m2, v2, o2) {
          let h2 = [], C2 = [];
          return b2.each((S2) => {
            h2.push(C2, u2(o2())), C2 = [",", s2], S2.getValue() && E2(S2.getValue(), m2) && C2.push(a2);
          }, v2), h2;
        }
        function f2(b2, m2, v2, o2) {
          let h2 = [];
          return b2.each((C2, S2, x2) => {
            let T2 = S2 === x2.length - 1;
            h2.push([v2(), T2 ? o2 : ","]), T2 || h2.push(E2(C2.getValue(), m2) ? [n2, n2] : c2(x2[S2 + 1], D2.Leading | D2.Line) ? n2 : s2);
          }, "elements"), p2(h2);
        }
        r2.exports = { printArray: I2, printArrayItems: H2, isConciselyPrintedArray: P2 };
      } }), Ao = Z2({ "src/language-js/print/call-arguments.js"(e25, r2) {
        ne2();
        var { printDanglingComments: t2 } = et2(), { getLast: s2, getPenultimate: a2 } = Ue2(), { getFunctionParameters: n2, hasComment: u2, CommentCheckFlags: i2, isFunctionCompositionArgs: l2, isJsxNode: p2, isLongCurriedCallExpression: d2, shouldPrintComma: y2, getCallArguments: g2, iterateCallArgumentsPath: c2, isNextLineEmpty: D2, isCallExpression: E2, isStringLiteral: _2, isObjectProperty: w2, isTSTypeExpression: F2 } = Ke2(), { builders: { line: A2, hardline: N2, softline: I2, group: P2, indent: H2, conditionalGroup: f2, ifBreak: b2, breakParent: m2 }, utils: { willBreak: v2 } } = Me2(), { ArgExpansionBailout: o2 } = Qt2(), { isConciselyPrintedArray: h2 } = er2();
        function C2(q2, U2, L2) {
          let Y2 = q2.getValue(), V2 = Y2.type === "ImportExpression", j2 = g2(Y2);
          if (j2.length === 0)
            return ["(", t2(q2, U2, true), ")"];
          if (k2(j2))
            return ["(", L2(["arguments", 0]), ", ", L2(["arguments", 1]), ")"];
          let K2 = false, se2 = false, Q2 = j2.length - 1, ce2 = [];
          c2(q2, (z2, ue2) => {
            let J2 = z2.getNode(), le2 = [L2()];
            ue2 === Q2 || (D2(J2, U2) ? (ue2 === 0 && (se2 = true), K2 = true, le2.push(",", N2, N2)) : le2.push(",", A2)), ce2.push(le2);
          });
          let W2 = !(V2 || Y2.callee && Y2.callee.type === "Import") && y2(U2, "all") ? "," : "";
          function X2() {
            return P2(["(", H2([A2, ...ce2]), W2, A2, ")"], { shouldBreak: true });
          }
          if (K2 || q2.getParentNode().type !== "Decorator" && l2(j2))
            return X2();
          let de2 = T2(j2), ie2 = x2(j2, U2);
          if (de2 || ie2) {
            if (de2 ? ce2.slice(1).some(v2) : ce2.slice(0, -1).some(v2))
              return X2();
            let z2 = [];
            try {
              q2.try(() => {
                c2(q2, (ue2, J2) => {
                  de2 && J2 === 0 && (z2 = [[L2([], { expandFirstArg: true }), ce2.length > 1 ? "," : "", se2 ? N2 : A2, se2 ? N2 : ""], ...ce2.slice(1)]), ie2 && J2 === Q2 && (z2 = [...ce2.slice(0, -1), L2([], { expandLastArg: true })]);
                });
              });
            } catch (ue2) {
              if (ue2 instanceof o2)
                return X2();
              throw ue2;
            }
            return [ce2.some(v2) ? m2 : "", f2([["(", ...z2, ")"], de2 ? ["(", P2(z2[0], { shouldBreak: true }), ...z2.slice(1), ")"] : ["(", ...ce2.slice(0, -1), P2(s2(z2), { shouldBreak: true }), ")"], X2()])];
          }
          let Ee2 = ["(", H2([I2, ...ce2]), b2(W2), I2, ")"];
          return d2(q2) ? Ee2 : P2(Ee2, { shouldBreak: ce2.some(v2) || K2 });
        }
        function S2(q2) {
          let U2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
          return q2.type === "ObjectExpression" && (q2.properties.length > 0 || u2(q2)) || q2.type === "ArrayExpression" && (q2.elements.length > 0 || u2(q2)) || q2.type === "TSTypeAssertion" && S2(q2.expression) || F2(q2) && S2(q2.expression) || q2.type === "FunctionExpression" || q2.type === "ArrowFunctionExpression" && (!q2.returnType || !q2.returnType.typeAnnotation || q2.returnType.typeAnnotation.type !== "TSTypeReference" || M2(q2.body)) && (q2.body.type === "BlockStatement" || q2.body.type === "ArrowFunctionExpression" && S2(q2.body, true) || q2.body.type === "ObjectExpression" || q2.body.type === "ArrayExpression" || !U2 && (E2(q2.body) || q2.body.type === "ConditionalExpression") || p2(q2.body)) || q2.type === "DoExpression" || q2.type === "ModuleExpression";
        }
        function x2(q2, U2) {
          let L2 = s2(q2), Y2 = a2(q2);
          return !u2(L2, i2.Leading) && !u2(L2, i2.Trailing) && S2(L2) && (!Y2 || Y2.type !== L2.type) && (q2.length !== 2 || Y2.type !== "ArrowFunctionExpression" || L2.type !== "ArrayExpression") && !(q2.length > 1 && L2.type === "ArrayExpression" && h2(L2, U2));
        }
        function T2(q2) {
          if (q2.length !== 2)
            return false;
          let [U2, L2] = q2;
          return U2.type === "ModuleExpression" && R2(L2) ? true : !u2(U2) && (U2.type === "FunctionExpression" || U2.type === "ArrowFunctionExpression" && U2.body.type === "BlockStatement") && L2.type !== "FunctionExpression" && L2.type !== "ArrowFunctionExpression" && L2.type !== "ConditionalExpression" && !S2(L2);
        }
        function k2(q2) {
          return q2.length === 2 && q2[0].type === "ArrowFunctionExpression" && n2(q2[0]).length === 0 && q2[0].body.type === "BlockStatement" && q2[1].type === "ArrayExpression" && !q2.some((U2) => u2(U2));
        }
        function M2(q2) {
          return q2.type === "BlockStatement" && (q2.body.some((U2) => U2.type !== "EmptyStatement") || u2(q2, i2.Dangling));
        }
        function R2(q2) {
          return q2.type === "ObjectExpression" && q2.properties.length === 1 && w2(q2.properties[0]) && q2.properties[0].key.type === "Identifier" && q2.properties[0].key.name === "type" && _2(q2.properties[0].value) && q2.properties[0].value.value === "module";
        }
        r2.exports = C2;
      } }), So = Z2({ "src/language-js/print/member.js"(e25, r2) {
        ne2();
        var { builders: { softline: t2, group: s2, indent: a2, label: n2 } } = Me2(), { isNumericLiteral: u2, isMemberExpression: i2, isCallExpression: l2 } = Ke2(), { printOptionalToken: p2 } = ct2();
        function d2(g2, c2, D2) {
          let E2 = g2.getValue(), _2 = g2.getParentNode(), w2, F2 = 0;
          do
            w2 = g2.getParentNode(F2), F2++;
          while (w2 && (i2(w2) || w2.type === "TSNonNullExpression"));
          let A2 = D2("object"), N2 = y2(g2, c2, D2), I2 = w2 && (w2.type === "NewExpression" || w2.type === "BindExpression" || w2.type === "AssignmentExpression" && w2.left.type !== "Identifier") || E2.computed || E2.object.type === "Identifier" && E2.property.type === "Identifier" && !i2(_2) || (_2.type === "AssignmentExpression" || _2.type === "VariableDeclarator") && (l2(E2.object) && E2.object.arguments.length > 0 || E2.object.type === "TSNonNullExpression" && l2(E2.object.expression) && E2.object.expression.arguments.length > 0 || A2.label === "member-chain");
          return n2(A2.label === "member-chain" ? "member-chain" : "member", [A2, I2 ? N2 : s2(a2([t2, N2]))]);
        }
        function y2(g2, c2, D2) {
          let E2 = D2("property"), _2 = g2.getValue(), w2 = p2(g2);
          return _2.computed ? !_2.property || u2(_2.property) ? [w2, "[", E2, "]"] : s2([w2, "[", a2([t2, E2]), t2, "]"]) : [w2, ".", E2];
        }
        r2.exports = { printMemberExpression: d2, printMemberLookup: y2 };
      } }), Dd2 = Z2({ "src/language-js/print/member-chain.js"(e25, r2) {
        ne2();
        var { printComments: t2 } = et2(), { getLast: s2, isNextLineEmptyAfterIndex: a2, getNextNonSpaceNonCommentCharacterIndex: n2 } = Ue2(), u2 = qt2(), { isCallExpression: i2, isMemberExpression: l2, isFunctionOrArrowExpression: p2, isLongCurriedCallExpression: d2, isMemberish: y2, isNumericLiteral: g2, isSimpleCallArgument: c2, hasComment: D2, CommentCheckFlags: E2, isNextLineEmpty: _2 } = Ke2(), { locEnd: w2 } = ut2(), { builders: { join: F2, hardline: A2, group: N2, indent: I2, conditionalGroup: P2, breakParent: H2, label: f2 }, utils: { willBreak: b2 } } = Me2(), m2 = Ao(), { printMemberLookup: v2 } = So(), { printOptionalToken: o2, printFunctionTypeParameters: h2, printBindExpressionCallee: C2 } = ct2();
        function S2(x2, T2, k2) {
          let M2 = x2.getParentNode(), R2 = !M2 || M2.type === "ExpressionStatement", q2 = [];
          function U2(we2) {
            let { originalText: _e2 } = T2, De2 = n2(_e2, we2, w2);
            return _e2.charAt(De2) === ")" ? De2 !== false && a2(_e2, De2 + 1) : _2(we2, T2);
          }
          function L2(we2) {
            let _e2 = we2.getValue();
            i2(_e2) && (y2(_e2.callee) || i2(_e2.callee)) ? (q2.unshift({ node: _e2, printed: [t2(we2, [o2(we2), h2(we2, T2, k2), m2(we2, T2, k2)], T2), U2(_e2) ? A2 : ""] }), we2.call((De2) => L2(De2), "callee")) : y2(_e2) ? (q2.unshift({ node: _e2, needsParens: u2(we2, T2), printed: t2(we2, l2(_e2) ? v2(we2, T2, k2) : C2(we2, T2, k2), T2) }), we2.call((De2) => L2(De2), "object")) : _e2.type === "TSNonNullExpression" ? (q2.unshift({ node: _e2, printed: t2(we2, "!", T2) }), we2.call((De2) => L2(De2), "expression")) : q2.unshift({ node: _e2, printed: k2() });
          }
          let Y2 = x2.getValue();
          q2.unshift({ node: Y2, printed: [o2(x2), h2(x2, T2, k2), m2(x2, T2, k2)] }), Y2.callee && x2.call((we2) => L2(we2), "callee");
          let V2 = [], j2 = [q2[0]], K2 = 1;
          for (; K2 < q2.length && (q2[K2].node.type === "TSNonNullExpression" || i2(q2[K2].node) || l2(q2[K2].node) && q2[K2].node.computed && g2(q2[K2].node.property)); ++K2)
            j2.push(q2[K2]);
          if (!i2(q2[0].node))
            for (; K2 + 1 < q2.length && (y2(q2[K2].node) && y2(q2[K2 + 1].node)); ++K2)
              j2.push(q2[K2]);
          V2.push(j2), j2 = [];
          let se2 = false;
          for (; K2 < q2.length; ++K2) {
            if (se2 && y2(q2[K2].node)) {
              if (q2[K2].node.computed && g2(q2[K2].node.property)) {
                j2.push(q2[K2]);
                continue;
              }
              V2.push(j2), j2 = [], se2 = false;
            }
            (i2(q2[K2].node) || q2[K2].node.type === "ImportExpression") && (se2 = true), j2.push(q2[K2]), D2(q2[K2].node, E2.Trailing) && (V2.push(j2), j2 = [], se2 = false);
          }
          j2.length > 0 && V2.push(j2);
          function Q2(we2) {
            return /^[A-Z]|^[$_]+$/.test(we2);
          }
          function ce2(we2) {
            return we2.length <= T2.tabWidth;
          }
          function W2(we2) {
            let _e2 = we2[1].length > 0 && we2[1][0].node.computed;
            if (we2[0].length === 1) {
              let G2 = we2[0][0].node;
              return G2.type === "ThisExpression" || G2.type === "Identifier" && (Q2(G2.name) || R2 && ce2(G2.name) || _e2);
            }
            let De2 = s2(we2[0]).node;
            return l2(De2) && De2.property.type === "Identifier" && (Q2(De2.property.name) || _e2);
          }
          let X2 = V2.length >= 2 && !D2(V2[1][0].node) && W2(V2);
          function de2(we2) {
            let _e2 = we2.map((De2) => De2.printed);
            return we2.length > 0 && s2(we2).needsParens ? ["(", ..._e2, ")"] : _e2;
          }
          function ie2(we2) {
            return we2.length === 0 ? "" : I2(N2([A2, F2(A2, we2.map(de2))]));
          }
          let Ee2 = V2.map(de2), z2 = Ee2, ue2 = X2 ? 3 : 2, J2 = V2.flat(), le2 = J2.slice(1, -1).some((we2) => D2(we2.node, E2.Leading)) || J2.slice(0, -1).some((we2) => D2(we2.node, E2.Trailing)) || V2[ue2] && D2(V2[ue2][0].node, E2.Leading);
          if (V2.length <= ue2 && !le2)
            return d2(x2) ? z2 : N2(z2);
          let ge2 = s2(V2[X2 ? 1 : 0]).node, pe2 = !i2(ge2) && U2(ge2), Ae2 = [de2(V2[0]), X2 ? V2.slice(1, 2).map(de2) : "", pe2 ? A2 : "", ie2(V2.slice(X2 ? 2 : 1))], Ce2 = q2.map((we2) => {
            let { node: _e2 } = we2;
            return _e2;
          }).filter(i2);
          function Oe2() {
            let we2 = s2(s2(V2)).node, _e2 = s2(Ee2);
            return i2(we2) && b2(_e2) && Ce2.slice(0, -1).some((De2) => De2.arguments.some(p2));
          }
          let Ie2;
          return le2 || Ce2.length > 2 && Ce2.some((we2) => !we2.arguments.every((_e2) => c2(_e2, 0))) || Ee2.slice(0, -1).some(b2) || Oe2() ? Ie2 = N2(Ae2) : Ie2 = [b2(z2) || pe2 ? H2 : "", P2([z2, Ae2])], f2("member-chain", Ie2);
        }
        r2.exports = S2;
      } }), xo2 = Z2({ "src/language-js/print/call-expression.js"(e25, r2) {
        ne2();
        var { builders: { join: t2, group: s2 } } = Me2(), a2 = qt2(), { getCallArguments: n2, hasFlowAnnotationComment: u2, isCallExpression: i2, isMemberish: l2, isStringLiteral: p2, isTemplateOnItsOwnLine: d2, isTestCall: y2, iterateCallArgumentsPath: g2 } = Ke2(), c2 = Dd2(), D2 = Ao(), { printOptionalToken: E2, printFunctionTypeParameters: _2 } = ct2();
        function w2(A2, N2, I2) {
          let P2 = A2.getValue(), H2 = A2.getParentNode(), f2 = P2.type === "NewExpression", b2 = P2.type === "ImportExpression", m2 = E2(A2), v2 = n2(P2);
          if (v2.length > 0 && (!b2 && !f2 && F2(P2, H2) || v2.length === 1 && d2(v2[0], N2.originalText) || !f2 && y2(P2, H2))) {
            let C2 = [];
            return g2(A2, () => {
              C2.push(I2());
            }), [f2 ? "new " : "", I2("callee"), m2, _2(A2, N2, I2), "(", t2(", ", C2), ")"];
          }
          let o2 = (N2.parser === "babel" || N2.parser === "babel-flow") && P2.callee && P2.callee.type === "Identifier" && u2(P2.callee.trailingComments);
          if (o2 && (P2.callee.trailingComments[0].printed = true), !b2 && !f2 && l2(P2.callee) && !A2.call((C2) => a2(C2, N2), "callee"))
            return c2(A2, N2, I2);
          let h2 = [f2 ? "new " : "", b2 ? "import" : I2("callee"), m2, o2 ? `/*:: ${P2.callee.trailingComments[0].value.slice(2).trim()} */` : "", _2(A2, N2, I2), D2(A2, N2, I2)];
          return b2 || i2(P2.callee) ? s2(h2) : h2;
        }
        function F2(A2, N2) {
          if (A2.callee.type !== "Identifier")
            return false;
          if (A2.callee.name === "require")
            return true;
          if (A2.callee.name === "define") {
            let I2 = n2(A2);
            return N2.type === "ExpressionStatement" && (I2.length === 1 || I2.length === 2 && I2[0].type === "ArrayExpression" || I2.length === 3 && p2(I2[0]) && I2[1].type === "ArrayExpression");
          }
          return false;
        }
        r2.exports = { printCallExpression: w2 };
      } }), tr2 = Z2({ "src/language-js/print/assignment.js"(e25, r2) {
        ne2();
        var { isNonEmptyArray: t2, getStringWidth: s2 } = Ue2(), { builders: { line: a2, group: n2, indent: u2, indentIfBreak: i2, lineSuffixBoundary: l2 }, utils: { cleanDoc: p2, willBreak: d2, canBreak: y2 } } = Me2(), { hasLeadingOwnLineComment: g2, isBinaryish: c2, isStringLiteral: D2, isLiteral: E2, isNumericLiteral: _2, isCallExpression: w2, isMemberExpression: F2, getCallArguments: A2, rawText: N2, hasComment: I2, isSignedNumericLiteral: P2, isObjectProperty: H2 } = Ke2(), { shouldInlineLogicalExpression: f2 } = ru2(), { printCallExpression: b2 } = xo2();
        function m2(W2, X2, de2, ie2, Ee2, z2) {
          let ue2 = h2(W2, X2, de2, ie2, z2), J2 = de2(z2, { assignmentLayout: ue2 });
          switch (ue2) {
            case "break-after-operator":
              return n2([n2(ie2), Ee2, n2(u2([a2, J2]))]);
            case "never-break-after-operator":
              return n2([n2(ie2), Ee2, " ", J2]);
            case "fluid": {
              let le2 = Symbol("assignment");
              return n2([n2(ie2), Ee2, n2(u2(a2), { id: le2 }), l2, i2(J2, { groupId: le2 })]);
            }
            case "break-lhs":
              return n2([ie2, Ee2, " ", n2(J2)]);
            case "chain":
              return [n2(ie2), Ee2, a2, J2];
            case "chain-tail":
              return [n2(ie2), Ee2, u2([a2, J2])];
            case "chain-tail-arrow-chain":
              return [n2(ie2), Ee2, J2];
            case "only-left":
              return ie2;
          }
        }
        function v2(W2, X2, de2) {
          let ie2 = W2.getValue();
          return m2(W2, X2, de2, de2("left"), [" ", ie2.operator], "right");
        }
        function o2(W2, X2, de2) {
          return m2(W2, X2, de2, de2("id"), " =", "init");
        }
        function h2(W2, X2, de2, ie2, Ee2) {
          let z2 = W2.getValue(), ue2 = z2[Ee2];
          if (!ue2)
            return "only-left";
          let J2 = !x2(ue2);
          if (W2.match(x2, T2, (Ae2) => !J2 || Ae2.type !== "ExpressionStatement" && Ae2.type !== "VariableDeclaration"))
            return J2 ? ue2.type === "ArrowFunctionExpression" && ue2.body.type === "ArrowFunctionExpression" ? "chain-tail-arrow-chain" : "chain-tail" : "chain";
          if (!J2 && x2(ue2.right) || g2(X2.originalText, ue2))
            return "break-after-operator";
          if (ue2.type === "CallExpression" && ue2.callee.name === "require" || X2.parser === "json5" || X2.parser === "json")
            return "never-break-after-operator";
          if (S2(z2) || k2(z2) || q2(z2) || U2(z2) && y2(ie2))
            return "break-lhs";
          let pe2 = se2(z2, ie2, X2);
          return W2.call(() => C2(W2, X2, de2, pe2), Ee2) ? "break-after-operator" : pe2 || ue2.type === "TemplateLiteral" || ue2.type === "TaggedTemplateExpression" || ue2.type === "BooleanLiteral" || _2(ue2) || ue2.type === "ClassExpression" ? "never-break-after-operator" : "fluid";
        }
        function C2(W2, X2, de2, ie2) {
          let Ee2 = W2.getValue();
          if (c2(Ee2) && !f2(Ee2))
            return true;
          switch (Ee2.type) {
            case "StringLiteralTypeAnnotation":
            case "SequenceExpression":
              return true;
            case "ConditionalExpression": {
              let { test: J2 } = Ee2;
              return c2(J2) && !f2(J2);
            }
            case "ClassExpression":
              return t2(Ee2.decorators);
          }
          if (ie2)
            return false;
          let z2 = Ee2, ue2 = [];
          for (; ; )
            if (z2.type === "UnaryExpression")
              z2 = z2.argument, ue2.push("argument");
            else if (z2.type === "TSNonNullExpression")
              z2 = z2.expression, ue2.push("expression");
            else
              break;
          return !!(D2(z2) || W2.call(() => V2(W2, X2, de2), ...ue2));
        }
        function S2(W2) {
          if (T2(W2)) {
            let X2 = W2.left || W2.id;
            return X2.type === "ObjectPattern" && X2.properties.length > 2 && X2.properties.some((de2) => H2(de2) && (!de2.shorthand || de2.value && de2.value.type === "AssignmentPattern"));
          }
          return false;
        }
        function x2(W2) {
          return W2.type === "AssignmentExpression";
        }
        function T2(W2) {
          return x2(W2) || W2.type === "VariableDeclarator";
        }
        function k2(W2) {
          let X2 = M2(W2);
          if (t2(X2)) {
            let de2 = W2.type === "TSTypeAliasDeclaration" ? "constraint" : "bound";
            if (X2.length > 1 && X2.some((ie2) => ie2[de2] || ie2.default))
              return true;
          }
          return false;
        }
        function M2(W2) {
          return R2(W2) && W2.typeParameters && W2.typeParameters.params ? W2.typeParameters.params : null;
        }
        function R2(W2) {
          return W2.type === "TSTypeAliasDeclaration" || W2.type === "TypeAlias";
        }
        function q2(W2) {
          if (W2.type !== "VariableDeclarator")
            return false;
          let { typeAnnotation: X2 } = W2.id;
          if (!X2 || !X2.typeAnnotation)
            return false;
          let de2 = L2(X2.typeAnnotation);
          return t2(de2) && de2.length > 1 && de2.some((ie2) => t2(L2(ie2)) || ie2.type === "TSConditionalType");
        }
        function U2(W2) {
          return W2.type === "VariableDeclarator" && W2.init && W2.init.type === "ArrowFunctionExpression";
        }
        function L2(W2) {
          return Y2(W2) && W2.typeParameters && W2.typeParameters.params ? W2.typeParameters.params : null;
        }
        function Y2(W2) {
          return W2.type === "TSTypeReference" || W2.type === "GenericTypeAnnotation";
        }
        function V2(W2, X2, de2) {
          let ie2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, Ee2 = W2.getValue(), z2 = () => V2(W2, X2, de2, true);
          if (Ee2.type === "TSNonNullExpression")
            return W2.call(z2, "expression");
          if (w2(Ee2)) {
            if (b2(W2, X2, de2).label === "member-chain")
              return false;
            let J2 = A2(Ee2);
            return !(J2.length === 0 || J2.length === 1 && K2(J2[0], X2)) || Q2(Ee2, de2) ? false : W2.call(z2, "callee");
          }
          return F2(Ee2) ? W2.call(z2, "object") : ie2 && (Ee2.type === "Identifier" || Ee2.type === "ThisExpression");
        }
        var j2 = 0.25;
        function K2(W2, X2) {
          let { printWidth: de2 } = X2;
          if (I2(W2))
            return false;
          let ie2 = de2 * j2;
          if (W2.type === "ThisExpression" || W2.type === "Identifier" && W2.name.length <= ie2 || P2(W2) && !I2(W2.argument))
            return true;
          let Ee2 = W2.type === "Literal" && "regex" in W2 && W2.regex.pattern || W2.type === "RegExpLiteral" && W2.pattern;
          return Ee2 ? Ee2.length <= ie2 : D2(W2) ? N2(W2).length <= ie2 : W2.type === "TemplateLiteral" ? W2.expressions.length === 0 && W2.quasis[0].value.raw.length <= ie2 && !W2.quasis[0].value.raw.includes(`
`) : E2(W2);
        }
        function se2(W2, X2, de2) {
          if (!H2(W2))
            return false;
          X2 = p2(X2);
          let ie2 = 3;
          return typeof X2 == "string" && s2(X2) < de2.tabWidth + ie2;
        }
        function Q2(W2, X2) {
          let de2 = ce2(W2);
          if (t2(de2)) {
            if (de2.length > 1)
              return true;
            if (de2.length === 1) {
              let Ee2 = de2[0];
              if (Ee2.type === "TSUnionType" || Ee2.type === "UnionTypeAnnotation" || Ee2.type === "TSIntersectionType" || Ee2.type === "IntersectionTypeAnnotation" || Ee2.type === "TSTypeLiteral" || Ee2.type === "ObjectTypeAnnotation")
                return true;
            }
            let ie2 = W2.typeParameters ? "typeParameters" : "typeArguments";
            if (d2(X2(ie2)))
              return true;
          }
          return false;
        }
        function ce2(W2) {
          return W2.typeParameters && W2.typeParameters.params || W2.typeArguments && W2.typeArguments.params;
        }
        r2.exports = { printVariableDeclarator: o2, printAssignmentExpression: v2, printAssignment: m2, isArrowFunctionVariableDeclarator: U2 };
      } }), Lr2 = Z2({ "src/language-js/print/function-parameters.js"(e25, r2) {
        ne2();
        var { getNextNonSpaceNonCommentCharacter: t2 } = Ue2(), { printDanglingComments: s2 } = et2(), { builders: { line: a2, hardline: n2, softline: u2, group: i2, indent: l2, ifBreak: p2 }, utils: { removeLines: d2, willBreak: y2 } } = Me2(), { getFunctionParameters: g2, iterateFunctionParametersPath: c2, isSimpleType: D2, isTestCall: E2, isTypeAnnotationAFunction: _2, isObjectType: w2, isObjectTypePropertyAFunction: F2, hasRestParameter: A2, shouldPrintComma: N2, hasComment: I2, isNextLineEmpty: P2 } = Ke2(), { locEnd: H2 } = ut2(), { ArgExpansionBailout: f2 } = Qt2(), { printFunctionTypeParameters: b2 } = ct2();
        function m2(C2, S2, x2, T2, k2) {
          let M2 = C2.getValue(), R2 = g2(M2), q2 = k2 ? b2(C2, x2, S2) : "";
          if (R2.length === 0)
            return [q2, "(", s2(C2, x2, true, (se2) => t2(x2.originalText, se2, H2) === ")"), ")"];
          let U2 = C2.getParentNode(), L2 = E2(U2), Y2 = v2(M2), V2 = [];
          if (c2(C2, (se2, Q2) => {
            let ce2 = Q2 === R2.length - 1;
            ce2 && M2.rest && V2.push("..."), V2.push(S2()), !ce2 && (V2.push(","), L2 || Y2 ? V2.push(" ") : P2(R2[Q2], x2) ? V2.push(n2, n2) : V2.push(a2));
          }), T2) {
            if (y2(q2) || y2(V2))
              throw new f2();
            return i2([d2(q2), "(", d2(V2), ")"]);
          }
          let j2 = R2.every((se2) => !se2.decorators);
          return Y2 && j2 ? [q2, "(", ...V2, ")"] : L2 ? [q2, "(", ...V2, ")"] : (F2(U2) || _2(U2) || U2.type === "TypeAlias" || U2.type === "UnionTypeAnnotation" || U2.type === "TSUnionType" || U2.type === "IntersectionTypeAnnotation" || U2.type === "FunctionTypeAnnotation" && U2.returnType === M2) && R2.length === 1 && R2[0].name === null && M2.this !== R2[0] && R2[0].typeAnnotation && M2.typeParameters === null && D2(R2[0].typeAnnotation) && !M2.rest ? x2.arrowParens === "always" ? ["(", ...V2, ")"] : V2 : [q2, "(", l2([u2, ...V2]), p2(!A2(M2) && N2(x2, "all") ? "," : ""), u2, ")"];
        }
        function v2(C2) {
          if (!C2)
            return false;
          let S2 = g2(C2);
          if (S2.length !== 1)
            return false;
          let [x2] = S2;
          return !I2(x2) && (x2.type === "ObjectPattern" || x2.type === "ArrayPattern" || x2.type === "Identifier" && x2.typeAnnotation && (x2.typeAnnotation.type === "TypeAnnotation" || x2.typeAnnotation.type === "TSTypeAnnotation") && w2(x2.typeAnnotation.typeAnnotation) || x2.type === "FunctionTypeParam" && w2(x2.typeAnnotation) || x2.type === "AssignmentPattern" && (x2.left.type === "ObjectPattern" || x2.left.type === "ArrayPattern") && (x2.right.type === "Identifier" || x2.right.type === "ObjectExpression" && x2.right.properties.length === 0 || x2.right.type === "ArrayExpression" && x2.right.elements.length === 0));
        }
        function o2(C2) {
          let S2;
          return C2.returnType ? (S2 = C2.returnType, S2.typeAnnotation && (S2 = S2.typeAnnotation)) : C2.typeAnnotation && (S2 = C2.typeAnnotation), S2;
        }
        function h2(C2, S2) {
          let x2 = o2(C2);
          if (!x2)
            return false;
          let T2 = C2.typeParameters && C2.typeParameters.params;
          if (T2) {
            if (T2.length > 1)
              return false;
            if (T2.length === 1) {
              let k2 = T2[0];
              if (k2.constraint || k2.default)
                return false;
            }
          }
          return g2(C2).length === 1 && (w2(x2) || y2(S2));
        }
        r2.exports = { printFunctionParameters: m2, shouldHugFunctionParameters: v2, shouldGroupFunctionParameters: h2 };
      } }), Or2 = Z2({ "src/language-js/print/type-annotation.js"(e25, r2) {
        ne2();
        var { printComments: t2, printDanglingComments: s2 } = et2(), { isNonEmptyArray: a2 } = Ue2(), { builders: { group: n2, join: u2, line: i2, softline: l2, indent: p2, align: d2, ifBreak: y2 } } = Me2(), g2 = qt2(), { locStart: c2 } = ut2(), { isSimpleType: D2, isObjectType: E2, hasLeadingOwnLineComment: _2, isObjectTypePropertyAFunction: w2, shouldPrintComma: F2 } = Ke2(), { printAssignment: A2 } = tr2(), { printFunctionParameters: N2, shouldGroupFunctionParameters: I2 } = Lr2(), { printArrayItems: P2 } = er2();
        function H2(x2) {
          if (D2(x2) || E2(x2))
            return true;
          if (x2.type === "UnionTypeAnnotation" || x2.type === "TSUnionType") {
            let T2 = x2.types.filter((M2) => M2.type === "VoidTypeAnnotation" || M2.type === "TSVoidKeyword" || M2.type === "NullLiteralTypeAnnotation" || M2.type === "TSNullKeyword").length, k2 = x2.types.some((M2) => M2.type === "ObjectTypeAnnotation" || M2.type === "TSTypeLiteral" || M2.type === "GenericTypeAnnotation" || M2.type === "TSTypeReference");
            if (x2.types.length - 1 === T2 && k2)
              return true;
          }
          return false;
        }
        function f2(x2, T2, k2) {
          let M2 = T2.semi ? ";" : "", R2 = x2.getValue(), q2 = [];
          return q2.push("opaque type ", k2("id"), k2("typeParameters")), R2.supertype && q2.push(": ", k2("supertype")), R2.impltype && q2.push(" = ", k2("impltype")), q2.push(M2), q2;
        }
        function b2(x2, T2, k2) {
          let M2 = T2.semi ? ";" : "", R2 = x2.getValue(), q2 = [];
          R2.declare && q2.push("declare "), q2.push("type ", k2("id"), k2("typeParameters"));
          let U2 = R2.type === "TSTypeAliasDeclaration" ? "typeAnnotation" : "right";
          return [A2(x2, T2, k2, q2, " =", U2), M2];
        }
        function m2(x2, T2, k2) {
          let M2 = x2.getValue(), R2 = x2.map(k2, "types"), q2 = [], U2 = false;
          for (let L2 = 0; L2 < R2.length; ++L2)
            L2 === 0 ? q2.push(R2[L2]) : E2(M2.types[L2 - 1]) && E2(M2.types[L2]) ? q2.push([" & ", U2 ? p2(R2[L2]) : R2[L2]]) : !E2(M2.types[L2 - 1]) && !E2(M2.types[L2]) ? q2.push(p2([" &", i2, R2[L2]])) : (L2 > 1 && (U2 = true), q2.push(" & ", L2 > 1 ? p2(R2[L2]) : R2[L2]));
          return n2(q2);
        }
        function v2(x2, T2, k2) {
          let M2 = x2.getValue(), R2 = x2.getParentNode(), q2 = R2.type !== "TypeParameterInstantiation" && R2.type !== "TSTypeParameterInstantiation" && R2.type !== "GenericTypeAnnotation" && R2.type !== "TSTypeReference" && R2.type !== "TSTypeAssertion" && R2.type !== "TupleTypeAnnotation" && R2.type !== "TSTupleType" && !(R2.type === "FunctionTypeParam" && !R2.name && x2.getParentNode(1).this !== R2) && !((R2.type === "TypeAlias" || R2.type === "VariableDeclarator" || R2.type === "TSTypeAliasDeclaration") && _2(T2.originalText, M2)), U2 = H2(M2), L2 = x2.map((j2) => {
            let K2 = k2();
            return U2 || (K2 = d2(2, K2)), t2(j2, K2, T2);
          }, "types");
          if (U2)
            return u2(" | ", L2);
          let Y2 = q2 && !_2(T2.originalText, M2), V2 = [y2([Y2 ? i2 : "", "| "]), u2([i2, "| "], L2)];
          return g2(x2, T2) ? n2([p2(V2), l2]) : R2.type === "TupleTypeAnnotation" && R2.types.length > 1 || R2.type === "TSTupleType" && R2.elementTypes.length > 1 ? n2([p2([y2(["(", l2]), V2]), l2, y2(")")]) : n2(q2 ? p2(V2) : V2);
        }
        function o2(x2, T2, k2) {
          let M2 = x2.getValue(), R2 = [], q2 = x2.getParentNode(0), U2 = x2.getParentNode(1), L2 = x2.getParentNode(2), Y2 = M2.type === "TSFunctionType" || !((q2.type === "ObjectTypeProperty" || q2.type === "ObjectTypeInternalSlot") && !q2.variance && !q2.optional && c2(q2) === c2(M2) || q2.type === "ObjectTypeCallProperty" || L2 && L2.type === "DeclareFunction"), V2 = Y2 && (q2.type === "TypeAnnotation" || q2.type === "TSTypeAnnotation"), j2 = V2 && Y2 && (q2.type === "TypeAnnotation" || q2.type === "TSTypeAnnotation") && U2.type === "ArrowFunctionExpression";
          w2(q2) && (Y2 = true, V2 = true), j2 && R2.push("(");
          let K2 = N2(x2, k2, T2, false, true), se2 = M2.returnType || M2.predicate || M2.typeAnnotation ? [Y2 ? " => " : ": ", k2("returnType"), k2("predicate"), k2("typeAnnotation")] : "", Q2 = I2(M2, se2);
          return R2.push(Q2 ? n2(K2) : K2), se2 && R2.push(se2), j2 && R2.push(")"), n2(R2);
        }
        function h2(x2, T2, k2) {
          let M2 = x2.getValue(), R2 = M2.type === "TSTupleType" ? "elementTypes" : "types", q2 = M2[R2], U2 = a2(q2), L2 = U2 ? l2 : "";
          return n2(["[", p2([L2, P2(x2, T2, R2, k2)]), y2(U2 && F2(T2, "all") ? "," : ""), s2(x2, T2, true), L2, "]"]);
        }
        function C2(x2, T2, k2) {
          let M2 = x2.getValue(), R2 = M2.type === "OptionalIndexedAccessType" && M2.optional ? "?.[" : "[";
          return [k2("objectType"), R2, k2("indexType"), "]"];
        }
        function S2(x2, T2, k2) {
          let M2 = x2.getValue();
          return [M2.postfix ? "" : k2, T2("typeAnnotation"), M2.postfix ? k2 : ""];
        }
        r2.exports = { printOpaqueType: f2, printTypeAlias: b2, printIntersectionType: m2, printUnionType: v2, printFunctionType: o2, printTupleType: h2, printIndexedAccessType: C2, shouldHugType: H2, printJSDocType: S2 };
      } }), jr2 = Z2({ "src/language-js/print/type-parameters.js"(e25, r2) {
        ne2();
        var { printDanglingComments: t2 } = et2(), { builders: { join: s2, line: a2, hardline: n2, softline: u2, group: i2, indent: l2, ifBreak: p2 } } = Me2(), { isTestCall: d2, hasComment: y2, CommentCheckFlags: g2, isTSXFile: c2, shouldPrintComma: D2, getFunctionParameters: E2, isObjectType: _2 } = Ke2(), { createGroupIdMapper: w2 } = Ue2(), { shouldHugType: F2 } = Or2(), { isArrowFunctionVariableDeclarator: A2 } = tr2(), N2 = w2("typeParameters");
        function I2(f2, b2, m2, v2) {
          let o2 = f2.getValue();
          if (!o2[v2])
            return "";
          if (!Array.isArray(o2[v2]))
            return m2(v2);
          let h2 = f2.getNode(2), C2 = h2 && d2(h2), S2 = f2.match((k2) => !(k2[v2].length === 1 && _2(k2[v2][0])), void 0, (k2, M2) => M2 === "typeAnnotation", (k2) => k2.type === "Identifier", A2);
          if (o2[v2].length === 0 || !S2 && (C2 || o2[v2].length === 1 && (o2[v2][0].type === "NullableTypeAnnotation" || F2(o2[v2][0]))))
            return ["<", s2(", ", f2.map(m2, v2)), P2(f2, b2), ">"];
          let T2 = o2.type === "TSTypeParameterInstantiation" ? "" : E2(o2).length === 1 && c2(b2) && !o2[v2][0].constraint && f2.getParentNode().type === "ArrowFunctionExpression" ? "," : D2(b2, "all") ? p2(",") : "";
          return i2(["<", l2([u2, s2([",", a2], f2.map(m2, v2))]), T2, u2, ">"], { id: N2(o2) });
        }
        function P2(f2, b2) {
          let m2 = f2.getValue();
          if (!y2(m2, g2.Dangling))
            return "";
          let v2 = !y2(m2, g2.Line), o2 = t2(f2, b2, v2);
          return v2 ? o2 : [o2, n2];
        }
        function H2(f2, b2, m2) {
          let v2 = f2.getValue(), o2 = [], h2 = f2.getParentNode();
          return h2.type === "TSMappedType" ? (o2.push("[", m2("name")), v2.constraint && o2.push(" in ", m2("constraint")), h2.nameType && o2.push(" as ", f2.callParent(() => m2("nameType"))), o2.push("]"), o2) : (v2.variance && o2.push(m2("variance")), v2.in && o2.push("in "), v2.out && o2.push("out "), o2.push(m2("name")), v2.bound && o2.push(": ", m2("bound")), v2.constraint && o2.push(" extends ", m2("constraint")), v2.default && o2.push(" = ", m2("default")), o2);
        }
        r2.exports = { printTypeParameter: H2, printTypeParameters: I2, getTypeParametersGroupId: N2 };
      } }), rr2 = Z2({ "src/language-js/print/property.js"(e25, r2) {
        ne2();
        var { printComments: t2 } = et2(), { printString: s2, printNumber: a2 } = Ue2(), { isNumericLiteral: n2, isSimpleNumber: u2, isStringLiteral: i2, isStringPropSafeToUnquote: l2, rawText: p2 } = Ke2(), { printAssignment: d2 } = tr2(), y2 = new WeakMap();
        function g2(D2, E2, _2) {
          let w2 = D2.getNode();
          if (w2.computed)
            return ["[", _2("key"), "]"];
          let F2 = D2.getParentNode(), { key: A2 } = w2;
          if (E2.quoteProps === "consistent" && !y2.has(F2)) {
            let N2 = (F2.properties || F2.body || F2.members).some((I2) => !I2.computed && I2.key && i2(I2.key) && !l2(I2, E2));
            y2.set(F2, N2);
          }
          if ((A2.type === "Identifier" || n2(A2) && u2(a2(p2(A2))) && String(A2.value) === a2(p2(A2)) && !(E2.parser === "typescript" || E2.parser === "babel-ts")) && (E2.parser === "json" || E2.quoteProps === "consistent" && y2.get(F2))) {
            let N2 = s2(JSON.stringify(A2.type === "Identifier" ? A2.name : A2.value.toString()), E2);
            return D2.call((I2) => t2(I2, N2, E2), "key");
          }
          return l2(w2, E2) && (E2.quoteProps === "as-needed" || E2.quoteProps === "consistent" && !y2.get(F2)) ? D2.call((N2) => t2(N2, /^\d/.test(A2.value) ? a2(A2.value) : A2.value, E2), "key") : _2("key");
        }
        function c2(D2, E2, _2) {
          return D2.getValue().shorthand ? _2("value") : d2(D2, E2, _2, g2(D2, E2, _2), ":", "value");
        }
        r2.exports = { printProperty: c2, printPropertyKey: g2 };
      } }), qr2 = Z2({ "src/language-js/print/function.js"(e25, r2) {
        ne2();
        var t2 = Zt2(), { printDanglingComments: s2, printCommentsSeparately: a2 } = et2(), n2 = lt2(), { getNextNonSpaceNonCommentCharacterIndex: u2 } = Ue2(), { builders: { line: i2, softline: l2, group: p2, indent: d2, ifBreak: y2, hardline: g2, join: c2, indentIfBreak: D2 }, utils: { removeLines: E2, willBreak: _2 } } = Me2(), { ArgExpansionBailout: w2 } = Qt2(), { getFunctionParameters: F2, hasLeadingOwnLineComment: A2, isFlowAnnotationComment: N2, isJsxNode: I2, isTemplateOnItsOwnLine: P2, shouldPrintComma: H2, startsWithNoLookaheadToken: f2, isBinaryish: b2, isLineComment: m2, hasComment: v2, getComments: o2, CommentCheckFlags: h2, isCallLikeExpression: C2, isCallExpression: S2, getCallArguments: x2, hasNakedLeftSide: T2, getLeftSide: k2 } = Ke2(), { locEnd: M2 } = ut2(), { printFunctionParameters: R2, shouldGroupFunctionParameters: q2 } = Lr2(), { printPropertyKey: U2 } = rr2(), { printFunctionTypeParameters: L2 } = ct2();
        function Y2(ue2, J2, le2, ge2) {
          let pe2 = ue2.getValue(), Ae2 = false;
          if ((pe2.type === "FunctionDeclaration" || pe2.type === "FunctionExpression") && ge2 && ge2.expandLastArg) {
            let _e2 = ue2.getParentNode();
            S2(_e2) && x2(_e2).length > 1 && (Ae2 = true);
          }
          let Ce2 = [];
          pe2.type === "TSDeclareFunction" && pe2.declare && Ce2.push("declare "), pe2.async && Ce2.push("async "), pe2.generator ? Ce2.push("function* ") : Ce2.push("function "), pe2.id && Ce2.push(J2("id"));
          let Oe2 = R2(ue2, J2, le2, Ae2), Ie2 = X2(ue2, J2, le2), we2 = q2(pe2, Ie2);
          return Ce2.push(L2(ue2, le2, J2), p2([we2 ? p2(Oe2) : Oe2, Ie2]), pe2.body ? " " : "", J2("body")), le2.semi && (pe2.declare || !pe2.body) && Ce2.push(";"), Ce2;
        }
        function V2(ue2, J2, le2) {
          let ge2 = ue2.getNode(), { kind: pe2 } = ge2, Ae2 = ge2.value || ge2, Ce2 = [];
          return !pe2 || pe2 === "init" || pe2 === "method" || pe2 === "constructor" ? Ae2.async && Ce2.push("async ") : (t2.ok(pe2 === "get" || pe2 === "set"), Ce2.push(pe2, " ")), Ae2.generator && Ce2.push("*"), Ce2.push(U2(ue2, J2, le2), ge2.optional || ge2.key.optional ? "?" : ""), ge2 === Ae2 ? Ce2.push(j2(ue2, J2, le2)) : Ae2.type === "FunctionExpression" ? Ce2.push(ue2.call((Oe2) => j2(Oe2, J2, le2), "value")) : Ce2.push(le2("value")), Ce2;
        }
        function j2(ue2, J2, le2) {
          let ge2 = ue2.getNode(), pe2 = R2(ue2, le2, J2), Ae2 = X2(ue2, le2, J2), Ce2 = q2(ge2, Ae2), Oe2 = [L2(ue2, J2, le2), p2([Ce2 ? p2(pe2) : pe2, Ae2])];
          return ge2.body ? Oe2.push(" ", le2("body")) : Oe2.push(J2.semi ? ";" : ""), Oe2;
        }
        function K2(ue2, J2, le2, ge2) {
          let pe2 = ue2.getValue(), Ae2 = [];
          if (pe2.async && Ae2.push("async "), W2(ue2, J2))
            Ae2.push(le2(["params", 0]));
          else {
            let Oe2 = ge2 && (ge2.expandLastArg || ge2.expandFirstArg), Ie2 = X2(ue2, le2, J2);
            if (Oe2) {
              if (_2(Ie2))
                throw new w2();
              Ie2 = p2(E2(Ie2));
            }
            Ae2.push(p2([R2(ue2, le2, J2, Oe2, true), Ie2]));
          }
          let Ce2 = s2(ue2, J2, true, (Oe2) => {
            let Ie2 = u2(J2.originalText, Oe2, M2);
            return Ie2 !== false && J2.originalText.slice(Ie2, Ie2 + 2) === "=>";
          });
          return Ce2 && Ae2.push(" ", Ce2), Ae2;
        }
        function se2(ue2, J2, le2, ge2, pe2, Ae2) {
          let Ce2 = ue2.getName(), Oe2 = ue2.getParentNode(), Ie2 = C2(Oe2) && Ce2 === "callee", we2 = Boolean(J2 && J2.assignmentLayout), _e2 = Ae2.body.type !== "BlockStatement" && Ae2.body.type !== "ObjectExpression" && Ae2.body.type !== "SequenceExpression", De2 = Ie2 && _e2 || J2 && J2.assignmentLayout === "chain-tail-arrow-chain", G2 = Symbol("arrow-chain");
          return Ae2.body.type === "SequenceExpression" && (pe2 = p2(["(", d2([l2, pe2]), l2, ")"])), p2([p2(d2([Ie2 || we2 ? l2 : "", p2(c2([" =>", i2], le2), { shouldBreak: ge2 })]), { id: G2, shouldBreak: De2 }), " =>", D2(_e2 ? d2([i2, pe2]) : [" ", pe2], { groupId: G2 }), Ie2 ? y2(l2, "", { groupId: G2 }) : ""]);
        }
        function Q2(ue2, J2, le2, ge2) {
          let pe2 = ue2.getValue(), Ae2 = [], Ce2 = [], Oe2 = false;
          if (function G2() {
            let oe2 = K2(ue2, J2, le2, ge2);
            if (Ae2.length === 0)
              Ae2.push(oe2);
            else {
              let { leading: ee2, trailing: re2 } = a2(ue2, J2);
              Ae2.push([ee2, oe2]), Ce2.unshift(re2);
            }
            Oe2 = Oe2 || pe2.returnType && F2(pe2).length > 0 || pe2.typeParameters || F2(pe2).some((ee2) => ee2.type !== "Identifier"), pe2.body.type !== "ArrowFunctionExpression" || ge2 && ge2.expandLastArg ? Ce2.unshift(le2("body", ge2)) : (pe2 = pe2.body, ue2.call(G2, "body"));
          }(), Ae2.length > 1)
            return se2(ue2, ge2, Ae2, Oe2, Ce2, pe2);
          let Ie2 = Ae2;
          if (Ie2.push(" =>"), !A2(J2.originalText, pe2.body) && (pe2.body.type === "ArrayExpression" || pe2.body.type === "ObjectExpression" || pe2.body.type === "BlockStatement" || I2(pe2.body) || P2(pe2.body, J2.originalText) || pe2.body.type === "ArrowFunctionExpression" || pe2.body.type === "DoExpression"))
            return p2([...Ie2, " ", Ce2]);
          if (pe2.body.type === "SequenceExpression")
            return p2([...Ie2, p2([" (", d2([l2, Ce2]), l2, ")"])]);
          let we2 = (ge2 && ge2.expandLastArg || ue2.getParentNode().type === "JSXExpressionContainer") && !v2(pe2), _e2 = ge2 && ge2.expandLastArg && H2(J2, "all"), De2 = pe2.body.type === "ConditionalExpression" && !f2(pe2.body, (G2) => G2.type === "ObjectExpression");
          return p2([...Ie2, p2([d2([i2, De2 ? y2("", "(") : "", Ce2, De2 ? y2("", ")") : ""]), we2 ? [y2(_e2 ? "," : ""), l2] : ""])]);
        }
        function ce2(ue2) {
          let J2 = F2(ue2);
          return J2.length === 1 && !ue2.typeParameters && !v2(ue2, h2.Dangling) && J2[0].type === "Identifier" && !J2[0].typeAnnotation && !v2(J2[0]) && !J2[0].optional && !ue2.predicate && !ue2.returnType;
        }
        function W2(ue2, J2) {
          if (J2.arrowParens === "always")
            return false;
          if (J2.arrowParens === "avoid") {
            let le2 = ue2.getValue();
            return ce2(le2);
          }
          return false;
        }
        function X2(ue2, J2, le2) {
          let ge2 = ue2.getValue(), pe2 = J2("returnType");
          if (ge2.returnType && N2(le2.originalText, ge2.returnType))
            return [" /*: ", pe2, " */"];
          let Ae2 = [pe2];
          return ge2.returnType && ge2.returnType.typeAnnotation && Ae2.unshift(": "), ge2.predicate && Ae2.push(ge2.returnType ? " " : ": ", J2("predicate")), Ae2;
        }
        function de2(ue2, J2, le2) {
          let ge2 = ue2.getValue(), pe2 = J2.semi ? ";" : "", Ae2 = [];
          ge2.argument && (z2(J2, ge2.argument) ? Ae2.push([" (", d2([g2, le2("argument")]), g2, ")"]) : b2(ge2.argument) || ge2.argument.type === "SequenceExpression" ? Ae2.push(p2([y2(" (", " "), d2([l2, le2("argument")]), l2, y2(")")])) : Ae2.push(" ", le2("argument")));
          let Ce2 = o2(ge2), Oe2 = n2(Ce2), Ie2 = Oe2 && m2(Oe2);
          return Ie2 && Ae2.push(pe2), v2(ge2, h2.Dangling) && Ae2.push(" ", s2(ue2, J2, true)), Ie2 || Ae2.push(pe2), Ae2;
        }
        function ie2(ue2, J2, le2) {
          return ["return", de2(ue2, J2, le2)];
        }
        function Ee2(ue2, J2, le2) {
          return ["throw", de2(ue2, J2, le2)];
        }
        function z2(ue2, J2) {
          if (A2(ue2.originalText, J2))
            return true;
          if (T2(J2)) {
            let le2 = J2, ge2;
            for (; ge2 = k2(le2); )
              if (le2 = ge2, A2(ue2.originalText, le2))
                return true;
          }
          return false;
        }
        r2.exports = { printFunction: Y2, printArrowFunction: Q2, printMethod: V2, printReturnStatement: ie2, printThrowStatement: Ee2, printMethodInternal: j2, shouldPrintParamsWithoutParens: W2 };
      } }), nu2 = Z2({ "src/language-js/print/decorators.js"(e25, r2) {
        ne2();
        var { isNonEmptyArray: t2, hasNewline: s2 } = Ue2(), { builders: { line: a2, hardline: n2, join: u2, breakParent: i2, group: l2 } } = Me2(), { locStart: p2, locEnd: d2 } = ut2(), { getParentExportDeclaration: y2 } = Ke2();
        function g2(w2, F2, A2) {
          let N2 = w2.getValue();
          return l2([u2(a2, w2.map(A2, "decorators")), E2(N2, F2) ? n2 : a2]);
        }
        function c2(w2, F2, A2) {
          return [u2(n2, w2.map(A2, "declaration", "decorators")), n2];
        }
        function D2(w2, F2, A2) {
          let N2 = w2.getValue(), { decorators: I2 } = N2;
          if (!t2(I2) || _2(w2.getParentNode()))
            return;
          let P2 = N2.type === "ClassExpression" || N2.type === "ClassDeclaration" || E2(N2, F2);
          return [y2(w2) ? n2 : P2 ? i2 : "", u2(a2, w2.map(A2, "decorators")), a2];
        }
        function E2(w2, F2) {
          return w2.decorators.some((A2) => s2(F2.originalText, d2(A2)));
        }
        function _2(w2) {
          if (w2.type !== "ExportDefaultDeclaration" && w2.type !== "ExportNamedDeclaration" && w2.type !== "DeclareExportDeclaration")
            return false;
          let F2 = w2.declaration && w2.declaration.decorators;
          return t2(F2) && p2(w2) === p2(F2[0]);
        }
        r2.exports = { printDecorators: D2, printClassMemberDecorators: g2, printDecoratorsBeforeExport: c2, hasDecoratorsBeforeExport: _2 };
      } }), nr2 = Z2({ "src/language-js/print/class.js"(e25, r2) {
        ne2();
        var { isNonEmptyArray: t2, createGroupIdMapper: s2 } = Ue2(), { printComments: a2, printDanglingComments: n2 } = et2(), { builders: { join: u2, line: i2, hardline: l2, softline: p2, group: d2, indent: y2, ifBreak: g2 } } = Me2(), { hasComment: c2, CommentCheckFlags: D2 } = Ke2(), { getTypeParametersGroupId: E2 } = jr2(), { printMethod: _2 } = qr2(), { printOptionalToken: w2, printTypeAnnotation: F2, printDefiniteToken: A2 } = ct2(), { printPropertyKey: N2 } = rr2(), { printAssignment: I2 } = tr2(), { printClassMemberDecorators: P2 } = nu2();
        function H2(x2, T2, k2) {
          let M2 = x2.getValue(), R2 = [];
          M2.declare && R2.push("declare "), M2.abstract && R2.push("abstract "), R2.push("class");
          let q2 = M2.id && c2(M2.id, D2.Trailing) || M2.typeParameters && c2(M2.typeParameters, D2.Trailing) || M2.superClass && c2(M2.superClass) || t2(M2.extends) || t2(M2.mixins) || t2(M2.implements), U2 = [], L2 = [];
          if (M2.id && U2.push(" ", k2("id")), U2.push(k2("typeParameters")), M2.superClass) {
            let Y2 = [h2(x2, T2, k2), k2("superTypeParameters")], V2 = x2.call((j2) => ["extends ", a2(j2, Y2, T2)], "superClass");
            q2 ? L2.push(i2, d2(V2)) : L2.push(" ", V2);
          } else
            L2.push(o2(x2, T2, k2, "extends"));
          if (L2.push(o2(x2, T2, k2, "mixins"), o2(x2, T2, k2, "implements")), q2) {
            let Y2;
            v2(M2) ? Y2 = [...U2, y2(L2)] : Y2 = y2([...U2, L2]), R2.push(d2(Y2, { id: f2(M2) }));
          } else
            R2.push(...U2, ...L2);
          return R2.push(" ", k2("body")), R2;
        }
        var f2 = s2("heritageGroup");
        function b2(x2) {
          return g2(l2, "", { groupId: f2(x2) });
        }
        function m2(x2) {
          return ["superClass", "extends", "mixins", "implements"].filter((T2) => Boolean(x2[T2])).length > 1;
        }
        function v2(x2) {
          return x2.typeParameters && !c2(x2.typeParameters, D2.Trailing | D2.Line) && !m2(x2);
        }
        function o2(x2, T2, k2, M2) {
          let R2 = x2.getValue();
          if (!t2(R2[M2]))
            return "";
          let q2 = n2(x2, T2, true, (U2) => {
            let { marker: L2 } = U2;
            return L2 === M2;
          });
          return [v2(R2) ? g2(" ", i2, { groupId: E2(R2.typeParameters) }) : i2, q2, q2 && l2, M2, d2(y2([i2, u2([",", i2], x2.map(k2, M2))]))];
        }
        function h2(x2, T2, k2) {
          let M2 = k2("superClass");
          return x2.getParentNode().type === "AssignmentExpression" ? d2(g2(["(", y2([p2, M2]), p2, ")"], M2)) : M2;
        }
        function C2(x2, T2, k2) {
          let M2 = x2.getValue(), R2 = [];
          return t2(M2.decorators) && R2.push(P2(x2, T2, k2)), M2.accessibility && R2.push(M2.accessibility + " "), M2.readonly && R2.push("readonly "), M2.declare && R2.push("declare "), M2.static && R2.push("static "), (M2.type === "TSAbstractMethodDefinition" || M2.abstract) && R2.push("abstract "), M2.override && R2.push("override "), R2.push(_2(x2, T2, k2)), R2;
        }
        function S2(x2, T2, k2) {
          let M2 = x2.getValue(), R2 = [], q2 = T2.semi ? ";" : "";
          return t2(M2.decorators) && R2.push(P2(x2, T2, k2)), M2.accessibility && R2.push(M2.accessibility + " "), M2.declare && R2.push("declare "), M2.static && R2.push("static "), (M2.type === "TSAbstractPropertyDefinition" || M2.type === "TSAbstractAccessorProperty" || M2.abstract) && R2.push("abstract "), M2.override && R2.push("override "), M2.readonly && R2.push("readonly "), M2.variance && R2.push(k2("variance")), (M2.type === "ClassAccessorProperty" || M2.type === "AccessorProperty" || M2.type === "TSAbstractAccessorProperty") && R2.push("accessor "), R2.push(N2(x2, T2, k2), w2(x2), A2(x2), F2(x2, T2, k2)), [I2(x2, T2, k2, R2, " =", "value"), q2];
        }
        r2.exports = { printClass: H2, printClassMethod: C2, printClassProperty: S2, printHardlineAfterHeritage: b2 };
      } }), bo2 = Z2({ "src/language-js/print/interface.js"(e25, r2) {
        ne2();
        var { isNonEmptyArray: t2 } = Ue2(), { builders: { join: s2, line: a2, group: n2, indent: u2, ifBreak: i2 } } = Me2(), { hasComment: l2, identity: p2, CommentCheckFlags: d2 } = Ke2(), { getTypeParametersGroupId: y2 } = jr2(), { printTypeScriptModifiers: g2 } = ct2();
        function c2(D2, E2, _2) {
          let w2 = D2.getValue(), F2 = [];
          w2.declare && F2.push("declare "), w2.type === "TSInterfaceDeclaration" && F2.push(w2.abstract ? "abstract " : "", g2(D2, E2, _2)), F2.push("interface");
          let A2 = [], N2 = [];
          w2.type !== "InterfaceTypeAnnotation" && A2.push(" ", _2("id"), _2("typeParameters"));
          let I2 = w2.typeParameters && !l2(w2.typeParameters, d2.Trailing | d2.Line);
          return t2(w2.extends) && N2.push(I2 ? i2(" ", a2, { groupId: y2(w2.typeParameters) }) : a2, "extends ", (w2.extends.length === 1 ? p2 : u2)(s2([",", a2], D2.map(_2, "extends")))), w2.id && l2(w2.id, d2.Trailing) || t2(w2.extends) ? I2 ? F2.push(n2([...A2, u2(N2)])) : F2.push(n2(u2([...A2, ...N2]))) : F2.push(...A2, ...N2), F2.push(" ", _2("body")), n2(F2);
        }
        r2.exports = { printInterface: c2 };
      } }), To2 = Z2({ "src/language-js/print/module.js"(e25, r2) {
        ne2();
        var { isNonEmptyArray: t2 } = Ue2(), { builders: { softline: s2, group: a2, indent: n2, join: u2, line: i2, ifBreak: l2, hardline: p2 } } = Me2(), { printDanglingComments: d2 } = et2(), { hasComment: y2, CommentCheckFlags: g2, shouldPrintComma: c2, needsHardlineAfterDanglingComment: D2, isStringLiteral: E2, rawText: _2 } = Ke2(), { locStart: w2, hasSameLoc: F2 } = ut2(), { hasDecoratorsBeforeExport: A2, printDecoratorsBeforeExport: N2 } = nu2();
        function I2(S2, x2, T2) {
          let k2 = S2.getValue(), M2 = x2.semi ? ";" : "", R2 = [], { importKind: q2 } = k2;
          return R2.push("import"), q2 && q2 !== "value" && R2.push(" ", q2), R2.push(m2(S2, x2, T2), b2(S2, x2, T2), o2(S2, x2, T2), M2), R2;
        }
        function P2(S2, x2, T2) {
          let k2 = S2.getValue(), M2 = [];
          A2(k2) && M2.push(N2(S2, x2, T2));
          let { type: R2, exportKind: q2, declaration: U2 } = k2;
          return M2.push("export"), (k2.default || R2 === "ExportDefaultDeclaration") && M2.push(" default"), y2(k2, g2.Dangling) && (M2.push(" ", d2(S2, x2, true)), D2(k2) && M2.push(p2)), U2 ? M2.push(" ", T2("declaration")) : M2.push(q2 === "type" ? " type" : "", m2(S2, x2, T2), b2(S2, x2, T2), o2(S2, x2, T2)), f2(k2, x2) && M2.push(";"), M2;
        }
        function H2(S2, x2, T2) {
          let k2 = S2.getValue(), M2 = x2.semi ? ";" : "", R2 = [], { exportKind: q2, exported: U2 } = k2;
          return R2.push("export"), q2 === "type" && R2.push(" type"), R2.push(" *"), U2 && R2.push(" as ", T2("exported")), R2.push(b2(S2, x2, T2), o2(S2, x2, T2), M2), R2;
        }
        function f2(S2, x2) {
          if (!x2.semi)
            return false;
          let { type: T2, declaration: k2 } = S2, M2 = S2.default || T2 === "ExportDefaultDeclaration";
          if (!k2)
            return true;
          let { type: R2 } = k2;
          return !!(M2 && R2 !== "ClassDeclaration" && R2 !== "FunctionDeclaration" && R2 !== "TSInterfaceDeclaration" && R2 !== "DeclareClass" && R2 !== "DeclareFunction" && R2 !== "TSDeclareFunction" && R2 !== "EnumDeclaration");
        }
        function b2(S2, x2, T2) {
          let k2 = S2.getValue();
          if (!k2.source)
            return "";
          let M2 = [];
          return v2(k2, x2) || M2.push(" from"), M2.push(" ", T2("source")), M2;
        }
        function m2(S2, x2, T2) {
          let k2 = S2.getValue();
          if (v2(k2, x2))
            return "";
          let M2 = [" "];
          if (t2(k2.specifiers)) {
            let R2 = [], q2 = [];
            S2.each(() => {
              let U2 = S2.getValue().type;
              if (U2 === "ExportNamespaceSpecifier" || U2 === "ExportDefaultSpecifier" || U2 === "ImportNamespaceSpecifier" || U2 === "ImportDefaultSpecifier")
                R2.push(T2());
              else if (U2 === "ExportSpecifier" || U2 === "ImportSpecifier")
                q2.push(T2());
              else
                throw new Error(`Unknown specifier type ${JSON.stringify(U2)}`);
            }, "specifiers"), M2.push(u2(", ", R2)), q2.length > 0 && (R2.length > 0 && M2.push(", "), q2.length > 1 || R2.length > 0 || k2.specifiers.some((L2) => y2(L2)) ? M2.push(a2(["{", n2([x2.bracketSpacing ? i2 : s2, u2([",", i2], q2)]), l2(c2(x2) ? "," : ""), x2.bracketSpacing ? i2 : s2, "}"])) : M2.push(["{", x2.bracketSpacing ? " " : "", ...q2, x2.bracketSpacing ? " " : "", "}"]));
          } else
            M2.push("{}");
          return M2;
        }
        function v2(S2, x2) {
          let { type: T2, importKind: k2, source: M2, specifiers: R2 } = S2;
          return T2 !== "ImportDeclaration" || t2(R2) || k2 === "type" ? false : !/{\s*}/.test(x2.originalText.slice(w2(S2), w2(M2)));
        }
        function o2(S2, x2, T2) {
          let k2 = S2.getNode();
          return t2(k2.assertions) ? [" assert {", x2.bracketSpacing ? " " : "", u2(", ", S2.map(T2, "assertions")), x2.bracketSpacing ? " " : "", "}"] : "";
        }
        function h2(S2, x2, T2) {
          let k2 = S2.getNode(), { type: M2 } = k2, R2 = [], q2 = M2 === "ImportSpecifier" ? k2.importKind : k2.exportKind;
          q2 && q2 !== "value" && R2.push(q2, " ");
          let U2 = M2.startsWith("Import"), L2 = U2 ? "imported" : "local", Y2 = U2 ? "local" : "exported", V2 = k2[L2], j2 = k2[Y2], K2 = "", se2 = "";
          return M2 === "ExportNamespaceSpecifier" || M2 === "ImportNamespaceSpecifier" ? K2 = "*" : V2 && (K2 = T2(L2)), j2 && !C2(k2) && (se2 = T2(Y2)), R2.push(K2, K2 && se2 ? " as " : "", se2), R2;
        }
        function C2(S2) {
          if (S2.type !== "ImportSpecifier" && S2.type !== "ExportSpecifier")
            return false;
          let { local: x2, [S2.type === "ImportSpecifier" ? "imported" : "exported"]: T2 } = S2;
          if (x2.type !== T2.type || !F2(x2, T2))
            return false;
          if (E2(x2))
            return x2.value === T2.value && _2(x2) === _2(T2);
          switch (x2.type) {
            case "Identifier":
              return x2.name === T2.name;
            default:
              return false;
          }
        }
        r2.exports = { printImportDeclaration: I2, printExportDeclaration: P2, printExportAllDeclaration: H2, printModuleSpecifier: h2 };
      } }), uu2 = Z2({ "src/language-js/print/object.js"(e25, r2) {
        ne2();
        var { printDanglingComments: t2 } = et2(), { builders: { line: s2, softline: a2, group: n2, indent: u2, ifBreak: i2, hardline: l2 } } = Me2(), { getLast: p2, hasNewlineInRange: d2, hasNewline: y2, isNonEmptyArray: g2 } = Ue2(), { shouldPrintComma: c2, hasComment: D2, getComments: E2, CommentCheckFlags: _2, isNextLineEmpty: w2 } = Ke2(), { locStart: F2, locEnd: A2 } = ut2(), { printOptionalToken: N2, printTypeAnnotation: I2 } = ct2(), { shouldHugFunctionParameters: P2 } = Lr2(), { shouldHugType: H2 } = Or2(), { printHardlineAfterHeritage: f2 } = nr2();
        function b2(m2, v2, o2) {
          let h2 = v2.semi ? ";" : "", C2 = m2.getValue(), S2;
          C2.type === "TSTypeLiteral" ? S2 = "members" : C2.type === "TSInterfaceBody" ? S2 = "body" : S2 = "properties";
          let x2 = C2.type === "ObjectTypeAnnotation", T2 = [S2];
          x2 && T2.push("indexers", "callProperties", "internalSlots");
          let k2 = T2.map((W2) => C2[W2][0]).sort((W2, X2) => F2(W2) - F2(X2))[0], M2 = m2.getParentNode(0), R2 = x2 && M2 && (M2.type === "InterfaceDeclaration" || M2.type === "DeclareInterface" || M2.type === "DeclareClass") && m2.getName() === "body", q2 = C2.type === "TSInterfaceBody" || R2 || C2.type === "ObjectPattern" && M2.type !== "FunctionDeclaration" && M2.type !== "FunctionExpression" && M2.type !== "ArrowFunctionExpression" && M2.type !== "ObjectMethod" && M2.type !== "ClassMethod" && M2.type !== "ClassPrivateMethod" && M2.type !== "AssignmentPattern" && M2.type !== "CatchClause" && C2.properties.some((W2) => W2.value && (W2.value.type === "ObjectPattern" || W2.value.type === "ArrayPattern")) || C2.type !== "ObjectPattern" && k2 && d2(v2.originalText, F2(C2), F2(k2)), U2 = R2 ? ";" : C2.type === "TSInterfaceBody" || C2.type === "TSTypeLiteral" ? i2(h2, ";") : ",", L2 = C2.type === "RecordExpression" ? "#{" : C2.exact ? "{|" : "{", Y2 = C2.exact ? "|}" : "}", V2 = [];
          for (let W2 of T2)
            m2.each((X2) => {
              let de2 = X2.getValue();
              V2.push({ node: de2, printed: o2(), loc: F2(de2) });
            }, W2);
          T2.length > 1 && V2.sort((W2, X2) => W2.loc - X2.loc);
          let j2 = [], K2 = V2.map((W2) => {
            let X2 = [...j2, n2(W2.printed)];
            return j2 = [U2, s2], (W2.node.type === "TSPropertySignature" || W2.node.type === "TSMethodSignature" || W2.node.type === "TSConstructSignatureDeclaration") && D2(W2.node, _2.PrettierIgnore) && j2.shift(), w2(W2.node, v2) && j2.push(l2), X2;
          });
          if (C2.inexact) {
            let W2;
            if (D2(C2, _2.Dangling)) {
              let X2 = D2(C2, _2.Line);
              W2 = [t2(m2, v2, true), X2 || y2(v2.originalText, A2(p2(E2(C2)))) ? l2 : s2, "..."];
            } else
              W2 = ["..."];
            K2.push([...j2, ...W2]);
          }
          let se2 = p2(C2[S2]), Q2 = !(C2.inexact || se2 && se2.type === "RestElement" || se2 && (se2.type === "TSPropertySignature" || se2.type === "TSCallSignatureDeclaration" || se2.type === "TSMethodSignature" || se2.type === "TSConstructSignatureDeclaration") && D2(se2, _2.PrettierIgnore)), ce2;
          if (K2.length === 0) {
            if (!D2(C2, _2.Dangling))
              return [L2, Y2, I2(m2, v2, o2)];
            ce2 = n2([L2, t2(m2, v2), a2, Y2, N2(m2), I2(m2, v2, o2)]);
          } else
            ce2 = [R2 && g2(C2.properties) ? f2(M2) : "", L2, u2([v2.bracketSpacing ? s2 : a2, ...K2]), i2(Q2 && (U2 !== "," || c2(v2)) ? U2 : ""), v2.bracketSpacing ? s2 : a2, Y2, N2(m2), I2(m2, v2, o2)];
          return m2.match((W2) => W2.type === "ObjectPattern" && !W2.decorators, (W2, X2, de2) => P2(W2) && (X2 === "params" || X2 === "parameters" || X2 === "this" || X2 === "rest") && de2 === 0) || m2.match(H2, (W2, X2) => X2 === "typeAnnotation", (W2, X2) => X2 === "typeAnnotation", (W2, X2, de2) => P2(W2) && (X2 === "params" || X2 === "parameters" || X2 === "this" || X2 === "rest") && de2 === 0) || !q2 && m2.match((W2) => W2.type === "ObjectPattern", (W2) => W2.type === "AssignmentExpression" || W2.type === "VariableDeclarator") ? ce2 : n2(ce2, { shouldBreak: q2 });
        }
        r2.exports = { printObject: b2 };
      } }), md2 = Z2({ "src/language-js/print/flow.js"(e25, r2) {
        ne2();
        var t2 = Zt2(), { printDanglingComments: s2 } = et2(), { printString: a2, printNumber: n2 } = Ue2(), { builders: { hardline: u2, softline: i2, group: l2, indent: p2 } } = Me2(), { getParentExportDeclaration: d2, isFunctionNotation: y2, isGetterOrSetter: g2, rawText: c2, shouldPrintComma: D2 } = Ke2(), { locStart: E2, locEnd: _2 } = ut2(), { replaceTextEndOfLine: w2 } = Yt2(), { printClass: F2 } = nr2(), { printOpaqueType: A2, printTypeAlias: N2, printIntersectionType: I2, printUnionType: P2, printFunctionType: H2, printTupleType: f2, printIndexedAccessType: b2 } = Or2(), { printInterface: m2 } = bo2(), { printTypeParameter: v2, printTypeParameters: o2 } = jr2(), { printExportDeclaration: h2, printExportAllDeclaration: C2 } = To2(), { printArrayItems: S2 } = er2(), { printObject: x2 } = uu2(), { printPropertyKey: T2 } = rr2(), { printOptionalToken: k2, printTypeAnnotation: M2, printRestSpread: R2 } = ct2();
        function q2(L2, Y2, V2) {
          let j2 = L2.getValue(), K2 = Y2.semi ? ";" : "", se2 = [];
          switch (j2.type) {
            case "DeclareClass":
              return U2(L2, F2(L2, Y2, V2));
            case "DeclareFunction":
              return U2(L2, ["function ", V2("id"), j2.predicate ? " " : "", V2("predicate"), K2]);
            case "DeclareModule":
              return U2(L2, ["module ", V2("id"), " ", V2("body")]);
            case "DeclareModuleExports":
              return U2(L2, ["module.exports", ": ", V2("typeAnnotation"), K2]);
            case "DeclareVariable":
              return U2(L2, ["var ", V2("id"), K2]);
            case "DeclareOpaqueType":
              return U2(L2, A2(L2, Y2, V2));
            case "DeclareInterface":
              return U2(L2, m2(L2, Y2, V2));
            case "DeclareTypeAlias":
              return U2(L2, N2(L2, Y2, V2));
            case "DeclareExportDeclaration":
              return U2(L2, h2(L2, Y2, V2));
            case "DeclareExportAllDeclaration":
              return U2(L2, C2(L2, Y2, V2));
            case "OpaqueType":
              return A2(L2, Y2, V2);
            case "TypeAlias":
              return N2(L2, Y2, V2);
            case "IntersectionTypeAnnotation":
              return I2(L2, Y2, V2);
            case "UnionTypeAnnotation":
              return P2(L2, Y2, V2);
            case "FunctionTypeAnnotation":
              return H2(L2, Y2, V2);
            case "TupleTypeAnnotation":
              return f2(L2, Y2, V2);
            case "GenericTypeAnnotation":
              return [V2("id"), o2(L2, Y2, V2, "typeParameters")];
            case "IndexedAccessType":
            case "OptionalIndexedAccessType":
              return b2(L2, Y2, V2);
            case "TypeAnnotation":
              return V2("typeAnnotation");
            case "TypeParameter":
              return v2(L2, Y2, V2);
            case "TypeofTypeAnnotation":
              return ["typeof ", V2("argument")];
            case "ExistsTypeAnnotation":
              return "*";
            case "EmptyTypeAnnotation":
              return "empty";
            case "MixedTypeAnnotation":
              return "mixed";
            case "ArrayTypeAnnotation":
              return [V2("elementType"), "[]"];
            case "BooleanLiteralTypeAnnotation":
              return String(j2.value);
            case "EnumDeclaration":
              return ["enum ", V2("id"), " ", V2("body")];
            case "EnumBooleanBody":
            case "EnumNumberBody":
            case "EnumStringBody":
            case "EnumSymbolBody": {
              if (j2.type === "EnumSymbolBody" || j2.explicitType) {
                let Q2 = null;
                switch (j2.type) {
                  case "EnumBooleanBody":
                    Q2 = "boolean";
                    break;
                  case "EnumNumberBody":
                    Q2 = "number";
                    break;
                  case "EnumStringBody":
                    Q2 = "string";
                    break;
                  case "EnumSymbolBody":
                    Q2 = "symbol";
                    break;
                }
                se2.push("of ", Q2, " ");
              }
              if (j2.members.length === 0 && !j2.hasUnknownMembers)
                se2.push(l2(["{", s2(L2, Y2), i2, "}"]));
              else {
                let Q2 = j2.members.length > 0 ? [u2, S2(L2, Y2, "members", V2), j2.hasUnknownMembers || D2(Y2) ? "," : ""] : [];
                se2.push(l2(["{", p2([...Q2, ...j2.hasUnknownMembers ? [u2, "..."] : []]), s2(L2, Y2, true), u2, "}"]));
              }
              return se2;
            }
            case "EnumBooleanMember":
            case "EnumNumberMember":
            case "EnumStringMember":
              return [V2("id"), " = ", typeof j2.init == "object" ? V2("init") : String(j2.init)];
            case "EnumDefaultedMember":
              return V2("id");
            case "FunctionTypeParam": {
              let Q2 = j2.name ? V2("name") : L2.getParentNode().this === j2 ? "this" : "";
              return [Q2, k2(L2), Q2 ? ": " : "", V2("typeAnnotation")];
            }
            case "InterfaceDeclaration":
            case "InterfaceTypeAnnotation":
              return m2(L2, Y2, V2);
            case "ClassImplements":
            case "InterfaceExtends":
              return [V2("id"), V2("typeParameters")];
            case "NullableTypeAnnotation":
              return ["?", V2("typeAnnotation")];
            case "Variance": {
              let { kind: Q2 } = j2;
              return t2.ok(Q2 === "plus" || Q2 === "minus"), Q2 === "plus" ? "+" : "-";
            }
            case "ObjectTypeCallProperty":
              return j2.static && se2.push("static "), se2.push(V2("value")), se2;
            case "ObjectTypeIndexer":
              return [j2.static ? "static " : "", j2.variance ? V2("variance") : "", "[", V2("id"), j2.id ? ": " : "", V2("key"), "]: ", V2("value")];
            case "ObjectTypeProperty": {
              let Q2 = "";
              return j2.proto ? Q2 = "proto " : j2.static && (Q2 = "static "), [Q2, g2(j2) ? j2.kind + " " : "", j2.variance ? V2("variance") : "", T2(L2, Y2, V2), k2(L2), y2(j2) ? "" : ": ", V2("value")];
            }
            case "ObjectTypeAnnotation":
              return x2(L2, Y2, V2);
            case "ObjectTypeInternalSlot":
              return [j2.static ? "static " : "", "[[", V2("id"), "]]", k2(L2), j2.method ? "" : ": ", V2("value")];
            case "ObjectTypeSpreadProperty":
              return R2(L2, Y2, V2);
            case "QualifiedTypeofIdentifier":
            case "QualifiedTypeIdentifier":
              return [V2("qualification"), ".", V2("id")];
            case "StringLiteralTypeAnnotation":
              return w2(a2(c2(j2), Y2));
            case "NumberLiteralTypeAnnotation":
              t2.strictEqual(typeof j2.value, "number");
            case "BigIntLiteralTypeAnnotation":
              return j2.extra ? n2(j2.extra.raw) : n2(j2.raw);
            case "TypeCastExpression":
              return ["(", V2("expression"), M2(L2, Y2, V2), ")"];
            case "TypeParameterDeclaration":
            case "TypeParameterInstantiation": {
              let Q2 = o2(L2, Y2, V2, "params");
              if (Y2.parser === "flow") {
                let ce2 = E2(j2), W2 = _2(j2), X2 = Y2.originalText.lastIndexOf("/*", ce2), de2 = Y2.originalText.indexOf("*/", W2);
                if (X2 !== -1 && de2 !== -1) {
                  let ie2 = Y2.originalText.slice(X2 + 2, de2).trim();
                  if (ie2.startsWith("::") && !ie2.includes("/*") && !ie2.includes("*/"))
                    return ["/*:: ", Q2, " */"];
                }
              }
              return Q2;
            }
            case "InferredPredicate":
              return "%checks";
            case "DeclaredPredicate":
              return ["%checks(", V2("value"), ")"];
            case "AnyTypeAnnotation":
              return "any";
            case "BooleanTypeAnnotation":
              return "boolean";
            case "BigIntTypeAnnotation":
              return "bigint";
            case "NullLiteralTypeAnnotation":
              return "null";
            case "NumberTypeAnnotation":
              return "number";
            case "SymbolTypeAnnotation":
              return "symbol";
            case "StringTypeAnnotation":
              return "string";
            case "VoidTypeAnnotation":
              return "void";
            case "ThisTypeAnnotation":
              return "this";
            case "Node":
            case "Printable":
            case "SourceLocation":
            case "Position":
            case "Statement":
            case "Function":
            case "Pattern":
            case "Expression":
            case "Declaration":
            case "Specifier":
            case "NamedSpecifier":
            case "Comment":
            case "MemberTypeAnnotation":
            case "Type":
              throw new Error("unprintable type: " + JSON.stringify(j2.type));
          }
        }
        function U2(L2, Y2) {
          let V2 = d2(L2);
          return V2 ? (t2.strictEqual(V2.type, "DeclareExportDeclaration"), Y2) : ["declare ", Y2];
        }
        r2.exports = { printFlow: q2 };
      } }), dd2 = Z2({ "src/language-js/utils/is-ts-keyword-type.js"(e25, r2) {
        ne2();
        function t2(s2) {
          let { type: a2 } = s2;
          return a2.startsWith("TS") && a2.endsWith("Keyword");
        }
        r2.exports = t2;
      } }), Bo2 = Z2({ "src/language-js/print/ternary.js"(e25, r2) {
        ne2();
        var { hasNewlineInRange: t2 } = Ue2(), { isJsxNode: s2, getComments: a2, isCallExpression: n2, isMemberExpression: u2, isTSTypeExpression: i2 } = Ke2(), { locStart: l2, locEnd: p2 } = ut2(), d2 = Ot2(), { builders: { line: y2, softline: g2, group: c2, indent: D2, align: E2, ifBreak: _2, dedent: w2, breakParent: F2 } } = Me2();
        function A2(f2) {
          let b2 = [f2];
          for (let m2 = 0; m2 < b2.length; m2++) {
            let v2 = b2[m2];
            for (let o2 of ["test", "consequent", "alternate"]) {
              let h2 = v2[o2];
              if (s2(h2))
                return true;
              h2.type === "ConditionalExpression" && b2.push(h2);
            }
          }
          return false;
        }
        function N2(f2, b2, m2) {
          let v2 = f2.getValue(), o2 = v2.type === "ConditionalExpression", h2 = o2 ? "alternate" : "falseType", C2 = f2.getParentNode(), S2 = o2 ? m2("test") : [m2("checkType"), " ", "extends", " ", m2("extendsType")];
          return C2.type === v2.type && C2[h2] === v2 ? E2(2, S2) : S2;
        }
        var I2 = new Map([["AssignmentExpression", "right"], ["VariableDeclarator", "init"], ["ReturnStatement", "argument"], ["ThrowStatement", "argument"], ["UnaryExpression", "argument"], ["YieldExpression", "argument"]]);
        function P2(f2) {
          let b2 = f2.getValue();
          if (b2.type !== "ConditionalExpression")
            return false;
          let m2, v2 = b2;
          for (let o2 = 0; !m2; o2++) {
            let h2 = f2.getParentNode(o2);
            if (n2(h2) && h2.callee === v2 || u2(h2) && h2.object === v2 || h2.type === "TSNonNullExpression" && h2.expression === v2) {
              v2 = h2;
              continue;
            }
            h2.type === "NewExpression" && h2.callee === v2 || i2(h2) && h2.expression === v2 ? (m2 = f2.getParentNode(o2 + 1), v2 = h2) : m2 = h2;
          }
          return v2 === b2 ? false : m2[I2.get(m2.type)] === v2;
        }
        function H2(f2, b2, m2) {
          let v2 = f2.getValue(), o2 = v2.type === "ConditionalExpression", h2 = o2 ? "consequent" : "trueType", C2 = o2 ? "alternate" : "falseType", S2 = o2 ? ["test"] : ["checkType", "extendsType"], x2 = v2[h2], T2 = v2[C2], k2 = [], M2 = false, R2 = f2.getParentNode(), q2 = R2.type === v2.type && S2.some((ie2) => R2[ie2] === v2), U2 = R2.type === v2.type && !q2, L2, Y2, V2 = 0;
          do
            Y2 = L2 || v2, L2 = f2.getParentNode(V2), V2++;
          while (L2 && L2.type === v2.type && S2.every((ie2) => L2[ie2] !== Y2));
          let j2 = L2 || R2, K2 = Y2;
          if (o2 && (s2(v2[S2[0]]) || s2(x2) || s2(T2) || A2(K2))) {
            M2 = true, U2 = true;
            let ie2 = (z2) => [_2("("), D2([g2, z2]), g2, _2(")")], Ee2 = (z2) => z2.type === "NullLiteral" || z2.type === "Literal" && z2.value === null || z2.type === "Identifier" && z2.name === "undefined";
            k2.push(" ? ", Ee2(x2) ? m2(h2) : ie2(m2(h2)), " : ", T2.type === v2.type || Ee2(T2) ? m2(C2) : ie2(m2(C2)));
          } else {
            let ie2 = [y2, "? ", x2.type === v2.type ? _2("", "(") : "", E2(2, m2(h2)), x2.type === v2.type ? _2("", ")") : "", y2, ": ", T2.type === v2.type ? m2(C2) : E2(2, m2(C2))];
            k2.push(R2.type !== v2.type || R2[C2] === v2 || q2 ? ie2 : b2.useTabs ? w2(D2(ie2)) : E2(Math.max(0, b2.tabWidth - 2), ie2));
          }
          let Q2 = [...S2.map((ie2) => a2(v2[ie2])), a2(x2), a2(T2)].flat().some((ie2) => d2(ie2) && t2(b2.originalText, l2(ie2), p2(ie2))), ce2 = (ie2) => R2 === j2 ? c2(ie2, { shouldBreak: Q2 }) : Q2 ? [ie2, F2] : ie2, W2 = !M2 && (u2(R2) || R2.type === "NGPipeExpression" && R2.left === v2) && !R2.computed, X2 = P2(f2), de2 = ce2([N2(f2, b2, m2), U2 ? k2 : D2(k2), o2 && W2 && !X2 ? g2 : ""]);
          return q2 || X2 ? c2([D2([g2, de2]), g2]) : de2;
        }
        r2.exports = { printTernary: H2 };
      } }), No2 = Z2({ "src/language-js/print/statement.js"(e25, r2) {
        ne2();
        var { builders: { hardline: t2 } } = Me2(), s2 = qt2(), { getLeftSidePathName: a2, hasNakedLeftSide: n2, isJsxNode: u2, isTheOnlyJsxElementInMarkdown: i2, hasComment: l2, CommentCheckFlags: p2, isNextLineEmpty: d2 } = Ke2(), { shouldPrintParamsWithoutParens: y2 } = qr2();
        function g2(N2, I2, P2, H2) {
          let f2 = N2.getValue(), b2 = [], m2 = f2.type === "ClassBody", v2 = c2(f2[H2]);
          return N2.each((o2, h2, C2) => {
            let S2 = o2.getValue();
            if (S2.type === "EmptyStatement")
              return;
            let x2 = P2();
            !I2.semi && !m2 && !i2(I2, o2) && D2(o2, I2) ? l2(S2, p2.Leading) ? b2.push(P2([], { needsSemi: true })) : b2.push(";", x2) : b2.push(x2), !I2.semi && m2 && F2(S2) && A2(S2, C2[h2 + 1]) && b2.push(";"), S2 !== v2 && (b2.push(t2), d2(S2, I2) && b2.push(t2));
          }, H2), b2;
        }
        function c2(N2) {
          for (let I2 = N2.length - 1; I2 >= 0; I2--) {
            let P2 = N2[I2];
            if (P2.type !== "EmptyStatement")
              return P2;
          }
        }
        function D2(N2, I2) {
          return N2.getNode().type !== "ExpressionStatement" ? false : N2.call((H2) => E2(H2, I2), "expression");
        }
        function E2(N2, I2) {
          let P2 = N2.getValue();
          switch (P2.type) {
            case "ParenthesizedExpression":
            case "TypeCastExpression":
            case "ArrayExpression":
            case "ArrayPattern":
            case "TemplateLiteral":
            case "TemplateElement":
            case "RegExpLiteral":
              return true;
            case "ArrowFunctionExpression": {
              if (!y2(N2, I2))
                return true;
              break;
            }
            case "UnaryExpression": {
              let { prefix: H2, operator: f2 } = P2;
              if (H2 && (f2 === "+" || f2 === "-"))
                return true;
              break;
            }
            case "BindExpression": {
              if (!P2.object)
                return true;
              break;
            }
            case "Literal": {
              if (P2.regex)
                return true;
              break;
            }
            default:
              if (u2(P2))
                return true;
          }
          return s2(N2, I2) ? true : n2(P2) ? N2.call((H2) => E2(H2, I2), ...a2(N2, P2)) : false;
        }
        function _2(N2, I2, P2) {
          return g2(N2, I2, P2, "body");
        }
        function w2(N2, I2, P2) {
          return g2(N2, I2, P2, "consequent");
        }
        var F2 = (N2) => {
          let { type: I2 } = N2;
          return I2 === "ClassProperty" || I2 === "PropertyDefinition" || I2 === "ClassPrivateProperty" || I2 === "ClassAccessorProperty" || I2 === "AccessorProperty" || I2 === "TSAbstractPropertyDefinition" || I2 === "TSAbstractAccessorProperty";
        };
        function A2(N2, I2) {
          let { type: P2, name: H2 } = N2.key;
          if (!N2.computed && P2 === "Identifier" && (H2 === "static" || H2 === "get" || H2 === "set" || H2 === "accessor") && !N2.value && !N2.typeAnnotation)
            return true;
          if (!I2 || I2.static || I2.accessibility)
            return false;
          if (!I2.computed) {
            let f2 = I2.key && I2.key.name;
            if (f2 === "in" || f2 === "instanceof")
              return true;
          }
          if (F2(I2) && I2.variance && !I2.static && !I2.declare)
            return true;
          switch (I2.type) {
            case "ClassProperty":
            case "PropertyDefinition":
            case "TSAbstractPropertyDefinition":
              return I2.computed;
            case "MethodDefinition":
            case "TSAbstractMethodDefinition":
            case "ClassMethod":
            case "ClassPrivateMethod": {
              if ((I2.value ? I2.value.async : I2.async) || I2.kind === "get" || I2.kind === "set")
                return false;
              let b2 = I2.value ? I2.value.generator : I2.generator;
              return !!(I2.computed || b2);
            }
            case "TSIndexSignature":
              return true;
          }
          return false;
        }
        r2.exports = { printBody: _2, printSwitchCaseConsequent: w2 };
      } }), wo = Z2({ "src/language-js/print/block.js"(e25, r2) {
        ne2();
        var { printDanglingComments: t2 } = et2(), { isNonEmptyArray: s2 } = Ue2(), { builders: { hardline: a2, indent: n2 } } = Me2(), { hasComment: u2, CommentCheckFlags: i2, isNextLineEmpty: l2 } = Ke2(), { printHardlineAfterHeritage: p2 } = nr2(), { printBody: d2 } = No2();
        function y2(c2, D2, E2) {
          let _2 = c2.getValue(), w2 = [];
          if (_2.type === "StaticBlock" && w2.push("static "), _2.type === "ClassBody" && s2(_2.body)) {
            let A2 = c2.getParentNode();
            w2.push(p2(A2));
          }
          w2.push("{");
          let F2 = g2(c2, D2, E2);
          if (F2)
            w2.push(n2([a2, F2]), a2);
          else {
            let A2 = c2.getParentNode(), N2 = c2.getParentNode(1);
            A2.type === "ArrowFunctionExpression" || A2.type === "FunctionExpression" || A2.type === "FunctionDeclaration" || A2.type === "ObjectMethod" || A2.type === "ClassMethod" || A2.type === "ClassPrivateMethod" || A2.type === "ForStatement" || A2.type === "WhileStatement" || A2.type === "DoWhileStatement" || A2.type === "DoExpression" || A2.type === "CatchClause" && !N2.finalizer || A2.type === "TSModuleDeclaration" || A2.type === "TSDeclareFunction" || _2.type === "StaticBlock" || _2.type === "ClassBody" || w2.push(a2);
          }
          return w2.push("}"), w2;
        }
        function g2(c2, D2, E2) {
          let _2 = c2.getValue(), w2 = s2(_2.directives), F2 = _2.body.some((I2) => I2.type !== "EmptyStatement"), A2 = u2(_2, i2.Dangling);
          if (!w2 && !F2 && !A2)
            return "";
          let N2 = [];
          if (w2 && c2.each((I2, P2, H2) => {
            N2.push(E2()), (P2 < H2.length - 1 || F2 || A2) && (N2.push(a2), l2(I2.getValue(), D2) && N2.push(a2));
          }, "directives"), F2 && N2.push(d2(c2, D2, E2)), A2 && N2.push(t2(c2, D2, true)), _2.type === "Program") {
            let I2 = c2.getParentNode();
            (!I2 || I2.type !== "ModuleExpression") && N2.push(a2);
          }
          return N2;
        }
        r2.exports = { printBlock: y2, printBlockBody: g2 };
      } }), gd2 = Z2({ "src/language-js/print/typescript.js"(e25, r2) {
        ne2();
        var { printDanglingComments: t2 } = et2(), { hasNewlineInRange: s2 } = Ue2(), { builders: { join: a2, line: n2, hardline: u2, softline: i2, group: l2, indent: p2, conditionalGroup: d2, ifBreak: y2 } } = Me2(), { isLiteral: g2, getTypeScriptMappedTypeModifier: c2, shouldPrintComma: D2, isCallExpression: E2, isMemberExpression: _2 } = Ke2(), w2 = dd2(), { locStart: F2, locEnd: A2 } = ut2(), { printOptionalToken: N2, printTypeScriptModifiers: I2 } = ct2(), { printTernary: P2 } = Bo2(), { printFunctionParameters: H2, shouldGroupFunctionParameters: f2 } = Lr2(), { printTemplateLiteral: b2 } = jt2(), { printArrayItems: m2 } = er2(), { printObject: v2 } = uu2(), { printClassProperty: o2, printClassMethod: h2 } = nr2(), { printTypeParameter: C2, printTypeParameters: S2 } = jr2(), { printPropertyKey: x2 } = rr2(), { printFunction: T2, printMethodInternal: k2 } = qr2(), { printInterface: M2 } = bo2(), { printBlock: R2 } = wo(), { printTypeAlias: q2, printIntersectionType: U2, printUnionType: L2, printFunctionType: Y2, printTupleType: V2, printIndexedAccessType: j2, printJSDocType: K2 } = Or2();
        function se2(Q2, ce2, W2) {
          let X2 = Q2.getValue();
          if (!X2.type.startsWith("TS"))
            return;
          if (w2(X2))
            return X2.type.slice(2, -7).toLowerCase();
          let de2 = ce2.semi ? ";" : "", ie2 = [];
          switch (X2.type) {
            case "TSThisType":
              return "this";
            case "TSTypeAssertion": {
              let Ee2 = !(X2.expression.type === "ArrayExpression" || X2.expression.type === "ObjectExpression"), z2 = l2(["<", p2([i2, W2("typeAnnotation")]), i2, ">"]), ue2 = [y2("("), p2([i2, W2("expression")]), i2, y2(")")];
              return Ee2 ? d2([[z2, W2("expression")], [z2, l2(ue2, { shouldBreak: true })], [z2, W2("expression")]]) : l2([z2, W2("expression")]);
            }
            case "TSDeclareFunction":
              return T2(Q2, W2, ce2);
            case "TSExportAssignment":
              return ["export = ", W2("expression"), de2];
            case "TSModuleBlock":
              return R2(Q2, ce2, W2);
            case "TSInterfaceBody":
            case "TSTypeLiteral":
              return v2(Q2, ce2, W2);
            case "TSTypeAliasDeclaration":
              return q2(Q2, ce2, W2);
            case "TSQualifiedName":
              return a2(".", [W2("left"), W2("right")]);
            case "TSAbstractMethodDefinition":
            case "TSDeclareMethod":
              return h2(Q2, ce2, W2);
            case "TSAbstractAccessorProperty":
            case "TSAbstractPropertyDefinition":
              return o2(Q2, ce2, W2);
            case "TSInterfaceHeritage":
            case "TSExpressionWithTypeArguments":
              return ie2.push(W2("expression")), X2.typeParameters && ie2.push(W2("typeParameters")), ie2;
            case "TSTemplateLiteralType":
              return b2(Q2, W2, ce2);
            case "TSNamedTupleMember":
              return [W2("label"), X2.optional ? "?" : "", ": ", W2("elementType")];
            case "TSRestType":
              return ["...", W2("typeAnnotation")];
            case "TSOptionalType":
              return [W2("typeAnnotation"), "?"];
            case "TSInterfaceDeclaration":
              return M2(Q2, ce2, W2);
            case "TSClassImplements":
              return [W2("expression"), W2("typeParameters")];
            case "TSTypeParameterDeclaration":
            case "TSTypeParameterInstantiation":
              return S2(Q2, ce2, W2, "params");
            case "TSTypeParameter":
              return C2(Q2, ce2, W2);
            case "TSSatisfiesExpression":
            case "TSAsExpression": {
              let Ee2 = X2.type === "TSAsExpression" ? "as" : "satisfies";
              ie2.push(W2("expression"), ` ${Ee2} `, W2("typeAnnotation"));
              let z2 = Q2.getParentNode();
              return E2(z2) && z2.callee === X2 || _2(z2) && z2.object === X2 ? l2([p2([i2, ...ie2]), i2]) : ie2;
            }
            case "TSArrayType":
              return [W2("elementType"), "[]"];
            case "TSPropertySignature":
              return X2.readonly && ie2.push("readonly "), ie2.push(x2(Q2, ce2, W2), N2(Q2)), X2.typeAnnotation && ie2.push(": ", W2("typeAnnotation")), X2.initializer && ie2.push(" = ", W2("initializer")), ie2;
            case "TSParameterProperty":
              return X2.accessibility && ie2.push(X2.accessibility + " "), X2.export && ie2.push("export "), X2.static && ie2.push("static "), X2.override && ie2.push("override "), X2.readonly && ie2.push("readonly "), ie2.push(W2("parameter")), ie2;
            case "TSTypeQuery":
              return ["typeof ", W2("exprName"), W2("typeParameters")];
            case "TSIndexSignature": {
              let Ee2 = Q2.getParentNode(), z2 = X2.parameters.length > 1 ? y2(D2(ce2) ? "," : "") : "", ue2 = l2([p2([i2, a2([", ", i2], Q2.map(W2, "parameters"))]), z2, i2]);
              return [X2.export ? "export " : "", X2.accessibility ? [X2.accessibility, " "] : "", X2.static ? "static " : "", X2.readonly ? "readonly " : "", X2.declare ? "declare " : "", "[", X2.parameters ? ue2 : "", X2.typeAnnotation ? "]: " : "]", X2.typeAnnotation ? W2("typeAnnotation") : "", Ee2.type === "ClassBody" ? de2 : ""];
            }
            case "TSTypePredicate":
              return [X2.asserts ? "asserts " : "", W2("parameterName"), X2.typeAnnotation ? [" is ", W2("typeAnnotation")] : ""];
            case "TSNonNullExpression":
              return [W2("expression"), "!"];
            case "TSImportType":
              return [X2.isTypeOf ? "typeof " : "", "import(", W2(X2.parameter ? "parameter" : "argument"), ")", X2.qualifier ? [".", W2("qualifier")] : "", S2(Q2, ce2, W2, "typeParameters")];
            case "TSLiteralType":
              return W2("literal");
            case "TSIndexedAccessType":
              return j2(Q2, ce2, W2);
            case "TSConstructSignatureDeclaration":
            case "TSCallSignatureDeclaration":
            case "TSConstructorType": {
              if (X2.type === "TSConstructorType" && X2.abstract && ie2.push("abstract "), X2.type !== "TSCallSignatureDeclaration" && ie2.push("new "), ie2.push(l2(H2(Q2, W2, ce2, false, true))), X2.returnType || X2.typeAnnotation) {
                let Ee2 = X2.type === "TSConstructorType";
                ie2.push(Ee2 ? " => " : ": ", W2("returnType"), W2("typeAnnotation"));
              }
              return ie2;
            }
            case "TSTypeOperator":
              return [X2.operator, " ", W2("typeAnnotation")];
            case "TSMappedType": {
              let Ee2 = s2(ce2.originalText, F2(X2), A2(X2));
              return l2(["{", p2([ce2.bracketSpacing ? n2 : i2, X2.readonly ? [c2(X2.readonly, "readonly"), " "] : "", I2(Q2, ce2, W2), W2("typeParameter"), X2.optional ? c2(X2.optional, "?") : "", X2.typeAnnotation ? ": " : "", W2("typeAnnotation"), y2(de2)]), t2(Q2, ce2, true), ce2.bracketSpacing ? n2 : i2, "}"], { shouldBreak: Ee2 });
            }
            case "TSMethodSignature": {
              let Ee2 = X2.kind && X2.kind !== "method" ? `${X2.kind} ` : "";
              ie2.push(X2.accessibility ? [X2.accessibility, " "] : "", Ee2, X2.export ? "export " : "", X2.static ? "static " : "", X2.readonly ? "readonly " : "", X2.abstract ? "abstract " : "", X2.declare ? "declare " : "", X2.computed ? "[" : "", W2("key"), X2.computed ? "]" : "", N2(Q2));
              let z2 = H2(Q2, W2, ce2, false, true), ue2 = X2.returnType ? "returnType" : "typeAnnotation", J2 = X2[ue2], le2 = J2 ? W2(ue2) : "", ge2 = f2(X2, le2);
              return ie2.push(ge2 ? l2(z2) : z2), J2 && ie2.push(": ", l2(le2)), l2(ie2);
            }
            case "TSNamespaceExportDeclaration":
              return ie2.push("export as namespace ", W2("id")), ce2.semi && ie2.push(";"), l2(ie2);
            case "TSEnumDeclaration":
              return X2.declare && ie2.push("declare "), X2.modifiers && ie2.push(I2(Q2, ce2, W2)), X2.const && ie2.push("const "), ie2.push("enum ", W2("id"), " "), X2.members.length === 0 ? ie2.push(l2(["{", t2(Q2, ce2), i2, "}"])) : ie2.push(l2(["{", p2([u2, m2(Q2, ce2, "members", W2), D2(ce2, "es5") ? "," : ""]), t2(Q2, ce2, true), u2, "}"])), ie2;
            case "TSEnumMember":
              return X2.computed ? ie2.push("[", W2("id"), "]") : ie2.push(W2("id")), X2.initializer && ie2.push(" = ", W2("initializer")), ie2;
            case "TSImportEqualsDeclaration":
              return X2.isExport && ie2.push("export "), ie2.push("import "), X2.importKind && X2.importKind !== "value" && ie2.push(X2.importKind, " "), ie2.push(W2("id"), " = ", W2("moduleReference")), ce2.semi && ie2.push(";"), l2(ie2);
            case "TSExternalModuleReference":
              return ["require(", W2("expression"), ")"];
            case "TSModuleDeclaration": {
              let Ee2 = Q2.getParentNode(), z2 = g2(X2.id), ue2 = Ee2.type === "TSModuleDeclaration", J2 = X2.body && X2.body.type === "TSModuleDeclaration";
              if (ue2)
                ie2.push(".");
              else {
                X2.declare && ie2.push("declare "), ie2.push(I2(Q2, ce2, W2));
                let le2 = ce2.originalText.slice(F2(X2), F2(X2.id));
                X2.id.type === "Identifier" && X2.id.name === "global" && !/namespace|module/.test(le2) || ie2.push(z2 || /(?:^|\s)module(?:\s|$)/.test(le2) ? "module " : "namespace ");
              }
              return ie2.push(W2("id")), J2 ? ie2.push(W2("body")) : X2.body ? ie2.push(" ", l2(W2("body"))) : ie2.push(de2), ie2;
            }
            case "TSConditionalType":
              return P2(Q2, ce2, W2);
            case "TSInferType":
              return ["infer", " ", W2("typeParameter")];
            case "TSIntersectionType":
              return U2(Q2, ce2, W2);
            case "TSUnionType":
              return L2(Q2, ce2, W2);
            case "TSFunctionType":
              return Y2(Q2, ce2, W2);
            case "TSTupleType":
              return V2(Q2, ce2, W2);
            case "TSTypeReference":
              return [W2("typeName"), S2(Q2, ce2, W2, "typeParameters")];
            case "TSTypeAnnotation":
              return W2("typeAnnotation");
            case "TSEmptyBodyFunctionExpression":
              return k2(Q2, ce2, W2);
            case "TSJSDocAllType":
              return "*";
            case "TSJSDocUnknownType":
              return "?";
            case "TSJSDocNullableType":
              return K2(Q2, W2, "?");
            case "TSJSDocNonNullableType":
              return K2(Q2, W2, "!");
            case "TSInstantiationExpression":
              return [W2("expression"), W2("typeParameters")];
            default:
              throw new Error(`Unknown TypeScript node type: ${JSON.stringify(X2.type)}.`);
          }
        }
        r2.exports = { printTypescript: se2 };
      } }), yd2 = Z2({ "src/language-js/print/comment.js"(e25, r2) {
        ne2();
        var { hasNewline: t2 } = Ue2(), { builders: { join: s2, hardline: a2 }, utils: { replaceTextEndOfLine: n2 } } = Me2(), { isLineComment: u2 } = Ke2(), { locStart: i2, locEnd: l2 } = ut2(), p2 = Ot2();
        function d2(c2, D2) {
          let E2 = c2.getValue();
          if (u2(E2))
            return D2.originalText.slice(i2(E2), l2(E2)).trimEnd();
          if (p2(E2)) {
            if (y2(E2)) {
              let F2 = g2(E2);
              return E2.trailing && !t2(D2.originalText, i2(E2), { backwards: true }) ? [a2, F2] : F2;
            }
            let _2 = l2(E2), w2 = D2.originalText.slice(_2 - 3, _2) === "*-/";
            return ["/*", n2(E2.value), w2 ? "*-/" : "*/"];
          }
          throw new Error("Not a comment: " + JSON.stringify(E2));
        }
        function y2(c2) {
          let D2 = `*${c2.value}*`.split(`
`);
          return D2.length > 1 && D2.every((E2) => E2.trim()[0] === "*");
        }
        function g2(c2) {
          let D2 = c2.value.split(`
`);
          return ["/*", s2(a2, D2.map((E2, _2) => _2 === 0 ? E2.trimEnd() : " " + (_2 < D2.length - 1 ? E2.trim() : E2.trimStart()))), "*/"];
        }
        r2.exports = { printComment: d2 };
      } }), hd2 = Z2({ "src/language-js/print/literal.js"(e25, r2) {
        ne2();
        var { printString: t2, printNumber: s2 } = Ue2(), { replaceTextEndOfLine: a2 } = Yt2(), { printDirective: n2 } = ct2();
        function u2(d2, y2) {
          let g2 = d2.getNode();
          switch (g2.type) {
            case "RegExpLiteral":
              return p2(g2);
            case "BigIntLiteral":
              return l2(g2.bigint || g2.extra.raw);
            case "NumericLiteral":
              return s2(g2.extra.raw);
            case "StringLiteral":
              return a2(t2(g2.extra.raw, y2));
            case "NullLiteral":
              return "null";
            case "BooleanLiteral":
              return String(g2.value);
            case "DecimalLiteral":
              return s2(g2.value) + "m";
            case "Literal": {
              if (g2.regex)
                return p2(g2.regex);
              if (g2.bigint)
                return l2(g2.raw);
              if (g2.decimal)
                return s2(g2.decimal) + "m";
              let { value: c2 } = g2;
              return typeof c2 == "number" ? s2(g2.raw) : typeof c2 == "string" ? i2(d2) ? n2(g2.raw, y2) : a2(t2(g2.raw, y2)) : String(c2);
            }
          }
        }
        function i2(d2) {
          if (d2.getName() !== "expression")
            return;
          let y2 = d2.getParentNode();
          return y2.type === "ExpressionStatement" && y2.directive;
        }
        function l2(d2) {
          return d2.toLowerCase();
        }
        function p2(d2) {
          let { pattern: y2, flags: g2 } = d2;
          return g2 = [...g2].sort().join(""), `/${y2}/${g2}`;
        }
        r2.exports = { printLiteral: u2 };
      } }), vd2 = Z2({ "src/language-js/printer-estree.js"(e25, r2) {
        ne2();
        var { printDanglingComments: t2 } = et2(), { hasNewline: s2 } = Ue2(), { builders: { join: a2, line: n2, hardline: u2, softline: i2, group: l2, indent: p2 }, utils: { replaceTextEndOfLine: d2 } } = Me2(), y2 = td2(), g2 = rd2(), { insertPragma: c2 } = Co(), D2 = Eo2(), E2 = qt2(), _2 = Fo(), { hasFlowShorthandAnnotationComment: w2, hasComment: F2, CommentCheckFlags: A2, isTheOnlyJsxElementInMarkdown: N2, isLineComment: I2, isNextLineEmpty: P2, needsHardlineAfterDanglingComment: H2, hasIgnoreComment: f2, isCallExpression: b2, isMemberExpression: m2, markerForIfWithoutBlockAndSameLineComment: v2 } = Ke2(), { locStart: o2, locEnd: h2 } = ut2(), C2 = Ot2(), { printHtmlBinding: S2, isVueEventBindingExpression: x2 } = cd2(), { printAngular: T2 } = pd2(), { printJsx: k2, hasJsxIgnoreComment: M2 } = fd2(), { printFlow: R2 } = md2(), { printTypescript: q2 } = gd2(), { printOptionalToken: U2, printBindExpressionCallee: L2, printTypeAnnotation: Y2, adjustClause: V2, printRestSpread: j2, printDefiniteToken: K2, printDirective: se2 } = ct2(), { printImportDeclaration: Q2, printExportDeclaration: ce2, printExportAllDeclaration: W2, printModuleSpecifier: X2 } = To2(), { printTernary: de2 } = Bo2(), { printTemplateLiteral: ie2 } = jt2(), { printArray: Ee2 } = er2(), { printObject: z2 } = uu2(), { printClass: ue2, printClassMethod: J2, printClassProperty: le2 } = nr2(), { printProperty: ge2 } = rr2(), { printFunction: pe2, printArrowFunction: Ae2, printMethod: Ce2, printReturnStatement: Oe2, printThrowStatement: Ie2 } = qr2(), { printCallExpression: we2 } = xo2(), { printVariableDeclarator: _e2, printAssignmentExpression: De2 } = tr2(), { printBinaryishExpression: G2 } = ru2(), { printSwitchCaseConsequent: oe2 } = No2(), { printMemberExpression: ee2 } = So(), { printBlock: re2, printBlockBody: be2 } = wo(), { printComment: ve2 } = yd2(), { printLiteral: fe2 } = hd2(), { printDecorators: B2 } = nu2();
        function $2(Fe2, Ne2, he2, ze2) {
          let Te2 = te2(Fe2, Ne2, he2, ze2);
          if (!Te2)
            return "";
          let Ye2 = Fe2.getValue(), { type: Se2 } = Ye2;
          if (Se2 === "ClassMethod" || Se2 === "ClassPrivateMethod" || Se2 === "ClassProperty" || Se2 === "ClassAccessorProperty" || Se2 === "AccessorProperty" || Se2 === "TSAbstractAccessorProperty" || Se2 === "PropertyDefinition" || Se2 === "TSAbstractPropertyDefinition" || Se2 === "ClassPrivateProperty" || Se2 === "MethodDefinition" || Se2 === "TSAbstractMethodDefinition" || Se2 === "TSDeclareMethod")
            return Te2;
          let ke2 = [Te2], je2 = B2(Fe2, Ne2, he2), Je2 = Ye2.type === "ClassExpression" && je2;
          if (je2 && (ke2 = [...je2, Te2], !Je2))
            return l2(ke2);
          if (!E2(Fe2, Ne2))
            return ze2 && ze2.needsSemi && ke2.unshift(";"), ke2.length === 1 && ke2[0] === Te2 ? Te2 : ke2;
          if (Je2 && (ke2 = [p2([n2, ...ke2])]), ke2.unshift("("), ze2 && ze2.needsSemi && ke2.unshift(";"), w2(Ye2)) {
            let [qe2] = Ye2.trailingComments;
            ke2.push(" /*", qe2.value.trimStart(), "*/"), qe2.printed = true;
          }
          return Je2 && ke2.push(n2), ke2.push(")"), ke2;
        }
        function te2(Fe2, Ne2, he2, ze2) {
          let Te2 = Fe2.getValue(), Ye2 = Ne2.semi ? ";" : "";
          if (!Te2)
            return "";
          if (typeof Te2 == "string")
            return Te2;
          for (let ke2 of [fe2, S2, T2, k2, R2, q2]) {
            let je2 = ke2(Fe2, Ne2, he2);
            if (typeof je2 < "u")
              return je2;
          }
          let Se2 = [];
          switch (Te2.type) {
            case "JsExpressionRoot":
              return he2("node");
            case "JsonRoot":
              return [he2("node"), u2];
            case "File":
              return Te2.program && Te2.program.interpreter && Se2.push(he2(["program", "interpreter"])), Se2.push(he2("program")), Se2;
            case "Program":
              return be2(Fe2, Ne2, he2);
            case "EmptyStatement":
              return "";
            case "ExpressionStatement": {
              if (Ne2.parser === "__vue_event_binding" || Ne2.parser === "__vue_ts_event_binding") {
                let je2 = Fe2.getParentNode();
                if (je2.type === "Program" && je2.body.length === 1 && je2.body[0] === Te2)
                  return [he2("expression"), x2(Te2.expression) ? ";" : ""];
              }
              let ke2 = t2(Fe2, Ne2, true, (je2) => {
                let { marker: Je2 } = je2;
                return Je2 === v2;
              });
              return [he2("expression"), N2(Ne2, Fe2) ? "" : Ye2, ke2 ? [" ", ke2] : ""];
            }
            case "ParenthesizedExpression":
              return !F2(Te2.expression) && (Te2.expression.type === "ObjectExpression" || Te2.expression.type === "ArrayExpression") ? ["(", he2("expression"), ")"] : l2(["(", p2([i2, he2("expression")]), i2, ")"]);
            case "AssignmentExpression":
              return De2(Fe2, Ne2, he2);
            case "VariableDeclarator":
              return _e2(Fe2, Ne2, he2);
            case "BinaryExpression":
            case "LogicalExpression":
              return G2(Fe2, Ne2, he2);
            case "AssignmentPattern":
              return [he2("left"), " = ", he2("right")];
            case "OptionalMemberExpression":
            case "MemberExpression":
              return ee2(Fe2, Ne2, he2);
            case "MetaProperty":
              return [he2("meta"), ".", he2("property")];
            case "BindExpression":
              return Te2.object && Se2.push(he2("object")), Se2.push(l2(p2([i2, L2(Fe2, Ne2, he2)]))), Se2;
            case "Identifier":
              return [Te2.name, U2(Fe2), K2(Fe2), Y2(Fe2, Ne2, he2)];
            case "V8IntrinsicIdentifier":
              return ["%", Te2.name];
            case "SpreadElement":
            case "SpreadElementPattern":
            case "SpreadProperty":
            case "SpreadPropertyPattern":
            case "RestElement":
              return j2(Fe2, Ne2, he2);
            case "FunctionDeclaration":
            case "FunctionExpression":
              return pe2(Fe2, he2, Ne2, ze2);
            case "ArrowFunctionExpression":
              return Ae2(Fe2, Ne2, he2, ze2);
            case "YieldExpression":
              return Se2.push("yield"), Te2.delegate && Se2.push("*"), Te2.argument && Se2.push(" ", he2("argument")), Se2;
            case "AwaitExpression": {
              if (Se2.push("await"), Te2.argument) {
                Se2.push(" ", he2("argument"));
                let ke2 = Fe2.getParentNode();
                if (b2(ke2) && ke2.callee === Te2 || m2(ke2) && ke2.object === Te2) {
                  Se2 = [p2([i2, ...Se2]), i2];
                  let je2 = Fe2.findAncestor((Je2) => Je2.type === "AwaitExpression" || Je2.type === "BlockStatement");
                  if (!je2 || je2.type !== "AwaitExpression")
                    return l2(Se2);
                }
              }
              return Se2;
            }
            case "ExportDefaultDeclaration":
            case "ExportNamedDeclaration":
              return ce2(Fe2, Ne2, he2);
            case "ExportAllDeclaration":
              return W2(Fe2, Ne2, he2);
            case "ImportDeclaration":
              return Q2(Fe2, Ne2, he2);
            case "ImportSpecifier":
            case "ExportSpecifier":
            case "ImportNamespaceSpecifier":
            case "ExportNamespaceSpecifier":
            case "ImportDefaultSpecifier":
            case "ExportDefaultSpecifier":
              return X2(Fe2, Ne2, he2);
            case "ImportAttribute":
              return [he2("key"), ": ", he2("value")];
            case "Import":
              return "import";
            case "BlockStatement":
            case "StaticBlock":
            case "ClassBody":
              return re2(Fe2, Ne2, he2);
            case "ThrowStatement":
              return Ie2(Fe2, Ne2, he2);
            case "ReturnStatement":
              return Oe2(Fe2, Ne2, he2);
            case "NewExpression":
            case "ImportExpression":
            case "OptionalCallExpression":
            case "CallExpression":
              return we2(Fe2, Ne2, he2);
            case "ObjectExpression":
            case "ObjectPattern":
            case "RecordExpression":
              return z2(Fe2, Ne2, he2);
            case "ObjectProperty":
            case "Property":
              return Te2.method || Te2.kind === "get" || Te2.kind === "set" ? Ce2(Fe2, Ne2, he2) : ge2(Fe2, Ne2, he2);
            case "ObjectMethod":
              return Ce2(Fe2, Ne2, he2);
            case "Decorator":
              return ["@", he2("expression")];
            case "ArrayExpression":
            case "ArrayPattern":
            case "TupleExpression":
              return Ee2(Fe2, Ne2, he2);
            case "SequenceExpression": {
              let ke2 = Fe2.getParentNode(0);
              if (ke2.type === "ExpressionStatement" || ke2.type === "ForStatement") {
                let je2 = [];
                return Fe2.each((Je2, Be2) => {
                  Be2 === 0 ? je2.push(he2()) : je2.push(",", p2([n2, he2()]));
                }, "expressions"), l2(je2);
              }
              return l2(a2([",", n2], Fe2.map(he2, "expressions")));
            }
            case "ThisExpression":
              return "this";
            case "Super":
              return "super";
            case "Directive":
              return [he2("value"), Ye2];
            case "DirectiveLiteral":
              return se2(Te2.extra.raw, Ne2);
            case "UnaryExpression":
              return Se2.push(Te2.operator), /[a-z]$/.test(Te2.operator) && Se2.push(" "), F2(Te2.argument) ? Se2.push(l2(["(", p2([i2, he2("argument")]), i2, ")"])) : Se2.push(he2("argument")), Se2;
            case "UpdateExpression":
              return Se2.push(he2("argument"), Te2.operator), Te2.prefix && Se2.reverse(), Se2;
            case "ConditionalExpression":
              return de2(Fe2, Ne2, he2);
            case "VariableDeclaration": {
              let ke2 = Fe2.map(he2, "declarations"), je2 = Fe2.getParentNode(), Je2 = je2.type === "ForStatement" || je2.type === "ForInStatement" || je2.type === "ForOfStatement", Be2 = Te2.declarations.some((Re2) => Re2.init), qe2;
              return ke2.length === 1 && !F2(Te2.declarations[0]) ? qe2 = ke2[0] : ke2.length > 0 && (qe2 = p2(ke2[0])), Se2 = [Te2.declare ? "declare " : "", Te2.kind, qe2 ? [" ", qe2] : "", p2(ke2.slice(1).map((Re2) => [",", Be2 && !Je2 ? u2 : n2, Re2]))], Je2 && je2.body !== Te2 || Se2.push(Ye2), l2(Se2);
            }
            case "WithStatement":
              return l2(["with (", he2("object"), ")", V2(Te2.body, he2("body"))]);
            case "IfStatement": {
              let ke2 = V2(Te2.consequent, he2("consequent")), je2 = l2(["if (", l2([p2([i2, he2("test")]), i2]), ")", ke2]);
              if (Se2.push(je2), Te2.alternate) {
                let Je2 = F2(Te2.consequent, A2.Trailing | A2.Line) || H2(Te2), Be2 = Te2.consequent.type === "BlockStatement" && !Je2;
                Se2.push(Be2 ? " " : u2), F2(Te2, A2.Dangling) && Se2.push(t2(Fe2, Ne2, true), Je2 ? u2 : " "), Se2.push("else", l2(V2(Te2.alternate, he2("alternate"), Te2.alternate.type === "IfStatement")));
              }
              return Se2;
            }
            case "ForStatement": {
              let ke2 = V2(Te2.body, he2("body")), je2 = t2(Fe2, Ne2, true), Je2 = je2 ? [je2, i2] : "";
              return !Te2.init && !Te2.test && !Te2.update ? [Je2, l2(["for (;;)", ke2])] : [Je2, l2(["for (", l2([p2([i2, he2("init"), ";", n2, he2("test"), ";", n2, he2("update")]), i2]), ")", ke2])];
            }
            case "WhileStatement":
              return l2(["while (", l2([p2([i2, he2("test")]), i2]), ")", V2(Te2.body, he2("body"))]);
            case "ForInStatement":
              return l2(["for (", he2("left"), " in ", he2("right"), ")", V2(Te2.body, he2("body"))]);
            case "ForOfStatement":
              return l2(["for", Te2.await ? " await" : "", " (", he2("left"), " of ", he2("right"), ")", V2(Te2.body, he2("body"))]);
            case "DoWhileStatement": {
              let ke2 = V2(Te2.body, he2("body"));
              return Se2 = [l2(["do", ke2])], Te2.body.type === "BlockStatement" ? Se2.push(" ") : Se2.push(u2), Se2.push("while (", l2([p2([i2, he2("test")]), i2]), ")", Ye2), Se2;
            }
            case "DoExpression":
              return [Te2.async ? "async " : "", "do ", he2("body")];
            case "BreakStatement":
              return Se2.push("break"), Te2.label && Se2.push(" ", he2("label")), Se2.push(Ye2), Se2;
            case "ContinueStatement":
              return Se2.push("continue"), Te2.label && Se2.push(" ", he2("label")), Se2.push(Ye2), Se2;
            case "LabeledStatement":
              return Te2.body.type === "EmptyStatement" ? [he2("label"), ":;"] : [he2("label"), ": ", he2("body")];
            case "TryStatement":
              return ["try ", he2("block"), Te2.handler ? [" ", he2("handler")] : "", Te2.finalizer ? [" finally ", he2("finalizer")] : ""];
            case "CatchClause":
              if (Te2.param) {
                let ke2 = F2(Te2.param, (Je2) => !C2(Je2) || Je2.leading && s2(Ne2.originalText, h2(Je2)) || Je2.trailing && s2(Ne2.originalText, o2(Je2), { backwards: true })), je2 = he2("param");
                return ["catch ", ke2 ? ["(", p2([i2, je2]), i2, ") "] : ["(", je2, ") "], he2("body")];
              }
              return ["catch ", he2("body")];
            case "SwitchStatement":
              return [l2(["switch (", p2([i2, he2("discriminant")]), i2, ")"]), " {", Te2.cases.length > 0 ? p2([u2, a2(u2, Fe2.map((ke2, je2, Je2) => {
                let Be2 = ke2.getValue();
                return [he2(), je2 !== Je2.length - 1 && P2(Be2, Ne2) ? u2 : ""];
              }, "cases"))]) : "", u2, "}"];
            case "SwitchCase": {
              Te2.test ? Se2.push("case ", he2("test"), ":") : Se2.push("default:"), F2(Te2, A2.Dangling) && Se2.push(" ", t2(Fe2, Ne2, true));
              let ke2 = Te2.consequent.filter((je2) => je2.type !== "EmptyStatement");
              if (ke2.length > 0) {
                let je2 = oe2(Fe2, Ne2, he2);
                Se2.push(ke2.length === 1 && ke2[0].type === "BlockStatement" ? [" ", je2] : p2([u2, je2]));
              }
              return Se2;
            }
            case "DebuggerStatement":
              return ["debugger", Ye2];
            case "ClassDeclaration":
            case "ClassExpression":
              return ue2(Fe2, Ne2, he2);
            case "ClassMethod":
            case "ClassPrivateMethod":
            case "MethodDefinition":
              return J2(Fe2, Ne2, he2);
            case "ClassProperty":
            case "PropertyDefinition":
            case "ClassPrivateProperty":
            case "ClassAccessorProperty":
            case "AccessorProperty":
              return le2(Fe2, Ne2, he2);
            case "TemplateElement":
              return d2(Te2.value.raw);
            case "TemplateLiteral":
              return ie2(Fe2, he2, Ne2);
            case "TaggedTemplateExpression":
              return [he2("tag"), he2("typeParameters"), he2("quasi")];
            case "PrivateIdentifier":
              return ["#", he2("name")];
            case "PrivateName":
              return ["#", he2("id")];
            case "InterpreterDirective":
              return Se2.push("#!", Te2.value, u2), P2(Te2, Ne2) && Se2.push(u2), Se2;
            case "TopicReference":
              return "%";
            case "ArgumentPlaceholder":
              return "?";
            case "ModuleExpression": {
              Se2.push("module {");
              let ke2 = he2("body");
              return ke2 && Se2.push(p2([u2, ke2]), u2), Se2.push("}"), Se2;
            }
            default:
              throw new Error("unknown type: " + JSON.stringify(Te2.type));
          }
        }
        function ye2(Fe2) {
          return Fe2.type && !C2(Fe2) && !I2(Fe2) && Fe2.type !== "EmptyStatement" && Fe2.type !== "TemplateElement" && Fe2.type !== "Import" && Fe2.type !== "TSEmptyBodyFunctionExpression";
        }
        r2.exports = { preprocess: _2, print: $2, embed: y2, insertPragma: c2, massageAstNode: g2, hasPrettierIgnore(Fe2) {
          return f2(Fe2) || M2(Fe2);
        }, willPrintOwnComments: D2.willPrintOwnComments, canAttachComment: ye2, printComment: ve2, isBlockComment: C2, handleComments: { avoidAstMutation: true, ownLine: D2.handleOwnLineComment, endOfLine: D2.handleEndOfLineComment, remaining: D2.handleRemainingComment }, getCommentChildNodes: D2.getCommentChildNodes };
      } }), Cd2 = Z2({ "src/language-js/printer-estree-json.js"(e25, r2) {
        ne2();
        var { builders: { hardline: t2, indent: s2, join: a2 } } = Me2(), n2 = Fo();
        function u2(d2, y2, g2) {
          let c2 = d2.getValue();
          switch (c2.type) {
            case "JsonRoot":
              return [g2("node"), t2];
            case "ArrayExpression": {
              if (c2.elements.length === 0)
                return "[]";
              let D2 = d2.map(() => d2.getValue() === null ? "null" : g2(), "elements");
              return ["[", s2([t2, a2([",", t2], D2)]), t2, "]"];
            }
            case "ObjectExpression":
              return c2.properties.length === 0 ? "{}" : ["{", s2([t2, a2([",", t2], d2.map(g2, "properties"))]), t2, "}"];
            case "ObjectProperty":
              return [g2("key"), ": ", g2("value")];
            case "UnaryExpression":
              return [c2.operator === "+" ? "" : c2.operator, g2("argument")];
            case "NullLiteral":
              return "null";
            case "BooleanLiteral":
              return c2.value ? "true" : "false";
            case "StringLiteral":
              return JSON.stringify(c2.value);
            case "NumericLiteral":
              return i2(d2) ? JSON.stringify(String(c2.value)) : JSON.stringify(c2.value);
            case "Identifier":
              return i2(d2) ? JSON.stringify(c2.name) : c2.name;
            case "TemplateLiteral":
              return g2(["quasis", 0]);
            case "TemplateElement":
              return JSON.stringify(c2.value.cooked);
            default:
              throw new Error("unknown type: " + JSON.stringify(c2.type));
          }
        }
        function i2(d2) {
          return d2.getName() === "key" && d2.getParentNode().type === "ObjectProperty";
        }
        var l2 = new Set(["start", "end", "extra", "loc", "comments", "leadingComments", "trailingComments", "innerComments", "errors", "range", "tokens"]);
        function p2(d2, y2) {
          let { type: g2 } = d2;
          if (g2 === "ObjectProperty") {
            let { key: c2 } = d2;
            c2.type === "Identifier" ? y2.key = { type: "StringLiteral", value: c2.name } : c2.type === "NumericLiteral" && (y2.key = { type: "StringLiteral", value: String(c2.value) });
            return;
          }
          if (g2 === "UnaryExpression" && d2.operator === "+")
            return y2.argument;
          if (g2 === "ArrayExpression") {
            for (let [c2, D2] of d2.elements.entries())
              D2 === null && y2.elements.splice(c2, 0, { type: "NullLiteral" });
            return;
          }
          if (g2 === "TemplateLiteral")
            return { type: "StringLiteral", value: d2.quasis[0].value.cooked };
        }
        p2.ignoredProperties = l2, r2.exports = { preprocess: n2, print: u2, massageAstNode: p2 };
      } }), Mt2 = Z2({ "src/common/common-options.js"(e25, r2) {
        ne2();
        var t2 = "Common";
        r2.exports = { bracketSpacing: { since: "0.0.0", category: t2, type: "boolean", default: true, description: "Print spaces between brackets.", oppositeDescription: "Do not print spaces between brackets." }, singleQuote: { since: "0.0.0", category: t2, type: "boolean", default: false, description: "Use single quotes instead of double quotes." }, proseWrap: { since: "1.8.2", category: t2, type: "choice", default: [{ since: "1.8.2", value: true }, { since: "1.9.0", value: "preserve" }], description: "How to wrap prose.", choices: [{ since: "1.9.0", value: "always", description: "Wrap prose if it exceeds the print width." }, { since: "1.9.0", value: "never", description: "Do not wrap prose." }, { since: "1.9.0", value: "preserve", description: "Wrap prose as-is." }] }, bracketSameLine: { since: "2.4.0", category: t2, type: "boolean", default: false, description: "Put > of opening tags on the last line instead of on a new line." }, singleAttributePerLine: { since: "2.6.0", category: t2, type: "boolean", default: false, description: "Enforce single attribute per line in HTML, Vue and JSX." } };
      } }), Ed2 = Z2({ "src/language-js/options.js"(e25, r2) {
        ne2();
        var t2 = Mt2(), s2 = "JavaScript";
        r2.exports = { arrowParens: { since: "1.9.0", category: s2, type: "choice", default: [{ since: "1.9.0", value: "avoid" }, { since: "2.0.0", value: "always" }], description: "Include parentheses around a sole arrow function parameter.", choices: [{ value: "always", description: "Always include parens. Example: `(x) => x`" }, { value: "avoid", description: "Omit parens when possible. Example: `x => x`" }] }, bracketSameLine: t2.bracketSameLine, bracketSpacing: t2.bracketSpacing, jsxBracketSameLine: { since: "0.17.0", category: s2, type: "boolean", description: "Put > on the last line instead of at a new line.", deprecated: "2.4.0" }, semi: { since: "1.0.0", category: s2, type: "boolean", default: true, description: "Print semicolons.", oppositeDescription: "Do not print semicolons, except at the beginning of lines which may need them." }, singleQuote: t2.singleQuote, jsxSingleQuote: { since: "1.15.0", category: s2, type: "boolean", default: false, description: "Use single quotes in JSX." }, quoteProps: { since: "1.17.0", category: s2, type: "choice", default: "as-needed", description: "Change when properties in objects are quoted.", choices: [{ value: "as-needed", description: "Only add quotes around object properties where required." }, { value: "consistent", description: "If at least one property in an object requires quotes, quote all properties." }, { value: "preserve", description: "Respect the input use of quotes in object properties." }] }, trailingComma: { since: "0.0.0", category: s2, type: "choice", default: [{ since: "0.0.0", value: false }, { since: "0.19.0", value: "none" }, { since: "2.0.0", value: "es5" }], description: "Print trailing commas wherever possible when multi-line.", choices: [{ value: "es5", description: "Trailing commas where valid in ES5 (objects, arrays, etc.)" }, { value: "none", description: "No trailing commas." }, { value: "all", description: "Trailing commas wherever possible (including function arguments)." }] }, singleAttributePerLine: t2.singleAttributePerLine };
      } }), Fd2 = Z2({ "src/language-js/parse/parsers.js"() {
        ne2();
      } }), Ln2 = Z2({ "node_modules/linguist-languages/data/JavaScript.json"(e25, r2) {
        r2.exports = { name: "JavaScript", type: "programming", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", color: "#f1e05a", aliases: ["js", "node"], extensions: [".js", "._js", ".bones", ".cjs", ".es", ".es6", ".frag", ".gs", ".jake", ".javascript", ".jsb", ".jscad", ".jsfl", ".jslib", ".jsm", ".jspre", ".jss", ".jsx", ".mjs", ".njs", ".pac", ".sjs", ".ssjs", ".xsjs", ".xsjslib"], filenames: ["Jakefile"], interpreters: ["chakra", "d8", "gjs", "js", "node", "nodejs", "qjs", "rhino", "v8", "v8-shell"], languageId: 183 };
      } }), Ad2 = Z2({ "node_modules/linguist-languages/data/TypeScript.json"(e25, r2) {
        r2.exports = { name: "TypeScript", type: "programming", color: "#3178c6", aliases: ["ts"], interpreters: ["deno", "ts-node"], extensions: [".ts", ".cts", ".mts"], tmScope: "source.ts", aceMode: "typescript", codemirrorMode: "javascript", codemirrorMimeType: "application/typescript", languageId: 378 };
      } }), Sd2 = Z2({ "node_modules/linguist-languages/data/TSX.json"(e25, r2) {
        r2.exports = { name: "TSX", type: "programming", color: "#3178c6", group: "TypeScript", extensions: [".tsx"], tmScope: "source.tsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", languageId: 94901924 };
      } }), wa2 = Z2({ "node_modules/linguist-languages/data/JSON.json"(e25, r2) {
        r2.exports = { name: "JSON", type: "data", color: "#292929", tmScope: "source.json", aceMode: "json", codemirrorMode: "javascript", codemirrorMimeType: "application/json", aliases: ["geojson", "jsonl", "topojson"], extensions: [".json", ".4DForm", ".4DProject", ".avsc", ".geojson", ".gltf", ".har", ".ice", ".JSON-tmLanguage", ".jsonl", ".mcmeta", ".tfstate", ".tfstate.backup", ".topojson", ".webapp", ".webmanifest", ".yy", ".yyp"], filenames: [".arcconfig", ".auto-changelog", ".c8rc", ".htmlhintrc", ".imgbotconfig", ".nycrc", ".tern-config", ".tern-project", ".watchmanconfig", "Pipfile.lock", "composer.lock", "mcmod.info"], languageId: 174 };
      } }), xd2 = Z2({ "node_modules/linguist-languages/data/JSON with Comments.json"(e25, r2) {
        r2.exports = { name: "JSON with Comments", type: "data", color: "#292929", group: "JSON", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", aliases: ["jsonc"], extensions: [".jsonc", ".code-snippets", ".sublime-build", ".sublime-commands", ".sublime-completions", ".sublime-keymap", ".sublime-macro", ".sublime-menu", ".sublime-mousemap", ".sublime-project", ".sublime-settings", ".sublime-theme", ".sublime-workspace", ".sublime_metrics", ".sublime_session"], filenames: [".babelrc", ".devcontainer.json", ".eslintrc.json", ".jscsrc", ".jshintrc", ".jslintrc", "api-extractor.json", "devcontainer.json", "jsconfig.json", "language-configuration.json", "tsconfig.json", "tslint.json"], languageId: 423 };
      } }), bd2 = Z2({ "node_modules/linguist-languages/data/JSON5.json"(e25, r2) {
        r2.exports = { name: "JSON5", type: "data", color: "#267CB9", extensions: [".json5"], tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "application/json", languageId: 175 };
      } }), Td2 = Z2({ "src/language-js/index.js"(e25, r2) {
        ne2();
        var t2 = _t2(), s2 = vd2(), a2 = Cd2(), n2 = Ed2(), u2 = Fd2(), i2 = [t2(Ln2(), (p2) => ({ since: "0.0.0", parsers: ["babel", "acorn", "espree", "meriyah", "babel-flow", "babel-ts", "flow", "typescript"], vscodeLanguageIds: ["javascript", "mongo"], interpreters: [...p2.interpreters, "zx"], extensions: [...p2.extensions.filter((d2) => d2 !== ".jsx"), ".wxs"] })), t2(Ln2(), () => ({ name: "Flow", since: "0.0.0", parsers: ["flow", "babel-flow"], vscodeLanguageIds: ["javascript"], aliases: [], filenames: [], extensions: [".js.flow"] })), t2(Ln2(), () => ({ name: "JSX", since: "0.0.0", parsers: ["babel", "babel-flow", "babel-ts", "flow", "typescript", "espree", "meriyah"], vscodeLanguageIds: ["javascriptreact"], aliases: void 0, filenames: void 0, extensions: [".jsx"], group: "JavaScript", interpreters: void 0, tmScope: "source.js.jsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", color: void 0 })), t2(Ad2(), () => ({ since: "1.4.0", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescript"] })), t2(Sd2(), () => ({ since: "1.4.0", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescriptreact"] })), t2(wa2(), () => ({ name: "JSON.stringify", since: "1.13.0", parsers: ["json-stringify"], vscodeLanguageIds: ["json"], extensions: [".importmap"], filenames: ["package.json", "package-lock.json", "composer.json"] })), t2(wa2(), (p2) => ({ since: "1.5.0", parsers: ["json"], vscodeLanguageIds: ["json"], extensions: p2.extensions.filter((d2) => d2 !== ".jsonl") })), t2(xd2(), (p2) => ({ since: "1.5.0", parsers: ["json"], vscodeLanguageIds: ["jsonc"], filenames: [...p2.filenames, ".eslintrc", ".swcrc"] })), t2(bd2(), () => ({ since: "1.13.0", parsers: ["json5"], vscodeLanguageIds: ["json5"] }))], l2 = { estree: s2, "estree-json": a2 };
        r2.exports = { languages: i2, options: n2, printers: l2, parsers: u2 };
      } }), Bd2 = Z2({ "src/language-css/clean.js"(e25, r2) {
        ne2();
        var { isFrontMatterNode: t2 } = Ue2(), s2 = lt2(), a2 = new Set(["raw", "raws", "sourceIndex", "source", "before", "after", "trailingComma"]);
        function n2(i2, l2, p2) {
          if (t2(i2) && i2.lang === "yaml" && delete l2.value, i2.type === "css-comment" && p2.type === "css-root" && p2.nodes.length > 0 && ((p2.nodes[0] === i2 || t2(p2.nodes[0]) && p2.nodes[1] === i2) && (delete l2.text, /^\*\s*@(?:format|prettier)\s*$/.test(i2.text)) || p2.type === "css-root" && s2(p2.nodes) === i2))
            return null;
          if (i2.type === "value-root" && delete l2.text, (i2.type === "media-query" || i2.type === "media-query-list" || i2.type === "media-feature-expression") && delete l2.value, i2.type === "css-rule" && delete l2.params, i2.type === "selector-combinator" && (l2.value = l2.value.replace(/\s+/g, " ")), i2.type === "media-feature" && (l2.value = l2.value.replace(/ /g, "")), (i2.type === "value-word" && (i2.isColor && i2.isHex || ["initial", "inherit", "unset", "revert"].includes(l2.value.replace().toLowerCase())) || i2.type === "media-feature" || i2.type === "selector-root-invalid" || i2.type === "selector-pseudo") && (l2.value = l2.value.toLowerCase()), i2.type === "css-decl" && (l2.prop = l2.prop.toLowerCase()), (i2.type === "css-atrule" || i2.type === "css-import") && (l2.name = l2.name.toLowerCase()), i2.type === "value-number" && (l2.unit = l2.unit.toLowerCase()), (i2.type === "media-feature" || i2.type === "media-keyword" || i2.type === "media-type" || i2.type === "media-unknown" || i2.type === "media-url" || i2.type === "media-value" || i2.type === "selector-attribute" || i2.type === "selector-string" || i2.type === "selector-class" || i2.type === "selector-combinator" || i2.type === "value-string") && l2.value && (l2.value = u2(l2.value)), i2.type === "selector-attribute" && (l2.attribute = l2.attribute.trim(), l2.namespace && typeof l2.namespace == "string" && (l2.namespace = l2.namespace.trim(), l2.namespace.length === 0 && (l2.namespace = true)), l2.value && (l2.value = l2.value.trim().replace(/^["']|["']$/g, ""), delete l2.quoted)), (i2.type === "media-value" || i2.type === "media-type" || i2.type === "value-number" || i2.type === "selector-root-invalid" || i2.type === "selector-class" || i2.type === "selector-combinator" || i2.type === "selector-tag") && l2.value && (l2.value = l2.value.replace(/([\d+.Ee-]+)([A-Za-z]*)/g, (d2, y2, g2) => {
            let c2 = Number(y2);
            return Number.isNaN(c2) ? d2 : c2 + g2.toLowerCase();
          })), i2.type === "selector-tag") {
            let d2 = i2.value.toLowerCase();
            ["from", "to"].includes(d2) && (l2.value = d2);
          }
          if (i2.type === "css-atrule" && i2.name.toLowerCase() === "supports" && delete l2.value, i2.type === "selector-unknown" && delete l2.value, i2.type === "value-comma_group") {
            let d2 = i2.groups.findIndex((y2) => y2.type === "value-number" && y2.unit === "...");
            d2 !== -1 && (l2.groups[d2].unit = "", l2.groups.splice(d2 + 1, 0, { type: "value-word", value: "...", isColor: false, isHex: false }));
          }
          if (i2.type === "value-comma_group" && i2.groups.some((d2) => d2.type === "value-atword" && d2.value.endsWith("[") || d2.type === "value-word" && d2.value.startsWith("]")))
            return { type: "value-atword", value: i2.groups.map((d2) => d2.value).join(""), group: { open: null, close: null, groups: [], type: "value-paren_group" } };
        }
        n2.ignoredProperties = a2;
        function u2(i2) {
          return i2.replace(/'/g, '"').replace(/\\([^\dA-Fa-f])/g, "$1");
        }
        r2.exports = n2;
      } }), su2 = Z2({ "src/utils/front-matter/print.js"(e25, r2) {
        ne2();
        var { builders: { hardline: t2, markAsRoot: s2 } } = Me2();
        function a2(n2, u2) {
          if (n2.lang === "yaml") {
            let i2 = n2.value.trim(), l2 = i2 ? u2(i2, { parser: "yaml" }, { stripTrailingHardline: true }) : "";
            return s2([n2.startDelimiter, t2, l2, l2 ? t2 : "", n2.endDelimiter]);
          }
        }
        r2.exports = a2;
      } }), Nd2 = Z2({ "src/language-css/embed.js"(e25, r2) {
        ne2();
        var { builders: { hardline: t2 } } = Me2(), s2 = su2();
        function a2(n2, u2, i2) {
          let l2 = n2.getValue();
          if (l2.type === "front-matter") {
            let p2 = s2(l2, i2);
            return p2 ? [p2, t2] : "";
          }
        }
        r2.exports = a2;
      } }), _o2 = Z2({ "src/utils/front-matter/parse.js"(e25, r2) {
        ne2();
        var t2 = new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)", "s");
        function s2(a2) {
          let n2 = a2.match(t2);
          if (!n2)
            return { content: a2 };
          let { startDelimiter: u2, language: i2, value: l2 = "", endDelimiter: p2 } = n2.groups, d2 = i2.trim() || "yaml";
          if (u2 === "+++" && (d2 = "toml"), d2 !== "yaml" && u2 !== p2)
            return { content: a2 };
          let [y2] = n2;
          return { frontMatter: { type: "front-matter", lang: d2, value: l2, startDelimiter: u2, endDelimiter: p2, raw: y2.replace(/\n$/, "") }, content: y2.replace(/[^\n]/g, " ") + a2.slice(y2.length) };
        }
        r2.exports = s2;
      } }), wd2 = Z2({ "src/language-css/pragma.js"(e25, r2) {
        ne2();
        var t2 = Co(), s2 = _o2();
        function a2(u2) {
          return t2.hasPragma(s2(u2).content);
        }
        function n2(u2) {
          let { frontMatter: i2, content: l2 } = s2(u2);
          return (i2 ? i2.raw + `

` : "") + t2.insertPragma(l2);
        }
        r2.exports = { hasPragma: a2, insertPragma: n2 };
      } }), _d2 = Z2({ "src/language-css/utils/index.js"(e25, r2) {
        ne2();
        var t2 = new Set(["red", "green", "blue", "alpha", "a", "rgb", "hue", "h", "saturation", "s", "lightness", "l", "whiteness", "w", "blackness", "b", "tint", "shade", "blend", "blenda", "contrast", "hsl", "hsla", "hwb", "hwba"]);
        function s2(z2, ue2) {
          let J2 = Array.isArray(ue2) ? ue2 : [ue2], le2 = -1, ge2;
          for (; ge2 = z2.getParentNode(++le2); )
            if (J2.includes(ge2.type))
              return le2;
          return -1;
        }
        function a2(z2, ue2) {
          let J2 = s2(z2, ue2);
          return J2 === -1 ? null : z2.getParentNode(J2);
        }
        function n2(z2) {
          var ue2;
          let J2 = a2(z2, "css-decl");
          return J2 == null || (ue2 = J2.prop) === null || ue2 === void 0 ? void 0 : ue2.toLowerCase();
        }
        var u2 = new Set(["initial", "inherit", "unset", "revert"]);
        function i2(z2) {
          return u2.has(z2.toLowerCase());
        }
        function l2(z2, ue2) {
          let J2 = a2(z2, "css-atrule");
          return (J2 == null ? void 0 : J2.name) && J2.name.toLowerCase().endsWith("keyframes") && ["from", "to"].includes(ue2.toLowerCase());
        }
        function p2(z2) {
          return z2.includes("$") || z2.includes("@") || z2.includes("#") || z2.startsWith("%") || z2.startsWith("--") || z2.startsWith(":--") || z2.includes("(") && z2.includes(")") ? z2 : z2.toLowerCase();
        }
        function d2(z2, ue2) {
          var J2;
          let le2 = a2(z2, "value-func");
          return (le2 == null || (J2 = le2.value) === null || J2 === void 0 ? void 0 : J2.toLowerCase()) === ue2;
        }
        function y2(z2) {
          var ue2;
          let J2 = a2(z2, "css-rule"), le2 = J2 == null || (ue2 = J2.raws) === null || ue2 === void 0 ? void 0 : ue2.selector;
          return le2 && (le2.startsWith(":import") || le2.startsWith(":export"));
        }
        function g2(z2, ue2) {
          let J2 = Array.isArray(ue2) ? ue2 : [ue2], le2 = a2(z2, "css-atrule");
          return le2 && J2.includes(le2.name.toLowerCase());
        }
        function c2(z2) {
          let ue2 = z2.getValue(), J2 = a2(z2, "css-atrule");
          return (J2 == null ? void 0 : J2.name) === "import" && ue2.groups[0].value === "url" && ue2.groups.length === 2;
        }
        function D2(z2) {
          return z2.type === "value-func" && z2.value.toLowerCase() === "url";
        }
        function E2(z2, ue2) {
          var J2;
          let le2 = (J2 = z2.getParentNode()) === null || J2 === void 0 ? void 0 : J2.nodes;
          return le2 && le2.indexOf(ue2) === le2.length - 1;
        }
        function _2(z2) {
          let { selector: ue2 } = z2;
          return ue2 ? typeof ue2 == "string" && /^@.+:.*$/.test(ue2) || ue2.value && /^@.+:.*$/.test(ue2.value) : false;
        }
        function w2(z2) {
          return z2.type === "value-word" && ["from", "through", "end"].includes(z2.value);
        }
        function F2(z2) {
          return z2.type === "value-word" && ["and", "or", "not"].includes(z2.value);
        }
        function A2(z2) {
          return z2.type === "value-word" && z2.value === "in";
        }
        function N2(z2) {
          return z2.type === "value-operator" && z2.value === "*";
        }
        function I2(z2) {
          return z2.type === "value-operator" && z2.value === "/";
        }
        function P2(z2) {
          return z2.type === "value-operator" && z2.value === "+";
        }
        function H2(z2) {
          return z2.type === "value-operator" && z2.value === "-";
        }
        function f2(z2) {
          return z2.type === "value-operator" && z2.value === "%";
        }
        function b2(z2) {
          return N2(z2) || I2(z2) || P2(z2) || H2(z2) || f2(z2);
        }
        function m2(z2) {
          return z2.type === "value-word" && ["==", "!="].includes(z2.value);
        }
        function v2(z2) {
          return z2.type === "value-word" && ["<", ">", "<=", ">="].includes(z2.value);
        }
        function o2(z2) {
          return z2.type === "css-atrule" && ["if", "else", "for", "each", "while"].includes(z2.name);
        }
        function h2(z2) {
          var ue2;
          return ((ue2 = z2.raws) === null || ue2 === void 0 ? void 0 : ue2.params) && /^\(\s*\)$/.test(z2.raws.params);
        }
        function C2(z2) {
          return z2.name.startsWith("prettier-placeholder");
        }
        function S2(z2) {
          return z2.prop.startsWith("@prettier-placeholder");
        }
        function x2(z2, ue2) {
          return z2.value === "$$" && z2.type === "value-func" && (ue2 == null ? void 0 : ue2.type) === "value-word" && !ue2.raws.before;
        }
        function T2(z2) {
          var ue2, J2;
          return ((ue2 = z2.value) === null || ue2 === void 0 ? void 0 : ue2.type) === "value-root" && ((J2 = z2.value.group) === null || J2 === void 0 ? void 0 : J2.type) === "value-value" && z2.prop.toLowerCase() === "composes";
        }
        function k2(z2) {
          var ue2, J2, le2;
          return ((ue2 = z2.value) === null || ue2 === void 0 || (J2 = ue2.group) === null || J2 === void 0 || (le2 = J2.group) === null || le2 === void 0 ? void 0 : le2.type) === "value-paren_group" && z2.value.group.group.open !== null && z2.value.group.group.close !== null;
        }
        function M2(z2) {
          var ue2;
          return ((ue2 = z2.raws) === null || ue2 === void 0 ? void 0 : ue2.before) === "";
        }
        function R2(z2) {
          var ue2, J2;
          return z2.type === "value-comma_group" && ((ue2 = z2.groups) === null || ue2 === void 0 || (J2 = ue2[1]) === null || J2 === void 0 ? void 0 : J2.type) === "value-colon";
        }
        function q2(z2) {
          var ue2;
          return z2.type === "value-paren_group" && ((ue2 = z2.groups) === null || ue2 === void 0 ? void 0 : ue2[0]) && R2(z2.groups[0]);
        }
        function U2(z2) {
          var ue2;
          let J2 = z2.getValue();
          if (J2.groups.length === 0)
            return false;
          let le2 = z2.getParentNode(1);
          if (!q2(J2) && !(le2 && q2(le2)))
            return false;
          let ge2 = a2(z2, "css-decl");
          return !!(ge2 != null && (ue2 = ge2.prop) !== null && ue2 !== void 0 && ue2.startsWith("$") || q2(le2) || le2.type === "value-func");
        }
        function L2(z2) {
          return z2.type === "value-comment" && z2.inline;
        }
        function Y2(z2) {
          return z2.type === "value-word" && z2.value === "#";
        }
        function V2(z2) {
          return z2.type === "value-word" && z2.value === "{";
        }
        function j2(z2) {
          return z2.type === "value-word" && z2.value === "}";
        }
        function K2(z2) {
          return ["value-word", "value-atword"].includes(z2.type);
        }
        function se2(z2) {
          return (z2 == null ? void 0 : z2.type) === "value-colon";
        }
        function Q2(z2, ue2) {
          if (!R2(ue2))
            return false;
          let { groups: J2 } = ue2, le2 = J2.indexOf(z2);
          return le2 === -1 ? false : se2(J2[le2 + 1]);
        }
        function ce2(z2) {
          return z2.value && ["not", "and", "or"].includes(z2.value.toLowerCase());
        }
        function W2(z2) {
          return z2.type !== "value-func" ? false : t2.has(z2.value.toLowerCase());
        }
        function X2(z2) {
          return /\/\//.test(z2.split(/[\n\r]/).pop());
        }
        function de2(z2) {
          return (z2 == null ? void 0 : z2.type) === "value-atword" && z2.value.startsWith("prettier-placeholder-");
        }
        function ie2(z2, ue2) {
          var J2, le2;
          if (((J2 = z2.open) === null || J2 === void 0 ? void 0 : J2.value) !== "(" || ((le2 = z2.close) === null || le2 === void 0 ? void 0 : le2.value) !== ")" || z2.groups.some((ge2) => ge2.type !== "value-comma_group"))
            return false;
          if (ue2.type === "value-comma_group") {
            let ge2 = ue2.groups.indexOf(z2) - 1, pe2 = ue2.groups[ge2];
            if ((pe2 == null ? void 0 : pe2.type) === "value-word" && pe2.value === "with")
              return true;
          }
          return false;
        }
        function Ee2(z2) {
          var ue2, J2;
          return z2.type === "value-paren_group" && ((ue2 = z2.open) === null || ue2 === void 0 ? void 0 : ue2.value) === "(" && ((J2 = z2.close) === null || J2 === void 0 ? void 0 : J2.value) === ")";
        }
        r2.exports = { getAncestorCounter: s2, getAncestorNode: a2, getPropOfDeclNode: n2, maybeToLowerCase: p2, insideValueFunctionNode: d2, insideICSSRuleNode: y2, insideAtRuleNode: g2, insideURLFunctionInImportAtRuleNode: c2, isKeyframeAtRuleKeywords: l2, isWideKeywords: i2, isLastNode: E2, isSCSSControlDirectiveNode: o2, isDetachedRulesetDeclarationNode: _2, isRelationalOperatorNode: v2, isEqualityOperatorNode: m2, isMultiplicationNode: N2, isDivisionNode: I2, isAdditionNode: P2, isSubtractionNode: H2, isModuloNode: f2, isMathOperatorNode: b2, isEachKeywordNode: A2, isForKeywordNode: w2, isURLFunctionNode: D2, isIfElseKeywordNode: F2, hasComposesNode: T2, hasParensAroundNode: k2, hasEmptyRawBefore: M2, isDetachedRulesetCallNode: h2, isTemplatePlaceholderNode: C2, isTemplatePropNode: S2, isPostcssSimpleVarNode: x2, isKeyValuePairNode: R2, isKeyValuePairInParenGroupNode: q2, isKeyInValuePairNode: Q2, isSCSSMapItemNode: U2, isInlineValueCommentNode: L2, isHashNode: Y2, isLeftCurlyBraceNode: V2, isRightCurlyBraceNode: j2, isWordNode: K2, isColonNode: se2, isMediaAndSupportsKeywords: ce2, isColorAdjusterFuncNode: W2, lastLineHasInlineComment: X2, isAtWordPlaceholderNode: de2, isConfigurationNode: ie2, isParenGroupNode: Ee2 };
      } }), Pd2 = Z2({ "src/utils/line-column-to-index.js"(e25, r2) {
        ne2(), r2.exports = function(t2, s2) {
          let a2 = 0;
          for (let n2 = 0; n2 < t2.line - 1; ++n2)
            a2 = s2.indexOf(`
`, a2) + 1;
          return a2 + t2.column;
        };
      } }), Id2 = Z2({ "src/language-css/loc.js"(e25, r2) {
        ne2();
        var { skipEverythingButNewLine: t2 } = Pr2(), s2 = lt2(), a2 = Pd2();
        function n2(c2, D2) {
          return typeof c2.sourceIndex == "number" ? c2.sourceIndex : c2.source ? a2(c2.source.start, D2) - 1 : null;
        }
        function u2(c2, D2) {
          if (c2.type === "css-comment" && c2.inline)
            return t2(D2, c2.source.startOffset);
          let E2 = c2.nodes && s2(c2.nodes);
          return E2 && c2.source && !c2.source.end && (c2 = E2), c2.source && c2.source.end ? a2(c2.source.end, D2) : null;
        }
        function i2(c2, D2) {
          c2.source && (c2.source.startOffset = n2(c2, D2), c2.source.endOffset = u2(c2, D2));
          for (let E2 in c2) {
            let _2 = c2[E2];
            E2 === "source" || !_2 || typeof _2 != "object" || (_2.type === "value-root" || _2.type === "value-unknown" ? l2(_2, p2(c2), _2.text || _2.value) : i2(_2, D2));
          }
        }
        function l2(c2, D2, E2) {
          c2.source && (c2.source.startOffset = n2(c2, E2) + D2, c2.source.endOffset = u2(c2, E2) + D2);
          for (let _2 in c2) {
            let w2 = c2[_2];
            _2 === "source" || !w2 || typeof w2 != "object" || l2(w2, D2, E2);
          }
        }
        function p2(c2) {
          let D2 = c2.source.startOffset;
          return typeof c2.prop == "string" && (D2 += c2.prop.length), c2.type === "css-atrule" && typeof c2.name == "string" && (D2 += 1 + c2.name.length + c2.raws.afterName.match(/^\s*:?\s*/)[0].length), c2.type !== "css-atrule" && c2.raws && typeof c2.raws.between == "string" && (D2 += c2.raws.between.length), D2;
        }
        function d2(c2) {
          let D2 = "initial", E2 = "initial", _2, w2 = false, F2 = [];
          for (let A2 = 0; A2 < c2.length; A2++) {
            let N2 = c2[A2];
            switch (D2) {
              case "initial":
                if (N2 === "'") {
                  D2 = "single-quotes";
                  continue;
                }
                if (N2 === '"') {
                  D2 = "double-quotes";
                  continue;
                }
                if ((N2 === "u" || N2 === "U") && c2.slice(A2, A2 + 4).toLowerCase() === "url(") {
                  D2 = "url", A2 += 3;
                  continue;
                }
                if (N2 === "*" && c2[A2 - 1] === "/") {
                  D2 = "comment-block";
                  continue;
                }
                if (N2 === "/" && c2[A2 - 1] === "/") {
                  D2 = "comment-inline", _2 = A2 - 1;
                  continue;
                }
                continue;
              case "single-quotes":
                if (N2 === "'" && c2[A2 - 1] !== "\\" && (D2 = E2, E2 = "initial"), N2 === `
` || N2 === "\r")
                  return c2;
                continue;
              case "double-quotes":
                if (N2 === '"' && c2[A2 - 1] !== "\\" && (D2 = E2, E2 = "initial"), N2 === `
` || N2 === "\r")
                  return c2;
                continue;
              case "url":
                if (N2 === ")" && (D2 = "initial"), N2 === `
` || N2 === "\r")
                  return c2;
                if (N2 === "'") {
                  D2 = "single-quotes", E2 = "url";
                  continue;
                }
                if (N2 === '"') {
                  D2 = "double-quotes", E2 = "url";
                  continue;
                }
                continue;
              case "comment-block":
                N2 === "/" && c2[A2 - 1] === "*" && (D2 = "initial");
                continue;
              case "comment-inline":
                (N2 === '"' || N2 === "'" || N2 === "*") && (w2 = true), (N2 === `
` || N2 === "\r") && (w2 && F2.push([_2, A2]), D2 = "initial", w2 = false);
                continue;
            }
          }
          for (let [A2, N2] of F2)
            c2 = c2.slice(0, A2) + c2.slice(A2, N2).replace(/["'*]/g, " ") + c2.slice(N2);
          return c2;
        }
        function y2(c2) {
          return c2.source.startOffset;
        }
        function g2(c2) {
          return c2.source.endOffset;
        }
        r2.exports = { locStart: y2, locEnd: g2, calculateLoc: i2, replaceQuotesInInlineComments: d2 };
      } }), kd2 = Z2({ "src/language-css/utils/is-less-parser.js"(e25, r2) {
        ne2();
        function t2(s2) {
          return s2.parser === "css" || s2.parser === "less";
        }
        r2.exports = t2;
      } }), Ld2 = Z2({ "src/language-css/utils/is-scss.js"(e25, r2) {
        ne2();
        function t2(s2, a2) {
          return s2 === "less" || s2 === "scss" ? s2 === "scss" : /(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(a2);
        }
        r2.exports = t2;
      } }), Od2 = Z2({ "src/language-css/utils/css-units.evaluate.js"(e25, r2) {
        r2.exports = { em: "em", rem: "rem", ex: "ex", rex: "rex", cap: "cap", rcap: "rcap", ch: "ch", rch: "rch", ic: "ic", ric: "ric", lh: "lh", rlh: "rlh", vw: "vw", svw: "svw", lvw: "lvw", dvw: "dvw", vh: "vh", svh: "svh", lvh: "lvh", dvh: "dvh", vi: "vi", svi: "svi", lvi: "lvi", dvi: "dvi", vb: "vb", svb: "svb", lvb: "lvb", dvb: "dvb", vmin: "vmin", svmin: "svmin", lvmin: "lvmin", dvmin: "dvmin", vmax: "vmax", svmax: "svmax", lvmax: "lvmax", dvmax: "dvmax", cm: "cm", mm: "mm", q: "Q", in: "in", pt: "pt", pc: "pc", px: "px", deg: "deg", grad: "grad", rad: "rad", turn: "turn", s: "s", ms: "ms", hz: "Hz", khz: "kHz", dpi: "dpi", dpcm: "dpcm", dppx: "dppx", x: "x" };
      } }), jd2 = Z2({ "src/language-css/utils/print-unit.js"(e25, r2) {
        ne2();
        var t2 = Od2();
        function s2(a2) {
          let n2 = a2.toLowerCase();
          return Object.prototype.hasOwnProperty.call(t2, n2) ? t2[n2] : a2;
        }
        r2.exports = s2;
      } }), qd2 = Z2({ "src/language-css/printer-postcss.js"(e25, r2) {
        ne2();
        var t2 = lt2(), { printNumber: s2, printString: a2, hasNewline: n2, isFrontMatterNode: u2, isNextLineEmpty: i2, isNonEmptyArray: l2 } = Ue2(), { builders: { join: p2, line: d2, hardline: y2, softline: g2, group: c2, fill: D2, indent: E2, dedent: _2, ifBreak: w2, breakParent: F2 }, utils: { removeLines: A2, getDocParts: N2 } } = Me2(), I2 = Bd2(), P2 = Nd2(), { insertPragma: H2 } = wd2(), { getAncestorNode: f2, getPropOfDeclNode: b2, maybeToLowerCase: m2, insideValueFunctionNode: v2, insideICSSRuleNode: o2, insideAtRuleNode: h2, insideURLFunctionInImportAtRuleNode: C2, isKeyframeAtRuleKeywords: S2, isWideKeywords: x2, isLastNode: T2, isSCSSControlDirectiveNode: k2, isDetachedRulesetDeclarationNode: M2, isRelationalOperatorNode: R2, isEqualityOperatorNode: q2, isMultiplicationNode: U2, isDivisionNode: L2, isAdditionNode: Y2, isSubtractionNode: V2, isMathOperatorNode: j2, isEachKeywordNode: K2, isForKeywordNode: se2, isURLFunctionNode: Q2, isIfElseKeywordNode: ce2, hasComposesNode: W2, hasParensAroundNode: X2, hasEmptyRawBefore: de2, isKeyValuePairNode: ie2, isKeyInValuePairNode: Ee2, isDetachedRulesetCallNode: z2, isTemplatePlaceholderNode: ue2, isTemplatePropNode: J2, isPostcssSimpleVarNode: le2, isSCSSMapItemNode: ge2, isInlineValueCommentNode: pe2, isHashNode: Ae2, isLeftCurlyBraceNode: Ce2, isRightCurlyBraceNode: Oe2, isWordNode: Ie2, isColonNode: we2, isMediaAndSupportsKeywords: _e2, isColorAdjusterFuncNode: De2, lastLineHasInlineComment: G2, isAtWordPlaceholderNode: oe2, isConfigurationNode: ee2, isParenGroupNode: re2 } = _d2(), { locStart: be2, locEnd: ve2 } = Id2(), fe2 = kd2(), B2 = Ld2(), $2 = jd2();
        function te2(Be2) {
          return Be2.trailingComma === "es5" || Be2.trailingComma === "all";
        }
        function ye2(Be2, qe2, Re2) {
          let ae2 = Be2.getValue();
          if (!ae2)
            return "";
          if (typeof ae2 == "string")
            return ae2;
          switch (ae2.type) {
            case "front-matter":
              return [ae2.raw, y2];
            case "css-root": {
              let Ve2 = Fe2(Be2, qe2, Re2), We2 = ae2.raws.after.trim();
              return We2.startsWith(";") && (We2 = We2.slice(1).trim()), [Ve2, We2 ? ` ${We2}` : "", N2(Ve2).length > 0 ? y2 : ""];
            }
            case "css-comment": {
              let Ve2 = ae2.inline || ae2.raws.inline, We2 = qe2.originalText.slice(be2(ae2), ve2(ae2));
              return Ve2 ? We2.trimEnd() : We2;
            }
            case "css-rule":
              return [Re2("selector"), ae2.important ? " !important" : "", ae2.nodes ? [ae2.selector && ae2.selector.type === "selector-unknown" && G2(ae2.selector.value) ? d2 : " ", "{", ae2.nodes.length > 0 ? E2([y2, Fe2(Be2, qe2, Re2)]) : "", y2, "}", M2(ae2) ? ";" : ""] : ";"];
            case "css-decl": {
              let Ve2 = Be2.getParentNode(), { between: We2 } = ae2.raws, Xe2 = We2.trim(), st2 = Xe2 === ":", O2 = W2(ae2) ? A2(Re2("value")) : Re2("value");
              return !st2 && G2(Xe2) && (O2 = E2([y2, _2(O2)])), [ae2.raws.before.replace(/[\s;]/g, ""), Ve2.type === "css-atrule" && Ve2.variable || o2(Be2) ? ae2.prop : m2(ae2.prop), Xe2.startsWith("//") ? " " : "", Xe2, ae2.extend ? "" : " ", fe2(qe2) && ae2.extend && ae2.selector ? ["extend(", Re2("selector"), ")"] : "", O2, ae2.raws.important ? ae2.raws.important.replace(/\s*!\s*important/i, " !important") : ae2.important ? " !important" : "", ae2.raws.scssDefault ? ae2.raws.scssDefault.replace(/\s*!default/i, " !default") : ae2.scssDefault ? " !default" : "", ae2.raws.scssGlobal ? ae2.raws.scssGlobal.replace(/\s*!global/i, " !global") : ae2.scssGlobal ? " !global" : "", ae2.nodes ? [" {", E2([g2, Fe2(Be2, qe2, Re2)]), g2, "}"] : J2(ae2) && !Ve2.raws.semicolon && qe2.originalText[ve2(ae2) - 1] !== ";" ? "" : qe2.__isHTMLStyleAttribute && T2(Be2, ae2) ? w2(";") : ";"];
            }
            case "css-atrule": {
              let Ve2 = Be2.getParentNode(), We2 = ue2(ae2) && !Ve2.raws.semicolon && qe2.originalText[ve2(ae2) - 1] !== ";";
              if (fe2(qe2)) {
                if (ae2.mixin)
                  return [Re2("selector"), ae2.important ? " !important" : "", We2 ? "" : ";"];
                if (ae2.function)
                  return [ae2.name, Re2("params"), We2 ? "" : ";"];
                if (ae2.variable)
                  return ["@", ae2.name, ": ", ae2.value ? Re2("value") : "", ae2.raws.between.trim() ? ae2.raws.between.trim() + " " : "", ae2.nodes ? ["{", E2([ae2.nodes.length > 0 ? g2 : "", Fe2(Be2, qe2, Re2)]), g2, "}"] : "", We2 ? "" : ";"];
              }
              return ["@", z2(ae2) || ae2.name.endsWith(":") ? ae2.name : m2(ae2.name), ae2.params ? [z2(ae2) ? "" : ue2(ae2) ? ae2.raws.afterName === "" ? "" : ae2.name.endsWith(":") ? " " : /^\s*\n\s*\n/.test(ae2.raws.afterName) ? [y2, y2] : /^\s*\n/.test(ae2.raws.afterName) ? y2 : " " : " ", Re2("params")] : "", ae2.selector ? E2([" ", Re2("selector")]) : "", ae2.value ? c2([" ", Re2("value"), k2(ae2) ? X2(ae2) ? " " : d2 : ""]) : ae2.name === "else" ? " " : "", ae2.nodes ? [k2(ae2) ? "" : ae2.selector && !ae2.selector.nodes && typeof ae2.selector.value == "string" && G2(ae2.selector.value) || !ae2.selector && typeof ae2.params == "string" && G2(ae2.params) ? d2 : " ", "{", E2([ae2.nodes.length > 0 ? g2 : "", Fe2(Be2, qe2, Re2)]), g2, "}"] : We2 ? "" : ";"];
            }
            case "media-query-list": {
              let Ve2 = [];
              return Be2.each((We2) => {
                let Xe2 = We2.getValue();
                Xe2.type === "media-query" && Xe2.value === "" || Ve2.push(Re2());
              }, "nodes"), c2(E2(p2(d2, Ve2)));
            }
            case "media-query":
              return [p2(" ", Be2.map(Re2, "nodes")), T2(Be2, ae2) ? "" : ","];
            case "media-type":
              return je2(Se2(ae2.value, qe2));
            case "media-feature-expression":
              return ae2.nodes ? ["(", ...Be2.map(Re2, "nodes"), ")"] : ae2.value;
            case "media-feature":
              return m2(Se2(ae2.value.replace(/ +/g, " "), qe2));
            case "media-colon":
              return [ae2.value, " "];
            case "media-value":
              return je2(Se2(ae2.value, qe2));
            case "media-keyword":
              return Se2(ae2.value, qe2);
            case "media-url":
              return Se2(ae2.value.replace(/^url\(\s+/gi, "url(").replace(/\s+\)$/g, ")"), qe2);
            case "media-unknown":
              return ae2.value;
            case "selector-root":
              return c2([h2(Be2, "custom-selector") ? [f2(Be2, "css-atrule").customSelector, d2] : "", p2([",", h2(Be2, ["extend", "custom-selector", "nest"]) ? d2 : y2], Be2.map(Re2, "nodes"))]);
            case "selector-selector":
              return c2(E2(Be2.map(Re2, "nodes")));
            case "selector-comment":
              return ae2.value;
            case "selector-string":
              return Se2(ae2.value, qe2);
            case "selector-tag": {
              let Ve2 = Be2.getParentNode(), We2 = Ve2 && Ve2.nodes.indexOf(ae2), Xe2 = We2 && Ve2.nodes[We2 - 1];
              return [ae2.namespace ? [ae2.namespace === true ? "" : ae2.namespace.trim(), "|"] : "", Xe2.type === "selector-nesting" ? ae2.value : je2(S2(Be2, ae2.value) ? ae2.value.toLowerCase() : ae2.value)];
            }
            case "selector-id":
              return ["#", ae2.value];
            case "selector-class":
              return [".", je2(Se2(ae2.value, qe2))];
            case "selector-attribute": {
              var nt2;
              return ["[", ae2.namespace ? [ae2.namespace === true ? "" : ae2.namespace.trim(), "|"] : "", ae2.attribute.trim(), (nt2 = ae2.operator) !== null && nt2 !== void 0 ? nt2 : "", ae2.value ? ke2(Se2(ae2.value.trim(), qe2), qe2) : "", ae2.insensitive ? " i" : "", "]"];
            }
            case "selector-combinator": {
              if (ae2.value === "+" || ae2.value === ">" || ae2.value === "~" || ae2.value === ">>>") {
                let Xe2 = Be2.getParentNode();
                return [Xe2.type === "selector-selector" && Xe2.nodes[0] === ae2 ? "" : d2, ae2.value, T2(Be2, ae2) ? "" : " "];
              }
              let Ve2 = ae2.value.trim().startsWith("(") ? d2 : "", We2 = je2(Se2(ae2.value.trim(), qe2)) || d2;
              return [Ve2, We2];
            }
            case "selector-universal":
              return [ae2.namespace ? [ae2.namespace === true ? "" : ae2.namespace.trim(), "|"] : "", ae2.value];
            case "selector-pseudo":
              return [m2(ae2.value), l2(ae2.nodes) ? c2(["(", E2([g2, p2([",", d2], Be2.map(Re2, "nodes"))]), g2, ")"]) : ""];
            case "selector-nesting":
              return ae2.value;
            case "selector-unknown": {
              let Ve2 = f2(Be2, "css-rule");
              if (Ve2 && Ve2.isSCSSNesterProperty)
                return je2(Se2(m2(ae2.value), qe2));
              let We2 = Be2.getParentNode();
              if (We2.raws && We2.raws.selector) {
                let st2 = be2(We2), O2 = st2 + We2.raws.selector.length;
                return qe2.originalText.slice(st2, O2).trim();
              }
              let Xe2 = Be2.getParentNode(1);
              if (We2.type === "value-paren_group" && Xe2 && Xe2.type === "value-func" && Xe2.value === "selector") {
                let st2 = ve2(We2.open) + 1, O2 = be2(We2.close), me2 = qe2.originalText.slice(st2, O2).trim();
                return G2(me2) ? [F2, me2] : me2;
              }
              return ae2.value;
            }
            case "value-value":
            case "value-root":
              return Re2("group");
            case "value-comment":
              return qe2.originalText.slice(be2(ae2), ve2(ae2));
            case "value-comma_group": {
              let Ve2 = Be2.getParentNode(), We2 = Be2.getParentNode(1), Xe2 = b2(Be2), st2 = Xe2 && Ve2.type === "value-value" && (Xe2 === "grid" || Xe2.startsWith("grid-template")), O2 = f2(Be2, "css-atrule"), me2 = O2 && k2(O2), Pe2 = ae2.groups.some((at2) => pe2(at2)), He2 = Be2.map(Re2, "groups"), Ge2 = [], it2 = v2(Be2, "url"), Qe2 = false, rt2 = false;
              for (let at2 = 0; at2 < ae2.groups.length; ++at2) {
                var tt2;
                Ge2.push(He2[at2]);
                let Ze2 = ae2.groups[at2 - 1], Le2 = ae2.groups[at2], $e2 = ae2.groups[at2 + 1], sr2 = ae2.groups[at2 + 2];
                if (it2) {
                  ($e2 && Y2($e2) || Y2(Le2)) && Ge2.push(" ");
                  continue;
                }
                if (h2(Be2, "forward") && Le2.type === "value-word" && Le2.value && Ze2 !== void 0 && Ze2.type === "value-word" && Ze2.value === "as" && $e2.type === "value-operator" && $e2.value === "*" || !$e2 || Le2.type === "value-word" && Le2.value.endsWith("-") && oe2($e2))
                  continue;
                if (Le2.type === "value-string" && Le2.quoted) {
                  let $r2 = Le2.value.lastIndexOf("#{"), Vr2 = Le2.value.lastIndexOf("}");
                  $r2 !== -1 && Vr2 !== -1 ? Qe2 = $r2 > Vr2 : $r2 !== -1 ? Qe2 = true : Vr2 !== -1 && (Qe2 = false);
                }
                if (Qe2 || we2(Le2) || we2($e2) || Le2.type === "value-atword" && (Le2.value === "" || Le2.value.endsWith("[")) || $e2.type === "value-word" && $e2.value.startsWith("]") || Le2.value === "~" || Le2.value && Le2.value.includes("\\") && $e2 && $e2.type !== "value-comment" || Ze2 && Ze2.value && Ze2.value.indexOf("\\") === Ze2.value.length - 1 && Le2.type === "value-operator" && Le2.value === "/" || Le2.value === "\\" || le2(Le2, $e2) || Ae2(Le2) || Ce2(Le2) || Oe2($e2) || Ce2($e2) && de2($e2) || Oe2(Le2) && de2($e2) || Le2.value === "--" && Ae2($e2))
                  continue;
                let Rr2 = j2(Le2), ou2 = j2($e2);
                if ((Rr2 && Ae2($e2) || ou2 && Oe2(Le2)) && de2($e2) || !Ze2 && L2(Le2) || v2(Be2, "calc") && (Y2(Le2) || Y2($e2) || V2(Le2) || V2($e2)) && de2($e2))
                  continue;
                let qo2 = (Y2(Le2) || V2(Le2)) && at2 === 0 && ($e2.type === "value-number" || $e2.isHex) && We2 && De2(We2) && !de2($e2), lu2 = sr2 && sr2.type === "value-func" || sr2 && Ie2(sr2) || Le2.type === "value-func" || Ie2(Le2), cu2 = $e2.type === "value-func" || Ie2($e2) || Ze2 && Ze2.type === "value-func" || Ze2 && Ie2(Ze2);
                if (!(!(U2($e2) || U2(Le2)) && !v2(Be2, "calc") && !qo2 && (L2($e2) && !lu2 || L2(Le2) && !cu2 || Y2($e2) && !lu2 || Y2(Le2) && !cu2 || V2($e2) || V2(Le2)) && (de2($e2) || Rr2 && (!Ze2 || Ze2 && j2(Ze2)))) && !((qe2.parser === "scss" || qe2.parser === "less") && Rr2 && Le2.value === "-" && re2($e2) && ve2(Le2) === be2($e2.open) && $e2.open.value === "(")) {
                  if (pe2(Le2)) {
                    if (Ve2.type === "value-paren_group") {
                      Ge2.push(_2(y2));
                      continue;
                    }
                    Ge2.push(y2);
                    continue;
                  }
                  if (me2 && (q2($e2) || R2($e2) || ce2($e2) || K2(Le2) || se2(Le2))) {
                    Ge2.push(" ");
                    continue;
                  }
                  if (O2 && O2.name.toLowerCase() === "namespace") {
                    Ge2.push(" ");
                    continue;
                  }
                  if (st2) {
                    Le2.source && $e2.source && Le2.source.start.line !== $e2.source.start.line ? (Ge2.push(y2), rt2 = true) : Ge2.push(" ");
                    continue;
                  }
                  if (ou2) {
                    Ge2.push(" ");
                    continue;
                  }
                  if (!($e2 && $e2.value === "...") && !(oe2(Le2) && oe2($e2) && ve2(Le2) === be2($e2))) {
                    if (oe2(Le2) && re2($e2) && ve2(Le2) === be2($e2.open)) {
                      Ge2.push(g2);
                      continue;
                    }
                    if (Le2.value === "with" && re2($e2)) {
                      Ge2.push(" ");
                      continue;
                    }
                    (tt2 = Le2.value) !== null && tt2 !== void 0 && tt2.endsWith("#") && $e2.value === "{" && re2($e2.group) || Ge2.push(d2);
                  }
                }
              }
              return Pe2 && Ge2.push(F2), rt2 && Ge2.unshift(y2), me2 ? c2(E2(Ge2)) : C2(Be2) ? c2(D2(Ge2)) : c2(E2(D2(Ge2)));
            }
            case "value-paren_group": {
              let Ve2 = Be2.getParentNode();
              if (Ve2 && Q2(Ve2) && (ae2.groups.length === 1 || ae2.groups.length > 0 && ae2.groups[0].type === "value-comma_group" && ae2.groups[0].groups.length > 0 && ae2.groups[0].groups[0].type === "value-word" && ae2.groups[0].groups[0].value.startsWith("data:")))
                return [ae2.open ? Re2("open") : "", p2(",", Be2.map(Re2, "groups")), ae2.close ? Re2("close") : ""];
              if (!ae2.open) {
                let it2 = Be2.map(Re2, "groups"), Qe2 = [];
                for (let rt2 = 0; rt2 < it2.length; rt2++)
                  rt2 !== 0 && Qe2.push([",", d2]), Qe2.push(it2[rt2]);
                return c2(E2(D2(Qe2)));
              }
              let We2 = ge2(Be2), Xe2 = t2(ae2.groups), st2 = Xe2 && Xe2.type === "value-comment", O2 = Ee2(ae2, Ve2), me2 = ee2(ae2, Ve2), Pe2 = me2 || We2 && !O2, He2 = me2 || O2, Ge2 = c2([ae2.open ? Re2("open") : "", E2([g2, p2([d2], Be2.map((it2, Qe2) => {
                let rt2 = it2.getValue(), at2 = Qe2 === ae2.groups.length - 1, Ze2 = [Re2(), at2 ? "" : ","];
                if (ie2(rt2) && rt2.type === "value-comma_group" && rt2.groups && rt2.groups[0].type !== "value-paren_group" && rt2.groups[2] && rt2.groups[2].type === "value-paren_group") {
                  let Le2 = N2(Ze2[0].contents.contents);
                  Le2[1] = c2(Le2[1]), Ze2 = [c2(_2(Ze2))];
                }
                if (!at2 && rt2.type === "value-comma_group" && l2(rt2.groups)) {
                  let Le2 = t2(rt2.groups);
                  !Le2.source && Le2.close && (Le2 = Le2.close), Le2.source && i2(qe2.originalText, Le2, ve2) && Ze2.push(y2);
                }
                return Ze2;
              }, "groups"))]), w2(!st2 && B2(qe2.parser, qe2.originalText) && We2 && te2(qe2) ? "," : ""), g2, ae2.close ? Re2("close") : ""], { shouldBreak: Pe2 });
              return He2 ? _2(Ge2) : Ge2;
            }
            case "value-func":
              return [ae2.value, h2(Be2, "supports") && _e2(ae2) ? " " : "", Re2("group")];
            case "value-paren":
              return ae2.value;
            case "value-number":
              return [Je2(ae2.value), $2(ae2.unit)];
            case "value-operator":
              return ae2.value;
            case "value-word":
              return ae2.isColor && ae2.isHex || x2(ae2.value) ? ae2.value.toLowerCase() : ae2.value;
            case "value-colon": {
              let Ve2 = Be2.getParentNode(), We2 = Ve2 && Ve2.groups.indexOf(ae2), Xe2 = We2 && Ve2.groups[We2 - 1];
              return [ae2.value, Xe2 && typeof Xe2.value == "string" && t2(Xe2.value) === "\\" || v2(Be2, "url") ? "" : d2];
            }
            case "value-comma":
              return [ae2.value, " "];
            case "value-string":
              return a2(ae2.raws.quote + ae2.value + ae2.raws.quote, qe2);
            case "value-atword":
              return ["@", ae2.value];
            case "value-unicode-range":
              return ae2.value;
            case "value-unknown":
              return ae2.value;
            default:
              throw new Error(`Unknown postcss type ${JSON.stringify(ae2.type)}`);
          }
        }
        function Fe2(Be2, qe2, Re2) {
          let ae2 = [];
          return Be2.each((nt2, tt2, Ve2) => {
            let We2 = Ve2[tt2 - 1];
            if (We2 && We2.type === "css-comment" && We2.text.trim() === "prettier-ignore") {
              let Xe2 = nt2.getValue();
              ae2.push(qe2.originalText.slice(be2(Xe2), ve2(Xe2)));
            } else
              ae2.push(Re2());
            tt2 !== Ve2.length - 1 && (Ve2[tt2 + 1].type === "css-comment" && !n2(qe2.originalText, be2(Ve2[tt2 + 1]), { backwards: true }) && !u2(Ve2[tt2]) || Ve2[tt2 + 1].type === "css-atrule" && Ve2[tt2 + 1].name === "else" && Ve2[tt2].type !== "css-comment" ? ae2.push(" ") : (ae2.push(qe2.__isHTMLStyleAttribute ? d2 : y2), i2(qe2.originalText, nt2.getValue(), ve2) && !u2(Ve2[tt2]) && ae2.push(y2)));
          }, "nodes"), ae2;
        }
        var Ne2 = /(["'])(?:(?!\1)[^\\]|\\.)*\1/gs, he2 = /(?:\d*\.\d+|\d+\.?)(?:[Ee][+-]?\d+)?/g, ze2 = /[A-Za-z]+/g, Te2 = /[$@]?[A-Z_a-z\u0080-\uFFFF][\w\u0080-\uFFFF-]*/g, Ye2 = new RegExp(Ne2.source + `|(${Te2.source})?(${he2.source})(${ze2.source})?`, "g");
        function Se2(Be2, qe2) {
          return Be2.replace(Ne2, (Re2) => a2(Re2, qe2));
        }
        function ke2(Be2, qe2) {
          let Re2 = qe2.singleQuote ? "'" : '"';
          return Be2.includes('"') || Be2.includes("'") ? Be2 : Re2 + Be2 + Re2;
        }
        function je2(Be2) {
          return Be2.replace(Ye2, (qe2, Re2, ae2, nt2, tt2) => !ae2 && nt2 ? Je2(nt2) + m2(tt2 || "") : qe2);
        }
        function Je2(Be2) {
          return s2(Be2).replace(/\.0(?=$|e)/, "");
        }
        r2.exports = { print: ye2, embed: P2, insertPragma: H2, massageAstNode: I2 };
      } }), Md2 = Z2({ "src/language-css/options.js"(e25, r2) {
        ne2();
        var t2 = Mt2();
        r2.exports = { singleQuote: t2.singleQuote };
      } }), Rd2 = Z2({ "src/language-css/parsers.js"() {
        ne2();
      } }), $d2 = Z2({ "node_modules/linguist-languages/data/CSS.json"(e25, r2) {
        r2.exports = { name: "CSS", type: "markup", tmScope: "source.css", aceMode: "css", codemirrorMode: "css", codemirrorMimeType: "text/css", color: "#563d7c", extensions: [".css"], languageId: 50 };
      } }), Vd2 = Z2({ "node_modules/linguist-languages/data/PostCSS.json"(e25, r2) {
        r2.exports = { name: "PostCSS", type: "markup", color: "#dc3a0c", tmScope: "source.postcss", group: "CSS", extensions: [".pcss", ".postcss"], aceMode: "text", languageId: 262764437 };
      } }), Wd2 = Z2({ "node_modules/linguist-languages/data/Less.json"(e25, r2) {
        r2.exports = { name: "Less", type: "markup", color: "#1d365d", aliases: ["less-css"], extensions: [".less"], tmScope: "source.css.less", aceMode: "less", codemirrorMode: "css", codemirrorMimeType: "text/css", languageId: 198 };
      } }), Hd2 = Z2({ "node_modules/linguist-languages/data/SCSS.json"(e25, r2) {
        r2.exports = { name: "SCSS", type: "markup", color: "#c6538c", tmScope: "source.css.scss", aceMode: "scss", codemirrorMode: "css", codemirrorMimeType: "text/x-scss", extensions: [".scss"], languageId: 329 };
      } }), Gd2 = Z2({ "src/language-css/index.js"(e25, r2) {
        ne2();
        var t2 = _t2(), s2 = qd2(), a2 = Md2(), n2 = Rd2(), u2 = [t2($d2(), (l2) => ({ since: "1.4.0", parsers: ["css"], vscodeLanguageIds: ["css"], extensions: [...l2.extensions, ".wxss"] })), t2(Vd2(), () => ({ since: "1.4.0", parsers: ["css"], vscodeLanguageIds: ["postcss"] })), t2(Wd2(), () => ({ since: "1.4.0", parsers: ["less"], vscodeLanguageIds: ["less"] })), t2(Hd2(), () => ({ since: "1.4.0", parsers: ["scss"], vscodeLanguageIds: ["scss"] }))], i2 = { postcss: s2 };
        r2.exports = { languages: u2, options: a2, printers: i2, parsers: n2 };
      } }), Ud2 = Z2({ "src/language-handlebars/loc.js"(e25, r2) {
        ne2();
        function t2(a2) {
          return a2.loc.start.offset;
        }
        function s2(a2) {
          return a2.loc.end.offset;
        }
        r2.exports = { locStart: t2, locEnd: s2 };
      } }), Jd2 = Z2({ "src/language-handlebars/clean.js"(e25, r2) {
        ne2();
        function t2(s2, a2) {
          if (s2.type === "TextNode") {
            let n2 = s2.chars.trim();
            if (!n2)
              return null;
            a2.chars = n2.replace(/[\t\n\f\r ]+/g, " ");
          }
          s2.type === "AttrNode" && s2.name.toLowerCase() === "class" && delete a2.value;
        }
        t2.ignoredProperties = new Set(["loc", "selfClosing"]), r2.exports = t2;
      } }), zd2 = Z2({ "vendors/html-void-elements.json"(e25, r2) {
        r2.exports = { htmlVoidElements: ["area", "base", "basefont", "bgsound", "br", "col", "command", "embed", "frame", "hr", "image", "img", "input", "isindex", "keygen", "link", "menuitem", "meta", "nextid", "param", "source", "track", "wbr"] };
      } }), Xd2 = Z2({ "src/language-handlebars/utils.js"(e25, r2) {
        ne2();
        var { htmlVoidElements: t2 } = zd2(), s2 = lt2();
        function a2(A2) {
          let N2 = A2.getValue(), I2 = A2.getParentNode(0);
          return !!(y2(A2, ["ElementNode"]) && s2(I2.children) === N2 || y2(A2, ["Block"]) && s2(I2.body) === N2);
        }
        function n2(A2) {
          return A2.toUpperCase() === A2;
        }
        function u2(A2) {
          return d2(A2, ["ElementNode"]) && typeof A2.tag == "string" && !A2.tag.startsWith(":") && (n2(A2.tag[0]) || A2.tag.includes("."));
        }
        var i2 = new Set(t2);
        function l2(A2) {
          return i2.has(A2.tag) || A2.selfClosing === true || u2(A2) && A2.children.every((N2) => p2(N2));
        }
        function p2(A2) {
          return d2(A2, ["TextNode"]) && !/\S/.test(A2.chars);
        }
        function d2(A2, N2) {
          return A2 && N2.includes(A2.type);
        }
        function y2(A2, N2) {
          let I2 = A2.getParentNode(0);
          return d2(I2, N2);
        }
        function g2(A2, N2) {
          let I2 = E2(A2);
          return d2(I2, N2);
        }
        function c2(A2, N2) {
          let I2 = _2(A2);
          return d2(I2, N2);
        }
        function D2(A2, N2) {
          var I2, P2, H2, f2;
          let b2 = A2.getValue(), m2 = (I2 = A2.getParentNode(0)) !== null && I2 !== void 0 ? I2 : {}, v2 = (P2 = (H2 = (f2 = m2.children) !== null && f2 !== void 0 ? f2 : m2.body) !== null && H2 !== void 0 ? H2 : m2.parts) !== null && P2 !== void 0 ? P2 : [], o2 = v2.indexOf(b2);
          return o2 !== -1 && v2[o2 + N2];
        }
        function E2(A2) {
          let N2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
          return D2(A2, -N2);
        }
        function _2(A2) {
          return D2(A2, 1);
        }
        function w2(A2) {
          return d2(A2, ["MustacheCommentStatement"]) && typeof A2.value == "string" && A2.value.trim() === "prettier-ignore";
        }
        function F2(A2) {
          let N2 = A2.getValue(), I2 = E2(A2, 2);
          return w2(N2) || w2(I2);
        }
        r2.exports = { getNextNode: _2, getPreviousNode: E2, hasPrettierIgnore: F2, isLastNodeOfSiblings: a2, isNextNodeOfSomeType: c2, isNodeOfSomeType: d2, isParentOfSomeType: y2, isPreviousNodeOfSomeType: g2, isVoid: l2, isWhitespaceNode: p2 };
      } }), Kd2 = Z2({ "src/language-handlebars/printer-glimmer.js"(e25, r2) {
        ne2();
        var { builders: { dedent: t2, fill: s2, group: a2, hardline: n2, ifBreak: u2, indent: i2, join: l2, line: p2, softline: d2 }, utils: { getDocParts: y2, replaceTextEndOfLine: g2 } } = Me2(), { getPreferredQuote: c2, isNonEmptyArray: D2 } = Ue2(), { locStart: E2, locEnd: _2 } = Ud2(), w2 = Jd2(), { getNextNode: F2, getPreviousNode: A2, hasPrettierIgnore: N2, isLastNodeOfSiblings: I2, isNextNodeOfSomeType: P2, isNodeOfSomeType: H2, isParentOfSomeType: f2, isPreviousNodeOfSomeType: b2, isVoid: m2, isWhitespaceNode: v2 } = Xd2(), o2 = 2;
        function h2(G2, oe2, ee2) {
          let re2 = G2.getValue();
          if (!re2)
            return "";
          if (N2(G2))
            return oe2.originalText.slice(E2(re2), _2(re2));
          let be2 = oe2.singleQuote ? "'" : '"';
          switch (re2.type) {
            case "Block":
            case "Program":
            case "Template":
              return a2(G2.map(ee2, "body"));
            case "ElementNode": {
              let ve2 = a2(S2(G2, ee2)), fe2 = oe2.htmlWhitespaceSensitivity === "ignore" && P2(G2, ["ElementNode"]) ? d2 : "";
              if (m2(re2))
                return [ve2, fe2];
              let B2 = ["</", re2.tag, ">"];
              return re2.children.length === 0 ? [ve2, i2(B2), fe2] : oe2.htmlWhitespaceSensitivity === "ignore" ? [ve2, i2(x2(G2, oe2, ee2)), n2, i2(B2), fe2] : [ve2, i2(a2(x2(G2, oe2, ee2))), i2(B2), fe2];
            }
            case "BlockStatement": {
              let ve2 = G2.getParentNode(1);
              return ve2 && ve2.inverse && ve2.inverse.body.length === 1 && ve2.inverse.body[0] === re2 && ve2.inverse.body[0].path.parts[0] === ve2.path.parts[0] ? [se2(G2, ee2, ve2.inverse.body[0].path.parts[0]), de2(G2, ee2, oe2), ie2(G2, ee2, oe2)] : [j2(G2, ee2), a2([de2(G2, ee2, oe2), ie2(G2, ee2, oe2), Q2(G2, ee2, oe2)])];
            }
            case "ElementModifierStatement":
              return a2(["{{", Ie2(G2, ee2), "}}"]);
            case "MustacheStatement":
              return a2([k2(re2), Ie2(G2, ee2), M2(re2)]);
            case "SubExpression":
              return a2(["(", Oe2(G2, ee2), d2, ")"]);
            case "AttrNode": {
              let ve2 = re2.value.type === "TextNode";
              if (ve2 && re2.value.chars === "" && E2(re2.value) === _2(re2.value))
                return re2.name;
              let B2 = ve2 ? c2(re2.value.chars, be2).quote : re2.value.type === "ConcatStatement" ? c2(re2.value.parts.filter((te2) => te2.type === "TextNode").map((te2) => te2.chars).join(""), be2).quote : "", $2 = ee2("value");
              return [re2.name, "=", B2, re2.name === "class" && B2 ? a2(i2($2)) : $2, B2];
            }
            case "ConcatStatement":
              return G2.map(ee2, "parts");
            case "Hash":
              return l2(p2, G2.map(ee2, "pairs"));
            case "HashPair":
              return [re2.key, "=", ee2("value")];
            case "TextNode": {
              let ve2 = re2.chars.replace(/{{/g, "\\{{"), fe2 = ue2(G2);
              if (fe2) {
                if (fe2 === "class") {
                  let Ye2 = ve2.trim().split(/\s+/).join(" "), Se2 = false, ke2 = false;
                  return f2(G2, ["ConcatStatement"]) && (b2(G2, ["MustacheStatement"]) && /^\s/.test(ve2) && (Se2 = true), P2(G2, ["MustacheStatement"]) && /\s$/.test(ve2) && Ye2 !== "" && (ke2 = true)), [Se2 ? p2 : "", Ye2, ke2 ? p2 : ""];
                }
                return g2(ve2);
              }
              let $2 = /^[\t\n\f\r ]*$/.test(ve2), te2 = !A2(G2), ye2 = !F2(G2);
              if (oe2.htmlWhitespaceSensitivity !== "ignore") {
                let Ye2 = /^[\t\n\f\r ]*/, Se2 = /[\t\n\f\r ]*$/, ke2 = ye2 && f2(G2, ["Template"]), je2 = te2 && f2(G2, ["Template"]);
                if ($2) {
                  if (je2 || ke2)
                    return "";
                  let ae2 = [p2], nt2 = J2(ve2);
                  return nt2 && (ae2 = pe2(nt2)), I2(G2) && (ae2 = ae2.map((tt2) => t2(tt2))), ae2;
                }
                let [Je2] = ve2.match(Ye2), [Be2] = ve2.match(Se2), qe2 = [];
                if (Je2) {
                  qe2 = [p2];
                  let ae2 = J2(Je2);
                  ae2 && (qe2 = pe2(ae2)), ve2 = ve2.replace(Ye2, "");
                }
                let Re2 = [];
                if (Be2) {
                  if (!ke2) {
                    Re2 = [p2];
                    let ae2 = J2(Be2);
                    ae2 && (Re2 = pe2(ae2)), I2(G2) && (Re2 = Re2.map((nt2) => t2(nt2)));
                  }
                  ve2 = ve2.replace(Se2, "");
                }
                return [...qe2, s2(Ee2(ve2)), ...Re2];
              }
              let Fe2 = J2(ve2), Ne2 = le2(ve2), he2 = ge2(ve2);
              if ((te2 || ye2) && $2 && f2(G2, ["Block", "ElementNode", "Template"]))
                return "";
              $2 && Fe2 ? (Ne2 = Math.min(Fe2, o2), he2 = 0) : (P2(G2, ["BlockStatement", "ElementNode"]) && (he2 = Math.max(he2, 1)), b2(G2, ["BlockStatement", "ElementNode"]) && (Ne2 = Math.max(Ne2, 1)));
              let ze2 = "", Te2 = "";
              return he2 === 0 && P2(G2, ["MustacheStatement"]) && (Te2 = " "), Ne2 === 0 && b2(G2, ["MustacheStatement"]) && (ze2 = " "), te2 && (Ne2 = 0, ze2 = ""), ye2 && (he2 = 0, Te2 = ""), ve2 = ve2.replace(/^[\t\n\f\r ]+/g, ze2).replace(/[\t\n\f\r ]+$/, Te2), [...pe2(Ne2), s2(Ee2(ve2)), ...pe2(he2)];
            }
            case "MustacheCommentStatement": {
              let ve2 = E2(re2), fe2 = _2(re2), B2 = oe2.originalText.charAt(ve2 + 2) === "~", $2 = oe2.originalText.charAt(fe2 - 3) === "~", te2 = re2.value.includes("}}") ? "--" : "";
              return ["{{", B2 ? "~" : "", "!", te2, re2.value, te2, $2 ? "~" : "", "}}"];
            }
            case "PathExpression":
              return re2.original;
            case "BooleanLiteral":
              return String(re2.value);
            case "CommentStatement":
              return ["<!--", re2.value, "-->"];
            case "StringLiteral": {
              if (Ce2(G2)) {
                let ve2 = oe2.singleQuote ? '"' : "'";
                return Ae2(re2.value, ve2);
              }
              return Ae2(re2.value, be2);
            }
            case "NumberLiteral":
              return String(re2.value);
            case "UndefinedLiteral":
              return "undefined";
            case "NullLiteral":
              return "null";
            default:
              throw new Error("unknown glimmer type: " + JSON.stringify(re2.type));
          }
        }
        function C2(G2, oe2) {
          return E2(G2) - E2(oe2);
        }
        function S2(G2, oe2) {
          let ee2 = G2.getValue(), re2 = ["attributes", "modifiers", "comments"].filter((ve2) => D2(ee2[ve2])), be2 = re2.flatMap((ve2) => ee2[ve2]).sort(C2);
          for (let ve2 of re2)
            G2.each((fe2) => {
              let B2 = be2.indexOf(fe2.getValue());
              be2.splice(B2, 1, [p2, oe2()]);
            }, ve2);
          return D2(ee2.blockParams) && be2.push(p2, De2(ee2)), ["<", ee2.tag, i2(be2), T2(ee2)];
        }
        function x2(G2, oe2, ee2) {
          let be2 = G2.getValue().children.every((ve2) => v2(ve2));
          return oe2.htmlWhitespaceSensitivity === "ignore" && be2 ? "" : G2.map((ve2, fe2) => {
            let B2 = ee2();
            return fe2 === 0 && oe2.htmlWhitespaceSensitivity === "ignore" ? [d2, B2] : B2;
          }, "children");
        }
        function T2(G2) {
          return m2(G2) ? u2([d2, "/>"], [" />", d2]) : u2([d2, ">"], ">");
        }
        function k2(G2) {
          let oe2 = G2.escaped === false ? "{{{" : "{{", ee2 = G2.strip && G2.strip.open ? "~" : "";
          return [oe2, ee2];
        }
        function M2(G2) {
          let oe2 = G2.escaped === false ? "}}}" : "}}";
          return [G2.strip && G2.strip.close ? "~" : "", oe2];
        }
        function R2(G2) {
          let oe2 = k2(G2), ee2 = G2.openStrip.open ? "~" : "";
          return [oe2, ee2, "#"];
        }
        function q2(G2) {
          let oe2 = M2(G2);
          return [G2.openStrip.close ? "~" : "", oe2];
        }
        function U2(G2) {
          let oe2 = k2(G2), ee2 = G2.closeStrip.open ? "~" : "";
          return [oe2, ee2, "/"];
        }
        function L2(G2) {
          let oe2 = M2(G2);
          return [G2.closeStrip.close ? "~" : "", oe2];
        }
        function Y2(G2) {
          let oe2 = k2(G2), ee2 = G2.inverseStrip.open ? "~" : "";
          return [oe2, ee2];
        }
        function V2(G2) {
          let oe2 = M2(G2);
          return [G2.inverseStrip.close ? "~" : "", oe2];
        }
        function j2(G2, oe2) {
          let ee2 = G2.getValue(), re2 = R2(ee2), be2 = q2(ee2), ve2 = [we2(G2, oe2)], fe2 = _e2(G2, oe2);
          if (fe2 && ve2.push(p2, fe2), D2(ee2.program.blockParams)) {
            let B2 = De2(ee2.program);
            ve2.push(p2, B2);
          }
          return a2([re2, i2(ve2), d2, be2]);
        }
        function K2(G2, oe2) {
          return [oe2.htmlWhitespaceSensitivity === "ignore" ? n2 : "", Y2(G2), "else", V2(G2)];
        }
        function se2(G2, oe2, ee2) {
          let re2 = G2.getValue(), be2 = [];
          D2(re2.program.blockParams) && (be2 = [p2, De2(re2.program)]);
          let ve2 = G2.getParentNode(1);
          return a2([Y2(ve2), i2(a2([a2(["else", p2, ee2]), p2, _e2(G2, oe2)])), i2(be2), d2, V2(ve2)]);
        }
        function Q2(G2, oe2, ee2) {
          let re2 = G2.getValue();
          return ee2.htmlWhitespaceSensitivity === "ignore" ? [ce2(re2) ? d2 : n2, U2(re2), oe2("path"), L2(re2)] : [U2(re2), oe2("path"), L2(re2)];
        }
        function ce2(G2) {
          return H2(G2, ["BlockStatement"]) && G2.program.body.every((oe2) => v2(oe2));
        }
        function W2(G2) {
          return X2(G2) && G2.inverse.body.length === 1 && H2(G2.inverse.body[0], ["BlockStatement"]) && G2.inverse.body[0].path.parts[0] === G2.path.parts[0];
        }
        function X2(G2) {
          return H2(G2, ["BlockStatement"]) && G2.inverse;
        }
        function de2(G2, oe2, ee2) {
          let re2 = G2.getValue();
          if (ce2(re2))
            return "";
          let be2 = oe2("program");
          return ee2.htmlWhitespaceSensitivity === "ignore" ? i2([n2, be2]) : i2(be2);
        }
        function ie2(G2, oe2, ee2) {
          let re2 = G2.getValue(), be2 = oe2("inverse"), ve2 = ee2.htmlWhitespaceSensitivity === "ignore" ? [n2, be2] : be2;
          return W2(re2) ? ve2 : X2(re2) ? [K2(re2, ee2), i2(ve2)] : "";
        }
        function Ee2(G2) {
          return y2(l2(p2, z2(G2)));
        }
        function z2(G2) {
          return G2.split(/[\t\n\f\r ]+/);
        }
        function ue2(G2) {
          for (let oe2 = 0; oe2 < 2; oe2++) {
            let ee2 = G2.getParentNode(oe2);
            if (ee2 && ee2.type === "AttrNode")
              return ee2.name.toLowerCase();
          }
        }
        function J2(G2) {
          return G2 = typeof G2 == "string" ? G2 : "", G2.split(`
`).length - 1;
        }
        function le2(G2) {
          G2 = typeof G2 == "string" ? G2 : "";
          let oe2 = (G2.match(/^([^\S\n\r]*[\n\r])+/g) || [])[0] || "";
          return J2(oe2);
        }
        function ge2(G2) {
          G2 = typeof G2 == "string" ? G2 : "";
          let oe2 = (G2.match(/([\n\r][^\S\n\r]*)+$/g) || [])[0] || "";
          return J2(oe2);
        }
        function pe2() {
          let G2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          return Array.from({ length: Math.min(G2, o2) }).fill(n2);
        }
        function Ae2(G2, oe2) {
          let { quote: ee2, regex: re2 } = c2(G2, oe2);
          return [ee2, G2.replace(re2, `\\${ee2}`), ee2];
        }
        function Ce2(G2) {
          let oe2 = 0, ee2 = G2.getParentNode(oe2);
          for (; ee2 && H2(ee2, ["SubExpression"]); )
            oe2++, ee2 = G2.getParentNode(oe2);
          return !!(ee2 && H2(G2.getParentNode(oe2 + 1), ["ConcatStatement"]) && H2(G2.getParentNode(oe2 + 2), ["AttrNode"]));
        }
        function Oe2(G2, oe2) {
          let ee2 = we2(G2, oe2), re2 = _e2(G2, oe2);
          return re2 ? i2([ee2, p2, a2(re2)]) : ee2;
        }
        function Ie2(G2, oe2) {
          let ee2 = we2(G2, oe2), re2 = _e2(G2, oe2);
          return re2 ? [i2([ee2, p2, re2]), d2] : ee2;
        }
        function we2(G2, oe2) {
          return oe2("path");
        }
        function _e2(G2, oe2) {
          let ee2 = G2.getValue(), re2 = [];
          if (ee2.params.length > 0) {
            let be2 = G2.map(oe2, "params");
            re2.push(...be2);
          }
          if (ee2.hash && ee2.hash.pairs.length > 0) {
            let be2 = oe2("hash");
            re2.push(be2);
          }
          return re2.length === 0 ? "" : l2(p2, re2);
        }
        function De2(G2) {
          return ["as |", G2.blockParams.join(" "), "|"];
        }
        r2.exports = { print: h2, massageAstNode: w2 };
      } }), Yd2 = Z2({ "src/language-handlebars/parsers.js"() {
        ne2();
      } }), Qd2 = Z2({ "node_modules/linguist-languages/data/Handlebars.json"(e25, r2) {
        r2.exports = { name: "Handlebars", type: "markup", color: "#f7931e", aliases: ["hbs", "htmlbars"], extensions: [".handlebars", ".hbs"], tmScope: "text.html.handlebars", aceMode: "handlebars", languageId: 155 };
      } }), Zd2 = Z2({ "src/language-handlebars/index.js"(e25, r2) {
        ne2();
        var t2 = _t2(), s2 = Kd2(), a2 = Yd2(), n2 = [t2(Qd2(), () => ({ since: "2.3.0", parsers: ["glimmer"], vscodeLanguageIds: ["handlebars"] }))], u2 = { glimmer: s2 };
        r2.exports = { languages: n2, printers: u2, parsers: a2 };
      } }), eg2 = Z2({ "src/language-graphql/pragma.js"(e25, r2) {
        ne2();
        function t2(a2) {
          return /^\s*#[^\S\n]*@(?:format|prettier)\s*(?:\n|$)/.test(a2);
        }
        function s2(a2) {
          return `# @format

` + a2;
        }
        r2.exports = { hasPragma: t2, insertPragma: s2 };
      } }), tg2 = Z2({ "src/language-graphql/loc.js"(e25, r2) {
        ne2();
        function t2(a2) {
          return typeof a2.start == "number" ? a2.start : a2.loc && a2.loc.start;
        }
        function s2(a2) {
          return typeof a2.end == "number" ? a2.end : a2.loc && a2.loc.end;
        }
        r2.exports = { locStart: t2, locEnd: s2 };
      } }), rg2 = Z2({ "src/language-graphql/printer-graphql.js"(e25, r2) {
        ne2();
        var { builders: { join: t2, hardline: s2, line: a2, softline: n2, group: u2, indent: i2, ifBreak: l2 } } = Me2(), { isNextLineEmpty: p2, isNonEmptyArray: d2 } = Ue2(), { insertPragma: y2 } = eg2(), { locStart: g2, locEnd: c2 } = tg2();
        function D2(P2, H2, f2) {
          let b2 = P2.getValue();
          if (!b2)
            return "";
          if (typeof b2 == "string")
            return b2;
          switch (b2.kind) {
            case "Document": {
              let m2 = [];
              return P2.each((v2, o2, h2) => {
                m2.push(f2()), o2 !== h2.length - 1 && (m2.push(s2), p2(H2.originalText, v2.getValue(), c2) && m2.push(s2));
              }, "definitions"), [...m2, s2];
            }
            case "OperationDefinition": {
              let m2 = H2.originalText[g2(b2)] !== "{", v2 = Boolean(b2.name);
              return [m2 ? b2.operation : "", m2 && v2 ? [" ", f2("name")] : "", m2 && !v2 && d2(b2.variableDefinitions) ? " " : "", d2(b2.variableDefinitions) ? u2(["(", i2([n2, t2([l2("", ", "), n2], P2.map(f2, "variableDefinitions"))]), n2, ")"]) : "", E2(P2, f2, b2), b2.selectionSet ? !m2 && !v2 ? "" : " " : "", f2("selectionSet")];
            }
            case "FragmentDefinition":
              return ["fragment ", f2("name"), d2(b2.variableDefinitions) ? u2(["(", i2([n2, t2([l2("", ", "), n2], P2.map(f2, "variableDefinitions"))]), n2, ")"]) : "", " on ", f2("typeCondition"), E2(P2, f2, b2), " ", f2("selectionSet")];
            case "SelectionSet":
              return ["{", i2([s2, t2(s2, _2(P2, H2, f2, "selections"))]), s2, "}"];
            case "Field":
              return u2([b2.alias ? [f2("alias"), ": "] : "", f2("name"), b2.arguments.length > 0 ? u2(["(", i2([n2, t2([l2("", ", "), n2], _2(P2, H2, f2, "arguments"))]), n2, ")"]) : "", E2(P2, f2, b2), b2.selectionSet ? " " : "", f2("selectionSet")]);
            case "Name":
              return b2.value;
            case "StringValue": {
              if (b2.block) {
                let m2 = b2.value.replace(/"""/g, "\\$&").split(`
`);
                return m2.length === 1 && (m2[0] = m2[0].trim()), m2.every((v2) => v2 === "") && (m2.length = 0), t2(s2, ['"""', ...m2, '"""']);
              }
              return ['"', b2.value.replace(/["\\]/g, "\\$&").replace(/\n/g, "\\n"), '"'];
            }
            case "IntValue":
            case "FloatValue":
            case "EnumValue":
              return b2.value;
            case "BooleanValue":
              return b2.value ? "true" : "false";
            case "NullValue":
              return "null";
            case "Variable":
              return ["$", f2("name")];
            case "ListValue":
              return u2(["[", i2([n2, t2([l2("", ", "), n2], P2.map(f2, "values"))]), n2, "]"]);
            case "ObjectValue":
              return u2(["{", H2.bracketSpacing && b2.fields.length > 0 ? " " : "", i2([n2, t2([l2("", ", "), n2], P2.map(f2, "fields"))]), n2, l2("", H2.bracketSpacing && b2.fields.length > 0 ? " " : ""), "}"]);
            case "ObjectField":
            case "Argument":
              return [f2("name"), ": ", f2("value")];
            case "Directive":
              return ["@", f2("name"), b2.arguments.length > 0 ? u2(["(", i2([n2, t2([l2("", ", "), n2], _2(P2, H2, f2, "arguments"))]), n2, ")"]) : ""];
            case "NamedType":
              return f2("name");
            case "VariableDefinition":
              return [f2("variable"), ": ", f2("type"), b2.defaultValue ? [" = ", f2("defaultValue")] : "", E2(P2, f2, b2)];
            case "ObjectTypeExtension":
            case "ObjectTypeDefinition":
              return [f2("description"), b2.description ? s2 : "", b2.kind === "ObjectTypeExtension" ? "extend " : "", "type ", f2("name"), b2.interfaces.length > 0 ? [" implements ", ...A2(P2, H2, f2)] : "", E2(P2, f2, b2), b2.fields.length > 0 ? [" {", i2([s2, t2(s2, _2(P2, H2, f2, "fields"))]), s2, "}"] : ""];
            case "FieldDefinition":
              return [f2("description"), b2.description ? s2 : "", f2("name"), b2.arguments.length > 0 ? u2(["(", i2([n2, t2([l2("", ", "), n2], _2(P2, H2, f2, "arguments"))]), n2, ")"]) : "", ": ", f2("type"), E2(P2, f2, b2)];
            case "DirectiveDefinition":
              return [f2("description"), b2.description ? s2 : "", "directive ", "@", f2("name"), b2.arguments.length > 0 ? u2(["(", i2([n2, t2([l2("", ", "), n2], _2(P2, H2, f2, "arguments"))]), n2, ")"]) : "", b2.repeatable ? " repeatable" : "", " on ", t2(" | ", P2.map(f2, "locations"))];
            case "EnumTypeExtension":
            case "EnumTypeDefinition":
              return [f2("description"), b2.description ? s2 : "", b2.kind === "EnumTypeExtension" ? "extend " : "", "enum ", f2("name"), E2(P2, f2, b2), b2.values.length > 0 ? [" {", i2([s2, t2(s2, _2(P2, H2, f2, "values"))]), s2, "}"] : ""];
            case "EnumValueDefinition":
              return [f2("description"), b2.description ? s2 : "", f2("name"), E2(P2, f2, b2)];
            case "InputValueDefinition":
              return [f2("description"), b2.description ? b2.description.block ? s2 : a2 : "", f2("name"), ": ", f2("type"), b2.defaultValue ? [" = ", f2("defaultValue")] : "", E2(P2, f2, b2)];
            case "InputObjectTypeExtension":
            case "InputObjectTypeDefinition":
              return [f2("description"), b2.description ? s2 : "", b2.kind === "InputObjectTypeExtension" ? "extend " : "", "input ", f2("name"), E2(P2, f2, b2), b2.fields.length > 0 ? [" {", i2([s2, t2(s2, _2(P2, H2, f2, "fields"))]), s2, "}"] : ""];
            case "SchemaExtension":
              return ["extend schema", E2(P2, f2, b2), ...b2.operationTypes.length > 0 ? [" {", i2([s2, t2(s2, _2(P2, H2, f2, "operationTypes"))]), s2, "}"] : []];
            case "SchemaDefinition":
              return [f2("description"), b2.description ? s2 : "", "schema", E2(P2, f2, b2), " {", b2.operationTypes.length > 0 ? i2([s2, t2(s2, _2(P2, H2, f2, "operationTypes"))]) : "", s2, "}"];
            case "OperationTypeDefinition":
              return [f2("operation"), ": ", f2("type")];
            case "InterfaceTypeExtension":
            case "InterfaceTypeDefinition":
              return [f2("description"), b2.description ? s2 : "", b2.kind === "InterfaceTypeExtension" ? "extend " : "", "interface ", f2("name"), b2.interfaces.length > 0 ? [" implements ", ...A2(P2, H2, f2)] : "", E2(P2, f2, b2), b2.fields.length > 0 ? [" {", i2([s2, t2(s2, _2(P2, H2, f2, "fields"))]), s2, "}"] : ""];
            case "FragmentSpread":
              return ["...", f2("name"), E2(P2, f2, b2)];
            case "InlineFragment":
              return ["...", b2.typeCondition ? [" on ", f2("typeCondition")] : "", E2(P2, f2, b2), " ", f2("selectionSet")];
            case "UnionTypeExtension":
            case "UnionTypeDefinition":
              return u2([f2("description"), b2.description ? s2 : "", u2([b2.kind === "UnionTypeExtension" ? "extend " : "", "union ", f2("name"), E2(P2, f2, b2), b2.types.length > 0 ? [" =", l2("", " "), i2([l2([a2, "  "]), t2([a2, "| "], P2.map(f2, "types"))])] : ""])]);
            case "ScalarTypeExtension":
            case "ScalarTypeDefinition":
              return [f2("description"), b2.description ? s2 : "", b2.kind === "ScalarTypeExtension" ? "extend " : "", "scalar ", f2("name"), E2(P2, f2, b2)];
            case "NonNullType":
              return [f2("type"), "!"];
            case "ListType":
              return ["[", f2("type"), "]"];
            default:
              throw new Error("unknown graphql type: " + JSON.stringify(b2.kind));
          }
        }
        function E2(P2, H2, f2) {
          if (f2.directives.length === 0)
            return "";
          let b2 = t2(a2, P2.map(H2, "directives"));
          return f2.kind === "FragmentDefinition" || f2.kind === "OperationDefinition" ? u2([a2, b2]) : [" ", u2(i2([n2, b2]))];
        }
        function _2(P2, H2, f2, b2) {
          return P2.map((m2, v2, o2) => {
            let h2 = f2();
            return v2 < o2.length - 1 && p2(H2.originalText, m2.getValue(), c2) ? [h2, s2] : h2;
          }, b2);
        }
        function w2(P2) {
          return P2.kind && P2.kind !== "Comment";
        }
        function F2(P2) {
          let H2 = P2.getValue();
          if (H2.kind === "Comment")
            return "#" + H2.value.trimEnd();
          throw new Error("Not a comment: " + JSON.stringify(H2));
        }
        function A2(P2, H2, f2) {
          let b2 = P2.getNode(), m2 = [], { interfaces: v2 } = b2, o2 = P2.map((h2) => f2(h2), "interfaces");
          for (let h2 = 0; h2 < v2.length; h2++) {
            let C2 = v2[h2];
            m2.push(o2[h2]);
            let S2 = v2[h2 + 1];
            if (S2) {
              let x2 = H2.originalText.slice(C2.loc.end, S2.loc.start), T2 = x2.includes("#"), k2 = x2.replace(/#.*/g, "").trim();
              m2.push(k2 === "," ? "," : " &", T2 ? a2 : " ");
            }
          }
          return m2;
        }
        function N2(P2, H2) {
          P2.kind === "StringValue" && P2.block && !P2.value.includes(`
`) && (H2.value = H2.value.trim());
        }
        N2.ignoredProperties = new Set(["loc", "comments"]);
        function I2(P2) {
          var H2;
          let f2 = P2.getValue();
          return f2 == null || (H2 = f2.comments) === null || H2 === void 0 ? void 0 : H2.some((b2) => b2.value.trim() === "prettier-ignore");
        }
        r2.exports = { print: D2, massageAstNode: N2, hasPrettierIgnore: I2, insertPragma: y2, printComment: F2, canAttachComment: w2 };
      } }), ng2 = Z2({ "src/language-graphql/options.js"(e25, r2) {
        ne2();
        var t2 = Mt2();
        r2.exports = { bracketSpacing: t2.bracketSpacing };
      } }), ug2 = Z2({ "src/language-graphql/parsers.js"() {
        ne2();
      } }), sg2 = Z2({ "node_modules/linguist-languages/data/GraphQL.json"(e25, r2) {
        r2.exports = { name: "GraphQL", type: "data", color: "#e10098", extensions: [".graphql", ".gql", ".graphqls"], tmScope: "source.graphql", aceMode: "text", languageId: 139 };
      } }), ig2 = Z2({ "src/language-graphql/index.js"(e25, r2) {
        ne2();
        var t2 = _t2(), s2 = rg2(), a2 = ng2(), n2 = ug2(), u2 = [t2(sg2(), () => ({ since: "1.5.0", parsers: ["graphql"], vscodeLanguageIds: ["graphql"] }))], i2 = { graphql: s2 };
        r2.exports = { languages: u2, options: a2, printers: i2, parsers: n2 };
      } }), Po2 = Z2({ "node_modules/collapse-white-space/index.js"(e25, r2) {
        ne2(), r2.exports = t2;
        function t2(s2) {
          return String(s2).replace(/\s+/g, " ");
        }
      } }), Io2 = Z2({ "src/language-markdown/loc.js"(e25, r2) {
        ne2();
        function t2(a2) {
          return a2.position.start.offset;
        }
        function s2(a2) {
          return a2.position.end.offset;
        }
        r2.exports = { locStart: t2, locEnd: s2 };
      } }), ag2 = Z2({ "src/language-markdown/constants.evaluate.js"(e25, r2) {
        r2.exports = { cjkPattern: "(?:[\\u02ea-\\u02eb\\u1100-\\u11ff\\u2e80-\\u2e99\\u2e9b-\\u2ef3\\u2f00-\\u2fd5\\u2ff0-\\u303f\\u3041-\\u3096\\u3099-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312f\\u3131-\\u318e\\u3190-\\u3191\\u3196-\\u31ba\\u31c0-\\u31e3\\u31f0-\\u321e\\u322a-\\u3247\\u3260-\\u327e\\u328a-\\u32b0\\u32c0-\\u32cb\\u32d0-\\u3370\\u337b-\\u337f\\u33e0-\\u33fe\\u3400-\\u4db5\\u4e00-\\u9fef\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufe10-\\ufe1f\\ufe30-\\ufe6f\\uff00-\\uffef]|[\\ud840-\\ud868\\ud86a-\\ud86c\\ud86f-\\ud872\\ud874-\\ud879][\\udc00-\\udfff]|\\ud82c[\\udc00-\\udd1e\\udd50-\\udd52\\udd64-\\udd67]|\\ud83c[\\ude00\\ude50-\\ude51]|\\ud869[\\udc00-\\uded6\\udf00-\\udfff]|\\ud86d[\\udc00-\\udf34\\udf40-\\udfff]|\\ud86e[\\udc00-\\udc1d\\udc20-\\udfff]|\\ud873[\\udc00-\\udea1\\udeb0-\\udfff]|\\ud87a[\\udc00-\\udfe0]|\\ud87e[\\udc00-\\ude1d])(?:[\\ufe00-\\ufe0f]|\\udb40[\\udd00-\\uddef])?", kPattern: "[\\u1100-\\u11ff\\u3001-\\u3003\\u3008-\\u3011\\u3013-\\u301f\\u302e-\\u3030\\u3037\\u30fb\\u3131-\\u318e\\u3200-\\u321e\\u3260-\\u327e\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\ufe45-\\ufe46\\uff61-\\uff65\\uffa0-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc]", punctuationPattern: "[\\u0021-\\u002f\\u003a-\\u0040\\u005b-\\u0060\\u007b-\\u007e\\u00a1\\u00a7\\u00ab\\u00b6-\\u00b7\\u00bb\\u00bf\\u037e\\u0387\\u055a-\\u055f\\u0589-\\u058a\\u05be\\u05c0\\u05c3\\u05c6\\u05f3-\\u05f4\\u0609-\\u060a\\u060c-\\u060d\\u061b\\u061e-\\u061f\\u066a-\\u066d\\u06d4\\u0700-\\u070d\\u07f7-\\u07f9\\u0830-\\u083e\\u085e\\u0964-\\u0965\\u0970\\u09fd\\u0a76\\u0af0\\u0c77\\u0c84\\u0df4\\u0e4f\\u0e5a-\\u0e5b\\u0f04-\\u0f12\\u0f14\\u0f3a-\\u0f3d\\u0f85\\u0fd0-\\u0fd4\\u0fd9-\\u0fda\\u104a-\\u104f\\u10fb\\u1360-\\u1368\\u1400\\u166e\\u169b-\\u169c\\u16eb-\\u16ed\\u1735-\\u1736\\u17d4-\\u17d6\\u17d8-\\u17da\\u1800-\\u180a\\u1944-\\u1945\\u1a1e-\\u1a1f\\u1aa0-\\u1aa6\\u1aa8-\\u1aad\\u1b5a-\\u1b60\\u1bfc-\\u1bff\\u1c3b-\\u1c3f\\u1c7e-\\u1c7f\\u1cc0-\\u1cc7\\u1cd3\\u2010-\\u2027\\u2030-\\u2043\\u2045-\\u2051\\u2053-\\u205e\\u207d-\\u207e\\u208d-\\u208e\\u2308-\\u230b\\u2329-\\u232a\\u2768-\\u2775\\u27c5-\\u27c6\\u27e6-\\u27ef\\u2983-\\u2998\\u29d8-\\u29db\\u29fc-\\u29fd\\u2cf9-\\u2cfc\\u2cfe-\\u2cff\\u2d70\\u2e00-\\u2e2e\\u2e30-\\u2e4f\\u3001-\\u3003\\u3008-\\u3011\\u3014-\\u301f\\u3030\\u303d\\u30a0\\u30fb\\ua4fe-\\ua4ff\\ua60d-\\ua60f\\ua673\\ua67e\\ua6f2-\\ua6f7\\ua874-\\ua877\\ua8ce-\\ua8cf\\ua8f8-\\ua8fa\\ua8fc\\ua92e-\\ua92f\\ua95f\\ua9c1-\\ua9cd\\ua9de-\\ua9df\\uaa5c-\\uaa5f\\uaade-\\uaadf\\uaaf0-\\uaaf1\\uabeb\\ufd3e-\\ufd3f\\ufe10-\\ufe19\\ufe30-\\ufe52\\ufe54-\\ufe61\\ufe63\\ufe68\\ufe6a-\\ufe6b\\uff01-\\uff03\\uff05-\\uff0a\\uff0c-\\uff0f\\uff1a-\\uff1b\\uff1f-\\uff20\\uff3b-\\uff3d\\uff3f\\uff5b\\uff5d\\uff5f-\\uff65]|\\ud800[\\udd00-\\udd02\\udf9f\\udfd0]|\\ud801[\\udd6f]|\\ud802[\\udc57\\udd1f\\udd3f\\ude50-\\ude58\\ude7f\\udef0-\\udef6\\udf39-\\udf3f\\udf99-\\udf9c]|\\ud803[\\udf55-\\udf59]|\\ud804[\\udc47-\\udc4d\\udcbb-\\udcbc\\udcbe-\\udcc1\\udd40-\\udd43\\udd74-\\udd75\\uddc5-\\uddc8\\uddcd\\udddb\\udddd-\\udddf\\ude38-\\ude3d\\udea9]|\\ud805[\\udc4b-\\udc4f\\udc5b\\udc5d\\udcc6\\uddc1-\\uddd7\\ude41-\\ude43\\ude60-\\ude6c\\udf3c-\\udf3e]|\\ud806[\\udc3b\\udde2\\ude3f-\\ude46\\ude9a-\\ude9c\\ude9e-\\udea2]|\\ud807[\\udc41-\\udc45\\udc70-\\udc71\\udef7-\\udef8\\udfff]|\\ud809[\\udc70-\\udc74]|\\ud81a[\\ude6e-\\ude6f\\udef5\\udf37-\\udf3b\\udf44]|\\ud81b[\\ude97-\\ude9a\\udfe2]|\\ud82f[\\udc9f]|\\ud836[\\ude87-\\ude8b]|\\ud83a[\\udd5e-\\udd5f]" };
      } }), iu2 = Z2({ "src/language-markdown/utils.js"(e25, r2) {
        ne2();
        var { getLast: t2 } = Ue2(), { locStart: s2, locEnd: a2 } = Io2(), { cjkPattern: n2, kPattern: u2, punctuationPattern: i2 } = ag2(), l2 = ["liquidNode", "inlineCode", "emphasis", "esComment", "strong", "delete", "wikiLink", "link", "linkReference", "image", "imageReference", "footnote", "footnoteReference", "sentence", "whitespace", "word", "break", "inlineMath"], p2 = [...l2, "tableCell", "paragraph", "heading"], d2 = new RegExp(u2), y2 = new RegExp(i2);
        function g2(F2, A2) {
          let N2 = "non-cjk", I2 = "cj-letter", P2 = "k-letter", H2 = "cjk-punctuation", f2 = [], b2 = (A2.proseWrap === "preserve" ? F2 : F2.replace(new RegExp(`(${n2})
(${n2})`, "g"), "$1$2")).split(/([\t\n ]+)/);
          for (let [v2, o2] of b2.entries()) {
            if (v2 % 2 === 1) {
              f2.push({ type: "whitespace", value: /\n/.test(o2) ? `
` : " " });
              continue;
            }
            if ((v2 === 0 || v2 === b2.length - 1) && o2 === "")
              continue;
            let h2 = o2.split(new RegExp(`(${n2})`));
            for (let [C2, S2] of h2.entries())
              if (!((C2 === 0 || C2 === h2.length - 1) && S2 === "")) {
                if (C2 % 2 === 0) {
                  S2 !== "" && m2({ type: "word", value: S2, kind: N2, hasLeadingPunctuation: y2.test(S2[0]), hasTrailingPunctuation: y2.test(t2(S2)) });
                  continue;
                }
                m2(y2.test(S2) ? { type: "word", value: S2, kind: H2, hasLeadingPunctuation: true, hasTrailingPunctuation: true } : { type: "word", value: S2, kind: d2.test(S2) ? P2 : I2, hasLeadingPunctuation: false, hasTrailingPunctuation: false });
              }
          }
          return f2;
          function m2(v2) {
            let o2 = t2(f2);
            o2 && o2.type === "word" && (o2.kind === N2 && v2.kind === I2 && !o2.hasTrailingPunctuation || o2.kind === I2 && v2.kind === N2 && !v2.hasLeadingPunctuation ? f2.push({ type: "whitespace", value: " " }) : !h2(N2, H2) && ![o2.value, v2.value].some((C2) => /\u3000/.test(C2)) && f2.push({ type: "whitespace", value: "" })), f2.push(v2);
            function h2(C2, S2) {
              return o2.kind === C2 && v2.kind === S2 || o2.kind === S2 && v2.kind === C2;
            }
          }
        }
        function c2(F2, A2) {
          let [, N2, I2, P2] = A2.slice(F2.position.start.offset, F2.position.end.offset).match(/^\s*(\d+)(\.|\))(\s*)/);
          return { numberText: N2, marker: I2, leadingSpaces: P2 };
        }
        function D2(F2, A2) {
          if (!F2.ordered || F2.children.length < 2)
            return false;
          let N2 = Number(c2(F2.children[0], A2.originalText).numberText), I2 = Number(c2(F2.children[1], A2.originalText).numberText);
          if (N2 === 0 && F2.children.length > 2) {
            let P2 = Number(c2(F2.children[2], A2.originalText).numberText);
            return I2 === 1 && P2 === 1;
          }
          return I2 === 1;
        }
        function E2(F2, A2) {
          let { value: N2 } = F2;
          return F2.position.end.offset === A2.length && N2.endsWith(`
`) && A2.endsWith(`
`) ? N2.slice(0, -1) : N2;
        }
        function _2(F2, A2) {
          return function N2(I2, P2, H2) {
            let f2 = Object.assign({}, A2(I2, P2, H2));
            return f2.children && (f2.children = f2.children.map((b2, m2) => N2(b2, m2, [f2, ...H2]))), f2;
          }(F2, null, []);
        }
        function w2(F2) {
          if ((F2 == null ? void 0 : F2.type) !== "link" || F2.children.length !== 1)
            return false;
          let [A2] = F2.children;
          return s2(F2) === s2(A2) && a2(F2) === a2(A2);
        }
        r2.exports = { mapAst: _2, splitText: g2, punctuationPattern: i2, getFencedCodeBlockValue: E2, getOrderedListItemInfo: c2, hasGitDiffFriendlyOrderedList: D2, INLINE_NODE_TYPES: l2, INLINE_NODE_WRAPPER_TYPES: p2, isAutolink: w2 };
      } }), og2 = Z2({ "src/language-markdown/embed.js"(e25, r2) {
        ne2();
        var { inferParserByLanguage: t2, getMaxContinuousCount: s2 } = Ue2(), { builders: { hardline: a2, markAsRoot: n2 }, utils: { replaceEndOfLine: u2 } } = Me2(), i2 = su2(), { getFencedCodeBlockValue: l2 } = iu2();
        function p2(d2, y2, g2, c2) {
          let D2 = d2.getValue();
          if (D2.type === "code" && D2.lang !== null) {
            let E2 = t2(D2.lang, c2);
            if (E2) {
              let _2 = c2.__inJsTemplate ? "~" : "`", w2 = _2.repeat(Math.max(3, s2(D2.value, _2) + 1)), F2 = { parser: E2 };
              D2.lang === "tsx" && (F2.filepath = "dummy.tsx");
              let A2 = g2(l2(D2, c2.originalText), F2, { stripTrailingHardline: true });
              return n2([w2, D2.lang, D2.meta ? " " + D2.meta : "", a2, u2(A2), a2, w2]);
            }
          }
          switch (D2.type) {
            case "front-matter":
              return i2(D2, g2);
            case "importExport":
              return [g2(D2.value, { parser: "babel" }, { stripTrailingHardline: true }), a2];
            case "jsx":
              return g2(`<$>${D2.value}</$>`, { parser: "__js_expression", rootMarker: "mdx" }, { stripTrailingHardline: true });
          }
          return null;
        }
        r2.exports = p2;
      } }), ko = Z2({ "src/language-markdown/pragma.js"(e25, r2) {
        ne2();
        var t2 = _o2(), s2 = ["format", "prettier"];
        function a2(n2) {
          let u2 = `@(${s2.join("|")})`, i2 = new RegExp([`<!--\\s*${u2}\\s*-->`, `{\\s*\\/\\*\\s*${u2}\\s*\\*\\/\\s*}`, `<!--.*\r?
[\\s\\S]*(^|
)[^\\S
]*${u2}[^\\S
]*($|
)[\\s\\S]*
.*-->`].join("|"), "m"), l2 = n2.match(i2);
          return (l2 == null ? void 0 : l2.index) === 0;
        }
        r2.exports = { startWithPragma: a2, hasPragma: (n2) => a2(t2(n2).content.trimStart()), insertPragma: (n2) => {
          let u2 = t2(n2), i2 = `<!-- @${s2[0]} -->`;
          return u2.frontMatter ? `${u2.frontMatter.raw}

${i2}

${u2.content}` : `${i2}

${u2.content}`;
        } };
      } }), lg2 = Z2({ "src/language-markdown/print-preprocess.js"(e25, r2) {
        ne2();
        var t2 = lt2(), { getOrderedListItemInfo: s2, mapAst: a2, splitText: n2 } = iu2(), u2 = /^.$/su;
        function i2(w2, F2) {
          return w2 = d2(w2, F2), w2 = c2(w2), w2 = p2(w2, F2), w2 = E2(w2, F2), w2 = _2(w2, F2), w2 = D2(w2, F2), w2 = l2(w2), w2 = y2(w2), w2;
        }
        function l2(w2) {
          return a2(w2, (F2) => F2.type !== "import" && F2.type !== "export" ? F2 : Object.assign(Object.assign({}, F2), {}, { type: "importExport" }));
        }
        function p2(w2, F2) {
          return a2(w2, (A2) => A2.type !== "inlineCode" || F2.proseWrap === "preserve" ? A2 : Object.assign(Object.assign({}, A2), {}, { value: A2.value.replace(/\s+/g, " ") }));
        }
        function d2(w2, F2) {
          return a2(w2, (A2) => A2.type !== "text" || A2.value === "*" || A2.value === "_" || !u2.test(A2.value) || A2.position.end.offset - A2.position.start.offset === A2.value.length ? A2 : Object.assign(Object.assign({}, A2), {}, { value: F2.originalText.slice(A2.position.start.offset, A2.position.end.offset) }));
        }
        function y2(w2) {
          return g2(w2, (F2, A2) => F2.type === "importExport" && A2.type === "importExport", (F2, A2) => ({ type: "importExport", value: F2.value + `

` + A2.value, position: { start: F2.position.start, end: A2.position.end } }));
        }
        function g2(w2, F2, A2) {
          return a2(w2, (N2) => {
            if (!N2.children)
              return N2;
            let I2 = N2.children.reduce((P2, H2) => {
              let f2 = t2(P2);
              return f2 && F2(f2, H2) ? P2.splice(-1, 1, A2(f2, H2)) : P2.push(H2), P2;
            }, []);
            return Object.assign(Object.assign({}, N2), {}, { children: I2 });
          });
        }
        function c2(w2) {
          return g2(w2, (F2, A2) => F2.type === "text" && A2.type === "text", (F2, A2) => ({ type: "text", value: F2.value + A2.value, position: { start: F2.position.start, end: A2.position.end } }));
        }
        function D2(w2, F2) {
          return a2(w2, (A2, N2, I2) => {
            let [P2] = I2;
            if (A2.type !== "text")
              return A2;
            let { value: H2 } = A2;
            return P2.type === "paragraph" && (N2 === 0 && (H2 = H2.trimStart()), N2 === P2.children.length - 1 && (H2 = H2.trimEnd())), { type: "sentence", position: A2.position, children: n2(H2, F2) };
          });
        }
        function E2(w2, F2) {
          return a2(w2, (A2, N2, I2) => {
            if (A2.type === "code") {
              let P2 = /^\n?(?: {4,}|\t)/.test(F2.originalText.slice(A2.position.start.offset, A2.position.end.offset));
              if (A2.isIndented = P2, P2)
                for (let H2 = 0; H2 < I2.length; H2++) {
                  let f2 = I2[H2];
                  if (f2.hasIndentedCodeblock)
                    break;
                  f2.type === "list" && (f2.hasIndentedCodeblock = true);
                }
            }
            return A2;
          });
        }
        function _2(w2, F2) {
          return a2(w2, (I2, P2, H2) => {
            if (I2.type === "list" && I2.children.length > 0) {
              for (let f2 = 0; f2 < H2.length; f2++) {
                let b2 = H2[f2];
                if (b2.type === "list" && !b2.isAligned)
                  return I2.isAligned = false, I2;
              }
              I2.isAligned = N2(I2);
            }
            return I2;
          });
          function A2(I2) {
            return I2.children.length === 0 ? -1 : I2.children[0].position.start.column - 1;
          }
          function N2(I2) {
            if (!I2.ordered)
              return true;
            let [P2, H2] = I2.children;
            if (s2(P2, F2.originalText).leadingSpaces.length > 1)
              return true;
            let b2 = A2(P2);
            if (b2 === -1)
              return false;
            if (I2.children.length === 1)
              return b2 % F2.tabWidth === 0;
            let m2 = A2(H2);
            return b2 !== m2 ? false : b2 % F2.tabWidth === 0 ? true : s2(H2, F2.originalText).leadingSpaces.length > 1;
          }
        }
        r2.exports = i2;
      } }), cg2 = Z2({ "src/language-markdown/clean.js"(e25, r2) {
        ne2();
        var t2 = Po2(), { isFrontMatterNode: s2 } = Ue2(), { startWithPragma: a2 } = ko(), n2 = new Set(["position", "raw"]);
        function u2(i2, l2, p2) {
          if ((i2.type === "front-matter" || i2.type === "code" || i2.type === "yaml" || i2.type === "import" || i2.type === "export" || i2.type === "jsx") && delete l2.value, i2.type === "list" && delete l2.isAligned, (i2.type === "list" || i2.type === "listItem") && (delete l2.spread, delete l2.loose), i2.type === "text" || (i2.type === "inlineCode" && (l2.value = i2.value.replace(/[\t\n ]+/g, " ")), i2.type === "wikiLink" && (l2.value = i2.value.trim().replace(/[\t\n]+/g, " ")), (i2.type === "definition" || i2.type === "linkReference" || i2.type === "imageReference") && (l2.label = t2(i2.label)), (i2.type === "definition" || i2.type === "link" || i2.type === "image") && i2.title && (l2.title = i2.title.replace(/\\(["')])/g, "$1")), p2 && p2.type === "root" && p2.children.length > 0 && (p2.children[0] === i2 || s2(p2.children[0]) && p2.children[1] === i2) && i2.type === "html" && a2(i2.value)))
            return null;
        }
        u2.ignoredProperties = n2, r2.exports = u2;
      } }), pg2 = Z2({ "src/language-markdown/printer-markdown.js"(e25, r2) {
        ne2();
        var t2 = Po2(), { getLast: s2, getMinNotPresentContinuousCount: a2, getMaxContinuousCount: n2, getStringWidth: u2, isNonEmptyArray: i2 } = Ue2(), { builders: { breakParent: l2, join: p2, line: d2, literalline: y2, markAsRoot: g2, hardline: c2, softline: D2, ifBreak: E2, fill: _2, align: w2, indent: F2, group: A2, hardlineWithoutBreakParent: N2 }, utils: { normalizeDoc: I2, replaceTextEndOfLine: P2 }, printer: { printDocToString: H2 } } = Me2(), f2 = og2(), { insertPragma: b2 } = ko(), { locStart: m2, locEnd: v2 } = Io2(), o2 = lg2(), h2 = cg2(), { getFencedCodeBlockValue: C2, hasGitDiffFriendlyOrderedList: S2, splitText: x2, punctuationPattern: T2, INLINE_NODE_TYPES: k2, INLINE_NODE_WRAPPER_TYPES: M2, isAutolink: R2 } = iu2(), q2 = new Set(["importExport"]), U2 = ["heading", "tableCell", "link", "wikiLink"], L2 = new Set(["listItem", "definition", "footnoteDefinition"]);
        function Y2(De2, G2, oe2) {
          let ee2 = De2.getValue();
          if (pe2(De2))
            return x2(G2.originalText.slice(ee2.position.start.offset, ee2.position.end.offset), G2).map((re2) => re2.type === "word" ? re2.value : re2.value === "" ? "" : W2(De2, re2.value, G2));
          switch (ee2.type) {
            case "front-matter":
              return G2.originalText.slice(ee2.position.start.offset, ee2.position.end.offset);
            case "root":
              return ee2.children.length === 0 ? "" : [I2(de2(De2, G2, oe2)), q2.has(z2(ee2).type) ? "" : c2];
            case "paragraph":
              return ie2(De2, G2, oe2, { postprocessor: _2 });
            case "sentence":
              return ie2(De2, G2, oe2);
            case "word": {
              let re2 = ee2.value.replace(/\*/g, "\\$&").replace(new RegExp([`(^|${T2})(_+)`, `(_+)(${T2}|$)`].join("|"), "g"), (fe2, B2, $2, te2, ye2) => ($2 ? `${B2}${$2}` : `${te2}${ye2}`).replace(/_/g, "\\_")), be2 = (fe2, B2, $2) => fe2.type === "sentence" && $2 === 0, ve2 = (fe2, B2, $2) => R2(fe2.children[$2 - 1]);
              return re2 !== ee2.value && (De2.match(void 0, be2, ve2) || De2.match(void 0, be2, (fe2, B2, $2) => fe2.type === "emphasis" && $2 === 0, ve2)) && (re2 = re2.replace(/^(\\?[*_])+/, (fe2) => fe2.replace(/\\/g, ""))), re2;
            }
            case "whitespace": {
              let re2 = De2.getParentNode(), be2 = re2.children.indexOf(ee2), ve2 = re2.children[be2 + 1], fe2 = ve2 && /^>|^(?:[*+-]|#{1,6}|\d+[).])$/.test(ve2.value) ? "never" : G2.proseWrap;
              return W2(De2, ee2.value, { proseWrap: fe2 });
            }
            case "emphasis": {
              let re2;
              if (R2(ee2.children[0]))
                re2 = G2.originalText[ee2.position.start.offset];
              else {
                let be2 = De2.getParentNode(), ve2 = be2.children.indexOf(ee2), fe2 = be2.children[ve2 - 1], B2 = be2.children[ve2 + 1];
                re2 = fe2 && fe2.type === "sentence" && fe2.children.length > 0 && s2(fe2.children).type === "word" && !s2(fe2.children).hasTrailingPunctuation || B2 && B2.type === "sentence" && B2.children.length > 0 && B2.children[0].type === "word" && !B2.children[0].hasLeadingPunctuation || ce2(De2, "emphasis") ? "*" : "_";
              }
              return [re2, ie2(De2, G2, oe2), re2];
            }
            case "strong":
              return ["**", ie2(De2, G2, oe2), "**"];
            case "delete":
              return ["~~", ie2(De2, G2, oe2), "~~"];
            case "inlineCode": {
              let re2 = a2(ee2.value, "`"), be2 = "`".repeat(re2 || 1), ve2 = re2 && !/^\s/.test(ee2.value) ? " " : "";
              return [be2, ve2, ee2.value, ve2, be2];
            }
            case "wikiLink": {
              let re2 = "";
              return G2.proseWrap === "preserve" ? re2 = ee2.value : re2 = ee2.value.replace(/[\t\n]+/g, " "), ["[[", re2, "]]"];
            }
            case "link":
              switch (G2.originalText[ee2.position.start.offset]) {
                case "<": {
                  let re2 = "mailto:";
                  return ["<", ee2.url.startsWith(re2) && G2.originalText.slice(ee2.position.start.offset + 1, ee2.position.start.offset + 1 + re2.length) !== re2 ? ee2.url.slice(re2.length) : ee2.url, ">"];
                }
                case "[":
                  return ["[", ie2(De2, G2, oe2), "](", Ae2(ee2.url, ")"), Ce2(ee2.title, G2), ")"];
                default:
                  return G2.originalText.slice(ee2.position.start.offset, ee2.position.end.offset);
              }
            case "image":
              return ["![", ee2.alt || "", "](", Ae2(ee2.url, ")"), Ce2(ee2.title, G2), ")"];
            case "blockquote":
              return ["> ", w2("> ", ie2(De2, G2, oe2))];
            case "heading":
              return ["#".repeat(ee2.depth) + " ", ie2(De2, G2, oe2)];
            case "code": {
              if (ee2.isIndented) {
                let ve2 = " ".repeat(4);
                return w2(ve2, [ve2, ...P2(ee2.value, c2)]);
              }
              let re2 = G2.__inJsTemplate ? "~" : "`", be2 = re2.repeat(Math.max(3, n2(ee2.value, re2) + 1));
              return [be2, ee2.lang || "", ee2.meta ? " " + ee2.meta : "", c2, ...P2(C2(ee2, G2.originalText), c2), c2, be2];
            }
            case "html": {
              let re2 = De2.getParentNode(), be2 = re2.type === "root" && s2(re2.children) === ee2 ? ee2.value.trimEnd() : ee2.value, ve2 = /^<!--.*-->$/s.test(be2);
              return P2(be2, ve2 ? c2 : g2(y2));
            }
            case "list": {
              let re2 = K2(ee2, De2.getParentNode()), be2 = S2(ee2, G2);
              return ie2(De2, G2, oe2, { processor: (ve2, fe2) => {
                let B2 = te2(), $2 = ve2.getValue();
                if ($2.children.length === 2 && $2.children[1].type === "html" && $2.children[0].position.start.column !== $2.children[1].position.start.column)
                  return [B2, V2(ve2, G2, oe2, B2)];
                return [B2, w2(" ".repeat(B2.length), V2(ve2, G2, oe2, B2))];
                function te2() {
                  let ye2 = ee2.ordered ? (fe2 === 0 ? ee2.start : be2 ? 1 : ee2.start + fe2) + (re2 % 2 === 0 ? ". " : ") ") : re2 % 2 === 0 ? "- " : "* ";
                  return ee2.isAligned || ee2.hasIndentedCodeblock ? j2(ye2, G2) : ye2;
                }
              } });
            }
            case "thematicBreak": {
              let re2 = Q2(De2, "list");
              return re2 === -1 ? "---" : K2(De2.getParentNode(re2), De2.getParentNode(re2 + 1)) % 2 === 0 ? "***" : "---";
            }
            case "linkReference":
              return ["[", ie2(De2, G2, oe2), "]", ee2.referenceType === "full" ? we2(ee2) : ee2.referenceType === "collapsed" ? "[]" : ""];
            case "imageReference":
              switch (ee2.referenceType) {
                case "full":
                  return ["![", ee2.alt || "", "]", we2(ee2)];
                default:
                  return ["![", ee2.alt, "]", ee2.referenceType === "collapsed" ? "[]" : ""];
              }
            case "definition": {
              let re2 = G2.proseWrap === "always" ? d2 : " ";
              return A2([we2(ee2), ":", F2([re2, Ae2(ee2.url), ee2.title === null ? "" : [re2, Ce2(ee2.title, G2, false)]])]);
            }
            case "footnote":
              return ["[^", ie2(De2, G2, oe2), "]"];
            case "footnoteReference":
              return _e2(ee2);
            case "footnoteDefinition": {
              let re2 = De2.getParentNode().children[De2.getName() + 1], be2 = ee2.children.length === 1 && ee2.children[0].type === "paragraph" && (G2.proseWrap === "never" || G2.proseWrap === "preserve" && ee2.children[0].position.start.line === ee2.children[0].position.end.line);
              return [_e2(ee2), ": ", be2 ? ie2(De2, G2, oe2) : A2([w2(" ".repeat(4), ie2(De2, G2, oe2, { processor: (ve2, fe2) => fe2 === 0 ? A2([D2, oe2()]) : oe2() })), re2 && re2.type === "footnoteDefinition" ? D2 : ""])];
            }
            case "table":
              return X2(De2, G2, oe2);
            case "tableCell":
              return ie2(De2, G2, oe2);
            case "break":
              return /\s/.test(G2.originalText[ee2.position.start.offset]) ? ["  ", g2(y2)] : ["\\", c2];
            case "liquidNode":
              return P2(ee2.value, c2);
            case "importExport":
              return [ee2.value, c2];
            case "esComment":
              return ["{/* ", ee2.value, " */}"];
            case "jsx":
              return ee2.value;
            case "math":
              return ["$$", c2, ee2.value ? [...P2(ee2.value, c2), c2] : "", "$$"];
            case "inlineMath":
              return G2.originalText.slice(m2(ee2), v2(ee2));
            case "tableRow":
            case "listItem":
            default:
              throw new Error(`Unknown markdown type ${JSON.stringify(ee2.type)}`);
          }
        }
        function V2(De2, G2, oe2, ee2) {
          let re2 = De2.getValue(), be2 = re2.checked === null ? "" : re2.checked ? "[x] " : "[ ] ";
          return [be2, ie2(De2, G2, oe2, { processor: (ve2, fe2) => {
            if (fe2 === 0 && ve2.getValue().type !== "list")
              return w2(" ".repeat(be2.length), oe2());
            let B2 = " ".repeat(Oe2(G2.tabWidth - ee2.length, 0, 3));
            return [B2, w2(B2, oe2())];
          } })];
        }
        function j2(De2, G2) {
          let oe2 = ee2();
          return De2 + " ".repeat(oe2 >= 4 ? 0 : oe2);
          function ee2() {
            let re2 = De2.length % G2.tabWidth;
            return re2 === 0 ? 0 : G2.tabWidth - re2;
          }
        }
        function K2(De2, G2) {
          return se2(De2, G2, (oe2) => oe2.ordered === De2.ordered);
        }
        function se2(De2, G2, oe2) {
          let ee2 = -1;
          for (let re2 of G2.children)
            if (re2.type === De2.type && oe2(re2) ? ee2++ : ee2 = -1, re2 === De2)
              return ee2;
        }
        function Q2(De2, G2) {
          let oe2 = Array.isArray(G2) ? G2 : [G2], ee2 = -1, re2;
          for (; re2 = De2.getParentNode(++ee2); )
            if (oe2.includes(re2.type))
              return ee2;
          return -1;
        }
        function ce2(De2, G2) {
          let oe2 = Q2(De2, G2);
          return oe2 === -1 ? null : De2.getParentNode(oe2);
        }
        function W2(De2, G2, oe2) {
          if (oe2.proseWrap === "preserve" && G2 === `
`)
            return c2;
          let ee2 = oe2.proseWrap === "always" && !ce2(De2, U2);
          return G2 !== "" ? ee2 ? d2 : " " : ee2 ? D2 : "";
        }
        function X2(De2, G2, oe2) {
          let ee2 = De2.getValue(), re2 = [], be2 = De2.map((ye2) => ye2.map((Fe2, Ne2) => {
            let he2 = H2(oe2(), G2).formatted, ze2 = u2(he2);
            return re2[Ne2] = Math.max(re2[Ne2] || 3, ze2), { text: he2, width: ze2 };
          }, "children"), "children"), ve2 = B2(false);
          if (G2.proseWrap !== "never")
            return [l2, ve2];
          let fe2 = B2(true);
          return [l2, A2(E2(fe2, ve2))];
          function B2(ye2) {
            let Fe2 = [te2(be2[0], ye2), $2(ye2)];
            return be2.length > 1 && Fe2.push(p2(N2, be2.slice(1).map((Ne2) => te2(Ne2, ye2)))), p2(N2, Fe2);
          }
          function $2(ye2) {
            return `| ${re2.map((Ne2, he2) => {
              let ze2 = ee2.align[he2], Te2 = ze2 === "center" || ze2 === "left" ? ":" : "-", Ye2 = ze2 === "center" || ze2 === "right" ? ":" : "-", Se2 = ye2 ? "-" : "-".repeat(Ne2 - 2);
              return `${Te2}${Se2}${Ye2}`;
            }).join(" | ")} |`;
          }
          function te2(ye2, Fe2) {
            return `| ${ye2.map((he2, ze2) => {
              let { text: Te2, width: Ye2 } = he2;
              if (Fe2)
                return Te2;
              let Se2 = re2[ze2] - Ye2, ke2 = ee2.align[ze2], je2 = 0;
              ke2 === "right" ? je2 = Se2 : ke2 === "center" && (je2 = Math.floor(Se2 / 2));
              let Je2 = Se2 - je2;
              return `${" ".repeat(je2)}${Te2}${" ".repeat(Je2)}`;
            }).join(" | ")} |`;
          }
        }
        function de2(De2, G2, oe2) {
          let ee2 = [], re2 = null, { children: be2 } = De2.getValue();
          for (let [ve2, fe2] of be2.entries())
            switch (ue2(fe2)) {
              case "start":
                re2 === null && (re2 = { index: ve2, offset: fe2.position.end.offset });
                break;
              case "end":
                re2 !== null && (ee2.push({ start: re2, end: { index: ve2, offset: fe2.position.start.offset } }), re2 = null);
                break;
            }
          return ie2(De2, G2, oe2, { processor: (ve2, fe2) => {
            if (ee2.length > 0) {
              let B2 = ee2[0];
              if (fe2 === B2.start.index)
                return [Ee2(be2[B2.start.index]), G2.originalText.slice(B2.start.offset, B2.end.offset), Ee2(be2[B2.end.index])];
              if (B2.start.index < fe2 && fe2 < B2.end.index)
                return false;
              if (fe2 === B2.end.index)
                return ee2.shift(), false;
            }
            return oe2();
          } });
        }
        function ie2(De2, G2, oe2) {
          let ee2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, { postprocessor: re2 } = ee2, be2 = ee2.processor || (() => oe2()), ve2 = De2.getValue(), fe2 = [], B2;
          return De2.each(($2, te2) => {
            let ye2 = $2.getValue(), Fe2 = be2($2, te2);
            if (Fe2 !== false) {
              let Ne2 = { parts: fe2, prevNode: B2, parentNode: ve2, options: G2 };
              J2(ye2, Ne2) && (fe2.push(c2), B2 && q2.has(B2.type) || (le2(ye2, Ne2) || ge2(ye2, Ne2)) && fe2.push(c2), ge2(ye2, Ne2) && fe2.push(c2)), fe2.push(Fe2), B2 = ye2;
            }
          }, "children"), re2 ? re2(fe2) : fe2;
        }
        function Ee2(De2) {
          if (De2.type === "html")
            return De2.value;
          if (De2.type === "paragraph" && Array.isArray(De2.children) && De2.children.length === 1 && De2.children[0].type === "esComment")
            return ["{/* ", De2.children[0].value, " */}"];
        }
        function z2(De2) {
          let G2 = De2;
          for (; i2(G2.children); )
            G2 = s2(G2.children);
          return G2;
        }
        function ue2(De2) {
          let G2;
          if (De2.type === "html")
            G2 = De2.value.match(/^<!--\s*prettier-ignore(?:-(start|end))?\s*-->$/);
          else {
            let oe2;
            De2.type === "esComment" ? oe2 = De2 : De2.type === "paragraph" && De2.children.length === 1 && De2.children[0].type === "esComment" && (oe2 = De2.children[0]), oe2 && (G2 = oe2.value.match(/^prettier-ignore(?:-(start|end))?$/));
          }
          return G2 ? G2[1] || "next" : false;
        }
        function J2(De2, G2) {
          let oe2 = G2.parts.length === 0, ee2 = k2.includes(De2.type), re2 = De2.type === "html" && M2.includes(G2.parentNode.type);
          return !oe2 && !ee2 && !re2;
        }
        function le2(De2, G2) {
          var oe2, ee2, re2;
          let ve2 = (G2.prevNode && G2.prevNode.type) === De2.type && L2.has(De2.type), fe2 = G2.parentNode.type === "listItem" && !G2.parentNode.loose, B2 = ((oe2 = G2.prevNode) === null || oe2 === void 0 ? void 0 : oe2.type) === "listItem" && G2.prevNode.loose, $2 = ue2(G2.prevNode) === "next", te2 = De2.type === "html" && ((ee2 = G2.prevNode) === null || ee2 === void 0 ? void 0 : ee2.type) === "html" && G2.prevNode.position.end.line + 1 === De2.position.start.line, ye2 = De2.type === "html" && G2.parentNode.type === "listItem" && ((re2 = G2.prevNode) === null || re2 === void 0 ? void 0 : re2.type) === "paragraph" && G2.prevNode.position.end.line + 1 === De2.position.start.line;
          return B2 || !(ve2 || fe2 || $2 || te2 || ye2);
        }
        function ge2(De2, G2) {
          let oe2 = G2.prevNode && G2.prevNode.type === "list", ee2 = De2.type === "code" && De2.isIndented;
          return oe2 && ee2;
        }
        function pe2(De2) {
          let G2 = ce2(De2, ["linkReference", "imageReference"]);
          return G2 && (G2.type !== "linkReference" || G2.referenceType !== "full");
        }
        function Ae2(De2) {
          let G2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], oe2 = [" ", ...Array.isArray(G2) ? G2 : [G2]];
          return new RegExp(oe2.map((ee2) => `\\${ee2}`).join("|")).test(De2) ? `<${De2}>` : De2;
        }
        function Ce2(De2, G2) {
          let oe2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
          if (!De2)
            return "";
          if (oe2)
            return " " + Ce2(De2, G2, false);
          if (De2 = De2.replace(/\\(["')])/g, "$1"), De2.includes('"') && De2.includes("'") && !De2.includes(")"))
            return `(${De2})`;
          let ee2 = De2.split("'").length - 1, re2 = De2.split('"').length - 1, be2 = ee2 > re2 ? '"' : re2 > ee2 || G2.singleQuote ? "'" : '"';
          return De2 = De2.replace(/\\/, "\\\\"), De2 = De2.replace(new RegExp(`(${be2})`, "g"), "\\$1"), `${be2}${De2}${be2}`;
        }
        function Oe2(De2, G2, oe2) {
          return De2 < G2 ? G2 : De2 > oe2 ? oe2 : De2;
        }
        function Ie2(De2) {
          let G2 = Number(De2.getName());
          if (G2 === 0)
            return false;
          let oe2 = De2.getParentNode().children[G2 - 1];
          return ue2(oe2) === "next";
        }
        function we2(De2) {
          return `[${t2(De2.label)}]`;
        }
        function _e2(De2) {
          return `[^${De2.label}]`;
        }
        r2.exports = { preprocess: o2, print: Y2, embed: f2, massageAstNode: h2, hasPrettierIgnore: Ie2, insertPragma: b2 };
      } }), fg2 = Z2({ "src/language-markdown/options.js"(e25, r2) {
        ne2();
        var t2 = Mt2();
        r2.exports = { proseWrap: t2.proseWrap, singleQuote: t2.singleQuote };
      } }), Dg2 = Z2({ "src/language-markdown/parsers.js"() {
        ne2();
      } }), _a2 = Z2({ "node_modules/linguist-languages/data/Markdown.json"(e25, r2) {
        r2.exports = { name: "Markdown", type: "prose", color: "#083fa1", aliases: ["pandoc"], aceMode: "markdown", codemirrorMode: "gfm", codemirrorMimeType: "text/x-gfm", wrap: true, extensions: [".md", ".livemd", ".markdown", ".mdown", ".mdwn", ".mdx", ".mkd", ".mkdn", ".mkdown", ".ronn", ".scd", ".workbook"], filenames: ["contents.lr"], tmScope: "source.gfm", languageId: 222 };
      } }), mg2 = Z2({ "src/language-markdown/index.js"(e25, r2) {
        ne2();
        var t2 = _t2(), s2 = pg2(), a2 = fg2(), n2 = Dg2(), u2 = [t2(_a2(), (l2) => ({ since: "1.8.0", parsers: ["markdown"], vscodeLanguageIds: ["markdown"], filenames: [...l2.filenames, "README"], extensions: l2.extensions.filter((p2) => p2 !== ".mdx") })), t2(_a2(), () => ({ name: "MDX", since: "1.15.0", parsers: ["mdx"], vscodeLanguageIds: ["mdx"], filenames: [], extensions: [".mdx"] }))], i2 = { mdast: s2 };
        r2.exports = { languages: u2, options: a2, printers: i2, parsers: n2 };
      } }), dg2 = Z2({ "src/language-html/clean.js"(e25, r2) {
        ne2();
        var { isFrontMatterNode: t2 } = Ue2(), s2 = new Set(["sourceSpan", "startSourceSpan", "endSourceSpan", "nameSpan", "valueSpan"]);
        function a2(n2, u2) {
          if (n2.type === "text" || n2.type === "comment" || t2(n2) || n2.type === "yaml" || n2.type === "toml")
            return null;
          n2.type === "attribute" && delete u2.value, n2.type === "docType" && delete u2.value;
        }
        a2.ignoredProperties = s2, r2.exports = a2;
      } }), gg2 = Z2({ "src/language-html/constants.evaluate.js"(e25, r2) {
        r2.exports = { CSS_DISPLAY_TAGS: { area: "none", base: "none", basefont: "none", datalist: "none", head: "none", link: "none", meta: "none", noembed: "none", noframes: "none", param: "block", rp: "none", script: "block", source: "block", style: "none", template: "inline", track: "block", title: "none", html: "block", body: "block", address: "block", blockquote: "block", center: "block", div: "block", figure: "block", figcaption: "block", footer: "block", form: "block", header: "block", hr: "block", legend: "block", listing: "block", main: "block", p: "block", plaintext: "block", pre: "block", xmp: "block", slot: "contents", ruby: "ruby", rt: "ruby-text", article: "block", aside: "block", h1: "block", h2: "block", h3: "block", h4: "block", h5: "block", h6: "block", hgroup: "block", nav: "block", section: "block", dir: "block", dd: "block", dl: "block", dt: "block", ol: "block", ul: "block", li: "list-item", table: "table", caption: "table-caption", colgroup: "table-column-group", col: "table-column", thead: "table-header-group", tbody: "table-row-group", tfoot: "table-footer-group", tr: "table-row", td: "table-cell", th: "table-cell", fieldset: "block", button: "inline-block", details: "block", summary: "block", dialog: "block", meter: "inline-block", progress: "inline-block", object: "inline-block", video: "inline-block", audio: "inline-block", select: "inline-block", option: "block", optgroup: "block" }, CSS_DISPLAY_DEFAULT: "inline", CSS_WHITE_SPACE_TAGS: { listing: "pre", plaintext: "pre", pre: "pre", xmp: "pre", nobr: "nowrap", table: "initial", textarea: "pre-wrap" }, CSS_WHITE_SPACE_DEFAULT: "normal" };
      } }), yg2 = Z2({ "src/language-html/utils/is-unknown-namespace.js"(e25, r2) {
        ne2();
        function t2(s2) {
          return s2.type === "element" && !s2.hasExplicitNamespace && !["html", "svg"].includes(s2.namespace);
        }
        r2.exports = t2;
      } }), Rt2 = Z2({ "src/language-html/utils/index.js"(e25, r2) {
        ne2();
        var { inferParserByLanguage: t2, isFrontMatterNode: s2 } = Ue2(), { builders: { line: a2, hardline: n2, join: u2 }, utils: { getDocParts: i2, replaceTextEndOfLine: l2 } } = Me2(), { CSS_DISPLAY_TAGS: p2, CSS_DISPLAY_DEFAULT: d2, CSS_WHITE_SPACE_TAGS: y2, CSS_WHITE_SPACE_DEFAULT: g2 } = gg2(), c2 = yg2(), D2 = new Set(["	", `
`, "\f", "\r", " "]), E2 = (B2) => B2.replace(/^[\t\n\f\r ]+/, ""), _2 = (B2) => B2.replace(/[\t\n\f\r ]+$/, ""), w2 = (B2) => E2(_2(B2)), F2 = (B2) => B2.replace(/^[\t\f\r ]*\n/g, ""), A2 = (B2) => F2(_2(B2)), N2 = (B2) => B2.split(/[\t\n\f\r ]+/), I2 = (B2) => B2.match(/^[\t\n\f\r ]*/)[0], P2 = (B2) => {
          let [, $2, te2, ye2] = B2.match(/^([\t\n\f\r ]*)(.*?)([\t\n\f\r ]*)$/s);
          return { leadingWhitespace: $2, trailingWhitespace: ye2, text: te2 };
        }, H2 = (B2) => /[\t\n\f\r ]/.test(B2);
        function f2(B2, $2) {
          return !!(B2.type === "ieConditionalComment" && B2.lastChild && !B2.lastChild.isSelfClosing && !B2.lastChild.endSourceSpan || B2.type === "ieConditionalComment" && !B2.complete || le2(B2) && B2.children.some((te2) => te2.type !== "text" && te2.type !== "interpolation") || ee2(B2, $2) && !o2(B2) && B2.type !== "interpolation");
        }
        function b2(B2) {
          return B2.type === "attribute" || !B2.parent || !B2.prev ? false : m2(B2.prev);
        }
        function m2(B2) {
          return B2.type === "comment" && B2.value.trim() === "prettier-ignore";
        }
        function v2(B2) {
          return B2.type === "text" || B2.type === "comment";
        }
        function o2(B2) {
          return B2.type === "element" && (B2.fullName === "script" || B2.fullName === "style" || B2.fullName === "svg:style" || c2(B2) && (B2.name === "script" || B2.name === "style"));
        }
        function h2(B2) {
          return B2.children && !o2(B2);
        }
        function C2(B2) {
          return o2(B2) || B2.type === "interpolation" || S2(B2);
        }
        function S2(B2) {
          return Ce2(B2).startsWith("pre");
        }
        function x2(B2, $2) {
          let te2 = ye2();
          if (te2 && !B2.prev && B2.parent && B2.parent.tagDefinition && B2.parent.tagDefinition.ignoreFirstLf)
            return B2.type === "interpolation";
          return te2;
          function ye2() {
            return s2(B2) ? false : (B2.type === "text" || B2.type === "interpolation") && B2.prev && (B2.prev.type === "text" || B2.prev.type === "interpolation") ? true : !B2.parent || B2.parent.cssDisplay === "none" ? false : le2(B2.parent) ? true : !(!B2.prev && (B2.parent.type === "root" || le2(B2) && B2.parent || o2(B2.parent) || G2(B2.parent, $2) || !ie2(B2.parent.cssDisplay)) || B2.prev && !ue2(B2.prev.cssDisplay));
          }
        }
        function T2(B2, $2) {
          return s2(B2) ? false : (B2.type === "text" || B2.type === "interpolation") && B2.next && (B2.next.type === "text" || B2.next.type === "interpolation") ? true : !B2.parent || B2.parent.cssDisplay === "none" ? false : le2(B2.parent) ? true : !(!B2.next && (B2.parent.type === "root" || le2(B2) && B2.parent || o2(B2.parent) || G2(B2.parent, $2) || !Ee2(B2.parent.cssDisplay)) || B2.next && !z2(B2.next.cssDisplay));
        }
        function k2(B2) {
          return J2(B2.cssDisplay) && !o2(B2);
        }
        function M2(B2) {
          return s2(B2) || B2.next && B2.sourceSpan.end && B2.sourceSpan.end.line + 1 < B2.next.sourceSpan.start.line;
        }
        function R2(B2) {
          return q2(B2) || B2.type === "element" && B2.children.length > 0 && (["body", "script", "style"].includes(B2.name) || B2.children.some(($2) => Q2($2))) || B2.firstChild && B2.firstChild === B2.lastChild && B2.firstChild.type !== "text" && V2(B2.firstChild) && (!B2.lastChild.isTrailingSpaceSensitive || j2(B2.lastChild));
        }
        function q2(B2) {
          return B2.type === "element" && B2.children.length > 0 && (["html", "head", "ul", "ol", "select"].includes(B2.name) || B2.cssDisplay.startsWith("table") && B2.cssDisplay !== "table-cell");
        }
        function U2(B2) {
          return K2(B2) || B2.prev && L2(B2.prev) || Y2(B2);
        }
        function L2(B2) {
          return K2(B2) || B2.type === "element" && B2.fullName === "br" || Y2(B2);
        }
        function Y2(B2) {
          return V2(B2) && j2(B2);
        }
        function V2(B2) {
          return B2.hasLeadingSpaces && (B2.prev ? B2.prev.sourceSpan.end.line < B2.sourceSpan.start.line : B2.parent.type === "root" || B2.parent.startSourceSpan.end.line < B2.sourceSpan.start.line);
        }
        function j2(B2) {
          return B2.hasTrailingSpaces && (B2.next ? B2.next.sourceSpan.start.line > B2.sourceSpan.end.line : B2.parent.type === "root" || B2.parent.endSourceSpan && B2.parent.endSourceSpan.start.line > B2.sourceSpan.end.line);
        }
        function K2(B2) {
          switch (B2.type) {
            case "ieConditionalComment":
            case "comment":
            case "directive":
              return true;
            case "element":
              return ["script", "select"].includes(B2.name);
          }
          return false;
        }
        function se2(B2) {
          return B2.lastChild ? se2(B2.lastChild) : B2;
        }
        function Q2(B2) {
          return B2.children && B2.children.some(($2) => $2.type !== "text");
        }
        function ce2(B2) {
          let { type: $2, lang: te2 } = B2.attrMap;
          if ($2 === "module" || $2 === "text/javascript" || $2 === "text/babel" || $2 === "application/javascript" || te2 === "jsx")
            return "babel";
          if ($2 === "application/x-typescript" || te2 === "ts" || te2 === "tsx")
            return "typescript";
          if ($2 === "text/markdown")
            return "markdown";
          if ($2 === "text/html")
            return "html";
          if ($2 && ($2.endsWith("json") || $2.endsWith("importmap")) || $2 === "speculationrules")
            return "json";
          if ($2 === "text/x-handlebars-template")
            return "glimmer";
        }
        function W2(B2, $2) {
          let { lang: te2 } = B2.attrMap;
          if (!te2 || te2 === "postcss" || te2 === "css")
            return "css";
          if (te2 === "scss")
            return "scss";
          if (te2 === "less")
            return "less";
          if (te2 === "stylus")
            return t2("stylus", $2);
        }
        function X2(B2, $2) {
          if (B2.name === "script" && !B2.attrMap.src)
            return !B2.attrMap.lang && !B2.attrMap.type ? "babel" : ce2(B2);
          if (B2.name === "style")
            return W2(B2, $2);
          if ($2 && ee2(B2, $2))
            return ce2(B2) || !("src" in B2.attrMap) && t2(B2.attrMap.lang, $2);
        }
        function de2(B2) {
          return B2 === "block" || B2 === "list-item" || B2.startsWith("table");
        }
        function ie2(B2) {
          return !de2(B2) && B2 !== "inline-block";
        }
        function Ee2(B2) {
          return !de2(B2) && B2 !== "inline-block";
        }
        function z2(B2) {
          return !de2(B2);
        }
        function ue2(B2) {
          return !de2(B2);
        }
        function J2(B2) {
          return !de2(B2) && B2 !== "inline-block";
        }
        function le2(B2) {
          return Ce2(B2).startsWith("pre");
        }
        function ge2(B2, $2) {
          let te2 = 0;
          for (let ye2 = B2.stack.length - 1; ye2 >= 0; ye2--) {
            let Fe2 = B2.stack[ye2];
            Fe2 && typeof Fe2 == "object" && !Array.isArray(Fe2) && $2(Fe2) && te2++;
          }
          return te2;
        }
        function pe2(B2, $2) {
          let te2 = B2;
          for (; te2; ) {
            if ($2(te2))
              return true;
            te2 = te2.parent;
          }
          return false;
        }
        function Ae2(B2, $2) {
          if (B2.prev && B2.prev.type === "comment") {
            let ye2 = B2.prev.value.match(/^\s*display:\s*([a-z]+)\s*$/);
            if (ye2)
              return ye2[1];
          }
          let te2 = false;
          if (B2.type === "element" && B2.namespace === "svg")
            if (pe2(B2, (ye2) => ye2.fullName === "svg:foreignObject"))
              te2 = true;
            else
              return B2.name === "svg" ? "inline-block" : "block";
          switch ($2.htmlWhitespaceSensitivity) {
            case "strict":
              return "inline";
            case "ignore":
              return "block";
            default:
              return $2.parser === "vue" && B2.parent && B2.parent.type === "root" ? "block" : B2.type === "element" && (!B2.namespace || te2 || c2(B2)) && p2[B2.name] || d2;
          }
        }
        function Ce2(B2) {
          return B2.type === "element" && (!B2.namespace || c2(B2)) && y2[B2.name] || g2;
        }
        function Oe2(B2) {
          let $2 = Number.POSITIVE_INFINITY;
          for (let te2 of B2.split(`
`)) {
            if (te2.length === 0)
              continue;
            if (!D2.has(te2[0]))
              return 0;
            let ye2 = I2(te2).length;
            te2.length !== ye2 && ye2 < $2 && ($2 = ye2);
          }
          return $2 === Number.POSITIVE_INFINITY ? 0 : $2;
        }
        function Ie2(B2) {
          let $2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Oe2(B2);
          return $2 === 0 ? B2 : B2.split(`
`).map((te2) => te2.slice($2)).join(`
`);
        }
        function we2(B2, $2) {
          let te2 = 0;
          for (let ye2 = 0; ye2 < B2.length; ye2++)
            B2[ye2] === $2 && te2++;
          return te2;
        }
        function _e2(B2) {
          return B2.replace(/&apos;/g, "'").replace(/&quot;/g, '"');
        }
        var De2 = new Set(["template", "style", "script"]);
        function G2(B2, $2) {
          return oe2(B2, $2) && !De2.has(B2.fullName);
        }
        function oe2(B2, $2) {
          return $2.parser === "vue" && B2.type === "element" && B2.parent.type === "root" && B2.fullName.toLowerCase() !== "html";
        }
        function ee2(B2, $2) {
          return oe2(B2, $2) && (G2(B2, $2) || B2.attrMap.lang && B2.attrMap.lang !== "html");
        }
        function re2(B2) {
          let $2 = B2.fullName;
          return $2.charAt(0) === "#" || $2 === "slot-scope" || $2 === "v-slot" || $2.startsWith("v-slot:");
        }
        function be2(B2, $2) {
          let te2 = B2.parent;
          if (!oe2(te2, $2))
            return false;
          let ye2 = te2.fullName, Fe2 = B2.fullName;
          return ye2 === "script" && Fe2 === "setup" || ye2 === "style" && Fe2 === "vars";
        }
        function ve2(B2) {
          let $2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : B2.value;
          return B2.parent.isWhitespaceSensitive ? B2.parent.isIndentationSensitive ? l2($2) : l2(Ie2(A2($2)), n2) : i2(u2(a2, N2($2)));
        }
        function fe2(B2, $2) {
          return oe2(B2, $2) && B2.name === "script";
        }
        r2.exports = { htmlTrim: w2, htmlTrimPreserveIndentation: A2, hasHtmlWhitespace: H2, getLeadingAndTrailingHtmlWhitespace: P2, canHaveInterpolation: h2, countChars: we2, countParents: ge2, dedentString: Ie2, forceBreakChildren: q2, forceBreakContent: R2, forceNextEmptyLine: M2, getLastDescendant: se2, getNodeCssStyleDisplay: Ae2, getNodeCssStyleWhiteSpace: Ce2, hasPrettierIgnore: b2, inferScriptParser: X2, isVueCustomBlock: G2, isVueNonHtmlBlock: ee2, isVueScriptTag: fe2, isVueSlotAttribute: re2, isVueSfcBindingsAttribute: be2, isVueSfcBlock: oe2, isDanglingSpaceSensitiveNode: k2, isIndentationSensitiveNode: S2, isLeadingSpaceSensitiveNode: x2, isPreLikeNode: le2, isScriptLikeTag: o2, isTextLikeNode: v2, isTrailingSpaceSensitiveNode: T2, isWhitespaceSensitiveNode: C2, isUnknownNamespace: c2, preferHardlineAsLeadingSpaces: U2, preferHardlineAsTrailingSpaces: L2, shouldPreserveContent: f2, unescapeQuoteEntities: _e2, getTextValueParts: ve2 };
      } }), hg2 = Z2({ "node_modules/angular-html-parser/lib/compiler/src/chars.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true }), e25.$EOF = 0, e25.$BSPACE = 8, e25.$TAB = 9, e25.$LF = 10, e25.$VTAB = 11, e25.$FF = 12, e25.$CR = 13, e25.$SPACE = 32, e25.$BANG = 33, e25.$DQ = 34, e25.$HASH = 35, e25.$$ = 36, e25.$PERCENT = 37, e25.$AMPERSAND = 38, e25.$SQ = 39, e25.$LPAREN = 40, e25.$RPAREN = 41, e25.$STAR = 42, e25.$PLUS = 43, e25.$COMMA = 44, e25.$MINUS = 45, e25.$PERIOD = 46, e25.$SLASH = 47, e25.$COLON = 58, e25.$SEMICOLON = 59, e25.$LT = 60, e25.$EQ = 61, e25.$GT = 62, e25.$QUESTION = 63, e25.$0 = 48, e25.$7 = 55, e25.$9 = 57, e25.$A = 65, e25.$E = 69, e25.$F = 70, e25.$X = 88, e25.$Z = 90, e25.$LBRACKET = 91, e25.$BACKSLASH = 92, e25.$RBRACKET = 93, e25.$CARET = 94, e25.$_ = 95, e25.$a = 97, e25.$b = 98, e25.$e = 101, e25.$f = 102, e25.$n = 110, e25.$r = 114, e25.$t = 116, e25.$u = 117, e25.$v = 118, e25.$x = 120, e25.$z = 122, e25.$LBRACE = 123, e25.$BAR = 124, e25.$RBRACE = 125, e25.$NBSP = 160, e25.$PIPE = 124, e25.$TILDA = 126, e25.$AT = 64, e25.$BT = 96;
        function r2(i2) {
          return i2 >= e25.$TAB && i2 <= e25.$SPACE || i2 == e25.$NBSP;
        }
        e25.isWhitespace = r2;
        function t2(i2) {
          return e25.$0 <= i2 && i2 <= e25.$9;
        }
        e25.isDigit = t2;
        function s2(i2) {
          return i2 >= e25.$a && i2 <= e25.$z || i2 >= e25.$A && i2 <= e25.$Z;
        }
        e25.isAsciiLetter = s2;
        function a2(i2) {
          return i2 >= e25.$a && i2 <= e25.$f || i2 >= e25.$A && i2 <= e25.$F || t2(i2);
        }
        e25.isAsciiHexDigit = a2;
        function n2(i2) {
          return i2 === e25.$LF || i2 === e25.$CR;
        }
        e25.isNewLine = n2;
        function u2(i2) {
          return e25.$0 <= i2 && i2 <= e25.$7;
        }
        e25.isOctalDigit = u2;
      } }), vg2 = Z2({ "node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = class {
          constructor(s2, a2, n2) {
            this.filePath = s2, this.name = a2, this.members = n2;
          }
          assertNoMembers() {
            if (this.members.length)
              throw new Error(`Illegal state: symbol without members expected, but got ${JSON.stringify(this)}.`);
          }
        };
        e25.StaticSymbol = r2;
        var t2 = class {
          constructor() {
            this.cache = new Map();
          }
          get(s2, a2, n2) {
            n2 = n2 || [];
            let u2 = n2.length ? `.${n2.join(".")}` : "", i2 = `"${s2}".${a2}${u2}`, l2 = this.cache.get(i2);
            return l2 || (l2 = new r2(s2, a2, n2), this.cache.set(i2, l2)), l2;
          }
        };
        e25.StaticSymbolCache = t2;
      } }), Cg2 = Z2({ "node_modules/angular-html-parser/lib/compiler/src/util.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = /-+([a-z0-9])/g;
        function t2(o2) {
          return o2.replace(r2, function() {
            for (var h2 = arguments.length, C2 = new Array(h2), S2 = 0; S2 < h2; S2++)
              C2[S2] = arguments[S2];
            return C2[1].toUpperCase();
          });
        }
        e25.dashCaseToCamelCase = t2;
        function s2(o2, h2) {
          return n2(o2, ":", h2);
        }
        e25.splitAtColon = s2;
        function a2(o2, h2) {
          return n2(o2, ".", h2);
        }
        e25.splitAtPeriod = a2;
        function n2(o2, h2, C2) {
          let S2 = o2.indexOf(h2);
          return S2 == -1 ? C2 : [o2.slice(0, S2).trim(), o2.slice(S2 + 1).trim()];
        }
        function u2(o2, h2, C2) {
          return Array.isArray(o2) ? h2.visitArray(o2, C2) : F2(o2) ? h2.visitStringMap(o2, C2) : o2 == null || typeof o2 == "string" || typeof o2 == "number" || typeof o2 == "boolean" ? h2.visitPrimitive(o2, C2) : h2.visitOther(o2, C2);
        }
        e25.visitValue = u2;
        function i2(o2) {
          return o2 != null;
        }
        e25.isDefined = i2;
        function l2(o2) {
          return o2 === void 0 ? null : o2;
        }
        e25.noUndefined = l2;
        var p2 = class {
          visitArray(o2, h2) {
            return o2.map((C2) => u2(C2, this, h2));
          }
          visitStringMap(o2, h2) {
            let C2 = {};
            return Object.keys(o2).forEach((S2) => {
              C2[S2] = u2(o2[S2], this, h2);
            }), C2;
          }
          visitPrimitive(o2, h2) {
            return o2;
          }
          visitOther(o2, h2) {
            return o2;
          }
        };
        e25.ValueTransformer = p2, e25.SyncAsync = { assertSync: (o2) => {
          if (P2(o2))
            throw new Error("Illegal state: value cannot be a promise");
          return o2;
        }, then: (o2, h2) => P2(o2) ? o2.then(h2) : h2(o2), all: (o2) => o2.some(P2) ? Promise.all(o2) : o2 };
        function d2(o2) {
          throw new Error(`Internal Error: ${o2}`);
        }
        e25.error = d2;
        function y2(o2, h2) {
          let C2 = Error(o2);
          return C2[g2] = true, h2 && (C2[c2] = h2), C2;
        }
        e25.syntaxError = y2;
        var g2 = "ngSyntaxError", c2 = "ngParseErrors";
        function D2(o2) {
          return o2[g2];
        }
        e25.isSyntaxError = D2;
        function E2(o2) {
          return o2[c2] || [];
        }
        e25.getParseErrors = E2;
        function _2(o2) {
          return o2.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
        }
        e25.escapeRegExp = _2;
        var w2 = Object.getPrototypeOf({});
        function F2(o2) {
          return typeof o2 == "object" && o2 !== null && Object.getPrototypeOf(o2) === w2;
        }
        function A2(o2) {
          let h2 = "";
          for (let C2 = 0; C2 < o2.length; C2++) {
            let S2 = o2.charCodeAt(C2);
            if (S2 >= 55296 && S2 <= 56319 && o2.length > C2 + 1) {
              let x2 = o2.charCodeAt(C2 + 1);
              x2 >= 56320 && x2 <= 57343 && (C2++, S2 = (S2 - 55296 << 10) + x2 - 56320 + 65536);
            }
            S2 <= 127 ? h2 += String.fromCharCode(S2) : S2 <= 2047 ? h2 += String.fromCharCode(S2 >> 6 & 31 | 192, S2 & 63 | 128) : S2 <= 65535 ? h2 += String.fromCharCode(S2 >> 12 | 224, S2 >> 6 & 63 | 128, S2 & 63 | 128) : S2 <= 2097151 && (h2 += String.fromCharCode(S2 >> 18 & 7 | 240, S2 >> 12 & 63 | 128, S2 >> 6 & 63 | 128, S2 & 63 | 128));
          }
          return h2;
        }
        e25.utf8Encode = A2;
        function N2(o2) {
          if (typeof o2 == "string")
            return o2;
          if (o2 instanceof Array)
            return "[" + o2.map(N2).join(", ") + "]";
          if (o2 == null)
            return "" + o2;
          if (o2.overriddenName)
            return `${o2.overriddenName}`;
          if (o2.name)
            return `${o2.name}`;
          if (!o2.toString)
            return "object";
          let h2 = o2.toString();
          if (h2 == null)
            return "" + h2;
          let C2 = h2.indexOf(`
`);
          return C2 === -1 ? h2 : h2.substring(0, C2);
        }
        e25.stringify = N2;
        function I2(o2) {
          return typeof o2 == "function" && o2.hasOwnProperty("__forward_ref__") ? o2() : o2;
        }
        e25.resolveForwardRef = I2;
        function P2(o2) {
          return !!o2 && typeof o2.then == "function";
        }
        e25.isPromise = P2;
        var H2 = class {
          constructor(o2) {
            this.full = o2;
            let h2 = o2.split(".");
            this.major = h2[0], this.minor = h2[1], this.patch = h2.slice(2).join(".");
          }
        };
        e25.Version = H2;
        var f2 = typeof window < "u" && window, b2 = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, m2 = typeof globalThis < "u" && globalThis, v2 = m2 || f2 || b2;
        e25.global = v2;
      } }), Eg2 = Z2({ "node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = vg2(), t2 = Cg2(), s2 = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
        function a2(C2) {
          return C2.replace(/\W/g, "_");
        }
        e25.sanitizeIdentifier = a2;
        var n2 = 0;
        function u2(C2) {
          if (!C2 || !C2.reference)
            return null;
          let S2 = C2.reference;
          if (S2 instanceof r2.StaticSymbol)
            return S2.name;
          if (S2.__anonymousType)
            return S2.__anonymousType;
          let x2 = t2.stringify(S2);
          return x2.indexOf("(") >= 0 ? (x2 = `anonymous_${n2++}`, S2.__anonymousType = x2) : x2 = a2(x2), x2;
        }
        e25.identifierName = u2;
        function i2(C2) {
          let S2 = C2.reference;
          return S2 instanceof r2.StaticSymbol ? S2.filePath : `./${t2.stringify(S2)}`;
        }
        e25.identifierModuleUrl = i2;
        function l2(C2, S2) {
          return `View_${u2({ reference: C2 })}_${S2}`;
        }
        e25.viewClassName = l2;
        function p2(C2) {
          return `RenderType_${u2({ reference: C2 })}`;
        }
        e25.rendererTypeName = p2;
        function d2(C2) {
          return `HostView_${u2({ reference: C2 })}`;
        }
        e25.hostViewClassName = d2;
        function y2(C2) {
          return `${u2({ reference: C2 })}NgFactory`;
        }
        e25.componentFactoryName = y2;
        var g2;
        (function(C2) {
          C2[C2.Pipe = 0] = "Pipe", C2[C2.Directive = 1] = "Directive", C2[C2.NgModule = 2] = "NgModule", C2[C2.Injectable = 3] = "Injectable";
        })(g2 = e25.CompileSummaryKind || (e25.CompileSummaryKind = {}));
        function c2(C2) {
          return C2.value != null ? a2(C2.value) : u2(C2.identifier);
        }
        e25.tokenName = c2;
        function D2(C2) {
          return C2.identifier != null ? C2.identifier.reference : C2.value;
        }
        e25.tokenReference = D2;
        var E2 = class {
          constructor() {
            let { moduleUrl: C2, styles: S2, styleUrls: x2 } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            this.moduleUrl = C2 || null, this.styles = P2(S2), this.styleUrls = P2(x2);
          }
        };
        e25.CompileStylesheetMetadata = E2;
        var _2 = class {
          constructor(C2) {
            let { encapsulation: S2, template: x2, templateUrl: T2, htmlAst: k2, styles: M2, styleUrls: R2, externalStylesheets: q2, animations: U2, ngContentSelectors: L2, interpolation: Y2, isInline: V2, preserveWhitespaces: j2 } = C2;
            if (this.encapsulation = S2, this.template = x2, this.templateUrl = T2, this.htmlAst = k2, this.styles = P2(M2), this.styleUrls = P2(R2), this.externalStylesheets = P2(q2), this.animations = U2 ? f2(U2) : [], this.ngContentSelectors = L2 || [], Y2 && Y2.length != 2)
              throw new Error("'interpolation' should have a start and an end symbol.");
            this.interpolation = Y2, this.isInline = V2, this.preserveWhitespaces = j2;
          }
          toSummary() {
            return { ngContentSelectors: this.ngContentSelectors, encapsulation: this.encapsulation, styles: this.styles, animations: this.animations };
          }
        };
        e25.CompileTemplateMetadata = _2;
        var w2 = class {
          static create(C2) {
            let { isHost: S2, type: x2, isComponent: T2, selector: k2, exportAs: M2, changeDetection: R2, inputs: q2, outputs: U2, host: L2, providers: Y2, viewProviders: V2, queries: j2, guards: K2, viewQueries: se2, entryComponents: Q2, template: ce2, componentViewType: W2, rendererType: X2, componentFactory: de2 } = C2, ie2 = {}, Ee2 = {}, z2 = {};
            L2 != null && Object.keys(L2).forEach((le2) => {
              let ge2 = L2[le2], pe2 = le2.match(s2);
              pe2 === null ? z2[le2] = ge2 : pe2[1] != null ? Ee2[pe2[1]] = ge2 : pe2[2] != null && (ie2[pe2[2]] = ge2);
            });
            let ue2 = {};
            q2 != null && q2.forEach((le2) => {
              let ge2 = t2.splitAtColon(le2, [le2, le2]);
              ue2[ge2[0]] = ge2[1];
            });
            let J2 = {};
            return U2 != null && U2.forEach((le2) => {
              let ge2 = t2.splitAtColon(le2, [le2, le2]);
              J2[ge2[0]] = ge2[1];
            }), new w2({ isHost: S2, type: x2, isComponent: !!T2, selector: k2, exportAs: M2, changeDetection: R2, inputs: ue2, outputs: J2, hostListeners: ie2, hostProperties: Ee2, hostAttributes: z2, providers: Y2, viewProviders: V2, queries: j2, guards: K2, viewQueries: se2, entryComponents: Q2, template: ce2, componentViewType: W2, rendererType: X2, componentFactory: de2 });
          }
          constructor(C2) {
            let { isHost: S2, type: x2, isComponent: T2, selector: k2, exportAs: M2, changeDetection: R2, inputs: q2, outputs: U2, hostListeners: L2, hostProperties: Y2, hostAttributes: V2, providers: j2, viewProviders: K2, queries: se2, guards: Q2, viewQueries: ce2, entryComponents: W2, template: X2, componentViewType: de2, rendererType: ie2, componentFactory: Ee2 } = C2;
            this.isHost = !!S2, this.type = x2, this.isComponent = T2, this.selector = k2, this.exportAs = M2, this.changeDetection = R2, this.inputs = q2, this.outputs = U2, this.hostListeners = L2, this.hostProperties = Y2, this.hostAttributes = V2, this.providers = P2(j2), this.viewProviders = P2(K2), this.queries = P2(se2), this.guards = Q2, this.viewQueries = P2(ce2), this.entryComponents = P2(W2), this.template = X2, this.componentViewType = de2, this.rendererType = ie2, this.componentFactory = Ee2;
          }
          toSummary() {
            return { summaryKind: g2.Directive, type: this.type, isComponent: this.isComponent, selector: this.selector, exportAs: this.exportAs, inputs: this.inputs, outputs: this.outputs, hostListeners: this.hostListeners, hostProperties: this.hostProperties, hostAttributes: this.hostAttributes, providers: this.providers, viewProviders: this.viewProviders, queries: this.queries, guards: this.guards, viewQueries: this.viewQueries, entryComponents: this.entryComponents, changeDetection: this.changeDetection, template: this.template && this.template.toSummary(), componentViewType: this.componentViewType, rendererType: this.rendererType, componentFactory: this.componentFactory };
          }
        };
        e25.CompileDirectiveMetadata = w2;
        var F2 = class {
          constructor(C2) {
            let { type: S2, name: x2, pure: T2 } = C2;
            this.type = S2, this.name = x2, this.pure = !!T2;
          }
          toSummary() {
            return { summaryKind: g2.Pipe, type: this.type, name: this.name, pure: this.pure };
          }
        };
        e25.CompilePipeMetadata = F2;
        var A2 = class {
        };
        e25.CompileShallowModuleMetadata = A2;
        var N2 = class {
          constructor(C2) {
            let { type: S2, providers: x2, declaredDirectives: T2, exportedDirectives: k2, declaredPipes: M2, exportedPipes: R2, entryComponents: q2, bootstrapComponents: U2, importedModules: L2, exportedModules: Y2, schemas: V2, transitiveModule: j2, id: K2 } = C2;
            this.type = S2 || null, this.declaredDirectives = P2(T2), this.exportedDirectives = P2(k2), this.declaredPipes = P2(M2), this.exportedPipes = P2(R2), this.providers = P2(x2), this.entryComponents = P2(q2), this.bootstrapComponents = P2(U2), this.importedModules = P2(L2), this.exportedModules = P2(Y2), this.schemas = P2(V2), this.id = K2 || null, this.transitiveModule = j2 || null;
          }
          toSummary() {
            let C2 = this.transitiveModule;
            return { summaryKind: g2.NgModule, type: this.type, entryComponents: C2.entryComponents, providers: C2.providers, modules: C2.modules, exportedDirectives: C2.exportedDirectives, exportedPipes: C2.exportedPipes };
          }
        };
        e25.CompileNgModuleMetadata = N2;
        var I2 = class {
          constructor() {
            this.directivesSet = new Set(), this.directives = [], this.exportedDirectivesSet = new Set(), this.exportedDirectives = [], this.pipesSet = new Set(), this.pipes = [], this.exportedPipesSet = new Set(), this.exportedPipes = [], this.modulesSet = new Set(), this.modules = [], this.entryComponentsSet = new Set(), this.entryComponents = [], this.providers = [];
          }
          addProvider(C2, S2) {
            this.providers.push({ provider: C2, module: S2 });
          }
          addDirective(C2) {
            this.directivesSet.has(C2.reference) || (this.directivesSet.add(C2.reference), this.directives.push(C2));
          }
          addExportedDirective(C2) {
            this.exportedDirectivesSet.has(C2.reference) || (this.exportedDirectivesSet.add(C2.reference), this.exportedDirectives.push(C2));
          }
          addPipe(C2) {
            this.pipesSet.has(C2.reference) || (this.pipesSet.add(C2.reference), this.pipes.push(C2));
          }
          addExportedPipe(C2) {
            this.exportedPipesSet.has(C2.reference) || (this.exportedPipesSet.add(C2.reference), this.exportedPipes.push(C2));
          }
          addModule(C2) {
            this.modulesSet.has(C2.reference) || (this.modulesSet.add(C2.reference), this.modules.push(C2));
          }
          addEntryComponent(C2) {
            this.entryComponentsSet.has(C2.componentType) || (this.entryComponentsSet.add(C2.componentType), this.entryComponents.push(C2));
          }
        };
        e25.TransitiveCompileNgModuleMetadata = I2;
        function P2(C2) {
          return C2 || [];
        }
        var H2 = class {
          constructor(C2, S2) {
            let { useClass: x2, useValue: T2, useExisting: k2, useFactory: M2, deps: R2, multi: q2 } = S2;
            this.token = C2, this.useClass = x2 || null, this.useValue = T2, this.useExisting = k2, this.useFactory = M2 || null, this.dependencies = R2 || null, this.multi = !!q2;
          }
        };
        e25.ProviderMeta = H2;
        function f2(C2) {
          return C2.reduce((S2, x2) => {
            let T2 = Array.isArray(x2) ? f2(x2) : x2;
            return S2.concat(T2);
          }, []);
        }
        e25.flatten = f2;
        function b2(C2) {
          return C2.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, "ng:///");
        }
        function m2(C2, S2, x2) {
          let T2;
          return x2.isInline ? S2.type.reference instanceof r2.StaticSymbol ? T2 = `${S2.type.reference.filePath}.${S2.type.reference.name}.html` : T2 = `${u2(C2)}/${u2(S2.type)}.html` : T2 = x2.templateUrl, S2.type.reference instanceof r2.StaticSymbol ? T2 : b2(T2);
        }
        e25.templateSourceUrl = m2;
        function v2(C2, S2) {
          let x2 = C2.moduleUrl.split(/\/\\/g), T2 = x2[x2.length - 1];
          return b2(`css/${S2}${T2}.ngstyle.js`);
        }
        e25.sharedStylesheetJitUrl = v2;
        function o2(C2) {
          return b2(`${u2(C2.type)}/module.ngfactory.js`);
        }
        e25.ngModuleJitUrl = o2;
        function h2(C2, S2) {
          return b2(`${u2(C2)}/${u2(S2.type)}.ngfactory.js`);
        }
        e25.templateJitUrl = h2;
      } }), Fg2 = Z2({ "node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(e25) {
        ne2(), Object.defineProperty(e25, "__esModule", { value: true });
        var r2 = hg2(), t2 = Eg2(), s2 = class {
          constructor(d2, y2, g2, c2) {
            this.file = d2, this.offset = y2, this.line = g2, this.col = c2;
          }
          toString() {
            return this.offset != null ? `${this.file.url}@${this.line}:${this.col}` : this.file.url;
          }
          moveBy(d2) {
            let y2 = this.file.content, g2 = y2.length, c2 = this.offset, D2 = this.line, E2 = this.col;
            for (; c2 > 0 && d2 < 0; )
              if (c2--, d2++, y2.charCodeAt(c2) == r2.$LF) {
                D2--;
                let w2 = y2.substr(0, c2 - 1).lastIndexOf(String.fromCharCode(r2.$LF));
                E2 = w2 > 0 ? c2 - w2 : c2;
              } else
                E2--;
            for (; c2 < g2 && d2 > 0; ) {
              let _2 = y2.charCodeAt(c2);
              c2++, d2--, _2 == r2.$LF ? (D2++, E2 = 0) : E2++;
            }
            return new s2(this.file, c2, D2, E2);
          }
          getContext(d2, y2) {
            let g2 = this.file.content, c2 = this.offset;
            if (c2 != null) {
              c2 > g2.length - 1 && (c2 = g2.length - 1);
              let D2 = c2, E2 = 0, _2 = 0;
              for (; E2 < d2 && c2 > 0 && (c2--, E2++, !(g2[c2] == `
` && ++_2 == y2)); )
                ;
              for (E2 = 0, _2 = 0; E2 < d2 && D2 < g2.length - 1 && (D2++, E2++, !(g2[D2] == `
` && ++_2 == y2)); )
                ;
              return { before: g2.substring(c2, this.offset), after: g2.substring(this.offset, D2 + 1) };
            }
            return null;
          }
        };
        e25.ParseLocation = s2;
        var a2 = class {
          constructor(d2, y2) {
            this.content = d2, this.url = y2;
          }
        };
        e25.ParseSourceFile = a2;
        var n2 = class {
          constructor(d2, y2) {
            let g2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
            this.start = d2, this.end = y2, this.details = g2;
          }
          toString() {
            return this.start.file.content.substring(this.start.offset, this.end.offset);
          }
        };
        e25.ParseSourceSpan = n2, e25.EMPTY_PARSE_LOCATION = new s2(new a2("", ""), 0, 0, 0), e25.EMPTY_SOURCE_SPAN = new n2(e25.EMPTY_PARSE_LOCATION, e25.EMPTY_PARSE_LOCATION);
        var u2;
        (function(d2) {
          d2[d2.WARNING = 0] = "WARNING", d2[d2.ERROR = 1] = "ERROR";
        })(u2 = e25.ParseErrorLevel || (e25.ParseErrorLevel = {}));
        var i2 = class {
          constructor(d2, y2) {
            let g2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : u2.ERROR;
            this.span = d2, this.msg = y2, this.level = g2;
          }
          contextualMessage() {
            let d2 = this.span.start.getContext(100, 3);
            return d2 ? `${this.msg} ("${d2.before}[${u2[this.level]} ->]${d2.after}")` : this.msg;
          }
          toString() {
            let d2 = this.span.details ? `, ${this.span.details}` : "";
            return `${this.contextualMessage()}: ${this.span.start}${d2}`;
          }
        };
        e25.ParseError = i2;
        function l2(d2, y2) {
          let g2 = t2.identifierModuleUrl(y2), c2 = g2 != null ? `in ${d2} ${t2.identifierName(y2)} in ${g2}` : `in ${d2} ${t2.identifierName(y2)}`, D2 = new a2("", c2);
          return new n2(new s2(D2, -1, -1, -1), new s2(D2, -1, -1, -1));
        }
        e25.typeSourceSpan = l2;
        function p2(d2, y2, g2) {
          let c2 = `in ${d2} ${y2} in ${g2}`, D2 = new a2("", c2);
          return new n2(new s2(D2, -1, -1, -1), new s2(D2, -1, -1, -1));
        }
        e25.r3JitTypeSourceSpan = p2;
      } }), Ag2 = Z2({ "src/language-html/print-preprocess.js"(e25, r2) {
        ne2();
        var { ParseSourceSpan: t2 } = Fg2(), { htmlTrim: s2, getLeadingAndTrailingHtmlWhitespace: a2, hasHtmlWhitespace: n2, canHaveInterpolation: u2, getNodeCssStyleDisplay: i2, isDanglingSpaceSensitiveNode: l2, isIndentationSensitiveNode: p2, isLeadingSpaceSensitiveNode: d2, isTrailingSpaceSensitiveNode: y2, isWhitespaceSensitiveNode: g2, isVueScriptTag: c2 } = Rt2(), D2 = [_2, w2, A2, I2, P2, b2, H2, f2, m2, N2, v2];
        function E2(o2, h2) {
          for (let C2 of D2)
            C2(o2, h2);
          return o2;
        }
        function _2(o2) {
          o2.walk((h2) => {
            if (h2.type === "element" && h2.tagDefinition.ignoreFirstLf && h2.children.length > 0 && h2.children[0].type === "text" && h2.children[0].value[0] === `
`) {
              let C2 = h2.children[0];
              C2.value.length === 1 ? h2.removeChild(C2) : C2.value = C2.value.slice(1);
            }
          });
        }
        function w2(o2) {
          let h2 = (C2) => C2.type === "element" && C2.prev && C2.prev.type === "ieConditionalStartComment" && C2.prev.sourceSpan.end.offset === C2.startSourceSpan.start.offset && C2.firstChild && C2.firstChild.type === "ieConditionalEndComment" && C2.firstChild.sourceSpan.start.offset === C2.startSourceSpan.end.offset;
          o2.walk((C2) => {
            if (C2.children)
              for (let S2 = 0; S2 < C2.children.length; S2++) {
                let x2 = C2.children[S2];
                if (!h2(x2))
                  continue;
                let T2 = x2.prev, k2 = x2.firstChild;
                C2.removeChild(T2), S2--;
                let M2 = new t2(T2.sourceSpan.start, k2.sourceSpan.end), R2 = new t2(M2.start, x2.sourceSpan.end);
                x2.condition = T2.condition, x2.sourceSpan = R2, x2.startSourceSpan = M2, x2.removeChild(k2);
              }
          });
        }
        function F2(o2, h2, C2) {
          o2.walk((S2) => {
            if (S2.children)
              for (let x2 = 0; x2 < S2.children.length; x2++) {
                let T2 = S2.children[x2];
                if (T2.type !== "text" && !h2(T2))
                  continue;
                T2.type !== "text" && (T2.type = "text", T2.value = C2(T2));
                let k2 = T2.prev;
                !k2 || k2.type !== "text" || (k2.value += T2.value, k2.sourceSpan = new t2(k2.sourceSpan.start, T2.sourceSpan.end), S2.removeChild(T2), x2--);
              }
          });
        }
        function A2(o2) {
          return F2(o2, (h2) => h2.type === "cdata", (h2) => `<![CDATA[${h2.value}]]>`);
        }
        function N2(o2) {
          let h2 = (C2) => C2.type === "element" && C2.attrs.length === 0 && C2.children.length === 1 && C2.firstChild.type === "text" && !n2(C2.children[0].value) && !C2.firstChild.hasLeadingSpaces && !C2.firstChild.hasTrailingSpaces && C2.isLeadingSpaceSensitive && !C2.hasLeadingSpaces && C2.isTrailingSpaceSensitive && !C2.hasTrailingSpaces && C2.prev && C2.prev.type === "text" && C2.next && C2.next.type === "text";
          o2.walk((C2) => {
            if (C2.children)
              for (let S2 = 0; S2 < C2.children.length; S2++) {
                let x2 = C2.children[S2];
                if (!h2(x2))
                  continue;
                let T2 = x2.prev, k2 = x2.next;
                T2.value += `<${x2.rawName}>` + x2.firstChild.value + `</${x2.rawName}>` + k2.value, T2.sourceSpan = new t2(T2.sourceSpan.start, k2.sourceSpan.end), T2.isTrailingSpaceSensitive = k2.isTrailingSpaceSensitive, T2.hasTrailingSpaces = k2.hasTrailingSpaces, C2.removeChild(x2), S2--, C2.removeChild(k2);
              }
          });
        }
        function I2(o2, h2) {
          if (h2.parser === "html")
            return;
          let C2 = /{{(.+?)}}/s;
          o2.walk((S2) => {
            if (u2(S2))
              for (let x2 of S2.children) {
                if (x2.type !== "text")
                  continue;
                let T2 = x2.sourceSpan.start, k2 = null, M2 = x2.value.split(C2);
                for (let R2 = 0; R2 < M2.length; R2++, T2 = k2) {
                  let q2 = M2[R2];
                  if (R2 % 2 === 0) {
                    k2 = T2.moveBy(q2.length), q2.length > 0 && S2.insertChildBefore(x2, { type: "text", value: q2, sourceSpan: new t2(T2, k2) });
                    continue;
                  }
                  k2 = T2.moveBy(q2.length + 4), S2.insertChildBefore(x2, { type: "interpolation", sourceSpan: new t2(T2, k2), children: q2.length === 0 ? [] : [{ type: "text", value: q2, sourceSpan: new t2(T2.moveBy(2), k2.moveBy(-2)) }] });
                }
                S2.removeChild(x2);
              }
          });
        }
        function P2(o2) {
          o2.walk((h2) => {
            if (!h2.children)
              return;
            if (h2.children.length === 0 || h2.children.length === 1 && h2.children[0].type === "text" && s2(h2.children[0].value).length === 0) {
              h2.hasDanglingSpaces = h2.children.length > 0, h2.children = [];
              return;
            }
            let C2 = g2(h2), S2 = p2(h2);
            if (!C2)
              for (let x2 = 0; x2 < h2.children.length; x2++) {
                let T2 = h2.children[x2];
                if (T2.type !== "text")
                  continue;
                let { leadingWhitespace: k2, text: M2, trailingWhitespace: R2 } = a2(T2.value), q2 = T2.prev, U2 = T2.next;
                M2 ? (T2.value = M2, T2.sourceSpan = new t2(T2.sourceSpan.start.moveBy(k2.length), T2.sourceSpan.end.moveBy(-R2.length)), k2 && (q2 && (q2.hasTrailingSpaces = true), T2.hasLeadingSpaces = true), R2 && (T2.hasTrailingSpaces = true, U2 && (U2.hasLeadingSpaces = true))) : (h2.removeChild(T2), x2--, (k2 || R2) && (q2 && (q2.hasTrailingSpaces = true), U2 && (U2.hasLeadingSpaces = true)));
              }
            h2.isWhitespaceSensitive = C2, h2.isIndentationSensitive = S2;
          });
        }
        function H2(o2) {
          o2.walk((h2) => {
            h2.isSelfClosing = !h2.children || h2.type === "element" && (h2.tagDefinition.isVoid || h2.startSourceSpan === h2.endSourceSpan);
          });
        }
        function f2(o2, h2) {
          o2.walk((C2) => {
            C2.type === "element" && (C2.hasHtmComponentClosingTag = C2.endSourceSpan && /^<\s*\/\s*\/\s*>$/.test(h2.originalText.slice(C2.endSourceSpan.start.offset, C2.endSourceSpan.end.offset)));
          });
        }
        function b2(o2, h2) {
          o2.walk((C2) => {
            C2.cssDisplay = i2(C2, h2);
          });
        }
        function m2(o2, h2) {
          o2.walk((C2) => {
            let { children: S2 } = C2;
            if (S2) {
              if (S2.length === 0) {
                C2.isDanglingSpaceSensitive = l2(C2);
                return;
              }
              for (let x2 of S2)
                x2.isLeadingSpaceSensitive = d2(x2, h2), x2.isTrailingSpaceSensitive = y2(x2, h2);
              for (let x2 = 0; x2 < S2.length; x2++) {
                let T2 = S2[x2];
                T2.isLeadingSpaceSensitive = (x2 === 0 || T2.prev.isTrailingSpaceSensitive) && T2.isLeadingSpaceSensitive, T2.isTrailingSpaceSensitive = (x2 === S2.length - 1 || T2.next.isLeadingSpaceSensitive) && T2.isTrailingSpaceSensitive;
              }
            }
          });
        }
        function v2(o2, h2) {
          if (h2.parser === "vue") {
            let C2 = o2.children.find((x2) => c2(x2, h2));
            if (!C2)
              return;
            let { lang: S2 } = C2.attrMap;
            (S2 === "ts" || S2 === "typescript") && (h2.__should_parse_vue_template_with_ts = true);
          }
        }
        r2.exports = E2;
      } }), Sg2 = Z2({ "src/language-html/pragma.js"(e25, r2) {
        ne2();
        function t2(a2) {
          return /^\s*<!--\s*@(?:format|prettier)\s*-->/.test(a2);
        }
        function s2(a2) {
          return `<!-- @format -->

` + a2.replace(/^\s*\n/, "");
        }
        r2.exports = { hasPragma: t2, insertPragma: s2 };
      } }), au2 = Z2({ "src/language-html/loc.js"(e25, r2) {
        ne2();
        function t2(a2) {
          return a2.sourceSpan.start.offset;
        }
        function s2(a2) {
          return a2.sourceSpan.end.offset;
        }
        r2.exports = { locStart: t2, locEnd: s2 };
      } }), ur2 = Z2({ "src/language-html/print/tag.js"(e25, r2) {
        ne2();
        var t2 = Zt2(), { isNonEmptyArray: s2 } = Ue2(), { builders: { indent: a2, join: n2, line: u2, softline: i2, hardline: l2 }, utils: { replaceTextEndOfLine: p2 } } = Me2(), { locStart: d2, locEnd: y2 } = au2(), { isTextLikeNode: g2, getLastDescendant: c2, isPreLikeNode: D2, hasPrettierIgnore: E2, shouldPreserveContent: _2, isVueSfcBlock: w2 } = Rt2();
        function F2(L2, Y2) {
          return [L2.isSelfClosing ? "" : A2(L2, Y2), N2(L2, Y2)];
        }
        function A2(L2, Y2) {
          return L2.lastChild && o2(L2.lastChild) ? "" : [I2(L2, Y2), H2(L2, Y2)];
        }
        function N2(L2, Y2) {
          return (L2.next ? m2(L2.next) : v2(L2.parent)) ? "" : [f2(L2, Y2), P2(L2, Y2)];
        }
        function I2(L2, Y2) {
          return v2(L2) ? f2(L2.lastChild, Y2) : "";
        }
        function P2(L2, Y2) {
          return o2(L2) ? H2(L2.parent, Y2) : h2(L2) ? q2(L2.next) : "";
        }
        function H2(L2, Y2) {
          if (t2(!L2.isSelfClosing), b2(L2, Y2))
            return "";
          switch (L2.type) {
            case "ieConditionalComment":
              return "<!";
            case "element":
              if (L2.hasHtmComponentClosingTag)
                return "<//";
            default:
              return `</${L2.rawName}`;
          }
        }
        function f2(L2, Y2) {
          if (b2(L2, Y2))
            return "";
          switch (L2.type) {
            case "ieConditionalComment":
            case "ieConditionalEndComment":
              return "[endif]-->";
            case "ieConditionalStartComment":
              return "]><!-->";
            case "interpolation":
              return "}}";
            case "element":
              if (L2.isSelfClosing)
                return "/>";
            default:
              return ">";
          }
        }
        function b2(L2, Y2) {
          return !L2.isSelfClosing && !L2.endSourceSpan && (E2(L2) || _2(L2.parent, Y2));
        }
        function m2(L2) {
          return L2.prev && L2.prev.type !== "docType" && !g2(L2.prev) && L2.isLeadingSpaceSensitive && !L2.hasLeadingSpaces;
        }
        function v2(L2) {
          return L2.lastChild && L2.lastChild.isTrailingSpaceSensitive && !L2.lastChild.hasTrailingSpaces && !g2(c2(L2.lastChild)) && !D2(L2);
        }
        function o2(L2) {
          return !L2.next && !L2.hasTrailingSpaces && L2.isTrailingSpaceSensitive && g2(c2(L2));
        }
        function h2(L2) {
          return L2.next && !g2(L2.next) && g2(L2) && L2.isTrailingSpaceSensitive && !L2.hasTrailingSpaces;
        }
        function C2(L2) {
          let Y2 = L2.trim().match(/^prettier-ignore-attribute(?:\s+(.+))?$/s);
          return Y2 ? Y2[1] ? Y2[1].split(/\s+/) : true : false;
        }
        function S2(L2) {
          return !L2.prev && L2.isLeadingSpaceSensitive && !L2.hasLeadingSpaces;
        }
        function x2(L2, Y2, V2) {
          let j2 = L2.getValue();
          if (!s2(j2.attrs))
            return j2.isSelfClosing ? " " : "";
          let K2 = j2.prev && j2.prev.type === "comment" && C2(j2.prev.value), se2 = typeof K2 == "boolean" ? () => K2 : Array.isArray(K2) ? (ie2) => K2.includes(ie2.rawName) : () => false, Q2 = L2.map((ie2) => {
            let Ee2 = ie2.getValue();
            return se2(Ee2) ? p2(Y2.originalText.slice(d2(Ee2), y2(Ee2))) : V2();
          }, "attrs"), ce2 = j2.type === "element" && j2.fullName === "script" && j2.attrs.length === 1 && j2.attrs[0].fullName === "src" && j2.children.length === 0, X2 = Y2.singleAttributePerLine && j2.attrs.length > 1 && !w2(j2, Y2) ? l2 : u2, de2 = [a2([ce2 ? " " : u2, n2(X2, Q2)])];
          return j2.firstChild && S2(j2.firstChild) || j2.isSelfClosing && v2(j2.parent) || ce2 ? de2.push(j2.isSelfClosing ? " " : "") : de2.push(Y2.bracketSameLine ? j2.isSelfClosing ? " " : "" : j2.isSelfClosing ? u2 : i2), de2;
        }
        function T2(L2) {
          return L2.firstChild && S2(L2.firstChild) ? "" : U2(L2);
        }
        function k2(L2, Y2, V2) {
          let j2 = L2.getValue();
          return [M2(j2, Y2), x2(L2, Y2, V2), j2.isSelfClosing ? "" : T2(j2)];
        }
        function M2(L2, Y2) {
          return L2.prev && h2(L2.prev) ? "" : [R2(L2, Y2), q2(L2)];
        }
        function R2(L2, Y2) {
          return S2(L2) ? U2(L2.parent) : m2(L2) ? f2(L2.prev, Y2) : "";
        }
        function q2(L2) {
          switch (L2.type) {
            case "ieConditionalComment":
            case "ieConditionalStartComment":
              return `<!--[if ${L2.condition}`;
            case "ieConditionalEndComment":
              return "<!--<!";
            case "interpolation":
              return "{{";
            case "docType":
              return "<!DOCTYPE";
            case "element":
              if (L2.condition)
                return `<!--[if ${L2.condition}]><!--><${L2.rawName}`;
            default:
              return `<${L2.rawName}`;
          }
        }
        function U2(L2) {
          switch (t2(!L2.isSelfClosing), L2.type) {
            case "ieConditionalComment":
              return "]>";
            case "element":
              if (L2.condition)
                return "><!--<![endif]-->";
            default:
              return ">";
          }
        }
        r2.exports = { printClosingTag: F2, printClosingTagStart: A2, printClosingTagStartMarker: H2, printClosingTagEndMarker: f2, printClosingTagSuffix: P2, printClosingTagEnd: N2, needsToBorrowLastChildClosingTagEndMarker: v2, needsToBorrowParentClosingTagStartMarker: o2, needsToBorrowPrevClosingTagEndMarker: m2, printOpeningTag: k2, printOpeningTagStart: M2, printOpeningTagPrefix: R2, printOpeningTagStartMarker: q2, printOpeningTagEndMarker: U2, needsToBorrowNextOpeningTagStartMarker: h2, needsToBorrowParentOpeningTagEndMarker: S2 };
      } }), xg2 = Z2({ "node_modules/parse-srcset/src/parse-srcset.js"(e25, r2) {
        ne2(), function(t2, s2) {
          typeof r2 == "object" && r2.exports ? r2.exports = s2() : t2.parseSrcset = s2();
        }(e25, function() {
          return function(t2, s2) {
            var a2 = s2 && s2.logger || console;
            function n2(H2) {
              return H2 === " " || H2 === "	" || H2 === `
` || H2 === "\f" || H2 === "\r";
            }
            function u2(H2) {
              var f2, b2 = H2.exec(t2.substring(A2));
              if (b2)
                return f2 = b2[0], A2 += f2.length, f2;
            }
            for (var i2 = t2.length, l2 = /^[ \t\n\r\u000c]+/, p2 = /^[, \t\n\r\u000c]+/, d2 = /^[^ \t\n\r\u000c]+/, y2 = /[,]+$/, g2 = /^\d+$/, c2 = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, D2, E2, _2, w2, F2, A2 = 0, N2 = []; ; ) {
              if (u2(p2), A2 >= i2)
                return N2;
              D2 = u2(d2), E2 = [], D2.slice(-1) === "," ? (D2 = D2.replace(y2, ""), P2()) : I2();
            }
            function I2() {
              for (u2(l2), _2 = "", w2 = "in descriptor"; ; ) {
                if (F2 = t2.charAt(A2), w2 === "in descriptor")
                  if (n2(F2))
                    _2 && (E2.push(_2), _2 = "", w2 = "after descriptor");
                  else if (F2 === ",") {
                    A2 += 1, _2 && E2.push(_2), P2();
                    return;
                  } else if (F2 === "(")
                    _2 = _2 + F2, w2 = "in parens";
                  else if (F2 === "") {
                    _2 && E2.push(_2), P2();
                    return;
                  } else
                    _2 = _2 + F2;
                else if (w2 === "in parens")
                  if (F2 === ")")
                    _2 = _2 + F2, w2 = "in descriptor";
                  else if (F2 === "") {
                    E2.push(_2), P2();
                    return;
                  } else
                    _2 = _2 + F2;
                else if (w2 === "after descriptor" && !n2(F2))
                  if (F2 === "") {
                    P2();
                    return;
                  } else
                    w2 = "in descriptor", A2 -= 1;
                A2 += 1;
              }
            }
            function P2() {
              var H2 = false, f2, b2, m2, v2, o2 = {}, h2, C2, S2, x2, T2;
              for (v2 = 0; v2 < E2.length; v2++)
                h2 = E2[v2], C2 = h2[h2.length - 1], S2 = h2.substring(0, h2.length - 1), x2 = parseInt(S2, 10), T2 = parseFloat(S2), g2.test(S2) && C2 === "w" ? ((f2 || b2) && (H2 = true), x2 === 0 ? H2 = true : f2 = x2) : c2.test(S2) && C2 === "x" ? ((f2 || b2 || m2) && (H2 = true), T2 < 0 ? H2 = true : b2 = T2) : g2.test(S2) && C2 === "h" ? ((m2 || b2) && (H2 = true), x2 === 0 ? H2 = true : m2 = x2) : H2 = true;
              H2 ? a2 && a2.error && a2.error("Invalid srcset descriptor found in '" + t2 + "' at '" + h2 + "'.") : (o2.url = D2, f2 && (o2.w = f2), b2 && (o2.d = b2), m2 && (o2.h = m2), N2.push(o2));
            }
          };
        });
      } }), bg2 = Z2({ "src/language-html/syntax-attribute.js"(e25, r2) {
        ne2();
        var t2 = xg2(), { builders: { ifBreak: s2, join: a2, line: n2 } } = Me2();
        function u2(l2) {
          let p2 = t2(l2, { logger: { error(I2) {
            throw new Error(I2);
          } } }), d2 = p2.some((I2) => {
            let { w: P2 } = I2;
            return P2;
          }), y2 = p2.some((I2) => {
            let { h: P2 } = I2;
            return P2;
          }), g2 = p2.some((I2) => {
            let { d: P2 } = I2;
            return P2;
          });
          if (d2 + y2 + g2 > 1)
            throw new Error("Mixed descriptor in srcset is not supported");
          let c2 = d2 ? "w" : y2 ? "h" : "d", D2 = d2 ? "w" : y2 ? "h" : "x", E2 = (I2) => Math.max(...I2), _2 = p2.map((I2) => I2.url), w2 = E2(_2.map((I2) => I2.length)), F2 = p2.map((I2) => I2[c2]).map((I2) => I2 ? I2.toString() : ""), A2 = F2.map((I2) => {
            let P2 = I2.indexOf(".");
            return P2 === -1 ? I2.length : P2;
          }), N2 = E2(A2);
          return a2([",", n2], _2.map((I2, P2) => {
            let H2 = [I2], f2 = F2[P2];
            if (f2) {
              let b2 = w2 - I2.length + 1, m2 = N2 - A2[P2], v2 = " ".repeat(b2 + m2);
              H2.push(s2(v2, " "), f2 + D2);
            }
            return H2;
          }));
        }
        function i2(l2) {
          return l2.trim().split(/\s+/).join(" ");
        }
        r2.exports = { printImgSrcset: u2, printClassNames: i2 };
      } }), Tg2 = Z2({ "src/language-html/syntax-vue.js"(e25, r2) {
        ne2();
        var { builders: { group: t2 } } = Me2();
        function s2(i2, l2) {
          let { left: p2, operator: d2, right: y2 } = a2(i2);
          return [t2(l2(`function _(${p2}) {}`, { parser: "babel", __isVueForBindingLeft: true })), " ", d2, " ", l2(y2, { parser: "__js_expression" }, { stripTrailingHardline: true })];
        }
        function a2(i2) {
          let l2 = /(.*?)\s+(in|of)\s+(.*)/s, p2 = /,([^,\]}]*)(?:,([^,\]}]*))?$/, d2 = /^\(|\)$/g, y2 = i2.match(l2);
          if (!y2)
            return;
          let g2 = {};
          if (g2.for = y2[3].trim(), !g2.for)
            return;
          let c2 = y2[1].trim().replace(d2, ""), D2 = c2.match(p2);
          D2 ? (g2.alias = c2.replace(p2, ""), g2.iterator1 = D2[1].trim(), D2[2] && (g2.iterator2 = D2[2].trim())) : g2.alias = c2;
          let E2 = [g2.alias, g2.iterator1, g2.iterator2];
          if (!E2.some((_2, w2) => !_2 && (w2 === 0 || E2.slice(w2 + 1).some(Boolean))))
            return { left: E2.filter(Boolean).join(","), operator: y2[2], right: g2.for };
        }
        function n2(i2, l2) {
          return l2(`function _(${i2}) {}`, { parser: "babel", __isVueBindings: true });
        }
        function u2(i2) {
          let l2 = /^(?:[\w$]+|\([^)]*\))\s*=>|^function\s*\(/, p2 = /^[$A-Z_a-z][\w$]*(?:\.[$A-Z_a-z][\w$]*|\['[^']*']|\["[^"]*"]|\[\d+]|\[[$A-Z_a-z][\w$]*])*$/, d2 = i2.trim();
          return l2.test(d2) || p2.test(d2);
        }
        r2.exports = { isVueEventBindingExpression: u2, printVueFor: s2, printVueBindings: n2 };
      } }), Lo2 = Z2({ "src/language-html/get-node-content.js"(e25, r2) {
        ne2();
        var { needsToBorrowParentClosingTagStartMarker: t2, printClosingTagStartMarker: s2, needsToBorrowLastChildClosingTagEndMarker: a2, printClosingTagEndMarker: n2, needsToBorrowParentOpeningTagEndMarker: u2, printOpeningTagEndMarker: i2 } = ur2();
        function l2(p2, d2) {
          let y2 = p2.startSourceSpan.end.offset;
          p2.firstChild && u2(p2.firstChild) && (y2 -= i2(p2).length);
          let g2 = p2.endSourceSpan.start.offset;
          return p2.lastChild && t2(p2.lastChild) ? g2 += s2(p2, d2).length : a2(p2) && (g2 -= n2(p2.lastChild, d2).length), d2.originalText.slice(y2, g2);
        }
        r2.exports = l2;
      } }), Bg2 = Z2({ "src/language-html/embed.js"(e25, r2) {
        ne2();
        var { builders: { breakParent: t2, group: s2, hardline: a2, indent: n2, line: u2, fill: i2, softline: l2 }, utils: { mapDoc: p2, replaceTextEndOfLine: d2 } } = Me2(), y2 = su2(), { printClosingTag: g2, printClosingTagSuffix: c2, needsToBorrowPrevClosingTagEndMarker: D2, printOpeningTagPrefix: E2, printOpeningTag: _2 } = ur2(), { printImgSrcset: w2, printClassNames: F2 } = bg2(), { printVueFor: A2, printVueBindings: N2, isVueEventBindingExpression: I2 } = Tg2(), { isScriptLikeTag: P2, isVueNonHtmlBlock: H2, inferScriptParser: f2, htmlTrimPreserveIndentation: b2, dedentString: m2, unescapeQuoteEntities: v2, isVueSlotAttribute: o2, isVueSfcBindingsAttribute: h2, getTextValueParts: C2 } = Rt2(), S2 = Lo2();
        function x2(k2, M2, R2) {
          let q2 = (Q2) => new RegExp(Q2.join("|")).test(k2.fullName), U2 = () => v2(k2.value), L2 = false, Y2 = (Q2, ce2) => {
            let W2 = Q2.type === "NGRoot" ? Q2.node.type === "NGMicrosyntax" && Q2.node.body.length === 1 && Q2.node.body[0].type === "NGMicrosyntaxExpression" ? Q2.node.body[0].expression : Q2.node : Q2.type === "JsExpressionRoot" ? Q2.node : Q2;
            W2 && (W2.type === "ObjectExpression" || W2.type === "ArrayExpression" || ce2.parser === "__vue_expression" && (W2.type === "TemplateLiteral" || W2.type === "StringLiteral")) && (L2 = true);
          }, V2 = (Q2) => s2(Q2), j2 = function(Q2) {
            let ce2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            return s2([n2([l2, Q2]), ce2 ? l2 : ""]);
          }, K2 = (Q2) => L2 ? V2(Q2) : j2(Q2), se2 = (Q2, ce2) => M2(Q2, Object.assign({ __onHtmlBindingRoot: Y2, __embeddedInHtml: true }, ce2));
          if (k2.fullName === "srcset" && (k2.parent.fullName === "img" || k2.parent.fullName === "source"))
            return j2(w2(U2()));
          if (k2.fullName === "class" && !R2.parentParser) {
            let Q2 = U2();
            if (!Q2.includes("{{"))
              return F2(Q2);
          }
          if (k2.fullName === "style" && !R2.parentParser) {
            let Q2 = U2();
            if (!Q2.includes("{{"))
              return j2(se2(Q2, { parser: "css", __isHTMLStyleAttribute: true }));
          }
          if (R2.parser === "vue") {
            if (k2.fullName === "v-for")
              return A2(U2(), se2);
            if (o2(k2) || h2(k2, R2))
              return N2(U2(), se2);
            let Q2 = ["^@", "^v-on:"], ce2 = ["^:", "^v-bind:"], W2 = ["^v-"];
            if (q2(Q2)) {
              let X2 = U2(), de2 = I2(X2) ? "__js_expression" : R2.__should_parse_vue_template_with_ts ? "__vue_ts_event_binding" : "__vue_event_binding";
              return K2(se2(X2, { parser: de2 }));
            }
            if (q2(ce2))
              return K2(se2(U2(), { parser: "__vue_expression" }));
            if (q2(W2))
              return K2(se2(U2(), { parser: "__js_expression" }));
          }
          if (R2.parser === "angular") {
            let Q2 = (z2, ue2) => se2(z2, Object.assign(Object.assign({}, ue2), {}, { trailingComma: "none" })), ce2 = ["^\\*"], W2 = ["^\\(.+\\)$", "^on-"], X2 = ["^\\[.+\\]$", "^bind(on)?-", "^ng-(if|show|hide|class|style)$"], de2 = ["^i18n(-.+)?$"];
            if (q2(W2))
              return K2(Q2(U2(), { parser: "__ng_action" }));
            if (q2(X2))
              return K2(Q2(U2(), { parser: "__ng_binding" }));
            if (q2(de2)) {
              let z2 = U2().trim();
              return j2(i2(C2(k2, z2)), !z2.includes("@@"));
            }
            if (q2(ce2))
              return K2(Q2(U2(), { parser: "__ng_directive" }));
            let ie2 = /{{(.+?)}}/s, Ee2 = U2();
            if (ie2.test(Ee2)) {
              let z2 = [];
              for (let [ue2, J2] of Ee2.split(ie2).entries())
                if (ue2 % 2 === 0)
                  z2.push(d2(J2));
                else
                  try {
                    z2.push(s2(["{{", n2([u2, Q2(J2, { parser: "__ng_interpolation", __isInHtmlInterpolation: true })]), u2, "}}"]));
                  } catch {
                    z2.push("{{", d2(J2), "}}");
                  }
              return s2(z2);
            }
          }
          return null;
        }
        function T2(k2, M2, R2, q2) {
          let U2 = k2.getValue();
          switch (U2.type) {
            case "element": {
              if (P2(U2) || U2.type === "interpolation")
                return;
              if (!U2.isSelfClosing && H2(U2, q2)) {
                let L2 = f2(U2, q2);
                if (!L2)
                  return;
                let Y2 = S2(U2, q2), V2 = /^\s*$/.test(Y2), j2 = "";
                return V2 || (j2 = R2(b2(Y2), { parser: L2, __embeddedInHtml: true }, { stripTrailingHardline: true }), V2 = j2 === ""), [E2(U2, q2), s2(_2(k2, q2, M2)), V2 ? "" : a2, j2, V2 ? "" : a2, g2(U2, q2), c2(U2, q2)];
              }
              break;
            }
            case "text": {
              if (P2(U2.parent)) {
                let L2 = f2(U2.parent, q2);
                if (L2) {
                  let Y2 = L2 === "markdown" ? m2(U2.value.replace(/^[^\S\n]*\n/, "")) : U2.value, V2 = { parser: L2, __embeddedInHtml: true };
                  if (q2.parser === "html" && L2 === "babel") {
                    let j2 = "script", { attrMap: K2 } = U2.parent;
                    K2 && (K2.type === "module" || K2.type === "text/babel" && K2["data-type"] === "module") && (j2 = "module"), V2.__babelSourceType = j2;
                  }
                  return [t2, E2(U2, q2), R2(Y2, V2, { stripTrailingHardline: true }), c2(U2, q2)];
                }
              } else if (U2.parent.type === "interpolation") {
                let L2 = { __isInHtmlInterpolation: true, __embeddedInHtml: true };
                return q2.parser === "angular" ? (L2.parser = "__ng_interpolation", L2.trailingComma = "none") : q2.parser === "vue" ? L2.parser = q2.__should_parse_vue_template_with_ts ? "__vue_ts_expression" : "__vue_expression" : L2.parser = "__js_expression", [n2([u2, R2(U2.value, L2, { stripTrailingHardline: true })]), U2.parent.next && D2(U2.parent.next) ? " " : u2];
              }
              break;
            }
            case "attribute": {
              if (!U2.value)
                break;
              if (/^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(q2.originalText.slice(U2.valueSpan.start.offset, U2.valueSpan.end.offset)))
                return [U2.rawName, "=", U2.value];
              if (q2.parser === "lwc" && /^{.*}$/s.test(q2.originalText.slice(U2.valueSpan.start.offset, U2.valueSpan.end.offset)))
                return [U2.rawName, "=", U2.value];
              let L2 = x2(U2, (Y2, V2) => R2(Y2, Object.assign({ __isInHtmlAttribute: true, __embeddedInHtml: true }, V2), { stripTrailingHardline: true }), q2);
              if (L2)
                return [U2.rawName, '="', s2(p2(L2, (Y2) => typeof Y2 == "string" ? Y2.replace(/"/g, "&quot;") : Y2)), '"'];
              break;
            }
            case "front-matter":
              return y2(U2, R2);
          }
        }
        r2.exports = T2;
      } }), Oo2 = Z2({ "src/language-html/print/children.js"(e25, r2) {
        ne2();
        var { builders: { breakParent: t2, group: s2, ifBreak: a2, line: n2, softline: u2, hardline: i2 }, utils: { replaceTextEndOfLine: l2 } } = Me2(), { locStart: p2, locEnd: d2 } = au2(), { forceBreakChildren: y2, forceNextEmptyLine: g2, isTextLikeNode: c2, hasPrettierIgnore: D2, preferHardlineAsLeadingSpaces: E2 } = Rt2(), { printOpeningTagPrefix: _2, needsToBorrowNextOpeningTagStartMarker: w2, printOpeningTagStartMarker: F2, needsToBorrowPrevClosingTagEndMarker: A2, printClosingTagEndMarker: N2, printClosingTagSuffix: I2, needsToBorrowParentClosingTagStartMarker: P2 } = ur2();
        function H2(m2, v2, o2) {
          let h2 = m2.getValue();
          return D2(h2) ? [_2(h2, v2), ...l2(v2.originalText.slice(p2(h2) + (h2.prev && w2(h2.prev) ? F2(h2).length : 0), d2(h2) - (h2.next && A2(h2.next) ? N2(h2, v2).length : 0))), I2(h2, v2)] : o2();
        }
        function f2(m2, v2) {
          return c2(m2) && c2(v2) ? m2.isTrailingSpaceSensitive ? m2.hasTrailingSpaces ? E2(v2) ? i2 : n2 : "" : E2(v2) ? i2 : u2 : w2(m2) && (D2(v2) || v2.firstChild || v2.isSelfClosing || v2.type === "element" && v2.attrs.length > 0) || m2.type === "element" && m2.isSelfClosing && A2(v2) ? "" : !v2.isLeadingSpaceSensitive || E2(v2) || A2(v2) && m2.lastChild && P2(m2.lastChild) && m2.lastChild.lastChild && P2(m2.lastChild.lastChild) ? i2 : v2.hasLeadingSpaces ? n2 : u2;
        }
        function b2(m2, v2, o2) {
          let h2 = m2.getValue();
          if (y2(h2))
            return [t2, ...m2.map((S2) => {
              let x2 = S2.getValue(), T2 = x2.prev ? f2(x2.prev, x2) : "";
              return [T2 ? [T2, g2(x2.prev) ? i2 : ""] : "", H2(S2, v2, o2)];
            }, "children")];
          let C2 = h2.children.map(() => Symbol(""));
          return m2.map((S2, x2) => {
            let T2 = S2.getValue();
            if (c2(T2)) {
              if (T2.prev && c2(T2.prev)) {
                let Y2 = f2(T2.prev, T2);
                if (Y2)
                  return g2(T2.prev) ? [i2, i2, H2(S2, v2, o2)] : [Y2, H2(S2, v2, o2)];
              }
              return H2(S2, v2, o2);
            }
            let k2 = [], M2 = [], R2 = [], q2 = [], U2 = T2.prev ? f2(T2.prev, T2) : "", L2 = T2.next ? f2(T2, T2.next) : "";
            return U2 && (g2(T2.prev) ? k2.push(i2, i2) : U2 === i2 ? k2.push(i2) : c2(T2.prev) ? M2.push(U2) : M2.push(a2("", u2, { groupId: C2[x2 - 1] }))), L2 && (g2(T2) ? c2(T2.next) && q2.push(i2, i2) : L2 === i2 ? c2(T2.next) && q2.push(i2) : R2.push(L2)), [...k2, s2([...M2, s2([H2(S2, v2, o2), ...R2], { id: C2[x2] })]), ...q2];
          }, "children");
        }
        r2.exports = { printChildren: b2 };
      } }), Ng2 = Z2({ "src/language-html/print/element.js"(e25, r2) {
        ne2();
        var { builders: { breakParent: t2, dedentToRoot: s2, group: a2, ifBreak: n2, indentIfBreak: u2, indent: i2, line: l2, softline: p2 }, utils: { replaceTextEndOfLine: d2 } } = Me2(), y2 = Lo2(), { shouldPreserveContent: g2, isScriptLikeTag: c2, isVueCustomBlock: D2, countParents: E2, forceBreakContent: _2 } = Rt2(), { printOpeningTagPrefix: w2, printOpeningTag: F2, printClosingTagSuffix: A2, printClosingTag: N2, needsToBorrowPrevClosingTagEndMarker: I2, needsToBorrowLastChildClosingTagEndMarker: P2 } = ur2(), { printChildren: H2 } = Oo2();
        function f2(b2, m2, v2) {
          let o2 = b2.getValue();
          if (g2(o2, m2))
            return [w2(o2, m2), a2(F2(b2, m2, v2)), ...d2(y2(o2, m2)), ...N2(o2, m2), A2(o2, m2)];
          let h2 = o2.children.length === 1 && o2.firstChild.type === "interpolation" && o2.firstChild.isLeadingSpaceSensitive && !o2.firstChild.hasLeadingSpaces && o2.lastChild.isTrailingSpaceSensitive && !o2.lastChild.hasTrailingSpaces, C2 = Symbol("element-attr-group-id"), S2 = (M2) => a2([a2(F2(b2, m2, v2), { id: C2 }), M2, N2(o2, m2)]), x2 = (M2) => h2 ? u2(M2, { groupId: C2 }) : (c2(o2) || D2(o2, m2)) && o2.parent.type === "root" && m2.parser === "vue" && !m2.vueIndentScriptAndStyle ? M2 : i2(M2), T2 = () => h2 ? n2(p2, "", { groupId: C2 }) : o2.firstChild.hasLeadingSpaces && o2.firstChild.isLeadingSpaceSensitive ? l2 : o2.firstChild.type === "text" && o2.isWhitespaceSensitive && o2.isIndentationSensitive ? s2(p2) : p2, k2 = () => (o2.next ? I2(o2.next) : P2(o2.parent)) ? o2.lastChild.hasTrailingSpaces && o2.lastChild.isTrailingSpaceSensitive ? " " : "" : h2 ? n2(p2, "", { groupId: C2 }) : o2.lastChild.hasTrailingSpaces && o2.lastChild.isTrailingSpaceSensitive ? l2 : (o2.lastChild.type === "comment" || o2.lastChild.type === "text" && o2.isWhitespaceSensitive && o2.isIndentationSensitive) && new RegExp(`\\n[\\t ]{${m2.tabWidth * E2(b2, (R2) => R2.parent && R2.parent.type !== "root")}}$`).test(o2.lastChild.value) ? "" : p2;
          return o2.children.length === 0 ? S2(o2.hasDanglingSpaces && o2.isDanglingSpaceSensitive ? l2 : "") : S2([_2(o2) ? t2 : "", x2([T2(), H2(b2, m2, v2)]), k2()]);
        }
        r2.exports = { printElement: f2 };
      } }), wg2 = Z2({ "src/language-html/printer-html.js"(e25, r2) {
        ne2();
        var { builders: { fill: t2, group: s2, hardline: a2, literalline: n2 }, utils: { cleanDoc: u2, getDocParts: i2, isConcat: l2, replaceTextEndOfLine: p2 } } = Me2(), d2 = dg2(), { countChars: y2, unescapeQuoteEntities: g2, getTextValueParts: c2 } = Rt2(), D2 = Ag2(), { insertPragma: E2 } = Sg2(), { locStart: _2, locEnd: w2 } = au2(), F2 = Bg2(), { printClosingTagSuffix: A2, printClosingTagEnd: N2, printOpeningTagPrefix: I2, printOpeningTagStart: P2 } = ur2(), { printElement: H2 } = Ng2(), { printChildren: f2 } = Oo2();
        function b2(m2, v2, o2) {
          let h2 = m2.getValue();
          switch (h2.type) {
            case "front-matter":
              return p2(h2.raw);
            case "root":
              return v2.__onHtmlRoot && v2.__onHtmlRoot(h2), [s2(f2(m2, v2, o2)), a2];
            case "element":
            case "ieConditionalComment":
              return H2(m2, v2, o2);
            case "ieConditionalStartComment":
            case "ieConditionalEndComment":
              return [P2(h2), N2(h2)];
            case "interpolation":
              return [P2(h2, v2), ...m2.map(o2, "children"), N2(h2, v2)];
            case "text": {
              if (h2.parent.type === "interpolation") {
                let S2 = /\n[^\S\n]*$/, x2 = S2.test(h2.value), T2 = x2 ? h2.value.replace(S2, "") : h2.value;
                return [...p2(T2), x2 ? a2 : ""];
              }
              let C2 = u2([I2(h2, v2), ...c2(h2), A2(h2, v2)]);
              return l2(C2) || C2.type === "fill" ? t2(i2(C2)) : C2;
            }
            case "docType":
              return [s2([P2(h2, v2), " ", h2.value.replace(/^html\b/i, "html").replace(/\s+/g, " ")]), N2(h2, v2)];
            case "comment":
              return [I2(h2, v2), ...p2(v2.originalText.slice(_2(h2), w2(h2)), n2), A2(h2, v2)];
            case "attribute": {
              if (h2.value === null)
                return h2.rawName;
              let C2 = g2(h2.value), S2 = y2(C2, "'"), x2 = y2(C2, '"'), T2 = S2 < x2 ? "'" : '"';
              return [h2.rawName, "=", T2, ...p2(T2 === '"' ? C2.replace(/"/g, "&quot;") : C2.replace(/'/g, "&apos;")), T2];
            }
            default:
              throw new Error(`Unexpected node type ${h2.type}`);
          }
        }
        r2.exports = { preprocess: D2, print: b2, insertPragma: E2, massageAstNode: d2, embed: F2 };
      } }), _g2 = Z2({ "src/language-html/options.js"(e25, r2) {
        ne2();
        var t2 = Mt2(), s2 = "HTML";
        r2.exports = { bracketSameLine: t2.bracketSameLine, htmlWhitespaceSensitivity: { since: "1.15.0", category: s2, type: "choice", default: "css", description: "How to handle whitespaces in HTML.", choices: [{ value: "css", description: "Respect the default value of CSS display property." }, { value: "strict", description: "Whitespaces are considered sensitive." }, { value: "ignore", description: "Whitespaces are considered insensitive." }] }, singleAttributePerLine: t2.singleAttributePerLine, vueIndentScriptAndStyle: { since: "1.19.0", category: s2, type: "boolean", default: false, description: "Indent script and style tags in Vue files." } };
      } }), Pg2 = Z2({ "src/language-html/parsers.js"() {
        ne2();
      } }), On2 = Z2({ "node_modules/linguist-languages/data/HTML.json"(e25, r2) {
        r2.exports = { name: "HTML", type: "markup", tmScope: "text.html.basic", aceMode: "html", codemirrorMode: "htmlmixed", codemirrorMimeType: "text/html", color: "#e34c26", aliases: ["xhtml"], extensions: [".html", ".hta", ".htm", ".html.hl", ".inc", ".xht", ".xhtml"], languageId: 146 };
      } }), Ig2 = Z2({ "node_modules/linguist-languages/data/Vue.json"(e25, r2) {
        r2.exports = { name: "Vue", type: "markup", color: "#41b883", extensions: [".vue"], tmScope: "text.html.vue", aceMode: "html", languageId: 391 };
      } }), kg2 = Z2({ "src/language-html/index.js"(e25, r2) {
        ne2();
        var t2 = _t2(), s2 = wg2(), a2 = _g2(), n2 = Pg2(), u2 = [t2(On2(), () => ({ name: "Angular", since: "1.15.0", parsers: ["angular"], vscodeLanguageIds: ["html"], extensions: [".component.html"], filenames: [] })), t2(On2(), (l2) => ({ since: "1.15.0", parsers: ["html"], vscodeLanguageIds: ["html"], extensions: [...l2.extensions, ".mjml"] })), t2(On2(), () => ({ name: "Lightning Web Components", since: "1.17.0", parsers: ["lwc"], vscodeLanguageIds: ["html"], extensions: [], filenames: [] })), t2(Ig2(), () => ({ since: "1.10.0", parsers: ["vue"], vscodeLanguageIds: ["vue"] }))], i2 = { html: s2 };
        r2.exports = { languages: u2, printers: i2, options: a2, parsers: n2 };
      } }), Lg2 = Z2({ "src/language-yaml/pragma.js"(e25, r2) {
        ne2();
        function t2(n2) {
          return /^\s*@(?:prettier|format)\s*$/.test(n2);
        }
        function s2(n2) {
          return /^\s*#[^\S\n]*@(?:prettier|format)\s*?(?:\n|$)/.test(n2);
        }
        function a2(n2) {
          return `# @format

${n2}`;
        }
        r2.exports = { isPragma: t2, hasPragma: s2, insertPragma: a2 };
      } }), Og2 = Z2({ "src/language-yaml/loc.js"(e25, r2) {
        ne2();
        function t2(a2) {
          return a2.position.start.offset;
        }
        function s2(a2) {
          return a2.position.end.offset;
        }
        r2.exports = { locStart: t2, locEnd: s2 };
      } }), jg2 = Z2({ "src/language-yaml/embed.js"(e25, r2) {
        ne2();
        function t2(s2, a2, n2, u2) {
          if (s2.getValue().type === "root" && u2.filepath && /(?:[/\\]|^)\.(?:prettier|stylelint|lintstaged)rc$/.test(u2.filepath))
            return n2(u2.originalText, Object.assign(Object.assign({}, u2), {}, { parser: "json" }));
        }
        r2.exports = t2;
      } }), $t2 = Z2({ "src/language-yaml/utils.js"(e25, r2) {
        ne2();
        var { getLast: t2, isNonEmptyArray: s2 } = Ue2();
        function a2(f2, b2) {
          let m2 = 0, v2 = f2.stack.length - 1;
          for (let o2 = 0; o2 < v2; o2++) {
            let h2 = f2.stack[o2];
            n2(h2) && b2(h2) && m2++;
          }
          return m2;
        }
        function n2(f2, b2) {
          return f2 && typeof f2.type == "string" && (!b2 || b2.includes(f2.type));
        }
        function u2(f2, b2, m2) {
          return b2("children" in f2 ? Object.assign(Object.assign({}, f2), {}, { children: f2.children.map((v2) => u2(v2, b2, f2)) }) : f2, m2);
        }
        function i2(f2, b2, m2) {
          Object.defineProperty(f2, b2, { get: m2, enumerable: false });
        }
        function l2(f2, b2) {
          let m2 = 0, v2 = b2.length;
          for (let o2 = f2.position.end.offset - 1; o2 < v2; o2++) {
            let h2 = b2[o2];
            if (h2 === `
` && m2++, m2 === 1 && /\S/.test(h2))
              return false;
            if (m2 === 2)
              return true;
          }
          return false;
        }
        function p2(f2) {
          switch (f2.getValue().type) {
            case "tag":
            case "anchor":
            case "comment":
              return false;
          }
          let m2 = f2.stack.length;
          for (let v2 = 1; v2 < m2; v2++) {
            let o2 = f2.stack[v2], h2 = f2.stack[v2 - 1];
            if (Array.isArray(h2) && typeof o2 == "number" && o2 !== h2.length - 1)
              return false;
          }
          return true;
        }
        function d2(f2) {
          return s2(f2.children) ? d2(t2(f2.children)) : f2;
        }
        function y2(f2) {
          return f2.value.trim() === "prettier-ignore";
        }
        function g2(f2) {
          let b2 = f2.getValue();
          if (b2.type === "documentBody") {
            let m2 = f2.getParentNode();
            return A2(m2.head) && y2(t2(m2.head.endComments));
          }
          return E2(b2) && y2(t2(b2.leadingComments));
        }
        function c2(f2) {
          return !s2(f2.children) && !D2(f2);
        }
        function D2(f2) {
          return E2(f2) || _2(f2) || w2(f2) || F2(f2) || A2(f2);
        }
        function E2(f2) {
          return s2(f2 == null ? void 0 : f2.leadingComments);
        }
        function _2(f2) {
          return s2(f2 == null ? void 0 : f2.middleComments);
        }
        function w2(f2) {
          return f2 == null ? void 0 : f2.indicatorComment;
        }
        function F2(f2) {
          return f2 == null ? void 0 : f2.trailingComment;
        }
        function A2(f2) {
          return s2(f2 == null ? void 0 : f2.endComments);
        }
        function N2(f2) {
          let b2 = [], m2;
          for (let v2 of f2.split(/( +)/))
            v2 !== " " ? m2 === " " ? b2.push(v2) : b2.push((b2.pop() || "") + v2) : m2 === void 0 && b2.unshift(""), m2 = v2;
          return m2 === " " && b2.push((b2.pop() || "") + " "), b2[0] === "" && (b2.shift(), b2.unshift(" " + (b2.shift() || ""))), b2;
        }
        function I2(f2, b2, m2) {
          let v2 = b2.split(`
`).map((o2, h2, C2) => h2 === 0 && h2 === C2.length - 1 ? o2 : h2 !== 0 && h2 !== C2.length - 1 ? o2.trim() : h2 === 0 ? o2.trimEnd() : o2.trimStart());
          return m2.proseWrap === "preserve" ? v2.map((o2) => o2.length === 0 ? [] : [o2]) : v2.map((o2) => o2.length === 0 ? [] : N2(o2)).reduce((o2, h2, C2) => C2 !== 0 && v2[C2 - 1].length > 0 && h2.length > 0 && !(f2 === "quoteDouble" && t2(t2(o2)).endsWith("\\")) ? [...o2.slice(0, -1), [...t2(o2), ...h2]] : [...o2, h2], []).map((o2) => m2.proseWrap === "never" ? [o2.join(" ")] : o2);
        }
        function P2(f2, b2) {
          let { parentIndent: m2, isLastDescendant: v2, options: o2 } = b2, h2 = f2.position.start.line === f2.position.end.line ? "" : o2.originalText.slice(f2.position.start.offset, f2.position.end.offset).match(/^[^\n]*\n(.*)$/s)[1], C2;
          if (f2.indent === null) {
            let T2 = h2.match(/^(?<leadingSpace> *)[^\n\r ]/m);
            C2 = T2 ? T2.groups.leadingSpace.length : Number.POSITIVE_INFINITY;
          } else
            C2 = f2.indent - 1 + m2;
          let S2 = h2.split(`
`).map((T2) => T2.slice(C2));
          if (o2.proseWrap === "preserve" || f2.type === "blockLiteral")
            return x2(S2.map((T2) => T2.length === 0 ? [] : [T2]));
          return x2(S2.map((T2) => T2.length === 0 ? [] : N2(T2)).reduce((T2, k2, M2) => M2 !== 0 && S2[M2 - 1].length > 0 && k2.length > 0 && !/^\s/.test(k2[0]) && !/^\s|\s$/.test(t2(T2)) ? [...T2.slice(0, -1), [...t2(T2), ...k2]] : [...T2, k2], []).map((T2) => T2.reduce((k2, M2) => k2.length > 0 && /\s$/.test(t2(k2)) ? [...k2.slice(0, -1), t2(k2) + " " + M2] : [...k2, M2], [])).map((T2) => o2.proseWrap === "never" ? [T2.join(" ")] : T2));
          function x2(T2) {
            if (f2.chomping === "keep")
              return t2(T2).length === 0 ? T2.slice(0, -1) : T2;
            let k2 = 0;
            for (let M2 = T2.length - 1; M2 >= 0 && T2[M2].length === 0; M2--)
              k2++;
            return k2 === 0 ? T2 : k2 >= 2 && !v2 ? T2.slice(0, -(k2 - 1)) : T2.slice(0, -k2);
          }
        }
        function H2(f2) {
          if (!f2)
            return true;
          switch (f2.type) {
            case "plain":
            case "quoteDouble":
            case "quoteSingle":
            case "alias":
            case "flowMapping":
            case "flowSequence":
              return true;
            default:
              return false;
          }
        }
        r2.exports = { getLast: t2, getAncestorCount: a2, isNode: n2, isEmptyNode: c2, isInlineNode: H2, mapNode: u2, defineShortcut: i2, isNextLineEmpty: l2, isLastDescendantNode: p2, getBlockValueLineContents: P2, getFlowScalarLineContents: I2, getLastDescendantNode: d2, hasPrettierIgnore: g2, hasLeadingComments: E2, hasMiddleComments: _2, hasIndicatorComment: w2, hasTrailingComment: F2, hasEndComments: A2 };
      } }), qg2 = Z2({ "src/language-yaml/print-preprocess.js"(e25, r2) {
        ne2();
        var { defineShortcut: t2, mapNode: s2 } = $t2();
        function a2(u2) {
          return s2(u2, n2);
        }
        function n2(u2) {
          switch (u2.type) {
            case "document":
              t2(u2, "head", () => u2.children[0]), t2(u2, "body", () => u2.children[1]);
              break;
            case "documentBody":
            case "sequenceItem":
            case "flowSequenceItem":
            case "mappingKey":
            case "mappingValue":
              t2(u2, "content", () => u2.children[0]);
              break;
            case "mappingItem":
            case "flowMappingItem":
              t2(u2, "key", () => u2.children[0]), t2(u2, "value", () => u2.children[1]);
              break;
          }
          return u2;
        }
        r2.exports = a2;
      } }), Mr2 = Z2({ "src/language-yaml/print/misc.js"(e25, r2) {
        ne2();
        var { builders: { softline: t2, align: s2 } } = Me2(), { hasEndComments: a2, isNextLineEmpty: n2, isNode: u2 } = $t2(), i2 = new WeakMap();
        function l2(y2, g2) {
          let c2 = y2.getValue(), D2 = y2.stack[0], E2;
          return i2.has(D2) ? E2 = i2.get(D2) : (E2 = new Set(), i2.set(D2, E2)), !E2.has(c2.position.end.line) && (E2.add(c2.position.end.line), n2(c2, g2) && !p2(y2.getParentNode())) ? t2 : "";
        }
        function p2(y2) {
          return a2(y2) && !u2(y2, ["documentHead", "documentBody", "flowMapping", "flowSequence"]);
        }
        function d2(y2, g2) {
          return s2(" ".repeat(y2), g2);
        }
        r2.exports = { alignWithSpaces: d2, shouldPrintEndComments: p2, printNextEmptyLine: l2 };
      } }), Mg2 = Z2({ "src/language-yaml/print/flow-mapping-sequence.js"(e25, r2) {
        ne2();
        var { builders: { ifBreak: t2, line: s2, softline: a2, hardline: n2, join: u2 } } = Me2(), { isEmptyNode: i2, getLast: l2, hasEndComments: p2 } = $t2(), { printNextEmptyLine: d2, alignWithSpaces: y2 } = Mr2();
        function g2(D2, E2, _2) {
          let w2 = D2.getValue(), F2 = w2.type === "flowMapping", A2 = F2 ? "{" : "[", N2 = F2 ? "}" : "]", I2 = a2;
          F2 && w2.children.length > 0 && _2.bracketSpacing && (I2 = s2);
          let P2 = l2(w2.children), H2 = P2 && P2.type === "flowMappingItem" && i2(P2.key) && i2(P2.value);
          return [A2, y2(_2.tabWidth, [I2, c2(D2, E2, _2), _2.trailingComma === "none" ? "" : t2(","), p2(w2) ? [n2, u2(n2, D2.map(E2, "endComments"))] : ""]), H2 ? "" : I2, N2];
        }
        function c2(D2, E2, _2) {
          let w2 = D2.getValue();
          return D2.map((A2, N2) => [E2(), N2 === w2.children.length - 1 ? "" : [",", s2, w2.children[N2].position.start.line !== w2.children[N2 + 1].position.start.line ? d2(A2, _2.originalText) : ""]], "children");
        }
        r2.exports = { printFlowMapping: g2, printFlowSequence: g2 };
      } }), Rg2 = Z2({ "src/language-yaml/print/mapping-item.js"(e25, r2) {
        ne2();
        var { builders: { conditionalGroup: t2, group: s2, hardline: a2, ifBreak: n2, join: u2, line: i2 } } = Me2(), { hasLeadingComments: l2, hasMiddleComments: p2, hasTrailingComment: d2, hasEndComments: y2, isNode: g2, isEmptyNode: c2, isInlineNode: D2 } = $t2(), { alignWithSpaces: E2 } = Mr2();
        function _2(N2, I2, P2, H2, f2) {
          let { key: b2, value: m2 } = N2, v2 = c2(b2), o2 = c2(m2);
          if (v2 && o2)
            return ": ";
          let h2 = H2("key"), C2 = F2(N2) ? " " : "";
          if (o2)
            return N2.type === "flowMappingItem" && I2.type === "flowMapping" ? h2 : N2.type === "mappingItem" && w2(b2.content, f2) && !d2(b2.content) && (!I2.tag || I2.tag.value !== "tag:yaml.org,2002:set") ? [h2, C2, ":"] : ["? ", E2(2, h2)];
          let S2 = H2("value");
          if (v2)
            return [": ", E2(2, S2)];
          if (l2(m2) || !D2(b2.content))
            return ["? ", E2(2, h2), a2, u2("", P2.map(H2, "value", "leadingComments").map((q2) => [q2, a2])), ": ", E2(2, S2)];
          if (A2(b2.content) && !l2(b2.content) && !p2(b2.content) && !d2(b2.content) && !y2(b2) && !l2(m2.content) && !p2(m2.content) && !y2(m2) && w2(m2.content, f2))
            return [h2, C2, ": ", S2];
          let x2 = Symbol("mappingKey"), T2 = s2([n2("? "), s2(E2(2, h2), { id: x2 })]), k2 = [a2, ": ", E2(2, S2)], M2 = [C2, ":"];
          l2(m2.content) || y2(m2) && m2.content && !g2(m2.content, ["mapping", "sequence"]) || I2.type === "mapping" && d2(b2.content) && D2(m2.content) || g2(m2.content, ["mapping", "sequence"]) && m2.content.tag === null && m2.content.anchor === null ? M2.push(a2) : m2.content && M2.push(i2), M2.push(S2);
          let R2 = E2(f2.tabWidth, M2);
          return w2(b2.content, f2) && !l2(b2.content) && !p2(b2.content) && !y2(b2) ? t2([[h2, R2]]) : t2([[T2, n2(k2, R2, { groupId: x2 })]]);
        }
        function w2(N2, I2) {
          if (!N2)
            return true;
          switch (N2.type) {
            case "plain":
            case "quoteSingle":
            case "quoteDouble":
              break;
            case "alias":
              return true;
            default:
              return false;
          }
          if (I2.proseWrap === "preserve")
            return N2.position.start.line === N2.position.end.line;
          if (/\\$/m.test(I2.originalText.slice(N2.position.start.offset, N2.position.end.offset)))
            return false;
          switch (I2.proseWrap) {
            case "never":
              return !N2.value.includes(`
`);
            case "always":
              return !/[\n ]/.test(N2.value);
            default:
              return false;
          }
        }
        function F2(N2) {
          return N2.key.content && N2.key.content.type === "alias";
        }
        function A2(N2) {
          if (!N2)
            return true;
          switch (N2.type) {
            case "plain":
            case "quoteDouble":
            case "quoteSingle":
              return N2.position.start.line === N2.position.end.line;
            case "alias":
              return true;
            default:
              return false;
          }
        }
        r2.exports = _2;
      } }), $g2 = Z2({ "src/language-yaml/print/block.js"(e25, r2) {
        ne2();
        var { builders: { dedent: t2, dedentToRoot: s2, fill: a2, hardline: n2, join: u2, line: i2, literalline: l2, markAsRoot: p2 }, utils: { getDocParts: d2 } } = Me2(), { getAncestorCount: y2, getBlockValueLineContents: g2, hasIndicatorComment: c2, isLastDescendantNode: D2, isNode: E2 } = $t2(), { alignWithSpaces: _2 } = Mr2();
        function w2(F2, A2, N2) {
          let I2 = F2.getValue(), P2 = y2(F2, (v2) => E2(v2, ["sequence", "mapping"])), H2 = D2(F2), f2 = [I2.type === "blockFolded" ? ">" : "|"];
          I2.indent !== null && f2.push(I2.indent.toString()), I2.chomping !== "clip" && f2.push(I2.chomping === "keep" ? "+" : "-"), c2(I2) && f2.push(" ", A2("indicatorComment"));
          let b2 = g2(I2, { parentIndent: P2, isLastDescendant: H2, options: N2 }), m2 = [];
          for (let [v2, o2] of b2.entries())
            v2 === 0 && m2.push(n2), m2.push(a2(d2(u2(i2, o2)))), v2 !== b2.length - 1 ? m2.push(o2.length === 0 ? n2 : p2(l2)) : I2.chomping === "keep" && H2 && m2.push(s2(o2.length === 0 ? n2 : l2));
          return I2.indent === null ? f2.push(t2(_2(N2.tabWidth, m2))) : f2.push(s2(_2(I2.indent - 1 + P2, m2))), f2;
        }
        r2.exports = w2;
      } }), Vg2 = Z2({ "src/language-yaml/printer-yaml.js"(e25, r2) {
        ne2();
        var { builders: { breakParent: t2, fill: s2, group: a2, hardline: n2, join: u2, line: i2, lineSuffix: l2, literalline: p2 }, utils: { getDocParts: d2, replaceTextEndOfLine: y2 } } = Me2(), { isPreviousLineEmpty: g2 } = Ue2(), { insertPragma: c2, isPragma: D2 } = Lg2(), { locStart: E2 } = Og2(), _2 = jg2(), { getFlowScalarLineContents: w2, getLastDescendantNode: F2, hasLeadingComments: A2, hasMiddleComments: N2, hasTrailingComment: I2, hasEndComments: P2, hasPrettierIgnore: H2, isLastDescendantNode: f2, isNode: b2, isInlineNode: m2 } = $t2(), v2 = qg2(), { alignWithSpaces: o2, printNextEmptyLine: h2, shouldPrintEndComments: C2 } = Mr2(), { printFlowMapping: S2, printFlowSequence: x2 } = Mg2(), T2 = Rg2(), k2 = $g2();
        function M2(j2, K2, se2) {
          let Q2 = j2.getValue(), ce2 = [];
          Q2.type !== "mappingValue" && A2(Q2) && ce2.push([u2(n2, j2.map(se2, "leadingComments")), n2]);
          let { tag: W2, anchor: X2 } = Q2;
          W2 && ce2.push(se2("tag")), W2 && X2 && ce2.push(" "), X2 && ce2.push(se2("anchor"));
          let de2 = "";
          b2(Q2, ["mapping", "sequence", "comment", "directive", "mappingItem", "sequenceItem"]) && !f2(j2) && (de2 = h2(j2, K2.originalText)), (W2 || X2) && (b2(Q2, ["sequence", "mapping"]) && !N2(Q2) ? ce2.push(n2) : ce2.push(" ")), N2(Q2) && ce2.push([Q2.middleComments.length === 1 ? "" : n2, u2(n2, j2.map(se2, "middleComments")), n2]);
          let ie2 = j2.getParentNode();
          return H2(j2) ? ce2.push(y2(K2.originalText.slice(Q2.position.start.offset, Q2.position.end.offset).trimEnd(), p2)) : ce2.push(a2(R2(Q2, ie2, j2, K2, se2))), I2(Q2) && !b2(Q2, ["document", "documentHead"]) && ce2.push(l2([Q2.type === "mappingValue" && !Q2.content ? "" : " ", ie2.type === "mappingKey" && j2.getParentNode(2).type === "mapping" && m2(Q2) ? "" : t2, se2("trailingComment")])), C2(Q2) && ce2.push(o2(Q2.type === "sequenceItem" ? 2 : 0, [n2, u2(n2, j2.map((Ee2) => [g2(K2.originalText, Ee2.getValue(), E2) ? n2 : "", se2()], "endComments"))])), ce2.push(de2), ce2;
        }
        function R2(j2, K2, se2, Q2, ce2) {
          switch (j2.type) {
            case "root": {
              let { children: W2 } = j2, X2 = [];
              se2.each((ie2, Ee2) => {
                let z2 = W2[Ee2], ue2 = W2[Ee2 + 1];
                Ee2 !== 0 && X2.push(n2), X2.push(ce2()), U2(z2, ue2) ? (X2.push(n2, "..."), I2(z2) && X2.push(" ", ce2("trailingComment"))) : ue2 && !I2(ue2.head) && X2.push(n2, "---");
              }, "children");
              let de2 = F2(j2);
              return (!b2(de2, ["blockLiteral", "blockFolded"]) || de2.chomping !== "keep") && X2.push(n2), X2;
            }
            case "document": {
              let W2 = K2.children[se2.getName() + 1], X2 = [];
              return L2(j2, W2, K2, Q2) === "head" && ((j2.head.children.length > 0 || j2.head.endComments.length > 0) && X2.push(ce2("head")), I2(j2.head) ? X2.push(["---", " ", ce2(["head", "trailingComment"])]) : X2.push("---")), q2(j2) && X2.push(ce2("body")), u2(n2, X2);
            }
            case "documentHead":
              return u2(n2, [...se2.map(ce2, "children"), ...se2.map(ce2, "endComments")]);
            case "documentBody": {
              let { children: W2, endComments: X2 } = j2, de2 = "";
              if (W2.length > 0 && X2.length > 0) {
                let ie2 = F2(j2);
                b2(ie2, ["blockFolded", "blockLiteral"]) ? ie2.chomping !== "keep" && (de2 = [n2, n2]) : de2 = n2;
              }
              return [u2(n2, se2.map(ce2, "children")), de2, u2(n2, se2.map(ce2, "endComments"))];
            }
            case "directive":
              return ["%", u2(" ", [j2.name, ...j2.parameters])];
            case "comment":
              return ["#", j2.value];
            case "alias":
              return ["*", j2.value];
            case "tag":
              return Q2.originalText.slice(j2.position.start.offset, j2.position.end.offset);
            case "anchor":
              return ["&", j2.value];
            case "plain":
              return Y2(j2.type, Q2.originalText.slice(j2.position.start.offset, j2.position.end.offset), Q2);
            case "quoteDouble":
            case "quoteSingle": {
              let W2 = "'", X2 = '"', de2 = Q2.originalText.slice(j2.position.start.offset + 1, j2.position.end.offset - 1);
              if (j2.type === "quoteSingle" && de2.includes("\\") || j2.type === "quoteDouble" && /\\[^"]/.test(de2)) {
                let Ee2 = j2.type === "quoteDouble" ? X2 : W2;
                return [Ee2, Y2(j2.type, de2, Q2), Ee2];
              }
              if (de2.includes(X2))
                return [W2, Y2(j2.type, j2.type === "quoteDouble" ? de2.replace(/\\"/g, X2).replace(/'/g, W2.repeat(2)) : de2, Q2), W2];
              if (de2.includes(W2))
                return [X2, Y2(j2.type, j2.type === "quoteSingle" ? de2.replace(/''/g, W2) : de2, Q2), X2];
              let ie2 = Q2.singleQuote ? W2 : X2;
              return [ie2, Y2(j2.type, de2, Q2), ie2];
            }
            case "blockFolded":
            case "blockLiteral":
              return k2(se2, ce2, Q2);
            case "mapping":
            case "sequence":
              return u2(n2, se2.map(ce2, "children"));
            case "sequenceItem":
              return ["- ", o2(2, j2.content ? ce2("content") : "")];
            case "mappingKey":
            case "mappingValue":
              return j2.content ? ce2("content") : "";
            case "mappingItem":
            case "flowMappingItem":
              return T2(j2, K2, se2, ce2, Q2);
            case "flowMapping":
              return S2(se2, ce2, Q2);
            case "flowSequence":
              return x2(se2, ce2, Q2);
            case "flowSequenceItem":
              return ce2("content");
            default:
              throw new Error(`Unexpected node type ${j2.type}`);
          }
        }
        function q2(j2) {
          return j2.body.children.length > 0 || P2(j2.body);
        }
        function U2(j2, K2) {
          return I2(j2) || K2 && (K2.head.children.length > 0 || P2(K2.head));
        }
        function L2(j2, K2, se2, Q2) {
          return se2.children[0] === j2 && /---(?:\s|$)/.test(Q2.originalText.slice(E2(j2), E2(j2) + 4)) || j2.head.children.length > 0 || P2(j2.head) || I2(j2.head) ? "head" : U2(j2, K2) ? false : K2 ? "root" : false;
        }
        function Y2(j2, K2, se2) {
          let Q2 = w2(j2, K2, se2);
          return u2(n2, Q2.map((ce2) => s2(d2(u2(i2, ce2)))));
        }
        function V2(j2, K2) {
          if (b2(K2))
            switch (delete K2.position, K2.type) {
              case "comment":
                if (D2(K2.value))
                  return null;
                break;
              case "quoteDouble":
              case "quoteSingle":
                K2.type = "quote";
                break;
            }
        }
        r2.exports = { preprocess: v2, embed: _2, print: M2, massageAstNode: V2, insertPragma: c2 };
      } }), Wg2 = Z2({ "src/language-yaml/options.js"(e25, r2) {
        ne2();
        var t2 = Mt2();
        r2.exports = { bracketSpacing: t2.bracketSpacing, singleQuote: t2.singleQuote, proseWrap: t2.proseWrap };
      } }), Hg2 = Z2({ "src/language-yaml/parsers.js"() {
        ne2();
      } }), Gg2 = Z2({ "node_modules/linguist-languages/data/YAML.json"(e25, r2) {
        r2.exports = { name: "YAML", type: "data", color: "#cb171e", tmScope: "source.yaml", aliases: ["yml"], extensions: [".yml", ".mir", ".reek", ".rviz", ".sublime-syntax", ".syntax", ".yaml", ".yaml-tmlanguage", ".yaml.sed", ".yml.mysql"], filenames: [".clang-format", ".clang-tidy", ".gemrc", "CITATION.cff", "glide.lock", "yarn.lock"], aceMode: "yaml", codemirrorMode: "yaml", codemirrorMimeType: "text/x-yaml", languageId: 407 };
      } }), Ug2 = Z2({ "src/language-yaml/index.js"(e25, r2) {
        ne2();
        var t2 = _t2(), s2 = Vg2(), a2 = Wg2(), n2 = Hg2(), u2 = [t2(Gg2(), (i2) => ({ since: "1.14.0", parsers: ["yaml"], vscodeLanguageIds: ["yaml", "ansible", "home-assistant"], filenames: [...i2.filenames.filter((l2) => l2 !== "yarn.lock"), ".prettierrc", ".stylelintrc", ".lintstagedrc"] }))];
        r2.exports = { languages: u2, printers: { yaml: s2 }, options: a2, parsers: n2 };
      } }), Jg2 = Z2({ "src/languages.js"(e25, r2) {
        ne2(), r2.exports = [Td2(), Gd2(), Zd2(), ig2(), mg2(), kg2(), Ug2()];
      } });
      ne2();
      var { version: zg2 } = Ia2(), Lt2 = Gm2(), { getSupportInfo: Xg2 } = Xn2(), Kg2 = Um2(), Yg2 = Jg2(), Qg2 = Me2();
      function Nt2(e25) {
        let r2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        return function() {
          for (var t2 = arguments.length, s2 = new Array(t2), a2 = 0; a2 < t2; a2++)
            s2[a2] = arguments[a2];
          let n2 = s2[r2] || {}, u2 = n2.plugins || [];
          return s2[r2] = Object.assign(Object.assign({}, n2), {}, { plugins: [...Yg2, ...Array.isArray(u2) ? u2 : Object.values(u2)] }), e25(...s2);
        };
      }
      var jn2 = Nt2(Lt2.formatWithCursor);
      jo2.exports = { formatWithCursor: jn2, format(e25, r2) {
        return jn2(e25, r2).formatted;
      }, check(e25, r2) {
        let { formatted: t2 } = jn2(e25, r2);
        return t2 === e25;
      }, doc: Qg2, getSupportInfo: Nt2(Xg2, 0), version: zg2, util: Kg2, __debug: { parse: Nt2(Lt2.parse), formatAST: Nt2(Lt2.formatAST), formatDoc: Nt2(Lt2.formatDoc), printToDoc: Nt2(Lt2.printToDoc), printDocToString: Nt2(Lt2.printDocToString) } };
    });
    return Zg2();
  });
})(standalone);
var prettier = /* @__PURE__ */ getDefaultExportFromCjs(standalone.exports);
var CodeEditor_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$c = ["id"];
var Language;
(function(Language2) {
  Language2["JSON"] = "json";
  Language2["JAVASCRIPT"] = "javascript";
  Language2["HTML"] = "html";
})(Language || (Language = {}));
const __default__$o = defineComponent({
  name: "UICodeEditor",
  inheritAttrs: false
});
const _sfc_main$q = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$o), {
  props: {
    value: String,
    language: String,
    id: {
      type: String,
      required: true,
      default: "ghl-editor"
    },
    resize: Boolean
  },
  emits: ["update:value"],
  setup(__props, { emit }) {
    const props = __props;
    window.process = { cwd: () => "" };
    let timer;
    const canFormateCode = ref(false);
    const editor = ref();
    let formattedCode;
    watch(() => props.language, (newLanguage) => {
      initiateEditor(newLanguage);
    });
    function jsEditor() {
      editor.value = new EditorView({
        state: EditorState.create({
          doc: props.value,
          extensions: [
            linter(esLint(new zN())),
            lintGutter(),
            basicSetup,
            javascript(),
            javascriptLanguage.data.of({
              autocomplete: scopeCompletionSource(globalThis)
            }),
            EditorView.updateListener.of(function(update) {
              if (update.docChanged) {
                try {
                  formattedCode = prettier.format(update.state.doc.toString(), {
                    parser: "babel",
                    plugins: [parserBabel]
                  });
                  emit("update:value", formattedCode);
                  canFormateCode.value = true;
                } catch (error) {
                  canFormateCode.value = false;
                  emit("update:value", update.state.doc.toString());
                }
              }
            })
          ]
        }),
        parent: document.querySelector(`.ghl-code-mirror#${props.id}`)
      });
    }
    function jsonEditor() {
      editor.value = new EditorView({
        state: EditorState.create({
          doc: props.value,
          extensions: [
            lintGutter(),
            basicSetup,
            linter(jsonParseLinter()),
            json(),
            jsonLanguage,
            EditorView.updateListener.of((update) => {
              if (update.docChanged) {
                try {
                  formattedCode = JSON.stringify(JSON.parse(update.state.doc.toString()), null, 2);
                  canFormateCode.value = true;
                } catch (error) {
                  canFormateCode.value = false;
                  emit("update:value", update.state.doc.toString());
                }
              }
            })
          ]
        }),
        parent: document.querySelector(`.ghl-code-mirror#${props.id}`)
      });
    }
    function htmlEditor() {
      editor.value = new EditorView({
        state: EditorState.create({
          doc: props.value,
          extensions: [
            lintGutter(),
            basicSetup,
            html(),
            htmlLanguage.data.of({
              autocomplete: htmlCompletionSource
            }),
            EditorView.updateListener.of(function(update) {
              if (update.docChanged) {
                try {
                  formattedCode = prettier.format(update.state.doc.toString(), {
                    parser: "html",
                    plugins: [parserHtml]
                  });
                  canFormateCode.value = true;
                  emit("update:value", formattedCode);
                } catch (error) {
                  canFormateCode.value = false;
                  emit("update:value", update.state.doc.toString());
                }
              }
            })
          ]
        }),
        parent: document.querySelector(`.ghl-code-mirror#${props.id}`)
      });
    }
    function initiateEditor(editorLanguage) {
      editor.value && editor.value.destroy();
      switch (editorLanguage) {
        case Language.JAVASCRIPT:
          jsEditor();
          break;
        case Language.JSON:
          jsonEditor();
          break;
        case Language.HTML:
        default:
          htmlEditor();
          break;
      }
      editor.value.contentDOM.addEventListener("blur", () => {
        if (!canFormateCode.value)
          return;
        if (timer)
          clearInterval(timer);
        timer = setTimeout(() => {
          dispatchFormattedData(formattedCode);
        }, 10);
      });
    }
    function dispatchFormattedData(formattedCode2) {
      editor.value.dispatch({
        changes: {
          from: 0,
          to: editor.value.state.doc.length,
          insert: formattedCode2
        }
      });
    }
    onMounted(() => initiateEditor(props.language));
    onUnmounted(() => editor.value && editor.value.destroy());
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["ghl-code-mirror", __props.resize ? "allow-resize" : null].join(" ")),
        id: __props.id
      }, null, 10, _hoisted_1$c);
    };
  }
}));
_sfc_main$q.install = (Vue) => {
  Vue.component(_sfc_main$q.name, _sfc_main$q);
};
const __default__$n = defineComponent({
  name: "UIColorPicker",
  inheritAttrs: false,
  components: { NColorPicker }
});
const _sfc_main$p = defineComponent(__spreadProps(__spreadValues({}, __default__$n), {
  props: {
    placement: {
      type: String,
      default: "bottom"
    },
    compact: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: void 0
    },
    defaultShow: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    modes: {
      type: Array,
      default: () => ["rgb", "hex", "hsl"]
    },
    customTrigger: {
      type: Function,
      default: void 0
    },
    defaultValue: {
      type: String,
      default: "#000"
    },
    value: {
      type: String,
      default: "#000"
    },
    swatches: {
      type: Array,
      default: void 0
    },
    to: {
      type: String,
      default: "body"
    }
  },
  emits: ["onComplete", "update:value"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const renderLabel = (color) => {
      if (props.compact) {
        return h$1("div", {
          class: "ghl-color-preview",
          style: {
            "background-color": color != null ? color : "#000",
            width: "24px",
            height: "24px",
            "border-radius": "50%",
            outline: "#00000069 solid 1px",
            padding: "2px"
          }
        });
      }
      return void 0;
    };
    return (_ctx, _cache) => {
      var _a2;
      return openBlock(), createBlock(unref(NColorPicker), {
        class: normalizeClass(__props.compact || __props.customTrigger ? "compact-picker" : ""),
        placement: __props.placement,
        "render-label": (_a2 = __props.customTrigger) != null ? _a2 : renderLabel,
        value: __props.value,
        "default-value": __props.defaultValue,
        "default-show": __props.defaultShow,
        show: __props.show,
        to: __props.to,
        disabled: __props.disabled,
        swatches: __props.swatches,
        modes: __props.modes,
        onComplete: _cache[0] || (_cache[0] = (color) => emits("onComplete", color)),
        "onUpdate:value": _cache[1] || (_cache[1] = (color) => emits("update:value", color))
      }, null, 8, ["class", "placement", "render-label", "value", "default-value", "default-show", "show", "to", "disabled", "swatches", "modes"]);
    };
  }
}));
_sfc_main$p.install = (Vue) => {
  Vue.component(_sfc_main$p.name, _sfc_main$p);
};
var GHLLanguageKeys;
(function(GHLLanguageKeys2) {
  GHLLanguageKeys2["englishUS"] = "en-US";
  GHLLanguageKeys2["danish"] = "da";
  GHLLanguageKeys2["dutch"] = "nl";
  GHLLanguageKeys2["finnish"] = "fi";
  GHLLanguageKeys2["frenchFrance"] = "fr-FR";
  GHLLanguageKeys2["frenchCanada"] = "fr-CA";
  GHLLanguageKeys2["german"] = "de";
  GHLLanguageKeys2["italian"] = "it";
  GHLLanguageKeys2["norwegian"] = "no";
  GHLLanguageKeys2["portuguesePortugal"] = "pt-PT";
  GHLLanguageKeys2["portugueseBrazil"] = "pt-BR";
  GHLLanguageKeys2["spanish"] = "es";
  GHLLanguageKeys2["swedish"] = "sv";
})(GHLLanguageKeys || (GHLLanguageKeys = {}));
var formatDistanceLocale$3 = {
  lessThanXSeconds: {
    one: "mindre end \xE9t sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "\xE9t halvt minut",
  lessThanXMinutes: {
    one: "mindre end \xE9t minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 m\xE5ned",
    other: "cirka {{count}} m\xE5neder"
  },
  xMonths: {
    one: "1 m\xE5ned",
    other: "{{count}} m\xE5neder"
  },
  aboutXYears: {
    one: "cirka 1 \xE5r",
    other: "cirka {{count}} \xE5r"
  },
  xYears: {
    one: "1 \xE5r",
    other: "{{count}} \xE5r"
  },
  overXYears: {
    one: "over 1 \xE5r",
    other: "over {{count}} \xE5r"
  },
  almostXYears: {
    one: "n\xE6sten 1 \xE5r",
    other: "n\xE6sten {{count}} \xE5r"
  }
};
var formatDistance$6 = function(token, count, options) {
  var result2;
  var tokenValue = formatDistanceLocale$3[token];
  if (typeof tokenValue === "string") {
    result2 = tokenValue;
  } else if (count === 1) {
    result2 = tokenValue.one;
  } else {
    result2 = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "om " + result2;
    } else {
      return result2 + " siden";
    }
  }
  return result2;
};
var formatDistance$7 = formatDistance$6;
var dateFormats$4 = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
};
var timeFormats$4 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats$4 = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong$8 = {
  date: buildFormatLongFn$1({
    formats: dateFormats$4,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$4,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$4,
    defaultWidth: "full"
  })
};
var formatLong$9 = formatLong$8;
var formatRelativeLocale$3 = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i g\xE5r kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'p\xE5' eeee 'kl.' p",
  other: "P"
};
var formatRelative$6 = function(token, _date, _baseDate, _options) {
  return formatRelativeLocale$3[token];
};
var formatRelative$7 = formatRelative$6;
var eraValues$3 = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["f\xF8r vesterlandsk tidsregning", "vesterlandsk tidsregning"]
};
var quarterValues$3 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
};
var monthValues$3 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
};
var dayValues$3 = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["s\xF8", "ma", "ti", "on", "to", "fr", "l\xF8"],
  abbreviated: ["s\xF8n.", "man.", "tir.", "ons.", "tor.", "fre.", "l\xF8r."],
  wide: ["s\xF8ndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "l\xF8rdag"]
};
var dayPeriodValues$3 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
};
var formattingDayPeriodValues$2 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
};
var ordinalNumber$3 = function(dirtyNumber, _options) {
  var number4 = Number(dirtyNumber);
  return number4 + ".";
};
var localize$6 = {
  ordinalNumber: ordinalNumber$3,
  era: buildLocalizeFn$1({
    values: eraValues$3,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$3,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues$3,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$3,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$3,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$2,
    defaultFormattingWidth: "wide"
  })
};
var localize$7 = localize$6;
var matchOrdinalNumberPattern$3 = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern$3 = /\d+/i;
var matchEraPatterns$3 = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var parseEraPatterns$3 = {
  any: [/^f/i, /^(v|e)/i]
};
var matchQuarterPatterns$3 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
};
var parseQuarterPatterns$3 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$3 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var parseMonthPatterns$3 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$3 = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var parseDayPatterns$3 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
var matchDayPeriodPatterns$3 = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var parseDayPeriodPatterns$3 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
};
var match$6 = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$3,
    parsePattern: parseOrdinalNumberPattern$3,
    valueCallback: function(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$3,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$3,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$3,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$3,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$3,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$3,
    defaultParseWidth: "any"
  })
};
var match$7 = match$6;
var locale$4 = {
  code: "da",
  formatDistance: formatDistance$7,
  formatLong: formatLong$9,
  formatRelative: formatRelative$7,
  localize: localize$7,
  match: match$7,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var da$1 = locale$4;
const date_da = {
  name: GHLLanguageKeys.danish,
  locale: da$1
};
const da = {
  name: GHLLanguageKeys.danish,
  global: {
    undo: "Fortryd",
    redo: "Gentag",
    confirm: "Bekr\xE6ft",
    clear: "Ryd"
  },
  Popconfirm: {
    positiveText: "Bekr\xE6ft",
    negativeText: "Annuller"
  },
  Cascader: {
    placeholder: "V\xE6lg venligst",
    loading: "Indl\xE6ser",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Ryd",
    now: "Nu",
    confirm: "Bekr\xE6ft",
    selectTime: "V\xE6lg Tid",
    selectDate: "V\xE6lg Dato",
    datePlaceholder: "V\xE6lg Dato",
    datetimePlaceholder: "V\xE6lg Dato og Tid",
    monthPlaceholder: "V\xE6lg M\xE5ned",
    yearPlaceholder: "V\xE6lg \xC5r",
    quarterPlaceholder: "V\xE6lg Kvartal",
    startDatePlaceholder: "Start Dato",
    endDatePlaceholder: "Slut Dato",
    startDatetimePlaceholder: "Start Dato og Tid",
    endDatetimePlaceholder: "Slut Dato og Tid",
    startMonthPlaceholder: "Start M\xE5ned",
    endMonthPlaceholder: "Slut M\xE5ned",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "I dag"
  },
  DataTable: {
    checkTableAll: "V\xE6lg alt i tabellen",
    uncheckTableAll: "Frav\xE6lg alt i tabellen",
    confirm: "Bekr\xE6ft",
    clear: "Ryd",
    apply: "Anvend",
    filters: "Filtre"
  },
  LegacyTransfer: {
    sourceTitle: "Kilde",
    targetTitle: "M\xE5l"
  },
  Transfer: {
    selectAll: "V\xE6lg alle",
    unselectAll: "Frav\xE6lg alle",
    clearAll: "Ryd"
  },
  Empty: {
    description: "Ingen data"
  },
  Select: {
    placeholder: "V\xE6lg venligst"
  },
  TimePicker: {
    placeholder: "V\xE6lg tid",
    positiveText: "OK",
    negativeText: "Annuller",
    now: "Nu"
  },
  Pagination: {
    goto: "G\xE5 til",
    selectionSuffix: "side",
    next: "N\xE6ste",
    previous: "Tidligere"
  },
  DynamicTags: {
    add: "Tilf\xF8j"
  },
  Log: {
    loading: "Indl\xE6ser"
  },
  Input: {
    placeholder: "Indtast venligst"
  },
  InputNumber: {
    placeholder: "Indtast venligst"
  },
  DynamicInput: {
    create: "Opret"
  },
  ThemeEditor: {
    title: "Tema Editor",
    clearAllVars: "Ryd alle variabler",
    clearSearch: "Ryd s\xF8gning",
    filterCompName: "Filterkomponentnavn",
    filterVarName: "Filtervariabelnavn",
    import: "Import",
    export: "Eksport",
    restore: "Nulstil til standard"
  },
  Image: {
    tipPrevious: "Forrige billede (\u2190)",
    tipNext: "N\xE6ste billede (\u2192)",
    tipCounterclockwise: "Mod uret",
    tipClockwise: "Med uret",
    tipZoomOut: "Zoom ud",
    tipZoomIn: "Zoom ind",
    tipClose: "Luk (ESC)",
    tipOriginalSize: "Zoom til original st\xF8rrelse"
  }
};
const date_nl = {
  name: GHLLanguageKeys.dutch,
  locale: nl$2
};
const nl = {
  name: GHLLanguageKeys.dutch,
  global: {
    undo: "Ongedaan maken",
    redo: "Opnieuw uitvoeren",
    confirm: "Bevestig",
    clear: "Duidelijk"
  },
  Popconfirm: {
    positiveText: "Bevestig",
    negativeText: "Annuleer"
  },
  Cascader: {
    placeholder: "Gelieve te selecteren",
    loading: "Bezig met laden",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM/yyyy",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "qqq yyyy",
    clear: "Duidelijk",
    now: "Nu",
    confirm: "Bevestig",
    selectTime: "Selecteer Tijd",
    selectDate: "Selecteer Datum",
    datePlaceholder: "Selecteer Datum",
    datetimePlaceholder: "Selecteer Tijd en Datum",
    monthPlaceholder: "Selecteer Maand",
    yearPlaceholder: "Selecteer Jaar",
    quarterPlaceholder: "Selecteer Kwartaal",
    startDatePlaceholder: "Start Datum",
    endDatePlaceholder: "Eind Datum",
    startDatetimePlaceholder: "Start Datum en Tijd",
    endDatetimePlaceholder: "Eind Datum en Tijd",
    startMonthPlaceholder: "Start Maand",
    endMonthPlaceholder: "Einde Maand",
    monthBeforeYear: true,
    firstDayOfWeek: 0,
    today: "Vandaag"
  },
  DataTable: {
    checkTableAll: "Selecteer alles in de tabel",
    uncheckTableAll: "Deselecteer alles in de tabel",
    confirm: "Bevestig",
    clear: "Duidelijk",
    apply: "Toepassen",
    filters: "Filters"
  },
  LegacyTransfer: {
    sourceTitle: "Bron",
    targetTitle: "Target"
  },
  Transfer: {
    selectAll: "Selecteer Alle",
    unselectAll: "Deselecteer Alle",
    clearAll: "Duidelijk"
  },
  Empty: {
    description: "Geen Data"
  },
  Select: {
    placeholder: "Selecteer alstublieft"
  },
  TimePicker: {
    placeholder: "Selecteer Tijd",
    positiveText: "OK",
    negativeText: "Annuleer",
    now: "Nu"
  },
  Pagination: {
    goto: "Ga naar",
    selectionSuffix: "Pagina",
    next: "Volgende",
    previous: "Vorige"
  },
  DynamicTags: {
    add: "Toevoegen"
  },
  Log: {
    loading: "Bezig met laden"
  },
  Input: {
    placeholder: "Vul alsjeblieft in"
  },
  InputNumber: {
    placeholder: "Vul alsjeblieft in"
  },
  DynamicInput: {
    create: "Maak"
  },
  ThemeEditor: {
    title: "Thema Editor",
    clearAllVars: "Wis Alle Variabelen",
    clearSearch: "Zoekopdracht Wissen",
    filterCompName: "Naam van filter component",
    filterVarName: "Naam van filter variable",
    import: "Import",
    export: "Export",
    restore: "Resetten naar standaard"
  },
  Image: {
    tipPrevious: "Vorige Afbeelding (\u2190)",
    tipNext: "Volgende afbeelding (\u2192)",
    tipCounterclockwise: "Tegen de klok in",
    tipClockwise: "Met de klok mee",
    tipZoomOut: "Zoom uit",
    tipZoomIn: "Zoom in",
    tipClose: "Sluiten (Esc)",
    tipOriginalSize: "Zoom in op originele grootte"
  }
};
const date_en_US = {
  name: GHLLanguageKeys.englishUS,
  locale: enUS$2
};
const enUS = {
  name: GHLLanguageKeys.englishUS,
  global: {
    undo: "Undo",
    redo: "Redo",
    confirm: "Confirm",
    clear: "Clear"
  },
  Popconfirm: {
    positiveText: "Confirm",
    negativeText: "Cancel"
  },
  Cascader: {
    placeholder: "Please Select",
    loading: "Loading",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Clear",
    now: "Now",
    confirm: "Confirm",
    selectTime: "Select Time",
    selectDate: "Select Date",
    datePlaceholder: "Select Date",
    datetimePlaceholder: "Select Date and Time",
    monthPlaceholder: "Select Month",
    yearPlaceholder: "Select Year",
    quarterPlaceholder: "Select Quarter",
    startDatePlaceholder: "Start Date",
    endDatePlaceholder: "End Date",
    startDatetimePlaceholder: "Start Date and Time",
    endDatetimePlaceholder: "End Date and Time",
    startMonthPlaceholder: "Start Month",
    endMonthPlaceholder: "End Month",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "Today"
  },
  DataTable: {
    checkTableAll: "Select all in the table",
    uncheckTableAll: "Unselect all in the table",
    confirm: "Confirm",
    clear: "Clear",
    apply: "Apply",
    filters: "Filters"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Target"
  },
  Transfer: {
    selectAll: "Select all",
    unselectAll: "Unselect all",
    clearAll: "Clear"
  },
  Empty: {
    description: "No Data"
  },
  Select: {
    placeholder: "Please Select"
  },
  TimePicker: {
    placeholder: "Select Time",
    positiveText: "OK",
    negativeText: "Cancel",
    now: "Now"
  },
  Pagination: {
    goto: "Goto",
    selectionSuffix: "page",
    next: "Next",
    previous: "Previous"
  },
  DynamicTags: {
    add: "Add"
  },
  Log: {
    loading: "Loading"
  },
  Input: {
    placeholder: "Please Input"
  },
  InputNumber: {
    placeholder: "Please Input"
  },
  DynamicInput: {
    create: "Create"
  },
  ThemeEditor: {
    title: "Theme Editor",
    clearAllVars: "Clear All Variables",
    clearSearch: "Clear Search",
    filterCompName: "Filter Component Name",
    filterVarName: "Filter Variable Name",
    import: "Import",
    export: "Export",
    restore: "Reset to Default"
  },
  Image: {
    tipPrevious: "Previous picture (\u2190)",
    tipNext: "Next picture (\u2192)",
    tipCounterclockwise: "Counterclockwise",
    tipClockwise: "Clockwise",
    tipZoomOut: "Zoom out",
    tipZoomIn: "Zoom in",
    tipClose: "Close (Esc)",
    tipOriginalSize: "Zoom to original size"
  }
};
function futureSeconds(text) {
  return text.replace(/sekuntia?/, "sekunnin");
}
function futureMinutes(text) {
  return text.replace(/minuuttia?/, "minuutin");
}
function futureHours(text) {
  return text.replace(/tuntia?/, "tunnin");
}
function futureDays(text) {
  return text.replace(/päivää?/, "p\xE4iv\xE4n");
}
function futureWeeks(text) {
  return text.replace(/(viikko|viikkoa)/, "viikon");
}
function futureMonths(text) {
  return text.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function futureYears(text) {
  return text.replace(/(vuosi|vuotta)/, "vuoden");
}
var formatDistanceLocale$2 = {
  lessThanXSeconds: {
    one: "alle sekunti",
    other: "alle {{count}} sekuntia",
    futureTense: futureSeconds
  },
  xSeconds: {
    one: "sekunti",
    other: "{{count}} sekuntia",
    futureTense: futureSeconds
  },
  halfAMinute: {
    one: "puoli minuuttia",
    other: "puoli minuuttia",
    futureTense: function(_text) {
      return "puolen minuutin";
    }
  },
  lessThanXMinutes: {
    one: "alle minuutti",
    other: "alle {{count}} minuuttia",
    futureTense: futureMinutes
  },
  xMinutes: {
    one: "minuutti",
    other: "{{count}} minuuttia",
    futureTense: futureMinutes
  },
  aboutXHours: {
    one: "noin tunti",
    other: "noin {{count}} tuntia",
    futureTense: futureHours
  },
  xHours: {
    one: "tunti",
    other: "{{count}} tuntia",
    futureTense: futureHours
  },
  xDays: {
    one: "p\xE4iv\xE4",
    other: "{{count}} p\xE4iv\xE4\xE4",
    futureTense: futureDays
  },
  aboutXWeeks: {
    one: "noin viikko",
    other: "noin {{count}} viikkoa",
    futureTense: futureWeeks
  },
  xWeeks: {
    one: "viikko",
    other: "{{count}} viikkoa",
    futureTense: futureWeeks
  },
  aboutXMonths: {
    one: "noin kuukausi",
    other: "noin {{count}} kuukautta",
    futureTense: futureMonths
  },
  xMonths: {
    one: "kuukausi",
    other: "{{count}} kuukautta",
    futureTense: futureMonths
  },
  aboutXYears: {
    one: "noin vuosi",
    other: "noin {{count}} vuotta",
    futureTense: futureYears
  },
  xYears: {
    one: "vuosi",
    other: "{{count}} vuotta",
    futureTense: futureYears
  },
  overXYears: {
    one: "yli vuosi",
    other: "yli {{count}} vuotta",
    futureTense: futureYears
  },
  almostXYears: {
    one: "l\xE4hes vuosi",
    other: "l\xE4hes {{count}} vuotta",
    futureTense: futureYears
  }
};
var formatDistance$4 = function(token, count, options) {
  var tokenValue = formatDistanceLocale$2[token];
  var result2 = count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return tokenValue.futureTense(result2) + " kuluttua";
    } else {
      return result2 + " sitten";
    }
  }
  return result2;
};
var formatDistance$5 = formatDistance$4;
var dateFormats$3 = {
  full: "eeee d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "d.M.y"
};
var timeFormats$3 = {
  full: "HH.mm.ss zzzz",
  long: "HH.mm.ss z",
  medium: "HH.mm.ss",
  short: "HH.mm"
};
var dateTimeFormats$3 = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong$6 = {
  date: buildFormatLongFn$1({
    formats: dateFormats$3,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$3,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$3,
    defaultWidth: "full"
  })
};
var formatLong$7 = formatLong$6;
var formatRelativeLocale$2 = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'t\xE4n\xE4\xE4n klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: "P"
};
var formatRelative$4 = function(token, _date, _baseDate, _options) {
  return formatRelativeLocale$2[token];
};
var formatRelative$5 = formatRelative$4;
var eraValues$2 = {
  narrow: ["eaa.", "jaa."],
  abbreviated: ["eaa.", "jaa."],
  wide: ["ennen ajanlaskun alkua", "j\xE4lkeen ajanlaskun alun"]
};
var quarterValues$2 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"]
};
var monthValues$2 = {
  narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
  abbreviated: ["tammi", "helmi", "maalis", "huhti", "touko", "kes\xE4", "hein\xE4", "elo", "syys", "loka", "marras", "joulu"],
  wide: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kes\xE4kuu", "hein\xE4kuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"]
};
var formattingMonthValues = {
  narrow: monthValues$2.narrow,
  abbreviated: monthValues$2.abbreviated,
  wide: ["tammikuuta", "helmikuuta", "maaliskuuta", "huhtikuuta", "toukokuuta", "kes\xE4kuuta", "hein\xE4kuuta", "elokuuta", "syyskuuta", "lokakuuta", "marraskuuta", "joulukuuta"]
};
var dayValues$2 = {
  narrow: ["S", "M", "T", "K", "T", "P", "L"],
  short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
  abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],
  wide: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"]
};
var formattingDayValues = {
  narrow: dayValues$2.narrow,
  short: dayValues$2.short,
  abbreviated: dayValues$2.abbreviated,
  wide: ["sunnuntaina", "maanantaina", "tiistaina", "keskiviikkona", "torstaina", "perjantaina", "lauantaina"]
};
var dayPeriodValues$2 = {
  narrow: {
    am: "ap",
    pm: "ip",
    midnight: "keskiy\xF6",
    noon: "keskip\xE4iv\xE4",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "y\xF6ll\xE4"
  },
  abbreviated: {
    am: "ap",
    pm: "ip",
    midnight: "keskiy\xF6",
    noon: "keskip\xE4iv\xE4",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "y\xF6ll\xE4"
  },
  wide: {
    am: "ap",
    pm: "ip",
    midnight: "keskiy\xF6ll\xE4",
    noon: "keskip\xE4iv\xE4ll\xE4",
    morning: "aamup\xE4iv\xE4ll\xE4",
    afternoon: "iltap\xE4iv\xE4ll\xE4",
    evening: "illalla",
    night: "y\xF6ll\xE4"
  }
};
var ordinalNumber$2 = function(dirtyNumber, _options) {
  var number4 = Number(dirtyNumber);
  return number4 + ".";
};
var localize$4 = {
  ordinalNumber: ordinalNumber$2,
  era: buildLocalizeFn$1({
    values: eraValues$2,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$2,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues$2,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$2,
    defaultWidth: "wide",
    formattingValues: formattingDayValues,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$2,
    defaultWidth: "wide"
  })
};
var localize$5 = localize$4;
var matchOrdinalNumberPattern$2 = /^(\d+)(\.)/i;
var parseOrdinalNumberPattern$2 = /\d+/i;
var matchEraPatterns$2 = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var parseEraPatterns$2 = {
  any: [/^e/i, /^j/i]
};
var matchQuarterPatterns$2 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? kvartaali/i
};
var parseQuarterPatterns$2 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$2 = {
  narrow: /^[thmkeslj]/i,
  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var parseMonthPatterns$2 = {
  narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
  any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
};
var matchDayPatterns$2 = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var parseDayPatterns$2 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
};
var matchDayPeriodPatterns$2 = {
  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var parseDayPeriodPatterns$2 = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i
  }
};
var match$4 = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$2,
    parsePattern: parseOrdinalNumberPattern$2,
    valueCallback: function(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$2,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$2,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$2,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$2,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$2,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$2,
    defaultParseWidth: "any"
  })
};
var match$5 = match$4;
var locale$3 = {
  code: "fi",
  formatDistance: formatDistance$5,
  formatLong: formatLong$7,
  formatRelative: formatRelative$5,
  localize: localize$5,
  match: match$5,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var fi$1 = locale$3;
const date_fi = {
  name: GHLLanguageKeys.finnish,
  locale: fi$1
};
const fi = {
  name: GHLLanguageKeys.finnish,
  global: {
    undo: "Kumoa",
    redo: "tehd\xE4 uudelleen",
    confirm: "Vahvista",
    clear: "Selv\xE4"
  },
  Popconfirm: {
    positiveText: "vahvista",
    negativeText: "Peruuta"
  },
  Cascader: {
    placeholder: "Valitse, ole hyv\xE4",
    loading: "Ladataan",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "selv\xE4",
    now: "Nyt",
    confirm: "Vahvistaa",
    selectTime: "Valitse aika",
    selectDate: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4",
    datePlaceholder: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4",
    datetimePlaceholder: "Valitse p\xE4iv\xE4m\xE4\xE4r\xE4 ja aika",
    monthPlaceholder: "Valitse kuukausi",
    yearPlaceholder: "Valitse vuosi",
    quarterPlaceholder: "Valitse nelj\xE4nnes",
    startDatePlaceholder: "Aloitus p\xE4iv\xE4m\xE4\xE4r\xE4",
    endDatePlaceholder: "P\xE4\xE4ttymisp\xE4iv\xE4m\xE4\xE4r\xE4",
    startDatetimePlaceholder: "Aloitusajankohta ja -aika",
    endDatetimePlaceholder: "P\xE4\xE4t\xF6sp\xE4iv\xE4 ja aika",
    startMonthPlaceholder: "Aloituskuukausi",
    endMonthPlaceholder: "Lopun kuukausi",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "T\xE4n\xE4\xE4n"
  },
  DataTable: {
    checkTableAll: "Valitse kaikki taulukosta",
    uncheckTableAll: "Poista valinnat taulukosta",
    confirm: "Vahvista",
    clear: "Selv\xE4",
    apply: "Ans\xF8g",
    filters: "Suodattimet"
  },
  LegacyTransfer: {
    sourceTitle: "L\xE4hde",
    targetTitle: "kohde"
  },
  Transfer: {
    selectAll: "Valitse kaikki",
    unselectAll: "Poista kaikki valinnat",
    clearAll: "Kirkas"
  },
  Empty: {
    description: "Ei dataa"
  },
  Select: {
    placeholder: "Valitse, kiitos"
  },
  TimePicker: {
    placeholder: "Valitse aika",
    positiveText: "OK",
    negativeText: "peruuttaa",
    now: "Nyt"
  },
  Pagination: {
    goto: "Siirry",
    selectionSuffix: "sivu",
    next: "Seuraava",
    previous: "Edellinen"
  },
  DynamicTags: {
    add: "Lis\xE4\xE4"
  },
  Log: {
    loading: "Lataus"
  },
  Input: {
    placeholder: "Sy\xF6t\xE4th\xE4n tiedot"
  },
  InputNumber: {
    placeholder: "Sy\xF6t\xE4 kiitos"
  },
  DynamicInput: {
    create: "Luoda"
  },
  ThemeEditor: {
    title: "Teeman muokkaaja",
    clearAllVars: "Poista kaikki muuttujat",
    clearSearch: "Tyhjenn\xE4 haku",
    filterCompName: "Suodatin osan nimi",
    filterVarName: "Suodattimen muuttujan nimi",
    import: "Tuonti",
    export: "Vienti",
    restore: "Nollaa oletusarvoihin"
  },
  Image: {
    tipPrevious: "Edellinen kuva (\u2190)",
    tipNext: "Seuraava kuva (\u2192)",
    tipCounterclockwise: "Vastap\xE4iv\xE4\xE4n",
    tipClockwise: "My\xF6t\xE4p\xE4iv\xE4\xE4n",
    tipZoomOut: "Zoomaa ulos",
    tipZoomIn: "L\xE4henn\xE4",
    tipClose: "Sulje (Esc)",
    tipOriginalSize: "Zoomaa alkuper\xE4iseen kokoon"
  }
};
var dateFormats$2 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "yy-MM-dd"
};
var timeFormats$2 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats$2 = {
  full: "{{date}} '\xE0' {{time}}",
  long: "{{date}} '\xE0' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong$4 = {
  date: buildFormatLongFn$1({
    formats: dateFormats$2,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$2,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$2,
    defaultWidth: "full"
  })
};
var formatLong$5 = formatLong$4;
var locale$2 = {
  code: "fr-CA",
  formatDistance: formatDistance$g,
  formatLong: formatLong$5,
  formatRelative: formatRelative$g,
  localize: localize$g,
  match: match$g,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
var frCA$1 = locale$2;
const date_fr_CA = {
  name: GHLLanguageKeys.frenchCanada,
  locale: frCA$1
};
const frCA = {
  name: GHLLanguageKeys.frenchCanada,
  global: {
    undo: "Annuler",
    redo: "R\xE9tablir",
    confirm: "Confirmer",
    clear: "Effacer"
  },
  Popconfirm: {
    positiveText: "Confirmer",
    negativeText: "Effacer"
  },
  Cascader: {
    placeholder: "Veuillez s\xE9lectionner",
    loading: "Chargement",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM/yyyy",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "qqq yyyy",
    clear: "Effacer",
    now: "Maintenant",
    confirm: "Confirmer",
    selectTime: "S\xE9lectionner l'heure",
    selectDate: "S\xE9lectionner la date",
    datePlaceholder: "S\xE9lectionner une date",
    datetimePlaceholder: "S\xE9lectionner la date et l'heure",
    monthPlaceholder: "S\xE9lectionner le mois",
    yearPlaceholder: "S\xE9lectionner l'ann\xE9e",
    quarterPlaceholder: "S\xE9lectionner le trimestre",
    startDatePlaceholder: "Date de d\xE9but",
    endDatePlaceholder: "Date de fin",
    startDatetimePlaceholder: "Date et heure de d\xE9but",
    endDatetimePlaceholder: "Date et heure de fin",
    startMonthPlaceholder: "Mois de d\xE9but",
    endMonthPlaceholder: "Mois de fin",
    monthBeforeYear: true,
    firstDayOfWeek: 1,
    today: "Aujourd'hui"
  },
  DataTable: {
    checkTableAll: "S\xE9lectionner tout dans le tableau",
    uncheckTableAll: "D\xE9selectionner tout dans le tableau",
    confirm: "Confirmer",
    clear: "Effacer",
    apply: "Appliquer",
    filters: "Filtres"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Cible"
  },
  Transfer: {
    selectAll: "Tout s\xE9lectionner",
    unselectAll: "Tout d\xE9s\xE9lectionner",
    clearAll: "Effacer"
  },
  Empty: {
    description: "Aucune donn\xE9e"
  },
  Select: {
    placeholder: "Veuillez s\xE9lectionner"
  },
  TimePicker: {
    placeholder: "S\xE9lectionner l'heure",
    positiveText: "OK",
    negativeText: "Annuler",
    now: "Maintenant"
  },
  Pagination: {
    goto: "Aller \xE0",
    selectionSuffix: "page",
    next: "Suivant",
    previous: "Pr\xE9c\xE9dent"
  },
  DynamicTags: {
    add: "Ajouter"
  },
  Log: {
    loading: "Chargement"
  },
  Input: {
    placeholder: "Veuillez entrer"
  },
  InputNumber: {
    placeholder: "Veuillez entrer"
  },
  DynamicInput: {
    create: "Cr\xE9er"
  },
  ThemeEditor: {
    title: "\xC9diteur de th\xE8me",
    clearAllVars: "Effacer toutes les variables",
    clearSearch: "Effacer la recherche",
    filterCompName: "Filtrer le nom du composant",
    filterVarName: "Filtrer le nom de la variable",
    import: "Importer",
    export: "Exporter",
    restore: "R\xE9initialiser par d\xE9faut"
  },
  Image: {
    tipPrevious: "Image pr\xE9c\xE9dente (\u2190)",
    tipNext: "Image suivante (\u2192)",
    tipCounterclockwise: "Dans le sens antihoraire",
    tipClockwise: "Dans le sens horaire",
    tipZoomOut: "Zoom arri\xE8re",
    tipZoomIn: "Zoom avant",
    tipClose: "Fermer (Esc)",
    tipOriginalSize: "Zoom \xE0 la taille d'origine"
  }
};
const date_fr_FR = {
  name: GHLLanguageKeys.frenchFrance,
  locale: fr$1
};
const frFR = {
  name: GHLLanguageKeys.frenchFrance,
  global: {
    undo: "Annuler",
    redo: "R\xE9tablir",
    confirm: "Confirmer",
    clear: "Effacer"
  },
  Popconfirm: {
    positiveText: "Confirmer",
    negativeText: "Annuler"
  },
  Cascader: {
    placeholder: "Veuillez s\xE9lectionner",
    loading: "Chargement",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM/yyyy",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "qqq yyyy",
    clear: "Effacer",
    now: "Maintenant",
    confirm: "Confirmer",
    selectTime: "S\xE9lectionner l'heure",
    selectDate: "S\xE9lectionner la date",
    datePlaceholder: "S\xE9lectionner la date",
    datetimePlaceholder: "S\xE9lectionner la date et l'heure",
    monthPlaceholder: "S\xE9lectionner le mois",
    yearPlaceholder: "S\xE9lectionner l'ann\xE9e",
    quarterPlaceholder: "S\xE9lectionner le trimestre",
    startDatePlaceholder: "Date de d\xE9but",
    endDatePlaceholder: "Date de fin",
    startDatetimePlaceholder: "Heure de d\xE9but",
    endDatetimePlaceholder: "Heure de fin",
    startMonthPlaceholder: "Mois de d\xE9but",
    endMonthPlaceholder: "Mois de fin",
    monthBeforeYear: true,
    firstDayOfWeek: 1,
    today: "Aujourd'hui"
  },
  DataTable: {
    checkTableAll: "S\xE9lectionner tout dans le tableau",
    uncheckTableAll: "D\xE9selectionner tout dans le tableau",
    confirm: "Confirmer",
    clear: "Effacer",
    apply: "Appliquer",
    filters: "Filtres"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Cible"
  },
  Transfer: {
    selectAll: "S\xE9lectionner tout",
    unselectAll: "D\xE9s\xE9lectionner tout",
    clearAll: "Effacer"
  },
  Empty: {
    description: "Pas de donn\xE9es"
  },
  Select: {
    placeholder: "Veuillez s\xE9lectionner"
  },
  TimePicker: {
    placeholder: "S\xE9lectionner l'heure",
    positiveText: "OK",
    negativeText: "Annuler",
    now: "Maintenant"
  },
  Pagination: {
    goto: "Aller \xE0",
    selectionSuffix: "page",
    next: "Suivant",
    previous: "Pr\xE9c\xE9dent"
  },
  DynamicTags: {
    add: "Ajouter"
  },
  Log: {
    loading: "Chargement"
  },
  Input: {
    placeholder: "Veuillez entrer"
  },
  InputNumber: {
    placeholder: "Veuillez entrer"
  },
  DynamicInput: {
    create: "Cr\xE9er"
  },
  ThemeEditor: {
    title: "\xC9diteur de th\xE8me",
    clearAllVars: "Effacer toutes les variables",
    clearSearch: "Effacer la recherche",
    filterCompName: "Filtrer le nom de l'\xE9l\xE9ment",
    filterVarName: "Filtrer le nom de la variable",
    import: "Importer",
    export: "Exporter",
    restore: "Remise \xE0 l'\xE9tat initial"
  },
  Image: {
    tipPrevious: "Image pr\xE9c\xE9dente (\u2190)",
    tipNext: "Image suivante (\u2192)",
    tipCounterclockwise: "Sens antihoraire",
    tipClockwise: "Sens horaire",
    tipZoomOut: "Zoom arri\xE8re",
    tipZoomIn: "Zoom avant",
    tipClose: "Fermer (Esc)",
    tipOriginalSize: "Zoom sur la taille originale"
  }
};
const date_de = {
  name: GHLLanguageKeys.german,
  locale: de$2
};
const de = {
  name: GHLLanguageKeys.german,
  global: {
    undo: "R\xFCckg\xE4ngig machen",
    redo: "Wiederholen",
    confirm: "Best\xE4tigen Sie",
    clear: "L\xF6schen"
  },
  Popconfirm: {
    positiveText: "Best\xE4tigen",
    negativeText: "Abbrechen"
  },
  Cascader: {
    placeholder: "Bitte ausw\xE4hlen",
    loading: "Laden",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM-yyyy",
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "L\xF6schen",
    now: "Jetzt",
    confirm: "Best\xE4tigen Sie",
    selectTime: "Zeit ausw\xE4hlen",
    selectDate: "Datum ausw\xE4hlen",
    datePlaceholder: "Datum ausw\xE4hlen",
    datetimePlaceholder: "Datum und Uhrzeit w\xE4hlen",
    monthPlaceholder: "Monat w\xE4hlen",
    yearPlaceholder: "Jahr w\xE4hlen",
    quarterPlaceholder: "Quartal w\xE4hlen",
    startDatePlaceholder: "Startdatum",
    endDatePlaceholder: "Enddatum",
    startDatetimePlaceholder: "Startdatum und Uhrzeit",
    endDatetimePlaceholder: "Enddatum und -uhrzeit",
    startMonthPlaceholder: "Monat beginnen",
    endMonthPlaceholder: "Ende Monat",
    monthBeforeYear: true,
    firstDayOfWeek: 0,
    today: "Heute"
  },
  DataTable: {
    checkTableAll: "Alles in der Tabelle markieren",
    uncheckTableAll: "Alle in der Tabelle abw\xE4hlen",
    confirm: "Best\xE4tigen",
    clear: "L\xF6schen",
    apply: "Anwenden",
    filters: "Filtern"
  },
  LegacyTransfer: {
    sourceTitle: "Quelle",
    targetTitle: "Ziel"
  },
  Transfer: {
    selectAll: "Alles ausw\xE4hlen",
    unselectAll: "Alle abw\xE4hlen",
    clearAll: "L\xF6schen"
  },
  Empty: {
    description: "Keine Daten"
  },
  Select: {
    placeholder: "Bitte ausw\xE4hlen"
  },
  TimePicker: {
    placeholder: "Zeit ausw\xE4hlen",
    positiveText: "OK",
    negativeText: "Abbrechen",
    now: "Jetzt"
  },
  Pagination: {
    goto: "Gehe zu",
    selectionSuffix: "Seite",
    next: "N\xE4chste",
    previous: "Vorherige"
  },
  DynamicTags: {
    add: "hinzuf\xFCgen"
  },
  Log: {
    loading: "Laden"
  },
  Input: {
    placeholder: "Bitte eingeben"
  },
  InputNumber: {
    placeholder: "Bitte eingeben"
  },
  DynamicInput: {
    create: "erstellen"
  },
  ThemeEditor: {
    title: "Themen-Editor",
    clearAllVars: "Alle Variablen l\xF6schen",
    clearSearch: "Suche l\xF6schen",
    filterCompName: "Komponentenname filtern",
    filterVarName: "Variablenname filtern",
    import: "Importieren",
    export: "Exportieren",
    restore: "Auf Standard zur\xFCcksetzen"
  },
  Image: {
    tipPrevious: "Vorheriges Bild (\u2190)",
    tipNext: "N\xE4chstes Bild (\u2192)",
    tipCounterclockwise: "Gegen den Uhrzeigersinn",
    tipClockwise: "Im Uhrzeigersinn",
    tipZoomOut: "Verkleinern",
    tipZoomIn: "Einzoomen",
    tipClose: "Schlie\xDFen (Esc)",
    tipOriginalSize: "Auf Originalgr\xF6\xDFe zoomen"
  }
};
const date_it = {
  name: GHLLanguageKeys.italian,
  locale: it$2
};
const it = {
  name: GHLLanguageKeys.italian,
  global: {
    undo: "Annulla",
    redo: "Rifare",
    confirm: "Confermare",
    clear: "Chiaro"
  },
  Popconfirm: {
    positiveText: "Confermare",
    negativeText: "Annulla"
  },
  Cascader: {
    placeholder: "Per favore seleziona.",
    loading: "Caricamento",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Chiaro",
    now: "Adesso",
    confirm: "Conferma",
    selectTime: "Seleziona l'orario",
    selectDate: "Seleziona data",
    datePlaceholder: "Seleziona la data",
    datetimePlaceholder: "Seleziona data e ora",
    monthPlaceholder: "Seleziona mese",
    yearPlaceholder: "Seleziona anno",
    quarterPlaceholder: "Seleziona il trimestre",
    startDatePlaceholder: "Data di inizio",
    endDatePlaceholder: "Data di fine",
    startDatetimePlaceholder: "Data e Ora di inizio",
    endDatetimePlaceholder: "Data e ora di fine",
    startMonthPlaceholder: "Mese di Inizio",
    endMonthPlaceholder: "Fine Mese",
    monthBeforeYear: true,
    firstDayOfWeek: 0,
    today: "Oggi"
  },
  DataTable: {
    checkTableAll: "Selezionare tutto nella tabella.",
    uncheckTableAll: "Deseleziona tutto nella tabella.",
    confirm: "Confermare",
    clear: "Chiaro",
    apply: "Applica",
    filters: "Filtri"
  },
  LegacyTransfer: {
    sourceTitle: "Fonte",
    targetTitle: "Obiettivo"
  },
  Transfer: {
    selectAll: "Seleziona tutto",
    unselectAll: "Deseleziona tutto",
    clearAll: "Chiaro"
  },
  Empty: {
    description: "Nessun dato"
  },
  Select: {
    placeholder: "Per favore seleziona"
  },
  TimePicker: {
    placeholder: "Seleziona orario",
    positiveText: "OK",
    negativeText: "Annullare",
    now: "Ora"
  },
  Pagination: {
    goto: "Andare a",
    selectionSuffix: "pagina",
    next: "Prossimo",
    previous: "Precedente"
  },
  DynamicTags: {
    add: "Aggiungi"
  },
  Log: {
    loading: "Caricamento"
  },
  Input: {
    placeholder: "Per favore, inserisci"
  },
  InputNumber: {
    placeholder: "Inserisci per favore."
  },
  DynamicInput: {
    create: "Creare"
  },
  ThemeEditor: {
    title: "Editor di temi",
    clearAllVars: "Cancella tutte le variabili",
    clearSearch: "Cancella ricerca",
    filterCompName: "Nome del componente di filtro",
    filterVarName: "Nome variabile filtro",
    import: "importazione",
    export: "Esportazione",
    restore: "Ripristina impostazioni predefinite"
  },
  Image: {
    tipPrevious: "Immagine precedente (\u2190)",
    tipNext: "Prossima immagine (\u2192)",
    tipCounterclockwise: "Controverse",
    tipClockwise: "in senso orario",
    tipZoomOut: "Allontana l'immagine",
    tipZoomIn: "Ingrandisci",
    tipClose: "Chiudi (Esc)",
    tipOriginalSize: "Ingrandisci alla dimensione originale"
  }
};
const date_no = {
  name: GHLLanguageKeys.norwegian,
  locale: nb$1
};
const no = {
  name: GHLLanguageKeys.norwegian,
  global: {
    undo: "Angre",
    redo: "Gj\xF8r om",
    confirm: "Gj\xF8r om",
    clear: "Gj\xF8r om"
  },
  Popconfirm: {
    positiveText: "Bekreft",
    negativeText: "Avbryt"
  },
  Cascader: {
    placeholder: "Vennligst Velg",
    loading: "Laster",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM.yyyy",
    dateFormat: "dd.MM.yyyy",
    dateTimeFormat: "dd.MM.yyyy HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "T\xF8m",
    now: "N\xE5",
    confirm: "Bekreft",
    selectTime: "Velg Tid",
    selectDate: "Velg Dato",
    datePlaceholder: "Velg Dato",
    datetimePlaceholder: "Velg Dato og Tid",
    monthPlaceholder: "Velg M\xE5ned",
    yearPlaceholder: "Velg \xC5r",
    quarterPlaceholder: "Velg Kvartal",
    startDatePlaceholder: "Start Dato",
    endDatePlaceholder: "Slutt Dato",
    startDatetimePlaceholder: "Start Dato og Tid",
    endDatetimePlaceholder: "Slutt Dato og Tid",
    startMonthPlaceholder: "Start M\xE5ned",
    endMonthPlaceholder: "Slutt M\xE5ned",
    monthBeforeYear: true,
    firstDayOfWeek: 0,
    today: "I Dag"
  },
  DataTable: {
    checkTableAll: "Velg alle i tabellen",
    uncheckTableAll: "Fjern markeringen av alle i tabellen",
    confirm: "Bekreft",
    clear: "T\xF8m",
    apply: "Bruk",
    filters: "Filtere"
  },
  LegacyTransfer: {
    sourceTitle: "Kilde",
    targetTitle: "M\xE5l"
  },
  Transfer: {
    selectAll: "Marker alle",
    unselectAll: "Fjern alle valg",
    clearAll: "T\xF8m"
  },
  Empty: {
    description: "Ingen Data"
  },
  Select: {
    placeholder: "Vennligst Velg"
  },
  TimePicker: {
    placeholder: "Velg Tid",
    positiveText: "OK",
    negativeText: "Avbryt",
    now: "N\xE5"
  },
  Pagination: {
    goto: "G\xE5 til",
    selectionSuffix: "side",
    next: "Neste",
    previous: "Forrige"
  },
  DynamicTags: {
    add: "Legg tid"
  },
  Log: {
    loading: "Laster"
  },
  Input: {
    placeholder: "Vennligst Skriv Inn"
  },
  InputNumber: {
    placeholder: "Vennligst Skriv Inn"
  },
  DynamicInput: {
    create: "Opprett"
  },
  ThemeEditor: {
    title: "Tema Redigerer",
    clearAllVars: "T\xF8m Alle Variabler",
    clearSearch: "T\xF8m S\xF8k",
    filterCompName: "Filtrer Komponentnavn",
    filterVarName: "Filtrer Variabelnavn",
    import: "Importer",
    export: "Eksporter",
    restore: "Tilbakestill til Standard"
  },
  Image: {
    tipPrevious: "Forrige bilde (\u2190)",
    tipNext: "Neste bilde (\u2192)",
    tipCounterclockwise: "Mot klokken",
    tipClockwise: "Med klokken",
    tipZoomOut: "Zoom ut",
    tipZoomIn: "Zoom inn",
    tipClose: "Lukk (Esc)",
    tipOriginalSize: "Zoom til original st\xF8rrelse"
  }
};
const date_pt_BR = {
  name: GHLLanguageKeys.portugueseBrazil,
  locale: ptBR$1
};
const ptBR = {
  name: GHLLanguageKeys.portugueseBrazil,
  global: {
    undo: "Desfazer",
    redo: "Refazer",
    confirm: "Confirmar",
    clear: "Limpar"
  },
  Popconfirm: {
    positiveText: "Confirmar",
    negativeText: "Cancelar"
  },
  Cascader: {
    placeholder: "Por favor, selecione",
    loading: "Carregando",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy/MM",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "yyyy/qqq",
    clear: "Limpar",
    now: "Agora",
    confirm: "Confirmar",
    selectTime: "Selecionar Hor\xE1rio",
    selectDate: "Selecionar Data",
    datePlaceholder: "Selecionar Data",
    datetimePlaceholder: "Selecionar Data e Hora",
    monthPlaceholder: "Selecionar M\xEAs",
    yearPlaceholder: "Selecionar Ano",
    quarterPlaceholder: "Selecionar Trimestre",
    startDatePlaceholder: "Data de In\xEDcio",
    endDatePlaceholder: "Data Final",
    startDatetimePlaceholder: "Data e Hora Inicial",
    endDatetimePlaceholder: "Data e Hora Final",
    startMonthPlaceholder: "M\xEAs de In\xEDcio",
    endMonthPlaceholder: "M\xEAs Final",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "Hoje"
  },
  DataTable: {
    checkTableAll: "Selecionar tudo na tabela",
    uncheckTableAll: "Desmarcar tudo na tabela",
    confirm: "Confirmar",
    clear: "Limpar",
    apply: "Aplicar",
    filters: "Filtros"
  },
  LegacyTransfer: {
    sourceTitle: "Origem",
    targetTitle: "Destino"
  },
  Transfer: {
    selectAll: "Selecionar tudo",
    unselectAll: "Desmarcar tudo",
    clearAll: "Limpar"
  },
  Empty: {
    description: "Sem Dados"
  },
  Select: {
    placeholder: "Por favor, selecione"
  },
  TimePicker: {
    placeholder: "Selecionar Hor\xE1rio",
    positiveText: "OK",
    negativeText: "Cancelar",
    now: "Agora"
  },
  Pagination: {
    goto: "Ir para",
    selectionSuffix: "p\xE1gina",
    next: "Pr\xF3ximo",
    previous: "Anterior"
  },
  DynamicTags: {
    add: "Adicionar"
  },
  Log: {
    loading: "Carregando"
  },
  Input: {
    placeholder: "Por favor, insira"
  },
  InputNumber: {
    placeholder: "Por favor, preencha"
  },
  DynamicInput: {
    create: "Criar"
  },
  ThemeEditor: {
    title: "Editor de Tema",
    clearAllVars: "Limpar todas as vari\xE1veis",
    clearSearch: "Limpar Busca",
    filterCompName: "Filtrar Nome do Componente",
    filterVarName: "Filtrar Nome da Vari\xE1vel",
    import: "Importar",
    export: "Exportar",
    restore: "Redefinir para o Padr\xE3o"
  },
  Image: {
    tipPrevious: "Imagem Anterior (\u2190)",
    tipNext: "Pr\xF3xima Imagem (\u2192)",
    tipCounterclockwise: "Sentido Anti-hor\xE1rio",
    tipClockwise: "Sentido Hor\xE1rio",
    tipZoomOut: "Reduzir Zoom",
    tipZoomIn: "Aumentar Zoom",
    tipClose: "Fechar (Esc)",
    tipOriginalSize: "Zoom para Tamanho Original"
  }
};
var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 m\xEAs",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 m\xEAs",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
};
var formatDistance$2 = function(token, count, options) {
  var result2;
  var tokenValue = formatDistanceLocale$1[token];
  if (typeof tokenValue === "string") {
    result2 = tokenValue;
  } else if (count === 1) {
    result2 = tokenValue.one;
  } else {
    result2 = tokenValue.other.replace("{{count}}", String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "daqui a " + result2;
    } else {
      return "h\xE1 " + result2;
    }
  }
  return result2;
};
var formatDistance$3 = formatDistance$2;
var dateFormats$1 = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
};
var timeFormats$1 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats$1 = {
  full: "{{date}} '\xE0s' {{time}}",
  long: "{{date}} '\xE0s' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong$2 = {
  date: buildFormatLongFn$1({
    formats: dateFormats$1,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats$1,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats$1,
    defaultWidth: "full"
  })
};
var formatLong$3 = formatLong$2;
var formatRelativeLocale$1 = {
  lastWeek: function(date4) {
    var weekday = date4.getUTCDay();
    var last = weekday === 0 || weekday === 6 ? "\xFAltimo" : "\xFAltima";
    return "'" + last + "' eeee '\xE0s' p";
  },
  yesterday: "'ontem \xE0s' p",
  today: "'hoje \xE0s' p",
  tomorrow: "'amanh\xE3 \xE0s' p",
  nextWeek: "eeee '\xE0s' p",
  other: "P"
};
var formatRelative$2 = function(token, date4, _baseDate, _options) {
  var format2 = formatRelativeLocale$1[token];
  if (typeof format2 === "function") {
    return format2(date4);
  }
  return format2;
};
var formatRelative$3 = formatRelative$2;
var eraValues$1 = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
};
var quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
};
var monthValues$1 = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
  wide: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
};
var dayValues$1 = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
  wide: ["domingo", "segunda-feira", "ter\xE7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\xE1bado"]
};
var dayPeriodValues$1 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manh\xE3",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
};
var formattingDayPeriodValues$1 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manh\xE3",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
};
var ordinalNumber$1 = function(dirtyNumber, _options) {
  var number4 = Number(dirtyNumber);
  return number4 + "\xBA";
};
var localize$2 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn$1({
    values: eraValues$1,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues$1,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues$1,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide"
  })
};
var localize$3 = localize$2;
var matchOrdinalNumberPattern$1 = /^(\d+)(º|ª)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var parseEraPatterns$1 = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$1 = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var parseDayPatterns$1 = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
};
var match$2 = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any"
  })
};
var match$3 = match$2;
var locale$1 = {
  code: "pt",
  formatDistance: formatDistance$3,
  formatLong: formatLong$3,
  formatRelative: formatRelative$3,
  localize: localize$3,
  match: match$3,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var pt = locale$1;
const date_pt_PT = {
  name: GHLLanguageKeys.portuguesePortugal,
  locale: pt
};
const ptPT = {
  name: GHLLanguageKeys.portuguesePortugal,
  global: {
    undo: "Desfazer",
    redo: "Refazer",
    confirm: "Confirmar",
    clear: "Claro"
  },
  Popconfirm: {
    positiveText: "Confirmar",
    negativeText: "Cancelar"
  },
  Cascader: {
    placeholder: "Por favor, selecione",
    loading: "A carregar",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy/MM",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "yyyy/qqq",
    clear: "Claro",
    now: "Agora",
    confirm: "Confirmar",
    selectTime: "Selecionar Tempo",
    selectDate: "Selecionar Data",
    datePlaceholder: "Selecionar Data",
    datetimePlaceholder: "Selecionar Data e Hora",
    monthPlaceholder: "Selecionar M\xEAs",
    yearPlaceholder: "Selecionar Ano",
    quarterPlaceholder: "Selecionar Trimestre",
    startDatePlaceholder: "Data de In\xEDcio",
    endDatePlaceholder: "Data de t\xE9rmino",
    startDatetimePlaceholder: "Data e Hora de In\xEDcio",
    endDatetimePlaceholder: "Data e Hora de Fim",
    startMonthPlaceholder: "M\xEAs de In\xEDcio",
    endMonthPlaceholder: "Fim do m\xEAs",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "Hoje"
  },
  DataTable: {
    checkTableAll: "Selecione tudo na tabela",
    uncheckTableAll: "Desmarcar tudo na tabela",
    confirm: "Confirmar",
    clear: "Claro",
    apply: "Aplicar",
    filters: "Filtros"
  },
  LegacyTransfer: {
    sourceTitle: "Fonte",
    targetTitle: "Alvo"
  },
  Transfer: {
    selectAll: "Selecionar tudo",
    unselectAll: "Desmarcar tudo",
    clearAll: "Claro"
  },
  Empty: {
    description: "Sem Dados"
  },
  Select: {
    placeholder: "Por favor, selecione"
  },
  TimePicker: {
    placeholder: "Selecionar Tempo",
    positiveText: "OK",
    negativeText: "Cancelar",
    now: "Agora"
  },
  Pagination: {
    goto: "Ir para",
    selectionSuffix: "p\xE1gina",
    next: "Seguinte",
    previous: "Anterior"
  },
  DynamicTags: {
    add: "Adicionar"
  },
  Log: {
    loading: "A carregar"
  },
  Input: {
    placeholder: "Por favor, introduza"
  },
  InputNumber: {
    placeholder: "Por favor, introduza"
  },
  DynamicInput: {
    create: "Criar"
  },
  ThemeEditor: {
    title: "Editor de Temas",
    clearAllVars: "Limpar todas as vari\xE1veis",
    clearSearch: "Limpar pesquisa",
    filterCompName: "Nome do Componente de Filtro",
    filterVarName: "Nome da Vari\xE1vel de Filtro",
    import: "Importar",
    export: "Exportar",
    restore: "Repor para o Padr\xE3o"
  },
  Image: {
    tipPrevious: "Imagem anterior (\u2190)",
    tipNext: "Pr\xF3xima Imagem (\u2192)",
    tipCounterclockwise: "Anticlockwise",
    tipClockwise: "No sentido dos ponteiros do rel\xF3gio",
    tipZoomOut: "Afastar o zoom",
    tipZoomIn: "Ampliar",
    tipClose: "Fechar (Esc)",
    tipOriginalSize: "Ampliar para o tamanho original"
  }
};
const date_es = {
  name: GHLLanguageKeys.spanish,
  locale: es$2
};
const es = {
  name: GHLLanguageKeys.spanish,
  global: {
    undo: "Deshacer",
    redo: "Rehacer",
    confirm: "Confirmar",
    clear: "Limpiar"
  },
  Popconfirm: {
    positiveText: "Confirmar",
    negativeText: "Cancelar"
  },
  Cascader: {
    placeholder: "Por favor Seleccionar",
    loading: "Cargando",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Limpiar",
    now: "Ahora",
    confirm: "Confirmar",
    selectTime: "Seleccionar Hora",
    selectDate: "Seleccionar Fecha",
    datePlaceholder: "Seleccionar Fecha",
    datetimePlaceholder: "Seleccionar Fecha y Hora",
    monthPlaceholder: "Seleccionar Mes",
    yearPlaceholder: "Seleccionar A\xF1o",
    quarterPlaceholder: "Seleccionar Trimestre",
    startDatePlaceholder: "Fecha de Inicio",
    endDatePlaceholder: "Fecha Final",
    startDatetimePlaceholder: "Fecha y Hora de Inicio",
    endDatetimePlaceholder: "Fecha Hora Final",
    monthBeforeYear: true,
    startMonthPlaceholder: "Mes de Inicio",
    endMonthPlaceholder: "Mes final",
    firstDayOfWeek: 6,
    today: "Hoy"
  },
  DataTable: {
    checkTableAll: "Seleccionar todo en la tabla",
    uncheckTableAll: "Deseleccionar todo en la tabla",
    confirm: "Confirmar",
    clear: "Limpiar",
    apply: "Aplicar",
    filters: "Filtros"
  },
  LegacyTransfer: {
    sourceTitle: "Origen",
    targetTitle: "Objetivo"
  },
  Transfer: {
    selectAll: "Seleccionar Todos",
    unselectAll: "Deseleccionar todos",
    clearAll: "Limpiar"
  },
  Empty: {
    description: "Sin datos"
  },
  Select: {
    placeholder: "Por favor selecciona"
  },
  TimePicker: {
    placeholder: "Seleccionar hora",
    positiveText: "De acuerdo",
    negativeText: "Cancelar",
    now: "Ahora"
  },
  Pagination: {
    goto: "Ir a",
    selectionSuffix: "Pagina",
    next: "Siguiente",
    previous: "Anterior"
  },
  DynamicTags: {
    add: "Agregar"
  },
  Log: {
    loading: "Cargando"
  },
  Input: {
    placeholder: "Por favor, entrada"
  },
  InputNumber: {
    placeholder: "Por favor, entrada"
  },
  DynamicInput: {
    create: "Crear"
  },
  ThemeEditor: {
    title: "Editor de Tema",
    clearAllVars: "Limpiar todas las variables",
    clearSearch: "Limpiar b\xFAsqueda",
    filterCompName: "Filtrar nombre del componente",
    filterVarName: "Filtrar variable de nombre",
    import: "Importar",
    export: "Exportar",
    restore: "restablecer a predeterminado"
  },
  Image: {
    tipPrevious: "Foto anterior (\u2190)",
    tipNext: "Siguiente foto (\u2192)",
    tipCounterclockwise: "Sentido contrario a las agujas del reloj",
    tipClockwise: "Sentido de las agujas del reloj",
    tipZoomOut: "Zoom out",
    tipZoomIn: "Zoom in",
    tipClose: "Cerrar (Esc)",
    tipOriginalSize: "Zoom al tama\xF1o original"
  }
};
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "mindre \xE4n en sekund",
    other: "mindre \xE4n {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre \xE4n en minut",
    other: "mindre \xE4n {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungef\xE4r en timme",
    other: "ungef\xE4r {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungef\xE4r en vecka",
    other: "ungef\xE4r {{count}} vecka"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} vecka"
  },
  aboutXMonths: {
    one: "ungef\xE4r en m\xE5nad",
    other: "ungef\xE4r {{count}} m\xE5nader"
  },
  xMonths: {
    one: "en m\xE5nad",
    other: "{{count}} m\xE5nader"
  },
  aboutXYears: {
    one: "ungef\xE4r ett \xE5r",
    other: "ungef\xE4r {{count}} \xE5r"
  },
  xYears: {
    one: "ett \xE5r",
    other: "{{count}} \xE5r"
  },
  overXYears: {
    one: "\xF6ver ett \xE5r",
    other: "\xF6ver {{count}} \xE5r"
  },
  almostXYears: {
    one: "n\xE4stan ett \xE5r",
    other: "n\xE4stan {{count}} \xE5r"
  }
};
var wordMapping = ["noll", "en", "tv\xE5", "tre", "fyra", "fem", "sex", "sju", "\xE5tta", "nio", "tio", "elva", "tolv"];
var formatDistance = function(token, count, options) {
  var result2;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result2 = tokenValue;
  } else if (count === 1) {
    result2 = tokenValue.one;
  } else {
    if (options && options.onlyNumeric) {
      result2 = tokenValue.other.replace("{{count}}", String(count));
    } else {
      result2 = tokenValue.other.replace("{{count}}", count < 13 ? wordMapping[count] : String(count));
    }
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "om " + result2;
    } else {
      return result2 + " sedan";
    }
  }
  return result2;
};
var formatDistance$1 = formatDistance;
var dateFormats = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
};
var timeFormats = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
};
var dateTimeFormats = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
};
var formatLong = {
  date: buildFormatLongFn$1({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
var formatLong$1 = formatLong;
var formatRelativeLocale = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'ig\xE5r kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
};
var formatRelative = function(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative$1 = formatRelative;
var eraValues = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["f\xF6re Kristus", "efter Kristus"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
};
var dayValues = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["s\xF6", "m\xE5", "ti", "on", "to", "fr", "l\xF6"],
  abbreviated: ["s\xF6n", "m\xE5n", "tis", "ons", "tors", "fre", "l\xF6r"],
  wide: ["s\xF6ndag", "m\xE5ndag", "tisdag", "onsdag", "torsdag", "fredag", "l\xF6rdag"]
};
var dayPeriodValues = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kv\xE4ll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kv\xE4ll",
    night: "natt"
  },
  wide: {
    am: "f\xF6rmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kv\xE4ll",
    night: "natt"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morg.",
    afternoon: "p\xE5 efterm.",
    evening: "p\xE5 kv\xE4llen",
    night: "p\xE5 natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morg.",
    afternoon: "p\xE5 efterm.",
    evening: "p\xE5 kv\xE4llen",
    night: "p\xE5 natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "p\xE5 morgonen",
    afternoon: "p\xE5 eftermiddagen",
    evening: "p\xE5 kv\xE4llen",
    night: "p\xE5 natten"
  }
};
var ordinalNumber = function(dirtyNumber, _options) {
  var number4 = Number(dirtyNumber);
  var rem100 = number4 % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
      case 2:
        return number4 + ":a";
    }
  }
  return number4 + ":e";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn$1({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn$1({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
var localize$1 = localize;
var matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var parseEraPatterns = {
  any: [/^f/i, /^[ev]/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var parseDayPatterns = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
var matchDayPeriodPatterns = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function(value2) {
      return parseInt(value2, 10);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
var match$1 = match;
var locale = {
  code: "sv",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
var sv$1 = locale;
const date_sv = {
  name: GHLLanguageKeys.swedish,
  locale: sv$1
};
const sv = {
  name: GHLLanguageKeys.swedish,
  global: {
    undo: "\xC5ngra",
    redo: "Klar",
    confirm: "Bekr\xE4fta",
    clear: "Klar"
  },
  Popconfirm: {
    positiveText: "Bekr\xE4fta",
    negativeText: "Avbryt"
  },
  Cascader: {
    placeholder: "V\xE4nligen v\xE4lj",
    loading: "Laddar",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Klar",
    now: "Nu",
    confirm: "Bekr\xE4fta",
    selectTime: "V\xE4lj tidpunkt",
    selectDate: "V\xE4lj datum",
    datePlaceholder: "V\xE4lj datum",
    datetimePlaceholder: "V\xE4lj datum och tid",
    monthPlaceholder: "V\xE4lj m\xE5nad",
    yearPlaceholder: "V\xE4lj \xE5r",
    quarterPlaceholder: "V\xE4lj kvartal",
    startDatePlaceholder: "Startdatum",
    endDatePlaceholder: "Slutdatum",
    startDatetimePlaceholder: "Startdatum och tid",
    endDatetimePlaceholder: "Slutdatum och tidpunkt",
    startMonthPlaceholder: "Startm\xE5nad",
    endMonthPlaceholder: "Slutet av m\xE5naden",
    monthBeforeYear: true,
    firstDayOfWeek: 6,
    today: "Idag"
  },
  DataTable: {
    checkTableAll: "V\xE4lj allt i tabellen",
    uncheckTableAll: "Avmarkera allt i tabellen",
    confirm: "Bekr\xE4fta",
    clear: "Klar",
    apply: "Ans\xF6k",
    filters: "Filter"
  },
  LegacyTransfer: {
    sourceTitle: "K\xE4lla",
    targetTitle: "M\xE5l"
  },
  Transfer: {
    selectAll: "Markera alla",
    unselectAll: "Avmarkera alla",
    clearAll: "Tydlig"
  },
  Empty: {
    description: "Inget data"
  },
  Select: {
    placeholder: "V\xE4lj"
  },
  TimePicker: {
    placeholder: "V\xE4lj tid",
    positiveText: "OK",
    negativeText: "Avbryt",
    now: "Nu"
  },
  Pagination: {
    goto: "G\xE5 till",
    selectionSuffix: "sida",
    next: "N\xE4sta",
    previous: "F\xF6reg\xE5ende"
  },
  DynamicTags: {
    add: "L\xE4gg till"
  },
  Log: {
    loading: "L\xE4ser in"
  },
  Input: {
    placeholder: "V\xE4nligen ange"
  },
  InputNumber: {
    placeholder: "Var v\xE4nlig ange"
  },
  DynamicInput: {
    create: "Skapa"
  },
  ThemeEditor: {
    title: "Teman Redigerare",
    clearAllVars: "Rensa alla variabler",
    clearSearch: "Rensa s\xF6kning",
    filterCompName: "Filterkomponentnamn",
    filterVarName: "Filter Variabelnamn",
    import: "Importera",
    export: "Export",
    restore: "\xC5terst\xE4ll till standardinst\xE4llningar"
  },
  Image: {
    tipPrevious: "F\xF6reg\xE5ende bild (\u2190)",
    tipNext: "N\xE4sta bild (\u2192)",
    tipCounterclockwise: "Moturs",
    tipClockwise: "Medurs",
    tipZoomOut: "Zooma ut",
    tipZoomIn: "Zooma in",
    tipClose: "St\xE4ng (Esc)",
    tipOriginalSize: "Zooma till originalstorlek"
  }
};
const theme = {
  name: "common",
  common: {
    name: "common",
    fontFamily: 'Inter var, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji""',
    fontFamilyMono: "v-mono, SFMono-Regular, Menlo, Consolas, Courier, monospace",
    fontWeight: "400",
    fontWeightStrong: "500",
    cubicBezierEaseInOut: "cubic-bezier(.4, 0, .2, 1)",
    cubicBezierEaseOut: "cubic-bezier(0, 0, .2, 1)",
    cubicBezierEaseIn: "cubic-bezier(.4, 0, 1, 1)",
    borderRadius: "3px",
    borderRadiusSmall: "2px",
    fontSize: "14px",
    fontSizeMini: "12px",
    fontSizeTiny: "12px",
    fontSizeSmall: "14px",
    fontSizeMedium: "14px",
    fontSizeLarge: "15px",
    fontSizeHuge: "16px",
    lineHeight: "1.6",
    heightMini: "16px",
    heightTiny: "22px",
    heightSmall: "28px",
    heightMedium: "34px",
    heightLarge: "40px",
    heightHuge: "46px",
    baseColor: "#FFF",
    primaryColor: "#155EEF",
    primaryColorHover: "#004EEB",
    primaryColorPressed: "#155EEF",
    primaryColorSuppl: "#155EEF",
    infoColor: "#2080f0",
    infoColorHover: "#4098fc",
    infoColorPressed: "#1060c9",
    infoColorSuppl: "#4098fc",
    successColor: "#155EEF",
    successColorHover: "#155EEF",
    successColorPressed: "#004EEB",
    successColorSuppl: "#155EEF",
    warningColor: "#f0a020",
    warningColorHover: "#fcb040",
    warningColorPressed: "#c97c10",
    warningColorSuppl: "#fcb040",
    errorColor: "#D92D20",
    errorColorHover: "#B42318",
    errorColorPressed: "#D92D20",
    errorColorSuppl: "#D92D20",
    textColorBase: "#000",
    textColor1: "rgba(16, 24, 40, 1)",
    textColor2: "rgba(52, 64, 84, 1)",
    textColor3: "rgb(118, 124, 130)",
    textColorDisabled: "rgba(194, 194, 194, 1)",
    placeholderColor: "rgba(102, 112, 133, 1)",
    placeholderColorDisabled: "rgba(209, 209, 209, 1)",
    iconColor: "rgba(194, 194, 194, 1)",
    iconColorHover: "rgba(146, 146, 146, 1)",
    iconColorPressed: "rgba(175, 175, 175, 1)",
    iconColorDisabled: "rgba(209, 209, 209, 1)",
    opacity1: "0.82",
    opacity2: "0.72",
    opacity3: "0.38",
    opacity4: "0.24",
    opacity5: "0.18",
    dividerColor: "rgb(239, 239, 245)",
    borderColor: "rgb(224, 224, 230)",
    closeIconColor: "rgba(102, 102, 102, 1)",
    closeIconColorHover: "rgba(102, 102, 102, 1)",
    closeIconColorPressed: "rgba(102, 102, 102, 1)",
    closeColorHover: "rgba(0, 0, 0, .09)",
    closeColorPressed: "rgba(0, 0, 0, .13)",
    clearColor: "rgba(194, 194, 194, 1)",
    clearColorHover: "rgba(146, 146, 146, 1)",
    clearColorPressed: "rgba(175, 175, 175, 1)",
    scrollbarColor: "rgba(0, 0, 0, 0.25)",
    scrollbarColorHover: "rgba(0, 0, 0, 0.4)",
    scrollbarWidth: "5px",
    scrollbarHeight: "5px",
    scrollbarBorderRadius: "5px",
    progressRailColor: "rgba(235, 235, 235, 1)",
    railColor: "rgb(219, 219, 223)",
    popoverColor: "#fff",
    tableColor: "#fff",
    cardColor: "#fff",
    modalColor: "#fff",
    bodyColor: "#fff",
    tagColor: "#eee",
    avatarColor: "rgba(204, 204, 204, 1)",
    invertedColor: "rgb(0, 20, 40)",
    inputColor: "rgba(255, 255, 255, 1)",
    codeColor: "rgb(244, 244, 248)",
    tabColor: "rgb(247, 247, 250)",
    actionColor: "rgb(250, 250, 252)",
    tableHeaderColor: "rgb(250, 250, 252)",
    hoverColor: "rgb(243, 243, 245)",
    tableColorHover: "rgba(0, 0, 100, 0.03)",
    tableColorStriped: "rgba(0, 0, 100, 0.02)",
    pressedColor: "rgb(237, 237, 239)",
    opacityDisabled: "0.5",
    inputColorDisabled: "rgb(250, 250, 252)",
    buttonColor2: "rgba(46, 51, 56, .05)",
    buttonColor2Hover: "rgba(46, 51, 56, .09)",
    buttonColor2Pressed: "rgba(46, 51, 56, .13)",
    boxShadow1: "0 1px 2px -2px rgba(0, 0, 0, .08), 0 3px 6px 0 rgba(0, 0, 0, .06), 0 5px 12px 4px rgba(0, 0, 0, .04)",
    boxShadow2: "0 3px 6px -4px rgba(0, 0, 0, .12), 0 6px 16px 0 rgba(0, 0, 0, .08), 0 9px 28px 8px rgba(0, 0, 0, .05)",
    boxShadow3: "0 6px 16px -9px rgba(0, 0, 0, .08), 0 9px 28px 0 rgba(0, 0, 0, .05), 0 12px 48px 16px rgba(0, 0, 0, .03)"
  }
};
const themeOverrides = {
  Notification: {
    common: {
      successColor: "#039855",
      infoColor: "#155EEF",
      warningColor: "#DC6803",
      errorColor: "#D92D20"
    }
  },
  Badge: {
    common: {
      successColor: "var(--success-600)",
      infoColor: "var(--primary-600)"
    }
  }
};
var override = "";
var ContentWrap_vue_vue_type_style_index_0_lang = "";
const __default__$m = defineComponent({
  name: "UIContentWrap",
  inheritAttrs: true
});
const _sfc_main$o = defineComponent(__spreadProps(__spreadValues({}, __default__$m), {
  props: {
    fullScreen: {
      type: Boolean,
      default: false
    },
    locale: {
      type: String,
      default: GHLLanguageKeys.englishUS
    }
  },
  setup(__props) {
    const props = __props;
    const languageLocale = ref(enUS);
    const dateLocale = ref(date_en_US);
    const provideLocales = () => {
      const transformedLanguage = function() {
        if (!(props == null ? void 0 : props.locale)) {
          return GHLLanguageKeys.englishUS;
        }
        if (props.locale.includes("_")) {
          console.warn(`Deprecated used of '_' in the language '${props.locale}', please change to use hyphen '-'.`);
          return props.locale.replace("_", "-");
        }
        return props.locale;
      }();
      switch (transformedLanguage) {
        case GHLLanguageKeys.englishUS:
        default: {
          languageLocale.value = enUS;
          dateLocale.value = date_en_US;
          break;
        }
        case GHLLanguageKeys.danish: {
          languageLocale.value = da;
          dateLocale.value = date_da;
          break;
        }
        case GHLLanguageKeys.dutch: {
          languageLocale.value = nl;
          dateLocale.value = date_nl;
          break;
        }
        case GHLLanguageKeys.finnish: {
          languageLocale.value = fi;
          dateLocale.value = date_fi;
          break;
        }
        case GHLLanguageKeys.frenchCanada: {
          languageLocale.value = frCA;
          dateLocale.value = date_fr_CA;
          break;
        }
        case GHLLanguageKeys.frenchFrance: {
          languageLocale.value = frFR;
          dateLocale.value = date_fr_FR;
          break;
        }
        case GHLLanguageKeys.german: {
          languageLocale.value = de;
          dateLocale.value = date_de;
          break;
        }
        case GHLLanguageKeys.italian: {
          languageLocale.value = it;
          dateLocale.value = date_it;
          break;
        }
        case GHLLanguageKeys.norwegian: {
          languageLocale.value = no;
          dateLocale.value = date_no;
          break;
        }
        case GHLLanguageKeys.portuguesePortugal: {
          languageLocale.value = ptPT;
          dateLocale.value = date_pt_PT;
          break;
        }
        case GHLLanguageKeys.portugueseBrazil: {
          languageLocale.value = ptBR;
          dateLocale.value = date_pt_BR;
          break;
        }
        case GHLLanguageKeys.spanish: {
          languageLocale.value = es;
          dateLocale.value = date_es;
          break;
        }
        case GHLLanguageKeys.swedish: {
          languageLocale.value = sv;
          dateLocale.value = date_sv;
          break;
        }
      }
    };
    onMounted(() => {
      provideLocales();
    });
    onUpdated(() => {
      provideLocales();
    });
    provide("customLocale", languageLocale);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["font-sans hl-wrapper-container", { "full-screen": __props.fullScreen }])
      }, [
        createVNode(unref(NConfigProvider), {
          theme: unref(theme),
          "theme-overrides": unref(themeOverrides),
          locale: languageLocale.value,
          "date-locale": dateLocale.value
        }, {
          default: withCtx(() => [
            createVNode(unref(NNotificationProvider), null, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["theme", "theme-overrides", "locale", "date-locale"])
      ], 2);
    };
  }
}));
_sfc_main$o.install = (Vue) => {
  Vue.component(_sfc_main$o.name, _sfc_main$o);
};
const __default__$l = defineComponent({
  name: "UIDataTable"
});
const _sfc_main$n = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$l), {
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NDataTable), normalizeProps(guardReactiveProps(_ctx.$attrs)), null, 16);
    };
  }
}));
_sfc_main$n.install = (Vue) => {
  Vue.component(_sfc_main$n.name, _sfc_main$n);
};
const __default__$k = defineComponent({
  name: "UIDatepicker"
});
const _sfc_main$m = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$k), {
  props: {
    type: {
      type: String,
      default: "date"
    },
    clearable: {
      type: Boolean,
      default: false
    },
    panel: {
      type: Boolean,
      default: false
    },
    isDateDisabled: {
      type: Function
    },
    isTimeDisabled: {
      type: Function
    },
    disabled: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    shortcuts: {
      type: Object,
      default: void 0
    },
    value: {
      type: [Number, Array]
    },
    defaultValue: {
      type: [Number, Array]
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NDatePicker), mergeProps({ id: __props.id }, _ctx.$attrs, {
        disabled: __props.disabled,
        "is-date-disabled": __props.isDateDisabled,
        "is-time-disabled": __props.isTimeDisabled,
        panel: __props.panel,
        value: __props.value,
        "default-value": __props.defaultValue,
        "onUpdate:value": _cache[0] || (_cache[0] = (e25) => _ctx.$emit("update:value", e25)),
        clearable: __props.clearable,
        type: __props.type,
        size: "large",
        shortcuts: __props.shortcuts
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "disabled", "is-date-disabled", "is-time-disabled", "panel", "value", "default-value", "clearable", "type", "shortcuts"]);
    };
  }
}));
_sfc_main$m.install = (Vue) => {
  Vue.component(_sfc_main$m.name, _sfc_main$m);
};
var dragHandler = "data:image/svg+xml;base64,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";
var Element_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$b = ["id"];
const _hoisted_2$a = ["src"];
const _hoisted_3$9 = { class: "gui__builder-card--icon" };
const __default__$j = defineComponent({
  name: "UIDraggableElement",
  inheritAttrs: false,
  components: { UITextXsMedium: _sfc_main$1d }
});
const _sfc_main$l = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$j), {
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    icon: {
      type: Function,
      default: null
    },
    disabled: Boolean
  },
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["gui__builder-card", __props.disabled ? "disabled" : ""]),
        id: __props.id,
        tabindex: "0"
      }, [
        createElementVNode("img", {
          src: unref(dragHandler),
          class: "gui__builder-card--handler",
          draggable: "false"
        }, null, 8, _hoisted_2$a),
        createElementVNode("div", _hoisted_3$9, [
          unref(slots).icon ? renderSlot(_ctx.$slots, "icon", { key: 0 }) : (openBlock(), createBlock(resolveDynamicComponent(__props.icon), {
            key: 1,
            class: "w-8 h-8 p-2 text-gray-600"
          }))
        ]),
        createVNode(unref(_sfc_main$1d), { class: "gui__builder-card--label" }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(__props.label), 1)
          ]),
          _: 1
        })
      ], 10, _hoisted_1$b);
    };
  }
}));
_sfc_main$l.install = (Vue) => {
  Vue.component(_sfc_main$l.name, _sfc_main$l);
};
var BreadCrumb_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$a = {
  key: 0,
  class: "dropdown-tree__breadcrumb"
};
const _hoisted_2$9 = { class: "dropdown-tree__breadcrumb-content" };
const _hoisted_3$8 = { class: "dropdown-tree__breadcrumb-title" };
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "BreadCrumb",
  props: {
    disabled: Boolean,
    title: String,
    show: Boolean,
    icon: Function,
    iconClass: String
  },
  emits: ["onClick"],
  setup(__props, { emit }) {
    return (_ctx, _cache) => {
      return __props.show ? (openBlock(), createElementBlock("div", _hoisted_1$a, [
        createVNode(unref(_sfc_main$1l), {
          id: "dropdown-backward-traversal",
          text: "",
          onClick: _cache[0] || (_cache[0] = ($event) => emit("onClick")),
          disabled: __props.disabled
        }, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_2$9, [
              createVNode(unref(render$45), { class: "w-5 h-5" }),
              createElementVNode("span", _hoisted_3$8, [
                (openBlock(), createBlock(resolveDynamicComponent(__props.icon), {
                  class: normalizeClass(__props.iconClass)
                }, null, 8, ["class"])),
                createVNode(unref(NEllipsis), {
                  style: { "max-width": "250px" },
                  tooltip: false
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString(__props.title), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["disabled"])
      ])) : createCommentVNode("", true);
    };
  }
});
var BreadCrumb = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["__scopeId", "data-v-565aecec"]]);
var DropdownItem_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$9 = ["onClick"];
const _hoisted_2$8 = { class: "flex gap-1" };
const _hoisted_3$7 = { class: "dropdown-tree__item--path" };
const _hoisted_4$6 = /* @__PURE__ */ createTextVNode(" " + /* @__PURE__ */ toDisplayString("/"));
const _hoisted_5$4 = { class: "dropdown-tree__item--label" };
const _hoisted_6$4 = {
  key: 0,
  class: "dropdown-tree__item--icon"
};
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "DropdownItem",
  props: {
    options: {
      type: Array,
      default: () => []
    },
    showPath: {
      type: Boolean,
      default: false
    }
  },
  emits: ["onForwardTraverse", "onSelect"],
  setup(__props, { emit }) {
    const handleClick2 = (option) => {
      var _a2;
      if (!option.disabled && ((_a2 = option.children) == null ? void 0 : _a2.length)) {
        emit("onForwardTraverse", option);
      } else {
        emit("onSelect", option.value);
      }
    };
    const getCurrentPath = (path) => {
      if (!path)
        return null;
      return path == null ? void 0 : path.split("/").filter(Boolean).at(-1);
    };
    return (_ctx, _cache) => {
      return openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (option) => {
        var _a2;
        return openBlock(), createElementBlock("a", {
          key: option.label.toString(),
          class: normalizeClass(["dropdown-tree__item", [option == null ? void 0 : option.className, option.disabled ? "disabled" : ""]]),
          onClick: () => handleClick2(option)
        }, [
          createElementVNode("span", _hoisted_2$8, [
            __props.showPath && option._pathFromRoot !== "/" ? (openBlock(), createBlock(unref(_sfc_main$11), {
              key: 0,
              disabled: !__props.showPath && option._pathFromRoot
            }, {
              trigger: withCtx(() => [
                createElementVNode("span", _hoisted_3$7, [
                  createVNode(unref(NEllipsis), {
                    class: "dropdown-tree__item--path-label",
                    tooltip: false
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(getCurrentPath(option._pathFromRoot)), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _hoisted_4$6
                ])
              ]),
              default: withCtx(() => [
                createTextVNode(" " + toDisplayString(option == null ? void 0 : option._pathFromRoot), 1)
              ]),
              _: 2
            }, 1032, ["disabled"])) : createCommentVNode("", true),
            createElementVNode("span", _hoisted_5$4, [
              (openBlock(), createBlock(resolveDynamicComponent(option.icon), {
                class: normalizeClass(option.iconClass)
              }, null, 8, ["class"])),
              createVNode(unref(NEllipsis), {
                class: normalizeClass(__props.showPath ? "showPath" : ""),
                tooltip: false
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(option.label), 1)
                ]),
                _: 2
              }, 1032, ["class"])
            ])
          ]),
          ((_a2 = option.children) == null ? void 0 : _a2.length) ? (openBlock(), createElementBlock("span", _hoisted_6$4, [
            option.customArrow ? (openBlock(), createBlock(resolveDynamicComponent(option == null ? void 0 : option.customArrow), {
              key: 0,
              class: normalizeClass(option == null ? void 0 : option.arrowClass)
            }, null, 8, ["class"])) : (openBlock(), createBlock(unref(render$41), {
              key: 1,
              class: "chevron"
            }))
          ])) : createCommentVNode("", true)
        ], 10, _hoisted_1$9);
      }), 128);
    };
  }
});
var DropdownItem = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["__scopeId", "data-v-1449dac1"]]);
const getObjectByPath = ({
  path,
  options,
  pathSeparator = "/"
}) => {
  const paths = path.split(pathSeparator).filter(Boolean);
  let currentOptions = options;
  for (const path2 of paths) {
    const matchingOption = currentOptions.find((option) => option.value === path2);
    if (!matchingOption) {
      return null;
    }
    currentOptions = matchingOption.children || [];
  }
  return lodash.exports.uniqBy(currentOptions, "value");
};
const showDebugging = (eventName, output) => {
  console.log(eventName, output);
};
const getFlattenedOptions = (nodes) => {
  const flattened2 = [];
  const flatten2 = (node2, path = "/") => {
    const _a2 = node2, { label, value: value2, children } = _a2, rest = __objRest(_a2, ["label", "value", "children"]);
    const flattenedNode = __spreadValues({ label, value: value2, _pathFromRoot: path }, rest);
    if (children) {
      flattened2.push(__spreadProps(__spreadValues({}, flattenedNode), { type: "parent" }));
      children.forEach((child) => flatten2(child, `${path}${label}/`));
    } else {
      flattened2.push(flattenedNode);
    }
  };
  nodes.forEach((node2) => flatten2(node2));
  return lodash.exports.uniqBy(flattened2, "value");
};
var DropdownTree_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$8 = { class: "dropdown-tree__container" };
const _hoisted_2$7 = { class: "dropdown-tree__search" };
const _hoisted_3$6 = { key: 0 };
const _hoisted_4$5 = {
  key: 1,
  class: "no-data"
};
const _hoisted_5$3 = { key: 1 };
const _hoisted_6$3 = {
  key: 1,
  class: "empty-search"
};
const __default__$i = defineComponent({
  name: "UIDropdownTree",
  inheritAttrs: false,
  components: { UIInput: _sfc_main$16, UIButton: _sfc_main$1l, BreadCrumb, DropdownItem, NInput }
});
const _sfc_main$i = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$i), {
  props: {
    options: {
      type: Array,
      default: () => []
    },
    pathSeparator: {
      type: String,
      default: "/"
    },
    disabled: Boolean,
    triggerLabel: String,
    debug: Boolean,
    placement: String,
    loading: Boolean,
    remote: Boolean,
    searchPlaceholder: {
      type: String,
      required: false,
      default: "Search"
    },
    trigger: {
      type: String,
      default: "click"
    }
  },
  emits: ["onSelect", "onSearch"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const flattenedOptions = computed(() => {
      const options = getFlattenedOptions(props.options).filter((option) => option.type !== "parent");
      if (props.debug) {
        showDebugging(`flattenedOptions`, options);
      }
      return options;
    });
    const flattenedParents = computed(() => {
      const options = getFlattenedOptions(props.options).filter((option) => option.type === "parent");
      if (props.debug) {
        showDebugging(`flattenedParents`, options);
      }
      return options;
    });
    const currentTree = ref(props.options);
    watch(() => props.options, (updateOptions) => {
      currentTree.value = updateOptions;
    });
    const currentPath = ref("");
    const pathSeparator = ref(props.pathSeparator);
    const searchString = ref(null);
    const slots = useSlots();
    const isSearching = ref(false);
    const handleForwardTraversal = (value2) => {
      var _a2, _b2;
      if (!((_a2 = currentPath.value) == null ? void 0 : _a2.includes(value2))) {
        if (currentPath.value) {
          currentPath.value += `${value2}${pathSeparator.value}`;
        } else {
          currentPath.value += `${value2}${pathSeparator.value}`;
        }
        currentTree.value = (_b2 = getObjectByPath({ options: props.options, path: currentPath.value })) != null ? _b2 : [];
        if (props.debug) {
          showDebugging(`handleForwardTraversal(${value2})`, `${JSON.stringify(currentTree.value)}   ${currentPath.value}`);
        }
      }
    };
    const handleBackwardTraversal = (path) => {
      var _a2;
      const paths = path.split(pathSeparator.value).filter(Boolean);
      const updatedPath = paths.slice(0, paths.length - 1).join(pathSeparator.value);
      currentPath.value = updatedPath ? `${updatedPath}${pathSeparator.value}` : "";
      currentTree.value = (_a2 = getObjectByPath({ options: props.options, path: updatedPath })) != null ? _a2 : [];
      if (props.debug) {
        showDebugging(`handleBackwardTraversal(${path})`, currentTree.value);
      }
    };
    const currentViewTitle = computed(() => {
      const path = currentPath.value.split(pathSeparator.value).filter(Boolean).at(-1);
      const currentOption = flattenedParents.value.find((option) => option.value === path);
      if (props.debug) {
        showDebugging(`[Computed] currentViewTitle for ${path} is`, currentOption);
      }
      return currentOption;
    });
    const handleSearch = (value2) => {
      currentPath.value = "";
      isSearching.value = true;
      if (props.remote) {
        emits("onSearch", value2);
      } else if (value2) {
        const filteredValues = flattenedOptions.value.filter((option) => option.label.toLowerCase().includes(value2.toLowerCase()));
        currentTree.value = filteredValues;
      } else {
        currentTree.value = props.options;
        isSearching.value = false;
      }
      if (props.debug) {
        showDebugging(`handleSearch with remote ${props.remote} and search string is ${value2}`, currentTree.value);
      }
    };
    watch(() => searchString, lodash.exports.debounce((searchString2) => {
      handleSearch(searchString2.value);
    }, 300), { deep: true });
    const handlePopperClose = () => {
      setTimeout(() => {
        currentTree.value = props.options;
        searchString.value = null;
        currentPath.value = "";
      }, 300);
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NPopover), {
        raw: "",
        class: "dropdown-tree",
        disabled: __props.disabled,
        "show-arrow": false,
        trigger: __props.trigger,
        onClickoutside: handlePopperClose,
        placement: __props.placement
      }, {
        trigger: withCtx(() => [
          unref(slots).trigger ? renderSlot(_ctx.$slots, "trigger", {
            key: 0,
            disabled: __props.disabled
          }, void 0, true) : (openBlock(), createBlock(unref(_sfc_main$1l), {
            key: 1,
            id: "dropdown-tree__trigger",
            class: "dropdown-tree__trigger",
            disabled: __props.disabled,
            loading: __props.loading
          }, {
            default: withCtx(() => [
              createElementVNode("span", null, [
                createTextVNode(toDisplayString(__props.triggerLabel) + " ", 1),
                (openBlock(), createBlock(resolveDynamicComponent(unref(render$42)), { class: "chevron" }))
              ])
            ]),
            _: 1
          }, 8, ["disabled", "loading"]))
        ]),
        default: withCtx(() => {
          var _a2, _b2, _c2;
          return [
            createElementVNode("div", _hoisted_1$8, [
              createElementVNode("div", _hoisted_2$7, [
                createVNode(unref(NInput), {
                  id: "dropdown-tree-search",
                  placeholder: __props.searchPlaceholder,
                  value: searchString.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event) => searchString.value = $event),
                  loading: __props.loading,
                  size: "small"
                }, {
                  prefix: withCtx(() => [
                    unref(slots).searchIcon ? renderSlot(_ctx.$slots, "searchIcon", { key: 0 }, void 0, true) : (openBlock(), createBlock(unref(render$3X), {
                      key: 1,
                      class: "icon"
                    }))
                  ]),
                  _: 3
                }, 8, ["placeholder", "value", "loading"])
              ]),
              createVNode(BreadCrumb, {
                show: Boolean(currentPath.value.length),
                title: (_a2 = unref(currentViewTitle)) == null ? void 0 : _a2.label,
                disabled: !currentPath.value,
                onOnClick: _cache[1] || (_cache[1] = ($event) => handleBackwardTraversal(currentPath.value)),
                icon: (_b2 = unref(currentViewTitle)) == null ? void 0 : _b2.icon,
                "icon-class": (_c2 = unref(currentViewTitle)) == null ? void 0 : _c2.iconClass
              }, null, 8, ["show", "title", "disabled", "icon", "icon-class"]),
              createVNode(DropdownItem, {
                showPath: isSearching.value,
                options: currentTree.value,
                onOnForwardTraverse: _cache[2] || (_cache[2] = (option) => handleForwardTraversal(option.value)),
                onOnSelect: _cache[3] || (_cache[3] = (value2) => emits("onSelect", value2))
              }, null, 8, ["showPath", "options"]),
              !isSearching.value && !__props.options.length ? (openBlock(), createElementBlock("div", _hoisted_3$6, [
                unref(slots).empty ? renderSlot(_ctx.$slots, "empty", { key: 0 }, void 0, true) : (openBlock(), createElementBlock("p", _hoisted_4$5, "No data"))
              ])) : createCommentVNode("", true),
              isSearching.value && !currentTree.value.length ? (openBlock(), createElementBlock("div", _hoisted_5$3, [
                unref(slots).emptySearch ? renderSlot(_ctx.$slots, "emptySearch", { key: 0 }, void 0, true) : (openBlock(), createElementBlock("p", _hoisted_6$3, "No matching results found"))
              ])) : createCommentVNode("", true)
            ])
          ];
        }),
        _: 3
      }, 8, ["disabled", "trigger", "placement"]);
    };
  }
}));
var UIDropdownTree = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["__scopeId", "data-v-c94dd12e"]]);
UIDropdownTree.install = (Vue) => {
  Vue.component(UIDropdownTree.name, UIDropdownTree);
};
const __default__$h = defineComponent({
  name: "UIDynamicTags",
  inheritAttrs: false,
  components: { NDynamicTags }
});
const _sfc_main$h = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$h), {
  props: {
    id: {
      required: true,
      type: String
    },
    defaultValue: {
      type: Array,
      default: null
    },
    type: {
      type: String,
      default: "default"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 10
    },
    closable: {
      type: Boolean,
      default: true
    },
    round: {
      type: Boolean,
      default: true
    }
  },
  emits: ["onUpdate"],
  setup(__props, { emit }) {
    var _a2;
    const props = __props;
    const tags2 = ref((_a2 = props.defaultValue) != null ? _a2 : []);
    const handleUpdate = (values2) => {
      tags2.value = lodash.exports.uniqWith(values2, (base2, compare2) => base2.trim() === compare2.trim());
      emit("onUpdate", tags2.value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NDynamicTags), mergeProps({
        value: tags2.value,
        type: __props.type,
        disabled: __props.disabled,
        max: __props.max,
        closable: __props.closable,
        round: __props.round,
        class: [`hl-${__props.type}`]
      }, _ctx.$attrs, { "onUpdate:value": handleUpdate }), null, 16, ["value", "type", "disabled", "max", "closable", "round", "class"]);
    };
  }
}));
_sfc_main$h.install = (Vue) => {
  Vue.component(_sfc_main$h.name, _sfc_main$h);
};
var Empty_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$7 = { class: "hl-empty" };
const _hoisted_2$6 = {
  key: 1,
  class: "hl-empty-icon-container"
};
const _hoisted_3$5 = { class: "hl-empty-icon" };
const _hoisted_4$4 = {
  key: 2,
  class: "hl-empty-title"
};
const _hoisted_5$2 = {
  key: 3,
  class: "hl-empty-description"
};
const _hoisted_6$2 = { class: "hl-empty-actions" };
const __default__$g = defineComponent({
  name: "UIEmpty",
  inheritAttrs: false
});
const _sfc_main$g = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$g), {
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    positiveText: {
      type: String,
      default: ""
    },
    icon: {
      type: Function,
      default: render$3Y
    },
    negativeText: {
      type: String,
      default: ""
    },
    positiveIcon: {
      type: Function,
      default: () => ""
    }
  },
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$7, [
        createElementVNode("div", null, [
          unref(slots).media ? renderSlot(_ctx.$slots, "media", { key: 0 }) : (openBlock(), createElementBlock("div", _hoisted_2$6, [
            createElementVNode("div", _hoisted_3$5, [
              (openBlock(), createBlock(resolveDynamicComponent(__props.icon), { class: "w-5 h-6" }))
            ])
          ])),
          __props.title ? (openBlock(), createElementBlock("div", _hoisted_4$4, toDisplayString(__props.title), 1)) : createCommentVNode("", true),
          __props.description ? (openBlock(), createElementBlock("div", _hoisted_5$2, toDisplayString(__props.description), 1)) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_6$2, [
          __props.negativeText ? (openBlock(), createBlock(unref(_sfc_main$1l), {
            key: 0,
            id: `${__props.id}-btn-negative-action`,
            onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("negativeClick"))
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.negativeText), 1)
            ]),
            _: 1
          }, 8, ["id"])) : createCommentVNode("", true),
          __props.positiveText ? (openBlock(), createBlock(unref(_sfc_main$1l), {
            key: 1,
            id: `${__props.id}-btn-positive-action`,
            type: "primary",
            onClick: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("positiveClick"))
          }, {
            default: withCtx(() => [
              __props.positiveIcon ? (openBlock(), createBlock(resolveDynamicComponent(__props.positiveIcon), {
                key: 0,
                class: "w-5 h-6"
              })) : createCommentVNode("", true),
              createTextVNode(" " + toDisplayString(__props.positiveText), 1)
            ]),
            _: 1
          }, 8, ["id"])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
}));
_sfc_main$g.install = (Vue) => {
  Vue.component(_sfc_main$g.name, _sfc_main$g);
};
var Header_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$6 = { class: "hl-header" };
const _hoisted_2$5 = {
  key: 0,
  class: "back"
};
const _hoisted_3$4 = {
  key: 1,
  class: "header"
};
const _hoisted_4$3 = { class: "hl-header-content" };
const _hoisted_5$1 = { class: "hl-title-container" };
const _hoisted_6$1 = { class: "flex" };
const _hoisted_7$1 = { class: "space-x-2 flex" };
const _hoisted_8$1 = { key: 3 };
const _hoisted_9$1 = {
  key: 2,
  class: "footer"
};
const __default__$f = defineComponent({
  name: "UIHeader",
  inheritAttrs: false
});
const _sfc_main$f = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$f), {
  props: {
    title: {
      type: String,
      default: ""
    },
    secondaryTitle: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    primaryText: {
      type: String,
      default: void 0
    },
    secondaryText: {
      type: String,
      default: void 0
    },
    primaryActionIcon: {
      type: Function
    },
    secondaryActionIcon: {
      type: Function
    },
    primaryOptions: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$6, [
        unref(slots).back ? (openBlock(), createElementBlock("div", _hoisted_2$5, [
          renderSlot(_ctx.$slots, "back")
        ])) : createCommentVNode("", true),
        unref(slots).header ? (openBlock(), createElementBlock("div", _hoisted_3$4, [
          renderSlot(_ctx.$slots, "header")
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_4$3, [
          createElementVNode("div", _hoisted_5$1, [
            __props.title ? (openBlock(), createBlock(unref(_sfc_main$1h), {
              key: 0,
              class: "title"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.title), 1)
              ]),
              _: 1
            })) : createCommentVNode("", true),
            __props.secondaryTitle ? (openBlock(), createBlock(unref(_sfc_main$1g), { key: 1 }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.secondaryTitle), 1)
              ]),
              _: 1
            })) : createCommentVNode("", true),
            __props.description ? (openBlock(), createBlock(resolveDynamicComponent(__props.secondaryTitle ? unref(_sfc_main$1f) : unref(_sfc_main$1a)), {
              key: 2,
              class: "description max-w-3xl"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.description), 1)
              ]),
              _: 1
            })) : createCommentVNode("", true)
          ]),
          createElementVNode("div", _hoisted_6$1, [
            createElementVNode("div", _hoisted_7$1, [
              __props.secondaryText ? (openBlock(), createBlock(unref(_sfc_main$1l), {
                key: 0,
                onClick: _cache[0] || (_cache[0] = (e25) => _ctx.$emit("secondaryClick")),
                id: `${__props.id}-btn-secondary`
              }, {
                default: withCtx(() => [
                  (openBlock(), createBlock(resolveDynamicComponent(__props.secondaryActionIcon), { class: "w-5 h-4 mr-1" })),
                  createTextVNode(" " + toDisplayString(__props.secondaryText), 1)
                ]),
                _: 1
              }, 8, ["id"])) : createCommentVNode("", true),
              __props.primaryText && !__props.primaryOptions.length ? (openBlock(), createBlock(unref(_sfc_main$1l), {
                key: 1,
                onClick: _cache[1] || (_cache[1] = (e25) => _ctx.$emit("primaryClick")),
                type: "primary",
                id: `${__props.id}-btn-primary`
              }, {
                default: withCtx(() => [
                  (openBlock(), createBlock(resolveDynamicComponent(__props.primaryActionIcon), { class: "w-5 h-4 mr-1" })),
                  createTextVNode(" " + toDisplayString(__props.primaryText), 1)
                ]),
                _: 1
              }, 8, ["id"])) : createCommentVNode("", true),
              __props.primaryOptions && __props.primaryOptions.length ? (openBlock(), createBlock(unref(_sfc_main$$), {
                key: 2,
                options: __props.primaryOptions,
                onSelect: _cache[2] || (_cache[2] = (val) => _ctx.$emit("primaryClick", val)),
                id: `${__props.id}-dropdown-primary`
              }, {
                default: withCtx(() => [
                  createVNode(unref(_sfc_main$1l), {
                    type: "primary",
                    id: `${__props.id}-dropdown-btn-primary`
                  }, {
                    default: withCtx(() => [
                      (openBlock(), createBlock(resolveDynamicComponent(__props.primaryActionIcon), { class: "w-5 h-4 mr-1" })),
                      createTextVNode(" " + toDisplayString(__props.primaryText), 1)
                    ]),
                    _: 1
                  }, 8, ["id"])
                ]),
                _: 1
              }, 8, ["options", "id"])) : createCommentVNode("", true),
              unref(slots).extra ? (openBlock(), createElementBlock("div", _hoisted_8$1, [
                renderSlot(_ctx.$slots, "extra")
              ])) : createCommentVNode("", true)
            ])
          ])
        ]),
        unref(slots).footer ? (openBlock(), createElementBlock("div", _hoisted_9$1, [
          renderSlot(_ctx.$slots, "footer")
        ])) : createCommentVNode("", true)
      ]);
    };
  }
}));
_sfc_main$f.install = (Vue) => {
  Vue.component(_sfc_main$f.name, _sfc_main$f);
};
var InputNumber_vue_vue_type_style_index_0_lang = "";
const __default__$e = defineComponent({
  name: "UIInput"
});
const _sfc_main$e = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$e), {
  props: {
    modelValue: {
      type: Number
    },
    placeholder: String,
    readonly: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    precision: {
      type: Number,
      default: void 0
    },
    size: {
      type: String,
      default: "medium"
    },
    buttonPlacement: {
      type: String,
      default: void 0
    },
    showButton: {
      type: Boolean,
      default: void 0
    },
    max: {
      type: Number,
      default: void 0
    },
    min: {
      type: Number,
      default: void 0
    },
    id: {
      type: String,
      required: true
    }
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(__props, { emit }) {
    function emitValueUpdate(value2) {
      emit("update:modelValue", value2);
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NInputNumber), mergeProps({
        id: __props.id,
        max: __props.max,
        min: __props.min,
        "button-placement": __props.buttonPlacement,
        "show-button": __props.showButton,
        precision: __props.precision,
        disabled: __props.disabled,
        size: __props.size,
        readonly: __props.readonly,
        value: __props.modelValue,
        "onUpdate:value": emitValueUpdate,
        placeholder: __props.placeholder,
        clearable: __props.clearable,
        loading: __props.loading
      }, _ctx.$attrs, {
        class: [__props.loading ? "" : "hide-loader", "hl-input-number font-sans"],
        onFocus: _cache[0] || (_cache[0] = (e25) => _ctx.$emit("focus", e25)),
        onBlur: _cache[1] || (_cache[1] = (e25) => _ctx.$emit("blur", e25))
      }), {
        prefix: withCtx(() => [
          renderSlot(_ctx.$slots, "prefix")
        ]),
        suffix: withCtx(() => [
          renderSlot(_ctx.$slots, "suffix")
        ]),
        _: 3
      }, 16, ["id", "max", "min", "button-placement", "show-button", "precision", "disabled", "size", "readonly", "value", "placeholder", "clearable", "loading", "class"]);
    };
  }
}));
_sfc_main$e.install = (Vue) => {
  Vue.component(_sfc_main$e.name, _sfc_main$e);
};
var metadata = { "version": 4, "country_calling_codes": { "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], "7": ["RU", "KZ"], "20": ["EG"], "27": ["ZA"], "30": ["GR"], "31": ["NL"], "32": ["BE"], "33": ["FR"], "34": ["ES"], "36": ["HU"], "39": ["IT", "VA"], "40": ["RO"], "41": ["CH"], "43": ["AT"], "44": ["GB", "GG", "IM", "JE"], "45": ["DK"], "46": ["SE"], "47": ["NO", "SJ"], "48": ["PL"], "49": ["DE"], "51": ["PE"], "52": ["MX"], "53": ["CU"], "54": ["AR"], "55": ["BR"], "56": ["CL"], "57": ["CO"], "58": ["VE"], "60": ["MY"], "61": ["AU", "CC", "CX"], "62": ["ID"], "63": ["PH"], "64": ["NZ"], "65": ["SG"], "66": ["TH"], "81": ["JP"], "82": ["KR"], "84": ["VN"], "86": ["CN"], "90": ["TR"], "91": ["IN"], "92": ["PK"], "93": ["AF"], "94": ["LK"], "95": ["MM"], "98": ["IR"], "211": ["SS"], "212": ["MA", "EH"], "213": ["DZ"], "216": ["TN"], "218": ["LY"], "220": ["GM"], "221": ["SN"], "222": ["MR"], "223": ["ML"], "224": ["GN"], "225": ["CI"], "226": ["BF"], "227": ["NE"], "228": ["TG"], "229": ["BJ"], "230": ["MU"], "231": ["LR"], "232": ["SL"], "233": ["GH"], "234": ["NG"], "235": ["TD"], "236": ["CF"], "237": ["CM"], "238": ["CV"], "239": ["ST"], "240": ["GQ"], "241": ["GA"], "242": ["CG"], "243": ["CD"], "244": ["AO"], "245": ["GW"], "246": ["IO"], "247": ["AC"], "248": ["SC"], "249": ["SD"], "250": ["RW"], "251": ["ET"], "252": ["SO"], "253": ["DJ"], "254": ["KE"], "255": ["TZ"], "256": ["UG"], "257": ["BI"], "258": ["MZ"], "260": ["ZM"], "261": ["MG"], "262": ["RE", "YT"], "263": ["ZW"], "264": ["NA"], "265": ["MW"], "266": ["LS"], "267": ["BW"], "268": ["SZ"], "269": ["KM"], "290": ["SH", "TA"], "291": ["ER"], "297": ["AW"], "298": ["FO"], "299": ["GL"], "350": ["GI"], "351": ["PT"], "352": ["LU"], "353": ["IE"], "354": ["IS"], "355": ["AL"], "356": ["MT"], "357": ["CY"], "358": ["FI", "AX"], "359": ["BG"], "370": ["LT"], "371": ["LV"], "372": ["EE"], "373": ["MD"], "374": ["AM"], "375": ["BY"], "376": ["AD"], "377": ["MC"], "378": ["SM"], "380": ["UA"], "381": ["RS"], "382": ["ME"], "383": ["XK"], "385": ["HR"], "386": ["SI"], "387": ["BA"], "389": ["MK"], "420": ["CZ"], "421": ["SK"], "423": ["LI"], "500": ["FK"], "501": ["BZ"], "502": ["GT"], "503": ["SV"], "504": ["HN"], "505": ["NI"], "506": ["CR"], "507": ["PA"], "508": ["PM"], "509": ["HT"], "590": ["GP", "BL", "MF"], "591": ["BO"], "592": ["GY"], "593": ["EC"], "594": ["GF"], "595": ["PY"], "596": ["MQ"], "597": ["SR"], "598": ["UY"], "599": ["CW", "BQ"], "670": ["TL"], "672": ["NF"], "673": ["BN"], "674": ["NR"], "675": ["PG"], "676": ["TO"], "677": ["SB"], "678": ["VU"], "679": ["FJ"], "680": ["PW"], "681": ["WF"], "682": ["CK"], "683": ["NU"], "685": ["WS"], "686": ["KI"], "687": ["NC"], "688": ["TV"], "689": ["PF"], "690": ["TK"], "691": ["FM"], "692": ["MH"], "850": ["KP"], "852": ["HK"], "853": ["MO"], "855": ["KH"], "856": ["LA"], "880": ["BD"], "886": ["TW"], "960": ["MV"], "961": ["LB"], "962": ["JO"], "963": ["SY"], "964": ["IQ"], "965": ["KW"], "966": ["SA"], "967": ["YE"], "968": ["OM"], "970": ["PS"], "971": ["AE"], "972": ["IL"], "973": ["BH"], "974": ["QA"], "975": ["BT"], "976": ["MN"], "977": ["NP"], "992": ["TJ"], "993": ["TM"], "994": ["AZ"], "995": ["GE"], "996": ["KG"], "998": ["UZ"] }, "countries": { "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[01])\\d{4}"], ["80[1-4]\\d{5}"]]], "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-59]\\d{7}"]]], "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3888[013-9]\\d{5}|3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6])))\\d{6}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)[46]|8(?:(?:21|4[16]|69|9[12])[46]|88[013-9]))\\d{5}|9(?:29(?:54|66)|3(?:7(?:55|77)|865))[2-8]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|473|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:284|3(?:02|23)|657|920)|3(?:4(?:8[27]|92)|541|878))[2-7]\\d{5}|9(?:2(?:(?:26|62)2|320|477|9(?:42|83))|3(?:329|4(?:[47]6|62|89)|564))[2-6]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-7]|[235][4-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|[17][2-6]|3[4-6]|[58][3-6]))))\\d{6}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|475|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:2(?:57|81)|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|71)|5(?:25|37|4[347]|71)|7(?:18|5[17])))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[03-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[145]|4[13]|5[468]|7[2-5]|8[26])|8(?:2[5-7]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:222|[45]\\d)\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|6[69]|7[78])\\d{6}", [10]]]], "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[569]|7[0579])|90\\d\\d)\\d{4}", [8]], 0, 0, ["78(?:0[57]|1[014-8]|2[25]|3[15-8]|48|[56]0|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], "BF": ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-35-7]|5[1-8]|[67]\\d)\\d{6}"]]], "BG": ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|7[7-9]|88)|9[69][69])|7(?:1(?:11|78)|7\\d\\d))\\d{4}"], ["(?:3(?:[1-79]\\d|8[0-47-9])\\d|6(?:3(?:00|33|6[16])|6(?:3[03-9]|[69]\\d|7[0-6])))\\d{4}"], ["80\\d{6}"], ["(?:87|9[014578])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["(?:29|[67][125-9])\\d{6}"]]], "BJ": ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]], 0, 0, 0, 0, 0, 0, [["2(?:02|1[037]|2[45]|3[68]|4\\d)\\d{5}"], ["(?:4[0-356]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}"], 0, ["857[58]\\d{4}"]]], "BL": ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-2])\\d{4}"]]], "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|92)\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], "BO": ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]]]], "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["300\\d{6}|[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", [8, 10]]]], "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], "BT": ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|77)\\d{6}", [8]]]], "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013])|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[067]))\\d{4}", [7]], ["(?:321|7(?:[1-7]\\d|8[0-4]))\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[01]\\d|2[0-7])|2[0-7]\\d)\\d{3}", [8]]]], "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], "CA": ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CD": ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["12\\d{7}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-59]|9[017-9])\\d{7}"]]], "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80[0-2]\\d{6}"]]], "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}"], ["7[35-9]\\d{7}"], ["800\\d{6}"], ["90[016]\\d{6}"], ["878\\d{6}"], 0, ["5[18]\\d{7}"], ["74[0248]\\d{6}"], 0, ["84[0248]\\d{6}"]]], "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", [9]], ["", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6[25-9]\\d)\\d{6}", [9]], ["88\\d{6,7}"]]], "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|21(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))\\d{5}|(?:43[35]|754)\\d{7,8}|8(?:078\\d{7}|51\\d{7,8})|(?:10|(?:2|85)1|43[35]|754)(?:100\\d\\d|95\\d{3,4})|(?:2[02-57-9]|3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[1-9]\\d{6})|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[1-9]\\d{5})|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0(4(?:[14]4|56)|[579])?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|60[124-8][2-9]\\d{6}", [10]], ["3333(?:0(?:0\\d|1[0-5])|[4-9]\\d\\d)\\d{3}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", [10]], ["1800\\d{7}", [11]], ["19(?:0[01]|4[78])\\d{7}", [11]]]], "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], "CU": ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|48)\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["5\\d{7}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}"], ["(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}"], ["800\\d{6}"], ["9(?:0[05689]|76)\\d{6}"], ["70[01]\\d{6}"], 0, ["9(?:5\\d|7[2-4])\\d{6}"], 0, ["9[17]0\\d{6}"], ["8[134]\\d{7}"]]], "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], 0, ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"], [""], ["80\\d{6}"], ["90\\d{6}"]]], "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-2])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[2-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9])\\d|7(?:[0-3679]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2[2-4]|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], "ET": ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8])|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], "FK": ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[1-35]\\d|4[1-9])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[02]|84)\\d{6}"]]], "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-579])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-49]|5[5-79]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|58)|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|(?:5(?:00(?:0\\d|44|5[05]|77|88|99)|1(?:1(?:00|[124]\\d|3[01])|4\\d\\d)|(?:44|68)\\d\\d|5(?:[0157-9]\\d\\d|200)|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[01]\\d|2[0-4])|58[89]|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}|5(?:0(?:070|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], "GF": ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[0239]\\d|[16][0-3]|4[03-9]|5[6-9]|80)\\d{4}"], ["694(?:[0-249]\\d|3[0-8])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[0-2])\\d{4}"]]], "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], "GI": ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|6[14689]|70|8[14-79]|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"], ["(?:[23679]\\d|5[0-489])\\d{5}"]]], "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], "GP": ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1289]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-2])\\d{4}"]]], "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], "GT": ["502", "00", "(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["[3-5]\\d{7}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([3-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-46-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[48])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], "GY": ["592", "001", "9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-24-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|77[1-57])\\d{4}"], ["(?:6\\d\\d|70[0-35-7])\\d{4}"], ["(?:289|862)\\d{4}"], ["9008\\d{3}"]]], "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:[45][0-8]|6[01]|9\\d))|58(?:0[1-8]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[5-9]|6(?:0[0-7]|1[0-6]|4[0-57-9]|6[0-4]|7[0-8]))|573[0-6]|6(?:26[013-8]|66[0-3])|70(?:7[1-5]|8[0-4])|848[015-9]|9(?:29[013-9]|59[0-4]))\\d{4}|(?:4(?:4[01]|6[2358])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|84[09]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-6]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], "HR": ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|77|9[67])))\\d{4}|98\\d{6}", [8, 9]], ["80[01]\\d{4,6}", [7, 8, 9]], ["6[01459]\\d{6}|6[01]\\d{4,5}", [6, 7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], "HT": ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|55)\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], "ID": ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00[17]803\\d{7}|(?:177\\d|800)\\d{5,7}|001803\\d{6}", [8, 9, 10, 11, 12, 13]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], 0, ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["5(?:(?:[02368]\\d|[19][2-9]|4[1-9])\\d|5(?:01|1[79]|2[2-9]|3[0-3]|4[34]|5[015689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, 0, ["1599\\d{6}", [10]], 0, ["7(?:38(?:0\\d|5[09]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|2(?:121|[2689]0\\d)|30[0-2]\\d|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, 0, ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], "IT": ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[025-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], "JP": ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["[7-9]0[1-9]\\d{7}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-6]|1[0-5]|2[014]|30)|7\\d\\d)\\d{6}", [9]], ["800[2-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], "KG": ["996", "00", "8\\d{9}|(?:[235-8]\\d|99)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|99[05-9])\\d{6}", [9]], ["800\\d{6,7}"]]], "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[1-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|80)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|66)|222|3[36]3|444|7(?:0[013-9]|[67]\\d)|888|9(?:[069]\\d|3[039]))|9(?:(?:0[09]|[4679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|[48]8)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["345849\\d{4}"]]], "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["(?:20(?:[2359]\\d|7[6-8]|88)|302\\d)\\d{6}", [10]], 0, 0, 0, 0, ["30[013-9]\\d{6}", [9]]]], "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5[0-4])\\d|6(?:[0245]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, 0, ["870(?:28|87)\\d\\d", [7]]]], "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], "LR": ["231", "00", "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{7}", [8]], ["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4[67])\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[256]\\d{4}"]]], "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], "LV": ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["23(?:23[0-57-9]|33[0238])\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[024-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29[1289]|389)", "529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]], "MC": ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[46]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], "MF": ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-2])\\d{4}"]]], "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[35]|8[268]|9[245])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|45[78]|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[356])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-48]\\d|7[01578])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-39]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-49])\\d{6}"], ["80\\d{6}"]]], "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:2\\d|3[56]|[89][0-6])\\d|4(?:2[29]|62|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|[26]2|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5470)|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:(?:3\\d|8[01459])\\d|4[67]0)))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|[35]2\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}|[12]468\\d{4}", [8]]]], "MN": ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|7(?:0[0-5]\\d|128)\\d{4}|(?:[12](?:1|27)|5[368])\\d{6}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|8[015689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[25-9]\\d)\\d{5}", [8]]]], "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "MQ": ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["596(?:[03-7]\\d|10|2[7-9]|8[09]|9[4-9])\\d{4}"], ["69(?:6(?:[0-46-9]\\d|5[0-6])|727)\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:397[01]|477[0-2]|76(?:6\\d|7[0-367]))\\d{4}"]]], "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-7])|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-2]|3[013]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, 0, ["3(?:20|9\\d)\\d{4}", [7]]], "020"], "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-3]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], "MW": ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], "MX": ["52", "0[09]", "1(?:(?:[27]2|44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, [["657[12]\\d{6}|(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}", [10]], ["657[12]\\d{6}|(?:1(?:2(?:2[1-9]|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[24-7][1-9]|3[1-8]|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1-467][1-9]|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69][1-9]|7[12]|8[1-8]))|2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[25-7][1-9]|3[1-8]|4\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-3689]|6[1-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[13467][1-9]|2\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[1-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|6[1-9]|7[12]|8[1-8]|9\\d))\\d{7}"], ["8(?:00|88)\\d{7}", [10]], ["900\\d{7}", [10]], ["500\\d{7}", [10]], 0, 0, 0, 0, ["300\\d{7}", [10]]], "00"], "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-6]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], "NC": ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:5[0-4]|[79]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[04]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[04]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], "NG": ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[1-356]\\d|4[02-8]|8[2-9])\\d|9(?:0[3-9]|[1-9]\\d))\\d{5}|7(?:0(?:[013-689]\\d|2[0-24-9])\\d{3,4}|[1-79]\\d{6})|(?:[12]\\d|4[147]|5[14579]|6[1578]|7[1-3578])\\d{5}", [7, 8]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:70[13-689]|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-356]))\\d{7}", [10]], ["800\\d{7,11}", [10, 11, 12, 13, 14]], 0, 0, 0, ["700\\d{7,11}", [10, 11, 12, 13, 14]]]], "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|59|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], 0, ["(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:6[0-3]|7[024-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], "NR": ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:55[3-9]|666|8\\d\\d)\\d{4}"]]], "NU": ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["888[4-9]\\d{3}", [7]]]], "NZ": ["64", "0(?:0|161)", "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], "0", 0, 0, 0, 0, 0, [["24099\\d{3}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2[0-27-9]\\d{7,8}|2(?:1\\d|75)\\d{5}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:11\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[6-9]|22|3\\d|4[045]|5[459]|7[0-3579]|90)\\d{2,7}"], ["[28]6\\d{6,7}", [8, 9]]], "00"], "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[1-6]\\d{6}", [8]], ["1505\\d{4}|(?:7(?:[1289]\\d|7[0-5])|9(?:0[1-9]|[1-9]\\d))\\d{5}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[58]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[089]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068]|7[0-8])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[056]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], "PE": ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:4[34]|5[14])[0-8]\\d|7(?:173|3[0-8]\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[128])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-24]\\d|3[0-7]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], "PL": ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["21(?:1(?:[145]\\d|3[1-5])|2[0-4]\\d)\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], "PM": ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-356]|50)\\d{4}", [6]], ["(?:4[02-4]|5[056]|708[45][0-5])\\d{4}"], ["80[0-5]\\d{6}", [9]]]], "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:3[03]|9\\d))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], 0, ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6222\\d{5}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|6[2-4689]0)\\d{4}|(?:45|77|88)\\d{5}"]]], "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|[78][1-6]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], "QA": ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2[16]\\d{5}", [7]]]], "RE": ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-3]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:0[0-46]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|6[0-6]|7[0-27]|8[0-8]|9[0-479]))|9(?:399[0-3]|479[0-2]|76(?:2[27]|3[0-37]|9\\d)))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, 0, ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], "RO": ["40", "00", "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["7020\\d{5}|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-29])\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", [["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[2389]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], "SA": ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-35-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, ["811\\d{7}", [10]], 0, 0, ["920\\d{6}", [9]]]], "SB": ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], "SC": ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], 0, 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], 0, ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-6]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["8(?:06[0-689]|95[0-2])\\d{4}|(?:8(?:0[1-5]|[1-8]\\d|9[0-4])|9[0-8]\\d)\\d{5}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|59|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], 0, ["(?:0[2-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[2-9]|8[08]|9[09])\\d{6}"]]], "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|21|90)\\d|5(?:01|[19]0|25|[38]3|[4-7]\\d))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|79|8[08])\\d|6(?:0[5-7]|[1-9]\\d)|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], "SR": ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"], ["(?:7[124-7]|8[124-9])\\d{5}", [7]], 0, 0, 0, 0, 0, 0, ["56\\d{4}", [6]]]], "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], "SV": ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1-6]\\d{3}|[79]90[034]|890[0245])\\d{3}", [8]], ["66(?:[02-9]\\d\\d|1(?:[02-9]\\d|16))\\d{3}|(?:6[0-57-9]|7\\d)\\d{6}", [8]], ["800\\d{4}(?:\\d{4})?", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "SY": ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["9[1-689]\\d{7}", [9]]]], "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[6-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], "TD": ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:6[0235689]|77|9\\d)\\d{6}"]], "00"], "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[019]|9[0-36-9])\\d{6}"]]], "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["671[0-8]\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], "TJ": ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"], ["41[18]\\d{6}|(?:0[0-27]|1[017]|2[02]|[34]0|5[05]|7[0178]|8[078]|9\\d)\\d{7}"]], "8~10"], "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], "TM": ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["6\\d{7}"]], "8~10"], "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-7])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:55[4-6]|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["56161\\d{5}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], "TZ": ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["77[2-9]\\d{6}|(?:6[125-9]|7[13-689])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["(?:39|50|6[36-8]|7[1-3]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|32|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["726[01]\\d{5}|7(?:[01578]\\d|20|36|[46][0-4]|9[89])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], "US": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "UY": ["598", "0(?:0|1[3-9]\\d)", "(?:0004|4)\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [7, 8, 10, 13], [["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|987)|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["(?:(?:0004|4)\\d{5}|80[05])\\d{4}|405\\d{4}", [7, 10, 13]], ["90[0-8]\\d{4}", [7]]], "00", " int. "], "UZ": ["998", "810", "(?:33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|6\\d\\d|7(?:[23]\\d|7[69])|9(?:22|4[1-8]|6[135]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|(?:1[12]|8\\d)\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|6(?:22|3[12457]|4[13-8])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:33|50|88|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079]))|9(?:2(?:1[1267]|3[01]|5\\d|7[0-4])|(?:5[67]|7\\d)\\d|6(?:2[0-26]|8\\d)))|7(?:[07]\\d{3}|1(?:13[01]|6(?:0[47]|1[67]|66)|71[3-69]|98\\d)|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|6(?:2(?:2[1245]|4[2-4])|39\\d|41[179]|5(?:[349]\\d|5[0-2])|7(?:0[017]|[13]\\d|22|44|55|67|88))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]], "8~10"], "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[46])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0[0-368]|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], "WF": ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]]]], "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], "XK": ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[89]|39)0\\d{6}|[23][89]\\d{6}"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], "YT": ["262", "00", "(?:(?:(?:26|63)9|80\\d)\\d|9398)\\d{5}", [9], 0, "0", 0, 0, 0, 0, "269|63|9398", [["269(?:0[0-467]|5[0-3]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|9398[01])\\d{4}"], ["80\\d{7}"]]], "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:6\\d|7[0-46-9])\\d{3}|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], "ZM": ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:7[5-79]|9[5-8])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[178]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, "nonGeographic": { "800": ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], "870": ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], "881": ["881", 0, "[0-36-9]\\d{8}", [9], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[0-36-9]\\d{8}"]]], "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], "883": ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function withMetadataArgument(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata);
  return func.apply(this, args);
}
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
function _defineProperties$2(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result2);
  };
}
function _possibleConstructorReturn(self2, call2) {
  if (call2 && (_typeof$2(call2) === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper2);
    }
    function Wrapper2() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper2.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper2, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf(Wrapper2, Class2);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a2 = [null];
      a2.push.apply(a2, args2);
      var Constructor = Function.bind.apply(Parent2, a2);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e25) {
    return false;
  }
}
function _isNativeFunction(fn2) {
  return Function.toString.call(fn2).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _getPrototypeOf(o2) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf(o2);
}
var ParseError = /* @__PURE__ */ function(_Error) {
  _inherits(ParseError2, _Error);
  var _super = _createSuper(ParseError2);
  function ParseError2(code) {
    var _this;
    _classCallCheck$2(this, ParseError2);
    _this = _super.call(this, code);
    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError2.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }
  return _createClass$2(ParseError2);
}(/* @__PURE__ */ _wrapNativeSuper(Error));
var MIN_LENGTH_FOR_NSN = 2;
var MAX_LENGTH_FOR_NSN = 17;
var MAX_LENGTH_COUNTRY_CODE = 3;
var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";
var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]";
var TILDES = "~\u2053\u223C\uFF5E";
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B";
function compare(a2, b2) {
  a2 = a2.split("-");
  b2 = b2.split("-");
  var pa2 = a2[0].split(".");
  var pb2 = b2[0].split(".");
  for (var i2 = 0; i2 < 3; i2++) {
    var na2 = Number(pa2[i2]);
    var nb2 = Number(pb2[i2]);
    if (na2 > nb2)
      return 1;
    if (nb2 > na2)
      return -1;
    if (!isNaN(na2) && isNaN(nb2))
      return 1;
    if (isNaN(na2) && !isNaN(nb2))
      return -1;
  }
  if (a2[1] && b2[1]) {
    return a2[1] > b2[1] ? 1 : a2[1] < b2[1] ? -1 : 0;
  }
  return !a2[1] && b2[1] ? 1 : a2[1] && !b2[1] ? -1 : 0;
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var V3 = "1.2.0";
var V4 = "1.7.35";
var DEFAULT_EXT_PREFIX = " ext. ";
var CALLING_CODE_REG_EXP = /^\d+$/;
var Metadata = /* @__PURE__ */ function() {
  function Metadata2(metadata2) {
    _classCallCheck$1(this, Metadata2);
    validateMetadata(metadata2);
    this.metadata = metadata2;
    setVersion.call(this, metadata2);
  }
  _createClass$1(Metadata2, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function(_2) {
        return _2 !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3)
        return;
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }
      if (countryCode && countryCode !== "001") {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = void 0;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata2 = this.nonGeographic()[callingCode];
        if (metadata2) {
          return metadata2;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return this.metadata.countries["001"];
        }
      }
    }
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }
  }, {
    key: "type",
    value: function type4(_type) {
      return this.numberingPlan.type(_type);
    }
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1)
        return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== void 0;
    }
  }]);
  return Metadata2;
}();
var NumberingPlan = /* @__PURE__ */ function() {
  function NumberingPlan2(metadata2, globalMetadataObject) {
    _classCallCheck$1(this, NumberingPlan2);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata2;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  _createClass$1(NumberingPlan2, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2)
        return this.metadata[1];
      return this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1)
        return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata2) {
      return metadata2[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats2 = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats2.map(function(_2) {
        return new Format(_2, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata2) {
      return metadata2[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types2() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      if (this.types() && this.types().length === 0) {
        return false;
      }
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type4(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2)
        return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
  return NumberingPlan2;
}();
var Format = /* @__PURE__ */ function() {
  function Format2(format2, metadata2) {
    _classCallCheck$1(this, Format2);
    this._format = format2;
    this.metadata = metadata2;
  }
  _createClass$1(Format2, [{
    key: "pattern",
    value: function pattern4() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format2() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
  return Format2;
}();
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /* @__PURE__ */ function() {
  function Type2(type4, metadata2) {
    _classCallCheck$1(this, Type2);
    this.type = type4;
    this.metadata = metadata2;
  }
  _createClass$1(Type2, [{
    key: "pattern",
    value: function pattern4() {
      if (this.metadata.v1)
        return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1)
        return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
  return Type2;
}();
function getType(types2, type4) {
  switch (type4) {
    case "FIXED_LINE":
      return types2[0];
    case "MOBILE":
      return types2[1];
    case "TOLL_FREE":
      return types2[2];
    case "PREMIUM_RATE":
      return types2[3];
    case "PERSONAL_NUMBER":
      return types2[4];
    case "VOICEMAIL":
      return types2[5];
    case "UAN":
      return types2[6];
    case "PAGER":
      return types2[7];
    case "VOIP":
      return types2[8];
    case "SHARED_COST":
      return types2[9];
  }
}
function validateMetadata(metadata2) {
  if (!metadata2) {
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  }
  if (!is_object(metadata2) || !is_object(metadata2.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata2) ? "an object of shape: { " + Object.keys(metadata2).join(", ") + " }" : "a " + type_of(metadata2) + ": " + metadata2, "."));
  }
}
var is_object = function is_object2(_2) {
  return _typeof$1(_2) === "object";
};
var type_of = function type_of2(_2) {
  return _typeof$1(_2);
};
function getCountryCallingCode(country, metadata2) {
  metadata2 = new Metadata(metadata2);
  if (metadata2.hasCountry(country)) {
    return metadata2.country(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}
function setVersion(metadata2) {
  var version = metadata2.version;
  if (typeof version === "number") {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (compare(version, V3) === -1) {
      this.v2 = true;
    } else if (compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}
var RFC3966_EXTN_PREFIX = ";ext=";
var getExtensionDigitsPattern = function getExtensionDigitsPattern2(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
function createExtensionPattern(purpose) {
  var extLimitAfterExplicitLabel = "20";
  var extLimitAfterLikelyLabel = "15";
  var extLimitAfterAmbiguousChar = "9";
  var extLimitWhenNotSure = "6";
  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  var optionalExtnSuffix = "#?";
  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)";
  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)";
  var ambiguousSeparator = "[- ]+";
  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}";
var VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*";
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i");
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + "(?:" + createExtensionPattern() + ")?";
var VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$", "i");
function isViablePhoneNumber(number4) {
  return number4.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number4);
}
function isViablePhoneNumberStart(number4) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number4);
}
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(number4) {
  var start = number4.search(EXTN_PATTERN);
  if (start < 0) {
    return {};
  }
  var numberWithoutExtension = number4.slice(0, start);
  var matches = number4.match(EXTN_PATTERN);
  var i2 = 1;
  while (i2 < matches.length) {
    if (matches[i2]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i2]
      };
    }
    i2++;
  }
}
var DIGITS = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  "\uFF10": "0",
  "\uFF11": "1",
  "\uFF12": "2",
  "\uFF13": "3",
  "\uFF14": "4",
  "\uFF15": "5",
  "\uFF16": "6",
  "\uFF17": "7",
  "\uFF18": "8",
  "\uFF19": "9",
  "\u0660": "0",
  "\u0661": "1",
  "\u0662": "2",
  "\u0663": "3",
  "\u0664": "4",
  "\u0665": "5",
  "\u0666": "6",
  "\u0667": "7",
  "\u0668": "8",
  "\u0669": "9",
  "\u06F0": "0",
  "\u06F1": "1",
  "\u06F2": "2",
  "\u06F3": "3",
  "\u06F4": "4",
  "\u06F5": "5",
  "\u06F6": "6",
  "\u06F7": "7",
  "\u06F8": "8",
  "\u06F9": "9"
};
function parseDigit(character) {
  return DIGITS[character];
}
function _createForOfIteratorHelperLoose$4(o2, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (it2)
    return (it2 = it2.call(o2)).next.bind(it2);
  if (Array.isArray(o2) || (it2 = _unsupportedIterableToArray$5(o2)) || allowArrayLike && o2 && typeof o2.length === "number") {
    if (it2)
      o2 = it2;
    var i2 = 0;
    return function() {
      if (i2 >= o2.length)
        return { done: true };
      return { done: false, value: o2[i2++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$5(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$5(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$5(o2, minLen);
}
function _arrayLikeToArray$5(arr, len2) {
  if (len2 == null || len2 > arr.length)
    len2 = arr.length;
  for (var i2 = 0, arr2 = new Array(len2); i2 < len2; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function parseIncompletePhoneNumber(string3) {
  var result2 = "";
  for (var _iterator = _createForOfIteratorHelperLoose$4(string3.split("")), _step; !(_step = _iterator()).done; ) {
    var character = _step.value;
    result2 += parsePhoneNumberCharacter(character, result2) || "";
  }
  return result2;
}
function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  if (character === "+") {
    if (prevParsedCharacters) {
      return;
    }
    return "+";
  }
  return parseDigit(character);
}
function _createForOfIteratorHelperLoose$3(o2, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (it2)
    return (it2 = it2.call(o2)).next.bind(it2);
  if (Array.isArray(o2) || (it2 = _unsupportedIterableToArray$4(o2)) || allowArrayLike && o2 && typeof o2.length === "number") {
    if (it2)
      o2 = it2;
    var i2 = 0;
    return function() {
      if (i2 >= o2.length)
        return { done: true };
      return { done: false, value: o2[i2++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$4(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$4(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$4(o2, minLen);
}
function _arrayLikeToArray$4(arr, len2) {
  if (len2 == null || len2 > arr.length)
    len2 = arr.length;
  for (var i2 = 0, arr2 = new Array(len2); i2 < len2; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function mergeArrays(a2, b2) {
  var merged = a2.slice();
  for (var _iterator = _createForOfIteratorHelperLoose$3(b2), _step; !(_step = _iterator()).done; ) {
    var element = _step.value;
    if (a2.indexOf(element) < 0) {
      merged.push(element);
    }
  }
  return merged.sort(function(a3, b3) {
    return a3 - b3;
  });
}
function checkNumberLength(nationalNumber, metadata2) {
  return checkNumberLengthForType(nationalNumber, void 0, metadata2);
}
function checkNumberLengthForType(nationalNumber, type4, metadata2) {
  var type_info = metadata2.type(type4);
  var possible_lengths = type_info && type_info.possibleLengths() || metadata2.possibleLengths();
  if (!possible_lengths) {
    return "IS_POSSIBLE";
  }
  if (type4 === "FIXED_LINE_OR_MOBILE") {
    if (!metadata2.type("FIXED_LINE")) {
      return checkNumberLengthForType(nationalNumber, "MOBILE", metadata2);
    }
    var mobile_type = metadata2.type("MOBILE");
    if (mobile_type) {
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths());
    }
  } else if (type4 && !type_info) {
    return "INVALID_LENGTH";
  }
  var actual_length = nationalNumber.length;
  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return "IS_POSSIBLE";
  }
  if (minimum_length > actual_length) {
    return "TOO_SHORT";
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return "TOO_LONG";
  }
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function isPossiblePhoneNumber(input, options, metadata2) {
  if (options === void 0) {
    options = {};
  }
  metadata2 = new Metadata(metadata2);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error("Invalid phone number object passed");
    }
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata2.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata2.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error("Invalid phone number object passed");
      }
      metadata2.selectNumberingPlan(input.countryCallingCode);
    }
  }
  if (metadata2.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata2);
  } else {
    if (input.countryCallingCode && metadata2.isNonGeographicCallingCode(input.countryCallingCode)) {
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "IS_POSSIBLE":
      return true;
    default:
      return false;
  }
}
function matchesEntirely(text, regular_expression) {
  text = text || "";
  return new RegExp("^(?:" + regular_expression + ")$").test(text);
}
function _createForOfIteratorHelperLoose$2(o2, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (it2)
    return (it2 = it2.call(o2)).next.bind(it2);
  if (Array.isArray(o2) || (it2 = _unsupportedIterableToArray$3(o2)) || allowArrayLike && o2 && typeof o2.length === "number") {
    if (it2)
      o2 = it2;
    var i2 = 0;
    return function() {
      if (i2 >= o2.length)
        return { done: true };
      return { done: false, value: o2[i2++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$3(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$3(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$3(o2, minLen);
}
function _arrayLikeToArray$3(arr, len2) {
  if (len2 == null || len2 > arr.length)
    len2 = arr.length;
  for (var i2 = 0, arr2 = new Array(len2); i2 < len2; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(input, options, metadata2) {
  options = options || {};
  if (!input.country) {
    return;
  }
  metadata2 = new Metadata(metadata2);
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern())) {
    return;
  }
  if (isNumberTypeEqualTo(nationalNumber, "FIXED_LINE", metadata2)) {
    if (metadata2.type("MOBILE") && metadata2.type("MOBILE").pattern() === "") {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (!metadata2.type("MOBILE")) {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (isNumberTypeEqualTo(nationalNumber, "MOBILE", metadata2)) {
      return "FIXED_LINE_OR_MOBILE";
    }
    return "FIXED_LINE";
  }
  for (var _iterator = _createForOfIteratorHelperLoose$2(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done; ) {
    var type4 = _step.value;
    if (isNumberTypeEqualTo(nationalNumber, type4, metadata2)) {
      return type4;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type4, metadata2) {
  type4 = metadata2.type(type4);
  if (!type4 || !type4.pattern()) {
    return false;
  }
  if (type4.possibleLengths() && type4.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return matchesEntirely(nationalNumber, type4.pattern());
}
function isValidNumber(input, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  if (metadata2.hasTypes()) {
    return getNumberType(input, options, metadata2.metadata) !== void 0;
  }
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata2.nationalNumberPattern());
}
function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata2) {
  var _metadata = new Metadata(metadata2);
  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return [];
  }
  return possibleCountries.filter(function(country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata2);
  });
}
function couldNationalNumberBelongToCountry(nationalNumber, country, metadata2) {
  var _metadata = new Metadata(metadata2);
  _metadata.selectNumberingPlan(country);
  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }
  return false;
}
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number4, format2, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix;
  _ref.carrierCode;
  _ref.metadata;
  var formattedNumber = number4.replace(new RegExp(format2.pattern()), useInternationalFormat ? format2.internationalFormat() : withNationalPrefix && format2.nationalPrefixFormattingRule() ? format2.format().replace(FIRST_GROUP_PATTERN, format2.nationalPrefixFormattingRule()) : format2.format());
  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }
  return formattedNumber;
}
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata2) {
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
function formatRFC3966(_ref) {
  var number4 = _ref.number, ext = _ref.ext;
  if (!number4) {
    return "";
  }
  if (number4[0] !== "+") {
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  }
  return "tel:".concat(number4).concat(ext ? ";ext=" + ext : "");
}
function _createForOfIteratorHelperLoose$1(o2, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (it2)
    return (it2 = it2.call(o2)).next.bind(it2);
  if (Array.isArray(o2) || (it2 = _unsupportedIterableToArray$2(o2)) || allowArrayLike && o2 && typeof o2.length === "number") {
    if (it2)
      o2 = it2;
    var i2 = 0;
    return function() {
      if (i2 >= o2.length)
        return { done: true };
      return { done: false, value: o2[i2++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$2(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$2(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$2(o2, minLen);
}
function _arrayLikeToArray$2(arr, len2) {
  if (len2 == null || len2 > arr.length)
    len2 = arr.length;
  for (var i2 = 0, arr2 = new Array(len2); i2 < len2; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function ownKeys$3(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object4);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$3(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$3(Object(source), true).forEach(function(key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$3(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata2) {
    return "".concat(formattedNumber).concat(metadata2.ext()).concat(extension);
  }
};
function formatNumber(input, format2, options, metadata2) {
  if (options) {
    options = _objectSpread$3(_objectSpread$3({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  metadata2 = new Metadata(metadata2);
  if (input.country && input.country !== "001") {
    if (!metadata2.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata2.country(input.country);
  } else if (input.countryCallingCode) {
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else
    return input.phone || "";
  var countryCallingCode = metadata2.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  var number4;
  switch (format2) {
    case "NATIONAL":
      if (!nationalNumber) {
        return "";
      }
      number4 = formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata2, options);
      return addExtension(number4, input.ext, metadata2, options.formatExtension);
    case "INTERNATIONAL":
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number4 = formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata2, options);
      number4 = "+".concat(countryCallingCode, " ").concat(number4);
      return addExtension(number4, input.ext, metadata2, options.formatExtension);
    case "E.164":
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    case "IDD":
      if (!options.fromCountry) {
        return;
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata2);
      return addExtension(formattedNumber, input.ext, metadata2, options.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format2, '"'));
  }
}
function formatNationalNumber(number4, carrierCode, formatAs, metadata2, options) {
  var format2 = chooseFormatForNumber(metadata2.formats(), number4);
  if (!format2) {
    return number4;
  }
  return formatNationalNumberUsingFormat(number4, format2, {
    useInternationalFormat: formatAs === "INTERNATIONAL",
    withNationalPrefix: format2.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode,
    metadata: metadata2
  });
}
function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose$1(availableFormats), _step; !(_step = _iterator()).done; ) {
    var format2 = _step.value;
    if (format2.leadingDigitsPatterns().length > 0) {
      var lastLeadingDigitsPattern = format2.leadingDigitsPatterns()[format2.leadingDigitsPatterns().length - 1];
      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    }
    if (matchesEntirely(nationalNnumber, format2.pattern())) {
      return format2;
    }
  }
}
function addExtension(formattedNumber, ext, metadata2, formatExtension2) {
  return ext ? formatExtension2(formattedNumber, ext, metadata2) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata2) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata2.metadata);
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata2);
    if (countryCallingCode === "1") {
      return countryCallingCode + " " + formattedNumber;
    }
    return formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, void 0, metadata2.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata2));
  }
}
function ownKeys$2(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object4);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$2(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$2(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var PhoneNumber = /* @__PURE__ */ function() {
  function PhoneNumber2(countryOrCountryCallingCode, nationalNumber, metadata2) {
    _classCallCheck(this, PhoneNumber2);
    if (!countryOrCountryCallingCode) {
      throw new TypeError("`country` or `countryCallingCode` not passed");
    }
    if (!nationalNumber) {
      throw new TypeError("`nationalNumber` not passed");
    }
    if (!metadata2) {
      throw new TypeError("`metadata` not passed");
    }
    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata2), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = "+" + this.countryCallingCode + this.nationalNumber;
    this.getMetadata = function() {
      return metadata2;
    };
  }
  _createClass(PhoneNumber2, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }
      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid2() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata2 = new Metadata(this.getMetadata());
      return metadata2.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }
  }, {
    key: "getType",
    value: function getType2() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format2(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$2(_objectSpread$2({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format("NATIONAL", options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format("INTERNATIONAL", options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format("RFC3966", options);
    }
  }]);
  return PhoneNumber2;
}();
var isCountryCode = function isCountryCode2(value2) {
  return /^[A-Z]{2}$/.test(value2);
};
function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata2 = new Metadata(metadataJson);
  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata2.selectNumberingPlan(country);
    countryCallingCode = metadata2.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
  }
  return {
    country,
    countryCallingCode
  };
}
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number4, country, callingCode, metadata2) {
  if (!country) {
    return;
  }
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
  if (number4.search(IDDPrefixPattern) !== 0) {
    return;
  }
  number4 = number4.slice(number4.match(IDDPrefixPattern)[0].length);
  var matchedGroups = number4.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === "0") {
      return;
    }
  }
  return number4;
}
function extractNationalNumberFromPossiblyIncompleteNumber(number4, metadata2) {
  if (number4 && metadata2.numberingPlan.nationalPrefixForParsing()) {
    var prefixPattern = new RegExp("^(?:" + metadata2.numberingPlan.nationalPrefixForParsing() + ")");
    var prefixMatch2 = prefixPattern.exec(number4);
    if (prefixMatch2) {
      var nationalNumber;
      var carrierCode;
      var capturedGroupsCount = prefixMatch2.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch2[capturedGroupsCount];
      if (metadata2.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number4.replace(prefixPattern, metadata2.nationalPrefixTransformRule());
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch2[1];
        }
      } else {
        var prefixBeforeNationalNumber = prefixMatch2[0];
        nationalNumber = number4.slice(prefixBeforeNationalNumber.length);
        if (hasCapturedGroups) {
          carrierCode = prefixMatch2[1];
        }
      }
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number4.indexOf(prefixMatch2[1]);
        var possibleNationalPrefix = number4.slice(0, possiblePositionOfTheFirstCapturedGroup);
        if (possibleNationalPrefix === metadata2.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata2.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch2[0];
      }
      return {
        nationalNumber,
        nationalPrefix,
        carrierCode
      };
    }
  }
  return {
    nationalNumber: number4
  };
}
function extractNationalNumber(number4, metadata2) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number4, metadata2), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number4) {
    if (!shouldHaveExtractedNationalPrefix(number4, nationalNumber, metadata2)) {
      return {
        nationalNumber: number4
      };
    }
    if (metadata2.possibleLengths()) {
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata2)) {
        return {
          nationalNumber: number4
        };
      }
    }
  }
  return {
    nationalNumber,
    carrierCode
  };
}
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata2) {
  if (matchesEntirely(nationalNumberBefore, metadata2.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata2.nationalNumberPattern())) {
    return false;
  }
  return true;
}
function isPossibleIncompleteNationalNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return false;
    default:
      return true;
  }
}
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number4, country, callingCode, metadata2) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata2) : callingCode;
  if (number4.indexOf(countryCallingCode) === 0) {
    metadata2 = new Metadata(metadata2);
    metadata2.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number4.slice(countryCallingCode.length);
    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata2), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = extractNationalNumber(number4, metadata2), nationalNumber = _extractNationalNumbe2.nationalNumber;
    if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata2.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata2) === "TOO_LONG") {
      return {
        countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number: number4
  };
}
function extractCountryCallingCode(number4, country, callingCode, metadata2) {
  if (!number4) {
    return {};
  }
  var isNumberWithIddPrefix;
  if (number4[0] !== "+") {
    var numberWithoutIDD = stripIddPrefix(number4, country, callingCode, metadata2);
    if (numberWithoutIDD && numberWithoutIDD !== number4) {
      isNumberWithIddPrefix = true;
      number4 = "+" + numberWithoutIDD;
    } else {
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number4, country, callingCode, metadata2), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        number: number4
      };
    }
  }
  if (number4[1] === "0") {
    return {};
  }
  metadata2 = new Metadata(metadata2);
  var i2 = 2;
  while (i2 - 1 <= MAX_LENGTH_COUNTRY_CODE && i2 <= number4.length) {
    var _countryCallingCode = number4.slice(1, i2);
    if (metadata2.hasCallingCode(_countryCallingCode)) {
      metadata2.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: _countryCallingCode,
        number: number4.slice(i2)
      };
    }
    i2++;
  }
  return {};
}
function _createForOfIteratorHelperLoose(o2, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o2[Symbol.iterator] || o2["@@iterator"];
  if (it2)
    return (it2 = it2.call(o2)).next.bind(it2);
  if (Array.isArray(o2) || (it2 = _unsupportedIterableToArray$1(o2)) || allowArrayLike && o2 && typeof o2.length === "number") {
    if (it2)
      o2 = it2;
    var i2 = 0;
    return function() {
      if (i2 >= o2.length)
        return { done: true };
      return { done: false, value: o2[i2++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$1(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$1(o2, minLen);
}
function _arrayLikeToArray$1(arr, len2) {
  if (len2 == null || len2 > arr.length)
    len2 = arr.length;
  for (var i2 = 0, arr2 = new Array(len2); i2 < len2; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata2 = _ref.metadata;
  metadata2 = new Metadata(metadata2);
  var matchingCountries = [];
  for (var _iterator = _createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done; ) {
    var country = _step.value;
    metadata2.country(country);
    if (metadata2.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata2.leadingDigits()) === 0) {
        return country;
      }
    } else if (getNumberType({
      phone: nationalPhoneNumber,
      country
    }, void 0, metadata2.metadata)) {
      if (defaultCountry) {
        if (country === defaultCountry) {
          return country;
        }
        matchingCountries.push(country);
      } else {
        return country;
      }
    }
  }
  if (matchingCountries.length > 0) {
    return matchingCountries[0];
  }
}
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata2 = _ref.metadata;
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata2.isNonGeographicCallingCode(callingCode)) {
      return "001";
    }
  }
  var possibleCountries = metadata2.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    defaultCountry,
    metadata: metadata2.metadata
  });
}
var PLUS_SIGN = "+";
var RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var RFC3966_PHONE_DIGIT_ = "([" + VALID_DIGITS + "]|" + RFC3966_VISUAL_SEPARATOR_ + ")";
var RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + "*[" + VALID_DIGITS + "]" + RFC3966_PHONE_DIGIT_ + "*$";
var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, "g");
var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = "[" + ALPHANUM_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var VALID_ALPHA_ = "a-zA-Z";
var RFC3966_TOPLABEL_ = "[" + VALID_ALPHA_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var RFC3966_DOMAINNAME_ = "^(" + RFC3966_DOMAINLABEL_ + "\\.)*" + RFC3966_TOPLABEL_ + "\\.?$";
var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, "g");
var RFC3966_PREFIX_ = "tel:";
var RFC3966_PHONE_CONTEXT_ = ";phone-context=";
var RFC3966_ISDN_SUBADDRESS_ = ";isub=";
function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
  if (indexOfPhoneContext < 0) {
    return null;
  }
  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
  if (phoneContextStart >= numberToExtractFrom.length) {
    return "";
  }
  var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart);
  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }
  if (phoneContext.length === 0) {
    return false;
  }
  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);
  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError("NOT_A_NUMBER");
  }
  var phoneNumberString;
  if (phoneContext === null) {
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
  } else {
    phoneNumberString = "";
    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    }
    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber;
    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }
    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  }
  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  }
  if (phoneNumberString !== "") {
    return phoneNumberString;
  }
}
var MAX_INPUT_STRING_LENGTH = 250;
var PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]");
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
function parse(text, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  if (options.defaultCountry && !metadata2.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }
  var _parseInput = parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === "TOO_SHORT") {
        throw new ParseError("TOO_SHORT");
      }
      throw new ParseError("NOT_A_NUMBER");
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata2), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata2.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_SHORT");
    }
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_LONG");
    }
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata2.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  }
  var valid = (options.extended ? metadata2.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }
  return {
    country,
    countryCallingCode,
    carrierCode,
    valid,
    possible: valid ? true : options.extended === true && metadata2.possibleLengths() && isPossibleNumber(nationalNumber, metadata2) ? true : false,
    phone: nationalNumber,
    ext
  };
}
function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError("TOO_LONG");
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
}
function parseInput(text, v2, extract) {
  var number4 = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text2) {
      return _extractFormattedPhoneNumber(text2, extract, v2);
    }
  });
  if (!number4) {
    return {};
  }
  if (!isViablePhoneNumber(number4)) {
    if (isViablePhoneNumberStart(number4)) {
      return {
        error: "TOO_SHORT"
      };
    }
    return {};
  }
  var withExtensionStripped = extractExtension(number4);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number: number4
  };
}
function result(country, nationalNumber, ext) {
  var result2 = {
    country,
    phone: nationalNumber
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata2) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata2.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number4 = _extractCountryCallin.number;
  var country;
  if (countryCallingCode) {
    metadata2.selectNumberingPlan(countryCallingCode);
  } else if (number4 && (defaultCountry || defaultCallingCode)) {
    metadata2.selectNumberingPlan(defaultCountry, defaultCallingCode);
    if (defaultCountry) {
      country = defaultCountry;
    }
    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata2.metadata);
  } else
    return {};
  if (!number4) {
    return {
      countryCallingCodeSource,
      countryCallingCode
    };
  }
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number4), metadata2), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber,
    defaultCountry,
    metadata: metadata2
  });
  if (exactCountry) {
    country = exactCountry;
    if (exactCountry === "001")
      ;
    else {
      metadata2.country(country);
    }
  }
  return {
    country,
    countryCallingCode,
    countryCallingCodeSource,
    nationalNumber,
    carrierCode
  };
}
function ownKeys$1(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object4);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$1(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
function parsePhoneNumberWithError$2(text, options, metadata2) {
  return parse(text, _objectSpread$1(_objectSpread$1({}, options), {}, {
    v2: true
  }), metadata2);
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function ownKeys(object4, enumerableOnly) {
  var keys2 = Object.keys(object4);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object4);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object4, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    i2 % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value2) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value2, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value2;
  }
  return obj;
}
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o2, minLen);
}
function _arrayLikeToArray(arr, len2) {
  if (len2 == null || len2 > arr.length)
    len2 = arr.length;
  for (var i2 = 0, arr2 = new Array(len2); i2 < len2; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i2) {
  var _i2 = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i2 == null)
    return;
  var _arr = [];
  var _n2 = true;
  var _d2 = false;
  var _s2, _e2;
  try {
    for (_i2 = _i2.call(arr); !(_n2 = (_s2 = _i2.next()).done); _n2 = true) {
      _arr.push(_s2.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d2 = true;
    _e2 = err;
  } finally {
    try {
      if (!_n2 && _i2["return"] != null)
        _i2["return"]();
    } finally {
      if (_d2)
        throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata2;
  if (typeof arg_1 === "string") {
    text = arg_1;
  } else
    throw new TypeError("A text for parsing must be a string.");
  if (!arg_2 || typeof arg_2 === "string") {
    if (arg_4) {
      options = arg_3;
      metadata2 = arg_4;
    } else {
      options = void 0;
      metadata2 = arg_3;
    }
    if (arg_2) {
      options = _objectSpread({
        defaultCountry: arg_2
      }, options);
    }
  } else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata2 = arg_3;
    } else {
      metadata2 = arg_2;
    }
  } else
    throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text,
    options,
    metadata: metadata2
  };
}
var isObject = function isObject2(_2) {
  return _typeof(_2) === "object";
};
function parsePhoneNumberWithError$1() {
  var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata2 = _normalizeArguments.metadata;
  return parsePhoneNumberWithError$2(text, options, metadata2);
}
function parsePhoneNumberWithError() {
  return withMetadataArgument(parsePhoneNumberWithError$1, arguments);
}
function render$3S(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3551)" }, [
      createElementVNode("path", {
        d: "M17.2175 1.19072C15.6399 0.427875 13.87 0 12.0001 0C10.1303 0 8.36037 0.427875 6.78274 1.19072L5.73926 12L6.78274 22.8093C8.36037 23.5721 10.1303 24 12.0001 24C13.87 24 15.6399 23.5721 17.2175 22.8093L18.261 12L17.2175 1.19072Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.78262 1.19135C2.76872 3.1323 0 7.24272 0 12.0002C0 16.7577 2.76872 20.8681 6.78262 22.8091V1.19135Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M17.2178 1.19135V22.8091C21.2317 20.8681 24.0004 16.7577 24.0004 12.0002C24.0004 7.24272 21.2317 3.1323 17.2178 1.19135Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M12.0001 7.82672C9.69484 7.82672 7.82617 9.69544 7.82617 12.0006C7.82617 14.3058 9.69489 16.1745 12.0001 16.1745C14.3052 16.1745 16.174 14.3058 16.174 12.0006C16.174 9.69544 14.3053 7.82672 12.0001 7.82672ZM12.0001 14.6093C10.5593 14.6093 9.39138 13.4413 9.39138 12.0006C9.39138 10.5599 10.5594 9.39192 12.0001 9.39192C13.4408 9.39192 14.6088 10.5599 14.6088 12.0006C14.6088 13.4413 13.4408 14.6093 12.0001 14.6093Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0005 10.4362C11.4242 10.4362 10.957 10.9034 10.957 11.4797V13.0449H13.044V11.4797C13.044 10.9034 12.5768 10.4362 12.0005 10.4362Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3551" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3R(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3552)" }, [
      createElementVNode("path", {
        d: "M23.5866 15.1299C23.8556 14.1317 24 13.0826 24 11.9994C24 10.9163 23.8556 9.86715 23.5866 8.869L10.9565 0.045105C8.61178 0.247136 6.46008 1.12323 4.69566 2.4789L0.413391 8.869C0.144375 9.86715 0 10.9163 0 11.9994C0 13.0763 0.142641 14.1197 0.408656 15.1126L4.69561 21.52C6.46003 22.8757 8.61173 23.7518 10.9565 23.9538L23.5866 15.1299Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M0.413086 15.1305C1.1074 17.7067 2.63763 19.9395 4.69535 21.5206V15.1305H0.413086Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M10.9561 23.9544C11.3 23.984 11.6479 24.0001 11.9995 24.0001C17.5439 24.0001 22.2091 20.2397 23.5861 15.1305H10.9561V23.9544Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.5861 8.86955C22.2091 3.76036 17.5439 0 11.9995 0C11.6479 0 11.3 0.0160312 10.9561 0.0456562V8.86955H23.5861Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M4.69535 2.4798C2.63763 4.06089 1.1074 6.29369 0.413086 8.86989H4.69535V2.4798Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4343H9.39136H9.39131V0.284729C8.28234 0.530635 7.23098 0.929213 6.26086 1.45857V10.4342H0.101578C0.0347813 10.9466 0 11.469 0 11.9995C0 12.53 0.0347813 13.0524 0.101578 13.5647H6.26081H6.26086V22.5404C7.23098 23.0697 8.28234 23.4684 9.39131 23.7142V13.5648V13.5647H23.8984C23.9651 13.0524 24 12.53 24 11.9995C24 11.469 23.9651 10.9466 23.8984 10.4343Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3552" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3Q(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3553)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.783 8.90742H14.4364C14.7048 8.62646 14.8699 8.24606 14.8699 7.82686C14.8699 6.96244 14.1691 6.26166 13.3047 6.26166C12.7601 6.26166 12.2807 6.53991 12.0004 6.96183C11.72 6.53991 11.2406 6.26166 10.696 6.26166C9.83159 6.26166 9.13081 6.96244 9.13081 7.82686C9.13081 8.24606 9.29595 8.6265 9.56426 8.90742H5.21777C5.21777 10.06 6.2217 10.9943 7.37421 10.9943H7.30465C7.30465 12.147 8.23901 13.0814 9.39166 13.0814C9.39166 13.4547 9.49005 13.8046 9.6618 14.1076L7.93071 15.8388L9.25887 17.1668L11.1429 15.2829C11.2166 15.3099 11.293 15.3316 11.3719 15.3464L10.2334 17.9168L12.0004 19.8269L13.7673 17.9167L12.6289 15.3463C12.7077 15.3316 12.7841 15.3099 12.8578 15.2828L14.7418 17.1668L16.07 15.8386L14.3389 14.1075C14.5106 13.8046 14.609 13.4545 14.609 13.0812C15.7616 13.0812 16.696 12.1469 16.696 10.9942H16.6265C17.779 10.9943 18.783 10.06 18.783 8.90742Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3553" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3P(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3554)" }, [
      createElementVNode("path", {
        d: "M12.0008 0C18.6281 0 24.0007 5.37262 24.0007 12C24.0007 18.6274 18.6281 24 12.0008 24C12.0008 23.4783 10.4355 12 10.4355 12L12.0008 0Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 24C5.37262 24 0 18.6274 0 12C0 5.37262 5.37262 0 12 0",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M14.5781 9.69867L13.5936 11.0555L11.999 10.5383L12.9852 11.894L12.0007 13.2508L13.5946 12.7318L14.5808 14.0874L14.5798 12.4111L16.1738 11.8921L14.5793 11.3751L14.5781 9.69867Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.9948 15.392C11.1219 15.392 9.60353 13.8736 9.60353 12.0007C9.60353 10.1277 11.1219 8.60935 12.9948 8.60935C13.5788 8.60935 14.1283 8.757 14.608 9.01697C13.8554 8.28099 12.8262 7.82672 11.6905 7.82672C9.38528 7.82672 7.5166 9.69544 7.5166 12.0006C7.5166 14.3058 9.38532 16.1745 11.6905 16.1745C12.8263 16.1745 13.8555 15.7202 14.608 14.9843C14.1283 15.2443 13.5788 15.392 12.9948 15.392Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3554" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3O(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3555)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.8217 1.50525C16.0974 0.54675 14.1127 0 12 0C5.37309 0 0.00084375 5.37178 0 11.9986L8.34783 7.82611L17.8217 1.50525Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0 12.0019C0.00084375 18.6287 5.37309 24.0005 12 24.0005C14.1127 24.0005 16.0974 23.4538 17.8217 22.4952L8.34783 16.1744L0 12.0019Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M18.8217 2.12703C18.4994 1.90395 18.1654 1.69648 17.8213 1.50519L0 11.9983C0 11.9988 0 11.9993 0 11.9998C0 12.0002 0 12.0007 0 12.0012L17.8213 22.4943C18.1655 22.3029 18.4994 22.0955 18.8218 21.8724L2.05416 11.9998L18.8217 2.12703Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.8692 11.5526H19.4398C19.8115 11.1064 19.7885 10.4425 19.3698 10.0238C19.8133 9.58035 19.8133 8.86124 19.3698 8.41766L19.3431 8.44447C19.7866 8.00099 19.8133 7.25507 19.3698 6.81158L12.9453 13.2361C13.3888 13.6797 14.0953 13.6744 14.5388 13.2308L14.6625 13.1178L17.7388 12.8382V14.1613H18.7823V12.7433L20.3475 12.601L20.8692 11.5526Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M13.0439 14.6089L12 14.0872L13.0439 13.5654H19.8264V14.6089H13.0439Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3555" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3N(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3556)" }, [
      createElementVNode("path", {
        d: "M6.78274 22.8093C8.36037 23.5721 10.1302 24 12.0001 24C13.87 24 15.6399 23.5721 17.2175 22.8093L18.261 12L17.2175 1.19072C15.6399 0.427875 13.87 0 12.0001 0C10.1302 0 8.36037 0.427875 6.78274 1.19072L5.73926 12L6.78274 22.8093Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M17.2168 22.8091C21.2308 20.8682 23.9994 16.7577 23.9994 12.0002C23.9994 7.24272 21.2308 3.13225 17.2168 1.19135V22.8091Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.78262 22.8091V1.19135C2.76867 3.13225 0 7.24267 0 12.0002C0 16.7577 2.76867 20.8682 6.78262 22.8091Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12 16.1734C12 14.2585 12 11.9995 12 11.9995H15.1304V13.5647C15.1304 13.8366 14.6087 14.833 13.3209 15.6517C12.8332 15.9618 12.3283 16.0616 12 16.1734Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9996 8.86884H8.86914V11.9993H11.9996V8.86884Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.5653 7.8262C13.5653 7.24987 13.0981 6.78271 12.5218 6.78271C12.3315 6.78271 12.1536 6.83446 12.0001 6.92343C11.8465 6.83446 11.6687 6.78271 11.4783 6.78271C10.9021 6.78271 10.4349 7.24987 10.4349 7.8262H7.82617V13.0435C7.82617 14.9858 9.36864 16.1091 10.5782 16.6914C10.4877 16.846 10.4349 17.0254 10.4349 17.2175C10.4349 17.7938 10.9021 18.261 11.4783 18.261C11.6687 18.261 11.8465 18.2093 12.0001 18.1203C12.1537 18.2093 12.3315 18.261 12.5218 18.261C13.0981 18.261 13.5653 17.7938 13.5653 17.2175C13.5653 17.0254 13.5124 16.846 13.4218 16.6914C14.6314 16.1091 16.174 14.9859 16.174 13.0435V7.8262H13.5653ZM14.6088 13.0435C14.6088 13.3155 14.6087 14.1428 13.321 14.9616C12.8332 15.2717 12.3284 15.4728 12.0001 15.5846C11.6718 15.4728 11.1669 15.2717 10.6791 14.9616C9.39138 14.1428 9.39138 13.3155 9.39138 13.0435V9.3914H14.6088V13.0435Z",
        fill: "#FF9811"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3556" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3M(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3557)" }, [
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M24 12.0004C24 18.6277 18.6274 24.0004 12 24.0004C5.37262 24.0004 0 18.6277 0 12.0004",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M10.3535 9.54359L11.3708 10.2819L10.9831 11.4776L11.9997 10.7381L13.017 11.4763L12.6279 10.281L13.6443 9.54162L12.3874 9.54237L11.9982 8.34711L11.6105 9.5428L10.3535 9.54359Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.9994 6.80332C14.0538 6.25736 13.0199 5.99969 11.9994 6.00147V7.56635C12.7537 7.56499 13.5178 7.7553 14.2168 8.1589C16.3345 9.38158 17.0627 12.0992 15.84 14.2169C14.6173 16.3346 11.8998 17.0628 9.78199 15.8402C9.16502 15.484 8.66698 15.0003 8.29985 14.4422L6.99316 15.3048C7.4899 16.06 8.16471 16.7137 8.99941 17.1956C11.8646 18.8498 15.5413 17.8646 17.1955 14.9995C18.8497 12.1343 17.8646 8.45754 14.9994 6.80332Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M8.53898 10.956C8.12414 11.7144 8.40267 12.6655 9.16101 13.0804L14.2446 15.8582C13.8989 16.4901 14.0825 17.2593 14.7144 17.605L16.0876 18.3561C16.7195 18.7019 17.5122 18.4698 17.8579 17.8378L18.6091 16.4646L8.53898 10.956Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3557" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3L(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3558)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.0005H11.9999C11.9999 11.9897 11.9999 11.9792 11.9999 11.9684C11.9892 11.9791 11.9785 11.9898 11.9678 12.0005Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07027 1.56506C4.19344 2.63377 2.63311 4.19405 1.56445 6.07088V11.9999H4.69491V4.69561V4.69552H11.9993C11.9993 3.70819 11.9993 2.7676 11.9993 1.56506H6.07027Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9989 10.5248L7.73539 6.26135H6.25977V6.26145L11.9988 12.0005H11.9989C11.9989 12.0005 11.9989 10.9829 11.9989 10.5248Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.2942 13.7574C20.6393 13.2826 20.8698 12.7029 20.8698 12.0008V6.78339C20.4337 7.11095 19.8919 7.30511 19.3046 7.30511C18.4512 7.30511 17.6935 6.89528 17.2176 6.26172C16.7416 6.89528 15.984 7.30511 15.1306 7.30511C14.5433 7.30511 14.0014 7.11091 13.5654 6.78348V12.0008C13.5654 12.7029 13.7959 13.2826 14.141 13.7574H20.2942Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M19.208 11.0321C19.3741 10.6269 19.5033 10.0345 19.5033 9.7397C19.5033 9.26603 18.8858 8.88208 18.8858 8.88208C18.8858 8.88208 18.2682 9.26603 18.2682 9.7397C18.2682 10.0345 18.3975 10.6269 18.5635 11.0321L18.207 11.837C18.4166 11.9222 18.6456 11.9696 18.8858 11.9696C19.1261 11.9696 19.355 11.9222 19.5646 11.837L19.208 11.0321Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M16.7955 8.42672C16.3617 8.4855 15.784 8.66995 15.5287 8.81733C15.1185 9.05419 15.0947 9.78089 15.0947 9.78089C15.0947 9.78089 15.7361 10.1237 16.1462 9.88687C16.4016 9.73945 16.8499 9.33145 17.1177 8.98495L17.9932 8.8912C17.9622 8.66723 17.8885 8.44519 17.7685 8.2372C17.6483 8.02922 17.4929 7.85447 17.3144 7.71558L16.7955 8.42672Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M15.7445 11.8206C16.0123 12.1669 16.4608 12.5748 16.7162 12.7223C17.1264 12.9591 17.7677 12.6164 17.7677 12.6164C17.7677 12.6164 17.7438 11.8896 17.3336 11.6528C17.0782 11.5053 16.5007 11.3211 16.0667 11.2624L15.5479 10.5511C15.3694 10.69 15.214 10.8648 15.0938 11.0726C14.9738 11.2807 14.9003 11.5027 14.8691 11.7268L15.7445 11.8206Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M14.0117 13.5657C14.9862 15.1292 17.2175 15.6525 17.2175 15.6525C17.2175 15.6525 19.4487 15.1292 20.4232 13.5657H14.0117Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3558" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3K(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3559)" }, [
      createElementVNode("path", {
        d: "M0 11.9992C0 12.8212 0.082875 13.6238 0.240328 14.3992L12 15.1297L23.7597 14.3992C23.9172 13.6238 24 12.8212 24 11.9992C24 11.1773 23.9171 10.3747 23.7597 9.59923L12 8.86877L0.240328 9.59923C0.082875 10.3747 0 11.1773 0 11.9992Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.7596 14.3992H0.240234C1.35206 19.8765 6.19448 23.9992 11.9999 23.9992C17.8053 23.9992 22.6477 19.8765 23.7596 14.3992Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0.240234 9.6H23.7597C22.6478 4.12266 17.8054 0 11.9999 0C6.19439 0 1.35206 4.12266 0.240234 9.6Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M17.218 9.59937H6.7832L8.91508 8.59653L7.77981 6.53192L10.0947 6.97466L10.3882 4.63611L12.0006 6.35614L13.6131 4.63611L13.9063 6.97466L16.2214 6.53192L15.0862 8.59662L17.218 9.59937Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M0 12.0008C0 18.6282 5.37262 24.0008 12 24.0008L2.39981 4.80042C0.893062 6.80615 0 9.2991 0 12.0008Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12 23.9999C18.6274 23.9999 24 18.6272 24 11.9999C24 9.29813 23.1069 6.80517 21.6002 4.79944L12 23.9999Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3559" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3J(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3560)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 -0.000976562C7.24316 -0.000976562 3.13241 2.7677 1.19141 6.78165H22.8099C20.869 2.7677 16.7582 -0.000976562 12.0007 -0.000976562Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.0007 23.9987C16.7582 23.9987 20.869 21.23 22.81 17.2161H1.19141C3.13241 21.23 7.24316 23.9987 12.0007 23.9987Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M15.5864 12L14.1208 12.6894L14.9012 14.1087L13.3098 13.8043L13.1082 15.4119L11.9997 14.2295L10.8912 15.4119L10.6896 13.8043L9.09821 14.1087L9.87859 12.6894L8.41309 12L9.87863 11.3106L9.09821 9.89135L10.6896 10.1958L10.8913 8.58813L11.9997 9.77051L13.1082 8.58813L13.3098 10.1958L14.9013 9.89135L14.1209 11.3107L15.5864 12Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3560" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3I(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3561)" }, [
      createElementVNode("path", {
        d: "M24 12.0001C24 10.5323 23.736 9.12615 23.2536 7.82621L12 7.30444L0.746391 7.82616C0.264047 9.12614 0 10.5323 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174L12 16.6957L23.2536 16.174C23.736 14.874 24 13.4679 24 12.0001Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9996C17.1593 23.9996 21.5578 20.7431 23.2533 16.1735H0.746094C2.44161 20.7431 6.84012 23.9996 11.9997 23.9996Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M0.746094 7.82611H23.2534C21.5578 3.2565 17.1593 0 11.9997 0C6.84012 0 2.44161 3.2565 0.746094 7.82611Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3561" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3H(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3562)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9999 24.0003C15.637 24.0003 18.8959 22.382 21.0965 19.8264H2.90332C5.10396 22.382 8.36285 24.0003 11.9999 24.0003Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M24 12C24 5.37263 18.6274 0 12 0C5.37262 0 0 5.37263 0 12C0 13.0831 0.144375 14.1323 0.413391 15.1305H23.5867C23.8556 14.1323 24 13.0831 24 12Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M0.954102 16.6962C1.18543 17.2397 1.45585 17.7625 1.76152 18.2614H22.239C22.5446 17.7624 22.8151 17.2397 23.0465 16.6962H0.954102Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M5.4988 7.56904L3.1543 6.53432L5.4988 5.4996L6.53347 3.15515L7.56814 5.4996L9.9126 6.53432L7.56814 7.56904L6.53347 9.9135L5.4988 7.56904Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.53326 4.44739L7.17221 5.89531L8.62018 6.53436L7.17221 7.17336L6.53326 8.62128L5.89421 7.17336L4.44629 6.53436L5.89421 5.89531L6.53326 4.44739Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3562" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3G(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createTextVNode(" > "),
    createElementVNode("defs", null, [
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26117",
        gradientUnits: "userSpaceOnUse",
        x1: "-1706.416",
        x2: "-1705.416",
        gradientTransform: "matrix(1.972 -1.9014 -2.3361 -1.2306 7188.126 -1233.376)"
      }, [
        createElementVNode("stop", { "stop-color": "#288549" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#288549"
        })
      ]),
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26118",
        gradientUnits: "userSpaceOnUse",
        x1: "-1426.487",
        x2: "-1425.487",
        gradientTransform: "matrix(4.2109 1.6428 -2.7757 3.3581 11406.147 -4099.373)"
      }, [
        createElementVNode("stop", { "stop-color": "#288549" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#288549"
        })
      ]),
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26119",
        gradientUnits: "userSpaceOnUse",
        x1: "-1740.867",
        x2: "-1739.866",
        gradientTransform: "matrix(-.6286 -2.665 -2.2494 1.3805 3029.934 -7118.667)"
      }, [
        createElementVNode("stop", { "stop-color": "#288549" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#288549"
        })
      ]),
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26120",
        gradientUnits: "userSpaceOnUse",
        x1: "47.56",
        x2: "52.91",
        gradientTransform: "matrix(1 0 0 -1 0 66)"
      }, [
        createElementVNode("stop", { "stop-color": "#288549" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#288549"
        })
      ]),
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26121",
        gradientUnits: "userSpaceOnUse",
        x1: "-1458.591",
        x2: "-1457.591",
        gradientTransform: "rotate(45 10033.28 17957.933) scale(6.6516)"
      }, [
        createElementVNode("stop", { "stop-color": "#288549" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#288549"
        })
      ]),
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26122",
        gradientUnits: "userSpaceOnUse",
        x1: "-1618.009",
        x2: "-1617.009",
        gradientTransform: "matrix(1.1995 -5.0853 4.2924 2.6342 -5986.943 -13088.627)"
      }, [
        createElementVNode("stop", { "stop-color": "#288549" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#288549"
        })
      ])
    ]),
    createElementVNode("path", {
      fill: "#2a5f9e",
      d: "M11.9 12h20.8v20.8H11.9z"
    }),
    createElementVNode("path", {
      fill: "#ffffff",
      d: "M18.8 8.1V14h-7.3l14.4 18h6v-7.5z"
    }),
    createElementVNode("path", {
      d: "M31.9 2v30h-30c0 16.6 13.4 30 30 30s30-13.4 30-30s-13.5-30-30-30",
      fill: "#2a5f9e"
    }),
    createElementVNode("path", {
      d: "M10.9 18.9h-6c-1.9 4-3 8.4-3 13.1h12V13.9h-3v5",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      fill: "#ed4c5c",
      d: "M31.9 27.1L18.9 11h-6l17 21h2z"
    }),
    createElementVNode("path", {
      d: "M18.8 5v6h-7.9v3h21V2c-4.7 0-9.2 1.1-13.1 3",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M31.9 5H18.8c-6.1 2.9-11 7.9-13.9 13.9V32h6V11h21V5",
      fill: "#ed4c5c"
    }),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M49.9 27.9c.6-1.5 1.9-2.4 3-2c.3.1.6.3.7.6c-.1-.9-.5-1.7-1.2-2c-1.1-.4-2.5.5-3 2c-.4 1.1-.3 2.2.2 2.9c.1-.4.1-.9.3-1.5" }),
      createElementVNode("path", { d: "M42.1 24.5c-1.1-.4-2.4.5-3 2c-.3.7-.3 1.3-.2 1.9c-.5.4-1.2.6-2 .7c-.6 0-1.1 0-1.5-.2c.5.7 1.6 1.1 2.7 1.1c1.6-.1 2.9-1.1 2.8-2.3c0-.4-.2-.8-.5-1.1c.6-.6 1.5-.9 2.2-.7c.3.1.6.3.7.6c0-1-.5-1.7-1.2-2" }),
      createElementVNode("path", { d: "M59.6 27.6c-1-1.1-2.3-1.4-2.9-.5c-.2.2-.3.5-.3.8c-.3-.9-.2-1.7.2-2.3c.7-.8 2-.6 2.9.5c.7.8 1 1.9.9 2.7c-.2-.4-.5-.9-.8-1.2" }),
      createElementVNode("path", { d: "M36.2 27.1c.5-1.1.2-2.2-.6-2.4c-.2-.1-.5 0-.8 0c.5-.5 1.2-.8 1.8-.6c.9.2 1.1 1.3.6 2.4c-.4.8-1.1 1.4-1.8 1.6c.4-.2.7-.6.8-1" })
    ]),
    createElementVNode("path", {
      d: "M42.6 31.8s.1 5.1.1 5.5c.1.5.4 3.4 4.5 5.1c0 0 3.2-1.4 4-3.3c.8-1.9.7-5.5.7-5.5v-2l-9.3.2",
      fill: "#000000"
    }),
    createElementVNode("path", {
      d: "M43 32.2s.1 4.7.1 5.1c.1.4.3 3.1 4.2 4.7c0 0 3-1.3 3.8-3c.8-1.8.6-5.1.6-5.1v-1.8l-8.7.1",
      fill: "#ffffff"
    }),
    createElementVNode("g", { fill: "#1b81b6" }, [
      createElementVNode("path", { d: "M51.7 33.7l-1.2-.4l-1.6.7l-1.6-.5l-1.4.5l-1.7-.7l-1.2.5v1.6l1.2-.5l1.7.7l1.4-.5l1.6.5l1.6-.7l1.3.4l-.1-1.6" }),
      createElementVNode("path", { d: "M43.9 39.4c.1 0 2.1.6 2.1.6l1.4-.6l1.6.6s1.8-.7 2-.7c.5.1-2.7 2.7-3.6 2.7c-.8.1-4-2.4-3.5-2.6" }),
      createElementVNode("path", { d: "M51.4 38c-.2-.1-1-.3-1-.3l-1.5.7l-1.6-.6l-1.4.6l-1.6-.7s-.8.2-1 .4c-.1.1-.2-1.2-.2-1.2l1.2-.5l1.6.7l1.4-.6l1.6.6l1.5-.7l1.3.4c-.1 0-.2 1.3-.3 1.2" })
    ]),
    createElementVNode("path", {
      d: "M50.7 39.7l-.1.1l.1-.1m-3.2-5.5l-4.1 4.4c.2.4.4.8.7 1.3l3.4-3.5l3.2 3.4c.3-.4.6-.9.7-1.4l-3.9-4.2",
      fill: "url(#IconifyId17ecdb2904d178eab26121)"
    }),
    createElementVNode("path", {
      d: "M44.6 28.3l.6 1.4h4.2l.6-1.4l-2.7-6.4z",
      fill: "#000000"
    }),
    createElementVNode("path", {
      fill: "#7ed16d",
      d: "M44.8 28.1l.6 1.4h3.8l.5-1.4l-2.4-5.7z"
    }),
    createElementVNode("path", {
      fill: "#93695a",
      d: "M44.1 26.9l2.1 2.6l2.6-.1l.5-1.8l-1.8-.1l-1.2.6z"
    }),
    createElementVNode("path", {
      d: "M47.1 29.1l-3.2.9l1.5 1.8v1.7l1.6-.2s.8-1.5.9-1.5c.1 0 1.5.5 1.5.5l.3-.8l1.8-.6l-3.1-.9l.1-.8l-1.4-.1",
      fill: "#6baaa7"
    }),
    createElementVNode("path", {
      d: "M51.9 29.8c-.6.3-1.2.5-1.8.4c.7-.1 1.4-.7 1.6-1.4c.2-.8 0-1.6-.6-2.1c.1.4.1.7 0 1.1c-.3 1.1-1.5 1.9-2.6 1.4c-.5-.2-.6-.9-.6-1.2c-.3.7-.4 1.5 0 2.2c-.1.1-.1.2-.2.3c-.4 1 .1 2.1 1.1 2.4c.7.3 1.5.1 2-.4c-.3.1-.7 0-1-.1c-.6-.2-1-.7-1.1-1.2c.9.7 2.1.8 3.1.2c.9-.6 1.3-1.6 1.2-2.6c-.3.3-.6.7-1.1 1",
      fill: "url(#IconifyId17ecdb2904d178eab26120)"
    }),
    createElementVNode("path", {
      d: "M42.6 25.9c.5 1.5.1 3.1-1 3.5c-.3.1-.6.1-.9 0c.6.7 1.5 1 2.2.7c1.1-.4 1.6-1.9 1-3.5c-.4-1.1-1.2-1.9-2-2.1c.2.4.5.9.7 1.4",
      fill: "url(#IconifyId17ecdb2904d178eab26122)"
    }),
    createElementVNode("path", {
      d: "M36.1 27.2c-.3.8 0 1.6.5 1.8c.2.1.3.1.5 0c-.3.4-.8.5-1.1.4c-.6-.2-.8-1-.5-1.8c.2-.6.6-1 1.1-1.1c-.3.2-.4.4-.5.7",
      fill: "url(#IconifyId17ecdb2904d178eab26119)"
    }),
    createElementVNode("path", {
      d: "M58 25.4c-.8.2-1.4.8-1.3 1.4c0 .2.1.3.2.4c-.5-.1-.8-.4-.9-.8c-.1-.6.5-1.2 1.3-1.4c.6-.1 1.2 0 1.5.4H58",
      fill: "url(#IconifyId17ecdb2904d178eab26117)"
    }),
    createElementVNode("path", {
      d: "M55.9 27.5c-1.3.3-2.5-.4-2.7-1.5c-.1-.3 0-.6.1-.9c-.6.5-1 1.3-.8 2.1c.2 1.1 1.4 1.8 2.7 1.5c.9-.2 1.7-.9 1.9-1.7c-.3.1-.7.3-1.2.5",
      fill: "url(#IconifyId17ecdb2904d178eab26118)"
    }),
    createElementVNode("path", {
      d: "M36.1 43.3c-1.3-.5 2.9-2.7 4.7-2.6c1.4.1 4.2 2.5 3.2 2.8c-4.9 1.3-4.8 1-7.9-.2",
      fill: "#74948f"
    }),
    createElementVNode("path", {
      d: "M40.6 31.8c.1-.4.5-1.2.8-1.5c.3-.3 1.1-.6 1.5-.5c.3 0 1 .4.9.6h-.3c-.3.1-.4.9-.6 1.2c-.2.2-.8.3-.9.5c-.1.2.1 1 .1 1l-1.5.1s-.1-1 0-1.4",
      fill: "#e5c9bd"
    }),
    createElementVNode("path", {
      d: "M41 36.9c0 .1.7 1.8.9 2.5c.3 1.2-1.6 3.3-1.5 2.3c.2-1.3-.5-2.6-.5-2.6l1.1-2.2",
      fill: "#c6a397"
    }),
    createElementVNode("g", { fill: "#e5c9bd" }, [
      createElementVNode("path", { d: "M40.5 37.9c-.1.1.1 1.9.1 2.6c-.1 1.3-2.5 2.6-2.1 1.7c.6-1.2.3-2.6.3-2.6l1.7-1.7" }),
      createElementVNode("path", { d: "M41.5 33.3c0 .1 1.6 1.1 2.1 1.5c.9.9.5 3.6.1 2.7c-.6-1.2-1.8-1.9-1.8-1.9l-.4-2.3" })
    ]),
    createElementVNode("path", {
      d: "M41 32.4c-1.2.1-2.9 2.5-3.4 3.6c-.5 1.2-1.2 5-.5 5.2c.9.3 3.9-2 4.6-3.3c.6-1 .9-3.6.4-4.7c0-.2-.7-.8-1.1-.8",
      fill: "#d66b3c"
    }),
    createElementVNode("path", {
      d: "M58.6 43.3c1.3-.5-2.9-2.7-4.7-2.6c-1.4.1-4.2 2.5-3.2 2.8c4.9 1.3 4.7 1 7.9-.2",
      fill: "#74948f"
    }),
    createElementVNode("path", {
      d: "M54.1 31.8c-.1-.4-.5-1.2-.8-1.5c-.3-.3-1.1-.6-1.5-.5c-.3 0-1 .4-.9.6h.3c.3.1.4.9.6 1.2c.2.2.8.3.9.5c.1.2-.1 1-.1 1l1.5.1c-.1 0 .1-1 0-1.4",
      fill: "#e5c9bd"
    }),
    createElementVNode("path", {
      d: "M53.7 36.9c0 .1-.7 1.8-.9 2.5c-.3 1.2 1.6 3.3 1.5 2.3c-.2-1.3.5-2.6.5-2.6l-1.1-2.2",
      fill: "#c6a397"
    }),
    createElementVNode("g", { fill: "#e5c9bd" }, [
      createElementVNode("path", { d: "M54.2 37.9c.1.1-.1 1.9-.1 2.6c.1 1.3 2.5 2.6 2.1 1.7c-.6-1.2-.3-2.6-.3-2.6l-1.7-1.7" }),
      createElementVNode("path", { d: "M53.2 33.3c0 .1-1.6 1.1-2.1 1.5c-.9.9-.5 3.6-.1 2.7c.6-1.2 1.8-1.9 1.8-1.9l.4-2.3" })
    ]),
    createElementVNode("path", {
      d: "M53.7 32.4c1.2.1 2.9 2.5 3.4 3.6c.5 1.2 1.2 5 .5 5.2c-.9.3-3.9-2-4.6-3.3c-.6-1-.9-3.6-.4-4.7c0-.2.7-.8 1.1-.8",
      fill: "#d66b3c"
    })
  ]);
}
function render$3F(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3563)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0028 12 0.00135937 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.0004H11.9999C11.9999 11.9895 11.9999 11.9791 11.9999 11.9683C11.9892 11.979 11.9785 11.9897 11.9678 12.0004Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26171C12 4.15023 12 2.76662 12 0.000854492H11.998C5.3715 0.00193262 0 5.37404 0 12.0008H6.26086V8.47524L9.78642 12.0008H11.9679C11.9787 11.9901 11.9894 11.9794 12 11.9687C12 11.1602 12 10.4389 12 9.78732L8.47443 6.26171H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56567C4.19441 2.63438 2.63413 4.19466 1.56543 6.07149V12.0005H4.69588V4.69617V4.69613H12.0002C12.0002 3.7088 12.0002 2.76821 12.0002 1.56567H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0008 10.5249L7.73739 6.2615H6.26172C6.26172 6.26145 6.26172 6.2615 6.26172 6.2615L12.0008 12.0005H12.0008C12.0008 12.0005 12.0008 10.9831 12.0008 10.5249Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.23729 14.0864L7.89588 15.4635L9.38309 15.1198L8.71709 16.4933L9.91305 17.4417L8.42398 17.7774L8.42815 19.3038L7.23729 18.3488L6.04648 19.3038L6.05065 17.7774L4.56152 17.4417L5.75754 16.4933L5.09145 15.1198L6.57874 15.4635L7.23729 14.0864Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.9668 16.6954L18.2961 17.384L19.0397 17.2121L18.7066 17.8989L19.3047 18.3731L18.5601 18.5409L18.5622 19.3041L17.9668 18.8266L17.3714 19.3041L17.3734 18.5409L16.6289 18.3731L17.2269 17.8989L16.8939 17.2121L17.6375 17.384L17.9668 16.6954Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.9033 9.39148L15.2326 10.0801L15.9762 9.90814L15.6432 10.5949L16.2412 11.0691L15.4967 11.2369L15.4987 12.0002L14.9033 11.5227L14.3079 12.0002L14.3099 11.2369L13.5654 11.0691L14.1634 10.5949L13.8304 9.90814L14.574 10.0801L14.9033 9.39148Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.9668 5.21765L18.2961 5.90625L19.0397 5.73436L18.7067 6.42112L19.3046 6.89531L18.5601 7.06317L18.5622 7.82639L17.9668 7.34887L17.3714 7.82639L17.3734 7.06317L16.6289 6.89531L17.2268 6.42112L16.8939 5.73436L17.6375 5.90625L17.9668 5.21765Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M20.6416 8.34778L20.9709 9.03637L21.7145 8.86443L21.3815 9.5512L21.9795 10.0254L21.2349 10.1933L21.237 10.9565L20.6416 10.479L20.0462 10.9565L20.0482 10.1933L19.3037 10.0254L19.9017 9.5512L19.5687 8.86443L20.3123 9.03637L20.6416 8.34778Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M18.729 12.0004L18.988 12.7975H19.8262L19.1481 13.2902L19.4072 14.0873L18.729 13.5947L18.0509 14.0873L18.3099 13.2902L17.6318 12.7975H18.47L18.729 12.0004Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3563" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3E(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3564)" }, [
      createElementVNode("path", {
        d: "M23.2536 16.173C23.736 14.8731 24 13.467 24 11.9991C24 10.5313 23.736 9.12525 23.2536 7.82522L12 6.78174L0.746391 7.82522C0.264047 9.12525 0 10.5313 0 11.9991C0 13.467 0.264047 14.8731 0.746391 16.173L12 17.2165L23.2536 16.173Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9998 23.9996C17.1593 23.9996 21.5578 20.7431 23.2533 16.1735H0.746094C2.44166 20.7431 6.84013 23.9996 11.9998 23.9996Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 0C6.84012 0 2.44166 3.2565 0.746094 7.82611H23.2534C21.5578 3.2565 17.1593 0 11.9997 0Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3564" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3D(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3565)" }, [
      createElementVNode("path", {
        d: "M24 12.0001C24 10.5323 23.736 9.12615 23.2536 7.82621L12 7.30444L0.746391 7.82616C0.264047 9.12614 0 10.5323 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174L12 16.6957L23.2536 16.174C23.736 14.874 24 13.4679 24 12.0001Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0007 23.9996C17.1603 23.9996 21.5588 20.7431 23.2543 16.1735H0.74707C2.44259 20.7431 6.8411 23.9996 12.0007 23.9996Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M0.74707 7.82513H23.2543C21.5588 3.25552 17.1603 -0.000976562 12.0007 -0.000976562C6.8411 -0.000976562 2.44259 3.25552 0.74707 7.82513Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.2605 15.3911C10.3875 15.3911 8.86915 13.8727 8.86915 11.9997C8.86915 10.1268 10.3875 8.60843 12.2605 8.60843C12.8444 8.60843 13.3939 8.75609 13.8737 9.01606C13.121 8.28007 12.0918 7.82581 10.9561 7.82581C8.6509 7.82581 6.78223 9.69452 6.78223 11.9997C6.78223 14.3049 8.65094 16.1736 10.9561 16.1736C12.0919 16.1736 13.1211 15.7193 13.8737 14.9833C13.3939 15.2434 12.8444 15.3911 12.2605 15.3911Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.8693 9.65076L15.3185 10.9141L16.5295 10.3384L15.9538 11.5493L17.2171 11.9986L15.9538 12.4478L16.5295 13.6588L15.3185 13.0831L14.8693 14.3464L14.4202 13.0831L13.2091 13.6588L13.7849 12.4478L12.5215 11.9986L13.7849 11.5493L13.2091 10.3384L14.4202 10.9141L14.8693 9.65076Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3565" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3C(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3566)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M7.30584 7.82513H23.2551C21.5596 3.25552 17.161 -0.000976562 12.0015 -0.000976562C8.68771 -0.000976562 5.68804 1.34241 3.5166 3.51413L7.30584 7.82513Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M7.30486 16.1725H23.2541C21.5586 20.7421 17.16 23.9986 12.0005 23.9986C8.68673 23.9986 5.68706 22.6552 3.51562 20.4835L7.30486 16.1725Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51428C-1.17157 8.20056 -1.17157 15.7986 3.51471 20.4849C5.45126 18.5484 7.31374 16.6859 12 11.9996L3.51471 3.51428Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3566" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3B(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3567)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000976562C9.59141 -0.000976562 7.34928 0.708945 5.46997 1.93018L8.55617 3.99873L4.69531 5.9987L8.55617 7.99866L4.69531 9.99863L8.55617 11.9984L4.69531 13.9983L8.55617 15.9982L4.69531 17.9984L8.55617 19.9983L5.46959 22.0675C7.349 23.289 9.59127 23.999 11.9997 23.999C18.627 23.999 23.9997 18.6264 23.9997 11.999C23.9997 5.37165 18.627 -0.000976562 11.9997 -0.000976562Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3567" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3A(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3568)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M9.3912 17.2175C12.2727 17.2175 14.6086 14.8816 14.6086 12.0001C14.6086 9.11861 12.2727 6.78271 9.3912 6.78271C6.50973 6.78271 4.17383 9.11861 4.17383 12.0001C4.17383 14.8816 6.50973 17.2175 9.3912 17.2175Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3568" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3z(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3569)" }, [
      createElementVNode("path", {
        d: "M17.2175 1.19084C15.6399 0.427997 13.87 0.00012207 12.0001 0.00012207C10.1303 0.00012207 8.36037 0.427997 6.78274 1.19084L5.73926 12.0001L6.78274 22.8094C8.36037 23.5722 10.1303 24.0001 12.0001 24.0001C13.87 24.0001 15.6399 23.5722 17.2175 22.8094L18.261 12.0001L17.2175 1.19084Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M6.78262 1.19128C2.76872 3.13219 0 7.24261 0 12.0001C0 16.7577 2.76872 20.8681 6.78262 22.809V1.19128Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M17.2178 1.19165V22.8094C21.2317 20.8685 24.0004 16.758 24.0004 12.0005C24.0004 7.24303 21.2317 3.13256 17.2178 1.19165Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M15.6518 7.30337L16.3518 7.65334L15.6518 7.30337L14.9518 6.9534C14.9096 7.03783 13.9956 8.8975 13.8463 11.7382H12.7822V7.30337L11.9996 6.25989L11.217 7.30337V11.7382H10.153C10.0036 8.8975 9.08966 7.03783 9.04743 6.9534L7.64746 7.65339C7.65712 7.67261 8.60835 9.60878 8.60835 12.5208V13.3034H11.217V17.7382H12.7822V13.3034H15.3909V12.5207C15.3909 11.0152 15.6514 9.77378 15.87 8.99744C16.1083 8.15087 16.3503 7.65648 16.3527 7.65156L15.6518 7.30337Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3569" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3y(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3570)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FCFCFC"
      }),
      createElementVNode("path", {
        d: "M4.95669 11.1289L3.65234 8.76249L4.95669 6.43323L6.26103 8.76249L4.95669 11.1289Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M2.34731 11.1289L1.04297 8.76249L2.34731 6.43323L3.65166 8.76249L2.34731 11.1289Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M4.95669 17.5643L3.65234 15.1979L4.95669 12.8687L6.26103 15.1979L4.95669 17.5643Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M2.34731 17.5643L1.04297 15.1979L2.34731 12.8687L3.65166 15.1979L2.34731 17.5643Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M6.26041 2.32875L5.89113 1.66931C5.22878 2.06175 4.60755 2.51611 4.03516 3.02442L4.95606 4.69509L6.26041 2.32875Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M4.95605 19.3042L4.02539 20.9662C4.59727 21.4752 5.21808 21.9302 5.88014 22.3235L6.26044 21.6335L4.95605 19.3042Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M7.30371 15.1306V23.0461C8.74601 23.66 10.3329 24.0002 11.9994 24.0002C17.1589 24.0002 21.5575 20.7437 23.253 16.1741L7.30371 15.1306Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M23.253 16.174C23.7354 14.874 23.9994 13.468 23.9994 12.0001C23.9994 5.37275 18.6268 0.00012207 11.9994 0.00012207C10.333 0.00012207 8.74601 0.340106 7.30371 0.953935V16.1741H23.253V16.174Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3570" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3x(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3571)" }, [
      createElementVNode("path", {
        d: "M16.1735 0.746513C14.8735 0.264169 13.4675 0.00012207 11.9996 0.00012207C10.5318 0.00012207 9.1257 0.264169 7.82571 0.746513L6.78223 12.0001L7.82571 23.2537C9.1257 23.7361 10.5318 24.0001 11.9996 24.0001C13.4675 24.0001 14.8735 23.7361 16.1735 23.2537L17.217 12.0001L16.1735 0.746513Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.9999 11.9993C23.9999 6.83976 20.7434 2.4412 16.1738 0.745728V23.253C20.7434 21.5574 23.9999 17.1589 23.9999 11.9993Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12C0 17.1596 3.2565 21.5581 7.82611 23.2537V0.74646C3.2565 2.44193 0 6.84049 0 12Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3571" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3w(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3572)" }, [
      createElementVNode("path", {
        d: "M24 12C24 7.8815 21.9249 4.24808 18.7635 2.08695L12 1.56519L5.23655 2.0869C2.07516 4.24808 0 7.88155 0 12C0 16.1186 2.07516 19.7519 5.23655 21.913L12 22.4348L18.7635 21.9131C21.9249 19.7519 24 16.1186 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M18.7642 2.08709C16.8384 0.77056 14.5097 0.00012207 12.0008 0.00012207C9.49187 0.00012207 7.16316 0.77056 5.2373 2.08709H18.7642Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M5.23633 21.9133C7.16214 23.2299 9.49089 24.0003 11.9998 24.0003C14.5087 24.0003 16.8374 23.2299 18.7632 21.9133H5.23633Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12.0009 17.7382C15.1705 17.7382 17.74 15.1687 17.74 11.999C17.74 8.82939 15.1705 6.25989 12.0009 6.25989C8.83122 6.25989 6.26172 8.82939 6.26172 11.999C6.26172 15.1687 8.83122 17.7382 12.0009 17.7382Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0003 16.6954C14.5937 16.6954 16.696 14.5931 16.696 11.9997C16.696 9.4064 14.5937 7.30408 12.0003 7.30408C9.40701 7.30408 7.30469 9.4064 7.30469 11.9997C7.30469 14.5931 9.40701 16.6954 12.0003 16.6954Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M11.9996 15.1296C13.7285 15.1296 15.13 13.728 15.13 11.9991C15.13 10.2702 13.7285 8.86865 11.9996 8.86865C10.2707 8.86865 8.86914 10.2702 8.86914 11.9991C8.86914 13.728 10.2707 15.1296 11.9996 15.1296Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9994 11.217L10.3037 11.9997V13.304L11.9994 14.3475L13.695 13.304V11.9997L11.9994 11.217Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M13.695 10.4358H10.3037V12.001H13.695V10.4358Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3572" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3v(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3573)" }, [
      createElementVNode("path", {
        d: "M7.82617 10.9569L8.86966 23.587C9.86777 23.856 10.9169 24.0004 12.0001 24.0004C18.6274 24.0004 24.0001 18.6278 24.0001 12.0004L7.82617 10.9569Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.82617 12.0001L8.86961 0.413513C9.86777 0.144497 10.9169 0.00012207 12.0001 0.00012207C18.6274 0.00012207 24.0001 5.37275 24.0001 12.0001H7.82617Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M0 11.9997C0 17.544 3.76036 22.2093 8.86955 23.5863V0.413086C3.76036 1.79009 0 6.45537 0 11.9997Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3573" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3u(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3574)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0001 5.73889V9.78622L7.82617 5.73889H12.0001Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.26098 11.9996H9.78649L6.26098 7.30396L5.73926 10.9561L6.26098 11.9996Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9688 12.0012H12.0009C12.0009 11.9904 12.0009 11.9798 12.0009 11.969C11.9902 11.9797 11.9795 11.9905 11.9688 12.0012Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.999 6.26135C11.999 4.14986 11.999 2.76635 11.999 0.000488281H11.997C5.37048 0.00161328 -0.000976562 5.37372 -0.000976562 12.0005H6.25988V8.47497L9.7854 12.0005H11.967C11.9776 11.9898 11.9883 11.9791 11.9991 11.9684C11.9991 11.1599 11.9991 10.4386 11.9991 9.78696L8.47346 6.26135H11.999Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07027 1.56519C4.19344 2.63389 2.63311 4.19417 1.56445 6.071V12.5217H4.69491V4.69573V4.69564H12.521C12.521 3.70831 12.521 2.76772 12.521 1.56519H6.07027Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.476 11.0002L7.73539 6.25977H6.25977V6.25986L12.4758 12.4759H12.4759C12.476 12.476 12.476 11.4584 12.476 11.0002Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.5654 6.25989V11.999C13.5654 14.7946 20.8698 14.7946 20.8698 11.999V6.25989H13.5654Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M13.5654 12.0005V12.0005C13.5654 14.7961 17.2176 15.6527 17.2176 15.6527C17.2176 15.6527 20.8698 14.7961 20.8698 12.0005V12.0005H13.5654Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M17.2171 9.70447L15.5215 10.4349V12.0001L17.2171 13.0436L18.9128 12.0001V10.4349L17.2171 9.70447Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M18.9128 8.86865H15.5215V10.4339H18.9128V8.86865Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3574" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3t(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3575)" }, [
      createElementVNode("path", {
        d: "M3.51373 20.4854C-1.17255 15.7991 -1.17255 8.20118 3.51373 3.51485C8.20002 -1.17148 15.798 -1.17143 20.4844 3.51485C20.4844 3.51649 23.6704 14.2988 18.984 18.9851C14.2978 23.6715 3.51702 20.4887 3.51373 20.4854Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.51465 20.4846C8.20093 25.1709 15.7989 25.1709 20.4853 20.4846C25.1716 15.7983 25.1716 8.20036 20.4853 3.51404L3.51465 20.4846Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M18.7886 6.78192V4.69495H14.7885L14.4829 5.00052C13.3959 6.08751 13.5788 7.35557 13.7123 8.28145C13.8361 9.14034 13.8509 9.46935 13.5315 9.78881C13.2121 10.1082 12.883 10.0934 12.0242 9.96946C11.0983 9.83601 9.83032 9.65315 8.74334 10.7401C7.6564 11.827 7.83935 13.095 7.97294 14.0208C8.09684 14.8796 8.11174 15.2086 7.79243 15.5279C7.47307 15.8472 7.14396 15.8323 6.28535 15.7084C5.95057 15.6601 5.6044 15.6102 5.23484 15.6061L5.21191 17.693C5.4432 17.6955 5.70752 17.7336 5.98737 17.774C6.31868 17.8219 6.69368 17.876 7.08865 17.876C7.49796 17.876 7.92855 17.8176 8.3538 17.634V19.3037H11.4843V17.7385H9.91905V16.695H10.9625V15.1298H10.1285C10.1681 14.6235 10.0985 14.1386 10.0385 13.7229C9.91465 12.8641 9.89974 12.5351 10.2191 12.2159C10.5385 11.8965 10.8674 11.9113 11.7264 12.0351C12.401 12.1324 13.2574 12.2553 14.093 11.8946V13.5646H17.2234V11.9994H15.6582V10.9559H16.7017V9.3907H15.8678C15.9074 8.88431 15.8379 8.39948 15.7779 7.98365C15.6914 7.3836 15.658 7.04217 15.7548 6.78196H18.7886V6.78192Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3575" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3s(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3576)" }, [
      createElementVNode("path", {
        d: "M24 12.0006C24 10.5328 23.736 9.12669 23.2536 7.82676L12 7.30499L0.746391 7.82671C0.264 9.12669 0 10.5328 0 12.0006C0 13.4685 0.264 14.8746 0.746391 16.1745L12 16.6963L23.2536 16.1746C23.736 14.8746 24 13.4685 24 12.0006Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9999C17.1593 23.9999 21.5578 20.7434 23.2533 16.1738H0.746094C2.44161 20.7434 6.84013 23.9999 11.9997 23.9999Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M0.746094 7.82641H23.2534C21.5578 3.25681 17.1593 0.000305176 11.9997 0.000305176C6.84012 0.000305176 2.44161 3.25681 0.746094 7.82641Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3576" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3r(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3577)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M3.51534 3.51432C0.943538 6.08612 -0.216478 9.5349 0.034444 12.898L12.899 0.0334789C9.53587 -0.21749 6.08713 0.942526 3.51534 3.51432Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.28516 21.1899C8.99989 25.1565 16.048 24.9219 20.4856 20.4843C24.9233 16.0467 25.1579 8.99856 21.1912 4.28387L4.28516 21.1899Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.957 11.5167L12.9912 10.9566L11.957 10.3964C11.7156 8.82794 10.4763 7.58861 8.90783 7.34721L8.34763 6.31305L7.78747 7.34716C6.21904 7.58857 4.97976 8.82789 4.73826 10.3964L3.7041 10.9566L4.73821 11.5167C4.97966 13.0852 6.21894 14.3246 7.78743 14.566L8.34763 15.6001L8.90778 14.566C10.4763 14.3246 11.7156 13.0852 11.957 11.5167ZM8.34768 13.0436C7.19507 13.0436 6.26071 12.1092 6.26071 10.9566C6.26071 9.80393 7.19502 8.86961 8.34768 8.86961C9.50033 8.86961 10.4346 9.80393 10.4346 10.9566C10.4346 12.1092 9.50029 13.0436 8.34768 13.0436Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M8.34767 9.39093L8.7995 10.1735H9.7032L9.25133 10.9561L9.7032 11.7388H8.7995L8.34767 12.5213L7.89584 11.7388H6.99219L7.44402 10.9561L6.99219 10.1735H7.89584L8.34767 9.39093Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3577" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3q(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3578)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9999 -0.000732422C7.74505 -0.000732422 4.0077 2.21378 1.87695 5.55297L18.15 22.3047C21.6536 20.2093 23.9999 16.3785 23.9999 11.9993C23.9999 5.37189 18.6273 -0.000732422 11.9999 -0.000732422Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.9996 11.9991C23.9996 8.8856 22.8137 6.04928 20.8691 3.91656V20.0817C22.8137 17.949 23.9996 15.1127 23.9996 11.9991Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M14.9901 22.587L16.2471 22.5862L16.6348 21.3904L17.024 22.5857L17.6544 22.5853C18.041 22.3784 18.4149 22.1509 18.7747 21.9043L2.0948 5.22437C1.81992 5.62543 1.56923 6.04421 1.34381 6.47827L1.49203 6.93352L2.74898 6.93272L1.73255 7.67218L2.1217 8.86744L1.10433 8.12926L0.497531 8.57063C0.174047 9.65701 0 10.8077 0 11.9992C0 18.6265 5.37262 23.9992 12 23.9992C13.4012 23.9992 14.7461 23.7586 15.9961 23.317L14.9901 22.587ZM2.67652 11.4774L3.06417 10.2818L2.04689 9.54348L3.30384 9.54268L3.69155 8.34694L4.0807 9.54221L5.33766 9.54141L4.32117 10.2809L4.71033 11.4761L3.69295 10.7379L2.67652 11.4774ZM5.26519 14.0861L5.65284 12.8904L4.63556 12.1522L5.89252 12.1514L6.28022 10.9556L6.66937 12.1509L7.92633 12.1501L6.90989 12.8896L7.29905 14.0848L6.28167 13.3466L5.26519 14.0861ZM7.85381 16.6948L8.24147 15.4991L7.22419 14.7608L8.48114 14.7601L8.86884 13.5643L9.258 14.7596L10.515 14.7588L9.49851 15.4982L9.88767 16.6935L8.8703 15.9552L7.85381 16.6948ZM11.4589 18.5641L10.4424 19.3035L10.8301 18.1078L9.81281 17.3695L11.0698 17.3687L11.4575 16.173L11.8467 17.3683L13.1036 17.3675L12.0872 18.1069L12.4763 19.3022L11.4589 18.5641ZM13.0311 21.9122L13.4188 20.7165L12.4015 19.9782L13.6584 19.9774L14.0461 18.7817L14.4353 19.977L15.6922 19.9762L14.6758 20.7156L15.065 21.9109L14.0476 21.1726L13.0311 21.9122Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3578" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3p(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3579)" }, [
      createElementVNode("path", {
        d: "M0.566625 8.34777C0.199031 9.49944 -4.68667e-05 10.7263 8.276e-09 11.9999C-4.68667e-05 13.2735 0.199031 14.5004 0.566672 15.6521L12 16.1739L23.4333 15.6521C23.8008 14.5004 24 13.2734 24 12C24 10.7264 23.8009 9.49944 23.4333 8.34777L12 7.82605L0.566625 8.34777Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M24 12.0005C24 11.2886 23.9377 10.5913 23.8187 9.91351H0.181313C0.0623437 10.5913 0 11.2885 0 12.0005C0 12.7124 0.0623906 13.4096 0.181313 14.0874H23.8187C23.9376 13.4096 24 12.7124 24 12.0005Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9997C17.3536 23.9997 21.8878 20.4933 23.433 15.6518H0.566406C2.11164 20.4932 6.64591 23.9996 11.9997 23.9997Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M11.9998 -0.00061035C6.64595 -0.00061035 2.11173 3.50578 0.566406 8.34712L23.433 8.34717C21.8878 3.50578 17.3536 -0.0007041 11.9998 -0.00061035Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3579" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3o(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3580)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M11.9999 4.69611L21.913 12.0004L11.9999 19.3048L2.08691 12.0004L11.9999 4.69611Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0001 16.1738C14.3052 16.1738 16.174 14.3051 16.174 11.9999C16.174 9.69476 14.3052 7.82605 12.0001 7.82605C9.69489 7.82605 7.82617 9.69476 7.82617 11.9999C7.82617 14.3051 9.69489 16.1738 12.0001 16.1738Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.91276 11.7395C9.18694 11.7395 8.48649 11.8499 7.82715 12.0547C7.85635 14.3347 9.71279 16.1743 11.9997 16.1743C13.4138 16.1743 14.6628 15.4704 15.4178 14.3945C14.1261 12.7775 12.1385 11.7395 9.91276 11.7395Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M16.0962 12.7998C16.1464 12.5409 16.1735 12.2737 16.1735 12.0001C16.1735 9.69491 14.3048 7.82623 11.9997 7.82623C10.2796 7.82623 8.80306 8.86691 8.16406 10.3528C8.72891 10.2357 9.31372 10.1741 9.91273 10.1741C12.337 10.174 14.5301 11.1817 16.0962 12.7998Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3580" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3n(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3581)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M21.9999 13.4358C20.9999 13.4358 20.9999 12.5214 19.9998 12.5214C18.9999 12.5214 18.9999 13.4358 17.9999 13.4358C17 13.4358 16.9999 12.5214 16 12.5214C15 12.5214 15 13.4358 14 13.4358C13 13.4358 12.9999 12.5214 11.9998 12.5214C10.9998 12.5214 10.9998 13.4358 9.99991 13.4358C9.00006 13.4358 9.00006 12.5214 8.00008 12.5214C7 12.5214 7 13.4358 5.99992 13.4358C4.99984 13.4358 4.99984 12.5214 3.99977 12.5214C2.99992 12.5214 2.99992 13.4358 1.99994 13.4358C1.00534 13.4358 0.999578 12.5315 0.015625 12.5218C0.0433281 13.0707 0.108859 13.6096 0.207953 14.1366C1.00502 14.2537 1.07481 15.0357 2.00003 15.0357C3.00002 15.0357 3.00002 14.1215 3.99986 14.1215C4.99994 14.1215 4.99994 15.0357 6.00002 15.0357C7.00009 15.0357 7.00009 14.1215 8.00017 14.1215C9.00016 14.1215 9.00016 15.0357 10 15.0357C11 15.0357 11 14.1215 11.9999 14.1215C13 14.1215 13 15.0357 14.0001 15.0357C15.0002 15.0357 15.0002 14.1215 16.0001 14.1215C17.0001 14.1215 17.0001 15.0357 18 15.0357C19 15.0357 19 14.1215 19.9999 14.1215C21 14.1215 21 15.0357 22 15.0357C22.9252 15.0357 22.995 14.2537 23.7921 14.1366C23.8913 13.6096 23.9567 13.0708 23.9845 12.5218C23.0004 12.5315 22.9945 13.4358 21.9999 13.4358Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M20.0003 15.6514C19.0003 15.6514 19.0003 16.5658 18.0003 16.5658C17.0004 16.5658 17.0004 15.6514 16.0004 15.6514C15.0004 15.6514 15.0004 16.5658 14.0004 16.5658C13.0003 16.5658 13.0003 15.6514 12.0003 15.6514C11.0003 15.6514 11.0003 16.5658 10.0003 16.5658C9.00049 16.5658 9.00049 15.6514 8.00051 15.6514C7.00043 15.6514 7.00043 16.5658 6.00035 16.5658C5.00027 16.5658 5.00027 15.6514 4.0002 15.6514C3.00035 15.6514 3.00035 16.5658 2.00037 16.5658C1.26373 16.5658 1.06924 16.0699 0.618164 15.8087C0.891352 16.6253 1.25018 17.4024 1.68354 18.1301C1.77738 18.1527 1.88173 18.1658 2.00032 18.1658C3.0003 18.1658 3.0003 17.2515 4.00015 17.2515C5.00023 17.2515 5.00023 18.1658 6.0003 18.1658C7.00038 18.1658 7.00038 17.2515 8.00046 17.2515C9.00045 17.2515 9.00045 18.1658 10.0003 18.1658C11.0003 18.1658 11.0003 17.2515 12.0002 17.2515C13.0003 17.2515 13.0003 18.1658 14.0004 18.1658C15.0004 18.1658 15.0004 17.2515 16.0004 17.2515C17.0004 17.2515 17.0004 18.1658 18.0003 18.1658C19.0002 18.1658 19.0003 17.2515 20.0002 17.2515C21.0003 17.2515 21.0003 18.1658 22.0002 18.1658C22.1189 18.1658 22.2234 18.1527 22.3173 18.13C22.7507 17.4024 23.1094 16.6253 23.3826 15.8088C22.9315 16.07 22.737 16.5658 22.0002 16.5658C21.0004 16.5658 21.0003 15.6514 20.0003 15.6514Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.7211 9.41946C22.9902 9.57119 22.897 10.306 22.0002 10.306C21.0002 10.306 21.0002 9.39166 20.0002 9.39166C19.0002 9.39166 19.0002 10.306 18.0002 10.306C17.0003 10.306 17.0003 9.39166 16.0003 9.39166C15.0003 9.39166 15.0003 10.306 14.0003 10.306C13.0003 10.306 13.0002 9.39166 12.0001 9.39166C11.4598 9.39166 11.2114 9.65857 10.9395 9.904V11.504C11.2114 11.2586 11.4598 10.9917 12.0001 10.9917C13.0002 10.9917 13.0002 11.906 14.0003 11.906C15.0004 11.906 15.0004 10.9917 16.0003 10.9917C17.0003 10.9917 17.0003 11.906 18.0002 11.906C19.0002 11.906 19.0002 10.9917 20.0002 10.9917C21.0002 10.9917 21.0002 11.906 22.0002 11.906C22.9254 11.906 22.9952 11.124 23.7923 11.0069C23.8434 11.0069 23.9005 11.0064 23.959 11.0057C23.9147 10.466 23.8345 9.93654 23.7211 9.41946Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M22.8445 6.85727C22.6373 7.03132 22.3978 7.17588 22.0002 7.17588C21.0002 7.17588 21.0002 6.26154 20.0002 6.26154C19.0002 6.26154 19.0002 7.17588 18.0002 7.17588C17.0003 7.17588 17.0003 6.26154 16.0003 6.26154C15.0003 6.26154 15.0003 7.17588 14.0003 7.17588C13.0003 7.17588 13.0002 6.26154 12.0001 6.26154C11.4598 6.26154 11.2114 6.52844 10.9395 6.77388V8.37386C11.2114 8.12847 11.4598 7.86161 12.0001 7.86161C13.0002 7.86161 13.0002 8.77586 14.0003 8.77586C15.0003 8.77586 15.0003 7.86161 16.0003 7.86161C17.0003 7.86161 17.0003 8.77586 18.0002 8.77586C19.0001 8.77586 19.0001 7.86161 20.0001 7.86161C21.0002 7.86161 21.0002 8.77586 22.0001 8.77586C22.7097 8.77586 22.9164 8.31625 23.3335 8.04897C23.1914 7.6413 23.0281 7.24357 22.8445 6.85727Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M20.0856 3.13263C20.0579 3.13113 20.0296 3.13019 20.0002 3.13019C19.0002 3.13019 19.0002 4.04453 18.0003 4.04453C17.0003 4.04453 17.0003 3.13019 16.0004 3.13019C15.0004 3.13019 15.0004 4.04453 14.0003 4.04453C13.0002 4.04453 13.0002 3.13019 12.0001 3.13019C11.4598 3.13019 11.2114 3.39709 10.9395 3.64253V5.24252C11.2114 4.99713 11.4598 4.73027 12.0001 4.73027C13.0002 4.73027 13.0002 5.64452 14.0003 5.64452C15.0004 5.64452 15.0004 4.73027 16.0003 4.73027C17.0003 4.73027 17.0003 5.64452 18.0002 5.64452C19.0002 5.64452 19.0002 4.73027 20.0002 4.73027C21.0002 4.73027 21.0002 5.64452 22.0002 5.64452C22.0618 5.64452 22.1193 5.64086 22.1738 5.63435C21.5929 4.70791 20.8896 3.86617 20.0856 3.13263Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M15.0668 0.396249C14.7923 0.643186 14.5443 0.914405 13.9996 0.914405C12.9996 0.914405 12.9996 0.000154785 11.9995 6.10352e-05H11.9994C11.4822 0.00010791 11.2326 0.244655 10.9736 0.480858V2.08089C11.2325 1.84469 11.4823 1.60009 11.9995 1.60009C12.9996 1.60009 12.9996 2.51434 13.9997 2.51434C14.9997 2.51434 14.9997 1.60009 15.9997 1.60009C16.9997 1.60009 16.9997 2.51434 17.9996 2.51434C18.4192 2.51434 18.6626 2.35328 18.8778 2.16644C17.7371 1.36698 16.4509 0.761077 15.0668 0.396249Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M14.0003 22.8273C13.0002 22.8273 13.0002 21.913 12.0001 21.913C11.0002 21.913 11.0002 22.8273 10.0002 22.8273C9.00037 22.8273 9.00037 21.913 8.00038 21.913C7.2344 21.913 7.05473 22.4489 6.56348 22.7001C7.91817 23.3898 9.42131 23.8294 11.0122 23.9591C11.2583 23.7343 11.5082 23.513 12.0001 23.513C12.4922 23.513 12.7421 23.7343 12.9882 23.9592C14.5792 23.8295 16.0824 23.3898 17.4372 22.7001C16.9458 22.449 16.7662 21.9129 16.0003 21.9129C15.0004 21.9129 15.0004 22.8273 14.0003 22.8273Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M18.0003 19.6977C17.0003 19.6977 17.0003 18.7833 16.0003 18.7833C15.0004 18.7833 15.0004 19.6977 14.0003 19.6977C13.0002 19.6977 13.0003 18.7833 12.0002 18.7833C11.0002 18.7833 11.0002 19.6977 10.0003 19.6977C9.00041 19.6977 9.00041 18.7833 8.00042 18.7833C7.00034 18.7833 7.00034 19.6977 6.00027 19.6977C5.00019 19.6977 5.00019 18.7833 4.00011 18.7833C3.281 18.7833 3.07906 19.2563 2.65039 19.5218C2.91908 19.8555 3.20473 20.1749 3.50703 20.4777C3.64245 20.4199 3.80136 20.3834 4.00006 20.3834C5.00014 20.3834 5.00014 21.2976 6.00022 21.2976C7.0003 21.2976 7.0003 20.3834 8.00038 20.3834C9.00036 20.3834 9.00036 21.2976 10.0002 21.2976C11.0002 21.2976 11.0002 20.3834 12.0001 20.3834C13.0002 20.3834 13.0002 21.2976 14.0003 21.2976C15.0004 21.2976 15.0004 20.3834 16.0003 20.3834C17.0002 20.3834 17.0003 21.2976 18.0002 21.2976C19.0002 21.2976 19.0002 20.3834 20.0001 20.3834C20.1991 20.3834 20.358 20.4199 20.4935 20.4778C20.7958 20.1749 21.0815 19.8555 21.3502 19.5219C20.9215 19.2564 20.7195 18.7834 20.0002 18.7834C19.0002 18.7833 19.0002 19.6977 18.0003 19.6977Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 11.9991H11.9999C11.9999 11.9883 11.9999 11.9778 11.9999 11.9669C11.9892 11.9777 11.9785 11.9884 11.9678 11.9991Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0001 6.26153V9.78714L7.82617 5.73981L12.0001 6.26153Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.26102 12.0005H9.78649L6.26098 7.30487L5.73926 10.957L6.26102 12.0005Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.3715 0.001125 0 5.37323 0 12H6.2609V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56415C4.19441 2.63285 2.63413 4.19313 1.56543 6.06996V11.9989H4.69588V4.6947V4.6946H12.0002C12.0002 3.70727 12.0002 2.76668 12.0002 1.56415H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9999 10.5234L7.73637 6.25995H6.26074V6.26004L11.9998 11.999H11.9999C11.9999 11.999 11.9999 10.9815 11.9999 10.5234Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.6523 6.26099H20.348L18.0002 8.60882L15.6523 6.26099Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M18.522 8.08649H17.4785V10.956H18.522V8.08649Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M18.521 15.652H17.4775V18.5215H18.521V15.652Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M21.13 14.0874C21.13 13.2229 20.4292 12.5222 19.5648 12.5222C19.1638 12.5222 18.7983 12.6731 18.5213 12.921V12.0004H19.043V10.9569H18.5213V10.4352H17.4778V10.9569H16.9561V12.0004H17.4778V12.921C17.2008 12.6731 16.8353 12.5222 16.4343 12.5222C15.5699 12.5222 14.8691 13.2229 14.8691 14.0874C14.8691 14.5508 15.0708 14.9671 15.3909 15.2537V16.1743H20.6082V15.2537C20.9284 14.9671 21.13 14.5508 21.13 14.0874Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.5652 13.5649C19.4006 13.5649 19.2854 13.6372 19.2177 13.6978L18.5217 14.3208H17.4783L16.7823 13.6978C16.7146 13.6372 16.5994 13.5649 16.4348 13.5649C16.1471 13.5649 15.9131 13.799 15.9131 14.0867C15.9131 14.2893 16.0224 14.4173 16.0875 14.4757L16.4349 14.7867V15.1301H19.5653V14.7867L19.9127 14.4757C19.9778 14.4174 20.0871 14.2893 20.0871 14.0867C20.087 13.799 19.8529 13.5649 19.5652 13.5649Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3581" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3m(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3582)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9688 12.0007H12.0009C12.0009 11.9899 12.0009 11.9794 12.0009 11.9686C11.9902 11.9793 11.9795 11.99 11.9688 12.0007Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26178C12 4.15029 12 2.76677 12 0.000915527H11.998C5.37145 0.00204053 0 5.37415 0 12.0009H6.26086V8.4754L9.78637 12.0009H11.9679C11.9786 11.9902 11.9893 11.9795 12 11.9688C12 11.1604 12 10.439 12 9.78738L8.47443 6.26178H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07027 1.56415C4.19344 2.63285 2.63311 4.19313 1.56445 6.06996V11.9989H4.69491V4.6947V4.6946H11.9993C11.9993 3.70727 11.9993 2.76668 11.9993 1.56415H6.07027Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M17.218 11.9996L13.9746 15.2431C14.5825 16.4154 15.8063 17.217 17.218 17.217C18.6298 17.217 19.8536 16.4154 20.4615 15.2431L17.218 11.9996Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9999 10.5244L7.73637 6.26099H6.26074V6.26108L11.9998 12.0001H11.9999C11.9999 12.0001 11.9999 10.9826 11.9999 10.5244Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.5654 6.26099V12.0001V12.0001C13.5655 14.7957 17.2176 15.6523 17.2176 15.6523C17.2176 15.6523 20.8697 14.7957 20.8698 12.0001V12.0001V6.26099H13.5654Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M17.9998 8.86987H16.4346V13.0438H17.9998V8.86987Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.2172 9.65174C17.6494 9.65174 17.9998 9.30135 17.9998 8.86911C17.9998 8.43688 17.6494 8.08649 17.2172 8.08649C16.785 8.08649 16.4346 8.43688 16.4346 8.86911C16.4346 9.30135 16.785 9.65174 17.2172 9.65174Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M15.6529 7.30481H14.6094V8.34829H15.6529V7.30481Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.6519 9.65198H14.6084V10.6955H15.6519V9.65198Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.6519 12.0005H14.6084V13.044H15.6519V12.0005Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.8257 7.30548H18.7822V8.34897H19.8257V7.30548Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.8257 9.65198H18.7822V10.6955H19.8257V9.65198Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.8257 12.0005H18.7822V13.044H19.8257V12.0005Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3582" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3l(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3583)" }, [
      createElementVNode("path", {
        d: "M12.0002 23.9977C18.6266 23.9977 23.9984 18.6259 23.9984 11.9995C23.9984 5.37302 18.6266 0.0012207 12.0002 0.0012207C5.37375 0.0012207 0.00195312 5.37302 0.00195312 11.9995C0.00195312 18.6259 5.37375 23.9977 12.0002 23.9977Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.6094 6.00122C1.06784 6.93912 0.668365 7.91967 0.402344 8.91846L20.468 20.5034C21.2 19.7736 21.8495 18.9373 22.3909 17.9995L1.6094 6.00122Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M17.9983 1.6092C13.1974 -1.16253 7.27791 -0.238742 3.53125 3.4969L23.5969 15.0818C24.9588 9.9694 22.799 4.38098 17.9983 1.6092Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M6.0003 22.3899C10.8011 25.1617 16.7207 24.2379 20.4673 20.5023L0.401573 8.91724C-0.960222 14.0298 1.19945 19.6182 6.0003 22.3899Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.3903 10.6964C15.3903 12.569 13.8722 14.0872 11.9995 14.0872C10.1268 14.0872 8.60867 12.5691 8.60867 10.6964C8.60867 10.1125 8.75629 9.56306 9.01626 9.08337C8.28045 9.83587 7.82617 10.8649 7.82617 12.0005C7.82617 14.3054 9.6946 16.1738 11.9995 16.1738C14.3044 16.1738 16.1728 14.3054 16.1728 12.0005C16.1728 10.8649 15.7186 9.83587 14.9827 9.08337C15.2427 9.56315 15.3903 10.1125 15.3903 10.6964Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.7828 6.78357H11.2178V14.6085H12.7828V6.78357Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.6082 8.34827H9.3916C9.3916 8.70841 9.70534 9.00036 10.0654 9.00036H10.0437C10.0437 9.36051 10.3357 9.65245 10.6958 9.65245C10.6958 10.0126 10.9878 10.3045 11.3479 10.3045H12.652C13.0122 10.3045 13.3041 10.0126 13.3041 9.65245C13.6643 9.65245 13.9562 9.36051 13.9562 9.00036H13.9345C14.2945 9.00031 14.6082 8.70846 14.6082 8.34827Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.6519 15.13H8.34863V16.695H15.6519V15.13Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.6944 15.651H13.5645V17.216H16.6944V15.651Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M10.4346 15.651H7.30469V17.216H10.4346V15.651Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3583" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3k(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3584)" }, [
      createElementVNode("path", {
        d: "M24 12.0007C24 10.5329 23.736 9.12676 23.2536 7.82682L12 7.30505L0.746391 7.82677C0.264047 9.12675 0 10.5329 0 12.0007C0 13.4685 0.264047 14.8747 0.746391 16.1746L12 16.6964L23.2536 16.1746C23.736 14.8747 24 13.4685 24 12.0007Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9999C17.1593 23.9999 21.5578 20.7434 23.2533 16.1738H0.746094C2.44161 20.7434 6.84012 23.9999 11.9997 23.9999Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.746094 7.82538H23.2534C21.5578 3.25577 17.1593 -0.000732422 11.9997 -0.000732422C6.84012 -0.000732422 2.44161 3.25577 0.746094 7.82538Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3584" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3j(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3585)" }, [
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M24 12.0007C24 18.6281 18.6274 24.0007 12 24.0007C5.37262 24.0007 0 18.6281 0 12.0007",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0003 7.82544L12.9067 10.6153H15.8405L13.4671 12.3397L14.3736 15.1298L12.0003 13.4055L9.62697 15.1298L10.5336 12.3397L8.16016 10.6153H11.0938L12.0003 7.82544Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3585" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3i(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3674)" }, [
      createElementVNode("path", {
        d: "M23.2536 16.1744C23.736 14.8744 24 13.4683 24 12.0005C24 10.5326 23.736 9.1265 23.2536 7.82657L12 6.78308L0.746391 7.82657C0.264047 9.1265 0 10.5326 0 12.0005C0 13.4683 0.264047 14.8744 0.746391 16.1744L12 17.2178L23.2536 16.1744Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M23.2533 7.82599C21.5578 3.25638 17.1593 -0.00012207 11.9997 -0.00012207C6.84013 -0.00012207 2.44161 3.25638 0.746094 7.82599H23.2533Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9991C17.1593 23.9991 21.5578 20.7426 23.2533 16.173H0.746094C2.44161 20.7426 6.84012 23.9991 11.9997 23.9991Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.2292 10.153H13.9429L12.0003 4.17444L10.0577 10.153H3.77148L8.85719 13.848L6.91459 19.8267L12.0003 16.1744L17.0861 19.8266L15.1435 13.8479L20.2292 10.153Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3674" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3h(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3586)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M19.3067 2.48005C15.0105 -0.82586 8.98955 -0.82586 4.69336 2.48L12 9.78669L19.3067 2.48005Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 14.214L4.69336 21.5206C8.98955 24.8265 15.0105 24.8265 19.3067 21.5206L12 14.2139L12 14.214Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.78705 12.0003L2.48041 4.6936C-0.8255 8.98979 -0.8255 15.0108 2.48041 19.307L9.78705 12.0003Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M14.2148 12.0003L21.5214 19.307C24.8273 15.0108 24.8273 8.98979 21.5214 4.6936L14.2148 12.0003Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0006 17.2178C14.8821 17.2178 17.218 14.8819 17.218 12.0005C17.218 9.11898 14.8821 6.78308 12.0006 6.78308C9.1191 6.78308 6.7832 9.11898 6.7832 12.0005C6.7832 14.8819 9.1191 17.2178 12.0006 17.2178Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 8.34827L12.4518 9.13089H13.3555L12.9037 9.91347L13.3555 10.6961H12.4518L12 11.4787L11.5482 10.6961H10.6445L11.0964 9.91347L10.6445 9.13089H11.5482L12 8.34827Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.70319 12.001L10.155 12.7836H11.0587L10.6068 13.5662L11.0587 14.3488H10.155L9.70319 15.1314L9.25131 14.3488H8.34766L8.79948 13.5662L8.34766 12.7836H9.25131L9.70319 12.001Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.2969 12.001L14.7488 12.7836H15.6524L15.2006 13.5662L15.6524 14.3488H14.7488L14.2969 15.1314L13.8451 14.3488H12.9414L13.3932 13.5662L12.9414 12.7836H13.8451L14.2969 12.001Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3586" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3g(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3587)" }, [
      createElementVNode("path", {
        d: "M0 12.0009C0 14.0798 0.528891 16.0351 1.45908 17.74L12 18.7835L22.5409 17.74C23.4711 16.0351 24 14.0798 24 12.0009C24 9.92198 23.4711 7.96664 22.5409 6.26175L12 5.21826L1.45908 6.26175C0.528891 7.96664 0 9.92198 0 12.0009Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M1.45898 6.26123H22.5408C20.5056 2.5311 16.5484 0.000366211 11.9999 0.000366211C7.45139 0.000366211 3.49425 2.5311 1.45898 6.26123Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9999 24.0008C16.5484 24.0008 20.5056 21.4701 22.5408 17.74H1.45898C3.49425 21.4701 7.45139 24.0008 11.9999 24.0008Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M16.1745 14.3473V12.7821H15.131V10.6951L14.0876 9.65167L13.0441 10.6951V8.60818L12.0006 7.5647L10.9571 8.60818V10.6951L9.91361 9.65167L8.87013 10.6951V12.7821H7.82669V14.3473H6.7832V15.9125H17.218V14.3473H16.1745Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3587" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3f(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3588)" }, [
      createElementVNode("path", {
        d: "M17.2175 1.19108C15.6399 0.428241 13.87 0.000366211 12.0001 0.000366211C10.1303 0.000366211 8.36037 0.428241 6.78274 1.19108L5.73926 12.0004L6.78274 22.8096C8.36037 23.5725 10.1303 24.0004 12.0001 24.0004C13.87 24.0004 15.6399 23.5725 17.2175 22.8096L18.261 12.0004L17.2175 1.19108Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 7.82544L13.0359 11.0138H16.3888L13.6764 12.9846L14.7124 16.1732L12 14.2025L9.28753 16.1732L10.3237 12.9846L7.61133 11.0138H10.964L12 7.82544Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M6.78262 1.19165C2.76872 3.13256 0 7.24298 0 12.0005C0 16.758 2.76872 20.8685 6.78262 22.8094V1.19165Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M17.2178 1.19165V22.8094C21.2317 20.8685 24.0004 16.758 24.0004 12.0005C24.0004 7.24303 21.2317 3.13256 17.2178 1.19165Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3588" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3e(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3589)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M24.0004 12.0011C24.0004 7.24352 21.2317 3.13277 17.2178 1.19177V22.8103C21.2317 20.8693 24.0004 16.7586 24.0004 12.0011Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12.0004C0 16.758 2.76867 20.8687 6.78262 22.8097V1.19116C2.76867 3.13216 0 7.24291 0 12.0004Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.087 13.5663L16.174 12.5228L15.1305 12.001V10.9576L13.0435 12.001L14.087 9.91408H13.0435L12.0001 8.34888L10.9566 9.91408H9.91309L10.9566 12.001L8.86961 10.9576V12.001L7.82617 12.5228L9.91309 13.5663L9.39138 14.6097H11.4783V16.1749H12.5218V14.6097H14.6088L14.087 13.5663Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3589" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3d(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { fill: "#2a5f9e" }, [
      createElementVNode("path", { d: "M32 62c9.8 0 18.5-4.7 24-12H8c5.5 7.3 14.2 12 24 12" }),
      createElementVNode("path", { d: "M32 2C15.4 2 2 15.4 2 32h60C62 15.4 48.6 2 32 2z" })
    ]),
    createElementVNode("path", {
      d: "M61.4 38c.4-1.9.6-3.9.6-6H2c0 2.1.2 4.1.6 6h58.8",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M4.5 44h55c.8-1.9 1.5-3.9 1.9-6H2.6c.4 2.1 1.1 4.1 1.9 6",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M4.5 44c.9 2.1 2.1 4.2 3.5 6h48c1.4-1.8 2.6-3.9 3.5-6h-55",
      fill: "#ffffff"
    }),
    createElementVNode("g", { fill: "#ffce31" }, [
      createElementVNode("path", { d: "M25 26.1l1.2.9l-.4-1.5l1.2-1h-1.5L25 23l-.5 1.5H23l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M25 56.1l1.2.9l-.4-1.5l1.2-1h-1.5L25 53l-.5 1.5H23l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M36 36.1l1.2.9l-.4-1.5l1.2-1h-1.5L36 33l-.5 1.5H34l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M18 29.1l1.2.9l-.4-1.5l1.2-1h-1.5L18 26l-.5 1.5H16l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M32 29.1l1.2.9l-.4-1.5l1.2-1h-1.5L32 26l-.5 1.5H30l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M13 36.1l1.2.9l-.4-1.5l1.2-1h-1.5L13 33l-.5 1.5H11l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M36 48.1l1.2.9l-.4-1.5l1.2-1h-1.5L36 45l-.5 1.5H34l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M13 48.1l1.2.9l-.4-1.5l1.2-1h-1.5L13 45l-.5 1.5H11l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M31 54.1l1.2.9l-.4-1.5l1.2-1h-1.5L31 51l-.5 1.5H29l1.2 1l-.4 1.5z" }),
      createElementVNode("path", { d: "M18 54.1l1.2.9l-.4-1.5l1.2-1h-1.5L18 51l-.5 1.5H16l1.2 1l-.4 1.5z" })
    ])
  ]);
}
function render$3c(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3590)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9688 12.0004H12.0009C12.0009 11.9896 12.0009 11.9791 12.0009 11.9683C11.9902 11.979 11.9795 11.9897 11.9688 12.0004Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26037C12 4.14889 12 2.76537 12 -0.000488281H11.998C5.37145 0.000636719 0 5.37275 0 11.9995H6.26086V8.474L9.78638 11.9995H11.9679C11.9786 11.9888 11.9893 11.9781 12 11.9674C12 11.1589 12 10.4376 12 9.78598L8.47444 6.26037H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.2169 8.86913C18.3695 8.86913 19.3038 7.93476 19.3038 6.78216C19.3038 5.62956 18.3695 4.69519 17.2169 4.69519C16.0642 4.69519 15.1299 5.62956 15.1299 6.78216C15.1299 7.93476 16.0642 8.86913 17.2169 8.86913Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M6.07027 1.56531C4.19344 2.63401 2.63311 4.19429 1.56445 6.07112V12.0001H4.69491V4.69586V4.69576H11.9993C11.9993 3.70843 11.9993 2.76784 11.9993 1.56531H6.07027Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9989 10.5239L7.73539 6.2605H6.25977V6.26059L11.9988 11.9996H11.9989C11.9989 11.9996 11.9989 10.9821 11.9989 10.5239Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.8688 6.2605H13.5645V9.39095H20.8688V6.2605Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.5654 14.0869V16.1739H14.6634C15.3218 16.8191 16.223 17.2174 17.2176 17.2174C18.2122 17.2174 19.1134 16.8191 19.7718 16.1739H19.8263H20.8698V14.0869H13.5654Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.5654 8.86902V11.9995C13.5654 14.7951 17.2176 15.6516 17.2176 15.6516C17.2176 15.6516 20.8698 14.7951 20.8698 11.9995V8.86902H13.5654Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M17.2174 10.5404C16.3044 10.5404 16.3044 11.3752 15.3914 11.3752C14.4784 11.3752 14.4784 10.5404 13.5654 10.5404V12.0013C14.4784 12.0013 14.4784 12.8361 15.3914 12.8361C16.3044 12.8361 16.3044 12.0013 17.2174 12.0013C18.1304 12.0013 18.1304 12.8361 19.0436 12.8361C19.9567 12.8361 19.9566 12.0013 20.8698 12.0013V10.5404C19.9567 10.5404 19.9567 11.3752 19.0436 11.3752C18.1304 11.3752 18.1304 10.5404 17.2174 10.5404Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M17.2174 7.6167C16.3044 7.6167 16.3044 8.4515 15.3914 8.4515C14.4784 8.4515 14.4784 7.6167 13.5654 7.6167V9.07756C14.4784 9.07756 14.4784 9.91236 15.3914 9.91236C16.3044 9.91236 16.3044 9.07756 17.2174 9.07756C18.1304 9.07756 18.1304 9.91236 19.0436 9.91236C19.9567 9.91236 19.9566 9.07756 20.8698 9.07756V7.6167C19.9567 7.6167 19.9567 8.4515 19.0436 8.4515C18.1304 8.4515 18.1304 7.6167 17.2174 7.6167Z",
        fill: "#F3F3F3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3590" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3b(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3591)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M22.5406 6.26036C20.99 3.41837 18.3236 1.27295 15.1301 0.412231L14.6084 6.26036H22.5406Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M1.45898 6.2606H9.39117L8.86945 0.412476C5.676 1.27319 3.00966 3.41866 1.45898 6.2606Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M14.6084 12.0017V17.7408H22.5406C23.4708 16.036 23.9997 14.0806 23.9997 12.0017H14.6084Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M9.39131 12.0007H0C0 14.0796 0.528891 16.035 1.45908 17.7399H9.39127V12.0007H9.39131Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M1.45898 17.7396C3.00966 20.5816 5.676 22.727 8.86945 23.5878L9.39117 18.4733L1.45898 17.7396Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.1301 23.5884C18.3236 22.7276 20.99 20.5822 22.5406 17.7402L14.6084 18.4738L15.1301 23.5884Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.6084 18.4738L22.5406 17.7402H14.6084V18.4738Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.39122 17.7396H1.45898L9.39122 18.4732V17.7396Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0006 0.000366211C10.9174 0.000366211 9.86827 0.144741 8.87012 0.413757V23.587C9.86827 23.856 10.9174 24.0004 12.0006 24.0004C13.0837 24.0004 14.1329 23.856 15.131 23.587V0.413757C14.1329 0.144741 13.0837 0.000366211 12.0006 0.000366211Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.45438 2.60913L6.7781 3.60555H7.8259L6.9783 4.2214L7.30207 5.21782L6.45438 4.60202L5.60674 5.21782L5.9306 4.2214L5.08301 3.60555H6.13071L6.45438 2.60913Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3591" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3a(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3592)" }, [
      createElementVNode("path", {
        d: "M12.0003 -0.000488281C10.5325 -0.000488281 9.12639 0.263559 7.82645 0.745902L7.30469 11.9995L7.82641 23.2531C9.12639 23.7355 10.5325 23.9995 12.0003 23.9995C13.4682 23.9995 14.8743 23.7355 16.1742 23.2531L16.696 11.9995L16.1743 0.745902C14.8743 0.263559 13.4682 -0.000488281 12.0003 -0.000488281Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M24.0009 12.0004C24.0009 6.84086 20.7444 2.44234 16.1748 0.746826V23.2541C20.7444 21.5585 24.0009 17.16 24.0009 12.0004Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.82611 23.254V0.746826C3.2565 2.44234 0 6.84086 0 12.0004C0 17.16 3.2565 21.5585 7.82611 23.254Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3592" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$39(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3593)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M24 12.0003C24 18.6277 18.6274 24.0003 12 24.0003C5.37262 24.0003 0 18.6277 0 12.0003C0 5.37293 12 12.0003 12 12.0003C12 12.0003 21.0825 12.0003 24 12.0003Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C12 4.56352 12 12 12 12C12 12 4.17389 12 0 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M7.14312 4.17346L7.92017 6.56493H10.4347L8.40041 8.0429L9.17741 10.4344L7.14312 8.95635L5.10884 10.4344L5.88584 8.0429L3.85156 6.56493H6.36608L7.14312 4.17346Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3593" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$38(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3594)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.56719 7.30139L7.60313 10.4889H10.9547L8.24531 12.4623L9.28125 15.6498L6.56719 13.6811L3.85313 15.6498L4.89375 12.4623L2.17969 10.4889H5.53125L6.56719 7.30139Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.226 18.5846L13.4338 17.6096L12.2619 18.0643L12.9416 17.0096L12.1494 16.03L13.3635 16.3534L14.0479 15.2987L14.1135 16.555L15.3322 16.8784L14.1557 17.3284L14.226 18.5846Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.802 15.7253L16.177 14.5253L15.1504 13.7987L16.4066 13.78L16.777 12.58L17.1848 13.7706L18.441 13.7565L17.4332 14.5065L17.8363 15.6971L16.8098 14.9706L15.802 15.7253Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M17.9256 8.80662L17.3725 9.9363L18.2725 10.8129L17.0303 10.6347L16.4771 11.7597L16.2615 10.5222L15.0146 10.3441L16.1303 9.75818L15.9146 8.51599L16.8146 9.39255L17.9256 8.80662Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.2592 5.38501L14.1654 6.63657L15.3326 7.11001L14.1092 7.41001L14.0201 8.66626L13.3592 7.59751L12.1357 7.89751L12.9467 6.93657L12.2811 5.87251L13.4482 6.34595L14.2592 5.38501Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3594" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$37(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3595)" }, [
      createElementVNode("path", {
        d: "M20.4853 20.4857C15.799 25.172 8.20104 25.172 3.51472 20.4857C-1.1716 15.7995 -1.17155 8.20146 3.51472 3.51514C3.88363 3.884 13.1068 10.8936 13.1068 10.8936L20.4853 20.4857Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M3.51465 3.51422C8.20092 -1.17206 15.7989 -1.17206 20.4853 3.51422C25.1716 8.20049 25.1715 15.7985 20.4853 20.4848",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0006 15.131C13.7295 15.131 15.131 13.7295 15.131 12.0006C15.131 10.2717 13.7295 8.87012 12.0006 8.87012C10.2717 8.87012 8.87012 10.2717 8.87012 12.0006C8.87012 13.7295 10.2717 15.131 12.0006 15.131Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.46876 17.2175L4.79806 17.9061L5.54164 17.7342L5.20864 18.4209L5.80667 18.8952L5.06211 19.0629L5.06417 19.8262L4.46876 19.3487L3.87336 19.8262L3.87542 19.0629L3.13086 18.8952L3.72889 18.4209L3.39584 17.7342L4.13947 17.9061L4.46876 17.2175Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M2.31442 11.4769L2.64372 12.1655L3.38729 11.9935L3.05434 12.6803L3.65228 13.1546L2.90776 13.3223L2.90982 14.0856L2.31442 13.6081L1.71906 14.0856L1.72108 13.3223L0.976562 13.1546L1.57455 12.6803L1.24155 11.9935L1.98512 12.1655L2.31442 11.4769Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M4.46872 6.78186L4.79801 7.47041L5.54159 7.29847L5.20864 7.98528L5.80662 8.45951L5.06206 8.62728L5.06412 9.39054L4.46872 8.91307L3.87331 9.39054L3.87537 8.62728L3.13086 8.45951L3.7288 7.98528L3.3958 7.29847L4.13942 7.47041L4.46872 6.78186Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.1445 10.4346L7.47379 11.1231L8.21742 10.9512L7.88437 11.638L8.48236 12.1122L7.73784 12.28L7.73986 13.0432L7.1445 12.5658L6.54909 13.0432L6.55116 12.28L5.80664 12.1122L6.40458 11.638L6.07162 10.9512L6.8152 11.1231L7.1445 10.4346Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.23094 13.5646L5.48998 14.3617H6.3281L5.65001 14.8544L5.90904 15.6515L5.23094 15.1589L4.55285 15.6515L4.81188 14.8544L4.13379 14.3617H4.97191L5.23094 13.5646Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 14.0871H13.0434C13.0434 14.0871 13.4956 13.2872 13.0434 12.5219L14.0869 11.4784L13.5652 10.4349H13.0435C13.0435 10.4349 12.7826 11.2176 11.7391 11.2176C10.6957 11.2176 10.4348 10.4349 10.4348 10.4349H9.91309L10.4348 11.4784L9.91309 12.5219L10.4348 13.0436C10.4348 13.0436 10.9565 12.0001 12 12.5219C12 12.5219 12.4434 13.1741 12 14.0871Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M19.7888 6.57258C19.8134 6.44437 19.8265 6.31214 19.8265 6.17677C19.8265 5.24864 19.2205 4.4625 18.3828 4.19128C18.6387 4.7116 18.783 5.29678 18.783 5.91591C18.783 6.12469 18.7662 6.32953 18.7347 6.52945C18.6086 6.32634 18.4466 6.14077 18.2488 5.98331C17.5034 5.39025 16.4849 5.37455 15.7318 5.874C16.3132 6.00094 16.8754 6.25898 17.3726 6.65456C17.7618 6.96431 18.0763 7.38328 18.3172 7.78772L15.1309 8.78545C18.2613 9.30717 20.87 7.22025 20.87 7.22025C20.5809 6.64219 20.132 6.54469 19.7888 6.57258Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3595" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$36(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3596)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M18.4209 17.2178L18.7502 17.9063L19.4938 17.7345L19.1608 18.4212L19.7588 18.8954L19.0142 19.0632L19.0163 19.8265L18.4209 19.349L17.8255 19.8265L17.8275 19.0632L17.083 18.8954L17.681 18.4212L17.348 17.7345L18.0916 17.9063L18.4209 17.2178Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.3574 9.91223L15.6867 10.6008L16.4304 10.4289L16.0973 11.1157L16.6953 11.5899L15.9508 11.7577L15.9528 12.5209L15.3574 12.0435L14.762 12.5209L14.764 11.7577L14.0195 11.5899L14.6175 11.1157L14.2845 10.4289L15.0281 10.6008L15.3574 9.91223Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M18.4208 5.73828L18.7501 6.42683L19.4937 6.25489L19.1608 6.9417L19.7587 7.41594L19.0142 7.5837L19.0162 8.34697L18.4208 7.86945L17.8254 8.34697L17.8275 7.5837L17.083 7.41594L17.6809 6.9417L17.3479 6.25489L18.0915 6.42683L18.4208 5.73828Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M21.0976 8.87012L21.4269 9.55866L22.1706 9.38677L21.8376 10.0736L22.4355 10.5478L21.691 10.7156L21.6931 11.4788L21.0976 11.0013L20.5022 11.4788L20.5042 10.7156L19.7598 10.5478L20.3578 10.0736L20.0247 9.38677L20.7683 9.55866L21.0976 8.87012Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.1841 12.5211L19.4432 13.3183H20.2813L19.6032 13.811L19.8623 14.6081L19.1841 14.1155L18.506 14.6081L18.765 13.811L18.0869 13.3183H18.9251L19.1841 12.5211Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.3045 15.3913C11.4315 15.3913 9.9131 13.8729 9.9131 12C9.9131 10.127 11.4314 8.60867 13.3045 8.60867C13.8884 8.60867 14.4379 8.75638 14.9177 9.0163C14.1651 8.28027 13.1359 7.82605 12 7.82605C9.69489 7.82605 7.82617 9.69477 7.82617 11.9999C7.82617 14.3051 9.69489 16.1738 12 16.1738C13.1359 16.1738 14.1651 15.7196 14.9176 14.9836C14.4379 15.2436 13.8884 15.3913 13.3045 15.3913Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M7.54678 4.69546C7.18584 4.07184 6.51201 3.65198 5.7397 3.65198C4.96738 3.65198 4.29356 4.07184 3.93262 4.69546H7.54678Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M7.55328 4.7074L5.73927 6.52141L3.92525 4.7074C3.75186 5.01166 3.65234 5.36355 3.65234 5.73883C3.65234 6.89144 4.5867 7.8258 5.73931 7.8258C6.89192 7.8258 7.82628 6.89149 7.82628 5.73883C7.82623 5.36355 7.72667 5.01166 7.55328 4.7074Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.21777 6.00049V7.76083C5.38451 7.80372 5.55935 7.82655 5.73949 7.82655C5.91964 7.82655 6.09448 7.80367 6.26121 7.76083V6.00049H5.21777Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3596" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$35(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3597)" }, [
      createElementVNode("path", {
        d: "M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12L12 13.0435L0 12Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M1.60547 18.0005C3.68039 21.5872 7.55808 24.0005 11.9997 24.0005C16.4414 24.0005 20.319 21.5872 22.394 18.0005L11.9997 17.2179L1.60547 18.0005Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M22.3942 17.9998C23.4153 16.2347 24 14.1856 24 11.9998H0C0 14.1856 0.584719 16.2347 1.60575 17.9998H22.3942Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3597" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$34(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3598)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9994 11.9653H10.9911C8.40842 14.548 6.84664 16.542 5.25195 18.1367L12.0346 18.7479L22.5596 17.7044C23.4781 16.0078 23.9998 14.0649 23.9998 12.0001C23.9998 11.9884 23.9994 11.977 23.9994 11.9653Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M5.25272 6.22564H22.522C20.4812 2.51464 16.5348 -0.000488281 12.0005 -0.000488281C8.69559 -0.000488281 5.70328 1.33597 3.5332 3.49751L5.25272 6.22564Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.77327 17.704C4.69449 18.7828 4.27759 19.6866 3.49707 20.4671C5.66996 22.649 8.67676 23.9996 11.9994 23.9996C16.562 23.9996 20.5297 21.4531 22.5592 17.704H5.77327Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.48035C-1.17157 8.16663 -1.17157 15.7646 3.51471 20.451C5.45126 18.5144 7.31374 16.6519 12 11.9657L3.51471 3.48035Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M3.16584 11.9647C3.16584 10.2163 4.39457 8.75575 6.03538 8.39744C5.78319 8.34236 5.52154 8.3125 5.25276 8.3125C3.23568 8.3125 1.60059 9.9476 1.60059 11.9647C1.60059 13.9818 3.23568 15.6169 5.25276 15.6169C5.52149 15.6169 5.78315 15.587 6.03538 15.5319C4.39457 15.1736 3.16584 13.713 3.16584 11.9647Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.99574 8.83472L6.19004 9.43256H6.81863L6.31004 9.80208L6.50434 10.3999L5.99574 10.0305L5.48715 10.3999L5.68145 9.80208L5.17285 9.43256H5.80145L5.99574 8.83472Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.99574 10.3998L6.19004 10.9977H6.81863L6.31004 11.3671L6.50434 11.965L5.99574 11.5955L5.48715 11.965L5.68145 11.3671L5.17285 10.9977H5.80145L5.99574 10.3998Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.99574 11.9646L6.19004 12.5624H6.81863L6.31004 12.932L6.50434 13.5298L5.99574 13.1603L5.48715 13.5298L5.68145 12.932L5.17285 12.5624H5.80145L5.99574 11.9646Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.99574 13.5297L6.19004 14.1275H6.81863L6.31004 14.497L6.50434 15.0949L5.99574 14.7254L5.48715 15.0949L5.68145 14.497L5.17285 14.1275H5.80145L5.99574 13.5297Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3598" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$33(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3694)" }, [
      createElementVNode("path", {
        d: "M6.50505 22.6698L15.3206 15.3194L22.6709 6.50387C21.5281 4.28913 19.716 2.47605 17.5022 1.33179L8.67967 8.67854L1.33301 17.501C2.47718 19.7149 4.29025 21.527 6.50505 22.6698Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M20.485 20.4851C24.2709 16.6992 24.9977 11.0134 22.6669 6.49719L6.49707 22.667C11.0133 24.9978 16.6991 24.271 20.485 20.4851Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51436 3.51375C-0.271537 7.29965 -0.998285 12.9855 1.33248 17.5017L17.5023 1.33191C12.9861 -0.998946 7.30026 -0.272103 3.51436 3.51375Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3694" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$32(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3606)" }, [
      createElementVNode("path", {
        d: "M22.667 6.49842C22.1125 5.42409 21.3857 4.41572 20.4852 3.51516C19.5845 2.61455 18.5761 1.88775 17.5018 1.33331L9.04798 9.04922L1.33203 17.5031C1.88652 18.5774 2.61331 19.5858 3.51387 20.4864C4.41444 21.387 5.42286 22.1138 6.49714 22.6682L14.951 14.9523L22.667 6.49842Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.51455 20.4854C4.01795 20.9888 4.55509 21.4378 5.11848 21.8331L21.8334 5.11811C21.4381 4.55472 20.9892 4.01758 20.4858 3.51419C19.9824 3.0108 19.4453 2.56188 18.8819 2.16663L2.16699 18.8815C2.5622 19.4448 3.01112 19.982 3.51455 20.4854Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51441 3.51437C-0.271541 7.30032 -0.998338 12.9862 1.33257 17.5023L17.5024 1.33257C12.9862 -0.998286 7.30032 -0.271396 3.51441 3.51437Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M20.486 20.4851C24.2719 16.6992 24.9986 11.0133 22.6679 6.49713L6.49805 22.6669C11.0142 24.9978 16.7001 24.271 20.486 20.4851Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M6.39547 3.65118L7.043 5.64417H9.1385L7.44322 6.87586L8.09075 8.86879L6.39547 7.63706L4.70009 8.86879L5.34772 6.87586L3.65234 5.64417H5.74784L6.39547 3.65118Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3606" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$31(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3599)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.001H11.9999C11.9999 11.9902 11.9999 11.9797 11.9999 11.9689C11.9892 11.9796 11.9785 11.9903 11.9678 12.001Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26184C12 4.15035 12 2.76684 12 0.000976562H11.998C5.37145 0.00210156 0 5.37421 0 12.001H6.26086V8.47546L9.78637 12.001H11.9679C11.9786 11.9903 11.9893 11.9796 12 11.9689C12 11.1604 12 10.4391 12 9.78745L8.47443 6.26184H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56458C4.19441 2.63328 2.63409 4.19356 1.56543 6.07039V11.9994H4.69588V4.69512V4.69503H12.0002C12.0002 3.7077 12.0002 2.76711 12.0002 1.56458H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9999 10.5236L7.73637 6.26013H6.26074V6.26023L11.9998 11.9992H11.9999C11.9999 11.9992 11.9999 10.9817 11.9999 10.5236Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.1747 12L16.3968 12.6833H17.1152L16.534 13.1055L16.756 13.7888L16.1747 13.3665L15.5935 13.7888L15.8155 13.1055L15.2344 12.6833H15.9527L16.1747 12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.2229 13.223L13.863 13.5491L14.371 13.0411L14.2586 13.7507L14.8987 14.0769L14.1891 14.1892L14.0768 14.8989L13.7506 14.2587L13.041 14.3711L13.5491 13.8631L13.2229 13.223Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 16.1731L12.6833 15.9511L12.6833 15.2328L13.1055 15.8139L13.7888 15.5918L13.3665 16.1731L13.7888 16.7544L13.1055 16.5324L12.6833 17.1135V16.3952L12 16.1731Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.2229 19.1254L13.549 18.4853L13.041 17.9774L13.7506 18.0897L14.0768 17.4496L14.1891 18.1592L14.8987 18.2715L14.2586 18.5977L14.371 19.3073L13.863 18.7992L13.2229 19.1254Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.1738 20.3481L15.9518 19.6648H15.2334L15.8146 19.2426L15.5926 18.5593L16.1738 18.9816L16.7551 18.5593L16.5331 19.2426L17.1143 19.6648H16.3959L16.1738 20.3481Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M19.125 19.1254L18.4849 18.7994L17.977 19.3073L18.0893 18.5977L17.4492 18.2716L18.1588 18.1592L18.2712 17.4496L18.5973 18.0897L19.3069 17.9774L18.7988 18.4853L19.125 19.1254Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M20.3484 16.1731L19.6651 16.3952V17.1135L19.2428 16.5323L18.5596 16.7544L18.9819 16.1731L18.5596 15.5918L19.2428 15.8139L19.6651 15.2328V15.9511L20.3484 16.1731Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M19.125 13.223L18.799 13.8631L19.3069 14.3711L18.5973 14.2587L18.2712 14.8988L18.1588 14.1892L17.4492 14.0768L18.0893 13.7507L17.977 13.0411L18.485 13.5491L19.125 13.223Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3599" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$30(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3600)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.2536 7.82617H0.746391C0.264047 9.12616 0 10.5322 0 12.0001C0 13.4679 0.264047 14.874 0.746391 16.174H23.2537C23.736 14.874 24 13.4679 24 12.0001C24 10.5322 23.736 9.12616 23.2536 7.82617Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0009 -0.000488281C8.36383 -0.000488281 5.10494 1.61782 2.9043 4.1734H21.0975C18.8969 1.61782 15.638 -0.000488281 12.0009 -0.000488281Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M21.0965 19.826H2.90332C5.10396 22.3816 8.36285 23.9999 11.9999 23.9999C15.637 23.9999 18.8959 22.3816 21.0965 19.826Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3600" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2$(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    height: "24",
    width: "24",
    viewBox: "0 0 473.681 473.681",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      style: { "fill": "#008E56" },
      d: "M315.8,13.537l-27.64,76.628c25.511,84.197,25.511,209.158,0,293.358l27.639,76.624\r\n	c91.975-32.523,157.881-120.201,157.881-223.309C473.682,133.731,407.774,46.057,315.8,13.537z"
    }),
    createElementVNode("g", null, [
      createElementVNode("path", {
        style: { "fill": "#E7E7E7" },
        d: "M315.8,90.161V13.537c-24.7-8.736-51.266-13.534-78.961-13.534\r\n		C273.359,0.004,222.723,123.772,315.8,90.161z"
      }),
      createElementVNode("path", {
        style: { "fill": "#E7E7E7" },
        d: "M236.839,473.681c27.695,0,54.261-4.798,78.961-13.534v-76.624\r\n		C223.657,374.328,236.839,473.681,236.839,473.681z"
      })
    ]),
    createElementVNode("path", {
      style: { "fill": "#E97E24" },
      d: "M0.001,236.838c0,103.456,66.355,191.362,158.805,223.623V13.223\r\n	C66.356,45.484,0.001,133.391,0.001,236.838z"
    }),
    createElementVNode("path", {
      style: { "fill": "#14B36F" },
      d: "M315.8,90.161v293.358C341.315,299.323,341.315,174.361,315.8,90.161z"
    }),
    createElementVNode("path", {
      style: { "fill": "#F3F1F2" },
      d: "M315.8,383.523V90.161C299.672,36.94,273.356,0,236.839,0c-27.351,0-53.592,4.693-78.034,13.223\r\n	v447.238c24.442,8.523,50.682,13.219,78.034,13.219C273.359,473.681,299.674,436.745,315.8,383.523z"
    })
  ]);
}
function render$2_(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3601)" }, [
      createElementVNode("path", {
        d: "M24 12C24 10.5321 23.736 9.12602 23.2536 7.82609L12 7.30432L0.746391 7.82604C0.264047 9.12602 0 10.5321 0 12C0 13.4678 0.264047 14.8739 0.746391 16.1739L12 16.6956L23.2536 16.1739C23.736 14.8739 24 13.4678 24 12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9995C17.1593 23.9995 21.5578 20.743 23.2533 16.1733H0.746094C2.44161 20.743 6.84013 23.9995 11.9997 23.9995Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0.746094 7.82666H23.2534C21.5578 3.25705 17.1593 0.000549316 11.9997 0.000549316C6.84012 0.000549316 2.44161 3.25705 0.746094 7.82666Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.1309 8.34753H13.0439L13.3918 5.7388L14.7831 4.69531L16.1743 5.7388V7.82576L15.1309 8.34753Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M8.86961 8.34802H10.9566L10.6087 5.73928L9.21742 4.6958L7.82617 5.73928V7.82625L8.86961 8.34802Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M13.3911 8.34777H10.6084V5.73904L11.9997 4.69556L13.3911 5.73904V8.34777Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M7.82617 7.82574V13.5648C7.82617 14.9314 8.48627 16.1467 9.50439 16.9085L10.2348 16.7258L11.1566 17.653C11.4292 17.7092 11.7112 17.7388 12.0001 17.7388C12.2875 17.7388 12.5681 17.7096 12.8392 17.654L13.8914 16.7779L14.4957 16.9068C15.5134 16.145 16.174 14.931 16.174 13.5648V7.82574H7.82617Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.49572 7.82593H7.82617V9.49548H9.49572V7.82593Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.8346 7.82593H11.165V9.49548H12.8346V7.82593Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.1744 7.82593H14.5049V9.49548H16.1744V7.82593Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.1647 9.495H9.49512V11.1645H11.1647V9.495Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.5045 9.495H12.835V11.1645H14.5045V9.495Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.49572 11.1638H7.82617V12.8334H9.49572V11.1638Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.1647 12.8347H9.49512V14.5042H11.1647V12.8347Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.8346 11.1638H11.165V12.8334H12.8346V11.1638Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.1744 11.1638H14.5049V12.8334H16.1744V11.1638Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.5045 12.8347H12.835V14.5042H14.5045V12.8347Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.8346 14.5039H11.165V16.1734H12.8346V14.5039Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.49542 14.5039H7.93359C8.07684 15.1245 8.35847 15.6924 8.74462 16.1734H9.49542V14.5039V14.5039Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.5049 16.1736H15.2556C15.6419 15.6926 15.9234 15.1247 16.0667 14.5041H14.5049V16.1736V16.1736Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.49512 16.1732V16.9016C9.98069 17.267 10.5482 17.529 11.1647 17.6547V16.1732H9.49512V16.1732Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.835 16.1732V17.6547C13.4515 17.5291 14.0189 17.267 14.5045 16.9016V16.1732H12.835V16.1732Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3601" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2Z(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3602)" }, [
      createElementVNode("path", {
        d: "M12 24.0001C18.6273 24.0001 23.9999 18.6275 23.9999 12.0001C23.9999 5.37274 18.6273 0.000183105 12 0.000183105C5.37256 0.000183105 0 5.37274 0 12.0001C0 18.6275 5.37256 24.0001 12 24.0001Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9999 0.000244141C8.07405 0.000244141 4.58871 1.8857 2.39941 4.80024H21.6004C19.4111 1.88565 15.9258 0.000244141 11.9999 0.000244141Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9999 24.0002C15.9258 24.0002 19.4111 22.1147 21.6004 19.2002H2.39941C4.58866 22.1148 8.07406 24.0002 11.9999 24.0002Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0 12.0002C0 12.8222 0.0828749 13.6248 0.240328 14.4002H23.7597C23.9172 13.6248 24 12.8222 24 12.0002C24 11.1783 23.9171 10.3757 23.7597 9.60022H0.240328C0.0828749 10.3757 0 11.1783 0 12.0002Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M3.51468 3.51459C-1.17156 8.20082 -1.17156 15.7988 3.51468 20.4852C5.45122 18.5486 7.31366 16.6861 11.9999 11.9999L3.51468 3.51459Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.85695 8.86957L5.63385 11.2609H8.14851L6.11427 12.739L6.89118 15.1303L4.85695 13.6524L2.82262 15.1303L3.59971 12.739L1.56543 11.2609H4.0799L4.85695 8.86957Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3602" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2Y(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3603)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12 24.0007C15.9375 24.0007 19.432 22.1042 21.6201 19.1749H2.37988C4.56801 22.1042 8.06249 24.0007 12 24.0007Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M24 12C24 5.37263 18.6274 0 12 0C5.37262 0 0 5.37263 0 12C0 13.419 0.246984 14.7803 0.699188 16.0439H23.3008C23.753 14.7803 24 13.419 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M8.21457 7.69598L8.86205 9.68873H10.9576L9.26232 10.9205L9.9098 12.9134L8.21457 11.6817L6.51934 12.9134L7.16691 10.9205L5.47168 9.68873H7.56708L8.21457 7.69598Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M4.61541 5.6095L5.00391 6.80519H6.26124L5.2441 7.54422L5.6326 8.73995L4.61541 8.00092L3.59827 8.73995L3.98682 7.54422L2.96973 6.80519H4.22701L4.61541 5.6095Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3603" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2X(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3604)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FCFCFC"
      }),
      createElementVNode("path", {
        d: "M18.7829 10.4344C18.4177 10.4344 17.9655 10.4344 17.2177 10.4344C17.2177 13.316 14.8818 15.6518 12.0004 15.6518C9.1188 15.6518 6.78298 13.316 6.78298 10.4344C6.2786 10.4344 5.72205 10.4344 5.21777 10.4344C5.21777 13.5383 7.30259 16.1552 10.1484 16.9611C9.83637 17.5538 9.8839 18.3 10.3296 18.8562C10.915 18.387 11.521 17.9013 12.0351 17.4894C12.5493 17.9014 13.1553 18.387 13.7407 18.8562C14.1908 18.2945 14.2351 17.5388 13.9127 16.9432C16.7273 16.1175 18.7829 13.5162 18.7829 10.4344Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M7.82617 9.91286C7.82617 9.91286 7.82617 12.5215 10.4349 12.5215L10.9566 13.0433H12.0001C12.0001 13.0433 12.5218 11.4781 13.5653 11.4781C13.5653 11.4781 13.5653 10.4346 14.6088 10.4346C15.6522 10.4346 16.174 10.4346 16.174 10.4346C16.174 10.4346 15.6522 8.34761 18.2609 6.7824L17.2174 6.26068C17.2174 6.26068 13.5653 8.86937 10.9566 8.34765V9.39114H9.91309L9.39138 8.86942L7.82617 9.91286Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3604" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2W(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3605)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.9565 11.9993C10.9565 11.9993 3.52168 20.4863 3.51465 20.4846C5.68618 22.6562 8.68623 23.9993 12 23.9993C18.6273 23.9993 24 18.6267 24 11.9993H10.9565Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51459C-1.17157 8.20087 -1.17157 15.7989 3.51471 20.4852C5.45126 18.5487 7.31375 16.6862 12 11.9999L3.51471 3.51459Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3605" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2V(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3607)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.39165 10.4349H23.8987C23.1317 4.54709 18.0972 0.00012207 12.0003 0.00012207C11.1043 0.00012207 10.2316 0.099169 9.3916 0.285356V10.4349H9.39165Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.26085 10.4357V1.46002C2.96586 3.25787 0.607016 6.55557 0.101562 10.4357H6.26085V10.4357Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.2608 13.5656H0.101562C0.607016 17.4457 2.96586 20.7434 6.26085 22.5412L6.2608 13.5656Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.3916 13.5656V23.7151C10.2316 23.9013 11.1043 24.0003 12.0003 24.0003C18.0972 24.0003 23.1317 19.4534 23.8987 13.5656H9.3916V13.5656Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3607" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2U(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3608)" }, [
      createElementVNode("path", {
        d: "M10.9565 13.044C10.9565 13.044 3.52168 3.51354 3.51465 3.51522C5.68618 1.34364 8.68623 0.000488281 12 0.000488281C18.6273 0.000488281 24 5.37311 24 12.0005L10.9565 13.044Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M10.9565 11.9994C10.9565 11.9994 3.52168 20.4863 3.51465 20.4847C5.68618 22.6562 8.68623 23.9994 12 23.9994C18.6273 23.9994 24 18.6268 24 11.9994H10.9565Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51465C-1.17157 8.20093 -1.17157 15.7989 3.51471 20.4853C5.45126 18.5487 7.31374 16.6862 12 12L3.51471 3.51465Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M4.85597 8.86938L5.63292 11.2608H8.14758L6.1133 12.7388L6.8902 15.1303L4.85597 13.6523L2.82164 15.1303L3.59873 12.7388L1.56445 11.2608H4.07892L4.85597 8.86938Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3608" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2T(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3609)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.3486 23.7693C19.0925 22.8282 22.8294 19.0913 23.7705 14.3474H14.3486V23.7693Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M0.230469 14.3474C1.17148 19.0913 4.90845 22.8282 9.65234 23.7693V14.3474H0.230469Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M23.7705 9.65222C22.8294 4.90838 19.0925 1.17141 14.3486 0.230347V9.65222H23.7705Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M9.65234 0.230469C4.90845 1.17153 1.17148 4.9085 0.230469 9.65234H9.65234V0.230469Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M11.2175 14.3481H9.65234V23.77C10.1631 23.8713 10.6857 23.9399 11.2175 23.9742V14.3481Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.2175 9.6528V0.0267334C10.6857 0.0609522 10.1631 0.129624 9.65234 0.230921V9.6528H11.2175Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.782 0.0265977C12.5232 0.00986328 12.2624 0.000488281 11.9994 0.000488281C11.7364 0.000488281 11.4756 0.00986328 11.2168 0.0265977V9.65271H12.782V0.0265977H12.782Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M11.2168 23.9738C11.4756 23.9906 11.7364 24 11.9994 24C12.2624 24 12.5232 23.9906 12.782 23.9738V14.3478H11.2168V23.9738H11.2168Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M9.65243 11.2178V9.65259H0.230555C0.129211 10.1634 0.0605859 10.6859 0.0263672 11.2178H9.65243Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.3486 11.2183H23.9747C23.9405 10.6864 23.8719 10.1639 23.7706 9.65308H14.3487V11.2183H14.3486Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.3477 12.7832H23.9738C23.9904 12.5244 23.9998 12.2635 23.9998 12.0005C23.9998 11.7375 23.9904 11.4767 23.9737 11.2179H14.3477V12.7832Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M0.0261094 11.2179C0.00942187 11.4767 0 11.7375 0 12.0005C0 12.2635 0.00942187 12.5244 0.0261094 12.7832H9.65222V11.2179H0.0261094V11.2179Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M11.9999 17.7389C15.1695 17.7389 17.739 15.1694 17.739 11.9998C17.739 8.83012 15.1695 6.26062 11.9999 6.26062C8.83024 6.26062 6.26074 8.83012 6.26074 11.9998C6.26074 15.1694 8.83024 17.7389 11.9999 17.7389Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.3075 12.6408C12.8806 11.7871 12.3258 10.9218 12.3258 10.9218C12.3258 10.9218 12.3395 10.5278 12.3395 10.293C12.3395 9.9394 12.0529 9.65271 11.6992 9.65271C11.3642 9.65271 11.0897 9.9101 11.0617 10.2378C10.7983 10.255 10.5898 10.4735 10.5898 10.7413C10.5898 10.936 10.7001 11.1047 10.8616 11.189C10.9418 11.0013 11.099 10.8548 11.2933 10.788C11.325 10.8139 11.359 10.8371 11.3953 10.8567L11.4774 10.896C11.4774 10.896 11.1732 11.7534 11.1732 12.214C11.1732 13.5088 12.027 13.9082 12.027 13.9082V13.9215L11.6001 14.3484H12.4538V13.4946L12.8807 13.9215C12.8845 13.9135 13.6893 13.4044 13.3075 12.6408Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M11.9996 7.30444L12.1938 7.90229H12.8224L12.3139 8.2718L12.5082 8.86964L11.9996 8.50018L11.491 8.86964L11.6853 8.2718L11.1768 7.90229H11.8054L11.9996 7.30444Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M9.24012 8.20183L9.74862 8.57135L10.2572 8.20178L10.063 8.79972L10.5716 9.16914L9.94292 9.16919L9.74867 9.76704L9.55437 9.16919L8.92578 9.16914L9.43433 8.79963L9.24012 8.20183Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M7.53418 10.5491H8.16273L8.35702 9.95129L8.55127 10.5491L9.17991 10.5491L8.67136 10.9187L8.86566 11.5165L8.35702 11.147L7.84848 11.5165L8.04268 10.9186L7.53418 10.5491Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M7.53418 13.4513L8.04268 13.0819L7.84843 12.484L8.35702 12.8535L8.86562 12.484L8.67137 13.0819L9.17996 13.4514L8.55127 13.4514L8.35702 14.0492L8.16273 13.4513H7.53418Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M9.24017 15.7989L9.43437 15.2012L8.92578 14.8317H9.55442L9.74872 14.2338L9.94297 14.8316H10.5716L10.063 15.2012L10.2573 15.799L9.74867 15.4295L9.24017 15.7989Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M11.9996 16.6963L11.8054 16.0986H11.1768L11.6853 15.729L11.491 15.1312L11.9996 15.5006L12.5081 15.1311L12.3139 15.729L12.8224 16.0985L12.1938 16.0986L11.9996 16.6963Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M14.7601 15.7989L14.2516 15.4295L13.7431 15.799L13.9373 15.2012L13.4287 14.8317L14.0574 14.8316L14.2516 14.2338L14.4459 14.8317H15.0745L14.5659 15.2012L14.7601 15.7989Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M16.4661 13.4514H15.8375L15.6433 14.0493L15.449 13.4515H14.8203L15.3289 13.0819L15.1346 12.4841L15.6433 12.8536L16.1518 12.4841L15.9576 13.082L16.4661 13.4514Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M16.4661 10.5491L15.9576 10.9186L16.1518 11.5164L15.6433 11.1469L15.1347 11.5165L15.3289 10.9186L14.8203 10.5491L15.449 10.549L15.6432 9.95129L15.8375 10.5491H16.4661Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M14.7601 8.20178L14.5659 8.79958L15.0745 9.1691H14.4459L14.2516 9.76699L14.0574 9.16915L13.4287 9.16919L13.9373 8.79958L13.7431 8.20183L14.2516 8.57125L14.7601 8.20178Z",
        fill: "#496E2D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3609" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2S(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3610)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0.414062 15.1311C1.52209 19.2422 4.75914 22.4793 8.87027 23.5873V15.1311H0.414062Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M8.86924 0.41333C4.75816 1.52131 1.52107 4.75841 0.413086 8.86949H8.86929V0.41333H8.86924Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.587 8.86973C22.479 4.75865 19.2419 1.52156 15.1309 0.413574V8.86978H23.587V8.86973Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.1309 23.5871C19.2419 22.479 22.479 19.242 23.5871 15.1309H15.1309V23.5871Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M15.131 11.9998C15.131 13.7288 13.7295 15.1303 12.0006 15.1303C10.2717 15.1303 8.87012 13.7288 8.87012 11.9998C8.87012 10.2709 12.0006 8.86938 12.0006 8.86938C12.0006 8.86938 15.131 10.2709 15.131 11.9998Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M8.87012 11.9998C8.87012 10.2709 10.2717 8.86938 12.0006 8.86938C13.7295 8.86938 15.131 10.2709 15.131 11.9998",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M10.2393 10.4344V12.391C10.2393 13.3635 11.0276 14.1518 12.0001 14.1518C12.9726 14.1518 13.761 13.3635 13.761 12.391V10.4344H10.2393Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3610" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2R(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3612)" }, [
      createElementVNode("path", {
        d: "M0 12C0 5.37263 5.37262 0 12 0C18.6274 0 24 5.37263 24 12L12 13.0435L0 12Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M1.60547 18.0009C3.68039 21.5876 7.55808 24.0009 11.9997 24.0009C16.4414 24.0009 20.319 21.5876 22.394 18.0009L11.9997 17.2183L1.60547 18.0009Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M22.3942 18.0002C23.4153 16.2352 24 14.1861 24 12.0002H0C0 14.1861 0.584719 16.2352 1.60575 18.0002H22.3942Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0001 16.1744C14.3052 16.1744 16.174 14.3057 16.174 12.0006C16.174 9.69537 14.3052 7.82666 12.0001 7.82666C9.69489 7.82666 7.82617 9.69537 7.82617 12.0006C7.82617 14.3057 9.69489 16.1744 12.0001 16.1744Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0003 14.6092C10.5618 14.6092 9.3916 13.439 9.3916 12.0005V10.4353C9.3916 8.99689 10.5619 7.82666 12.0003 7.82666C13.4387 7.82666 14.609 8.99694 14.609 10.4353V12.0005C14.609 13.439 13.4387 14.6092 12.0003 14.6092Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M16.1741 5.74002H13.0436C13.0436 5.16374 12.5764 4.69653 12.0001 4.69653C11.4238 4.69653 10.9566 5.16374 10.9566 5.74002H7.82617C7.82617 6.31635 8.32816 6.7835 8.90439 6.7835H8.86966C8.86966 7.35983 9.33681 7.82699 9.91314 7.82699C9.91314 8.40332 10.3803 8.87047 10.9566 8.87047H13.0436C13.6199 8.87047 14.0871 8.40332 14.0871 7.82699C14.6634 7.82699 15.1306 7.35983 15.1306 6.7835H15.0958C15.6721 6.7835 16.1741 6.3163 16.1741 5.74002Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3612" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2Q(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3613)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0003C17.1593 24.0003 21.5578 20.7438 23.2533 16.1742H0.746094C2.44161 20.7438 6.84012 24.0003 11.9997 24.0003Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M16.174 10.6956H13.0436C13.0436 10.1193 12.5764 9.6521 12.0001 9.6521C11.4238 9.6521 10.9566 10.1193 10.9566 10.6956H7.82617C7.82617 11.2719 8.32816 11.7391 8.90444 11.7391H8.86966C8.86966 12.3154 9.33681 12.7826 9.91314 12.7826C9.91314 13.3589 10.3803 13.826 10.9566 13.826H13.0436C13.6199 13.826 14.0871 13.3589 14.0871 12.7826C14.6634 12.7826 15.1306 12.3154 15.1306 11.7391H15.0958C15.6721 11.7391 16.174 11.2719 16.174 10.6956Z",
        fill: "#FF9811"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3613" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2P(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3752)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000976562C7.24218 -0.000976562 3.13143 2.7677 1.19043 6.78165H22.8089C20.868 2.7677 16.7572 -0.000976562 11.9997 -0.000976562Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9989C16.7572 23.9989 20.868 21.2302 22.809 17.2162H1.19043C3.13143 21.2302 7.24218 23.9989 11.9997 23.9989Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M9.58984 12.5225L11.9997 8.34857L14.4095 12.5225H9.58984Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.13 13.8996L11.9996 15.4649L8.86914 13.8996V11.8127H15.13V13.8996Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M14.9514 8.52728L13.8446 9.63405C14.3167 10.1061 14.6088 10.7583 14.6088 11.4787C14.6088 12.9194 13.4408 14.0874 12.0001 14.0874C10.5594 14.0874 9.39138 12.9194 9.39138 11.4787C9.39138 10.7583 9.68341 10.1061 10.1555 9.63405L9.04872 8.52728C8.29333 9.28253 7.82617 10.326 7.82617 11.4787C7.82617 13.7839 9.69489 15.6526 12.0001 15.6526C14.3052 15.6526 16.174 13.7839 16.174 11.4787C16.1739 10.326 15.7068 9.28253 14.9514 8.52728Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3752" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2O(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3615)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.30486 7.82574H23.2541C21.5586 3.25613 17.16 -0.000366211 12.0005 -0.000366211C8.68673 -0.000366211 5.68706 1.34302 3.51562 3.51474L7.30486 7.82574Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M7.30486 16.1742H23.2541C21.5586 20.7438 17.16 24.0003 12.0005 24.0003C8.68673 24.0003 5.68706 22.6569 3.51562 20.4852L7.30486 16.1742Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.5155C-1.17157 8.20178 -1.17157 15.7998 3.51471 20.4861C5.45126 18.5496 7.31375 16.6871 12 12.0008L3.51471 3.5155Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M14.0869 9.91272V12.5214C14.0869 14.1189 16.1739 14.6084 16.1739 14.6084C16.1739 14.6084 18.2609 14.1189 18.2609 12.5214V9.91272H14.0869Z",
        fill: "#DEDDE0"
      }),
      createElementVNode("path", {
        d: "M16.6958 12.0524H15.6523V13.5654H16.6958V12.0524Z",
        fill: "#786145"
      }),
      createElementVNode("path", {
        d: "M17.2171 11.4788C17.2171 10.9025 16.7499 10.4353 16.1736 10.4353C15.5973 10.4353 15.1301 10.9025 15.1301 11.4788C14.842 11.4788 14.6084 11.7124 14.6084 12.0005C14.6084 12.2887 14.842 12.5222 15.1301 12.5222C15.3012 12.5222 17.046 12.5222 17.2171 12.5222C17.5052 12.5222 17.7388 12.2887 17.7388 12.0005C17.7388 11.7124 17.5053 11.4788 17.2171 11.4788Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3615" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2N(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3616)" }, [
      createElementVNode("path", {
        d: "M10.9565 10.9565C10.9565 10.9565 3.52168 20.487 3.51465 20.4853C5.68618 22.6569 8.68623 24 12 24C18.6273 24 24 18.6274 24 12L10.9565 10.9565Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M10.9565 11.9996C10.9565 11.9996 3.52168 3.51268 3.51465 3.51437C5.68618 1.34279 8.68623 -0.000366211 12 -0.000366211C18.6273 -0.000366211 24 5.37226 24 11.9996H10.9565Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M3.51373 3.5155C-1.17255 8.20178 -1.17255 15.7998 3.51373 20.4861C3.51341 20.4881 23.999 12.0008 23.999 12.0008L3.51373 3.5155Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.26081 7.04321C3.95929 7.04321 2.08691 8.91563 2.08691 11.2171V12.7823C2.08691 15.0838 3.95934 16.9562 6.26081 16.9562C8.56227 16.9562 10.4347 15.0838 10.4347 12.7823V11.2171C10.4347 8.91563 8.56232 7.04321 6.26081 7.04321ZM8.86949 12.7824C8.86949 13.9482 8.10065 14.9377 7.04338 15.2709V13.565L8.15076 12.4576L7.04399 11.3508L7.04338 10.9569V10.4346H5.47823V11.9997L4.3716 13.1063L5.47823 14.2129V15.271C4.42096 14.9378 3.65212 13.9483 3.65212 12.7824V11.2172C3.65212 9.77874 4.8224 8.60851 6.26081 8.60851C7.69921 8.60851 8.86949 9.77879 8.86949 11.2172V12.7824Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3616" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2M(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3617)" }, [
      createElementVNode("path", {
        d: "M0 11.9995C0 13.4673 0.264047 14.8734 0.746391 16.1734L12 16.6951L23.2536 16.1734C23.736 14.8734 24 13.4673 24 11.9995C24 10.5316 23.736 9.12558 23.2536 7.8256L12 7.30383L0.746391 7.82555C0.264047 9.12558 0 10.5316 0 11.9995Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.2533 16.1742H0.746094C2.44161 20.7438 6.84012 24.0003 11.9997 24.0003C17.1593 24.0003 21.5578 20.7438 23.2533 16.1742Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3617" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2L(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 512 512"
  }, [
    createElementVNode("path", {
      style: { "fill": "#FFDA44" },
      d: "M486.598,367.304C502.872,333.649,512,295.89,512,256s-9.128-77.649-25.402-111.304L256,133.565\r\n	l-230.598,11.13C9.128,178.351,0,216.11,0,256s9.128,77.649,25.402,111.304L256,378.435L486.598,367.304z"
    }),
    createElementVNode("path", { d: "M256,0C154.506,0,66.81,59.065,25.402,144.696h461.195C445.19,59.065,357.493,0,256,0z" }),
    createElementVNode("path", {
      style: { "fill": "#0052B4" },
      d: "M256,512c-101.494,0-189.19-59.065-230.598-144.696h461.195C445.19,452.935,357.493,512,256,512z"
    }),
    createElementVNode("path", {
      style: { "fill": "#A2001D" },
      d: "M499.911,178.087H12.089C4.247,202.656,0,228.831,0,256s4.247,53.344,12.089,77.913H499.91\r\n	C507.753,309.344,512,283.169,512,256S507.753,202.656,499.911,178.087z"
    }),
    createElementVNode("g", null, [
      createElementVNode("rect", {
        x: "89.043",
        y: "244.87",
        style: { "fill": "#FFDA44" },
        width: "333.913",
        height: "22.261"
      }),
      createElementVNode("rect", {
        x: "133.565",
        y: "200.348",
        style: { "fill": "#FFDA44" },
        width: "244.87",
        height: "22.261"
      })
    ]),
    createElementVNode("path", {
      style: { "fill": "#F0F0F0" },
      d: "M380.025,256c0,0-57.243,66.783-124.025,66.783S189.217,256,189.217,256s0-66.783,66.783-66.783\r\n	S380.025,256,380.025,256z"
    }),
    createElementVNode("path", { d: "M256,322.783c-66.783,0-124.025-66.783-124.025-66.783S189.217,189.217,256,189.217" }),
    createElementVNode("rect", {
      x: "211.478",
      y: "233.739",
      style: { "fill": "#F0F0F0" },
      width: "22.261",
      height: "44.522"
    }),
    createElementVNode("rect", {
      x: "278.261",
      y: "233.739",
      width: "22.261",
      height: "44.522"
    }),
    createElementVNode("g", null, [
      createElementVNode("circle", {
        style: { "fill": "#0052B4" },
        cx: "89.043",
        cy: "256",
        r: "22.261"
      }),
      createElementVNode("circle", {
        style: { "fill": "#0052B4" },
        cx: "422.957",
        cy: "256",
        r: "22.261"
      })
    ])
  ]);
}
function render$2K(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3618)" }, [
      createElementVNode("path", {
        d: "M0 12C0 13.4679 0.264047 14.874 0.746437 16.174L12 17.2173L23.2536 16.1739C23.736 14.874 24 13.4679 24 12C24 10.5522 23.7435 9.1644 23.2737 7.87942L12 6.78259L0.726281 7.87947C0.256453 9.1644 0 10.5522 0 12Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0003C17.1593 24.0003 21.5578 20.7438 23.2533 16.1742H0.746094C2.44161 20.7438 6.84012 24.0003 11.9997 24.0003Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M11.9999 17.7399C15.1695 17.7399 17.739 15.1704 17.739 12.0007C17.739 8.8311 15.1695 6.2616 11.9999 6.2616C8.83024 6.2616 6.26074 8.8311 6.26074 12.0007C6.26074 15.1704 8.83024 17.7399 11.9999 17.7399Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.999 7.5564L13.035 10.7449H16.393L13.6753 12.7156L14.7195 15.9136L11.999 13.9336L9.28269 15.9099L10.3227 12.7156L7.60742 10.7449H10.963L11.999 7.5564Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.1308 12.7938L12.8441 11.7258L14.8753 8.93018L14.0312 8.31677L11.9999 11.1126L9.96872 8.31682L9.1245 8.93013L11.1557 11.726L7.86914 12.7938L8.19155 13.7862L11.4782 12.7184V16.1741H12.5217V12.7183L15.8082 13.7862L16.1308 12.7938Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3618" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2J(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3619)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.0002H11.9999C11.9999 11.9894 11.9999 11.9789 11.9999 11.968C11.9892 11.9788 11.9785 11.9895 11.9678 12.0002Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26074C12 4.14925 12 2.76574 12 -0.00012207H11.998C5.3715 0.00100293 0 5.37311 0 11.9999H6.26086V8.47436L9.78642 11.9999H11.9679C11.9786 11.9892 11.9893 11.9785 12 11.9678C12 11.1593 12 10.438 12 9.78635L8.47443 6.26074H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07027 1.56494C4.19344 2.63364 2.63316 4.19393 1.56445 6.07075V11.9997H4.69491V4.69549V4.69539H11.9993C11.9993 3.70807 11.9993 2.76747 11.9993 1.56494H6.07027Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9989 10.5244L7.73544 6.26099H6.25977V6.26108L11.9988 12.0001H11.9989C11.9989 12.0001 11.9989 10.9826 11.9989 10.5244Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M19.3046 14.0863V14.608H15.1307V14.0863H13.5654V16.1732H14.6089V16.695H19.8263V16.1732H20.8698V14.0863H19.3046Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.5654 6.2616V12.0007C13.5654 14.7963 17.2176 15.6529 17.2176 15.6529C17.2176 15.6529 20.8698 14.7963 20.8698 12.0007V6.2616H13.5654Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M17.2174 10.5428C16.3044 10.5428 16.3044 11.3776 15.3914 11.3776C14.4784 11.3776 14.4784 10.5428 13.5654 10.5428V12.0037C14.4784 12.0037 14.4784 12.8385 15.3914 12.8385C16.3044 12.8385 16.3044 12.0037 17.2174 12.0037C18.1304 12.0037 18.1304 12.8385 19.0436 12.8385C19.9567 12.8385 19.9566 12.0037 20.8698 12.0037V10.5428C19.9567 10.5428 19.9567 11.3776 19.0436 11.3776C18.1304 11.3776 18.1304 10.5428 17.2174 10.5428Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M17.2174 7.61804C16.3044 7.61804 16.3044 8.45284 15.3914 8.45284C14.4784 8.45284 14.4784 7.61804 13.5654 7.61804V9.0789C14.4784 9.0789 14.4784 9.9137 15.3914 9.9137C16.3044 9.9137 16.3044 9.0789 17.2174 9.0789C18.1304 9.0789 18.1304 9.9137 19.0436 9.9137C19.9567 9.9137 19.9566 9.0789 20.8698 9.0789V7.61804C19.9567 7.61804 19.9567 8.45284 19.0436 8.45284C18.1304 8.45284 18.1304 7.61804 17.2174 7.61804Z",
        fill: "#F3F3F3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3619" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2I(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3620)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.4781 12L23.898 10.4348C23.8283 9.90131 23.7237 9.37875 23.5865 8.86959H10.9563V0.0456543C10.4238 0.0914981 9.90139 0.172545 9.39111 0.285701L7.30414 1.5652L6.26066 1.45987C5.71151 1.7595 5.18834 2.10075 4.69545 2.47945V8.86954H0.413187C0.275984 9.3787 0.171359 9.90126 0.101609 10.4347L0.521516 12L0.101562 13.5652C0.171312 14.0987 0.275937 14.6213 0.413141 15.1304H4.69541V21.5205C5.1883 21.8993 5.71151 22.2405 6.26061 22.5401L7.82581 22.4347L9.39101 23.7142C9.90134 23.8274 10.4238 23.9084 10.9562 23.9543V15.1305H23.5863C23.7235 14.6213 23.8281 14.0987 23.8979 13.5652L23.4781 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4347H9.39136H9.39131V0.285156C8.28234 0.531062 7.23098 0.929641 6.26086 1.459V10.4347H0.101578C0.034875 10.9471 0 11.4694 0 11.9999C0 12.5304 0.034875 13.0528 0.101578 13.5651H6.26081H6.26086V22.5408C7.23098 23.0701 8.28234 23.4688 9.39131 23.7146V13.5653V13.5652H23.8984C23.9651 13.0528 24 12.5304 24 11.9999C24 11.4694 23.9651 10.9471 23.8984 10.4347Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3620" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2H(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3621)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.0001 5.74023V9.78756L7.82617 5.74023H12.0001Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.26098 12.0018H9.78654L6.26098 7.30615L5.73926 10.9583L6.26098 12.0018Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.0001H11.9999C11.9999 11.9893 11.9999 11.9787 11.9999 11.9679C11.9892 11.9786 11.9785 11.9894 11.9678 12.0001Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26147C12 4.14999 12 2.76647 12 0.000610352H11.998C5.3715 0.00173535 0 5.37384 0 12.0006H6.26086V8.47509L9.78642 12.0006H11.968C11.9787 11.9899 11.9894 11.9792 12.0001 11.9685C12.0001 11.16 12.0001 10.4387 12.0001 9.78708L8.47443 6.26147H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.5658C4.19441 2.6345 2.63413 4.19478 1.56543 6.07161V12.0006H4.69588V4.69635V4.69625H12.0002C12.0002 3.70892 12.0002 2.76833 12.0002 1.5658H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9998 10.5249L7.73641 6.26147H6.26074V6.26157L11.9997 12.0006H11.9998C11.9998 12.0006 11.9998 10.983 11.9998 10.5249Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.5654 7.82718V12.001C13.5654 14.7966 17.2176 15.6532 17.2176 15.6532C17.2176 15.6532 20.8698 14.7966 20.8698 12.001V7.82718L17.2176 6.78369L13.5654 7.82718Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M20.8698 7.82631V6.26111H13.5654V7.82631H16.6958V10.9568H13.5654V12.0002C13.5654 12.0002 13.5654 12.0003 13.5654 12.0003L16.6958 12.0003V15.4924C17.0107 15.6038 17.2176 15.6524 17.2176 15.6524C17.2176 15.6524 17.4244 15.6039 17.7393 15.4924V12.0003H20.8698V12.0002V10.9568H17.7393V7.82626H20.8698V7.82631Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3621" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2G(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3622)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4347H9.39136H9.39131V0.285156C8.28234 0.531062 7.23098 0.929641 6.26086 1.459V10.4346V10.4347H0.101578C0.0347813 10.9471 0 11.4694 0 11.9999C0 12.5304 0.0347813 13.0528 0.101578 13.5651H6.26081H6.26086V22.5408C7.23098 23.0701 8.28234 23.4688 9.39131 23.7146V13.5653V13.5652H23.8984C23.9651 13.0528 24 12.5304 24 11.9999C24 11.4694 23.9651 10.9471 23.8984 10.4347Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3622" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2F(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3623)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9999 11.9999C23.9999 6.84037 20.7434 2.44185 16.1738 0.746338V23.2536C20.7434 21.558 23.9999 17.1595 23.9999 11.9999Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12.0008C0 17.1604 3.25655 21.5589 7.82611 23.2544V0.747192C3.25655 2.44271 0 6.84122 0 12.0008Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3623" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2E(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M2 32c0 16.6 13.4 30 30 30c11.7 0 21.9-6.8 26.8-16.6L5.2 18.6C3.1 22.6 2 27.2 2 32z",
      fill: "#ffce31"
    }),
    createElementVNode("path", {
      d: "M32 2C20.3 2 10.1 8.8 5.2 18.6l53.7 26.8c2-4 3.2-8.6 3.2-13.4C62 15.4 48.6 2 32 2z",
      fill: "#699635"
    }),
    createElementVNode("path", {
      fill: "#da121a",
      d: "M32 17.9L35.3 28h10.6l-8.6 6.3l3.3 10.1l-8.6-6.2l-8.6 6.2l3.3-10.1l-8.6-6.3h10.6z"
    })
  ]);
}
function render$2D(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3624)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.45898 6.26159H22.5408C20.5056 2.53147 16.5484 0.000732422 11.9999 0.000732422C7.45139 0.000732422 3.49425 2.53147 1.45898 6.26159Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9999 23.9999C16.5484 23.9999 20.5056 21.4691 22.5408 17.739H1.45898C3.49425 21.4691 7.45139 23.9999 11.9999 23.9999Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.174 11.9997C16.174 14.3049 14.3052 15.6519 12.0001 15.6519C9.69489 15.6519 7.82617 14.3049 7.82617 11.9997C7.82617 9.69448 9.69489 7.82581 12.0001 7.82581C14.3052 7.82581 16.174 9.69448 16.174 11.9997Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.174 11.9998C16.174 14.305 14.3052 16.1737 12.0001 16.1737C9.69489 16.1737 7.82617 14.305 7.82617 11.9998",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M10.4351 10.9559H9.3916V13.0429H10.4351V10.9559Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.6089 10.9559H13.5654V13.0429H14.6089V10.9559Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.522 9.39087H11.4785V13.043H12.522V9.39087Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3624" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2C(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3625)" }, [
      createElementVNode("path", {
        d: "M23.2536 16.175C23.736 14.875 24 13.4689 24 12.0011C24 10.5332 23.736 9.12721 23.2536 7.82718L12 6.78369L0.746391 7.82718C0.264047 9.12721 0 10.5332 0 12.0011C0 13.4689 0.264047 14.875 0.746391 16.175L12 17.2184L23.2536 16.175Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0007 23.9997C17.1603 23.9997 21.5588 20.7432 23.2543 16.1736H0.74707C2.44263 20.7432 6.8411 23.9997 12.0007 23.9997Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0007 0.000732422C6.8411 0.000732422 2.44263 3.25723 0.74707 7.82684H23.2543C21.5588 3.25723 17.1603 0.000732422 12.0007 0.000732422Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3625" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2B(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3726)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0003 0.000793457C7.03927 0.000793457 2.78171 3.01139 0.954102 7.30514H23.0465C21.2189 3.01139 16.9613 0.000793457 12.0003 0.000793457Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12.0003 24.0007C16.9613 24.0007 21.2189 20.9901 23.0465 16.6964H0.954102C2.78171 20.9901 7.03927 24.0007 12.0003 24.0007Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M23.5866 8.86963H0.413391C0.144375 9.86774 0 10.9169 0 12.0001C0 13.0832 0.144375 14.1324 0.413391 15.1305H23.5867C23.8556 14.1324 24 13.0832 24 12.0001C24 10.9169 23.8556 9.86774 23.5866 8.86963Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3726" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2A(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3727)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.30428 5.73981V4.17456H5.73908V5.73981H4.17383V7.30501H5.73908V8.87022H7.30428V7.30501H8.86948V5.73981H7.30428Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.2613 5.73981V4.17456H16.6961V5.73981H15.1309V7.30501H16.6961V8.87022H18.2613V7.30501H19.8265V5.73981H18.2613Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.30428 16.6967V15.1315H5.73908V16.6967H4.17383V18.2619H5.73908V19.8271H7.30428V18.2619H8.86948V16.6967H7.30428Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.2613 16.6967V15.1315H16.6961V16.6967H15.1309V18.2619H16.6961V19.8271H18.2613V18.2619H19.8265V16.6967H18.2613Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3727" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2z(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3728)" }, [
      createElementVNode("path", {
        d: "M0.746094 16.1749C2.44161 20.7445 6.84012 24.001 11.9997 24.001C17.1593 24.001 21.5578 20.7445 23.2533 16.1749L11.9997 15.1315L0.746094 16.1749Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9997 0.000793457C6.84012 0.000793457 2.44161 3.25729 0.746094 7.8269L11.9997 8.87034L23.2533 7.82686C21.5578 3.25729 17.1593 0.000793457 11.9997 0.000793457Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M0.746391 7.82574C0.264047 9.12573 0 10.5318 0 11.9996C0 13.4675 0.264047 14.8735 0.746391 16.1735H23.2537C23.736 14.8735 24 13.4675 24 11.9996C24 10.5318 23.736 9.12573 23.2536 7.82574H0.746391Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3728" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2y(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3626)" }, [
      createElementVNode("path", {
        d: "M0 11.9991C0 13.467 0.264047 14.873 0.746391 16.173L12 16.6948L23.2536 16.1731C23.736 14.873 24 13.467 24 11.9991C24 10.5313 23.736 9.12522 23.2536 7.82523L12 7.30347L0.746391 7.82519C0.264047 9.12522 0 10.5313 0 11.9991Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000976562C6.84012 -0.000976562 2.44161 3.25552 0.746094 7.82513H23.2534C21.5578 3.25552 17.1593 -0.000976562 11.9997 -0.000976562Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.2533 16.1741H0.746094C2.44161 20.7436 6.84013 24.0002 11.9997 24.0002C17.1593 24.0002 21.5578 20.7436 23.2533 16.1741Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M12 7.82629L13.0359 11.0147H16.3888L13.6764 12.9855L14.7124 16.1741L12 14.2035L9.28753 16.1741L10.3237 12.9855L7.61133 11.0147H10.964L12 7.82629Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3626" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2x(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3627)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F9F9F9"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0007C17.1593 24.0007 21.5578 20.7442 23.2533 16.1746H0.746094C2.44166 20.7442 6.84012 24.0007 11.9997 24.0007Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.6955 9.91359V8.34839H17.2173V7.30491H16.1738V7.82667H15.1303V7.30491H14.0869V8.34839H14.6086V9.91359H13.5651V6.26152H14.0869V5.21808H13.0434V5.7397H12.5216V5.21808H11.4782V5.7397H10.9564V5.21808H9.91292V6.26152H10.4347V9.91359H9.3912V8.34839H9.91292V7.30491H8.86943V7.82667H7.82599V7.30491H6.78251V8.34839H7.30423V9.91359H6.26074V14.0875H17.739V9.91359H16.6955Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 13.5651C11.1356 13.5651 10.4348 14.2659 10.4348 15.1303C10.4348 15.8117 10.8705 16.3913 11.4783 16.6061V18.7826H9.91309V20.8695H12.5218V16.6062C13.1296 16.3913 13.5653 15.8118 13.5653 15.1304C13.5652 14.266 12.8644 13.5651 12 13.5651ZM12 15.6521C11.7119 15.6521 11.4783 15.4185 11.4783 15.1304C11.4783 14.8422 11.7119 14.6087 12 14.6087C12.2881 14.6087 12.5217 14.8422 12.5217 15.1304C12.5217 15.4185 12.2881 15.6521 12 15.6521Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3627" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2w(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3628)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 8.87002H23.5866C23.2857 7.75373 22.8284 6.70181 22.2387 5.73956H12V8.87002Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M4.53058 21.3914H19.4702C20.5654 20.5191 21.5046 19.4597 22.2391 18.2609H1.76172C2.4963 19.4596 3.43548 20.5191 4.53058 21.3914Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M4.17433 2.90375C3.23092 3.71614 2.41534 4.67281 1.76172 5.7395H4.17433V2.90375Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12 12C12 10.7776 12 9.75469 12 8.86951H7.30434V12H4.17389V8.86951H0.413391C0.144375 9.86766 0 10.9168 0 12C0 13.0831 0.144375 14.1323 0.413391 15.1304H23.5867C23.8556 14.1323 24 13.0831 24 12H12Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.0003 0.000671387C10.334 0.000671387 8.74703 0.340656 7.30469 0.954484V5.73981H12.0003C12.0003 4.64706 12.0003 3.71767 12.0003 2.60936H19.4702C17.4203 0.976796 14.8245 0.000671387 12.0003 0.000671387Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3628" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2v(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3629)" }, [
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12C23.4783 12 12 13.5652 12 13.5652L0 12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M24 12.0004C24 18.6278 18.6274 24.0004 12 24.0004C5.37262 24.0004 0 18.6278 0 12.0004",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M8.34754 17.7397C11.5172 17.7397 14.0867 15.1702 14.0867 12.0006C14.0867 8.83091 11.5172 6.26141 8.34754 6.26141C5.1779 6.26141 2.6084 8.83091 2.6084 12.0006C2.6084 15.1702 5.1779 17.7397 8.34754 17.7397Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M2.6084 12.0006C2.6084 8.83101 5.1779 6.26141 8.34754 6.26141C11.5172 6.26141 14.0867 8.83096 14.0867 12.0006",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3629" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2u(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3630)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.23633 2.08691C7.16219 0.770377 9.49084 -6.10352e-05 11.9998 -6.10352e-05C14.5087 -6.10352e-05 16.8374 0.770377 18.7632 2.08691L11.9998 2.60863L5.23633 2.08691Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12.0004 11.9995L11.2346 11.2336L11.0312 11.5979L12.0004 11.9995Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51514C-1.17157 8.20142 -1.17157 15.7994 3.51471 20.4858C5.45126 18.5492 7.31375 16.6867 12 12.0004L3.51471 3.51514Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M20.4853 3.51587C25.1716 8.20215 25.1716 15.8002 20.4853 20.4865C18.5488 18.5499 16.6863 16.6875 12 12.0012L20.4853 3.51587Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M12.0001 16.1741C14.3052 16.1741 16.174 14.3054 16.174 12.0002C16.174 9.69501 14.3052 7.82629 12.0001 7.82629C9.69489 7.82629 7.82617 9.69501 7.82617 12.0002C7.82617 14.3054 9.69489 16.1741 12.0001 16.1741Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M11.9996 7.82642L12.9352 10.7059H15.9633L13.5137 12.4859L14.4492 15.3655L11.9996 13.5859L9.54996 15.3655L10.4857 12.4859L8.03613 10.7059H11.064L11.9996 7.82642Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0043 -6.10352e-05H11.9963C8.68444 0.00101709 5.68627 1.34366 3.51562 3.51406H20.485C18.3143 1.34366 15.3161 0.00101709 12.0043 -6.10352e-05Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M3.51562 20.4857C5.68716 22.6569 8.68688 23.9998 12.0002 23.9998C15.3136 23.9998 18.3133 22.6569 20.4848 20.4857H3.51562Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12.0006 1.3042L12.1949 1.90204H12.8235L12.315 2.27156L12.5093 2.8694L12.0006 2.49993L11.4921 2.8694L11.6864 2.27156L11.1777 1.90204H11.8063L12.0006 1.3042Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.09047 1.3042L9.28477 1.90204H9.91336L9.40481 2.27156L9.59911 2.8694L9.09047 2.49993L8.58197 2.8694L8.77622 2.27156L8.26758 1.90204H8.89617L9.09047 1.3042Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.9098 1.3042L15.1041 1.90204H15.7327L15.2241 2.27156L15.4184 2.8694L14.9098 2.49993L14.4013 2.8694L14.5956 2.27156L14.0869 1.90204H14.7155L14.9098 1.3042Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0006 21.1298L12.1949 21.7276H12.8235L12.315 22.0971L12.5093 22.695L12.0006 22.3254L11.4921 22.695L11.6864 22.0971L11.1777 21.7276H11.8063L12.0006 21.1298Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.09047 21.1298L9.28477 21.7276H9.91336L9.40481 22.0971L9.59911 22.695L9.09047 22.3254L8.58197 22.695L8.77622 22.0971L8.26758 21.7276H8.89617L9.09047 21.1298Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.9098 21.1298L15.1041 21.7276H15.7327L15.2241 22.0971L15.4184 22.695L14.9098 22.3254L14.4013 22.695L14.5956 22.0971L14.0869 21.7276H14.7155L14.9098 21.1298Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.65664 11.8019C3.96484 12.2889 3.82 12.9335 3.33301 13.2417C2.84607 13.55 2.20145 13.4051 1.8932 12.9182C1.33515 12.0365 1.65873 10.5967 1.65873 10.5967C1.65873 10.5967 3.09854 10.9203 3.65664 11.8019Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.05395 13.3225C3.34209 13.3225 3.57567 13.0889 3.57567 12.8008C3.57567 12.5126 3.34209 12.2791 3.05395 12.2791C2.76581 12.2791 2.53223 12.5126 2.53223 12.8008C2.53223 13.0889 2.76581 13.3225 3.05395 13.3225Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3630" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2t(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M2 32c0 16.6 13.4 30 30 30s30-13.4 30-30c0-3.5-.6-6.9-1.7-10H3.7C2.6 25.1 2 28.5 2 32z",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      d: "M32 2C18.9 2 7.8 10.4 3.7 22h56.6C56.2 10.4 45.1 2 32 2z",
      fill: "#2a5f9e"
    }),
    createElementVNode("g", { fill: "#ffce31" }, [
      createElementVNode("path", { d: "M30.9 5.2c-1 1.6-1.1 2.9-.4 5c.3 1 .7 2.5.8 3.4c.2 1.2.2 1.3.2 1.5h1.1c0-.4.1-.9.2-1.5c.1-.7.4-2.3.7-3.4c.6-2.2.5-3.5-.5-5c-.4-.6-.9-1-1.1-1c-.2 0-.7.4-1 1m4.7 4.4c-1.4.6-2.2 2.2-2.6 4.4c-.1.4-.1.6-.1 1h.7c.1-.3.1-.5.2-.9c.5-1.7 2.2-2.4 2.1-.8c0 .4-.2.7-.4.9c.3-.1.8-.3 1.3-.6c2.4-1.4 1.4-5.1-1.2-4m-5.5 6.1H34v-.3h-3.9v.3m.3 1.3c-.4.4-1 .7-1 .7s.5.1 1.1 0s.8-.1 1.1-.2c-.1.6-.1 1.2-.1 1.2c.1.8.2 1 .3 1.4c.2.3.4.3.5 0c.2-.4.3-.8.3-1.4c0-.4 0-.6-.1-1.2c.4.2.6.2 1.1.2h1s-.7-.4-1-.8c-.3-.4-.2-.4-.5-.9H31c-.3.5-.3.6-.6 1m-2-7.4c1.4.6 2.2 2.2 2.6 4.4c.1.4.1.6.1 1h-.7c-.1-.3-.1-.5-.2-.9c-.5-1.7-2.2-2.4-2.1-.8c0 .4.2.7.4.9c-.3-.1-.8-.3-1.3-.6c-2.4-1.4-1.4-5.1 1.2-4" }),
      createElementVNode("path", { d: "M13.6 13.6c.2 1.2.2 1.3.2 1.5h1.1c0-.4.1-.9.2-1.5c.1-.7.4-2.3.7-3.4c.4-1.5.5-2.5.3-3.5c-1.2.8-2.4 1.6-3.5 2.6c.1.3.1.6.3 1c.2.9.5 2.5.7 3.3" }),
      createElementVNode("path", { d: "M16.2 15.7v-.3h-3.9v.3h3.9" }),
      createElementVNode("path", { d: "M9.6 13.7c.4.3 1 .5 1.3.6c-.2-.2-.4-.5-.4-.9c-.1-1.6 1.5-.9 2.1.8c.1.4.2.6.2.9h.7c0-.5-.1-.6-.1-1c-.4-1.8-.9-3.1-1.8-3.9c-1 .9-1.9 1.9-2.7 2.9c.1.2.3.4.7.6" }),
      createElementVNode("path", { d: "M15.9 17c-.3-.4-.2-.4-.5-.9h-2.1c-.2.5-.3.6-.6 1c-.4.4-1 .7-1 .7s.5.1 1.1 0s.8-.1 1.1-.2c-.1.6-.1 1.2-.1 1.2c.1.8.2 1 .3 1.4c.2.3.4.3.5 0c.2-.4.3-.8.3-1.4c0-.4 0-.6-.1-1.2c.4.2.6.2 1.1.2h1s-.7-.4-1-.8" }),
      createElementVNode("path", { d: "M17.9 9.6c-1.4.6-2.2 2.2-2.6 4.4c-.1.4-.1.6-.1 1h.7c.1-.3.1-.5.2-.9c.5-1.7 2.2-2.4 2.1-.8c0 .4-.2.7-.4.9c.3-.1.8-.3 1.3-.6c2.4-1.4 1.4-5.1-1.2-4" }),
      createElementVNode("path", { d: "M48.2 15.1h.7c0-.5-.1-.6-.1-1c-.4-2.2-1.3-3.8-2.6-4.4c-2.6-1.1-3.6 2.6-1.1 4.1c.4.3 1 .5 1.3.6c-.2-.2-.4-.5-.4-.9c-.1-1.6 1.5-.9 2.1.8c0 .3 0 .5.1.8" }),
      createElementVNode("path", { d: "M48.2 10.2c.3 1 .7 2.5.8 3.4c.2 1.2.2 1.3.2 1.5h1c0-.4.1-.9.2-1.5c.1-.7.4-2.3.7-3.4c.1-.4.2-.7.3-1.1c-1.1-.9-2.2-1.8-3.4-2.5c-.3 1-.3 2.1.2 3.6" }),
      createElementVNode("path", { d: "M51.3 17c-.3-.4-.2-.4-.5-.9h-2.1c-.2.5-.3.6-.6 1c-.4.4-1 .7-1 .7s.5.1 1.1 0s.8-.1 1.1-.2c-.1.6-.1 1.2-.1 1.2c.1.8.2 1 .3 1.4c.2.3.4.3.5 0c.2-.4.3-.8.3-1.4c0-.4 0-.6-.1-1.2c.4.2.6.2 1.1.2h1s-.7-.4-1-.8" }),
      createElementVNode("path", { d: "M47.8 15.7h3.9v-.3h-3.9v.3" }),
      createElementVNode("path", { d: "M50.7 14.1c-.1.4-.1.6-.1 1h.7c.1-.3.1-.5.2-.9c.5-1.7 2.2-2.4 2.1-.8c0 .4-.2.7-.4.9c.3-.1.8-.3 1.3-.6c.3-.2.6-.4.8-.7c-.8-1-1.7-2-2.7-2.9c-.9.9-1.5 2.2-1.9 4" })
    ]),
    createElementVNode("g", { fill: "#83bf4f" }, [
      createElementVNode("path", { d: "M53.8 50.8l-.2.7l-15.8-6.9l.2-.6z" }),
      createElementVNode("path", { d: "M54.3 49.1l-.2.7L38 43.9l.2-.7z" }),
      createElementVNode("path", { d: "M54.7 47.7l-.1.6l-16.4-5.2l.2-.6z" }),
      createElementVNode("path", { d: "M38.47 42.113l.195-.672l16.421 4.769l-.195.672z" }),
      createElementVNode("path", { d: "M55.6 44.6l-.2.7l-16.6-4.1l.2-.7z" }),
      createElementVNode("path", { d: "M14.3 28.1l.4-.5l12.5 12l-.4.5z" }),
      createElementVNode("path", { d: "M12 28.7l.4-.5l13 11.2l-.4.5z" }),
      createElementVNode("path", { d: "M9.6 28.2l.4-.6l13.5 10.6l-.4.6z" }),
      createElementVNode("path", { d: "M9.158 29.737l.419-.561L23.28 39.403l-.42.561z" }),
      createElementVNode("path", { d: "M6.4 29.5l.4-.5l14.1 9.7l-.4.5z" }),
      createElementVNode("path", { d: "M6.3 32.3v-.6l16.9 3.8l-.1.6z" }),
      createElementVNode("path", { d: "M4.9 33.6v-.7l17 2.9l-.1.6z" }),
      createElementVNode("path", { d: "M7 35.4l.1-.7l17 2l-.1.7z" }),
      createElementVNode("path", { d: "M4.915 36.483l.066-.697l17.023 1.612l-.066.697z" }),
      createElementVNode("path", { d: "M7.8 38.7l.1-.7l17.1.9l-.1.7z" })
    ]),
    createElementVNode("path", {
      d: "M33.3 50.6l.7.5c1 .7 1.5 1.6 1.4 2.6v.8l.3-.8c.3-.8.3-2.1-.1-3l-.2-.5l.8.3c1.1.5 1.8 1.3 1.9 2.2l.1.8l.1-.8c.2-.9-.1-2.1-.7-2.9l-.3-.5l.8.2c1.2.2 2 .9 2.4 1.8l.3.7v-.8c0-.9-.6-2-1.3-2.7l-.4-.4h.8c1.2 0 2.2.4 2.7 1.2l.4.7l-.2-.8c-.2-.9-1-1.8-1.8-2.4l-.5-.3l.8-.2c1.1-.3 2.2 0 2.9.6l.6.6l-.4-.8c-.4-.8-1.3-1.6-2.3-1.9l-.6-.2l.8-.3c1.1-.5 2.1-.5 3 0l.7.4l-.5-.7c-.5-.7-1.6-1.3-2.6-1.4H42l.7-.5c.9-.7 2-.9 2.9-.6l.7.3l-.6-.5c-.7-.6-1.9-.9-2.9-.8l-.6.1l.5-.6c.8-.9 1.8-1.3 2.7-1.2l.8.1l-.7-.4c-.8-.4-2-.5-3-.2l-.6.2l.4-.7c.6-1 1.4-1.7 2.4-1.7h.8l-.8-.2c-.9-.3-2.1-.1-3 .4l-.5.3l.2-.8c.3-1.1 1.1-1.9 2-2.2l.8-.2l-.8-.1c-.9-.1-2.1.4-2.8 1l-.4.4l.1-.8c.1-1.2.6-2.1 1.5-2.5l.7-.4h-.8c-.9.1-1.9.8-2.5 1.6l-.3.5l-.1-.8c-.1-1.2.2-2.2.9-2.8l.6-.5l-.8.3c-.8.3-1.7 1.2-2.1 2.1l-.2.5l-.3-.8c-.4-1.1-.3-2.2.3-2.9l.5-.6l-.8.4c-.8.5-1.5 1.5-1.7 2.5v.5l-.4-.7c-.6-1-.7-2.1-.3-2.9l.4-.7l-.6.6c-.7.6-1.1 1.8-1.1 2.8v.6l-.7-.7c-.8-.9-1.1-1.9-.9-2.8l.2-.8l-.5.7c-.5.7-.7 2-.5 2.9l.1.6l-.7-.5c-1-.7-1.5-1.6-1.4-2.6v-.8l-.3.8c-.3.8-.3 2.1.1 3l.2.5l-.8-.3c-1.1-.5-1.8-1.3-1.9-2.2l-.1-.8v.9c-.2.9.1 2.1.7 2.9l.3.5l-.8-.2c-1.2-.2-2-.9-2.4-1.8l-.3-.7v.8c0 .9.6 2 1.3 2.7l.4.4h-.8c-1.2 0-2.2-.4-2.7-1.2l-.4-.7l.2.8c.2.9 1 1.8 1.8 2.4l.5.3l-.7.2c-1.1.3-2.2 0-2.9-.6l-.6-.6l.4.8c.4.8 1.3 1.6 2.3 1.9l.6.2l-.7.3c-1.1.5-2.1.5-3 0l-.7-.4l.5.7c.5.7 1.6 1.3 2.6 1.4l.6.1l-.7.5c-.9.7-2 .9-2.9.6l-.6-.5l.6.5c.7.6 1.9.9 2.9.8l.6-.1l-.5.6c-.8.9-1.8 1.3-2.7 1.2H18l.7.4c.8.4 2 .5 3 .2l.6-.2l-.4.7c-.6 1-1.4 1.7-2.4 1.7h-.8l.8.2c.9.3 2.1.1 3-.4l.5-.3l-.2.8c-.3 1.1-1.1 1.9-2 2.2l-.8.3l.8.1c.9.1 2.1-.4 2.8-1l.4-.4v.7c-.1 1.2-.6 2.1-1.5 2.5l-.7.4l.8-.1c.9-.1 1.9-.8 2.5-1.6l.3-.5l.1.8c.1 1.2-.2 2.2-.9 2.8l-.6.6l.8-.3c.8-.3 1.7-1.2 2.1-2.1l.2-.5l.3.8c.4 1.1.3 2.2-.3 2.9l-.5.6l.7-.5c.8-.5 1.5-1.5 1.7-2.5l.1-.6l.4.7c.6 1 .7 2.1.3 2.9l-.4.7l.6-.4c.7-.6 1.1-1.8 1.1-2.8v-.6l.6.6c.8.9 1.1 1.9.9 2.8l-.2.8l.5-.7c.5-.7.7-2 .5-2.9l-.1-.6",
      fill: "#ffce31"
    })
  ]);
}
function render$2s(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3631)" }, [
      createElementVNode("path", {
        d: "M5.23633 21.9123C7.16214 23.2288 9.49089 23.9992 11.9998 23.9992C14.5087 23.9992 16.8374 23.2288 18.7632 21.9123L11.9998 20.8688L5.23633 21.9123Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.7642 2.08685C16.8383 0.770362 14.5096 -0.00012207 12.0008 -0.00012207C9.49187 -0.00012207 7.16312 0.770362 5.2373 2.08685L12.0008 3.13033L18.7642 2.08685Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M24 12.0004C24 8.02965 21.6227 4.042 18.7635 2.0874H5.23655C2.07516 4.24853 0 7.882 0 12.0004C0 16.119 2.07516 19.7523 5.23655 21.9135H18.7635C21.9249 19.7523 24 16.119 24 12.0004Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.3213 19.5748C11.1573 19.4342 7.30469 16.0851 7.30469 12C7.30469 7.91486 11.1573 4.56569 11.3213 4.42511L12.0003 3.84302L12.6794 4.42506C12.8434 4.56569 16.696 7.91481 16.696 12C16.696 16.0851 12.8434 19.4343 12.6794 19.5748L12.0003 20.1569L11.3213 19.5748Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.652 12C15.652 8.34786 11.9998 5.21741 11.9998 5.21741C11.9998 5.21741 8.34766 8.34795 8.34766 12C8.34766 13.1173 8.6897 14.1855 9.16417 15.1305H14.8355C15.31 14.1855 15.652 13.1173 15.652 12Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M15.652 12.0005C15.652 13.1178 15.31 14.186 14.8355 15.1309L11.9998 15.6527L9.16417 15.1309C8.6897 14.186 8.34766 13.1178 8.34766 12.0005H15.652Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9997 18.7824C11.9997 18.7824 13.7588 17.2741 14.8354 15.1302H9.16406C10.2406 17.2741 11.9997 18.7824 11.9997 18.7824Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.65137 9.9126H14.347L11.9992 12.2604L9.65137 9.9126Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.783 11.4773H11.2178V16.173H12.783V11.4773Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3631" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2r(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3632)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9994 12.0002C23.9994 7.24267 21.2307 3.13192 17.2168 1.19092V22.8094C21.2307 20.8685 23.9994 16.7577 23.9994 12.0002Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M0 12.0001C0 16.7576 2.76867 20.8684 6.78262 22.8094V1.1908C2.76867 3.1318 0 7.24255 0 12.0001Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M15.135 14.0284L13.106 11.9994L15.0374 10.0679L14.9499 9.04778L14.3969 8.49475L11.9992 10.8925L9.60142 8.49475L9.04848 9.04778L8.96097 10.0679L10.8924 11.9994L8.86328 14.0284L9.97009 15.1351L11.9992 13.1061L14.0282 15.1351L15.135 14.0284Z",
        fill: "#ACABB1"
      }),
      createElementVNode("path", {
        d: "M14.9515 9.04895L13.8447 10.1557C14.3168 10.6278 14.6088 11.28 14.6088 12.0003C14.6088 13.4411 13.4408 14.609 12.0001 14.609C10.5594 14.609 9.39138 13.4411 9.39138 12.0003C9.39138 11.28 9.68341 10.6278 10.1555 10.1557L9.04872 9.04895C8.29333 9.8042 7.82617 10.8477 7.82617 12.0003C7.82617 14.3056 9.69489 16.1742 12.0001 16.1742C14.3052 16.1742 16.174 14.3055 16.174 12.0003C16.174 10.8477 15.7068 9.80425 14.9515 9.04895Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3632" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2q(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3633)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4695 0 10.9471 0.034875 10.4348 0.101578V10.4348H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5305 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4695 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5305 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.3914 12.5219L16.174 13.0437V10.9567L15.3914 11.4785H12.5218V8.60887L13.0435 7.82629H10.9566L11.4783 8.60887V11.4785H8.60875L7.82617 10.9567V13.0437L8.60875 12.5219H11.4783V15.3915L10.9566 16.1741H13.0435L12.5218 15.3915V12.5219H15.3914Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3633" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2p(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    height: "24",
    width: "24",
    viewBox: "0 0 512 512"
  }, [
    createElementVNode("path", {
      style: { "fill": "#FFDA44" },
      d: "M256,0c-23.106,0-45.49,3.08-66.783,8.819L166.957,256l22.261,247.181\r\n	C210.51,508.92,232.894,512,256,512c141.384,0,256-114.616,256-256S397.384,0,256,0z"
    }),
    createElementVNode("path", {
      style: { "fill": "#6DA544" },
      d: "M166.957,256l22.261,247.181C210.51,508.92,232.894,512,256,512c141.384,0,256-114.616,256-256\r\n	H166.957z"
    }),
    createElementVNode("g", null, [
      createElementVNode("path", {
        style: { "fill": "#D80027" },
        d: "M0,256c0,97.035,53.99,181.455,133.565,224.873V31.127C53.99,74.545,0,158.965,0,256z"
      }),
      createElementVNode("path", {
        style: { "fill": "#D80027" },
        d: "M0,256c0,118.279,80.221,217.805,189.217,247.181V8.819C80.221,38.195,0,137.721,0,256z"
      })
    ]),
    createElementVNode("polygon", { points: "96.736,189.217 113.311,240.233 166.957,240.233 123.559,271.765 140.133,322.783 96.736,291.252 53.337,322.783 \r\n	69.915,271.765 26.517,240.233 80.16,240.233 " })
  ]);
}
function render$2o(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3635)" }, [
      createElementVNode("path", {
        d: "M16.1743 0.746315C14.8742 0.263925 13.4681 -0.00012207 12.0002 -0.00012207C10.5325 -0.00012207 9.12639 0.263925 7.82645 0.746222L7.30469 11.9999L7.82641 23.2535C9.12639 23.7359 10.5325 23.9999 12.0002 23.9999C13.4682 23.9999 14.8742 23.7359 16.1743 23.2534L16.696 11.9999L16.1743 0.746315Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M0 12.0004C0 17.1599 3.2565 21.5585 7.82611 23.2539V0.746704C3.2565 2.44227 0 6.84073 0 12.0004Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.9999 12.0004C23.9999 6.84073 20.7434 2.44227 16.1738 0.746704V23.254C20.7434 21.5585 23.9999 17.1599 23.9999 12.0004Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3635" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2n(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3636)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000976562C9.87813 -0.000976562 7.88556 0.550367 6.15625 1.51646V22.4816C7.88561 23.4477 9.87813 23.999 11.9997 23.999C18.6271 23.999 23.9997 18.6264 23.9997 11.999C23.9997 5.37165 18.6271 -0.000976562 11.9997 -0.000976562Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M6.19178 1.49817C5.43686 1.91653 4.73195 2.41378 4.08794 2.97909C4.15305 2.922 4.21881 2.86556 4.28509 2.80987L13.4756 12.0005L4.28505 21.1911C4.21872 21.1354 4.153 21.0789 4.08789 21.0218C4.73191 21.5872 5.43686 22.0844 6.19173 22.5028L24 12.0005L6.19178 1.49817Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.17837 2.12695C4.81241 2.38036 4.46095 2.65303 4.12602 2.94445L12.0001 11.9997L4.12598 21.0549C4.4609 21.3463 4.81237 21.619 5.17832 21.8724L21.9459 11.9997L5.17837 2.12695Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.28504 2.80981C4.01827 3.03397 3.76084 3.26896 3.51465 3.5151L10.9565 12.0004L3.51465 20.4857C3.76084 20.7319 4.01823 20.9669 4.28504 21.191L13.4756 12.0004L4.28504 2.80981Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51428C-1.17157 8.20056 -1.17157 15.7986 3.51471 20.4849C5.45126 18.5484 7.31375 16.6859 12 11.9996L3.51471 3.51428Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3636" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2m(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3637)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 5.37262 12 0 12 0C12 0 24 5.37262 24 12Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M16.174 15.1305L12.0001 14.6088L7.82617 15.1305V8.86963H16.174V15.1305Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0001 14.6083C13.1527 14.6083 14.087 13.6739 14.087 12.5213C14.087 11.3687 13.1527 10.4343 12.0001 10.4343C10.8475 10.4343 9.91309 11.3687 9.91309 12.5213C9.91309 13.6739 10.8475 14.6083 12.0001 14.6083Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0005 13.5651C12.5768 13.5651 13.044 13.0979 13.044 12.5216C13.044 11.9453 12.5768 11.4781 12.0005 11.4781C11.4242 11.4781 10.957 11.9453 10.957 12.5216C10.957 13.0979 11.4242 13.5651 12.0005 13.5651Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M10.4346 9.91333H13.565L11.9998 11.4786L10.4346 9.91333Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.522 10.9556H11.4785V14.086H12.522V10.9556Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.6696 13.7745H10.3304L7.82617 15.1311H16.174L13.6696 13.7745Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3637" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2l(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3638)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9987C16.7572 23.9987 20.868 21.23 22.809 17.2161H1.19043C3.13143 21.23 7.24218 23.9987 11.9997 23.9987Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.0007 -0.000976562C7.24316 -0.000976562 3.13241 2.7677 1.19141 6.78165H22.8099C20.869 2.7677 16.7582 -0.000976562 12.0007 -0.000976562Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M7.38504 7.82446L7.77354 9.0202H9.03077L8.01368 9.75913L8.40223 10.9549L7.38504 10.2159L6.36785 10.9549L6.7564 9.75913L5.73926 9.0202H6.99649L7.38504 7.82446Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M7.38504 13.0425L7.77354 14.2383H9.03077L8.01368 14.9772L8.40223 16.1729L7.38504 15.4339L6.36785 16.1729L6.7564 14.9772L5.73926 14.2383H6.99649L7.38504 13.0425Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M16.6145 7.82446L17.0031 9.0202H18.2603L17.2432 9.75913L17.6317 10.9549L16.6145 10.2159L15.5973 10.9549L15.9859 9.75913L14.9688 9.0202H16.226L16.6145 7.82446Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M16.6145 13.0425L17.0031 14.2383H18.2603L17.2432 14.9772L17.6317 16.1729L16.6145 15.4339L15.5973 16.1729L15.9859 14.9772L14.9688 14.2383H16.226L16.6145 13.0425Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M11.9993 10.4333L12.3878 11.6291H13.6451L12.6279 12.3681L13.0165 13.5638L11.9993 12.8248L10.9821 13.5638L11.3707 12.3681L10.3535 11.6291H11.6107L11.9993 10.4333Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3638" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2k(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3639)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.2387 9.07752C12.966 10.2118 12.4815 9.99552 12.2437 10.9848C10.8429 10.648 9.98021 9.23938 10.317 7.83852C10.6537 6.43775 12.0624 5.57506 13.4632 5.91186C12.9876 7.89031 13.4827 8.063 13.2387 9.07752Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.60395 9.91749C10.5985 10.5273 10.243 10.9214 11.1103 11.4533C10.3571 12.6815 8.75092 13.0665 7.5227 12.3134C6.29453 11.5603 5.90936 9.954 6.66255 8.72583C8.3972 9.78952 8.71431 9.372 9.60395 9.91749Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.27946 13.6349C10.1668 12.8775 10.4316 13.3373 11.2055 12.6769C12.1409 13.7727 12.0108 15.4193 10.915 16.3547C9.81918 17.2901 8.17255 17.1598 7.2373 16.0641C8.78483 14.743 8.48573 14.3123 9.27946 13.6349Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.7145 15.0914C12.2683 14.0135 12.7875 13.9036 12.3984 12.9636C13.7296 12.4127 15.2555 13.0452 15.8065 14.3764C16.3574 15.7076 15.7248 17.2334 14.3936 17.7844C13.6156 15.9043 13.1136 16.0557 12.7145 15.0914Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M15.1618 12.2739C13.9987 12.3652 14.0545 11.8374 13.0403 11.917C12.9277 10.4808 14.0009 9.22495 15.4372 9.11222C16.8734 8.99976 18.1292 10.0728 18.2418 11.5092C16.2132 11.6682 16.202 12.1924 15.1618 12.2739Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3639" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2j(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3640)" }, [
      createElementVNode("path", {
        d: "M0.746391 7.82522C0.264047 9.12525 0 10.5313 0 11.9991C0 13.467 0.264047 14.8731 0.746391 16.173L12 17.2165L23.2536 16.173C23.736 14.8731 24 13.467 24 11.9991C24 10.5313 23.736 9.12525 23.2536 7.82522L12 6.78174L0.746391 7.82522Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0006 -0.000976562C6.8411 -0.000976562 2.44254 3.25552 0.74707 7.82513H23.2543C21.5587 3.25552 17.1603 -0.000976562 12.0006 -0.000976562Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0006 23.9993C17.1603 23.9993 21.5587 20.7428 23.2543 16.1732H0.74707C2.44254 20.7428 6.8411 23.9993 12.0006 23.9993Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3640" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2i(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3641)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0.413086 15.1301C1.1074 17.7063 2.63763 19.9392 4.69535 21.5202V15.1301H0.413086Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M10.9561 23.954C11.3 23.9837 11.6479 23.9997 11.9995 23.9997C17.5439 23.9997 22.2091 20.2393 23.5861 15.1301H10.9561V23.954Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.5861 8.86918C22.2091 3.75999 17.5439 -0.000366211 11.9995 -0.000366211C11.6479 -0.000366211 11.3 0.015665 10.9561 0.04529V8.86918H23.5861Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M4.69535 2.47937C2.63763 4.06046 1.1074 6.29326 0.413086 8.86946H4.69535V2.47937Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4352H9.39136H9.39131V0.285645C8.28234 0.531551 7.23098 0.930129 6.26086 1.45949V10.4352H0.101578C0.0347813 10.9476 0 11.4699 0 12.0004C0 12.5309 0.0347813 13.0533 0.101578 13.5656H6.26081H6.26086V22.5413C7.23098 23.0706 8.28234 23.4693 9.39131 23.7151V13.5658V13.5657H23.8984C23.9651 13.0533 24 12.5309 24 12.0004C24 11.4699 23.9651 10.9475 23.8984 10.4352Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3641" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2h(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3642)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000976562C7.24218 -0.000976562 3.13143 2.7677 1.19043 6.78165H22.8089C20.868 2.7677 16.7572 -0.000976562 11.9997 -0.000976562Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9997C16.7572 23.9997 20.868 21.231 22.809 17.217H1.19043C3.13143 21.231 7.24218 23.9997 11.9997 23.9997Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0001 16.1732C14.3052 16.1732 16.174 14.3045 16.174 11.9993C16.174 9.69415 14.3052 7.82544 12.0001 7.82544C9.69489 7.82544 7.82617 9.69415 7.82617 11.9993C7.82617 14.3045 9.69489 16.1732 12.0001 16.1732Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0003 14.608C13.441 14.608 14.609 13.44 14.609 11.9993C14.609 10.5586 13.441 9.39062 12.0003 9.39062C10.5595 9.39062 9.3916 10.5586 9.3916 11.9993C9.3916 13.44 10.5595 14.608 12.0003 14.608Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 8.78088L12.8055 10.6061L14.7885 10.3904L13.6102 12L14.7885 13.6095L12.8055 13.3939L12.0007 15.2191L11.1959 13.3939L9.21289 13.6095L10.3911 12L9.21289 10.3904L11.1959 10.6061L12.0007 8.78088Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3642" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2g(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3643)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3643" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2f(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3644)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M15.8976 8.86968H14.3275C14.3405 9.04222 14.3479 9.21632 14.3479 9.39139C14.3479 10.5522 14.0577 11.6774 13.5519 12.4783C13.3958 12.7253 13.1336 13.0741 12.7826 13.3094V8.86963H11.2174V13.3094C10.8665 13.0741 10.6042 12.7253 10.4481 12.4783C9.94227 11.6774 9.65216 10.5522 9.65216 9.39139C9.65216 9.21632 9.65957 9.04218 9.67251 8.86968H8.10248C8.0924 9.04138 8.08691 9.21529 8.08691 9.39139C8.08691 12.6096 9.80573 15.1305 11.9999 15.1305C14.1942 15.1305 15.913 12.6096 15.913 9.39139C15.9131 9.21529 15.9076 9.04138 15.8976 8.86968Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.9572 5.73816H6.52241V6.78165H8.08761V5.73816H9.65281V6.78165H11.218V5.73816H12.7832V6.78165H14.3484V5.73816H15.9136V6.78165H17.4788V5.73816H19.044V6.78165H22.8098C20.869 2.7677 16.7582 -0.000976562 12.0007 -0.000976562C7.2432 -0.000976562 3.13241 2.7677 1.19141 6.78165H4.9572V5.73816Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M19.0442 17.217V18.2605H17.479V17.217H15.9138V18.2605H14.3486V17.217H12.7834V18.2605H11.2182V17.217H9.65295V18.2605H8.08775V17.217H6.52241V18.2605H4.9572V17.217H1.19141C3.13241 21.231 7.24316 23.9997 12.0007 23.9997C16.7582 23.9997 20.869 21.231 22.81 17.217H19.0442Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3644" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2e(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3645)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000610352C6.84012 -0.000610352 2.44161 3.25589 0.746094 7.8255H23.2534C21.5578 3.25589 17.1593 -0.000610352 11.9997 -0.000610352Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0006C17.1593 24.0006 21.5578 20.7441 23.2533 16.1744H0.746094C2.44161 20.7441 6.84013 24.0006 11.9997 24.0006Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M9.13039 11.2186C9.12383 11.2186 9.1174 11.219 9.11084 11.2191V11.2186H6.81692C6.93322 10.7692 7.34094 10.4359 7.82605 10.4359V8.87073C6.38759 8.87073 5.21736 10.041 5.21736 11.4794V12.7577V12.7838H9.11084C9.11966 12.7838 9.12659 12.7838 9.13039 12.7838C9.27425 12.7838 9.39125 12.9009 9.39125 13.0447V13.5664H4.17383V15.1316H10.9565V13.0446C10.9565 12.0377 10.1373 11.2186 9.13039 11.2186Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M13.0437 13.5657V8.87H11.4785V15.1309H14.0872V13.5657H13.0437Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M18.2606 13.5657V8.87H16.6954V13.5657H16.1736V12.0005H14.6084V15.1309H19.3041V13.5657H18.2606Z",
        fill: "#496E2D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3645" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2d(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3646)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9999 11.999C23.9999 6.83951 20.7434 2.44095 16.1738 0.745483V23.2527C20.7434 21.5571 23.9999 17.1587 23.9999 11.999Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M0 11.9997C0 17.1593 3.2565 21.5578 7.82611 23.2533V0.746094C3.2565 2.44156 0 6.84013 0 11.9997Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3646" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2c(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3647)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.4437 8.04392L15.5955 11.0707L13.0507 10.6008L11.4126 7.22412L6.98727 8.79448L6.63828 7.81104L5.48047 7.6684L6.35286 10.1269L9.39828 9.34812L10.2637 11.787L8.15848 14.8939L11.7312 17.9411L11.054 18.735L11.5093 19.8091L13.2024 17.8242L11.0052 15.5763L12.6845 13.6074L16.4279 13.8771L17.2805 9.25943L18.3066 9.44895L19.0093 8.51754L16.4437 8.04392Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3647" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2b(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3729)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.5173 9.39207H13.505L11.9989 6.78339L10.4928 9.39207H7.48047L8.98675 12.0008L7.48047 14.6094H10.4928L11.9989 17.2181L13.505 14.6094H16.5173L15.011 12.0008L16.5173 9.39207ZM13.8493 12.0008L12.9242 13.6033H11.0738L10.1485 12.0008L11.0737 10.3982H12.9241L13.8493 12.0008ZM11.9989 8.79559L12.3432 9.39203H11.6546L11.9989 8.79559ZM9.22324 10.3982H9.91192L9.56758 10.9946L9.22324 10.3982ZM9.22324 13.6033L9.56763 13.0069L9.91197 13.6033H9.22324ZM11.9989 15.2059L11.6546 14.6094H12.3432L11.9989 15.2059ZM14.7746 13.6033H14.0859L14.4303 13.0069L14.7746 13.6033ZM14.0859 10.3982H14.7746L14.4302 10.9946L14.0859 10.3982Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M19.4693 2.60907H4.5296C3.43446 3.48132 2.49527 4.54079 1.76074 5.73952H22.2382C21.5036 4.54084 20.5644 3.48132 19.4693 2.60907Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M4.5296 21.3914H19.4693C20.5644 20.5191 21.5036 19.4597 22.2381 18.2609H1.76074C2.49532 19.4596 3.43451 20.5191 4.5296 21.3914Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3729" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2a(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3730)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9999 11.9992C23.9999 6.83958 20.7434 2.44106 16.1738 0.745544V23.2528C20.7434 21.5572 23.9999 17.1587 23.9999 11.9992Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 11.9997C0 17.1593 3.2565 21.5578 7.82611 23.2533V0.746094C3.2565 2.44161 0 6.84013 0 11.9997Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3730" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$29(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3731)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.3059 2.48075C17.2824 0.925388 14.7495 0.00012207 12.0001 0.00012207C9.25073 0.00012207 6.71779 0.925434 4.69434 2.48075L12.0001 9.7865L19.3059 2.48075Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M2.48058 4.6936C0.925312 6.71706 0 9.24995 0 11.9994C0 14.7488 0.925312 17.2817 2.48062 19.3052L9.78642 11.9994L2.48058 4.6936Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M4.69434 21.5188C6.71784 23.0741 9.25073 23.9994 12.0001 23.9994C14.7495 23.9994 17.2824 23.0741 19.3059 21.5188L12.0001 14.213L4.69434 21.5188Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M21.5196 19.3051C23.075 17.2816 24.0002 14.7488 24.0002 11.9994C24.0002 9.24995 23.075 6.71706 21.5196 4.6936L14.2139 11.9994L21.5196 19.3051Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3731" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$28(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3732)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9996 17.2178C14.8811 17.2178 17.217 14.8819 17.217 12.0004C17.217 9.11892 14.8811 6.78302 11.9996 6.78302C9.11813 6.78302 6.78223 9.11892 6.78223 12.0004C6.78223 14.8819 9.11813 17.2178 11.9996 17.2178Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3732" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$27(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3733)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M21.5209 19.3071L14.2143 12.0006H14.2142L21.5209 4.69382C21.2058 4.28432 20.861 3.89033 20.486 3.51519C20.1109 3.1401 19.7169 2.79533 19.3074 2.48029L12.0007 9.78693L12.0007 9.78697L4.69405 2.48029C4.28459 2.79538 3.89056 3.14005 3.51542 3.51519C3.14028 3.89033 2.79556 4.28432 2.48052 4.69382L9.78716 12.0004L9.7872 12.0005L2.48047 19.3072C2.79561 19.7167 3.14033 20.1107 3.51538 20.4858C3.89052 20.8609 4.28445 21.2057 4.694 21.5207L12.0007 14.2141L12.0007 14.214L19.3074 21.5207C19.7168 21.2056 20.1109 20.8609 20.486 20.4858C20.8611 20.1106 21.2058 19.7166 21.5209 19.3071Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.91309 3.65288L12.0001 4.1746L14.087 3.65288V1.87899L13.2522 2.29636L12.0001 1.04419L10.7479 2.29636L9.91309 1.87899V3.65288Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.91309 3.65289V4.95733C9.91309 6.55483 12.0001 7.0443 12.0001 7.0443C12.0001 7.0443 14.087 6.55478 14.087 4.95733V3.65289H9.91309Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3733" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$26(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3734)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.30388 7.82623H23.2531C21.5576 3.25662 17.1591 0.00012207 11.9995 0.00012207C8.68576 0.00012207 5.68609 1.34351 3.51465 3.51523L7.30388 7.82623Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M7.30388 16.1745H23.2531C21.5576 20.7441 17.1591 24.0006 11.9995 24.0006C8.68576 24.0006 5.68609 22.6572 3.51465 20.4855L7.30388 16.1745Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51379C-1.17157 8.20008 -1.17157 15.7981 3.51471 20.4844C5.45126 18.5479 7.31375 16.6854 12 11.9991L3.51471 3.51379Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.76268 9.39178L5.42123 10.7689L6.90852 10.4252L6.24243 11.7987L7.43845 12.7471L5.94937 13.0827L5.95349 14.6092L4.76268 13.6542L3.57182 14.6092L3.57599 13.0827L2.08691 12.7471L3.28288 11.7987L2.61688 10.4252L4.10409 10.7689L4.76268 9.39178Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3734" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$25(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3648)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M18.783 12.1301H5.21777C5.21777 13.0666 6.03345 13.8258 6.96987 13.8258H6.91343C6.91343 14.7623 7.67257 15.5214 8.60909 15.5214C8.60909 16.458 9.36823 17.2171 10.3047 17.2171H13.6961C14.6326 17.2171 15.3917 16.458 15.3917 15.5214C16.3282 15.5214 17.0874 14.7623 17.0874 13.8258H17.0309C17.9673 13.8258 18.783 13.0666 18.783 12.1301Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.696 9.91351C16.696 12.5068 14.5937 14.6092 12.0003 14.6092C9.40698 14.6092 7.30469 12.5068 7.30469 9.91351",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M15.5864 9.91238L14.1208 10.6018L14.9012 12.0212L13.3098 11.7167L13.1082 13.3243L11.9997 12.1419L10.8912 13.3243L10.6896 11.7167L9.09821 12.0211L9.87859 10.6017L8.41309 9.91238L9.87863 9.22304L9.09821 7.80371L10.6896 8.10812L10.8913 6.50049L11.9997 7.68291L13.1082 6.50049L13.3098 8.10812L14.9013 7.80371L14.1209 9.22308L15.5864 9.91238Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3648" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$24(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3649)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 -0.000732422C7.24316 -0.000732422 3.13241 2.76794 1.19141 6.78189H22.8099C20.869 2.76794 16.7582 -0.000732422 12.0007 -0.000732422Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M12.0007 24C7.24316 24 3.13241 21.2314 1.19141 17.2174H22.8099C20.869 21.2314 16.7582 24 12.0007 24Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M23.4333 8.34705H0.566672C0.199078 9.49872 0 10.7257 0 11.9992C0 13.2728 0.199078 14.4997 0.566672 15.6514H23.4333C23.8009 14.4997 24 13.2728 24 11.9992C24 10.7257 23.8009 9.49872 23.4333 8.34705Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M15.7369 5.54508L14.3158 4.88916L12.0003 10.1322L9.68478 4.88916L8.26367 5.54508L11.1384 11.9997L8.26367 18.4544L9.68478 19.1103L12.0003 13.8673L14.3158 19.1103L15.7369 18.4544L12.8622 11.9997L15.7369 5.54508Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.9656 6.16321C12.4154 5.56242 12.0004 5.21704 12.0004 5.21704C12.0004 5.21704 11.5853 5.56237 11.0352 6.16321V17.836C11.5853 18.4369 12.0004 18.7823 12.0004 18.7823C12.0004 18.7823 12.4154 18.437 12.9656 17.8361V6.16321Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.3916 8.40226V15.5981C9.97294 16.6282 10.6845 17.4725 11.2177 18.0323V5.96814C10.6845 6.52787 9.9729 7.37223 9.3916 8.40226Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M14.6083 8.40287C14.0269 7.3728 13.3155 6.52848 12.7822 5.96875V18.0329C13.3154 17.4731 14.0269 16.6288 14.6083 15.5987V8.40287Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M14.6084 8.40088V15.5968C15.1969 14.5538 15.6519 13.3206 15.6519 11.9989C15.6519 10.6771 15.1969 9.44385 14.6084 8.40088Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M9.39114 8.40088V15.5968C8.80263 14.5538 8.34766 13.3206 8.34766 11.9989C8.34766 10.6771 8.80263 9.44385 9.39114 8.40088Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3649" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$23(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3650)" }, [
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.173 11.16L14.4674 11.9622L15.3757 13.614L13.5237 13.2597L13.289 15.1305L11.9991 13.7545L10.7091 15.1305L10.4745 13.2597L8.62249 13.6139L9.5307 11.9622L7.8252 11.16L9.5307 10.3577L8.62249 8.70605L10.4744 9.06023L10.7091 7.18945L11.9991 8.56537L13.2891 7.18945L13.5237 9.06023L15.3757 8.70605L14.4676 10.3578L16.173 11.16Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.13 3.913H12.7822C12.7822 3.48086 12.4318 3.13037 11.9996 3.13037C11.5674 3.13037 11.217 3.48081 11.217 3.913H8.86914C8.86914 4.34518 9.24564 4.69562 9.67783 4.69562H9.65172C9.65172 5.12781 10.0021 5.47824 10.4343 5.47824C10.4343 5.91043 10.7847 6.26087 11.217 6.26087H12.7822C13.2143 6.26087 13.5648 5.91048 13.5648 5.47824C13.9969 5.47824 14.3474 5.12785 14.3474 4.69562H14.3213C14.7535 4.69562 15.13 4.34523 15.13 3.913Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M24 11.9996C24 18.627 18.6274 23.9996 12 23.9996C5.37262 23.9996 0 18.627 0 11.9996C0.521719 11.9996 24 11.9996 24 11.9996Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0004 24.0005C15.7515 24.0005 19.0999 22.279 21.3005 19.5835C20.9047 19.3137 20.691 18.8774 20.0003 18.8774C19.0003 18.8774 19.0003 19.7918 18.0003 19.7918C17.0004 19.7918 17.0004 18.8774 16.0004 18.8774C15.0004 18.8774 15.0004 19.7918 14.0004 19.7918C13.0004 19.7918 13.0003 18.8774 12.0002 18.8774C11.0003 18.8774 11.0003 19.7918 10.0003 19.7918C9.00048 19.7918 9.00048 18.8774 8.00049 18.8774C7.00041 18.8774 7.00041 19.7918 6.00034 19.7918C5.00026 19.7918 5.00026 18.8774 4.00018 18.8774C3.30952 18.8774 3.09582 19.3136 2.7002 19.5834C4.9007 22.279 8.24935 24.0005 12.0004 24.0005Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M21.9999 13.5312C20.9999 13.5312 20.9999 12.6168 19.9998 12.6168C18.9999 12.6168 18.9999 13.5312 17.9999 13.5312C17 13.5312 16.9999 12.6168 16 12.6168C15 12.6168 15 13.5312 14 13.5312C13 13.5312 12.9999 12.6168 11.9998 12.6168C10.9998 12.6168 10.9998 13.5312 9.99991 13.5312C9.00006 13.5312 9.00006 12.6168 8.00008 12.6168C7 12.6168 7 13.5312 5.99992 13.5312C4.99984 13.5312 4.99984 12.6168 3.99977 12.6168C2.99992 12.6168 2.99992 13.5312 1.99994 13.5312C1.00534 13.5312 0.999578 12.6269 0.015625 12.6172C0.0433281 13.1661 0.108859 13.705 0.207953 14.232C1.00502 14.3491 1.07481 15.1311 1.99998 15.1311C2.99997 15.1311 2.99997 14.2169 3.99981 14.2169C4.99989 14.2169 4.99989 15.1311 5.99997 15.1311C7.00005 15.1311 7.00005 14.2169 8.00012 14.2169C9.00011 14.2169 9.00011 15.1311 9.99995 15.1311C10.9999 15.1311 10.9999 14.2169 11.9999 14.2169C13 14.2169 13 15.1311 14 15.1311C15.0001 15.1311 15.0001 14.2169 16 14.2169C17 14.2169 17 15.1311 18 15.1311C18.9999 15.1311 19 14.2169 19.9999 14.2169C21 14.2169 21 15.1311 21.9999 15.1311C22.9252 15.1311 22.995 14.3492 23.7921 14.232C23.8912 13.705 23.9567 13.1662 23.9845 12.6173C23.0004 12.627 22.9945 13.5312 21.9999 13.5312Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M19.9998 15.7477C18.9998 15.7477 18.9998 16.662 17.9998 16.662C16.9999 16.662 16.9999 15.7477 15.9999 15.7477C14.9999 15.7477 14.9999 16.662 13.9999 16.662C12.9998 16.662 12.9998 15.7477 11.9998 15.7477C10.9998 15.7477 10.9998 16.662 9.99983 16.662C8.99998 16.662 8.99998 15.7477 8 15.7477C6.99992 15.7477 6.99992 16.662 5.99984 16.662C4.99977 16.662 4.99977 15.7477 3.99969 15.7477C2.99984 15.7477 2.99984 16.662 1.99986 16.662C1.28534 16.662 1.08125 16.1953 0.658203 15.9287C0.939828 16.7424 1.3062 17.5165 1.74744 18.24C1.82417 18.2542 1.9077 18.262 1.99986 18.262C2.99984 18.262 2.99984 17.3478 3.99969 17.3478C4.99977 17.3478 4.99977 18.262 5.99984 18.262C6.99992 18.262 6.99992 17.3478 8 17.3478C8.99998 17.3478 8.99998 18.262 9.99983 18.262C10.9998 18.262 10.9998 17.3478 11.9998 17.3478C12.9998 17.3478 12.9998 18.262 13.9999 18.262C15 18.262 15 17.3478 15.9999 17.3478C16.9999 17.3478 16.9999 18.262 17.9998 18.262C18.9998 18.262 18.9998 17.3478 19.9998 17.3478C20.9998 17.3478 20.9998 18.262 21.9998 18.262C22.092 18.262 22.1756 18.2542 22.2523 18.24C22.6935 17.5165 23.0599 16.7424 23.3416 15.9288C22.9185 16.1952 22.7144 16.662 21.9998 16.662C20.9998 16.662 20.9998 15.7477 19.9998 15.7477Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.9628 11.0511C23.0004 11.0738 22.9872 11.9644 21.9998 11.9644C20.9999 11.9644 20.9999 11.05 19.9998 11.05C18.9998 11.05 18.9998 11.9644 17.9999 11.9644C17 11.9644 16.9999 11.05 16 11.05C15 11.05 15 11.9644 14 11.9644C12.9999 11.9644 12.9999 11.05 11.9998 11.05C10.9998 11.05 10.9998 11.9644 9.99989 11.9644C9.00005 11.9644 9.00005 11.05 8.00006 11.05C6.99998 11.05 6.99998 11.9644 5.99991 11.9644C4.99983 11.9644 4.99983 11.05 3.99975 11.05C2.99991 11.05 2.99991 11.9644 1.99992 11.9644C1.01278 11.9644 0.999422 11.0739 0.0371719 11.0511C0.01275 11.3639 0 11.68 0 11.9991C0 12.2177 0.0061875 12.4349 0.0178594 12.6505C0.999563 12.6616 1.00608 13.5643 1.99997 13.5643C2.99995 13.5643 2.99995 12.6501 3.9998 12.6501C4.99988 12.6501 4.99988 13.5643 5.99995 13.5643C7.00003 13.5643 7.00003 12.6501 8.00011 12.6501C9.00009 12.6501 9.00009 13.5643 9.99994 13.5643C10.9999 13.5643 10.9999 12.6501 11.9999 12.6501C12.9999 12.6501 12.9999 13.5643 14 13.5643C15.0001 13.5643 15.0001 12.6501 16 12.6501C17 12.6501 17 13.5643 18 13.5643C18.9999 13.5643 18.9999 12.6501 19.9999 12.6501C21 12.6501 21 13.5643 21.9999 13.5643C22.9939 13.5643 23.0004 12.6616 23.9823 12.6505C23.9938 12.4348 24 12.2177 24 11.9991C24 11.68 23.9872 11.3639 23.9628 11.0511Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3650" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$22(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    height: "24",
    width: "24",
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("circle", {
      style: { "fill": "#0052B4" },
      cx: "256",
      cy: "256",
      r: "256"
    }),
    createElementVNode("g", null, [
      createElementVNode("polygon", {
        style: { "fill": "#F0F0F0" },
        points: "112.449,155.827 117.975,172.835 135.855,172.835 121.39,183.344 126.915,200.349 \r\n		112.449,189.84 97.982,200.349 103.509,183.344 89.043,172.835 106.922,172.835 	"
      }),
      createElementVNode("polygon", {
        style: { "fill": "#F0F0F0" },
        points: "168.101,139.132 173.627,156.139 191.507,156.139 177.042,166.648 182.567,183.653 \r\n		168.101,173.144 153.635,183.653 159.161,166.648 144.696,156.139 162.576,156.139 	"
      }),
      createElementVNode("polygon", {
        style: { "fill": "#F0F0F0" },
        points: "223.753,122.436 229.279,139.443 247.159,139.443 232.694,149.953 238.219,166.958 \r\n		223.753,156.448 209.287,166.958 214.813,149.953 200.348,139.443 218.228,139.443 	"
      }),
      createElementVNode("polygon", {
        style: { "fill": "#F0F0F0" },
        points: "399.551,155.827 394.025,172.835 376.145,172.835 390.611,183.344 385.085,200.349 \r\n		399.551,189.84 414.018,200.349 408.491,183.344 422.957,172.835 405.077,172.835 	"
      }),
      createElementVNode("polygon", {
        style: { "fill": "#F0F0F0" },
        points: "343.899,139.132 338.373,156.139 320.493,156.139 334.959,166.648 329.433,183.653 \r\n		343.899,173.144 358.365,183.653 352.839,166.648 367.304,156.139 349.424,156.139 	"
      }),
      createElementVNode("polygon", {
        style: { "fill": "#F0F0F0" },
        points: "288.247,122.436 282.721,139.443 264.841,139.443 279.306,149.953 273.781,166.958 \r\n		288.247,156.448 302.713,166.958 297.187,149.953 311.652,139.443 293.772,139.443 	"
      })
    ]),
    createElementVNode("path", {
      style: { "fill": "#FFDA44" },
      d: "M300.522,267.13L256,211.478l-22.261,11.13v22.261l-33.391,22.261h-22.261v28.759\r\n	c32.628,13.212,55.652,45.181,55.652,82.546l0,0H256v-22.261l22.261-22.261l22.261,22.261l22.261-22.261v-22.261l22.261-33.391\r\n	L300.522,267.13z"
    })
  ]);
}
function render$21(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3651)" }, [
      createElementVNode("path", {
        d: "M23.2536 16.173C23.736 14.873 24 13.467 24 11.9991C24 10.5313 23.736 9.12521 23.2536 7.82522L12 6.78174L0.746391 7.82522C0.264047 9.12521 0 10.5313 0 11.9991C0 13.467 0.264047 14.873 0.746391 16.173L12 17.2165L23.2536 16.173Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 23.9996C17.1603 23.9996 21.5588 20.7431 23.2543 16.1735H0.74707C2.44263 20.7431 6.8411 23.9996 12.0007 23.9996Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000488281C6.84012 -0.000488281 2.44166 3.25601 0.746094 7.82562H23.2534C21.5578 3.25601 17.1593 -0.000488281 11.9997 -0.000488281Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51453C-1.17157 8.20081 -1.17157 15.7988 3.51471 20.4852C4.73791 19.2619 5.93182 18.068 7.82609 16.1738V7.82595L3.51471 3.51453Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3651" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$20(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3652)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M17.8681 12L15.4702 13.1279L16.7471 15.4504L14.1431 14.9522L13.8133 17.5826L11.9994 15.6481L10.1857 17.5826L9.85578 14.9522L7.25197 15.4503L8.52884 13.1278L6.13086 12L8.52884 10.8721L7.25197 8.54956L9.85569 9.04784L10.1858 6.41736L11.9994 8.35193L13.8133 6.41736L14.1431 9.04784L16.7472 8.54956L15.4702 10.8723L17.8681 12Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9998 15.6514C14.0169 15.6514 15.652 14.0163 15.652 11.9992C15.652 9.98218 14.0169 8.34705 11.9998 8.34705C9.98279 8.34705 8.34766 9.98218 8.34766 11.9992C8.34766 14.0163 9.98279 15.6514 11.9998 15.6514Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M10.1746 12.0004C10.0867 12.0004 9.9998 12.0049 9.91406 12.0134C9.9172 12.5192 10.1002 12.9822 10.4025 13.3419C10.5637 12.908 10.8045 12.5123 11.1081 12.1737C10.8181 12.0621 10.5035 12.0004 10.1746 12.0004Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.2988 13.967C11.5182 14.0454 11.7544 14.0884 12.0008 14.0884C12.2472 14.0884 12.4834 14.0454 12.7027 13.967C12.5832 13.4977 12.3363 13.0788 12.0008 12.7495C11.6653 13.0787 11.4184 13.4977 11.2988 13.967Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.8079 10.9573C13.447 10.3335 12.7731 9.91345 12.0006 9.91345C11.2281 9.91345 10.5542 10.3335 10.1934 10.9573C10.8512 10.9606 11.4681 11.1395 12.0006 11.4483C12.5332 11.1395 13.15 10.9606 13.8079 10.9573Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.8936 12.1739C13.1972 12.5125 13.4379 12.9082 13.5992 13.3421C13.9014 12.9825 14.0844 12.5195 14.0876 12.0136C14.0018 12.0051 13.9149 12.0006 13.827 12.0006C13.4982 12.0006 13.1836 12.0623 12.8936 12.1739Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3652" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1$(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3653)" }, [
      createElementVNode("path", {
        d: "M22.809 6.78189C20.868 2.76794 16.7572 -0.000732422 11.9997 -0.000732422C7.24218 -0.000732422 3.13143 2.76794 1.19043 6.78189L11.9997 7.82538L22.809 6.78189Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M1.19043 17.2162C3.13143 21.2302 7.24218 23.9988 11.9997 23.9988C16.7572 23.9988 20.868 21.2302 22.809 17.2162L11.9997 16.1727L1.19043 17.2162Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M22.8093 6.78174H1.19072C0.427875 8.35932 0 10.1292 0 11.9991C0 13.869 0.427875 15.6389 1.19072 17.2165H22.8092C23.5722 15.6389 24 13.869 24 11.9991C24 10.1292 23.5722 8.35932 22.8093 6.78174Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0001 16.1736C14.3052 16.1736 16.174 14.3049 16.174 11.9997C16.174 9.69452 14.3052 7.82581 12.0001 7.82581C9.69489 7.82581 7.82617 9.69452 7.82617 11.9997C7.82617 14.3049 9.69489 16.1736 12.0001 16.1736Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3653" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1_(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3654)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 -0.000732422C6.45634 -0.000732422 1.79106 3.75963 0.414062 8.86881H23.5873C22.2103 3.75963 17.545 -0.000732422 12.0007 -0.000732422Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12.0007 23.9986C17.545 23.9986 22.2103 20.2382 23.5873 15.129H0.414062C1.79106 20.2382 6.45634 23.9986 12.0007 23.9986Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3654" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1Z(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3655)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000732422C7.24218 -0.000732422 3.13143 2.76794 1.19043 6.78189H22.8089C20.868 2.76794 16.7572 -0.000732422 11.9997 -0.000732422Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9993C16.7572 23.9993 20.868 21.2306 22.809 17.2167H1.19043C3.13143 21.2306 7.24218 23.9993 11.9997 23.9993Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.131 14.0862L12.0006 8.34705L8.87012 14.0862H11.2179V15.6514H12.7832V14.0862H15.131Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3655" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1Y(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3656)" }, [
      createElementVNode("path", {
        d: "M0 11.9999C0 13.8697 0.427828 15.6396 1.19072 17.2173L12 17.739L22.8093 17.2173C23.5722 15.6396 24 13.8697 24 11.9999C24 10.13 23.5722 8.36013 22.8093 6.78251L12 6.26074L1.19072 6.78246C0.427828 8.36013 0 10.13 0 11.9999Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 24C16.7582 24 20.869 21.2314 22.81 17.2174H1.19141C3.13241 21.2314 7.24316 24 12.0007 24Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0007 -0.000732422C7.24316 -0.000732422 3.13241 2.76794 1.19141 6.78189H22.8099C20.869 2.76794 16.7582 -0.000732422 12.0007 -0.000732422Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.7828 11.7392V8.86963H11.2176V11.7392L9.32715 13.6297C9.87694 14.5297 10.8684 15.1305 12.0002 15.1305C13.1321 15.1305 14.1235 14.5297 14.6733 13.6297L12.7828 11.7392Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3656" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1X(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3657)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M2.74316 4.36307H21.2573C20.5735 3.53502 19.7804 2.80073 18.9006 2.18127H5.0999C4.2201 2.80063 3.42702 3.53498 2.74316 4.36307Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12.0005C0 12.3684 0.0174844 12.732 0.049875 13.0915H23.9501C23.9825 12.732 24 12.3684 24 12.0005C24 11.6327 23.9825 11.2691 23.9501 10.9097H0.049875C0.0174844 11.2691 0 11.6327 0 12.0005Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.30884 17.4546H22.6917C23.0451 16.7634 23.3332 16.0335 23.5484 15.2728H0.452148C0.667258 16.0335 0.955539 16.7634 1.30884 17.4546Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.0999 21.818H18.9005C19.7803 21.1986 20.5734 20.4643 21.2572 19.6362H2.74316C3.42702 20.4642 4.2201 21.1986 5.0999 21.818Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0.452148 8.72782H23.5485C23.3333 7.96713 23.0451 7.23719 22.6918 6.54602H1.30888C0.955586 7.23719 0.667305 7.96713 0.452148 8.72782Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.73926 2.18192H18.9004C16.9486 0.807638 14.5687 0.00012207 12.0001 0.00012207C10.4349 0.00012207 7.69113 0.807638 5.73926 2.18192Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.4785 6.54532H22.6917C22.2926 5.76471 21.8107 5.03351 21.2573 4.36353H11.4785V6.54532Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.4785 10.9085H23.9504C23.8829 10.1593 23.7472 9.42976 23.5484 8.72668H11.4785V10.9085Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.451805 15.2737H23.5481C23.7469 14.5707 23.8826 13.8411 23.9501 13.0919H0.0498047C0.117305 13.8411 0.252961 14.5706 0.451805 15.2737Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M2.74297 19.6369H21.2571C21.8105 18.9668 22.2924 18.2356 22.6915 17.4551H1.30859C1.70764 18.2357 2.18961 18.9669 2.74297 19.6369Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9999 24.0005C14.5685 24.0005 16.9484 23.193 18.9003 21.8187H5.09961C7.05148 23.193 9.43133 24.0005 11.9999 24.0005Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.451758 8.72692C0.252914 9.43004 0.117305 10.1596 0.0498047 10.9087H11.9999V-0.000366211C6.50711 -0.000366211 1.87638 3.6902 0.451758 8.72692Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M7.14405 3.13049L7.92101 5.52182H10.4357L8.40138 6.99989L9.17829 9.39136L7.14405 7.91339L5.10973 9.39136L5.88682 6.99989L3.85254 5.52182H6.36705L7.14405 3.13049Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3657" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1W(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3658)" }, [
      createElementVNode("path", {
        d: "M1.19072 6.78274C0.427875 8.36037 0 10.1302 0 12.0001C0 13.87 0.427875 15.6399 1.19072 17.2175L12 18.261L22.8093 17.2175C23.5721 15.6399 24 13.87 24 12.0001C24 10.1302 23.5721 8.36037 22.8093 6.78274L12 5.73926L1.19072 6.78274Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M1.19141 17.2168C3.13231 21.2307 7.24273 23.9994 12.0003 23.9994C16.7577 23.9994 20.8682 21.2307 22.8091 17.2168H1.19141Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M1.19141 6.78299H22.8091C20.8682 2.76904 16.7577 0.000366211 12.0003 0.000366211C7.24273 0.000366211 3.13231 2.76904 1.19141 6.78299Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.7929 9.80481L15.7775 11.1616L17.372 10.6446L16.3859 12.0002L17.3704 13.357L15.7764 12.838L14.7903 14.1936L14.7913 12.5173L13.1973 11.9983L14.7919 11.4812L14.7929 9.80481Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.1062 15.3904C10.2332 15.3904 8.71485 13.8721 8.71485 11.9991C8.71485 10.1262 10.2332 8.60782 12.1062 8.60782C12.6901 8.60782 13.2396 8.75548 13.7194 9.01545C12.9667 8.27946 11.9376 7.8252 10.8018 7.8252C8.4966 7.8252 6.62793 9.69391 6.62793 11.9991C6.62793 14.3043 8.49665 16.173 10.8018 16.173C11.9376 16.173 12.9668 15.7187 13.7194 14.9827C13.2396 15.2428 12.6902 15.3904 12.1062 15.3904Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3658" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1V(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3659)" }, [
      createElementVNode("path", {
        d: "M24 11.9995C24 18.6269 18.6274 23.9995 12 23.9995C5.37262 23.9995 0 18.6269 0 11.9995C0.521719 11.9995 12 10.4343 12 10.4343L24 11.9995Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M8.87023 8.34736C8.87023 7.48294 8.16945 6.78216 7.30503 6.78216C6.90401 6.78216 6.53853 6.9331 6.26154 7.18102V6.26039H6.78326V5.21691H6.26154V4.69519H5.21806V5.21691H4.69634V6.26039H5.21806V7.18102C4.94108 6.9331 4.57559 6.78216 4.17458 6.78216C3.31016 6.78216 2.60938 7.48294 2.60938 8.34736C2.60938 8.81082 2.81098 9.22707 3.13109 9.51371V10.4343H8.34846V9.51371C8.66867 9.22707 8.87023 8.81082 8.87023 8.34736Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3659" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1U(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3660)" }, [
      createElementVNode("path", {
        d: "M23.2536 16.1743C23.736 14.8744 24 13.4683 24 12.0005C24 10.5326 23.736 9.1265 23.2536 7.82656L12 6.78308L0.746391 7.82656C0.264 9.1265 0 10.5326 0 12.0005C0 13.4683 0.264 14.8744 0.746391 16.1743L12 17.2178L23.2536 16.1743Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M23.2533 7.82574C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2533Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0007 24.0008C17.1603 24.0008 21.5588 20.7443 23.2543 16.1747H0.74707C2.44259 20.7443 6.8411 24.0008 12.0007 24.0008Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3660" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1T(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3661)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000366211C6.84012 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0007 24.0008C17.1603 24.0008 21.5588 20.7443 23.2543 16.1747H0.74707C2.44259 20.7443 6.8411 24.0008 12.0007 24.0008Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3661" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1S(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3662)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M14.0872 11.5003C13.7927 11.5003 13.513 11.559 13.2533 11.6525C13.3956 11.3354 13.491 10.9826 13.491 10.6059C13.491 9.11521 12.0003 7.99719 12.0003 7.99719C12.0003 7.99719 10.5096 9.11521 10.5096 10.6059C10.5096 10.9826 10.605 11.3354 10.7473 11.6525C10.4875 11.5591 10.2079 11.5003 9.91337 11.5003C8.4227 11.5003 7.30469 12.9909 7.30469 12.9909C7.30469 12.9909 8.4227 14.4816 9.91337 14.4816C10.7874 14.4816 11.5328 13.9694 12.0003 13.5454C12.4679 13.9693 13.2133 14.4816 14.0873 14.4816C15.578 14.4816 16.696 12.9909 16.696 12.9909C16.696 12.9909 15.5779 11.5003 14.0872 11.5003Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0006 4.69458L12.3086 5.64221H13.305L12.499 6.22796L12.8066 7.17558L12.0006 6.58983L11.1946 7.17558L11.5023 6.22796L10.6963 5.64221H11.6927L12.0006 4.69458Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M8.2111 6.35156L8.80351 6.88491L9.49384 6.48637L9.16965 7.21458L9.76201 7.74802L8.96926 7.66467L8.64507 8.39288L8.47923 7.6132L7.68652 7.52986L8.3768 7.13123L8.2111 6.35156Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.4375 9.12594L6.21722 9.29164L6.6158 8.60132L6.69914 9.39402L7.47877 9.55986L6.75061 9.8841L6.83395 10.6768L6.30047 10.0845L5.57231 10.4087L5.97089 9.7183L5.4375 9.12594Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.7891 6.35156L15.1968 6.88491L14.5065 6.48637L14.8306 7.21458L14.2383 7.74802L15.031 7.66467L15.3552 8.39288L15.5211 7.6132L16.3138 7.52986L15.6235 7.13123L15.7891 6.35156Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M18.5627 9.12594L17.783 9.29164L17.3845 8.60132L17.3011 9.39402L16.5215 9.55986L17.2496 9.8841L17.1663 10.6768L17.6998 10.0845L18.4279 10.4087L18.0294 9.7183L18.5627 9.12594Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.9997 18.6554C13.1838 18.6554 14.2752 18.2603 15.1507 17.5956H8.84863C9.72416 18.2603 10.8156 18.6554 11.9997 18.6554Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.2168 15.5243C7.38241 15.9033 7.59241 16.2583 7.83906 16.5841H16.1602C16.4069 16.2584 16.6169 15.9033 16.7825 15.5243H7.2168Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3662" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1R(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3692)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.8259 23.8624C15.7776 23.5647 17.5741 22.7961 19.0973 21.6772L12.001 12.0004L13.8259 23.8624Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M10.1757 0.137695C8.22408 0.435445 6.42755 1.20401 4.9043 2.32287L12.0007 11.9997L10.1757 0.137695Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.9043 21.6772C6.42745 22.7961 8.22398 23.5646 10.1756 23.8625L12.0007 12.0004L4.9043 21.6772Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M2.32384 4.90234C1.20494 6.42559 0.436469 8.22208 0.138672 10.1738L12.0007 11.9988L2.32384 4.90234Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.138672 13.8253C0.436422 15.777 1.20498 17.5735 2.32389 19.0967L12.0007 12.0004L0.138672 13.8253Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.863 10.174C23.5652 8.22233 22.7967 6.42579 21.6778 4.90259L12.001 11.999L23.863 10.174Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M19.0973 2.32282C17.5741 1.20396 15.7776 0.435445 13.8259 0.137695L12.001 11.9997L19.0973 2.32282Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M21.6779 19.0967C22.7968 17.5735 23.5653 15.7769 23.8631 13.8254L12.001 12.0004L21.6779 19.0967Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.001 16.1743C14.3062 16.1743 16.1749 14.3056 16.1749 12.0004C16.1749 9.69525 14.3062 7.82654 12.001 7.82654C9.69586 7.82654 7.82715 9.69525 7.82715 12.0004C7.82715 14.3056 9.69586 16.1743 12.001 16.1743Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0006 15.1297C13.7295 15.1297 15.131 13.7281 15.131 11.9992C15.131 10.2703 13.7295 8.86877 12.0006 8.86877C10.2717 8.86877 8.87012 10.2703 8.87012 11.9992C8.87012 13.7281 10.2717 15.1297 12.0006 15.1297Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3692" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1Q(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3663)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.82617 11.9995V23.2531C9.12611 23.7355 10.5322 23.9995 12.0001 23.9995C18.6274 23.9995 24.0001 18.6268 24.0001 11.9995C24.0001 5.37208 7.82617 11.9995 7.82617 11.9995Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0001 0.000366211C10.5322 0.000366211 9.12611 0.264413 7.82617 0.746757V12.0004C7.82617 12.0004 18.4697 12.0004 24.0001 12.0004C24.0001 5.37299 18.6274 0.000366211 12.0001 0.000366211Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3663" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1P(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3664)" }, [
      createElementVNode("path", {
        d: "M0 11.9997C0 13.4676 0.264047 14.8736 0.746391 16.1736L12 16.6954L23.2536 16.1737C23.736 14.8736 24 13.4676 24 11.9997C24 10.5319 23.736 9.12583 23.2536 7.82584L12 7.30408L0.746391 7.8258C0.264047 9.12583 0 10.5319 0 11.9997Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000366211C6.84013 -0.000366211 2.44161 3.25613 0.746094 7.82574H23.2534C21.5578 3.25613 17.1593 -0.000366211 11.9997 -0.000366211Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.2533 16.1747H0.746094C2.44161 20.7442 6.84012 24.0008 11.9997 24.0008C17.1593 24.0008 21.5578 20.7442 23.2533 16.1747Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M15.5864 5.73994L14.1209 5.0506L14.9013 3.63127L13.3099 3.93572L13.1082 2.328L11.9997 3.51042L10.8913 2.328L10.6896 3.93572L9.09821 3.63127L9.87863 5.0506L8.41309 5.73994H15.5864Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3664" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1O(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3665)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.4785 12.0002H24.0002C24.0002 10.9171 23.8559 9.86791 23.5869 8.86975H11.4785V12.0002Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.4785 5.73873H22.239C21.5044 4.54004 20.5652 3.48053 19.4701 2.60828H11.4785V5.73873Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0011 24.0002C14.8253 24.0002 17.4211 23.024 19.471 21.3915H4.53125C6.58114 23.024 9.17694 24.0002 12.0011 24.0002Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M1.76195 18.2601H22.2394C22.8291 17.2978 23.2864 16.2459 23.5873 15.1296H0.414062C0.714859 16.2459 1.17222 17.2978 1.76195 18.2601Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M7.98001 10.2709C6.34117 10.2709 5.01263 8.94229 5.01263 7.30349C5.01263 5.6647 6.34121 4.33612 7.98001 4.33612C8.491 4.33612 8.97179 4.46535 9.39156 4.69279C8.73306 4.04887 7.8325 3.65137 6.8387 3.65137C4.82171 3.65137 3.18652 5.28651 3.18652 7.30354C3.18652 9.32057 4.82171 10.9557 6.8387 10.9557C7.8325 10.9557 8.73306 10.5582 9.39156 9.91429C8.97179 10.1416 8.49104 10.2709 7.98001 10.2709Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M8.81647 5.21729L9.3433 6.31894L10.533 6.04407L10.0002 7.14277L10.9571 7.90153L9.76578 8.17008L9.76911 9.39122L8.81647 8.62725L7.86378 9.39122L7.86706 8.17008L6.67578 7.90153L7.63259 7.14277L7.09977 6.04407L8.28959 6.31894L8.81647 5.21729Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3665" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1N(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3666)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M19.826 6.26099H4.17383V17.7393H19.826V6.26099Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M13.9323 15.3913C12.0594 15.3913 10.541 13.8729 10.541 12C10.541 10.127 12.0594 8.60867 13.9323 8.60867C14.5163 8.60867 15.0658 8.75633 15.5455 9.0163C14.793 8.28032 13.7638 7.82605 12.628 7.82605C10.3229 7.82605 8.4541 9.69477 8.4541 11.9999C8.4541 14.3051 10.3229 16.1738 12.628 16.1738C13.7638 16.1738 14.793 15.7196 15.5455 14.9836C15.0658 15.2436 14.5163 15.3913 13.9323 15.3913Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3666" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1M(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3735)" }, [
      createElementVNode("path", {
        d: "M16.1745 0.745902C14.8745 0.263559 13.4684 -0.000488281 12.0006 -0.000488281C10.5327 -0.000488281 9.12667 0.263559 7.82669 0.745902L6.7832 11.9995L7.82669 23.2531C9.12667 23.7355 10.5327 23.9995 12.0006 23.9995C13.4684 23.9995 14.8745 23.7355 16.1745 23.2531L17.218 11.9995L16.1745 0.745902Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.9999 12.0002C23.9999 6.84067 20.7434 2.44211 16.1738 0.746643V23.2539C20.7434 21.5583 23.9999 17.1598 23.9999 12.0002Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 11.9994C0 17.159 3.2565 21.5575 7.82611 23.2531V0.74585C3.2565 2.44132 0 6.83988 0 11.9994Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3735" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1L(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3736)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 -0.000488281C18.6274 -0.000488281 24 5.37214 24 11.9995C24 18.6269 18.6274 23.9995 12 23.9995",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M8.34725 4.69624V3.13104H6.78205V4.69624H5.2168V6.26145H6.78205V7.82669H8.34725V6.26145H9.91245V4.69624H8.34725Z",
        fill: "#ACABB1"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3736" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1K(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3737)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 9.98611 23.5031 8.08847 22.6265 6.42188L11.9859 12.0141L17.5781 1.37353C15.9115 0.496875 14.0139 0 12 0C5.37262 0 0 5.37262 0 12C0 15.3137 1.34316 18.3137 3.51469 20.4853C5.68627 22.6569 8.68627 24 12 24Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M22.6141 6.43435C22.0648 5.38885 21.3507 4.40724 20.4716 3.52815C19.5925 2.64906 18.611 1.93492 17.5654 1.38568L3.50098 20.4987L22.6141 6.43435Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M3.50098 20.4994L22.6141 6.43501C22.0648 5.38951 21.3507 4.4079 20.4716 3.52881L3.50098 20.4994Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M10.4204 7.03688L8.95485 7.72622L9.73527 9.1456L8.14387 8.84114L7.94221 10.4488L6.83371 9.26635L5.72521 10.4488L5.52365 8.84114L3.93224 9.1455L4.71257 7.72617L3.24707 7.03688L4.71262 6.34749L3.93224 4.9282L5.52355 5.23256L5.72526 3.62494L6.83371 4.80736L7.94221 3.62494L8.14387 5.23256L9.73532 4.9282L8.9549 6.34753L10.4204 7.03688Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3737" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1J(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3738)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.8964 10.4353C23.5654 7.90475 22.4287 5.45947 20.4845 3.51533C18.5404 1.57119 16.095 0.434425 13.5645 0.103394L13.5645 10.4353H23.8964Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M10.4345 0.104065C7.9039 0.435096 5.45857 1.57182 3.51443 3.51596C1.57034 5.46014 0.43357 7.90547 0.102539 10.4361L10.4345 10.4361L10.4345 0.104065Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0.102539 13.5664C0.43357 16.097 1.57034 18.5424 3.51443 20.4865C5.45857 22.4306 7.90385 23.5673 10.4345 23.8984L10.4345 13.5665L0.102539 13.5664Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M13.5645 23.8983C16.095 23.5673 18.5403 22.4306 20.4845 20.4864C22.4286 18.5423 23.5653 16.097 23.8964 13.5664H13.5645V23.8983Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M16.0961 7.61471C16.0961 7.45515 16.2258 7.32545 16.3854 7.32545H17.0053C17.9851 7.32545 18.7823 6.52829 18.7823 5.54846C18.7823 4.56863 17.9852 3.77143 17.0053 3.77143H16.4166C16.2245 3.6271 15.9667 3.53809 15.6824 3.53809C15.0892 3.53809 14.6084 3.9227 14.6084 4.39716C14.6084 4.86704 15.0801 5.24823 15.6652 5.25563L15.665 5.25906H17.0053C17.1649 5.25906 17.2946 5.38881 17.2946 5.54837C17.2946 5.70793 17.1649 5.83763 17.0053 5.83763H16.3854C15.4055 5.83763 14.6084 6.63479 14.6084 7.61462C14.6084 8.59445 15.4055 9.39165 16.3854 9.39165H18.7823V7.90393H16.3854C16.2258 7.90398 16.0961 7.77428 16.0961 7.61471Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.70442 7.61484C6.70442 7.45527 6.83413 7.32557 6.99373 7.32557H7.61361C8.59348 7.32557 9.39069 6.52841 9.39069 5.54858C9.39069 4.56876 8.59353 3.77155 7.61361 3.77155H7.02495C6.83281 3.62722 6.57505 3.53821 6.2907 3.53821C5.69759 3.53821 5.2168 3.92282 5.2168 4.39729C5.2168 4.86716 5.68841 5.24835 6.27359 5.25576L6.27331 5.25918H7.61366C7.77327 5.25918 7.90297 5.38893 7.90297 5.54849C7.90297 5.70805 7.77327 5.83776 7.61366 5.83776H6.99378C6.01391 5.83776 5.2168 6.63491 5.2168 7.61474C5.2168 8.59457 6.01386 9.39177 6.99378 9.39177H9.39064V7.90406H6.99373C6.83413 7.9041 6.70442 7.7744 6.70442 7.61484Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.0961 18.6859C16.0961 18.5264 16.2258 18.3967 16.3854 18.3967H17.0053C17.9852 18.3967 18.7824 17.5995 18.7824 16.6197C18.7824 15.6399 17.9852 14.8427 17.0053 14.8427H16.4167C16.2245 14.6983 15.9667 14.6093 15.6824 14.6093C15.0892 14.6093 14.6084 14.994 14.6084 15.4684C14.6084 15.9383 15.0801 16.3195 15.6652 16.3269L15.665 16.3303H17.0053C17.1649 16.3303 17.2946 16.46 17.2946 16.6196C17.2946 16.7792 17.1649 16.9089 17.0053 16.9089H16.3854C15.4055 16.9089 14.6084 17.706 14.6084 18.6858C14.6084 19.6657 15.4055 20.4629 16.3854 20.4629H18.7823V18.9752H16.3854C16.2258 18.9753 16.0961 18.8455 16.0961 18.6859Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.70447 18.6859C6.70447 18.5264 6.83417 18.3967 6.99378 18.3967H7.61365C8.59353 18.3967 9.39073 17.5995 9.39073 16.6197C9.39073 15.6399 8.59358 14.8427 7.61365 14.8427H7.025C6.83286 14.6983 6.57509 14.6093 6.29075 14.6093C5.69759 14.6093 5.2168 14.994 5.2168 15.4684C5.2168 15.9383 5.68841 16.3195 6.27359 16.3269L6.27331 16.3303H7.61365C7.77326 16.3303 7.90297 16.46 7.90297 16.6196C7.90297 16.7792 7.77326 16.9089 7.61365 16.9089H6.99378C6.01391 16.9089 5.2168 17.706 5.2168 18.6858C5.2168 19.6657 6.01386 20.4629 6.99378 20.4629H9.39068V18.9752H6.99378C6.83417 18.9753 6.70447 18.8455 6.70447 18.6859Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3738" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1I(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3739)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M12.0001 13.8637C10.002 13.8637 8.33275 12.4594 7.9232 10.5842C7.8603 10.8724 7.82617 11.1714 7.82617 11.4786C7.82617 13.7838 9.69484 15.6525 12.0001 15.6525C14.3053 15.6525 16.174 13.7838 16.174 11.4786C16.174 11.1714 16.1398 10.8724 16.0769 10.5841C15.6674 12.4594 13.9982 13.8637 12.0001 13.8637Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0002 8.34778L12.3887 9.54351H13.6461L12.6289 10.2825L13.0174 11.4782L12.0002 10.7392L10.9831 11.4782L11.3716 10.2825L10.3545 9.54351H11.6117L12.0002 8.34778Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3739" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1H(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3740)" }, [
      createElementVNode("path", {
        d: "M1.45898 6.26037L11.9999 7.30386L22.5408 6.26037C20.5056 2.53025 16.5484 -0.000488281 11.9999 -0.000488281C7.45139 -0.000488281 3.49425 2.53025 1.45898 6.26037Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M1.45908 17.7384L12 18.7819L22.5409 17.7384C23.4711 16.0335 24 14.0782 24 11.9993L12 10.9558L0 11.9993C0 14.0782 0.528891 16.0335 1.45908 17.7384Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M1.45908 6.26099C0.528891 7.96588 0 9.92122 0 12.0001H24C24 9.92122 23.4711 7.96588 22.5409 6.26099H12H1.45908Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9999 23.9996C16.5484 23.9996 20.5056 21.4688 22.5408 17.7387H1.45898C3.49425 21.4688 7.45139 23.9996 11.9999 23.9996Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3740" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1G(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("circle", {
      cx: "32",
      cy: "32",
      r: "30",
      fill: "#f5f5f5"
    }),
    createElementVNode("path", {
      d: "M17.8 21.2v-4.1h1.3l.9 3.1l.9-3.1h1.3v4.1h-.8v-3.3l-.9 3.3h-.9l-.9-3.3v3.3h-.9m6.9-3.3l-.6 1.7h1.2l-.6-1.7m-.5-.8h1l1.6 4.1h-.9l-.3-.8h-1.7l-.3.8h-.9l1.5-4.1m5 4.1h-.9v-1.5l-1.6-2.5h1.1l.9 1.8l.9-1.8h1l-1.4 2.5v1.5m2.5-2.1c0 .4.1.8.3 1c.2.2.5.4.9.4s.7-.1.9-.4c.2-.2.3-.6.3-1s-.1-.8-.3-1c-.2-.2-.5-.4-.9-.4s-.7.1-.9.4s-.3.6-.3 1m-.9 0c0-.7.2-1.2.6-1.6c.4-.4.9-.6 1.6-.6c.7 0 1.2.2 1.6.6c.4.4.6.9.6 1.6c0 .7-.2 1.2-.6 1.6c-.4.4-.9.6-1.6.6c-.7 0-1.2-.2-1.6-.6c-.4-.4-.6-.9-.6-1.6m5.9 2.1v-3.3h-1.3v-.7h3.5v.7h-1.3v3.3h-.9m3.6 0v-3.3H39v-.7h3.5v.7h-1.3v3.3h-.9m2.7 0v-4.1h3.2v.7h-2.3v.9H46v.7h-2.1v1h2.4v.8H43",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M22.7 44.7c-1.3.4-3.1 1.3-3.8 1.8c-.2.2-.2.4.1 1.1c.3.5.5.9.6.9c.1 0 .8-.3 1.6-.7c.8-.4 1.8-.9 2.3-1c.4-.1.7-.1.9-.2c.1.2 0 .1.2.4c.2.4.1.4.4.6c.4.1 1.3-.4 1.3-.4c1.1-.4 1.7-.4 5.7-.4s4.6 0 5.7.4c0 0 .9.3 1 .3c.1 0 .2.1.3 0c.1 0 .2-.2.3-.3c0 0 .2-.6.3-.8c.2.1.6.2 1 .4s1.4.6 2.2 1c.8.4 1.5.7 1.6.7c0 0 .3-.4.6-.9c.5-1 .6-.9-1.3-1.9c-2.5-1.3-4.9-1.9-5.2-1.2c0 .1-.1.2-.1.3c-.2-.1-.9-.2-1.5-.3c-2-.4-7.5-.4-9.5 0c-.6.1-1.1.3-1.5.4c-.2-.4-.2-.2-.2-.4c-.3-.4-1.4-.3-3 .2",
      fill: "#3e4347"
    }),
    createElementVNode("g", { fill: "#dfdfdf" }, [
      createElementVNode("path", { d: "M24.8 44.4c-.9 0-2.6.6-4.4 1.5c-1.5.7-1.5.8-1.1 1.6c.2.4.4.7.4.7c.1 0 .7-.3 1.5-.7c.8-.4 1.8-.8 2.3-1c.3-.1.6-.1.9-.2l-.2-.6c.2-.6.7-1.1 1.2-1.2c-.3 0-.4-.1-.6-.1" }),
      createElementVNode("path", { d: "M31.8 44.5c-1.8 0-3.5.1-4.3.2c-1.4.2-2.1.7-2.6.9c-.2.1-.3.2-.5.3c.2.4.2.6.3.9c.1.3.1.5.5.6c.4 0 1.2-.4 1.2-.4c1.1-.4 1.7-.4 5.7-.4s4.8.1 5.7.4c.7.2.9.4 1.2.4c.1 0 .2-.2.3-.5c.1-.3.3-.8.4-1.3c-.2 0-.1.1-.4-.1c-.6-.3-.7-.3-1.1-.5c-.5-.2-.9-.2-1.6-.3c-.8-.1-2.7-.2-4.5-.2h-.3" }),
      createElementVNode("path", { d: "M39.2 44.5h-.3c.2.1.4.3.5.4c.4.2.4.5.4.9c0 .2 0 .3-.1.5c.2.1.6.2.9.4c.4.1 1.4.6 2.3 1c.8.4 1.4.7 1.5.7c0 0 .2-.4.4-.7c.3-.5.3-.7.1-.9c-.5-.4-2.4-1.3-3.7-1.7c-1-.5-1.6-.6-2-.6" }),
      createElementVNode("path", { d: "M38.6 44.6c-.1.1-.1.2-.1.3c.1 0 .6.3.9.3h.1s-.1-.1-.3-.2c-.2-.1-.4-.3-.6-.4" }),
      createElementVNode("path", { d: "M25.4 44.6c-.1.1-.4.3-.5.4c-.3.2-.3.3-.4.6c0 0 .2-.2.7-.4c.4-.2.2-.1.5-.2c-.2-.2-.3-.2-.3-.4" })
    ]),
    createElementVNode("path", {
      d: "M26.1 24.8c-.5.2-.7.6-.8 1.1c0 .5.1.9.4 1.2l.3.3s-.1.2-.2.3c-.3.3-.5.7-.5 1.1c0 .4.1.7.5 1l.3.3l-.3.3c-.6.7-.6 1.4 0 2l.3.3h12.2l.3-.3c.6-.6.6-1.3 0-2l-.4-.4l.3-.3c.6-.7.6-1.4 0-2.1c-.3-.3-.3-.4-.1-.5c.4-.2.6-1 .4-1.5c-.2-.7-1.3-1.2-1.9-.9c-.1.1-.3.2-.5.4c-.2.1-.3.3-.4.3c0 0-.2-.1-.3-.3c-.6-.5-1.4-.5-2 .1l-.2.2l-.3-.3c-.6-.6-1.4-.6-2.1.1l-.2.2l-.3-.2c-.4-.4-.6-.5-1.1-.5c-.4 0-.8.2-1.1.5l-.2.2l-.3-.3c-.7-.6-1.2-.6-1.8-.3",
      fill: "#2a5f9e"
    }),
    createElementVNode("path", {
      d: "M25.7 33.1c-.6.7-.6 1.4 0 2.1l.2.3l-.3.3c-.1.2-.3.4-.4.5c-.2.5-.1 1.2.4 1.5c.2.2.3.3 0 .6c-.1.1-.2.3-.3.4c-.5.9.2 2.1 1.3 2.1c.4 0 .8-.1 1-.4c.2-.2.4-.3.6 0c.3.3.7.5 1 .5c.4 0 .6-.1 1-.5l.3-.3l.3.3c.6.6 1.2.7 2 .1l.3-.2l.3.3c.4.3.6.4 1 .4s.6-.1 1-.5l.3-.3l.3.2c.5.4.8.6 1.1.6c.4 0 .6-.1 1-.5c.4-.3.5-.7.5-1c0-.3-.3-.9-.6-1.1l-.2-.2l.3-.3c.6-.7.6-1.3 0-2.1l-.3-.3l.3-.3c.6-.7.6-1.4 0-2l-.3-.3H25.6l.1.1",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M24.4 32.2v8.4c0 .3.2.4.5.7c.5.4 1 .8 3.7.5c2.5 0 3 .2 3.3 1.2l.1.6l.1-.6c.2-1 .8-1.2 3.2-1.2c3.1 0 3.4-.1 3.8-.5c0 0 .3-.2.4-.5c.1-.3 0-.5 0-.5V23.7H24.4v8.5m15 .1v7c0 .9.1 1.2 0 1.4c-.1.2-.3.4-.3.4c-.5.5-.9.6-3 .5c-1.4 0-2.1 0-3.2.2c-.2.2-.6.1-.9 1c-.3-.9-.5-.9-.5-.9c-1.2-.5-1.7-.4-3.5-.4c-1.2.2-2.5-.1-3-.5c0 0-.1 0-.4-.4V23.8h14.8v8.5",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      d: "M30.9 29.4c.8.5 2.1.4 2.8-.4c.3-.3.4-.8.5-1c.1-.2.1-.3.1-.5c.1.2.2.3.2.7c.1.5 0 .9-.2 1.3c-.6 1.6-2.6 2.1-3.8.9c-.6-.5-1.1-1.6-.8-2.3c.1-.2.1-.4.2-.6c0 .2 0 .4.2.8c.2.5.5.8.8 1.1",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M29 35.7c0 .4 0 .6.1.8c-.2-.2-.4-.3-.6-.5c-.3-.2-.8-.4-.9-.1c-.1.2.3.5.6.7c.3.2.5.2.8.3c-.2.1-.4.2-.7.3c-.3.2-.7.5-.5.8c.2.2.6 0 .9-.2c.2-.1.5-.4.6-.5c0 .2-.1.5-.1.8c0 .4.1.8.4.8c.3 0 .4-.5.4-.9s0-.6-.1-.8c.1.1.3.3.6.5c.2.2.7.4.9.2c.2-.2-.1-.5-.5-.8c-.3-.2-.5-.3-.7-.4c.2-.1.4-.1.8-.3c.5-.3.7-.5.6-.8c-.1-.2-.4-.1-.9.2c-.2.2-.5.4-.6.5c0-.2.1-.6.1-.8c0-.4-.1-.9-.3-.9c-.8.2-.8.6-.9 1.1",
      fill: "#ffce31"
    }),
    createElementVNode("path", {
      d: "M29.8 36.9c0 .2-.2.4-.4.4s-.4-.2-.4-.4s.2-.4.4-.4s.4.2.4.4",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M34.3 35.7c0 .4 0 .6.1.8c-.2-.2-.4-.3-.6-.5c-.3-.2-.8-.4-.9-.1c-.1.2.3.5.6.7c.3.2.5.2.8.3c-.2.1-.4.2-.7.3c-.3.2-.7.5-.5.8c.2.2.6 0 .9-.2c.2-.1.5-.4.6-.5c0 .2-.1.5-.1.8c0 .4.1.8.3.8c.3 0 .4-.5.4-.9s0-.6-.1-.8c.1.1.3.3.6.5c.2.2.7.4.9.2c.2-.2-.1-.5-.5-.8c-.3-.2-.5-.3-.7-.4c.2-.1.4-.1.8-.3c.5-.3.7-.5.6-.8c-.1-.2-.4-.1-.9.2c-.2.2-.5.4-.6.5c0-.2.1-.6.1-.8c0-.4-.1-.9-.3-.9c-.8.2-.8.6-.8 1.1",
      fill: "#ffce31"
    }),
    createElementVNode("path", {
      d: "M35 36.9c0 .2-.2.4-.4.4s-.4-.2-.4-.4s.2-.4.4-.4s.4.2.4.4",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M23.4 34.7c-.4-1.8-1.4-3.2-2.7-4h1.1l1.5-.1l-1.3-.8c-.4-.2-1.4-1.1-1.4-1.8c0-.2 0-.4.4-.7l.9-.7l-1-.1l.4-1l-1.1.3l-.1-1l.4-.3l-.9-.8l-.8-.1l-.9.4l-.3-.8l-.5.8l-.6-.8l-.3 1.2l-.7-.4l-.2 1l-1-.8l.1 1.6l-1.5-.3l.4 1.2l-1.3-.1l1 1.9l-1.2.7l1.7 1.7v.5l-3.5-.8l2.1 2.1l-.6 2.1l2.4.2l-.9 1.8l2.9-.7l.7 1.9c-.1 0-.3-.1-.4-.1c-1.6 0-3 2.5-3 3.9s2.4 3.8 4.8 3.8c1 0 1.9-.4 2.7-1.2c2.5-2.4 3.5-6.2 2.7-9.7M18 36.4c.6.6 1.8 2 1.9 4.1c0 .7-.4 1.6-1.1 2.4c-.5.5-.9.7-1.1.7c-1.9-.4-2.9-1.2-2.8-2.4c.1-.9.7-1.5.9-1.5c.4 0 .4.1.4.5c0 .2.1.5.4.7l.2.1h.1c.4 0 .7-.3.9-.7c.2-.5.2-1.2-.4-1.8c-.2-.2-.4-.3-.6-.4l1.2-1.7",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      d: "M18.9 24.3l-1.3.5l-.1-.3l-.3.5l-.4-.5l-.2.8l-.7-.4l-.2 1.1l-.8-.6l.1 1.2l-1.4-.2l.3 1.1l-1.1-.1l.8 1.5l-1 .6l1.4 1.4l.1 1.3l-2.4-.6l1 1.1l-.5 1.8l2.5.2l-.8 1.6l2.3-.6l.6 1.6l1.1-1.5s2.4 1.6 2.5 4.8c0 1.8-1.9 3.8-2.8 3.6c-5-1-2.9-4.9-1.8-4.9c1.2 0 .8 1.1 1 1.2c.4.2.9-.8.2-1.6c-1.4-1.4-3.4 1.4-3.4 3.1c0 1.4 3.8 5.1 6.6 2.3c4.3-4.3 3.5-12.1-.9-13.4c-4.4-1.3-3.3-3.2-3.3-3.2c.5 3.2 5.6 2.8 5.6 2.8s-2.6-2-.9-3.5h-.5l.3-.6l-.7.2l-.1-.9l-.5.5l-.8-.2l-.2-.5l1.5-1l-.3-.2h-.5",
      fill: "#dfdfdf"
    }),
    createElementVNode("path", {
      d: "M43.4 44.5c.8.8 1.7 1.2 2.7 1.2c2.4 0 4.8-2.4 4.8-3.8c0-1.5-1.4-3.9-3-3.9c-.1 0-.3 0-.4.1l.7-1.9l2.9.7l-1-1.9l2.4-.2l-.5-2.1l2.1-2.1l-3.5.8v-.5l1.7-1.7l-1.2-.7l1-1.9l-1.3.1l.4-1.2l-1.5.3l.1-1.6l-1 .8l-.2-1l-.8.4l-.3-1.2l-.6.8l-.5-.8l-.3.8l-.9-.4l-.8.1l-.9.8l.4.3l-.1 1l-1.1-.3l.4 1l-1 .1l.9.7c.4.3.4.5.4.7c0 .7-1.1 1.5-1.4 1.8l-1.2.8l1.5.1h1.1c-1.3.8-2.2 2.2-2.7 4c-.9 3.5.1 7.3 2.7 9.8m3.8-6.5c-.2.1-.4.2-.6.4c-.6.6-.6 1.3-.4 1.8c.2.4.5.7.9.7h.1l.2-.1c.3-.1.4-.5.4-.7c0-.4.1-.5.4-.5c.2 0 .9.6.9 1.5c.1 1.2-.9 2-2.8 2.4c-.2 0-.7-.2-1.1-.7c-.7-.7-1.1-1.7-1.1-2.4c.1-2.1 1.3-3.5 1.9-4.1l1.2 1.7",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      d: "M45.1 24.3h-.5l-.2.2l1.5 1l-.3.5l-.8.2l-.5-.5l-.1.9l-.7-.2l.3.6h-.5c1.7 1.4-1.1 3.3-1.1 3.3s5.2.4 5.6-2.8c0 0 1.1 1.9-3.3 3.2c-4.4 1.4-5.2 9.1-.9 13.4c2.9 2.9 6.6-.9 6.6-2.3c0-1.7-2-4.4-3.4-3.1c-.7.7-.2 1.7.2 1.6c.2-.1-.1-1.2 1-1.2c1.2 0 3.3 3.9-1.8 4.9c-.9.2-2.9-1.8-2.8-3.6c.1-3.1 2.5-4.8 2.5-4.8l1.1 1.5l.6-1.6l2.3.6l-.8-1.6l2.5-.2l-.5-1.8l1-1.1l-2.4.6l.1-1.3l1.4-1.4l-1-.6l.8-1.5l-1.1.1l.3-1.1l-1.2.3l.1-1.2l-.8.6l-.2-1.1l-.7.4l-.2-.8l-.4.6l-.3-.5l-.1.3l-1.3-.5",
      fill: "#dfdfdf"
    })
  ]);
}
function render$1F(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3741)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9994 11.9997C23.9994 7.24218 21.2307 3.13143 17.2168 1.19043V22.8089C21.2307 20.868 23.9994 16.7572 23.9994 11.9997Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 11.9997C0 16.7572 2.76867 20.868 6.78262 22.809V1.19043C2.76867 3.13143 0 7.24218 0 11.9997Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M8.87012 11.9992C8.87012 13.7281 10.2717 15.1297 12.0006 15.1297C13.7295 15.1297 15.131 13.7281 15.131 11.9992V10.9557H8.87012V11.9992Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M16.1731 9.91336H13.0426C13.0426 9.33708 12.5754 8.86987 11.9991 8.86987C11.4229 8.86987 10.9557 9.33708 10.9557 9.91336H7.8252C7.8252 10.4897 8.32718 10.9568 8.90342 10.9568H8.86868C8.86868 11.5332 9.33584 12.0003 9.91217 12.0003C9.91217 12.5766 10.3793 13.0438 10.9557 13.0438H13.0426C13.619 13.0438 14.0861 12.5766 14.0861 12.0003C14.6624 12.0003 15.1296 11.5332 15.1296 10.9568H15.0948C15.6711 10.9568 16.1731 10.4897 16.1731 9.91336Z",
        fill: "#FF9811"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3741" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1E(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3742)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.001 5.21741L12.519 6.81172H14.1954L12.8392 7.79708L13.3572 9.39134L12.001 8.40603L10.6448 9.39134L11.1629 7.79708L9.80664 6.81172H11.483L12.001 5.21741Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.21777 11.9997L6.81209 11.4816V9.80518L7.79745 11.1615L9.39171 10.6434L8.4064 11.9997L9.39171 13.3558L7.79745 12.8377L6.81209 14.1939V12.5176L5.21777 11.9997Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0011 18.7829L11.4831 17.1886H9.80664L11.1629 16.2033L10.6449 14.609L12.0011 15.5943L13.3572 14.609L12.8392 16.2033L14.1954 17.1886H12.5191L12.0011 18.7829Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M18.7833 11.9995L17.189 12.5176V14.1939L16.2036 12.8377L14.6094 13.3557L15.5947 11.9995L14.6094 10.6434L16.2036 11.1615L17.189 9.80518V11.4816L18.7833 11.9995Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3742" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1D(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3667)" }, [
      createElementVNode("path", {
        d: "M17.2175 1.19133C15.6399 0.428485 13.87 0.000610352 12.0001 0.000610352C10.1303 0.000610352 8.36037 0.428485 6.78274 1.19133L5.73926 12.0006L6.78274 22.8099C8.36037 23.5727 10.1303 24.0006 12.0001 24.0006C13.87 24.0006 15.6399 23.5727 17.2175 22.8099L18.261 12.0006L17.2175 1.19133Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M6.78262 1.19214C2.76872 3.13309 0 7.24351 0 12.001C0 16.7585 2.76872 20.8689 6.78262 22.8099V1.19214Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M17.2178 1.19214V22.8099C21.2317 20.8689 24.0004 16.7585 24.0004 12.001C24.0004 7.24351 21.2317 3.13309 17.2178 1.19214Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.174 9.44228H13.3044C13.3044 8.72191 12.7204 8.13794 12.0001 8.13794C11.2797 8.13794 10.6957 8.72191 10.6957 9.44228H7.82617C7.82617 10.1515 8.44403 10.7265 9.1532 10.7265H9.11045C9.11045 11.4358 9.68542 12.0108 10.3947 12.0108C10.3947 12.6388 10.8458 13.1606 11.4415 13.2722L10.4294 15.5569C10.9143 15.754 11.4443 15.8636 12.0001 15.8636C12.5558 15.8636 13.0858 15.754 13.5707 15.5569L12.5587 13.2722C13.1544 13.1606 13.6054 12.6388 13.6054 12.0108C14.3147 12.0108 14.8897 11.4358 14.8897 10.7265H14.8469C15.5561 10.7265 16.174 10.1515 16.174 9.44228Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M12.0003 11.2178L10.3047 12.0004V13.5656L12.0003 14.6091L13.696 13.5656V12.0004L12.0003 11.2178Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M13.696 10.4341H10.3047V11.9993H13.696V10.4341Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3667" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1C(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3668)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3668" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1B(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3669)" }, [
      createElementVNode("path", {
        d: "M11.9994 24.0006C13.4672 24.0006 14.8733 23.7366 16.1733 23.2542L16.695 12.0006L16.1733 0.747001C14.8733 0.264657 13.4672 0.000610352 11.9994 0.000610352C10.5315 0.000610352 9.12541 0.264657 7.82548 0.747001L7.30371 12.0006L7.82543 23.2542C9.12541 23.7366 10.5315 24.0006 11.9994 24.0006Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0 12.0001C0 17.1596 3.2565 21.5582 7.82611 23.2537V0.74646C3.2565 2.44198 0 6.84049 0 12.0001Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M16.1738 0.745972V23.2532C20.7434 21.5577 23.9999 17.1592 23.9999 11.9996C23.9999 6.84 20.7434 2.44149 16.1738 0.745972Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M6.78274 11.9989H5.73926V16.1728H6.78274V11.9989Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M2.60891 11.9989H1.56543V16.1728H2.60891V11.9989Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.17434 14.6085C4.75064 14.6085 5.21783 14.1413 5.21783 13.565C5.21783 12.9887 4.75064 12.5215 4.17434 12.5215C3.59804 12.5215 3.13086 12.9887 3.13086 13.565C3.13086 14.1413 3.59804 14.6085 4.17434 14.6085Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.17406 10.4336C4.4622 10.4336 4.69578 10.2 4.69578 9.91185C4.69578 9.62372 4.4622 9.39014 4.17406 9.39014C3.88593 9.39014 3.65234 9.62372 3.65234 9.91185C3.65234 10.2 3.88593 10.4336 4.17406 10.4336Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.21783 15.1288H3.13086V16.1723H5.21783V15.1288Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.21783 10.9551H3.13086V11.9986H5.21783V10.9551Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.17458 6.26001L4.54414 7.3972H5.73983L4.77256 8.10004L5.14184 9.23723L4.17458 8.53439L3.20736 9.23723L3.57664 8.10004L2.60938 7.3972H3.80506L4.17458 6.26001Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3669" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1A(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3670)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M24 11.9997C24 7.88122 21.9249 4.24775 18.7635 2.08667H5.23655C2.07516 4.24775 0 7.88122 0 11.9997C0 16.1183 2.07516 19.7517 5.23655 21.9127H18.7635C21.9249 19.7517 24 16.1183 24 11.9997Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M9.3916 8.87015H14.609V6.78323L13.5655 7.30495L12.0003 5.73975L10.4351 7.30495L9.3916 6.78323V8.87015Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.6961 12.0003H14.0884C14.1907 11.8234 14.2501 11.6187 14.2501 11.3997C14.2501 10.7347 13.711 10.1957 13.0461 10.1957C12.5867 10.1957 12.1877 10.4531 11.9846 10.8314C11.7816 10.4531 11.3826 10.1957 10.9232 10.1957C10.2583 10.1957 9.71917 10.7347 9.71917 11.3997C9.71917 11.6188 9.7787 11.8235 9.88089 12.0003H7.30469C7.30469 12.7983 7.9997 13.4451 8.79761 13.4451H8.74952C8.74952 14.0996 9.18484 14.6523 9.7817 14.8298L8.60903 16.0026L9.7158 17.1093L11.2858 15.5393C11.3473 15.5619 11.4109 15.5799 11.4767 15.5923L10.528 17.7342C10.9826 17.9191 11.4794 18.0217 12.0004 18.0217C12.5214 18.0217 13.0182 17.9191 13.4729 17.7342L12.5242 15.5923C12.5899 15.5799 12.6535 15.5619 12.715 15.5393L14.285 17.1093L15.3917 16.0026L14.219 14.8298C14.8158 14.6522 15.2512 14.0997 15.2512 13.4451H15.203C16.001 13.4451 16.6961 12.7983 16.6961 12.0003Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0003 12.7828L10.3047 13.5654V15.1307L12.0003 16.1741L13.696 15.1307V13.5654L12.0003 12.7828Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M13.696 11.9991H10.3047V14.0861H13.696V11.9991Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3670" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1z(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3671)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 11.9997H11.9999C11.9999 11.9889 11.9999 11.9784 11.9999 11.9675C11.9892 11.9783 11.9785 11.989 11.9678 11.9997Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26123C12 4.14974 12 2.76623 12 0.000366211H11.998C5.37145 0.00149121 0 5.3736 0 12.0004H6.26086V8.47485L9.78637 12.0004H11.9679C11.9786 11.9897 11.9893 11.979 12 11.9683C12 11.1598 12 10.4384 12 9.78683L8.47443 6.26123H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56543C4.19441 2.63413 2.63409 4.19441 1.56543 6.07124V12.0002H4.69588V4.69598V4.69588H12.0002C12.0002 3.70856 12.0002 2.76796 12.0002 1.56543H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0009 10.5242L7.73734 6.26074H6.26172V6.26084L12.0008 11.9998H12.0009C12.0009 11.9998 12.0009 10.9823 12.0009 10.5242Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.5654 6.2605V11.9996C13.5654 14.7952 17.2176 15.6518 17.2176 15.6518C17.2176 15.6518 20.8698 14.7952 20.8698 11.9996V6.2605H13.5654Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M13.5654 11.9991C13.5654 14.7948 17.2176 15.6514 17.2176 15.6514C17.2176 15.6514 20.8698 14.7948 20.8698 11.9991H13.5654Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M18.7828 8.86909H17.7393V7.82556H16.6958V8.86909H15.6523V9.91253H16.6958V13.0429H17.7393V9.91253H18.7828V8.86909Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3671" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1y(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3672)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M19.0924 9.84775H13.6749L12.0008 4.69543L10.3267 9.84775H4.90918L9.29204 13.0321L7.6179 18.1845L12.0008 15.0002L16.3837 18.1846L14.7096 13.0321L19.0924 9.84775ZM10.5187 12.6335L11.0848 10.8912H12.9167L13.4829 12.6335V12.6335L12.0008 13.7103L10.5188 12.6335L10.5187 12.6335ZM12.5777 9.84775H11.4239L12.0008 8.07212L12.5777 9.84775ZM14.3705 11.9886L14.0139 10.8912H15.8809L14.3705 11.9886ZM9.98766 10.8912L9.63109 11.9886L8.12063 10.8912H9.98766ZM9.60273 15.4526L10.1797 13.6771L11.1132 14.3552L9.60273 15.4526ZM12.8884 14.3553L13.8219 13.6771L14.3989 15.4527L12.8884 14.3553Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3672" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1x(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3673)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.48568 16.6959L3.51465 20.4852C5.68609 22.6569 8.68576 24.0003 11.9995 24.0003C16.9603 24.0003 21.2172 20.9895 23.0447 16.6959H6.48568Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.0634 7.34841C21.2461 3.03164 16.9771 0.000610352 11.9995 0.000610352C8.68576 0.000610352 5.68609 1.344 3.51465 3.51572L6.51981 7.34841H23.0634Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M2.6084 8.82593V15.1302H23.5864C23.8555 14.1322 23.9997 13.083 23.9997 11.9998C23.9997 10.901 23.8517 9.83693 23.575 8.82593H2.6084Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51428C-1.17157 8.20056 -1.17157 15.7986 3.51471 20.4849C5.45126 18.5484 7.31374 16.6859 12 11.9996L3.51471 3.51428Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M4.85694 8.86938L5.6339 11.2608H8.14855L6.11427 12.7388L6.89118 15.1303L4.85694 13.6523L2.82262 15.1303L3.59971 12.7388L1.56543 11.2608H4.0799L4.85694 8.86938Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M7.13101 11.9991H2.58301V14.0861H7.13101V11.9991Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.99252 9.60729L7.25466 8.86938L4.8571 11.2669L2.45954 8.86938L1.72168 9.60729L4.12135 12.0027L1.72168 14.4024L2.45954 15.1303L4.8571 12.737L7.25466 15.1303L7.99252 14.4024L5.59285 12.0027L7.99252 9.60729Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3673" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1w(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3675)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M3.51451 20.4849C4.0179 20.9883 4.55499 21.4372 5.11838 21.8325L21.8326 5.11826C21.4374 4.55487 20.9884 4.01778 20.485 3.51439C19.9816 3.011 19.4445 2.56212 18.8811 2.16687L2.16699 18.8811C2.5622 19.4444 3.01112 19.9815 3.51451 20.4849Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M3.51526 3.51478C-0.270555 7.30059 -0.997306 12.9862 1.33346 17.5022L17.5026 1.33307C12.9866 -0.997692 7.30098 -0.270848 3.51526 3.51478Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M20.4854 20.4847C24.2711 16.699 24.9979 11.0134 22.6672 6.49731L6.49805 22.6665C11.014 24.9972 16.6996 24.2705 20.4854 20.4847Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M9.91356 6.78182L8.56891 7.41431L9.28497 8.71659L7.82486 8.43731L7.6398 9.91223L6.6228 8.8274L5.60575 9.91223L5.42078 8.43731L3.96063 8.71654L4.67664 7.41426L3.33203 6.78182L4.67669 6.14929L3.96063 4.8471L5.42073 5.12638L5.6058 3.65137L6.6228 4.73624L7.63984 3.65137L7.82486 5.12638L9.28497 4.8471L8.569 6.14934L9.91356 6.78182Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3675" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1v(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3676)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0012 -0.000488281C5.72536 -0.000488281 0.575766 4.81737 0.046875 10.956H23.9555C23.4266 4.81737 18.277 -0.000488281 12.0012 -0.000488281Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0002 24.0001C18.276 24.0001 23.4256 19.1822 23.9545 13.0436H0.0458984C0.574789 19.1822 5.72438 24.0001 12.0002 24.0001Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M9.91361 16.1745L8.56895 16.807L9.28497 18.1092L7.82486 17.8299L7.63984 19.3049L6.6228 18.2201L5.6058 19.3049L5.42078 17.8299L3.96063 18.1092L4.67669 16.807L3.33203 16.1745L4.67673 15.542L3.96063 14.2398L5.42073 14.5191L5.60584 13.0441L6.6228 14.1289L7.63989 13.0441L7.82486 14.5191L9.28502 14.2398L8.569 15.542L9.91361 16.1745Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3676" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1u(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3677)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9292 13.3041C23.9292 13.304 23.9293 13.3039 23.9293 13.3037L10.7693 0.0621338C10.1757 0.122649 9.59475 0.226431 9.02986 0.37029C3.83897 1.69193 0 11.9997 0 11.9997C0 11.9997 16.7999 23.242 18.7165 21.9449C19.1 21.6854 19.4677 21.4043 19.8177 21.1034L12.0185 13.3041H23.9292Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M20.8695 11.9995L9.19899 0.328979C3.92288 1.59071 0 6.33662 0 11.9995C0 18.6269 5.37263 23.9995 12 23.9995C14.5139 23.9995 16.8467 23.226 18.7748 21.9047L8.86955 11.9995H20.8695Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.4126 17.7174L9.94704 17.028L10.7275 15.6087L9.13605 15.9131L8.9344 14.3054L7.82595 15.4878L6.71749 14.3054L6.51579 15.9131L4.92443 15.6086L5.70485 17.028L4.23926 17.7174L5.70485 18.4067L4.92443 19.826L6.51588 19.5216L6.71745 21.1292L7.82595 19.9468L8.9344 21.1292L9.13605 19.5216L10.7274 19.8261L9.94699 18.4067L11.4126 17.7174Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.4342 6.6549L9.36828 6.15357L9.93589 5.12124L8.77841 5.34268L8.63174 4.17334L7.82553 5.03335L7.01933 4.17334L6.87261 5.34268L5.71512 5.12124L6.28278 6.15357L5.2168 6.6549L7.82553 7.17671L10.4342 6.6549Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.9572 6.65527C10.9572 8.38416 9.55563 9.78572 7.82674 9.78572C6.09785 9.78572 4.69629 8.38416 4.69629 6.65527",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3677" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1t(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3678)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000488281C6.84013 -0.000488281 2.44161 3.25601 0.746094 7.82562H23.2534C21.5578 3.25601 17.1593 -0.000488281 11.9997 -0.000488281Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0004C17.1593 24.0004 21.5578 20.7439 23.2533 16.1743H0.746094C2.44161 20.7439 6.84012 24.0004 11.9997 24.0004Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3678" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1s(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M32 62c13.1 0 24.2-8.3 28.3-20H3.7C7.8 53.7 18.9 62 32 62z",
      fill: "#83bf4f"
    }),
    createElementVNode("path", {
      d: "M32 2C18.9 2 7.8 10.4 3.7 22h56.6C56.2 10.4 45.1 2 32 2z",
      fill: "#2a5f9e"
    }),
    createElementVNode("path", {
      d: "M60.3 42c1.1-3.1 1.7-6.5 1.7-10s-.6-6.9-1.7-10H3.7C2.6 25.1 2 28.5 2 32s.6 6.9 1.7 10h56.6z",
      fill: "#ed4c5c"
    }),
    createElementVNode("circle", {
      cx: "24",
      cy: "32",
      r: "17.7",
      fill: "#ffe62e"
    }),
    createElementVNode("path", {
      d: "M24 14c-9.9 0-18 8.1-18 18s8.1 18 18 18s18-8.1 18-18s-8.1-18-18-18M6.6 32c0-9.5 7.6-17.2 17-17.4v3.9c-1.1.5-1.9.9-2.1 1.9c0 .1-.1 1.4-.1 1.8c0 0 .2 0 .6-.3c.2-.2.8-.3 1.6-.7v2c-1.2.2-2 1.2-2 2.4s.9 2.2 2 2.4v.5c-.9 0-1.7-.3-2.4-1.7c-.4-.8-1.4-2-1.4-2s.5 1.3.5 2.7c.1 2 1.9 2.2 3.2 2.2v.4H21v.7h2.6v.4c-1.2.1-2 .7-2 1.5s.9 1.4 2 1.5v.4H21v.4h2.6v.4c-2 .1-3 .9-3.1 2.1c-.2 2.5-.7 4.5-.7 4.5s.8-.9 1.6-3.1c.4-1 1.3-1.6 2.2-1.8v.3c-.9.2-1.6 1.4-1.6 2.8s.7 2.6 1.6 2.8v.8c-1.2 0-2.4.3-3 .8c-.8.7-2.8 2.6-3.6 3.4c-6.1-2.7-10.4-8.8-10.4-16m24 16.1c-.7-.8-2.5-2.7-3.6-3.5c-.6-.5-1.6-.7-2.6-.8V43c.9-.2 1.6-1.4 1.6-2.8s-.7-2.6-1.6-2.8v-.3c.9.1 1.8.8 2.2 1.8c.9 2.2 1.6 3.1 1.6 3.1s-.5-2-.7-4.5c-.1-1.2-1.1-2-3.1-2.1V35H27v-.7h-2.6v-.4c1.2-.1 2-.7 2-1.5s-.9-1.4-2-1.5v-.4H27v-.7h-2.6v-.4c1.4 0 3.1-.2 3.2-2.2c.1-1.4.5-2.7.5-2.7s-1 1.2-1.4 2c-.7 1.4-1.5 1.7-2.4 1.7v-.5c1.2-.2 2-1.2 2-2.4s-.9-2.2-2-2.4v-2.5c.7-.6 1.5-1.5 2.3-2.9c.4-.8.2-1.1.2-1.1s0 .1-.3.3c-.7.6-1.5 1-2.2 1.4v-3.5c9.4.2 17 7.9 17 17.4c.1 7.3-4.4 13.5-10.7 16.1",
      fill: "#3e4347"
    })
  ]);
}
function render$1r(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3679)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.0004H11.9999C11.9999 11.9896 11.9999 11.9791 11.9999 11.9683C11.9892 11.979 11.9785 11.9897 11.9678 12.0004Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.3715 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78642 12H11.9679C11.9786 11.9893 11.9894 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56494C4.19441 2.63364 2.63413 4.19393 1.56543 6.07075V11.9997H4.69588V4.69549V4.69539H12.0002C12.0002 3.70807 12.0002 2.76747 12.0002 1.56494H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0008 10.5247L7.73739 6.26123C7.73739 6.26123 6.26172 6.26132 6.26172 6.26123V6.26132L12.0008 12.0003H12.0008C12.0008 12.0003 12.0008 10.9828 12.0008 10.5247Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.7808 8.90466L21.0398 9.70182H21.878L21.1999 10.1945L21.4589 10.9916L20.7808 10.499L20.1027 10.9916L20.3617 10.1945L19.6836 9.70182H20.5218L20.7808 8.90466Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M17.7854 14.6436L18.174 15.8393H19.4312L18.414 16.5783L18.8026 17.774L17.7854 17.035L16.7682 17.774L17.1568 16.5783L16.1396 15.8393H17.3969L17.7854 14.6436Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M17.8988 5.25183L18.2226 6.24834H19.2703L18.4226 6.86405L18.7464 7.86051L17.8988 7.24463L17.0512 7.86051L17.3749 6.86405L16.5273 6.24834H17.575L17.8988 5.25183Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.0149 8.86987L15.4034 10.0657H16.6607L15.6435 10.8046L16.0321 12.0003L15.0149 11.2613L13.9977 12.0003L14.3863 10.8046L13.3691 10.0657H14.6264L15.0149 8.86987Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3679" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1q(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3680)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 -0.000244141C7.24316 -0.000244141 3.13241 2.76843 1.19141 6.78238H22.8099C20.869 2.76843 16.7582 -0.000244141 12.0007 -0.000244141Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.0007 24.001C16.7582 24.001 20.869 21.2323 22.81 17.2184H1.19141C3.13241 21.2323 7.24316 24.001 12.0007 24.001Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M11.9998 8.34766C9.9828 8.34766 8.34766 9.9828 8.34766 11.9998C8.34766 14.0169 9.9828 15.652 11.9998 15.652C14.0169 15.652 15.652 14.0169 15.652 11.9998C15.652 9.9828 14.0169 8.34766 11.9998 8.34766ZM11.9998 14.0868C10.8473 14.0868 9.91286 13.1525 9.91286 11.9998C9.91286 10.8472 10.8472 9.91286 11.9998 9.91286C13.1524 9.91286 14.0868 10.8472 14.0868 11.9998C14.0868 13.1525 13.1524 14.0868 11.9998 14.0868Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M13.8071 12.5222L11.9997 12.0005L10.1923 12.5222L9.58984 13.5657H14.4095L13.8071 12.5222Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9998 9.39136L10.7949 11.4783L11.9998 12L13.2048 11.4783L11.9998 9.39136Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M10.1924 12.5211H13.8072L13.2047 11.4777H10.7949L10.1924 12.5211Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3680" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1p(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3681)" }, [
      createElementVNode("path", {
        d: "M1.19072 6.78213C0.427875 8.35976 0 10.1296 0 11.9995C0 13.8694 0.427875 15.6393 1.19072 17.2169L12 18.2604L22.8093 17.2169C23.5721 15.6393 24 13.8694 24 11.9995C24 10.1296 23.5721 8.35976 22.8093 6.78213L12 5.73865L1.19072 6.78213Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.19043 17.2183C3.13134 21.2322 7.24176 24.0009 11.9993 24.0009C16.7568 24.0009 20.8672 21.2322 22.8081 17.2183H1.19043Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M1.19043 6.78238H22.8081C20.8672 2.76843 16.7568 -0.000244141 11.9993 -0.000244141C7.24181 -0.000244141 3.13134 2.76843 1.19043 6.78238Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M11.9991 16.1742C14.3043 16.1742 16.173 14.3055 16.173 12.0003C16.173 9.69513 14.3043 7.82642 11.9991 7.82642C9.69391 7.82642 7.8252 9.69513 7.8252 12.0003C7.8252 14.3055 9.69391 16.1742 11.9991 16.1742Z",
        fill: "#FF9811"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3681" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1o(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3682)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12.0003C0 17.1599 3.2565 21.5584 7.82611 23.2539V0.746704C3.2565 2.44217 0 6.84074 0 12.0003Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M23.9999 12.0003C23.9999 6.84074 20.7434 2.44217 16.1738 0.746704V23.254C20.7434 21.5584 23.9999 17.1599 23.9999 12.0003Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3682" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1n(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3683)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0001 5.7395V9.78683L7.82617 5.7395H12.0001Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.26098 12.0002H9.78649L6.26098 7.30457L5.73926 10.9567L6.26098 12.0002Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9688 12.0007H12.0009C12.0009 11.9899 12.0009 11.9794 12.0009 11.9685C11.9902 11.9793 11.9795 11.99 11.9688 12.0007Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26086C12 4.14937 12 2.76586 12 0H11.998C5.37145 0.001125 0 5.37323 0 12H6.26086V8.47448L9.78637 12H11.9679C11.9786 11.9893 11.9893 11.9786 12 11.9679C12 11.1594 12 10.4381 12 9.78647L8.47443 6.26086H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9989 10.5247L7.73539 6.26123H6.25977V6.26132L11.9988 12.0003H11.9989C11.9989 12.0003 11.9989 10.9828 11.9989 10.5247Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.07027 1.56494C5.60766 1.82838 5.16445 2.12196 4.74295 2.44244H5.23533L3.93398 3.3881L4.43095 4.91796L3.12961 3.97249L2.99114 4.07313C2.45081 4.68672 1.97175 5.35554 1.56445 6.07075V11.9997H4.69491V4.69549V4.69539H11.9993C11.9993 3.70807 11.9993 2.76747 11.9993 1.56494H6.07027Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M5.12601 2.16431C4.99659 2.25492 4.86899 2.34806 4.74332 2.44363L3.93449 3.38929L3.13012 3.97363L2.99048 4.07507C2.69582 4.40976 2.41949 4.76095 2.16309 5.12718C2.45535 5.26903 2.78343 5.34876 3.13012 5.34876C4.35477 5.34876 5.34749 4.35604 5.34749 3.13138C5.34759 2.7846 5.2679 2.45662 5.12601 2.16431Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M2.99023 4.07382L3.12987 3.97238L4.43122 4.9179L3.9342 3.38804L5.23545 2.44238H4.74299C4.10577 2.92702 3.51856 3.47377 2.99023 4.07382Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M8.29451 2.0874L8.55354 2.88451H9.39167L8.71362 3.37721L8.97251 4.17432L8.29451 3.68167L7.61647 4.17432L7.87531 3.37721L7.19727 2.88451H8.03544L8.29451 2.0874Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.13041 7.30518L3.38944 8.10228H4.22756L3.54956 8.59504L3.80845 9.39215L3.13041 8.89944L2.45231 9.39215L2.7112 8.59504L2.0332 8.10228H2.87133L3.13041 7.30518Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3683" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1m(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3743)" }, [
      createElementVNode("path", {
        d: "M17.2165 1.19047C15.6389 0.427631 13.869 -0.000244141 11.9991 -0.000244141C10.1292 -0.000244141 8.35939 0.427631 6.78176 1.19047L5.73828 11.9998L6.78176 22.809C8.35939 23.5719 10.1292 23.9998 11.9991 23.9998C13.869 23.9998 15.6389 23.5719 17.2165 22.809L18.26 11.9998L17.2165 1.19047Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.78262 1.19122C2.76867 3.13213 0 7.24255 0 12.0001C0 16.7576 2.76867 20.868 6.78262 22.8089V1.19122Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M17.2168 1.19122V22.8089C21.2307 20.868 23.9994 16.7576 23.9994 12.0001C23.9994 7.2426 21.2307 3.13213 17.2168 1.19122Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M15.131 15.6516L12.0006 5.73859L8.87012 15.6516H11.2179V18.2603H12.7832V15.6516H15.131Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3743" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1l(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3744)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9999 -0.000244141C8.36285 -0.000244141 5.10396 1.61807 2.90332 4.17365H21.0965C18.8959 1.61807 15.637 -0.000244141 11.9999 -0.000244141Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M21.0965 19.827H2.90332C5.10396 22.3825 8.36285 24.0009 11.9999 24.0009C15.637 24.0009 18.8959 22.3825 21.0965 19.827Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M22.2387 5.73859H1.76128C0.644297 7.56132 0 9.70506 0 11.9994C0 14.2938 0.644297 16.4376 1.76128 18.2603H22.2387C23.3557 16.4376 24 14.2938 24 11.9994C24 9.70506 23.3557 7.56132 22.2387 5.73859Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.383 16.6182C9.9331 16.6182 12.0004 14.551 12.0004 12.0009C12.0004 9.45076 9.9331 7.38348 7.383 7.38348C4.83289 7.38348 2.76562 9.45076 2.76562 12.0009C2.76562 14.551 4.83289 16.6182 7.383 16.6182Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.38279 7.38348L8.41877 10.572H11.7768L9.05913 12.5427L10.1032 15.7407L7.38279 13.7606L4.66648 15.737L5.70645 12.5427L2.99121 10.572H6.34676L7.38279 7.38348Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3744" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1k(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3745)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M11.6216 19.5561C11.2981 19.5405 11.0304 19.3302 10.9256 19.0448C10.7404 19.2864 10.4221 19.408 10.1085 19.3271C9.79442 19.2462 9.57482 18.9864 9.52939 18.6848C9.29877 18.8841 8.96277 18.9383 8.67219 18.796C8.38105 18.653 8.2183 18.354 8.23499 18.0498C7.96944 18.199 7.62927 18.1844 7.3731 17.9861C7.11744 17.7879 7.01778 17.4628 7.09499 17.168C6.80488 17.2609 6.47516 17.1785 6.26385 16.9327C6.05253 16.6875 6.02014 16.3489 6.15482 16.076C5.85219 16.1083 5.54544 15.9612 5.38785 15.6785C5.22974 15.3957 5.2663 15.0571 5.45357 14.8165C5.15043 14.7873 4.87911 14.5812 4.78208 14.2723C4.68453 13.9635 4.78888 13.639 5.02105 13.4412C4.72991 13.3514 4.5066 13.0947 4.47374 12.7728C4.44088 12.451 4.60785 12.1551 4.87442 12.008C4.6078 11.8619 4.4398 11.5661 4.47163 11.2447C4.47163 11.2447 4.47163 11.2447 4.47214 11.2447C4.50397 10.9222 4.72728 10.6651 5.01786 10.5742C4.78569 10.377 4.68032 10.053 4.77683 9.74411C4.87335 9.43474 5.1441 9.22811 5.44728 9.19783C5.25997 8.95783 5.22243 8.61916 5.37946 8.33594C5.53649 8.05315 5.84328 7.90549 6.14643 7.93732C6.01077 7.66446 6.0426 7.32583 6.25339 7.0796C6.46367 6.83388 6.79339 6.75091 7.08402 6.84274C7.00574 6.54846 7.10488 6.22291 7.36053 6.02416C7.61567 5.82532 7.95585 5.81018 8.22139 5.95835C8.20419 5.65422 8.36642 5.35521 8.65705 5.21172C8.94716 5.06875 9.28368 5.122 9.51477 5.32127C9.55911 5.01977 9.77877 4.75891 10.0923 4.67744C10.4053 4.59607 10.7236 4.71658 10.9093 4.95761C11.0142 4.67224 11.2813 4.46144 11.6048 4.44527C11.9278 4.42863 12.2147 4.61013 12.3483 4.88308C12.508 4.62429 12.8116 4.47091 13.1315 4.51943C13.4518 4.56743 13.6976 4.80321 13.7737 5.09805C13.9824 4.87572 14.3111 4.7876 14.6148 4.89921C14.9189 5.01138 15.112 5.29207 15.1266 5.59675C15.3755 5.42149 15.7156 5.4011 15.9906 5.57224C16.2656 5.74286 16.3976 6.05641 16.3506 6.35744C16.6297 6.2359 16.9668 6.28441 17.2016 6.50664C17.4364 6.72944 17.5031 7.06282 17.3967 7.34819C17.6946 7.28505 18.015 7.39985 18.2007 7.66539C18.3864 7.93043 18.3849 8.2706 18.2237 8.52888C18.5278 8.52677 18.8185 8.70419 18.9473 9.00105C19.0757 9.29843 19.0052 9.63185 18.795 9.85254C19.094 9.91202 19.3428 10.1442 19.4085 10.4614C19.4737 10.7786 19.3376 11.0901 19.0877 11.2638C19.3673 11.3823 19.5645 11.6593 19.5651 11.9828C19.5651 11.9864 19.5651 11.9896 19.5651 11.9933C19.5651 11.9954 19.5651 11.998 19.5651 12.0001C19.5651 12.3235 19.3689 12.6011 19.0892 12.7206C19.3397 12.8933 19.4769 13.2048 19.4117 13.522C19.347 13.8392 19.0986 14.0719 18.7997 14.1324C19.0105 14.3526 19.082 14.6854 18.9541 14.9834C18.8263 15.2808 18.5357 15.4587 18.231 15.4571C18.3927 15.7154 18.3953 16.0556 18.2101 16.3211C18.0249 16.5867 17.7051 16.7025 17.4072 16.6399C17.5141 16.9248 17.4478 17.2587 17.2136 17.482C16.9788 17.7048 16.6423 17.7538 16.3632 17.6333C16.4106 17.9338 16.2792 18.2479 16.0047 18.4196C15.7303 18.5913 15.3901 18.5714 15.1407 18.3966C15.1266 18.7013 14.9346 18.9826 14.631 19.0953C14.631 19.0953 14.631 19.0953 14.6305 19.0953C14.3268 19.2074 13.9981 19.1198 13.7889 18.8981C13.7138 19.1934 13.4686 19.4297 13.1482 19.4788C12.8284 19.5273 12.5242 19.375 12.3641 19.1162C12.2368 19.3786 11.9676 19.557 11.6608 19.557C11.6477 19.5572 11.6346 19.5567 11.6216 19.5561Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M12.0006 17.2183C14.8821 17.2183 17.218 14.8824 17.218 12.0009C17.218 9.11941 14.8821 6.78351 12.0006 6.78351C9.1191 6.78351 6.7832 9.11941 6.7832 12.0009C6.7832 14.8824 9.1191 17.2183 12.0006 17.2183Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M13.142 10.2289C13.3983 10.0388 13.5652 9.73488 13.5652 9.39119V8.86947C13.5652 8.29315 13.0981 7.82599 12.5217 7.82599H11.4783C10.902 7.82599 10.4348 8.29315 10.4348 8.86947V9.39119C10.4348 9.73488 10.6017 10.0388 10.858 10.2289L9.91309 19.8259C9.91309 19.8259 10.4348 20.3478 12.0001 20.3478C13.5653 20.3478 14.087 19.8259 14.087 19.8259L13.142 10.2289Z",
        fill: "#BDBCC1"
      }),
      createElementVNode("path", {
        d: "M12.0002 7.82599L12.9067 10.6159H15.8404L13.4671 12.3403L14.3735 15.1303L12.0002 13.406L9.62687 15.1303L10.5335 12.3403L8.16016 10.6159H11.0937L12.0002 7.82599Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3745" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1j(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3746)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0.413086 15.131C1.1074 17.7072 2.63763 19.94 4.69535 21.5211V15.131H0.413086Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M10.9561 23.9549C11.3 23.9845 11.6479 24.0005 11.9995 24.0005C17.5439 24.0005 22.2091 20.2402 23.5861 15.131H10.9561V23.9549Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.5861 8.87004C22.2091 3.76085 17.5439 0.000488281 11.9995 0.000488281C11.6479 0.000488281 11.3 0.0165195 10.9561 0.0461445V8.87004H23.5861Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.69535 2.48029C2.63763 4.06138 1.1074 6.29418 0.413086 8.87038H4.69535V2.48029Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4343H9.39136H9.39131V0.284729C8.28234 0.530635 7.23098 0.929213 6.26086 1.45857V10.4342V10.4342H0.101578C0.0347813 10.9466 0 11.469 0 11.9995C0 12.53 0.0347813 13.0524 0.101578 13.5647H6.26081H6.26086V22.5404C7.23098 23.0697 8.28234 23.4684 9.39131 23.7142V13.5648V13.5647H23.8984C23.9651 13.0524 24 12.53 24 11.9995C24 11.469 23.9651 10.9466 23.8984 10.4343Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3746" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1i(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3747)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12.0005C0 16.549 2.53078 20.5062 6.26086 22.5414V1.45959C2.53078 3.49481 0 7.452 0 12.0005Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.2537 16.1752C23.736 14.8752 24 13.4691 24 12.0013C24 10.5334 23.736 9.12733 23.2537 7.82739H0.746438C0.264047 9.12733 0 10.5334 0 12.0013C0 13.4691 0.264047 14.8752 0.746438 16.1752L12 17.2187L23.2537 16.1752Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0006 23.9997C17.1603 23.9997 21.5587 20.7432 23.2543 16.1736H0.74707C2.44254 20.7432 6.8411 23.9997 12.0006 23.9997Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M0 11.9996C0 17.544 3.76036 22.2092 8.86955 23.5862V0.413025C3.76036 1.79002 0 6.45531 0 11.9996Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.34159 5.28157L6.23483 4.1748L5.49701 4.91271L4.7592 4.1748L3.65244 5.28157L4.3903 6.01943L3.65234 6.75734L4.75911 7.8641L5.49697 7.1262L6.23483 7.8641L7.34159 6.75734L6.60373 6.01943L7.34159 5.28157Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3747" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1h(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3748)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12.0002C0 16.5487 2.53074 20.5059 6.26086 22.5411V1.45929C2.53074 3.49455 0 7.4517 0 12.0002Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9999 0.000793457C9.92098 0.000793457 7.96563 0.529684 6.26074 1.45987V22.5417C7.96563 23.4719 9.92098 24.0008 11.9999 24.0008C18.6273 24.0008 23.9999 18.6282 23.9999 12.0008C23.9999 5.37342 18.6273 0.000793457 11.9999 0.000793457Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M17.1307 13.9861C15.6126 15.083 13.4926 14.7415 12.3957 13.2234C11.2987 11.7053 11.6402 9.58533 13.1584 8.48846C13.6317 8.14646 14.1636 7.94428 14.7046 7.87402C13.6637 7.71835 12.5633 7.95291 11.6428 8.61802C9.77437 9.96811 9.35404 12.5772 10.7041 14.4458C12.0541 16.3142 14.6633 16.7345 16.5318 15.3843C17.4524 14.7192 18.0206 13.7483 18.1995 12.711C17.963 13.2025 17.6041 13.644 17.1307 13.9861Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.0659 7.82721L17.9211 8.74882L19.0618 8.22044L18.4495 9.31844L19.3047 10.2401L18.0711 9.9971L17.4588 11.0952L17.3088 9.84691L16.0752 9.60386L17.216 9.07549L17.0659 7.82721Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3748" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1g(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3749)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M9.3912 17.2183C12.2727 17.2183 14.6086 14.8824 14.6086 12.0009C14.6086 9.11941 12.2727 6.78351 9.3912 6.78351C6.50973 6.78351 4.17383 9.11941 4.17383 12.0009C4.17383 14.8824 6.50973 17.2183 9.3912 17.2183Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3749" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1f(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3750)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.30388 7.82696H23.2531C21.5576 3.25735 17.1591 0.000854492 11.9995 0.000854492C8.68576 0.000854492 5.68609 1.34424 3.51465 3.51596L7.30388 7.82696Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M7.30388 16.1736H23.2531C21.5576 20.7432 17.1591 23.9997 11.9995 23.9997C8.68576 23.9997 5.68609 22.6563 3.51465 20.4846L7.30388 16.1736Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51489C-1.17157 8.20117 -1.17157 15.7992 3.51471 20.4855C5.45126 18.549 7.31375 16.6865 12 12.0002L3.51471 3.51489Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3750" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1e(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3751)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 11.9998C0 18.6271 5.37262 23.9998 12 23.9998C12 19.4362 12 11.9998 12 11.9998C12 11.9998 4.17389 11.9998 0 11.9998Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12 0.000854492C18.6274 0.000854492 24 5.37348 24 12.0009C19.4365 12.0009 12 12.0009 12 12.0009C12 12.0009 12 4.17475 12 0.000854492Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.1441 4.1748L7.92115 6.56627H10.4357L8.40138 8.04424L9.17838 10.4357L7.1441 8.9577L5.10982 10.4357L5.88682 8.04424L3.85254 6.56627H6.36705L7.1441 4.1748Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M16.857 13.5647L17.634 15.9562H20.1486L18.1142 17.4341L18.8913 19.8256L16.857 18.3476L14.8227 19.8256L15.5997 17.4341L13.5654 15.9562H16.0799L16.857 13.5647Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3751" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1d(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M32 62c9.8 0 18.5-4.7 24-12L8 14c-3.8 5-6 11.2-6 18c0 16.6 13.4 30 30 30z",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      d: "M62 32C62 15.4 48.6 2 32 2C22.2 2 13.5 6.7 8 14l48 36c3.8-5 6-11.2 6-18",
      fill: "#c94747"
    }),
    createElementVNode("path", {
      d: "M53 29.7c-.2-2.8-1.1-3.2-1.3-3.6c-.1-.4.2.1.5.2s-.1-.6-.1-.9c-.1-.3.9.7 1.2.7c.3.1-.6-2.3-.9-2.5c-.3-.2.3.1.4.1S51.2 21 50.9 21s.3-.1.5-.1s-2-1.8-2.4-1.8s.8-.5.9-.5c.2 0-2.5-1.5-5 0c-.1-.1 1.2-1 1.2-1.4c0-.1-.4-.3-.5-.4c0-.1.7-.5.7-.7c0-.2-.3-.1-.5-.1c0-.2.6-.7.5-1c0-.1-.5-.2-.6-.1s.3-.6.2-.8c-.1-.1-.3 0-.5 0c-.1 0 .7-1.3.6-1.4c-.2-.2-2.6 1.3-3.5 2.9c-.9 1.6-.2 2.9-.3 3.4c-.1.5-.3 1.1-.6 1.1c-.4 0-1.2-.6-1.5-.9s-.3-.5-.7-.6c-.4-.1-1.3.2-1.7.3c-.3 0-1.7-.3-1.8-.2c-.1.1 1.3.6 1.6.8c.3.2.3.4.6.5c.2.1 2.4.8 1.7 1.7c-.5.6-1.6-.6-3-.7c-1.4 0-2.3 1.3-2.7 1.8c-.4.5-1.7 2.9-1.7 3.1c0 .3.8-.7 1.1-.9c0 .3-.3.7-.2.9c.1.1 1-.7 1.3-.7c.1.2-.2.5-.1.8c.1.1.6-.6 1-.7c.1.3-.3.7-.1 1.1c.1 0 1-1 1.3-1.1c.3-.1-.1.9 0 1c.3-.2 1.1-1.1 1.3-1.2c.3-.1 0 1.2.1 1.2c.3-.2 1.1-1.3 1.2-1.5c.1-.2-.1 1.7.8 2.6s2.2 2.1 2.4 2.1c.2-.3-.1-1 .1-.9c.4.4 1.1 1.1 1.3 1.1s-.1-.7.1-.7c.5.4 1.8 2.1 4.3 2.9c-.2-.5-.5-.9-.6-1.1c.2 0 .8.3.9.3c.1 0-1.3-1.7-1.2-1.9c.3 0 .5.2.6 0c-.1-.2-1.3-1.6-1.3-1.9c0-.3.4.1.5 0c.1-.1-.5-1.3-.3-1.4c.1-.1 1.4.8 1.7.8c.1 0 .2-.2.2-.4c.9.7 2.5 2 3.7 3.7c0 .4-.1.7-.2 1.1c-.9 2.1-2.6 3.2-5.1 2.3c.1.2 1.5 1.3 2.9.9c1.2-.3 2.7-1.2 3-3.2c.3.7.5 1.5.5 2.3c0 3.8-3.4 3.7-4.3 3.5c1.1.9 5.2.7 5.2-3.5c-.1-1.3-.7-2.6-1.5-3.7m-4.3-4.1c0-.1 0-.2.1-.2c.1-.1 1.2.6 1.4.6s.2-.5.3-.4c.1 0 1.4 1.4 1.8 3.2c-1.4-1.6-2.9-2.8-3.6-3.2",
      fill: "#ffce31"
    }),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M19.4 41.2L19 40l-.4 1.2h-1.2l1 .8l-.4 1.2l1-.8l1 .8l-.4-1.2l1-.8z" }),
      createElementVNode("path", { d: "M14.4 26.6l-.7 2.3l1.9-1.4l2 1.5l-.8-2.4l2-1.5h-2.4l-.8-2.5l-.7 2.5h-2.5z" }),
      createElementVNode("path", { d: "M8.9 34.7l-.8-2.4l-.7 2.4H4.9l2 1.5l-.7 2.4l1.9-1.5l2 1.5l-.8-2.4l2-1.5z" }),
      createElementVNode("path", { d: "M24.3 35.5l2-1.5h-2.4l-.8-2.4l-.7 2.4h-2.5l2 1.5l-.7 2.4l1.9-1.5l2 1.5z" }),
      createElementVNode("path", { d: "M16.4 47.7l-.8-2.5l-.7 2.5h-2.5l2 1.5l-.7 2.3l1.9-1.4l2 1.5l-.8-2.4l2-1.5z" })
    ])
  ]);
}
function render$1c(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3685)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.0007 0C7.24316 0 3.13241 2.76867 1.19141 6.78262H22.8099C20.869 2.76867 16.7582 0 12.0007 0Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0007 24.0008C16.7582 24.0008 20.869 21.2321 22.81 17.2181H1.19141C3.13241 21.2321 7.24316 24.0008 12.0007 24.0008Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M14.9514 8.52661L13.8446 9.63338C14.3167 10.1055 14.6088 10.7576 14.6088 11.478C14.6088 12.9188 13.4408 14.0867 12.0001 14.0867C10.5594 14.0867 9.39138 12.9187 9.39138 11.478C9.39138 10.7576 9.68341 10.1055 10.1555 9.63338L9.04872 8.52661C8.29333 9.28186 7.82617 10.3253 7.82617 11.478C7.82617 13.7832 9.69489 15.6519 12.0001 15.6519C14.3052 15.6519 16.174 13.7832 16.174 11.478C16.1739 10.3253 15.7068 9.28186 14.9514 8.52661Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0003 9.9126L12.3888 11.1084H13.6461L12.6289 11.8473L13.0175 13.043L12.0003 12.3041L10.9831 13.043L11.3716 11.8473L10.3545 11.1084H11.6117L12.0003 9.9126Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3685" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1b(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3686)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9999 12.0015C23.9999 6.84196 20.7434 2.44339 16.1738 0.747925V23.2552C20.7434 21.5596 23.9999 17.1611 23.9999 12.0015Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12.0006C0 17.1603 3.2565 21.5587 7.82611 23.2543V0.74707C3.2565 2.44254 0 6.8411 0 12.0006Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3686" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1a(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3687)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 0V12L3.51465 20.4853C5.68623 22.6568 8.68623 24 12 24C18.6273 24 24 18.6274 24 12C24 5.37262 12 0 12 0Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 0C8.68623 0 5.68623 1.34316 3.51465 3.51469C6.45887 6.45891 7.50404 7.50412 12 12H24C24 5.37262 18.6273 0 12 0Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M8.21723 11.9998L6.75173 11.3104L7.53215 9.89111L5.94074 10.1956L5.73909 8.58789L4.63059 9.77027L3.52213 8.58789L3.32043 10.1956L1.72907 9.89106L2.50949 11.3104L1.04395 11.9998L2.50949 12.6891L1.72907 14.1085L3.32057 13.8041L3.52209 15.4117L4.63059 14.2293L5.73909 15.4117L5.94074 13.8041L7.53205 14.1085L6.75168 12.6892L8.21723 11.9998Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.20082 4.69519L3.68851 5.37689L4.48749 5.12382L3.98977 5.79825L4.47746 6.47996L3.68218 6.21507L3.18451 6.88946L3.19074 6.05133L2.39551 5.78639L3.19463 5.53332L3.20082 4.69519Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.20082 17.1095L3.68851 17.7912L4.48749 17.5381L3.98977 18.2126L4.47746 18.8943L3.68218 18.6294L3.18451 19.3038L3.19074 18.4656L2.39551 18.2007L3.19463 17.9476L3.20082 17.1095Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M10.1558 10.9032L9.66817 11.5849L8.86914 11.3317L9.36686 12.0062L8.87917 12.688L9.67445 12.423L10.1722 13.0974L10.1659 12.2593L10.9611 11.9944L10.162 11.7413L10.1558 10.9032Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3687" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$19(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3688)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 12.0005H11.9999C11.9999 11.9897 11.9999 11.9792 11.9999 11.9684C11.9892 11.9791 11.9785 11.9898 11.9678 12.0005Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26098C12 4.1495 12 2.76598 12 0.00012207H11.998C5.37145 0.00124707 0 5.37336 0 12.0001H6.26086V8.47461L9.78637 12.0001H11.9679C11.9786 11.9894 11.9893 11.9787 12 11.968C12 11.1596 12 10.4382 12 9.78659L8.47443 6.26098H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56506C4.19441 2.63377 2.63409 4.19405 1.56543 6.07088V11.9999H4.69588V4.69561V4.69552H12.0002C12.0002 3.70819 12.0002 2.7676 12.0002 1.56506H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0009 10.5248L7.73734 6.26135H6.26172V6.26145L12.0008 12.0005H12.0009C12.0009 12.0005 12.0009 10.9829 12.0009 10.5248Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.783 7.30388L17.2178 7.82564L15.6526 7.30388L15.1309 5.99953L15.6526 4.69519H18.783L18.2613 5.99953L18.783 7.30388Z",
        fill: "#ACABB1"
      }),
      createElementVNode("path", {
        d: "M13.5654 7.30396V13.0431C13.5654 15.8387 17.2176 16.6953 17.2176 16.6953C17.2176 16.6953 20.8698 15.8387 20.8698 13.0431V7.30396H13.5654Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M13.8945 14.4023C14.7923 16.1258 17.2175 16.6948 17.2175 16.6948C17.2175 16.6948 19.6427 16.1258 20.5405 14.4023L17.2175 8.86877L13.8945 14.4023Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M20.8698 12.9851L17.2176 7.30396L13.5654 12.9851V13.043C13.5654 13.5605 13.6908 14.0113 13.8946 14.4027L17.2176 9.23356L20.5406 14.4027C20.7444 14.0112 20.8698 13.5604 20.8698 13.043V12.9851Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3688" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$18(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3693)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M24 11.9995C24 18.6269 18.6274 23.9995 12 23.9995C5.37262 23.9995 0 18.6269 0 11.9995",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3693" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$17(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3689)" }, [
      createElementVNode("path", {
        d: "M0 12.0007C0 17.1602 3.2565 21.5587 7.82602 23.2542L8.86955 12.0006L7.82602 0.74707C3.2565 2.44263 0 6.8411 0 12.0007Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M24.0002 12C24.0002 5.37262 18.6275 0 12.0002 0C10.5323 0 9.1262 0.264047 7.82617 0.746391V23.2536C9.1262 23.736 10.5323 24 12.0002 24C18.6275 24 24.0002 18.6274 24.0002 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.82623 16.1744C10.1314 16.1744 12.0001 14.3057 12.0001 12.0006C12.0001 9.69537 10.1314 7.82666 7.82623 7.82666C5.52106 7.82666 3.65234 9.69537 3.65234 12.0006C3.65234 14.3057 5.52106 16.1744 7.82623 16.1744Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.47754 9.9126V12.5213C5.47754 13.8179 6.52866 14.8691 7.82537 14.8691C9.12207 14.8691 10.1732 13.818 10.1732 12.5213V9.9126H5.47754Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.82657 13.3037C7.39504 13.3037 7.04395 12.9526 7.04395 12.5211V11.4777H8.60915V12.5211C8.60915 12.9526 8.25805 13.3037 7.82657 13.3037Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3689" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$16(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3690)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.999 -0.000610352C8.07308 -0.000610352 4.58769 1.88484 2.39844 4.79939H21.5995C19.4102 1.88484 15.9248 -0.000610352 11.999 -0.000610352Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.999 23.9993C15.9248 23.9993 19.4102 22.1139 21.5995 19.1993H2.39844C4.58769 22.1139 8.07308 23.9993 11.999 23.9993Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M-0.000976562 11.9994C-0.000976562 12.8213 0.0818984 13.6239 0.239352 14.3994H23.7588C23.9162 13.6239 23.999 12.8213 23.999 11.9994C23.999 11.1774 23.9161 10.3748 23.7587 9.59937H0.239352C0.0818984 10.3748 -0.000976562 11.1774 -0.000976562 11.9994Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51538C-1.17157 8.20166 -1.17157 15.7997 3.51471 20.486C5.45126 18.5495 7.31374 16.687 12 12.0007L3.51471 3.51538Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M4.85694 8.86877L5.6339 11.2601H8.14855L6.11427 12.7382L6.89118 15.1297L4.85694 13.6517L2.82262 15.1297L3.59971 12.7382L1.56543 11.2601H4.0799L4.85694 8.86877Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3690" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$15(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3691)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9997 12C23.9997 5.37262 18.627 0 11.9997 0C9.65216 0 7.46244 0.674766 5.61284 1.83989L8.24314 2.95744L4.69531 4.46484L8.24314 5.9722L4.69531 7.47952L8.24314 8.98678L4.69531 10.4939L8.24314 12.0008L4.69531 13.5082L8.24314 15.0154L4.69531 16.5225L8.24314 18.0297L4.69531 19.537L8.24314 21.0441L5.61402 22.161C7.46338 23.3256 9.65263 24 11.9997 24C18.627 24 23.9997 18.6274 23.9997 12Z",
        fill: "#751A46"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3691" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$14(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      fill: "#2a5f9e",
      d: "M14 8v48l24-24z"
    }),
    createElementVNode("path", {
      d: "M56 14C50.5 6.7 41.8 2 32 2c-6.8 0-13 2.2-18 6l24 24l18-18",
      fill: "#ffce31"
    }),
    createElementVNode("path", {
      d: "M56 50c3.8-5 6-11.2 6-18c0-6.8-2.2-13-6-18L38 32l18 18",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M38 32L14 56c5 3.8 11.2 6 18 6c9.8 0 18.5-4.7 24-12L38 32z",
      fill: "#699635"
    }),
    createElementVNode("path", {
      d: "M6 17c-2.5 4.4-4 9.5-4 15s1.5 10.6 4 15V17",
      fill: "#2a5f9e"
    }),
    createElementVNode("path", {
      d: "M6 17v30c1.1 2 2.5 3.8 4 5.4V11.6c-1.5 1.7-2.9 3.5-4 5.4",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M10 11.6v40.8c1.2 1.3 2.6 2.5 4 3.6V8c-1.4 1.1-2.8 2.3-4 3.6",
      fill: "#ed4c5c"
    }),
    createElementVNode("circle", {
      cx: "38",
      cy: "32",
      r: "12",
      fill: "#ffffff"
    })
  ]);
}
function render$13(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3695)" }, [
      createElementVNode("path", {
        d: "M16.1745 0.745367C14.8744 0.26307 13.4684 -0.000976556 12.0006 -0.000976556C10.5327 -0.00102343 9.12667 0.26307 7.82669 0.745367L6.7832 11.999L7.82669 23.2526C9.12662 23.735 10.5327 23.999 12.0006 23.999C13.4684 23.999 14.8745 23.735 16.1745 23.2526L17.2179 11.999L16.1745 0.745367Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.9999 11.9996C23.9999 6.84005 20.7434 2.44144 16.1738 0.745972V23.2533C20.7434 21.5576 23.9999 17.1592 23.9999 11.9996Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 11.9995C0 17.1592 3.2565 21.5576 7.82602 23.2532L7.82606 0.745972C3.2565 2.44144 0 6.83991 0 11.9995Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3695" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$12(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3696)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.2536 16.1733C23.736 14.8734 24 13.4673 24 11.9995C24 10.5316 23.736 9.12555 23.2536 7.82556H0.746391C0.264047 9.12555 0 10.5316 0 11.9995C0 13.4673 0.264047 14.8734 0.746391 16.1733L12 17.2168L23.2536 16.1733Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0007 23.9995C17.1603 23.9995 21.5588 20.743 23.2543 16.1733H0.74707C2.44259 20.743 6.8411 23.9995 12.0007 23.9995Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3696" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$11(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3697)" }, [
      createElementVNode("path", {
        d: "M0 11.9991C0 14.078 0.528891 16.0333 1.45908 17.7382L12 18.7817L22.5409 17.7382C23.4711 16.0333 24 14.078 24 11.9991L12 10.9556L0 11.9991Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M22.5409 6.26086C20.5057 2.53073 16.5485 0 12 0C7.45148 0 3.49434 2.53073 1.45908 6.26086C0.528891 7.96575 0 9.92109 0 12H24C24 9.92109 23.4711 7.96575 22.5409 6.26086Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M11.9999 23.9991C16.5484 23.9991 20.5056 21.4684 22.5408 17.7383H1.45898C3.49425 21.4684 7.45139 23.9991 11.9999 23.9991Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M13.5654 7.02244L15.031 7.71183L14.2506 9.1312L15.842 8.8268L16.0437 10.4344L17.1521 9.252L18.2606 10.4344L18.4622 8.8268L20.0536 9.13111L19.2732 7.71178L20.7387 7.02244L19.2732 6.33314L20.0536 4.91377L18.4622 5.21817L18.2605 3.6106L17.1521 4.79297L16.0436 3.6106L15.842 5.21817L14.2506 4.91377L15.031 6.33319L13.5654 7.02244Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3697" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$10(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3710)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M21.4265 9.65236H17.4787C17.4787 8.932 16.8947 8.34802 16.1744 8.34802L15.1309 10.435C15.1309 10.435 16.2439 13.5654 16.2091 13.5654H17.5135C18.2339 13.5654 18.8178 12.9815 18.8178 12.2611C19.5382 12.2611 20.1221 11.6771 20.1221 10.9567H20.0787C20.799 10.9567 21.4265 10.3728 21.4265 9.65236Z",
        fill: "#ACABB1"
      }),
      createElementVNode("path", {
        d: "M2.57422 9.65224H6.52204C6.52204 8.93188 7.10601 8.3479 7.82637 8.3479L8.86987 10.4348C8.86987 10.4348 7.7568 13.5653 7.79161 13.5653H6.48727C5.76687 13.5653 5.18294 12.9814 5.18294 12.261C4.46253 12.261 3.8786 11.677 3.8786 10.9566H3.92204C3.20164 10.9566 2.57422 10.3726 2.57422 9.65224Z",
        fill: "#ACABB1"
      }),
      createElementVNode("path", {
        d: "M16.174 16.6957V17.2174H7.82621V16.6957H5.73926V18.7826H7.82621V19.3043H16.174V18.7826H18.261V16.6957H16.174Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M7.82617 8.34851V13.5659C7.82617 16.7608 12.0001 17.7398 12.0001 17.7398C12.0001 17.7398 16.174 16.7608 16.174 13.5659V8.34851L12.0001 7.82678L7.82617 8.34851Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M16.174 10.4342H7.82617V13.5646H16.174V10.4342Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.087 5.73881V6.52142L13.5653 6.78231L13.0436 6.26054V4.69531H10.9566V6.26054L10.4349 6.78231L9.91312 6.52142V5.73881H7.82617V8.34748H16.174V5.73881H14.087Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3710" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$$(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M32 2v10H12v20H2c0 16.6 13.4 30 30 30s30-13.4 30-30S48.6 2 32 2z",
      fill: "#2a5f9e"
    }),
    createElementVNode("path", {
      d: "M32 2c-4.7 0-9.1 1.1-13.1 3v6H11v7.9H5c-1.9 4-3 8.4-3 13.1h12V17l12 15h6v-7.5L23.6 14H32V2z",
      fill: "#ffffff"
    }),
    createElementVNode("g", { fill: "#ed4c5c" }, [
      createElementVNode("path", { d: "M15.4 14L30 32h2v-4.9L21.4 14z" }),
      createElementVNode("path", { d: "M32 5H18.9c-6 2.9-11 7.9-13.9 13.9V32h6V11h21V5z" })
    ]),
    createElementVNode("path", {
      d: "M57.9 29.2c0 7.4-1.2 15.3-10.7 19.1c-9.5-3.8-10.7-11.7-10.7-19.1h21.4",
      fill: "#49c3f2"
    }),
    createElementVNode("path", {
      d: "M47.2 48.3c4.3-1.7 6.9-4.3 8.5-7.3h-.9c-.2 0-9.2-.9-10.2-1.3c-.9-.3-4.4.3-6.1.9c1.5 3.2 4.1 5.9 8.7 7.7",
      fill: "#428bc1"
    }),
    createElementVNode("path", {
      d: "M40.5 43.8c.1 0 2.6.4 3-.2c.4-.6-1.2-1.9-1.1-2.6c0-.2.2-.6.4-.7c.4-.2 1.7.3 1.8-.6c.1-1.5-1.2-2.7-1.6-4.1c-.3-.9-.3-1.7-.4-2.6c0-.4-.1-.6-.5-.7c-.5-.2-.5-.6-.7-1.1c-.2 0-.7.4-.7.6c0 .9-.8.9-1.2 1.6c-.3-.4-.5-1.1-.8-1.5c-.4-.4-.5-.4-.4-1c-.6-.5-.6.3-1 .5c-.1.2-.5.5-.8 1c.3 4.1 1.2 8.1 4 11.4",
      fill: "#c94747"
    }),
    createElementVNode("path", {
      d: "M57.9 29.2c0-2.8-.1-5.5-.1-7.8c-3.6-1.6-8.3-1.9-10.7-1.9c-2.4 0-7.1.3-10.7 1.9c.1 2.4-.1 5.1-.1 7.8h21.6",
      fill: "#ffe62e"
    }),
    createElementVNode("path", {
      d: "M49.6 39.9c-1.4 0-2.7 0-3.7-.1c-.9-.1-1.2-.3-1.9-.7c-1-.6-1.2-.7-2.6-1.5c-.2-.1-.4 0-.1.2c1.4.9 1.9 1.2 2.5 1.7c.7.4 2.7 1.7 2.7 1.7h8.1l1.3-2.7c0-.2-.1-.4-.1-.5c-1.5.1-2.9.1-4 .1c-.1.1-.2.3-.3.5c-.6.1-1 .2-1.2.2c.1.1-.5.9-.7 1.1",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      d: "M44.7 21.3c-.4 0-1.1 0-1.3.1c-.2.1-.2.1.1.2c.3.1.8.2 1 .4c.3.2.5.5.4.9c-.2 1.2.4 2.4 1.4 2.9c.1 0 .1.1.1.2c0 .2-.1.4-.1.5c-.1.1-.1.2.1.1c-.1.2-.4.6-.4.7c-.8-.1-1.4 0-1.4.8c0 .1 0 .2.1 0s.2-.4.6-.4c-.3.3-.4.5-.3.7c0 .2.1.3.2.1s.2-.4.4-.5c.1 0 .1-.1.1.1s0 .4.1.5c.1.1.1.1.1-.1s0-.5.2-.6c.3-.1.5-.1.6.1c.1.2.2 0 .1-.2s-.3-.4-.5-.4c.2-.3.4-.7.4-.8c0-.1.1-.1.2-.1s.1 0 .2-.1s.2-.5.3-.7c.1 0 .2 0 .2-.1c.2.3.4.6.4.7c0 .1.1.1.1.2s-.2.6-.2.7c-.6 0-.8 0-1 .3c-.1.1 0 .2.2.1c.1-.1.3-.1.4-.1c.1 0 .1.1 0 .1c-.3.2-.6.4-.5.7c0 .1.1.2.1 0c.1-.2.3-.4.6-.5c0 .2 0 .6.2.7c.2.1.2 0 .1-.1c-.1-.2 0-.5.1-.6c.2-.3.8.1.9.2c.1.1.2.1.1-.1c-.1-.3-.5-.5-.9-.6c.1-.5.4-1.6.5-1.9c.2.1.4-.2.8-.1c.6.2 1.6.8 1.7 1s.2.1.3 0c.1-.1.2 0 .3 0c.1 0 .2.1.1-.2c-.1-.3-.5-.8-1.1-1.2c.3 0 .8 0 .8-.1s-.5-.3-.8-.3c.2-.1.5-.2.7-.3c.1-.1 0-.1-.3-.1c-1 0-1.5 0-2-.3c-.8-.5-1.3-1-1.7-1.2c-.2-.1-.3-.4-.4-.6c-.3-.7-.3-1-.9-1.3c-.4 0-1.2.3-1.5.6",
      fill: "#c94747"
    })
  ]);
}
function render$_(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3699)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.51539 20.4852C4.01878 20.9885 4.55593 21.4375 5.11932 21.8327L21.8335 5.11856C21.4383 4.55512 20.9893 4.01802 20.4859 3.51463C19.9825 3.01124 19.4454 2.56241 18.882 2.16711L2.16797 18.8813C2.56313 19.4447 3.012 19.9818 3.51539 20.4852Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.51426 3.51475C-0.271509 7.30053 -0.998308 12.9861 1.33251 17.5021L17.5016 1.33309C12.9856 -0.997679 7.2999 -0.27088 3.51426 3.51475Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M20.4855 20.4847C24.2712 16.699 24.998 11.0134 22.6673 6.49731L6.49805 22.6665C11.0141 24.9972 16.6997 24.2705 20.4855 20.4847Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.62971 14.1578L8.74993 14.7286L9.63896 13.8396L9.44228 15.0813L10.5624 15.6521L9.32068 15.8488L9.12399 17.0905L8.55324 15.9703L7.31152 16.167L8.20051 15.278L7.62971 14.1578Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.1561 7.63057L15.2763 8.20136L16.1653 7.31238L15.9686 8.55405L17.0888 9.1249L15.8471 9.32158L15.6504 10.5633L15.0796 9.44313L13.8379 9.63977L14.7269 8.75079L14.1561 7.63057Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3699" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$Z(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3711)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M7.56543 16.1739H16.435L12.0002 5.73914L7.56543 16.1739Z",
        fill: "#F3F3F3"
      }),
      createElementVNode("path", {
        d: "M9.10645 15.1303L12 8.54858L14.8936 15.1303H9.10645Z",
        fill: "#333333"
      }),
      createElementVNode("path", {
        d: "M7.56543 16.1745H16.435L12.0002 12.0006L7.56543 16.1745Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3711" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$Y(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1518_57409)" }, [
      createElementVNode("path", {
        d: "M0 0H1200V800H0V0Z",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M0 0H1200V400H0V0Z",
        fill: "#DC171D"
      }),
      createElementVNode("path", {
        d: "M0 0V800L533.333 400L0 0Z",
        fill: "white"
      }),
      createElementVNode("path", {
        d: "M269.43 301.951L269.593 295.758C269.593 295.758 266.268 290.461 270.127 284.769C270.127 284.769 261.928 280.431 263.836 273.638C263.836 273.638 256.422 271.743 256.967 263.587C256.967 263.587 248.964 263.032 248.135 256.219C248.135 256.219 240.132 257.537 236.61 250.898C236.61 250.898 228.803 252.424 226.601 246.951C226.601 246.951 219.012 249.58 214.509 243.147C214.509 243.147 206.495 246.385 203.136 240.312C199.822 246.364 191.808 243.147 191.808 243.147C187.359 249.557 179.716 246.897 179.716 246.897C177.589 252.391 169.804 250.832 169.804 250.832C166.293 257.473 158.301 256.152 158.301 256.152C157.516 262.945 149.524 263.5 149.524 263.5C150.156 271.676 142.753 273.53 142.753 273.53C144.704 280.322 136.516 284.649 136.516 284.649C140.474 290.373 137.181 295.628 137.181 295.628L136.996 301.339L269.451 301.951H269.43Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.399999"
      }),
      createElementVNode("path", {
        d: "M203.377 264.624C206.926 268.208 203.608 270.166 200.334 268.326C192.241 262.202 182.783 258.806 169.775 262.509C151.084 262.577 131.229 261.452 122.15 271.367C121.504 273.28 116.435 280.488 136.041 269.913C134.819 277.226 143.939 271.248 150.99 267.93C146.132 273.008 158.427 273.84 166.203 268.855C162.381 273.983 169.095 273.845 175.463 273.88C184.779 274.171 179.633 282.272 163.69 282.606C162.527 282.525 158.057 284.622 164.086 286.176C166.879 286.315 164.607 290.209 174.273 285.251C173.672 288.152 177.814 287.59 183.665 285.779C186.984 288.387 189.677 285.684 192.529 284.325C204.741 289.098 220.866 293.878 225.205 277.317C235.397 276.143 243.833 274.648 239.266 270.769C252.543 276.182 253.312 274.094 253.11 271.424C259.477 273.829 266.883 277.087 263.867 271.798C269.989 273.362 276.694 273.906 281.921 277.033C287.218 279.776 285.504 274.984 284.26 272.826C281.547 268.486 278.117 267.205 270.382 267.047C263.822 266.912 233.085 258.343 217.096 267.59C217.096 267.59 217.47 267.59 217.189 267.59C216.909 267.59 210.548 261.607 210.548 261.607C212.011 261.568 213.068 260.831 213.915 259.737C220.152 260.051 226.388 259.454 232.624 257.774C235.465 256.887 237.085 258.578 237.021 259.83C239.62 255.259 236.021 254.312 233.372 254.501C222.823 255.099 216.49 254.547 211.39 253.66C201.278 248.615 189.107 256.354 200.351 262.729L203.377 264.624Z",
        fill: "#BC715F",
        stroke: "black",
        "stroke-width": "0.4"
      }),
      createElementVNode("path", {
        d: "M205.753 255.674C203.637 255.989 201.453 256.243 200.608 257.708C200.67 255.297 204.26 255.131 205.753 255.674Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M204.631 257.495C205.135 257.495 205.543 257.076 205.543 256.56C205.543 256.044 205.135 255.625 204.631 255.625C204.127 255.625 203.719 256.044 203.719 256.56C203.719 257.076 204.127 257.495 204.631 257.495Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M89.9346 285.812C94.1107 309.512 98.7459 333.803 101.025 358.615C105.986 395.362 83.6328 426.215 92.8026 462.517C98.2762 479.937 117.433 490.062 134.966 492.069C158.225 496.465 186.342 492.083 203.32 509.479C220.298 492.08 248.415 496.465 271.674 492.069C289.207 490.062 308.364 479.937 313.837 462.517C323.007 426.215 300.654 395.362 305.615 358.615C307.894 333.803 312.529 309.512 316.705 285.812C275.764 308.04 235.31 279.124 203.32 297.611C171.33 279.124 130.876 308.04 89.9346 285.812Z",
        fill: "#DC171D",
        stroke: "black",
        "stroke-width": "0.399999"
      }),
      createElementVNode("path", {
        d: "M105.198 304.957C108.805 324.511 112.808 344.553 114.777 365.024C119.062 395.344 99.7552 420.8 107.675 450.752C112.403 465.124 128.949 473.479 144.092 475.134C164.181 478.761 188.466 475.141 203.13 489.499C217.794 475.143 242.079 478.761 262.168 475.134C277.311 473.479 293.857 465.124 298.584 450.752C306.504 420.8 287.198 395.344 291.483 365.024C293.451 344.553 297.455 324.511 301.062 304.957C265.7 323.296 230.76 299.438 203.13 314.692C175.499 299.438 140.559 323.296 105.198 304.957Z",
        fill: "#62AFE1",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M183.937 359.77L142.561 388.126V422.266H263.699V388.126L222.323 359.77H183.937Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M132.733 416.617V423.144H136.718V456.673H269.543V423.144H273.527V416.617H132.733Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M203.128 322.797L183.937 341.476V359.772H222.323V341.476L203.128 322.797Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M148.541 392.762H160.678V411.983H148.541V392.762Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M182.997 392.762H195.134V411.983H182.997V392.762Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M257.717 392.762H245.579V411.983H257.717V392.762Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M223.263 392.762H211.126V411.983H223.263V392.762Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M148.541 426.188H160.678V445.409H148.541V426.188Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M257.717 426.188H245.579V445.409H257.717V426.188Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M212.644 425.102H193.616V456.675H212.644V425.102Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M182.554 416.617H174.021V456.673H182.554V416.617Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M223.706 416.617H232.243V456.673H223.706V416.617Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M235.411 417.987V408.094H170.849V417.987H235.411Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M183.937 341.477H222.323Z",
        fill: "white"
      }),
      createElementVNode("path", {
        d: "M183.937 341.477H222.323",
        stroke: "black",
        "stroke-width": "0.9"
      }),
      createElementVNode("path", {
        d: "M142.561 388.129H263.699Z",
        fill: "white"
      }),
      createElementVNode("path", {
        d: "M142.561 388.129H263.699",
        stroke: "black",
        "stroke-width": "0.9"
      }),
      createElementVNode("path", {
        d: "M129.691 452.484H276.569V462.864H129.691V452.484Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M210.453 345.438H195.805V355.812H210.453V345.438Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.9",
        "stroke-linecap": "round"
      }),
      createElementVNode("path", {
        d: "M175.461 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M230.799 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M226.188 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M221.576 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M216.965 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M212.353 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M207.741 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M203.13 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M198.518 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M193.907 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M189.295 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M184.684 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M180.072 408.094V417.987",
        stroke: "black",
        "stroke-width": "0.999999"
      }),
      createElementVNode("path", {
        d: "M235.411 408.766V417.984",
        stroke: "black",
        "stroke-width": "0.9"
      }),
      createElementVNode("path", {
        d: "M140.901 320.895C150.019 326.712 154.33 332.092 154.352 337.081C143.005 336.478 132.744 331.137 140.901 320.895Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M148.243 326.195C157.024 331.19 161.971 336.629 163.497 342.463C154.577 344.015 145.061 339.806 148.243 326.195Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M136.893 334.777C138.075 344.808 136.628 352.016 132.833 356.703C126.295 350.442 124.044 340.284 136.893 334.777Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M136.904 334.805C145.152 340.637 149.542 346.534 150.488 352.49C141.459 353.16 132.402 348.037 136.904 334.805Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M142.382 326.777L146.183 329.151L150.261 328.748L151.973 331.566C151.973 331.566 151.514 337.357 151.511 337.886C151.507 338.414 152.771 341.653 152.771 341.653L149.995 343.671L142.559 346.717L135.605 341.068L131.221 341.522L129.299 336.076L131.459 331.433L136.886 327.91L142.382 326.777Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M135.246 329.655C131.672 339.103 127.066 344.833 121.538 347.245C118.621 338.676 121.304 328.624 135.246 329.655Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M135.226 330.347C125.314 328.396 118.896 324.809 115.598 319.76C123.564 315.458 133.924 316.431 135.226 330.347Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M154.181 330.685C164.244 331.578 171.408 329.924 175.985 325.997C169.537 319.643 159.317 317.685 154.181 330.685Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M154.212 330.696C160.28 338.771 166.303 342.989 172.284 343.763C172.694 334.72 167.312 325.816 154.212 330.696Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M151.05 335.633C158.613 342.329 162.334 348.67 162.625 354.694C153.577 354.375 145.132 348.296 151.05 335.633Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M147.933 346.73C153.108 355.405 154.73 362.575 153.18 368.403C144.655 365.356 138.452 357.002 147.933 346.73Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M144.292 346.168C145.438 356.203 143.965 363.406 140.153 368.079C133.638 361.794 131.423 351.628 144.292 346.168Z",
        fill: "#008830",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M137.72 334.909C136.992 334.393 136.445 333.496 136.317 332.61C136.208 331.854 136.27 331.368 136.61 330.302C136.783 329.762 136.92 329.308 136.915 329.292C136.91 329.277 136.775 329.237 136.615 329.205C136.337 329.147 136.303 329.165 135.802 329.627C134.09 331.208 132.528 331.966 131.459 331.734C130.22 331.465 129.746 329.747 130.435 328.024C131.02 326.559 132.119 325.663 133.523 325.504C134.042 325.446 134.261 325.466 134.867 325.632C135.265 325.741 135.576 325.798 135.558 325.758C135.54 325.719 135.237 325.504 134.885 325.281C133.155 324.184 132.132 322.915 132.063 321.78C132.013 320.957 132.552 320.166 133.476 319.71C135.028 318.943 136.97 319.489 137.874 320.947C138.307 321.646 138.42 322.203 138.419 323.642C138.418 324.477 138.452 324.956 138.515 324.982C138.569 325.005 138.712 325.135 138.832 325.271L139.051 325.519L139.908 324.816C140.781 324.1 141.414 323.664 142.123 323.286C143.104 322.764 144.26 322.616 144.839 322.939C146.108 323.646 146.103 325.952 144.829 327.531C143.795 328.812 142.225 329.264 140.79 328.693C140.468 328.564 140.013 328.408 139.778 328.344L139.351 328.229L140.012 329.069C140.903 330.203 141.404 331.014 141.749 331.883C142.401 333.524 142.069 334.789 140.846 335.332C139.904 335.75 138.669 335.583 137.72 334.909Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M139.421 327.788C139.202 328.338 138.797 328.788 138.297 329.038C137.796 329.289 137.24 329.321 136.75 329.126C136.261 328.931 135.879 328.526 135.688 327.999C135.497 327.473 135.513 326.868 135.732 326.319C135.951 325.769 136.356 325.319 136.857 325.068C137.357 324.817 137.913 324.786 138.403 324.981C138.892 325.176 139.274 325.581 139.465 326.107C139.656 326.634 139.64 327.239 139.421 327.788Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M146.811 324.251C146.818 325.028 146.949 325.517 147.433 326.574C147.678 327.109 147.876 327.56 147.874 327.576C147.871 327.592 147.747 327.643 147.599 327.689C147.341 327.769 147.305 327.754 146.757 327.323C144.884 325.852 143.275 325.205 142.285 325.526C141.136 325.897 140.935 327.681 141.85 329.378C142.628 330.819 143.813 331.643 145.181 331.694C145.688 331.712 145.895 331.674 146.451 331.458C146.816 331.316 147.106 331.233 147.094 331.275C147.083 331.316 146.825 331.558 146.52 331.813C145.024 333.065 144.23 334.435 144.332 335.594C144.406 336.435 145.039 337.196 145.992 337.586C147.592 338.243 149.373 337.534 150.024 335.982C150.337 335.236 150.362 334.662 150.148 333.199C150.024 332.35 149.987 331.861 150.044 331.829C150.092 331.802 150.209 331.659 150.305 331.511L150.478 331.242L151.403 331.888C152.345 332.547 153.016 332.941 153.751 333.268C154.769 333.722 155.899 333.78 156.406 333.407C157.518 332.587 157.172 330.244 155.718 328.74C154.539 327.52 152.967 327.185 151.676 327.879C151.387 328.035 150.973 328.23 150.757 328.313L150.365 328.464L150.874 327.557C151.561 326.335 151.922 325.471 152.124 324.56C152.506 322.841 152.002 321.582 150.749 321.127C149.785 320.777 148.626 321.044 147.911 321.715C147.195 322.385 146.803 323.341 146.811 324.251Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.449764"
      }),
      createElementVNode("path", {
        d: "M146.921 328.816C147.182 328.269 147.626 327.827 148.155 327.587C148.684 327.348 149.255 327.331 149.741 327.54C150.228 327.749 150.592 328.167 150.751 328.702C150.911 329.236 150.854 329.845 150.593 330.392C150.332 330.94 149.888 331.382 149.359 331.621C148.83 331.861 148.259 331.878 147.772 331.669C147.285 331.46 146.922 331.042 146.762 330.507C146.602 329.972 146.659 329.364 146.921 328.816Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M135.662 346.222C135.459 345.327 135.477 344.729 135.747 343.384C135.884 342.702 135.99 342.13 135.982 342.112C135.975 342.095 135.819 342.069 135.636 342.057C135.317 342.035 135.281 342.062 134.767 342.705C133.012 344.905 131.338 346.084 130.112 345.985C128.691 345.869 127.976 343.873 128.568 341.675C129.071 339.806 130.21 338.538 131.77 338.109C132.347 337.95 132.595 337.938 133.293 338.036C133.752 338.1 134.107 338.116 134.083 338.072C134.059 338.027 133.696 337.819 133.277 337.609C131.217 336.576 129.933 335.215 129.735 333.856C129.592 332.869 130.114 331.823 131.103 331.116C132.765 329.927 135.006 330.259 136.175 331.866C136.736 332.638 136.922 333.292 137.073 335.031C137.16 336.041 137.25 336.613 137.323 336.634C137.387 336.652 137.56 336.785 137.71 336.93L137.982 337.192L138.87 336.198C139.776 335.186 140.44 334.551 141.197 333.975C142.243 333.178 143.527 332.804 144.211 333.096C145.712 333.736 145.95 336.524 144.686 338.647C143.661 340.369 141.944 341.18 140.272 340.732C139.897 340.632 139.369 340.519 139.098 340.483L138.606 340.416L139.437 341.319C140.559 342.538 141.208 343.434 141.688 344.426C142.593 346.298 142.355 347.883 141.038 348.745C140.024 349.409 138.62 349.416 137.615 348.839C136.61 348.262 135.9 347.271 135.662 346.222Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M138.638 339.87C138.45 340.571 138.043 341.183 137.507 341.571C136.971 341.958 136.35 342.091 135.78 341.938C135.209 341.785 134.737 341.36 134.467 340.756C134.197 340.152 134.15 339.419 134.338 338.718C134.526 338.017 134.933 337.405 135.469 337.017C136.005 336.63 136.626 336.497 137.196 336.65C137.766 336.803 138.239 337.228 138.509 337.832C138.779 338.436 138.826 339.169 138.638 339.87Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.45"
      }),
      createElementVNode("path", {
        d: "M148.377 336.769C148.201 337.648 148.233 338.232 148.53 339.539C148.681 340.201 148.798 340.758 148.792 340.775C148.785 340.792 148.633 340.821 148.455 340.837C148.144 340.867 148.108 340.841 147.59 340.226C145.822 338.121 144.157 337.011 142.963 337.139C141.578 337.287 140.93 339.254 141.562 341.386C142.1 343.198 143.244 344.409 144.778 344.789C145.345 344.93 145.588 344.936 146.267 344.823C146.713 344.749 147.06 344.724 147.037 344.768C147.015 344.812 146.666 345.025 146.262 345.24C144.276 346.3 143.056 347.661 142.897 348.993C142.781 349.961 143.317 350.97 144.301 351.636C145.953 352.756 148.133 352.376 149.235 350.777C149.764 350.009 149.929 349.366 150.033 347.663C150.093 346.675 150.166 346.114 150.238 346.092C150.299 346.073 150.465 345.938 150.608 345.794L150.867 345.531L151.759 346.479C152.669 347.446 153.333 348.049 154.086 348.593C155.128 349.345 156.391 349.679 157.052 349.377C158.501 348.714 158.665 345.986 157.378 343.943C156.334 342.287 154.637 341.537 153.015 342.016C152.651 342.124 152.138 342.246 151.875 342.289L151.396 342.367L152.185 341.463C153.25 340.245 153.862 339.355 154.306 338.374C155.143 336.523 154.871 334.981 153.564 334.171C152.557 333.548 151.185 333.576 150.218 334.164C149.251 334.753 148.583 335.739 148.377 336.769Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.450001"
      }),
      createElementVNode("path", {
        d: "M149.289 340.879C148.58 340.898 147.906 341.168 147.417 341.632C146.927 342.096 146.661 342.715 146.677 343.352C146.693 343.99 146.99 344.595 147.503 345.033C148.016 345.471 148.702 345.707 149.411 345.689C150.12 345.671 150.793 345.4 151.283 344.937C151.773 344.473 152.039 343.854 152.023 343.216C152.007 342.578 151.709 341.974 151.197 341.536C150.684 341.097 149.998 340.861 149.289 340.879Z",
        fill: "#F9D90F",
        stroke: "black",
        "stroke-width": "0.450001"
      }),
      createElementVNode("path", {
        d: "M283.679 361.85H278.595V358.237H274.264V354.109H269.306L269.302 327.908L263.655 318.027L258.008 327.908V354.109H253.05V358.237H248.719V361.85H243.635V367.183L283.679 367.297V361.85Z",
        fill: "white",
        stroke: "black",
        "stroke-width": "0.800001"
      }),
      createElementVNode("path", {
        d: "M203.576 526.322C223.922 526.387 248.946 522.234 260.667 516.174L286.41 513.894L286.923 545.303C265.116 557.326 214.763 559.909 203.685 559.822C192.597 559.909 141.623 557.283 119.718 545.215L120.001 513.785L145.799 516.107C157.52 522.137 183.307 526.322 203.631 526.322H203.576Z",
        fill: "#F9D90F"
      }),
      createElementVNode("path", {
        d: "M119.718 545.218L146.265 539.146L119.806 535.359L119.718 545.218Z",
        fill: "#F9B60F"
      }),
      createElementVNode("path", {
        d: "M53.4459 392.354L76.1252 399.571L69.2668 436.288L47.7978 439.623C47.7978 439.623 44.1779 420.316 53.4459 392.332",
        fill: "#F9D90F"
      }),
      createElementVNode("path", {
        d: "M47.7979 439.62L61.7435 420.379L69.2668 436.285L47.7979 439.62Z",
        fill: "#F9B60F"
      }),
      createElementVNode("path", {
        d: "M53.4459 392.354L76.1252 399.571L69.2668 436.288L47.7978 439.623C47.7978 439.623 44.1779 420.316 53.4459 392.332V392.354Z",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M119.718 545.217L146.434 539.145",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M61.7646 420.262L69.2669 436.284",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M286.923 545.3L260.375 539.228L286.834 535.441L286.923 545.3Z",
        fill: "#F9B60F"
      }),
      createElementVNode("path", {
        d: "M353.194 392.444L330.515 399.66L337.373 436.378L358.842 439.713C358.842 439.713 362.462 420.406 353.194 392.422",
        fill: "#F9D90F"
      }),
      createElementVNode("path", {
        d: "M358.842 439.714L344.897 420.473L337.373 436.379L358.842 439.714Z",
        fill: "#F9B60F"
      }),
      createElementVNode("path", {
        d: "M353.194 392.444L330.515 399.66L337.373 436.378L358.842 439.713C358.842 439.713 362.462 420.406 353.194 392.422V392.444Z",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M286.923 545.307L260.206 539.234",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M344.875 420.352L337.373 436.374",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M203.576 526.326C223.922 526.391 248.946 522.238 260.667 516.178L286.41 513.898L286.923 545.306C265.116 557.33 214.763 559.913 203.685 559.826C192.597 559.913 141.623 557.287 119.718 545.219L120.001 513.789L145.799 516.111C157.52 522.141 183.307 526.326 203.631 526.326H203.576Z",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M366.758 418.887L344.897 420.466C344.406 438.989 342.16 509.675 257.745 513.512L260.373 539.229C363.127 540.296 370.934 452.529 366.758 418.887Z",
        fill: "#F9D90F"
      }),
      createElementVNode("path", {
        d: "M366.758 418.887L344.897 420.466C344.406 438.989 342.16 509.675 257.745 513.512L260.373 539.229C363.127 540.296 370.934 452.529 366.758 418.887Z",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M39.8818 418.805L61.7433 420.384C62.2338 438.907 64.4801 509.593 148.895 513.43L146.267 539.147C43.5126 540.214 35.7057 452.447 39.8818 418.805Z",
        fill: "#F9D90F"
      }),
      createElementVNode("path", {
        d: "M39.8818 418.805L61.7433 420.384C62.2338 438.907 64.4801 509.593 148.895 513.43L146.267 539.147C43.5126 540.214 35.7057 452.447 39.8818 418.805Z",
        stroke: "black",
        "stroke-width": "0.40063"
      }),
      createElementVNode("path", {
        d: "M189.244 541.802C188.666 542.172 187.881 542.271 186.976 542.227L182.898 542.02L183.247 536.93L187.292 537.147C188.088 537.201 188.721 537.355 189.113 537.594C189.931 538.019 190.291 538.805 190.214 539.894C190.16 540.831 189.833 541.443 189.233 541.802M182.386 549.815L182.789 543.611L187.543 543.939C189.08 544.059 190.225 543.656 190.999 542.87C191.806 542.107 192.221 541.105 192.275 539.971C192.373 538.651 192.035 537.572 191.25 536.776C190.498 536.013 189.429 535.61 188.088 535.48L181.295 535.055L180.358 549.662L182.375 549.794",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M197.841 537.59L202.813 537.644C203.533 537.709 204.1 537.797 204.514 537.993C205.277 538.353 205.637 539.072 205.637 540.119C205.637 541.101 205.354 541.755 204.798 542.148C204.263 542.506 203.489 542.67 202.562 542.67L197.787 542.615L197.83 537.59M197.754 550.53L197.798 544.294L202.464 544.361C203.293 544.361 203.904 544.425 204.329 544.632C205.016 544.948 205.354 545.614 205.386 546.529L205.506 548.982C205.539 549.571 205.55 549.931 205.583 550.17C205.648 550.345 205.681 550.53 205.768 550.662H208.276L208.232 550.345C207.949 550.192 207.72 549.899 207.622 549.451C207.535 549.167 207.491 548.742 207.469 548.208L207.425 546.257C207.393 545.374 207.24 544.764 206.902 544.425C206.608 544.033 206.204 543.695 205.583 543.488C206.281 543.118 206.804 542.693 207.186 542.168C207.545 541.591 207.731 540.86 207.731 539.967C207.731 538.289 207.044 537.143 205.648 536.523C204.896 536.185 203.936 536.009 202.802 535.988L195.792 535.922L195.737 550.574H197.754",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M214.363 547.472C213.469 546.383 212.989 545.021 212.88 543.407C212.782 541.379 213.175 539.832 214.102 538.784C215.039 537.65 216.25 537.106 217.831 537.019C219.422 536.932 220.731 537.444 221.701 538.446C222.694 539.428 223.261 540.791 223.359 542.492C223.413 544.126 223.13 545.576 222.377 546.851C221.636 548.149 220.404 548.88 218.583 548.922C216.686 549.022 215.268 548.575 214.363 547.472ZM211.964 538.25C211.027 539.7 210.645 541.379 210.743 543.407C210.885 545.597 211.561 547.408 212.837 548.771C214.254 550.133 216.13 550.819 218.441 550.688C220.916 550.579 222.781 549.642 224.046 547.92C225.07 546.362 225.561 544.551 225.452 542.316C225.31 540.321 224.732 538.697 223.653 537.487C222.29 535.862 220.295 535.144 217.591 535.253C215.039 535.415 213.164 536.353 211.954 538.25",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M49.8913 446.007L50.2293 447.837C49.4116 448.001 48.7574 448.329 48.2776 448.754C47.4162 449.56 47.1218 450.771 47.4162 452.417C47.5472 453.114 47.7978 453.801 48.1141 454.347C48.7685 455.459 49.6187 455.905 50.6982 455.73C51.4942 455.589 52.0176 455.284 52.2683 454.717C52.5082 454.16 52.6829 453.31 52.7373 452.221L52.8354 450.16C52.9026 448.884 53.0424 447.882 53.3259 447.325C53.7727 446.322 54.6126 445.701 55.8664 445.495C57.2076 445.254 58.3852 445.559 59.3992 446.322C60.4241 447.031 61.1001 448.263 61.3509 449.898C61.6674 451.392 61.5256 452.733 60.9363 453.942C60.3692 455.121 59.279 455.839 57.6107 456.144L57.2835 454.292C58.0576 454.009 58.6356 453.735 59.0172 453.355C59.6717 452.623 59.8676 451.567 59.6165 450.117C59.4203 448.939 59.0172 448.175 58.4062 447.795C57.8069 447.347 57.2069 447.173 56.5527 447.283C55.8221 447.392 55.3424 447.795 55.1134 448.449C54.9716 448.884 54.8627 449.789 54.7646 451.174L54.6666 453.31C54.6128 454.313 54.4596 455.143 54.1216 455.709C53.5875 456.755 52.6823 457.398 51.363 457.605C49.6948 457.889 48.4081 457.507 47.4923 456.439C46.5546 455.392 45.9766 454.139 45.6823 452.58C45.3551 450.726 45.5949 449.287 46.3367 448.133C47.0891 446.945 48.2776 446.258 49.8913 446.029",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M48.9644 465.335L63.3787 460.996L66.737 471.144L64.9815 471.7L62.2339 463.361L57.8507 464.681L60.3912 472.387L58.712 472.921L56.1933 465.193L51.3086 466.653L54.0998 475.178L52.3771 475.67L48.9644 465.335Z",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M55.3542 482.929L68.6129 475.898L70.0304 478.372L60.915 488.009L74.2282 485.731L75.602 488.184L62.3761 495.172L61.4384 493.547L69.2453 489.438C69.5288 489.274 69.9649 489.034 70.5973 488.697C71.2189 488.413 71.9166 488.031 72.6145 487.671L59.3558 489.928L58.3854 488.205L67.4353 478.601L66.9992 478.82C66.7157 478.982 66.2251 479.223 65.56 479.604C64.9055 480.008 64.4151 480.258 64.0989 480.389L56.3138 484.564L55.3543 482.908",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M80.0612 502.457C79.396 502.306 78.7419 501.923 78.0986 501.258L75.2964 498.369L79.069 494.913L81.893 497.792C82.4379 498.327 82.7871 498.849 82.9725 499.297C83.2338 500.157 82.9725 500.943 82.1765 501.683C81.4569 502.348 80.7372 502.621 80.0612 502.457ZM69.4085 503.798L74.0316 499.557L77.3135 502.882C78.3712 503.962 79.4506 504.452 80.5846 504.431C81.7403 504.365 82.7326 503.94 83.6048 503.111C84.5862 502.239 85.055 501.214 85.055 500.114C85.0415 499.045 84.5537 498.043 83.6485 497.106L78.9382 492.297L67.9692 502.37L69.3867 503.798",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M82.6345 515.57L90.5832 503.109L99.982 508.822L99.0007 510.305L91.281 505.683L88.8931 509.455L95.9913 513.76L95.0754 515.189L87.9663 510.905L85.2622 515.123L93.0801 519.822L92.1424 521.294L82.6345 515.57Z",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M106.164 513.162L110.94 514.678C111.616 514.884 112.107 515.146 112.434 515.441C113.044 516.019 113.208 516.847 112.848 517.849C112.554 518.722 112.107 519.288 111.409 519.529C110.787 519.637 110.002 519.637 109.086 519.354L104.583 517.916L106.164 513.162ZM102.043 525.404L104.027 519.463L108.476 520.913C109.272 521.121 109.85 521.404 110.133 521.698C110.678 522.188 110.842 522.919 110.569 523.825L109.904 526.189C109.752 526.767 109.675 527.148 109.61 527.323C109.61 527.509 109.61 527.706 109.643 527.835L111.988 528.598L112.129 528.26C111.879 528.064 111.737 527.706 111.748 527.259C111.802 526.985 111.879 526.55 112.031 526.047L112.598 524.151C112.828 523.322 112.915 522.701 112.707 522.255C112.533 521.785 112.238 521.36 111.748 520.957C112.489 520.825 113.133 520.597 113.678 520.193C114.19 519.746 114.626 519.125 114.888 518.254C115.422 516.672 115.128 515.353 113.95 514.35C113.362 513.828 112.522 513.38 111.421 512.966L104.748 510.906L100.081 524.805L102.033 525.404",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M279.855 516.151C281.266 515.936 282.485 516.025 283.59 516.426C285.216 516.968 286.295 518.199 286.948 520.064L284.926 520.31C284.508 519.3 283.9 518.602 283.067 518.205C282.256 517.831 281.233 517.724 280.052 517.878C278.675 518.06 277.561 518.725 276.767 519.813C275.983 520.975 275.725 522.542 276.026 524.552C276.279 526.216 276.864 527.632 277.85 528.587C278.759 529.563 280.116 529.926 281.897 529.708C283.231 529.514 284.309 529.001 285.078 528.098C285.879 527.241 286.132 525.926 285.902 524.22L281.19 524.855L280.98 523.238L287.539 522.353L288.673 530.126L287.372 530.299L286.598 528.496C286.038 529.294 285.482 529.905 284.995 530.255C284.177 530.874 283.08 531.257 281.713 531.428C279.942 531.668 278.335 531.322 276.891 530.358C275.31 529.141 274.307 527.356 273.959 524.897C273.578 522.481 273.997 520.427 275.139 518.823C276.225 517.274 277.778 516.386 279.855 516.129",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M294.669 515.285L299.388 513.67C300.036 513.443 300.593 513.376 301.072 513.44C301.932 513.521 302.555 514.044 302.896 515.075C303.218 515.953 303.204 516.716 302.812 517.245C302.399 517.792 301.759 518.185 300.837 518.505L296.404 520.005L294.669 515.285ZM299.136 527.481L296.954 521.564L301.343 520.073C302.165 519.827 302.735 519.695 303.159 519.748C303.931 519.859 304.512 520.34 304.888 521.239L305.839 523.493C306.047 524.052 306.215 524.393 306.354 524.549C306.416 524.747 306.555 524.869 306.662 525.001L309.044 524.173L308.918 523.855C308.57 523.848 308.235 523.646 307.992 523.259C307.811 522.984 307.644 522.588 307.402 522.126L306.661 520.28C306.327 519.478 305.976 518.982 305.567 518.679C305.157 518.442 304.636 518.28 304.016 518.226C304.506 517.678 304.865 517.128 305.007 516.477C305.161 515.816 305.109 515.073 304.808 514.239C304.237 512.67 303.152 511.799 301.606 511.662C300.789 511.582 299.848 511.739 298.762 512.1L292.135 514.324L297.203 528.197L299.146 527.524",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M316.417 520.536L308.278 508.185L317.564 502.5L318.551 503.991L310.941 508.659L313.446 512.434L320.472 508.092L321.394 509.537L314.368 513.88L317.128 518.041L324.87 513.286L325.857 514.744L316.406 520.536",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M324.126 499.104L326.572 496.51C327.706 495.353 328.893 494.84 330.176 495.016C331.461 495.149 332.757 495.848 334.13 497.095C334.506 497.396 334.837 497.784 335.178 498.215C335.774 499.022 336.121 499.727 336.337 500.428C336.517 501.304 336.459 502.099 336.14 502.857C335.948 503.234 335.613 503.675 335.112 504.201L332.655 506.773L324.126 499.083M336.689 505.057C338.424 503.215 338.831 501.205 337.881 498.909C337.325 497.665 336.464 496.45 335.262 495.382C333.75 493.991 332.16 493.264 330.473 493.104C328.6 492.927 326.996 493.575 325.584 495.063L321.416 499.37L332.509 509.409L336.678 505.08",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M345.628 493.854L332.795 485.998L333.883 484.34L346.739 492.152L345.639 493.876",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M350.881 485.096L336.975 479.236L341.287 469.458L342.975 470.143L339.458 478.202L343.647 479.937L346.934 472.516L348.535 473.212L345.281 480.621L349.967 482.624L353.573 474.47L355.261 475.143L350.87 485.095",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M357.627 468.011L342.948 464.483L343.48 462.214L357.18 457.863L345.269 455.006L345.738 453.227L360.419 456.667L359.91 458.871L346.186 463.321L358.098 466.122L357.638 468.011",
        fill: "#012A87"
      }),
      createElementVNode("path", {
        d: "M356.803 449.274L357.022 447.424C357.872 447.462 358.594 447.344 359.144 447.06C360.223 446.501 360.864 445.413 361.058 443.791C361.137 443.03 361.117 442.363 360.954 441.728C360.66 440.502 359.985 439.813 358.886 439.684C358.07 439.582 357.478 439.767 357.045 440.207C356.654 440.713 356.237 441.445 355.912 442.487L355.201 444.404C354.742 445.66 354.323 446.524 353.878 447.007C353.163 447.911 352.176 448.209 350.924 448.099C349.586 447.933 348.506 447.379 347.75 446.34C346.972 445.388 346.669 444.041 346.895 442.387C347.054 440.875 347.579 439.609 348.491 438.601C349.337 437.679 350.632 437.254 352.275 437.459L352.088 439.309C351.281 439.294 350.636 439.424 350.161 439.743C349.302 440.196 348.815 441.179 348.647 442.626C348.505 443.824 348.654 444.633 349.101 445.252C349.549 445.773 350.121 446.109 350.796 446.176C351.514 446.255 352.085 446.036 352.488 445.489C352.778 445.111 353.131 444.289 353.614 442.957L354.316 440.942C354.66 440.01 355.066 439.298 355.533 438.794C356.366 437.959 357.441 437.619 358.78 437.742C360.412 437.945 361.566 438.644 362.143 439.897C362.709 441.161 362.913 442.55 362.742 444.117C362.524 445.889 361.921 447.275 360.836 448.193C359.75 449.131 358.414 449.434 356.803 449.274Z",
        fill: "#012A87"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1518_57409" }, [
        createElementVNode("rect", {
          width: "800",
          height: "800",
          rx: "400",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$X(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M25.8 9.3H15.4V7c-.8.5-1.5 1.1-2.3 1.7c-1.7 1.4-3.3 3-4.6 4.7h2.8v8.1H3.9C2.7 24.8 2 28.3 2 32c0 3.5.6 6.9 1.7 10h22V21.6H15.4v-8.2h10.4V9.3",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M32 2c-2.1 0-4.2.2-6.2.6v58.7c2 .4 4.1.6 6.2.6c16.6 0 30-13.4 30-30C62 15.4 48.6 2 32 2",
      fill: "#0091c8"
    }),
    createElementVNode("path", {
      d: "M61.5 32.3c0-.2.3-.7.5-1.2v-.9c-.2.4-.4.7-.4.9c-.2.6-.4.2-.4-1.6c-.1-1.4 0-2.8.2-4.1c-.7-3.3-2-6.4-3.8-9.2c-.4.1-.7.2-.7.2s.2-.3.4-.7c-.1-.1-.2-.3-.3-.4c-.6.8-1.2 1.5-1.3 1.5c-.2.1-.9.3-1.7.6l-1.4.6l1.1-1c.6-.5 1.7-1.6 2.5-2.3l.2-.2c-.1-.1-.2-.2-.2-.3l-1.5 1.4c-1.6 1.5-3.2 2.9-3.4 3c-.2.1-.5.3-.5.5c-.1.3 0 .7.3.8c.2.1.1.3-.5 1.1c-.8 1.1-1.5 2.4-2 3.7l-.4 1l-.2-.9c-.3-1.1-.6-2.7-.6-3.8c0-1 0-1 .7-1.9c.8-1.1 2.7-3.1 3.7-3.9c.4-.3 1.1-.8 1.6-1c1-.5 1.3-.7 1.3-1c0-.4-.3-.6-.8-.5c-.3.1-1.4-.1-3.3-.5c-1.6-.3-2.9-.6-3-.6c0 0 .1-.6.3-1.2c.2-.8.4-1.3.6-1.5c.4-.4.4-.9 0-1.2c-.6-.6-1.6-.1-1.5.8l.1.4l-.8.1c-.5.1-1.6.3-2.4.5c-1.8.5-3.1.6-4 .2c-.3-.1-.5-.2-.5-.2v.3c0 .5.3 1 .9 1.3l.5.3l-.4.1c-.2.1-.8.1-1.3 0s-.9 0-.9 0c0 .3.6 1 1 1.2c.9.5 2.7.3 4.8-.4c1-.4 2.4-.5 2.3-.2c0 .2-1.8 1.5-4.9 3.7c-1.6 1.1-1.8 1.4-1.6 1.9c.1.3.1.4-.3 1c-.8 1.4-1.6 3.8-1.6 5c0 .6 0 .7-.9 1.6c-1.7 1.8-5.1 6-5.8 7.3l-.2.3l-.2-.3c-.5-.6-1.5-.3-1.5.5c0 .5.3.8.9.8c.3 0 1 .3 2.1.8l1.7.8l-.4.5c-.6.7-.7 1.2-.4 1.6c.2.2.3.2 1.1.2s1 .1 1.9.5c.9.4 1.2.7 2.5 2c3.8 3.9 4.8 4.9 6.9 6.2c.6.3 1.1.5 1.3.5c.2-.1.6-.4 1-.8c1.7-2 3.1-1.5 6.3.3c1.6.9 2.2 1.1 2.4 1.1v-.2c.4-1.8 1-2.4 2.4-2.6c.8-1.7 1.5-3.5 2-5.4h-2.3l-1.3-.1l.1-.4c.1-.6.5-1.3 1.1-1.9c.3-.3.5-.6.6-.6c0 0 .4.2.9.5c.4.3.9.6 1.3.8c.2-1.1.4-2.3.5-3.4c-.3-.8-.5-1.7-.4-2m-14.7-18c.3-1.2.6-2.3.7-2.3c.1 0 1.1.2 2.3.5c2.7.5 2.7.6 2.2.7c-.2.1-1.5.4-2.8.8l-2.5.7l.1-.4M36.1 35.2h-.4c-.5-.1-4.3-1.8-4.3-2c0-.5 3.6-5.1 5.7-7.3l.8-.8v.4c0 .2.1.8.2 1.2l.2.8l-1.1 3.9l-1.1 3.8m4 2c-.1 0-.8-.3-1.5-.8c-.7-.4-1.5-.8-1.7-.9l-.4-.1l1-3.5c.5-1.9 1-3.5 1-3.5c.1 0 .2.3.4.7c.2.5.3.9.3 2v1.3h.8v1.1c0 .6.1 1.6.3 2.1c.2 1 .2 1.6-.2 1.6m1.6-9.3l-.4 1.2h-.9c-.5 0-.9 0-1-.1c-.2-.2 0-1.1.3-1.6s1.2-1 1.8-1c.2 0 .4 0 .4.1c.2.1 0 .7-.2 1.4m2.4 1.3h-1.2l.1-.4c.1-.2.2-.6.3-1l.2-.7l.4.3c.3.2.6.6.9.9c.2.3.4.6.4.7c0 .1-.5.2-1.1.2m.3-13.9c-.5.1-1.4.4-1.9.5c-.5.1-.8.2-.8.2c.1-.1 4.2-3.1 4.3-3.1v.2c0 .1-.2.6-.3 1.1l-.3.8l-1 .3m4.8 21.8c-1.1-.8-2.2-2.2-2.8-3.7c-.4-.9-.4-1-.1-1c.2 0 .2-.3.2-1.6v-1.6h-.4c-.3 0-.4-.1-.5-.5c-.1-.3-.2-1.2-.2-2.3c0-1.9.2-2.7 1-4.5c.4-1 .6-.9.6.1c0 .7.3 2.2.7 3.3c.3.8.3 1 .2 1.5c-.1.3-.2 1.1-.3 1.9c-.2 2.4.2 4.7 1.2 6.9c.3.6.6 1.3.6 1.5l.1.3l-.3-.3m3.3-2.6c0 .1-.3.9-.6 1.8s-.6 1.7-.6 1.8c0 .1-.3 0-.6-.1c-.4-.2-.5-.3-.7-.9c-.2-.6-.2-.7.2-1.2c.4-.7 1-1.2 1.7-1.3c.6-.3.6-.3.6-.1m3.5 4.9c-.4 0-1.2-.2-1.9-.3l-1.3-.3l.3-1c.2-.5.5-1.5.6-2.1c.3-1.1.4-1.2.9-1c.2.1.3.3.5 1.1c.2.7.5 1.5.9 2.4l.7 1.3l-.7-.1m2.2-2.3c-.3.4-.7.9-.8 1.2c-.1.3-.2.6-.3.7c-.2.3-1.7-3.1-1.7-3.8c0-.3.5-.1 2 .6l1.3.6l-.5.7",
      fill: "#ffce31"
    }),
    createElementVNode("g", { fill: "#3e4347" }, [
      createElementVNode("path", { d: "M56.6 47.6v.2c-.2 0-.8-.2-2.4-1.1c-3.2-1.9-4.6-2.4-6.3-.3c-.4.4-.8.7-1 .8c-.2-.1-.7-.2-1.3-.5c-.2-.1-.5-.2-.7-.3c-1.9-1-3.3-1.3-4.4-1c-.7.2-1.2.6-1.5 1.3c-.2.4-.4.7-.6.7c-.5.1-2.2-.9-2.8-1.3c-2.3-1.4-3.7-1.5-5.8-.1c-.4.3-.8.5-1 .5c-.1 0-.5-.1-.9-.2c-.5-.2-.9-.4-1-.5c-.2-.4-.6-.6-1-.5l-.1.1V47c.3.3.8.6 1.5.8c1.6.6 2 .5 3.5-.5c1.4-.9 2.1-1 3.8.1c1.9 1.2 3.1 1.8 4.2 1.5c.9-.2 1.4-1 1.7-1.6c.2-.3.3-.4.5-.4c.3-.1 1.1-.1 3 .8c.2.1 2.1 1.1 2.9 1.1c.5 0 1.1-.4 1.5-.7c.4-.3.7-.6.8-.7c.8-.9 1-1.1 4.1.7c1.3.8 2.3 1.2 3.1 1.3c.3-.4.6-.8.9-1.3l.2-.3c.4-.6.8-1.3 1.1-2l.1-.2c.1-.3.3-.5.4-.8c-1.5.4-2.1 1-2.5 2.8" }),
      createElementVNode("path", { d: "M25.5 34l.3.2v-.5z" }),
      createElementVNode("path", { d: "M23.1 34l1.3.3l.3-.3l-.3-.4z" }),
      createElementVNode("path", { d: "M24.8 33.3l.3.3l.4-.3l-.4-1.3z" }),
      createElementVNode("path", { d: "M25.8 37.2v-1.7l-.6-1.2H25l-1.3 2.9h.8l.5.7h.2l.5-.7h.1" }),
      createElementVNode("path", { d: "M17.5 34l.3.3l1.3-.3l-1.3-.4z" }),
      createElementVNode("path", { d: "M15 34l1.3.3l.3-.3l-.3-.4z" }),
      createElementVNode("path", { d: "M16.7 33.3l.3.3l.4-.3L17 32z" }),
      createElementVNode("path", { d: "M16.9 34.3l-1.3 2.9h.9l.4.7h.2l.5-.7h.8l-1.3-2.9z" }),
      createElementVNode("path", { d: "M9.4 34l.3.3L11 34l-1.3-.4z" }),
      createElementVNode("path", { d: "M8.5 34l-.3-.4l-1.3.4l1.3.3z" }),
      createElementVNode("path", { d: "M8.6 33.3l.4.3l.3-.3L9 32z" }),
      createElementVNode("path", { d: "M8.8 34.3l-1.2 2.9h.8l.4.7h.3l.4-.7h.9l-1.3-2.9z" }),
      createElementVNode("path", { d: "M25 23.7h.2l.5-.7h.1v-1.4h-1.4l-.7 1.4h.8z" }),
      createElementVNode("path", { d: "M16.9 23.7h.2l.5-.7h.8l-.6-1.4h-1.5l-.7 1.4h.9z" }),
      createElementVNode("path", { d: "M8.8 23.7h.3l.4-.7h.9l-.7-1.4H8.2L7.6 23h.8z" }),
      createElementVNode("path", { d: "M6.9 27l-1.3-.4l-.3.4l.3.3z" }),
      createElementVNode("path", { d: "M4.5 27l-.3-.4l-1.3.4l1.3.3z" }),
      createElementVNode("path", { d: "M5.3 26.3L4.9 25l-.3 1.3l.3.3z" }),
      createElementVNode("path", { d: "M4.8 27.3l-1.3 2.9h.8l.5.7H5l.4-.7h.9L5 27.3z" }),
      createElementVNode("path", { d: "M15 27l-1.3-.4l-.3.4l.3.3z" }),
      createElementVNode("path", { d: "M12.6 27l-.3-.4l-1.3.4l1.3.3z" }),
      createElementVNode("path", { d: "M13.3 26.3L13 25l-.3 1.3l.3.3z" }),
      createElementVNode("path", { d: "M12.9 27.3l-1.3 2.9h.8l.5.7h.2l.4-.7h.9l-1.3-2.9z" }),
      createElementVNode("path", { d: "M23.1 27l-1.3-.4l-.3.4l.3.3z" }),
      createElementVNode("path", { d: "M20.7 27l-.3-.4l-1.3.4l1.3.3z" }),
      createElementVNode("path", { d: "M21.4 26.3l-.3-1.3l-.4 1.3l.4.3z" }),
      createElementVNode("path", { d: "M21 27.3l-1.3 2.9h.8l.5.7h.2l.4-.7h.9l-1.3-2.9z" }),
      createElementVNode("path", { d: "M13.4 41.5l.3.3l1.3-.3l-1.3-.4z" }),
      createElementVNode("path", { d: "M11 41.5l1.3.3l.3-.3l-.3-.4z" }),
      createElementVNode("path", { d: "M12.7 40.8l.3.3l.3-.3l-.3-1.3z" }),
      createElementVNode("path", { d: "M21.5 41.5l.3.3l1.3-.3l-1.3-.4z" }),
      createElementVNode("path", { d: "M19.1 41.5l1.3.3l.3-.3l-.3-.4z" }),
      createElementVNode("path", { d: "M20.7 40.8l.4.3l.3-.3l-.3-1.3z" })
    ]),
    createElementVNode("g", { fill: "#ed4c5c" }, [
      createElementVNode("path", { d: "M22.7 21.6l-7.3-6v6h10.4h-1.4z" }),
      createElementVNode("path", { d: "M18.9 9.3h6.9V3.7z" }),
      createElementVNode("path", { d: "M18.9 13.4l6.9 5.6v1.4v-7z" }),
      createElementVNode("path", { d: "M3.9 21.5v.1h7.3v-6.1z" })
    ]),
    createElementVNode("path", {
      fill: "#dc241f",
      d: "M25.8 2.6v.5v-.5"
    }),
    createElementVNode("g", { fill: "#699635" }, [
      createElementVNode("path", { d: "M25.8 20.4V19l-6.9-5.6h-3.5v2.2l7.3 6h3.1v-.3z" }),
      createElementVNode("path", { d: "M25.8 3.1v-.5c-3.5.7-6.9 2.1-9.8 4c-.2.1-.4.2-.6.4v2.3h3.5l6.9-5.6v-.6" }),
      createElementVNode("path", { d: "M8.5 13.4c-1.9 2.4-3.5 5.1-4.6 8.1l7.3-6v-2.1H8.5" })
    ]),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M53.3 48.2c-3.1-1.8-3.3-1.6-4.1-.7c-.1.1-.4.4-.8.7c-.4.4-1 .7-1.5.7c-.8 0-2.7-1-2.9-1.1c-1.9-1-2.7-.9-3-.8c-.1 0-.3.1-.5.4c-.3.6-.8 1.4-1.7 1.6c-1.1.3-2.3-.3-4.2-1.5c-1.8-1.1-2.5-1-3.8-.1c-1.5 1-1.9 1-3.5.5c-.7-.2-1.2-.5-1.5-.8v.5c.3.4.9.8 1.8 1.1c1.6.6 2 .5 3.5-.5c1.4-.9 2.1-1 3.8.1c1.9 1.2 3.1 1.8 4.2 1.5c.9-.2 1.4-1 1.7-1.6c.2-.3.3-.4.5-.4c.3-.1 1.1-.1 3 .8c.2.1 2.1 1.1 2.9 1.1c.7 0 1.5-.7 2-1.2l.3-.3c.8-.9 1-1.1 4.1.7c.9.5 1.7.9 2.3 1.2c.2-.2.3-.4.5-.6c-.8-.1-1.8-.6-3.1-1.3" }),
      createElementVNode("path", { d: "M32.7 51.7c.8-.1 1.4 0 2.5.7c2.2 1.2 3.1 1.3 4.5.4c1.7-1 2.4-1.2 3.8-.9c1 .2 1.1.2.7-.2c-.9-.8-2.6-.8-4.1 0c-1.8.9-2.6.9-4.6 0c-1.8-.8-2.4-.9-3.3-.3c-.6.4-.5.4.5.3" }),
      createElementVNode("path", { d: "M49.9 52.5c-1.4-.3-1.6-.1-.3.6c1 .5 2 .6 3.6.2c.4-.4.8-.9 1.2-1.3c-2 .6-3.4.8-4.5.5" }),
      createElementVNode("path", { d: "M47.4 55.9c-1.5 1.2-2.4 1.2-4 .1c-1.4-1-2.4-1-4.2-.1c-1.1.5-1.3.7-.9.8c.3.1.9 0 1.5-.2c1.4-.6 2.1-.6 3.8.5c.9.5 1.7 1 1.9 1s.8-.4 1.5-.8c1.4-.9 2.1-1.3 3-1.2c.3-.2.5-.4.8-.6c-1.6-.7-2.1-.6-3.4.5" }),
      createElementVNode("path", { d: "M41.6 59.2c-1.2-.9-2.4-.9-4.2 0c-1.7.8-2.2.8-4.3-.7c-1.7-1.2-1.8-1.2-2.8-.8c-.4.2-.8.5-1 .8c-.4.5-.3.5.2.3c.8-.4 2.1-.4 2.4 0c.1.2.8.7 1.5 1.1c1.6 1 3 1.1 4.6.1c1.3-.7 2.1-.8 3.9-.2c.5.1.4 0-.3-.6" })
    ]),
    createElementVNode("g", { fill: "#ed4c5c" }, [
      createElementVNode("path", { d: "M20.6 59.5c-.3-.1-.2-.4 0-.4c.3-.1.6.2 1.4.2c.2 0 .4 0 .4-.4c0-.5-.4-.9-1.8-.7c-1.1.2-2 .2-2.6.1v.5c.8.4 1.5.8 2.3 1.1c.1-.3.2-.4.3-.4" }),
      createElementVNode("path", { d: "M3.7 42c.7 1.8 1.5 3.6 2.5 5.3c.5.5 3.2 3.5 2.5 3.7c1.7 2 3.6 3.8 5.7 5.4c.2 0 7.3 3.6 7.1 3.8c1.4.5 2.8.9 4.3 1.2V42H3.7" })
    ]),
    createElementVNode("g", { fill: "#ffe62e" }, [
      createElementVNode("path", { d: "M23.5 48.6c-.1-.2-.2-.3-.5-.2c-.8.2-3 .1-3.7-.3c1.1.4 2.4-.4 2.4-1.1c0-.8-1-1.4-3.2-1c-2.1.4-4.7.2-4.7-.4c0-.6 1.9-.7 2.8-.6c1 .1 1.6.2 3.4-.3c-.4.1-1.9.2-3-.1c-1.1-.3-3.9-.3-3.9 1s2.9 1.2 5.5.9c1.5-.2 2.3-.1 2.3.4c0 .4-1.4.6-2.4.5c-1-.1-2.1-.1-3.4.2c-2.2.6-4.8.2-5.4-.8c0-.1.1-.2.1-.4c.2-.1.3-.4.4-.6c.1-.5-.1-.5-.7-.3c-.2-.2-.6-.3-1.2-.3s-.9.1-1.2.3c-.6-.2-.8-.2-.7.3c.1.2.2.5.4.6c0 .7.9 1.8.9 1.8c-.5 0-1.1-.4-1.6-.9c.5.8.9 1.5 1.5 2.2c.2.2.3.3.4.5c.2.3.5.6.7.9c.7-.1 1.3-.4 2-.9c.4 0 3.1-.1 4.2-.6c.7.7.8.6 1.4.7c.6.1 1 .1.6.4c-.1.1-.8.1-1.2.1c-1.1 0-1.6-.6-1.9-.3c-.2.3 0 .4.4.4c-.3 0-.7 0-.6.3c.1.5.7-.1.9.1c-.2 0-.5.1-.5.2c0 .2.4.4.9 0c.3-.2.6-.2.8-.2c.7 0 2.4.3 3-.2c.2-.2-.1-.4-.3-.6c-.2-.2-.3-.4-.2-.9c.6.1 1.4.1 2.6-.1c1.4-.2 1.8.2 1.8.7c0 .4-.3.4-.4.4c-.8 0-1.1-.2-1.4-.2c-.2.1-.3.3 0 .4c-.2.1-.2.3-.1.4c.1.1.4 0 .7-.1c-.3.1-.6.3-.4.5c.1.1.3.2.6 0c.2-.3.7-.4.9-.5c.9.2 1.4-1.3 1-2.3" }),
      createElementVNode("path", { d: "M23.5 57.2c-.1-.2-.2-.3-.5-.2c-.8.2-3 .1-3.7-.3c1.1.4 2.4-.4 2.4-1.1c0-.8-1-1.4-3.2-1c-2.1.4-4.7.2-4.7-.4s1.9-.7 2.8-.6c1 .1 1.6.2 3.4-.3c-.4.2-1.9.2-3-.1c-1.1-.3-3.9-.3-3.9 1s2.9 1.2 5.5.9c1.5-.2 2.3-.1 2.3.4c0 .4-1.4.6-2.4.5c-1-.1-2.1-.1-3.4.2c-.2.1-.5.1-.7.2c1.2.8 2.4 1.6 3.7 2.3v-.5c.6.1 1.4.1 2.6-.1c1.4-.2 1.8.2 1.8.7c0 .4-.3.4-.4.4c-.8 0-1.1-.2-1.4-.2c-.2.1-.3.3 0 .4c-.1.1-.2.1-.2.2c.1.1.3.1.4.2h.1c.2.1.4.2.6.2c.2-.2.6-.3.8-.3c1 0 1.5-1.5 1.1-2.5" })
    ])
  ]);
}
function render$W(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3712)" }, [
      createElementVNode("path", {
        d: "M17.7395 1.45932C16.0346 0.529135 14.0793 0.000244141 12.0004 0.000244141C9.92149 0.000244141 7.96615 0.529135 6.26126 1.45932L5.21777 12.0002L6.26126 22.5412C7.96615 23.4714 9.92149 24.0002 12.0004 24.0002C14.0793 24.0002 16.0346 23.4714 17.7395 22.5412L18.783 12.0002L17.7395 1.45932Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M6.26086 22.5408V1.45898C2.53073 3.4943 0 7.45144 0 12C0 16.5485 2.53073 20.5056 6.26086 22.5408Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M24.0001 12.0002C24.0001 7.45168 21.4694 3.49454 17.7393 1.45923V22.541C21.4694 20.5059 24.0001 16.5487 24.0001 12.0002Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M9.3917 15.1298L7.30469 11.9993L9.39166 8.8689L11.4787 11.9993L9.3917 15.1298Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M14.6094 15.1298L12.5225 11.9993L14.6094 8.8689L16.6964 11.9993L14.6094 15.1298Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.001 19.3037L9.91406 16.1733L12.001 13.0428L14.088 16.1733L12.001 19.3037Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3712" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$V(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3753)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C4.12172 7.87828 7.61737 4.38263 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M9.61098 7.82617L9.80527 8.42406H10.4339L9.92527 8.79348L10.1196 9.39137L9.61098 9.02186L9.10238 9.39137L9.29668 8.79348L8.78809 8.42406H9.41668L9.61098 7.82617Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.45448 3.13116L6.77824 4.12768H7.826L6.97831 4.74338L7.30217 5.73985L6.45448 5.12396L5.60684 5.73985L5.93065 4.74338L5.08301 4.12768H6.13067L6.45448 3.13116Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.58534 4.17499L9.9091 5.17155H10.9568L10.1092 5.78725L10.4329 6.78372L9.58534 6.16783L8.7377 6.78372L9.06151 5.78725L8.21387 5.17155H9.26153L9.58534 4.17499Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.11072 8.349L7.43454 9.34551H8.48219L7.63455 9.96122L7.95836 10.9577L7.11072 10.3418L6.26309 10.9577L6.5869 9.96122L5.73926 9.34551H6.78696L7.11072 8.349Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M4.36752 5.73987L4.69133 6.73638H5.73903L4.89135 7.35209L5.21516 8.34856L4.36752 7.73271L3.51992 8.34856L3.84369 7.35209L2.99609 6.73638H4.04375L4.36752 5.73987Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3753" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$U(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3754)" }, [
      createElementVNode("path", {
        d: "M24 11.9997C24 18.6271 18.6274 23.9997 12 23.9997C5.37262 23.9997 0 18.6271 0 11.9997C0.521719 11.9997 12 10.4345 12 10.4345L24 11.9997Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.7631 8.28088L11.9998 13.0442L7.23659 8.28088C6.6206 9.19527 6.26074 10.2959 6.26074 11.4789V13.0441C6.26074 15.5574 7.88473 17.6983 10.1383 18.4732C9.83754 19.0627 9.88826 19.7984 10.329 20.3485C10.9144 19.8793 11.5204 19.3936 12.0346 18.9817C12.5487 19.3937 13.1548 19.8794 13.7401 20.3485C14.186 19.792 14.2331 19.0453 13.9204 18.4523C16.1433 17.6606 17.7389 15.5354 17.7389 13.0441V11.479C17.739 10.2959 17.3791 9.19532 16.7631 8.28088Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0001 17.2176C9.69855 17.2176 7.82617 15.3451 7.82617 13.0437V11.4785C7.82617 9.17694 9.69859 7.30457 12.0001 7.30457C14.3015 7.30457 16.174 9.17699 16.174 11.4785V13.0437C16.174 15.3451 14.3016 17.2176 12.0001 17.2176Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.609 13.0433V11.4781C14.609 10.0397 13.4387 8.86945 12.0003 8.86945C10.5619 8.86945 9.3916 10.0397 9.3916 11.4781V13.0433L12.0003 13.565L14.609 13.0433Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M9.3916 13.0432C9.3916 14.4817 10.5619 15.6519 12.0003 15.6519C13.4387 15.6519 14.609 14.4816 14.609 13.0432H9.3916Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M15.13 7.30397C15.13 6.43955 14.4292 5.73876 13.5648 5.73876C13.1638 5.73876 12.7983 5.8897 12.5213 6.13762V5.217H13.043V4.17351H12.5213V3.65179H11.4778V4.17351H10.9561V5.217H11.4778V6.13762C11.2008 5.8897 10.8353 5.73876 10.4343 5.73876C9.56992 5.73876 8.86914 6.43955 8.86914 7.30397C8.86914 7.76742 9.07075 8.18367 9.39086 8.47031V9.39094H14.6082V8.47031C14.9284 8.18367 15.13 7.76742 15.13 7.30397Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3754" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$T(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { fill: "#83bf4f" }, [
      createElementVNode("path", { d: "M60 42c-5.5 0-10-4.5-10-10H10.8v21.2C16.2 58.6 23.7 62 32 62c13.1 0 24.2-8.4 28.3-20H60" }),
      createElementVNode("path", { d: "M60 22h.3C56.2 10.4 45.1 2 32 2c-8.3 0-15.8 3.4-21.2 8.8V32H50c0-5.5 4.5-10 10-10" })
    ]),
    createElementVNode("path", {
      d: "M60.3 22H10.8v20h49.5c1.1-3.1 1.7-6.5 1.7-10s-.6-6.9-1.7-10",
      fill: "#ffe62e"
    }),
    createElementVNode("path", {
      d: "M10.8 10.8C5.4 16.2 2 23.7 2 32s3.4 15.8 8.8 21.2L32 32L10.8 10.8z",
      fill: "#ed4c5c"
    }),
    createElementVNode("g", { fill: "#3e4347" }, [
      createElementVNode("path", { d: "M40 34.1l2.5 1.9l-1-3.1l2.5-1.8l-3-.1l-1-3l-1 3l-3 .1l2.5 1.8l-1 3.1z" }),
      createElementVNode("path", { d: "M52 34.1l2.5 1.9l-1-3.1l2.5-1.8l-3-.1l-1-3l-1 3l-3 .1l2.5 1.8l-1 3.1z" })
    ])
  ]);
}
function render$S(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3756)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M6.7832 14.3477C6.7832 15.2121 7.48399 15.9129 8.34841 15.9129H13.0441C13.0441 16.6332 13.628 17.2172 14.3484 17.2172H15.9136C16.634 17.2172 17.218 16.6332 17.218 15.9129V14.3477H6.7832Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M17.3472 6.78308V10.4352C17.3472 11.0106 16.8791 11.4787 16.3037 11.4787V13.0439C17.7422 13.0439 18.9124 11.8737 18.9124 10.4352V6.78308H17.3472Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.1304 10.435C6.1304 11.0104 5.6623 11.4785 5.08691 11.4785V13.0437C6.52537 13.0437 7.6956 11.8734 7.6956 10.435V6.78284H6.1304V10.435Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.5652 6.78308H15V10.4353H16.5652V6.78308Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.6524 8.87005C12.6524 9.01391 12.5354 9.13091 12.3916 9.13091C12.2477 9.13091 12.1307 9.01386 12.1307 8.87005V6.78308H10.5655V8.87005C10.5655 9.01391 10.4484 9.13091 10.3046 9.13091C10.1608 9.13091 10.0438 9.01386 10.0438 8.87005V6.78308H8.47852V8.87005C8.47852 9.87697 9.2977 10.6962 10.3046 10.6962C10.6924 10.6962 11.0521 10.5743 11.3481 10.3673C11.6441 10.5742 12.0038 10.6962 12.3916 10.6962C12.4697 10.6962 12.5465 10.6907 12.622 10.6811C12.5111 11.138 12.0995 11.4787 11.609 11.4787V13.0439C13.0474 13.0439 14.2177 11.8737 14.2177 10.4353V8.87005V6.78308H12.6525V8.87005H12.6524Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.8263 11.4781H8.47852V13.0433H10.8263V11.4781Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3756" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$R(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3757)" }, [
      createElementVNode("path", {
        d: "M17.2175 1.19084C15.6399 0.427997 13.87 0.00012207 12.0001 0.00012207C10.1303 0.00012207 8.36037 0.427997 6.78274 1.19084L5.73926 12.0001L6.78274 22.8094C8.36037 23.5722 10.1303 24.0001 12.0001 24.0001C13.87 24.0001 15.6399 23.5722 17.2175 22.8094L18.261 12.0001L17.2175 1.19084Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12 7.82605L13.0359 11.0145H16.3888L13.6764 12.9853L14.7124 16.1738L12 14.2032L9.28753 16.1738L10.3237 12.9853L7.61133 11.0145H10.964L12 7.82605Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M6.78262 1.1908C2.76872 3.13175 0 7.24217 0 11.9997C0 16.7571 2.76872 20.8676 6.78262 22.8085V1.1908Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M17.2178 1.19141V22.8091C21.2317 20.8682 24.0004 16.7578 24.0004 12.0003C24.0004 7.24278 21.2317 3.13236 17.2178 1.19141Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3757" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$Q(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3758)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 0C5.37262 0 0 5.37262 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739H23.2537C23.736 14.874 24 13.4678 24 12C24 5.37262 18.6274 0 12 0Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0007 0.00012207C6.8411 0.00012207 2.44259 3.25662 0.74707 7.82623H23.2543C21.5588 3.25662 17.1603 0.00012207 12.0007 0.00012207Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.10352 6.78314V12.7694C3.10352 16.1746 7.552 17.2179 7.552 17.2179C7.552 17.2179 12.0004 16.1746 12.0004 12.7694V6.78314H3.10352Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.94238 7.82638H10.1598V5.73941L9.11632 6.26113L7.55112 4.69592L5.98587 6.26113L4.94238 5.73941V7.82638Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M10.9565 13.6026L7.56514 10.2112L4.17383 13.6026L5.28059 14.7093L7.56514 12.4248L9.84969 14.7093L10.9565 13.6026Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M10.9565 10.4341H9.37414C9.46311 10.2805 9.51486 10.1027 9.51486 9.91244C9.51486 9.33607 9.04766 8.86896 8.47137 8.86896C8.07317 8.86896 7.72737 9.09199 7.55145 9.41988C7.37553 9.09204 7.02973 8.86896 6.63153 8.86896C6.05525 8.86896 5.58805 9.33607 5.58805 9.91244C5.58805 10.1027 5.6398 10.2806 5.72877 10.4341H4.17383C4.17383 11.0104 4.67581 11.4776 5.25205 11.4776H5.21731C5.21731 12.0539 5.68447 12.521 6.2608 12.521C6.2608 13.0313 6.62726 13.4553 7.11125 13.546L6.28906 15.4023C6.68309 15.5625 7.11369 15.6515 7.56519 15.6515C8.01669 15.6515 8.44728 15.5625 8.84131 15.4023L8.01912 13.546C8.50311 13.4553 8.86958 13.0314 8.86958 12.521C9.44591 12.521 9.91306 12.0539 9.91306 11.4776H9.87833C10.4545 11.4776 10.9565 11.0103 10.9565 10.4341Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3758" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$P(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3759)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M20.1006 3.14638C17.9659 1.19206 15.1224 -0.000671387 12.0002 -0.000671387C11.489 -0.000671387 10.9854 0.0315317 10.491 0.0935474L4.69581 6.78195L0.379883 15.0055C0.658695 16.0865 1.08498 17.108 1.63496 18.0485L12.0002 11.9993L20.1006 3.14638Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M21.9903 18.6479L5.20117 21.8879C7.13378 23.2192 9.47556 23.9993 11.9998 23.9993C16.168 23.9993 19.8392 21.8738 21.9903 18.6479Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M20.1021 3.14819L1.6416 18.0603C2.12446 18.8838 2.70257 19.6446 3.36102 20.3276L23.9999 11.9996C23.9999 8.49522 22.4976 5.34204 20.1021 3.14819Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0 12C0 13.0382 0.131906 14.0455 0.379734 15.0062L10.4909 0.0942383C4.57584 0.836457 0 5.88377 0 12Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3759" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$O(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3760)" }, [
      createElementVNode("path", {
        d: "M23.2536 16.1743C23.736 14.8744 24 13.4683 24 12.0005C24 10.5326 23.736 9.12655 23.2536 7.82656L12 6.78308L0.746391 7.82656C0.264 9.12655 0 10.5326 0 12.0005C0 13.4683 0.264 14.8744 0.746391 16.1743L12 17.2178L23.2536 16.1743Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0006C17.1593 24.0006 21.5578 20.7441 23.2533 16.1744H0.746094C2.44166 20.7441 6.84012 24.0006 11.9997 24.0006Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M11.9997 0.00012207C6.84012 0.00012207 2.44166 3.25662 0.746094 7.82623H23.2534C21.5578 3.25662 17.1593 0.00012207 11.9997 0.00012207Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3760" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$N(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3761)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M7.30353 6.26101C7.30353 4.51267 8.53226 3.05214 10.1731 2.69378C9.92089 2.63875 9.65928 2.60889 9.39045 2.60889C7.37337 2.60889 5.73828 4.24398 5.73828 6.26106C5.73828 8.27814 7.37337 9.91323 9.39045 9.91323C9.65919 9.91323 9.92084 9.88337 10.1731 9.82829C8.53226 9.46993 7.30353 8.0094 7.30353 6.26101Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9995 2.87L12.2585 3.66711H13.0967L12.4186 4.15981L12.6776 4.95692L11.9995 4.46431L11.3214 4.95692L11.5804 4.15981L10.9023 3.66711H11.7405L11.9995 2.87Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.96639 4.43469L10.2254 5.23185H11.0635L10.3855 5.7245L10.6445 6.52161L9.96639 6.029L9.2882 6.52161L9.54728 5.7245L8.86914 5.23185H9.70731L9.96639 4.43469Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.0327 4.43469L14.2918 5.23185H15.1299L14.4518 5.7245L14.7108 6.52161L14.0327 6.029L13.3546 6.52161L13.6136 5.7245L12.9355 5.23185H13.7737L14.0327 4.43469Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.2505 6.78345L13.5095 7.5806H14.3476L13.6695 8.07326L13.9286 8.87037L13.2505 8.37776L12.5724 8.87037L12.8314 8.07326L12.1533 7.5806H12.9914L13.2505 6.78345Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.7486 6.78345L11.0076 7.5806H11.8458L11.1676 8.07326L11.4267 8.87037L10.7486 8.37776L10.0704 8.87037L10.3295 8.07326L9.65137 7.5806H10.4895L10.7486 6.78345Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3761" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$M(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3762)" }, [
      createElementVNode("path", {
        d: "M5.2373 21.9127C7.16321 23.2292 9.49182 23.9997 12.0008 23.9997C14.5097 23.9997 16.8384 23.2292 18.7642 21.9127L12.0008 20.8693L5.2373 21.9127Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.7642 2.08709C16.8384 0.770606 14.5097 0.00012207 12.0008 0.00012207C9.49182 0.00012207 7.16312 0.770606 5.2373 2.08709L12.0008 3.13057L18.7642 2.08709Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M5.2373 21.9127C7.16321 23.2292 9.49182 23.9997 12.0008 23.9997C14.5097 23.9997 16.8384 23.2292 18.7642 21.9127L12.0008 20.8693L5.2373 21.9127Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.7642 2.08709C16.8384 0.770606 14.5097 0.00012207 12.0008 0.00012207C9.49182 0.00012207 7.16312 0.770606 5.2373 2.08709L12.0008 3.13057L18.7642 2.08709Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.9706 11.2165C23.6863 7.51292 21.436 3.91217 18.7646 2.08606H5.2377C2.2782 4.10923 0.27068 7.42274 0.0263672 11.2165L12.0012 11.9991L23.9706 11.2165Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0.0253906 12.7823C0.269703 16.5761 2.27717 19.8895 5.23667 21.9127H18.7636C21.7232 19.8896 23.7306 16.5761 23.9749 12.7823L12.0002 11.9996L0.0253906 12.7823Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.9694 11.2173H12.7826V1.56519H11.2174V11.2173H0.0252656C0.008625 11.4761 0 11.737 0 12C0 12.2629 0.00857813 12.5238 0.0252187 12.7826H11.2174V22.4348H12.7826V12.7826H23.9748C23.9914 12.5238 24 12.2629 24 12C24 11.7389 23.9895 11.4779 23.9694 11.2173Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.69629 11.9992L12.0006 7.4082L19.305 11.9992L12.0006 16.5903L4.69629 11.9992Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.82617 14.0872H17.2174L15.1305 10.9568L14.087 12.0003L13.0435 11.4786L12.0001 13.0438H9.91309L8.86961 12.0003L7.82617 14.0872Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0004 8.8689L12.2595 9.66601H13.0975L12.4195 10.1587L12.6785 10.9559L12.0004 10.4632L11.3223 10.9559L11.5814 10.1587L10.9033 9.66601H11.7414L12.0004 8.8689Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0006 6.09656L2.60938 11.9993L12.0006 17.9021L21.392 11.9993L12.0006 6.09656ZM5.55069 11.9993L12.0006 7.94526L18.4507 11.9993L12.0006 16.0534L5.55069 11.9993Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3762" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$L(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3700)" }, [
      createElementVNode("path", {
        d: "M10.9565 13.0426C10.9565 13.0426 3.52168 3.51219 3.51465 3.51388C5.68618 1.3423 8.68623 -0.000854492 12 -0.000854492C18.6273 -0.000854492 24 5.37177 24 11.9991L10.9565 13.0426Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M10.9565 11.9995C10.9565 11.9995 3.52168 20.4865 3.51465 20.4848C5.68618 22.6563 8.68623 23.9995 12 23.9995C18.6273 23.9995 24 18.6269 24 11.9995H10.9565Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51465C-1.17157 8.20093 -1.17157 15.7989 3.51471 20.4853C5.45126 18.5487 7.31375 16.6862 12 12L3.51471 3.51465Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.3157 11.9995C1.30914 12.0857 1.30469 12.1725 1.30469 12.2603C1.30469 14.1333 2.82306 15.6516 4.696 15.6516C6.56894 15.6516 8.08731 14.1333 8.08731 12.2603C8.08731 12.1725 8.08286 12.0856 8.0763 11.9995H1.3157Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M4.69583 10.4338C5.27213 10.4338 5.73931 9.96659 5.73931 9.39029C5.73931 8.81399 5.27213 8.3468 4.69583 8.3468C4.11953 8.3468 3.65234 8.81399 3.65234 9.39029C3.65234 9.96659 4.11953 10.4338 4.69583 10.4338Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M2.34766 9.13025V12.5216C2.34766 14.3187 4.69548 14.8694 4.69548 14.8694C4.69548 14.8694 7.04331 14.3187 7.04331 12.5216V9.13025H2.34766Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.69712 13.7777C4.26155 13.6209 3.3916 13.2203 3.3916 12.5219V10.1741H6.00033V12.5219C6.00033 13.2226 5.13048 13.6222 4.69712 13.7777Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M5.21743 11.4777V10.9559L4.69571 10.6951L4.17395 10.9559V11.4777L3.91309 11.7386V12.782H5.47834V11.7386L5.21743 11.4777Z",
        fill: "#F3F3F3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3700" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$K(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3701)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 23.9996C18.6274 23.9996 24 18.6269 24 11.9996C24 10.5317 23.736 9.12562 23.2536 7.82568H0.746391C0.264047 9.12562 0 10.5317 0 11.9996C0 18.6269 5.37262 23.9996 12 23.9996Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9997C17.1593 23.9997 21.5578 20.7432 23.2533 16.1736H0.746094C2.44161 20.7432 6.84012 23.9997 11.9997 23.9997Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.10254 6.78186V12.7681C3.10254 16.1733 7.55102 17.2167 7.55102 17.2167C7.55102 17.2167 11.9995 16.1733 11.9995 12.7681V6.78186H3.10254Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M4.14648 6.78186V12.7681C4.14648 13.1678 4.23527 13.5454 4.41114 13.8993C6.15648 13.8993 8.76517 13.8993 10.6918 13.8993C10.8677 13.5454 10.9564 13.1678 10.9564 12.7681V6.78186H4.14648Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.63874 10.9561H8.07358V9.91261H9.11707V8.86912H8.07358V7.82568H7.03009V8.86912H5.98666V9.91261H7.03009V10.9561H5.46484V11.9996H7.03009V13.0431H8.07358V11.9996H9.63874V10.9561Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.8344 15.3573C6.50682 15.7799 7.19766 16.0252 7.55134 16.1343C7.90501 16.0253 8.59585 15.7799 9.26827 15.3573C9.94637 14.9311 10.4217 14.4437 10.6916 13.9007C10.3939 13.69 10.0307 13.5658 9.63831 13.5658C9.49543 13.5658 9.35663 13.5827 9.22318 13.6138C8.94038 12.9713 8.29843 12.5223 7.55138 12.5223C6.80434 12.5223 6.16234 12.9713 5.87959 13.6138C5.74613 13.5827 5.60729 13.5658 5.46446 13.5658C5.07207 13.5658 4.70884 13.69 4.41113 13.9007C4.6809 14.4437 5.15626 14.9311 5.8344 15.3573Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3701" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$J(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3702)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.2536 7.82637H10.4348V4.69592H4.17389V7.82637H0.746391C0.264047 9.12631 0 10.5324 0 12.0003C0 13.4681 0.264047 14.8742 0.746391 16.1742L12 17.2176L23.2536 16.1742C23.736 14.8742 24 13.4681 24 12.0003C24 10.5324 23.736 9.12631 23.2536 7.82637Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9997C17.1593 23.9997 21.5578 20.7432 23.2533 16.1736H0.746094C2.44161 20.7432 6.84012 23.9997 11.9997 23.9997Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M4.17383 7.82641V8.86984C4.17383 11.2661 7.30428 12.0003 7.30428 12.0003C7.30428 12.0003 10.4347 11.2661 10.4347 8.86984V7.82641L9.39125 8.86989L7.30428 7.30469L5.21731 8.86989L4.17383 7.82641Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3702" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$I(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3703)" }, [
      createElementVNode("path", {
        d: "M20.4863 20.4851C24.9868 15.9846 25.1645 8.79939 21.0213 4.08569L12.0007 11.9994L4.08691 21.0201C8.80061 25.1633 15.9858 24.9856 20.4863 20.4851Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M3.51438 3.5144C8.01488 -0.986107 15.2001 -1.16381 19.9138 2.97942L12 12.0001L2.97944 19.9138C-1.16383 15.2001 -0.986083 8.01491 3.51438 3.5144Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M19.9139 2.98022L2.97949 19.9146C3.15068 20.1094 3.32843 20.3005 3.51448 20.4864C3.70048 20.6724 3.89158 20.8502 4.0864 21.0214L21.0207 4.08703C20.8495 3.89222 20.6717 3.70116 20.4856 3.51511C20.2997 3.32921 20.1086 3.15141 19.9139 2.98022Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M5.05619 4.17444L5.31526 4.97164H6.15343L5.47534 5.46425L5.73433 6.26145L5.05619 5.76875L4.37805 6.26145L4.63712 5.46425L3.95898 4.97164H4.7972L5.05619 4.17444Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.33744 4.17358L9.59652 4.97079H10.4346L9.75655 5.46339L10.0156 6.2606L9.33744 5.76789L8.6593 6.2606L8.91837 5.46339L8.24023 4.97079H9.07841L9.33744 4.17358Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.05619 8.34778L5.31526 9.14498H6.15343L5.47534 9.63763L5.73433 10.4348L5.05619 9.94213L4.37805 10.4348L4.63712 9.63763L3.95898 9.14498H4.7972L5.05619 8.34778Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M9.33744 8.34778L9.59652 9.14498H10.4346L9.75655 9.63763L10.0156 10.4348L9.33744 9.94213L8.6593 10.4348L8.91837 9.63763L8.24023 9.14498H9.07841L9.33744 8.34778Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.19686 6.2616L7.45593 7.0588H8.29406L7.61597 7.55145L7.875 8.34865L7.19686 7.85595L6.51872 8.34865L6.77775 7.55145L6.09961 7.0588H6.93783L7.19686 6.2616Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3703" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$H(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3704)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12.0006 6.26062L13.2956 10.2464H17.4864L14.096 12.7096L15.391 16.6954L12.0006 14.2321L8.6101 16.6954L9.90516 12.7096L6.51465 10.2464H10.7055L12.0006 6.26062Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3704" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$G(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3705)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M3.51471 20.4853C-1.17157 15.7989 -1.17157 8.20098 3.51471 3.51465C3.51438 3.51516 10.4348 12 10.4348 12L3.51471 20.4853Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M10.4351 12.0002L1.59187 6.02429C1.3177 6.50087 1.07591 6.99831 0.868164 7.51318L5.34515 12.0003L0.868305 16.4876C1.07587 17.0021 1.31741 17.4992 1.5914 17.9755L10.4351 12.0002Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.8982 10.4347H10.4342L3.51434 3.51477C2.76865 4.26046 2.12079 5.10379 1.59129 6.02399L7.55562 11.9999L1.59082 17.975C2.12032 18.8955 2.76846 19.7391 3.51434 20.485L10.4342 13.5651H23.8982C23.9649 13.0528 23.9997 12.5304 23.9997 11.9999C23.9997 11.4694 23.9649 10.947 23.8982 10.4347Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M4.69336 21.5181C6.71691 23.0735 9.24989 23.9988 11.9994 23.9988C17.5437 23.9988 22.209 20.2385 23.586 15.1293H11.0822L4.69336 21.5181Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.586 8.86869C22.209 3.7595 17.5437 -0.000854492 11.9994 -0.000854492C9.24989 -0.000854492 6.71691 0.924505 4.69336 2.47991L11.0821 8.86869H23.586Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3705" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$F(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("defs", null, [
      createElementVNode("linearGradient", {
        id: "IconifyId17ecdb2904d178eab26137",
        gradientUnits: "userSpaceOnUse",
        x1: "-1760.792",
        x2: "-1759.792",
        gradientTransform: "matrix(-.5968 -1.5125 -1.2072 .7477 87.385 -3301.715)"
      }, [
        createElementVNode("stop", { "stop-color": "#d5dfff" }),
        createElementVNode("stop", {
          offset: "1",
          "stop-color": "#ffffff"
        })
      ])
    ]),
    createElementVNode("g", { fill: "#2a5f9e" }, [
      createElementVNode("path", { d: "M32 2v30H2c0 16.6 13.4 30 30 30s30-13.4 30-30S48.6 2 32 2z" }),
      createElementVNode("path", { d: "M12 12h21v21H12z" })
    ]),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M18.9 8.1V14h-7.3L26 32h6v-7.5z" }),
      createElementVNode("path", { d: "M11 18.9H5c-1.9 4-3 8.4-3 13.1h12V13.9h-3v5" })
    ]),
    createElementVNode("path", {
      fill: "#ed4c5c",
      d: "M32 27.1L19 11h-6l17 21h2z"
    }),
    createElementVNode("path", {
      d: "M18.9 5v6H11v3h21V2c-4.7 0-9.1 1.1-13.1 3z",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M32 5H18.9c-6 2.9-11 7.9-13.9 13.9V32h6V11h21V5z",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M44.6 41.7c-.6.6-1.8 1.2-2.6.6c-1.1.2-.5.5-1.5-.2c-.7.2-.9.2-1.9-.2c-.5.9-1.1 1.1-1.9.5c.1-.2.3-.4.4-.6c0 .4-1.6.3-1.7.3c.9-2.9 4.6-5.3 6.7-7.3c1 1.8 3.7 4.7 2.5 6.9",
      fill: "#6a4c2d"
    }),
    createElementVNode("path", {
      fill: "#ffffff",
      d: "M48.8 42h1.5l-.7-.3l5.9-.3l-.8-.3l-.8-1l-3.6-.3l-.3-.5l-1.9-.2l-1.1.8l.8 2z"
    }),
    createElementVNode("path", {
      d: "M48.8 31.1c.1-.1.5-.2.4-.7c0-.5-.5-.6-.8-.6c-.3 0-.5.2-.5.2l-.9-.5s.4-2.7.9-2.9c.4-.3.5-.5.5-.5l-.2-.3l-2.8-.3l-2.7.3s-.2.3-.2.4c0 .1 0 .3.5.6c.5.4.9 2.7.9 2.7l-.8.3s-.3-.1-.4-.1s-.5.2-.5.7c0 .5.4.8.4.8s2.6-.3 2.9.4c.5-.6 3-.3 3.3-.5",
      fill: "#656263"
    }),
    createElementVNode("path", {
      d: "M51.5 28.3c.2-.6.6-.6 1.2-.6c1.2 0 1.1.4 1.5 1.4c.5 1.4 1.4 2.8 1.5 4.4c.1 1.7.1 4-.7 5.5c-.6 1.1.7 1.4 1.5 1.8l-.6-.2l.6.5l-.7-.3l.4.4l-1-.5l.4.4l-.8-.4c.1.2.3.3.4.5c-.2-.1-.4-.2-.7-.3v.2c-.8-.6-2-.7-2.3-1.6c-.4-1-1.2-2.5-1.1-3.6c.3-2.3 1-5.3.4-7.6",
      fill: "#3e4347"
    }),
    createElementVNode("path", {
      fill: "#00713d",
      d: "M44 39.7l-.3 1l.4-.5v1l.3-.5v1.2l.3-.6v1.1l.3-.5l.2 1l.3-.7l.4.8l.1-.6l.6.7v-.7l.7.6v-.4l.7.3v-.4l.8.2l-.5-.5h.5l-.8-.5h.4l-.7-.6h.5l-.8-.6l.4-.1z"
    }),
    createElementVNode("path", {
      d: "M41.9 31.4h2.2s1.4 0 1.6.5c.3-.6 1.5-.6 1.5-.6c.7 0 1.5-.1 2.2-.1v5.4c-.4 2.1-2 3.6-3.6 4.2c-2-.6-3.3-2.3-3.7-4.2c0-1.8-.1-3.5-.2-5.2",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M42.7 31.4l3.1 8.4l2.8-8.6c-.9.1-2.8-.1-3 .7c-.3-.8-2.3-.5-2.9-.5",
      fill: "#006b00"
    }),
    createElementVNode("g", { fill: "#cdad56" }, [
      createElementVNode("path", { d: "M44 17.8l1.8-1.5l.3-1.1l-.4.2l-.1-.5l-.1-.1l-.1.2l-.2-.4l-.3.4l.5 1l-.5.8l-.2-.5l.2-.6l-.3.1v-.6l-.4.4l-.1-.1l.4 1.2l-.3.4l-.5-1.3l-.1.3l-.2-.2l.1.7h-.2l.3.4l-.3.4l.6-.2l-.2.4z" }),
      createElementVNode("path", { d: "M42.6 17.8L41 16.4l-.1-1l.2.2l.2-.5l.2.3l.3-.4l.2.3l-.6.9l.4.7l.2-.5l-.3-.4h.4v-.5l.3.3l.2-.3l-.5 1.3l.2.3l.4-1l.2.2l.2-.2l-.1.6h.2l-.1.4l.1.3l-.5-.2l.1.4z" })
    ]),
    createElementVNode("path", {
      d: "M48.2 32.6l-.3-.4l.4-.5l-.6.1l-.1-.6l-.3.8l-.6-.3l.4.5l-1.1.8l.3.1l-.4.1l.1.2l-.3.1l.2.1h-.8V33h.8l-.4-.8l-.3.2l-.2-.3l-.7.2l.4-.5l-.6.3l-.1-.7l-.1.6l-.6-.1l.5.4l-.4.5l.5-.2l.2.6l.1-.4l.3.2h.1l.1 2l-.2.4l.1-.1l.3.7l.1-.6l.5-.2l.3-.1l.2.1l.1.6l-.5.7H45l-.2.3l.6-.3v.3l.3-.3v.2l.2-.1l-.5 1.4l.5-.4v.6l.2-.4l.2-.2l.1.2v-.5l.2.1l-.2-.7l.3.2l-.2-.9l.8-.4v-.4H47l.2-.4l.1-.6v.3v-.5l.3.1l-.2-.3l.4-.2h-.2l.5-.5l-1.3.9l-.1 1.7l-.4-1.9l.2.3l.2-.8l.4.1l-.2-.3l.2.1l-.3-.2l.4-.1l-.4-.3l.5-.2v.6l.2-.6l.7.2M45 34.8l.1-.7l.8-.1l-.9.8",
      fill: "#ffc900"
    }),
    createElementVNode("g", { fill: "#ed4c5c" }, [
      createElementVNode("path", { d: "M38.8 48.8c.3-.1 2 .4 2.7 1.1c-.1-1.3-.5-2.2-.5-2.2s-1-.3-1.2-.2c-.2.2-.8.9-1 1.3" }),
      createElementVNode("path", { d: "M38.2 43c-.1 0-.2.1-.4.3c-.1.3-.2 1.2-.4 1.4s-.4.2-.4.4s0 .6.6.8c.5 0 1.4-.9 1.4-.9s.4-.5.6-1c-1 .3-1.7-.6-1.4-1" }),
      createElementVNode("path", { d: "M53.4 48.6c-.3-.1-2.1.4-2.7 1.1c.1-1.3.5-2.2.5-2.2c.1 0 1-.3 1.1-.2c.2.2.8.9 1.1 1.3" }),
      createElementVNode("path", { d: "M53.8 42.8c.1 0 .2.2.3.4c.1.3.3.8.5 1c.2.2.4.5.4.7s0 .4-.6.6c-.5 0-1.3-.7-1.3-.7s-.4-.5-.6-1c1 .4 1.7-.6 1.3-1" })
    ]),
    createElementVNode("path", {
      d: "M52.3 45.4c.4-.4.7-.6.7-.6s-.5-.6-.6-1c1 .5 2.3-1.1.8-1.2c-1 .1-1.9.9-2.5 1.9c-3.1-1.5-6.7-1.4-9.6.1c-.6-1-1.4-1.8-2.4-1.8c-1.5.1-.1 1.7.8 1.2c-.1.4-.6 1-.6 1s.3.1.7.5c-.8.6-1.5 1.3-2.1 2.2c0 0 1.1.7 1.1 1.1c.5-.7 1.1-1.4 1.9-1.9c.4.7.7 1.7.9 3.1c0 0 .6-1.6.9-1.6c.2 0 0-1.1-.5-2.2c2.4-1.2 5.5-1.4 8.1-.2c-.5 1.1-.6 2.1-.5 2.4c.3 0 1 1.4 1 1.4c.2-1.3.5-2.3.9-3c.7.5 1.3 1.1 1.9 1.8c.6-.7 1.1-1 1.1-1c-.5-.9-1.2-1.6-2-2.2",
      fill: "#ffce31"
    }),
    createElementVNode("g", { fill: "#1e5aa6" }, [
      createElementVNode("path", { d: "M48.7 31.2h.4l-.8 1l.9 1.1l-1.8 2.3l1.7 2c-.2.5-.4.9-.7 1.2l-1-1.1l1.8-2.2l-1.4-1.6l.9-2.7" }),
      createElementVNode("path", { d: "M42.6 31.4h-.5l.8.9l-.9 1.1l1.9 2l-1.5 2.1c.2.5.5 1 .7 1.3l.9-1.2l-1.9-2.1l1.4-1.8l-.9-2.3" }),
      createElementVNode("path", { d: "M44.7 36.8l-.7.9l2.4 2.8c.4-.2.8-.5 1.1-.7l-1.2-1.4l.5-1.5l.7.8l-2.3 2.9c-.4-.2-.8-.4-1.2-.7l1.2-1.5l-.5-1.6" }),
      createElementVNode("path", { d: "M44 35.5l.4.5l-.3-.7z" }),
      createElementVNode("path", { d: "M47.1 35.9l.4-.4l-.2-.2z" })
    ]),
    createElementVNode("path", {
      d: "M51.5 29.5c.2 0 1.4 0 1.4.2c-.5.2-.8.5-1.1 1c.3.5.6.9.9 1.4c.1 1-1.3 2-1.2 3.5c.1 1.1.1 2.2 1 2.9c1.1 1 .6-2.1.7-2.4c0-.2 1.1 1 1.1 1.4c-.1 1.1-.5.5-.5.8c-.3 1.1-.3 1.8-1.3 1.8c-1.4-.8-2.7-8.8-1-10.6",
      fill: "#f5f5f5"
    }),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M47.4 27.6s1.1 1.2 1.9 1.2c.1.4-.3.7-.5.8c-.4-.1-.7 0-1.6-1c.1-.6.3-.9.2-1" }),
      createElementVNode("path", { d: "M49 24.8c.1-.5.4-.8.7-.8c-.1-.3.5-1.9 2.3-2.4c.1.8-.7 1.5-.7 1.5s2.6-.4 3.1-1.1c-.1.3-.6 2.1-3.3 2.1c1 1-.3 1.8-.9 1.5c.9-.8-.5-1.3-1.2-.8" })
    ]),
    createElementVNode("g", { fill: "#00f" }, [
      createElementVNode("path", { d: "M48.8 29.7s1.4.4 1.6-1.6c-.3-.9-.7-2.8-.1-3.3c-.6-.4-1.2 0-1.2 0c0 .1-.6.8.1 2.2c-1.7-.4-1 1.2-1 1.2c.1-.2 1-.5 1.2.8c0 .2-.7.7-.6.7" }),
      createElementVNode("path", { d: "M50.3 28.1s1.5-.8 1.4-2.7c-1.3 0-1.7 1.7-1.7 1.7l.3 1" })
    ]),
    createElementVNode("path", {
      d: "M43.7 28s-1.1 1-1.7.6c-.5.3-1-.2-1-.2s.6 2.3 2.9.6l-.2-1",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M42 28.6c.1-.5.5-.7.8-.3c.4.1.8-1.6-.6-1.3c.4-2.2-.8-3-.8-3s-.4 2.4-.2 2.9s-.3-.8-1.9-1.2c0 1.8 1.8 2.7 1.8 2.7s.4.4.9.2",
      fill: "#00f"
    }),
    createElementVNode("path", {
      d: "M41.1 24.9s-1 0-.4 1.1c-.5.1-1.5-.5-.8-1.4c-2.3-.1-3.3-1.2-3.3-2.2c.7.7 2.3.4 2.9.9c-.7-.7-.6-1.6-.6-1.6s2 .6 2.4 2.4c-.1.2-.2.8-.2.8",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M42.9 24.3c-.1.2-.1.4-.2.5c1.9 0 3.7.1 5.6.1c-.1-.6-.5-1.2-.7-1.7c.1-.4.1-1.1.2-1.6s-.7-.6-.5-1.1c-.1.2.6 0 .6 0c-.3 0-.4-1-.7-1.1c-.7-.2-1 0-1.6 0c-.8 0-2 0-1.8-1.2c.4.1.9 0 1-.4c-.1-.1-1.4-.3-1.6-.3c-.2 0-1.6.4-1.7.5c.4.5.8.4 1.2.8c.2.2.3 1.1.1 1h.2c-.1.1-.2.2-.2.3h.4c-.1.2-.2.3-.3.5h.5c-.1.2-.1.3-.2.5c.1 0 .2-.1.4-.1c.4.9-.3 2.4-.7 3.3m4.2-1c.2-.1.2-.1 0 0m-.2-1.9c.8 0 .4 1.8.1 1.9c-.8.1-.7-1.9-.1-1.9m-2 .6c-.3-1.6 2-1.1 1.3.1c-.1.2-.6 1.3-.6 1.3c-.6 0-.8-.9-.7-1.4m-1 1c.4-.5-.3-1.7.6-2c0 .7 0 1.7-.4 2.4c-.1-.2-.2-.3-.4-.2c.1 0 .2-.1.2-.2",
      fill: "#923f00"
    }),
    createElementVNode("path", {
      d: "M42.7 26.4l2.8 1.8l2.5-1.7s.5-.3.5-.5s-.2-.1-.3-.1l-2.6 1.8l-2.7-1.7s-.2-.1-.2.1c-.1.2 0 .3 0 .3",
      fill: "#b4b6b9"
    }),
    createElementVNode("g", { fill: "#ff7000" }, [
      createElementVNode("path", { d: "M52 39.8l-1 .1l.3.3h1.3z" }),
      createElementVNode("path", { d: "M51.6 28.4l-1.3.7l.3.3h1.3z" }),
      createElementVNode("path", { d: "M51.3 40.4l.6.4l1.7-.3l-.5-.3z" })
    ]),
    createElementVNode("path", {
      d: "M51 31.7c-.2-.1-.8-.2-1.6.3v1.7s1.1-.6 1.7-.5c0-.4 0-1.1-.1-1.5",
      fill: "url(#IconifyId17ecdb2904d178eab26137)"
    }),
    createElementVNode("path", {
      d: "M40 30c-.3.8.7 2 1 2.7c.7-.8 1-.9 1 .2c0 .3.1.7 0 1c-.1.3-.8.1-.5.5c.6 1 .5 1.6.2 2.6c-.1.4-.5 2.5-1.1 2.6c0 0 .1-1.5 0-1.7c-.1-.3-.6-1-.4-1.3c-.2.3-1 1.5-1.5 1.1c.2.5 0 .7-.1 1.2c-.1.3-.1.7-.1 1c-.1.4-.7.8-.6 1.4c-2.1-.7-3.5-2.3-2.8-4.6c.2-.5.4-1 .9-1.3c.5-.4.6-1 .8-1.7c.1-.2.3-.5.3-.8c-.1-.6.3-.8.3-1.2c.1-.7.2-1.5.2-2.2c0-1.1.4-1 1.3-1.5c.3-.1 1.5.1 1.8.3c.2.3-.5 1.5-.7 1.7",
      fill: "#8a9396"
    }),
    createElementVNode("path", {
      fill: "#ffffff",
      d: "M42.6 24.7h5.9v1.2h-5.9z"
    })
  ]);
}
function render$E(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3706)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.174 11.9996C16.174 13.0431 14.3052 15.6517 12.0001 15.6517C9.69489 15.6517 7.82617 13.0431 7.82617 11.9996C7.82617 9.69436 9.69489 7.82568 12.0001 7.82568C14.3052 7.82568 16.174 9.69436 16.174 11.9996Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.174 11.9995C16.174 14.3047 14.3052 16.1734 12.0001 16.1734C9.69489 16.1734 7.82617 14.3047 7.82617 11.9995",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M17.5335 14.5826L16.4268 15.6893L17.1646 16.4272L18.2714 15.3204L17.5335 14.5826Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M15.6888 16.4268L14.582 17.5336L15.3199 18.2714L16.4266 17.1647L15.6888 16.4268Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M19.7474 16.7947L18.6406 17.9015L19.3785 18.6393L20.4852 17.5326L19.7474 16.7947Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M17.9027 18.6409L16.7959 19.7477L17.5337 20.4855L18.6405 19.3788L17.9027 18.6409Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M18.6409 15.6896L17.5342 16.7964L18.272 17.5342L19.3788 16.4275L18.6409 15.6896Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M16.7962 17.5339L15.6895 18.6406L16.4273 19.3785L17.5341 18.2717L16.7962 17.5339Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M15.6893 5.35821L18.6406 8.30957L19.3785 7.57172L16.4271 4.62037L15.6893 5.35821Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M14.5827 6.46612L15.6895 7.57288L16.4273 6.83506L15.3205 5.7283L14.5827 6.46612Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M16.4274 8.31L17.5342 9.41675L18.272 8.67893L17.1652 7.57218L16.4274 8.31Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M16.7946 4.25225L17.9014 5.35901L18.6392 4.62116L17.5325 3.5144L16.7946 4.25225Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M18.6413 6.09771L19.748 7.20447L20.4859 6.46662L19.3791 5.35987L18.6413 6.09771Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M7.20331 19.748L4.25195 16.7966L3.5141 17.5345L6.46546 20.4858L7.20331 19.748Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M8.31086 18.64L7.2041 17.5332L6.46629 18.271L7.57304 19.3778L8.31086 18.64Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M6.46613 16.796L5.35938 15.6892L4.62153 16.4271L5.72828 17.5338L6.46613 16.796Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M9.41718 17.5336L6.46582 14.5823L5.72797 15.3201L8.67933 18.2715L9.41718 17.5336Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M4.25274 7.20465L7.2041 4.2533L6.46625 3.51545L3.5149 6.46681L4.25274 7.20465Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M5.35821 8.30976L8.30957 5.3584L7.57172 4.62055L4.62036 7.57191L5.35821 8.30976Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M6.46661 9.41706L9.41797 6.4657L8.68015 5.72788L5.7288 8.67924L6.46661 9.41706Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3706" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$D(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3707)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.0634 7.34694C21.2461 3.03018 16.9771 -0.000854492 11.9995 -0.000854492C8.68576 -0.000854492 5.68609 1.34254 3.51465 3.51425L6.51981 7.34694H23.0634Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M6.55388 16.6075L3.51465 20.4837C5.68609 22.6554 8.68576 23.9988 11.9995 23.9988C16.9939 23.9988 21.2751 20.9475 23.0819 16.6075H6.55388Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M2.6084 8.82605V15.1304H23.5864C23.8555 14.1323 23.9997 13.0831 23.9997 12C23.9997 10.9011 23.8517 9.83705 23.575 8.82605H2.6084Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51465C-1.17157 8.20093 -1.17157 15.7989 3.51471 20.4853C5.45126 18.5487 7.31375 16.6862 12 12L3.51471 3.51465Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M3.90889 9.01648L5.3735 11.0603L7.77013 10.2988L6.27899 12.3235L7.7436 14.3674L5.35728 13.5748L3.8661 15.5995L3.8825 13.085L1.49609 12.2923L3.89253 11.5309L3.90889 9.01648Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3707" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$C(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3708)" }, [
      createElementVNode("path", {
        d: "M0 11.9992C0 13.4671 0.264047 14.8731 0.746391 16.1731L12 17.2166L23.2536 16.1731C23.736 14.8731 24 13.4671 24 11.9992C24 10.5314 23.736 9.12533 23.2536 7.82534L12 6.78186L0.746391 7.82534C0.264047 9.12533 0 10.5314 0 11.9992Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.2553 7.82574C21.5597 3.25618 17.1612 -0.000366211 12.0017 -0.000366211C6.84208 -0.000366211 2.44356 3.25618 0.748047 7.82574H23.2553Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.74707 16.174C2.44259 20.7435 6.8411 24.0001 12.0007 24.0001C17.1603 24.0001 21.5588 20.7435 23.2543 16.174H0.74707Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3708" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$B(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3709)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.39149 2.08618H5.23672C5.0526 2.21204 4.87241 2.34306 4.69583 2.47867L3.65234 11.9992L4.69583 21.5197C4.87241 21.6554 5.0526 21.7864 5.23672 21.9122H9.39149V2.08618Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M0 12.0007C0 15.8793 1.84069 19.3276 4.69567 21.5212V2.4801C1.84069 4.67376 0 8.12199 0 12.0007Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M19.3047 7.31531V7.61582L19.3159 7.61751L19.3047 7.31531Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.043 15.1296H20.7821L19.8256 16.1731V18.2601H17.7386V17.2166H18.7821V15.1296H14.0865V16.434H13.043V13.9482C12.7228 13.6616 12.5213 13.2453 12.5213 12.7818V5.99922C12.5213 5.1348 13.222 4.43401 14.0865 4.43401V14.0862H16.1734L16.8895 13.4894C16.7644 13.1915 16.6952 12.8644 16.6952 12.521V10.9558H15.13V7.82538H18.2604C18.2604 7.30366 19.043 6.78189 19.043 6.78189C19.043 6.78189 19.8256 7.30361 19.8256 7.82538V8.60801V10.9558C20.4061 10.9627 21.3283 10.9477 22.3246 10.9558C22.0629 10.4983 21.9125 9.95548 21.9125 9.39063C21.9125 8.46996 22.31 7.64224 22.9428 7.06943C22.0308 5.04841 20.5755 3.32518 18.763 2.08618H10.9561V21.9123H18.763C20.967 20.4057 22.6428 18.1833 23.4558 15.5799L23.043 15.1296Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3709" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$A(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3713)" }, [
      createElementVNode("path", {
        d: "M1.19072 6.78262C0.427875 8.36025 0 10.1301 0 12C0 13.8699 0.427875 15.6398 1.19072 17.2174L12 18.2609L22.8093 17.2174C23.5721 15.6398 24 13.8699 24 12C24 10.1301 23.5721 8.36025 22.8093 6.78262L12 5.73914L1.19072 6.78262Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.19141 17.2167C3.13231 21.2306 7.24273 23.9993 12.0003 23.9993C16.7578 23.9993 20.8682 21.2306 22.8091 17.2167H1.19141Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M1.19141 6.78287H22.8091C20.8682 2.76892 16.7578 0.000244141 12.0003 0.000244141C7.24273 0.000244141 3.13231 2.76892 1.19141 6.78287Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51392C-1.17157 8.2002 -1.17157 15.7982 3.51471 20.4845C5.45126 18.548 7.31375 16.6855 12 11.9992L3.51471 3.51392Z",
        fill: "#496E2D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3713" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$z(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3763)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.2536 7.82684H0.746344C0.264047 9.12687 0 10.5329 0 12.0007C0 13.4686 0.264047 14.8747 0.746344 16.1746H23.2536C23.736 14.8747 24 13.4686 24 12.0007C24 10.5329 23.736 9.12687 23.2536 7.82684Z",
        fill: "#A2001D"
      }),
      createElementVNode("path", {
        d: "M12.0345 24.0012C16.1446 24.0012 19.7716 21.9344 21.9343 18.7838H2.13477C4.29748 21.9344 7.92439 24.0012 12.0345 24.0012Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M12.0345 0.000305176C16.1446 0.000305176 19.7716 2.06712 21.9343 5.21768H2.13477C4.29748 2.06712 7.92439 0.000305176 12.0345 0.000305176Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M11.9991 7.82684L13.0351 11.0153H16.3878L13.6754 12.9861L14.7115 16.1746L11.9991 14.204L9.28665 16.1746L10.3228 12.9861L7.61035 11.0153H10.9631L11.9991 7.82684Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3763" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$y(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M61.7 28c-.1-1-.3-2-.6-3H2.8l-.6 3h59.5" }),
      createElementVNode("path", { d: "M2.3 36c.1 1 .3 2 .6 3h58.3l.6-3H2.3" }),
      createElementVNode("path", { d: "M20 4.5L17 6v52c1 .6 2 1.1 3 1.5v-55" }),
      createElementVNode("path", { d: "M28 2.3v59.5l3 .3V2c-1 0-2 .1-3 .3" })
    ]),
    createElementVNode("g", { fill: "#2a5f9e" }, [
      createElementVNode("path", { d: "M2 32c0 1.4.1 2.7.3 4h59.5c.2-1.3.3-2.6.3-4s-.1-2.7-.3-4H2.3c-.2 1.3-.3 2.6-.3 4" }),
      createElementVNode("path", { d: "M20 59.5c2.5 1.1 5.2 1.9 8 2.2V2.3c-2.8.4-5.5 1.1-8 2.2v55" })
    ]),
    createElementVNode("g", { fill: "#ed4c5c" }, [
      createElementVNode("path", { d: "M17 25V6C10 10.1 4.8 16.9 2.8 25H17z" }),
      createElementVNode("path", { d: "M17 39v19C10 53.9 4.8 47.1 2.8 39H17z" }),
      createElementVNode("path", { d: "M32 2h-1v23h30.2C58 11.8 46.2 2 32 2z" }),
      createElementVNode("path", { d: "M31 39v23h1c14.2 0 26-9.8 29.2-23H31" })
    ])
  ]);
}
function render$x(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3765)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.39067 10.435H23.8977C23.1307 4.54721 18.0962 0.000244141 11.9993 0.000244141C11.1033 0.000244141 10.2306 0.099291 9.39062 0.285479V10.435H9.39067Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.26085 10.4349V1.45923C2.96581 3.25707 0.607016 6.55478 0.101562 10.4349H6.26085V10.4349Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.2608 13.5657H0.101562C0.607016 17.4458 2.96581 20.7436 6.26085 22.5414L6.2608 13.5657Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M9.39062 13.5657V23.7152C10.2306 23.9014 11.1033 24.0005 11.9993 24.0005C18.0962 24.0005 23.1307 19.4535 23.8977 13.5657H9.39062V13.5657Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3765" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$w(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3766)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.26 9.91308H14.0861V5.73914H9.91217V9.91308H5.73828V14.087H9.91217V18.2609H14.0861V14.087H18.26V9.91308Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3766" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$v(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3767)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000732422C6.84013 -0.000732422 2.44161 3.25577 0.746094 7.82538H23.2534C21.5578 3.25577 17.1593 -0.000732422 11.9997 -0.000732422Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0005C17.1593 24.0005 21.5578 20.744 23.2533 16.1744H0.746094C2.44161 20.744 6.84012 24.0005 11.9997 24.0005Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M7.17067 9.13013L7.81815 11.1229H9.91361L8.21837 12.3547L8.8659 14.3475L7.17067 13.1159L5.47544 14.3475L6.12297 12.3547L4.42773 11.1229H6.52319L7.17067 9.13013Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M16.8308 9.13013L17.4783 11.1229H19.5738L17.8785 12.3547L18.5261 14.3475L16.8308 13.1159L15.1356 14.3475L15.7831 12.3547L14.0879 11.1229H16.1833L16.8308 9.13013Z",
        fill: "#6DA544"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3767" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$u(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3768)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37262 24 0 18.6274 0 12C4.12172 7.87828 7.61737 4.38263 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 12C12 5.37262 12 4.59131 12 0C5.37262 0 0 5.37262 0 12H12Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M10.435 7.02305L8.96945 7.71249L9.74983 9.13181L8.15847 8.82731L7.95677 10.435L6.84836 9.25261L5.73986 10.435L5.53825 8.82731L3.94684 9.13172L4.72722 7.71239L3.26172 7.02305L4.72727 6.33375L3.94684 4.91438L5.5382 5.21883L5.73991 3.61121L6.84836 4.79358L7.95681 3.61121L8.15847 5.21883L9.74987 4.91438L8.96945 6.3338L10.435 7.02305Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.84897 9.25671C8.08262 9.25671 9.0827 8.25664 9.0827 7.02298C9.0827 5.78932 8.08262 4.78925 6.84897 4.78925C5.61531 4.78925 4.61523 5.78932 4.61523 7.02298C4.61523 8.25664 5.61531 9.25671 6.84897 9.25671Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M6.84841 8.21399C6.19211 8.21399 5.6582 7.68004 5.6582 7.02374C5.6582 6.36745 6.19216 5.8335 6.84841 5.8335C7.50471 5.8335 8.03866 6.36745 8.03866 7.02374C8.03861 7.68004 7.50461 8.21399 6.84841 8.21399Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3768" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$t(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3769)" }, [
      createElementVNode("path", {
        d: "M1.19072 6.78177C0.427875 8.35939 0 10.1293 0 11.9991C0 13.869 0.427875 15.6389 1.19072 17.2165L12 18.26L22.8093 17.2165C23.5721 15.6389 24 13.869 24 11.9991C24 10.1293 23.5721 8.35939 22.8093 6.78177L12 5.73828L1.19072 6.78177Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.19141 17.2176C3.13236 21.2315 7.24278 24.0002 12.0003 24.0002C16.7577 24.0002 20.8682 21.2315 22.8091 17.2176H1.19141Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M1.19141 6.78201H22.8091C20.8682 2.76811 16.7577 -0.000610352 12.0003 -0.000610352C7.24278 -0.000610352 3.13236 2.76811 1.19141 6.78201Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M9.91309 15.1315H14.087V13.3576L13.2522 13.7749L12.0001 12.5228L10.7479 13.7749L9.91309 13.3576V15.1315Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M7.52504 13.0438L7.71934 13.6416H8.34793L7.83934 14.0111L8.03363 14.609L7.52504 14.2395L7.01645 14.609L7.21074 14.0111L6.70215 13.6416H7.33074L7.52504 13.0438Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M8.12758 10.9577L8.32187 11.5555H8.95047L8.44187 11.9251L8.63612 12.5229L8.12758 12.1534L7.61898 12.5229L7.81328 11.9251L7.30469 11.5555H7.93328L8.12758 10.9577Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.84926 9.39282L10.0436 9.99067H10.6721L10.1636 10.3602L10.3578 10.958L9.84926 10.5886L9.34071 10.958L9.53496 10.3602L9.02637 9.99067H9.65501L9.84926 9.39282Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.4752 13.0438L16.2809 13.6416H15.6523L16.1609 14.0111L15.9666 14.609L16.4752 14.2395L16.9838 14.609L16.7895 14.0111L17.2981 13.6416H16.6695L16.4752 13.0438Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M15.8727 10.9577L15.6784 11.5555H15.0498L15.5584 11.9251L15.3641 12.5229L15.8727 12.1534L16.3813 12.5229L16.187 11.9251L16.6956 11.5555H16.067L15.8727 10.9577Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.151 9.39282L13.9567 9.99067H13.3281L13.8366 10.3602L13.6424 10.958L14.151 10.5886L14.6595 10.958L14.4653 10.3602L14.9738 9.99067H14.3452L14.151 9.39282Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0006 8.60938L12.1949 9.20722H12.8235L12.3149 9.57673L12.5092 10.1746L12.0006 9.80511L11.492 10.1746L11.6863 9.57673L11.1777 9.20722H11.8063L12.0006 8.60938Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3769" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$s(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3770)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.51446 20.4856C4.01785 20.989 4.55495 21.4379 5.11834 21.8331L21.8326 5.11887C21.4374 4.55548 20.9884 4.01839 20.485 3.515C19.9816 3.01161 19.4446 2.56273 18.8812 2.16748L2.16699 18.8817C2.56215 19.445 3.01112 19.9821 3.51446 20.4856Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.51422 3.5138C-0.271495 7.29961 -0.998292 12.9851 1.33247 17.5012L17.5016 1.3321C12.9856 -0.998668 7.29999 -0.271825 3.51422 3.5138Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M20.4854 20.4851C24.2711 16.6994 24.9979 11.0138 22.6672 6.49768L6.49805 22.6668C11.014 24.9976 16.6996 24.2708 20.4854 20.4851Z",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3770" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$r(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3771)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.2536 7.82593H0.746391C0.264 9.12591 0 10.532 0 11.9998C0 13.4677 0.264 14.8737 0.746391 16.1737H23.2537C23.736 14.8737 24 13.4677 24 11.9998C24 10.532 23.736 9.12591 23.2536 7.82593Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0009 -0.000610352C8.36383 -0.000610352 5.10494 1.6177 2.9043 4.17328H21.0975C18.8969 1.6177 15.638 -0.000610352 12.0009 -0.000610352Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M21.0965 19.826H2.90332C5.10396 22.3816 8.36285 23.9999 11.9999 23.9999C15.637 23.9999 18.8959 22.3816 21.0965 19.826Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3771" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$q(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3611)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0001 -0.000366211C9.06209 -0.000366211 6.37119 1.05606 4.28516 2.80904L17.2175 11.9996L4.28516 21.1902C6.37119 22.9432 9.06209 23.9996 12.0001 23.9996C18.6275 23.9996 24.0001 18.627 24.0001 11.9996C24.0001 5.37226 18.6275 -0.000366211 12.0001 -0.000366211Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.5155C-1.17157 8.20178 -1.17157 15.7998 3.51471 20.4861C5.45126 18.5496 7.31375 16.6871 12 12.0008L3.51471 3.5155Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.32659 9.25146L5.15284 10.9798L7.36103 9.77684L6.28173 12.0479L8.10803 13.7763L5.61456 13.4516L4.53513 15.7226L4.07355 13.2508L1.58008 12.926L3.78817 11.7231L3.32659 9.25146Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3611" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$p(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3772)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M12.0002 0.000366211C11.9915 0.000459961 11.4785 4.80037 11.4785 4.80037H21.6008C19.4115 1.88582 15.9261 0.000366211 12.0002 0.000366211Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M11.9999 24.0003C15.9258 24.0003 19.4112 22.1149 21.6004 19.2003H2.39941C4.58866 22.1149 8.07405 24.0003 11.9999 24.0003Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M23.7599 9.60034H11.4785L12.0002 14.4003H23.7599C23.9174 13.6249 24.0002 12.8223 24.0002 12.0003C24.0002 11.1784 23.9174 10.3758 23.7599 9.60034Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M12 14.4C12 11.8957 12 2.81737 12 0C5.37262 0 0 5.37262 0 12C0 12.822 0.082875 13.6245 0.240281 14.4H12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.62155 5.73828L7.39855 8.12961H9.91316L7.87892 9.60772L8.65583 11.9991L6.62155 10.5212L4.58727 11.9991L5.36431 9.60772L3.33008 8.12961H5.84459L6.62155 5.73828Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3772" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$o(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3773)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.3043 5.73914C19.1967 6.25641 19.1478 6.80733 19.1478 7.35652C19.1478 10.5222 21.035 13.2621 23.7394 14.4955C23.9097 13.6904 24 12.8558 24 12C24 5.37262 18.6274 0 12 0C5.37262 0 0 5.37262 0 12C0 18.6274 5.37262 24 12 24C16.1101 24 19.7371 21.9332 21.8998 18.7826H6.78263V17.2174H22.8093C22.9733 16.8782 23.1215 16.53 23.2537 16.1739H6.78263L19.3043 5.73914Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M8.81498 6.26123L9.07401 7.05839H9.91214L9.23409 7.55109L9.49312 8.3482L8.81498 7.85559L8.13693 8.3482L8.39592 7.55109L7.71777 7.05839H8.55595L8.81498 6.26123Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.41146 12L5.73528 12.9965H6.78294L5.93529 13.6122L6.25911 14.6087L5.41146 13.9928L4.56387 14.6087L4.88763 13.6122L4.04004 12.9965H5.0877L5.41146 12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M5.41146 3.65247L5.73528 4.64898H6.78294L5.93529 5.26468L6.25911 6.26115L5.41146 5.64531L4.56387 6.26115L4.88763 5.26468L4.04004 4.64898H5.0877L5.41146 3.65247Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M2.80209 8.34753L3.1259 9.34405H4.17351L3.32591 9.95975L3.64973 10.9562L2.80209 10.3404L1.95449 10.9562L2.27826 9.95975L1.43066 9.34405H2.47827L2.80209 8.34753Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3773" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$n(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3774)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.82577 6.26137V4.69617H6.26052V6.26137H4.69531V7.82662H6.26052V9.39183H7.82577V7.82662H9.39097V6.26137H7.82577Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12 0V12C5.37262 12 2.73867 12 0 12C0 18.6274 5.37262 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37262 18.6274 0 12 0Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3774" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$m(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3775)" }, [
      createElementVNode("path", {
        d: "M6.49812 1.33191C5.42384 1.88639 4.41541 2.61319 3.51485 3.51375C2.61424 4.41436 1.88745 5.42278 1.33301 6.49706L9.04896 14.9509L17.5028 22.6669C18.5771 22.1124 19.5856 21.3856 20.4861 20.4851C21.3867 19.5845 22.1135 18.576 22.668 17.5018L14.952 9.04786L6.49812 1.33191Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M20.4858 20.486C20.9892 19.9826 21.4382 19.4455 21.8334 18.8821L5.11852 2.16711C4.55513 2.56232 4.01799 3.01129 3.5146 3.51468C3.01121 4.01807 2.56224 4.55521 2.16699 5.11865L18.8819 21.8335C19.4453 21.4383 19.9824 20.9894 20.4858 20.486Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.51431 20.4865C7.30026 24.2725 12.9861 24.9992 17.5023 22.6683L1.33251 6.49854C-0.998347 11.0148 -0.271457 16.7006 3.51431 20.4865Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.485 3.51461C16.6991 -0.271293 11.0133 -0.998043 6.49707 1.33272L22.6668 17.5026C24.9977 12.9864 24.271 7.30052 20.485 3.51461Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3775" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$l(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3714)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9999 17.7386C15.1695 17.7386 17.739 15.1692 17.739 11.9995C17.739 8.82988 15.1695 6.26038 11.9999 6.26038C8.83025 6.26038 6.26074 8.82988 6.26074 11.9995C6.26074 15.1692 8.83025 17.7386 11.9999 17.7386Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12.707 9.80505L13.6915 11.1619L15.2861 10.6448L14.3 12.0004L15.2844 13.3572L13.6904 12.8382L12.7043 14.1938L12.7053 12.5175L11.1113 11.9985L12.7059 11.4815L12.707 9.80505Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.3044 15.3906C11.4315 15.3906 9.91309 13.8722 9.91309 11.9993C9.91309 10.1263 11.4315 8.60794 13.3044 8.60794C13.8884 8.60794 14.4379 8.7556 14.9176 9.01557C14.165 8.27958 13.1359 7.82532 12.0001 7.82532C9.69494 7.82532 7.82617 9.69404 7.82617 11.9992C7.82617 14.3044 9.69494 16.1731 12.0001 16.1731C13.1359 16.1731 14.1651 15.7188 14.9176 14.9828C14.4379 15.2429 13.8884 15.3906 13.3044 15.3906Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3714" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$k(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3715)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.5087 9.80505L12.4933 11.1619L14.0879 10.6448L13.1017 12.0004L14.0862 13.3572L12.4922 12.8382L11.5061 14.1938L11.5071 12.5175L9.91309 11.9985L11.5077 11.4815L11.5087 9.80505Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M8.82198 15.3906C6.94905 15.3906 5.43067 13.8722 5.43067 11.9993C5.43067 10.1263 6.94905 8.60794 8.82198 8.60794C9.40595 8.60794 9.95542 8.75565 10.4351 9.01557C9.68256 8.27954 8.65333 7.82532 7.51764 7.82532C5.21242 7.82532 3.34375 9.69404 3.34375 11.9992C3.34375 14.3044 5.21247 16.1731 7.51764 16.1731C8.65342 16.1731 9.68261 15.7188 10.4351 14.9828C9.95542 15.2429 9.40595 15.3906 8.82198 15.3906Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3715" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$j(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3716)" }, [
      createElementVNode("path", {
        d: "M11.9995 -0.000610352C11.1035 -0.000610352 10.2308 0.0984365 9.39086 0.284624L8.86914 11.9993L9.39086 23.7141C10.2308 23.9003 11.1036 23.9994 11.9995 23.9994C18.6269 23.9994 23.9995 18.6268 23.9995 11.9993C23.9995 5.37197 18.6269 -0.000610352 11.9995 -0.000610352Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M3.13041 3.91711C1.18584 6.04974 0 8.88615 0 11.9997C0 15.1132 1.18589 17.9496 3.13045 20.0823L3.65217 11.9997L3.13041 3.91711Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M17.5512 9.05156C18.1416 7.40596 17.4783 5.61623 16.0548 4.72485C16.3109 4.75818 16.5672 4.81846 16.8201 4.90917C18.7187 5.59035 19.7056 7.68154 19.0244 9.58007C18.3432 11.4787 16.252 12.4656 14.3535 11.7844C14.1005 11.6936 13.8643 11.5771 13.6455 11.4401C15.311 11.657 16.9608 10.6971 17.5512 9.05156Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.2766 4.27429L13.7636 4.9372L12.9747 4.65412L13.4465 5.34684L12.9336 6.00965L13.7382 5.77499L14.2101 6.46762L14.2355 5.62987L15.0401 5.39517L14.2513 5.11218L14.2766 4.27429Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M15.6624 6.4353L15.1493 7.09816L14.3604 6.81508L14.8323 7.5078L14.3193 8.17062L15.1239 7.93587L15.5959 8.62863L15.6213 7.79083L16.4259 7.55608L15.637 7.27305L15.6624 6.4353Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.8332 5.06042L11.3202 5.72324L10.5313 5.44025L11.0032 6.13293L10.4902 6.79578L11.2948 6.56108L11.7667 7.25375L11.7921 6.416L12.5967 6.1813L11.8079 5.89822L11.8332 5.06042Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.7776 7.53455L11.2646 8.19741L10.4757 7.91437L10.9477 8.60709L10.4346 9.26991L11.2393 9.03525L11.7112 9.72787L11.7365 8.89012L12.5412 8.65542L11.7522 8.37234L11.7776 7.53455Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M14.1321 8.38L13.6191 9.04282L12.8302 8.75979L13.3022 9.4525L12.7891 10.1153L13.5938 9.88061L14.0657 10.5733L14.091 9.73549L14.8957 9.50083L14.1067 9.2178L14.1321 8.38Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M3.12988 3.91743V20.0826C4.76488 21.8758 6.9366 23.1707 9.39074 23.7147V0.285278C6.93655 0.82931 4.76493 2.12423 3.12988 3.91743Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M5.51985 6.31761L4.47168 5.53676V4.43253L5.51985 3.65173H7.00228L8.05045 4.43253V5.53676L7.00228 6.31761H5.51985Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.26108 3.65173H5.51985L4.47168 4.43253V4.97239H6.26108V3.65173Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M6.26074 6.31668H7.00193L8.0501 5.53583V4.97253H6.26074V6.31668Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M5.51985 20.3485L4.47168 19.5676V18.4635L5.51985 17.6826H7.00228L8.05045 18.4635V19.5676L7.00228 20.3485H5.51985Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.26108 17.6826H5.51985L4.47168 18.4635V19.0033H6.26108V17.6826Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M6.26074 20.3493H7.00193L8.0501 19.5685V19.0052H6.26074V20.3493Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M5.51985 13.3324L4.47168 12.5515V11.4473L5.51985 10.6665H7.00227L8.05044 11.4473V12.5515L7.00227 13.3324H5.51985Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M8.0867 15.0514H7.63014V14.5949H6.82787L6.26059 14.0276L5.69335 14.5949H4.89109V15.0514H4.43457V15.9644H4.89109V16.4209H5.69331L6.26063 16.9883L6.82787 16.4209H7.63014V15.9644H8.0867V15.0514Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M8.0867 8.03605H7.63014V7.57949H6.82787L6.26059 7.01221L5.69335 7.57949H4.89109V8.03605H4.43457V8.94908H4.89109V9.4056H5.69331L6.26063 9.97297L6.82787 9.4056H7.63014V8.94908H8.0867V8.03605Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M6.78274 11.4791H5.73926V12.5226H6.78274V11.4791Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.26097 9.01487C6.54911 9.01487 6.78269 8.78129 6.78269 8.49315C6.78269 8.20502 6.54911 7.97144 6.26097 7.97144C5.97284 7.97144 5.73926 8.20502 5.73926 8.49315C5.73926 8.78129 5.97284 9.01487 6.26097 9.01487Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.26097 16.0309C6.54911 16.0309 6.78269 15.7973 6.78269 15.5091C6.78269 15.221 6.54911 14.9874 6.26097 14.9874C5.97284 14.9874 5.73926 15.221 5.73926 15.5091C5.73926 15.7973 5.97284 16.0309 6.26097 16.0309Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3716" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$i(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { fill: "#2a5f9e" }, [
      createElementVNode("path", { d: "M32 2v30H2c0 16.6 13.4 30 30 30s30-13.4 30-30S48.6 2 32 2z" }),
      createElementVNode("path", { d: "M12 12h21v21H12z" })
    ]),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M18.9 8.1V14h-7.3L26 32h6v-7.5z" }),
      createElementVNode("path", { d: "M11 18.9H5c-1.9 4-3 8.4-3 13.1h12V13.9h-3v5" })
    ]),
    createElementVNode("path", {
      fill: "#ed4c5c",
      d: "M32 27.1L19 11h-6l17 21h2z"
    }),
    createElementVNode("path", {
      d: "M18.9 5v6H11v3h21V2c-4.7 0-9.1 1.1-13.1 3z",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M32 5H18.9c-6 2.9-11 7.9-13.9 13.9V32h6V11h21V5z",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M58 26.5v9.3c0 7.6-3 14.6-11.9 18.8c-8.9-4.2-11.9-11.2-11.9-18.8v-9.3H58",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M57.2 27.4V36c0 7.1-2.8 13.6-11.1 17.5C37.8 49.6 35 43.1 35 36v-8.6h22.2",
      fill: "#ffce31"
    }),
    createElementVNode("path", {
      d: "M41 31.2c-.5-.4-.4 0-.6-.6c-.2-.4-.6-.5-.9-.7c-.2-.1-1.2-1.5-1.5-1.4c-.3.1-.4 1-.4 1.1c-.2.6.1.5.2.9c-.3 0 .1.4.2.4c-.1.1-.1.2 0 .3c-.6 0-1.1.6-1.5.9c.3 0 .4-.2.7-.2c.3 0 .5.3.8.2c-.2.2-.5.4-.5.7c-.1.6-.8.6-1 1.2c.4.9 1.3 1 2.1 1.5c.6.4 1 .8 1.4 1.4c.4.7 1.3 1.7 2 .6c.4-.7.2-2.2.2-3c-.1-.8-.2-2.7-1.2-3.3",
      fill: "#ff9e3d"
    }),
    createElementVNode("path", {
      d: "M41.7 29.1c-.8.9-.7 1.4-.7 2.5s-.9 1.2-1.2 2.1c-.3 1 1 1.6 1.2 2.5c.1.5.1 1 .4 1.4c.2.3 1.1.2 1.4 0c.3-.2.1-.7.3-1c.2-.4.7-.3.9-.6c.5-.7.5-2 .1-2.7c-.2-.4.1-.9-.4-1.2c-.4-.3-.2-.7-.6-1c-.7-.6-.4-1.6-1.4-2",
      fill: "#ff927f"
    }),
    createElementVNode("path", {
      d: "M41.8 37.8c.9-.2.8-1.7.7-2.3s-.5-1.5-.2-2.2c.4-1-.5-1.9-.2-2.3c.2-.4.2-.6.2-.7c0-.1-.2-.2-.2 0c0 .3-.1.3-.2.5s-.1.5 0 .9s.4 1 0 1.7c-.4.8-.2 1.1-.1 1.5c0 .6.6 2.6 0 2.9",
      fill: "#ff9ee1"
    }),
    createElementVNode("g", { fill: "#ff9e3d" }, [
      createElementVNode("path", { d: "M37.8 29.4c.1 0 .3 0 .3.1" }),
      createElementVNode("path", { d: "M37.6 30.1c.1-.1.3 0 .5-.1" }),
      createElementVNode("path", { d: "M37.8 30.6c.2 0 .4 0 .6-.2" }),
      createElementVNode("path", { d: "M38 31.1c.1 0 .4-.1.5-.3" }),
      createElementVNode("path", { d: "M38.1 31.4c.3 0 .7.1.7 0" }),
      createElementVNode("path", { d: "M38.1 32.3c.2-.2.7-.3.8-.5" }),
      createElementVNode("path", { d: "M38.6 29.3c.3.1.2.3.4.4c.3.2 0 .5.3.5c.2.1.2.1.2.4c-.1.3.2.3.1.5" }),
      createElementVNode("path", { d: "M40.4 31c-.1 0-.5 0-.7.4" }),
      createElementVNode("path", { d: "M37.6 34.9c.2 0 .2-.1.3-.1c0-.1.1-.2.2-.2s.4 0 .4-.2s.2 0 .4-.3c.1-.3.2-.6.6-.7" })
    ]),
    createElementVNode("path", {
      d: "M48.1 40.7c.2.2 0 .5.2.6c.3.1 0 .5.4.6c.3.1 0 .5.3.7c.3.2-.1.5.4.7s-.1.7.2.8s-.1.6.3.8c.4.2-.2.5.2.8c.3.3-.1.6.3.9s-.2.5.1.9c.3.3-.1.5.1.9c.1.3-.1 1.3-.8 1.2c-.3.4-1.2.8-1.6.7c-.4.3-1.5.6-2.1.1c-.6.6-1.7.2-2.1-.1c-.4.1-1.3-.3-1.6-.7c-.7.1-1-.9-.8-1.2c.2-.4-.2-.6.1-.9c.3-.3-.2-.6.1-.9s-.1-.6.3-.9c.3-.3-.2-.6.2-.8c.4-.2-.1-.6.3-.8c.3-.2-.2-.6.2-.8s.1-.6.4-.7c.3-.2 0-.5.3-.7c.4-.1.1-.5.4-.6c.3-.1.1-.3.3-.6c.6.3 3 .5 3.9 0",
      fill: "#699635"
    }),
    createElementVNode("path", {
      d: "M48.2 40.5s-.1-.1-.2-.1c-.1-2.4-.5-3.3-1.9-3.3s-1.8.9-1.9 3.3c-.1 0-.1 0-.2.1c-.2.2-.2.4.4.6c.4.2 1.1.3 1.7.3c.6 0 1.2-.1 1.7-.3c.5-.2.5-.3.4-.6",
      fill: "#ed4c5c"
    }),
    createElementVNode("path", {
      d: "M54.6 33.4v-.7l2.2-.2l-2.2-.2V32l-.1-.6l2.2-.4l-2.3.1l-.3-.6l1.6-1.3l-1.9 1l-.8-.4l-.8-1.2l.1-.4l-.8 1.8v.6l.1.4l-.1-.6v-.6l-.8-1.8l.1.4l-.8 1.2l-.8.4l-1.9-1l1.6 1.3l-.3.6l-2.2.1l2.2.4l-.1.6v.3l-2.2.2l2.2.2v.7l-2 .8l2-.5l.2 4.3l-.5 2.8l.8-2.6l-.1-4.5l1.1.3l.2.5l.1.6l.2.5v.1l.1.6l.1.6l.1.5l.2.2l-.9.9l-.1.8l.6-.2l.1.7l.3-.1l.2.3l.4-.8l.4.8l.2-.3l.3.1l.1-.7l.6.2l-.1-.7l-.9-.9l.2-.2l.1-.5l.1-.6l.1-.6v-.1l.2-.5l.1-.6l.2-.5l1.1-.3l-.1 4.5l.8 2.6l-.6-2.9l.2-4.3l2 .5l-2-.8m-3.5-2.5l-.7-.8l.7.5v.3m-.2.3l-.1.1l-1.2-.9l.6-.2l.7 1m0-2.6l.4 1.3v.2l-.9-.3l.5-1.2m-1.6 2.1l1.2.9l-.1.2l-1.1-.5l-.2-.1l.2-.5m-.4 1.3l.1-.5l1.2.6v.3l-.1.3l-.8-.3l-.4-.1V32m0 1.4v-.6l1.2.4v.5l-1-.2l-.2-.1m3.5-2.1l-.1-.1l.8-1l.6.2l-1.3.9m-.3-.4v-.2l.7-.5l-.7.7m.8.9l-.1-.2l1.2-.9l.2.5H54l-1.1.6m-.5-3.2l.5 1.1l-.9.4v-.2l.4-1.3m.6 3.5l1.2-.6l.1.5v.3l-.3.1l-.8.3l-.2-.3v-.3m1.2 1.3l-1 .2v-.5l1.2-.4v.6l-.2.1",
      fill: "#b95a1e"
    })
  ]);
}
function render$h(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3718)" }, [
      createElementVNode("path", {
        d: "M24 12C24 18.6274 18.6274 24 12 24C5.37263 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M5.73926 12.0012H9.78654L6.26098 7.82727L5.73926 9.39247V12.0012Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M12.0001 9.78671L7.82617 5.73938H12.0001L12.0001 9.78671Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9678 11.9996H11.9999C11.9999 11.9888 11.9999 11.9783 11.9999 11.9674C11.9892 11.9782 11.9785 11.9889 11.9678 11.9996Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 6.26123C12 4.14974 12 2.76618 12 0.000366211H11.998C5.3715 0.00149121 0 5.3736 0 12.0004H6.26091V8.47485L9.78642 12.0004H11.968C11.9787 11.9897 11.9894 11.979 12.0001 11.9683C12.0001 11.1598 12.0001 10.4384 12.0001 9.78683L8.47444 6.26123H12Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.07124 1.56543C4.19441 2.63413 2.63413 4.19441 1.56543 6.07124V12.0002H4.69588V4.69598V4.69588H12.0002C12.0002 3.70856 12.0002 2.76796 12.0002 1.56543H6.07124Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0009 10.5242L7.73735 6.26074H6.26172V6.26084L12.0008 11.9998H12.0009C12.0009 11.9998 12.0009 10.9823 12.0009 10.5242Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.0972 19.8252L13.3562 20.6224H14.1944L13.5163 21.115L13.7753 21.9121L13.0972 21.4195L12.4191 21.9121L12.6781 21.115L12 20.6224H12.8381L13.0972 19.8252Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.773 14.6094L20.032 15.4065H20.8701L20.1921 15.8992L20.4512 16.6963L19.773 16.2037L19.0949 16.6963L19.354 15.8992L18.6758 15.4065H19.5139L19.773 14.6094Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M21.4448 6.78259L21.7038 7.57975H22.542L21.864 8.07241L22.123 8.86951L21.4448 8.3769L20.7668 8.86951L21.0258 8.07241L20.3477 7.57975H21.1858L21.4448 6.78259Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M21.8599 12.5215L22.1189 13.3187H22.9571L22.279 13.8113L22.538 14.6085L21.8599 14.1158L21.1819 14.6085L21.4409 13.8113L20.7627 13.3187H21.6009L21.8599 12.5215Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.299 17.9513L15.0459 18.3319L15.6386 17.7393L15.5075 18.567L16.2543 18.9475L15.4264 19.0787L15.2953 19.9066L14.9148 19.1597L14.0869 19.2909L14.6796 18.6983L14.299 17.9513Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M14.299 14.8215L15.0459 15.202L15.6386 14.6094L15.5075 15.4372L16.2543 15.8177L15.4264 15.9488L15.2953 16.7767L14.9148 16.0299L14.0869 16.161L14.6796 15.5684L14.299 14.8215Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.9084 16.8272L17.6553 17.2078L18.2479 16.6151L18.1169 17.4429L18.8637 17.8234L18.0357 17.9546L17.9046 18.7824L17.5242 18.0355L16.6963 18.1668L17.2889 17.5741L16.9084 16.8272Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M16.9084 10.1248L17.6553 10.5054L18.2479 9.91272L18.1169 10.7405L18.8637 11.121L18.0357 11.2522L17.9046 12.08L17.5242 11.3332L16.6963 11.4644L17.2889 10.8717L16.9084 10.1248Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M19.4367 10.0445L20.1836 10.425L20.7763 9.8324L20.6451 10.6602L21.392 11.0407L20.5641 11.1718L20.4329 11.9997L20.0525 11.2529L19.2246 11.3841L19.8172 10.7914L19.4367 10.0445Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3718" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$g(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3719)" }, [
      createElementVNode("path", {
        d: "M20.9434 20.0001C22.8439 17.8771 24 15.0739 24 12.0002C24 8.92648 22.8438 6.12321 20.9434 4.00015L12 3.13062L3.05662 4.00015C1.15617 6.12321 0 8.92648 0 12.0002C0 15.0739 1.15613 17.8771 3.05658 20.0001L12 20.8697L20.9434 20.0001Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.05664 4.00047H20.9434C18.7462 1.54577 15.5537 0.000488281 12 0.000488281C8.44628 0.000488281 5.25386 1.54577 3.05664 4.00047Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M0 12.0008L12 13.0442L24 12.0008C24 10.5981 23.7585 9.25192 23.3162 8.00073H0.683812C0.241453 9.25192 0 10.5981 0 12.0008Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.683812 15.9993H23.3163C23.7585 14.7481 24 13.402 24 11.9993H0C0 13.402 0.241453 14.7481 0.683812 15.9993Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M20.9435 19.9995H3.05664C5.25386 22.4543 8.44628 23.9995 12.0001 23.9995C15.5538 23.9995 18.7463 22.4543 20.9435 19.9995Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M16.0038 12.0007C16.0038 14.2124 14.2112 16.005 11.9995 16.005C9.78776 16.005 7.99512 14.2124 7.99512 12.0007C7.99512 9.78898 9.78776 7.99634 11.9995 7.99634C14.2112 7.99634 16.0038 9.78898 16.0038 12.0007Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.4669 12.2036L11.9999 11.568C11.9999 11.568 12.3431 10.4288 12.3614 10.3508C12.3748 10.2939 12.3819 10.2345 12.3819 10.1734C12.3819 9.9573 12.2943 9.76164 12.1526 9.62008L12.5215 9.25117C12.2855 9.01516 11.9594 8.86914 11.5992 8.86914C11.239 8.86914 10.9129 9.01511 10.6769 9.25117L11.0458 9.62008C10.9042 9.76169 10.8166 9.95734 10.8166 10.1734C10.8166 10.2525 10.8285 10.3286 10.8503 10.4006L10.2949 10.956H11.3044C11.3044 10.956 10.887 11.5829 10.6592 12.0977C10.4313 12.6125 10.6623 13.2409 11.1889 13.475L11.4934 13.6104L11.9999 14.0864V14.6081L11.4782 15.1299H12.5217V14.0864L12.9978 13.6103H13.9825C13.9873 13.6005 13.9922 13.5909 13.9967 13.5809C14.2307 13.0543 13.9935 12.4376 13.4669 12.2036Z",
        fill: "black"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3719" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$f(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3720)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M0 12C0 5.37262 5.37262 0 12 0C18.6274 0 24 5.37262 24 12",
        fill: "#338AF3"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3720" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$e(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3722)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M2.48032 4.69299C1.53771 5.91938 0.826945 7.3329 0.413086 8.86848H6.6558L2.48032 4.69299Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.5864 8.86855C23.1725 7.33302 22.4617 5.91951 21.5191 4.69312L17.3438 8.86855H23.5864Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M0.413086 15.1302C0.826992 16.6658 1.53776 18.0793 2.48032 19.3056L6.65567 15.1302H0.413086Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M19.3053 2.47976C18.0789 1.53715 16.6655 0.826382 15.1299 0.412476V6.65515L19.3053 2.47976Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M4.69336 21.5176C5.91975 22.4602 7.33327 23.171 8.8688 23.5849V17.3423L4.69336 21.5176Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M8.86875 0.412476C7.33322 0.826382 5.9197 1.53715 4.69336 2.47971L8.86875 6.6551V0.412476Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M15.1299 23.5849C16.6654 23.171 18.0789 22.4602 19.3053 21.5177L15.1299 17.3423V23.5849Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M17.3438 15.1302L21.5191 19.3057C22.4617 18.0793 23.1725 16.6658 23.5864 15.1302H17.3438Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.1309 15.1313L20.4857 20.4861C20.732 20.2399 20.9669 19.9825 21.191 19.7157L16.6066 15.1312H15.1309V15.1313Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M8.86951 15.1312H8.86941L3.51465 20.486C3.76084 20.7323 4.01823 20.9672 4.28504 21.1914L8.86951 16.6068V15.1312Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M8.86976 8.86911V8.86902L3.51495 3.51416C3.26866 3.76035 3.03373 4.01774 2.80957 4.28455L7.39409 8.86907H8.86976V8.86911Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.1309 8.87017L20.4857 3.51526C20.2395 3.26898 19.9821 3.03405 19.7153 2.80994L15.1309 7.39445V8.87017Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3722" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$d(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3721)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M6.78223 16.1729L7.82571 23.2527C9.12565 23.7351 10.5318 23.999 11.9996 23.999C17.1591 23.999 21.5577 20.7425 23.2532 16.1729H6.78223Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M6.78223 7.8266L7.82571 0.746785C9.12565 0.264394 10.5318 0.000488281 11.9996 0.000488281C17.1591 0.000488281 21.5577 3.25699 23.2532 7.8266H6.78223Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M0 11.9999C0 17.1595 3.25655 21.558 7.82611 23.2536V0.746338C3.25655 2.44185 0 6.84037 0 11.9999Z",
        fill: "#A2001D"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3721" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$c(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3723)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.4775 12H23.9993C23.9993 10.9169 23.8549 9.86761 23.5859 8.86951H11.4775V12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.4775 5.73848H22.238C21.5034 4.5398 20.5642 3.48028 19.4691 2.60803H11.4775V5.73848Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0001 23.9999C14.8243 23.9999 17.4201 23.0238 19.4699 21.3912H4.53027C6.58012 23.0238 9.17591 23.9999 12.0001 23.9999Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M1.76098 18.2598H22.2384C22.8281 17.2975 23.2855 16.2457 23.5863 15.1294H0.413086C0.713883 16.2457 1.17124 17.2975 1.76098 18.2598Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M5.55863 1.87397H6.65217L5.63498 2.61295L6.02353 3.80869L5.00639 3.0697L3.98925 3.80869L4.32487 2.7757C3.42928 3.52172 2.64431 4.39575 1.99744 5.36963H2.34783L1.70034 5.84002C1.59947 6.0083 1.50272 6.17925 1.41 6.35273L1.71919 7.30434L1.14234 6.88523C0.998953 7.18903 0.867797 7.49967 0.749906 7.81678L1.09055 8.86528H2.34783L1.33064 9.60427L1.71919 10.8L0.702047 10.061L0.0927656 10.5037C0.0317812 10.9939 0 11.4932 0 12H12C12 5.37262 12 4.59131 12 0C9.62944 0 7.41961 0.687656 5.55863 1.87397ZM6.02353 10.8L5.00639 10.061L3.98925 10.8L4.3778 9.60427L3.36061 8.86528H4.61789L5.00639 7.66955L5.39489 8.86528H6.65217L5.63498 9.60427L6.02353 10.8ZM5.63498 6.10861L6.02353 7.30434L5.00639 6.56536L3.98925 7.30434L4.3778 6.10861L3.36061 5.36963H4.61789L5.00639 4.17389L5.39489 5.36963H6.65217L5.63498 6.10861ZM10.3279 10.8L9.31073 10.061L8.29359 10.8L8.68214 9.60427L7.66495 8.86528H8.92223L9.31073 7.66955L9.69923 8.86528H10.9565L9.93933 9.60427L10.3279 10.8ZM9.93933 6.10861L10.3279 7.30434L9.31073 6.56536L8.29359 7.30434L8.68214 6.10861L7.66495 5.36963H8.92223L9.31073 4.17389L9.69923 5.36963H10.9565L9.93933 6.10861ZM9.93933 2.61295L10.3279 3.80869L9.31073 3.0697L8.29359 3.80869L8.68214 2.61295L7.66495 1.87397H8.92223L9.31073 0.678234L9.69923 1.87397H10.9565L9.93933 2.61295Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3723" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$b(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3724)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M12 8.86873H23.5866C23.2857 7.75245 22.8284 6.70053 22.2387 5.73828H12V8.86873Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M4.5296 21.3898H19.4693C20.5644 20.5176 21.5036 19.4581 22.2381 18.2594H1.76074C2.49532 19.4581 3.43451 20.5176 4.5296 21.3898Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12 -0.000854492C12 1.04263 12 2.60783 12 2.60783H19.4699C17.42 0.975271 14.8242 -0.000854492 12 -0.000854492Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M12 8.86873H23.5866C23.2857 7.75245 22.8284 6.70053 22.2387 5.73828H12V8.86873Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M0 12.0001C0 13.0833 0.144375 14.1324 0.413391 15.1306H23.5867C23.8556 14.1324 24 13.0833 24 12.0001H0Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M10.435 7.02317L8.96941 7.71256L9.74983 9.13194L8.15842 8.82753L7.95677 10.4351L6.84836 9.25273L5.73986 10.4351L5.53825 8.82753L3.94684 9.13184L4.72722 7.71251L3.26172 7.02317L4.72727 6.33387L3.94684 4.9145L5.5382 5.21891L5.73991 3.61133L6.84836 4.7937L7.95681 3.61133L8.15842 5.21891L9.74988 4.9145L8.96945 6.33392L10.435 7.02317Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3724" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$a(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3779)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#FCFCFC"
      }),
      createElementVNode("path", {
        d: "M14.0373 8.38349C14.0373 7.25793 13.1249 6.34546 11.9993 6.34546C10.8737 6.34546 9.96118 7.25793 9.96118 8.38349H5.47754C5.47754 9.49166 6.44288 10.3901 7.55105 10.3901H7.48431C7.48431 11.4984 8.38262 12.3969 9.49098 12.3969C9.49098 13.3781 10.1957 14.1934 11.1264 14.3677L11.1212 14.3794H12.8774L12.8722 14.3677C13.8029 14.1934 14.5076 13.3781 14.5076 12.3969C15.6159 12.3969 16.5143 11.4984 16.5143 10.3901H16.4474C17.5556 10.3901 18.521 9.49166 18.521 8.38349H14.0373Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M11.1035 14.1724L9.83984 17.0253C10.5066 17.2964 11.2354 17.447 11.9995 17.447C12.7636 17.447 13.4923 17.2964 14.159 17.0253L12.8954 14.1724H11.1035Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M9.3916 9.3855V12.896C9.3916 14.8928 12.0003 15.5047 12.0003 15.5047C12.0003 15.5047 14.609 14.8928 14.609 12.896V9.3855H9.3916Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M2.91024 12.0846L4.32113 16.0307L5.71735 12.0846H6.78292L4.74732 17.302H3.8949L1.84473 12.0846H2.91024Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M19.3047 17.302V12.0846H20.3187V17.302H19.3047Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M10.4346 10.5195V14.7736C10.7932 15.0376 11.1791 15.2191 11.4781 15.3354V10.5195H10.4346Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M13.565 10.5195V14.7736C13.2063 15.0376 12.8205 15.2191 12.5215 15.3354V10.5195H13.565Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M14.609 9.3855H9.3916V11.0409H14.609V9.3855Z",
        fill: "#0052B4"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3779" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$9(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3725)" }, [
      createElementVNode("path", {
        d: "M0.566625 8.34794C0.199031 9.49956 -4.68667e-05 10.7264 8.27601e-09 12C-4.68667e-05 13.2736 0.199078 14.5005 0.566672 15.6521L12 16.174L23.4333 15.6522C23.8009 14.5006 24.0001 13.2736 24.0001 12.0001C24 10.7265 23.8009 9.49956 23.4333 8.34789L12 7.82617L0.566625 8.34794Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.4332 8.34789L11.9999 7.82617L0.5665 8.34789C0.457563 8.68933 0.363766 9.03747 0.285156 9.39137H23.7144C23.6359 9.03742 23.5421 8.68923 23.4332 8.34789Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M0.285156 14.609C0.363672 14.9629 0.457469 15.311 0.566406 15.6524L0.567531 15.6525L11.9997 16.1742L23.433 15.6525C23.542 15.3111 23.6358 14.9629 23.7143 14.609H0.285156Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0007 24.0007C17.3545 24.0007 21.8888 20.4943 23.434 15.6528H0.567383C2.11262 20.4942 6.64693 24.0007 12.0007 24.0007Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M11.9997 -0.000854492C6.64595 -0.000807617 2.11173 3.50558 0.566406 8.34697L23.433 8.34702C21.8879 3.50554 17.3536 -0.000901367 11.9997 -0.000854492Z",
        fill: "#338AF3"
      }),
      createElementVNode("path", {
        d: "M5.48376 4.95618C5.48376 3.83226 6.27365 2.89335 7.32847 2.66301C7.16638 2.62757 6.99815 2.6084 6.82536 2.6084C5.52871 2.6084 4.47754 3.65952 4.47754 4.95623C4.47754 6.25293 5.52862 7.30406 6.82536 7.30406C6.99815 7.30406 7.16633 7.28484 7.32847 7.24945C6.27369 7.01901 5.48376 6.0801 5.48376 4.95618Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M8.71531 6.02246L8.87421 6.5116H9.38853L8.97246 6.81395L9.13137 7.30309L8.71531 7.00079L8.29915 7.30309L8.4581 6.81395L8.04199 6.5116H8.55631L8.71531 6.02246Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.3578 6.02246L10.5167 6.5116H11.0311L10.6149 6.81395L10.7739 7.30309L10.3578 7.00079L9.94168 7.30309L10.1006 6.81395L9.68457 6.5116H10.1988L10.3578 6.02246Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9995 6.02246L12.1584 6.5116H12.6728L12.2566 6.81395L12.4156 7.30309L11.9995 7.00079L11.5833 7.30309L11.7423 6.81395L11.3262 6.5116H11.8405L11.9995 6.02246Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.6411 6.02246L13.8 6.5116H14.3143L13.8982 6.81395L14.0572 7.30309L13.6411 7.00079L13.2249 7.30309L13.3839 6.81395L12.9678 6.5116H13.4821L13.6411 6.02246Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M15.2826 6.02246L15.4415 6.5116H15.9559L15.5398 6.81395L15.6987 7.30309L15.2826 7.00079L14.8665 7.30309L15.0254 6.81395L14.6094 6.5116H15.1236L15.2826 6.02246Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.3578 4.31506L10.5167 4.80416H11.0311L10.6149 5.10655L10.7739 5.59564L10.3578 5.29335L9.94168 5.59564L10.1006 5.10655L9.68457 4.80416H10.1988L10.3578 4.31506Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9995 4.31506L12.1584 4.80416H12.6728L12.2566 5.10655L12.4156 5.59564L11.9995 5.29335L11.5833 5.59564L11.7423 5.10655L11.3262 4.80416H11.8405L11.9995 4.31506Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.6411 4.31506L13.8 4.80416H14.3143L13.8982 5.10655L14.0572 5.59564L13.6411 5.29335L13.2249 5.59564L13.3839 5.10655L12.9678 4.80416H13.4821L13.6411 4.31506Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M15.2826 4.31506L15.4415 4.80416H15.9559L15.5398 5.10655L15.6987 5.59564L15.2826 5.29335L14.8665 5.59564L15.0254 5.10655L14.6094 4.80416H15.1236L15.2826 4.31506Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9995 2.60803L12.1584 3.09722H12.6728L12.2566 3.39952L12.4156 3.8887L11.9995 3.58641L11.5833 3.8887L11.7423 3.39952L11.3262 3.09722H11.8405L11.9995 2.60803Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.6411 2.60803L13.8 3.09722H14.3143L13.8982 3.39952L14.0572 3.8887L13.6411 3.58641L13.2249 3.8887L13.3839 3.39952L12.9678 3.09722H13.4821L13.6411 2.60803Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M15.2826 2.60803L15.4415 3.09722H15.9559L15.5398 3.39952L15.6987 3.8887L15.2826 3.58641L14.8665 3.8887L15.0254 3.39952L14.6094 3.09722H15.1236L15.2826 2.60803Z",
        fill: "#F0F0F0"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3725" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$8(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3776)" }, [
      createElementVNode("path", {
        d: "M24 12.0003C24 11.4698 23.9651 10.9475 23.8984 10.4351H10.4347C7.98306 7.98365 3.51452 3.51539 3.5147 3.51501C-1.17157 8.20129 -1.17157 15.7992 3.5147 20.4856L10.4348 13.5656H23.8984C23.9651 13.0532 24 12.5308 24 12.0003Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9968 12.2726C23.9963 12.2958 23.9958 12.319 23.9951 12.3422C23.9957 12.3189 23.9962 12.2958 23.9968 12.2726Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9853 12.6002C23.9843 12.6232 23.9827 12.646 23.9814 12.6689C23.9827 12.6461 23.9842 12.6232 23.9853 12.6002Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9684 12.8632C23.966 12.8969 23.9637 12.9307 23.9609 12.9643C23.9637 12.9307 23.966 12.8969 23.9684 12.8632Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9287 10.6921C23.9331 10.7323 23.9375 10.7724 23.9415 10.8127C23.9375 10.7724 23.9331 10.7323 23.9287 10.6921Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9805 11.3298C23.9817 11.3527 23.9833 11.3756 23.9844 11.3985C23.9832 11.3756 23.9817 11.3527 23.9805 11.3298Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9951 11.6567C23.9958 11.6799 23.9962 11.7032 23.9968 11.7264C23.9963 11.7031 23.9957 11.6799 23.9951 11.6567Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9609 11.0355C23.9637 11.0692 23.966 11.1029 23.9684 11.1367C23.966 11.1029 23.9637 11.0692 23.9609 11.0355Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.8984 10.4344C23.9038 10.4755 23.9086 10.5168 23.9135 10.558C23.2013 4.61044 18.1395 -0.000366211 12 -0.000366211C8.68626 -0.000366211 5.68622 1.34283 3.51465 3.5145L10.4345 10.4344H23.8984V10.4344Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M23.8984 13.5652H10.4345L3.51465 20.4851C5.68622 22.6567 8.68626 24 12 24C18.1395 24 23.2014 19.3892 23.9135 13.4415C23.9086 13.4827 23.9037 13.5241 23.8984 13.5652Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M23.9415 13.1877C23.9375 13.228 23.9331 13.2681 23.9287 13.3083C23.9331 13.2681 23.9376 13.2281 23.9415 13.1877Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M23.9688 11.137C23.9733 11.2012 23.9774 11.2655 23.981 11.33C23.9774 11.2655 23.9733 11.2012 23.9688 11.137Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9131 10.5583C23.9185 10.6029 23.9236 10.6475 23.9284 10.6922C23.9235 10.6475 23.9184 10.6029 23.9131 10.5583Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9414 10.8124C23.9487 10.8869 23.9553 10.9616 23.9613 11.0367C23.9554 10.9616 23.9488 10.8869 23.9414 10.8124Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M24.0005 12C24.0005 12.0913 23.9991 12.1823 23.9971 12.2731C23.9991 12.1823 24.0005 12.0913 24.0005 12Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.981 12.6688C23.9774 12.7333 23.9733 12.7977 23.9688 12.8619C23.9733 12.7977 23.9773 12.7333 23.981 12.6688Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9613 12.964C23.9553 13.0389 23.9487 13.1137 23.9414 13.1882C23.9488 13.1137 23.9554 13.0389 23.9613 12.964Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9284 13.3081C23.9236 13.3528 23.9185 13.3974 23.9131 13.4419C23.9184 13.3974 23.9235 13.3528 23.9284 13.3081Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9971 11.7274C23.9991 11.8183 24.0005 11.9093 24.0005 12.0005C24.0005 11.9093 23.9991 11.8183 23.9971 11.7274Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9854 11.3982C23.9896 11.4841 23.9928 11.5704 23.9952 11.6569C23.9928 11.5704 23.9896 11.4841 23.9854 11.3982Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9952 12.3419C23.9928 12.4283 23.9896 12.5146 23.9854 12.6006C23.9897 12.5146 23.9928 12.4283 23.9952 12.3419Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M23.9892 11.4733H9.9945L2.80591 4.28577C2.57355 4.53083 2.32169 4.87302 2.16592 5.11672L9.04055 11.995L2.16016 18.8755C2.29637 19.1178 2.59314 19.4765 2.8015 19.7099L9.99464 12.5168H23.9909C23.9984 12.3437 24.0007 12.1699 24.0007 11.995C24.0007 11.7608 23.9942 11.588 23.9892 11.4733Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M2.91515 14.5574V13.5523C3.91818 13.5523 4.73413 12.7362 4.73413 11.7333C4.73413 11.0237 4.15677 10.4464 3.44718 10.4464C2.96376 10.4464 2.57043 10.8396 2.57043 11.3232C2.57043 11.6323 2.82191 11.8838 3.1311 11.8838C3.30585 11.8838 3.44802 11.7416 3.44802 11.5668H4.45311C4.45311 12.2959 3.86005 12.8889 3.13115 12.8889C2.26776 12.889 1.56543 12.1865 1.56543 11.3232C1.56543 10.2856 2.40965 9.44141 3.44722 9.44141C4.71106 9.44141 5.73931 10.4697 5.73931 11.7335C5.73927 13.2905 4.47238 14.5574 2.91515 14.5574Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3776" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$7(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("path", {
      d: "M62 32C62 15.4 48.6 2 32 2v60c16.6 0 30-13.4 30-30",
      fill: "#f9f9f9"
    }),
    createElementVNode("path", {
      d: "M2 32c0 16.6 13.4 30 30 30V2C15.4 2 2 15.4 2 32z",
      fill: "#ffe62e"
    }),
    createElementVNode("path", {
      d: "M49 21.3c0 2.9 0 3.8-3 3.8s-3-.9-3-3.8s1.3-5.3 3-5.3s3 2.4 3 5.3",
      fill: "#ffffff"
    }),
    createElementVNode("g", { fill: "#dbb471" }, [
      createElementVNode("path", { d: "M47.5 17.8L46 16.6l-1.5 1.2l-1.5-1.2l.5 2.4h5l.5-2.4z" }),
      createElementVNode("path", { d: "M47.5 20.6L46 19.2l-1.5 1.4l-1.5-1.4V22h6v-2.8z" }),
      createElementVNode("path", { d: "M47.5 23.5L46 22l-1.5 1.5L43 22v3h6v-3z" }),
      createElementVNode("ellipse", {
        cx: "46",
        cy: "15.1",
        rx: ".5",
        ry: "1.5"
      })
    ]),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("ellipse", {
        cx: "46",
        cy: "25",
        rx: "3",
        ry: ".7"
      }),
      createElementVNode("path", { d: "M41.9 32.6c-1.4 0-2.5-2.1-2.6-2.8c-.2-1 .3-2 .8-3.1c.3-.5.7-1.6.7-1.9c-.1-.4-1.2-1.5-2.3-2.3l1.2-1.6c.8.6 2.7 2.3 3 3.4c.2 1-.3 2-.8 3.2c-.3.6-.7 1.5-.7 1.9c.1.3.4.8.7 1.1c.5-.5 1.3-2.9 1.7-5.3l2 .3c-.4 2.5-1.4 6.7-3.4 7c-.1.1-.2.1-.3.1" }),
      createElementVNode("path", { d: "M50.1 32.6h-.2c-2.1-.3-3-4.5-3.4-7l2-.3c.4 2.3 1.1 4.6 1.7 5.2c.3-.3.6-.8.7-1.1c.1-.3-.4-1.3-.7-1.9c-.5-1.1-1-2.2-.8-3.2c.3-1.2 2.2-2.8 3-3.4l1.2 1.6c-1.1.9-2.2 2-2.3 2.3c-.1.3.4 1.3.7 1.8c.5 1.1 1 2.2.8 3.1c-.3.8-1.3 2.9-2.7 2.9" })
    ]),
    createElementVNode("path", {
      d: "M41.5 36.6c-1.4-.9-3.2-.7-4.5.6c-1.4 1.6-1.4 4.1 0 5.6c1.4 1.6 3.8 1.6 5.2 0c1.2-1.3 1.4-3.3.6-4.8l9.6-10.2l1.3 1.4l1.3-1.4l-2.6-2.8l-10.9 11.6",
      fill: "#dbb471"
    }),
    createElementVNode("path", {
      d: "M40.3 39.4c.3-.3.3-.8 0-1.2s-.8-.3-1.2 0c-.3.3-.3.8 0 1.2c-.3-.3-.8-.3-1.2 0c-.3.3-.3.8 0 1.2c.3.3.8.3 1.2 0c-.3.3-.3.8 0 1.2c.3.3.8.3 1.2 0s.3-.8 0-1.2c.3.3.8.3 1.2 0c.3-.3.3-.8 0-1.2c-.4-.3-.9-.3-1.2 0",
      fill: "#ffffff"
    }),
    createElementVNode("path", {
      d: "M50.5 36.6c1.4-.9 3.2-.7 4.5.6c1.4 1.6 1.4 4.1 0 5.6c-1.4 1.6-3.8 1.6-5.2 0c-1.2-1.3-1.4-3.3-.6-4.8l-9.6-10.2l-1.3 1.4l-1.3-1.4l2.6-2.8l10.9 11.6",
      fill: "#d0d0d0"
    }),
    createElementVNode("path", {
      d: "M51.7 39.4c-.3-.3-.3-.8 0-1.2c.3-.3.8-.3 1.2 0c.3.3.3.8 0 1.2c.3-.3.8-.3 1.2 0c.3.3.3.8 0 1.2c-.3.3-.8.3-1.2 0c.3.3.3.8 0 1.2c-.3.3-.8.3-1.2 0s-.3-.8 0-1.2c-.3.3-.8.3-1.2 0c-.3-.3-.3-.8 0-1.2c.4-.3.9-.3 1.2 0",
      fill: "#ffffff"
    }),
    createElementVNode("g", { fill: "#ed4c5c" }, [
      createElementVNode("path", { d: "M50.4 39.8c-2.9.4-5.9.4-8.8 0c-.6-.1-.8.6-.2.7c3.1.5 6.2.5 9.3 0c.6-.2.3-.8-.3-.7" }),
      createElementVNode("path", { d: "M50.3 39.2c-1.8-1.3-3.4-2.9-4.7-4.7c-.3-.4-.8-.1-.5.2c1.4 1.9 3.1 3.6 5 5c.3.3.6-.2.2-.5" }),
      createElementVNode("path", { d: "M46.4 34.5c-1.3 1.8-2.9 3.4-4.7 4.7c-.4.3-.1.8.2.5c1.9-1.4 3.6-3.1 5-5c.3-.3-.2-.5-.5-.2" }),
      createElementVNode("path", { d: "M45.5 31h1v13h-1z" }),
      createElementVNode("path", { d: "M43.481 33.436l.708-.707l2.404 2.404l-.707.708z" }),
      createElementVNode("path", { d: "M45.411 35.062l2.404-2.404l.707.707l-2.404 2.404z" })
    ]),
    createElementVNode("g", { fill: "#ff717f" }, [
      createElementVNode("path", { d: "M45.5 42.7c-.6 0-1 .4-1 1v3h2v-3c0-.5-.4-1-1-1" }),
      createElementVNode("path", { d: "M46.5 41.8c-.6 0-1 .4-1 1v3h2v-3c0-.6-.4-1-1-1" })
    ]),
    createElementVNode("g", { fill: "#94989b" }, [
      createElementVNode("circle", {
        cx: "42.6",
        cy: "37.1",
        r: "1.2"
      }),
      createElementVNode("circle", {
        cx: "36.8",
        cy: "42.9",
        r: "1.2"
      }),
      createElementVNode("circle", {
        cx: "36.8",
        cy: "37.1",
        r: "1.2"
      }),
      createElementVNode("circle", {
        cx: "42.6",
        cy: "42.9",
        r: "1.2"
      })
    ]),
    createElementVNode("g", { fill: "#dbb471" }, [
      createElementVNode("circle", {
        cx: "55.2",
        cy: "37.1",
        r: "1.2"
      }),
      createElementVNode("circle", {
        cx: "49.4",
        cy: "42.9",
        r: "1.2"
      }),
      createElementVNode("circle", {
        cx: "49.4",
        cy: "37.1",
        r: "1.2"
      }),
      createElementVNode("circle", {
        cx: "55.2",
        cy: "42.9",
        r: "1.2"
      }),
      createElementVNode("path", { d: "M38.1 20.9h2v2.2h-2z" }),
      createElementVNode("path", { d: "M51.9 20.9h2v2.2h-2z" }),
      createElementVNode("path", { d: "M43.577 28.624l.607-2.218l.58.158l-.608 2.219z" }),
      createElementVNode("path", { d: "M43.386 27.408l.16-.579l1.542.425l-.159.578z" }),
      createElementVNode("path", { d: "M47.2 26.532l.578-.158l.608 2.218l-.58.158z" }),
      createElementVNode("path", { d: "M46.95 27.212l1.543-.424l.16.579l-1.543.424z" })
    ]),
    createElementVNode("g", { fill: "#ffffff" }, [
      createElementVNode("path", { d: "M52.5 28.1l-1.7 1.5l-1.1-3.1l1.7-.9z" }),
      createElementVNode("path", { d: "M39.5 28.1l1.7 1.5l1.1-3.1l-1.7-.9z" })
    ]),
    createElementVNode("g", { fill: "#dbb471" }, [
      createElementVNode("path", { d: "M41.5 26.5l-.6-.2l-.1.5l-.4-.1l-.2.6l.4.1l-.2 1.1l.5.2l.3-1.1l.5.1l.1-.6l-.4-.1z" }),
      createElementVNode("path", { d: "M51.8 27.3l-.2-.6l-.4.1l-.1-.5l-.6.2l.1.5l-.4.1l.1.6l.5-.1l.3 1.1l.5-.2l-.2-1.1z" })
    ])
  ]);
}
function render$6(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3777)" }, [
      createElementVNode("path", {
        d: "M22.8093 17.2166C23.5722 15.639 24 13.8692 24 11.9993C24 10.1294 23.5722 8.35951 22.8093 6.78189L12 5.7384L1.19072 6.78189C0.427828 8.35951 0 10.1294 0 11.9993C0 13.8692 0.427828 15.639 1.19072 17.2166L12 18.2601L22.8093 17.2166Z",
        fill: "#0052B4"
      }),
      createElementVNode("path", {
        d: "M11.9997 24.0004C16.7572 24.0004 20.868 21.2317 22.809 17.2178H1.19043C3.13143 21.2317 7.24218 24.0004 11.9997 24.0004Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.7824 14.3561L20.1486 14.8514L20.4236 15.607L19.7568 15.1574L19.1229 15.6525L19.3445 14.8793L18.6777 14.4295L19.4816 14.4015L19.7034 13.6283L19.9786 14.3841L20.7824 14.3561Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M19.1585 11.5444L18.7324 12.2266L19.2495 12.8426L18.469 12.6483L18.0427 13.3303L17.9865 12.5279L17.2061 12.3333L17.9519 12.0319L17.8959 11.2295L18.4129 11.8458L19.1585 11.5444Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M16.6724 9.45837L16.5052 10.2452L17.2018 10.6474L16.4019 10.7317L16.2346 11.5183L15.9074 10.7835L15.1074 10.8675L15.7053 10.3293L15.3781 9.59455L16.0747 9.99664L16.6724 9.45837Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M13.6219 8.34802L13.7339 9.14457L14.526 9.28416L13.8031 9.63695L13.9151 10.4334L13.3563 9.85482L12.6332 10.2074L13.0109 9.49712L12.4521 8.91859L13.2443 9.05823L13.6219 8.34802Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M10.3767 8.34802L10.7544 9.05822L11.5464 8.91849L10.9878 9.49726L11.3653 10.2075L10.6424 9.85482L10.0835 10.4333L10.1956 9.63694L9.47266 9.28435L10.2648 9.14457L10.3767 8.34802Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M7.32614 9.45837L7.92399 9.99664L8.62041 9.59455L8.29336 10.3295L8.89106 10.8677L8.09114 10.7835L7.76386 11.5183L7.59684 10.7315L6.79688 10.6475L7.49344 10.2453L7.32614 9.45837Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M4.83973 11.5444L5.58565 11.8457L6.10249 11.2296L6.04657 12.0322L6.79225 12.3335L6.01183 12.528L5.95563 13.3303L5.52954 12.6483L4.74902 12.8428L5.26605 12.2266L4.83973 11.5444Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M3.2168 14.3561L4.0208 14.3841L4.29577 13.6284L4.51772 14.4017L5.32148 14.4297L4.65464 14.8796L4.87627 15.6527L4.24252 15.1575L3.57562 15.6072L3.85073 14.8514L3.2168 14.3561Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M22.809 6.78226C20.868 2.76831 16.7572 -0.000366211 11.9997 -0.000366211C7.24218 -0.000366211 3.13143 2.76831 1.19043 6.78226H22.809Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3777" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$5(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3778)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M12.0005 6.26123L13.2956 10.247H17.4864L14.0959 12.7103L15.391 16.696L12.0005 14.2327L8.61005 16.696L9.90511 12.7103L6.51465 10.247H10.7055L12.0005 6.26123Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3778" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$4(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1520_57548)" }, [
      createElementVNode("path", {
        d: "M0 0H900V800H0V0Z",
        fill: "#CE1126"
      }),
      createElementVNode("path", {
        d: "M-60 0H286V346H-60V0Z",
        fill: "white"
      }),
      createElementVNode("path", {
        d: "M-60 0H113V346H-60V0Z",
        fill: "#002654"
      }),
      createElementVNode("path", {
        d: "M-60 346H459V0",
        stroke: "white",
        "stroke-width": "6"
      }),
      createElementVNode("path", {
        d: "M528 506L432 410H624L528 506ZM496 538L400 442V634L496 538ZM528 570L432 666H624L528 570ZM560 538L656 442V634L560 538Z",
        fill: "white"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1520_57548" }, [
        createElementVNode("rect", {
          width: "800",
          height: "800",
          rx: "400",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3780)" }, [
      createElementVNode("path", {
        d: "M1.19072 6.78189C0.427875 8.35951 0 10.1294 0 11.9993C0 13.8692 0.427875 15.639 1.19072 17.2166L12 18.2601L22.8093 17.2166C23.5721 15.639 24 13.8692 24 11.9993C24 10.1294 23.5721 8.35951 22.8093 6.78189L12 5.7384L1.19072 6.78189Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M1.19141 17.2178C3.13231 21.2317 7.24278 24.0004 12.0003 24.0004C16.7577 24.0004 20.8682 21.2317 22.8091 17.2178H1.19141Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M1.19141 6.78226H22.8091C20.8682 2.76831 16.7578 -0.000366211 12.0003 -0.000366211C7.24273 -0.000366211 3.13231 2.76831 1.19141 6.78226Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M3.51471 3.51501C-1.17157 8.2013 -1.17157 15.7993 3.51471 20.4856C5.45126 18.5491 7.31375 16.6866 12 12.0003L3.51471 3.51501Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M15.1307 12C15.1307 10.2516 16.3594 8.79103 18.0002 8.43272C17.748 8.37764 17.4864 8.34778 17.2176 8.34778C15.2005 8.34778 13.5654 9.98287 13.5654 12C13.5654 14.017 15.2005 15.6521 17.2176 15.6521C17.4863 15.6521 17.748 15.6223 18.0002 15.5672C16.3594 15.2089 15.1307 13.7483 15.1307 12Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M18.1533 9.6521L18.6714 11.2465H20.3477L18.9915 12.2317L19.5096 13.826L18.1533 12.8407L16.7972 13.826L17.3153 12.2317L15.959 11.2465H17.6353L18.1533 9.6521Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3780" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3781)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M11.9997 23.9992C17.1593 23.9992 21.5578 20.7427 23.2533 16.1731H0.746094C2.44161 20.7427 6.84013 23.9992 11.9997 23.9992Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M11.9997 0.000610352C6.84013 0.000610352 2.44161 3.25711 0.746094 7.82672H23.2534C21.5578 3.25711 17.1593 0.000610352 11.9997 0.000610352Z",
        fill: "#D80027"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3781" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render$1(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3782)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#496E2D"
      }),
      createElementVNode("path", {
        d: "M16.6957 11.9993H12V23.9993C13.4027 23.9993 14.7488 23.7578 16 23.3156L16.6957 11.9993Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M20.0003 20.9427C22.4551 18.7455 24.0004 15.553 24.0004 11.9993H19.3047L20.0003 20.9427Z",
        fill: "#FF9811"
      }),
      createElementVNode("path", {
        d: "M16 11.9993V23.3155C17.4905 22.7886 18.8458 21.9759 20 20.9427V11.9993H16Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M22.174 7.82669H19.0436C19.0436 7.25041 18.5764 6.7832 18.0001 6.7832C17.4238 6.7832 16.9566 7.25041 16.9566 7.82669H13.8262C13.8262 8.40302 14.3282 8.87017 14.9044 8.87017H14.8697C14.8697 9.4465 15.3368 9.91366 15.9131 9.91366C15.9131 10.49 16.3803 10.9571 16.9566 10.9571H19.0436C19.6199 10.9571 20.0871 10.49 20.0871 9.91366C20.6634 9.91366 21.1306 9.4465 21.1306 8.87017H21.0958C21.6721 8.87013 22.174 8.40297 22.174 7.82669Z",
        fill: "#FF9811"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3782" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_1046_3783)" }, [
      createElementVNode("path", {
        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
        fill: "#F0F0F0"
      }),
      createElementVNode("path", {
        d: "M22.8522 6.87246C22.2426 5.58461 21.4105 4.42291 20.4055 3.43643L12.0008 2.60913L3.5961 3.43647C3.56929 3.46277 3.54313 3.48968 3.5166 3.51625L6.87285 6.8725L12.0008 7.02911L22.8522 6.87246Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M3.51562 20.4852C3.55978 20.5294 3.60384 20.5736 3.64866 20.6171L12 21.3922L20.3512 20.6171C21.3665 19.6327 22.2088 18.4709 22.827 17.181L7.30425 16.6965C5.96864 18.0322 4.42814 19.5726 3.51562 20.4852Z",
        fill: "#FFDA44"
      }),
      createElementVNode("path", {
        d: "M23.8807 10.3081L9.91309 9.91309L12.0001 12.0001C11.3819 12.6182 10.4591 13.541 9.91309 14.087L23.8734 13.7442C23.9564 13.1747 24.0001 12.5925 24.0001 12.0001C24.0001 11.4256 23.9588 10.861 23.8807 10.3081Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M12.0004 0.000610352C8.7272 0.000610352 5.76067 1.3117 3.5957 3.43664H20.4051C18.2401 1.3117 15.2736 0.000610352 12.0004 0.000610352Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M10.3071 10.3086H23.8797C23.7085 9.09551 23.3562 7.94079 22.8505 6.87256H6.87109L10.3071 10.3086Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.81934 17.1815H22.8266C23.3382 16.1141 23.6961 14.9592 23.8729 13.7455H10.2554C8.92473 15.0761 7.79701 16.2038 6.81934 17.1815Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M11.9996 24.0006C15.246 24.0006 18.1907 22.7109 20.3508 20.6167H3.64844C5.80863 22.7109 8.75331 24.0006 11.9996 24.0006Z",
        fill: "#6DA544"
      }),
      createElementVNode("path", {
        d: "M4.28504 2.80994C4.01827 3.03409 3.76088 3.26908 3.51465 3.51522L12 12.0005L3.51465 20.4858C3.76084 20.732 4.01827 20.967 4.28504 21.1911L13.4756 12.0005L4.28504 2.80994Z",
        fill: "black"
      }),
      createElementVNode("path", {
        d: "M4.82467 8.86914L5.60163 11.2605H8.11624L6.08195 12.7386L6.85895 15.13L4.82467 13.652L2.79034 15.13L3.56744 12.7386L1.5332 11.2605H4.04767L4.82467 8.86914Z",
        fill: "#D80027"
      }),
      createElementVNode("path", {
        d: "M6.96184 12.1947L4.93694 11.4773C4.93694 11.4773 4.78731 10.0738 4.77827 10.0262C4.70955 9.66418 4.39141 9.39038 4.00937 9.39038C3.57719 9.39038 3.22675 9.74077 3.22675 10.173C3.22675 10.2447 3.2372 10.3137 3.25525 10.3797L2.6875 10.9513C2.6875 10.9513 3.36184 10.9513 3.697 10.9513C3.697 11.9991 2.91512 11.9991 2.91512 13.0425L3.34886 14.086H5.95755L6.39236 13.0425H6.39217C6.43572 12.9424 6.46216 12.8392 6.47308 12.736C6.84789 12.5844 6.96184 12.1947 6.96184 12.1947Z",
        fill: "#FFDA44"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_1046_3783" }, [
        createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      ])
    ])
  ]);
}
const countryDetails = [
  {
    name: "Afghanistan (\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646)",
    code: "AF",
    phoneCode: "+93",
    placeholder: "070 123 4567",
    icon: render$3S
  },
  {
    name: "\xC5land Islands",
    code: "AX",
    phoneCode: "+358",
    placeholder: "041 2345678",
    icon: render$3R
  },
  {
    name: "Albania (Shqip\xEBri)",
    code: "AL",
    phoneCode: "+355",
    placeholder: "066 123 4567",
    icon: render$3Q
  },
  {
    name: "Algeria (\u0627\u0644\u062C\u0632\u0627\u0626\u0631)",
    code: "DZ",
    phoneCode: "+213",
    placeholder: "05 12 34 56 78",
    icon: render$3P
  },
  {
    name: "American Samoa",
    code: "AS",
    phoneCode: "+1",
    placeholder: "(684) 733-1234",
    icon: render$3O
  },
  {
    name: "Andorra",
    code: "AD",
    phoneCode: "+376",
    placeholder: "312 345",
    icon: render$3N
  },
  {
    name: "Angola",
    code: "AO",
    phoneCode: "+244",
    placeholder: "923 123 456",
    icon: render$3M
  },
  {
    name: "Anguilla",
    code: "AI",
    phoneCode: "+1",
    placeholder: "(264) 235-1234",
    icon: render$3L
  },
  {
    name: "Antigua and Barbuda",
    code: "AG",
    phoneCode: "+1",
    placeholder: "(268) 722-1234",
    icon: render$3K
  },
  {
    name: "Argentina",
    code: "AR",
    phoneCode: "+54",
    placeholder: "011 15-2345-6789",
    icon: render$3J
  },
  {
    name: "Armenia (\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576)",
    code: "AM",
    phoneCode: "+374",
    placeholder: "077 123456",
    icon: render$3I
  },
  {
    name: "Aruba",
    code: "AW",
    phoneCode: "+297",
    placeholder: "560-1234",
    icon: render$3H
  },
  {
    name: "Ascension Island",
    code: "AC",
    phoneCode: "+247",
    placeholder: "3 2250",
    icon: render$3G
  },
  {
    name: "Australia",
    code: "AU",
    phoneCode: "+61",
    placeholder: "0412 345 678",
    icon: render$3F
  },
  {
    name: "Austria (\xD6sterreich)",
    code: "AT",
    phoneCode: "+43",
    placeholder: "0664 123456",
    icon: render$3E
  },
  {
    name: "Azerbaijan (Az\u0259rbaycan)",
    code: "AZ",
    phoneCode: "+994",
    placeholder: "040 123 45 67",
    icon: render$3D
  },
  {
    name: "Bahamas",
    code: "BS",
    phoneCode: "+1",
    placeholder: "(242) 359-1234",
    icon: render$3C
  },
  {
    name: "Bahrain (\u0627\u0644\u0628\u062D\u0631\u064A\u0646)",
    code: "BH",
    phoneCode: "+973",
    placeholder: "3600 1234",
    icon: render$3B
  },
  {
    name: "Bangladesh (\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)",
    code: "BD",
    phoneCode: "+880",
    placeholder: "01812-345678",
    icon: render$3A
  },
  {
    name: "Barbados",
    code: "BB",
    phoneCode: "+1",
    placeholder: "(246) 250-1234",
    icon: render$3z
  },
  {
    name: "Belarus (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)",
    code: "BY",
    phoneCode: "+375",
    placeholder: "8 029 491-19-11",
    icon: render$3y
  },
  {
    name: "Belgium (Belgi\xEB)",
    code: "BE",
    phoneCode: "+32",
    placeholder: "0470 12 34 56",
    icon: render$3x
  },
  {
    name: "Belize",
    code: "BZ",
    phoneCode: "+501",
    placeholder: "622-1234",
    icon: render$3w
  },
  {
    name: "Benin (B\xE9nin)",
    code: "BJ",
    phoneCode: "+229",
    placeholder: "90 01 12 34",
    icon: render$3v
  },
  {
    name: "Bermuda",
    code: "BM",
    phoneCode: "+1",
    placeholder: "(441) 370-1234",
    icon: render$3u
  },
  {
    name: "Bhutan (\u0F60\u0F56\u0FB2\u0F74\u0F42)",
    code: "BT",
    phoneCode: "+975",
    placeholder: "17 12 34 56",
    icon: render$3t
  },
  {
    name: "Bolivia",
    code: "BO",
    phoneCode: "+591",
    placeholder: "71234567",
    icon: render$3s
  },
  {
    name: "Bosnia and Herzegovina (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)",
    code: "BA",
    phoneCode: "+387",
    placeholder: "061 123 456",
    icon: render$3q
  },
  {
    name: "Botswana",
    code: "BW",
    phoneCode: "+267",
    placeholder: "71 123 456",
    icon: render$3p
  },
  {
    name: "Brazil (Brasil)",
    code: "BR",
    phoneCode: "+55",
    placeholder: "(11) 91234-5678",
    icon: render$3o
  },
  {
    name: "British Indian Ocean Territory",
    code: "IO",
    phoneCode: "+246",
    placeholder: "370 5123",
    icon: render$3n
  },
  {
    name: "British Virgin Islands",
    code: "VG",
    phoneCode: "+1",
    placeholder: "(284) 300-1234",
    icon: render$3m
  },
  {
    name: "Brunei",
    code: "BN",
    phoneCode: "+673",
    placeholder: "712 3456",
    icon: render$3l
  },
  {
    name: "Bulgaria (\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F)",
    code: "BG",
    phoneCode: "+359",
    placeholder: "0881 234 567",
    icon: render$3k
  },
  {
    name: "Burkina Faso",
    code: "BF",
    phoneCode: "+226",
    placeholder: "70 12 34 56",
    icon: render$3j
  },
  {
    name: "Burundi (Uburundi)",
    code: "BI",
    phoneCode: "+257",
    placeholder: "79 56 12 34",
    icon: render$3h
  },
  {
    name: "Cambodia (\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6)",
    code: "KH",
    phoneCode: "+855",
    placeholder: "091 234 567",
    icon: render$3g
  },
  {
    name: "Cameroon (Cameroun)",
    code: "CM",
    phoneCode: "+237",
    placeholder: "6 71 23 45 67",
    icon: render$3f
  },
  {
    name: "Canada",
    code: "CA",
    phoneCode: "+1",
    placeholder: "(204) 123-4567",
    icon: render$3e
  },
  {
    name: "Cape Verde (Kabu Verdi)",
    code: "CV",
    phoneCode: "+238",
    placeholder: "991 12 34",
    icon: render$3d
  },
  {
    name: "Bonaire (Caribbean Netherlands)",
    code: "BQ",
    phoneCode: "+599",
    placeholder: "318 1234",
    icon: render$3r
  },
  {
    name: "Cayman Islands",
    code: "KY",
    phoneCode: "+1",
    placeholder: "(345) 323-1234",
    icon: render$3c
  },
  {
    name: "Central African Republic (R\xE9publique centrafricaine)",
    code: "CF",
    phoneCode: "+236",
    placeholder: "70 01 23 45",
    icon: render$3b
  },
  {
    name: "Chad (Tchad)",
    code: "TD",
    phoneCode: "+235",
    placeholder: "63 01 23 45",
    icon: render$3a
  },
  {
    name: "Chile",
    code: "CL",
    phoneCode: "+56",
    placeholder: "9 9123 4567",
    icon: render$39
  },
  {
    name: "China (\u4E2D\u56FD)",
    code: "CN",
    phoneCode: "+86",
    placeholder: "131 2345 6789",
    icon: render$38
  },
  {
    name: "Christmas Island",
    code: "CX",
    phoneCode: "+61",
    placeholder: "0412 345 678",
    icon: render$37
  },
  {
    name: "Cocos (Keeling) Islands",
    code: "CC",
    phoneCode: "+61",
    placeholder: "0412 345 678",
    icon: render$36
  },
  {
    name: "Colombia",
    code: "CO",
    phoneCode: "+57",
    placeholder: "321 1234567",
    icon: render$35
  },
  {
    name: "Comoros (\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631)",
    code: "KM",
    phoneCode: "+269",
    placeholder: "321 12 34",
    icon: render$34
  },
  {
    name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    code: "CD",
    phoneCode: "+243",
    placeholder: "081 234 5678",
    icon: render$32
  },
  {
    name: "Congo (Republic) (Congo-Brazzaville)",
    code: "CG",
    phoneCode: "+242",
    placeholder: "06 123 4567",
    icon: render$33
  },
  {
    name: "Cook Islands",
    code: "CK",
    phoneCode: "+682",
    placeholder: "21 234",
    icon: render$31
  },
  {
    name: "Costa Rica",
    code: "CR",
    phoneCode: "+506",
    placeholder: "8312 3456",
    icon: render$30
  },
  {
    name: "C\xF4te d\u2019Ivoire",
    code: "CI",
    phoneCode: "+225",
    placeholder: "01 23 45 67",
    icon: render$2$
  },
  {
    name: "Croatia (Hrvatska)",
    code: "HR",
    phoneCode: "+385",
    placeholder: "091 234 5678",
    icon: render$2_
  },
  {
    name: "Cuba",
    code: "CU",
    phoneCode: "+53",
    placeholder: "05 1234567",
    icon: render$2Z
  },
  {
    name: "Cura\xE7ao",
    code: "CW",
    phoneCode: "+599",
    placeholder: "9 512 3456",
    icon: render$2Y
  },
  {
    name: "Cyprus (\u039A\u03CD\u03C0\u03C1\u03BF\u03C2)",
    code: "CY",
    phoneCode: "+357",
    placeholder: "96 123456",
    icon: render$2X
  },
  {
    name: "Czech Republic (\u010Cesk\xE1 republika)",
    code: "CZ",
    phoneCode: "+420",
    placeholder: "601 123 456",
    icon: render$2W
  },
  {
    name: "Denmark (Danmark)",
    code: "DK",
    phoneCode: "+45",
    placeholder: "20 12 34 56",
    icon: render$2V
  },
  {
    name: "Djibouti",
    code: "DJ",
    phoneCode: "+253",
    placeholder: "77 83 10 20",
    icon: render$2U
  },
  {
    name: "Dominica",
    code: "DM",
    phoneCode: "+1",
    placeholder: "(767) 225-1234",
    icon: render$2T
  },
  {
    name: "Dominican Republic (Rep\xFAblica Dominicana)",
    code: "DO",
    phoneCode: "+1",
    placeholder: "(809) 234-5678",
    icon: render$2S
  },
  {
    name: "Ecuador",
    code: "EC",
    phoneCode: "+593",
    placeholder: "099 123 4567",
    icon: render$2R
  },
  {
    name: "Egypt (\u0645\u0635\u0631)",
    code: "EG",
    phoneCode: "+20",
    placeholder: "0100 123 4567",
    icon: render$2Q
  },
  {
    name: "El Salvador",
    code: "SV",
    phoneCode: "+503",
    placeholder: "7012 3456",
    icon: render$2P
  },
  {
    name: "Equatorial Guinea (Guinea Ecuatorial)",
    code: "GQ",
    phoneCode: "+240",
    placeholder: "222 123 456",
    icon: render$2O
  },
  {
    name: "Eritrea",
    code: "ER",
    phoneCode: "+291",
    placeholder: "07 123 456",
    icon: render$2N
  },
  {
    name: "Estonia (Eesti)",
    code: "EE",
    phoneCode: "+372",
    placeholder: "5123 4567",
    icon: render$2M
  },
  {
    name: "Eswatini",
    code: "SZ",
    phoneCode: "+268",
    placeholder: "7612 3456",
    icon: render$2L
  },
  {
    name: "Ethiopia",
    code: "ET",
    phoneCode: "+251",
    placeholder: "091 123 4567",
    icon: render$2K
  },
  {
    name: "Falkland Islands (Islas Malvinas)",
    code: "FK",
    phoneCode: "+500",
    placeholder: "51234",
    icon: render$2J
  },
  {
    name: "Faroe Islands (F\xF8royar)",
    code: "FO",
    phoneCode: "+298",
    placeholder: "211234",
    icon: render$2I
  },
  {
    name: "Fiji",
    code: "FJ",
    phoneCode: "+679",
    placeholder: "701 2345",
    icon: render$2H
  },
  {
    name: "Finland (Suomi)",
    code: "FI",
    phoneCode: "+358",
    placeholder: "041 2345678",
    icon: render$2G
  },
  {
    name: "France",
    code: "FR",
    phoneCode: "+33",
    placeholder: "06 12 34 56 78",
    icon: render$2F
  },
  {
    name: "French Guiana (Guyane fran\xE7aise)",
    code: "GF",
    phoneCode: "+594",
    placeholder: "0694 20 12 34",
    icon: render$2E
  },
  {
    name: "French Polynesia (Polyn\xE9sie fran\xE7aise)",
    code: "PF",
    phoneCode: "+689",
    placeholder: "87 12 34 56",
    icon: render$2D
  },
  {
    name: "Gabon",
    code: "GA",
    phoneCode: "+241",
    placeholder: "06 03 12 34",
    icon: render$2C
  },
  {
    name: "Gambia",
    code: "GM",
    phoneCode: "+220",
    placeholder: "301 2345",
    icon: render$2B
  },
  {
    name: "Georgia (\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD)",
    code: "GE",
    phoneCode: "+995",
    placeholder: "555 12 34 56",
    icon: render$2A
  },
  {
    name: "Germany (Deutschland)",
    code: "DE",
    phoneCode: "+49",
    placeholder: "01512 3456789",
    icon: render$2z
  },
  {
    name: "Ghana (Gaana)",
    code: "GH",
    phoneCode: "+233",
    placeholder: "023 123 4567",
    icon: render$2y
  },
  {
    name: "Gibraltar",
    code: "GI",
    phoneCode: "+350",
    placeholder: "57123456",
    icon: render$2x
  },
  {
    name: "Greece (\u0395\u03BB\u03BB\u03AC\u03B4\u03B1)",
    code: "GR",
    phoneCode: "+30",
    placeholder: "691 234 5678",
    icon: render$2w
  },
  {
    name: "Greenland (Kalaallit Nunaat)",
    code: "GL",
    phoneCode: "+299",
    placeholder: "22 12 34",
    icon: render$2v
  },
  {
    name: "Grenada",
    code: "GD",
    phoneCode: "+1",
    placeholder: "(473) 403-1234",
    icon: render$2u
  },
  {
    name: "Guadeloupe",
    code: "GP",
    phoneCode: "+590",
    placeholder: "0690 30 12 34",
    icon: render$2t
  },
  {
    name: "Guam",
    code: "GU",
    phoneCode: "+1",
    placeholder: "(671) 300-1234",
    icon: render$2s
  },
  {
    name: "Guatemala",
    code: "GT",
    phoneCode: "+502",
    placeholder: "5123 4567",
    icon: render$2r
  },
  {
    name: "Guernsey",
    code: "GG",
    phoneCode: "+44",
    placeholder: "07781 123456",
    icon: render$2q
  },
  {
    name: "Guinea (Guin\xE9e)",
    code: "GN",
    phoneCode: "+224",
    placeholder: "601 12 34 56",
    icon: render$2o
  },
  {
    name: "Guinea-Bissau (Guin\xE9 Bissau)",
    code: "GW",
    phoneCode: "+245",
    placeholder: "955 123 456",
    icon: render$2p
  },
  {
    name: "Guyana",
    code: "GY",
    phoneCode: "+592",
    placeholder: "609 1234",
    icon: render$2n
  },
  {
    name: "Haiti",
    code: "HT",
    phoneCode: "+509",
    placeholder: "34 10 1234",
    icon: render$2m
  },
  {
    name: "Honduras",
    code: "HN",
    phoneCode: "+504",
    placeholder: "9123-4567",
    icon: render$2l
  },
  {
    name: "Hong Kong (\u9999\u6E2F)",
    code: "HK",
    phoneCode: "+852",
    placeholder: "5123 4567",
    icon: render$2k
  },
  {
    name: "Hungary (Magyarorsz\xE1g)",
    code: "HU",
    phoneCode: "+36",
    placeholder: "20 123 4567",
    icon: render$2j
  },
  {
    name: "Iceland (\xCDsland)",
    code: "IS",
    phoneCode: "+354",
    placeholder: "611 1234",
    icon: render$2i
  },
  {
    name: "India (\u092D\u093E\u0930\u0924)",
    code: "IN",
    phoneCode: "+91",
    placeholder: "90123 45678",
    icon: render$2h
  },
  {
    name: "Indonesia",
    code: "ID",
    phoneCode: "+62",
    placeholder: "0812-345-678",
    icon: render$2g
  },
  {
    name: "Iran (\u0627\u06CC\u0631\u0627\u0646)",
    code: "IR",
    phoneCode: "+98",
    placeholder: "0912 345 6789",
    icon: render$2f
  },
  {
    name: "Iraq (\u0627\u0644\u0639\u0631\u0627\u0642)",
    code: "IQ",
    phoneCode: "+964",
    placeholder: "0791 234 5678",
    icon: render$2e
  },
  {
    name: "Ireland",
    code: "IE",
    phoneCode: "+353",
    placeholder: "085 123 4567",
    icon: render$2d
  },
  {
    name: "Isle of Man",
    code: "IM",
    phoneCode: "+44",
    placeholder: "07924 123456",
    icon: render$2c
  },
  {
    name: "Israel (\u05D9\u05E9\u05E8\u05D0\u05DC)",
    code: "IL",
    phoneCode: "+972",
    placeholder: "050-123-4567",
    icon: render$2b
  },
  {
    name: "Italy (Italia)",
    code: "IT",
    phoneCode: "+39",
    placeholder: "312 345 6789",
    icon: render$2a
  },
  {
    name: "Jamaica",
    code: "JM",
    phoneCode: "+1",
    placeholder: "(876) 210-1234",
    icon: render$29
  },
  {
    name: "Japan (\u65E5\u672C)",
    code: "JP",
    phoneCode: "+81",
    placeholder: "090-1234-5678",
    icon: render$28
  },
  {
    name: "Jersey",
    code: "JE",
    phoneCode: "+44",
    placeholder: "07797 123456",
    icon: render$27
  },
  {
    name: "Jordan (\u0627\u0644\u0623\u0631\u062F\u0646)",
    code: "JO",
    phoneCode: "+962",
    placeholder: "07 9012 3456",
    icon: render$26
  },
  {
    name: "Kazakhstan (\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D)",
    code: "KZ",
    phoneCode: "+7",
    placeholder: "8 (771) 000 9998",
    icon: render$25
  },
  {
    name: "Kenya",
    code: "KE",
    phoneCode: "+254",
    placeholder: "0712 123456",
    icon: render$24
  },
  {
    name: "Kiribati",
    code: "KI",
    phoneCode: "+686",
    placeholder: "72012345",
    icon: render$23
  },
  {
    name: "Kosovo",
    code: "XK",
    phoneCode: "+383",
    placeholder: "044 123 456",
    icon: render$22
  },
  {
    name: "Kuwait (\u0627\u0644\u0643\u0648\u064A\u062A)",
    code: "KW",
    phoneCode: "+965",
    placeholder: "50012345",
    icon: render$21
  },
  {
    name: "Kyrgyzstan (\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D)",
    code: "KG",
    phoneCode: "+996",
    placeholder: "0700 123 456",
    icon: render$20
  },
  {
    name: "Laos (\u0EA5\u0EB2\u0EA7)",
    code: "LA",
    phoneCode: "+856",
    placeholder: "020 23 123 456",
    icon: render$1$
  },
  {
    name: "Latvia (Latvija)",
    code: "LV",
    phoneCode: "+371",
    placeholder: "21 234 567",
    icon: render$1_
  },
  {
    name: "Lebanon (\u0644\u0628\u0646\u0627\u0646)",
    code: "LB",
    phoneCode: "+961",
    placeholder: "03 123 456",
    icon: render$1Z
  },
  {
    name: "Lesotho",
    code: "LS",
    phoneCode: "+266",
    placeholder: "5012 3456",
    icon: render$1Y
  },
  {
    name: "Liberia",
    code: "LR",
    phoneCode: "+231",
    placeholder: "077 012 3456",
    icon: render$1X
  },
  {
    name: "Libya (\u0644\u064A\u0628\u064A\u0627)",
    code: "LY",
    phoneCode: "+218",
    placeholder: "091-2345678",
    icon: render$1W
  },
  {
    name: "Liechtenstein",
    code: "LI",
    phoneCode: "+423",
    placeholder: "660 234 567",
    icon: render$1V
  },
  {
    name: "Lithuania (Lietuva)",
    code: "LT",
    phoneCode: "+370",
    placeholder: "612 34567",
    icon: render$1U
  },
  {
    name: "Luxembourg",
    code: "LU",
    phoneCode: "+352",
    placeholder: "621 123 456",
    icon: render$1T
  },
  {
    name: "Macau",
    code: "MO",
    phoneCode: "+853",
    placeholder: "6612 3456",
    icon: render$1S
  },
  {
    name: "Madagascar (Madagasikara)",
    code: "MG",
    phoneCode: "+261",
    placeholder: "032 12 345 67",
    icon: render$1Q
  },
  {
    name: "Malawi",
    code: "MW",
    phoneCode: "+265",
    placeholder: "0991 23 45 67",
    icon: render$1P
  },
  {
    name: "Malaysia",
    code: "MY",
    phoneCode: "+60",
    placeholder: "012-345 6789",
    icon: render$1O
  },
  {
    name: "Maldives",
    code: "MV",
    phoneCode: "+960",
    placeholder: "771-2345",
    icon: render$1N
  },
  {
    name: "Mali",
    code: "ML",
    phoneCode: "+223",
    placeholder: "60 12 34 56",
    icon: render$1M
  },
  {
    name: "Malta",
    code: "MT",
    phoneCode: "+356",
    placeholder: "9696 1234",
    icon: render$1L
  },
  {
    name: "Marshall Islands",
    code: "MH",
    phoneCode: "+692",
    placeholder: "235-1234",
    icon: render$1K
  },
  {
    name: "Martinique",
    code: "MQ",
    phoneCode: "+596",
    placeholder: "0696 20 12 34",
    icon: render$1J
  },
  {
    name: "Mauritania (\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627)",
    code: "MR",
    phoneCode: "+222",
    placeholder: "22 12 34 56",
    icon: render$1I
  },
  {
    name: "Mauritius (Moris)",
    code: "MU",
    phoneCode: "+230",
    placeholder: "5251 2345",
    icon: render$1H
  },
  {
    name: "Mayotte",
    code: "YT",
    phoneCode: "+262",
    placeholder: "0639 01 23 45",
    icon: render$1G
  },
  {
    name: "Mexico (M\xE9xico)",
    code: "MX",
    phoneCode: "+52",
    placeholder: "044 55 1234 5678",
    icon: render$1F
  },
  {
    name: "Micronesia",
    code: "FM",
    phoneCode: "+691",
    placeholder: "350 1234",
    icon: render$1E
  },
  {
    name: "Moldova (Republica Moldova)",
    code: "MD",
    phoneCode: "+373",
    placeholder: "0621 12 345",
    icon: render$1D
  },
  {
    name: "Monaco",
    code: "MC",
    phoneCode: "+377",
    placeholder: "06 12 34 56 78",
    icon: render$1C
  },
  {
    name: "Mongolia (\u041C\u043E\u043D\u0433\u043E\u043B)",
    code: "MN",
    phoneCode: "+976",
    placeholder: "8812 3456",
    icon: render$1B
  },
  {
    name: "Montenegro (Crna Gora)",
    code: "ME",
    phoneCode: "+382",
    placeholder: "067 123 456",
    icon: render$1A
  },
  {
    name: "Montserrat",
    code: "MS",
    phoneCode: "+1",
    placeholder: "(664) 492-3456",
    icon: render$1z
  },
  {
    name: "Morocco (\u0627\u0644\u0645\u063A\u0631\u0628)",
    code: "MA",
    phoneCode: "+212",
    placeholder: "0650-123456",
    icon: render$1y
  },
  {
    name: "Mozambique (Mo\xE7ambique)",
    code: "MZ",
    phoneCode: "+258",
    placeholder: "82 123 4567",
    icon: render$1x
  },
  {
    name: "Myanmar (Burma) (\u1019\u103C\u1014\u103A\u1019\u102C)",
    code: "MM",
    phoneCode: "+95",
    placeholder: "09 123 4567",
    icon: render$3i
  },
  {
    name: "Namibia (Namibi\xEB)",
    code: "NA",
    phoneCode: "+264",
    placeholder: "081 123 4567",
    icon: render$1w
  },
  {
    name: "Nauru",
    code: "NR",
    phoneCode: "+674",
    placeholder: "555 1234",
    icon: render$1v
  },
  {
    name: "Nepal (\u0928\u0947\u092A\u093E\u0932)",
    code: "NP",
    phoneCode: "+977",
    placeholder: "984-1234567",
    icon: render$1u
  },
  {
    name: "Netherlands (Nederland)",
    code: "NL",
    phoneCode: "+31",
    placeholder: "06 12345678",
    icon: render$1t
  },
  {
    name: "New Caledonia (Nouvelle-Cal\xE9donie)",
    code: "NC",
    phoneCode: "+687",
    placeholder: "75.12.34",
    icon: render$1s
  },
  {
    name: "New Zealand",
    code: "NZ",
    phoneCode: "+64",
    placeholder: "021 123 456",
    icon: render$1r
  },
  {
    name: "Nicaragua",
    code: "NI",
    phoneCode: "+505",
    placeholder: "8123 4567",
    icon: render$1q
  },
  {
    name: "Niger (Nijar)",
    code: "NE",
    phoneCode: "+227",
    placeholder: "93 12 34 56",
    icon: render$1p
  },
  {
    name: "Nigeria",
    code: "NG",
    phoneCode: "+234",
    placeholder: "0802 123 4567",
    icon: render$1o
  },
  {
    name: "Niue",
    code: "NU",
    phoneCode: "+683",
    placeholder: "1234",
    icon: render$1n
  },
  {
    name: "Norfolk Island",
    code: "NF",
    phoneCode: "+672",
    placeholder: "3 81234",
    icon: render$1m
  },
  {
    name: "North Korea (\uC870\uC120 \uBBFC\uC8FC\uC8FC\uC758 \uC778\uBBFC \uACF5\uD654\uAD6D)",
    code: "KP",
    phoneCode: "+850",
    placeholder: "0192 123 4567",
    icon: render$1l
  },
  {
    name: "North Macedonia (\u0421\u0435\u0432\u0435\u0440\u043D\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430)",
    code: "MK",
    phoneCode: "+389",
    placeholder: "072 123 456",
    icon: render$1R
  },
  {
    name: "Northern Mariana Islands",
    code: "MP",
    phoneCode: "+1",
    placeholder: "(670) 234-5678",
    icon: render$1k
  },
  {
    name: "Norway (Norge)",
    code: "NO",
    phoneCode: "+47",
    placeholder: "406 12 345",
    icon: render$1j
  },
  {
    name: "Oman (\u0639\u064F\u0645\u0627\u0646)",
    code: "OM",
    phoneCode: "+968",
    placeholder: "9212 3456",
    icon: render$1i
  },
  {
    name: "Pakistan (\u067E\u0627\u06A9\u0633\u062A\u0627\u0646)",
    code: "PK",
    phoneCode: "+92",
    placeholder: "0301 2345678",
    icon: render$1h
  },
  {
    name: "Palau",
    code: "PW",
    phoneCode: "+680",
    placeholder: "620 1234",
    icon: render$1g
  },
  {
    name: "Palestine (\u0641\u0644\u0633\u0637\u064A\u0646)",
    code: "PS",
    phoneCode: "+970",
    placeholder: "0599 123 456",
    icon: render$1f
  },
  {
    name: "Panama (Panam\xE1)",
    code: "PA",
    phoneCode: "+507",
    placeholder: "6123-4567",
    icon: render$1e
  },
  {
    name: "Papua New Guinea",
    code: "PG",
    phoneCode: "+675",
    placeholder: "7012 3456",
    icon: render$1d
  },
  {
    name: "Paraguay",
    code: "PY",
    phoneCode: "+595",
    placeholder: "0961 456789",
    icon: render$1c
  },
  {
    name: "Peru (Per\xFA)",
    code: "PE",
    phoneCode: "+51",
    placeholder: "912 345 678",
    icon: render$1b
  },
  {
    name: "Philippines",
    code: "PH",
    phoneCode: "+63",
    placeholder: "0912 345 6789",
    icon: render$1a
  },
  {
    name: "Pitcairn",
    code: "PN",
    phoneCode: "+870",
    placeholder: "5123",
    icon: render$19
  },
  {
    name: "Poland (Polska)",
    code: "PL",
    phoneCode: "+48",
    placeholder: "512 345 678",
    icon: render$18
  },
  {
    name: "Portugal",
    code: "PT",
    phoneCode: "+351",
    placeholder: "912 345 678",
    icon: render$17
  },
  {
    name: "Puerto Rico",
    code: "PR",
    phoneCode: "+1",
    placeholder: "(787) 234-5678",
    icon: render$16
  },
  {
    name: "Qatar (\u0642\u0637\u0631)",
    code: "QA",
    phoneCode: "+974",
    placeholder: "3312 3456",
    icon: render$15
  },
  {
    name: "R\xE9union (La R\xE9union)",
    code: "RE",
    phoneCode: "+262",
    placeholder: "0692 12 34 56",
    icon: render$14
  },
  {
    name: "Romania (Rom\xE2nia)",
    code: "RO",
    phoneCode: "+40",
    placeholder: "0712 345 678",
    icon: render$13
  },
  {
    name: "Russia (\u0420\u043E\u0441\u0441\u0438\u044F)",
    code: "RU",
    phoneCode: "+7",
    placeholder: "8 (912) 345-67-89",
    icon: render$12
  },
  {
    name: "Rwanda",
    code: "RW",
    phoneCode: "+250",
    placeholder: "0720 123 456",
    icon: render$11
  },
  {
    name: "Saint Barth\xE9lemy",
    code: "BL",
    phoneCode: "+590",
    placeholder: "0690 30 12 34",
    icon: render$10
  },
  {
    name: "Saint Helena",
    code: "SH",
    phoneCode: "+290",
    placeholder: "51234",
    icon: render$$
  },
  {
    name: "Saint Kitts and Nevis",
    code: "KN",
    phoneCode: "+1",
    placeholder: "(869) 765-1234",
    icon: render$_
  },
  {
    name: "Saint Lucia",
    code: "LC",
    phoneCode: "+1",
    placeholder: "(758) 284-5678",
    icon: render$Z
  },
  {
    name: "Saint Martin (partie fran\xE7aise)",
    code: "MF",
    phoneCode: "+590",
    placeholder: "0690 30 12 34",
    icon: render$Y
  },
  {
    name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    code: "PM",
    phoneCode: "+508",
    placeholder: "055 12 34",
    icon: render$X
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
    phoneCode: "+1",
    placeholder: "(784) 430-1234",
    icon: render$W
  },
  {
    name: "Samoa",
    code: "WS",
    phoneCode: "+685",
    placeholder: "601234",
    icon: render$V
  },
  {
    name: "San Marino",
    code: "SM",
    phoneCode: "+378",
    placeholder: "66 66 12 34",
    icon: render$U
  },
  {
    name: "S\xE3o Tom\xE9 and Pr\xEDncipe (S\xE3o Tom\xE9 e Pr\xEDncipe)",
    code: "ST",
    phoneCode: "+239",
    placeholder: "981 2345",
    icon: render$T
  },
  {
    name: "Saudi Arabia (\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629)",
    code: "SA",
    phoneCode: "+966",
    placeholder: "055 123 4567",
    icon: render$S
  },
  {
    name: "Senegal (S\xE9n\xE9gal)",
    code: "SN",
    phoneCode: "+221",
    placeholder: "70 123 45 67",
    icon: render$R
  },
  {
    name: "Serbia (\u0421\u0440\u0431\u0438\u0458\u0430)",
    code: "RS",
    phoneCode: "+381",
    placeholder: "060 1234567",
    icon: render$Q
  },
  {
    name: "Seychelles",
    code: "SC",
    phoneCode: "+248",
    placeholder: "2 510 123",
    icon: render$P
  },
  {
    name: "Sierra Leone",
    code: "SL",
    phoneCode: "+232",
    placeholder: "025 123456",
    icon: render$O
  },
  {
    name: "Singapore",
    code: "SG",
    phoneCode: "+65",
    placeholder: "8123 4567",
    icon: render$N
  },
  {
    name: "Sint Maarten",
    code: "SX",
    phoneCode: "+1",
    placeholder: "(721) 520-1234",
    icon: render$L
  },
  {
    name: "Sint Eustatius",
    code: "BQ",
    phoneCode: "+599",
    placeholder: "318 1234",
    icon: render$M
  },
  {
    name: "Slovakia (Slovensko)",
    code: "SK",
    phoneCode: "+421",
    placeholder: "0912 123 456",
    icon: render$K
  },
  {
    name: "Slovenia (Slovenija)",
    code: "SI",
    phoneCode: "+386",
    placeholder: "031 234 567",
    icon: render$J
  },
  {
    name: "Solomon Islands",
    code: "SB",
    phoneCode: "+677",
    placeholder: "74 21234",
    icon: render$I
  },
  {
    name: "Somalia (Soomaaliya)",
    code: "SO",
    phoneCode: "+252",
    placeholder: "7 1123456",
    icon: render$H
  },
  {
    name: "South Africa",
    code: "ZA",
    phoneCode: "+27",
    placeholder: "071 234 5678",
    icon: render$G
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    code: "GS",
    phoneCode: "+500",
    placeholder: "51234",
    icon: render$F
  },
  {
    name: "South Korea (\uB300\uD55C\uBBFC\uAD6D)",
    code: "KR",
    phoneCode: "+82",
    placeholder: "010-1234-5678",
    icon: render$E
  },
  {
    name: "South Sudan (\u062C\u0646\u0648\u0628 \u0627\u0644\u0633\u0648\u062F\u0627\u0646)",
    code: "SS",
    phoneCode: "+211",
    placeholder: "0977 123 456",
    icon: render$D
  },
  {
    name: "Spain (Espa\xF1a)",
    code: "ES",
    phoneCode: "+34",
    placeholder: "612 34 56 78",
    icon: render$C
  },
  {
    name: "Sri Lanka (\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0)",
    code: "LK",
    phoneCode: "+94",
    placeholder: "071 234 5678",
    icon: render$B
  },
  {
    name: "Sudan (\u0627\u0644\u0633\u0648\u062F\u0627\u0646)",
    code: "SD",
    phoneCode: "+249",
    placeholder: "091 123 4567",
    icon: render$A
  },
  {
    name: "Suriname",
    code: "SR",
    phoneCode: "+597",
    placeholder: "741-2345",
    icon: render$z
  },
  {
    name: "Svalbard and Jan Mayen",
    code: "SJ",
    phoneCode: "+47",
    placeholder: "412 34 567",
    icon: render$y
  },
  {
    name: "Sweden (Sverige)",
    code: "SE",
    phoneCode: "+46",
    placeholder: "070-123 45 67",
    icon: render$x
  },
  {
    name: "Switzerland (Schweiz)",
    code: "CH",
    phoneCode: "+41",
    placeholder: "078 123 45 67",
    icon: render$w
  },
  {
    name: "Syria (\u0633\u0648\u0631\u064A\u0627)",
    code: "SY",
    phoneCode: "+963",
    placeholder: "0944 567 890",
    icon: render$v
  },
  {
    name: "Taiwan (\u53F0\u7063)",
    code: "TW",
    phoneCode: "+886",
    placeholder: "0912 345 678",
    icon: render$u
  },
  {
    name: "Tajikistan",
    code: "TJ",
    phoneCode: "+992",
    placeholder: "917 12 3456",
    icon: render$t
  },
  {
    name: "Tanzania",
    code: "TZ",
    phoneCode: "+255",
    placeholder: "0621 234 567",
    icon: render$s
  },
  {
    name: "Thailand (\u0E44\u0E17\u0E22)",
    code: "TH",
    phoneCode: "+66",
    placeholder: "081 234 5678",
    icon: render$r
  },
  {
    name: "Timor-Leste",
    code: "TL",
    phoneCode: "+670",
    placeholder: "7721 2345",
    icon: render$q
  },
  {
    name: "Togo",
    code: "TG",
    phoneCode: "+228",
    placeholder: "90 11 12 34",
    icon: render$p
  },
  {
    name: "Tokelau",
    code: "TK",
    phoneCode: "+690",
    placeholder: "7290",
    icon: render$o
  },
  {
    name: "Tonga",
    code: "TO",
    phoneCode: "+676",
    placeholder: "771 5123",
    icon: render$n
  },
  {
    name: "Trinidad and Tobago",
    code: "TT",
    phoneCode: "+1",
    placeholder: "(868) 291-1234",
    icon: render$m
  },
  {
    name: "Tunisia (\u062A\u0648\u0646\u0633)",
    code: "TN",
    phoneCode: "+216",
    placeholder: "20 123 456",
    icon: render$l
  },
  {
    name: "Turkey (T\xFCrkiye)",
    code: "TR",
    phoneCode: "+90",
    placeholder: "0501 234 5678",
    icon: render$k
  },
  {
    name: "Turkmenistan",
    code: "TM",
    phoneCode: "+993",
    placeholder: "8 66 123456",
    icon: render$j
  },
  {
    name: "Turks and Caicos Islands",
    code: "TC",
    phoneCode: "+1",
    placeholder: "(649) 231-1234",
    icon: render$i
  },
  {
    name: "Tuvalu",
    code: "TV",
    phoneCode: "+688",
    placeholder: "901234",
    icon: render$h
  },
  {
    name: "U.S. Virgin Islands",
    code: "VI",
    phoneCode: "+1",
    placeholder: "(340) 642-1234",
    icon: render$a
  },
  {
    name: "Uganda",
    code: "UG",
    phoneCode: "+256",
    placeholder: "0712 345678",
    icon: render$g
  },
  {
    name: "Ukraine (\u0423\u043A\u0440\u0430\u0457\u043D\u0430)",
    code: "UA",
    phoneCode: "+380",
    placeholder: "039 123 4567",
    icon: render$f
  },
  {
    name: "United Arab Emirates (\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629)",
    code: "AE",
    phoneCode: "+971",
    placeholder: "050 123 4567",
    icon: render$d
  },
  {
    name: "United Kingdom",
    code: "GB",
    phoneCode: "+44",
    placeholder: "07700 900123",
    icon: render$e
  },
  {
    name: "United States",
    code: "US",
    phoneCode: "+1",
    placeholder: "(201) 555-0123",
    icon: render$c
  },
  {
    name: "Uruguay",
    code: "UY",
    phoneCode: "+598",
    placeholder: "091 234 567",
    icon: render$b
  },
  {
    name: "Uzbekistan (O\u02BBzbekiston)",
    code: "UZ",
    phoneCode: "+998",
    placeholder: "8 91 234 56 78",
    icon: render$9
  },
  {
    name: "Vanuatu",
    code: "VU",
    phoneCode: "+678",
    placeholder: "591 2345",
    icon: render$8
  },
  {
    name: "Vatican City (Citt\xE0 del Vaticano)",
    code: "VA",
    phoneCode: "+379",
    placeholder: "3123456789",
    icon: render$7
  },
  {
    name: "Venezuela",
    code: "VE",
    phoneCode: "+58",
    placeholder: "0412-1234567",
    icon: render$6
  },
  {
    name: "Vietnam (Vi\u1EC7t Nam)",
    code: "VN",
    phoneCode: "+84",
    placeholder: "091 234 56 78",
    icon: render$5
  },
  {
    name: "Wallis and Futuna (Wallis-et-Futuna)",
    code: "WF",
    phoneCode: "+681",
    placeholder: "50 12 34",
    icon: render$4
  },
  {
    name: "Western Sahara (\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629)",
    code: "EH",
    phoneCode: "+212",
    placeholder: "0650-123456",
    icon: render$3
  },
  {
    name: "Yemen (\u0627\u0644\u064A\u0645\u0646)",
    code: "YE",
    phoneCode: "+967",
    placeholder: "0712 345 678",
    icon: render$2
  },
  {
    name: "Zambia",
    code: "ZM",
    phoneCode: "+260",
    placeholder: "095 1234567",
    icon: render$1
  },
  {
    name: "Zimbabwe",
    code: "ZW",
    phoneCode: "+263",
    placeholder: "071 123 4567",
    icon: render
  }
];
var InputPhone_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$5 = { class: "button-container" };
const __default__$d = defineComponent({
  name: "UIInputPhone",
  inheritAttrs: false
});
const _sfc_main$d = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$d), {
  props: {
    id: String,
    countryCode: String,
    disabled: Boolean,
    value: String
  },
  emits: [
    "internationalFormat",
    "isValid",
    "nationalFormat",
    "update:countryCode",
    "update:value"
  ],
  setup(__props, { emit }) {
    const props = __props;
    const selectedCountryDetails = function() {
      if (props.countryCode)
        return ref(countryDetails.filter((aCountry) => aCountry.code === props.countryCode)[0]);
      return ref(countryDetails.filter((country) => country.code === "US")[0]);
    }();
    onMounted(() => {
      validatePhoneNumber(props.value, selectedCountryDetails.value.code);
    });
    watch(() => props.value, (newValue) => {
      validatePhoneNumber(newValue, selectedCountryDetails.value.code);
    });
    function onChange(phoneNumber) {
      validatePhoneNumber(phoneNumber, selectedCountryDetails.value.code);
    }
    function onSelect(value2) {
      const [countryCode, countryName] = value2.split("--");
      selectedCountryDetails.value = countryDetails.filter((aCountry) => aCountry.code === countryCode && aCountry.name === countryName)[0];
      validatePhoneNumber(props.value, countryCode);
    }
    function emitValues({
      countryCode,
      internationalFormat,
      isPhoneNumberValid,
      nationalFormat,
      phoneNumber
    }) {
      emit("update:countryCode", countryCode);
      emit("internationalFormat", internationalFormat);
      emit("isValid", isPhoneNumberValid);
      emit("nationalFormat", nationalFormat);
      emit("update:value", phoneNumber);
    }
    function validatePhoneNumber(phoneNumber, countryCode) {
      try {
        const phoneValidationObject = parsePhoneNumberWithError(phoneNumber, countryCode);
        const isPhoneNumberValid = phoneValidationObject.isValid() && phoneValidationObject.country === countryCode;
        if (isPhoneNumberValid) {
          return emitValues({
            countryCode,
            internationalFormat: phoneValidationObject.formatInternational(),
            isPhoneNumberValid,
            nationalFormat: phoneValidationObject.formatNational(),
            phoneNumber: phoneValidationObject.formatNational()
          });
        }
        emitValues({
          countryCode,
          internationalFormat: "",
          isPhoneNumberValid,
          nationalFormat: "",
          phoneNumber
        });
      } catch (error) {
        emitValues({
          countryCode,
          internationalFormat: "",
          isPhoneNumberValid: false,
          nationalFormat: "",
          phoneNumber
        });
      }
    }
    const options = countryDetails.map((aCountry) => {
      return {
        label: `${aCountry.name} ${aCountry.phoneCode}`,
        value: `${aCountry.code}--${aCountry.name}`,
        icon: () => h$1(aCountry.icon),
        placeholder: aCountry.placeholder
      };
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$16, {
        modelValue: __props.value,
        id: __props.id,
        class: "phone-input-container",
        placeholder: unref(selectedCountryDetails).placeholder,
        disabled: __props.disabled,
        "onUpdate:modelValue": onChange
      }, {
        prefix: withCtx(() => [
          createVNode(unref(UIDropdownTree), {
            options: unref(options),
            onOnSelect: onSelect
          }, {
            trigger: withCtx(() => [
              createElementVNode("div", _hoisted_1$5, [
                unref(selectedCountryDetails) ? (openBlock(), createBlock(resolveDynamicComponent(unref(selectedCountryDetails).icon), { key: 0 })) : createCommentVNode("", true),
                createVNode(unref(render$42), { class: "w-5 h-5" })
              ])
            ]),
            _: 1
          }, 8, ["options"])
        ]),
        _: 1
      }, 8, ["modelValue", "id", "placeholder", "disabled"]);
    };
  }
}));
_sfc_main$d.install = (Vue) => {
  Vue.component(_sfc_main$d.name, _sfc_main$d);
};
const __default__$c = defineComponent({
  name: "UIMenu",
  inheritAttrs: false
});
const _sfc_main$c = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$c), {
  props: {
    options: {
      type: Array
    },
    value: {
      type: [String, Number]
    }
  },
  emits: ["update:value"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NMenu), mergeProps({
        options: __props.options,
        "onUpdate:value": _cache[0] || (_cache[0] = (val) => _ctx.$emit("update:value", val)),
        value: __props.value
      }, _ctx.$attrs), null, 16, ["options", "value"]);
    };
  }
}));
_sfc_main$c.install = (Vue) => {
  Vue.component(_sfc_main$c.name, _sfc_main$c);
};
const __default__$b = defineComponent({
  name: "UIPopover",
  inheritAttrs: false
});
const _sfc_main$b = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$b), {
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    delay: {
      type: Number
    },
    duration: {
      type: Number
    },
    placement: {
      type: String,
      default: "top"
    },
    show: {
      type: Boolean,
      default: void 0
    },
    showArrow: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NPopover), mergeProps(_ctx.$attrs, {
        "show-arrow": __props.showArrow,
        show: __props.show,
        placement: __props.placement,
        trigger: __props.trigger,
        delay: __props.delay,
        duration: __props.duration
      }), {
        trigger: withCtx(() => [
          renderSlot(_ctx.$slots, "trigger")
        ]),
        header: withCtx(() => [
          renderSlot(_ctx.$slots, "header")
        ]),
        footer: withCtx(() => [
          renderSlot(_ctx.$slots, "footer")
        ]),
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["show-arrow", "show", "placement", "trigger", "delay", "duration"]);
    };
  }
}));
_sfc_main$b.install = (Vue) => {
  Vue.component(_sfc_main$b.name, _sfc_main$b);
};
const sizeMaps = {
  mobile: {
    device: {
      width: "280px",
      height: "564px"
    },
    page: {
      width: "248px",
      height: "473px"
    }
  }
};
var Preview_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1$4 = ["id"];
const _hoisted_2$4 = ["src"];
const _hoisted_3$3 = {
  key: 1,
  class: "ghl-ui-preview__page--html-code"
};
const __default__$a = defineComponent({
  name: "UIPreview",
  inheritAttrs: false
});
const _sfc_main$a = defineComponent(__spreadProps(__spreadValues({}, __default__$a), {
  props: {
    id: {
      type: String,
      required: true
    },
    href: {
      type: String,
      required: false
    },
    deviceClasses: {
      type: String,
      default: "",
      required: false
    },
    pageClasses: {
      type: String,
      default: "",
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const customClasses = computed(() => {
      const deviceDimensions = sizeMaps["mobile"];
      return {
        device: props.deviceClasses ? "" : deviceDimensions.device,
        page: props.pageClasses ? "" : deviceDimensions.page
      };
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps(_ctx.$attrs, {
        class: "ghl-ui-preview",
        id: __props.id
      }), [
        createElementVNode("div", {
          class: normalizeClass(["ghl-ui-preview__page", __props.pageClasses]),
          style: normalizeStyle(unref(customClasses).page)
        }, [
          props.href ? (openBlock(), createElementBlock("iframe", {
            key: 0,
            src: __props.href,
            id: "iphone-preview",
            class: "ghl-ui-preview__page--iframe"
          }, null, 8, _hoisted_2$4)) : unref(slots).html ? (openBlock(), createElementBlock("div", _hoisted_3$3, [
            renderSlot(_ctx.$slots, "html", {}, void 0, true)
          ])) : createCommentVNode("", true)
        ], 6),
        createElementVNode("div", {
          class: normalizeClass(["ghl-ui-preview__device--mobile", __props.deviceClasses]),
          style: normalizeStyle(unref(customClasses).device)
        }, null, 6)
      ], 16, _hoisted_1$4);
    };
  }
}));
var UIPreview = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["__scopeId", "data-v-3efbf9aa"]]);
UIPreview.install = (Vue) => {
  Vue.component(UIPreview.name, UIPreview);
};
const _hoisted_1$3 = { key: 1 };
const _hoisted_2$3 = {
  class: "n-progress-text",
  role: "none"
};
const _hoisted_3$2 = { class: "n-progress-text__percentage" };
const _hoisted_4$2 = /* @__PURE__ */ createElementVNode("span", { class: "n-progress-text__unit" }, "%", -1);
const __default__$9 = defineComponent({
  name: "UIProgress",
  inheritAttrs: false
});
const _sfc_main$9 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$9), {
  props: {
    percentage: {
      type: Number
    },
    type: {
      type: String,
      default: "line"
    },
    processing: {
      type: Boolean
    },
    indicatorPlacement: {
      type: String,
      default: "inside"
    },
    status: {
      type: String
    },
    showIndicator: {
      type: Boolean,
      default: void 0
    }
  },
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NProgress), mergeProps({
        "indicator-placement": __props.indicatorPlacement,
        percentage: __props.percentage,
        processing: __props.processing,
        "show-indicator": __props.showIndicator,
        status: __props.status,
        type: __props.type,
        "gap-position": "bottom"
      }, _ctx.$attrs), {
        default: withCtx(() => [
          unref(slots).default ? renderSlot(_ctx.$slots, "default", { key: 0 }) : (openBlock(), createElementBlock("div", _hoisted_1$3, [
            createElementVNode("div", _hoisted_2$3, [
              createElementVNode("span", _hoisted_3$2, toDisplayString(__props.percentage), 1),
              _hoisted_4$2
            ])
          ]))
        ]),
        _: 3
      }, 16, ["indicator-placement", "percentage", "processing", "show-indicator", "status", "type"]);
    };
  }
}));
_sfc_main$9.install = (Vue) => {
  Vue.component(_sfc_main$9.name, _sfc_main$9);
};
var RadioGroupItem_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$2 = { class: "hl-radio-group-item-container" };
const _hoisted_2$2 = {
  key: 0,
  class: "hl-radio-group-item-icon"
};
const _hoisted_3$1 = {
  key: 1,
  class: "hl-radio-group-item-content"
};
const _hoisted_4$1 = { class: "hl-radio-group-item-action" };
const __default__$8 = defineComponent({
  name: "UIRadioButton",
  inheritAttrs: false
});
const _sfc_main$8 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$8), {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number, Boolean]
    },
    compact: Boolean
  },
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NRadioButton), mergeProps(_ctx.$attrs, {
        value: __props.value,
        disabled: __props.disabled,
        class: ["hl-radio-group-item", __props.compact ? "compact-radio-item" : null]
      }), {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$2, [
            unref(slots).icon ? (openBlock(), createElementBlock("div", _hoisted_2$2, [
              renderSlot(_ctx.$slots, "icon")
            ])) : createCommentVNode("", true),
            unref(slots).content ? (openBlock(), createElementBlock("div", _hoisted_3$1, [
              renderSlot(_ctx.$slots, "content")
            ])) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_4$1, [
              createVNode(unref(NRadio), { value: __props.value }, null, 8, ["value"])
            ])
          ])
        ]),
        _: 3
      }, 16, ["value", "disabled", "class"]);
    };
  }
}));
_sfc_main$8.install = (Vue) => {
  Vue.component(_sfc_main$8.name, _sfc_main$8);
};
const __default__$7 = defineComponent({
  name: "UISkeleton",
  inheritAttrs: false
});
const _sfc_main$7 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$7), {
  props: {
    text: {
      type: Boolean,
      default: true
    },
    repeat: {
      type: Number,
      default: 1
    },
    width: {
      type: [String, Number],
      default: void 0
    },
    height: {
      type: [String, Number],
      default: void 0
    },
    animated: {
      type: Boolean,
      default: true
    },
    circle: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NSkeleton), mergeProps(_ctx.$attrs, {
        text: __props.text,
        repeat: __props.repeat,
        width: __props.width,
        height: __props.height,
        animated: __props.animated,
        circle: __props.circle
      }), null, 16, ["text", "repeat", "width", "height", "animated", "circle"]);
    };
  }
}));
_sfc_main$7.install = (Vue) => {
  Vue.component(_sfc_main$7.name, _sfc_main$7);
};
const __default__$6 = defineComponent({
  name: "UISlider",
  inheritAttrs: false
});
const _sfc_main$6 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$6), {
  props: {
    value: {
      type: [Number, Array]
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    marks: {
      type: Object,
      default: void 0
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: Number,
      default: void 0
    },
    formatTooltip: {
      type: Function,
      default: void 0
    }
  },
  emits: ["update:value"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NSlider), {
        "default-value": __props.defaultValue,
        "format-tooltip": __props.formatTooltip,
        tooltip: __props.tooltip,
        marks: __props.marks,
        step: __props.step,
        max: __props.max,
        min: __props.min,
        value: __props.value,
        "onUpdate:value": _cache[0] || (_cache[0] = (e25) => _ctx.$emit("update:value", e25))
      }, null, 8, ["default-value", "format-tooltip", "tooltip", "marks", "step", "max", "min", "value"]);
    };
  }
}));
_sfc_main$6.install = (Vue) => {
  Vue.component(_sfc_main$6.name, _sfc_main$6);
};
const __default__$5 = defineComponent({
  name: "UISpace",
  inheritAttrs: false
});
const _sfc_main$5 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$5), {
  props: {
    align: {
      type: String,
      default: void 0
    },
    inline: {
      type: Boolean,
      default: false
    },
    wrapItem: {
      type: Boolean,
      default: true
    },
    justify: {
      type: String,
      default: "start"
    },
    size: {
      type: String,
      default: "medium"
    },
    vertical: {
      type: Boolean,
      default: false
    },
    wrap: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NSpace), mergeProps(_ctx.$attrs, {
        align: __props.align,
        inline: __props.inline,
        "wrap-item": __props.wrapItem,
        justify: __props.justify,
        size: __props.size,
        vertical: __props.vertical,
        wrap: __props.wrap
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["align", "inline", "wrap-item", "justify", "size", "vertical", "wrap"]);
    };
  }
}));
_sfc_main$5.install = (Vue) => {
  Vue.component(_sfc_main$5.name, _sfc_main$5);
};
const __default__$4 = defineComponent({
  name: "UISpin",
  inheritAttrs: false
});
const _sfc_main$4 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$4), {
  props: {
    size: {
      type: [String, Number],
      default: "medium"
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NSpin), mergeProps(_ctx.$attrs, {
        show: __props.show,
        size: __props.size
      }), null, 16, ["show", "size"]);
    };
  }
}));
_sfc_main$4.install = (Vue) => {
  Vue.component(_sfc_main$4.name, _sfc_main$4);
};
var Statistic_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$1 = { class: "hl-statistic" };
const _hoisted_2$1 = { class: "hl-statistic-header" };
const _hoisted_3 = {
  key: 0,
  class: "hl-statistic-action"
};
const _hoisted_4 = { class: "hl-content" };
const _hoisted_5 = { class: "hl-container" };
const _hoisted_6 = {
  key: 0,
  class: "trend trend-container"
};
const _hoisted_7 = { key: 1 };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = {
  key: 0,
  class: "badge badge--positive"
};
const _hoisted_11 = { key: 1 };
const _hoisted_12 = {
  key: 0,
  class: "badge badge--negative"
};
const _hoisted_13 = { key: 1 };
const __default__$3 = defineComponent({
  name: "UIStatistic",
  inheritAttrs: false
});
const _sfc_main$3 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$3), {
  props: {
    id: {
      type: String,
      required: true
    },
    icon: {
      type: Function
    },
    title: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "success"
    },
    trendTitle: {
      type: String,
      default: ""
    },
    showGraph: {
      type: Boolean,
      default: false,
      required: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  emits: ["select"],
  setup(__props) {
    const slots = useSlots();
    return (_ctx, _cache) => {
      var _a2;
      return openBlock(), createElementBlock("div", _hoisted_1$1, [
        createElementVNode("div", _hoisted_2$1, [
          createElementVNode("div", null, [
            ((_a2 = unref(slots)) == null ? void 0 : _a2.icon) ? (openBlock(), createBlock(unref(_sfc_main$U), {
              key: 0,
              type: "success"
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "icon")
              ]),
              _: 3
            })) : createCommentVNode("", true),
            createVNode(unref(_sfc_main$1e), { class: "title" }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(__props.title), 1)
              ]),
              _: 1
            })
          ]),
          __props.options.length ? (openBlock(), createElementBlock("div", _hoisted_3, [
            createVNode(unref(_sfc_main$$), {
              options: __props.options,
              onSelect: _cache[0] || (_cache[0] = (val) => _ctx.$emit("select", val)),
              id: `${__props.id}-dropdown`
            }, {
              default: withCtx(() => [
                createVNode(unref(_sfc_main$1l), {
                  circle: "",
                  quaternary: "",
                  id: `${__props.id}-dropdown-trigger`
                }, {
                  default: withCtx(() => [
                    createVNode(unref(render$40), { class: "w-5 h-5" })
                  ]),
                  _: 1
                }, 8, ["id"])
              ]),
              _: 1
            }, 8, ["options", "id"])
          ])) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_4, [
          createElementVNode("div", _hoisted_5, [
            createVNode(unref(_sfc_main$19), null, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }),
            __props.showGraph ? (openBlock(), createElementBlock("div", _hoisted_6, [
              unref(slots).badge ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass({
                  "trend trend--success": __props.type === "success",
                  "trend trend--error": __props.type === "error"
                })
              }, [
                renderSlot(_ctx.$slots, "badge")
              ], 2)) : createCommentVNode("", true),
              __props.trendTitle ? (openBlock(), createElementBlock("div", _hoisted_7, toDisplayString(__props.trendTitle), 1)) : createCommentVNode("", true)
            ])) : createCommentVNode("", true)
          ]),
          !__props.showGraph ? (openBlock(), createElementBlock("div", _hoisted_8, [
            __props.type === "success" ? (openBlock(), createElementBlock("div", _hoisted_9, [
              unref(slots).badge ? (openBlock(), createElementBlock("div", _hoisted_10, [
                renderSlot(_ctx.$slots, "badge")
              ])) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            __props.type === "error" ? (openBlock(), createElementBlock("div", _hoisted_11, [
              unref(slots).badge ? (openBlock(), createElementBlock("div", _hoisted_12, [
                renderSlot(_ctx.$slots, "badge")
              ])) : createCommentVNode("", true)
            ])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          __props.showGraph && unref(slots).graph ? (openBlock(), createElementBlock("div", _hoisted_13, [
            renderSlot(_ctx.$slots, "graph")
          ])) : createCommentVNode("", true)
        ])
      ]);
    };
  }
}));
_sfc_main$3.install = (Vue) => {
  Vue.component(_sfc_main$3.name, _sfc_main$3);
};
const __default__$2 = defineComponent({
  name: "UISwitch",
  inheritAttrs: false
});
const _sfc_main$2 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$2), {
  props: {
    checkedValue: {
      type: [String, Number, Boolean],
      default: true
    },
    defaultValue: {
      type: [String, Number, Boolean]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    rubberBand: {
      type: Boolean,
      default: false
    },
    size: {
      type: String
    },
    uncheckedValue: {
      type: [String, Number, Boolean],
      default: false
    },
    value: {
      type: [String, Number, Boolean]
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NSwitch), {
        "checked-value": __props.checkedValue,
        "default-value": __props.defaultValue,
        disabled: __props.disabled,
        loading: __props.loading,
        "rubber-band": __props.rubberBand,
        size: __props.size,
        "unchecked-value": __props.uncheckedValue,
        value: __props.value,
        "onUpdate:value": _cache[0] || (_cache[0] = (val) => _ctx.$emit("update:value", val))
      }, null, 8, ["checked-value", "default-value", "disabled", "loading", "rubber-band", "size", "unchecked-value", "value"]);
    };
  }
}));
_sfc_main$2.install = (Vue) => {
  Vue.component(_sfc_main$2.name, _sfc_main$2);
};
const __default__$1 = defineComponent({
  name: "UITimePicker",
  inheritAttrs: false
});
const _sfc_main$1 = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__$1), {
  props: {
    defaultValue: {
      type: Number
    },
    defaultFormattedValue: {
      type: String
    },
    size: {
      type: String,
      default: "large"
    },
    isHourDisabled: {
      type: Function
    },
    isMinuteDisabled: {
      type: Function
    },
    isSecondDisabled: {
      type: Function
    },
    format: {
      type: String
    },
    value: {
      type: Number
    },
    status: {
      type: String
    },
    placeholder: {
      type: String
    },
    actions: {
      type: Array
    }
  },
  emits: ["confirm", "update:value"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NTimePicker), mergeProps(_ctx.$attrs, {
        actions: __props.actions,
        placeholder: __props.placeholder,
        status: __props.status,
        value: __props.value,
        "onUpdate:value": _cache[0] || (_cache[0] = (val) => _ctx.$emit("update:value", val)),
        size: __props.size,
        "default-value": __props.defaultValue,
        "default-formatted-value": __props.defaultFormattedValue,
        onConfirm: _cache[1] || (_cache[1] = (val) => _ctx.$emit("confirm", val)),
        format: __props.format,
        "is-hour-disabled": __props.isHourDisabled,
        "is-minute-disabled": __props.isMinuteDisabled,
        "is-second-disabled": __props.isSecondDisabled
      }), {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16, ["actions", "placeholder", "status", "value", "size", "default-value", "default-formatted-value", "format", "is-hour-disabled", "is-minute-disabled", "is-second-disabled"]);
    };
  }
}));
_sfc_main$1.install = (Vue) => {
  Vue.component(_sfc_main$1.name, _sfc_main$1);
};
const downloadFromDOM = (file) => {
  if (file) {
    const { url: url2, name: name2 } = file;
    if (!url2)
      return;
    const a2 = document.createElement("a");
    a2.href = url2;
    a2.target = "_blank";
    if (name2 !== void 0) {
      a2.download = name2;
    }
    document.body.appendChild(a2);
    a2.click();
    document.body.removeChild(a2);
    return true;
  }
  return null;
};
const downloadFromXHR = (file) => {
  if (file) {
    const { url: url2 } = file;
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url2, true);
    xhr.responseType = "blob";
    xhr.onload = function() {
      const urlCreator = window.URL || window.webkitURL;
      const imageUrl = urlCreator.createObjectURL(this == null ? void 0 : this.response);
      const downloadLink = document.createElement("a");
      downloadLink.href = imageUrl;
      downloadLink.download = url2;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };
    xhr.send();
    return true;
  }
  return false;
};
var Upload_vue_vue_type_style_index_0_scoped_true_lang = "";
const _hoisted_1 = { class: "upload-icon" };
const _hoisted_2 = { key: 0 };
const __default__ = defineComponent({
  name: "UIUpload"
});
const _sfc_main = /* @__PURE__ */ defineComponent(__spreadProps(__spreadValues({}, __default__), {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default: () => []
    },
    max: Number,
    showDownloadButton: Boolean,
    accept: String,
    onDownload: Function
  },
  emits: ["change", "remove", "update:file-list", "download"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const slots = useSlots();
    const handleDownload = (file) => {
      if (file) {
        if (props.onDownload) {
          emits("download", file);
          return false;
        }
        downloadFromDOM(file);
        return false;
      }
      return null;
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NUpload), mergeProps(_ctx.$attrs, {
        "list-type": "image",
        onChange: _cache[0] || (_cache[0] = (val) => _ctx.$emit("change", val)),
        multiple: __props.multiple,
        "file-list": __props.fileList,
        max: __props.max,
        accept: __props.accept,
        "show-download-button": __props.showDownloadButton,
        onRemove: _cache[1] || (_cache[1] = (val) => _ctx.$emit("remove", val)),
        "onUpdate:fileList": _cache[2] || (_cache[2] = (val) => _ctx.$emit("update:file-list", val)),
        onDownload: handleDownload
      }), {
        default: withCtx(() => [
          createVNode(unref(NUploadDragger), null, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1, [
                createVNode(unref(render$3W), { class: "text-gray-600" })
              ]),
              unref(slots).extra ? (openBlock(), createElementBlock("div", _hoisted_2, [
                renderSlot(_ctx.$slots, "extra", {}, void 0, true)
              ])) : createCommentVNode("", true)
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 16, ["multiple", "file-list", "max", "accept", "show-download-button"]);
    };
  }
}));
var UIUpload = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-7b362b16"]]);
UIUpload.install = (Vue) => {
  Vue.component(UIUpload.name, UIUpload);
};
const renderIcon = (icon) => {
  return () => {
    return h$1(icon, {
      class: "h-4 w-4"
    }, {});
  };
};
const components = {
  UIButton: _sfc_main$1l,
  UIButtonGroup: _sfc_main$1k,
  UIContentWrap: _sfc_main$o,
  UIDropdown: _sfc_main$$,
  UIBadge: _sfc_main$w,
  UIInput: _sfc_main$16,
  UIInputGroup: _sfc_main$15,
  UIInputGroupLabel: _sfc_main$14,
  UIPagination: _sfc_main$13,
  UITable: _sfc_main$12,
  UIActionDropdown: _sfc_main$_,
  UIActionButtons: _sfc_main$10,
  UICheckbox: _sfc_main$r,
  UIModal: _sfc_main$N,
  UIModalContent: _sfc_main$K,
  UIModalFooter: _sfc_main$L,
  UIModalHeader: _sfc_main$M,
  UISelect: _sfc_main$1i,
  UITag: _sfc_main$1j,
  UITooltip: _sfc_main$11,
  UIForm: _sfc_main$R,
  UIFormItem: _sfc_main$O,
  UIFormContentHorizontal: _sfc_main$P,
  UIFormLabelTooltip: _sfc_main$S,
  UIDatePicker: _sfc_main$m,
  UIHeader: _sfc_main$f,
  UITabs: _sfc_main$F,
  UITab,
  UITabPane,
  UIStatistic: _sfc_main$3,
  UIInputNumber: _sfc_main$e,
  UIEmpty: _sfc_main$g,
  UIAvatar: _sfc_main$B,
  UIAvatarGroup: _sfc_main$x,
  UIRadio: _sfc_main$J,
  UIRadioGroup: _sfc_main$I,
  UIDrawer: _sfc_main$V,
  UIDrawerContent: _sfc_main$T,
  UISpin: _sfc_main$4,
  UICollapse: _sfc_main$X,
  UICollapseItem: _sfc_main$W,
  UIStep: _sfc_main$G,
  UISteps: _sfc_main$H,
  UIToolbar: _sfc_main$E,
  UIToolbarGroup: _sfc_main$D,
  UIDisplaySmMedium: _sfc_main$1h,
  UITextLgMedium: _sfc_main$1g,
  UITextSmNormal: _sfc_main$1f,
  UITextSmMedium: _sfc_main$1e,
  UITextXsMedium: _sfc_main$1d,
  UITextMdMedium: _sfc_main$1b,
  UITextMdNormal: _sfc_main$1a,
  UIDisplaySmSemibold: _sfc_main$19,
  UITextSmRegular: _sfc_main$18,
  UITextXsRegular: _sfc_main$1c,
  UIDivider: _sfc_main$Q,
  UIMenu: _sfc_main$c,
  UICard: _sfc_main$t,
  UITimePicker: _sfc_main$1,
  UIPopover: _sfc_main$b,
  UISwitch: _sfc_main$2,
  UIProgress: _sfc_main$9,
  UIUpload,
  UISpace: _sfc_main$5,
  UISkeleton: _sfc_main$7,
  UIRadioGroupItem: _sfc_main$8,
  UISlider: _sfc_main$6,
  UIAlert,
  UIBreadcrumb: _sfc_main$Z,
  UIBreadcrumbItem: _sfc_main$Y,
  UIPreview,
  UIBuilderSpace,
  UIDynamicTags: _sfc_main$h,
  UIColorPicker: _sfc_main$p,
  UICarousel,
  UIDraggableElement: _sfc_main$l,
  UIDropdownTree,
  UIDataTable: _sfc_main$n,
  UICodeEditor: _sfc_main$q,
  UIInputPhone: _sfc_main$d,
  UIFilter: _sfc_main$17,
  UIAdvancedSelect: _sfc_main$z
};
function install(Vue) {
  for (const component in components) {
    Vue.component(components[component].name, components[component]);
  }
}
var index = { install };
export { _sfc_main$10 as UIActionButtons, _sfc_main$_ as UIActionDropdown, _sfc_main$z as UIAdvancedSelect, UIAlert, _sfc_main$B as UIAvatar, _sfc_main$x as UIAvatarGroup, _sfc_main$w as UIBadge, _sfc_main$Z as UIBreadcrumb, _sfc_main$Y as UIBreadcrumbItem, UIBuilderSpace, _sfc_main$1l as UIButton, _sfc_main$1k as UIButtonGroup, _sfc_main$t as UICard, UICarousel, _sfc_main$r as UICheckbox, _sfc_main$q as UICodeEditor, _sfc_main$X as UICollapse, _sfc_main$W as UICollapseItem, _sfc_main$p as UIColorPicker, _sfc_main$o as UIContentWrap, _sfc_main$n as UIDataTable, _sfc_main$m as UIDatepicker, _sfc_main$1h as UIDisplaySmMedium, _sfc_main$19 as UIDisplaySmSemibold, _sfc_main$Q as UIDivider, _sfc_main$l as UIDraggableElement, _sfc_main$V as UIDrawer, _sfc_main$T as UIDrawerContent, _sfc_main$$ as UIDropdown, UIDropdownTree, _sfc_main$h as UIDynamicTags, _sfc_main$g as UIEmpty, _sfc_main$17 as UIFilter, _sfc_main$R as UIForm, _sfc_main$P as UIFormContentHorizontal, _sfc_main$O as UIFormItem, _sfc_main$S as UIFormLabelTooltip, _sfc_main$f as UIHeader, _sfc_main$16 as UIInput, _sfc_main$15 as UIInputGroup, _sfc_main$14 as UIInputGroupLabel, _sfc_main$e as UIInputNumber, _sfc_main$d as UIInputPhone, _sfc_main$c as UIMenu, _sfc_main$N as UIModal, _sfc_main$K as UIModalContent, _sfc_main$L as UIModalFooter, _sfc_main$M as UIModalHeader, _sfc_main$13 as UIPagination, _sfc_main$b as UIPopover, UIPreview, _sfc_main$9 as UIProgress, _sfc_main$J as UIRadio, _sfc_main$I as UIRadioGroup, _sfc_main$8 as UIRadioGroupItem, _sfc_main$1i as UISelect, _sfc_main$7 as UISkeleton, _sfc_main$6 as UISlider, _sfc_main$5 as UISpace, _sfc_main$4 as UISpin, _sfc_main$3 as UIStatistic, _sfc_main$G as UIStep, _sfc_main$H as UISteps, _sfc_main$2 as UISwitch, UITab, UITabPane, _sfc_main$12 as UITable, _sfc_main$F as UITabs, _sfc_main$1j as UITag, _sfc_main$1g as UITextLgMedium, _sfc_main$1b as UITextMdMedium, _sfc_main$1a as UITextMdNormal, _sfc_main$1e as UITextSmMedium, _sfc_main$1f as UITextSmNormal, _sfc_main$18 as UITextSmRegular, _sfc_main$1d as UITextXsMedium, _sfc_main$1c as UITextXsRegular, _sfc_main$1 as UITimePicker, _sfc_main$E as UIToolbar, _sfc_main$D as UIToolbarGroup, _sfc_main$11 as UITooltip, UIUpload, index as default, downloadFromDOM, downloadFromXHR, renderIcon, useNotification };
